import React__default, { useState, useEffect, useCallback, Fragment as Fragment$2, useMemo, useReducer, useRef, createElement, forwardRef, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, Link, useHistory, useParams, Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { CloseSvg, RadioButtons, Localities, RemoveableTag, CheckBox as CheckBox$1, SubmitBar, Label, TextInput as TextInput$2, LinkLabel, ActionBar, DatePicker, MobileNumber, Loader, Card, DetailsCard, SearchAction, FilterAction, PopUp, CaseIcon, Table, Header, KeyNote, TelePhone, DisplayPhotos, CardSectionHeader, CheckPoint, ConnectingCheckPoints, MultiLink, StatusTable, Row, CardHeader, PDFSvg, FilterFormField, MultiSelectDropdown, SearchField, CardLabelError, InboxComposer, Toast, BPAIcon, BPAHomeIcon, EDCRIcon, EmployeeModuleCard, CitizenOBPSHomeCard, CardSubHeader, LinkButton, Menu, Modal, ButtonSelector, LabelFieldPair, CardLabel, Dropdown, MultiUploadWrapper, UploadFile, PrintIcon as PrintIcon$1, BreakLine, LocationSearch, BackButton, AutoLogoutWarning, FormComposer, GalleryIcon, RemoveIcon as RemoveIcon$2, CameraIcon, Banner, CardText, PrivateRoute, SurveyIconSolid, PMBIconSolid, EventsIconSolid, DocumentIconSolid, FormStep, RadioOrSelect, TickMark, SearchIcon as SearchIcon$1, DeleteIcon as DeleteIcon$1, CitizenInfoLabel, LocationSearchCard, CardCaption, SearchIconSvg, SearchForm, Close as Close$9, EditIcon as EditIcon$1, CitizenOBPSCard, OBPSIcon } from '@egovernments/digit-ui-react-components';
import _$1, { debounce } from 'lodash';
import { useForm, Controller, useWatch, useFormContext, useFieldArray } from 'react-hook-form';
import cloneDeep from 'lodash/cloneDeep';
import { styled, Typography, Box, Tabs, Tab, MenuItem as MenuItem$2, OutlinedInput, FormHelperText, TextField, InputAdornment, IconButton as IconButton$1, FormControlLabel as FormControlLabel$1, Checkbox, FormControl as FormControl$1, FormLabel, RadioGroup as RadioGroup$1, Grid, Radio as Radio$1, TableCell as TableCell$1, tableCellClasses, TableRow as TableRow$1, TableContainer as TableContainer$1, Paper as Paper$1, Table as Table$2, TableHead as TableHead$1, TableBody as TableBody$1, Card as Card$1, Divider, Button as Button$2, Accordion, AccordionSummary, AccordionDetails, CardContent, InputLabel, Select as Select$3, Autocomplete, ListItemText, FormGroup, useTheme, Collapse, Tooltip, Avatar as Avatar$3, CircularProgress, List, ListItemButton, Dialog as Dialog$1, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions, DialogContentText, Modal as Modal$1, ToggleButtonGroup, ToggleButton, Snackbar, Alert, Chip, keyframes, Container as Container$1, AppBar, Toolbar, Menu as Menu$1, Drawer, alpha, Backdrop, Fade, Popover, ListItem, TableSortLabel as TableSortLabel$1, TablePagination as TablePagination$1, Link as Link$1, ButtonGroup, Stack } from '@mui/material';
import { bindActionCreators } from 'redux';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveIcon from '@mui/icons-material/HighlightOff';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select$2 from '@mui/material/Select';
import MenuItem$3 from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as DatePicker$1, MobileTimePicker, LocalizationProvider as LocalizationProvider$1 } from '@mui/x-date-pickers';
import 'dayjs/locale/en-in';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { Search as Search$1, VisibilityOff, Visibility, ExpandLess, ExpandMore, InfoOutlined, AccessTime, Chat, ArrowForward, PictureAsPdf, History, Person, Assignment, Payment, Description, CheckCircle, Cancel as Cancel$2, Warning, SyncAlt, ArrowDownward, ArrowForwardIos, ArrowBackIos, Fullscreen, Close as Close$8, Delete, Add } from '@mui/icons-material';
import Table$1 from 'react-bootstrap/Table';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getDocumentByFileStoreId, getDocumentByFileStoreIdV2 } from '@egovernments/digit-ui-libraries/src/utils/fileType';
import { TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, Button as Button$1, Avatar as Avatar$2, Card as Card$3, Box as Box$2, FormControl as FormControl$2, FormControlLabel as FormControlLabel$2, Checkbox as Checkbox$1 } from '@material-ui/core';
import HelpIcon from '@mui/icons-material/Help';
import { FaFilePdf, FaTimes, FaPencilAlt, FaFont, FaEraser, FaUndo, FaRedo, FaSave, FaArrowCircleUp, FaBars, FaCopy, FaChevronUp, FaChevronDown, FaQuestionCircle, FaUser, FaFileExcel, FaDownload } from 'react-icons/fa';
import { makeStyles, styled as styled$2 } from '@mui/styles';
import Avatar$1 from '@material-ui/core/Avatar';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { styled as styled$1 } from '@mui/material/styles';
import { useQuery, useQueryClient } from 'react-query';
import { Row as Row$1, Container, Card as Card$2, Col, Table as Table$3, Button as Button$3, CloseButton } from 'react-bootstrap';
import reactDom from 'react-dom';
import Urls$1 from '@egovernments/digit-ui-libraries/src/services/atoms/urls';
import PrintIcon from '@mui/icons-material/Print';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import DownloadIcon from '@mui/icons-material/Download';
import Box$1 from '@mui/material/Box';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useHistory as useHistory$1 } from 'react-router-dom/cjs/react-router-dom.min';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import useModal from '@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Collapse$1 from '@mui/material/Collapse';
import AddIcon$1 from '@mui/icons-material/Add';
import RemoveIcon$1 from '@mui/icons-material/Remove';
import { ConvertEpochToDate, convertDateToEpoch as convertDateToEpoch$1 } from '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';
import DescriptionIcon from '@mui/icons-material/Description';
import { makeStyles as makeStyles$1 } from '@material-ui/core/styles';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RestoreIcon from '@mui/icons-material/Restore';
import FlipIcon from '@mui/icons-material/Flip';
import '@mui/icons-material/Info';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DialogActions$1 from '@mui/material/DialogActions';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import utc from 'dayjs/plugin/utc';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import PersonIcon from '@mui/icons-material/Person';
import { green } from '@mui/material/colors';
import Avatar$4 from '@mui/material/Avatar';
import Accordion$1 from '@mui/material/Accordion';
import AccordionSummary$1 from '@mui/material/AccordionSummary';
import AccordionDetails$1 from '@mui/material/AccordionDetails';
import Typography$1 from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SaveIcon from '@mui/icons-material/Save';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { NOCService as NOCService$1 } from '@egovernments/digit-ui-libraries/src/services/elements/NOC';
import Table$4 from '@mui/material/Table';
import TableContainer$2 from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useHistory as useHistory$2, useLocation as useLocation$1, useParams as useParams$1 } from 'react-router-dom/cjs/react-router-dom';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LockIcon from '@mui/icons-material/Lock';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import TableSortLabel from '@mui/material/TableSortLabel';
import '@mui/material/Checkbox';
import EditIcon from '@mui/icons-material/Edit';
import Paper$2 from '@mui/material/Paper';
import TableBody$2 from '@mui/material/TableBody';
import TableCell$2, { tableCellClasses as tableCellClasses$1 } from '@mui/material/TableCell';
import TableHead$2 from '@mui/material/TableHead';
import TableRow$2 from '@mui/material/TableRow';
import 'react-bootstrap/Modal';
import get$1 from '@egovernments/digit-ui-libraries/src/hooks/obps/useFormSubmitValidation';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'react-icons/fa6';
import DrawIcon from '@mui/icons-material/Draw';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Grid$1 from '@mui/material/Grid';
import HouseIcon from '@mui/icons-material/House';
import Table$5 from '@material-ui/core/Table';
import TableBody$3 from '@material-ui/core/TableBody';
import TableCell$3 from '@material-ui/core/TableCell';
import TableContainer$3 from '@material-ui/core/TableContainer';
import TableRow$3 from '@material-ui/core/TableRow';
import TextField$1 from '@mui/material/TextField';
import TableHead$3 from '@material-ui/core/TableHead';
import Paper$3 from '@material-ui/core/Paper';
import '@material-ui/core/TablePagination';
import '@mui/lab';
import Tab$1 from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel$1 from '@mui/lab/TabPanel';
import { AiFillDashboard } from 'react-icons/ai';
import Card$4 from '@mui/material/Card';
import CardContent$1 from '@mui/material/CardContent';
import { BiSolidLike } from 'react-icons/bi';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker as DatePicker$2 } from '@mui/x-date-pickers/DatePicker';
import RefreshIcon from '@mui/icons-material/Refresh';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import '@mui/icons-material/FilterAlt';
import '@mui/icons-material/Assessment';
import InputAdornment$1 from '@mui/material/InputAdornment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PieChartIcon from '@mui/icons-material/PieChart';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Search = ({
  path
}) => {
  var _userInfo$value, _bpaData$;
  const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
  const userInfo = userInfos ? JSON.parse(userInfos) : {};
  const userInformation = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.info;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const location = useLocation();
  const details = () => {
    var _userInformation$role, _userInformation$role2, _userInformation$role3, _userInformation$role4, _userInformation$role5, _userInformation$role6;
    if ((userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role = userInformation.roles) === null || _userInformation$role === void 0 ? void 0 : (_userInformation$role2 = _userInformation$role.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role2 === void 0 ? void 0 : _userInformation$role2.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role3 = userInformation.roles) === null || _userInformation$role3 === void 0 ? void 0 : _userInformation$role3.filter(ob => ob.code.includes("BPA_")).length) > 0) return "BUILDING_PLAN_SCRUTINY";
    if ((userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role4 = userInformation.roles) === null || _userInformation$role4 === void 0 ? void 0 : (_userInformation$role5 = _userInformation$role4.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role5 === void 0 ? void 0 : _userInformation$role5.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role6 = userInformation.roles) === null || _userInformation$role6 === void 0 ? void 0 : _userInformation$role6.filter(ob => ob.code.includes("BPA_")).length) <= 0) return "BPA_STAKEHOLDER_REGISTRATION";else return "BUILDING_PLAN_SCRUTINY";
  };
  const [selectedType, setSelectedType] = useState(details());
  const [payload, setPayload] = useState({});
  const [searchData, setSearchData] = useState({});
  useEffect(() => {
    if (location.pathname === "/digit-ui/citizen/obps/search/application" || location.pathname === "/digit-ui/employee/obps/search/application") {
      Digit.SessionStorage.del("OBPS.INBOX");
      Digit.SessionStorage.del("STAKEHOLDER.INBOX");
    }
  }, [location.pathname]);
  const Search = Digit.ComponentRegistryService.getComponent("OBPSSearchApplication");
  const checkData = data => {
    if ((data === null || data === void 0 ? void 0 : data.applicationNo) === "" && (data === null || data === void 0 ? void 0 : data.fromDate) === "" && (data === null || data === void 0 ? void 0 : data.mobileNumber) === "" && (data === null || data === void 0 ? void 0 : data.serviceType) === "" && (data === null || data === void 0 ? void 0 : data.status) === "" && (data === null || data === void 0 ? void 0 : data.toDate) === "") return false;
    return true;
  };
  const [paramerror, setparamerror] = useState("");
  function onSubmit(_data) {
    var _data$applicationType, _data$applicationType2, _data$applicationType3;
    if ((_data === null || _data === void 0 ? void 0 : (_data$applicationType = _data.applicationType) === null || _data$applicationType === void 0 ? void 0 : _data$applicationType.code) === "BPA_STAKEHOLDER_REGISTRATION") {
      const isSearchAllowed = checkData(_data);
      if (!isSearchAllowed) {
        setparamerror("BPA_ADD_MORE_PARAM_STAKEHOLDER");
      }
    }
    setSearchData(_data);
    var fromDate = new Date(_data === null || _data === void 0 ? void 0 : _data.fromDate);
    fromDate === null || fromDate === void 0 ? void 0 : fromDate.setSeconds((fromDate === null || fromDate === void 0 ? void 0 : fromDate.getSeconds()) - 19800);
    var toDate = new Date(_data === null || _data === void 0 ? void 0 : _data.toDate);
    setSelectedType(_data !== null && _data !== void 0 && (_data$applicationType2 = _data.applicationType) !== null && _data$applicationType2 !== void 0 && _data$applicationType2.code ? _data === null || _data === void 0 ? void 0 : (_data$applicationType3 = _data.applicationType) === null || _data$applicationType3 === void 0 ? void 0 : _data$applicationType3.code : selectedType);
    toDate === null || toDate === void 0 ? void 0 : toDate.setSeconds((toDate === null || toDate === void 0 ? void 0 : toDate.getSeconds()) + 86399 - 19800);
    const data = {
      ..._data,
      ...(_data.toDate ? {
        toDate: toDate === null || toDate === void 0 ? void 0 : toDate.getTime()
      } : {}),
      ...(_data.fromDate ? {
        fromDate: fromDate === null || fromDate === void 0 ? void 0 : fromDate.getTime()
      } : {})
    };
    setPayload(Object.keys(data).filter(k => data[k]).reduce((acc, key) => ({
      ...acc,
      [key]: typeof data[key] === "object" ? data[key].code : data[key]
    }), {}));
  }
  let params = {};
  let filters = {};
  if (selectedType && selectedType.includes("STAKEHOLDER") || Object.keys(payload).length > 0 && payload !== null && payload !== void 0 && payload.applicationType && payload !== null && payload !== void 0 && payload.applicationType.includes("STAKEHOLDER")) {
    if (Object.entries(payload).length <= 2 && Object.keys(payload).filter(ob => ob === "applicationType").length == 0) ; else {
      if (payload.applicationNo) {
        payload["applicationNumber"] = payload.applicationNo;
        payload.applicationNo = "";
      }
      if (payload && payload["applicationType"]) delete payload["applicationType"];
      if (payload && payload["serviceType"]) {
        payload["tradeType"] = payload["serviceType"];
        delete payload["serviceType"];
      }
      params = {
        ...payload,
        tenantId: Digit.ULBService.getStateId()
      };
    }
  } else {
    if (Object.keys(payload).length === 0) {
      var _Digit$UserService$ge, _Digit$UserService$ge2;
      let payload1 = {
        applicationType: "BUILDING_PLAN_SCRUTINY",
        serviceType: "NEW_CONSTRUCTION",
        ...(window.location.href.includes("/digit-ui/citizen") && {
          mobileNumber: (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.mobileNumber
        })
      };
      setPayload({
        ...payload,
        ...payload1
      });
    }
    filters = payload;
  }
  const {
    data: bpaData = [],
    isLoading: isBpaSearchLoading,
    isSuccess: isBpaSuccess,
    error: bpaerror
  } = Digit.Hooks.obps.useOBPSSearch(selectedType, payload, tenantId, filters, params, {
    enabled: paramerror === ""
  });
  return /*#__PURE__*/React__default.createElement(Search, {
    t: t,
    tenantId: tenantId,
    onSubmit: onSubmit,
    searchData: searchData,
    isLoading: isBpaSearchLoading,
    Count: bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$ = bpaData[0]) === null || _bpaData$ === void 0 ? void 0 : _bpaData$.Count,
    error: paramerror,
    data: !isBpaSearchLoading && isBpaSuccess && (bpaData === null || bpaData === void 0 ? void 0 : bpaData.length) > 0 ? bpaData : [{
      display: "ES_COMMON_NO_DATA"
    }],
    setparamerror: setparamerror
  });
};

const Filter = ({
  searchParams,
  onFilterChange,
  defaultSearchParams,
  statuses,
  ...props
}) => {
  var _searchParams$localit;
  const {
    t
  } = useTranslation();
  const [_searchParams, setSearchParams] = useState(() => searchParams);
  const localParamChange = filterParam => {
    let keys_to_delete = filterParam.delete;
    let _new = {
      ..._searchParams,
      ...filterParam
    };
    if (keys_to_delete) keys_to_delete.forEach(key => delete _new[key]);
    delete filterParam.delete;
    setSearchParams({
      ..._new
    });
  };
  const clearAll = () => {
    setSearchParams({
      applicationStatus: []
    });
    onFilterChange({
      applicationStatus: []
    });
  };
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const onServiceSelect = (e, label) => {
    if (e.target.checked) localParamChange({
      applicationStatus: [...(_searchParams !== null && _searchParams !== void 0 && _searchParams.applicationStatus ? _searchParams.applicationStatus : []), label]
    });else localParamChange({
      applicationStatus: _searchParams === null || _searchParams === void 0 ? void 0 : _searchParams.applicationStatus.filter(o => o !== label)
    });
  };
  const selectLocality = d => {
    localParamChange({
      locality: [...((_searchParams === null || _searchParams === void 0 ? void 0 : _searchParams.locality) || []), d]
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "heading",
    style: {
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label",
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0.66666 2.48016C3.35999 5.9335 8.33333 12.3335 8.33333 12.3335V20.3335C8.33333 21.0668 8.93333 21.6668 9.66666 21.6668H12.3333C13.0667 21.6668 13.6667 21.0668 13.6667 20.3335V12.3335C13.6667 12.3335 18.6267 5.9335 21.32 2.48016C22 1.60016 21.3733 0.333496 20.2667 0.333496H1.71999C0.613327 0.333496 -0.01334 1.60016 0.66666 2.48016Z",
    fill: "#505A5F"
  }))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "8px",
      fontWeight: "normal"
    }
  }, t("ES_COMMON_FILTER_BY"))), /*#__PURE__*/React__default.createElement("div", {
    className: "clearAll",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), props.type === "desktop" && /*#__PURE__*/React__default.createElement("span", {
    className: "clear-search",
    onClick: clearAll,
    style: {
      border: "1px solid #e0e0e0",
      padding: "6px"
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M8 5V8L12 4L8 0V3C3.58 3 0 6.58 0 11C0 12.57 0.46 14.03 1.24 15.26L2.7 13.8C2.25 12.97 2 12.01 2 11C2 7.69 4.69 5 8 5ZM14.76 6.74L13.3 8.2C13.74 9.04 14 9.99 14 11C14 14.31 11.31 17 8 17V14L4 18L8 22V19C12.42 19 16 15.42 16 11C16 9.43 15.54 7.97 14.76 6.74Z",
    fill: "#505A5F"
  }))), props.type === "mobile" && /*#__PURE__*/React__default.createElement("span", {
    onClick: props.onClose
  }, /*#__PURE__*/React__default.createElement(CloseSvg, null))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RadioButtons, {
    onSelect: d => localParamChange({
      uuid: d
    }),
    selectedOption: (_searchParams === null || _searchParams === void 0 ? void 0 : _searchParams.uuid) || {
      code: "ASSIGNED_TO_ALL",
      name: "ES_INBOX_ASSIGNED_TO_ALL"
    },
    t: t,
    optionsKey: "name",
    options: [{
      code: "ASSIGNED_TO_ME",
      name: "ES_INBOX_ASSIGNED_TO_ME"
    }, {
      code: "ASSIGNED_TO_ALL",
      name: "ES_INBOX_ASSIGNED_TO_ALL"
    }]
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label",
    style: {
      fontWeight: "normal"
    }
  }, t("ES_INBOX_LOCALITY"), ":"), /*#__PURE__*/React__default.createElement(Localities, {
    selectLocality: selectLocality,
    tenantId: tenantId,
    boundaryType: "revenue"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "tag-container"
  }, _searchParams === null || _searchParams === void 0 ? void 0 : (_searchParams$localit = _searchParams.locality) === null || _searchParams$localit === void 0 ? void 0 : _searchParams$localit.map((locality, index) => {
    return /*#__PURE__*/React__default.createElement(RemoveableTag, {
      key: index,
      text: t(`${locality.i18nkey}`),
      onClick: () => {
        localParamChange({
          locality: _searchParams === null || _searchParams === void 0 ? void 0 : _searchParams.locality.filter(loc => loc.code !== locality.code)
        });
      }
    });
  }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label",
    style: {
      fontWeight: "normal"
    }
  }, t("CS_INBOX_STATUS_FILTER")), statuses === null || statuses === void 0 ? void 0 : statuses.map((e, index) => {
    var _searchParams$applica;
    const checked = _searchParams === null || _searchParams === void 0 ? void 0 : (_searchParams$applica = _searchParams.applicationStatus) === null || _searchParams$applica === void 0 ? void 0 : _searchParams$applica.includes(e.statusid);
    return /*#__PURE__*/React__default.createElement(CheckBox$1, {
      key: index + "service",
      label: t(`CS_COMMON_INBOX_${e.businessservice.toUpperCase()}`) + " - " + t(`WF_NEWTL_${e.applicationstatus}`) + " " + `(${e.count})`,
      value: e.statusid,
      checked: checked,
      onChange: event => onServiceSelect(event, e.statusid)
    });
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SubmitBar, {
    disabled: _$1.isEqual(_searchParams, searchParams),
    onSubmit: () => onFilterChange(_searchParams),
    label: t("ES_COMMON_APPLY")
  }))))));
};

const fieldComponents = {
  date: DatePicker,
  mobileNumber: MobileNumber
};
const SearchApplication = ({
  onSearch,
  type,
  onClose,
  searchFields,
  searchParams,
  isInboxPage,
  defaultSearchParams,
  clearSearch: _clearSearch,
  setSearchFieldsBackToOriginalState,
  setSetSearchFieldsBackToOriginalState
}) => {
  var _searchFields$filter;
  const {
    t
  } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setError,
    clearErrors,
    formState,
    setValue
  } = useForm({
    defaultValues: searchParams
  });
  const form = watch();
  const mobileView = innerWidth <= 640;
  const [justToResetSearchFieldsInCaseOfFilterTrigger, setSearchFieldsInCaseOfFilterTrigger] = useState([{
    applicationNumber: "",
    mobileNumber: ""
  }]);
  useEffect(() => {
    if (setSearchFieldsBackToOriginalState) {
      setNotRemovedStateToSearchFields();
      setTimeout(setSetSearchFieldsBackToOriginalState(false), 1000);
    }
  }, [setSearchFieldsBackToOriginalState]);
  const setNotRemovedStateToSearchFields = () => {
    if (Array.isArray(justToResetSearchFieldsInCaseOfFilterTrigger)) {
      let [{
        applicationNumber,
        mobileNumber
      }] = justToResetSearchFieldsInCaseOfFilterTrigger;
      setValue("applicationNumber", applicationNumber);
      setValue("mobileNumber", mobileNumber);
    } else {
      let {
        applicationNumber,
        mobileNumber
      } = justToResetSearchFieldsInCaseOfFilterTrigger;
      setValue("applicationNumber", applicationNumber);
      setValue("mobileNumber", mobileNumber);
    }
  };
  useEffect(() => {
    searchFields.forEach(({
      pattern,
      name,
      maxLength,
      minLength,
      errorMessages,
      ...el
    }) => {
      const value = form[name];
      const error = formState.errors[name];
      if (pattern) {
        if (!new RegExp(pattern).test(value) && !error) setError(name, {
          type: "pattern",
          message: t(errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.pattern) || t(`PATTERN_${name.toUpperCase()}_FAILED`)
        });else if (new RegExp(pattern).test(value) && (error === null || error === void 0 ? void 0 : error.type) === "pattern") clearErrors([name]);
      }
      if (minLength) {
        if ((value === null || value === void 0 ? void 0 : value.length) < minLength && !error) setError(name, {
          type: "minLength",
          message: t((errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.minLength) || `MINLENGTH_${name.toUpperCase()}_FAILED`)
        });else if ((value === null || value === void 0 ? void 0 : value.length) >= minLength && (error === null || error === void 0 ? void 0 : error.type) === "minLength") clearErrors([name]);
      }
      if (maxLength) {
        if ((value === null || value === void 0 ? void 0 : value.length) > maxLength && !error) setError(name, {
          type: "maxLength",
          message: t((errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.maxLength) || `MAXLENGTH_${name.toUpperCase()}_FAILED`)
        });else if ((value === null || value === void 0 ? void 0 : value.length) <= maxLength && (error === null || error === void 0 ? void 0 : error.type) === "maxLength") clearErrors([name]);
      }
    });
  }, [form, formState, setError, clearErrors]);
  const onSubmitInput = data => {
    if (data.mobileNumber.length == 0 || data.mobileNumber.length == 10) {
      if (!data.mobileNumber) {
        delete data.mobileNumber;
      }
      const mobileNumber = data === null || data === void 0 ? void 0 : data.mobileNumber;
      const applicationNumber = data === null || data === void 0 ? void 0 : data.applicationNumber;
      setSearchFieldsInCaseOfFilterTrigger({
        mobileNumber,
        applicationNumber
      });
      data.delete = [];
      searchFields.forEach(field => {
        if (!data[field.name]) data.delete.push(field.name);
      });
      onSearch(data);
      if (type === "mobile") {
        onClose();
      }
    }
  };
  function clearSearch() {
    const resetValues = searchFields.reduce((acc, field) => ({
      ...acc,
      [field === null || field === void 0 ? void 0 : field.name]: ""
    }), {});
    reset(resetValues);
    if (isInboxPage) {
      const _newParams = {
        ...searchParams
      };
      _newParams.delete = [];
      searchFields.forEach(e => {
        _newParams.delete.push(e === null || e === void 0 ? void 0 : e.name);
      });
      setSearchFieldsInCaseOfFilterTrigger({
        applicationNumber: "",
        mobileNumber: ""
      });
      onSearch({
        ..._newParams
      });
    } else {
      _clearSearch();
    }
  }
  const clearAll = mobileView => {
    const mobileViewStyles = mobileView ? {
      margin: 0
    } : {};
    return /*#__PURE__*/React__default.createElement(LinkLabel, {
      style: {
        display: "inline",
        ...mobileViewStyles
      },
      onClick: clearSearch
    }, t("ES_COMMON_CLEAR_SEARCH"));
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmitInput)
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "search-container",
    style: {
      width: "auto",
      marginLeft: isInboxPage ? "24px" : "revert"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "search-complaint-container"
  }, (type === "mobile" || mobileView) && /*#__PURE__*/React__default.createElement("div", {
    className: "complaint-header"
  }, /*#__PURE__*/React__default.createElement("h2", null, t("ES_COMMON_SEARCH_BY")), /*#__PURE__*/React__default.createElement("span", {
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(CloseSvg, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "complaint-input-container",
    style: {
      textAlign: "start"
    }
  }, searchFields === null || searchFields === void 0 ? void 0 : (_searchFields$filter = searchFields.filter(e => true)) === null || _searchFields$filter === void 0 ? void 0 : _searchFields$filter.map((input, index) => {
    var _formState$dirtyField, _formState$errors, _formState$errors$inp;
    return /*#__PURE__*/React__default.createElement("div", {
      key: input.name,
      className: "input-fields"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "complaint-input"
    }, /*#__PURE__*/React__default.createElement(Label, null, t(input.label)), !input.type ? /*#__PURE__*/React__default.createElement(Controller, {
      render: props => {
        return /*#__PURE__*/React__default.createElement(TextInput$2, {
          onChange: props.onChange,
          value: props.value
        });
      },
      name: input.name,
      control: control,
      defaultValue: ""
    }) : /*#__PURE__*/React__default.createElement(Controller, {
      render: props => {
        const Comp = fieldComponents === null || fieldComponents === void 0 ? void 0 : fieldComponents[input.type];
        return /*#__PURE__*/React__default.createElement(Comp, {
          onChange: props.onChange,
          value: props.value
        });
      },
      name: input.name,
      control: control,
      defaultValue: ""
    })), formState !== null && formState !== void 0 && (_formState$dirtyField = formState.dirtyFields) !== null && _formState$dirtyField !== void 0 && _formState$dirtyField[input.name] ? /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontWeight: "700",
        color: "rgba(212, 53, 28)",
        paddingLeft: "8px",
        marginTop: "-20px",
        fontSize: "12px"
      },
      className: "inbox-search-form-error"
    }, formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$inp = _formState$errors[input.name]) === null || _formState$errors$inp === void 0 ? void 0 : _formState$errors$inp.message) : null);
  }), type === "desktop" && !mobileView && !isInboxPage && /*#__PURE__*/React__default.createElement("div", {
    className: "search-action-wrapper"
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    className: "submit-bar-search",
    label: t("ES_COMMON_SEARCH"),
    disabled: !!Object.keys(formState.errors).length || Object.keys(form).every(key => !(form !== null && form !== void 0 && form[key])),
    submit: true
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      textAlign: "right",
      width: "240px",
      textAlign: "right",
      marginLeft: "96px",
      marginTop: "8px"
    }
  }, clearAll())), isInboxPage && /*#__PURE__*/React__default.createElement("div", {
    className: "search-action-wrapper",
    style: {
      width: "100%"
    }
  }, type === "desktop" && !mobileView && /*#__PURE__*/React__default.createElement(SubmitBar, {
    className: "submit-bar-search",
    label: t("ES_COMMON_SEARCH"),
    submit: true
  }), type === "desktop" && !mobileView && /*#__PURE__*/React__default.createElement("span", {
    className: "clear-search search-secondary-action"
  }, clearAll()))))), (type === "mobile" || mobileView) && /*#__PURE__*/React__default.createElement(ActionBar, {
    className: "clear-search-container"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "clear-search",
    style: {
      flex: 1
    }
  }, clearAll(mobileView)), /*#__PURE__*/React__default.createElement(SubmitBar, {
    disabled: !!Object.keys(formState.errors).length,
    label: t("ES_COMMON_SEARCH"),
    style: {
      flex: 1
    },
    submit: true
  }))));
};

const SortBy = props => {
  const {
    t
  } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(() => {
    var _props$sortParams, _props$sortParams$;
    return (_props$sortParams = props.sortParams) !== null && _props$sortParams !== void 0 && (_props$sortParams$ = _props$sortParams[0]) !== null && _props$sortParams$ !== void 0 && _props$sortParams$.desc ? {
      code: "DESC",
      name: t("ES_INBOX_DATE_LATEST_FIRST")
    } : {
      code: "ASC",
      name: t("ES_INBOX_DATE_LATEST_LAST")
    };
  });
  function clearAll() {}
  function onSort(option) {
    props.onSort([{
      id: "createdTime",
      desc: option.code === "DESC" ? true : false
    }]);
    props.onClose();
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-card"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "heading"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label"
  }, t("SORT_BY"), ":"), /*#__PURE__*/React__default.createElement("div", {
    className: "clearAll",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), props.type === "desktop" && /*#__PURE__*/React__default.createElement("span", {
    className: "clear-search",
    onClick: clearAll
  }, t("ES_COMMON_CLEAR_ALL")), props.type === "mobile" && /*#__PURE__*/React__default.createElement("span", {
    onClick: props.onClose
  }, /*#__PURE__*/React__default.createElement(CloseSvg, null))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RadioButtons, {
    onSelect: onSort,
    selectedOption: selectedOption,
    optionsKey: "name",
    options: [{
      code: "DESC",
      name: t("ES_INBOX_DATE_LATEST_FIRST")
    }, {
      code: "ASC",
      name: t("ES_INBOX_DATE_LATEST_LAST")
    }]
  })))));
};

const ApplicationCard = ({
  t,
  data,
  onFilterChange,
  onSearch,
  onSort,
  serviceRequestIdKey,
  isFstpOperator,
  isLoading,
  isSearch,
  searchParams,
  searchFields,
  sortParams,
  linkPrefix,
  removeParam
}) => {
  const [type, setType] = useState(isSearch ? "SEARCH" : "");
  const [popup, setPopup] = useState(isSearch ? true : false);
  const [params, setParams] = useState(searchParams);
  const [_sortparams, setSortParams] = useState(sortParams);
  const selectParams = param => {
    setParams(o => ({
      ...o,
      ...param
    }));
  };
  const onSearchPara = param => {
    onFilterChange({
      ...params,
      ...param
    });
    setType("");
    setPopup(false);
  };
  useEffect(() => {
    if (type) setPopup(true);
  }, [type]);
  const handlePopupClose = () => {
    setPopup(false);
    setType("");
    setParams(searchParams);
    setSortParams(sortParams);
  };
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  let result;
  if (!data || (data === null || data === void 0 ? void 0 : data.length) === 0) {
    result = /*#__PURE__*/React__default.createElement(Card, {
      style: {
        marginTop: 20
      }
    }, t("CS_MYAPPLICATIONS_NO_APPLICATION").split("\\n").map((text, index) => /*#__PURE__*/React__default.createElement("p", {
      key: index,
      style: {
        textAlign: "center"
      }
    }, text)));
  } else if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    result = /*#__PURE__*/React__default.createElement(DetailsCard, {
      data: data,
      serviceRequestIdKey: serviceRequestIdKey,
      linkPrefix: linkPrefix ? linkPrefix : "/digit-ui/employee/tl/application-details/"
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "searchBox"
  }, onSearch && /*#__PURE__*/React__default.createElement(SearchAction, {
    text: "SEARCH",
    handleActionClick: () => {
      setType("SEARCH");
      setPopup(true);
    }
  }), !isSearch && onFilterChange && /*#__PURE__*/React__default.createElement(FilterAction, {
    text: "FILTER",
    handleActionClick: () => {
      setType("FILTER");
      setPopup(true);
    }
  }), /*#__PURE__*/React__default.createElement(FilterAction, {
    text: "SORT",
    handleActionClick: () => {
      setType("SORT");
      setPopup(true);
    }
  })), result, popup && /*#__PURE__*/React__default.createElement(PopUp, null, type === "FILTER" && /*#__PURE__*/React__default.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React__default.createElement(Filter, {
    onFilterChange: selectParams,
    onClose: handlePopupClose,
    onSearch: onSearchPara,
    type: "mobile",
    searchParams: params,
    removeParam: removeParam
  })), type === "SORT" && /*#__PURE__*/React__default.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React__default.createElement(SortBy, {
    type: "mobile",
    sortParams: sortParams,
    onClose: handlePopupClose,
    onSort: onSort
  })), type === "SEARCH" && /*#__PURE__*/React__default.createElement("div", {
    className: "popup-module"
  }, /*#__PURE__*/React__default.createElement(SearchApplication, {
    type: "mobile",
    onClose: handlePopupClose,
    onSearch: onSearch,
    isFstpOperator: isFstpOperator,
    searchParams: searchParams,
    searchFields: searchFields
  }))));
};

const InboxLinks = ({
  parentRoute,
  businessService,
  allLinks,
  headerText,
  classNameForMobileView: _classNameForMobileView = ""
}) => {
  const {
    t
  } = useTranslation();
  const [links, setLinks] = useState([]);
  const {
    roles: userRoles
  } = Digit.UserService.getUser().info;
  useEffect(() => {
    let linksToShow = allLinks.filter(e => e.businessService === businessService).filter(({
      roles
    }) => roles.some(e => userRoles.map(({
      code
    }) => code).includes(e)) || !roles.length);
    setLinks(linksToShow);
  }, []);
  const GetLogo = () => /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "logo"
  }, /*#__PURE__*/React__default.createElement(CaseIcon, null)), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "text"
  }, t(headerText)));
  if (links.length < 1) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Card, {
    className: "employeeCard filter inboxLinks mb-1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `complaint-links-container ${_classNameForMobileView}`
  }, GetLogo(), /*#__PURE__*/React__default.createElement("div", {
    className: "body"
  }, links.map(({
    link,
    text,
    hyperlink: _hyperlink = false,
    accessTo: _accessTo = []
  }, index) => {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "link",
      key: index
    }, _hyperlink ? /*#__PURE__*/React__default.createElement("a", {
      href: link
    }, t(text)) : /*#__PURE__*/React__default.createElement(Link, {
      to: link
    }, t(text)));
  }))));
};

const getPattern = type => {
  switch (type) {
    case "Name":
      return /^[^{0-9}^\$\"<>?\\\\~!@#$%^()+={}\[\]*,/_:;“”‘’]{1,50}$/i;
    case "MobileNo":
      return /^[6-9]{1}[0-9]{9}$/i;
  }
};
const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};
const uuidv4 = () => {
  return require("uuid/v4")();
};
const pdfDownloadLink = (documents = {}, fileStoreId = "", format = "") => {
  let downloadLink = documents[fileStoreId] || "";
  let differentFormats = (downloadLink === null || downloadLink === void 0 ? void 0 : downloadLink.split(",")) || [];
  let fileURL = "";
  differentFormats.length > 0 && differentFormats.map(link => {
    if (!link.includes("large") && !link.includes("medium") && !link.includes("small")) {
      fileURL = link;
    }
  });
  return fileURL;
};
const convertToNocObject = (data, datafromflow) => {
  var _datafromflow$nocDocu, _datafromflow$nocDocu2;
  let formData = {
    Noc: data
  };
  let doc = (datafromflow === null || datafromflow === void 0 ? void 0 : (_datafromflow$nocDocu = datafromflow.nocDocuments) === null || _datafromflow$nocDocu === void 0 ? void 0 : _datafromflow$nocDocu.nocDocuments.length) > 0 ? (datafromflow === null || datafromflow === void 0 ? void 0 : (_datafromflow$nocDocu2 = datafromflow.nocDocuments) === null || _datafromflow$nocDocu2 === void 0 ? void 0 : _datafromflow$nocDocu2.nocDocuments.filter(n => {
    var _data$nocType;
    return n.documentType.includes(data === null || data === void 0 ? void 0 : (_data$nocType = data.nocType) === null || _data$nocType === void 0 ? void 0 : _data$nocType.split("_")[0]);
  }).map(noc => {
    return {
      fileName: (noc === null || noc === void 0 ? void 0 : noc.fileName) || "",
      name: (noc === null || noc === void 0 ? void 0 : noc.name) || "",
      fileStoreId: noc === null || noc === void 0 ? void 0 : noc.fileStoreId,
      fileUrl: "",
      isClickable: true,
      link: "",
      title: noc === null || noc === void 0 ? void 0 : noc.documentType,
      documentType: noc === null || noc === void 0 ? void 0 : noc.documentType,
      id: noc === null || noc === void 0 ? void 0 : noc.id,
      additionalDetails: {}
    };
  })) || [] : [];
  doc = [...doc, ...(datafromflow !== null && datafromflow !== void 0 && datafromflow.PrevStateNocDocuments ? datafromflow === null || datafromflow === void 0 ? void 0 : datafromflow.PrevStateNocDocuments.filter(n => {
    var _data$nocType2;
    return n.documentType.includes(data === null || data === void 0 ? void 0 : (_data$nocType2 = data.nocType) === null || _data$nocType2 === void 0 ? void 0 : _data$nocType2.split("_")[0]);
  }) : [])];
  formData.Noc.documents = doc;
  return formData;
};
const getBPAFormData = async (data, mdmsData, history, t) => {
  var _data$landInfo, _data$landInfo2, _data$landInfo3, _data$landInfo3$addre, _data$landInfo4, _data$landInfo4$addre, _data$landInfo4$addre2, _data$additionalDetai, _APIScrutinyDetails$p, _APIScrutinyDetails$p2, _data$auditDetails, _data$additionalDetai2, _APIScrutinyDetails$p3, _APIScrutinyDetails$p4, _data$additionalDetai3, _mdmsData$BPA, _APIScrutinyDetails$p5, _APIScrutinyDetails$p6, _APIScrutinyDetails$p7, _data$additionalDetai4, _data$landInfo5, _data$landInfo6, _data$landInfo7, _mdmsData$BPA2, _APIScrutinyDetails$p8, _APIScrutinyDetails$p9, _APIScrutinyDetails$p10, _data$landInfo8, _data$businessService, _data$additionalDetai5, _data$additionalDetai6;
  const edcrResponse = await Digit.OBPSService.scrutinyDetails(data === null || data === void 0 ? void 0 : data.tenantId, {
    edcrNumber: data === null || data === void 0 ? void 0 : data.edcrNumber
  });
  const APIScrutinyDetails = edcrResponse === null || edcrResponse === void 0 ? void 0 : edcrResponse.edcrDetail[0];
  const getBlockIds = unit => {
    let blocks = {};
    unit && unit.map((ob, index) => {
      blocks[`Block_${index + 1}`] = ob.id;
    });
    return blocks;
  };
  const getBlocksforFlow = unit => {
    let arr = [];
    let subBlocks = [];
    let subOcc = {};
    unit && unit.map((un, index) => {
      var _un$usageCategory, _arr;
      arr = un === null || un === void 0 ? void 0 : (_un$usageCategory = un.usageCategory) === null || _un$usageCategory === void 0 ? void 0 : _un$usageCategory.split(",");
      subBlocks = [];
      arr && ((_arr = arr) === null || _arr === void 0 ? void 0 : _arr.length) > 0 && arr != "" && arr.map((ob, ind) => {
        subBlocks.push({
          code: ob,
          i18nKey: `BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`,
          name: t(`BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`)
        });
      });
      subOcc[`Block_${index + 1}`] = subBlocks;
    });
    return subOcc;
  };
  data.BlockIds = getBlockIds(data === null || data === void 0 ? void 0 : (_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : _data$landInfo.unit);
  data.address = data === null || data === void 0 ? void 0 : (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : _data$landInfo2.address;
  data.address.locality["i18nkey"] = `${t(`${stringReplaceAll(data === null || data === void 0 ? void 0 : (_data$landInfo3 = data.landInfo) === null || _data$landInfo3 === void 0 ? void 0 : (_data$landInfo3$addre = _data$landInfo3.address) === null || _data$landInfo3$addre === void 0 ? void 0 : _data$landInfo3$addre.tenantId, ".", "_").toUpperCase()}_REVENUE_${data === null || data === void 0 ? void 0 : (_data$landInfo4 = data.landInfo) === null || _data$landInfo4 === void 0 ? void 0 : (_data$landInfo4$addre = _data$landInfo4.address) === null || _data$landInfo4$addre === void 0 ? void 0 : (_data$landInfo4$addre2 = _data$landInfo4$addre.locality) === null || _data$landInfo4$addre2 === void 0 ? void 0 : _data$landInfo4$addre2.code}`)}`;
  data.placeName = (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.GISPlaceName) || "";
  data.data = {
    scrutinyNumber: {
      edcrNumber: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.edcrNumber
    },
    applicantName: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p === void 0 ? void 0 : (_APIScrutinyDetails$p2 = _APIScrutinyDetails$p.planInformation) === null || _APIScrutinyDetails$p2 === void 0 ? void 0 : _APIScrutinyDetails$p2.applicantName,
    applicationDate: data === null || data === void 0 ? void 0 : (_data$auditDetails = data.auditDetails) === null || _data$auditDetails === void 0 ? void 0 : _data$auditDetails.createdTime,
    applicationType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType,
    holdingNumber: data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.holdingNo,
    occupancyType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p3 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p3 === void 0 ? void 0 : (_APIScrutinyDetails$p4 = _APIScrutinyDetails$p3.planInformation) === null || _APIScrutinyDetails$p4 === void 0 ? void 0 : _APIScrutinyDetails$p4.occupancy,
    registrationDetails: data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.registrationDetails,
    riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p5 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p5 === void 0 ? void 0 : (_APIScrutinyDetails$p6 = _APIScrutinyDetails$p5.plot) === null || _APIScrutinyDetails$p6 === void 0 ? void 0 : _APIScrutinyDetails$p6.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p7 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p7 === void 0 ? void 0 : _APIScrutinyDetails$p7.blocks),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  data === null || data === void 0 ? void 0 : data.landInfo.owners.map((owner, ind) => {
    owner.gender = {
      active: true,
      code: owner.gender,
      i18nKey: `COMMON_GENDER_${owner.gender}`
    };
  });
  data.owners = {
    owners: data === null || data === void 0 ? void 0 : (_data$landInfo5 = data.landInfo) === null || _data$landInfo5 === void 0 ? void 0 : _data$landInfo5.owners,
    ownershipCategory: {
      active: true,
      code: data === null || data === void 0 ? void 0 : (_data$landInfo6 = data.landInfo) === null || _data$landInfo6 === void 0 ? void 0 : _data$landInfo6.ownershipCategory,
      i18nKey: `COMMON_MASTERS_OWNERSHIPCATEGORY_${data === null || data === void 0 ? void 0 : (_data$landInfo7 = data.landInfo) === null || _data$landInfo7 === void 0 ? void 0 : _data$landInfo7.ownershipCategory.replaceAll(".", "_")}`
    }
  };
  data.riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p8 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p8 === void 0 ? void 0 : (_APIScrutinyDetails$p9 = _APIScrutinyDetails$p8.plot) === null || _APIScrutinyDetails$p9 === void 0 ? void 0 : _APIScrutinyDetails$p9.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p10 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p10 === void 0 ? void 0 : _APIScrutinyDetails$p10.blocks);
  data.subOccupancy = getBlocksforFlow(data === null || data === void 0 ? void 0 : (_data$landInfo8 = data.landInfo) === null || _data$landInfo8 === void 0 ? void 0 : _data$landInfo8.unit);
  data.uiFlow = {
    flow: data !== null && data !== void 0 && data.businessService.includes("OC") ? "OCBPA" : data === null || data === void 0 ? void 0 : (_data$businessService = data.businessService) === null || _data$businessService === void 0 ? void 0 : _data$businessService.split(".")[0],
    applicationType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai5 = data.additionalDetails) === null || _data$additionalDetai5 === void 0 ? void 0 : _data$additionalDetai5.applicationType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai6 = data.additionalDetails) === null || _data$additionalDetai6 === void 0 ? void 0 : _data$additionalDetai6.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  if (data !== null && data !== void 0 && data.businessService.includes("OC")) {
    var _data$additionalDetai7, _data$additionalDetai8;
    sessionStorage.setItem("BPAintermediateValue", JSON.stringify({
      ...data
    }));
    history.push(`/digit-ui/citizen/obps/ocbpa/${data === null || data === void 0 ? void 0 : (_data$additionalDetai7 = data.additionalDetails) === null || _data$additionalDetai7 === void 0 ? void 0 : _data$additionalDetai7.applicationType.toLowerCase()}/${data === null || data === void 0 ? void 0 : (_data$additionalDetai8 = data.additionalDetails) === null || _data$additionalDetai8 === void 0 ? void 0 : _data$additionalDetai8.serviceType.toLowerCase()}`);
  } else {
    var _data$additionalDetai9, _data$additionalDetai10;
    sessionStorage.setItem("BPAintermediateValue", JSON.stringify({
      ...data
    }));
    history.push(`/digit-ui/citizen/obps/bpa/${data === null || data === void 0 ? void 0 : (_data$additionalDetai9 = data.additionalDetails) === null || _data$additionalDetai9 === void 0 ? void 0 : _data$additionalDetai9.applicationType.toLowerCase()}/${data === null || data === void 0 ? void 0 : (_data$additionalDetai10 = data.additionalDetails) === null || _data$additionalDetai10 === void 0 ? void 0 : _data$additionalDetai10.serviceType.toLowerCase()}`);
  }
};
const getDocumentforBPA = (docs, PrevStateDocs) => {
  let document = [];
  docs && docs.map(ob => {
    if (ob.id) {
      document.push({
        documentType: ob.documentType,
        fileStoreId: ob.fileStoreId,
        fileStore: ob.fileStoreId,
        fileName: "",
        fileUrl: "",
        additionalDetails: {},
        id: ob.id
      });
    } else {
      document.push({
        documentType: ob.documentType,
        fileStoreId: ob.fileStoreId,
        fileStore: ob.fileStoreId,
        fileName: "",
        fileUrl: "",
        additionalDetails: {}
      });
    }
  });
  document = [...document, ...(PrevStateDocs ? PrevStateDocs : [])];
  return document;
};
function getusageCategoryAPI(arr) {
  let usageCat = "";
  arr.map((ob, i) => {
    usageCat = usageCat + (i !== 0 ? "," : "") + ob.code;
  });
  return usageCat;
}
const getBPAUnit = data => {
  var _data$landInfo10;
  let units = [];
  let ob = data === null || data === void 0 ? void 0 : data.subOccupancy;
  if (ob) {
    var _data$landInfo9;
    let result = Object.entries(ob);
    data === null || data === void 0 ? void 0 : (_data$landInfo9 = data.landInfo) === null || _data$landInfo9 === void 0 ? void 0 : _data$landInfo9.unit.map((oldUnit, ind) => {
      result.map((newunit, index) => {
        var _newunit$;
        if (oldUnit.id && oldUnit.floorNo === ((_newunit$ = newunit[0]) === null || _newunit$ === void 0 ? void 0 : _newunit$.split("_")[1])) {
          units.push({
            ...oldUnit,
            usageCategory: "Residential"
          });
        }
      });
    });
    result && result.map((newunit, index) => {
      let found = units.length > 0 ? units === null || units === void 0 ? void 0 : units.some(el => {
        var _newunit$2;
        return (el === null || el === void 0 ? void 0 : el.floorNo) === ((_newunit$2 = newunit[0]) === null || _newunit$2 === void 0 ? void 0 : _newunit$2.split("_")[1]);
      }) : false;
      if (!found) {
        var _newunit$3;
        units.push({
          blockIndex: index,
          floorNo: (_newunit$3 = newunit[0]) === null || _newunit$3 === void 0 ? void 0 : _newunit$3.split("_")[1],
          unitType: "Block",
          usageCategory: 'Residential'
        });
      }
    });
  }
  return units.length > 0 ? units : data === null || data === void 0 ? void 0 : (_data$landInfo10 = data.landInfo) === null || _data$landInfo10 === void 0 ? void 0 : _data$landInfo10.unit;
};
const getBPAUnitsForAPI = ob => {
  let units = [];
  if (ob) {
    let result = Object.entries(ob);
    result.map((unit, index) => {
      var _unit$;
      units.push({
        blockIndex: index,
        floorNo: (_unit$ = unit[0]) === null || _unit$ === void 0 ? void 0 : _unit$.split("_")[1],
        unitType: "Block",
        usageCategory: getusageCategoryAPI(unit[1])
      });
    });
  }
  return units;
};
const getunitforBPA = units => {
  let unit = [];
  units && units.map((ob, index) => {
    unit.push({
      blockIndex: index,
      usageCategory: ob.usageCategory,
      occupancyType: ob.occupancyType,
      floorNo: ob.floorNo,
      unitType: ob.unitType,
      id: ob.id
    });
  });
  return unit;
};
const getBPAOwners = (data, isOCBPA) => {
  var _data$owners, _data$landInfo11, _data$landInfo11$owne;
  if (isOCBPA) return data.landInfo.owners;
  let bpaownerarray = cloneDeep(data === null || data === void 0 ? void 0 : (_data$owners = data.owners) === null || _data$owners === void 0 ? void 0 : _data$owners.owners);
  bpaownerarray && (bpaownerarray === null || bpaownerarray === void 0 ? void 0 : bpaownerarray.forEach(newOwner => {
    var _newOwner$gender, _newOwner$gender2;
    if (newOwner !== null && newOwner !== void 0 && (_newOwner$gender = newOwner.gender) !== null && _newOwner$gender !== void 0 && _newOwner$gender.code) newOwner.gender = (_newOwner$gender2 = newOwner.gender) === null || _newOwner$gender2 === void 0 ? void 0 : _newOwner$gender2.code;
    if (!(newOwner !== null && newOwner !== void 0 && newOwner.fatherOrHusbandName)) newOwner.fatherOrHusbandName = "NAME";
    newOwner.active = true;
  }));
  data === null || data === void 0 ? void 0 : (_data$landInfo11 = data.landInfo) === null || _data$landInfo11 === void 0 ? void 0 : (_data$landInfo11$owne = _data$landInfo11.owners) === null || _data$landInfo11$owne === void 0 ? void 0 : _data$landInfo11$owne.map(oldowner => {
    let found = (bpaownerarray === null || bpaownerarray === void 0 ? void 0 : bpaownerarray.length) > 0 ? bpaownerarray === null || bpaownerarray === void 0 ? void 0 : bpaownerarray.some(el => el.id === oldowner.id) : false;
    if (!found) bpaownerarray === null || bpaownerarray === void 0 ? void 0 : bpaownerarray.push({
      ...oldowner,
      active: false
    });
  });
  return bpaownerarray;
};
const convertToBPAObject = (data, isOCBPA = false, isSendBackTOCitizen = false) => {
  var _data$address4, _data$documents, _data$address5, _data$data, _data$data2, _data$additionalDetai11, _data$data3, _data$data4, _data$additionalDetai12;
  if (isOCBPA) {
    data.landInfo = data.landInfo;
    data.landInfo.owners.forEach((owner, index) => {
      var _owner$gender, _owner$gender2;
      if (owner !== null && owner !== void 0 && (_owner$gender = owner.gender) !== null && _owner$gender !== void 0 && _owner$gender.code) data.landInfo.owners[index].gender = owner === null || owner === void 0 ? void 0 : (_owner$gender2 = owner.gender) === null || _owner$gender2 === void 0 ? void 0 : _owner$gender2.code;
    });
  } else {
    var _data$address, _data$address2, _data$address3, _data$landInfo12, _data$landInfo13, _data$landInfo14;
    data.landInfo.owners.map((owner, index) => {
      var _owner$gender3;
      data.landInfo.owners[index].gender = owner === null || owner === void 0 ? void 0 : (_owner$gender3 = owner.gender) === null || _owner$gender3 === void 0 ? void 0 : _owner$gender3.code;
    });
    data.landInfo.address.landmark = data === null || data === void 0 ? void 0 : (_data$address = data.address) === null || _data$address === void 0 ? void 0 : _data$address.landmark;
    data.landInfo.address.street = data !== null && data !== void 0 && (_data$address2 = data.address) !== null && _data$address2 !== void 0 && _data$address2.street ? data === null || data === void 0 ? void 0 : (_data$address3 = data.address) === null || _data$address3 === void 0 ? void 0 : _data$address3.street : null;
    data.landInfo.address.city = "Solan";
    data.landInfo.address.locality = {
      code: "hp.tcpsolan"
    };
    data.landInfo.address.village = "Neri", data.landInfo.address.areaType = "Special Area";
    data.landInfo.unit = data !== null && data !== void 0 && (_data$landInfo12 = data.landInfo) !== null && _data$landInfo12 !== void 0 && _data$landInfo12.unit && (data === null || data === void 0 ? void 0 : (_data$landInfo13 = data.landInfo) === null || _data$landInfo13 === void 0 ? void 0 : _data$landInfo13.unit.length) > 0 ? getunitforBPA(data === null || data === void 0 ? void 0 : (_data$landInfo14 = data.landInfo) === null || _data$landInfo14 === void 0 ? void 0 : _data$landInfo14.unit) : data !== null && data !== void 0 && data.subOccupancy ? getBPAUnitsForAPI(data === null || data === void 0 ? void 0 : data.subOccupancy) : [];
  }
  let formData = {
    BPA: {
      id: data === null || data === void 0 ? void 0 : data.id,
      applicationNo: data === null || data === void 0 ? void 0 : data.applicationNo,
      approvalNo: data === null || data === void 0 ? void 0 : data.approvalNo,
      accountId: data === null || data === void 0 ? void 0 : data.accountId,
      edcrNumber: data === null || data === void 0 ? void 0 : data.edcrNumber,
      riskType: data === null || data === void 0 ? void 0 : data.riskType,
      businessService: data === null || data === void 0 ? void 0 : data.businessService,
      landId: data === null || data === void 0 ? void 0 : data.landId,
      tenantId: (data === null || data === void 0 ? void 0 : data.tenantId) || (data === null || data === void 0 ? void 0 : (_data$address4 = data.address) === null || _data$address4 === void 0 ? void 0 : _data$address4.tenantId) || "hp",
      approvalDate: data === null || data === void 0 ? void 0 : data.approvalDate,
      applicationDate: data === null || data === void 0 ? void 0 : data.applicationDate,
      status: isSendBackTOCitizen ? data.status : data.status ? data.status : "INITIATED",
      documents: getDocumentforBPA(data === null || data === void 0 ? void 0 : (_data$documents = data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.documents, data === null || data === void 0 ? void 0 : data.PrevStateDocuments),
      landInfo: isOCBPA ? data === null || data === void 0 ? void 0 : data.landInfo : {
        ...(data === null || data === void 0 ? void 0 : data.landInfo),
        owners: getBPAOwners(data, isOCBPA),
        unit: getBPAUnit(data)
      },
      assignee: isSendBackTOCitizen ? data.assignee : [],
      workflow: {
        action: "ASSIGN_TO_STRUCTURE_ENGINEER",
        assignes: null,
        comments: null,
        varificationDocuments: null
      },
      auditDetails: data === null || data === void 0 ? void 0 : data.auditDetails,
      additionalDetails: {
        ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
        GISPlaceName: data === null || data === void 0 ? void 0 : (_data$address5 = data.address) === null || _data$address5 === void 0 ? void 0 : _data$address5.placeName,
        holdingNo: data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.holdingNumber ? data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.holdingNumber : data === null || data === void 0 ? void 0 : (_data$additionalDetai11 = data.additionalDetails) === null || _data$additionalDetai11 === void 0 ? void 0 : _data$additionalDetai11.holdingNo,
        registrationDetails: data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.registrationDetails ? data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.registrationDetails : data === null || data === void 0 ? void 0 : (_data$additionalDetai12 = data.additionalDetails) === null || _data$additionalDetai12 === void 0 ? void 0 : _data$additionalDetai12.registrationDetails
      },
      applicationType: "FORM_12",
      serviceType: "NEW_CONSTRUCTION",
      occupancyType: "A"
    }
  };
  return formData;
};
const convertForm11ToBPAObject = data => {
  var _data$tenantId, _data$businessService2;
  if (data !== null && data !== void 0 && (_data$tenantId = data.tenantId) !== null && _data$tenantId !== void 0 && _data$tenantId.includes("ud")) {
    data.workflow = {
      action: 'MAKE_PAYMENT'
    };
  }
  if (data !== null && data !== void 0 && (_data$businessService2 = data.businessService) !== null && _data$businessService2 !== void 0 && _data$businessService2.includes("BBNDA")) {
    data.workflow = {
      action: 'SEND_TO_JDM_JE_SPD'
    };
  }
  if ((data === null || data === void 0 ? void 0 : data.applicationType) === "FORM_26") {
    data.workflow = {
      action: 'SEND_TO_STRUCTURE_ENGINEER'
    };
  } else {
    data.workflow = {
      action: 'SEND_TO_JE'
    };
  }
  return {
    PermissionOfSubdivision: data
  };
};
const getapplicationdocstakeholder = initial => {
  var _initial$documents;
  let convertedDoc = [];
  (_initial$documents = initial.documents) === null || _initial$documents === void 0 ? void 0 : _initial$documents.documents.map(ob => {
    var _initial$result, _initial$result$Licen;
    convertedDoc.push({
      fileStoreId: ob.fileStoreId,
      fileStore: ob.fileStoreId,
      fileName: ob.fileName,
      fileUrl: "",
      documentType: ob.documentType,
      tenantId: initial === null || initial === void 0 ? void 0 : (_initial$result = initial.result) === null || _initial$result === void 0 ? void 0 : (_initial$result$Licen = _initial$result.Licenses[0]) === null || _initial$result$Licen === void 0 ? void 0 : _initial$result$Licen.tenantId
    });
  });
  return convertedDoc;
};
const convertToStakeholderObject = data => {
  var _data$result, _data$result2, _data$result2$License, _data$formData, _data$formData$Licnes, _data$result3, _data$result3$License, _data$result3$License2, _data$result3$License3, _data$formData2, _data$formData2$Licne, _data$formData2$Licne2, _data$result4, _data$result4$License, _data$result4$License2, _data$result4$License3, _data$result4$License4, _data$result5, _data$result5$License, _data$result5$License2, _data$result5$License3, _data$formData3, _data$formData3$Licne, _data$formData3$Licne2, _data$formData4, _data$formData4$Licne, _data$formData5, _data$formData5$Licne, _data$formData6, _data$formData6$Licne, _data$formData7, _data$formData7$Licne, _data$formData8, _data$formData8$Licne, _data$result6, _data$result6$License, _data$result6$License2, _data$result6$License3, _data$result6$License4;
  let formData = {
    Licenses: [{
      ...(data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.Licenses[0]),
      action: "APPLY",
      tradeLicenseDetail: {
        ...(data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : (_data$result2$License = _data$result2.Licenses[0]) === null || _data$result2$License === void 0 ? void 0 : _data$result2$License.tradeLicenseDetail),
        additionalDetail: {
          counsilForArchNo: data === null || data === void 0 ? void 0 : (_data$formData = data.formData) === null || _data$formData === void 0 ? void 0 : (_data$formData$Licnes = _data$formData.LicneseType) === null || _data$formData$Licnes === void 0 ? void 0 : _data$formData$Licnes.ArchitectNo
        },
        tradeUnits: [{
          ...(data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : (_data$result3$License = _data$result3.Licenses[0]) === null || _data$result3$License === void 0 ? void 0 : (_data$result3$License2 = _data$result3$License.tradeLicenseDetail) === null || _data$result3$License2 === void 0 ? void 0 : (_data$result3$License3 = _data$result3$License2.tradeUnits) === null || _data$result3$License3 === void 0 ? void 0 : _data$result3$License3[0]),
          tradeType: data === null || data === void 0 ? void 0 : (_data$formData2 = data.formData) === null || _data$formData2 === void 0 ? void 0 : (_data$formData2$Licne = _data$formData2.LicneseType) === null || _data$formData2$Licne === void 0 ? void 0 : (_data$formData2$Licne2 = _data$formData2$Licne.LicenseType) === null || _data$formData2$Licne2 === void 0 ? void 0 : _data$formData2$Licne2.tradeType,
          id: data === null || data === void 0 ? void 0 : (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : (_data$result4$License = _data$result4.Licenses[0]) === null || _data$result4$License === void 0 ? void 0 : (_data$result4$License2 = _data$result4$License.tradeLicenseDetail) === null || _data$result4$License2 === void 0 ? void 0 : (_data$result4$License3 = _data$result4$License2.tradeUnits) === null || _data$result4$License3 === void 0 ? void 0 : (_data$result4$License4 = _data$result4$License3[0]) === null || _data$result4$License4 === void 0 ? void 0 : _data$result4$License4.id
        }],
        owners: [{
          ...(data === null || data === void 0 ? void 0 : (_data$result5 = data.result) === null || _data$result5 === void 0 ? void 0 : (_data$result5$License = _data$result5.Licenses[0]) === null || _data$result5$License === void 0 ? void 0 : (_data$result5$License2 = _data$result5$License.tradeLicenseDetail) === null || _data$result5$License2 === void 0 ? void 0 : (_data$result5$License3 = _data$result5$License2.owners) === null || _data$result5$License3 === void 0 ? void 0 : _data$result5$License3[0]),
          gender: data === null || data === void 0 ? void 0 : (_data$formData3 = data.formData) === null || _data$formData3 === void 0 ? void 0 : (_data$formData3$Licne = _data$formData3.LicneseDetails) === null || _data$formData3$Licne === void 0 ? void 0 : (_data$formData3$Licne2 = _data$formData3$Licne.gender) === null || _data$formData3$Licne2 === void 0 ? void 0 : _data$formData3$Licne2.code,
          mobileNumber: data === null || data === void 0 ? void 0 : (_data$formData4 = data.formData) === null || _data$formData4 === void 0 ? void 0 : (_data$formData4$Licne = _data$formData4.LicneseDetails) === null || _data$formData4$Licne === void 0 ? void 0 : _data$formData4$Licne.mobileNumber,
          name: data === null || data === void 0 ? void 0 : (_data$formData5 = data.formData) === null || _data$formData5 === void 0 ? void 0 : (_data$formData5$Licne = _data$formData5.LicneseDetails) === null || _data$formData5$Licne === void 0 ? void 0 : _data$formData5$Licne.name,
          dob: null,
          emailId: data === null || data === void 0 ? void 0 : (_data$formData6 = data.formData) === null || _data$formData6 === void 0 ? void 0 : (_data$formData6$Licne = _data$formData6.LicneseDetails) === null || _data$formData6$Licne === void 0 ? void 0 : _data$formData6$Licne.email,
          permanentAddress: data === null || data === void 0 ? void 0 : (_data$formData7 = data.formData) === null || _data$formData7 === void 0 ? void 0 : (_data$formData7$Licne = _data$formData7.LicneseDetails) === null || _data$formData7$Licne === void 0 ? void 0 : _data$formData7$Licne.PermanentAddress,
          correspondenceAddress: data === null || data === void 0 ? void 0 : data.Correspondenceaddress,
          pan: data === null || data === void 0 ? void 0 : (_data$formData8 = data.formData) === null || _data$formData8 === void 0 ? void 0 : (_data$formData8$Licne = _data$formData8.LicneseDetails) === null || _data$formData8$Licne === void 0 ? void 0 : _data$formData8$Licne.PanNumber,
          uuid: data === null || data === void 0 ? void 0 : (_data$result6 = data.result) === null || _data$result6 === void 0 ? void 0 : (_data$result6$License = _data$result6.Licenses[0]) === null || _data$result6$License === void 0 ? void 0 : (_data$result6$License2 = _data$result6$License.tradeLicenseDetail) === null || _data$result6$License2 === void 0 ? void 0 : (_data$result6$License3 = _data$result6$License2.owners) === null || _data$result6$License3 === void 0 ? void 0 : (_data$result6$License4 = _data$result6$License3[0]) === null || _data$result6$License4 === void 0 ? void 0 : _data$result6$License4.uuid
        }],
        applicationDocuments: getapplicationdocstakeholder(data)
      }
    }]
  };
  return formData;
};
const convertDateToEpoch = (dateString, dayStartOrEnd = "dayend") => {
  try {
    const parts = dateString.match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    const DateObj = new Date(Date.UTC(parts[1], parts[2] - 1, parts[3]));
    DateObj.setMinutes(DateObj.getMinutes() + DateObj.getTimezoneOffset());
    if (dayStartOrEnd === "dayend") {
      DateObj.setHours(DateObj.getHours() + 24);
      DateObj.setSeconds(DateObj.getSeconds() - 1);
    }
    return DateObj.getTime();
  } catch (e) {
    return dateString;
  }
};
const convertEpochToDateDMY = dateEpoch => {
  if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
    return "NA";
  }
  const dateFromApi = new Date(dateEpoch);
  let month = dateFromApi.getMonth() + 1;
  let day = dateFromApi.getDate();
  let year = dateFromApi.getFullYear();
  month = (month > 9 ? "" : "0") + month;
  day = (day > 9 ? "" : "0") + day;
  return `${day}/${month}/${year}`;
};
const getBPAEditDetails = async (data, APIScrutinyDetails, mdmsData, nocdata, t) => {
  var _data$landInfo15, _data$landInfo16, _APIScrutinyDetails$p11, _APIScrutinyDetails$p12, _data$auditDetails2, _data$additionalDetai13, _APIScrutinyDetails$p13, _APIScrutinyDetails$p14, _data$additionalDetai14, _mdmsData$BPA3, _APIScrutinyDetails$p15, _APIScrutinyDetails$p16, _APIScrutinyDetails$p17, _data$additionalDetai15, _data$landInfo17, _data$landInfo18, _data$landInfo19, _mdmsData$BPA4, _APIScrutinyDetails$p18, _APIScrutinyDetails$p19, _APIScrutinyDetails$p20, _data$landInfo20, _mdmsData$BPA5, _mdmsData$BPA5$homePa, _data$businessService3, _data$additionalDetai16, _data$additionalDetai17;
  const getBlockIds = unit => {
    let blocks = {};
    unit && unit.map((ob, index) => {
      blocks[`Block_${index + 1}`] = ob.id;
    });
    return blocks;
  };
  const getBlocksforFlow = unit => {
    let arr = [];
    let subBlocks = [];
    let subOcc = {};
    unit && unit.map((un, index) => {
      var _un$usageCategory2;
      arr = un === null || un === void 0 ? void 0 : (_un$usageCategory2 = un.usageCategory) === null || _un$usageCategory2 === void 0 ? void 0 : _un$usageCategory2.split(",");
      subBlocks = [];
      arr && arr.map((ob, ind) => {
        subBlocks.push({
          code: ob,
          i18nKey: `BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`,
          name: t(`BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`)
        });
      });
      subOcc[`Block_${index + 1}`] = subBlocks;
    });
    return subOcc;
  };
  data.BlockIds = getBlockIds(data === null || data === void 0 ? void 0 : (_data$landInfo15 = data.landInfo) === null || _data$landInfo15 === void 0 ? void 0 : _data$landInfo15.unit);
  data.address = data === null || data === void 0 ? void 0 : (_data$landInfo16 = data.landInfo) === null || _data$landInfo16 === void 0 ? void 0 : _data$landInfo16.address;
  data.data = {
    applicantName: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p11 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p11 === void 0 ? void 0 : (_APIScrutinyDetails$p12 = _APIScrutinyDetails$p11.planInformation) === null || _APIScrutinyDetails$p12 === void 0 ? void 0 : _APIScrutinyDetails$p12.applicantName,
    applicationDate: data === null || data === void 0 ? void 0 : (_data$auditDetails2 = data.auditDetails) === null || _data$auditDetails2 === void 0 ? void 0 : _data$auditDetails2.createdTime,
    applicationType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType,
    holdingNumber: data === null || data === void 0 ? void 0 : (_data$additionalDetai13 = data.additionalDetails) === null || _data$additionalDetai13 === void 0 ? void 0 : _data$additionalDetai13.holdingNo,
    occupancyType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p13 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p13 === void 0 ? void 0 : (_APIScrutinyDetails$p14 = _APIScrutinyDetails$p13.planInformation) === null || _APIScrutinyDetails$p14 === void 0 ? void 0 : _APIScrutinyDetails$p14.occupancy,
    registrationDetails: data === null || data === void 0 ? void 0 : (_data$additionalDetai14 = data.additionalDetails) === null || _data$additionalDetai14 === void 0 ? void 0 : _data$additionalDetai14.registrationDetails,
    riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA3 = mdmsData.BPA) === null || _mdmsData$BPA3 === void 0 ? void 0 : _mdmsData$BPA3.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p15 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p15 === void 0 ? void 0 : (_APIScrutinyDetails$p16 = _APIScrutinyDetails$p15.plot) === null || _APIScrutinyDetails$p16 === void 0 ? void 0 : _APIScrutinyDetails$p16.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p17 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p17 === void 0 ? void 0 : _APIScrutinyDetails$p17.blocks),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai15 = data.additionalDetails) === null || _data$additionalDetai15 === void 0 ? void 0 : _data$additionalDetai15.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType),
    edcrDetails: APIScrutinyDetails,
    scrutinyNumber: {
      edcrNumber: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.edcrNumber
    }
  };
  let PrevStateDocuments = [];
  data === null || data === void 0 ? void 0 : data.documents.map(doc => PrevStateDocuments.push(doc));
  data["PrevStateDocuments"] = cloneDeep(PrevStateDocuments);
  data.documents = {
    documents: []
  };
  let nocDocs = [];
  nocdata && nocdata.map((a, index) => {
    a.documents && a.documents.map((b, index) => {
      nocDocs.push(b);
    });
  });
  data["PrevStateNocDocuments"] = nocDocs;
  data.nocDocuments = {
    NocDetails: nocdata,
    nocDocuments: []
  };
  data === null || data === void 0 ? void 0 : data.landInfo.owners.map((owner, ind) => {
    owner.gender = {
      active: true,
      code: owner.gender,
      i18nKey: `COMMON_GENDER_${owner.gender}`
    };
  });
  data.owners = {
    owners: data === null || data === void 0 ? void 0 : (_data$landInfo17 = data.landInfo) === null || _data$landInfo17 === void 0 ? void 0 : _data$landInfo17.owners,
    ownershipCategory: {
      active: true,
      code: data === null || data === void 0 ? void 0 : (_data$landInfo18 = data.landInfo) === null || _data$landInfo18 === void 0 ? void 0 : _data$landInfo18.ownershipCategory,
      i18nKey: `COMMON_MASTERS_OWNERSHIPCATEGORY_${data === null || data === void 0 ? void 0 : (_data$landInfo19 = data.landInfo) === null || _data$landInfo19 === void 0 ? void 0 : _data$landInfo19.ownershipCategory.replaceAll(".", "_")}`
    }
  };
  data.riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA4 = mdmsData.BPA) === null || _mdmsData$BPA4 === void 0 ? void 0 : _mdmsData$BPA4.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p18 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p18 === void 0 ? void 0 : (_APIScrutinyDetails$p19 = _APIScrutinyDetails$p18.plot) === null || _APIScrutinyDetails$p19 === void 0 ? void 0 : _APIScrutinyDetails$p19.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p20 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p20 === void 0 ? void 0 : _APIScrutinyDetails$p20.blocks);
  data.subOccupancy = getBlocksforFlow(data === null || data === void 0 ? void 0 : (_data$landInfo20 = data.landInfo) === null || _data$landInfo20 === void 0 ? void 0 : _data$landInfo20.unit);
  mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA5 = mdmsData.BPA) === null || _mdmsData$BPA5 === void 0 ? void 0 : (_mdmsData$BPA5$homePa = _mdmsData$BPA5.homePageUrlLinks) === null || _mdmsData$BPA5$homePa === void 0 ? void 0 : _mdmsData$BPA5$homePa.map(linkData => {
  });
  data.uiFlow = {
    flow: data !== null && data !== void 0 && data.businessService.includes("OC") ? "OCBPA" : data === null || data === void 0 ? void 0 : (_data$businessService3 = data.businessService) === null || _data$businessService3 === void 0 ? void 0 : _data$businessService3.split(".")[0],
    applicationType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai16 = data.additionalDetails) === null || _data$additionalDetai16 === void 0 ? void 0 : _data$additionalDetai16.applicationType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai17 = data.additionalDetails) === null || _data$additionalDetai17 === void 0 ? void 0 : _data$additionalDetai17.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  sessionStorage.setItem("BPA_IS_ALREADY_WENT_OFF_DETAILS", JSON.stringify(true));
  return data;
};
const getPath = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const convertDateTimeToEpoch = dateTimeString => {
  try {
    const parts = dateTimeString.match(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})/);
    return Date.UTC(+parts[3], parts[2] - 1, +parts[1], +parts[4], +parts[5]);
  } catch (e) {
    return dateTimeString;
  }
};
const convertEpochToDate = dateEpoch => {
  if (dateEpoch) {
    const dateFromApi = new Date(dateEpoch);
    let month = dateFromApi.getMonth() + 1;
    let day = dateFromApi.getDate();
    let year = dateFromApi.getFullYear();
    month = (month > 9 ? "" : "0") + month;
    day = (day > 9 ? "" : "0") + day;
    return `${year}-${month}-${day}`;
  } else {
    return null;
  }
};
const addYearsToEpoch = (epoch, years) => {
  if (!epoch) return null;
  const date = new Date(epoch);
  date.setFullYear(date.getFullYear() + years);
  return date.getTime();
};
const getBusinessServices = (businessService, status) => {
  let billBusinessService = "BPA.NC_APP_FEE";
  if (businessService === "BPA_LOW") {
    billBusinessService = "BPA.LOW_RISK_PERMIT_FEE";
  } else if (businessService === "BPA") {
    billBusinessService = status == "PENDING_APPL_FEE" ? "BPA.NC_APP_FEE" : "BPA.NC_SAN_FEE";
  } else if (businessService === "BPA_OC") {
    billBusinessService = status == "PENDING_APPL_FEE" ? "BPA.NC_OC_APP_FEE" : "BPA.NC_OC_SAN_FEE";
  }
  return billBusinessService;
};
const downloadPdf = (blob, fileName) => {
  if (window.mSewaApp && window.mSewaApp.isMsewaApp() && window.mSewaApp.downloadBase64File) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      var base64data = reader.result;
      mSewaApp.downloadBase64File(base64data, fileName);
    };
  } else {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
  }
};
const printPdf = blob => {
  const fileURL = URL.createObjectURL(blob);
  var myWindow = window.open(fileURL);
  if (myWindow != undefined) {
    myWindow.addEventListener("load", event => {
      myWindow.focus();
      myWindow.print();
    });
  }
};
const downloadAndPrintReciept = async (bussinessService, consumerCode, tenantId, mode = "download", pdfKey = "consolidatedreceipt") => {
  const response = await Digit.OBPSService.receipt_download(bussinessService, consumerCode, tenantId, {
    pdfKey: pdfKey
  });
  const responseStatus = parseInt(response.status, 10);
  if (responseStatus === 201 || responseStatus === 200) {
    let fileName = mode == "print" ? printPdf(new Blob([response.data], {
      type: "application/pdf"
    })) : downloadPdf(new Blob([response.data], {
      type: "application/pdf"
    }), `RECEIPT-${consumerCode}.pdf`);
  }
};
const showHidingLinksForStakeholder = (roles = []) => {
  let userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
  const userInfo = userInfos ? JSON.parse(userInfos) : {};
  let checkedRoles = [];
  const stateId = Digit.ULBService.getStateId();
  const rolearray = roles === null || roles === void 0 ? void 0 : roles.map(role => {
    var _userInfo$value, _userInfo$value$info, _userInfo$value$info$;
    userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : (_userInfo$value$info = _userInfo$value.info) === null || _userInfo$value$info === void 0 ? void 0 : (_userInfo$value$info$ = _userInfo$value$info.roles) === null || _userInfo$value$info$ === void 0 ? void 0 : _userInfo$value$info$.map(item => {
      if (item.code === role.code && (item.tenantId === role.tenantId || item.tenantId === stateId)) {
        checkedRoles.push(item);
      }
    });
  });
  return checkedRoles === null || checkedRoles === void 0 ? void 0 : checkedRoles.length;
};
const showHidingLinksForBPA = (roles = []) => {
  const userInfo = Digit.UserService.getUser();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  let checkedRoles = [];
  const rolearray = roles === null || roles === void 0 ? void 0 : roles.map(role => {
    var _userInfo$info, _userInfo$info$roles;
    userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(item => {
      if (item.code == role && (item.tenantId === tenantId || item.tenantId === stateId)) {
        checkedRoles.push(item);
      }
    });
  });
  return checkedRoles === null || checkedRoles === void 0 ? void 0 : checkedRoles.length;
};
const getCheckBoxLabelData = (t, appData) => {
  if ((appData === null || appData === void 0 ? void 0 : appData.status) == "CITIZEN_APPROVAL_INPROCESS") {
    return `${t(`BPA_CITIZEN_1_DECLARAION_LABEL`)}${t(`BPA_CITIZEN_2_DECLARAION_LABEL`)}`;
  } else if ((appData === null || appData === void 0 ? void 0 : appData.status) == "INPROGRESS") {
    return `${t(`BPA_STAKEHOLDER_1_DECLARAION_LABEL`)}${t(`BPA_STAKEHOLDER_2_DECLARAION_LABEL`)}`;
  }
};
const scrutinyDetailsData = async (edcrNumber, tenantId) => {
  var _scrutinyDetails$edcr, _scrutinyDetails$edcr2;
  const scrutinyDetails = await Digit.OBPSService.scrutinyDetails(tenantId, {
    edcrNumber: edcrNumber
  });
  return scrutinyDetails !== null && scrutinyDetails !== void 0 && (_scrutinyDetails$edcr = scrutinyDetails.edcrDetail) !== null && _scrutinyDetails$edcr !== void 0 && _scrutinyDetails$edcr[0] ? scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$edcr2 = scrutinyDetails.edcrDetail) === null || _scrutinyDetails$edcr2 === void 0 ? void 0 : _scrutinyDetails$edcr2[0] : {
    type: "ERROR",
    message: "BPA_NO_RECORD_FOUND"
  };
};
const getOCEDCRDetails = async (edcrNumber, tenantId) => {
  try {
    const valueToStore = await Digit.OBPSService.scrutinyDetails(tenantId, {
      edcrNumber: edcrNumber
    });
    return valueToStore;
  } catch (err) {
    var _err$response, _err$response2;
    return err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.statusText ? err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.statusText : "BPA_INTERNAL_SERVER_ERROR";
  }
};
const ocScrutinyDetailsData = async (edcrNumber, tenantId) => {
  var _scrutinyDetails$edcr3, _scrutinyDetails$edcr4, _scrutinyDetails$edcr5, _scrutinyDetails$edcr6, _bpaDetails$BPA, _bpaDetails$BPA$, _bpaDetails$BPA2, _bpaDetails$BPA2$, _scrutinyDetails$edcr7, _scrutinyDetails$edcr8, _scrutinyDetails$edcr9, _scrutinyDetails$edcr10;
  const scrutinyDetails = await getOCEDCRDetails(edcrNumber, tenantId);
  if (!(scrutinyDetails !== null && scrutinyDetails !== void 0 && (_scrutinyDetails$edcr3 = scrutinyDetails.edcrDetail) !== null && _scrutinyDetails$edcr3 !== void 0 && (_scrutinyDetails$edcr4 = _scrutinyDetails$edcr3[0]) !== null && _scrutinyDetails$edcr4 !== void 0 && _scrutinyDetails$edcr4.edcrNumber)) {
    return {
      type: "ERROR",
      message: scrutinyDetails ? scrutinyDetails : "BPA_NO_RECORD_FOUND"
    };
  }
  const bpaDetails = await Digit.OBPSService.BPASearch(tenantId, {
    approvalNo: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$edcr5 = scrutinyDetails.edcrDetail) === null || _scrutinyDetails$edcr5 === void 0 ? void 0 : (_scrutinyDetails$edcr6 = _scrutinyDetails$edcr5[0]) === null || _scrutinyDetails$edcr6 === void 0 ? void 0 : _scrutinyDetails$edcr6.permitNumber
  });
  const bpaEdcrNumber = bpaDetails === null || bpaDetails === void 0 ? void 0 : (_bpaDetails$BPA = bpaDetails.BPA) === null || _bpaDetails$BPA === void 0 ? void 0 : (_bpaDetails$BPA$ = _bpaDetails$BPA[0]) === null || _bpaDetails$BPA$ === void 0 ? void 0 : _bpaDetails$BPA$.edcrNumber;
  tenantId = bpaDetails === null || bpaDetails === void 0 ? void 0 : (_bpaDetails$BPA2 = bpaDetails.BPA) === null || _bpaDetails$BPA2 === void 0 ? void 0 : (_bpaDetails$BPA2$ = _bpaDetails$BPA2[0]) === null || _bpaDetails$BPA2$ === void 0 ? void 0 : _bpaDetails$BPA2$.tenantId;
  const edcrDetails = await Digit.OBPSService.scrutinyDetails(tenantId, {
    edcrNumber: bpaEdcrNumber
  });
  const bpaResponse = await Digit.OBPSService.BPASearch(tenantId, {
    edcrNumber: edcrNumber
  });
  if (!(scrutinyDetails !== null && scrutinyDetails !== void 0 && (_scrutinyDetails$edcr7 = scrutinyDetails.edcrDetail) !== null && _scrutinyDetails$edcr7 !== void 0 && (_scrutinyDetails$edcr8 = _scrutinyDetails$edcr7[0]) !== null && _scrutinyDetails$edcr8 !== void 0 && _scrutinyDetails$edcr8.edcrNumber)) {
    return {
      type: "ERROR",
      message: scrutinyDetails ? scrutinyDetails : "BPA_NO_RECORD_FOUND"
    };
  }
  if (scrutinyDetails !== null && scrutinyDetails !== void 0 && (_scrutinyDetails$edcr9 = scrutinyDetails.edcrDetail) !== null && _scrutinyDetails$edcr9 !== void 0 && (_scrutinyDetails$edcr10 = _scrutinyDetails$edcr9[0]) !== null && _scrutinyDetails$edcr10 !== void 0 && _scrutinyDetails$edcr10.edcrNumber) {
    var _scrutinyDetails$edcr11;
    return {
      ocEdcrDetails: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$edcr11 = scrutinyDetails.edcrDetail) === null || _scrutinyDetails$edcr11 === void 0 ? void 0 : _scrutinyDetails$edcr11[0],
      otherDetails: {
        bpaApprovalResponse: bpaDetails === null || bpaDetails === void 0 ? void 0 : bpaDetails.BPA,
        edcrDetails: edcrDetails === null || edcrDetails === void 0 ? void 0 : edcrDetails.edcrDetail,
        bpaResponse: bpaResponse === null || bpaResponse === void 0 ? void 0 : bpaResponse.BPA
      }
    };
  } else {
    return {
      type: "ERROR",
      message: "BPA_NO_RECORD_FOUND"
    };
  }
};
const getOrderDocuments = (appUploadedDocumnets, isNoc = false) => {
  let finalDocs = [];
  if ((appUploadedDocumnets === null || appUploadedDocumnets === void 0 ? void 0 : appUploadedDocumnets.length) > 0) {
    let uniqueDocmnts = appUploadedDocumnets.filter((elem, index) => appUploadedDocumnets.findIndex(obj => {
      var _obj$documentType, _obj$documentType$spl, _obj$documentType$spl2, _elem$documentType, _elem$documentType$sp, _elem$documentType$sp2;
      return (obj === null || obj === void 0 ? void 0 : (_obj$documentType = obj.documentType) === null || _obj$documentType === void 0 ? void 0 : (_obj$documentType$spl = _obj$documentType.split(".")) === null || _obj$documentType$spl === void 0 ? void 0 : (_obj$documentType$spl2 = _obj$documentType$spl.slice(0, 2)) === null || _obj$documentType$spl2 === void 0 ? void 0 : _obj$documentType$spl2.join("_")) === (elem === null || elem === void 0 ? void 0 : (_elem$documentType = elem.documentType) === null || _elem$documentType === void 0 ? void 0 : (_elem$documentType$sp = _elem$documentType.split(".")) === null || _elem$documentType$sp === void 0 ? void 0 : (_elem$documentType$sp2 = _elem$documentType$sp.slice(0, 2)) === null || _elem$documentType$sp2 === void 0 ? void 0 : _elem$documentType$sp2.join("_"));
    }) === index);
    uniqueDocmnts === null || uniqueDocmnts === void 0 ? void 0 : uniqueDocmnts.map(uniDoc => {
      var _resultsDocs$, _resultsDocs$$documen, _resultsDocs$$documen2, _resultsDocs$$documen3;
      const resultsDocs = appUploadedDocumnets === null || appUploadedDocumnets === void 0 ? void 0 : appUploadedDocumnets.filter(appDoc => {
        var _uniDoc$documentType, _uniDoc$documentType$, _uniDoc$documentType$2, _appDoc$documentType, _appDoc$documentType$, _appDoc$documentType$2;
        return (uniDoc === null || uniDoc === void 0 ? void 0 : (_uniDoc$documentType = uniDoc.documentType) === null || _uniDoc$documentType === void 0 ? void 0 : (_uniDoc$documentType$ = _uniDoc$documentType.split(".")) === null || _uniDoc$documentType$ === void 0 ? void 0 : (_uniDoc$documentType$2 = _uniDoc$documentType$.slice(0, 2)) === null || _uniDoc$documentType$2 === void 0 ? void 0 : _uniDoc$documentType$2.join("_")) == (appDoc === null || appDoc === void 0 ? void 0 : (_appDoc$documentType = appDoc.documentType) === null || _appDoc$documentType === void 0 ? void 0 : (_appDoc$documentType$ = _appDoc$documentType.split(".")) === null || _appDoc$documentType$ === void 0 ? void 0 : (_appDoc$documentType$2 = _appDoc$documentType$.slice(0, 2)) === null || _appDoc$documentType$2 === void 0 ? void 0 : _appDoc$documentType$2.join("_"));
      });
      resultsDocs === null || resultsDocs === void 0 ? void 0 : resultsDocs.forEach(resDoc => resDoc.title = resDoc.documentType);
      finalDocs.push({
        title: !isNoc ? resultsDocs === null || resultsDocs === void 0 ? void 0 : (_resultsDocs$ = resultsDocs[0]) === null || _resultsDocs$ === void 0 ? void 0 : (_resultsDocs$$documen = _resultsDocs$.documentType) === null || _resultsDocs$$documen === void 0 ? void 0 : (_resultsDocs$$documen2 = _resultsDocs$$documen.split(".")) === null || _resultsDocs$$documen2 === void 0 ? void 0 : (_resultsDocs$$documen3 = _resultsDocs$$documen2.slice(0, 2)) === null || _resultsDocs$$documen3 === void 0 ? void 0 : _resultsDocs$$documen3.join("_") : "",
        values: resultsDocs
      });
    });
  }
  return finalDocs;
};
const toTitleCase = (str = '') => {
  if (!str || str.length <= 0) {
    return '';
  }
  return str.toLowerCase().split(' ').map(word => {
    try {
      return word.replace(word[0], word[0].toUpperCase());
    } catch (error) {
      return '';
    }
  }).join(' ');
};

const MobileInbox = ({
  data,
  vehicleLog,
  isLoading,
  isSearch,
  onSearch,
  onFilterChange,
  onSort,
  searchParams,
  searchFields,
  linkPrefix,
  parentRoute,
  removeParam,
  sortParams
}) => {
  const {
    t
  } = useTranslation();
  const getData = () => data === null || data === void 0 ? void 0 : data.table.map(e => {
    var _e$businessService, _e$businessService2;
    return {
      [t("WF_INBOX_HEADER_APPLICATION_NO")]: e === null || e === void 0 ? void 0 : e["applicationId"],
      [t("TL_COMMON_TABLE_COL_APP_DATE")]: convertEpochToDateDMY(e === null || e === void 0 ? void 0 : e["date"]),
      [t("TL_COMMON_TABLE_COL_APP_TYPE")]: e !== null && e !== void 0 && e["businessService"] ? t(`CS_COMMON_INBOX_${e === null || e === void 0 ? void 0 : (_e$businessService = e["businessService"]) === null || _e$businessService === void 0 ? void 0 : _e$businessService.toUpperCase()}`) : t("NA"),
      [t("WF_INBOX_HEADER_LOCALITY")]: t(Digit.Utils.locale.getRevenueLocalityCode(e === null || e === void 0 ? void 0 : e["locality"], e === null || e === void 0 ? void 0 : e["tenantId"])),
      [t("WF_INBOX_HEADER_STATUS")]: t(e !== null && e !== void 0 && e["businessService"] ? `WF_${(_e$businessService2 = e["businessService"]) === null || _e$businessService2 === void 0 ? void 0 : _e$businessService2.toUpperCase()}_${e === null || e === void 0 ? void 0 : e["status"]}` : `NA`),
      [t("WF_INBOX_HEADER_CURRENT_OWNER")]: t(e === null || e === void 0 ? void 0 : e.owner),
      [t("WF_INBOX_HEADER_SLA_DAYS_REMAINING")]: e === null || e === void 0 ? void 0 : e["sla"]
    };
  });
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inbox-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React__default.createElement(InboxLinks, {
    classNameForMobileView: "linksWrapperForMobileInbox",
    linkPrefix: parentRoute,
    allLinks: [{
      text: "TL_NEW_APPLICATION",
      link: "/digit-ui/employee/tl/new-application",
      businessService: "TL",
      roles: ["TL_CEMP"]
    }, {
      text: "TL_SEARCH_APPLICATIONS",
      link: "/digit-ui/employee/tl/search/application",
      businessService: "TL",
      roles: ["TL_FIELD_INSPECTOR", "TL_APPROVER", "TL_DOC_VERIFIER", "TL_CEMP"]
    }, {
      text: "TL_SEARCH_LICENSE",
      link: "/digit-ui/employee/tl/search/license",
      businessService: "TL",
      roles: ["TL_APPROVER", "TL_DOC_VERIFIER", "TL_FIELD_INSPECTOR"]
    }, {
      text: "TL_RENEWAL_HEADER",
      link: "/digit-ui/employee/tl/search/license",
      businessService: "TL",
      roles: ["TL_CEMP"]
    }, {
      text: "ACTION_TEST_DASHBOARD",
      link: "/digit-ui/employee/dss/dashboard/tradelicence",
      businessService: "TL",
      roles: ["STADMIN"]
    }],
    headerText: t("ACTION_TEST_TRADELICENSE"),
    isMobile: true
  }), /*#__PURE__*/React__default.createElement(ApplicationCard, {
    t: t,
    data: getData(),
    onFilterChange: onFilterChange,
    serviceRequestIdKey: t("WF_INBOX_HEADER_APPLICATION_NO"),
    isLoading: isLoading,
    onSearch: onSearch,
    onSort: onSort,
    searchParams: searchParams,
    searchFields: searchFields,
    linkPrefix: linkPrefix,
    removeParam: removeParam,
    sortParams: sortParams
  }))));
};

const ApplicationTable = ({
  t,
  currentPage,
  columns,
  data,
  getCellProps,
  disableSort,
  onSort,
  onNextPage,
  onPrevPage,
  onPageSizeChange,
  pageSizeLimit,
  sortParams,
  totalRecords
}) => {
  return /*#__PURE__*/React__default.createElement(Table, {
    t: t,
    data: data,
    currentPage: currentPage,
    columns: columns,
    getCellProps: getCellProps,
    onNextPage: onNextPage,
    onPrevPage: onPrevPage,
    pageSizeLimit: pageSizeLimit,
    disableSort: disableSort,
    onPageSizeChange: onPageSizeChange,
    onSort: onSort,
    sortParams: sortParams,
    totalRecords: totalRecords
  });
};

const DesktopForm12Inbox = ({
  tableConfig,
  filterComponent,
  columns,
  isLoading,
  setSearchFieldsBackToOriginalState,
  setSetSearchFieldsBackToOriginalState,
  ...props
}) => {
  var _data$table, _data$table2;
  const {
    data
  } = props;
  const {
    t
  } = useTranslation();
  const [FilterComponent, setComp] = useState(() => {
    var _Digit$ComponentRegis;
    return (_Digit$ComponentRegis = Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent(filterComponent);
  });
  const GetCell = value => /*#__PURE__*/React__default.createElement("span", {
    className: "cell-text"
  }, value);
  const GetSlaCell = value => {
    if (isNaN(value)) return /*#__PURE__*/React__default.createElement("span", {
      className: "sla-cell-success"
    }, "0");
    return value < 0 ? /*#__PURE__*/React__default.createElement("span", {
      className: "sla-cell-error"
    }, value) : /*#__PURE__*/React__default.createElement("span", {
      className: "sla-cell-success"
    }, value);
  };
  const isEmployee = window.location.pathname.split("/").includes("employee");
  const inboxColumns = () => [{
    Header: t("WF_INBOX_HEADER_APPLICATION_NO"),
    Cell: ({
      row
    }) => {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
        className: "link"
      }, /*#__PURE__*/React__default.createElement(Link, {
        to: isEmployee ? "/digit-ui/employee/obps/bpa/" + row.original["applicationId"] : "/digit-ui/citizen/obps/bpa/" + row.original["applicationId"]
      }, row.original["applicationId"])));
    }
  }, {
    Header: t("TL_COMMON_TABLE_COL_APP_DATE"),
    accessor: "applicationDate",
    Cell: ({
      row
    }) => {
      const date = convertEpochToDateDMY(row.original.date);
      return GetCell(date);
    }
  }, {
    Header: t("TL_COMMON_TABLE_COL_APP_TYPE"),
    Cell: ({
      row
    }) => {
      var _row$original$busines;
      return GetCell(t(row.original["businessService"] ? `CS_COMMON_INBOX_${(_row$original$busines = row.original["businessService"]) === null || _row$original$busines === void 0 ? void 0 : _row$original$busines.toUpperCase()}` : "NA"));
    }
  }, {
    Header: t("WF_INBOX_HEADER_LOCALITY"),
    Cell: ({
      row
    }) => {
      return GetCell(t(Digit.Utils.locale.getRevenueLocalityCode(row.original["locality"], row.original["tenantId"])));
    }
  }, {
    Header: t("WF_INBOX_HEADER_STATUS"),
    Cell: ({
      row
    }) => {
      var _row$original$busines2, _row$original;
      return GetCell(t(row.original["businessService"] ? `WF_${(_row$original$busines2 = row.original["businessService"]) === null || _row$original$busines2 === void 0 ? void 0 : _row$original$busines2.toUpperCase()}_${(_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original["status"]}` : `NA`));
    }
  }, {
    Header: t("WF_INBOX_HEADER_CURRENT_OWNER"),
    Cell: ({
      row
    }) => {
      var _row$original2;
      return GetCell(t(`${(_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2.owner}`));
    }
  }, {
    Header: t("WF_INBOX_HEADER_SLA_DAYS_REMAINING"),
    Cell: ({
      row
    }) => {
      return GetSlaCell(row.original["sla"]);
    }
  }];
  let result;
  if (props.isLoading) {
    result = /*#__PURE__*/React__default.createElement(Loader, null);
  } else if ((data === null || data === void 0 ? void 0 : (_data$table = data.table) === null || _data$table === void 0 ? void 0 : _data$table.length) === 0) {
    result = /*#__PURE__*/React__default.createElement(Card, {
      style: {
        marginTop: 20
      }
    }, t("CS_MYAPPLICATIONS_NO_APPLICATION").split("\\n").map((text, index) => /*#__PURE__*/React__default.createElement("p", {
      key: index,
      style: {
        textAlign: "center"
      }
    }, text)));
  } else if ((data === null || data === void 0 ? void 0 : (_data$table2 = data.table) === null || _data$table2 === void 0 ? void 0 : _data$table2.length) > 0) {
    result = /*#__PURE__*/React__default.createElement(ApplicationTable, {
      t: t,
      data: data === null || data === void 0 ? void 0 : data.table,
      columns: inboxColumns(),
      getCellProps: cellInfo => {
        return {
          style: {
            minWidth: cellInfo.column.Header === t("ES_INBOX_APPLICATION_NO") ? "240px" : "",
            padding: "20px 18px",
            fontSize: "16px"
          }
        };
      },
      onPageSizeChange: props.onPageSizeChange,
      currentPage: props.currentPage,
      onNextPage: props.onNextPage,
      onPrevPage: props.onPrevPage,
      pageSizeLimit: props.pageSizeLimit,
      onSort: props.onSort,
      disableSort: props.disableSort,
      sortParams: props.sortParams,
      totalRecords: props.totalRecords
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "inbox-container"
  }, !props.isSearch && /*#__PURE__*/React__default.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React__default.createElement(InboxLinks, {
    parentRoute: props.parentRoute,
    allLinks: [{
      text: "TL_NEW_APPLICATION",
      link: "/digit-ui/employee/tl/new-application",
      businessService: "TL",
      roles: ["TL_CEMP"]
    }, {
      text: "TL_SEARCH_APPLICATIONS",
      link: "/digit-ui/employee/tl/search/application",
      businessService: "TL",
      roles: ["TL_FIELD_INSPECTOR", "TL_APPROVER", "TL_DOC_VERIFIER", "TL_CEMP"]
    }, {
      text: "TL_SEARCH_LICENSE",
      link: "/digit-ui/employee/tl/search/license",
      businessService: "TL",
      roles: ["TL_APPROVER", "TL_DOC_VERIFIER", "TL_FIELD_INSPECTOR"]
    }, {
      text: "TL_RENEWAL_HEADER",
      link: "/digit-ui/employee/tl/search/license",
      businessService: "TL",
      roles: ["TL_CEMP"]
    }, {
      text: "ACTION_TEST_DASHBOARD",
      link: "/digit-ui/employee/dss/dashboard/tradelicence",
      businessService: "TL",
      roles: ["STADMIN"]
    }],
    headerText: t("BPA_FORM12_INBOX"),
    businessService: props.businessService
  }), /*#__PURE__*/React__default.createElement("div", null, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FilterComponent, {
    defaultSearchParams: props.defaultSearchParams,
    statuses: data === null || data === void 0 ? void 0 : data.statuses,
    onFilterChange: props.onFilterChange,
    searchParams: props.searchParams,
    type: "desktop"
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(SearchApplication, Object.assign({
    defaultSearchParams: props.defaultSearchParams,
    onSearch: props.onSearch,
    type: "desktop",
    searchFields: props.searchFields,
    isInboxPage: !(props !== null && props !== void 0 && props.isSearch),
    searchParams: props.searchParams
  }, {
    setSearchFieldsBackToOriginalState,
    setSetSearchFieldsBackToOriginalState
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "result",
    style: {
      marginLeft: !(props !== null && props !== void 0 && props.isSearch) ? "24px" : "",
      flex: 1
    }
  }, result)));
};

const BPAForm12Inbox = ({
  parentRoute,
  businessService: _businessService = ["BPA"],
  initialStates: _initialStates = {},
  filterComponent,
  isInbox
}) => {
  var _sortParams$, _sortParams$2, _sortParams$3, _sortParams$4;
  const tenantId = "hp";
  const [enableSarch, setEnableSearch] = useState(() => isInbox ? {} : {
    enabled: false
  });
  const {
    t
  } = useTranslation();
  const [pageOffset, setPageOffset] = useState((_initialStates === null || _initialStates === void 0 ? void 0 : _initialStates.pageOffset) || 0);
  const [pageSize, setPageSize] = useState((_initialStates === null || _initialStates === void 0 ? void 0 : _initialStates.pageSize) || 10);
  const [sortParams, setSortParams] = useState((_initialStates === null || _initialStates === void 0 ? void 0 : _initialStates.sortParams) || [{
    id: "applicationDate",
    desc: false
  }]);
  const [setSearchFieldsBackToOriginalState, setSetSearchFieldsBackToOriginalState] = useState(false);
  const [searchParams, setSearchParams] = useState(() => {
    return (_initialStates === null || _initialStates === void 0 ? void 0 : _initialStates.searchParams) || {};
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  let paginationParams = isMobile ? {
    limit: 100,
    offset: 0,
    sortBy: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$ = sortParams[0]) === null || _sortParams$ === void 0 ? void 0 : _sortParams$.id,
    sortOrder: sortParams !== null && sortParams !== void 0 && (_sortParams$2 = sortParams[0]) !== null && _sortParams$2 !== void 0 && _sortParams$2.desc ? "DESC" : "ASC"
  } : {
    limit: pageSize,
    offset: pageOffset,
    sortBy: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$3 = sortParams[0]) === null || _sortParams$3 === void 0 ? void 0 : _sortParams$3.id,
    sortOrder: sortParams !== null && sortParams !== void 0 && (_sortParams$4 = sortParams[0]) !== null && _sortParams$4 !== void 0 && _sortParams$4.desc ? "DESC" : "ASC"
  };
  const {
    isFetching,
    isLoading: hookLoading,
    searchResponseKey,
    data,
    searchFields,
    ...rest
  } = Digit.Hooks.obps.useForm12Inbox({
    tenantId,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {}
  });
  useEffect(() => {
    setPageOffset(0);
  }, [searchParams]);
  const fetchNextPage = () => {
    setPageOffset(prevState => prevState + pageSize);
  };
  const fetchPrevPage = () => {
    setPageOffset(prevState => prevState - pageSize);
  };
  const handleFilterChange = filterParam => {
    var _new2;
    let keys_to_delete = filterParam === null || filterParam === void 0 ? void 0 : filterParam.delete;
    let _new = {};
    if (isMobile) {
      _new = {
        ...filterParam
      };
    } else {
      _new = {
        ...searchParams,
        ...filterParam
      };
    }
    if (keys_to_delete) keys_to_delete.forEach(key => delete _new[key]);
    (_new2 = _new) === null || _new2 === void 0 ? true : delete _new2.delete;
    filterParam === null || filterParam === void 0 ? true : delete filterParam.delete;
    setSetSearchFieldsBackToOriginalState(true);
    setSearchParams({
      ..._new
    });
    setEnableSearch({
      enabled: true
    });
  };
  const handleSort = useCallback(args => {
    if (args.length === 0) return;
    setSortParams(args);
  }, []);
  const handlePageSizeChange = e => {
    setPageSize(Number(e.target.value));
  };
  console.log("service....12345", _businessService);
  const getSearchFields = () => {
    return [{
      label: t("TL_HOME_SEARCH_RESULTS_APP_NO_LABEL"),
      name: "applicationNumber"
    }];
  };
  useEffect(() => {}, [data]);
  if (isMobile) {
    return /*#__PURE__*/React__default.createElement(MobileInbox, {
      data: data,
      isLoading: hookLoading,
      searchFields: getSearchFields(),
      onFilterChange: handleFilterChange,
      onSearch: handleFilterChange,
      onSort: handleSort,
      parentRoute: parentRoute,
      searchParams: searchParams,
      sortParams: sortParams
    });
  } else {
    return /*#__PURE__*/React__default.createElement("div", null, isInbox && /*#__PURE__*/React__default.createElement(Header, null, t("ES_COMMON_INBOX")), /*#__PURE__*/React__default.createElement(DesktopForm12Inbox, {
      businessService: _businessService,
      data: data,
      tableConfig: rest === null || rest === void 0 ? void 0 : rest.tableConfig,
      isLoading: hookLoading,
      defaultSearchParams: _initialStates.searchParams,
      isSearch: !isInbox,
      onFilterChange: handleFilterChange,
      searchFields: getSearchFields(),
      setSearchFieldsBackToOriginalState: setSearchFieldsBackToOriginalState,
      setSetSearchFieldsBackToOriginalState: setSetSearchFieldsBackToOriginalState,
      onSearch: handleFilterChange,
      onSort: handleSort,
      onNextPage: fetchNextPage,
      onPrevPage: fetchPrevPage,
      currentPage: Math.floor(pageOffset / pageSize),
      pageSizeLimit: pageSize,
      disableSort: false,
      onPageSizeChange: handlePageSizeChange,
      parentRoute: parentRoute,
      searchParams: searchParams,
      sortParams: sortParams,
      totalRecords: Number(data === null || data === void 0 ? void 0 : data.totalCount),
      filterComponent: filterComponent
    }));
  }
};

const MyApplication = () => {
  var _userInfo$info, _userInfo$info2, _userInfo$info3, _userInfo$info3$roles, _userInfo$info4, _data$Licenses3;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [finalData, setFinalData] = useState([]);
  const [labelMessage, setLableMessage] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser();
  const requestor = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.mobileNumber;
  const mobileNumber = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber;
  const isStakeholder = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : (_userInfo$info3$roles = _userInfo$info3.roles) === null || _userInfo$info3$roles === void 0 ? void 0 : _userInfo$info3$roles.length) > 1 && !(userInfo !== null && userInfo !== void 0 && (_userInfo$info4 = userInfo.info) !== null && _userInfo$info4 !== void 0 && _userInfo$info4.roles.some(role => role.code === "BPA_STRUCTURALENGINEER"));
  const {
    data,
    isLoading,
    revalidate
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading,
    revalidate: bpaRevalidate
  } = isStakeholder ? Digit.Hooks.obps.useBPASearch(tenantId, {
    requestor,
    limit: 20,
    offset: 0
  }) : Digit.Hooks.obps.useBPASearch(tenantId, {
    mobileNumber,
    limit: 20,
    offset: 0
  });
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(Digit.ULBService.getStateId(), "BPA", ["RiskTypeComputation"]);
  const getBPAREGFormData = data => {
    var _license$tradeLicense, _license$tradeLicense2, _license$tradeLicense3, _license$tradeLicense4, _license$tradeLicense5, _license$tradeLicense6, _license$tradeLicense7, _license$tradeLicense8, _license$tradeLicense9, _license$tradeLicense10, _license$tradeLicense11, _license$tradeLicense12, _license$tradeLicense13, _license$tradeLicense14, _license$tradeLicense15, _license$tradeLicense16, _license$tradeLicense17, _license$tradeLicense18, _license$tradeLicense19, _license$tradeLicense20, _license$tradeLicense21, _license$tradeLicense22, _license$tradeLicense23, _license$tradeLicense24, _license$tradeLicense25, _license$tradeLicense26, _license$tradeLicense27, _license$tradeLicense28, _license$tradeLicense29, _license$tradeLicense30, _license$tradeLicense31, _license$tradeLicense32, _license$tradeLicense33, _license$tradeLicense34, _license$tradeLicense35, _license$tradeLicense36, _license$tradeLicense37, _license$tradeLicense38, _license$tradeLicense39, _license$tradeLicense40, _license$tradeLicense41, _license$tradeLicense42, _license$tradeLicense43, _license$tradeLicense44, _license$tradeLicense45, _license$tradeLicense46, _license$tradeLicense47, _license$tradeLicense48, _license$tradeLicense49, _license$tradeLicense50, _license$tradeLicense51, _license$tradeLicense52, _license$tradeLicense53, _license$tradeLicense54, _license$tradeLicense55, _license$tradeLicense56, _license$tradeLicense57, _license$tradeLicense58, _license$tradeLicense59, _license$tradeLicense60, _license$tradeLicense61, _license$tradeLicense62, _license$tradeLicense63, _license$tradeLicense64, _license$tradeLicense65, _license$tradeLicense66;
    let license = data;
    let intermediateData = {
      "Correspondenceaddress": (license === null || license === void 0 ? void 0 : (_license$tradeLicense = license.tradeLicenseDetail) === null || _license$tradeLicense === void 0 ? void 0 : (_license$tradeLicense2 = _license$tradeLicense.owners) === null || _license$tradeLicense2 === void 0 ? void 0 : (_license$tradeLicense3 = _license$tradeLicense2[0]) === null || _license$tradeLicense3 === void 0 ? void 0 : _license$tradeLicense3.correspondenceAddress) || `${license !== null && license !== void 0 && (_license$tradeLicense4 = license.tradeLicenseDetail) !== null && _license$tradeLicense4 !== void 0 && (_license$tradeLicense5 = _license$tradeLicense4.address) !== null && _license$tradeLicense5 !== void 0 && _license$tradeLicense5.doorNo ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense6 = license.tradeLicenseDetail) === null || _license$tradeLicense6 === void 0 ? void 0 : (_license$tradeLicense7 = _license$tradeLicense6.address) === null || _license$tradeLicense7 === void 0 ? void 0 : _license$tradeLicense7.doorNo}, ` : ""} ${license !== null && license !== void 0 && (_license$tradeLicense8 = license.tradeLicenseDetail) !== null && _license$tradeLicense8 !== void 0 && (_license$tradeLicense9 = _license$tradeLicense8.address) !== null && _license$tradeLicense9 !== void 0 && _license$tradeLicense9.street ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense10 = license.tradeLicenseDetail) === null || _license$tradeLicense10 === void 0 ? void 0 : (_license$tradeLicense11 = _license$tradeLicense10.address) === null || _license$tradeLicense11 === void 0 ? void 0 : _license$tradeLicense11.street}, ` : ""}${license !== null && license !== void 0 && (_license$tradeLicense12 = license.tradeLicenseDetail) !== null && _license$tradeLicense12 !== void 0 && (_license$tradeLicense13 = _license$tradeLicense12.address) !== null && _license$tradeLicense13 !== void 0 && _license$tradeLicense13.landmark ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense14 = license.tradeLicenseDetail) === null || _license$tradeLicense14 === void 0 ? void 0 : (_license$tradeLicense15 = _license$tradeLicense14.address) === null || _license$tradeLicense15 === void 0 ? void 0 : _license$tradeLicense15.landmark}, ` : ""}${t(license === null || license === void 0 ? void 0 : (_license$tradeLicense16 = license.tradeLicenseDetail) === null || _license$tradeLicense16 === void 0 ? void 0 : (_license$tradeLicense17 = _license$tradeLicense16.address) === null || _license$tradeLicense17 === void 0 ? void 0 : _license$tradeLicense17.locality.code)}, ${t(license !== null && license !== void 0 && (_license$tradeLicense18 = license.tradeLicenseDetail) !== null && _license$tradeLicense18 !== void 0 && (_license$tradeLicense19 = _license$tradeLicense18.address) !== null && _license$tradeLicense19 !== void 0 && _license$tradeLicense19.city ? license === null || license === void 0 ? void 0 : (_license$tradeLicense20 = license.tradeLicenseDetail) === null || _license$tradeLicense20 === void 0 ? void 0 : (_license$tradeLicense21 = _license$tradeLicense20.address) === null || _license$tradeLicense21 === void 0 ? void 0 : _license$tradeLicense21.city.code : "")},${t(license === null || license === void 0 ? void 0 : (_license$tradeLicense22 = license.tradeLicenseDetail) === null || _license$tradeLicense22 === void 0 ? void 0 : (_license$tradeLicense23 = _license$tradeLicense22.address) === null || _license$tradeLicense23 === void 0 ? void 0 : _license$tradeLicense23.pincode) ? `${(_license$tradeLicense24 = license.tradeLicenseDetail) === null || _license$tradeLicense24 === void 0 ? void 0 : (_license$tradeLicense25 = _license$tradeLicense24.address) === null || _license$tradeLicense25 === void 0 ? void 0 : _license$tradeLicense25.pincode}` : " "}`,
      "formData": {
        "LicneseDetails": {
          "PanNumber": license === null || license === void 0 ? void 0 : (_license$tradeLicense26 = license.tradeLicenseDetail) === null || _license$tradeLicense26 === void 0 ? void 0 : (_license$tradeLicense27 = _license$tradeLicense26.owners) === null || _license$tradeLicense27 === void 0 ? void 0 : (_license$tradeLicense28 = _license$tradeLicense27[0]) === null || _license$tradeLicense28 === void 0 ? void 0 : _license$tradeLicense28.pan,
          "PermanentAddress": license === null || license === void 0 ? void 0 : (_license$tradeLicense29 = license.tradeLicenseDetail) === null || _license$tradeLicense29 === void 0 ? void 0 : (_license$tradeLicense30 = _license$tradeLicense29.owners) === null || _license$tradeLicense30 === void 0 ? void 0 : (_license$tradeLicense31 = _license$tradeLicense30[0]) === null || _license$tradeLicense31 === void 0 ? void 0 : _license$tradeLicense31.permanentAddress,
          "email": license === null || license === void 0 ? void 0 : (_license$tradeLicense32 = license.tradeLicenseDetail) === null || _license$tradeLicense32 === void 0 ? void 0 : (_license$tradeLicense33 = _license$tradeLicense32.owners) === null || _license$tradeLicense33 === void 0 ? void 0 : (_license$tradeLicense34 = _license$tradeLicense33[0]) === null || _license$tradeLicense34 === void 0 ? void 0 : _license$tradeLicense34.emailId,
          "gender": {
            code: license === null || license === void 0 ? void 0 : (_license$tradeLicense35 = license.tradeLicenseDetail) === null || _license$tradeLicense35 === void 0 ? void 0 : (_license$tradeLicense36 = _license$tradeLicense35.owners) === null || _license$tradeLicense36 === void 0 ? void 0 : (_license$tradeLicense37 = _license$tradeLicense36[0]) === null || _license$tradeLicense37 === void 0 ? void 0 : _license$tradeLicense37.gender,
            i18nKey: `COMMON_GENDER_${license === null || license === void 0 ? void 0 : (_license$tradeLicense38 = license.tradeLicenseDetail) === null || _license$tradeLicense38 === void 0 ? void 0 : (_license$tradeLicense39 = _license$tradeLicense38.owners) === null || _license$tradeLicense39 === void 0 ? void 0 : (_license$tradeLicense40 = _license$tradeLicense39[0]) === null || _license$tradeLicense40 === void 0 ? void 0 : _license$tradeLicense40.gender}`,
            value: license === null || license === void 0 ? void 0 : (_license$tradeLicense41 = license.tradeLicenseDetail) === null || _license$tradeLicense41 === void 0 ? void 0 : (_license$tradeLicense42 = _license$tradeLicense41.owners) === null || _license$tradeLicense42 === void 0 ? void 0 : (_license$tradeLicense43 = _license$tradeLicense42[0]) === null || _license$tradeLicense43 === void 0 ? void 0 : _license$tradeLicense43.gender
          },
          "mobileNumber": license === null || license === void 0 ? void 0 : (_license$tradeLicense44 = license.tradeLicenseDetail) === null || _license$tradeLicense44 === void 0 ? void 0 : (_license$tradeLicense45 = _license$tradeLicense44.owners) === null || _license$tradeLicense45 === void 0 ? void 0 : (_license$tradeLicense46 = _license$tradeLicense45[0]) === null || _license$tradeLicense46 === void 0 ? void 0 : _license$tradeLicense46.mobileNumber,
          "name": license === null || license === void 0 ? void 0 : (_license$tradeLicense47 = license.tradeLicenseDetail) === null || _license$tradeLicense47 === void 0 ? void 0 : (_license$tradeLicense48 = _license$tradeLicense47.owners) === null || _license$tradeLicense48 === void 0 ? void 0 : (_license$tradeLicense49 = _license$tradeLicense48[0]) === null || _license$tradeLicense49 === void 0 ? void 0 : _license$tradeLicense49.name
        },
        "LicneseType": {
          LicenseType: {
            i18nKey: `TRADELICENSE_TRADETYPE_${license === null || license === void 0 ? void 0 : (_license$tradeLicense50 = license.tradeLicenseDetail) === null || _license$tradeLicense50 === void 0 ? void 0 : (_license$tradeLicense51 = _license$tradeLicense50.tradeUnits) === null || _license$tradeLicense51 === void 0 ? void 0 : (_license$tradeLicense52 = _license$tradeLicense51[0]) === null || _license$tradeLicense52 === void 0 ? void 0 : _license$tradeLicense52.tradeType.split(".")[0]}`,
            role: [`BPA_${license === null || license === void 0 ? void 0 : (_license$tradeLicense53 = license.tradeLicenseDetail) === null || _license$tradeLicense53 === void 0 ? void 0 : (_license$tradeLicense54 = _license$tradeLicense53.tradeUnits) === null || _license$tradeLicense54 === void 0 ? void 0 : (_license$tradeLicense55 = _license$tradeLicense54[0]) === null || _license$tradeLicense55 === void 0 ? void 0 : _license$tradeLicense55.tradeType.split(".")[0]}`],
            tradeType: license === null || license === void 0 ? void 0 : (_license$tradeLicense56 = license.tradeLicenseDetail) === null || _license$tradeLicense56 === void 0 ? void 0 : (_license$tradeLicense57 = _license$tradeLicense56.tradeUnits) === null || _license$tradeLicense57 === void 0 ? void 0 : (_license$tradeLicense58 = _license$tradeLicense57[0]) === null || _license$tradeLicense58 === void 0 ? void 0 : _license$tradeLicense58.tradeType
          },
          ArchitectNo: (license === null || license === void 0 ? void 0 : (_license$tradeLicense59 = license.tradeLicenseDetail) === null || _license$tradeLicense59 === void 0 ? void 0 : (_license$tradeLicense60 = _license$tradeLicense59.additionalDetail) === null || _license$tradeLicense60 === void 0 ? void 0 : _license$tradeLicense60.counsilForArchNo) || null
        }
      },
      "isAddressSame": (license === null || license === void 0 ? void 0 : (_license$tradeLicense61 = license.tradeLicenseDetail) === null || _license$tradeLicense61 === void 0 ? void 0 : (_license$tradeLicense62 = _license$tradeLicense61.owners) === null || _license$tradeLicense62 === void 0 ? void 0 : (_license$tradeLicense63 = _license$tradeLicense62[0]) === null || _license$tradeLicense63 === void 0 ? void 0 : _license$tradeLicense63.correspondenceAddress) === (license === null || license === void 0 ? void 0 : (_license$tradeLicense64 = license.tradeLicenseDetail) === null || _license$tradeLicense64 === void 0 ? void 0 : (_license$tradeLicense65 = _license$tradeLicense64.owners) === null || _license$tradeLicense65 === void 0 ? void 0 : (_license$tradeLicense66 = _license$tradeLicense65[0]) === null || _license$tradeLicense66 === void 0 ? void 0 : _license$tradeLicense66.permanentAddress) ? true : false,
      "result": {
        Licenses: [{
          ...data
        }]
      },
      "initiationFlow": true
    };
    sessionStorage.setItem("BPAREGintermediateValue", JSON.stringify(intermediateData));
    history.push("/digit-ui/citizen/obps/stakeholder/apply/stakeholder-docs-required");
  };
  useEffect(() => {
    return () => {
      setFinalData([]);
      revalidate === null || revalidate === void 0 ? void 0 : revalidate();
      bpaRevalidate === null || bpaRevalidate === void 0 ? void 0 : bpaRevalidate();
    };
  }, []);
  useEffect(() => {
    if (!isLoading && !isBpaSearchLoading) {
      var _data$Licenses, _userInfoDetails$valu, _userInfoDetails$valu2, _userInfoDetails$valu3, _userInfoDetails$valu4, _userInfoDetails$valu5, _userInfoDetails$valu6, _userInfoDetails$valu7;
      let searchConvertedArray = [];
      let sortConvertedArray = [];
      if (data !== null && data !== void 0 && (_data$Licenses = data.Licenses) !== null && _data$Licenses !== void 0 && _data$Licenses.length) {
        var _data$Licenses2;
        data === null || data === void 0 ? void 0 : (_data$Licenses2 = data.Licenses) === null || _data$Licenses2 === void 0 ? void 0 : _data$Licenses2.forEach(license => {
          license.sortNumber = 0;
          license.modifiedTime = license.auditDetails.lastModifiedTime;
          license.type = "BPAREG";
          searchConvertedArray.push(license);
        });
      }
      if (bpaData !== null && bpaData !== void 0 && bpaData.length) {
        bpaData === null || bpaData === void 0 ? void 0 : bpaData.forEach(bpaDta => {
          bpaDta.sortNumber = 0;
          bpaDta.modifiedTime = bpaDta.auditDetails.lastModifiedTime;
          bpaDta.type = "BPA";
          searchConvertedArray.push(bpaDta);
        });
      }
      sortConvertedArray = [].slice.call(searchConvertedArray).sort(function (a, b) {
        return new Date(b.modifiedTime) - new Date(a.modifiedTime) || a.sortNumber - b.sortNumber;
      });
      setFinalData(sortConvertedArray);
      let userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
      const userInfoDetails = userInfos ? JSON.parse(userInfos) : {};
      if ((userInfoDetails === null || userInfoDetails === void 0 ? void 0 : (_userInfoDetails$valu = userInfoDetails.value) === null || _userInfoDetails$valu === void 0 ? void 0 : (_userInfoDetails$valu2 = _userInfoDetails$valu.info) === null || _userInfoDetails$valu2 === void 0 ? void 0 : (_userInfoDetails$valu3 = _userInfoDetails$valu2.roles) === null || _userInfoDetails$valu3 === void 0 ? void 0 : _userInfoDetails$valu3.length) == 1 && (userInfoDetails === null || userInfoDetails === void 0 ? void 0 : (_userInfoDetails$valu4 = userInfoDetails.value) === null || _userInfoDetails$valu4 === void 0 ? void 0 : (_userInfoDetails$valu5 = _userInfoDetails$valu4.info) === null || _userInfoDetails$valu5 === void 0 ? void 0 : (_userInfoDetails$valu6 = _userInfoDetails$valu5.roles) === null || _userInfoDetails$valu6 === void 0 ? void 0 : (_userInfoDetails$valu7 = _userInfoDetails$valu6[0]) === null || _userInfoDetails$valu7 === void 0 ? void 0 : _userInfoDetails$valu7.code) == "CITIZEN") setLableMessage(true);
    }
  }, [isLoading, isBpaSearchLoading, bpaData, data]);
  if (isLoading || isBpaSearchLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Header, null, `${t("BPA_MY_APPLICATIONS")} (${(data === null || data === void 0 ? void 0 : (_data$Licenses3 = data.Licenses) === null || _data$Licenses3 === void 0 ? void 0 : _data$Licenses3.length) + (bpaData === null || bpaData === void 0 ? void 0 : bpaData.length)})`), finalData === null || finalData === void 0 ? void 0 : finalData.map((application, index) => {
    if (application.type === "BPAREG") {
      var _application$tradeLic, _application$tradeLic2, _application$tradeLic3, _application$tradeLic4, _application$tradeLic5, _application$tradeLic6, _application$tradeLic7, _application$tradeLic8, _application$tradeLic9, _application$tradeLic10, _application$tradeLic11, _application$tradeLic12;
      return /*#__PURE__*/React__default.createElement(Card, {
        key: index
      }, /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICATION_NUMBER_LABEL"),
        note: application === null || application === void 0 ? void 0 : application.applicationNumber
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_LICENSE_TYPE"),
        note: t(`TRADELICENSE_TRADETYPE_${application === null || application === void 0 ? void 0 : (_application$tradeLic = application.tradeLicenseDetail) === null || _application$tradeLic === void 0 ? void 0 : (_application$tradeLic2 = _application$tradeLic.tradeUnits) === null || _application$tradeLic2 === void 0 ? void 0 : (_application$tradeLic3 = _application$tradeLic2[0]) === null || _application$tradeLic3 === void 0 ? void 0 : (_application$tradeLic4 = _application$tradeLic3.tradeType) === null || _application$tradeLic4 === void 0 ? void 0 : _application$tradeLic4.split('.')[0]}`)
      }), (application === null || application === void 0 ? void 0 : (_application$tradeLic5 = application.tradeLicenseDetail) === null || _application$tradeLic5 === void 0 ? void 0 : (_application$tradeLic6 = _application$tradeLic5.tradeUnits) === null || _application$tradeLic6 === void 0 ? void 0 : (_application$tradeLic7 = _application$tradeLic6[0]) === null || _application$tradeLic7 === void 0 ? void 0 : _application$tradeLic7.tradeType.includes('ARCHITECT')) && /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COUNCIL_OF_ARCH_NO_LABEL"),
        note: application === null || application === void 0 ? void 0 : (_application$tradeLic8 = application.tradeLicenseDetail) === null || _application$tradeLic8 === void 0 ? void 0 : (_application$tradeLic9 = _application$tradeLic8.additionalDetail) === null || _application$tradeLic9 === void 0 ? void 0 : _application$tradeLic9.counsilForArchNo
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICANT_NAME_LABEL"),
        note: application === null || application === void 0 ? void 0 : (_application$tradeLic10 = application.tradeLicenseDetail) === null || _application$tradeLic10 === void 0 ? void 0 : (_application$tradeLic11 = _application$tradeLic10.owners) === null || _application$tradeLic11 === void 0 ? void 0 : (_application$tradeLic12 = _application$tradeLic11[0]) === null || _application$tradeLic12 === void 0 ? void 0 : _application$tradeLic12.name
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("TL_COMMON_TABLE_COL_STATUS"),
        note: t(`WF_ARCHITECT_${application === null || application === void 0 ? void 0 : application.status}`),
        noteStyle: (application === null || application === void 0 ? void 0 : application.status) === "APPROVED" ? {
          color: "#00703C"
        } : {
          color: "#D4351C"
        }
      }), application.status !== "INITIATED" ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/stakeholder/${application === null || application === void 0 ? void 0 : application.applicationNumber}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("BPA_COMP_WORKFLOW"),
        onSubmit: () => getBPAREGFormData(application)
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(Card, {
        key: index
      }, /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICATION_NUMBER_LABEL"),
        note: application === null || application === void 0 ? void 0 : application.applicationNo
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL"),
        note: (application === null || application === void 0 ? void 0 : application.businessService) !== "BPA_OC" ? t(`WF_BPA_BUILDING_PLAN_SCRUTINY`) : t(`WF_BPA_BUILDING_OC_PLAN_SCRUTINY`)
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COMMON_SERVICE"),
        note: t(`BPA_SERVICETYPE_NEW_CONSTRUCTION`)
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("TL_COMMON_TABLE_COL_STATUS"),
        note: t(`WF_BPA_${application === null || application === void 0 ? void 0 : application.state}`),
        noteStyle: (application === null || application === void 0 ? void 0 : application.status) === "APPROVED" ? {
          color: "#00703C"
        } : {
          color: "#D4351C"
        }
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COMMON_SLA"),
        note: application === null || application === void 0 ? void 0 : application.sla
      }), application.action === "SEND_TO_ARCHITECT" || application.status !== "INITIATED" ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/bpa/${application === null || application === void 0 ? void 0 : application.applicationNo}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement("div", null, labelMessage ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/bpa/${application === null || application === void 0 ? void 0 : application.applicationNo}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("BPA_COMP_WORKFLOW"),
        onSubmit: () => getBPAFormData(application, mdmsData, history, t)
      })));
    }
  }));
};

const BPAReason = ({
  headComment,
  otherComment
}) => /*#__PURE__*/React__default.createElement("div", {
  className: "checkpoint-comments-wrap"
}, /*#__PURE__*/React__default.createElement("h4", null, headComment), /*#__PURE__*/React__default.createElement("p", null, otherComment));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var purify = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
      return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
      return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create;
    var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;
    if (!apply) {
      apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
      };
    }
    if (!freeze) {
      freeze = function freeze(x) {
        return x;
      };
    }
    if (!seal) {
      seal = function seal(x) {
        return x;
      };
    }
    if (!construct) {
      construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
      };
    }
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
      return function (thisArg) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return apply(func, thisArg, args);
      };
    }
    function unconstruct(func) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return construct(func, args);
      };
    }
    function addToSet(set, array, transformCaseFunc) {
      var _transformCaseFunc;
      transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
      if (setPrototypeOf) {
        setPrototypeOf(set, null);
      }
      var l = array.length;
      while (l--) {
        var element = array[l];
        if (typeof element === 'string') {
          var lcElement = transformCaseFunc(element);
          if (lcElement !== element) {
            if (!isFrozen(array)) {
              array[l] = lcElement;
            }
            element = lcElement;
          }
        }
        set[element] = true;
      }
      return set;
    }
    function clone(object) {
      var newObject = create(null);
      var property;
      for (property in object) {
        if (apply(hasOwnProperty, object, [property]) === true) {
          newObject[property] = object[property];
        }
      }
      return newObject;
    }
    function lookupGetter(object, prop) {
      while (object !== null) {
        var desc = getOwnPropertyDescriptor(object, prop);
        if (desc) {
          if (desc.get) {
            return unapply(desc.get);
          }
          if (typeof desc.value === 'function') {
            return unapply(desc.value);
          }
        }
        object = getPrototypeOf(object);
      }
      function fallbackValue(element) {
        console.warn('fallback value for', element);
        return null;
      }
      return fallbackValue;
    }
    var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
    var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
    var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
    var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
    var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);
    var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
    var text = freeze(['#text']);
    var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
    var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
    var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
    var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
      return typeof window === 'undefined' ? null : window;
    };
    var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
      if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
        return null;
      }
      var suffix = null;
      var ATTR_NAME = 'data-tt-policy-suffix';
      if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
        suffix = document.currentScript.getAttribute(ATTR_NAME);
      }
      var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
      try {
        return trustedTypes.createPolicy(policyName, {
          createHTML: function createHTML(html) {
            return html;
          },
          createScriptURL: function createScriptURL(scriptUrl) {
            return scriptUrl;
          }
        });
      } catch (_) {
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
      }
    };
    function createDOMPurify() {
      var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
      var DOMPurify = function DOMPurify(root) {
        return createDOMPurify(root);
      };
      DOMPurify.version = '2.5.6';
      DOMPurify.removed = [];
      if (!window || !window.document || window.document.nodeType !== 9) {
        DOMPurify.isSupported = false;
        return DOMPurify;
      }
      var originalDocument = window.document;
      var document = window.document;
      var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
      var ElementPrototype = Element.prototype;
      var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
      var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
      var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
      var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
      if (typeof HTMLTemplateElement === 'function') {
        var template = document.createElement('template');
        if (template.content && template.content.ownerDocument) {
          document = template.content.ownerDocument;
        }
      }
      var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
      var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
      var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
      var importNode = originalDocument.importNode;
      var documentMode = {};
      try {
        documentMode = clone(document).documentMode ? document.documentMode : {};
      } catch (_) {}
      var hooks = {};
      DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
      var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
        CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
      var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
      var ALLOWED_TAGS = null;
      var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
      var ALLOWED_ATTR = null;
      var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
      var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
        tagNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        attributeNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        allowCustomizedBuiltInElements: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: false
        }
      }));
      var FORBID_TAGS = null;
      var FORBID_ATTR = null;
      var ALLOW_ARIA_ATTR = true;
      var ALLOW_DATA_ATTR = true;
      var ALLOW_UNKNOWN_PROTOCOLS = false;
      var ALLOW_SELF_CLOSE_IN_ATTR = true;
      var SAFE_FOR_TEMPLATES = false;
      var SAFE_FOR_XML = true;
      var WHOLE_DOCUMENT = false;
      var SET_CONFIG = false;
      var FORCE_BODY = false;
      var RETURN_DOM = false;
      var RETURN_DOM_FRAGMENT = false;
      var RETURN_TRUSTED_TYPE = false;
      var SANITIZE_DOM = true;
      var SANITIZE_NAMED_PROPS = false;
      var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
      var KEEP_CONTENT = true;
      var IN_PLACE = false;
      var USE_PROFILES = {};
      var FORBID_CONTENTS = null;
      var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
      var DATA_URI_TAGS = null;
      var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
      var URI_SAFE_ATTRIBUTES = null;
      var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
      var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var NAMESPACE = HTML_NAMESPACE;
      var IS_EMPTY_INPUT = false;
      var ALLOWED_NAMESPACES = null;
      var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
      var PARSER_MEDIA_TYPE;
      var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
      var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
      var transformCaseFunc;
      var CONFIG = null;
      var formElement = document.createElement('form');
      var isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
      };
      var _parseConfig = function _parseConfig(cfg) {
        if (CONFIG && CONFIG === cfg) {
          return;
        }
        if (!cfg || _typeof(cfg) !== 'object') {
          cfg = {};
        }
        cfg = clone(cfg);
        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
        RETURN_DOM = cfg.RETURN_DOM || false;
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
        FORCE_BODY = cfg.FORCE_BODY || false;
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
        IN_PLACE = cfg.IN_PLACE || false;
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
          CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        }
        if (SAFE_FOR_TEMPLATES) {
          ALLOW_DATA_ATTR = false;
        }
        if (RETURN_DOM_FRAGMENT) {
          RETURN_DOM = true;
        }
        if (USE_PROFILES) {
          ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
          ALLOWED_ATTR = [];
          if (USE_PROFILES.html === true) {
            addToSet(ALLOWED_TAGS, html$1);
            addToSet(ALLOWED_ATTR, html);
          }
          if (USE_PROFILES.svg === true) {
            addToSet(ALLOWED_TAGS, svg$1);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.svgFilters === true) {
            addToSet(ALLOWED_TAGS, svgFilters);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.mathMl === true) {
            addToSet(ALLOWED_TAGS, mathMl$1);
            addToSet(ALLOWED_ATTR, mathMl);
            addToSet(ALLOWED_ATTR, xml);
          }
        }
        if (cfg.ADD_TAGS) {
          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
            ALLOWED_TAGS = clone(ALLOWED_TAGS);
          }
          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
            ALLOWED_ATTR = clone(ALLOWED_ATTR);
          }
          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) {
          addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        }
        if (cfg.FORBID_CONTENTS) {
          if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
            FORBID_CONTENTS = clone(FORBID_CONTENTS);
          }
          addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if (KEEP_CONTENT) {
          ALLOWED_TAGS['#text'] = true;
        }
        if (WHOLE_DOCUMENT) {
          addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
        }
        if (ALLOWED_TAGS.table) {
          addToSet(ALLOWED_TAGS, ['tbody']);
          delete FORBID_TAGS.tbody;
        }
        if (freeze) {
          freeze(cfg);
        }
        CONFIG = cfg;
      };
      var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
      var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'annotation-xml']);
      var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
      var ALL_SVG_TAGS = addToSet({}, svg$1);
      addToSet(ALL_SVG_TAGS, svgFilters);
      addToSet(ALL_SVG_TAGS, svgDisallowed);
      var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
      addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
      var _checkValidNamespace = function _checkValidNamespace(element) {
        var parent = getParentNode(element);
        if (!parent || !parent.tagName) {
          parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
          };
        }
        var tagName = stringToLowerCase(element.tagName);
        var parentTagName = stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
          return false;
        }
        if (element.namespaceURI === SVG_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'svg';
          }
          if (parent.namespaceURI === MATHML_NAMESPACE) {
            return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
          }
          return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'math';
          }
          if (parent.namespaceURI === SVG_NAMESPACE) {
            return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
          }
          return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
          if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
          return true;
        }
        return false;
      };
      var _forceRemove = function _forceRemove(node) {
        arrayPush(DOMPurify.removed, {
          element: node
        });
        try {
          node.parentNode.removeChild(node);
        } catch (_) {
          try {
            node.outerHTML = emptyHTML;
          } catch (_) {
            node.remove();
          }
        }
      };
      var _removeAttribute = function _removeAttribute(name, node) {
        try {
          arrayPush(DOMPurify.removed, {
            attribute: node.getAttributeNode(name),
            from: node
          });
        } catch (_) {
          arrayPush(DOMPurify.removed, {
            attribute: null,
            from: node
          });
        }
        node.removeAttribute(name);
        if (name === 'is' && !ALLOWED_ATTR[name]) {
          if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
            try {
              _forceRemove(node);
            } catch (_) {}
          } else {
            try {
              node.setAttribute(name, '');
            } catch (_) {}
          }
        }
      };
      var _initDocument = function _initDocument(dirty) {
        var doc;
        var leadingWhitespace;
        if (FORCE_BODY) {
          dirty = '<remove></remove>' + dirty;
        } else {
          var matches = stringMatch(dirty, /^[\r\n\t ]+/);
          leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
          dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        }
        var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        if (NAMESPACE === HTML_NAMESPACE) {
          try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
          } catch (_) {}
        }
        if (!doc || !doc.documentElement) {
          doc = implementation.createDocument(NAMESPACE, 'template', null);
          try {
            doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
          } catch (_) {}
        }
        var body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) {
          body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        }
        if (NAMESPACE === HTML_NAMESPACE) {
          return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        }
        return WHOLE_DOCUMENT ? doc.documentElement : body;
      };
      var _createIterator = function _createIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
      };
      var _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
      };
      var _isNode = function _isNode(object) {
        return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
      };
      var _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) {
          return;
        }
        arrayForEach(hooks[entryPoint], function (hook) {
          hook.call(DOMPurify, currentNode, data, CONFIG);
        });
      };
      var _sanitizeElements = function _sanitizeElements(currentNode) {
        var content;
        _executeHook('beforeSanitizeElements', currentNode, null);
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
          _forceRemove(currentNode);
          return true;
        }
        var tagName = transformCaseFunc(currentNode.nodeName);
        _executeHook('uponSanitizeElement', currentNode, {
          tagName: tagName,
          allowedTags: ALLOWED_TAGS
        });
        if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
          _forceRemove(currentNode);
          return true;
        }
        if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode.nodeType === 7) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
          _forceRemove(currentNode);
          return true;
        }
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
          }
          if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            var parentNode = getParentNode(currentNode) || currentNode.parentNode;
            var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
            if (childNodes && parentNode) {
              var childCount = childNodes.length;
              for (var i = childCount - 1; i >= 0; --i) {
                var childClone = cloneNode(childNodes[i], true);
                childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                parentNode.insertBefore(childClone, getNextSibling(currentNode));
              }
            }
          }
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
          content = currentNode.textContent;
          content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
          content = stringReplace(content, ERB_EXPR$1, ' ');
          content = stringReplace(content, TMPLIT_EXPR$1, ' ');
          if (currentNode.textContent !== content) {
            arrayPush(DOMPurify.removed, {
              element: currentNode.cloneNode()
            });
            currentNode.textContent = content;
          }
        }
        _executeHook('afterSanitizeElements', currentNode, null);
        return false;
      };
      var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
          return false;
        }
        if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
          if (_basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
            return false;
          }
        } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if (value) {
          return false;
        }
        return true;
      };
      var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
        return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
      };
      var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        var attr;
        var value;
        var lcName;
        var l;
        _executeHook('beforeSanitizeAttributes', currentNode, null);
        var attributes = currentNode.attributes;
        if (!attributes) {
          return;
        }
        var hookEvent = {
          attrName: '',
          attrValue: '',
          keepAttr: true,
          allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;
        while (l--) {
          attr = attributes[l];
          var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
          value = name === 'value' ? attr.value : stringTrim(attr.value);
          lcName = transformCaseFunc(name);
          hookEvent.attrName = lcName;
          hookEvent.attrValue = value;
          hookEvent.keepAttr = true;
          hookEvent.forceKeepAttr = undefined;
          _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
          value = hookEvent.attrValue;
          if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (hookEvent.forceKeepAttr) {
            continue;
          }
          _removeAttribute(name, currentNode);
          if (!hookEvent.keepAttr) {
            continue;
          }
          if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (SAFE_FOR_TEMPLATES) {
            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
            value = stringReplace(value, ERB_EXPR$1, ' ');
            value = stringReplace(value, TMPLIT_EXPR$1, ' ');
          }
          var lcTag = transformCaseFunc(currentNode.nodeName);
          if (!_isValidAttribute(lcTag, lcName, value)) {
            continue;
          }
          if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
            _removeAttribute(name, currentNode);
            value = SANITIZE_NAMED_PROPS_PREFIX + value;
          }
          if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
            if (namespaceURI) ;else {
              switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                case 'TrustedHTML':
                  {
                    value = trustedTypesPolicy.createHTML(value);
                    break;
                  }
                case 'TrustedScriptURL':
                  {
                    value = trustedTypesPolicy.createScriptURL(value);
                    break;
                  }
              }
            }
          }
          try {
            if (namespaceURI) {
              currentNode.setAttributeNS(namespaceURI, name, value);
            } else {
              currentNode.setAttribute(name, value);
            }
            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);
            } else {
              arrayPop(DOMPurify.removed);
            }
          } catch (_) {}
        }
        _executeHook('afterSanitizeAttributes', currentNode, null);
      };
      var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        var shadowNode;
        var shadowIterator = _createIterator(fragment);
        _executeHook('beforeSanitizeShadowDOM', fragment, null);
        while (shadowNode = shadowIterator.nextNode()) {
          _executeHook('uponSanitizeShadowNode', shadowNode, null);
          if (_sanitizeElements(shadowNode)) {
            continue;
          }
          if (shadowNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(shadowNode.content);
          }
          _sanitizeAttributes(shadowNode);
        }
        _executeHook('afterSanitizeShadowDOM', fragment, null);
      };
      DOMPurify.sanitize = function (dirty) {
        var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var body;
        var importedNode;
        var currentNode;
        var oldNode;
        var returnNode;
        IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) {
          dirty = '<!-->';
        }
        if (typeof dirty !== 'string' && !_isNode(dirty)) {
          if (typeof dirty.toString === 'function') {
            dirty = dirty.toString();
            if (typeof dirty !== 'string') {
              throw typeErrorCreate('dirty is not a string, aborting');
            }
          } else {
            throw typeErrorCreate('toString is not a function');
          }
        }
        if (!DOMPurify.isSupported) {
          if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
            if (typeof dirty === 'string') {
              return window.toStaticHTML(dirty);
            }
            if (_isNode(dirty)) {
              return window.toStaticHTML(dirty.outerHTML);
            }
          }
          return dirty;
        }
        if (!SET_CONFIG) {
          _parseConfig(cfg);
        }
        DOMPurify.removed = [];
        if (typeof dirty === 'string') {
          IN_PLACE = false;
        }
        if (IN_PLACE) {
          if (dirty.nodeName) {
            var tagName = transformCaseFunc(dirty.nodeName);
            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
          }
        } else if (dirty instanceof Node) {
          body = _initDocument('<!---->');
          importedNode = body.ownerDocument.importNode(dirty, true);
          if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
            body = importedNode;
          } else if (importedNode.nodeName === 'HTML') {
            body = importedNode;
          } else {
            body.appendChild(importedNode);
          }
        } else {
          if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
          }
          body = _initDocument(dirty);
          if (!body) {
            return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
          }
        }
        if (body && FORCE_BODY) {
          _forceRemove(body.firstChild);
        }
        var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
        while (currentNode = nodeIterator.nextNode()) {
          if (currentNode.nodeType === 3 && currentNode === oldNode) {
            continue;
          }
          if (_sanitizeElements(currentNode)) {
            continue;
          }
          if (currentNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(currentNode.content);
          }
          _sanitizeAttributes(currentNode);
          oldNode = currentNode;
        }
        oldNode = null;
        if (IN_PLACE) {
          return dirty;
        }
        if (RETURN_DOM) {
          if (RETURN_DOM_FRAGMENT) {
            returnNode = createDocumentFragment.call(body.ownerDocument);
            while (body.firstChild) {
              returnNode.appendChild(body.firstChild);
            }
          } else {
            returnNode = body;
          }
          if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
            returnNode = importNode.call(originalDocument, returnNode, true);
          }
          return returnNode;
        }
        var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
          serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        }
        if (SAFE_FOR_TEMPLATES) {
          serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
        }
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
      };
      DOMPurify.setConfig = function (cfg) {
        _parseConfig(cfg);
        SET_CONFIG = true;
      };
      DOMPurify.clearConfig = function () {
        CONFIG = null;
        SET_CONFIG = false;
      };
      DOMPurify.isValidAttribute = function (tag, attr, value) {
        if (!CONFIG) {
          _parseConfig({});
        }
        var lcTag = transformCaseFunc(tag);
        var lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
      };
      DOMPurify.addHook = function (entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') {
          return;
        }
        hooks[entryPoint] = hooks[entryPoint] || [];
        arrayPush(hooks[entryPoint], hookFunction);
      };
      DOMPurify.removeHook = function (entryPoint) {
        if (hooks[entryPoint]) {
          return arrayPop(hooks[entryPoint]);
        }
      };
      DOMPurify.removeHooks = function (entryPoint) {
        if (hooks[entryPoint]) {
          hooks[entryPoint] = [];
        }
      };
      DOMPurify.removeAllHooks = function () {
        hooks = {};
      };
      return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
  });
});

const SafeHtml = ({
  html,
  tag: _tag = "div",
  style: _style = {},
  className: _className = ""
}) => {
  const sanitizedHtml = purify.sanitize(html);
  const Tag = _tag;
  return /*#__PURE__*/React__default.createElement(Tag, {
    className: _className,
    style: _style,
    dangerouslySetInnerHTML: {
      __html: sanitizedHtml
    }
  });
};

const BPACaption = ({
  data,
  OpenImage
}) => {
  var _data$wfComment, _data$thumbnailsToSho, _data$thumbnailsToSho2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", null, data.date && /*#__PURE__*/React__default.createElement("p", null, data.date), /*#__PURE__*/React__default.createElement("p", null, data.name), data.mobileNumber && /*#__PURE__*/React__default.createElement(TelePhone, {
    mobile: data.mobileNumber
  }), data.source && /*#__PURE__*/React__default.createElement("p", null, t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())), data.comment && /*#__PURE__*/React__default.createElement(BPAReason, {
    otherComment: data === null || data === void 0 ? void 0 : data.otherComment,
    headComment: data === null || data === void 0 ? void 0 : data.comment
  }), data !== null && data !== void 0 && data.wfComment ? /*#__PURE__*/React__default.createElement("div", null, data === null || data === void 0 ? void 0 : (_data$wfComment = data.wfComment) === null || _data$wfComment === void 0 ? void 0 : _data$wfComment.map(e => /*#__PURE__*/React__default.createElement("div", {
    className: "TLComments"
  }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: e
  }))))) : null, (data === null || data === void 0 ? void 0 : (_data$thumbnailsToSho = data.thumbnailsToShow) === null || _data$thumbnailsToSho === void 0 ? void 0 : (_data$thumbnailsToSho2 = _data$thumbnailsToSho.thumbs) === null || _data$thumbnailsToSho2 === void 0 ? void 0 : _data$thumbnailsToSho2.length) > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "TLComments"
  }, /*#__PURE__*/React__default.createElement("h3", null, t("CS_COMMON_ATTACHMENTS")), /*#__PURE__*/React__default.createElement(DisplayPhotos, {
    srcs: data === null || data === void 0 ? void 0 : data.thumbnailsToShow.thumbs,
    onClick: (src, index) => {
      OpenImage(src, index, data === null || data === void 0 ? void 0 : data.thumbnailsToShow);
    }
  })) : null);
};

const ApplicationTimeline = ({
  id,
  tenantId
}) => {
  var _data$timeline, _data$timeline2, _data$timeline$, _data$nextActions;
  const {
    t
  } = useTranslation();
  const {
    isLoading,
    data
  } = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "OBPS"
  });
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "INITIATE") {
      var _props$application, _props$application$au, _props$application2, _props$application2$t;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate((_props$application = props.application) === null || _props$application === void 0 ? void 0 : (_props$application$au = _props$application.auditDetails) === null || _props$application$au === void 0 ? void 0 : _props$application$au.createdTime),
        source: ((_props$application2 = props.application) === null || _props$application2 === void 0 ? void 0 : (_props$application2$t = _props$application2.tradeLicenseDetail) === null || _props$application2$t === void 0 ? void 0 : _props$application2$t.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(BPACaption, {
        data: caption
      });
    } else {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment)
      };
      return /*#__PURE__*/React__default.createElement(BPACaption, {
        data: caption
      });
    }
  };
  const showNextActions = nextAction => {
    var _data$processInstance, _data$processInstance2, _data$processInstance3, _data$processInstance4, _data$processInstance5, _data$processInstance6;
    switch (nextAction === null || nextAction === void 0 ? void 0 : nextAction.action) {
      case "PAY":
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: "24px"
          }
        }, /*#__PURE__*/React__default.createElement(Link, {
          to: {
            pathname: `/digit-ui/citizen/payment/collect/${data === null || data === void 0 ? void 0 : (_data$processInstance = data.processInstances) === null || _data$processInstance === void 0 ? void 0 : (_data$processInstance2 = _data$processInstance[0]) === null || _data$processInstance2 === void 0 ? void 0 : _data$processInstance2.moduleName}/${data === null || data === void 0 ? void 0 : (_data$processInstance3 = data.processInstances) === null || _data$processInstance3 === void 0 ? void 0 : (_data$processInstance4 = _data$processInstance3[0]) === null || _data$processInstance4 === void 0 ? void 0 : _data$processInstance4.businessId}`,
            state: {
              tenantId: data === null || data === void 0 ? void 0 : (_data$processInstance5 = data.processInstances) === null || _data$processInstance5 === void 0 ? void 0 : (_data$processInstance6 = _data$processInstance5[0]) === null || _data$processInstance6 === void 0 ? void 0 : _data$processInstance6.tenantId
            }
          }
        }, /*#__PURE__*/React__default.createElement(SubmitBar, {
          label: t("TL_COMMON_BUTTON_CITIZEN_MAKE_PAYMENT")
        })));
      case "SUBMIT_FEEDBACK":
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginTop: "24px"
          }
        }, /*#__PURE__*/React__default.createElement(Link, {
          to: `/digit-ui/citizen/fsm/rate/${props.id}`
        }, /*#__PURE__*/React__default.createElement(SubmitBar, {
          label: t("CS_APPLICATION_DETAILS_RATE")
        })));
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && /*#__PURE__*/React__default.createElement(Fragment$2, null, (data === null || data === void 0 ? void 0 : (_data$timeline = data.timeline) === null || _data$timeline === void 0 ? void 0 : _data$timeline.length) > 0 && /*#__PURE__*/React__default.createElement(CardSectionHeader, {
    style: {
      marginBottom: "16px",
      marginTop: "32px"
    }
  }, t("CS_APPLICATION_DETAILS_APPLICATION_TIMELINE")), data !== null && data !== void 0 && data.timeline && (data === null || data === void 0 ? void 0 : (_data$timeline2 = data.timeline) === null || _data$timeline2 === void 0 ? void 0 : _data$timeline2.length) === 1 ? /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t((data === null || data === void 0 ? void 0 : (_data$timeline$ = data.timeline[0]) === null || _data$timeline$ === void 0 ? void 0 : _data$timeline$.state) && `WF_ARCHITECT_${data.timeline[0].state}` || "NA"),
    customChild: getTimelineCaptions(data === null || data === void 0 ? void 0 : data.timeline[0])
  }) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (data === null || data === void 0 ? void 0 : data.timeline) && (data === null || data === void 0 ? void 0 : data.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      label: checkpoint.state ? t(`WF_ARCHITECT_${checkpoint.state}`) : "NA",
      customChild: getTimelineCaptions(checkpoint)
    }));
  })))), data && showNextActions(data === null || data === void 0 ? void 0 : (_data$nextActions = data.nextActions) === null || _data$nextActions === void 0 ? void 0 : _data$nextActions[0]));
};

const ApplicationDetails = () => {
  var _LicenseData$Licenses, _License$tradeLicense7, _License$tradeLicense8, _mdmsRes$StakeholderR, _mdmsRes$StakeholderR2, _reciept_data$Payment6, _License$tradeLicense14, _License$tradeLicense15, _License$tradeLicense16, _License$tradeLicense17, _License$tradeLicense18, _License$tradeLicense19, _License$tradeLicense20, _License$tradeLicense21, _License$tradeLicense22, _License$tradeLicense23, _License$tradeLicense24, _License$tradeLicense25, _License$tradeLicense26, _License$tradeLicense27, _License$tradeLicense28, _License$tradeLicense29, _License$tradeLicense30, _License$tradeLicense31, _License$tradeLicense32, _License$tradeLicense33, _License$tradeLicense34, _License$tradeLicense35, _License$tradeLicense36, _License$tradeLicense37, _License$tradeLicense38, _License$tradeLicense39, _License$tradeLicense40, _License$tradeLicense41, _License$tradeLicense42, _License$tradeLicense43, _License$tradeLicense44, _License$tradeLicense45, _License$tradeLicense46, _License$tradeLicense47;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const [documents, setDocuments] = useState({});
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showOptions, setShowOptions] = useState(false);
  const [dowloadOptions, setDowloadOptions] = useState([]);
  const {
    id: appNumber
  } = useParams();
  const params = {
    applicationNumber: appNumber
  };
  const stateCode = Digit.ULBService.getStateId();
  const {
    data: LicenseData,
    isLoading
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId, {}, params);
  let License = LicenseData === null || LicenseData === void 0 ? void 0 : (_LicenseData$Licenses = LicenseData.Licenses) === null || _LicenseData$Licenses === void 0 ? void 0 : _LicenseData$Licenses[0];
  const {
    data: mdmsRes,
    isLoading: mdmsResIsLoading
  } = Digit.Hooks.obps.useMDMS(stateCode, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  const {
    data: reciept_data,
    isLoading: recieptDataLoading
  } = Digit.Hooks.useRecieptSearch({
    tenantId: stateCode,
    businessService: "BPAREG",
    consumerCodes: id,
    isEmployee: false
  }, {});
  useEffect(() => {
    var _License$tradeLicense, _License$tradeLicense2;
    if (License !== null && License !== void 0 && (_License$tradeLicense = License.tradeLicenseDetail) !== null && _License$tradeLicense !== void 0 && (_License$tradeLicense2 = _License$tradeLicense.applicationDocuments) !== null && _License$tradeLicense2 !== void 0 && _License$tradeLicense2.length) {
      var _License$tradeLicense3, _License$tradeLicense4;
      const fileStoresIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense3 = License.tradeLicenseDetail) === null || _License$tradeLicense3 === void 0 ? void 0 : (_License$tradeLicense4 = _License$tradeLicense3.applicationDocuments) === null || _License$tradeLicense4 === void 0 ? void 0 : _License$tradeLicense4.map(document => document === null || document === void 0 ? void 0 : document.fileStoreId);
      Digit.UploadServices.Filefetch(fileStoresIds, tenantId.split(".")[0]).then(res => setDocuments(res === null || res === void 0 ? void 0 : res.data));
    }
  }, [License]);
  useEffect(() => {
    if (License) {
      var _reciept_data$Payment, _License$tradeLicense5, _License$tradeLicense6;
      if ((reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment = reciept_data.Payments) === null || _reciept_data$Payment === void 0 ? void 0 : _reciept_data$Payment.length) > 0) {
        setDowloadOptions([{
          label: t("TL_RECEIPT"),
          onClick: () => {
            var _reciept_data$Payment2, _reciept_data$Payment3, _reciept_data$Payment4, _reciept_data$Payment5;
            return downloadAndPrintReciept((reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment2 = reciept_data.Payments) === null || _reciept_data$Payment2 === void 0 ? void 0 : (_reciept_data$Payment3 = _reciept_data$Payment2[0]) === null || _reciept_data$Payment3 === void 0 ? void 0 : (_reciept_data$Payment4 = _reciept_data$Payment3.paymentDetails) === null || _reciept_data$Payment4 === void 0 ? void 0 : (_reciept_data$Payment5 = _reciept_data$Payment4[0]) === null || _reciept_data$Payment5 === void 0 ? void 0 : _reciept_data$Payment5.businessService) || "BPAREG", License === null || License === void 0 ? void 0 : License.applicationNumber, License === null || License === void 0 ? void 0 : License.tenantId);
          }
        }]);
      }
      const fileStoresIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense5 = License.tradeLicenseDetail) === null || _License$tradeLicense5 === void 0 ? void 0 : (_License$tradeLicense6 = _License$tradeLicense5.applicationDocuments) === null || _License$tradeLicense6 === void 0 ? void 0 : _License$tradeLicense6.map(document => document === null || document === void 0 ? void 0 : document.fileStoreId);
    }
  }, [License, reciept_data]);
  if (License !== null && License !== void 0 && (_License$tradeLicense7 = License.tradeLicenseDetail) !== null && _License$tradeLicense7 !== void 0 && (_License$tradeLicense8 = _License$tradeLicense7.applicationDocuments) !== null && _License$tradeLicense8 !== void 0 && _License$tradeLicense8.length && (mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR === void 0 ? void 0 : (_mdmsRes$StakeholderR2 = _mdmsRes$StakeholderR.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR2 === void 0 ? void 0 : _mdmsRes$StakeholderR2.length) > 0) {
    var _mdmsRes$StakeholderR3, _mdmsRes$StakeholderR4;
    mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR3 = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR3 === void 0 ? void 0 : (_mdmsRes$StakeholderR4 = _mdmsRes$StakeholderR3.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR4 === void 0 ? void 0 : _mdmsRes$StakeholderR4.map(doc => {
      var _doc$docTypes, _License$tradeLicense9, _License$tradeLicense10, _License$tradeLicense11;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$docTypes = doc.docTypes) === null || _doc$docTypes === void 0 ? void 0 : _doc$docTypes.length) > 0 && (doc === null || doc === void 0 ? void 0 : doc.tradeType) == (License === null || License === void 0 ? void 0 : (_License$tradeLicense9 = License.tradeLicenseDetail) === null || _License$tradeLicense9 === void 0 ? void 0 : (_License$tradeLicense10 = _License$tradeLicense9.tradeUnits) === null || _License$tradeLicense10 === void 0 ? void 0 : (_License$tradeLicense11 = _License$tradeLicense10[0]) === null || _License$tradeLicense11 === void 0 ? void 0 : _License$tradeLicense11.tradeType)) {
        var _doc$docTypes2;
        doc === null || doc === void 0 ? void 0 : (_doc$docTypes2 = doc.docTypes) === null || _doc$docTypes2 === void 0 ? void 0 : _doc$docTypes2.map(docType => {
          var _License$tradeLicense12, _License$tradeLicense13;
          License === null || License === void 0 ? void 0 : (_License$tradeLicense12 = License.tradeLicenseDetail) === null || _License$tradeLicense12 === void 0 ? void 0 : (_License$tradeLicense13 = _License$tradeLicense12.applicationDocuments) === null || _License$tradeLicense13 === void 0 ? void 0 : _License$tradeLicense13.forEach(document => {
            if ((docType === null || docType === void 0 ? void 0 : docType.code) == (document === null || document === void 0 ? void 0 : document.documentType) && docType !== null && docType !== void 0 && docType.info) document.info = docType === null || docType === void 0 ? void 0 : docType.info;
          });
        });
      }
    });
  }
  if (isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: "cardHeaderWithOptions",
    style: {
      marginRight: "auto",
      maxWidth: "960px"
    }
  }, /*#__PURE__*/React__default.createElement(Header, {
    styles: {
      fontSize: "32px"
    }
  }, t("BPA_TASK_DETAILS_HEADER")), (reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment6 = reciept_data.Payments) === null || _reciept_data$Payment6 === void 0 ? void 0 : _reciept_data$Payment6.length) > 0 &&
  /*#__PURE__*/
  React__default.createElement(MultiLink, {
    className: "multilinkWrapper",
    onHeadClick: () => setShowOptions(!showOptions),
    displayOptions: showOptions,
    options: dowloadOptions,
    style: {
      top: "90px"
    }
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: (License === null || License === void 0 ? void 0 : License.applicationNumber) || "NA"
  }))), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSE_DETAILS_LABEL`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LICENSE_TYPE`),
    text: t(`TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense14 = License.tradeLicenseDetail) === null || _License$tradeLicense14 === void 0 ? void 0 : (_License$tradeLicense15 = _License$tradeLicense14.tradeUnits) === null || _License$tradeLicense15 === void 0 ? void 0 : (_License$tradeLicense16 = _License$tradeLicense15[0]) === null || _License$tradeLicense16 === void 0 ? void 0 : (_License$tradeLicense17 = _License$tradeLicense16.tradeType) === null || _License$tradeLicense17 === void 0 ? void 0 : _License$tradeLicense17.split('.')[0]}`)
  }), (License === null || License === void 0 ? void 0 : (_License$tradeLicense18 = License.tradeLicenseDetail) === null || _License$tradeLicense18 === void 0 ? void 0 : (_License$tradeLicense19 = _License$tradeLicense18.tradeUnits) === null || _License$tradeLicense19 === void 0 ? void 0 : (_License$tradeLicense20 = _License$tradeLicense19[0]) === null || _License$tradeLicense20 === void 0 ? void 0 : _License$tradeLicense20.tradeType.includes('ARCHITECT')) && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_COUNCIL_OF_ARCH_NO_LABEL"),
    text: License === null || License === void 0 ? void 0 : (_License$tradeLicense21 = License.tradeLicenseDetail) === null || _License$tradeLicense21 === void 0 ? void 0 : (_License$tradeLicense22 = _License$tradeLicense21.additionalDetail) === null || _License$tradeLicense22 === void 0 ? void 0 : _License$tradeLicense22.counsilForArchNo
  }))), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSE_DET_CAPTION`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_NAME_LABEL`),
    text: t(License === null || License === void 0 ? void 0 : (_License$tradeLicense23 = License.tradeLicenseDetail) === null || _License$tradeLicense23 === void 0 ? void 0 : (_License$tradeLicense24 = _License$tradeLicense23.owners) === null || _License$tradeLicense24 === void 0 ? void 0 : (_License$tradeLicense25 = _License$tradeLicense24[0]) === null || _License$tradeLicense25 === void 0 ? void 0 : _License$tradeLicense25.name)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_GENDER_LABEL`),
    text: t(License === null || License === void 0 ? void 0 : (_License$tradeLicense26 = License.tradeLicenseDetail) === null || _License$tradeLicense26 === void 0 ? void 0 : (_License$tradeLicense27 = _License$tradeLicense26.owners) === null || _License$tradeLicense27 === void 0 ? void 0 : (_License$tradeLicense28 = _License$tradeLicense27[0]) === null || _License$tradeLicense28 === void 0 ? void 0 : _License$tradeLicense28.gender)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_OWNER_MOBILE_NO_LABEL`),
    text: License === null || License === void 0 ? void 0 : (_License$tradeLicense29 = License.tradeLicenseDetail) === null || _License$tradeLicense29 === void 0 ? void 0 : (_License$tradeLicense30 = _License$tradeLicense29.owners) === null || _License$tradeLicense30 === void 0 ? void 0 : (_License$tradeLicense31 = _License$tradeLicense30[0]) === null || _License$tradeLicense31 === void 0 ? void 0 : _License$tradeLicense31.mobileNumber
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_EMAIL_LABEL`),
    text: (License === null || License === void 0 ? void 0 : (_License$tradeLicense32 = License.tradeLicenseDetail) === null || _License$tradeLicense32 === void 0 ? void 0 : (_License$tradeLicense33 = _License$tradeLicense32.owners) === null || _License$tradeLicense33 === void 0 ? void 0 : (_License$tradeLicense34 = _License$tradeLicense33[0]) === null || _License$tradeLicense34 === void 0 ? void 0 : _License$tradeLicense34.emailId) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_PAN_NO`),
    text: (License === null || License === void 0 ? void 0 : (_License$tradeLicense35 = License.tradeLicenseDetail) === null || _License$tradeLicense35 === void 0 ? void 0 : (_License$tradeLicense36 = _License$tradeLicense35.owners) === null || _License$tradeLicense36 === void 0 ? void 0 : (_License$tradeLicense37 = _License$tradeLicense36[0]) === null || _License$tradeLicense37 === void 0 ? void 0 : _License$tradeLicense37.pan) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSEE_PERMANENT_LABEL`)), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    text: (License === null || License === void 0 ? void 0 : (_License$tradeLicense38 = License.tradeLicenseDetail) === null || _License$tradeLicense38 === void 0 ? void 0 : (_License$tradeLicense39 = _License$tradeLicense38.owners) === null || _License$tradeLicense39 === void 0 ? void 0 : (_License$tradeLicense40 = _License$tradeLicense39[0]) === null || _License$tradeLicense40 === void 0 ? void 0 : _License$tradeLicense40.permanentAddress) || t("CS_NA")
  })), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_CORRESPONDANCE_ADDRESS_LABEL`)), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    text: (License === null || License === void 0 ? void 0 : (_License$tradeLicense41 = License.tradeLicenseDetail) === null || _License$tradeLicense41 === void 0 ? void 0 : (_License$tradeLicense42 = _License$tradeLicense41.owners) === null || _License$tradeLicense42 === void 0 ? void 0 : (_License$tradeLicense43 = _License$tradeLicense42[0]) === null || _License$tradeLicense43 === void 0 ? void 0 : _License$tradeLicense43.correspondenceAddress) || t("CS_NA")
  })), (License === null || License === void 0 ? void 0 : (_License$tradeLicense44 = License.tradeLicenseDetail) === null || _License$tradeLicense44 === void 0 ? void 0 : (_License$tradeLicense45 = _License$tradeLicense44.applicationDocuments) === null || _License$tradeLicense45 === void 0 ? void 0 : _License$tradeLicense45.length) > 0 && /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t("BPA_DOC_DETAILS_SUMMARY")), License === null || License === void 0 ? void 0 : (_License$tradeLicense46 = License.tradeLicenseDetail) === null || _License$tradeLicense46 === void 0 ? void 0 : (_License$tradeLicense47 = _License$tradeLicense46.applicationDocuments) === null || _License$tradeLicense47 === void 0 ? void 0 : _License$tradeLicense47.map((document, index) => {
    var _document$documentTyp, _documents$document$f, _document$documentTyp2, _License$tradeLicense48, _License$tradeLicense49;
    return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      styles: {
        fontSize: "18px"
      }
    }, t(`BPAREG_HEADER_${stringReplaceAll(document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.toUpperCase(), ".", "_")}`)), document !== null && document !== void 0 && document.info ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "12px",
        color: "#505A5F",
        fontWeight: 400,
        lineHeight: "15px",
        margin: "10px 0px"
      }
    }, `${t(document === null || document === void 0 ? void 0 : document.info)}`) : null, /*#__PURE__*/React__default.createElement("a", {
      target: "_blank",
      href: (_documents$document$f = documents[document.fileStoreId]) === null || _documents$document$f === void 0 ? void 0 : _documents$document$f.split(",")[0]
    }, /*#__PURE__*/React__default.createElement(PDFSvg, null)), /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "8px",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F",
        fontWeight: "400"
      }
    }, t(`BPAREG_HEADER_${stringReplaceAll(document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.toUpperCase(), ".", "_")}`))), (License === null || License === void 0 ? void 0 : (_License$tradeLicense48 = License.tradeLicenseDetail) === null || _License$tradeLicense48 === void 0 ? void 0 : (_License$tradeLicense49 = _License$tradeLicense48.applicationDocuments) === null || _License$tradeLicense49 === void 0 ? void 0 : _License$tradeLicense49.length) != index + 1 ? /*#__PURE__*/React__default.createElement("hr", {
      style: {
        color: "#cccccc",
        backgroundColor: "#cccccc",
        height: "2px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }) : null);
  })), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(ApplicationTimeline, {
    id: id,
    tenantId: License === null || License === void 0 ? void 0 : License.tenantId
  }))));
};

const Form12Applications = () => {
  var _userInfo$info, _data$Licenses3;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [finalData, setFinalData] = useState([]);
  const [labelMessage, setLableMessage] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = Digit.UserService.getUser();
  const requestor = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.mobileNumber;
  const {
    data,
    isLoading,
    revalidate
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading,
    revalidate: bpaRevalidate
  } = Digit.Hooks.obps.useBPASearch(tenantId, {
    requestor,
    limit: -1,
    offset: 0
  });
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(Digit.ULBService.getStateId(), "BPA", ["RiskTypeComputation"]);
  const getBPAREGFormData = data => {
    var _license$tradeLicense, _license$tradeLicense2, _license$tradeLicense3, _license$tradeLicense4, _license$tradeLicense5, _license$tradeLicense6, _license$tradeLicense7, _license$tradeLicense8, _license$tradeLicense9, _license$tradeLicense10, _license$tradeLicense11, _license$tradeLicense12, _license$tradeLicense13, _license$tradeLicense14, _license$tradeLicense15, _license$tradeLicense16, _license$tradeLicense17, _license$tradeLicense18, _license$tradeLicense19, _license$tradeLicense20, _license$tradeLicense21, _license$tradeLicense22, _license$tradeLicense23, _license$tradeLicense24, _license$tradeLicense25, _license$tradeLicense26, _license$tradeLicense27, _license$tradeLicense28, _license$tradeLicense29, _license$tradeLicense30, _license$tradeLicense31, _license$tradeLicense32, _license$tradeLicense33, _license$tradeLicense34, _license$tradeLicense35, _license$tradeLicense36, _license$tradeLicense37, _license$tradeLicense38, _license$tradeLicense39, _license$tradeLicense40, _license$tradeLicense41, _license$tradeLicense42, _license$tradeLicense43, _license$tradeLicense44, _license$tradeLicense45, _license$tradeLicense46, _license$tradeLicense47, _license$tradeLicense48, _license$tradeLicense49, _license$tradeLicense50, _license$tradeLicense51, _license$tradeLicense52, _license$tradeLicense53, _license$tradeLicense54, _license$tradeLicense55, _license$tradeLicense56, _license$tradeLicense57, _license$tradeLicense58, _license$tradeLicense59, _license$tradeLicense60, _license$tradeLicense61, _license$tradeLicense62, _license$tradeLicense63, _license$tradeLicense64, _license$tradeLicense65, _license$tradeLicense66;
    let license = data;
    let intermediateData = {
      "Correspondenceaddress": (license === null || license === void 0 ? void 0 : (_license$tradeLicense = license.tradeLicenseDetail) === null || _license$tradeLicense === void 0 ? void 0 : (_license$tradeLicense2 = _license$tradeLicense.owners) === null || _license$tradeLicense2 === void 0 ? void 0 : (_license$tradeLicense3 = _license$tradeLicense2[0]) === null || _license$tradeLicense3 === void 0 ? void 0 : _license$tradeLicense3.correspondenceAddress) || `${license !== null && license !== void 0 && (_license$tradeLicense4 = license.tradeLicenseDetail) !== null && _license$tradeLicense4 !== void 0 && (_license$tradeLicense5 = _license$tradeLicense4.address) !== null && _license$tradeLicense5 !== void 0 && _license$tradeLicense5.doorNo ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense6 = license.tradeLicenseDetail) === null || _license$tradeLicense6 === void 0 ? void 0 : (_license$tradeLicense7 = _license$tradeLicense6.address) === null || _license$tradeLicense7 === void 0 ? void 0 : _license$tradeLicense7.doorNo}, ` : ""} ${license !== null && license !== void 0 && (_license$tradeLicense8 = license.tradeLicenseDetail) !== null && _license$tradeLicense8 !== void 0 && (_license$tradeLicense9 = _license$tradeLicense8.address) !== null && _license$tradeLicense9 !== void 0 && _license$tradeLicense9.street ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense10 = license.tradeLicenseDetail) === null || _license$tradeLicense10 === void 0 ? void 0 : (_license$tradeLicense11 = _license$tradeLicense10.address) === null || _license$tradeLicense11 === void 0 ? void 0 : _license$tradeLicense11.street}, ` : ""}${license !== null && license !== void 0 && (_license$tradeLicense12 = license.tradeLicenseDetail) !== null && _license$tradeLicense12 !== void 0 && (_license$tradeLicense13 = _license$tradeLicense12.address) !== null && _license$tradeLicense13 !== void 0 && _license$tradeLicense13.landmark ? `${license === null || license === void 0 ? void 0 : (_license$tradeLicense14 = license.tradeLicenseDetail) === null || _license$tradeLicense14 === void 0 ? void 0 : (_license$tradeLicense15 = _license$tradeLicense14.address) === null || _license$tradeLicense15 === void 0 ? void 0 : _license$tradeLicense15.landmark}, ` : ""}${t(license === null || license === void 0 ? void 0 : (_license$tradeLicense16 = license.tradeLicenseDetail) === null || _license$tradeLicense16 === void 0 ? void 0 : (_license$tradeLicense17 = _license$tradeLicense16.address) === null || _license$tradeLicense17 === void 0 ? void 0 : _license$tradeLicense17.locality.code)}, ${t(license !== null && license !== void 0 && (_license$tradeLicense18 = license.tradeLicenseDetail) !== null && _license$tradeLicense18 !== void 0 && (_license$tradeLicense19 = _license$tradeLicense18.address) !== null && _license$tradeLicense19 !== void 0 && _license$tradeLicense19.city ? license === null || license === void 0 ? void 0 : (_license$tradeLicense20 = license.tradeLicenseDetail) === null || _license$tradeLicense20 === void 0 ? void 0 : (_license$tradeLicense21 = _license$tradeLicense20.address) === null || _license$tradeLicense21 === void 0 ? void 0 : _license$tradeLicense21.city.code : "")},${t(license === null || license === void 0 ? void 0 : (_license$tradeLicense22 = license.tradeLicenseDetail) === null || _license$tradeLicense22 === void 0 ? void 0 : (_license$tradeLicense23 = _license$tradeLicense22.address) === null || _license$tradeLicense23 === void 0 ? void 0 : _license$tradeLicense23.pincode) ? `${(_license$tradeLicense24 = license.tradeLicenseDetail) === null || _license$tradeLicense24 === void 0 ? void 0 : (_license$tradeLicense25 = _license$tradeLicense24.address) === null || _license$tradeLicense25 === void 0 ? void 0 : _license$tradeLicense25.pincode}` : " "}`,
      "formData": {
        "LicneseDetails": {
          "PanNumber": license === null || license === void 0 ? void 0 : (_license$tradeLicense26 = license.tradeLicenseDetail) === null || _license$tradeLicense26 === void 0 ? void 0 : (_license$tradeLicense27 = _license$tradeLicense26.owners) === null || _license$tradeLicense27 === void 0 ? void 0 : (_license$tradeLicense28 = _license$tradeLicense27[0]) === null || _license$tradeLicense28 === void 0 ? void 0 : _license$tradeLicense28.pan,
          "PermanentAddress": license === null || license === void 0 ? void 0 : (_license$tradeLicense29 = license.tradeLicenseDetail) === null || _license$tradeLicense29 === void 0 ? void 0 : (_license$tradeLicense30 = _license$tradeLicense29.owners) === null || _license$tradeLicense30 === void 0 ? void 0 : (_license$tradeLicense31 = _license$tradeLicense30[0]) === null || _license$tradeLicense31 === void 0 ? void 0 : _license$tradeLicense31.permanentAddress,
          "email": license === null || license === void 0 ? void 0 : (_license$tradeLicense32 = license.tradeLicenseDetail) === null || _license$tradeLicense32 === void 0 ? void 0 : (_license$tradeLicense33 = _license$tradeLicense32.owners) === null || _license$tradeLicense33 === void 0 ? void 0 : (_license$tradeLicense34 = _license$tradeLicense33[0]) === null || _license$tradeLicense34 === void 0 ? void 0 : _license$tradeLicense34.emailId,
          "gender": {
            code: license === null || license === void 0 ? void 0 : (_license$tradeLicense35 = license.tradeLicenseDetail) === null || _license$tradeLicense35 === void 0 ? void 0 : (_license$tradeLicense36 = _license$tradeLicense35.owners) === null || _license$tradeLicense36 === void 0 ? void 0 : (_license$tradeLicense37 = _license$tradeLicense36[0]) === null || _license$tradeLicense37 === void 0 ? void 0 : _license$tradeLicense37.gender,
            i18nKey: `COMMON_GENDER_${license === null || license === void 0 ? void 0 : (_license$tradeLicense38 = license.tradeLicenseDetail) === null || _license$tradeLicense38 === void 0 ? void 0 : (_license$tradeLicense39 = _license$tradeLicense38.owners) === null || _license$tradeLicense39 === void 0 ? void 0 : (_license$tradeLicense40 = _license$tradeLicense39[0]) === null || _license$tradeLicense40 === void 0 ? void 0 : _license$tradeLicense40.gender}`,
            value: license === null || license === void 0 ? void 0 : (_license$tradeLicense41 = license.tradeLicenseDetail) === null || _license$tradeLicense41 === void 0 ? void 0 : (_license$tradeLicense42 = _license$tradeLicense41.owners) === null || _license$tradeLicense42 === void 0 ? void 0 : (_license$tradeLicense43 = _license$tradeLicense42[0]) === null || _license$tradeLicense43 === void 0 ? void 0 : _license$tradeLicense43.gender
          },
          "mobileNumber": license === null || license === void 0 ? void 0 : (_license$tradeLicense44 = license.tradeLicenseDetail) === null || _license$tradeLicense44 === void 0 ? void 0 : (_license$tradeLicense45 = _license$tradeLicense44.owners) === null || _license$tradeLicense45 === void 0 ? void 0 : (_license$tradeLicense46 = _license$tradeLicense45[0]) === null || _license$tradeLicense46 === void 0 ? void 0 : _license$tradeLicense46.mobileNumber,
          "name": license === null || license === void 0 ? void 0 : (_license$tradeLicense47 = license.tradeLicenseDetail) === null || _license$tradeLicense47 === void 0 ? void 0 : (_license$tradeLicense48 = _license$tradeLicense47.owners) === null || _license$tradeLicense48 === void 0 ? void 0 : (_license$tradeLicense49 = _license$tradeLicense48[0]) === null || _license$tradeLicense49 === void 0 ? void 0 : _license$tradeLicense49.name
        },
        "LicneseType": {
          LicenseType: {
            i18nKey: `TRADELICENSE_TRADETYPE_${license === null || license === void 0 ? void 0 : (_license$tradeLicense50 = license.tradeLicenseDetail) === null || _license$tradeLicense50 === void 0 ? void 0 : (_license$tradeLicense51 = _license$tradeLicense50.tradeUnits) === null || _license$tradeLicense51 === void 0 ? void 0 : (_license$tradeLicense52 = _license$tradeLicense51[0]) === null || _license$tradeLicense52 === void 0 ? void 0 : _license$tradeLicense52.tradeType.split(".")[0]}`,
            role: [`BPA_${license === null || license === void 0 ? void 0 : (_license$tradeLicense53 = license.tradeLicenseDetail) === null || _license$tradeLicense53 === void 0 ? void 0 : (_license$tradeLicense54 = _license$tradeLicense53.tradeUnits) === null || _license$tradeLicense54 === void 0 ? void 0 : (_license$tradeLicense55 = _license$tradeLicense54[0]) === null || _license$tradeLicense55 === void 0 ? void 0 : _license$tradeLicense55.tradeType.split(".")[0]}`],
            tradeType: license === null || license === void 0 ? void 0 : (_license$tradeLicense56 = license.tradeLicenseDetail) === null || _license$tradeLicense56 === void 0 ? void 0 : (_license$tradeLicense57 = _license$tradeLicense56.tradeUnits) === null || _license$tradeLicense57 === void 0 ? void 0 : (_license$tradeLicense58 = _license$tradeLicense57[0]) === null || _license$tradeLicense58 === void 0 ? void 0 : _license$tradeLicense58.tradeType
          },
          ArchitectNo: (license === null || license === void 0 ? void 0 : (_license$tradeLicense59 = license.tradeLicenseDetail) === null || _license$tradeLicense59 === void 0 ? void 0 : (_license$tradeLicense60 = _license$tradeLicense59.additionalDetail) === null || _license$tradeLicense60 === void 0 ? void 0 : _license$tradeLicense60.counsilForArchNo) || null
        }
      },
      "isAddressSame": (license === null || license === void 0 ? void 0 : (_license$tradeLicense61 = license.tradeLicenseDetail) === null || _license$tradeLicense61 === void 0 ? void 0 : (_license$tradeLicense62 = _license$tradeLicense61.owners) === null || _license$tradeLicense62 === void 0 ? void 0 : (_license$tradeLicense63 = _license$tradeLicense62[0]) === null || _license$tradeLicense63 === void 0 ? void 0 : _license$tradeLicense63.correspondenceAddress) === (license === null || license === void 0 ? void 0 : (_license$tradeLicense64 = license.tradeLicenseDetail) === null || _license$tradeLicense64 === void 0 ? void 0 : (_license$tradeLicense65 = _license$tradeLicense64.owners) === null || _license$tradeLicense65 === void 0 ? void 0 : (_license$tradeLicense66 = _license$tradeLicense65[0]) === null || _license$tradeLicense66 === void 0 ? void 0 : _license$tradeLicense66.permanentAddress) ? true : false,
      "result": {
        Licenses: [{
          ...data
        }]
      },
      "initiationFlow": true
    };
    sessionStorage.setItem("BPAREGintermediateValue", JSON.stringify(intermediateData));
    history.push("/digit-ui/citizen/obps/stakeholder/apply/stakeholder-docs-required");
  };
  useEffect(() => {
    return () => {
      setFinalData([]);
      revalidate === null || revalidate === void 0 ? void 0 : revalidate();
      bpaRevalidate === null || bpaRevalidate === void 0 ? void 0 : bpaRevalidate();
    };
  }, []);
  useEffect(() => {
    if (!isLoading && !isBpaSearchLoading) {
      var _data$Licenses, _userInfoDetails$valu, _userInfoDetails$valu2, _userInfoDetails$valu3, _userInfoDetails$valu4, _userInfoDetails$valu5, _userInfoDetails$valu6, _userInfoDetails$valu7;
      let searchConvertedArray = [];
      let sortConvertedArray = [];
      if (data !== null && data !== void 0 && (_data$Licenses = data.Licenses) !== null && _data$Licenses !== void 0 && _data$Licenses.length) {
        var _data$Licenses2;
        data === null || data === void 0 ? void 0 : (_data$Licenses2 = data.Licenses) === null || _data$Licenses2 === void 0 ? void 0 : _data$Licenses2.forEach(license => {
          license.sortNumber = 0;
          license.modifiedTime = license.auditDetails.lastModifiedTime;
          license.type = "BPAREG";
          searchConvertedArray.push(license);
        });
      }
      if (bpaData !== null && bpaData !== void 0 && bpaData.length) {
        bpaData === null || bpaData === void 0 ? void 0 : bpaData.forEach(bpaDta => {
          bpaDta.sortNumber = 0;
          bpaDta.modifiedTime = bpaDta.auditDetails.lastModifiedTime;
          bpaDta.type = "BPA";
          searchConvertedArray.push(bpaDta);
        });
      }
      sortConvertedArray = [].slice.call(searchConvertedArray).sort(function (a, b) {
        return new Date(b.modifiedTime) - new Date(a.modifiedTime) || a.sortNumber - b.sortNumber;
      });
      setFinalData(sortConvertedArray);
      let userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
      const userInfoDetails = userInfos ? JSON.parse(userInfos) : {};
      if ((userInfoDetails === null || userInfoDetails === void 0 ? void 0 : (_userInfoDetails$valu = userInfoDetails.value) === null || _userInfoDetails$valu === void 0 ? void 0 : (_userInfoDetails$valu2 = _userInfoDetails$valu.info) === null || _userInfoDetails$valu2 === void 0 ? void 0 : (_userInfoDetails$valu3 = _userInfoDetails$valu2.roles) === null || _userInfoDetails$valu3 === void 0 ? void 0 : _userInfoDetails$valu3.length) == 1 && (userInfoDetails === null || userInfoDetails === void 0 ? void 0 : (_userInfoDetails$valu4 = userInfoDetails.value) === null || _userInfoDetails$valu4 === void 0 ? void 0 : (_userInfoDetails$valu5 = _userInfoDetails$valu4.info) === null || _userInfoDetails$valu5 === void 0 ? void 0 : (_userInfoDetails$valu6 = _userInfoDetails$valu5.roles) === null || _userInfoDetails$valu6 === void 0 ? void 0 : (_userInfoDetails$valu7 = _userInfoDetails$valu6[0]) === null || _userInfoDetails$valu7 === void 0 ? void 0 : _userInfoDetails$valu7.code) == "CITIZEN") setLableMessage(true);
    }
  }, [isLoading, isBpaSearchLoading, bpaData, data]);
  if (isLoading || isBpaSearchLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Header, null, `${t("BPA_MY_APPLICATIONS")} (${(data === null || data === void 0 ? void 0 : (_data$Licenses3 = data.Licenses) === null || _data$Licenses3 === void 0 ? void 0 : _data$Licenses3.length) + (bpaData === null || bpaData === void 0 ? void 0 : bpaData.length)})`), finalData === null || finalData === void 0 ? void 0 : finalData.map((application, index) => {
    if (application.type === "BPAREG") {
      var _application$tradeLic, _application$tradeLic2, _application$tradeLic3, _application$tradeLic4, _application$tradeLic5, _application$tradeLic6, _application$tradeLic7, _application$tradeLic8, _application$tradeLic9, _application$tradeLic10, _application$tradeLic11, _application$tradeLic12;
      return /*#__PURE__*/React__default.createElement(Card, {
        key: index
      }, /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICATION_NUMBER_LABEL"),
        note: application === null || application === void 0 ? void 0 : application.applicationNumber
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_LICENSE_TYPE"),
        note: t(`TRADELICENSE_TRADETYPE_${application === null || application === void 0 ? void 0 : (_application$tradeLic = application.tradeLicenseDetail) === null || _application$tradeLic === void 0 ? void 0 : (_application$tradeLic2 = _application$tradeLic.tradeUnits) === null || _application$tradeLic2 === void 0 ? void 0 : (_application$tradeLic3 = _application$tradeLic2[0]) === null || _application$tradeLic3 === void 0 ? void 0 : (_application$tradeLic4 = _application$tradeLic3.tradeType) === null || _application$tradeLic4 === void 0 ? void 0 : _application$tradeLic4.split('.')[0]}`)
      }), (application === null || application === void 0 ? void 0 : (_application$tradeLic5 = application.tradeLicenseDetail) === null || _application$tradeLic5 === void 0 ? void 0 : (_application$tradeLic6 = _application$tradeLic5.tradeUnits) === null || _application$tradeLic6 === void 0 ? void 0 : (_application$tradeLic7 = _application$tradeLic6[0]) === null || _application$tradeLic7 === void 0 ? void 0 : _application$tradeLic7.tradeType.includes('ARCHITECT')) && /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COUNCIL_OF_ARCH_NO_LABEL"),
        note: application === null || application === void 0 ? void 0 : (_application$tradeLic8 = application.tradeLicenseDetail) === null || _application$tradeLic8 === void 0 ? void 0 : (_application$tradeLic9 = _application$tradeLic8.additionalDetail) === null || _application$tradeLic9 === void 0 ? void 0 : _application$tradeLic9.counsilForArchNo
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICANT_NAME_LABEL"),
        note: application === null || application === void 0 ? void 0 : (_application$tradeLic10 = application.tradeLicenseDetail) === null || _application$tradeLic10 === void 0 ? void 0 : (_application$tradeLic11 = _application$tradeLic10.owners) === null || _application$tradeLic11 === void 0 ? void 0 : (_application$tradeLic12 = _application$tradeLic11[0]) === null || _application$tradeLic12 === void 0 ? void 0 : _application$tradeLic12.name
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("TL_COMMON_TABLE_COL_STATUS"),
        note: t(`WF_ARCHITECT_${application === null || application === void 0 ? void 0 : application.status}`),
        noteStyle: (application === null || application === void 0 ? void 0 : application.status) === "APPROVED" ? {
          color: "#00703C"
        } : {
          color: "#D4351C"
        }
      }), application.status !== "INITIATED" ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/stakeholder/${application === null || application === void 0 ? void 0 : application.applicationNumber}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("BPA_COMP_WORKFLOW"),
        onSubmit: () => getBPAREGFormData(application)
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(Card, {
        key: index
      }, /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_APPLICATION_NUMBER_LABEL"),
        note: application === null || application === void 0 ? void 0 : application.applicationNo
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL"),
        note: (application === null || application === void 0 ? void 0 : application.businessService) !== "BPA_OC" ? t(`WF_BPA_BUILDING_PLAN_SCRUTINY`) : t(`WF_BPA_BUILDING_OC_PLAN_SCRUTINY`)
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COMMON_SERVICE"),
        note: t(`BPA_SERVICETYPE_NEW_CONSTRUCTION`)
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("TL_COMMON_TABLE_COL_STATUS"),
        note: t(`WF_BPA_${application === null || application === void 0 ? void 0 : application.state}`),
        noteStyle: (application === null || application === void 0 ? void 0 : application.status) === "APPROVED" ? {
          color: "#00703C"
        } : {
          color: "#D4351C"
        }
      }), /*#__PURE__*/React__default.createElement(KeyNote, {
        keyValue: t("BPA_COMMON_SLA"),
        note: application === null || application === void 0 ? void 0 : application.sla
      }), application.action === "SEND_TO_ARCHITECT" || application.status !== "INITIATED" ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/services/form12/${application === null || application === void 0 ? void 0 : application.applicationNo}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement("div", null, labelMessage ? /*#__PURE__*/React__default.createElement(Link, {
        to: {
          pathname: `/digit-ui/citizen/obps/services/form12/${application === null || application === void 0 ? void 0 : application.applicationNo}`,
          state: {
            tenantId: ''
          }
        }
      }, /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("TL_VIEW_DETAILS")
      })) : /*#__PURE__*/React__default.createElement(SubmitBar, {
        label: t("BPA_COMP_WORKFLOW"),
        onSubmit: () => getBPAFormData(application, mdmsData, history, t)
      })));
    }
  }));
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const FilterFormFieldsComponent = ({
  statuses,
  isInboxLoading,
  registerRef,
  controlFilterForm,
  setFilterFormValue,
  filterFormState,
  getFilterFormValue,
  localitiesForEmployeesCurrentTenant,
  loadingLocalitiesForEmployeesCurrentTenant
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data: applicationTypesOfBPA,
    isLoading: loadingApplicationTypesOfBPA
  } = Digit.Hooks.obps.SearchMdmsTypes.useApplicationTypes(tenantId);
  const availableOptions = [{
    code: "ASSIGNED_TO_ME",
    name: `${t("ES_INBOX_ASSIGNED_TO_ME")}`
  }, {
    code: "ASSIGNED_TO_ALL",
    name: `${t("ES_INBOX_ASSIGNED_TO_ALL")}`
  }];
  const selectedApplicationType = useWatch({
    control: controlFilterForm,
    name: "applicationType",
    defaultValue: (filterFormState === null || filterFormState === void 0 ? void 0 : filterFormState.applicationType) || null
  });
  const availableBusinessServicesOptions = Digit.Hooks.obps.useBusinessServiceBasedOnServiceType({
    applicationType: selectedApplicationType
  });
  const selectedBusinessService = useWatch({
    control: controlFilterForm,
    name: "businessService",
    defaultValue: (filterFormState === null || filterFormState === void 0 ? void 0 : filterFormState.businessService) || null
  });
  const selectrole = (listOfSelections, props) => {
    const res = listOfSelections.map(propsData => {
      const data = propsData[1];
      return data;
    });
    return props.onChange(res);
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, !window.location.href.includes("/citizen") ? /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "assignee",
    control: controlFilterForm,
    render: props => {
      return /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          props.onChange(e.code);
        },
        selectedOption: availableOptions.filter(option => option.code === props.value)[0],
        optionsKey: "name",
        name: "assignee",
        options: availableOptions
      });
    }
  })) : null, !window.location.href.includes("/citizen") ? /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "locality",
    control: controlFilterForm,
    render: props => {
      const renderRemovableTokens = useMemo(() => {
        var _props$value;
        return props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.map((locality, index) => {
          return /*#__PURE__*/React__default.createElement(RemoveableTag, {
            key: index,
            text: locality.i18nkey,
            onClick: () => {
              var _props$value2;
              props.onChange(props === null || props === void 0 ? void 0 : (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.filter(loc => loc.code !== locality.code));
            }
          });
        });
      }, [props === null || props === void 0 ? void 0 : props.value]);
      return loadingLocalitiesForEmployeesCurrentTenant ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontSize: "18px",
          fontWeight: "600"
        }
      }, t("ES_INBOX_LOCALITY")), /*#__PURE__*/React__default.createElement(MultiSelectDropdown, {
        options: localitiesForEmployeesCurrentTenant ? localitiesForEmployeesCurrentTenant : [],
        optionsKey: "i18nkey",
        props: props,
        isPropsNeeded: true,
        onSelect: selectrole,
        selected: props === null || props === void 0 ? void 0 : props.value,
        defaultLabel: t("ES_BPA_ALL_SELECTED"),
        defaultUnit: t("BPA_SELECTED_TEXT")
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "tag-container"
      }, renderRemovableTokens));
    }
  })) : null, /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "applicationType",
    control: controlFilterForm,
    render: props => {
      return loadingApplicationTypesOfBPA ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontSize: "18px",
          fontWeight: "600"
        }
      }, t("BPA_SEARCH_APPLICATION_TYPE_LABEL")), /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          props.onChange(e.code);
          setFilterFormValue("applicationStatus", []);
          setFilterFormValue("businessService", []);
        },
        selectedOption: applicationTypesOfBPA.filter(option => option.code === props.value)[0],
        optionsKey: "i18nKey",
        name: "applicationType",
        options: applicationTypesOfBPA
      }));
    }
  })), (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.length) > 0 ? /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "businessService",
    control: controlFilterForm,
    render: props => {
      return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontSize: "18px",
          fontWeight: "600"
        }
      }, t("ES_INBOX_RISK_TYPE")), /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          props.onChange(e.code);
          setFilterFormValue("applicationStatus", []);
        },
        selectedOption: availableBusinessServicesOptions.filter(option => option.code === props.value)[0],
        optionsKey: "i18nKey",
        name: "businessService",
        options: availableBusinessServicesOptions
      }));
    }
  })) : null, (selectedApplicationType === null || selectedApplicationType === void 0 ? void 0 : selectedApplicationType.length) > 0 && (selectedBusinessService === null || selectedBusinessService === void 0 ? void 0 : selectedBusinessService.length) > 0 ? /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label sub-filter-label",
    style: {
      fontSize: "18px",
      fontWeight: "600"
    }
  }, t("ACTION_TEST_APPLICATION_STATUS")), /*#__PURE__*/React__default.createElement(Controller, {
    name: "applicationStatus",
    control: controlFilterForm,
    render: props => {
      function changeItemCheckStatus(value) {
        props.onChange(value);
      }
      const renderStatusCheckBoxes = useMemo(() => {
        var _statuses$filter;
        return statuses === null || statuses === void 0 ? void 0 : (_statuses$filter = statuses.filter(e => {
          let value = cloneDeep(selectedBusinessService);
          if (value == "BPA_OC_LOW") value = "BPA_OC";
          return e.businessservice === value;
        })) === null || _statuses$filter === void 0 ? void 0 : _statuses$filter.map((status, index) => {
          var _props$value4;
          return /*#__PURE__*/React__default.createElement(CheckBox$1, {
            style: {
              marginTop: "10px"
            },
            key: index,
            onChange: e => {
              var _props$value3;
              return e.target.checked ? changeItemCheckStatus([...(props === null || props === void 0 ? void 0 : props.value), status === null || status === void 0 ? void 0 : status.statusid]) : changeItemCheckStatus(props === null || props === void 0 ? void 0 : (_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.filter(id => id !== (status === null || status === void 0 ? void 0 : status.statusid)));
            },
            checked: props === null || props === void 0 ? void 0 : (_props$value4 = props.value) === null || _props$value4 === void 0 ? void 0 : _props$value4.includes(status === null || status === void 0 ? void 0 : status.statusid),
            label: `${t(`WF_STATE_${status.businessservice}_${status.applicationstatus}`)}`
          });
        });
      }, [props.value, statuses, selectedBusinessService]);
      return /*#__PURE__*/React__default.createElement(Fragment$2, null, isInboxLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, renderStatusCheckBoxes));
    }
  })) : null);
};

const SearchFormFieldsComponents = ({
  registerRef,
  searchFormState,
  searchFieldComponents
}) => {
  var _searchFormState$erro5, _searchFormState$erro6, _searchFormState$erro7, _searchFormState$erro8;
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const gridStyles = () => {
    return {
      gridTemplateColumns: "33.33% 67.33%",
      textAlign: "start"
    };
  };
  if (!isMobile) {
    var _searchFormState$erro, _searchFormState$erro2, _searchFormState$erro3, _searchFormState$erro4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "search-container",
      style: {
        width: "auto",
        marginLeft: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "search-complaint-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "complaint-input-container",
      style: window.location.href.includes("/citizen") ? gridStyles() : {
        textAlign: "start"
      }
    }, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
      name: "applicationNo",
      inputRef: registerRef({})
    })), !window.location.href.includes("/citizen") ? /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("CORE_COMMON_MOBILE_NUMBER")), /*#__PURE__*/React__default.createElement(MobileNumber, {
      name: "mobileNumber",
      type: "number",
      inputRef: registerRef({
        minLength: {
          value: 10,
          message: t("CORE_COMMON_MOBILE_ERROR")
        },
        maxLength: {
          value: 10,
          message: t("CORE_COMMON_MOBILE_ERROR")
        },
        pattern: {
          value: /[6789][0-9]{9}/,
          message: t("CORE_COMMON_MOBILE_ERROR")
        }
      })
    }), searchFormState !== null && searchFormState !== void 0 && (_searchFormState$erro = searchFormState.errors) !== null && _searchFormState$erro !== void 0 && (_searchFormState$erro2 = _searchFormState$erro["mobileNumber"]) !== null && _searchFormState$erro2 !== void 0 && _searchFormState$erro2.message ? /*#__PURE__*/React__default.createElement(CardLabelError, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro3 = searchFormState.errors) === null || _searchFormState$erro3 === void 0 ? void 0 : (_searchFormState$erro4 = _searchFormState$erro3["mobileNumber"]) === null || _searchFormState$erro4 === void 0 ? void 0 : _searchFormState$erro4.message) : null) : null, /*#__PURE__*/React__default.createElement("div", {
      className: "search-action-wrapper",
      style: {
        width: "100%"
      }
    }, searchFieldComponents)))));
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
    name: "applicationNo",
    inputRef: registerRef({})
  })), !window.location.href.includes("/citizen") ? /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("CORE_COMMON_MOBILE_NUMBER")), /*#__PURE__*/React__default.createElement(MobileNumber, {
    name: "mobileNumber",
    type: "number",
    inputRef: registerRef({
      minLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      maxLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      pattern: {
        value: /[6789][0-9]{9}/,
        message: t("CORE_COMMON_MOBILE_ERROR")
      }
    })
  }), searchFormState !== null && searchFormState !== void 0 && (_searchFormState$erro5 = searchFormState.errors) !== null && _searchFormState$erro5 !== void 0 && (_searchFormState$erro6 = _searchFormState$erro5["mobileNumber"]) !== null && _searchFormState$erro6 !== void 0 && _searchFormState$erro6.message ? /*#__PURE__*/React__default.createElement(CardLabelError, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro7 = searchFormState.errors) === null || _searchFormState$erro7 === void 0 ? void 0 : (_searchFormState$erro8 = _searchFormState$erro7["mobileNumber"]) === null || _searchFormState$erro8 === void 0 ? void 0 : _searchFormState$erro8.message) : null) : null);
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function (date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function (date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function (date, token) {
    return formatters.S(date, token);
  },
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}
function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

const useInboxTableConfig = ({
  parentRoute,
  onPageSizeChange,
  formState,
  totalCount,
  table,
  dispatch,
  onSortingByData
}) => {
  var _formState$tableForm, _formState$tableForm2, _formState$tableForm7, _formState$searchForm;
  const GetCell = value => /*#__PURE__*/React__default.createElement("span", {
    className: "cell-text styled-cell"
  }, value);
  const GetStatusCell = value => value === "Active" || value > 0 ? /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-success"
  }, value) : /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-error"
  }, value);
  const {
    t
  } = useTranslation();
  const tableColumnConfig = useMemo(() => {
    return [{
      Header: t("BPA_APPLICATION_NUMBER_LABEL"),
      accessor: "applicationNo",
      disableSortBy: true,
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Link, {
          to: window.location.href.includes("/citizen") ? `${parentRoute}/bpa/${row.original["applicationId"]}` : `${parentRoute}/inbox/bpa/${row.original["applicationId"]}`
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "link"
        }, row.original["applicationId"])));
      }
    }, {
      Header: t("CS_APPLICATION_DETAILS_APPLICATION_DATE"),
      accessor: "applicationDate",
      Cell: ({
        row
      }) => {
        var _row$original, _row$original2;
        return (_row$original = row.original) !== null && _row$original !== void 0 && _row$original["date"] ? GetCell(format(new Date((_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2["date"]), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("ES_INBOX_LOCALITY"),
      accessor: row => t(row === null || row === void 0 ? void 0 : row.locality),
      disableSortBy: true
    }, {
      Header: t("EVENTS_STATUS_LABEL"),
      accessor: row => row !== null && row !== void 0 && row.state ? t(`WF_${row === null || row === void 0 ? void 0 : row.businessService}_${row === null || row === void 0 ? void 0 : row.state}`) : t(`WF_${row === null || row === void 0 ? void 0 : row.businessService}_${row === null || row === void 0 ? void 0 : row.status}`),
      disableSortBy: true
    }, {
      Header: t("WF_INBOX_HEADER_CURRENT_OWNER"),
      accessor: row => t(row === null || row === void 0 ? void 0 : row.owner),
      disableSortBy: true
    }, {
      Header: t("BPA_SEARCH_APPLICATION_TYPE_LABEL"),
      accessor: row => t(row === null || row === void 0 ? void 0 : row.applicationType),
      disableSortBy: true
    }, {
      Header: t("ES_INBOX_SLA_DAYS_REMAINING"),
      accessor: row => GetStatusCell(row === null || row === void 0 ? void 0 : row.sla)
    }];
  });
  return {
    getCellProps: cellInfo => {
      return {
        style: {
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    disableSort: false,
    autoSort: false,
    manualPagination: true,
    initSortId: "applicationDate",
    onPageSizeChange: onPageSizeChange,
    currentPage: ((_formState$tableForm = formState.tableForm) === null || _formState$tableForm === void 0 ? void 0 : _formState$tableForm.offset) / ((_formState$tableForm2 = formState.tableForm) === null || _formState$tableForm2 === void 0 ? void 0 : _formState$tableForm2.limit),
    onNextPage: () => {
      var _formState$tableForm3, _formState$tableForm4;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm3 = formState.tableForm) === null || _formState$tableForm3 === void 0 ? void 0 : _formState$tableForm3.offset) + parseInt((_formState$tableForm4 = formState.tableForm) === null || _formState$tableForm4 === void 0 ? void 0 : _formState$tableForm4.limit)
        }
      });
    },
    onPrevPage: () => {
      var _formState$tableForm5, _formState$tableForm6;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm5 = formState.tableForm) === null || _formState$tableForm5 === void 0 ? void 0 : _formState$tableForm5.offset) - parseInt((_formState$tableForm6 = formState.tableForm) === null || _formState$tableForm6 === void 0 ? void 0 : _formState$tableForm6.limit)
        }
      });
    },
    pageSizeLimit: (_formState$tableForm7 = formState.tableForm) === null || _formState$tableForm7 === void 0 ? void 0 : _formState$tableForm7.limit,
    onSort: onSortingByData,
    totalRecords: totalCount,
    onSearch: formState === null || formState === void 0 ? void 0 : (_formState$searchForm = formState.searchForm) === null || _formState$searchForm === void 0 ? void 0 : _formState$searchForm.message,
    onLastPage: () => {
      var _formState$tableForm8;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: Math.ceil(totalCount / 10) * 10 - parseInt((_formState$tableForm8 = formState.tableForm) === null || _formState$tableForm8 === void 0 ? void 0 : _formState$tableForm8.limit)
        }
      });
    },
    onFirstPage: () => dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        offset: 0
      }
    }),
    data: table,
    columns: tableColumnConfig
  };
};

const useInboxMobileCardsData = ({
  parentRoute,
  table,
  getRedirectionLink
}) => {
  const {
    t
  } = useTranslation();
  const dataForMobileInboxCards = table === null || table === void 0 ? void 0 : table.map(({
    applicationId,
    date,
    applicationType,
    businessService,
    locality,
    status,
    owner,
    sla,
    state
  }) => ({
    [t("BPA_APPLICATION_NUMBER_LABEL")]: applicationId,
    [t("CS_APPLICATION_DETAILS_APPLICATION_DATE")]: format(new Date(date), 'dd/MM/yyyy'),
    [t("BPA_SEARCH_APPLICATION_TYPE_LABEL")]: t(applicationType),
    [t("ES_INBOX_LOCALITY")]: t(locality),
    [t("EVENTS_STATUS_LABEL")]: state ? t(`WF_${businessService}_${state}`) : t(`WF_${businessService}_${status}`),
    [t("WF_INBOX_HEADER_CURRENT_OWNER")]: owner,
    [t("ES_INBOX_SLA_DAYS_REMAINING")]: sla
  }));
  const MobileSortFormValues = () => {
    const sortOrderOptions = [{
      code: "DESC",
      i18nKey: "ES_COMMON_SORT_BY_DESC"
    }, {
      code: "ASC",
      i18nKey: "ES_COMMON_SORT_BY_ASC"
    }];
    const {
      control: controlSortForm
    } = useFormContext();
    return /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement(Controller, {
      name: "sortOrder",
      control: controlSortForm,
      render: ({
        onChange,
        value
      }) => /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          onChange(e.code);
        },
        selectedOption: sortOrderOptions.filter(option => option.code === value)[0],
        optionsKey: "i18nKey",
        name: "sortOrder",
        options: sortOrderOptions
      })
    }));
  };
  return {
    data: dataForMobileInboxCards,
    isTwoDynamicPrefix: true,
    linkPrefix: window.location.href.includes("/citizen") ? `/digit-ui/citizen/obps/` : `/digit-ui/employee/obps/`,
    getRedirectionLink: getRedirectionLink,
    serviceRequestIdKey: "applicationNo",
    MobileSortFormValues
  };
};

const Inbox = ({
  parentRoute
}) => {
  window.scroll(0, 0);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const searchFormDefaultValues = {};
  const filterFormDefaultValues = {
    moduleName: "bpa-services",
    applicationStatus: [],
    locality: [],
    assignee: "ASSIGNED_TO_ALL",
    applicationType: []
  };
  const tableOrderFormDefaultValues = {
    sortBy: "",
    limit: Digit.Utils.browser.isMobile() ? 50 : 10,
    offset: 0,
    sortOrder: "DESC"
  };
  function formReducer(state, payload) {
    switch (payload.action) {
      case "mutateSearchForm":
        Digit.SessionStorage.set("OBPS.INBOX", {
          ...state,
          searchForm: payload.data
        });
        return {
          ...state,
          searchForm: payload.data
        };
      case "mutateFilterForm":
        Digit.SessionStorage.set("OBPS.INBOX", {
          ...state,
          filterForm: payload.data
        });
        return {
          ...state,
          filterForm: payload.data
        };
      case "mutateTableForm":
        Digit.SessionStorage.set("OBPS.INBOX", {
          ...state,
          tableForm: payload.data
        });
        return {
          ...state,
          tableForm: payload.data
        };
    }
  }
  const InboxObjectInSessionStorage = Digit.SessionStorage.get("OBPS.INBOX");
  const onSearchFormReset = setSearchFormValue => {
    setSearchFormValue("mobileNumber", null);
    setSearchFormValue("applicationNo", null);
    dispatch({
      action: "mutateSearchForm",
      data: searchFormDefaultValues
    });
  };
  const onFilterFormReset = setFilterFormValue => {
    setFilterFormValue("moduleName", "bpa-services");
    setFilterFormValue("applicationStatus", "");
    setFilterFormValue("locality", []);
    setFilterFormValue("assignee", "ASSIGNED_TO_ALL");
    setFilterFormValue("applicationType", []);
    dispatch({
      action: "mutateFilterForm",
      data: filterFormDefaultValues
    });
  };
  const onSortFormReset = setSortFormValue => {
    setSortFormValue("sortOrder", "DESC");
    dispatch({
      action: "mutateTableForm",
      data: tableOrderFormDefaultValues
    });
  };
  const formInitValue = useMemo(() => {
    return InboxObjectInSessionStorage || {
      filterForm: filterFormDefaultValues,
      searchForm: searchFormDefaultValues,
      tableForm: tableOrderFormDefaultValues
    };
  }, [Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.filterForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.searchForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.tableForm) || {})]);
  const [formState, dispatch] = useReducer(formReducer, formInitValue);
  const onPageSizeChange = e => {
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        limit: e.target.value
      }
    });
  };
  const onSortingByData = e => {
    if (e.length > 0) {
      const [{
        id,
        desc
      }] = e;
      const sortOrder = desc ? "DESC" : "ASC";
      const sortBy = id;
      if (!(formState.tableForm.sortBy === sortBy && formState.tableForm.sortOrder === sortOrder)) {
        dispatch({
          action: "mutateTableForm",
          data: {
            ...formState.tableForm,
            sortBy: id,
            sortOrder: desc ? "DESC" : "ASC"
          }
        });
      }
    }
  };
  const onMobileSortOrderData = data => {
    const {
      sortOrder
    } = data;
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        sortOrder
      }
    });
  };
  const getRedirectionLink = bService => {
    let redirectBS = "";
    if (bService === "BPAREG") {
      redirectBS = "search/application/stakeholder";
    } else {
      redirectBS = window.location.href.includes("/citizen") ? "bpa" : "search/application/bpa";
    }
    return redirectBS;
  };
  const {
    data: localitiesForEmployeesCurrentTenant,
    isLoading: loadingLocalitiesForEmployeesCurrentTenant
  } = Digit.Hooks.useBoundaryLocalities(tenantId, "revenue", {}, t);
  const {
    isLoading: isInboxLoading,
    data: {
      table,
      statuses,
      totalCount
    } = {}
  } = Digit.Hooks.obps.useBPAInbox({
    tenantId,
    filters: {
      ...formState
    }
  });
  const PropsForInboxLinks = {
    logoIcon: /*#__PURE__*/React__default.createElement(CaseIcon, null),
    headerText: "CS_COMMON_OBPS",
    links: [{
      text: t("BPA_SEARCH_PAGE_TITLE"),
      link: window.location.href.includes("/citizen") ? "/digit-ui/citizen/obps/search/application" : "/digit-ui/employee/obps/search/application",
      businessService: "BPA",
      roles: ["BPAREG_EMPLOYEE", "BPAREG_APPROVER", "BPAREG_DOC_VERIFIER", "BPAREG_DOC_VERIFIER"]
    }]
  };
  const SearchFormFields = useCallback(({
    registerRef,
    searchFormState,
    searchFieldComponents
  }) => /*#__PURE__*/React__default.createElement(SearchFormFieldsComponents, {
    registerRef,
    searchFormState,
    searchFieldComponents
  }), []);
  const FilterFormFields = useCallback(({
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    getFilterFormValue
  }) => /*#__PURE__*/React__default.createElement(FilterFormFieldsComponent, {
    statuses,
    isInboxLoading,
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    filterFormState: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    getFilterFormValue,
    localitiesForEmployeesCurrentTenant,
    loadingLocalitiesForEmployeesCurrentTenant
  }), [statuses, isInboxLoading, localitiesForEmployeesCurrentTenant, loadingLocalitiesForEmployeesCurrentTenant]);
  const onSearchFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateSearchForm",
      data
    });
  };
  const onFilterFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateFilterForm",
      data
    });
  };
  const propsForSearchForm = {
    SearchFormFields,
    onSearchFormSubmit,
    searchFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.searchForm,
    resetSearchFormDefaultValues: searchFormDefaultValues,
    onSearchFormReset
  };
  const propsForFilterForm = {
    FilterFormFields,
    onFilterFormSubmit,
    filterFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    resetFilterFormDefaultValues: filterFormDefaultValues,
    onFilterFormReset
  };
  const propsForInboxTable = useInboxTableConfig({
    ...{
      parentRoute,
      onPageSizeChange,
      formState,
      totalCount,
      table,
      dispatch,
      onSortingByData
    }
  });
  const propsForInboxMobileCards = useInboxMobileCardsData({
    parentRoute,
    table,
    getRedirectionLink
  });
  const propsForMobileSortForm = {
    onMobileSortOrderData,
    sortFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.tableForm,
    onSortFormReset
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Header, null, t("ES_COMMON_INBOX"), totalCount ? /*#__PURE__*/React__default.createElement("p", {
    className: "inbox-count"
  }, totalCount) : null), /*#__PURE__*/React__default.createElement(InboxComposer, _extends({
    isInboxLoading,
    PropsForInboxLinks
  }, propsForSearchForm, propsForFilterForm, propsForMobileSortForm, {
    propsForInboxTable,
    propsForInboxMobileCards,
    formState
  })));
};

const BPACitizenHomeScreen = ({
  parentRoute
}) => {
  var _userInfo$info, _userInfo$info$roles, _Digit, _sortParams$5, _sortParams$6;
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(roleData => roleData.code);
  const stateCode = Digit.ULBService.getStateId();
  const [stakeHolderRoles, setStakeholderRoles] = useState(false);
  const {
    data: stakeHolderDetails,
    isLoading: stakeHolderDetailsLoading
  } = Digit.Hooks.obps.useMDMS(stateCode, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  const [bpaLinks, setBpaLinks] = useState([]);
  const state = Digit.ULBService.getStateId();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BPA_HOME_CREATE", {});
  const {
    data: homePageUrlLinks,
    isLoading: homePageUrlLinksLoading
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["homePageUrlLinks"]);
  const [showToast, setShowToast] = useState(null);
  const [totalCount, setTotalCount] = useState("-");
  const closeToast = () => {
    window.location.replace("/digit-ui/citizen/all-services");
    setShowToast(null);
  };
  const [searchParams, setSearchParams] = useState({
    applicationStatus: []
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  const [pageOffset, setPageOffset] = useState(0);
  const [pageSize, setPageSize] = useState(window.Digit.Utils.browser.isMobile() ? 50 : 10);
  const [sortParams, setSortParams] = useState([{
    id: "createdTime",
    sortOrder: "DESC"
  }]);
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const isUdFlow = applicationFlow === "UD";
  let businessObject = isUdFlow ? ["BPA_UDSOLAN", "BPA_UDPARWANOO", "BPA_UDARKI", "BPA_UDTHEOG", "BPA_UDSHIMLA"] : ["BPA_LOW", "BPA", "BPA_OC", "BPA_TCPBBNDA"];
  const {
    isLoading: bpaLoading,
    data: bpaInboxData
  } = Digit.Hooks.obps.useArchitectInbox({
    tenantId: stateCode,
    moduleName: "bpa-services",
    businessService: businessObject,
    filters: {
      searchForm: {
        ...searchParams
      },
      tableForm: {
        sortBy: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$5 = sortParams[0]) === null || _sortParams$5 === void 0 ? void 0 : _sortParams$5.id,
        limit: pageSize,
        offset: pageOffset,
        sortOrder: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$6 = sortParams[0]) === null || _sortParams$6 === void 0 ? void 0 : _sortParams$6.sortOrder
      },
      filterForm: {
        moduleName: "bpa-services",
        businessService: businessObject,
        applicationStatus: searchParams === null || searchParams === void 0 ? void 0 : searchParams.applicationStatus,
        locality: [],
        assignee: "ASSIGNED_TO_ALL"
      }
    },
    config: {},
    withEDCRData: false
  });
  const {
    isLoading: isEDCRInboxLoading,
    data: {
      totalCount: edcrCount
    } = {}
  } = Digit.Hooks.obps.useEDCRInbox({
    tenantId: stateCode,
    filters: {
      filterForm: {},
      searchForm: {},
      tableForm: {
        limit: 10,
        offset: 0
      }
    }
  });
  useEffect(() => {
    if (location.pathname === "/digit-ui/citizen/obps/home") {
      Digit.SessionStorage.del("OBPS.INBOX");
      Digit.SessionStorage.del("STAKEHOLDER.INBOX");
    }
  }, [location.pathname]);
  useEffect(() => {
    if (!bpaLoading) {
      const totalCountofBoth = (bpaInboxData === null || bpaInboxData === void 0 ? void 0 : bpaInboxData.totalCount) || 0;
      setTotalCount(totalCountofBoth);
    }
  }, [bpaInboxData]);
  useEffect(() => {
    if (!stakeHolderDetailsLoading) {
      var _stakeHolderDetails$S, _stakeHolderDetails$S2;
      let roles = [];
      stakeHolderDetails === null || stakeHolderDetails === void 0 ? void 0 : (_stakeHolderDetails$S = stakeHolderDetails.StakeholderRegistraition) === null || _stakeHolderDetails$S === void 0 ? void 0 : (_stakeHolderDetails$S2 = _stakeHolderDetails$S.TradeTypetoRoleMapping) === null || _stakeHolderDetails$S2 === void 0 ? void 0 : _stakeHolderDetails$S2.map(type => {
        var _type$role;
        type === null || type === void 0 ? void 0 : (_type$role = type.role) === null || _type$role === void 0 ? void 0 : _type$role.map(role => {
          roles.push(role);
        });
      });
      const uniqueRoles = roles === null || roles === void 0 ? void 0 : roles.filter((item, i, ar) => ar.indexOf(item) === i);
      let isRoute = false;
      uniqueRoles === null || uniqueRoles === void 0 ? void 0 : uniqueRoles.map(unRole => {
        if (userRoles !== null && userRoles !== void 0 && userRoles.includes(unRole) && !isRoute) {
          isRoute = true;
        }
      });
      if (!isRoute) {
        setStakeholderRoles(false);
        setShowToast({
          key: "true",
          message: t("BPA_LOGIN_HOME_VALIDATION_MESSAGE_LABEL")
        });
      } else {
        setStakeholderRoles(true);
      }
    }
  }, [stakeHolderDetailsLoading]);
  useEffect(() => {
    var _homePageUrlLinks$BPA, _homePageUrlLinks$BPA2;
    if (!homePageUrlLinksLoading && (homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA === void 0 ? void 0 : (_homePageUrlLinks$BPA2 = _homePageUrlLinks$BPA.homePageUrlLinks) === null || _homePageUrlLinks$BPA2 === void 0 ? void 0 : _homePageUrlLinks$BPA2.length) > 0) {
      var _homePageUrlLinks$BPA3, _homePageUrlLinks$BPA4;
      let uniqueLinks = [];
      homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA3 = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA3 === void 0 ? void 0 : (_homePageUrlLinks$BPA4 = _homePageUrlLinks$BPA3.homePageUrlLinks) === null || _homePageUrlLinks$BPA4 === void 0 ? void 0 : _homePageUrlLinks$BPA4.map(linkData => {
        var _linkData$flow, _linkData$application, _linkData$serviceType;
        uniqueLinks.push({
          link: `${linkData === null || linkData === void 0 ? void 0 : (_linkData$flow = linkData.flow) === null || _linkData$flow === void 0 ? void 0 : _linkData$flow.toLowerCase()}/${linkData === null || linkData === void 0 ? void 0 : (_linkData$application = linkData.applicationType) === null || _linkData$application === void 0 ? void 0 : _linkData$application.toLowerCase()}/${linkData === null || linkData === void 0 ? void 0 : (_linkData$serviceType = linkData.serviceType) === null || _linkData$serviceType === void 0 ? void 0 : _linkData$serviceType.toLowerCase()}/basic-details`,
          i18nKey: t(`BPA_HOME_${linkData === null || linkData === void 0 ? void 0 : linkData.applicationType}_${linkData === null || linkData === void 0 ? void 0 : linkData.serviceType}_LABEL`),
          state: {
            linkData
          },
          linkState: true
        });
      });
      setBpaLinks(uniqueLinks);
    }
  }, [!homePageUrlLinksLoading]);
  useEffect(() => {
    clearParams();
  }, []);
  Digit.SessionStorage.set("EDCR_BACK", "IS_EDCR_BACK");
  if (showToast) return /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  });
  if (stakeHolderDetailsLoading || !stakeHolderRoles || bpaLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  const homeDetails = [{
    title: t("Building Plan Permission - Form12"),
    Icon: /*#__PURE__*/React__default.createElement(BPAIcon, {
      className: "fill-path-primary-main"
    }),
    links: [{
      link: `edcrscrutiny/apply/home`,
      i18nKey: t("Apply for form 12")
    }, {
      link: `edcrscrutiny/apply/home`,
      i18nKey: t("Apply for Self-Certification Form-12 (Applicable for granting planning permission upto 500m2 of plot area for resendential use)")
    }, {
      link: `form12Applications`,
      i18nKey: t("View applications")
    }],
    styles: {
      minWidth: "90%",
      minHeight: "90%"
    }
  }, {
    Icon: /*#__PURE__*/React__default.createElement(BPAHomeIcon, null),
    moduleName: t("ACTION_TEST_BPA_STAKE_HOLDER_HOME"),
    name: "employeeCard",
    isCitizen: true,
    kpis: [{
      count: !(bpaLoading || isEDCRInboxLoading) && totalCount && edcrCount ? totalCount + edcrCount : "-",
      label: t("BPA_PDF_TOTAL"),
      link: `/digit-ui/citizen/obps/bpa/inbox`
    }],
    links: [{
      count: !bpaLoading ? totalCount : "-",
      label: t("ES_COMMON_OBPS_INBOX_LABEL"),
      link: `/digit-ui/citizen/obps/form12inbox`
    }, {
      count: !isEDCRInboxLoading ? edcrCount : "-",
      label: t("ES_COMMON_EDCR_INBOX_LABEL"),
      link: `/digit-ui/citizen/obps/edcr/inbox`
    }],
    className: "CitizenHomeCard",
    styles: {
      padding: "0px",
      minWidth: "90%",
      minHeight: "90%"
    }
  }, {
    title: t("ACTION_TEST_EDCR_SCRUTINY"),
    Icon: /*#__PURE__*/React__default.createElement(EDCRIcon, {
      className: "fill-path-primary-main"
    }),
    links: [{
      link: `edcrscrutiny/apply`,
      i18nKey: t("BPA_PLAN_SCRUTINY_FOR_NEW_CONSTRUCTION_LABEL")
    }, {
      link: `edcrscrutiny/oc-apply`,
      i18nKey: t("BPA_OC_PLAN_SCRUTINY_FOR_NEW_CONSTRUCTION_LABEL")
    }],
    styles: {
      minWidth: "90%",
      minHeight: "90%"
    }
  }, {
    title: t("ACTION_TEST_BPA_STAKE_HOLDER_HOME"),
    Icon: /*#__PURE__*/React__default.createElement(BPAIcon, {
      className: "fill-path-primary-main"
    }),
    links: bpaLinks,
    styles: {
      minWidth: "90%",
      minHeight: "90%"
    }
  }];
  const homeScreen = /*#__PURE__*/React__default.createElement("div", {
    className: "mainContent citizenAllServiceGrid"
  }, homeDetails.map(data => {
    return /*#__PURE__*/React__default.createElement("div", null, data.name === "employeeCard" ? /*#__PURE__*/React__default.createElement(EmployeeModuleCard, data) : /*#__PURE__*/React__default.createElement(CitizenOBPSHomeCard, {
      header: data.title,
      links: data.links,
      Icon: () => data.Icon,
      styles: data === null || data === void 0 ? void 0 : data.styles
    }));
  }));
  sessionStorage.setItem("isPermitApplication", true);
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(false));
  return homeScreen;
};

const types = {
  INIT_DOCUMENTS: "INIT_FORM12_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM12_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM12_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM12_DOCUMENTS"
};
const initForm12Docs = documents => {
  return dispatch => dispatch({
    type: types.INIT_DOCUMENTS,
    payload: documents
  });
};
const addForm12Doc = docData => {
  return dispatch => dispatch({
    type: types.ADD_DOCUMENT,
    payload: docData
  });
};
const removeForm12Doc = docId => {
  return dispatch => dispatch({
    type: types.REMOVE_DOCUMENT,
    payload: docId
  });
};
const resetForm12Docs = () => {
  return dispatch => dispatch({
    type: types.RESET_DOCUMENTS
  });
};

var form12DocActions = {
  __proto__: null,
  types: types,
  initForm12Docs: initForm12Docs,
  addForm12Doc: addForm12Doc,
  removeForm12Doc: removeForm12Doc,
  resetForm12Docs: resetForm12Docs
};

const types$1 = {
  INIT_DOCUMENTS: "INIT_FORM11_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM11_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM11_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM11_DOCUMENTS"
};
const initForm11Docs = documents => {
  return dispatch => dispatch({
    type: types$1.INIT_DOCUMENTS,
    payload: documents
  });
};
const addForm11Doc = docData => {
  return dispatch => dispatch({
    type: types$1.ADD_DOCUMENT,
    payload: docData
  });
};
const removeForm11Doc = docId => {
  return dispatch => dispatch({
    type: types$1.REMOVE_DOCUMENT,
    payload: docId
  });
};
const resetForm11Docs = () => {
  return dispatch => dispatch({
    type: types$1.RESET_DOCUMENTS
  });
};

var form11DocActions = {
  __proto__: null,
  types: types$1,
  initForm11Docs: initForm11Docs,
  addForm11Doc: addForm11Doc,
  removeForm11Doc: removeForm11Doc,
  resetForm11Docs: resetForm11Docs
};

const types$2 = {
  ADD_DOCUMENT: "ADD_REGISTRATION_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_REGISTRATION_DOCUMENT",
  INIT_DOCUMENTS: "INIT_REGISTRATION_DOCUMENTS",
  RESET_DOCUMENTS: "RESET_REGISTRATION_DOCUMENTS"
};
const addRegistrationDoc = docData => {
  return dispatch => dispatch({
    type: types$2.ADD_DOCUMENT,
    payload: docData
  });
};
const initRegistrationDocs = documents => {
  return dispatch => dispatch({
    type: types$2.INIT_DOCUMENTS,
    payload: documents
  });
};
const removeRegistrationDoc = docId => {
  return dispatch => dispatch({
    type: types$2.REMOVE_DOCUMENT,
    payload: docId
  });
};
const resetRegistrationDocs = () => {
  return dispatch => dispatch({
    type: types$2.RESET_DOCUMENTS
  });
};

var registration = {
  __proto__: null,
  types: types$2,
  addRegistrationDoc: addRegistrationDoc,
  initRegistrationDocs: initRegistrationDocs,
  removeRegistrationDoc: removeRegistrationDoc,
  resetRegistrationDocs: resetRegistrationDocs
};

const types$3 = {
  INIT_DOCUMENTS: "INIT_FORM_MT_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM_MT_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM_MT_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM_MT_DOCUMENTS"
};
const initFormMTDocs = documents => {
  return dispatch => dispatch({
    type: types$3.INIT_DOCUMENTS,
    payload: documents
  });
};
const addFormMTDoc = docData => {
  return dispatch => dispatch({
    type: types$3.ADD_DOCUMENT,
    payload: docData
  });
};
const removeFormMTDoc = docId => {
  return dispatch => dispatch({
    type: types$3.REMOVE_DOCUMENT,
    payload: docId
  });
};
const resetFormMTDocs = () => {
  return dispatch => dispatch({
    type: types$3.RESET_DOCUMENTS
  });
};

var formMTDocActions = {
  __proto__: null,
  types: types$3,
  initFormMTDocs: initFormMTDocs,
  addFormMTDoc: addFormMTDoc,
  removeFormMTDoc: removeFormMTDoc,
  resetFormMTDocs: resetFormMTDocs
};

const ButtonWrapper = ({
  variant,
  disabled,
  onClick,
  color,
  size,
  startIcon,
  endIcon,
  label,
  type,
  sx
}) => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button, {
    sx: {
      borderRadius: "4px",
      ...sx
    },
    variant: variant,
    disabled: disabled,
    onClick: onClick,
    color: color,
    size: size,
    startIcon: startIcon,
    endIcon: endIcon,
    type: type || "button"
  }, label));
};

const nameSuffix = [{
  value: "Mr.",
  label: "Mr."
}, {
  value: "Mrs.",
  label: "Mrs."
}, {
  value: "Miss.",
  label: "Miss."
}];
const departmentList = [{
  value: "AVP",
  label: "UPAVP",
  name: "avp"
}, {
  value: "DA",
  label: "DA",
  name: "da"
}];
const scrutinyList = [{
  value: "PDF",
  label: "Via PDF",
  name: "pdf"
}, {
  value: "EDCR",
  label: "Via EDCR Scrutiny",
  name: "edcr"
}];
const propertyTypeList = [{
  value: "Govt.",
  label: "Govt.",
  name: "Govt."
}, {
  value: "Private",
  label: "Private",
  name: "Private"
}, {
  value: "Himuda",
  label: "Himuda",
  name: "Himuda"
}];
const qualificationTypeList = [{
  value: "B.Arch",
  label: "B.Arch",
  name: "B.Arch",
  type: "Architect"
}, {
  value: "M.Arch",
  label: "M.Arch",
  name: "M.Arch",
  type: "Architect"
}, {
  value: "B.E",
  label: "B.E",
  name: "B.E",
  type: "Graduate Civil Engineer"
}, {
  value: "M.E",
  label: "M.E",
  name: "M.E",
  type: "Graduate Civil Engineer"
}, {
  value: "B.Tech",
  label: "B.Tech",
  name: "B.Tech",
  type: "Graduate Civil Engineer"
}, {
  value: "M.Tech",
  label: "M.Tech",
  name: "M.Tech",
  type: "Graduate Civil Engineer"
}, {
  value: "Diploma in Civil Engineering",
  label: "Diploma in Civil Engineering",
  name: "Diploma in Civil Engineering",
  type: "Supervisor"
}, {
  value: "Architectural Assistantship",
  label: "Architectural Assistantship",
  name: "Architectural Assistantship",
  type: "Supervisor"
}, {
  value: "B.Plan",
  label: "B.Plan",
  name: "B.Plan",
  type: "Town Planner"
}, {
  value: "M.Plan",
  label: "M.Plan",
  name: "M.Plan",
  type: "Town Planner"
}, {
  value: "B.E",
  label: "B.E",
  name: "B.E",
  type: "Structural Engineer"
}, {
  value: "M.E",
  label: "M.E",
  name: "M.E",
  type: "Structural Engineer"
}, {
  value: "B.Tech",
  label: "B.Tech",
  name: "B.Tech",
  type: "Structural Engineer"
}, {
  value: "M.Tech",
  label: "M.Tech",
  name: "M.Tech",
  type: "Structural Engineer"
}, {
  value: "B.Arch",
  label: "B.Arch",
  name: "B.Arch",
  type: "Landscape Architect"
}, {
  value: "B.Arch",
  label: "B.Arch",
  name: "B.Arch",
  type: "Urban Designer"
}, {
  value: "B.Plan",
  label: "B.Plan",
  name: "B.Plan",
  type: "Urban Designer"
}, {
  value: "M.Plan",
  label: "M.Plan",
  name: "M.Plan",
  type: "Urban Designer"
}, {
  value: "B.E",
  label: "B.E",
  name: "B.E",
  type: "Engineers for Utility Services"
}, {
  value: "M.E",
  label: "M.E",
  name: "M.E",
  type: "Engineers for Utility Services"
}];
const proposalSubmittedFor = [{
  value: "ApprovalOfMap",
  label: "Approval of map",
  name: "Approval of map"
}, {
  value: "ChangeOfExistingBuildingUse",
  label: "Change of Existing building use",
  name: "Change of Existing building use"
}, {
  value: "RevisedProposalOfApprovedMap",
  label: "Revised proposal of approved map",
  name: "Revised proposal of approved map"
}, {
  value: "ReconstructionOnOldLine",
  label: "Reconstruction on old line",
  name: "Reconstruction on old line"
}, {
  value: "AlterationAdditionOfExistingBuilding",
  label: "Alteration/Addition of Existing building",
  name: "Alteration/Addition of Existing building"
}];
const projectTypeOptions = [{
  value: "Building Permission-Low Risk",
  label: "Building Permission-Low Risk",
  name: "Building Permission-Low Risk"
}, {
  value: "Building Permission-High Risk/Group Housing",
  label: "Building Permission-High Risk/Group Housing",
  name: "Building Permission-High Risk/Group Housing"
}, {
  value: "Layout Development",
  label: "Layout Development",
  name: "Layout Development"
}, {
  value: "Other",
  label: "Other",
  name: "Other"
}];
const ConstructionTypeOptions = [{
  value: "Built-up Area",
  label: "Built-up Area",
  name: "Built-up Area"
}, {
  value: "Non-Built-up Area",
  label: "Non-Built-up Area",
  name: "Non-Built-up Area"
}];
const governmentBuildingOptions = [{
  value: "Government Building",
  label: "Government Building",
  name: "Government Building"
}];
const propertyTypeListUP = [{
  value: "Plot",
  label: "Plot",
  name: "Plot"
}, {
  value: "House",
  label: "House",
  name: "House"
}, {
  value: "Flat",
  label: "Flat",
  name: "Flat"
}];
const vacantOrBuilt = [{
  value: "Vacant",
  label: "Vacant",
  name: "Vacant"
}, {
  value: "Built",
  label: "Built",
  name: "Built"
}];
const guaranteeList = [{
  value: "Bank Gaurantee",
  label: "Bank Gaurantee",
  name: "Bank Gaurantee"
}, {
  value: "Land Mortgaged",
  label: "Land Mortgaged",
  name: "Land Mortgaged"
}];
const specialProjectList = [{
  value: "Transit Oriented Development (TOD)",
  label: "Transit Oriented Development (TOD)",
  name: "Transit Oriented Development (TOD)"
}, {
  value: "Government Building",
  label: "Government Building",
  name: "Government Building"
}, {
  value: "Type design",
  label: "Type design",
  name: "Type design"
}, {
  value: "Mixed Use Along 18/24M Wide Road",
  label: "Mixed Use Along 18/24M Wide Road",
  name: "Mixed Use Along 18/24M Wide Road"
}, {
  value: "Pradhan Mantri Awas Yojna (PMAY)",
  label: "Pradhan Mantri Awas Yojna (PMAY)",
  name: "Pradhan Mantri Awas Yojna (PMAY)"
}];
const yesOrNo = [{
  value: "yes",
  label: "Yes",
  name: "Yes"
}, {
  value: "no",
  label: "No",
  name: "No"
}];
const buildingInternalChanges = [{
  value: "Under building byelaws",
  label: "Under building byelaws",
  name: "Under building byelaws"
}, {
  value: "If contrary to the byelaws It has been extinguished",
  label: "If contrary to the byelaws It has been extinguished",
  name: "If contrary to the byelaws It has been extinguished"
}];
const fullyPartial = [{
  value: "Fully",
  label: "Fully",
  name: "Fully"
}, {
  value: "Partially",
  label: "Partially",
  name: "Partially"
}];
const additionalFar = [{
  value: "3%",
  label: "3%",
  name: "3%"
}, {
  value: "5%",
  label: "5%",
  name: "5%"
}, {
  value: "7%",
  label: "7%",
  name: "7%"
}];
const approvedOrShortfall = [{
  value: "approved",
  label: "Approved",
  name: "Approved"
}, {
  value: "shortfall",
  label: "Shortfall",
  name: "Shortfall"
}];
const siteInspRecommendation = [{
  value: "Rejection",
  label: "Rejection",
  name: "Rejection"
}, {
  value: "Approval",
  label: "Approval",
  name: "Approval"
}, {
  value: "Shortfall",
  label: "Shortfall",
  name: "Shortfall"
}];
const innerInspRecommendation = [{
  value: "Map is not as per Building Byelwas",
  label: "Map is not as per Building Byelwas",
  name: "Map is not as per Building Byelwas"
}, {
  value: "Proposed Map is against land use report",
  label: "Proposed Map is against land use report",
  name: "Proposed Map is against land use report"
}, {
  value: "Ground coverage & FAR is not as per Building Byelaws",
  label: "Ground coverage & FAR is not as per Building Byelaws",
  name: "Ground coverage & FAR is not as per Building Byelaws"
}, {
  value: "Set back & Parking is not as per Building Byelaws",
  label: "Set back & Parking is not as per Building Byelaws",
  name: "Set back & Parking is not as per Building Byelaws"
}, {
  value: "Key Plan & Google Co-ordinates of Proposed site is not provided",
  label: "Key Plan & Google Co-ordinates of Proposed site is not provided",
  name: "Key Plan & Google Co-ordinates of Proposed site is not provided"
}, {
  value: "Plot mortgaged in favor of DA",
  label: "Plot mortgaged in favor of DA",
  name: "Plot mortgaged in favor of DA"
}, {
  value: "Elevation, Section & Plot Boundaries is not correct",
  label: "Elevation, Section & Plot Boundaries is not correct",
  name: "Elevation, Section & Plot Boundaries is not correct"
}, {
  value: "Map is not as per control design",
  label: "Map is not as per control design",
  name: "Map is not as per control design"
}, {
  value: "Ground coverage & FAR is not as per Deed",
  label: "Ground coverage & FAR is not as per Deed",
  name: "Ground coverage & FAR is not as per Deed"
}, {
  value: "Setback is not as marked in approved Layout",
  label: "Setback is not as marked in approved Layout",
  name: "Setback is not as marked in approved Layout"
}];
const recommendation = [{
  value: "Not accepted",
  label: "Not accepted",
  name: "Not accepted"
}, {
  value: "Accepted",
  label: "Accepted",
  name: "Accepted"
}];
const remarks = [{
  value: "Plz upload full documents in chronological order",
  label: "Plz upload full documents in chronological order",
  name: "Plz upload full documents in chronological order"
}, {
  value: "Not accepted plz upload relevant document as per guidelines",
  label: "Not accepted plz upload relevant document as per guidelines",
  name: "Not accepted plz upload relevant document as per guidelines"
}, {
  value: "Not readable please upload clear scan image",
  label: "Not readable please upload clear scan image",
  name: "Not readable please upload clear scan image"
}, {
  value: "Upload a valid document",
  label: "Upload a valid document",
  name: "Upload a valid document"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const ownerOrApplicant = [{
  value: "owner",
  label: "Owner",
  name: "Owner"
}, {
  value: "Applicant",
  label: "Applicant",
  name: "Applicant"
}];
const yesNoNA2 = [{
  value: "yes",
  label: "Yes",
  name: "Yes"
}, {
  value: "no",
  label: "No",
  name: "No"
}, {
  value: "N/A",
  label: "N/A",
  name: "N/A"
}];
const yesNoNA = [{
  value: "yes",
  label: "Yet to Verify",
  name: "Yes"
}, {
  value: "",
  label: "No",
  name: "No"
}, {
  value: "N/A",
  label: "N/A",
  name: "N/A"
}];
const typeOfIdProof = [{
  value: "Pan Card",
  label: "Pan Card",
  name: "Pan Card"
}, {
  value: "Aadhaar Card",
  label: "Aadhaar Card",
  name: "Aadhaar Card"
}, {
  value: "Driving License",
  label: "Driving License",
  name: "Driving License"
}, {
  value: "Voter Card",
  label: "Voter Card",
  name: "Voter Card"
}, {
  value: "Ration Card",
  label: "Ration Card",
  name: "Ration Card"
}, {
  value: "Passport",
  label: "Passport",
  name: "Passport"
}];
const landUseZoneOptions = [{
  value: "Residential Use Zone",
  label: "Residential Use Zone",
  name: "Residential Use Zone"
}, {
  value: "Commercial Building",
  label: "Commercial Building",
  name: "Commercial Building"
}, {
  value: "Educational Building",
  label: "Educational Building",
  name: "Educational Building"
}, {
  value: "Institutional Buildings",
  label: "Institutional Buildings",
  name: "Institutional Buildings"
}, {
  value: "Assembly Buildings",
  label: "Assembly Buildings",
  name: "Assembly Buildings"
}, {
  value: "Officials Buildings",
  label: "Officials Buildings",
  name: "Officials Buildings"
}, {
  value: "Industrial Buildings",
  label: "Industrial Buildings",
  name: "Industrial Buildings"
}, {
  value: "Storage Buildings",
  label: "Storage Buildings",
  name: "Storage Buildings"
}];
const natureOfConstructionOptions = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Addition Extension",
  label: "Addition Extension",
  name: "Addition Extension"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}, {
  value: "Revalidation/Time Extension",
  label: "Revalidation/Time Extension",
  name: "Revalidation/Time Extension"
}, {
  value: "Compounding",
  label: "Compounding",
  name: "Compounding"
}];
const natureOfConstructionOption = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Addition Extension",
  label: "Addition Extension",
  name: "Addition Extension"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}, {
  value: "Revalidation/Time Extension",
  label: "Revalidation/Time Extension",
  name: "Revalidation/Time Extension"
}, {
  value: "Compounding",
  label: "Compounding",
  name: "Compounding"
}];
const natureOfConstructionOption2 = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Addition Extension",
  label: "Addition Extension",
  name: "Addition Extension"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}, {
  value: "Revalidation/Time Extension",
  label: "Revalidation/Time Extension",
  name: "Revalidation/Time Extension"
}, {
  value: "Compounding",
  label: "Compounding",
  name: "Compounding"
}];
const natureOfCompounding = [{
  value: "Compounding application SUO-MOTO",
  label: "Compounding application SUO-MOTO",
  name: "Compounding application SUO-MOTO"
}, {
  value: "In response to notice",
  label: "In response to notice",
  name: "In response to notice"
}];
const natureOfConstructionOptionComp = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Additional/Alteration/Revision",
  label: "Additional/Alteration/Revision",
  name: "Additional/Alteration/Revision"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}, {
  value: "Revalidation/Time Extension",
  label: "Revalidation/Time Extension",
  name: "Revalidation/Time Extension"
}, {
  value: "Compounding",
  label: "Compounding",
  name: "Compounding"
}];
const selfApprovalnatureOfConstruction = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Reconstruction",
  label: "Reconstruction",
  name: "Reconstruction"
}, {
  value: "Revision",
  label: "Revision",
  name: "Revision"
}, {
  value: "Revalidation",
  label: "Revalidation",
  name: "Revalidation"
}];
const residentialNatureOfConstructionOptions = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Additional/Alteration/Revision",
  label: "Additional/Alteration/Revision",
  name: "Additional/Alteration/Revision"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}];
const specialProjectOptions = [{
  value: "Building Design as per standard Drawing",
  label: "Building Design as per standard Drawing",
  name: "Building Design as per standard Drawing"
}, {
  value: "Standard condition as per Lease deed/freehold deed",
  label: "Standard condition as per Lease deed/freehold deed",
  name: "Standard condition as per Lease deed/freehold deed"
}, {
  value: "Other",
  label: "Other",
  name: "Other"
}];
const plotUseOptions = [{
  value: "Residential",
  label: "Residential",
  name: "Residential"
}, {
  value: "Commercial",
  label: "Commercial",
  name: "Commercial"
}, {
  value: "Educational",
  label: "Educational",
  name: "Educational"
}, {
  value: "Institutional",
  label: "Institutional",
  name: "Institutional"
}, {
  value: "Assembly",
  label: "Assembly",
  name: "Assembly"
}, {
  value: "Industrial",
  label: "Industrial",
  name: "Industrial"
}, {
  value: "Storage",
  label: "Storage",
  name: "Storage"
}];
const plotSubUseOptions = [{
  value: "Row Houses",
  label: "Row Houses",
  name: "Row Houses"
}, {
  value: "Semi detached",
  label: "Semi detached",
  name: "Semi detached"
}, {
  value: "Detached",
  label: "Detached",
  name: "Detached"
}];
const developmentAreaOption = [{
  value: "Built-up area",
  label: "Built-up area",
  name: "Built-up area"
}, {
  value: "Non-Built-up area",
  label: "Non-Built-up area",
  name: "Non-Built-up area"
}];
const planOnOptions = [{
  value: "Approved Schemes",
  label: "Approved Schemes",
  name: "Approved Schemes"
}, {
  value: "Private Approved Schemes",
  label: "Private Approved Schemes",
  name: "Private Approved Schemes"
}, {
  value: "Plot Area in 100 SqM built up residential land use",
  label: "Plot Area in 100 SqM built up residential land use",
  name: "Plot Area in 100 SqM built up residential land use"
}, {
  value: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
  label: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
  name: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const residentialPlanOnOptions = [{
  value: "Approved Schemes",
  label: "Approved Schemes",
  name: "Approved Schemes"
}, {
  value: "Private Approved Schemes",
  label: "Private Approved Schemes",
  name: "Private Approved Schemes"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const proposedSiteOptions = [{
  value: "Scheme Developed by Authority",
  label: "Scheme Developed by Authority",
  name: "Scheme Developed by Authority"
}, {
  value: "Scheme Approved by Authority",
  label: "Scheme Approved by Authority",
  name: "Scheme Approved by Authority"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const proposedSite = [{
  value: "Layout Developed by Authority",
  label: "Layout Developed by Authority",
  name: "Layout Developed by Authority"
}, {
  value: "Layout Approved by Authority",
  label: "Layout Approved by Authority",
  name: "Layout Approved by Authority"
}];
const statesName = [{
  value: "Andaman and Nicobar Islands",
  label: "Andaman and Nicobar Islands",
  name: "Andaman and Nicobar Islands"
}, {
  value: "Andhra Pradesh",
  label: "Andhra Pradesh",
  name: "Andhra Pradesh"
}, {
  value: "Arunachal Pradesh",
  label: "Arunachal Pradesh",
  name: "Arunachal Pradesh"
}, {
  value: "Assam",
  label: "Assam",
  name: "Assam"
}, {
  value: "Bihar",
  label: "Bihar",
  name: "Bihar"
}, {
  value: "Chandigarh",
  label: "Chandigarh",
  name: "Chandigarh"
}, {
  value: "Chhattisgarh",
  label: "Chhattisgarh",
  name: "Chhattisgarh"
}, {
  value: "Dadra & Nagar Haveli & Daman and Diu",
  label: "Dadra & Nagar Haveli & Daman and Diu",
  name: "Dadra & Nagar Haveli & Daman and Diu"
}, {
  value: "Delhi",
  label: "Delhi",
  name: "Delhi"
}, {
  value: "Goa",
  label: "Goa",
  name: "Goa"
}, {
  value: "Gujarat",
  label: "Gujarat",
  name: "Gujarat"
}, {
  value: "Haryana",
  label: "Haryana",
  name: "Haryana"
}, {
  value: "Himachal Pradesh",
  label: "Himachal Pradesh",
  name: "Himachal Pradesh"
}, {
  value: "Jammu and Kashmir",
  label: "Jammu and Kashmir",
  name: "Jammu and Kashmir"
}, {
  value: "Jharkhand",
  label: "Jharkhand",
  name: "Jharkhand"
}, {
  value: "Karnataka",
  label: "Karnataka",
  name: "Karnataka"
}, {
  value: "Kerala",
  label: "Kerala",
  name: "Kerala"
}, {
  value: "Ladakh",
  label: "Ladakh",
  name: "Ladakh"
}, {
  value: "Lakshadweep",
  label: "Lakshadweep",
  name: "Lakshadweep"
}, {
  value: "Madhya Pradesh",
  label: "Madhya Pradesh",
  name: "Madhya Pradesh"
}, {
  value: "Maharashtra",
  label: "Maharashtra",
  name: "Maharashtra"
}, {
  value: "Manipur",
  label: "Manipur",
  name: "Manipur"
}, {
  value: "Meghalaya",
  label: "Meghalaya",
  name: "Meghalaya"
}, {
  value: "Mizoram",
  label: "Mizoram",
  name: "Mizoram"
}, {
  value: "Nagaland",
  label: "Nagaland",
  name: "Nagaland"
}, {
  value: "Odisha",
  label: "Odisha",
  name: "Odisha"
}, {
  value: "Puducherry",
  label: "Puducherry",
  name: "Puducherry"
}, {
  value: "Punjab",
  label: "Punjab",
  name: "Punjab"
}, {
  value: "Rajasthan",
  label: "Rajasthan",
  name: "Rajasthan"
}, {
  value: "Sikkim",
  label: "Sikkim",
  name: "Sikkim"
}, {
  value: "Tamil Nadu",
  label: "Tamil Nadu",
  name: "Tamil Nadu"
}, {
  value: "Telangana",
  label: "Telangana",
  name: "Telangana"
}, {
  value: "Tripura",
  label: "Tripura",
  name: "Tripura"
}, {
  value: "Uttar Pradesh",
  label: "Uttar Pradesh",
  name: "Uttar Pradesh"
}, {
  value: "Uttarakhand",
  label: "Uttarakhand",
  name: "Uttarakhand"
}, {
  value: "West Bengal",
  label: "West Bengal",
  name: "West Bengal"
}];
const landUsesSchemeTypeList = [{
  value: "Residential",
  label: "Residential",
  name: "Residential"
}, {
  value: "Commercial",
  label: "Commercial",
  name: "Commercial"
}, {
  value: "Industrial",
  label: "Industrial",
  name: "Industrial"
}, {
  value: "Institutional",
  label: "Institutional",
  name: "Institutional"
}, {
  value: "Educational",
  label: "Educational",
  name: "Educational"
}, {
  value: "Community Facilities",
  label: "Community Facilities",
  name: "Community Facilities"
}, {
  value: "Health Facilities",
  label: "Health Facilities",
  name: "Health Facilities"
}, {
  value: "Offices",
  label: "Offices",
  name: "Offices"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const subUsesTypeList = [{
  value: "Built up area/Gramin Abadi",
  label: "Built up area/Gramin Abadi",
  name: "Built up area/Gramin Abadi"
}, {
  value: "Residential",
  label: "Residential",
  name: "Residential"
}];
const developmentPlans = [{
  value: "Master Plan",
  label: "Master Plan",
  name: "Master Plan"
}, {
  value: "Zonal Plan",
  label: "Zonal Plan",
  name: "Zonal Plan"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const subUseCommercialList = [{
  value: "City Center",
  label: "City Center",
  name: "City Center"
}, {
  value: "District Business Center",
  label: "District Business Center",
  name: "District Business Center"
}, {
  value: "Mixed LandUse - 1",
  label: "Mixed LandUse - 1",
  name: "Mixed LandUse - 1"
}, {
  value: "Mixed LandUse - 2",
  label: "Mixed LandUse - 2",
  name: "Mixed LandUse - 2"
}, {
  value: "Other Commercial",
  label: "Other Commercial",
  name: "Other Commercial"
}, {
  value: "Storage/Godown/Warehousing",
  label: "Storage/Godown/Warehousing",
  name: "Storage/Godown/Warehousing"
}, {
  value: "Sub-City Center",
  label: "Sub-City Center",
  name: "Sub-City Center"
}, {
  value: "Vehicle Sales-Purchase House / Workshop / Accessories Center",
  label: "Vehicle Sales-Purchase House / Workshop / Accessories Center",
  name: "Vehicle Sales-Purchase House / Workshop / Accessories Center"
}, {
  value: "Wholesale Business Center",
  label: "Wholesale Business Center",
  name: "Wholesale Business Center"
}];
const schemeTypeList = [{
  value: "Scheme",
  label: "Scheme",
  name: "Scheme"
}, {
  value: "Non Scheme",
  label: "Non Scheme",
  name: "Non Scheme"
}];
const permissionTypeList = [{
  value: "New",
  label: "New",
  name: "New"
}];
const schemeNameList = [{
  value: "Radhika Vihar Yojna no 1 Mathura",
  label: "Radhika Vihar Yojna no 1 Mathura",
  name: "Radhika Vihar Yojna no 1 Mathura"
}, {
  value: "Krishna Vihar Yojna no 2 Mathura",
  label: "Krishna Vihar Yojna no 2 Mathura",
  name: "Krishna Vihar Yojna no 2 Mathura"
}, {
  value: "Yojna NO 1 Mainpuri",
  label: "Yojna NO 1 Mainpuri",
  name: "Yojna NO 1 Mainpuri"
}, {
  value: "Kasganj Yojna",
  label: "Kasganj Yojna",
  name: "Kasganj Yojna"
}, {
  value: "Yojna no 1 Hathras",
  label: "Yojna no 1 Hathras",
  name: "Yojna no 1 Hathras"
}];
const farLandUseTypes = [{
  value: "Residential (Group Housing)",
  label: "Residential (Group Housing)",
  name: "Residential (Group Housing)"
}, {
  value: "Commercial",
  label: "Commercial",
  name: "Commercial"
}, {
  value: "Mixed land",
  label: "Mixed land",
  name: "Mixed land"
}, {
  value: "Office/Organization",
  label: "Office/Organization",
  name: "Office/Organization"
}, {
  value: "Hotel",
  label: "Hotel",
  name: "Hotel"
}, {
  value: "Community and Social facilities",
  label: "Community and Social facilities",
  name: "Community and Social facilities"
}];
const ResidentialUseList = [{
  value: "Residential Building Single Dwelling Unit",
  label: "Residential Building Single Dwelling Unit",
  name: "Residential Building Single Dwelling Unit"
}, {
  value: "Residential Group Housing",
  label: "Residential Group Housing",
  name: "Residential Group Housing"
}, {
  value: "Residentail Multi Unit",
  label: "Residentail Multi Unit",
  name: "Residentail Multi Unit"
}];
const landSubUseTypes = [{
  value: "Group Housing",
  label: "Group Housing",
  name: "Group Housing"
}, {
  value: "City Center/Central Business District",
  label: "City Center/Central Business District",
  name: "City Center/Central Business District"
}, {
  value: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  label: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  name: "Minicity center/Sub Central Buisness District/ Zonal Commercial center"
}, {
  value: "Other Commercial",
  label: "Other Commercial",
  name: "Other Commercial"
}, {
  value: "Hotel",
  label: "Hotel",
  name: "Hotel"
}, {
  value: "Fruit and Vegetable Mandi",
  label: "Fruit and Vegetable Mandi",
  name: "Fruit and Vegetable Mandi"
}, {
  value: "Other Wholesale business",
  label: "Other Wholesale business",
  name: "Other Wholesale business"
}, {
  value: "Grain Market",
  label: "Grain Market",
  name: "Grain Market"
}, {
  value: "Primary and Nursary School",
  label: "Primary and Nursary School",
  name: "Primary and Nursary School"
}, {
  value: "High School/Intermediate/College",
  label: "High School/Intermediate/College",
  name: "High School/Intermediate/College"
}, {
  value: "Degree College",
  label: "Degree College",
  name: "Degree College"
}, {
  value: "High School/Intermediate",
  label: "High School/Intermediate",
  name: "High School/Intermediate"
}, {
  value: "Techinical Management College",
  label: "Techinical Management College",
  name: "Techinical Management College"
}, {
  value: "Community facilities",
  label: "Community facilities",
  name: "Community facilities"
}, {
  value: "Community center, Marrige Palace and Religious Building",
  label: "Community center, Marrige Palace and Religious Building",
  name: "Community center, Marrige Palace and Religious Building"
}, {
  value: "Other Organization center",
  label: "Other Organization center",
  name: "Other Organization center"
}, {
  value: "Godown",
  label: "Godown",
  name: "Godown"
}, {
  value: "Building constrution material yard",
  label: "Building constrution material yard",
  name: "Building constrution material yard"
}, {
  value: "Clinic and Dispensary",
  label: "Clinic and Dispensary",
  name: "Clinic and Dispensary"
}, {
  value: "Nursing Home with 50 Beds Capacity",
  label: "Nursing Home with 50 Beds Capacity",
  name: "Nursing Home with 50 Beds Capacity"
}, {
  value: "Hospital more than 50 Beds",
  label: "Hospital more than 50 Beds",
  name: "Hospital more than 50 Beds"
}, {
  value: "Hospital upto 50 - 100 Beds",
  label: "Hospital upto 50 - 100 Beds",
  name: "Hospital upto 50 - 100 Beds"
}, {
  value: "Hospital more than 100 Beds",
  label: "Hospital more than 100 Beds",
  name: "Hospital more than 100 Beds"
}, {
  value: "Filling station",
  label: "Filling station",
  name: "Filling station"
}, {
  value: "Filling station cum service center",
  label: "Filling station cum service center",
  name: "Filling station cum service center"
}, {
  value: "Petrol Pump, Service Garage, Repair shop etc.",
  label: "Petrol Pump, Service Garage, Repair shop etc.",
  name: "Petrol Pump, Service Garage, Repair shop etc."
}];
const landSubUseTypes2 = [{
  value: "Group Housing",
  label: "Group Housing",
  name: "Group Housing"
}, {
  value: "City Center/Central Business District",
  label: "City Center/Central Business District",
  name: "City Center/Central Business District"
}, {
  value: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  label: "Minicity center/Sub Central Buisness District/ Zonal Commercial center",
  name: "Minicity center/Sub Central Buisness District/ Zonal Commercial center"
}, {
  value: "Other Commercial",
  label: "Other Commercial",
  name: "Other Commercial"
}, {
  value: "Plotted Development",
  label: "Plotted Development",
  name: "Plotted Development"
}, {
  value: "Hotel",
  label: "Hotel",
  name: "Hotel"
}, {
  value: "Fruit and Vegetable Mandi",
  label: "Fruit and Vegetable Mandi",
  name: "Fruit and Vegetable Mandi"
}, {
  value: "Other Wholesale business",
  label: "Other Wholesale business",
  name: "Other Wholesale business"
}, {
  value: "Grain Market",
  label: "Grain Market",
  name: "Grain Market"
}, {
  value: "Primary and Nursery School",
  label: "Primary and Nursery School",
  name: "Primary and Nursery School"
}, {
  value: "High School/Intermediate/College",
  label: "High School/Intermediate/College",
  name: "High School/Intermediate/College"
}, {
  value: "Degree College",
  label: "Degree College",
  name: "Degree College"
}, {
  value: "High School/Intermediate",
  label: "High School/Intermediate",
  name: "High School/Intermediate"
}, {
  value: "Techinical Management College",
  label: "Techinical Management College",
  name: "Techinical Management College"
}, {
  value: "Community facilities",
  label: "Community facilities",
  name: "Community facilities"
}, {
  value: "Community center, Marrige Palace and Religious Building",
  label: "Community center, Marrige Palace and Religious Building",
  name: "Community center, Marrige Palace and Religious Building"
}, {
  value: "Other Organization center",
  label: "Other Organization center",
  name: "Other Organization center"
}, {
  value: "Godown",
  label: "Godown",
  name: "Godown"
}, {
  value: "Building constrution material yard",
  label: "Building constrution material yard",
  name: "Building constrution material yard"
}, {
  value: "Clinic and Dispensary",
  label: "Clinic and Dispensary",
  name: "Clinic and Dispensary"
}, {
  value: "Nursing Home with 50 Beds Capacity",
  label: "Nursing Home with 50 Beds Capacity",
  name: "Nursing Home with 50 Beds Capacity"
}, {
  value: "Hospital more than 50 Beds",
  label: "Hospital more than 50 Beds",
  name: "Hospital more than 50 Beds"
}, {
  value: "Hospital upto 50 - 100 Beds",
  label: "Hospital upto 50 - 100 Beds",
  name: "Hospital upto 50 - 100 Beds"
}, {
  value: "Hospital more than 100 Beds",
  label: "Hospital more than 100 Beds",
  name: "Hospital more than 100 Beds"
}, {
  value: "Filling station",
  label: "Filling station",
  name: "Filling station"
}, {
  value: "Filling station cum service center",
  label: "Filling station cum service center",
  name: "Filling station cum service center"
}, {
  value: "Petrol Pump, Service Garage, Repair shop etc.",
  label: "Petrol Pump, Service Garage, Repair shop etc.",
  name: "Petrol Pump, Service Garage, Repair shop etc."
}];
const landUseList = [{
  value: "General Permissible",
  label: "General Permissible",
  name: "General Permissible"
}, {
  value: "Conditional Permissible",
  label: "Conditional Permissible",
  name: "Conditional Permissible"
}, {
  value: "Special Permissible",
  label: "Special Permissible",
  name: "Special Permissible"
}];
const yesNoRadioList = [{
  value: "Yes",
  label: "Yes",
  name: "Yes"
}, {
  value: "No",
  label: "No",
  name: "No"
}];
const solidWasteDisposal = [{
  value: "STP",
  label: "STP",
  name: "STP"
}, {
  value: "Septic",
  label: "Septic",
  name: "Septic"
}, {
  value: "Sewerage",
  label: "Sewerage",
  name: "Sewerage"
}];
const garbageCollection = [{
  value: "Private",
  label: "Private",
  name: "Private"
}, {
  value: "Government",
  label: "Government",
  name: "Government"
}];
const publicSewerageOrSepticTank = [{
  value: "Public Sewerage Plan",
  label: "Public Sewerage Plan",
  name: "Public Sewerage Plan"
}, {
  value: "Septic Tank",
  label: "Septic Tank",
  name: "Septic Tank"
}];
const farPayment = [{
  value: "Full Payment",
  label: "Full Payment",
  name: "Full Payment"
}, {
  value: "Installments",
  label: "Installments",
  name: "Installments"
}];
const nonCoreOther = [{
  value: "Core",
  label: "Core"
}, {
  value: "Non Core",
  label: "Non Core"
}, {
  value: "Other",
  label: "Other"
}, {
  value: "Restricted",
  label: "Restricted"
}, {
  value: "Green",
  label: "Green"
}, {
  value: "Heritage",
  label: "Heritage"
}, {
  value: "Sinking",
  label: "Sinking"
}, {
  value: "Sliding",
  label: "Sliding"
}];
const submittedNotSubmitted = [{
  value: "submitted",
  label: "Submitted"
}, {
  value: "notSubmitted",
  label: "Not Submitted"
}];
const constructionType = [{
  value: "Built Up",
  label: "Built Up"
}, {
  value: "Develop",
  label: "Develop"
}, {
  value: "Undevelop",
  label: "Undevelop"
}];
const genderData = [{
  value: "Male",
  label: "Male"
}, {
  value: "Female",
  label: "Female"
}, {
  value: "Transgender",
  label: "Transgender"
}];
const registrationTypes = [{
  value: "Architect",
  label: "Architect"
}, {
  value: "Town Planner",
  label: "Town Planner"
}, {
  value: "Graduate Civil Engineer",
  label: "Graduate Civil Engineer"
}, {
  value: "Supervisor",
  label: "Supervisor"
}, {
  value: "Structural Engineer",
  label: "Structural Engineer"
}, {
  value: "Landscape Architect",
  label: "Landscape Architect"
}, {
  value: "Urban Designer",
  label: "Urban Designer"
}, {
  value: "Engineers for Utility Services",
  label: "Engineers for Utility Services"
}];
const typeOfLandForDevelopment = [{
  value: "Commercial",
  label: "Commercial",
  name: "Commercial"
}, {
  value: "Industrial",
  label: "Industrial",
  name: "Industrial"
}, {
  value: "Residential",
  label: "Residential",
  name: "Residential"
}, {
  value: "PublicSemipublic",
  label: "Public Semi public",
  name: "Public Semi public"
}];
const typeOfConstructionResidential = [{
  value: "Row House",
  label: "Row House",
  name: "Row House"
}, {
  value: "Detach House",
  label: "Detach House",
  name: "Detach House"
}, {
  value: "Semi Detach House",
  label: "Semi Detach House",
  name: "Semi Detach House"
}];
const natureOfConstruction = [{
  value: "New",
  label: "New",
  name: "New"
}, {
  value: "Additional/Alteration",
  label: "Additional/Alteration",
  name: "Additional/Alteration"
}, {
  value: "Redevelopment/Reconstruction",
  label: "Redevelopment/Reconstruction",
  name: "Redevelopment/Reconstruction"
}, {
  value: "Standard Design",
  label: "Standard Design",
  name: "Standard Design"
}];
const typeOfConstructionCommercial = [{
  value: "Shops",
  label: "Shops",
  name: "Shops"
}, {
  value: "Shopping-Complex",
  label: "Shopping-Complex",
  name: "Shopping-Complex"
}, {
  value: "Tourism-Unit",
  label: "Tourism-Unit",
  name: "Tourism-Unit"
}, {
  value: "Cinema/Cineplex",
  label: "Cinema/Cineplex",
  name: "Cinema/Cineplex"
}, {
  value: "Multiplexes",
  label: "Multiplexes",
  name: "Multiplexes"
}, {
  value: "Multi-level parking",
  label: "Multi-level parking",
  name: "Multi-level parking"
}, {
  value: "Others",
  label: "Others",
  name: "Others"
}];
const typeOfConstructionIndustrial = [{
  value: "Small Scale Industries",
  label: "Small Scale Industries",
  name: "Small Scale Industries"
}, {
  value: "Services/ Light scale In-dustries",
  label: "Services/ Light scale In-dustries",
  name: "Services/ Light scale In-dustries"
}, {
  value: "Medium Scale Industries",
  label: "Medium Scale Industries",
  name: "Medium Scale Industries"
}, {
  value: "Large and Heavy Scale Industries",
  label: "Large and Heavy Scale Industries",
  name: "Large and Heavy Scale Industries"
}];
const typeOfConstructionPublic = [{
  value: "Educational Building",
  label: "Educational Building",
  name: "Educational Building"
}, {
  value: "Police Station, Fire Station Buildings",
  label: "Police Station, Fire Station Buildings",
  name: "Police Station, Fire Station Buildings"
}, {
  value: "Medical Buildings",
  label: "Medical Buildings",
  name: "Medical Buildings"
}, {
  value: "Community Hall",
  label: "Community Hall",
  name: "Community Hall"
}, {
  value: "Library/Religious Building",
  label: "Library/Religious Building",
  name: "Library/Religious Building"
}, {
  value: "Government-Semi Govern-ment offices Buildings",
  label: "Government-Semi Govern-ment offices Buildings",
  name: "Government-Semi Govern-ment offices Buildings"
}];
const useTypeList = [{
  value: "Commercial",
  label: "Commercial",
  name: "Commercial"
}, {
  value: "Industrial",
  label: "Industrial",
  name: "Industrial"
}, {
  value: "Public and Semi-Public",
  label: "PublicSemipublic",
  name: "Public and Semi-Public"
}, {
  value: "Residential",
  label: "Residential",
  name: "Residential"
}];
const typeOfCluInvolved = [{
  value: "For change of Land use from the original Use",
  label: "For change of Land use from the original Use"
}, {
  value: "IDP/Development plan to other land use",
  label: "IDP/Development plan to other land use"
}];
const statesData = [{
  value: "Andaman and Nicobar",
  label: "Andaman and Nicobar"
}, {
  value: "Andhra Pradesh",
  label: "Andhra Pradesh"
}, {
  value: "Arunachal Pradesh",
  label: "Arunachal Pradesh"
}, {
  value: "Assam",
  label: "Assam"
}, {
  value: "Bihar",
  label: "Bihar"
}, {
  value: "Chandigarh",
  label: "Chandigarh"
}, {
  value: "Chhattisgarh",
  label: "Chhattisgarh"
}, {
  value: "Delhi",
  label: "Delhi"
}, {
  value: "Goa",
  label: "Goa"
}, {
  value: "Gujarat",
  label: "Gujarat"
}, {
  value: "Haryana",
  label: "Haryana"
}, {
  value: "Uttar Pradesh",
  label: "Uttar Pradesh"
}, {
  value: "Jharkhand",
  label: "Jharkhand"
}, {
  value: "Karnataka",
  label: "Karnataka"
}, {
  value: "Kerala",
  label: "Kerala"
}, {
  value: "Madhya Pradesh",
  label: "Madhya Pradesh"
}, {
  value: "Maharashtra",
  label: "Maharashtra"
}, {
  value: "Manipur",
  label: "Manipur"
}, {
  value: "Meghalaya",
  label: "Meghalaya"
}, {
  value: "Mizoram",
  label: "Mizoram"
}, {
  value: "Nagaland",
  label: "Nagaland"
}, {
  value: "Odisha",
  label: "Odisha"
}, {
  value: "Puducherry",
  label: "Puducherry"
}, {
  value: "Punjab",
  label: "Punjab"
}, {
  value: "Rajasthan",
  label: "Rajasthan"
}, {
  value: "Sikkim",
  label: "Sikkim"
}, {
  value: "Tamil Nadu",
  label: "Tamil Nadu"
}, {
  value: "Telangana",
  label: "Telangana"
}, {
  value: "Tripura",
  label: "Tripura"
}, {
  value: "Uttar Pradesh",
  label: "Uttar Pradesh"
}, {
  value: "Uttarakhand",
  label: "Uttarakhand"
}, {
  value: "West Bengal",
  label: "West Bengal"
}];
const paymentStatus = [{
  value: "Not Done",
  label: "Not Done",
  name: "Not Done"
}, {
  value: "Under Process",
  label: "Under Process",
  name: "Under Process"
}];
const registryStatus = [{
  value: "Not Done",
  label: "Not Done",
  name: "Not Done"
}, {
  value: "Under Process",
  label: "Under Process",
  name: "Under Process"
}, {
  value: "Done",
  label: "Done",
  name: "Done"
}];
const uptodatePaymentStatus = [{
  value: "Outstanding",
  label: "Outstanding",
  name: "Outstanding"
}, {
  value: "Running",
  label: "Running",
  name: "Running"
}, {
  value: "Full Payment",
  label: "Full Payment",
  name: "Full Payment"
}];
const TypeOfLetter = [{
  value: "Approval",
  label: "Approval",
  name: "Approval"
}, {
  value: "Shortfall",
  label: "Shortfall",
  name: "Shortfall"
}, {
  value: "Rejected",
  label: "Rejected",
  name: "Rejected"
}];
const proposalOptionsPlotted = [{
  value: "Layout Development",
  label: "Layout Development",
  name: "Layout Development"
}];
const proposalOptions = [{
  value: "Plot sub-division",
  label: "Plot sub-division",
  name: "Plot sub-division"
}, {
  value: "Building Permission",
  label: "Building Permission",
  name: "Building Permission"
}, {
  value: "Amalgamation",
  label: "Amalgamation",
  name: "Amalgamation"
}];
const groupHousingOrMultiUnits = [{
  value: "Group Housing",
  label: "Group Housing",
  name: "Group Housing"
}, {
  value: "Multi Units",
  label: "Multi Units",
  name: "Multi Units"
}];

const StyledRadioGroup = styled(RadioGroup)(({
  theme
}) => ({
  columnGap: theme.spacing(1),
  alignItems: "center",
  minHeight: 40
}));
const RadioButton = ({
  row,
  data,
  control,
  name,
  width,
  defaultValue,
  clickControl,
  validation,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(StyledRadioGroup, {
      "aria-labelledby": "radio-buttons-group-label",
      value: value || defaultValue,
      name: name || "radio-buttons-group",
      row: row,
      onChange: clickControl,
      sx: {
        width: width || "18.25vw",
        translate: "-8px 0"
      }
    }, data === null || data === void 0 ? void 0 : data.map(item => {
      return /*#__PURE__*/React__default.createElement(FormControlLabel, {
        sx: {
          margin: 0
        },
        key: item === null || item === void 0 ? void 0 : item.value,
        value: (item === null || item === void 0 ? void 0 : item.value) || value,
        control: /*#__PURE__*/React__default.createElement(Radio, null),
        label: item === null || item === void 0 ? void 0 : item.label,
        onChange: onChange,
        disabled: disabled
      });
    }), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const FormInfo = styled(Box)(() => ({
  backgroundColor: '#fff7cb',
  margin: '2rem auto 0',
  padding: '1.5rem'
}));
const SubTabsWrapper = styled(Box)(({
  theme
}) => ({
  backgroundColor: '#F2F2F2',
  height: '8vh',
  display: 'flex',
  alignItems: 'center',
  '& .container1': {
    justifyContent: 'space-between',
    marginBlock: theme.spacing(4),
    alignItems: 'center',
    display: 'flex'
  }
}));
const MainTabs = styled(Tabs)(() => ({
  marginInline: 'auto'
}));
const MainTab = styled(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    color: '#1F4A7C',
    outline: 'none'
  },
  '&.Mui-selected': {
    backgroundColor: '#1F4A7C',
    color: 'white'
  }
}));
const SubTabs = styled(Tabs)(() => ({
  '&.Mui-selected': {
    backgroundColor: '#5CB85C',
    color: 'white'
  }
}));
const SubTab = styled(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    outline: 'none',
    fontSize: '1.25rem',
    fontWeight: '400'
  },
  '&.Mui-selected': {
    color: '#1F4A7C',
    borderBottom: '4px solid #1F4A7C',
    fontSize: '1.25rem',
    fontWeight: '600'
  }
}));
const MandatoryInfo = styled(Box)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: 'red',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18
  }
}));
const InfoBox = styled(Box)(() => ({
  lineHeight: 1.5,
  fontSize: '16px',
  color: '#1F4A7C',
  padding: '8px 16px',
  backgroundColor: '#f0f4fa',
  borderRadius: '1px',
  fontWeight: '600',
  marginLeft: '30px',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18
  }
}));
const StyledMenuItem = styled(MenuItem$2)(() => ({
  '&.MuiMenuItem-root': {
    padding: '0.25rem 0.75rem',
    display: 'block'
  }
}));
const accordionSummaryStyles = {
  backgroundColor: 'rgb(230, 239, 248)',
  height: '1rem',
  minHeight: '48px',
  '&.Mui-expanded': {
    backgroundColor: 'rgb(230, 239, 248)',
    minHeight: '48px',
    height: '1rem'
  }
};

const SelectWrapper = ({
  label,
  inputLabel,
  data: _data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled: _disabled = false,
  validation,
  isRequired
}) => {
  console.log("fromSelectInput", width);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name || "name",
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw"
      },
      size: "small",
      disabled: _disabled,
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Select$2, {
      displayEmpty: true,
      value: value || defaultValue || "",
      onChange: onChange,
      autoWidth: autoWidth,
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      size: "small",
      variant: "outlined",
      required: isRequired,
      input: /*#__PURE__*/React__default.createElement(OutlinedInput, null),
      renderValue: selected => {
        if (selected.length === 0) {
          return /*#__PURE__*/React__default.createElement("em", null, placeholder);
        }
        return selected;
      },
      inputProps: {
        "aria-label": "Without label"
      }
    }, /*#__PURE__*/React__default.createElement(StyledMenuItem, {
      disabled: true,
      value: ""
    }, /*#__PURE__*/React__default.createElement("em", null, placeholder)), Array.isArray(_data) && (_data === null || _data === void 0 ? void 0 : _data.map(item => {
      const dropdowns = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.i18nKey);
      return /*#__PURE__*/React__default.createElement(StyledMenuItem, {
        value: dropdowns,
        key: dropdowns
      }, dropdowns);
    }))), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      color: "error"
    }, error.message), helperText && !error && /*#__PURE__*/React__default.createElement(FormHelperText, null, helperText))
  });
};

const TextInput = ({
  children,
  select,
  width,
  height,
  multiline,
  control,
  name,
  defaultValue,
  validation,
  isRequired,
  ...rest
}) => {
  console.log("isRequired", name, isRequired);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    rules: validation,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TextField, Object.assign({
      sx: {
        ...(width && {
          minWidth: width
        }),
        ...(height && {
          minHeight: height
        }),
        marginRight: select ? "1rem" : 0
      },
      name: name,
      onChange: onChange,
      select: select,
      multiline: multiline,
      value: value || defaultValue || "",
      minRows: multiline ? 3 : 0,
      maxRows: multiline ? 3 : 0,
      error: !!error,
      required: isRequired
    }, rest), children), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const UploadButton = ({
  error
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    color: "primary",
    "aria-label": "upload picture",
    component: "label"
  }, /*#__PURE__*/React__default.createElement("input", {
    hidden: true,
    accept: "image/*",
    type: "file"
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
    className: "img",
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, error));
};

const formatDate = date => {
  return dayjs(date).format('YYYY-MM-DD');
};
const DatePick = ({
  label,
  defaultValue,
  control,
  name,
  width,
  validation
}) => {
  var _validation$required;
  const [reqDate, setReqDate] = useState(null);
  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate(defaultValue)));
    }
  }, [defaultValue]);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    defaultValue: reqDate,
    rules: {
      ...((validation === null || validation === void 0 ? void 0 : (_validation$required = validation.required) === null || _validation$required === void 0 ? void 0 : _validation$required.value) && {
        validate: value => {
          var _validation$required2;
          return !!value || (validation === null || validation === void 0 ? void 0 : (_validation$required2 = validation.required) === null || _validation$required2 === void 0 ? void 0 : _validation$required2.message);
        }
      })
    },
    control: control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DatePicker$1, {
      label: label,
      value: value ? dayjs(value) : reqDate,
      sx: {
        width: width ? width : "18.25vw",
        borderRadius: '1px'
      },
      onChange: event => {
        if (event) {
          const formattedDate = formatDate(event);
          onChange(formattedDate);
        } else {
          onChange(null);
        }
      },
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField, Object.assign({
        size: "small"
      }, params, {
        error: !!error,
        helperText: error ? error.message : null,
        sx: {
          width: width ? width : "18.25vw",
          borderRadius: '1px'
        }
      }))
    })), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const TimePick = ({
  label,
  variant,
  disabled,
  defaultValue,
  placeholder,
  InputProps,
  size,
  fullWidth,
  color,
  helperText,
  children,
  select,
  width,
  multiline,
  control,
  name,
  height
}) => {
  const [reqTime, setreqTime] = useState(new Date());
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        ...restField
      }
    }) => /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DemoContainer, {
      components: ['MobileTimePicker']
    }, /*#__PURE__*/React__default.createElement(DemoItem, null, /*#__PURE__*/React__default.createElement(MobileTimePicker, {
      slotProps: {
        textField: {
          size: 'small'
        }
      },
      label: label,
      onChange: event => {
        onChange(event);
        setreqTime(event);
      },
      sx: {
        width: width ? width : '18.25vw'
      },
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField, Object.assign({
        size: "small"
      }, params))
    }))))
  });
};

const InputContainer = ({
  label,
  width,
  height,
  disabled: _disabled = false,
  selectSuffix: _selectSuffix = null,
  hasLabel: _hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine: _multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  autoWidth,
  isRequired
}) => {
  console.log("fromInputcontainer", validation, name);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `inputContainer ${containerClasses}`,
    style: containerStyles
  }, _hasLabel && type !== "defaultCheckbox" && /*#__PURE__*/React__default.createElement("h3", {
    className: `label ${multiColumn ? "multiCoumn" : ""}`,
    style: {
      width: labelWidth && labelWidth
    }
  }, label, mandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), type === "textInput" ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "1vw",
      width: width || "18.25vw"
    }
  }, _selectSuffix && /*#__PURE__*/React__default.createElement(SelectWrapper, Object.assign({
    variant: "outlined",
    width: "6vw",
    size: "small"
  }, _selectSuffix, {
    defaultValue: _selectSuffix === null || _selectSuffix === void 0 ? void 0 : _selectSuffix.defaultValue,
    validation: validation
  })), /*#__PURE__*/React__default.createElement(TextInput, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || (_selectSuffix ? "11.25vw" : "18.25vw"),
    height: height,
    name: name,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: _multiLine,
    isRequired: isRequired,
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      endAdornment: showSearchIcon &&
      /*#__PURE__*/
      React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        onClick: onSearchClick
      }, /*#__PURE__*/React__default.createElement(Search$1, null)))
    },
    validation: validation,
    inputProps: {
      maxLength
    }
  }, !_selectSuffix && data && select && (data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: option.value,
    value: option.value
  }, option.label))))) : type === "radioButton" ? /*#__PURE__*/React__default.createElement(RadioButton, {
    defaultValue: defaultValue,
    clickControl: clickControl,
    control: control,
    width: width,
    data: data,
    name: name,
    row: true,
    validation: validation,
    disabled: _disabled
  }) : type === "selectInput" ? /*#__PURE__*/React__default.createElement(SelectWrapper, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue,
    inputLabel: placeholder,
    width: width,
    label: label,
    data: data,
    name: name,
    autoWidth: autoWidth,
    disabled: _disabled,
    validation: validation,
    isRequired: isRequired,
    InputProps: {
      style: {
        borderRadius: "1px"
      }
    }
  }) : type === "upload" ? /*#__PURE__*/React__default.createElement(UploadButton, {
    error: uploadValidity
  }) : type === "htmlUpload" ? /*#__PURE__*/React__default.createElement("div", {
    className: "uploadHtml"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return getDocumentData(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    }
  }), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, uploadValidity)) : type === "datePicker" ? /*#__PURE__*/React__default.createElement(DatePick, {
    placeholder: placeholder,
    control: control,
    name: name,
    width: width,
    validation: validation
  }) : type === "timePicker" ? /*#__PURE__*/React__default.createElement(TimePick, {
    control: control,
    label: label,
    name: name
  }) : type === "number" ? /*#__PURE__*/React__default.createElement(TextInput, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    type: "number",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    defaultValue: defaultValue,
    inputProps: {
      step: "any",
      min: 0,
      max: {
        maxLength
      }
    },
    InputProps: {
      style: {
        borderRadius: "1px"
      }
    }
  }) : type === "checkbox" ? /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Controller, {
      name: name,
      control: control,
      defaultValue: defaultValue,
      render: ({
        field: {
          onChange,
          value
        }
      }) => /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: value,
        onChange: e => {
          onChange(e.target.checked);
        },
        disabled: _disabled
      })
    }),
    label: label
  }) : type === "defaultCheckbox" ? /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: name,
      checked: defaultValue,
      disabled: _disabled
    }),
    label: label
  }) : "");
};

function Address({
  applicationFlow,
  defaultValues,
  namePrefix,
  control,
  watch,
  setValue
}) {
  var _districtData$filter, _districtData$filter$;
  const permanentAddressKey = 'landInfo.owners[0].permanentAddress';
  const isPermanentAddress = namePrefix === permanentAddressKey;
  const [watchCorrespondenceAddress, watchCorrespondenceDistrict, watchCorrespondenceTehsil, watchPermanentDistrict, watchPermanentTehsil] = watch(['landInfo.owners[0].correspondenceAddress', 'landInfo.owners[0].correspondenceAddress.district', 'landInfo.owners[0].correspondenceAddress.tehsil', 'landInfo.owners[0].permanentAddress.district', 'landInfo.owners[0].permanentAddress.tehsil']);
  const handleSameAsCorrespondence = e => {
    if (e.target.checked) {
      setValue(permanentAddressKey, watchCorrespondenceAddress);
      setValue('landInfo.owners[0].permanentAddress.type', "PERMANENT");
    } else {
      setValue(permanentAddressKey, {
        applicantName: '',
        applicantGuardianName: '',
        state: 'Uttar Pradesh',
        district: '',
        tehsil: '',
        town: '',
        address: '',
        pinno: '',
        type: isPermanentAddress ? "PERMANENT" : "CORRESPONDENCE"
      });
    }
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const districtList = !isDistrictDataLoading ? districtData === null || districtData === void 0 ? void 0 : (_districtData$filter = districtData.filter(district => {
    var _district$code;
    return district === null || district === void 0 ? void 0 : (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes(applicationFlow.toLowerCase());
  })) === null || _districtData$filter === void 0 ? void 0 : (_districtData$filter$ = _districtData$filter[0]) === null || _districtData$filter$ === void 0 ? void 0 : _districtData$filter$.boundary : [];
  const [correspondenceTehsilList, setCorrespondenceTehsilList] = useState([]);
  const [permanentTehsilList, setPermanentTehsilList] = useState([]);
  useEffect(() => {
    if (watchCorrespondenceDistrict) {
      var _districtList$find;
      const tehsilList = (_districtList$find = districtList.find(item => item.name === watchCorrespondenceDistrict)) === null || _districtList$find === void 0 ? void 0 : _districtList$find.boundary;
      setCorrespondenceTehsilList(tehsilList);
    }
  }, [watchCorrespondenceDistrict]);
  useEffect(() => {
    if (watchPermanentDistrict) {
      var _districtList$find2;
      const tehsilList = (_districtList$find2 = districtList.find(item => item.name === watchPermanentDistrict)) === null || _districtList$find2 === void 0 ? void 0 : _districtList$find2.boundary;
      setPermanentTehsilList(tehsilList);
    }
  }, [watchPermanentDistrict]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, isPermanentAddress ? /*#__PURE__*/React__default.createElement("div", {
    className: "checkboxWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Permanent Address"), /*#__PURE__*/React__default.createElement("label", {
    style: {
      alignItems: 'center',
      width: '18.25vw',
      marginBottom: 0,
      display: 'flex',
      gap: '0.5rem',
      translate: '-8px 0'
    }
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    onChange: handleSameAsCorrespondence
  }), "Same as Corr. Address")) : /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Correspondence Address"), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Name",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.applicantName,
    name: `${namePrefix}.applicantName`,
    type: "textInput",
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Father/Guardian Name",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.applicantGuardianName,
    name: `${namePrefix}.applicantGuardianName`,
    type: "textInput",
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "State",
    defaultValue: 'Uttar Pradesh',
    name: `${namePrefix}.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: districtList,
    label: "District",
    placeholder: watchPermanentDistrict && 'District' || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.district) || 'District',
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.district,
    name: `${namePrefix}.district`,
    type: "selectInput",
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Tehsil",
    placeholder: (isPermanentAddress ? watchPermanentTehsil : watchCorrespondenceTehsil) && 'Tehsil' || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.tehsil) || 'Tehsil',
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.tehsil,
    name: `${namePrefix}.tehsil`,
    type: "textInput",
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Town/Village/Ward",
    placeholder: "Enter Town/Village/Ward",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.town,
    name: `${namePrefix}.town`,
    type: "textInput",
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Address",
    placeholder: "Enter Address",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.address,
    name: `${namePrefix}.address`,
    type: "textInput",
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Pincode",
    placeholder: "Enter Pincode",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.pinno,
    name: `${namePrefix}.pinno`,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }));
}

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

const {
  toString
} = Object.prototype;
const {
  getPrototypeOf
} = Object;
const kindOf = (cache => thing => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));
const kindOfTest = type => {
  type = type.toLowerCase();
  return thing => kindOf(thing) === type;
};
const typeOfTest = type => thing => typeof thing === type;
const {
  isArray
} = Array;
const isUndefined = typeOfTest('undefined');
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest('ArrayBuffer');
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
const isString = typeOfTest('string');
const isFunction = typeOfTest('function');
const isNumber = typeOfTest('number');
const isObject = thing => thing !== null && typeof thing === 'object';
const isBoolean = thing => thing === true || thing === false;
const isPlainObject = val => {
  if (kindOf(val) !== 'object') {
    return false;
  }
  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$1 = kindOfTest('Date');
const isFile = kindOfTest('File');
const isBlob = kindOfTest('Blob');
const isFileList = kindOfTest('FileList');
const isStream = val => isObject(val) && isFunction(val.pipe);
const isFormData = thing => {
  let kind;
  return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);
const trim = str => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
function forEach(obj, fn, {
  allOwnKeys = false
} = {}) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  let i;
  let l;
  if (typeof obj !== 'object') {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey$1(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = context => !isUndefined(context) && context !== _global;
function merge() {
  const {
    caseless
  } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey$1(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}
const extend = (a, b, thisArg, {
  allOwnKeys
} = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {
    allOwnKeys
  });
  return a;
};
const stripBOM = content => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = thing => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = (TypedArray => {
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};
const hasOwnProperty = (({
  hasOwnProperty
}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = obj => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = arr => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const DIGIT = '0123456789';
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {
    length
  } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const toJSONObject = obj => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = undefined;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = thing => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({
      source,
      data
    }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return cb => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : cb => setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;
var utils = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey: findKey$1,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};

function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype = AxiosError.prototype;
const descriptors = {};
['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL'].forEach(code => {
  descriptors[code] = {
    value: code
  };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
  value: true
});
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);
  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};

var httpAdapter = null;

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }
  formData = formData || new ( FormData)();
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);
  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }
  function convertValue(value) {
    if (value === null) return '';
    if (utils.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }
    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils.isArray(value) && isFlatArray(value) || (utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils.isUndefined(value)) return;
    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }
    stack.push(value);
    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers);
      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }
  build(obj);
  return formData;
}

function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData(params, this, options);
}
const prototype$1 = AxiosURLSearchParams.prototype;
prototype$1.append = function append(name, value) {
  this._pairs.push([name, value]);
};
prototype$1.toString = function toString(encoder) {
  const _encode = encoder ? function (value) {
    return encoder.call(this, value, encode);
  } : encode;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode$1;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const hasStandardBrowserEnv = (product => {
  return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0;
})(typeof navigator !== 'undefined' && navigator.product);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils$1 = {
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv: hasStandardBrowserEnv,
  origin: origin
};

var platform$1 = {
  ...utils$1,
  ...platform
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform$1.classes.URLSearchParams(), Object.assign({
    visitor: function (value, key, path, helpers) {
      if (platform$1.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

function parsePropPath(name) {
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === '__proto__') return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }
    const result = buildPath(path, value, target[name], index);
    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ['xhr', 'http', 'fetch'],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);
    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData = utils.isFormData(data);
    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data) || utils.isReadableStream(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }
    let isFileList;
    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(isFileList ? {
          'files[]': data
        } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';
    if (utils.isResponse(data) || utils.isReadableStream(data)) {
      return data;
    }
    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform$1.classes.FormData,
    Blob: platform$1.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};
utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], method => {
  defaults.headers[method] = {};
});

const ignoreDuplicateOf = utils.toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);
var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });
  return parsed;
});

const $internals = Symbol('internals');
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = str => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils.isString(value)) return;
  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }
  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);
  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function (arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }
      const key = utils.findKey(self, lHeader);
      if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
        self[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils.findKey(self, _header);
        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];
          deleted = true;
        }
      }
    }
    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format) {
    const self = this;
    const headers = {};
    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);
      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self[header];
      }
      self[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = Object.create(null);
    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }
  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach(target => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }
    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);
utils.reduceDescriptors(AxiosHeaders.prototype, ({
  value
}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils.freezeMethods(AxiosHeaders);

function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });
  headers.normalize();
  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

function CanceledError(message, config, request) {
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}
utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError('Request failed with status code ' + response.status, [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== undefined ? min : 1000;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [loaded => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = fn => (...args) => utils.asap(() => fn(...args));

var isURLSameOrigin = platform$1.hasStandardBrowserEnv ? function standardBrowserEnv() {
  const msie = /(msie|trident)/i.test(navigator.userAgent);
  const urlParsingNode = document.createElement('a');
  let originURL;
  function resolveURL(url) {
    let href = url;
    if (msie) {
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin(requestURL) {
    const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var cookies = platform$1.hasStandardBrowserEnv ? {
  write(name, value, expires, path, domain, secure) {
    const cookie = [name + '=' + encodeURIComponent(value)];
    utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
    utils.isString(path) && cookie.push('path=' + path);
    utils.isString(domain) && cookie.push('domain=' + domain);
    secure === true && cookie.push('secure');
    document.cookie = cookie.join('; ');
  },
  read(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
    return match ? decodeURIComponent(match[3]) : null;
  },
  remove(name) {
    this.write(name, '', Date.now() - 86400000);
  }
} : {
  write() {},
  read() {
    return null;
  },
  remove() {}
};

function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = thing => thing instanceof AxiosHeaders ? {
  ...thing
} : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({
        caseless
      }, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };
  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}

var resolveConfig = (config => {
  const newConfig = mergeConfig({}, config);
  let {
    data,
    withXSRFToken,
    xsrfHeaderName,
    xsrfCookieName,
    headers,
    auth
  } = newConfig;
  newConfig.headers = headers = AxiosHeaders.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
  if (auth) {
    headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
  }
  let contentType;
  if (utils.isFormData(data)) {
    if (platform$1.hasStandardBrowserEnv || platform$1.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }
  if (platform$1.hasStandardBrowserEnv) {
    withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
});

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let {
      responseType,
      onUploadProgress,
      onDownloadProgress
    } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ('onloadend' in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    requestData === undefined && requestHeaders.setContentType(null);
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener('progress', downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener('progress', uploadThrottled);
      request.upload.addEventListener('loadend', flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform$1.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  let controller = new AbortController();
  let aborted;
  const onabort = function (cancel) {
    if (!aborted) {
      aborted = true;
      unsubscribe();
      const err = cancel instanceof Error ? cancel : this.reason;
      controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
    }
  };
  let timer = timeout && setTimeout(() => {
    onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
  }, timeout);
  const unsubscribe = () => {
    if (signals) {
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach(signal => {
        signal && (signal.removeEventListener ? signal.removeEventListener('abort', onabort) : signal.unsubscribe(onabort));
      });
      signals = null;
    }
  };
  signals.forEach(signal => signal && signal.addEventListener && signal.addEventListener('abort', onabort));
  const {
    signal
  } = controller;
  signal.unsubscribe = unsubscribe;
  return [signal, () => {
    timer && clearTimeout(timer);
    timer = null;
  }];
};

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize, encode) {
  for await (const chunk of iterable) {
    yield* streamChunk(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish, encode) => {
  const iterator = readBytes(stream, chunkSize, encode);
  let bytes = 0;
  let done;
  let _onFinish = e => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const {
          done,
          value
        } = await iterator.next();
        if (done) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? (encoder => str => encoder.encode(str))(new TextEncoder()) : async str => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform$1.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    }
  }).headers.has('Content-Type');
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils.isReadableStream(new Response('').body));
const resolvers = {
  stream: supportsResponseStream && (res => res.body)
};
isFetchSupported && (res => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils.isFunction(res[type]) ? res => res[type]() : (_, config) => {
      throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async body => {
  if (body == null) {
    return 0;
  }
  if (utils.isBlob(body)) {
    return body.size;
  }
  if (utils.isSpecCompliantForm(body)) {
    return (await new Request(body).arrayBuffer()).byteLength;
  }
  if (utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils.isURLSearchParams(body)) {
    body = body + '';
  }
  if (utils.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
var fetchAdapter = isFetchSupported && (async config => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + '').toLowerCase() : 'text';
  let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? composeSignals([signal, cancelToken], timeout) : [];
  let finished, request;
  const onFinish = () => {
    !finished && setTimeout(() => {
      composedSignal && composedSignal.unsubscribe();
    });
    finished = true;
  };
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress)));
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush, encodeText);
      }
    }
    if (!utils.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: withCredentials
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
      const options = {};
      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [];
      response = new Response(trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
        flush && flush();
        isStreamResponse && onFinish();
      }, encodeText), options);
    }
    responseType = responseType || 'text';
    let responseData = await resolvers[utils.findKey(resolvers, responseType) || 'text'](response, config);
    !isStreamResponse && onFinish();
    stopTimeout && stopTimeout();
    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    onFinish();
    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request), {
        cause: err.cause || err
      });
    }
    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {
        value
      });
    } catch (e) {}
    Object.defineProperty(fn, 'adapterName', {
      value
    });
  }
});
const renderReason = reason => `- ${reason}`;
const isResolvedHandle = adapter => utils.isFunction(adapter) || adapter === null || adapter === false;
var adapters = {
  getAdapter: adapters => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];
    const {
      length
    } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(([id, state]) => `adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
      let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
      throw new AxiosError(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
  },
  adapters: knownAdapters
};

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders.from(config.headers);
  config.data = transformData.call(config, config.transformRequest);
  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(config, config.transformResponse, response);
    response.headers = AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}

const VERSION = "1.7.4";

const validators = {};
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
const deprecatedWarnings = {};
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), AxiosError.ERR_DEPRECATED);
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }
    return validator ? validator(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
var validator = {
  assertOptions,
  validators
};

const validators$1 = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;
        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {}
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const {
      transitional,
      paramsSerializer,
      headers
    } = config;
    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators$1.transitional(validators$1.boolean),
        forcedJSONParsing: validators$1.transitional(validators$1.boolean),
        clarifyTimeoutError: validators$1.transitional(validators$1.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators$1.function,
          serialize: validators$1.function
        }, true);
      }
    }
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();
    let contextHeaders = headers && utils.merge(headers.common, headers[config.method]);
    headers && utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], method => {
      delete headers[method];
    });
    config.headers = AxiosHeaders.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then(cancel => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = onfulfilled => {
      let _resolve;
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context, {
    allOwnKeys: true
  });
  utils.extend(instance, context, null, {
    allOwnKeys: true
  });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.CanceledError = CanceledError;
axios$1.CancelToken = CancelToken;
axios$1.isCancel = isCancel;
axios$1.VERSION = VERSION;
axios$1.toFormData = toFormData;
axios$1.AxiosError = AxiosError;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$1.mergeConfig = mergeConfig;
axios$1.AxiosHeaders = AxiosHeaders;
axios$1.formToJSON = thing => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
axios$1.getAdapter = adapters.getAdapter;
axios$1.HttpStatusCode = HttpStatusCode;
axios$1.default = axios$1;

function FileUploader$1({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  maxWidth,
  alignLabelTop = false,
  required,
  tab
}) {
  const {
    documents
  } = useSelector(state => state.form12);
  const dispatch = useDispatch();
  const {
    addForm12Doc,
    removeForm12Doc
  } = bindActionCreators(form12DocActions, dispatch);
  const fileInputRef = useRef(null);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleFileUpload = async (file, inputName) => {
    setIsLoading(true);
    setShowToast(null);
    fileInputRef.current.value = null;
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    if (tab === 1) {
      const allowedFormats = [".png", ".jpg", ".jpeg", ".pdf", ".JPG", ".PNG", ".JPEG", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.png, .jpg, .jpeg, .pdf)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 10 MB."
        });
        setIsLoading(false);
        return;
      }
    } else {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file in a pdf format"
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 30 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 30 MB."
        });
        setIsLoading(false);
        return;
      }
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addForm12Doc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      ...(alignLabelTop && {
        alignItems: 'flex-start'
      })
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: `label`
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      p: '0.5rem 0.75rem 0.375rem',
      borderRadius: '0.25rem',
      flexDirection: 'column',
      position: 'relative',
      width: maxWidth || '18.25vw',
      display: 'flex'
    }
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: 'center',
      position: 'absolute',
      alignItems: 'center',
      display: 'flex',
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : null, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return handleFileUpload(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    },
    style: {
      maxWidth: '100%'
    },
    required: required && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name)),
    ref: fileInputRef
  }), /*#__PURE__*/React__default.createElement("small", {
    className: "error",
    style: {
      wordBreak: 'break-all'
    }
  }, validationMsg), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label), !isLoading && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: '100%',
      display: 'flex',
      mb: 0.5,
      mt: 1
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map(doc => {
    var _doc$additionalDetail;
    if (!(name in documents) && doc.documentType !== name) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: 'space-between',
        p: '0.25rem 0 0.25rem 0.75rem',
        backgroundColor: '#eee',
        borderRadius: '0.25rem',
        wordBreak: 'break-all',
        fontSize: '0.875rem',
        alignItems: 'center',
        display: 'flex',
        lineHeight: 1,
        flex: 1
      },
      key: doc.fileStoreId
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      onClick: () => removeForm12Doc(doc.documentType)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  })) || null)));
}

const StyledFormControl = styled(FormControl$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  display: "flex"
}));
const StyledFormLabel = styled(FormLabel)(({
  theme
}) => ({
  color: theme.palette.grey[900],
  minWidth: theme.spacing(18),
  marginBottom: 0
}));
const StyledFormControlLabel = styled(FormControlLabel$1)(() => ({
  margin: 0
}));
const StyledRadioGroup$1 = styled(RadioGroup$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  alignItems: "center",
  width: "18.25vw",
  minHeight: 40
}));
function useDepartmentSelector() {
  var _Digit;
  const [applicationFlow, setApplicationFlow] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null);
  const handleDepartmentOnChange = ({
    target: {
      value
    }
  }) => {
    var _Digit2;
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("CITIZEN.COMMON.HOME.FLOW", value);
    setApplicationFlow(value);
  };
  return [applicationFlow === "DA", applicationFlow, () => /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, applicationFlow === null && /*#__PURE__*/React__default.createElement(StyledFormControl, null, /*#__PURE__*/React__default.createElement(StyledFormLabel, null, "Department ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement(StyledRadioGroup$1, {
    onChange: handleDepartmentOnChange,
    "aria-labelledby": "departments-list",
    name: "department",
    row: true
  }, departmentList === null || departmentList === void 0 ? void 0 : departmentList.map(item => {
    return /*#__PURE__*/React__default.createElement(StyledFormControlLabel, {
      control: /*#__PURE__*/React__default.createElement(Radio$1, null),
      value: item === null || item === void 0 ? void 0 : item.value,
      label: item === null || item === void 0 ? void 0 : item.label,
      key: item === null || item === void 0 ? void 0 : item.name
    });
  }))))))];
}

const Step1 = ({
  formData,
  handleTabChange
}) => {
  var _formData$blocks, _formData$blocks$, _formData$blocks$$set, _Digit$SessionStorage, _edcrData$planDetail, _currLocality$localna, _SubOccupancyData$BPA, _SubOccupancyData$BPA2, _formData$cluInvolved, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$cluInvolved2, _formData$landInfo3, _formData$landInfo3$a, _formData$landInfo4, _formData$landInfo4$a, _formData$landInfo5, _formData$landInfo5$a, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$blocks2, _planDeatail$parkingD, _setBacksData$frontYa, _setBacksData$frontYa2, _setBacksData$rearYar, _setBacksData$rearYar2, _setBacksData$sideYar, _setBacksData$sideYar2, _setBacksData$sideYar3, _setBacksData$sideYar4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.form12);
  const dispatch = useDispatch();
  const {
    resetForm12Docs
  } = bindActionCreators(form12DocActions, dispatch);
  const setBacksData = formData === null || formData === void 0 ? void 0 : (_formData$blocks = formData.blocks) === null || _formData$blocks === void 0 ? void 0 : (_formData$blocks$ = _formData$blocks[0]) === null || _formData$blocks$ === void 0 ? void 0 : (_formData$blocks$$set = _formData$blocks$.setBacks) === null || _formData$blocks$$set === void 0 ? void 0 : _formData$blocks$$set[0];
  const stateCode = Digit.ULBService.getStateId();
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const planDeatail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const planInformation = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : _edcrData$planDetail.planInformation;
  const bizServ = "BPA";
  const currentCity = JSON.parse(sessionStorage.getItem("currentCity") || null);
  const currLocality = JSON.parse(sessionStorage.getItem("currLocality") || null);
  const currVillage = JSON.parse(sessionStorage.getItem("currVillage") || null);
  const localityName = (currLocality === null || currLocality === void 0 ? void 0 : (_currLocality$localna = currLocality.localname) === null || _currLocality$localna === void 0 ? void 0 : _currLocality$localna.trim()) || '';
  const applicationType = "FORM_12";
  const {
    isMdmsLoading,
    data: SubOccupancyData
  } = Digit.Hooks.obps.useMDMS(stateCode, bizServ, ["SubOccupancyType"]);
  const subOccupancyList = !isMdmsLoading && (SubOccupancyData === null || SubOccupancyData === void 0 ? void 0 : (_SubOccupancyData$BPA = SubOccupancyData.BPA) === null || _SubOccupancyData$BPA === void 0 ? void 0 : (_SubOccupancyData$BPA2 = _SubOccupancyData$BPA.SubOccupancyType) === null || _SubOccupancyData$BPA2 === void 0 ? void 0 : _SubOccupancyData$BPA2.map(ob => {
    var _ob$code;
    return {
      code: ob.code,
      name: ob.name,
      i18nKey: `BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(ob === null || ob === void 0 ? void 0 : (_ob$code = ob.code) === null || _ob$code === void 0 ? void 0 : _ob$code.toUpperCase(), "-", "_")}`
    };
  })) || null;
  const [selectedSubOccupancy, setSelectedSubOccupancy] = useState((formData === null || formData === void 0 ? void 0 : formData.subOccupancy) || []);
  const [isSubdivisionApproved, setIsSubdivisionApproved] = useState(formData === null || formData === void 0 ? void 0 : formData.whetherSubdivisionApproved);
  const [isAncestralProperty, setIsAncestralProperty] = useState(formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty);
  const [cluInvolvedName, setIsChangeOfLandInvolved] = useState(formData === null || formData === void 0 ? void 0 : (_formData$cluInvolved = formData.cluInvolved) === null || _formData$cluInvolved === void 0 ? void 0 : _formData$cluInvolved.name);
  const [aadhaarNumber, setAadhaarNumber] = useState((formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.aadhaarNumber) || null);
  const [gender, setGender] = useState((formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.gender) || null);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const khasraTableEntry = {
    plotNo: null,
    plotarea: null,
    landType: null
  };
  const khasraAreaEntry = {
    khasra: null,
    area: null
  };
  const defaultValues = {
    ...formData,
    khasraArea: (formData === null || formData === void 0 ? void 0 : formData.khasraArea) || [khasraAreaEntry],
    whetherSubdivisionApproved: (formData === null || formData === void 0 ? void 0 : formData.whetherSubdivisionApproved) || isSubdivisionApproved,
    isAncestralProperty: (formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty) || isAncestralProperty,
    subOccupancy: selectedSubOccupancy,
    cluInvolved: {
      name: (formData === null || formData === void 0 ? void 0 : (_formData$cluInvolved2 = formData.cluInvolved) === null || _formData$cluInvolved2 === void 0 ? void 0 : _formData$cluInvolved2.name) || cluInvolvedName
    },
    landDevelopment: (formData === null || formData === void 0 ? void 0 : formData.landDevelopment) || [khasraTableEntry]
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const [watchTypeOfCLUInvolved, watchAppliedLandUse, watchAadhaarNumber, watchGender, watchCluInvolved] = watch(['cluType.code', 'typeofArea', 'landInfo.owners[0].aadhaarNumber', 'landInfo.owners[0].gender', 'cluInvolved.name']);
  const {
    fields: khasraArea,
    append,
    remove
  } = useFieldArray({
    control,
    name: "khasraArea"
  });
  const {
    fields: landDevelopment,
    append: appendTable,
    remove: removeTable
  } = useFieldArray({
    control,
    name: "landDevelopment"
  });
  const watchPlotArea = watch("khasraArea");
  const watchKhasraTable = watch("landDevelopment");
  const khasraWithAreaFields = khasraArea.map((field, index) => {
    return {
      ...field,
      ...watchPlotArea[index]
    };
  });
  const khasraTableFields = landDevelopment.map((field, index) => {
    return {
      ...field,
      ...watchKhasraTable[index]
    };
  });
  useEffect(async () => {
    const decodedLocality = decodeURIComponent(localityName.replace(/\+/g, ' '));
    const fetchBusinessService = await Digit.LocationService.getBusinessServices(currentCity === null || currentCity === void 0 ? void 0 : currentCity.name, decodedLocality, applicationType, applicationFlow);
    setValue("businessService", fetchBusinessService);
  }, []);
  useEffect(() => {
    setValue('subOccupancy', selectedSubOccupancy);
  }, [selectedSubOccupancy]);
  useEffect(() => {
    setAadhaarNumber(watchAadhaarNumber);
  }, [watchAadhaarNumber]);
  useEffect(() => {
    setGender(watchGender);
  }, [watchGender]);
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const handleIsSubdivisionApproved = event => {
    const val = event.target.value;
    setValue('whetherSubdivisionApproved', val);
    setIsSubdivisionApproved(val);
  };
  const handleIsAncestralProperty = event => {
    const val = event.target.value;
    setValue('isAncestralProperty', val);
    setIsAncestralProperty(val);
  };
  useEffect(() => {
    if (watchCluInvolved === 'no') {
      setValue("cluType", null);
      setValue("landDevelopment", [khasraTableEntry]);
    }
  }, [watchCluInvolved]);
  const handlePropertyType = event => {
    setValue('propertyType', event.target.value);
  };
  const handleGenderSelection = event => {
    setValue('landInfo.owners[0].gender', event.target.value);
  };
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_PARKINGAREA",
    id: "ParkingArea"
  }];
  const typeOfConstructionMap = {
    Residential: typeOfConstructionResidential,
    Commercial: typeOfConstructionCommercial,
    Industrial: typeOfConstructionIndustrial,
    "Public Semi public": typeOfConstructionPublic
  };
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        ParkingArea: ob.parking.floorWiseParkingArea !== null ? ob.parking.floorWiseParkingArea : ob.parking.floorWiseExistingParkingArea,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Hierarchy Details of Area")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('City')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, (currentCity === null || currentCity === void 0 ? void 0 : currentCity.name) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.district) || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$a = _formData$landInfo3.address) === null || _formData$landInfo3$a === void 0 ? void 0 : _formData$landInfo3$a.city))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(isUdFlow ? "Scheme Name" : "Scheme Name")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, isUdFlow ? (currLocality === null || currLocality === void 0 ? void 0 : currLocality.name) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.office) || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$a = _formData$landInfo4.address) === null || _formData$landInfo4$a === void 0 ? void 0 : _formData$landInfo4$a.doorNo) : (currLocality === null || currLocality === void 0 ? void 0 : currLocality.name) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.planningArea) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.specialArea) || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$a = _formData$landInfo5.address) === null || _formData$landInfo5$a === void 0 ? void 0 : _formData$landInfo5$a.doorNo))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(isUdFlow ? "Unit" : "Unit")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, isUdFlow ? currentCity === null || currentCity === void 0 ? void 0 : currentCity.Unit : currentCity === null || currentCity === void 0 ? void 0 : currentCity.Unit))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Owner Name "), /*#__PURE__*/React__default.createElement("th", null, "Father/Guardian Name  "), /*#__PURE__*/React__default.createElement("th", null, "Owner Mobile No. "), /*#__PURE__*/React__default.createElement("th", null, "Owner Email "), /*#__PURE__*/React__default.createElement("th", null, "Aadhaar No."), /*#__PURE__*/React__default.createElement("th", null, "Gender "))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.name,
    name: "landInfo.owners[0].name",
    type: "textInput",
    hasLabel: false,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Guardian Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : _formData$landInfo7$o2.fatherOrHusbandName,
    disabled: !!(formData !== null && formData !== void 0 && (_formData$landInfo8 = formData.landInfo) !== null && _formData$landInfo8 !== void 0 && (_formData$landInfo8$o = _formData$landInfo8.owners) !== null && _formData$landInfo8$o !== void 0 && (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) !== null && _formData$landInfo8$o2 !== void 0 && _formData$landInfo8$o2.fatherOrHusbandName),
    name: "landInfo.owners[0].fatherOrHusbandName",
    type: "textInput",
    hasLabel: false,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Mobile No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : _formData$landInfo9$o2.mobileNumber,
    disabled: !!(formData !== null && formData !== void 0 && (_formData$landInfo10 = formData.landInfo) !== null && _formData$landInfo10 !== void 0 && (_formData$landInfo10$ = _formData$landInfo10.owners) !== null && _formData$landInfo10$ !== void 0 && (_formData$landInfo10$2 = _formData$landInfo10$[0]) !== null && _formData$landInfo10$2 !== void 0 && _formData$landInfo10$2.mobileNumber),
    name: "landInfo.owners[0].mobileNumber",
    type: "textInput",
    hasLabel: false,
    mobileNumber: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('MobileNo'),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Email",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : _formData$landInfo11$2.emailId,
    disabled: !!(formData !== null && formData !== void 0 && (_formData$landInfo12 = formData.landInfo) !== null && _formData$landInfo12 !== void 0 && (_formData$landInfo12$ = _formData$landInfo12.owners) !== null && _formData$landInfo12$ !== void 0 && (_formData$landInfo12$2 = _formData$landInfo12$[0]) !== null && _formData$landInfo12$2 !== void 0 && _formData$landInfo12$2.emailId),
    name: "landInfo.owners[0].emailId",
    type: "textInput",
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Email'),
        message: "Please enter valid email id"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Aadhaar No.",
    defaultValue: aadhaarNumber,
    name: "landInfo.owners[0].aadhaarNumber",
    type: "textInput",
    hasLabel: false,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern('AadharNo'),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Gender",
    defaultValue: gender,
    name: `landInfo.owners[0].gender`,
    type: "radioButton",
    data: genderData,
    clickControl: handleGenderSelection,
    hasLabel: false
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Photo & Signature")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    name: "OwnerPhoto",
    label: "Owner Photo",
    validationMsg: "(jpg,jpeg,png,pdf file only and Max file Size 10 MB)",
    required: true,
    tab: 1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    name: "signature",
    label: "Signature",
    validationMsg: "(jpg,jpeg,png,pdf file only and Max file Size 10 MB)",
    required: true,
    tab: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Contact Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Address, {
    defaultValues: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : _formData$landInfo13$2.correspondenceAddress,
    namePrefix: 'landInfo.owners[0].correspondenceAddress',
    applicationFlow,
    setValue,
    control,
    watch
  }), /*#__PURE__*/React__default.createElement(Address, {
    defaultValues: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : _formData$landInfo14$2.permanentAddress,
    namePrefix: 'landInfo.owners[0].permanentAddress',
    applicationFlow,
    setValue,
    control,
    watch
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      paddingLeft: "100"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Description of land proposed for Development of Land/Construction of Building")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: '5px 5px 0 0',
      borderBottom: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: isUdFlow ? "Mohal/Muzza/Phati/Up Mohal" : "Revenue Village/Mohal",
    control: control,
    placeholder: "Enter Village Name.",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillageMohal,
    name: "revenueVillageMohal",
    type: "textInput",
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Khatauni No.",
    control: control,
    placeholder: "Enter Khatauni No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khatauniNo,
    name: "khatauniNo",
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Khata No.",
    control: control,
    placeholder: "Enter Khata No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khataNo,
    name: "khataNo",
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Latitude/Longitude",
    control: control,
    placeholder: "Enter Latitude/Longitude",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.latLong,
    name: "latLong",
    type: "textInput",
    maxLength: 20
  }))), khasraWithAreaFields.map((field, index) => /*#__PURE__*/React__default.createElement(Box, {
    key: field.id,
    className: "formInputContainer endAdornment"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Khasra No.",
    placeholder: "Enter Khasra No.",
    defaultValue: field.khasra,
    name: `khasraArea.${index}.khasra`,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper append"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Area (Sq.M)",
    placeholder: "Enter Area (Sq.M)",
    defaultValue: field.area,
    name: `khasraArea.${index}.area`,
    type: "textInput",
    maxLength: 10,
    width: `calc(18.25vw - ${index === 0 ? '40px' : '80px'})`,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "adornment"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "info",
    "aria-label": "Add more",
    onClick: () => append(khasraAreaEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)), (khasraArea === null || khasraArea === void 0 ? void 0 : khasraArea.length) > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => remove(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: '0',
      borderBottom: 0,
      borderTopColor: '#eee'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Total Plot Area (Sq.m)",
    name: "plotArea",
    type: "textInput",
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Plot Area for Sub-division/Development Activity(sq.m) ",
    control: control,
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.totalPlotArea,
    name: "totalPlotArea",
    type: "textInput",
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: '0',
      borderBottom: 0,
      borderTopColor: '#eee'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: yesNoNA,
    label: "Whether Subdivision Approved",
    defaultValue: isSubdivisionApproved,
    name: "whetherSubdivisionApproved",
    type: "radioButton",
    clickControl: handleIsSubdivisionApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), isSubdivisionApproved === 'yes' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "No. of Plot",
    placeholder: "Enter No. of Plot",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlot,
    name: "noOfPlot",
    type: "textInput",
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Amount'),
        message: "Please enter valid Numbers"
      }
    }
  })) : isUdFlow && isAncestralProperty === 'yes' && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    name: "ancestralProperty",
    label: "Ancestral Property document Upload",
    validationMsg: "(pdf file only and Max file Size 10 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Premium FAR",
    placeholder: "Enter Premium FAR",
    name: "premiumFAR",
    type: "textInput",
    defaultValue: `${formData === null || formData === void 0 ? void 0 : formData.premiumFAR}`,
    disabled: true
  }), isSubdivisionApproved === 'yes' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Case Reference No.",
    placeholder: "Enter Case Reference No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.caseReferenceNo,
    name: "caseReferenceNo",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), isUdFlow && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    isMandatory: true,
    control: control,
    name: "subdivisionApprovalSupporting",
    label: "Subdivision approval supporting document",
    validationMsg: "(pdf file only and Max file Size 10 MB)"
  })) : isUdFlow && isSubdivisionApproved === 'no' && /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: yesOrNo,
    label: "Whether Property is ancestral",
    defaultValue: isAncestralProperty,
    name: "isAncestralProperty",
    type: "radioButton",
    clickControl: handleIsAncestralProperty,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: '0 0 5px 5px',
      borderTopColor: '#eee'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: typeOfLandForDevelopment,
    label: "Applied land use",
    placeholder: watchAppliedLandUse && 'Applied land use' || (formData === null || formData === void 0 ? void 0 : formData.typeofArea) || 'Applied land use',
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.typeofArea,
    name: 'typeofArea',
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Type of Construction",
    placeholder: "Select Type",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    name: "constructionType",
    type: "selectInput",
    data: typeOfConstructionMap[watchAppliedLandUse],
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: proposalSubmittedFor,
    label: "Proposal submitted for",
    placeholder: (formData === null || formData === void 0 ? void 0 : formData.proposal) || 'Select',
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposal,
    name: "proposal",
    type: formData !== null && formData !== void 0 && formData.proposal ? "textInput" : "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Maximum Permissible Ground Coverage (In Sq.mt.)",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.maximumPermissibleGroundCoverage,
    name: "maximumPermissibleGroundCoverage",
    type: "textInput",
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: propertyTypeList,
    label: "Property Type",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.propertyType,
    name: "propertyType",
    type: "radioButton",
    clickControl: handlePropertyType,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Builtup Area")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "formInputContainer",
    sx: {
      flexDirection: 'column !important',
      alignItems: 'stretch !important',
      borderRadius: '5px 5px 0 0 !important',
      borderBottomColor: '#eee !important',
      overflow: 'visible !important'
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "text-bold",
    label: `${t("No. of Blocks")}`,
    text: formData === null || formData === void 0 ? void 0 : formData.noOfBlocks
  })), formData === null || formData === void 0 ? void 0 : (_formData$blocks2 = formData.blocks) === null || _formData$blocks2 === void 0 ? void 0 : _formData$blocks2.map((block, index) => /*#__PURE__*/React__default.createElement(Box, {
    key: index,
    sx: {
      marginBlock: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      marginBottom: "8px",
      paddingBottom: "9px",
      color: "#0B0C0C",
      fontSize: "18px",
      lineHeight: "19px"
    }
  }, t("BPA_BLOCK_SUBHEADER"), " ", block.number), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      paddingInline: 5
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    labelStyle: {
      lineHeight: 2.5
    },
    textStyle: {
      wordBreak: "break-word"
    },
    label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
    text:  /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MultiSelectDropdown, {
      BlockNumber: block.number,
      className: "form-field",
      isMandatory: true,
      defaultUnit: "Selected",
      selected: selectedSubOccupancy,
      options: subOccupancyList,
      onSelect: e => setSelectedSubOccupancy(e.map(o => o === null || o === void 0 ? void 0 : o[1])),
      isOBPSMultiple: true,
      optionsKey: "i18nKey",
      ServerStyle: {
        width: "100%",
        overflowX: "hidden"
      },
      t: t
    }), (selectedSubOccupancy === null || selectedSubOccupancy === void 0 ? void 0 : selectedSubOccupancy.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "tag-container"
    }, selectedSubOccupancy.map((value, index) => /*#__PURE__*/React__default.createElement(RemoveableTag, {
      key: index,
      text: `${t(value["i18nKey"])}`,
      onClick: () => {
        const filteredData = [...selectedSubOccupancy].filter(item => item.code !== value.code);
        setSelectedSubOccupancy(filteredData);
      }
    }))), /*#__PURE__*/React__default.createElement(LinkButton, {
      style: {
        textAlign: "left"
      },
      label: "Clear All",
      onClick: () => setSelectedSubOccupancy([])
    })))
  })), /*#__PURE__*/React__default.createElement(Table, {
    className: "customTable table-fixed-first-column table-border-style",
    t: t,
    disableSort: false,
    autoSort: true,
    manualPagination: false,
    isPaginationRequired: false,
    initSortId: "S N ",
    data: getFloorData(block),
    columns: tableColumns,
    getCellProps: cellInfo => {
      return {
        style: {}
      };
    }
  })))), /*#__PURE__*/React__default.createElement(Box, {
    className: "formInputContainer",
    sx: {
      borderRadius: '0 !important',
      borderBlock: '0 !important'
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      marginLeft: '2px',
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none mb-0 pb-0",
    label: t("BPA_APPLICATION_DEMOLITION_AREA_LABEL"),
    text: !!(formData !== null && formData !== void 0 && formData.demolitionArea) ? `${formData.demolitionArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React__default.createElement("h4", {
    style: {
      margin: '10px',
      fontSize: '18px',
      fontWeight: '600'
    }
  }, "Parking Area Details"), /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "Area Type"), /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right"
  }, "Value"))), /*#__PURE__*/React__default.createElement(TableBody, null, (planDeatail === null || planDeatail === void 0 ? void 0 : (_planDeatail$parkingD = planDeatail.parkingDetails) === null || _planDeatail$parkingD === void 0 ? void 0 : _planDeatail$parkingD.parkingMap) && Object.entries(planDeatail.parkingDetails.parkingMap).map(([key, value]) => /*#__PURE__*/React__default.createElement(TableRow, {
    key: key
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, key), /*#__PURE__*/React__default.createElement(TableCell, {
    align: "right"
  }, value)))))), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      paddingInline: '1.65rem',
      borderInline: '1px solid gray'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none mb-0",
    label: t("BPA_APPLICATION_SETBACKS_INFORMATION"),
    text: ""
  })), /*#__PURE__*/React__default.createElement(Box, {
    className: "formInputContainer",
    sx: {
      borderRadius: '0 0 5px 5px !important',
      borderTopColor: '#eee !important'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("BPA_SETBACLS_TYPE_FRONT_LABEL"),
    placeholder: `Enter ${t("BPA_SETBACLS_TYPE_FRONT_LABEL")}`,
    defaultValue: setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$frontYa = setBacksData.frontYard) === null || _setBacksData$frontYa === void 0 ? void 0 : _setBacksData$frontYa.minimumDistance,
    name: "setBacks.front",
    type: "textInput",
    mandatory: true,
    disabled: !!(setBacksData !== null && setBacksData !== void 0 && (_setBacksData$frontYa2 = setBacksData.frontYard) !== null && _setBacksData$frontYa2 !== void 0 && _setBacksData$frontYa2.minimumDistance)
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("BPA_SETBACKS_TYPE_REAR_LABEL"),
    placeholder: `Enter ${t("BPA_SETBACKS_TYPE_REAR_LABEL")}`,
    defaultValue: setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$rearYar = setBacksData.rearYard) === null || _setBacksData$rearYar === void 0 ? void 0 : _setBacksData$rearYar.minimumDistance,
    name: "setBacks.rear",
    type: "textInput",
    mandatory: true,
    disabled: !!(setBacksData !== null && setBacksData !== void 0 && (_setBacksData$rearYar2 = setBacksData.rearYard) !== null && _setBacksData$rearYar2 !== void 0 && _setBacksData$rearYar2.minimumDistance)
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("BPA_SETBACKS_TYPE_LEFT_LABEL"),
    placeholder: `Enter ${t("BPA_SETBACKS_TYPE_LEFT_LABEL")}`,
    defaultValue: setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar = setBacksData.sideYard1) === null || _setBacksData$sideYar === void 0 ? void 0 : _setBacksData$sideYar.minimumDistance,
    name: "setBacks.left",
    type: "textInput",
    mandatory: true,
    disabled: !!(setBacksData !== null && setBacksData !== void 0 && (_setBacksData$sideYar2 = setBacksData.sideYard1) !== null && _setBacksData$sideYar2 !== void 0 && _setBacksData$sideYar2.minimumDistance)
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("BPA_SETBACKS_TYPE_RIGHT_LABEL"),
    placeholder: `Enter ${t("BPA_SETBACKS_TYPE_RIGHT_LABEL")}`,
    defaultValue: setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar3 = setBacksData.sideYard2) === null || _setBacksData$sideYar3 === void 0 ? void 0 : _setBacksData$sideYar3.minimumDistance,
    name: "setBacks.right",
    type: "textInput",
    mandatory: true,
    disabled: !!(setBacksData !== null && setBacksData !== void 0 && (_setBacksData$sideYar4 = setBacksData.sideYard2) !== null && _setBacksData$sideYar4 !== void 0 && _setBacksData$sideYar4.minimumDistance)
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => {
      setSelectedSubOccupancy([]);
      resetForm12Docs();
      reset();
    }
  })))));
};

const inputWidth = 200;
const Step2 = ({
  formData,
  handleTabChange
}) => {
  var _formData$landInfo, _checklistdata$regula, _checklistdata$setBac, _checklistdata$regula2, _checklistdata$setBac2, _checklistdata$regula3, _checklistdata$setBac3, _checklistdata$regula4, _checklistdata$setBac4, _checklistdata$nhregu, _checklistdata$nhsetB, _checklistdata$nhregu2, _checklistdata$nhsetB2, _checklistdata$nhregu3, _checklistdata$nhsetB3, _checklistdata$nhregu4, _checklistdata$nhsetB4;
  const {
    documents
  } = useSelector(state => state.form12);
  const dispatch = useDispatch();
  const {
    resetForm12Docs
  } = bindActionCreators(form12DocActions, dispatch);
  const checklistdata = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.checklistdata;
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    reset
  } = useForm({
    defaultValues
  });
  const [watchWhetherHtLtLineCrossing, watchWhetherNearbyAsiMonument, watchWhetherNearbyHfl, watchWhetherTreesOnPlot, watchWhetherAbuttingForestBoundary, watchWhetherAbuttingHighway, watchWhetherAbuttingNaturalDrainage, watchWhetherSeweragePassingThrough, watchWhetherAboveRoadLevel, watchWhetherSlidingArea, watchWhetherAirportPermissionRequired] = watch(["landInfo.checklistdata.whetherHtLtLineCrossing", "landInfo.checklistdata.whetherNearbyAsiMonument", "landInfo.checklistdata.whetherNearbyHfl", "landInfo.checklistdata.whetherTreesOnPlot", "landInfo.checklistdata.whetherAbuttingForestBoundary", "landInfo.checklistdata.whetherAbuttingHighway", "landInfo.checklistdata.whetherAbuttingNaturalDrainage", "landInfo.checklistdata.whetherSeweragePassingThrough", "landInfo.checklistdata.whetherAboveRoadLevel", "landInfo.checklistdata.whetherSlidingArea", "landInfo.checklistdata.whetherAirportPermissionRequired"]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = formData => {
    handleTabChange(2, formData);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Case Checklist")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Sr. No."), /*#__PURE__*/React__default.createElement("th", null, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("th", null, "As proposed"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Relaxation"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Type of Area"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "selectInput",
    control: control,
    name: "landInfo.checklistdata.typeOfArea_regulated",
    data: nonCoreOther,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.typeOfArea_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "selectInput",
    control: control,
    name: "landInfo.checklistdata.typeOfArea",
    data: nonCoreOther,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.typeOfArea
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.typeOfArea_remarks,
    name: "landInfo.checklistdata.typeOfArea_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.typeOfArea_relaxation,
    name: "landInfo.checklistdata.typeOfArea_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Total Plot Area(in sq.m)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.regulatedPlotArea",
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedPlotArea
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plotAreaForSubdivision",
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plotAreaForSubdivision
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plotAreaForSubdivision_remarks,
    name: "landInfo.checklistdata.plotAreaForSubdivision_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plotAreaForSubdivision_relaxation,
    name: "landInfo.checklistdata.plotAreaForSubdivision_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Ownership & Revenue documents"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.ownershipRevenueDocuments",
    data: submittedNotSubmitted,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.ownershipRevenueDocuments
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.ownershipRevenueDocuments_remarks,
    name: "landInfo.checklistdata.ownershipRevenueDocuments_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.ownershipRevenueDocuments_relaxation,
    name: "landInfo.checklistdata.ownershipRevenueDocuments_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Land-use"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedLandUse,
    placeholder: "Enter Use Type",
    name: "landInfo.checklistdata.regulatedLandUse"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.landUse,
    placeholder: "Enter Use Type",
    name: "landInfo.checklistdata.landUse"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.landUse_remarks,
    name: "landInfo.checklistdata.landUse_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.landUse_relaxation,
    name: "landInfo.checklistdata.landUse_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "F.A.R."), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.permissableFar) || (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedFAR),
    name: "landInfo.checklistdata.regulatedFAR"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.far,
    name: "landInfo.checklistdata.far"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.far_remarks,
    name: "landInfo.checklistdata.far_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.far_relaxation,
    name: "landInfo.checklistdata.far_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Built up area (in sq.mt.)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.regulatedBuildUpArea",
    defaultValue: (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.totalCoverageArea) || (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedBuildUpArea)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.builtupArea",
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.builtupArea
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.builtupArea_remarks,
    name: "landInfo.checklistdata.builtupArea_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.builtupArea_relaxation,
    name: "landInfo.checklistdata.builtupArea_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: "top"
    }
  }, "7"), /*#__PURE__*/React__default.createElement("td", null, "Setbacks(meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$regula = checklistdata.regulatedsetBacks) === null || _checklistdata$regula === void 0 ? void 0 : _checklistdata$regula.front,
    name: "landInfo.checklistdata.regulatedsetBacks.front"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$setBac = checklistdata.setBacks) === null || _checklistdata$setBac === void 0 ? void 0 : _checklistdata$setBac.front,
    name: "landInfo.checklistdata.setBacks.front"
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.setBacks_remarks,
    name: "landInfo.checklistdata.setBacks_remarks",
    placeholder: "Enter Remarks",
    height: 50
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.setBacks_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.setBacks_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$regula2 = checklistdata.regulatedsetBacks) === null || _checklistdata$regula2 === void 0 ? void 0 : _checklistdata$regula2.rear,
    name: "landInfo.checklistdata.regulatedsetBacks.rear"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$setBac2 = checklistdata.setBacks) === null || _checklistdata$setBac2 === void 0 ? void 0 : _checklistdata$setBac2.rear,
    name: "landInfo.checklistdata.setBacks.rear"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$regula3 = checklistdata.regulatedsetBacks) === null || _checklistdata$regula3 === void 0 ? void 0 : _checklistdata$regula3.left,
    name: "landInfo.checklistdata.regulatedsetBacks.left"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$setBac3 = checklistdata.setBacks) === null || _checklistdata$setBac3 === void 0 ? void 0 : _checklistdata$setBac3.left,
    name: "landInfo.checklistdata.setBacks.left"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$regula4 = checklistdata.regulatedsetBacks) === null || _checklistdata$regula4 === void 0 ? void 0 : _checklistdata$regula4.right,
    name: "landInfo.checklistdata.regulatedsetBacks.right"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$setBac4 = checklistdata.setBacks) === null || _checklistdata$setBac4 === void 0 ? void 0 : _checklistdata$setBac4.right,
    name: "landInfo.checklistdata.setBacks.right"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: "top"
    }
  }), /*#__PURE__*/React__default.createElement("td", null, "Whether Construction abuts with N.H Set Backs (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhregu = checklistdata.nhregulatedsetBacks) === null || _checklistdata$nhregu === void 0 ? void 0 : _checklistdata$nhregu.front,
    name: "landInfo.checklistdata.nhregulatedsetBacks.front"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhsetB = checklistdata.nhsetBacks) === null || _checklistdata$nhsetB === void 0 ? void 0 : _checklistdata$nhsetB.front,
    name: "landInfo.checklistdata.nhsetBacks.front"
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nhsetBacks_remarks,
    name: "landInfo.checklistdata.nhsetBacks_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.nhsetBacks_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nhsetBacks_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhregu2 = checklistdata.nhregulatedsetBacks) === null || _checklistdata$nhregu2 === void 0 ? void 0 : _checklistdata$nhregu2.rear,
    name: "landInfo.checklistdata.nhregulatedsetBacks.rear"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhsetB2 = checklistdata.nhsetBacks) === null || _checklistdata$nhsetB2 === void 0 ? void 0 : _checklistdata$nhsetB2.rear,
    name: "landInfo.checklistdata.nhsetBacks.rear"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhregu3 = checklistdata.nhregulatedsetBacks) === null || _checklistdata$nhregu3 === void 0 ? void 0 : _checklistdata$nhregu3.left,
    name: "landInfo.checklistdata.nhregulatedsetBacks.left"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhsetB3 = checklistdata.nhsetBacks) === null || _checklistdata$nhsetB3 === void 0 ? void 0 : _checklistdata$nhsetB3.left,
    name: "landInfo.checklistdata.nhsetBacks.left"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhregu4 = checklistdata.nhregulatedsetBacks) === null || _checklistdata$nhregu4 === void 0 ? void 0 : _checklistdata$nhregu4.right,
    name: "landInfo.checklistdata.nhregulatedsetBacks.right"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : (_checklistdata$nhsetB4 = checklistdata.nhsetBacks) === null || _checklistdata$nhsetB4 === void 0 ? void 0 : _checklistdata$nhsetB4.right,
    name: "landInfo.checklistdata.nhsetBacks.right"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "8"), /*#__PURE__*/React__default.createElement("td", null, "Number of storey's"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatednumberOfStoreys) || (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.maxFloor),
    name: "landInfo.checklistdata.regulatednumberOfStoreys"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfStoreys,
    name: "landInfo.checklistdata.numberOfStoreys"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfStoreys_remarks,
    name: "landInfo.checklistdata.numberOfStoreys_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfStoreys_relaxation,
    name: "landInfo.checklistdata.numberOfStoreys_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: "top"
    }
  }, "9"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Road/path existing at site")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.roadPathExisting_remarks,
    name: "landInfo.checklistdata.roadPathExisting_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.roadPathExisting_relaxation,
    name: "landInfo.checklistdata.roadPathExisting_relaxation",
    placeholder: "Enter Relaxation",
    height: 50,
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing at site"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedexistingAtSite,
    name: "landInfo.checklistdata.regulatedexistingAtSite"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.existingAtSite,
    name: "landInfo.checklistdata.existingAtSite"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Shown in Tatima"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.shownInTatima",
    data: submittedNotSubmitted,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.shownInTatima
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "10"), /*#__PURE__*/React__default.createElement("td", null, "Parking provision"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedparkingProvision,
    name: "landInfo.checklistdata.regulatedparkingProvision"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.parkingProvision,
    name: "landInfo.checklistdata.parkingProvision"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.parkingProvision_remarks,
    name: "landInfo.checklistdata.parkingProvision_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.parkingProvision_relaxation,
    name: "landInfo.checklistdata.parkingProvision_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "11"), /*#__PURE__*/React__default.createElement("td", null, "Whether any HT/LT Line, crossing over the proposed land", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherHtLtLineCrossing",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherHtLtLineCrossing
  })), /*#__PURE__*/React__default.createElement("td", null, watchWhetherHtLtLineCrossing == "yes" && "(Upload NOC from HPSEB)"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherHtLtLineCrossing == "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nocFromHPSEB,
    name: "landInfo.checklistdata.nocFromHPSEB",
    label: "NOC from HPSEB",
    validationMsg: "(pdf file only and Max file Size 10 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nocFromHPSEB_remarks,
    name: "landInfo.checklistdata.nocFromHPSEB_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nocFromHPSEB_relaxation,
    name: "landInfo.checklistdata.nocFromHPSEB_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "12"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed site is located nearby ASI Protected monument", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherNearbyAsiMonument",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyAsiMonument
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      wordBreak: "break-word"
    }
  }, watchWhetherNearbyAsiMonument === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Upload NOC from the competent authority)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nmanoc.nic.in/home/register)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NMA"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, watchWhetherNearbyAsiMonument === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyAsiMonument_noc,
    name: "landInfo.checklistdata.whetherNearbyAsiMonument_noc",
    label: "NOC from NMA",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyAsiMonument_remarks,
    name: "landInfo.checklistdata.whetherNearbyAsiMonument_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyAsiMonument_relaxation,
    name: "landInfo.checklistdata.whetherNearbyAsiMonument_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "13"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located nearby HFL", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherNearbyHfl",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyHfl
  })), /*#__PURE__*/React__default.createElement("td", null, watchWhetherNearbyHfl === "yes" && "(Upload NOC from the competent authority)"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherNearbyHfl === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyHfl_noc,
    name: "landInfo.checklistdata.whetherNearbyHfl_noc",
    label: "NOC from competent authority",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyHflc_remarks,
    name: "landInfo.checklistdata.whetherNearbyHflc_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherNearbyHflc_relaxation,
    name: "landInfo.checklistdata.whetherNearbyHflc_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherTreesOnPlot === "yes" ? 5 : 2,
    style: {
      verticalAlign: "top"
    }
  }, "14"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Whether trees are standing on plot"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherTreesOnPlot",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherTreesOnPlot
  })), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherTreesOnPlot === "yes" ? 5 : 2,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherTreesOnPlot_remarks,
    name: "landInfo.checklistdata.whetherTreesOnPlot_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherTreesOnPlot === "yes" ? 5 : 2
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherTreesOnPlot_relaxation,
    name: "landInfo.checklistdata.whetherTreesOnPlot_relaxation",
    placeholder: "Enter Relaxation",
    height: 50,
    multiline: true
  }))), watchWhetherTreesOnPlot === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of trees"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.noOfTrees,
    name: "landInfo.checklistdata.noOfTrees"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance of tree from proposed development if not to be cut (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceOfTrees,
    name: "landInfo.checklistdata.distanceOfTrees"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether Permission of Competent authority for cutting of trees"), /*#__PURE__*/React__default.createElement("td", null, "(Upload NOC from Forest Department)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.forestDepartment_noc,
    name: "landInfo.checklistdata.forestDepartment_noc",
    label: "NOC from Forest Department",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Abutting to Forest Boundary", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherAbuttingForestBoundary",
    data: yesOrNo,
    defaultValue: (checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingForestBoundary) === "yes" ? "yes" : "no"
  }), "Distance from Forest Boundary (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherAbuttingForestBoundary === "yes" && /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceFromForestBoundary,
    name: "landInfo.checklistdata.distanceFromForestBoundary"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "15"), /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Directly abutting with National Highway/State Highway/Bye-pass/Other H.P. Public Department Schedule road", /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherAbuttingHighway",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingHighway
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      wordBreak: "break-word"
    }
  }, watchWhetherAbuttingHighway === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Upload NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://morthnoc.nic.in) ", /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NHAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, watchWhetherAbuttingHighway === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.nocFromNHAI,
    name: "landInfo.checklistdata.nocFromNHAI",
    label: "NOC from NHAI",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingHighway_remarks,
    name: "landInfo.checklistdata.whetherAbuttingHighway_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingHighway_relaxation,
    name: "landInfo.checklistdata.whetherAbuttingHighway_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherAbuttingNaturalDrainage === "yes" ? 3 : 1,
    style: {
      verticalAlign: "top"
    }
  }, "16"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed plot is abutting to natural drainage", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherAbuttingNaturalDrainage",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingNaturalDrainage
  })), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherAbuttingNaturalDrainage === "yes" ? 3 : 1,
    style: {
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherAbuttingNaturalDrainage_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: watchWhetherAbuttingNaturalDrainage === "yes" ? 3 : 1
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherAbuttingNaturalDrainage_relaxation",
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAbuttingNaturalDrainage_relaxation,
    placeholder: "Enter Relaxation",
    height: 50,
    multiline: true
  }))), watchWhetherAbuttingNaturalDrainage === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance from Nullah (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceFromNullah,
    name: "landInfo.checklistdata.distanceFromNullah"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance from Khud/HFL of River (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceFromKhudHfl,
    name: "landInfo.checklistdata.distanceFromKhudHfl"
  })))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "17"), /*#__PURE__*/React__default.createElement("td", null, "Whether any Pipeline/Sewerage line crossing or passing through the plot", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherSeweragePassingThrough",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSeweragePassingThrough
  })), /*#__PURE__*/React__default.createElement("td", null, watchWhetherSeweragePassingThrough === "yes" && "(Upload NOC from the competent authority)"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherSeweragePassingThrough === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSeweragePassingThrough_noc,
    name: "landInfo.checklistdata.whetherSeweragePassingThrough_noc",
    label: "NOC from competent authority",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSeweragePassingThrough_remarks,
    name: "landInfo.checklistdata.whetherSeweragePassingThrough_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSeweragePassingThrough_relaxation,
    name: "landInfo.checklistdata.whetherSeweragePassingThrough_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "18"), /*#__PURE__*/React__default.createElement("td", null, "Provision of Solar Passive Building"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedprovisionOfSolar,
    name: "landInfo.checklistdata.regulatedprovisionOfSolar"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionOfSolar,
    name: "landInfo.checklistdata.provisionOfSolar"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionOfSolar_remarks,
    name: "landInfo.checklistdata.provisionOfSolar_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionOfSolar_relaxation,
    name: "landInfo.checklistdata.provisionOfSolar_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "19"), /*#__PURE__*/React__default.createElement("td", null, "Provision of barrier free access for persons with disability"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedprovisionForDisabiled,
    name: "landInfo.checklistdata.regulatedprovisionForDisabiled"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionForDisabiled,
    name: "landInfo.checklistdata.provisionForDisabiled"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionForDisabiled_remarks,
    name: "landInfo.checklistdata.provisionForDisabiled_remarks",
    placeholder: "Enter Relaxation",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionForDisabiled_relaxation,
    name: "landInfo.checklistdata.provisionForDisabiled_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "20"), /*#__PURE__*/React__default.createElement("td", null, "Whether the Proposed Plan is above the road level on Valley Side.", /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherAboveRoadLevel",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAboveRoadLevel
  })), /*#__PURE__*/React__default.createElement("td", null, watchWhetherAboveRoadLevel === "yes"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherAboveRoadLevel === "yes" && /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAboveRoadLevel_view,
    name: "landInfo.checklistdata.whetherAboveRoadLevel_view"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAboveRoadLevel_remarks,
    name: "landInfo.checklistdata.whetherAboveRoadLevel_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAboveRoadLevel_relaxation,
    name: "landInfo.checklistdata.whetherAboveRoadLevel_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "21"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located in Sinking and Sliding area", /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherSlidingArea",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSlidingArea
  })), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, watchWhetherSlidingArea === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSlidingArea_doc,
    name: "landInfo.checklistdata.whetherSlidingArea_doc",
    label: "Located in Sinking and Sliding area",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSlidingArea_remarks,
    name: "landInfo.checklistdata.whetherSlidingArea_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherSlidingArea_relaxation,
    name: "landInfo.checklistdata.whetherSlidingArea_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "22"), /*#__PURE__*/React__default.createElement("td", null, "Rain water harvesting tank provision"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedprovisionRainWaterHarvesting,
    name: "landInfo.checklistdata.regulatedprovisionRainWaterHarvesting"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionRainWaterHarvesting,
    name: "landInfo.checklistdata.provisionRainWaterHarvesting"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionRainWaterHarvesting_remarks,
    name: "landInfo.checklistdata.provisionRainWaterHarvesting_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.provisionRainWaterHarvesting_relaxation,
    name: "landInfo.checklistdata.provisionRainWaterHarvesting_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "23"), /*#__PURE__*/React__default.createElement("td", null, "Structural Stability Certificate"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.structuralStabilityCertificate,
    name: "landInfo.checklistdata.structuralStabilityCertificate",
    label: "Structural Stability Certificate",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.structuralStabilityCertificate_remarks,
    name: "landInfo.checklistdata.structuralStabilityCertificate_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.structuralStabilityCertificate_relaxation,
    name: "landInfo.checklistdata.structuralStabilityCertificate_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "24"), /*#__PURE__*/React__default.createElement("td", null, "Number of Dwelling Units"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatednumberOfDwellingUnits,
    name: "landInfo.checklistdata.regulatednumberOfDwellingUnits"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfDwellingUnits,
    name: "landInfo.checklistdata.numberOfDwellingUnits"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfDwellingUnits_remarks,
    name: "landInfo.checklistdata.numberOfDwellingUnits_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.numberOfDwellingUnits_relaxation,
    name: "landInfo.checklistdata.numberOfDwellingUnits_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      verticalAlign: "top"
    }
  }, "25"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Risk based Classification of building")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether building with communication tower"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherCommunicationTower",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherCommunicationTower
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherCommunicationTower_remarks,
    name: "landInfo.checklistdata.whetherCommunicationTower_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherCommunicationTower_relaxation,
    name: "landInfo.checklistdata.whetherCommunicationTower_relaxation",
    placeholder: "Enter Relaxation",
    height: 50,
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposal is for Group Housing Scheme"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherGroupHousing",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherGroupHousing
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherGroupHousing_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherGroupHousing_remarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherGroupHousing_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherGroupHousing_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on land fill"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherBuildingLandFill",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherBuildingLandFill
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherBuildingLandFill_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherBuildingLandFill_remarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherBuildingLandFill_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherBuildingLandFill_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on reclaimed land"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherRaisedReclaimed",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherRaisedReclaimed
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherRaisedReclaimed_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherRaisedReclaimed_remarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.whetherRaisedReclaimed_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherRaisedReclaimed_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 12,
    style: {
      verticalAlign: "top"
    }
  }, "26"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "General requirements")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Slope of land(Degree)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedslopeOfLandDegree,
    name: "landInfo.checklistdata.regulatedslopeOfLandDegree"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.slopeOfLandDegree,
    name: "landInfo.checklistdata.slopeOfLandDegree"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.slopeOfLandDegree_remarks,
    name: "landInfo.checklistdata.slopeOfLandDegree_remarks",
    placeholder: "Enter Remarks",
    height: 50,
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.slopeOfLandDegree_relaxation,
    name: "landInfo.checklistdata.slopeOfLandDegree_relaxation",
    placeholder: "Enter Relaxation",
    height: 50,
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of parking floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedheightOfParkingFloor,
    name: "landInfo.checklistdata.regulatedheightOfParkingFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfParkingFloor,
    name: "landInfo.checklistdata.heightOfParkingFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfParkingFloor_remarks,
    name: "landInfo.checklistdata.heightOfParkingFloor_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfParkingFloor_relaxation,
    name: "landInfo.checklistdata.heightOfParkingFloor_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of slopping roof(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedheightOfSloppingRoof,
    name: "landInfo.checklistdata.regulatedheightOfSloppingRoof"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfSloppingRoof,
    name: "landInfo.checklistdata.heightOfSloppingRoof"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfSloppingRoof_remarks,
    name: "landInfo.checklistdata.heightOfSloppingRoof_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfSloppingRoof_relaxation,
    name: "landInfo.checklistdata.heightOfSloppingRoof_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedheightOfFloor,
    name: "landInfo.checklistdata.regulatedheightOfFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfFloor,
    name: "landInfo.checklistdata.heightOfFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfFloor_remarks,
    name: "landInfo.checklistdata.heightOfFloor_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfFloor_relaxation,
    name: "landInfo.checklistdata.heightOfFloor_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of building(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedheightOfBuilding,
    name: "landInfo.checklistdata.regulatedheightOfBuilding"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfBuilding,
    name: "landInfo.checklistdata.heightOfBuilding"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfBuilding_remarks,
    name: "landInfo.checklistdata.heightOfBuilding_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfBuilding_relaxation,
    name: "landInfo.checklistdata.heightOfBuilding_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Maximum hill cut(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedmaxHillCut,
    name: "landInfo.checklistdata.regulatedmaxHillCut"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.maxHillCut,
    name: "landInfo.checklistdata.maxHillCut"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.maxHillCut_remarks,
    name: "landInfo.checklistdata.maxHillCut_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.maxHillCut_relaxation,
    name: "landInfo.checklistdata.maxHillCut_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance between two blocks(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulateddistanceBetween2Blocks,
    name: "landInfo.checklistdata.regulateddistanceBetween2Blocks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceBetween2Blocks,
    name: "landInfo.checklistdata.distanceBetween2Blocks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceBetween2Blocks_remarks,
    name: "landInfo.checklistdata.distanceBetween2Blocks_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.distanceBetween2Blocks_relaxation,
    name: "landInfo.checklistdata.distanceBetween2Blocks_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Plinth height(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedplinthHeight,
    name: "landInfo.checklistdata.regulatedplinthHeight"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plinthHeight,
    name: "landInfo.checklistdata.plinthHeight"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plinthHeight_remarks,
    name: "landInfo.checklistdata.plinthHeight_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.plinthHeight_relaxation,
    name: "landInfo.checklistdata.plinthHeight_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Service floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedheightOfServiceFloor,
    name: "landInfo.checklistdata.regulatedheightOfServiceFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfServiceFloor,
    name: "landInfo.checklistdata.heightOfServiceFloor"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfServiceFloor_remarks,
    name: "landInfo.checklistdata.heightOfServiceFloor_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.heightOfServiceFloor_relaxation,
    name: "landInfo.checklistdata.heightOfServiceFloor_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Equivalent car Space"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedequivalentCarSpace,
    name: "landInfo.checklistdata.regulatedequivalentCarSpace"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.equivalentCarSpace,
    name: "landInfo.checklistdata.equivalentCarSpace"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.equivalentCarSpace_remarks,
    name: "landInfo.checklistdata.equivalentCarSpace_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.equivalentCarSpace_relaxation,
    name: "landInfo.checklistdata.equivalentCarSpace_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Buildable width"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.regulatedbuildableWidth,
    name: "landInfo.checklistdata.regulatedbuildableWidth"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.buildableWidth,
    name: "landInfo.checklistdata.buildableWidth"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.buildableWidth_remarks,
    name: "landInfo.checklistdata.buildableWidth_remarks",
    placeholder: "Enter Remarks"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.buildableWidth_relaxation,
    name: "landInfo.checklistdata.buildableWidth_relaxation",
    placeholder: "Enter Relaxation"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "27"), /*#__PURE__*/React__default.createElement("td", null, "Photograph's of site"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.PhotographsOfSite,
    name: "landInfo.checklistdata.PhotographsOfSite",
    label: "Photograph's of site",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.PhotographsOfSite_remarks,
    name: "landInfo.checklistdata.PhotographsOfSite_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.PhotographsOfSite_relaxation",
    placeholder: "Enter Relaxation",
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.PhotographsOfSite_relaxation,
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "28"), /*#__PURE__*/React__default.createElement("td", null, "Any other information"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.anyOtherInformation,
    name: "landInfo.checklistdata.anyOtherInformation"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.anyOtherInformation_remarks,
    name: "landInfo.checklistdata.anyOtherInformation_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.anyOtherInformation_relaxation,
    name: "landInfo.checklistdata.anyOtherInformation_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "29"), /*#__PURE__*/React__default.createElement("td", null, "Whether the permission from Airport Authority of India is Required?", /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "landInfo.checklistdata.whetherAirportPermissionRequired",
    data: yesOrNo,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAirportPermissionRequired
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      wordBreak: "break-word"
    }
  }, watchWhetherAirportPermissionRequired === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Upload NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nocas2.aai.aero/nocas/Registration.html)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "To apply for NOC from AAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, watchWhetherAirportPermissionRequired === "yes" && /*#__PURE__*/React__default.createElement(FileUploader$1, {
    maxWidth: inputWidth,
    isMandatory: true,
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAirportPermissionRequired_noc,
    name: "landInfo.checklistdata.whetherAirportPermissionRequired_noc",
    label: "NOC from AAI",
    validationMsg: `(https://tcp.hp.gov.in/Application/uploadDocuments/form12Doc/1) \n (pdf file only and Max file Size 30 MB)`,
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAirportPermissionRequired_remarks,
    name: "landInfo.checklistdata.whetherAirportPermissionRequired_remarks",
    placeholder: "Enter Remarks",
    multiline: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    defaultValue: checklistdata === null || checklistdata === void 0 ? void 0 : checklistdata.whetherAirportPermissionRequired_relaxation,
    name: "landInfo.checklistdata.whetherAirportPermissionRequired_relaxation",
    placeholder: "Enter Relaxation",
    multiline: true
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    sx: {
      backgroundColor: "#eee",
      "&:hover": {
        backgroundColor: "#e5e5e5"
      },
      color: "#000"
    },
    variant: "contained",
    size: "medium",
    label: "Prev",
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => {
      resetForm12Docs();
      reset();
    }
  })))));
};

const Step3 = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.form12);
  const dispatch = useDispatch();
  const {
    resetForm12Docs
  } = bindActionCreators(form12DocActions, dispatch);
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    label: "Allotement Letter",
    name: "allotmentDoc",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    label: "Registry Deed",
    name: "registryDeed",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    label: "Mutation Letter",
    name: "mutationDoc",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$1, {
    control: control,
    name: "possessionDoc",
    label: "Possession Letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    sx: {
      backgroundColor: '#eee',
      '&:hover': {
        backgroundColor: '#e5e5e5'
      },
      color: '#000'
    },
    variant: "contained",
    size: "medium",
    label: "Prev",
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  })))));
};

function BPADocumentsPreview({
  documents,
  svgStyles = {},
  isSendBackFlow = false,
  isHrLine = false,
  titleStyles
}) {
  const {
    t
  } = useTranslation();
  return (
    /*#__PURE__*/
    React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginLeft: "2%"
      }
    }, documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
      var _document$values;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-4",
        key: document.id || index
      }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
        var _value$additionalDeta;
        return /*#__PURE__*/React__default.createElement("div", {
          key: (value === null || value === void 0 ? void 0 : value.documentType) || index,
          style: {
            display: "flex",
            marginTop: "10px"
          }
        }, /*#__PURE__*/React__default.createElement("a", {
          target: "_",
          href: value === null || value === void 0 ? void 0 : value.url,
          style: {
            minWidth: "80px",
            height: "auto",
            minWidth: "30px"
          }
        }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
          color: "#a10505",
          style: {
            width: '20px',
            height: '30px'
          }
        }))), /*#__PURE__*/React__default.createElement("p", {
          style: {
            margin: '2px 0'
          }
        }, t(value === null || value === void 0 ? void 0 : (_value$additionalDeta = value.additionalDetails) === null || _value$additionalDeta === void 0 ? void 0 : _value$additionalDeta.title)));
      }) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL"))));
    })))
  );
}

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});
const BPACheckListPreview = ({
  certificate,
  nocFromHPSEBcertificate,
  whetherNearbyAsiMonument_noccertificate,
  whetherNearbyHfl_noccertificate,
  nocFromNHAIcertificate,
  whetherSeweragePassingThrough_noccertificate,
  whetherSlidingArea_doc,
  photo,
  whetherAirportPermissionRequired_noc,
  formData
}) => {
  var _formData$regulatedse, _formData$setBacks, _formData$regulatedse2, _formData$setBacks2, _formData$regulatedse3, _formData$setBacks3, _formData$regulatedse4, _formData$setBacks4, _formData$nhregulated, _formData$nhsetBacks, _formData$nhregulated2, _formData$nhsetBacks2, _formData$nhregulated3, _formData$nhsetBacks3, _formData$nhregulated4, _formData$nhsetBacks4, _nocFromHPSEBcertific, _nocFromHPSEBcertific2, _whetherNearbyAsiMonu, _whetherNearbyAsiMonu2, _whetherNearbyHfl_noc, _whetherNearbyHfl_noc2, _nocFromNHAIcertifica, _nocFromNHAIcertifica2, _whetherSeweragePassi, _nwhetherSeweragePass, _nwhetherSeweragePass2, _whetherSlidingArea_d, _whetherSlidingArea_d2, _certificate$, _certificate$2, _photo$, _photo$2, _whetherAirportPermis, _whetherAirportPermis2;
  const classes = useStyles();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "SI#"), /*#__PURE__*/React__default.createElement("th", null, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("th", null, "As proposed"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Relaxation"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Type of Area"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("h6", null, "Core"), /*#__PURE__*/React__default.createElement("h6", null, "NOn Core"), /*#__PURE__*/React__default.createElement("h6", null, "Restricted"), /*#__PURE__*/React__default.createElement("h6", null, "Green"), /*#__PURE__*/React__default.createElement("h6", null, "Heritage"), /*#__PURE__*/React__default.createElement("h6", null, "Sinking"), /*#__PURE__*/React__default.createElement("h6", null, "Sliding"), /*#__PURE__*/React__default.createElement("h6", null, "Other")), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Plot Area For Sub-division/Development Activity (in sq.mt.)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_regulated), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Ownership & Revenue documents"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments_remarks), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments_relaxation))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Land-use *"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedLandUse), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "F.A.R."), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedFAR), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Built up area (in sq.mt.)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedBuildUpArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }, "7"), /*#__PURE__*/React__default.createElement("td", null, "Setbacks(meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse = formData.regulatedsetBacks) === null || _formData$regulatedse === void 0 ? void 0 : _formData$regulatedse.front), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks = formData.setBacks) === null || _formData$setBacks === void 0 ? void 0 : _formData$setBacks.front), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setBacks_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setBacks_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse2 = formData.regulatedsetBacks) === null || _formData$regulatedse2 === void 0 ? void 0 : _formData$regulatedse2.rear), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks2 = formData.setBacks) === null || _formData$setBacks2 === void 0 ? void 0 : _formData$setBacks2.rear)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse3 = formData.regulatedsetBacks) === null || _formData$regulatedse3 === void 0 ? void 0 : _formData$regulatedse3.left), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks3 = formData.setBacks) === null || _formData$setBacks3 === void 0 ? void 0 : _formData$setBacks3.left)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse4 = formData.regulatedsetBacks) === null || _formData$regulatedse4 === void 0 ? void 0 : _formData$regulatedse4.right), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks4 = formData.setBacks) === null || _formData$setBacks4 === void 0 ? void 0 : _formData$setBacks4.right)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }), /*#__PURE__*/React__default.createElement("td", null, "Whether Construction abuts with N.H Set Backs (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated = formData.nhregulatedsetBacks) === null || _formData$nhregulated === void 0 ? void 0 : _formData$nhregulated.front), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks = formData.nhsetBacks) === null || _formData$nhsetBacks === void 0 ? void 0 : _formData$nhsetBacks.front), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.nhsetBacks_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.nhsetBacks_relaxation))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated2 = formData.nhregulatedsetBacks) === null || _formData$nhregulated2 === void 0 ? void 0 : _formData$nhregulated2.rear), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks2 = formData.nhsetBacks) === null || _formData$nhsetBacks2 === void 0 ? void 0 : _formData$nhsetBacks2.rear)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated3 = formData.nhregulatedsetBacks) === null || _formData$nhregulated3 === void 0 ? void 0 : _formData$nhregulated3.left), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks3 = formData.nhsetBacks) === null || _formData$nhsetBacks3 === void 0 ? void 0 : _formData$nhsetBacks3.left)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated4 = formData.nhregulatedsetBacks) === null || _formData$nhregulated4 === void 0 ? void 0 : _formData$nhregulated4.right), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks4 = formData.nhsetBacks) === null || _formData$nhsetBacks4 === void 0 ? void 0 : _formData$nhsetBacks4.right)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "8"), /*#__PURE__*/React__default.createElement("td", null, "Number of storey's"), /*#__PURE__*/React__default.createElement("td", null, "Strictly Upto FAR and Upto the Height of 21 meter"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: 'top'
    }
  }, "9"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Road/path existing at site")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.roadPathExisting_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3
  }, formData === null || formData === void 0 ? void 0 : formData.roadPathExisting_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing at site"), /*#__PURE__*/React__default.createElement("td", null, "3 meter (Minimum)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.existingAtSite)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Shown in Tatima"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.shownInTatima)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "10"), /*#__PURE__*/React__default.createElement("td", null, "Parking provision"), /*#__PURE__*/React__default.createElement("td", null, "Mandatory If Feasible"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "11"), /*#__PURE__*/React__default.createElement("td", null, "Whether any HT/LT Line, crossing over the proposed land", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) == 'yes' && '(Upload NOC from HPSEB)', (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) == 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (nocFromHPSEBcertificate === null || nocFromHPSEBcertificate === void 0 ? void 0 : (_nocFromHPSEBcertific = nocFromHPSEBcertificate[0]) === null || _nocFromHPSEBcertific === void 0 ? void 0 : _nocFromHPSEBcertific.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: nocFromHPSEBcertificate === null || nocFromHPSEBcertificate === void 0 ? void 0 : (_nocFromHPSEBcertific2 = nocFromHPSEBcertificate[0]) === null || _nocFromHPSEBcertific2 === void 0 ? void 0 : _nocFromHPSEBcertific2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.nocFromHPSEB_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.nocFromHPSEB_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "12"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed site is located nearby ASI Protected monument", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Download NOC from the competent authority)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nmanoc.nic.in/home/register)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NMA"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) == 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherNearbyAsiMonument_noccertificate === null || whetherNearbyAsiMonument_noccertificate === void 0 ? void 0 : (_whetherNearbyAsiMonu = whetherNearbyAsiMonument_noccertificate[0]) === null || _whetherNearbyAsiMonu === void 0 ? void 0 : _whetherNearbyAsiMonu.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherNearbyAsiMonument_noccertificate === null || whetherNearbyAsiMonument_noccertificate === void 0 ? void 0 : (_whetherNearbyAsiMonu2 = whetherNearbyAsiMonument_noccertificate[0]) === null || _whetherNearbyAsiMonu2 === void 0 ? void 0 : _whetherNearbyAsiMonu2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "13"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located nearby HFL", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === 'yes' && '(Download NOC from the competent authority)', (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherNearbyHfl_noccertificate === null || whetherNearbyHfl_noccertificate === void 0 ? void 0 : (_whetherNearbyHfl_noc = whetherNearbyHfl_noccertificate[0]) === null || _whetherNearbyHfl_noc === void 0 ? void 0 : _whetherNearbyHfl_noc.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherNearbyHfl_noccertificate === null || whetherNearbyHfl_noccertificate === void 0 ? void 0 : (_whetherNearbyHfl_noc2 = whetherNearbyHfl_noccertificate[0]) === null || _whetherNearbyHfl_noc2 === void 0 ? void 0 : _whetherNearbyHfl_noc2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHflc_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHflc_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      verticalAlign: 'top'
    }
  }, "14"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Whether trees are standing on plot"), /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot_relaxation, " ")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Abutting to Forest Boundary", /*#__PURE__*/React__default.createElement("br", null), "Distance from Forest Boundary (Meter)"), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, " "), /*#__PURE__*/React__default.createElement("td", null)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "15"), /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Directly abutting with National Highway/State Highway/Bye-pass/Other H.P. Public Department Schedule road"), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Download NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://morthnoc.nic.in) ", /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NHAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  })), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (nocFromNHAIcertificate === null || nocFromNHAIcertificate === void 0 ? void 0 : (_nocFromNHAIcertifica = nocFromNHAIcertificate[0]) === null || _nocFromNHAIcertifica === void 0 ? void 0 : _nocFromNHAIcertifica.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: nocFromNHAIcertificate === null || nocFromNHAIcertificate === void 0 ? void 0 : (_nocFromNHAIcertifica2 = nocFromNHAIcertificate[0]) === null || _nocFromNHAIcertifica2 === void 0 ? void 0 : _nocFromNHAIcertifica2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      verticalAlign: 'top'
    }
  }, "16"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed plot is abutting to natural drainage", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null)), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Distance from Nullah (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceFromNullah)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Distance from Khud/HFL of River (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceFromKhudHfl))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "17"), /*#__PURE__*/React__default.createElement("td", null, "Whether any Pipeline/Sewerage line crossing or passing through the plot", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === 'yes' && '(Upload NOC from the competent authority)', " ", (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherSeweragePassingThrough_noccertificate === null || whetherSeweragePassingThrough_noccertificate === void 0 ? void 0 : (_whetherSeweragePassi = whetherSeweragePassingThrough_noccertificate[0]) === null || _whetherSeweragePassi === void 0 ? void 0 : _whetherSeweragePassi.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: (_nwhetherSeweragePass = nwhetherSeweragePassingThrough_noccertificate) === null || _nwhetherSeweragePass === void 0 ? void 0 : (_nwhetherSeweragePass2 = _nwhetherSeweragePass[0]) === null || _nwhetherSeweragePass2 === void 0 ? void 0 : _nwhetherSeweragePass2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "18"), /*#__PURE__*/React__default.createElement("td", null, "Provision of Solar Passive Building"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedprovisionOfSolar), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "19"), /*#__PURE__*/React__default.createElement("td", null, "Provision of barrier free access for persons with disability"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedprovisionForDisabiled), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "20"), /*#__PURE__*/React__default.createElement("td", null, "Whether the Proposed Plan is above the road level on Valley Side."), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_view), (formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel) === 'no' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "21"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located in Sinking and Sliding area"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherSlidingArea_doc === null || whetherSlidingArea_doc === void 0 ? void 0 : (_whetherSlidingArea_d = whetherSlidingArea_doc[0]) === null || _whetherSlidingArea_d === void 0 ? void 0 : _whetherSlidingArea_d.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherSlidingArea_doc === null || whetherSlidingArea_doc === void 0 ? void 0 : (_whetherSlidingArea_d2 = whetherSlidingArea_doc[0]) === null || _whetherSlidingArea_d2 === void 0 ? void 0 : _whetherSlidingArea_d2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "22"), /*#__PURE__*/React__default.createElement("td", null, "Rain water harvesting tank provision"), /*#__PURE__*/React__default.createElement("td", null, "Required @20 ltr per roof top area"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "23"), /*#__PURE__*/React__default.createElement("td", null, "Structural Stability Certificate"), /*#__PURE__*/React__default.createElement("td", null, "Stability Certificate "), /*#__PURE__*/React__default.createElement("td", null, (certificate === null || certificate === void 0 ? void 0 : (_certificate$ = certificate[0]) === null || _certificate$ === void 0 ? void 0 : _certificate$.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: certificate === null || certificate === void 0 ? void 0 : (_certificate$2 = certificate[0]) === null || _certificate$2 === void 0 ? void 0 : _certificate$2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.structuralStabilityCertificate_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.structuralStabilityCertificate_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "24"), /*#__PURE__*/React__default.createElement("td", null, "Number of Dwelling Units"), /*#__PURE__*/React__default.createElement("td", null, "8 Minimum if not for sale Otherwise 8 Maximum"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      verticalAlign: 'top'
    }
  }, "25"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Risk based Classification of building")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether building with communication tower"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower_relaxation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposal is for Group Housing Scheme"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on land fill"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on reclaimed land"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 12,
    style: {
      verticalAlign: 'top'
    }
  }, "26"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "General requirements")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Slope of land(Degree)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedslopeOfLandDegree), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of parking floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfParkingFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of slopping roof(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfSloppingRoof), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of building(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfBuilding), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Maximum hill cut(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedmaxHillCut), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance between two blocks(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulateddistanceBetween2Blocks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Plinth height(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedplinthHeight), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Service floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfServiceFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Equivalent car Space"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedequivalentCarSpace), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Buildable width"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedbuildableWidth), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "27"), /*#__PURE__*/React__default.createElement("td", null, "Photograph's of site"), /*#__PURE__*/React__default.createElement("td", null, "Photograph Doc"), /*#__PURE__*/React__default.createElement("td", null, (photo === null || photo === void 0 ? void 0 : (_photo$ = photo[0]) === null || _photo$ === void 0 ? void 0 : _photo$.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: photo === null || photo === void 0 ? void 0 : (_photo$2 = photo[0]) === null || _photo$2 === void 0 ? void 0 : _photo$2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.PhotographsOfSite_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.PhotographsOfSite_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "28"), /*#__PURE__*/React__default.createElement("td", null, "Any other information"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "29"), /*#__PURE__*/React__default.createElement("td", null, "Whether the permission from Airport Authority of India is Required?"), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Upload NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nocas2.aai.aero/nocas/Registration.html)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "To apply for NOC from AAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherAirportPermissionRequired_noc === null || whetherAirportPermissionRequired_noc === void 0 ? void 0 : (_whetherAirportPermis = whetherAirportPermissionRequired_noc[0]) === null || _whetherAirportPermis === void 0 ? void 0 : _whetherAirportPermis.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherAirportPermissionRequired_noc === null || whetherAirportPermissionRequired_noc === void 0 ? void 0 : (_whetherAirportPermis2 = whetherAirportPermissionRequired_noc[0]) === null || _whetherAirportPermis2 === void 0 ? void 0 : _whetherAirportPermis2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'no' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired_relaxation)))))));
};

const StyledTableCell = styled$1(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow = styled$1(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const StyledTableCell$1 = styled$1(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$1 = styled$1(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
function KhasraTables({
  formData
}) {
  var _formData$khasraArea;
  return /*#__PURE__*/createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/createElement(Table$2, {
    sx: {
      minWidth: 700
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/createElement(TableHead$1, null, /*#__PURE__*/createElement(TableRow$1, null, /*#__PURE__*/createElement(StyledTableCell$1, null, "Sr. No"), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, "Khasra No"), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, "Area"))), /*#__PURE__*/createElement(TableBody$1, null, formData === null || formData === void 0 ? void 0 : (_formData$khasraArea = formData.khasraArea) === null || _formData$khasraArea === void 0 ? void 0 : _formData$khasraArea.map((item, index) => /*#__PURE__*/createElement(StyledTableRow$1, {
    key: item.id || index
  }, /*#__PURE__*/createElement(StyledTableCell$1, {
    component: "th",
    scope: "row"
  }, index + 1), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, item.khasra || 'N/A'), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, item.area || 'N/A'))))));
}

const Form12ApplicaionFormatView = ({
  formData,
  applicationDocs,
  totalAmount,
  edcrDetails
}) => {
  var _formData$application, _formData$landInfo, _formData$landInfo$ch, _formData$blocks, _formData$taxHeadEsti;
  const {
    t
  } = useTranslation();
  const {
    landInfo,
    professionaldetails
  } = formData;
  const {
    checklistdata,
    owners,
    address
  } = landInfo;
  const tenant = Digit.ULBService.getCurrentTenantId();
  const isTcp = formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationNo) === null || _formData$application === void 0 ? void 0 : _formData$application.includes('TCP');
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const filteredDocuments = applicationDocs.filter(doc => !["applicantPhoto", "signature", "OwnerPhoto"].includes(doc.documentType));
  const checklistfilteredCertificate = applicationDocs.filter(doc => ["landInfo.checklist.structuralStabilityCertificate"].includes(doc.documentType));
  const checklistfilteredPhoto = applicationDocs.filter(doc => ["checklist.PhotographsOfSite"].includes(doc.documentType));
  const nocFromHPSEBcertificate = applicationDocs.filter(doc => ["checklist.nocFromHPSEB"].includes(doc.documentType));
  const whetherNearbyAsiMonument_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyAsiMonument_noc"].includes(doc.documentType));
  const whetherNearbyHfl_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyHfl_noccertificate"].includes(doc.documentType));
  const nocFromNHAI = applicationDocs.filter(doc => ["checklist.nocFromNHAI"].includes(doc.documentType));
  const whetherSeweragePassingThrough_noccertificate = applicationDocs.filter(doc => ["checklist.whetherSeweragePassingThrough_noccertificate"].includes(doc.documentType));
  const whetherSlidingArea_doc = applicationDocs.filter(doc => ["checklist.whetherSlidingArea_doc"].includes(doc.documentType));
  const whetherAirportPermissionRequired_noc = applicationDocs.filter(doc => ["checklist.whetherAirportPermissionRequired_noc"].includes(doc.documentType));
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  const urlImg = isTcp ? "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" : "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = isTcp ? "Department of Town and Country Planning" : "UP Housing & Development Board";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "1px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      marginLeft: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Himachal"
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "blue"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "23px",
      marginTop: "6px"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      marginTop: "4px"
    }
  }, 'Hamara Prayas....Aapka Awas')))), /*#__PURE__*/React__default.createElement("strong", null, " ", /*#__PURE__*/React__default.createElement("hr", null), " "), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Submission")), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Application Details ")), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "0px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => /*#__PURE__*/React__default.createElement("div", {
    key: `${item === null || item === void 0 ? void 0 : item.mobileNumber}_${index}`,
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '60%',
      marginLeft: "2%",
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Name :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Father/Guardian Name :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Gender :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.gender)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "MobileNumber :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Email :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Application Number :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", formData === null || formData === void 0 ? void 0 : formData.applicationNo))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '25%',
      marginTop: "auto"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      margin: "4px"
    }
  }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "110px",
      height: "110px"
    },
    src: item === null || item === void 0 ? void 0 : item.photo,
    alt: 'image',
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar$1, {
    style: {
      width: "70px",
      height: "70px"
    }
  }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      margin: "4px"
    }
  }, item !== null && item !== void 0 && item.signature ?
  /*#__PURE__*/
  React__default.createElement("img", {
    style: {
      width: "110px",
      height: "40px"
    },
    src: item === null || item === void 0 ? void 0 : item.signature,
    alt: 'signature',
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
    style: {
      width: "70px",
      height: "25px"
    }
  }, item === null || item === void 0 ? void 0 : item.signature))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address Details ")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "3px",
      border: "2px solid rgba(91, 90, 95, 0.35)",
      backgroundColor: "#99b3d98c",
      marginTop: "14px",
      textAlign: "center",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Correspondance Address")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "7%",
      marginRight: "5%"
    }
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Address :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.address) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "State :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state) || 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "District :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.district) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Tehsil :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.tehsil) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Town/Village/Ward :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "PinNo : "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.pinno) || 'N/A')));
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "3px",
      border: "2px solid rgba(91, 90, 95, 0.35)",
      backgroundColor: "#99b3d98c",
      marginTop: "14px",
      textAlign: "center",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permanent Address")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "7%",
      marginRight: "5%"
    }
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$permanentAddres, _item$permanentAddres2, _item$permanentAddres3, _item$permanentAddres4, _item$permanentAddres5, _item$permanentAddres6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Address :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres = item.permanentAddress) === null || _item$permanentAddres === void 0 ? void 0 : _item$permanentAddres.address) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "State :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres2 = item.permanentAddres) === null || _item$permanentAddres2 === void 0 ? void 0 : _item$permanentAddres2.state) || 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "District :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres3 = item.permanentAddress) === null || _item$permanentAddres3 === void 0 ? void 0 : _item$permanentAddres3.district) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Tehsil :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres4 = item.permanentAddress) === null || _item$permanentAddres4 === void 0 ? void 0 : _item$permanentAddres4.tehsil) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Town/Village/Ward :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres5 = item.permanentAddress) === null || _item$permanentAddres5 === void 0 ? void 0 : _item$permanentAddres5.town) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "PinNo : "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres6 = item.permanentAddress) === null || _item$permanentAddres6 === void 0 ? void 0 : _item$permanentAddres6.pinno) || 'N/A')));
  }))))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Description Of Land Proposed for Development of Land/Construction of Building")), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "0px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "1%",
      marginTop: "1%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Revenue Village/Mohalla :"), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.revenueVillageMohal) || 'N/A', " "))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Khatuni No :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.khatauniNo) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Applied Land Use:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.typeofArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Khata No :"), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.khataNo) || 'N/A', " "))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Total Plot Area: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.plotArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "District:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.city) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, isTcp ? /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, " ", /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Notified Area:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.doorNo) || 'N/A')) : /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "ULB:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.doorNo) || 'N/A')))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Area Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.areaType) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Property Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.propertyType) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Case Ref No: "), " ", /*#__PURE__*/React__default.createElement("p", null, "  ", (formData === null || formData === void 0 ? void 0 : formData.caseReferenceNo) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "No of Blocks:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.noOfBlocks) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Risk Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.riskType) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Number of Plot:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.noOfPlot) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, " Latitude/Longitude: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.latLong) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Type of Construction: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.constructionType) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Whether Subdivision Approved:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSubdivisionApproved) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Whether Property is ancestral:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Muck to be disposed (cubic mt.):  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ch = _formData$landInfo.checklistdata) === null || _formData$landInfo$ch === void 0 ? void 0 : _formData$landInfo$ch.muckToBeDisposed) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Maximum Permissible Ground Coverage (in Sq.mt):  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.maximumPermissibleGroundCoverage) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Proposal Submitted For:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.proposal) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Plot Area for Sub-division/Development Activity:   "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.totalPlotArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), (formData === null || formData === void 0 ? void 0 : formData.khasraArea) && /*#__PURE__*/React__default.createElement(KhasraTables, {
    formData: formData
  }))))), (formData === null || formData === void 0 ? void 0 : formData.blocks) && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Details of Blocks")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "1%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrReport) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "edcr-Report :"), /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.edcrReport,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, (formData === null || formData === void 0 ? void 0 : formData.drawingPdf) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "DrawingPdf :"), /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.drawingPdf,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  }))))))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("h4", null, "Occupancy : ", formData === null || formData === void 0 ? void 0 : formData.occupancy), formData === null || formData === void 0 ? void 0 : (_formData$blocks = formData.blocks) === null || _formData$blocks === void 0 ? void 0 : _formData$blocks.map((block, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: "scroll"
    },
    key: index
  }, /*#__PURE__*/React__default.createElement("div", null, "blocks Number : ", index + 1), /*#__PURE__*/React__default.createElement(Table, {
    className: "customTable table-fixed-first-column table-border-style",
    t: t,
    disableSort: false,
    autoSort: true,
    manualPagination: false,
    isPaginationRequired: false,
    initSortId: "S N ",
    data: getFloorData(block),
    columns: tableColumns,
    getCellProps: cellInfo => {
      return {
        style: {}
      };
    }
  }), /*#__PURE__*/React__default.createElement("br", null))))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Documents/Maps")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  }))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "CheckList")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPACheckListPreview, {
    certificate: checklistfilteredCertificate,
    nocFromHPSEBcertificate: nocFromHPSEBcertificate,
    whetherNearbyAsiMonument_noccertificate: whetherNearbyAsiMonument_noccertificate,
    whetherNearbyHfl_noccertificate: whetherNearbyHfl_noccertificate,
    nocFromNHAIcertificate: nocFromNHAI,
    whetherSeweragePassingThrough_noccertificate: whetherSeweragePassingThrough_noccertificate,
    whetherSlidingArea_doc: whetherSlidingArea_doc,
    photo: checklistfilteredPhoto,
    whetherAirportPermissionRequired_noc: whetherAirportPermissionRequired_noc,
    formData: checklistdata
  }))), formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti.map((item, index) => {
    var _item$feeDetails, _item$feeDetails2, _item$feeDetails2$dev;
    return /*#__PURE__*/React__default.createElement(Box, {
      gridColumn: "span 12",
      sx: {
        ml: 2
      },
      key: index
    }, /*#__PURE__*/React__default.createElement(Card$1, {
      style: {
        paddingBottom: " 20px",
        marginTop: "10px",
        marginBottom: "5px"
      }
    }, isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) !== "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) != "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Incudling Application & Processing fee to Fee structure "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Application Fee "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure"), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure"), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Application Fee"), (item === null || item === void 0 ? void 0 : (_item$feeDetails = item.feeDetails) === null || _item$feeDetails === void 0 ? void 0 : _item$feeDetails.deviationTable) && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Floor No"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Use Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Area (Sq.M.)"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price()"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Parking Area"))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$feeDetails2 = item.feeDetails) === null || _item$feeDetails2 === void 0 ? void 0 : (_item$feeDetails2$dev = _item$feeDetails2.deviationTable) === null || _item$feeDetails2$dev === void 0 ? void 0 : _item$feeDetails2$dev.map((feeData, index) => {
      var _feeData$floorType, _feeData$landUseType, _feeData$landUseType2, _feeData$landUseType3, _feeData$landUseType4, _feeData$floorType2;
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType = feeData.floorType) === null || _feeData$floorType === void 0 ? void 0 : _feeData$floorType.name), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType = feeData.landUseType) === null || _feeData$landUseType === void 0 ? void 0 : _feeData$landUseType.name)), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType2 = feeData.landUseType) === null || _feeData$landUseType2 === void 0 ? void 0 : _feeData$landUseType2.area), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType3 = feeData.landUseType) === null || _feeData$landUseType3 === void 0 ? void 0 : _feeData$landUseType3.unitPrice), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType4 = feeData.landUseType) === null || _feeData$landUseType4 === void 0 ? void 0 : _feeData$landUseType4.price), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType2 = feeData.floorType) === null || _feeData$floorType2 === void 0 ? void 0 : _feeData$floorType2.area));
    }))), /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginLeft: "10px",
        textAlign: "left"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.applicationFee) !== 0 && (item === null || item === void 0 ? void 0 : item.applicationFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, t(`BPA_COMMON_APPLICATION_FEE`)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.applicationFee}`))), (item === null || item === void 0 ? void 0 : item.buildUpCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.buildUpCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Building Permission Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.buildUpCharges}`))), (item === null || item === void 0 ? void 0 : item.cluFee) !== 0 && (item === null || item === void 0 ? void 0 : item.cluFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "CLU Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.cluFee}`))), (item === null || item === void 0 ? void 0 : item.deviationCharges) && (item === null || item === void 0 ? void 0 : item.deviationCharges) !== 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Deviation Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.deviationCharges}`))), (item === null || item === void 0 ? void 0 : item.muckCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.muckCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Total Muck-Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.muckCharges}`))), (item === null || item === void 0 ? void 0 : item.totalCBMFees) !== 0 && (item === null || item === void 0 ? void 0 : item.totalCBMFees) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Planning Permission Fee")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.totalCBMFees}`))), (item === null || item === void 0 ? void 0 : item.premiumFARFee) !== 0 && (item === null || item === void 0 ? void 0 : item.premiumFARFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Premium FAR Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.premiumFARFee}`))), (item === null || item === void 0 ? void 0 : item.echarges) !== 0 && (item === null || item === void 0 ? void 0 : item.echarges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "e-charges (3%)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.echarges}`))), (item === null || item === void 0 ? void 0 : item.amountDisplay) !== 0 && (item === null || item === void 0 ? void 0 : item.amountDisplay) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Grand Total Amount")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.amountDisplay}`)))))));
  }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      paddingBottom: " 20px",
      marginTop: "10px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, "Processing fee to Fee structure "), /*#__PURE__*/React__default.createElement("table", {
    class: "table table-sm"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, " Building Approval charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Malba Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Water Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Site Inspection Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Shudhikaran Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))))))))));
};

const Form12SummaryView = ({
  formData,
  collectionBillDetails,
  edcrDetails
}) => {
  var _formData$PrevStateDo, _formData$documents, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _pdfDetails$pdfFiles, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$application, _formData$serviceType;
  const stateId = Digit.ULBService.getStateId();
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount;
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationType) === null || _formData$application === void 0 ? void 0 : _formData$application.toLowerCase()}/${formData === null || formData === void 0 ? void 0 : (_formData$serviceType = formData.serviceType) === null || _formData$serviceType === void 0 ? void 0 : _formData$serviceType.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("dfygbhusw", formData);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Form12ApplicaionFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  }));
};

function ApplicationView12({
  id,
  formType
}) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  });
  const {
    applicationData,
    edcrDetails,
    collectionBillDetails
  } = data;
  if (!isLoading && data) {
    console.log("dfygbhusw", data, id, formType);
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(Form12SummaryView, {
    formData: applicationData,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  }));
}

const getApplicationData = (t, id = null, userUid) => {
  var _Digit$SessionStorage, _edcrData$planDetail, _edcrData$planDetail$, _edcrData$planDetail$2, _mdmsData$BPA, _planDetail$plot, _planDetail$blocks, _blocks$setBacks, _currLocality$localna, _planDetail$farDetail3, _planDetail$blocks9, _planDetail$blocks9$, _planDetail$blocks9$$, _planDetail$farDetail4, _planDetail$virtualBu8, _planDetail$virtualBu9, _setBacksData$frontYa2, _setBacksData$rearYar2, _setBacksData$sideYar3, _setBacksData$sideYar4, _regulatedObj$5, _regulatedObj$5$detai, _regulatedObj$5$detai2, _regulatedObj$6, _regulatedObj$6$detai, _regulatedObj$6$detai2, _regulatedObj$7, _regulatedObj$7$detai, _regulatedObj$7$detai2, _regulatedObj$8, _regulatedObj$8$detai, _regulatedObj$8$detai2, _planDetail$blocks10, _planDetail$blocks10$, _planDetail$blocks10$2, _planDetail$utility2, _planDetail$utility2$, _planDetail$blocks11, _planDetail$blocks11$, _planDetail$blocks12, _planDetail$blocks12$, _planDetail$blocks12$2, _planDetail$blocks12$3, _planDetail$blocks13, _planDetail$blocks13$, _planDetail$blocks13$2, _planDetail$blocks14, _planDetail$blocks14$, _planDetail$virtualBu10, _planDetail$virtualBu11, _planDetail$parkingDe3, _Digit2, _userInfo$info, _userInfo$info2, _scrutinyDetails$city, _planInformation$corr7, _scrutinyDetails$loca, _planInformation$corr8, _scrutinyDetails$vill, _planInformation$corr9;
  const tenantId = Digit.ULBService.getStateId() || 'hp';
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const planDetail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const isRescrutiny = (planDetail === null || planDetail === void 0 ? void 0 : planDetail.applicationScrutinyType) || false;
  const regulatedObj = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : (_edcrData$planDetail$ = _edcrData$planDetail.reportOutput) === null || _edcrData$planDetail$ === void 0 ? void 0 : (_edcrData$planDetail$2 = _edcrData$planDetail$.scrutinyDetails) === null || _edcrData$planDetail$2 === void 0 ? void 0 : _edcrData$planDetail$2.filter(e => e.key === 'Block_1_Side Setback');
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot = planDetail.plot) === null || _planDetail$plot === void 0 ? void 0 : _planDetail$plot.area, planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const blocks = planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks = planDetail.blocks) === null || _planDetail$blocks === void 0 ? void 0 : _planDetail$blocks[0];
  const setBacksData = blocks === null || blocks === void 0 ? void 0 : (_blocks$setBacks = blocks.setBacks) === null || _blocks$setBacks === void 0 ? void 0 : _blocks$setBacks[0];
  const planInformation = planDetail === null || planDetail === void 0 ? void 0 : planDetail.planInformation;
  const currentCity = JSON.parse(sessionStorage.getItem("currentCity") || null);
  const currLocality = JSON.parse(sessionStorage.getItem("currLocality") || null);
  const localityName = (currLocality === null || currLocality === void 0 ? void 0 : (_currLocality$localna = currLocality.localname) === null || _currLocality$localna === void 0 ? void 0 : _currLocality$localna.trim()) || '';
  if (id && !isRescrutiny) {
    var _data$BPA;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationNo: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  } else if (id && isRescrutiny) {
    var _data$BPA2;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationNo: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    let _applicationData2 = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA2 = data.BPA) === null || _data$BPA2 === void 0 ? void 0 : _data$BPA2[0]);
    if (_applicationData2) {
      var _applicationData3, _applicationData3$lan, _applicationData4, _applicationData4$lan, _planInformation$corr, _planInformation$corr2, _planInformation$corr3, _planInformation$corr4, _planInformation$corr5, _planInformation$corr6, _planInformation$perm, _planInformation$perm2, _planInformation$perm3, _planInformation$perm4, _planInformation$perm5, _planInformation$perm6, _planDetail$farDetail, _planDetail$blocks2, _planDetail$blocks2$, _planDetail$blocks2$$, _planDetail$farDetail2, _planDetail$virtualBu, _planDetail$virtualBu2, _setBacksData$frontYa, _existingChecklist$se, _setBacksData$rearYar, _existingChecklist$se2, _setBacksData$sideYar, _existingChecklist$se3, _setBacksData$sideYar2, _existingChecklist$se4, _regulatedObj$, _regulatedObj$$detail, _regulatedObj$$detail2, _existingChecklist$re, _regulatedObj$2, _regulatedObj$2$detai, _regulatedObj$2$detai2, _existingChecklist$re2, _regulatedObj$3, _regulatedObj$3$detai, _regulatedObj$3$detai2, _existingChecklist$re3, _regulatedObj$4, _regulatedObj$4$detai, _regulatedObj$4$detai2, _existingChecklist$re4, _planDetail$blocks3, _planDetail$blocks3$, _planDetail$blocks3$$, _planDetail$utility, _planDetail$utility$r, _planDetail$blocks4, _planDetail$blocks4$, _planDetail$blocks5, _planDetail$blocks5$, _planDetail$blocks5$$, _planDetail$blocks5$$2, _planDetail$blocks6, _planDetail$blocks6$, _planDetail$blocks6$$, _planDetail$blocks7, _planDetail$blocks7$, _planDetail$virtualBu3, _planDetail$virtualBu4, _planDetail$virtualBu5, _planDetail$virtualBu6, _planDetail$planInfoP, _planDetail$plot2, _planDetail$blocks8, _planDetail$virtualBu7, _planDetail$parkingDe, _planDetail$parkingDe2, _Digit;
      const _applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
      const existingOwner = (_applicationData3 = _applicationData2) === null || _applicationData3 === void 0 ? void 0 : (_applicationData3$lan = _applicationData3.landInfo) === null || _applicationData3$lan === void 0 ? void 0 : _applicationData3$lan.owners[0];
      const existingChecklist = (_applicationData4 = _applicationData2) === null || _applicationData4 === void 0 ? void 0 : (_applicationData4$lan = _applicationData4.landInfo) === null || _applicationData4$lan === void 0 ? void 0 : _applicationData4$lan.checklistdata;
      const modifiedOwner = {
        ...existingOwner,
        name: _applicantName,
        fatherOrHusbandName: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantGuardianName),
        mobileNumber: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantMobile) || existingOwner.mobileNumber,
        emailId: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantEmail) || existingOwner.emailId,
        gender: existingOwner.gender,
        correspondenceAddress: {
          ...existingOwner.correspondenceAddress,
          applicantName: _applicantName,
          applicantGuardianName: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantGuardianName),
          state: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr = planInformation.correspondenceAddress) === null || _planInformation$corr === void 0 ? void 0 : _planInformation$corr.state),
          district: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr2 = planInformation.correspondenceAddress) === null || _planInformation$corr2 === void 0 ? void 0 : _planInformation$corr2.district),
          tehsil: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr3 = planInformation.correspondenceAddress) === null || _planInformation$corr3 === void 0 ? void 0 : _planInformation$corr3.tehsil),
          town: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr4 = planInformation.correspondenceAddress) === null || _planInformation$corr4 === void 0 ? void 0 : _planInformation$corr4.town),
          address: (planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr5 = planInformation.correspondenceAddress) === null || _planInformation$corr5 === void 0 ? void 0 : _planInformation$corr5.address) || existingOwner.correspondenceAddress.address,
          pinno: (planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr6 = planInformation.correspondenceAddress) === null || _planInformation$corr6 === void 0 ? void 0 : _planInformation$corr6.pinCode) || existingOwner.correspondenceAddress.pinno,
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          ...existingOwner.permanentAddress,
          applicantName: _applicantName,
          applicantGuardianName: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantGuardianName),
          state: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm = planInformation.permanentAddress) === null || _planInformation$perm === void 0 ? void 0 : _planInformation$perm.state),
          district: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm2 = planInformation.permanentAddress) === null || _planInformation$perm2 === void 0 ? void 0 : _planInformation$perm2.district),
          tehsil: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm3 = planInformation.permanentAddress) === null || _planInformation$perm3 === void 0 ? void 0 : _planInformation$perm3.tehsil),
          town: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm4 = planInformation.permanentAddress) === null || _planInformation$perm4 === void 0 ? void 0 : _planInformation$perm4.town),
          address: (planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm5 = planInformation.permanentAddress) === null || _planInformation$perm5 === void 0 ? void 0 : _planInformation$perm5.address) || existingOwner.permanentAddress.address,
          pinno: (planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$perm6 = planInformation.permanentAddress) === null || _planInformation$perm6 === void 0 ? void 0 : _planInformation$perm6.pinCode) || existingOwner.permanentAddress.pinno,
          type: "PERMANENT"
        }
      };
      const modifiedChecklist = {
        ...existingChecklist,
        plotAreaForSubdivision: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.plotAreaForSubdivision),
        ownershipRevenueDocuments: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.ownershipRevenueDocuments) || 'notSubmitted',
        landUse: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.landUse),
        permissableFar: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$farDetail = planDetail.farDetails) === null || _planDetail$farDetail === void 0 ? void 0 : _planDetail$farDetail.permissableFar) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.permissableFar) || 0,
        maxFloor: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks2 = planDetail.blocks) === null || _planDetail$blocks2 === void 0 ? void 0 : (_planDetail$blocks2$ = _planDetail$blocks2[0]) === null || _planDetail$blocks2$ === void 0 ? void 0 : (_planDetail$blocks2$$ = _planDetail$blocks2$.building) === null || _planDetail$blocks2$$ === void 0 ? void 0 : _planDetail$blocks2$$.maxFloor) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.maxFloor) || 0,
        far: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$farDetail2 = planDetail.farDetails) === null || _planDetail$farDetail2 === void 0 ? void 0 : _planDetail$farDetail2.providedFar) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.far) || 0,
        builtupArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu = planDetail.virtualBuilding) === null || _planDetail$virtualBu === void 0 ? void 0 : _planDetail$virtualBu.totalBuitUpArea) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.builtupArea) || null,
        totalCoverageArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu2 = planDetail.virtualBuilding) === null || _planDetail$virtualBu2 === void 0 ? void 0 : _planDetail$virtualBu2.totalCoverageArea) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.totalCoverageArea) || null,
        isNHSetBacks: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.isNHSetBacks) || 'yes',
        setBacks: {
          front: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$frontYa = setBacksData.frontYard) === null || _setBacksData$frontYa === void 0 ? void 0 : _setBacksData$frontYa.mean) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$se = existingChecklist.setBacks) === null || _existingChecklist$se === void 0 ? void 0 : _existingChecklist$se.front),
          rear: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$rearYar = setBacksData.rearYard) === null || _setBacksData$rearYar === void 0 ? void 0 : _setBacksData$rearYar.mean) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$se2 = existingChecklist.setBacks) === null || _existingChecklist$se2 === void 0 ? void 0 : _existingChecklist$se2.rear),
          left: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar = setBacksData.sideYard1) === null || _setBacksData$sideYar === void 0 ? void 0 : _setBacksData$sideYar.mean) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$se3 = existingChecklist.setBacks) === null || _existingChecklist$se3 === void 0 ? void 0 : _existingChecklist$se3.left),
          right: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar2 = setBacksData.sideYard2) === null || _setBacksData$sideYar2 === void 0 ? void 0 : _setBacksData$sideYar2.mean) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$se4 = existingChecklist.setBacks) === null || _existingChecklist$se4 === void 0 ? void 0 : _existingChecklist$se4.right)
        },
        regulatedsetBacks: {
          front: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$ = regulatedObj[0]) === null || _regulatedObj$ === void 0 ? void 0 : (_regulatedObj$$detail = _regulatedObj$.detail) === null || _regulatedObj$$detail === void 0 ? void 0 : (_regulatedObj$$detail2 = _regulatedObj$$detail[0]) === null || _regulatedObj$$detail2 === void 0 ? void 0 : _regulatedObj$$detail2.Permissible) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$re = existingChecklist.regulatedsetBacks) === null || _existingChecklist$re === void 0 ? void 0 : _existingChecklist$re.front),
          rear: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$2 = regulatedObj[0]) === null || _regulatedObj$2 === void 0 ? void 0 : (_regulatedObj$2$detai = _regulatedObj$2.detail) === null || _regulatedObj$2$detai === void 0 ? void 0 : (_regulatedObj$2$detai2 = _regulatedObj$2$detai[1]) === null || _regulatedObj$2$detai2 === void 0 ? void 0 : _regulatedObj$2$detai2.Permissible) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$re2 = existingChecklist.regulatedsetBacks) === null || _existingChecklist$re2 === void 0 ? void 0 : _existingChecklist$re2.rear),
          left: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$3 = regulatedObj[0]) === null || _regulatedObj$3 === void 0 ? void 0 : (_regulatedObj$3$detai = _regulatedObj$3.detail) === null || _regulatedObj$3$detai === void 0 ? void 0 : (_regulatedObj$3$detai2 = _regulatedObj$3$detai[2]) === null || _regulatedObj$3$detai2 === void 0 ? void 0 : _regulatedObj$3$detai2.Permissible) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$re3 = existingChecklist.regulatedsetBacks) === null || _existingChecklist$re3 === void 0 ? void 0 : _existingChecklist$re3.left),
          right: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$4 = regulatedObj[0]) === null || _regulatedObj$4 === void 0 ? void 0 : (_regulatedObj$4$detai = _regulatedObj$4.detail) === null || _regulatedObj$4$detai === void 0 ? void 0 : (_regulatedObj$4$detai2 = _regulatedObj$4$detai[3]) === null || _regulatedObj$4$detai2 === void 0 ? void 0 : _regulatedObj$4$detai2.Permissible) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : (_existingChecklist$re4 = existingChecklist.regulatedsetBacks) === null || _existingChecklist$re4 === void 0 ? void 0 : _existingChecklist$re4.right)
        },
        setBacks_relaxation: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.setBacks_relaxation) || false,
        numberOfStoreys: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks3 = planDetail.blocks) === null || _planDetail$blocks3 === void 0 ? void 0 : (_planDetail$blocks3$ = _planDetail$blocks3[0]) === null || _planDetail$blocks3$ === void 0 ? void 0 : (_planDetail$blocks3$$ = _planDetail$blocks3$.building) === null || _planDetail$blocks3$$ === void 0 ? void 0 : _planDetail$blocks3$$.totalFloors) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.numberOfStoreys),
        shownInTatima: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.shownInTatima) || 'notSubmitted',
        whetherHtLtLineCrossing: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherHtLtLineCrossing) || 'no',
        whetherNearbyAsiMonument: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.buildingNearMonument) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherNearbyAsiMonument) || 'no',
        whetherNearbyHfl: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherNearbyHfl) || 'no',
        whetherTreesOnPlot: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherTreesOnPlot) || 'no',
        whetherAbuttingForestBoundary: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherAbuttinorestBoundary) || 'no',
        whetherAbuttingHighway: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherAbuttingHighway) || 'no',
        whetherAbuttingNaturalDrainage: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.buildingNearToRiver) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherAbuttingNaturalDrainage) || 'no',
        whetherSeweragePassingThrough: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherSeweragePassingThrough) || 'no',
        whetherAboveRoadLevel: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherAboveRoadLevel) || 'no',
        whetherSlidingArea: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherSlidingArea) || 'no',
        whetherCommunicationTower: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherCommunicationTower) || 'no',
        whetherGroupHousing: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherGroupHousing) || 'no',
        whetherBuildingLandFill: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherBuildingLandFill) || 'no',
        whetherRaisedReclaimed: (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherRaisedReclaimed) || 'no',
        whetherAirportPermissionRequired: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.nocNearAirport) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.whetherAirportPermissionRequired) || 'no',
        provisionForDisabiled: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.barrierFreeAccessForPhyChlngdPpl) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.provisionForDisabiled) || null,
        provisionRainWaterHarvesting: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$utility = planDetail.utility) === null || _planDetail$utility === void 0 ? void 0 : (_planDetail$utility$r = _planDetail$utility.rainWaterHarvest) === null || _planDetail$utility$r === void 0 ? void 0 : _planDetail$utility$r.tankCapacity) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.provisionRainWaterHarvesting) || null,
        heightOfSloppingRoof: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks4 = planDetail.blocks) === null || _planDetail$blocks4 === void 0 ? void 0 : (_planDetail$blocks4$ = _planDetail$blocks4[0]) === null || _planDetail$blocks4$ === void 0 ? void 0 : _planDetail$blocks4$.maxSloppingRoofHeight) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.heightOfSloppingRoof) || null,
        heightOfFloor: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks5 = planDetail.blocks) === null || _planDetail$blocks5 === void 0 ? void 0 : (_planDetail$blocks5$ = _planDetail$blocks5[0]) === null || _planDetail$blocks5$ === void 0 ? void 0 : (_planDetail$blocks5$$ = _planDetail$blocks5$.floors) === null || _planDetail$blocks5$$ === void 0 ? void 0 : (_planDetail$blocks5$$2 = _planDetail$blocks5$$[0]) === null || _planDetail$blocks5$$2 === void 0 ? void 0 : _planDetail$blocks5$$2.floorHeights) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.heightOfFloor) || null,
        heightOfBuilding: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks6 = planDetail.blocks) === null || _planDetail$blocks6 === void 0 ? void 0 : (_planDetail$blocks6$ = _planDetail$blocks6[0]) === null || _planDetail$blocks6$ === void 0 ? void 0 : (_planDetail$blocks6$$ = _planDetail$blocks6$.building) === null || _planDetail$blocks6$$ === void 0 ? void 0 : _planDetail$blocks6$$.buildingHeight) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.heightOfBuilding) || null,
        distanceBetween2Blocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks7 = planDetail.blocks) === null || _planDetail$blocks7 === void 0 ? void 0 : (_planDetail$blocks7$ = _planDetail$blocks7[0]) === null || _planDetail$blocks7$ === void 0 ? void 0 : _planDetail$blocks7$.distanceBetween2Blk) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.distanceBetween2Blocks) || null,
        anyOtherInformation: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu3 = planDetail.virtualBuilding) === null || _planDetail$virtualBu3 === void 0 ? void 0 : _planDetail$virtualBu3.totalCoverageArea) || (existingChecklist === null || existingChecklist === void 0 ? void 0 : existingChecklist.anyOtherInformation) || null
      };
      const modifiedLandInfo = {
        ..._applicationData2.landInfo,
        owners: [modifiedOwner],
        checklistdata: modifiedChecklist,
        address: {
          city: currentCity === null || currentCity === void 0 ? void 0 : currentCity.name,
          locality: {
            code: currLocality === null || currLocality === void 0 ? void 0 : currLocality.code
          },
          region: localityName,
          doorNo: currLocality === null || currLocality === void 0 ? void 0 : currLocality.name,
          areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
        }
      };
      _applicationData2 = {
        ..._applicationData2,
        applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
        applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
        applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
        occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
        edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
        totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu4 = planDetail.virtualBuilding) === null || _planDetail$virtualBu4 === void 0 ? void 0 : _planDetail$virtualBu4.totalBuitUpArea,
        maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu5 = planDetail.virtualBuilding) === null || _planDetail$virtualBu5 === void 0 ? void 0 : (_planDetail$virtualBu6 = _planDetail$virtualBu5.totalCoverageArea) === null || _planDetail$virtualBu6 === void 0 ? void 0 : _planDetail$virtualBu6.toFixed(2)) || null,
        typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
        propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP = planDetail.planInfoProperties) === null || _planDetail$planInfoP === void 0 ? void 0 : _planDetail$planInfoP.PROPERTY_TYPE)),
        proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
        revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
        khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
        khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
        plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot2 = planDetail.plot) === null || _planDetail$plot2 === void 0 ? void 0 : _planDetail$plot2.area) || 0,
        totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
        blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
        noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks8 = planDetail.blocks) === null || _planDetail$blocks8 === void 0 ? void 0 : _planDetail$blocks8.length) || 0,
        premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu7 = planDetail.virtualBuilding) === null || _planDetail$virtualBu7 === void 0 ? void 0 : _planDetail$virtualBu7.premiumFarArea) || 0,
        demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
        parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe = planDetail.parkingDetails) === null || _planDetail$parkingDe === void 0 ? void 0 : _planDetail$parkingDe.overAllParkingArea) || 0,
        parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe2 = planDetail.parkingDetails) === null || _planDetail$parkingDe2 === void 0 ? void 0 : _planDetail$parkingDe2.parkingFloorNo) || 0,
        activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("FORM12_CURRENT_TAB")) || 0,
        landInfo: modifiedLandInfo
      };
    }
    return {
      applicationData: _applicationData2,
      isAppDataLoading
    };
  }
  const applicationType = "FORM_12";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [isUdFlow, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
  const checklistdata = {
    typeOfArea: null,
    typeOfArea_relaxation: null,
    plotAreaForSubdivision: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || null,
    regulatedPlotArea: null,
    ownershipRevenueDocuments: 'notSubmitted',
    landUse: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
    regulatedLandUse: null,
    permissableFar: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$farDetail3 = planDetail.farDetails) === null || _planDetail$farDetail3 === void 0 ? void 0 : _planDetail$farDetail3.permissableFar) || 0,
    maxFloor: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks9 = planDetail.blocks) === null || _planDetail$blocks9 === void 0 ? void 0 : (_planDetail$blocks9$ = _planDetail$blocks9[0]) === null || _planDetail$blocks9$ === void 0 ? void 0 : (_planDetail$blocks9$$ = _planDetail$blocks9$.building) === null || _planDetail$blocks9$$ === void 0 ? void 0 : _planDetail$blocks9$$.maxFloor) || 0,
    far: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$farDetail4 = planDetail.farDetails) === null || _planDetail$farDetail4 === void 0 ? void 0 : _planDetail$farDetail4.providedFar) || 0,
    regulatedFAR: null,
    builtupArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu8 = planDetail.virtualBuilding) === null || _planDetail$virtualBu8 === void 0 ? void 0 : _planDetail$virtualBu8.totalBuitUpArea) || null,
    regulatedBuildUpArea: null,
    totalCoverageArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu9 = planDetail.virtualBuilding) === null || _planDetail$virtualBu9 === void 0 ? void 0 : _planDetail$virtualBu9.totalCoverageArea) || 0,
    isNHSetBacks: 'yes',
    setBacks: {
      front: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$frontYa2 = setBacksData.frontYard) === null || _setBacksData$frontYa2 === void 0 ? void 0 : _setBacksData$frontYa2.mean) || "",
      rear: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$rearYar2 = setBacksData.rearYard) === null || _setBacksData$rearYar2 === void 0 ? void 0 : _setBacksData$rearYar2.mean) || "",
      left: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar3 = setBacksData.sideYard1) === null || _setBacksData$sideYar3 === void 0 ? void 0 : _setBacksData$sideYar3.mean) || "",
      right: (setBacksData === null || setBacksData === void 0 ? void 0 : (_setBacksData$sideYar4 = setBacksData.sideYard2) === null || _setBacksData$sideYar4 === void 0 ? void 0 : _setBacksData$sideYar4.mean) || ""
    },
    regulatedsetBacks: {
      front: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$5 = regulatedObj[0]) === null || _regulatedObj$5 === void 0 ? void 0 : (_regulatedObj$5$detai = _regulatedObj$5.detail) === null || _regulatedObj$5$detai === void 0 ? void 0 : (_regulatedObj$5$detai2 = _regulatedObj$5$detai[0]) === null || _regulatedObj$5$detai2 === void 0 ? void 0 : _regulatedObj$5$detai2.Permissible) || "",
      rear: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$6 = regulatedObj[0]) === null || _regulatedObj$6 === void 0 ? void 0 : (_regulatedObj$6$detai = _regulatedObj$6.detail) === null || _regulatedObj$6$detai === void 0 ? void 0 : (_regulatedObj$6$detai2 = _regulatedObj$6$detai[1]) === null || _regulatedObj$6$detai2 === void 0 ? void 0 : _regulatedObj$6$detai2.Permissible) || "",
      left: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$7 = regulatedObj[0]) === null || _regulatedObj$7 === void 0 ? void 0 : (_regulatedObj$7$detai = _regulatedObj$7.detail) === null || _regulatedObj$7$detai === void 0 ? void 0 : (_regulatedObj$7$detai2 = _regulatedObj$7$detai[2]) === null || _regulatedObj$7$detai2 === void 0 ? void 0 : _regulatedObj$7$detai2.Permissible) || "",
      right: (regulatedObj === null || regulatedObj === void 0 ? void 0 : (_regulatedObj$8 = regulatedObj[0]) === null || _regulatedObj$8 === void 0 ? void 0 : (_regulatedObj$8$detai = _regulatedObj$8.detail) === null || _regulatedObj$8$detai === void 0 ? void 0 : (_regulatedObj$8$detai2 = _regulatedObj$8$detai[3]) === null || _regulatedObj$8$detai2 === void 0 ? void 0 : _regulatedObj$8$detai2.Permissible) || ""
    },
    setBacks_relaxation: false,
    numberOfStoreys: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks10 = planDetail.blocks) === null || _planDetail$blocks10 === void 0 ? void 0 : (_planDetail$blocks10$ = _planDetail$blocks10[0]) === null || _planDetail$blocks10$ === void 0 ? void 0 : (_planDetail$blocks10$2 = _planDetail$blocks10$.building) === null || _planDetail$blocks10$2 === void 0 ? void 0 : _planDetail$blocks10$2.totalFloors) || 0,
    shownInTatima: 'notSubmitted',
    whetherHtLtLineCrossing: 'no',
    whetherNearbyAsiMonument: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.buildingNearMonument) || 'no',
    whetherNearbyHfl: 'no',
    whetherTreesOnPlot: 'no',
    whetherAbuttingForestBoundary: 'no',
    whetherAbuttingHighway: 'no',
    whetherAbuttingNaturalDrainage: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.buildingNearToRiver) || 'no',
    whetherSeweragePassingThrough: 'no',
    whetherAboveRoadLevel: 'no',
    whetherSlidingArea: 'no',
    whetherCommunicationTower: 'no',
    whetherGroupHousing: 'no',
    whetherBuildingLandFill: 'no',
    whetherRaisedReclaimed: 'no',
    whetherAirportPermissionRequired: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.nocNearAirport) || 'no',
    existingAtSite: null,
    regulatedexistingAtSite: null,
    parkingProvision: null,
    regulatedparkingProvision: null,
    nocFromHPSEB: null,
    noOfTrees: null,
    distanceOfTrees: null,
    distanceFromForestBoundary: null,
    nocFromNHAI: null,
    distanceFromNullah: null,
    distanceFromKhudHfl: null,
    provisionOfSolar: null,
    regulatedprovisionOfSolar: null,
    provisionForDisabiled: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.barrierFreeAccessForPhyChlngdPpl) || null,
    regulatedprovisionForDisabiled: null,
    whetherAboveRoadLevel_view: null,
    whetherSlidingArea_doc: null,
    provisionRainWaterHarvesting: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$utility2 = planDetail.utility) === null || _planDetail$utility2 === void 0 ? void 0 : (_planDetail$utility2$ = _planDetail$utility2.rainWaterHarvest) === null || _planDetail$utility2$ === void 0 ? void 0 : _planDetail$utility2$.tankCapacity) || null,
    regulatedprovisionRainWaterHarvesting: null,
    structuralStabilityCertificate: null,
    numberOfDwellingUnits: null,
    regulatednumberOfDwellingUnits: null,
    slopeOfLandDegree: null,
    regulatedslopeOfLandDegree: null,
    lopeOfLandDegree_remarks: null,
    slopeOfLandDegree_relaxation: null,
    regulatedheightOfParkingFloor: null,
    heightOfParkingFloor: null,
    heightOfParkingFloor_remarks: null,
    heightOfParkingFloor_relaxation: null,
    heightOfSloppingRoof: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks11 = planDetail.blocks) === null || _planDetail$blocks11 === void 0 ? void 0 : (_planDetail$blocks11$ = _planDetail$blocks11[0]) === null || _planDetail$blocks11$ === void 0 ? void 0 : _planDetail$blocks11$.maxSloppingRoofHeight) || null,
    regulatedheightOfSloppingRoof: null,
    heightOfSloppingRoof_remarks: null,
    heightOfSloppingRoof_relaxation: null,
    heightOfFloor: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks12 = planDetail.blocks) === null || _planDetail$blocks12 === void 0 ? void 0 : (_planDetail$blocks12$ = _planDetail$blocks12[0]) === null || _planDetail$blocks12$ === void 0 ? void 0 : (_planDetail$blocks12$2 = _planDetail$blocks12$.floors) === null || _planDetail$blocks12$2 === void 0 ? void 0 : (_planDetail$blocks12$3 = _planDetail$blocks12$2[0]) === null || _planDetail$blocks12$3 === void 0 ? void 0 : _planDetail$blocks12$3.floorHeights) || null,
    regulatedheightOfFloor: null,
    heightOfFloor_remarks: null,
    heightOfFloor_relaxation: null,
    heightOfBuilding: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks13 = planDetail.blocks) === null || _planDetail$blocks13 === void 0 ? void 0 : (_planDetail$blocks13$ = _planDetail$blocks13[0]) === null || _planDetail$blocks13$ === void 0 ? void 0 : (_planDetail$blocks13$2 = _planDetail$blocks13$.building) === null || _planDetail$blocks13$2 === void 0 ? void 0 : _planDetail$blocks13$2.buildingHeight) || null,
    regulatedmaxHillCut: null,
    maxHillCut: null,
    maxHillCut_remarks: null,
    maxHillCut_relaxation: null,
    regulateddistanceBetween2Blocks: null,
    distanceBetween2Blocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks14 = planDetail.blocks) === null || _planDetail$blocks14 === void 0 ? void 0 : (_planDetail$blocks14$ = _planDetail$blocks14[0]) === null || _planDetail$blocks14$ === void 0 ? void 0 : _planDetail$blocks14$.distanceBetween2Blk) || null,
    distanceBetween2Blocks_relaxation: null,
    distanceBetween2Blocks_remarks: null,
    regulatedplinthHeight: null,
    plinthHeight: null,
    plinthHeight_remarks: null,
    plinthHeight_relaxation: null,
    regulatedheightOfServiceFloor: null,
    heightOfServiceFloor: null,
    heightOfServiceFloor_remarks: null,
    heightOfServiceFloor_relaxation: null,
    regulatedequivalentCarSpace: null,
    equivalentCarSpace: null,
    equivalentCarSpace_remarks: null,
    equivalentCarSpace_relaxation: null,
    regulatedbuildableWidth: null,
    buildableWidth: null,
    PhotographsOfSite: null,
    anyOtherInformation: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu10 = planDetail.virtualBuilding) === null || _planDetail$virtualBu10 === void 0 ? void 0 : _planDetail$virtualBu10.totalCoverageArea) || null,
    whetherNearbyAsiMonument_noc: null,
    whetherNearbyHfl_noc: null,
    forestDepartment_noc: null,
    whetherSeweragePassingThrough_noc: null,
    whetherAirportPermissionRequired_noc: null,
    typeOfArea_remarks: null,
    plotAreaForSubdivision_remarks: null,
    plotAreaForSubdivision_relaxation: null,
    ownershipRevenueDocuments_remarks: null,
    ownershipRevenueDocuments_relaxation: null,
    landUse_remarks: null,
    landUse_relaxation: null,
    far_remarks: null,
    far_relaxation: null,
    builtupArea_remarks: null,
    builtupArea_relaxation: null,
    setBacks_remarks: null,
    nhsetBacks_remarks: null,
    setBacks_relaxation: null,
    nhsetBacks_relaxation: null,
    numberOfStoreys_remarks: null,
    roadPathExisting_remarks: null,
    roadPathExisting_relaxation: null,
    parkingProvision_remarks: null,
    parkingProvision_relaxation: null,
    nocFromHPSEB_remarks: null,
    nocFromHPSEB_relaxation: null,
    whetherNearbyAsiMonument_remarks: null,
    whetherNearbyAsiMonument_relaxation: null,
    whetherNearbyHflc_remarks: null,
    whetherNearbyHflc_relaxation: null,
    whetherTreesOnPlot_remarks: null,
    whetherTreesOnPlot_relaxation: null,
    whetherAbuttingHighway_remarks: null,
    whetherAbuttingHighway_relaxation: null,
    whetherAbuttingNaturalDrainage_remarks: null,
    whetherAbuttingNaturalDrainage_relaxation: null,
    whetherSeweragePassingThrough_remarks: null,
    whetherSeweragePassingThrough_relaxation: null,
    provisionOfSolar_remarks: null,
    provisionOfSolar_relaxation: null,
    provisionForDisabiled_remarks: null,
    provisionForDisabiled_relaxation: null,
    whetherAboveRoadLevel_remarks: null,
    whetherAboveRoadLevel_relaxation: null,
    whetherSlidingArea_remarks: null,
    whetherSlidingArea_relaxation: null,
    provisionRainWaterHarvesting_remarks: null,
    provisionRainWaterHarvesting_relaxation: null,
    structuralStabilityCertificate_remarks: null,
    structuralStabilityCertificate_relaxation: null,
    numberOfDwellingUnits_remarks: null,
    numberOfDwellingUnits_relaxation: null,
    whetherCommunicationTower_remarks: null,
    whetherCommunicationTower_relaxation: null,
    whetherGroupHousing_remarks: null,
    whetherCommunicationTower_relaxation: null,
    whetherGroupHousing_relaxation: null,
    whetherBuildingLandFill_remarks: null,
    whetherBuildingLandFill_relaxation: null,
    whetherRaisedReclaimed_remarks: null,
    whetherRaisedReclaimed_relaxation: null,
    riskBasedClassification_remarks: null,
    slopeOfLandDegree_remarks: null,
    PhotographsOfSite_remarks: null,
    anyOtherInformation_remarks: null,
    anyOtherInformation_relaxation: null,
    whetherAirportPermissionRequired_remarks: null,
    whetherAirportPermissionRequired_relaxation: null
  };
  const applicationData = {
    tenantId,
    applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
    applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
    applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
    occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
    edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
    blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
    premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu11 = planDetail.virtualBuilding) === null || _planDetail$virtualBu11 === void 0 ? void 0 : _planDetail$virtualBu11.premiumFarArea) || 0,
    parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe3 = planDetail.parkingDetails) === null || _planDetail$parkingDe3 === void 0 ? void 0 : _planDetail$parkingDe3.parkingFloorNo) || 0,
    activeTab: ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("FORM12_CURRENT_TAB")) || 0,
    riskType,
    applicationType,
    feeType: "ApplicationFee",
    workflow: {
      action: "INITIATE",
      assignes: [userUid]
    },
    landInfo: {
      owners: [{
        name: null,
        fatherOrHusbandName: null,
        mobileNumber: '',
        emailId: '',
        gender: null,
        correspondenceAddress: {
          applicantName,
          applicantGuardianName: null,
          state: 'Uttar Pradesh',
          district: null,
          tehsil: null,
          town: null,
          address: '',
          pinno: '',
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          applicantName,
          applicantGuardianName: null,
          state: 'Uttar Pradesh',
          district: null,
          tehsil: null,
          town: null,
          address: '',
          pinno: '',
          type: "PERMANENT"
        }
      }],
      address: {
        city: currentCity === null || currentCity === void 0 ? void 0 : currentCity.name,
        locality: {
          code: currLocality === null || currLocality === void 0 ? void 0 : currLocality.code
        },
        region: localityName,
        doorNo: currLocality === null || currLocality === void 0 ? void 0 : currLocality.name,
        areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
      },
      tenantId
    },
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber
    },
    landAreaDetails: {
      city: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$city = scrutinyDetails.city) === null || _scrutinyDetails$city === void 0 ? void 0 : _scrutinyDetails$city.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr7 = planInformation.correspondenceAddress) === null || _planInformation$corr7 === void 0 ? void 0 : _planInformation$corr7.district) || null,
      locality: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$loca = scrutinyDetails.locality) === null || _scrutinyDetails$loca === void 0 ? void 0 : _scrutinyDetails$loca.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr8 = planInformation.correspondenceAddress) === null || _planInformation$corr8 === void 0 ? void 0 : _planInformation$corr8.tehsil) || null
      },
      village: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$vill = scrutinyDetails.village) === null || _scrutinyDetails$vill === void 0 ? void 0 : _scrutinyDetails$vill.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr9 = planInformation.correspondenceAddress) === null || _planInformation$corr9 === void 0 ? void 0 : _planInformation$corr9.town) || null
      },
      areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
    },
    businessService: null,
    documents,
    uiFlow: {
      flow: 'Form12'
    }
  };
  return {
    applicationData
  };
};

const Form12 = () => {
  const dispatch = useDispatch();
  const {
    initForm12Docs,
    resetForm12Docs
  } = bindActionCreators(form12DocActions, dispatch);
  const {
    t
  } = useTranslation();
  const {
    id
  } = useParams();
  const history = useHistory();
  const tenantId = Digit.ULBService.getStateId() || 'hp';
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const {
    applicationData,
    isAppDataLoading
  } = getApplicationData(t, id, userUid);
  const [activeTab, setActiveTab] = useState(Number(applicationData === null || applicationData === void 0 ? void 0 : applicationData.activeTab) || 0);
  const [showToast, setShowToast] = useState(null);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      var _Digit, _Digit2, _Digit3;
      clearParams();
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("FORM12_CURRENT_TAB");
      (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("ScrutinyDetails");
      (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("EDCR_CREATE");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetForm12Docs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initForm12Docs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", applicationData);
  const onSelect = (key, data, isFromCreateApi = false) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (!data.landInfo.owners[0].gender) {
        setShowToast({
          error: true,
          message: 'Please select the gender in applicant details'
        });
        return;
      }
      data.activeTab = nextTabNo;
      if (activeTab === 0 && nextTabNo === 1 && !('additionalDetails' in params)) {
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(result => {
          var _result$BPA;
          if ((result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA.length) > 0) {
            var _result$BPA2, _result$BPA2$, _Digit4;
            onSelect("", {
              ...data,
              ...result.BPA[0]
            }, true);
            setShowToast({
              error: false,
              message: `Application (${result === null || result === void 0 ? void 0 : (_result$BPA2 = result.BPA) === null || _result$BPA2 === void 0 ? void 0 : (_result$BPA2$ = _result$BPA2[0]) === null || _result$BPA2$ === void 0 ? void 0 : _result$BPA2$.applicationNo}) Created Successfully!`
            });
            setActiveTab(nextTabNo);
            (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.set("FORM12_CURRENT_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        if (nextTabNo === 4) {
          data.activeTab = 0;
          data.workflow = {
            action: "ASSIGN_TO_STRUCTURE_ENGINEER",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: [userUid]
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (nextTabNo === 4) {
              setShowToast({
                error: false,
                message: `Application has been dispatched to Owner for Approval`,
                gotoProfile: true
              });
            } else {
              var _Digit5;
              setActiveTab(nextTabNo);
              (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set("FORM12_CURRENT_TAB", nextTabNo);
              setShowToast({
                error: false,
                message: `Your changes saved successfully!`
              });
            }
          },
          onError: () => {
            setShowToast({
              error: true,
              message: `Something went wrong, please try again!`
            });
          }
        });
      }
    } else {
      var _Digit6;
      setActiveTab(nextTabNo);
      (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("FORM12_CURRENT_TAB", nextTabNo);
    }
  };
  if (!applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id) {
    var _params$landInfo, _params$landInfo$addr;
    if (!(params !== null && params !== void 0 && (_params$landInfo = params.landInfo) !== null && _params$landInfo !== void 0 && (_params$landInfo$addr = _params$landInfo.address) !== null && _params$landInfo$addr !== void 0 && _params$landInfo$addr.city)) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    className: "container1",
    sx: {
      my: 0
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "formContainer",
    sx: {
      my: '1rem !important',
      backgroundColor: '#e6eff8'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('BPA_APPLICATION_NUMBER_LABEL')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, convertEpochToDateDMY(applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationDate))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, t("Map Submission"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, t(applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationSubType))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, t(applicationData === null || applicationData === void 0 ? void 0 : applicationData.occupancy))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t(`Private Profofessional Name`)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || '')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Private Profofessional Mobile No.")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber) || 'N/A')))))), /*#__PURE__*/React__default.createElement(SubTabsWrapper, null, /*#__PURE__*/React__default.createElement(Box, {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement(SubTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    indicatorColor: "#5CB85C",
    "aria-label": "sub tabs"
  }, /*#__PURE__*/React__default.createElement(SubTab, {
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: "Case Checklist"
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: "Summary"
  })), /*#__PURE__*/React__default.createElement(MandatoryInfo, null, "(", /*#__PURE__*/React__default.createElement("span", null, "*"), ") Indicates Mandatory Field"))), activeTab === 0 && /*#__PURE__*/React__default.createElement(Step1, {
    formData: params,
    isLoading: updateApiCall.isLoading || updateApiCall.isIdle,
    handleTabChange: handleTabChange
  }), activeTab === 1 && /*#__PURE__*/React__default.createElement(Step2, {
    formData: params,
    isLoading: updateApiCall.isLoading || updateApiCall.isIdle,
    handleTabChange: handleTabChange
  }), activeTab === 2 && /*#__PURE__*/React__default.createElement(Step3, {
    formData: params,
    isLoading: updateApiCall.isLoading || updateApiCall.isIdle,
    handleTabChange: handleTabChange
  }), activeTab === 3 &&
  /*#__PURE__*/
  React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(ApplicationView12, {
    formType: params === null || params === void 0 ? void 0 : params.applicationType,
    id: params === null || params === void 0 ? void 0 : params.applicationNo
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    onClick: () => {
      handleTabChange(4, params);
    },
    style: {
      backgroundColor: '#2e7d32',
      color: '#fff',
      marginTop: '1rem'
    }
  }, "Send to Owner")))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

var lib = createCommonjsModule(function (module, exports) {
  !function (e, t) {
     module.exports = t(React__default, reactDom) ;
  }("undefined" != typeof self ? self : commonjsGlobal, function (e, t) {
    return function () {

      var n = {
          156: function (t) {
            t.exports = e;
          },
          111: function (e) {
            e.exports = t;
          },
          582: function (e, t, n) {
            n.r(t), n.d(t, {
              __assign: function () {
                return i;
              },
              __asyncDelegator: function () {
                return S;
              },
              __asyncGenerator: function () {
                return x;
              },
              __asyncValues: function () {
                return E;
              },
              __await: function () {
                return O;
              },
              __awaiter: function () {
                return h;
              },
              __classPrivateFieldGet: function () {
                return k;
              },
              __classPrivateFieldIn: function () {
                return R;
              },
              __classPrivateFieldSet: function () {
                return M;
              },
              __createBinding: function () {
                return g;
              },
              __decorate: function () {
                return c;
              },
              __esDecorate: function () {
                return u;
              },
              __exportStar: function () {
                return v;
              },
              __extends: function () {
                return o;
              },
              __generator: function () {
                return y;
              },
              __importDefault: function () {
                return C;
              },
              __importStar: function () {
                return A;
              },
              __makeTemplateObject: function () {
                return j;
              },
              __metadata: function () {
                return p;
              },
              __param: function () {
                return l;
              },
              __propKey: function () {
                return f;
              },
              __read: function () {
                return m;
              },
              __rest: function () {
                return a;
              },
              __runInitializers: function () {
                return s;
              },
              __setFunctionName: function () {
                return d;
              },
              __spread: function () {
                return _;
              },
              __spreadArray: function () {
                return P;
              },
              __spreadArrays: function () {
                return w;
              },
              __values: function () {
                return b;
              }
            });
            var r = function (e, t) {
              return r = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (e, t) {
                e.__proto__ = t;
              } || function (e, t) {
                for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
              }, r(e, t);
            };
            function o(e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
              function n() {
                this.constructor = e;
              }
              r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
            }
            var i = function () {
              return i = Object.assign || function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }, i.apply(this, arguments);
            };
            function a(e, t) {
              var n = {};
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
              if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var o = 0;
                for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
              }
              return n;
            }
            function c(e, t, n, r) {
              var o,
                i = arguments.length,
                a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
              if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var c = e.length - 1; c >= 0; c--) (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
              return i > 3 && a && Object.defineProperty(t, n, a), a;
            }
            function l(e, t) {
              return function (n, r) {
                t(n, r, e);
              };
            }
            function u(e, t, n, r, o, i) {
              function a(e) {
                if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                return e;
              }
              for (var c, l = r.kind, u = "getter" === l ? "get" : "setter" === l ? "set" : "value", s = !t && e ? r.static ? e : e.prototype : null, f = t || (s ? Object.getOwnPropertyDescriptor(s, r.name) : {}), d = !1, p = n.length - 1; p >= 0; p--) {
                var h = {};
                for (var y in r) h[y] = "access" === y ? {} : r[y];
                for (var y in r.access) h.access[y] = r.access[y];
                h.addInitializer = function (e) {
                  if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                  i.push(a(e || null));
                };
                var g = (0, n[p])("accessor" === l ? {
                  get: f.get,
                  set: f.set
                } : f[u], h);
                if ("accessor" === l) {
                  if (void 0 === g) continue;
                  if (null === g || "object" != typeof g) throw new TypeError("Object expected");
                  (c = a(g.get)) && (f.get = c), (c = a(g.set)) && (f.set = c), (c = a(g.init)) && o.unshift(c);
                } else (c = a(g)) && ("field" === l ? o.unshift(c) : f[u] = c);
              }
              s && Object.defineProperty(s, r.name, f), d = !0;
            }
            function s(e, t, n) {
              for (var r = arguments.length > 2, o = 0; o < t.length; o++) n = r ? t[o].call(e, n) : t[o].call(e);
              return r ? n : void 0;
            }
            function f(e) {
              return "symbol" == typeof e ? e : "".concat(e);
            }
            function d(e, t, n) {
              return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                configurable: !0,
                value: n ? "".concat(n, " ", t) : t
              });
            }
            function p(e, t) {
              if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            }
            function h(e, t, n, r) {
              return new (n || (n = Promise))(function (o, i) {
                function a(e) {
                  try {
                    l(r.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  try {
                    l(r.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function l(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                    e(t);
                  })).then(a, c);
                }
                l((r = r.apply(e, t || [])).next());
              });
            }
            function y(e, t) {
              var n,
                r,
                o,
                i,
                a = {
                  label: 0,
                  sent: function () {
                    if (1 & o[0]) throw o[1];
                    return o[1];
                  },
                  trys: [],
                  ops: []
                };
              return i = {
                next: c(0),
                throw: c(1),
                return: c(2)
              }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
                return this;
              }), i;
              function c(c) {
                return function (l) {
                  return function (c) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for (; i && (i = 0, c[0] && (a = 0)), a;) try {
                      if (n = 1, r && (o = 2 & c[0] ? r.return : c[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, c[1])).done) return o;
                      switch (r = 0, o && (c = [2 & c[0], o.value]), c[0]) {
                        case 0:
                        case 1:
                          o = c;
                          break;
                        case 4:
                          return a.label++, {
                            value: c[1],
                            done: !1
                          };
                        case 5:
                          a.label++, r = c[1], c = [0];
                          continue;
                        case 7:
                          c = a.ops.pop(), a.trys.pop();
                          continue;
                        default:
                          if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                            a = 0;
                            continue;
                          }
                          if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                            a.label = c[1];
                            break;
                          }
                          if (6 === c[0] && a.label < o[1]) {
                            a.label = o[1], o = c;
                            break;
                          }
                          if (o && a.label < o[2]) {
                            a.label = o[2], a.ops.push(c);
                            break;
                          }
                          o[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      c = t.call(e, a);
                    } catch (e) {
                      c = [6, e], r = 0;
                    } finally {
                      n = o = 0;
                    }
                    if (5 & c[0]) throw c[1];
                    return {
                      value: c[0] ? c[1] : void 0,
                      done: !0
                    };
                  }([c, l]);
                };
              }
            }
            var g = Object.create ? function (e, t, n, r) {
              void 0 === r && (r = n);
              var o = Object.getOwnPropertyDescriptor(t, n);
              o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                enumerable: !0,
                get: function () {
                  return t[n];
                }
              }), Object.defineProperty(e, r, o);
            } : function (e, t, n, r) {
              void 0 === r && (r = n), e[r] = t[n];
            };
            function v(e, t) {
              for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || g(t, e, n);
            }
            function b(e) {
              var t = "function" == typeof Symbol && Symbol.iterator,
                n = t && e[t],
                r = 0;
              if (n) return n.call(e);
              if (e && "number" == typeof e.length) return {
                next: function () {
                  return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                  };
                }
              };
              throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }
            function m(e, t) {
              var n = "function" == typeof Symbol && e[Symbol.iterator];
              if (!n) return e;
              var r,
                o,
                i = n.call(e),
                a = [];
              try {
                for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
              } catch (e) {
                o = {
                  error: e
                };
              } finally {
                try {
                  r && !r.done && (n = i.return) && n.call(i);
                } finally {
                  if (o) throw o.error;
                }
              }
              return a;
            }
            function _() {
              for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(m(arguments[t]));
              return e;
            }
            function w() {
              for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
              var r = Array(e),
                o = 0;
              for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, c = i.length; a < c; a++, o++) r[o] = i[a];
              return r;
            }
            function P(e, t, n) {
              if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
              return e.concat(r || Array.prototype.slice.call(t));
            }
            function O(e) {
              return this instanceof O ? (this.v = e, this) : new O(e);
            }
            function x(e, t, n) {
              if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
              var r,
                o = n.apply(e, t || []),
                i = [];
              return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
                return this;
              }, r;
              function a(e) {
                o[e] && (r[e] = function (t) {
                  return new Promise(function (n, r) {
                    i.push([e, t, n, r]) > 1 || c(e, t);
                  });
                });
              }
              function c(e, t) {
                try {
                  (n = o[e](t)).value instanceof O ? Promise.resolve(n.value.v).then(l, u) : s(i[0][2], n);
                } catch (e) {
                  s(i[0][3], e);
                }
                var n;
              }
              function l(e) {
                c("next", e);
              }
              function u(e) {
                c("throw", e);
              }
              function s(e, t) {
                e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
              }
            }
            function S(e) {
              var t, n;
              return t = {}, r("next"), r("throw", function (e) {
                throw e;
              }), r("return"), t[Symbol.iterator] = function () {
                return this;
              }, t;
              function r(r, o) {
                t[r] = e[r] ? function (t) {
                  return (n = !n) ? {
                    value: O(e[r](t)),
                    done: !1
                  } : o ? o(t) : t;
                } : o;
              }
            }
            function E(e) {
              if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
              var t,
                n = e[Symbol.asyncIterator];
              return n ? n.call(e) : (e = b(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
                return this;
              }, t);
              function r(n) {
                t[n] = e[n] && function (t) {
                  return new Promise(function (r, o) {
                    !function (e, t, n, r) {
                      Promise.resolve(r).then(function (t) {
                        e({
                          value: t,
                          done: n
                        });
                      }, t);
                    }(r, o, (t = e[n](t)).done, t.value);
                  });
                };
              }
            }
            function j(e, t) {
              return Object.defineProperty ? Object.defineProperty(e, "raw", {
                value: t
              }) : e.raw = t, e;
            }
            var T = Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            };
            function A(e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && g(t, e, n);
              return T(t, e), t;
            }
            function C(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }
            function k(e, t, n, r) {
              if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
              if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
              return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
            }
            function M(e, t, n, r, o) {
              if ("m" === r) throw new TypeError("Private method is not writable");
              if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
              if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
              return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
            }
            function R(e, t) {
              if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
              return "function" == typeof e ? t === e : e.has(t);
            }
            t.default = {
              __extends: o,
              __assign: i,
              __rest: a,
              __decorate: c,
              __param: l,
              __metadata: p,
              __awaiter: h,
              __generator: y,
              __createBinding: g,
              __exportStar: v,
              __values: b,
              __read: m,
              __spread: _,
              __spreadArrays: w,
              __spreadArray: P,
              __await: O,
              __asyncGenerator: x,
              __asyncDelegator: S,
              __asyncValues: E,
              __makeTemplateObject: j,
              __importStar: A,
              __importDefault: C,
              __classPrivateFieldGet: k,
              __classPrivateFieldSet: M,
              __classPrivateFieldIn: R
            };
          }
        },
        r = {};
      function o(e) {
        var t = r[e];
        if (void 0 !== t) return t.exports;
        var i = r[e] = {
          exports: {}
        };
        return n[e](i, i.exports, o), i.exports;
      }
      o.d = function (e, t) {
        for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }, o.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, o.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
      var i = {};
      return function () {
        var e = i;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.useReactToPrint = e.PrintContextConsumer = void 0;
        var t = o(582),
          n = o(156),
          r = o(111),
          a = Object.prototype.hasOwnProperty.call(n, "createContext"),
          c = Object.prototype.hasOwnProperty.call(n, "useMemo") && Object.prototype.hasOwnProperty.call(n, "useCallback"),
          l = a ? n.createContext({}) : null;
        e.PrintContextConsumer = l ? l.Consumer : function () {
          return null;
        };
        var u = {
            copyStyles: !0,
            pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
            removeAfterPrint: !1,
            suppressErrors: !1
          },
          s = function (e) {
            function o() {
              var n = null !== e && e.apply(this, arguments) || this;
              return n.startPrint = function (e) {
                var t = n.props,
                  r = t.onAfterPrint,
                  o = t.onPrintError,
                  i = t.print,
                  a = t.documentTitle;
                setTimeout(function () {
                  var t, c;
                  if (e.contentWindow) {
                    if (e.contentWindow.focus(), i) i(e).then(function () {
                      return null == r ? void 0 : r();
                    }).then(function () {
                      return n.handleRemoveIframe();
                    }).catch(function (e) {
                      o ? o("print", e) : n.logMessages(["An error was thrown by the specified `print` function"]);
                    });else {
                      if (e.contentWindow.print) {
                        var l = null !== (c = null === (t = e.contentDocument) || void 0 === t ? void 0 : t.title) && void 0 !== c ? c : "",
                          u = e.ownerDocument.title;
                        a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = l));
                      } else n.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);
                      null == r || r(), n.handleRemoveIframe();
                    }
                  } else n.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"]);
                }, 500);
              }, n.triggerPrint = function (e) {
                var t = n.props,
                  r = t.onBeforePrint,
                  o = t.onPrintError;
                if (r) {
                  var i = r();
                  i && "function" == typeof i.then ? i.then(function () {
                    n.startPrint(e);
                  }).catch(function (e) {
                    o && o("onBeforePrint", e);
                  }) : n.startPrint(e);
                } else n.startPrint(e);
              }, n.handleClick = function () {
                var e = n.props,
                  t = e.onBeforeGetContent,
                  r = e.onPrintError;
                if (t) {
                  var o = t();
                  o && "function" == typeof o.then ? o.then(n.handlePrint).catch(function (e) {
                    r && r("onBeforeGetContent", e);
                  }) : n.handlePrint();
                } else n.handlePrint();
              }, n.handlePrint = function () {
                var e = n.props,
                  o = e.bodyClass,
                  i = e.content,
                  a = e.copyStyles,
                  c = e.fonts,
                  l = e.pageStyle,
                  u = e.nonce,
                  s = i();
                if (void 0 !== s) {
                  if (null !== s) {
                    var f = document.createElement("iframe");
                    f.width = "".concat(document.documentElement.clientWidth, "px"), f.height = "".concat(document.documentElement.clientHeight, "px"), f.style.position = "absolute", f.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), f.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), f.id = "printWindow", f.srcdoc = "<!DOCTYPE html>";
                    var d = (0, r.findDOMNode)(s);
                    if (d) {
                      var p = d.cloneNode(!0),
                        h = p instanceof Text,
                        y = document.querySelectorAll("link[rel='stylesheet']"),
                        g = h ? [] : p.querySelectorAll("img"),
                        v = h ? [] : p.querySelectorAll("video"),
                        b = c ? c.length : 0;
                      n.numResourcesToLoad = y.length + g.length + v.length + b, n.resourcesLoaded = [], n.resourcesErrored = [];
                      var m = function (e, r) {
                        n.resourcesLoaded.includes(e) ? n.logMessages(["Tried to mark a resource that has already been handled", e], "debug") : (r ? (n.logMessages(t.__spreadArray(['"react-to-print" was unable to load a resource but will continue attempting to print the page'], t.__read(r), !1)), n.resourcesErrored.push(e)) : n.resourcesLoaded.push(e), n.resourcesLoaded.length + n.resourcesErrored.length === n.numResourcesToLoad && n.triggerPrint(f));
                      };
                      f.onload = function () {
                        var e, r, i, s;
                        f.onload = null;
                        var y = f.contentDocument || (null === (r = f.contentWindow) || void 0 === r ? void 0 : r.document);
                        if (y) {
                          y.body.appendChild(p), c && ((null === (i = f.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (s = f.contentWindow) || void 0 === s ? void 0 : s.FontFace) ? c.forEach(function (e) {
                            var t = new FontFace(e.family, e.source, {
                              weight: e.weight,
                              style: e.style
                            });
                            f.contentDocument.fonts.add(t), t.loaded.then(function () {
                              m(t);
                            }).catch(function (e) {
                              m(t, ["Failed loading the font:", t, "Load error:", e]);
                            });
                          }) : (c.forEach(function (e) {
                            return m(e);
                          }), n.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'])));
                          var b = "function" == typeof l ? l() : l;
                          if ("string" != typeof b) n.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')]);else {
                            var _ = y.createElement("style");
                            u && (_.setAttribute("nonce", u), y.head.setAttribute("nonce", u)), _.appendChild(y.createTextNode(b)), y.head.appendChild(_);
                          }
                          if (o && (e = y.body.classList).add.apply(e, t.__spreadArray([], t.__read(o.split(" ")), !1)), !h) {
                            for (var w = h ? [] : d.querySelectorAll("canvas"), P = y.querySelectorAll("canvas"), O = 0; O < w.length; ++O) {
                              var x = w[O],
                                S = P[O].getContext("2d");
                              S && S.drawImage(x, 0, 0);
                            }
                            var E = function (e) {
                              var t = g[e],
                                n = t.getAttribute("src");
                              if (n) {
                                var r = new Image();
                                r.onload = function () {
                                  return m(t);
                                }, r.onerror = function (e, n, r, o, i) {
                                  return m(t, ["Error loading <img>", t, "Error", i]);
                                }, r.src = n;
                              } else m(t, ['Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:', t]);
                            };
                            for (O = 0; O < g.length; O++) E(O);
                            var j = function (e) {
                              var t = v[e];
                              t.preload = "auto";
                              var n = t.getAttribute("poster");
                              if (n) {
                                var r = new Image();
                                r.onload = function () {
                                  return m(t);
                                }, r.onerror = function (e, r, o, i, a) {
                                  return m(t, ["Error loading video poster", n, "for video", t, "Error:", a]);
                                }, r.src = n;
                              } else t.readyState >= 2 ? m(t) : (t.onloadeddata = function () {
                                return m(t);
                              }, t.onerror = function (e, n, r, o, i) {
                                return m(t, ["Error loading video", t, "Error", i]);
                              }, t.onstalled = function () {
                                return m(t, ["Loading video stalled, skipping", t]);
                              });
                            };
                            for (O = 0; O < v.length; O++) j(O);
                            var T = "input",
                              A = d.querySelectorAll(T),
                              C = y.querySelectorAll(T);
                            for (O = 0; O < A.length; O++) C[O].value = A[O].value;
                            var k = "input[type=checkbox],input[type=radio]",
                              M = d.querySelectorAll(k),
                              R = y.querySelectorAll(k);
                            for (O = 0; O < M.length; O++) R[O].checked = M[O].checked;
                            var D = "select",
                              I = d.querySelectorAll(D),
                              q = y.querySelectorAll(D);
                            for (O = 0; O < I.length; O++) q[O].value = I[O].value;
                          }
                          if (a) for (var F = document.querySelectorAll("style, link[rel='stylesheet']"), L = function (e, t) {
                              var r = F[e];
                              if ("style" === r.tagName.toLowerCase()) {
                                var o = y.createElement(r.tagName),
                                  i = r.sheet;
                                if (i) {
                                  var a = "";
                                  try {
                                    for (var c = i.cssRules.length, l = 0; l < c; ++l) "string" == typeof i.cssRules[l].cssText && (a += "".concat(i.cssRules[l].cssText, "\r\n"));
                                  } catch (e) {
                                    n.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.", r], "warning");
                                  }
                                  o.setAttribute("id", "react-to-print-".concat(e)), u && o.setAttribute("nonce", u), o.appendChild(y.createTextNode(a)), y.head.appendChild(o);
                                }
                              } else if (r.getAttribute("href")) {
                                if (r.hasAttribute("disabled")) n.logMessages(["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:", r], "warning"), m(r);else {
                                  for (var s = y.createElement(r.tagName), f = (l = 0, r.attributes.length); l < f; ++l) {
                                    var d = r.attributes[l];
                                    d && s.setAttribute(d.nodeName, d.nodeValue || "");
                                  }
                                  s.onload = function () {
                                    return m(s);
                                  }, s.onerror = function (e, t, n, r, o) {
                                    return m(s, ["Failed to load", s, "Error:", o]);
                                  }, u && s.setAttribute("nonce", u), y.head.appendChild(s);
                                }
                              } else n.logMessages(["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:", r], "warning"), m(r);
                            }, W = (O = 0, F.length); O < W; ++O) L(O);
                        }
                        0 !== n.numResourcesToLoad && a || n.triggerPrint(f);
                      }, n.handleRemoveIframe(!0), document.body.appendChild(f);
                    } else n.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop']);
                  } else n.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);
                } else n.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"]);
              }, n.handleRemoveIframe = function (e) {
                var t = n.props.removeAfterPrint;
                if (e || t) {
                  var r = document.getElementById("printWindow");
                  r && document.body.removeChild(r);
                }
              }, n.logMessages = function (e, t) {
                void 0 === t && (t = "error"), n.props.suppressErrors || ("error" === t ? console.error(e) : "warning" === t ? console.warn(e) : "debug" === t && console.debug(e));
              }, n;
            }
            return t.__extends(o, e), o.prototype.render = function () {
              var e = this.props,
                t = e.children,
                r = e.trigger;
              if (r) return n.cloneElement(r(), {
                onClick: this.handleClick
              });
              if (!l) return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']), null;
              var o = {
                handlePrint: this.handleClick
              };
              return n.createElement(l.Provider, {
                value: o
              }, t);
            }, o.defaultProps = u, o;
          }(n.Component);
        e.default = s, e.useReactToPrint = function (e) {
          if (!c) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function () {
            throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
          };
          var r = n.useMemo(function () {
            return new s(t.__assign(t.__assign({}, u), e));
          }, [e]);
          return n.useCallback(function () {
            return r.handleClick();
          }, [r]);
        };
      }(), i;
    }();
  });
});
var ReactToPrint = unwrapExports(lib);

const FormatSlip = ({
  scrutinyTable,
  scrutinyDetails,
  wordslist,
  scrutinyData,
  id,
  logoData
}) => {
  var _scrutinyDetails$corr;
  const date = convertEpochToDateDMY(scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.auditDetails.createdTime);
  const isDA = (scrutinyData === null || scrutinyData === void 0 ? void 0 : scrutinyData.department) === 'DA';
  const colorCodeUrl = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const colorCodeiner = isDA ? "#f06107ed" : "#000";
  const colorCode = "#1f4a7c";
  const nameOfDepartment = isDA ? "Development Authority" : "Awas Evam Vikas Parishad";
  console.log("abcdefgh", colorCode, nameOfDepartment, scrutinyData, scrutinyDetails, isDA);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, scrutinyTable && /*#__PURE__*/React__default.createElement("div", {
    className: "FormatSlipbody"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container bootstrap snippets bootdeys"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      marginLeft: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "85",
    src: colorCodeUrl,
    alt: "Himachal"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "23px",
      marginTop: "6px"
    }
  }, "Govermment of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      marginTop: "4px"
    }
  }, nameOfDepartment))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, " ", /*#__PURE__*/React__default.createElement("hr", null), " "), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      border: `10px solid ${colorCode}`,
      padding: "12px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-sm-12",
    style: {
      border: `5px solid ${colorCodeiner}`,
      padding: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      opacity: 0.09,
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      flexDirection: "column",
      gap: 10,
      userSelect: "none"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: 200,
    src: colorCodeUrl,
    alt: "hp"
  }), /*#__PURE__*/React__default.createElement("p", null, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", null, "Govermment of Uttar Pradesh")), /*#__PURE__*/React__default.createElement("div", {
    className: "panel panel-default invoice",
    id: "invoice"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "invoice-ribbon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "ribbon-inner",
    style: {
      background: colorCode
    }
  }, "PAID")), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    width: "90",
    style: {
      margin: "auto"
    },
    src: logoData,
    alt: "UttarPradesh"
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      textAlign: "center",
      fontSize: "33px",
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, id)), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      fontSize: "22px",
      margin: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "18rem",
      border: `2px solid ${colorCode}`,
      color: colorCode,
      margin: "auto",
      borderRadius: "50px"
    }
  }, "PAYMENT RECEIPT"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, "No : ", scrutinyTable.txnId), /*#__PURE__*/React__default.createElement("div", null, "Dated : ", date)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontFamily: "Arial, sans-serif",
      margin: "20px",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    classname: "receiptApp"
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      color: colorCode,
      textAlign: "center",
      margin: "5px"
    }
  }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "block",
      marginBottom: "20px",
      marginLeft: "25px",
      color: "#333",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name Of Professional  : Sh./Smt."), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.name, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Phone No :"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.mobileNumber, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Email Id :"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.emailId, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Received Bank :"), " ", scrutinyTable.gateway, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Status :"), " ", scrutinyTable.txnStatusMsg, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Address:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$corr = scrutinyDetails.correspondenceAddress) === null || _scrutinyDetails$corr === void 0 ? void 0 : _scrutinyDetails$corr.address)), /*#__PURE__*/React__default.createElement("table", {
    className: "dataTablePayment"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount of words"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Applicaion Fee"), /*#__PURE__*/React__default.createElement("td", null, wordslist), /*#__PURE__*/React__default.createElement("td", null, " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnAmount)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "20px",
      textAlign: "right",
      color: "#333"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount:"), " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnAmount)))))))))));
};

var enAE = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Dirham',
          plural: 'Dirhams',
          symbol: '',
          fractionalUnit: {
            name: 'Fil',
            plural: 'Fils',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enAE);

var enBD = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Taka',
          plural: 'Taka',
          symbol: '৳',
          fractionalUnit: {
            name: 'Poysha',
            plural: 'Poysha',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'Crore'
        }, {
          number: 100000,
          value: 'Lakh'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enBD);

var enGH = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Cedi',
          plural: 'Cedis',
          symbol: 'GH¢',
          fractionalUnit: {
            name: 'Pesewa',
            plural: 'Pesewas',
            symbol: 'Gp'
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enGH);

var enIN = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Rupee',
          plural: 'Rupees',
          symbol: '₹',
          fractionalUnit: {
            name: 'Paisa',
            plural: 'Paise',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'Crore'
        }, {
          number: 100000,
          value: 'Lakh'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enIN);

var enMM = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Kyat',
          plural: 'Kyats',
          symbol: 'K',
          fractionalUnit: {
            name: 'Pya',
            plural: 'Pyas',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enMM);

var enMU = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Rupee',
          plural: 'Rupees',
          symbol: 'Rs',
          fractionalUnit: {
            name: 'Cent',
            plural: 'Cents',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'Crore'
        }, {
          number: 100000,
          value: 'Lakh'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enMU);

var enNG = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Naira',
          plural: 'Naira',
          symbol: '₦',
          fractionalUnit: {
            name: 'Kobo',
            plural: 'Kobo',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enNG);

var enNP = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Rupee',
          plural: 'Rupees',
          symbol: '₹',
          fractionalUnit: {
            name: 'Paisa',
            plural: 'Paisa',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 100000000000,
          value: 'Kharab'
        }, {
          number: 1000000000,
          value: 'Arab'
        }, {
          number: 10000000,
          value: 'Crore'
        }, {
          number: 100000,
          value: 'Lakh'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enNP);

var enUS = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Dollar',
          plural: 'Dollars',
          symbol: '$',
          fractionalUnit: {
            name: 'Cent',
            plural: 'Cents',
            symbol: '¢'
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enUS);

var enGB = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Pound',
          plural: 'Pounds',
          symbol: '£',
          fractionalUnit: {
            name: 'Pence',
            plural: 'Pence',
            symbol: ''
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enGB);

var enPH = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Peso',
          plural: 'Pesos',
          symbol: '₱',
          fractionalUnit: {
            name: 'Cent',
            plural: 'Cents',
            symbol: '¢'
          }
        },
        texts: {
          and: 'And',
          minus: 'Minus',
          only: 'Only',
          point: 'Point'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrillion'
        }, {
          number: 1000000000000,
          value: 'Trillion'
        }, {
          number: 1000000000,
          value: 'Billion'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Thousand'
        }, {
          number: 100,
          value: 'Hundred'
        }, {
          number: 90,
          value: 'Ninety'
        }, {
          number: 80,
          value: 'Eighty'
        }, {
          number: 70,
          value: 'Seventy'
        }, {
          number: 60,
          value: 'Sixty'
        }, {
          number: 50,
          value: 'Fifty'
        }, {
          number: 40,
          value: 'Forty'
        }, {
          number: 30,
          value: 'Thirty'
        }, {
          number: 20,
          value: 'Twenty'
        }, {
          number: 19,
          value: 'Nineteen'
        }, {
          number: 18,
          value: 'Eighteen'
        }, {
          number: 17,
          value: 'Seventeen'
        }, {
          number: 16,
          value: 'Sixteen'
        }, {
          number: 15,
          value: 'Fifteen'
        }, {
          number: 14,
          value: 'Fourteen'
        }, {
          number: 13,
          value: 'Thirteen'
        }, {
          number: 12,
          value: 'Twelve'
        }, {
          number: 11,
          value: 'Eleven'
        }, {
          number: 10,
          value: 'Ten'
        }, {
          number: 9,
          value: 'Nine'
        }, {
          number: 8,
          value: 'Eight'
        }, {
          number: 7,
          value: 'Seven'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Five'
        }, {
          number: 4,
          value: 'Four'
        }, {
          number: 3,
          value: 'Three'
        }, {
          number: 2,
          value: 'Two'
        }, {
          number: 1,
          value: 'One'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'One Hundred'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(enPH);

var faIR = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'تومان',
          plural: '',
          symbol: 'تومان',
          fractionalUnit: {
            name: '',
            plural: 'تومان',
            symbol: ''
          }
        },
        texts: {
          and: 'و',
          minus: 'منفی',
          only: '',
          point: 'و'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'کوادریلیون'
        }, {
          number: 1000000000000,
          value: 'تیلیارد'
        }, {
          number: 1000000000,
          value: 'میلیارد'
        }, {
          number: 1000000,
          value: 'میلیون'
        }, {
          number: 1000,
          value: 'هزار'
        }, {
          number: 900,
          value: 'نهصد'
        }, {
          number: 800,
          value: 'هشتصد'
        }, {
          number: 700,
          value: 'هفتصد'
        }, {
          number: 600,
          value: 'ششصد'
        }, {
          number: 500,
          value: 'پانصد'
        }, {
          number: 400,
          value: 'چهارصد'
        }, {
          number: 300,
          value: 'سیصد'
        }, {
          number: 200,
          value: 'دویست'
        }, {
          number: 100,
          value: 'صد'
        }, {
          number: 90,
          value: 'نود'
        }, {
          number: 80,
          value: 'هشتاد'
        }, {
          number: 70,
          value: 'هفتاد'
        }, {
          number: 60,
          value: 'شصت'
        }, {
          number: 50,
          value: 'پنجاه'
        }, {
          number: 40,
          value: 'چهل'
        }, {
          number: 30,
          value: 'سی'
        }, {
          number: 20,
          value: 'بیست'
        }, {
          number: 19,
          value: 'نوزده'
        }, {
          number: 18,
          value: 'هجده'
        }, {
          number: 17,
          value: 'هفده'
        }, {
          number: 16,
          value: 'شانزده'
        }, {
          number: 15,
          value: 'پانزده'
        }, {
          number: 14,
          value: 'چهارده'
        }, {
          number: 13,
          value: 'سیزده'
        }, {
          number: 12,
          value: 'دوازده'
        }, {
          number: 11,
          value: 'یازده'
        }, {
          number: 10,
          value: 'ده'
        }, {
          number: 9,
          value: 'نه'
        }, {
          number: 8,
          value: 'هشت'
        }, {
          number: 7,
          value: 'هفت'
        }, {
          number: 6,
          value: 'شش'
        }, {
          number: 5,
          value: 'پنج'
        }, {
          number: 4,
          value: 'چهار'
        }, {
          number: 3,
          value: 'سه'
        }, {
          number: 2,
          value: 'دو'
        }, {
          number: 1,
          value: 'یک'
        }, {
          number: 0,
          value: 'صفر'
        }],
        namedLessThan1000: true,
        splitWord: 'و',
        ignoreZeroInDecimals: true,
        decimalLengthWordMapping: {
          1: 'دهم',
          2: 'صدم',
          3: 'هزارم',
          4: 'ده‌هزارم',
          5: 'صد‌هزارم',
          6: 'میلیونیوم',
          7: 'ده‌میلیونیوم',
          8: 'صد‌میلیونیوم',
          9: 'میلیاردیوم'
        }
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(faIR);

var frBE = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Euro',
          plural: 'Euros',
          symbol: '€',
          fractionalUnit: {
            name: 'Centime',
            plural: 'Centimes',
            symbol: 'Cts'
          }
        },
        texts: {
          and: 'Et',
          minus: 'Moins',
          only: '',
          point: 'Virgule'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Billiard'
        }, {
          number: 1000000000000,
          value: 'Billion'
        }, {
          number: 1000000000,
          value: 'Milliard'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Mille'
        }, {
          number: 100,
          value: 'Cent'
        }, {
          number: 99,
          value: 'Nonante-Neuf'
        }, {
          number: 98,
          value: 'Nonante-Huit'
        }, {
          number: 97,
          value: 'Nonante-Sept'
        }, {
          number: 96,
          value: 'Nonante-Six'
        }, {
          number: 95,
          value: 'Nonante-Cinq'
        }, {
          number: 94,
          value: 'Nonante-Quatre'
        }, {
          number: 93,
          value: 'Nonante-Trois'
        }, {
          number: 92,
          value: 'Nonante-Deux'
        }, {
          number: 91,
          value: 'Nonante-Et-Un'
        }, {
          number: 90,
          value: 'Nonante'
        }, {
          number: 89,
          value: 'Quatre-Vingt-Neuf'
        }, {
          number: 88,
          value: 'Quatre-Vingt-Huit'
        }, {
          number: 87,
          value: 'Quatre-Vingt-Sept'
        }, {
          number: 86,
          value: 'Quatre-Vingt-Six'
        }, {
          number: 85,
          value: 'Quatre-Vingt-Cinq'
        }, {
          number: 84,
          value: 'Quatre-Vingt-Quatre'
        }, {
          number: 83,
          value: 'Quatre-Vingt-Trois'
        }, {
          number: 82,
          value: 'Quatre-Vingt-Deux'
        }, {
          number: 81,
          value: 'Quatre-Vingt-Un'
        }, {
          number: 80,
          value: 'Quatre-Vingt'
        }, {
          number: 79,
          value: 'Septante-Neuf'
        }, {
          number: 78,
          value: 'Septante-Huit'
        }, {
          number: 77,
          value: 'Septante-Sept'
        }, {
          number: 76,
          value: 'Septante-Six'
        }, {
          number: 75,
          value: 'Septante-Cinq'
        }, {
          number: 74,
          value: 'Septante-Quatre'
        }, {
          number: 73,
          value: 'Septante-Trois'
        }, {
          number: 72,
          value: 'Septante-Deux'
        }, {
          number: 71,
          value: 'Septante-Et-Un'
        }, {
          number: 70,
          value: 'Septante'
        }, {
          number: 69,
          value: 'Soixante-Neuf'
        }, {
          number: 68,
          value: 'Soixante-Huit'
        }, {
          number: 67,
          value: 'Soixante-Sept'
        }, {
          number: 66,
          value: 'Soixante-Six'
        }, {
          number: 65,
          value: 'Soixante-Cinq'
        }, {
          number: 64,
          value: 'Soixante-Quatre'
        }, {
          number: 63,
          value: 'Soixante-Trois'
        }, {
          number: 62,
          value: 'Soixante-Deux'
        }, {
          number: 61,
          value: 'Soixante-Et-Un'
        }, {
          number: 60,
          value: 'Soixante'
        }, {
          number: 59,
          value: 'Cinquante-Neuf'
        }, {
          number: 58,
          value: 'Cinquante-Huit'
        }, {
          number: 57,
          value: 'Cinquante-Sept'
        }, {
          number: 56,
          value: 'Cinquante-Six'
        }, {
          number: 55,
          value: 'Cinquante-Cinq'
        }, {
          number: 54,
          value: 'Cinquante-Quatre'
        }, {
          number: 53,
          value: 'Cinquante-Trois'
        }, {
          number: 52,
          value: 'Cinquante-Deux'
        }, {
          number: 51,
          value: 'Cinquante-Et-Un'
        }, {
          number: 50,
          value: 'Cinquante'
        }, {
          number: 49,
          value: 'Quarante-Neuf'
        }, {
          number: 48,
          value: 'Quarante-Huit'
        }, {
          number: 47,
          value: 'Quarante-Sept'
        }, {
          number: 46,
          value: 'Quarante-Six'
        }, {
          number: 45,
          value: 'Quarante-Cinq'
        }, {
          number: 44,
          value: 'Quarante-Quatre'
        }, {
          number: 43,
          value: 'Quarante-Trois'
        }, {
          number: 42,
          value: 'Quarante-Deux'
        }, {
          number: 41,
          value: 'Quarante-Et-Un'
        }, {
          number: 40,
          value: 'Quarante'
        }, {
          number: 39,
          value: 'Trente-Neuf'
        }, {
          number: 38,
          value: 'Trente-Huit'
        }, {
          number: 37,
          value: 'Trente-Sept'
        }, {
          number: 36,
          value: 'Trente-Six'
        }, {
          number: 35,
          value: 'Trente-Cinq'
        }, {
          number: 34,
          value: 'Trente-Quatre'
        }, {
          number: 33,
          value: 'Trente-Trois'
        }, {
          number: 32,
          value: 'Trente-Deux'
        }, {
          number: 31,
          value: 'Trente-Et-Un'
        }, {
          number: 30,
          value: 'Trente'
        }, {
          number: 29,
          value: 'Vingt-Neuf'
        }, {
          number: 28,
          value: 'Vingt-Huit'
        }, {
          number: 27,
          value: 'Vingt-Sept'
        }, {
          number: 26,
          value: 'Vingt-Six'
        }, {
          number: 25,
          value: 'Vingt-Cinq'
        }, {
          number: 24,
          value: 'Vingt-Quatre'
        }, {
          number: 23,
          value: 'Vingt-Trois'
        }, {
          number: 22,
          value: 'Vingt-Deux'
        }, {
          number: 21,
          value: 'Vingt-Et-Un'
        }, {
          number: 20,
          value: 'Vingt'
        }, {
          number: 19,
          value: 'Dix-Neuf'
        }, {
          number: 18,
          value: 'Dix-Huit'
        }, {
          number: 17,
          value: 'Dix-Sept'
        }, {
          number: 16,
          value: 'Seize'
        }, {
          number: 15,
          value: 'Quinze'
        }, {
          number: 14,
          value: 'Quatorze'
        }, {
          number: 13,
          value: 'Treize'
        }, {
          number: 12,
          value: 'Douze'
        }, {
          number: 11,
          value: 'Onze'
        }, {
          number: 10,
          value: 'Dix'
        }, {
          number: 9,
          value: 'Neuf'
        }, {
          number: 8,
          value: 'Huit'
        }, {
          number: 7,
          value: 'Sept'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Cinq'
        }, {
          number: 4,
          value: 'Quatre'
        }, {
          number: 3,
          value: 'Trois'
        }, {
          number: 2,
          value: 'Deux'
        }, {
          number: 1,
          value: 'Un'
        }, {
          number: 0,
          value: 'Zéro'
        }],
        ignoreOneForWords: ['Cent', 'Mille'],
        pluralMark: 's',
        pluralWords: ['Billiard', 'Billion', 'Milliard', 'Million']
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(frBE);

var frFR = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Euro',
          plural: 'Euros',
          symbol: '€',
          fractionalUnit: {
            name: 'Centime',
            plural: 'Centimes',
            symbol: 'Cts'
          }
        },
        texts: {
          and: 'Et',
          minus: 'Moins',
          only: '',
          point: 'Virgule'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Billiard'
        }, {
          number: 1000000000000,
          value: 'Billion'
        }, {
          number: 1000000000,
          value: 'Milliard'
        }, {
          number: 1000000,
          value: 'Million'
        }, {
          number: 1000,
          value: 'Mille'
        }, {
          number: 100,
          value: 'Cent'
        }, {
          number: 99,
          value: 'Quatre-Vingt-Dix-Neuf'
        }, {
          number: 98,
          value: 'Quatre-Vingt-Dix-Huit'
        }, {
          number: 97,
          value: 'Quatre-Vingt-Dix-Sept'
        }, {
          number: 96,
          value: 'Quatre-Vingt-Seize'
        }, {
          number: 95,
          value: 'Quatre-Vingt-Quinze'
        }, {
          number: 94,
          value: 'Quatre-Vingt-Quatorze'
        }, {
          number: 93,
          value: 'Quatre-Vingt-Treize'
        }, {
          number: 92,
          value: 'Quatre-Vingt-Douze'
        }, {
          number: 91,
          value: 'Quatre-Vingt-Onze'
        }, {
          number: 90,
          value: 'Quatre-Vingt-Dix'
        }, {
          number: 89,
          value: 'Quatre-Vingt-Neuf'
        }, {
          number: 88,
          value: 'Quatre-Vingt-Huit'
        }, {
          number: 87,
          value: 'Quatre-Vingt-Sept'
        }, {
          number: 86,
          value: 'Quatre-Vingt-Six'
        }, {
          number: 85,
          value: 'Quatre-Vingt-Cinq'
        }, {
          number: 84,
          value: 'Quatre-Vingt-Quatre'
        }, {
          number: 83,
          value: 'Quatre-Vingt-Trois'
        }, {
          number: 82,
          value: 'Quatre-Vingt-Deux'
        }, {
          number: 81,
          value: 'Quatre-Vingt-Un'
        }, {
          number: 80,
          value: 'Quatre-Vingt'
        }, {
          number: 79,
          value: 'Soixante-Dix-Neuf'
        }, {
          number: 78,
          value: 'Soixante-Dix-Huit'
        }, {
          number: 77,
          value: 'Soixante-Dix-Sept'
        }, {
          number: 76,
          value: 'Soixante-Seize'
        }, {
          number: 75,
          value: 'Soixante-Quinze'
        }, {
          number: 74,
          value: 'Soixante-Quatorze'
        }, {
          number: 73,
          value: 'Soixante-Treize'
        }, {
          number: 72,
          value: 'Soixante-Douze'
        }, {
          number: 71,
          value: 'Soixante Et Onze'
        }, {
          number: 70,
          value: 'Soixante-dix'
        }, {
          number: 69,
          value: 'Soixante-Neuf'
        }, {
          number: 68,
          value: 'Soixante-Huit'
        }, {
          number: 67,
          value: 'Soixante-Sept'
        }, {
          number: 66,
          value: 'Soixante-Six'
        }, {
          number: 65,
          value: 'Soixante-Cinq'
        }, {
          number: 64,
          value: 'Soixante-Quatre'
        }, {
          number: 63,
          value: 'Soixante-Trois'
        }, {
          number: 62,
          value: 'Soixante-Deux'
        }, {
          number: 61,
          value: 'Soixante Et Un'
        }, {
          number: 60,
          value: 'Soixante'
        }, {
          number: 59,
          value: 'Cinquante-Neuf'
        }, {
          number: 58,
          value: 'Cinquante-Huit'
        }, {
          number: 57,
          value: 'Cinquante-Sept'
        }, {
          number: 56,
          value: 'Cinquante-Six'
        }, {
          number: 55,
          value: 'Cinquante-Cinq'
        }, {
          number: 54,
          value: 'Cinquante-Quatre'
        }, {
          number: 53,
          value: 'Cinquante-Trois'
        }, {
          number: 52,
          value: 'Cinquante-Deux'
        }, {
          number: 51,
          value: 'Cinquante Et Un'
        }, {
          number: 50,
          value: 'Cinquante'
        }, {
          number: 49,
          value: 'Quarante-Neuf'
        }, {
          number: 48,
          value: 'Quarante-Huit'
        }, {
          number: 47,
          value: 'Quarante-Sept'
        }, {
          number: 46,
          value: 'Quarante-Six'
        }, {
          number: 45,
          value: 'Quarante-Cinq'
        }, {
          number: 44,
          value: 'Quarante-Quatre'
        }, {
          number: 43,
          value: 'Quarante-Trois'
        }, {
          number: 42,
          value: 'Quarante-Deux'
        }, {
          number: 41,
          value: 'Quarante Et Un'
        }, {
          number: 40,
          value: 'Quarante'
        }, {
          number: 39,
          value: 'Trente-Neuf'
        }, {
          number: 38,
          value: 'Trente-Huit'
        }, {
          number: 37,
          value: 'Trente-Sept'
        }, {
          number: 36,
          value: 'Trente-Six'
        }, {
          number: 35,
          value: 'Trente-Cinq'
        }, {
          number: 34,
          value: 'Trente-Quatre'
        }, {
          number: 33,
          value: 'Trente-Trois'
        }, {
          number: 32,
          value: 'Trente-Deux'
        }, {
          number: 31,
          value: 'Trente Et Un'
        }, {
          number: 30,
          value: 'Trente'
        }, {
          number: 29,
          value: 'Vingt-Neuf'
        }, {
          number: 28,
          value: 'Vingt-Huit'
        }, {
          number: 27,
          value: 'Vingt-Sept'
        }, {
          number: 26,
          value: 'Vingt-Six'
        }, {
          number: 25,
          value: 'Vingt-Cinq'
        }, {
          number: 24,
          value: 'Vingt-Quatre'
        }, {
          number: 23,
          value: 'Vingt-Trois'
        }, {
          number: 22,
          value: 'Vingt-Deux'
        }, {
          number: 21,
          value: 'Vingt Et Un'
        }, {
          number: 20,
          value: 'Vingt'
        }, {
          number: 19,
          value: 'Dix-Neuf'
        }, {
          number: 18,
          value: 'Dix-Huit'
        }, {
          number: 17,
          value: 'Dix-Sept'
        }, {
          number: 16,
          value: 'Seize'
        }, {
          number: 15,
          value: 'Quinze'
        }, {
          number: 14,
          value: 'Quatorze'
        }, {
          number: 13,
          value: 'Treize'
        }, {
          number: 12,
          value: 'Douze'
        }, {
          number: 11,
          value: 'Onze'
        }, {
          number: 10,
          value: 'Dix'
        }, {
          number: 9,
          value: 'Neuf'
        }, {
          number: 8,
          value: 'Huit'
        }, {
          number: 7,
          value: 'Sept'
        }, {
          number: 6,
          value: 'Six'
        }, {
          number: 5,
          value: 'Cinq'
        }, {
          number: 4,
          value: 'Quatre'
        }, {
          number: 3,
          value: 'Trois'
        }, {
          number: 2,
          value: 'Deux'
        }, {
          number: 1,
          value: 'Un'
        }, {
          number: 0,
          value: 'Zéro'
        }],
        ignoreOneForWords: ['Cent', 'Mille'],
        pluralMark: 's',
        pluralWords: ['Billiard', 'Billion', 'Milliard', 'Million']
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(frFR);

var guIN = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'રૂપિયો',
          plural: 'રૂપિયા',
          symbol: '₹',
          fractionalUnit: {
            name: 'પૈસા',
            plural: 'પૈસા',
            symbol: ''
          }
        },
        texts: {
          and: 'અને',
          minus: 'ઋણ',
          only: '',
          point: 'દશાંશ'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'કરોડ'
        }, {
          number: 100000,
          value: 'લાખ'
        }, {
          number: 1000,
          value: 'હજાર'
        }, {
          number: 100,
          value: 'સો'
        }, {
          number: 99,
          value: 'નવ્વાણું'
        }, {
          number: 98,
          value: 'અઠ્ઠાણું'
        }, {
          number: 97,
          value: 'સત્તાણું'
        }, {
          number: 96,
          value: 'છન્નું'
        }, {
          number: 95,
          value: 'પંચાણું'
        }, {
          number: 94,
          value: 'ચોરાણું'
        }, {
          number: 93,
          value: 'ત્રાણું'
        }, {
          number: 92,
          value: 'બાણું'
        }, {
          number: 91,
          value: 'એકાણું'
        }, {
          number: 90,
          value: 'નેવું'
        }, {
          number: 89,
          value: 'નેવ્યાસી'
        }, {
          number: 88,
          value: 'ઈઠ્યાસી'
        }, {
          number: 87,
          value: 'સિત્યાસી'
        }, {
          number: 86,
          value: 'છ્યાસી'
        }, {
          number: 85,
          value: 'પંચ્યાસી'
        }, {
          number: 84,
          value: 'ચોર્યાસી'
        }, {
          number: 83,
          value: 'ત્યાસી'
        }, {
          number: 82,
          value: 'બ્યાસી'
        }, {
          number: 81,
          value: 'એક્યાસી'
        }, {
          number: 80,
          value: 'એંસી'
        }, {
          number: 79,
          value: 'ઓગણાએંસી'
        }, {
          number: 78,
          value: 'ઇઠ્યોતેર'
        }, {
          number: 77,
          value: 'સિત્યોતેર'
        }, {
          number: 76,
          value: 'છોતેર'
        }, {
          number: 75,
          value: 'પંચોતેર'
        }, {
          number: 74,
          value: 'ચુમોતેર'
        }, {
          number: 73,
          value: 'તોતેર'
        }, {
          number: 72,
          value: 'બોતેર'
        }, {
          number: 71,
          value: 'એકોતેર'
        }, {
          number: 70,
          value: 'સિત્તેર'
        }, {
          number: 69,
          value: 'ઓગણોસિત્તેર'
        }, {
          number: 68,
          value: 'અડસઠ'
        }, {
          number: 67,
          value: 'સડસઠ'
        }, {
          number: 66,
          value: 'છાસઠ'
        }, {
          number: 65,
          value: 'પાંસઠ'
        }, {
          number: 64,
          value: 'ચોસઠ'
        }, {
          number: 63,
          value: 'ત્રેસઠ'
        }, {
          number: 62,
          value: 'બાસઠ'
        }, {
          number: 61,
          value: 'એકસઠ'
        }, {
          number: 60,
          value: 'સાઈઠ'
        }, {
          number: 59,
          value: 'ઓગણસાઠ'
        }, {
          number: 58,
          value: 'અઠ્ઠાવન'
        }, {
          number: 57,
          value: 'સત્તાવન'
        }, {
          number: 56,
          value: 'છપ્પન'
        }, {
          number: 55,
          value: 'પંચાવન'
        }, {
          number: 54,
          value: 'ચોપન'
        }, {
          number: 53,
          value: 'ત્રેપન'
        }, {
          number: 52,
          value: 'બાવન'
        }, {
          number: 51,
          value: 'એકાવન'
        }, {
          number: 50,
          value: 'પચાસ'
        }, {
          number: 49,
          value: 'ઓગણપચાસ'
        }, {
          number: 48,
          value: 'સુડતાલીસ'
        }, {
          number: 47,
          value: 'સુડતાલીસ'
        }, {
          number: 46,
          value: 'છેતાલીસ'
        }, {
          number: 45,
          value: 'પિસ્તાલીસ'
        }, {
          number: 44,
          value: 'ચુંમાલીસ'
        }, {
          number: 43,
          value: 'ત્રેતાલીસ'
        }, {
          number: 42,
          value: 'એકતાલીસ'
        }, {
          number: 41,
          value: 'એકતાલીસ'
        }, {
          number: 40,
          value: 'ચાલીસ'
        }, {
          number: 39,
          value: 'ઓગણચાલીસ'
        }, {
          number: 38,
          value: 'આડત્રીસ'
        }, {
          number: 37,
          value: 'સાડત્રીસ'
        }, {
          number: 36,
          value: 'છત્રીસ'
        }, {
          number: 35,
          value: 'પાંત્રીસ'
        }, {
          number: 34,
          value: 'ચોત્રીસ'
        }, {
          number: 33,
          value: 'તેત્રીસ'
        }, {
          number: 32,
          value: 'બત્રીસ'
        }, {
          number: 31,
          value: 'એકત્રીસ'
        }, {
          number: 30,
          value: 'ત્રીસ'
        }, {
          number: 29,
          value: 'ઓગણત્રીસ'
        }, {
          number: 28,
          value: 'અઠ્ઠાવીસ'
        }, {
          number: 27,
          value: 'સત્તાવીસ'
        }, {
          number: 26,
          value: 'છવીસ'
        }, {
          number: 25,
          value: 'પચ્ચીસ'
        }, {
          number: 24,
          value: 'ચોવીસ'
        }, {
          number: 23,
          value: 'તેવીસ'
        }, {
          number: 22,
          value: 'બાવીસ'
        }, {
          number: 21,
          value: 'એકવીસ'
        }, {
          number: 20,
          value: 'વીસ'
        }, {
          number: 19,
          value: 'ઓગણિસ'
        }, {
          number: 18,
          value: 'અઢાર'
        }, {
          number: 17,
          value: 'સત્તર'
        }, {
          number: 16,
          value: 'સોળ'
        }, {
          number: 15,
          value: 'પંદર'
        }, {
          number: 14,
          value: 'ચૌદ'
        }, {
          number: 13,
          value: 'તેર'
        }, {
          number: 12,
          value: 'બાર'
        }, {
          number: 11,
          value: 'અગિયાર'
        }, {
          number: 10,
          value: 'દસ'
        }, {
          number: 9,
          value: 'નવ'
        }, {
          number: 8,
          value: 'આઠ'
        }, {
          number: 7,
          value: 'સાત'
        }, {
          number: 6,
          value: 'છ'
        }, {
          number: 5,
          value: 'પાંચ'
        }, {
          number: 4,
          value: 'ચાર'
        }, {
          number: 3,
          value: 'ત્રણ'
        }, {
          number: 2,
          value: 'બે'
        }, {
          number: 1,
          value: 'એક'
        }, {
          number: 0,
          value: 'શૂન્ય'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(guIN);

var hiIN = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'रुपया',
          plural: 'रुपये',
          symbol: '₹',
          fractionalUnit: {
            name: 'पैसा',
            plural: 'पैसे',
            symbol: ''
          }
        },
        texts: {
          and: 'और',
          minus: 'ऋण',
          only: '',
          point: 'दशांश'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'करोड़'
        }, {
          number: 100000,
          value: 'लाख'
        }, {
          number: 1000,
          value: 'हज़ार'
        }, {
          number: 100,
          value: 'सौ'
        }, {
          number: 99,
          value: 'निन्यानवे'
        }, {
          number: 98,
          value: 'अट्ठानवे'
        }, {
          number: 97,
          value: 'सत्तानवे'
        }, {
          number: 96,
          value: 'छियानवे'
        }, {
          number: 95,
          value: 'पचानवे'
        }, {
          number: 94,
          value: 'चौरानवे'
        }, {
          number: 93,
          value: 'तिरानवे'
        }, {
          number: 92,
          value: 'बानवे'
        }, {
          number: 91,
          value: 'इक्यानबे'
        }, {
          number: 90,
          value: 'नब्बे'
        }, {
          number: 89,
          value: 'नवासी'
        }, {
          number: 88,
          value: 'अठासी'
        }, {
          number: 87,
          value: 'सतासी'
        }, {
          number: 86,
          value: 'छियासी'
        }, {
          number: 85,
          value: 'पचासी'
        }, {
          number: 84,
          value: 'चौरासी'
        }, {
          number: 83,
          value: 'तिरासी'
        }, {
          number: 82,
          value: 'बयासी'
        }, {
          number: 81,
          value: 'इक्यासी'
        }, {
          number: 80,
          value: 'अस्सी'
        }, {
          number: 79,
          value: 'उनासी'
        }, {
          number: 78,
          value: 'अठहत्तर'
        }, {
          number: 77,
          value: 'सतहत्तर'
        }, {
          number: 76,
          value: 'छिहत्तर'
        }, {
          number: 75,
          value: 'पचहत्तर'
        }, {
          number: 74,
          value: 'चौहत्तर'
        }, {
          number: 73,
          value: 'तिहत्तर'
        }, {
          number: 72,
          value: 'बहत्तर'
        }, {
          number: 71,
          value: 'इकहत्तर'
        }, {
          number: 70,
          value: 'सत्तर'
        }, {
          number: 69,
          value: 'उनहत्तर'
        }, {
          number: 68,
          value: 'अड़सठ'
        }, {
          number: 67,
          value: 'सड़सठ'
        }, {
          number: 66,
          value: 'छियासठ'
        }, {
          number: 65,
          value: 'पैंसठ'
        }, {
          number: 64,
          value: 'चौंसठ'
        }, {
          number: 63,
          value: 'तिरसठ'
        }, {
          number: 62,
          value: 'बासठ'
        }, {
          number: 61,
          value: 'इकसठ'
        }, {
          number: 60,
          value: 'साठ'
        }, {
          number: 59,
          value: 'उनसठ'
        }, {
          number: 58,
          value: 'अट्ठावन'
        }, {
          number: 57,
          value: 'सत्तावन'
        }, {
          number: 56,
          value: 'छप्पन'
        }, {
          number: 55,
          value: 'पचपन'
        }, {
          number: 54,
          value: 'चौबन'
        }, {
          number: 53,
          value: 'तिरेपन'
        }, {
          number: 52,
          value: 'बावन'
        }, {
          number: 51,
          value: 'इक्याबन'
        }, {
          number: 50,
          value: 'पचास'
        }, {
          number: 49,
          value: 'उनचास'
        }, {
          number: 48,
          value: 'अड़तालीस'
        }, {
          number: 47,
          value: 'सैंतालीस'
        }, {
          number: 46,
          value: 'छियालीस'
        }, {
          number: 45,
          value: 'पैंतालीस'
        }, {
          number: 44,
          value: 'चौंतालीस'
        }, {
          number: 43,
          value: 'तैंतालीस'
        }, {
          number: 42,
          value: 'बयालीस'
        }, {
          number: 41,
          value: 'इकतालीस'
        }, {
          number: 40,
          value: 'चालीस'
        }, {
          number: 39,
          value: 'उनतालीस'
        }, {
          number: 38,
          value: 'अड़तीस'
        }, {
          number: 37,
          value: 'सैंतीस'
        }, {
          number: 36,
          value: 'छत्तीस'
        }, {
          number: 35,
          value: 'पैंतीस'
        }, {
          number: 34,
          value: 'चौंतीस'
        }, {
          number: 33,
          value: 'तैंतीस'
        }, {
          number: 32,
          value: 'बत्तीस'
        }, {
          number: 31,
          value: 'इकतीस'
        }, {
          number: 30,
          value: 'तीस'
        }, {
          number: 29,
          value: 'उनतीस'
        }, {
          number: 28,
          value: 'अट्ठाईस'
        }, {
          number: 27,
          value: 'सत्ताईस'
        }, {
          number: 26,
          value: 'छब्बीस'
        }, {
          number: 25,
          value: 'पच्चीस'
        }, {
          number: 24,
          value: 'चौबीस'
        }, {
          number: 23,
          value: 'तेईस'
        }, {
          number: 22,
          value: 'बाईस'
        }, {
          number: 21,
          value: 'इक्कीस'
        }, {
          number: 20,
          value: 'बीस'
        }, {
          number: 19,
          value: 'उन्नीस'
        }, {
          number: 18,
          value: 'अठारह'
        }, {
          number: 17,
          value: 'सत्रह'
        }, {
          number: 16,
          value: 'सोलह'
        }, {
          number: 15,
          value: 'पंद्रह'
        }, {
          number: 14,
          value: 'चौदह'
        }, {
          number: 13,
          value: 'तेरह'
        }, {
          number: 12,
          value: 'बारह'
        }, {
          number: 11,
          value: 'ग्यारह'
        }, {
          number: 10,
          value: 'दस'
        }, {
          number: 9,
          value: 'नौ'
        }, {
          number: 8,
          value: 'आठ'
        }, {
          number: 7,
          value: 'सात'
        }, {
          number: 6,
          value: 'छह'
        }, {
          number: 5,
          value: 'पांच'
        }, {
          number: 4,
          value: 'चार'
        }, {
          number: 3,
          value: 'तीन'
        }, {
          number: 2,
          value: 'दो'
        }, {
          number: 1,
          value: 'एक'
        }, {
          number: 0,
          value: 'शून्य'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(hiIN);

var mrIN = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'रुपया',
          plural: 'रुपये',
          symbol: '₹',
          fractionalUnit: {
            name: 'पैसा',
            plural: 'पैसे',
            symbol: ''
          }
        },
        texts: {
          and: 'आणि',
          minus: 'वजा',
          only: '',
          point: 'पूर्णांक'
        },
        numberWordsMapping: [{
          number: 10000000,
          value: 'कोटी'
        }, {
          number: 100000,
          value: 'लाख'
        }, {
          number: 1000,
          value: 'हजार'
        }, {
          number: 900,
          value: 'नऊशे'
        }, {
          number: 800,
          value: 'आठशे'
        }, {
          number: 700,
          value: 'सातशे'
        }, {
          number: 600,
          value: 'सहाशे'
        }, {
          number: 500,
          value: 'पाचशे'
        }, {
          number: 400,
          value: 'चारशे'
        }, {
          number: 300,
          value: 'तीनशे'
        }, {
          number: 200,
          value: 'दोनशे'
        }, {
          number: 100,
          value: 'एकशे'
        }, {
          number: 99,
          value: 'नव्व्याण्णव'
        }, {
          number: 98,
          value: 'अठ्ठ्याण्णव'
        }, {
          number: 97,
          value: 'सत्त्याण्णव'
        }, {
          number: 96,
          value: 'शहाण्णव'
        }, {
          number: 95,
          value: 'पंच्याण्णव'
        }, {
          number: 94,
          value: 'चौऱ्याण्णव'
        }, {
          number: 93,
          value: 'त्र्याण्णव'
        }, {
          number: 92,
          value: 'ब्याण्णव'
        }, {
          number: 91,
          value: 'एक्क्याण्णव'
        }, {
          number: 90,
          value: 'नव्वद'
        }, {
          number: 89,
          value: 'एकोणनव्वद'
        }, {
          number: 88,
          value: 'अठ्ठ्याऐंशी'
        }, {
          number: 87,
          value: 'सत्त्याऐंशी'
        }, {
          number: 86,
          value: 'शहाऐंशी'
        }, {
          number: 85,
          value: 'पंच्याऐंशी'
        }, {
          number: 84,
          value: 'चौऱ्याऐंशी'
        }, {
          number: 83,
          value: 'त्र्याऐंशी'
        }, {
          number: 82,
          value: 'ब्याऐंशी'
        }, {
          number: 81,
          value: 'एक्क्याऐंशी'
        }, {
          number: 80,
          value: 'ऐंशी'
        }, {
          number: 79,
          value: 'एकोणऐंशी'
        }, {
          number: 78,
          value: 'अठ्ठ्याहत्तर'
        }, {
          number: 77,
          value: 'सत्याहत्तर'
        }, {
          number: 76,
          value: 'शहात्तर'
        }, {
          number: 75,
          value: 'पंच्याहत्तर'
        }, {
          number: 74,
          value: 'चौर्‍याहत्तर'
        }, {
          number: 73,
          value: 'त्र्याहत्तर'
        }, {
          number: 72,
          value: 'बाहत्तर'
        }, {
          number: 71,
          value: 'एक्काहत्तर'
        }, {
          number: 70,
          value: 'सत्तर'
        }, {
          number: 69,
          value: 'एकोणसत्तर'
        }, {
          number: 68,
          value: 'अडुसष्ठ'
        }, {
          number: 67,
          value: 'सदुसष्ठ'
        }, {
          number: 66,
          value: 'सहासष्ठ'
        }, {
          number: 65,
          value: 'पासष्ठ'
        }, {
          number: 64,
          value: 'चौसष्ठ'
        }, {
          number: 63,
          value: 'त्रेसष्ठ'
        }, {
          number: 62,
          value: 'बासष्ठ'
        }, {
          number: 61,
          value: 'एकसष्ठ'
        }, {
          number: 60,
          value: 'साठ'
        }, {
          number: 59,
          value: 'एकोणसाठ'
        }, {
          number: 58,
          value: 'अठ्ठावन्न'
        }, {
          number: 57,
          value: 'सत्तावन्न'
        }, {
          number: 56,
          value: 'छप्पन्न'
        }, {
          number: 55,
          value: 'पंचावन्न'
        }, {
          number: 54,
          value: 'चोपन्न'
        }, {
          number: 53,
          value: 'त्रेपन्न'
        }, {
          number: 52,
          value: 'बावन्न'
        }, {
          number: 51,
          value: 'एक्कावन्न'
        }, {
          number: 50,
          value: 'पन्नास'
        }, {
          number: 49,
          value: 'एकोणपन्नास'
        }, {
          number: 48,
          value: 'अठ्ठेचाळीस'
        }, {
          number: 47,
          value: 'सत्तेचाळीस'
        }, {
          number: 46,
          value: 'सेहेचाळीस'
        }, {
          number: 45,
          value: 'पंचेचाळीस'
        }, {
          number: 44,
          value: 'चव्वेचाळीस'
        }, {
          number: 43,
          value: 'त्रेचाळीस'
        }, {
          number: 42,
          value: 'बेचाळीस'
        }, {
          number: 41,
          value: 'एक्केचाळीस'
        }, {
          number: 40,
          value: 'चाळीस'
        }, {
          number: 39,
          value: 'एकोणचाळीस'
        }, {
          number: 38,
          value: 'अडतीस'
        }, {
          number: 37,
          value: 'सदतीस'
        }, {
          number: 36,
          value: 'छत्तीस'
        }, {
          number: 35,
          value: 'पस्तीस'
        }, {
          number: 34,
          value: 'चौतीस'
        }, {
          number: 33,
          value: 'तेहेतीस'
        }, {
          number: 32,
          value: 'बत्तीस'
        }, {
          number: 31,
          value: 'एकतीस'
        }, {
          number: 30,
          value: 'तीस'
        }, {
          number: 29,
          value: 'एकोणतीस'
        }, {
          number: 28,
          value: 'अठ्ठावीस'
        }, {
          number: 27,
          value: 'सत्तावीस'
        }, {
          number: 26,
          value: 'सव्वीस'
        }, {
          number: 25,
          value: 'पंचवीस'
        }, {
          number: 24,
          value: 'चोवीस'
        }, {
          number: 23,
          value: 'तेवीस'
        }, {
          number: 22,
          value: 'बावीस'
        }, {
          number: 21,
          value: 'एकवीस'
        }, {
          number: 20,
          value: 'वीस'
        }, {
          number: 19,
          value: 'एकोणीस'
        }, {
          number: 18,
          value: 'अठरा'
        }, {
          number: 17,
          value: 'सतरा'
        }, {
          number: 16,
          value: 'सोळा'
        }, {
          number: 15,
          value: 'पंधरा'
        }, {
          number: 14,
          value: 'चौदा'
        }, {
          number: 13,
          value: 'तेरा'
        }, {
          number: 12,
          value: 'बारा'
        }, {
          number: 11,
          value: 'अकरा'
        }, {
          number: 10,
          value: 'दहा'
        }, {
          number: 9,
          value: 'नऊ'
        }, {
          number: 8,
          value: 'आठ'
        }, {
          number: 7,
          value: 'सात'
        }, {
          number: 6,
          value: 'सहा'
        }, {
          number: 5,
          value: 'पाच'
        }, {
          number: 4,
          value: 'चार'
        }, {
          number: 3,
          value: 'तीन'
        }, {
          number: 2,
          value: 'दोन'
        }, {
          number: 1,
          value: 'एक'
        }, {
          number: 0,
          value: 'शून्य'
        }],
        namedLessThan1000: true
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(mrIN);

var ptBR = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Real',
          plural: 'Reais',
          symbol: 'R$',
          fractionalUnit: {
            name: 'Centavo',
            plural: 'Centavos',
            symbol: ''
          }
        },
        texts: {
          and: 'E',
          minus: 'Menos',
          only: '',
          point: 'Vírgula'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Quadrilhões'
        }, {
          number: 1000000000000,
          value: 'Trilhões'
        }, {
          number: 1000000000,
          value: 'Bilhões'
        }, {
          number: 1000000,
          value: 'Milhões'
        }, {
          number: 1000,
          value: 'Mil'
        }, {
          number: 900,
          value: 'Novecentos'
        }, {
          number: 800,
          value: 'Oitocentos'
        }, {
          number: 700,
          value: 'Setecentos'
        }, {
          number: 600,
          value: 'Seiscentos'
        }, {
          number: 500,
          value: 'Quinhentos'
        }, {
          number: 400,
          value: 'Quatrocentos'
        }, {
          number: 300,
          value: 'Trezentos'
        }, {
          number: 200,
          value: 'Duzentos'
        }, {
          number: 100,
          value: 'Cento'
        }, {
          number: 90,
          value: 'Noventa'
        }, {
          number: 80,
          value: 'Oitenta'
        }, {
          number: 70,
          value: 'Setenta'
        }, {
          number: 60,
          value: 'Sessenta'
        }, {
          number: 50,
          value: 'Cinquenta'
        }, {
          number: 40,
          value: 'Quarenta'
        }, {
          number: 30,
          value: 'Trinta'
        }, {
          number: 20,
          value: 'Vinte'
        }, {
          number: 19,
          value: 'Dezenove'
        }, {
          number: 18,
          value: 'Dezoito'
        }, {
          number: 17,
          value: 'Dezesete'
        }, {
          number: 16,
          value: 'Dezesseis'
        }, {
          number: 15,
          value: 'Quinze'
        }, {
          number: 14,
          value: 'Quatorze'
        }, {
          number: 13,
          value: 'Treze'
        }, {
          number: 12,
          value: 'Doze'
        }, {
          number: 11,
          value: 'Onze'
        }, {
          number: 10,
          value: 'Dez'
        }, {
          number: 9,
          value: 'Nove'
        }, {
          number: 8,
          value: 'Oito'
        }, {
          number: 7,
          value: 'Sete'
        }, {
          number: 6,
          value: 'Seis'
        }, {
          number: 5,
          value: 'Cinco'
        }, {
          number: 4,
          value: 'Quatro'
        }, {
          number: 3,
          value: 'Três'
        }, {
          number: 2,
          value: 'Dois'
        }, {
          number: 1,
          value: 'Um'
        }, {
          number: 0,
          value: 'Zero'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'Cem'
        }, {
          number: 1000000000000000,
          value: 'Um Quadrilhão'
        }, {
          number: 1000000000000,
          value: 'Um Trilhão'
        }, {
          number: 1000000000,
          value: 'Um Bilhão'
        }, {
          number: 1000000,
          value: 'Um Milhão'
        }],
        ignoreOneForWords: ['Mil', 'Novecentos', 'Oitocentos', 'Setecentos', 'Seiscentos', 'Quinhentos', 'Quatrocentos', 'Trezentos', 'Duzentos', 'Cento'],
        splitWord: 'E',
        noSplitWordAfter: ['Mil', 'Milhões', 'Bilhões', 'Trilhões', 'Quadrilhões']
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(ptBR);

var trTR = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'lira',
          plural: '',
          symbol: '₺',
          fractionalUnit: {
            name: '',
            plural: 'lira',
            symbol: ''
          }
        },
        texts: {
          and: 'virgül',
          minus: 'eksi',
          only: '',
          point: 'virgül'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'katrilyon'
        }, {
          number: 1000000000000,
          value: 'trilyon'
        }, {
          number: 1000000000,
          value: 'milyar'
        }, {
          number: 1000000,
          value: 'milyon'
        }, {
          number: 1000,
          value: 'bin'
        }, {
          number: 900,
          value: 'dokuz yüz'
        }, {
          number: 800,
          value: 'sekiz yüz'
        }, {
          number: 700,
          value: 'yedi yüz'
        }, {
          number: 600,
          value: 'altı yüz'
        }, {
          number: 500,
          value: 'beş yüz'
        }, {
          number: 400,
          value: 'dört yüz'
        }, {
          number: 300,
          value: 'üç yüz'
        }, {
          number: 200,
          value: 'iki yüz'
        }, {
          number: 100,
          value: 'yüz'
        }, {
          number: 90,
          value: 'doksan'
        }, {
          number: 80,
          value: 'seksen'
        }, {
          number: 70,
          value: 'yetmiş'
        }, {
          number: 60,
          value: 'altmış'
        }, {
          number: 50,
          value: 'elli'
        }, {
          number: 40,
          value: 'kırk'
        }, {
          number: 30,
          value: 'otuz'
        }, {
          number: 20,
          value: 'yirmi'
        }, {
          number: 19,
          value: 'on dokuz'
        }, {
          number: 18,
          value: 'on sekiz'
        }, {
          number: 17,
          value: 'on yedi'
        }, {
          number: 16,
          value: 'on altı'
        }, {
          number: 15,
          value: 'on beş'
        }, {
          number: 14,
          value: 'on dört'
        }, {
          number: 13,
          value: 'on üç'
        }, {
          number: 12,
          value: 'on iki'
        }, {
          number: 11,
          value: 'on bir'
        }, {
          number: 10,
          value: 'on'
        }, {
          number: 9,
          value: 'dokuz'
        }, {
          number: 8,
          value: 'sekiz'
        }, {
          number: 7,
          value: 'yedi'
        }, {
          number: 6,
          value: 'altı'
        }, {
          number: 5,
          value: 'beş'
        }, {
          number: 4,
          value: 'dört'
        }, {
          number: 3,
          value: 'üç'
        }, {
          number: 2,
          value: 'iki'
        }, {
          number: 1,
          value: 'bir'
        }, {
          number: 0,
          value: 'sıfır'
        }],
        namedLessThan1000: true,
        ignoreZeroInDecimals: true,
        decimalLengthWordMapping: {
          1: 'onuncu',
          2: 'yüzüncü',
          3: 'bininci',
          4: 'on bininci',
          5: 'yüz bininci',
          6: 'on milyonuncu',
          7: 'milyonuncu',
          8: 'yüz milyonuncu'
        }
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(trTR);

var nlSR = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Surinaamse dollar',
          plural: 'Surinaamse dollars',
          symbol: 'SRD',
          fractionalUnit: {
            name: 'Cent',
            plural: 'Centen',
            symbol: 'SRD'
          }
        },
        texts: {
          and: 'En',
          minus: 'Negatief',
          only: '',
          point: 'Punt'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Biljard'
        }, {
          number: 1000000000000,
          value: 'Biljoen'
        }, {
          number: 1000000000,
          value: 'Miljard'
        }, {
          number: 1000000,
          value: 'Miljoen'
        }, {
          number: 1000,
          value: 'Duizend'
        }, {
          number: 100,
          value: 'Honderd'
        }, {
          number: 99,
          value: 'Negenennegentig'
        }, {
          number: 98,
          value: 'Achtennegentig'
        }, {
          number: 97,
          value: 'Zevenennegentig'
        }, {
          number: 96,
          value: 'Zesennegentig'
        }, {
          number: 95,
          value: 'Vijfennegentig'
        }, {
          number: 94,
          value: 'Vierennegentig'
        }, {
          number: 93,
          value: 'Drieënnegentig'
        }, {
          number: 92,
          value: 'Tweeënnegentig'
        }, {
          number: 91,
          value: 'Eenennegentig'
        }, {
          number: 90,
          value: 'Negentig'
        }, {
          number: 89,
          value: 'Negenentachtig'
        }, {
          number: 88,
          value: 'Achtentachtig'
        }, {
          number: 87,
          value: 'Zevenentachtig'
        }, {
          number: 86,
          value: 'Zesentachtig'
        }, {
          number: 85,
          value: 'Vijfentachtig'
        }, {
          number: 84,
          value: 'Vierentachtig'
        }, {
          number: 83,
          value: 'Drieëntachtig'
        }, {
          number: 82,
          value: 'Tweeëntachtig'
        }, {
          number: 81,
          value: 'Eenentachtig'
        }, {
          number: 80,
          value: 'Tachtig'
        }, {
          number: 79,
          value: 'Negenenzeventig'
        }, {
          number: 78,
          value: 'Achtenzeventig'
        }, {
          number: 77,
          value: 'Zevenenzeventig'
        }, {
          number: 76,
          value: 'Zesenzeventig'
        }, {
          number: 75,
          value: 'Vijfenzeventig'
        }, {
          number: 74,
          value: 'Vierenzeventig'
        }, {
          number: 73,
          value: 'Drieënzeventig'
        }, {
          number: 72,
          value: 'Tweeënzeventig'
        }, {
          number: 71,
          value: 'Eenenzeventig'
        }, {
          number: 70,
          value: 'Zeventig'
        }, {
          number: 69,
          value: 'Negenenzestig'
        }, {
          number: 68,
          value: 'Achtenzestig'
        }, {
          number: 67,
          value: 'Zevenenzestig'
        }, {
          number: 66,
          value: 'Zesenzestig'
        }, {
          number: 65,
          value: 'Vijfenzestig'
        }, {
          number: 64,
          value: 'Vierenzestig'
        }, {
          number: 63,
          value: 'Drieënzestig'
        }, {
          number: 62,
          value: 'Tweeënzestig'
        }, {
          number: 61,
          value: 'Eenenzestig'
        }, {
          number: 60,
          value: 'Zestig'
        }, {
          number: 59,
          value: 'Negenenvijftig'
        }, {
          number: 58,
          value: 'Achtenvijftig'
        }, {
          number: 57,
          value: 'Zevenenvijftig'
        }, {
          number: 56,
          value: 'Zesenvijftig'
        }, {
          number: 55,
          value: 'Vijfenvijftig'
        }, {
          number: 54,
          value: 'Vierenvijftig'
        }, {
          number: 53,
          value: 'Drieënvijftig'
        }, {
          number: 52,
          value: 'Tweeënvijftig'
        }, {
          number: 51,
          value: 'Eenenvijftig'
        }, {
          number: 50,
          value: 'Vijftig'
        }, {
          number: 49,
          value: 'Negenenveertig'
        }, {
          number: 48,
          value: 'Achtenveertig'
        }, {
          number: 47,
          value: 'Zevenenveertig'
        }, {
          number: 46,
          value: 'Zesenveertig'
        }, {
          number: 45,
          value: 'Vijfenveertig'
        }, {
          number: 44,
          value: 'Vierenveertig'
        }, {
          number: 43,
          value: 'Drieënveertig'
        }, {
          number: 42,
          value: 'Tweeënveertig'
        }, {
          number: 41,
          value: 'Eenenveertig'
        }, {
          number: 40,
          value: 'Veertig'
        }, {
          number: 39,
          value: 'Negenendertig'
        }, {
          number: 38,
          value: 'Achtendertig'
        }, {
          number: 37,
          value: 'Zevenendertig'
        }, {
          number: 36,
          value: 'Zesendertig'
        }, {
          number: 35,
          value: 'Vijfendertig'
        }, {
          number: 34,
          value: 'Vierendertig'
        }, {
          number: 33,
          value: 'Drieëndertig'
        }, {
          number: 32,
          value: 'Tweeëndertig'
        }, {
          number: 31,
          value: 'Eenendertig'
        }, {
          number: 30,
          value: 'Dertig'
        }, {
          number: 29,
          value: 'Negenentwintig'
        }, {
          number: 28,
          value: 'Achtentwintig'
        }, {
          number: 27,
          value: 'Zevenentwintig'
        }, {
          number: 26,
          value: 'Zesentwintig'
        }, {
          number: 25,
          value: 'Vijfentwintig'
        }, {
          number: 24,
          value: 'Vierentwintig'
        }, {
          number: 23,
          value: 'Drieëntwintig'
        }, {
          number: 22,
          value: 'Tweeëntwintig'
        }, {
          number: 21,
          value: 'Eenentwintig'
        }, {
          number: 20,
          value: 'Twintig'
        }, {
          number: 19,
          value: 'Negentien'
        }, {
          number: 18,
          value: 'Achttien'
        }, {
          number: 17,
          value: 'Zeventien'
        }, {
          number: 16,
          value: 'Zestien'
        }, {
          number: 15,
          value: 'Vijftien'
        }, {
          number: 14,
          value: 'Veertien'
        }, {
          number: 13,
          value: 'Dertien'
        }, {
          number: 12,
          value: 'Twaalf'
        }, {
          number: 11,
          value: 'Elf'
        }, {
          number: 10,
          value: 'Tien'
        }, {
          number: 9,
          value: 'Negen'
        }, {
          number: 8,
          value: 'Acht'
        }, {
          number: 7,
          value: 'Zeven'
        }, {
          number: 6,
          value: 'Zes'
        }, {
          number: 5,
          value: 'Vijf'
        }, {
          number: 4,
          value: 'Vier'
        }, {
          number: 3,
          value: 'Drie'
        }, {
          number: 2,
          value: 'Twee'
        }, {
          number: 1,
          value: 'Een'
        }, {
          number: 0,
          value: 'Nul'
        }],
        exactWordsMapping: [{
          number: 100,
          value: 'Honderd'
        }]
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(nlSR);

var eeEE = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  class Locale {
    constructor() {
      this.config = {
        currency: {
          name: 'Euro',
          plural: 'Eurot',
          symbol: '€',
          fractionalUnit: {
            name: 'Sent',
            plural: 'Senti',
            symbol: '¢'
          }
        },
        texts: {
          and: 'Ja',
          minus: 'Miinus',
          only: 'Ainult',
          point: 'Koma'
        },
        numberWordsMapping: [{
          number: 1000000000000000,
          value: 'Kvadriljon'
        }, {
          number: 1000000000000,
          value: 'Triljon'
        }, {
          number: 1000000000,
          value: 'Miljard'
        }, {
          number: 1000000,
          value: 'Miljon'
        }, {
          number: 1000,
          value: 'Tuhat'
        }, {
          number: 900,
          value: 'Üheksasada'
        }, {
          number: 800,
          value: 'Kaheksasada'
        }, {
          number: 700,
          value: 'Seitsesada'
        }, {
          number: 600,
          value: 'Kuussada'
        }, {
          number: 500,
          value: 'Viissada'
        }, {
          number: 400,
          value: 'Nelisada'
        }, {
          number: 300,
          value: 'Kolmsada'
        }, {
          number: 200,
          value: 'Kakssada'
        }, {
          number: 100,
          value: 'Sada'
        }, {
          number: 90,
          value: 'Üheksakümmend'
        }, {
          number: 80,
          value: 'Kaheksakümmend'
        }, {
          number: 70,
          value: 'Seitsekümmend'
        }, {
          number: 60,
          value: 'Kuuskümmend'
        }, {
          number: 50,
          value: 'Viiskümmend'
        }, {
          number: 40,
          value: 'Nelikümmend'
        }, {
          number: 30,
          value: 'Kolmkümmend'
        }, {
          number: 20,
          value: 'Kakskümmend'
        }, {
          number: 19,
          value: 'Üheksateist'
        }, {
          number: 18,
          value: 'Kaheksateist'
        }, {
          number: 17,
          value: 'Seitseteist'
        }, {
          number: 16,
          value: 'Kuusteist'
        }, {
          number: 15,
          value: 'Viisteist'
        }, {
          number: 14,
          value: 'Neliteist'
        }, {
          number: 13,
          value: 'Kolmteist'
        }, {
          number: 12,
          value: 'Kaksteist'
        }, {
          number: 11,
          value: 'Üksteist'
        }, {
          number: 10,
          value: 'Kümme'
        }, {
          number: 9,
          value: 'Üheksa'
        }, {
          number: 8,
          value: 'Kaheksa'
        }, {
          number: 7,
          value: 'Seitse'
        }, {
          number: 6,
          value: 'Kuus'
        }, {
          number: 5,
          value: 'Viis'
        }, {
          number: 4,
          value: 'Neli'
        }, {
          number: 3,
          value: 'Kolm'
        }, {
          number: 2,
          value: 'Kaks'
        }, {
          number: 1,
          value: 'Üks'
        }, {
          number: 0,
          value: 'Null'
        }],
        ignoreOneForWords: ['Sada', 'Kakssada', 'Kolmsada', 'Nelisada', 'Viissada', 'Kuussada', 'Seitsesada', 'Kaheksasada', 'Üheksasada'],
        exactWordsMapping: [{
          number: 100,
          value: 'Ükssada'
        }],
        pluralWords: ['Miljon', 'Miljard', 'Trillion', 'Kvadriljon'],
        pluralMark: 'it',
        onlyInFront: true
      };
    }
  }
  exports.default = Locale;
});
unwrapExports(eeEE);

var ToWords_1 = createCommonjsModule(function (module, exports) {

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ToWords = exports.DefaultToWordsOptions = exports.DefaultConverterOptions = void 0;
  const en_AE_1 = __importDefault(enAE);
  const en_BD_1 = __importDefault(enBD);
  const en_GH_1 = __importDefault(enGH);
  const en_IN_1 = __importDefault(enIN);
  const en_MM_1 = __importDefault(enMM);
  const en_MU_1 = __importDefault(enMU);
  const en_NG_1 = __importDefault(enNG);
  const en_NP_1 = __importDefault(enNP);
  const en_US_1 = __importDefault(enUS);
  const en_GB_1 = __importDefault(enGB);
  const en_PH_1 = __importDefault(enPH);
  const fa_IR_1 = __importDefault(faIR);
  const fr_BE_1 = __importDefault(frBE);
  const fr_FR_1 = __importDefault(frFR);
  const gu_IN_1 = __importDefault(guIN);
  const hi_IN_1 = __importDefault(hiIN);
  const mr_IN_1 = __importDefault(mrIN);
  const pt_BR_1 = __importDefault(ptBR);
  const tr_TR_1 = __importDefault(trTR);
  const nl_SR_1 = __importDefault(nlSR);
  const ee_EE_1 = __importDefault(eeEE);
  exports.DefaultConverterOptions = {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false
  };
  exports.DefaultToWordsOptions = {
    localeCode: 'en-IN',
    converterOptions: exports.DefaultConverterOptions
  };
  class ToWords {
    constructor(options = {}) {
      this.options = {};
      this.locale = undefined;
      this.options = Object.assign({}, exports.DefaultToWordsOptions, options);
    }
    getLocaleClass() {
      switch (this.options.localeCode) {
        case 'ee-EE':
          return ee_EE_1.default;
        case 'en-AE':
          return en_AE_1.default;
        case 'en-BD':
          return en_BD_1.default;
        case 'en-GH':
          return en_GH_1.default;
        case 'en-IN':
          return en_IN_1.default;
        case 'en-MM':
          return en_MM_1.default;
        case 'en-MU':
          return en_MU_1.default;
        case 'en-NG':
          return en_NG_1.default;
        case 'en-NP':
          return en_NP_1.default;
        case 'en-US':
          return en_US_1.default;
        case 'en-GB':
          return en_GB_1.default;
        case 'en-PH':
          return en_PH_1.default;
        case 'fa-IR':
          return fa_IR_1.default;
        case 'fr-BE':
          return fr_BE_1.default;
        case 'fr-FR':
          return fr_FR_1.default;
        case 'gu-IN':
          return gu_IN_1.default;
        case 'hi-IN':
          return hi_IN_1.default;
        case 'mr-IN':
          return mr_IN_1.default;
        case 'pt-BR':
          return pt_BR_1.default;
        case 'tr-TR':
          return tr_TR_1.default;
        case 'nl-SR':
          return nl_SR_1.default;
      }
      throw new Error(`Unknown Locale "${this.options.localeCode}"`);
    }
    getLocale() {
      if (this.locale === undefined) {
        const LocaleClass = this.getLocaleClass();
        this.locale = new LocaleClass();
      }
      return this.locale;
    }
    convert(number, options = {}) {
      options = Object.assign({}, this.options.converterOptions, options);
      if (!this.isValidNumber(number)) {
        throw new Error(`Invalid Number "${number}"`);
      }
      if (options.ignoreDecimal) {
        number = Number.parseInt(number.toString());
      }
      let words = [];
      if (options.currency) {
        words = this.convertCurrency(number, options);
      } else {
        words = this.convertNumber(number);
      }
      return words.join(' ');
    }
    convertNumber(number) {
      var _a, _b, _c;
      const locale = this.getLocale();
      const isNegativeNumber = number < 0;
      if (isNegativeNumber) {
        number = Math.abs(number);
      }
      const split = number.toString().split('.');
      const ignoreZero = this.isNumberZero(number) && locale.config.ignoreZeroInDecimals;
      let words = this.convertInternal(Number(split[0]));
      const isFloat = this.isFloat(number);
      if (isFloat && ignoreZero) {
        words = [];
      }
      const wordsWithDecimal = [];
      if (isFloat) {
        if (!ignoreZero) {
          wordsWithDecimal.push(locale.config.texts.point);
        }
        if (split[1].startsWith('0') && !((_a = locale.config) === null || _a === void 0 ? void 0 : _a.decimalLengthWordMapping)) {
          const zeroWords = [];
          for (const num of split[1]) {
            zeroWords.push(...this.convertInternal(Number(num)));
          }
          wordsWithDecimal.push(...zeroWords);
        } else {
          wordsWithDecimal.push(...this.convertInternal(Number(split[1])));
          const decimalLengthWord = (_c = (_b = locale.config) === null || _b === void 0 ? void 0 : _b.decimalLengthWordMapping) === null || _c === void 0 ? void 0 : _c[split[1].length];
          if (decimalLengthWord) {
            wordsWithDecimal.push(decimalLengthWord);
          }
        }
      }
      const isEmpty = words.length <= 0;
      if (!isEmpty && isNegativeNumber) {
        words.unshift(locale.config.texts.minus);
      }
      words.push(...wordsWithDecimal);
      return words;
    }
    convertCurrency(number, options = {}) {
      var _a, _b, _c, _d;
      const locale = this.getLocale();
      const currencyOptions = (_a = options.currencyOptions) !== null && _a !== void 0 ? _a : locale.config.currency;
      const isNegativeNumber = number < 0;
      if (isNegativeNumber) {
        number = Math.abs(number);
      }
      number = this.toFixed(number);
      const split = number.toString().split('.');
      let words = [...this.convertInternal(Number(split[0]))];
      if (currencyOptions.plural) {
        words.push(currencyOptions.plural);
      }
      const ignoreZero = this.isNumberZero(number) && (options.ignoreZeroCurrency || ((_b = locale.config) === null || _b === void 0 ? void 0 : _b.ignoreZeroInDecimals) && number !== 0);
      if (ignoreZero) {
        words = [];
      }
      const wordsWithDecimal = [];
      const isFloat = this.isFloat(number);
      if (isFloat) {
        if (!ignoreZero) {
          wordsWithDecimal.push(locale.config.texts.and);
        }
        wordsWithDecimal.push(...this.convertInternal(Number(split[1]) * (!locale.config.decimalLengthWordMapping ? Math.pow(10, 2 - split[1].length) : 1)));
        const decimalLengthWord = (_d = (_c = locale.config) === null || _c === void 0 ? void 0 : _c.decimalLengthWordMapping) === null || _d === void 0 ? void 0 : _d[split[1].length];
        if (decimalLengthWord === null || decimalLengthWord === void 0 ? void 0 : decimalLengthWord.length) {
          wordsWithDecimal.push(decimalLengthWord);
        }
        wordsWithDecimal.push(currencyOptions.fractionalUnit.plural);
      } else if (locale.config.decimalLengthWordMapping && words.length) {
        wordsWithDecimal.push(currencyOptions.fractionalUnit.plural);
      }
      const isEmpty = words.length <= 0 && wordsWithDecimal.length <= 0;
      if (!isEmpty && isNegativeNumber) {
        words.unshift(locale.config.texts.minus);
      }
      if (!isEmpty && locale.config.texts.only && !options.doNotAddOnly && !locale.config.onlyInFront) {
        wordsWithDecimal.push(locale.config.texts.only);
      }
      if (wordsWithDecimal.length) {
        words.push(...wordsWithDecimal);
      }
      if (!isEmpty && !options.doNotAddOnly && locale.config.onlyInFront) {
        words.splice(0, 0, locale.config.texts.only);
      }
      return words;
    }
    convertInternal(number) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      const locale = this.getLocale();
      if (locale.config.exactWordsMapping) {
        const exactMatch = (_b = (_a = locale.config) === null || _a === void 0 ? void 0 : _a.exactWordsMapping) === null || _b === void 0 ? void 0 : _b.find(elem => {
          return number === elem.number;
        });
        if (exactMatch) {
          return [exactMatch.value];
        }
      }
      const match = locale.config.numberWordsMapping.find(elem => {
        return number >= elem.number;
      });
      const words = [];
      if (number <= 100 || number < 1000 && locale.config.namedLessThan1000) {
        words.push(match.value);
        number -= match.number;
        if (number > 0) {
          if ((_d = (_c = locale.config) === null || _c === void 0 ? void 0 : _c.splitWord) === null || _d === void 0 ? void 0 : _d.length) {
            words.push(locale.config.splitWord);
          }
          words.push(...this.convertInternal(number));
        }
        return words;
      }
      const quotient = Math.floor(number / match.number);
      const remainder = number % match.number;
      let matchValue = match.value;
      if (quotient > 1 && ((_f = (_e = locale.config) === null || _e === void 0 ? void 0 : _e.pluralWords) === null || _f === void 0 ? void 0 : _f.find(word => word === match.value)) && ((_g = locale.config) === null || _g === void 0 ? void 0 : _g.pluralMark)) {
        matchValue += locale.config.pluralMark;
      }
      if (quotient === 1 && ((_j = (_h = locale.config) === null || _h === void 0 ? void 0 : _h.ignoreOneForWords) === null || _j === void 0 ? void 0 : _j.includes(matchValue))) {
        words.push(matchValue);
      } else {
        words.push(...this.convertInternal(quotient), matchValue);
      }
      if (remainder > 0) {
        if ((_l = (_k = locale.config) === null || _k === void 0 ? void 0 : _k.splitWord) === null || _l === void 0 ? void 0 : _l.length) {
          if (!((_o = (_m = locale.config) === null || _m === void 0 ? void 0 : _m.noSplitWordAfter) === null || _o === void 0 ? void 0 : _o.find(word => word === match.value))) {
            words.push(locale.config.splitWord);
          }
        }
        words.push(...this.convertInternal(remainder));
      }
      return words;
    }
    toFixed(number, precision = 2) {
      return Number(Number(number).toFixed(precision));
    }
    isFloat(number) {
      return Number(number) === number && number % 1 !== 0;
    }
    isValidNumber(number) {
      return !isNaN(parseFloat(number)) && isFinite(number);
    }
    isNumberZero(number) {
      return number >= 0 && number < 1;
    }
  }
  exports.ToWords = ToWords;
});
unwrapExports(ToWords_1);
var ToWords_2 = ToWords_1.ToWords;

const PaymentPrint = props => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _applicationDetails$a3, _applicationDetails$a4, _applicationDetails$a5, _applicationDetails$a6, _applicationDetails$a7;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords_2();
  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const getApplicationPay = async () => {
    setLoader(true);
    let requestInfo = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: "v1",
        ts: 0,
        action: "_search",
        did: "",
        key: "",
        msgId: "090909",
        requesterId: "",
        authToken: authToken,
        userInfo: userInfo
      }
    };
    try {
      var _Resp$Transaction, _Resp$Transaction2, _Resp$Transaction2$, _Resp$Transaction2$$a, _Resp$Transaction2$$a2;
      const Resp = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then(response => {
        return response === null || response === void 0 ? void 0 : response.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction = Resp.Transaction) === null || _Resp$Transaction === void 0 ? void 0 : _Resp$Transaction[0]);
      const amountPaid = Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction2 = Resp.Transaction) === null || _Resp$Transaction2 === void 0 ? void 0 : (_Resp$Transaction2$ = _Resp$Transaction2[0]) === null || _Resp$Transaction2$ === void 0 ? void 0 : (_Resp$Transaction2$$a = _Resp$Transaction2$.additionalDetails) === null || _Resp$Transaction2$$a === void 0 ? void 0 : (_Resp$Transaction2$$a2 = _Resp$Transaction2$$a.taxAndPayments[0]) === null || _Resp$Transaction2$$a2 === void 0 ? void 0 : _Resp$Transaction2$$a2.amountPaid;
      if (amountPaid) {
        const wordsList = toWords.convert(amountPaid, {
          currency: true,
          ignoreDecimal: false
        });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getApplicationPay();
  }, [id]);
  const {
    isLoading,
    data: applicationDetails
  } = Digit.Hooks.obps.useLicenseDetails(stateId, {
    applicationNumber: id
  }, {});
  const {
    eg_pg_txnid: egId,
    txnStatus: txn,
    workflow: workflw
  } = Digit.Hooks.useQueryParams();
  const {
    isLoading: paymentLoading,
    data,
    isError
  } = Digit.Hooks.usePaymentUpdate({
    egId,
    txn
  }, {
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
  useEffect(() => {
    const fetchData = async () => {
      var _applicationDetails$a, _applicationDetails$a2, _Digit$UserService$ge3;
      const department = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.department;
      const locationDistrict = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : _applicationDetails$a2.location1;
      if (!department) return;
      setLoading(true);
      const authToken = (_Digit$UserService$ge3 = Digit.UserService.getUser()) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.access_token;
      const requestInfo = {
        RequestInfo: {
          apiId: "Rainmaker",
          msgId: "1669293303096|en_IN",
          authToken: authToken
        }
      };
      let url = `${Urls$1.logoUrl.bpaLogoUrl}department=${department}`;
      if (department !== "AVP" && locationDistrict) {
        url += `&district=${locationDistrict}`;
      }
      try {
        const response = await axios$1.post(url, requestInfo);
        setLogoData(response === null || response === void 0 ? void 0 : response.data);
        console.log("Logo API response:", response === null || response === void 0 ? void 0 : response.data);
      } catch (error) {
        console.error("Logo API call failed:", error);
        setLogoData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a3 = applicationDetails.applicationData) === null || _applicationDetails$a3 === void 0 ? void 0 : _applicationDetails$a3.department, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a4 = applicationDetails.applicationData) === null || _applicationDetails$a4 === void 0 ? void 0 : _applicationDetails$a4.location1]);
  if (loading || loader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log({
    scrutinyTable,
    amountDetails,
    applicationDetails,
    logoData
  }, "in ltp details slip");
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "justify-content-center",
    style: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "50%",
      minHeight: "40%",
      marginTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, null, /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormatSlip, {
    scrutinyTable: scrutinyTable,
    scrutinyDetails: applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a5 = applicationDetails.applicationData) === null || _applicationDetails$a5 === void 0 ? void 0 : (_applicationDetails$a6 = _applicationDetails$a5.tradeLicenseDetail) === null || _applicationDetails$a6 === void 0 ? void 0 : (_applicationDetails$a7 = _applicationDetails$a6.owners) === null || _applicationDetails$a7 === void 0 ? void 0 : _applicationDetails$a7[0],
    scrutinyData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    wordslist: amountDetails,
    id: id,
    logoData: logoData
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "justify-content-space-between",
    style: {
      padding: "10px",
      marginTop: 20
    }
  }, /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    style: {
      marginLeft: "85px"
    },
    label: t("CORE_COMMON_GO_TO_HOME")
  }))), /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }), /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement("button", {
      class: "btn btn-success",
      id: "invoice-print"
    }, "Print Payment Receipt"),
    content: () => conponentPDF.current
  })))));
};

const FormattedDate = ({
  timestamp,
  fallback: _fallback = "-"
}) => {
  if (!timestamp) return _fallback;
  const date = new Date(timestamp);
  const formatted = date.toLocaleString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true
  });
  return /*#__PURE__*/React__default.createElement("span", null, formatted);
};

const PaymentReceipt = ({
  scrutinyTable,
  scrutinyDetails,
  wordslist,
  logoData
}) => {
  var _scrutinyDetails$desc, _scrutinyDetails$desc2, _scrutinyDetails$desc3, _scrutinyDetails$desc4, _scrutinyDetails$desc5, _scrutinyDetails$desc6, _scrutinyTable$auditD, _scrutinyDetails$desc7, _scrutinyDetails$desc8, _scrutinyDetails$desc9, _scrutinyDetails$desc10, _scrutinyDetails$land, _scrutinyDetails$land2, _scrutinyDetails$land3, _scrutinyDetails$land4, _scrutinyDetails$land5, _scrutinyDetails$land6, _scrutinyDetails$desc11, _scrutinyDetails$desc12, _scrutinyDetails$land7, _scrutinyDetails$land8, _scrutinyDetails$land9, _scrutinyDetails$land10, _scrutinyDetails$land11, _scrutinyDetails$land12, _scrutinyDetails$land13, _scrutinyDetails$land14, _scrutinyDetails$land15, _scrutinyDetails$land16, _scrutinyDetails$land17, _scrutinyDetails$land18, _scrutinyDetails$land19, _scrutinyDetails$land20, _scrutinyDetails$land21, _scrutinyDetails$land22, _scrutinyTable$additi, _scrutinyTable$additi2, _scrutinyTable$additi3;
  const authorityName = (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.department) === "DA" ? "Development Authority" : "Avas Vikas Parishad";
  const receiptLog = (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.department) === "DA" ? true : false;
  const locationName = (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicationType) === "FORM_LANDUSE" ? scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.location1 : scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.locationDistrict;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, scrutinyTable && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Box, {
    className: "paymentReceipt"
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 3,
    className: "receipt-paper"
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "header",
    sx: {
      textAlign: "center",
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    fontWeight: "bold"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      width: "22%",
      height: "0em"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: logoData,
    alt: "logo",
    style: {
      width: receiptLog ? "5em" : "8em",
      height: receiptLog ? "3em" : "4em"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "85%",
      margin: "auto"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, locationName, " ", authorityName), /*#__PURE__*/React__default.createElement(Box, {
    className: "receipt-title"
  }, "Payment Receipt"))))), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      borderColor: "black"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    className: "section",
    sx: {
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicationNo) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicationNo), (scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnId) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Receipt No:"), " ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnId), ((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc === void 0 ? void 0 : (_scrutinyDetails$desc2 = _scrutinyDetails$desc.khasraDetails) === null || _scrutinyDetails$desc2 === void 0 ? void 0 : (_scrutinyDetails$desc3 = _scrutinyDetails$desc2[0]) === null || _scrutinyDetails$desc3 === void 0 ? void 0 : _scrutinyDetails$desc3.plotNo) || (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.plotNo)) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plot No:"), " ", (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc4 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc4 === void 0 ? void 0 : (_scrutinyDetails$desc5 = _scrutinyDetails$desc4.khasraDetails) === null || _scrutinyDetails$desc5 === void 0 ? void 0 : (_scrutinyDetails$desc6 = _scrutinyDetails$desc5[0]) === null || _scrutinyDetails$desc6 === void 0 ? void 0 : _scrutinyDetails$desc6.plotNo) || (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.plotNo)), (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.natureOfConstruction) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application type:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.natureOfConstruction), (scrutinyTable === null || scrutinyTable === void 0 ? void 0 : (_scrutinyTable$auditD = scrutinyTable.auditDetails) === null || _scrutinyTable$auditD === void 0 ? void 0 : _scrutinyTable$auditD.createdTime) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Receipt Date:"), /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.auditDetails.createdTime
  })), locationName && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "City Name:"), " ", locationName), (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc7 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc7 === void 0 ? void 0 : _scrutinyDetails$desc7.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plot sub use:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc8 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc8 === void 0 ? void 0 : _scrutinyDetails$desc8.subLandUseAsPerLayout), ((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc9 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc9 === void 0 ? void 0 : _scrutinyDetails$desc9.schemeName) || (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.schemeName)) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Scheme Name:"), " ", (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc10 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc10 === void 0 ? void 0 : _scrutinyDetails$desc10.schemeName) || (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.schemeName)), (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land = scrutinyDetails.landInfo) === null || _scrutinyDetails$land === void 0 ? void 0 : (_scrutinyDetails$land2 = _scrutinyDetails$land.owners) === null || _scrutinyDetails$land2 === void 0 ? void 0 : (_scrutinyDetails$land3 = _scrutinyDetails$land2[0]) === null || _scrutinyDetails$land3 === void 0 ? void 0 : _scrutinyDetails$land3.name) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owner Name:"), "Sh./Smt. ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land4 = scrutinyDetails.landInfo) === null || _scrutinyDetails$land4 === void 0 ? void 0 : (_scrutinyDetails$land5 = _scrutinyDetails$land4.owners) === null || _scrutinyDetails$land5 === void 0 ? void 0 : (_scrutinyDetails$land6 = _scrutinyDetails$land5[0]) === null || _scrutinyDetails$land6 === void 0 ? void 0 : _scrutinyDetails$land6.name), (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc11 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc11 === void 0 ? void 0 : _scrutinyDetails$desc11.landAddress) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement("strong", null, "Property address:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$desc12 = scrutinyDetails.descriptionOfLand) === null || _scrutinyDetails$desc12 === void 0 ? void 0 : _scrutinyDetails$desc12.landAddress, " , Uttar Pradesh"), (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land7 = scrutinyDetails.landInfo) === null || _scrutinyDetails$land7 === void 0 ? void 0 : (_scrutinyDetails$land8 = _scrutinyDetails$land7.owners) === null || _scrutinyDetails$land8 === void 0 ? void 0 : (_scrutinyDetails$land9 = _scrutinyDetails$land8[0]) === null || _scrutinyDetails$land9 === void 0 ? void 0 : (_scrutinyDetails$land10 = _scrutinyDetails$land9.correspondenceAddress) === null || _scrutinyDetails$land10 === void 0 ? void 0 : _scrutinyDetails$land10.address) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owner Communication Address:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land11 = scrutinyDetails.landInfo) === null || _scrutinyDetails$land11 === void 0 ? void 0 : (_scrutinyDetails$land12 = _scrutinyDetails$land11.owners) === null || _scrutinyDetails$land12 === void 0 ? void 0 : (_scrutinyDetails$land13 = _scrutinyDetails$land12[0]) === null || _scrutinyDetails$land13 === void 0 ? void 0 : (_scrutinyDetails$land14 = _scrutinyDetails$land13.correspondenceAddress) === null || _scrutinyDetails$land14 === void 0 ? void 0 : _scrutinyDetails$land14.address, " , Uttar Pradesh", scrutinyDetails !== null && scrutinyDetails !== void 0 && (_scrutinyDetails$land15 = scrutinyDetails.landInfo) !== null && _scrutinyDetails$land15 !== void 0 && (_scrutinyDetails$land16 = _scrutinyDetails$land15.owners) !== null && _scrutinyDetails$land16 !== void 0 && (_scrutinyDetails$land17 = _scrutinyDetails$land16[0]) !== null && _scrutinyDetails$land17 !== void 0 && (_scrutinyDetails$land18 = _scrutinyDetails$land17.correspondenceAddress) !== null && _scrutinyDetails$land18 !== void 0 && _scrutinyDetails$land18.pinno ? `, ${scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land19 = scrutinyDetails.landInfo) === null || _scrutinyDetails$land19 === void 0 ? void 0 : (_scrutinyDetails$land20 = _scrutinyDetails$land19.owners) === null || _scrutinyDetails$land20 === void 0 ? void 0 : (_scrutinyDetails$land21 = _scrutinyDetails$land20[0]) === null || _scrutinyDetails$land21 === void 0 ? void 0 : (_scrutinyDetails$land22 = _scrutinyDetails$land21.correspondenceAddress) === null || _scrutinyDetails$land22 === void 0 ? void 0 : _scrutinyDetails$land22.pinno}` : ""))))), /*#__PURE__*/React__default.createElement(Box, {
    className: "paymentReceipt"
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 3,
    className: "receipt-paper"
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "section",
    sx: {
      mt: 4
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    className: "section-heading"
  }, "Payment Details"), /*#__PURE__*/React__default.createElement(Box, {
    className: "payment-info"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Total (In INR):"), " \u20B9", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnAmount), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Amount (In Words):"), " ", wordslist), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Payment Mode:"), (scrutinyTable === null || scrutinyTable === void 0 ? void 0 : (_scrutinyTable$additi = scrutinyTable.additionalDetails) === null || _scrutinyTable$additi === void 0 ? void 0 : _scrutinyTable$additi.paymentMode) || "N/A"), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Transaction Id:"), " ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnId), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Bill Id:"), " ", (scrutinyTable === null || scrutinyTable === void 0 ? void 0 : (_scrutinyTable$additi2 = scrutinyTable.additionalDetails) === null || _scrutinyTable$additi2 === void 0 ? void 0 : _scrutinyTable$additi2.billIdFromDoubleVerification) || "N/A"), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "UTR:"), " ", (scrutinyTable === null || scrutinyTable === void 0 ? void 0 : (_scrutinyTable$additi3 = scrutinyTable.additionalDetails) === null || _scrutinyTable$additi3 === void 0 ? void 0 : _scrutinyTable$additi3.utrNo) || "N/A")))))));
};

const PaymentPrint$1 = props => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _applicationData$appl, _applicationData$Land, _applicationData$Land2, _applicationData$appl2, _applicationData$Land3, _applicationData$Land4, _daLogo$boundary, _daLogo$boundary$find, _applicationData$Land5;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    tenantId
  } = useParams();
  const id = `${authority}/${plan}/${form}/${year}/${serial}`;
  const formType = form === "LU" ? "formLandUse" : "";
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords_2();
  const [loader, setLoader] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  console.log("idFromOurcomponent", id, authority, plan, form, year, serial, tenantId);
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const getApplicationPay = async () => {
    setLoader(true);
    let requestInfo = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: "v1",
        ts: 0,
        action: "_search",
        did: "",
        key: "",
        msgId: "090909",
        requesterId: "",
        authToken: authToken,
        userInfo: userInfo
      }
    };
    try {
      var _Resp$Transaction, _Resp$Transaction2, _Resp$Transaction2$, _Resp$Transaction2$$a, _Resp$Transaction2$$a2;
      const Resp = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then(response => {
        return response === null || response === void 0 ? void 0 : response.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction = Resp.Transaction) === null || _Resp$Transaction === void 0 ? void 0 : _Resp$Transaction[0]);
      const amountPaid = Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction2 = Resp.Transaction) === null || _Resp$Transaction2 === void 0 ? void 0 : (_Resp$Transaction2$ = _Resp$Transaction2[0]) === null || _Resp$Transaction2$ === void 0 ? void 0 : (_Resp$Transaction2$$a = _Resp$Transaction2$.additionalDetails) === null || _Resp$Transaction2$$a === void 0 ? void 0 : (_Resp$Transaction2$$a2 = _Resp$Transaction2$$a.taxAndPayments[0]) === null || _Resp$Transaction2$$a2 === void 0 ? void 0 : _Resp$Transaction2$$a2.amountPaid;
      if (amountPaid > 1) {
        const wordsList = toWords.convert(amountPaid, {
          currency: true,
          ignoreDecimal: false
        });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      } else if (amountPaid === 1) {
        const wordstr = "One Rupee Only";
        setAmountDetails(wordstr);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getApplicationPay();
  }, [id]);
  const {
    data: applicationData = {},
    isLoading: paymentStatus
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id
  }, {
    formType: formType
  });
  console.log(applicationData, "aplicationData");
  const isDA = (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$appl = applicationData.applicationData) === null || _applicationData$appl === void 0 ? void 0 : _applicationData$appl.department) === "DA" || (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$Land = applicationData.LandUse) === null || _applicationData$Land === void 0 ? void 0 : (_applicationData$Land2 = _applicationData$Land[0]) === null || _applicationData$Land2 === void 0 ? void 0 : _applicationData$Land2.department) === "DA";
  const locationDistrict = (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$appl2 = applicationData.applicationData) === null || _applicationData$appl2 === void 0 ? void 0 : _applicationData$appl2.locationDistrict) || (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$Land3 = applicationData.LandUse) === null || _applicationData$Land3 === void 0 ? void 0 : (_applicationData$Land4 = _applicationData$Land3[0]) === null || _applicationData$Land4 === void 0 ? void 0 : _applicationData$Land4.location1);
  const currentLogoId = isDA ? daLogo === null || daLogo === void 0 ? void 0 : (_daLogo$boundary = daLogo.boundary) === null || _daLogo$boundary === void 0 ? void 0 : (_daLogo$boundary$find = _daLogo$boundary.find(item => item.name === locationDistrict)) === null || _daLogo$boundary$find === void 0 ? void 0 : _daLogo$boundary$find.fileStoreId : avpLogo === null || avpLogo === void 0 ? void 0 : avpLogo.fileStoreId;
  console.log("currentLogoIdFromReceipt", currentLogoId, logoStore);
  const business_service = applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService;
  const {
    eg_pg_txnid: egId,
    txnStatus: txn,
    workflow: workflw
  } = Digit.Hooks.useQueryParams();
  const {
    isLoading: paymentLoading,
    data,
    isError
  } = Digit.Hooks.usePaymentUpdate({
    egId,
    txn
  }, business_service, {
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (!currentLogoId) return;
      setLoading(true);
      const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
      setLogoUrl(result);
      setLoading(false);
    };
    fetchLogoUrl();
  }, [locationDistrict, isDA]);
  if (loading || loader || paymentStatus) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "justify-content-center",
    style: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "50%",
      minHeight: "40%",
      marginTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, null, /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PaymentReceipt, {
    scrutinyTable: scrutinyTable,
    scrutinyDetails: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationData) || (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$Land5 = applicationData.LandUse) === null || _applicationData$Land5 === void 0 ? void 0 : _applicationData$Land5[0]),
    wordslist: amountDetails,
    logoData: logoUrl
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "justify-content-space-between",
    style: {
      padding: "10px",
      marginTop: 20
    }
  }, /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    style: {
      marginLeft: "85px"
    },
    label: t("CORE_COMMON_GO_TO_HOME")
  }))), /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }), /*#__PURE__*/React__default.createElement(Col, {
    xs: "4"
  }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement(Button$2, {
      class: "btn btn-success",
      id: "invoice-print",
      variant: "outlined",
      startIcon: /*#__PURE__*/React__default.createElement(PrintIcon, null)
    }, "Print"),
    content: () => conponentPDF.current
  })))));
};

function RegistrationSummary() {
  var _summaryData$tradeLic, _summaryData$tradeLic2, _pdfDetails$pdfFiles, _summaryData$tradeLic3, _summaryData$tradeLic4, _summaryData$tradeLic5, _summaryData$tradeLic6, _summaryData$tradeLic7, _summaryData$tradeLic8, _summaryData$tradeLic9, _summaryData$tradeLic10, _summaryData$tradeLic11, _summaryData$tradeLic12, _summaryData$tradeLic13, _summaryData$tradeLic14, _summaryData$tradeLic15, _summaryData$tradeLic16, _summaryData$tradeLic17, _summaryData$tradeLic18, _summaryData$tradeLic19, _summaryData$tradeLic20, _summaryData$tradeLic21, _summaryData$tradeLic22, _summaryData$tradeLic23, _summaryData$tradeLic24, _summaryData$tradeLic25, _summaryData$tradeLic26, _summaryData$tradeLic27, _summaryData$tradeLic28, _summaryData$tradeLic29, _summaryData$tradeLic30, _summaryData$tradeLic31, _summaryData$tradeLic32, _summaryData$tradeLic33, _summaryData$tradeLic34, _summaryData$tradeLic35, _summaryData$tradeLic36, _summaryData$tradeLic37, _summaryData$tradeLic38, _summaryData$tradeLic39, _summaryData$tradeLic40, _summaryData$tradeLic41, _summaryData$tradeLic42, _summaryData$tradeLic43, _summaryData$tradeLic44, _summaryData$tradeLic45, _summaryData$tradeLic46, _summaryData$tradeLic47, _summaryData$tradeLic48, _summaryData$tradeLic49, _summaryData$tradeLic50, _summaryData$tradeLic51, _summaryData$tradeLic52, _summaryData$tradeLic53, _summaryData$tradeLic54, _summaryData$tradeLic55, _summaryData$tradeLic56, _summaryData$tradeLic57, _summaryData$tradeLic58, _summaryData$tradeLic59, _summaryData$tradeLic60, _summaryData$tradeLic61, _summaryData$tradeLic62, _summaryData$tradeLic63, _summaryData$tradeLic64, _summaryData$tradeLic65, _summaryData$tradeLic66, _summaryData$tradeLic67, _summaryData$tradeLic68, _summaryData$tradeLic69, _summaryData$tradeLic70, _summaryData$tradeLic71, _summaryData$tradeLic72, _summaryData$tradeLic73, _summaryData$tradeLic74, _summaryData$tradeLic75, _summaryData$calculat, _summaryData$calculat2, _summaryData$calculat3;
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch
  } = useForm();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const summaryData = location === null || location === void 0 ? void 0 : location.state;
  const businessService = summaryData === null || summaryData === void 0 ? void 0 : summaryData.businessService;
  const applicationNumber = summaryData === null || summaryData === void 0 ? void 0 : summaryData.applicationNumber;
  const stateId = Digit.ULBService.getStateId();
  let improvedDoc = [];
  summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic === void 0 ? void 0 : (_summaryData$tradeLic2 = _summaryData$tradeLic.applicationDocuments) === null || _summaryData$tradeLic2 === void 0 ? void 0 : _summaryData$tradeLic2.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "tl"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "tl") applicationDocs.push(pdfAppDoc);
    });
  }
  const onSubmit = data => {
    history.push(`/digit-ui/citizen/payment/collect/${businessService}/${applicationNumber}/${stateId}?tenantId=${stateId}`);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Type")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Application No')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, (summaryData === null || summaryData === void 0 ? void 0 : summaryData.applicationNumber) || '')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Applicant Type")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic3 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic3 === void 0 ? void 0 : (_summaryData$tradeLic4 = _summaryData$tradeLic3.additionalDetail) === null || _summaryData$tradeLic4 === void 0 ? void 0 : (_summaryData$tradeLic5 = _summaryData$tradeLic4.tradeLicenseDetail) === null || _summaryData$tradeLic5 === void 0 ? void 0 : (_summaryData$tradeLic6 = _summaryData$tradeLic5.tradeUnits) === null || _summaryData$tradeLic6 === void 0 ? void 0 : (_summaryData$tradeLic7 = _summaryData$tradeLic6[0]) === null || _summaryData$tradeLic7 === void 0 ? void 0 : _summaryData$tradeLic7.tradeType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Council for Architecture No.")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, (summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic8 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic8 === void 0 ? void 0 : (_summaryData$tradeLic9 = _summaryData$tradeLic8.additionalDetail) === null || _summaryData$tradeLic9 === void 0 ? void 0 : (_summaryData$tradeLic10 = _summaryData$tradeLic9.tradeLicenseDetail) === null || _summaryData$tradeLic10 === void 0 ? void 0 : (_summaryData$tradeLic11 = _summaryData$tradeLic10.additionalDetail) === null || _summaryData$tradeLic11 === void 0 ? void 0 : _summaryData$tradeLic11.counsilForArchNo) || '')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Registration Date")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, convertEpochToDateDMY(summaryData === null || summaryData === void 0 ? void 0 : summaryData.applicationDate)))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Applicant Name')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic12 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic12 === void 0 ? void 0 : (_summaryData$tradeLic13 = _summaryData$tradeLic12.owners) === null || _summaryData$tradeLic13 === void 0 ? void 0 : (_summaryData$tradeLic14 = _summaryData$tradeLic13[0]) === null || _summaryData$tradeLic14 === void 0 ? void 0 : _summaryData$tradeLic14.name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Applicant Mobile No")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic15 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic15 === void 0 ? void 0 : (_summaryData$tradeLic16 = _summaryData$tradeLic15.owners) === null || _summaryData$tradeLic16 === void 0 ? void 0 : (_summaryData$tradeLic17 = _summaryData$tradeLic16[0]) === null || _summaryData$tradeLic17 === void 0 ? void 0 : _summaryData$tradeLic17.mobileNumber)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Gender")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic18 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic18 === void 0 ? void 0 : (_summaryData$tradeLic19 = _summaryData$tradeLic18.owners) === null || _summaryData$tradeLic19 === void 0 ? void 0 : (_summaryData$tradeLic20 = _summaryData$tradeLic19[0]) === null || _summaryData$tradeLic20 === void 0 ? void 0 : _summaryData$tradeLic20.gender)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Applicant Email-Id')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic21 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic21 === void 0 ? void 0 : (_summaryData$tradeLic22 = _summaryData$tradeLic21.owners) === null || _summaryData$tradeLic22 === void 0 ? void 0 : (_summaryData$tradeLic23 = _summaryData$tradeLic22[0]) === null || _summaryData$tradeLic23 === void 0 ? void 0 : _summaryData$tradeLic23.emailId)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("College")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic24 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic24 === void 0 ? void 0 : (_summaryData$tradeLic25 = _summaryData$tradeLic24.owners) === null || _summaryData$tradeLic25 === void 0 ? void 0 : (_summaryData$tradeLic26 = _summaryData$tradeLic25[0]) === null || _summaryData$tradeLic26 === void 0 ? void 0 : _summaryData$tradeLic26.college)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("University")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic27 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic27 === void 0 ? void 0 : (_summaryData$tradeLic28 = _summaryData$tradeLic27.owners) === null || _summaryData$tradeLic28 === void 0 ? void 0 : (_summaryData$tradeLic29 = _summaryData$tradeLic28[0]) === null || _summaryData$tradeLic29 === void 0 ? void 0 : _summaryData$tradeLic29.university)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Year of Passing")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic30 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic30 === void 0 ? void 0 : (_summaryData$tradeLic31 = _summaryData$tradeLic30.owners) === null || _summaryData$tradeLic31 === void 0 ? void 0 : (_summaryData$tradeLic32 = _summaryData$tradeLic31[0]) === null || _summaryData$tradeLic32 === void 0 ? void 0 : _summaryData$tradeLic32.passingYear)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("PanCard")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic33 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic33 === void 0 ? void 0 : (_summaryData$tradeLic34 = _summaryData$tradeLic33.owners) === null || _summaryData$tradeLic34 === void 0 ? void 0 : (_summaryData$tradeLic35 = _summaryData$tradeLic34[0]) === null || _summaryData$tradeLic35 === void 0 ? void 0 : _summaryData$tradeLic35.pan))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Address Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Correspondence Address')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Permanent Address')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Address')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic36 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic36 === void 0 ? void 0 : (_summaryData$tradeLic37 = _summaryData$tradeLic36.owners) === null || _summaryData$tradeLic37 === void 0 ? void 0 : (_summaryData$tradeLic38 = _summaryData$tradeLic37[0]) === null || _summaryData$tradeLic38 === void 0 ? void 0 : (_summaryData$tradeLic39 = _summaryData$tradeLic38.correspondenceAddress) === null || _summaryData$tradeLic39 === void 0 ? void 0 : _summaryData$tradeLic39.address)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Address")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic40 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic40 === void 0 ? void 0 : (_summaryData$tradeLic41 = _summaryData$tradeLic40.owners) === null || _summaryData$tradeLic41 === void 0 ? void 0 : (_summaryData$tradeLic42 = _summaryData$tradeLic41[0]) === null || _summaryData$tradeLic42 === void 0 ? void 0 : (_summaryData$tradeLic43 = _summaryData$tradeLic42.permanentAddress) === null || _summaryData$tradeLic43 === void 0 ? void 0 : _summaryData$tradeLic43.address)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("State")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('State')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("District")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic44 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic44 === void 0 ? void 0 : (_summaryData$tradeLic45 = _summaryData$tradeLic44.owners) === null || _summaryData$tradeLic45 === void 0 ? void 0 : (_summaryData$tradeLic46 = _summaryData$tradeLic45[0]) === null || _summaryData$tradeLic46 === void 0 ? void 0 : (_summaryData$tradeLic47 = _summaryData$tradeLic46.correspondenceAddress) === null || _summaryData$tradeLic47 === void 0 ? void 0 : _summaryData$tradeLic47.district)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("District")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic48 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic48 === void 0 ? void 0 : (_summaryData$tradeLic49 = _summaryData$tradeLic48.owners) === null || _summaryData$tradeLic49 === void 0 ? void 0 : (_summaryData$tradeLic50 = _summaryData$tradeLic49[0]) === null || _summaryData$tradeLic50 === void 0 ? void 0 : (_summaryData$tradeLic51 = _summaryData$tradeLic50.permanentAddress) === null || _summaryData$tradeLic51 === void 0 ? void 0 : _summaryData$tradeLic51.district)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Tehsil")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic52 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic52 === void 0 ? void 0 : (_summaryData$tradeLic53 = _summaryData$tradeLic52.owners) === null || _summaryData$tradeLic53 === void 0 ? void 0 : (_summaryData$tradeLic54 = _summaryData$tradeLic53[0]) === null || _summaryData$tradeLic54 === void 0 ? void 0 : (_summaryData$tradeLic55 = _summaryData$tradeLic54.correspondenceAddress) === null || _summaryData$tradeLic55 === void 0 ? void 0 : _summaryData$tradeLic55.tehsil)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Tehsil")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic56 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic56 === void 0 ? void 0 : (_summaryData$tradeLic57 = _summaryData$tradeLic56.owners) === null || _summaryData$tradeLic57 === void 0 ? void 0 : (_summaryData$tradeLic58 = _summaryData$tradeLic57[0]) === null || _summaryData$tradeLic58 === void 0 ? void 0 : (_summaryData$tradeLic59 = _summaryData$tradeLic58.permanentAddress) === null || _summaryData$tradeLic59 === void 0 ? void 0 : _summaryData$tradeLic59.tehsil)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Town/Village/Ward")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic60 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic60 === void 0 ? void 0 : (_summaryData$tradeLic61 = _summaryData$tradeLic60.owners) === null || _summaryData$tradeLic61 === void 0 ? void 0 : (_summaryData$tradeLic62 = _summaryData$tradeLic61[0]) === null || _summaryData$tradeLic62 === void 0 ? void 0 : (_summaryData$tradeLic63 = _summaryData$tradeLic62.correspondenceAddress) === null || _summaryData$tradeLic63 === void 0 ? void 0 : _summaryData$tradeLic63.town)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("Town/Village/Ward")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic64 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic64 === void 0 ? void 0 : (_summaryData$tradeLic65 = _summaryData$tradeLic64.owners) === null || _summaryData$tradeLic65 === void 0 ? void 0 : (_summaryData$tradeLic66 = _summaryData$tradeLic65[0]) === null || _summaryData$tradeLic66 === void 0 ? void 0 : (_summaryData$tradeLic67 = _summaryData$tradeLic66.permanentAddress) === null || _summaryData$tradeLic67 === void 0 ? void 0 : _summaryData$tradeLic67.town)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("PinCode")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic68 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic68 === void 0 ? void 0 : (_summaryData$tradeLic69 = _summaryData$tradeLic68.owners) === null || _summaryData$tradeLic69 === void 0 ? void 0 : (_summaryData$tradeLic70 = _summaryData$tradeLic69[0]) === null || _summaryData$tradeLic70 === void 0 ? void 0 : (_summaryData$tradeLic71 = _summaryData$tradeLic70.correspondenceAddress) === null || _summaryData$tradeLic71 === void 0 ? void 0 : _summaryData$tradeLic71.pinCode)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t("PinCode")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$tradeLic72 = summaryData.tradeLicenseDetail) === null || _summaryData$tradeLic72 === void 0 ? void 0 : (_summaryData$tradeLic73 = _summaryData$tradeLic72.owners) === null || _summaryData$tradeLic73 === void 0 ? void 0 : (_summaryData$tradeLic74 = _summaryData$tradeLic73[0]) === null || _summaryData$tradeLic74 === void 0 ? void 0 : (_summaryData$tradeLic75 = _summaryData$tradeLic74.permanentAddress) === null || _summaryData$tradeLic75 === void 0 ? void 0 : _summaryData$tradeLic75.pinCode))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Document Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(applicationDocs)
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, t('Total Amount')), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6,
    md: 3
  }, summaryData === null || summaryData === void 0 ? void 0 : (_summaryData$calculat = summaryData.calculation) === null || _summaryData$calculat === void 0 ? void 0 : (_summaryData$calculat2 = _summaryData$calculat.taxHeadEstimates) === null || _summaryData$calculat2 === void 0 ? void 0 : (_summaryData$calculat3 = _summaryData$calculat2[0]) === null || _summaryData$calculat3 === void 0 ? void 0 : _summaryData$calculat3.estimateAmount)))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Make Payment",
    type: "submit"
  })))));
}

const newConfig = [{
  head: "",
  body: [{
    type: "component",
    component: "InspectionReport",
    key: "FieldReports",
    withoutLabel: true,
    hideInCitizen: true
  }]
}];

function ApplicationDetailsToast({
  t,
  showToast,
  closeToast,
  businessService
}) {
  var _showToast$error, _showToast$error2, _showToast$error3, _showToast$error4, _showToast$error5, _showToast$error6, _showToast$error7, _showToast$error8, _showToast$action2, _showToast$error9, _showToast$error10, _showToast$error11, _showToast$error12, _showToast$error13, _showToast$error14, _showToast$error15, _showToast$error16, _showToast$action4;
  if (businessService !== null && businessService !== void 0 && businessService.includes("NewTL") || businessService !== null && businessService !== void 0 && businessService.includes("TL") || businessService !== null && businessService !== void 0 && businessService.includes("EDITRENEWAL")) {
    var _showToast$action;
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action = showToast.action) === null || _showToast$action === void 0 ? void 0 : _showToast$action.action) {
      case "SENDBACK":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error = showToast.error) === null || _showToast$error === void 0 ? void 0 : _showToast$error.message : t("TL_SENDBACK_CHECKLIST_MESSAGE_HEAD");
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error2 = showToast.error) === null || _showToast$error2 === void 0 ? void 0 : _showToast$error2.message : t("TL_FORWARD_SUCCESS_MESSAGE_MAIN");
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error3 = showToast.error) === null || _showToast$error3 === void 0 ? void 0 : _showToast$error3.message : t("TL_APPROVAL_CHECKLIST_MESSAGE_HEAD");
        break;
      case "SENDBACKTOCITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error4 = showToast.error) === null || _showToast$error4 === void 0 ? void 0 : _showToast$error4.message : t("TL_SENDBACK_TOCITIZEN_CHECKLIST_MESSAGE_HEAD");
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error5 = showToast.error) === null || _showToast$error5 === void 0 ? void 0 : _showToast$error5.message : t("TL_APPROVAL_REJ_MESSAGE_HEAD");
        break;
      case "RESUBMIT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error6 = showToast.error) === null || _showToast$error6 === void 0 ? void 0 : _showToast$error6.message : t("TL_APPLICATION_RESUBMIT_SUCCESS_MESSAGE_MAIN");
        break;
      case "CANCEL":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error7 = showToast.error) === null || _showToast$error7 === void 0 ? void 0 : _showToast$error7.message : t("TL_TL_CANCELLED_MESSAGE_HEAD");
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error8 = showToast.error) === null || _showToast$error8 === void 0 ? void 0 : _showToast$error8.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action2 = showToast.action) === null || _showToast$action2 === void 0 ? void 0 : _showToast$action2.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else if (businessService !== null && businessService !== void 0 && businessService.includes("BPA") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_LOW") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC")) {
    var _showToast$action3;
    const getMessage = (messages = []) => {
      let returnValue = messages[0];
      if ((messages === null || messages === void 0 ? void 0 : messages.length) == 2) returnValue = businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC") ? t(messages[1]) : t(messages[0]);else returnValue = t(messages[0]);
      return returnValue;
    };
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action3 = showToast.action) === null || _showToast$action3 === void 0 ? void 0 : _showToast$action3.action) {
      case "REVOCATE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error9 = showToast.error) === null || _showToast$error9 === void 0 ? void 0 : _showToast$error9.message : getMessage(["BPA_APPROVAL_REVOCATED_MESSAGE_HEAD", "BPA_APPROVAL_OC_REVOCATED_MESSAGE_HEAD"]);
        break;
      case "VERIFY_AND_FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error10 = showToast.error) === null || _showToast$error10 === void 0 ? void 0 : _showToast$error10.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_TO_CITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error11 = showToast.error) === null || _showToast$error11 === void 0 ? void 0 : _showToast$error11.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error12 = showToast.error) === null || _showToast$error12 === void 0 ? void 0 : _showToast$error12.message : getMessage(["BPA_APPROVAL_CHECKLIST_MESSAGE_HEAD"]);
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error13 = showToast.error) === null || _showToast$error13 === void 0 ? void 0 : _showToast$error13.message : getMessage(["BPA_APPROVAL_REJECTED_MESSAGE_HEAD", "BPA_OC_APPROVAL_REJECTED_MESSAGE_HEAD"]);
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error14 = showToast.error) === null || _showToast$error14 === void 0 ? void 0 : _showToast$error14.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_FOR_DOCUMENT_VERIFICATION":
      case "SEND_BACK_FOR_FIELD_INSPECTION":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error15 = showToast.error) === null || _showToast$error15 === void 0 ? void 0 : _showToast$error15.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error16 = showToast.error) === null || _showToast$error16 === void 0 ? void 0 : _showToast$error16.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action4 = showToast.action) === null || _showToast$action4 === void 0 ? void 0 : _showToast$action4.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else {
    var _showToast$error17, _showToast$action5;
    const label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error17 = showToast.error) === null || _showToast$error17 === void 0 ? void 0 : _showToast$error17.message : `ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action5 = showToast.action) === null || _showToast$action5 === void 0 ? void 0 : _showToast$action5.action}_UPDATE_SUCCESS`;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
      error: showToast.key === "error",
      label: t(label),
      onClose: closeToast
    }));
  }
}

function ApplicationDetailsActionBar({
  workflowDetails,
  displayMenu,
  onActionSelect,
  setDisplayMenu,
  businessService,
  forcedActionPrefix,
  ActionBarStyle = {},
  MenuStyle = {},
  applicationDetails
}) {
  var _user, _user$info, _user$info$roles, _applicationDetails$a, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _actions$, _actions$$redirection, _workflowDetails$data4, _workflowDetails$data5, _actions$2, _actions$3, _actions$4;
  const {
    t
  } = useTranslation();
  let user = Digit.UserService.getUser();
  if (window.location.href.includes("/obps") || window.location.href.includes("/noc")) {
    const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
    const userInfo = userInfos ? JSON.parse(userInfos) : {};
    user = userInfo === null || userInfo === void 0 ? void 0 : userInfo.value;
  }
  const userRoles = (_user = user) === null || _user === void 0 ? void 0 : (_user$info = _user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.map(e => e.code);
  let isSingleButton = false;
  let isMenuBotton = false;
  let isbelow = (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.plotArea) < 2500;
  const isTCP = userRoles.includes("TCP_HQ");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.filter(e => {
    if (isbelow && isTCP && e.action === "SEND_TO_STP" && businessService === "BPA") {
      return false;
    } else if (!isbelow && isTCP && (e.action === "APPROVE" || e.action === "APPROVAL_LETTER_GENERATE" || e.action === "REJECT") && businessService === "BPA") {
      return false;
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  if ((window.location.href.includes("/obps") || window.location.href.includes("/noc")) && (actions === null || actions === void 0 ? void 0 : actions.length) == 1 || actions !== null && actions !== void 0 && (_actions$ = actions[0]) !== null && _actions$ !== void 0 && (_actions$$redirection = _actions$.redirectionUrl) !== null && _actions$$redirection !== void 0 && _actions$$redirection.pathname.includes("/pt/property-details/") && (actions === null || actions === void 0 ? void 0 : actions.length) == 1) {
    isMenuBotton = false;
    isSingleButton = true;
  } else if ((actions === null || actions === void 0 ? void 0 : actions.length) > 0) {
    isMenuBotton = true;
    isSingleButton = false;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && isMenuBotton && !isSingleButton && /*#__PURE__*/React__default.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, displayMenu && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data4 = workflowDetails.data) !== null && _workflowDetails$data4 !== void 0 && (_workflowDetails$data5 = _workflowDetails$data4.actionState) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.nextActions ? /*#__PURE__*/React__default.createElement(Menu, {
    localeKeyPrefix: forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`,
    options: actions,
    optionKey: "action",
    t: t,
    onSelect: onActionSelect,
    style: MenuStyle
  }) : null, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("WF_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isMenuBotton && isSingleButton && /*#__PURE__*/React__default.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    style: {
      color: "#FFFFFF",
      fontSize: "19px"
    },
    className: "submit-bar",
    name: actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action,
    value: actions === null || actions === void 0 ? void 0 : (_actions$3 = actions[0]) === null || _actions$3 === void 0 ? void 0 : _actions$3.action,
    onClick: e => {
      onActionSelect((actions === null || actions === void 0 ? void 0 : actions[0]) || {});
    }
  }, t(`${forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`}_${actions === null || actions === void 0 ? void 0 : (_actions$4 = actions[0]) === null || _actions$4 === void 0 ? void 0 : _actions$4.action}`))));
}

const Close = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close, null));
};
function ApplicationDetailsWarningPopup({
  action,
  workflowDetails,
  businessService,
  isWarningPop,
  closeWarningPopup
}) {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement("h1", {
      className: "heading-m"
    }, t("PT_DUES_ARE_PENDING")),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn, {
      onClick: () => {
        closeWarningPopup();
      }
    }),
    hideSubmit: true,
    isDisabled: false,
    popupStyles: isMobile ? {} : {
      width: "29%",
      marginTop: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("h1", null, t("PT_YOU_HAVE"), " \u20B9", action === null || action === void 0 ? void 0 : action.AmountDueForPay, " ", t("PT_DUE_WARNING_MSG2"))), /*#__PURE__*/React__default.createElement(Row, {
    rowContainerStyle: {
      display: "flex"
    },
    labelStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginRight: "10%"
    },
    textStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginBottom: "20px"
    },
    label: `${t("PT_AMOUNT_DUE")}`,
    text: `₹${t(action === null || action === void 0 ? void 0 : action.AmountDueForPay)}`
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonSelector, {
    theme: "border",
    label: t('ES_PT_COMMON_CANCEL'),
    onSubmit: closeWarningPopup,
    style: {
      marginLeft: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(ButtonSelector, {
    label: t('PT_COLLECT'),
    onSubmit: () => {
      var _action$redirectionUr;
      return window.location.assign(`${window.location.origin}${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrl) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
    },
    style: {
      marginLeft: "10px"
    }
  })))), ")");
}

var bind$1 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var toString$1 = Object.prototype.toString;
function isArray$1(val) {
  return toString$1.call(val) === '[object Array]';
}
function isUndefined$1(val) {
  return typeof val === 'undefined';
}
function isBuffer$1(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
function isArrayBuffer$1(val) {
  return toString$1.call(val) === '[object ArrayBuffer]';
}
function isFormData$1(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
function isArrayBufferView$1(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$1(val) {
  return typeof val === 'string';
}
function isNumber$1(val) {
  return typeof val === 'number';
}
function isObject$1(val) {
  return val !== null && typeof val === 'object';
}
function isPlainObject$1(val) {
  if (toString$1.call(val) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$2(val) {
  return toString$1.call(val) === '[object Date]';
}
function isFile$1(val) {
  return toString$1.call(val) === '[object File]';
}
function isBlob$1(val) {
  return toString$1.call(val) === '[object Blob]';
}
function isFunction$1(val) {
  return toString$1.call(val) === '[object Function]';
}
function isStream$1(val) {
  return isObject$1(val) && isFunction$1(val.pipe);
}
function isURLSearchParams$1(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
function trim$1(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function forEach$1(obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  if (typeof obj !== 'object') {
    obj = [obj];
  }
  if (isArray$1(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$1() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$1(arguments[i], assignValue);
  }
  return result;
}
function extend$1(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM$1(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}
var utils$2 = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$1,
  isFormData: isFormData$1,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate$2,
  isFile: isFile$1,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$1,
  merge: merge$1,
  extend: extend$1,
  trim: trim$1,
  stripBOM: stripBOM$1
};

function encode$2(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$2.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$2.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils$2.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils$2.forEach(val, function parseValue(v) {
        if (utils$2.isDate(v)) {
          v = v.toISOString();
        } else if (utils$2.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$2(key) + '=' + encode$2(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$2.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;

var transformData$1 = function transformData(data, headers, fns) {
  utils$2.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$2.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies$1 = utils$2.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils$2.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils$2.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils$2.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL$1(requestedURL)) {
    return combineURLs$1(baseURL, requestedURL);
  }
  return requestedURL;
};

var ignoreDuplicateOf$1 = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$2.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$2.trim(line.substr(0, i)).toLowerCase();
    val = utils$2.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf$1.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin$1 = utils$2.isStandardBrowserEnv() ? function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin(requestURL) {
    var parsed = utils$2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils$2.isFormData(requestData)) {
      delete requestHeaders['Content-Type'];
    }
    var request = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    var fullPath = buildFullPath$1(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders$1(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle$1(resolve, reject, response);
      request = null;
    };
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(createError('Request aborted', config, 'ECONNABORTED', request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(createError('Network Error', config, null, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));
      request = null;
    };
    if (utils$2.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$1(fullPath)) && config.xsrfCookieName ? cookies$1.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ('setRequestHeader' in request) {
      utils$2.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          delete requestHeaders[key];
        } else {
          request.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$2.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        request = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$2.isUndefined(headers) && utils$2.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    adapter = xhr;
  }
  return adapter;
}
var defaults$1 = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$2.isFormData(data) || utils$2.isArrayBuffer(data) || utils$2.isBuffer(data) || utils$2.isStream(data) || utils$2.isFile(data) || utils$2.isBlob(data)) {
      return data;
    }
    if (utils$2.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$2.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$2.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults$1.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils$2.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$1.headers[method] = {};
});
utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$1.headers[method] = utils$2.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$1;

function throwIfCancellationRequested$1(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested$1(config);
  config.headers = config.headers || {};
  config.data = transformData$1(config.data, config.headers, config.transformRequest);
  config.headers = utils$2.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$2.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested$1(config);
    response.data = transformData$1(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested$1(config);
      if (reason && reason.response) {
        reason.response.data = transformData$1(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

var mergeConfig$1 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];
  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }
  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$2.forEach(otherKeys, mergeDeepProperties);
  return config;
};

function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
Axios$1.prototype.request = function request(config) {
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }
  var chain = [dispatchRequest$1, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL$1(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  Axios$1.prototype[method] = function (url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  Axios$1.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios$1;

function Cancel(message) {
  this.message = message;
}
Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;

function CancelToken$1(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
CancelToken$1.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken$1.source = function source() {
  var cancel;
  var token = new CancelToken$1(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
var CancelToken_1 = CancelToken$1;

var spread$1 = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var isAxiosError$1 = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

function createInstance$1(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind$1(Axios_1.prototype.request, context);
  utils$2.extend(instance, Axios_1.prototype, context);
  utils$2.extend(instance, context);
  return instance;
}
var axios$2 = createInstance$1(defaults_1);
axios$2.Axios = Axios_1;
axios$2.create = function create(instanceConfig) {
  return createInstance$1(mergeConfig$1(axios$2.defaults, instanceConfig));
};
axios$2.Cancel = Cancel_1;
axios$2.CancelToken = CancelToken_1;
axios$2.isCancel = isCancel$1;
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = spread$1;
axios$2.isAxiosError = isAxiosError$1;
var axios_1 = axios$2;
var _default = axios$2;
axios_1.default = _default;

var axios$3 = axios_1;

axios$3.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
axios$3.defaults.headers.common['X-Frame-Options'] = 'DENY';
axios$3.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none';";
axios$3.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios$3.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
axios$3.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios$3.interceptors.response.use(res => res, err => {
  const isEmployee = window.location.pathname.split("/").includes("employee");
  if (err && err.response && err.response.data && err.response.data.Errors) {
    for (const error of err.response.data.Errors) {
      if (error.message.includes("InvalidAccessTokenException")) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/digit-ui/citizen" + `?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      }
    }
  }
  throw err;
});
const requestInfo = () => ({
  authToken: Digit.UserService.getUser().access_token || null
});
const authHeaders = () => ({
  "auth-token": Digit.UserService.getUser().access_token || null
});
const userServiceData = () => ({
  userInfo: Digit.UserService.getUser().info
});
window.Digit = window.Digit || {};
window.Digit = {
  ...window.Digit,
  RequestCache: window.Digit.RequestCache || {}
};
const Request$1 = async ({
  method: _method = "POST",
  url,
  data: _data = {},
  headers: _headers = {},
  useCache: _useCache = false,
  params: _params = {},
  auth,
  urlParams: _urlParams = {},
  userService,
  locale: _locale = true,
  authHeader: _authHeader = false,
  setTimeParam: _setTimeParam = true,
  userDownload: _userDownload = false,
  noResponseData: _noResponseData = false,
  noRequestInfo: _noRequestInfo = false,
  multipartFormData: _multipartFormData = false,
  multipartData: _multipartData = {}
}) => {
  if (_method.toUpperCase() === "POST") {
    const ts = new Date().getTime();
    _data.RequestInfo = {
      apiId: "Rainmaker"
    };
    if (auth) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...requestInfo()
      };
    }
    if (userService) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...userServiceData()
      };
    }
    if (_locale) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        msgId: `${ts}|${Digit.StoreData.getCurrentLanguage()}`
      };
    }
    if (_noRequestInfo) {
      delete _data.RequestInfo;
    }
  }
  const headers1 = {
    "Content-Type": "application/json",
    Accept: window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? "application/pdf,application/json" : "*/*",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none';",
    "X-Content-Type-Options": "nosniff",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  };
  if (_authHeader) _headers = {
    ..._headers,
    ...authHeaders()
  };
  if (_userDownload) _headers = {
    ..._headers,
    ...headers1
  };
  let key = "";
  if (_useCache) {
    key = `${_method.toUpperCase()}.${url}.${btoa(escape(JSON.stringify(_params, null, 0)))}.${btoa(escape(JSON.stringify(_data, null, 0)))}`;
    const value = window.Digit.RequestCache[key];
    if (value) {
      return value;
    }
  } else if (_setTimeParam) {
    _params._ = Date.now();
  }
  let _url = url.split("/").map(path => {
    let key = path.split(":")[1];
    return _urlParams[key] ? _urlParams[key] : path;
  }).join("/");
  if (_multipartFormData) {
    const multipartFormDataRes = await axios$3({
      method: _method,
      url: _url,
      data: _multipartData.data,
      params: _params,
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": Digit.UserService.getUser().access_token || null
      }
    });
    return multipartFormDataRes;
  }
  const tenantInfo = Digit.SessionStorage.get("userType") === "citizen" ? Digit.ULBService.getStateId() : Digit.ULBService.getCurrentTenantId() || Digit.ULBService.getStateId();
  if (!_params["tenantId"] && window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")) {
    _params["tenantId"] = tenantInfo;
  }
  const res = _userDownload ? await axios$3({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers,
    responseType: "arraybuffer"
  }) : await axios$3({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers
  });
  if (_userDownload) return res;
  if (_noResponseData) return res;
  const returnData = res.data || res.response.data || {};
  if (_useCache && res.data && Object.keys(returnData).length !== 0) {
    window.Digit.RequestCache[key] = returnData;
  }
  return returnData;
};
const ServiceRequest = async ({
  serviceName,
  method: _method2 = "POST",
  url,
  data: _data2 = {},
  headers: _headers2 = {},
  useCache: _useCache2 = false,
  params: _params2 = {},
  auth,
  userService
}) => {
  const preHookName = `${serviceName}Pre`;
  const postHookName = `${serviceName}Post`;
  let reqParams = _params2;
  let reqData = _data2;
  if (window[preHookName] && typeof window[preHookName] === "function") {
    let preHookRes = await window[preHookName]({
      params: _params2,
      data: _data2
    });
    reqParams = preHookRes.params;
    reqData = preHookRes.data;
  }
  const resData = await Request$1({
    method: _method2,
    url,
    data: reqData,
    headers: _headers2,
    useCache: _useCache2,
    params: reqParams,
    auth,
    userService
  });
  if (window[postHookName] && typeof window[postHookName] === "function") {
    return await window[postHookName](resData);
  }
  return resData;
};

const Urls = {
  MDMS: `/egov-mdms-service/v1/_search`,
  MdmsSearchV2: `/mdms-v2/v1/_search`,
  MdmsCreateV2: `/mdms-v2/v1/_create`,
  MdmsUpdateV2: `/mdms-v2/v1/_update`,
  opensearchAPI: `/bpa-services/v1/bpa/_plainsearch`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  WorkFlowProcessCount: `/egov-workflow-v2/egov-wf/process/_count`,
  localization: `/localization/messages/v1/_search`,
  qrCodeURL: {
    bpaQRCode: `/bpa-services/v1/bpa/_qrcodeurl`,
    tlQRCode: `/tl-services/v1/ltp/_qrcodeurl`,
    SelfMap: `/bpa-services/v1/bpa/_qrcodeurl/_SelfMap`
  },
  logoUrl: {
    bpaLogoUrl: `/bpa-services/v1/bpa/_logourl?`
  },
  bpaService: {
    remarksDetail: `/bpa-services/v1/bpa/_remarksDetail/_create`,
    remarksPaymentDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=PaymentDetails`,
    khasraDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=khasraDetails`,
    nocRemarks: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocRemarks`,
    remarksDocument: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DocumentDetails`,
    remarksSiteInspection: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=InspectionDetail`,
    remarksDrawing: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DrawingsDetails`,
    remarkspFARDetail: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=remarksDetails`,
    remarksNoc: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocDetails`,
    remarksNoting: `/bpa-services/v1/bpa/_remarksDetail/_search1?`,
    getNotice: `/bpa-services/v1/bpa/_getNotice?vaadId=`
  },
  location: {
    localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=ADMIN&boundaryType=Locality`,
    revenue_localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality`,
    business_services: `/bpa-services/v1/bpa/business-services`
  },
  pgr_search: `/pgr-services/v2/request/_search`,
  pgr_update: `/pgr-services/v2/request/_update`,
  filter_data: `https://run.mocky.io/v3/597a50a0-90e5-4a45-b82e-8a2186b760bd`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/url",
  PGR_Create: `/pgr-services/v2/request/_create`,
  pgr_count: `/pgr-services/v2/request/_count`,
  OTP_Send: "/user-otp/v1/_send",
  Otp_Validate: "/otp/v1/_validate",
  OTP_Send_verify: "/otp/_verify",
  trackAppliactionStatus: "/bpa-services/v1/bpa/_trackapplicationstatus",
  Authenticate: "/user/oauth/token",
  RegisterUser: "/user/citizen/_create",
  ChangePassword: "/user/password/nologin/_update",
  ChangePassword1: "/user/password/_update",
  UserProfileUpdate: "/user/profile/_update",
  UserCaptchaGenerate: "/user/captcha/generate",
  UserCaptchaValidate: "/user/captcha/validate",
  EmployeeSearch: "/egov-hrms/employees/_search",
  UserManualDelete: "/bpa-services/v1/adminApi/_usermanual/_delete",
  InboxSearch: "/inbox/v1/_search",
  InboxSearchApplication: "/bpa-services/v1/bpa/_dashboard/_count",
  SearchApplication: "/bpa-services/v1/bpa/_dashboard/_applicationDetail",
  tlSearchApplication: "/tl-services/v1/_dashboard/_applicationDetail",
  InboxSearchApplicationProfessional: "/tl-services/v1/_dashboard/_count",
  UserSearch: "/user/_search",
  UserManualCreate: `/bpa-services/v1/adminApi/_usermanual/_create`,
  UserManualSearch: `/bpa-services/v1/adminApi/_usermanual/_search`,
  UserLogout: "/user/_logout",
  Shortener: "/egov-url-shortening/shortener",
  fsm: {
    search: "/fsm/v1/_search",
    create: "/fsm/v1/_create",
    update: "/fsm/v1/_update",
    vendorSearch: "/vendor/v1/_search",
    vehicleSearch: "/vehicle/v1/_search",
    audit: "/fsm/v1/_audit",
    vehicleTripSearch: "/vehicle/trip/v1/_search",
    billingSlabSearch: "/fsm-calculator/v1/billingSlab/_search",
    vehilceUpdate: "/vehicle/trip/v1/_update",
    vehicleTripCreate: "/vehicle/trip/v1/_create"
  },
  form11: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  form12: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  payment: {
    fetch_bill: "/billing-service/bill/v2/_fetchbill",
    demandSearch: "/billing-service/demand/_search",
    create_reciept: "/collection-services/payments/_create",
    print_reciept: "/collection-services/payments",
    generate_pdf: "/pdf-service/v1/_create",
    create_citizen_reciept: "/pg-service/transaction/v1/_create",
    update_citizen_reciept: "/pg-service/transaction/v1/_update",
    search_bill: "/billing-service/bill/v2/_search",
    reciept_search: "/collection-services/payments/:buisnessService/_search",
    obps_Reciept_Search: "/collection-services/payments/_search"
  },
  dsc: {
    signParams: "/dsc-service/v1/signature/getSignParams"
  },
  pt: {
    fectch_property: "/property-services/property/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    create: "/property-services/property/_create",
    search: "/property-services/property/_search",
    update: "/property-services/property/_update",
    pt_calculation_estimate: "/pt-calculator-v2/propertytax/v2/_estimate",
    assessment_create: "/property-services/assessment/_create",
    assessment_search: "/property-services/assessment/_search",
    payment_search: "/collection-services/payments/PT/_search",
    pt_calculate_mutation: "/pt-calculator-v2/propertytax/mutation/_calculate"
  },
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2"
  },
  mcollect: {
    search: "/echallan-services/eChallan/v1/_search",
    create: "/echallan-services/eChallan/v1/_create?",
    fetch_bill: "/billing-service/bill/v2/_fetchbill?",
    search_bill: "/egov-searcher/bill-genie/mcollectbills/_get",
    search_bill_pt: "/egov-searcher/bill-genie/billswithaddranduser/_get",
    update: "/echallan-services/eChallan/v1/_update",
    download_pdf: "/egov-pdf/download/UC/mcollect-challan",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    bill_download: "/egov-pdf/download/bills/consolidatedbill",
    count: "/echallan-services/eChallan/v1/_count"
  },
  hrms: {
    search: "/egov-hrms/employees/_search",
    count: "/egov-hrms/employees/_count",
    create: "/egov-hrms/employees/_create",
    update: "/egov-hrms/employees/_update",
    employeeSearch: "/user/users/_jobdelegation/_employeeSearch",
    employeeFileTransfer: "/user/users/_employeeFileTransfer",
    deactivateUser: "/user/users/_deactivate"
  },
  tl: {
    create: "/tl-services/v1/_create",
    search: "/tl-services/v1/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    download_pdf: "/egov-pdf/download/TL/",
    update: "/tl-services/v1/_update",
    billingslab: "/tl-calculator/billingslab/_search",
    designOfApproval: "/tl-services/_DesignOfApprovalLetter",
    workflowEsclate: "/egov-workflow-v2/egov-wf/auto/BPAREG/_escalate",
    coaValidate: "/tl-services/v1/validate/_architectureNo",
    misReportRegistration: "/tl-services/v1/_misReportRegistration"
  },
  receipts: {
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    payments: "/collection-services/payments",
    count: "/egov-hrms/employees/_count"
  },
  obps: {
    compliance_create: "/bpa-services/_compliance/_create",
    compliance_search: "/bpa-services/_compliance/_search",
    compliance_update: "/bpa-services/_compliance/_update",
    scrutinyDetails: "/edcr/rest/dcr/scrutinydetails",
    comparisionReport: "/edcr/rest/dcr/occomparison",
    create: "/bpa-services/v1/bpa/_create",
    createForm11: "/bpa-services/v1/subdivision/_create",
    createLandUseUP: "/bpa-services/v1/_landUse/_create",
    createOwner: "/bpa-services/v1/_owner/_create",
    updateOwner: "/bpa-services/v1/_owner/_update",
    createPurchasableFAR: "/bpa-services/v1/_purchasableFAR/_create",
    updatePurchasableFAR: "/bpa-services/v1/_purchasableFAR/_update",
    createFormCLU: "/bpa-services/v1/subdivision/_create",
    createForm34: "/bpa-services/v1/subdivision/_create",
    createForm26: "/bpa-services/v1/offences/_create",
    nocSearch: "/noc-services/v1/noc/_search",
    updateNOC: "/noc-services/v1/noc/_update",
    update: "/bpa-services/v1/bpa/_update",
    updateForm11: "/bpa-services/v1/subdivision/_update",
    updateFormCLU: "/bpa-services/v1/subdivision/_update",
    updateForm34: "/bpa-services/v1/subdivision/_update",
    updateFormLandUse: "/bpa-services/v1/_landUse/_update",
    bpaSearch: "/bpa-services/v1/bpa/_search",
    ltpGrading: "/bpa-services/v1/bpa/_dashboard/_fastpasHome",
    bpaSearchChallan: "/bpa-services/v1/bpa/_searchChallan",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    searchLandUseUP: "/bpa-services/v1/_landUse/_search",
    searchfrom11: "/bpa-services/v1/subdivision/_search",
    searchfrom26: "/bpa-services/v1/subdivision/_search",
    searchFromCLU: "/bpa-services/v1/subdivision/_search",
    searchFrom34: "/bpa-services/v1/subdivision/_search",
    ownerSearch: "/bpa-services/v1/_owner/_search",
    searchPurchasableFar: "/bpa-services/v1/_purchasableFAR/_search",
    bpaRegSearch: "/tl-services/v1/BPAREG/_search",
    bpaRegCreate: "/tl-services/v1/BPAREG/_create",
    bpaRegGetBill: "/tl-calculator/v1/BPAREG/_getbill",
    bpaRegUpdate: "/tl-services/v1/BPAREG/_update",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    edcrreportdownload: "/bpa-services/v1/bpa/_permitorderedcr",
    designOfApproval: "/bpa-services/_DesignOfApprovalLetter",
    designOfStuctural: "/bpa-services/_Structralcertificate",
    farIntimationLetter: "/bpa-services/_FarInimitionLetter",
    scheduleInspection: "/bpa-services/v1/bpa/_dashboard/_inspection",
    applicationDetailData: "/bpa-services/v1/bpa//_dashboard/_applicationDetailData",
    applicationDetailDataView: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    fetchProfessional: "/tl-services/v1/_dashboard/_applicationDetailData",
    fetchAppendex: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    paymentList: "/collection-services/payments/_plainsearch",
    paymentReport: "/bpa-services/v1/_paymentReport",
    echargesReport: "/bpa-services/v1/_echargesReport",
    applicationReport: "/bpa-services/v1/_applicationReport",
    applicationMisReport: "/bpa-services/v1/bpa/_extarctMisData",
    paymentMisReport: "/bpa-services/v1/bpa/_extractAllMisData",
    paymentMisReportNew: "/bpa-services/v1/bpa/_extractAllMisData",
    dashboardReport: "/bpa-services/v1/bpa/_bidashboard",
    scrutinyFailedReport: "/edcr/rest/dcr/not-accepted-files",
    inwardApplicationReport: "/bpa-services/v1/_inwardApplicationReport",
    selfApprovalReport: "/bpa-services/v1/_selfCertification",
    installments: "/bpa-calculator/api/installments/_calculate",
    fastpassSearch: "/bpa-services/v1/bpa/_plainsearch",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    bpacalculate: "/bpa-calculator/_calculate",
    bpacalculatechallan: "/bpa-calculator/_calculateChallan",
    deleteChallan: "/bpa-calculator/bpa/delete-challan",
    migratedSearch: "/bpa-services/v1/bpamigration/_search",
    migratedSearchappNo: "/bpa-services/v1/bpamigration/_searchByAppNo",
    employeeSearchList: "/user/users/_jobdelegation/_employeeSearch",
    totalAmountOfCharges: "/bpa-services/v1/bpa/_totalAmountOfCharges",
    taxHeadEstimateSearch: "/bpa-services/v1/bpa/_taxHeadEstimateSearch",
    employeeWorkflowCount: "/bpa-services/v1/adminApi/_employee-workflow-count",
    installmentCalculate: "/bpa-calculator/_insatllmentCalculate",
    checkPaymentStatus: "/bpa-ui/application-payment-status/live-status",
    challanUpdaterDirect: "/bpa-ui/challan-updater-direct",
    getSelfApprovalData: "/bpa-services/v1/bpa/_dashboard/_selfcount"
  },
  edcr: {
    create: "/edcr/rest/dcr/scrutinize"
  },
  land: {
    chatBoard_data_search: "/land-services/egscrutiny/_search1?applicationNumber",
    chatBoard_data_search3: "/land-services/egscrutiny/_search3?applicationNumber",
    modal_data_search: "/land-services/egscrutiny/_search?applicationNumber"
  },
  events: {
    search: "/egov-user-event/v1/events/_search",
    update: "/egov-user-event/v1/events/lat/_update",
    updateEvent: "/egov-user-event/v1/events/_update",
    updateEventCDG: "/egov-user-event/v1/events/lat/_update",
    count: "/egov-user-event/v1/events/notifications/_count",
    create: "/egov-user-event/v1/events/_create"
  },
  ws: {
    water_search: "/ws-services/wc/_search",
    sewarage_search: "/sw-services/swc/_search"
  },
  engagement: {
    document: {
      search: "/egov-document-uploader/egov-du/document/_search",
      create: "/egov-document-uploader/egov-du/document/_create",
      delete: "/egov-document-uploader/egov-du/document/_delete",
      update: "/egov-document-uploader/egov-du/document/_update"
    },
    surveys: {
      create: "/egov-survey-services/egov-ss/survey/_create",
      update: "/egov-survey-services/egov-ss/survey/_update",
      search: "/egov-survey-services/egov-ss/survey/_search",
      delete: "/egov-survey-services/egov-ss/survey/_delete",
      submitResponse: "/egov-survey-services/egov-ss/survey/response/_submit",
      showResults: "/egov-survey-services/egov-ss/survey/response/_results"
    }
  },
  noc: {
    nocSearch: "/noc-services/v1/noc/_search",
    nocExcelSearch: "/noc-services/v1/noc/excel/search",
    nocExcelCreate: "/noc-services/v1/noc/excel/create",
    nocExcelUpdate: "/noc-services/v1/noc/excel/update",
    nocCountSearch: "/noc-services/v1/noc/_dashboard/noc/_count",
    nocCountApplicationData: "/noc-services/v1/noc/_dashboard/noc/_applicationDetailData"
  }
};

const convertEpochToDate$1 = (dateEpoch, businessService) => {
  if (dateEpoch) {
    const dateFromApi = new Date(dateEpoch);
    let month = dateFromApi.getMonth() + 1;
    let day = dateFromApi.getDate();
    let year = dateFromApi.getFullYear();
    month = (month > 9 ? "" : "0") + month;
    day = (day > 9 ? "" : "0") + day;
    if (businessService == "PT") return `${day}-${month}-${year}`;else return `${day}/${month}/${year}`;
  } else {
    return null;
  }
};
const stringReplaceAll$1 = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};

const localStoreSupport = () => {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
};
const k = key => `Digit.${key}`;
const getStorage = storageClass => ({
  get: key => {
    if (localStoreSupport() && key) {
      let valueInStorage = storageClass.getItem(k(key));
      if (!valueInStorage || valueInStorage === "undefined") {
        return null;
      }
      const item = JSON.parse(valueInStorage);
      if (Date.now() > item.expiry) {
        storageClass.removeItem(k(key));
        return null;
      }
      return item.value;
    } else if (typeof window !== "undefined") {
      var _window, _window$eGov;
      return ((_window = window) === null || _window === void 0 ? void 0 : (_window$eGov = _window.eGov) === null || _window$eGov === void 0 ? void 0 : _window$eGov.Storage) && window.eGov.Storage[k(key)].value;
    } else {
      return null;
    }
  },
  set: (key, value, ttl = 86400) => {
    const item = {
      value,
      ttl,
      expiry: Date.now() + ttl * 1000
    };
    if (localStoreSupport()) {
      storageClass.setItem(k(key), JSON.stringify(item));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      window.eGov.Storage[k(key)] = item;
    }
  },
  del: key => {
    if (localStoreSupport()) {
      storageClass.removeItem(k(key));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      delete window.eGov.Storage[k(key)];
    }
  }
});
const PersistantStorage = getStorage(window.localStorage);

const SortByName = (na, nb) => {
  if (na < nb) {
    return -1;
  }
  if (na > nb) {
    return 1;
  }
  return 0;
};
const GetCitiesWithi18nKeys = (MdmsRes, moduleCode) => {
  const cityList = MdmsRes.tenant.citymodule && MdmsRes.tenant.citymodule.find(module => module.code === moduleCode).tenants || [];
  const citiesMap = cityList.map(city => city.code);
  const cities = MdmsRes.tenant.tenants.filter(city => citiesMap.includes(city.code)).map(({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber
  }) => ({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber,
    i18nKey: "TENANT_TENANTS_" + code.replace(".", "_").toUpperCase()
  })).sort((cityA, cityB) => {
    const na = cityA.name.toLowerCase(),
      nb = cityB.name.toLowerCase();
    return SortByName(na, nb);
  });
  return cities;
};
const initRequestBody = tenantId => ({
  MdmsCriteria: {
    tenantId,
    moduleDetails: [{
      moduleName: "common-masters",
      masterDetails: [{
        name: "Department"
      }, {
        name: "Designation"
      }, {
        name: "StateInfo"
      }, {
        name: "wfSlaConfig"
      }]
    }, {
      moduleName: "tenant",
      masterDetails: [{
        name: "tenants"
      }, {
        name: "citymodule"
      }]
    }, {
      moduleName: "DIGIT-UI",
      masterDetails: [{
        name: "ApiCachingSettings"
      }]
    }, {
      moduleName: "BPA",
      masterDetails: [{
        name: "SchemesRate"
      }]
    }]
  }
});
const getCriteria = (tenantId, moduleDetails) => {
  return {
    MdmsCriteria: {
      tenantId,
      ...moduleDetails
    }
  };
};
const getGeneralCriteria = (tenantId, moduleCode, type) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: type
      }]
    }]
  }
});
const getMultipleTypes = (tenantId, moduleCode, types) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: types.map(type => {
        if (typeof type === "object") {
          return {
            name: type.name,
            filter: type.filter
          };
        }
        return {
          name: type
        };
      })
    }]
  }
});
const getReceiptKey = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "uiCommonPay"
      }]
    }]
  }
});
const getModuleServiceDefsCriteria = (tenantId, moduleCode) => ({
  type: "serviceDefs",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: `RAINMAKER-${moduleCode}`,
      masterDetails: [{
        name: "ServiceDefs"
      }]
    }]
  }
});
const getSanitationTypeCriteria = (tenantId, moduleCode) => ({
  type: "SanitationType",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SanitationType",
        filter: null
      }]
    }]
  }
});
const getPitTypeCriteria = (tenantId, moduleCode) => ({
  type: "PitType",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PitType",
        filter: null
      }]
    }]
  }
});
const getApplicationChannelCriteria = (tenantId, moduleCode) => ({
  type: "ApplicationChannel",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ApplicationChannel",
        filter: null
      }]
    }]
  }
});
const getPropertyTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getPropertyUsageCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getCommonFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CommonFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPreFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PreFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPostFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PostFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getConfig = (tenantId, moduleCode) => ({
  type: "Config",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Config"
      }]
    }]
  }
});
const getVehicleTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "VehicleMakeModel",
        filter: null
      }]
    }]
  }
});
const getChecklistCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CheckList",
        filter: null
      }]
    }]
  }
});
const getSlumLocalityCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Slum"
      }]
    }]
  }
});
const getPropertyOwnerTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerType"
      }]
    }]
  }
});
const getSubPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SubOwnerShipCategory"
      }]
    }]
  }
});
const getPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getTradeOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getDocumentRequiredScreenCategory = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Documents"
      }]
    }]
  }
});
const getDefaultMapConfig = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "MapConfig"
      }]
    }]
  }
});
const getUsageCategoryList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "UsageCategory"
      }]
    }]
  }
});
const getPTPropertyTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType"
      }]
    }]
  }
});
const getTLStructureTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "StructureType"
      }]
    }]
  }
});
const getTLAccessoriesTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "AccessoriesCategory"
      }]
    }]
  }
});
const getTLFinancialYearList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FinancialYear",
        filter: `[?(@.module == "TL")]`
      }]
    }]
  }
});
const getPTFloorList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Floor"
      }]
    }]
  }
});
const getReasonCriteria = (tenantId, moduleCode, type, payload) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: payload.map(mdmsLoad => ({
        name: mdmsLoad
      }))
    }]
  }
});
const getBillingServiceForBusinessServiceCriteria = filter => ({
  moduleDetails: [{
    moduleName: "BillingService",
    masterDetails: [{
      name: "BusinessService",
      filter
    }, {
      name: "TaxHeadMaster"
    }, {
      name: "TaxPeriod"
    }]
  }]
});
const getRoleStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RoleStatusMapping",
        filter: null
      }]
    }]
  }
});
const getRentalDetailsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RentalDetails"
      }]
    }]
  }
});
const getChargeSlabsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ChargeSlabs"
      }]
    }]
  }
});
const getGenderTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "GenderType"
      }]
    }]
  }
});
const getDssDashboardCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "dashboard-config"
      }]
    }]
  }
});
const getMCollectBillingServiceCriteria = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BusinessService",
        filter: filter
      }]
    }]
  }
});
const getTradeUnitsDataList = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeType",
        filter: filter
      }]
    }]
  }
});
const getMCollectApplicationStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "applicationStatus"
      }]
    }]
  }
});
const getHrmsEmployeeRolesandDesignations = () => ({
  moduleDetails: [{
    moduleName: "common-masters",
    masterDetails: [{
      name: "Department",
      filter: "[?(@.active == true)]"
    }, {
      name: "Designation",
      filter: "[?(@.active == true)]"
    }]
  }, {
    moduleName: "tenant",
    masterDetails: [{
      name: "tenants"
    }]
  }, {
    moduleName: "ACCESSCONTROL-ROLES",
    masterDetails: [{
      name: "roles",
      filter: "$.[?(@.code!='CITIZEN')]"
    }]
  }, {
    moduleName: "egov-location",
    masterDetails: [{
      name: "TenantBoundary"
    }]
  }]
});
const getFSTPPlantCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPPlantInfo"
      }]
    }]
  }
});
const getCancelReceiptReason = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CancelReceiptReason"
      }]
    }]
  }
});
const getReceiptStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }]
    }]
  }
});
const getCancelReceiptReasonAndStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }, {
        name: "uiCommonPay"
      }]
    }]
  }
});
const getDocumentTypesCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DocTypeMapping"
      }]
    }]
  }
});
const getTradeTypeRoleCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeTypetoRoleMapping"
      }]
    }]
  }
});
const getMSDropDownCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DropdownsConfig"
      }]
    }]
  }
});
const getLandUseCategories = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BasicFarPurchasable"
      }]
    }]
  }
});
const getFSTPORejectionReasonCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPORejectionReason",
        filter: null
      }]
    }]
  }
});
const getFSMPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PaymentType",
        filter: null
      }]
    }]
  }
});
const getFSMTripNumberCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TripNumber",
        filter: null
      }]
    }]
  }
});
const getFSMReceivedPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceivedPaymentType",
        filter: null
      }]
    }]
  }
});
const GetEgovLocations = MdmsRes => {
  return MdmsRes["egov-location"].TenantBoundary[0].boundary.children.map(obj => ({
    name: obj.localname,
    i18nKey: obj.localname
  }));
};
const GetServiceDefs = (MdmsRes, moduleCode) => MdmsRes[`RAINMAKER-${moduleCode}`].ServiceDefs.filter(def => def.active);
const GetSanitationType = MdmsRes => MdmsRes["FSM"].SanitationType.filter(type => type.active);
const GetPitType = MdmsRes => MdmsRes["FSM"].PitType.filter(item => item.active).map(type => ({
  ...type,
  i18nKey: `PITTYPE_MASTERS_${type.code}`
}));
const GetApplicationChannel = MdmsRes => MdmsRes["FSM"].ApplicationChannel.filter(type => type.active).map(channel => ({
  ...channel,
  i18nKey: `ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_${channel.code}`
}));
const GetPropertyType = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && !property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetPropertySubtype = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetVehicleType = MdmsRes => MdmsRes["Vehicle"].VehicleMakeModel.filter(vehicle => vehicle.active).filter(vehicle => vehicle.make).map(vehicleDetails => {
  return {
    ...vehicleDetails,
    i18nKey: `COMMON_MASTER_VEHICLE_${vehicleDetails.code}`
  };
});
const GetSlumLocalityMapping = (MdmsRes, tenantId) => MdmsRes["FSM"].Slum.filter(type => type.active).reduce((prev, curr) => {
  return prev[curr.locality] ? {
    ...prev,
    [curr.locality]: [...prev[curr.locality], {
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  } : {
    ...prev,
    [curr.locality]: [{
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  };
}, {});
const GetPropertyOwnerShipCategory = MdmsRes => MdmsRes["PropertyTax"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetTradeOwnerShipCategory = MdmsRes => MdmsRes["common-masters"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetPropertyOwnerType = MdmsRes => MdmsRes["PropertyTax"].OwnerType.filter(owner => owner.active).map(ownerDetails => {
  return {
    ...ownerDetails,
    i18nKey: `PROPERTYTAX_OWNERTYPE_${ownerDetails.code}`
  };
});
const getSubPropertyOwnerShipCategory = MdmsRes => {
  MdmsRes["PropertyTax"].SubOwnerShipCategory.filter(category => category.active).map(subOwnerShipDetails => {
    return {
      ...subOwnerShipDetails,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${subOwnerShipDetails.code}`
    };
  });
  sessionStorage.setItem("getSubPropertyOwnerShipCategory", JSON.stringify(MdmsRes));
};
const getDocumentRequiredScreen = MdmsRes => {
  MdmsRes["PropertyTax"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getTLDocumentRequiredScreen = MdmsRes => {
  MdmsRes["TradeLicense"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getMapConfig = MdmsRes => {
  MdmsRes["PropertyTax"].MapConfig.filter(MapConfig => MapConfig).map(MapData => {
    return {
      ...MapConfig,
      defaultconfig: MapData.defaultConfig
    };
  });
};
const getUsageCategory = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(UsageCategory => UsageCategory.active).map(UsageCategorylist => {
  return {
    ...UsageCategorylist,
    i18nKey: `PROPERTYTAX_BILLING_SLAB_${UsageCategorylist.code}`
  };
});
const getPTPropertyType = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(PropertyType => PropertyType.active).map(PTPropertyTypelist => {
  return {
    ...UsageCategorylist,
    i18nKey: `COMMON_PROPTYPE_${stringReplaceAll$1(PTPropertyTypelist.code, ".", "_")}`
  };
});
const getTLStructureType = MdmsRes => MdmsRes["common-masters"].StructureType.filter(StructureType => StructureType.active).map(TLStructureTypeList => {
  return {
    ...TLStructureTypeList,
    i18nKey: `COMMON_MASTERS_STRUCTURETYPE_${stringReplaceAll$1(TLStructureTypeList.code, ".", "_")}`
  };
});
const getTLAccessoriesType = MdmsRes => MdmsRes["TradeLicense"].AccessoriesCategory.filter(AccessoriesCategory => AccessoriesCategory.active).map(TLAccessoryTypeList => {
  return {
    ...TLAccessoryTypeList,
    i18nKey: `TRADELICENSE_ACCESSORIESCATEGORY_${stringReplaceAll$1(TLAccessoryTypeList.code, ".", "_")}`
  };
});
const getTLFinancialYear = MdmsRes => MdmsRes["egf-master"].FinancialYear.filter(FinancialYear => FinancialYear.active && FinancialYear.module === "TL").map(FinancialYearList => {
  return {
    ...FinancialYearList
  };
});
const getFloorList = MdmsRes => MdmsRes["PropertyTax"].Floor.filter(PTFloor => PTFloor.active).map(PTFloorlist => {
  return {
    ...PTFloorlist,
    i18nKey: `PROPERTYTAX_FLOOR_${PTFloorlist.code}`
  };
});
const GetReasonType = (MdmsRes, type, moduleCode) => Object.assign({}, ...Object.keys(MdmsRes[moduleCode]).map(collection => ({
  [collection]: MdmsRes[moduleCode][collection].filter(reason => reason.active).map(reason => ({
    ...reason,
    i18nKey: `ES_ACTION_REASON_${reason.code}`
  }))
})));
const getRentalDetailsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].RentalDetails.filter(category => category.active).map(RentalDetailsInfo => {
    return {
      ...RentalDetailsInfo,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${RentalDetailsInfo.code}`
    };
  });
};
const getChargeSlabsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].ChargeSlabs.filter(category => category.active).map(ChargeSlabsInfo => {
    return {
      ...ChargeSlabsInfo
    };
  });
};
const getGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const TLGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genders => {
    return {
      ...genders,
      i18nKey: `TL_GENDER_${genders.code}`
    };
  });
};
const PTGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(formGender => {
    return {
      ...formGender,
      i18nKey: `PT_FORM3_${formGender.code}`
    };
  });
};
const HRGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(comGender => {
    return {
      ...comGender,
      i18nKey: `COMMON_GENDER_${comGender.code}`
    };
  });
};
const GetMCollectBusinessService = MdmsRes => MdmsRes["BillingService"].BusinessService.map(businesServiceDetails => {
  return {
    ...businesServiceDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${businesServiceDetails.code}`
  };
});
const GetMCollectApplicationStatus = MdmsRes => MdmsRes["mCollect"].applcationStatus.map(appStatusDetails => {
  return {
    ...appStatusDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${appStatusDetails.code}`
  };
});
const getFSMGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const GetFSTPORejectionReason = MdmsRes => {
  return MdmsRes["Vehicle"].FSTPORejectionReason.filter(reason => reason.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_REASON_${reasonDetails.code}`
    };
  });
};
const GetPaymentType = MdmsRes => {
  return MdmsRes["FSM"].PaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const GetTripNumber = MdmsRes => {
  return MdmsRes["FSM"].TripNumber.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_TRIP_${reasonDetails.code}`
    };
  });
};
const GetReceivedPaymentType = MdmsRes => {
  return MdmsRes["FSM"].ReceivedPaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const getDssDashboard = MdmsRes => MdmsRes["dss-dashboard"]["dashboard-config"];
const GetRoleStatusMapping = MdmsRes => MdmsRes["DIGIT-UI"].RoleStatusMapping;
const GetCommonFields = (MdmsRes, moduleCode) => moduleCode.toUpperCase() === "PROPERTYTAX" ? MdmsRes["PropertyTax"].CommonFieldsConfig : MdmsRes["FSM"].CommonFieldsConfig;
const GetPreFields = MdmsRes => MdmsRes["FSM"].PreFieldsConfig;
const GetPostFields = MdmsRes => MdmsRes["FSM"].PostFieldsConfig;
const GetFSTPPlantInfo = MdmsRes => MdmsRes["FSM"].FSTPPlantInfo;
const GetDocumentsTypes = MdmsRes => MdmsRes["BPA"].DocTypeMapping;
const GetChecklist = MdmsRes => MdmsRes["BPA"].CheckList;
const transformResponse = (type, MdmsRes, moduleCode, tenantId) => {
  switch (type) {
    case "citymodule":
      return GetCitiesWithi18nKeys(MdmsRes, moduleCode);
    case "egovLocation":
      return GetEgovLocations(MdmsRes);
    case "serviceDefs":
      return GetServiceDefs(MdmsRes, moduleCode);
    case "ApplicationChannel":
      return GetApplicationChannel(MdmsRes);
    case "SanitationType":
      return GetSanitationType(MdmsRes);
    case "PropertyType":
      return GetPropertyType(MdmsRes);
    case "PropertySubtype":
      return GetPropertySubtype(MdmsRes);
    case "PitType":
      return GetPitType(MdmsRes);
    case "VehicleType":
      return GetVehicleType(MdmsRes);
    case "Slum":
      return GetSlumLocalityMapping(MdmsRes, tenantId);
    case "OwnerShipCategory":
      return GetPropertyOwnerShipCategory(MdmsRes);
    case "TLOwnerShipCategory":
      return GetTradeOwnerShipCategory(MdmsRes);
    case "OwnerType":
      return GetPropertyOwnerType(MdmsRes);
    case "SubOwnerShipCategory":
      return getSubPropertyOwnerShipCategory(MdmsRes);
    case "Documents":
      return getDocumentRequiredScreen(MdmsRes);
    case "TLDocuments":
      return getTLDocumentRequiredScreen(MdmsRes);
    case "MapConfig":
      return getMapConfig(MdmsRes);
    case "UsageCategory":
      return getUsageCategory(MdmsRes);
    case "PTPropertyType":
      return getPTPropertyType(MdmsRes);
    case "StructureType":
      return getTLStructureType(MdmsRes);
    case "AccessoryCategory":
      return getTLAccessoriesType(MdmsRes);
    case "FinancialYear":
      return getTLFinancialYear(MdmsRes);
    case "Floor":
      return getFloorList(MdmsRes);
    case "Reason":
      return GetReasonType(MdmsRes, type, moduleCode);
    case "RoleStatusMapping":
      return GetRoleStatusMapping(MdmsRes);
    case "CommonFieldsConfig":
      return GetCommonFields(MdmsRes, moduleCode);
    case "PreFieldsConfig":
      return GetPreFields(MdmsRes);
    case "PostFieldsConfig":
      return GetPostFields(MdmsRes);
    case "RentalDeatils":
      return getRentalDetailsCategory(MdmsRes);
    case "ChargeSlabs":
      return getChargeSlabsCategory(MdmsRes);
    case "DssDashboard":
      return getDssDashboard(MdmsRes);
    case "BusinessService":
      return GetMCollectBusinessService(MdmsRes);
    case "applcatonStatus":
      return GetMCollectApplicationStatus(MdmsRes);
    case "FSTPPlantInfo":
      return GetFSTPPlantInfo(MdmsRes);
    case "GenderType":
      return getGenderType(MdmsRes);
    case "TLGendertype":
      return TLGenderType(MdmsRes);
    case "PTGenderType":
      return PTGenderType(MdmsRes);
    case "HRGenderType":
      return HRGenderType(MdmsRes);
    case "DocumentTypes":
      return GetDocumentsTypes(MdmsRes);
    case "CheckList":
      return GetChecklist(MdmsRes);
    case "FSMGenderType":
      return getFSMGenderType(MdmsRes);
    case "FSTPORejectionReason":
      return GetFSTPORejectionReason(MdmsRes);
    case "PaymentType":
      return GetPaymentType(MdmsRes);
    case "TripNumber":
      return GetTripNumber(MdmsRes);
    case "ReceivedPaymentType":
      return GetReceivedPaymentType(MdmsRes);
    default:
      return MdmsRes;
  }
};
const mergedData = {};
const mergedPromises = {};
const callAllPromises = (success, promises = [], resData) => {
  promises.forEach(promise => {
    if (success) {
      promise.resolve(resData);
    } else {
      promise.reject(resData);
    }
  });
};
const mergeMDMSData = (data, tenantId, url) => {
  const key = `${tenantId}:${url}`;
  if (!mergedData[key] || Object.keys(mergedData[key]).length === 0) {
    mergedData[key] = data;
  } else {
    data.MdmsCriteria.moduleDetails.forEach(dataModuleDetails => {
      const moduleName = dataModuleDetails.moduleName;
      const masterDetails = dataModuleDetails.masterDetails;
      let found = false;
      mergedData[key].MdmsCriteria.moduleDetails.forEach(moduleDetail => {
        if (moduleDetail.moduleName === moduleName) {
          found = true;
          moduleDetail.masterDetails = [...moduleDetail.masterDetails, ...masterDetails];
        }
      });
      if (!found) {
        mergedData[key].MdmsCriteria.moduleDetails.push(dataModuleDetails);
      }
    });
  }
};
const debouncedCall = ({
  serviceName,
  url,
  data,
  useCache,
  params
}, resolve, reject) => {
  const key = `${params.tenantId}:${url}`;
  if (!mergedPromises[key] || mergedPromises[key].length === 0) {
    setTimeout(() => {
      let callData = JSON.parse(JSON.stringify(mergedData[key]));
      mergedData[key] = {};
      let callPromises = [...mergedPromises[key]];
      mergedPromises[key] = [];
      ServiceRequest({
        serviceName,
        url,
        data: callData,
        useCache,
        params
      }).then(data => {
        callAllPromises(true, callPromises, data);
      }).catch(err => {
        callAllPromises(false, callPromises, err);
      });
    }, 500);
  }
  mergeMDMSData(data, params.tenantId, url);
  if (!mergedPromises[key]) {
    mergedPromises[key] = [];
  }
  mergedPromises[key].push({
    resolve,
    reject
  });
};
const MdmsService = {
  init: stateCode => ServiceRequest({
    serviceName: "mdmsInit",
    url: Urls.MDMS,
    data: initRequestBody(stateCode),
    useCache: true,
    params: {
      tenantId: stateCode
    }
  }),
  call: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsCall",
      url: Urls.MDMS,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  search: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsSearchV2",
      url: Urls.MdmsSearchV2,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  getDataByCriteria: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMS.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.call(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  searchDataV2: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMSV2.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.search(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  getServiceDefs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getModuleServiceDefsCriteria(tenantId, moduleCode), moduleCode);
  },
  getSanitationType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getSanitationTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getApplicationChannel: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getApplicationChannelCriteria(tenantId, moduleCode), moduleCode);
  },
  getPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyUsage: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyUsageCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubtype: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPitType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getPitTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getVehicleType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getVehicleTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getChecklist: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChecklistCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentRules: (tenantId, filter) => {
    return MdmsService.call(tenantId, getBillingServiceForBusinessServiceCriteria(filter));
  },
  getCustomizationConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getConfig(tenantId, moduleCode), moduleCode);
  },
  getSlumLocalityMapping: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getSlumLocalityCriteria(tenantId, moduleCode, type), moduleCode),
  getReason: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getReasonCriteria(tenantId, moduleCode, type, payload), moduleCode),
  getRoleStatus: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getRoleStatusCriteria(tenantId, moduleCode, type), moduleCode),
  getCommonFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getCommonFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPreFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPreFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPostFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPostFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPropertyOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  GetTradeOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyOwnerType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getSubPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTLDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTradeUnitsData: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeUnitsDataList(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMapConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDefaultMapConfig(tenantId, moduleCode), moduleCode);
  },
  getUsageCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getUsageCategoryList(tenantId, moduleCode), moduleCode);
  },
  getPTPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTPropertyTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLStructureType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLStructureTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLAccessoriesType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLAccessoriesTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLFinancialYear: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLFinancialYearList(tenantId, moduleCode), moduleCode);
  },
  getFloorList: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTFloorList(tenantId, moduleCode, type), moduleCode);
  },
  getRentalDetails: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getRentalDetailsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getChargeSlabs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChargeSlabsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getDssDashboard: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDssDashboardCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentGateway: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getReceiptKey: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptKey(tenantId, moduleCode), moduleCode);
  },
  getHelpText: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMCollectBillingService: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectBillingServiceCriteria(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMCollectApplcationStatus: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectApplicationStatusCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeRolesandDesignation: tenantId => {
    return MdmsService.call(tenantId, getHrmsEmployeeRolesandDesignations());
  },
  getHrmsEmployeeTypes: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMultipleTypes: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getMultipleTypesV2: (tenantId, moduleCode, types) => {
    return MdmsService.searchDataV2(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getFSTPPlantInfo: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPPlantCriteria(tenantId, moduleCode, types), moduleCode);
  },
  getCancelReceiptReason: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReason(tenantId, moduleCode), moduleCode);
  },
  getReceiptStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptStatus(tenantId, moduleCode), moduleCode);
  },
  getCancelReceiptReasonAndStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReasonAndStatus(tenantId, moduleCode), moduleCode);
  },
  getGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  TLGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  PTGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  HRGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentTypesCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getTradeTypeRoleTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeTypeRoleCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMSDropDownTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getMSDropDownCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getLandUseCategories: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getLandUseCategories(tenantId, moduleCode, type), moduleCode);
  },
  getFSMGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getFSTPORejectionReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPORejectionReasonCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMTripNumber: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMTripNumberCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMReceivedPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMReceivedPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  }
};

const UploadServices = {
  Filestorage: async (module, filedata, tenantId) => {
    var _window, _window$globalConfigs, _Digit$UserService$ge;
    const formData = new FormData();
    formData.append("file", filedata, filedata.name);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window = window) !== null && _window !== void 0 && (_window$globalConfigs = _window.globalConfigs) !== null && _window$globalConfigs !== void 0 && _window$globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        "auth-token": Digit.UserService.getUser() ? (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token : null
      }
    };
    return axios$3(config);
  },
  MultipleFilesStorage: async (module, filesData, tenantId) => {
    var _window2, _window2$globalConfig;
    const formData = new FormData();
    const filesArray = Array.from(filesData);
    filesArray === null || filesArray === void 0 ? void 0 : filesArray.forEach((fileData, index) => fileData ? formData.append("file", fileData, fileData.name) : null);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window2 = window) !== null && _window2 !== void 0 && (_window2$globalConfig = _window2.globalConfigs) !== null && _window2$globalConfig !== void 0 && _window2$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        "auth-token": Digit.UserService.getUser().access_token
      }
    };
    return axios$3(config);
  },
  Filefetch: async (filesArray, tenantId) => {
    var _window3, _window3$globalConfig;
    let tenantInfo = (_window3 = window) !== null && _window3 !== void 0 && (_window3$globalConfig = _window3.globalConfigs) !== null && _window3$globalConfig !== void 0 && _window3$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "get",
      url: `${Urls.FileFetch}${tenantInfo}`,
      params: {
        tenantId: tenantId,
        fileStoreIds: filesArray === null || filesArray === void 0 ? void 0 : filesArray.join(",")
      }
    };
    const res = await axios$3(config);
    return res;
  }
};

const OBPSService = {
  scrutinyDetails: (tenantId, params) => Request$1({
    url: Urls.obps.scrutinyDetails,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  comparisionReport: (tenantId, params) => Request$1({
    url: Urls.obps.comparisionReport,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  create: (details, tenantId) => Request$1({
    url: Urls.obps.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm11: details => Request$1({
    url: Urls.obps.createForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createLandUseUP: details => Request$1({
    url: Urls.obps.createLandUseUP,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createOwner: details => Request$1({
    url: Urls.obps.createOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateOwner: details => Request$1({
    url: Urls.obps.updateOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createPurchasableFAR: details => Request$1({
    url: Urls.obps.createPurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updatePurchasableFAR: details => Request$1({
    url: Urls.obps.updatePurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  calculateInstallments: details => Request$1({
    url: Urls.obps.installments,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createFormCLU: details => Request$1({
    url: Urls.obps.createFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm34: details => Request$1({
    url: Urls.obps.createForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm26: (details, tenantId) => Request$1({
    url: Urls.obps.createForm26,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  NOCSearch: (tenantId, sourceRefId) => Request$1({
    url: Urls.obps.nocSearch,
    params: {
      tenantId,
      ...sourceRefId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelCreate: (tenantId, details) => Request$1({
    url: Urls.noc.nocExcelCreate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelUpdate: (tenantId, details) => Request$1({
    url: Urls.noc.nocExcelUpdate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  update: (details, tenantId) => Request$1({
    url: Urls.obps.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  update11: (details, tenantId) => Request$1({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm11: details => Request$1({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormCLU: details => Request$1({
    url: Urls.obps.updateFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm34: details => Request$1({
    url: Urls.obps.updateForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormLandUse: details => Request$1({
    url: Urls.obps.updateFormLandUse,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateNOC: (details, tenantId) => Request$1({
    url: Urls.obps.updateNOC,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  BPASearch: (tenantId, params) => Request$1({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchNoAuth: (tenantId, params) => Request$1({
    url: Urls.obps.bpaSearchChallan,
    params: {
      tenantId,
      ...params
    },
    method: "POST"
  }),
  BPAmigratedSearch: params => Request$1({
    url: Urls.obps.migratedSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAREGCommonSearch: (tenantId, params) => Request$1({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAmigratedSearchappNo: params => Request$1({
    url: Urls.obps.migratedSearchappNo,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm11: (tenantId, params) => Request$1({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAOwnerRegistration: (tenantId, params) => Request$1({
    url: Urls.obps.ownerSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchPurchasableFAR: (tenantId, params) => Request$1({
    url: Urls.obps.searchPurchasableFar,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormLandUse: (tenantId, params) => Request$1({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm26: (tenantId, params) => Request$1({
    url: Urls.obps.searchfrom26,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormCLU: (tenantId, params) => Request$1({
    url: Urls.obps.searchFromCLU,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAFastPASSearch: params => Request$1({
    url: Urls.obps.fastpassSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm34: (tenantId, params) => Request$1({
    url: Urls.obps.searchFrom34,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchMyApplicationForm11: (tenantId, applicationType, limit, departement, details, params) => Request$1({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      applicationType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationForm12: (tenantId, applType, limit, departement, details, params) => Request$1({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAMyApplicationCommonsearch: (tenantId, applType, limit, departement, details, params) => Request$1({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationFormLandUse: (tenantId, applicationType, limit, details, params) => Request$1({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      applicationType,
      limit,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request$1({
    url: Urls.obps.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  designOfRegApprovalLetterPdf: (tenantId, applicationNumber, details) => Request$1({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true,
    data: details
  }),
  designOfStructuralLetter: (tenantId, applicationNumber, params) => Request$1({
    url: Urls.obps.designOfStuctural,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  farIntimationLetter: (tenantId, applicationNumber) => Request$1({
    url: Urls.obps.farIntimationLetter,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    data: {}
  }),
  scheduleInspection: details => Request$1({
    url: Urls.obps.scheduleInspection,
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  applicationDetailData: (tenantId, params) => Request$1({
    url: Urls.obps.applicationDetailData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  logUrlData: params => Request$1({
    url: Urls.logoUrl.bpaLogoUrl,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  applicationDetailDataView: (tenantId, params) => Request$1({
    url: Urls.obps.applicationDetailDataView,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountApplicationData: (tenantId, params) => Request$1({
    url: Urls.noc.nocCountApplicationData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchAppendex: (tenantId, params) => Request$1({
    url: Urls.obps.fetchAppendex,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchProfessional: (tenantId, params) => Request$1({
    url: Urls.obps.fetchProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountSearch: (tenantId, params) => Request$1({
    url: Urls.noc.nocCountSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplication: (tenantId, params) => Request$1({
    url: Urls.InboxSearchApplication,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplicationProfessional: (tenantId, params) => Request$1({
    url: Urls.InboxSearchApplicationProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentDetailData: tenantId => Request$1({
    url: Urls.obps.paymentList,
    params: {
      tenantId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentReportData: () => Request$1({
    url: Urls.obps.paymentReport,
    method: "POST"
  }),
  eChargesReportData: tenantId => Request$1({
    url: Urls.obps.echargesReport,
    params: {
      tenantId
    },
    method: "POST"
  }),
  applicationReportData: (tenantId, params) => Request$1({
    url: Urls.obps.applicationReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  applicationReportMISData: (tenantId, params) => Request$1({
    url: Urls.obps.applicationMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  searchReportData: params => Request$1({
    url: Urls.obps.employeeSearchList,
    params: params,
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISData: (tenantId, params) => Request$1({
    url: Urls.obps.paymentMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISDataNew: async (tenantId, params) => {
    try {
      return await Request$1({
        url: Urls.obps.paymentMisReportNew || "/bpa-services/v1/bpa/_extractAllMisData",
        params: {
          tenantId,
          _: Date.now(),
          ...params
        },
        userService: true,
        auth: true,
        method: "POST"
      });
    } catch (err) {
      var _err$response;
      if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 405) {
        return await Request$1({
          url: Urls.obps.paymentMisReportNew ,
          params: {
            tenantId,
            _: Date.now(),
            ...params
          },
          userService: true,
          auth: true,
          method: "GET"
        });
      }
      throw err;
    }
  },
  dashboardReportData: (tenantId, params) => Request$1({
    url: Urls.obps.dashboardReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  selfApprovalReportData: (tenantId, params) => Request$1({
    url: Urls.obps.selfApprovalReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  scrutinyReportFailedData: selectedDate => Request$1({
    url: Urls.obps.scrutinyFailedReport,
    params: {
      selectedDate
    },
    userService: true,
    auth: true,
    method: "GET"
  }),
  inwardReportData: tenantId => Request$1({
    url: Urls.obps.inwardApplicationReport,
    params: {
      tenantId
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  bpacalculate: details => Request$1({
    url: Urls.obps.bpacalculate,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  bpacalculatechallan: details => Request$1({
    url: Urls.obps.bpacalculatechallan,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  deleteChallan: (details, params) => Request$1({
    url: Urls.obps.deleteChallan,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  calculateInstallment: (details, params) => Request$1({
    url: Urls.obps.installmentCalculate,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  BPAREGSearch: (tenantId, details, params) => Request$1({
    url: Urls.obps.bpaRegSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAREGCreate: (details, tenantId) => Request$1({
    url: Urls.obps.bpaRegCreate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  BPAREGGetBill: (tenantId, filters = {}) => Request$1({
    url: Urls.obps.bpaRegGetBill,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }).then(d => {
    return d;
  }).catch(err => {
    var _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2;
    if ((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) === "EG_BS_BILL_NO_DEMANDS_FOUND") return {
      Bill: []
    };else throw err;
  }),
  BPAREGupdate: (details, tenantId) => Request$1({
    url: Urls.obps.bpaRegUpdate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  receipt_download: (bussinessService, consumerCode, tenantId, filters = {}) => Request$1({
    url: Urls.obps.receipt_download,
    data: {},
    useCache: true,
    method: "POST",
    params: {
      bussinessService,
      consumerCode,
      tenantId,
      ...filters
    },
    auth: true,
    locale: true,
    userService: true,
    userDownload: true
  }),
  edcr_report_download: (details, tenantId) => Request$1({
    url: Urls.obps.edcrreportdownload,
    data: details,
    useCache: true,
    method: "POST",
    auth: true,
    locale: true,
    userService: false,
    userDownload: true
  }),
  ltpGrading: (details, tenantId) => Request$1({
    url: Urls.obps.ltpGrading,
    useCache: false,
    method: "POST",
    auth: false,
    userService: false
  }),
  LicenseDetails: async (tenantId, params) => {
    var _response$Licenses, _License$tradeLicense, _License$tradeLicense2, _mdmsRes$StakeholderR, _mdmsRes$StakeholderR2, _License$tradeLicense8, _License$tradeLicense9, _License$tradeLicense10, _License$tradeLicense11, _License$tradeLicense12, _License$tradeLicense13, _License$tradeLicense14, _License$tradeLicense15, _License$tradeLicense16, _License$tradeLicense17, _License$tradeLicense18, _License$tradeLicense19, _License$tradeLicense20, _License$tradeLicense21, _License$tradeLicense22, _License$tradeLicense23, _License$tradeLicense24, _License$tradeLicense25, _License$tradeLicense26, _License$tradeLicense27, _License$tradeLicense28, _License$tradeLicense29, _License$tradeLicense30, _License$tradeLicense31, _License$tradeLicense32, _License$tradeLicense33, _License$tradeLicense34, _License$tradeLicense35, _License$tradeLicense36, _License$tradeLicense37, _License$tradeLicense38, _License$tradeLicense39, _License$tradeLicense40, _License$tradeLicense41, _License$tradeLicense42, _License$tradeLicense43, _License$tradeLicense44, _License$tradeLicense45, _License$tradeLicense46, _License$tradeLicense47, _License$tradeLicense48, _License$tradeLicense49, _License$tradeLicense50, _License$tradeLicense51, _License$tradeLicense52, _License$tradeLicense53, _License$tradeLicense54, _License$tradeLicense55, _License$tradeLicense56, _License$tradeLicense57, _License$tradeLicense58, _License$tradeLicense59, _License$tradeLicense60, _License$tradeLicense61, _License$tradeLicense62, _License$tradeLicense63, _License$tradeLicense64, _License$tradeLicense65, _License$tradeLicense66, _License$tradeLicense67, _License$tradeLicense68, _License$tradeLicense69, _License$tradeLicense70, _License$tradeLicense71, _License$tradeLicense72, _License$tradeLicense73, _License$tradeLicense74, _License$tradeLicense75, _License$tradeLicense76, _License$tradeLicense77, _License$tradeLicense78, _License$tradeLicense79, _License$tradeLicense80, _License$tradeLicense81, _License$tradeLicense82, _License$tradeLicense83, _License$tradeLicense84, _License$tradeLicense85, _License$tradeLicense86, _License$tradeLicense87, _License$tradeLicense88, _License$tradeLicense89, _License$tradeLicense90, _License$tradeLicense91, _License$tradeLicense92, _License$tradeLicense93, _License$tradeLicense94, _License$tradeLicense95, _License$tradeLicense96, _License$tradeLicense97, _License$tradeLicense98, _License$tradeLicense99, _License$tradeLicense100, _License$tradeLicense101, _License$tradeLicense102, _License$tradeLicense103, _License$tradeLicense104, _License$tradeLicense105, _License$tradeLicense106, _License$tradeLicense107, _License$tradeLicense108, _License$tradeLicense109, _License$tradeLicense110, _License$tradeLicense111, _License$tradeLicense112, _License$tradeLicense113, _License$tradeLicense114, _License$tradeLicense115, _License$tradeLicense116, _License$tradeLicense117, _License$tradeLicense118, _License$tradeLicense119, _License$tradeLicense120, _License$tradeLicense121, _License$tradeLicense122, _License$tradeLicense123, _License$tradeLicense124, _License$tradeLicense125, _License$tradeLicense126, _License$tradeLicense127, _License$tradeLicense128, _License$tradeLicense129, _License$tradeLicense130, _License$tradeLicense131, _License$tradeLicense132, _License$tradeLicense133, _License$tradeLicense134, _License$tradeLicense135, _License$tradeLicense136, _License$tradeLicense137, _paymentRes$Payments, _paymentRes$Payments2, _paymentRes$Payments3, _paymentRes$Payments4, _paymentRes$Payments5;
    const response = await OBPSService.BPAREGSearch(tenantId, {}, params);
    if (!(response !== null && response !== void 0 && (_response$Licenses = response.Licenses) !== null && _response$Licenses !== void 0 && _response$Licenses.length)) {
      return;
    }
    const [License] = response === null || response === void 0 ? void 0 : response.Licenses;
    const paymentRes = await Digit.PaymentService.recieptSearch(tenantId, "BPAREG", {
      consumerCodes: License === null || License === void 0 ? void 0 : License.applicationNumber,
      isEmployee: true
    });
    const mdmsRes = await MdmsService.getMultipleTypes(License === null || License === void 0 ? void 0 : License.tenantId, "StakeholderRegistraition", ["TradeTypetoRoleMapping"]);
    if (License !== null && License !== void 0 && (_License$tradeLicense = License.tradeLicenseDetail) !== null && _License$tradeLicense !== void 0 && (_License$tradeLicense2 = _License$tradeLicense.applicationDocuments) !== null && _License$tradeLicense2 !== void 0 && _License$tradeLicense2.length && (mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR === void 0 ? void 0 : (_mdmsRes$StakeholderR2 = _mdmsRes$StakeholderR.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR2 === void 0 ? void 0 : _mdmsRes$StakeholderR2.length) > 0) {
      var _mdmsRes$StakeholderR3, _mdmsRes$StakeholderR4;
      mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR3 = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR3 === void 0 ? void 0 : (_mdmsRes$StakeholderR4 = _mdmsRes$StakeholderR3.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR4 === void 0 ? void 0 : _mdmsRes$StakeholderR4.map(doc => {
        var _doc$docTypes, _License$tradeLicense3, _License$tradeLicense4, _License$tradeLicense5;
        if ((doc === null || doc === void 0 ? void 0 : (_doc$docTypes = doc.docTypes) === null || _doc$docTypes === void 0 ? void 0 : _doc$docTypes.length) > 0 && (doc === null || doc === void 0 ? void 0 : doc.tradeType) == (License === null || License === void 0 ? void 0 : (_License$tradeLicense3 = License.tradeLicenseDetail) === null || _License$tradeLicense3 === void 0 ? void 0 : (_License$tradeLicense4 = _License$tradeLicense3.tradeUnits) === null || _License$tradeLicense4 === void 0 ? void 0 : (_License$tradeLicense5 = _License$tradeLicense4[0]) === null || _License$tradeLicense5 === void 0 ? void 0 : _License$tradeLicense5.tradeType)) {
          var _doc$docTypes2;
          doc === null || doc === void 0 ? void 0 : (_doc$docTypes2 = doc.docTypes) === null || _doc$docTypes2 === void 0 ? void 0 : _doc$docTypes2.map(docType => {
            var _License$tradeLicense6, _License$tradeLicense7;
            License === null || License === void 0 ? void 0 : (_License$tradeLicense6 = License.tradeLicenseDetail) === null || _License$tradeLicense6 === void 0 ? void 0 : (_License$tradeLicense7 = _License$tradeLicense6.applicationDocuments) === null || _License$tradeLicense7 === void 0 ? void 0 : _License$tradeLicense7.forEach(document => {
              if ((docType === null || docType === void 0 ? void 0 : docType.code) == (document === null || document === void 0 ? void 0 : document.documentType) && docType !== null && docType !== void 0 && docType.info) document.info = docType === null || docType === void 0 ? void 0 : docType.info;
            });
          });
        }
      });
    }
    const appDocumentFileStoreIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense8 = License.tradeLicenseDetail) === null || _License$tradeLicense8 === void 0 ? void 0 : (_License$tradeLicense9 = _License$tradeLicense8.applicationDocuments) === null || _License$tradeLicense9 === void 0 ? void 0 : _License$tradeLicense9.map(appDoc => appDoc === null || appDoc === void 0 ? void 0 : appDoc.fileStoreId);
    let fileDetails = {};
    if ((appDocumentFileStoreIds === null || appDocumentFileStoreIds === void 0 ? void 0 : appDocumentFileStoreIds.length) > 0) {
      fileDetails = await UploadServices.Filefetch(appDocumentFileStoreIds, Digit.ULBService.getStateId());
    }
    const details = [{
      title: " ",
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (License === null || License === void 0 ? void 0 : License.applicationNumber) || "NA"
      }]
    }, License !== null && License !== void 0 && (_License$tradeLicense10 = License.tradeLicenseDetail) !== null && _License$tradeLicense10 !== void 0 && (_License$tradeLicense11 = _License$tradeLicense10.tradeUnits) !== null && _License$tradeLicense11 !== void 0 && (_License$tradeLicense12 = _License$tradeLicense11[0]) !== null && _License$tradeLicense12 !== void 0 && _License$tradeLicense12.tradeType.includes("ARCHITECT") ? {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense13 = License.tradeLicenseDetail) === null || _License$tradeLicense13 === void 0 ? void 0 : (_License$tradeLicense14 = _License$tradeLicense13.tradeUnits) === null || _License$tradeLicense14 === void 0 ? void 0 : (_License$tradeLicense15 = _License$tradeLicense14[0]) === null || _License$tradeLicense15 === void 0 ? void 0 : (_License$tradeLicense16 = _License$tradeLicense15.tradeType) === null || _License$tradeLicense16 === void 0 ? void 0 : _License$tradeLicense16.split(".")[0]}` || "NA"
      }, {
        title: "BPA_COUNCIL_OF_ARCH_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense17 = License.tradeLicenseDetail) === null || _License$tradeLicense17 === void 0 ? void 0 : (_License$tradeLicense18 = _License$tradeLicense17.additionalDetail) === null || _License$tradeLicense18 === void 0 ? void 0 : _License$tradeLicense18.counsilForArchNo) || "NA"
      }]
    } : {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense19 = License.tradeLicenseDetail) === null || _License$tradeLicense19 === void 0 ? void 0 : (_License$tradeLicense20 = _License$tradeLicense19.tradeUnits) === null || _License$tradeLicense20 === void 0 ? void 0 : (_License$tradeLicense21 = _License$tradeLicense20[0]) === null || _License$tradeLicense21 === void 0 ? void 0 : (_License$tradeLicense22 = _License$tradeLicense21.tradeType) === null || _License$tradeLicense22 === void 0 ? void 0 : _License$tradeLicense22.split(".")[0]}` || "NA"
      }]
    }, {
      title: "BPA_LICENSEE_DETAILS_HEADER_OWNER_INFO",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_NAME_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense23 = License.tradeLicenseDetail) === null || _License$tradeLicense23 === void 0 ? void 0 : (_License$tradeLicense24 = _License$tradeLicense23.owners) === null || _License$tradeLicense24 === void 0 ? void 0 : (_License$tradeLicense25 = _License$tradeLicense24[0]) === null || _License$tradeLicense25 === void 0 ? void 0 : _License$tradeLicense25.name) || "NA"
      }, {
        title: "BPA_APPLICANT_GENDER_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense26 = License.tradeLicenseDetail) === null || _License$tradeLicense26 === void 0 ? void 0 : (_License$tradeLicense27 = _License$tradeLicense26.owners) === null || _License$tradeLicense27 === void 0 ? void 0 : (_License$tradeLicense28 = _License$tradeLicense27[0]) === null || _License$tradeLicense28 === void 0 ? void 0 : _License$tradeLicense28.gender) || "NA"
      }, {
        title: "BPA_OWNER_MOBILE_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense29 = License.tradeLicenseDetail) === null || _License$tradeLicense29 === void 0 ? void 0 : (_License$tradeLicense30 = _License$tradeLicense29.owners) === null || _License$tradeLicense30 === void 0 ? void 0 : (_License$tradeLicense31 = _License$tradeLicense30[0]) === null || _License$tradeLicense31 === void 0 ? void 0 : _License$tradeLicense31.mobileNumber) || "NA"
      }, {
        title: "BPA_APPLICANT_EMAIL_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense32 = License.tradeLicenseDetail) === null || _License$tradeLicense32 === void 0 ? void 0 : (_License$tradeLicense33 = _License$tradeLicense32.owners) === null || _License$tradeLicense33 === void 0 ? void 0 : (_License$tradeLicense34 = _License$tradeLicense33[0]) === null || _License$tradeLicense34 === void 0 ? void 0 : _License$tradeLicense34.emailId) || "NA"
      }, {
        title: "BPA_APPLICANT_PAN_NO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense35 = License.tradeLicenseDetail) === null || _License$tradeLicense35 === void 0 ? void 0 : (_License$tradeLicense36 = _License$tradeLicense35.owners) === null || _License$tradeLicense36 === void 0 ? void 0 : (_License$tradeLicense37 = _License$tradeLicense36[0]) === null || _License$tradeLicense37 === void 0 ? void 0 : _License$tradeLicense37.pan) || "NA"
      }]
    }, {
      title: "BPA_PERMANANT_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_PERMANANT_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense38 = License.tradeLicenseDetail) === null || _License$tradeLicense38 === void 0 ? void 0 : (_License$tradeLicense39 = _License$tradeLicense38.additionalDetail) === null || _License$tradeLicense39 === void 0 ? void 0 : (_License$tradeLicense40 = _License$tradeLicense39[0]) === null || _License$tradeLicense40 === void 0 ? void 0 : (_License$tradeLicense41 = _License$tradeLicense40.tradeLicenseDetail) === null || _License$tradeLicense41 === void 0 ? void 0 : (_License$tradeLicense42 = _License$tradeLicense41.owners) === null || _License$tradeLicense42 === void 0 ? void 0 : (_License$tradeLicense43 = _License$tradeLicense42[0]) === null || _License$tradeLicense43 === void 0 ? void 0 : (_License$tradeLicense44 = _License$tradeLicense43.permanentAddress) === null || _License$tradeLicense44 === void 0 ? void 0 : _License$tradeLicense44.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense45 = License.tradeLicenseDetail) === null || _License$tradeLicense45 === void 0 ? void 0 : (_License$tradeLicense46 = _License$tradeLicense45.additionalDetail) === null || _License$tradeLicense46 === void 0 ? void 0 : (_License$tradeLicense47 = _License$tradeLicense46[0]) === null || _License$tradeLicense47 === void 0 ? void 0 : (_License$tradeLicense48 = _License$tradeLicense47.tradeLicenseDetail) === null || _License$tradeLicense48 === void 0 ? void 0 : (_License$tradeLicense49 = _License$tradeLicense48.owners) === null || _License$tradeLicense49 === void 0 ? void 0 : (_License$tradeLicense50 = _License$tradeLicense49[0]) === null || _License$tradeLicense50 === void 0 ? void 0 : (_License$tradeLicense51 = _License$tradeLicense50.permanentAddress) === null || _License$tradeLicense51 === void 0 ? void 0 : _License$tradeLicense51.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense52 = License.tradeLicenseDetail) === null || _License$tradeLicense52 === void 0 ? void 0 : (_License$tradeLicense53 = _License$tradeLicense52.additionalDetail) === null || _License$tradeLicense53 === void 0 ? void 0 : (_License$tradeLicense54 = _License$tradeLicense53[0]) === null || _License$tradeLicense54 === void 0 ? void 0 : (_License$tradeLicense55 = _License$tradeLicense54.tradeLicenseDetail) === null || _License$tradeLicense55 === void 0 ? void 0 : (_License$tradeLicense56 = _License$tradeLicense55.owners) === null || _License$tradeLicense56 === void 0 ? void 0 : (_License$tradeLicense57 = _License$tradeLicense56[0]) === null || _License$tradeLicense57 === void 0 ? void 0 : (_License$tradeLicense58 = _License$tradeLicense57.permanentAddress) === null || _License$tradeLicense58 === void 0 ? void 0 : _License$tradeLicense58.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense59 = License.tradeLicenseDetail) === null || _License$tradeLicense59 === void 0 ? void 0 : (_License$tradeLicense60 = _License$tradeLicense59.additionalDetail) === null || _License$tradeLicense60 === void 0 ? void 0 : (_License$tradeLicense61 = _License$tradeLicense60[0]) === null || _License$tradeLicense61 === void 0 ? void 0 : (_License$tradeLicense62 = _License$tradeLicense61.tradeLicenseDetail) === null || _License$tradeLicense62 === void 0 ? void 0 : (_License$tradeLicense63 = _License$tradeLicense62.owners) === null || _License$tradeLicense63 === void 0 ? void 0 : (_License$tradeLicense64 = _License$tradeLicense63[0]) === null || _License$tradeLicense64 === void 0 ? void 0 : (_License$tradeLicense65 = _License$tradeLicense64.permanentAddress) === null || _License$tradeLicense65 === void 0 ? void 0 : _License$tradeLicense65.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense66 = License.tradeLicenseDetail) === null || _License$tradeLicense66 === void 0 ? void 0 : (_License$tradeLicense67 = _License$tradeLicense66.additionalDetail) === null || _License$tradeLicense67 === void 0 ? void 0 : (_License$tradeLicense68 = _License$tradeLicense67[0]) === null || _License$tradeLicense68 === void 0 ? void 0 : (_License$tradeLicense69 = _License$tradeLicense68.tradeLicenseDetail) === null || _License$tradeLicense69 === void 0 ? void 0 : (_License$tradeLicense70 = _License$tradeLicense69.owners) === null || _License$tradeLicense70 === void 0 ? void 0 : (_License$tradeLicense71 = _License$tradeLicense70[0]) === null || _License$tradeLicense71 === void 0 ? void 0 : (_License$tradeLicense72 = _License$tradeLicense71.permanentAddress) === null || _License$tradeLicense72 === void 0 ? void 0 : _License$tradeLicense72.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense73 = License.tradeLicenseDetail) === null || _License$tradeLicense73 === void 0 ? void 0 : (_License$tradeLicense74 = _License$tradeLicense73.additionalDetail) === null || _License$tradeLicense74 === void 0 ? void 0 : (_License$tradeLicense75 = _License$tradeLicense74[0]) === null || _License$tradeLicense75 === void 0 ? void 0 : (_License$tradeLicense76 = _License$tradeLicense75.tradeLicenseDetail) === null || _License$tradeLicense76 === void 0 ? void 0 : (_License$tradeLicense77 = _License$tradeLicense76.owners) === null || _License$tradeLicense77 === void 0 ? void 0 : (_License$tradeLicense78 = _License$tradeLicense77[0]) === null || _License$tradeLicense78 === void 0 ? void 0 : (_License$tradeLicense79 = _License$tradeLicense78.permanentAddress) === null || _License$tradeLicense79 === void 0 ? void 0 : _License$tradeLicense79.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense80 = License.tradeLicenseDetail) === null || _License$tradeLicense80 === void 0 ? void 0 : (_License$tradeLicense81 = _License$tradeLicense80.additionalDetail) === null || _License$tradeLicense81 === void 0 ? void 0 : (_License$tradeLicense82 = _License$tradeLicense81[0]) === null || _License$tradeLicense82 === void 0 ? void 0 : (_License$tradeLicense83 = _License$tradeLicense82.tradeLicenseDetail) === null || _License$tradeLicense83 === void 0 ? void 0 : (_License$tradeLicense84 = _License$tradeLicense83.owners) === null || _License$tradeLicense84 === void 0 ? void 0 : (_License$tradeLicense85 = _License$tradeLicense84[0]) === null || _License$tradeLicense85 === void 0 ? void 0 : (_License$tradeLicense86 = _License$tradeLicense85.permanentAddress) === null || _License$tradeLicense86 === void 0 ? void 0 : _License$tradeLicense86.university) || "NA"
      }]
    }, {
      title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense87 = License.tradeLicenseDetail) === null || _License$tradeLicense87 === void 0 ? void 0 : (_License$tradeLicense88 = _License$tradeLicense87.additionalDetail) === null || _License$tradeLicense88 === void 0 ? void 0 : (_License$tradeLicense89 = _License$tradeLicense88[0]) === null || _License$tradeLicense89 === void 0 ? void 0 : (_License$tradeLicense90 = _License$tradeLicense89.tradeLicenseDetail) === null || _License$tradeLicense90 === void 0 ? void 0 : (_License$tradeLicense91 = _License$tradeLicense90.owners) === null || _License$tradeLicense91 === void 0 ? void 0 : (_License$tradeLicense92 = _License$tradeLicense91[0]) === null || _License$tradeLicense92 === void 0 ? void 0 : (_License$tradeLicense93 = _License$tradeLicense92.correspondenceAddress) === null || _License$tradeLicense93 === void 0 ? void 0 : _License$tradeLicense93.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense94 = License.tradeLicenseDetail) === null || _License$tradeLicense94 === void 0 ? void 0 : (_License$tradeLicense95 = _License$tradeLicense94.additionalDetail) === null || _License$tradeLicense95 === void 0 ? void 0 : (_License$tradeLicense96 = _License$tradeLicense95[0]) === null || _License$tradeLicense96 === void 0 ? void 0 : (_License$tradeLicense97 = _License$tradeLicense96.tradeLicenseDetail) === null || _License$tradeLicense97 === void 0 ? void 0 : (_License$tradeLicense98 = _License$tradeLicense97.owners) === null || _License$tradeLicense98 === void 0 ? void 0 : (_License$tradeLicense99 = _License$tradeLicense98[0]) === null || _License$tradeLicense99 === void 0 ? void 0 : (_License$tradeLicense100 = _License$tradeLicense99.correspondenceAddress) === null || _License$tradeLicense100 === void 0 ? void 0 : _License$tradeLicense100.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense101 = License.tradeLicenseDetail) === null || _License$tradeLicense101 === void 0 ? void 0 : (_License$tradeLicense102 = _License$tradeLicense101.additionalDetail) === null || _License$tradeLicense102 === void 0 ? void 0 : (_License$tradeLicense103 = _License$tradeLicense102[0]) === null || _License$tradeLicense103 === void 0 ? void 0 : (_License$tradeLicense104 = _License$tradeLicense103.tradeLicenseDetail) === null || _License$tradeLicense104 === void 0 ? void 0 : (_License$tradeLicense105 = _License$tradeLicense104.owners) === null || _License$tradeLicense105 === void 0 ? void 0 : (_License$tradeLicense106 = _License$tradeLicense105[0]) === null || _License$tradeLicense106 === void 0 ? void 0 : (_License$tradeLicense107 = _License$tradeLicense106.correspondenceAddress) === null || _License$tradeLicense107 === void 0 ? void 0 : _License$tradeLicense107.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense108 = License.tradeLicenseDetail) === null || _License$tradeLicense108 === void 0 ? void 0 : (_License$tradeLicense109 = _License$tradeLicense108.additionalDetail) === null || _License$tradeLicense109 === void 0 ? void 0 : (_License$tradeLicense110 = _License$tradeLicense109[0]) === null || _License$tradeLicense110 === void 0 ? void 0 : (_License$tradeLicense111 = _License$tradeLicense110.tradeLicenseDetail) === null || _License$tradeLicense111 === void 0 ? void 0 : (_License$tradeLicense112 = _License$tradeLicense111.owners) === null || _License$tradeLicense112 === void 0 ? void 0 : (_License$tradeLicense113 = _License$tradeLicense112[0]) === null || _License$tradeLicense113 === void 0 ? void 0 : (_License$tradeLicense114 = _License$tradeLicense113.correspondenceAddress) === null || _License$tradeLicense114 === void 0 ? void 0 : _License$tradeLicense114.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense115 = License.tradeLicenseDetail) === null || _License$tradeLicense115 === void 0 ? void 0 : (_License$tradeLicense116 = _License$tradeLicense115.additionalDetail) === null || _License$tradeLicense116 === void 0 ? void 0 : (_License$tradeLicense117 = _License$tradeLicense116[0]) === null || _License$tradeLicense117 === void 0 ? void 0 : (_License$tradeLicense118 = _License$tradeLicense117.tradeLicenseDetail) === null || _License$tradeLicense118 === void 0 ? void 0 : (_License$tradeLicense119 = _License$tradeLicense118.owners) === null || _License$tradeLicense119 === void 0 ? void 0 : (_License$tradeLicense120 = _License$tradeLicense119[0]) === null || _License$tradeLicense120 === void 0 ? void 0 : (_License$tradeLicense121 = _License$tradeLicense120.correspondenceAddress) === null || _License$tradeLicense121 === void 0 ? void 0 : _License$tradeLicense121.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense122 = License.tradeLicenseDetail) === null || _License$tradeLicense122 === void 0 ? void 0 : (_License$tradeLicense123 = _License$tradeLicense122.additionalDetail) === null || _License$tradeLicense123 === void 0 ? void 0 : (_License$tradeLicense124 = _License$tradeLicense123[0]) === null || _License$tradeLicense124 === void 0 ? void 0 : (_License$tradeLicense125 = _License$tradeLicense124.tradeLicenseDetail) === null || _License$tradeLicense125 === void 0 ? void 0 : (_License$tradeLicense126 = _License$tradeLicense125.owners) === null || _License$tradeLicense126 === void 0 ? void 0 : (_License$tradeLicense127 = _License$tradeLicense126[0]) === null || _License$tradeLicense127 === void 0 ? void 0 : (_License$tradeLicense128 = _License$tradeLicense127.correspondenceAddress) === null || _License$tradeLicense128 === void 0 ? void 0 : _License$tradeLicense128.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense129 = License.tradeLicenseDetail) === null || _License$tradeLicense129 === void 0 ? void 0 : (_License$tradeLicense130 = _License$tradeLicense129.additionalDetail) === null || _License$tradeLicense130 === void 0 ? void 0 : (_License$tradeLicense131 = _License$tradeLicense130[0]) === null || _License$tradeLicense131 === void 0 ? void 0 : (_License$tradeLicense132 = _License$tradeLicense131.tradeLicenseDetail) === null || _License$tradeLicense132 === void 0 ? void 0 : (_License$tradeLicense133 = _License$tradeLicense132.owners) === null || _License$tradeLicense133 === void 0 ? void 0 : (_License$tradeLicense134 = _License$tradeLicense133[0]) === null || _License$tradeLicense134 === void 0 ? void 0 : (_License$tradeLicense135 = _License$tradeLicense134.correspondenceAddress) === null || _License$tradeLicense135 === void 0 ? void 0 : _License$tradeLicense135.university) || "NA"
      }]
    }, {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      additionalDetails: {
        documentsWithUrl: [{
          title: "",
          values: License === null || License === void 0 ? void 0 : (_License$tradeLicense136 = License.tradeLicenseDetail) === null || _License$tradeLicense136 === void 0 ? void 0 : (_License$tradeLicense137 = _License$tradeLicense136.applicationDocuments) === null || _License$tradeLicense137 === void 0 ? void 0 : _License$tradeLicense137.map(doc => {
            var _doc$documentType, _fileDetails, _fileDetails2, _fileDetails2$data$do;
            return {
              title: `BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll(".", "_")}`,
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              docInfo: doc === null || doc === void 0 ? void 0 : doc.info,
              url: (_fileDetails = fileDetails) !== null && _fileDetails !== void 0 && _fileDetails.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? (_fileDetails2 = fileDetails) === null || _fileDetails2 === void 0 ? void 0 : (_fileDetails2$data$do = _fileDetails2.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails2$data$do === void 0 ? void 0 : _fileDetails2$data$do.split(",")[0] : ""
            };
          })
        }]
      }
    }, (paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments = paymentRes.Payments) === null || _paymentRes$Payments === void 0 ? void 0 : _paymentRes$Payments.length) > 0 && {
      title: "BPA_FEE_DETAILS_LABEL",
      additionalDetails: {
        inspectionReport: [],
        values: [{
          title: "BPAREG_FEES",
          value: /*#__PURE__*/React__default.createElement("span", null, "\u20B9", paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments2 = paymentRes.Payments) === null || _paymentRes$Payments2 === void 0 ? void 0 : (_paymentRes$Payments3 = _paymentRes$Payments2[0]) === null || _paymentRes$Payments3 === void 0 ? void 0 : _paymentRes$Payments3.totalAmountPaid)
        }, {
          title: "BPA_STATUS_LABEL",
          isTransLate: true,
          isStatus: true,
          value: paymentRes !== null && paymentRes !== void 0 && (_paymentRes$Payments4 = paymentRes.Payments) !== null && _paymentRes$Payments4 !== void 0 && (_paymentRes$Payments5 = _paymentRes$Payments4[0]) !== null && _paymentRes$Payments5 !== void 0 && _paymentRes$Payments5.totalAmountPaid ? "WF_BPA_PAID" : "NA",
          isTransLate: true
        }]
      }
    }];
    return {
      applicationData: License,
      applicationDetails: details,
      tenantId: License === null || License === void 0 ? void 0 : License.tenantId,
      payments: (paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.Payments) || []
    };
  },
  BPADetailsPage: async (tenantId, filters) => {
    var _response$BPA, _response$BPA$, _response$BPA$$docume, _response$BPA2, _response$BPA3, _response$BPA3$, _response$BPA3$$addit, _response$BPA4, _response$BPA4$, _response$BPA4$$addit, _response$BPA5, _edcrResponse, _BPA$additionalDetail, _BPA$additionalDetail2, _BPA$additionalDetail3, _BPA$additionalDetail4, _BPA$additionalDetail5, _BPA$additionalDetail6, _BPA$additionalDetail7, _BPA$additionalDetail8, _BPA$additionalDetail9, _BPA$auditDetails, _BPA$auditDetails2, _edcr$, _edcr$2, _edcr$3, _edcr$3$planDetail, _edcr$3$planDetail$pl, _edcr$4, _edcr$4$planDetail, _edcr$4$planDetail$pl, _edcr$5, _edcr$5$planDetail, _edcr$5$planDetail$pl, _edcr$6, _edcr$6$planDetail, _edcr$6$planDetail$pl, _edcr$7, _edcr$7$planDetail, _edcr$7$planDetail$pl, _BPA$additionalDetail13, _BPA$additionalDetail14, _edcr$8, _edcr$9, _edcr$10, _edcr$11, _edcr$11$planDetail, _edcr$11$planDetail$b, _edcr$11$planDetail$b2, _edcr$11$planDetail$b3, _edcr$12, _edcr$12$planDetail, _edcr$12$planDetail$b, _edcr$12$planDetail$b2, _edcr$12$planDetail$b3, _edcr$13, _edcr$13$planDetail, _edcr$13$planDetail$b, _edcr$13$planDetail$b2, _edcr$13$planDetail$b3, _edcr$14, _edcr$14$planDetail, _edcr$14$planDetail$p, _BPA$landInfo, _BPA$landInfo$address, _BPA$additionalDetail15, _BPA$additionalDetail16, _BPA$additionalDetail17, _BPA$additionalDetail18, _BPA$additionalDetail19, _BPA$additionalDetail20, _BPA$landInfo2, _BPA$landInfo2$owners, _BPA$landInfo3, _BPA$landInfo3$owners, _BPA$additionalDetail21, _BPA$additionalDetail22, _BPA$additionalDetail23, _BPA$documents, _BPA$additionalDetail24, _BPA$additionalDetail25, _BPA$additionalDetail26, _BPA$additionalDetail27, _BPA$additionalDetail28, _BPA$additionalDetail29, _BPA$additionalDetail30, _billDetails$addition, _billDetails$addition2, _details;
    const response = await OBPSService.BPASearch(tenantId, filters);
    console.log("Latest5111111111111111111", response);
    const currentTenant = Digit.ULBService.getCurrentTenantId();
    let appDocumentFileStoreIds = response === null || response === void 0 ? void 0 : (_response$BPA = response.BPA) === null || _response$BPA === void 0 ? void 0 : (_response$BPA$ = _response$BPA[0]) === null || _response$BPA$ === void 0 ? void 0 : (_response$BPA$$docume = _response$BPA$.documents) === null || _response$BPA$$docume === void 0 ? void 0 : _response$BPA$$docume.map(docId => docId.fileStoreId);
    if (!appDocumentFileStoreIds) appDocumentFileStoreIds = [];
    if (!(response !== null && response !== void 0 && (_response$BPA2 = response.BPA) !== null && _response$BPA2 !== void 0 && _response$BPA2.length)) {
      return;
    }
    sessionStorage.setItem("BPA_ARCHITECT_NAME", JSON.stringify(response !== null && response !== void 0 && (_response$BPA3 = response.BPA) !== null && _response$BPA3 !== void 0 && (_response$BPA3$ = _response$BPA3[0]) !== null && _response$BPA3$ !== void 0 && (_response$BPA3$$addit = _response$BPA3$.additionalDetails) !== null && _response$BPA3$$addit !== void 0 && _response$BPA3$$addit.typeOfArchitect ? response === null || response === void 0 ? void 0 : (_response$BPA4 = response.BPA) === null || _response$BPA4 === void 0 ? void 0 : (_response$BPA4$ = _response$BPA4[0]) === null || _response$BPA4$ === void 0 ? void 0 : (_response$BPA4$$addit = _response$BPA4$.additionalDetails) === null || _response$BPA4$$addit === void 0 ? void 0 : _response$BPA4$$addit.typeOfArchitect : "ARCHITECT"));
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA5 = response.BPA) === null || _response$BPA5 === void 0 ? void 0 : _response$BPA5[0];
    let edcrResponse = {};
    if (BPA !== null && BPA !== void 0 && BPA.edcrNumber) {
      edcrResponse = await OBPSService.scrutinyDetails(currentTenant, {
        edcrNumber: BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber
      });
    }
    const edcr = ((_edcrResponse = edcrResponse) === null || _edcrResponse === void 0 ? void 0 : _edcrResponse.edcrDetail) || [];
    const nocResponse = await OBPSService.NOCSearch(currentTenant, {
      sourceRefId: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo
    });
    const noc = nocResponse === null || nocResponse === void 0 ? void 0 : nocResponse.Noc;
    noc === null || noc === void 0 ? void 0 : noc.map(nocDetails => {
      var _nocDetails$documents;
      nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents = nocDetails.documents) === null || _nocDetails$documents === void 0 ? void 0 : _nocDetails$documents.map(nocDoc => {
        if (nocDoc !== null && nocDoc !== void 0 && nocDoc.fileStoreId) appDocumentFileStoreIds.push(nocDoc === null || nocDoc === void 0 ? void 0 : nocDoc.fileStoreId);
      });
    });
    let fileDetails = {};
    let appBusinessService = [],
      collectionBillDetails = [],
      collectionBillArray = [],
      totalAmount = 0,
      collectionBillRes = [];
    const bussinessService = BPA === null || BPA === void 0 ? void 0 : BPA.businessService;
    const isUD = bussinessService === null || bussinessService === void 0 ? void 0 : bussinessService.includes("UD");
    if (bussinessService === "BPA_LOW") appBusinessService = ["BPA.LOW_RISK_PERMIT_FEE"];else if (bussinessService === "BPA") appBusinessService = ["BPA.FORM_12_FEE_UD", "BPA.FORM_12_FEE_UD"];else if (bussinessService === "BPA_OC") appBusinessService = ["BPA.NC_OC_APP_FEE", "BPA.NC_OC_SAN_FEE"];
    if (bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("UD") || bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("TCP")) appBusinessService = ["BPA.FORM_12_FEE", "BPA.FORM_12_FEE_UD"];
    const splittedFeeData = BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail = BPA.additionalDetails) === null || _BPA$additionalDetail === void 0 ? void 0 : (_BPA$additionalDetail2 = _BPA$additionalDetail.taxHeadEstimates) === null || _BPA$additionalDetail2 === void 0 ? void 0 : _BPA$additionalDetail2.map(item => {
      return Object.fromEntries(Object.entries(item).filter(([key, value]) => typeof value === "number"));
    });
    for (let _i = 0; _i < ((_appBusinessService = appBusinessService) === null || _appBusinessService === void 0 ? void 0 : _appBusinessService.length); _i++) {
      var _appBusinessService, _collectionres$Paymen, _collectionres$Paymen3;
      let collectionres = await Digit.PaymentService.recieptSearch(BPA === null || BPA === void 0 ? void 0 : BPA.tenantId, appBusinessService[_i], {
        consumerCodes: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
        isEmployee: true
      });
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen = collectionres.Payments) === null || _collectionres$Paymen === void 0 ? void 0 : _collectionres$Paymen.length) > 0) {
        var _collectionres$Paymen2;
        collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen2 = collectionres.Payments) === null || _collectionres$Paymen2 === void 0 ? void 0 : _collectionres$Paymen2.map(res => {
          var _res$paymentDetails;
          res === null || res === void 0 ? void 0 : (_res$paymentDetails = res.paymentDetails) === null || _res$paymentDetails === void 0 ? void 0 : _res$paymentDetails.map(resData => {
            if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[_i]) {
              collectionBillRes.push(res);
            }
          });
        });
      }
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen3 = collectionres.Payments) === null || _collectionres$Paymen3 === void 0 ? void 0 : _collectionres$Paymen3.length) > 0) collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
    }
    if ((collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.length) > 0) {
      collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.map(ob => {
        var _ob$paymentDetails, _ob$paymentDetails$, _ob$paymentDetails$$b, _ob$paymentDetails$$b2, _ob$paymentDetails$$b3;
        ob === null || ob === void 0 ? void 0 : (_ob$paymentDetails = ob.paymentDetails) === null || _ob$paymentDetails === void 0 ? void 0 : (_ob$paymentDetails$ = _ob$paymentDetails[0]) === null || _ob$paymentDetails$ === void 0 ? void 0 : (_ob$paymentDetails$$b = _ob$paymentDetails$.bill) === null || _ob$paymentDetails$$b === void 0 ? void 0 : (_ob$paymentDetails$$b2 = _ob$paymentDetails$$b.billDetails) === null || _ob$paymentDetails$$b2 === void 0 ? void 0 : (_ob$paymentDetails$$b3 = _ob$paymentDetails$$b2[0]) === null || _ob$paymentDetails$$b3 === void 0 ? void 0 : _ob$paymentDetails$$b3.billAccountDetails.map((bill, index) => {
          collectionBillArray.push({
            title: `${bill === null || bill === void 0 ? void 0 : bill.taxHeadCode}_DETAILS`,
            value: "",
            isSubTitle: true
          }, {
            title: bill === null || bill === void 0 ? void 0 : bill.taxHeadCode,
            value: `₹${bill === null || bill === void 0 ? void 0 : bill.amount}`
          }, {
            title: "BPA_STATUS_LABEL",
            value: "Paid"
          });
          totalAmount = totalAmount + parseInt(bill === null || bill === void 0 ? void 0 : bill.amount);
        });
      });
    } else {
      var _splittedFeeData$;
      for (const key in splittedFeeData === null || splittedFeeData === void 0 ? void 0 : splittedFeeData[0]) {
        if (key === "estimateAmount") continue;
        collectionBillArray.push({
          title: `BPA_COMMON_${key.toUpperCase()}_FEE`,
          value: `₹${splittedFeeData[0][key]}`
        });
      }
      collectionBillArray.push({
        title: "BPA_COMMON_TOTAL_FEE",
        value: `₹${splittedFeeData === null || splittedFeeData === void 0 ? void 0 : (_splittedFeeData$ = splittedFeeData[0]) === null || _splittedFeeData$ === void 0 ? void 0 : _splittedFeeData$.estimateAmount}`
      });
      collectionBillArray.push({
        title: "BPA_STATUS_LABEL",
        value: "Unpaid"
      });
    }
    totalAmount > 0 && collectionBillArray.push({
      title: "BPA_TOT_AMT_PAID",
      value: `₹${totalAmount}`
    });
    const billDetails = {
      title: "BPA_FEE_DETAILS_LABEL",
      isFeeDetails: true,
      additionalDetails: {
        inspectionReport: [],
        values: [...collectionBillArray]
      }
    };
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail3 = BPA.additionalDetails) === null || _BPA$additionalDetail3 === void 0 ? void 0 : (_BPA$additionalDetail4 = _BPA$additionalDetail3.fieldinspection_pending) === null || _BPA$additionalDetail4 === void 0 ? void 0 : _BPA$additionalDetail4.forEach(fiData => {
      var _fiData$docs;
      fiData === null || fiData === void 0 ? void 0 : (_fiData$docs = fiData.docs) === null || _fiData$docs === void 0 ? void 0 : _fiData$docs.forEach(fiDoc => {
        var _fileDetails$data$fiD;
        if (fileDetails !== null && fileDetails !== void 0 && fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) fiDoc.url = fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data$fiD = fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) === null || _fileDetails$data$fiD === void 0 ? void 0 : _fileDetails$data$fiD.split(",")[0];
      });
    });
    function ConvertEpochToValidityDate(dateEpoch) {
      if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
        return "NA";
      }
      const dateFromApi = new Date(dateEpoch);
      let month = dateFromApi.getMonth() + 1;
      let day = dateFromApi.getDate();
      let year = dateFromApi.getFullYear() - 3;
      month = (month > 9 ? "" : "0") + month;
      day = (day > 9 ? "" : "0") + day;
      return `${day}/${month}/${year}`;
    }
    const nocDetails = noc === null || noc === void 0 ? void 0 : noc.map((nocDetails, index) => {
      var _nocDetails$additiona, _nocDetails$additiona2, _nocDetails$additiona3, _nocDetails$auditDeta, _nocDetails$documents2;
      return {
        title: index === 0 ? "BPA_NOC_DETAILS_SUMMARY" : "",
        values: [{
          title: `BPA_${nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocType}_LABEL`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationNo,
          isNotTranslated: true
        }, {
          title: `BPA_NOC_STATUS`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus,
          field: "STATUS"
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona = nocDetails.additionalDetails) === null || _nocDetails$additiona === void 0 ? void 0 : _nocDetails$additiona.SubmittedOn) && {
          title: "BPA_SUDMITTED_ON_LABEL",
          value: nocDetails !== null && nocDetails !== void 0 && (_nocDetails$additiona2 = nocDetails.additionalDetails) !== null && _nocDetails$additiona2 !== void 0 && _nocDetails$additiona2.SubmittedOn ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona3 = nocDetails.additionalDetails) === null || _nocDetails$additiona3 === void 0 ? void 0 : _nocDetails$additiona3.SubmittedOn)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVAL_NUMBER_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) || "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVED_REJECTED_ON_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "REJECTED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_REJECTED" ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$auditDeta = nocDetails.auditDetails) === null || _nocDetails$auditDeta === void 0 ? void 0 : _nocDetails$auditDeta.lastModifiedTime)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }],
        additionalDetails: {
          data: nocDetails,
          noc: [{
            title: "BPA_DOCUMENT_DETAILS_LABEL",
            values: nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents2 = nocDetails.documents) === null || _nocDetails$documents2 === void 0 ? void 0 : _nocDetails$documents2.map(doc => {
              var _doc$documentType2, _fileDetails$data, _fileDetails$data2, _fileDetails$data2$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data = fileDetails.data) !== null && _fileDetails$data !== void 0 && _fileDetails$data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data2 = fileDetails.data) === null || _fileDetails$data2 === void 0 ? void 0 : (_fileDetails$data2$do = _fileDetails$data2[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data2$do === void 0 ? void 0 : _fileDetails$data2$do.split(",")[0] : ""
              };
            })
          }]
        }
      };
    });
    let inspectionReport = [];
    let checklist = [];
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail5 = BPA.additionalDetails) === null || _BPA$additionalDetail5 === void 0 ? void 0 : (_BPA$additionalDetail6 = _BPA$additionalDetail5.fieldinspection_pending) === null || _BPA$additionalDetail6 === void 0 ? void 0 : _BPA$additionalDetail6.filter(ob => ob.docs && ob.docs.length > 0).map((ob, ind) => {
      var _ob$date, _ob$date2, _ob$date3, _ob$questions, _ob$docs;
      checklist = [];
      inspectionReport.push({
        title: "BPA_FI_REPORT",
        asSectionHeader: true,
        values: [{
          title: "BPA_FI_DATE_LABEL",
          value: ob.date.includes("-") ? `${(_ob$date = ob.date) === null || _ob$date === void 0 ? void 0 : _ob$date.split("-")[2]}/${(_ob$date2 = ob.date) === null || _ob$date2 === void 0 ? void 0 : _ob$date2.split("-")[1]}/${(_ob$date3 = ob.date) === null || _ob$date3 === void 0 ? void 0 : _ob$date3.split("-")[0]}` : ob.date
        }, {
          title: "BPA_FI_TIME_LABEL",
          value: ob.time
        }]
      });
      ob === null || ob === void 0 ? void 0 : (_ob$questions = ob.questions) === null || _ob$questions === void 0 ? void 0 : _ob$questions.map((q, index) => {
        checklist.push({
          title: q.question,
          value: q.value
        });
        checklist.push({
          title: "BPA_ENTER_REMARKS",
          value: q.remarks
        });
      });
      inspectionReport.push({
        title: "BPA_CHECK_LIST_DETAILS",
        asSectionHeader: true,
        values: checklist
      });
      inspectionReport.push({
        title: "BPA_DOCUMENT_DETAILS_LABEL",
        asSectionHeader: true,
        additionalDetails: {
          obpsDocuments: [{
            title: "",
            values: ob === null || ob === void 0 ? void 0 : (_ob$docs = ob.docs) === null || _ob$docs === void 0 ? void 0 : _ob$docs.map(doc => {
              var _doc$documentType3, _fileDetails$data3, _fileDetails$data4, _fileDetails$data4$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.fileStore,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data3 = fileDetails.data) !== null && _fileDetails$data3 !== void 0 && _fileDetails$data3[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data4 = fileDetails.data) === null || _fileDetails$data4 === void 0 ? void 0 : (_fileDetails$data4$do = _fileDetails$data4[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data4$do === void 0 ? void 0 : _fileDetails$data4$do.split(",")[0] : ""
              };
            })
          }]
        }
      });
    });
    let details = [];
    let applicationDetailsInfo = {
      title: " ",
      isCommon: true,
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo) || "NA"
      }]
    };
    let envCitizenName = window.location.href.includes("/employee") ? "employee" : "citizen";
    if (BPA !== null && BPA !== void 0 && BPA.businessService.includes("BPA_OC")) {
      var _response$BPA6, _response$BPA6$, _response$BPA7, _response$BPA7$, _response$BPA8, _response$BPA8$, _response$BPA8$$addit, _response$BPA9, _response$BPA9$, _response$BPA9$$addit, _response$BPA10, _response$BPA10$, _response$BPA10$$addi;
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_APP_NUMBER",
        to: `/digit-ui/${envCitizenName}/obps/bpa/${response === null || response === void 0 ? void 0 : (_response$BPA6 = response.BPA) === null || _response$BPA6 === void 0 ? void 0 : (_response$BPA6$ = _response$BPA6[0]) === null || _response$BPA6$ === void 0 ? void 0 : _response$BPA6$.applicationNo}`,
        value: response === null || response === void 0 ? void 0 : (_response$BPA7 = response.BPA) === null || _response$BPA7 === void 0 ? void 0 : (_response$BPA7$ = _response$BPA7[0]) === null || _response$BPA7$ === void 0 ? void 0 : _response$BPA7$.approvalNo,
        isLink: true
      }];
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_VALIDITY",
        value: response !== null && response !== void 0 && (_response$BPA8 = response.BPA) !== null && _response$BPA8 !== void 0 && (_response$BPA8$ = _response$BPA8[0]) !== null && _response$BPA8$ !== void 0 && (_response$BPA8$$addit = _response$BPA8$.additionalDetails) !== null && _response$BPA8$$addit !== void 0 && _response$BPA8$$addit.validityDate ? `${ConvertEpochToValidityDate(response === null || response === void 0 ? void 0 : (_response$BPA9 = response.BPA) === null || _response$BPA9 === void 0 ? void 0 : (_response$BPA9$ = _response$BPA9[0]) === null || _response$BPA9$ === void 0 ? void 0 : (_response$BPA9$$addit = _response$BPA9$.additionalDetails) === null || _response$BPA9$$addit === void 0 ? void 0 : _response$BPA9$$addit.validityDate)} - ${format(new Date(response === null || response === void 0 ? void 0 : (_response$BPA10 = response.BPA) === null || _response$BPA10 === void 0 ? void 0 : (_response$BPA10$ = _response$BPA10[0]) === null || _response$BPA10$ === void 0 ? void 0 : (_response$BPA10$$addi = _response$BPA10$.additionalDetails) === null || _response$BPA10$$addi === void 0 ? void 0 : _response$BPA10$$addi.validityDate), "dd/MM/yyyy")}` : "NA"
      }];
    }
    let permitcondn = [];
    (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail7 = BPA.additionalDetails) === null || _BPA$additionalDetail7 === void 0 ? void 0 : _BPA$additionalDetail7.pendingapproval) && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail8 = BPA.additionalDetails) === null || _BPA$additionalDetail8 === void 0 ? void 0 : _BPA$additionalDetail8.pendingapproval.length) > 0 && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail9 = BPA.additionalDetails) === null || _BPA$additionalDetail9 === void 0 ? void 0 : _BPA$additionalDetail9.pendingapproval.map((ob, index) => {
      permitcondn.push({
        title: `${index + 1}. ${ob}`,
        value: ""
      });
    }));
    let PermitConditions = {
      title: "BPA_PERMIT_CONDITIONS",
      isTitleVisible: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      isNotAllowed: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      additionalDetails: {
        inspectionReport: [],
        permit: [...permitcondn]
      }
    };
    if (permitcondn.length == 0) PermitConditions = {};
    if (BPA !== null && BPA !== void 0 && BPA.approvalNo) {
      var _applicationDetailsIn, _applicationDetailsIn2, _BPA$additionalDetail10, _BPA$additionalDetail11, _BPA$additionalDetail12;
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn = applicationDetailsInfo.values) === null || _applicationDetailsIn === void 0 ? void 0 : _applicationDetailsIn.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_NUMBER_LABEL" : "BPA_OC_PERMIT_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.approvalNo) || "NA"
      });
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn2 = applicationDetailsInfo.values) === null || _applicationDetailsIn2 === void 0 ? void 0 : _applicationDetailsIn2.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_VALIDITY" : "BPA_OC_PERMIT_VALIDITY",
        value: BPA !== null && BPA !== void 0 && (_BPA$additionalDetail10 = BPA.additionalDetails) !== null && _BPA$additionalDetail10 !== void 0 && _BPA$additionalDetail10.validityDate ? `${ConvertEpochToValidityDate(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail11 = BPA.additionalDetails) === null || _BPA$additionalDetail11 === void 0 ? void 0 : _BPA$additionalDetail11.validityDate)} - ${format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail12 = BPA.additionalDetails) === null || _BPA$additionalDetail12 === void 0 ? void 0 : _BPA$additionalDetail12.validityDate), "dd/MM/yyyy")}` : "NA"
      });
    }
    const basicDetails = {
      title: "BPA_BASIC_DETAILS_TITLE",
      asSectionHeader: true,
      isInsert: true,
      isCommon: true,
      values: [{
        title: "BPA_BASIC_DETAILS_APP_DATE_LABEL",
        value: BPA !== null && BPA !== void 0 && (_BPA$auditDetails = BPA.auditDetails) !== null && _BPA$auditDetails !== void 0 && _BPA$auditDetails.createdTime ? format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$auditDetails2 = BPA.auditDetails) === null || _BPA$auditDetails2 === void 0 ? void 0 : _BPA$auditDetails2.createdTime), "dd/MM/yyyy") : ""
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL",
        value: `WF_BPA_${edcr === null || edcr === void 0 ? void 0 : (_edcr$ = edcr[0]) === null || _edcr$ === void 0 ? void 0 : _edcr$.appliactionType}`
      }, {
        title: "BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$2 = edcr[0]) === null || _edcr$2 === void 0 ? void 0 : _edcr$2.applicationSubType
      }, {
        title: "BPA_BASIC_DETAILS_OCCUPANCY_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$3 = edcr[0]) === null || _edcr$3 === void 0 ? void 0 : (_edcr$3$planDetail = _edcr$3.planDetail) === null || _edcr$3$planDetail === void 0 ? void 0 : (_edcr$3$planDetail$pl = _edcr$3$planDetail.planInformation) === null || _edcr$3$planDetail$pl === void 0 ? void 0 : _edcr$3$planDetail$pl.occupancy
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$4 = edcr[0]) === null || _edcr$4 === void 0 ? void 0 : (_edcr$4$planDetail = _edcr$4.planDetail) === null || _edcr$4$planDetail === void 0 ? void 0 : (_edcr$4$planDetail$pl = _edcr$4$planDetail.planInformation) === null || _edcr$4$planDetail$pl === void 0 ? void 0 : _edcr$4$planDetail$pl.applicantName
      }]
    };
    const plotDetails = {
      title: "BPA_PLOT_DETAILS_TITLE",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_BOUNDARY_PLOT_AREA_LABEL",
        value: `${edcr === null || edcr === void 0 ? void 0 : (_edcr$5 = edcr[0]) === null || _edcr$5 === void 0 ? void 0 : (_edcr$5$planDetail = _edcr$5.planDetail) === null || _edcr$5$planDetail === void 0 ? void 0 : (_edcr$5$planDetail$pl = _edcr$5$planDetail.planInformation) === null || _edcr$5$planDetail$pl === void 0 ? void 0 : _edcr$5$planDetail$pl.plotArea}`,
        isNotTranslated: true,
        isUnit: "BPA_SQ_MT_LABEL"
      }, {
        title: "BPA_PLOT_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$6 = edcr[0]) === null || _edcr$6 === void 0 ? void 0 : (_edcr$6$planDetail = _edcr$6.planDetail) === null || _edcr$6$planDetail === void 0 ? void 0 : (_edcr$6$planDetail$pl = _edcr$6$planDetail.planInformation) === null || _edcr$6$planDetail$pl === void 0 ? void 0 : _edcr$6$planDetail$pl.plotNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_KHATHA_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$7 = edcr[0]) === null || _edcr$7 === void 0 ? void 0 : (_edcr$7$planDetail = _edcr$7.planDetail) === null || _edcr$7$planDetail === void 0 ? void 0 : (_edcr$7$planDetail$pl = _edcr$7$planDetail.planInformation) === null || _edcr$7$planDetail$pl === void 0 ? void 0 : _edcr$7$planDetail$pl.khataNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_HOLDING_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail13 = BPA.additionalDetails) === null || _BPA$additionalDetail13 === void 0 ? void 0 : _BPA$additionalDetail13.holdingNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_BOUNDARY_LAND_REG_DETAIL_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail14 = BPA.additionalDetails) === null || _BPA$additionalDetail14 === void 0 ? void 0 : _BPA$additionalDetail14.registrationDetails) || "NA",
        isNotTranslated: true
      }]
    };
    const scrutinyDetails = {
      title: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_EDCR_DETAILS",
          value: " ",
          isHeader: true
        }, {
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_EDCR_NO_LABEL" : "BPA_OC_EDCR_NO_LABEL",
          value: (BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber) || "NA"
        }],
        scruntinyDetails: [{
          title: "BPA_UPLOADED_PLAN_DIAGRAM",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$8 = edcr[0]) === null || _edcr$8 === void 0 ? void 0 : _edcr$8.updatedDxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }, {
          title: "BPA_SCRUNTINY_REPORT_OUTPUT",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$9 = edcr[0]) === null || _edcr$9 === void 0 ? void 0 : _edcr$9.planReport,
          text: "BPA_SCRUTINY_REPORT_PDF"
        }, {
          title: "BPA_UPLOADED_PLAN_DXF",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$10 = edcr[0]) === null || _edcr$10 === void 0 ? void 0 : _edcr$10.dxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }]
      }
    };
    const buildingExtractionDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_BUILDING_EXTRACT_HEADER" : "BPA_ACTUAL_BUILDING_EXTRACT_HEADER",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_TOTAL_BUILT_UP_AREA_HEADER",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$11 = edcr[0]) === null || _edcr$11 === void 0 ? void 0 : (_edcr$11$planDetail = _edcr$11.planDetail) === null || _edcr$11$planDetail === void 0 ? void 0 : (_edcr$11$planDetail$b = _edcr$11$planDetail.blocks) === null || _edcr$11$planDetail$b === void 0 ? void 0 : (_edcr$11$planDetail$b2 = _edcr$11$planDetail$b[0]) === null || _edcr$11$planDetail$b2 === void 0 ? void 0 : (_edcr$11$planDetail$b3 = _edcr$11$planDetail$b2.building) === null || _edcr$11$planDetail$b3 === void 0 ? void 0 : _edcr$11$planDetail$b3.totalBuitUpArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }, {
          title: "BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL",
          value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$12 = edcr[0]) === null || _edcr$12 === void 0 ? void 0 : (_edcr$12$planDetail = _edcr$12.planDetail) === null || _edcr$12$planDetail === void 0 ? void 0 : (_edcr$12$planDetail$b = _edcr$12$planDetail.blocks) === null || _edcr$12$planDetail$b === void 0 ? void 0 : (_edcr$12$planDetail$b2 = _edcr$12$planDetail$b[0]) === null || _edcr$12$planDetail$b2 === void 0 ? void 0 : (_edcr$12$planDetail$b3 = _edcr$12$planDetail$b2.building) === null || _edcr$12$planDetail$b3 === void 0 ? void 0 : _edcr$12$planDetail$b3.totalFloors) || "NA"
        }, {
          title: "BPA_HEIGHT_FROM_GROUND_LEVEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$13 = edcr[0]) === null || _edcr$13 === void 0 ? void 0 : (_edcr$13$planDetail = _edcr$13.planDetail) === null || _edcr$13$planDetail === void 0 ? void 0 : (_edcr$13$planDetail$b = _edcr$13$planDetail.blocks) === null || _edcr$13$planDetail$b === void 0 ? void 0 : (_edcr$13$planDetail$b2 = _edcr$13$planDetail$b[0]) === null || _edcr$13$planDetail$b2 === void 0 ? void 0 : (_edcr$13$planDetail$b3 = _edcr$13$planDetail$b2.building) === null || _edcr$13$planDetail$b3 === void 0 ? void 0 : _edcr$13$planDetail$b3.declaredBuildingHeigh,
          isUnit: "BPA_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const demolitionAreaDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$14 = edcr[0]) === null || _edcr$14 === void 0 ? void 0 : (_edcr$14$planDetail = _edcr$14.planDetail) === null || _edcr$14$planDetail === void 0 ? void 0 : (_edcr$14$planDetail$p = _edcr$14$planDetail.planInformation) === null || _edcr$14$planDetail$p === void 0 ? void 0 : _edcr$14$planDetail$p.demolitionArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const subOccupancyTableDetails = {
      title: "",
      isSubOccupancyTable: true,
      isTitleRepeat: true,
      additionalDetails: {
        values: [{
          title: "BPA_OCC_SUBOCC_HEADER",
          value: " ",
          isHeader: true
        }],
        subOccupancyTableDetails: [{
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr
        }, {
          title: "NO_REPEAT",
          value: ""
        }]
      }
    };
    const addressDetails = {
      title: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_CITY_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo = BPA.landInfo) === null || _BPA$landInfo === void 0 ? void 0 : (_BPA$landInfo$address = _BPA$landInfo.address) === null || _BPA$landInfo$address === void 0 ? void 0 : _BPA$landInfo$address.city
      }, {
        title: !isUD ? "BPA_LOC_NOTIFIED-AREA_LABEL" : "BPA_ULB-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail15 = BPA.additionalDetails) === null || _BPA$additionalDetail15 === void 0 ? void 0 : (_BPA$additionalDetail16 = _BPA$additionalDetail15.landInfo) === null || _BPA$additionalDetail16 === void 0 ? void 0 : (_BPA$additionalDetail17 = _BPA$additionalDetail16.address) === null || _BPA$additionalDetail17 === void 0 ? void 0 : _BPA$additionalDetail17.doorNo
      }, {
        title: !isUD ? "BPA_LOC_VILLAGE-AREA_LABEL" : "BPA_LOC_WARD-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail18 = BPA.additionalDetails) === null || _BPA$additionalDetail18 === void 0 ? void 0 : (_BPA$additionalDetail19 = _BPA$additionalDetail18.landInfo) === null || _BPA$additionalDetail19 === void 0 ? void 0 : (_BPA$additionalDetail20 = _BPA$additionalDetail19.address) === null || _BPA$additionalDetail20 === void 0 ? void 0 : _BPA$additionalDetail20.village
      }]
    };
    const checkOwnerLength = (BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo2 = BPA.landInfo) === null || _BPA$landInfo2 === void 0 ? void 0 : (_BPA$landInfo2$owners = _BPA$landInfo2.owners) === null || _BPA$landInfo2$owners === void 0 ? void 0 : _BPA$landInfo2$owners.length) || 1;
    if ((BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo3 = BPA.landInfo) === null || _BPA$landInfo3 === void 0 ? void 0 : (_BPA$landInfo3$owners = _BPA$landInfo3.owners) === null || _BPA$landInfo3$owners === void 0 ? void 0 : _BPA$landInfo3$owners.length) > 0) {
      var _BPA$landInfo4, _BPA$landInfo4$owners;
      BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo4 = BPA.landInfo) === null || _BPA$landInfo4 === void 0 ? void 0 : (_BPA$landInfo4$owners = _BPA$landInfo4.owners) === null || _BPA$landInfo4$owners === void 0 ? void 0 : _BPA$landInfo4$owners.forEach(ownerD => {
        if (!ownerD.isPrimaryOwner) ownerD.isPrimaryOwner = "false";
      });
    }
    const ownerDetails = {
      title: "BPA_APPLICANT_DETAILS_HEADER",
      isOwnerDetails: true,
      additionalDetails: {
        owners: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail21 = BPA.additionalDetails) === null || _BPA$additionalDetail21 === void 0 ? void 0 : (_BPA$additionalDetail22 = _BPA$additionalDetail21.landInfo) === null || _BPA$additionalDetail22 === void 0 ? void 0 : (_BPA$additionalDetail23 = _BPA$additionalDetail22.owners) === null || _BPA$additionalDetail23 === void 0 ? void 0 : _BPA$additionalDetail23.map((owner, index) => {
          var _owner$permanentAddre, _owner$permanentAddre2, _owner$permanentAddre3, _owner$permanentAddre4, _owner$permanentAddre5, _owner$permanentAddre6, _owner$correspondence, _owner$correspondence2, _owner$correspondence3, _owner$correspondence4, _owner$correspondence5, _owner$correspondence6;
          return {
            title: Number(checkOwnerLength) > 1 ? "COMMON_OWNER" : "",
            values: [{
              title: "CORE_COMMON_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.name
            }, {
              title: "BPA_APPLICANT_GENDER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.gender
            }, {
              title: "CORE_COMMON_MOBILE_NUMBER",
              value: owner === null || owner === void 0 ? void 0 : owner.mobileNumber
            }, {
              title: "BPA_APPLICANT_EMAIL_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.emailId
            }, {
              title: "CORE_COMMON_GUARDIAN_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.fatherOrHusbandName
            }, {
              title: "BPA_IS_PRIMARY_OWNER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.isPrimaryOwner,
              isNotTranslated: false
            }, {
              title: "BPA_OWNER_PERMANENT_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre = owner.permanentAddress) === null || _owner$permanentAddre === void 0 ? void 0 : _owner$permanentAddre.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre2 = owner.permanentAddress) === null || _owner$permanentAddre2 === void 0 ? void 0 : _owner$permanentAddre2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre3 = owner.permanentAddress) === null || _owner$permanentAddre3 === void 0 ? void 0 : _owner$permanentAddre3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre4 = owner.permanentAddress) === null || _owner$permanentAddre4 === void 0 ? void 0 : _owner$permanentAddre4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre5 = owner.permanentAddress) === null || _owner$permanentAddre5 === void 0 ? void 0 : _owner$permanentAddre5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre6 = owner.permanentAddress) === null || _owner$permanentAddre6 === void 0 ? void 0 : _owner$permanentAddre6.pinno
            }, {
              title: "BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence2 = owner.correspondenceAddress) === null || _owner$correspondence2 === void 0 ? void 0 : _owner$correspondence2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence3 = owner.correspondenceAddress) === null || _owner$correspondence3 === void 0 ? void 0 : _owner$correspondence3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence4 = owner.correspondenceAddress) === null || _owner$correspondence4 === void 0 ? void 0 : _owner$correspondence4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence5 = owner.correspondenceAddress) === null || _owner$correspondence5 === void 0 ? void 0 : _owner$correspondence5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence6 = owner.correspondenceAddress) === null || _owner$correspondence6 === void 0 ? void 0 : _owner$correspondence6.pinno
            }]
          };
        })
      }
    };
    const professionalDetails = {
      title: "BPA_PROFESSIONAL_DETAILS_HEADER",
      asSectionHeader: true,
      isprofessionalDetail: true,
      values: [BPA === null || BPA === void 0 ? void 0 : BPA.professionaldetails]
    };
    const documentDetails = {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      isDocumentDetails: true,
      additionalDetails: {
        obpsDocuments: [{
          title: "",
          values: BPA === null || BPA === void 0 ? void 0 : (_BPA$documents = BPA.documents) === null || _BPA$documents === void 0 ? void 0 : _BPA$documents.map(doc => {
            var _doc$documentType4, _fileDetails$data5, _fileDetails$data6, _fileDetails$data6$do;
            return {
              title: doc === null || doc === void 0 ? void 0 : (_doc$documentType4 = doc.documentType) === null || _doc$documentType4 === void 0 ? void 0 : _doc$documentType4.replaceAll(".", "_"),
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data5 = fileDetails.data) !== null && _fileDetails$data5 !== void 0 && _fileDetails$data5[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data6 = fileDetails.data) === null || _fileDetails$data6 === void 0 ? void 0 : (_fileDetails$data6$do = _fileDetails$data6[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data6$do === void 0 ? void 0 : _fileDetails$data6$do.split(",")[0] : ""
            };
          })
        }]
      }
    };
    let approvalChecks = [];
    let approvalChecksDetails = {};
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.status) === "APPROVAL_INPROGRESS") {
      approvalChecksDetails = {
        title: "",
        isTitleVisible: (approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.length) > 0 ? false : true,
        asSectionHeader: true,
        isPermissions: true,
        additionalDetails: {
          permissions: approvalChecks
        }
      };
    }
    let val;
    var i;
    inspectionReport && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail24 = BPA.additionalDetails) === null || _BPA$additionalDetail24 === void 0 ? void 0 : (_BPA$additionalDetail25 = _BPA$additionalDetail24.fieldinspection_pending) === null || _BPA$additionalDetail25 === void 0 ? void 0 : (_BPA$additionalDetail26 = _BPA$additionalDetail25[0]) === null || _BPA$additionalDetail26 === void 0 ? void 0 : _BPA$additionalDetail26.questions.length) > 0 && inspectionReport.map((ob, index) => {
      if (ob.title.includes("FI_REPORT")) ;else if (ob.title.includes("CHECK_LIST")) ;else {
        var _ob$additionalDetails, _ob$additionalDetails2;
        let improvedDoc = [...((_ob$additionalDetails = ob.additionalDetails.obpsDocuments) === null || _ob$additionalDetails === void 0 ? void 0 : (_ob$additionalDetails2 = _ob$additionalDetails[0]) === null || _ob$additionalDetails2 === void 0 ? void 0 : _ob$additionalDetails2.values)];
        improvedDoc.map(ob => {
          ob["isNotDuplicate"] = true;
        });
        improvedDoc.map((ob, index) => {
          val = ob.documentType;
          if (ob.isNotDuplicate == true) for (i = index + 1; i < improvedDoc.length; i++) {
            if (val === improvedDoc[i].documentType) improvedDoc[i].isNotDuplicate = false;
          }
        });
      }
    });
    const fiReports = {
      title: "",
      isFieldInspection: true,
      isNotAllowed: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail27 = BPA.additionalDetails) === null || _BPA$additionalDetail27 === void 0 ? void 0 : (_BPA$additionalDetail28 = _BPA$additionalDetail27.fieldinspection_pending) === null || _BPA$additionalDetail28 === void 0 ? void 0 : _BPA$additionalDetail28.length) > 0 ? false : true,
      additionalDetails: {
        values: [],
        fiReport: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail29 = BPA.additionalDetails) === null || _BPA$additionalDetail29 === void 0 ? void 0 : (_BPA$additionalDetail30 = _BPA$additionalDetail29.fieldinspection_pending) === null || _BPA$additionalDetail30 === void 0 ? void 0 : _BPA$additionalDetail30.length) > 0 ? true : false
      }
    };
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC") {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, addressDetails, ownerDetails, professionalDetails, documentDetails, fiReports, ...nocDetails, approvalChecksDetails, PermitConditions];
    } else {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, documentDetails, fiReports, ...nocDetails, PermitConditions];
    }
    if (billDetails !== null && billDetails !== void 0 && (_billDetails$addition = billDetails.additionalDetails) !== null && _billDetails$addition !== void 0 && (_billDetails$addition2 = _billDetails$addition.values) !== null && _billDetails$addition2 !== void 0 && _billDetails$addition2.length) {
      details.push(billDetails);
    }
    let bpaFilterDetails = (_details = details) === null || _details === void 0 ? void 0 : _details.filter(data => data);
    return {
      applicationData: BPA,
      applicationDetails: bpaFilterDetails,
      tenantId: BPA === null || BPA === void 0 ? void 0 : BPA.tenantId,
      edcrDetails: edcr || [],
      nocData: noc,
      businessService: BPA === null || BPA === void 0 ? void 0 : BPA.businessService,
      applicationNo: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
      applicationStatus: BPA === null || BPA === void 0 ? void 0 : BPA.status,
      collectionBillDetails: collectionBillDetails
    };
  },
  BPADetailsPageForm11: async (tenantId, filters) => {
    var _response$PermissionO5;
    const response = await OBPSService.BPASearchForm11(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$PermissionO, _response$PermissionO2, _filters$formType, _businessService$join, _response$PermissionO4;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$PermissionO = response.PermissionOfSubdivision) === null || _response$PermissionO === void 0 ? void 0 : (_response$PermissionO2 = _response$PermissionO[0]) === null || _response$PermissionO2 === void 0 ? void 0 : _response$PermissionO2.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType = filters.formType) === null || _filters$formType === void 0 ? void 0 : _filters$formType.replace("form", "");
      const appBusinessService = (_businessService$join = businessService.join("")) !== null && _businessService$join !== void 0 && _businessService$join.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$PermissionO3;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen4;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen4 = collectionres.Payments) === null || _collectionres$Paymen4 === void 0 ? void 0 : _collectionres$Paymen4.length) > 0) {
            var _collectionres$Paymen5;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen5 = collectionres.Payments) === null || _collectionres$Paymen5 === void 0 ? void 0 : _collectionres$Paymen5.map(res => {
              var _res$paymentDetails2;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails2 = res.paymentDetails) === null || _res$paymentDetails2 === void 0 ? void 0 : _res$paymentDetails2.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$PermissionO3 = response.PermissionOfSubdivision) === null || _response$PermissionO3 === void 0 ? void 0 : _response$PermissionO3[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$PermissionO4 = response.PermissionOfSubdivision) === null || _response$PermissionO4 === void 0 ? void 0 : _response$PermissionO4[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$PermissionO5 = response.PermissionOfSubdivision) === null || _response$PermissionO5 === void 0 ? void 0 : _response$PermissionO5[0];
  },
  BPADetailsPageFormLandUse: async (tenantId, filters) => {
    var _response$LandUse4;
    const response = await OBPSService.BPASearchFormLandUse(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$LandUse, _response$LandUse$, _filters$formType2, _businessService$join2, _response$LandUse3;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$LandUse = response.LandUse) === null || _response$LandUse === void 0 ? void 0 : (_response$LandUse$ = _response$LandUse[0]) === null || _response$LandUse$ === void 0 ? void 0 : _response$LandUse$.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType2 = filters.formType) === null || _filters$formType2 === void 0 ? void 0 : _filters$formType2.replace("form", "");
      const appBusinessService = (_businessService$join2 = businessService.join("")) !== null && _businessService$join2 !== void 0 && _businessService$join2.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$LandUse2;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen6;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen6 = collectionres.Payments) === null || _collectionres$Paymen6 === void 0 ? void 0 : _collectionres$Paymen6.length) > 0) {
            var _collectionres$Paymen7;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen7 = collectionres.Payments) === null || _collectionres$Paymen7 === void 0 ? void 0 : _collectionres$Paymen7.map(res => {
              var _res$paymentDetails3;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails3 = res.paymentDetails) === null || _res$paymentDetails3 === void 0 ? void 0 : _res$paymentDetails3.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$LandUse2 = response.LandUse) === null || _response$LandUse2 === void 0 ? void 0 : _response$LandUse2[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$LandUse3 = response.LandUse) === null || _response$LandUse3 === void 0 ? void 0 : _response$LandUse3[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$LandUse4 = response.LandUse) === null || _response$LandUse4 === void 0 ? void 0 : _response$LandUse4[0];
  },
  Form12DetailsPage: async (tenantId, filter) => {
    var _response$BPA11;
    const response = await OBPSService.BPASearch(tenantId, filter);
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA11 = response.BPA) === null || _response$BPA11 === void 0 ? void 0 : _response$BPA11[0];
    return {
      applicationData: BPA
    };
  }
};

function DocumentsPreview({
  documents,
  svgStyles = {},
  isSendBackFlow = false,
  isHrLine = false,
  titleStyles
}) {
  const {
    t
  } = useTranslation();
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: titleStyles ? titleStyles : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _value$documentType;
      return /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: value === null || value === void 0 ? void 0 : value.url,
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto",
          minWidth: "100px"
        },
        key: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React__default.createElement(PDFSvg, null)), /*#__PURE__*/React__default.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#505A5F"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React__default.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React__default.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))), isHrLine && (documents === null || documents === void 0 ? void 0 : documents.length) != index + 1 ? /*#__PURE__*/React__default.createElement("hr", {
      style: {
        color: "#D6D5D4",
        backgroundColor: "#D6D5D4",
        height: "2px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }) : null);
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React__default.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => /*#__PURE__*/React__default.createElement("a", {
      target: "_",
      href: value === null || value === void 0 ? void 0 : value.url,
      style: {
        minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
        marginRight: "20px"
      },
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        maxWidth: "940px",
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #D6D5D4",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "8px",
        fontWeight: "bold",
        marginBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "12px",
        color: "#505A5F",
        fontWeight: 400,
        lineHeight: "15px",
        marginBottom: "10px"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React__default.createElement(PDFSvg, null), /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F",
        fontWeight: "400",
        textAlign: "center",
        color: "#505A5F"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)))) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

const BPADocuments = ({
  t,
  formData,
  applicationData,
  docs,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da, _formData$documents;
  const applicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.documents) || []);
  const [error, setError] = useState(null);
  const [bpaTaxDocuments, setBpaTaxDocuments] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  useEffect(() => {
    var _bpaDocs$BPA, _filtredBpaDocs, _filtredBpaDocs$, _filtredBpaDocs$$docT;
    let filtredBpaDocs = [];
    if (bpaDocs !== null && bpaDocs !== void 0 && (_bpaDocs$BPA = bpaDocs.BPA) !== null && _bpaDocs$BPA !== void 0 && _bpaDocs$BPA.DocTypeMapping) {
      var _bpaDocs$BPA2, _bpaDocs$BPA2$DocType;
      filtredBpaDocs = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA2 = bpaDocs.BPA) === null || _bpaDocs$BPA2 === void 0 ? void 0 : (_bpaDocs$BPA2$DocType = _bpaDocs$BPA2.DocTypeMapping) === null || _bpaDocs$BPA2$DocType === void 0 ? void 0 : _bpaDocs$BPA2$DocType.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) ? applicationData === null || applicationData === void 0 ? void 0 : applicationData.status :  data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    let documentsList = [];
    (_filtredBpaDocs = filtredBpaDocs) === null || _filtredBpaDocs === void 0 ? void 0 : (_filtredBpaDocs$ = _filtredBpaDocs[0]) === null || _filtredBpaDocs$ === void 0 ? void 0 : (_filtredBpaDocs$$docT = _filtredBpaDocs$.docTypes) === null || _filtredBpaDocs$$docT === void 0 ? void 0 : _filtredBpaDocs$$docT.forEach(doc => {
      var _commonDocs$commonMa, _commonDocs$commonMa$, _docs$, _docs$$values;
      let code = doc.code;
      doc.dropdownData = [];
      doc.uploadedDocuments = [];
      commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : (_commonDocs$commonMa$ = _commonDocs$commonMa.DocumentType) === null || _commonDocs$commonMa$ === void 0 ? void 0 : _commonDocs$commonMa$.forEach(value => {
        let values = value.code.slice(0, code.length);
        if (code === values) {
          doc.hasDropdown = true;
          value.i18nKey = value.code;
          doc.dropdownData.push(value);
        }
      });
      doc.uploadedDocuments[0] = {};
      doc.uploadedDocuments[0].values = [];
      docs === null || docs === void 0 ? void 0 : (_docs$ = docs[0]) === null || _docs$ === void 0 ? void 0 : (_docs$$values = _docs$.values) === null || _docs$$values === void 0 ? void 0 : _docs$$values.map(upDocs => {
        if (code === (upDocs === null || upDocs === void 0 ? void 0 : upDocs.documentType)) {
          doc.uploadedDocuments[0].values.push(upDocs);
        }
      });
      documentsList.push(doc);
    });
    sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(documentsList));
    setBpaTaxDocuments(documentsList);
  }, [!bpaDocsLoading, !commonDocsLoading]);
  useEffect(() => {
    let count = 0;
    bpaTaxDocuments.map(doc => {
      let isRequired = false;
      documents.map(data => {
        if (doc.required && doc.code == `${data.documentType.split('.')[0]}.${data.documentType.split('.')[1]}`) {
          isRequired = true;
        }
      });
      if (!isRequired && doc.required) {
        count = count + 1;
      }
    });
    if ((count == "0" || count == 0) && documents.length > 0) setEnableSubmit(false);else setEnableSubmit(true);
  }, [documents, checkRequiredFields]);
  useEffect(() => {
    if (applicationStatus === "DOC_VERIFICATION_INPROGRESS" && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React__default.createElement("div", null, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SelectDocument, {
      key: index,
      index: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      applicationStatus: applicationStatus,
      actions: actions,
      bpaTaxDocuments: bpaTaxDocuments,
      checkEnablingDocs: checkEnablingDocs
    }));
  }));
};
function SelectDocument({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  index,
  applicationStatus,
  actions,
  bpaTaxDocuments,
  checkEnablingDocs
}) {
  var _doc$dropdownData, _doc$uploadedDocument;
  const filteredDocument = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) === 1 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const [selectArrayFiles, SetSelectArrayFiles] = useState([]);
  const handleSelectDocument = value => setSelectedDocument(value);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfiles(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.documentType) !== (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code));
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) return filteredDocumentsByDocumentType;
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    (async () => {
      if (selectArrayFiles.length > 0) {
        sessionStorage.removeItem("BPA_DOCUMENTS");
        doc.newUploadedDocs = [];
        selectArrayFiles.map(newDoc => {
          if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
            var _newDoc$fileStoreId, _newDoc$fileStoreId2, _newDoc$fileStoreId3;
            doc.newUploadedDocs.push({
              documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
              fileStoreId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId = newDoc.fileStoreId) === null || _newDoc$fileStoreId === void 0 ? void 0 : _newDoc$fileStoreId.fileStoreId,
              documentUid: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId2 = newDoc.fileStoreId) === null || _newDoc$fileStoreId2 === void 0 ? void 0 : _newDoc$fileStoreId2.fileStoreId,
              tenantId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId3 = newDoc.fileStoreId) === null || _newDoc$fileStoreId3 === void 0 ? void 0 : _newDoc$fileStoreId3.tenantId
            });
          }
        });
        bpaTaxDocuments[index] = doc;
        sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(bpaTaxDocuments));
      }
    })();
  }, [selectArrayFiles, selectedDocument]);
  useEffect(() => {
  }, [file]);
  const getData = (index, state) => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    if (Object.keys(data).length !== 0) SetSelectArrayFiles(newArr);
    selectfiles(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "24px",
      maxWidth: "950px",
      minWidth: "280px",
      background: "#FAFAFA",
      borderRadius: "4px",
      border: "1px solid #D6D5D4",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      marginBottom: "8px",
      paddingBottom: "9px",
      color: "#0B0C0C",
      fontSize: "16px",
      lineHeight: "19px"
    }
  }, `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments,
    svgStyles: {
      width: "100px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "100px"
    }
  }), checkEnablingDocs ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "20px"
    }
  }, "]]      ", /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginTop: "-10px",
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)}* ` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    className: "form-field",
    t: t,
    isMandatory: false,
    option: doc === null || doc === void 0 ? void 0 : doc.dropdownData,
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument,
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "card-label-smaller",
    style: {
      width: "100%"
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: e => getData(index, e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  })))) : null);
}

const Reason = ({
  headComment,
  otherComment
}) => /*#__PURE__*/React__default.createElement("div", {
  className: "checkpoint-comments-wrap"
}, /*#__PURE__*/React__default.createElement("h4", null, headComment), /*#__PURE__*/React__default.createElement("p", null, otherComment));

const TLCaption = ({
  data,
  OpenImage
}) => {
  var _data$wfComment, _data$thumbnailsToSho, _data$thumbnailsToSho2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", null, data.date && /*#__PURE__*/React__default.createElement("p", null, data.date), /*#__PURE__*/React__default.createElement("p", null, data.name), data.mobileNumber && /*#__PURE__*/React__default.createElement(TelePhone, {
    mobile: data.mobileNumber
  }), data.source && /*#__PURE__*/React__default.createElement("p", null, t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())), data.comment && /*#__PURE__*/React__default.createElement(Reason, {
    otherComment: data === null || data === void 0 ? void 0 : data.otherComment,
    headComment: data === null || data === void 0 ? void 0 : data.comment
  }), data !== null && data !== void 0 && data.wfComment ? /*#__PURE__*/React__default.createElement("div", null, data === null || data === void 0 ? void 0 : (_data$wfComment = data.wfComment) === null || _data$wfComment === void 0 ? void 0 : _data$wfComment.map(e => /*#__PURE__*/React__default.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: e
  }))))) : null, (data === null || data === void 0 ? void 0 : (_data$thumbnailsToSho = data.thumbnailsToShow) === null || _data$thumbnailsToSho === void 0 ? void 0 : (_data$thumbnailsToSho2 = _data$thumbnailsToSho.thumbs) === null || _data$thumbnailsToSho2 === void 0 ? void 0 : _data$thumbnailsToSho2.length) > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, t("CS_COMMON_ATTACHMENTS")), /*#__PURE__*/React__default.createElement(DisplayPhotos, {
    srcs: data === null || data === void 0 ? void 0 : data.thumbnailsToShow.thumbs,
    onClick: (src, index) => {
      OpenImage(src, index, data === null || data === void 0 ? void 0 : data.thumbnailsToShow);
    }
  })) : null);
};

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e$1 = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k$1 = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e$1:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k$1;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment$1 = e$1;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function (a) {
  return z(a) === k$1;
};
var isContextProvider = function (a) {
  return z(a) === h;
};
var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function (a) {
  return z(a) === n;
};
var isFragment = function (a) {
  return z(a) === e$1;
};
var isLazy = function (a) {
  return z(a) === t;
};
var isMemo = function (a) {
  return z(a) === r;
};
var isPortal = function (a) {
  return z(a) === d;
};
var isProfiler = function (a) {
  return z(a) === g;
};
var isStrictMode = function (a) {
  return z(a) === f;
};
var isSuspense = function (a) {
  return z(a) === p;
};
var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k$1 || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment$1,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

const TabPanel = ({
  children,
  value,
  index,
  ...rest
}) => {
  return /*#__PURE__*/React__default.createElement(Box$1, Object.assign({
    role: "tabpanel",
    hidden: value !== index,
    id: `full-width-tabpanel-${index}`
  }, rest), value === index && /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      p: 2
    }
  }, children));
};
TabPanel.propTypes = {
  children: propTypes.node.isRequired,
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),
  index: propTypes.oneOfType([propTypes.string, propTypes.number])
};
TabPanel.defaultProps = {
  value: "0",
  index: "0"
};

const TLCaption$1 = ({
  data,
  OpenImage
}) => {
  var _data$wfComment, _data$thumbnailsToSho, _data$thumbnailsToSho2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", null, data.date && /*#__PURE__*/React__default.createElement("p", null, data.date), /*#__PURE__*/React__default.createElement("p", null, data.name), data.mobileNumber && /*#__PURE__*/React__default.createElement(TelePhone, {
    mobile: data.mobileNumber
  }), data.source && /*#__PURE__*/React__default.createElement("p", null, t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())), data.comment && /*#__PURE__*/React__default.createElement(Reason, {
    otherComment: data === null || data === void 0 ? void 0 : data.otherComment,
    headComment: data === null || data === void 0 ? void 0 : data.comment
  }), data !== null && data !== void 0 && data.wfComment ? /*#__PURE__*/React__default.createElement("div", null, data === null || data === void 0 ? void 0 : (_data$wfComment = data.wfComment) === null || _data$wfComment === void 0 ? void 0 : _data$wfComment.map(e => /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: e
  }))))) : null, (data === null || data === void 0 ? void 0 : (_data$thumbnailsToSho = data.thumbnailsToShow) === null || _data$thumbnailsToSho === void 0 ? void 0 : (_data$thumbnailsToSho2 = _data$thumbnailsToSho.thumbs) === null || _data$thumbnailsToSho2 === void 0 ? void 0 : _data$thumbnailsToSho2.length) > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, t("CS_COMMON_ATTACHMENTS")), /*#__PURE__*/React__default.createElement(PictureAsPdfIcon, {
    style: {
      color: "red"
    },
    srcs: data === null || data === void 0 ? void 0 : data.thumbnailsToShow.thumbs,
    onClick: (src, index) => {
      OpenImage(src, index, data === null || data === void 0 ? void 0 : data.thumbnailsToShow);
    }
  })) : null);
};

var jodit_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(self, function () {
    return function () {
      var e,
        t = {
          90643: function (e) {
            e.exports.default = ["إبدأ في الكتابة...", "حول جوديت", "محرر جوديت", null, "دليل مستخدم جوديت", "يحتوي على مساعدة مفصلة للاستخدام", "للحصول على معلومات حول الترخيص، يرجى الذهاب لموقعنا:", "شراء النسخة الكاملة", "حقوق الطبع والنشر © XDSoft.net - Chupurnov Valeriy. كل الحقوق محفوظة.", "مِرْساة", "فتح في نافذة جديدة", "فتح المحرر في الحجم الكامل", "مسح التنسيق", "ملء اللون أو تعيين لون النص", "إعادة", "تراجع", "عريض", "مائل", "إدراج قائمة غير مرتبة", "إدراج قائمة مرتبة", "محاذاة للوسط", "محاذاة مثبتة", "محاذاة لليسار", "محاذاة لليمين", "إدراج خط أفقي", "إدراج صورة", "ادخال الملف", "إدراج فيديو يوتيوب/فيميو ", "إدراج رابط", "حجم الخط", "نوع الخط", "إدراج كتلة تنسيق", "عادي", "عنوان 1", "عنوان 2", "عنوان 3", "عنوان 4", "إقتباس", "كود", "إدراج", "إدراج جدول", "تقليل المسافة البادئة", "زيادة المسافة البادئة", "تحديد أحرف خاصة", "إدراج حرف خاص", "تنسيق الرسم", "تغيير الوضع", "هوامش", "أعلى", "يمين", "أسفل", "يسار", "الأنماط", "الطبقات", "محاذاة", "اليمين", "الوسط", "اليسار", "--غير مضبوط--", "Src", "العنوان", "العنوان البديل", "الرابط", "افتح الرابط في نافذة جديدة", "الصورة", "ملف", "متقدم", "خصائص الصورة", "إلغاء", "حسنا", "يشبه الكود الخاص بك HTML. تبقي كما HTML؟", "الصق ك HTML", "احتفظ", "نظيفة", "إدراج كنص", "إدراج النص فقط", "كلمة لصق الكشف عن", "للصق المحتوى قادم من Microsoft Word/Excel الوثيقة. هل تريد أن تبقي شكل أو تنظيفه ؟ ", "متصفح الملفات", "حدث خطأ في تحميل القائمة ", "حدث خطأ في تحميل المجلدات", "هل أنت واثق؟", "أدخل اسم المجلد", "إنشاء مجلد", "أكتب إسم", "إسقاط صورة", "إسقاط الملف", "أو أنقر", "النص البديل", "تصفح", "رفع", "الخلفية", "نص", "أعلى", "الوسط", "الأسفل", "إدراج عمود قبل", "إدراج عمود بعد", "إدراج صف أعلى", "إدراج صف أسفل", "حذف الجدول", "حذف الصف", "حذف العمود", "خلية فارغة", "مصدر", "بالخط العريض", "مائل", "شغل", "صلة", "إلغاء", "كرر", "طاولة", "صورة", "نظيف", "فقرة", "حجم الخط", "فيديو", "الخط", "حول المحرر", "طباعة", "أكد", "شطب", "المسافة البادئة", "نتوء", "ملء الشاشة", "الحجم التقليدي", "الخط", "قائمة", "قائمة مرقمة", "قطع", "اختر الكل", "قانون", "فتح الرابط", "تعديل الرابط", "سمة Nofollow", "إزالة الرابط", "مراجعة", "لتحرير", "تحديث", "URL", "تحرير", "محاذاة أفقية", "فلتر", "عن طريق التغيير", "بالاسم", "حسب الحجم", "إضافة مجلد", "إعادة", "احتفظ", "حفظ باسم", "تغيير الحجم", "حجم القطع", "عرض", "ارتفاع", "حافظ على النسب", "أن", "لا", "حذف", "تميز", "%d حرف", "%d كلام", null, "تميز %s", "اختر الكل", "محاذاة عمودية", "انشق، مزق", "انقسام عمودي", "تقسيم أفقي", "اذهب", "أضف العمود", "اضف سطر", "حذف", "الحدود", "رخصة %s", "اضرب من خلال", "أكد", "حرف فوقي", "مخطوطة", "قطع الاختيار", "استراحة", "البحث عن", "استبدل ب", "محل", "معجون", "اختر محتوى للصق", "يمكنك فقط تحرير صورك الخاصة. تحميل هذه الصورة على المضيف؟", "تم تحميل الصورة بنجاح على الخادم!", "لوحة", "لا توجد ملفات في هذا الدليل.", "إعادة تسمية", "أدخل اسم جديد", "معاينة", "تحميل", "لصق من الحافظة", "متصفحك لا يدعم إمكانية الوصول المباشر إلى الحافظة.", "نسخ التحديد", "نسخ", "دائرة نصف قطرها الحدود", "عرض كل", "تطبيق", "يرجى ملء هذا المجال", "يرجى إدخال عنوان ويب", "الافتراضي", "دائرة", "نقطة", "المربعة", "البحث", "تجد السابقة", "تجد التالي", "أدخل اسم الفصل", "اضغط البديل لتغيير حجم مخصص"];
          },
          52532: function (e) {
            e.exports.default = ["Napiš něco", "O Jodit", "Editor Jodit", "Verze pro nekomerční použití", "Jodit Uživatelská příručka", "obsahuje detailní nápovědu", "Pro informace o licenci, prosím, přejděte na naši stránku:", "Koupit plnou verzi", "Copyright © XDSoft.net - Chupurnov Valeriy. Všechna práva vyhrazena.", "Anchor", "Otevřít v nové záložce", "Otevřít v celoobrazovkovém režimu", "Vyčistit formátování", "Barva výplně a písma", "Vpřed", "Zpět", "Tučné", "Kurzíva", "Odrážky", "Číslovaný seznam", "Zarovnat na střed", "Zarovnat do bloku", "Zarovnat vlevo", "Zarovnat vpravo", "Vložit horizontální linku", "Vložit obrázek", "Vložit soubor", "Vložit video (YT/Vimeo)", "Vložit odkaz", "Velikost písma", "Typ písma", "Formátovat blok", "Normální text", "Nadpis 1", "Nadpis 2", "Nadpis 3", "Nadpis 4", "Citát", "Kód", "Vložit", "Vložit tabulku", "Zmenšit odsazení", "Zvětšit odsazení", "Vybrat speciální symbol", "Vložit speciální symbol", "Použít formát", "Změnit mód", "Okraje", "horní", "pravý", "spodní", "levý", "Styly", "Třídy", "Zarovnání", "Vpravo", "Na střed", "Vlevo", "--nenastaveno--", "src", "Titulek", "Alternativní text (alt)", "Link", "Otevřít link v nové záložce", "Obrázek", "soubor", "Rozšířené", "Vlastnosti obrázku", "Zpět", "Ok", "Váš text se podobá HTML. Vložit ho jako HTML?", "Vložit jako HTML", "Ponechat originál", "Vyčistit", "Vložit jako TEXT", "Vložit pouze TEXT", "Detekován fragment z Wordu nebo Excelu", "Obsah, který vkládáte, je pravděpodobně z Microsoft Word / Excel. Chcete ponechat formát nebo vložit pouze text?", "Prohlížeč souborů", "Chyba při načítání seznamu souborů", "Chyba při načítání složek", "Jste si jistý(á)?", "Název složky", "Vytvořit složku", "název", "Přetáhněte sem obrázek", "Přetáhněte sem soubor", "nebo klikněte", "Alternativní text", "Server", "Nahrát", "Pozadí", "Text", "Nahoru", "Na střed", "Dolu", "Vložit sloupec před", "Vložit sloupec za", "Vložit řádek nad", "Vložit řádek pod", "Vymazat tabulku", "Vymazat řádku", "Vymazat sloupec", "Vyčistit buňku", "HTML", "tučně", "kurzíva", "štětec", "odkaz", "zpět", "vpřed", "tabulka", "obrázek", "guma", "odstavec", "velikost písma", "video", "písmo", "о editoru", "tisk", "podtrženo", "přeškrtnuto", "zvětšit odsazení", "zmenšit odsazení", "celoobrazovkový režim", "smrsknout", "Linka", "Odrážka", "Číslovaný seznam", "Vyjmout", "Označit vše", "Kód", "Otevřít odkaz", "Upravit odkaz", "Atribut no-follow", "Odstranit odkaz", "Zobrazit", "Chcete-li upravit", "Aktualizovat", "URL", "Editovat", "Horizontální zarovnání", "Filtr", "Dle poslední změny", "Dle názvu", "Dle velikosti", "Přidat složku", "Reset", "Uložit", "Uložit jako...", "Změnit rozměr", "Ořezat", "Šířka", "Výška", "Ponechat poměr", "Ano", "Ne", "Vyjmout", "Označit", "Znaky: %d", "Slova: %d", "Vše", "Označit %s", "Označit vše", "Vertikální zarovnání", "Rozdělit", "Rozdělit vertikálně", "Rozdělit horizontálně", "Spojit", "Přidat sloupec", "Přidat řádek", "Vymazat", "Okraj", "Licence: %s", "Přeškrtnuto", "Podtrženo", "Horní index", "Dolní index", "Vyjmout označené", "Zalomení", "Najdi", "Nahradit za", "Vyměňte", "Vložit", "Vyber obsah pro vložení", "Můžete upravovat pouze své obrázky. Načíst obrázek?", "Obrázek byl úspěšně nahrán!", "paleta", "V tomto adresáři nejsou žádné soubory.", "přejmenovat", "Zadejte nový název", "náhled", "Stažení", "Vložit ze schránky", "Váš prohlížeč nepodporuje přímý přístup do schránky.", "Kopírovat výběr", "kopírování", "Border radius", "Zobrazit všechny", "Platí", "Prosím, vyplňte toto pole", "Prosím, zadejte webovou adresu", "Výchozí", "Kruh", "Dot", "Quadrate", "Najít", "Najít Předchozí", "Najít Další", "Vložte název třídy", "Stiskněte Alt pro vlastní změnu velikosti"];
          },
          75178: function (e) {
            e.exports.default = ["Bitte geben Sie einen Text ein", "Über Jodit", "Jodit Editor", null, "Das Jodit Benutzerhandbuch", "beinhaltet ausführliche Informationen wie Sie den Editor verwenden können.", "Für Informationen zur Lizenz, besuchen Sie bitte unsere Web-Präsenz:", "Vollversion kaufen", "Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.", "Anker", "In neuer Registerkarte öffnen", "Editor in voller Größe öffnen", "Formatierung löschen", "Füllfarbe oder Textfarbe ändern", "Wiederholen", "Rückgängig machen", "Fett", "Kursiv", "Unsortierte Liste einfügen", "Nummerierte Liste einfügen", "Mittig ausrichten", "Blocksatz", "Links ausrichten", "Rechts ausrichten", "Horizontale Linie einfügen", "Bild einfügen", "Datei einfügen", "Youtube/vimeo Video einfügen", "Link einfügen", "Schriftgröße", "Schriftfamilie", "Formatblock einfügen", "Normal", "Überschrift 1", "Überschrift 2", "Überschrift 3", "Überschrift 4", "Zitat", "Code", "Einfügen", "Tabelle einfügen", "Einzug verkleinern", "Einzug vergrößern", "Sonderzeichen auswählen", "Sonderzeichen einfügen", "Format kopieren", "Änderungsmodus", "Ränder", "Oben", "Rechts", "Unten", "Links", "CSS Stil", "CSS Klassen", "Ausrichtung", "Rechts", "Zentriert", "Links", "Keine", "Pfad", "Titel", "Alternativer Text", "Link", "Link in neuem Tab öffnen", "Bild", "Datei", "Fortgeschritten", "Bildeigenschaften", "Abbrechen", "OK", "Ihr Text ähnelt HTML-Code. Als HTML beibehalten?", "Als HTML einfügen?", "Original speichern", "Säubern", "Als Text einfügen", "Nur Text einfügen", "In Word formatierter Text erkannt", "Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder bereinigen?", "Dateibrowser", "Fehler beim Laden der Liste", "Fehler beim Laden der Ordner", "Sind Sie sicher?", "Geben Sie den Verzeichnisnamen ein", "Verzeichnis erstellen", "Typname", "Bild hier hinziehen", "Datei löschen", "oder hier klicken", "Alternativtext", "Auswählen", "Hochladen", "Hintergrund", "Text", "Oben", "Mittig", "Unten", "Spalte davor einfügen", "Spalte danach einfügen", "Zeile oberhalb einfügen", "Zeile unterhalb einfügen", "Tabelle löschen", "Zeile löschen", "Spalte löschen", "Zelle leeren", "HTML", "Fett gedruckt", "Kursiv", "Bürste", "Verknüpfung", "Rückgängig machen", "Wiederholen", "Tabelle", "Bild", "Radiergummi", "Absatz", "Schriftgröße", "Video", "Schriftart", "Über", "Drucken", "Unterstreichen", "Durchstreichen", "Einzug", "Herausstellen", "Vollgröße", "Schrumpfen", "die Linie", "Liste von", "Nummerierte Liste", "Schneiden", "Wählen Sie Alle aus", "Code einbetten", "Link öffnen", "Link bearbeiten", "Nofollow-Attribut", "Link entfernen", "Ansehen", "Bearbeiten", "Aktualisieren", "URL", "Bearbeiten", "Horizontale Ausrichtung", "Filter", "Sortieren nach geändert", "Nach Name sortieren", "Nach Größe sortiert", "Ordner hinzufügen", "Wiederherstellen", "Speichern", "Speichern als", "Größe ändern", "Größe anpassen", "Breite", "Höhe", "Seitenverhältnis beibehalten", "Ja", "Nein", "Entfernen", "Markieren", "Zeichen: %d", "Wörter: %d", "Alles markieren", "Markieren: %s", "Alles markieren", "Vertikale Ausrichtung", "Unterteilen", "Vertikal unterteilen", "Horizontal unterteilen", "Vereinen", "Spalte hinzufügen", "Zeile hinzufügen", "Löschen", "Rand", null, "Durchstreichen", "Unterstreichen", "Hochstellen", "Tiefstellen", "Auswahl ausschneiden", "Pause", "Suche nach", "Ersetzen durch", "Ersetzen", "Einfügen", "Wählen Sie den Inhalt zum Einfügen aus", "Sie können nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?", "Das Bild wurde erfolgreich auf den Server hochgeladen!", "Palette", "In diesem Verzeichnis befinden sich keine Dateien.", "Umbenennen", "Geben Sie einen neuen Namen ein", "Vorschau", "Herunterladen", "Aus Zwischenablage einfügen", "Ihr Browser unterstützt keinen direkten Zugriff auf die Zwischenablage.", "Auswahl kopieren", "Kopieren", "Radius für abgerundete Ecken", "Alle anzeigen", "Anwenden", "Bitte füllen Sie dieses Feld aus", "Bitte geben Sie eine Web-Adresse ein", "Standard", "Kreis", "Punkte", "Quadrate", "Suchen", "Suche vorherige", "Weitersuchen", "className (CSS) einfügen", "Drücken Sie Alt für benutzerdefinierte Größenanpassung"];
          },
          51048: function (e) {
            e.exports.default = {
              "Type something": "Start writing...",
              pencil: "Edit",
              Quadrate: "Square"
            };
          },
          22999: function (e) {
            e.exports.default = ["Escriba algo...", "Acerca de Jodit", "Jodit Editor", null, "Guía de usuario Jodit", "contiene ayuda detallada para el uso.", "Para información sobre la licencia, por favor visite nuestro sitio:", "Compre la versión completa", "Copyright © XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.", "Anclar", "Abrir en nueva pestaña", "Abrir editor en pantalla completa", "Limpiar formato", "Color de relleno o de letra", "Rehacer", "Deshacer", "Negrita", "Cursiva", "Insertar lista no ordenada", "Insertar lista ordenada", "Alinear Centrado", "Alinear Justificado", "Alinear Izquierda", "Alinear Derecha", "Insertar línea horizontal", "Insertar imagen", "Insertar archivo", "Insertar video de Youtube/vimeo", "Insertar vínculo", "Tamaño de letra", "Familia de letra", "Insertar bloque", "Normal", "Encabezado 1", "Encabezado 2", "Encabezado 3", "Encabezado 4", "Cita", "Código", "Insertar", "Insertar tabla", "Disminuir sangría", "Aumentar sangría", "Seleccionar caracter especial", "Insertar caracter especial", "Copiar formato", "Cambiar modo", "Márgenes", "arriba", "derecha", "abajo", "izquierda", "Estilos CSS", "Clases CSS", "Alinear", "Derecha", "Centrado", "Izquierda", "--No Establecido--", "Fuente", "Título", "Texto Alternativo", "Vínculo", "Abrir vínculo en nueva pestaña", "Imagen", "Archivo", "Avanzado", "Propiedades de imagen", "Cancelar", "Aceptar", "El código es similar a HTML. ¿Mantener como HTML?", "Pegar como HTML?", "Mantener", "Limpiar", "Insertar como texto", "Insertar solo texto", "Pegado desde Word detectado", "El contenido pegado proviene de un documento de Microsoft Word/Excel. ¿Desea mantener el formato o limpiarlo?", "Buscar archivo", "Error al cargar la lista", "Error al cargar las carpetas", "¿Está seguro?", "Entre nombre de carpeta", "Crear carpeta", "Entre el nombre", "Soltar imagen", "Soltar archivo", "o click", "Texto alternativo", "Buscar", "Subir", "Fondo", "Texto", "Arriba", "Centro", "Abajo", "Insertar columna antes", "Interar columna después", "Insertar fila arriba", "Insertar fila debajo", "Borrar tabla", "Borrar fila", "Borrar columna", "Vaciar celda", "HTML", "negrita", "cursiva", "Brocha", "Vínculo", "deshacer", "rehacer", "Tabla", "Imagen", "Borrar", "Párrafo", "Tamaño de letra", "Video", "Letra", "Acerca de", "Imprimir", "subrayar", "tachar", "sangría", "quitar sangría", "Tamaño completo", "encoger", "línea horizontal", "lista sin ordenar", "lista ordenada", "Cortar", "Seleccionar todo", "Incluir código", "Abrir vínculo", "Editar vínculo", "No seguir", "Desvincular", "Ver", "Para editar", "Actualizar", "URL", "Editar", "Alineación horizontal", "Filtrar", "Ordenar por fecha modificación", "Ordenar por nombre", "Ordenar por tamaño", "Agregar carpeta", "Resetear", "Guardar", "Guardar como...", "Redimensionar", "Recortar", "Ancho", "Alto", "Mantener relación de aspecto", "Si", "No", "Quitar", "Seleccionar", "Caracteres: %d", "Palabras: %d", "Todo", "Seleccionar: %s", "Seleccionar todo", "Alineación vertical", "Dividir", "Dividir vertical", "Dividir horizontal", "Mezclar", "Agregar columna", "Agregar fila", "Borrar", "Borde", null, "Tachado", "Subrayado", "superíndice", "subíndice", "Cortar selección", "Pausa", "Buscar", "Reemplazar con", "Reemplazar", "Pegar", "Seleccionar contenido para pegar", "Solo puedes editar tus propias imágenes. ¿Descargar esta imagen en el servidor?", "¡La imagen se ha subido correctamente al servidor!", "paleta", "No hay archivos en este directorio.", "renombrar", "Ingresa un nuevo nombre", "avance", "Descargar", "Pegar desde el portapapeles", "Su navegador no soporta el acceso directo en el portapapeles.", "Selección de copia", "copia", "Radio frontera", "Mostrar todos los", "Aplicar", "Por favor, rellene este campo", "Por favor, introduzca una dirección web", "Predeterminado", "Círculo", "Punto", "Cuadro", "Encontrar", "Buscar Anterior", "Buscar Siguiente", "Insertar nombre de clase", "Presione Alt para cambiar el tamaño personalizado"];
          },
          34145: function (e) {
            e.exports.default = ["Ecrivez ici", "A propos de Jodit", "Editeur Jodit", null, "Guide de l'utilisateur", "Aide détaillée à l'utilisation", "Consulter la licence sur notre site web:", "Acheter la version complète", "Copyright © XDSoft.net - Chupurnov Valeriy. Tous droits réservés.", "Ancre", "Ouvrir dans un nouvel onglet", "Ouvrir l'éditeur en pleine page", "Supprimer le formattage", "Modifier la couleur du fond ou du texte", "Refaire", "Défaire", "Gras", "Italique", "Liste non ordonnée", "Liste ordonnée", "Centrer", "Justifier", "Aligner à gauche ", "Aligner à droite", "Insérer une ligne horizontale", "Insérer une image", "Insérer un fichier", "Insérer une vidéo", "Insérer un lien", "Taille des caractères", "Famille des caractères", "Bloc formatté", "Normal", "Titre 1", "Titre 2", "Titre 3", "Titre 4", "Citation", "Code", "Insérer", "Insérer un tableau", "Diminuer le retrait", "Retrait plus", "Sélectionnez un caractère spécial", "Insérer un caractère spécial", "Cloner le format", "Mode wysiwyg <-> code html", "Marges", "haut", "droite", "Bas", "gauche", "Styles", "Classes", "Alignement", "Droite", "Centre", "Gauche", "--Non disponible--", "Source", "Titre", "Alternative", "Lien", "Ouvrir le lien dans un nouvel onglet", "Image", "fichier", "Avancé", "Propriétés de l'image", "Annuler", "OK", "Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?", "Coller en HTML?", "Sauvegarder l'original", "Nettoyer", "Coller en tant que texte", "Coller le texte seulement", "C'est peut-être un fragment de Word ou Excel", "Le contenu que vous insérez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?", "Explorateur de fichiers", "Erreur de liste de chargement", "Erreur de dossier de chargement", "Etes-vous sûrs ?", "Entrer le nom de dossier", "Créer un dossier", "type de fichier", "Coller une image", "Déposer un fichier", "ou cliquer", "Texte de remplacemement", "Chercher", "Charger", "Arrière-plan", "Texte", "Haut", "Milieu", "Bas", "Insérer une colonne avant", "Insérer une colonne après", "Insérer une ligne au dessus", "Insérer une ligne en dessous", "Supprimer le tableau", "Supprimer la ligne", "Supprimer la colonne", "Vider la cellule", "la source", "gras", "italique", "pinceau", "lien", "annuler", "refaire", "tableau", "image", "gomme", "clause", "taille de police", "Video", "police", "à propos de l'éditeur", "impression", "souligné", "barré", "indentation", "retrait", "taille réelle", "taille conventionnelle", "la ligne", "Liste", "Liste numérotée", "Couper", "Sélectionner tout", null, "Ouvrir le lien", "Modifier le lien", "Attribut Nofollow", "Supprimer le lien", "Voir", "Pour éditer", "Mettre à jour", "URL", null, "Alignement horizontal", "Filtre", "Trier par modification", "Trier par nom", "Trier par taille", "Créer le dossier", "Restaurer", "Sauvegarder", "Enregistrer sous", "Changer la taille", "Taille de garniture", "Largeur", "Hauteur", "Garder les proportions", "Oui", "Non", "Supprimer", "Mettre en évidence", "Symboles: %d", "Mots: %d", null, "Mettre en évidence: %s", "Tout sélectionner", "Alignement vertical", "Split", "Split vertical", "Split horizontal", "aller", "Ajouter une colonne", "Ajouter une rangée", "Effacer", "Bordure", null, "Barrer", "Souligner", "exposant", "indice", "Couper la sélection", "Pause", "Rechercher", "Remplacer par", "Remplacer", "Coller", "Choisissez le contenu à coller", "Vous ne pouvez éditer que vos propres images. Téléchargez cette image sur l'hôte?", "L'image a été téléchargée avec succès sur le serveur!", "Palette", "Il n'y a aucun fichier dans ce répertoire.", "renommer", "Entrez un nouveau nom", "Aperçu", "Télécharger", "Coller à partir du presse-papiers", "Votre navigateur ne prend pas en charge l'accès direct au presse-papiers.", "Copier la sélection", "copie", "Rayon des bordures", "Afficher tous", "Appliquer", "Veuillez remplir ce champ", "Veuillez entrer une adresse web", "Par défaut", "Cercle", "Point", "Quadratique", "Trouver", "Précédent", "Suivant", "Insérer un nom de classe", "Appuyez sur Alt pour un redimensionnement personnalisé"];
          },
          40272: function (e) {
            e.exports.default = ["הקלד משהו...", "About Jodit", "Jodit Editor", null, "Jodit User's Guide", "contains detailed help for using.", "For information about the license, please go to our website:", "Buy full version", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.", "מקום עיגון", "פתח בכרטיסיה חדשה", "פתח את העורך בחלון חדש", "נקה עיצוב", "שנה צבע טקסט או רקע", "בצע שוב", "בטל", "מודגש", "נטוי", "הכנס רשימת תבליטים", "הכנס רשימה ממוספרת", "מרכז", "ישר ", "ישר לשמאל", "ישר לימין", "הכנס קו אופקי", "הכנס תמונה", "הכנס קובץ", "הכנס סרטון וידאו מYouTube/Vimeo", "הכנס קישור", "גודל גופן", "גופן", "מעוצב מראש", "רגיל", "כותרת 1", "כותרת 2", "כותרת 3", "כותרת 4", "ציטוט", "קוד", "הכנס", "הכנס טבלה", "הקטן כניסה", "הגדל כניסה", "בחר תו מיוחד", "הכנס תו מיוחד", "העתק עיצוב", "החלף מצב", "ריווח", "עליון", "ימין", "תחתון", "שמאל", "עיצוב CSS", "מחלקת CSS", "יישור", "ימין", "מרכז", "שמאל", "--לא נקבע--", "מקור", "כותרת", "כיתוב חלופי", "קישור", "פתח בכרטיסיה חדשה", "תמונה", "קובץ", "מתקדם", "מאפייני תמונה", "ביטול", "אישור", "הקוד דומה לHTML, האם להשאיר כHTML", "הדבק כHTML", "השאר", "נקה", "הכנס כטקסט", "הכנס טקסט בלבד", 'זוהתה הדבקה מ"וורד"', "התוכן המודבק מגיע ממסמך וורד/אקסל. האם ברצונך להשאיר את העיצוב או לנקותו", "סייר הקבצים", "שגיאה  בזמן טעינת רשימה", "שגיאה בזמן טעינת תקיות", "האם אתה בטוח?", "הכנס שם תקיה", "צור תקיה", "סוג הקובץ", "הסר תמונה", "הסר קובץ", "או לחץ", "כיתוב חלופי", "סייר", "העלה", "רקע", "טקסט", "עליון", "מרכז", "תחתון", "הכנס עמודה לפני", "הכנס עמודה אחרי", "הכנס שורה מעל", "הכנס שורה מתחת", "מחק טבלה", "מחק שורה", "מחק עמודה", "רוקן תא", "HTML", "מודגש", "נטוי", "מברשת", "קישור", "בטל", "בצע שוב", "טבלה", "תמונה", "מחק", "פסקה", "גודל גופן", "וידאו", "גופן", "עלינו", "הדפס", "קו תחתון", "קו חוצה", "הגדל כניסה", "הקטן כניסה", "גודל מלא", "כווץ", "קו אופקי", "רשימת תבליטים", "רשימה ממוספרת", "חתוך", "בחר הכל", "הוסף קוד", "פתח קישור", "ערוך קישור", "ללא מעקב", "בטל קישור", "הצג", "כדי לערוך", "עדכן", "כתובת", "ערוך", "יישור אופקי", "סנן", "מין לפי שינוי", "מיין לפי שם", "מיין לפי גודל", "הוסף תקייה", "אפס", "שמור", "שמור בשם...", "שנה גודל", "חתוך", "רוחב", "גובה", "שמור יחס", "כן", "לא", "הסר", "בחר", "תווים: %d", "מילים: %d", "הכל", "נבחר: %s", "בחר הכל", "יישור אנכי", "פיצול", "פיצול אנכי", "פיצול אופקי", "מזג", "הוסף עמודה", "הוסף שורה", "מחק", "מסגרת", null, "קו חוצה", "קו תחתון", "superscript", "subscript", "גזור בחירה", "שבירת שורה", "חפש", "החלף ב", "להחליף", "הדבק", "בחר תוכן להדבקה", "רק קבצים המשוייכים שלך ניתנים לעריכה. האם להוריד את הקובץ?", "התמונה עלתה בהצלחה!", "לוח", "אין קבצים בספריה זו.", "הונגרית", "הזן שם חדש", "תצוגה מקדימה", "הורד", "להדביק מהלוח", "הדפדפן שלך לא תומך גישה ישירה ללוח.", "העתק בחירה", "העתק", "רדיוס הגבול", "הצג את כל", "החל", "נא למלא שדה זה", "אנא הזן כתובת אינטרנט", "ברירת המחדל", "מעגל", "נקודה", "הריבוע הזה", "למצוא", "מצא את הקודם", "חפש את הבא", "הכנס את שם הכיתה", "לחץ על אלט לשינוי גודל מותאם אישית"];
          },
          2978: function (e) {
            e.exports.default = ["Írjon be valamit", "Joditról", "Jodit Editor", "Ingyenes változat", "Jodit útmutató", "további segítséget tartalmaz", "További licence információkért látogassa meg a weboldalunkat:", "Teljes verzió megvásárlása", "Copyright © XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.", "Horgony", "Megnyitás új lapon", "Megnyitás teljes méretben", "Formázás törlése", "Háttér/szöveg szín", "Újra", "Visszavon", "Félkövér", "Dőlt", "Pontozott lista", "Számozott lista", "Középre zárt", "Sorkizárt", "Balra zárt", "Jobbra zárt", "Vízszintes vonal beszúrása", "Kép beszúrás", "Fájl beszúrás", "Youtube videó beszúrása", "Link beszúrás", "Betűméret", "Betűtípus", "Formázott blokk beszúrása", "Normál", "Fejléc 1", "Fejléc 2", "Fejléc 3", "Fejléc 4", "Idézet", "Kód", "Beszúr", "Táblázat beszúrása", "Behúzás csökkentése", "Behúzás növelése", "Speciális karakter kiválasztása", "Speciális karakter beszúrása", "Kép formázása", "Nézet váltása", "Szegélyek", "felső", "jobb", "alsó", "bal", "CSS stílusok", "CSS osztályok", "Igazítás", "Jobbra", "Középre", "Balra", "Nincs", "Forrás", "Cím", "Helyettesítő szöveg", "Link", "Link megnyitása új lapon", "Kép", "Fájl", "Haladó", "Kép tulajdonságai", "Mégsem", "OK", "A beillesztett szöveg HTML-nek tűnik. Megtartsuk HTML-ként?", "Beszúrás HTML-ként", "Megtartás", "Elvetés", "Beszúrás szövegként", "Csak szöveg beillesztése", "Word-ből másolt szöveg", "A beillesztett tartalom Microsoft Word/Excel dokumentumból származik. Meg szeretné tartani a formátumát?", "Fájl tallózó", "Hiba a lista betöltése közben", "Hiba a mappák betöltése közben", "Biztosan ezt szeretné?", "Írjon be egy mappanevet", "Mappa létrehozása", "írjon be bevet", "Húzza ide a képet", "Húzza ide a fájlt", "vagy kattintson", "Helyettesítő szöveg", "Tallóz", "Feltölt", "Háttér", "Szöveg", "Fent", "Középen", "Lent", "Oszlop beszúrás elé", "Oszlop beszúrás utána", "Sor beszúrás fölé", "Sor beszúrás alá", "Táblázat törlése", "Sor törlése", "Oszlop törlése", "Cella tartalmának törlése", "HTML", "Félkövér", "Dőlt", "Ecset", "Link", "Visszavon", "Újra", "Táblázat", "Kép", "Törlés", "Paragráfus", "Betűméret", "Videó", "Betű", "Rólunk", "Nyomtat", "Aláhúzott", "Áthúzott", "Behúzás", "Aussenseiter", "Teljes méret", "Összenyom", "Egyenes vonal", "Lista", "Számozott lista", "Kivág", "Összes kijelölése", "Beágyazott kód", "Link megnyitása", "Link szerkesztése", "Nincs követés", "Link leválasztása", "felülvizsgálat", "Szerkesztés", "Frissít", "URL", "Szerkeszt", "Vízszintes igazítás", "Szűrő", "Rendezés módosítás szerint", "Rendezés név szerint", "Rendezés méret szerint", "Mappa hozzáadás", "Visszaállít", "Mentés", "Mentés másként...", "Átméretezés", "Kivág", "Szélesség", "Magasság", "Képarány megtartása", "Igen", "Nem", "Eltávolít", "Kijelöl", "Karakterek száma: %d", "Szavak száma: %d", "Összes", "Kijelöl: %s", "Összes kijelölése", "Függőleges igazítás", "Felosztás", "Függőleges felosztás", "Vízszintes felosztás", "Összevonás", "Oszlop hozzáadás", "Sor hozzáadás", "Törlés", "Szegély", null, "Áthúzott", "Aláhúzott", "Felső index", "Alsó index", "Kivágás", "Szünet", "Keresés", "Csere erre", "Cserélje ki", "Beillesztés", "Válasszon tartalmat a beillesztéshez", "Csak a saját képeit tudja szerkeszteni. Letölti ezt a képet?", "Kép sikeresen feltöltve!", "Palette", "Er zijn geen bestanden in deze map.", "átnevezés", "Adja meg az új nevet", "előnézet", "Letöltés", "Illessze be a vágólap", "A böngésző nem támogatja a közvetlen hozzáférést biztosít a vágólapra.", "Másolás kiválasztása", "másolás", "Határ sugár", "Összes", "Alkalmazni", "Kérjük, töltse ki ezt a mezőt,", "Kérjük, írja be a webcímet", "Alapértelmezett", "Kör", "Pont", "Quadrate", "Találni", "Megtalálja Előző", "Következő Keresése", "Helyezze be az osztály nevét", "Nyomja meg az Alt egyéni átméretezés"];
          },
          99113: function (e) {
            e.exports.default = ["Ketik sesuatu", "Tentang Jodit", "Editor Jodit", "Versi Bebas Non-komersil", "Panduan Pengguna Jodit", "mencakup detail bantuan penggunaan", "Untuk informasi tentang lisensi, silakan kunjungi website:", "Beli versi lengkap", "Hak Cipta © XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.", "Tautan", "Buka di tab baru", "Buka editor dalam ukuran penuh", "Hapus Pemformatan", "Isi warna atau atur warna teks", "Ulangi", "Batalkan", "Tebal", "Miring", "Sisipkan Daftar Tidak Berurut", "Sisipkan Daftar Berurut", "Tengah", "Penuh", "Kiri", "Kanan", "Sisipkan Garis Horizontal", "Sisipkan Gambar", "Sisipkan Berkas", "Sisipkan video youtube/vimeo", "Sisipkan tautan", "Ukuran font", "Keluarga font", "Sisipkan blok format", "Normal", "Heading 1", "Heading 2", "Heading 3", "Heading 4", "Kutip", "Kode", "Sisipkan", "Sisipkan tabel", "Kurangi Indentasi", "Tambah Indentasi", "Pilih Karakter Spesial", "Sisipkan Karakter Spesial", "Formar warna", "Ubah mode", "Batas", "atas", "kanan", "bawah", "kiri", "Gaya", "Class", "Rata", "Kanan", "Tengah", "Kiri", "--Tidak diset--", "Src", "Judul", "Teks alternatif", "Tautan", "Buka tautan di tab baru", "Gambar", "berkas", "Lanjutan", "Properti gambar", "Batal", "Ya", "Kode Anda cenderung ke HTML. Biarkan sebagai HTML?", "Paste sebagai HTML", "Jaga", "Bersih", "Sisipkan sebagai teks", "Sisipkan hanya teks", "Terdeteksi paste dari Word", "Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?", "Penjelajah Berkas", "Error ketika memuat list", "Error ketika memuat folder", "Apakah Anda yakin?", "Masukkan nama Direktori", "Buat direktori", "ketik nama", "Letakkan gambar", "Letakkan berkas", "atau klik", "Teks alternatif", "Jelajahi", "Unggah", "Latar Belakang", "Teks", "Atas", "Tengah", "Bawah", "Sisipkan kolom sebelumnya", "Sisipkan kolom setelahnya", "Sisipkan baris di atasnya", "Sisipkan baris di bawahnya", "Hapus tabel", "Hapus baris", "Hapus kolom", "Kosongkan cell", "sumber", "tebal", "miring", "sikat", "tautan", "batalkan", "ulangi", "tabel", "gambar", "penghapus", "paragraf", "ukuran font", "video", "font", "tentang", "cetak", "garis bawah", "coret", "menjorok ke dalam", "menjorok ke luar", "ukuran penuh", "menyusut", "hr", "ul", "ol", "potong", "Pilih semua", "Kode embed", "Buka tautan", "Edit tautan", "No follow", "Hapus tautan", "Mata", "pensil", "Perbarui", "URL", "Edit", "Perataan horizontal", "Filter", "Urutkan berdasarkan perubahan", "Urutkan berdasarkan nama", "Urutkan berdasarkan ukuran", "Tambah folder", "Reset", "Simpan", "Simpan sebagai...", "Ubah ukuran", "Crop", "Lebar", "Tinggi", "Jaga aspek rasio", "Ya", "Tidak", "Copot", "Pilih", "Karakter: %d", "Kata: %d", "Semua", "Pilih %s", "Pilih semua", "Rata vertikal", "Bagi", "Bagi secara vertikal", "Bagi secara horizontal", "Gabungkan", "Tambah kolom", "tambah baris", "Hapus", "Bingkai", "Lisensi: %s", "Coret", "Garis Bawah", "Superskrip", "Subskrip", "Potong pilihan", "Berhenti", "Mencari", "Ganti dengan", "Mengganti", "Paste", "Pilih konten untuk dipaste", "Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?", "Gambar telah sukses diunggah ke host!", "palet", "Tidak ada berkas", "ganti nama", "Masukkan nama baru", "pratinjau", "Unduh", "Paste dari clipboard", "Browser anda tidak mendukung akses langsung ke clipboard.", "Copy seleksi", "copy", "Border radius", "Tampilkan semua", "Menerapkan", "Silahkan mengisi kolom ini", "Silahkan masukkan alamat web", "Default", "Lingkaran", "Dot", "Kuadrat", "Menemukan", "Menemukan Sebelumnya", "Menemukan Berikutnya", "Masukkan nama kelas", "Tekan Alt untuk mengubah ukuran kustom"];
          },
          51923: function (e) {
            e.exports.default = ["Scrivi qualcosa...", "A proposito di Jodit", "Jodit Editor", null, "Guida utente di Jodit", "contiene una guida dettagliata per l'uso.", "Per informazioni sulla licenza, si prega di visitare il nostro sito:", "Acquista la versione completa", "Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.", "Ancora", "Apri in una nuova scheda", "Apri l'editor a schermo intero", "Formato chiaro", "Riempi colore o lettera", "Ripristina", "Annulla", "Grassetto", "Corsivo", "Inserisci lista non ordinata", "Inserisci l'elenco ordinato", "Allinea Centra", "Allineare Giustificato", "Allinea a Sinistra", "Allinea a Destra", "Inserisci la linea orizzontale", "Inserisci immagine", "Inserisci un file", "Inserisci video Youtube/Vimeo", "Inserisci il link", "Dimensione del carattere", "Tipo di font", "Inserisci blocco", "Normale", "Heading 1", "Heading 2", "Heading 3", "Heading 4", "Citazione", "Codice", "Inserisci", "Inserisci tabella", "Riduci il rientro", "Aumenta il rientro", "Seleziona una funzione speciale", "Inserisci un carattere speciale", "Copia formato", "Cambia modo", "Margini", "su", "destra", "giù", "sinistra", "Stili CSS", "Classi CSS", "Allinea", "Destra", "Centro", "Sinistra", "--Non Impostato--", "Fonte", "Titolo", "Testo Alternativo", "Link", "Apri il link in una nuova scheda", "Immagine", "Archivio", "Avanzato", "Proprietà dell'immagine", "Annulla", "Accetta", "Il codice è simile all'HTML. Mantieni come HTML?", "Incolla come HTML?", "Mantieni", "Pulisci", "Inserisci come testo", "Inserisci solo il testo", "Incollato da Word rilevato", "Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?", "Cerca il file", "Errore durante il caricamento dell'elenco", "Errore durante il caricamento delle cartelle", "Sei sicuro?", "Inserisci il nome della cartella", "Crea cartella", "Entre el nombre", "Rilascia l'immagine", "Rilascia file", "o click", "Testo alternativo", "Sfoglia", "Carica", "Sfondo", "Testo", "Su", "Centro", "Sotto", "Inserisci prima la colonna", "Inserisci colonna dopo", "Inserisci la riga sopra", "Inserisci la riga sotto", "Elimina tabella", "Elimina riga", "Elimina colonna", "Cella vuota", "HTML", "Grassetto", "Corsivo", "Pennello", "Link", "Annulla", "Ripristina", "Tabella", "Immagine", "Gomma", "Paragrafo", "Dimensione del carattere", "Video", "Font", "Approposito di", "Stampa", "Sottolineato", "Barrato", "trattino", "annulla rientro", "A grandezza normale", "comprimere", "linea orizzontale", "lista non ordinata", "lista ordinata", "Taglia", "Seleziona tutto", "Includi codice", "Apri link", "Modifica link", "Non seguire", "Togli link", "Recensione", "Per modificare", "Aggiornare", " URL", "Modifica", "Allineamento orizzontale", "Filtro", "Ordina per data di modifica", "Ordina per nome", "Ordina per dimensione", "Aggiungi cartella", "Reset", "Salva", "Salva con nome...", "Ridimensiona", "Tagliare", "Larghezza", "Altezza", "Mantenere le proporzioni", "Si", "No", "Rimuovere", "Seleziona", "Caratteri: %d", "Parole: %d", "Tutto", "Seleziona: %s", "Seleziona tutto", "Allineamento verticala", "Dividere", "Dividere verticalmente", "Diviso orizzontale", "Fondi", "Aggiungi colonna", "Aggiungi riga", "Cancella", "Bordo", null, "Barrato", "Sottolineato", "indice", "deponente", "Taglia la selezione", "Pausa", "Cerca", "Sostituisci con", "Sostituire", "Incolla", "Seleziona il contenuto da incollare", "Puoi modificare solo le tue immagini. Scarica questa immagine sul server?", "L'immagine è stata caricata con successo sul server!", "tavolozza", "Non ci sono file in questa directory.", "ungherese", "Inserisci un nuovo nome", "anteprima", "Scaricare", "Incolla dagli appunti", "Il tuo browser non supporta l'accesso diretto agli appunti.", "Selezione di copia", "copia", "Border radius", "Mostra tutti", "Applicare", "Si prega di compilare questo campo", "Si prega di inserire un indirizzo web", "Di Default", "Cerchio", "Dot", "Quadrate", "Trovare", "Trova Precedente", "Trova Successivo", "Inserisci il nome della classe", "Premere Alt per il ridimensionamento personalizzato"];
          },
          21268: function (e) {
            e.exports.default = ["なにかタイプしてください", "Joditについて", "Jodit Editor", null, "Jodit ユーザーズ・ガイド", "詳しい使い方", "ライセンス詳細についてはJodit Webサイトを確認ください：", "フルバージョンを購入", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.", "Anchor", "新しいタブで開く", "エディターのサイズ（フル/ノーマル）", "書式をクリア", "テキストの色", "やり直し", "元に戻す", "太字", "斜体", "箇条書き", "番号付きリスト", "中央揃え", "両端揃え", "左揃え", "右揃え", "区切り線を挿入", "画像を挿入", "ファイルを挿入", "Youtube/Vimeo 動画", "リンクを挿入", "フォントサイズ", "フォント", "テキストのスタイル", "指定なし", "タイトル1", "タイトル2", "タイトル3", "タイトル4", "引用", "コード", "挿入", "表を挿入", "インデント減", "インデント増", "特殊文字を選択", "特殊文字を挿入", "書式を貼付け", "編集モード切替え", "マージン", "上", "右", "下", "左", "スタイル", "クラス", "配置", "右寄せ", "中央寄せ", "左寄せ", "指定なし", "ソース", "タイトル", "代替テキスト", "リンク", "新しいタブで開く", "画像", "ファイル", "高度な設定", "画像のプロパティー", "キャンセル", "確定", "HTMLコードを保持しますか？", "HTMLで貼付け", "HTMLを保持", "Clean", "HTMLをテキストにする", "テキストだけ", "Word Paste Detected", "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?", "File Browser", "Error on load list", "Error on load folders", "Are you sure?", "Enter Directory name", "Create directory", "type name", "ここに画像をドロップ", "ここにファイルをドロップ", "or クリック", "代替テキスト", "ブラウズ", "アップロード", "背景", "文字", "上", "中央", "下", "左に列を挿入", "右に列を挿入", "上に行を挿入", "下に行を挿入", "表を削除", "行を削除", "列を削除", "セルを空にする", "source", "bold", "italic", "brush", "link", "undo", "redo", "table", "image", "eraser", "paragraph", "fontsize", "video", "font", "about", "print", "underline", "strikethrough", "indent", "outdent", "fullsize", "shrink", "分割線", "箇条書き", "番号付きリスト", "切り取り", "すべて選択", "埋め込みコード", "リンクを開く", "リンクを編集", "No follow", "リンク解除", "サイトを確認", "鉛筆", "更新", "URL", "編集", "水平方向の配置", "Filter", "Sort by changed", "Sort by name", "Sort by size", "Add folder", "リセット", "保存", "Save as ...", "リサイズ", "Crop", "幅", "高さ", "縦横比を保持", "はい", "いいえ", "移除", "選択", "文字数: %d", "単語数: %d", "全部", "選択: %s", "すべて選択", "垂直方向の配置", "分割", "セルの分割（垂直方向）", "セルの分割（水平方向）", "セルの結合", "列を追加", "行を追加", "削除", "境界線", null, "取り消し線", "下線", "上付き文字", "下付き文字", "切り取り", "Pause", "検索", "置換", "交換", "貼付け", "選択した内容を貼付け", "You can only edit your own images. Download this image on the host?", "The image has been successfully uploaded to the host!", "パレット", "There are no files", "Rename", "Enter new name", "プレビュー", "ダウンロード", "貼り付け", "お使いのブラウザはクリップボードを使用できません", "コピー", "copy", "角の丸み", "全て表示", "適用", "まだこの分野", "を入力してくださいウェブアドレス", "デフォルト", "白丸", "黒丸", "四角", "見", "探前", "由来", "クラス名を挿入", "カスタムサイズ変更のためのAltキーを押します"];
          },
          11399: function (e) {
            e.exports.default = ["Type something", "About Jodit", "Jodit Editor", "Free Non-commercial Version", "Jodit User's Guide", "contains detailed help for using", "For information about the license, please go to our website:", "Buy full version", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.", "Anchor", "Open in new tab", "Open in fullsize", "Clear Formatting", "Fill color or set the text color", "Redo", "Undo", "Bold", "Italic", "Insert Unordered List", "Insert Ordered List", "Align Center", "Align Justify", "Align Left", "Align Right", "Insert Horizontal Line", "Insert Image", "Insert file", "Insert youtube/vimeo video", "Insert link", "Font size", "Font family", "Insert format block", "Normal", "Heading 1", "Heading 2", "Heading 3", "Heading 4", "Quote", "Code", "Insert", "Insert table", "Decrease Indent", "Increase Indent", "Select Special Character", "Insert Special Character", "Paint format", "Change mode", "Margins", "top", "right", "bottom", "left", "Styles", "Classes", "Align", "Right", "Center", "Left", "--Not Set--", "Src", "Title", "Alternative", "Link", "Open link in new tab", "Image", "file", "Advanced", "Image properties", "Cancel", "Ok", "Your code is similar to HTML. Keep as HTML?", "Paste as HTML", "Keep", "Clean", "Insert as Text", "Insert only Text", "Word Paste Detected", "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?", "File Browser", "Error on load list", "Error on load folders", "Are you sure?", "Enter Directory name", "Create directory", "type name", "Drop image", "Drop file", "or click", "Alternative text", "Browse", "Upload", "Background", "Text", "Top", "Middle", "Bottom", "Insert column before", "Insert column after", "Insert row above", "Insert row below", "Delete table", "Delete row", "Delete column", "Empty cell", "source", "bold", "italic", "brush", "link", "undo", "redo", "table", "image", "eraser", "paragraph", "fontsize", "video", "font", "about", "print", "underline", "strikethrough", "indent", "outdent", "fullsize", "shrink", "hr", "ul", "ol", "cut", "selectall", "Embed code", "Open link", "Edit link", "No follow", "Unlink", "Eye", "pencil", "Update", " URL", "Edit", "Horizontal align", "Filter", "Sort by changed", "Sort by name", "Sort by size", "Add folder", "Reset", "Save", "Save as ...", "Resize", "Crop", "Width", "Height", "Keep Aspect Ratio", "Yes", "No", "Remove", "Select", "Chars: %d", "Words: %d", "All", "Select %s", "Select all", "Vertical align", "Split", "Split vertical", "Split horizontal", "Merge", "Add column", "Add row", "Delete", "Border", "License: %s", "Strike through", "Underline", "superscript", "subscript", "Cut selection", "Break", "Search for", "Replace with", "Replace", "Paste", "Choose Content to Paste", "You can only edit your own images. Download this image on the host?", "The image has been successfully uploaded to the host!", "palette", "There are no files", "Rename", "Enter new name", "preview", "download", "Paste from clipboard", "Your browser doesn't support direct access to the clipboard.", "Copy selection", "copy", "Border radius", "Show all", "Apply", "Please fill out this field", "Please enter a web address", "Default", "Circle", "Dot", "Quadrate", "Find", "Find Previous", "Find Next", "Insert className", "Press Alt for custom resizing"];
          },
          37289: function (e) {
            e.exports.default = ["무엇이든 입력하세요", "Jodit에 대하여", "Jodit Editor", null, "Jodit 사용자 안내서", "자세한 도움말이 들어있어요", "라이센스에 관해서는 Jodit 웹 사이트를 방문해주세요：", "풀 버전 구입하기", "© XDSoft.net - Chupurnov Valeriy. 에게 저작권과 모든 권리가 있습니다.", "Anchor", "새 탭에서 열기", "전체 크기로 보기", "서식 지우기", "글씨 색상", "재실행", "실행 취소", "굵게", "기울임", "글머리 목록", "번호 목록", "가운데 정렬", "양쪽 정렬", "왼쪽 정렬", "오른쪽 정렬", "수평 구분선 넣기", "이미지 넣기", "파일 넣기", "Youtube/Vimeo 동영상", "링크 넣기", "글꼴 크기", "글꼴", "블록 요소 넣기", "일반 텍스트", "제목 1", "제목 2", "제목 3", "제목 4", "인용", "코드", "붙여 넣기", "테이블", "들여쓰기 감소", "들여쓰기 증가", "특수문자 선택", "특수문자 입력", "페인트 형식", "편집모드 변경", "마진", "위", "오른쪽", "아래", "왼쪽", "스타일", "클래스", "정렬", "오른쪽으로", "가운데로", "왼쪽으로", "--지정 안 함--", "경로(src)", "제목", "대체 텍스트(alt)", "링크", "새 탭에서 열기", null, "파일", "고급", "이미지 속성", "취소", "확인", "HTML 코드로 감지했어요. 코드인채로 붙여넣을까요?", "HTML로 붙여넣기", "원본 유지", "지우기", "텍스트로 넣기", "텍스트만 넣기", "Word 붙여넣기 감지", "Microsoft Word/Excel 문서로 감지했어요. 서식을 유지한채로 붙여넣을까요?", "파일 탐색기", "목록 불러오기 에러", "폴더 불러오기", "정말 진행할까요?", "디렉토리 이름 입력", "디렉토리 생성", "이름 입력", "이미지 드래그", "파일 드래그", "혹은 클릭", "대체 텍스트", "탐색", "업로드", "배경", "텍스트", "위", "중앙", "아래", "이전 열에 삽입", "다음 열에 삽입", "위 행에 삽입", "아래 행에 삽입", "테이블 삭제", "행 삭제", "열 삭제", "빈 셀", "HTML 소스", "볼드", "이탤릭", "브러시", "링크", "실행 취소", "재실행", "테이블", "이미지", "지우개", "문단", "글꼴 크기", "비디오", "글꼴", "편집기 정보", "프린트", "밑줄", "취소선", "들여쓰기", "내어쓰기", "전체 화면", "일반 화면", "구분선", "글머리 목록", "번호 목록", "잘라내기", "모두 선택", "Embed 코드", "링크 열기", "링크 편집", "No follow", "링크 제거", "사이트 확인", "연필", "갱신", "URL", "편집", "수평 정렬", "필터", "변경일 정렬", "이름 정렬", "크기 정렬", "새 폴더", "초기화", "저장", "새로 저장하기 ...", "리사이즈", "크롭", "가로 길이", "세로 높이", "비율 유지하기", "네", "아니오", "제거", "선택", "문자수: %d", "단어수: %d", "모두", "선택: %s", "모두 선택", "수직 정렬", "분할", "세로 셀 분할", "가로 셀 분할", "셀 병합", "열 추가", "행 추가", "삭제", "외곽선", "라이센스: %s", "취소선", "밑줄", "윗첨자", "아래첨자", "선택 잘라내기", "구분자", "검색", "대체하기", "대체", "붙여넣기", "붙여넣을 내용 선택", "외부 이미지는 편집할 수 없어요. 외부 이미지를 다운로드 할까요?", "이미지를 무사히 업로드 했어요!", "팔레트", "파일이 없어요", "이름 변경", "새 이름 입력", "미리보기", "다운로드", "클립보드 붙여넣기", "사용중인 브라우저가 클립보드 접근을 지원하지 않아요.", "선택 복사", "복사", "둥근 테두리", "모두 보기", "적용", "이 항목을 입력해주세요!", "웹 URL을 입력해주세요.", "기본", "원", "점", "정사각형", "찾기", "이전 찾기", "다음 찾기", "className 입력", "사용자 지정 크기 조정에 대 한 고도 누르십시오"];
          },
          26501: function (e) {
            e.exports.default = ["Бичээд үзээрэй", "Jodit-ын талаар ", "Jodit програм", null, "Jodit гарын авлага", "хэрэглээний талаар дэлгэрэнгүй мэдээллийг агуулна", "Лицензийн мэдээллийг манай вэб хуудаснаас авна уу:", "Бүрэн хувилбар худалдан авах", "Зохиогчийн эрх хамгаалагдсан © XDSoft.net - Chupurnov Valeriy. Бүх эрхийг эзэмшинэ.", "Холбоо барих", "Шинэ табаар нээх", "Бүтэн дэлгэцээр нээх", "Форматыг арилгах", "Өнгөөр будах эсвэл текстийн өнгө сонгох", "Дахих", "Буцаах", "Тод", "Налуу", "Тэмдэгт жагсаалт нэмэх", "Дугаарт жагсаалт нэмэх", "Голлож байрлуулах", "Тэгшитгэн байрлуулах", "Зүүнд байрлуулах", "Баруунд байрлуулах", "Хэвтээ зураас нэмэх", "Зураг нэмэх", "Файл нэмэх", "Youtube/Vimeo видео нэмэх", "Холбоос нэмэх", "Фонтын хэмжээ", "Фонтын бүл", "Блок нэмэх", "Хэвийн", "Гарчиг 1", "Гарчиг 2", "Гарчиг 3", "Гарчиг 4", "Ишлэл", "Код", "Оруулах", "Хүснэгт оруулах", "Доголын зай хасах", "Доголын зай нэмэх", "Тусгай тэмдэгт сонгох", "Тусгай тэмдэгт нэмэх", "Зургийн формат", "Горим өөрчлөх", "Цаасны зай", "Дээрээс", "Баруунаас", "Доороос", "Зүүнээс", "CSS стиль", "CSS анги", "Байрлуулах", "Баруун", "Төв", "Зүүн", "--Тодорхойгүй--", "Эх үүсвэр", "Гарчиг", "Алтернатив текст", "Холбоос", "Холбоосыг шинэ хавтсанд нээх", "Зураг", "Файл", "Дэвшилтэт", "Зургийн үзүүлэлт", "Цуцлах", "Ok", "Таны код HTML кодтой адил байна. HTML форматаар үргэлжлүүлэх үү?", "HTML байдлаар буулгах", "Хадгалах", "Цэвэрлэх", "Текст байдлаар нэмэх", "Зөвхөн текст оруулах", "Word байдлаар буулгасан байна", "Буулгасан агуулга Microsoft Word/Excel форматтай байна. Энэ форматыг хэвээр хадгалах уу эсвэл арилгах уу?", "Файлын цонх", "Жагсаалт татах үед алдаа гарлаа", "Хавтас татах үед алдаа гарлаа", "Итгэлтэй байна уу?", "Хавтсын нэр оруулах", "Хавтас үүсгэх", "Нэр бичих", "Зураг буулгах", "Файл буулгах", "эсвэл товш", "Алтернатив текст", "Үзэх", "Байршуулах", "Арын зураг", "Текст", "Дээр", "Дунд", "Доор", "Урд нь багана нэмэх", "Ард нь багана нэмэх", "Дээр нь мөр нэмэх", "Доор нь мөр нэмэх", "Хүснэгт устгах", "Мөр устгах", "Багана устгах", "Нүд цэвэрлэх", "Эх үүсвэр", "Тод", "Налуу", "Будах", "Холбоос", "Буцаах", "Дахих", "Хүснэгт", "Зураг", "Баллуур", "Параграф", "Фонтын хэмжээ", "Видео", "Фонт", "Тухай", "Хэвлэх", "Доогуур зураас", "Дээгүүр зураас", "Догол нэмэх", "Догол багасгах", "Бүтэн дэлгэц", "Багасга", "Хаалт", "Тэмдэгт жагсаалт", "Дугаарласан жагсаалт", "Таслах", "Бүгдийг сонго", "Код оруулах", "Холбоос нээх", "Холбоос засах", "Nofollow özelliği", "Холбоос салгах", "Нүд", "Засах", "Шинэчлэх", "URL", "Засах", "Хэвтээ эгнүүлэх", "Шүүх", "Сүүлд өөрчлөгдсөнөөр жагсаах", "Нэрээр жагсаах", "Хэмжээгээр жагсаах", "Хавтас нэмэх", "Буцаах", "Хадгалах", "Өөрөөр хадгалах", "Хэмжээг өөрчил", "Тайрах", "Өргөн", "Өндөр", "Харьцааг хадгал", "Тийм", "Үгүй", "Арилга", "Сонго", "Тэмдэгт: %d", "Үг: %d", "Бүгдийг", "Сонго: %s", "Бүгдийг сонго", "Босоо эгнүүлэх", "Задлах", "Баганаар задлах", "Мөрөөр задлах", "Нэгтгэх", "Багана нэмэх", "Мөр нэмэх", "Устгах", "Хүрээ", null, "Дээгүүр зураас", "Доогуур зураас", "Дээд индекс", "Доод индекс", "Сонголтыг таслах", "Мөрийг таслах", "Хайх", "Үүгээр солих", "Солих", "Буулгах", "Буулгах агуулгаа сонгоно уу", "Та зөвхөн өөрийн зургуудаа янзлах боломжтой. Энэ зургийг өөр лүүгээ татмаар байна уу?", "Зургийг хост руу амжилттай хадгалсан", "Палет", "Энд ямар нэг файл алга", "Шинээр нэрлэх", "Шинэ нэр оруулна уу", "Урьдчилан харах", "Татах", "Самбараас хуулах ", "Энэ вэб хөтчөөс самбарт хандах эрх алга.", "Сонголтыг хуул", "Хуулах", "Хүрээний радиус", "Бүгдийг харуулах", "Хэрэгжүүл", "Энэ талбарыг бөглөнө үү", "Вэб хаягаа оруулна уу", "Үндсэн", "Дугуй", "Цэг", "Дөрвөлжин", "Хайх", "Өмнөхийг ол", "Дараагийнхийг ол", "Бүлгийн нэрээ оруулна уу", "Хэмжээсийг шинээр өөчрлөхийн тулд Alt товчин дээр дарна уу"];
          },
          17084: function (e) {
            e.exports.default = ["Begin met typen..", "Over Jodit", "Jodit Editor", "Gratis niet-commerciële versie", "Jodit gebruikershandleiding", "bevat gedetailleerde informatie voor gebruik.", "Voor informatie over de licentie, ga naar onze website:", "Volledige versie kopen", "Copyright © XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.", "Anker", "Open in nieuwe tab", "Editor in volledig scherm openen", "Opmaak verwijderen", "Vulkleur of tekstkleur aanpassen", "Opnieuw", "Ongedaan maken", "Vet", "Cursief", "Geordende list invoegen", "Ongeordende lijst invoegen", "Centreren", "Uitlijnen op volledige breedte", "Links uitlijnen", "Rechts uitlijnen", "Horizontale lijn invoegen", "Afbeelding invoegen", "Bestand invoegen", "Youtube/Vimeo video invoegen", "Link toevoegen", "Tekstgrootte", "Lettertype", "Format blok invoegen", "Normaal", "Koptekst 1", "Koptekst 2", "Koptekst 3", "Koptekst 4", "Citaat", "Code", "Invoegen", "Tabel invoegen", "Inspringing verkleinen", "Inspringing vergroten", "Symbool selecteren", "Symbool invoegen", "Opmaak kopieren", "Modus veranderen", "Marges", "Boven", "Rechts", "Onder", "Links", "CSS styles", "CSS classes", "Uitlijning", "Rechts", "Gecentreerd", "Links", "--Leeg--", "Src", "Titel", "Alternatieve tekst", "Link", "Link in nieuwe tab openen", "Afbeelding", "Bestand", "Geavanceerd", "Afbeeldingseigenschappen", "Annuleren", "OK", "Deze code lijkt op HTML. Als HTML behouden?", "Invoegen als HTML", "Origineel behouden", "Opschonen", "Als tekst invoegen", "Als onopgemaakte tekst invoegen", "Word-tekst gedetecteerd", "De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?", "Bestandsbrowser", "Fout bij het laden van de lijst", "Fout bij het laden van de mappenlijst", "Weet je het zeker?", "Geef de map een naam", "Map aanmaken", "Type naam", "Sleep hier een afbeelding naartoe", "Sleep hier een bestand naartoe", "of klik", "Alternatieve tekst", "Bladeren", "Uploaden", "Achtergrond", "Tekst", "Boven", "Midden", "Onder", "Kolom invoegen (voor)", "Kolom invoegen (na)", "Rij invoegen (boven)", "Rij invoegen (onder)", "Tabel verwijderen", "Rij verwijderen", "Kolom verwijderen", "Cel leegmaken", "Broncode", "vet", "cursief", "kwast", "link", "ongedaan maken", "opnieuw", "tabel", "afbeelding", "gum", "paragraaf", "lettergrootte", "video", "lettertype", "over", "afdrukken", "onderstreept", "doorgestreept", "inspringen", "minder inspringen", "volledige grootte", "kleiner maken", "horizontale lijn", "lijst", "genummerde lijst", "knip", "alles selecteren", "Embed code", "link openen", "link aanpassen", "niet volgen", "link verwijderen", "Recensie", "Om te bewerken", "Updaten", " URL", "Bewerken", "Horizontaal uitlijnen", "Filteren", "Sorteren op wijzigingsdatum", "Sorteren op naam", "Sorteren op grootte", "Map toevoegen", "Herstellen", "Opslaan", "Opslaan als ...", "Grootte aanpassen", "Bijknippen", "Breedte", "Hoogte", "Verhouding behouden", "Ja", "Nee", "Verwijderen", "Selecteren", "Tekens: %d", "Woorden: %d", "Alles", "Selecteer: %s", "Selecteer alles", "Verticaal uitlijnen", "Splitsen", "Verticaal splitsen", "Horizontaal splitsen", "Samenvoegen", "Kolom toevoegen", "Rij toevoegen", "Verwijderen", "Rand", null, "Doorstrepen", "Onderstrepen", "Superscript", "Subscript", "Selectie knippen", "Enter", "Zoek naar", "Vervangen door", "Vervangen", "Plakken", "Kies content om te plakken", "Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?", "De afbeelding is succesvol geüploadet!", "Palette", "Er zijn geen bestanden in deze map.", "Hongaars", "Voer een nieuwe naam in", "voorvertoning", "Download", "Plakken van klembord", "Uw browser ondersteunt geen directe toegang tot het klembord.", "Selectie kopiëren", "kopiëren", "Border radius", "Toon alle", "Toepassing", "Vul dit veld", "Voer een webadres", "Standaard", "Cirkel", "Dot", "Quadrate", "Zoeken", "Vorige Zoeken", "Volgende Zoeken", "Voeg de klassenaam in", "Druk op Alt voor aangepaste grootte"];
          },
          96891: function (e) {
            e.exports.default = ["Napisz coś", "O Jodit", "Edytor Jodit", null, "Instrukcja Jodit", "zawiera szczegółowe informacje dotyczące użytkowania.", "Odwiedź naszą stronę, aby uzyskać więcej informacji na temat licencji:", "Zakup pełnej wersji", "Copyright © XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrzeżone.", "Kotwica", "Otwórz w nowej zakładce", "Otwórz edytor w pełnym rozmiarze", "Wyczyść formatowanie", "Kolor wypełnienia lub ustaw kolor tekstu", "Ponów", "Cofnij", "Pogrubienie", "Kursywa", "Wstaw listę wypunktowaną", "Wstaw listę numeryczną", "Wyśrodkuj", "Wyjustuj", "Wyrównaj do lewej", "Wyrównaj do prawej", "Wstaw linię poziomą", "Wstaw grafikę", "Wstaw plik", "Wstaw film Youtube/vimeo", "Wstaw link", "Rozmiar tekstu", "Krój czcionki", "Wstaw formatowanie", "Normalne", "Nagłówek 1", "Nagłówek 2", "Nagłówek 3", "Nagłówek 4", "Cytat", "Kod", "Wstaw", "Wstaw tabelę", "Zmniejsz wcięcie", "Zwiększ wcięcie", "Wybierz znak specjalny", "Wstaw znak specjalny", "Malarz formatów", "Zmień tryb", "Marginesy", "Górny", "Prawy", "Dolny", "Levy", "Style CSS", "Klasy CSS", "Wyrównanie", "Prawa", "środek", "Lewa", "brak", "Źródło", "Tytuł", "Tekst alternatywny", "Link", "Otwórz w nowej zakładce", "Grafika", "Plik", "Zaawansowane", "Właściwości grafiki", "Anuluj", "OK", "Twój kod wygląda jak HTML. Zachować HTML?", "Wkleić jako HTML?", "Oryginalny tekst", "Wyczyść", "Wstaw jako tekst", "Wstaw tylko treść", "Wykryto tekst w formacie Word", "Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachować ten format czy wyczyścić go? ", "Przeglądarka plików", "Błąd ładowania listy plików", "Błąd ładowania folderów", "Czy jesteś pewien?", "Wprowadź nazwę folderu", "Utwórz folder", "wprowadź nazwę", "Upuść plik graficzny", "Upuść plik", "lub kliknij tu", "Tekst alternatywny", "Przeglądaj", "Wczytaj", "Tło", "Treść", "Góra", "Środek", "Dół", "Wstaw kolumnę przed", "Wstaw kolumnę po", "Wstaw wiersz przed", "Wstaw wiersz po", "Usuń tabelę", "Usuń wiersz", "Usuń kolumnę", "Wyczyść komórkę", "HTML", "pogrubienie", "kursywa", "pędzel", "link", "cofnij", "ponów", "tabela", "grafika", "wyczyść", "akapit", "rozmiar czcionki", "wideo", "czcionka", "O programie", "drukuj", "podkreślenie", "przekreślenie", "wcięcie", "wycięcie", "pełen rozmiar", "przytnij", "linia pozioma", "lista", "lista numerowana", "wytnij", "zaznacz wszystko", "Wstaw kod", "otwórz link", "edytuj link", "Atrybut no-follow", "Usuń link", "szukaj", "edytuj", "Aktualizuj", "URL", "Edytuj", "Wyrównywanie w poziomie", "Filtruj", "Sortuj wg zmiany", "Sortuj wg nazwy", "Sortuj wg rozmiaru", "Dodaj folder", "wyczyść", "zapisz", "zapisz jako", "Zmień rozmiar", "Przytnij", "Szerokość", "Wysokość", "Zachowaj proporcje", "Tak", "Nie", "Usuń", "Wybierz", "Znaki: %d", "Słowa: %d", "Wszystko", "Wybierz: %s", "Wybierz wszystko", "Wyrównywanie w pionie", "Podziel", "Podziel w pionie", "Podziel w poziomie", "Scal", "Dodaj kolumnę", "Dodaj wiersz", "Usuń", "Obramowanie", null, "Przekreślenie", "Podkreślenie", "indeks górny", "index dolny", "Wytnij zaznaczenie", "Przerwa", "Szukaj", "Zamień na", "Wymienić", "Wklej", "Wybierz zawartość do wklejenia", "Możesz edytować tylko swoje grafiki. Czy chcesz pobrać tą grafikę?", "Grafika została pomyślnienie dodana na serwer", "Paleta", "Brak plików.", "zmień nazwę", "Wprowadź nową nazwę", "podgląd", "pobierz", "Wklej ze schowka", "Twoja przeglądarka nie obsługuje schowka", "Kopiuj zaznaczenie", "kopiuj", "Zaokrąglenie krawędzi", "Pokaż wszystkie", "Zastosuj", "Proszę wypełnić to pole", "Proszę, wpisz adres sieci web", "Domyślnie", "Koło", "Punkt", "Kwadrat", "Znaleźć", "Znaleźć Poprzednie", "Znajdź Dalej", "Wstaw nazwę zajęć", "Naciśnij Alt, aby zmienić rozmiar"];
          },
          31211: function (e) {
            e.exports.default = ["Escreva algo...", "Sobre o Jodit", "Editor Jodit", null, "Guia de usuário Jodit", "contém ajuda detalhada para o uso.", "Para informação sobre a licença, por favor visite nosso site:", "Compre a versão completa", "Copyright © XDSoft.net - Chupurnov Valeriy. Todos os direitos reservados.", "Link", "Abrir em nova aba", "Abrir editor em tela cheia", "Limpar formatação", "Cor de preenchimento ou cor do texto", "Refazer", "Desfazer", "Negrito", "Itálico", "Inserir lista não ordenada", "Inserir lista ordenada", "Centralizar", "Justificar", "Alinhar à Esquerda", "Alinhar à Direita", "Inserir linha horizontal", "Inserir imagem", "Inserir arquivo", "Inserir vídeo do Youtube/vimeo", "Inserir link", "Tamanho da letra", "Fonte", "Inserir bloco", "Normal", "Cabeçalho 1", "Cabeçalho 2", "Cabeçalho 3", "Cabeçalho 4", "Citação", "Código", "Inserir", "Inserir tabela", "Diminuir recuo", "Aumentar recuo", "Selecionar caractere especial", "Inserir caractere especial", "Copiar formato", "Mudar modo", "Margens", "cima", "direta", "baixo", "esquerda", "Estilos CSS", "Classes CSS", "Alinhamento", "Direita", "Centro", "Esquerda", "--Não Estabelecido--", "Fonte", "Título", "Texto Alternativo", "Link", "Abrir link em nova aba", "Imagem", "Arquivo", "Avançado", "Propriedades da imagem", "Cancelar", "Ok", "Seu código é similar ao HTML. Manter como HTML?", "Colar como HTML?", "Manter", "Limpar", "Inserir como Texto", "Inserir somente o Texto", "Colado do Word Detectado", "O conteúdo colado veio de um documento Microsoft Word/Excel. Você deseja manter o formato ou limpa-lo?", "Procurar arquivo", "Erro ao carregar a lista", "Erro ao carregar as pastas", "Você tem certeza?", "Escreva o nome da pasta", "Criar pasta", "Escreva seu nome", "Soltar imagem", "Soltar arquivo", "ou clique", "Texto alternativo", "Explorar", "Upload", "Fundo", "Texto", "Cima", "Meio", "Baixo", "Inserir coluna antes", "Inserir coluna depois", "Inserir linha acima", "Inserir linha abaixo", "Excluir tabela", "Excluir linha", "Excluir coluna", "Limpar célula", "HTML", "negrito", "itálico", "pincel", "link", "desfazer", "refazer", "tabela", "imagem", "apagar", "parágrafo", "tamanho da letra", "vídeo", "fonte", "Sobre de", "Imprimir", "sublinhar", "tachado", "recuar", "diminuir recuo", "Tamanho completo", "diminuir", "linha horizontal", "lista não ordenada", "lista ordenada", "Cortar", "Selecionar tudo", "Incluir código", "Abrir link", "Editar link", "Não siga", "Remover link", "Visualizar", "Editar", "Atualizar", "URL", "Editar", "Alinhamento horizontal", "filtrar", "Ordenar por modificação", "Ordenar por nome", "Ordenar por tamanho", "Adicionar pasta", "Resetar", "Salvar", "Salvar como...", "Redimensionar", "Recortar", "Largura", "Altura", "Manter a proporção", "Sim", "Não", "Remover", "Selecionar", "Caracteres: %d", "Palavras: %d", "Tudo", "Selecionar: %s", "Selecionar tudo", "Alinhamento vertical", "Dividir", "Dividir vertical", "Dividir horizontal", "Mesclar", "Adicionar coluna", "Adicionar linha", "Excluir", "Borda", null, "Tachado", "Sublinhar", "sobrescrito", "subscrito", "Cortar seleção", "Pausa", "Procurar por", "Substituir com", "Substituir", "Colar", "Escolher conteúdo para colar", "Você só pode editar suas próprias imagens. Baixar essa imagem pro servidor?", "A imagem foi enviada com sucesso para o servidor!", "Palette", "Não há arquivos nesse diretório.", "Húngara", "Digite um novo nome", "preview", "Baixar", "Colar da área de transferência", "O seu navegador não oferece suporte a acesso direto para a área de transferência.", "Selecção de cópia", "cópia", "Border radius", "Mostrar todos os", "Aplicar", "Por favor, preencha este campo", "Por favor introduza um endereço web", "Padrão", "Círculo", "Ponto", "Quadro", "Encontrar", "Encontrar Anteriores", "Localizar Próxima", "Insira o nome da classe", "Pressione Alt para redimensionamento personalizado"];
          },
          31109: function (e) {
            e.exports.default = ["Напишите что-либо", "О Jodit", "Редактор Jodit", null, "Jodit Руководство пользователя", "содержит детальную информацию по использованию", "Для получения сведений о лицензии , пожалуйста, перейдите на наш сайт:", "Купить полную версию", "Авторские права © XDSoft.net - Чупурнов Валерий. Все права защищены.", "Анкор", "Открывать ссылку в новой вкладке", "Открыть редактор в полном размере", "Очистить форматирование", "Цвет заливки или цвет текста", "Повтор", "Отмена", "Жирный", "Наклонный", "Вставка маркированного списка", "Вставить нумерованный список", "Выровнять по центру", "Выровнять по ширине", "Выровнять по левому краю", "Выровнять по правому краю", "Вставить горизонтальную линию", "Вставить изображение", "Вставить файл", "Вставьте видео", "Вставить ссылку", "Размер шрифта", "Шрифт", "Вставить блочный элемент", "Нормальный текст", "Заголовок 1", "Заголовок 2", "Заголовок 3", "Заголовок 4", "Цитата", "Код", "Вставить", "Вставить таблицу", "Уменьшить отступ", "Увеличить отступ", "Выберите специальный символ", "Вставить специальный символ", "Формат краски", "Источник", "Отступы", "сверху", "справа", "снизу", "слева", "Стили", "Классы", "Выравнивание", "По правому краю", "По центру", "По левому краю", "--не устанавливать--", "src", "Заголовок", "Альтернативный текст (alt)", "Ссылка", "Открывать ссылку в новом окне", null, "Файл", "Расширенные", "Свойства изображения", "Отмена", "Ок", "Ваш текст, который вы пытаетесь вставить похож на HTML. Вставить его как HTML?", "Вставить как HTML?", "Сохранить оригинал", "Почистить", "Вставить как текст", "Вставить только текст", "Возможно это фрагмент Word или Excel", "Контент который вы вставляете поступает из документа Microsoft Word / Excel. Вы хотите сохранить формат или очистить его?", "Браузер файлов", "Ошибка при загрузке списка изображений", "Ошибка при загрузке списка директорий", "Вы уверены?", "Введите название директории", "Создать директорию", "введите название", "Перетащите сюда изображение", "Перетащите сюда файл", "или нажмите", "Альтернативный текст", "Сервер", "Загрузка", "Фон", "Текст", " К верху", "По середине", "К низу", "Вставить столбец до", "Вставить столбец после", "Вставить ряд выше", "Вставить ряд ниже", "Удалить таблицу", "Удалять ряд", "Удалить столбец", "Очистить ячейку", "HTML", "жирный", "курсив", "заливка", "ссылка", "отменить", "повторить", "таблица", "Изображение", "очистить", "параграф", "размер шрифта", "видео", "шрифт", "о редакторе", "печать", "подчеркнутый", "перечеркнутый", "отступ", "выступ", "во весь экран", "обычный размер", "линия", "Список", "Нумерованный список", "Вырезать", "Выделить все", "Код", "Открыть ссылку", "Редактировать ссылку", "Атрибут nofollow", "Убрать ссылку", "Просмотр", "Редактировать", "Обновить", "URL", "Редактировать", "Горизонтальное выравнивание", "Фильтр", "По изменению", "По имени", "По размеру", "Добавить папку", "Восстановить", "Сохранить", "Сохранить как", "Изменить размер", "Обрезать размер", "Ширина", "Высота", "Сохранять пропорции", "Да", "Нет", "Удалить", "Выделить", "Символов: %d", "Слов: %d", "Выделить все", "Выделить: %s", "Выделить все", "Вертикальное выравнивание", "Разделить", "Разделить по вертикали", "Разделить по горизонтали", "Объединить в одну", "Добавить столбец", "Добавить строку", "Удалить", "Рамка", "Лицензия: %s", "Перечеркнуть", "Подчеркивание", "верхний индекс", "индекс", "Вырезать", "Разделитель", "Найти", "Заменить на", "Заменить", "Вставить", "Выбрать контент для вставки", "Вы можете редактировать только свои собственные изображения. Загрузить это изображение на ваш сервер?", "Изображение успешно загружено на сервер!", "палитра", "В данном каталоге нет файлов", "Переименовать", "Введите новое имя", "Предпросмотр", "Скачать", "Вставить из буфера обмена", "Ваш браузер не поддерживает прямой доступ к буферу обмена.", "Скопировать выделенное", "копия", "Радиус границы", "Показать все", "Применить", "Пожалуйста, заполните это поле", "Пожалуйста, введите веб-адрес", "По умолчанию", "Круг", "Точка", "Квадрат", "Найти", "Найти Предыдущие", "Найти Далее", "Вставить название класса", "Нажмите Alt для изменения пользовательского размера"];
          },
          79375: function (e) {
            e.exports.default = ["Bir şeyler yaz", "Jodit Hakkında", "Jodit Editor", null, "Jodit Kullanım Kılavuzu", "kullanım için detaylı bilgiler içerir", "Lisans hakkında bilgi için lütfen web sitemize gidin:", "Tam versiyonunu satın al", "Copyright © XDSoft.net - Chupurnov Valeriy. Tüm hakları saklıdır.", "Bağlantı", "Yeni sekmede aç", "Editörü tam ekranda aç", "Stili temizle", "Renk doldur veya yazı rengi seç", "Yinele", "Geri Al", "Kalın", "İtalik", "Sırasız Liste Ekle", "Sıralı Liste Ekle", "Ortala", "Kenarlara Yasla", "Sola Yasla", "Sağa Yasla", "Yatay Çizgi Ekle", "Resim Ekle", "Dosya Ekle", "Youtube/Vimeo Videosu Ekle", "Bağlantı Ekle", "Font Boyutu", "Font Ailesi", "Blok Ekle", "Normal", "Başlık 1", "Başlık 2", "Başlık 3", "Başlık 4", "Alıntı", "Kod", "Ekle", "Tablo Ekle", "Girintiyi Azalt", "Girintiyi Arttır", "Özel Karakter Seç", "Özel Karakter Ekle", "Resim Biçimi", "Mod Değiştir", "Boşluklar", "Üst", "Sağ", "Alt", "Sol", "CSS Stilleri", "CSS Sınıfları", "Hizalama", "Sağ", "Ortalı", "Sol", "Belirsiz", "Kaynak", "Başlık", "Alternatif Yazı", "Link", "Bağlantıyı yeni sekmede aç", "Resim", "Dosya", "Gelişmiş", "Resim özellikleri", "İptal", "Tamam", "Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?", "HTML olarak yapıştır", "Sakla", "Temizle", "Yazı olarak ekle", "Sadece yazıyı ekle", "Word biçiminde yapıştırma algılandı", "Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder löschen?", "Dosya Listeleyici", "Liste yüklenirken hata oluştu", "Klasörler yüklenirken hata oluştur", "Emin misiniz?", "Dizin yolu giriniz", "Dizin oluştur", "İsim yaz", "Resim bırak", "Dosya bırak", "veya tıkla", "Alternatif yazı", "Gözat", "Yükle", "Arka plan", "Yazı", "Üst", "Orta", "Aşağı", "Öncesine kolon ekle", "Sonrasına kolon ekle", "Üstüne satır ekle", "Altına satır ekle", "Tabloyu sil", "Satırı sil", "Kolonu sil", "Hücreyi temizle", "Kaynak", "Kalın", "italik", "Fırça", "Bağlantı", "Geri al", "Yinele", "Tablo", "Resim", "Silgi", "Paragraf", "Font boyutu", "Video", "Font", "Hakkında", "Yazdır", "Alt çizgi", "Üstü çizili", "Girinti", "Çıkıntı", "Tam ekran", "Küçült", "Ayraç", "Sırasız liste", "Sıralı liste", "Kes", "Tümünü seç", "Kod ekle", "Bağlantıyı aç", "Bağlantıyı düzenle", "Nofollow özelliği", "Bağlantıyı kaldır", "Yorumu", "Düzenlemek için", "Güncelle", "URL", "Düzenle", "Yatay hizala", "Filtre", "Değişime göre sırala", "İsme göre sırala", "Boyuta göre sırala", "Klasör ekle", "Sıfırla", "Kaydet", "Farklı kaydet", "Boyutlandır", "Kırp", "Genişlik", "Yükseklik", "En boy oranını koru", "Evet", "Hayır", "Sil", "Seç", "Harfler: %d", "Kelimeler: %d", "Tümü", "Seç: %s", "Tümünü seç", "Dikey hizala", "Ayır", "Dikey ayır", "Yatay ayır", "Birleştir", "Kolon ekle", "Satır ekle", "Sil", "Kenarlık", null, "Üstü çizili", "Alt çizgi", "Üst yazı", "Alt yazı", "Seçilimi kes", "Satır sonu", "Ara", "Şununla değiştir", "Değiştir", "Yapıştır", "Yapıştırılacak içerik seç", "Sadece kendi resimlerinizi düzenleyebilirsiniz. Bu görseli kendi hostunuza indirmek ister misiniz?", "Görsel başarıyla hostunuza yüklendi", "Palet", "Bu dizinde dosya yok", "Yeniden isimlendir", "Yeni isim girin", "Ön izleme", "İndir", "Panodan yapıştır ", "Tarayıcınız panoya doğrudan erişimi desteklemiyor.", "Seçimi kopyala", "Kopyala", "Sınır yarıçapı", "Tümünü Göster", "Uygula", "Lütfen bu alanı doldurun", "Lütfen bir web adresi girin", "Varsayılan", "Daire", "Nokta", "Kare", "Bul", "Öncekini Bul", "Sonrakini Bul", "Sınıf adı girin", "Özel yeniden boyutlandırma için Alt tuşuna basın"];
          },
          21042: function (e) {
            e.exports.default = ["输入一些内容", "关于Jodit", "Jodit Editor", "Free Non-commercial Version", "开发者指南", "使用帮助", "有关许可证的信息，请访问我们的网站：", "购买完整版本", "Copyright © XDSoft.net - Chupurnov Valeriy. 版权所有", "Anchor", "在新窗口打开", "全屏编辑", "清除样式", "颜色", "重做", "撤销", "粗体", "斜体", "符号列表", "编号", "居中", "对齐文本", "左对齐", "右对齐", "分割线", "图片", "文件", "视频", "链接", "字号", "字体", "格式块", "默认", "标题1", "标题2", "标题3", "标题4", "引用", "代码", "插入", "表格", "减少缩进", "增加缩进", "选择特殊符号", "特殊符号", "格式复制", "改变模式", "外边距（Margins）", "top", "right", "bottom", "left", "样式", "Classes", "对齐方式", "居右", "居中", "居左", "无", "Src", "Title", "Alternative", "Link", "在新窗口打开链接", "图片", "file", "高级", "图片属性", "取消", "确定", "你粘贴的文本是一段html代码，是否保留源格式", "html粘贴", "保留源格式", "匹配目标格式", "把html代码视为普通文本", "只保留文本", "文本粘贴", "正在粘贴 Word/Excel 的文本，是否保留源格式？", "文件管理", "加载list错误", "加载folders错误", "你确定吗？", "输入路径", "创建路径", "type name", "拖动图片到此", "拖动文件到此", "或点击", "Alternative text", "浏览", "上传", "背景色", "文字", "顶部", "中间", "底部", "在之前插入列", "在之后插入列", "在之前插入行", "在之后插入行", "删除表格", "删除行", "删除列", "清除内容", "源码", "粗体", "斜体", "颜色", "链接", "撤销", "重做", "表格", "图片", "橡皮擦", "段落", "字号", "视频", "字体", "关于", "打印", "下划线", "上出现", "增加缩进", "减少缩进", "全屏", "收缩", "分割线", "无序列表", "顺序列表", "剪切", "全选", "嵌入代码", "打开链接", "编辑链接", "No follow", "取消链接", "预览", "铅笔", "更新", "URL", "编辑", "水平对齐", "筛选", "修改时间排序", "名称排序", "大小排序", "新建文件夹", "重置", "保存", "保存为", "调整大小", "剪切", "宽", "高", "保持长宽比", "是", "不", "移除", "选择", "字符数: %d", "单词数: %d", "全部", "选择: %s", "全选", "垂直对齐", "拆分", "垂直拆分", "水平拆分", "合并", "添加列", "添加行", "删除", "边框", null, "删除线", "下划线", "上标", "下标", "剪切", "Break", "查找", "替换为", "替换", "粘贴", "选择内容并粘贴", "你只能编辑你自己的图片。Download this image on the host?", "图片上传成功", "调色板", "此目录中沒有文件。", "重命名", "输入新名称", "预览", "下载", "粘贴从剪贴板", "你浏览器不支持直接访问的剪贴板。", "复制选中内容", "复制", "边界半径", "显示所有", "应用", "请填写这个字段", "请输入一个网址", "默认", "圆圈", "点", "方形", "搜索", "查找上一个", "查找下一个", "插入班级名称", "按Alt自定义调整大小"];
          },
          73895: function (e) {
            e.exports.default = ["輸入一些內容", "關於Jodit", "Jodit Editor", null, "開發者指南", "使用幫助", "有關許可證的信息，請訪問我們的網站：", "購買完整版本", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.", "Anchor", "在新窗口打開", "全屏編輯", "清除樣式", "顏色", "重做", "撤銷", "粗體", "斜體", "符號列表", "編號", "居中", "對齊文本", "左對齊", "右對齊", "分割線", "圖片", "文件", "youtube/vimeo 影片", "鏈接", "字號", "字體", "格式塊", "文本", "標題1", "標題2", "標題3", "標題4", "引用", "代碼", "插入", "表格", "減少縮進", "增加縮進", "選擇特殊符號", "特殊符號", "格式複製", "改變模式", "外邊距（Margins）", "top", "right", "bottom", "left", "樣式", "Classes", "對齊方式", "居右", "居中", "居左", "無", "Src", "Title", "替代", "Link", "在新窗口打開鏈接", "圖片", "file", "高級", "圖片屬性", "取消", "確定", "你黏貼的文本是一段html代碼，是否保留源格式", "html黏貼", "保留源格式", "匹配目標格式", "把html代碼視為普通文本", "只保留文本", "文本黏貼", "正在黏貼 Word/Excel 的文本，是否保留源格式？", "文件管理", "加載list錯誤", "加載folders錯誤", "你確定嗎？", "輸入路徑", "創建路徑", "type name", "拖動圖片到此", "拖動文件到此", "或點擊", "替代文字", "瀏覽", "上傳", "背景色", "文字", "頂部", "中間", "底部", "在之前插入列", "在之後插入列", "在之前插入行", "在之後插入行", "刪除表格", "刪除行", "刪除列", "清除內容", "源碼", "粗體", "斜體", "顏色", "鏈接", "撤銷", "重做", "表格", "圖片", "橡皮擦", "段落", "字號", "影片", "字體", "關於", "打印", "下劃線", "上出現", "增加縮進", "減少縮進", "全屏", "收縮", "分割線", "無序列表", "順序列表", "剪切", "全選", "嵌入代碼", "打開鏈接", "編輯鏈接", "No follow", "取消連結", "回顧", "鉛筆", "更新", "URL", null, "水平對齊", "篩選", "修改時間排序", "名稱排序", "大小排序", "新建文件夾", "重置", "保存", "保存為", "調整大小", "Crop", "寬", "高", "保存長寬比", "是", "不", "移除", "選擇", "字符數: %d", "單詞數: %d", "全部", "選擇: %s", "全選", "垂直對齊", "拆分", "垂直拆分", "水平拆分", "合併", "添加列", "添加行", "刪除", "邊框", null, "刪除線", "下劃線", "上標", "下標", "剪切", "Pause", "查找", "替換為", "แทนที่", "黏貼", "選擇內容並黏貼", "你只能編輯你自己的圖片。是否下載此圖片到本地?", "圖片上傳成功", "調色板", "此目錄中沒有文件。", "重命名", "輸入新名稱", "預覽", "下載", "從剪貼板貼上", "瀏覽器無法存取剪贴板。", "複製已選取項目", "複製", "邊框圓角", "顯示所有", "應用", "ได้โปรดกรอกช่องข้อมูลนี้", "โปรดเติมที่อยู่บนเว็บ", "ค่าปริยาย", "วงกลม", "จุด", "Quadrate", "ค้นหา", "ค้นหาก่อนหน้านี้", "ค้นหาถัดไป", "ใส่ชื่อคลาส", "กดอัลท์สำหรับการปรับขนาดที่กำหนดเอง"];
          },
          3610: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"/> </svg>';
          },
          56170: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <g transform="translate(-251.000000, -443.000000)"> <g transform="translate(215.000000, 119.000000)"/> <path d="M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z"/> </g> </svg>';
          },
          95331: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' x="0px" y="0px" viewBox="0 0 459 459"> <g> <path d="M229.5,0C102,0,0,102,0,229.5S102,459,229.5,459c20.4,0,38.25-17.85,38.25-38.25c0-10.2-2.55-17.85-10.2-25.5 c-5.1-7.65-10.2-15.3-10.2-25.5c0-20.4,17.851-38.25,38.25-38.25h45.9c71.4,0,127.5-56.1,127.5-127.5C459,91.8,357,0,229.5,0z M89.25,229.5c-20.4,0-38.25-17.85-38.25-38.25S68.85,153,89.25,153s38.25,17.85,38.25,38.25S109.65,229.5,89.25,229.5z M165.75,127.5c-20.4,0-38.25-17.85-38.25-38.25S145.35,51,165.75,51S204,68.85,204,89.25S186.15,127.5,165.75,127.5z M293.25,127.5c-20.4,0-38.25-17.85-38.25-38.25S272.85,51,293.25,51s38.25,17.85,38.25,38.25S313.65,127.5,293.25,127.5z M369.75,229.5c-20.4,0-38.25-17.85-38.25-38.25S349.35,153,369.75,153S408,170.85,408,191.25S390.15,229.5,369.75,229.5z" /> </g> </svg>';
          },
          84279: function (e) {
            e.exports = '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"> <path d="M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"/> </svg>';
          },
          11257: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 128 128" xml:space="preserve"> <polygon points="112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125"/> </svg>';
          },
          25141: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/> </svg>';
          },
          24557: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/> </svg>';
          },
          10859: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"/> </svg>';
          },
          9813: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm639 217v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"/> </svg>';
          },
          93395: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm637-679v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"/> </svg>';
          },
          98213: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/> </svg>';
          },
          20026: function (e) {
            e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M36 4h-24c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 4h10v16l-5-3-5 3v-16z"/> </svg>';
          },
          66911: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/> </svg>';
          },
          50018: function (e) {
            e.exports = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89,6.61H22.31V4.47A2.47,2.47,0,0,0,19.84,2H6.78A2.47,2.47,0,0,0,4.31,4.47V22.92a2.47,2.47,0,0,0,2.47,2.47H9.69V27.2a2.8,2.8,0,0,0,2.8,2.8h12.4a2.8,2.8,0,0,0,2.8-2.8V9.41A2.8,2.8,0,0,0,24.89,6.61ZM6.78,23.52a.61.61,0,0,1-.61-.6V4.47a.61.61,0,0,1,.61-.6H19.84a.61.61,0,0,1,.61.6V6.61h-8a2.8,2.8,0,0,0-2.8,2.8V23.52Zm19,3.68a.94.94,0,0,1-.94.93H12.49a.94.94,0,0,1-.94-.93V9.41a.94.94,0,0,1,.94-.93h12.4a.94.94,0,0,1,.94.93Z"/> <path d="M23.49,13.53h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,17.37h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,21.22h-9.6a.93.93,0,1,0,0,1.86h9.6a.93.93,0,1,0,0-1.86Z"/> </svg>';
          },
          99738: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zm300 64l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zm-681-260q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zm-85 745q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zm178-613l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zm224 224l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zm704 416l128-64-520-408-177 138q-2 3-13 7z"/> </svg>';
          },
          9185: function (e) {
            e.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> <path stroke-width="0" d="M10.5 20H2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1V3l2.03-.4a3 3 0 0 1 5.94 0L13 3v1h1a2 2 0 0 1 2 2v1h-2V6h-1v1H3V6H2v12h5v2h3.5zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2 4h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm0 2v8h8v-8h-8z"/> </svg>';
          },
          8619: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 18 18"> <g fill-rule="evenodd" stroke="none" stroke-width="1"> <g transform="translate(-381.000000, -381.000000)"> <g transform="translate(381.000000, 381.000000)"> <path d="M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z"/> </g> </g> </g> </svg>';
          },
          73894: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"/> </svg>';
          },
          83301: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 16 16"> <path stroke-width="0" d="M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"/> </svg>';
          },
          84142: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"/> </svg>';
          },
          57292: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"/> </svg>';
          },
          18019: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"/></svg>';
          },
          45146: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <path stroke-width="0" d="M22,20.6L3.4,2H8V0H0v8h2V3.4L20.6,22H16v2h8v-8h-2V20.6z M16,0v2h4.7l-6.3,6.3l1.4,1.4L22,3.5V8h2V0H16z M8.3,14.3L2,20.6V16H0v8h8v-2H3.5l6.3-6.3L8.3,14.3z"/> </svg>';
          },
          53576: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"/> </svg>';
          },
          14655: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"/> </svg>';
          },
          53477: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/> </svg>';
          },
          90053: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
          },
          72230: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
          },
          78321: function (e) {
            e.exports = '<svg viewBox="0 0 18.151 18.151" xmlns="http://www.w3.org/2000/svg"> <g> <path stroke-width="0" d="M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z"/> <path stroke-width="0" d="M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z"/> <polygon stroke-width="0" points="11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 "/> </g> </svg>';
          },
          77654: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 432 432"> <g> <polygon points="203.688,96 0,96 0,144 155.688,144 "/> <polygon points="155.719,288 0,288 0,336 203.719,336 "/> <path d="M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z"/> <polygon points="232,176 232,96 112,216 232,336 232,256 432,256 432,176"/> </g> </svg>';
          },
          43371: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 312 312"> <g transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z"/> <path d="M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z"/> <path d="M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z"/> <path d="M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z"/> </g> </svg>';
          },
          44563: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
          },
          53183: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
          },
          18548: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"/> </svg>';
          },
          52242: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"/> </svg>';
          },
          87498: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"/> </svg>';
          },
          7986: function (e) {
            e.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path d="M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z"/> <path d="M22.8412 7H8.84119V5H22.8412V7Z"/> <path d="M22.8412 11H8.84119V9H22.8412V11Z"/> <path d="M8.84119 15H22.8412V13H8.84119V15Z"/> <path d="M22.8412 19H8.84119V17H22.8412V19Z"/> </svg>';
          },
          23075: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/> </svg>';
          },
          10655: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"/> </svg>';
          },
          15476: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
          },
          59403: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
          },
          22860: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/> </svg>';
          },
          95600: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"/> </svg>';
          },
          76214: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"/> </svg>';
          },
          41197: function (e) {
            e.exports = '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"> <path clip-rule="evenodd" d="M306.39,154.09c19.628,4.543,35.244,21.259,39.787,39.523 c1.551,8.54,8.998,14.989,17.904,14.989c9.991,0,18.168-8.175,18.168-18.17c0-13.083-10.991-32.98-25.985-47.881 c-14.719-14.537-32.252-24.802-46.695-24.802c-9.991,0-18.172,8.45-18.172,18.446C291.396,145.094,297.847,152.546,306.39,154.09z M56.629,392.312c-14.09,14.08-14.09,36.979,0,51.059c14.08,14.092,36.981,14.092,50.965,0l104.392-104.303 c24.347,15.181,53.062,23.991,83.953,23.991c87.857,0,158.995-71.142,158.995-158.999c0-87.854-71.138-158.995-158.995-158.995 c-87.856,0-158.995,71.141-158.995,158.995c0,30.802,8.819,59.606,23.992,83.953L56.629,392.312z M182.371,204.06 c0-62.687,50.875-113.568,113.568-113.568s113.569,50.881,113.569,113.568c0,62.694-50.876,113.569-113.569,113.569 S182.371,266.754,182.371,204.06z" fill-rule="evenodd"/> </svg>';
          },
          9342: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/> </svg>';
          },
          69546: function (e) {
            e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89 32h4.18L18.86 6h-3.71L4.93 32h4.18l2.25-6h11.29l2.24 6zM12.86 22L17 10.95 21.14 22h-8.28zm30.31 1.17L27 39.34 19.66 32l-2.83 2.83L27 45l19-19-2.83-2.83z"/> </svg>';
          },
          43158: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 270 270"> <path d="m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z"/> </svg>';
          },
          51716: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/> </svg>';
          },
          49222: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"/> </svg>';
          },
          1755: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
          },
          74911: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
          },
          8805: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
          },
          16547: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
          },
          10856: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/> </svg>';
          },
          98441: function (e) {
            e.exports = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"> <g stroke="none" stroke-width="1"> <path d="M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z"/> </g> </svg>';
          },
          52488: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/> </svg>';
          },
          9370: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"/> </svg>';
          },
          66543: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 10 10"> <path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/> </svg>';
          },
          608: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24" > <circle cx="12" cy="12" r="2.2"/> <circle cx="12" cy="5" r="2.2"/> <circle cx="12" cy="19" r="2.2"/> </svg>';
          },
          42840: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"/> </svg>';
          },
          79096: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 512v-472q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"/> </svg>';
          },
          33014: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"/> </svg>';
          },
          91677: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"/> </svg>';
          },
          8259: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
          },
          64467: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/></svg>';
          },
          86934: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 32 32"> <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"/> </svg>';
          },
          76133: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"/></svg>';
          },
          45519: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg>';
          },
          90265: function (e) {
            e.exports = '<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg"> <path d="M5.9814 11.8049C5.59087 11.4144 5.59087 10.7812 5.9814 10.3907L10.224 6.14806C10.6146 5.75754 11.2477 5.75754 11.6383 6.14806C12.0288 6.53859 12.0288 7.17175 11.6383 7.56228L7.39561 11.8049C7.00509 12.1954 6.37192 12.1954 5.9814 11.8049Z"/> <path d="M0.707107 12.0208C0.316582 11.6303 0.316582 10.9971 0.707107 10.6066L10.6066 0.707121C10.9971 0.316597 11.6303 0.316596 12.0208 0.707121C12.4113 1.09764 12.4113 1.73081 12.0208 2.12133L2.12132 12.0208C1.7308 12.4114 1.09763 12.4114 0.707107 12.0208Z"/> </svg>';
          },
          81279: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
          },
          68899: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"/> </svg>';
          },
          70744: function (e) {
            e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path stroke="null" d="m42.276011,26.302547c0.098397,-0.76605 0.172194,-1.54407 0.172194,-2.33406s-0.073797,-1.56801 -0.172194,-2.33406l5.202718,-3.961917c0.467384,-0.359086 0.602679,-1.005441 0.29519,-1.532101l-4.919828,-8.29489c-0.307489,-0.51469 -0.947067,-0.730142 -1.500548,-0.51469l-6.125186,2.405877c-1.266856,-0.945594 -2.656707,-1.747553 -4.157255,-2.357999l-0.922468,-6.343855c-0.110696,-0.562568 -0.614979,-1.005441 -1.229957,-1.005441l-9.839656,0c-0.614979,0 -1.119261,0.442873 -1.217657,1.005441l-0.922468,6.343855c-1.500548,0.610446 -2.890399,1.400436 -4.157255,2.357999l-6.125186,-2.405877c-0.553481,-0.203482 -1.193058,0 -1.500548,0.51469l-4.919828,8.29489c-0.307489,0.51469 -0.172194,1.161045 0.29519,1.532101l5.190419,3.961917c-0.098397,0.76605 -0.172194,1.54407 -0.172194,2.33406s0.073797,1.56801 0.172194,2.33406l-5.190419,3.961917c-0.467384,0.359086 -0.602679,1.005441 -0.29519,1.532101l4.919828,8.29489c0.307489,0.51469 0.947067,0.730142 1.500548,0.51469l6.125186,-2.405877c1.266856,0.945594 2.656707,1.747553 4.157255,2.357999l0.922468,6.343855c0.098397,0.562568 0.602679,1.005441 1.217657,1.005441l9.839656,0c0.614979,0 1.119261,-0.442873 1.217657,-1.005441l0.922468,-6.343855c1.500548,-0.610446 2.890399,-1.400436 4.157255,-2.357999l6.125186,2.405877c0.553481,0.203482 1.193058,0 1.500548,-0.51469l4.919828,-8.29489c0.307489,-0.51469 0.172194,-1.161045 -0.29519,-1.532101l-5.190419,-3.961917zm-18.277162,6.044617c-4.759934,0 -8.609699,-3.746465 -8.609699,-8.378677s3.849766,-8.378677 8.609699,-8.378677s8.609699,3.746465 8.609699,8.378677s-3.849766,8.378677 -8.609699,8.378677z"/> </svg>';
          },
          19201: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"/> </svg>';
          },
          84930: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/> </svg>';
          },
          99704: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"/> </svg>';
          },
          2304: function (e) {
            e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"/> </svg>';
          },
          93330: function (e, t, o) {

            o.r(t);
          },
          45066: function (e, t, o) {

            o.r(t);
          },
          99895: function (e, t, o) {

            o.r(t);
          },
          87682: function (e, t, o) {

            o.r(t);
          },
          50905: function (e, t, o) {

            o.r(t);
          },
          70446: function (e, t, o) {

            o.r(t);
          },
          18984: function (e, t, o) {

            o.r(t);
          },
          4591: function (e, t, o) {

            o.r(t);
          },
          64194: function (e, t, o) {

            o.r(t);
          },
          70375: function (e, t, o) {

            o.r(t);
          },
          90235: function (e, t, o) {

            o.r(t);
          },
          88477: function (e, t, o) {

            o.r(t);
          },
          50197: function (e, t, o) {

            o.r(t);
          },
          39008: function (e, t, o) {

            o.r(t);
          },
          47086: function (e, t, o) {

            o.r(t);
          },
          16462: function (e, t, o) {

            o.r(t);
          },
          40692: function (e, t, o) {

            o.r(t);
          },
          27452: function (e, t, o) {

            o.r(t);
          },
          51422: function (e, t, o) {

            o.r(t);
          },
          62820: function (e, t, o) {

            o.r(t);
          },
          63421: function (e, t, o) {

            o.r(t);
          },
          32115: function (e, t, o) {

            o.r(t);
          },
          53362: function (e, t, o) {

            o.r(t);
          },
          48904: function (e, t, o) {

            o.r(t);
          },
          85796: function (e, t, o) {

            o.r(t);
          },
          28654: function (e, t, o) {

            o.r(t);
          },
          60819: function (e, t, o) {

            o.r(t);
          },
          96410: function (e, t, o) {

            o.r(t);
          },
          33126: function (e, t, o) {

            o.r(t);
          },
          30724: function (e, t, o) {

            o.r(t);
          },
          14320: function (e, t, o) {

            o.r(t);
          },
          9947: function (e, t, o) {

            o.r(t);
          },
          45109: function (e, t, o) {

            o.r(t);
          },
          71708: function (e, t, o) {

            o.r(t);
          },
          51629: function (e, t, o) {

            o.r(t);
          },
          54860: function (e, t, o) {

            o.r(t);
          },
          47818: function (e, t, o) {

            o.r(t);
          },
          6316: function (e, t, o) {

            o.r(t);
          },
          88582: function (e, t, o) {

            o.r(t);
          },
          30962: function (e, t, o) {

            o.r(t);
          },
          68197: function (e, t, o) {

            o.r(t);
          },
          60057: function (e, t, o) {

            o.r(t);
          },
          33393: function (e, t, o) {

            o.r(t);
          },
          51057: function (e, t, o) {

            o.r(t);
          },
          64618: function (e, t, o) {

            o.r(t);
          },
          90176: function (e, t, o) {

            o.r(t);
          },
          91147: function (e, t, o) {

            o.r(t);
          },
          70631: function (e, t) {

            function o(e) {
              return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                return typeof e;
              } : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
              }, o(e);
            }
            function n(e, t, n) {
              var r = n.value;
              if ("function" != typeof r) throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(o(r)));
              var i = !1;
              return {
                configurable: !0,
                get: function () {
                  if (i || this === e.prototype || this.hasOwnProperty(t) || "function" != typeof r) return r;
                  var o = r.bind(this);
                  return i = !0, Object.defineProperty(this, t, {
                    configurable: !0,
                    get: function () {
                      return o;
                    },
                    set: function (e) {
                      r = e, delete this[t];
                    }
                  }), i = !1, o;
                },
                set: function (e) {
                  r = e;
                }
              };
            }
            function r(e) {
              var t;
              return "undefined" != typeof Reflect && "function" == typeof Reflect.ownKeys ? t = Reflect.ownKeys(e.prototype) : (t = Object.getOwnPropertyNames(e.prototype), "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e.prototype)))), t.forEach(function (t) {
                if ("constructor" !== t) {
                  var o = Object.getOwnPropertyDescriptor(e.prototype, t);
                  "function" == typeof o.value && Object.defineProperty(e.prototype, t, n(e, t, o));
                }
              }), e;
            }
            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.boundClass = t.boundMethod = void 0, t.boundMethod = n, t.boundClass = r, t.default = function () {
              return 1 === arguments.length ? r.apply(void 0, arguments) : n.apply(void 0, arguments);
            };
          },
          61227: function () {

            "document" in window.self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function (e) {
              if ("Element" in e) {
                var t = "classList",
                  o = e.Element.prototype,
                  n = Object,
                  r = String.prototype.trim || function () {
                    return this.replace(/^\s+|\s+$/g, "");
                  },
                  i = Array.prototype.indexOf || function (e) {
                    for (var t = 0, o = this.length; o > t; t++) if (t in this && this[t] === e) return t;
                    return -1;
                  },
                  a = function (e, t) {
                    this.name = e, this.code = DOMException[e], this.message = t;
                  },
                  s = function (e, t) {
                    if ("" === t) throw new a("SYNTAX_ERR", "An invalid or illegal string was specified");
                    if (/\s/.test(t)) throw new a("INVALID_CHARACTER_ERR", "String contains an invalid character");
                    return i.call(e, t);
                  },
                  l = function (e) {
                    for (var t = r.call(e.getAttribute("class") || ""), o = t ? t.split(/\s+/) : [], n = 0, i = o.length; i > n; n++) this.push(o[n]);
                    this._updateClassName = function () {
                      e.setAttribute("class", this.toString());
                    };
                  },
                  c = l.prototype = [],
                  u = function () {
                    return new l(this);
                  };
                if (a.prototype = Error.prototype, c.item = function (e) {
                  return this[e] || null;
                }, c.contains = function (e) {
                  return -1 !== s(this, e += "");
                }, c.add = function () {
                  var e,
                    t = arguments,
                    o = 0,
                    n = t.length,
                    r = !1;
                  do {
                    -1 === s(this, e = t[o] + "") && (this.push(e), r = !0);
                  } while (++o < n);
                  r && this._updateClassName();
                }, c.remove = function () {
                  var e,
                    t,
                    o = arguments,
                    n = 0,
                    r = o.length,
                    i = !1;
                  do {
                    for (t = s(this, e = o[n] + ""); -1 !== t;) this.splice(t, 1), i = !0, t = s(this, e);
                  } while (++n < r);
                  i && this._updateClassName();
                }, c.toggle = function (e, t) {
                  var o = this.contains(e += ""),
                    n = o ? !0 !== t && "remove" : !1 !== t && "add";
                  return n && this[n](e), !0 === t || !1 === t ? t : !o;
                }, c.toString = function () {
                  return this.join(" ");
                }, n.defineProperty) {
                  var d = {
                    get: u,
                    enumerable: !0,
                    configurable: !0
                  };
                  try {
                    n.defineProperty(o, t, d);
                  } catch (e) {
                    void 0 !== e.number && -2146823252 !== e.number || (d.enumerable = !1, n.defineProperty(o, t, d));
                  }
                } else n.prototype.__defineGetter__ && o.__defineGetter__(t, u);
              }
            }(window.self), function () {
              var e = document.createElement("_");
              if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
                var t = function (e) {
                  var t = DOMTokenList.prototype[e];
                  DOMTokenList.prototype[e] = function (e) {
                    var o,
                      n = arguments.length;
                    for (o = 0; n > o; o++) t.call(this, e = arguments[o]);
                  };
                };
                t("add"), t("remove");
              }
              if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
                var o = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function (e, t) {
                  return 1 in arguments && !this.contains(e) == !t ? t : o.call(this, e);
                };
              }
              e = null;
            }());
          },
          69220: function (e, t, o) {

            o(22513);
            var n = o(56599);
            e.exports = n("Array", "findIndex");
          },
          10444: function (e, t, o) {

            o(52867), o(70057);
            var n = o(31116);
            e.exports = n.Array.from;
          },
          66622: function (e, t, o) {

            o(54166), o(32044), o(95661), o(28424), o(64514), o(30733), o(40327), o(53639), o(6147), o(7290), o(95122), o(61322), o(39605), o(49341), o(28809), o(82658), o(43967), o(90217), o(73477), o(93697);
            var n = o(31116);
            e.exports = n.Symbol;
          },
          98061: function (e, t, o) {

            var n = o(794),
              r = o(98418),
              i = TypeError;
            e.exports = function (e) {
              if (n(e)) return e;
              throw i(r(e) + " is not a function");
            };
          },
          75839: function (e, t, o) {

            var n = o(794),
              r = String,
              i = TypeError;
            e.exports = function (e) {
              if ("object" == typeof e || n(e)) return e;
              throw i("Can't set " + r(e) + " as a prototype");
            };
          },
          15179: function (e, t, o) {

            var n = o(19517),
              r = o(93503),
              i = o(73252).f,
              a = n("unscopables"),
              s = Array.prototype;
            null == s[a] && i(s, a, {
              configurable: !0,
              value: r(null)
            }), e.exports = function (e) {
              s[a][e] = !0;
            };
          },
          52313: function (e, t, o) {

            var n = o(8148),
              r = String,
              i = TypeError;
            e.exports = function (e) {
              if (n(e)) return e;
              throw i(r(e) + " is not an object");
            };
          },
          92707: function (e, t, o) {

            var n = o(40207),
              r = o(9093),
              i = o(68488),
              a = o(79665),
              s = o(84997),
              l = o(15333),
              c = o(15050),
              u = o(89476),
              d = o(27395),
              p = o(81058),
              f = Array;
            e.exports = function (e) {
              var t = i(e),
                o = l(this),
                h = arguments.length,
                m = h > 1 ? arguments[1] : void 0,
                v = void 0 !== m;
              v && (m = n(m, h > 2 ? arguments[2] : void 0));
              var g,
                y,
                _,
                b,
                w,
                S,
                C = p(t),
                j = 0;
              if (!C || this === f && s(C)) for (g = c(t), y = o ? new this(g) : f(g); g > j; j++) S = v ? m(t[j], j) : t[j], u(y, j, S);else for (w = (b = d(t, C)).next, y = o ? new this() : []; !(_ = r(w, b)).done; j++) S = v ? a(b, m, [_.value, j], !0) : _.value, u(y, j, S);
              return y.length = j, y;
            };
          },
          79327: function (e, t, o) {

            var n = o(98651),
              r = o(10586),
              i = o(15050),
              a = function (e) {
                return function (t, o, a) {
                  var s,
                    l = n(t),
                    c = i(l),
                    u = r(a, c);
                  if (e && o != o) {
                    for (; c > u;) if ((s = l[u++]) != s) return !0;
                  } else for (; c > u; u++) if ((e || u in l) && l[u] === o) return e || u || 0;
                  return !e && -1;
                };
              };
            e.exports = {
              includes: a(!0),
              indexOf: a(!1)
            };
          },
          56881: function (e, t, o) {

            var n = o(40207),
              r = o(90838),
              i = o(25049),
              a = o(68488),
              s = o(15050),
              l = o(6429),
              c = r([].push),
              u = function (e) {
                var t = 1 == e,
                  o = 2 == e,
                  r = 3 == e,
                  u = 4 == e,
                  d = 6 == e,
                  p = 7 == e,
                  f = 5 == e || d;
                return function (h, m, v, g) {
                  for (var y, _, b = a(h), w = i(b), S = n(m, v), C = s(w), j = 0, E = g || l, x = t ? E(h, C) : o || p ? E(h, 0) : void 0; C > j; j++) if ((f || j in w) && (_ = S(y = w[j], j, b), e)) if (t) x[j] = _;else if (_) switch (e) {
                    case 3:
                      return !0;
                    case 5:
                      return y;
                    case 6:
                      return j;
                    case 2:
                      c(x, y);
                  } else switch (e) {
                    case 4:
                      return !1;
                    case 7:
                      c(x, y);
                  }
                  return d ? -1 : r || u ? u : x;
                };
              };
            e.exports = {
              forEach: u(0),
              map: u(1),
              filter: u(2),
              some: u(3),
              every: u(4),
              find: u(5),
              findIndex: u(6),
              filterReject: u(7)
            };
          },
          63833: function (e, t, o) {

            var n = o(75834),
              r = o(19517),
              i = o(65190),
              a = r("species");
            e.exports = function (e) {
              return i >= 51 || !n(function () {
                var t = [];
                return (t.constructor = {})[a] = function () {
                  return {
                    foo: 1
                  };
                }, 1 !== t[e](Boolean).foo;
              });
            };
          },
          57652: function (e, t, o) {

            var n = o(10586),
              r = o(15050),
              i = o(89476),
              a = Array,
              s = Math.max;
            e.exports = function (e, t, o) {
              for (var l = r(e), c = n(t, l), u = n(void 0 === o ? l : o, l), d = a(s(u - c, 0)), p = 0; u > c; c++, p++) i(d, p, e[c]);
              return d.length = p, d;
            };
          },
          54832: function (e, t, o) {

            var n = o(90838);
            e.exports = n([].slice);
          },
          22506: function (e, t, o) {

            var n = o(36222),
              r = o(15333),
              i = o(8148),
              a = o(19517)("species"),
              s = Array;
            e.exports = function (e) {
              var t;
              return n(e) && (r(t = e.constructor) && (t === s || n(t.prototype)) || i(t) && null === (t = t[a])) && (t = void 0), void 0 === t ? s : t;
            };
          },
          6429: function (e, t, o) {

            var n = o(22506);
            e.exports = function (e, t) {
              return new (n(e))(0 === t ? 0 : t);
            };
          },
          79665: function (e, t, o) {

            var n = o(52313),
              r = o(11274);
            e.exports = function (e, t, o, i) {
              try {
                return i ? t(n(o)[0], o[1]) : t(o);
              } catch (t) {
                r(e, "throw", t);
              }
            };
          },
          7581: function (e, t, o) {

            var n = o(19517)("iterator"),
              r = !1;
            try {
              var i = 0,
                a = {
                  next: function () {
                    return {
                      done: !!i++
                    };
                  },
                  return: function () {
                    r = !0;
                  }
                };
              a[n] = function () {
                return this;
              }, Array.from(a, function () {
                throw 2;
              });
            } catch (e) {}
            e.exports = function (e, t) {
              if (!t && !r) return !1;
              var o = !1;
              try {
                var i = {};
                i[n] = function () {
                  return {
                    next: function () {
                      return {
                        done: o = !0
                      };
                    }
                  };
                }, e(i);
              } catch (e) {}
              return o;
            };
          },
          6285: function (e, t, o) {

            var n = o(90838),
              r = n({}.toString),
              i = n("".slice);
            e.exports = function (e) {
              return i(r(e), 8, -1);
            };
          },
          8652: function (e, t, o) {

            var n = o(6424),
              r = o(794),
              i = o(6285),
              a = o(19517)("toStringTag"),
              s = Object,
              l = "Arguments" == i(function () {
                return arguments;
              }());
            e.exports = n ? i : function (e) {
              var t, o, n;
              return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (o = function (e, t) {
                try {
                  return e[t];
                } catch (e) {}
              }(t = s(e), a)) ? o : l ? i(t) : "Object" == (n = i(t)) && r(t.callee) ? "Arguments" : n;
            };
          },
          58392: function (e, t, o) {

            var n = o(14434),
              r = o(86671),
              i = o(36999),
              a = o(73252);
            e.exports = function (e, t, o) {
              for (var s = r(t), l = a.f, c = i.f, u = 0; s.length > u; u++) {
                var d = s[u];
                n(e, d) || o && n(o, d) || l(e, d, c(t, d));
              }
            };
          },
          27259: function (e, t, o) {

            var n = o(75834);
            e.exports = !n(function () {
              function e() {}
              return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
            });
          },
          17427: function (e) {

            e.exports = function (e, t) {
              return {
                value: e,
                done: t
              };
            };
          },
          45840: function (e, t, o) {

            var n = o(13873),
              r = o(73252),
              i = o(32500);
            e.exports = n ? function (e, t, o) {
              return r.f(e, t, i(1, o));
            } : function (e, t, o) {
              return e[t] = o, e;
            };
          },
          32500: function (e) {

            e.exports = function (e, t) {
              return {
                enumerable: !(1 & e),
                configurable: !(2 & e),
                writable: !(4 & e),
                value: t
              };
            };
          },
          89476: function (e, t, o) {

            var n = o(43836),
              r = o(73252),
              i = o(32500);
            e.exports = function (e, t, o) {
              var a = n(t);
              a in e ? r.f(e, a, i(0, o)) : e[a] = o;
            };
          },
          97548: function (e, t, o) {

            var n = o(40846),
              r = o(73252);
            e.exports = function (e, t, o) {
              return o.get && n(o.get, t, {
                getter: !0
              }), o.set && n(o.set, t, {
                setter: !0
              }), r.f(e, t, o);
            };
          },
          35065: function (e, t, o) {

            var n = o(794),
              r = o(73252),
              i = o(40846),
              a = o(25379);
            e.exports = function (e, t, o, s) {
              s || (s = {});
              var l = s.enumerable,
                c = void 0 !== s.name ? s.name : t;
              if (n(o) && i(o, c, s), s.global) l ? e[t] = o : a(t, o);else {
                try {
                  s.unsafe ? e[t] && (l = !0) : delete e[t];
                } catch (e) {}
                l ? e[t] = o : r.f(e, t, {
                  value: o,
                  enumerable: !1,
                  configurable: !s.nonConfigurable,
                  writable: !s.nonWritable
                });
              }
              return e;
            };
          },
          25379: function (e, t, o) {

            var n = o(37042),
              r = Object.defineProperty;
            e.exports = function (e, t) {
              try {
                r(n, e, {
                  value: t,
                  configurable: !0,
                  writable: !0
                });
              } catch (o) {
                n[e] = t;
              }
              return t;
            };
          },
          13873: function (e, t, o) {

            var n = o(75834);
            e.exports = !n(function () {
              return 7 != Object.defineProperty({}, 1, {
                get: function () {
                  return 7;
                }
              })[1];
            });
          },
          12062: function (e) {

            var t = "object" == typeof document && document.all;
            e.exports = {
              all: t,
              IS_HTMLDDA: void 0 === t && void 0 !== t
            };
          },
          15192: function (e, t, o) {

            var n = o(37042),
              r = o(8148),
              i = n.document,
              a = r(i) && r(i.createElement);
            e.exports = function (e) {
              return a ? i.createElement(e) : {};
            };
          },
          39505: function (e) {

            var t = TypeError;
            e.exports = function (e) {
              if (e > 9007199254740991) throw t("Maximum allowed index exceeded");
              return e;
            };
          },
          21473: function (e) {

            e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
          },
          65190: function (e, t, o) {

            var n,
              r,
              i = o(37042),
              a = o(21473),
              s = i.process,
              l = i.Deno,
              c = s && s.versions || l && l.version,
              u = c && c.v8;
            u && (r = (n = u.split("."))[0] > 0 && 4 > n[0] ? 1 : +(n[0] + n[1])), !r && a && ((n = a.match(/Edge\/(\d+)/)) && 74 > n[1] || (n = a.match(/Chrome\/(\d+)/)) && (r = +n[1])), e.exports = r;
          },
          56599: function (e, t, o) {

            var n = o(37042),
              r = o(90838);
            e.exports = function (e, t) {
              return r(n[e].prototype[t]);
            };
          },
          64456: function (e) {

            e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
          },
          50791: function (e, t, o) {

            var n = o(37042),
              r = o(36999).f,
              i = o(45840),
              a = o(35065),
              s = o(25379),
              l = o(58392),
              c = o(56930);
            e.exports = function (e, t) {
              var o,
                u,
                d,
                p,
                f,
                h = e.target,
                m = e.global,
                v = e.stat;
              if (o = m ? n : v ? n[h] || s(h, {}) : (n[h] || {}).prototype) for (u in t) {
                if (p = t[u], d = e.dontCallGetSet ? (f = r(o, u)) && f.value : o[u], !c(m ? u : h + (v ? "." : "#") + u, e.forced) && void 0 !== d) {
                  if (typeof p == typeof d) continue;
                  l(p, d);
                }
                (e.sham || d && d.sham) && i(p, "sham", !0), a(o, u, p, e);
              }
            };
          },
          75834: function (e) {

            e.exports = function (e) {
              try {
                return !!e();
              } catch (e) {
                return !0;
              }
            };
          },
          55101: function (e, t, o) {

            var n = o(32610),
              r = Function.prototype,
              i = r.apply,
              a = r.call;
            e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(i) : function () {
              return a.apply(i, arguments);
            });
          },
          40207: function (e, t, o) {

            var n = o(75114),
              r = o(98061),
              i = o(32610),
              a = n(n.bind);
            e.exports = function (e, t) {
              return r(e), void 0 === t ? e : i ? a(e, t) : function () {
                return e.apply(t, arguments);
              };
            };
          },
          32610: function (e, t, o) {

            var n = o(75834);
            e.exports = !n(function () {
              var e = function () {}.bind();
              return "function" != typeof e || e.hasOwnProperty("prototype");
            });
          },
          9093: function (e, t, o) {

            var n = o(32610),
              r = Function.prototype.call;
            e.exports = n ? r.bind(r) : function () {
              return r.apply(r, arguments);
            };
          },
          84521: function (e, t, o) {

            var n = o(13873),
              r = o(14434),
              i = Function.prototype,
              a = n && Object.getOwnPropertyDescriptor,
              s = r(i, "name"),
              l = s && "something" === function () {}.name,
              c = s && (!n || n && a(i, "name").configurable);
            e.exports = {
              EXISTS: s,
              PROPER: l,
              CONFIGURABLE: c
            };
          },
          47448: function (e, t, o) {

            var n = o(90838),
              r = o(98061);
            e.exports = function (e, t, o) {
              try {
                return n(r(Object.getOwnPropertyDescriptor(e, t)[o]));
              } catch (e) {}
            };
          },
          75114: function (e, t, o) {

            var n = o(6285),
              r = o(90838);
            e.exports = function (e) {
              if ("Function" === n(e)) return r(e);
            };
          },
          90838: function (e, t, o) {

            var n = o(32610),
              r = Function.prototype,
              i = r.call,
              a = n && r.bind.bind(i, i);
            e.exports = n ? a : function (e) {
              return function () {
                return i.apply(e, arguments);
              };
            };
          },
          98945: function (e, t, o) {

            var n = o(37042),
              r = o(794),
              i = function (e) {
                return r(e) ? e : void 0;
              };
            e.exports = function (e, t) {
              return 2 > arguments.length ? i(n[e]) : n[e] && n[e][t];
            };
          },
          81058: function (e, t, o) {

            var n = o(8652),
              r = o(20156),
              i = o(8140),
              a = o(84922),
              s = o(19517)("iterator");
            e.exports = function (e) {
              if (!i(e)) return r(e, s) || r(e, "@@iterator") || a[n(e)];
            };
          },
          27395: function (e, t, o) {

            var n = o(9093),
              r = o(98061),
              i = o(52313),
              a = o(98418),
              s = o(81058),
              l = TypeError;
            e.exports = function (e, t) {
              var o = 2 > arguments.length ? s(e) : t;
              if (r(o)) return i(n(o, e));
              throw l(a(e) + " is not iterable");
            };
          },
          6693: function (e, t, o) {

            var n = o(90838),
              r = o(36222),
              i = o(794),
              a = o(6285),
              s = o(63046),
              l = n([].push);
            e.exports = function (e) {
              if (i(e)) return e;
              if (r(e)) {
                for (var t = e.length, o = [], n = 0; t > n; n++) {
                  var c = e[n];
                  "string" == typeof c ? l(o, c) : "number" != typeof c && "Number" != a(c) && "String" != a(c) || l(o, s(c));
                }
                var u = o.length,
                  d = !0;
                return function (e, t) {
                  if (d) return d = !1, t;
                  if (r(this)) return t;
                  for (var n = 0; u > n; n++) if (o[n] === e) return t;
                };
              }
            };
          },
          20156: function (e, t, o) {

            var n = o(98061),
              r = o(8140);
            e.exports = function (e, t) {
              var o = e[t];
              return r(o) ? void 0 : n(o);
            };
          },
          37042: function (e, t, o) {

            var n = function (e) {
              return e && e.Math == Math && e;
            };
            e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof o.g && o.g) || function () {
              return this;
            }() || Function("return this")();
          },
          14434: function (e, t, o) {

            var n = o(90838),
              r = o(68488),
              i = n({}.hasOwnProperty);
            e.exports = Object.hasOwn || function (e, t) {
              return i(r(e), t);
            };
          },
          48889: function (e) {

            e.exports = {};
          },
          36249: function (e, t, o) {

            var n = o(98945);
            e.exports = n("document", "documentElement");
          },
          12816: function (e, t, o) {

            var n = o(13873),
              r = o(75834),
              i = o(15192);
            e.exports = !n && !r(function () {
              return 7 != Object.defineProperty(i("div"), "a", {
                get: function () {
                  return 7;
                }
              }).a;
            });
          },
          25049: function (e, t, o) {

            var n = o(90838),
              r = o(75834),
              i = o(6285),
              a = Object,
              s = n("".split);
            e.exports = r(function () {
              return !a("z").propertyIsEnumerable(0);
            }) ? function (e) {
              return "String" == i(e) ? s(e, "") : a(e);
            } : a;
          },
          92355: function (e, t, o) {

            var n = o(90838),
              r = o(794),
              i = o(45752),
              a = n(Function.toString);
            r(i.inspectSource) || (i.inspectSource = function (e) {
              return a(e);
            }), e.exports = i.inspectSource;
          },
          56113: function (e, t, o) {

            var n,
              r,
              i,
              a = o(95473),
              s = o(37042),
              l = o(8148),
              c = o(45840),
              u = o(14434),
              d = o(45752),
              p = o(85475),
              f = o(48889),
              h = "Object already initialized",
              m = s.TypeError;
            if (a || d.state) {
              var v = d.state || (d.state = new (s.WeakMap)());
              v.get = v.get, v.has = v.has, v.set = v.set, n = function (e, t) {
                if (v.has(e)) throw m(h);
                return t.facade = e, v.set(e, t), t;
              }, r = function (e) {
                return v.get(e) || {};
              }, i = function (e) {
                return v.has(e);
              };
            } else {
              var g = p("state");
              f[g] = !0, n = function (e, t) {
                if (u(e, g)) throw m(h);
                return t.facade = e, c(e, g, t), t;
              }, r = function (e) {
                return u(e, g) ? e[g] : {};
              }, i = function (e) {
                return u(e, g);
              };
            }
            e.exports = {
              set: n,
              get: r,
              has: i,
              enforce: function (e) {
                return i(e) ? r(e) : n(e, {});
              },
              getterFor: function (e) {
                return function (t) {
                  var o;
                  if (!l(t) || (o = r(t)).type !== e) throw m("Incompatible receiver, " + e + " required");
                  return o;
                };
              }
            };
          },
          84997: function (e, t, o) {

            var n = o(19517),
              r = o(84922),
              i = n("iterator"),
              a = Array.prototype;
            e.exports = function (e) {
              return void 0 !== e && (r.Array === e || a[i] === e);
            };
          },
          36222: function (e, t, o) {

            var n = o(6285);
            e.exports = Array.isArray || function (e) {
              return "Array" == n(e);
            };
          },
          794: function (e, t, o) {

            var n = o(12062),
              r = n.all;
            e.exports = n.IS_HTMLDDA ? function (e) {
              return "function" == typeof e || e === r;
            } : function (e) {
              return "function" == typeof e;
            };
          },
          15333: function (e, t, o) {

            var n = o(90838),
              r = o(75834),
              i = o(794),
              a = o(8652),
              s = o(98945),
              l = o(92355),
              c = function () {},
              u = [],
              d = s("Reflect", "construct"),
              p = /^\s*(?:class|function)\b/,
              f = n(p.exec),
              h = !p.exec(c),
              m = function (e) {
                if (!i(e)) return !1;
                try {
                  return d(c, u, e), !0;
                } catch (e) {
                  return !1;
                }
              },
              v = function (e) {
                if (!i(e)) return !1;
                switch (a(e)) {
                  case "AsyncFunction":
                  case "GeneratorFunction":
                  case "AsyncGeneratorFunction":
                    return !1;
                }
                try {
                  return h || !!f(p, l(e));
                } catch (e) {
                  return !0;
                }
              };
            v.sham = !0, e.exports = !d || r(function () {
              var e;
              return m(m.call) || !m(Object) || !m(function () {
                e = !0;
              }) || e;
            }) ? v : m;
          },
          56930: function (e, t, o) {

            var n = o(75834),
              r = o(794),
              i = /#|\.prototype\./,
              a = function (e, t) {
                var o = l[s(e)];
                return o == u || o != c && (r(t) ? n(t) : !!t);
              },
              s = a.normalize = function (e) {
                return String(e).replace(i, ".").toLowerCase();
              },
              l = a.data = {},
              c = a.NATIVE = "N",
              u = a.POLYFILL = "P";
            e.exports = a;
          },
          8140: function (e) {

            e.exports = function (e) {
              return null == e;
            };
          },
          8148: function (e, t, o) {

            var n = o(794),
              r = o(12062),
              i = r.all;
            e.exports = r.IS_HTMLDDA ? function (e) {
              return "object" == typeof e ? null !== e : n(e) || e === i;
            } : function (e) {
              return "object" == typeof e ? null !== e : n(e);
            };
          },
          70852: function (e) {

            e.exports = !1;
          },
          88253: function (e, t, o) {

            var n = o(98945),
              r = o(794),
              i = o(54671),
              a = o(57982),
              s = Object;
            e.exports = a ? function (e) {
              return "symbol" == typeof e;
            } : function (e) {
              var t = n("Symbol");
              return r(t) && i(t.prototype, s(e));
            };
          },
          11274: function (e, t, o) {

            var n = o(9093),
              r = o(52313),
              i = o(20156);
            e.exports = function (e, t, o) {
              var a, s;
              r(e);
              try {
                if (!(a = i(e, "return"))) {
                  if ("throw" === t) throw o;
                  return o;
                }
                a = n(a, e);
              } catch (e) {
                s = !0, a = e;
              }
              if ("throw" === t) throw o;
              if (s) throw a;
              return r(a), o;
            };
          },
          60928: function (e, t, o) {

            var n = o(77831).IteratorPrototype,
              r = o(93503),
              i = o(32500),
              a = o(44532),
              s = o(84922),
              l = function () {
                return this;
              };
            e.exports = function (e, t, o, c) {
              var u = t + " Iterator";
              return e.prototype = r(n, {
                next: i(+!c, o)
              }), a(e, u, !1, !0), s[u] = l, e;
            };
          },
          13759: function (e, t, o) {

            var n = o(50791),
              r = o(9093),
              i = o(70852),
              a = o(84521),
              s = o(794),
              l = o(60928),
              c = o(1074),
              u = o(482),
              d = o(44532),
              p = o(45840),
              f = o(35065),
              h = o(19517),
              m = o(84922),
              v = o(77831),
              g = a.PROPER,
              y = a.CONFIGURABLE,
              _ = v.IteratorPrototype,
              b = v.BUGGY_SAFARI_ITERATORS,
              w = h("iterator"),
              S = "keys",
              C = "values",
              j = "entries",
              E = function () {
                return this;
              };
            e.exports = function (e, t, o, a, h, v, x) {
              l(o, t, a);
              var k,
                T,
                I,
                P = function (e) {
                  if (e === h && A) return A;
                  if (!b && e in O) return O[e];
                  switch (e) {
                    case S:
                    case C:
                    case j:
                      return function () {
                        return new o(this, e);
                      };
                  }
                  return function () {
                    return new o(this);
                  };
                },
                M = t + " Iterator",
                D = !1,
                O = e.prototype,
                z = O[w] || O["@@iterator"] || h && O[h],
                A = !b && z || P(h),
                L = "Array" == t && O.entries || z;
              if (L && (k = c(L.call(new e()))) !== Object.prototype && k.next && (i || c(k) === _ || (u ? u(k, _) : s(k[w]) || f(k, w, E)), d(k, M, !0, !0), i && (m[M] = E)), g && h == C && z && z.name !== C && (!i && y ? p(O, "name", C) : (D = !0, A = function () {
                return r(z, this);
              })), h) if (T = {
                values: P(C),
                keys: v ? A : P(S),
                entries: P(j)
              }, x) for (I in T) (b || D || !(I in O)) && f(O, I, T[I]);else n({
                target: t,
                proto: !0,
                forced: b || D
              }, T);
              return i && !x || O[w] === A || f(O, w, A, {
                name: h
              }), m[t] = A, T;
            };
          },
          77831: function (e, t, o) {

            var n,
              r,
              i,
              a = o(75834),
              s = o(794),
              l = o(8148),
              c = o(93503),
              u = o(1074),
              d = o(35065),
              p = o(19517),
              f = o(70852),
              h = p("iterator"),
              m = !1;
            [].keys && ("next" in (i = [].keys()) ? (r = u(u(i))) !== Object.prototype && (n = r) : m = !0), !l(n) || a(function () {
              var e = {};
              return n[h].call(e) !== e;
            }) ? n = {} : f && (n = c(n)), s(n[h]) || d(n, h, function () {
              return this;
            }), e.exports = {
              IteratorPrototype: n,
              BUGGY_SAFARI_ITERATORS: m
            };
          },
          84922: function (e) {

            e.exports = {};
          },
          15050: function (e, t, o) {

            var n = o(24431);
            e.exports = function (e) {
              return n(e.length);
            };
          },
          40846: function (e, t, o) {

            var n = o(90838),
              r = o(75834),
              i = o(794),
              a = o(14434),
              s = o(13873),
              l = o(84521).CONFIGURABLE,
              c = o(92355),
              u = o(56113),
              d = u.enforce,
              p = u.get,
              f = String,
              h = Object.defineProperty,
              m = n("".slice),
              v = n("".replace),
              g = n([].join),
              y = s && !r(function () {
                return 8 !== h(function () {}, "length", {
                  value: 8
                }).length;
              }),
              _ = String(String).split("String"),
              b = e.exports = function (e, t, o) {
                "Symbol(" === m(f(t), 0, 7) && (t = "[" + v(f(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), o && o.getter && (t = "get " + t), o && o.setter && (t = "set " + t), (!a(e, "name") || l && e.name !== t) && (s ? h(e, "name", {
                  value: t,
                  configurable: !0
                }) : e.name = t), y && o && a(o, "arity") && e.length !== o.arity && h(e, "length", {
                  value: o.arity
                });
                try {
                  o && a(o, "constructor") && o.constructor ? s && h(e, "prototype", {
                    writable: !1
                  }) : e.prototype && (e.prototype = void 0);
                } catch (e) {}
                var n = d(e);
                return a(n, "source") || (n.source = g(_, "string" == typeof t ? t : "")), e;
              };
            Function.prototype.toString = b(function () {
              return i(this) && p(this).source || c(this);
            }, "toString");
          },
          43932: function (e) {

            var t = Math.ceil,
              o = Math.floor;
            e.exports = Math.trunc || function (e) {
              var n = +e;
              return (n > 0 ? o : t)(n);
            };
          },
          93503: function (e, t, o) {

            var n,
              r = o(52313),
              i = o(5770),
              a = o(64456),
              s = o(48889),
              l = o(36249),
              c = o(15192),
              u = o(85475)("IE_PROTO"),
              d = function () {},
              p = function (e) {
                return "<script>" + e + "<\/script>";
              },
              f = function (e) {
                e.write(p("")), e.close();
                var t = e.parentWindow.Object;
                return e = null, t;
              },
              h = function () {
                try {
                  n = new ActiveXObject("htmlfile");
                } catch (e) {}
                var e, t;
                h = "undefined" != typeof document ? document.domain && n ? f(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F) : f(n);
                for (var o = a.length; o--;) delete h.prototype[a[o]];
                return h();
              };
            s[u] = !0, e.exports = Object.create || function (e, t) {
              var o;
              return null !== e ? (d.prototype = r(e), o = new d(), d.prototype = null, o[u] = e) : o = h(), void 0 === t ? o : i.f(o, t);
            };
          },
          5770: function (e, t, o) {

            var n = o(13873),
              r = o(63142),
              i = o(73252),
              a = o(52313),
              s = o(98651),
              l = o(3385);
            t.f = n && !r ? Object.defineProperties : function (e, t) {
              a(e);
              for (var o, n = s(t), r = l(t), c = r.length, u = 0; c > u;) i.f(e, o = r[u++], n[o]);
              return e;
            };
          },
          73252: function (e, t, o) {

            var n = o(13873),
              r = o(12816),
              i = o(63142),
              a = o(52313),
              s = o(43836),
              l = TypeError,
              c = Object.defineProperty,
              u = Object.getOwnPropertyDescriptor;
            t.f = n ? i ? function (e, t, o) {
              if (a(e), t = s(t), a(o), "function" == typeof e && "prototype" === t && "value" in o && "writable" in o && !o.writable) {
                var n = u(e, t);
                n && n.writable && (e[t] = o.value, o = {
                  configurable: "configurable" in o ? o.configurable : n.configurable,
                  enumerable: "enumerable" in o ? o.enumerable : n.enumerable,
                  writable: !1
                });
              }
              return c(e, t, o);
            } : c : function (e, t, o) {
              if (a(e), t = s(t), a(o), r) try {
                return c(e, t, o);
              } catch (e) {}
              if ("get" in o || "set" in o) throw l("Accessors not supported");
              return "value" in o && (e[t] = o.value), e;
            };
          },
          36999: function (e, t, o) {

            var n = o(13873),
              r = o(9093),
              i = o(33244),
              a = o(32500),
              s = o(98651),
              l = o(43836),
              c = o(14434),
              u = o(12816),
              d = Object.getOwnPropertyDescriptor;
            t.f = n ? d : function (e, t) {
              if (e = s(e), t = l(t), u) try {
                return d(e, t);
              } catch (e) {}
              if (c(e, t)) return a(!r(i.f, e, t), e[t]);
            };
          },
          53305: function (e, t, o) {

            var n = o(6285),
              r = o(98651),
              i = o(7792).f,
              a = o(57652),
              s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
            e.exports.f = function (e) {
              return s && "Window" == n(e) ? function (e) {
                try {
                  return i(e);
                } catch (e) {
                  return a(s);
                }
              }(e) : i(r(e));
            };
          },
          7792: function (e, t, o) {

            var n = o(84729),
              r = o(64456).concat("length", "prototype");
            t.f = Object.getOwnPropertyNames || function (e) {
              return n(e, r);
            };
          },
          23953: function (e, t) {

            t.f = Object.getOwnPropertySymbols;
          },
          1074: function (e, t, o) {

            var n = o(14434),
              r = o(794),
              i = o(68488),
              a = o(85475),
              s = o(27259),
              l = a("IE_PROTO"),
              c = Object,
              u = c.prototype;
            e.exports = s ? c.getPrototypeOf : function (e) {
              var t = i(e);
              if (n(t, l)) return t[l];
              var o = t.constructor;
              return r(o) && t instanceof o ? o.prototype : t instanceof c ? u : null;
            };
          },
          54671: function (e, t, o) {

            var n = o(90838);
            e.exports = n({}.isPrototypeOf);
          },
          84729: function (e, t, o) {

            var n = o(90838),
              r = o(14434),
              i = o(98651),
              a = o(79327).indexOf,
              s = o(48889),
              l = n([].push);
            e.exports = function (e, t) {
              var o,
                n = i(e),
                c = 0,
                u = [];
              for (o in n) !r(s, o) && r(n, o) && l(u, o);
              for (; t.length > c;) r(n, o = t[c++]) && (~a(u, o) || l(u, o));
              return u;
            };
          },
          3385: function (e, t, o) {

            var n = o(84729),
              r = o(64456);
            e.exports = Object.keys || function (e) {
              return n(e, r);
            };
          },
          33244: function (e, t) {

            var o = {}.propertyIsEnumerable,
              n = Object.getOwnPropertyDescriptor,
              r = n && !o.call({
                1: 2
              }, 1);
            t.f = r ? function (e) {
              var t = n(this, e);
              return !!t && t.enumerable;
            } : o;
          },
          482: function (e, t, o) {

            var n = o(47448),
              r = o(52313),
              i = o(75839);
            e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
              var e,
                t = !1,
                o = {};
              try {
                (e = n(Object.prototype, "__proto__", "set"))(o, []), t = o instanceof Array;
              } catch (e) {}
              return function (o, n) {
                return r(o), i(n), t ? e(o, n) : o.__proto__ = n, o;
              };
            }() : void 0);
          },
          57555: function (e, t, o) {

            var n = o(6424),
              r = o(8652);
            e.exports = n ? {}.toString : function () {
              return "[object " + r(this) + "]";
            };
          },
          82472: function (e, t, o) {

            var n = o(9093),
              r = o(794),
              i = o(8148),
              a = TypeError;
            e.exports = function (e, t) {
              var o, s;
              if ("string" === t && r(o = e.toString) && !i(s = n(o, e))) return s;
              if (r(o = e.valueOf) && !i(s = n(o, e))) return s;
              if ("string" !== t && r(o = e.toString) && !i(s = n(o, e))) return s;
              throw a("Can't convert object to primitive value");
            };
          },
          86671: function (e, t, o) {

            var n = o(98945),
              r = o(90838),
              i = o(7792),
              a = o(23953),
              s = o(52313),
              l = r([].concat);
            e.exports = n("Reflect", "ownKeys") || function (e) {
              var t = i.f(s(e)),
                o = a.f;
              return o ? l(t, o(e)) : t;
            };
          },
          31116: function (e, t, o) {

            var n = o(37042);
            e.exports = n;
          },
          60265: function (e, t, o) {

            var n = o(8140),
              r = TypeError;
            e.exports = function (e) {
              if (n(e)) throw r("Can't call method on " + e);
              return e;
            };
          },
          44532: function (e, t, o) {

            var n = o(73252).f,
              r = o(14434),
              i = o(19517)("toStringTag");
            e.exports = function (e, t, o) {
              e && !o && (e = e.prototype), e && !r(e, i) && n(e, i, {
                configurable: !0,
                value: t
              });
            };
          },
          85475: function (e, t, o) {

            var n = o(95138),
              r = o(15257),
              i = n("keys");
            e.exports = function (e) {
              return i[e] || (i[e] = r(e));
            };
          },
          45752: function (e, t, o) {

            var n = o(37042),
              r = o(25379),
              i = "__core-js_shared__",
              a = n[i] || r(i, {});
            e.exports = a;
          },
          95138: function (e, t, o) {

            var n = o(70852),
              r = o(45752);
            (e.exports = function (e, t) {
              return r[e] || (r[e] = void 0 !== t ? t : {});
            })("versions", []).push({
              version: "3.28.0",
              mode: n ? "pure" : "global",
              copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
              license: "https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE",
              source: "https://github.com/zloirock/core-js"
            });
          },
          41397: function (e, t, o) {

            var n = o(90838),
              r = o(27876),
              i = o(63046),
              a = o(60265),
              s = n("".charAt),
              l = n("".charCodeAt),
              c = n("".slice),
              u = function (e) {
                return function (t, o) {
                  var n,
                    u,
                    d = i(a(t)),
                    p = r(o),
                    f = d.length;
                  return 0 > p || p >= f ? e ? "" : void 0 : 55296 > (n = l(d, p)) || n > 56319 || p + 1 === f || 56320 > (u = l(d, p + 1)) || u > 57343 ? e ? s(d, p) : n : e ? c(d, p, p + 2) : u - 56320 + (n - 55296 << 10) + 65536;
                };
              };
            e.exports = {
              codeAt: u(!1),
              charAt: u(!0)
            };
          },
          73800: function (e, t, o) {

            var n = o(65190),
              r = o(75834);
            e.exports = !!Object.getOwnPropertySymbols && !r(function () {
              var e = Symbol();
              return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && 41 > n;
            });
          },
          13829: function (e, t, o) {

            var n = o(9093),
              r = o(98945),
              i = o(19517),
              a = o(35065);
            e.exports = function () {
              var e = r("Symbol"),
                t = e && e.prototype,
                o = t && t.valueOf,
                s = i("toPrimitive");
              t && !t[s] && a(t, s, function (e) {
                return n(o, this);
              }, {
                arity: 1
              });
            };
          },
          31948: function (e, t, o) {

            var n = o(73800);
            e.exports = n && !!Symbol.for && !!Symbol.keyFor;
          },
          10586: function (e, t, o) {

            var n = o(27876),
              r = Math.max,
              i = Math.min;
            e.exports = function (e, t) {
              var o = n(e);
              return 0 > o ? r(o + t, 0) : i(o, t);
            };
          },
          98651: function (e, t, o) {

            var n = o(25049),
              r = o(60265);
            e.exports = function (e) {
              return n(r(e));
            };
          },
          27876: function (e, t, o) {

            var n = o(43932);
            e.exports = function (e) {
              var t = +e;
              return t != t || 0 === t ? 0 : n(t);
            };
          },
          24431: function (e, t, o) {

            var n = o(27876),
              r = Math.min;
            e.exports = function (e) {
              return e > 0 ? r(n(e), 9007199254740991) : 0;
            };
          },
          68488: function (e, t, o) {

            var n = o(60265),
              r = Object;
            e.exports = function (e) {
              return r(n(e));
            };
          },
          11261: function (e, t, o) {

            var n = o(9093),
              r = o(8148),
              i = o(88253),
              a = o(20156),
              s = o(82472),
              l = o(19517),
              c = TypeError,
              u = l("toPrimitive");
            e.exports = function (e, t) {
              if (!r(e) || i(e)) return e;
              var o,
                l = a(e, u);
              if (l) {
                if (void 0 === t && (t = "default"), o = n(l, e, t), !r(o) || i(o)) return o;
                throw c("Can't convert object to primitive value");
              }
              return void 0 === t && (t = "number"), s(e, t);
            };
          },
          43836: function (e, t, o) {

            var n = o(11261),
              r = o(88253);
            e.exports = function (e) {
              var t = n(e, "string");
              return r(t) ? t : t + "";
            };
          },
          6424: function (e, t, o) {

            var n = {};
            n[o(19517)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
          },
          63046: function (e, t, o) {

            var n = o(8652),
              r = String;
            e.exports = function (e) {
              if ("Symbol" === n(e)) throw TypeError("Cannot convert a Symbol value to a string");
              return r(e);
            };
          },
          98418: function (e) {

            var t = String;
            e.exports = function (e) {
              try {
                return t(e);
              } catch (e) {
                return "Object";
              }
            };
          },
          15257: function (e, t, o) {

            var n = o(90838),
              r = 0,
              i = Math.random(),
              a = n(1..toString);
            e.exports = function (e) {
              return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++r + i, 36);
            };
          },
          57982: function (e, t, o) {

            var n = o(73800);
            e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
          },
          63142: function (e, t, o) {

            var n = o(13873),
              r = o(75834);
            e.exports = n && r(function () {
              return 42 != Object.defineProperty(function () {}, "prototype", {
                value: 42,
                writable: !1
              }).prototype;
            });
          },
          95473: function (e, t, o) {

            var n = o(37042),
              r = o(794),
              i = n.WeakMap;
            e.exports = r(i) && /native code/.test(String(i));
          },
          89633: function (e, t, o) {

            var n = o(31116),
              r = o(14434),
              i = o(96767),
              a = o(73252).f;
            e.exports = function (e) {
              var t = n.Symbol || (n.Symbol = {});
              r(t, e) || a(t, e, {
                value: i.f(e)
              });
            };
          },
          96767: function (e, t, o) {

            var n = o(19517);
            t.f = n;
          },
          19517: function (e, t, o) {

            var n = o(37042),
              r = o(95138),
              i = o(14434),
              a = o(15257),
              s = o(73800),
              l = o(57982),
              c = n.Symbol,
              u = r("wks"),
              d = l ? c.for || c : c && c.withoutSetter || a;
            e.exports = function (e) {
              return i(u, e) || (u[e] = s && i(c, e) ? c[e] : d("Symbol." + e)), u[e];
            };
          },
          54166: function (e, t, o) {

            var n = o(50791),
              r = o(75834),
              i = o(36222),
              a = o(8148),
              s = o(68488),
              l = o(15050),
              c = o(39505),
              u = o(89476),
              d = o(6429),
              p = o(63833),
              f = o(19517),
              h = o(65190),
              m = f("isConcatSpreadable"),
              v = h >= 51 || !r(function () {
                var e = [];
                return e[m] = !1, e.concat()[0] !== e;
              }),
              g = function (e) {
                if (!a(e)) return !1;
                var t = e[m];
                return void 0 !== t ? !!t : i(e);
              };
            n({
              target: "Array",
              proto: !0,
              arity: 1,
              forced: !v || !p("concat")
            }, {
              concat: function (e) {
                var t,
                  o,
                  n,
                  r,
                  i,
                  a = s(this),
                  p = d(a, 0),
                  f = 0;
                for (t = -1, n = arguments.length; n > t; t++) if (g(i = -1 === t ? a : arguments[t])) for (r = l(i), c(f + r), o = 0; r > o; o++, f++) o in i && u(p, f, i[o]);else c(f + 1), u(p, f++, i);
                return p.length = f, p;
              }
            });
          },
          22513: function (e, t, o) {

            var n = o(50791),
              r = o(56881).findIndex,
              i = o(15179),
              a = "findIndex",
              s = !0;
            a in [] && Array(1).findIndex(function () {
              s = !1;
            }), n({
              target: "Array",
              proto: !0,
              forced: s
            }, {
              findIndex: function (e) {
                return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), i(a);
          },
          70057: function (e, t, o) {

            var n = o(50791),
              r = o(92707);
            n({
              target: "Array",
              stat: !0,
              forced: !o(7581)(function (e) {
              })
            }, {
              from: r
            });
          },
          67507: function (e, t, o) {

            var n = o(50791),
              r = o(98945),
              i = o(55101),
              a = o(9093),
              s = o(90838),
              l = o(75834),
              c = o(794),
              u = o(88253),
              d = o(54832),
              p = o(6693),
              f = o(73800),
              h = String,
              m = r("JSON", "stringify"),
              v = s(/./.exec),
              g = s("".charAt),
              y = s("".charCodeAt),
              _ = s("".replace),
              b = s(1..toString),
              w = /[\uD800-\uDFFF]/g,
              S = /^[\uD800-\uDBFF]$/,
              C = /^[\uDC00-\uDFFF]$/,
              j = !f || l(function () {
                var e = r("Symbol")();
                return "[null]" != m([e]) || "{}" != m({
                  a: e
                }) || "{}" != m(Object(e));
              }),
              E = l(function () {
                return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
              }),
              x = function (e, t) {
                var o = d(arguments),
                  n = p(t);
                if (c(n) || void 0 !== e && !u(e)) return o[1] = function (e, t) {
                  if (c(n) && (t = a(n, this, h(e), t)), !u(t)) return t;
                }, i(m, null, o);
              },
              k = function (e, t, o) {
                var n = g(o, t - 1),
                  r = g(o, t + 1);
                return v(S, e) && !v(C, r) || v(C, e) && !v(S, n) ? "\\u" + b(y(e, 0), 16) : e;
              };
            m && n({
              target: "JSON",
              stat: !0,
              arity: 3,
              forced: j || E
            }, {
              stringify: function (e, t, o) {
                var n = d(arguments),
                  r = i(j ? x : m, null, n);
                return E && "string" == typeof r ? _(r, w, k) : r;
              }
            });
          },
          90217: function (e, t, o) {

            var n = o(37042);
            o(44532)(n.JSON, "JSON", !0);
          },
          73477: function (e, t, o) {

            o(44532)(Math, "Math", !0);
          },
          30165: function (e, t, o) {

            var n = o(50791),
              r = o(73800),
              i = o(75834),
              a = o(23953),
              s = o(68488);
            n({
              target: "Object",
              stat: !0,
              forced: !r || i(function () {
                a.f(1);
              })
            }, {
              getOwnPropertySymbols: function (e) {
                var t = a.f;
                return t ? t(s(e)) : [];
              }
            });
          },
          32044: function (e, t, o) {

            var n = o(6424),
              r = o(35065),
              i = o(57555);
            n || r(Object.prototype, "toString", i, {
              unsafe: !0
            });
          },
          93697: function (e, t, o) {

            var n = o(50791),
              r = o(37042),
              i = o(44532);
            n({
              global: !0
            }, {
              Reflect: {}
            }), i(r.Reflect, "Reflect", !0);
          },
          52867: function (e, t, o) {

            var n = o(41397).charAt,
              r = o(63046),
              i = o(56113),
              a = o(13759),
              s = o(17427),
              l = "String Iterator",
              c = i.set,
              u = i.getterFor(l);
            a(String, "String", function (e) {
              c(this, {
                type: l,
                string: r(e),
                index: 0
              });
            }, function () {
              var e,
                t = u(this),
                o = t.string,
                r = t.index;
              return o.length > r ? (e = n(o, r), t.index += e.length, s(e, !1)) : s(void 0, !0);
            });
          },
          28424: function (e, t, o) {

            o(89633)("asyncIterator");
          },
          9656: function (e, t, o) {

            var n = o(50791),
              r = o(37042),
              i = o(9093),
              a = o(90838),
              s = o(70852),
              l = o(13873),
              c = o(73800),
              u = o(75834),
              d = o(14434),
              p = o(54671),
              f = o(52313),
              h = o(98651),
              m = o(43836),
              v = o(63046),
              g = o(32500),
              y = o(93503),
              _ = o(3385),
              b = o(7792),
              w = o(53305),
              S = o(23953),
              C = o(36999),
              j = o(73252),
              E = o(5770),
              x = o(33244),
              k = o(35065),
              T = o(97548),
              I = o(95138),
              P = o(85475),
              M = o(48889),
              D = o(15257),
              O = o(19517),
              z = o(96767),
              A = o(89633),
              L = o(13829),
              N = o(44532),
              R = o(56113),
              B = o(56881).forEach,
              q = P("hidden"),
              F = "Symbol",
              H = R.set,
              V = R.getterFor(F),
              U = Object.prototype,
              W = r.Symbol,
              Y = W && W.prototype,
              G = r.TypeError,
              K = r.QObject,
              X = C.f,
              J = j.f,
              $ = w.f,
              Z = x.f,
              Q = a([].push),
              ee = I("symbols"),
              te = I("op-symbols"),
              oe = I("wks"),
              ne = !K || !K.prototype || !K.prototype.findChild,
              re = l && u(function () {
                return 7 != y(J({}, "a", {
                  get: function () {
                    return J(this, "a", {
                      value: 7
                    }).a;
                  }
                })).a;
              }) ? function (e, t, o) {
                var n = X(U, t);
                n && delete U[t], J(e, t, o), n && e !== U && J(U, t, n);
              } : J,
              ie = function (e, t) {
                var o = ee[e] = y(Y);
                return H(o, {
                  type: F,
                  tag: e,
                  description: t
                }), l || (o.description = t), o;
              },
              ae = function (e, t, o) {
                e === U && ae(te, t, o), f(e);
                var n = m(t);
                return f(o), d(ee, n) ? (o.enumerable ? (d(e, q) && e[q][n] && (e[q][n] = !1), o = y(o, {
                  enumerable: g(0, !1)
                })) : (d(e, q) || J(e, q, g(1, {})), e[q][n] = !0), re(e, n, o)) : J(e, n, o);
              },
              se = function (e, t) {
                f(e);
                var o = h(t),
                  n = _(o).concat(de(o));
                return B(n, function (t) {
                  l && !i(le, o, t) || ae(e, t, o[t]);
                }), e;
              },
              le = function (e) {
                var t = m(e),
                  o = i(Z, this, t);
                return !(this === U && d(ee, t) && !d(te, t)) && (!(o || !d(this, t) || !d(ee, t) || d(this, q) && this[q][t]) || o);
              },
              ce = function (e, t) {
                var o = h(e),
                  n = m(t);
                if (o !== U || !d(ee, n) || d(te, n)) {
                  var r = X(o, n);
                  return !r || !d(ee, n) || d(o, q) && o[q][n] || (r.enumerable = !0), r;
                }
              },
              ue = function (e) {
                var t = $(h(e)),
                  o = [];
                return B(t, function (e) {
                  d(ee, e) || d(M, e) || Q(o, e);
                }), o;
              },
              de = function (e) {
                var t = e === U,
                  o = $(t ? te : h(e)),
                  n = [];
                return B(o, function (e) {
                  !d(ee, e) || t && !d(U, e) || Q(n, ee[e]);
                }), n;
              };
            c || (W = function () {
              if (p(Y, this)) throw G("Symbol is not a constructor");
              var e = arguments.length && void 0 !== arguments[0] ? v(arguments[0]) : void 0,
                t = D(e),
                o = function (e) {
                  this === U && i(o, te, e), d(this, q) && d(this[q], t) && (this[q][t] = !1), re(this, t, g(1, e));
                };
              return l && ne && re(U, t, {
                configurable: !0,
                set: o
              }), ie(t, e);
            }, k(Y = W.prototype, "toString", function () {
              return V(this).tag;
            }), k(W, "withoutSetter", function (e) {
              return ie(D(e), e);
            }), x.f = le, j.f = ae, E.f = se, C.f = ce, b.f = w.f = ue, S.f = de, z.f = function (e) {
              return ie(O(e), e);
            }, l && (T(Y, "description", {
              configurable: !0,
              get: function () {
                return V(this).description;
              }
            }), s || k(U, "propertyIsEnumerable", le, {
              unsafe: !0
            }))), n({
              global: !0,
              constructor: !0,
              wrap: !0,
              forced: !c,
              sham: !c
            }, {
              Symbol: W
            }), B(_(oe), function (e) {
              A(e);
            }), n({
              target: F,
              stat: !0,
              forced: !c
            }, {
              useSetter: function () {
                ne = !0;
              },
              useSimple: function () {
                ne = !1;
              }
            }), n({
              target: "Object",
              stat: !0,
              forced: !c,
              sham: !l
            }, {
              create: function (e, t) {
                return void 0 === t ? y(e) : se(y(e), t);
              },
              defineProperty: ae,
              defineProperties: se,
              getOwnPropertyDescriptor: ce
            }), n({
              target: "Object",
              stat: !0,
              forced: !c
            }, {
              getOwnPropertyNames: ue
            }), L(), N(W, F), M[q] = !0;
          },
          64514: function (e, t, o) {

            var n = o(50791),
              r = o(13873),
              i = o(37042),
              a = o(90838),
              s = o(14434),
              l = o(794),
              c = o(54671),
              u = o(63046),
              d = o(97548),
              p = o(58392),
              f = i.Symbol,
              h = f && f.prototype;
            if (r && l(f) && (!("description" in h) || void 0 !== f().description)) {
              var m = {},
                v = function () {
                  var e = 1 > arguments.length || void 0 === arguments[0] ? void 0 : u(arguments[0]),
                    t = c(h, this) ? new f(e) : void 0 === e ? f() : f(e);
                  return "" === e && (m[t] = !0), t;
                };
              p(v, f), v.prototype = h, h.constructor = v;
              var g = "Symbol(test)" == String(f("test")),
                y = a(h.valueOf),
                _ = a(h.toString),
                b = /^Symbol\((.*)\)[^)]+$/,
                w = a("".replace),
                S = a("".slice);
              d(h, "description", {
                configurable: !0,
                get: function () {
                  var e = y(this);
                  if (s(m, e)) return "";
                  var t = _(e),
                    o = g ? S(t, 7, -1) : w(t, b, "$1");
                  return "" === o ? void 0 : o;
                }
              }), n({
                global: !0,
                constructor: !0,
                forced: !0
              }, {
                Symbol: v
              });
            }
          },
          56202: function (e, t, o) {

            var n = o(50791),
              r = o(98945),
              i = o(14434),
              a = o(63046),
              s = o(95138),
              l = o(31948),
              c = s("string-to-symbol-registry"),
              u = s("symbol-to-string-registry");
            n({
              target: "Symbol",
              stat: !0,
              forced: !l
            }, {
              for: function (e) {
                var t = a(e);
                if (i(c, t)) return c[t];
                var o = r("Symbol")(t);
                return c[t] = o, u[o] = t, o;
              }
            });
          },
          30733: function (e, t, o) {

            o(89633)("hasInstance");
          },
          40327: function (e, t, o) {

            o(89633)("isConcatSpreadable");
          },
          53639: function (e, t, o) {

            o(89633)("iterator");
          },
          95661: function (e, t, o) {

            o(9656), o(56202), o(71940), o(67507), o(30165);
          },
          71940: function (e, t, o) {

            var n = o(50791),
              r = o(14434),
              i = o(88253),
              a = o(98418),
              s = o(95138),
              l = o(31948),
              c = s("symbol-to-string-registry");
            n({
              target: "Symbol",
              stat: !0,
              forced: !l
            }, {
              keyFor: function (e) {
                if (!i(e)) throw TypeError(a(e) + " is not a symbol");
                if (r(c, e)) return c[e];
              }
            });
          },
          7290: function (e, t, o) {

            o(89633)("matchAll");
          },
          6147: function (e, t, o) {

            o(89633)("match");
          },
          95122: function (e, t, o) {

            o(89633)("replace");
          },
          61322: function (e, t, o) {

            o(89633)("search");
          },
          39605: function (e, t, o) {

            o(89633)("species");
          },
          49341: function (e, t, o) {

            o(89633)("split");
          },
          28809: function (e, t, o) {

            var n = o(89633),
              r = o(13829);
            n("toPrimitive"), r();
          },
          82658: function (e, t, o) {

            var n = o(98945),
              r = o(89633),
              i = o(44532);
            r("toStringTag"), i(n("Symbol"), "Symbol");
          },
          43967: function (e, t, o) {

            o(89633)("unscopables");
          },
          690: function (e, t, o) {

            e.exports = o(26002).polyfill();
          },
          26002: function (e, t, o) {

            e.exports = function () {
              function e(e) {
                return "function" == typeof e;
              }
              var t = Array.isArray ? Array.isArray : function (e) {
                  return "[object Array]" === Object.prototype.toString.call(e);
                },
                n = 0,
                r = void 0,
                i = void 0,
                a = function (e, t) {
                  f[n] = e, f[n + 1] = t, 2 === (n += 2) && (i ? i(h) : _());
                },
                s = "undefined" != typeof window ? window : void 0,
                l = s || {},
                c = l.MutationObserver || l.WebKitMutationObserver,
                u = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
                d = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
              function p() {
                var e = setTimeout;
                return function () {
                  return e(h, 1);
                };
              }
              var f = new Array(1e3);
              function h() {
                for (var e = 0; n > e; e += 2) (0, f[e])(f[e + 1]), f[e] = void 0, f[e + 1] = void 0;
                n = 0;
              }
              var m,
                v,
                g,
                y,
                _ = void 0;
              function b(e, t) {
                var o = this,
                  n = new this.constructor(C);
                void 0 === n[S] && z(n);
                var r = o._state;
                if (r) {
                  var i = arguments[r - 1];
                  a(function () {
                    return D(r, n, i, o._result);
                  });
                } else P(o, n, e, t);
                return n;
              }
              function w(e) {
                if (e && "object" == typeof e && e.constructor === this) return e;
                var t = new this(C);
                return x(t, e), t;
              }
              _ = u ? function () {
                return process.nextTick(h);
              } : c ? (v = 0, g = new c(h), y = document.createTextNode(""), g.observe(y, {
                characterData: !0
              }), function () {
                y.data = v = ++v % 2;
              }) : d ? ((m = new MessageChannel()).port1.onmessage = h, function () {
                return m.port2.postMessage(0);
              }) : void 0 === s ? function () {
                try {
                  var e = Function("return this")().require("vertx");
                  return void 0 !== (r = e.runOnLoop || e.runOnContext) ? function () {
                    r(h);
                  } : p();
                } catch (e) {
                  return p();
                }
              }() : p();
              var S = Math.random().toString(36).substring(2);
              function C() {}
              var j = void 0;
              function E(t, o, n) {
                o.constructor === t.constructor && n === b && o.constructor.resolve === w ? function (e, t) {
                  1 === t._state ? T(e, t._result) : 2 === t._state ? I(e, t._result) : P(t, void 0, function (t) {
                    return x(e, t);
                  }, function (t) {
                    return I(e, t);
                  });
                }(t, o) : void 0 === n ? T(t, o) : e(n) ? function (e, t, o) {
                  a(function (e) {
                    var n = !1,
                      r = function (o, r, i, a) {
                        try {
                          o.call(r, function (o) {
                            n || (n = !0, t !== o ? x(e, o) : T(e, o));
                          }, function (t) {
                            n || (n = !0, I(e, t));
                          });
                        } catch (e) {
                          return e;
                        }
                      }(o, t);
                    !n && r && (n = !0, I(e, r));
                  }, e);
                }(t, o, n) : T(t, o);
              }
              function x(e, t) {
                if (e === t) I(e, new TypeError("You cannot resolve a promise with itself"));else if (r = typeof (n = t), null === n || "object" !== r && "function" !== r) T(e, t);else {
                  var o = void 0;
                  try {
                    o = t.then;
                  } catch (t) {
                    return void I(e, t);
                  }
                  E(e, t, o);
                }
                var n, r;
              }
              function k(e) {
                e._onerror && e._onerror(e._result), M(e);
              }
              function T(e, t) {
                e._state === j && (e._result = t, e._state = 1, 0 !== e._subscribers.length && a(M, e));
              }
              function I(e, t) {
                e._state === j && (e._state = 2, e._result = t, a(k, e));
              }
              function P(e, t, o, n) {
                var r = e._subscribers,
                  i = r.length;
                e._onerror = null, r[i] = t, r[i + 1] = o, r[i + 2] = n, 0 === i && e._state && a(M, e);
              }
              function M(e) {
                var t = e._subscribers,
                  o = e._state;
                if (0 !== t.length) {
                  for (var n = void 0, r = void 0, i = e._result, a = 0; t.length > a; a += 3) r = t[a + o], (n = t[a]) ? D(o, n, r, i) : r(i);
                  e._subscribers.length = 0;
                }
              }
              function D(t, o, n, r) {
                var i = e(n),
                  a = void 0,
                  s = void 0,
                  l = !0;
                if (i) {
                  try {
                    a = n(r);
                  } catch (e) {
                    l = !1, s = e;
                  }
                  if (o === a) return void I(o, new TypeError("A promises callback cannot return that same promise."));
                } else a = r;
                o._state !== j || (i && l ? x(o, a) : !1 === l ? I(o, s) : 1 === t ? T(o, a) : 2 === t && I(o, a));
              }
              var O = 0;
              function z(e) {
                e[S] = O++, e._state = void 0, e._result = void 0, e._subscribers = [];
              }
              var A = function () {
                  function e(e, o) {
                    this._instanceConstructor = e, this.promise = new e(C), this.promise[S] || z(this.promise), t(o) ? (this.length = o.length, this._remaining = o.length, this._result = new Array(this.length), 0 === this.length ? T(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(o), 0 === this._remaining && T(this.promise, this._result))) : I(this.promise, new Error("Array Methods must be provided an Array"));
                  }
                  return e.prototype._enumerate = function (e) {
                    for (var t = 0; this._state === j && e.length > t; t++) this._eachEntry(e[t], t);
                  }, e.prototype._eachEntry = function (e, t) {
                    var o = this._instanceConstructor,
                      n = o.resolve;
                    if (n === w) {
                      var r = void 0,
                        i = void 0,
                        a = !1;
                      try {
                        r = e.then;
                      } catch (e) {
                        a = !0, i = e;
                      }
                      if (r === b && e._state !== j) this._settledAt(e._state, t, e._result);else if ("function" != typeof r) this._remaining--, this._result[t] = e;else if (o === L) {
                        var s = new o(C);
                        a ? I(s, i) : E(s, e, r), this._willSettleAt(s, t);
                      } else this._willSettleAt(new o(function (t) {
                        return t(e);
                      }), t);
                    } else this._willSettleAt(n(e), t);
                  }, e.prototype._settledAt = function (e, t, o) {
                    var n = this.promise;
                    n._state === j && (this._remaining--, 2 === e ? I(n, o) : this._result[t] = o), 0 === this._remaining && T(n, this._result);
                  }, e.prototype._willSettleAt = function (e, t) {
                    var o = this;
                    P(e, void 0, function (e) {
                      return o._settledAt(1, t, e);
                    }, function (e) {
                      return o._settledAt(2, t, e);
                    });
                  }, e;
                }(),
                L = function () {
                  function t(e) {
                    this[S] = O++, this._result = this._state = void 0, this._subscribers = [], C !== e && ("function" != typeof e && function () {
                      throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                    }(), this instanceof t ? function (e, t) {
                      try {
                        t(function (t) {
                          x(e, t);
                        }, function (t) {
                          I(e, t);
                        });
                      } catch (t) {
                        I(e, t);
                      }
                    }(this, e) : function () {
                      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                    }());
                  }
                  return t.prototype.catch = function (e) {
                    return this.then(null, e);
                  }, t.prototype.finally = function (t) {
                    var o = this,
                      n = o.constructor;
                    return e(t) ? o.then(function (e) {
                      return n.resolve(t()).then(function () {
                        return e;
                      });
                    }, function (e) {
                      return n.resolve(t()).then(function () {
                        throw e;
                      });
                    }) : o.then(t, t);
                  }, t;
                }();
              return L.prototype.then = b, L.all = function (e) {
                return new A(this, e).promise;
              }, L.race = function (e) {
                var o = this;
                return t(e) ? new o(function (t, n) {
                  for (var r = e.length, i = 0; r > i; i++) o.resolve(e[i]).then(t, n);
                }) : new o(function (e, t) {
                  return t(new TypeError("You must pass an array to race."));
                });
              }, L.resolve = w, L.reject = function (e) {
                var t = new this(C);
                return I(t, e), t;
              }, L._setScheduler = function (e) {
                i = e;
              }, L._setAsap = function (e) {
                a = e;
              }, L._asap = a, L.polyfill = function () {
                var e = void 0;
                if (void 0 !== o.g) e = o.g;else if ("undefined" != typeof self) e = self;else try {
                  e = Function("return this")();
                } catch (e) {
                  throw new Error("polyfill failed because global object is unavailable in this environment");
                }
                var t = e.Promise;
                if (t) {
                  var n = null;
                  try {
                    n = Object.prototype.toString.call(t.resolve());
                  } catch (e) {}
                  if ("[object Promise]" === n && !t.cast) return;
                }
                e.Promise = L;
              }, L.Promise = L, L;
            }();
          },
          20255: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.__classPrivateFieldIn = t.__classPrivateFieldSet = t.__classPrivateFieldGet = t.__importDefault = t.__importStar = t.__makeTemplateObject = t.__asyncValues = t.__asyncDelegator = t.__asyncGenerator = t.__await = t.__spreadArray = t.__spreadArrays = t.__spread = t.__read = t.__values = t.__exportStar = t.__createBinding = t.__generator = t.__awaiter = t.__metadata = t.__setFunctionName = t.__propKey = t.__runInitializers = t.__esDecorate = t.__param = t.__decorate = t.__rest = t.__assign = t.__extends = void 0;
            var o = function (e, t) {
              return o = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (e, t) {
                e.__proto__ = t;
              } || function (e, t) {
                for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }, o(e, t);
            };
            function n(e) {
              var t = "function" == typeof Symbol && Symbol.iterator,
                o = t && e[t],
                n = 0;
              if (o) return o.call(e);
              if (e && "number" == typeof e.length) return {
                next: function () {
                  return e && n >= e.length && (e = void 0), {
                    value: e && e[n++],
                    done: !e
                  };
                }
              };
              throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }
            function r(e, t) {
              var o = "function" == typeof Symbol && e[Symbol.iterator];
              if (!o) return e;
              var n,
                r,
                i = o.call(e),
                a = [];
              try {
                for (; (void 0 === t || t-- > 0) && !(n = i.next()).done;) a.push(n.value);
              } catch (e) {
                r = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (o = i.return) && o.call(i);
                } finally {
                  if (r) throw r.error;
                }
              }
              return a;
            }
            function i(e) {
              return this instanceof i ? (this.v = e, this) : new i(e);
            }
            t.__extends = function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
              function n() {
                this.constructor = e;
              }
              o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
            }, t.__assign = function () {
              return t.__assign = Object.assign || function (e) {
                for (var t, o = 1, n = arguments.length; n > o; o++) for (var r in t = arguments[o]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              }, t.__assign.apply(this, arguments);
            }, t.__rest = function (e, t) {
              var o = {};
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (o[n] = e[n]);
              if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                var r = 0;
                for (n = Object.getOwnPropertySymbols(e); n.length > r; r++) 0 > t.indexOf(n[r]) && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
              }
              return o;
            }, t.__decorate = function (e, t, o, n) {
              var r,
                i = arguments.length,
                a = 3 > i ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
              if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);else for (var s = e.length - 1; s >= 0; s--) (r = e[s]) && (a = (3 > i ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
              return i > 3 && a && Object.defineProperty(t, o, a), a;
            }, t.__param = function (e, t) {
              return function (o, n) {
                t(o, n, e);
              };
            }, t.__esDecorate = function (e, t, o, n, r, i) {
              function a(e) {
                if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                return e;
              }
              for (var s, l = n.kind, c = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), p = !1, f = o.length - 1; f >= 0; f--) {
                var h = {};
                for (var m in n) h[m] = "access" === m ? {} : n[m];
                for (var m in n.access) h.access[m] = n.access[m];
                h.addInitializer = function (e) {
                  if (p) throw new TypeError("Cannot add initializers after decoration has completed");
                  i.push(a(e || null));
                };
                var v = (0, o[f])("accessor" === l ? {
                  get: d.get,
                  set: d.set
                } : d[c], h);
                if ("accessor" === l) {
                  if (void 0 === v) continue;
                  if (null === v || "object" != typeof v) throw new TypeError("Object expected");
                  (s = a(v.get)) && (d.get = s), (s = a(v.set)) && (d.set = s), (s = a(v.init)) && r.push(s);
                } else (s = a(v)) && ("field" === l ? r.push(s) : d[c] = s);
              }
              u && Object.defineProperty(u, n.name, d), p = !0;
            }, t.__runInitializers = function (e, t, o) {
              for (var n = arguments.length > 2, r = 0; t.length > r; r++) o = n ? t[r].call(e, o) : t[r].call(e);
              return n ? o : void 0;
            }, t.__propKey = function (e) {
              return "symbol" == typeof e ? e : "".concat(e);
            }, t.__setFunctionName = function (e, t, o) {
              return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                configurable: !0,
                value: o ? "".concat(o, " ", t) : t
              });
            }, t.__metadata = function (e, t) {
              if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            }, t.__awaiter = function (e, t, o, n) {
              return new (o || (o = Promise))(function (r, i) {
                function a(e) {
                  try {
                    l(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function s(e) {
                  try {
                    l(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function l(e) {
                  var t;
                  e.done ? r(e.value) : (t = e.value, t instanceof o ? t : new o(function (e) {
                    e(t);
                  })).then(a, s);
                }
                l((n = n.apply(e, t || [])).next());
              });
            }, t.__generator = function (e, t) {
              var o,
                n,
                r,
                i,
                a = {
                  label: 0,
                  sent: function () {
                    if (1 & r[0]) throw r[1];
                    return r[1];
                  },
                  trys: [],
                  ops: []
                };
              return i = {
                next: s(0),
                throw: s(1),
                return: s(2)
              }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
                return this;
              }), i;
              function s(s) {
                return function (l) {
                  return function (s) {
                    if (o) throw new TypeError("Generator is already executing.");
                    for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                      if (o = 1, n && (r = 2 & s[0] ? n.return : s[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, s[1])).done) return r;
                      switch (n = 0, r && (s = [2 & s[0], r.value]), s[0]) {
                        case 0:
                        case 1:
                          r = s;
                          break;
                        case 4:
                          return a.label++, {
                            value: s[1],
                            done: !1
                          };
                        case 5:
                          a.label++, n = s[1], s = [0];
                          continue;
                        case 7:
                          s = a.ops.pop(), a.trys.pop();
                          continue;
                        default:
                          if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                            a = 0;
                            continue;
                          }
                          if (3 === s[0] && (!r || s[1] > r[0] && r[3] > s[1])) {
                            a.label = s[1];
                            break;
                          }
                          if (6 === s[0] && r[1] > a.label) {
                            a.label = r[1], r = s;
                            break;
                          }
                          if (r && r[2] > a.label) {
                            a.label = r[2], a.ops.push(s);
                            break;
                          }
                          r[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      s = t.call(e, a);
                    } catch (e) {
                      s = [6, e], n = 0;
                    } finally {
                      o = r = 0;
                    }
                    if (5 & s[0]) throw s[1];
                    return {
                      value: s[0] ? s[1] : void 0,
                      done: !0
                    };
                  }([s, l]);
                };
              }
            }, t.__createBinding = Object.create ? function (e, t, o, n) {
              void 0 === n && (n = o);
              var r = Object.getOwnPropertyDescriptor(t, o);
              r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                enumerable: !0,
                get: function () {
                  return t[o];
                }
              }), Object.defineProperty(e, n, r);
            } : function (e, t, o, n) {
              void 0 === n && (n = o), e[n] = t[o];
            }, t.__exportStar = function (e, o) {
              for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(o, n) || (0, t.__createBinding)(o, e, n);
            }, t.__values = n, t.__read = r, t.__spread = function () {
              for (var e = [], t = 0; arguments.length > t; t++) e = e.concat(r(arguments[t]));
              return e;
            }, t.__spreadArrays = function () {
              for (var e = 0, t = 0, o = arguments.length; o > t; t++) e += arguments[t].length;
              var n = Array(e),
                r = 0;
              for (t = 0; o > t; t++) for (var i = arguments[t], a = 0, s = i.length; s > a; a++, r++) n[r] = i[a];
              return n;
            }, t.__spreadArray = function (e, t, o) {
              if (o || 2 === arguments.length) for (var n, r = 0, i = t.length; i > r; r++) !n && r in t || (n || (n = Array.prototype.slice.call(t, 0, r)), n[r] = t[r]);
              return e.concat(n || Array.prototype.slice.call(t));
            }, t.__await = i, t.__asyncGenerator = function (e, t, o) {
              if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
              var n,
                r = o.apply(e, t || []),
                a = [];
              return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function () {
                return this;
              }, n;
              function s(e) {
                r[e] && (n[e] = function (t) {
                  return new Promise(function (o, n) {
                    a.push([e, t, o, n]) > 1 || l(e, t);
                  });
                });
              }
              function l(e, t) {
                try {
                  (o = r[e](t)).value instanceof i ? Promise.resolve(o.value.v).then(c, u) : d(a[0][2], o);
                } catch (e) {
                  d(a[0][3], e);
                }
                var o;
              }
              function c(e) {
                l("next", e);
              }
              function u(e) {
                l("throw", e);
              }
              function d(e, t) {
                e(t), a.shift(), a.length && l(a[0][0], a[0][1]);
              }
            }, t.__asyncDelegator = function (e) {
              var t, o;
              return t = {}, n("next"), n("throw", function (e) {
                throw e;
              }), n("return"), t[Symbol.iterator] = function () {
                return this;
              }, t;
              function n(n, r) {
                t[n] = e[n] ? function (t) {
                  return (o = !o) ? {
                    value: i(e[n](t)),
                    done: !1
                  } : r ? r(t) : t;
                } : r;
              }
            }, t.__asyncValues = function (e) {
              if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
              var t,
                o = e[Symbol.asyncIterator];
              return o ? o.call(e) : (e = n(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
                return this;
              }, t);
              function r(o) {
                t[o] = e[o] && function (t) {
                  return new Promise(function (n, r) {
                    !function (e, t, o, n) {
                      Promise.resolve(n).then(function (t) {
                        e({
                          value: t,
                          done: o
                        });
                      }, t);
                    }(n, r, (t = e[o](t)).done, t.value);
                  });
                };
              }
            }, t.__makeTemplateObject = function (e, t) {
              return Object.defineProperty ? Object.defineProperty(e, "raw", {
                value: t
              }) : e.raw = t, e;
            };
            var a = Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            };
            t.__importStar = function (e) {
              if (e && e.__esModule) return e;
              var o = {};
              if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && (0, t.__createBinding)(o, e, n);
              return a(o, e), o;
            }, t.__importDefault = function (e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }, t.__classPrivateFieldGet = function (e, t, o, n) {
              if ("a" === o && !n) throw new TypeError("Private accessor was defined without a getter");
              if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
              return "m" === o ? n : "a" === o ? n.call(e) : n ? n.value : t.get(e);
            }, t.__classPrivateFieldSet = function (e, t, o, n, r) {
              if ("m" === n) throw new TypeError("Private method is not writable");
              if ("a" === n && !r) throw new TypeError("Private accessor was defined without a setter");
              if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
              return "a" === n ? r.call(e, o) : r ? r.value = o : t.set(e, o), o;
            }, t.__classPrivateFieldIn = function (e, t) {
              if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
              return "function" == typeof e ? t === e : e.has(t);
            };
          },
          93166: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Config = void 0;
            var n = o(86893),
              r = o(86893),
              i = function () {
                function e() {
                  this.defaultTimeout = 100, this.namespace = "", this.safeMode = !1, this.width = "auto", this.height = "auto", this.safePluginsList = ["about", "enter", "backspace", "size"], this.license = "", this.preset = "custom", this.presets = {
                    inline: {
                      inline: !0,
                      toolbar: !1,
                      toolbarInline: !0,
                      toolbarInlineForSelection: !0,
                      showXPathInStatusbar: !1,
                      showCharsCounter: !1,
                      showWordsCounter: !1,
                      showPlaceholder: !1
                    }
                  }, this.ownerDocument = "undefined" != typeof document ? document : null, this.ownerWindow = "undefined" != typeof window ? window : null, this.shadowRoot = null, this.zIndex = 0, this.readonly = !1, this.disabled = !1, this.activeButtonsInReadOnly = ["source", "fullsize", "print", "about", "dots", "selectall"], this.allowCommandsInReadOnly = ["selectall", "preview", "print"], this.toolbarButtonSize = "middle", this.allowTabNavigation = !1, this.inline = !1, this.theme = "default", this.saveModeInStorage = !1, this.editorClassName = !1, this.editorCssClass = !1, this.className = !1, this.style = !1, this.containerStyle = !1, this.styleValues = {}, this.triggerChangeEvent = !0, this.direction = "", this.language = "auto", this.debugLanguage = !1, this.i18n = !1, this.tabIndex = -1, this.toolbar = !0, this.statusbar = !0, this.showTooltip = !0, this.showTooltipDelay = 1e3, this.useNativeTooltip = !1, this.defaultActionOnPaste = r.INSERT_AS_HTML, this.enter = n.PARAGRAPH, this.iframe = !1, this.editHTMLDocumentMode = !1, this.enterBlock = "br" !== this.enter ? this.enter : n.PARAGRAPH, this.defaultMode = n.MODE_WYSIWYG, this.useSplitMode = !1, this.colors = {
                    greyscale: ["#000000", "#434343", "#666666", "#999999", "#B7B7B7", "#CCCCCC", "#D9D9D9", "#EFEFEF", "#F3F3F3", "#FFFFFF"],
                    palette: ["#980000", "#FF0000", "#FF9900", "#FFFF00", "#00F0F0", "#00FFFF", "#4A86E8", "#0000FF", "#9900FF", "#FF00FF"],
                    full: ["#E6B8AF", "#F4CCCC", "#FCE5CD", "#FFF2CC", "#D9EAD3", "#D0E0E3", "#C9DAF8", "#CFE2F3", "#D9D2E9", "#EAD1DC", "#DD7E6B", "#EA9999", "#F9CB9C", "#FFE599", "#B6D7A8", "#A2C4C9", "#A4C2F4", "#9FC5E8", "#B4A7D6", "#D5A6BD", "#CC4125", "#E06666", "#F6B26B", "#FFD966", "#93C47D", "#76A5AF", "#6D9EEB", "#6FA8DC", "#8E7CC3", "#C27BA0", "#A61C00", "#CC0000", "#E69138", "#F1C232", "#6AA84F", "#45818E", "#3C78D8", "#3D85C6", "#674EA7", "#A64D79", "#85200C", "#990000", "#B45F06", "#BF9000", "#38761D", "#134F5C", "#1155CC", "#0B5394", "#351C75", "#733554", "#5B0F00", "#660000", "#783F04", "#7F6000", "#274E13", "#0C343D", "#1C4587", "#073763", "#20124D", "#4C1130"]
                  }, this.colorPickerDefaultTab = "background", this.imageDefaultWidth = 300, this.removeButtons = [], this.disablePlugins = [], this.extraPlugins = [], this.extraButtons = [], this.extraIcons = {}, this.createAttributes = {
                    table: {
                      style: "border-collapse:collapse;width: 100%;"
                    }
                  }, this.sizeLG = 900, this.sizeMD = 700, this.sizeSM = 400, this.buttons = [{
                    group: "font-style",
                    buttons: []
                  }, {
                    group: "list",
                    buttons: []
                  }, {
                    group: "font",
                    buttons: []
                  }, "---", {
                    group: "script",
                    buttons: []
                  }, {
                    group: "media",
                    buttons: []
                  }, "\n", {
                    group: "state",
                    buttons: []
                  }, {
                    group: "clipboard",
                    buttons: []
                  }, {
                    group: "insert",
                    buttons: []
                  }, {
                    group: "indent",
                    buttons: []
                  }, {
                    group: "color",
                    buttons: []
                  }, {
                    group: "form",
                    buttons: []
                  }, "---", {
                    group: "history",
                    buttons: []
                  }, {
                    group: "search",
                    buttons: []
                  }, {
                    group: "source",
                    buttons: []
                  }, {
                    group: "other",
                    buttons: []
                  }, {
                    group: "info",
                    buttons: []
                  }], this.buttonsMD = ["bold", "italic", "|", "ul", "ol", "eraser", "|", "font", "fontsize", "---", "image", "table", "|", "link", "\n", "brush", "paragraph", "align", "|", "hr", "copyformat", "fullsize", "---", "undo", "redo", "|", "dots"], this.buttonsSM = ["bold", "italic", "|", "ul", "ol", "eraser", "|", "fontsize", "brush", "paragraph", "---", "image", "table", "\n", "link", "|", "align", "|", "undo", "redo", "|", "copyformat", "fullsize", "---", "dots"], this.buttonsXS = ["bold", "brush", "paragraph", "eraser", "|", "fontsize", "---", "image", "\n", "align", "undo", "redo", "|", "link", "table", "---", "dots"], this.events = {}, this.textIcons = !1, this.showBrowserColorPicker = !0;
                }
                return Object.defineProperty(e, "defaultOptions", {
                  get: function () {
                    return e.__defaultOptions || (e.__defaultOptions = new e()), e.__defaultOptions;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e;
              }();
            t.Config = i, i.prototype.controls = {};
          },
          77536: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Async = void 0;
            var n = o(20255),
              r = o(4696),
              i = o(42096),
              a = o(79736),
              s = o(26335),
              l = o(24421),
              c = o(61817),
              u = (o(52378), function () {
                function e() {
                  var e,
                    t,
                    o,
                    n,
                    r = this;
                  this.timers = new Map(), this.__callbacks = new Map(), this.promisesRejections = new Set(), this.requestsIdle = new Set(), this.requestsRaf = new Set(), this.requestIdleCallbackNative = null !== (t = null === (e = window.requestIdleCallback) || void 0 === e ? void 0 : e.bind(window)) && void 0 !== t ? t : function (e, t) {
                    var o,
                      n = Date.now();
                    return r.setTimeout(function () {
                      e({
                        didTimeout: !1,
                        timeRemaining: function () {
                          return Math.max(0, 50 - (Date.now() - n));
                        }
                      });
                    }, null !== (o = null == t ? void 0 : t.timeout) && void 0 !== o ? o : 1);
                  }, this.cancelIdleCallbackNative = null !== (n = null === (o = window.cancelIdleCallback) || void 0 === o ? void 0 : o.bind(window)) && void 0 !== n ? n : function (e) {
                    r.clearTimeout(e);
                  }, this.isDestructed = !1;
                }
                return e.prototype.delay = function (e) {
                  var t = this;
                  return this.promise(function (o) {
                    return t.setTimeout(o, e);
                  });
                }, e.prototype.setTimeout = function (e, t) {
                  for (var o = [], i = 2; arguments.length > i; i++) o[i - 2] = arguments[i];
                  if (this.isDestructed) return 0;
                  var a = {};
                  (0, c.isNumber)(t) || (t = (a = t).timeout || 0), a.label && this.clearLabel(a.label);
                  var s = r.setTimeout.apply(void 0, n.__spreadArray([e, t], n.__read(o), !1)),
                    l = a.label || s;
                  return this.timers.set(l, s), this.__callbacks.set(l, e), s;
                }, e.prototype.updateTimeout = function (e, t) {
                  if (!e || !this.timers.has(e)) return null;
                  var o = this.__callbacks.get(e);
                  return this.setTimeout(o, {
                    label: e,
                    timeout: t
                  });
                }, e.prototype.clearLabel = function (e) {
                  e && this.timers.has(e) && ((0, r.clearTimeout)(this.timers.get(e)), this.timers.delete(e), this.__callbacks.delete(e));
                }, e.prototype.clearTimeout = function (e) {
                  if ((0, l.isString)(e)) return this.clearLabel(e);
                  (0, r.clearTimeout)(e), this.timers.delete(e), this.__callbacks.delete(e);
                }, e.prototype.debounce = function (e, t, o) {
                  var l = this;
                  void 0 === o && (o = !1);
                  var c = 0,
                    u = !1,
                    d = [],
                    p = function () {
                      for (var t = [], o = 0; arguments.length > o; o++) t[o] = arguments[o];
                      if (!u) {
                        c = 0;
                        var r = e.apply(void 0, n.__spreadArray([], n.__read(t), !1));
                        if (u = !0, d.length) {
                          var i = function () {
                            d.forEach(function (e) {
                              return e();
                            }), d.length = 0;
                          };
                          (0, s.isPromise)(r) ? r.finally(i) : i();
                        }
                      }
                    },
                    f = function () {
                      for (var a = [], s = 0; arguments.length > s; s++) a[s] = arguments[s];
                      u = !1, t ? (!c && o && p.apply(void 0, n.__spreadArray([], n.__read(a), !1)), (0, r.clearTimeout)(c), c = l.setTimeout(function () {
                        return p.apply(void 0, n.__spreadArray([], n.__read(a), !1));
                      }, (0, i.isFunction)(t) ? t() : t), l.timers.set(e, c)) : p.apply(void 0, n.__spreadArray([], n.__read(a), !1));
                    };
                  return (0, a.isPlainObject)(t) && t.promisify ? function () {
                    for (var e = [], t = 0; arguments.length > t; t++) e[t] = arguments[t];
                    var o = l.promise(function (e) {
                      d.push(e);
                    });
                    return f.apply(void 0, n.__spreadArray([], n.__read(e), !1)), o;
                  } : f;
                }, e.prototype.throttle = function (e, t, o) {
                  var r = this;
                  var a,
                    s,
                    l,
                    c = null;
                  return function () {
                    for (var o = [], u = 0; arguments.length > u; u++) o[u] = arguments[u];
                    a = !0, l = o, t ? c || (s = function () {
                      a ? (e.apply(void 0, n.__spreadArray([], n.__read(l), !1)), a = !1, c = r.setTimeout(s, (0, i.isFunction)(t) ? t() : t), r.timers.set(s, c)) : c = null;
                    })() : e.apply(void 0, n.__spreadArray([], n.__read(l), !1));
                  };
                }, e.prototype.promise = function (e) {
                  var t = this,
                    o = function () {},
                    n = new Promise(function (n, r) {
                      return t.promisesRejections.add(r), o = r, e(n, r);
                    });
                  return n.finally || (n.finally = function (e) {
                    return n.then(e).catch(e), n;
                  }), n.finally(function () {
                    t.promisesRejections.delete(o);
                  }).catch(function () {
                    return null;
                  }), n.rejectCallback = o, n;
                }, e.prototype.promiseState = function (e) {
                  var t = this;
                  if (e.status) return e.status;
                  if (!Promise.race) return new Promise(function (o) {
                    e.then(function (e) {
                      return o("fulfilled"), e;
                    }, function (e) {
                      throw o("rejected"), e;
                    }), t.setTimeout(function () {
                      o("pending");
                    }, 100);
                  });
                  var o = {};
                  return Promise.race([e, o]).then(function (e) {
                    return e === o ? "pending" : "fulfilled";
                  }, function () {
                    return "rejected";
                  });
                }, e.prototype.requestIdleCallback = function (e, t) {
                  var o = this.requestIdleCallbackNative(e, t);
                  return this.requestsIdle.add(o), o;
                }, e.prototype.requestIdlePromise = function (e) {
                  var t = this;
                  return this.promise(function (o) {
                    var n = t.requestIdleCallback(function () {
                      return o(n);
                    }, e);
                  });
                }, e.prototype.cancelIdleCallback = function (e) {
                  return this.requestsIdle.delete(e), this.cancelIdleCallbackNative(e);
                }, e.prototype.requestAnimationFrame = function (e) {
                  var t = requestAnimationFrame(e);
                  return this.requestsRaf.add(t), t;
                }, e.prototype.cancelAnimationFrame = function (e) {
                  this.requestsRaf.delete(e), cancelAnimationFrame(e);
                }, e.prototype.clear = function () {
                  var e = this;
                  this.requestsIdle.forEach(function (t) {
                    return e.cancelIdleCallback(t);
                  }), this.requestsRaf.forEach(function (t) {
                    return e.cancelAnimationFrame(t);
                  }), this.timers.forEach(function (t) {
                    return (0, r.clearTimeout)(e.timers.get(t));
                  }), this.timers.clear(), this.promisesRejections.forEach(function (e) {
                    return e();
                  }), this.promisesRejections.clear();
                }, e.prototype.destruct = function () {
                  this.clear(), this.isDestructed = !0;
                }, e;
              }());
            t.Async = u;
          },
          22630: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(77536), t);
          },
          45113: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Component = void 0;
            var n = o(40332),
              r = o(17332),
              i = o(29411),
              a = o(22630),
              s = new Map(),
              l = function () {
                function e() {
                  this.async = new a.Async(), this.ownerWindow = window, this.__componentStatus = i.STATUSES.beforeInit, this.uid = "jodit-uid-" + (0, r.uniqueUid)();
                }
                return Object.defineProperty(e.prototype, "componentName", {
                  get: function () {
                    return this.__componentName || (this.__componentName = "jodit-" + (0, n.kebabCase)(((0, n.isFunction)(this.className) ? this.className() : "") || (0, n.getClassName)(this))), this.__componentName;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.getFullElName = function (e, t, o) {
                  var r = [this.componentName];
                  return e && (e = e.replace(/[^a-z0-9-]/gi, "-"), r.push("__".concat(e))), t && (r.push("_", t), r.push("_", (0, n.isVoid)(o) ? "true" : o.toString())), r.join("");
                }, Object.defineProperty(e.prototype, "ownerDocument", {
                  get: function () {
                    return this.ow.document;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "od", {
                  get: function () {
                    return this.ownerDocument;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "ow", {
                  get: function () {
                    return this.ownerWindow;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.get = function (e, t) {
                  return (0, n.get)(e, t || this);
                }, Object.defineProperty(e.prototype, "isReady", {
                  get: function () {
                    return this.componentStatus === i.STATUSES.ready;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "isDestructed", {
                  get: function () {
                    return this.componentStatus === i.STATUSES.destructed;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "isInDestruct", {
                  get: function () {
                    return i.STATUSES.beforeDestruct === this.componentStatus || i.STATUSES.destructed === this.componentStatus;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.bindDestruct = function (e) {
                  var t = this;
                  return e.hookStatus(i.STATUSES.beforeDestruct, function () {
                    return !t.isInDestruct && t.destruct();
                  }), this;
                }, e.prototype.destruct = function () {
                  this.setStatus(i.STATUSES.destructed), this.async.destruct(), s.get(this) && s.delete(this);
                }, Object.defineProperty(e.prototype, "componentStatus", {
                  get: function () {
                    return this.__componentStatus;
                  },
                  set: function (e) {
                    this.setStatus(e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.setStatus = function (e) {
                  return this.setStatusComponent(e, this);
                }, e.prototype.setStatusComponent = function (e, t) {
                  if (e !== this.__componentStatus) {
                    t === this && (this.__componentStatus = e);
                    var o = Object.getPrototypeOf(this);
                    o && (0, n.isFunction)(o.setStatusComponent) && o.setStatusComponent(e, t);
                    var r = s.get(this),
                      i = null == r ? void 0 : r[e];
                    i && i.length && i.forEach(function (e) {
                      return e(t);
                    });
                  }
                }, e.prototype.hookStatus = function (e, t) {
                  var o = s.get(this);
                  o || s.set(this, o = {}), o[e] || (o[e] = []), o[e].push(t);
                }, e.isInstanceOf = function (e, t) {
                  return e instanceof t;
                }, e.STATUSES = i.STATUSES, e;
              }();
            t.Component = l;
          },
          56562: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(29411), t), n.__exportStar(o(45113), t), n.__exportStar(o(39840), t);
          },
          29411: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.STATUSES = void 0, t.STATUSES = {
              beforeInit: "beforeInit",
              ready: "ready",
              beforeDestruct: "beforeDestruct",
              destructed: "destructed"
            };
          },
          39840: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ViewComponent = void 0;
            var n = o(20255),
              r = function (e) {
                function t(t) {
                  var o = e.call(this) || this;
                  return o.setParentView(t), o;
                }
                return n.__extends(t, e), Object.defineProperty(t.prototype, "j", {
                  get: function () {
                    return this.jodit;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "defaultTimeout", {
                  get: function () {
                    return this.j.defaultTimeout;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.i18n = function (e) {
                  for (var t, o = [], r = 1; arguments.length > r; r++) o[r - 1] = arguments[r];
                  return (t = this.j).i18n.apply(t, n.__spreadArray([e], n.__read(o), !1));
                }, t.prototype.setParentView = function (e) {
                  return this.jodit = e, e.components.add(this), this;
                }, t.prototype.destruct = function () {
                  return this.j.components.delete(this), e.prototype.destruct.call(this);
                }, t;
              }(o(45113).Component);
            t.ViewComponent = r;
          },
          86893: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.CLIPBOARD_ID = t.lang = t.TEMP_ATTR = t.BASE_PATH = t.KEY_ALIASES = t.IS_MAC = t.SAFE_COUNT_CHANGE_CALL = t.INSERT_ONLY_TEXT = t.INSERT_AS_TEXT = t.INSERT_CLEAR_HTML = t.INSERT_AS_HTML = t.EMULATE_DBLCLICK_TIMEOUT = t.MARKER_CLASS = t.TEXT_RTF = t.TEXT_HTML = t.TEXT_PLAIN = t.IS_IE = t.MODE_SPLIT = t.MODE_SOURCE = t.MODE_WYSIWYG = t.PARAGRAPH = t.BR = t.COMMAND_KEYS = t.ACCURACY = t.NEARBY = t.KEY_F3 = t.KEY_DELETE = t.KEY_SPACE = t.KEY_DOWN = t.KEY_RIGHT = t.KEY_UP = t.KEY_LEFT = t.KEY_ALT = t.KEY_ESC = t.KEY_ENTER = t.KEY_TAB = t.KEY_BACKSPACE = t.KEY_META = t.NO_EMPTY_TAGS = t.INSEPARABLE_TAGS = t.IS_INLINE = t.IS_BLOCK = t.SPACE_REG_EXP_END = t.SPACE_REG_EXP_START = t.SPACE_REG_EXP = t.INVISIBLE_SPACE_REG_EXP_START = t.INVISIBLE_SPACE_REG_EXP_END = t.INVISIBLE_SPACE_REG_EXP = t.NBSP_SPACE = t.INVISIBLE_SPACE = void 0, t.SOURCE_CONSUMER = void 0;
            var n = o(20255);
            t.INVISIBLE_SPACE = "\ufeff", t.NBSP_SPACE = " ", t.INVISIBLE_SPACE_REG_EXP = function () {
              return /[\uFEFF]/g;
            }, t.INVISIBLE_SPACE_REG_EXP_END = function () {
              return /[\uFEFF]+$/g;
            }, t.INVISIBLE_SPACE_REG_EXP_START = function () {
              return /^[\uFEFF]+/g;
            }, t.SPACE_REG_EXP = function () {
              return /[\s\n\t\r\uFEFF\u200b]+/g;
            }, t.SPACE_REG_EXP_START = function () {
              return /^[\s\n\t\r\uFEFF\u200b]+/g;
            }, t.SPACE_REG_EXP_END = function () {
              return /[\s\n\t\r\uFEFF\u200b]+$/g;
            }, t.IS_BLOCK = /^(ADDRESS|ARTICLE|ASIDE|BLOCKQUOTE|CANVAS|DD|DFN|DIV|DL|DT|FIELDSET|FIGCAPTION|FIGURE|FOOTER|FORM|H[1-6]|HEADER|HGROUP|HR|LI|MAIN|NAV|NOSCRIPT|OUTPUT|P|PRE|RUBY|SCRIPT|STYLE|OBJECT|OL|SECTION|IFRAME|JODIT|JODIT-MEDIA|UL|TR|TD|TH|TBODY|THEAD|TFOOT|TABLE|BODY|HTML|VIDEO)$/i, t.IS_INLINE = /^(STRONG|SPAN|I|EM|B|SUP|SUB|A|U)$/i;
            var r = ["img", "video", "svg", "iframe", "script", "input", "textarea", "link", "jodit", "jodit-media"];
            t.INSEPARABLE_TAGS = new Set(n.__spreadArray(n.__spreadArray([], n.__read(r), !1), ["br", "hr"], !1)), t.NO_EMPTY_TAGS = new Set(r), t.KEY_META = "Meta", t.KEY_BACKSPACE = "Backspace", t.KEY_TAB = "Tab", t.KEY_ENTER = "Enter", t.KEY_ESC = "Escape", t.KEY_ALT = "Alt", t.KEY_LEFT = "ArrowLeft", t.KEY_UP = "ArrowUp", t.KEY_RIGHT = "ArrowRight", t.KEY_DOWN = "ArrowDown", t.KEY_SPACE = "Space", t.KEY_DELETE = "Delete", t.KEY_F3 = "F3", t.NEARBY = 5, t.ACCURACY = 10, t.COMMAND_KEYS = [t.KEY_META, t.KEY_BACKSPACE, t.KEY_DELETE, t.KEY_UP, t.KEY_DOWN, t.KEY_RIGHT, t.KEY_LEFT, t.KEY_ENTER, t.KEY_ESC, t.KEY_F3, t.KEY_TAB], t.BR = "br", t.PARAGRAPH = "p", t.MODE_WYSIWYG = 1, t.MODE_SOURCE = 2, t.MODE_SPLIT = 3, t.IS_IE = "undefined" != typeof navigator && (-1 !== navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent)), t.TEXT_PLAIN = t.IS_IE ? "text" : "text/plain", t.TEXT_HTML = t.IS_IE ? "html" : "text/html", t.TEXT_RTF = t.IS_IE ? "rtf" : "text/rtf", t.MARKER_CLASS = "jodit-selection_marker", t.EMULATE_DBLCLICK_TIMEOUT = 300, t.INSERT_AS_HTML = "insert_as_html", t.INSERT_CLEAR_HTML = "insert_clear_html", t.INSERT_AS_TEXT = "insert_as_text", t.INSERT_ONLY_TEXT = "insert_only_text", t.SAFE_COUNT_CHANGE_CALL = 10, t.IS_MAC = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), t.KEY_ALIASES = {
              add: "+",
              break: "pause",
              cmd: "meta",
              command: "meta",
              ctl: "control",
              ctrl: "control",
              del: "delete",
              down: "arrowdown",
              esc: "escape",
              ins: "insert",
              left: "arrowleft",
              mod: t.IS_MAC ? "meta" : "control",
              opt: "alt",
              option: "alt",
              return: "enter",
              right: "arrowright",
              space: " ",
              spacebar: " ",
              up: "arrowup",
              win: "meta",
              windows: "meta"
            }, t.BASE_PATH = function () {
              if ("undefined" == typeof document) return "";
              var e = document.currentScript,
                t = function (e) {
                  var t = e.split("/");
                  return /\.js/.test(t[t.length - 1]) ? t.slice(0, t.length - 1).join("/") + "/" : e;
                };
              if (e) return t(e.src);
              var o = document.querySelectorAll("script[src]");
              return o && o.length ? t(o[o.length - 1].src) : window.location.href;
            }(), t.TEMP_ATTR = "data-jodit-temp", t.lang = {}, t.CLIPBOARD_ID = "clipboard", t.SOURCE_CONSUMER = "source-consumer";
          },
          31897: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Create = void 0;
            var n = o(40332),
              r = (o(52378), o(64968)),
              i = o(86893),
              a = function () {
                function e(e, t) {
                  this.document = e, this.createAttributes = t;
                }
                return Object.defineProperty(e.prototype, "doc", {
                  get: function () {
                    return (0, n.isFunction)(this.document) ? this.document() : this.document;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.element = function (e, t, o) {
                  var r = this,
                    i = this.doc.createElement(e.toLowerCase());
                  return this.applyCreateAttributes(i), t && ((0, n.isPlainObject)(t) ? (0, n.attr)(i, t) : o = t), o && (0, n.asArray)(o).forEach(function (e) {
                    return i.appendChild((0, n.isString)(e) ? r.fromHTML(e) : e);
                  }), i;
                }, e.prototype.div = function (e, t, o) {
                  var n = this.element("div", t, o);
                  return e && (n.className = e), n;
                }, e.prototype.sandbox = function () {
                  var e,
                    t = this.element("iframe", {
                      sandbox: "allow-same-origin"
                    });
                  this.doc.body.appendChild(t);
                  var o = null === (e = t.contentWindow) || void 0 === e ? void 0 : e.document;
                  if (!o) throw Error("Iframe error");
                  return o.open(), o.write("<!DOCTYPE html><html><head></head><body></body></html>"), o.close(), o.body;
                }, e.prototype.span = function (e, t, o) {
                  var n = this.element("span", t, o);
                  return e && (n.className = e), n;
                }, e.prototype.a = function (e, t, o) {
                  var n = this.element("a", t, o);
                  return e && (n.className = e), n;
                }, e.prototype.text = function (e) {
                  return this.doc.createTextNode(e);
                }, e.prototype.fake = function () {
                  return this.text(i.INVISIBLE_SPACE);
                }, e.prototype.fragment = function () {
                  return this.doc.createDocumentFragment();
                }, e.prototype.fromHTML = function (e, t) {
                  var o = this.div();
                  o.innerHTML = e.toString();
                  var i = o.firstChild === o.lastChild && o.firstChild ? o.firstChild : o;
                  if (r.Dom.safeRemove(i), t) {
                    var a = (0, n.refs)(i);
                    Object.keys(t).forEach(function (e) {
                      var o = a[e];
                      o && !1 === t[e] && r.Dom.hide(o);
                    });
                  }
                  return i;
                }, e.prototype.applyCreateAttributes = function (e) {
                  if (this.createAttributes) {
                    var t = this.createAttributes;
                    if (t && t[e.tagName.toLowerCase()]) {
                      var o = t[e.tagName.toLowerCase()];
                      (0, n.isFunction)(o) ? o(e) : (0, n.isPlainObject)(o) && (0, n.attr)(e, o);
                    }
                  }
                }, e;
              }();
            t.Create = a;
          },
          42841: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(31897), t);
          },
          32358: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.cache = void 0;
            var n = o(40332);
            t.cache = function (e, t, o) {
              var r = o.get;
              if (!r) throw (0, n.error)("Getter property descriptor expected");
              o.get = function () {
                var e = r.call(this);
                return e && !0 === e.noCache || Object.defineProperty(this, t, {
                  configurable: o.configurable,
                  enumerable: o.enumerable,
                  writable: !1,
                  value: e
                }), e;
              };
            };
          },
          11441: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.component = void 0;
            var n = o(20255);
            t.component = function (e) {
              var t = function (e) {
                function t() {
                  for (var o = [], r = 0; arguments.length > r; r++) o[r] = arguments[r];
                  var i = e.apply(this, n.__spreadArray([], n.__read(o), !1)) || this,
                    a = i.constructor === t;
                  return a && (i instanceof t || Object.setPrototypeOf(i, t.prototype), i.setStatus("ready")), i;
                }
                return n.__extends(t, e), t;
              }(e);
              return t;
            };
          },
          55773: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.throttle = t.debounce = void 0;
            var n = o(10172),
              r = o(56562),
              i = o(56964);
            function a(e, t, o) {
              return void 0 === t && (t = !1), void 0 === o && (o = "debounce"), function (a, s) {
                var l = a[s];
                if (!(0, n.isFunction)(l)) throw (0, i.error)("Handler must be a Function");
                return a.hookStatus(r.STATUSES.ready, function (r) {
                  var i = r.async,
                    a = (0, n.isFunction)(e) ? e(r) : e;
                  Object.defineProperty(r, s, {
                    configurable: !0,
                    value: i[o](r[s].bind(r), (0, n.isNumber)(a) || (0, n.isPlainObject)(a) ? a : r.defaultTimeout, t)
                  });
                }), {
                  configurable: !0,
                  get: function () {
                    return l.bind(this);
                  }
                };
              };
            }
            o(52378), t.debounce = a, t.throttle = function (e, t) {
              return void 0 === t && (t = !1), a(e, t, "throttle");
            };
          },
          70669: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.derive = void 0;
            var n = o(20255),
              r = o(10172);
            t.derive = function () {
              for (var e = [], t = 0; arguments.length > t; t++) e[t] = arguments[t];
              return function (t) {
                for (var o = t.prototype, i = 0; e.length > i; i++) for (var a = e[i], s = Object.getOwnPropertyNames(a.prototype), l = function (e) {
                    var t = s[e],
                      i = Object.getOwnPropertyDescriptor(a.prototype, t);
                    null != i && (0, r.isFunction)(i.value) && !(0, r.isFunction)(o[t]) && Object.defineProperty(o, t, {
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                      value: function () {
                        for (var e, t = [], o = 0; arguments.length > o; o++) t[o] = arguments[o];
                        return (e = i.value).call.apply(e, n.__spreadArray([this], n.__read(t), !1));
                      }
                    });
                  }, c = 0; s.length > c; c++) l(c);
              };
            };
          },
          64522: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hook = void 0;
            var n = o(10172),
              r = o(56964);
            t.hook = function (e) {
              return function (t, o) {
                if (!(0, n.isFunction)(t[o])) throw (0, r.error)("Handler must be a Function");
                t.hookStatus(e, function (e) {
                  e[o].call(e);
                });
              };
            };
          },
          58682: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.idle = void 0;
            var n = o(20255),
              r = o(56562),
              i = o(40332);
            t.idle = function () {
              return function (e, t) {
                if (!(0, i.isFunction)(e[t])) throw (0, i.error)("Handler must be a Function");
                e.hookStatus(r.STATUSES.ready, function (e) {
                  var o = e.async,
                    r = e[t];
                  e[t] = function () {
                    for (var t = [], i = 0; arguments.length > i; i++) t[i] = arguments[i];
                    return o.requestIdleCallback(r.bind.apply(r, n.__spreadArray([e], n.__read(t), !1)));
                  };
                });
              };
            };
          },
          43441: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.autobind = void 0;
            var n = o(20255);
            n.__exportStar(o(32358), t), n.__exportStar(o(11441), t), n.__exportStar(o(55773), t), n.__exportStar(o(58682), t), n.__exportStar(o(64522), t), n.__exportStar(o(91627), t), n.__exportStar(o(31418), t), n.__exportStar(o(67587), t), n.__exportStar(o(46163), t), n.__exportStar(o(70669), t);
            var r = o(70631);
            Object.defineProperty(t, "autobind", {
              enumerable: !0,
              get: function () {
                return r.default;
              }
            });
          },
          91627: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.nonenumerable = void 0, t.nonenumerable = function (e, t) {
              !1 !== (Object.getOwnPropertyDescriptor(e, t) || {}).enumerable && Object.defineProperty(e, t, {
                enumerable: !1,
                set: function (e) {
                  Object.defineProperty(this, t, {
                    enumerable: !1,
                    writable: !0,
                    value: e
                  });
                }
              });
            };
          },
          31418: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.persistent = void 0;
            var n = o(56562),
              r = o(96574);
            t.persistent = function (e, t) {
              e.hookStatus(n.STATUSES.ready, function (e) {
                var o = (0, r.isViewObject)(e) ? e : e.jodit,
                  n = "".concat(o.options.namespace).concat(e.componentName, "_prop_").concat(t),
                  i = e[t];
                Object.defineProperty(e, t, {
                  get: function () {
                    var e;
                    return null !== (e = o.storage.get(n)) && void 0 !== e ? e : i;
                  },
                  set: function (e) {
                    o.storage.set(n, e);
                  }
                });
              });
            };
          },
          67587: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.wait = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(56562);
            t.wait = function (e) {
              return function (t, o) {
                if (!(0, r.isFunction)(t[o])) throw (0, r.error)("Handler must be a Function");
                t.hookStatus(i.STATUSES.ready, function (t) {
                  var r = t.async,
                    i = t[o],
                    a = 0;
                  Object.defineProperty(t, o, {
                    configurable: !0,
                    value: function o() {
                      for (var s = [], l = 0; arguments.length > l; l++) s[l] = arguments[l];
                      r.clearTimeout(a), e(t) ? i.apply(t, s) : a = r.setTimeout(function () {
                        return o.apply(void 0, n.__spreadArray([], n.__read(s), !1));
                      }, 10);
                    }
                  });
                });
              };
            };
          },
          46163: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.watch = t.getPropertyDescriptor = void 0;
            var n = o(20255),
              r = o(42096),
              i = o(79736),
              a = o(96574),
              s = o(88418),
              l = o(29411),
              c = o(14556),
              u = o(56964);
            function d(e, t) {
              var o;
              do {
                o = Object.getOwnPropertyDescriptor(e, t), e = Object.getPrototypeOf(e);
              } while (!o && e);
              return o;
            }
            function p(e, t) {
              return function (o, p) {
                if (!(0, r.isFunction)(o[p])) throw (0, u.error)("Handler must be a Function");
                var f = function (l) {
                  var u = function (e) {
                    for (var t, o = [], r = 1; arguments.length > r; r++) o[r - 1] = arguments[r];
                    if (!l.isInDestruct) return (t = l)[p].apply(t, n.__spreadArray([e], n.__read(o), !1));
                  };
                  (0, c.splitArray)(e).forEach(function (e) {
                    if (/:/.test(e)) {
                      var c = n.__read(e.split(":"), 2),
                        p = c[0],
                        f = c[1],
                        h = t,
                        m = (0, a.isViewObject)(l) ? l : l.jodit;
                      return p.length && (h = l.get(p)), (0, r.isFunction)(h) && (h = h(l)), m.events.on(h || l, f, u), h || m.events.on(f, u), void l.hookStatus("beforeDestruct", function () {
                        m.events.off(h || l, f, u).off(f, u);
                      });
                    }
                    var v = e.split("."),
                      g = n.__read(v, 1)[0],
                      y = v.slice(1),
                      _ = l[g];
                    (0, i.isPlainObject)(_) && (0, s.observable)(_).on("change.".concat(y.join(".")), u);
                    var b = d(o, g);
                    Object.defineProperty(l, g, {
                      configurable: !0,
                      set: function (e) {
                        var t = _;
                        t !== e && (_ = e, b && b.set && b.set.call(l, e), (0, i.isPlainObject)(_) && (_ = (0, s.observable)(_)).on("change.".concat(y.join(".")), u), u(g, t, _));
                      },
                      get: function () {
                        return b && b.get ? b.get.call(l) : _;
                      }
                    });
                  });
                };
                (0, r.isFunction)(o.hookStatus) ? o.hookStatus(l.STATUSES.ready, f) : f(o);
              };
            }
            t.getPropertyDescriptor = d, t.watch = p, t.default = p;
          },
          24263: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Dom = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(10172),
              a = o(12557),
              s = o(19035),
              l = o(76502),
              c = o(37204),
              u = o(86893),
              d = function () {
                function e() {}
                return e.detach = function (e) {
                  for (; e.firstChild;) e.removeChild(e.firstChild);
                }, e.wrapInline = function (t, o, n) {
                  var r,
                    a = t,
                    s = t;
                  n.s.save();
                  var l = !1;
                  do {
                    l = !1, (r = a.previousSibling) && !e.isBlock(r) && (l = !0, a = r);
                  } while (l);
                  do {
                    l = !1, (r = s.nextSibling) && !e.isBlock(r) && (l = !0, s = r);
                  } while (l);
                  var c = (0, i.isString)(o) ? n.createInside.element(o) : o;
                  a.parentNode && a.parentNode.insertBefore(c, a);
                  for (var u = a; u && (u = a.nextSibling, c.appendChild(a), a !== s && u);) a = u;
                  return n.s.restore(), c;
                }, e.wrap = function (t, o, n) {
                  var r = (0, i.isString)(o) ? n.element(o) : o;
                  if (e.isNode(t)) {
                    if (!t.parentNode) throw (0, l.error)("Element should be in DOM");
                    t.parentNode.insertBefore(r, t), r.appendChild(t);
                  } else {
                    var a = t.extractContents();
                    t.insertNode(r), r.appendChild(a);
                  }
                  return r;
                }, e.unwrap = function (t) {
                  var o = t.parentNode;
                  if (o) {
                    for (; t.firstChild;) o.insertBefore(t.firstChild, t);
                    e.safeRemove(t);
                  }
                }, e.between = function (e, t, o) {
                  for (var n = e; n && n !== t && (e === n || !o(n));) {
                    var r = n.firstChild || n.nextSibling;
                    if (!r) {
                      for (; n && !n.nextSibling;) n = n.parentNode;
                      r = null == n ? void 0 : n.nextSibling;
                    }
                    n = r;
                  }
                }, e.replace = function (t, o, n, r, s) {
                  void 0 === r && (r = !1), void 0 === s && (s = !1), (0, i.isHTML)(o) && (o = n.fromHTML(o));
                  var l = (0, i.isString)(o) ? n.element(o) : o;
                  if (!s) for (; t.firstChild;) l.appendChild(t.firstChild);
                  return r && e.isElement(t) && e.isElement(l) && (0, a.toArray)(t.attributes).forEach(function (e) {
                    l.setAttribute(e.name, e.value);
                  }), t.parentNode && t.parentNode.replaceChild(l, t), l;
                }, e.isEmptyTextNode = function (t) {
                  return e.isText(t) && (!t.nodeValue || 0 === t.nodeValue.replace(r.INVISIBLE_SPACE_REG_EXP(), "").trim().length);
                }, e.isEmptyContent = function (t) {
                  return e.each(t, function (t) {
                    return e.isEmptyTextNode(t);
                  });
                }, e.isContentEditable = function (t, o) {
                  return e.isNode(t) && !e.closest(t, function (t) {
                    return e.isElement(t) && "false" === t.getAttribute("contenteditable");
                  }, o);
                }, e.isEmpty = function (t, o) {
                  if (void 0 === o && (o = u.NO_EMPTY_TAGS), !t) return !0;
                  var n;
                  n = (0, i.isFunction)(o) ? o : function (e) {
                    return o.has(e.nodeName.toLowerCase());
                  };
                  var r = function (e) {
                    return null == e.nodeValue || 0 === (0, s.trim)(e.nodeValue).length;
                  };
                  return e.isText(t) ? r(t) : !(e.isElement(t) && n(t)) && e.each(t, function (t) {
                    if (e.isText(t) && !r(t) || e.isElement(t) && n(t)) return !1;
                  });
                }, e.isNode = function (e) {
                  return Boolean(e && (0, i.isString)(e.nodeName) && "number" == typeof e.nodeType && e.childNodes && (0, i.isFunction)(e.appendChild));
                }, e.isCell = function (t) {
                  return e.isNode(t) && /^(td|th)$/i.test(t.nodeName);
                }, e.isImage = function (t) {
                  return e.isNode(t) && /^(img|svg|picture|canvas)$/i.test(t.nodeName);
                }, e.isBlock = function (t) {
                  return !(0, i.isVoid)(t) && "object" == typeof t && e.isNode(t) && r.IS_BLOCK.test(t.nodeName);
                }, e.isText = function (e) {
                  return Boolean(e && e.nodeType === Node.TEXT_NODE);
                }, e.isElement = function (t) {
                  var o;
                  if (!e.isNode(t)) return !1;
                  var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                  return Boolean(n && t.nodeType === Node.ELEMENT_NODE);
                }, e.isFragment = function (t) {
                  var o;
                  if (!e.isNode(t)) return !1;
                  var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                  return Boolean(n && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE);
                }, e.isHTMLElement = function (t) {
                  var o;
                  if (!e.isNode(t)) return !1;
                  var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                  return Boolean(n && t instanceof n.HTMLElement);
                }, e.isInlineBlock = function (t) {
                  return e.isElement(t) && !/^(BR|HR)$/i.test(t.tagName) && -1 !== ["inline", "inline-block"].indexOf((0, l.css)(t, "display").toString());
                }, e.canSplitBlock = function (t) {
                  return !(0, i.isVoid)(t) && e.isHTMLElement(t) && e.isBlock(t) && !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) && void 0 !== t.style && !/^(fixed|absolute)/i.test(t.style.position);
                }, e.last = function (e, t) {
                  var o = null == e ? void 0 : e.lastChild;
                  if (!o) return null;
                  do {
                    if (t(o)) return o;
                    var n = o.lastChild;
                    if (n || (n = o.previousSibling), !n && o.parentNode !== e) {
                      do {
                        o = o.parentNode;
                      } while (o && !(null == o ? void 0 : o.previousSibling) && o.parentNode !== e);
                      n = null == o ? void 0 : o.previousSibling;
                    }
                    o = n;
                  } while (o);
                  return null;
                }, e.prev = function (t, o, n, r) {
                  return void 0 === r && (r = !0), e.find(t, o, n, !1, r);
                }, e.next = function (t, o, n, r) {
                  return void 0 === r && (r = !0), e.find(t, o, n, !0, r);
                }, e.prevWithClass = function (t, o) {
                  return e.prev(t, function (t) {
                    return e.isElement(t) && t.classList.contains(o);
                  }, t.parentNode);
                }, e.nextWithClass = function (t, o) {
                  return e.next(t, function (t) {
                    return e.isElement(t) && t.classList.contains(o);
                  }, t.parentNode);
                }, e.find = function (e, t, o, n, r) {
                  void 0 === n && (n = !0), void 0 === r && (r = !0);
                  for (var i = this.nextGen(e, o, n, r), a = i.next(); !a.done;) {
                    if (t(a.value)) return a.value;
                    a = i.next();
                  }
                  return null;
                }, e.nextGen = function (e, t, o, r) {
                  var i, a, s;
                  return void 0 === o && (o = !0), void 0 === r && (r = !0), n.__generator(this, function (l) {
                    switch (l.label) {
                      case 0:
                        i = [], a = e, l.label = 1;
                      case 1:
                        for (s = o ? a.nextSibling : a.previousSibling; s;) i.unshift(s), s = o ? s.nextSibling : s.previousSibling;
                        return [5, n.__values(this.runInStack(e, i, o, r))];
                      case 2:
                        l.sent(), a = a.parentNode, l.label = 3;
                      case 3:
                        if (a && a !== t) return [3, 1];
                        l.label = 4;
                      case 4:
                        return [2, null];
                    }
                  });
                }, e.each = function (e, t, o) {
                  void 0 === o && (o = !0);
                  for (var n = this.eachGen(e, o), r = n.next(); !r.done;) {
                    if (!1 === t(r.value)) return !1;
                    r = n.next();
                  }
                  return !0;
                }, e.eachGen = function (e, t) {
                  return void 0 === t && (t = !0), this.runInStack(e, [e], t);
                }, e.runInStack = function (e, t, o, r) {
                  var i, a;
                  return void 0 === r && (r = !0), n.__generator(this, function (n) {
                    switch (n.label) {
                      case 0:
                        if (!t.length) return [3, 3];
                        if (i = t.pop(), r) for (a = o ? i.lastChild : i.firstChild; a;) t.push(a), a = o ? a.previousSibling : a.nextSibling;
                        return e === i ? [3, 2] : [4, i];
                      case 1:
                        n.sent(), n.label = 2;
                      case 2:
                        return [3, 0];
                      case 3:
                        return [2];
                    }
                  });
                }, e.findWithCurrent = function (t, o, n, r, i) {
                  void 0 === r && (r = "nextSibling"), void 0 === i && (i = "firstChild");
                  var a = t;
                  do {
                    if (o(a)) return a || null;
                    if (i && a && a[i]) {
                      var s = e.findWithCurrent(a[i], o, a, r, i);
                      if (s) return s;
                    }
                    for (; a && !a[r] && a !== n;) a = a.parentNode;
                    a && a[r] && a !== n && (a = a[r]);
                  } while (a && a !== n);
                  return null;
                }, e.findSibling = function (t, o, n) {
                  void 0 === o && (o = !0), void 0 === n && (n = function (t) {
                    return !e.isEmptyTextNode(t);
                  });
                  for (var r = e.sibling(t, o); r && !n(r);) r = e.sibling(r, o);
                  return r && n(r) ? r : null;
                }, e.findNotEmptySibling = function (t, o) {
                  return e.findSibling(t, o, function (t) {
                    var o;
                    return !e.isEmptyTextNode(t) && Boolean(!e.isText(t) || (null === (o = t.nodeValue) || void 0 === o ? void 0 : o.length) && (0, s.trim)(t.nodeValue));
                  });
                }, e.findNotEmptyNeighbor = function (t, o, n) {
                  return (0, l.call)(o ? e.prev : e.next, t, function (t) {
                    return Boolean(t && (!e.isText(t) || (0, s.trim)((null == t ? void 0 : t.nodeValue) || "").length));
                  }, n);
                }, e.sibling = function (e, t) {
                  return t ? e.previousSibling : e.nextSibling;
                }, e.up = function (e, t, o, n) {
                  void 0 === n && (n = !1);
                  var r = e;
                  if (!r) return null;
                  do {
                    if (t(r)) return r;
                    if (r === o || !r.parentNode) break;
                    r = r.parentNode;
                  } while (r && r !== o);
                  return r === o && n && t(r) ? r : null;
                }, e.closest = function (t, o, n) {
                  var r,
                    a = function (e) {
                      return e.toLowerCase();
                    };
                  if ((0, i.isFunction)(o)) r = o;else if ((0, i.isArray)(o)) {
                    var s = new Set(o.map(a));
                    r = function (e) {
                      return Boolean(e && s.has(a(e.nodeName)));
                    };
                  } else r = function (e) {
                    return Boolean(e && a(o) === a(e.nodeName));
                  };
                  return e.up(t, r, n);
                }, e.furthest = function (e, t, o) {
                  for (var n = null, r = null == e ? void 0 : e.parentElement; r && r !== o;) t(r) && (n = r), r = null == r ? void 0 : r.parentElement;
                  return n;
                }, e.appendChildFirst = function (e, t) {
                  var o = e.firstChild;
                  o ? o !== t && e.insertBefore(t, o) : e.appendChild(t);
                }, e.after = function (e, t) {
                  var o = e.parentNode;
                  o && (o.lastChild === e ? o.appendChild(t) : o.insertBefore(t, e.nextSibling));
                }, e.before = function (e, t) {
                  var o = e.parentNode;
                  o && o.insertBefore(t, e);
                }, e.prepend = function (e, t) {
                  e.insertBefore(t, e.firstChild);
                }, e.append = function (e, t) {
                  var o = this;
                  (0, i.isArray)(t) ? t.forEach(function (t) {
                    o.append(e, t);
                  }) : e.appendChild(t);
                }, e.moveContent = function (t, o, n, r) {
                  void 0 === n && (n = !1), void 0 === r && (r = function () {
                    return !0;
                  });
                  var i = (t.ownerDocument || document).createDocumentFragment();
                  (0, a.toArray)(t.childNodes).filter(function (t) {
                    return !!r(t) || (e.safeRemove(t), !1);
                  }).forEach(function (e) {
                    i.appendChild(e);
                  }), n && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i);
                }, e.isOrContains = function (e, t, o) {
                  return void 0 === o && (o = !1), e === t ? !o : Boolean(t && e && this.up(t, function (t) {
                    return t === e;
                  }, e, !0));
                }, e.safeRemove = function () {
                  for (var t = [], o = 0; arguments.length > o; o++) t[o] = arguments[o];
                  t.forEach(function (t) {
                    return e.isNode(t) && t.parentNode && t.parentNode.removeChild(t);
                  });
                }, e.safeInsertNode = function (t, o) {
                  t.collapsed || t.deleteContents(), t.insertNode(o), t.setStartBefore(o), t.collapse(!0), [o.nextSibling, o.previousSibling].forEach(function (t) {
                    return e.isText(t) && !t.nodeValue && e.safeRemove(t);
                  });
                }, e.hide = function (e) {
                  e && ((0, l.dataBind)(e, "__old_display", e.style.display), e.style.display = "none");
                }, e.show = function (e) {
                  if (e) {
                    var t = (0, l.dataBind)(e, "__old_display");
                    "none" === e.style.display && (e.style.display = t || "");
                  }
                }, e.isTag = function (e, t) {
                  if (!this.isElement(e)) return !1;
                  var o = e.tagName.toLowerCase(),
                    n = e.tagName.toUpperCase();
                  if (t instanceof Set) return t.has(o) || t.has(n);
                  for (var r = (0, a.asArray)(t).map(function (e) {
                      return String(e).toLowerCase();
                    }), i = 0; r.length > i; i += 1) if (o === r[i] || n === r[i]) return !0;
                  return !1;
                }, e.markTemporary = function (e, t) {
                  return t && (0, l.attr)(e, t), (0, l.attr)(e, u.TEMP_ATTR, !0), e;
                }, e.isTemporary = function (t) {
                  return !!e.isElement(t) && ((0, c.isMarker)(t) || "true" === (0, l.attr)(t, u.TEMP_ATTR));
                }, e.replaceTemporaryFromString = function (e) {
                  return e.replace(/<([a-z]+)[^>]+data-jodit-temp[^>]+>(.+?)<\/\1>/gi, "$2");
                }, e.temporaryList = function (e) {
                  return (0, l.$$)("[".concat(u.TEMP_ATTR, "]"), e);
                }, e;
              }();
            t.Dom = d;
          },
          64968: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(24263), t), n.__exportStar(o(33841), t);
          },
          33841: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.LazyWalker = void 0;
            var n = o(20255),
              r = o(73852),
              i = o(43441),
              a = o(24263),
              s = function (e) {
                function t(t, o) {
                  void 0 === o && (o = {});
                  var n = e.call(this) || this;
                  return n.async = t, n.options = o, n.workNodes = null, n.hadAffect = !1, n.isWorked = !1, n.isFinished = !1, n.idleId = 0, n;
                }
                return n.__extends(t, e), t.prototype.setWork = function (e) {
                  return this.isWorked && this.break(), this.workNodes = a.Dom.eachGen(e, !this.options.reverse), this.isFinished = !1, this.startIdleRequest(), this;
                }, t.prototype.startIdleRequest = function () {
                  var e;
                  this.idleId = this.async.requestIdleCallback(this.workPerform, {
                    timeout: null !== (e = this.options.timeout) && void 0 !== e ? e : 10
                  });
                }, t.prototype.break = function (e) {
                  this.isWorked && (this.stop(), this.emit("break", e));
                }, t.prototype.end = function () {
                  this.isWorked && (this.stop(), this.emit("end", this.hadAffect), this.hadAffect = !1);
                }, t.prototype.stop = function () {
                  this.isWorked = !1, this.isFinished = !0, this.workNodes = null, this.async.cancelIdleCallback(this.idleId);
                }, t.prototype.destruct = function () {
                  e.prototype.destruct.call(this), this.stop();
                }, t.prototype.workPerform = function (e) {
                  var t;
                  if (this.workNodes) {
                    this.isWorked = !0;
                    for (var o = 0, n = null !== (t = this.options.timeoutChunkSize) && void 0 !== t ? t : 50; !this.isFinished && (e.timeRemaining() > 0 || e.didTimeout && n >= o);) {
                      var r = this.workNodes.next();
                      if (o += 1, this.visitNode(r.value) && (this.hadAffect = !0), r.done) return void this.end();
                    }
                  } else this.end();
                  this.isFinished || this.startIdleRequest();
                }, t.prototype.visitNode = function (e) {
                  var t;
                  return !(!e || void 0 !== this.options.whatToShow && e.nodeType !== this.options.whatToShow) && null !== (t = this.emit("visit", e)) && void 0 !== t && t;
                }, n.__decorate([i.autobind], t.prototype, "workPerform", null), t;
              }(r.Eventify);
            t.LazyWalker = s;
          },
          3808: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.EventEmitter = void 0;
            var n = o(20255),
              r = o(83611),
              i = o(24421),
              a = o(42096),
              s = o(49781),
              l = o(56964),
              c = o(14556),
              u = function () {
                function e(e) {
                  var t = this;
                  this.__mutedEvents = new Set(), this.__key = "__JoditEventEmitterNamespaces", this.__doc = document, this.__prepareEvent = function (e) {
                    e.cancelBubble || (e.composed && (0, a.isFunction)(e.composedPath) && e.composedPath()[0] && Object.defineProperty(e, "target", {
                      value: e.composedPath()[0],
                      configurable: !0,
                      enumerable: !0
                    }), e.type.match(/^touch/) && e.changedTouches && e.changedTouches.length && ["clientX", "clientY", "pageX", "pageY"].forEach(function (t) {
                      Object.defineProperty(e, t, {
                        value: e.changedTouches[0][t],
                        configurable: !0,
                        enumerable: !0
                      });
                    }), e.originalEvent || (e.originalEvent = e), "paste" === e.type && void 0 === e.clipboardData && t.__doc.defaultView.clipboardData && Object.defineProperty(e, "clipboardData", {
                      get: function () {
                        return t.__doc.defaultView.clipboardData;
                      },
                      configurable: !0,
                      enumerable: !0
                    }));
                  }, this.currents = [], this.__stopped = [], this.__isDestructed = !1, e && (this.__doc = e), this.__key += new Date().getTime();
                }
                return e.prototype.mute = function (e) {
                  return this.__mutedEvents.add(null != e ? e : "*"), this;
                }, e.prototype.isMuted = function (e) {
                  return !(!e || !this.__mutedEvents.has(e)) || this.__mutedEvents.has("*");
                }, e.prototype.unmute = function (e) {
                  return this.__mutedEvents.delete(null != e ? e : "*"), this;
                }, e.prototype.__eachEvent = function (e, t) {
                  var o = this;
                  (0, c.splitArray)(e).map(function (e) {
                    return e.trim();
                  }).forEach(function (e) {
                    var n = e.split(".");
                    t.call(o, n[0], n[1] || r.defaultNameSpace);
                  });
                }, e.prototype.__getStore = function (e) {
                  if (!e) throw (0, l.error)("Need subject");
                  if (void 0 === e[this.__key]) {
                    var t = new r.EventHandlersStore();
                    Object.defineProperty(e, this.__key, {
                      enumerable: !1,
                      configurable: !0,
                      writable: !0,
                      value: t
                    });
                  }
                  return e[this.__key];
                }, e.prototype.__removeStoreFromSubject = function (e) {
                  void 0 !== e[this.__key] && Object.defineProperty(e, this.__key, {
                    enumerable: !1,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                  });
                }, e.prototype.__triggerNativeEvent = function (e, t) {
                  var o = this.__doc.createEvent("HTMLEvents");
                  (0, i.isString)(t) ? o.initEvent(t, !0, !0) : (o.initEvent(t.type, t.bubbles, t.cancelable), ["screenX", "screenY", "clientX", "clientY", "target", "srcElement", "currentTarget", "timeStamp", "which", "keyCode"].forEach(function (e) {
                    Object.defineProperty(o, e, {
                      value: t[e],
                      enumerable: !0
                    });
                  }), Object.defineProperty(o, "originalEvent", {
                    value: t,
                    enumerable: !0
                  })), e.dispatchEvent(o);
                }, Object.defineProperty(e.prototype, "current", {
                  get: function () {
                    return this.currents[this.currents.length - 1];
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.on = function (e, t, o, r) {
                  var c,
                    u,
                    d,
                    p,
                    f = this;
                  if ((0, i.isString)(e) || (0, i.isStringArray)(e) ? (c = this, u = e, d = t, p = o) : (c = e, u = t, d = o, p = r), !(0, i.isString)(u) && !(0, i.isStringArray)(u) || 0 === u.length) throw (0, l.error)("Need events names");
                  if (!(0, a.isFunction)(d)) throw (0, l.error)("Need event handler");
                  if ((0, s.isArray)(c)) return c.forEach(function (e) {
                    f.on(e, u, d, p);
                  }), this;
                  var h = c,
                    m = this.__getStore(h),
                    v = (0, a.isFunction)(h.addEventListener),
                    g = this,
                    y = function (e) {
                      for (var t = [], o = 1; arguments.length > o; o++) t[o - 1] = arguments[o];
                      if (!g.isMuted(e)) return d && d.call.apply(d, n.__spreadArray([this], n.__read(t), !1));
                    };
                  return v && (y = function (e) {
                    if (!g.isMuted(e.type)) return g.__prepareEvent(e), d && !1 === d.call(this, e) ? (e.preventDefault(), e.stopImmediatePropagation(), !1) : void 0;
                  }), this.__eachEvent(u, function (e, t) {
                    if (0 === e.length) throw (0, l.error)("Need event name");
                    if (!1 === m.indexOf(e, t, d) && (m.set(e, t, {
                      event: e,
                      originalCallback: d,
                      syntheticCallback: y
                    }, null == p ? void 0 : p.top), v)) {
                      var o = !!["touchstart", "touchend", "scroll", "mousewheel", "mousemove", "touchmove"].includes(e) && {
                        passive: !0
                      };
                      h.addEventListener(e, y, o);
                    }
                  }), this;
                }, e.prototype.one = function (e, t, o, r) {
                  var a,
                    s,
                    l,
                    c,
                    u = this;
                  (0, i.isString)(e) || (0, i.isStringArray)(e) ? (a = this, s = e, l = t, c = o) : (a = e, s = t, l = o, c = r);
                  var d = function () {
                    for (var e = [], t = 0; arguments.length > t; t++) e[t] = arguments[t];
                    return u.off(a, s, d), l.apply(void 0, n.__spreadArray([], n.__read(e), !1));
                  };
                  return this.on(a, s, d, c), this;
                }, e.prototype.off = function (e, t, o) {
                  var n,
                    l,
                    c,
                    u = this;
                  if ((0, i.isString)(e) || (0, i.isStringArray)(e) ? (n = this, l = e, c = t) : (n = e, l = t, c = o), (0, s.isArray)(n)) return n.forEach(function (e) {
                    u.off(e, l, c);
                  }), this;
                  var d = n,
                    p = this.__getStore(d);
                  if (!(0, i.isString)(l) && !(0, i.isStringArray)(l) || 0 === l.length) return p.namespaces().forEach(function (e) {
                    u.off(d, "." + e);
                  }), this.__removeStoreFromSubject(d), this;
                  var f = (0, a.isFunction)(d.removeEventListener),
                    h = function (e) {
                      f && d.removeEventListener(e.event, e.syntheticCallback, !1);
                    },
                    m = function (e, t) {
                      if ("" !== e) {
                        var o = p.get(e, t);
                        if (o && o.length) if ((0, a.isFunction)(c)) {
                          var n = p.indexOf(e, t, c);
                          !1 !== n && (h(o[n]), o.splice(n, 1), o.length || p.clearEvents(t, e));
                        } else o.forEach(h), o.length = 0, p.clearEvents(t, e);
                      } else p.events(t).forEach(function (e) {
                        "" !== e && m(e, t);
                      });
                    };
                  return this.__eachEvent(l, function (e, t) {
                    t === r.defaultNameSpace ? p.namespaces().forEach(function (t) {
                      m(e, t);
                    }) : m(e, t);
                  }), p.isEmpty() && this.__removeStoreFromSubject(d), this;
                }, e.prototype.stopPropagation = function (e, t) {
                  var o = this,
                    n = (0, i.isString)(e) ? this : e,
                    a = (0, i.isString)(e) ? e : t;
                  if ("string" != typeof a) throw (0, l.error)("Need event names");
                  var s = this.__getStore(n);
                  this.__eachEvent(a, function (e, t) {
                    var i = s.get(e, t);
                    i && o.__stopped.push(i), t === r.defaultNameSpace && s.namespaces(!0).forEach(function (t) {
                      return o.stopPropagation(n, e + "." + t);
                    });
                  });
                }, e.prototype.__removeStop = function (e) {
                  if (e) {
                    var t = this.__stopped.indexOf(e);
                    -1 !== t && this.__stopped.splice(0, t + 1);
                  }
                }, e.prototype.__isStopped = function (e) {
                  return void 0 !== e && -1 !== this.__stopped.indexOf(e);
                }, e.prototype.fire = function (e, t) {
                  for (var o, s, c = this, u = [], d = 2; arguments.length > d; d++) u[d - 2] = arguments[d];
                  var p = (0, i.isString)(e) ? this : e,
                    f = (0, i.isString)(e) ? e : t,
                    h = (0, i.isString)(e) ? n.__spreadArray([t], n.__read(u), !1) : u,
                    m = (0, a.isFunction)(p.dispatchEvent);
                  if (!m && !(0, i.isString)(f)) throw (0, l.error)("Need events names");
                  var v = this.__getStore(p);
                  return !(0, i.isString)(f) && m ? this.__triggerNativeEvent(p, t) : this.__eachEvent(f, function (e, t) {
                    if (m) c.__triggerNativeEvent(p, e);else {
                      var i = v.get(e, t);
                      if (i) try {
                        n.__spreadArray([], n.__read(i), !1).every(function (t) {
                          var r;
                          return !c.__isStopped(i) && (c.currents.push(e), s = (r = t.syntheticCallback).call.apply(r, n.__spreadArray([p, e], n.__read(h), !1)), c.currents.pop(), void 0 !== s && (o = s), !0);
                        });
                      } finally {
                        c.__removeStop(i);
                      }
                      t !== r.defaultNameSpace || m || v.namespaces().filter(function (e) {
                        return e !== t;
                      }).forEach(function (t) {
                        var r = c.fire.apply(c, n.__spreadArray([p, e + "." + t], n.__read(h), !1));
                        void 0 !== r && (o = r);
                      });
                    }
                  }), o;
                }, e.prototype.destruct = function () {
                  this.__isDestructed && (this.__isDestructed = !0, this.off(this), this.__getStore(this).clear(), this.__removeStoreFromSubject(this));
                }, e;
              }();
            t.EventEmitter = u;
          },
          73852: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Eventify = void 0;
            var n = o(20255),
              r = function () {
                function e() {
                  this.__map = new Map();
                }
                return e.prototype.on = function (e, t) {
                  var o;
                  return this.__map.has(e) || this.__map.set(e, new Set()), null === (o = this.__map.get(e)) || void 0 === o || o.add(t), this;
                }, e.prototype.off = function (e, t) {
                  var o;
                  return this.__map.has(e) && (null === (o = this.__map.get(e)) || void 0 === o || o.delete(t)), this;
                }, e.prototype.destruct = function () {
                  this.__map.clear();
                }, e.prototype.emit = function (e) {
                  for (var t, o, r = [], i = 1; arguments.length > i; i++) r[i - 1] = arguments[i];
                  return this.__map.has(e) && (null === (t = this.__map.get(e)) || void 0 === t || t.forEach(function (e) {
                    o = e.apply(void 0, n.__spreadArray([], n.__read(r), !1));
                  })), o;
                }, e;
              }();
            t.Eventify = r;
          },
          55395: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(3808), t), n.__exportStar(o(73852), t), n.__exportStar(o(88418), t), n.__exportStar(o(83611), t);
          },
          88418: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.observable = void 0;
            var n = o(20255),
              r = o(49781),
              i = o(32756),
              a = o(79736),
              s = o(46163),
              l = Symbol("observable-object");
            function c(e) {
              return void 0 !== e[l];
            }
            t.observable = function (e) {
              if (c(e)) return e;
              var t = {},
                o = {},
                u = function (t, n) {
                  return (0, r.isArray)(t) ? (t.map(function (e) {
                    return u(e, n);
                  }), e) : (o[t] || (o[t] = []), o[t].push(n), e);
                },
                d = function (i) {
                  for (var a = [], s = 1; arguments.length > s; s++) a[s - 1] = arguments[s];
                  if ((0, r.isArray)(i)) i.map(function (e) {
                    return d.apply(void 0, n.__spreadArray([e], n.__read(a), !1));
                  });else try {
                    !t[i] && o[i] && (t[i] = !0, o[i].forEach(function (t) {
                      return t.call.apply(t, n.__spreadArray([e], n.__read(a), !1));
                    }));
                  } finally {
                    t[i] = !1;
                  }
                },
                p = function (t, o) {
                  void 0 === o && (o = []);
                  var r = {};
                  c(t) || (Object.defineProperty(t, l, {
                    enumerable: !1,
                    value: !0
                  }), Object.keys(t).forEach(function (l) {
                    var c = l,
                      u = o.concat(c).filter(function (e) {
                        return e.length;
                      });
                    r[c] = t[c];
                    var f = (0, s.getPropertyDescriptor)(t, c);
                    Object.defineProperty(t, c, {
                      set: function (t) {
                        var o = r[c];
                        if (!(0, i.isFastEqual)(r[c], t)) {
                          d(["beforeChange", "beforeChange.".concat(u.join("."))], c, t), (0, a.isPlainObject)(t) && p(t, u), f && f.set ? f.set.call(e, t) : r[c] = t;
                          var s = [];
                          d(n.__spreadArray(["change"], n.__read(u.reduce(function (e, t) {
                            return s.push(t), e.push("change.".concat(s.join("."))), e;
                          }, [])), !1), u.join("."), o, (null == t ? void 0 : t.valueOf) ? t.valueOf() : t);
                        }
                      },
                      get: function () {
                        return f && f.get ? f.get.call(e) : r[c];
                      },
                      enumerable: !0,
                      configurable: !0
                    }), (0, a.isPlainObject)(r[c]) && p(r[c], u);
                  }), Object.defineProperty(e, "on", {
                    value: u
                  }));
                };
              return p(e), e;
            };
          },
          83611: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.EventHandlersStore = t.defaultNameSpace = void 0, o(52378);
            var n = o(1853);
            t.defaultNameSpace = "JoditEventDefaultNamespace";
            var r = function () {
              function e() {
                this.__store = new Map();
              }
              return e.prototype.get = function (e, t) {
                if (this.__store.has(t)) return this.__store.get(t)[e];
              }, e.prototype.indexOf = function (e, t, o) {
                var n = this.get(e, t);
                if (n) for (var r = 0; n.length > r; r += 1) if (n[r].originalCallback === o) return r;
                return !1;
              }, e.prototype.namespaces = function (e) {
                void 0 === e && (e = !1);
                var o = (0, n.toArray)(this.__store.keys());
                return e ? o.filter(function (e) {
                  return e !== t.defaultNameSpace;
                }) : o;
              }, e.prototype.events = function (e) {
                var t = this.__store.get(e);
                return t ? Object.keys(t) : [];
              }, e.prototype.set = function (e, t, o, n) {
                void 0 === n && (n = !1);
                var r = this.__store.get(t);
                r || this.__store.set(t, r = {}), void 0 === r[e] && (r[e] = []), n ? r[e].unshift(o) : r[e].push(o);
              }, e.prototype.clear = function () {
                this.__store.clear();
              }, e.prototype.clearEvents = function (e, t) {
                var o = this.__store.get(e);
                o && o[t] && (delete o[t], Object.keys(o).length || this.__store.delete(e));
              }, e.prototype.isEmpty = function () {
                return 0 === this.__store.size;
              }, e;
            }();
            t.EventHandlersStore = r;
          },
          17332: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.eventEmitter = t.getContainer = t.extendLang = t.modules = t.pluginSystem = t.uniqueUid = t.instances = void 0;
            var n = o(44540),
              r = o(64968),
              i = o(55395),
              a = o(77892),
              s = o(96574),
              l = o(87247),
              c = o(11278),
              u = o(86893);
            t.instances = {};
            var d = 1,
              p = new Set();
            t.uniqueUid = function () {
              function e() {
                return d += 10 * (Math.random() + 1), Math.round(d).toString(16);
              }
              for (var t = e(); p.has(t);) t = e();
              return p.add(t), t;
            }, t.pluginSystem = new n.PluginSystem(), t.modules = {}, t.extendLang = function (e) {
              Object.keys(e).forEach(function (t) {
                u.lang[t] ? Object.assign(u.lang[t], e[t]) : u.lang[t] = e[t];
              });
            };
            var f = new WeakMap();
            t.getContainer = function (e, t, o, n) {
              void 0 === o && (o = "div"), void 0 === n && (n = !1);
              var i = t ? (0, l.getClassName)(t.prototype) : "jodit-utils",
                u = f.get(e) || {},
                d = i + o,
                p = (0, s.isViewObject)(e) ? e : e.j;
              if (!u[d]) {
                var h = p.c,
                  m = (0, a.isJoditObject)(e) && e.o.shadowRoot ? e.o.shadowRoot : e.od.body;
                if (n && (0, a.isJoditObject)(e) && e.od !== e.ed) {
                  h = e.createInside;
                  var v = "style" === o ? e.ed.head : e.ed.body;
                  m = (0, a.isJoditObject)(e) && e.o.shadowRoot ? e.o.shadowRoot : v;
                }
                var g = h.element(o, {
                  className: "jodit jodit-".concat((0, c.kebabCase)(i), "-container jodit-box")
                });
                g.classList.add("jodit_theme_".concat(p.o.theme || "default")), m.appendChild(g), u[d] = g, e.hookStatus("beforeDestruct", function () {
                  r.Dom.safeRemove(g), delete u[d], Object.keys(u).length && f.delete(e);
                }), f.set(e, u);
              }
              return u[d].classList.remove("jodit_theme_default", "jodit_theme_dark"), u[d].classList.add("jodit_theme_".concat(p.o.theme || "default")), u[d];
            }, t.eventEmitter = new i.EventEmitter();
          },
          34578: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.asArray = void 0;
            var n = o(49781);
            t.asArray = function (e) {
              return (0, n.isArray)(e) ? e : [e];
            };
          },
          12557: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.toArray = t.splitArray = t.asArray = void 0;
            var n = o(34578);
            Object.defineProperty(t, "asArray", {
              enumerable: !0,
              get: function () {
                return n.asArray;
              }
            });
            var r = o(14556);
            Object.defineProperty(t, "splitArray", {
              enumerable: !0,
              get: function () {
                return r.splitArray;
              }
            });
            var i = o(1853);
            Object.defineProperty(t, "toArray", {
              enumerable: !0,
              get: function () {
                return i.toArray;
              }
            });
          },
          14556: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.splitArray = void 0, t.splitArray = function (e) {
              return Array.isArray(e) ? e : e.split(/[,\s]+/);
            };
          },
          1853: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.toArray = void 0;
            var n = o(80861),
              r = o(28069);
            t.toArray = function () {
              for (var e, t = [], o = 0; arguments.length > o; o++) t[o] = arguments[o];
              var i = (0, r.isNativeFunction)(Array.from) ? Array.from : null !== (e = (0, n.reset)("Array.from")) && void 0 !== e ? e : Array.from;
              return i.apply(Array, t);
            };
          },
          4696: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(27512), t);
          },
          27512: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.clearTimeout = t.setTimeout = void 0;
            var n = o(20255);
            t.setTimeout = function (e, t) {
              for (var o = [], r = 2; arguments.length > r; r++) o[r - 2] = arguments[r];
              return t ? window.setTimeout.apply(window, n.__spreadArray([e, t], n.__read(o), !1)) : (e.call.apply(e, n.__spreadArray([null], n.__read(o), !1)), 0);
            }, t.clearTimeout = function (e) {
              window.clearTimeout(e);
            };
          },
          31553: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hasBrowserColorPicker = void 0, t.hasBrowserColorPicker = function () {
              var e = !0;
              try {
                var t = document.createElement("input");
                t.type = "color", t.value = "!", e = "color" === t.type && "!" !== t.value;
              } catch (t) {
                e = !1;
              }
              return e;
            };
          },
          10172: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(31553), t), n.__exportStar(o(49781), t), n.__exportStar(o(67749), t), n.__exportStar(o(32756), t), n.__exportStar(o(42096), t), n.__exportStar(o(66869), t), n.__exportStar(o(72543), t), n.__exportStar(o(33156), t), n.__exportStar(o(93578), t), n.__exportStar(o(77892), t), n.__exportStar(o(96574), t), n.__exportStar(o(60280), t), n.__exportStar(o(28069), t), n.__exportStar(o(61817), t), n.__exportStar(o(57649), t), n.__exportStar(o(79736), t), n.__exportStar(o(26335), t), n.__exportStar(o(24421), t), n.__exportStar(o(64350), t), n.__exportStar(o(19179), t), n.__exportStar(o(24021), t), n.__exportStar(o(85994), t), n.__exportStar(o(37204), t);
          },
          49781: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isArray = void 0, t.isArray = function (e) {
              return Array.isArray(e);
            };
          },
          67749: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isBoolean = void 0, t.isBoolean = function (e) {
              return "boolean" == typeof e;
            };
          },
          32756: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isFastEqual = t.isEqual = void 0;
            var n = o(42554);
            t.isEqual = function (e, t) {
              return e === t || (0, n.stringify)(e) === (0, n.stringify)(t);
            }, t.isFastEqual = function (e, t) {
              return e === t;
            };
          },
          42096: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isFunction = void 0, t.isFunction = function (e) {
              return "function" == typeof e;
            };
          },
          72543: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isHtmlFromWord = void 0, t.isHtmlFromWord = function (e) {
              return -1 !== e.search(/<meta.*?Microsoft Excel\s[\d].*?>/) || -1 !== e.search(/<meta.*?Microsoft Word\s[\d].*?>/) || -1 !== e.search(/style="[^"]*mso-/) && -1 !== e.search(/<font/);
            };
          },
          66869: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isHTML = void 0;
            var n = o(24421);
            t.isHTML = function (e) {
              return (0, n.isString)(e) && /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(e.replace(/[\r\n]/g, ""));
            };
          },
          33156: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hasContainer = t.isDestructable = t.isInitable = void 0;
            var n = o(42096),
              r = o(24263),
              i = o(24021);
            t.isInitable = function (e) {
              return !(0, i.isVoid)(e) && (0, n.isFunction)(e.init);
            }, t.isDestructable = function (e) {
              return !(0, i.isVoid)(e) && (0, n.isFunction)(e.destruct);
            }, t.hasContainer = function (e) {
              return !(0, i.isVoid)(e) && r.Dom.isElement(e.container);
            };
          },
          93578: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isInt = void 0;
            var n = o(57649),
              r = o(24421);
            t.isInt = function (e) {
              return (0, r.isString)(e) && (0, n.isNumeric)(e) && (e = parseFloat(e)), "number" == typeof e && Number.isFinite(e) && !(e % 1);
            };
          },
          77892: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isJoditObject = void 0;
            var n = o(42096);
            t.isJoditObject = function (e) {
              return Boolean(e && e instanceof Object && (0, n.isFunction)(e.constructor) && ("undefined" != typeof Jodit && e instanceof Jodit || e.isJodit));
            };
          },
          60280: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isLicense = void 0;
            var n = o(24421);
            t.isLicense = function (e) {
              return (0, n.isString)(e) && 23 === e.length && /^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}$/i.test(e);
            };
          },
          37204: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isMarker = void 0;
            var n = o(24263),
              r = o(86893);
            t.isMarker = function (e) {
              return n.Dom.isNode(e) && n.Dom.isTag(e, "span") && e.hasAttribute("data-" + r.MARKER_CLASS);
            };
          },
          28069: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isNativeFunction = void 0, t.isNativeFunction = function (e) {
              return Boolean(e) && "function" === (typeof e).toLowerCase() && (e === Function.prototype || /^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code]\s*}\s*$/i.test(String(e)));
            };
          },
          61817: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isNumber = void 0, t.isNumber = function (e) {
              return "number" == typeof e && !isNaN(e) && isFinite(e);
            };
          },
          57649: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isNumeric = void 0;
            var n = o(24421);
            t.isNumeric = function (e) {
              if ((0, n.isString)(e)) {
                if (!e.match(/^([+-])?[0-9]+(\.?)([0-9]+)?(e[0-9]+)?$/)) return !1;
                e = parseFloat(e);
              }
              return "number" == typeof e && !isNaN(e) && isFinite(e);
            };
          },
          79736: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isPlainObject = void 0;
            var n = o(85994);
            t.isPlainObject = function (e) {
              return !(!e || "object" != typeof e || e.nodeType || (0, n.isWindow)(e) || e.constructor && !{}.hasOwnProperty.call(e.constructor.prototype, "isPrototypeOf"));
            };
          },
          26335: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isPromise = void 0, t.isPromise = function (e) {
              return e && "function" == typeof e.then;
            };
          },
          24421: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isStringArray = t.isString = void 0;
            var n = o(49781);
            function r(e) {
              return "string" == typeof e;
            }
            t.isString = r, t.isStringArray = function (e) {
              return (0, n.isArray)(e) && r(e[0]);
            };
          },
          64350: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isURL = void 0, t.isURL = function (e) {
              if (e.includes(" ")) return !1;
              if ("undefined" != typeof URL) try {
                var t = new URL(e);
                return ["https:", "http:", "ftp:", "file:", "rtmp:"].includes(t.protocol);
              } catch (e) {
                return !1;
              }
              var o = document.createElement("a");
              return o.href = e, Boolean(o.hostname);
            };
          },
          19179: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isValidName = void 0, t.isValidName = function (e) {
              return !!e.length && !/[^0-9A-Za-zа-яА-ЯЁё\w\-_.]/.test(e);
            };
          },
          96574: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isViewObject = void 0;
            var n = o(42096);
            t.isViewObject = function (e) {
              return Boolean(e && e instanceof Object && (0, n.isFunction)(e.constructor) && e.isView);
            };
          },
          24021: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isVoid = void 0, t.isVoid = function (e) {
              return null == e;
            };
          },
          85994: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isWindow = void 0, t.isWindow = function (e) {
              return null != e && e === e.window;
            };
          },
          13203: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.colorToHex = void 0, t.colorToHex = function (e) {
              if ("rgba(0, 0, 0, 0)" === e || "" === e) return !1;
              if (!e) return "#000000";
              if ("#" === e.substr(0, 1)) return e;
              var t = /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(e) || /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(e);
              if (!t) return "#000000";
              for (var o = parseInt(t[2], 10), n = parseInt(t[3], 10), r = (parseInt(t[4], 10) | n << 8 | o << 16).toString(16).toUpperCase(); 6 > r.length;) r = "0" + r;
              return t[1] + "#" + r;
            };
          },
          61354: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(13203), t);
          },
          66546: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.applyStyles = void 0;
            var n = o(24263),
              r = o(76502),
              i = o(33941);
            function a(e) {
              return e.replace(/mso-[a-z-]+:[\s]*[^;]+;/gi, "").replace(/mso-[a-z-]+:[\s]*[^";']+$/gi, "").replace(/border[a-z-]*:[\s]*[^;]+;/gi, "").replace(/([0-9.]+)(pt|cm)/gi, function (e, t, o) {
                switch (o.toLowerCase()) {
                  case "pt":
                    return (1.328 * parseFloat(t)).toFixed(0) + "px";
                  case "cm":
                    return (.02645833 * parseFloat(t)).toFixed(0) + "px";
                }
                return e;
              });
            }
            t.applyStyles = function (e) {
              if (-1 === e.indexOf("<html ")) return e;
              e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + "</html>".length);
              var t = document.createElement("iframe");
              t.style.display = "none", document.body.appendChild(t);
              var o = "";
              try {
                var s = t.contentDocument || (t.contentWindow ? t.contentWindow.document : null);
                if (s) {
                  s.open(), s.write(e), s.close();
                  try {
                    for (var l = function (e) {
                        for (var t = s.styleSheets[e].cssRules, o = function (e) {
                            if ("" === t[e].selectorText) return "continue";
                            (0, r.$$)(t[e].selectorText, s.body).forEach(function (o) {
                              o.style.cssText = a(t[e].style.cssText + ";" + o.style.cssText);
                            });
                          }, n = 0; t.length > n; n += 1) o(n);
                      }, c = 0; s.styleSheets.length > c; c += 1) l(c);
                  } catch (e) {}
                  n.Dom.each(s.body, function (e) {
                    if (n.Dom.isElement(e)) {
                      var t = e,
                        o = t.getAttribute("style");
                      o && (t.style.cssText = a(o)), t.hasAttribute("style") && !t.getAttribute("style") && t.removeAttribute("style");
                    }
                  }), o = s.firstChild ? (0, i.trim)(s.body.innerHTML) : "";
                }
              } catch (e) {} finally {
                n.Dom.safeRemove(t);
              }
              return o && (e = o), (0, i.trim)(e.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, ""));
            };
          },
          33316: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.cleanFromWord = void 0;
            var n = o(24263),
              r = o(33941),
              i = o(1853);
            t.cleanFromWord = function (e) {
              -1 !== e.indexOf("<html ") && (e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + "</html>".length));
              var t = "";
              try {
                var o = document.createElement("div");
                o.innerHTML = e;
                var a = [];
                o.firstChild && n.Dom.each(o, function (e) {
                  if (e) switch (e.nodeType) {
                    case Node.ELEMENT_NODE:
                      switch (e.nodeName) {
                        case "STYLE":
                        case "LINK":
                        case "META":
                          a.push(e);
                          break;
                        case "W:SDT":
                        case "W:SDTPR":
                        case "FONT":
                          n.Dom.unwrap(e);
                          break;
                        default:
                          (0, i.toArray)(e.attributes).forEach(function (t) {
                            -1 === ["src", "href", "rel", "content"].indexOf(t.name.toLowerCase()) && e.removeAttribute(t.name);
                          });
                      }
                      break;
                    case Node.TEXT_NODE:
                      break;
                    default:
                      a.push(e);
                  }
                }), n.Dom.safeRemove.apply(null, a), t = o.innerHTML;
              } catch (e) {}
              return t && (e = t), (e = e.split(/(\n)/).filter(r.trim).join("\n")).replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, "");
            };
          },
          46639: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.htmlspecialchars = void 0, t.htmlspecialchars = function (e) {
              var t = document.createElement("div");
              return t.textContent = e, t.innerHTML;
            };
          },
          13098: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(66546), t), n.__exportStar(o(33316), t), n.__exportStar(o(46639), t), n.__exportStar(o(11336), t), n.__exportStar(o(67128), t), n.__exportStar(o(86645), t);
          },
          86645: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.nl2br = void 0, t.nl2br = function (e) {
              return e.replace(/\r\n|\r|\n/g, "<br/>");
            };
          },
          67128: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.sanitizeHTMLElement = t.safeHTML = void 0;
            var n = o(76502),
              r = o(24263);
            function i(e, t) {
              var o = void 0 === t ? {
                  safeJavaScriptLink: !0,
                  removeOnError: !0
                } : t,
                i = o.safeJavaScriptLink,
                a = o.removeOnError;
              if (!r.Dom.isElement(e)) return !1;
              var s = !1;
              a && e.hasAttribute("onerror") && ((0, n.attr)(e, "onerror", null), s = !0);
              var l = e.getAttribute("href");
              return i && l && 0 === l.trim().indexOf("javascript") && ((0, n.attr)(e, "href", location.protocol + "//" + l), s = !0), s;
            }
            t.safeHTML = function (e, t) {
              (r.Dom.isElement(e) || r.Dom.isFragment(e)) && (t.removeOnError && (i(e), (0, n.$$)("[onerror]", e).forEach(function (e) {
                return i(e, t);
              })), t.safeJavaScriptLink && (i(e), (0, n.$$)('a[href^="javascript"]', e).forEach(function (e) {
                return i(e, t);
              })));
            }, t.sanitizeHTMLElement = i;
          },
          11336: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.stripTags = void 0;
            var n = o(24421),
              r = o(76502),
              i = o(33941),
              a = o(24263),
              s = new Set(["div", "p", "br", "h1", "h2", "h3", "h4", "h5", "h6", "hr"]),
              l = new Set(["script", "style"]);
            t.stripTags = function e(t, o, c) {
              void 0 === o && (o = document), void 0 === c && (c = null);
              var u = o.createElement("div");
              return (0, n.isString)(t) ? u.innerHTML = t : u.appendChild(t), (0, r.$$)("*", u).forEach(function (t) {
                var n = t.parentNode;
                if (n) {
                  if (c && a.Dom.isTag(t, c)) {
                    var r = t.nodeName.toLowerCase(),
                      i = a.Dom.isTag(t, ["br", "hr", "input"]) ? "%%%jodit-single-".concat(r, "%%%") : "%%%jodit-".concat(r, "%%%").concat(e(t.innerHTML, o, c), "%%%/jodit-").concat(r, "%%%");
                    return a.Dom.before(t, o.createTextNode(i)), void a.Dom.safeRemove(t);
                  }
                  if (a.Dom.isTag(t, l)) a.Dom.safeRemove(t);else if (a.Dom.isTag(t, s)) {
                    var u = t.nextSibling;
                    a.Dom.isText(u) && /^\s/.test(u.nodeValue || "") || u && n.insertBefore(o.createTextNode(" "), u);
                  }
                }
              }), (0, i.trim)(u.innerText).replace(/%%%(\/)?jodit(-single)?-([\w\n]+)%%%/g, function (e, t, o, n) {
                return "<".concat(t ? "/" : "").concat(n, ">");
              });
            };
          },
          40332: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(76502), t), n.__exportStar(o(12557), t), n.__exportStar(o(4696), t), n.__exportStar(o(10172), t), n.__exportStar(o(61354), t), n.__exportStar(o(13098), t), n.__exportStar(o(89693), t), n.__exportStar(o(90954), t), n.__exportStar(o(19035), t);
          },
          89693: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(48926), t), n.__exportStar(o(78648), t), n.__exportStar(o(74504), t), n.__exportStar(o(50870), t), n.__exportStar(o(76787), t), n.__exportStar(o(93251), t), n.__exportStar(o(91518), t), n.__exportStar(o(49353), t), n.__exportStar(o(64274), t);
          },
          64274: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeColor = void 0;
            var n = o(61354),
              r = o(19035);
            t.normalizeColor = function (e) {
              var t = ["#"],
                o = (0, n.colorToHex)(e);
              if (!o) return !1;
              if (3 === (o = (o = (0, r.trim)(o.toUpperCase())).substr(1)).length) {
                for (var i = 0; 3 > i; i += 1) t.push(o[i]), t.push(o[i]);
                return t.join("");
              }
              return o.length > 6 && (o = o.substr(0, 6)), "#" + o;
            };
          },
          49353: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeCssValue = t.normalizeCssNumericValue = t.NUMBER_FIELDS_REG = void 0;
            var n = o(57649),
              r = o(11278),
              i = o(13203),
              a = o(24021);
            t.NUMBER_FIELDS_REG = /^(left|top|bottom|right|width|min|max|height|margin|padding|fontsize|font-size)/i, t.normalizeCssNumericValue = function (e, o) {
              return !(0, a.isVoid)(o) && t.NUMBER_FIELDS_REG.test(e) && (0, n.isNumeric)(o.toString()) ? parseInt(o.toString(), 10) + "px" : o;
            }, t.normalizeCssValue = function (e, t) {
              if ("font-weight" === (0, r.kebabCase)(e)) {
                switch (t.toString().toLowerCase()) {
                  case "700":
                  case "bold":
                    return 700;
                  case "400":
                  case "normal":
                    return 400;
                  case "900":
                  case "heavy":
                    return 900;
                }
                return (0, n.isNumeric)(t) ? Number(t) : t;
              }
              return /color/i.test(e) && /^rgb/i.test(t.toString()) && (0, i.colorToHex)(t.toString()) || t;
            };
          },
          48926: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeKeyAliases = void 0;
            var n = o(33941),
              r = o(86893);
            t.normalizeKeyAliases = function (e) {
              var t = {},
                o = {
                  meta: 1,
                  ctrl: 2,
                  control: 2,
                  alt: 3,
                  shift: 4
                };
              return e.replace(/\+\+/g, "+add").split(/[\s]*\+[\s]*/).map(function (e) {
                return (0, n.trim)(e.toLowerCase());
              }).map(function (e) {
                return r.KEY_ALIASES[e] || e;
              }).sort(function (e, t) {
                return o[e] && !o[t] ? -1 : !o[e] && o[t] ? 1 : o[e] && o[t] ? o[e] - o[t] : e > t ? 1 : -1;
              }).filter(function (e) {
                return !t[e] && "" !== e && (t[e] = !0);
              }).join("+");
            };
          },
          78648: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeLicense = void 0, t.normalizeLicense = function (e, t) {
              void 0 === t && (t = 8);
              for (var o = []; e.length;) o.push(e.substr(0, t)), e = e.substr(t);
              return o[1] = o[1].replace(/./g, "*"), o[2] = o[2].replace(/./g, "*"), o.join("-");
            };
          },
          74504: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeNode = void 0;
            var n = o(86893),
              r = o(24263);
            t.normalizeNode = function e(t) {
              if (t) {
                if (r.Dom.isText(t) && null != t.nodeValue && t.parentNode) for (; r.Dom.isText(t.nextSibling);) null != t.nextSibling.nodeValue && (t.nodeValue += t.nextSibling.nodeValue), t.nodeValue = t.nodeValue.replace((0, n.INVISIBLE_SPACE_REG_EXP)(), ""), r.Dom.safeRemove(t.nextSibling);else e(t.firstChild);
                e(t.nextSibling);
              }
            };
          },
          50870: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizePath = void 0;
            var n = o(19035);
            t.normalizePath = function () {
              for (var e = [], t = 0; arguments.length > t; t++) e[t] = arguments[t];
              return e.filter(function (e) {
                return (0, n.trim)(e).length;
              }).map(function (t, o) {
                return t = t.replace(/([^:])[\\/]+/g, "$1/"), o && (t = t.replace(/^\//, "")), o !== e.length - 1 && (t = t.replace(/\/$/, "")), t;
              }).join("/");
            };
          },
          76787: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeRelativePath = void 0, t.normalizeRelativePath = function (e) {
              return e.split("/").reduce(function (e, t) {
                switch (t) {
                  case "":
                  case ".":
                    break;
                  case "..":
                    e.pop();
                    break;
                  default:
                    e.push(t);
                }
                return e;
              }, []).join("/") + (e.endsWith("/") ? "/" : "");
            };
          },
          93251: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeSize = void 0, t.normalizeSize = function (e) {
              return /^[0-9]+$/.test(e.toString()) ? e + "px" : e.toString();
            };
          },
          91518: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeUrl = void 0, t.normalizeUrl = function () {
              for (var e = [], t = 0; arguments.length > t; t++) e[t] = arguments[t];
              return e.filter(function (e) {
                return e.length;
              }).map(function (e) {
                return e.replace(/\/$/, "");
              }).join("/").replace(/([^:])[\\/]+/g, "$1/");
            };
          },
          1684: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getContentWidth = void 0, t.getContentWidth = function (e, t) {
              var o = function (e) {
                  return parseInt(e, 10);
                },
                n = t.getComputedStyle(e);
              return e.offsetWidth - o(n.getPropertyValue("padding-left") || "0") - o(n.getPropertyValue("padding-right") || "0");
            };
          },
          73874: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getScrollParent = void 0;
            var n = o(76502),
              r = o(24263);
            t.getScrollParent = function e(t) {
              if (!t) return null;
              var o = r.Dom.isHTMLElement(t),
                i = o && (0, n.css)(t, "overflowY");
              return o && "visible" !== i && "hidden" !== i && t.scrollHeight >= t.clientHeight ? t : e(t.parentNode) || document.scrollingElement || document.body;
            };
          },
          90954: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(1684), t), n.__exportStar(o(73874), t), n.__exportStar(o(83810), t), n.__exportStar(o(98701), t), n.__exportStar(o(81710), t), n.__exportStar(o(16492), t);
          },
          83810: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.innerWidth = void 0, t.innerWidth = function (e, t) {
              var o = t.getComputedStyle(e);
              return e.clientWidth - (parseFloat(o.paddingLeft || "0") + parseFloat(o.paddingRight || "0"));
            };
          },
          16492: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.size = void 0;
            var n = o(10172);
            t.size = function (e) {
              return (0, n.isString)(e) || (0, n.isArray)(e) ? e.length : (0, n.isPlainObject)(e) ? Object.keys(e).length : 0;
            };
          },
          98701: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.offset = void 0, t.offset = function (e, o, n, r) {
              var i;
              void 0 === r && (r = !1);
              try {
                i = e.getBoundingClientRect();
              } catch (e) {
                i = {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: 0,
                  height: 0
                };
              }
              var a,
                s,
                l = n.body,
                c = n.documentElement || {
                  clientTop: 0,
                  clientLeft: 0,
                  scrollTop: 0,
                  scrollLeft: 0
                },
                u = n.defaultView || n.parentWindow,
                d = u.pageYOffset || c.scrollTop || l.scrollTop,
                p = u.pageXOffset || c.scrollLeft || l.scrollLeft,
                f = c.clientTop || l.clientTop || 0,
                h = c.clientLeft || l.clientLeft || 0,
                m = o.iframe;
              if (!r && o && o.options && o.o.iframe && m) {
                var v = (0, t.offset)(m, o, o.od, !0);
                a = i.top + v.top, s = i.left + v.left;
              } else a = i.top + d - f, s = i.left + p - h;
              return {
                top: Math.round(a),
                left: Math.round(s),
                width: i.width,
                height: i.height
              };
            };
          },
          81710: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.position = void 0;
            var n = o(77892);
            t.position = function e(t, o, r) {
              void 0 === r && (r = !1);
              var i = t.getBoundingClientRect(),
                a = i.left,
                s = i.top;
              if ((0, n.isJoditObject)(o) && o.iframe && o.ed.body.contains(t) && !r) {
                var l = e(o.iframe, o, !0);
                a += l.left, s += l.top;
              }
              return {
                left: Math.round(a),
                top: Math.round(s),
                width: Math.round(t.offsetWidth),
                height: Math.round(t.offsetHeight)
              };
            };
          },
          26596: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.camelCase = void 0, t.camelCase = function (e) {
              return e.replace(/([-_])(.)/g, function (e, t, o) {
                return o.toUpperCase();
              });
            };
          },
          93163: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.fuzzySearchIndex = void 0;
            var n = o(86893);
            t.fuzzySearchIndex = function (e, t, o, r) {
              void 0 === o && (o = 0), void 0 === r && (r = 1);
              var i = 0,
                a = 0,
                s = -1,
                l = 0,
                c = 0;
              for (a = o; e.length > i && t.length > a;) e[i].toLowerCase() === t[a].toLowerCase() ? (i++, l++, c = 0, -1 === s && (s = a)) : i > 0 && (r > c || t[a] === n.INVISIBLE_SPACE ? (c++, l++) : (i = 0, s = -1, l = 0, c = 0, a--)), a++;
              return i === e.length ? [s, l] : [-1, 0];
            };
          },
          11625: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.i18n = t.sprintf = void 0;
            var n = o(93166),
              r = o(76502),
              i = o(24421),
              a = o(13449),
              s = o(86893);
            t.sprintf = function (e, t) {
              if (!t || !t.length) return e;
              for (var o = /%([sd])/g, n = o.exec(e), r = e, i = 0; n && void 0 !== t[i];) r = r.replace(n[0], t[i].toString()), i += 1, n = o.exec(e);
              return r;
            }, t.i18n = function (e, o, l) {
              if (!(0, i.isString)(e)) throw (0, r.error)("i18n: Need string in first argument");
              if (!e.length) return e;
              var c = Boolean(null == l ? void 0 : l.debugLanguage),
                u = {},
                d = function (e) {
                  return o && o.length ? (0, t.sprintf)(e, o) : e;
                },
                p = (0, r.defaultLanguage)(n.Config.defaultOptions.language, n.Config.defaultOptions.language),
                f = (0, r.defaultLanguage)(null == l ? void 0 : l.language, p),
                h = function (t) {
                  if (t) {
                    if ((0, i.isString)(t[e])) return d(t[e]);
                    var o = e.toLowerCase();
                    if ((0, i.isString)(t[o])) return d(t[o]);
                    var n = (0, a.ucfirst)(e);
                    return (0, i.isString)(t[n]) ? d(t[n]) : void 0;
                  }
                };
              void 0 !== s.lang[f] ? u = s.lang[f] : c || (u = void 0 !== s.lang[p] ? s.lang[p] : s.lang.en);
              var m = null == l ? void 0 : l.i18n;
              if (m && m[f]) {
                var v = h(m[f]);
                if (v) return v;
              }
              return h(u) || (!c && s.lang.en && (0, i.isString)(s.lang.en[e]) && s.lang.en[e] ? d(s.lang.en[e]) : c ? "{" + e + "}" : d(e));
            };
          },
          19035: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(26596), t), n.__exportStar(o(93163), t), n.__exportStar(o(11625), t), n.__exportStar(o(11278), t), n.__exportStar(o(42554), t), n.__exportStar(o(33941), t), n.__exportStar(o(13449), t);
          },
          11278: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.CamelCaseToKebabCase = t.kebabCase = void 0, t.kebabCase = function (e) {
              return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
            }, t.CamelCaseToKebabCase = function (e) {
              return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
            };
          },
          42554: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.stringify = void 0, t.stringify = function (e, t) {
              if (void 0 === t && (t = {}), "object" != typeof e) return String(e);
              var o = new Set(t.excludeKeys),
                n = new WeakMap();
              return JSON.stringify(e, function (e, t) {
                if (!o.has(e)) {
                  if ("object" == typeof t && null != t) {
                    if (n.get(t)) return "[refObject]";
                    n.set(t, !0);
                  }
                  return t;
                }
              }, t.prettify);
            };
          },
          33941: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.trimInv = t.trim = void 0;
            var n = o(86893);
            t.trim = function (e) {
              return e.replace((0, n.SPACE_REG_EXP_END)(), "").replace((0, n.SPACE_REG_EXP_START)(), "");
            }, t.trimInv = function (e) {
              return e.replace((0, n.INVISIBLE_SPACE_REG_EXP_END)(), "").replace((0, n.INVISIBLE_SPACE_REG_EXP_START)(), "");
            };
          },
          13449: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ucfirst = void 0, t.ucfirst = function (e) {
              return e.length ? e[0].toUpperCase() + e.substr(1) : "";
            };
          },
          60303: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.alignElement = t.clearAlign = t.hAlignElement = void 0;
            var n = o(64968),
              r = o(26911);
            function i(e) {
              n.Dom.each(e, function (e) {
                n.Dom.isHTMLElement(e) && e.style.textAlign && (e.style.textAlign = "", e.style.cssText.trim().length || e.removeAttribute("style"));
              });
            }
            t.hAlignElement = function (e, t) {
              t && "normal" !== t ? "center" !== t ? ((0, r.css)(e, "float", t), (0, r.clearCenterAlign)(e)) : (0, r.css)(e, {
                float: "",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }) : ((0, r.css)(e, "float") && -1 !== ["right", "left"].indexOf((0, r.css)(e, "float").toString().toLowerCase()) && (0, r.css)(e, "float", ""), (0, r.clearCenterAlign)(e));
            }, t.clearAlign = i, t.alignElement = function (e, t) {
              if (n.Dom.isNode(t) && n.Dom.isElement(t)) switch (i(t), e.toLowerCase()) {
                case "justifyfull":
                  t.style.textAlign = "justify";
                  break;
                case "justifyright":
                  t.style.textAlign = "right";
                  break;
                case "justifyleft":
                  t.style.textAlign = "left";
                  break;
                case "justifycenter":
                  t.style.textAlign = "center";
              }
            };
          },
          62462: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.loadNextStyle = t.loadNext = t.appendStyleAsync = t.appendScriptAsync = t.appendScript = void 0;
            var n = o(20255),
              r = o(48240),
              i = o(42096),
              a = o(24421),
              s = new Map(),
              l = function (e) {
                return function (t, o) {
                  return n.__awaiter(void 0, void 0, Promise, function () {
                    var r;
                    return n.__generator(this, function (n) {
                      return s.has(o) ? [2, s.get(o)] : (r = e(t, o), s.set(o, r), [2, r]);
                    });
                  });
                };
              };
            t.appendScript = function (e, t, o) {
              var n = e.c.element("script");
              return n.type = "text/javascript", n.async = !0, (0, i.isFunction)(o) && !e.isInDestruct && e.e.on(n, "load", o), n.src || (n.src = (0, r.completeUrl)(t)), e.od.body.appendChild(n), {
                callback: o,
                element: n
              };
            }, t.appendScriptAsync = l(function (e, o) {
              return new Promise(function (n, r) {
                var i = (0, t.appendScript)(e, o, n).element;
                !e.isInDestruct && e.e.on(i, "error", r);
              });
            }), t.appendStyleAsync = l(function (e, t) {
              return new Promise(function (o, n) {
                var i = e.c.element("link");
                i.rel = "stylesheet", i.media = "all", i.crossOrigin = "anonymous", !e.isInDestruct && e.e.on(i, "load", function () {
                  return o(i);
                }).on(i, "error", n), i.href = (0, r.completeUrl)(t), e.o.shadowRoot ? e.o.shadowRoot.appendChild(i) : e.od.body.appendChild(i);
              });
            }), t.loadNext = function (e, o, n) {
              return void 0 === n && (n = 0), (0, a.isString)(o[n]) ? (0, t.appendScriptAsync)(e, o[n]).then(function () {
                return (0, t.loadNext)(e, o, n + 1);
              }) : Promise.resolve();
            }, t.loadNextStyle = function (e, o, n) {
              return void 0 === n && (n = 0), (0, a.isString)(o[n]) ? (0, t.appendStyleAsync)(e, o[n]).then(function () {
                return (0, t.loadNextStyle)(e, o, n + 1);
              }) : Promise.resolve();
            };
          },
          603: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.assert = void 0;
            var n = o(20255),
              r = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  return o.name = "AssertionError", o;
                }
                return n.__extends(t, e), t;
              }(Error);
            t.assert = function (e, t) {
              if (!e) throw new r("Assertion failed: ".concat(t));
            };
          },
          37682: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.browser = void 0, t.browser = function (e) {
              var t = navigator.userAgent.toLowerCase(),
                o = /(firefox)[\s/]([\w.]+)/.exec(t) || /(chrome)[\s/]([\w.]+)/.exec(t) || /(webkit)[\s/]([\w.]+)/.exec(t) || /(opera)(?:.*version)[\s/]([\w.]+)/.exec(t) || /(msie)[\s]([\w.]+)/.exec(t) || /(trident)\/([\w.]+)/.exec(t) || 0 > t.indexOf("compatible") || [];
              return "version" === e ? o[2] : "webkit" === e ? "chrome" === o[1] || "webkit" === o[1] : "ff" === e ? "firefox" === o[1] : "msie" === e ? "trident" === o[1] || "msie" === o[1] : o[1] === e;
            };
          },
          71567: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.buildQuery = void 0;
            var n = o(79736);
            t.buildQuery = function (e, o) {
              var r = [],
                i = encodeURIComponent;
              for (var a in e) if (Object.prototype.hasOwnProperty.call(e, a)) {
                var s = o ? o + "[" + a + "]" : a,
                  l = e[a];
                r.push((0, n.isPlainObject)(l) ? (0, t.buildQuery)(l, s) : i(s) + "=" + i(l));
              }
              return r.join("&");
            };
          },
          48240: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.completeUrl = void 0, t.completeUrl = function (e) {
              return "file:" === window.location.protocol && /^\/\//.test(e) && (e = "https:" + e), e;
            };
          },
          64981: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ConfigFlatten = t.ConfigProto = void 0;
            var n = o(20255),
              r = o(7935),
              i = o(49781),
              a = o(79736),
              s = o(24421),
              l = o(24021),
              c = o(93166),
              u = o(67309);
            t.ConfigProto = function e(t, o, u) {
              if (void 0 === u && (u = 0), Object.getPrototypeOf(t) !== Object.prototype) return t;
              var d = c.Config.defaultOptions;
              if ((0, s.isString)(t.preset)) {
                if (void 0 !== d.presets[t.preset]) {
                  var p = d.presets[t.preset];
                  Object.keys(p).forEach(function (e) {
                    (0, l.isVoid)(t[e]) && (t[e] = p[e]);
                  });
                }
                delete t.preset;
              }
              var f = {};
              return Object.keys(t).forEach(function (s) {
                var l = t[s],
                  c = o ? o[s] : null;
                f[s] = (0, a.isPlainObject)(l) && (0, a.isPlainObject)(c) && !(0, r.isAtom)(l) ? e(l, c, u + 1) : 0 !== u && (0, i.isArray)(l) && !(0, r.isAtom)(l) && (0, i.isArray)(c) ? n.__spreadArray(n.__spreadArray([], n.__read(l), !1), n.__read(c.slice(l.length)), !1) : l;
              }), Object.setPrototypeOf(f, o), f;
            }, t.ConfigFlatten = function (e) {
              return (0, u.keys)(e, !1).reduce(function (t, o) {
                return t[o] = e[o], t;
              }, {});
            };
          },
          42051: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.convertMediaUrlToVideoEmbed = void 0;
            var n = o(64350),
              r = o(67285);
            t.convertMediaUrlToVideoEmbed = function (e, t, o) {
              if (void 0 === t && (t = 400), void 0 === o && (o = 345), !(0, n.isURL)(e)) return e;
              var i = document.createElement("a"),
                a = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
              i.href = e, t || (t = 400), o || (o = 345);
              var s = i.protocol || "";
              switch (i.hostname) {
                case "www.vimeo.com":
                case "vimeo.com":
                  return a.test(e) ? e.replace(a, '<iframe width="' + t + '" height="' + o + '" src="' + s + '//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>') : e;
                case "youtube.com":
                case "www.youtube.com":
                case "youtu.be":
                case "www.youtu.be":
                  var l = i.search ? (0, r.parseQuery)(i.search) : {
                    v: i.pathname.substr(1)
                  };
                  return l.v ? '<iframe width="' + t + '" height="' + o + '" src="' + s + "//www.youtube.com/embed/" + l.v + '" frameborder="0" allowfullscreen></iframe>' : e;
              }
              return e;
            };
          },
          26911: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.clearCenterAlign = t.css = void 0;
            var n = o(79736),
              r = o(67749),
              i = o(49353),
              a = o(26596),
              s = o(11278);
            function l(e, t, o, c) {
              if (void 0 === c && (c = !1), (0, r.isBoolean)(o) && (c = o, o = void 0), (0, n.isPlainObject)(t) || void 0 !== o) {
                var u = function (e, t, o) {
                  void 0 === (o = (0, i.normalizeCssNumericValue)(t, o)) || null != o && l(e, t, !0) === (0, i.normalizeCssValue)(t, o) || (e.style[t] = o);
                };
                if ((0, n.isPlainObject)(t)) for (var d = Object.keys(t), p = 0; d.length > p; p += 1) u(e, (0, a.camelCase)(d[p]), t[d[p]]);else u(e, (0, a.camelCase)(t), o);
                return "";
              }
              var f = (0, s.kebabCase)(t),
                h = e.ownerDocument || document,
                m = !!h && (h.defaultView || h.parentWindow),
                v = e.style[t],
                g = "";
              return void 0 !== v && "" !== v ? g = v : m && !c && (g = m.getComputedStyle(e).getPropertyValue(f)), i.NUMBER_FIELDS_REG.test(t) && /^[-+]?[0-9.]+px$/.test(g.toString()) && (g = parseInt(g.toString(), 10)), (0, i.normalizeCssValue)(t, g);
            }
            t.css = l, t.clearCenterAlign = function (e) {
              "block" === l(e, "display") && l(e, "display", "");
              var t = e.style;
              "auto" === t.marginLeft && "auto" === t.marginRight && (t.marginLeft = "", t.marginRight = "");
            };
          },
          2522: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ctrlKey = void 0, t.ctrlKey = function (e) {
              if ("undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Mac OS X")) {
                if (e.metaKey && !e.altKey) return !0;
              } else if (e.ctrlKey && !e.altKey) return !0;
              return !1;
            };
          },
          63122: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.dataBind = void 0;
            var n = o(96574),
              r = new WeakMap();
            t.dataBind = function (e, t, o) {
              var i = r.get(e);
              if (!i) {
                r.set(e, i = {});
                var a = null;
                (0, n.isViewObject)(e.j) && (a = e.j.e), (0, n.isViewObject)(e) && (a = e.e), a && a.on("beforeDestruct", function () {
                  r.delete(e);
                });
              }
              return void 0 === o ? i[t] : (i[t] = o, o);
            };
          },
          93351: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultLanguage = void 0;
            var n = o(24421);
            t.defaultLanguage = function (e, t) {
              return void 0 === t && (t = "en"), "auto" !== e && (0, n.isString)(e) ? e : document.documentElement && document.documentElement.lang ? document.documentElement.lang : navigator.language ? navigator.language.substring(0, 2) : t;
            };
          },
          41579: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isAbort = t.abort = t.options = t.connection = t.error = void 0;
            var n = o(45339);
            t.error = function (e) {
              return new TypeError(e);
            }, t.connection = function (e) {
              return new n.ConnectionError(e);
            }, t.options = function (e) {
              return new n.OptionsError(e);
            }, t.abort = function (e) {
              return new n.AbortError(e);
            }, t.isAbort = function (e) {
              return e instanceof n.AbortError;
            };
          },
          86768: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.AbortError = void 0;
            var n = o(20255),
              r = function (e) {
                function t(o) {
                  var n = e.call(this, o) || this;
                  return Object.setPrototypeOf(n, t.prototype), n;
                }
                return n.__extends(t, e), t;
              }(Error);
            t.AbortError = r;
          },
          43380: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ConnectionError = void 0;
            var n = o(20255),
              r = function (e) {
                function t(o) {
                  var n = e.call(this, o) || this;
                  return Object.setPrototypeOf(n, t.prototype), n;
                }
                return n.__extends(t, e), t;
              }(Error);
            t.ConnectionError = r;
          },
          45339: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(86768), t), n.__exportStar(o(43380), t), n.__exportStar(o(47403), t);
          },
          47403: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.OptionsError = void 0;
            var n = o(20255),
              r = function (e) {
                function t(o) {
                  var n = e.call(this, o) || this;
                  return Object.setPrototypeOf(n, t.prototype), n;
                }
                return n.__extends(t, e), t;
              }(TypeError);
            t.OptionsError = r;
          },
          56964: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(41579), t), n.__exportStar(o(45339), t);
          },
          7935: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.fastClone = t.markAsAtomic = t.isAtom = void 0;
            var n = o(42554);
            t.isAtom = function (e) {
              return e && e.isAtom;
            }, t.markAsAtomic = function (e) {
              return Object.defineProperty(e, "isAtom", {
                enumerable: !1,
                value: !0,
                configurable: !1
              }), e;
            }, t.fastClone = function (e) {
              return JSON.parse((0, n.stringify)(e));
            };
          },
          87247: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getClassName = t.keepNames = void 0;
            var n = o(42096);
            t.keepNames = new Map(), t.getClassName = function (e) {
              var o;
              if ((0, n.isFunction)(e.className)) return e.className();
              var r = (null === (o = e.constructor) || void 0 === o ? void 0 : o.originalConstructor) || e.constructor;
              if (t.keepNames.has(r)) return t.keepNames.get(r);
              if (r.name) return r.name;
              var i = new RegExp(/^\s*function\s*(\S*)\s*\(/),
                a = r.toString().match(i);
              return a ? a[1] : "";
            };
          },
          69384: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.get = void 0;
            var n = o(20255),
              r = o(24421),
              i = o(24021);
            t.get = function (e, t) {
              var o, a;
              if (!(0, r.isString)(e) || !e.length) return null;
              var s = e.split("."),
                l = t;
              try {
                try {
                  for (var c = n.__values(s), u = c.next(); !u.done; u = c.next()) {
                    var d = u.value;
                    if ((0, i.isVoid)(l[d])) return null;
                    l = l[d];
                  }
                } catch (e) {
                  o = {
                    error: e
                  };
                } finally {
                  try {
                    u && !u.done && (a = c.return) && a.call(c);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              } catch (e) {
                return null;
              }
              return (0, i.isVoid)(l) ? null : l;
            };
          },
          6102: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.humanSizeToBytes = void 0, t.humanSizeToBytes = function (e) {
              if (/^[0-9.]+$/.test(e.toString())) return parseFloat(e);
              var t = e.substr(-2, 2).toUpperCase(),
                o = ["KB", "MB", "GB", "TB"],
                n = parseFloat(e.substr(0, e.length - 2));
              return -1 !== o.indexOf(t) ? n * Math.pow(1024, o.indexOf(t) + 1) : parseInt(e, 10);
            };
          },
          76502: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(60303), t), n.__exportStar(o(62462), t), n.__exportStar(o(52378), t), n.__exportStar(o(37682), t), n.__exportStar(o(71567), t), n.__exportStar(o(48240), t), n.__exportStar(o(64981), t), n.__exportStar(o(42051), t), n.__exportStar(o(26911), t), n.__exportStar(o(2522), t), n.__exportStar(o(63122), t), n.__exportStar(o(93351), t), n.__exportStar(o(56964), t), n.__exportStar(o(7935), t), n.__exportStar(o(69384), t), n.__exportStar(o(87247), t), n.__exportStar(o(6102), t), n.__exportStar(o(47580), t), n.__exportStar(o(67285), t), n.__exportStar(o(21498), t), n.__exportStar(o(80861), t), n.__exportStar(o(9005), t), n.__exportStar(o(54188), t), n.__exportStar(o(21518), t), n.__exportStar(o(37228), t), n.__exportStar(o(67309), t), n.__exportStar(o(22362), t);
          },
          47580: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.markDeprecated = t.cns = void 0;
            var n = o(20255);
            t.cns = console, t.markDeprecated = function (e, o, r) {
              return void 0 === o && (o = [""]), void 0 === r && (r = null), function () {
                for (var i = [], a = 0; arguments.length > a; a++) i[a] = arguments[a];
                return t.cns.warn('Method "'.concat(o[0], '" deprecated.') + (o[1] ? ' Use "'.concat(o[1], '" instead') : "")), e.call.apply(e, n.__spreadArray([r], n.__read(i), !1));
              };
            };
          },
          67285: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.parseQuery = void 0, t.parseQuery = function (e) {
              for (var t = {}, o = e.substring(1).split("&"), n = 0; o.length > n; n += 1) {
                var r = o[n].split("=");
                t[decodeURIComponent(r[0])] = decodeURIComponent(r[1] || "");
              }
              return t;
            };
          },
          21498: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.previewBox = void 0;
            var n = o(24421),
              r = o(24263),
              i = o(26911),
              a = o(67309),
              s = o(54188);
            t.previewBox = function (e, t, o, l) {
              void 0 === o && (o = "px"), void 0 === l && (l = null);
              var c = function (e, t) {
                var o = [];
                try {
                  (0, s.$$)("img", e.editor).forEach(function (n) {
                    var i = [(0, a.attr)(n, "width"), (0, a.attr)(n, "height"), n.src];
                    (0, a.attr)(n, {
                      width: n.offsetWidth + t,
                      height: n.offsetHeight + t
                    });
                    var s = e.createInside.a();
                    e.ed.body.appendChild(s), s.href = n.src, n.src = s.href, r.Dom.safeRemove(s), o.push(function () {
                      var e;
                      n.src = null !== (e = i[2]) && void 0 !== e ? e : "", (0, a.attr)(n, {
                        width: i[0] || null,
                        height: i[1] || null
                      });
                    });
                  });
                } catch (e) {
                  throw o.forEach(function (e) {
                    return e();
                  }), o.length = 0, e;
                }
                return o;
              }(e, o);
              try {
                var u = e.e.fire("beforePreviewBox", t, o);
                if (null != u) return u;
                var d = e.c.div("jodit__preview-box jodit-context");
                l && l.appendChild(d), (0, i.css)(d, {
                  position: "relative",
                  padding: 16
                });
                var p = e.value || "<div style='position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);color:#ccc;'>".concat(e.i18n("Empty"), "</div>");
                if (e.iframe) {
                  var f = e.create.element("iframe");
                  (0, i.css)(f, {
                    minWidth: 800,
                    minHeight: 600,
                    border: 0
                  }), d.appendChild(f);
                  var h = f.contentWindow;
                  if (h && (e.e.fire("generateDocumentStructure.iframe", h.document, e), d = h.document.body, "function" == typeof ResizeObserver)) {
                    var m = new ResizeObserver(function (e) {
                      f.style.height = h.document.body.offsetHeight + 20 + "px";
                    });
                    m.observe(h.document.body), e.e.on("beforeDestruct", function () {
                      m.unobserve(h.document.body);
                    });
                  }
                } else (0, i.css)(d, {
                  minWidth: 1024,
                  minHeight: 600,
                  border: 0
                });
                var v = function (t, o) {
                  var i = (0, n.isString)(o) ? e.c.div() : o;
                  (0, n.isString)(o) && (i.innerHTML = o);
                  for (var s = 0; i.childNodes.length > s; s += 1) {
                    var l = i.childNodes[s];
                    if (r.Dom.isElement(l)) {
                      for (var c = t.ownerDocument.createElement(l.nodeName), u = 0; l.attributes.length > u; u += 1) (0, a.attr)(c, l.attributes[u].nodeName, l.attributes[u].nodeValue);
                      0 === l.childNodes.length || r.Dom.isTag(l, ["table"]) ? "SCRIPT" === l.nodeName ? l.textContent && (c.textContent = l.textContent) : l.innerHTML && (c.innerHTML = l.innerHTML) : v(c, l);
                      try {
                        t.appendChild(c);
                      } catch (e) {}
                    } else try {
                      t.appendChild(l.cloneNode(!0));
                    } catch (e) {}
                  }
                };
                return v(d, p), e.e.fire("afterPreviewBox", d), d;
              } finally {
                c.forEach(function (e) {
                  return e();
                });
              }
            };
          },
          80861: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.reset = void 0;
            var n = o(69384),
              r = o(42096),
              i = {};
            t.reset = function (e) {
              var t, o;
              if (!(e in i)) {
                var a = document.createElement("iframe");
                try {
                  if (a.src = "about:blank", document.body.appendChild(a), !a.contentWindow) return null;
                  var s = (0, n.get)(e, a.contentWindow),
                    l = (0, n.get)(e.split(".").slice(0, -1).join("."), a.contentWindow);
                  (0, r.isFunction)(s) && (i[e] = s.bind(l));
                } catch (e) {} finally {
                  null === (t = a.parentNode) || void 0 === t || t.removeChild(a);
                }
              }
              return null !== (o = i[e]) && void 0 !== o ? o : null;
            };
          },
          9005: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.scrollIntoViewIfNeeded = t.inView = void 0;
            var n = o(24263);
            t.inView = function (e, t, o) {
              var n = e.getBoundingClientRect(),
                r = e,
                i = n.top,
                a = n.height;
              do {
                if (r && r.parentNode) {
                  if ((n = (r = r.parentNode).getBoundingClientRect()).bottom < i) return !1;
                  if (n.top >= i + a) return !1;
                }
              } while (r && r !== t && r.parentNode);
              return (o.documentElement && o.documentElement.clientHeight || 0) >= i;
            }, t.scrollIntoViewIfNeeded = function (e, o, r) {
              n.Dom.isHTMLElement(e) && !(0, t.inView)(e, o, r) && (o.clientHeight !== o.scrollHeight && (o.scrollTop = e.offsetTop), (0, t.inView)(e, o, r) || e.scrollIntoView());
            };
          },
          54188: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.resolveElement = t.cssPath = t.refs = t.getXPathByElement = t.$$ = void 0;
            var n = o(86893),
              r = o(24421),
              i = o(76502),
              a = o(24263),
              s = o(26596),
              l = o(1853),
              c = o(53929),
              u = o(45113),
              d = 1;
            function p(e, t) {
              var o;
              if (!/:scope/.test(e) || !n.IS_IE || t && t.nodeType === Node.DOCUMENT_NODE) o = t.querySelectorAll(e);else {
                var r = t.id,
                  i = r || "_selector_id_" + String(Math.random()).slice(2) + ++d;
                e = e.replace(/:scope/g, "#" + i), !r && t.setAttribute("id", i), o = t.parentNode.querySelectorAll(e), r || t.removeAttribute("id");
              }
              return [].slice.call(o);
            }
            t.$$ = p, t.getXPathByElement = function (e, o) {
              if (!e || e.nodeType !== Node.ELEMENT_NODE) return "";
              if (!e.parentNode || o === e) return "";
              if (e.id) return "//*[@id='" + e.id + "']";
              var n = [].filter.call(e.parentNode.childNodes, function (t) {
                return t.nodeName === e.nodeName;
              });
              return (0, t.getXPathByElement)(e.parentNode, o) + "/" + e.nodeName.toLowerCase() + (n.length > 1 ? "[" + ((0, l.toArray)(n).indexOf(e) + 1) + "]" : "");
            }, t.refs = function (e) {
              return u.Component.isInstanceOf(e, c.UIElement) && (e = e.container), p("[ref],[data-ref]", e).reduce(function (e, t) {
                var o = (0, i.attr)(t, "-ref");
                return o && (0, r.isString)(o) && (e[(0, s.camelCase)(o)] = t, e[o] = t), e;
              }, {});
            }, t.cssPath = function (e) {
              if (!a.Dom.isElement(e)) return null;
              for (var t = [], o = e; o && o.nodeType === Node.ELEMENT_NODE;) {
                var n = o.nodeName.toLowerCase();
                if (o.id) {
                  t.unshift(n += "#" + o.id);
                  break;
                }
                var r = o,
                  i = 1;
                do {
                  (r = r.previousElementSibling) && r.nodeName.toLowerCase() === n && i++;
                } while (r);
                t.unshift(n += ":nth-of-type(" + i + ")"), o = o.parentNode;
              }
              return t.join(" > ");
            }, t.resolveElement = function (e, t) {
              var o = e;
              if ((0, r.isString)(e)) try {
                o = t.querySelector(e);
              } catch (t) {
                throw (0, i.error)('String "' + e + '" should be valid HTML selector');
              }
              if (!o || "object" != typeof o || !a.Dom.isElement(o) || !o.cloneNode) throw (0, i.error)('Element "' + e + '" should be string or HTMLElement instance');
              return o;
            };
          },
          21518: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.set = void 0;
            var n = o(24421),
              r = o(57649),
              i = o(49781),
              a = o(79736);
            t.set = function (e, t, o) {
              if ((0, n.isString)(e) && e.length) {
                for (var s = e.split("."), l = o, c = s[0], u = 0; s.length - 1 > u; u += 1) (0, i.isArray)(l[c = s[u]]) || (0, a.isPlainObject)(l[c]) || (l[c] = (0, r.isNumeric)(s[u + 1]) ? [] : {}), l = l[c];
                l && (l[s[s.length - 1]] = t);
              }
            };
          },
          37228: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.LimitedStack = void 0;
            var o = function () {
              function e(e) {
                this.limit = e, this.stack = [];
              }
              return e.prototype.push = function (e) {
                return this.stack.push(e), this.stack.length > this.limit && this.stack.shift(), this;
              }, e.prototype.pop = function () {
                return this.stack.pop();
              }, e.prototype.find = function (e) {
                return this.stack.find(e);
              }, e;
            }();
            t.LimitedStack = o;
          },
          67309: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getDataTransfer = t.memorizeExec = t.keys = t.loadImage = t.callPromise = t.markOwner = t.attr = t.call = void 0;
            var n = o(20255),
              r = o(42096),
              i = o(26335),
              a = o(24021),
              s = o(79736),
              l = o(24421),
              c = o(63122),
              u = o(26911),
              d = o(11278);
            function p(e, t, o) {
              if (!e || !(0, r.isFunction)(e.getAttribute)) return null;
              if (!(0, l.isString)(t)) return Object.keys(t).forEach(function (o) {
                var n = t[o];
                (0, s.isPlainObject)(n) && "style" === o ? (0, u.css)(e, n) : ("className" === o && (o = "class"), p(e, o, n));
              }), null;
              var n = (0, d.CamelCaseToKebabCase)(t);
              if (/^-/.test(n)) {
                var i = p(e, "data".concat(n));
                if (i) return i;
                n = n.substr(1);
              }
              if (void 0 !== o) {
                if (null != o) return e.setAttribute(n, o.toString()), o.toString();
                e.hasAttribute(n) && e.removeAttribute(n);
              }
              return e.getAttribute(n);
            }
            t.call = function (e) {
              for (var t = [], o = 1; arguments.length > o; o++) t[o - 1] = arguments[o];
              return e.apply(void 0, n.__spreadArray([], n.__read(t), !1));
            }, t.attr = p, t.markOwner = function (e, t) {
              p(t, "data-editor_id", e.id), !t.component && Object.defineProperty(t, "jodit", {
                value: e
              });
            }, t.callPromise = function (e, t) {
              return (0, i.isPromise)(e) ? e.finally(t) : t();
            }, t.loadImage = function (e, t) {
              return t.async.promise(function (o, n) {
                var r = new Image(),
                  i = function () {
                    t.e.off(r), null == n || n();
                  },
                  a = function () {
                    t.e.off(r), o(r);
                  };
                t.e.one(r, "load", a).one(r, "error", i).one(r, "abort", i), r.src = e, r.complete && a();
              });
            }, t.keys = function (e, t) {
              if (void 0 === t && (t = !0), t) return Object.keys(e);
              var o = [];
              for (var n in e) o.push(n);
              return o;
            }, t.memorizeExec = function (e, t, o, n) {
              var r,
                i = o.control,
                s = "button".concat(i.command),
                l = null !== (r = i.args && i.args[0]) && void 0 !== r ? r : (0, c.dataBind)(e, s);
              if ((0, a.isVoid)(l)) return !1;
              (0, c.dataBind)(e, s, l), n && (l = n(l)), e.execCommand(i.command, !1, null != l ? l : void 0);
            }, t.getDataTransfer = function (e) {
              if (e.clipboardData) return e.clipboardData;
              try {
                return e.dataTransfer || new DataTransfer();
              } catch (e) {
                return null;
              }
            };
          },
          22362: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.val = void 0, t.val = function (e, t, o) {
              var n = e.querySelector(t);
              return n ? (o && (n.value = o), n.value) : "";
            };
          },
          33286: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.init = t.initInstance = void 0;
            var n = o(10172),
              r = o(90338);
            function i(e, t, o, i, a) {
              var s = o.requires;
              if ((null == s ? void 0 : s.length) && !s.every(function (e) {
                return i.has(e);
              })) return a[t] = o, !1;
              if ((0, n.isInitable)(o)) try {
                o.init(e);
              } catch (e) {}
              return i.add(t), delete a[t], o.hasStyle && (0, r.loadStyle)(e, t).catch(function (e) {}), !0;
            }
            t.initInstance = function (e, t, o, n, r) {
              i(e, t, o, n, r) && Object.keys(r).forEach(function (t) {
                i(e, t, r[t], n, r);
              });
            }, t.init = i;
          },
          90338: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.loadExtras = t.loadStyle = void 0;
            var n = o(20255),
              r = o(62462),
              i = o(11278),
              a = o(93498),
              s = new Set();
            function l(e, t, o) {
              return t = (0, i.kebabCase)(t), e.basePath + "plugins/" + t + "/" + t + "." + (o ? "js" : "css");
            }
            t.loadStyle = function (e, t) {
              return n.__awaiter(this, void 0, Promise, function () {
                var o;
                return n.__generator(this, function (n) {
                  return o = l(e, t, !1), s.has(o) ? [2] : (s.add(o), [2, (0, r.appendStyleAsync)(e, o)]);
                });
              });
            }, t.loadExtras = function (e, t, o, n) {
              try {
                var i = o.filter(function (t) {
                  return !e.has((0, a.normalizeName)(t.name));
                });
                i.length && function (e, t, o) {
                  t.map(function (t) {
                    var n = t.url || l(e, t.name, !0);
                    return (0, r.appendScriptAsync)(e, n).then(o).catch(function () {
                      return null;
                    });
                  });
                }(t, i, n);
              } catch (e) {}
            };
          },
          24342: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.makeInstance = void 0;
            var n = o(10172);
            t.makeInstance = function (e, t) {
              try {
                try {
                  return (0, n.isFunction)(t) ? new t(e) : t;
                } catch (o) {
                  if ((0, n.isFunction)(t) && !t.prototype) return t(e);
                }
              } catch (e) {}
              return null;
            };
          },
          93498: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.normalizeName = void 0;
            var n = o(11278);
            t.normalizeName = function (e) {
              return (0, n.kebabCase)(e).toLowerCase();
            };
          },
          57549: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(44540), t), n.__exportStar(o(85605), t);
          },
          13573: function () {},
          44540: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.PluginSystem = void 0;
            var n = o(20255);
            o(13573);
            var r = o(10172),
              i = o(12557),
              a = o(17332),
              s = o(90338),
              l = o(93498),
              c = o(24342),
              u = o(33286),
              d = function () {
                function e() {
                  this.__items = new Map();
                }
                return e.prototype.add = function (e, t) {
                  this.__items.set((0, l.normalizeName)(e), t), a.eventEmitter.fire("plugin:".concat(e, ":ready"));
                }, e.prototype.get = function (e) {
                  return this.__items.get((0, l.normalizeName)(e));
                }, e.prototype.remove = function (e) {
                  this.__items.delete((0, l.normalizeName)(e));
                }, e.prototype.__filter = function (e) {
                  var t = [];
                  return this.__items.forEach(function (o, n) {
                    e && !e.has(n) || t.push([n, o]);
                  }), t;
                }, e.prototype.__init = function (e) {
                  var t = this,
                    o = function (e) {
                      return {
                        extrasList: e.o.extraPlugins.map(function (e) {
                          return (0, r.isString)(e) ? {
                            name: e
                          } : e;
                        }),
                        disableList: new Set((0, i.splitArray)(e.o.disablePlugins).map(l.normalizeName)),
                        filter: e.o.safeMode ? new Set(e.o.safePluginsList) : null
                      };
                    }(e),
                    a = o.extrasList,
                    d = o.disableList,
                    p = o.filter,
                    f = new Set(),
                    h = {},
                    m = {};
                  e.__plugins = m;
                  var v = function () {
                    if (!e.isInDestruct) {
                      var o = !1;
                      t.__filter(p).forEach(function (t) {
                        var i = n.__read(t, 2),
                          a = i[0],
                          s = i[1];
                        if (!(d.has(a) || f.has(a) || h[a])) {
                          var l = null == s ? void 0 : s.requires;
                          if (!(l && (0, r.isArray)(l) && Boolean(l.some(function (e) {
                            return d.has(e);
                          })))) {
                            o = !0;
                            var p = (0, c.makeInstance)(e, s);
                            if (!p) return f.add(a), void delete h[a];
                            (0, u.initInstance)(e, a, p, f, h), m[a] = p;
                          }
                        }
                      }), o && e.e.fire("updatePlugins");
                    }
                  };
                  a && a.length || (0, s.loadExtras)(this.__items, e, a, v), v(), function (e, t) {
                    e.e.on("beforeDestruct", function () {
                      Object.keys(t).forEach(function (o) {
                        var n = t[o];
                        (0, r.isDestructable)(n) && n.destruct(e), delete t[o];
                      }), delete e.__plugins;
                    });
                  }(e, m);
                }, e.prototype.wait = function (e) {
                  var t = this;
                  return new Promise(function (o) {
                    if (t.get(e)) return o();
                    var n = function () {
                      o(), a.eventEmitter.off("plugin:".concat(e, ":ready"), n);
                    };
                    a.eventEmitter.on("plugin:".concat(e, ":ready"), n);
                  });
                }, e;
              }();
            t.PluginSystem = d;
          },
          85605: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Plugin = void 0;
            var n = o(20255),
              r = o(56562),
              i = o(43441),
              a = o(40332),
              s = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  return o.requires = [], o.buttons = [], o.hasStyle = !1, t.e.on("afterPluginSystemInit", function () {
                    var e;
                    (0, a.isJoditObject)(t) && (null === (e = o.buttons) || void 0 === e || e.forEach(function (e) {
                      t.registerButton(e);
                    }));
                  }).on("afterInit", function () {
                    o.setStatus(r.STATUSES.ready), o.afterInit(t);
                  }).on("beforeDestruct", o.destruct), o;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "";
                }, t.prototype.init = function (e) {}, t.prototype.destruct = function () {
                  var t, o, n;
                  if (this.isReady) {
                    this.setStatus(r.STATUSES.beforeDestruct);
                    var i = this.j;
                    (0, a.isJoditObject)(i) && (null === (t = this.buttons) || void 0 === t || t.forEach(function (e) {
                      null == i || i.unregisterButton(e);
                    })), null === (n = null === (o = this.j) || void 0 === o ? void 0 : o.events) || void 0 === n || n.off("beforeDestruct", this.destruct), this.beforeDestruct(this.j), e.prototype.destruct.call(this);
                  }
                }, n.__decorate([i.autobind], t.prototype, "destruct", null), t;
              }(r.ViewComponent);
            t.Plugin = s;
          },
          9917: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Ajax = void 0;
            var n = o(20255),
              r = o(93166),
              i = o(40332),
              a = o(56964),
              s = o(86101),
              l = o(22630),
              c = o(43441);
            o(12144);
            var u = function () {
              function e(e, t) {
                void 0 === t && (t = r.Config.prototype.defaultAjaxOptions), this.__async = new l.Async(), this.__isFulfilled = !1, this.__activated = !1, this.__isDestructed = !1, this.options = (0, i.ConfigProto)(e || {}, t), this.xhr = this.o.xhr ? this.o.xhr() : new XMLHttpRequest();
              }
              return e.prototype.__buildParams = function (e, t) {
                return (0, i.isPlainObject)(e) && this.options.contentType && this.options.contentType.includes("application/json") ? JSON.stringify(e) : (0, i.isFunction)(this.o.queryBuild) ? this.o.queryBuild.call(this, e, t) : (0, i.isString)(e) || e instanceof window.FormData || "object" == typeof e && null != e && (0, i.isFunction)(e.append) ? e : (0, i.buildQuery)(e);
              }, Object.defineProperty(e.prototype, "o", {
                get: function () {
                  return this.options;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.abort = function () {
                if (this.__isFulfilled) return this;
                try {
                  this.__isFulfilled = !0, this.xhr.abort();
                } catch (e) {}
                return this;
              }, e.prototype.send = function () {
                var e = this;
                this.__activated = !0;
                var t = this.xhr,
                  o = this.o,
                  r = this.prepareRequest();
                return this.__async.promise(function (l, c) {
                  return n.__awaiter(e, void 0, void 0, function () {
                    var e,
                      u,
                      d,
                      p,
                      f,
                      h = this;
                    return n.__generator(this, function (n) {
                      switch (n.label) {
                        case 0:
                          return e = function () {
                            h.__isFulfilled = !0, c(a.connection("Connection error"));
                          }, t.onload = u = function () {
                            h.__isFulfilled = !0, l(new s.Response(r, t.status, t.statusText, t.responseType ? t.response : t.responseText));
                          }, t.onabort = function () {
                            h.__isFulfilled = !0, c(a.abort("Abort connection"));
                          }, t.onerror = e, t.ontimeout = e, o.responseType && (t.responseType = o.responseType), t.onprogress = function (e) {
                            var t,
                              o,
                              n = 0;
                            e.lengthComputable && (n = e.loaded / e.total * 100), null === (o = (t = h.options).onProgress) || void 0 === o || o.call(t, n);
                          }, t.onreadystatechange = function () {
                            var e, n;
                            null === (n = (e = h.options).onProgress) || void 0 === n || n.call(e, 10), t.readyState === XMLHttpRequest.DONE && (o.successStatuses.includes(t.status) ? u() : t.statusText && (h.__isFulfilled = !0, c(a.connection(t.statusText))));
                          }, t.withCredentials = null !== (f = o.withCredentials) && void 0 !== f && f, d = r.data, t.open(r.method, r.url, !0), o.contentType && t.setRequestHeader && t.setRequestHeader("Content-type", o.contentType), (0, i.isFunction)(p = o.headers) ? [4, p.call(this)] : [3, 2];
                        case 1:
                          p = n.sent(), n.label = 2;
                        case 2:
                          return p && t.setRequestHeader && Object.keys(p).forEach(function (e) {
                            t.setRequestHeader(e, p[e]);
                          }), this.__async.setTimeout(function () {
                            t.send(d ? h.__buildParams(d) : void 0);
                          }, 0), [2];
                      }
                    });
                  });
                });
              }, e.prototype.prepareRequest = function () {
                if (!this.o.url) throw a.error("Need URL for AJAX request");
                var t = this.o.url,
                  o = this.o.data,
                  r = (this.o.method || "get").toLowerCase();
                if ("get" === r && o && (0, i.isPlainObject)(o)) {
                  var s = t.indexOf("?");
                  if (-1 !== s) {
                    var l = (0, i.parseQuery)(t);
                    t = t.substring(0, s) + "?" + (0, i.buildQuery)(n.__assign(n.__assign({}, l), o));
                  } else t += "?" + (0, i.buildQuery)(this.o.data);
                }
                var c = {
                  url: t,
                  method: r,
                  data: o
                };
                return e.log.splice(100), e.log.push(c), c;
              }, e.prototype.destruct = function () {
                this.__isDestructed || (this.__isDestructed = !0, this.__activated && !this.__isFulfilled && (this.abort(), this.__isFulfilled = !0), this.__async.destruct());
              }, e.log = [], n.__decorate([c.autobind], e.prototype, "destruct", null), e;
            }();
            t.Ajax = u;
          },
          12144: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.defaultAjaxOptions = {
              successStatuses: [200, 201, 202],
              method: "GET",
              url: "",
              data: null,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",
              headers: {
                "X-REQUESTED-WITH": "XMLHttpRequest"
              },
              withCredentials: !1,
              xhr: function () {
                return new XMLHttpRequest();
              }
            };
          },
          30056: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(9917), t), n.__exportStar(o(86101), t);
          },
          86101: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Response = void 0;
            var n = o(20255),
              r = function () {
                function e(e, t, o, n) {
                  this.request = e, this.status = t, this.statusText = o, this.body = n;
                }
                return Object.defineProperty(e.prototype, "url", {
                  get: function () {
                    return this.request.url;
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.json = function () {
                  return n.__awaiter(this, void 0, Promise, function () {
                    return n.__generator(this, function (e) {
                      return [2, JSON.parse(this.body)];
                    });
                  });
                }, e.prototype.text = function () {
                  return Promise.resolve(this.body);
                }, e.prototype.blob = function () {
                  return n.__awaiter(this, void 0, Promise, function () {
                    return n.__generator(this, function (e) {
                      return [2, this.body];
                    });
                  });
                }, e;
              }();
            t.Response = r;
          },
          10109: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(287), t), n.__exportStar(o(10264), t);
          },
          287: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.moveNodeInsideStart = void 0;
            var n = o(64968),
              r = o(86893);
            t.moveNodeInsideStart = function (e, t, o) {
              for (var i = n.Dom.findSibling(t, o), a = n.Dom.findSibling(t, !o); n.Dom.isElement(i) && !n.Dom.isTag(i, r.INSEPARABLE_TAGS) && n.Dom.isContentEditable(i, e.editor) && (!a || !n.Dom.closest(t, n.Dom.isElement, e.editor));) o || !i.firstChild ? i.appendChild(t) : n.Dom.before(i.firstChild, t), i = n.Dom.sibling(t, o), a = n.Dom.sibling(t, !o);
            };
          },
          10264: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.moveTheNodeAlongTheEdgeOutward = void 0;
            var n = o(64968);
            t.moveTheNodeAlongTheEdgeOutward = function (e, t, o) {
              for (var r = e; r && r !== o;) {
                if (n.Dom.findSibling(r, t)) return;
                (r = r.parentElement) && r !== o && (t ? n.Dom.before(r, e) : n.Dom.after(r, e));
              }
            };
          },
          2123: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(70851), t), n.__exportStar(o(77627), t);
          },
          2047: function () {},
          77627: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Select = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(86893),
              a = o(64968),
              s = o(40332),
              l = o(70851),
              c = o(43441),
              u = o(10109),
              d = (o(52378), o(10172));
            o(2047);
            var p = function () {
              function e(e) {
                var t = this;
                this.jodit = e, e.e.on("removeMarkers", function () {
                  t.removeMarkers();
                });
              }
              return Object.defineProperty(e.prototype, "j", {
                get: function () {
                  return this.jodit;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.errorNode = function (e) {
                if (!a.Dom.isNode(e)) throw (0, s.error)("Parameter node must be instance of Node");
              }, Object.defineProperty(e.prototype, "area", {
                get: function () {
                  return this.j.editor;
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "win", {
                get: function () {
                  return this.j.ew;
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "doc", {
                get: function () {
                  return this.j.ed;
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "sel", {
                get: function () {
                  return this.j.o.shadowRoot && (0, d.isFunction)(this.j.o.shadowRoot.getSelection) ? this.j.o.shadowRoot.getSelection() : this.win.getSelection();
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "range", {
                get: function () {
                  var e = this.sel;
                  return e && e.rangeCount ? e.getRangeAt(0) : this.createRange();
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "isInsideArea", {
                get: function () {
                  var e = this.sel,
                    t = (null == e ? void 0 : e.rangeCount) ? e.getRangeAt(0) : null;
                  return !(!t || !a.Dom.isOrContains(this.area, t.startContainer));
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.createRange = function (e) {
                void 0 === e && (e = !1);
                var t = this.doc.createRange();
                return e && this.selectRange(t), t;
              }, e.prototype.remove = function () {
                var e = this.sel,
                  t = this.current();
                if (e && t) for (var o = 0; e.rangeCount > o; o += 1) e.getRangeAt(o).deleteContents(), e.getRangeAt(o).collapse(!0);
              }, e.prototype.clear = function () {
                var e, t;
                (null === (e = this.sel) || void 0 === e ? void 0 : e.rangeCount) && (null === (t = this.sel) || void 0 === t || t.removeAllRanges());
              }, e.prototype.removeNode = function (e) {
                if (!a.Dom.isOrContains(this.j.editor, e, !0)) throw (0, s.error)("Selection.removeNode can remove only editor's children");
                a.Dom.safeRemove(e), this.j.e.fire("afterRemoveNode", e);
              }, e.prototype.insertCursorAtPoint = function (e, t) {
                var o = this;
                this.removeMarkers();
                try {
                  var n = this.createRange();
                  return function () {
                    if (o.doc.caretPositionFromPoint && (r = o.doc.caretPositionFromPoint(e, t))) n.setStart(r.offsetNode, r.offset);else if (o.doc.caretRangeFromPoint) {
                      var r = o.doc.caretRangeFromPoint(e, t);
                      n.setStart(r.startContainer, r.startOffset);
                    }
                  }(), n.collapse(!0), this.selectRange(n), !0;
                } catch (e) {}
                return !1;
              }, Object.defineProperty(e.prototype, "hasMarkers", {
                get: function () {
                  return Boolean(this.markers.length);
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "markers", {
                get: function () {
                  return (0, s.$$)("span[data-" + r.MARKER_CLASS + "]", this.area);
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.removeMarkers = function () {
                a.Dom.safeRemove.apply(null, this.markers);
              }, e.prototype.marker = function (e, t) {
                void 0 === e && (e = !1);
                var o = null;
                t && (o = t.cloneRange()).collapse(e);
                var n = this.j.createInside.span();
                return n.id = r.MARKER_CLASS + "_" + Number(new Date()) + "_" + String(Math.random()).slice(2), n.style.lineHeight = "0", n.style.display = "none", a.Dom.markTemporary(n), (0, s.attr)(n, "data-" + r.MARKER_CLASS, e ? "start" : "end"), n.appendChild(this.j.createInside.text(r.INVISIBLE_SPACE)), o && a.Dom.isOrContains(this.area, e ? o.startContainer : o.endContainer) && o.insertNode(n), n;
              }, e.prototype.restore = function () {
                var e = !1,
                  t = function (e) {
                    return "span[data-".concat(r.MARKER_CLASS, "=").concat(e ? "start" : "end", "]");
                  },
                  o = this.area.querySelector(t(!0)),
                  n = this.area.querySelector(t(!1));
                if (o) {
                  if (e = this.createRange(), n) e.setStartAfter(o), a.Dom.safeRemove(o), e.setEndBefore(n), a.Dom.safeRemove(n);else {
                    var i = o.previousSibling;
                    a.Dom.isText(i) ? e.setStart(i, i.nodeValue ? i.nodeValue.length : 0) : e.setStartBefore(o), a.Dom.safeRemove(o), e.collapse(!0);
                  }
                  e && this.selectRange(e);
                }
              }, e.prototype.save = function (e) {
                if (void 0 === e && (e = !1), this.hasMarkers) return [];
                var t = this.sel;
                if (!t || !t.rangeCount) return [];
                for (var o = [], n = t.rangeCount, r = [], i = 0; n > i; i += 1) if (r[i] = t.getRangeAt(i), r[i].collapsed) {
                  var a = this.marker(!0, r[i]);
                  o[i] = {
                    startId: a.id,
                    collapsed: !0,
                    startMarker: a.outerHTML
                  };
                } else {
                  a = this.marker(!0, r[i]);
                  var s = this.marker(!1, r[i]);
                  o[i] = {
                    startId: a.id,
                    endId: s.id,
                    collapsed: !1,
                    startMarker: a.outerHTML,
                    endMarker: s.outerHTML
                  };
                }
                if (!e) for (t.removeAllRanges(), i = n - 1; i >= 0; --i) {
                  var l = this.doc.getElementById(o[i].startId);
                  if (l) if (o[i].collapsed) r[i].setStartAfter(l), r[i].collapse(!0);else if (r[i].setStartBefore(l), o[i].endId) {
                    var c = this.doc.getElementById(o[i].endId);
                    c && r[i].setEndAfter(c);
                  }
                  try {
                    t.addRange(r[i].cloneRange());
                  } catch (e) {}
                }
                return o;
              }, e.prototype.focus = function (e) {
                var t, o;
                if (void 0 === e && (e = {
                  preventScroll: !0
                }), !this.isFocused()) {
                  var n = (0, s.getScrollParent)(this.j.container),
                    r = null == n ? void 0 : n.scrollTop;
                  this.j.iframe && "complete" === this.doc.readyState && this.j.iframe.focus(e), this.win.focus(), this.area.focus(e), r && (null == n ? void 0 : n.scrollTo) && n.scrollTo(0, r);
                  var i = this.sel,
                    l = (null == i ? void 0 : i.rangeCount) ? null == i ? void 0 : i.getRangeAt(0) : null;
                  if (!l || !a.Dom.isOrContains(this.area, l.startContainer)) {
                    var c = this.createRange();
                    c.setStart(this.area, 0), c.collapse(!0), this.selectRange(c, !1);
                  }
                  return this.j.editorIsActive || null === (o = null === (t = this.j) || void 0 === t ? void 0 : t.events) || void 0 === o || o.fire("focus"), !0;
                }
                return !1;
              }, e.prototype.isCollapsed = function () {
                for (var e = this.sel, t = 0; e && e.rangeCount > t; t += 1) if (!e.getRangeAt(t).collapsed) return !1;
                return !0;
              }, e.prototype.isFocused = function () {
                return this.doc.hasFocus && this.doc.hasFocus() && this.area === this.doc.activeElement;
              }, e.prototype.current = function (e) {
                if (void 0 === e && (e = !0), this.j.getRealMode() === r.MODE_WYSIWYG) {
                  var t = this.sel;
                  if (!t || 0 === t.rangeCount) return null;
                  var o = t.getRangeAt(0),
                    n = o.startContainer,
                    i = !1,
                    s = function (e) {
                      return i ? e.lastChild : e.firstChild;
                    };
                  if (a.Dom.isTag(n, "br") && t.isCollapsed) return n;
                  if (!a.Dom.isText(n)) {
                    if ((n = o.startContainer.childNodes[o.startOffset]) || (n = o.startContainer.childNodes[o.startOffset - 1], i = !0), n && t.isCollapsed && !a.Dom.isText(n)) if (!i && a.Dom.isText(n.previousSibling)) n = n.previousSibling;else if (e) for (var l = s(n); l;) {
                      if (l && a.Dom.isText(l)) {
                        n = l;
                        break;
                      }
                      l = s(l);
                    }
                    if (n && !t.isCollapsed && !a.Dom.isText(n)) {
                      var c = n,
                        u = n;
                      do {
                        c = c.firstChild, u = u.lastChild;
                      } while (c && u && !a.Dom.isText(c));
                      c === u && c && a.Dom.isText(c) && (n = c);
                    }
                  }
                  if (n && a.Dom.isOrContains(this.area, n)) return n;
                }
                return null;
              }, e.prototype.insertNode = function (e, t, o) {
                var n = this;
                void 0 === t && (t = !0), void 0 === o && (o = !0), this.errorNode(e), this.j.e.fire("safeHTML", e), !this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore());
                var r = this.sel;
                this.j.history.snapshot.transaction(function () {
                  var o;
                  if (n.isCollapsed() || n.j.execCommand("Delete"), n.j.e.fire("beforeInsertNode", e), r && r.rangeCount) {
                    var s = r.getRangeAt(0);
                    a.Dom.isOrContains(n.area, s.commonAncestorContainer) ? a.Dom.isTag(s.startContainer, i.INSEPARABLE_TAGS) && s.collapsed ? null === (o = s.startContainer.parentNode) || void 0 === o || o.insertBefore(e, s.startContainer) : a.Dom.safeInsertNode(s, e) : n.area.appendChild(e);
                  } else n.area.appendChild(e);
                  t && (e.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? e.lastChild && n.setCursorAfter(e.lastChild) : n.setCursorAfter(e));
                }), o && this.j.events && this.j.__imdSynchronizeValues(), this.j.events && this.j.e.fire("afterInsertNode", e);
              }, e.prototype.insertHTML = function (e, t) {
                if (void 0 === t && (t = !0), "" !== e) {
                  var o,
                    n = this.j.createInside.div(),
                    r = this.j.createInside.fragment();
                  if (!this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore()), a.Dom.isNode(e) ? n.appendChild(e) : n.innerHTML = e.toString(), (this.j.isEditorMode() || !1 !== this.j.e.fire("insertHTML", n.innerHTML)) && (o = n.lastChild)) {
                    for (; n.firstChild;) o = n.firstChild, r.appendChild(n.firstChild);
                    this.insertNode(r.firstChild && r.firstChild === r.lastChild ? r.lastChild : r, !1, !1), t && (o ? this.setCursorAfter(o) : this.setCursorIn(r)), this.j.__imdSynchronizeValues();
                  }
                }
              }, e.prototype.insertImage = function (e, t, o) {
                void 0 === t && (t = null), void 0 === o && (o = null);
                var n = (0, d.isString)(e) ? this.j.createInside.element("img") : e;
                if ((0, d.isString)(e) && n.setAttribute("src", e), null != o) {
                  var r = o.toString();
                  r && "auto" !== r && 0 > String(r).indexOf("px") && 0 > String(r).indexOf("%") && (r += "px"), (0, s.call)(this.j.o.resizer.forImageChangeAttributes ? s.attr : s.css, n, "width", r);
                }
                t && "object" == typeof t && (0, s.css)(n, t);
                var i = function () {
                  (n.offsetHeight > n.naturalHeight || n.offsetWidth > n.naturalWidth) && (n.style.width = "", n.style.height = ""), n.removeEventListener("load", i);
                };
                this.j.e.on(n, "load", i), n.complete && i(), this.insertNode(n), this.j.e.fire("afterInsertImage", n);
              }, e.prototype.eachSelection = function (e) {
                var t,
                  o = this,
                  n = this.sel;
                if (n && n.rangeCount) {
                  var r = n.getRangeAt(0),
                    l = r.commonAncestorContainer;
                  a.Dom.isHTMLElement(l) || (l = l.parentElement);
                  var c = [],
                    u = r.startOffset,
                    p = l.childNodes.length,
                    f = r.startContainer === this.area ? l.childNodes[p > u ? u : p - 1] : r.startContainer,
                    h = r.endContainer === this.area ? l.childNodes[r.endOffset - 1] : r.endContainer;
                  a.Dom.isText(f) && f === r.startContainer && r.startOffset === (null === (t = f.nodeValue) || void 0 === t ? void 0 : t.length) && f.nextSibling && (f = f.nextSibling), a.Dom.isText(h) && h === r.endContainer && 0 === r.endOffset && h.previousSibling && (h = h.previousSibling);
                  var m = function (e) {
                    !e || e === l || a.Dom.isEmptyTextNode(e) || (0, d.isMarker)(e) || c.push(e);
                  };
                  m(f), f !== h && a.Dom.isOrContains(l, f, !0) && a.Dom.find(f, function (e) {
                    return m(e), e === h || e && e.contains && e.contains(h);
                  }, l, !0, !1);
                  var v = function (t) {
                    if (a.Dom.isOrContains(o.j.editor, t, !0)) {
                      if (t.nodeName.match(/^(UL|OL)$/)) return (0, s.toArray)(t.childNodes).forEach(v);
                      if (a.Dom.isTag(t, "li")) if (t.firstChild) t = t.firstChild;else {
                        var n = o.j.createInside.text(i.INVISIBLE_SPACE);
                        t.appendChild(n), t = n;
                      }
                      e(t);
                    }
                  };
                  0 === c.length && a.Dom.isEmptyTextNode(f) && c.push(f), 0 === c.length && f.firstChild && c.push(f.firstChild), c.forEach(v);
                }
              }, e.prototype.cursorInTheEdge = function (e, t, o) {
                var n,
                  r,
                  l = this;
                void 0 === o && (o = null);
                var c = !e,
                  u = null === (n = this.sel) || void 0 === n ? void 0 : n.getRangeAt(0);
                if (null != o || (o = this.current(!1)), !u || !o || !a.Dom.isOrContains(t, o, !0)) return null;
                var d = e ? u.startContainer : u.endContainer,
                  p = e ? u.startOffset : u.endOffset,
                  f = function (e) {
                    return Boolean(e && !a.Dom.isTag(e, "br") && !a.Dom.isEmptyTextNode(e) && !a.Dom.isTemporary(e) && !(a.Dom.isElement(e) && !0 === l.j.e.fire("isInvisibleForCursor", e)));
                  };
                if (a.Dom.isText(d)) {
                  var h = (null === (r = d.nodeValue) || void 0 === r ? void 0 : r.length) ? d.nodeValue : "";
                  if (c && h.replace((0, i.INVISIBLE_SPACE_REG_EXP_END)(), "").length > p) return !1;
                  var m = (0, i.INVISIBLE_SPACE_REG_EXP_START)().exec(h);
                  if (e && (m && p > m[0].length || !m && p > 0)) return !1;
                } else {
                  var v = (0, s.toArray)(d.childNodes);
                  if (c) {
                    if (v.slice(p).some(f)) return !1;
                  } else if (v.slice(0, p).some(f)) return !1;
                }
                for (var g = o; g && g !== t;) {
                  var y = a.Dom.sibling(g, e);
                  if (y) {
                    if ((g = y) && f(g)) return !1;
                  } else g = g.parentNode;
                }
                return !0;
              }, e.prototype.cursorOnTheLeft = function (e, t) {
                return this.cursorInTheEdge(!0, e, t);
              }, e.prototype.cursorOnTheRight = function (e, t) {
                return this.cursorInTheEdge(!1, e, t);
              }, e.prototype.setCursorAfter = function (e) {
                return this.setCursorNearWith(e, !1);
              }, e.prototype.setCursorBefore = function (e) {
                return this.setCursorNearWith(e, !0);
              }, e.prototype.setCursorNearWith = function (e, t) {
                var o,
                  n,
                  i = this;
                if (this.errorNode(e), !a.Dom.up(e, function (e) {
                  return e === i.area || e && e.parentNode === i.area;
                }, this.area)) throw (0, s.error)("Node element must be in editor");
                var l = this.createRange(),
                  c = null;
                return a.Dom.isText(e) ? t ? l.setStart(e, 0) : l.setEnd(e, null !== (n = null === (o = e.nodeValue) || void 0 === o ? void 0 : o.length) && void 0 !== n ? n : 0) : (c = this.j.createInside.text(r.INVISIBLE_SPACE), t ? l.setStartBefore(e) : l.setEndAfter(e), l.collapse(t), a.Dom.safeInsertNode(l, c), l.selectNode(c)), l.collapse(t), this.selectRange(l), c;
              }, e.prototype.setCursorIn = function (e, t) {
                var o = this;
                if (void 0 === t && (t = !1), this.errorNode(e), !a.Dom.up(e, function (e) {
                  return e === o.area || e && e.parentNode === o.area;
                }, this.area)) throw (0, s.error)("Node element must be in editor");
                var n = this.createRange(),
                  i = e,
                  l = e;
                do {
                  if (a.Dom.isText(i)) break;
                  l = i, i = t ? i.firstChild : i.lastChild;
                } while (i);
                if (!i) {
                  var c = this.j.createInside.text(r.INVISIBLE_SPACE);
                  /^(img|br|input)$/i.test(l.nodeName) ? i = l : (l.appendChild(c), l = c);
                }
                return n.selectNodeContents(i || l), n.collapse(t), this.selectRange(n), l;
              }, e.prototype.selectRange = function (e, t) {
                void 0 === t && (t = !0);
                var o = this.sel;
                return t && !this.isFocused() && this.focus(), o && (o.removeAllRanges(), o.addRange(e)), this.j.e.fire("changeSelection"), this;
              }, e.prototype.select = function (e, t) {
                var o = this;
                if (void 0 === t && (t = !1), this.errorNode(e), !a.Dom.up(e, function (e) {
                  return e === o.area || e && e.parentNode === o.area;
                }, this.area)) throw (0, s.error)("Node element must be in editor");
                var n = this.createRange();
                return n[t ? "selectNodeContents" : "selectNode"](e), this.selectRange(n);
              }, Object.defineProperty(e.prototype, "html", {
                get: function () {
                  var e = this.sel;
                  if (e && e.rangeCount > 0) {
                    var t = e.getRangeAt(0).cloneContents(),
                      o = this.j.createInside.div();
                    return o.appendChild(t), o.innerHTML;
                  }
                  return "";
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.wrapInTagGen = function () {
                var e, t, o, r, l, c, u, p, f, h, m;
                return n.__generator(this, function (v) {
                  switch (v.label) {
                    case 0:
                      return this.isCollapsed() ? (c = this.jodit.createInside.element("font", i.INVISIBLE_SPACE), this.insertNode(c, !1, !1), e = n.__read(this.markers, 1), (t = e[0]) ? c.appendChild(t) : (this.setCursorIn(c), this.save()), [4, c]) : [3, 2];
                    case 1:
                      return v.sent(), a.Dom.unwrap(c), [2];
                    case 2:
                      (0, s.$$)("*[style*=font-size]", this.area).forEach(function (e) {
                        (0, s.attr)(e, "data-font-size", e.style.fontSize.toString()), e.style.removeProperty("font-size");
                      }), this.isCollapsed() ? (c = this.j.createInside.element("font"), (0, s.attr)(c, "size", 7), this.insertNode(c, !1, !1)) : this.j.nativeExecCommand("fontsize", !1, "7"), (0, s.$$)("*[data-font-size]", this.area).forEach(function (e) {
                        var t = (0, s.attr)(e, "data-font-size");
                        t && (e.style.fontSize = t, (0, s.attr)(e, "data-font-size", null));
                      }), o = (0, s.$$)('font[size="7"]', this.area), v.label = 3;
                    case 3:
                      v.trys.push([3, 8, 9, 10]), r = n.__values(o), l = r.next(), v.label = 4;
                    case 4:
                      return l.done ? [3, 7] : (p = (c = l.value).lastChild, (u = c.firstChild) && u === p && (0, d.isMarker)(u) ? (a.Dom.unwrap(c), [3, 6]) : (u && (0, d.isMarker)(u) && a.Dom.before(c, u), p && (0, d.isMarker)(p) && a.Dom.after(c, p), [4, c]));
                    case 5:
                      v.sent(), a.Dom.unwrap(c), v.label = 6;
                    case 6:
                      return l = r.next(), [3, 4];
                    case 7:
                      return [3, 10];
                    case 8:
                      return f = v.sent(), h = {
                        error: f
                      }, [3, 10];
                    case 9:
                      try {
                        l && !l.done && (m = r.return) && m.call(r);
                      } finally {
                        if (h) throw h.error;
                      }
                      return [7];
                    case 10:
                      return [2];
                  }
                });
              }, e.prototype.wrapInTag = function (e) {
                var t,
                  o,
                  r = [];
                try {
                  for (var i = n.__values(this.wrapInTagGen()), s = i.next(); !s.done; s = i.next()) {
                    var l = s.value;
                    try {
                      if (l.firstChild && l.firstChild === l.lastChild && (0, d.isMarker)(l.firstChild)) continue;
                      (0, d.isFunction)(e) ? e(l) : r.push(a.Dom.replace(l, e, this.j.createInside));
                    } finally {
                      var c = l.parentNode;
                      c && (a.Dom.unwrap(l), a.Dom.isEmpty(c) && a.Dom.unwrap(c));
                    }
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    s && !s.done && (o = i.return) && o.call(i);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                return r;
              }, e.prototype.commitStyle = function (e) {
                new l.CommitStyle(e).apply(this.j);
              }, e.prototype.applyStyle = function (e, t) {
                void 0 === t && (t = {}), this.commitStyle(n.__assign({
                  style: e
                }, t));
              }, e.prototype.splitSelection = function (e, t) {
                if (!this.isCollapsed()) return null;
                var o = this.createRange(),
                  n = this.range;
                o.setStartBefore(e);
                var r = this.cursorOnTheRight(e, t),
                  i = this.cursorOnTheLeft(e, t),
                  s = this.j.createInside.element("br"),
                  l = this.j.createInside.fake(),
                  c = l.cloneNode();
                try {
                  if (r || i) {
                    t ? a.Dom.before(t, s) : a.Dom.safeInsertNode(n, s);
                    var u = function (e, t) {
                      for (var o = t(e); o;) {
                        var n = t(o);
                        if (!o || !a.Dom.isTag(o, "br") && !a.Dom.isEmptyTextNode(o)) break;
                        a.Dom.safeRemove(o), o = n;
                      }
                    };
                    u(s, function (e) {
                      return e.nextSibling;
                    }), u(s, function (e) {
                      return e.previousSibling;
                    }), a.Dom.after(s, c), a.Dom.before(s, l), r ? (o.setEndBefore(s), n.setEndBefore(s)) : (o.setEndAfter(s), n.setEndAfter(s));
                  } else o.setEnd(n.startContainer, n.startOffset);
                  var d = o.extractContents(),
                    p = function (e) {
                      return a.Dom.each(e, function (e) {
                        return a.Dom.isEmptyTextNode(e) && a.Dom.safeRemove(e);
                      });
                    };
                  try {
                    if (p(d), p(e), e.parentNode.insertBefore(d, e), !t && r && (null == s ? void 0 : s.parentNode)) {
                      var f = this.createRange();
                      f.setStartBefore(s), this.selectRange(f);
                    }
                  } catch (e) {}
                  var h = function (e) {
                    var t, o, n;
                    (null === (t = null == e ? void 0 : e.parentNode) || void 0 === t ? void 0 : t.firstChild) === (null === (o = null == e ? void 0 : e.parentNode) || void 0 === o ? void 0 : o.lastChild) && (null === (n = null == e ? void 0 : e.parentNode) || void 0 === n || n.appendChild(s.cloneNode()));
                  };
                  h(l), h(c);
                } finally {
                  a.Dom.safeRemove(l), a.Dom.safeRemove(c);
                }
                return e.previousElementSibling;
              }, e.prototype.expandSelection = function () {
                var e = this;
                if (this.isCollapsed()) return this;
                var t = this.range,
                  o = t.cloneRange();
                if (!a.Dom.isOrContains(this.j.editor, t.commonAncestorContainer, !0)) return this;
                var n = function (o) {
                    var n = e.j.createInside.fake(),
                      r = t.cloneRange();
                    return r.collapse(o), a.Dom.safeInsertNode(r, n), (0, u.moveTheNodeAlongTheEdgeOutward)(n, o, e.j.editor), n;
                  },
                  r = n(!0),
                  i = n(!1);
                o.setStartAfter(r), o.setEndBefore(i);
                var s = a.Dom.findSibling(r, !1),
                  l = a.Dom.findSibling(i, !0);
                if (s !== l) {
                  var c = a.Dom.isElement(s) && a.Dom.isOrContains(s, i),
                    d = !c && a.Dom.isElement(l) && a.Dom.isOrContains(l, r);
                  if (c || d) {
                    for (var p = c ? s : l, f = p; a.Dom.isElement(p);) (p = c ? p.firstElementChild : p.lastElementChild) && a.Dom.isOrContains(p, c ? i : r) && (f = p);
                    c ? o.setStart(f, 0) : o.setEnd(f, f.childNodes.length);
                  }
                }
                return this.selectRange(o), a.Dom.safeRemove(r, i), this;
              }, n.__decorate([c.autobind], e.prototype, "createRange", null), n.__decorate([c.autobind], e.prototype, "focus", null), n.__decorate([c.autobind], e.prototype, "setCursorAfter", null), n.__decorate([c.autobind], e.prototype, "setCursorBefore", null), n.__decorate([c.autobind], e.prototype, "setCursorIn", null), e;
            }();
            t.Select = p;
          },
          77846: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.extractSelectedPart = void 0;
            var n = o(67309),
              r = o(33941),
              i = o(24263),
              a = o(37204);
            function s(e, t, o) {
              var a = t.extractContents();
              a.textContent && (0, r.trim)(a.textContent).length || !a.firstChild || i.Dom.unwrap(a.firstChild), e.parentNode && (0, n.call)(o ? i.Dom.before : i.Dom.after, e, a);
            }
            t.extractSelectedPart = function (e, t, o) {
              var n = o.s.createRange(),
                r = (0, a.isMarker)(t.previousSibling) ? t.previousSibling : t;
              n.setStartBefore(e), n.setEndBefore(r), s(e, n, !0);
              var i = (0, a.isMarker)(t.nextSibling) ? t.nextSibling : t;
              n.setStartAfter(i), n.setEndAfter(e), s(e, n, !1);
            };
          },
          95901: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.FiniteStateMachine = void 0, o(24421), o(603);
            var n = function () {
              function e(e, t) {
                this.transitions = t, this.silent = !0, this.__previewsStates = new Set(), this.setState(e);
              }
              return e.prototype.setState = function (e) {
                this.__previewsStates.add(e), this.__state = e;
              }, e.prototype.getState = function () {
                return this.__state;
              }, e.prototype.disableSilent = function () {
                this.silent = !1;
              }, e.prototype.dispatch = function (e, t) {
                var o = this.transitions[this.getState()][e];
                if (o) {
                  var n = o.call(this, t);
                  return this.setState(n.next), n;
                }
                throw new Error("invalid action: ".concat(this.getState(), ".").concat(e.toString()));
              }, e;
            }();
            t.FiniteStateMachine = n;
          },
          65774: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getSuitChild = void 0;
            var n = o(24263),
              r = o(63150),
              i = o(74477);
            t.getSuitChild = function (e, t) {
              for (var o = t.firstChild; o && !(0, r.isNormalNode)(o);) if (!(o = o.nextSibling)) return null;
              return o && !n.Dom.next(o, r.isNormalNode, t) && (0, i.isSuitElement)(e, o, !1) ? o : null;
            };
          },
          66277: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getSuitParent = void 0;
            var n = o(24263),
              r = o(63150),
              i = o(74477);
            t.getSuitParent = function e(t, o, a) {
              var s = o.parentNode;
              return s === a || !n.Dom.isHTMLElement(s) || n.Dom.next(o, r.isNormalNode, s) || n.Dom.prev(o, r.isNormalNode, s) ? null : t.isElementCommit && t.elementIsBlock && !n.Dom.isBlock(s) ? e(t, s, a) : !(0, i.isSuitElement)(t, s, !1) || n.Dom.isBlock(s) && !t.elementIsBlock ? t.isElementCommit && !n.Dom.isBlock(s) ? e(t, s, a) : null : s;
            };
          },
          18387: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hasSameStyleKeys = t.hasSameStyle = void 0;
            var n = o(26911),
              r = o(24021),
              i = o(49353),
              a = o(24263);
            o(52378), t.hasSameStyle = function (e, t) {
              return Boolean(!a.Dom.isTag(e, "font") && a.Dom.isHTMLElement(e) && Object.keys(t).every(function (o) {
                var a = (0, n.css)(e, o, !0);
                return "" === a && ("" === t[o] || null == t[o]) || !(0, r.isVoid)(a) && "" !== a && !(0, r.isVoid)(t[o]) && (0, i.normalizeCssValue)(o, t[o]).toString().toLowerCase() === a.toString().toLowerCase();
              }));
            }, document.createElement("div").style.color = "red", t.hasSameStyleKeys = function (e, t) {
              return Boolean(!a.Dom.isTag(e, "font") && a.Dom.isHTMLElement(e) && Object.keys(t).every(function (t) {
                var o = (0, n.css)(e, t, !0);
                return !(0, r.isVoid)(o);
              }));
            };
          },
          66162: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(93217), t), n.__exportStar(o(11651), t), n.__exportStar(o(29271), t), n.__exportStar(o(18387), t), n.__exportStar(o(77846), t), n.__exportStar(o(95901), t), n.__exportStar(o(65774), t), n.__exportStar(o(66277), t), n.__exportStar(o(76991), t), n.__exportStar(o(47508), t), n.__exportStar(o(63150), t), n.__exportStar(o(74477), t), n.__exportStar(o(26707), t), n.__exportStar(o(8298), t), n.__exportStar(o(6278), t);
          },
          76991: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isInsideInvisibleElement = void 0;
            var n = o(24263);
            t.isInsideInvisibleElement = function (e, t) {
              return Boolean(n.Dom.closest(e, ["style", "script"], t));
            };
          },
          63150: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isNormalNode = void 0;
            var n = o(24263),
              r = o(37204);
            t.isNormalNode = function (e) {
              return Boolean(e && !n.Dom.isEmptyTextNode(e) && !n.Dom.isTemporary(e) && !(0, r.isMarker)(e));
            };
          },
          47508: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.elementsEqualAttributes = t.isSameAttributes = void 0;
            var n = o(76502),
              r = o(16492),
              i = (o(52378), o(18387));
            t.isSameAttributes = function (e, t) {
              return !e.attributes.length && !(0, r.size)(t) || !(0, r.size)(t) || Object.keys(t).every(function (o) {
                return "class" === o ? e.classList.contains(t[o]) : "style" === o ? (0, i.hasSameStyle)(e, t[o]) : (0, n.attr)(e, o) === t[o];
              });
            }, t.elementsEqualAttributes = function (e, t) {
              return e.attributes.length === t.attributes.length && Array.from(e.attributes).every(function (e) {
                return t.hasAttribute(e.name) && t.getAttribute(e.name) === e.value;
              });
            };
          },
          74477: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isSameStyleChild = t.findSuitClosest = t.isSuitElement = void 0;
            var n = o(24263),
              r = o(63150),
              i = o(18387);
            function a(e, t, o) {
              var a;
              if (!t) return !1;
              var s = e.element,
                l = e.elementIsDefault,
                c = e.options,
                u = Boolean((null === (a = c.attributes) || void 0 === a ? void 0 : a.style) && (0, i.hasSameStyle)(t, c.attributes.style)),
                d = t.nodeName.toLowerCase() === s || n.Dom.isTag(t, ["ul", "ol"]) && e.elementIsList;
              return !((l && o || !d) && (!u || !(0, r.isNormalNode)(t) || e.elementIsList)) || Boolean(!d && !o && l && n.Dom.isInlineBlock(t));
            }
            t.isSuitElement = a, t.findSuitClosest = function (e, t, o) {
              return n.Dom.closest(t, function (t) {
                return a(e, t, !0);
              }, o);
            }, t.isSameStyleChild = function (e, t) {
              var o,
                n,
                a = e.element,
                s = e.options;
              if (!t || !(0, r.isNormalNode)(t)) return !1;
              var l = t.nodeName.toLowerCase() === a,
                c = Boolean((null === (o = s.attributes) || void 0 === o ? void 0 : o.style) && (0, i.hasSameStyleKeys)(t, null === (n = s.attributes) || void 0 === n ? void 0 : n.style));
              return l && c;
            };
          },
          11651: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.toggleOrderedList = void 0;
            var n = o(24263),
              r = (o(52378), o(77846)),
              i = o(70851),
              a = o(93217),
              s = o(66162);
            function l(e, t, o, a, s) {
              return a.e.fire("".concat(i._PREFIX, "BeforeUnwrapList"), e, t, s) || ((0, r.extractSelectedPart)(t, o, a), n.Dom.unwrap(o.parentElement), n.Dom.replace(o, a.o.enter, a.createInside));
            }
            t.toggleOrderedList = function (e, t, o, n) {
              if (!t) return n;
              var r = t.parentElement;
              if (!r) return n;
              var c = o.e.fire("".concat(i._PREFIX, "BeforeToggleList"), n, e, r);
              if (void 0 !== c) return c;
              var u = o.e.fire.bind(o.e, "".concat(i._PREFIX, "AfterToggleList"));
              if (n !== i.UNWRAP) {
                var d = (0, a.toggleAttributes)(e, t.parentElement, o, i.INITIAL, !0) === i.CHANGE;
                if (n === i.REPLACE || d || r.tagName.toLowerCase() !== e.element) {
                  var p = l(i.REPLACE, r, t, o, e),
                    f = (0, s.wrapList)(e, p, o);
                  return u(i.REPLACE, f, e), i.REPLACE;
                }
              }
              var h = l(i.UNWRAP, r, t, o, e);
              return u(i.UNWRAP, h, e), i.UNWRAP;
            };
          },
          29271: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.wrapList = void 0;
            var n = o(64968),
              r = o(70851),
              i = o(66162);
            t.wrapList = function (e, t, o) {
              var a = o.e.fire("".concat(r._PREFIX, "BeforeWrapList"), r.REPLACE, t, e),
                s = null != a ? a : n.Dom.replace(t, "li", o.createInside),
                l = s.previousElementSibling,
                c = s.nextElementSibling,
                u = n.Dom.isTag(l, e.element) ? l : null;
              return null != u || (u = n.Dom.isTag(c, e.element) ? c : null), n.Dom.isTag(u, ["ul", "ol"]) && (0, i.isSameAttributes)(u, e.options.attributes) || (u = o.createInside.element(e.element), (0, i.toggleAttributes)(e, u, o, r.INITIAL), n.Dom.before(s, u)), l === u ? n.Dom.append(u, s) : n.Dom.prepend(u, s), n.Dom.isTag(u.nextElementSibling, e.element) && (0, i.elementsEqualAttributes)(u, u.nextElementSibling) && (n.Dom.append(u, Array.from(u.nextElementSibling.childNodes)), n.Dom.safeRemove(u.nextElementSibling)), o.e.fire("".concat(r._PREFIX, "AfterWrapList"), r.WRAP, u, e), u;
            };
          },
          93217: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.toggleAttributes = void 0;
            var n = o(76502),
              r = o(26911),
              i = o(63122),
              a = o(11278),
              s = o(49353),
              l = o(16492),
              c = o(24263),
              u = o(70851),
              d = o(17332),
              p = (o(10172), "toggleAttributes");
            function f(e, t, o) {
              return (0, n.attr)(t, "style") || ((0, n.attr)(t, "style", null), t.tagName.toLowerCase() === e.defaultTag && (c.Dom.unwrap(t), o = u.UNWRAP)), o;
            }
            t.toggleAttributes = function (e, t, o, h, m) {
              if (void 0 === m && (m = !1), !m && e.isApplied(t, p)) return h;
              !m && e.setApplied(t, p);
              var v = e.options.attributes;
              return v && (0, l.size)(v) > 0 && Object.keys(v).forEach(function (l) {
                var p = v[l];
                switch (l) {
                  case "style":
                    h = function (e, t, o, n, l, p) {
                      return Object.keys(o).forEach(function (h) {
                        var m = n.style.getPropertyValue((0, a.kebabCase)(h)),
                          v = o[h];
                        if ("" !== m || null != v) {
                          if (function (e, t, o) {
                            var n = e.create.element(t.tagName.toLowerCase());
                            n.style.cssText = t.style.cssText, function (e) {
                              var t;
                              if (void 0 !== (0, i.dataBind)(e, "shadowRoot")) return (0, i.dataBind)(e, "shadowRoot");
                              var o = (0, d.getContainer)(e),
                                n = document.createElement("iframe");
                              (0, r.css)(n, {
                                width: 0,
                                height: 0,
                                position: "absolute",
                                border: 0
                              }), n.src = "about:blank", o.appendChild(n);
                              var a = null === (t = n.contentWindow) || void 0 === t ? void 0 : t.document,
                                s = a ? a.body : e.od.body;
                              return (0, i.dataBind)(e, "shadowRoot", s), s;
                            }(e).appendChild(n);
                            var a = (0, r.css)(n, o);
                            return c.Dom.safeRemove(n), a;
                          }(t, n, h) === (0, s.normalizeCssValue)(h, v)) {
                            if (!m) return;
                            return !l && (0, r.css)(n, h, null), void (p = f(e, n, p = u.UNSET));
                          }
                          p = u.CHANGE, l || ((0, r.css)(n, h, v), p = f(e, n, p));
                        }
                      }), p;
                    }(e, o, p, t, m, h);
                    break;
                  case "class":
                    h = function (e, t, o, r, i) {
                      var a = e.e.fire.bind(e.e, "".concat(u._PREFIX, "AfterToggleAttribute"));
                      return o.classList.contains(t.toString()) ? (r = u.UNSET, i || (o.classList.remove(t), 0 === o.classList.length && ((0, n.attr)(o, "class", null), a(r, o, "class", null)))) : (r = u.CHANGE, i || (o.classList.add(t), a(r, o, "class", t))), r;
                    }(o, p, t, h, m);
                    break;
                  default:
                    h = function (e, t, o, r, i, a) {
                      var s = e.e.fire.bind(e.e, "".concat(u._PREFIX, "AfterToggleAttribute"));
                      return (0, n.attr)(o, r) === t ? (!i && (0, n.attr)(o, r, null), a = u.UNSET, !i && s(a, o, r, t), a) : (a = u.CHANGE, i || ((0, n.attr)(o, r, t), s(a, o, r, t)), a);
                    }(o, p, t, l, m, h);
                }
              }), h;
            };
          },
          26707: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.unwrapChildren = void 0;
            var n = o(24263),
              r = o(40332),
              i = o(18387),
              a = o(74477);
            t.unwrapChildren = function (e, t) {
              var o,
                s,
                l = [],
                c = [],
                u = null === (o = e.options.attributes) || void 0 === o ? void 0 : o.style;
              if (t.firstChild) for (var d = n.Dom.eachGen(t), p = d.next(), f = function () {
                  var t = p.value;
                  !(0, a.isSuitElement)(e, t, !0) || u && !(0, i.hasSameStyleKeys)(t, u) ? u && (0, a.isSameStyleChild)(e, t) ? (void 0 === s && (s = !1), c.push(function () {
                    (0, r.css)(t, Object.keys(u).reduce(function (e, t) {
                      return e[t] = null, e;
                    }, {})), (0, r.attr)(t, "style") || (0, r.attr)(t, "style", null), (0, r.attr)(t, "style") || t.nodeName.toLowerCase() !== e.element || l.push(t);
                  })) : n.Dom.isEmptyTextNode(t) || void 0 === s && (s = !1) : (void 0 === s && (s = !0), l.push(t)), p = d.next();
                }; !p.done;) f();
              return c.forEach(function (e) {
                return e();
              }), l.forEach(n.Dom.unwrap), Boolean(s);
            };
          },
          6278: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.wrapUnwrappedText = void 0;
            var n = o(24263),
              r = o(37204);
            t.wrapUnwrappedText = function (e, t, o) {
              var i = o.editor,
                a = o.createInside,
                s = function (e, t) {
                  void 0 === t && (t = "previousSibling");
                  for (var a = e, s = e; s && !(0, r.isMarker)(s) && !n.Dom.isTag(s, o.o.enter) && (a = s, s = s[t] ? s[t] : s.parentNode && !n.Dom.isBlock(s.parentNode) && s.parentNode !== i ? s.parentNode : null, !n.Dom.isBlock(s)););
                  return a;
                },
                l = s(t),
                c = s(t, "nextSibling"),
                u = o.s.createRange();
              u.setStartBefore(l), u.setEndAfter(c);
              var d = u.extractContents(),
                p = a.element(e.element);
              return p.appendChild(d), n.Dom.safeInsertNode(u, p), e.elementIsBlock && n.Dom.isEmpty(p) && !n.Dom.isTag(p.firstElementChild, "br") && p.appendChild(a.element("br")), p;
            };
          },
          8298: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.wrap = void 0;
            var n = o(64968),
              r = o(6278),
              i = o(67309),
              a = o(29271);
            t.wrap = function (e, t, o) {
              var s = function (e, t, o) {
                return e.elementIsBlock ? n.Dom.up(t, function (e) {
                  return n.Dom.isBlock(e) && !n.Dom.isTag(e, ["td", "th", "tr", "tbody", "table", "li", "ul", "ol"]);
                }, o.editor) || (0, r.wrapUnwrappedText)(e, t, o) : ((0, i.attr)(t, "size", null), t);
              }(e, t, o);
              return e.elementIsList ? (0, a.wrapList)(e, s, o) : n.Dom.replace(s, e.element, o.createInside, !0);
            };
          },
          3097: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ApplyStyle = void 0;
            var n = o(74504),
              r = o(66162),
              i = o(33090),
              a = o(70851);
            t.ApplyStyle = function (e, t) {
              var o = e.s,
                s = e.editor;
              o.save(), (0, n.normalizeNode)(s.firstChild);
              for (var l = e.s.wrapInTagGen(), c = l.next(), u = {
                  mode: a.INITIAL,
                  element: c.value,
                  next: i.states.START,
                  jodit: e,
                  style: t
                }; c && !c.done;) {
                var d = new r.FiniteStateMachine(i.states.START, i.transactions);
                for (u.element = c.value; d.getState() !== i.states.END;) u = d.dispatch("exec", u);
                c = l.next();
              }
              o.restore();
            };
          },
          70851: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.CommitStyle = t._PREFIX = t.REPLACE = t.INITIAL = t.UNSET = t.CHANGE = t.UNWRAP = t.WRAP = void 0;
            var n = o(86893),
              r = o(26596),
              i = o(3097);
            t.WRAP = "wrap", t.UNWRAP = "unwrap", t.CHANGE = "change", t.UNSET = "unset", t.INITIAL = "initial", t.REPLACE = "replace", t._PREFIX = "commitStyle";
            var a = function () {
              function e(e) {
                var t, o, n, r;
                this.options = e, this.__applyMap = new WeakMap(), e.attributes = (t = e.attributes, r = (o = this.options).className, (n = o.style) && (t ? t.style = n : t = {
                  style: n
                }, delete this.options.style), r && (t ? t.class = r : t = {
                  class: r
                }, delete this.options.className), t);
              }
              return e.prototype.isApplied = function (e, t) {
                var o = this.__applyMap.get(e);
                return !!o && o[t];
              }, e.prototype.setApplied = function (e, t) {
                var o,
                  n = null !== (o = this.__applyMap.get(e)) && void 0 !== o ? o : {};
                n[t] = !0, this.__applyMap.set(e, n);
              }, Object.defineProperty(e.prototype, "elementIsList", {
                get: function () {
                  return Boolean(this.options.element && ["ul", "ol"].includes(this.options.element));
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "element", {
                get: function () {
                  return this.options.element || this.defaultTag;
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "elementIsBlock", {
                get: function () {
                  return Boolean(this.options.element && n.IS_BLOCK.test(this.options.element));
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "isElementCommit", {
                get: function () {
                  return Boolean(this.options.element && this.options.element !== this.options.defaultTag);
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "defaultTag", {
                get: function () {
                  return this.options.defaultTag ? this.options.defaultTag : this.elementIsBlock ? "p" : "span";
                },
                enumerable: !1,
                configurable: !0
              }), Object.defineProperty(e.prototype, "elementIsDefault", {
                get: function () {
                  return this.element === this.defaultTag;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.apply = function (e) {
                var o = this.options.hooks;
                try {
                  o && Object.keys(o).forEach(function (n) {
                    e.e.on((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
                  }), (0, i.ApplyStyle)(e, this);
                } finally {
                  o && Object.keys(o).forEach(function (n) {
                    e.e.off((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
                  }), this.__applyMap = new WeakMap();
                }
              }, e;
            }();
            t.CommitStyle = a;
          },
          33090: function (e, t, o) {

            var n;
            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.transactions = t.states = void 0;
            var r = o(20255),
              i = o(2123),
              a = o(66162),
              s = o(64968),
              l = o(2123);
            o(52378), t.states = {
              START: "START",
              ELEMENT: "ELEMENT",
              UNWRAP: "UNWRAP",
              UNWRAP_CHILDREN: "UNWRAP_CHILDREN",
              CHANGE: "CHANGE",
              REPLACE_DEFAULT: "REPLACE_DEFAULT",
              LIST: "LIST",
              TOGGLE_LIST: "TOGGLE_LIST",
              WRAP: "WRAP",
              EXTRACT: "EXTRACT",
              END: "END"
            }, t.transactions = ((n = {})[t.states.START] = {
              exec: function (e) {
                var o = e.element,
                  n = e.jodit,
                  i = e.style,
                  c = e.mode;
                if ((0, a.isInsideInvisibleElement)(o, n.editor) || s.Dom.isEmptyContent(o)) return r.__assign(r.__assign({}, e), {
                  next: t.states.END
                });
                var u = (0, a.getSuitParent)(i, o, n.editor) || (0, a.getSuitChild)(i, o);
                if (u) return r.__assign(r.__assign({}, e), {
                  next: t.states.ELEMENT,
                  element: u
                });
                var d = (0, a.findSuitClosest)(i, o, n.editor);
                return i.elementIsList && s.Dom.isTag(d, ["ul", "ol"]) ? r.__assign(r.__assign({}, e), {
                  next: t.states.LIST
                }) : r.__assign(r.__assign({}, e), d ? {
                  next: t.states.EXTRACT
                } : {
                  next: c !== l.UNWRAP ? t.states.UNWRAP_CHILDREN : t.states.END
                });
              }
            }, n[t.states.LIST] = {
              exec: function (e) {
                var o = e.element,
                  n = e.jodit,
                  a = e.mode;
                if (a !== l.INITIAL && a !== l.UNWRAP && a !== i.REPLACE) return r.__assign(r.__assign({}, e), {
                  next: t.states.END
                });
                var c = s.Dom.closest(o, "li", n.editor);
                if (!c) return r.__assign(r.__assign({}, e), {
                  next: t.states.END
                });
                var u = s.Dom.closest(o, ["ul", "ol"], n.editor);
                return r.__assign(r.__assign({}, e), u ? {
                  element: c,
                  next: t.states.TOGGLE_LIST
                } : {
                  next: t.states.END
                });
              }
            }, n[t.states.TOGGLE_LIST] = {
              exec: function (e) {
                return r.__assign(r.__assign({}, e), {
                  mode: (0, a.toggleOrderedList)(e.style, e.element, e.jodit, e.mode),
                  next: t.states.END
                });
              }
            }, n[t.states.EXTRACT] = {
              exec: function (e) {
                var o = e.element,
                  n = e.jodit,
                  i = e.style,
                  s = (0, a.findSuitClosest)(i, o, n.editor);
                return i.elementIsBlock || (0, a.extractSelectedPart)(s, o, n), r.__assign(r.__assign({}, e), {
                  element: s,
                  next: t.states.ELEMENT
                });
              }
            }, n[t.states.UNWRAP_CHILDREN] = {
              exec: function (e) {
                return (0, a.unwrapChildren)(e.style, e.element) ? r.__assign(r.__assign({}, e), {
                  mode: l.UNWRAP,
                  next: t.states.END
                }) : r.__assign(r.__assign({}, e), {
                  next: t.states.WRAP
                });
              }
            }, n[t.states.WRAP] = {
              exec: function (e) {
                var o = e.style,
                  n = (0, a.wrap)(o, e.element, e.jodit);
                return r.__assign(r.__assign({}, e), {
                  next: o.elementIsList ? t.states.END : t.states.CHANGE,
                  mode: l.WRAP,
                  element: n
                });
              }
            }, n[t.states.ELEMENT] = {
              exec: function (e) {
                var o = e.style,
                  n = e.element;
                return (0, a.toggleAttributes)(o, n, e.jodit, l.INITIAL, !0) !== l.INITIAL ? r.__assign(r.__assign({}, e), {
                  next: t.states.CHANGE
                }) : s.Dom.isTag(n, o.element) ? r.__assign(r.__assign({}, e), {
                  next: t.states.UNWRAP
                }) : r.__assign(r.__assign({}, e), {
                  next: t.states.END
                });
              }
            }, n[t.states.CHANGE] = {
              exec: function (e) {
                var o = e.style,
                  n = e.element,
                  i = e.mode,
                  c = (0, a.toggleAttributes)(o, n, e.jodit, e.mode);
                return i !== l.WRAP && c === l.UNSET && !n.attributes.length && s.Dom.isTag(n, o.element) ? r.__assign(r.__assign({}, e), {
                  next: t.states.UNWRAP
                }) : r.__assign(r.__assign({}, e), {
                  mode: c,
                  next: t.states.END
                });
              }
            }, n[t.states.UNWRAP] = {
              exec: function (e) {
                return e.element.attributes.length && s.Dom.isTag(e.element, e.style.element) ? r.__assign(r.__assign({}, e), {
                  next: t.states.REPLACE_DEFAULT
                }) : (s.Dom.unwrap(e.element), r.__assign(r.__assign({}, e), {
                  mode: l.UNWRAP,
                  next: t.states.END
                }));
              }
            }, n[t.states.REPLACE_DEFAULT] = {
              exec: function (e) {
                return s.Dom.replace(e.element, e.style.defaultTag, e.jodit.createInside, !0), r.__assign(r.__assign({}, e), {
                  mode: i.REPLACE,
                  next: t.states.END
                });
              }
            }, n[t.states.END] = {
              exec: function (e) {
                return e;
              }
            }, n);
          },
          75764: function (e, t) {

            var o;
            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.LocalStorageProvider = t.canUsePersistentStorage = void 0, t.canUsePersistentStorage = function () {
              return void 0 === o && (o = function () {
                var e = "___Jodit___" + Math.random().toString();
                try {
                  localStorage.setItem(e, "1");
                  var t = "1" === localStorage.getItem(e);
                  return localStorage.removeItem(e), t;
                } catch (e) {}
                return !1;
              }()), o;
            };
            var n = function () {
              function e(e) {
                this.rootKey = e;
              }
              return e.prototype.set = function (e, t) {
                try {
                  var o = localStorage.getItem(this.rootKey),
                    n = o ? JSON.parse(o) : {};
                  n[e] = t, localStorage.setItem(this.rootKey, JSON.stringify(n));
                } catch (e) {}
                return this;
              }, e.prototype.delete = function (e) {
                try {
                  localStorage.removeItem(this.rootKey);
                } catch (e) {}
                return this;
              }, e.prototype.get = function (e) {
                try {
                  var t = localStorage.getItem(this.rootKey),
                    o = t ? JSON.parse(t) : {};
                  return void 0 !== o[e] ? o[e] : null;
                } catch (e) {}
              }, e.prototype.exists = function (e) {
                return null != this.get(e);
              }, e.prototype.clear = function () {
                try {
                  localStorage.removeItem(this.rootKey);
                } catch (e) {}
                return this;
              }, e;
            }();
            t.LocalStorageProvider = n;
          },
          79905: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.MemoryStorageProvider = void 0;
            var o = function () {
              function e() {
                this.data = new Map();
              }
              return e.prototype.set = function (e, t) {
                return this.data.set(e, t), this;
              }, e.prototype.delete = function (e) {
                return this.data.delete(e), this;
              }, e.prototype.get = function (e) {
                return this.data.get(e);
              }, e.prototype.exists = function (e) {
                return this.data.has(e);
              }, e.prototype.clear = function () {
                return this.data.clear(), this;
              }, e;
            }();
            t.MemoryStorageProvider = o;
          },
          77462: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(79905), t), n.__exportStar(o(75764), t), n.__exportStar(o(52015), t);
          },
          52015: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Storage = t.StorageKey = void 0;
            var n = o(40332),
              r = o(75764),
              i = o(79905);
            t.StorageKey = "Jodit_";
            var a = function () {
              function e(e, o) {
                this.provider = e, this.prefix = t.StorageKey, o && (this.prefix += o);
              }
              return e.prototype.set = function (e, t) {
                return this.provider.set((0, n.camelCase)(this.prefix + e), t), this;
              }, e.prototype.delete = function (e) {
                return this.provider.delete((0, n.camelCase)(this.prefix + e)), this;
              }, e.prototype.get = function (e) {
                return this.provider.get((0, n.camelCase)(this.prefix + e));
              }, e.prototype.exists = function (e) {
                return this.provider.exists((0, n.camelCase)(this.prefix + e));
              }, e.prototype.clear = function () {
                return this.provider.clear(), this;
              }, e.makeStorage = function (o, n) {
                var a;
                return void 0 === o && (o = !1), o && (0, r.canUsePersistentStorage)() && (a = new r.LocalStorageProvider(t.StorageKey + n)), a || (a = new i.MemoryStorageProvider()), new e(a, n);
              }, e;
            }();
            t.Storage = a;
          },
          59363: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Dlgs = void 0;
            var n = o(20255),
              r = o(87837),
              i = o(40332),
              a = function () {
                function e() {}
                return e.prototype.dlg = function (e) {
                  var t = new r.Dialog(n.__assign({
                    language: this.o.language,
                    shadowRoot: this.o.shadowRoot,
                    ownerWindow: this.o.ownerWindow,
                    defaultTimeout: this.o.defaultTimeout,
                    theme: this.o.theme,
                    globalFullSize: this.o.globalFullSize
                  }, e));
                  return (0, i.markOwner)(this, t.container), t.parent = this, t.bindDestruct(this);
                }, e.prototype.confirm = function (e, t, o) {
                  return (0, i.isString)(t) && (t = this.i18n(t)), r.Confirm.call(this.dlg(), this.i18n(e), t, o);
                }, e.prototype.prompt = function (e, t, o, n, a) {
                  return (0, i.isString)(t) && (t = this.i18n(t)), (0, i.isString)(n) && (n = this.i18n(n)), r.Prompt.call(this.dlg(), this.i18n(e), t, o, n, a);
                }, e.prototype.alert = function (e, t, o, n) {
                  return (0, i.isString)(e) && (e = this.i18n(e)), (0, i.isString)(t) && (t = this.i18n(t)), r.Alert.call(this.dlg(), e, t, o, n);
                }, e;
              }();
            t.Dlgs = a;
          },
          14089: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Elms = void 0;
            var n = o(1853),
              r = function () {
                function e() {}
                return e.prototype.getElm = function (e) {
                  return this.container.querySelector(".".concat(this.getFullElName(e)));
                }, e.prototype.getElms = function (e) {
                  return (0, n.toArray)(this.container.querySelectorAll(".".concat(this.getFullElName(e))));
                }, e;
              }();
            t.Elms = r;
          },
          59829: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(14089), t), n.__exportStar(o(41681), t), n.__exportStar(o(59363), t);
          },
          41681: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Mods = void 0;
            var n = o(1853),
              r = o(24021),
              i = function () {
                function e() {}
                return e.prototype.afterSetMod = function (e, t) {}, e.prototype.setMod = function (e, t, o) {
                  if (e = e.toLowerCase(), this.mods[e] === t) return this;
                  var i = "".concat(this.componentName, "_").concat(e),
                    a = (o || this.container).classList;
                  return (0, n.toArray)(a).forEach(function (e) {
                    0 === e.indexOf(i) && a.remove(e);
                  }), !(0, r.isVoid)(t) && "" !== t && a.add("".concat(i, "_").concat(t.toString().toLowerCase())), this.mods[e] = t, this.afterSetMod(e, t), this;
                }, e.prototype.getMod = function (e) {
                  var t;
                  return null !== (t = this.mods[e]) && void 0 !== t ? t : null;
                }, e;
              }();
            t.Mods = i;
          },
          96031: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Button = t.UIButton = t.UIButtonState = void 0;
            var n = o(20255);
            o(93330);
            var r = o(53929),
              i = o(24263),
              a = o(76502),
              s = o(24421),
              l = o(42096),
              c = o(77904),
              u = o(47970),
              d = o(43441),
              p = o(29411);
            t.UIButtonState = function () {
              return {
                size: "middle",
                type: "button",
                name: "",
                value: "",
                variant: "initial",
                disabled: !1,
                activated: !1,
                icon: {
                  name: "empty",
                  fill: "",
                  iconURL: ""
                },
                tooltip: "",
                text: "",
                tabIndex: void 0
              };
            };
            var f = function (e) {
              function o(o, n) {
                var r = e.call(this, o) || this;
                return r.isButton = !0, r.state = (0, t.UIButtonState)(), r.actionHandlers = [], r.updateSize(), r.onChangeSize(), r.onChangeStatus(), n && r.hookStatus(p.STATUSES.ready, function () {
                  r.setState(n);
                }), r;
              }
              return n.__extends(o, e), o.prototype.className = function () {
                return "UIButton";
              }, o.prototype.setState = function (e) {
                return Object.assign(this.state, e), this;
              }, o.prototype.onChangeSize = function () {
                this.setMod("size", this.state.size);
              }, o.prototype.onChangeType = function () {
                (0, a.attr)(this.container, "type", this.state.type);
              }, o.prototype.updateSize = function () {
                var e = this.closest(u.UIList);
                e && (this.state.size = e.buttonSize);
              }, o.prototype.onChangeStatus = function () {
                this.setMod("variant", this.state.variant);
              }, o.prototype.onChangeText = function () {
                this.text.textContent = this.jodit.i18n(this.state.text);
              }, o.prototype.onChangeTextSetMode = function () {
                this.setMod("text-icons", Boolean(this.state.text.trim().length));
              }, o.prototype.onChangeDisabled = function () {
                (0, a.attr)(this.container, "disabled", this.state.disabled || null);
              }, o.prototype.onChangeActivated = function () {
                (0, a.attr)(this.container, "aria-pressed", this.state.activated);
              }, o.prototype.onChangeName = function () {
                this.container.classList.add("".concat(this.componentName, "_").concat(this.clearName(this.state.name))), this.name = this.state.name, (0, a.attr)(this.container, "data-ref", this.state.name), (0, a.attr)(this.container, "ref", this.state.name);
              }, o.prototype.onChangeTooltip = function () {
                this.get("j.o.useNativeTooltip") && (0, a.attr)(this.container, "title", this.state.tooltip), (0, a.attr)(this.container, "aria-label", this.state.tooltip);
              }, o.prototype.onChangeTabIndex = function () {
                (0, a.attr)(this.container, "tabindex", this.state.tabIndex);
              }, o.prototype.onChangeIcon = function () {
                var e = this.get("j.o.textIcons");
                if (!(!0 === e || (0, l.isFunction)(e) && e(this.state.name))) {
                  i.Dom.detach(this.icon);
                  var t = c.Icon.makeIcon(this.j, this.state.icon);
                  t && this.icon.appendChild(t);
                }
              }, o.prototype.focus = function () {
                this.container.focus();
              }, o.prototype.isFocused = function () {
                var e = this.od.activeElement;
                return Boolean(e && i.Dom.isOrContains(this.container, e));
              }, o.prototype.createContainer = function () {
                var e = this.componentName,
                  t = this.j.c.element("button", {
                    class: e,
                    type: "button",
                    role: "button",
                    ariaPressed: !1
                  });
                return this.icon = this.j.c.span(e + "__icon"), this.text = this.j.c.span(e + "__text"), t.appendChild(this.icon), t.appendChild(this.text), this.j.e.on(t, "click", this.onActionFire), t;
              }, o.prototype.destruct = function () {
                return this.j.e.off(this.container), e.prototype.destruct.call(this);
              }, o.prototype.onAction = function (e) {
                return this.actionHandlers.push(e), this;
              }, o.prototype.onActionFire = function (e) {
                var t = this;
                e.buffer = {
                  actionTrigger: this
                }, this.actionHandlers.forEach(function (o) {
                  return o.call(t, e);
                });
              }, n.__decorate([(0, d.watch)("state.size")], o.prototype, "onChangeSize", null), n.__decorate([(0, d.watch)("state.type")], o.prototype, "onChangeType", null), n.__decorate([(0, d.watch)("parentElement")], o.prototype, "updateSize", null), n.__decorate([(0, d.watch)("state.variant")], o.prototype, "onChangeStatus", null), n.__decorate([(0, d.watch)("state.text")], o.prototype, "onChangeText", null), n.__decorate([(0, d.watch)("state.text")], o.prototype, "onChangeTextSetMode", null), n.__decorate([(0, d.watch)("state.disabled")], o.prototype, "onChangeDisabled", null), n.__decorate([(0, d.watch)("state.activated")], o.prototype, "onChangeActivated", null), n.__decorate([(0, d.watch)("state.name")], o.prototype, "onChangeName", null), n.__decorate([(0, d.watch)("state.tooltip")], o.prototype, "onChangeTooltip", null), n.__decorate([(0, d.watch)("state.tabIndex")], o.prototype, "onChangeTabIndex", null), n.__decorate([(0, d.watch)("state.icon")], o.prototype, "onChangeIcon", null), n.__decorate([d.autobind], o.prototype, "onActionFire", null), n.__decorate([d.component], o);
            }(r.UIElement);
            t.UIButton = f, t.Button = function (e, t, o, n) {
              var r = new f(e);
              return r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, (0, s.isString)(t) ? (r.state.icon.name = t, r.state.name = t, n && (r.state.variant = n), o && (r.state.text = o)) : r.setState(t), r;
            };
          },
          67252: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIButtonGroup = void 0;
            var n = o(20255);
            o(45066);
            var r = o(61479),
              i = o(11441),
              a = o(96031),
              s = (o(52378), function (e) {
                function t(t, o) {
                  void 0 === o && (o = {
                    radio: !0
                  });
                  var n,
                    r,
                    i = this;
                  return (i = e.call(this, t, null === (n = o.options) || void 0 === n ? void 0 : n.map(function (e) {
                    var o = new a.UIButton(t, {
                      text: e.text,
                      value: e.value,
                      variant: "primary"
                    });
                    return o.onAction(function () {
                      i.select(e.value);
                    }), o;
                  }), o) || this).options = o, i.select(null !== (r = o.value) && void 0 !== r ? r : 0), i;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIButtonGroup";
                }, t.prototype.render = function (e) {
                  return '<div>\n\t\t\t<div class="&__label">~'.concat(e.label, '~</div>\n\t\t\t<div class="&__options"></div>\n\t\t</div>');
                }, t.prototype.appendChildToContainer = function (e) {
                  this.getElm("options").appendChild(e);
                }, t.prototype.select = function (e) {
                  var t,
                    o,
                    n = this;
                  this.elements.forEach(function (t, o) {
                    o === e || t.state.value === e ? t.state.activated = !0 : n.options.radio && (t.state.activated = !1);
                  });
                  var r = this.elements.filter(function (e) {
                    return e.state.activated;
                  }).map(function (e) {
                    return {
                      text: e.state.text,
                      value: e.state.value
                    };
                  });
                  this.jodit.e.fire(this, "select", r), null === (o = (t = this.options).onChange) || void 0 === o || o.call(t, r);
                }, n.__decorate([i.component], t);
              }(r.UIGroup));
            t.UIButtonGroup = s;
          },
          96516: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(96031), t), n.__exportStar(o(67252), t), n.__exportStar(o(33627), t);
          },
          33627: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UITooltip = void 0;
            var n = o(20255);
            o(99895);
            var r = o(40332),
              i = o(17332),
              a = o(43441),
              s = function (e) {
                function t(o) {
                  var n = e.call(this, o) || this;
                  n.__isOpened = !1, n.__useCount = 1, n.__delayShowTimeout = 0, (0, i.getContainer)(o, t).appendChild(n.container);
                  var r = 0;
                  return o.e.off(".tooltip").on("showTooltip.tooltip", function (e, t) {
                    o.async.clearTimeout(r), n.__open(e, t);
                  }).on("delayShowTooltip.tooltip", n.__delayOpen).on("escape.tooltip", n.__close).on("hideTooltip.tooltip change.tooltip scroll.tooltip changePlace.tooltip hidePopup.tooltip closeAllPopups.tooltip", function () {
                    n.j.async.clearTimeout(n.__delayShowTimeout), r = o.async.setTimeout(n.__close, n.j.defaultTimeout);
                  }), n;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UITooltip";
                }, t.make = function (e) {
                  var o = (0, r.dataBind)(e, "ui-tooltip");
                  return o ? (o.__useCount += 1, o) : (o = new t(e), (0, r.dataBind)(e, "ui-tooltip", o), o);
                }, t.prototype.__delayOpen = function (e, t) {
                  var o = this,
                    n = this.j.o.showTooltipDelay || this.j.defaultTimeout;
                  this.j.async.clearTimeout(this.__delayShowTimeout), this.__delayShowTimeout = this.j.async.setTimeout(function () {
                    return o.__open(e, t);
                  }, {
                    timeout: n,
                    label: "tooltip"
                  });
                }, t.prototype.__open = function (e, t) {
                  this.setMod("visible", !0), this.container.innerHTML = t, this.__isOpened = !0, this.__setPosition(e);
                }, t.prototype.__setPosition = function (e) {
                  var t = e();
                  (0, r.css)(this.container, {
                    left: t.x,
                    top: t.y
                  });
                }, t.prototype.__close = function () {
                  this.j.async.clearTimeout(this.__delayShowTimeout), this.__isOpened && (this.__isOpened = !1, this.setMod("visible", !1), (0, r.css)(this.container, {
                    left: -5e3
                  }));
                }, t.prototype.destruct = function () {
                  var t;
                  this.__useCount--, this.__useCount || (null === (t = this.j) || void 0 === t || t.e.off(".tooltip"), this.__close(), e.prototype.destruct.call(this));
                }, n.__decorate([a.autobind], t.prototype, "__delayOpen", null), n.__decorate([a.autobind], t.prototype, "__close", null), t;
              }(o(53929).UIElement);
            t.UITooltip = s;
          },
          53929: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIElement = void 0;
            var n = o(20255),
              r = o(56562),
              i = o(24263),
              a = o(59829),
              s = o(24421),
              l = o(77904),
              c = o(43441),
              u = function (e) {
                function t(t, o) {
                  var n = e.call(this, t) || this;
                  return n.name = "", n.__parentElement = null, n.mods = {}, n.container = n.createContainer(o), Object.defineProperty(n.container, "component", {
                    value: n,
                    configurable: !0
                  }), n;
                }
                var o;
                return n.__extends(t, e), o = t, Object.defineProperty(t.prototype, "parentElement", {
                  get: function () {
                    return this.__parentElement;
                  },
                  set: function (e) {
                    var t = this;
                    this.__parentElement = e, e && e.hookStatus("beforeDestruct", function () {
                      return t.destruct();
                    }), this.updateParentElement(this);
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.bubble = function (e) {
                  for (var t = this.parentElement; t;) e(t), t = t.parentElement;
                  return this;
                }, t.prototype.updateParentElement = function (e) {
                  var t;
                  return null === (t = this.__parentElement) || void 0 === t || t.updateParentElement(e), this;
                }, t.prototype.get = function (t, o) {
                  return e.prototype.get.call(this, t, o) || this.getElm(t);
                }, t.prototype.closest = function (e) {
                  for (var t = "object" == typeof e ? function (t) {
                      return t === e;
                    } : function (t) {
                      return r.Component.isInstanceOf(t, e);
                    }, n = this.__parentElement; n;) {
                    if (t(n)) return n;
                    n = !n.parentElement && n.container.parentElement ? o.closestElement(n.container.parentElement, o) : n.parentElement;
                  }
                  return null;
                }, t.closestElement = function (e, t) {
                  var o = i.Dom.up(e, function (e) {
                    if (e) {
                      var o = e.component;
                      return o && r.Component.isInstanceOf(o, t);
                    }
                    return !1;
                  });
                  return o ? null == o ? void 0 : o.component : null;
                }, t.prototype.update = function () {}, t.prototype.appendTo = function (e) {
                  return e.appendChild(this.container), this;
                }, t.prototype.clearName = function (e) {
                  return e.replace(/[^a-zA-Z0-9]/g, "_");
                }, t.prototype.render = function (e) {
                  return this.j.c.div(this.componentName);
                }, t.prototype.createContainer = function (e) {
                  var t = this.render(e);
                  if ((0, s.isString)(t)) {
                    var o = this.parseTemplate(t);
                    return o.classList.add(this.componentName), o;
                  }
                  return t;
                }, t.prototype.parseTemplate = function (e) {
                  var t = this;
                  return this.j.c.fromHTML(e.replace(/\*([^*]+?)\*/g, function (e, t) {
                    return l.Icon.get(t) || "";
                  }).replace(/&__/g, this.componentName + "__").replace(/~([^~]+?)~/g, function (e, o) {
                    return t.i18n(o);
                  }));
                }, t.prototype.destruct = function () {
                  return i.Dom.safeRemove(this.container), this.parentElement = null, e.prototype.destruct.call(this);
                }, o = n.__decorate([(0, c.derive)(a.Mods, a.Elms)], t);
              }(r.ViewComponent);
            t.UIElement = u;
          },
          38318: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIBlock = void 0;
            var n = o(20255);
            o(87682);
            var r = o(61479),
              i = o(76502),
              a = o(11441),
              s = function (e) {
                function t(t, o, n) {
                  void 0 === n && (n = {
                    align: "left"
                  });
                  var r = e.call(this, t, o) || this;
                  return r.options = n, r.setMod("align", r.options.align || "left"), r.setMod("width", r.options.width || ""), r.options.mod && r.setMod(r.options.mod, !0), r.options.className && r.container.classList.add(r.options.className), (0, i.attr)(r.container, "data-ref", n.ref), (0, i.attr)(r.container, "ref", n.ref), r;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIBlock";
                }, n.__decorate([a.component], t);
              }(r.UIGroup);
            t.UIBlock = s;
          },
          26207: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIForm = void 0;
            var n = o(20255),
              r = o(61479),
              i = o(30194),
              a = o(75840),
              s = o(76502),
              l = o(11441),
              c = o(45113),
              u = function (e) {
                function t() {
                  for (var t = [], o = 0; arguments.length > o; o++) t[o] = arguments[o];
                  var r,
                    i,
                    a = this;
                  return (null === (r = (a = e.apply(this, n.__spreadArray([], n.__read(t), !1)) || this).options) || void 0 === r ? void 0 : r.className) && a.container.classList.add(null === (i = a.options) || void 0 === i ? void 0 : i.className), a;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIForm";
                }, t.prototype.submit = function () {
                  this.j.e.fire(this.container, "submit");
                }, t.prototype.validate = function () {
                  var e,
                    t,
                    o,
                    r,
                    s = this.allChildren.filter(function (e) {
                      return c.Component.isInstanceOf(e, i.UIInput);
                    });
                  try {
                    for (var l = n.__values(s), u = l.next(); !u.done; u = l.next()) if (!u.value.validate()) return !1;
                  } catch (t) {
                    e = {
                      error: t
                    };
                  } finally {
                    try {
                      u && !u.done && (t = l.return) && t.call(l);
                    } finally {
                      if (e) throw e.error;
                    }
                  }
                  var d = this.allChildren.filter(function (e) {
                    return c.Component.isInstanceOf(e, a.UISelect);
                  });
                  try {
                    for (var p = n.__values(d), f = p.next(); !f.done; f = p.next()) if (!f.value.validate()) return !1;
                  } catch (e) {
                    o = {
                      error: e
                    };
                  } finally {
                    try {
                      f && !f.done && (r = p.return) && r.call(p);
                    } finally {
                      if (o) throw o.error;
                    }
                  }
                  return !0;
                }, t.prototype.onSubmit = function (e) {
                  var t = this;
                  this.j.e.on(this.container, "submit", function () {
                    var o = t.allChildren.filter(function (e) {
                      return c.Component.isInstanceOf(e, i.UIInput);
                    });
                    return !!t.validate() && (e(o.reduce(function (e, t) {
                      return e[t.state.name] = t.value, e;
                    }, {})), !1);
                  });
                }, t.prototype.createContainer = function () {
                  var e = this.j.c.element("form");
                  return e.classList.add(this.componentName), (0, s.attr)(e, "dir", this.j.o.direction || "auto"), e;
                }, n.__decorate([l.component], t);
              }(r.UIGroup);
            t.UIForm = u;
          },
          95963: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(26207), t), n.__exportStar(o(63034), t), n.__exportStar(o(38318), t);
          },
          21639: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UITextArea = void 0;
            var n = o(20255);
            o(50905);
            var r = o(30194),
              i = o(11441),
              a = function (e) {
                function t(t, r) {
                  var i = e.call(this, t, r) || this;
                  return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), !1 === i.state.resizable && (i.nativeInput.style.resize = "none"), i;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "UITextArea";
                }, t.prototype.createContainer = function (t) {
                  return this.nativeInput = this.j.create.element("textarea"), e.prototype.createContainer.call(this, t);
                }, t.defaultState = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                  size: 5,
                  resizable: !0
                }), o = n.__decorate([i.component], t);
              }(r.UIInput);
            t.UITextArea = a;
          },
          63747: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UICheckbox = void 0;
            var n = o(20255);
            o(70446);
            var r = o(30194),
              i = o(43441),
              a = o(24263),
              s = function (e) {
                function t(t, r) {
                  var i = e.call(this, t, n.__assign(n.__assign({}, r), {
                    type: "checkbox"
                  })) || this;
                  return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), i;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "UICheckbox";
                }, t.prototype.render = function () {
                  return this.j.c.element("label", {
                    className: this.componentName
                  });
                }, t.prototype.onChangeChecked = function () {
                  this.value = this.state.checked.toString(), this.nativeInput.checked = this.state.checked, this.setMod("checked", this.state.checked);
                }, t.prototype.onChangeNativeCheckBox = function () {
                  this.state.checked = this.nativeInput.checked;
                }, t.prototype.onChangeSwitch = function () {
                  this.setMod("switch", this.state.switch);
                  var e = this.getElm("switch-slider");
                  this.state.switch ? (e || (e = this.j.c.div(this.getFullElName("switch-slider"))), a.Dom.after(this.nativeInput, e)) : a.Dom.safeRemove(e);
                }, t.defaultState = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                  checked: !1,
                  switch: !1
                }), n.__decorate([(0, i.watch)("state.checked"), (0, i.hook)("ready")], t.prototype, "onChangeChecked", null), n.__decorate([(0, i.watch)("nativeInput:change")], t.prototype, "onChangeNativeCheckBox", null), n.__decorate([(0, i.watch)("state.switch"), (0, i.hook)("ready")], t.prototype, "onChangeSwitch", null), o = n.__decorate([i.component], t);
              }(r.UIInput);
            t.UICheckbox = s;
          },
          41374: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIFileInput = void 0;
            var n = o(20255);
            o(18984);
            var r = o(30194),
              i = o(11441),
              a = o(96031),
              s = function (e) {
                function t(t, o) {
                  var i = e.call(this, t, n.__assign({
                    type: "file"
                  }, o)) || this;
                  return i.state = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                    type: "file",
                    onlyImages: !0
                  }), i;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIFileInput";
                }, t.prototype.createContainer = function (e) {
                  this.button = new a.UIButton(this.j, {
                    icon: {
                      name: "plus"
                    }
                  });
                  var t = this.button.container;
                  this.nativeInput || (this.nativeInput = this.createNativeInput(e));
                  var o = this.nativeInput;
                  return o.classList.add(this.getFullElName("input")), t.classList.add(this.componentName), t.appendChild(o), t;
                }, t.prototype.createNativeInput = function (e) {
                  return this.j.create.fromHTML('<input\n\t\t\ttype="file"\n\t\t\taccept="'.concat(e.onlyImages ? "image/*" : "*", '"\n\t\t\ttabindex="-1"\n\t\t\tdir="auto"\n\t\t\tmultiple=""\n\t\t/>'));
                }, n.__decorate([i.component], t);
              }(r.UIInput);
            t.UIFileInput = s;
          },
          63034: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(30194), t), n.__exportStar(o(21639), t), n.__exportStar(o(63747), t), n.__exportStar(o(75840), t), n.__exportStar(o(41374), t);
          },
          30194: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIInput = void 0;
            var n = o(20255);
            o(4591);
            var r = o(53929),
              i = o(76502),
              a = o(1853),
              s = o(24263),
              l = o(43441),
              c = o(77904),
              u = o(60081),
              d = function (e) {
                function t(t, r) {
                  var i = e.call(this, t, r) || this;
                  return i.label = i.j.c.span(i.getFullElName("label")), i.icon = i.j.c.span(i.getFullElName("icon")), i.clearButton = i.j.c.span(i.getFullElName("clear"), c.Icon.get("cancel")), i.state = n.__assign({}, o.defaultState), i.__errorBox = i.j.c.span(i.getFullElName("error")), i.validators = new Set([]), void 0 !== (null == r ? void 0 : r.value) && (r.value = r.value.toString()), Object.assign(i.state, r), void 0 !== i.state.clearButton && (i.j.e.on(i.clearButton, "click", function (e) {
                    e.preventDefault(), i.nativeInput.value = "", i.j.e.fire(i.nativeInput, "input"), i.focus();
                  }).on(i.nativeInput, "input", function () {
                    i.state.clearButton = Boolean(i.value.length);
                  }), i.state.clearButton = Boolean(i.value.length)), i.j.e.on(i.nativeInput, "focus blur", function () {
                    i.onChangeFocus();
                  }).on(i.nativeInput, "input change", i.onChangeValue), i.onChangeState(), i.onChangeClassName(), i.onChangeStateValue(), i;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "UIInput";
                }, t.prototype.onChangeClear = function () {
                  this.state.clearButton ? s.Dom.after(this.nativeInput, this.clearButton) : s.Dom.safeRemove(this.clearButton);
                }, t.prototype.onChangeClassName = function (e, t) {
                  t && this.container.classList.remove(t), this.state.className && this.container.classList.add(this.state.className);
                }, t.prototype.onChangeState = function () {
                  this.name = this.state.name;
                  var e = this.nativeInput,
                    t = this.state,
                    o = t.name,
                    n = t.icon,
                    r = t.type,
                    a = t.ref,
                    l = t.required,
                    u = t.placeholder,
                    d = t.autocomplete,
                    p = t.label;
                  (0, i.attr)(e, "name", o), (0, i.attr)(e, "type", r), (0, i.attr)(e, "data-ref", a || o), (0, i.attr)(e, "ref", a || o), (0, i.attr)(e, "required", l || null), (0, i.attr)(e, "autocomplete", d ? null : "off"), (0, i.attr)(e, "placeholder", u ? this.j.i18n(u) : ""), n && c.Icon.exists(n) ? (s.Dom.before(e, this.icon), this.icon.innerHTML = c.Icon.get(n)) : s.Dom.safeRemove(this.icon), p ? (s.Dom.before(this.wrapper, this.label), this.label.innerText = this.j.i18n(p)) : s.Dom.safeRemove(this.label), this.updateValidators();
                }, t.prototype.updateValidators = function () {
                  var e,
                    t = this;
                  this.validators.clear(), this.state.required && this.validators.add(u.inputValidators.required), null === (e = this.state.validators) || void 0 === e || e.forEach(function (e) {
                    var o = u.inputValidators[e];
                    o && t.validators.add(o);
                  });
                }, Object.defineProperty(t.prototype, "error", {
                  set: function (e) {
                    this.setMod("has-error", Boolean(e)), e ? (this.__errorBox.innerText = this.j.i18n(e, this.j.i18n(this.state.label || "")), this.container.appendChild(this.__errorBox)) : s.Dom.safeRemove(this.__errorBox);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "value", {
                  get: function () {
                    return this.nativeInput.value;
                  },
                  set: function (e) {
                    this.value !== e && (this.nativeInput.value = e, this.onChangeValue());
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.onChangeStateValue = function () {
                  var e = this.state.value.toString();
                  e !== this.value && (this.value = e);
                }, t.prototype.onChangeValue = function () {
                  var e,
                    t,
                    o = this.value;
                  this.state.value !== o && (this.state.value = o, this.j.e.fire(this, "change", o), null === (t = (e = this.state).onChange) || void 0 === t || t.call(e, o));
                }, t.prototype.validate = function () {
                  var e = this;
                  return this.error = "", (0, a.toArray)(this.validators).every(function (t) {
                    return t(e);
                  });
                }, t.prototype.createContainer = function (t) {
                  var o = e.prototype.createContainer.call(this);
                  this.wrapper = this.j.c.div(this.getFullElName("wrapper")), this.nativeInput || (this.nativeInput = this.createNativeInput());
                  var n = this.nativeInput;
                  return n.classList.add(this.getFullElName("input")), this.wrapper.appendChild(n), o.appendChild(this.wrapper), (0, i.attr)(n, "dir", this.j.o.direction || "auto"), o;
                }, t.prototype.createNativeInput = function (e) {
                  return this.j.create.element("input");
                }, t.prototype.focus = function () {
                  this.nativeInput.focus();
                }, Object.defineProperty(t.prototype, "isFocused", {
                  get: function () {
                    return this.nativeInput === this.j.od.activeElement;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.onChangeFocus = function () {
                  this.setMod("focused", this.isFocused);
                }, t.defaultState = {
                  className: "",
                  autocomplete: !0,
                  name: "",
                  value: "",
                  icon: "",
                  label: "",
                  ref: "",
                  type: "text",
                  placeholder: "",
                  required: !1,
                  validators: []
                }, n.__decorate([(0, l.watch)("state.clearButton")], t.prototype, "onChangeClear", null), n.__decorate([(0, l.watch)("state.className")], t.prototype, "onChangeClassName", null), n.__decorate([(0, l.watch)(["state.name", "state.type", "state.label", "state.placeholder", "state.autocomplete", "state.icon"]), (0, l.debounce)()], t.prototype, "onChangeState", null), n.__decorate([(0, l.watch)("state.value")], t.prototype, "onChangeStateValue", null), n.__decorate([l.autobind], t.prototype, "onChangeValue", null), o = n.__decorate([l.component], t);
              }(r.UIElement);
            t.UIInput = d;
          },
          75840: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UISelect = void 0;
            var n = o(20255);
            o(64194);
            var r = o(67309),
              i = o(11441),
              a = o(30194),
              s = o(60081),
              l = function (e) {
                function t(t, r) {
                  var i = e.call(this, t, r) || this;
                  return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), i;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "UISelect";
                }, t.prototype.createContainer = function (t) {
                  var o,
                    n = e.prototype.createContainer.call(this, t),
                    i = this.j,
                    a = this.nativeInput,
                    s = function () {
                      return i.create.element("option");
                    };
                  if (void 0 !== t.placeholder) {
                    var l = s();
                    l.value = "", l.text = i.i18n(t.placeholder), a.add(l);
                  }
                  return null === (o = t.options) || void 0 === o || o.forEach(function (e) {
                    var t = s();
                    t.value = e.value.toString(), t.text = i.i18n(e.text), a.add(t);
                  }), t.size && t.size > 0 && (0, r.attr)(a, "size", t.size), t.multiple && (0, r.attr)(a, "multiple", ""), n;
                }, t.prototype.createNativeInput = function () {
                  return this.j.create.element("select");
                }, t.prototype.updateValidators = function () {
                  e.prototype.updateValidators.call(this), this.state.required && (this.validators.delete(s.inputValidators.required), this.validators.add(s.selectValidators.required));
                }, t.defaultState = n.__assign(n.__assign({}, a.UIInput.defaultState), {
                  options: [],
                  size: 1,
                  multiple: !1
                }), o = n.__decorate([i.component], t);
              }(a.UIInput);
            t.UISelect = l;
          },
          60081: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.selectValidators = t.inputValidators = void 0, t.inputValidators = o(63355), t.selectValidators = o(65935);
          },
          63355: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.url = t.required = void 0;
            var n = o(64350),
              r = o(33941);
            t.required = function (e) {
              return !!(0, r.trim)(e.value).length || (e.error = "Please fill out this field", !1);
            }, t.url = function (e) {
              return !!(0, n.isURL)((0, r.trim)(e.value)) || (e.error = "Please enter a web address", !1);
            };
          },
          65935: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.required = void 0;
            var n = o(33941);
            t.required = function (e) {
              return !!(0, n.trim)(e.value).length || (e.error = "Please fill out this field", !1);
            };
          },
          61479: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIGroup = void 0;
            var n = o(20255);
            o(70375);
            var r = o(53929),
              i = o(43441),
              a = o(40332),
              s = (o(52378), o(24263)),
              l = o(45113),
              c = function (e) {
                function t(t, o, n) {
                  var r = e.call(this, t, n) || this;
                  return r.options = n, r.syncMod = !1, r.elements = [], r.buttonSize = "middle", null == o || o.forEach(function (e) {
                    return e && r.append(e);
                  }), (null == n ? void 0 : n.name) && (r.name = n.name), r;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "UIGroup";
                }, Object.defineProperty(t.prototype, "allChildren", {
                  get: function () {
                    for (var e = [], t = n.__spreadArray([], n.__read(this.elements), !1); t.length;) {
                      var r = t.shift();
                      (0, a.isArray)(r) ? t.push.apply(t, n.__spreadArray([], n.__read(r), !1)) : l.Component.isInstanceOf(r, o) ? t.push.apply(t, n.__spreadArray([], n.__read(r.elements), !1)) : r && e.push(r);
                    }
                    return e;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.update = function () {
                  this.elements.forEach(function (e) {
                    return e.update();
                  }), this.setMod("size", this.buttonSize);
                }, t.prototype.append = function (e, t) {
                  var o = this;
                  return (0, a.isArray)(e) ? (e.forEach(function (e) {
                    return o.append(e, t);
                  }), this) : (this.elements.push(e), e.name && e.container.classList.add(this.getFullElName(e.name)), t ? this.getElm(t).appendChild(e.container) : this.appendChildToContainer(e.container), e.parentElement = this, e.update(), this);
                }, t.prototype.afterSetMod = function (e, t) {
                  this.syncMod && this.elements.forEach(function (o) {
                    return o.setMod(e, t);
                  });
                }, t.prototype.appendChildToContainer = function (e) {
                  this.container.appendChild(e);
                }, t.prototype.remove = function (e) {
                  var t = this.elements.indexOf(e);
                  return -1 !== t && (this.elements.splice(t, 1), s.Dom.safeRemove(e.container), e.parentElement = null), this;
                }, t.prototype.clear = function () {
                  return this.elements.forEach(function (e) {
                    return e.destruct();
                  }), this.elements.length = 0, this;
                }, t.prototype.destruct = function () {
                  return this.clear(), e.prototype.destruct.call(this);
                }, n.__decorate([(0, i.watch)("buttonSize")], t.prototype, "update", null), o = n.__decorate([i.component], t);
              }(r.UIElement);
            t.UIGroup = c;
          },
          3249: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(61479), t), n.__exportStar(o(47970), t), n.__exportStar(o(75018), t), n.__exportStar(o(58495), t);
          },
          47970: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIList = void 0;
            var n = o(20255);
            o(90235);
            var r = o(32070),
              i = o(43441),
              a = o(61479),
              s = o(75018),
              l = o(58495),
              c = o(96031),
              u = o(97642),
              d = o(38546),
              p = o(14556),
              f = o(45113),
              h = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  return o.mode = "horizontal", o.removeButtons = [], o.onChangeMode(), o;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIList";
                }, t.prototype.onChangeMode = function () {
                  this.setMod("mode", this.mode);
                }, t.prototype.makeGroup = function () {
                  return new a.UIGroup(this.jodit);
                }, Object.defineProperty(t.prototype, "buttons", {
                  get: function () {
                    return this.allChildren.filter(function (e) {
                      return f.Component.isInstanceOf(e, c.UIButton);
                    });
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.getButtonsNames = function () {
                  return this.buttons.map(function (e) {
                    return e instanceof c.UIButton && e.state.name || "";
                  }).filter(function (e) {
                    return "" !== e;
                  });
                }, t.prototype.setRemoveButtons = function (e) {
                  return this.removeButtons = e || [], this;
                }, t.prototype.build = function (e, t) {
                  var o = this;
                  void 0 === t && (t = null), e = (0, p.splitArray)(e), this.clear();
                  var n,
                    i = !1,
                    a = this.makeGroup();
                  this.append(a), a.setMod("line", !0);
                  var c = function (e) {
                      var r = null;
                      switch (e.name) {
                        case "\n":
                          (a = o.makeGroup()).setMod("line", !0), n = o.makeGroup(), a.append(n), o.append(a);
                          break;
                        case "|":
                          i || (i = !0, r = new s.UISeparator(o.j));
                          break;
                        case "---":
                          n.setMod("before-spacer", !0);
                          var c = new l.UISpacer(o.j);
                          a.append(c), n = o.makeGroup(), a.append(n), i = !1;
                          break;
                        default:
                          i = !1, r = o.makeButton(e, t);
                      }
                      r && (n || (n = o.makeGroup(), a.append(n)), n.append(r));
                    },
                    f = function (e) {
                      return !o.removeButtons.includes(e.name);
                    };
                  return e.forEach(function (e) {
                    if ((0, u.isButtonGroup)(e)) {
                      var t = e.buttons.filter(function (e) {
                        return e;
                      });
                      t.length && ((n = o.makeGroup()).setMod("separated", !0).setMod("group", e.group), a.append(n), (0, r.getStrongControlTypes)(t, o.j.o.controls).filter(f).forEach(c));
                    } else {
                      n || (n = o.makeGroup(), a.append(n));
                      var i = (0, d.getControlType)(e, o.j.o.controls);
                      f(i) && c(i);
                    }
                  }), this.update(), this;
                }, t.prototype.makeButton = function (e, t) {
                  return new c.UIButton(this.j);
                }, n.__decorate([(0, i.watch)("mode")], t.prototype, "onChangeMode", null), n.__decorate([i.component], t);
              }(a.UIGroup);
            t.UIList = h;
          },
          75018: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UISeparator = void 0;
            var n = o(20255),
              r = o(53929),
              i = o(11441),
              a = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UISeparator";
                }, n.__decorate([i.component], t);
              }(r.UIElement);
            t.UISeparator = a;
          },
          58495: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UISpacer = void 0;
            var n = o(20255),
              r = o(53929),
              i = o(11441),
              a = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UISpacer";
                }, n.__decorate([i.component], t);
              }(r.UIElement);
            t.UISpacer = a;
          },
          97642: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.flatButtonsSet = t.isButtonGroup = void 0;
            var n = o(20255),
              r = o(49781);
            t.isButtonGroup = function (e) {
              return (0, r.isArray)(e.buttons);
            }, t.flatButtonsSet = function (e, o) {
              var r = o.getRegisteredButtonGroups();
              return new Set(e.reduce(function (e, o) {
                var i;
                return (0, t.isButtonGroup)(o) ? e = e.concat(n.__spreadArray(n.__spreadArray([], n.__read(o.buttons), !1), n.__read(null !== (i = r[o.group]) && void 0 !== i ? i : []), !1)) : e.push(o), e;
              }, []));
            };
          },
          38546: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.findControlType = t.getControlType = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(93166);
            function a(e, t) {
              var o = n.__read(e.split(/\./), 2),
                i = o[0],
                a = o[1],
                s = t;
              return null != a ? void 0 !== t[i] && (s = t[i]) : a = i, s[a] ? n.__assign({
                name: a
              }, (0, r.ConfigFlatten)(s[a])) : void 0;
            }
            t.getControlType = function (e, t) {
              var o;
              return t || (t = i.Config.defaultOptions.controls), (0, r.isString)(e) ? o = a(e, t) || {
                name: e,
                command: e,
                tooltip: e
              } : void 0 !== t[(o = n.__assign({
                name: "empty"
              }, (0, r.ConfigFlatten)(e))).name] && (o = n.__assign(n.__assign({}, (0, r.ConfigFlatten)(t[o.name])), (0, r.ConfigFlatten)(o))), o;
            }, t.findControlType = a;
          },
          32070: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getStrongControlTypes = void 0;
            var n = o(38546),
              r = o(93166),
              i = o(49781),
              a = o(76502);
            t.getStrongControlTypes = function (e, t) {
              return ((0, i.isArray)(e) ? e : (0, a.keys)(e, !1).map(function (t) {
                return (0, a.ConfigProto)({
                  name: t
                }, e[t] || {});
              })).map(function (e) {
                return (0, n.getControlType)(e, t || r.Config.defaultOptions.controls);
              });
            };
          },
          77904: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Icon = void 0;
            var n = o(26911),
              r = o(40332),
              i = function () {
                function e() {}
                return e.getIcon = function (t) {
                  return /<svg/i.test(t) ? t : e.icons[t] || e.icons[t.replace(/-/g, "_")] || e.icons[t.replace(/_/g, "-")] || e.icons[(0, r.camelCase)(t)] || e.icons[(0, r.kebabCase)(t)] || e.icons[t.toLowerCase()];
                }, e.exists = function (e) {
                  return void 0 !== this.getIcon(e);
                }, e.get = function (e, t) {
                  return void 0 === t && (t = "<span></span>"), this.getIcon(e) || t;
                }, e.set = function (e, t) {
                  return this.icons[e.replace("_", "-")] = t, this;
                }, e.makeIcon = function (t, o) {
                  var r, i;
                  if (o) {
                    var a = o.name.replace(/[^a-zA-Z0-9]/g, "_");
                    if (o.iconURL) i = t.c.span(), (0, n.css)(i, "backgroundImage", "url(" + o.iconURL.replace("{basePath}", (null == t ? void 0 : t.basePath) || "") + ")");else {
                      var s = t.e.fire("getIcon", o.name, o, a) || e.get(o.name, "") || (null === (r = t.o.extraIcons) || void 0 === r ? void 0 : r[o.name]);
                      s && (i = t.c.fromHTML(s.trim()), /^<svg/i.test(o.name) || i.classList.add("jodit-icon_" + a));
                    }
                  }
                  return i && (i.classList.add("jodit-icon"), i.style.fill = o.fill), i;
                }, e.icons = {}, e;
              }();
            t.Icon = i;
          },
          2074: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(53929), t), n.__exportStar(o(96516), t), n.__exportStar(o(35799), t), n.__exportStar(o(3249), t), n.__exportStar(o(95963), t), n.__exportStar(o(77904), t), n.__exportStar(o(63682), t);
          },
          35799: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(12680), t);
          },
          12680: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Popup = void 0;
            var n = o(20255);
            o(88477);
            var r = o(24263),
              i = o(40332),
              a = (o(52378), o(53929)),
              s = o(43441),
              l = o(45113),
              c = o(17332),
              u = function (e) {
                function t(t, o) {
                  void 0 === o && (o = !0);
                  var n = e.call(this, t) || this;
                  return n.smart = o, n.isOpened = !1, n.strategy = "leftBottom", n.viewBound = function () {
                    return {
                      left: 0,
                      top: 0,
                      width: n.ow.innerWidth,
                      height: n.ow.innerHeight
                    };
                  }, n.childrenPopups = new Set(), (0, i.attr)(n.container, "role", "popup"), n;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "Popup";
                }, t.prototype.updateParentElement = function (o) {
                  var n = this;
                  return o !== this && l.Component.isInstanceOf(o, t) && (this.childrenPopups.forEach(function (e) {
                    !o.closest(e) && e.isOpened && e.close();
                  }), this.childrenPopups.has(o) || this.j.e.on(o, "beforeClose", function () {
                    n.childrenPopups.delete(o);
                  }), this.childrenPopups.add(o)), e.prototype.updateParentElement.call(this, o);
                }, t.prototype.setContent = function (e) {
                  r.Dom.detach(this.container);
                  var t,
                    o = this.j.c.div("".concat(this.componentName, "__content"));
                  return l.Component.isInstanceOf(e, a.UIElement) ? (t = e.container, e.parentElement = this) : t = (0, i.isString)(e) ? this.j.c.fromHTML(e) : e, o.appendChild(t), this.container.appendChild(o), this.updatePosition(), this;
                }, t.prototype.open = function (e, o, n) {
                  if (void 0 === o && (o = !1), (0, i.markOwner)(this.jodit, this.container), this.calculateZIndex(), this.isOpened = !0, this.addGlobalListeners(), this.targetBound = o ? this.getKeepBound(e) : e, n) n.appendChild(this.container);else {
                    var r = (0, c.getContainer)(this.jodit, t);
                    n !== this.container.parentElement && r.appendChild(this.container);
                  }
                  return this.updatePosition(), this.j.e.fire(this, "afterOpen"), this;
                }, t.prototype.calculateZIndex = function () {
                  var e = this;
                  if (!this.container.style.zIndex) {
                    var t = function (t) {
                        var o = t.container.style.zIndex || t.o.zIndex;
                        return !!o && (e.setZIndex(1 + parseInt(o.toString(), 10)), !0);
                      },
                      o = this.j;
                    if (!t(o)) for (var n = this.parentElement; n;) {
                      if (t(o)) return;
                      if (n.container.style.zIndex) return void this.setZIndex(1 + parseInt(n.container.style.zIndex.toString(), 10));
                      if (!n.parentElement && n.container.parentElement) {
                        var r = a.UIElement.closestElement(n.container.parentElement, a.UIElement);
                        if (r) {
                          n = r;
                          continue;
                        }
                      }
                      n = n.parentElement;
                    }
                  }
                }, t.prototype.getKeepBound = function (e) {
                  var t = this,
                    o = e(),
                    a = this.od.elementFromPoint(o.left, o.top);
                  if (!a) return e;
                  var s = r.Dom.isHTMLElement(a) ? a : a.parentElement,
                    l = (0, i.position)(s, this.j);
                  return function () {
                    var o = e(),
                      r = (0, i.position)(s, t.j);
                    return n.__assign(n.__assign({}, o), {
                      top: o.top + (r.top - l.top),
                      left: o.left + (r.left - l.left)
                    });
                  };
                }, t.prototype.updatePosition = function () {
                  if (!this.isOpened) return this;
                  var e = n.__read(this.calculatePosition(this.targetBound(), this.viewBound(), (0, i.position)(this.container, this.j)), 2),
                    t = e[0];
                  return this.setMod("strategy", e[1]), (0, i.css)(this.container, {
                    left: t.left,
                    top: t.top
                  }), this.childrenPopups.forEach(function (e) {
                    return e.updatePosition();
                  }), this;
                }, t.prototype.throttleUpdatePosition = function () {
                  this.updatePosition();
                }, t.prototype.calculatePosition = function (e, o, r, a) {
                  void 0 === a && (a = this.strategy);
                  var s = {
                      left: e.left,
                      right: e.left - (r.width - e.width)
                    },
                    l = {
                      bottom: e.top + e.height,
                      top: e.top - r.height
                    },
                    c = Object.keys(s).reduce(function (e, t) {
                      return e.concat(Object.keys(l).map(function (e) {
                        return "".concat(t).concat((0, i.ucfirst)(e));
                      }));
                    }, []),
                    u = function (e) {
                      var t = n.__read((0, i.kebabCase)(e).split("-"), 2);
                      return {
                        left: s[t[0]],
                        top: l[t[1]],
                        width: r.width,
                        height: r.height
                      };
                    },
                    d = function (e) {
                      return t.boxInView(u(a), e) ? a : c.find(function (o) {
                        if (t.boxInView(u(o), e)) return o;
                      }) || null;
                    },
                    p = d((0, i.position)(this.j.container, this.j));
                  return p && t.boxInView(u(p), o) || (p = d(o) || p || a), [u(p), p];
                }, t.boxInView = function (e, t) {
                  return !(-2 > e.top - t.top || -2 > e.left - t.left || -2 > t.top + t.height - (e.top + e.height) || -2 > t.left + t.width - (e.left + e.width));
                }, t.prototype.close = function () {
                  return this.isOpened ? (this.isOpened = !1, this.childrenPopups.forEach(function (e) {
                    return e.close();
                  }), this.j.e.fire(this, "beforeClose"), this.j.e.fire("beforePopupClose", this), this.removeGlobalListeners(), r.Dom.safeRemove(this.container), this) : this;
                }, t.prototype.closeOnOutsideClick = function (e) {
                  this.isOpened && !this.isOwnClick(e) && this.close();
                }, t.prototype.isOwnClick = function (e) {
                  if (!e.target) return !1;
                  var o = a.UIElement.closestElement(e.target, t);
                  return Boolean(o && (this === o || o.closest(this)));
                }, t.prototype.addGlobalListeners = function () {
                  var e = this,
                    t = this.throttleUpdatePosition,
                    o = this.ow;
                  c.eventEmitter.on("closeAllPopups", this.close), this.smart && this.j.e.on("escape", this.close).on("mousedown touchstart", this.closeOnOutsideClick).on(o, "mousedown touchstart", this.closeOnOutsideClick), this.j.e.on("closeAllPopups", this.close).on("resize", t).on(this.container, "scroll mousewheel", t).on(o, "scroll", t).on(o, "resize", t), r.Dom.up(this.j.container, function (o) {
                    o && e.j.e.on(o, "scroll mousewheel", t);
                  });
                }, t.prototype.removeGlobalListeners = function () {
                  var e = this,
                    t = this.throttleUpdatePosition,
                    o = this.ow;
                  c.eventEmitter.off("closeAllPopups", this.close), this.smart && this.j.e.off("escape", this.close).off("mousedown touchstart", this.closeOnOutsideClick).off(o, "mousedown touchstart", this.closeOnOutsideClick), this.j.e.off("closeAllPopups", this.close).off("resize", t).off(this.container, "scroll mousewheel", t).off(o, "scroll", t).off(o, "resize", t), r.Dom.up(this.j.container, function (o) {
                    o && e.j.e.off(o, "scroll mousewheel", t);
                  });
                }, t.prototype.setZIndex = function (e) {
                  this.container.style.zIndex = e.toString();
                }, t.prototype.destruct = function () {
                  return this.close(), e.prototype.destruct.call(this);
                }, n.__decorate([s.autobind], t.prototype, "updatePosition", null), n.__decorate([(0, s.throttle)(10), s.autobind], t.prototype, "throttleUpdatePosition", null), n.__decorate([s.autobind], t.prototype, "close", null), n.__decorate([s.autobind], t.prototype, "closeOnOutsideClick", null), t;
              }(a.UIElement);
            t.Popup = u;
          },
          63682: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ProgressBar = void 0;
            var n = o(20255);
            o(50197);
            var r = o(24263),
              i = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ProgressBar";
                }, t.prototype.render = function () {
                  return "<div><div></div></div>";
                }, t.prototype.show = function () {
                  return (this.j.workplace || this.j.container).appendChild(this.container), this;
                }, t.prototype.hide = function () {
                  return r.Dom.safeRemove(this.container), this;
                }, t.prototype.progress = function (e) {
                  return this.container.style.width = e.toFixed(2) + "%", this;
                }, t.prototype.destruct = function () {
                  return this.hide(), e.prototype.destruct.call(this);
                }, t;
              }(o(53929).UIElement);
            t.ProgressBar = i;
          },
          43608: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ViewWithToolbar = void 0;
            var n = o(20255);
            o(39008);
            var r = o(75902),
              i = o(40332),
              a = o(64968),
              s = o(81438),
              l = o(56562),
              c = o(97642),
              u = o(43441),
              d = function (e) {
                function t(t, o) {
                  void 0 === o && (o = !1);
                  var n = e.call(this, t, o) || this;
                  return n.toolbar = (0, s.makeCollection)(n), n.defaultToolbarContainer = n.c.div("jodit-toolbar__box"), n.registeredButtons = new Set(), n.groupToButtons = {}, n.isJodit = !1, n.isJodit = o, n.e.on("beforeToolbarBuild", n.beforeToolbarBuild), n;
                }
                return n.__extends(t, e), Object.defineProperty(t.prototype, "toolbarContainer", {
                  get: function () {
                    return this.o.fullsize || !(0, i.isString)(this.o.toolbar) && !a.Dom.isHTMLElement(this.o.toolbar) ? (this.o.toolbar && a.Dom.appendChildFirst(this.container, this.defaultToolbarContainer), this.defaultToolbarContainer) : (0, i.resolveElement)(this.o.toolbar, this.o.shadowRoot || this.od);
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.setPanel = function (e) {
                  this.o.toolbar = e, this.buildToolbar();
                }, t.prototype.buildToolbar = function () {
                  if (this.o.toolbar) {
                    var e = this.o.buttons ? (0, i.splitArray)(this.o.buttons) : [];
                    this.toolbar.setRemoveButtons(this.o.removeButtons).build(e.concat(this.o.extraButtons || [])).appendTo(this.toolbarContainer);
                  }
                }, t.prototype.getRegisteredButtonGroups = function () {
                  return this.groupToButtons;
                }, t.prototype.registerButton = function (e) {
                  var t;
                  this.registeredButtons.add(e);
                  var o = null !== (t = e.group) && void 0 !== t ? t : "other";
                  return this.groupToButtons[o] || (this.groupToButtons[o] = []), null != e.position ? this.groupToButtons[o][e.position] = e.name : this.groupToButtons[o].push(e.name), this;
                }, t.prototype.unregisterButton = function (e) {
                  var t;
                  this.registeredButtons.delete(e);
                  var o = null !== (t = e.group) && void 0 !== t ? t : "other",
                    n = this.groupToButtons[o];
                  if (n) {
                    var r = n.indexOf(e.name);
                    -1 !== r && n.splice(r, 1), 0 === n.length && delete this.groupToButtons[o];
                  }
                  return this;
                }, t.prototype.beforeToolbarBuild = function (e) {
                  var t = this;
                  if (Object.keys(this.groupToButtons).length) return e.map(function (e) {
                    return (0, c.isButtonGroup)(e) && e.group && t.groupToButtons[e.group] ? {
                      group: e.group,
                      buttons: n.__spreadArray(n.__spreadArray([], n.__read(e.buttons), !1), n.__read(t.groupToButtons[e.group]), !1)
                    } : e;
                  });
                }, t.prototype.destruct = function () {
                  this.isDestructed || (this.setStatus(l.STATUSES.beforeDestruct), this.e.off("beforeToolbarBuild", this.beforeToolbarBuild), this.toolbar.destruct(), e.prototype.destruct.call(this));
                }, n.__decorate([u.autobind], t.prototype, "beforeToolbarBuild", null), t;
              }(r.View);
            t.ViewWithToolbar = d;
          },
          75902: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.View = void 0;
            var n = o(20255),
              r = o(77462),
              i = o(40332),
              a = o(86893),
              s = o(87837),
              l = o(17332),
              c = o(43441),
              u = o(59829),
              d = o(55395),
              p = o(71014),
              f = function (e) {
                function t(t, n) {
                  void 0 === n && (n = !1);
                  var i = e.call(this) || this;
                  return i.isJodit = n, i.isView = !0, i.parent = null, i.mods = {}, i.components = new Set(), i.version = "3.24.9", i.buffer = r.Storage.makeStorage(), i.storage = r.Storage.makeStorage(!0, i.componentName), i.OPTIONS = o.defaultOptions, i.__isFullSize = !1, i.__whoLocked = "", i.isLockedNotBy = function (e) {
                    return i.isLocked && i.__whoLocked !== e;
                  }, i.__modulesInstances = new Map(), i.id = new Date().getTime().toString(), i.buffer = r.Storage.makeStorage(), i.initOptions(t), i.initOwners(), i.events = new d.EventEmitter(i.od), i.create = new s.Create(i.od), i.container = i.c.div("jodit ".concat(i.componentName)), i.progressbar = new s.ProgressBar(i), i.message = new p.UIMessages(i, i.container), i;
                }
                var o;
                return n.__extends(t, e), o = t, Object.defineProperty(t.prototype, "basePath", {
                  get: function () {
                    return this.o.basePath ? this.o.basePath : a.BASE_PATH;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "defaultTimeout", {
                  get: function () {
                    return (0, i.isVoid)(this.o.defaultTimeout) ? 100 : this.o.defaultTimeout;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "c", {
                  get: function () {
                    return this.create;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "container", {
                  get: function () {
                    return this.__container;
                  },
                  set: function (e) {
                    this.__container = e;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "e", {
                  get: function () {
                    return this.events;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "options", {
                  get: function () {
                    return this.__options;
                  },
                  set: function (e) {
                    this.__options = e;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "o", {
                  get: function () {
                    return this.options;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.i18n = function (e) {
                  for (var t = [], o = 1; arguments.length > o; o++) t[o - 1] = arguments[o];
                  return (0, i.i18n)(e, t, this.options);
                }, t.prototype.toggleFullSize = function (e) {
                  void 0 === e && (e = !this.__isFullSize), e !== this.__isFullSize && (this.__isFullSize = e, this.e.fire("toggleFullSize", e));
                }, Object.defineProperty(t.prototype, "isLocked", {
                  get: function () {
                    return "" !== this.__whoLocked;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.lock = function (e) {
                  return void 0 === e && (e = "any"), !this.isLocked && (this.__whoLocked = e, !0);
                }, t.prototype.unlock = function () {
                  return !!this.isLocked && (this.__whoLocked = "", !0);
                }, Object.defineProperty(t.prototype, "isFullSize", {
                  get: function () {
                    return this.__isFullSize;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.getVersion = function () {
                  return "3.24.9";
                }, t.getVersion = function () {
                  return "3.24.9";
                }, t.prototype.initOptions = function (e) {
                  this.options = (0, i.ConfigProto)(e || {}, (0, i.ConfigProto)(this.options || {}, o.defaultOptions));
                }, t.prototype.initOwners = function () {
                  var e;
                  this.ownerWindow = null !== (e = this.o.ownerWindow) && void 0 !== e ? e : window;
                }, t.prototype.attachEvents = function (e) {
                  var t = this;
                  if (e) {
                    var o = null == e ? void 0 : e.events;
                    o && Object.keys(o).forEach(function (e) {
                      return t.e.on(e, o[e]);
                    });
                  }
                }, t.prototype.getInstance = function (e, t) {
                  var o = this.e.fire((0, i.camelCase)("getInstance_" + e), t);
                  if (o) return o;
                  var n = l.modules[e],
                    r = this.__modulesInstances;
                  if (!(0, i.isFunction)(n)) throw (0, i.error)("Need real module name");
                  if (!r.has(e)) {
                    var a = n.prototype instanceof s.ViewComponent ? new n(this, t) : new n(t);
                    this.components.add(a), r.set(e, a);
                  }
                  return r.get(e);
                }, t.prototype.addDisclaimer = function (e) {
                  this.container.appendChild(e);
                }, t.prototype.beforeDestruct = function () {
                  this.e.fire(s.STATUSES.beforeDestruct, this), this.components.forEach(function (e) {
                    (0, i.isDestructable)(e) && !e.isInDestruct && e.destruct();
                  }), this.components.clear();
                }, t.prototype.destruct = function () {
                  this.isDestructed || (this.progressbar.destruct(), this.message.destruct(), this.async && this.async.destruct(), this.events && this.e.destruct(), this.buffer && this.buffer.clear(), s.Dom.safeRemove(this.container), e.prototype.destruct.call(this));
                }, t.esNext = !1, n.__decorate([(0, c.hook)(s.STATUSES.beforeDestruct)], t.prototype, "beforeDestruct", null), o = n.__decorate([(0, c.derive)(u.Mods, u.Elms)], t);
              }(s.Component);
            t.View = f, f.defaultOptions = {
              extraButtons: [],
              textIcons: !1,
              namespace: "",
              removeButtons: [],
              zIndex: 100002,
              defaultTimeout: 100,
              fullsize: !1,
              showTooltip: !0,
              useNativeTooltip: !1,
              buttons: [],
              globalFullSize: !0,
              language: "auto"
            };
          },
          37920: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Jodit = void 0;
            var n = o(20255),
              r = o(93166),
              i = o(86893),
              a = o(87837),
              s = o(40332),
              l = o(77462),
              c = o(86893),
              u = o(17332),
              d = o(43441),
              p = o(59829),
              f = o(30056),
              h = "data-jodit-default-style-display",
              m = "data-jodit-default-classes",
              Jodit = function (e) {
                function Jodit(o, n) {
                  var r = e.call(this, n, !0) || this;
                  r.isJodit = !0, r.commands = new Map(), r.__selectionLocked = null, r.__wasReadOnly = !1, r.createInside = new a.Create(function () {
                    return r.ed;
                  }, r.o.createAttributes), r.editorIsActive = !1, r.__mode = i.MODE_WYSIWYG, r.__callChangeCount = 0, r.__isSilentChange = !1, r.__elementToPlace = new Map();
                  try {
                    var c = (0, s.resolveElement)(o, r.o.shadowRoot || r.od);
                    if (t.isJoditAssigned(c)) return c.component;
                  } catch (e) {
                    throw r.destruct(), e;
                  }
                  r.setStatus(a.STATUSES.beforeInit), r.id = (0, s.attr)((0, s.resolveElement)(o, r.o.shadowRoot || r.od), "id") || new Date().getTime().toString(), u.instances[r.id] = r, r.storage = l.Storage.makeStorage(!0, r.id), r.attachEvents(n), r.e.on(r.ow, "resize", function () {
                    r.e && r.e.fire("resize");
                  }), r.e.on("prepareWYSIWYGEditor", r.__prepareWYSIWYGEditor), r.selection = new a.Select(r);
                  var d = r.beforeInitHook();
                  return (0, s.callPromise)(d, function () {
                    r.e.fire("beforeInit", r), u.pluginSystem.__init(r), r.e.fire("afterPluginSystemInit", r), r.e.on("changePlace", function () {
                      r.setReadOnly(r.o.readonly), r.setDisabled(r.o.disabled);
                    }), r.places.length = 0;
                    var e = r.addPlace(o, n);
                    u.instances[r.id] = r, (0, s.callPromise)(e, function () {
                      r.e && r.e.fire("afterInit", r), r.afterInitHook(), r.setStatus(a.STATUSES.ready), r.e.fire("afterConstructor", r);
                    });
                  }), r;
                }
                var t;
                return n.__extends(Jodit, e), t = Jodit, Jodit.prototype.className = function () {
                  return "Jodit";
                }, Jodit.prototype.waitForReady = function () {
                  var e = this;
                  return this.isReady ? Promise.resolve(this) : this.async.promise(function (t) {
                    e.hookStatus("ready", function () {
                      return t(e);
                    });
                  });
                }, Object.defineProperty(Jodit, "ready", {
                  get: function () {
                    return new Promise(function (e) {
                      u.eventEmitter.on("oditready", e);
                    });
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "text", {
                  get: function () {
                    if (this.editor) return this.editor.innerText || "";
                    var e = this.createInside.div();
                    return e.innerHTML = this.getElementValue(), e.innerText || "";
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "defaultTimeout", {
                  get: function () {
                    return (0, s.isNumber)(this.o.defaultTimeout) ? this.o.defaultTimeout : r.Config.defaultOptions.defaultTimeout;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Jodit.atom = function (e) {
                  return (0, s.markAsAtomic)(e);
                }, Jodit.make = function (e, t) {
                  return new this(e, t);
                }, Jodit.isJoditAssigned = function (e) {
                  return e && (0, s.isJoditObject)(e.component) && !e.component.isInDestruct;
                }, Object.defineProperty(Jodit, "defaultOptions", {
                  get: function () {
                    return r.Config.defaultOptions;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Jodit.prototype.__setPlaceField = function (e, t) {
                  this.currentPlace || (this.currentPlace = {}, this.places = [this.currentPlace]), this.currentPlace[e] = t;
                }, Object.defineProperty(Jodit.prototype, "element", {
                  get: function () {
                    return this.currentPlace.element;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "editor", {
                  get: function () {
                    return this.currentPlace.editor;
                  },
                  set: function (e) {
                    this.__setPlaceField("editor", e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "container", {
                  get: function () {
                    return this.currentPlace.container;
                  },
                  set: function (e) {
                    this.__setPlaceField("container", e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "workplace", {
                  get: function () {
                    return this.currentPlace.workplace;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "statusbar", {
                  get: function () {
                    return this.currentPlace.statusbar;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "iframe", {
                  get: function () {
                    return this.currentPlace.iframe;
                  },
                  set: function (e) {
                    this.__setPlaceField("iframe", e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "history", {
                  get: function () {
                    return this.currentPlace.history;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "observer", {
                  get: function () {
                    return this.history;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "editorWindow", {
                  get: function () {
                    return this.currentPlace.editorWindow;
                  },
                  set: function (e) {
                    this.__setPlaceField("editorWindow", e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "ew", {
                  get: function () {
                    return this.editorWindow;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "editorDocument", {
                  get: function () {
                    return this.currentPlace.editorWindow.document;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "ed", {
                  get: function () {
                    return this.editorDocument;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "options", {
                  get: function () {
                    return this.currentPlace.options;
                  },
                  set: function (e) {
                    this.__setPlaceField("options", e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "s", {
                  get: function () {
                    return this.selection;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "uploader", {
                  get: function () {
                    return this.getInstance("Uploader", this.o.uploader);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "filebrowser", {
                  get: function () {
                    var e = this,
                      t = (0, s.ConfigProto)({
                        defaultTimeout: e.defaultTimeout,
                        uploader: e.o.uploader,
                        language: e.o.language,
                        license: e.o.license,
                        theme: e.o.theme,
                        shadowRoot: e.o.shadowRoot,
                        defaultCallback: function (t) {
                          t.files && t.files.length && t.files.forEach(function (o, n) {
                            var r = t.baseurl + o;
                            t.isImages && t.isImages[n] ? e.s.insertImage(r, null, e.o.imageDefaultWidth) : e.s.insertNode(e.createInside.fromHTML("<a href='".concat(r, "' title='").concat(r, "'>").concat(r, "</a>")));
                          });
                        }
                      }, this.o.filebrowser);
                    return e.getInstance("FileBrowser", t);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(Jodit.prototype, "mode", {
                  get: function () {
                    return this.__mode;
                  },
                  set: function (e) {
                    this.setMode(e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Jodit.prototype.getNativeEditorValue = function () {
                  var e = this.e.fire("beforeGetNativeEditorValue");
                  return (0, s.isString)(e) ? e : this.editor ? this.editor.innerHTML : this.getElementValue();
                }, Jodit.prototype.setNativeEditorValue = function (e) {
                  var t = {
                    value: e
                  };
                  this.e.fire("beforeSetNativeEditorValue", t) || this.editor && (this.editor.innerHTML = t.value);
                }, Object.defineProperty(Jodit.prototype, "value", {
                  get: function () {
                    return this.getEditorValue();
                  },
                  set: function (e) {
                    this.setEditorValue(e), this.history.__processChanges();
                  },
                  enumerable: !1,
                  configurable: !0
                }), Jodit.prototype.synchronizeValues = function () {
                  this.__imdSynchronizeValues();
                }, Jodit.prototype.__imdSynchronizeValues = function () {
                  this.setEditorValue();
                }, Jodit.prototype.getEditorValue = function (e, t) {
                  var o;
                  if (void 0 === e && (e = !0), void 0 !== (o = this.e.fire("beforeGetValueFromEditor", t))) return o;
                  o = this.getNativeEditorValue().replace(i.INVISIBLE_SPACE_REG_EXP(), ""), e && (o = o.replace(/<span[^>]+id="jodit-selection_marker_[^>]+><\/span>/g, "")), "<br>" === o && (o = "");
                  var n = {
                    value: o
                  };
                  return this.e.fire("afterGetValueFromEditor", n, t), n.value;
                }, Jodit.prototype.setEditorValue = function (e) {
                  var t = this.e.fire("beforeSetValueToEditor", e);
                  if (!1 !== t) if ((0, s.isString)(t) && (e = t), this.editor) {
                    if (!(0, s.isString)(e) && !(0, s.isVoid)(e)) throw (0, s.error)("value must be string");
                    (0, s.isVoid)(e) || this.getNativeEditorValue() === e || this.setNativeEditorValue(e), this.e.fire("postProcessSetEditorValue");
                    var o = this.getElementValue(),
                      n = this.getEditorValue();
                    if (!this.__isSilentChange && o !== n && i.SAFE_COUNT_CHANGE_CALL > this.__callChangeCount) {
                      this.__setElementValue(n), this.__callChangeCount += 1;
                      try {
                        this.history.__upTick(), this.e.fire("change", n, o), this.e.fire(this.history, "change", n, o);
                      } finally {
                        this.__callChangeCount = 0;
                      }
                    }
                  } else void 0 !== e && this.__setElementValue(e);
                }, Jodit.prototype.updateElementValue = function () {
                  this.__setElementValue(this.getEditorValue());
                }, Jodit.prototype.getElementValue = function () {
                  return void 0 !== this.element.value ? this.element.value : this.element.innerHTML;
                }, Jodit.prototype.setElementValue = function (e) {
                  var t = this.getElementValue();
                  return (void 0 === e || (0, s.isString)(e) && e !== t) && (null != e || (e = t), e !== this.getEditorValue() && this.setEditorValue(e)), this.__setElementValue(e);
                }, Jodit.prototype.__setElementValue = function (e) {
                  var t = this;
                  if (!(0, s.isString)(e)) throw (0, s.error)("value must be string");
                  if (this.element !== this.container && e !== this.getElementValue()) {
                    var o = {
                        value: e
                      },
                      n = this.e.fire("beforeSetElementValue", o);
                    (0, s.callPromise)(n, function () {
                      void 0 !== t.element.value ? t.element.value = o.value : t.element.innerHTML = o.value, t.e.fire("afterSetElementValue", o);
                    });
                  }
                }, Jodit.prototype.registerCommand = function (e, t, o) {
                  var n = e.toLowerCase(),
                    r = this.commands.get(n);
                  if (void 0 === r && this.commands.set(n, r = []), r.push(t), !(0, s.isFunction)(t)) {
                    var i = this.o.commandToHotkeys[n] || this.o.commandToHotkeys[e] || t.hotkeys;
                    i && this.registerHotkeyToCommand(i, n, null == o ? void 0 : o.stopPropagation);
                  }
                  return this;
                }, Jodit.prototype.registerHotkeyToCommand = function (e, t, o) {
                  var n = this;
                  void 0 === o && (o = !0);
                  var r = (0, s.asArray)(e).map(s.normalizeKeyAliases).map(function (e) {
                    return e + ".hotkey";
                  }).join(" ");
                  this.e.off(r).on(r, function (e, r) {
                    return r && (r.shouldStop = null == o || o), n.execCommand(t);
                  });
                }, Jodit.prototype.execCommand = function (e, t, o) {
                  for (var r, i = [], a = 3; arguments.length > a; a++) i[a - 3] = arguments[a];
                  if (this.s.isFocused() || this.s.focus(), !this.o.readonly || this.o.allowCommandsInReadOnly.includes(e)) {
                    var s;
                    if (e = e.toLowerCase(), !1 !== (s = (r = this.e).fire.apply(r, n.__spreadArray(["beforeCommand", e, t, o], n.__read(i), !1))) && (s = this.__execCustomCommands.apply(this, n.__spreadArray([e, t, o], n.__read(i), !1))), !1 !== s) if (this.s.focus(), "selectall" === e) this.s.select(this.editor, !0), this.s.expandSelection();else try {
                      s = this.nativeExecCommand(e, t, o);
                    } catch (e) {}
                    return this.e.fire("afterCommand", e, t, o), this.setEditorValue(), s;
                  }
                }, Jodit.prototype.nativeExecCommand = function (e, t, o) {
                  this.__isSilentChange = !0;
                  try {
                    return this.ed.execCommand(e, t, o);
                  } finally {
                    this.__isSilentChange = !1;
                  }
                }, Jodit.prototype.__execCustomCommands = function (e, t, o) {
                  for (var r = this, i = [], a = 3; arguments.length > a; a++) i[a - 3] = arguments[a];
                  e = e.toLowerCase();
                  var l,
                    c = this.commands.get(e);
                  if (void 0 !== c) return c.forEach(function (a) {
                    var c,
                      u = (c = (0, s.isFunction)(a) ? a : a.exec).call.apply(c, n.__spreadArray([r, e, t, o], n.__read(i), !1));
                    void 0 !== u && (l = u);
                  }), l;
                }, Jodit.prototype.lock = function (t) {
                  return void 0 === t && (t = "any"), !!e.prototype.lock.call(this, t) && (this.__selectionLocked = this.s.save(), this.s.clear(), this.editor.classList.add("jodit_lock"), this.e.fire("lock", !0), !0);
                }, Jodit.prototype.unlock = function () {
                  return !!e.prototype.unlock.call(this) && (this.editor.classList.remove("jodit_lock"), this.__selectionLocked && this.s.restore(), this.e.fire("lock", !1), !0);
                }, Jodit.prototype.getMode = function () {
                  return this.mode;
                }, Jodit.prototype.isEditorMode = function () {
                  return this.getRealMode() === i.MODE_WYSIWYG;
                }, Jodit.prototype.getRealMode = function () {
                  if (this.getMode() !== i.MODE_SPLIT) return this.getMode();
                  var e = this.od.activeElement;
                  return e && (e === this.iframe || a.Dom.isOrContains(this.editor, e) || a.Dom.isOrContains(this.toolbar.container, e)) ? i.MODE_WYSIWYG : i.MODE_SOURCE;
                }, Jodit.prototype.setMode = function (e) {
                  var t = this,
                    o = this.getMode(),
                    n = {
                      mode: parseInt(e.toString(), 10)
                    },
                    r = ["jodit-wysiwyg_mode", "jodit-source__mode", "jodit_split_mode"];
                  !1 !== this.e.fire("beforeSetMode", n) && (this.__mode = [i.MODE_SOURCE, i.MODE_WYSIWYG, i.MODE_SPLIT].includes(n.mode) ? n.mode : i.MODE_WYSIWYG, this.o.saveModeInStorage && this.storage.set("jodit_default_mode", this.mode), r.forEach(function (e) {
                    t.container.classList.remove(e);
                  }), this.container.classList.add(r[this.mode - 1]), o !== this.getMode() && this.e.fire("afterSetMode"));
                }, Jodit.prototype.toggleMode = function () {
                  var e = this.getMode();
                  [i.MODE_SOURCE, i.MODE_WYSIWYG, this.o.useSplitMode ? i.MODE_SPLIT : 9].includes(e + 1) ? e += 1 : e = i.MODE_WYSIWYG, this.setMode(e);
                }, Jodit.prototype.setDisabled = function (e) {
                  this.o.disabled = e;
                  var t = this.__wasReadOnly;
                  this.setReadOnly(e || t), this.__wasReadOnly = t, this.editor && (this.editor.setAttribute("aria-disabled", e.toString()), this.container.classList.toggle("jodit_disabled", e), this.e.fire("disabled", e));
                }, Jodit.prototype.getDisabled = function () {
                  return this.o.disabled;
                }, Jodit.prototype.setReadOnly = function (e) {
                  this.__wasReadOnly !== e && (this.__wasReadOnly = e, this.o.readonly = e, e ? this.editor && this.editor.removeAttribute("contenteditable") : this.editor && this.editor.setAttribute("contenteditable", "true"), this.e && this.e.fire("readonly", e));
                }, Jodit.prototype.getReadOnly = function () {
                  return this.o.readonly;
                }, Jodit.prototype.focus = function () {
                  this.getMode() !== i.MODE_SOURCE && this.s.focus();
                }, Object.defineProperty(Jodit.prototype, "isFocused", {
                  get: function () {
                    return this.s.isFocused();
                  },
                  enumerable: !1,
                  configurable: !0
                }), Jodit.prototype.beforeInitHook = function () {}, Jodit.prototype.afterInitHook = function () {}, Jodit.prototype.initOptions = function (e) {
                  this.options = (0, s.ConfigProto)(e || {}, r.Config.defaultOptions);
                }, Jodit.prototype.initOwners = function () {
                  this.editorWindow = this.o.ownerWindow, this.ownerWindow = this.o.ownerWindow;
                }, Jodit.prototype.addPlace = function (e, t) {
                  var o = this,
                    n = (0, s.resolveElement)(e, this.o.shadowRoot || this.od);
                  this.attachEvents(t), n.attributes && (0, s.toArray)(n.attributes).forEach(function (e) {
                    var n = e.name,
                      i = e.value;
                    void 0 === r.Config.defaultOptions[n] || t && void 0 !== t[n] || (-1 !== ["readonly", "disabled"].indexOf(n) && (i = "" === i || "true" === i), /^[0-9]+(\.)?([0-9]+)?$/.test(i.toString()) && (i = Number(i)), o.options[n] = i);
                  });
                  var i = this.c.div("jodit-container");
                  i.classList.add("jodit"), i.classList.add("jodit-container"), i.classList.add("jodit_theme_".concat(this.o.theme || "default")), v(this.o.className, i), this.o.containerStyle && (0, s.css)(i, this.o.containerStyle);
                  var l = this.o.styleValues;
                  Object.keys(l).forEach(function (e) {
                    var t = (0, s.kebabCase)(e);
                    i.style.setProperty("--jd-".concat(t), l[e]);
                  }), i.setAttribute("contenteditable", "false");
                  var c = null;
                  this.o.inline && (-1 === ["TEXTAREA", "INPUT"].indexOf(n.nodeName) && (i = n, n.setAttribute(m, n.className.toString()), c = i.innerHTML, i.innerHTML = ""), i.classList.add("jodit_inline"), i.classList.add("jodit-container")), n !== i && (n.style.display && n.setAttribute(h, n.style.display), n.style.display = "none");
                  var u = this.c.div("jodit-workplace", {
                    contenteditable: !1
                  });
                  i.appendChild(u), this.message.destruct(), this.message = new a.UIMessages(this, u), n.parentNode && n !== i && n.parentNode.insertBefore(i, n), Object.defineProperty(n, "component", {
                    enumerable: !1,
                    configurable: !0,
                    value: this
                  });
                  var d = this.c.div("jodit-wysiwyg", {
                    contenteditable: !0,
                    "aria-disabled": !1,
                    tabindex: this.o.tabIndex
                  });
                  u.appendChild(d);
                  var p = {
                    editor: d,
                    element: n,
                    container: i,
                    workplace: u,
                    statusbar: new a.StatusBar(this, i),
                    options: this.isReady ? (0, s.ConfigProto)(t || {}, r.Config.defaultOptions) : this.options,
                    history: new a.History(this),
                    editorWindow: this.ow
                  };
                  this.__elementToPlace.set(d, p), this.setCurrentPlace(p), this.places.push(p), this.setNativeEditorValue(this.getElementValue());
                  var f = this.__initEditor(c),
                    g = this.options;
                  return (0, s.callPromise)(f, function () {
                    g.enableDragAndDropFileToEditor && g.uploader && (g.uploader.url || g.uploader.insertImageAsBase64URI) && o.uploader.bind(o.editor), o.__elementToPlace.get(o.editor) || o.__elementToPlace.set(o.editor, p), o.e.fire("afterAddPlace", p);
                  });
                }, Jodit.prototype.addDisclaimer = function (e) {
                  this.workplace.appendChild(e);
                }, Jodit.prototype.setCurrentPlace = function (e) {
                  this.currentPlace !== e && (this.isEditorMode() || this.setMode(i.MODE_WYSIWYG), this.currentPlace = e, this.buildToolbar(), this.isReady && this.e.fire("changePlace", e));
                }, Jodit.prototype.__initEditor = function (e) {
                  var t = this,
                    o = this.__createEditor();
                  return (0, s.callPromise)(o, function () {
                    if (!t.isInDestruct) {
                      if (t.element !== t.container) {
                        var o = t.getElementValue();
                        o !== t.getEditorValue() && t.setEditorValue(o);
                      } else null != e && t.setEditorValue(e);
                      var n = t.o.defaultMode;
                      if (t.o.saveModeInStorage) {
                        var r = t.storage.get("jodit_default_mode");
                        "string" == typeof r && (n = parseInt(r, 10));
                      }
                      t.setMode(n), t.o.readonly && (t.__wasReadOnly = !1, t.setReadOnly(!0)), t.o.disabled && t.setDisabled(!0);
                      try {
                        t.ed.execCommand("defaultParagraphSeparator", !1, t.o.enter.toLowerCase());
                      } catch (e) {}
                      try {
                        t.ed.execCommand("enableObjectResizing", !1, "false");
                      } catch (e) {}
                      try {
                        t.ed.execCommand("enableInlineTableEditing", !1, "false");
                      } catch (e) {}
                    }
                  });
                }, Jodit.prototype.__createEditor = function () {
                  var e = this,
                    t = this.editor,
                    o = this.e.fire("createEditor", this);
                  return (0, s.callPromise)(o, function () {
                    if (!e.isInDestruct) {
                      if ((!1 === o || (0, s.isPromise)(o)) && a.Dom.safeRemove(t), v(e.o.editorClassName || e.o.editorCssClass, e.editor), e.o.editorCssClass && e.editor.classList.add(e.o.editorCssClass), e.o.style && (0, s.css)(e.editor, e.o.style), e.e.on("synchro", function () {
                        e.setEditorValue();
                      }).on("focus", function () {
                        e.editorIsActive = !0;
                      }).on("blur", function () {
                        return e.editorIsActive = !1;
                      }), e.__prepareWYSIWYGEditor(), e.o.direction) {
                        var n = "rtl" === e.o.direction.toLowerCase() ? "rtl" : "ltr";
                        e.container.style.direction = n, e.container.setAttribute("dir", n), e.toolbar.setDirection(n);
                      }
                      e.o.triggerChangeEvent && e.e.on("change", e.async.debounce(function () {
                        e.e && e.e.fire(e.element, "change");
                      }, e.defaultTimeout));
                    }
                  });
                }, Jodit.prototype.__prepareWYSIWYGEditor = function () {
                  var e = this,
                    t = this.editor;
                  if (this.o.direction) {
                    var o = "rtl" === this.o.direction.toLowerCase() ? "rtl" : "ltr";
                    this.editor.style.direction = o, this.editor.setAttribute("dir", o);
                  }
                  this.e.on(t, "mousedown touchstart focus", function () {
                    var o = e.__elementToPlace.get(t);
                    o && e.setCurrentPlace(o);
                  }).on(t, "compositionend", this.synchronizeValues).on(t, "selectionchange selectionstart keydown keyup input keypress dblclick mousedown mouseup click copy cut dragstart drop dragover paste resize touchstart touchend focus blur", function (t) {
                    if (!e.o.readonly && !e.__isSilentChange && !(t instanceof e.ew.KeyboardEvent && t.isComposing) && e.e && e.e.fire) {
                      if (!1 === e.e.fire(t.type, t)) return !1;
                      e.synchronizeValues();
                    }
                  });
                }, Jodit.prototype.fetch = function (e, t) {
                  var o = this,
                    r = new f.Ajax(n.__assign({
                      url: e
                    }, t), this.o.defaultAjaxOptions),
                    i = function () {
                      o.e.off("beforeDestruct", i), o.progressbar.progress(100).hide(), r.destruct();
                    };
                  this.e.one("beforeDestruct", i), this.progressbar.show().progress(30);
                  var a = r.send();
                  return a.finally(i).catch(function () {
                    return null;
                  }), a;
                }, Jodit.prototype.destruct = function () {
                  var t = this;
                  if (!this.isInDestruct && (this.setStatus(a.STATUSES.beforeDestruct), this.__elementToPlace.clear(), this.editor)) {
                    var o = this.getEditorValue();
                    this.storage.clear(), this.buffer.clear(), this.commands.clear(), this.__selectionLocked = null, this.e.off(this.ow, "resize"), this.e.off(this.ow), this.e.off(this.od), this.e.off(this.od.body), this.places.forEach(function (e) {
                      var n = e.container,
                        r = e.workplace,
                        i = e.statusbar,
                        l = e.element,
                        c = e.iframe,
                        u = e.editor,
                        d = e.history;
                      if (l !== n) {
                        if (l.hasAttribute(h)) {
                          var p = (0, s.attr)(l, h);
                          p && (l.style.display = p, l.removeAttribute(h));
                        } else l.style.display = "";
                      } else l.hasAttribute(m) && (l.className = (0, s.attr)(l, m) || "", l.removeAttribute(m));
                      l.hasAttribute("style") && !(0, s.attr)(l, "style") && l.removeAttribute("style"), i.destruct(), t.e.off(n), t.e.off(l), t.e.off(u), a.Dom.safeRemove(r), a.Dom.safeRemove(u), n !== l && a.Dom.safeRemove(n), Object.defineProperty(l, "component", {
                        enumerable: !1,
                        configurable: !0,
                        value: null
                      }), a.Dom.safeRemove(c), n === l && (l.innerHTML = o), d.destruct();
                    }), this.places.length = 0, this.currentPlace = {}, delete u.instances[this.id], e.prototype.destruct.call(this);
                  }
                }, Jodit.fatMode = !1, Jodit.plugins = u.pluginSystem, Jodit.modules = u.modules, Jodit.ns = u.modules, Jodit.decorators = {}, Jodit.constants = i, Jodit.instances = u.instances, Jodit.lang = c.lang, Jodit.core = {
                  Plugin: a.Plugin
                }, n.__decorate([d.cache], Jodit.prototype, "uploader", null), n.__decorate([d.cache], Jodit.prototype, "filebrowser", null), n.__decorate([(0, d.throttle)()], Jodit.prototype, "synchronizeValues", null), n.__decorate([(0, d.watch)(":internalChange")], Jodit.prototype, "updateElementValue", null), n.__decorate([d.autobind], Jodit.prototype, "__prepareWYSIWYGEditor", null), t = n.__decorate([(0, d.derive)(p.Dlgs)], Jodit);
              }(a.ViewWithToolbar);
            function v(e, t) {
              e && e.split(/\s+/).forEach(function (e) {
                return t.classList.add(e);
              });
            }
            t.Jodit = Jodit;
          },
          26435: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(10172),
              r = {},
              i = o(90643),
              a = o(52532),
              s = o(75178),
              l = o(51048),
              c = o(22999),
              u = o(34145),
              d = o(40272),
              p = o(2978),
              f = o(99113),
              h = o(51923),
              m = o(21268),
              v = o(37289),
              g = o(26501),
              y = o(17084),
              _ = o(96891),
              b = o(31211),
              w = o(31109),
              S = o(79375),
              C = o(21042),
              j = o(73895);
            r = {
              ar: i,
              cs_cz: a,
              de: s,
              en: l,
              es: c,
              fr: u,
              he: d,
              hu: p,
              id: f,
              it: h,
              ja: m,
              ko: v,
              mn: g,
              nl: y,
              pl: _,
              pt_br: b,
              ru: w,
              tr: S,
              zh_cn: C,
              zh_tw: j
            };
            var E = o(11399),
              x = function (e) {
                return e ? e.default || e : {};
              },
              k = {};
            (0, n.isArray)(x(E)) && x(E).forEach(function (e, t) {
              k[t] = e;
            }), Object.keys(r).forEach(function (e) {
              var t = x(r[e]);
              (0, n.isArray)(t) ? (r[e] = {}, t.forEach(function (t, o) {
                r[e][k[o]] = t;
              })) : r[e] = t;
            }), t.default = r;
          },
          60403: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ContextMenu = void 0;
            var n = o(20255);
            o(47086);
            var r = o(35799),
              i = o(96516),
              a = o(10172),
              s = o(11441),
              l = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ContextMenu";
                }, t.prototype.show = function (e, t, o) {
                  var n = this,
                    r = this,
                    s = this.j.c.div(this.getFullElName("actions"));
                  (0, a.isArray)(o) && (o.forEach(function (e) {
                    if (e) {
                      var t = (0, i.Button)(n.jodit, e.icon || "empty", e.title);
                      n.jodit && t.setParentView(n.jodit), t.setMod("context", "menu"), t.onAction(function (t) {
                        var o;
                        return null === (o = e.exec) || void 0 === o || o.call(r, t), r.close(), !1;
                      }), s.appendChild(t.container);
                    }
                  }), this.setContent(s).open(function () {
                    return {
                      left: e,
                      top: t,
                      width: 0,
                      height: 0
                    };
                  }, !0));
                }, n.__decorate([s.component], t);
              }(r.Popup);
            t.ContextMenu = l;
          },
          97528: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Alert = void 0;
            var n = o(6690),
              r = o(40332),
              i = o(64968),
              a = o(2074);
            t.Alert = function (e, t, o, s) {
              void 0 === s && (s = "jodit-dialog_alert"), (0, r.isFunction)(t) && (o = t, t = void 0);
              var l = this instanceof n.Dialog ? this : new n.Dialog(),
                c = l.c.div(s),
                u = (0, a.Button)(l, "ok", "Ok");
              return (0, r.asArray)(e).forEach(function (e) {
                c.appendChild(i.Dom.isNode(e) ? e : l.c.fromHTML(e));
              }), u.onAction(function () {
                o && (0, r.isFunction)(o) && !1 === o(l) || l.close();
              }), l.setFooter([u]), l.open(c, t || "&nbsp;", !0, !0), u.focus(), l;
            };
          },
          47360: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Confirm = void 0;
            var n = o(6690),
              r = o(42096),
              i = o(96031);
            t.Confirm = function (e, t, o) {
              var a = this instanceof n.Dialog ? this : new n.Dialog(),
                s = a.c.fromHTML('<form class="jodit-dialog_prompt"></form>'),
                l = a.c.element("label");
              (0, r.isFunction)(t) && (o = t, t = void 0), l.appendChild(a.c.fromHTML(e)), s.appendChild(l);
              var c = function (e) {
                  return function () {
                    o && !1 === o(e) || a.close();
                  };
                },
                u = (0, i.Button)(a, "cancel", "Cancel"),
                d = (0, i.Button)(a, "ok", "Yes");
              return u.onAction(c(!1)), d.onAction(c(!0)), a.e.on(s, "submit", function () {
                return c(!0)(), !1;
              }), a.setFooter([d, u]), a.open(s, t || "&nbsp;", !0, !0), d.focus(), a;
            };
          },
          6690: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Dialog = void 0;
            var n = o(20255);
            o(16462);
            var r = o(93166),
              i = o(86893),
              a = o(40332),
              s = (o(52378), o(43608)),
              l = o(64968),
              c = o(56562),
              u = o(17332),
              d = o(43441),
              p = o(75902),
              f = o(2074),
              h = o(71014);
            r.Config.prototype.dialog = {
              namespace: "",
              extraButtons: [],
              resizable: !0,
              draggable: !0,
              buttons: ["dialog.close"],
              removeButtons: [],
              toolbarButtonSize: "middle",
              zIndex: "inherit"
            }, r.Config.prototype.controls.dialog = {
              close: {
                icon: "cancel",
                exec: function (e) {
                  e.close();
                }
              }
            };
            var m = function (e) {
              function t(t) {
                void 0 === t && (t = {});
                var o = e.call(this, t) || this;
                o.destroyAfterClose = !1, o.moved = !1, o.resizable = !1, o.draggable = !1, o.startX = 0, o.startY = 0, o.startPoint = {
                  x: 0,
                  y: 0,
                  w: 0,
                  h: 0
                }, o.lockSelect = function () {
                  o.setMod("moved", !0);
                }, o.unlockSelect = function () {
                  o.setMod("moved", !1);
                }, o.onResize = function () {
                  o.options && o.o.resizable && !o.moved && o.isOpened && !o.offsetX && !o.offsetY && o.setPosition();
                }, o.isModal = !1, o.isOpened = !1;
                var n = o;
                n.options = (0, a.ConfigProto)(t, (0, a.ConfigProto)(r.Config.prototype.dialog, p.View.defaultOptions)), l.Dom.safeRemove(n.container);
                var i = o.getFullElName.bind(o);
                n.container = o.c.fromHTML('<div class="jodit jodit-dialog '.concat(o.componentName, '">\n\t\t\t\t<div class="').concat(i("overlay"), '"></div>\n\t\t\t\t<div class="').concat(o.getFullElName("panel"), '">\n\t\t\t\t\t<div class="').concat(i("header"), '">\n\t\t\t\t\t\t<div class="').concat(i("header-title"), '"></div>\n\t\t\t\t\t\t<div class="').concat(i("header-toolbar"), '"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="').concat(i("content"), '"></div>\n\t\t\t\t\t<div class="').concat(i("footer"), '"></div>\n\t\t\t\t\t<div class="').concat(i("resizer"), '">').concat(f.Icon.get("resize_handler"), "</div>\n\t\t\t\t</div>\n\t\t\t</div>")), o.o.zIndex && (o.container.style.zIndex = o.o.zIndex.toString()), (0, a.attr)(n.container, "role", "dialog"), Object.defineProperty(n.container, "component", {
                  value: o
                }), n.setMod("theme", n.o.theme || "default").setMod("resizable", Boolean(n.o.resizable));
                var s = n.getElm("panel"),
                  c = n.getElm("resizer"),
                  d = n.getElm("header-title"),
                  m = n.getElm("content"),
                  v = n.getElm("footer"),
                  g = n.getElm("header-toolbar");
                o.message.destruct(), o.message = new h.UIMessages(o, s), o.dialog = s, o.resizer = c, o.dialogbox_header = d, o.dialogbox_content = m, o.dialogbox_footer = v, o.dialogbox_toolbar = g, (0, a.css)(n.dialog, {
                  maxWidth: n.options.maxWidth,
                  minHeight: n.options.minHeight,
                  minWidth: n.options.minWidth
                });
                var y = n.getElm("header");
                y && n.e.on(y, "pointerdown touchstart", n.onHeaderMouseDown), n.e.on(n.resizer, "mousedown touchstart", n.onResizerMouseDown);
                var _ = u.pluginSystem.get("fullsize");
                return (0, a.isFunction)(_) && _(n), o.e.on(n.container, "close_dialog", n.close).on(o.ow, "keydown", o.onEsc).on(o.ow, "resize", o.onResize), o;
              }
              return n.__extends(t, e), t.prototype.className = function () {
                return "Dialog";
              }, Object.defineProperty(t.prototype, "destination", {
                get: function () {
                  var e;
                  return null !== (e = this.o.shadowRoot) && void 0 !== e ? e : this.od.body;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.setElements = function (e, t) {
                var o = this,
                  n = [];
                (0, a.asArray)(t).forEach(function (t) {
                  if ((0, a.isArray)(t)) {
                    var r = o.c.div(o.getFullElName("column"));
                    return n.push(r), e.appendChild(r), o.setElements(r, t);
                  }
                  var i;
                  i = (0, a.isString)(t) ? o.c.fromHTML(t) : (0, a.hasContainer)(t) ? t.container : t, n.push(i), i.parentNode !== e && e.appendChild(i);
                }), (0, a.toArray)(e.childNodes).forEach(function (t) {
                  -1 === n.indexOf(t) && e.removeChild(t);
                });
              }, t.prototype.onMouseUp = function () {
                (this.draggable || this.resizable) && (this.removeGlobalResizeListeners(), this.draggable = !1, this.resizable = !1, this.unlockSelect(), this.e && (this.removeGlobalResizeListeners(), this.e.fire(this, "endResize endMove")));
              }, t.prototype.onHeaderMouseDown = function (e) {
                var t = e.target;
                !this.o.draggable || t && t.nodeName.match(/^(INPUT|SELECT)$/) || (this.draggable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.x = (0, a.css)(this.dialog, "left"), this.startPoint.y = (0, a.css)(this.dialog, "top"), this.setMaxZIndex(), e.cancelable && e.preventDefault(), this.lockSelect(), this.addGlobalResizeListeners(), this.e && this.e.fire(this, "startMove"));
              }, t.prototype.onMouseMove = function (e) {
                this.draggable && this.o.draggable && (this.setPosition(this.startPoint.x + e.clientX - this.startX, this.startPoint.y + e.clientY - this.startY), this.e && this.e.fire(this, "move", e.clientX - this.startX, e.clientY - this.startY), e.stopImmediatePropagation()), this.resizable && this.o.resizable && (this.setSize(this.startPoint.w + e.clientX - this.startX, this.startPoint.h + e.clientY - this.startY), this.e && this.e.fire(this, "resizeDialog", e.clientX - this.startX, e.clientY - this.startY));
              }, t.prototype.onEsc = function (e) {
                if (this.isOpened && e.key === i.KEY_ESC && !0 !== this.getMod("static")) {
                  var t = this.getMaxZIndexDialog();
                  t ? t.close() : this.close(), e.stopImmediatePropagation();
                }
              }, t.prototype.onResizerMouseDown = function (e) {
                this.resizable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.w = this.dialog.offsetWidth, this.startPoint.h = this.dialog.offsetHeight, this.lockSelect(), this.addGlobalResizeListeners(), this.e && this.e.fire(this, "startResize");
              }, t.prototype.addGlobalResizeListeners = function () {
                var e = this;
                e.e.on(e.ow, "pointermove touchmove", e.onMouseMove).on(e.ow, "pointerup touchend", e.onMouseUp);
              }, t.prototype.removeGlobalResizeListeners = function () {
                var e = this;
                e.e.off(e.ow, "mousemove pointermove", e.onMouseMove).off(e.ow, "mouseup pointerup", e.onMouseUp);
              }, t.prototype.setSize = function (e, t) {
                return null == e && (e = this.dialog.offsetWidth), null == t && (t = this.dialog.offsetHeight), (0, a.css)(this.dialog, {
                  width: e,
                  height: t
                }), this;
              }, t.prototype.calcAutoSize = function () {
                return this.setSize("auto", "auto"), this.setSize(), this;
              }, t.prototype.setPosition = function (e, t) {
                var o = this.ow.innerWidth / 2 - this.dialog.offsetWidth / 2,
                  n = this.ow.innerHeight / 2 - this.dialog.offsetHeight / 2;
                return 0 > o && (o = 0), 0 > n && (n = 0), void 0 !== e && void 0 !== t && (this.offsetX = e, this.offsetY = t, this.moved = Math.abs(e - o) > 100 || Math.abs(t - n) > 100), this.dialog.style.left = (e || o) + "px", this.dialog.style.top = (t || n) + "px", this;
              }, t.prototype.setHeader = function (e) {
                return this.setElements(this.dialogbox_header, e), this;
              }, t.prototype.setContent = function (e) {
                return this.setElements(this.dialogbox_content, e), this;
              }, t.prototype.setFooter = function (e) {
                return this.setElements(this.dialogbox_footer, e), this.setMod("footer", Boolean(e)), this;
              }, t.prototype.getZIndex = function () {
                return parseInt((0, a.css)(this.container, "zIndex"), 10) || 0;
              }, t.prototype.getMaxZIndexDialog = function () {
                var e,
                  t,
                  o = 0,
                  n = this;
                return (0, a.$$)(".jodit-dialog", this.destination).forEach(function (r) {
                  e = r.component, t = parseInt((0, a.css)(r, "zIndex"), 10), e.isOpened && !isNaN(t) && t > o && (n = e, o = t);
                }), n;
              }, t.prototype.setMaxZIndex = function () {
                if (!this.getMod("static")) {
                  var e = 20000004,
                    t = 0;
                  (0, a.$$)(".jodit-dialog", this.destination).forEach(function (o) {
                    t = parseInt((0, a.css)(o, "zIndex"), 10), e = Math.max(isNaN(t) ? 0 : t, e);
                  }), this.container.style.zIndex = (e + 1).toString();
                }
              }, t.prototype.toggleFullSize = function (t) {
                (0, a.isVoid)(t) && (t = !this.getMod("fullsize")), this.setMod("fullsize", t), e.prototype.toggleFullSize.call(this, t);
              }, t.prototype.open = function (e, t, o, n) {
                if (u.eventEmitter.fire("closeAllPopups hideHelpers"), !1 === this.e.fire(this, "beforeOpen")) return this;
                (0, a.isBoolean)(e) && (o = e), (0, a.isBoolean)(t) && (n = t), this.destroyAfterClose = !0 === o;
                var r = (0, a.isBoolean)(e) ? void 0 : e,
                  i = (0, a.isBoolean)(t) ? void 0 : t;
                return void 0 !== i && this.setHeader(i), r && this.setContent(r), this.setMod("active", !0), this.isOpened = !0, this.setModal(n), this.destination.appendChild(this.container), !0 !== this.getMod("static") ? (this.setPosition(this.offsetX, this.offsetY), this.setMaxZIndex()) : this.container.style.removeProperty("z-index"), this.o.fullsize && this.toggleFullSize(!0), this.e.fire("afterOpen", this), this;
              }, t.prototype.setModal = function (e) {
                return this.isModal = Boolean(e), this.setMod("modal", this.isModal), this;
              }, t.prototype.close = function () {
                return this.isDestructed || !this.isOpened || !0 === this.getMod("static") || !1 === this.e.fire("beforeClose", this) || (this.setMod("active", !1), this.isOpened = !1, this.isFullSize && this.toggleFullSize(!1), l.Dom.safeRemove(this.container), this.removeGlobalResizeListeners(), this.destroyAfterClose && this.destruct(), this.e.fire(this, "afterClose"), this.e.fire(this.ow, "joditCloseDialog")), this;
              }, t.prototype.buildToolbar = function () {
                this.o.buttons && this.toolbar.build((0, a.splitArray)(this.o.buttons)).setMod("mode", "header").appendTo(this.dialogbox_toolbar);
              }, t.prototype.destruct = function () {
                this.isInDestruct || (this.setStatus(c.STATUSES.beforeDestruct), this.isOpened && this.close(), this.events && (this.removeGlobalResizeListeners(), this.events.off(this.container, "close_dialog", self.close).off(this.ow, "keydown", this.onEsc).off(this.ow, "resize", this.onResize)), e.prototype.destruct.call(this));
              }, n.__decorate([d.autobind], t.prototype, "onMouseUp", null), n.__decorate([d.autobind], t.prototype, "onHeaderMouseDown", null), n.__decorate([d.autobind], t.prototype, "onMouseMove", null), n.__decorate([d.autobind], t.prototype, "onEsc", null), n.__decorate([d.autobind], t.prototype, "onResizerMouseDown", null), n.__decorate([d.autobind], t.prototype, "close", null), n.__decorate([(0, d.hook)("ready")], t.prototype, "buildToolbar", null), n.__decorate([d.component], t);
            }(s.ViewWithToolbar);
            t.Dialog = m;
          },
          92080: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Confirm = t.Prompt = t.Alert = t.Dialog = void 0;
            var n = o(6690);
            Object.defineProperty(t, "Dialog", {
              enumerable: !0,
              get: function () {
                return n.Dialog;
              }
            });
            var r = o(97528);
            Object.defineProperty(t, "Alert", {
              enumerable: !0,
              get: function () {
                return r.Alert;
              }
            });
            var i = o(35789);
            Object.defineProperty(t, "Prompt", {
              enumerable: !0,
              get: function () {
                return i.Prompt;
              }
            });
            var a = o(47360);
            Object.defineProperty(t, "Confirm", {
              enumerable: !0,
              get: function () {
                return a.Confirm;
              }
            });
          },
          35789: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Prompt = void 0;
            var n = o(92080),
              r = o(2074),
              i = o(40332);
            t.Prompt = function (e, t, o, a, s) {
              var l = this instanceof n.Dialog ? this : new n.Dialog(),
                c = (0, r.Button)(l, "cancel", "Cancel"),
                u = (0, r.Button)(l, "ok", "Ok"),
                d = l.c.element("form", {
                  class: "jodit-dialog_prompt"
                }),
                p = l.c.element("input", {
                  autofocus: !0,
                  class: "jodit-input"
                }),
                f = l.c.element("label");
              (0, i.isFunction)(t) && (o = t, t = void 0), a && (0, i.attr)(p, "placeholder", a), f.appendChild(l.c.text(e)), d.appendChild(f), d.appendChild(p), c.onAction(l.close);
              var h = function () {
                o && (0, i.isFunction)(o) && !1 === o(p.value) || l.close();
              };
              return u.onAction(h), l.e.on(d, "submit", function () {
                return h(), !1;
              }), l.setFooter([u, c]), l.open(d, t || "&nbsp;", !0, !0), p.focus(), void 0 !== s && s.length && (p.value = s, p.select()), l;
            };
          },
          34468: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(64968),
              i = o(40332),
              a = o(46341),
              s = o(2074),
              l = o(21347),
              c = o(35503),
              u = o(66267),
              d = o(36303),
              p = o(48096),
              f = "jodit-filebrowser-preview",
              h = function (e, t) {
                return void 0 === e && (e = "next"), void 0 === t && (t = "right"), '<div class="'.concat(f, "__navigation ").concat(f, "__navigation_arrow_").concat(e, '">') + "" + s.Icon.get("angle-" + t) + "</a>";
              };
            t.default = function (e) {
              if (!e.o.contextMenu) return function () {};
              var t = (0, a.makeContextMenu)(e);
              return function (o) {
                var a = (0, l.getItem)(o.target, e.container);
                if (a) {
                  var s = a,
                    m = e.options,
                    v = function (e) {
                      return (0, i.attr)(s, e) || "";
                    };
                  return e.async.setTimeout(function () {
                    var g = (0, l.elementToItem)(a, (0, u.elementsMap)(e));
                    g && (e.state.activeElements = [g], t.show(o.clientX, o.clientY, [!("1" === v("data-is-file") || !m.editImage || !e.dataProvider.canI("ImageResize") && !e.dataProvider.canI("ImageCrop")) && {
                      icon: "pencil",
                      title: "Edit",
                      exec: function () {
                        return c.openImageEditor.call(e, v("href"), v("data-name"), v("data-path"), v("data-source"));
                      }
                    }, !!e.dataProvider.canI("FileRename") && {
                      icon: "italic",
                      title: "Rename",
                      exec: function () {
                        e.e.fire("fileRename.filebrowser", v("data-name"), v("data-path"), v("data-source"));
                      }
                    }, !!e.dataProvider.canI("FileRemove") && {
                      icon: "bin",
                      title: "Delete",
                      exec: function () {
                        return n.__awaiter(void 0, void 0, Promise, function () {
                          var t;
                          return n.__generator(this, function (o) {
                            switch (o.label) {
                              case 0:
                                return o.trys.push([0, 2,, 3]), [4, (0, p.deleteFile)(e, v("data-name"), v("data-source"))];
                              case 1:
                                return o.sent(), [3, 3];
                              case 2:
                                return t = o.sent(), [2, e.status(t)];
                              case 3:
                                return e.state.activeElements = [], [2, (0, d.loadTree)(e).catch(e.status)];
                            }
                          });
                        });
                      }
                    }, !!m.preview && {
                      icon: "eye",
                      title: "Preview",
                      exec: function () {
                        var t = e.dlg({
                            buttons: ["fullsize", "dialog.close"]
                          }),
                          o = e.c.div(f, '<div class="jodit-icon_loader"></div>'),
                          n = e.c.div(f + "__box"),
                          a = e.c.fromHTML(h()),
                          l = e.c.fromHTML(h("prev", "left")),
                          c = function (i) {
                            var c = e.c.element("img");
                            c.setAttribute("src", i);
                            var u = function () {
                              var i;
                              e.isInDestruct || (e.e.off(c, "load"), r.Dom.detach(o), m.showPreviewNavigation && (r.Dom.prevWithClass(s, e.files.getFullElName("item")) && o.appendChild(l), r.Dom.nextWithClass(s, e.files.getFullElName("item")) && o.appendChild(a)), o.appendChild(n), n.appendChild(c), t.setPosition(), null === (i = null == e ? void 0 : e.events) || void 0 === i || i.fire("previewOpenedAndLoaded"));
                            };
                            e.e.on(c, "load", u), c.complete && u();
                          };
                        e.e.on([a, l], "click", function () {
                          if (!(s = this === a ? r.Dom.nextWithClass(s, e.files.getFullElName("item")) : r.Dom.prevWithClass(s, e.files.getFullElName("item")))) throw (0, i.error)("Need element");
                          r.Dom.detach(o), r.Dom.detach(n), o.innerHTML = '<div class="jodit-icon_loader"></div>', c(v("href"));
                        }), e.e.on("beforeDestruct", function () {
                          t.destruct();
                        }), t.container.classList.add(f + "__dialog"), t.setContent(o), t.setPosition(), t.open(), c(v("href")), e.events.on("beforeDestruct", function () {
                          t.destruct();
                        }).fire("previewOpened");
                      }
                    }, {
                      icon: "upload",
                      title: "Download",
                      exec: function () {
                        var t = v("href");
                        t && e.ow.open(t);
                      }
                    }]));
                  }, e.defaultTimeout), e.e.on("beforeClose", function () {
                    return t.close();
                  }).on("beforeDestruct", function () {
                    return t.destruct();
                  }), o.stopPropagation(), o.preventDefault(), !1;
                }
              };
            };
          },
          66267: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.elementsMap = void 0;
            var o = new WeakMap();
            t.elementsMap = function (e) {
              var t = o.get(e);
              return t || o.set(e, t = {}), t;
            };
          },
          63511: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.FileBrowserItem = void 0;
            var n = o(40332),
              r = function () {
                function e(e) {
                  var t = this;
                  this.data = e, Object.keys(e).forEach(function (o) {
                    t[o] = e[o];
                  });
                }
                return e.create = function (t) {
                  return t instanceof e ? t : new e(t);
                }, Object.defineProperty(e.prototype, "path", {
                  get: function () {
                    return (0, n.normalizePath)(this.data.source.path ? this.data.source.path + "/" : "/");
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "imageURL", {
                  get: function () {
                    var e = this.time || new Date().getTime().toString(),
                      t = this.data,
                      o = t.source,
                      r = t.thumb || t.file;
                    return t.thumbIsAbsolute && r ? r : (0, n.normalizeUrl)(o.baseurl, o.path, r || "") + "?_tmst=" + encodeURIComponent(e);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "fileURL", {
                  get: function () {
                    var e = this.data.name,
                      t = this.data,
                      o = t.file,
                      r = t.source;
                    return void 0 !== o && (e = o), t.fileIsAbsolute && e ? e : (0, n.normalizeUrl)(r.baseurl, r.path, e || "");
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "time", {
                  get: function () {
                    var e = this.data.changed;
                    return e && ("number" == typeof e ? new Date(e).toLocaleString() : e) || "";
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e.prototype, "uniqueHashKey", {
                  get: function () {
                    var e = this.data;
                    return [e.sourceName, e.name, e.file, this.time, e.thumb].join("_").toLowerCase().replace(/[^0-9a-z\-.]/g, "-");
                  },
                  enumerable: !1,
                  configurable: !0
                }), e.prototype.toJSON = function () {
                  return this.data;
                }, e;
              }();
            t.FileBrowserItem = r;
          },
          38097: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(93166),
              i = o(10172),
              a = o(41374),
              s = o(6102);
            r.Config.prototype.filebrowser = {
              namespace: "",
              extraButtons: [],
              filter: function (e, t) {
                return t = t.toLowerCase(), (0, i.isString)(e) ? -1 !== e.toLowerCase().indexOf(t) : (0, i.isString)(e.name) ? -1 !== e.name.toLowerCase().indexOf(t) : !(0, i.isString)(e.file) || -1 !== e.file.toLowerCase().indexOf(t);
              },
              sortBy: "changed-desc",
              sort: function (e, t, o) {
                var r = n.__read(o.toLowerCase().split("-"), 2),
                  a = r[0],
                  l = "asc" === r[1],
                  c = function (e, t) {
                    return t > e ? l ? -1 : 1 : e > t ? l ? 1 : -1 : 0;
                  };
                if ((0, i.isString)(e)) return c(e.toLowerCase(), t.toLowerCase());
                if (void 0 === e[a] || "name" === a) return (0, i.isString)(e.name) ? c(e.name.toLowerCase(), t.name.toLowerCase()) : (0, i.isString)(e.file) ? c(e.file.toLowerCase(), t.file.toLowerCase()) : 0;
                switch (a) {
                  case "changed":
                    var u = new Date(e.changed).getTime(),
                      d = new Date(t.changed).getTime();
                    return l ? u - d : d - u;
                  case "size":
                    return u = (0, s.humanSizeToBytes)(e.size), d = (0, s.humanSizeToBytes)(t.size), l ? u - d : d - u;
                }
                return 0;
              },
              editImage: !0,
              preview: !0,
              showPreviewNavigation: !0,
              showSelectButtonInPreview: !0,
              contextMenu: !0,
              howLongShowMsg: 3e3,
              createNewFolder: !0,
              deleteFolder: !0,
              renameFolder: !0,
              moveFolder: !0,
              moveFile: !0,
              permissionsPresets: {
                allowFileDownload: void 0,
                allowFileMove: void 0,
                allowFileRemove: void 0,
                allowFileRename: void 0,
                allowFileUpload: void 0,
                allowFileUploadRemote: void 0,
                allowFiles: void 0,
                allowFolderCreate: void 0,
                allowFolderMove: void 0,
                allowFolderRemove: void 0,
                allowFolderRename: void 0,
                allowFolderTree: void 0,
                allowFolders: void 0,
                allowGeneratePdf: void 0,
                allowImageCrop: void 0,
                allowImageResize: void 0
              },
              showFoldersPanel: !0,
              storeLastOpenedFolder: !0,
              width: 859,
              height: 400,
              buttons: ["filebrowser.upload", "filebrowser.remove", "filebrowser.update", "filebrowser.select", "filebrowser.edit", "|", "filebrowser.tiles", "filebrowser.list", "|", "filebrowser.filter", "|", "filebrowser.sort"],
              removeButtons: [],
              fullsize: !1,
              showTooltip: !0,
              view: null,
              isSuccess: function (e) {
                return e.success;
              },
              getMessage: function (e) {
                return void 0 !== e.data.messages && (0, i.isArray)(e.data.messages) ? e.data.messages.join(" ") : "";
              },
              showFileName: !0,
              showFileSize: !0,
              showFileChangeTime: !0,
              saveStateInStorage: {
                storeLastOpenedFolder: !0,
                storeView: !0,
                storeSortBy: !0
              },
              pixelOffsetLoadNewChunk: 200,
              getThumbTemplate: function (e, t, o) {
                var n = this.options,
                  r = this.files.getFullElName("item"),
                  i = n.showFileName,
                  a = n.showFileSize && e.size,
                  s = n.showFileChangeTime && e.time,
                  l = "";
                void 0 !== e.file && (l = e.file);
                var c = '<div class="'.concat(r, '-info">').concat(i ? '<span class="'.concat(r, '-info-filename">').concat(l, "</span>") : "").concat(a ? '<span class="'.concat(r, '-info-filesize">').concat(e.size, "</span>") : "").concat(s ? '<span class="'.concat(r, '-info-filechanged">').concat(s, "</span>") : "", "</div>");
                return '<a\n\t\t\tdata-jodit-filebrowser-item="true"\n\t\t\tdata-is-file="'.concat(e.isImage ? 0 : 1, '"\n\t\t\tdraggable="true"\n\t\t\tclass="').concat(r, '"\n\t\t\thref="').concat(e.fileURL, '"\n\t\t\tdata-source="').concat(o, '"\n\t\t\tdata-path="').concat(e.path, '"\n\t\t\tdata-name="').concat(l, '"\n\t\t\ttitle="').concat(l, '"\n\t\t\tdata-url="').concat(e.fileURL, '">\n\t\t\t\t<img\n\t\t\t\t\tdata-is-file="').concat(e.isImage ? 0 : 1, '"\n\t\t\t\t\tdata-src="').concat(e.fileURL, '"\n\t\t\t\t\tsrc="').concat(e.imageURL, '"\n\t\t\t\t\talt="').concat(l, '"\n\t\t\t\t\tloading="lazy"\n\t\t\t\t/>\n\t\t\t\t').concat(i || a || s ? c : "", "\n\t\t\t</a>");
              },
              ajax: n.__assign(n.__assign({}, r.Config.prototype.defaultAjaxOptions), {
                url: "",
                data: {},
                cache: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                method: "POST",
                processData: !0,
                headers: {},
                prepareData: function (e) {
                  return e;
                },
                process: function (e) {
                  return e;
                }
              }),
              create: {
                data: {
                  action: "folderCreate"
                }
              },
              getLocalFileByUrl: {
                data: {
                  action: "getLocalFileByUrl"
                }
              },
              resize: {
                data: {
                  action: "imageResize"
                }
              },
              crop: {
                data: {
                  action: "imageCrop"
                }
              },
              fileMove: {
                data: {
                  action: "fileMove"
                }
              },
              folderMove: {
                data: {
                  action: "folderMove"
                }
              },
              fileRename: {
                data: {
                  action: "fileRename"
                }
              },
              folderRename: {
                data: {
                  action: "folderRename"
                }
              },
              fileRemove: {
                data: {
                  action: "fileRemove"
                }
              },
              folderRemove: {
                data: {
                  action: "folderRemove"
                }
              },
              items: {
                data: {
                  action: "files"
                }
              },
              folder: {
                data: {
                  action: "folders"
                }
              },
              permissions: {
                data: {
                  action: "permissions"
                }
              }
            }, r.Config.prototype.controls.filebrowser = {
              upload: {
                icon: "plus",
                isInput: !0,
                isDisabled: function (e) {
                  return !e.dataProvider.canI("FileUpload");
                },
                getContent: function (e) {
                  var t = new a.UIFileInput(e, {
                    onlyImages: e.state.onlyImages
                  });
                  return e.e.fire("bindUploader.filebrowser", t.container), t.container;
                }
              },
              remove: {
                icon: "bin",
                isDisabled: function (e) {
                  return !e.state.activeElements.length || !e.dataProvider.canI("FileRemove");
                },
                exec: function (e) {
                  e.e.fire("fileRemove.filebrowser");
                }
              },
              update: {
                exec: function (e) {
                  e.e.fire("update.filebrowser");
                }
              },
              select: {
                icon: "check",
                isDisabled: function (e) {
                  return !e.state.activeElements.length;
                },
                exec: function (e) {
                  e.e.fire("select.filebrowser");
                }
              },
              edit: {
                icon: "pencil",
                isDisabled: function (e) {
                  var t = e.state.activeElements;
                  return 1 !== t.length || !t[0].isImage || !(e.dataProvider.canI("ImageCrop") || e.dataProvider.canI("ImageResize"));
                },
                exec: function (e) {
                  e.e.fire("edit.filebrowser");
                }
              },
              tiles: {
                icon: "th",
                isActive: function (e) {
                  return "tiles" === e.state.view;
                },
                exec: function (e) {
                  e.e.fire("view.filebrowser", "tiles");
                }
              },
              list: {
                icon: "th-list",
                isActive: function (e) {
                  return "list" === e.state.view;
                },
                exec: function (e) {
                  e.e.fire("view.filebrowser", "list");
                }
              },
              filter: {
                isInput: !0,
                getContent: function (e, t, o) {
                  var n = o.container.querySelector(".jodit-input");
                  if (n) return n;
                  var r = e.c.element("input", {
                    class: "jodit-input",
                    placeholder: e.i18n("Filter")
                  });
                  return r.value = e.state.filterWord, e.e.on(r, "keydown mousedown", e.async.debounce(function () {
                    e.e.fire("filter.filebrowser", r.value);
                  }, e.defaultTimeout)), r;
                }
              },
              sort: {
                isInput: !0,
                getContent: function (e) {
                  var t = e.c.fromHTML('<select class="jodit-input jodit-select">' + '<option value="changed-asc">'.concat(e.i18n("Sort by changed"), " (⬆)</option>") + '<option value="changed-desc">'.concat(e.i18n("Sort by changed"), " (⬇)</option>") + '<option value="name-asc">'.concat(e.i18n("Sort by name"), " (⬆)</option>") + '<option value="name-desc">'.concat(e.i18n("Sort by name"), " (⬇)</option>") + '<option value="size-asc">'.concat(e.i18n("Sort by size"), " (⬆)</option>") + '<option value="size-desc">'.concat(e.i18n("Sort by size"), " (⬇)</option>") + "</select>");
                  return t.value = e.state.sortBy, e.e.on("sort.filebrowser", function (e) {
                    t.value !== e && (t.value = e);
                  }).on(t, "change", function () {
                    e.e.fire("sort.filebrowser", t.value);
                  }), t;
                }
              }
            };
          },
          82530: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.DEFAULT_SOURCE_NAME = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(30056),
              a = o(43441),
              s = o(63511);
            t.DEFAULT_SOURCE_NAME = "default";
            var l = function () {
              function e(e, t) {
                this.parent = e, this.options = t, this.__currentPermissions = null, this.ajaxInstances = new Map(), this.progressHandler = function (e) {};
              }
              return Object.defineProperty(e.prototype, "o", {
                get: function () {
                  return this.options;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.get = function (e) {
                var t = this,
                  o = this.ajaxInstances;
                if (o.has(e)) {
                  var n = o.get(e);
                  null == n || n.abort(), o.delete(e);
                }
                var a = (0, r.ConfigProto)(void 0 !== this.options[e] ? this.options[e] : {}, (0, r.ConfigProto)({
                  onProgress: this.progressHandler
                }, this.o.ajax));
                a.prepareData && (a.data = a.prepareData.call(this, a.data));
                var s = new i.Ajax(a);
                o.set(e, s);
                var l = s.send();
                return l.finally(function () {
                  s.destruct(), o.delete(e), t.progressHandler(100);
                }).catch(function () {
                  return null;
                }), l.then(function (e) {
                  return e.json();
                }).then(function (e) {
                  if (e && !t.isSuccess(e)) throw new Error(t.getMessage(e));
                  return e;
                });
              }, e.prototype.onProgress = function (e) {
                this.progressHandler = e;
              }, e.prototype.permissions = function (e, t) {
                return n.__awaiter(this, void 0, Promise, function () {
                  var o = this;
                  return n.__generator(this, function (n) {
                    return this.o.permissions ? (this.o.permissions.data.path = e, this.o.permissions.data.source = t, this.o.permissions.url ? [2, this.get("permissions").then(function (e) {
                      var t = o.o.permissions.process;
                      if (t || (t = o.o.ajax.process), t) {
                        var n = t.call(self, e);
                        n.data.permissions && (o.__currentPermissions = n.data.permissions);
                      }
                      return o.__currentPermissions;
                    })] : [2, null]) : [2, null];
                  });
                });
              }, e.prototype.canI = function (e) {
                var t = "allow" + e,
                  o = this.o.permissionsPresets[t];
                return void 0 !== o ? o : null == this.__currentPermissions || void 0 === this.__currentPermissions[t] || this.__currentPermissions[t];
              }, e.prototype.__items = function (e, t, o, n) {
                var r = this,
                  i = this.options;
                return i.items ? (i.items.data.path = e, i.items.data.source = t, i.items.data.mods = o, this.get("items").then(function (e) {
                  var t = r.o.items.process;
                  return t || (t = r.o.ajax.process), t && (e = t.call(self, e)), n(e);
                })) : Promise.reject("Set Items api options");
              }, e.prototype.items = function (e, t, o) {
                var n = this;
                return void 0 === o && (o = {}), this.__items(e, t, o, function (e) {
                  return n.generateItemsList(e.data.sources, o);
                });
              }, e.prototype.itemsEx = function (e, t, o) {
                var n = this;
                return void 0 === o && (o = {}), this.__items(e, t, o, function (e) {
                  return {
                    items: n.generateItemsList(e.data.sources, o),
                    loadedTotal: (t = e.data.sources, t.reduce(function (e, t) {
                      return e + t.files.length;
                    }, 0))
                  };
                  var t;
                });
              }, e.prototype.generateItemsList = function (e, t) {
                var o = this;
                void 0 === t && (t = {});
                var i = [];
                return e.forEach(function (e) {
                  if (e.files && e.files.length) {
                    var a = o.o.sort;
                    (0, r.isFunction)(a) && t.sortBy && e.files.sort(function (e, o) {
                      return a(e, o, t.sortBy);
                    }), e.files.forEach(function (r) {
                      (function (e) {
                        var n;
                        return !(null === (n = t.filterWord) || void 0 === n ? void 0 : n.length) || void 0 === o.o.filter || o.o.filter(e, t.filterWord);
                      })(r) && function (e) {
                        return "folder" === e.type || !t.onlyImages || void 0 === e.isImage || e.isImage;
                      }(r) && i.push(s.FileBrowserItem.create(n.__assign(n.__assign({}, r), {
                        sourceName: e.name,
                        source: e
                      })));
                    });
                  }
                }), i;
              }, e.prototype.tree = function (e, t) {
                return n.__awaiter(this, void 0, Promise, function () {
                  var o = this;
                  return n.__generator(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return e = (0, r.normalizeRelativePath)(e), this.o.folder ? [4, this.permissions(e, t)] : [2, Promise.reject("Set Folder Api options")];
                      case 1:
                        return n.sent(), this.o.folder.data.path = e, this.o.folder.data.source = t, [2, this.get("folder").then(function (e) {
                          var t = o.o.folder.process;
                          return t || (t = o.o.ajax.process), t && (e = t.call(self, e)), e.data.sources;
                        })];
                    }
                  });
                });
              }, e.prototype.getPathByUrl = function (e) {
                var t = this;
                return (0, r.set)("options.getLocalFileByUrl.data.url", e, this), this.get("getLocalFileByUrl").then(function (e) {
                  if (t.isSuccess(e)) return e.data;
                  throw (0, r.error)(t.getMessage(e));
                });
              }, e.prototype.createFolder = function (e, t, o) {
                var n = this,
                  i = this.o.create;
                if (!i) throw (0, r.error)("Set Create api options");
                return i.data.source = o, i.data.path = t, i.data.name = e, this.get("create").then(function (e) {
                  if (n.isSuccess(e)) return !0;
                  throw (0, r.error)(n.getMessage(e));
                });
              }, e.prototype.move = function (e, t, o, n) {
                var i = this,
                  a = n ? "fileMove" : "folderMove",
                  s = this.options[a];
                if (!s) throw (0, r.error)("Set Move api options");
                return s.data.from = e, s.data.path = t, s.data.source = o, this.get(a).then(function (e) {
                  if (i.isSuccess(e)) return !0;
                  throw (0, r.error)(i.getMessage(e));
                });
              }, e.prototype.remove = function (e, t, o, n) {
                var i = this,
                  a = this.o[e];
                if (!a) throw (0, r.error)('Set "'.concat(e, '" api options'));
                return a.data.path = t, a.data.name = o, a.data.source = n, this.get(e).then(function (e) {
                  return a.process && (e = a.process.call(i, e)), i.getMessage(e);
                });
              }, e.prototype.fileRemove = function (e, t, o) {
                return this.remove("fileRemove", e, t, o);
              }, e.prototype.folderRemove = function (e, t, o) {
                return this.remove("folderRemove", e, t, o);
              }, e.prototype.rename = function (e, t, o, n, i) {
                var a = this,
                  s = this.o[e];
                if (!s) throw (0, r.error)('Set "'.concat(e, '" api options'));
                return s.data.path = t, s.data.name = o, s.data.newname = n, s.data.source = i, this.get(e).then(function (e) {
                  return s.process && (e = s.process.call(self, e)), a.getMessage(e);
                });
              }, e.prototype.folderRename = function (e, t, o, n) {
                return this.rename("folderRename", e, t, o, n);
              }, e.prototype.fileRename = function (e, t, o, n) {
                return this.rename("fileRename", e, t, o, n);
              }, e.prototype.changeImage = function (e, t, o, n, r, i) {
                this.o[e] || (this.o[e] = {
                  data: {}
                });
                var a = this.o[e];
                return void 0 === a.data && (a.data = {
                  action: e
                }), a.data.newname = r || n, i && (a.data.box = i), a.data.path = t, a.data.name = n, a.data.source = o, this.get(e).then(function () {
                  return !0;
                });
              }, e.prototype.crop = function (e, t, o, n, r) {
                return this.changeImage("crop", e, t, o, n, r);
              }, e.prototype.resize = function (e, t, o, n, r) {
                return this.changeImage("resize", e, t, o, n, r);
              }, e.prototype.getMessage = function (e) {
                return this.options.getMessage(e);
              }, e.prototype.isSuccess = function (e) {
                return this.options.isSuccess(e);
              }, e.prototype.destruct = function () {
                this.ajaxInstances.forEach(function (e) {
                  return e.destruct();
                }), this.ajaxInstances.clear();
              }, n.__decorate([a.autobind], e);
            }();
            t.default = l;
          },
          46341: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.makeContextMenu = t.makeDataProvider = void 0;
            var n = o(82530),
              r = o(60403);
            t.makeDataProvider = function (e, t) {
              return new n.default(e, t);
            }, t.makeContextMenu = function (e) {
              return new r.ContextMenu(e);
            };
          },
          48096: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.deleteFile = void 0, t.deleteFile = function (e, t, o) {
              return e.dataProvider.fileRemove(e.state.currentPath, t, o).then(function (o) {
                e.status(o || e.i18n('File "%s" was deleted', t), !0);
              }).catch(e.status);
            };
          },
          4253: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.loadItems = void 0, t.loadItems = function (e) {
              return e.files.setMod("active", !0), e.files.setMod("loading", !0), e.dataProvider.items(e.state.currentPath, e.state.currentSource, {
                sortBy: e.state.sortBy,
                onlyImages: e.state.onlyImages,
                filterWord: e.state.filterWord
              }).then(function (t) {
                t && (e.state.elements = t, e.state.activeElements = []);
              }).catch(e.status).finally(function () {
                return e.files.setMod("loading", !1);
              });
            };
          },
          36303: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.loadTree = void 0;
            var n = o(20255),
              r = o(64968),
              i = o(4253);
            t.loadTree = function (e) {
              return n.__awaiter(this, void 0, Promise, function () {
                var t, o;
                return n.__generator(this, function (n) {
                  return e.tree.setMod("active", !0), r.Dom.detach(e.tree.container), t = (0, i.loadItems)(e), e.o.showFoldersPanel ? (e.tree.setMod("loading", !0), o = e.dataProvider.tree(e.state.currentPath, e.state.currentSource).then(function (t) {
                    e.state.sources = t;
                  }).catch(e.status).finally(function () {
                    return e.tree.setMod("loading", !1);
                  }), [2, Promise.all([o, t])]) : (e.tree.setMod("active", !1), [2, t]);
                });
              });
            };
          },
          50885: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isFileBrowserFilesItem = t.FileBrowser = void 0;
            var n = o(20255);
            o(40692);
            var r = o(93166),
              i = o(86893),
              a = o(77462),
              s = o(40332),
              l = o(64968),
              c = o(46341),
              u = o(86774),
              d = o(21347),
              p = o(44734),
              f = o(82530),
              h = o(43441),
              m = o(98782),
              v = o(55395),
              g = o(36303),
              y = o(4253),
              _ = o(56562),
              b = o(59829),
              w = o(43608);
            o(38097);
            var S = function (e) {
              function t(t) {
                var o,
                  n = this;
                (n = e.call(this, t) || this).browser = n.c.div(n.componentName), n.status_line = n.c.div(n.getFullElName("status")), n.tree = new m.FileBrowserTree(n), n.files = new m.FileBrowserFiles(n), n.state = (0, v.observable)({
                  currentPath: "",
                  currentSource: f.DEFAULT_SOURCE_NAME,
                  currentBaseUrl: "",
                  activeElements: [],
                  elements: [],
                  sources: [],
                  view: "tiles",
                  sortBy: "changed-desc",
                  filterWord: "",
                  onlyImages: !1
                }), n.errorHandler = function (e) {
                  (0, s.isAbort)(e) || (e instanceof Error ? n.status(n.i18n(e.message)) : n.status(n.dataProvider.getMessage(e)));
                }, n.close = function () {
                  n._dialog.close();
                }, n.attachEvents(t);
                var i = n;
                i.options = (0, s.ConfigProto)(t || {}, r.Config.defaultOptions.filebrowser), i.storage = a.Storage.makeStorage(Boolean(n.o.saveStateInStorage), n.componentName), i.dataProvider = (0, c.makeDataProvider)(i, i.options), i._dialog = n.dlg({
                  minWidth: Math.min(700, screen.width),
                  minHeight: 300,
                  buttons: null !== (o = n.o.headerButtons) && void 0 !== o ? o : ["fullsize", "dialog.close"]
                }), n.proxyDialogEvents(i), i.browser.component = n, i.container = i.browser, i.o.showFoldersPanel && i.browser.appendChild(i.tree.container), i.browser.appendChild(i.files.container), i.browser.appendChild(i.status_line), p.selfListeners.call(i), d.nativeListeners.call(i), u.stateListeners.call(i), i._dialog.setSize(i.o.width, i.o.height), ["getLocalFileByUrl", "crop", "resize", "create", "fileMove", "folderMove", "fileRename", "folderRename", "fileRemove", "folderRemove", "folder", "items", "permissions"].forEach(function (e) {
                  null != n.options[e] && (n.options[e] = (0, s.ConfigProto)(n.options[e], n.o.ajax));
                });
                var l = n.o.saveStateInStorage || {
                    storeLastOpenedFolder: !1,
                    storeView: !1,
                    storeSortBy: !1
                  },
                  h = l.storeSortBy,
                  g = l.storeLastOpenedFolder,
                  y = l.storeView && n.storage.get("view");
                i.state.view = y && null == n.o.view ? "list" === y ? "list" : "tiles" : "list" === i.o.view ? "list" : "tiles", i.files.setMod("view", i.state.view);
                var b = h && i.storage.get("sortBy");
                if (b) {
                  var w = b.split("-");
                  i.state.sortBy = ["changed", "name", "size"].includes(w[0]) ? b : "changed-desc";
                } else i.state.sortBy = i.o.sortBy || "changed-desc";
                if (g) {
                  var S = i.storage.get("currentPath"),
                    C = i.storage.get("currentSource");
                  i.state.currentPath = null != S ? S : "", i.state.currentSource = null != C ? C : "";
                }
                return i.initUploader(i), i.setStatus(_.STATUSES.ready), n;
              }
              return n.__extends(t, e), t.prototype.className = function () {
                return "Filebrowser";
              }, t.prototype.onSelect = function (e) {
                var t = this;
                return function () {
                  if (t.state.activeElements.length) {
                    var o = [],
                      n = [];
                    t.state.activeElements.forEach(function (e) {
                      var t = e.fileURL;
                      t && (o.push(t), n.push(e.isImage || !1));
                    }), t.close();
                    var r = {
                      baseurl: "",
                      files: o,
                      isImages: n
                    };
                    (0, s.isFunction)(e) && e(r), t.close();
                  }
                  return !1;
                };
              }, Object.defineProperty(t.prototype, "isOpened", {
                get: function () {
                  return this._dialog.isOpened && "none" !== this.browser.style.display;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.status = function (e, t) {
                e && !(0, s.isAbort)(e) && ((0, s.isString)(e) || (e = e.message), (0, s.isString)(e) && (0, s.trim)(e).length && this.message.message(e, t ? "success" : "error", this.o.howLongShowMsg));
              }, t.prototype.open = function (e, t) {
                var o = this;
                return void 0 === e && (e = this.o.defaultCallback), void 0 === t && (t = !1), this.state.onlyImages = t, this.async.promise(function (t, n) {
                  if (!o.o.items || !o.o.items.url) throw (0, s.error)("Need set options.filebrowser.ajax.url");
                  var r = 0;
                  o.e.off(o.files.container, "dblclick").on(o.files.container, "dblclick", o.onSelect(e)).on(o.files.container, "touchstart", function () {
                    var t = new Date().getTime();
                    i.EMULATE_DBLCLICK_TIMEOUT > t - r && o.onSelect(e)(), r = t;
                  }).off("select.filebrowser").on("select.filebrowser", o.onSelect(e));
                  var a = o.c.div();
                  o.toolbar.build(o.__getButtons()).appendTo(a), o._dialog.open(o.browser, a), o.e.fire("sort.filebrowser", o.state.sortBy), (0, g.loadTree)(o).then(t, n);
                });
              }, t.prototype.__getButtons = function () {
                var e,
                  t = this;
                return (null !== (e = this.o.buttons) && void 0 !== e ? e : []).filter(function (e) {
                  if (!(0, s.isString)(e)) return !0;
                  switch (e) {
                    case "filebrowser.upload":
                      return t.dataProvider.canI("FileUpload");
                    case "filebrowser.edit":
                      return t.dataProvider.canI("ImageResize") || t.dataProvider.canI("ImageCrop");
                    case "filebrowser.remove":
                      return t.dataProvider.canI("FileRemove");
                  }
                  return !0;
                });
              }, t.prototype.initUploader = function (e) {
                var t,
                  o = this,
                  n = this,
                  i = null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.uploader,
                  a = (0, s.ConfigProto)(i || {}, r.Config.defaultOptions.uploader),
                  l = function () {
                    return (0, y.loadItems)(o);
                  };
                n.uploader = n.getInstance("Uploader", a), n.uploader.setPath(n.state.currentPath).setSource(n.state.currentSource).bind(n.browser, l, n.errorHandler), this.state.on(["change.currentPath", "change.currentSource"], function () {
                  o.uploader.setPath(o.state.currentPath).setSource(o.state.currentSource);
                }), n.e.on("bindUploader.filebrowser", function (e) {
                  n.uploader.bind(e, l, n.errorHandler);
                });
              }, t.prototype.proxyDialogEvents = function (e) {
                var t = this;
                ["afterClose", "beforeOpen"].forEach(function (o) {
                  e._dialog.events.on(e.dlg, o, function () {
                    t.e.fire(o);
                  });
                });
              }, t.prototype.destruct = function () {
                this.isInDestruct || (e.prototype.destruct.call(this), this._dialog.destruct(), this.events && this.e.off(".filebrowser"), this.uploader && this.uploader.destruct());
              }, n.__decorate([h.autobind], t.prototype, "status", null), n.__decorate([h.autobind], t.prototype, "open", null), n.__decorate([(0, h.derive)(b.Dlgs)], t);
            }(w.ViewWithToolbar);
            t.FileBrowser = S, t.isFileBrowserFilesItem = function (e) {
              return l.Dom.isElement(e) && e.classList.contains(m.FileBrowserFiles.prototype.getFullElName("item"));
            };
          },
          63463: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(50885), t);
          },
          21347: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.nativeListeners = t.elementToItem = t.getItem = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(34468),
              a = o(64968),
              s = o(66267),
              l = o(36303);
            t.getItem = function (e, t, o) {
              return void 0 === o && (o = "a"), a.Dom.closest(e, function (e) {
                return a.Dom.isTag(e, o);
              }, t);
            }, t.elementToItem = function (e, t) {
              return t[e.dataset.key || ""].item;
            }, t.nativeListeners = function () {
              var e = this,
                o = !1,
                a = (0, s.elementsMap)(this),
                c = this;
              c.e.on(c.tree.container, "dragstart", function (e) {
                var n = (0, t.getItem)(e.target, c.container);
                n && c.o.moveFolder && (o = n);
              }).on(c.tree.container, "drop", function (n) {
                if ((c.o.moveFile || c.o.moveFolder) && o) {
                  var i = (0, r.attr)(o, "-path") || "";
                  if (!c.o.moveFolder && o.classList.contains(e.tree.getFullElName("item"))) return !1;
                  if (o.classList.contains(e.files.getFullElName("item")) && (i += (0, r.attr)(o, "-name"), !c.o.moveFile)) return !1;
                  var a = (0, t.getItem)(n.target, c.container);
                  if (!a) return;
                  c.dataProvider.move(i, (0, r.attr)(a, "-path") || "", (0, r.attr)(a, "-source") || "", o.classList.contains(e.files.getFullElName("item"))).then(function () {
                    return (0, l.loadTree)(e);
                  }).catch(c.status), o = !1;
                }
              }).on(c.files.container, "contextmenu", (0, i.default)(c)).on(c.files.container, "click", function (t) {
                (0, r.ctrlKey)(t) || (e.state.activeElements = []);
              }).on(c.files.container, "click", function (e) {
                var o = (0, t.getItem)(e.target, c.container);
                if (o) {
                  var i = (0, t.elementToItem)(o, a);
                  if (i) return c.state.activeElements = (0, r.ctrlKey)(e) ? n.__spreadArray(n.__spreadArray([], n.__read(c.state.activeElements), !1), [i], !1) : [i], e.stopPropagation(), !1;
                }
              }).on(c.files.container, "dragstart", function (e) {
                if (c.o.moveFile) {
                  var n = (0, t.getItem)(e.target, c.container);
                  if (!n) return;
                  o = n;
                }
              }).on(c.container, "drop", function (e) {
                return e.preventDefault();
              });
            };
          },
          44734: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.selfListeners = void 0;
            var n = o(20255),
              r = o(10172),
              i = o(40332),
              a = o(82530),
              s = o(35503),
              l = o(36303),
              c = o(4253),
              u = o(48096);
            t.selfListeners = function () {
              var e = this,
                t = this.state,
                o = this.dataProvider,
                d = this;
              d.e.on("view.filebrowser", function (e) {
                e !== t.view && (t.view = e);
              }).on("sort.filebrowser", function (e) {
                e !== t.sortBy && (t.sortBy = e, (0, c.loadItems)(d));
              }).on("filter.filebrowser", function (e) {
                e !== t.filterWord && (t.filterWord = e, (0, c.loadItems)(d));
              }).on("openFolder.filebrowser", function (e) {
                var t;
                t = ".." === e.name ? e.path.split("/").filter(function (e) {
                  return e.length;
                }).slice(0, -1).join("/") : (0, i.normalizePath)(e.path, e.name), d.state.currentPath = t, d.state.currentSource = "." === e.name ? a.DEFAULT_SOURCE_NAME : e.source;
              }).on("removeFolder.filebrowser", function (e) {
                d.confirm("Are you sure?", "Delete", function (t) {
                  t && o.folderRemove(e.path, e.name, e.source).then(function (e) {
                    return d.status(e, !0), (0, l.loadTree)(d);
                  }).catch(d.status);
                });
              }).on("renameFolder.filebrowser", function (e) {
                d.prompt("Enter new name", "Rename", function (t) {
                  if (!(0, r.isValidName)(t)) return d.status(d.i18n("Enter new name")), !1;
                  o.folderRename(e.path, e.name, t, e.source).then(function (e) {
                    return d.state.activeElements = [], d.status(e, !0), (0, l.loadTree)(d);
                  }).catch(d.status);
                }, "type name", e.name);
              }).on("addFolder.filebrowser", function (e) {
                d.prompt("Enter Directory name", "Create directory", function (t) {
                  o.createFolder(t, e.path, e.source).then(function () {
                    return (0, l.loadTree)(d);
                  }).catch(d.status);
                }, "type name");
              }).on("fileRemove.filebrowser", function () {
                d.state.activeElements.length && d.confirm("Are you sure?", "", function (e) {
                  if (e) {
                    var t = [];
                    d.state.activeElements.forEach(function (e) {
                      t.push((0, u.deleteFile)(d, e.file || e.name || "", e.sourceName));
                    }), d.state.activeElements = [], Promise.all(t).then(function () {
                      return (0, l.loadTree)(d).catch(d.status);
                    }, d.status);
                  }
                });
              }).on("edit.filebrowser", function () {
                if (1 === d.state.activeElements.length) {
                  var t = n.__read(e.state.activeElements, 1)[0];
                  s.openImageEditor.call(d, t.fileURL, t.file || "", t.path, t.sourceName);
                }
              }).on("fileRename.filebrowser", function (e, t, n) {
                1 === d.state.activeElements.length && d.prompt("Enter new name", "Rename", function (i) {
                  if (!(0, r.isValidName)(i)) return d.status(d.i18n("Enter new name")), !1;
                  o.fileRename(t, e, i, n).then(function (e) {
                    d.state.activeElements = [], d.status(e, !0), (0, c.loadItems)(d);
                  }).catch(d.status);
                }, "type name", e);
              }).on("update.filebrowser", function () {
                (0, l.loadTree)(e).then(e.status, e.status);
              });
            };
          },
          86774: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.stateListeners = void 0;
            var n = o(64968),
              r = o(89693),
              i = o(2074),
              a = o(66267),
              s = o(36303);
            t.stateListeners = function () {
              var e = this,
                t = (0, a.elementsMap)(this),
                o = this,
                l = o.state,
                c = o.files,
                u = o.create,
                d = o.options;
              l.on(["change.currentPath", "change.currentSource"], this.async.debounce(function () {
                e.o.saveStateInStorage && e.o.saveStateInStorage.storeLastOpenedFolder && e.storage.set("currentPath", e.state.currentPath).set("currentSource", e.state.currentSource), (0, s.loadTree)(e).catch(e.status);
              }, this.defaultTimeout)).on("beforeChange.activeElements", function () {
                l.activeElements.forEach(function (e) {
                  var o = t[e.uniqueHashKey].elm;
                  o && o.classList.remove(c.getFullElName("item", "active", !0));
                });
              }).on("change.activeElements", function () {
                e.e.fire("changeSelection"), l.activeElements.forEach(function (e) {
                  var o = t[e.uniqueHashKey].elm;
                  o && o.classList.add(c.getFullElName("item", "active", !0));
                });
              }).on("change.view", function () {
                c.setMod("view", l.view), e.o.saveStateInStorage && e.o.saveStateInStorage.storeView && e.storage.set("view", l.view);
              }).on("change.sortBy", function () {
                e.o.saveStateInStorage && e.o.saveStateInStorage.storeSortBy && e.storage.set("sortBy", l.sortBy);
              }).on("change.elements", this.async.debounce(function () {
                n.Dom.detach(c.container), l.elements.length ? l.elements.forEach(function (o) {
                  e.files.container.appendChild(function (o) {
                    var n = o.uniqueHashKey;
                    if (t[n]) return t[n].elm;
                    var r = u.fromHTML(d.getThumbTemplate.call(e, o, o.source, o.sourceName.toString()));
                    return r.dataset.key = n, t[n] = {
                      item: o,
                      elm: r
                    }, t[n].elm;
                  }(o));
                }) : c.container.appendChild(u.div(e.componentName + "_no-files_true", e.i18n("There are no files")));
              }, this.defaultTimeout)).on("change.sources", this.async.debounce(function () {
                n.Dom.detach(e.tree.container), l.sources.forEach(function (t) {
                  var o = t.name;
                  if (o && "default" !== o && e.tree.container.appendChild(u.div(e.tree.getFullElName("source-title"), o)), t.folders.forEach(function (n) {
                    var a,
                      s = u.a(e.tree.getFullElName("item"), {
                        draggable: "draggable",
                        href: "#",
                        "data-path": (0, r.normalizePath)(t.path, n + "/"),
                        "data-name": n,
                        "data-source": o,
                        "data-source-path": t.path
                      }, u.span(e.tree.getFullElName("item-title"), n)),
                      l = function (i) {
                        return function (a) {
                          e.e.fire("".concat(i, ".filebrowser"), {
                            name: n,
                            path: (0, r.normalizePath)(t.path + "/"),
                            source: o
                          }), a.stopPropagation(), a.preventDefault();
                        };
                      };
                    e.e.on(s, "click", l("openFolder")), e.tree.container.appendChild(s), ".." !== n && "." !== n && (d.renameFolder && e.dataProvider.canI("FolderRename") && ((a = (0, i.Button)(e, {
                      icon: {
                        name: "pencil"
                      },
                      name: "rename",
                      tooltip: "Rename",
                      size: "tiny"
                    })).onAction(l("renameFolder")), s.appendChild(a.container)), d.deleteFolder && e.dataProvider.canI("FolderRemove") && ((a = (0, i.Button)(e, {
                      icon: {
                        name: "cancel"
                      },
                      name: "remove",
                      tooltip: "Delete",
                      size: "tiny"
                    })).onAction(l("removeFolder")), s.appendChild(a.container)));
                  }), d.createNewFolder && e.dataProvider.canI("FolderCreate")) {
                    var n = (0, i.Button)(e, "plus", "Add folder", "secondary");
                    n.onAction(function () {
                      e.e.fire("addFolder", {
                        path: (0, r.normalizePath)(t.path + "/"),
                        source: o
                      });
                    }), e.tree.append(n);
                  }
                });
              }, this.defaultTimeout));
            };
          },
          21505: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.FileBrowserFiles = void 0;
            var n = o(20255);
            o(27452);
            var r = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return n.__extends(t, e), t.prototype.className = function () {
                return "FilebrowserFiles";
              }, t;
            }(o(2074).UIGroup);
            t.FileBrowserFiles = r;
          },
          98782: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(21505), t), n.__exportStar(o(42472), t);
          },
          42472: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.FileBrowserTree = void 0;
            var n = o(20255);
            o(51422);
            var r = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return n.__extends(t, e), t.prototype.className = function () {
                return "FilebrowserTree";
              }, t;
            }(o(2074).UIGroup);
            t.FileBrowserTree = r;
          },
          3107: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Command = void 0;
            var o = function () {
              function e(e, t, o, n) {
                this.oldValue = e, this.newValue = t, this.history = o, this.tick = n;
              }
              return e.prototype.undo = function () {
                this.history.snapshot.restore(this.oldValue);
              }, e.prototype.redo = function () {
                this.history.snapshot.restore(this.newValue);
              }, e;
            }();
            t.Command = o;
          },
          15432: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.History = void 0;
            var n = o(20255),
              r = o(93166),
              i = o(56562),
              a = o(31648),
              s = o(3621),
              l = o(3107),
              c = o(43441);
            r.Config.prototype.history = {
              enable: !0,
              maxHistoryLength: 1 / 0,
              timeout: 1e3
            }, r.Config.prototype.observer = r.Config.prototype.history;
            var u = function (e) {
              function t(t, o, n) {
                void 0 === o && (o = new s.Stack(t.o.history.maxHistoryLength)), void 0 === n && (n = new a.Snapshot(t));
                var r = e.call(this, t) || this;
                return r.updateTick = 0, r.__stack = o, r.snapshot = n, t.o.history.enable && t.e.on("afterAddPlace.history", function () {
                  r.isInDestruct || (r.startValue = r.snapshot.make(), t.events.on("internalChange internalUpdate", function () {
                    r.startValue = r.snapshot.make();
                  }).on(t.editor, ["changeSelection", "selectionstart", "selectionchange", "mousedown", "mouseup", "keydown", "keyup"].map(function (e) {
                    return e + ".history";
                  }).join(" "), function () {
                    r.startValue.html === r.j.getNativeEditorValue() && (r.startValue = r.snapshot.make());
                  }).on(r, "change.history", r.onChange));
                }), r;
              }
              return n.__extends(t, e), t.prototype.className = function () {
                return "History";
              }, Object.defineProperty(t.prototype, "startValue", {
                get: function () {
                  return this.__startValue;
                },
                set: function (e) {
                  this.__startValue = e;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.__upTick = function () {
                this.updateTick += 1;
              }, t.prototype.onChange = function () {
                this.__processChanges();
              }, t.prototype.__processChanges = function () {
                !this.snapshot.isBlocked && this.j.o.history.enable && this.updateStack();
              }, t.prototype.updateStack = function (e) {
                void 0 === e && (e = !1);
                var t = this.snapshot.make();
                if (!a.Snapshot.equal(t, this.startValue)) {
                  var o = new l.Command(this.startValue, t, this, this.updateTick);
                  if (e) {
                    var n = this.__stack.current();
                    n && this.updateTick === n.tick && this.__stack.replace(o);
                  } else this.__stack.push(o);
                  this.startValue = t, this.fireChangeStack();
                }
              }, t.prototype.redo = function () {
                this.__stack.redo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
              }, t.prototype.canRedo = function () {
                return this.__stack.canRedo();
              }, t.prototype.undo = function () {
                this.__stack.undo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
              }, t.prototype.canUndo = function () {
                return this.__stack.canUndo();
              }, t.prototype.clear = function () {
                this.startValue = this.snapshot.make(), this.__stack.clear(), this.fireChangeStack();
              }, Object.defineProperty(t.prototype, "length", {
                get: function () {
                  return this.__stack.length;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.fireChangeStack = function () {
                var e;
                this.j && !this.j.isInDestruct && (null === (e = this.j.events) || void 0 === e || e.fire("changeStack"));
              }, t.prototype.destruct = function () {
                this.isInDestruct || (this.j.events && this.j.e.off(".history"), this.snapshot.destruct(), e.prototype.destruct.call(this));
              }, n.__decorate([(0, c.debounce)()], t.prototype, "onChange", null), t;
            }(i.ViewComponent);
            t.History = u;
          },
          31648: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Snapshot = void 0;
            var n = o(20255),
              r = o(56562),
              i = o(64968),
              a = o(86893),
              s = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.__isBlocked = !1, t;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "Snapshot";
                }, t.equal = function (e, t) {
                  return e.html === t.html && JSON.stringify(e.range) === JSON.stringify(t.range);
                }, t.countNodesBeforeInParent = function (e) {
                  if (!e.parentNode) return 0;
                  for (var t = e.parentNode.childNodes, o = 0, n = null, r = 0; t.length > r; r += 1) {
                    if (!n || this.isIgnoredNode(t[r]) || i.Dom.isText(n) && i.Dom.isText(t[r]) || (o += 1), t[r] === e) return o;
                    n = t[r];
                  }
                  return 0;
                }, t.strokeOffset = function (e, t) {
                  for (; i.Dom.isText(e);) i.Dom.isText(e = e.previousSibling) && e.nodeValue && (t += e.nodeValue.length);
                  return t;
                }, t.prototype.calcHierarchyLadder = function (e) {
                  var o = [];
                  if (!e || !e.parentNode || !i.Dom.isOrContains(this.j.editor, e)) return [];
                  for (; e && e !== this.j.editor;) e && !t.isIgnoredNode(e) && o.push(t.countNodesBeforeInParent(e)), e = e.parentNode;
                  return o.reverse();
                }, t.prototype.getElementByLadder = function (e) {
                  var t,
                    o = this.j.editor;
                  for (t = 0; o && e.length > t; t += 1) o = o.childNodes[e[t]];
                  return o;
                }, Object.defineProperty(t.prototype, "isBlocked", {
                  get: function () {
                    return this.__isBlocked;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.__block = function (e) {
                  this.__isBlocked = e;
                }, t.prototype.transaction = function (e) {
                  this.__block(!0);
                  try {
                    e();
                  } catch (e) {}
                  this.__block(!1);
                }, t.prototype.make = function () {
                  var e = {
                    html: "",
                    range: {
                      startContainer: [],
                      startOffset: 0,
                      endContainer: [],
                      endOffset: 0
                    }
                  };
                  e.html = this.removeJoditSelection(this.j.editor);
                  var o = this.j.s.sel;
                  if (o && o.rangeCount) {
                    var n = o.getRangeAt(0),
                      r = this.calcHierarchyLadder(n.startContainer),
                      i = this.calcHierarchyLadder(n.endContainer),
                      a = t.strokeOffset(n.startContainer, n.startOffset),
                      s = t.strokeOffset(n.endContainer, n.endOffset);
                    r.length || n.startContainer === this.j.editor || (a = 0), i.length || n.endContainer === this.j.editor || (s = 0), e.range = {
                      startContainer: r,
                      startOffset: a,
                      endContainer: i,
                      endOffset: s
                    };
                  }
                  return e;
                }, t.prototype.restore = function (e) {
                  var t = this;
                  this.transaction(function () {
                    var o = t.storeScrollState();
                    t.j.getNativeEditorValue() !== e.html && (t.j.value = e.html), t.restoreOnlySelection(e), t.restoreScrollState(o);
                  });
                }, t.prototype.storeScrollState = function () {
                  return [this.j.ow.scrollY, this.j.editor.scrollTop];
                }, t.prototype.restoreScrollState = function (e) {
                  var t = this.j,
                    o = t.ow;
                  o.scrollTo(o.scrollX, e[0]), t.editor.scrollTop = e[1];
                }, t.prototype.restoreOnlySelection = function (e) {
                  try {
                    if (e.range) {
                      var t = this.j.ed.createRange();
                      t.setStart(this.getElementByLadder(e.range.startContainer), e.range.startOffset), t.setEnd(this.getElementByLadder(e.range.endContainer), e.range.endOffset), this.j.s.selectRange(t);
                    }
                  } catch (e) {
                    this.j.editor.lastChild && this.j.s.setCursorAfter(this.j.editor.lastChild);
                  }
                }, t.prototype.destruct = function () {
                  this.__block(!1), e.prototype.destruct.call(this);
                }, t.isIgnoredNode = function (e) {
                  return i.Dom.isText(e) && !e.nodeValue || i.Dom.isTemporary(e);
                }, t.prototype.removeJoditSelection = function (e) {
                  var t = e.cloneNode(!0);
                  return t.querySelectorAll("[".concat(a.TEMP_ATTR, "]")).forEach(i.Dom.unwrap), t.innerHTML;
                }, t;
              }(r.ViewComponent);
            t.Snapshot = s;
          },
          3621: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Stack = void 0;
            var o = function () {
              function e(e) {
                this.size = e, this.commands = [], this.stackPosition = -1;
              }
              return Object.defineProperty(e.prototype, "length", {
                get: function () {
                  return this.commands.length;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.clearRedo = function () {
                this.commands.length = this.stackPosition + 1;
              }, e.prototype.clear = function () {
                this.commands.length = 0, this.stackPosition = -1;
              }, e.prototype.push = function (e) {
                this.clearRedo(), this.commands.push(e), this.stackPosition += 1, this.commands.length > this.size && (this.commands.shift(), this.stackPosition -= 1);
              }, e.prototype.replace = function (e) {
                this.commands[this.stackPosition] = e;
              }, e.prototype.current = function () {
                return this.commands[this.stackPosition];
              }, e.prototype.undo = function () {
                return !!this.canUndo() && (this.commands[this.stackPosition] && this.commands[this.stackPosition].undo(), this.stackPosition -= 1, !0);
              }, e.prototype.redo = function () {
                return !!this.canRedo() && (this.stackPosition += 1, this.commands[this.stackPosition] && this.commands[this.stackPosition].redo(), !0);
              }, e.prototype.canUndo = function () {
                return this.stackPosition >= 0;
              }, e.prototype.canRedo = function () {
                return this.commands.length - 1 > this.stackPosition;
              }, e;
            }();
            t.Stack = o;
          },
          95356: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.imageeditor = {
              min_width: 20,
              min_height: 20,
              closeAfterSave: !1,
              width: "85%",
              height: "85%",
              crop: !0,
              resize: !0,
              resizeUseRatio: !0,
              resizeMinWidth: 20,
              resizeMinHeight: 20,
              cropUseRatio: !0,
              cropDefaultWidth: "70%",
              cropDefaultHeight: "70%"
            }, r.Icon.set("crop", o(3610)).set("resize", o(56170));
          },
          35503: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.openImageEditor = t.ImageEditor = void 0;
            var n = o(20255);
            o(62820);
            var r = o(93166),
              i = o(56562),
              a = o(40332),
              s = o(64968),
              l = o(96516),
              c = o(9249),
              u = o(43441);
            o(95356);
            var d = "jodit-image-editor",
              p = "resize",
              f = "crop",
              h = function (e) {
                function t(t) {
                  var n = e.call(this, t) || this;
                  n.resizeUseRatio = !0, n.cropUseRatio = !0, n.clicked = !1, n.start_x = 0, n.start_y = 0, n.top_x = 0, n.top_y = 0, n.width = 0, n.height = 0, n.activeTab = p, n.naturalWidth = 0, n.naturalHeight = 0, n.ratio = 0, n.new_h = 0, n.new_w = 0, n.diff_x = 0, n.diff_y = 0, n.cropBox = {
                    x: 0,
                    y: 0,
                    w: 0,
                    h: 0
                  }, n.resizeBox = {
                    w: 0,
                    h: 0
                  }, n.calcCropBox = function () {
                    var e = n.crop_box.parentNode,
                      t = .8 * e.offsetWidth,
                      o = .8 * e.offsetHeight,
                      r = t,
                      i = o,
                      s = n.naturalWidth,
                      l = n.naturalHeight;
                    t > s && o > l ? (r = s, i = l) : n.ratio > t / o ? (r = t, i = l * (t / s)) : (r = s * (o / l), i = o), (0, a.css)(n.crop_box, {
                      width: r,
                      height: i
                    });
                  }, n.showCrop = function () {
                    if (n.cropImage) {
                      n.calcCropBox();
                      var e = n.cropImage.offsetWidth || n.image.offsetWidth || n.image.naturalWidth;
                      n.new_w = o.calcValueByPercent(e, n.o.cropDefaultWidth);
                      var t = n.cropImage.offsetHeight || n.image.offsetHeight || n.image.naturalHeight;
                      n.new_h = n.cropUseRatio ? n.new_w / n.ratio : o.calcValueByPercent(t, n.o.cropDefaultHeight), (0, a.css)(n.cropHandler, {
                        backgroundImage: "url(" + (0, a.attr)(n.cropImage, "src") + ")",
                        width: n.new_w,
                        height: n.new_h,
                        left: e / 2 - n.new_w / 2,
                        top: t / 2 - n.new_h / 2
                      }), n.j.e.fire(n.cropHandler, "updatesize");
                    }
                  }, n.updateCropBox = function () {
                    if (n.cropImage) {
                      var e = n.cropImage.offsetWidth / n.naturalWidth,
                        t = n.cropImage.offsetHeight / n.naturalHeight;
                      n.cropBox.x = (0, a.css)(n.cropHandler, "left") / e, n.cropBox.y = (0, a.css)(n.cropHandler, "top") / t, n.cropBox.w = n.cropHandler.offsetWidth / e, n.cropBox.h = n.cropHandler.offsetHeight / t, n.sizes.textContent = n.cropBox.w.toFixed(0) + "x" + n.cropBox.h.toFixed(0);
                    }
                  }, n.updateResizeBox = function () {
                    n.resizeBox.w = n.image.offsetWidth || n.naturalWidth, n.resizeBox.h = n.image.offsetHeight || n.naturalHeight;
                  }, n.setHandlers = function () {
                    var e = n,
                      t = (0, a.refs)(n.editor),
                      o = t.widthInput,
                      r = t.heightInput;
                    e.j.e.on([e.editor.querySelector(".jodit_bottomright"), e.cropHandler], "mousedown.".concat(d), n.onResizeHandleMouseDown).on(n.j.ow, "resize.".concat(d), function () {
                      n.j.e.fire(e.resizeHandler, "updatesize"), e.showCrop(), n.j.e.fire(e.cropHandler, "updatesize");
                    }), e.j.e.on((0, a.toArray)(n.editor.querySelectorAll(".".concat(d, "__slider-title"))), "click", n.onTitleModeClick).on([o, r], "input", n.onChangeSizeInput);
                    var i = (0, a.refs)(n.editor),
                      s = i.keepAspectRatioResize,
                      l = i.keepAspectRatioCrop;
                    s && s.addEventListener("change", function () {
                      n.resizeUseRatio = s.checked;
                    }), l && l.addEventListener("change", function () {
                      n.cropUseRatio = l.checked;
                    }), e.j.e.on(e.resizeHandler, "updatesize", function () {
                      (0, a.css)(e.resizeHandler, {
                        top: 0,
                        left: 0,
                        width: e.image.offsetWidth || e.naturalWidth,
                        height: e.image.offsetHeight || e.naturalHeight
                      }), n.updateResizeBox();
                    }).on(e.cropHandler, "updatesize", function () {
                      if (e.cropImage) {
                        var t = (0, a.css)(e.cropHandler, "left"),
                          o = (0, a.css)(e.cropHandler, "top"),
                          n = e.cropHandler.offsetWidth,
                          r = e.cropHandler.offsetHeight;
                        0 > t && (t = 0), 0 > o && (o = 0), t + n > e.cropImage.offsetWidth && (n = e.cropImage.offsetWidth - t, e.cropUseRatio && (r = n / e.ratio)), o + r > e.cropImage.offsetHeight && (r = e.cropImage.offsetHeight - o, e.cropUseRatio && (n = r * e.ratio)), (0, a.css)(e.cropHandler, {
                          width: n,
                          height: r,
                          left: t,
                          top: o,
                          backgroundPosition: -t - 1 + "px " + (-o - 1) + "px",
                          backgroundSize: e.cropImage.offsetWidth + "px " + e.cropImage.offsetHeight + "px"
                        }), e.updateCropBox();
                      }
                    }), Object.values(e.buttons).forEach(function (t) {
                      t.onAction(function () {
                        var n = {
                          action: e.activeTab,
                          box: e.activeTab === p ? e.resizeBox : e.cropBox
                        };
                        switch (t) {
                          case e.buttons.saveas:
                            e.j.prompt("Enter new name", "Save in new file", function (t) {
                              if (!(0, a.trim)(t)) return e.j.alert("The name should not be empty"), !1;
                              e.onSave(t, n, e.hide, function (t) {
                                e.j.alert(t.message);
                              });
                            });
                            break;
                          case e.buttons.save:
                            e.onSave(void 0, n, e.hide, function (t) {
                              e.j.alert(t.message);
                            });
                            break;
                          case e.buttons.reset:
                            e.activeTab === p ? ((0, a.css)(e.image, {
                              width: null,
                              height: null
                            }), o.value = e.naturalWidth.toString(), r.value = e.naturalHeight.toString(), e.j.e.fire(e.resizeHandler, "updatesize")) : e.showCrop();
                        }
                      });
                    });
                  }, n.options = t && t.o && t.o.imageeditor ? t.o.imageeditor : r.Config.defaultOptions.imageeditor;
                  var i = n.options;
                  n.resizeUseRatio = i.resizeUseRatio, n.cropUseRatio = i.cropUseRatio, n.buttons = {
                    reset: (0, l.Button)(n.j, "update", "Reset"),
                    save: (0, l.Button)(n.j, "save", "Save"),
                    saveas: (0, l.Button)(n.j, "save", "Save as ...")
                  }, n.activeTab = i.resize ? p : f, n.editor = (0, c.form)(n.j, n.options);
                  var s = (0, a.refs)(n.editor),
                    u = s.cropBox;
                  return n.resize_box = s.resizeBox, n.crop_box = u, n.sizes = n.editor.querySelector(".".concat(d, "__area.").concat(d, "__area_crop .jodit-image-editor__sizes")), n.resizeHandler = n.editor.querySelector(".".concat(d, "__resizer")), n.cropHandler = n.editor.querySelector(".".concat(d, "__croper")), n._dialog = n.j.dlg({
                    buttons: ["fullsize", "dialog.close"]
                  }), n._dialog.setContent(n.editor), n._dialog.setSize(n.o.width, n.o.height), n._dialog.setHeader([n.buttons.reset, n.buttons.save, n.buttons.saveas]), n.setHandlers(), n;
                }
                var o;
                return n.__extends(t, e), o = t, t.prototype.className = function () {
                  return "ImageEditor";
                }, t.prototype.onTitleModeClick = function (e) {
                  var t = this,
                    o = e.target,
                    n = null == o ? void 0 : o.parentElement;
                  if (n) {
                    (0, a.$$)(".".concat(d, "__slider,.").concat(d, "__area"), t.editor).forEach(function (e) {
                      return e.classList.remove("".concat(d, "_active"));
                    }), n.classList.add("".concat(d, "_active")), this.activeTab = (0, a.attr)(n, "-area") || p;
                    var r = t.editor.querySelector(".".concat(d, "__area.").concat(d, "__area_") + t.activeTab);
                    r && r.classList.add("".concat(d, "_active")), t.activeTab === f && t.showCrop();
                  }
                }, t.prototype.onChangeSizeInput = function (e) {
                  var t,
                    o = this,
                    n = e.target,
                    r = (0, a.refs)(this.editor),
                    i = r.widthInput,
                    s = r.heightInput,
                    l = "widthInput" === (0, a.attr)(n, "data-ref"),
                    c = parseInt(n.value, 10),
                    u = l ? o.o.min_height : o.o.min_width;
                  c > (l ? o.o.min_width : o.o.min_height) && ((0, a.css)(o.image, l ? "width" : "height", c), o.resizeUseRatio && (t = l ? Math.round(c / o.ratio) : Math.round(c * o.ratio)) > u && ((0, a.css)(o.image, l ? "height" : "width", t), l ? s.value = t.toString() : i.value = t.toString())), this.j.e.fire(o.resizeHandler, "updatesize");
                }, t.prototype.onResizeHandleMouseDown = function (e) {
                  var t = this;
                  t.target = e.target, e.preventDefault(), e.stopImmediatePropagation(), t.clicked = !0, t.start_x = e.clientX, t.start_y = e.clientY, t.activeTab === f ? (t.top_x = (0, a.css)(t.cropHandler, "left"), t.top_y = (0, a.css)(t.cropHandler, "top"), t.width = t.cropHandler.offsetWidth, t.height = t.cropHandler.offsetHeight) : (t.width = t.image.offsetWidth, t.height = t.image.offsetHeight), t.j.e.on(this.j.ow, "mousemove", this.onGlobalMouseMove).one(this.j.ow, "mouseup", this.onGlobalMouseUp);
                }, t.prototype.onGlobalMouseUp = function (e) {
                  this.clicked && (this.clicked = !1, e.stopImmediatePropagation(), this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove));
                }, t.prototype.onGlobalMouseMove = function (e) {
                  var t = this;
                  if (t.clicked) {
                    var o = (0, a.refs)(this.editor),
                      n = o.widthInput,
                      r = o.heightInput;
                    t.diff_x = e.clientX - t.start_x, t.diff_y = e.clientY - t.start_y, t.activeTab === p && t.resizeUseRatio || t.activeTab === f && t.cropUseRatio ? t.diff_x ? (t.new_w = t.width + t.diff_x, t.new_h = Math.round(t.new_w / t.ratio)) : (t.new_h = t.height + t.diff_y, t.new_w = Math.round(t.new_h * t.ratio)) : (t.new_w = t.width + t.diff_x, t.new_h = t.height + t.diff_y), t.activeTab === p ? (t.new_w > t.o.resizeMinWidth && ((0, a.css)(t.image, "width", t.new_w + "px"), n.value = t.new_w.toString()), t.new_h > t.o.resizeMinHeight && ((0, a.css)(t.image, "height", t.new_h + "px"), r.value = t.new_h.toString()), this.j.e.fire(t.resizeHandler, "updatesize")) : (t.target !== t.cropHandler ? (t.top_x + t.new_w > t.cropImage.offsetWidth && (t.new_w = t.cropImage.offsetWidth - t.top_x), t.top_y + t.new_h > t.cropImage.offsetHeight && (t.new_h = t.cropImage.offsetHeight - t.top_y), (0, a.css)(t.cropHandler, {
                      width: t.new_w,
                      height: t.new_h
                    })) : (t.top_x + t.diff_x + t.cropHandler.offsetWidth > t.cropImage.offsetWidth && (t.diff_x = t.cropImage.offsetWidth - t.top_x - t.cropHandler.offsetWidth), (0, a.css)(t.cropHandler, "left", t.top_x + t.diff_x), t.top_y + t.diff_y + t.cropHandler.offsetHeight > t.cropImage.offsetHeight && (t.diff_y = t.cropImage.offsetHeight - t.top_y - t.cropHandler.offsetHeight), (0, a.css)(t.cropHandler, "top", t.top_y + t.diff_y)), this.j.e.fire(t.cropHandler, "updatesize"));
                  }
                }, Object.defineProperty(t.prototype, "o", {
                  get: function () {
                    return this.options;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.hide = function () {
                  this._dialog.close();
                }, t.prototype.open = function (e, t) {
                  var o = this;
                  return this.j.async.promise(function (n) {
                    var r = new Date().getTime();
                    o.image = o.j.c.element("img"), (0, a.$$)("img,.jodit-icon_loader", o.resize_box).forEach(s.Dom.safeRemove), (0, a.$$)("img,.jodit-icon_loader", o.crop_box).forEach(s.Dom.safeRemove), (0, a.css)(o.cropHandler, "background", "transparent"), o.onSave = t, o.resize_box.appendChild(o.j.c.element("i", {
                      class: "jodit-icon_loader"
                    })), o.crop_box.appendChild(o.j.c.element("i", {
                      class: "jodit-icon_loader"
                    })), /\?/.test(e) ? e += "&_tst=" + r : e += "?_tst=" + r, o.image.setAttribute("src", e), o._dialog.open();
                    var i = (0, a.refs)(o.editor),
                      l = i.widthInput,
                      c = i.heightInput,
                      u = function () {
                        o.isDestructed || (o.image.removeEventListener("load", u), o.naturalWidth = o.image.naturalWidth, o.naturalHeight = o.image.naturalHeight, l.value = o.naturalWidth.toString(), c.value = o.naturalHeight.toString(), o.ratio = o.naturalWidth / o.naturalHeight, o.resize_box.appendChild(o.image), o.cropImage = o.image.cloneNode(!0), o.crop_box.appendChild(o.cropImage), s.Dom.safeRemove.apply(null, (0, a.$$)(".jodit-icon_loader", o.editor)), o.activeTab === f && o.showCrop(), o.j.e.fire(o.resizeHandler, "updatesize"), o.j.e.fire(o.cropHandler, "updatesize"), o._dialog.setPosition(), o.j.e.fire("afterImageEditor"), n(o._dialog));
                      };
                    o.image.addEventListener("load", u), o.image.complete && u();
                  });
                }, t.prototype.destruct = function () {
                  this.isDestructed || (this._dialog && !this._dialog.isInDestruct && this._dialog.destruct(), s.Dom.safeRemove(this.editor), this.j.e && this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove).off(this.j.ow, "mouseup", this.onGlobalMouseUp).off(this.ow, ".".concat(d)).off(".".concat(d)), e.prototype.destruct.call(this));
                }, t.calcValueByPercent = function (e, t) {
                  var o,
                    n = t.toString(),
                    r = parseFloat(e.toString());
                  return (o = /^[-+]?[0-9]+(px)?$/.exec(n)) ? parseInt(n, 10) : (o = /^([-+]?[0-9.]+)%$/.exec(n)) ? Math.round(r * (parseFloat(o[1]) / 100)) : r || 0;
                }, n.__decorate([u.autobind], t.prototype, "onTitleModeClick", null), n.__decorate([(0, u.debounce)(), u.autobind], t.prototype, "onChangeSizeInput", null), n.__decorate([u.autobind], t.prototype, "onResizeHandleMouseDown", null), n.__decorate([u.autobind], t.prototype, "onGlobalMouseUp", null), n.__decorate([(0, u.throttle)(10)], t.prototype, "onGlobalMouseMove", null), n.__decorate([u.autobind], t.prototype, "hide", null), n.__decorate([u.autobind], t.prototype, "open", null), o = n.__decorate([u.component], t);
              }(i.ViewComponent);
            t.ImageEditor = h, t.openImageEditor = function (e, t, o, n, r, i) {
              var s = this;
              return this.getInstance("ImageEditor", this.o).open(e, function (e, l, c, u) {
                return (0, a.call)("resize" === l.action ? s.dataProvider.resize : s.dataProvider.crop, o, n, t, e, l.box).then(function (e) {
                  e && (c(), r && r());
                }).catch(function (e) {
                  u(e), i && i(e);
                });
              });
            };
          },
          9249: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.form = void 0;
            var n = o(2074),
              r = "jodit-image-editor",
              i = n.Icon.get.bind(n.Icon),
              a = function (e, t) {
                return void 0 === t && (t = "jodti-image-editor_active"), e ? t : "";
              };
            t.form = function (e, t) {
              var o = e.i18n.bind(e),
                n = function (e, t, n) {
                  return void 0 === n && (n = !0), '<div class="jodit-form__group">\n\t\t\t<label>'.concat(o(e), "</label>\n\n\t\t\t<label class='jodit-switcher'>\n\t\t\t\t<input ").concat(a(n, "checked"), ' data-ref="').concat(t, '" type="checkbox"/>\n\t\t\t\t<span class="jodit-switcher__slider"></span>\n\t\t\t</label>\n\t</div>');
                };
              return e.create.fromHTML('<form class="'.concat(r, ' jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-3-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div class="'.concat(r, "__area ").concat(r, "__area_resize ").concat(r, '_active">\n\t\t\t\t\t\t\t<div data-ref="resizeBox" class="').concat(r, '__box"></div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__resizer">\n\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", "\n\t\t\t").concat(t.crop ? '<div class="'.concat(r, "__area ").concat(r, "__area_crop ").concat(a(!t.resize), '">\n\t\t\t\t\t\t\t<div data-ref="cropBox" class="').concat(r, '__box">\n\t\t\t\t\t\t\t\t<div class="').concat(r, '__croper">\n\t\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t\t\t<i class="').concat(r, '__sizes"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", '\n\t\t\t</div>\n\t\t\t<div class="jodit_col-lg-1-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div data-area="resize" class="'.concat(r, "__slider ").concat(r, '_active">\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(i("resize"), "\n\t\t\t\t\t\t\t\t").concat(o("Resize"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-content">\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Width"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="widthInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Height"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="heightInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioResize"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t").concat(t.crop ? '<div data-area="crop" class="'.concat(r, "__slider ").concat(a(!t.resize), '\'">\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(i("crop"), "\n\t\t\t\t\t\t\t\t").concat(o("Crop"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-content">\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioCrop"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t</div>\n\t\t</div>\n\t</form>"));
            };
          },
          87837: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.PluginSystem = t.UIMessages = t.Uploader = t.ToolbarCollection = t.ToolbarEditorCollection = t.Table = t.StatusBar = t.CommitStyle = t.Select = t.Snapshot = t.History = t.ImageEditor = t.Helpers = t.ViewWithToolbar = t.View = t.Icon = t.ProgressBar = t.UIBlock = t.UICheckbox = t.UITextArea = t.UIInput = t.UIForm = t.UIList = t.UIGroup = t.UISeparator = t.Popup = t.UIButton = t.UIElement = t.Create = t.Plugin = t.LazyWalker = t.Dom = t.ContextMenu = t.STATUSES = t.ViewComponent = t.Component = t.Async = void 0;
            var n = o(20255);
            n.__exportStar(o(55395), t);
            var r = o(22630);
            Object.defineProperty(t, "Async", {
              enumerable: !0,
              get: function () {
                return r.Async;
              }
            }), n.__exportStar(o(30056), t);
            var i = o(56562);
            Object.defineProperty(t, "Component", {
              enumerable: !0,
              get: function () {
                return i.Component;
              }
            }), Object.defineProperty(t, "ViewComponent", {
              enumerable: !0,
              get: function () {
                return i.ViewComponent;
              }
            }), Object.defineProperty(t, "STATUSES", {
              enumerable: !0,
              get: function () {
                return i.STATUSES;
              }
            });
            var a = o(60403);
            Object.defineProperty(t, "ContextMenu", {
              enumerable: !0,
              get: function () {
                return a.ContextMenu;
              }
            }), n.__exportStar(o(92080), t);
            var s = o(64968);
            Object.defineProperty(t, "Dom", {
              enumerable: !0,
              get: function () {
                return s.Dom;
              }
            }), Object.defineProperty(t, "LazyWalker", {
              enumerable: !0,
              get: function () {
                return s.LazyWalker;
              }
            });
            var l = o(57549);
            Object.defineProperty(t, "Plugin", {
              enumerable: !0,
              get: function () {
                return l.Plugin;
              }
            });
            var c = o(42841);
            Object.defineProperty(t, "Create", {
              enumerable: !0,
              get: function () {
                return c.Create;
              }
            });
            var u = o(2074);
            Object.defineProperty(t, "UIElement", {
              enumerable: !0,
              get: function () {
                return u.UIElement;
              }
            }), Object.defineProperty(t, "UIButton", {
              enumerable: !0,
              get: function () {
                return u.UIButton;
              }
            }), Object.defineProperty(t, "Popup", {
              enumerable: !0,
              get: function () {
                return u.Popup;
              }
            }), Object.defineProperty(t, "UISeparator", {
              enumerable: !0,
              get: function () {
                return u.UISeparator;
              }
            }), Object.defineProperty(t, "UIGroup", {
              enumerable: !0,
              get: function () {
                return u.UIGroup;
              }
            }), Object.defineProperty(t, "UIList", {
              enumerable: !0,
              get: function () {
                return u.UIList;
              }
            }), Object.defineProperty(t, "UIForm", {
              enumerable: !0,
              get: function () {
                return u.UIForm;
              }
            }), Object.defineProperty(t, "UIInput", {
              enumerable: !0,
              get: function () {
                return u.UIInput;
              }
            }), Object.defineProperty(t, "UITextArea", {
              enumerable: !0,
              get: function () {
                return u.UITextArea;
              }
            }), Object.defineProperty(t, "UICheckbox", {
              enumerable: !0,
              get: function () {
                return u.UICheckbox;
              }
            }), Object.defineProperty(t, "UIBlock", {
              enumerable: !0,
              get: function () {
                return u.UIBlock;
              }
            }), Object.defineProperty(t, "ProgressBar", {
              enumerable: !0,
              get: function () {
                return u.ProgressBar;
              }
            }), Object.defineProperty(t, "Icon", {
              enumerable: !0,
              get: function () {
                return u.Icon;
              }
            });
            var d = o(75902);
            Object.defineProperty(t, "View", {
              enumerable: !0,
              get: function () {
                return d.View;
              }
            });
            var p = o(43608);
            Object.defineProperty(t, "ViewWithToolbar", {
              enumerable: !0,
              get: function () {
                return p.ViewWithToolbar;
              }
            }), n.__exportStar(o(63463), t);
            var f = o(40332);
            t.Helpers = f;
            var h = o(35503);
            Object.defineProperty(t, "ImageEditor", {
              enumerable: !0,
              get: function () {
                return h.ImageEditor;
              }
            });
            var m = o(15432);
            Object.defineProperty(t, "History", {
              enumerable: !0,
              get: function () {
                return m.History;
              }
            });
            var v = o(31648);
            Object.defineProperty(t, "Snapshot", {
              enumerable: !0,
              get: function () {
                return v.Snapshot;
              }
            });
            var g = o(2123);
            Object.defineProperty(t, "Select", {
              enumerable: !0,
              get: function () {
                return g.Select;
              }
            }), Object.defineProperty(t, "CommitStyle", {
              enumerable: !0,
              get: function () {
                return g.CommitStyle;
              }
            });
            var y = o(38603);
            Object.defineProperty(t, "StatusBar", {
              enumerable: !0,
              get: function () {
                return y.StatusBar;
              }
            });
            var _ = o(25120);
            Object.defineProperty(t, "Table", {
              enumerable: !0,
              get: function () {
                return _.Table;
              }
            });
            var b = o(81698);
            Object.defineProperty(t, "ToolbarEditorCollection", {
              enumerable: !0,
              get: function () {
                return b.ToolbarEditorCollection;
              }
            });
            var w = o(72719);
            Object.defineProperty(t, "ToolbarCollection", {
              enumerable: !0,
              get: function () {
                return w.ToolbarCollection;
              }
            }), n.__exportStar(o(3890), t);
            var S = o(50454);
            Object.defineProperty(t, "Uploader", {
              enumerable: !0,
              get: function () {
                return S.Uploader;
              }
            });
            var C = o(71014);
            Object.defineProperty(t, "UIMessages", {
              enumerable: !0,
              get: function () {
                return C.UIMessages;
              }
            });
            var j = o(44540);
            Object.defineProperty(t, "PluginSystem", {
              enumerable: !0,
              get: function () {
                return j.PluginSystem;
              }
            });
          },
          37762: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIMessage = void 0;
            var n = o(20255),
              r = o(2074),
              i = o(11441),
              a = function (e) {
                function t(t, o) {
                  var n = e.call(this, t) || this;
                  return n.setMod("active", !0), n.setMod("variant", o.variant), n.container.textContent = o.text, n;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIMessage";
                }, n.__decorate([i.component], t);
              }(r.UIElement);
            t.UIMessage = a;
          },
          71014: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UIMessages = void 0;
            var n = o(20255);
            o(63421);
            var r = o(26911),
              i = o(61479),
              a = o(11441),
              s = o(46163),
              l = o(37762),
              c = function (e) {
                function t(t, o, n) {
                  void 0 === n && (n = {
                    defaultTimeout: 3e3,
                    defaultOffset: 5
                  });
                  var r = e.call(this, t) || this;
                  return r.__box = o, r.options = n, r.__messages = new Set(), r;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UIMessages";
                }, t.prototype.info = function (e, t) {
                  this.__message(e, "info", t);
                }, t.prototype.success = function (e, t) {
                  this.__message(e, "success", t);
                }, t.prototype.error = function (e, t) {
                  this.__message(e, "error", t);
                }, t.prototype.message = function (e, t, o) {
                  this.__message(e, t, o);
                }, t.prototype.__message = function (e, t, o) {
                  void 0 === t && (t = "info");
                  var n = e + ":" + t;
                  if (this.__messages.has(n)) this.async.updateTimeout(n, o || this.options.defaultTimeout);else {
                    this.__box.appendChild(this.container);
                    var r = new l.UIMessage(this.j, {
                      text: e,
                      variant: t
                    });
                    this.append(r), this.__calcOffsets(), this.__messages.add(n);
                    var i = this.__getRemoveCallback(r, n);
                    this.j.e.on(r.container, "pointerdown", i), this.async.setTimeout(i, {
                      label: n,
                      timeout: o || this.options.defaultTimeout
                    });
                  }
                }, t.prototype.__getRemoveCallback = function (e, t) {
                  var o = this,
                    n = function (r) {
                      r && r.preventDefault(), e.isInDestruct || (o.async.clearTimeout(t), o.j.e.off(e.container, "pointerdown", n), o.__messages.delete(t), e.setMod("active", !1), o.async.setTimeout(function () {
                        o.remove(e), e.destruct(), o.__calcOffsets();
                      }, 300));
                    };
                  return n;
                }, t.prototype.__calcOffsets = function () {
                  var e = this,
                    t = 5;
                  this.elements.forEach(function (o) {
                    (0, r.css)(o.container, "bottom", t + "px"), t += o.container.offsetHeight + e.options.defaultOffset;
                  });
                }, n.__decorate([(0, s.watch)(":errorMessage")], t.prototype, "__message", null), n.__decorate([a.component], t);
              }(i.UIGroup);
            t.UIMessages = c;
          },
          38603: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.StatusBar = void 0;
            var n = o(20255);
            o(32115);
            var r = o(56562),
              i = o(64968),
              a = o(59829),
              s = o(43441),
              l = function (e) {
                function t(t, o) {
                  var n = e.call(this, t) || this;
                  return n.target = o, n.mods = {}, n.container = t.c.div("jodit-status-bar"), o.appendChild(n.container), n.hide(), n;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "StatusBar";
                }, t.prototype.hide = function () {
                  this.container.classList.add("jodit_hidden");
                }, t.prototype.show = function () {
                  this.container.classList.remove("jodit_hidden");
                }, Object.defineProperty(t.prototype, "isShown", {
                  get: function () {
                    return !this.container.classList.contains("jodit_hidden");
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.getHeight = function () {
                  var e, t;
                  return null !== (t = null === (e = this.container) || void 0 === e ? void 0 : e.offsetHeight) && void 0 !== t ? t : 0;
                }, t.prototype.findEmpty = function (e) {
                  void 0 === e && (e = !1);
                  for (var t = this.getElms(e ? "item-right" : "item"), o = 0; t.length > o; o += 1) if (!t[o].innerHTML.trim().length) return t[o];
                }, t.prototype.append = function (e, t) {
                  var o;
                  void 0 === t && (t = !1);
                  var n = this.findEmpty(t) || this.j.c.div(this.getFullElName("item"));
                  t && n.classList.add(this.getFullElName("item-right")), n.appendChild(e), null === (o = this.container) || void 0 === o || o.appendChild(n), this.j.o.statusbar && this.show(), this.j.e.fire("resize");
                }, t.prototype.destruct = function () {
                  this.isInDestruct || (this.setStatus(r.STATUSES.beforeDestruct), i.Dom.safeRemove(this.container), e.prototype.destruct.call(this));
                }, n.__decorate([s.component, (0, s.derive)(a.Mods, a.Elms)], t);
              }(r.ViewComponent);
            t.StatusBar = l;
          },
          25120: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Table = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(64968),
              a = o(40332),
              s = o(56562),
              l = o(17332),
              c = o(43441),
              u = new WeakMap(),
              d = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.selected = new Set(), t;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "Table";
                }, t.prototype.recalculateStyles = function () {
                  var e = (0, l.getContainer)(this.j, t, "style", !0),
                    o = [];
                  this.selected.forEach(function (e) {
                    var t = (0, a.cssPath)(e);
                    t && o.push(t);
                  }), e.innerHTML = o.length ? o.join(",") + "{".concat(this.jodit.options.table.selectionCellStyle, "}") : "";
                }, t.prototype.addSelection = function (e) {
                  this.selected.add(e), this.recalculateStyles();
                  var o = i.Dom.closest(e, "table", this.j.editor);
                  if (o) {
                    var n = t.selectedByTable.get(o) || new Set();
                    n.add(e), t.selectedByTable.set(o, n);
                  }
                }, t.prototype.removeSelection = function (e) {
                  this.selected.delete(e), this.recalculateStyles();
                  var o = i.Dom.closest(e, "table", this.j.editor);
                  if (o) {
                    var n = t.selectedByTable.get(o);
                    n && (n.delete(e), n.size || t.selectedByTable.delete(o));
                  }
                }, t.prototype.getAllSelectedCells = function () {
                  return (0, a.toArray)(this.selected);
                }, t.getSelectedCellsByTable = function (e) {
                  var o = t.selectedByTable.get(e);
                  return o ? (0, a.toArray)(o) : [];
                }, t.prototype.destruct = function () {
                  return this.selected.clear(), e.prototype.destruct.call(this);
                }, t.getRowsCount = function (e) {
                  return e.rows.length;
                }, t.getColumnsCount = function (e) {
                  return t.formalMatrix(e).reduce(function (e, t) {
                    return Math.max(e, t.length);
                  }, 0);
                }, t.formalMatrix = function (e, t) {
                  for (var o = [[]], n = (0, a.toArray)(e.rows), r = function (e, n) {
                      void 0 === o[n] && (o[n] = []);
                      for (var r, i, a = e.colSpan, s = e.rowSpan, l = 0; o[n][l];) l += 1;
                      for (i = 0; s > i; i += 1) for (r = 0; a > r; r += 1) {
                        if (void 0 === o[n + i] && (o[n + i] = []), t && !1 === t(e, n + i, l + r, a, s)) return !1;
                        o[n + i][l + r] = e;
                      }
                    }, i = 0; n.length > i; i += 1) for (var s = (0, a.toArray)(n[i].cells), l = 0; s.length > l; l += 1) if (!1 === r(s[l], i)) return o;
                  return o;
                }, t.formalCoordinate = function (e, o, n) {
                  void 0 === n && (n = !1);
                  var r = 0,
                    i = 0,
                    a = 1,
                    s = 1;
                  return t.formalMatrix(e, function (e, t, l, c, u) {
                    if (o === e) return r = t, i = l, a = c || 1, s = u || 1, n && (i += (c || 1) - 1, r += (u || 1) - 1), !1;
                  }), [r, i, a, s];
                }, t.appendRow = function (e, o, n, r) {
                  var i, s;
                  if (o) s = o.cloneNode(!0), (0, a.$$)("td,th", o).forEach(function (e) {
                    var t = (0, a.attr)(e, "rowspan");
                    if (t && parseInt(t, 10) > 1) {
                      var o = parseInt(t, 10) - 1;
                      (0, a.attr)(e, "rowspan", o > 1 ? o : null);
                    }
                  }), (0, a.$$)("td,th", s).forEach(function (e) {
                    e.innerHTML = "";
                  });else {
                    var l = t.getColumnsCount(e);
                    s = r.element("tr");
                    for (var c = 0; l > c; c += 1) s.appendChild(r.element("td"));
                  }
                  n && o && o.nextSibling ? o.parentNode && o.parentNode.insertBefore(s, o.nextSibling) : !n && o ? o.parentNode && o.parentNode.insertBefore(s, o) : ((null === (i = e.getElementsByTagName("tbody")) || void 0 === i ? void 0 : i[0]) || e).appendChild(s);
                }, t.removeRow = function (e, o) {
                  var n,
                    r = t.formalMatrix(e),
                    s = e.rows[o];
                  r[o].forEach(function (t, l) {
                    if (n = !1, 0 > o - 1 || r[o - 1][l] !== t) {
                      if (r[o + 1] && r[o + 1][l] === t) {
                        if (t.parentNode === s && t.parentNode.nextSibling) {
                          n = !0;
                          for (var c = l + 1; r[o + 1][c] === t;) c += 1;
                          var u = i.Dom.next(t.parentNode, function (e) {
                            return i.Dom.isTag(e, "tr");
                          }, e);
                          u && (r[o + 1][c] ? u.insertBefore(t, r[o + 1][c]) : u.appendChild(t));
                        }
                      } else i.Dom.safeRemove(t);
                    } else n = !0;
                    if (n && (t.parentNode === s || t !== r[o][l - 1])) {
                      var d = t.rowSpan;
                      (0, a.attr)(t, "rowspan", d - 1 > 1 ? d - 1 : null);
                    }
                  }), i.Dom.safeRemove(s);
                }, t.appendColumn = function (e, o, n, r) {
                  var s,
                    l = t.formalMatrix(e);
                  for ((void 0 === o || 0 > o) && (o = t.getColumnsCount(e) - 1), s = 0; l.length > s; s += 1) {
                    var c = r.element("td"),
                      u = l[s][o],
                      d = !1;
                    n ? (l[s] && u && o + 1 >= l[s].length || u !== l[s][o + 1]) && (u.nextSibling ? i.Dom.before(u.nextSibling, c) : u.parentNode && u.parentNode.appendChild(c), d = !0) : (0 > o - 1 || l[s][o] !== l[s][o - 1] && l[s][o].parentNode) && (i.Dom.before(l[s][o], c), d = !0), d || (0, a.attr)(l[s][o], "colspan", parseInt((0, a.attr)(l[s][o], "colspan") || "1", 10) + 1);
                  }
                }, t.removeColumn = function (e, o) {
                  var n,
                    r = t.formalMatrix(e);
                  r.forEach(function (e, t) {
                    var s = e[o];
                    if (n = !1, 0 > o - 1 || r[t][o - 1] !== s ? e.length > o + 1 && r[t][o + 1] === s ? n = !0 : i.Dom.safeRemove(s) : n = !0, n && (0 > t - 1 || s !== r[t - 1][o])) {
                      var l = s.colSpan;
                      (0, a.attr)(s, "colspan", l - 1 > 1 ? (l - 1).toString() : null);
                    }
                  });
                }, t.getSelectedBound = function (e, o) {
                  var n,
                    r,
                    i,
                    a = [[1 / 0, 1 / 0], [0, 0]],
                    s = t.formalMatrix(e);
                  for (n = 0; s.length > n; n += 1) for (r = 0; s[n] && s[n].length > r; r += 1) o.includes(s[n][r]) && (a[0][0] = Math.min(n, a[0][0]), a[0][1] = Math.min(r, a[0][1]), a[1][0] = Math.max(n, a[1][0]), a[1][1] = Math.max(r, a[1][1]));
                  for (n = a[0][0]; a[1][0] >= n; n += 1) for (i = 1, r = a[0][1]; a[1][1] >= r; r += 1) {
                    for (; s[n] && s[n][r - i] && s[n][r] === s[n][r - i];) a[0][1] = Math.min(r - i, a[0][1]), a[1][1] = Math.max(r - i, a[1][1]), i += 1;
                    for (i = 1; s[n] && s[n][r + i] && s[n][r] === s[n][r + i];) a[0][1] = Math.min(r + i, a[0][1]), a[1][1] = Math.max(r + i, a[1][1]), i += 1;
                    for (i = 1; s[n - i] && s[n][r] === s[n - i][r];) a[0][0] = Math.min(n - i, a[0][0]), a[1][0] = Math.max(n - i, a[1][0]), i += 1;
                    for (i = 1; s[n + i] && s[n][r] === s[n + i][r];) a[0][0] = Math.min(n + i, a[0][0]), a[1][0] = Math.max(n + i, a[1][0]), i += 1;
                  }
                  return a;
                }, t.normalizeTable = function (e) {
                  var o,
                    n,
                    r,
                    i,
                    s = [],
                    l = t.formalMatrix(e);
                  for (n = 0; l[0].length > n; n += 1) {
                    for (r = 1e6, i = !1, o = 0; l.length > o; o += 1) if (void 0 !== l[o][n]) {
                      if (2 > l[o][n].colSpan) {
                        i = !0;
                        break;
                      }
                      r = Math.min(r, l[o][n].colSpan);
                    }
                    if (!i) for (o = 0; l.length > o; o += 1) void 0 !== l[o][n] && t.mark(l[o][n], "colspan", l[o][n].colSpan - r + 1, s);
                  }
                  for (o = 0; l.length > o; o += 1) {
                    for (r = 1e6, i = !1, n = 0; l[o].length > n; n += 1) if (void 0 !== l[o][n]) {
                      if (2 > l[o][n].rowSpan) {
                        i = !0;
                        break;
                      }
                      r = Math.min(r, l[o][n].rowSpan);
                    }
                    if (!i) for (n = 0; l[o].length > n; n += 1) void 0 !== l[o][n] && t.mark(l[o][n], "rowspan", l[o][n].rowSpan - r + 1, s);
                  }
                  for (o = 0; l.length > o; o += 1) for (n = 0; l[o].length > n; n += 1) void 0 !== l[o][n] && (l[o][n].hasAttribute("rowspan") && 1 === l[o][n].rowSpan && (0, a.attr)(l[o][n], "rowspan", null), l[o][n].hasAttribute("colspan") && 1 === l[o][n].colSpan && (0, a.attr)(l[o][n], "colspan", null), l[o][n].hasAttribute("class") && !(0, a.attr)(l[o][n], "class") && (0, a.attr)(l[o][n], "class", null));
                  t.unmark(s);
                }, t.mergeSelected = function (e, o) {
                  var n,
                    s = [],
                    l = t.getSelectedBound(e, t.getSelectedCellsByTable(e)),
                    c = 0,
                    u = null,
                    d = 0,
                    f = 0,
                    h = 0,
                    m = new Set(),
                    v = [];
                  l && (l[0][0] - l[1][0] || l[0][1] - l[1][1]) && (t.formalMatrix(e, function (e, r, i, g, y) {
                    if (!(l[0][0] > r || r > l[1][0] || l[0][1] > i || i > l[1][1])) {
                      if (m.has(n = e)) return;
                      m.add(n), r === l[0][0] && n.style.width && (c += n.offsetWidth), "" !== (0, a.trim)(e.innerHTML.replace(/<br(\/)?>/g, "")) && s.push(e.innerHTML), g > 1 && (f += g - 1), y > 1 && (h += y - 1), u ? (t.mark(n, "remove", 1, v), p(o).removeSelection(n)) : (u = e, d = i);
                    }
                  }), f = l[1][1] - l[0][1] + 1, h = l[1][0] - l[0][0] + 1, u && (f > 1 && t.mark(u, "colspan", f, v), h > 1 && t.mark(u, "rowspan", h, v), c && (t.mark(u, "width", (c / e.offsetWidth * 100).toFixed(r.ACCURACY) + "%", v), d && t.setColumnWidthByDelta(e, d, 0, !0, v)), u.innerHTML = s.join("<br/>"), p(o).addSelection(u), m.delete(u), t.unmark(v), t.normalizeTable(e), (0, a.toArray)(e.rows).forEach(function (e, t) {
                    e.cells.length || i.Dom.safeRemove(e);
                  })));
                }, t.splitHorizontal = function (e, o) {
                  var n,
                    r,
                    a,
                    s,
                    l,
                    c = [];
                  t.getSelectedCellsByTable(e).forEach(function (u) {
                    (r = o.createInside.element("td")).appendChild(o.createInside.element("br")), a = o.createInside.element("tr"), n = t.formalCoordinate(e, u), 2 > u.rowSpan ? (t.formalMatrix(e, function (e, o, r) {
                      n[0] === o && n[1] !== r && e !== u && t.mark(e, "rowspan", e.rowSpan + 1, c);
                    }), i.Dom.after(i.Dom.closest(u, "tr", e), a), a.appendChild(r)) : (t.mark(u, "rowspan", u.rowSpan - 1, c), t.formalMatrix(e, function (t, o, r) {
                      o > n[0] && n[0] + u.rowSpan > o && n[1] > r && t.parentNode.rowIndex === o && (l = t), o > n[0] && t === u && (s = e.rows[o]);
                    }), l ? i.Dom.after(l, r) : s.insertBefore(r, s.firstChild)), u.colSpan > 1 && t.mark(r, "colspan", u.colSpan, c), t.unmark(c), p(o).removeSelection(u);
                  }), this.normalizeTable(e);
                }, t.splitVertical = function (e, o) {
                  var n,
                    a,
                    s,
                    l = [];
                  t.getSelectedCellsByTable(e).forEach(function (c) {
                    n = t.formalCoordinate(e, c), 2 > c.colSpan ? t.formalMatrix(e, function (e, o, r) {
                      n[1] === r && n[0] !== o && e !== c && t.mark(e, "colspan", e.colSpan + 1, l);
                    }) : t.mark(c, "colspan", c.colSpan - 1, l), (a = o.createInside.element("td")).appendChild(o.createInside.element("br")), c.rowSpan > 1 && t.mark(a, "rowspan", c.rowSpan, l);
                    var u = c.offsetWidth;
                    i.Dom.after(c, a), t.mark(c, "width", (100 * (s = u / e.offsetWidth / 2)).toFixed(r.ACCURACY) + "%", l), t.mark(a, "width", (100 * s).toFixed(r.ACCURACY) + "%", l), t.unmark(l), p(o).removeSelection(c);
                  }), t.normalizeTable(e);
                }, t.setColumnWidthByDelta = function (e, o, n, i, a) {
                  for (var s = t.formalMatrix(e), l = 0, c = 0; s.length > c; c += 1) if (1 >= (u = s[c][o]).colSpan || 1 >= s.length) {
                    t.mark(u, "width", ((u.offsetWidth + n) / e.offsetWidth * 100).toFixed(r.ACCURACY) + "%", a), l = c;
                    break;
                  }
                  for (c = l + 1; s.length > c; c += 1) {
                    var u;
                    t.mark(u = s[c][o], "width", null, a);
                  }
                  i || t.unmark(a);
                }, t.mark = function (e, t, o, n) {
                  var r;
                  n.push(e);
                  var i = null !== (r = u.get(e)) && void 0 !== r ? r : {};
                  i[t] = void 0 === o ? 1 : o, u.set(e, i);
                }, t.unmark = function (e) {
                  e.forEach(function (e) {
                    var t = u.get(e);
                    t && (Object.keys(t).forEach(function (o) {
                      var n = t[o];
                      switch (o) {
                        case "remove":
                          i.Dom.safeRemove(e);
                          break;
                        case "rowspan":
                          (0, a.attr)(e, "rowspan", (0, a.isNumber)(n) && n > 1 ? n : null);
                          break;
                        case "colspan":
                          (0, a.attr)(e, "colspan", (0, a.isNumber)(n) && n > 1 ? n : null);
                          break;
                        case "width":
                          null == n ? (e.style.removeProperty("width"), (0, a.attr)(e, "style") || (0, a.attr)(e, "style", null)) : e.style.width = n.toString();
                      }
                      delete t[o];
                    }), u.delete(e));
                  });
                }, t.selectedByTable = new WeakMap(), n.__decorate([(0, c.debounce)()], t.prototype, "recalculateStyles", null), t;
              }(s.ViewComponent);
            t.Table = d;
            var p = function (e) {
              return e.getInstance("Table", e.o);
            };
          },
          48197: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ToolbarButton = void 0;
            var n = o(20255);
            o(53362);
            var r = o(96516),
              i = o(43441),
              a = o(64968),
              s = o(12680),
              l = o(81438),
              c = o(40332),
              u = o(77904),
              d = o(72719),
              p = o(29411),
              f = o(38546),
              h = function (e) {
                function t(t, o, i) {
                  void 0 === i && (i = null);
                  var a = e.call(this, t) || this;
                  return a.control = o, a.target = i, a.state = n.__assign(n.__assign({}, (0, r.UIButtonState)()), {
                    theme: "toolbar",
                    currentValue: "",
                    hasTrigger: !1
                  }), a.openedPopup = null, t.e.on([a.button, a.trigger], "mousedown", function (e) {
                    return e.preventDefault();
                  }), a.onAction(a.onClick), a.hookStatus(p.STATUSES.ready, function () {
                    a.initFromControl(), a.initTooltip(), a.update();
                  }), o.mods && Object.keys(o.mods).forEach(function (e) {
                    o.mods && a.setMod(e, o.mods[e]);
                  }), a;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ToolbarButton";
                }, Object.defineProperty(t.prototype, "toolbar", {
                  get: function () {
                    return this.closest(d.ToolbarCollection);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "button", {
                  get: function () {
                    return this.container.querySelector("button.".concat(this.componentName, "__button"));
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.update = function () {
                  var t = this.control,
                    o = this.state,
                    n = this.closest(d.ToolbarCollection);
                  o.disabled = this.calculateDisabledStatus(n), o.activated = this.calculateActivatedStatus(n), (0, c.isFunction)(t.update) && n && t.update(this, n.jodit), e.prototype.update.call(this);
                }, t.prototype.calculateActivatedStatus = function (e) {
                  return !((0, c.isJoditObject)(this.j) && !this.j.editorIsActive) && (!(!(0, c.isFunction)(this.control.isActive) || !this.control.isActive(this.j, this.control, this)) || Boolean(e && e.shouldBeActive(this)));
                }, t.prototype.calculateDisabledStatus = function (e) {
                  return !!this.j.o.disabled || !(!this.j.o.readonly || this.j.o.activeButtonsInReadOnly && this.j.o.activeButtonsInReadOnly.includes(this.control.name)) || !(!(0, c.isFunction)(this.control.isDisabled) || !this.control.isDisabled(this.j, this.control, this)) || Boolean(e && e.shouldBeDisabled(this));
                }, t.prototype.onChangeActivated = function () {
                  (0, c.attr)(this.button, "aria-pressed", this.state.activated), e.prototype.onChangeActivated.call(this);
                }, t.prototype.onChangeText = function () {
                  (0, c.isFunction)(this.control.template) ? this.text.innerHTML = this.control.template(this.j, this.control.name, this.j.i18n(this.state.text)) : e.prototype.onChangeText.call(this), this.setMod("text-icons", Boolean(this.text.innerText.trim().length));
                }, t.prototype.onChangeTabIndex = function () {
                  (0, c.attr)(this.button, "tabindex", this.state.tabIndex);
                }, t.prototype.onChangeTooltip = function () {
                  (0, c.attr)(this.button, "aria-label", this.state.tooltip), e.prototype.onChangeTooltip.call(this);
                }, t.prototype.createContainer = function () {
                  var t = this.componentName,
                    o = this.j.c.span(t),
                    n = e.prototype.createContainer.call(this);
                  return (0, c.attr)(o, "role", "listitem"), n.classList.remove(t), n.classList.add(t + "__button"), Object.defineProperty(n, "component", {
                    value: this
                  }), o.appendChild(n), this.trigger = this.j.c.fromHTML('<span role="trigger" class="'.concat(t, '__trigger">').concat(u.Icon.get("chevron"), "</span>")), o;
                }, t.prototype.focus = function () {
                  var e;
                  null === (e = this.container.querySelector("button")) || void 0 === e || e.focus();
                }, t.prototype.onChangeHasTrigger = function () {
                  this.state.hasTrigger ? this.container.appendChild(this.trigger) : a.Dom.safeRemove(this.trigger), this.setMod("with-trigger", this.state.hasTrigger || null);
                }, t.prototype.onChangeDisabled = function () {
                  var e = this.state.disabled ? "disabled" : null;
                  (0, c.attr)(this.trigger, "disabled", e), (0, c.attr)(this.button, "disabled", e), (0, c.attr)(this.container, "disabled", e);
                }, t.prototype.initTooltip = function () {
                  var e = this;
                  this.j.o.textIcons || !this.j.o.showTooltip || this.j.o.useNativeTooltip || this.j.e.off(this.container, "mouseenter mouseleave").on(this.container, "mousemove", function (t) {
                    e.state.tooltip && !e.state.disabled && e.j.e.fire("delayShowTooltip", function () {
                      return {
                        x: t.clientX + 10,
                        y: t.clientY + 10
                      };
                    }, e.state.tooltip);
                  }).on(this.container, "mouseleave", function () {
                    e.j.e.fire("hideTooltip");
                  });
                }, t.prototype.initFromControl = function () {
                  var e,
                    t = this.control,
                    o = this.state;
                  this.updateSize(), o.name = t.name;
                  var n = this.j.o.textIcons;
                  if (!0 === n || (0, c.isFunction)(n) && n(t.name) || t.template) o.icon = (0, r.UIButtonState)().icon, o.text = t.text || t.name;else {
                    if (t.iconURL) o.icon.iconURL = t.iconURL;else {
                      var i = t.icon || t.name;
                      o.icon.name = u.Icon.exists(i) || (null === (e = this.j.o.extraIcons) || void 0 === e ? void 0 : e[i]) ? i : "";
                    }
                    t.iconURL || o.icon.name || (o.text = t.text || t.name);
                  }
                  t.tooltip && (o.tooltip = this.j.i18n((0, c.isFunction)(t.tooltip) ? t.tooltip(this.j, t, this) : t.tooltip)), o.hasTrigger = Boolean(t.list || t.popup && t.exec);
                }, t.prototype.onTriggerClick = function (e) {
                  var t,
                    o,
                    n,
                    r = this;
                  if (this.openedPopup) this.closePopup();else {
                    var i = this.control;
                    if (e.buffer = {
                      actionTrigger: this
                    }, i.list) return this.openControlList(i);
                    if ((0, c.isFunction)(i.popup)) {
                      var a = this.openPopup();
                      if (a.parentElement = this, !1 !== this.j.e.fire((0, c.camelCase)("before-".concat(i.name, "-open-popup")), this.target, i, a)) {
                        var s = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null,
                          l = i.popup(this.j, s, i, this.closePopup, this);
                        l && a.setContent((0, c.isString)(l) ? this.j.c.fromHTML(l) : l).open(function () {
                          return (0, c.position)(r.container);
                        }, !1, this.j.o.allowTabNavigation ? this.container : void 0);
                      }
                      this.j.e.fire((0, c.camelCase)("after-".concat(i.name, "-open-popup")), a.container);
                    }
                  }
                }, t.prototype.openControlList = function (e) {
                  var t,
                    o = this,
                    r = null !== (t = this.jodit.options.controls) && void 0 !== t ? t : {},
                    i = function (e) {
                      return (0, f.findControlType)(e, r);
                    },
                    a = e.list,
                    s = this.openPopup(),
                    u = (0, l.makeCollection)(this.j);
                  s.parentElement = this, u.parentElement = s, u.mode = "vertical";
                  var d = function (t, r) {
                    if ((0, c.isString)(r) && i(r)) return n.__assign({
                      name: r.toString()
                    }, i(r));
                    if ((0, c.isString)(t) && i(t)) return n.__assign(n.__assign({
                      name: t.toString()
                    }, i(t)), "object" == typeof r ? r : {});
                    (function (e) {
                      return (0, c.isPlainObject)(e) && "title" in e && "value" in e;
                    })(t) && (r = t.value, t = t.title);
                    var a = e.childTemplate,
                      s = {
                        name: t.toString(),
                        template: a && function (e, t, n) {
                          return a(e, t, n, o);
                        },
                        exec: e.childExec ? function (t, o, r) {
                          var i;
                          return null === (i = e.childExec) || void 0 === i ? void 0 : i.call(e, t, o, n.__assign(n.__assign({}, r), {
                            parentControl: e
                          }));
                        } : e.exec,
                        data: e.data,
                        command: e.command,
                        isActive: e.isChildActive,
                        isDisabled: e.isChildDisabled,
                        mode: e.mode,
                        args: n.__spreadArray(n.__spreadArray([], n.__read(e.args ? e.args : []), !1), [t, r], !1)
                      };
                    return (0, c.isString)(r) && (s.text = r), s;
                  };
                  u.build((0, c.isArray)(a) ? a.map(d) : (0, c.keys)(a, !1).map(function (e) {
                    return d(e, a[e]);
                  }), this.target), s.setContent(u.container).open(function () {
                    return (0, c.position)(o.container);
                  }, !1, this.j.o.allowTabNavigation ? this.container : void 0), this.state.activated = !0;
                }, t.prototype.onOutsideClick = function (e) {
                  this.openedPopup && (e && a.Dom.isNode(e.target) && (a.Dom.isOrContains(this.container, e.target) || this.openedPopup.isOwnClick(e)) || this.closePopup());
                }, t.prototype.openPopup = function () {
                  return this.closePopup(), this.openedPopup = new s.Popup(this.j, !1), this.j.e.on(this.ow, "mousedown touchstart", this.onOutsideClick).on("escape closeAllPopups", this.onOutsideClick), this.openedPopup;
                }, t.prototype.closePopup = function () {
                  this.openedPopup && (this.j.e.off(this.ow, "mousedown touchstart", this.onOutsideClick).off("escape closeAllPopups", this.onOutsideClick), this.state.activated = !1, this.openedPopup.close(), this.openedPopup.destruct(), this.openedPopup = null);
                }, t.prototype.onClick = function (e) {
                  var t,
                    o,
                    n,
                    r,
                    i,
                    a,
                    s,
                    l = this.control;
                  if ((0, c.isFunction)(l.exec)) {
                    var u = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null,
                      d = l.exec(this.j, u, {
                        control: l,
                        originalEvent: e,
                        button: this
                      });
                    if (!1 !== d && !0 !== d && (null === (i = null === (r = this.j) || void 0 === r ? void 0 : r.e) || void 0 === i || i.fire("synchro"), this.parentElement && this.parentElement.update(), null === (s = null === (a = this.j) || void 0 === a ? void 0 : a.e) || void 0 === s || s.fire("closeAllPopups afterExec")), !1 !== d) return;
                  }
                  return l.list ? this.openControlList(l) : (0, c.isFunction)(l.popup) ? this.onTriggerClick(e) : void ((l.command || l.name) && ((0, c.call)((0, c.isJoditObject)(this.j) ? this.j.execCommand.bind(this.j) : this.j.od.execCommand.bind(this.j.od), l.command || l.name, !1, l.args && l.args[0]), this.j.e.fire("closeAllPopups")));
                }, t.prototype.destruct = function () {
                  return this.closePopup(), e.prototype.destruct.call(this);
                }, n.__decorate([(0, i.watch)("state.tooltip")], t.prototype, "onChangeTooltip", null), n.__decorate([(0, i.watch)("state.hasTrigger")], t.prototype, "onChangeHasTrigger", null), n.__decorate([(0, i.watch)("trigger:click")], t.prototype, "onTriggerClick", null), n.__decorate([i.autobind], t.prototype, "onOutsideClick", null), n.__decorate([i.autobind], t.prototype, "closePopup", null), n.__decorate([i.component], t);
              }(r.UIButton);
            t.ToolbarButton = h;
          },
          34375: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ToolbarContent = void 0;
            var n = o(20255);
            o(48904);
            var r = o(96516),
              i = o(64968),
              a = o(40332),
              s = o(43441),
              l = function (e) {
                function t(t, o, n) {
                  void 0 === n && (n = null);
                  var r = e.call(this, t) || this;
                  return r.control = o, r.target = n, r.container.classList.add("".concat(r.componentName, "_").concat(r.clearName(o.name))), (0, a.attr)(r.container, "role", "content"), r;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ToolbarContent";
                }, t.prototype.update = function () {
                  var t = this.control.getContent(this.j, this.control, this);
                  ((0, a.isString)(t) || t.parentNode !== this.container) && (i.Dom.detach(this.container), this.container.appendChild((0, a.isString)(t) ? this.j.create.fromHTML(t) : t)), e.prototype.update.call(this);
                }, t.prototype.createContainer = function () {
                  return this.j.c.span(this.componentName);
                }, n.__decorate([s.component], t);
              }(r.UIButton);
            t.ToolbarContent = l;
          },
          3890: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(48197), t), n.__exportStar(o(34375), t);
          },
          72719: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ToolbarCollection = void 0;
            var n = o(20255);
            o(85796);
            var r = o(40332),
              i = o(2074),
              a = o(81438),
              s = o(43441),
              l = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  return o.__listenEvents = "updatePlugins updateToolbar changeStack mousedown mouseup keydown change afterInit readonly afterResize selectionchange changeSelection focus afterSetMode touchstart focus blur", o.update = o.j.async.debounce(o.__immediateUpdate, function () {
                    return o.j.defaultTimeout;
                  }), o.__tooltip = null, o.__initEvents(), o.__tooltip = i.UITooltip.make(t), o;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ToolbarCollection";
                }, Object.defineProperty(t.prototype, "firstButton", {
                  get: function () {
                    return n.__read(this.buttons, 1)[0] || null;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.makeButton = function (e, t) {
                  return void 0 === t && (t = null), (0, a.makeButton)(this.j, e, t);
                }, t.prototype.shouldBeActive = function (e) {}, t.prototype.shouldBeDisabled = function (e) {}, t.prototype.getTarget = function (e) {
                  return e.target || null;
                }, t.prototype.__immediateUpdate = function () {
                  this.isDestructed || this.j.isLocked || (e.prototype.update.call(this), this.j.e.fire("afterUpdateToolbar"));
                }, t.prototype.setDirection = function (e) {
                  this.container.style.direction = e, this.container.setAttribute("dir", e);
                }, t.prototype.__initEvents = function () {
                  this.j.e.on(this.__listenEvents, this.update).on("afterSetMode focus", this.__immediateUpdate);
                }, t.prototype.hide = function () {
                  this.container.remove();
                }, t.prototype.show = function () {
                  this.appendTo(this.j.toolbarContainer);
                }, t.prototype.showInline = function (e) {
                  throw (0, r.error)("The method is not implemented for this class.");
                }, t.prototype.build = function (t, o) {
                  void 0 === o && (o = null);
                  var n = this.j.e.fire("beforeToolbarBuild", t);
                  return n && (t = n), e.prototype.build.call(this, t, o), this;
                }, t.prototype.destruct = function () {
                  var t;
                  this.isDestructed || (null === (t = this.__tooltip) || void 0 === t || t.destruct(), this.j.e.off(this.__listenEvents, this.update).off("afterSetMode focus", this.__immediateUpdate), e.prototype.destruct.call(this));
                }, n.__decorate([s.autobind], t.prototype, "__immediateUpdate", null), n.__decorate([s.component], t);
              }(i.UIList);
            t.ToolbarCollection = l;
          },
          81698: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ToolbarEditorCollection = void 0;
            var n = o(20255),
              r = o(72719),
              i = o(86893),
              a = o(64968),
              s = o(40332),
              l = o(43441),
              c = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  return o.checkActiveStatus = function (e, t) {
                    var n = 0,
                      r = 0;
                    return Object.keys(e).forEach(function (i) {
                      var a = e[i];
                      (0, s.isFunction)(a) ? a(o.j, (0, s.css)(t, i).toString()) && (n += 1) : -1 !== a.indexOf((0, s.css)(t, i).toString()) && (n += 1), r += 1;
                    }), r === n;
                  }, o.prependInvisibleInput(o.container), o;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "ToolbarEditorCollection";
                }, t.prototype.shouldBeDisabled = function (t) {
                  var o = e.prototype.shouldBeDisabled.call(this, t);
                  if (void 0 !== o) return o;
                  var n = void 0 === t.control.mode ? i.MODE_WYSIWYG : t.control.mode;
                  return !(n === i.MODE_SPLIT || n === this.j.getRealMode());
                }, t.prototype.shouldBeActive = function (t) {
                  var o = this,
                    n = e.prototype.shouldBeActive.call(this, t);
                  if (void 0 !== n) return n;
                  var r = this.j.selection ? this.j.s.current() : null;
                  if (!r) return !1;
                  if (t.control.tags) {
                    var i = t.control.tags;
                    if (a.Dom.up(r, function (e) {
                      if (e && -1 !== i.indexOf(e.nodeName.toLowerCase())) return !0;
                    }, this.j.editor)) return !0;
                  }
                  if (t.control.css) {
                    var s = t.control.css;
                    if (a.Dom.up(r, function (e) {
                      if (e && !a.Dom.isText(e)) return o.checkActiveStatus(s, e);
                    }, this.j.editor)) return !0;
                  }
                  return !1;
                }, t.prototype.getTarget = function (e) {
                  return e.target || this.j.s.current() || null;
                }, t.prototype.prependInvisibleInput = function (e) {
                  var t = this.j.create.element("input", {
                    tabIndex: -1,
                    disabled: !0,
                    style: "width: 0; height:0; position: absolute; visibility: hidden;"
                  });
                  a.Dom.appendChildFirst(e, t);
                }, t.prototype.showInline = function (e) {
                  this.jodit.e.fire("showInlineToolbar", e);
                }, t.prototype.hide = function () {
                  this.jodit.e.fire("hidePopup"), e.prototype.hide.call(this), this.jodit.e.fire("toggleToolbar");
                }, t.prototype.show = function () {
                  e.prototype.show.call(this), this.jodit.e.fire("toggleToolbar");
                }, n.__decorate([l.component], t);
              }(r.ToolbarCollection);
            t.ToolbarEditorCollection = c;
          },
          81438: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.makeButton = t.makeCollection = void 0;
            var n = o(40332),
              r = o(72719),
              i = o(81698),
              a = o(48197),
              s = o(34375);
            t.makeCollection = function (e, t) {
              var o = (0, n.isJoditObject)(e) ? new i.ToolbarEditorCollection(e) : new r.ToolbarCollection(e);
              return e.o.textIcons && o.container.classList.add("jodit_text_icons"), t && (o.parentElement = t), e.o.toolbarButtonSize && (o.buttonSize = e.o.toolbarButtonSize), o;
            }, t.makeButton = function (e, t, o) {
              if (void 0 === o && (o = null), (0, n.isFunction)(t.getContent)) return new s.ToolbarContent(e, t, o);
              var r = new a.ToolbarButton(e, t, o);
              return r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, r;
            };
          },
          36262: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(93166),
              i = o(49781),
              a = o(77892);
            r.Config.prototype.enableDragAndDropFileToEditor = !0, r.Config.prototype.uploader = {
              url: "",
              insertImageAsBase64URI: !1,
              imagesExtensions: ["jpg", "png", "jpeg", "gif"],
              headers: null,
              data: null,
              filesVariableName: function (e) {
                return "files[".concat(e, "]");
              },
              withCredentials: !1,
              pathVariableName: "path",
              format: "json",
              method: "POST",
              prepareData: function (e) {
                return e;
              },
              isSuccess: function (e) {
                return e.success;
              },
              getMessage: function (e) {
                return void 0 !== e.data.messages && (0, i.isArray)(e.data.messages) ? e.data.messages.join(" ") : "";
              },
              processFileName: function (e, t, o) {
                return [e, t, o];
              },
              process: function (e) {
                return e.data;
              },
              error: function (e) {
                this.j.e.fire("errorMessage", e.message, "error", 4e3);
              },
              getDisplayName: function (e, t) {
                return e + t;
              },
              defaultHandlerSuccess: function (e) {
                var t = this,
                  o = this.j || this;
                (0, a.isJoditObject)(o) && e.files && e.files.length && e.files.forEach(function (r, i) {
                  var a = n.__read(e.isImages && e.isImages[i] ? ["img", "src"] : ["a", "href"], 2),
                    s = a[0],
                    l = a[1],
                    c = o.createInside.element(s);
                  c.setAttribute(l, e.baseurl + r), "a" === s && (c.textContent = o.o.uploader.getDisplayName.call(t, e.baseurl, r)), "img" === s ? o.s.insertImage(c, null, o.o.imageDefaultWidth) : o.s.insertNode(c);
                });
              },
              defaultHandlerError: function (e) {
                this.j.e.fire("errorMessage", e.message);
              },
              contentType: function (e) {
                return (void 0 === this.ow.FormData || "string" == typeof e) && "application/x-www-form-urlencoded; charset=UTF-8";
              }
            };
          },
          55778: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.buildData = void 0;
            var n = o(40332);
            t.buildData = function (e, t) {
              if ((0, n.isFunction)(e.o.buildData)) return e.o.buildData.call(e, t);
              var o = e.ow.FormData;
              if (void 0 !== o) {
                if (t instanceof o) return t;
                if ((0, n.isString)(t)) return t;
                var r = new o();
                return Object.keys(t).forEach(function (e) {
                  r.append(e, t[e]);
                }), r;
              }
              return t;
            };
          },
          98099: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.dataURItoBlob = void 0, t.dataURItoBlob = function (e) {
              for (var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; t.length > i; i += 1) r[i] = t.charCodeAt(i);
              return new Blob([r], {
                type: o
              });
            };
          },
          41566: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hasItems = t.hasFiles = void 0;
            var n = o(20255);
            n.__exportStar(o(32937), t), n.__exportStar(o(98099), t), n.__exportStar(o(55778), t), n.__exportStar(o(30863), t), n.__exportStar(o(20704), t), t.hasFiles = function (e) {
              return Boolean(e && e.files && e.files.length > 0);
            }, t.hasItems = function (e) {
              return Boolean(e && e.items && e.items.length > 0);
            };
          },
          32937: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.processOldBrowserDrag = void 0;
            var n = o(86893),
              r = o(17332),
              i = o(40332),
              a = o(64968),
              s = o(41566);
            t.processOldBrowserDrag = function (e, t, o, l, c) {
              if (t && (!t.types.length || t.types[0] !== n.TEXT_PLAIN)) {
                var u = e.j.c.div("", {
                  tabindex: -1,
                  style: "left: -9999px; top: 0; width: 0; height: 100%;line-height: 140%; overflow: hidden; position: fixed; z-index: 2147483647; word-break: break-all;",
                  contenteditable: !0
                });
                (0, r.getContainer)(e.j, e.constructor).appendChild(u);
                var d = (0, i.isJoditObject)(e.j) ? e.j.s.save() : null;
                u.focus(), e.j.async.setTimeout(function () {
                  var t = u.firstChild;
                  if (a.Dom.safeRemove(u), t && t.hasAttribute("src")) {
                    var n = (0, i.attr)(t, "src") || "";
                    d && (0, i.isJoditObject)(e.j) && e.j.s.restore(), (0, s.sendFiles)(e, [(0, s.dataURItoBlob)(n)], o, l).finally(c);
                  }
                }, e.j.defaultTimeout);
              }
            };
          },
          20704: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.sendFiles = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(30863);
            t.sendFiles = function (e, t, o, a, s) {
              if (!t) return Promise.reject((0, r.error)("Need files"));
              var l = e.o,
                c = (0, r.toArray)(t);
              if (!c.length) return Promise.reject((0, r.error)("Need files"));
              var u = [];
              if (l.insertImageAsBase64URI) {
                var d,
                  p = void 0,
                  f = function () {
                    if ((d = c[p]) && d.type) {
                      var t = d.type.match(/\/([a-z0-9]+)/i),
                        n = t[1] ? t[1].toLowerCase() : "";
                      if (l.imagesExtensions.includes(n)) {
                        var i = new FileReader();
                        u.push(e.j.async.promise(function (t, n) {
                          i.onerror = n, i.onloadend = function () {
                            var n = {
                              baseurl: "",
                              files: [i.result],
                              isImages: [!0]
                            };
                            ((0, r.isFunction)(o) ? o : l.defaultHandlerSuccess).call(e, n), t(n);
                          }, i.readAsDataURL(d);
                        })), c[p] = null;
                      }
                    }
                  };
                for (p = 0; c.length > p; p += 1) f();
              }
              if ((c = c.filter(function (e) {
                return e;
              })).length) {
                var h = new FormData();
                h.append(l.pathVariableName, e.path), h.append("source", e.source);
                var m = void 0;
                for (p = 0; c.length > p; p += 1) if (m = c[p]) {
                  var v = /\.[\d\w]+$/.test(m.name),
                    g = m.type.match(/\/([a-z0-9]+)/i),
                    y = g && g[1] ? g[1].toLowerCase() : "",
                    _ = c[p].name || Math.random().toString().replace(".", "");
                  if (!v && y) {
                    var b = y;
                    ["jpeg", "jpg"].includes(b) && (b = "jpeg|jpg"), new RegExp(".(" + b + ")$", "i").test(_) || (_ += "." + y);
                  }
                  var w = n.__read(l.processFileName.call(e, l.filesVariableName(p), c[p], _), 3);
                  h.append(w[0], w[1], w[2]);
                }
                s && s(h), l.data && (0, r.isPlainObject)(l.data) && Object.keys(l.data).forEach(function (e) {
                  h.append(e, l.data[e]);
                }), l.prepareData.call(e, h), u.push((0, i.send)(e, h).then(function (t) {
                  return l.isSuccess.call(e, t) ? (((0, r.isFunction)(o) ? o : l.defaultHandlerSuccess).call(e, l.process.call(e, t)), t) : (((0, r.isFunction)(a) ? a : l.defaultHandlerError).call(e, (0, r.error)(l.getMessage.call(e, t))), t);
                }).then(function () {
                  e.j.events && e.j.e.fire("filesWereUploaded");
                }));
              }
              return Promise.all(u);
            };
          },
          30863: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.send = t.ajaxInstances = void 0;
            var n = o(30056),
              r = o(40332),
              i = o(55778);
            t.ajaxInstances = new WeakMap(), t.send = function (e, o) {
              var a = (0, i.buildData)(e, o),
                s = function (o) {
                  var i = new n.Ajax({
                      xhr: function () {
                        var t = new XMLHttpRequest();
                        return void 0 !== e.j.ow.FormData && t.upload ? (e.j.progressbar.show().progress(10), t.upload.addEventListener("progress", function (t) {
                          if (t.lengthComputable) {
                            var o = t.loaded / t.total;
                            o *= 100, e.j.progressbar.show().progress(o), 100 > o || e.j.progressbar.hide();
                          }
                        }, !1)) : e.j.progressbar.hide(), t;
                      },
                      method: e.o.method || "POST",
                      data: o,
                      url: (0, r.isFunction)(e.o.url) ? e.o.url(o) : e.o.url,
                      headers: e.o.headers,
                      queryBuild: e.o.queryBuild,
                      contentType: e.o.contentType.call(e, o),
                      withCredentials: e.o.withCredentials || !1
                    }),
                    a = t.ajaxInstances.get(e);
                  return a || (a = new Set(), t.ajaxInstances.set(e, a)), a.add(i), e.j.e.one("beforeDestruct", i.destruct), i.send().then(function (e) {
                    return e.json();
                  }).catch(function (t) {
                    e.o.error.call(e, t);
                  }).finally(function () {
                    i.destruct(), null == a || a.delete(i);
                  });
                };
              return (0, r.isPromise)(a) ? a.then(s).catch(function (t) {
                e.o.error.call(e, t);
              }) : s(a);
            };
          },
          50454: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Uploader = void 0;
            var n = o(20255);
            o(28654);
            var r = o(93166),
              i = o(86893),
              a = o(40332),
              s = o(56562),
              l = o(41566);
            o(36262);
            var c = function (e) {
              function t(t, o) {
                var n = e.call(this, t) || this;
                return n.path = "", n.source = "default", n.options = (0, a.ConfigProto)(o || {}, (0, a.ConfigProto)(r.Config.defaultOptions.uploader, (0, a.isJoditObject)(t) ? t.o.uploader : {})), n;
              }
              return n.__extends(t, e), Object.defineProperty(t.prototype, "j", {
                get: function () {
                  return this.jodit;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.className = function () {
                return "Uploader";
              }, Object.defineProperty(t.prototype, "o", {
                get: function () {
                  return this.options;
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.setPath = function (e) {
                return this.path = e, this;
              }, t.prototype.setSource = function (e) {
                return this.source = e, this;
              }, t.prototype.bind = function (e, t, o) {
                var n = function () {
                    e.classList.remove("jodit_drag_hover");
                  },
                  r = this,
                  a = function (e) {
                    var a,
                      s,
                      c,
                      u = e.clipboardData,
                      d = function (e) {
                        s && (e.append("extension", c), e.append("mimetype", s.type));
                      };
                    if (!i.IS_IE && (0, l.hasFiles)(u)) return (0, l.sendFiles)(r, u.files, t, o).finally(n), !1;
                    if (i.IS_IE) return (0, l.processOldBrowserDrag)(r, u, t, o, n);
                    if ((0, l.hasItems)(u)) {
                      var p = u.items;
                      for (a = 0; p.length > a; a += 1) if ("file" === p[a].kind && "image/png" === p[a].type) {
                        if (s = p[a].getAsFile()) {
                          var f = s.type.match(/\/([a-z0-9]+)/i);
                          c = f[1] ? f[1].toLowerCase() : "", (0, l.sendFiles)(r, [s], t, o, d).finally(n);
                        }
                        e.preventDefault();
                        break;
                      }
                    }
                  };
                r.j && r.j.editor !== e ? r.j.e.on(e, "paste", a) : r.j.e.on("beforePaste", a), this.attachEvents(e, t, o, n);
              }, t.prototype.attachEvents = function (e, t, o, n) {
                var r = this;
                r.j.e.on(e, "dragend dragover dragenter dragleave drop", function (e) {
                  e.preventDefault();
                }).on(e, "dragover", function (t) {
                  ((0, l.hasFiles)(t.dataTransfer) || (0, l.hasItems)(t.dataTransfer)) && (e.classList.add("jodit_drag_hover"), t.preventDefault());
                }).on(e, "dragend dragleave", function (t) {
                  e.classList.remove("jodit_drag_hover"), (0, l.hasFiles)(t.dataTransfer) && t.preventDefault();
                }).on(e, "drop", function (i) {
                  e.classList.remove("jodit_drag_hover"), (0, l.hasFiles)(i.dataTransfer) && (i.preventDefault(), i.stopImmediatePropagation(), (0, l.sendFiles)(r, i.dataTransfer.files, t, o).finally(n));
                });
                var i = e.querySelector("input[type=file]");
                i && r.j.e.on(i, "change", function () {
                  (0, l.sendFiles)(r, i.files, t, o).then(function () {
                    i.value = "", /safari/i.test(navigator.userAgent) || (i.type = "", i.type = "file");
                  }).finally(n);
                });
              }, t.prototype.uploadRemoteImage = function (e, t, o) {
                var n = this,
                  r = n.o,
                  i = (0, a.isFunction)(o) ? o : r.defaultHandlerError;
                (0, l.send)(n, {
                  action: "fileUploadRemote",
                  url: e
                }).then(function (e) {
                  r.isSuccess.call(n, e) ? ((0, a.isFunction)(t) ? t : r.defaultHandlerSuccess).call(n, r.process.call(n, e)) : i.call(n, (0, a.error)(r.getMessage.call(n, e)));
                }).catch(function (e) {
                  return i.call(n, e);
                });
              }, t.prototype.destruct = function () {
                this.setStatus(s.STATUSES.beforeDestruct);
                var t = l.ajaxInstances.get(this);
                t && (t.forEach(function (e) {
                  try {
                    e.destruct();
                  } catch (e) {}
                }), t.clear()), e.prototype.destruct.call(this);
              }, t;
            }(s.ViewComponent);
            t.Uploader = c;
          },
          75243: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.ColorPickerWidget = void 0, o(60819);
            var n = o(40332),
              r = o(2074),
              i = o(64968);
            r.Icon.set("palette", o(95331)), t.ColorPickerWidget = function (e, t, o) {
              var a = "jodit-color-picker",
                s = (0, n.normalizeColor)(o),
                l = e.c.div(a),
                c = e.o.textIcons ? "<span>".concat(e.i18n("palette"), "</span>") : r.Icon.get("palette"),
                u = function (e) {
                  var t = [];
                  return (0, n.isPlainObject)(e) ? Object.keys(e).forEach(function (o) {
                    t.push('<div class="'.concat(a, "__group ").concat(a, "__group-").concat(o, '">')), t.push(u(e[o])), t.push("</div>");
                  }) : (0, n.isArray)(e) && e.forEach(function (e) {
                    t.push("<span class='".concat(a, "__color-item ").concat(s === e ? a + "__color-item_active_true" : "", "' title=\"").concat(e, '" style="background-color:').concat(e, '" data-color="').concat(e, '"></span>'));
                  }), t.join("");
                };
              l.appendChild(e.c.fromHTML('<div class="'.concat(a, '__groups">').concat(u(e.o.colors), "</div>"))), l.appendChild(e.c.fromHTML('<div data-ref="extra" class="'.concat(a, '__extra"></div>')));
              var d = (0, n.refs)(l).extra;
              return e.o.showBrowserColorPicker && (0, n.hasBrowserColorPicker)() && (d.appendChild(e.c.fromHTML('<div class="'.concat(a, '__native">').concat(c, '<input type="color" value="#ffffff"/></div>'))), e.e.on(l, "change", function (e) {
                e.stopPropagation();
                var o = e.target;
                if (o && o.tagName && i.Dom.isTag(o, "input")) {
                  var r = o.value || "";
                  (0, n.isFunction)(t) && t(r), e.preventDefault();
                }
              })), e.e.on(l, "mousedown touchend", function (o) {
                o.stopPropagation(), o.preventDefault();
                var r = o.target;
                if (r && r.tagName && !i.Dom.isTag(r, "svg") && !i.Dom.isTag(r, "path") || !r.parentNode || (r = i.Dom.closest(r.parentNode, "span", e.editor)), i.Dom.isTag(r, "span") && r.classList.contains(a + "__color-item")) {
                  var s = (0, n.attr)(r, "-color") || "";
                  t && (0, n.isFunction)(t) && t(s);
                }
              }), e.e.fire("afterGenerateColorPicker", l, d, t, s), l;
            };
          },
          83029: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.FileSelectorWidget = void 0;
            var n = o(40332),
              r = o(64968),
              i = o(2074),
              a = o(60929);
            t.FileSelectorWidget = function (e, t, o, s, l) {
              var c;
              void 0 === l && (l = !0);
              var u = [];
              if (t.upload && e.o.uploader && (e.o.uploader.url || e.o.uploader.insertImageAsBase64URI)) {
                var d = e.c.fromHTML('<div class="jodit-drag-and-drop__file-box">' + "<strong>".concat(e.i18n(l ? "Drop image" : "Drop file"), "</strong>") + "<span><br>".concat(e.i18n("or click"), "</span>") + '<input type="file" accept="'.concat(l ? "image/*" : "*", '" tabindex="-1" dir="auto" multiple=""/>') + "</div>");
                e.uploader.bind(d, function (o) {
                  var r = (0, n.isFunction)(t.upload) ? t.upload : e.o.uploader.defaultHandlerSuccess;
                  (0, n.isFunction)(r) && r.call(e, o), e.e.fire("closeAllPopups");
                }, function (t) {
                  e.e.fire("errorMessage", t.message), e.e.fire("closeAllPopups");
                }), u.push({
                  icon: "upload",
                  name: "Upload",
                  content: d
                });
              }
              if (t.filebrowser && (e.o.filebrowser.ajax.url || e.o.filebrowser.items.url) && u.push({
                icon: "folder",
                name: "Browse",
                content: function () {
                  s && s(), t.filebrowser && e.filebrowser.open(t.filebrowser, l);
                }
              }), t.url) {
                var p = new i.UIButton(e, {
                    type: "submit",
                    variant: "primary",
                    text: "Insert"
                  }),
                  f = new i.UIForm(e, [new i.UIInput(e, {
                    required: !0,
                    label: "URL",
                    name: "url",
                    type: "text",
                    placeholder: "https://"
                  }), new i.UIInput(e, {
                    name: "text",
                    label: "Alternative text"
                  }), new i.UIBlock(e, [p])]);
                c = null, o && !r.Dom.isText(o) && (r.Dom.isTag(o, "img") || (0, n.$$)("img", o).length) && (c = "IMG" === o.tagName ? o : (0, n.$$)("img", o)[0], (0, n.val)(f.container, "input[name=url]", (0, n.attr)(c, "src")), (0, n.val)(f.container, "input[name=text]", (0, n.attr)(c, "alt")), p.state.text = "Update"), o && r.Dom.isTag(o, "a") && ((0, n.val)(f.container, "input[name=url]", (0, n.attr)(o, "href")), (0, n.val)(f.container, "input[name=text]", (0, n.attr)(o, "title")), p.state.text = "Update"), f.onSubmit(function (o) {
                  (0, n.isFunction)(t.url) && t.url.call(e, o.url, o.text);
                }), u.push({
                  icon: "link",
                  name: "URL",
                  content: f.container
                });
              }
              return (0, a.TabsWidget)(e, u);
            };
          },
          718: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(75243), t), n.__exportStar(o(60929), t), n.__exportStar(o(83029), t);
          },
          60929: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.TabsWidget = void 0, o(96410);
            var n = o(40332),
              r = o(42096),
              i = o(2074),
              a = o(56562),
              s = o(24263);
            t.TabsWidget = function (e, t, o) {
              var l = e.c.div("jodit-tabs"),
                c = e.c.div("jodit-tabs__wrapper"),
                u = e.c.div("jodit-tabs__buttons"),
                d = {},
                p = [],
                f = "",
                h = 0;
              l.appendChild(u), l.appendChild(c);
              var m = function (e) {
                d[e] && (p.forEach(function (e) {
                  e.state.activated = !1;
                }), (0, n.$$)(".jodit-tab", c).forEach(function (e) {
                  e.classList.remove("jodit-tab_active");
                }), d[e].button.state.activated = !0, d[e].tab.classList.add("jodit-tab_active"));
              };
              if (t.forEach(function (n) {
                var l = n.icon,
                  v = n.name,
                  g = n.content,
                  y = e.c.div("jodit-tab"),
                  _ = (0, i.Button)(e, l || v, v);
                e.e.on(_.container, "mousedown", function (e) {
                  return e.preventDefault();
                }), f || (f = v), u.appendChild(_.container), p.push(_), _.container.classList.add("jodit-tabs__button", "jodit-tabs__button_columns_" + t.length), (0, r.isFunction)(g) ? y.appendChild(e.c.div("jodit-tab_empty")) : y.appendChild(a.Component.isInstanceOf(g, i.UIElement) ? g.container : g), c.appendChild(y), _.onAction(function () {
                  return m(v), (0, r.isFunction)(g) && !s.Dom.isElement(g) && g.call(e), o && (o.__activeTab = v), !1;
                }), d[v] = {
                  button: _,
                  tab: y
                }, h += 1;
              }), !h) return l;
              if ((0, n.$$)("a", u).forEach(function (e) {
                e.style.width = (100 / h).toFixed(10) + "%";
              }), m(o && o.__activeTab && d[o.__activeTab] ? o.__activeTab : f), o) {
                var v = o.__activeTab;
                Object.defineProperty(o, "__activeTab", {
                  configurable: !0,
                  enumerable: !1,
                  get: function () {
                    return v;
                  },
                  set: function (e) {
                    v = e, m(e);
                  }
                });
              }
              return l;
            };
          },
          55692: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(33126);
            var n = o(93166),
              r = o(40332),
              i = o(86893),
              a = o(17332),
              s = o(77904);
            n.Config.prototype.controls.about = {
              exec: function (e) {
                var t = e.dlg(),
                  o = e.i18n.bind(e);
                t.setMod("theme", e.o.theme).setHeader(o("About Jodit")).setContent('<div class="jodit-about">\n\t\t\t\t\t<div>'.concat(o("Jodit Editor"), " v.").concat(e.getVersion(), "</div>\n\t\t\t\t\t<div>").concat(o("License: %s", (0, r.isLicense)(e.o.license) ? (0, r.normalizeLicense)(e.o.license) : "MIT"), '</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="').concat("https://xdsoft.net/jodit/", '" target="_blank">').concat("https://xdsoft.net/jodit/", '</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="https://xdsoft.net/jodit/docs/" target="_blank">').concat(o("Jodit User's Guide"), "</a>\n\t\t\t\t\t\t").concat(o("contains detailed help for using"), "\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>").concat(o("Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved."), "</div>\n\t\t\t\t</div>")), (0, r.css)(t.dialog, {
                  minHeight: 200,
                  minWidth: 420
                }), t.open(!0);
              },
              tooltip: "About Jodit",
              mode: i.MODE_SOURCE + i.MODE_WYSIWYG
            }, a.pluginSystem.add("about", function (e) {
              e.registerButton({
                name: "about",
                group: "info"
              });
            }), s.Icon.set("about", o(84279));
          },
          66031: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.addNewLine = void 0;
            var n = o(20255);
            o(30724);
            var r = o(87837),
              i = o(40332),
              a = o(43441),
              s = o(17332);
            o(46360);
            var l = "addnewline",
              c = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.line = t.j.c.fromHTML('<div role="button" tabindex="-1" title="'.concat(t.j.i18n("Break"), '" class="jodit-add-new-line"><span>').concat(r.Icon.get("enter"), "</span></div>")), t.isMatchedTag = function (e) {
                    return Boolean(e && t.j.o.addNewLineTagsTriggers.includes(e.nodeName.toLowerCase()));
                  }, t.preview = !1, t.lineInFocus = !1, t.isShown = !1, t.hideForce = function () {
                    t.isShown && (t.isShown = !1, t.j.async.clearTimeout(t.timeout), t.lineInFocus = !1, r.Dom.safeRemove(t.line), t.line.style.setProperty("--jd-offset-handle", "0"));
                  }, t.canGetFocus = function (e) {
                    return null != e && r.Dom.isBlock(e) && !/^(img|table|iframe|hr)$/i.test(e.nodeName);
                  }, t.onClickLine = function (e) {
                    var o = t.j,
                      n = o.createInside.element(o.o.enter);
                    t.preview && t.current && t.current.parentNode ? t.current === o.editor ? r.Dom.prepend(o.editor, n) : t.current.parentNode.insertBefore(n, t.current) : o.editor.appendChild(n), o.s.setCursorIn(n), (0, i.scrollIntoViewIfNeeded)(n, o.editor, o.ed), o.synchronizeValues(), t.hideForce(), e.preventDefault();
                  }, t;
                }
                return n.__extends(t, e), t.prototype.show = function () {
                  this.isShown || this.j.o.readonly || this.j.isLocked || (this.isShown = !0, this.j.async.clearTimeout(this.timeout), this.line.classList.toggle("jodit-add-new-line_after", !this.preview), this.j.container.appendChild(this.line), this.line.style.width = this.j.container.clientWidth + "px");
                }, t.prototype.onLock = function (e) {
                  e && this.isShown && this.hideForce();
                }, t.prototype.hide = function () {
                  this.isShown && !this.lineInFocus && (this.timeout = this.j.async.setTimeout(this.hideForce, {
                    timeout: 500,
                    label: "add-new-line-hide"
                  }));
                }, t.prototype.afterInit = function (e) {
                  var t = this;
                  e.o.addNewLine && (e.e.on(this.line, "mousemove", function (e) {
                    e.stopPropagation();
                  }).on(this.line, "mousedown touchstart", this.onClickLine).on("change", this.hideForce).on(this.line, "mouseenter", function () {
                    t.j.async.clearTimeout(t.timeout), t.lineInFocus = !0;
                  }).on(this.line, "mouseleave", function () {
                    t.lineInFocus = !1;
                  }).on("changePlace", this.addEventListeners.bind(this)), this.addEventListeners());
                }, t.prototype.addEventListeners = function () {
                  var e = this.j;
                  e.e.off(e.editor, "." + l).off(e.container, "." + l).on([e.ow, e.ew, e.editor], "scroll." + l, this.hideForce).on(e.editor, "click." + l, this.hide).on(e.container, "mouseleave." + l, this.hide).on(e.editor, "mousemove." + l, this.onMouseMove);
                }, t.prototype.onDblClickEditor = function (e) {
                  var t = this.j;
                  if (!t.o.readonly && t.o.addNewLineOnDBLClick && e.target === t.editor && t.s.isCollapsed()) {
                    var o = (0, i.offset)(t.editor, t, t.ed),
                      n = e.pageY - t.ew.pageYOffset,
                      r = t.createInside.element(t.o.enter);
                    Math.abs(n - o.top) < Math.abs(n - (o.height + o.top)) && t.editor.firstChild ? t.editor.insertBefore(r, t.editor.firstChild) : t.editor.appendChild(r), t.s.setCursorIn(r), t.synchronizeValues(), this.hideForce(), e.preventDefault();
                  }
                }, t.prototype.onMouseMove = function (e) {
                  var t = this.j,
                    o = t.ed.elementFromPoint(e.clientX, e.clientY);
                  if (r.Dom.isHTMLElement(o) && !r.Dom.isOrContains(this.line, o) && r.Dom.isOrContains(t.editor, o)) if (t.editor === o || this.isMatchedTag(o) || (o = r.Dom.closest(o, this.isMatchedTag, t.editor)), o) {
                    if (this.isMatchedTag(o)) {
                      var n = r.Dom.up(o, r.Dom.isBlock, t.editor);
                      n && n !== t.editor && (o = n);
                    }
                    var a = (0, i.position)(o, this.j),
                      s = !1,
                      l = e.clientY,
                      c = e.clientX;
                    if (this.j.iframe) {
                      var u = (0, i.position)(this.j.iframe, this.j, !0);
                      l += u.top, c += u.left;
                    }
                    var d = this.j.o.addNewLineDeltaShow;
                    Math.abs(l - a.top) > d || (s = a.top, this.preview = !0), Math.abs(l - (a.top + a.height)) > d || (s = a.top + a.height, this.preview = !1), !1 === s || (t.editor !== o || this.preview) && (0, i.call)(this.preview ? r.Dom.prev : r.Dom.next, o, this.canGetFocus, t.editor) ? (this.current = !1, this.hide()) : (this.line.style.top = s + "px", this.current = o, this.show(), this.line.style.setProperty("--jd-offset-handle", c - a.left - 10 + "px"));
                  } else this.hide();
                }, t.prototype.beforeDestruct = function () {
                  this.j.async.clearTimeout(this.timeout), this.j.e.off(this.line).off("changePlace", this.addEventListeners), r.Dom.safeRemove(this.line), this.j.e.off([this.j.ow, this.j.ew, this.j.editor], "." + l).off(this.j.container, "." + l);
                }, n.__decorate([(0, a.watch)(":lock")], t.prototype, "onLock", null), n.__decorate([a.autobind], t.prototype, "hide", null), n.__decorate([(0, a.watch)(":dblclick")], t.prototype, "onDblClickEditor", null), n.__decorate([(0, a.debounce)(function (e) {
                  return 5 * e.defaultTimeout;
                })], t.prototype, "onMouseMove", null), t;
              }(r.Plugin);
            t.addNewLine = c, s.pluginSystem.add("addNewLine", c);
          },
          46360: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(2074);
            n.Config.prototype.addNewLine = !0, n.Config.prototype.addNewLineOnDBLClick = !0, n.Config.prototype.addNewLineTagsTriggers = ["table", "iframe", "img", "hr", "pre", "jodit"], n.Config.prototype.addNewLineDeltaShow = 20, r.Icon.set("enter", o(11257));
          },
          91241: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.backspace = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(64968),
              a = o(86893),
              s = o(40332),
              l = o(10109),
              c = o(17332),
              u = o(90089),
              d = o(95441);
            o(48229);
            var p = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.requires = ["hotkeys"], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.e.on("afterCommand.delete", function (e) {
                  "delete" === e && t.afterDeleteCommand();
                }), e.registerCommand("deleteButton", {
                  exec: function () {
                    return t.onDelete(!1);
                  },
                  hotkeys: e.o.delete.hotkeys.delete
                }, {
                  stopPropagation: !1
                }).registerCommand("backspaceButton", {
                  exec: function () {
                    return t.onDelete(!0);
                  },
                  hotkeys: e.o.delete.hotkeys.backspace
                }, {
                  stopPropagation: !1
                }).registerCommand("deleteWordButton", {
                  exec: function () {
                    return t.onDelete(!1, "word");
                  },
                  hotkeys: e.o.delete.hotkeys.deleteWord
                }).registerCommand("backspaceWordButton", {
                  exec: function () {
                    return t.onDelete(!0, "word");
                  },
                  hotkeys: e.o.delete.hotkeys.backspaceWord
                }).registerCommand("deleteSentenceButton", {
                  exec: function () {
                    return t.onDelete(!1, "sentence");
                  },
                  hotkeys: e.o.delete.hotkeys.deleteSentence
                }).registerCommand("backspaceSentenceButton", {
                  exec: function () {
                    return t.onDelete(!0, "sentence");
                  },
                  hotkeys: e.o.delete.hotkeys.backspaceSentence
                });
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off("afterCommand.delete");
              }, t.prototype.afterDeleteCommand = function () {
                var e = this.j,
                  t = e.s.current();
                if (t && i.Dom.isTag(t.firstChild, "br") && e.s.removeNode(t.firstChild), !((0, s.trim)(e.editor.textContent || "") || e.editor.querySelector("img,table,jodit,iframe,hr") || t && i.Dom.closest(t, "table", e.editor))) {
                  e.editor.innerHTML = "";
                  var o = e.s.setCursorIn(e.editor);
                  e.s.removeNode(o);
                }
              }, t.prototype.onDelete = function (e, t) {
                void 0 === t && (t = "char");
                var o = this.j,
                  n = o.selection;
                if (n.isFocused() || n.focus(), (0, d.checkNotCollapsed)(o)) return !1;
                var r = n.range,
                  c = o.createInside.text(a.INVISIBLE_SPACE);
                try {
                  if (i.Dom.safeInsertNode(r, c), !i.Dom.isOrContains(o.editor, c)) return;
                  if (o.e.fire("backSpaceBeforeCases", e, c)) return !1;
                  if ((0, l.moveNodeInsideStart)(o, c, e), u.cases.some(function (n) {
                    if ((0, s.isFunction)(n) && n(o, c, e, t)) return !0;
                  })) return !1;
                } catch (e) {
                  throw e;
                } finally {
                  o.e.fire("backSpaceAfterDelete", e, c), this.safeRemoveEmptyNode(c);
                }
                return !1;
              }, t.prototype.safeRemoveEmptyNode = function (e) {
                var t,
                  o,
                  n = this.j.s.range;
                n.startContainer === e && (e.previousSibling ? i.Dom.isText(e.previousSibling) ? n.setStart(e.previousSibling, null !== (o = null === (t = e.previousSibling.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) : n.setStartAfter(e.previousSibling) : e.nextSibling && (i.Dom.isText(e.nextSibling) ? n.setStart(e.nextSibling, 0) : n.setStartBefore(e.nextSibling)), n.collapse(!0), this.j.s.selectRange(n)), i.Dom.safeRemove(e);
              }, t;
            }(r.Plugin);
            t.backspace = p, c.pluginSystem.add("backspace", p);
          },
          31078: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkJoinNeighbors = void 0;
            var n = o(24263),
              r = o(30861);
            function i(e, t, o, i) {
              if (t && n.Dom.isElement(o)) {
                n.Dom.moveContent(t, o, !i, (0, r.getMoveFilter)(e));
                for (var a = t; a && a !== e.editor && n.Dom.isEmpty(a);) {
                  var s = a.parentElement;
                  n.Dom.safeRemove(a), a = s;
                }
                return !0;
              }
              return !1;
            }
            t.checkJoinNeighbors = function (e, t, o) {
              for (var r = t, a = r; r && !n.Dom.findNotEmptySibling(r, o) && r.parentElement !== e.editor;) a = r = r.parentElement;
              if (n.Dom.isElement(a) && n.Dom.isContentEditable(a, e.editor)) {
                var s = n.Dom.findNotEmptySibling(a, o);
                if (s && (function (e, t, o, r) {
                  var a = n.Dom.isTag(o, ["ol", "ul"]),
                    s = n.Dom.isTag(t, ["ol", "ul"]),
                    l = function (e, t) {
                      return t ? e.firstElementChild : e.lastElementChild;
                    };
                  return s ? (o = e.createInside.element(e.o.enterBlock), n.Dom.before(t, o), i(e, l(t, r), o, r)) : !(!o || !a || s) && i(e, t, l(o, !r), r);
                }(e, a, s, o) || i(e, a, s, o))) return e.s.setCursorBefore(t), !0;
              }
              return !1;
            };
          },
          92156: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkJoinTwoLists = void 0;
            var n = o(24263),
              r = o(67309),
              i = o(30861);
            t.checkJoinTwoLists = function (e, t, o) {
              var a = n.Dom.findSibling(t, o),
                s = n.Dom.findSibling(t, !o);
              if (!n.Dom.closest(t, n.Dom.isElement, e.editor) && n.Dom.isTag(a, ["ul", "ol"]) && n.Dom.isTag(s, ["ul", "ol"]) && n.Dom.isTag(a.lastElementChild, "li") && n.Dom.isTag(s.firstElementChild, "li")) {
                var l = e.s,
                  c = l.setCursorBefore,
                  u = l.setCursorAfter,
                  d = a.lastElementChild;
                return (0, r.call)(o ? n.Dom.prepend : n.Dom.append, s.firstElementChild, t), n.Dom.moveContent(s, a, !o, (0, i.getMoveFilter)(e)), n.Dom.safeRemove(s), (0, r.call)(o ? n.Dom.append : n.Dom.prepend, d, t), (0, r.call)(o ? c : u, t), !0;
              }
              return !1;
            };
          },
          95441: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkNotCollapsed = void 0, t.checkNotCollapsed = function (e) {
              return !e.s.isCollapsed() && (e.execCommand("Delete"), !0);
            };
          },
          13116: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkRemoveChar = void 0;
            var n = o(64968),
              r = o(40332),
              i = o(86893),
              a = o(30861);
            t.checkRemoveChar = function e(t, o, s, l) {
              var c,
                u,
                d,
                p,
                f = s ? -1 : 1,
                h = n.Dom.sibling(o, !s),
                m = n.Dom.sibling(o, s),
                v = null,
                g = !1,
                y = function (e) {
                  var o = n.Dom.sibling(e, s);
                  return !o && e.parentNode && e.parentNode !== t.editor && (o = (0, a.findMostNestedNeighbor)(e, !s, t.editor, !0)), o;
                };
              for (m || (m = y(o)); m && (n.Dom.isText(m) || n.Dom.isInlineBlock(m));) {
                for (; n.Dom.isInlineBlock(m);) m = s ? null == m ? void 0 : m.lastChild : null == m ? void 0 : m.firstChild;
                if (!m) break;
                if (null === (c = m.nodeValue) || void 0 === c ? void 0 : c.length) {
                  var _ = (0, r.toArray)(m.nodeValue),
                    b = _.length,
                    w = s ? b - 1 : 0;
                  if (_[w] === i.INVISIBLE_SPACE) for (; _[w] === i.INVISIBLE_SPACE;) w += f;
                  if (p = _[w], _[w + f] === i.INVISIBLE_SPACE) {
                    for (w += f; _[w] === i.INVISIBLE_SPACE;) w += f;
                    w += s ? 1 : -1;
                  }
                  if (_ = s && 0 > w ? [] : _.slice(s ? 0 : w + 1, s ? w : b), !h || !n.Dom.isText(h) || (s ? /^ / : / $/).test(null !== (u = h.nodeValue) && void 0 !== u ? u : "") || !(0, r.trimInv)(h.nodeValue || "").length) for (var S = s ? _.length - 1 : 0; (s ? S >= 0 : _.length > S) && " " === _[S]; S += s ? -1 : 1) _[S] = i.NBSP_SPACE;
                  m.nodeValue = _.join("");
                }
                if ((null === (d = m.nodeValue) || void 0 === d ? void 0 : d.length) || (v = m), !(0, r.isVoid)(p) && p !== i.INVISIBLE_SPACE) {
                  g = !0, (0, r.call)(s ? n.Dom.after : n.Dom.before, m, o), ("sentence" === l || "word" === l && " " !== p && p !== i.NBSP_SPACE) && e(t, o, s, l);
                  break;
                }
                var C = y(m);
                v && (n.Dom.safeRemove(v), v = null), m = C;
              }
              return v && (n.Dom.safeRemove(v), v = null), g && (function (e, t) {
                for (var o = e.parentElement; o && n.Dom.isInlineBlock(o) && n.Dom.isTag(o, t);) {
                  var r = o.parentElement;
                  n.Dom.isEmpty(o) && (n.Dom.after(o, e), n.Dom.safeRemove(o)), o = r;
                }
              }(o, ["a"]), function (e, t) {
                t.parentElement !== e.editor && n.Dom.isBlock(t.parentElement) && n.Dom.each(t.parentElement, n.Dom.isEmptyTextNode) && n.Dom.after(t, e.createInside.element("br"));
              }(t, o), t.s.setCursorBefore(o), n.Dom.isTag(o.previousSibling, "br") && !n.Dom.findNotEmptySibling(o, !1) && n.Dom.after(o, t.createInside.element("br"))), g;
            };
          },
          74217: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkRemoveContentNotEditable = void 0;
            var n = o(64968),
              r = o(40332),
              i = o(10109);
            t.checkRemoveContentNotEditable = function (e, t, o) {
              var a = n.Dom.findSibling(t, o);
              return !a && t.parentElement && t.parentElement !== e.editor && (a = n.Dom.findSibling(t.parentElement, o)), !(!n.Dom.isElement(a) || n.Dom.isContentEditable(a, e.editor) || ((0, r.call)(o ? n.Dom.before : n.Dom.after, a, t), n.Dom.safeRemove(a), (0, i.moveNodeInsideStart)(e, t, o), (0, r.call)(o ? e.s.setCursorBefore : e.s.setCursorAfter, t), 0));
            };
          },
          34181: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkRemoveEmptyNeighbor = void 0;
            var n = o(24263);
            t.checkRemoveEmptyNeighbor = function (e, t, o) {
              var r = n.Dom.closest(t, n.Dom.isElement, e.editor);
              if (!r) return !1;
              var i = n.Dom.findNotEmptySibling(r, o);
              return !(!i || !n.Dom.isEmpty(i) || (n.Dom.safeRemove(i), e.s.setCursorBefore(t), 0));
            };
          },
          13890: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkRemoveEmptyParent = void 0;
            var n = o(64968),
              r = o(86893),
              i = o(92156);
            t.checkRemoveEmptyParent = function (e, t, o) {
              var a = !1,
                s = e.s,
                l = s.setCursorBefore,
                c = s.setCursorIn,
                u = n.Dom.closest(t, n.Dom.isElement, e.editor);
              if (!u || !n.Dom.isEmpty(u)) return !1;
              var d = n.Dom.findNotEmptyNeighbor(t, o, e.editor);
              do {
                if (!u || !n.Dom.isEmpty(u) || n.Dom.isCell(u)) break;
                n.Dom.after(u, t);
                var p = n.Dom.closest(u, function (e) {
                  return n.Dom.isElement(e) && e !== u;
                }, e.editor);
                n.Dom.safeRemove(u), a = !0, u = p;
              } while (u);
              return !(!a || !(0, i.checkJoinTwoLists)(e, t, o)) || (!d || n.Dom.isText(d) || n.Dom.isTag(d, r.INSEPARABLE_TAGS) ? l(t) : c(d, !o), a);
            };
          },
          8249: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkRemoveUnbreakableElement = void 0;
            var n = o(24263),
              r = o(86893),
              i = o(13890);
            t.checkRemoveUnbreakableElement = function (e, t, o) {
              var a = n.Dom.findSibling(t, o);
              return !(!n.Dom.isElement(a) || !n.Dom.isTag(a, r.INSEPARABLE_TAGS) && !n.Dom.isEmpty(a) || (n.Dom.safeRemove(a), n.Dom.isTag(a, "br") && !n.Dom.findNotEmptySibling(t, !1) && n.Dom.after(t, e.createInside.element("br")), e.s.setCursorBefore(t), n.Dom.isTag(a, "br") && (0, i.checkRemoveEmptyParent)(e, t, o), 0));
            };
          },
          58368: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkTableCell = void 0;
            var n = o(24263);
            t.checkTableCell = function (e, t) {
              return !!n.Dom.isCell(t.parentElement);
            };
          },
          6028: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkUnwrapFirstListItem = void 0;
            var n = o(24263),
              r = o(76502);
            t.checkUnwrapFirstListItem = function (e, t, o) {
              var i,
                a = n.Dom.closest(t, n.Dom.isElement, e.editor),
                s = e.s;
              if (n.Dom.isTag(a, "li") && (null === (i = null == a ? void 0 : a.parentElement) || void 0 === i ? void 0 : i[o ? "firstElementChild" : "lastElementChild"]) === a && s.cursorInTheEdge(o, a)) {
                var l = a.parentElement,
                  c = e.createInside.element(e.o.enterBlock);
                return (0, r.call)(o ? n.Dom.before : n.Dom.after, l, c), n.Dom.moveContent(a, c), n.Dom.safeRemove(a), n.Dom.isEmpty(l) && n.Dom.safeRemove(l), (0, r.call)(o ? s.setCursorBefore : s.setCursorAfter, t), !0;
              }
              return !1;
            };
          },
          90089: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.cases = void 0;
            var n = o(8249),
              r = o(74217),
              i = o(13116),
              a = o(58368),
              s = o(13890),
              l = o(34181),
              c = o(92156),
              u = o(31078),
              d = o(6028);
            t.cases = [n.checkRemoveUnbreakableElement, r.checkRemoveContentNotEditable, i.checkRemoveChar, a.checkTableCell, s.checkRemoveEmptyParent, l.checkRemoveEmptyNeighbor, c.checkJoinTwoLists, u.checkJoinNeighbors, d.checkUnwrapFirstListItem];
          },
          48229: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.delete = {
              hotkeys: {
                delete: ["delete", "cmd+backspace"],
                deleteWord: ["ctrl+delete", "cmd+alt+backspace", "ctrl+alt+backspace"],
                deleteSentence: ["ctrl+shift+delete", "cmd+shift+delete"],
                backspace: ["backspace"],
                backspaceWord: ["ctrl+backspace"],
                backspaceSentence: ["ctrl+shift+backspace", "cmd+shift+backspace"]
              }
            };
          },
          30861: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getMoveFilter = t.findMostNestedNeighbor = void 0;
            var n = o(64968);
            t.findMostNestedNeighbor = function (e, t, o, r) {
              void 0 === r && (r = !1);
              var i = function (e) {
                  return t ? e.firstChild : e.lastChild;
                },
                a = n.Dom.findNotEmptyNeighbor(e, !t, o);
              if (r && n.Dom.isElement(a) && !n.Dom.isInlineBlock(a)) return null;
              if (a) do {
                if (!i(a)) return a;
                a = i(a);
              } while (a);
              return null;
            }, t.getMoveFilter = function (e) {
              return function (t) {
                return !0 !== e.e.fire("backSpaceIsMovedIgnore", t);
              };
            };
          },
          87565: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.bold = void 0;
            var n = o(20255),
              r = o(93166),
              i = o(40332),
              a = o(17332),
              s = o(77904);
            function l(e) {
              var t = function (t) {
                var o,
                  a = r.Config.defaultOptions.controls[t],
                  s = n.__assign({}, a.css);
                return Object.keys(s).forEach(function (e) {
                  o || (o = {}), o[e] = (0, i.isArray)(s[e]) ? s[e][0] : s[e];
                }), e.s.applyStyle(o, {
                  element: a.tags ? a.tags[0] : void 0
                }), e.synchronizeValues(), !1;
              };
              ["bold", "italic", "underline", "strikethrough"].forEach(function (t) {
                e.registerButton({
                  name: t,
                  group: "font-style"
                });
              }), ["superscript", "subscript"].forEach(function (t) {
                e.registerButton({
                  name: t,
                  group: "script"
                });
              }), e.registerCommand("bold", {
                exec: t,
                hotkeys: ["ctrl+b", "cmd+b"]
              }).registerCommand("italic", {
                exec: t,
                hotkeys: ["ctrl+i", "cmd+i"]
              }).registerCommand("underline", {
                exec: t,
                hotkeys: ["ctrl+u", "cmd+u"]
              }).registerCommand("strikethrough", {
                exec: t
              }).registerCommand("subscript", {
                exec: t
              }).registerCommand("superscript", {
                exec: t
              });
            }
            o(58334), o(90740), t.bold = l, a.pluginSystem.add("bold", l), s.Icon.set("bold", o(25141)).set("italic", o(24557)).set("strikethrough", o(10859)).set("subscript", o(9813)).set("superscript", o(93395)).set("underline", o(98213));
          },
          90740: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.controls.subscript = {
              tags: ["sub"],
              tooltip: "subscript"
            }, n.Config.prototype.controls.superscript = {
              tags: ["sup"],
              tooltip: "superscript"
            }, n.Config.prototype.controls.bold = {
              tagRegExp: /^(strong|b)$/i,
              tags: ["strong", "b"],
              css: {
                "font-weight": ["bold", "700"]
              },
              tooltip: "Bold"
            }, n.Config.prototype.controls.italic = {
              tagRegExp: /^(em|i)$/i,
              tags: ["em", "i"],
              css: {
                "font-style": "italic"
              },
              tooltip: "Italic"
            }, n.Config.prototype.controls.underline = {
              tagRegExp: /^(u)$/i,
              tags: ["u"],
              css: {
                "text-decoration-line": "underline"
              },
              tooltip: "Underline"
            }, n.Config.prototype.controls.strikethrough = {
              tagRegExp: /^(s)$/i,
              tags: ["s"],
              css: {
                "text-decoration-line": "line-through"
              },
              tooltip: "Strike through"
            };
          },
          58334: function () {},
          60894: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.classSpan = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(93166),
              a = o(64968),
              s = o(40332),
              l = o(17332),
              c = o(2074);
            i.Config.prototype.controls.classSpan = {
              command: "applyClassName",
              exec: s.memorizeExec,
              list: ["enabled", "disabled", "activated", "text-left", "text-center", "text-right", "warning", "error"],
              isChildActive: function (e, t) {
                var o = e.s.current();
                if (o) {
                  var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor;
                  return Boolean(t.args && n.classList.contains(t.args[0].toString()));
                }
                return !1;
              },
              isActive: function (e, t) {
                var o = e.s.current();
                if (o) {
                  var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor,
                    r = !1;
                  return t.list && Object.keys(t.list).forEach(function (e) {
                    n.classList.contains(e) && (r = !0);
                  }), Boolean(n && n !== e.editor && void 0 !== t.list && r);
                }
                return !1;
              },
              childTemplate: function (e, t, o) {
                return '<span class="'.concat(t, '">').concat(e.i18n(o), "</span>");
              },
              tooltip: "Insert className"
            };
            var u = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "classSpan",
                  group: "font"
                }], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                e.registerCommand("applyClassName", function (t, o, n) {
                  return e.s.applyStyle(void 0, {
                    className: n
                  }), !1;
                });
              }, t.prototype.beforeDestruct = function () {}, t;
            }(r.Plugin);
            t.classSpan = u, l.pluginSystem.add("classSpan", u), c.Icon.set("class-span", o(20026));
          },
          90302: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.cleanHtml = void 0;
            var n = o(20255),
              r = o(67128),
              i = o(85605),
              a = o(43441),
              s = o(33841),
              l = o(17332),
              c = o(24263),
              u = o(57713);
            o(98889);
            var d = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "eraser",
                  group: "font-style"
                }], t.currentSelectionNode = null, t.walker = new s.LazyWalker(t.j.async, {
                  timeout: t.j.o.cleanHTML.timeout
                }), t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {}, Object.defineProperty(t.prototype, "isEditMode", {
                get: function () {
                  return !(this.j.isInDestruct || !this.j.isEditorMode() || this.j.getReadOnly());
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.onChangeCleanHTML = function () {
                if (this.isEditMode) {
                  var e = this.j;
                  this.walker.setWork(e.editor), this.currentSelectionNode = e.s.current();
                }
              }, t.prototype.startWalker = function () {
                var e = this,
                  t = this.jodit,
                  o = (0, u.getHash)(this.j.o.cleanHTML.allowTags),
                  n = (0, u.getHash)(this.j.o.cleanHTML.denyTags);
                this.walker.on("visit", function (r) {
                  return (0, u.visitNodeWalker)(t, r, o, n, e.currentSelectionNode);
                }).on("end", function (t) {
                  e.j.e.fire(t ? "internalChange finishedCleanHTMLWorker" : "finishedCleanHTMLWorker");
                });
              }, t.prototype.beforeCommand = function (e) {
                if ("removeformat" === e.toLowerCase()) return this.j.s.isCollapsed() ? (0, u.removeFormatForCollapsedSelection)(this.j) : (0, u.removeFormatForSelection)(this.j), !1;
              }, t.prototype.onBeforeSetNativeEditorValue = function (e) {
                var t = this.j.o.cleanHTML.useIframeSandbox ? this.j.createInside.sandbox() : this.j.createInside.div();
                return t.innerHTML = e.value, this.onSafeHTML(t), e.value = t.innerHTML, (0, r.safeHTML)(t, {
                  safeJavaScriptLink: !0,
                  removeOnError: !0
                }), c.Dom.safeRemove(t), !1;
              }, t.prototype.onSafeHTML = function (e) {
                (0, r.safeHTML)(e, this.j.o.cleanHTML);
              }, t.prototype.beforeDestruct = function () {
                this.walker.destruct();
              }, n.__decorate([(0, a.watch)([":change", ":afterSetMode", ":afterInit", ":mousedown", ":keydown"])], t.prototype, "onChangeCleanHTML", null), n.__decorate([(0, a.hook)("ready")], t.prototype, "startWalker", null), n.__decorate([(0, a.watch)(":beforeCommand")], t.prototype, "beforeCommand", null), n.__decorate([(0, a.watch)(":beforeSetNativeEditorValue")], t.prototype, "onBeforeSetNativeEditorValue", null), n.__decorate([(0, a.watch)(":safeHTML")], t.prototype, "onSafeHTML", null), t;
            }(i.Plugin);
            t.cleanHtml = d, l.pluginSystem.add("cleanHtml", d);
          },
          98889: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.cleanHTML = {
              timeout: 300,
              removeEmptyElements: !0,
              fillEmptyParagraph: !0,
              replaceNBSP: !0,
              replaceOldTags: {
                i: "em",
                b: "strong"
              },
              allowTags: !1,
              denyTags: "script",
              useIframeSandbox: !1,
              removeOnError: !0,
              safeJavaScriptLink: !0,
              disableCleanFilter: null
            }, n.Config.prototype.controls.eraser = {
              command: "removeFormat",
              tooltip: "Clear Formatting"
            }, r.Icon.set("eraser", o(66911));
          },
          38655: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getHash = void 0;
            var n = o(33941),
              r = o(24421);
            t.getHash = function (e) {
              var t = /([^[]*)\[([^\]]+)]/,
                o = /[\s]*,[\s]*/,
                i = /^(.*)[\s]*=[\s]*(.*)$/,
                a = {};
              return (0, r.isString)(e) ? (e.split(o).map(function (e) {
                e = (0, n.trim)(e);
                var r = t.exec(e),
                  s = {};
                if (r) {
                  var l = r[2].split(o);
                  r[1] && (l.forEach(function (e) {
                    e = (0, n.trim)(e);
                    var t = i.exec(e);
                    t ? s[t[1]] = t[2] : s[e] = !0;
                  }), a[r[1].toUpperCase()] = s);
                } else a[e.toUpperCase()] = !0;
              }), a) : !!e && (Object.keys(e).forEach(function (t) {
                a[t.toUpperCase()] = e[t];
              }), a);
            };
          },
          57713: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(38655), t), n.__exportStar(o(72170), t), n.__exportStar(o(87783), t), n.__exportStar(o(88972), t);
          },
          72170: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isInlineBlock = t.removeFormatForCollapsedSelection = void 0;
            var n = o(24263),
              r = o(86893);
            function i(e) {
              return n.Dom.isInlineBlock(e) && !n.Dom.isTag(e, r.INSEPARABLE_TAGS);
            }
            t.removeFormatForCollapsedSelection = function (e, t) {
              var o = e.s,
                r = t;
              if (!r) {
                r = e.createInside.fake();
                var a = o.range;
                n.Dom.safeInsertNode(a, r), a.collapse();
              }
              var s = n.Dom.furthest(r, i, e.editor);
              if (s) if (o.cursorOnTheLeft(s)) n.Dom.before(s, r);else if (o.cursorOnTheRight(s)) n.Dom.after(s, r);else {
                var l = o.splitSelection(s);
                l && n.Dom.after(l, r);
              }
              t || (o.setCursorBefore(r), n.Dom.safeRemove(r));
            }, t.isInlineBlock = i;
          },
          87783: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.removeFormatForSelection = void 0;
            var n = o(24263),
              r = o(76502),
              i = o(72170);
            t.removeFormatForSelection = function (e) {
              var t = e.s,
                o = e.editor,
                a = e.createInside,
                s = t.range,
                l = s.cloneRange(),
                c = s.cloneRange(),
                u = a.fake(),
                d = a.fake();
              l.collapse(!0), c.collapse(!1), n.Dom.safeInsertNode(l, u), n.Dom.safeInsertNode(c, d), s.setStartBefore(u), s.collapse(!0), t.selectRange(s), (0, i.removeFormatForCollapsedSelection)(e, u), s.setEndAfter(d), s.collapse(!1), t.selectRange(s), (0, i.removeFormatForCollapsedSelection)(e, d);
              var p = [];
              n.Dom.between(u, d, function (e) {
                (0, i.isInlineBlock)(e) && !n.Dom.isTag(e, ["a"]) && p.push(e), n.Dom.isElement(e) && (0, r.attr)(e, "style") && (0, r.attr)(e, "style", null);
              }), p.forEach(function (e) {
                return n.Dom.unwrap(e);
              });
              var f = function (e, t) {
                if (!n.Dom.findNotEmptySibling(e, t)) {
                  var i = e.parentNode;
                  if (i && i !== o && (0, r.attr)(i, "style")) return (0, r.attr)(i, "style", null), f(i, t), !0;
                }
              };
              f(u, !0) && f(d, !1), s.setStartAfter(u), s.setEndBefore(d), t.selectRange(s), n.Dom.safeRemove(u), n.Dom.safeRemove(d);
            };
          },
          9948: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.allowAttributes = void 0;
            var n = o(24263);
            t.allowAttributes = function (e, t, o, r) {
              if (r && n.Dom.isElement(t) && !0 !== r[t.nodeName]) {
                var i = t.attributes;
                if (i && i.length) {
                  for (var a = [], s = 0; i.length > s; s += 1) {
                    var l = r[t.nodeName][i[s].name];
                    (!l || !0 !== l && l !== i[s].value) && a.push(i[s].name);
                  }
                  a.length && (o = !0), a.forEach(function (e) {
                    t.removeAttribute(e);
                  });
                }
              }
              return o;
            };
          },
          74722: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.fillEmptyParagraph = void 0;
            var n = o(24263),
              r = o(86893);
            t.fillEmptyParagraph = function (e, t, o) {
              if (e.o.cleanHTML.fillEmptyParagraph && n.Dom.isBlock(t) && n.Dom.isEmpty(t, r.INSEPARABLE_TAGS)) {
                var i = e.createInside.element("br");
                return t.appendChild(i), !0;
              }
              return o;
            };
          },
          2549: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(55901), t), n.__exportStar(o(9948), t), n.__exportStar(o(74722), t), n.__exportStar(o(75096), t), n.__exportStar(o(28194), t), n.__exportStar(o(94254), t), n.__exportStar(o(64701), t);
          },
          28194: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.removeEmptyTextNode = void 0;
            var n = o(24263);
            t.removeEmptyTextNode = function (e, t, o, r, i, a) {
              return n.Dom.isText(t) && !t.nodeValue ? (t === a && e.s.isCollapsed() && e.s.setCursorAfter(t), n.Dom.safeRemove(t), !0) : o;
            };
          },
          94254: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.removeInvTextNodes = void 0;
            var n = o(86893),
              r = o(24263);
            t.removeInvTextNodes = function (e, t, o, i, a, s) {
              return s !== t && r.Dom.isText(t) && null != t.nodeValue && (0, n.INVISIBLE_SPACE_REG_EXP)().test(t.nodeValue) ? (t.nodeValue = t.nodeValue.replace((0, n.INVISIBLE_SPACE_REG_EXP)(), ""), t === s && e.s.isCollapsed() && e.s.setCursorAfter(t), t.nodeValue || r.Dom.safeRemove(t), !0) : o;
            };
          },
          55901: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.replaceOldTags = void 0;
            var n = o(24263);
            t.replaceOldTags = function (e, t, o) {
              var r = function (e, t, o) {
                if (!o || !n.Dom.isHTMLElement(t)) return t;
                var r = o[t.nodeName.toLowerCase()] || o[t.nodeName];
                return r ? n.Dom.replace(t, r, e.createInside, !0, !1) : t;
              }(e, t, e.o.cleanHTML.replaceOldTags);
              return t !== r ? (t = r, !0) : o;
            };
          },
          64701: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.sanitizeAttributes = void 0;
            var n = o(24263),
              r = o(40332);
            t.sanitizeAttributes = function (e, t, o) {
              return !(!n.Dom.isElement(t) || !(0, r.sanitizeHTMLElement)(t, {
                safeJavaScriptLink: e.options.cleanHTML.safeJavaScriptLink,
                removeOnError: e.options.cleanHTML.removeOnError
              })) || o;
            };
          },
          75096: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.tryRemoveNode = void 0;
            var n = o(24263),
              r = o(86893),
              i = o(33941);
            t.tryRemoveNode = function (e, t, o, a, s, l) {
              return function (e, t, o, a, s) {
                return !(n.Dom.isText(t) || !(a && !a[t.nodeName] || s && s[t.nodeName])) || e.o.cleanHTML.removeEmptyElements && n.Dom.isElement(t) && null != t.nodeName.match(r.IS_INLINE) && !n.Dom.isTemporary(t) && 0 === (0, i.trim)(t.innerHTML).length && (null == o || !n.Dom.isOrContains(t, o));
              }(e, t, l, a, s) ? (n.Dom.safeRemove(t), !0) : o;
            };
          },
          88972: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.visitNodeWalker = void 0;
            var n = o(20255),
              r = o(2549),
              i = Object.keys(r);
            t.visitNodeWalker = function (e, t, o, a, s) {
              var l,
                c,
                u = !1,
                d = e.o.cleanHTML.disableCleanFilter;
              try {
                for (var p = n.__values(i), f = p.next(); !f.done; f = p.next()) {
                  var h = f.value;
                  if (!(d && d.has(h) || (u = (0, r[h])(e, t, u, o, a, s), t.isConnected))) return !0;
                }
              } catch (e) {
                l = {
                  error: e
                };
              } finally {
                try {
                  f && !f.done && (c = p.return) && c.call(p);
                } finally {
                  if (l) throw l.error;
                }
              }
              return u;
            };
          },
          92138: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.clipboard = void 0;
            var n = o(86893),
              r = o(40332),
              i = o(17332);
            o(31473);
            var a = function () {
              function e() {
                this.buttons = [{
                  name: "cut",
                  group: "clipboard"
                }, {
                  name: "copy",
                  group: "clipboard"
                }, {
                  name: "paste",
                  group: "clipboard"
                }, {
                  name: "selectall",
                  group: "clipboard"
                }];
              }
              return e.prototype.init = function (e) {
                var t;
                null === (t = this.buttons) || void 0 === t || t.forEach(function (t) {
                  return e.registerButton(t);
                }), e.e.off("copy.".concat(n.CLIPBOARD_ID, " cut.").concat(n.CLIPBOARD_ID)).on("copy.".concat(n.CLIPBOARD_ID, " cut.").concat(n.CLIPBOARD_ID), function (t) {
                  var o,
                    i = e.s.html,
                    a = (0, r.getDataTransfer)(t) || (0, r.getDataTransfer)(e.ew) || (0, r.getDataTransfer)(t.originalEvent);
                  a && (a.setData(n.TEXT_PLAIN, (0, r.stripTags)(i)), a.setData(n.TEXT_HTML, i)), e.buffer.set(n.CLIPBOARD_ID, i), e.e.fire("pasteStack", {
                    html: i,
                    action: e.o.defaultActionOnPaste || n.INSERT_AS_HTML
                  }), "cut" === t.type && (e.s.remove(), e.s.focus()), t.preventDefault(), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.fire("afterCopy", i);
                });
              }, e.prototype.destruct = function (e) {
                var t, o;
                null === (t = null == e ? void 0 : e.buffer) || void 0 === t || t.set(n.CLIPBOARD_ID, ""), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.off("." + n.CLIPBOARD_ID);
              }, e;
            }();
            t.clipboard = a, i.pluginSystem.add("clipboard", a);
          },
          31473: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.controls.cut = {
              command: "cut",
              isDisabled: function (e) {
                return e.s.isCollapsed();
              },
              tooltip: "Cut selection"
            }, n.Config.prototype.controls.copy = {
              command: "copy",
              isDisabled: function (e) {
                return e.s.isCollapsed();
              },
              tooltip: "Copy selection"
            }, n.Config.prototype.controls.selectall = {
              icon: "select-all",
              command: "selectall",
              tooltip: "Select all"
            }, r.Icon.set("copy", o(50018)).set("cut", o(99738)).set("paste", o(9185)).set("select-all", o(8619));
          },
          88412: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.color = void 0;
            var n = o(40332),
              r = o(17332);
            function i(e) {
              e.registerButton({
                name: "brush",
                group: "color"
              });
              var t = function (t, o, r) {
                var i = (0, n.normalizeColor)(r);
                switch (t) {
                  case "background":
                    e.s.applyStyle({
                      backgroundColor: i || ""
                    });
                    break;
                  case "forecolor":
                    e.s.applyStyle({
                      color: i || ""
                    });
                }
                return e.synchronizeValues(), !1;
              };
              e.registerCommand("forecolor", t).registerCommand("background", t);
            }
            o(21924), t.color = i, r.pluginSystem.add("color", i);
          },
          21924: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(40332),
              i = o(718),
              a = o(77904),
              s = o(24263);
            a.Icon.set("brush", o(73894)), n.Config.prototype.controls.brush = {
              update: function (e, t) {
                var o = (0, r.dataBind)(e, "color"),
                  n = function (o, n) {
                    n && n !== (0, r.css)(t.editor, o).toString() && (e.state.icon.fill = n);
                  };
                if (o) {
                  var i = (0, r.dataBind)(e, "color");
                  n("color" === i ? i : "background-color", o);
                } else {
                  var a = t.s.current();
                  if (a && !e.state.disabled) {
                    var l = s.Dom.closest(a, s.Dom.isElement, t.editor) || t.editor;
                    n("color", (0, r.css)(l, "color").toString()), n("background-color", (0, r.css)(l, "background-color").toString());
                  }
                  e.state.icon.fill = "", e.state.activated = !1;
                }
              },
              popup: function (e, t, o, n, a) {
                var l = "",
                  c = "",
                  u = [],
                  d = null;
                return t && t !== e.editor && s.Dom.isNode(t) && (s.Dom.isElement(t) && e.s.isCollapsed() && !s.Dom.isTag(t, ["br", "hr"]) && (d = t), s.Dom.up(t, function (e) {
                  if (s.Dom.isHTMLElement(e)) {
                    var t = (0, r.css)(e, "color", !0),
                      o = (0, r.css)(e, "background-color", !0);
                    if (t) return l = t.toString(), !0;
                    if (o) return c = o.toString(), !0;
                  }
                }, e.editor)), u = [{
                  name: "Background",
                  content: (0, i.ColorPickerWidget)(e, function (t) {
                    d ? d.style.backgroundColor = t : e.execCommand("background", !1, t), (0, r.dataBind)(a, "color", t), (0, r.dataBind)(a, "color-mode", "background"), n();
                  }, c)
                }, {
                  name: "Text",
                  content: (0, i.ColorPickerWidget)(e, function (t) {
                    d ? d.style.color = t : e.execCommand("forecolor", !1, t), (0, r.dataBind)(a, "color", t), (0, r.dataBind)(a, "color-mode", "color"), n();
                  }, l)
                }], "background" !== e.o.colorPickerDefaultTab && (u = u.reverse()), (0, i.TabsWidget)(e, u, d);
              },
              exec: function (e, t, o) {
                var n = o.button,
                  i = (0, r.dataBind)(n, "color-mode"),
                  a = (0, r.dataBind)(n, "color");
                if (!i) return !1;
                if (t && t !== e.editor && s.Dom.isNode(t) && s.Dom.isElement(t)) switch (i) {
                  case "color":
                    t.style.color = a;
                    break;
                  case "background":
                    t.style.backgroundColor = a;
                } else e.execCommand("background" === i ? i : "forecolor", !1, a);
              },
              tooltip: "Fill color or set the text color"
            };
          },
          79308: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.copyFormat = void 0;
            var n = o(93166),
              r = o(24263),
              i = o(26911),
              a = o(17332),
              s = o(77904),
              l = "copy-format",
              c = ["fontWeight", "fontStyle", "fontSize", "color", "margin", "padding", "borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "textDecorationLine", "fontFamily"],
              u = function (e, t, o, n) {
                var r = (0, i.css)(o, t);
                return r === n[t] && (r = o.parentNode && o !== e.editor && o.parentNode !== e.editor ? u(e, t, o.parentNode, n) : void 0), r;
              };
            function d(e) {
              e.registerButton({
                name: "copyformat",
                group: "clipboard"
              }), (0, a.extendLang)(o(9188));
            }
            n.Config.prototype.controls.copyformat = {
              exec: function (e, t, o) {
                var n = o.button;
                if (t) {
                  if (e.buffer.exists(l)) e.buffer.delete(l), e.e.off(e.editor, "mouseup." + l);else {
                    var a = {},
                      s = r.Dom.up(t, function (e) {
                        return e && !r.Dom.isText(e);
                      }, e.editor) || e.editor,
                      d = e.createInside.span();
                    e.editor.appendChild(d), c.forEach(function (e) {
                      a[e] = (0, i.css)(d, e);
                    }), d !== e.editor && r.Dom.safeRemove(d);
                    var p = function (e, t, o) {
                      var n = {};
                      return t && c.forEach(function (r) {
                        n[r] = u(e, r, t, o), r.match(/border(Style|Color)/) && !n.borderWidth && (n[r] = void 0);
                      }), n;
                    }(e, s, a);
                    e.e.on(e.editor, "mouseup." + l, function () {
                      e.buffer.delete(l);
                      var t = e.s.current();
                      t && (r.Dom.isTag(t, "img") ? (0, i.css)(t, p) : e.s.applyStyle(p)), e.e.off(e.editor, "mouseup." + l);
                    }), e.buffer.set(l, !0);
                  }
                  n.update();
                }
              },
              isActive: function (e) {
                return e.buffer.exists(l);
              },
              tooltip: "Paint format"
            }, t.copyFormat = d, a.pluginSystem.add("copyformat", d), s.Icon.set("copyformat", o(83301));
          },
          9188: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
            var n = o(80078);
            t.ar = n;
            var r = o(16986);
            t.cs_cz = r;
            var i = o(59347);
            t.de = i;
            var a = o(63640);
            t.es = a;
            var s = o(53434);
            t.fa = s;
            var l = o(85638);
            t.fr = l;
            var c = o(31743);
            t.he = c;
            var u = o(66219);
            t.hu = u;
            var d = o(50331);
            t.id = d;
            var p = o(25582);
            t.it = p;
            var f = o(82066);
            t.ja = f;
            var h = o(71925);
            t.ko = h;
            var m = o(12689);
            t.mn = m;
            var v = o(65274);
            t.nl = v;
            var g = o(58548);
            t.pl = g;
            var y = o(82958);
            t.pt_br = y;
            var _ = o(52315);
            t.ru = _;
            var b = o(87727);
            t.tr = b;
            var w = o(9396);
            t.zh_cn = w;
            var S = o(28765);
            t.zh_tw = S;
          },
          9412: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.draggableTags = ["img", "jodit-media", "jodit"];
          },
          30598: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.dragAndDropElement = void 0;
            var n,
              r = o(20255),
              i = o(40332),
              a = o(57549),
              s = o(64968),
              l = o(17332),
              c = o(43441);
            o(9412), function (e) {
              e[e.IDLE = 0] = "IDLE", e[e.WAIT_DRAGGING = 1] = "WAIT_DRAGGING", e[e.DRAGGING = 2] = "DRAGGING";
            }(n || (n = {}));
            var u = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.dragList = [], t.draggable = null, t.isCopyMode = !1, t.diffStep = 10, t.startX = 0, t.startY = 0, t.state = n.IDLE, t;
              }
              return r.__extends(t, e), t.prototype.afterInit = function () {
                this.dragList = this.j.o.draggableTags ? (0, i.splitArray)(this.j.o.draggableTags).filter(Boolean).map(function (e) {
                  return e.toLowerCase();
                }) : [], this.dragList.length && this.j.e.on("mousedown dragstart", this.onDragStart);
              }, t.prototype.onDragStart = function (e) {
                var t = this;
                if ("dragstart" === e.type && this.draggable) return !1;
                if (n.IDLE >= this.state) {
                  var o = e.target;
                  if (this.dragList.length && o) {
                    var r = function (e) {
                        return Boolean(e && t.dragList.includes(e.nodeName.toLowerCase()));
                      },
                      a = s.Dom.furthest(o, r, this.j.editor) || (r(o) ? o : null);
                    a && (s.Dom.isTag(a.parentElement, "a") && a.parentElement.firstChild === a && a.parentElement.lastChild === a && (a = a.parentElement), this.startX = e.clientX, this.startY = e.clientY, this.isCopyMode = (0, i.ctrlKey)(e), this.draggable = a.cloneNode(!0), (0, i.dataBind)(this.draggable, "target", a), this.state = n.WAIT_DRAGGING, this.addDragListeners());
                  }
                }
              }, t.prototype.onDrag = function (e) {
                var o, r;
                if (this.draggable && this.state !== n.IDLE) {
                  var a = e.clientY;
                  if (this.state !== n.WAIT_DRAGGING || Math.sqrt(Math.pow(e.clientX - this.startX, 2) + Math.pow(a - this.startY, 2)) >= this.diffStep) {
                    if (this.state === n.WAIT_DRAGGING && (this.j.lock("drag-and-drop-element"), this.state = n.DRAGGING), this.j.e.fire("hidePopup hideResizer"), !this.draggable.parentNode) {
                      var s = (0, i.dataBind)(this.draggable, "target");
                      (0, i.css)(this.draggable, {
                        zIndex: 1e13,
                        pointerEvents: "none",
                        pointer: "drag",
                        position: "fixed",
                        opacity: .7,
                        display: "inline-block",
                        left: e.clientX,
                        top: e.clientY,
                        width: null !== (o = null == s ? void 0 : s.offsetWidth) && void 0 !== o ? o : 100,
                        height: null !== (r = null == s ? void 0 : s.offsetHeight) && void 0 !== r ? r : 100
                      }), (0, l.getContainer)(this.j, t).appendChild(this.draggable);
                    }
                    (0, i.css)(this.draggable, {
                      left: e.clientX,
                      top: e.clientY
                    }), this.j.s.insertCursorAtPoint(e.clientX, e.clientY);
                  }
                }
              }, t.prototype.onDragEnd = function () {
                this.isInDestruct || (this.removeDragListeners(), this.j.unlock(), this.state = n.IDLE, this.draggable && (s.Dom.safeRemove(this.draggable), this.draggable = null));
              }, t.prototype.onDrop = function () {
                if (this.draggable && this.state >= n.DRAGGING) {
                  var e = (0, i.dataBind)(this.draggable, "target");
                  this.onDragEnd(), this.isCopyMode && (e = e.cloneNode(!0));
                  var t = e.parentElement;
                  this.j.s.insertNode(e, !0, !1), t && s.Dom.isEmpty(t) && !s.Dom.isTag(t, ["td", "th"]) && s.Dom.safeRemove(t), s.Dom.isTag(e, "img") && this.j.e && this.j.e.fire("afterInsertImage", e), this.j.e.fire("synchro");
                } else this.onDragEnd();
              }, t.prototype.addDragListeners = function () {
                this.j.e.on(this.j.editor, "mousemove", this.onDrag).on("mouseup", this.onDrop).on([this.j.ew, this.ow], "mouseup", this.onDragEnd);
              }, t.prototype.removeDragListeners = function () {
                this.j.e.off(this.j.editor, "mousemove", this.onDrag).off("mouseup", this.onDrop).off([this.j.ew, this.ow], "mouseup", this.onDragEnd);
              }, t.prototype.beforeDestruct = function () {
                this.onDragEnd(), this.j.e.off("mousedown dragstart", this.onDragStart), this.removeDragListeners();
              }, r.__decorate([c.autobind], t.prototype, "onDragStart", null), r.__decorate([(0, c.throttle)(function (e) {
                return e.defaultTimeout / 10;
              })], t.prototype, "onDrag", null), r.__decorate([c.autobind], t.prototype, "onDragEnd", null), r.__decorate([c.autobind], t.prototype, "onDrop", null), t;
            }(a.Plugin);
            t.dragAndDropElement = u, l.pluginSystem.add("dragAndDropElement", u);
          },
          19268: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.dragAndDrop = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(24263),
              a = o(40332),
              s = o(57549),
              l = o(43441),
              c = o(63463),
              u = o(17332),
              d = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.isFragmentFromEditor = !1, t.isCopyMode = !1, t.startDragPoint = {
                    x: 0,
                    y: 0
                  }, t.draggable = null, t.bufferRange = null, t.getText = function (e) {
                    var t = (0, a.getDataTransfer)(e);
                    return t ? t.getData(r.TEXT_HTML) || t.getData(r.TEXT_PLAIN) : null;
                  }, t;
                }
                return n.__extends(t, e), t.prototype.afterInit = function () {
                  this.j.e.on([window, this.j.ed, this.j.editor], "dragstart.DragAndDrop", this.onDragStart);
                }, t.prototype.onDragStart = function (e) {
                  var t = e.target;
                  if (this.onDragEnd(), this.isFragmentFromEditor = i.Dom.isOrContains(this.j.editor, t, !0), this.isCopyMode = !this.isFragmentFromEditor || (0, a.ctrlKey)(e), this.isFragmentFromEditor) {
                    var o = this.j.s.sel,
                      n = o && o.rangeCount ? o.getRangeAt(0) : null;
                    n && (this.bufferRange = n.cloneRange());
                  } else this.bufferRange = null;
                  this.startDragPoint.x = e.clientX, this.startDragPoint.y = e.clientY, (0, c.isFileBrowserFilesItem)(t) && (t = t.querySelector("img")), i.Dom.isTag(t, "img") && (this.draggable = t.cloneNode(!0), (0, a.dataBind)(this.draggable, "target", t)), this.addDragListeners();
                }, t.prototype.addDragListeners = function () {
                  this.j.e.on("dragover", this.onDrag).on("drop.DragAndDrop", this.onDrop).on(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                }, t.prototype.removeDragListeners = function () {
                  this.j.e.off("dragover", this.onDrag).off("drop.DragAndDrop", this.onDrop).off(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                }, t.prototype.onDrag = function (e) {
                  this.draggable && (this.j.e.fire("hidePopup"), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), e.preventDefault(), e.stopPropagation());
                }, t.prototype.onDragEnd = function () {
                  this.draggable && (i.Dom.safeRemove(this.draggable), this.draggable = null), this.isCopyMode = !1, this.removeDragListeners();
                }, t.prototype.onDrop = function (e) {
                  if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) {
                    if (!this.isFragmentFromEditor && !this.draggable) return this.j.e.fire("paste", e), e.preventDefault(), e.stopPropagation(), !1;
                    var t = this.j.s.sel,
                      o = this.bufferRange || (t && t.rangeCount ? t.getRangeAt(0) : null),
                      r = null;
                    if (!this.draggable && o) r = this.isCopyMode ? o.cloneContents() : o.extractContents();else if (this.draggable) {
                      if (this.isCopyMode) {
                        var s = n.__read("1" === (0, a.attr)(this.draggable, "-is-file") ? ["a", "href"] : ["img", "src"], 2),
                          l = s[0],
                          c = s[1];
                        (r = this.j.createInside.element(l)).setAttribute(c, (0, a.attr)(this.draggable, "data-src") || (0, a.attr)(this.draggable, "src") || ""), "a" === l && (r.textContent = (0, a.attr)(r, c) || "");
                      } else r = (0, a.dataBind)(this.draggable, "target");
                    } else this.getText(e) && (r = this.j.createInside.fromHTML(this.getText(e)));
                    t && t.removeAllRanges(), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), r && (this.j.s.insertNode(r, !1, !1), o && r.firstChild && r.lastChild && (o.setStartBefore(r.firstChild), o.setEndAfter(r.lastChild), this.j.s.selectRange(o), this.j.e.fire("synchro")), i.Dom.isTag(r, "img") && this.j.events && this.j.e.fire("afterInsertImage", r)), e.preventDefault(), e.stopPropagation();
                  }
                  this.isFragmentFromEditor = !1, this.removeDragListeners();
                }, t.prototype.beforeDestruct = function () {
                  this.onDragEnd(), this.j.e.off(window, ".DragAndDrop").off(".DragAndDrop").off([window, this.j.ed, this.j.editor], "dragstart.DragAndDrop", this.onDragStart);
                }, n.__decorate([l.autobind], t.prototype, "onDragStart", null), n.__decorate([(0, l.throttle)(function (e) {
                  return e.defaultTimeout / 10;
                })], t.prototype, "onDrag", null), n.__decorate([l.autobind], t.prototype, "onDragEnd", null), n.__decorate([l.autobind], t.prototype, "onDrop", null), t;
              }(s.Plugin);
            t.dragAndDrop = d, u.pluginSystem.add("dragAndDrop", d);
          },
          95049: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(69516), t);
          },
          69516: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.removeExtraBr = void 0;
            var n = o(24263);
            t.removeExtraBr = function (e, t) {
              if (e.o.dtd.removeExtraBr && !n.Dom.isTag(t, "br")) {
                var o = n.Dom.furthest(t, n.Dom.isBlock, e.editor);
                if (o && !n.Dom.isTag(o, ["table", "pre", "blockquote", "code"])) {
                  var r = n.Dom.isTag(t, "br") ? t : n.Dom.findNotEmptySibling(t, !1);
                  if (!n.Dom.isTag(r, "br")) return;
                  e.s.setCursorBefore(r), n.Dom.safeRemove(r);
                }
              }
            };
          },
          73967: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkBlockNesting = void 0;
            var n = o(24263);
            t.checkBlockNesting = function (e, t) {
              if (n.Dom.isFragment(t) && (t = t.firstChild), e.o.dtd.checkBlockNesting && n.Dom.isBlock(t)) {
                var o = n.Dom.furthest(e.s.current(), n.Dom.isBlock, e.editor);
                o && !e.o.dtd.blockLimits[o.tagName.toLowerCase()] && (e.s.setCursorAfter(o), n.Dom.isEmpty(o) && n.Dom.safeRemove(o));
              }
            };
          },
          73690: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(73967), t);
          },
          20173: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.dtd = {
              removeExtraBr: !0,
              checkBlockNesting: !0,
              blockLimits: {
                article: 1,
                aside: 1,
                audio: 1,
                body: 1,
                caption: 1,
                details: 1,
                dir: 1,
                div: 1,
                dl: 1,
                fieldset: 1,
                figcaption: 1,
                figure: 1,
                footer: 1,
                form: 1,
                header: 1,
                hgroup: 1,
                main: 1,
                menu: 1,
                nav: 1,
                ol: 1,
                section: 1,
                table: 1,
                td: 1,
                th: 1,
                tr: 1,
                ul: 1,
                video: 1
              }
            };
          },
          96899: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(57549),
              i = o(17332),
              a = o(46163);
            o(20173);
            var s = o(73690),
              l = o(95049),
              c = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.afterInit = function (e) {}, t.prototype.beforeDestruct = function (e) {}, t.prototype.__onBeforeInsertNode = function (e) {
                  var t = this;
                  Object.keys(s).forEach(function (o) {
                    s[o](t.j, e);
                  });
                }, t.prototype.__onAfterInsertNode = function (e) {
                  var t = this;
                  Object.keys(l).forEach(function (o) {
                    l[o](t.j, e);
                  });
                }, n.__decorate([(0, a.watch)(":beforeInsertNode")], t.prototype, "__onBeforeInsertNode", null), n.__decorate([(0, a.watch)(":afterInsertNode")], t.prototype, "__onAfterInsertNode", null), t;
              }(r.Plugin);
            i.pluginSystem.add("dtd", c);
          },
          33122: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.enter = void 0;
            var n = o(20255),
              r = o(24263),
              i = o(85605),
              a = o(86893),
              s = o(43441),
              l = o(67749),
              c = o(23217),
              u = o(17332);
            o(26231);
            var d = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this,
                  o = e.o.enter.toLowerCase(),
                  n = o === a.BR.toLowerCase();
                e.o.enterBlock || (e.o.enterBlock = n ? a.PARAGRAPH : o), e.registerCommand("enter", function (e, o, n) {
                  return void 0 === n && (n = {}), t.onEnter(n);
                });
              }, t.prototype.onEnterKeyDown = function (e) {
                if (e.key === a.KEY_ENTER) {
                  var t = this.j,
                    o = t.e.fire("beforeEnter", e);
                  return void 0 !== o ? o : (t.s.isCollapsed() || t.execCommand("Delete"), t.s.focus(), this.onEnter(e), t.e.fire("afterEnter", e), t.synchronizeValues(), !1);
                }
              }, t.prototype.onEnter = function (e) {
                var t = this.jodit,
                  o = t.createInside.fake();
                try {
                  r.Dom.safeInsertNode(t.s.range, o), (0, c.moveCursorOutFromSpecialTags)(t, o, ["a"]);
                  var n = (0, c.getBlockWrapper)(o, t),
                    i = r.Dom.isTag(n, "li");
                  if ((!i || (null == e ? void 0 : e.shiftKey)) && (0, c.checkBR)(o, t, null == e ? void 0 : e.shiftKey)) return !1;
                  if (n || (0, c.hasPreviousBlock)(o, t) || (n = (0, c.wrapText)(o, t)), !n) return (0, c.insertParagraph)(o, t, i ? "li" : t.o.enter), !1;
                  if (!(0, c.checkUnsplittableBox)(o, t, n)) return !1;
                  if (i && this.__isEmptyListLeaf(n)) return (0, c.processEmptyLILeaf)(o, t, n), !1;
                  (0, c.splitFragment)(o, t, n);
                } finally {
                  o.isConnected && t.s.setCursorBefore(o), r.Dom.safeRemove(o);
                }
              }, t.prototype.__isEmptyListLeaf = function (e) {
                var t = this.j.e.fire("enterIsEmptyListLeaf", e);
                return (0, l.isBoolean)(t) ? t : r.Dom.isEmpty(e);
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off("keydown.enter");
              }, n.__decorate([(0, s.watch)(":keydown.enter")], t.prototype, "onEnterKeyDown", null), t;
            }(i.Plugin);
            t.enter = d, u.pluginSystem.add("enter", d);
          },
          94149: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkBR = void 0;
            var n = o(24263),
              r = o(9005),
              i = o(86893);
            function a(e) {
              if (!e) return !1;
              var t = n.Dom.findSibling(e, !0);
              return !(!t || !n.Dom.isTag(t, "br")) && t;
            }
            t.checkBR = function (e, t, o) {
              var s = Boolean(n.Dom.closest(e, ["pre", "blockquote"], t.editor));
              if (t.o.enter.toLowerCase() === i.BR.toLowerCase() || o && !s || !o && s) {
                if (s && function (e) {
                  var t = a(a(e));
                  return !!t && (n.Dom.safeRemove(a(e)), n.Dom.safeRemove(t), !0);
                }(e)) return !1;
                var l = t.createInside.element("br");
                if (n.Dom.before(e, l), !n.Dom.findNotEmptySibling(l, !1)) {
                  var c = l.cloneNode();
                  n.Dom.after(l, c), n.Dom.before(c, e);
                }
                return (0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed), !0;
              }
              return !1;
            };
          },
          58921: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.checkUnsplittableBox = void 0;
            var n = o(24263);
            t.checkUnsplittableBox = function (e, t, o) {
              return !!n.Dom.canSplitBlock(o) || (n.Dom.before(e, t.createInside.element("br")), !1);
            };
          },
          70638: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getBlockWrapper = void 0;
            var n = o(86893),
              r = o(24263);
            t.getBlockWrapper = function e(t, o, i) {
              void 0 === i && (i = n.IS_BLOCK);
              var a = t,
                s = o.editor;
              do {
                if (!a || a === s) break;
                if (i.test(a.nodeName)) return r.Dom.isTag(a, "li") ? a : e(a.parentNode, o, /^li$/i) || a;
                a = a.parentNode;
              } while (a && a !== s);
              return null;
            };
          },
          50781: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hasPreviousBlock = void 0;
            var n = o(24263);
            t.hasPreviousBlock = function (e, t) {
              return Boolean(n.Dom.prev(e, function (e) {
                return n.Dom.isBlock(e) || n.Dom.isImage(e);
              }, t.editor));
            };
          },
          23217: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(94149), t), n.__exportStar(o(58921), t), n.__exportStar(o(92291), t), n.__exportStar(o(70638), t), n.__exportStar(o(50781), t), n.__exportStar(o(90443), t), n.__exportStar(o(52521), t), n.__exportStar(o(81512), t), n.__exportStar(o(29575), t);
          },
          90443: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.insertParagraph = void 0;
            var n = o(24263),
              r = o(9005);
            t.insertParagraph = function (e, t, o, i) {
              var a = "br" === o.toLowerCase(),
                s = t.createInside,
                l = s.element(o),
                c = s.element("br");
              return a || l.appendChild(c), i && i.cssText && l.setAttribute("style", i.cssText), n.Dom.after(e, l), n.Dom.before(a ? l : c, e), (0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed), l;
            };
          },
          29575: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.moveCursorOutFromSpecialTags = void 0;
            var n = o(24263);
            t.moveCursorOutFromSpecialTags = function (e, t, o) {
              var r = e.s,
                i = n.Dom.closest(t, o, e.editor);
              i && (r.cursorOnTheRight(i, t) ? n.Dom.after(i, t) : r.cursorOnTheLeft(i, t) && n.Dom.before(i, t));
            };
          },
          92291: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.processEmptyLILeaf = void 0;
            var n = o(24263),
              r = o(54188),
              i = o(90443);
            t.processEmptyLILeaf = function (e, t, o) {
              var a = n.Dom.closest(o, ["ol", "ul"], t.editor);
              if (a) {
                var s = a.parentElement,
                  l = n.Dom.isTag(s, "li"),
                  c = l ? s : a,
                  u = t.s.createRange();
                u.setStartAfter(o), u.setEndAfter(a);
                var d = u.extractContents();
                n.Dom.after(c, e), n.Dom.safeRemove(o), (0, r.$$)("li", a).length || n.Dom.safeRemove(a);
                var p = (0, i.insertParagraph)(e, t, l ? "li" : t.o.enter);
                d.querySelector("li") && (l ? p.appendChild(d) : n.Dom.after(p, d));
              }
            };
          },
          52521: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.splitFragment = void 0;
            var n = o(9005),
              r = o(24263),
              i = o(90443);
            t.splitFragment = function (e, t, o) {
              var a = t.s,
                s = t.o.enter.toLowerCase(),
                l = r.Dom.isTag(o, "li"),
                c = o.tagName.toLowerCase() === s || l,
                u = a.cursorOnTheRight(o, e),
                d = a.cursorOnTheLeft(o, e);
              if (!c && (u || d)) return u ? r.Dom.after(o, e) : r.Dom.before(o, e), (0, i.insertParagraph)(e, t, s), void (d && !u && r.Dom.prepend(o, e));
              var p = a.splitSelection(o, e);
              (0, n.scrollIntoViewIfNeeded)(p, t.editor, t.ed);
            };
          },
          81512: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.wrapText = void 0;
            var n = o(24263);
            t.wrapText = function (e, t) {
              var o = e;
              n.Dom.up(o, function (e) {
                e && e.hasChildNodes() && e !== t.editor && (o = e);
              }, t.editor);
              var r = n.Dom.wrapInline(o, t.o.enter, t);
              if (n.Dom.isEmpty(r)) {
                var i = t.createInside.element("br");
                r.appendChild(i), n.Dom.before(i, e);
              }
              return r;
            };
          },
          26231: function () {},
          10135: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.file = void 0;
            var n = o(93166),
              r = o(24263),
              i = o(718),
              a = o(17332);
            function s(e) {
              e.registerButton({
                name: "file",
                group: "media"
              });
            }
            n.Config.prototype.controls.file = {
              popup: function (e, t, o, n) {
                var a = function (t, o) {
                    void 0 === o && (o = ""), e.s.insertNode(e.createInside.fromHTML('<a href="'.concat(t, '" title="').concat(o, '">').concat(o || t, "</a>")));
                  },
                  s = null;
                return t && (r.Dom.isTag(t, "a") || r.Dom.closest(t, "a", e.editor)) && (s = r.Dom.isTag(t, "a") ? t : r.Dom.closest(t, "a", e.editor)), (0, i.FileSelectorWidget)(e, {
                  filebrowser: function (e) {
                    e.files && e.files.forEach(function (t) {
                      return a(e.baseurl + t);
                    }), n();
                  },
                  upload: !0,
                  url: function (e, t) {
                    s ? (s.setAttribute("href", e), s.setAttribute("title", t)) : a(e, t), n();
                  }
                }, s, n, !1);
              },
              tags: ["a"],
              tooltip: "Insert file"
            }, t.file = s, a.pluginSystem.add("file", s);
          },
          66994: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.focus = void 0;
            var n = o(93166),
              r = o(64968),
              i = o(17332);
            function a(e) {
              e.o.saveSelectionOnBlur && e.e.on("blur", function () {
                e.isEditorMode() && e.s.save(!0);
              }).on("focus", function () {
                e.s.restore();
              });
              var t = function () {
                if (e.s.focus(), "end" === e.o.cursorAfterAutofocus) {
                  var t = r.Dom.last(e.editor, function (e) {
                    return r.Dom.isText(e);
                  });
                  t && e.s.setCursorIn(t, !1);
                }
              };
              e.e.on("afterInit", function () {
                e.o.autofocus && (e.defaultTimeout ? e.async.setTimeout(t, 300) : t());
              }), e.e.on("afterInit afterAddPlace", function () {
                e.e.off(e.editor, "mousedown.autofocus").on(e.editor, "mousedown.autofocus", function (t) {
                  e.isEditorMode() && t.target && r.Dom.isBlock(t.target) && !t.target.childNodes.length && (e.editor === t.target ? e.s.focus() : e.s.setCursorIn(t.target));
                });
              });
            }
            n.Config.prototype.autofocus = !1, n.Config.prototype.cursorAfterAutofocus = "end", n.Config.prototype.saveSelectionOnBlur = !0, t.focus = a, i.pluginSystem.add("focus", a);
          },
          8082: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(93166),
              i = o(24263),
              a = o(76502),
              s = o(77904);
            r.Config.prototype.defaultFontSizePoints = "px", s.Icon.set("font", o(84142)).set("fontsize", o(57292)), r.Config.prototype.controls.fontsize = {
              command: "fontsize",
              data: {
                cssRule: "font-size"
              },
              list: ["8", "9", "10", "11", "12", "14", "16", "18", "24", "30", "36", "48", "60", "72", "96"],
              exec: function (e, t, o) {
                var n = o.control;
                return (0, a.memorizeExec)(e, t, {
                  control: n
                }, function (t) {
                  var o;
                  return "fontsize" === (null === (o = n.command) || void 0 === o ? void 0 : o.toLowerCase()) ? "".concat(t).concat(e.o.defaultFontSizePoints) : t;
                });
              },
              childTemplate: function (e, t, o) {
                return "".concat(o).concat(e.o.defaultFontSizePoints);
              },
              tooltip: "Font size",
              isChildActive: function (e, t) {
                var o,
                  n,
                  r = e.s.current(),
                  s = (null === (o = t.data) || void 0 === o ? void 0 : o.cssRule) || "font-size",
                  l = (null === (n = t.data) || void 0 === n ? void 0 : n.normalize) || function (t) {
                    return /pt$/i.test(t) && "pt" === e.o.defaultFontSizePoints ? t.replace(/pt$/i, "") : t;
                  };
                if (r) {
                  var c = i.Dom.closest(r, i.Dom.isElement, e.editor) || e.editor,
                    u = (0, a.css)(c, s);
                  return Boolean(u && t.args && l(t.args[0].toString()) === l(u.toString()));
                }
                return !1;
              }
            }, r.Config.prototype.controls.font = n.__assign(n.__assign({}, r.Config.prototype.controls.fontsize), {
              command: "fontname",
              list: {
                "": "Default",
                "helvetica,sans-serif": "Helvetica",
                "arial,helvetica,sans-serif": "Arial",
                "georgia,palatino,serif": "Georgia",
                "impact,charcoal,sans-serif": "Impact",
                "tahoma,geneva,sans-serif": "Tahoma",
                "times new roman,times,serif": "Times New Roman",
                "verdana,geneva,sans-serif": "Verdana"
              },
              childTemplate: function (e, t, o) {
                var n = !1;
                try {
                  n = -1 === t.indexOf("dings") && document.fonts.check("16px ".concat(t), o);
                } catch (e) {}
                return '<span data-style="'.concat(t, '" style="').concat(n ? "font-family: ".concat(t, "!important;") : "", '">').concat(o, "</span>");
              },
              data: {
                cssRule: "font-family",
                normalize: function (e) {
                  return e.toLowerCase().replace(/['"]+/g, "").replace(/[^a-z0-9]+/g, ",");
                }
              },
              tooltip: "Font family"
            });
          },
          54798: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.font = void 0;
            var n = o(40332),
              r = o(17332);
            function i(e) {
              e.registerButton({
                name: "font",
                group: "font"
              }).registerButton({
                name: "fontsize",
                group: "font"
              });
              var t = function (t, o, r) {
                switch (t) {
                  case "fontsize":
                    e.s.applyStyle({
                      fontSize: (0, n.normalizeSize)(r)
                    });
                    break;
                  case "fontname":
                    e.s.applyStyle({
                      fontFamily: r
                    });
                }
                return e.synchronizeValues(), !1;
              };
              e.registerCommand("fontsize", t).registerCommand("fontname", t);
            }
            o(8082), t.font = i, r.pluginSystem.add("font", i);
          },
          12908: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.formatBlock = void 0;
            var n = o(93166),
              r = o(87837),
              i = o(40332),
              a = o(17332);
            function s(e) {
              e.registerButton({
                name: "paragraph",
                group: "font"
              }), e.registerCommand("formatblock", function (t, o, n) {
                return e.s.applyStyle(void 0, {
                  element: n
                }), e.synchronizeValues(), !1;
              });
            }
            o(77904).Icon.set("paragraph", o(18019)), n.Config.prototype.controls.paragraph = {
              command: "formatBlock",
              update: function (e, t) {
                var o = e.control,
                  n = t.s.current();
                if (n && t.o.textIcons) {
                  var i = (r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor).nodeName.toLowerCase(),
                    a = o.list;
                  e && o.data && o.data.currentValue !== i && a && a[i] && (t.o.textIcons ? e.state.text = i : e.state.icon.name = i, o.data.currentValue = i);
                }
                return !1;
              },
              exec: i.memorizeExec,
              data: {
                currentValue: "left"
              },
              list: {
                p: "Normal",
                h1: "Heading 1",
                h2: "Heading 2",
                h3: "Heading 3",
                h4: "Heading 4",
                blockquote: "Quote",
                pre: "Code"
              },
              isChildActive: function (e, t) {
                var o = e.s.current();
                if (o) {
                  var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
                  return Boolean(n && n !== e.editor && void 0 !== t.args && n.nodeName.toLowerCase() === t.args[0]);
                }
                return !1;
              },
              isActive: function (e, t) {
                var o = e.s.current();
                if (o) {
                  var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
                  return Boolean(n && n !== e.editor && void 0 !== t.list && !r.Dom.isTag(n, "p") && void 0 !== t.list[n.nodeName.toLowerCase()]);
                }
                return !1;
              },
              childTemplate: function (e, t, o) {
                return "<".concat(t, ' style="margin:0;padding:0"><span>').concat(e.i18n(o), "</span></").concat(t, ">");
              },
              tooltip: "Insert format block"
            }, t.formatBlock = s, a.pluginSystem.add("formatBlock", s);
          },
          15045: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(14320);
            var n = o(93166),
              r = o(86893),
              i = o(77904);
            n.Config.prototype.fullsize = !1, n.Config.prototype.globalFullSize = !0, i.Icon.set("fullsize", o(45146)).set("shrink", o(53576)), n.Config.prototype.controls.fullsize = {
              exec: function (e) {
                e.toggleFullSize();
              },
              update: function (e, t) {
                var o = t.isFullSize ? "shrink" : "fullsize";
                e.state.activated = t.isFullSize, t.o.textIcons ? e.state.text = o : e.state.icon.name = o;
              },
              tooltip: "Open in fullsize",
              mode: r.MODE_SOURCE + r.MODE_WYSIWYG
            };
          },
          65123: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.fullsize = void 0, o(14320);
            var n = o(26911),
              r = o(77892),
              i = o(17332);
            o(15045);
            var a = new Set();
            function s(e) {
              e.registerButton({
                name: "fullsize"
              });
              var t = !1,
                o = 0,
                i = 0,
                s = !1,
                l = function () {
                  var r = e.container;
                  e.events && (t ? (o = (0, n.css)(r, "height", !0), i = (0, n.css)(r, "width", !0), (0, n.css)(r, {
                    height: e.ow.innerHeight,
                    width: e.ow.innerWidth
                  }), s = !0) : s && (0, n.css)(r, {
                    height: o || "auto",
                    width: i || "auto"
                  }));
                },
                c = function (o) {
                  var i = e.container,
                    s = e.events;
                  if (i) {
                    if (void 0 === o && (o = !i.classList.contains("jodit_fullsize")), e.setMod("fullsize", o), e.o.fullsize = o, t = o, i.classList.toggle("jodit_fullsize", o), e.toolbar && ((0, r.isJoditObject)(e) && e.toolbarContainer.appendChild(e.toolbar.container), (0, n.css)(e.toolbar.container, "width", "auto")), o ? a.add(i) : a.delete(i), e.o.globalFullSize && (1 === a.size && o || 0 === a.size && !o)) {
                      for (var c = i.parentNode; c && c.nodeType !== Node.DOCUMENT_NODE && c.nodeType !== Node.DOCUMENT_FRAGMENT_NODE;) c.classList.toggle("jodit_fullsize-box_true", o), c = c.parentNode;
                      l();
                    }
                    s.fire("afterResize");
                  }
                };
              e.o.globalFullSize && e.e.on(e.ow, "resize", l), e.e.on("afterInit afterOpen", function () {
                var t;
                e.toggleFullSize(null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.fullsize);
              }).on("toggleFullSize", c).on("beforeDestruct", function () {
                t && c(!1);
              }).on("beforeDestruct", function () {
                e.events && e.e.off(e.ow, "resize", l);
              });
            }
            t.fullsize = s, i.pluginSystem.add("fullsize", s);
          },
          16829: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.commandToHotkeys = {
              removeFormat: ["ctrl+shift+m", "cmd+shift+m"],
              insertOrderedList: ["ctrl+shift+7", "cmd+shift+7"],
              insertUnorderedList: ["ctrl+shift+8, cmd+shift+8"],
              selectall: ["ctrl+a", "cmd+a"]
            };
          },
          83228: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hotkeys = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(40332),
              a = o(86893),
              s = o(17332);
            o(16829);
            var l = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.onKeyPress = function (e) {
                  var o = t.specialKeys[e.which],
                    n = (e.key || String.fromCharCode(e.which)).toLowerCase(),
                    r = [o || n];
                  return ["alt", "ctrl", "shift", "meta"].forEach(function (t) {
                    e[t + "Key"] && o !== t && r.push(t);
                  }), (0, i.normalizeKeyAliases)(r.join("+"));
                }, t.specialKeys = {
                  8: "backspace",
                  9: "tab",
                  10: "return",
                  13: "return",
                  16: "shift",
                  17: "ctrl",
                  18: "alt",
                  19: "pause",
                  20: "capslock",
                  27: "esc",
                  32: "space",
                  33: "pageup",
                  34: "pagedown",
                  35: "end",
                  36: "home",
                  37: "left",
                  38: "up",
                  39: "right",
                  40: "down",
                  45: "insert",
                  46: "del",
                  59: ";",
                  61: "=",
                  91: "meta",
                  96: "0",
                  97: "1",
                  98: "2",
                  99: "3",
                  100: "4",
                  101: "5",
                  102: "6",
                  103: "7",
                  104: "8",
                  105: "9",
                  106: "*",
                  107: "+",
                  109: "-",
                  110: ".",
                  111: "/",
                  112: "f1",
                  113: "f2",
                  114: "f3",
                  115: "f4",
                  116: "f5",
                  117: "f6",
                  118: "f7",
                  119: "f8",
                  120: "f9",
                  121: "f10",
                  122: "f11",
                  123: "f12",
                  144: "numlock",
                  145: "scroll",
                  173: "-",
                  186: ";",
                  187: "=",
                  188: ",",
                  189: "-",
                  190: ".",
                  191: "/",
                  192: "`",
                  219: "[",
                  220: "\\",
                  221: "]",
                  222: "'"
                }, t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                (0, i.keys)(e.o.commandToHotkeys, !1).forEach(function (t) {
                  var o = e.o.commandToHotkeys[t];
                  o && ((0, i.isArray)(o) || (0, i.isString)(o)) && e.registerHotkeyToCommand(o, t);
                });
                var o = !1;
                e.e.off(".hotkeys").on([e.ow, e.ew], "keydown.hotkeys", function (e) {
                  if (e.key === a.KEY_ESC) return t.j.e.fire("escape", e);
                }).on("keydown.hotkeys", function (n) {
                  var r = t.onKeyPress(n),
                    i = {
                      shouldStop: !0
                    };
                  if (!1 === t.j.e.fire(r + ".hotkey", n.type, i)) {
                    if (i.shouldStop) return o = !0, e.e.stopPropagation("keydown"), !1;
                    n.preventDefault();
                  }
                }, {
                  top: !0
                }).on("keyup.hotkeys", function () {
                  if (o) return o = !1, e.e.stopPropagation("keyup"), !1;
                }, {
                  top: !0
                });
              }, t.prototype.beforeDestruct = function (e) {
                e.events && e.e.off(".hotkeys");
              }, t;
            }(r.Plugin);
            t.hotkeys = l, s.pluginSystem.add("hotkeys", l);
          },
          43889: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.hr = void 0;
            var n = o(93166),
              r = o(64968),
              i = o(17332);
            function a(e) {
              e.registerButton({
                name: "hr",
                group: "insert"
              }), e.registerCommand("insertHorizontalRule", function () {
                var t = e.createInside.element("hr");
                e.s.insertNode(t, !1, !1);
                var o = r.Dom.closest(t.parentElement, r.Dom.isBlock, e.editor);
                o && r.Dom.isEmpty(o) && o !== e.editor && (r.Dom.after(o, t), r.Dom.safeRemove(o));
                var n = r.Dom.next(t, r.Dom.isBlock, e.editor, !1);
                return n || (n = e.createInside.element(e.o.enter), r.Dom.after(t, n)), e.s.setCursorIn(n), !1;
              });
            }
            o(77904).Icon.set("hr", o(14655)), n.Config.prototype.controls.hr = {
              command: "insertHorizontalRule",
              tags: ["hr"],
              tooltip: "Insert Horizontal Line"
            }, t.hr = a, i.pluginSystem.add("hr", a);
          },
          2509: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.iframeBaseUrl = "", n.Config.prototype.iframeTitle = "Jodit Editor", n.Config.prototype.iframeDoctype = "<!DOCTYPE html>", n.Config.prototype.iframeDefaultSrc = "about:blank", n.Config.prototype.iframeStyle = 'html{margin:0;padding:0;min-height: 100%;}body{box-sizing:border-box;font-size:13px;line-height:1.6;padding:10px;margin:0;background:transparent;color:#000;position:relative;z-index:2;user-select:auto;margin:0px;overflow:auto;outline:none;}table{width:100%;border:none;border-collapse:collapse;empty-cells: show;max-width: 100%;}th,td{padding: 2px 5px;border:1px solid #ccc;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}p{margin-top:0;}.jodit_editor .jodit_iframe_wrapper{display: block;clear: both;user-select: none;position: relative;}.jodit_editor .jodit_iframe_wrapper:after {position:absolute;content:"";z-index:1;top:0;left:0;right: 0;bottom: 0;cursor: pointer;display: block;background: rgba(0, 0, 0, 0);} .jodit_disabled{user-select: none;-o-user-select: none;-moz-user-select: none;-khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none}', n.Config.prototype.iframeCSSLinks = [];
          },
          93300: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.iframe = void 0;
            var n = o(40332),
              r = o(40332),
              i = o(86893),
              a = o(17332);
            function s(e) {
              var t = e.options;
              e.e.on("afterSetMode", function () {
                e.isEditorMode() && e.s.focus();
              }).on("generateDocumentStructure.iframe", function (e, o) {
                var r = e || o.iframe.contentWindow.document;
                if (r.open(), r.write(t.iframeDoctype + '<html dir="'.concat(t.direction, '" class="jodit" lang="').concat((0, n.defaultLanguage)(t.language), '">') + "<head>" + "<title>".concat(t.iframeTitle, "</title>") + (t.iframeBaseUrl ? '<base href="'.concat(t.iframeBaseUrl, '"/>') : "") + '</head><body class="jodit-wysiwyg"></body></html>'), r.close(), t.iframeCSSLinks && t.iframeCSSLinks.forEach(function (e) {
                  var t = r.createElement("link");
                  t.setAttribute("rel", "stylesheet"), t.setAttribute("href", e), r.head && r.head.appendChild(t);
                }), t.iframeStyle) {
                  var i = r.createElement("style");
                  i.innerHTML = t.iframeStyle, r.head && r.head.appendChild(i);
                }
              }).on("createEditor", function () {
                if (t.iframe) {
                  var o = e.c.element("iframe");
                  o.style.display = "block", o.src = "about:blank", o.className = "jodit-wysiwyg_iframe", o.setAttribute("allowtransparency", "true"), o.setAttribute("tabindex", t.tabIndex.toString()), o.setAttribute("frameborder", "0"), e.workplace.appendChild(o), e.iframe = o;
                  var a = e.e.fire("generateDocumentStructure.iframe", null, e);
                  return (0, n.callPromise)(a, function () {
                    if (!e.iframe) return !1;
                    var o = e.iframe.contentWindow.document;
                    e.editorWindow = e.iframe.contentWindow;
                    var a = function () {
                        (0, n.attr)(o.body, "contenteditable", e.getMode() !== i.MODE_SOURCE && !e.getReadOnly() || null);
                      },
                      s = function (e) {
                        var t = /<body.*<\/body>/im,
                          o = "{%%BODY%%}",
                          n = t.exec(e);
                        return n && (e = e.replace(t, o).replace(/<span([^>]*?)>(.*?)<\/span>/gim, "").replace(/&lt;span([^&]*?)&gt;(.*?)&lt;\/span&gt;/gim, "").replace(o, n[0].replace(/(<body[^>]+?)min-height["'\s]*:[\s"']*[0-9]+(px|%)/im, "$1").replace(/(<body[^>]+?)([\s]*["'])?contenteditable["'\s]*=[\s"']*true["']?/im, "$1").replace(/<(style|script|span)[^>]+jodit[^>]+>.*?<\/\1>/g, "")).replace(/(class\s*=\s*)(['"])([^"']*)(jodit-wysiwyg|jodit)([^"']*\2)/g, "$1$2$3$5").replace(/(<[^<]+?)\sclass="[\s]*"/gim, "$1").replace(/(<[^<]+?)\sstyle="[\s;]*"/gim, "$1").replace(/(<[^<]+?)\sdir="[\s]*"/gim, "$1")), e;
                      };
                    if (t.editHTMLDocumentMode) {
                      var l = e.element.tagName;
                      if ("TEXTAREA" !== l && "INPUT" !== l) throw (0, r.error)("If enable `editHTMLDocumentMode` - source element should be INPUT or TEXTAREA");
                      e.e.on("beforeGetNativeEditorValue", function () {
                        return s(e.o.iframeDoctype + o.documentElement.outerHTML);
                      }).on("beforeSetNativeEditorValue", function (t) {
                        var n = t.value;
                        return !e.isLocked && (/<(html|body)/i.test(n) ? s(o.documentElement.outerHTML) !== s(n) && (o.open(), o.write(e.o.iframeDoctype + s(n)), o.close(), e.editor = o.body, e.e.fire("safeHTML", e.editor), a(), e.e.fire("prepareWYSIWYGEditor"), e.e.stopPropagation("beforeSetNativeEditorValue")) : o.body.innerHTML = n, !0);
                      }, {
                        top: !0
                      });
                    }
                    if (e.editor = o.body, e.e.on("afterSetMode afterInit afterAddPlace", a), "auto" === t.height) {
                      o.documentElement && (o.documentElement.style.overflowY = "hidden");
                      var c = e.async.throttle(function () {
                        if (e.editor && e.iframe && "auto" === t.height) {
                          var o = e.ew.getComputedStyle(e.editor),
                            r = parseInt(o.marginTop || "0", 10) + parseInt(o.marginBottom || "0", 10);
                          (0, n.css)(e.iframe, "height", e.editor.offsetHeight + r);
                        }
                      }, e.defaultTimeout / 2);
                      if (e.e.on("change afterInit afterSetMode resize", c).on([e.iframe, e.ew, o.documentElement], "load", c).on(o, "readystatechange DOMContentLoaded", c), "function" == typeof ResizeObserver) {
                        var u = new ResizeObserver(c);
                        u.observe(o.body), e.e.on("beforeDestruct", function () {
                          u.unobserve(o.body);
                        });
                      }
                    }
                    return o.documentElement && e.e.on(o.documentElement, "mousedown touchend", function () {
                      e.s.isFocused() || (e.s.focus(), e.editor === o.body && e.s.setCursorIn(o.body));
                    }).on(e.ew, "mousedown touchstart keydown keyup touchend click mouseup mousemove scroll", function (t) {
                      var o;
                      null === (o = e.events) || void 0 === o || o.fire(e.ow, t);
                    }), !1;
                  });
                }
              });
            }
            o(2509), t.iframe = s, a.pluginSystem.add("iframe", s);
          },
          18226: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.imageProcessor = {
              replaceDataURIToBlobIdInView: !0
            };
          },
          92575: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.imageProcessor = void 0;
            var n = o(20255),
              r = o(40332),
              i = o(57549),
              a = o(43441),
              s = o(86893),
              l = o(17332);
            o(18226);
            var c = "__jodit_imageprocessor_binded",
              u = "__jodit_imageprocessor_bindedblob-id",
              d = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.afterInit = function (e) {}, t.prototype.beforeDestruct = function (e) {
                  var t,
                    o,
                    r = e.buffer.get(u);
                  if (r) {
                    var i = Object.keys(r);
                    try {
                      for (var a = n.__values(i), s = a.next(); !s.done; s = a.next()) URL.revokeObjectURL(s.value);
                    } catch (e) {
                      t = {
                        error: e
                      };
                    } finally {
                      try {
                        s && !s.done && (o = a.return) && o.call(a);
                      } finally {
                        if (t) throw t.error;
                      }
                    }
                    e.buffer.delete(u);
                  }
                }, t.prototype.onAfterGetValueFromEditor = function (e, t) {
                  if (t !== s.SOURCE_CONSUMER) return this.onBeforeSetElementValue(e);
                }, t.prototype.onBeforeSetElementValue = function (e) {
                  var t,
                    o,
                    r = this.jodit;
                  if (r.o.imageProcessor.replaceDataURIToBlobIdInView) {
                    var i = r.buffer.get(u);
                    if (i) {
                      var a = Object.keys(i);
                      try {
                        for (var s = n.__values(a), l = s.next(); !l.done; l = s.next()) for (var c = l.value; e.value.includes(c);) e.value = e.value.replace(c, i[c]);
                      } catch (e) {
                        t = {
                          error: e
                        };
                      } finally {
                        try {
                          l && !l.done && (o = s.return) && o.call(s);
                        } finally {
                          if (t) throw t.error;
                        }
                      }
                    }
                  }
                }, t.prototype.afterChange = function (e) {
                  return n.__awaiter(this, void 0, Promise, function () {
                    var e;
                    return n.__generator(this, function (t) {
                      return (e = this.jodit).editor ? ((0, r.$$)("img", e.editor).forEach(function (t) {
                        (0, r.dataBind)(t, c) || ((0, r.dataBind)(t, c, !0), t.complete || e.e.on(t, "load", function o() {
                          var n;
                          !e.isInDestruct && (null === (n = e.e) || void 0 === n || n.fire("resize")), e.e.off(t, "load", o);
                        }), t.src && /^data:/.test(t.src) && function (e, t) {
                          if (e.o.imageProcessor.replaceDataURIToBlobIdInView && "undefined" != typeof ArrayBuffer && "undefined" != typeof URL) {
                            var o = t.src,
                              n = function (e) {
                                for (var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; t.length > i; i++) r[i] = t.charCodeAt(i);
                                return new Blob([n], {
                                  type: o
                                });
                              }(o);
                            t.src = URL.createObjectURL(n), e.e.fire("internalUpdate");
                            var r = e.buffer.get(u) || {};
                            r[t.src] = o, e.buffer.set(u, r);
                          }
                        }(e, t), e.e.on(t, "mousedown touchstart", function () {
                          e.s.select(t);
                        }));
                      }), [2]) : [2];
                    });
                  });
                }, n.__decorate([(0, a.watch)(":afterGetValueFromEditor")], t.prototype, "onAfterGetValueFromEditor", null), n.__decorate([(0, a.watch)(":beforeSetElementValue")], t.prototype, "onBeforeSetElementValue", null), n.__decorate([(0, a.watch)([":change", ":afterInit", ":changePlace"]), (0, a.debounce)()], t.prototype, "afterChange", null), t;
              }(i.Plugin);
            t.imageProcessor = d, l.pluginSystem.add("imageProcessor", d);
          },
          1601: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.image = {
              dialogWidth: 600,
              openOnDblClick: !0,
              editSrc: !0,
              useImageEditor: !0,
              editTitle: !0,
              editAlt: !0,
              editLink: !0,
              editSize: !0,
              editBorderRadius: !0,
              editMargins: !0,
              editClass: !0,
              availableClasses: [],
              editStyle: !0,
              editId: !0,
              editAlign: !0,
              showPreview: !0,
              selectImageAfterClose: !0
            };
          },
          15747: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.imageProperties = void 0;
            var n = o(20255);
            o(9947);
            var r = o(87837),
              i = o(40332),
              a = o(718),
              s = o(96516),
              l = o(43441),
              c = o(35503),
              u = o(17332),
              d = o(49391),
              p = o(27506),
              f = o(50109);
            o(1601);
            var h = function (e) {
                return e = (0, i.trim)(e), /^[0-9]+$/.test(e) ? e + "px" : e;
              },
              m = function (e) {
                return /^[-+]?[0-9.]+px$/.test(e.toString()) ? parseFloat(e.toString()) : e;
              },
              v = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.state = {
                    image: new Image(),
                    get ratio() {
                      return this.image.naturalWidth / this.image.naturalHeight || 1;
                    },
                    sizeIsLocked: !0,
                    marginIsLocked: !0
                  }, t.activeTabState = {
                    __activeTab: "Image"
                  }, t;
                }
                return n.__extends(t, e), t.prototype.onChangeMarginIsLocked = function () {
                  var e = this;
                  if (this.form) {
                    var t = (0, i.refs)(this.form),
                      o = t.lockMargin;
                    [t.marginRight, t.marginBottom, t.marginLeft].forEach(function (t) {
                      (0, i.attr)(t, "disabled", e.state.marginIsLocked || null);
                    }), o.innerHTML = r.Icon.get(this.state.marginIsLocked ? "lock" : "unlock");
                  }
                }, t.prototype.onChangeSizeIsLocked = function () {
                  if (this.form) {
                    var e = (0, i.refs)(this.form),
                      t = e.lockSize,
                      o = e.imageWidth;
                    t.innerHTML = r.Icon.get(this.state.sizeIsLocked ? "lock" : "unlock"), t.classList.remove("jodit-properties__lock"), t.classList.remove("jodit-properties__unlock"), t.classList.add(this.state.sizeIsLocked ? "jodit-properties__lock" : "jodit-properties__unlock"), this.j.e.fire(o, "change");
                  }
                }, t.prototype.open = function () {
                  return this.makeForm(), this.activeTabState.__activeTab = "Image", this.j.e.fire("hidePopup"), (0, i.markOwner)(this.j, this.dialog.container), this.state.marginIsLocked = !0, this.state.sizeIsLocked = !0, this.onChangeMarginIsLocked(), this.onChangeSizeIsLocked(), this.updateValues(), this.dialog.open().setModal(!0).setPosition(), !1;
                }, t.prototype.makeForm = function () {
                  var e = this;
                  if (!this.dialog) {
                    this.dialog = this.j.dlg({
                      minWidth: Math.min(400, screen.width),
                      minHeight: 590,
                      buttons: ["fullsize", "dialog.close"]
                    });
                    var t = this.j,
                      o = t.o,
                      n = t.i18n.bind(t),
                      r = {
                        check: (0, s.Button)(t, "ok", "Apply", "primary"),
                        remove: (0, s.Button)(t, "bin", "Delete")
                      };
                    t.e.on(this.dialog, "afterClose", function () {
                      e.state.image.parentNode && o.image.selectImageAfterClose && t.s.select(e.state.image);
                    }), r.remove.onAction(function () {
                      t.s.removeNode(e.state.image), e.dialog.close();
                    });
                    var l = this.dialog;
                    l.setHeader(n("Image properties"));
                    var c = (0, d.form)(t);
                    this.form = c, l.setContent(c);
                    var u = (0, i.refs)(this.form).tabsBox;
                    u && u.appendChild((0, a.TabsWidget)(t, [{
                      name: "Image",
                      content: (0, p.mainTab)(t)
                    }, {
                      name: "Advanced",
                      content: (0, f.positionTab)(t)
                    }], this.activeTabState)), r.check.onAction(this.onApply);
                    var h = (0, i.refs)(this.form),
                      m = h.editImage;
                    t.e.on(h.changeImage, "click", this.openImagePopup), o.image.useImageEditor && t.e.on(m, "click", this.openImageEditor);
                    var v = (0, i.refs)(c),
                      g = v.lockSize,
                      y = v.lockMargin,
                      _ = v.imageWidth,
                      b = v.imageHeight;
                    g && t.e.on(g, "click", function () {
                      e.state.sizeIsLocked = !e.state.sizeIsLocked;
                    }), t.e.on(y, "click", function (t) {
                      e.state.marginIsLocked = !e.state.marginIsLocked, t.preventDefault();
                    });
                    var w = function (t) {
                      if ((0, i.isNumeric)(_.value) && (0, i.isNumeric)(b.value)) {
                        var o = parseFloat(_.value),
                          n = parseFloat(b.value);
                        t.target === _ ? b.value = Math.round(o / e.state.ratio).toString() : _.value = Math.round(n * e.state.ratio).toString();
                      }
                    };
                    t.e.on([_, b], "change keydown mousedown paste", function (o) {
                      e.state.sizeIsLocked && t.async.setTimeout(w.bind(e, o), {
                        timeout: t.defaultTimeout,
                        label: "image-properties-changeSize"
                      });
                    }), l.setFooter([r.remove, r.check]), l.setSize(this.j.o.image.dialogWidth);
                  }
                }, t.prototype.updateValues = function () {
                  var e,
                    t,
                    o = this,
                    n = this.j.o,
                    a = this.state.image,
                    s = (0, i.refs)(this.form),
                    l = s.marginTop,
                    c = s.marginRight,
                    u = s.marginBottom,
                    d = s.marginLeft,
                    p = s.imageSrc,
                    f = s.id,
                    h = s.classes,
                    v = s.align,
                    g = s.style,
                    y = s.imageTitle,
                    _ = s.imageAlt,
                    b = s.borderRadius,
                    w = s.imageLink,
                    S = s.imageWidth,
                    C = s.imageHeight,
                    j = s.imageLinkOpenInNewTab,
                    E = s.imageViewSrc,
                    x = s.lockSize;
                  s.lockMargin.checked = o.state.marginIsLocked, x.checked = o.state.sizeIsLocked, p.value = (0, i.attr)(a, "src") || "", E && (0, i.attr)(E, "src", (0, i.attr)(a, "src") || ""), function () {
                    y.value = (0, i.attr)(a, "title") || "", _.value = (0, i.attr)(a, "alt") || "";
                    var e = r.Dom.closest(a, "a", o.j.editor);
                    e ? (w.value = (0, i.attr)(e, "href") || "", j.checked = "_blank" === (0, i.attr)(e, "target")) : (w.value = "", j.checked = !1);
                  }(), e = (0, i.attr)(a, "width") || (0, i.css)(a, "width", !0) || !1, t = (0, i.attr)(a, "height") || (0, i.css)(a, "height", !0) || !1, S.value = !1 !== e ? m(e).toString() : a.offsetWidth.toString(), C.value = !1 !== t ? m(t).toString() : a.offsetHeight.toString(), o.state.sizeIsLocked = function () {
                    if (!(0, i.isNumeric)(S.value) || !(0, i.isNumeric)(C.value)) return !1;
                    var e = parseFloat(S.value),
                      t = parseFloat(C.value);
                    return 1 > Math.abs(e - t * o.state.ratio);
                  }(), function () {
                    if (n.image.editMargins) {
                      var e = !0,
                        t = !1;
                      [l, c, u, d].forEach(function (o) {
                        var n = (0, i.attr)(o, "data-ref") || "",
                          r = a.style.getPropertyValue((0, i.kebabCase)(n));
                        if (!r) return t = !0, void (o.value = "");
                        /^[0-9]+(px)?$/.test(r) && (r = parseInt(r, 10)), o.value = r.toString() || "", (t && o.value || e && "marginTop" !== n && o.value !== l.value) && (e = !1);
                      }), o.state.marginIsLocked = e;
                    }
                  }(), h.value = ((0, i.attr)(a, "class") || "").replace(/jodit_focused_image[\s]*/, ""), f.value = (0, i.attr)(a, "id") || "", b.value = (parseInt(a.style.borderRadius || "0", 10) || "0").toString(), a.style.cssFloat && -1 !== ["left", "right"].indexOf(a.style.cssFloat.toLowerCase()) ? v.value = (0, i.css)(a, "float") : "block" === (0, i.css)(a, "display") && "auto" === a.style.marginLeft && "auto" === a.style.marginRight && (v.value = "center"), g.value = (0, i.attr)(a, "style") || "";
                }, t.prototype.onApply = function () {
                  var e = (0, i.refs)(this.form),
                    t = e.imageSrc,
                    o = e.borderRadius,
                    n = e.imageTitle,
                    a = e.imageAlt,
                    s = e.imageLink,
                    l = e.imageWidth,
                    c = e.imageHeight,
                    u = e.marginTop,
                    d = e.marginRight,
                    p = e.marginBottom,
                    f = e.marginLeft,
                    m = e.imageLinkOpenInNewTab,
                    v = e.align,
                    g = e.classes,
                    y = e.id,
                    _ = this.j.o,
                    b = this.state.image;
                  if (_.image.editStyle && (0, i.attr)(b, "style", e.style.value || null), !t.value) return r.Dom.safeRemove(b), void this.dialog.close();
                  (0, i.attr)(b, "src", t.value), b.style.borderRadius = "0" !== o.value && /^[0-9]+$/.test(o.value) ? o.value + "px" : "", (0, i.attr)(b, "title", n.value || null), (0, i.attr)(b, "alt", a.value || null);
                  var w = r.Dom.closest(b, "a", this.j.editor);
                  if (s.value ? (w || (w = r.Dom.wrap(b, "a", this.j.createInside)), (0, i.attr)(w, "href", s.value), (0, i.attr)(w, "target", m.checked ? "_blank" : null)) : w && w.parentNode && w.parentNode.replaceChild(b, w), l.value !== b.offsetWidth.toString() || c.value !== b.offsetHeight.toString()) {
                    var S = (0, i.trim)(l.value) ? h(l.value) : null,
                      C = (0, i.trim)(c.value) ? h(c.value) : null;
                    (0, i.css)(b, {
                      width: S,
                      height: C
                    }), (0, i.attr)(b, "width", (0, i.attr)(b, "width") ? S : null), (0, i.attr)(b, "height", (0, i.attr)(b, "height") ? C : null);
                  }
                  var j = [u, d, p, f];
                  _.image.editMargins && (this.state.marginIsLocked ? (0, i.css)(b, "margin", h(u.value)) : j.forEach(function (e) {
                    var t = (0, i.attr)(e, "data-ref") || "";
                    (0, i.css)(b, t, h(e.value));
                  })), _.image.editClass && (0, i.attr)(b, "class", g.value || null), _.image.editId && (0, i.attr)(b, "id", y.value || null), _.image.editAlign && (0, i.hAlignElement)(b, v.value), this.j.synchronizeValues(), this.dialog.close();
                }, t.prototype.openImageEditor = function () {
                  var e = this,
                    t = (0, i.attr)(this.state.image, "src") || "",
                    o = this.j.c.element("a"),
                    n = function () {
                      o.host === location.host || e.j.confirm("You can only edit your own images. Download this image on the host?", function (t) {
                        t && e.j.uploader && e.j.uploader.uploadRemoteImage(o.href.toString(), function (t) {
                          e.j.alert("The image has been successfully uploaded to the host!", function () {
                            (0, i.isString)(t.newfilename) && ((0, i.attr)(e.state.image, "src", t.baseurl + t.newfilename), e.updateValues());
                          });
                        }, function (t) {
                          e.j.alert("There was an error loading %s", t.message);
                        });
                      });
                    };
                  o.href = t, this.j.filebrowser.dataProvider.getPathByUrl(o.href.toString()).then(function (n) {
                    c.openImageEditor.call(e.j.filebrowser, o.href, n.name, n.path, n.source, function () {
                      var o = new Date().getTime();
                      (0, i.attr)(e.state.image, "src", t + (-1 !== t.indexOf("?") ? "" : "?") + "&_tmp=" + o.toString()), e.updateValues();
                    }, function (t) {
                      e.j.alert(t.message);
                    });
                  }).catch(function (t) {
                    e.j.alert(t.message, n);
                  });
                }, t.prototype.openImagePopup = function (e) {
                  var t = this,
                    o = new r.Popup(this.j),
                    n = (0, i.refs)(this.form).changeImage;
                  o.setZIndex(this.dialog.getZIndex() + 1), o.setContent((0, a.FileSelectorWidget)(this.j, {
                    upload: function (e) {
                      e.files && e.files.length && (0, i.attr)(t.state.image, "src", e.baseurl + e.files[0]), t.updateValues(), o.close();
                    },
                    filebrowser: function (e) {
                      e && (0, i.isArray)(e.files) && e.files.length && ((0, i.attr)(t.state.image, "src", e.files[0]), o.close(), t.updateValues());
                    }
                  }, this.state.image, o.close)).open(function () {
                    return (0, i.position)(n);
                  }), e.stopPropagation();
                }, t.prototype.afterInit = function (e) {
                  var t = this,
                    o = this;
                  e.e.on("afterConstructor changePlace", function () {
                    e.e.off(e.editor, ".imageproperties").on(e.editor, "dblclick.imageproperties", function (n) {
                      var i = n.target;
                      if (r.Dom.isTag(i, "img")) if (e.o.image.openOnDblClick) {
                        if (!1 === t.j.e.fire("openOnDblClick", i)) return;
                        o.state.image = i, e.o.readonly || (n.stopImmediatePropagation(), n.preventDefault(), o.open());
                      } else n.stopImmediatePropagation(), e.s.select(i);
                    });
                  }).on("openImageProperties.imageproperties", function (e) {
                    t.state.image = e, t.open();
                  });
                }, t.prototype.beforeDestruct = function (e) {
                  this.dialog && this.dialog.destruct(), e.e.off(e.editor, ".imageproperties").off(".imageproperties");
                }, n.__decorate([(0, l.watch)("state.marginIsLocked")], t.prototype, "onChangeMarginIsLocked", null), n.__decorate([(0, l.watch)("state.sizeIsLocked")], t.prototype, "onChangeSizeIsLocked", null), n.__decorate([l.autobind], t.prototype, "onApply", null), n.__decorate([l.autobind], t.prototype, "openImageEditor", null), n.__decorate([l.autobind], t.prototype, "openImagePopup", null), t;
              }(r.Plugin);
            t.imageProperties = v, u.pluginSystem.add("imageProperties", v);
          },
          49391: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.form = void 0;
            var n = o(77904);
            t.form = function (e) {
              var t = e.o.image,
                o = t.showPreview,
                r = t.editSize,
                i = n.Icon.get.bind(n.Icon);
              return e.c.fromHTML('<form class="jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-2-5 jodit_col-xs-5-5">\n\t\t\t\t<div class="jodit-properties_view_box">\n\t\t\t\t\t<div style="'.concat(o ? "" : "display:none", '" class="jodit-properties_image_view">\n\t\t\t\t\t\t<img data-ref="imageViewSrc" src="" alt=""/>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div style="').concat(r ? "" : "display:none", '" class="jodit-form__group jodit-properties_image_sizes">\n\t\t\t\t\t\t<input data-ref="imageWidth" type="text" class="jodit-input"/>\n\t\t\t\t\t\t<a data-ref="lockSize" class="jodit-properties__lock">').concat(i("lock"), '</a>\n\t\t\t\t\t\t<input data-ref="imageHeight" type="text" class="imageHeight jodit-input"/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div data-ref="tabsBox" class="jodit_col-lg-3-5 jodit_col-xs-5-5"></div>\n\t\t</div>\n\t</form>'));
            };
          },
          27506: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.mainTab = void 0;
            var n = o(77904);
            t.mainTab = function (e) {
              var t = e.o,
                o = e.i18n.bind(e),
                r = n.Icon.get.bind(n.Icon),
                i = t.filebrowser.ajax.url || t.uploader.url,
                a = t.image.useImageEditor;
              return e.c.fromHTML('<div style="'.concat(t.image.editSrc ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Src"), '</label>\n\t\t\t<div class="jodit-input_group">\n\t\t\t\t<input data-ref="imageSrc" class="jodit-input" type="text"/>\n\t\t\t\t<div\n\t\t\t\t\tclass="jodit-input_group-buttons"\n\t\t\t\t\tstyle="').concat(i ? "" : "display: none", '"\n\t\t\t\t>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="changeImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t>').concat(r("image"), '</a>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="editImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t\tstyle="').concat(a ? "" : "display: none", '"\n\t\t\t\t\t\t>').concat(r("crop"), '</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div style="').concat(t.image.editTitle ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Title"), '</label>\n\t\t\t<input data-ref="imageTitle" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editAlt ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Alternative"), '</label>\n\t\t\t<input data-ref="imageAlt" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editLink ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Link"), '</label>\n\t\t\t<input data-ref="imageLink" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editLink ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label class="jodit_vertical_middle">\n\t\t\t\t<input data-ref="imageLinkOpenInNewTab" type="checkbox" class="jodit-checkbox"/>\n\t\t\t\t<span>').concat(o("Open link in new tab"), "</span>\n\t\t\t</label>\n\t\t</div>"));
            };
          },
          50109: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.positionTab = void 0;
            var n = o(77904);
            t.positionTab = function (e) {
              var t = e.o,
                o = e.i18n.bind(e),
                r = n.Icon.get.bind(n.Icon),
                i = [];
              return t.image.availableClasses.length > 0 ? (i.push('<select data-ref="classes" class="jodit-input jodit-select">'), t.image.availableClasses.forEach(function (e) {
                i.push("string" == typeof e ? '<option value="'.concat(e, '">').concat(e, "</option>") : '<option value="'.concat(e[0], '">').concat(e[1], "</option>"));
              }), i.push("</select>")) : i.push('<input data-ref="classes" type="text" class="jodit-input"/>'), e.c.fromHTML('<div style="'.concat(t.image.editMargins ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Margins"), '</label>\n\t\t\t<div class="jodit-grid jodit_vertical_middle">\n\t\t\t\t<input class="jodit_col-lg-1-5 jodit-input" data-ref="marginTop" type="text" placeholder="').concat(o("top"), '"/>\n\t\t\t\t<a style="text-align: center;" data-ref="lockMargin" class="jodit-properties__lock jodit_col-lg-1-5">').concat(r("lock"), '</a>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginRight" type="text" placeholder="').concat(o("right"), '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginBottom" type="text" placeholder="').concat(o("bottom"), '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginLeft" type="text" placeholder="').concat(o("left"), '"/>\n\t\t\t</div>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="').concat(t.image.editAlign ? "" : "display:none", '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>').concat(o("Align"), '</label>\n\t\t\t<select data-ref="align" class="jodit-select">\n\t\t\t\t<option value="">').concat(o("--Not Set--"), '</option>\n\t\t\t\t<option value="left">').concat(o("Left"), '</option>\n\t\t\t\t<option value="center">').concat(o("Center"), '</option>\n\t\t\t\t<option value="right">').concat(o("Right"), '</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<div style="').concat(t.image.editStyle ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Styles"), '</label>\n\t\t\t<input data-ref="style" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editClass ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Classes"), "</label>\n\t\t\t").concat(i.join(""), '\n\t\t</div>\n\t\t<div style="').concat(t.image.editId ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>Id</label>\n\t\t\t<input data-ref="id" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="').concat(t.image.editBorderRadius ? "" : "display:none", '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>').concat(o("Border radius"), '</label>\n\t\t\t\t<input data-ref="borderRadius" type="number" class="jodit-input"/>\n\t\t</div>'));
            };
          },
          67547: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.image = void 0;
            var n = o(20255),
              r = o(64968),
              i = o(40332),
              a = o(718),
              s = o(93166),
              l = o(17332);
            function c(e) {
              e.registerButton({
                name: "image",
                group: "media"
              });
            }
            o(77904).Icon.set("image", o(53477)), s.Config.prototype.controls.image = {
              popup: function (e, t, o, s) {
                var l = null;
                return t && !r.Dom.isText(t) && r.Dom.isHTMLElement(t) && (r.Dom.isTag(t, "img") || (0, i.$$)("img", t).length) && (l = r.Dom.isTag(t, "img") ? t : (0, i.$$)("img", t)[0]), e.s.save(), (0, a.FileSelectorWidget)(e, {
                  filebrowser: function (t) {
                    e.s.restore(), t.files && t.files.forEach(function (o) {
                      return e.s.insertImage(t.baseurl + o, null, e.o.imageDefaultWidth);
                    }), s();
                  },
                  upload: !0,
                  url: function (t, o) {
                    return n.__awaiter(void 0, void 0, void 0, function () {
                      var r;
                      return n.__generator(this, function (n) {
                        switch (n.label) {
                          case 0:
                            return e.s.restore(), /^[a-z\d_-]+(\.[a-z\d_-]+)+/i.test(t) && (t = "//" + t), (r = l || e.createInside.element("img")).setAttribute("src", t), r.setAttribute("alt", o), l ? [3, 2] : [4, e.s.insertImage(r, null, e.o.imageDefaultWidth)];
                          case 1:
                            n.sent(), n.label = 2;
                          case 2:
                            return s(), [2];
                        }
                      });
                    });
                  }
                }, l, s);
              },
              tags: ["img"],
              tooltip: "Insert Image"
            }, t.image = c, l.pluginSystem.add("image", c);
          },
          2916: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(64968),
              i = o(77904),
              a = o(26011);
            i.Icon.set("indent", o(90053)).set("outdent", o(72230)), n.Config.prototype.controls.indent = {
              tooltip: "Increase Indent"
            }, n.Config.prototype.controls.outdent = {
              isDisabled: function (e) {
                var t = e.s.current();
                if (t) {
                  var o = r.Dom.closest(t, r.Dom.isBlock, e.editor);
                  if (o) {
                    var n = (0, a.getKey)(e.o.direction, o);
                    return !o.style[n] || 0 >= parseInt(o.style[n], 10);
                  }
                }
                return !0;
              },
              tooltip: "Decrease Indent"
            }, n.Config.prototype.indentMargin = 10;
          },
          26011: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.getKey = void 0;
            var n = o(24263);
            t.getKey = function (e, t) {
              return "".concat(n.Dom.isCell(t) ? "padding" : "margin").concat("rtl" === e ? "Right" : "Left");
            };
          },
          71838: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.indent = void 0;
            var n = o(86893),
              r = o(64968),
              i = o(40332),
              a = o(17332);
            o(2916);
            var s = o(26011);
            function l(e) {
              e.registerButton({
                name: "indent",
                group: "indent"
              }).registerButton({
                name: "outdent",
                group: "indent"
              });
              var t = function (t) {
                var o = [];
                return e.s.eachSelection(function (a) {
                  e.s.save();
                  var l = !!a && r.Dom.up(a, r.Dom.isBlock, e.editor),
                    c = e.o.enter;
                  if (!l && a && (l = r.Dom.wrapInline(a, c !== n.BR ? c : n.PARAGRAPH, e)), !l) return e.s.restore(), !1;
                  var u = o.includes(l);
                  if (l && !u) {
                    var d = (0, s.getKey)(e.o.direction, l);
                    o.push(l);
                    var p = l.style[d] ? parseInt(l.style[d], 10) : 0;
                    l.style[d] = (p += e.o.indentMargin * ("outdent" === t ? -1 : 1)) > 0 ? p + "px" : "", (0, i.attr)(l, "style") || (0, i.attr)(l, "style", null);
                  }
                  e.s.restore();
                }), e.synchronizeValues(), !1;
              };
              e.registerCommand("indent", {
                exec: t,
                hotkeys: ["ctrl+]", "cmd+]"]
              }), e.registerCommand("outdent", {
                exec: t,
                hotkeys: ["ctrl+[", "cmd+["]
              });
            }
            t.indent = l, a.pluginSystem.add("indent", l);
          },
          70022: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(55692), o(66031), o(91241), o(87565), o(60894), o(90302), o(92138), o(88412), o(79308), o(19268), o(30598), o(33122), o(10135), o(66994), o(54798), o(12908), o(65123), o(83228), o(43889), o(93300), o(67547), o(92575), o(15747), o(71838), o(54752), o(54452), o(46324), o(27738), o(61421), o(27582), o(76303), o(19806), o(52598), o(19483), o(15428), o(47224), o(83211), o(88297), o(72930), o(51197), o(2327), o(47608), o(90523), o(69257), o(14889), o(95323), o(37458), o(71003), o(86030), o(17002), o(1557), o(82808), o(48560), o(32246), o(45842), o(23308), o(19889), o(20728), o(96899), o(18238);
          },
          35387: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.toolbarInline = !0, n.Config.prototype.toolbarInlineForSelection = !1, n.Config.prototype.toolbarInlineDisableFor = [], n.Config.prototype.toolbarInlineDisabledButtons = ["source"], r.Icon.set("addcolumn", o(78321)).set("addrow", o(77654)).set("merge", o(43371)).set("th", o(52242)).set("splitg", o(44563)).set("splitv", o(53183)).set("th-list", o(18548)), n.Config.prototype.popup = {
              a: o(27487).Z,
              img: o(97425).default,
              cells: o(59500).Z,
              toolbar: o(55350).Z,
              jodit: o(66686).Z,
              iframe: o(66686).Z,
              "jodit-media": o(66686).Z,
              selection: ["bold", "underline", "italic", "ul", "ol", "\n", "outdent", "indent", "fontsize", "brush", "cut", "\n", "paragraph", "link", "align", "dots"]
            };
          },
          27487: function (e, t, o) {

            var n = o(76502);
            t.Z = [{
              name: "eye",
              tooltip: "Open link",
              exec: function (e, t) {
                var o = (0, n.attr)(t, "href");
                t && o && e.ow.open(o);
              }
            }, {
              name: "link",
              tooltip: "Edit link",
              icon: "pencil"
            }, "unlink", "brush", "file"];
          },
          59500: function (e, t, o) {

            var n = o(10172),
              r = o(26911),
              i = o(718),
              a = function (e) {
                return e.args && (0, n.isString)(e.args[0]) ? e.args[0].toLowerCase() : "";
              };
            t.Z = [{
              name: "brush",
              popup: function (e, t, o, a) {
                if ((0, n.isJoditObject)(e)) {
                  var s = e.getInstance("Table", e.o).getAllSelectedCells();
                  if (!s.length) return !1;
                  var l = function (t) {
                    return (0, i.ColorPickerWidget)(e, function (o) {
                      s.forEach(function (e) {
                        (0, r.css)(e, t, o);
                      }), e.lock(), e.synchronizeValues(), a(), e.unlock();
                    }, (0, r.css)(s[0], t));
                  };
                  return (0, i.TabsWidget)(e, [{
                    name: "Background",
                    content: l("background-color")
                  }, {
                    name: "Text",
                    content: l("color")
                  }, {
                    name: "Border",
                    content: l("border-color")
                  }]);
                }
              },
              tooltip: "Background"
            }, {
              name: "valign",
              list: ["Top", "Middle", "Bottom", "Normal"],
              childTemplate: function (e, t, o) {
                return o;
              },
              exec: function (e, t, o) {
                var n = a(o.control);
                e.getInstance("Table", e.o).getAllSelectedCells().forEach(function (e) {
                  (0, r.css)(e, "vertical-align", "normal" === n ? "" : n);
                });
              },
              tooltip: "Vertical align"
            }, {
              name: "splitv",
              list: {
                tablesplitv: "Split vertical",
                tablesplitg: "Split horizontal"
              },
              tooltip: "Split"
            }, {
              name: "align",
              icon: "left"
            }, "\n", {
              name: "merge",
              command: "tablemerge",
              tooltip: "Merge"
            }, {
              name: "addcolumn",
              list: {
                tableaddcolumnbefore: "Insert column before",
                tableaddcolumnafter: "Insert column after"
              },
              exec: function (e, t, o) {
                var r = o.control;
                if ((0, n.isJoditObject)(e)) {
                  var i = a(r);
                  e.execCommand(i, !1, t);
                }
              },
              tooltip: "Add column"
            }, {
              name: "addrow",
              list: {
                tableaddrowbefore: "Insert row above",
                tableaddrowafter: "Insert row below"
              },
              exec: function (e, t, o) {
                var r = o.control;
                if ((0, n.isJoditObject)(e)) {
                  var i = a(r);
                  e.execCommand(i, !1, t);
                }
              },
              tooltip: "Add row"
            }, {
              name: "delete",
              icon: "bin",
              list: {
                tablebin: "Delete table",
                tablebinrow: "Delete row",
                tablebincolumn: "Delete column",
                tableempty: "Empty cell"
              },
              exec: function (e, t, o) {
                var r = o.control;
                if ((0, n.isJoditObject)(e)) {
                  var i = a(r);
                  e.execCommand(i, !1, t), e.e.fire("hidePopup");
                }
              },
              tooltip: "Delete"
            }];
          },
          66686: function (e, t, o) {

            var n = o(97425);
            t.Z = [{
              name: "bin",
              tooltip: "Delete",
              exec: function (e, t) {
                t && e.s.removeNode(t);
              }
            }, n.align];
          },
          97425: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.align = void 0;
            var n = o(64968),
              r = o(24421),
              i = o(26911),
              a = o(60303);
            t.align = {
              name: "left",
              childTemplate: function (e, t, o) {
                return o;
              },
              list: ["Left", "Right", "Center", "Normal"],
              exec: function (e, t, o) {
                var i = o.control;
                if (n.Dom.isTag(t, ["img", "jodit", "jodit-media"])) {
                  var s = i.args && (0, r.isString)(i.args[0]) ? i.args[0].toLowerCase() : "";
                  if (!s) return !1;
                  (0, a.hAlignElement)(t, s), n.Dom.isTag(t, ["jodit", "jodit-media"]) && t.firstElementChild && (0, a.hAlignElement)(t.firstElementChild, s), e.synchronizeValues(), e.e.fire("recalcPositionPopup");
                }
              },
              tooltip: "Horizontal align"
            }, t.default = [{
              name: "delete",
              icon: "bin",
              tooltip: "Delete",
              exec: function (e, t) {
                t && e.s.removeNode(t);
              }
            }, {
              name: "pencil",
              exec: function (e, t) {
                "img" === t.tagName.toLowerCase() && e.e.fire("openImageProperties", t);
              },
              tooltip: "Edit"
            }, {
              name: "valign",
              list: ["Top", "Middle", "Bottom", "Normal"],
              tooltip: "Vertical align",
              exec: function (e, t, o) {
                var a = o.control;
                if (n.Dom.isTag(t, "img")) {
                  var s = a.args && (0, r.isString)(a.args[0]) ? a.args[0].toLowerCase() : "";
                  if (!s) return !1;
                  (0, i.css)(t, "vertical-align", "normal" === s ? "" : s), e.e.fire("recalcPositionPopup");
                }
              }
            }, t.align];
          },
          55350: function (e, t) {

            t.Z = ["bold", "italic", "|", "ul", "ol", "eraser", "|", "fontsize", "brush", "paragraph", "---", "image", "table", "\n", "link", "|", "align", "|", "undo", "redo", "|", "copyformat", "fullsize", "---", "dots"];
          },
          54752: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.inlinePopup = void 0;
            var n = o(20255);
            o(45109);
            var r = o(57549),
              i = o(81438),
              a = o(35799),
              s = o(40332),
              l = o(64968),
              c = o(2074),
              u = o(43441),
              d = o(17332);
            o(35387);
            var p = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.requires = ["select"], t.type = null, t.popup = new a.Popup(t.jodit, !1), t.toolbar = (0, i.makeCollection)(t.jodit, t.popup), t.snapRange = null, t.elmsList = (0, s.keys)(t.j.o.popup, !1).filter(function (e) {
                  return !t.isExcludedTarget(e);
                }), t;
              }
              return n.__extends(t, e), t.prototype.onClick = function (e) {
                var t = this,
                  o = this.elmsList,
                  n = l.Dom.isTag(e, "img") ? e : l.Dom.closest(e, o, this.j.editor);
                if (n && this.canShowPopupForType(n.nodeName.toLowerCase())) return this.showPopup(function () {
                  return (0, s.position)(n, t.j);
                }, n.nodeName.toLowerCase(), n), !1;
              }, t.prototype.showPopup = function (e, t, o) {
                if (t = t.toLowerCase(), !this.canShowPopupForType(t)) return !1;
                if (this.type !== t || o !== this.previousTarget) {
                  this.previousTarget = o;
                  var n = this.j.o.popup[t],
                    r = void 0;
                  r = (0, s.isFunction)(n) ? n(this.j, o, this.popup.close) : n, (0, s.isArray)(r) && (this.toolbar.build(r, o), this.toolbar.buttonSize = this.j.o.toolbarButtonSize, r = this.toolbar.container), this.popup.setContent(r), this.type = t;
                }
                return this.popup.open(e), !0;
              }, t.prototype.hidePopup = function (e) {
                (0, s.isString)(e) && e !== this.type || this.popup.close();
              }, t.prototype.onOutsideClick = function () {
                this.popup.close();
              }, t.prototype.canShowPopupForType = function (e) {
                var t = this.j.o.popup[e.toLowerCase()];
                return !(this.j.o.readonly || !this.j.o.toolbarInline || !t || this.isExcludedTarget(e));
              }, t.prototype.isExcludedTarget = function (e) {
                return (0, s.splitArray)(this.j.o.toolbarInlineDisableFor).map(function (e) {
                  return e.toLowerCase();
                }).includes(e.toLowerCase());
              }, t.prototype.afterInit = function (e) {
                var t = this;
                this.j.e.on("getDiffButtons.mobile", function (o) {
                  if (t.toolbar === o) {
                    var n = t.toolbar.getButtonsNames();
                    return (0, s.toArray)(e.registeredButtons).filter(function (e) {
                      return !t.j.o.toolbarInlineDisabledButtons.includes(e.name);
                    }).filter(function (e) {
                      var t = (0, s.isString)(e) ? e : e.name;
                      return t && "|" !== t && "\n" !== t && !n.includes(t);
                    });
                  }
                }).on("hidePopup", this.hidePopup).on("showInlineToolbar", this.showInlineToolbar).on("showPopup", function (e, o, n) {
                  t.showPopup(o, n || ((0, s.isString)(e) ? e : e.nodeName), (0, s.isString)(e) ? void 0 : e);
                }).on("mousedown keydown", this.onSelectionStart).on("change", function () {
                  t.popup.isOpened && t.previousTarget && !t.previousTarget.parentNode && (t.hidePopup(), t.previousTarget = void 0);
                }).on([this.j.ew, this.j.ow], "mouseup keyup", this.onSelectionEnd), this.addListenersForElements();
              }, t.prototype.onSelectionStart = function () {
                this.snapRange = this.j.s.range.cloneRange();
              }, t.prototype.onSelectionEnd = function (e) {
                if (!(e && e.target && c.UIElement.closestElement(e.target, a.Popup))) {
                  var t = this.snapRange,
                    o = this.j.s.range;
                  t && !o.collapsed && o.startContainer === t.startContainer && o.startOffset === t.startOffset && o.endContainer === t.endContainer && o.endOffset === t.endOffset || this.onSelectionChange();
                }
              }, t.prototype.onSelectionChange = function () {
                if (this.j.o.toolbarInlineForSelection) {
                  var e = "selection",
                    t = this.j.s.sel,
                    o = this.j.s.range;
                  (null == t ? void 0 : t.isCollapsed) || this.isSelectedTarget(o) || this.tableModule.getAllSelectedCells().length ? this.type === e && this.popup.isOpened && this.hidePopup() : this.j.s.current() && this.showPopup(function () {
                    return o.getBoundingClientRect();
                  }, e);
                }
              }, t.prototype.isSelectedTarget = function (e) {
                var t = e.startContainer;
                return l.Dom.isElement(t) && t === e.endContainer && l.Dom.isTag(t.childNodes[e.startOffset], (0, s.keys)(this.j.o.popup, !1)) && e.startOffset === e.endOffset - 1;
              }, Object.defineProperty(t.prototype, "tableModule", {
                get: function () {
                  return this.j.getInstance("Table", this.j.o);
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.beforeDestruct = function (e) {
                e.e.off("showPopup").off([this.j.ew, this.j.ow], "mouseup keyup", this.onSelectionEnd), this.removeListenersForElements();
              }, t.prototype._eventsList = function () {
                var e = this.elmsList;
                return e.map(function (e) {
                  return (0, s.camelCase)("click_".concat(e));
                }).concat(e.map(function (e) {
                  return (0, s.camelCase)("touchstart_".concat(e));
                })).join(" ");
              }, t.prototype.addListenersForElements = function () {
                this.j.e.on(this._eventsList(), this.onClick);
              }, t.prototype.removeListenersForElements = function () {
                this.j.e.off(this._eventsList(), this.onClick);
              }, t.prototype.showInlineToolbar = function (e) {
                var t = this;
                this.showPopup(function () {
                  return e || t.j.s.range.getBoundingClientRect();
                }, "toolbar");
              }, n.__decorate([u.autobind], t.prototype, "onClick", null), n.__decorate([(0, u.wait)(function (e) {
                return !e.j.isLocked;
              })], t.prototype, "showPopup", null), n.__decorate([(0, u.watch)(":clickEditor"), u.autobind], t.prototype, "hidePopup", null), n.__decorate([(0, u.watch)(":outsideClick")], t.prototype, "onOutsideClick", null), n.__decorate([u.autobind], t.prototype, "onSelectionStart", null), n.__decorate([u.autobind], t.prototype, "onSelectionEnd", null), n.__decorate([(0, u.debounce)(function (e) {
                return e.defaultTimeout;
              })], t.prototype, "onSelectionChange", null), n.__decorate([u.autobind], t.prototype, "showInlineToolbar", null), t;
            }(r.Plugin);
            t.inlinePopup = p, d.pluginSystem.add("inlinePopup", p);
          },
          54452: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.justify = void 0;
            var n = o(93166),
              r = o(24263),
              i = o(26911),
              a = o(60303),
              s = o(17332);
            function l(e) {
              e.registerButton({
                name: "align",
                group: "indent"
              });
              var t = function (t) {
                return e.s.focus(), e.s.eachSelection(function (o) {
                  if (o) {
                    var n = r.Dom.up(o, r.Dom.isBlock, e.editor);
                    n || (n = r.Dom.wrapInline(o, e.o.enterBlock, e)), (0, a.alignElement)(t, n);
                  }
                }), !1;
              };
              e.registerCommand("justifyfull", t), e.registerCommand("justifyright", t), e.registerCommand("justifyleft", t), e.registerCommand("justifycenter", t);
            }
            o(77904).Icon.set("justify", o(87498)), n.Config.prototype.controls.align = {
              name: "left",
              tooltip: "Align",
              update: function (e, t) {
                var o = e.control,
                  n = t.s.current();
                if (n) {
                  var a = r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor,
                    s = (0, i.css)(a, "text-align").toString();
                  o.defaultValue && -1 !== o.defaultValue.indexOf(s) && (s = "left"), o.data && o.data.currentValue !== s && o.list && -1 !== o.list.indexOf(s) && (t.o.textIcons ? e.state.text = s : e.state.icon.name = s, o.data.currentValue = s);
                }
              },
              isActive: function (e, t) {
                var o = e.s.current();
                if (o && t.defaultValue) {
                  var n = r.Dom.closest(o, r.Dom.isBlock, e.editor) || e.editor;
                  return -1 === t.defaultValue.indexOf((0, i.css)(n, "text-align").toString());
                }
                return !1;
              },
              defaultValue: ["left", "start", "inherit"],
              data: {
                currentValue: "left"
              },
              list: ["center", "left", "right", "justify"]
            }, n.Config.prototype.controls.center = {
              command: "justifyCenter",
              css: {
                "text-align": "center"
              },
              tooltip: "Align Center"
            }, n.Config.prototype.controls.justify = {
              command: "justifyFull",
              css: {
                "text-align": "justify"
              },
              tooltip: "Align Justify"
            }, n.Config.prototype.controls.left = {
              command: "justifyLeft",
              css: {
                "text-align": "left"
              },
              tooltip: "Align Left"
            }, n.Config.prototype.controls.right = {
              command: "justifyRight",
              css: {
                "text-align": "right"
              },
              tooltip: "Align Right"
            }, t.justify = l, s.pluginSystem.add("justify", l);
          },
          46324: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.keyArrowOutside = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(43441),
              a = o(86893),
              s = o(24263),
              l = o(17332),
              c = function (e) {
                function t() {
                  return null !== e && e.apply(this, arguments) || this;
                }
                return n.__extends(t, e), t.prototype.afterInit = function (e) {}, t.prototype.beforeDestruct = function (e) {}, t.prototype.onKeyDownArrow = function (e) {
                  var t;
                  if (e.key === a.KEY_RIGHT && this.j.selection.isCollapsed()) {
                    var o = this.j.selection.range,
                      n = o.endContainer,
                      r = o.endOffset;
                    if (s.Dom.isText(n) && (null === (t = n.nodeValue) || void 0 === t ? void 0 : t.length) === r) {
                      var i = n.parentNode;
                      s.Dom.isInlineBlock(i) && !s.Dom.findNotEmptyNeighbor(i, !1, this.j.editor) && s.Dom.after(i, this.j.createInside.text(a.NBSP_SPACE));
                    }
                  }
                }, n.__decorate([(0, i.watch)(":keydown")], t.prototype, "onKeyDownArrow", null), t;
              }(r.Plugin);
            t.keyArrowOutside = c, l.pluginSystem.add("keyArrowOutside", c);
          },
          19250: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.limitWords = !1, n.Config.prototype.limitChars = !1, n.Config.prototype.limitHTML = !1;
          },
          27738: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.limit = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(86893),
              a = o(43441),
              s = o(17332);
            o(19250);
            var l = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this,
                  o = e.o;
                if (e && (o.limitWords || o.limitChars)) {
                  var n = null;
                  e.e.off(".limit").on("beforePaste.limit", function () {
                    n = e.history.snapshot.make();
                  }).on("keydown.limit keyup.limit beforeEnter.limit", this.checkPreventKeyPressOrPaste).on("change.limit", this.checkPreventChanging).on("afterPaste.limit", function () {
                    if (t.__shouldDenyInput(!0) && n) return e.history.snapshot.restore(n), e.e.fire("denyPaste.limit"), !1;
                  });
                }
              }, t.prototype.shouldPreventInsertHTML = function (e) {
                return (!e || !(i.COMMAND_KEYS.includes(e.key) || e.ctrlKey || e.metaKey)) && this.__shouldDenyInput(!1);
              }, t.prototype.__shouldDenyInput = function (e) {
                var t = this.jodit,
                  o = t.o,
                  n = o.limitWords,
                  r = o.limitChars,
                  i = this.__splitWords(t.o.limitHTML ? t.value : t.text);
                if (n && c(i.length, n, e)) return t.e.fire("denyWords.limit limit.limit"), !0;
                var a = Boolean(r && c(i.join("").length, r, e));
                return a && t.e.fire("denyChars.limit limit.limit"), a;
              }, t.prototype.checkPreventKeyPressOrPaste = function (e) {
                if (this.shouldPreventInsertHTML(e)) return !1;
              }, t.prototype.checkPreventChanging = function (e, t) {
                var o = this.jodit;
                this.__shouldDenyInput(!0) && (o.value = t);
              }, t.prototype.__splitWords = function (e) {
                return e.replace((0, i.INVISIBLE_SPACE_REG_EXP)(), "").split((0, i.SPACE_REG_EXP)()).filter(function (e) {
                  return e.length;
                });
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off(".limit");
              }, n.__decorate([a.autobind], t.prototype, "checkPreventKeyPressOrPaste", null), n.__decorate([a.autobind], t.prototype, "checkPreventChanging", null), t;
            }(r.Plugin);
            function c(e, t, o) {
              return o ? e > t : e >= t;
            }
            t.limit = l, s.pluginSystem.add("limit", l);
          },
          29490: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(40332),
              i = o(77904);
            n.Config.prototype.defaultLineHeight = null, i.Icon.set("line-height", o(7986)), n.Config.prototype.controls.lineHeight = {
              command: "applyLineHeight",
              tags: ["ol"],
              tooltip: "Line height",
              list: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 2],
              exec: function (e, t, o) {
                return (0, r.memorizeExec)(e, t, {
                  control: o.control
                }, function (e) {
                  return e;
                });
              }
            };
          },
          26752: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
            var n = o(47762);
            t.ar = n;
            var r = o(97495);
            t.cs_cz = r;
            var i = o(80131);
            t.de = i;
            var a = o(1201);
            t.es = a;
            var s = o(89912);
            t.fa = s;
            var l = o(3405);
            t.fr = l;
            var c = o(14129);
            t.he = c;
            var u = o(93729);
            t.hu = u;
            var d = o(16106);
            t.id = d;
            var p = o(89690);
            t.it = p;
            var f = o(33216);
            t.ja = f;
            var h = o(17282);
            t.ko = h;
            var m = o(52841);
            t.mn = m;
            var v = o(91761);
            t.nl = v;
            var g = o(61675);
            t.pl = g;
            var y = o(69709);
            t.pt_br = y;
            var _ = o(82591);
            t.ru = _;
            var b = o(87649);
            t.tr = b;
            var w = o(60268);
            t.zh_cn = w;
            var S = o(58214);
            t.zh_tw = S;
          },
          61421: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.lineHeight = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(40332),
              a = o(43441),
              s = o(24263),
              l = o(17332);
            o(29490);
            var c = function (e) {
              function t(t) {
                var n = e.call(this, t) || this;
                return n.buttons = [{
                  name: "lineHeight",
                  group: "font"
                }], (0, l.extendLang)(o(26752)), n;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                (0, i.css)(e.editor, {
                  lineHeight: e.o.defaultLineHeight
                }), e.registerCommand("applyLineHeight", this.applyLineHeight);
              }, t.prototype.applyLineHeight = function (e, t, o) {
                var n,
                  r = this.j,
                  a = r.s,
                  l = r.createInside,
                  c = r.editor,
                  u = r.o;
                a.isFocused() || a.focus(), a.save();
                var d = function (e) {
                  var t = s.Dom.closest(e, s.Dom.isBlock, c);
                  t || (t = s.Dom.wrap(e, u.enter, l));
                  var r = (0, i.css)(t, "lineHeight");
                  void 0 === n && (n = r.toString() !== o.toString()), (0, i.css)(t, "lineHeight", n ? o : null);
                };
                try {
                  if (a.isCollapsed()) {
                    var p = l.fake();
                    a.insertNode(p, !1, !1), d(p), s.Dom.safeRemove(p);
                  } else a.eachSelection(d);
                } finally {
                  a.restore();
                }
              }, t.prototype.beforeDestruct = function (e) {
                (0, i.css)(e.editor, {
                  lineHeight: null
                });
              }, n.__decorate([a.autobind], t.prototype, "applyLineHeight", null), t;
            }(r.Plugin);
            t.lineHeight = c, l.pluginSystem.add("lineHeight", c);
          },
          56367: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(54238),
              i = o(24263),
              a = o(77904);
            n.Config.prototype.link = {
              formTemplate: r.formTemplate,
              followOnDblClick: !1,
              processVideoLink: !0,
              processPastedLink: !0,
              noFollowCheckbox: !0,
              openInNewTabCheckbox: !0,
              modeClassName: "input",
              selectMultipleClassName: !0,
              selectSizeClassName: 3,
              selectOptionsClassName: [],
              hotkeys: ["ctrl+k", "cmd+k"]
            }, a.Icon.set("link", o(23075)).set("unlink", o(10655)), n.Config.prototype.controls.unlink = {
              exec: function (e, t) {
                var o = i.Dom.closest(t, "a", e.editor);
                o && i.Dom.unwrap(o), e.synchronizeValues(), e.e.fire("hidePopup");
              },
              tooltip: "Unlink"
            }, n.Config.prototype.controls.link = {
              isActive: function (e) {
                var t = e.s.current();
                return Boolean(t && i.Dom.closest(t, "a", e.editor));
              },
              popup: function (e, t, o, n) {
                return e.e.fire("generateLinkForm.link", t, n);
              },
              tags: ["a"],
              tooltip: "Insert link"
            };
          },
          27582: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.link = void 0;
            var n = o(20255),
              r = o(64968),
              i = o(40332),
              a = o(57549),
              s = o(43441),
              l = o(17332);
            o(56367);
            var c = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "link",
                  group: "insert"
                }], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.o.link.followOnDblClick && e.e.on("dblclick.link", this.onDblClickOnLink), e.o.link.processPastedLink && e.e.on("processPaste.link", this.onProcessPasteLink), e.e.on("generateLinkForm.link", this.__generateForm), e.registerCommand("openLinkDialog", {
                  exec: function () {
                    var o = e.dlg({
                        resizable: !1
                      }),
                      n = t.__generateForm(e.s.current(), function () {
                        o.close();
                      });
                    n.container.classList.add("jodit-dialog_alert"), o.setContent(n), o.open(), e.async.requestIdleCallback(function () {
                      var e = (0, i.refs)(n.container).url_input;
                      null == e || e.focus();
                    });
                  },
                  hotkeys: e.o.link.hotkeys
                });
              }, t.prototype.onDblClickOnLink = function (e) {
                if (r.Dom.isTag(e.target, "a")) {
                  var t = (0, i.attr)(e.target, "href");
                  t && (location.href = t, e.preventDefault());
                }
              }, t.prototype.onProcessPasteLink = function (e, t) {
                var o = this.jodit;
                if ((0, i.isURL)(t) && o.o.link.processPastedLink) {
                  if (o.e.stopPropagation("processPaste"), o.o.link.processVideoLink) {
                    var n = (0, i.convertMediaUrlToVideoEmbed)(t);
                    if (n !== t) return o.createInside.fromHTML(n);
                  }
                  if (o.s.isCollapsed()) {
                    var r = o.createInside.element("a");
                    return r.setAttribute("href", t), r.textContent = t, o.e.fire("applyLink", o, r, null), r;
                  }
                  return o.s.applyStyle(void 0, {
                    element: "a",
                    attributes: {
                      href: t
                    }
                  }), !0;
                }
              }, t.prototype.__generateForm = function (e, t) {
                var o,
                  n = this.jodit,
                  a = n.i18n.bind(n),
                  s = n.o.link,
                  l = s.openInNewTabCheckbox,
                  c = s.noFollowCheckbox,
                  u = s.formClassName,
                  d = s.modeClassName,
                  p = (0, s.formTemplate)(n),
                  f = (0, i.isString)(p) ? n.c.fromHTML(p, {
                    target_checkbox_box: l,
                    nofollow_checkbox_box: c
                  }) : p,
                  h = r.Dom.isElement(f) ? f : f.container,
                  m = (0, i.refs)(h),
                  v = m.insert,
                  g = m.unlink,
                  y = m.content_input_box,
                  _ = m.target_checkbox,
                  b = m.nofollow_checkbox,
                  w = m.url_input,
                  S = r.Dom.isImage(e),
                  C = m.content_input,
                  j = m.className_input,
                  E = m.className_select;
                C || (C = n.c.element("input", {
                  type: "hidden",
                  ref: "content_input"
                })), u && h.classList.add(u), S && r.Dom.hide(y);
                var x = function () {
                  return o ? o.innerText : (0, i.stripTags)(n.s.range.cloneContents(), n.ed);
                };
                if (o = !(!e || !r.Dom.closest(e, "a", n.editor)) && r.Dom.closest(e, "a", n.editor), !S && e && (C.value = x()), o) {
                  if (w.value = (0, i.attr)(o, "href") || "", d) switch (d) {
                    case "input":
                      j && (j.value = (0, i.attr)(o, "class") || "");
                      break;
                    case "select":
                      if (E) {
                        for (var k = 0; E.selectedOptions.length > k; k++) {
                          var T = E.options.item(k);
                          T && (T.selected = !1);
                        }
                        ((0, i.attr)(o, "class") || "").split(" ").forEach(function (e) {
                          if (e) for (var t = 0; E.options.length > t; t++) {
                            var o = E.options.item(t);
                            (null == o ? void 0 : o.value) && o.value === e && (o.selected = !0);
                          }
                        });
                      }
                  }
                  l && _ && (_.checked = "_blank" === (0, i.attr)(o, "target")), c && b && (b.checked = "nofollow" === (0, i.attr)(o, "rel")), v.textContent = a("Update");
                } else r.Dom.hide(g);
                n.editor.normalize();
                var I = n.history.snapshot.make();
                g && n.e.on(g, "click", function (e) {
                  n.s.restore(), n.history.snapshot.restore(I), o && r.Dom.unwrap(o), n.synchronizeValues(), t(), e.preventDefault();
                });
                var P = function () {
                  if (!w.value.trim().length) return w.focus(), w.classList.add("jodit_error"), !1;
                  var e;
                  n.s.restore(), n.s.removeMarkers(), n.editor.normalize(), n.history.snapshot.restore(I);
                  var a = x() !== C.value.trim(),
                    s = n.createInside;
                  if (o) e = [o];else {
                    if (n.s.isCollapsed()) {
                      var u = s.element("a");
                      n.s.insertNode(u, !1, !1), e = [u];
                    } else {
                      var p = n.s.current();
                      e = r.Dom.isTag(p, ["img"]) ? [r.Dom.wrap(p, "a", s)] : n.s.wrapInTag("a");
                    }
                    e.forEach(function (e) {
                      return n.s.select(e);
                    });
                  }
                  return e.forEach(function (e) {
                    var t;
                    if ((0, i.attr)(e, "href", w.value), d && (null != j ? j : E)) if ("input" === d) "" === j.value && e.hasAttribute("class") && (0, i.attr)(e, "class", null), "" !== j.value && (0, i.attr)(e, "class", j.value);else if ("select" === d) {
                      e.hasAttribute("class") && (0, i.attr)(e, "class", null);
                      for (var o = 0; E.selectedOptions.length > o; o++) {
                        var r = null === (t = E.selectedOptions.item(o)) || void 0 === t ? void 0 : t.value;
                        r && e.classList.add(r);
                      }
                    }
                    if (!S) {
                      var s = e.textContent;
                      C.value.trim().length ? a && (s = C.value) : s = w.value, s !== e.textContent && (e.textContent = s);
                    }
                    l && _ && (0, i.attr)(e, "target", _.checked ? "_blank" : null), c && b && (0, i.attr)(e, "rel", b.checked ? "nofollow" : null), n.e.fire("applyLink", n, e, f);
                  }), n.synchronizeValues(), t(), !1;
                };
                return r.Dom.isElement(f) ? n.e.on(f, "submit", function (e) {
                  return e.preventDefault(), e.stopImmediatePropagation(), P(), !1;
                }) : f.onSubmit(P), f;
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off("generateLinkForm.link", this.__generateForm).off("dblclick.link", this.onDblClickOnLink).off("processPaste.link", this.onProcessPasteLink);
              }, n.__decorate([s.autobind], t.prototype, "onDblClickOnLink", null), n.__decorate([s.autobind], t.prototype, "onProcessPasteLink", null), n.__decorate([s.autobind], t.prototype, "__generateForm", null), t;
            }(a.Plugin);
            t.link = c, l.pluginSystem.add("link", c);
          },
          54238: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.formTemplate = void 0;
            var n = o(95963),
              r = o(96516);
            t.formTemplate = function (e) {
              var t = e.o.link,
                o = t.openInNewTabCheckbox,
                i = t.noFollowCheckbox,
                a = t.modeClassName,
                s = t.selectSizeClassName,
                l = t.selectMultipleClassName,
                c = t.selectOptionsClassName;
              return new n.UIForm(e, [new n.UIBlock(e, [new n.UIInput(e, {
                name: "url",
                type: "text",
                ref: "url_input",
                label: "URL",
                placeholder: "http://",
                required: !0
              })]), new n.UIBlock(e, [new n.UIInput(e, {
                name: "content",
                ref: "content_input",
                label: "Text"
              })], {
                ref: "content_input_box"
              }), a ? new n.UIBlock(e, ["input" === a ? new n.UIInput(e, {
                name: "className",
                ref: "className_input",
                label: "Class name"
              }) : "select" === a ? new n.UISelect(e, {
                name: "className",
                ref: "className_select",
                label: "Class name",
                size: s,
                multiple: l,
                options: c
              }) : null]) : null, o ? new n.UICheckbox(e, {
                name: "target",
                ref: "target_checkbox",
                label: "Open in new tab"
              }) : null, i ? new n.UICheckbox(e, {
                name: "nofollow",
                ref: "nofollow_checkbox",
                label: "No follow"
              }) : null, new n.UIBlock(e, [new r.UIButton(e, {
                name: "unlink",
                variant: "default",
                text: "Unlink"
              }), new r.UIButton(e, {
                name: "insert",
                type: "submit",
                variant: "primary",
                text: "Insert"
              })], {
                align: "full"
              })]);
            };
          },
          11737: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.mediaFakeTag = "jodit-media", n.Config.prototype.mediaInFakeBlock = !0, n.Config.prototype.mediaBlocks = ["video", "audio"];
          },
          76303: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.media = void 0;
            var n = o(86893),
              r = o(76502),
              i = o(17332);
            function a(e) {
              var t = "jodit_fake_wrapper",
                o = e.options,
                i = o.mediaFakeTag,
                a = o.mediaBlocks;
              o.mediaInFakeBlock && e.e.on("afterGetValueFromEditor", function (e) {
                var o = new RegExp("<".concat(i, "[^>]+data-").concat(t, "[^>]+>([^]+?)</").concat(i, ">"), "ig");
                o.test(e.value) && (e.value = e.value.replace(o, "$1"));
              }).on("change afterInit afterSetMode changePlace", e.async.debounce(function () {
                e.isDestructed || e.getMode() === n.MODE_SOURCE || (0, r.$$)(a.join(","), e.editor).forEach(function (o) {
                  (0, r.dataBind)(o, t) || ((0, r.dataBind)(o, t, !0), function (o) {
                    var n;
                    if (o.parentNode && (0, r.attr)(o.parentNode, "data-jodit_iframe_wrapper")) o = o.parentNode;else {
                      var a = e.createInside.element(i, ((n = {
                        "data-jodit-temp": 1,
                        contenteditable: !1,
                        draggable: !0
                      })["data-".concat(t)] = 1, n));
                      (0, r.attr)(a, "style", (0, r.attr)(o, "style")), a.style.display = "inline-block" === o.style.display ? "inline-block" : "block", a.style.width = o.offsetWidth + "px", a.style.height = o.offsetHeight + "px", o.parentNode && o.parentNode.insertBefore(a, o), a.appendChild(o), o = a;
                    }
                    e.e.off(o, "mousedown.select touchstart.select").on(o, "mousedown.select touchstart.select", function () {
                      e.s.setCursorAfter(o);
                    });
                  }(o));
                });
              }, e.defaultTimeout));
            }
            o(11737), t.media = a, i.pluginSystem.add("media", a);
          },
          8860: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(86893),
              i = o(81438),
              a = o(40332),
              s = o(72719);
            n.Config.prototype.mobileTapTimeout = 300, n.Config.prototype.toolbarAdaptive = !0, n.Config.prototype.controls.dots = {
              mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
              popup: function (e, t, o, n, r) {
                var l = o.data;
                return void 0 === l && (l = {
                  toolbar: (0, i.makeCollection)(e),
                  rebuild: function () {
                    var t;
                    if (r) {
                      var o = e.e.fire("getDiffButtons.mobile", r.closest(s.ToolbarCollection));
                      if (o && l) {
                        l.toolbar.build((0, a.splitArray)(o));
                        var n = (null === (t = e.toolbar.firstButton) || void 0 === t ? void 0 : t.container.offsetWidth) || 36;
                        l.toolbar.container.style.width = 3 * (n + 4) + "px";
                      }
                    }
                  }
                }, o.data = l), l.rebuild(), l.toolbar;
              },
              tooltip: "Show all"
            };
          },
          19806: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.mobile = void 0;
            var n = o(40332),
              r = o(97642),
              i = o(17332);
            function a(e) {
              var t = 0,
                o = (0, n.splitArray)(e.o.buttons);
              e.o.mobileTapTimeout && e.e.on("touchend", function (o) {
                if (o.changedTouches && o.changedTouches.length) {
                  var n = new Date().getTime(),
                    r = n - t;
                  r > e.o.mobileTapTimeout && (t = n, 1.5 * e.o.mobileTapTimeout > r && e.s.insertCursorAtPoint(o.clientX, o.clientY));
                }
              }), e.e.on("getDiffButtons.mobile", function (t) {
                if (t === e.toolbar) {
                  var i = (0, r.flatButtonsSet)((0, n.splitArray)(e.o.buttons), e),
                    a = (0, r.flatButtonsSet)(o, e);
                  return (0, n.toArray)(i).reduce(function (e, t) {
                    return a.has(t) || e.push(t), e;
                  }, []);
                }
              }), e.o.toolbarAdaptive && e.e.on("resize afterInit recalcAdaptive changePlace afterAddPlace", function () {
                var t;
                if (e.o.toolbar) {
                  var r = (null !== (t = e.container.parentElement) && void 0 !== t ? t : e.container).offsetWidth,
                    i = (0, n.splitArray)(e.isFullSize || r >= e.o.sizeLG ? e.o.buttons : e.o.sizeMD > r ? e.o.sizeSM > r ? e.o.buttonsXS : e.o.buttonsSM : e.o.buttonsMD);
                  i.toString() !== o.toString() && (o = i, e.e.fire("closeAllPopups"), e.toolbar.setRemoveButtons(e.o.removeButtons).build(o.concat(e.o.extraButtons)));
                }
              }).on(e.ow, "load resize", function () {
                return e.e.fire("recalcAdaptive");
              });
            }
            o(8860), t.mobile = a, i.pluginSystem.add("mobile", a);
          },
          73013: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(63122),
              i = function (e, t, o) {
                var n,
                  i = o.control,
                  a = "button".concat(i.command),
                  s = null !== (n = i.args && i.args[0]) && void 0 !== n ? n : (0, r.dataBind)(e, a);
                (0, r.dataBind)(e, a, s), e.execCommand(i.command, !1, "default" === s ? null : s);
              };
            o(77904).Icon.set("ol", o(15476)).set("ul", o(59403)), n.Config.prototype.controls.ul = {
              command: "insertUnorderedList",
              tags: ["ul"],
              tooltip: "Insert Unordered List",
              list: {
                default: "Default",
                circle: "Circle",
                disc: "Dot",
                square: "Quadrate"
              },
              exec: i
            }, n.Config.prototype.controls.ol = {
              command: "insertOrderedList",
              tags: ["ol"],
              tooltip: "Insert Ordered List",
              list: {
                default: "Default",
                "lower-alpha": "Lower Alpha",
                "lower-greek": "Lower Greek",
                "lower-roman": "Lower Roman",
                "upper-alpha": "Upper Alpha",
                "upper-roman": "Upper Roman"
              },
              exec: i
            };
          },
          52598: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.orderedList = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(43441),
              a = o(17332);
            o(73013);
            var s = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "ul",
                  group: "list"
                }, {
                  name: "ol",
                  group: "list"
                }], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                e.registerCommand("insertUnorderedList", this.onCommand).registerCommand("insertOrderedList", this.onCommand);
              }, t.prototype.onCommand = function (e, t, o) {
                return this.jodit.s.applyStyle({
                  listStyleType: null != o ? o : null
                }, {
                  element: "insertunorderedlist" === e ? "ul" : "ol"
                }), this.jodit.synchronizeValues(), !1;
              }, t.prototype.beforeDestruct = function (e) {}, n.__decorate([i.autobind], t.prototype, "onCommand", null), t;
            }(r.Plugin);
            t.orderedList = s, a.pluginSystem.add("orderedList", s);
          },
          47470: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(86893);
            n.Config.prototype.askBeforePasteFromWord = !0, n.Config.prototype.processPasteFromWord = !0, n.Config.prototype.defaultActionOnPasteFromWord = null, n.Config.prototype.pasteFromWordActionList = [{
              value: r.INSERT_AS_HTML,
              text: "Keep"
            }, {
              value: r.INSERT_AS_TEXT,
              text: "Clean"
            }, {
              value: r.INSERT_ONLY_TEXT,
              text: "Insert only Text"
            }];
          },
          15428: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.pasteFromWord = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(40332),
              a = o(86893),
              s = o(43441),
              l = o(64280),
              c = o(17332);
            o(47470);
            var u = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.requires = ["paste"], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {}, t.prototype.beforeDestruct = function (e) {}, t.prototype.processWordHTML = function (e, t, o) {
                var n = this,
                  r = this.j,
                  a = r.o,
                  s = a.askBeforePasteFromWord,
                  c = a.defaultActionOnPasteFromWord,
                  u = a.defaultActionOnPaste,
                  d = a.pasteFromWordActionList;
                return !(!a.processPasteFromWord || !(0, i.isHtmlFromWord)(t) || (s ? (0, l.askInsertTypeDialog)(r, "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?", "Word Paste Detected", function (r) {
                  n.insertFromWordByType(e, t, r, o);
                }, d) : this.insertFromWordByType(e, t, c || u, o), 0));
              }, t.prototype.insertFromWordByType = function (e, t, o, n) {
                var r;
                switch (o) {
                  case a.INSERT_AS_HTML:
                    t = (0, i.applyStyles)(t);
                    var s = null === (r = this.j.events) || void 0 === r ? void 0 : r.fire("beautifyHTML", t);
                    (0, i.isString)(s) && (t = s);
                    break;
                  case a.INSERT_AS_TEXT:
                    t = (0, i.cleanFromWord)(t);
                    break;
                  case a.INSERT_ONLY_TEXT:
                    t = (0, i.stripTags)((0, i.cleanFromWord)(t));
                }
                (0, l.pasteInsertHtml)(e, this.j, t);
              }, n.__decorate([(0, s.watch)(":processHTML")], t.prototype, "processWordHTML", null), t;
            }(r.Plugin);
            t.pasteFromWord = u, c.pluginSystem.add("pasteFromWord", u);
          },
          47224: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.pasteStorage = void 0;
            var n = o(20255);
            o(71708);
            var r = o(86893),
              i = o(85605),
              a = o(24263),
              s = o(40332),
              l = o(96031),
              c = o(17332),
              u = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.currentIndex = 0, t.list = [], t.container = null, t.listBox = null, t.previewBox = null, t.dialog = null, t.paste = function () {
                    if (t.j.s.focus(), t.j.s.insertHTML(t.list[t.currentIndex]), 0 !== t.currentIndex) {
                      var e = t.list[0];
                      t.list[0] = t.list[t.currentIndex], t.list[t.currentIndex] = e;
                    }
                    t.dialog && t.dialog.close(), t.j.synchronizeValues(), t.j.e.fire("afterPaste");
                  }, t.onKeyDown = function (e) {
                    var o = t.currentIndex;
                    -1 !== [r.KEY_UP, r.KEY_DOWN, r.KEY_ENTER].indexOf(e.key) && (e.key === r.KEY_UP && (0 === o ? o = t.list.length - 1 : o -= 1), e.key === r.KEY_DOWN && (o === t.list.length - 1 ? o = 0 : o += 1), e.key !== r.KEY_ENTER ? (o !== t.currentIndex && t.selectIndex(o), e.stopImmediatePropagation(), e.preventDefault()) : t.paste());
                  }, t.selectIndex = function (e) {
                    t.listBox && (0, s.toArray)(t.listBox.childNodes).forEach(function (o, n) {
                      o.classList.remove("jodit_active"), e === n && t.previewBox && (o.classList.add("jodit_active"), t.previewBox.innerHTML = t.list[e], o.focus());
                    }), t.currentIndex = e;
                  }, t.showDialog = function () {
                    2 > t.list.length || (t.dialog || t.createDialog(), t.listBox && (t.listBox.innerHTML = ""), t.previewBox && (t.previewBox.innerHTML = ""), t.list.forEach(function (e, o) {
                      var n = t.j.c.element("a");
                      n.textContent = o + 1 + ". " + e.replace((0, r.SPACE_REG_EXP)(), ""), t.j.e.on(n, "keydown", t.onKeyDown), (0, s.attr)(n, "href", "#"), (0, s.attr)(n, "data-index", o.toString()), (0, s.attr)(n, "tab-index", "-1"), t.listBox && t.listBox.appendChild(n);
                    }), t.dialog && t.dialog.open(), t.j.async.setTimeout(function () {
                      t.selectIndex(0);
                    }, 100));
                  }, t;
                }
                return n.__extends(t, e), t.prototype.createDialog = function () {
                  var e = this;
                  this.dialog = this.j.dlg();
                  var t = (0, l.Button)(this.j, "paste", "Paste", "primary");
                  t.onAction(this.paste);
                  var o = (0, l.Button)(this.j, "", "Cancel");
                  o.onAction(this.dialog.close), this.container = this.j.c.div(), this.container.classList.add("jodit-paste-storage"), this.listBox = this.j.c.div(), this.previewBox = this.j.c.div(), this.container.appendChild(this.listBox), this.container.appendChild(this.previewBox), this.dialog.setHeader(this.j.i18n("Choose Content to Paste")), this.dialog.setContent(this.container), this.dialog.setFooter([t, o]), this.j.e.on(this.listBox, "click dblclick", function (t) {
                    var o = t.target;
                    return a.Dom.isTag(o, "a") && o.hasAttribute("data-index") && e.selectIndex(parseInt((0, s.attr)(o, "-index") || "0", 10)), "dblclick" === t.type && e.paste(), !1;
                  });
                }, t.prototype.afterInit = function () {
                  var e = this;
                  this.j.e.off("afterCopy.paste-storage").on("pasteStorageList.paste-storage", function () {
                    return e.list.length;
                  }).on("afterCopy.paste-storage", function (t) {
                    -1 !== e.list.indexOf(t) && e.list.splice(e.list.indexOf(t), 1), e.list.unshift(t), e.list.length > 5 && (e.list.length = 5);
                  }), this.j.registerCommand("showPasteStorage", {
                    exec: this.showDialog,
                    hotkeys: ["ctrl+shift+v", "cmd+shift+v"]
                  });
                }, t.prototype.beforeDestruct = function () {
                  this.dialog && this.dialog.destruct(), this.j.e.off(".paste-storage"), a.Dom.safeRemove(this.previewBox), a.Dom.safeRemove(this.listBox), a.Dom.safeRemove(this.container), this.container = null, this.listBox = null, this.previewBox = null, this.dialog = null, this.list = [];
                }, t;
              }(i.Plugin);
            t.pasteStorage = u, c.pluginSystem.add("pasteStorage", u);
          },
          24703: function (e, t, o) {

            var n;
            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = o(20255),
              i = o(86893),
              a = o(93166),
              s = o(64280);
            a.Config.prototype.askBeforePasteHTML = !0, a.Config.prototype.processPasteHTML = !0, a.Config.prototype.pasteHTMLActionList = [{
              value: i.INSERT_AS_HTML,
              text: "Keep"
            }, {
              value: i.INSERT_AS_TEXT,
              text: "Insert as Text"
            }, {
              value: i.INSERT_ONLY_TEXT,
              text: "Insert only Text"
            }], a.Config.prototype.memorizeChoiceWhenPasteFragment = !1, a.Config.prototype.nl2brInPlainText = !0;
            var l = "pasteStorage";
            a.Config.prototype.controls.paste = {
              tooltip: "Paste from clipboard",
              exec: function (e, t, o) {
                var n = o.control;
                return r.__awaiter(this, void 0, void 0, function () {
                  var t, o, a, c, u;
                  return r.__generator(this, function (r) {
                    switch (r.label) {
                      case 0:
                        if (n.name === l) return e.execCommand("showPasteStorage"), [2];
                        if (e.s.focus(), t = "", o = !0, !navigator.clipboard) return [3, 11];
                        r.label = 1;
                      case 1:
                        return r.trys.push([1, 6,, 7]), [4, navigator.clipboard.read()];
                      case 2:
                        return (a = r.sent()) && a.length ? [4, a[0].getType(i.TEXT_PLAIN)] : [3, 5];
                      case 3:
                        return c = r.sent(), [4, new Response(c).text()];
                      case 4:
                        t = r.sent(), r.label = 5;
                      case 5:
                        return o = !1, [3, 7];
                      case 6:
                        return r.sent(), [3, 7];
                      case 7:
                        if (!o) return [3, 11];
                        r.label = 8;
                      case 8:
                        return r.trys.push([8, 10,, 11]), [4, navigator.clipboard.readText()];
                      case 9:
                        return t = r.sent(), o = !1, [3, 11];
                      case 10:
                        return r.sent(), [3, 11];
                      case 11:
                        return o && (t = e.buffer.get(i.CLIPBOARD_ID) || "", o = 0 === t.length), u = e.value, o ? (e.ed.execCommand("paste"), !(o = u === e.value) && e.e.fire("afterPaste")) : t.length ? ((0, s.pasteInsertHtml)(null, e, t), e.e.fire("afterPaste")) : o && e.alert("Your browser doesn't support direct access to the clipboard.", function () {
                          e.s.focus();
                        }), [2];
                    }
                  });
                });
              },
              list: (n = {}, n[l] = "Paste Storage", n),
              isChildDisabled: function (e) {
                return 2 > e.e.fire("pasteStorageList");
              }
            };
          },
          64280: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.askInsertTypeDialog = t.getAllTypes = t.pasteInsertHtml = void 0;
            var n = o(20255),
              r = o(10172),
              i = o(24263),
              a = o(86893),
              s = o(96031);
            t.pasteInsertHtml = function (e, t, o) {
              if (!t.isInDestruct) {
                (function (e) {
                  return Boolean(e && "drop" === e.type);
                })(e) && t.s.insertCursorAtPoint(e.clientX, e.clientY);
                var n = t.e.fire("beforePasteInsert", o);
                !(0, r.isVoid)(n) && ((0, r.isString)(n) || (0, r.isNumber)(n) || i.Dom.isNode(n)) && (o = n), (0, r.isString)(o) && (o = function (e) {
                  var t = (e = e.replace(/<meta[^>]+?>/g, "")).search(/<!--StartFragment-->/i);
                  -1 !== t && (e = e.substring(t + 20));
                  var o = e.search(/<!--EndFragment-->/i);
                  return -1 !== o && (e = e.substring(0, o)), e;
                }(o)), t.s.insertHTML(o);
              }
            }, t.getAllTypes = function (e) {
              var t = e.types,
                o = "";
              if ((0, r.isArray)(t) || "[object DOMStringList]" === {}.toString.call(t)) for (var n = 0; t.length > n; n += 1) o += t[n] + ";";else o = (t || a.TEXT_PLAIN).toString() + ";";
              return o;
            }, t.askInsertTypeDialog = function (e, t, o, r, i) {
              if (!1 !== e.e.fire("beforeOpenPasteDialog", t, o, r, i)) {
                var a = e.confirm('<div style="word-break: normal; white-space: normal">'.concat(e.i18n(t), "</div>"), e.i18n(o)),
                  l = i.map(function (t) {
                    var o = t.text,
                      n = t.value;
                    return (0, s.Button)(e, {
                      text: o,
                      name: o.toLowerCase(),
                      tabIndex: 0
                    }).onAction(function () {
                      a.close(), r(n);
                    });
                  });
                a.e.one(a, "afterClose", function () {
                  e.s.isFocused() || e.s.focus();
                });
                var c = (0, s.Button)(e, {
                  text: "Cancel",
                  tabIndex: 0
                }).onAction(function () {
                  a.close();
                });
                return a.setFooter(n.__spreadArray(n.__spreadArray([], n.__read(l), !1), [c], !1)), l[0].focus(), l[0].state.variant = "primary", e.e.fire("afterOpenPasteDialog", a, t, o, r, i), a;
              }
            };
          },
          19483: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.paste = void 0;
            var n = o(20255),
              r = o(85605),
              i = o(86893),
              a = o(24263),
              s = o(43441),
              l = o(40332),
              c = o(17332),
              u = o(64280);
            o(24703);
            var d = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.pasteStack = new l.LimitedStack(20), t._isDialogOpened = !1, t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.e.on("paste.paste", this.onPaste).on("pasteStack.paste", function (e) {
                  return t.pasteStack.push(e);
                }), e.o.nl2brInPlainText && this.j.e.on("processPaste.paste", this.onProcessPasteReplaceNl2Br);
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off("paste.paste", this.onPaste).off("processPaste.paste", this.onProcessPasteReplaceNl2Br).off(".paste");
              }, t.prototype.onPaste = function (e) {
                try {
                  if (!1 === this.customPasteProcess(e) || !1 === this.j.e.fire("beforePaste", e)) return e.preventDefault(), !1;
                  this.defaultPasteProcess(e);
                } finally {
                  this.j.e.fire("afterPaste", e);
                }
              }, t.prototype.customPasteProcess = function (e) {
                if (this.j.o.processPasteHTML) {
                  var t,
                    o = (0, l.getDataTransfer)(e),
                    n = {
                      html: null == o ? void 0 : o.getData(i.TEXT_HTML),
                      plain: null == o ? void 0 : o.getData(i.TEXT_PLAIN),
                      rtf: null == o ? void 0 : o.getData(i.TEXT_RTF)
                    };
                  for (t in n) {
                    var r = n[t];
                    if ((0, l.isHTML)(r) && (this.j.e.fire("processHTML", e, r, n) || this.processHTML(e, r))) return !1;
                  }
                }
              }, t.prototype.defaultPasteProcess = function (e) {
                var t = (0, l.getDataTransfer)(e),
                  o = (null == t ? void 0 : t.getData(i.TEXT_HTML)) || (null == t ? void 0 : t.getData(i.TEXT_PLAIN));
                if (t && o && "" !== (0, l.trim)(o)) {
                  var n = this.j.e.fire("processPaste", e, o, (0, u.getAllTypes)(t));
                  void 0 !== n && (o = n), ((0, l.isString)(o) || a.Dom.isNode(o)) && this.insertByType(e, o, this.j.o.defaultActionOnPaste), e.preventDefault(), e.stopPropagation();
                }
              }, t.prototype.processHTML = function (e, t) {
                var o = this;
                if (this.j.o.askBeforePasteHTML) {
                  if (this.j.o.memorizeChoiceWhenPasteFragment) {
                    var n = this.pasteStack.find(function (e) {
                      return e.html === t;
                    });
                    if (n) return this.insertByType(e, t, n.action || this.j.o.defaultActionOnPaste), !0;
                  }
                  if (this._isDialogOpened) return !0;
                  var r = (0, u.askInsertTypeDialog)(this.j, "Your code is similar to HTML. Keep as HTML?", "Paste as HTML", function (n) {
                    o._isDialogOpened = !1, o.insertByType(e, t, n);
                  }, this.j.o.pasteHTMLActionList);
                  return r && (this._isDialogOpened = !0, r.e.on("beforeClose", function () {
                    o._isDialogOpened = !1;
                  })), !0;
                }
                return !1;
              }, t.prototype.insertByType = function (e, t, o) {
                if (this.pasteStack.push({
                  html: t,
                  action: o
                }), (0, l.isString)(t)) switch (this.j.buffer.set(i.CLIPBOARD_ID, t), o) {
                  case i.INSERT_CLEAR_HTML:
                    t = (0, l.cleanFromWord)(t);
                    break;
                  case i.INSERT_ONLY_TEXT:
                    t = (0, l.stripTags)(t);
                    break;
                  case i.INSERT_AS_TEXT:
                    t = (0, l.htmlspecialchars)(t);
                }
                (0, u.pasteInsertHtml)(e, this.j, t);
              }, t.prototype.onProcessPasteReplaceNl2Br = function (e, t, o) {
                if (o === i.TEXT_PLAIN + ";" && !(0, l.isHTML)(t)) return (0, l.nl2br)(t);
              }, n.__decorate([s.autobind], t.prototype, "onPaste", null), n.__decorate([s.autobind], t.prototype, "onProcessPasteReplaceNl2Br", null), t;
            }(r.Plugin);
            t.paste = d, c.pluginSystem.add("paste", d);
          },
          76952: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.showPlaceholder = !0, n.Config.prototype.placeholder = "Type something", n.Config.prototype.useInputsPlaceholder = !0;
          },
          83211: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.placeholder = t.isEditorEmpty = void 0;
            var n = o(20255);
            o(51629);
            var r = o(86893),
              i = o(67309),
              a = o(26911),
              s = o(37204),
              l = o(24263),
              c = o(85605),
              u = o(86893),
              d = o(43441),
              p = o(17332);
            function f(e) {
              var t;
              if (!e.firstChild) return !0;
              var o = e.firstChild;
              if (u.INSEPARABLE_TAGS.has(null === (t = o.nodeName) || void 0 === t ? void 0 : t.toLowerCase()) || /^(TABLE)$/i.test(o.nodeName)) return !1;
              var n = l.Dom.next(o, function (e) {
                return e && !l.Dom.isEmptyTextNode(e);
              }, e);
              return l.Dom.isText(o) && !n ? l.Dom.isEmptyTextNode(o) : !n && l.Dom.each(o, function (e) {
                return !l.Dom.isTag(e, ["ul", "li", "ol"]) && (l.Dom.isEmpty(e) || l.Dom.isTag(e, "br"));
              });
            }
            o(76952), t.isEditorEmpty = f;
            var h = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.addNativeListeners = function () {
                  t.j.e.off(t.j.editor, "input.placeholder keydown.placeholder").on(t.j.editor, "input.placeholder keydown.placeholder", t.toggle);
                }, t.addEvents = function () {
                  var e = t.j;
                  e.o.useInputsPlaceholder && e.element.hasAttribute("placeholder") && (t.placeholderElm.innerHTML = (0, i.attr)(e.element, "placeholder") || ""), e.e.fire("placeholder", t.placeholderElm.innerHTML), e.e.off(".placeholder").on("changePlace.placeholder", t.addNativeListeners).on("change.placeholder focus.placeholder keyup.placeholder mouseup.placeholder keydown.placeholder mousedown.placeholder afterSetMode.placeholder changePlace.placeholder", t.toggle).on(window, "load", t.toggle), t.addNativeListeners(), t.toggle();
                }, t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.o.showPlaceholder && (this.placeholderElm = e.c.fromHTML('<span data-ref="placeholder" style="display: none;" class="jodit-placeholder">'.concat(e.i18n(e.o.placeholder), "</span>")), "rtl" === e.o.direction && (this.placeholderElm.style.right = "0px", this.placeholderElm.style.direction = "rtl"), e.e.on("readonly", function (e) {
                  e ? t.hide() : t.toggle();
                }).on("changePlace", this.addEvents), this.addEvents());
              }, t.prototype.show = function () {
                var e = this.j;
                if (!e.o.readonly) {
                  var t = 0,
                    o = 0,
                    n = e.s.current(),
                    r = n && l.Dom.closest(n, l.Dom.isBlock, e.editor) || e.editor,
                    i = e.ew.getComputedStyle(r),
                    c = e.ew.getComputedStyle(e.editor);
                  e.workplace.appendChild(this.placeholderElm);
                  var u = e.editor.firstChild;
                  if (l.Dom.isElement(u) && !(0, s.isMarker)(u)) {
                    var d = e.ew.getComputedStyle(u);
                    t = parseInt(d.getPropertyValue("margin-top"), 10), o = parseInt(d.getPropertyValue("margin-left"), 10), this.placeholderElm.style.fontSize = parseInt(d.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = d.getPropertyValue("line-height");
                  } else this.placeholderElm.style.fontSize = parseInt(i.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = i.getPropertyValue("line-height");
                  (0, a.css)(this.placeholderElm, {
                    display: "block",
                    textAlign: i.getPropertyValue("text-align"),
                    paddingTop: parseInt(c.paddingTop, 10) + "px",
                    paddingLeft: parseInt(c.paddingLeft, 10) + "px",
                    paddingRight: parseInt(c.paddingRight, 10) + "px",
                    marginTop: Math.max(parseInt(i.getPropertyValue("margin-top"), 10), t),
                    marginLeft: Math.max(parseInt(i.getPropertyValue("margin-left"), 10), o)
                  });
                }
              }, t.prototype.hide = function () {
                l.Dom.safeRemove(this.placeholderElm);
              }, t.prototype.toggle = function () {
                var e = this.j;
                e.editor && !e.isInDestruct && (e.getRealMode() === r.MODE_WYSIWYG && f(e.editor) ? this.show() : this.hide());
              }, t.prototype.beforeDestruct = function (e) {
                this.hide(), e.e.off(".placeholder").off(window, "load", this.toggle);
              }, n.__decorate([(0, d.debounce)(function (e) {
                return e.defaultTimeout / 10;
              }, !0)], t.prototype, "toggle", null), t;
            }(c.Plugin);
            t.placeholder = h, p.pluginSystem.add("placeholder", h);
          },
          88297: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.poweredByJodit = void 0;
            var n = o(17332);
            function r(e) {
              var t = e.o;
              t.hidePoweredByJodit || t.inline || !(t.showCharsCounter || t.showWordsCounter || t.showXPathInStatusbar) || e.hookStatus("ready", function () {
                e.statusbar.append(e.create.fromHTML('<a\n\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\tstyle="text-transform: uppercase"\n\t\t\t\t\t\tclass="jodit-status-bar-link"\n\t\t\t\t\t\ttarget="_blank"\n\t\t\t\t\t\thref="https://xdsoft.net/jodit/">\n\t\t\t\t\t\t\tPowered by Jodit\n\t\t\t\t\t\t</a>'), !0);
              });
            }
            t.poweredByJodit = r, n.pluginSystem.add("poweredByJodit", r);
          },
          72930: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.preview = void 0, o(54860);
            var n = o(93166),
              r = o(86893),
              i = o(21498),
              a = o(17332);
            function s(e) {
              e.registerButton({
                name: "preview"
              }), e.registerCommand("preview", function (t, o, n) {
                var r = e.dlg();
                r.setSize(1024, 600).open("", e.i18n("Preview")).setModal(!0), (0, i.previewBox)(e, n, "px", r.getElm("content"));
              });
            }
            n.Config.prototype.controls.preview = {
              icon: "eye",
              command: "preview",
              mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
              tooltip: "Preview"
            }, t.preview = s, a.pluginSystem.add("preview", s);
          },
          20137: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.generateCriticalCSS = void 0;
            var n = o(20255),
              r = o(1853);
            t.generateCriticalCSS = function (e) {
              var t = function (e, t) {
                  return void 0 === t && (t = e.ownerDocument.styleSheets), (0, r.toArray)(t).map(function (e) {
                    try {
                      return (0, r.toArray)(e.cssRules);
                    } catch (e) {}
                    return [];
                  }).flat().filter(function (t) {
                    try {
                      return Boolean(t && e.matches(t.selectorText));
                    } catch (e) {}
                    return !1;
                  });
                },
                o = function () {
                  function o(o, r, i) {
                    var a = this;
                    this.css = {};
                    var s = i || {},
                      l = function (t) {
                        var o = t.selectorText.split(",").map(function (e) {
                          return e.trim();
                        }).sort().join(",");
                        !1 === Boolean(a.css[o]) && (a.css[o] = {});
                        for (var r = t.style.cssText.split(/;(?![A-Za-z0-9])/), i = 0; r.length > i; i++) if (r[i]) {
                          var s = r[i].split(":");
                          s[0] = s[0].trim(), s[1] = s[1].trim(), a.css[o][s[0]] = s[1].replace(/var\(([^)]+)\)/g, function (t, o) {
                            var r = n.__read(o.split(","), 2),
                              i = r[0],
                              a = r[1];
                            return (e.ew.getComputedStyle(e.editor).getPropertyValue(i.trim()) || a || t).trim();
                          });
                        }
                      };
                    !function () {
                      for (var n = o.innerHeight, i = r.createTreeWalker(e.editor, NodeFilter.SHOW_ELEMENT, function () {
                          return NodeFilter.FILTER_ACCEPT;
                        }); i.nextNode();) {
                        var a = i.currentNode;
                        if (n > a.getBoundingClientRect().top || s.scanFullPage) {
                          var c = t(a);
                          if (c) for (var u = 0; c.length > u; u++) l(c[u]);
                        }
                      }
                    }();
                  }
                  return o.prototype.generateCSS = function () {
                    var e = "";
                    for (var t in this.css) if (!/:not\(/.test(t)) {
                      for (var o in e += t + " { ", this.css[t]) e += o + ": " + this.css[t][o] + "; ";
                      e += "}\n";
                    }
                    return e;
                  }, o;
                }();
              try {
                return new o(e.ew, e.ed, {
                  scanFullPage: !0
                }).generateCSS();
              } catch (e) {}
              return "";
            };
          },
          51197: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.print = void 0;
            var n = o(93166),
              r = o(17332),
              i = o(64968),
              a = o(93351),
              s = o(86893),
              l = o(17332),
              c = o(77904),
              u = o(20137),
              d = o(21498);
            function p(e) {
              e.registerButton({
                name: "print"
              });
            }
            c.Icon.set("print", o(22860)), n.Config.prototype.controls.print = {
              exec: function (e) {
                var t = e.create.element("iframe");
                Object.assign(t.style, {
                  position: "fixed",
                  right: 0,
                  bottom: 0,
                  width: 0,
                  height: 0,
                  border: 0
                }), (0, r.getContainer)(e, n.Config).appendChild(t);
                var o = function () {
                    e.e.off(e.ow, "mousemove", o), i.Dom.safeRemove(t);
                  },
                  s = t.contentWindow;
                if (s) {
                  e.e.on(s, "onbeforeunload onafterprint", o).on(e.ow, "mousemove", o), e.o.iframe ? (e.e.fire("generateDocumentStructure.iframe", s.document, e), s.document.body.innerHTML = e.value) : (s.document.write('<!doctype html><html lang="' + (0, a.defaultLanguage)(e.o.language) + '"><head><title></title></head><style>' + (0, u.generateCriticalCSS)(e) + "</style><body></body></html>"), s.document.close(), (0, d.previewBox)(e, void 0, "px", s.document.body));
                  var l = s.document.createElement("style");
                  l.innerHTML = "@media print {\n\t\t\t\t\tbody {\n\t\t\t\t\t\t\t-webkit-print-color-adjust: exact;\n\t\t\t\t\t}\n\t\t\t}", s.document.head.appendChild(l), s.focus(), s.print();
                }
              },
              mode: s.MODE_SOURCE + s.MODE_WYSIWYG,
              tooltip: "Print"
            }, t.print = p, l.pluginSystem.add("print", p);
          },
          2327: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.redoUndo = void 0;
            var n = o(20255),
              r = o(93166),
              i = o(86893),
              a = o(85605),
              s = o(17332);
            o(77904).Icon.set("redo", o(95600)).set("undo", o(76214)), r.Config.prototype.controls.redo = {
              mode: i.MODE_SPLIT,
              isDisabled: function (e) {
                return !e.history.canRedo();
              },
              tooltip: "Redo"
            }, r.Config.prototype.controls.undo = {
              mode: i.MODE_SPLIT,
              isDisabled: function (e) {
                return !e.history.canUndo();
              },
              tooltip: "Undo"
            };
            var l = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "undo",
                  group: "history"
                }, {
                  name: "redo",
                  group: "history"
                }], t;
              }
              return n.__extends(t, e), t.prototype.beforeDestruct = function () {}, t.prototype.afterInit = function (e) {
                var t = function (t) {
                  return e.history[t](), !1;
                };
                e.registerCommand("redo", {
                  exec: t,
                  hotkeys: ["ctrl+y", "ctrl+shift+z", "cmd+y", "cmd+shift+z"]
                }), e.registerCommand("undo", {
                  exec: t,
                  hotkeys: ["ctrl+z", "cmd+z"]
                });
              }, t;
            }(a.Plugin);
            t.redoUndo = l, s.pluginSystem.add("redoUndo", l);
          },
          52444: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.tableAllowCellResize = !0;
          },
          47608: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.resizeCells = void 0;
            var n = o(20255);
            o(47818);
            var r = o(86893),
              i = o(87837),
              a = o(40332),
              s = o(43441),
              l = o(24263),
              c = o(17332);
            o(52444);
            var u = "table_processor_observer-resize",
              d = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.selectMode = !1, t.resizeDelta = 0, t.createResizeHandle = function () {
                    t.resizeHandler || (t.resizeHandler = t.j.c.div("jodit-table-resizer"), t.j.e.on(t.resizeHandler, "mousedown.table touchstart.table", t.onHandleMouseDown).on(t.resizeHandler, "mouseenter.table", function () {
                      t.j.async.clearTimeout(t.hideTimeout);
                    }));
                  }, t.hideTimeout = 0, t.drag = !1, t.minX = 0, t.maxX = 0, t.startX = 0, t;
                }
                return n.__extends(t, e), Object.defineProperty(t.prototype, "module", {
                  get: function () {
                    return this.j.getInstance("Table", this.j.o);
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "isRTL", {
                  get: function () {
                    return "rtl" === this.j.o.direction;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.showResizeHandle = function () {
                  this.j.async.clearTimeout(this.hideTimeout), this.j.workplace.appendChild(this.resizeHandler);
                }, t.prototype.hideResizeHandle = function () {
                  var e = this;
                  this.hideTimeout = this.j.async.setTimeout(function () {
                    l.Dom.safeRemove(e.resizeHandler);
                  }, {
                    timeout: this.j.defaultTimeout,
                    label: "hideResizer"
                  });
                }, t.prototype.onHandleMouseDown = function (e) {
                  var t = this;
                  if (!this.j.isLocked) {
                    this.drag = !0, this.j.e.on(this.j.ow, "mouseup.resize-cells touchend.resize-cells", this.onMouseUp).on(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.startX = e.clientX, this.j.lock(u), this.resizeHandler.classList.add("jodit-table-resizer_moved");
                    var o,
                      n = this.workTable.getBoundingClientRect();
                    if (this.minX = 0, this.maxX = 1e6, null != this.wholeTable) n = this.workTable.parentNode.getBoundingClientRect(), this.minX = n.left, this.maxX = this.minX + n.width;else {
                      var a = i.Table.formalCoordinate(this.workTable, this.workCell, !0);
                      i.Table.formalMatrix(this.workTable, function (e, n, i) {
                        a[1] === i && (o = e.getBoundingClientRect(), t.minX = Math.max(o.left + r.NEARBY / 2, t.minX)), a[1] + (t.isRTL ? -1 : 1) === i && (o = e.getBoundingClientRect(), t.maxX = Math.min(o.left + o.width - r.NEARBY / 2, t.maxX));
                      });
                    }
                    return !1;
                  }
                }, t.prototype.onMouseMove = function (e) {
                  if (this.drag) {
                    this.j.e.fire("closeAllPopups");
                    var t = e.clientX,
                      o = (0, a.offset)(this.resizeHandler.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                    this.minX > t && (t = this.minX), t > this.maxX && (t = this.maxX), this.resizeDelta = t - this.startX + (this.j.o.iframe ? o.left : 0), this.resizeHandler.style.left = t - (this.j.o.iframe ? 0 : o.left) + "px";
                    var n = this.j.s.sel;
                    n && n.removeAllRanges();
                  }
                }, t.prototype.onMouseUp = function (e) {
                  (this.selectMode || this.drag) && (this.selectMode = !1, this.j.unlock()), this.resizeHandler && this.drag && (this.drag = !1, this.j.e.off(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.resizeHandler.classList.remove("jodit-table-resizer_moved"), this.startX !== e.clientX && (null == this.wholeTable ? this.resizeColumns() : this.resizeTable()), this.j.synchronizeValues(), this.j.s.focus());
                }, t.prototype.resizeColumns = function () {
                  var e = this.resizeDelta,
                    t = [];
                  i.Table.setColumnWidthByDelta(this.workTable, i.Table.formalCoordinate(this.workTable, this.workCell, !0)[1], e, !0, t);
                  var o = (0, a.call)(this.isRTL ? l.Dom.prev : l.Dom.next, this.workCell, l.Dom.isCell, this.workCell.parentNode);
                  i.Table.setColumnWidthByDelta(this.workTable, i.Table.formalCoordinate(this.workTable, o)[1], -e, !1, t);
                }, t.prototype.resizeTable = function () {
                  var e = this.resizeDelta * (this.isRTL ? -1 : 1),
                    t = this.workTable.offsetWidth,
                    o = (0, a.getContentWidth)(this.workTable.parentNode, this.j.ew),
                    n = !this.wholeTable;
                  if (this.isRTL ? !n : n) this.workTable.style.width = (t + e) / o * 100 + "%";else {
                    var r = this.isRTL ? "marginRight" : "marginLeft",
                      i = parseInt(this.j.ew.getComputedStyle(this.workTable)[r] || "0", 10);
                    this.workTable.style.width = (t - e) / o * 100 + "%", this.workTable.style[r] = (i + e) / o * 100 + "%";
                  }
                }, t.prototype.setWorkCell = function (e, t) {
                  void 0 === t && (t = null), this.wholeTable = t, this.workCell = e, this.workTable = l.Dom.up(e, function (e) {
                    return l.Dom.isTag(e, "table");
                  }, this.j.editor);
                }, t.prototype.calcHandlePosition = function (e, t, o, n) {
                  void 0 === o && (o = 0), void 0 === n && (n = 0);
                  var i = (0, a.offset)(t, this.j, this.j.ed);
                  if (o > r.NEARBY && i.width - r.NEARBY > o) this.hideResizeHandle();else {
                    var s = (0, a.offset)(this.j.workplace, this.j, this.j.od, !0),
                      c = (0, a.offset)(e, this.j, this.j.ed);
                    if (this.resizeHandler.style.left = (o > r.NEARBY ? i.left + i.width : i.left) - s.left + n + "px", Object.assign(this.resizeHandler.style, {
                      height: c.height + "px",
                      top: c.top - s.top + "px"
                    }), this.showResizeHandle(), o > r.NEARBY) {
                      var u = (0, a.call)(this.isRTL ? l.Dom.prev : l.Dom.next, t, l.Dom.isCell, t.parentNode);
                      this.setWorkCell(t, !!u && null);
                    } else {
                      var d = (0, a.call)(this.isRTL ? l.Dom.next : l.Dom.prev, t, l.Dom.isCell, t.parentNode);
                      this.setWorkCell(d || t, !d || null);
                    }
                  }
                }, t.prototype.afterInit = function (e) {
                  var t = this;
                  e.o.tableAllowCellResize && e.e.off(this.j.ow, ".resize-cells").off(".resize-cells").on("change.resize-cells afterCommand.resize-cells afterSetMode.resize-cells", function () {
                    (0, a.$$)("table", e.editor).forEach(t.observe);
                  }).on(this.j.ow, "scroll.resize-cells", function () {
                    if (t.drag) {
                      var o = l.Dom.up(t.workCell, function (e) {
                        return l.Dom.isTag(e, "table");
                      }, e.editor);
                      if (o) {
                        var n = o.getBoundingClientRect();
                        t.resizeHandler.style.top = n.top + "px";
                      }
                    }
                  }).on("beforeSetMode.resize-cells", function () {
                    t.module.getAllSelectedCells().forEach(function (o) {
                      t.module.removeSelection(o), i.Table.normalizeTable(l.Dom.closest(o, "table", e.editor));
                    });
                  });
                }, t.prototype.observe = function (e) {
                  var t = this;
                  (0, a.dataBind)(e, u) || ((0, a.dataBind)(e, u, !0), this.j.e.on(e, "mouseleave.resize-cells", function (e) {
                    t.resizeHandler && t.resizeHandler !== e.relatedTarget && t.hideResizeHandle();
                  }).on(e, "mousemove.resize-cells touchmove.resize-cells", this.j.async.throttle(function (o) {
                    if (!t.j.isLocked) {
                      var n = l.Dom.up(o.target, l.Dom.isCell, e);
                      n && t.calcHandlePosition(e, n, o.offsetX);
                    }
                  }, {
                    timeout: this.j.defaultTimeout
                  })), this.createResizeHandle());
                }, t.prototype.beforeDestruct = function (e) {
                  e.events && (e.e.off(this.j.ow, ".resize-cells"), e.e.off(".resize-cells"));
                }, n.__decorate([s.autobind], t.prototype, "onHandleMouseDown", null), n.__decorate([s.autobind], t.prototype, "onMouseMove", null), n.__decorate([s.autobind], t.prototype, "onMouseUp", null), n.__decorate([s.autobind], t.prototype, "observe", null), t;
              }(i.Plugin);
            t.resizeCells = d, c.pluginSystem.add("resizeCells", d);
          },
          91637: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.allowResizeX = !1, n.Config.prototype.allowResizeY = !0;
          },
          90523: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.resizeHandler = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(64968),
              a = o(43441),
              s = o(2074),
              l = o(17332);
            o(91637);
            var c = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.isResized = !1, t.start = {
                  x: 0,
                  y: 0,
                  w: 0,
                  h: 0
                }, t.handle = t.j.c.div("jodit-editor__resize", s.Icon.get("resize_handler")), t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this,
                  o = e.o,
                  n = o.height,
                  r = o.width,
                  i = e.o.allowResizeY;
                "auto" === n && "auto" !== r && (i = !1), "auto" === n && "auto" === r || !o.allowResizeX && !i || (e.statusbar.setMod("resize-handle", !0), e.e.on("toggleFullSize.resizeHandler", function () {
                  t.handle.style.display = e.isFullSize ? "none" : "block";
                }).on(this.handle, "mousedown touchstart", this.onHandleResizeStart).on(e.ow, "mouseup touchend", this.onHandleResizeEnd), e.container.appendChild(this.handle));
              }, t.prototype.onHandleResizeStart = function (e) {
                this.isResized = !0, this.start.x = e.clientX, this.start.y = e.clientY, this.start.w = this.j.container.offsetWidth, this.start.h = this.j.container.offsetHeight, this.j.lock(), this.j.e.on(this.j.ow, "mousemove touchmove", this.onHandleResize), e.preventDefault();
              }, t.prototype.onHandleResize = function (e) {
                this.isResized && (this.j.o.allowResizeY && this.j.e.fire("setHeight", this.start.h + e.clientY - this.start.y), this.j.o.allowResizeX && this.j.e.fire("setWidth", this.start.w + e.clientX - this.start.x), this.j.e.fire("resize"));
              }, t.prototype.onHandleResizeEnd = function () {
                this.isResized && (this.isResized = !1, this.j.e.off(this.j.ow, "mousemove touchmove", this.onHandleResize), this.j.unlock());
              }, t.prototype.beforeDestruct = function () {
                i.Dom.safeRemove(this.handle), this.j.e.off(this.j.ow, "mouseup touchsend", this.onHandleResizeEnd);
              }, t.requires = ["size"], n.__decorate([a.autobind], t);
            }(r.Plugin);
            t.resizeHandler = c, l.pluginSystem.add("resizeHandler", c);
          },
          36560: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.allowResizeTags = ["img", "iframe", "table", "jodit"], n.Config.prototype.resizer = {
              showSize: !0,
              hideSizeTimeout: 1e3,
              forImageChangeAttributes: !0,
              min_width: 10,
              min_height: 10,
              useAspectRatio: ["img"]
            };
          },
          69257: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.resizer = void 0;
            var n = o(20255);
            o(6316);
            var r = o(86893),
              i = o(86893),
              a = o(24263),
              s = o(40332),
              l = o(85605),
              c = o(17332),
              u = o(43441),
              d = o(17332);
            o(36560);
            var p = "__jodit-resizer_binded",
              f = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.LOCK_KEY = "resizer", t.element = null, t.isResizeMode = !1, t.isShown = !1, t.startX = 0, t.startY = 0, t.width = 0, t.height = 0, t.ratio = 0, t.rect = t.j.c.fromHTML('<div title="'.concat(t.j.i18n("Press Alt for custom resizing"), '" class="jodit-resizer">\n\t\t\t\t<div class="jodit-resizer__top-left"></div>\n\t\t\t\t<div class="jodit-resizer__top-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-left"></div>\n\t\t\t\t<span>100x100</span>\n\t\t\t</div>')), t.sizeViewer = t.rect.getElementsByTagName("span")[0], t.pointerX = 0, t.pointerY = 0, t.isAltMode = !1, t.onClickElement = function (e) {
                    t.isResizeMode || t.element === e && t.isShown || (t.element = e, t.show(), a.Dom.isTag(t.element, "img") && !t.element.complete && t.j.e.one(t.element, "load", t.updateSize));
                  }, t.updateSize = function () {
                    if (!t.isInDestruct && t.isShown && t.element && t.rect) {
                      var e = t.getWorkplacePosition(),
                        o = (0, s.offset)(t.element, t.j, t.j.ed),
                        n = parseInt(t.rect.style.left || "0", 10),
                        r = parseInt(t.rect.style.top || "0", 10),
                        i = o.top - e.top,
                        a = o.left - e.left;
                      r === i && n === a && t.rect.offsetWidth === t.element.offsetWidth && t.rect.offsetHeight === t.element.offsetHeight || ((0, s.css)(t.rect, {
                        top: i,
                        left: a,
                        width: t.element.offsetWidth,
                        height: t.element.offsetHeight
                      }), t.j.events && (t.j.e.fire(t.element, "changesize"), isNaN(n) || t.j.e.fire("resize")));
                    }
                  }, t.hideSizeViewer = function () {
                    t.sizeViewer.style.opacity = "0";
                  }, t;
                }
                return n.__extends(t, e), t.prototype.afterInit = function (e) {
                  var t = this;
                  (0, s.$$)("div", this.rect).forEach(function (o) {
                    e.e.on(o, "mousedown.resizer touchstart.resizer", t.onStartResizing.bind(t, o));
                  }), c.eventEmitter.on("hideHelpers", this.hide), e.e.on("readonly", function (e) {
                    e && t.hide();
                  }).on("afterInit changePlace", this.addEventListeners.bind(this)).on("afterGetValueFromEditor.resizer", function (e) {
                    var t = /<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/jodit>/gi;
                    t.test(e.value) && (e.value = e.value.replace(t, "$1"));
                  }).on("hideResizer", this.hide).on("change afterInit afterSetMode", this.onChangeEditor), this.addEventListeners(), this.onChangeEditor();
                }, t.prototype.onEditorClick = function (e) {
                  for (var t = e.target, o = this.j, n = o.editor, r = o.options.allowResizeTags; t && t !== n;) {
                    if (a.Dom.isTag(t, r)) return this.bind(t), void this.onClickElement(t);
                    t = t.parentNode;
                  }
                }, t.prototype.addEventListeners = function () {
                  var e = this,
                    t = this.j;
                  t.e.off(t.editor, ".resizer").off(t.ow, ".resizer").on(t.editor, "keydown.resizer", function (t) {
                    e.isShown && t.key === r.KEY_DELETE && e.element && !a.Dom.isTag(e.element, "table") && e.onDelete(t);
                  }).on(t.ow, "resize.resizer", this.updateSize).on("resize.resizer", this.updateSize).on([t.ow, t.editor], "scroll.resizer", function () {
                    e.isShown && !e.isResizeMode && e.hide();
                  }).on(t.ow, "keydown.resizer", this.onKeyDown).on(t.ow, "keyup.resizer", this.onKeyUp).on(t.ow, "mouseup.resizer touchend.resizer", this.onClickOutside);
                }, t.prototype.onStartResizing = function (e, t) {
                  if (!this.element || !this.element.parentNode) return this.hide(), !1;
                  this.handle = e, t.cancelable && t.preventDefault(), t.stopImmediatePropagation(), this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.isResizeMode = !0, this.startX = t.clientX, this.startY = t.clientY, this.pointerX = t.clientX, this.pointerY = t.clientY;
                  var o = this.j;
                  o.e.fire("hidePopup"), o.lock(this.LOCK_KEY), o.e.on(o.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                }, t.prototype.onEndResizing = function () {
                  var e = this.j;
                  e.unlock(), this.isResizeMode = !1, this.isAltMode = !1, e.synchronizeValues(), e.e.off(e.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                }, t.prototype.onResize = function (e) {
                  if (this.isResizeMode) {
                    if (!this.element) return;
                    this.pointerX = e.clientX, this.pointerY = e.clientY;
                    var t = void 0,
                      o = void 0;
                    if (this.j.options.iframe) {
                      var n = this.getWorkplacePosition();
                      t = e.clientX + n.left - this.startX, o = e.clientY + n.top - this.startY;
                    } else t = this.pointerX - this.startX, o = this.pointerY - this.startY;
                    var r = this.handle.className,
                      i = 0,
                      l = 0,
                      c = this.j.o.resizer.useAspectRatio;
                    !this.isAltMode && (!0 === c || Array.isArray(c) && a.Dom.isTag(this.element, c)) ? (t ? (i = this.width + (r.match(/left/) ? -1 : 1) * t, l = Math.round(i / this.ratio)) : (l = this.height + (r.match(/top/) ? -1 : 1) * o, i = Math.round(l * this.ratio)), i > (0, s.innerWidth)(this.j.editor, this.j.ow) && (i = (0, s.innerWidth)(this.j.editor, this.j.ow), l = Math.round(i / this.ratio))) : (i = this.width + (r.match(/left/) ? -1 : 1) * t, l = this.height + (r.match(/top/) ? -1 : 1) * o), i > this.j.o.resizer.min_width && this.applySize(this.element, "width", this.rect.parentNode.offsetWidth > i ? i : "100%"), l > this.j.o.resizer.min_height && this.applySize(this.element, "height", l), this.updateSize(), this.showSizeViewer(this.element.offsetWidth, this.element.offsetHeight), e.stopImmediatePropagation();
                  }
                }, t.prototype.onKeyDown = function (e) {
                  this.isAltMode = e.key === i.KEY_ALT, !this.isAltMode && this.isResizeMode && this.onEndResizing();
                }, t.prototype.onKeyUp = function () {
                  this.isAltMode && this.isResizeMode && this.element && (this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.startX = this.pointerX, this.startY = this.pointerY), this.isAltMode = !1;
                }, t.prototype.onClickOutside = function (e) {
                  if (this.isShown) {
                    if (!this.isResizeMode) return this.hide();
                    e.stopImmediatePropagation(), this.onEndResizing();
                  }
                }, t.prototype.getWorkplacePosition = function () {
                  return (0, s.offset)(this.rect.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                }, t.prototype.applySize = function (e, t, o) {
                  var n = a.Dom.isImage(e) && this.j.o.resizer.forImageChangeAttributes;
                  n && (0, s.attr)(e, t, o), n && !e.style[t] || (0, s.css)(e, t, o);
                }, t.prototype.onDelete = function (e) {
                  this.element && ("JODIT" !== this.element.tagName ? this.j.s.select(this.element) : (a.Dom.safeRemove(this.element), this.hide(), e.preventDefault()));
                }, t.prototype.onChangeEditor = function () {
                  this.isShown && (this.element && this.element.parentNode ? this.updateSize() : this.hide()), (0, s.$$)("iframe", this.j.editor).forEach(this.bind);
                }, t.prototype.bind = function (e) {
                  var t = this;
                  if (a.Dom.isHTMLElement(e) && this.j.o.allowResizeTags.includes(e.tagName.toLowerCase()) && !(0, s.dataBind)(e, p)) {
                    var o;
                    if ((0, s.dataBind)(e, p, !0), a.Dom.isTag(e, "iframe")) {
                      var n = e;
                      a.Dom.isHTMLElement(e.parentNode) && (0, s.attr)(e.parentNode, "-jodit_iframe_wrapper") ? e = e.parentNode : (o = this.j.createInside.element("jodit", {
                        "data-jodit-temp": 1,
                        contenteditable: !1,
                        draggable: !0,
                        "data-jodit_iframe_wrapper": 1
                      }), (0, s.attr)(o, "style", (0, s.attr)(e, "style")), (0, s.css)(o, {
                        display: "inline-block" === e.style.display ? "inline-block" : "block",
                        width: e.offsetWidth,
                        height: e.offsetHeight
                      }), e.parentNode && e.parentNode.insertBefore(o, e), o.appendChild(e), this.j.e.on(o, "click", function () {
                        (0, s.attr)(o, "data-jodit-wrapper_active", !0);
                      }), e = o), this.j.e.off(e, "mousedown.select touchstart.select").on(e, "mousedown.select touchstart.select", function () {
                        t.j.s.select(e);
                      }).off(e, "changesize").on(e, "changesize", function () {
                        n.setAttribute("width", e.offsetWidth + "px"), n.setAttribute("height", e.offsetHeight + "px");
                      });
                    }
                    this.j.e.on(e, "dragstart", this.hide), i.IS_IE && this.j.e.on(e, "mousedown", function (t) {
                      a.Dom.isTag(e, "img") && t.preventDefault();
                    });
                  }
                }, t.prototype.showSizeViewer = function (e, t) {
                  this.j.o.resizer.showSize && (this.sizeViewer.offsetWidth > e || this.sizeViewer.offsetHeight > t ? this.hideSizeViewer() : (this.sizeViewer.style.opacity = "1", this.sizeViewer.textContent = "".concat(e, " x ").concat(t), this.j.async.setTimeout(this.hideSizeViewer, {
                    timeout: this.j.o.resizer.hideSizeTimeout,
                    label: "hideSizeViewer"
                  })));
                }, t.prototype.show = function () {
                  this.j.o.readonly || this.isShown || (this.isShown = !0, this.rect.parentNode || ((0, s.markOwner)(this.j, this.rect), this.j.workplace.appendChild(this.rect)), this.j.isFullSize && (this.rect.style.zIndex = (0, s.css)(this.j.container, "zIndex").toString()), this.updateSize());
                }, t.prototype.hide = function () {
                  this.isResizeMode || (this.isResizeMode = !1, this.isShown = !1, this.element = null, a.Dom.safeRemove(this.rect), (0, s.$$)("[data-jodit-wrapper_active='true']", this.j.editor).forEach(function (e) {
                    return (0, s.attr)(e, "data-jodit-wrapper_active", !1);
                  }));
                }, t.prototype.beforeDestruct = function (e) {
                  this.hide(), c.eventEmitter.off("hideHelpers", this.hide), e.e.off(this.j.ow, ".resizer").off(".resizer");
                }, n.__decorate([(0, u.watch)(":click")], t.prototype, "onEditorClick", null), n.__decorate([u.autobind], t.prototype, "onStartResizing", null), n.__decorate([u.autobind], t.prototype, "onEndResizing", null), n.__decorate([u.autobind], t.prototype, "onResize", null), n.__decorate([u.autobind], t.prototype, "onKeyDown", null), n.__decorate([u.autobind], t.prototype, "onKeyUp", null), n.__decorate([u.autobind], t.prototype, "onClickOutside", null), n.__decorate([(0, u.debounce)()], t.prototype, "onChangeEditor", null), n.__decorate([u.autobind], t.prototype, "bind", null), n.__decorate([u.autobind], t.prototype, "hide", null), t;
              }(l.Plugin);
            t.resizer = f, d.pluginSystem.add("resizer", f);
          },
          61975: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            o(59535), n.Config.prototype.useSearch = !0, n.Config.prototype.search = {
              lazyIdleTimeout: 0
            }, r.Icon.set("search", o(41197)), n.Config.prototype.controls.find = {
              tooltip: "Find",
              icon: "search",
              exec: function (e, t, o) {
                var n = o.control;
                switch (n.args && n.args[0]) {
                  case "findPrevious":
                    e.e.fire("searchPrevious");
                    break;
                  case "findNext":
                    e.e.fire("searchNext");
                    break;
                  case "replace":
                    e.execCommand("openReplaceDialog");
                    break;
                  default:
                    e.execCommand("openSearchDialog");
                }
              },
              list: {
                search: "Find",
                findNext: "Find Next",
                findPrevious: "Find Previous",
                replace: "Replace"
              },
              childTemplate: function (e, t, o) {
                return o;
              }
            };
          },
          73934: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(18562), t), n.__exportStar(o(3928), t);
          },
          18562: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.SentenceFinder = void 0;
            var n = o(20255),
              r = o(93163),
              i = function () {
                function e(e) {
                  void 0 === e && (e = r.fuzzySearchIndex), this.searchIndex = e, this.queue = [], this.value = "";
                }
                return e.prototype.add = function (e) {
                  var t,
                    o = (null !== (t = e.nodeValue) && void 0 !== t ? t : "").toLowerCase();
                  if (o.length) {
                    var n = this.value.length;
                    this.queue.push({
                      startIndex: n,
                      endIndex: n + o.length,
                      node: e
                    }), this.value += o;
                  }
                }, e.prototype.ranges = function (e, t) {
                  var o;
                  void 0 === t && (t = 0);
                  var r = [],
                    i = t,
                    a = 0,
                    s = 0;
                  do {
                    if (a = (o = n.__read(this.searchIndex(e, this.value, i), 2))[1], -1 !== (i = o[0])) {
                      for (var l = void 0, c = 0, u = void 0, d = 0, p = s; this.queue.length > p; p += 1) if (!l && this.queue[p].endIndex > i && (l = this.queue[p].node, c = i - this.queue[p].startIndex), l && this.queue[p].endIndex >= i + a) {
                        u = this.queue[p].node, d = i + a - this.queue[p].startIndex, s = p;
                        break;
                      }
                      l && u && r.push({
                        startContainer: l,
                        startOffset: c,
                        endContainer: u,
                        endOffset: d
                      }), i += a;
                    }
                  } while (-1 !== i);
                  return 0 === r.length ? null : r;
                }, e;
              }();
            t.SentenceFinder = i;
          },
          3928: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.isSelectionWrapper = t.clearSelectionWrappersFromHTML = t.clearSelectionWrappers = t.getSelectionWrappers = t.wrapRangesTextsInTmpSpan = void 0;
            var n = o(20255),
              r = o(24263),
              i = o(54188),
              a = "jd-tmp-selection";
            function s(e) {
              return (0, i.$$)("[".concat(a, "]"), e);
            }
            function l(e) {
              return r.Dom.isElement(e) && e.hasAttribute(a);
            }
            t.wrapRangesTextsInTmpSpan = function (e, t, o, i) {
              var s, c, u;
              if (null != e.startContainer.nodeValue && null != e.endContainer.nodeValue) {
                var d = o.element("span", ((s = {})[a] = !0, s));
                r.Dom.markTemporary(d);
                var p = e.startContainer.nodeValue,
                  f = 0;
                if (0 !== e.startOffset) {
                  var h = o.text(p.substring(0, e.startOffset));
                  e.startContainer.nodeValue = p.substring(e.startOffset), r.Dom.before(e.startContainer, h), e.startContainer === e.endContainer && (e.endOffset -= f = e.startOffset), e.startOffset = 0;
                }
                var m = e.endContainer.nodeValue;
                if (e.endOffset !== m.length) {
                  h = o.text(m.substring(e.endOffset)), e.endContainer.nodeValue = m.substring(0, e.endOffset), r.Dom.after(e.endContainer, h);
                  try {
                    for (var v = n.__values(t), g = v.next(); !g.done; g = v.next()) {
                      var y = g.value;
                      if (y.startContainer !== e.endContainer) break;
                      y.startContainer = h, y.startOffset = y.startOffset - e.endOffset - f, y.endContainer === e.endContainer && (y.endContainer = h, y.endOffset = y.endOffset - e.endOffset - f);
                    }
                  } catch (e) {
                    c = {
                      error: e
                    };
                  } finally {
                    try {
                      g && !g.done && (u = v.return) && u.call(v);
                    } finally {
                      if (c) throw c.error;
                    }
                  }
                  e.endOffset = e.endContainer.nodeValue.length;
                }
                var _ = e.startContainer;
                do {
                  if (!_) break;
                  if (r.Dom.isText(_) && !l(_.parentNode) && r.Dom.wrap(_, d.cloneNode(), o), _ === e.endContainer) break;
                  var b = _.firstChild || _.nextSibling;
                  if (!b) {
                    for (; _ && !_.nextSibling && _ !== i;) _ = _.parentNode;
                    b = null == _ ? void 0 : _.nextSibling;
                  }
                  _ = b;
                } while (_ && _ !== i);
              }
            }, t.getSelectionWrappers = s, t.clearSelectionWrappers = function (e) {
              s(e).forEach(function (e) {
                return r.Dom.unwrap(e);
              });
            }, t.clearSelectionWrappersFromHTML = function (e) {
              return e.replace(RegExp("<span[^>]+".concat(a, "[^>]+>(.*?)</span>"), "g"), "$1");
            }, t.isSelectionWrapper = l;
          },
          59535: function () {},
          14889: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.search = void 0;
            var n = o(20255),
              r = o(64968),
              i = o(57549),
              a = o(43441),
              s = o(72235),
              l = o(40332),
              c = o(17332),
              u = o(73934);
            o(61975);
            var d = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "find",
                  group: "search"
                }], t.previousQuery = "", t.drawPromise = null, t.walker = null, t.walkerCount = null, t.cache = {}, t.wrapFrameRequest = 0, t;
              }
              return n.__extends(t, e), Object.defineProperty(t.prototype, "ui", {
                get: function () {
                  return new s.UISearch(this.j);
                },
                enumerable: !1,
                configurable: !0
              }), t.prototype.updateCounters = function () {
                return n.__awaiter(this, void 0, Promise, function () {
                  var e;
                  return n.__generator(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return this.ui.isOpened ? (e = this.ui, [4, this.calcCounts(this.ui.query)]) : [2];
                      case 1:
                        return e.count = t.sent(), [2];
                    }
                  });
                });
              }, t.prototype.onPressReplaceButton = function () {
                this.findAndReplace(this.ui.query), this.updateCounters();
              }, t.prototype.tryScrollToElement = function (e) {
                var t = r.Dom.closest(e, r.Dom.isElement, this.j.editor);
                t || (t = r.Dom.prev(e, r.Dom.isElement, this.j.editor)), t && t !== this.j.editor && (0, l.scrollIntoViewIfNeeded)(t, this.j.editor, this.j.ed);
              }, t.prototype.calcCounts = function (e) {
                return n.__awaiter(this, void 0, Promise, function () {
                  return n.__generator(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return [4, this.findQueryBounds(e, "walkerCount")];
                      case 1:
                        return [2, t.sent().length];
                    }
                  });
                });
              }, t.prototype.findQueryBounds = function (e, t) {
                return n.__awaiter(this, void 0, Promise, function () {
                  var o;
                  return n.__generator(this, function (n) {
                    return (o = this[t]) && o.break(), o = new r.LazyWalker(this.j.async, {
                      timeout: this.j.o.search.lazyIdleTimeout
                    }), this[t] = o, [2, this.find(o, e).catch(function (e) {
                      return [];
                    })];
                  });
                });
              }, t.prototype.findAndReplace = function (e) {
                return n.__awaiter(this, void 0, Promise, function () {
                  var t, o, i, a, s;
                  return n.__generator(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return [4, this.findQueryBounds(e, "walker")];
                      case 1:
                        if (!(t = n.sent()).length) return [2, !1];
                        if (-1 === (o = this.findCurrentIndexInRanges(t, this.j.s.range)) && (o = 0), !(i = t[o])) return [3, 6];
                        n.label = 2;
                      case 2:
                        return n.trys.push([2,, 4, 5]), (a = this.j.ed.createRange()).setStart(i.startContainer, i.startOffset), a.setEnd(i.endContainer, i.endOffset), a.deleteContents(), s = this.j.createInside.text(this.ui.replace), r.Dom.safeInsertNode(a, s), (0, u.clearSelectionWrappers)(this.j.editor), this.j.s.setCursorAfter(s), this.tryScrollToElement(s), this.cache = {}, this.ui.currentIndex = o, [4, this.findAndSelect(e, !0).catch(function (e) {
                          return null;
                        })];
                      case 3:
                        return n.sent(), [3, 5];
                      case 4:
                        return this.j.synchronizeValues(), [7];
                      case 5:
                        return this.j.e.fire("afterFindAndReplace"), [2, !0];
                      case 6:
                        return [2, !1];
                    }
                  });
                });
              }, t.prototype.findAndSelect = function (e, t) {
                var o;
                return n.__awaiter(this, void 0, Promise, function () {
                  var r, i, a, s;
                  return n.__generator(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return [4, this.findQueryBounds(e, "walker")];
                      case 1:
                        if (!(r = n.sent()).length) return [2, !1];
                        if (this.previousQuery === e && (0, u.getSelectionWrappers)(this.j.editor).length || (null === (o = this.drawPromise) || void 0 === o || o.rejectCallback(), this.j.async.cancelAnimationFrame(this.wrapFrameRequest), (0, u.clearSelectionWrappers)(this.j.editor), this.drawPromise = this.drawSelectionRanges(r)), this.previousQuery = e, this.ui.currentIndex = (i = -1 == (i = this.ui.currentIndex - 1) ? 0 : t ? i === r.length - 1 ? 0 : i + 1 : 0 === i ? r.length - 1 : i - 1) + 1, !(a = r[i])) return [3, 4];
                        s = this.j.ed.createRange();
                        try {
                          s.setStart(a.startContainer, a.startOffset), s.setEnd(a.endContainer, a.endOffset), this.j.s.selectRange(s);
                        } catch (e) {}
                        return this.tryScrollToElement(a.startContainer), [4, this.updateCounters()];
                      case 2:
                        return n.sent(), [4, this.drawPromise];
                      case 3:
                        return n.sent(), this.j.e.fire("afterFindAndSelect"), [2, !0];
                      case 4:
                        return [2, !1];
                    }
                  });
                });
              }, t.prototype.findCurrentIndexInRanges = function (e, t) {
                return e.findIndex(function (e) {
                  return e.startContainer === t.startContainer && e.startOffset === t.startOffset && e.endContainer === t.startContainer && e.endOffset === t.endOffset;
                });
              }, t.prototype.isValidCache = function (e) {
                return n.__awaiter(this, void 0, Promise, function () {
                  return n.__generator(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return [4, e];
                      case 1:
                        return [2, t.sent().every(function (e) {
                          var t, o, n, r;
                          return e.startContainer.isConnected && e.startOffset <= (null !== (o = null === (t = e.startContainer.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) && e.endContainer.isConnected && e.endOffset <= (null !== (r = null === (n = e.endContainer.nodeValue) || void 0 === n ? void 0 : n.length) && void 0 !== r ? r : 0);
                        })];
                    }
                  });
                });
              }, t.prototype.find = function (e, t) {
                return n.__awaiter(this, void 0, Promise, function () {
                  var o,
                    i,
                    a = this;
                  return n.__generator(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return t.length ? (i = o = this.cache[t]) ? [4, this.isValidCache(o)] : [3, 2] : [2, []];
                      case 1:
                        i = n.sent(), n.label = 2;
                      case 2:
                        return i ? [2, o] : (this.cache[t] = this.j.async.promise(function (o) {
                          var n = new u.SentenceFinder(a.j.o.search.fuzzySearch);
                          e.on("break", function () {
                            o([]);
                          }).on("visit", function (e) {
                            return r.Dom.isText(e) && n.add(e), !1;
                          }).on("end", function () {
                            var e;
                            o(null !== (e = n.ranges(t)) && void 0 !== e ? e : []);
                          }).setWork(a.j.editor);
                        }), [2, this.cache[t]]);
                    }
                  });
                });
              }, t.prototype.drawSelectionRanges = function (e) {
                var t = this,
                  o = this.j,
                  r = o.async,
                  i = o.createInside,
                  a = o.editor;
                r.cancelAnimationFrame(this.wrapFrameRequest);
                var s,
                  l = n.__spreadArray([], n.__read(e), !1),
                  c = 0;
                return r.promise(function (e) {
                  var o = function () {
                    do {
                      (s = l.shift()) && (0, u.wrapRangesTextsInTmpSpan)(s, l, i, a), c += 1;
                    } while (s && 5 >= c);
                    l.length ? t.wrapFrameRequest = r.requestAnimationFrame(o) : e();
                  };
                  o();
                });
              }, t.prototype.onAfterGetValueFromEditor = function (e) {
                e.value = (0, u.clearSelectionWrappersFromHTML)(e.value);
              }, t.prototype.afterInit = function (e) {
                var t = this;
                if (e.o.useSearch) {
                  var o = this;
                  e.e.on("beforeSetMode.search", function () {
                    t.ui.close();
                  }).on(this.ui, "afterClose", function () {
                    (0, u.clearSelectionWrappers)(e.editor), t.ui.currentIndex = 0, t.ui.count = 0, t.cache = {};
                  }).on("click", function () {
                    t.ui.currentIndex = 0, (0, u.clearSelectionWrappers)(e.editor);
                  }).on("change.search", function () {
                    t.cache = {};
                  }).on("keydown.search mousedown.search", e.async.debounce(function () {
                    t.ui.selInfo && (e.s.removeMarkers(), t.ui.selInfo = null), t.ui.isOpened && t.updateCounters();
                  }, e.defaultTimeout)).on("searchNext.search searchPrevious.search", function () {
                    return t.ui.isOpened || t.ui.open(), o.findAndSelect(o.ui.query, "searchNext" === e.e.current).catch(function (e) {});
                  }).on("search.search", function (e, n) {
                    return void 0 === n && (n = !0), t.ui.currentIndex = 0, o.findAndSelect(e || "", n).catch(function (e) {});
                  }), e.registerCommand("search", {
                    exec: function (e, t, n) {
                      return void 0 === n && (n = !0), t && o.findAndSelect(t, n).catch(function (e) {}), !1;
                    }
                  }).registerCommand("openSearchDialog", {
                    exec: function (e, t) {
                      return o.ui.open(t), !1;
                    },
                    hotkeys: ["ctrl+f", "cmd+f"]
                  }).registerCommand("openReplaceDialog", {
                    exec: function (t, n, r) {
                      return e.o.readonly || o.ui.open(n, r, !0), !1;
                    },
                    hotkeys: ["ctrl+h", "cmd+h"]
                  });
                }
              }, t.prototype.beforeDestruct = function (e) {
                this.ui.destruct(), e.e.off(".search");
              }, n.__decorate([a.cache], t.prototype, "ui", null), n.__decorate([(0, a.watch)("ui:needUpdateCounters")], t.prototype, "updateCounters", null), n.__decorate([(0, a.watch)("ui:pressReplaceButton")], t.prototype, "onPressReplaceButton", null), n.__decorate([a.autobind], t.prototype, "findQueryBounds", null), n.__decorate([a.autobind], t.prototype, "findAndReplace", null), n.__decorate([a.autobind], t.prototype, "findAndSelect", null), n.__decorate([a.autobind], t.prototype, "find", null), n.__decorate([(0, a.watch)(":afterGetValueFromEditor")], t.prototype, "onAfterGetValueFromEditor", null), t;
            }(i.Plugin);
            t.search = d, c.pluginSystem.add("search", d);
          },
          72235: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.UISearch = void 0;
            var n = o(20255);
            o(88582);
            var r = o(2074),
              i = o(40332),
              a = o(86893),
              s = o(86893),
              l = o(43441),
              c = o(64968),
              u = function (e) {
                function t(t) {
                  var o = e.call(this, t) || this;
                  o.selInfo = null, o._currentIndex = 0, o.isOpened = !1;
                  var n = (0, i.refs)(o.container),
                    r = n.replace,
                    a = n.cancel,
                    l = n.next,
                    c = n.prev,
                    u = n.replaceBtn,
                    d = n.current,
                    p = n.count;
                  return o.queryInput = n.query, o.replaceInput = r, o.closeButton = a, o.replaceButton = u, o.currentBox = d, o.countBox = p, t.e.on(o.closeButton, "pointerdown", function () {
                    return o.close(), !1;
                  }).on(o.queryInput, "input", function () {
                    o.currentIndex = 0;
                  }).on(o.queryInput, "pointerdown", function () {
                    t.s.isFocused() && (t.s.removeMarkers(), o.selInfo = t.s.save());
                  }).on(o.replaceButton, "pointerdown", function () {
                    return t.e.fire(o, "pressReplaceButton"), !1;
                  }).on(l, "pointerdown", function () {
                    return t.e.fire("searchNext"), !1;
                  }).on(c, "pointerdown", function () {
                    return t.e.fire("searchPrevious"), !1;
                  }).on(o.queryInput, "input", function () {
                    o.setMod("empty-query", !(0, i.trim)(o.queryInput.value).length);
                  }).on(o.queryInput, "keydown", o.j.async.debounce(function (e) {
                    e.key === s.KEY_ENTER ? (e.preventDefault(), e.stopImmediatePropagation(), t.e.fire("searchNext") && o.close()) : t.e.fire(o, "needUpdateCounters");
                  }, o.j.defaultTimeout)), o;
                }
                return n.__extends(t, e), t.prototype.className = function () {
                  return "UISearch";
                }, t.prototype.render = function () {
                  return '<div>\n\t\t\t<div class="&__box">\n\t\t\t\t<div class="&__inputs">\n\t\t\t\t\t<input data-ref="query" tabindex="0" placeholder="~Search for~" type="text"/>\n\t\t\t\t\t<input data-ref="replace" tabindex="0" placeholder="~Replace with~" type="text"/>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__counts">\n\t\t\t\t\t<span data-ref="counter-box">\n\t\t\t\t\t\t<span data-ref="current">0</span><span>/</span><span data-ref="count">0</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__buttons">\n\t\t\t\t\t<button data-ref="next" tabindex="0" type="button">'.concat(r.Icon.get("angle-down"), '</button>\n\t\t\t\t\t<button data-ref="prev" tabindex="0" type="button">').concat(r.Icon.get("angle-up"), '</button>\n\t\t\t\t\t<button data-ref="cancel" tabindex="0" type="button">').concat(r.Icon.get("cancel"), '</button>\n\t\t\t\t\t<button data-ref="replace-btn" tabindex="0" type="button" class="jodit-ui-button">~Replace~</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>');
                }, Object.defineProperty(t.prototype, "currentIndex", {
                  get: function () {
                    return this._currentIndex;
                  },
                  set: function (e) {
                    this._currentIndex = e, this.currentBox.innerText = e.toString();
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "count", {
                  set: function (e) {
                    this.countBox.innerText = e.toString();
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "query", {
                  get: function () {
                    return this.queryInput.value;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(t.prototype, "replace", {
                  get: function () {
                    return this.replaceInput.value;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.onEditorKeyDown = function (e) {
                  if (this.isOpened) {
                    var t = this.j;
                    if (t.getRealMode() === a.MODE_WYSIWYG) switch (e.key) {
                      case s.KEY_ESC:
                        this.close();
                        break;
                      case s.KEY_F3:
                        this.queryInput.value && (t.e.fire(e.shiftKey ? "searchPrevious" : "searchNext"), e.preventDefault());
                    }
                  }
                }, t.prototype.open = function (e, t, o) {
                  void 0 === o && (o = !1), this.isOpened || (this.j.workplace.appendChild(this.container), this.isOpened = !0), this.calcSticky(this.j.e.fire("getStickyState.sticky") || !1), this.j.e.fire("hidePopup"), this.setMod("replace", o);
                  var n = null != e ? e : (this.j.s.sel || "").toString();
                  n && (this.queryInput.value = n), t && (this.replaceInput.value = t), this.setMod("empty-query", !n.length), this.j.e.fire(this, "needUpdateCounters"), n ? this.queryInput.select() : this.queryInput.focus();
                }, t.prototype.close = function () {
                  this.isOpened && (this.j.s.restore(), c.Dom.safeRemove(this.container), this.isOpened = !1, this.j.e.fire(this, "afterClose"));
                }, t.prototype.calcSticky = function (e) {
                  if (this.isOpened) if (this.setMod("sticky", e), e) {
                    var t = (0, i.position)(this.j.toolbarContainer);
                    (0, i.css)(this.container, {
                      top: t.top + t.height,
                      left: t.left + t.width
                    });
                  } else (0, i.css)(this.container, {
                    top: null,
                    left: null
                  });
                }, n.__decorate([(0, l.watch)([":keydown", "queryInput:keydown"])], t.prototype, "onEditorKeyDown", null), n.__decorate([l.autobind], t.prototype, "open", null), n.__decorate([l.autobind], t.prototype, "close", null), n.__decorate([(0, l.watch)(":toggleSticky")], t.prototype, "calcSticky", null), n.__decorate([l.component], t);
              }(r.UIElement);
            t.UISearch = u;
          },
          14189: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.tableAllowCellSelection = !0;
          },
          37458: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.selectCells = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(87837),
              a = o(24263),
              s = o(40332),
              l = o(86893),
              c = o(43441),
              u = o(17332);
            o(14189);
            var d = "table_processor_observer",
              p = "onMoveTableSelectCell",
              f = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.requires = ["select"], t.selectedCell = null, t.isSelectionMode = !1, t;
                }
                return n.__extends(t, e), Object.defineProperty(t.prototype, "module", {
                  get: function () {
                    return this.j.getInstance("Table", this.j.o);
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.afterInit = function (e) {
                  var t = this;
                  e.o.tableAllowCellSelection && e.e.on("keydown.select-cells", function (e) {
                    e.key === l.KEY_TAB && t.unselectCells();
                  }).on("beforeCommand.select-cells", this.onExecCommand).on("afterCommand.select-cells", this.onAfterCommand).on(["clickEditor", "mousedownTd", "mousedownTh", "touchstartTd", "touchstartTh"].map(function (e) {
                    return e + ".select-cells";
                  }).join(" "), this.onStartSelection).on("clickTr clickTbody", function () {
                    var e,
                      o = t.module.getAllSelectedCells().length;
                    if (o) return o > 1 && (null === (e = t.j.s.sel) || void 0 === e || e.removeAllRanges()), !1;
                  });
                }, t.prototype.onStartSelection = function (e) {
                  if (!this.j.o.readonly && (this.unselectCells(), e !== this.j.editor)) {
                    var t = a.Dom.closest(e, "table", this.j.editor);
                    if (e && t) return e.firstChild || e.appendChild(this.j.createInside.element("br")), this.isSelectionMode = !0, this.selectedCell = e, this.module.addSelection(e), this.j.e.on(t, "mousemove.select-cells touchmove.select-cells", this.j.async.throttle(this.onMove.bind(this, t), {
                      label: p,
                      timeout: this.j.defaultTimeout / 2
                    })).on(t, "mouseup.select-cells touchend.select-cells", this.onStopSelection.bind(this, t)), !1;
                  }
                }, t.prototype.onOutsideClick = function () {
                  this.selectedCell = null, this.onRemoveSelection();
                }, t.prototype.onChange = function () {
                  this.j.isLocked || this.isSelectionMode || this.onRemoveSelection();
                }, t.prototype.onMove = function (e, t) {
                  var o,
                    n = this;
                  if ((!this.j.o.readonly || this.j.isLocked) && !this.j.isLockedNotBy(d)) {
                    var r = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                    if (r) {
                      var s = a.Dom.closest(r, ["td", "th"], e);
                      if (s && this.selectedCell) {
                        s !== this.selectedCell && this.j.lock(d), this.unselectCells();
                        for (var l = i.Table.getSelectedBound(e, [s, this.selectedCell]), c = i.Table.formalMatrix(e), u = l[0][0]; l[1][0] >= u; u += 1) for (var p = l[0][1]; l[1][1] >= p; p += 1) this.module.addSelection(c[u][p]);
                        var f;
                        this.module.getAllSelectedCells().length > 1 && (null === (o = this.j.s.sel) || void 0 === o || o.removeAllRanges()), this.j.e.fire("hidePopup"), t.stopPropagation(), f = n.j.createInside.fromHTML('<div style="color:rgba(0,0,0,0.01);width:0;height:0">&nbsp;</div>'), s.appendChild(f), n.j.async.setTimeout(function () {
                          var e;
                          null === (e = f.parentNode) || void 0 === e || e.removeChild(f);
                        }, n.j.defaultTimeout / 5);
                      }
                    }
                  }
                }, t.prototype.onRemoveSelection = function (e) {
                  var t;
                  if (!(null === (t = null == e ? void 0 : e.buffer) || void 0 === t ? void 0 : t.actionTrigger) && !this.selectedCell && this.module.getAllSelectedCells().length) return this.j.unlock(), this.unselectCells(), void this.j.e.fire("hidePopup", "cells");
                  this.isSelectionMode = !1, this.selectedCell = null;
                }, t.prototype.onStopSelection = function (e, t) {
                  var o = this;
                  if (this.selectedCell) {
                    this.isSelectionMode = !1, this.j.unlock();
                    var n = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                    if (n) {
                      var r = a.Dom.closest(n, ["td", "th"], e);
                      if (r) {
                        var l = a.Dom.closest(r, "table", e);
                        if (!l || l === e) {
                          var c = i.Table.getSelectedBound(e, [r, this.selectedCell]),
                            u = i.Table.formalMatrix(e),
                            d = u[c[1][0]][c[1][1]],
                            f = u[c[0][0]][c[0][1]];
                          this.j.e.fire("showPopup", e, function () {
                            var e = (0, s.position)(f, o.j),
                              t = (0, s.position)(d, o.j);
                            return {
                              left: e.left,
                              top: e.top,
                              width: t.left - e.left + t.width,
                              height: t.top - e.top + t.height
                            };
                          }, "cells"), (0, s.$$)("table", this.j.editor).forEach(function (e) {
                            o.j.e.off(e, "mousemove.select-cells touchmove.select-cells mouseup.select-cells touchend.select-cells");
                          }), this.j.async.clearTimeout(p);
                        }
                      }
                    }
                  }
                }, t.prototype.unselectCells = function (e) {
                  var t = this.module,
                    o = t.getAllSelectedCells();
                  o.length && o.forEach(function (o) {
                    e && e === o || t.removeSelection(o);
                  });
                }, t.prototype.onExecCommand = function (e) {
                  if (/table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(e)) {
                    e = e.replace("table", "");
                    var t = this.module.getAllSelectedCells();
                    if (t.length) {
                      var o = n.__read(t, 1)[0];
                      if (!o) return;
                      var r = a.Dom.closest(o, "table", this.j.editor);
                      if (!r) return;
                      switch (e) {
                        case "splitv":
                          i.Table.splitVertical(r, this.j);
                          break;
                        case "splitg":
                          i.Table.splitHorizontal(r, this.j);
                          break;
                        case "merge":
                          i.Table.mergeSelected(r, this.j);
                          break;
                        case "empty":
                          t.forEach(function (e) {
                            return a.Dom.detach(e);
                          });
                          break;
                        case "bin":
                          a.Dom.safeRemove(r);
                          break;
                        case "binrow":
                          new Set(t.map(function (e) {
                            return e.parentNode;
                          })).forEach(function (e) {
                            i.Table.removeRow(r, e.rowIndex);
                          });
                          break;
                        case "bincolumn":
                          var s = new Set();
                          t.reduce(function (e, t) {
                            return s.has(t.cellIndex) || (e.push(t), s.add(t.cellIndex)), e;
                          }, []).forEach(function (e) {
                            i.Table.removeColumn(r, e.cellIndex);
                          });
                          break;
                        case "addcolumnafter":
                        case "addcolumnbefore":
                          i.Table.appendColumn(r, o.cellIndex, "addcolumnafter" === e, this.j.createInside);
                          break;
                        case "addrowafter":
                        case "addrowbefore":
                          i.Table.appendRow(r, o.parentNode, "addrowafter" === e, this.j.createInside);
                      }
                    }
                    return !1;
                  }
                }, t.prototype.onAfterCommand = function (e) {
                  /^justify/.test(e) && this.module.getAllSelectedCells().forEach(function (t) {
                    return (0, s.alignElement)(e, t);
                  });
                }, t.prototype.beforeDestruct = function (e) {
                  this.onRemoveSelection(), e.e.off(".select-cells");
                }, n.__decorate([c.autobind], t.prototype, "onStartSelection", null), n.__decorate([(0, c.watch)(":outsideClick")], t.prototype, "onOutsideClick", null), n.__decorate([(0, c.watch)(":change")], t.prototype, "onChange", null), n.__decorate([c.autobind], t.prototype, "onRemoveSelection", null), n.__decorate([c.autobind], t.prototype, "onStopSelection", null), n.__decorate([c.autobind], t.prototype, "onExecCommand", null), n.__decorate([c.autobind], t.prototype, "onAfterCommand", null), t;
              }(r.Plugin);
            t.selectCells = f, u.pluginSystem.add("selectCells", f);
          },
          33100: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.select = {
              normalizeSelectionBeforeCutAndCopy: !1
            };
          },
          95323: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.select = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(43441),
              a = o(26596),
              s = o(24263),
              l = o(2074),
              c = o(17332);
            o(33100);
            var u = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.proxyEventsList = ["click", "mousedown", "touchstart", "mouseup", "touchend"], t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                this.proxyEventsList.forEach(function (o) {
                  e.e.on(o + ".select", t.onStartSelection);
                });
              }, t.prototype.beforeDestruct = function (e) {
                var t = this;
                this.proxyEventsList.forEach(function (o) {
                  e.e.on(o + ".select", t.onStartSelection);
                });
              }, t.prototype.onStartSelection = function (e) {
                for (var t, o = this.j, n = e.target; void 0 === t && n && n !== o.editor;) t = o.e.fire((0, a.camelCase)(e.type + "_" + n.nodeName.toLowerCase()), n, e), n = n.parentElement;
                "click" === e.type && void 0 === t && n === o.editor && o.e.fire(e.type + "Editor", n, e);
              }, t.prototype.onOutsideClick = function (e) {
                var t = this,
                  o = e.target;
                s.Dom.up(o, function (e) {
                  return e === t.j.editor;
                }) || l.UIElement.closestElement(o, l.Popup) || this.j.e.fire("outsideClick", e);
              }, t.prototype.beforeCommandCut = function (e) {
                var t = this.j.s;
                if ("cut" === e && !t.isCollapsed()) {
                  var o = t.current();
                  o && s.Dom.isOrContains(this.j.editor, o) && this.onCopyNormalizeSelectionBound();
                }
              }, t.prototype.onCopyNormalizeSelectionBound = function (e) {
                var t = this.j,
                  o = t.editor;
                t.o.select.normalizeSelectionBeforeCutAndCopy && !t.s.isCollapsed() && (!e || e.isTrusted && s.Dom.isNode(e.target) && s.Dom.isOrContains(o, e.target)) && this.jodit.s.expandSelection();
              }, n.__decorate([i.autobind], t.prototype, "onStartSelection", null), n.__decorate([(0, i.watch)("ow:click")], t.prototype, "onOutsideClick", null), n.__decorate([(0, i.watch)([":beforeCommand"])], t.prototype, "beforeCommandCut", null), n.__decorate([(0, i.watch)([":copy", ":cut"])], t.prototype, "onCopyNormalizeSelectionBound", null), t;
            }(r.Plugin);
            t.select = u, c.pluginSystem.add("select", u);
          },
          53387: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.minWidth = 200, n.Config.prototype.maxWidth = "100%", n.Config.prototype.minHeight = 200, n.Config.prototype.maxHeight = "auto", n.Config.prototype.saveHeightInStorage = !1;
          },
          71003: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.size = void 0;
            var n = o(20255);
            o(30962);
            var r = o(61817),
              i = o(26911),
              a = o(85605),
              s = o(43441),
              l = o(17332);
            o(53387);
            var c = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.__resizeWorkspaces = t.j.async.debounce(t.__resizeWorkspaceImd, t.j.defaultTimeout, !0), t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                e.e.on("setHeight.size", this.__setHeight).on("setWidth.size", this.__setWidth).on("afterInit.size changePlace.size", this.__initialize, {
                  top: !0
                }).on(e.ow, "load.size", this.__resizeWorkspaces).on("afterInit.size resize.size afterUpdateToolbar.size scroll.size afterResize.size", this.__resizeWorkspaces).on("toggleFullSize.size toggleToolbar.size", this.__resizeWorkspaceImd), this.__initialize();
              }, t.prototype.__initialize = function () {
                var e = this.j;
                if (!e.o.inline) {
                  var t = e.o.height;
                  if (e.o.saveHeightInStorage && "auto" !== t) {
                    var o = e.storage.get("height");
                    o && (t = o);
                  }
                  (0, i.css)(e.editor, {
                    minHeight: "100%"
                  }), (0, i.css)(e.container, {
                    minHeight: e.o.minHeight,
                    maxHeight: e.o.maxHeight,
                    minWidth: e.o.minWidth,
                    maxWidth: e.o.maxWidth
                  }), this.__setHeight(t), this.__setWidth(e.o.width);
                }
              }, t.prototype.__setHeight = function (e) {
                if ((0, r.isNumber)(e)) {
                  var t = this.j.o,
                    o = t.minHeight,
                    n = t.maxHeight;
                  (0, r.isNumber)(o) && o > e && (e = o), (0, r.isNumber)(n) && e > n && (e = n);
                }
                (0, i.css)(this.j.container, "height", e), this.j.o.saveHeightInStorage && this.j.storage.set("height", e), this.__resizeWorkspaceImd();
              }, t.prototype.__setWidth = function (e) {
                if ((0, r.isNumber)(e)) {
                  var t = this.j.o,
                    o = t.minWidth,
                    n = t.maxWidth;
                  (0, r.isNumber)(o) && o > e && (e = o), (0, r.isNumber)(n) && e > n && (e = n);
                }
                (0, i.css)(this.j.container, "width", e), this.__resizeWorkspaceImd();
              }, t.prototype.__getNotWorkHeight = function () {
                var e, t;
                return ((null === (e = this.j.toolbarContainer) || void 0 === e ? void 0 : e.offsetHeight) || 0) + ((null === (t = this.j.statusbar) || void 0 === t ? void 0 : t.getHeight()) || 0) + 2;
              }, t.prototype.__resizeWorkspaceImd = function () {
                if (this.j && !this.j.isDestructed && this.j.o && !this.j.o.inline && this.j.container && this.j.container.parentNode) {
                  var e = ((0, i.css)(this.j.container, "minHeight") || 0) - this.__getNotWorkHeight();
                  if ((0, r.isNumber)(e) && e > 0 && ([this.j.workplace, this.j.iframe, this.j.editor].map(function (t) {
                    t && (0, i.css)(t, "minHeight", e);
                  }), this.j.e.fire("setMinHeight", e)), (0, r.isNumber)(this.j.o.maxHeight)) {
                    var t = this.j.o.maxHeight - this.__getNotWorkHeight();
                    [this.j.workplace, this.j.iframe, this.j.editor].map(function (e) {
                      e && (0, i.css)(e, "maxHeight", t);
                    }), this.j.e.fire("setMaxHeight", t);
                  }
                  this.j.container && (0, i.css)(this.j.workplace, "height", "auto" !== this.j.o.height || this.j.isFullSize ? this.j.container.offsetHeight - this.__getNotWorkHeight() : "auto");
                }
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off(e.ow, "load.size", this.__resizeWorkspaces).off(".size");
              }, n.__decorate([(0, s.throttle)()], t.prototype, "__initialize", null), n.__decorate([s.autobind], t.prototype, "__resizeWorkspaceImd", null), n.__decorate([s.autobind], t);
            }(a.Plugin);
            t.size = c, l.pluginSystem.add("size", c);
          },
          13985: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(86893),
              i = o(77904);
            n.Config.prototype.beautifyHTML = !r.IS_IE, n.Config.prototype.sourceEditor = "ace", n.Config.prototype.sourceEditorNativeOptions = {
              showGutter: !0,
              theme: "ace/theme/idle_fingers",
              mode: "ace/mode/html",
              wrap: !0,
              highlightActiveLine: !0
            }, n.Config.prototype.sourceEditorCDNUrlsJS = ["https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.2/ace.js"], n.Config.prototype.beautifyHTMLCDNUrlsJS = ["https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify.min.js", "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify-html.min.js"], i.Icon.set("source", o(9342)), n.Config.prototype.controls.source = {
              mode: r.MODE_SPLIT,
              exec: function (e) {
                e.toggleMode();
              },
              isActive: function (e) {
                return e.getRealMode() === r.MODE_SOURCE;
              },
              tooltip: "Change mode"
            };
          },
          34186: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.AceEditor = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(40332),
              a = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.className = "jodit_ace_editor", t.proxyOnBlur = function (e) {
                    t.j.e.fire("blur", e);
                  }, t.proxyOnFocus = function (e) {
                    t.j.e.fire("focus", e);
                  }, t.proxyOnMouseDown = function (e) {
                    t.j.e.fire("mousedown", e);
                  }, t;
                }
                return n.__extends(t, e), t.prototype.aceExists = function () {
                  return void 0 !== this.j.ow.ace;
                }, t.prototype.getLastColumnIndex = function (e) {
                  return this.instance.session.getLine(e).length;
                }, t.prototype.getLastColumnIndices = function () {
                  for (var e = this.instance.session.getLength(), t = [], o = 0, n = 0; e > n; n++) o += this.getLastColumnIndex(n), n > 0 && (o += 1), t[n] = o;
                  return t;
                }, t.prototype.getRowColumnIndices = function (e) {
                  var t = this.getLastColumnIndices();
                  if (t[0] >= e) return {
                    row: 0,
                    column: e
                  };
                  for (var o = 1, n = 1; t.length > n; n++) e > t[n] && (o = n + 1);
                  return {
                    row: o,
                    column: e - t[o - 1] - 1
                  };
                }, t.prototype.setSelectionRangeIndices = function (e, t) {
                  var o = this.getRowColumnIndices(e),
                    n = this.getRowColumnIndices(t);
                  this.instance.getSelection().setSelectionRange({
                    start: o,
                    end: n
                  });
                }, t.prototype.getIndexByRowColumn = function (e, t) {
                  return this.getLastColumnIndices()[e] - this.getLastColumnIndex(e) + t;
                }, t.prototype.init = function (e) {
                  var t = this,
                    o = function () {
                      if (void 0 === t.instance && t.aceExists()) {
                        var o = t.j.c.div("jodit-source__mirror-fake");
                        t.container.appendChild(o), t.instance = e.ow.ace.edit(o), t.instance.setTheme(e.o.sourceEditorNativeOptions.theme), t.instance.renderer.setShowGutter(e.o.sourceEditorNativeOptions.showGutter), t.instance.getSession().setMode(e.o.sourceEditorNativeOptions.mode), t.instance.setHighlightActiveLine(e.o.sourceEditorNativeOptions.highlightActiveLine), t.instance.getSession().setUseWrapMode(!0), t.instance.setOption("indentedSoftWrap", !1), t.instance.setOption("wrap", e.o.sourceEditorNativeOptions.wrap), t.instance.getSession().setUseWorker(!1), t.instance.$blockScrolling = 1 / 0, t.instance.on("change", t.toWYSIWYG), t.instance.on("focus", t.proxyOnFocus), t.instance.on("mousedown", t.proxyOnMouseDown), t.instance.on("blur", t.proxyOnBlur), e.getRealMode() !== r.MODE_WYSIWYG && t.setValue(t.getValue());
                        var n = t.j.async.debounce(function () {
                          e.isInDestruct || (t.instance.setOption("maxLines", "auto" !== e.o.height ? e.workplace.offsetHeight / t.instance.renderer.lineHeight : 1 / 0), t.instance.resize());
                        }, 2 * t.j.defaultTimeout);
                        e.e.on("afterResize afterSetMode", n), n(), t.onReady();
                      }
                    };
                  e.e.on("afterSetMode", function () {
                    e.getRealMode() !== r.MODE_SOURCE && e.getMode() !== r.MODE_SPLIT || (t.fromWYSIWYG(), o());
                  }), o(), this.aceExists() || (0, i.loadNext)(e, e.o.sourceEditorCDNUrlsJS).then(function () {
                    e.isInDestruct || o();
                  }).catch(function () {
                    return null;
                  });
                }, t.prototype.destruct = function () {
                  var e, t;
                  this.instance.off("change", this.toWYSIWYG), this.instance.off("focus", this.proxyOnFocus), this.instance.off("mousedown", this.proxyOnMouseDown), this.instance.destroy(), null === (t = null === (e = this.j) || void 0 === e ? void 0 : e.events) || void 0 === t || t.off("aceInited.source");
                }, t.prototype.setValue = function (e) {
                  if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                    var t = this.j.e.fire("beautifyHTML", e);
                    (0, i.isString)(t) && (e = t);
                  }
                  this.instance.setValue(e), this.instance.clearSelection();
                }, t.prototype.getValue = function () {
                  return this.instance.getValue();
                }, t.prototype.setReadOnly = function (e) {
                  this.instance.setReadOnly(e);
                }, Object.defineProperty(t.prototype, "isFocused", {
                  get: function () {
                    return this.instance.isFocused();
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.focus = function () {
                  this.instance.focus();
                }, t.prototype.blur = function () {
                  this.instance.blur();
                }, t.prototype.getSelectionStart = function () {
                  var e = this.instance.selection.getRange();
                  return this.getIndexByRowColumn(e.start.row, e.start.column);
                }, t.prototype.getSelectionEnd = function () {
                  var e = this.instance.selection.getRange();
                  return this.getIndexByRowColumn(e.end.row, e.end.column);
                }, t.prototype.selectAll = function () {
                  this.instance.selection.selectAll();
                }, t.prototype.insertRaw = function (e) {
                  var t = this.instance.selection.getCursor(),
                    o = this.instance.session.insert(t, e);
                  this.instance.selection.setRange({
                    start: t,
                    end: o
                  }, !1);
                }, t.prototype.setSelectionRange = function (e, t) {
                  this.setSelectionRangeIndices(e, t);
                }, t.prototype.setPlaceHolder = function (e) {}, t.prototype.replaceUndoManager = function () {
                  var e = this.jodit.history;
                  this.instance.commands.addCommand({
                    name: "Undo",
                    bindKey: {
                      win: "Ctrl-Z",
                      mac: "Command-Z"
                    },
                    exec: function () {
                      e.undo();
                    }
                  }), this.instance.commands.addCommand({
                    name: "Redo",
                    bindKey: {
                      win: "Ctrl-Shift-Z",
                      mac: "Command-Shift-Z"
                    },
                    exec: function () {
                      e.redo();
                    }
                  });
                }, t;
              }(o(36729).SourceEditor);
            t.AceEditor = a;
          },
          58633: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.TextAreaEditor = void 0;
            var n = o(20255),
              r = o(26911),
              i = o(24263),
              a = function (e) {
                function t() {
                  var t = null !== e && e.apply(this, arguments) || this;
                  return t.autosize = t.j.async.debounce(function () {
                    t.instance.style.height = "auto", t.instance.style.height = t.instance.scrollHeight + "px";
                  }, t.j.defaultTimeout), t;
                }
                return n.__extends(t, e), t.prototype.init = function (e) {
                  var t = this;
                  this.instance = e.c.element("textarea", {
                    class: "jodit-source__mirror"
                  }), this.container.appendChild(this.instance), e.e.on(this.instance, "mousedown keydown touchstart input", e.async.debounce(this.toWYSIWYG, e.defaultTimeout)).on("setMinHeight.source", function (e) {
                    (0, r.css)(t.instance, "minHeight", e);
                  }).on(this.instance, "change keydown mousedown touchstart input", this.autosize).on("afterSetMode.source", this.autosize).on(this.instance, "mousedown focus", function (t) {
                    e.e.fire(t.type, t);
                  }), this.autosize(), this.onReady();
                }, t.prototype.destruct = function () {
                  i.Dom.safeRemove(this.instance);
                }, t.prototype.getValue = function () {
                  return this.instance.value;
                }, t.prototype.setValue = function (e) {
                  this.instance.value = e;
                }, t.prototype.insertRaw = function (e) {
                  var t = this.getValue();
                  if (0 > this.getSelectionStart()) this.setValue(t + e);else {
                    var o = this.getSelectionStart(),
                      n = this.getSelectionEnd();
                    this.setValue(t.substring(0, o) + e + t.substring(n, t.length));
                  }
                }, t.prototype.getSelectionStart = function () {
                  return this.instance.selectionStart;
                }, t.prototype.getSelectionEnd = function () {
                  return this.instance.selectionEnd;
                }, t.prototype.setSelectionRange = function (e, t) {
                  void 0 === t && (t = e), this.instance.setSelectionRange(e, t);
                }, Object.defineProperty(t.prototype, "isFocused", {
                  get: function () {
                    return this.instance === this.j.od.activeElement;
                  },
                  enumerable: !1,
                  configurable: !0
                }), t.prototype.focus = function () {
                  this.instance.focus();
                }, t.prototype.blur = function () {
                  this.instance.blur();
                }, t.prototype.setPlaceHolder = function (e) {
                  this.instance.setAttribute("placeholder", e);
                }, t.prototype.setReadOnly = function (e) {
                  e ? this.instance.setAttribute("readonly", "true") : this.instance.removeAttribute("readonly");
                }, t.prototype.selectAll = function () {
                  this.instance.select();
                }, t.prototype.replaceUndoManager = function () {
                  var e = this,
                    t = this.jodit.history;
                  this.j.e.on(this.instance, "keydown", function (o) {
                    if ((o.ctrlKey || o.metaKey) && "z" === o.key) return o.shiftKey ? t.redo() : t.undo(), e.setSelectionRange(e.getValue().length), !1;
                  });
                }, t;
              }(o(36729).SourceEditor);
            t.TextAreaEditor = a;
          },
          52834: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            n.__exportStar(o(58633), t), n.__exportStar(o(34186), t);
          },
          94785: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.createSourceEditor = void 0;
            var n = o(40332),
              r = o(52834);
            t.createSourceEditor = function (e, t, o, i, a) {
              var s;
              if ((0, n.isFunction)(e)) s = e(t);else switch (e) {
                case "ace":
                  if (!t.o.shadowRoot) {
                    s = new r.AceEditor(t, o, i, a);
                    break;
                  }
                default:
                  s = new r.TextAreaEditor(t, o, i, a);
              }
              return s.init(t), s.onReadyAlways(function () {
                s.setReadOnly(t.o.readonly);
              }), s;
            };
          },
          36729: function (e, t) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.SourceEditor = void 0;
            var o = function () {
              function e(e, t, o, n) {
                this.jodit = e, this.container = t, this.toWYSIWYG = o, this.fromWYSIWYG = n, this.className = "", this.isReady = !1;
              }
              return Object.defineProperty(e.prototype, "j", {
                get: function () {
                  return this.jodit;
                },
                enumerable: !1,
                configurable: !0
              }), e.prototype.onReady = function () {
                this.replaceUndoManager(), this.isReady = !0, this.j.e.fire(this, "ready");
              }, e.prototype.onReadyAlways = function (e) {
                var t;
                this.isReady ? e() : null === (t = this.j.events) || void 0 === t || t.on(this, "ready", e);
              }, e;
            }();
            t.SourceEditor = o;
          },
          86030: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.source = void 0;
            var n = o(20255);
            o(68197);
            var r = o(86893),
              i = o(86893),
              a = o(57549),
              s = o(24263),
              l = o(40332),
              c = o(43441),
              u = o(17332),
              d = o(94785);
            o(13985);
            var p = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.buttons = [{
                  name: "source",
                  group: "source"
                }], t.__lock = !1, t.__oldMirrorValue = "", t.tempMarkerStart = "{start-jodit-selection}", t.tempMarkerStartReg = /{start-jodit-selection}/g, t.tempMarkerEnd = "{end-jodit-selection}", t.tempMarkerEndReg = /{end-jodit-selection}/g, t.getSelectionStart = function () {
                  var e, o;
                  return null !== (o = null === (e = t.sourceEditor) || void 0 === e ? void 0 : e.getSelectionStart()) && void 0 !== o ? o : 0;
                }, t.getSelectionEnd = function () {
                  var e, o;
                  return null !== (o = null === (e = t.sourceEditor) || void 0 === e ? void 0 : e.getSelectionEnd()) && void 0 !== o ? o : 0;
                }, t;
              }
              return n.__extends(t, e), t.prototype.onInsertHTML = function (e) {
                var t;
                if (!this.j.o.readonly && !this.j.isEditorMode()) return null === (t = this.sourceEditor) || void 0 === t || t.insertRaw(e), this.toWYSIWYG(), !1;
              }, t.prototype.fromWYSIWYG = function (e) {
                if (void 0 === e && (e = !1), !this.__lock || !0 === e) {
                  this.__lock = !0;
                  var t = this.j.getEditorValue(!1, i.SOURCE_CONSUMER);
                  t !== this.getMirrorValue() && this.setMirrorValue(t), this.__lock = !1;
                }
              }, t.prototype.toWYSIWYG = function () {
                if (!this.__lock) {
                  var e = this.getMirrorValue();
                  e !== this.__oldMirrorValue && (this.__lock = !0, this.j.value = e, this.__lock = !1, this.__oldMirrorValue = e);
                }
              }, t.prototype.getNormalPosition = function (e, t) {
                for (t = t.replace(/<(script|style|iframe)[^>]*>[^]*?<\/\1>/im, function (e) {
                  for (var t = "", o = 0; e.length > o; o += 1) t += i.INVISIBLE_SPACE;
                  return t;
                }); e > 0 && t[e] === i.INVISIBLE_SPACE;) e--;
                for (var o = e; o > 0;) {
                  if ("<" === t[--o] && void 0 !== t[o + 1] && t[o + 1].match(/[\w/]+/i)) return o;
                  if (">" === t[o]) return e;
                }
                return e;
              }, t.prototype.clnInv = function (e) {
                return e.replace(r.INVISIBLE_SPACE_REG_EXP(), "");
              }, t.prototype.onSelectAll = function (e) {
                var t;
                if ("selectall" === e.toLowerCase() && this.j.getRealMode() === i.MODE_SOURCE) return null === (t = this.sourceEditor) || void 0 === t || t.selectAll(), !1;
              }, t.prototype.getMirrorValue = function () {
                var e;
                return (null === (e = this.sourceEditor) || void 0 === e ? void 0 : e.getValue()) || "";
              }, t.prototype.setMirrorValue = function (e) {
                var t;
                null === (t = this.sourceEditor) || void 0 === t || t.setValue(e);
              }, t.prototype.setFocusToMirror = function () {
                var e;
                null === (e = this.sourceEditor) || void 0 === e || e.focus();
              }, t.prototype.saveSelection = function () {
                if (this.j.getRealMode() === r.MODE_WYSIWYG) this.j.s.save(), this.j.synchronizeValues(), this.fromWYSIWYG(!0);else {
                  if (this.j.o.editHTMLDocumentMode) return;
                  var e = this.getMirrorValue();
                  if (this.getSelectionStart() === this.getSelectionEnd()) {
                    var t = this.j.s.marker(!0),
                      o = this.getNormalPosition(this.getSelectionStart(), this.getMirrorValue());
                    this.setMirrorValue(e.substring(0, o) + this.clnInv(t.outerHTML) + e.substring(o));
                  } else {
                    var n = this.j.s.marker(!0),
                      i = this.j.s.marker(!1),
                      a = (o = this.getNormalPosition(this.getSelectionStart(), e), this.getNormalPosition(this.getSelectionEnd(), e));
                    this.setMirrorValue(e.substring(0, o) + this.clnInv(n.outerHTML) + e.substring(o, a - o) + this.clnInv(i.outerHTML) + e.substring(a));
                  }
                  this.toWYSIWYG();
                }
              }, t.prototype.removeSelection = function () {
                if (this.j.getRealMode() === r.MODE_WYSIWYG) return this.__lock = !0, this.j.s.restore(), void (this.__lock = !1);
                var e = this.getMirrorValue(),
                  t = 0,
                  o = 0;
                try {
                  if (e = e.replace(/<span[^>]+data-jodit-selection_marker=(["'])start\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerStart).replace(/<span[^>]+data-jodit-selection_marker=(["'])end\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerEnd), !this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                    var n = this.j.e.fire("beautifyHTML", e);
                    (0, l.isString)(n) && (e = n);
                  }
                  if (o = t = e.indexOf(this.tempMarkerStart), e = e.replace(this.tempMarkerStartReg, ""), -1 !== t) {
                    var i = e.indexOf(this.tempMarkerEnd);
                    -1 !== i && (o = i);
                  }
                  e = e.replace(this.tempMarkerEndReg, "");
                } finally {
                  e = e.replace(this.tempMarkerEndReg, "").replace(this.tempMarkerStartReg, "");
                }
                this.setMirrorValue(e), this.setMirrorSelectionRange(t, o), this.toWYSIWYG(), this.setFocusToMirror();
              }, t.prototype.setMirrorSelectionRange = function (e, t) {
                var o;
                null === (o = this.sourceEditor) || void 0 === o || o.setSelectionRange(e, t);
              }, t.prototype.onReadonlyReact = function () {
                var e;
                null === (e = this.sourceEditor) || void 0 === e || e.setReadOnly(this.j.o.readonly);
              }, t.prototype.afterInit = function (e) {
                var t = this;
                if (this.mirrorContainer = e.c.div("jodit-source"), e.workplace.appendChild(this.mirrorContainer), e.e.on("afterAddPlace changePlace afterInit", function () {
                  e.workplace.appendChild(t.mirrorContainer);
                }), this.sourceEditor = (0, d.createSourceEditor)("area", e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG), e.e.on(e.ow, "keydown", function (e) {
                  var o;
                  e.key === i.KEY_ESC && (null === (o = t.sourceEditor) || void 0 === o ? void 0 : o.isFocused) && t.sourceEditor.blur();
                }), this.onReadonlyReact(), e.e.on("placeholder.source", function (e) {
                  var o;
                  null === (o = t.sourceEditor) || void 0 === o || o.setPlaceHolder(e);
                }).on("change.source", this.syncValueFromWYSIWYG).on("beautifyHTML", function (e) {
                  return e;
                }), e.o.beautifyHTML) {
                  var o = function () {
                    var t,
                      o = e.ow.html_beautify;
                    return !(!o || e.isInDestruct || (null === (t = e.events) || void 0 === t || t.off("beautifyHTML").on("beautifyHTML", function (e) {
                      return o(e);
                    }), 0));
                  };
                  o() || (0, l.loadNext)(e, e.o.beautifyHTMLCDNUrlsJS).then(o);
                }
                this.syncValueFromWYSIWYG(!0), this.initSourceEditor(e);
              }, t.prototype.syncValueFromWYSIWYG = function (e) {
                void 0 === e && (e = !1);
                var t = this.j;
                t.getMode() !== i.MODE_SPLIT && t.getMode() !== i.MODE_SOURCE || this.fromWYSIWYG(e);
              }, t.prototype.initSourceEditor = function (e) {
                var t,
                  o = this;
                if ("area" !== e.o.sourceEditor) {
                  var n = (0, d.createSourceEditor)(e.o.sourceEditor, e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG);
                  n.onReadyAlways(function () {
                    var t, r;
                    null === (t = o.sourceEditor) || void 0 === t || t.destruct(), o.sourceEditor = n, o.syncValueFromWYSIWYG(!0), null === (r = e.events) || void 0 === r || r.fire("sourceEditorReady", e);
                  });
                } else null === (t = this.sourceEditor) || void 0 === t || t.onReadyAlways(function () {
                  var t;
                  o.syncValueFromWYSIWYG(!0), null === (t = e.events) || void 0 === t || t.fire("sourceEditorReady", e);
                });
              }, t.prototype.beforeDestruct = function () {
                this.sourceEditor && (this.sourceEditor.destruct(), delete this.sourceEditor), s.Dom.safeRemove(this.mirrorContainer);
              }, n.__decorate([(0, c.watch)(":insertHTML.source")], t.prototype, "onInsertHTML", null), n.__decorate([c.autobind], t.prototype, "fromWYSIWYG", null), n.__decorate([c.autobind], t.prototype, "toWYSIWYG", null), n.__decorate([c.autobind], t.prototype, "getNormalPosition", null), n.__decorate([(0, c.watch)(":beforeCommand.source")], t.prototype, "onSelectAll", null), n.__decorate([(0, c.watch)(":beforeSetMode.source")], t.prototype, "saveSelection", null), n.__decorate([(0, c.watch)(":afterSetMode.source")], t.prototype, "removeSelection", null), n.__decorate([c.autobind], t.prototype, "setMirrorSelectionRange", null), n.__decorate([(0, c.watch)(":readonly.source")], t.prototype, "onReadonlyReact", null), n.__decorate([c.autobind], t.prototype, "syncValueFromWYSIWYG", null), t;
            }(a.Plugin);
            t.source = p, u.pluginSystem.add("source", p);
          },
          50876: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.spellcheck = !1, r.Icon.set("spellcheck", o(69546)), n.Config.prototype.controls.spellcheck = {
              isActive: function (e) {
                return e.o.spellcheck;
              },
              icon: o(69546),
              name: "spellcheck",
              command: "toggleSpellcheck",
              tooltip: "Spellcheck"
            };
          },
          87882: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
            var n = o(5586);
            t.ar = n;
            var r = o(66023);
            t.cs_cz = r;
            var i = o(65860);
            t.de = i;
            var a = o(86055);
            t.es = a;
            var s = o(50037);
            t.fa = s;
            var l = o(7118);
            t.fr = l;
            var c = o(30298);
            t.he = c;
            var u = o(52107);
            t.hu = u;
            var d = o(31240);
            t.id = d;
            var p = o(4101);
            t.it = p;
            var f = o(69286);
            t.ja = f;
            var h = o(13402);
            t.ko = h;
            var m = o(1242);
            t.mn = m;
            var v = o(89574);
            t.nl = v;
            var g = o(63630);
            t.pl = g;
            var y = o(72212);
            t.pt_br = y;
            var _ = o(82570);
            t.ru = _;
            var b = o(19323);
            t.tr = b;
            var w = o(50279);
            t.zh_cn = w;
            var S = o(98364);
            t.zh_tw = S;
          },
          17002: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.spellcheck = void 0;
            var n = o(20255),
              r = o(57549),
              i = o(67309),
              a = o(43441),
              s = o(17332);
            o(50876);
            var l = function (e) {
              function t(t) {
                var n = e.call(this, t) || this;
                return n.buttons = [{
                  group: "state",
                  name: "spellcheck"
                }], (0, s.extendLang)(o(87882)), n;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.e.on("afterInit afterAddPlace prepareWYSIWYGEditor", this.toggleSpellcheck), this.toggleSpellcheck(), e.registerCommand("toggleSpellcheck", function () {
                  t.jodit.o.spellcheck = !t.jodit.o.spellcheck, t.toggleSpellcheck(), t.j.e.fire("updateToolbar");
                });
              }, t.prototype.toggleSpellcheck = function () {
                (0, i.attr)(this.jodit.editor, "spellcheck", this.jodit.o.spellcheck);
              }, t.prototype.beforeDestruct = function (e) {}, n.__decorate([a.autobind], t.prototype, "toggleSpellcheck", null), t;
            }(r.Plugin);
            t.spellcheck = l, s.pluginSystem.add("spellcheck", l);
          },
          59818: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.showCharsCounter = !0, n.Config.prototype.countHTMLChars = !1, n.Config.prototype.showWordsCounter = !0;
          },
          1557: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.stat = void 0;
            var n = o(20255),
              r = o(86893),
              i = o(85605),
              a = o(24263),
              s = o(17332);
            o(59818);
            var l = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.charCounter = null, t.wordCounter = null, t.reInit = function () {
                  t.j.o.showCharsCounter && t.charCounter && t.j.statusbar.append(t.charCounter, !0), t.j.o.showWordsCounter && t.wordCounter && t.j.statusbar.append(t.wordCounter, !0), t.j.e.off("change keyup", t.calc).on("change keyup", t.calc), t.calc();
                }, t.calc = t.j.async.throttle(function () {
                  var e = t.j.text;
                  if (t.j.o.showCharsCounter && t.charCounter) {
                    var o = t.j.o.countHTMLChars ? t.j.value : e.replace((0, r.SPACE_REG_EXP)(), "");
                    t.charCounter.textContent = t.j.i18n("Chars: %d", o.length);
                  }
                  t.j.o.showWordsCounter && t.wordCounter && (t.wordCounter.textContent = t.j.i18n("Words: %d", e.replace((0, r.INVISIBLE_SPACE_REG_EXP)(), "").split((0, r.SPACE_REG_EXP)()).filter(function (e) {
                    return e.length;
                  }).length));
                }, t.j.defaultTimeout), t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function () {
                this.charCounter = this.j.c.span(), this.wordCounter = this.j.c.span(), this.j.e.on("afterInit changePlace afterAddPlace", this.reInit), this.reInit();
              }, t.prototype.beforeDestruct = function () {
                a.Dom.safeRemove(this.charCounter), a.Dom.safeRemove(this.wordCounter), this.j.e.off("afterInit changePlace afterAddPlace", this.reInit), this.charCounter = null, this.wordCounter = null;
              }, t;
            }(i.Plugin);
            t.stat = l, s.pluginSystem.add("stat", l);
          },
          40790: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166);
            n.Config.prototype.toolbarSticky = !0, n.Config.prototype.toolbarDisableStickyForMobile = !0, n.Config.prototype.toolbarStickyOffset = 0;
          },
          82808: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.sticky = void 0;
            var n = o(20255);
            o(60057);
            var r = o(86893),
              i = o(85605),
              a = o(24263),
              s = o(40332),
              l = o(43441),
              c = o(17332);
            o(40790);
            var u = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.isToolbarSticked = !1, t.createDummy = function (e) {
                  r.IS_IE && !t.dummyBox && (t.dummyBox = t.j.c.div(), t.dummyBox.classList.add("jodit_sticky-dummy_toolbar"), t.j.container.insertBefore(t.dummyBox, e));
                }, t.addSticky = function (e) {
                  t.isToolbarSticked || (t.createDummy(e), t.j.container.classList.add("jodit_sticky"), t.isToolbarSticked = !0), (0, s.css)(e, {
                    top: t.j.o.toolbarStickyOffset || null,
                    width: t.j.container.offsetWidth - 2
                  }), r.IS_IE && t.dummyBox && (0, s.css)(t.dummyBox, {
                    height: e.offsetHeight
                  });
                }, t.removeSticky = function (e) {
                  t.isToolbarSticked && ((0, s.css)(e, {
                    width: "",
                    top: ""
                  }), t.j.container.classList.remove("jodit_sticky"), t.isToolbarSticked = !1);
                }, t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.e.on(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.onScroll).on("getStickyState.sticky", function () {
                  return t.isToolbarSticked;
                });
              }, t.prototype.onScroll = function () {
                var e = this.jodit,
                  t = e.ow.pageYOffset || e.od.documentElement && e.od.documentElement.scrollTop || 0,
                  o = (0, s.offset)(e.container, e, e.od, !0),
                  n = e.getMode() === r.MODE_WYSIWYG && t + e.o.toolbarStickyOffset > o.top && o.top + o.height > t + e.o.toolbarStickyOffset && !(e.o.toolbarDisableStickyForMobile && this.isMobile());
                if (e.o.toolbarSticky && !0 === e.o.toolbar && this.isToolbarSticked !== n) {
                  var i = e.toolbarContainer;
                  i && (n ? this.addSticky(i) : this.removeSticky(i)), e.e.fire("toggleSticky", n);
                }
              }, t.prototype.isMobile = function () {
                return this.j && this.j.options && this.j.container && this.j.o.sizeSM >= this.j.container.offsetWidth;
              }, t.prototype.beforeDestruct = function (e) {
                this.dummyBox && a.Dom.safeRemove(this.dummyBox), e.e.off(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.onScroll).off(".sticky");
              }, n.__decorate([(0, l.throttle)()], t.prototype, "onScroll", null), t;
            }(i.Plugin);
            t.sticky = u, c.pluginSystem.add("sticky", u);
          },
          31750: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(77904);
            n.Config.prototype.usePopupForSpecialCharacters = !1, n.Config.prototype.specialCharacters = ["!", "&quot;", "#", "$", "%", "&amp;", "'", "(", ")", "*", "+", "-", ".", "/", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":", ";", "&lt;", "=", "&gt;", "?", "@", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "[", "]", "^", "_", "`", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "{", "|", "}", "~", "&euro;", "&lsquo;", "&rsquo;", "&ldquo;", "&rdquo;", "&ndash;", "&mdash;", "&iexcl;", "&cent;", "&pound;", "&curren;", "&yen;", "&brvbar;", "&sect;", "&uml;", "&copy;", "&ordf;", "&laquo;", "&raquo;", "&not;", "&reg;", "&macr;", "&deg;", "&sup2;", "&sup3;", "&acute;", "&micro;", "&para;", "&middot;", "&cedil;", "&sup1;", "&ordm;", "&frac14;", "&frac12;", "&frac34;", "&iquest;", "&Agrave;", "&Aacute;", "&Acirc;", "&Atilde;", "&Auml;", "&Aring;", "&AElig;", "&Ccedil;", "&Egrave;", "&Eacute;", "&Ecirc;", "&Euml;", "&Igrave;", "&Iacute;", "&Icirc;", "&Iuml;", "&ETH;", "&Ntilde;", "&Ograve;", "&Oacute;", "&Ocirc;", "&Otilde;", "&Ouml;", "&times;", "&Oslash;", "&Ugrave;", "&Uacute;", "&Ucirc;", "&Uuml;", "&Yacute;", "&THORN;", "&szlig;", "&agrave;", "&aacute;", "&acirc;", "&atilde;", "&auml;", "&aring;", "&aelig;", "&ccedil;", "&egrave;", "&eacute;", "&ecirc;", "&euml;", "&igrave;", "&iacute;", "&icirc;", "&iuml;", "&eth;", "&ntilde;", "&ograve;", "&oacute;", "&ocirc;", "&otilde;", "&ouml;", "&divide;", "&oslash;", "&ugrave;", "&uacute;", "&ucirc;", "&uuml;", "&yacute;", "&thorn;", "&yuml;", "&OElig;", "&oelig;", "&#372;", "&#374", "&#373", "&#375;", "&sbquo;", "&#8219;", "&bdquo;", "&hellip;", "&trade;", "&#9658;", "&bull;", "&rarr;", "&rArr;", "&hArr;", "&diams;", "&asymp;"], r.Icon.set("symbols", o(43158)), n.Config.prototype.controls.symbols = {
              hotkeys: ["ctrl+shift+i", "cmd+shift+i"],
              tooltip: "Insert Special Character",
              popup: function (e, t, o, n) {
                var r = e.e.fire("generateSpecialCharactersTable.symbols");
                if (r) {
                  if (e.o.usePopupForSpecialCharacters) {
                    var i = e.c.div();
                    return i.classList.add("jodit-symbols"), i.appendChild(r), e.e.on(r, "close_dialog", n), i;
                  }
                  e.alert(r, "Select Special Character", void 0, "jodit-symbols").bindDestruct(e);
                  var a = r.querySelector("a");
                  a && a.focus();
                }
              }
            };
          },
          21236: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
            var n = o(54261);
            t.ar = n;
            var r = o(60425);
            t.cs_cz = r;
            var i = o(7057);
            t.de = i;
            var a = o(48356);
            t.es = a;
            var s = o(11428);
            t.fa = s;
            var l = o(29084);
            t.fr = l;
            var c = o(22876);
            t.he = c;
            var u = o(20890);
            t.hu = u;
            var d = o(75987);
            t.id = d;
            var p = o(60379);
            t.it = p;
            var f = o(99950);
            t.ja = f;
            var h = o(60934);
            t.ko = h;
            var m = o(45913);
            t.mn = m;
            var v = o(21994);
            t.nl = v;
            var g = o(38128);
            t.pl = g;
            var y = o(71515);
            t.pt_br = y;
            var _ = o(58194);
            t.ru = _;
            var b = o(65802);
            t.tr = b;
            var w = o(86628);
            t.zh_cn = w;
            var S = o(32210);
            t.zh_tw = S;
          },
          48560: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.symbols = void 0;
            var n = o(20255);
            o(33393);
            var r = o(86893),
              i = o(85605),
              a = o(24263),
              s = o(76502),
              l = o(17332);
            o(31750);
            var c = function (e) {
              function t(t) {
                var n = e.call(this, t) || this;
                return n.buttons = [{
                  name: "symbols",
                  group: "insert"
                }], n.countInRow = 17, (0, l.extendLang)(o(21236)), n;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                var t = this;
                e.e.on("generateSpecialCharactersTable.symbols", function () {
                  for (var o = e.c.fromHTML('<div class="jodit-symbols__container">\n\t\t\t\t\t\t<div class="jodit-symbols__container_table">\n\t\t\t\t\t\t\t<table class="jodit-symbols__table"><tbody></tbody></table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jodit-symbols__container_preview">\n\t\t\t\t\t\t\t<div class="jodit-symbols__preview"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>'), n = o.querySelector(".jodit-symbols__preview"), i = o.querySelector("table").tBodies[0], l = [], c = 0; e.o.specialCharacters.length > c;) {
                    for (var u = e.c.element("tr"), d = 0; t.countInRow > d && e.o.specialCharacters.length > c; d += 1, c += 1) {
                      var p = e.c.element("td"),
                        f = e.c.fromHTML('<a\n\t\t\t\t\t\t\t\t\tdata-index="'.concat(c, '"\n\t\t\t\t\t\t\t\t\tdata-index-j="').concat(d, '"\n\t\t\t\t\t\t\t\t\trole="option"\n\t\t\t\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\t\t>').concat(e.o.specialCharacters[c], "</a>"));
                      l.push(f), p.appendChild(f), u.appendChild(p);
                    }
                    i.appendChild(u);
                  }
                  var h = t;
                  return e.e.on(l, "focus", function () {
                    n.innerHTML = this.innerHTML;
                  }).on(l, "mousedown", function (t) {
                    a.Dom.isTag(this, "a") && (e.s.focus(), e.s.insertHTML(this.innerHTML), e.e.fire(this, "close_dialog"), t && t.preventDefault(), t && t.stopImmediatePropagation());
                  }).on(l, "mouseenter", function () {
                    a.Dom.isTag(this, "a") && this.focus();
                  }).on(l, "keydown", function (t) {
                    var o = t.target;
                    if (a.Dom.isTag(o, "a")) {
                      var n = parseInt((0, s.attr)(o, "-index") || "0", 10),
                        i = parseInt((0, s.attr)(o, "data-index-j") || "0", 10),
                        c = void 0;
                      switch (t.key) {
                        case r.KEY_UP:
                        case r.KEY_DOWN:
                          void 0 === l[c = t.key === r.KEY_UP ? n - h.countInRow : n + h.countInRow] && (c = t.key === r.KEY_UP ? Math.floor(l.length / h.countInRow) * h.countInRow + i : i) > l.length - 1 && (c -= h.countInRow), l[c] && l[c].focus();
                          break;
                        case r.KEY_RIGHT:
                        case r.KEY_LEFT:
                          void 0 === l[c = t.key === r.KEY_LEFT ? n - 1 : n + 1] && (c = t.key === r.KEY_LEFT ? l.length - 1 : 0), l[c] && l[c].focus();
                          break;
                        case r.KEY_ENTER:
                          e.e.fire(o, "mousedown"), t.stopImmediatePropagation(), t.preventDefault();
                      }
                    }
                  }), o;
                });
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off("generateSpecialCharactersTable.symbols");
              }, t;
            }(i.Plugin);
            t.symbols = c, l.pluginSystem.add("symbols", c);
          },
          15797: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(20255).__exportStar(o(41170), t);
          },
          41170: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.onTabInsideLi = void 0;
            var n = o(20255),
              r = o(24263);
            o(603), t.onTabInsideLi = function (e, t) {
              if (void 0 === t && (t = !1), !e.o.tab.tabInsideLiInsertNewList) return !1;
              var o = n.__read(function (e) {
                  var t = e.createInside.fake(),
                    o = e.createInside.fake(),
                    n = e.s.range.cloneRange();
                  n.collapse(!0), n.insertNode(t);
                  var r = e.s.range.cloneRange();
                  return r.collapse(!1), r.insertNode(o), [t, o];
                }(e), 2),
                i = o[0],
                a = o[1];
              try {
                var s = function (e, t, o) {
                  var n = r.Dom.closest(t, "li", e.editor);
                  return !!n && !(!o && !r.Dom.isTag(n.previousElementSibling, "li")) && !(o && !r.Dom.closest(n, "li", e.editor)) && n;
                }(e, i, t);
                if (!s) return !1;
                if (!function (e, t, o) {
                  var n = r.Dom.closest(o, "li", t.editor);
                  return !(!n || n !== e && !e.contains(n));
                }(s, e, i)) return !1;
                var l = r.Dom.closest(s, ["ol", "ul"], e.editor);
                return !(!l || t && !r.Dom.closest(l, "li", e.editor) || (t ? function (e, t, o) {
                  var n = r.Dom.closest(t, "li", e.editor),
                    i = Array.from(t.children).filter(function (e) {
                      return r.Dom.isTag(e, "li");
                    });
                  r.Dom.after(n, o);
                  var a = i.indexOf(o);
                  if (0 !== a && 1 !== i.length || r.Dom.safeRemove(t), a !== i.length - 1) {
                    var s = t.cloneNode();
                    r.Dom.append(o, s);
                    for (var l = a + 1; i.length > l; l += 1) r.Dom.append(s, i[l]);
                  }
                }(e, l, s) : function (e, t, o) {
                  var n = o.previousElementSibling,
                    i = n.lastElementChild,
                    a = r.Dom.isTag(i, t.tagName) ? i : e.createInside.element(t.tagName, Array.from(t.attributes).reduce(function (e, t) {
                      return e[t.name] = t.value, e;
                    }, {}));
                  a.appendChild(o), i !== a && n.appendChild(a);
                }(e, l, s), 0));
              } finally {
                var c = e.s.createRange();
                c.setStartAfter(i), c.setEndBefore(a), e.s.selectRange(c), r.Dom.safeRemove(i), r.Dom.safeRemove(a);
              }
              return !1;
            };
          },
          56198: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.tab = {
              tabInsideLiInsertNewList: !0
            };
          },
          32246: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(57549),
              i = o(43441),
              a = o(86893),
              s = o(17332),
              l = o(15797);
            o(56198);
            var c = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {}, t.prototype.__onTab = function (e) {
                if (e.key === a.KEY_TAB && this.__onShift(e.shiftKey)) return !1;
              }, t.prototype.__onCommand = function (e) {
                if (("indent" === e || "outdent" === e) && this.__onShift("outdent" === e)) return !1;
              }, t.prototype.__onShift = function (e) {
                var t = (0, l.onTabInsideLi)(this.j, e);
                return t && this.j.e.fire("afterTab", e), t;
              }, t.prototype.beforeDestruct = function (e) {}, n.__decorate([(0, i.watch)(":keydown.tab")], t.prototype, "__onTab", null), n.__decorate([(0, i.watch)(":beforeCommand.tab")], t.prototype, "__onCommand", null), t;
            }(r.Plugin);
            s.pluginSystem.add("tab", c);
          },
          23308: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.tableKeyboardNavigation = void 0;
            var n = o(86893),
              r = o(24263),
              i = o(25120),
              a = o(17332);
            function s(e) {
              e.e.off(".tableKeyboardNavigation").on("keydown.tableKeyboardNavigation", function (t) {
                var o, a;
                if ((t.key === n.KEY_TAB || t.key === n.KEY_LEFT || t.key === n.KEY_RIGHT || t.key === n.KEY_UP || t.key === n.KEY_DOWN) && (o = e.s.current(), a = r.Dom.up(o, function (e) {
                  return e && e.nodeName && /^td|th$/i.test(e.nodeName);
                }, e.editor))) {
                  var s = e.s.range;
                  if (t.key === n.KEY_TAB || o === a || (t.key !== n.KEY_LEFT && t.key !== n.KEY_UP || !(r.Dom.prev(o, function (e) {
                    return t.key === n.KEY_UP ? r.Dom.isTag(e, "br") : Boolean(e);
                  }, a) || t.key !== n.KEY_UP && r.Dom.isText(o) && 0 !== s.startOffset)) && (t.key !== n.KEY_RIGHT && t.key !== n.KEY_DOWN || !(r.Dom.next(o, function (e) {
                    return t.key === n.KEY_DOWN ? r.Dom.isTag(e, "br") : Boolean(e);
                  }, a) || t.key !== n.KEY_DOWN && r.Dom.isText(o) && o.nodeValue && s.startOffset !== o.nodeValue.length))) {
                    var l = r.Dom.up(a, function (e) {
                        return e && /^table$/i.test(e.nodeName);
                      }, e.editor),
                      c = null;
                    switch (t.key) {
                      case n.KEY_TAB:
                      case n.KEY_LEFT:
                        var u = t.key === n.KEY_LEFT || t.shiftKey ? "prev" : "next";
                        (c = r.Dom[u](a, function (e) {
                          return e && /^td|th$/i.test(e.tagName);
                        }, l)) || (i.Table.appendRow(l, "next" !== u && l.querySelector("tr"), "next" === u, e.createInside), c = r.Dom[u](a, r.Dom.isCell, l));
                        break;
                      case n.KEY_UP:
                      case n.KEY_DOWN:
                        var d = 0,
                          p = 0,
                          f = i.Table.formalMatrix(l, function (e, t, o) {
                            e === a && (d = t, p = o);
                          });
                        t.key === n.KEY_UP ? void 0 !== f[d - 1] && (c = f[d - 1][p]) : void 0 !== f[d + 1] && (c = f[d + 1][p]);
                    }
                    if (c) {
                      if (c.firstChild) t.key === n.KEY_TAB ? e.s.select(c, !0) : e.s.setCursorIn(c, t.key === n.KEY_RIGHT || t.key === n.KEY_DOWN);else {
                        var h = e.createInside.element("br");
                        c.appendChild(h), e.s.setCursorBefore(h);
                      }
                      return !1;
                    }
                  }
                }
              });
            }
            t.tableKeyboardNavigation = s, a.pluginSystem.add("tableKeyboardNavigation", s);
          },
          30739: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(64968),
              i = o(76502),
              a = o(40332),
              s = o(77904);
            n.Config.prototype.table = {
              selectionCellStyle: "border: 1px double #1e88e5 !important;",
              useExtraClassesOptions: !1
            }, s.Icon.set("table", o(51716)), n.Config.prototype.controls.table = {
              data: {
                cols: 10,
                rows: 10,
                classList: {
                  "table table-bordered": "Bootstrap Bordered",
                  "table table-striped": "Bootstrap Striped",
                  "table table-dark": "Bootstrap Dark"
                }
              },
              popup: function (e, t, o, n, s) {
                for (var l = o.data && o.data.rows ? o.data.rows : 10, c = o.data && o.data.cols ? o.data.cols : 10, u = e.c.fromHTML('<form class="jodit-form jodit-form__inserter"><div class="jodit-form__table-creator-box"><div class="jodit-form__container"></div><div class="jodit-form__options">' + function () {
                    if (!e.o.table.useExtraClassesOptions) return "";
                    var t = [];
                    if (o.data) {
                      var n = o.data.classList;
                      Object.keys(n).forEach(function (e) {
                        t.push('<label class="jodit_vertical_middle"><input class="jodit-checkbox" value="'.concat(e, '" type="checkbox"/>').concat(n[e], "</label>"));
                      });
                    }
                    return t.join("");
                  }() + '</div></div><label class="jodit-form__center"><span>1</span> &times; <span>1</span></label></form>'), d = u.querySelectorAll("span")[0], p = u.querySelectorAll("span")[1], f = u.querySelector(".jodit-form__container"), h = u.querySelector(".jodit-form__options"), m = [], v = l * c, g = 0; v > g; g += 1) m[g] || m.push(e.c.element("span", {
                  dataIndex: g
                }));
                if (e.e.on(f, "mousemove", function (e, t) {
                  var o = e.target;
                  if (r.Dom.isTag(o, "span")) {
                    for (var n = void 0 === t || isNaN(t) ? parseInt((0, i.attr)(o, "-index") || "0", 10) : t || 0, a = Math.ceil((n + 1) / c), s = n % c + 1, l = 0; m.length > l; l += 1) m[l].className = l % c + 1 > s || a < Math.ceil((l + 1) / c) ? "" : "jodit_hovered";
                    p.textContent = s.toString(), d.textContent = a.toString();
                  }
                }).on(f, "touchstart mousedown", function (t) {
                  var o = t.target;
                  if (t.preventDefault(), t.stopImmediatePropagation(), r.Dom.isTag(o, "span")) {
                    var s = parseInt((0, i.attr)(o, "-index") || "0", 10),
                      l = Math.ceil((s + 1) / c),
                      u = s % c + 1,
                      d = e.createInside,
                      p = d.element("tbody"),
                      f = d.element("table");
                    f.appendChild(p);
                    for (var m, v, g = null, y = 1; l >= y; y += 1) {
                      m = d.element("tr");
                      for (var _ = 1; u >= _; _ += 1) v = d.element("td"), g || (g = v), (0, a.css)(v, "width", (100 / u).toFixed(4) + "%"), v.appendChild(d.element("br")), m.appendChild(d.text("\n")), m.appendChild(d.text("\t")), m.appendChild(v);
                      p.appendChild(d.text("\n")), p.appendChild(m);
                    }
                    (0, a.$$)("input[type=checkbox]:checked", h).forEach(function (e) {
                      e.value.split(/[\s]+/).forEach(function (e) {
                        f.classList.add(e);
                      });
                    }), e.editor.firstChild && e.s.insertNode(d.text("\n"), !1, !1), e.s.insertNode(f, !1), g && (e.s.setCursorIn(g), (0, a.scrollIntoViewIfNeeded)(g, e.editor, e.ed)), n();
                  }
                }), s && s.parentElement) {
                  for (g = 0; l > g; g += 1) {
                    for (var y = e.c.div(), _ = 0; c > _; _ += 1) y.appendChild(m[g * c + _]);
                    f.appendChild(y);
                  }
                  m[0] && (m[0].className = "hovered");
                }
                return u;
              },
              tooltip: "Insert table"
            };
          },
          45842: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.table = void 0, o(51057);
            var n = o(17332);
            function r(e) {
              e.registerButton({
                name: "table",
                group: "insert"
              });
            }
            o(30739), t.table = r, n.pluginSystem.add("table", r);
          },
          79114: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(93166),
              r = o(718),
              i = o(40332),
              a = o(95963),
              s = o(96516);
            o(77904).Icon.set("video", o(49222)), n.Config.prototype.controls.video = {
              popup: function (e, t, o, n) {
                var l = new a.UIForm(e, [new a.UIBlock(e, [new a.UIInput(e, {
                    name: "url",
                    required: !0,
                    label: "URL",
                    placeholder: "https://",
                    validators: ["url"]
                  })]), new a.UIBlock(e, [(0, s.Button)(e, "", "Insert", "primary").onAction(function () {
                    return l.submit();
                  })])]),
                  c = new a.UIForm(e, [new a.UIBlock(e, [new a.UITextArea(e, {
                    name: "code",
                    required: !0,
                    label: "Embed code"
                  })]), new a.UIBlock(e, [(0, s.Button)(e, "", "Insert", "primary").onAction(function () {
                    return c.submit();
                  })])]),
                  u = [],
                  d = function (t) {
                    e.s.restore(), e.s.insertHTML(t), n();
                  };
                return e.s.save(), u.push({
                  icon: "link",
                  name: "Link",
                  content: l.container
                }, {
                  icon: "source",
                  name: "Code",
                  content: c.container
                }), l.onSubmit(function (e) {
                  d((0, i.convertMediaUrlToVideoEmbed)(e.url));
                }), c.onSubmit(function (e) {
                  d(e.code);
                }), (0, r.TabsWidget)(e, u);
              },
              tags: ["iframe"],
              tooltip: "Insert youtube/vimeo video"
            };
          },
          19889: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(17332);
            o(79114), n.pluginSystem.add("video", function (e) {
              e.registerButton({
                name: "video",
                group: "media"
              });
            });
          },
          64401: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.wrapNodes = {
              exclude: ["hr", "style", "br"],
              emptyBlockAfterInit: !0
            };
          },
          20728: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255),
              r = o(57549),
              i = o(64968),
              a = o(24421),
              s = o(43441),
              l = o(17332);
            o(64401);
            var c = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.isSuitableStart = function (e) {
                  return i.Dom.isText(e) && (0, a.isString)(e.nodeValue) && /[^\s]/.test(e.nodeValue) || t.isNotClosed(e) && !i.Dom.isTemporary(e);
                }, t.isSuitable = function (e) {
                  return i.Dom.isText(e) || t.isNotClosed(e);
                }, t.isNotClosed = function (e) {
                  return i.Dom.isElement(e) && !(i.Dom.isBlock(e) || i.Dom.isTag(e, t.j.o.wrapNodes.exclude));
                }, t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function (e) {
                "br" !== e.o.enter.toLowerCase() && e.e.on("drop.wtn focus.wtn keydown.wtn mousedown.wtn afterInit.wtn", this.preprocessInput, {
                  top: !0
                }).on("afterInit.wtn postProcessSetEditorValue.wtn", this.postProcessSetEditorValue);
              }, t.prototype.beforeDestruct = function (e) {
                e.e.off(".wtn");
              }, t.prototype.postProcessSetEditorValue = function () {
                var e = this.jodit;
                if (e.isEditorMode()) {
                  for (var t = e.editor.firstChild, o = !1; t;) {
                    if (t = this.checkAloneListLeaf(t, e), this.isSuitableStart(t)) {
                      o || e.s.save(), o = !0;
                      var n = e.createInside.element(e.o.enter);
                      for (i.Dom.before(t, n); t && this.isSuitable(t);) {
                        var r = t.nextSibling;
                        n.appendChild(t), t = r;
                      }
                      n.normalize(), t = n;
                    }
                    t = t && t.nextSibling;
                  }
                  o && (e.s.restore(), "afterInit" === e.e.current && e.e.fire("internalChange"));
                }
              }, t.prototype.checkAloneListLeaf = function (e, t) {
                var o = e,
                  n = e;
                do {
                  if (!i.Dom.isElement(n) || !i.Dom.isTag(n, "li") || i.Dom.isTag(n.parentElement, ["ul", "ol"])) break;
                  var r = i.Dom.findNotEmptySibling(n, !1);
                  i.Dom.isTag(o, "ul") ? o.appendChild(n) : o = i.Dom.wrap(n, "ul", t.createInside), n = r;
                } while (n);
                return o;
              }, t.prototype.preprocessInput = function () {
                var e = this.jodit,
                  t = "afterInit" === e.e.current;
                if (e.isEditorMode() && !e.editor.firstChild && (e.o.wrapNodes.emptyBlockAfterInit || !t)) {
                  var o = e.createInside.element(e.o.enter),
                    n = e.createInside.element("br");
                  i.Dom.append(o, n), i.Dom.append(e.editor, o), e.s.isFocused() && e.s.setCursorBefore(n), e.e.fire("internalChange");
                }
              }, n.__decorate([s.autobind], t.prototype, "postProcessSetEditorValue", null), n.__decorate([s.autobind], t.prototype, "preprocessInput", null), t;
            }(r.Plugin);
            l.pluginSystem.add("wrapNodes", c);
          },
          71707: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(93166).Config.prototype.showXPathInStatusbar = !0;
          },
          18238: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var n = o(20255);
            o(64618);
            var r = o(86893),
              i = o(60403),
              a = o(64968),
              s = o(40332),
              l = o(57549),
              c = o(81438),
              u = o(17332);
            o(71707);
            var d = function (e) {
              function t() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.onContext = function (e, o) {
                  return t.menu || (t.menu = new i.ContextMenu(t.j)), t.menu.show(o.clientX, o.clientY, [{
                    icon: "bin",
                    title: e === t.j.editor ? "Clear" : "Remove",
                    exec: function () {
                      e !== t.j.editor ? a.Dom.safeRemove(e) : t.j.value = "", t.j.synchronizeValues();
                    }
                  }, {
                    icon: "select-all",
                    title: "Select",
                    exec: function () {
                      t.j.s.select(e);
                    }
                  }]), !1;
                }, t.onSelectPath = function (e, o) {
                  t.j.s.focus();
                  var n = (0, s.attr)(o.target, "-path") || "/";
                  if ("/" === n) return t.j.execCommand("selectall"), !1;
                  try {
                    var r = t.j.ed.evaluate(n, t.j.editor, null, XPathResult.ANY_TYPE, null).iterateNext();
                    if (r) return t.j.s.select(r), !1;
                  } catch (e) {}
                  return t.j.s.select(e), !1;
                }, t.tpl = function (e, o, n, r) {
                  var i = t.j.c.fromHTML('<span class="jodit-xpath__item"><a role="button" data-path="'.concat(o, '" title="').concat(r, '" tabindex="-1"\'>').concat((0, s.trim)(n), "</a></span>")),
                    a = i.firstChild;
                  return t.j.e.on(a, "click", t.onSelectPath.bind(t, e)).on(a, "contextmenu", t.onContext.bind(t, e)), i;
                }, t.removeSelectAll = function () {
                  t.selectAllButton && (t.selectAllButton.destruct(), delete t.selectAllButton);
                }, t.appendSelectAll = function () {
                  t.removeSelectAll(), t.selectAllButton = (0, c.makeButton)(t.j, n.__assign({
                    name: "selectall"
                  }, t.j.o.controls.selectall)), t.selectAllButton.state.size = "tiny", t.container && t.container.insertBefore(t.selectAllButton.container, t.container.firstChild);
                }, t.calcPathImd = function () {
                  if (!t.isDestructed) {
                    var e,
                      o,
                      n,
                      i = t.j.s.current();
                    t.container && (t.container.innerHTML = r.INVISIBLE_SPACE), i && a.Dom.up(i, function (r) {
                      r && t.j.editor !== r && !a.Dom.isText(r) && (e = r.nodeName.toLowerCase(), o = (0, s.getXPathByElement)(r, t.j.editor).replace(/^\//, ""), n = t.tpl(r, o, e, t.j.i18n("Select %s", e)), t.container && t.container.insertBefore(n, t.container.firstChild));
                    }, t.j.editor), t.appendSelectAll();
                  }
                }, t.calcPath = t.j.async.debounce(t.calcPathImd, 2 * t.j.defaultTimeout), t;
              }
              return n.__extends(t, e), t.prototype.afterInit = function () {
                var e = this;
                this.j.o.showXPathInStatusbar && (this.container = this.j.c.div("jodit-xpath"), this.j.e.off(".xpath").on("mouseup.xpath change.xpath keydown.xpath changeSelection.xpath", this.calcPath).on("afterSetMode.xpath afterInit.xpath changePlace.xpath", function () {
                  e.j.o.showXPathInStatusbar && e.container && (e.j.statusbar.append(e.container), e.j.getRealMode() === r.MODE_WYSIWYG ? e.calcPath() : (e.container && (e.container.innerHTML = r.INVISIBLE_SPACE), e.appendSelectAll()));
                }), this.calcPath());
              }, t.prototype.beforeDestruct = function () {
                this.j && this.j.events && this.j.e.off(".xpath"), this.removeSelectAll(), this.menu && this.menu.destruct(), a.Dom.safeRemove(this.container), delete this.menu, delete this.container;
              }, t;
            }(l.Plugin);
            u.pluginSystem.add("xpath", d);
          },
          89019: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), o(61227), o(690), o(66622), o(69220), o(10444), Array.prototype.includes || (Array.prototype.includes = function (e) {
              return this.indexOf(e) > -1;
            }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
              value: function (e, t) {
                if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                for (var o = Object(e), n = 1; arguments.length > n; n++) {
                  var r = arguments[n];
                  if (null != r) for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (o[i] = r[i]);
                }
                return o;
              },
              writable: !0,
              configurable: !0
            }), Array.prototype.find || (Array.prototype.find = function (e) {
              return this.indexOf(e) > -1 ? e : void 0;
            }), String.prototype.endsWith || (String.prototype.endsWith = function (e) {
              return this[this.length - 1] === e;
            });
          },
          15261: function (e, t, o) {

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.valign = t.upload = t.update = t.unlock = t.settings = t.save = t.right = t.resize_handler = t.plus = t.pencil = t.ok = t.lock = t.left = t.info_circle = t.folder = t.file = t.eye = t.dots = t.chevron = t.check = t.center = t.cancel = t.bin = t.angle_up = t.angle_right = t.angle_left = t.angle_down = void 0;
            var n = o(1755);
            t.angle_down = n;
            var r = o(74911);
            t.angle_left = r;
            var i = o(8805);
            t.angle_right = i;
            var a = o(16547);
            t.angle_up = a;
            var s = o(10856);
            t.bin = s;
            var l = o(98441);
            t.cancel = l;
            var c = o(52488);
            t.center = c;
            var u = o(9370);
            t.check = u;
            var d = o(66543);
            t.chevron = d;
            var p = o(608);
            t.dots = p;
            var f = o(42840);
            t.eye = f;
            var h = o(79096);
            t.file = h;
            var m = o(33014);
            t.folder = m;
            var v = o(91677);
            t.info_circle = v;
            var g = o(8259);
            t.left = g;
            var y = o(64467);
            t.lock = y;
            var _ = o(86934);
            t.ok = _;
            var b = o(76133);
            t.pencil = b;
            var w = o(45519);
            t.plus = w;
            var S = o(90265);
            t.resize_handler = S;
            var C = o(81279);
            t.right = C;
            var j = o(68899);
            t.save = j;
            var E = o(70744);
            t.settings = E;
            var x = o(19201);
            t.unlock = x;
            var k = o(84930);
            t.update = k;
            var T = o(99704);
            t.upload = T;
            var I = o(2304);
            t.valign = I;
          },
          80078: function (e) {
            e.exports = {
              "copy-format": "نسخ التنسيق"
            };
          },
          16986: function (e) {
            e.exports = {
              "copy-format": "Kopírovat formát"
            };
          },
          59347: function (e) {
            e.exports = {
              "copy-format": "Format kopierenт"
            };
          },
          63640: function (e) {
            e.exports = {
              "copy-format": "Copiar formato"
            };
          },
          53434: function (e) {
            e.exports = {
              "copy-format": "کپی کردن قالب"
            };
          },
          85638: function (e) {
            e.exports = {
              "copy-format": "Format de copie"
            };
          },
          31743: function (e) {
            e.exports = {
              "copy-format": "העתק עיצוב"
            };
          },
          66219: function (e) {
            e.exports = {
              "copy-format": "Formátum másolás"
            };
          },
          50331: function (e) {
            e.exports = {
              "copy-format": "salin format"
            };
          },
          25582: function (e) {
            e.exports = {
              "copy-format": "Copia il formato"
            };
          },
          82066: function (e) {
            e.exports = {
              "copy-format": "copyformat"
            };
          },
          71925: function (e) {
            e.exports = {
              "copy-format": "복사 형식"
            };
          },
          12689: function (e) {
            e.exports = {
              "copy-format": "Формат хуулах"
            };
          },
          65274: function (e) {
            e.exports = {
              "copy-format": "opmaak kopiëren"
            };
          },
          58548: function (e) {
            e.exports = {
              "copy-format": "format kopii"
            };
          },
          82958: function (e) {
            e.exports = {
              "copy-format": "Copiar formato"
            };
          },
          52315: function (e) {
            e.exports = {
              "copy-format": "Копировать формат"
            };
          },
          87727: function (e) {
            e.exports = {
              "copy-format": "Kopyalama Biçimi"
            };
          },
          9396: function (e) {
            e.exports = {
              "copy-format": "复制格式"
            };
          },
          28765: function (e) {
            e.exports = {
              "copy-format": "複製格式"
            };
          },
          47762: function (e) {
            e.exports = {
              "Line height": "ارتفاع الخط"
            };
          },
          97495: function (e) {
            e.exports = {
              "Line height": "Výška čáry"
            };
          },
          80131: function (e) {
            e.exports = {
              "Line height": "Zeilenhöhe"
            };
          },
          1201: function (e) {
            e.exports = {
              "Line height": "Altura de la línea"
            };
          },
          89912: function (e) {
            e.exports = {
              "Line height": "ارتفاع خط"
            };
          },
          3405: function (e) {
            e.exports = {
              "Line height": "Hauteur de ligne"
            };
          },
          14129: function (e) {
            e.exports = {
              "Line height": "גובה שורה"
            };
          },
          93729: function (e) {
            e.exports = {
              "Line height": "Vonal magassága"
            };
          },
          16106: function (e) {
            e.exports = {
              "Line height": "Tinggi baris"
            };
          },
          89690: function (e) {
            e.exports = {
              "Line height": "Altezza linea"
            };
          },
          33216: function (e) {
            e.exports = {
              "Line height": "ラインの高さ"
            };
          },
          17282: function (e) {
            e.exports = {
              "Line height": "선 높이"
            };
          },
          52841: function (e) {
            e.exports = {
              "Line height": "Зураасны өндөр"
            };
          },
          91761: function (e) {
            e.exports = {
              "Line height": "Lijnhoogte"
            };
          },
          61675: function (e) {
            e.exports = {
              "Line height": "Wysokość linii"
            };
          },
          69709: function (e) {
            e.exports = {
              "Line height": "Altura da linha"
            };
          },
          82591: function (e) {
            e.exports = {
              "Line height": "Высота линии"
            };
          },
          87649: function (e) {
            e.exports = {
              "Line height": "Çizgi yüksekliği"
            };
          },
          60268: function (e) {
            e.exports = {
              "Line height": "线高"
            };
          },
          58214: function (e) {
            e.exports = {
              "Line height": "ความสูงเส้น"
            };
          },
          5586: function (e) {
            e.exports = {
              Spellcheck: "التدقيق الإملائي"
            };
          },
          66023: function (e) {
            e.exports = {
              Spellcheck: "Kontrola pravopisu"
            };
          },
          65860: function (e) {
            e.exports = {
              Spellcheck: "Rechtschreibprüfung"
            };
          },
          86055: function (e) {
            e.exports = {
              Spellcheck: "Corrección ortográfica"
            };
          },
          50037: function (e) {
            e.exports = {
              Spellcheck: "غلطیابی املایی"
            };
          },
          7118: function (e) {
            e.exports = {
              Spellcheck: "Vérification Orthographique"
            };
          },
          30298: function (e) {
            e.exports = {
              Spellcheck: "בדיקת איות"
            };
          },
          52107: function (e) {
            e.exports = {
              Spellcheck: "Helyesírás-ellenőrzés"
            };
          },
          31240: function (e) {
            e.exports = {
              Spellcheck: "Spellchecking"
            };
          },
          4101: function (e) {
            e.exports = {
              Spellcheck: "Controllo ortografico"
            };
          },
          69286: function (e) {
            e.exports = {
              Spellcheck: "スペルチェック"
            };
          },
          13402: function (e) {
            e.exports = {
              Spellcheck: "맞춤법 검사"
            };
          },
          1242: function (e) {
            e.exports = {
              Spellcheck: "Дүрмийн алдаа шалгах"
            };
          },
          89574: function (e) {
            e.exports = {
              Spellcheck: "Spellingcontrole"
            };
          },
          63630: function (e) {
            e.exports = {
              Spellcheck: "Sprawdzanie pisowni"
            };
          },
          72212: function (e) {
            e.exports = {
              Spellcheck: "Verificação ortográfica"
            };
          },
          82570: function (e) {
            e.exports = {
              Spellcheck: "Проверка орфографии"
            };
          },
          19323: function (e) {
            e.exports = {
              Spellcheck: "Yazım denetimi"
            };
          },
          50279: function (e) {
            e.exports = {
              Spellcheck: "拼写检查"
            };
          },
          98364: function (e) {
            e.exports = {
              Spellcheck: "สะกดคำ"
            };
          },
          54261: function (e) {
            e.exports = {
              symbols: "رمز"
            };
          },
          60425: function (e) {
            e.exports = {
              symbols: "symbol"
            };
          },
          7057: function (e) {
            e.exports = {
              symbols: "Symbol"
            };
          },
          48356: function (e) {
            e.exports = {
              symbols: "Símbolo"
            };
          },
          11428: function (e) {
            e.exports = {
              symbols: "سمبل"
            };
          },
          29084: function (e) {
            e.exports = {
              symbols: "caractère"
            };
          },
          22876: function (e) {
            e.exports = {
              symbols: "תו מיוחד"
            };
          },
          20890: function (e) {
            e.exports = {
              symbols: "Szimbólum"
            };
          },
          75987: function (e) {
            e.exports = {
              symbols: "simbol"
            };
          },
          60379: function (e) {
            e.exports = {
              symbols: "Simbolo"
            };
          },
          99950: function (e) {
            e.exports = {
              symbols: "symbol"
            };
          },
          60934: function (e) {
            e.exports = {
              symbols: "기호"
            };
          },
          45913: function (e) {
            e.exports = {
              symbols: "тэмдэгт"
            };
          },
          21994: function (e) {
            e.exports = {
              symbols: "symbool"
            };
          },
          38128: function (e) {
            e.exports = {
              symbols: "symbol"
            };
          },
          71515: function (e) {
            e.exports = {
              symbols: "Símbolo"
            };
          },
          58194: function (e) {
            e.exports = {
              symbols: "символ"
            };
          },
          65802: function (e) {
            e.exports = {
              symbols: "Sembol"
            };
          },
          86628: function (e) {
            e.exports = {
              symbols: "符号"
            };
          },
          32210: function (e) {
            e.exports = {
              symbols: "符號"
            };
          },
          52378: function (e) {

            e.exports = {
              assert() {}
            };
          }
        },
        o = {};
      function n(e) {
        var r = o[e];
        if (void 0 !== r) return r.exports;
        var i = o[e] = {
          exports: {}
        };
        return t[e].call(i.exports, i, i.exports, n), i.exports;
      }
      n.m = t, e = [], n.O = function (t, o, r, i) {
        if (!o) {
          var a = 1 / 0;
          for (u = 0; e.length > u; u++) {
            o = e[u][0], r = e[u][1], i = e[u][2];
            for (var s = !0, l = 0; o.length > l; l++) (!1 & i || a >= i) && Object.keys(n.O).every(function (e) {
              return n.O[e](o[l]);
            }) ? o.splice(l--, 1) : (s = !1, a > i && (a = i));
            if (s) {
              e.splice(u--, 1);
              var c = r();
              void 0 !== c && (t = c);
            }
          }
          return t;
        }
        i = i || 0;
        for (var u = e.length; u > 0 && e[u - 1][2] > i; u--) e[u] = e[u - 1];
        e[u] = [o, r, i];
      }, n.g = function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e) {
          if ("object" == typeof window) return window;
        }
      }(), n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, function () {
        var e = {
          670: 0
        };
        n.O.j = function (t) {
          return 0 === e[t];
        };
        var t = function (t, o) {
            var r,
              i,
              a = o[0],
              s = o[1],
              l = o[2],
              c = 0;
            if (a.some(function (t) {
              return 0 !== e[t];
            })) {
              for (r in s) n.o(s, r) && (n.m[r] = s[r]);
              if (l) var u = l(n);
            }
            for (t && t(o); a.length > c; c++) n.o(e, i = a[c]) && e[i] && e[i][0](), e[i] = 0;
            return n.O(u);
          },
          o = self.webpackChunkjodit = self.webpackChunkjodit || [];
        o.forEach(t.bind(null, 0)), o.push = t.bind(null, o.push.bind(o));
      }();
      var r = {};
      return function () {

        var e = r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommitMode = e.Jodit = void 0, n(90176), "undefined" != typeof window && n(89019);
        var t = n(37920);
        Object.defineProperty(e, "Jodit", {
          enumerable: !0,
          get: function () {
            return t.Jodit;
          }
        });
        var o = n(26435),
          i = n(43441),
          a = n(86893),
          s = n(87837),
          l = n(15261);
        n(70022), n(91147), Object.keys(a).forEach(function (e) {
          t.Jodit[e] = a[e];
        });
        var c = function (e) {
          return "__esModule" !== e;
        };
        Object.keys(l).filter(c).forEach(function (e) {
          s.Icon.set(e.replace("_", "-"), l[e]);
        }), Object.keys(s).filter(c).forEach(function (e) {
          t.Jodit.modules[e] = s[e];
        }), Object.keys(i).filter(c).forEach(function (e) {
          t.Jodit.decorators[e] = i[e];
        }), ["Confirm", "Alert", "Prompt"].forEach(function (e) {
          t.Jodit[e] = s[e];
        }), Object.keys(o.default).filter(c).forEach(function (e) {
          t.Jodit.lang[e] = o.default[e];
        }), e.CommitMode = function () {};
      }(), n.O(r);
    }();
  });
});
unwrapExports(jodit_min);

var joditReact = createCommonjsModule(function (module, exports) {
  !function (t, o) {
     module.exports = o(React__default, jodit_min) ;
  }(self, (t, o) => (() => {
    var i = {
        922: t => {

          t.exports = function (t) {
            var o = [];
            return o.toString = function () {
              return this.map(function (o) {
                var i = "",
                  e = void 0 !== o[5];
                return o[4] && (i += "@supports (".concat(o[4], ") {")), o[2] && (i += "@media ".concat(o[2], " {")), e && (i += "@layer".concat(o[5].length > 0 ? " ".concat(o[5]) : "", " {")), i += t(o), e && (i += "}"), o[2] && (i += "}"), o[4] && (i += "}"), i;
              }).join("");
            }, o.i = function (t, i, e, a, r) {
              "string" == typeof t && (t = [[null, t, void 0]]);
              var n = {};
              if (e) for (var d = 0; d < this.length; d++) {
                var l = this[d][0];
                null != l && (n[l] = !0);
              }
              for (var s = 0; s < t.length; s++) {
                var c = [].concat(t[s]);
                e && n[c[0]] || (void 0 !== r && (void 0 === c[5] || (c[1] = "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = r), i && (c[2] ? (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}"), c[2] = i) : c[2] = i), a && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = a) : c[4] = "".concat(a)), o.push(c));
              }
            }, o;
          };
        },
        155: t => {

          t.exports = function (t, o) {
            return o || (o = {}), t ? (t = String(t.__esModule ? t.default : t), /^['"].*['"]$/.test(t) && (t = t.slice(1, -1)), o.hash && (t += o.hash), /["'() \t\n]|(%20)/.test(t) || o.needQuotes ? '"'.concat(t.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : t) : t;
          };
        },
        499: t => {

          t.exports = function (t) {
            return t[1];
          };
        },
        428: (t, o, i) => {

          var e = i(134);
          function a() {}
          function r() {}
          r.resetWarningCache = a, t.exports = function () {
            function t(t, o, i, a, r, n) {
              if (n !== e) {
                var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw d.name = "Invariant Violation", d;
              }
            }
            function o() {
              return t;
            }
            t.isRequired = t;
            var i = {
              array: t,
              bigint: t,
              bool: t,
              func: t,
              number: t,
              object: t,
              string: t,
              symbol: t,
              any: t,
              arrayOf: o,
              element: t,
              elementType: t,
              instanceOf: o,
              node: t,
              objectOf: o,
              oneOf: o,
              oneOfType: o,
              shape: o,
              exact: o,
              checkPropTypes: r,
              resetWarningCache: a
            };
            return i.PropTypes = i, i;
          };
        },
        526: (t, o, i) => {
          t.exports = i(428)();
        },
        134: t => {

          t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        472: (t, o, i) => {

          i.d(o, {
            Z: () => g
          });
          var e = i(499),
            a = i.n(e),
            r = i(922),
            n = i.n(r),
            d = i(155),
            l = i.n(d),
            s = new URL(i(456), i.b),
            c = new URL(i(963), i.b),
            p = new URL(i(910), i.b),
            b = n()(a()),
            u = l()(s),
            x = l()(c),
            _ = l()(p);
          b.push([t.id, '/*!\n * jodit - Jodit is awesome and usefully wysiwyg editor with filebrowser\n * Author: Chupurnov <chupurnov@gmail.com> (https://xdsoft.net/)\n * Version: v3.24.7\n * Url: https://xdsoft.net/jodit/\n * License(s): MIT\n */\n\t.jodit-wysiwyg{outline:0}.jodit-wysiwyg ::-moz-selection, .jodit-wysiwyg::-moz-selection{background:#b5d6fd;color:#4c4c4c}.jodit-wysiwyg ::selection,.jodit-wysiwyg::selection{background:#b5d6fd;color:#4c4c4c}.jodit-container:not(.jodit_inline) .jodit-wysiwyg{margin:0;outline:0;overflow-x:auto;padding:8px;position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg img{max-width:100%;position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media{position:relative}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media *{position:relative;z-index:0}.jodit-container:not(.jodit_inline) .jodit-wysiwyg jodit-media:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:1}.jodit-form{color:#4c4c4c;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px}.jodit-form.jodit_error{border-color:#ff3b3b;-webkit-box-shadow:inset 0 0 3px 0 hsla(0,0%,74%,.3);box-shadow:inset 0 0 3px 0 hsla(0,0%,74%,.3)}@media (max-width:768px){.jodit-form{min-width:150px}}.jodit-form button{background:#d6d6d6;border:none;color:#4c4c4c;cursor:pointer;font-size:16px;height:36px;line-height:1;margin-bottom:8px;margin-top:8px;outline:none;padding:8px;text-decoration:none;-webkit-transition:background .2s ease 0s;-o-transition:background .2s ease 0s;transition:background .2s ease 0s}.jodit-form button:hover{background-color:#ecebe9;color:#4c4c4c}.jodit-form button:active{background:#ecebe9;color:#4c4c4c}.jodit-form label{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px;text-align:left;white-space:nowrap}.jodit-form label:last-child{margin-bottom:0}.jodit-form .jodit-form__center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit .jodit-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:1px solid #dadada;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit .jodit-select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:1px solid #dadada;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit .jodit-textarea{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:1px solid #dadada;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit .jodit-input[disabled]{background-color:#f0f0f0;color:#dadada}.jodit .jodit-select[disabled]{background-color:#f0f0f0;color:#dadada}.jodit .jodit-textarea[disabled]{background-color:#f0f0f0;color:#dadada}.jodit .jodit-input_has-error_true{border-color:#ff3b3b}.jodit .jodit-select_has-error_true{border-color:#ff3b3b}.jodit .jodit-textarea_has-error_true{border-color:#ff3b3b}.jodit .jodit-input:focus{border-color:#66afe9;outline:0}.jodit-checkbox{border:0;cursor:pointer;height:16px;margin:0 calc(8px/2) 0 0;outline:none;padding:0;position:relative;width:16px;z-index:2}.jodit-select{background-image:url(' + u + ');background-position:98% 50%;background-repeat:no-repeat;padding-right:calc(8px*2)}.jodit-textarea{height:auto}.jodit-form__group{min-width:180px}.jodit-textarea{min-width:180px}.jodit-form__group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.jodit-form__group{margin-bottom:8px}.jodit-form__group>label{margin-bottom:8px}.jodit-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#dadada;border:0;border-radius:.25rem;color:#4c4c4c;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:calc(8px*4);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;margin:0;padding:0 8px;position:relative;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:auto}.jodit-button svg{display:inline-block;height:24px;width:24px}.jodit-button svg+span{margin-left:calc(8px/2)}.jodit-button:active,.jodit-button:focus{outline:0}.jodit-button.disabled{opacity:.7}.jodit-buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:8px}.jodit-button .jodit_icon,.jodit-button svg,.jodit-dialog__header .jodit_icon,.jodit-dialog__header svg{display:inline-block;height:16px;vertical-align:middle;width:16px}.jodit-switcher{display:inline-block;height:32px;position:relative;width:60px}.jodit-switcher input{height:0;opacity:0;width:0}.jodit-switcher .jodit-switcher__slider{background-color:#dadada;border-radius:32px;bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0;-webkit-transition:.4s;-o-transition:.4s;transition:.4s}.jodit-switcher .jodit-switcher__slider:before{background-color:#fff;border-radius:50%;bottom:4px;content:"";height:calc(32px - 4px*2);left:4px;position:absolute;-webkit-transition:.4s;-o-transition:.4s;transition:.4s;width:calc(32px - 4px*2)}input:checked+.jodit-switcher__slider{background-color:#2196f3}input:checked+.jodit-switcher__slider:before{-webkit-transform:translateX(calc(60px - 4px*2 - calc(32px - 4px*2)));-ms-transform:translateX(calc(60px - 4px*2 - calc(32px - 4px*2)));transform:translateX(calc(60px - 4px*2 - calc(32px - 4px*2)))}input:focus+.jodit-switcher__slider{-webkit-box-shadow:0 0 1px #2196f3;box-shadow:0 0 1px #2196f3}.jodit-button-group{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-button-group input{display:none}.jodit-button-group button{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.jodit-button-group button+button{margin-left:-1px}.jodit-button-group button:first-child,.jodit-button-group input:first-child+button{border-bottom-right-radius:0;border-right:0;border-top-right-radius:0}.jodit-button-group button:last-child,.jodit-button-group input:last-child+button{border-bottom-left-radius:0;border-left:0;border-top-left-radius:0}.jodit-button-group input[type=checkbox]:checked+button,.jodit-button-group input[type=checkbox]:not(:checked)+button+button{background-image:none;-webkit-box-shadow:inset 0 2px 4px rgba(0,0,0,.3),0 1px 2px rgba(0,0,0,.05);box-shadow:inset 0 2px 4px rgba(0,0,0,.3),0 1px 2px rgba(0,0,0,.05)}.jodit_text_icons .jodit_icon{font-size:14px;width:auto}.jodit_text_icons .jodit_icon:first-letter{text-transform:uppercase}.jodit_text_icons .jodit-tabs .jodit-tabs__buttons>a{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;width:auto}.jodit_text_icons .jodit-tabs .jodit-tabs__buttons>a i{width:auto}.jodit_text_icons.jodit-dialog .jodit-button{color:rgba(0,0,0,.75);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;padding:8px;width:auto}.jodit_text_icons.jodit-dialog .jodit-dialog__header a{color:rgba(0,0,0,.75);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;padding:8px;width:auto}.jodit_text_icons.jodit-dialog .jodit-button .jodit_icon,.jodit_text_icons.jodit-dialog .jodit-dialog__header a .jodit_icon{width:auto}.jodit-grid{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.jodit-grid.jodit-grid_column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (max-width:480px){.jodit-grid.jodit-grid_xs-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.jodit-grid [class*=jodit_col-]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.jodit-grid .jodit_col-lg-5-5{width:100%}.jodit-grid .jodit_col-lg-4-5{width:80%}.jodit-grid .jodit_col-lg-3-5{width:60%}.jodit-grid .jodit_col-lg-2-5{width:40%}.jodit-grid .jodit_col-lg-1-5{width:20%}.jodit-grid .jodit_col-lg-4-4{width:100%}.jodit-grid .jodit_col-lg-3-4{width:75%}.jodit-grid .jodit_col-lg-2-4{width:50%}.jodit-grid .jodit_col-lg-1-4{width:25%}@media (max-width:992px){.jodit-grid .jodit_col-md-5-5{width:100%}.jodit-grid .jodit_col-md-4-5{width:80%}.jodit-grid .jodit_col-md-3-5{width:60%}.jodit-grid .jodit_col-md-2-5{width:40%}.jodit-grid .jodit_col-md-1-5{width:20%}.jodit-grid .jodit_col-md-4-4{width:100%}.jodit-grid .jodit_col-md-3-4{width:75%}.jodit-grid .jodit_col-md-2-4{width:50%}.jodit-grid .jodit_col-md-1-4{width:25%}}@media (max-width:768px){.jodit-grid .jodit_col-sm-5-5{width:100%}.jodit-grid .jodit_col-sm-4-5{width:80%}.jodit-grid .jodit_col-sm-3-5{width:60%}.jodit-grid .jodit_col-sm-2-5{width:40%}.jodit-grid .jodit_col-sm-1-5{width:20%}.jodit-grid .jodit_col-sm-4-4{width:100%}.jodit-grid .jodit_col-sm-3-4{width:75%}.jodit-grid .jodit_col-sm-2-4{width:50%}.jodit-grid .jodit_col-sm-1-4{width:25%}}@media (max-width:480px){.jodit-grid .jodit_col-xs-5-5{width:100%}.jodit-grid .jodit_col-xs-4-5{width:80%}.jodit-grid .jodit_col-xs-3-5{width:60%}.jodit-grid .jodit_col-xs-2-5{width:40%}.jodit-grid .jodit_col-xs-1-5{width:20%}.jodit-grid .jodit_col-xs-4-4{width:100%}.jodit-grid .jodit_col-xs-3-4{width:75%}.jodit-grid .jodit_col-xs-2-4{width:50%}.jodit-grid .jodit_col-xs-1-4{width:25%}}@-webkit-keyframes a{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes a{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.jodit-icon_loader{-webkit-animation:a 2s ease-out 0s infinite;animation:a 2s ease-out 0s infinite;background:url(' + x + ') no-repeat 50%;background-size:100% 100%;display:inline-block;height:48px;vertical-align:middle;width:48px;will-change:transform}.jodit-icon{fill:#4c4c4c;background:50% no-repeat;background-size:contain;height:14px;overflow:visible;-webkit-transform-origin:0 0!important;-ms-transform-origin:0 0!important;transform-origin:0 0!important;width:14px}.jodit-icon{stroke:#4c4c4c}.jodit-icon_close{stroke:#4c4c4c}svg.jodit-icon{height:auto;isolation:isolate}.jodit-icon_text{font-size:14px}.jodit,.jodit *,.jodit-container,.jodit-container *{-webkit-box-sizing:border-box;box-sizing:border-box}.jodit .jodit-workplace,.jodit-container .jodit-workplace{overflow:auto;position:relative}.jodit .jodit-workplace .jodit-wysiwyg,.jodit .jodit-workplace .jodit-wysiwyg_iframe,.jodit-container .jodit-workplace .jodit-wysiwyg,.jodit-container .jodit-workplace .jodit-wysiwyg_iframe{height:100%;width:100%}.jodit-wysiwyg [contenteditable=false]{cursor:default}.jodit-container:not(.jodit_inline){background-color:#f5f5f6;border:1px solid #dadada;border-radius:3px}.jodit-container:not(.jodit_inline) .jodit-workplace{background-color:#fff;border:0 solid #dadada;max-height:100%}.jodit-container:not(.jodit_inline).jodit_disabled{background:#dadada}.jodit-container:not(.jodit_inline).jodit_disabled .jodit-workplace{opacity:.4}.jodit_disabled,.jodit_lock{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.jodit_hidden{display:none!important}.jodit_vertical_middle{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-box,.jodit-context-menu{background:0 0;border:0;float:none;height:auto;margin:0;max-width:none;outline:0;padding:0;position:static;width:auto}.jodit-context-menu{-webkit-box-shadow:0 4px 1px -2px rgba(76,76,76,.2),0 3px 3px 0 rgba(76,76,76,.15),0 1px 4px 0 rgba(76,76,76,.13);box-shadow:0 4px 1px -2px rgba(76,76,76,.2),0 3px 3px 0 rgba(76,76,76,.15),0 1px 4px 0 rgba(76,76,76,.13);display:inline-block;position:fixed;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:10000001;z-index:30000005}.jodit-context-menu__content{overflow-scrolling:touch;background:#fff;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;max-height:300px;overflow:auto;padding:8px}.jodit-context-menu_padding_false .jodit-context-menu__content{padding:0}.jodit-context-menu_max-height_false .jodit-context-menu__content{max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content}.jodit-context-menu .jodit-ui-button{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-context-menu__actions{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px}.jodit-context-menu__actions button{width:100%}.jodit-context-menu_theme_dark .jodit-context-menu__content{background-color:#575757}.jodit-popup{background:0 0;border:0;-webkit-box-shadow:0 4px 1px -2px rgba(76,76,76,.2),0 3px 3px 0 rgba(76,76,76,.15),0 1px 4px 0 rgba(76,76,76,.13);box-shadow:0 4px 1px -2px rgba(76,76,76,.2),0 3px 3px 0 rgba(76,76,76,.15),0 1px 4px 0 rgba(76,76,76,.13);display:inline-block;float:none;height:auto;margin:0;max-width:none;outline:0;padding:0;position:static;position:fixed;-webkit-transform:translateZ(0);transform:translateZ(0);width:auto;z-index:10000001}.jodit-popup__content{overflow-scrolling:touch;background:#fff;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;max-height:300px;overflow:auto;padding:8px}.jodit-popup_padding_false .jodit-popup__content{padding:0}.jodit-popup_max-height_false .jodit-popup__content{max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content}.jodit-ui-button-icon-text__icon{display:none}.jodit-ui-button-icon-text__icon:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.jodit-ui-button-icon-text__text{display:none}.jodit-ui-button-icon-text__text:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-ui-button-icon-text_context_menu .jodit-ui-button-icon-text__text{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;padding-left:8px;position:relative}.jodit-ui-button-icon-text_context_menu .jodit-ui-button-icon-text__text:before{border-left:1px solid #dadada;content:"";height:35px;left:0;position:absolute;top:calc(8px*-1)}.jodit-ui-button-icon-text__icon:not(:empty)+.jodit-ui-button-icon-text__text:not(:empty){margin-left:8px}.jodit-ui-button-icon-text__icon:empty+.jodit-ui-button-icon-text__text:not(:empty){padding:0 8px}.jodit-ui-button-clear,.jodit-ui-button_clear{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:0;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;font-style:normal;outline:0;padding:0;position:relative;text-align:center;text-decoration:none;text-transform:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-ui-button-sizes{height:34px;min-width:34px}.jodit-ui-button-sizes .jodit-icon{height:14px;width:14px}.jodit-ui-button-sizes button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:34px;min-width:34px;padding:0}.jodit-ui-button-sizes_text-icons_true button{padding:0 8px}.jodit-ui-button-sizes_size_tiny{height:16px;min-width:16px}.jodit-ui-button-sizes_size_tiny .jodit-icon{height:8px;width:8px}.jodit-ui-button-sizes_size_tiny button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:16px;min-width:16px;padding:0}.jodit-ui-button-sizes_size_tiny_text-icons_true button{padding:0 8px}.jodit-ui-button-sizes_size_xsmall{height:22px;min-width:22px}.jodit-ui-button-sizes_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-ui-button-sizes_size_xsmall button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:22px;min-width:22px;padding:0}.jodit-ui-button-sizes_size_xsmall_text-icons_true button{padding:0 8px}.jodit-ui-button-sizes_size_small{height:28px;min-width:28px}.jodit-ui-button-sizes_size_small .jodit-icon{height:12px;width:12px}.jodit-ui-button-sizes_size_small button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;min-width:28px;padding:0}.jodit-ui-button-sizes_size_small_text-icons_true button{padding:0 8px}.jodit-ui-button-sizes_size_large{height:40px;min-width:40px}.jodit-ui-button-sizes_size_large .jodit-icon{height:16px;width:16px}.jodit-ui-button-sizes_size_large button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:40px;min-width:40px;padding:0}.jodit-ui-button-sizes_size_large_text-icons_true button{padding:0 8px}.jodit-ui-button-variants_variant_default{background-color:#e3e3e3;color:#212529}.jodit-ui-button-variants_variant_default svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default [disabled]{opacity:.7}.jodit-ui-button-variants_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button-variants_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button-variants_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button-variants_variant_primary{background-color:#007bff;color:#fff}.jodit-ui-button-variants_variant_primary svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary [disabled]{opacity:.7}.jodit-ui-button-variants_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-ui-button-variants_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-ui-button-variants_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-ui-button-variants_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-ui-button-variants_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary [disabled]{opacity:.7}.jodit-ui-button-variants_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button-variants_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button-variants_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button-variants_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button-variants_variant_success{background-color:#28a745;color:#fff}.jodit-ui-button-variants_variant_success svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success [disabled]{opacity:.7}.jodit-ui-button-variants_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-ui-button-variants_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-ui-button-variants_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-ui-button-variants_variant_danger{background-color:#dc3545;color:#fff}.jodit-ui-button-variants_variant_danger svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger [disabled]{opacity:.7}.jodit-ui-button-variants_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-ui-button-variants_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-ui-button-variants_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button-variants_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-ui-button-style{border-radius:3px;padding:0 8px}.jodit-ui-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:rgba(0,0,0,.75);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-ui-button-style{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:rgba(0,0,0,.75);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-ui-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:0;border-radius:3px;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;font-style:normal;height:34px;min-width:34px;outline:0;padding:0;padding:0 8px;position:relative;text-align:center;text-decoration:none;text-transform:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-ui-button:focus-visible:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-ui-button:hover:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-ui-button:active:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-ui-button[aria-pressed=true]:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-ui-button[aria-pressed=true]:hover:not([disabled]){background-color:hsla(0,0%,86%,.6)}.jodit-ui-button[disabled]{opacity:.3;pointer-events:none}.jodit-ui-button .jodit-icon{height:14px;width:14px}.jodit-ui-button button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:34px;min-width:34px;padding:0}.jodit-ui-button_text-icons_true button{padding:0 8px}.jodit-ui-button_size_tiny{height:16px;min-width:16px}.jodit-ui-button_size_tiny .jodit-icon{height:8px;width:8px}.jodit-ui-button_size_tiny button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:16px;min-width:16px;padding:0}.jodit-ui-button_size_tiny_text-icons_true button{padding:0 8px}.jodit-ui-button_size_xsmall{height:22px;min-width:22px}.jodit-ui-button_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-ui-button_size_xsmall button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:22px;min-width:22px;padding:0}.jodit-ui-button_size_xsmall_text-icons_true button{padding:0 8px}.jodit-ui-button_size_small{height:28px;min-width:28px}.jodit-ui-button_size_small .jodit-icon{height:12px;width:12px}.jodit-ui-button_size_small button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;min-width:28px;padding:0}.jodit-ui-button_size_small_text-icons_true button{padding:0 8px}.jodit-ui-button_size_large{height:40px;min-width:40px}.jodit-ui-button_size_large .jodit-icon{height:16px;width:16px}.jodit-ui-button_size_large button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:40px;min-width:40px;padding:0}.jodit-ui-button_size_large_text-icons_true button{padding:0 8px}.jodit-ui-button__icon{display:none}.jodit-ui-button__icon:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.jodit-ui-button__text{display:none}.jodit-ui-button__text:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-ui-button_context_menu .jodit-ui-button__text{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;padding-left:8px;position:relative}.jodit-ui-button_context_menu .jodit-ui-button__text:before{border-left:1px solid #dadada;content:"";height:35px;left:0;position:absolute;top:calc(8px*-1)}.jodit-ui-button__icon:not(:empty)+.jodit-ui-button__text:not(:empty){margin-left:8px}.jodit-ui-button__icon:empty+.jodit-ui-button__text:not(:empty){padding:0 8px}.jodit-ui-button:focus:not([disabled]){outline:1px dashed #b5d6fd}.jodit-ui-button_variant_default{background-color:#e3e3e3;color:#212529}.jodit-ui-button_variant_default svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default [disabled]{opacity:.7}.jodit-ui-button_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button_variant_primary{background-color:#007bff;color:#fff}.jodit-ui-button_variant_primary svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary [disabled]{opacity:.7}.jodit-ui-button_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-ui-button_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-ui-button_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-ui-button_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-ui-button_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary [disabled]{opacity:.7}.jodit-ui-button_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-ui-button_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-ui-button_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-ui-button_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-ui-button_variant_success{background-color:#28a745;color:#fff}.jodit-ui-button_variant_success svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success [disabled]{opacity:.7}.jodit-ui-button_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-ui-button_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-ui-button_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-ui-button_variant_danger{background-color:#dc3545;color:#fff}.jodit-ui-button_variant_danger svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger [disabled]{opacity:.7}.jodit-ui-button_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-ui-button_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-ui-button_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-ui-button_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-ui-list{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.jodit-ui-list_mode_vertical .jodit-ui-group{background-color:transparent;border:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.jodit-ui-list_mode_vertical .jodit-toolbar-button{height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2)}.jodit-ui-list_mode_vertical .jodit-toolbar-button__button{cursor:pointer;height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2);width:100%}.jodit-ui-list_mode_vertical .jodit-toolbar-button__text:not(:empty){-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left}.jodit-ui-separator{border-left:0;border-right:1px solid #dadada;cursor:default;margin:2px;padding:0}.jodit-ui-break{border-top:1px solid #dadada;-ms-flex-preferred-size:100%;flex-basis:100%;height:0!important;width:0}.jodit-ui-spacer{-webkit-box-flex:1;-ms-flex:1;flex:1}.jodit-ui-group{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-negative:0;flex-shrink:0;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:100%}.jodit-ui-group_line_true{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}.jodit-ui-group_separated_true:not(:last-child):not(.jodit-ui-group_before-spacer_true):after{border-left:0;border-right:1px solid #dadada;content:"";cursor:default;margin:2px;padding:0}.jodit-ui-group:last-child{border-bottom:0}.jodit-ui-button-group{margin-bottom:8px}.jodit-ui-button-group__label{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-button-group__options{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.jodit-ui-button-group .jodit-ui-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.jodit-ui-button-group .jodit-ui-button+.jodit-ui-button{border-bottom-left-radius:0;border-left:1px solid hsla(0,0%,86%,.4);border-top-left-radius:0}.jodit-ui-button-group .jodit-ui-button[aria-pressed=true]:not([disabled]){background-color:#dcdcdc;border-left:0;-webkit-box-shadow:inset 0 0 3px 0 #4c4c4c;box-shadow:inset 0 0 3px 0 #4c4c4c;color:#4c4c4c;outline:0}.jodit-ui-button-group .jodit-ui-button[aria-pressed=true]:not([disabled])+.jodit-ui-button{border:0}.jodit-ui-tooltip{background:#727171;background-clip:padding-box;border-radius:2px;color:#fff;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;font-size:11px;line-height:1.4;max-width:120px;opacity:0;padding:calc(8px/4) calc(8px/2);position:fixed;text-rendering:optimizeLegibility;-webkit-transition:opacity .2s ease 0s;-o-transition:opacity .2s ease 0s;transition:opacity .2s ease 0s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:normal;width:auto;z-index:30000006}@media (max-width:768px){.jodit-ui-tooltip{display:none}}.jodit-ui-tooltip.jodit-ui-tooltip_visible_true{opacity:1}.jodit-dialog{border:0;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:0;position:absolute;width:0;will-change:left,top,width,height}.jodit-dialog_moved_true{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-dialog *{-webkit-box-sizing:border-box;box-sizing:border-box}.jodit-dialog .jodit_elfinder,.jodit-dialog .jodit_elfinder *{-webkit-box-sizing:initial;box-sizing:initial}.jodit-dialog__overlay{background-color:rgba(0,0,0,.5);display:none;height:100%;left:0;overflow:auto;position:fixed;text-align:center;top:0;white-space:nowrap;width:100%;z-index:20000003}.jodit-dialog_static_true .jodit-dialog__overlay{display:none}.jodit-dialog_active_true,.jodit-dialog_modal_true .jodit-dialog__overlay{display:block}.jodit-dialog__panel{background-color:#fff;-webkit-box-shadow:0 8px calc(8px*2) rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);box-shadow:0 8px calc(8px*2) rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;left:0;max-height:100%;max-width:100%;min-height:100px;min-width:200px;position:fixed;text-align:left;top:0;white-space:normal;z-index:20000004}@media (max-width:480px){.jodit-dialog:not(.jodit-dialog_adaptive_false) .jodit-dialog__panel{height:100%!important;left:0!important;max-width:100%;top:0!important;width:100%!important}}.jodit-dialog_static_true{-webkit-box-sizing:border-box;box-sizing:border-box;display:block;height:auto;position:relative;width:auto;z-index:inherit}.jodit-dialog_static_true .jodit-dialog__panel{border:1px solid #dadada;-webkit-box-shadow:none;box-shadow:none;left:auto!important;position:relative;top:auto!important;width:100%!important;z-index:inherit}.jodit-dialog_theme_dark{background-color:#353535;color:#fff}.jodit-dialog_theme_dark .jodit-dialog__panel{background-color:#353535;color:#fff}.jodit-dialog__header{border-bottom:1px solid #dadada;cursor:move;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:50px;text-align:left}.jodit-dialog__header-title{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:3;flex-shrink:3;font-size:18px;font-weight:400;line-height:48px;margin:0;padding:0 8px;vertical-align:top}.jodit-dialog__header-toolbar{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-negative:3;flex-shrink:3;font-size:18px;font-weight:400;line-height:48px;margin:0;padding:0 8px;vertical-align:top}@media (max-width:480px){.jodit-dialog__header-toolbar{padding-left:0}}.jodit-dialog__header-button{color:#222;-ms-flex-preferred-size:48px;flex-basis:48px;font-size:28px;height:48px;line-height:48px;text-align:center;text-decoration:none;-webkit-transition:background-color .2s ease 0s;-o-transition:background-color .2s ease 0s;transition:background-color .2s ease 0s}.jodit-dialog__header-button:hover{background-color:#ecebe9}.jodit-dialog__header .jodit_toolbar{background:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.jodit-dialog__header .jodit_toolbar>li.jodit-toolbar-button .jodit-input{padding-left:8px;width:auto}@media (max-width:480px){.jodit-dialog:not(.jodit-dialog_adaptive_false) .jodit-dialog__header{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.jodit-dialog_slim_true .jodit-dialog__header{min-height:10px}.jodit-dialog_slim_true .jodit-dialog__header-title{padding:0 calc(8px/4)}.jodit-dialog_slim_true .jodit-dialog__header-toolbar{padding:0 calc(8px/4)}.jodit-dialog_theme_dark .jodit-dialog__header{border-color:#4c4c4c}.jodit-dialog_fullsize_true .jodit-dialog__header{cursor:default}.jodit-dialog__content{-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:100px;overflow:auto}.jodit-dialog__content .jodit-form__group{margin-bottom:calc(8px*1.5);padding:0 8px}.jodit-dialog__content .jodit-form__group:first-child{margin-top:8px}.jodit-dialog__content .jodit-form__group label+.jodit-grid{margin-top:calc(8px/2)}.jodit-dialog__content .jodit-form__group label+.jodit-input_group{margin-top:calc(8px/2)}.jodit-dialog__content .jodit-form__group label+.jodit-select{margin-top:calc(8px/2)}.jodit-dialog__content .jodit-form__group label+input{margin-top:calc(8px/2)}.jodit-dialog__content .jodit-form__group .jodit-input_group{border-collapse:separate;display:table;width:100%}.jodit-dialog__content .jodit-form__group .jodit-input_group>*{display:table-cell;height:34px;vertical-align:middle}.jodit-dialog__content .jodit-form__group .jodit-input_group>input{margin:0!important}.jodit-dialog__content .jodit-form__group .jodit-input_group>input:not([class*=col-]){width:100%}.jodit-dialog__content .jodit-form__group .jodit-input_group-buttons{font-size:0;vertical-align:middle;white-space:nowrap;width:1%}.jodit-dialog__content .jodit-form__group .jodit-input_group-buttons>.jodit-button{border:1px solid #dadada;border-radius:0;height:34px;line-height:34px;margin-left:-1px}.jodit-dialog__footer{display:none;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:8px}.jodit-dialog__footer button{margin-right:calc(8px/2)}.jodit-dialog__footer button:last-child{margin-right:0}.jodit-dialog__column{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-dialog__resizer{display:none;position:relative}.jodit-dialog__resizer svg{fill:#a5a5a5;bottom:0;cursor:nwse-resize;height:12px;overflow:hidden;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:12px}.jodit-dialog_resizable_true .jodit-dialog__resizer{display:block}@media (max-width:480px){.jodit-dialog__resizer{display:none}}.jodit-dialog_prompt{max-width:300px;min-width:200px;padding:8px;word-break:break-all}.jodit-dialog_prompt label{display:block;margin-bottom:calc(8px/2)}.jodit-dialog_alert{max-width:300px;min-width:200px;padding:8px;word-break:break-all}.jodit-dialog_footer_true .jodit-dialog__footer{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit_fullsize .jodit-dialog__panel{bottom:0!important;height:100%!important;left:0!important;right:0!important;top:0!important;width:100%!important}.jodit_fullsize .jodit-dialog__panel .jodit-dialog__resizer{display:none}.jodit-dialog .jodit-ui-messages{z-index:20000004}.jodit-toolbar__box:not(:empty){background-color:#fff;border-bottom:1px solid #dadada;border-radius:3px 3px 0 0;overflow:hidden}.jodit-toolbar__box:not(:empty):not(:empty){background-color:#f9f9f9}.jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after{background-color:#f9f9f9}.jodit-ui-messages{bottom:0;height:0;overflow:visible;position:absolute;right:0;width:0;z-index:3}.jodit-ui-message{background:#cfe2ff;border:1px solid #b6d4fe;border-radius:0.375rem;bottom:0;color:#084298;cursor:pointer;display:block;font-size:1rem;opacity:0;padding:0.5rem 1rem;position:absolute;right:calc(8px/2);-webkit-transition:opacity .1s linear,bottom .3s linear,-webkit-transform .1s ease-out;transition:opacity .1s linear,bottom .3s linear,-webkit-transform .1s ease-out;-o-transition:opacity .1s linear,bottom .3s linear,transform .1s ease-out;transition:opacity .1s linear,bottom .3s linear,transform .1s ease-out;transition:opacity .1s linear,bottom .3s linear,transform .1s ease-out,-webkit-transform .1s ease-out;white-space:pre}.jodit-ui-message_active_true{opacity:1}.jodit-ui-message:active{-webkit-transform:scale(.76);-ms-transform:scale(.76);transform:scale(.76)}.jodit-ui-message_variant_danger{background:#f8d7da;border-color:#f5c2c7;color:#842029}.jodit-ui-message_variant_error{background:#f8d7da;border-color:#f5c2c7;color:#842029}.jodit-ui-message_variant_secondary{background:#e2e3e5;border-color:#d3d6d8;color:#41464b}.jodit-ui-message_variant_success{background:#d1e7dd;border-color:#badbcc;color:#0f5132}.jodit-ui-label{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-input{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:8px}.jodit-ui-input__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:0;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit-ui-input__input[disabled]{background-color:#f0f0f0;color:#dadada}.jodit-ui-input__input_has-error_true{border-color:#ff3b3b}.jodit-ui-input__input:focus{outline:0}.jodit-ui-input_theme_dark .jodit-ui-input__input{background-color:#dadada}.jodit-ui-input_has-error_true .jodit-ui-input__input{border-color:#ff3b3b}.jodit-ui-input__error{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-input__label{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-input__error{color:#ff3b3b}.jodit-ui-input_has-error_true .jodit-ui-input__label{color:#ff3b3b}.jodit-ui-input__wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid #dadada;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-input__wrapper{min-width:140px}}.jodit-ui-input_theme_dark .jodit-ui-input__wrapper{background-color:#dadada;border-color:#dadada}.jodit-ui-input_focused_true .jodit-ui-input__wrapper{border-color:#1e88e5}.jodit-ui-input__icon:not(:empty){-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 8px}.jodit-ui-input__icon:not(:empty) svg{fill:#dadada;height:16px;width:16px}.jodit-ui-input__icon:not(:empty)+.jodit-ui-input__input{padding-left:0}.jodit-ui-input__clear{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:.8;padding:0 8px 0 0}.jodit-ui-input__clear:active{opacity:1;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.jodit-ui-input__clear svg{fill:#dadada;height:12px;width:12px}.jodit-ui-input_theme_dark .jodit-ui-input__clear svg{fill:#4c4c4c}.jodit-ui-input_theme_dark .jodit-ui-input__icon svg{fill:#4c4c4c}.jodit-ui-block .jodit-ui-input{margin-bottom:0}.jodit-ui-select{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:8px}.jodit-ui-select__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:0;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit-ui-select__input[disabled]{background-color:#f0f0f0;color:#dadada}.jodit-ui-select__input_has-error_true{border-color:#ff3b3b}.jodit-ui-select__input:focus{outline:0}.jodit-ui-select_theme_dark .jodit-ui-select__input{background-color:#dadada}.jodit-ui-select_has-error_true .jodit-ui-select__input{border-color:#ff3b3b}.jodit-ui-select__error{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-select__label{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-select__error{color:#ff3b3b}.jodit-ui-select_has-error_true .jodit-ui-select__label{color:#ff3b3b}.jodit-ui-select__wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid #dadada;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-select__wrapper{min-width:140px}}.jodit-ui-select_theme_dark .jodit-ui-select__wrapper{background-color:#dadada;border-color:#dadada}.jodit-ui-select_focused_true .jodit-ui-select__wrapper{border-color:#1e88e5}.jodit-ui-select__icon:not(:empty){-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 8px}.jodit-ui-select__icon:not(:empty) svg{fill:#dadada;height:16px;width:16px}.jodit-ui-select__icon:not(:empty)+.jodit-ui-select__input{padding-left:0}.jodit-ui-select__clear{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:.8;padding:0 8px 0 0}.jodit-ui-select__clear:active{opacity:1;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.jodit-ui-select__clear svg{fill:#dadada;height:12px;width:12px}.jodit-ui-select_theme_dark .jodit-ui-select__clear svg{fill:#4c4c4c}.jodit-ui-select_theme_dark .jodit-ui-select__icon svg{fill:#4c4c4c}.jodit-ui-select__input{background-image:url(' + _ + ');background-position:98% 50%;background-repeat:no-repeat;padding-right:calc(8px*2)}.jodit-ui-select_size_tiny{margin-bottom:0}.jodit-ui-select_size_tiny .jodit-ui-select__input{height:calc(32px/1.8);line-height:calc(32px/1.8)}.jodit-ui-select_variant_outline .jodit-ui-select__wrapper{border:0}.jodit-ui-select_variant_outline .jodit-ui-select__wrapper select{outline:0}.jodit-ui-select_width_auto{width:auto}.jodit-ui-select_width_auto .jodit-ui-select__wrapper{min-width:auto}.jodit-ui-text-area{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:8px;width:100%}.jodit-ui-text-area__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border:0;border-radius:0;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;height:32px;line-height:32px;outline:none;padding:0 8px;width:100%}.jodit-ui-text-area__input[disabled]{background-color:#f0f0f0;color:#dadada}.jodit-ui-text-area__input_has-error_true{border-color:#ff3b3b}.jodit-ui-text-area__input:focus{outline:0}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__input{background-color:#dadada}.jodit-ui-text-area_has-error_true .jodit-ui-text-area__input{border-color:#ff3b3b}.jodit-ui-text-area__error{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-text-area__label{color:#a5a5a5;display:block;font-size:.8em;margin-bottom:calc(8px/4)}.jodit-ui-text-area__error{color:#ff3b3b}.jodit-ui-text-area_has-error_true .jodit-ui-text-area__label{color:#ff3b3b}.jodit-ui-text-area__wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border:1px solid #dadada;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;min-width:200px}@media (max-width:480px){.jodit-ui-text-area__wrapper{min-width:140px}}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__wrapper{background-color:#dadada;border-color:#dadada}.jodit-ui-text-area_focused_true .jodit-ui-text-area__wrapper{border-color:#1e88e5}.jodit-ui-text-area__icon:not(:empty){-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 8px}.jodit-ui-text-area__icon:not(:empty) svg{fill:#dadada;height:16px;width:16px}.jodit-ui-text-area__icon:not(:empty)+.jodit-ui-text-area__input{padding-left:0}.jodit-ui-text-area__clear{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:.8;padding:0 8px 0 0}.jodit-ui-text-area__clear:active{opacity:1;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.jodit-ui-text-area__clear svg{fill:#dadada;height:12px;width:12px}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__clear svg{fill:#4c4c4c}.jodit-ui-text-area_theme_dark .jodit-ui-text-area__icon svg{fill:#4c4c4c}.jodit-ui-text-area__wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1}.jodit-ui-text-area__input{height:100%;min-height:60px}.jodit-ui-checkbox{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:8px}.jodit-ui-checkbox__input{margin-right:8px}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__wrapper{display:inline-block;height:34px;margin-right:8px;position:relative;width:60px}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__wrapper input{height:0;opacity:0;width:0}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__switch-slider{background-color:#ccc;border-radius:34px;bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0;-webkit-transition:.4s;-o-transition:.4s;transition:.4s}.jodit-ui-checkbox_switch_true .jodit-ui-checkbox__switch-slider:before{background-color:#fff;border-radius:50%;bottom:4px;content:"";height:26px;left:4px;position:absolute;-webkit-transition:.4s;-o-transition:.4s;transition:.4s;width:26px}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_checked_true .jodit-ui-checkbox__switch-slider{background-color:#2196f3}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_checked_true .jodit-ui-checkbox__switch-slider:before{-webkit-transform:translateX(26px);-ms-transform:translateX(26px);transform:translateX(26px)}.jodit-ui-checkbox_switch_true.jodit-ui-checkbox_focused_true .jodit-ui-checkbox__switch-slider{-webkit-box-shadow:0 0 1px #2196f3;box-shadow:0 0 1px #2196f3}.jodit-ui-block .jodit-ui-checkbox{margin-bottom:0}.jodit-ui-file-input{overflow:hidden;position:relative}.jodit-ui-file-input__input{bottom:0;cursor:pointer;font-size:400px;margin:0 calc(8px*-1) 0 0;opacity:0;padding:0;position:absolute;right:0;top:0}.jodit-ui-block{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;margin-bottom:8px}.jodit-ui-block_width_full{width:100%}.jodit-ui-block_align_full{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.jodit-ui-block_align_right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.jodit-ui-block_padding_true{padding:8px}@-webkit-keyframes b{30%{opacity:.6}60%{opacity:0}to{opacity:.6}}@keyframes b{30%{opacity:.6}60%{opacity:0}to{opacity:.6}}.jodit-progress-bar{border-radius:1px;height:2px;left:0;opacity:.7;position:absolute;top:0;z-index:2147483647}.jodit-progress-bar div{background:#b91f1f;height:2px;position:relative;-webkit-transition:width .5s ease-out,opacity .5s linear;-o-transition:width .5s ease-out,opacity .5s linear;transition:width .5s ease-out,opacity .5s linear;will-change:width,opacity}.jodit-progress-bar div:after{-webkit-animation:b 2s ease-out 0s infinite;animation:b 2s ease-out 0s infinite;border-radius:100%;-webkit-box-shadow:#b91f1f 1px 0 6px 1px;box-shadow:#b91f1f 1px 0 6px 1px;content:"";display:inline-block;height:2px;opacity:.6;position:absolute;top:0}.jodit-progress-bar div:before{-webkit-animation:b 2s ease-out 0s infinite;animation:b 2s ease-out 0s infinite;border-radius:100%;-webkit-box-shadow:#b91f1f 1px 0 6px 1px;box-shadow:#b91f1f 1px 0 6px 1px;content:"";display:inline-block;height:2px;opacity:.6;position:absolute;top:0}.jodit-progress-bar div:before{clip:rect(-6px,90px,14px,-6px);right:-80px;width:180px}.jodit-progress-bar div:after{clip:rect(-6px,22px,14px,8px);right:0;width:20px}.jodit-toolbar-collection,.jodit-toolbar-editor-collection{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#dadada calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#dadada calc(14px + calc((14px - 4px)*2) + 2px*2));position:relative}.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#dadada calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#dadada calc(14px + calc((14px - 4px)*2) + 2px*2));position:relative}.jodit-toolbar-collection_mode_horizontal:after{background-color:#fff;bottom:0;content:"";display:block;height:1px;left:0;position:absolute;width:100%}.jodit-toolbar-editor-collection_mode_horizontal:after{background-color:#fff;bottom:0;content:"";display:block;height:1px;left:0;position:absolute;width:100%}.jodit-toolbar-collection_size_tiny.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px);background-image:repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px)}.jodit-toolbar-collection_size_tiny.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px);background-image:repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px)}.jodit-toolbar-editor-collection_size_tiny.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px);background-image:repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px)}.jodit-toolbar-editor-collection_size_tiny.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px);background-image:repeating-linear-gradient(transparent 0,transparent 19px,#dadada 20px)}.jodit-toolbar-collection_size_xsmall.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px);background-image:repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px)}.jodit-toolbar-collection_size_xsmall.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px);background-image:repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px)}.jodit-toolbar-editor-collection_size_xsmall.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px);background-image:repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px)}.jodit-toolbar-editor-collection_size_xsmall.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px);background-image:repeating-linear-gradient(transparent 0,transparent 25px,#dadada 26px)}.jodit-toolbar-collection_size_small.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px);background-image:repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px)}.jodit-toolbar-collection_size_small.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px);background-image:repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px)}.jodit-toolbar-editor-collection_size_small.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px);background-image:repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px)}.jodit-toolbar-editor-collection_size_small.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px);background-image:repeating-linear-gradient(transparent 0,transparent 31px,#dadada 32px)}.jodit-toolbar-collection_size_middle.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px);background-image:repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px)}.jodit-toolbar-collection_size_middle.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px);background-image:repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px)}.jodit-toolbar-editor-collection_size_middle.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px);background-image:repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px)}.jodit-toolbar-editor-collection_size_middle.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px);background-image:repeating-linear-gradient(transparent 0,transparent 37px,#dadada 38px)}.jodit-toolbar-collection_size_large.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px);background-image:repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px)}.jodit-toolbar-collection_size_large.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px);background-image:repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px)}.jodit-toolbar-editor-collection_size_large.jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px);background-image:repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px)}.jodit-toolbar-editor-collection_size_large.jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px);background-image:repeating-linear-gradient(transparent 0,transparent 43px,#dadada 44px)}.jodit-toolbar-collection_mode_vertical .jodit-ui-group,.jodit-toolbar-editor-collection_mode_vertical .jodit-ui-group{background-color:transparent;border:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button{height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2)}.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button{height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2)}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button__button{cursor:pointer;height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2);width:100%}.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button__button{cursor:pointer;height:auto;min-height:calc(14px + calc((14px - 4px)*2) + 2px*2);width:100%}.jodit-toolbar-collection_mode_vertical .jodit-toolbar-button__text:not(:empty),.jodit-toolbar-editor-collection_mode_vertical .jodit-toolbar-button__text:not(:empty){-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left}.jodit-toolbar-collection .jodit-toolbar-button{margin:2px 1px;padding:0}.jodit-toolbar-collection .jodit-toolbar-content{margin:2px 1px;padding:0}.jodit-toolbar-editor-collection .jodit-toolbar-button{margin:2px 1px;padding:0}.jodit-toolbar-editor-collection .jodit-toolbar-content{margin:2px 1px;padding:0}.jodit-dialog .jodit-toolbar-collection_mode_horizontal,.jodit-dialog .jodit-toolbar-editor-collection_mode_horizontal{background-image:none}.jodit-toolbar-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid transparent;border-radius:3px;display:-webkit-box;display:-ms-flexbox;display:flex;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:34px;overflow:hidden}.jodit-toolbar-button__icon{display:none}.jodit-toolbar-button__icon:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.jodit-toolbar-button__text{display:none}.jodit-toolbar-button__text:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-toolbar-button_context_menu .jodit-toolbar-button__text{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;padding-left:8px;position:relative}.jodit-toolbar-button_context_menu .jodit-toolbar-button__text:before{border-left:1px solid #dadada;content:"";height:35px;left:0;position:absolute;top:calc(8px*-1)}.jodit-toolbar-button__icon:not(:empty)+.jodit-toolbar-button__text:not(:empty){margin-left:8px}.jodit-toolbar-button__icon:empty+.jodit-toolbar-button__text:not(:empty){padding:0 8px;padding:0}.jodit-toolbar-button .jodit-icon{height:14px;width:14px}.jodit-toolbar-button button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:34px;min-width:34px;padding:0}.jodit-toolbar-button_text-icons_true button{padding:0 8px}.jodit-toolbar-button_size_tiny{height:16px;min-width:16px}.jodit-toolbar-button_size_tiny .jodit-icon{height:8px;width:8px}.jodit-toolbar-button_size_tiny button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:16px;min-width:16px;padding:0}.jodit-toolbar-button_size_tiny_text-icons_true button{padding:0 8px}.jodit-toolbar-button_size_xsmall{height:22px;min-width:22px}.jodit-toolbar-button_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-toolbar-button_size_xsmall button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:22px;min-width:22px;padding:0}.jodit-toolbar-button_size_xsmall_text-icons_true button{padding:0 8px}.jodit-toolbar-button_size_small{height:28px;min-width:28px}.jodit-toolbar-button_size_small .jodit-icon{height:12px;width:12px}.jodit-toolbar-button_size_small button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;min-width:28px;padding:0}.jodit-toolbar-button_size_small_text-icons_true button{padding:0 8px}.jodit-toolbar-button_size_large{height:40px;min-width:40px}.jodit-toolbar-button_size_large .jodit-icon{height:16px;width:16px}.jodit-toolbar-button_size_large button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:40px;min-width:40px;padding:0}.jodit-toolbar-button_size_large_text-icons_true button{padding:0 8px}.jodit-toolbar-button__button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:0;border-radius:3px;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;color:rgba(0,0,0,.75);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-style:normal;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:0;padding:0;padding:0 8px;position:relative;text-align:center;text-decoration:none;text-transform:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-toolbar-button__button:focus-visible:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-button__button:hover:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-button__button:active:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-button__button[aria-pressed=true]:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-button__button[aria-pressed=true]:hover:not([disabled]){background-color:hsla(0,0%,86%,.6)}.jodit-toolbar-button__button[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-button__trigger{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:0 3px 3px 0;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:.4;width:14px}.jodit-toolbar-button__trigger:focus-visible:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-button__trigger:hover:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-button__trigger:active:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-button__trigger[aria-pressed=true]:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-button__trigger[aria-pressed=true]:hover:not([disabled]){background-color:hsla(0,0%,86%,.6)}.jodit-toolbar-button__trigger[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-button__trigger svg{width:10px}.jodit-toolbar-button_size_tiny .jodit-toolbar-button__trigger{width:8px}.jodit-toolbar-button_size_tiny .jodit-toolbar-button__trigger svg{width:4px}.jodit-toolbar-button_size_xsmall .jodit-toolbar-button__trigger{width:10px}.jodit-toolbar-button_size_xsmall .jodit-toolbar-button__trigger svg{width:6px}.jodit-toolbar-button_size_small .jodit-toolbar-button__trigger{width:12px}.jodit-toolbar-button_size_small .jodit-toolbar-button__trigger svg{width:8px}.jodit-toolbar-button_size_large .jodit-toolbar-button__trigger{width:16px}.jodit-toolbar-button_size_large .jodit-toolbar-button__trigger svg{width:12px}.jodit-toolbar-button_with-trigger_true .jodit-toolbar-button__button{border-radius:3px 0 0 3px}.jodit-toolbar-button_with-trigger_true:hover:not([disabled]){border-color:#dadada}.jodit-toolbar-button_stroke_false svg{stroke:none}.jodit-toolbar-content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:0 0;border:1px solid transparent;border-radius:3px;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;color:rgba(0,0,0,.75);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-style:normal;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:34px;outline:0;padding:0;position:relative;text-align:center;text-decoration:none;text-transform:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-toolbar-content:focus-visible:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-content:hover:not([disabled]){background-color:#dcdcdc;opacity:1;outline:0}.jodit-toolbar-content:active:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-content[aria-pressed=true]:not([disabled]){background-color:hsla(0,0%,86%,.4);outline:0}.jodit-toolbar-content[aria-pressed=true]:hover:not([disabled]){background-color:hsla(0,0%,86%,.6)}.jodit-toolbar-content[disabled]{opacity:.3;pointer-events:none}.jodit-toolbar-content .jodit-icon{height:14px;width:14px}.jodit-toolbar-content button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:34px;min-width:34px;padding:0}.jodit-toolbar-content_text-icons_true button{padding:0 8px}.jodit-toolbar-content_size_tiny{height:16px;min-width:16px}.jodit-toolbar-content_size_tiny .jodit-icon{height:8px;width:8px}.jodit-toolbar-content_size_tiny button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:16px;min-width:16px;padding:0}.jodit-toolbar-content_size_tiny_text-icons_true button{padding:0 8px}.jodit-toolbar-content_size_xsmall{height:22px;min-width:22px}.jodit-toolbar-content_size_xsmall .jodit-icon{height:10px;width:10px}.jodit-toolbar-content_size_xsmall button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:22px;min-width:22px;padding:0}.jodit-toolbar-content_size_xsmall_text-icons_true button{padding:0 8px}.jodit-toolbar-content_size_small{height:28px;min-width:28px}.jodit-toolbar-content_size_small .jodit-icon{height:12px;width:12px}.jodit-toolbar-content_size_small button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;min-width:28px;padding:0}.jodit-toolbar-content_size_small_text-icons_true button{padding:0 8px}.jodit-toolbar-content_size_large{height:40px;min-width:40px}.jodit-toolbar-content_size_large .jodit-icon{height:16px;width:16px}.jodit-toolbar-content_size_large button{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:40px;min-width:40px;padding:0}.jodit-toolbar-content_size_large_text-icons_true button{padding:0 8px}.jodit-toolbar-content__icon{display:none}.jodit-toolbar-content__icon:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.jodit-toolbar-content__text{display:none}.jodit-toolbar-content__text:not(:empty){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-toolbar-content_context_menu .jodit-toolbar-content__text{-webkit-box-pack:left;-ms-flex-pack:left;justify-content:left;padding-left:8px;position:relative}.jodit-toolbar-content_context_menu .jodit-toolbar-content__text:before{border-left:1px solid #dadada;content:"";height:35px;left:0;position:absolute;top:calc(8px*-1)}.jodit-toolbar-content__icon:not(:empty)+.jodit-toolbar-content__text:not(:empty){margin-left:8px}.jodit-toolbar-content__icon:empty+.jodit-toolbar-content__text:not(:empty){padding:0 8px}.jodit-toolbar-content:focus:not([disabled]){outline:1px dashed #b5d6fd}.jodit-toolbar-content_variant_default{background-color:#e3e3e3;color:#212529}.jodit-toolbar-content_variant_default svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default [disabled]{opacity:.7}.jodit-toolbar-content_variant_default:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-toolbar-content_variant_default:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-toolbar-content_variant_default:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_default:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-toolbar-content_variant_primary{background-color:#007bff;color:#fff}.jodit-toolbar-content_variant_primary svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary [disabled]{opacity:.7}.jodit-toolbar-content_variant_primary:hover:not([disabled]){background-color:#0069d9;color:#fff}.jodit-toolbar-content_variant_primary:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary:active:not([disabled]){background-color:#0062cc;color:#fff}.jodit-toolbar-content_variant_primary:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_primary:focus:not([disabled]){outline:1px dashed #0062cc}.jodit-toolbar-content_variant_secondary{background-color:#d8d8d8;border-radius:0;color:#212529}.jodit-toolbar-content_variant_secondary svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary [disabled]{opacity:.7}.jodit-toolbar-content_variant_secondary:hover:not([disabled]){background-color:#c9cdd1;color:#212529}.jodit-toolbar-content_variant_secondary:hover:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary:active:not([disabled]){background-color:#dae0e5;color:#212529}.jodit-toolbar-content_variant_secondary:active:not([disabled]) svg{fill:#212529;stroke:#212529}.jodit-toolbar-content_variant_secondary:focus:not([disabled]){outline:1px dashed #dae0e5}.jodit-toolbar-content_variant_success{background-color:#28a745;color:#fff}.jodit-toolbar-content_variant_success svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success [disabled]{opacity:.7}.jodit-toolbar-content_variant_success:hover:not([disabled]){background-color:#218838;color:#fff}.jodit-toolbar-content_variant_success:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success:active:not([disabled]){background-color:#1e7e34;color:#fff}.jodit-toolbar-content_variant_success:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_success:focus:not([disabled]){outline:1px dashed #1e7e34}.jodit-toolbar-content_variant_danger{background-color:#dc3545;color:#fff}.jodit-toolbar-content_variant_danger svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger [disabled]{opacity:.7}.jodit-toolbar-content_variant_danger:hover:not([disabled]){background-color:#c82333;color:#fff}.jodit-toolbar-content_variant_danger:hover:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger:active:not([disabled]){background-color:#bd2130;color:#fff}.jodit-toolbar-content_variant_danger:active:not([disabled]) svg{fill:#fff;stroke:#fff}.jodit-toolbar-content_variant_danger:focus:not([disabled]){outline:1px dashed #bd2130}.jodit-toolbar-content:hover:not([disabled]){background-color:transparent;opacity:1;outline:0}.jodit-filebrowser{display:-webkit-box;display:-ms-flexbox;display:flex;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;height:100%}.jodit-filebrowser_no-files_true{padding:8px}@media (max-width:480px){.jodit-filebrowser{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-flow:column-reverse;flex-flow:column-reverse}}.jodit-dialog .jodit-dialog__header-title.jodit-filebrowser__title-box{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:8px}.jodit-filebrowser-preview{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;max-height:100%;max-width:Min(100%,1000px);min-height:Min(100%,500px);min-width:400px;position:relative;text-align:center}@media (max-width:768px){.jodit-filebrowser-preview{height:100%;max-height:100%;max-width:100%;min-height:auto;min-width:auto}}.jodit-filebrowser-preview__box{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-filebrowser-preview__navigation{cursor:pointer;height:100%;left:0;position:absolute;top:0}.jodit-filebrowser-preview__navigation_arrow_next{left:auto;right:0}.jodit-filebrowser-preview__navigation svg{fill:#9e9ba7;height:45px;position:relative;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);-webkit-transition:fill .3s linear;-o-transition:fill .3s linear;transition:fill .3s linear;width:45px}.jodit-filebrowser-preview__navigation:hover svg{fill:#000}.jodit-filebrowser-preview img{max-height:100%;max-width:100%}.jodit-image-editor{height:100%;overflow:hidden;padding:8px;width:100%}@media (max-width:768px){.jodit-image-editor{height:auto}}.jodit-image-editor>div,.jodit-image-editor>div>div{height:100%}@media (max-width:768px){.jodit-image-editor>div,.jodit-image-editor>div>div{height:auto;min-height:200px}}.jodit-image-editor *{-webkit-box-sizing:border-box;box-sizing:border-box}.jodit-image-editor .jodit-image-editor__slider-title{background-color:#f9f9f9;border-bottom:1px solid hsla(0,0%,62%,.31);color:#333;cursor:pointer;font-weight:700;line-height:1em;padding:.8em 1em;-o-text-overflow:ellipsis;text-overflow:ellipsis;text-shadow:#f3f3f3 0 1px 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.jodit-image-editor .jodit-image-editor__slider-title svg{display:inline-block;margin-right:8px;vertical-align:middle;width:16px}.jodit-image-editor .jodit-image-editor__slider-content{display:none}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-title{background-color:#5d5d5d;color:#fff;text-shadow:#000 0 1px 0}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-title svg{fill:#fff}.jodit-image-editor .jodit-image-editor__slider.jodit-image-editor_active .jodit-image-editor__slider-content{display:block}.jodit-image-editor__area{background-color:#eee;background-image:-o-linear-gradient(45deg,#dadada 25%,transparent 25%,transparent 75%,#dadada 75%,#dadada),-o-linear-gradient(45deg,#dadada 25%,transparent 25%,transparent 75%,#dadada 75%,#dadada);background-image:linear-gradient(45deg,#dadada 25%,transparent 25%,transparent 75%,#dadada 75%,#dadada),linear-gradient(45deg,#dadada 25%,transparent 25%,transparent 75%,#dadada 75%,#dadada);background-position:0 0,15px 15px;background-size:30px 30px;display:none;height:100%;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.jodit-image-editor__area.jodit-image-editor_active{display:block}.jodit-image-editor__area .jodit-image-editor__box{height:100%;overflow:hidden;pointer-events:none;position:relative;z-index:1}.jodit-image-editor__area .jodit-image-editor__box img{max-height:100%;max-width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-image-editor__area .jodit-image-editor__croper{background-repeat:no-repeat;border:1px solid #fff;-webkit-box-shadow:0 0 11px #000;box-shadow:0 0 11px #000;height:100px;left:20px;pointer-events:none;position:absolute;top:8px;width:100px;z-index:2}.jodit-image-editor__area .jodit-image-editor__resizer{background-repeat:no-repeat;border:1px solid #fff;-webkit-box-shadow:0 0 11px #000;box-shadow:0 0 11px #000;height:100px;left:20px;pointer-events:none;position:absolute;top:8px;width:100px;z-index:2}.jodit-image-editor__area .jodit-image-editor__croper i.jodit_bottomright{background-color:#8c7878;border:1px solid #383838;border-radius:50%;bottom:calc(8px*-1);-webkit-box-shadow:0 0 11px #000;box-shadow:0 0 11px #000;cursor:se-resize;display:inline-block;height:20px;pointer-events:all;position:absolute;right:calc(8px*-1);width:20px;z-index:4}.jodit-image-editor__area .jodit-image-editor__resizer i.jodit_bottomright{background-color:#8c7878;border:1px solid #383838;border-radius:50%;bottom:calc(8px*-1);-webkit-box-shadow:0 0 11px #000;box-shadow:0 0 11px #000;cursor:se-resize;display:inline-block;height:20px;pointer-events:all;position:absolute;right:calc(8px*-1);width:20px;z-index:4}.jodit-image-editor__area .jodit-image-editor__croper i.jodit_bottomright:active,.jodit-image-editor__area .jodit-image-editor__resizer i.jodit_bottomright:active{border:1px solid #ff0}.jodit-image-editor__area.jodit-image-editor__area_crop{background:#eee;height:100%;line-height:100%;position:relative;text-align:center}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box{height:100%;line-height:100%;overflow:visible;pointer-events:all;text-align:left}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box img{height:100%;max-height:100%;max-width:100%;width:100%}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box:after{background:hsla(0,0%,100%,.3);bottom:0;content:"";left:0;margin:auto;position:absolute;right:0;top:0;z-index:1}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box .jodit-image-editor__croper{cursor:move;pointer-events:all}.jodit-image-editor__area.jodit-image-editor__area_crop .jodit-image-editor__box .jodit-image-editor__croper i.jodit-image-editor__sizes{background:rgba(0,0,0,.2);border-radius:.4em;bottom:-30px;color:#fff;display:block;font-size:12px;left:100%;padding:9px 6px;position:absolute;text-align:center;text-shadow:none;white-space:pre}.jodit-image-editor__area.jodit-image-editor__area_crop.jodit-image-editor_active{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-filebrowser-files{display:none;height:100%;overflow-anchor:auto;position:relative;vertical-align:top}.jodit-filebrowser-files .jodit-button{border-radius:0}.jodit-filebrowser-files_loading_true:before{content:"";height:100%;left:0;position:absolute;top:0;width:100%}.jodit-filebrowser-files_loading_true:after{-webkit-animation:a 2s ease-out 0s infinite;animation:a 2s ease-out 0s infinite;background:url(' + x + ') no-repeat 50%;background-size:100% 100%;content:"";display:inline-block;height:48px;left:50%;margin-left:calc(48px/-2);margin-top:calc(48px/-2);opacity:.7;position:absolute;top:50%;vertical-align:middle;width:48px;will-change:transform}.jodit-filebrowser-files_active_true{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-filebrowser-files::-webkit-scrollbar{width:calc(8px/2)}.jodit-filebrowser-files::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-filebrowser-files::-webkit-scrollbar-thumb{background-color:#a9a9a9;outline:1px solid #708090}.jodit-filebrowser-files_active_true{-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;overflow-y:auto;padding:calc(8px/2);width:100%}.jodit-filebrowser-files__item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid #dadada;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:0;height:150px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:calc(8px/2);overflow:hidden;position:relative;text-align:center;-webkit-transition:border .1s linear,bottom .1s linear;-o-transition:border .1s linear,bottom .1s linear;transition:border .1s linear,bottom .1s linear;width:150px}@media (max-width:480px){.jodit-filebrowser-files__item{width:calc(50% - 8px)}}.jodit-filebrowser-files__item img{max-width:100%}.jodit-filebrowser-files__item:hover{border-color:#433b5c}.jodit-filebrowser-files__item_active_true{background-color:#b5b5b5;border-color:#1e88e5}.jodit-filebrowser-files__item_active_true .jodit-filebrowser-files__item-info{background-color:#b5b5b5;color:#fff;text-shadow:none}.jodit-filebrowser-files__item-info{background-color:#e9e9e9;bottom:0;color:#333;font-size:14px;left:0;line-height:16px;opacity:.85;overflow:visible;padding:.3em .6em;position:absolute;right:0;text-align:left;text-shadow:#eee 0 1px 0;-webkit-transition:opacity .4s ease;-o-transition:opacity .4s ease;transition:opacity .4s ease;white-space:normal}.jodit-filebrowser-files__item-info>span{display:block;font-size:.75em;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.jodit-filebrowser-files__item-info>span.jodit-filebrowser-files__item-info-filename{font-size:.9em;font-weight:700}.jodit-filebrowser-files__item:hover:not(.jodit-filebrowser-files__item_active_true) .jodit-filebrowser-files__item-info{bottom:-100px}.jodit-filebrowser-files_view_list{scroll-behavior:smooth}.jodit-filebrowser-files_view_list a{border-width:0 0 1px;display:block;height:26px;line-height:26px;margin:0;text-align:left;white-space:nowrap;width:100%}.jodit-filebrowser-files_view_list a img{display:inline-block;margin-left:4px;max-width:16px;min-width:16px;vertical-align:middle}.jodit-filebrowser-files_view_list a .jodit-filebrowser-files__item-info{background-color:transparent;display:inline-block;font-size:0;height:100%;line-height:inherit;margin-left:4px;padding:0;position:static;vertical-align:middle;width:calc(100% - 20px)}.jodit-filebrowser-files_view_list a .jodit-filebrowser-files__item-info>span{display:inline-block;font-size:12px;height:100%}.jodit-filebrowser-files_view_list a .jodit-filebrowser-files__item-info-filename{width:50%}.jodit-filebrowser-files_view_list a .jodit-filebrowser-files__item-info-filechanged,.jodit-filebrowser-files_view_list a .jodit-filebrowser-files__item-info-filesize{width:25%}.jodit-filebrowser-files_view_list a:hover{background-color:#433b5c}.jodit-filebrowser-files_view_list a:hover .jodit-filebrowser-files__item-info{color:#fff;text-shadow:none}.jodit-filebrowser-files_view_list a:before{content:"";display:inline-block;height:100%;vertical-align:middle}.jodit-filebrowser-tree{display:none;height:100%;overflow-anchor:auto;position:relative;vertical-align:top}.jodit-filebrowser-tree .jodit-button{border-radius:0}.jodit-filebrowser-tree_active_true{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-filebrowser-tree_loading_true:before{content:"";height:100%;left:0;position:absolute;top:0;width:100%}.jodit-filebrowser-tree_loading_true:after{-webkit-animation:a 2s ease-out 0s infinite;animation:a 2s ease-out 0s infinite;background:url(' + x + ') no-repeat 50%;background-size:100% 100%;content:"";display:inline-block;height:48px;left:50%;margin-left:calc(48px/-2);margin-top:calc(48px/-2);opacity:.7;position:absolute;top:50%;vertical-align:middle;width:48px;will-change:transform}.jodit-filebrowser-tree::-webkit-scrollbar{width:calc(8px/2)}.jodit-filebrowser-tree::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-filebrowser-tree::-webkit-scrollbar-thumb{background-color:#a9a9a9;outline:1px solid #708090}.jodit-filebrowser-tree_active_true{background-color:#3f3f3f;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:290px;min-width:200px;overflow-y:auto;width:31%;z-index:2}@media (max-width:480px){.jodit-filebrowser-tree_active_true{height:100px;max-width:100%;width:auto}}.jodit-filebrowser-tree_active_true::-webkit-scrollbar{width:calc(8px/2)}.jodit-filebrowser-tree_active_true::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3)}.jodit-filebrowser-tree_active_true::-webkit-scrollbar-thumb{background-color:hsla(0,0%,50%,.5);outline:1px solid #708090}.jodit-filebrowser-tree__item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #474747;color:#b1b1b1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:38px;padding:calc(8px/2) 8px;position:relative;text-decoration:none;-webkit-transition:background-color .2s ease 0s;-o-transition:background-color .2s ease 0s;transition:background-color .2s ease 0s;word-break:break-all}.jodit-filebrowser-tree__item-title{color:#b1b1b1;-webkit-box-flex:1;-ms-flex:1;flex:1}.jodit-filebrowser-tree__item .jodit-icon_folder{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:calc(12px + 4px);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-left:calc(8px/2);opacity:.3;width:calc(12px + 4px)}.jodit-filebrowser-tree__item .jodit-icon_folder svg{fill:#b1b1b1!important;stroke:#b1b1b1!important;height:12px;width:12px}.jodit-filebrowser-tree__item .jodit-icon_folder:hover{background:#696969}.jodit-filebrowser-tree__item:hover{background-color:#ecebe9}.jodit-filebrowser-tree__item:hover-title{color:#222}.jodit-filebrowser-tree__item:hover i.jodit-icon_folder{opacity:.6}.jodit-filebrowser-tree__source-title{background:#5a5a5a;border-bottom:1px solid #484848;color:#969696;display:block;font-size:12px;padding:2px 4px;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;word-break:break-all}a+.jodit-filebrowser-tree__source-title{margin-top:8px}.jodit-status-bar{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f9f9f9;border-radius:0 0 3px 3px;color:rgba(0,0,0,.75);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;height:20px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;overflow:hidden;padding:0 calc(8px/2);text-transform:uppercase}.jodit-status-bar_resize-handle_true{padding-right:14px}.jodit-status-bar:before{content:"";-webkit-box-flex:1;-ms-flex:auto;flex:auto;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.jodit-status-bar .jodit-status-bar__item{line-height:1.57142857em;margin:0 8px 0 0;-webkit-box-ordinal-group:1;-ms-flex-order:0;order:0;padding:0}.jodit-status-bar .jodit-status-bar__item{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;font-size:11px}.jodit-status-bar .jodit-status-bar__item>span{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px;font-size:11px}.jodit-status-bar .jodit-status-bar__item.jodit-status-bar__item-right{margin:0 0 0 8px;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}.jodit-status-bar .jodit-status-bar__item a{border-radius:3px;cursor:default;text-decoration:none}.jodit-status-bar .jodit-status-bar__item a:hover{background-color:#dadada;text-decoration:none}.jodit-status-bar a.jodit-status-bar-link{cursor:pointer}.jodit-status-bar a.jodit-status-bar-link{background-color:transparent;color:rgba(0,0,0,.75)}.jodit-status-bar a.jodit-status-bar-link:hover{background-color:transparent;color:rgba(0,0,0,.75)}.jodit-status-bar a.jodit-status-bar-link:visited{background-color:transparent;color:rgba(0,0,0,.75)}.jodit-status-bar a.jodit-status-bar-link:hover{text-decoration:underline}.jodit-workplace+.jodit-status-bar:not(:empty){border-top:1px solid #dadada}.jodit_disabled .jodit-status-bar{opacity:.4}.jodit-drag-and-drop__file-box{border:1px dashed #dadada;margin:8px 0;overflow:hidden;padding:25px 0;position:relative;text-align:center;width:100%}.jodit_uploadfile_button{border:1px dashed #dadada;margin:8px 0;overflow:hidden;padding:25px 0;position:relative;text-align:center;width:100%}.jodit-drag-and-drop__file-box:hover{background-color:#ecebe9}.jodit_uploadfile_button:hover{background-color:#ecebe9}.jodit-drag-and-drop__file-box input,.jodit_uploadfile_button input{bottom:0;cursor:pointer;font-size:400px;left:0;margin:0;opacity:0;padding:0;position:absolute;right:0;top:0}@media (max-width:768px){.jodit-drag-and-drop__file-box{max-width:100%;min-width:180px;width:auto}}.jodit-about{padding:20px}.jodit-about a{color:#459ce7;text-decoration:none}.jodit-about a:focus,.jodit-about a:hover{color:#23527c;outline:0;text-decoration:underline}.jodit-about div{margin-bottom:calc(8px/2)}.jodit-add-new-line{display:block;height:1px;outline:none;position:fixed;top:0;z-index:1}.jodit-add-new-line,.jodit-add-new-line *{-webkit-box-sizing:border-box;box-sizing:border-box}.jodit-add-new-line:after{background-color:#6b6b6b;content:"";display:block;height:1px;width:100%}.jodit-add-new-line span{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:hsla(40,7%,92%,.3);border:1px solid #6b6b6b;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:calc(100% - 30px);position:absolute;width:30px}.jodit-add-new-line span:hover{background:#ecebe9}.jodit-add-new-line_after span{bottom:0}.jodit-add-new-line svg{fill:#6b6b6b;width:16px}.jodit-source__mode .jodit-add-new-line{display:none!important}.jodit-color-picker{margin:0;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-color-picker__group{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:calc(8px/2);max-width:calc(24px*10);white-space:normal}.jodit-color-picker__color-item{border:1px solid transparent;display:block;height:24px;text-align:center;text-decoration:none;vertical-align:middle;width:24px}.jodit-color-picker__color-item:hover{border-color:#000}.jodit-color-picker__color-item:active{border:2px solid #1e88e5}.jodit-color-picker__color-item_active_true{border:2px solid #1e88e5}.jodit-color-picker__native svg{display:inline-block;height:16px;margin-right:4px;width:16px}.jodit-color-picker__native input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:18px;padding:0;width:18px}.jodit-color-picker__native input[type=color]::-webkit-color-swatch-wrapper{padding:0}.jodit-color-picker__native input input[type=color]::-webkit-color-swatch{border:none}.jodit-tabs{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;font-size:14px}.jodit-tabs .jodit-tabs__buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:18px;margin-bottom:calc(8px/2);margin-top:4px}.jodit-tabs .jodit-tabs__buttons>*{cursor:pointer;margin-left:calc(8px/2)}.jodit-tabs .jodit-tabs__buttons>:only-of-type{width:100%}.jodit-tabs .jodit-tabs__buttons>:first-child{margin-left:0}@media (max-width:480px){.jodit-tabs .jodit-tabs__buttons{display:block}.jodit-tabs .jodit-tabs__buttons>*{margin-left:0;width:100%}}.jodit-tabs__button{min-width:80px}.jodit-tabs__button_columns_3{width:33.33333%}.jodit-tabs__button_columns_2{width:50%}.jodit-tabs .jodit-tabs__wrapper .jodit-tab{display:none}.jodit-tabs .jodit-tabs__wrapper .jodit-tab.jodit-tab_active{display:block}.jodit-tabs .jodit-tabs__wrapper .jodit-tab.jodit-tab_empty{min-height:100px;min-width:220px}.jodit_fullsize-box_true{overflow:visible!important;position:static!important;z-index:100000!important}body.jodit_fullsize-box_true,html.jodit_fullsize-box_true{height:0!important;overflow:hidden!important;width:0!important}html.jodit_fullsize-box_true{position:fixed!important}.jodit_fullsize{bottom:0;left:0;max-width:none!important;position:absolute;right:0;top:0;z-index:100000}.jodit_fullsize .toolbar{width:100%!important}.jodit_fullsize .jodit__area,.jodit_fullsize .jodit_editor{height:100%}.jodit-properties__lock>svg,.jodit-properties__unlock>svg{fill:#222;display:inline-block;font-size:8px;font-style:normal;height:14px;line-height:14px;overflow:hidden;-webkit-transform-origin:0 0!important;-ms-transform-origin:0 0!important;transform-origin:0 0!important;vertical-align:middle;width:14px}.jodit-properties .jodit-properties_view_box{padding:8px}.jodit-properties .jodit-properties_view_box .jodit-properties_image_view{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f6f6f6;display:-webkit-box;display:-ms-flexbox;display:flex;height:150px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 0 8px;padding:0}.jodit-properties .jodit-properties_view_box .jodit-properties_image_view img{max-height:100%;max-width:100%}.jodit-properties .jodit-properties_view_box .jodit-properties_image_sizes.jodit-form__group{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin:0!important;min-width:auto;padding:0!important}.jodit-properties .jodit-properties_view_box .jodit-properties_image_sizes.jodit-form__group a{cursor:pointer;display:inline-block}.jodit-properties .jodit-properties_view_box .jodit-properties_image_sizes.jodit-form__group .jodit-input{width:calc(50% - 8px)!important}.jodit-popup-inline__container{min-width:700px;z-index:1300}.jodit-paste-storage{max-width:600px;padding:8px}@media (max-width:768px){.jodit-paste-storage{max-width:100%}}.jodit-paste-storage>div{border:1px solid #dadada;max-height:300px;max-width:100%}.jodit-paste-storage>div:first-child{margin-bottom:8px}.jodit-paste-storage>div:first-child a{border:1px solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:#4c4c4c;display:block;margin:0;max-width:100%;outline:none;overflow:hidden;padding:calc(8px/2);text-decoration:none;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:pre}.jodit-paste-storage>div:first-child a.jodit_active{background-color:#575757;color:#fff}.jodit-paste-storage>div:first-child a:focus{outline:none}.jodit-paste-storage>div:last-child{overflow:auto;padding:8px}.jodit-paste-storage>div:last-child li,.jodit-paste-storage>div:last-child ul{margin:0}.jodit-placeholder{color:#a5a5a5;display:block;left:0;padding:8px;pointer-events:none;position:absolute;top:0;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important;width:100%;z-index:1}.jodit__preview-box table{border:none;border-collapse:collapse;empty-cells:show;margin-bottom:1em;margin-top:1em;max-width:100%}.jodit__preview-box table tr{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit__preview-box table tr td{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit__preview-box table tr th{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit-table-resizer{cursor:col-resize;margin-left:calc(8px/-2);padding-left:calc(8px/2);padding-right:calc(8px/2);position:absolute;z-index:3}.jodit-table-resizer:after{border:0;content:"";display:block;height:100%;width:0}.jodit-table-resizer_moved{background-color:#b5d6fd;z-index:2}.jodit-table-resizer_moved:after{border-right:1px solid moved}[data-jodit_iframe_wrapper]{display:block;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[data-jodit_iframe_wrapper] iframe{position:relative}[data-jodit_iframe_wrapper]:after{background:transparent;bottom:0;content:"";cursor:pointer;display:block;left:0;position:absolute;right:0;top:0;z-index:1}[data-jodit_iframe_wrapper][data-jodit-wrapper_active=true] iframe{z-index:2}.jodit_lock [data-jodit-wrapper_active=true] iframe{z-index:1}.jodit-resizer{font-size:0;height:100px;left:0;outline:3px solid #98c1f1;pointer-events:none;position:absolute;top:0;width:100px}.jodit-resizer,.jodit-resizer *{-webkit-box-sizing:border-box;box-sizing:border-box}.jodit-resizer>span{background-color:#a5a5a5;color:#fff;display:inline-block;font-size:12px;height:24px;left:50%;line-height:24px;margin-left:calc(70px/-2);margin-top:calc(24px/-2);opacity:0;overflow:visible;position:absolute;text-align:center;top:50%;-webkit-transition:opacity .2s linear;-o-transition:opacity .2s linear;transition:opacity .2s linear;width:70px}.jodit-resizer>div{background-color:#5ba4f3;display:inline-block;height:10px;pointer-events:all;position:absolute;width:10px;z-index:4}.jodit-resizer>div:hover{background-color:#537ebb}.jodit-resizer>div:first-child{cursor:nwse-resize;left:calc(10px/-2);top:calc(10px/-2)}.jodit-resizer>div:nth-child(2){cursor:nesw-resize;right:calc(10px/-2);top:calc(10px/-2)}.jodit-resizer>div:nth-child(3){bottom:calc(10px/-2);cursor:nwse-resize;right:calc(10px/-2)}.jodit-resizer>div:nth-child(4){bottom:calc(10px/-2);cursor:nesw-resize;left:calc(10px/-2)}.jodit-ui-search{height:0;position:absolute;right:0;top:0;width:0}.jodit-ui-search_sticky_true{position:fixed}.jodit-ui-search__box{background-color:#f9f9f9;border:solid #dadada;border-width:0 0 1px 1px;display:-webkit-box;display:-ms-flexbox;display:flex;max-width:100vw;padding:calc(8px/2);position:absolute;right:0;width:320px}.jodit-ui-search__box input{background-color:transparent;border:0;height:100%;margin:0;outline:none;padding:0 8px;width:100%}.jodit-ui-search__box input[data-ref=replace]{display:none}.jodit-ui-search__box input:not(:focus)+input:not(:focus){border-top:1px solid #dadada}.jodit-ui-search__buttons{height:30px}.jodit-ui-search__counts{height:30px}.jodit-ui-search__inputs{height:30px}.jodit-ui-search__inputs{padding-right:calc(8px/2);width:60%}.jodit-ui-search__counts{border-left:1px solid #dadada;color:#dadada;width:15%}.jodit-ui-search__buttons,.jodit-ui-search__counts{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.jodit-ui-search__buttons{-webkit-box-flex:1;-ms-flex:1;flex:1;padding-left:0}.jodit-ui-search__buttons button{background-color:transparent;border:1px solid transparent;height:100%;margin-right:1%;width:32%}.jodit-ui-search__buttons button[data-ref=replace-btn]{border:1px solid #dadada;display:none;margin-top:2px;width:100%}.jodit-ui-search__buttons button:hover{background-color:#ecebe9}.jodit-ui-search__buttons button:focus{border:1px solid rgba(181,214,253,.995)}.jodit-ui-search__buttons button:active{border:1px solid #b5d6fd;-webkit-transform:scale(0.95);-ms-transform:scale(0.95);transform:scale(0.95)}.jodit-ui-search_empty-query_true [data-ref=next],.jodit-ui-search_empty-query_true [data-ref=prev]{opacity:.5}.jodit-ui-search_replace_true .jodit-ui-search__counts{height:calc(30px*2)}.jodit-ui-search_replace_true .jodit-ui-search__inputs{height:calc(30px*2)}.jodit-ui-search_replace_true .jodit-ui-search__counts input{height:50%;-webkit-transition:background-color 0.1s linear;-o-transition:background-color 0.1s linear;transition:background-color 0.1s linear}.jodit-ui-search_replace_true .jodit-ui-search__inputs input{height:50%;-webkit-transition:background-color 0.1s linear;-o-transition:background-color 0.1s linear;transition:background-color 0.1s linear}.jodit-ui-search_replace_true .jodit-ui-search__counts input:focus{-webkit-box-shadow:inset 0 0 3px 0 #dadada;box-shadow:inset 0 0 3px 0 #dadada}.jodit-ui-search_replace_true .jodit-ui-search__inputs input:focus{-webkit-box-shadow:inset 0 0 3px 0 #dadada;box-shadow:inset 0 0 3px 0 #dadada}.jodit-ui-search_replace_true .jodit-ui-search__counts input[data-ref=replace],.jodit-ui-search_replace_true .jodit-ui-search__inputs input[data-ref=replace]{display:block}.jodit-ui-search_replace_true .jodit-ui-search__buttons{-ms-flex-wrap:wrap;flex-wrap:wrap}.jodit-ui-search_replace_true .jodit-ui-search__buttons button[data-ref=replace-btn]{display:block}[jd-tmp-selection]{background-color:#7fffd4}.jodit-container:not(.jodit_inline){min-height:100px}.jodit-container:not(.jodit_inline) .jodit-workplace{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:auto;min-height:50px;overflow:hidden}.jodit-container:not(.jodit_inline) .jodit-editor__resize{position:relative}.jodit-container:not(.jodit_inline) .jodit-editor__resize svg{fill:#a5a5a5;bottom:0;cursor:nwse-resize;height:12px;overflow:hidden;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:12px}.jodit-source{background-color:#323232;display:none;-webkit-box-flex:1;-ms-flex:auto;flex:auto;overflow:auto;position:relative}.jodit-source,.jodit-source .jodit-source__mirror-fake{min-height:100%}.jodit-source *{font:12px/normal Monaco,Menlo,Ubuntu Mono,Consolas,source-code-pro,monospace}.jodit-container.jodit-source__mode .jodit-wysiwyg,.jodit-container.jodit-source__mode .jodit-wysiwyg_iframe{display:none!important}.jodit-container.jodit-source__mode .jodit-source{display:block!important}.jodit-container.jodit_split_mode .jodit-workplace{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.jodit-container.jodit_split_mode .jodit-source,.jodit-container.jodit_split_mode .jodit-wysiwyg,.jodit-container.jodit_split_mode .jodit-wysiwyg_iframe{display:block!important;-webkit-box-flex:1;-ms-flex:1;flex:1;width:50%}.jodit-source__mirror{background:#323232;border:0;-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;color:#f0f0f0;height:100%;line-height:1.5;font:12px/normal Monaco,Menlo,Ubuntu Mono,Consolas,source-code-pro,monospace;margin:0;min-height:100%;outline:none;overflow:auto;padding:8px;resize:none;-moz-tab-size:2em;-o-tab-size:2em;tab-size:2em;white-space:pre-wrap;width:100%;z-index:2}.jodit-source__mirror::-moz-selection{background:#bdbdbd}.jodit-source__mirror::selection{background:#bdbdbd}.jodit_sticky-dummy_toolbar{display:none}.jodit_sticky>.jodit-toolbar__box{border-bottom:1px solid #dadada;left:auto;position:fixed;position:sticky;top:0;z-index:3}.jodit_sticky .jodit_sticky-dummy_toolbar{display:block}.jodit-symbols{padding:8px;width:460px}.jodit-symbols__container{display:-webkit-box;display:-ms-flexbox;display:flex}.jodit-symbols__container_table{width:88%}.jodit-symbols__container_preview{width:12%}.jodit-symbols__preview{border:1px solid #dadada;font-size:34px;padding:20px 0;text-align:center}.jodit-symbols__table{border:0;border-spacing:0;table-layout:fixed}.jodit-symbols__table td{padding:0}.jodit-symbols__table td a{border:1px solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:#4c4c4c;cursor:pointer;display:inline-block;font-size:16px;height:calc(18px*1.2);line-height:calc(18px*1.2);text-align:center;text-decoration:none;vertical-align:top;width:calc(18px*1.2)}.jodit-symbols__table td a:focus{outline:2px solid #dadada}.jodit-symbols__table td a:hover{outline:2px solid #dadada}.jodit-context table,.jodit-wysiwyg table{border:none;border-collapse:collapse;empty-cells:show;margin-bottom:1em;margin-top:1em;max-width:100%}.jodit-context table tr,.jodit-wysiwyg table tr{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jodit-context table tr td{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit-context table tr th{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit-wysiwyg table tr td{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit-wysiwyg table tr th{border:1px solid #dadada;min-width:2em;padding:.4em;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;vertical-align:middle}.jodit-form__inserter .jodit-form__table-creator-box{display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:768px){.jodit-form__inserter .jodit-form__table-creator-box{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container{font-size:0;margin:0;min-width:180px;padding:0}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span{border:1px solid #dadada;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;height:18px;margin-bottom:2px;margin-left:2px;vertical-align:top;width:18px}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span:first-child{margin-left:0}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__container>div>span.jodit_hovered{background:#7a450f;border-color:#7a450f}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options{font-size:14px}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options label{padding-top:0;text-align:left}.jodit-form__inserter .jodit-form__table-creator-box .jodit-form__options label input{margin-right:8px}.jodit-form__inserter label{font-size:14px;margin:0;padding:8px;text-align:center}.jodit-xpath{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:calc(8px/-2)}.jodit-xpath__item{display:-webkit-box;display:-ms-flexbox;display:flex;height:11px;line-height:calc(11px - 1px)}.jodit-xpath__item a{color:#4c4c4c;font-size:11px;margin-left:2px;outline:0;padding:0 3px}.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2))}.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2))}.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2))}.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal{background-image:-o-repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2));background-image:repeating-linear-gradient(transparent 0,transparent calc(calc(14px + calc((14px - 4px)*2) + 2px*2) - 1px),#6b6b6b calc(14px + calc((14px - 4px)*2) + 2px*2))}.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal:after{background-color:#6b6b6b}.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after{background-color:#6b6b6b}.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal:after{background-color:#6b6b6b}.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after{background-color:#6b6b6b}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty){border-color:#6b6b6b}.jodit_theme_dark .jodit-toolbar__box:not(:empty){border-color:#6b6b6b}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after{background-color:#6b6b6b}.jodit_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after{background-color:#6b6b6b}.jodit-dialog_theme_dark .jodit-ui-group_separated_true:not(:last-child):not(.jodit-ui-group_before-spacer_true):after{border-right-color:#6b6b6b}.jodit_theme_dark .jodit-ui-group_separated_true:not(:last-child):not(.jodit-ui-group_before-spacer_true):after{border-right-color:#6b6b6b}.jodit-dialog_theme_dark.jodit-container{background-color:#575757;border-color:#6b6b6b}.jodit_theme_dark.jodit-container{background-color:#575757;border-color:#6b6b6b}.jodit-dialog_theme_dark.jodit-container.jodit_disabled{background-color:#575757}.jodit_theme_dark.jodit-container.jodit_disabled{background-color:#575757}.jodit-dialog_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace{border-color:#575757}.jodit_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace{border-color:#575757}.jodit-dialog_theme_dark .jodit-popup__content{background:#787878}.jodit_theme_dark .jodit-popup__content{background:#787878}.jodit-dialog_theme_dark .jodit-toolbar-button__text{color:#d1cccc}.jodit-dialog_theme_dark .jodit-ui-button__text{color:#d1cccc}.jodit_theme_dark .jodit-toolbar-button__text{color:#d1cccc}.jodit_theme_dark .jodit-ui-button__text{color:#d1cccc}.jodit-dialog_theme_dark .jodit-toolbar-button:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-toolbar-button__button:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-ui-button:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-ui-button__button:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-ui-button:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-ui-button__button:hover:not([disabled]){background-color:#787878}.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]){background-color:#787878}.jodit-dialog_theme_dark .jodit-status-bar{background-color:#5f5c5c;border-color:#6b6b6b;color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty){background-color:#5f5c5c;border-color:#6b6b6b;color:#d1cccc}.jodit_theme_dark .jodit-status-bar{background-color:#5f5c5c;border-color:#6b6b6b;color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty){background-color:#5f5c5c;border-color:#6b6b6b;color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar{color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item a{color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item span{color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link{color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover{color:#d1cccc}.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited{color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty){color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item a{color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item span{color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link{color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover{color:#d1cccc}.jodit-dialog_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited{color:#d1cccc}.jodit_theme_dark .jodit-status-bar{color:#d1cccc}.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item a{color:#d1cccc}.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item span{color:#d1cccc}.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link{color:#d1cccc}.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover{color:#d1cccc}.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited{color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty){color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item a{color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) .jodit-status-bar__item span{color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link{color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover{color:#d1cccc}.jodit_theme_dark .jodit-workplace+.jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited{color:#d1cccc}.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty){background:#5f5c5c}.jodit_theme_dark .jodit-toolbar__box:not(:empty){background:#5f5c5c}.jodit-dialog_theme_dark .jodit-icon{fill:silver;stroke:silver}.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-toolbar-button__trigger{fill:silver;stroke:silver}.jodit-dialog_theme_dark .jodit__upload-button svg{fill:silver;stroke:silver}.jodit_theme_dark .jodit-icon{fill:silver;stroke:silver}.jodit_theme_dark .jodit-toolbar-button .jodit-toolbar-button__trigger{fill:silver;stroke:silver}.jodit_theme_dark .jodit__upload-button svg{fill:silver;stroke:silver}.jodit-dialog_theme_dark .jodit-icon-close{stroke:silver}.jodit_theme_dark .jodit-icon-close{stroke:silver}.jodit-dialog_theme_dark .jodit-wysiwyg{background-color:#575757;color:#d1cccc}.jodit-dialog_theme_dark .jodit-wysiwyg_iframe{background-color:#575757;color:#d1cccc}.jodit_theme_dark .jodit-wysiwyg{background-color:#575757;color:#d1cccc}.jodit_theme_dark .jodit-wysiwyg_iframe{background-color:#575757;color:#d1cccc}.jodit-dialog_theme_dark .jodit-form input[type=text]{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit-dialog_theme_dark .jodit-form input[type=url]{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit-dialog_theme_dark .jodit-form textarea{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit_theme_dark .jodit-form input[type=text]{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit_theme_dark .jodit-form input[type=url]{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit_theme_dark .jodit-form textarea{background-color:rgba(81,81,81,.41);border-color:#686767;color:#d1cccc}.jodit-dialog_theme_dark .jodit-form button{background-color:hsla(0,0%,41%,.75);color:#d1cccc}.jodit_theme_dark .jodit-form button{background-color:hsla(0,0%,41%,.75);color:#d1cccc}.jodit-dialog_theme_dark .jodit-placeholder{color:hsla(0,5%,81%,.8)}.jodit_theme_dark .jodit-placeholder{color:hsla(0,5%,81%,.8)}.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box{color:#d1cccc}.jodit-dialog_theme_dark .jodit_uploadfile_button{color:#d1cccc}.jodit_theme_dark .jodit-drag-and-drop__file-box{color:#d1cccc}.jodit_theme_dark .jodit_uploadfile_button{color:#d1cccc}.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box:hover{background-color:hsla(0,0%,41%,.75)}.jodit-dialog_theme_dark .jodit_uploadfile_button:hover{background-color:hsla(0,0%,41%,.75)}.jodit_theme_dark .jodit-drag-and-drop__file-box:hover{background-color:hsla(0,0%,41%,.75)}.jodit_theme_dark .jodit_uploadfile_button:hover{background-color:hsla(0,0%,41%,.75)}.jodit-dialog_theme_dark .jodit-add-new-line:before{border-top-color:#686767}.jodit_theme_dark .jodit-add-new-line:before{border-top-color:#686767}.jodit-dialog_theme_dark .jodit-add-new-line span{background:hsla(0,0%,41%,.75);border-color:#686767}.jodit_theme_dark .jodit-add-new-line span{background:hsla(0,0%,41%,.75);border-color:#686767}.jodit-dialog_theme_dark .jodit-add-new-line span svg{fill:#d1cccc}.jodit_theme_dark .jodit-add-new-line span svg{fill:#d1cccc}.jodit-dialog_theme_dark .jodit-resizer>i{background:hsla(0,0%,41%,.75);border-color:silver}.jodit_theme_dark .jodit-resizer>i{background:hsla(0,0%,41%,.75);border-color:silver}.jodit-dialog_theme_dark .jodit-input{background-color:#787878;border-color:#444;color:#444}.jodit-dialog_theme_dark .jodit-select{background-color:#787878;border-color:#444;color:#444}.jodit_theme_dark .jodit-input{background-color:#787878;border-color:#444;color:#444}.jodit_theme_dark .jodit-select{background-color:#787878;border-color:#444;color:#444}.jodit-dialog_theme_dark.jodit-dialog{background-color:#575757}.jodit_theme_dark.jodit-dialog{background-color:#575757}.jodit-dialog_theme_dark.jodit-dialog .jodit-dialog__header{border-color:#444}.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item{border-color:#444}.jodit_theme_dark.jodit-dialog .jodit-dialog__header{border-color:#444}.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item{border-color:#444}.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info{background-color:#d1cccc}.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info{background-color:#d1cccc}', ""]);
          const g = b;
        },
        379: t => {

          var o = [];
          function i(t) {
            for (var i = -1, e = 0; e < o.length; e++) if (o[e].identifier === t) {
              i = e;
              break;
            }
            return i;
          }
          function e(t, e) {
            for (var r = {}, n = [], d = 0; d < t.length; d++) {
              var l = t[d],
                s = e.base ? l[0] + e.base : l[0],
                c = r[s] || 0,
                p = "".concat(s, " ").concat(c);
              r[s] = c + 1;
              var b = i(p),
                u = {
                  css: l[1],
                  media: l[2],
                  sourceMap: l[3],
                  supports: l[4],
                  layer: l[5]
                };
              if (-1 !== b) o[b].references++, o[b].updater(u);else {
                var x = a(u, e);
                e.byIndex = d, o.splice(d, 0, {
                  identifier: p,
                  updater: x,
                  references: 1
                });
              }
              n.push(p);
            }
            return n;
          }
          function a(t, o) {
            var i = o.domAPI(o);
            return i.update(t), function (o) {
              if (o) {
                if (o.css === t.css && o.media === t.media && o.sourceMap === t.sourceMap && o.supports === t.supports && o.layer === t.layer) return;
                i.update(t = o);
              } else i.remove();
            };
          }
          t.exports = function (t, a) {
            var r = e(t = t || [], a = a || {});
            return function (t) {
              t = t || [];
              for (var n = 0; n < r.length; n++) {
                var d = i(r[n]);
                o[d].references--;
              }
              for (var l = e(t, a), s = 0; s < r.length; s++) {
                var c = i(r[s]);
                0 === o[c].references && (o[c].updater(), o.splice(c, 1));
              }
              r = l;
            };
          };
        },
        569: t => {

          var o = {};
          t.exports = function (t, i) {
            var e = function (t) {
              if (void 0 === o[t]) {
                var i = document.querySelector(t);
                if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                  i = i.contentDocument.head;
                } catch (t) {
                  i = null;
                }
                o[t] = i;
              }
              return o[t];
            }(t);
            if (!e) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            e.appendChild(i);
          };
        },
        216: t => {

          t.exports = function (t) {
            var o = document.createElement("style");
            return t.setAttributes(o, t.attributes), t.insert(o, t.options), o;
          };
        },
        565: (t, o, i) => {

          t.exports = function (t) {
            var o = i.nc;
            o && t.setAttribute("nonce", o);
          };
        },
        795: t => {

          t.exports = function (t) {
            var o = t.insertStyleElement(t);
            return {
              update: function (i) {
                !function (t, o, i) {
                  var e = "";
                  i.supports && (e += "@supports (".concat(i.supports, ") {")), i.media && (e += "@media ".concat(i.media, " {"));
                  var a = void 0 !== i.layer;
                  a && (e += "@layer".concat(i.layer.length > 0 ? " ".concat(i.layer) : "", " {")), e += i.css, a && (e += "}"), i.media && (e += "}"), i.supports && (e += "}");
                  var r = i.sourceMap;
                  r && "undefined" != typeof btoa && (e += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), o.styleTagTransform(e, t, o.options);
                }(o, t, i);
              },
              remove: function () {
                !function (t) {
                  if (null === t.parentNode) return !1;
                  t.parentNode.removeChild(t);
                }(o);
              }
            };
          };
        },
        589: t => {

          t.exports = function (t, o) {
            if (o.styleSheet) o.styleSheet.cssText = t;else {
              for (; o.firstChild;) o.removeChild(o.firstChild);
              o.appendChild(document.createTextNode(t));
            }
          };
        },
        963: t => {

          t.exports = "data:image/png;base64,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";
        },
        910: t => {

          t.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NH08L3N0eWxlPjwvZGVmcz48cGF0aCBzdHlsZT0iZmlsbDojZmZmIiBkPSJNMCAwaDQuOTV2MTBIMHoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Im0xLjQxIDQuNjcgMS4wNy0xLjQ5IDEuMDYgMS40OUgxLjQxek0zLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zM2gyLjEzeiIvPjwvc3ZnPg==";
        },
        456: t => {

          t.exports = "data:image/svg+xml;charset=utf-8,%3Csvg id=%27Layer_1%27 data-name=%27Layer 1%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4.95 10%27%3E%3Cdefs%3E%3Cstyle%3E.cls-2{fill:%23444}%3C/style%3E%3C/defs%3E%3Cpath style=%27fill:%23fff%27 d=%27M0 0h4.95v10H0z%27/%3E%3Cpath class=%27cls-2%27 d=%27m1.41 4.67 1.07-1.49 1.06 1.49H1.41zM3.54 5.33 2.48 6.82 1.41 5.33h2.13z%27/%3E%3C/svg%3E";
        },
        342: t => {

          t.exports = o;
        },
        787: o => {

          o.exports = t;
        }
      },
      e = {};
    function a(t) {
      var o = e[t];
      if (void 0 !== o) return o.exports;
      var r = e[t] = {
        id: t,
        exports: {}
      };
      return i[t](r, r.exports, a), r.exports;
    }
    a.m = i, a.n = t => {
      var o = t && t.__esModule ? () => t.default : () => t;
      return a.d(o, {
        a: o
      }), o;
    }, a.d = (t, o) => {
      for (var i in o) a.o(o, i) && !a.o(t, i) && Object.defineProperty(t, i, {
        enumerable: !0,
        get: o[i]
      });
    }, a.o = (t, o) => Object.prototype.hasOwnProperty.call(t, o), a.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, a.b = document.baseURI || self.location.href, a.nc = void 0;
    var r = {};
    return (() => {

      a.r(r), a.d(r, {
        Jodit: () => e.Jodit,
        default: () => k
      });
      var t = a(787),
        o = a.n(t),
        i = a(526),
        e = a(342),
        n = a(379),
        d = a.n(n),
        l = a(795),
        s = a.n(l),
        c = a(569),
        p = a.n(c),
        b = a(565),
        u = a.n(b),
        x = a(216),
        _ = a.n(x),
        g = a(589),
        f = a.n(g),
        j = a(472),
        m = {};
      m.styleTagTransform = f(), m.setAttributes = u(), m.insert = p().bind(null, "head"), m.domAPI = s(), m.insertStyleElement = _(), d()(j.Z, m), j.Z && j.Z.locals && j.Z.locals;
      var h = e.Jodit.modules.Helpers.isFunction,
        w = (0, t.forwardRef)(function (i, a) {
          var r = i.className,
            n = i.config,
            d = i.id,
            l = i.name,
            s = i.onBlur,
            c = i.onChange,
            p = i.tabIndex,
            b = i.value,
            u = i.editorRef,
            x = (0, t.useRef)(null);
          (0, t.useLayoutEffect)(function () {
            a && (h(a) ? a(x.current) : a.current = x.current);
          }, [x, a]), (0, t.useEffect)(function () {
            var t = x.current,
              o = e.Jodit.make(t, n);
            return x.current = o, h(u) && u(o), function () {
              o && o.destruct(), x.current = t;
            };
          }, [n, u]);
          var _ = function (o) {
            var i = (0, t.useRef)();
            return (0, t.useEffect)(function () {
              i.current = o;
            }, [o]), i.current;
          }(r);
          return (0, t.useEffect)(function () {
            var t,
              o,
              i = null === (t = x.current) || void 0 === t || null === (o = t.container) || void 0 === o ? void 0 : o.classList;
            _ !== r && "string" == typeof _ && _.split(/\s+/).forEach(function (t) {
              return null == i ? void 0 : i.remove(t);
            }), r && "string" == typeof r && r.split(/\s+/).forEach(function (t) {
              return null == i ? void 0 : i.add(t);
            });
          }, [r, _]), (0, t.useEffect)(function () {
            x.current.workplace && (x.current.workplace.tabIndex = p || -1);
          }, [p]), (0, t.useEffect)(function () {
            if (x.current.events && (s || c)) {
              var t = function (t) {
                  return s && s(x.current.value, t);
                },
                o = function (t) {
                  return c && c(t);
                };
              return x.current.events.on("blur", t).on("change", o), function () {
                var i, e;
                null === (i = x.current) || void 0 === i || null === (e = i.events) || void 0 === e || e.off("blur", t).off("change", o);
              };
            }
          }, [s, c]), (0, t.useEffect)(function () {
            var t = function () {
              var t;
              x.current && (null == x || null === (t = x.current) || void 0 === t ? void 0 : t.value) !== b && (x.current.value = b);
            };
            x.current && (x.current.isReady ? t() : x.current.waitForReady().then(t));
          }, [b]), o().createElement("div", {
            className: "jodit-react-container"
          }, o().createElement("textarea", {
            name: l,
            id: d,
            ref: x
          }));
        });
      w.displayName = "JoditEditor", w.propTypes = {
        className: i.string,
        config: i.object,
        id: i.string,
        name: i.string,
        onBlur: i.func,
        onChange: i.func,
        editorRef: i.func,
        tabIndex: i.number,
        value: i.string
      };
      const k = w;
    })(), r;
  })());
});
var JoditEditor = unwrapExports(joditReact);

function sanitizeInput(html) {
  try {
    html = decodeURIComponent(html);
  } catch {}
  let clean = purify.sanitize(html, {
    ALLOWED_TAGS: false,
    ALLOWED_ATTR: false,
    FORBID_TAGS: ["script", "iframe", "svg", "math"],
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "srcdoc"],
    FORCE_BODY: true
  });
  clean = clean.replace(/\{\{.*?\}\}/g, "").replace(/\$\{.*?\}/g, "").replace(/expression\s*\(/gi, "").replace(/(javascript:|vbscript:|data:text\/html)/gi, "");
  return clean;
}
function newsanitizeInput(html) {
  if (!html) return "";
  try {
    html = decodeURIComponent(html);
  } catch {}
  let clean = purify.sanitize(html, {
    ALLOWED_TAGS: ["p", "strong", "em", "a", "ul", "ol", "li", "br", "img"],
    ALLOWED_ATTR: ["href", "src", "alt"],
    FORBID_TAGS: ["script", "iframe", "svg", "math", "object", "embed"],
    FORBID_ATTR: ["style", "onerror", "onload", "onclick", "onmouseover", "onfocus", "srcdoc"],
    FORCE_BODY: true
  });
  clean = clean.replace(/\{\{.*?\}\}/g, "").replace(/\$\{.*?\}/g, "").replace(/expression\s*\(/gi, "").replace(/(javascript:|vbscript:|data:text\/html)/gi, "");
  return clean;
}
function useSanitizedContent(setterFn, logger = null, useNewSanitized = false) {
  return useCallback(rawHtml => {
    const cleaned = useNewSanitized ? newsanitizeInput(rawHtml) : sanitizeInput(rawHtml);
    if (logger) logger(`Sanitized: ${cleaned}`);
    setterFn(cleaned);
  }, [setterFn, logger]);
}

function DemoParinted({
  content,
  setContent,
  useNewSanitized = false
}) {
  const [logs, setLogs] = useState([]);
  const appendLog = useCallback(message => {
    const newLogs = [...logs, message];
    setLogs(newLogs);
  }, [logs, setLogs]);
  const config = useMemo(() => ({
    readonly: false,
    height: 300,
    cleanHTML: {
      cleanOnPaste: true,
      removeEmptyElements: true
    },
    allowTags: "p,strong,em,a,ul,ol,li,br,img",
    allowAttributes: ["href", "src", "alt"],
    defaultLinkProtocol: "https",
    removeEmptyAttributes: true,
    disablePlugins: ["about"]
  }), []);
  const onChange = useCallback(newContent => appendLog(`onChange triggered: ${newContent}`), [appendLog]);
  const onBlur = useSanitizedContent(setContent, appendLog, useNewSanitized);
  useEffect(() => {}, [onChange]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(JoditEditor, {
    value: content,
    config: config,
    tabIndex: 1,
    onBlur: onBlur,
    onChange: onChange
  }));
}

const BootstrapDialog = styled$1(Dialog)(({
  theme
}) => ({
  zIndex: 99999,
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  },
  "& .MuiPaper-root": {
    minWidth: "fit-content"
  }
}));
const DialogContentModal = ({
  children,
  dataOpen,
  onClose,
  title
}) => {
  const conponentPDF = useRef();
  const [open, setOpen] = React__default.useState(false);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BootstrapDialog, {
    "aria-labelledby": "customized-dialog-title",
    open: dataOpen,
    fullWidth: true,
    maxWidth: "lg",
    style: {
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    className: "myapplication-dialog-title",
    id: "customized-dialog-title"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "8px"
    }
  }, title), /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement("button", {
      className: "btn btn-success",
      id: "invoice-print"
    }, "Print"),
    content: () => conponentPDF.current
  })), /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "close",
    onClick: onClose,
    sx: {
      position: "absolute",
      right: 8,
      top: 8,
      zIndex: 10,
      color: theme => theme.palette.grey[500]
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement(DialogContent, {
    dividers: true
  }, children))));
};

const questions = [{
  label: "Does your site require NOC from Municipal Corporation?",
  applicantName: "nocFromMunicipalCorporation",
  employeeName: "nocFromMunicipalCorporationEmployee"
}, {
  label: "Does your plot fall under 300m radius of any monument?",
  applicantName: "plotRadiusMonument",
  employeeName: "plotRadiusMonumentEmployee"
}, {
  label: "Does your proposal require Fire Noc?",
  applicantName: "requireFireNoc",
  employeeName: "requireFireNocEmployee"
}, {
  label: "Does your proposal require Environmental clearance Noc?",
  applicantName: "environmentClearanceNoc",
  employeeName: "environmentClearanceNocEmployee"
}, {
  label: "Is proposed plot near major crossroad (Chauraha) or affecting traffic?",
  applicantName: "plotNearCrossroad",
  employeeName: "plotNearCrossroadEmployee"
}, {
  label: "Is your plot nearby irrigation land/irrigation canal?",
  applicantName: "plotNearIrrigationLand",
  employeeName: "plotNearIrrigationLandEmployee"
}, {
  label: "Is your plot abutting PWD Road?",
  applicantName: "plotAbuttingPWD",
  employeeName: "plotAbuttingPWDEmployee"
}, {
  label: "Is your plot within 100 meters of a metro structure/corridor?",
  applicantName: "plotNearMetro",
  employeeName: "plotNearMetroEmployee"
}, {
  label: "Is the proposed site within 30 meters of a railway line/land?",
  applicantName: "siteNearRailwayBoundary",
  employeeName: "siteNearRailwayBoundaryEmployee"
}, {
  label: "Is your plot near Forest Land or any Major tree which requires NOC from the forest department?",
  applicantName: "plotNearForestLand",
  employeeName: "plotNearForestLandEmployee"
}, {
  label: "Is your plot abutting any National Highway?",
  applicantName: "plotAbuttingNationalHighway",
  employeeName: "plotAbuttingNationalHighwayEmployee"
}, {
  label: "Are you planning to use boundary material on your plot (for plots larger than 2000 sq. m)?",
  applicantName: "useBuildingMaterial",
  employeeName: "useBuildingMaterialEmployee"
}, {
  label: "Is your plot falling in funnel zone of Airport authorities/defence airport?",
  applicantName: "plotFunnelZoneAirport",
  employeeName: "plotFunnelZoneAirportEmployee"
}, {
  label: "Does your site require Land Acquisition department NOC?",
  applicantName: "landAcquisitionNOC",
  employeeName: "landAcquisitionNOCEmployee"
}, {
  label: "Does your site require Nazool department NOC?",
  applicantName: "nazoolDepartmentNOC",
  employeeName: "nazoolDepartmentNOCEmployee"
}, {
  label: "Does your site require Improvement Trust NOC?",
  applicantName: "improvementTrustNOC",
  employeeName: "improvementTrustNOCEmployee"
}, {
  label: "Does your site require NOC from Tehsil?",
  applicantName: "nocFromTehsil",
  employeeName: "nocFromTehsilEmployee"
}, {
  label: "Does your site require Property Department NOC? (Is your plot Leasehold?)",
  applicantName: "propertyDepartmentNOC",
  employeeName: "propertyDepartmentNOCEmployee"
}, {
  label: "Does your site require Ceiling department NOC?",
  applicantName: "ceilingDepartmentNOC",
  employeeName: "ceilingDepartmentNOCEmployee"
}, {
  label: "Does your site require Land Use Certificate?",
  applicantName: "landUseCertificate",
  employeeName: "landUseCertificateEmployee"
}, {
  label: "Is your proposed plot near defence area?",
  applicantName: "plotNearDefenseArea",
  employeeName: "plotNearDefenseAreaEmployee"
}, {
  label: "Is your proposed site within 100 meters of any security zone?",
  applicantName: "siteNearSecurityZone",
  employeeName: "siteNearSecurityZoneEmployee"
}, {
  label: " Is the plot situated within 30 meters of any government authority?",
  applicantName: "siteNearGovtAuthority",
  employeeName: "siteNearGovtAuthorityEmployee"
}, {
  label: "Is your proposed property affecting any Administrative revenue?",
  applicantName: "propertyAffectingRevenue",
  employeeName: "propertyAffectingRevenueEmployee"
}, {
  label: "Is your plot adjacent to UPAVP Land?",
  applicantName: "plotAdjacentUPAVP",
  employeeName: "plotAdjacentUPAVPEmployee"
}, {
  label: "Are you proposing any tourist activities on your plot?",
  applicantName: "touristActivities",
  employeeName: "touristActivitiesEmployee"
}, {
  label: "Is your plot abutting any Major road of National Capital Region?",
  applicantName: "plotAbuttingMajorRoadNCR",
  employeeName: "plotAbuttingMajorRoadNCREmployee"
}, {
  label: "Is your plot within 100 meters of a jail?",
  applicantName: "plotNearJail",
  employeeName: "plotNearJailEmployee"
}, {
  label: "Is your proposed site not a single dwelling unit and you are proposing a basement?",
  applicantName: "siteProposingBasement",
  employeeName: "siteProposingBasementEmployee"
}, {
  label: "Does your plot require an approach road from any National Highway?",
  applicantName: "plotApproachRoadNH",
  employeeName: "plotApproachRoadNHEmployee"
}, {
  label: "Is the property allotted to you directly by the authority/UPAVP?",
  applicantName: "propertyAllottedByUPAVP",
  employeeName: "propertyAllottedByUPAVPEmployee"
}, {
  label: "Do you want to attach any additional documents?",
  applicantName: "attachAdditionalDocuments",
  employeeName: "attachAdditionalDocumentsEmployee"
}, {
  label: "Does your plot require permission from Torrent Power Limited/Any other electricity service provider?",
  applicantName: "permissionElectricityProvider",
  employeeName: "permissionElectricityProviderEmployee"
}, {
  label: "Is your plot proposed for Green Building?",
  applicantName: "proposedGreenBuilding",
  employeeName: "proposedGreenBuildingEmployee"
}, {
  label: "Does your site require NOC from the Security Department?",
  applicantName: "securityDepartmentNOC",
  employeeName: "securityDepartmentNOCEmployee"
}];

const ApplicaionFormatView = forwardRef(({
  formData,
  applicationDocs,
  logoData
}, ref) => {
  var _logoData$boundary, _logoData$boundary$fi, _formData$landInfo, _formData$nocDetails, _formData$nocDetails2, _formData$description, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description36, _formData$description37, _formData$description38, _formData$taxHeadEsti, _formData$taxHeadEsti2;
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const isEmployee = history.location.pathname.includes("employee");
  const user = Digit.UserService.getUser();
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const currentLogoId = logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.location1))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  if (isEmployee) {
    var _user$info, _formData$location;
    nameOfDepartment = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.tenantId) == "up.da" ? `${formData === null || formData === void 0 ? void 0 : (_formData$location = formData.location1) === null || _formData$location === void 0 ? void 0 : _formData$location.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  } else {
    nameOfDepartment = applicationFlow === "DA" ? `${formData === null || formData === void 0 ? void 0 : formData.location1.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  }
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const roadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidths;
  const khasraDetails = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraDetails;
  const approachRoadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidths;
  console.log(formData, "FromSUmmary");
  const nocApplicantData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.applicantNOCData;
  const selectedNOCs = console.log(nocApplicantData, "nocapplicant");
  const additionalNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.additionalApplicantNOC;
  console.log("additionalNocs", additionalNOC);
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const StyledTableCell = styled(TableCell$1)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled(TableRow$1)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const accordionSummaryStyles = {
    backgroundColor: "rgb(230, 239, 248)",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "rgb(230, 239, 248)",
      minHeight: "48px",
      height: "1rem"
    }
  };
  const filteredDocuments = applicationDocs.filter(doc => !["applicantPhoto", "signature"].includes(doc.documentType));
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Id"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, isDA ? /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Office : ")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.selectedOffice)))) : /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Unit:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedUnit)), (formData === null || formData === void 0 ? void 0 : formData.selectedCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedCity))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px",
        marginTop: "80px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))));
  }))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.consultantCategory)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.planDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Validity :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.planDate)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.mobileNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.certificateNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.certificateNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.licenseNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.licenseNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.emailId))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      margin: "0px 4px",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plan on :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.planOn) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.schemeName) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.sectorNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.developmentArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.developmentArea) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.activityAsPerMap) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity Proposed :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.activityProposed) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.proposedActivity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Activity as per Zoning Regulation :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.proposedActivity) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.landUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.schemeType) === "Scheme" ? "Land Use as per Layout Plan :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.landUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.schemeType) === "Scheme" ? "Land Sub Use as per Layout :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.subLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.otherMasterPlan) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Master Layout Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.otherMasterPlan) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.selectLandUse) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Block No./Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.permanentAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.district) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_DISTRICT"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.permanentAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.district) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 1 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 2 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Width :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Length :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) || "")), (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0 && !isSchemeType && khasraDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.district || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.tehsil || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Village ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.village || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.plotNo || "")))), (formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.plotAreaDoc) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per document) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.plotAreaDoc)), (formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per site) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.landArea)), (formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.plotAreaPossession) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per possession) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description35 = formData.descriptionOfLand) === null || _formData$description35 === void 0 ? void 0 : _formData$description35.plotAreaPossession)), (roadWidths === null || roadWidths === void 0 ? void 0 : roadWidths.length) > 0 && roadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (Existing) (m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (approachRoadWidths === null || approachRoadWidths === void 0 ? void 0 : approachRoadWidths.length) > 0 && approachRoadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (as per the respective plan) (m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nearby Landmark :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Address :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) || "")))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " ")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }))))), ((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) || (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description36 = formData.descriptionOfLand) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : _formData$description37.googleMapLocation))))))))), (nocApplicantData || additionalNOC) && !isLowRiskCase && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("BPA_MY_APPLICATIONS_LANDUSENOC")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true).map((questionItem, index) => {
    const {
      label,
      applicantName
    } = questionItem;
    const answer = nocApplicantData[applicantName] ? "Yes" : "No";
    console.log("fromMap", answer, label, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true));
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, answer));
  }), additionalNOC === null || additionalNOC === void 0 ? void 0 : additionalNOC.map((item, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, "Yes"));
  })))))))), !((formData === null || formData === void 0 ? void 0 : (_formData$description38 = formData.descriptionOfLand) === null || _formData$description38 === void 0 ? void 0 : _formData$description38.schemeType) == "Scheme") && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, " ", /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Land Use Verification"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount))))))))));
});

const FormatSlip$1 = ({
  scrutinyTable,
  scrutinyDetails,
  wordslist
}) => {
  var _scrutinyData, _scrutinyData$applica, _scrutinyDetails$land, _scrutinyDetails$land2, _scrutinyDetails$land3, _scrutinyDetails$land4, _scrutinyDetails$land5, _scrutinyDetails$land6, _scrutinyDetails$land7, _scrutinyDetails$land8, _scrutinyDetails$land9;
  const isTcp = (_scrutinyData = scrutinyData) === null || _scrutinyData === void 0 ? void 0 : (_scrutinyData$applica = _scrutinyData.applicationNo) === null || _scrutinyData$applica === void 0 ? void 0 : _scrutinyData$applica.includes('TCP');
  const urlImg = isTcp ? "https://i.imgur.com/NgZ3OtP.jpeg" : "https://ud.hp.gov.in/sites/default/files/logo.png";
  const colorCodeUrl = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const colorCode = isTcp ? "#248624f7" : "#1f4a7c";
  const colorCodeiner = isTcp ? "#f06107ed" : "#000";
  const nameOfDepartment = isTcp ? "Department of Town and Country Planning" : "Urban Development Department";
  const title = isTcp ? (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land = scrutinyDetails.landAreaDetails) === null || _scrutinyDetails$land === void 0 ? void 0 : _scrutinyDetails$land.areaType) === 'Special' ? `Special Area Development Authority ${scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land2 = scrutinyDetails.landAreaDetails) === null || _scrutinyDetails$land2 === void 0 ? void 0 : _scrutinyDetails$land2.city}` : `Planning Area Development ${scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land3 = scrutinyDetails.landAreaDetails) === null || _scrutinyDetails$land3 === void 0 ? void 0 : _scrutinyDetails$land3.city}` : `${scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land4 = scrutinyDetails.landAreaDetails) === null || _scrutinyDetails$land4 === void 0 ? void 0 : (_scrutinyDetails$land5 = _scrutinyDetails$land4.locality) === null || _scrutinyDetails$land5 === void 0 ? void 0 : _scrutinyDetails$land5.name}`;
  const date = convertEpochToDateDMY(scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.auditDetails.createdTime);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, scrutinyTable && /*#__PURE__*/React__default.createElement("div", {
    classNameName: "FormatSlipbody"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container bootstrap snippets bootdeys"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      marginLeft: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "85",
    src: colorCodeUrl,
    alt: "Himachal"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "23px",
      marginTop: "6px"
    }
  }, "Govermment of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      marginTop: "4px"
    }
  }, nameOfDepartment))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, " ", /*#__PURE__*/React__default.createElement("hr", null), " "), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      border: `10px solid ${colorCode}`,
      padding: "12px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-sm-12",
    style: {
      border: `5px solid ${colorCodeiner}`,
      padding: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      opacity: 0.09,
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      flexDirection: "column",
      gap: 10,
      userSelect: "none"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: 200,
    src: urlImg,
    alt: "hp"
  }), /*#__PURE__*/React__default.createElement("p", null, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", null, "Govermment of Uttar Pradesh")), /*#__PURE__*/React__default.createElement("div", {
    className: "panel panel-default invoice",
    id: "invoice"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "invoice-ribbon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "ribbon-inner",
    style: {
      background: colorCode
    }
  }, "PAID")), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    width: "90",
    style: {
      margin: "auto"
    },
    src: urlImg,
    alt: "Himachal"
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      textAlign: "center",
      fontSize: "23px",
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, title)), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      fontSize: "18px",
      margin: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "18rem",
      border: `2px solid ${colorCode}`,
      color: colorCode,
      margin: "auto",
      borderRadius: "50px"
    }
  }, "PAYMENT RECEIPT"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, "No : ", scrutinyTable.txnId), /*#__PURE__*/React__default.createElement("div", null, "Dated : ", date)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontFamily: "Arial, sans-serif",
      margin: "20px",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    classname: "receiptApp"
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      color: colorCode,
      textAlign: "center",
      margin: "5px"
    }
  }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "block",
      marginBottom: "20px",
      marginLeft: "25px",
      color: "#333",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name Of Applicant : Sh./Smt."), " ", scrutinyTable.user.name, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Phone No :"), " ", scrutinyTable.user.mobileNumber, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Email Id :"), " ", scrutinyTable.user.emailId, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Received Bank :"), " ", scrutinyTable.gateway, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Status :"), " ", scrutinyTable.txnStatusMsg, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Address:"), " ", scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$land6 = scrutinyDetails.landInfo) === null || _scrutinyDetails$land6 === void 0 ? void 0 : (_scrutinyDetails$land7 = _scrutinyDetails$land6.owners) === null || _scrutinyDetails$land7 === void 0 ? void 0 : (_scrutinyDetails$land8 = _scrutinyDetails$land7[0]) === null || _scrutinyDetails$land8 === void 0 ? void 0 : (_scrutinyDetails$land9 = _scrutinyDetails$land8.correspondenceAddress) === null || _scrutinyDetails$land9 === void 0 ? void 0 : _scrutinyDetails$land9.address)), /*#__PURE__*/React__default.createElement("table", {
    className: "dataTablePayment"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount of words"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Applicaion Fee"), /*#__PURE__*/React__default.createElement("td", null, wordslist), /*#__PURE__*/React__default.createElement("td", null, " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnAmount)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "20px",
      textAlign: "right",
      color: "#333"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount:"), " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.txnAmount)))))))))));
};

const PaymentPrint$2 = ({
  id
}) => {
  var _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords_2();
  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const getApplicationPay = async () => {
    var _window, _window$localStorage;
    setLoader(true);
    const token = (_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem("token");
    let requestInfo = {
      "RequestInfo": {
        "apiId": "Rainmaker",
        "ver": "v1",
        "ts": 0,
        "action": "_search",
        "did": "",
        "key": "",
        "msgId": "090909",
        "requesterId": "",
        authToken: token,
        userInfo: userInfo
      }
    };
    try {
      var _Resp$Transaction, _Resp$Transaction2, _Resp$Transaction2$, _Resp$Transaction2$$a, _Resp$Transaction2$$a2;
      const Resp = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then(response => {
        return response === null || response === void 0 ? void 0 : response.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction = Resp.Transaction) === null || _Resp$Transaction === void 0 ? void 0 : _Resp$Transaction[0]);
      const amountPaid = Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction2 = Resp.Transaction) === null || _Resp$Transaction2 === void 0 ? void 0 : (_Resp$Transaction2$ = _Resp$Transaction2[0]) === null || _Resp$Transaction2$ === void 0 ? void 0 : (_Resp$Transaction2$$a = _Resp$Transaction2$.additionalDetails) === null || _Resp$Transaction2$$a === void 0 ? void 0 : (_Resp$Transaction2$$a2 = _Resp$Transaction2$$a.taxAndPayments[0]) === null || _Resp$Transaction2$$a2 === void 0 ? void 0 : _Resp$Transaction2$$a2.amountPaid;
      if (amountPaid) {
        const wordsList = toWords.convert(amountPaid, {
          currency: true,
          ignoreDecimal: false
        });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getApplicationPay();
  }, [id]);
  const {
    data: applicationData = {},
    isLoading: paymentStatus
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id
  }, {
    formType: "form11"
  });
  const business_service = applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService;
  const {
    eg_pg_txnid: egId,
    txnStatus: txn,
    workflow: workflw
  } = Digit.Hooks.useQueryParams();
  const {
    isLoading: paymentLoading,
    data,
    isError
  } = Digit.Hooks.usePaymentUpdate({
    egId,
    txn
  }, business_service, {
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
  if (loader || paymentStatus) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "justify-content-center",
    style: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "50%",
      minHeight: "40%",
      marginTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, null, /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormatSlip$1, {
    scrutinyTable: scrutinyTable,
    scrutinyDetails: applicationData,
    wordslist: amountDetails
  })))));
};

const NOCCheckList = ({
  checklist
}) => {
  var _checklist$buildupAre, _checklist$buildupAre2, _checklist$buildupAre3, _checklist$buildupAre4, _checklist$farNOC, _checklist$farNOC2, _checklist$farNOC3, _checklist$farNOC4, _checklist$coverageNO, _checklist$coverageNO2, _checklist$coverageNO3, _checklist$coverageNO4, _checklist$regulateds, _checklist$setBacks, _checklist$setBacks_r, _checklist$regulateds2, _checklist$setBacks2, _checklist$setBacks_r2, _checklist$regulateds3, _checklist$setBacks3, _checklist$setBacks_r3, _checklist$regulateds4, _checklist$setBacks4, _checklist$setBacks_r4, _checklist$numberOfSt, _checklist$numberOfSt2, _checklist$numberOfSt3, _checklist$numberOfSt4, _checklist$pathDevelo, _checklist$pathDevelo2, _checklist$pathDevelo3, _checklist$pathDevelo4, _checklist$parkingPro, _checklist$parkingPro2, _checklist$parkingPro3, _checklist$parkingPro4, _checklist$htLineNOC, _checklist$htLineNOC2, _checklist$htLineNOC3, _checklist$htLineNOC4, _checklist$provisionO, _checklist$provisionO2, _checklist$provisionO3, _checklist$provisionO4, _checklist$barrierfre, _checklist$barrierfre2, _checklist$barrierfre3, _checklist$barrierfre4, _checklist$provisionR, _checklist$provisionR2, _checklist$provisionR3, _checklist$provisionR4, _checklist$numberOfDw, _checklist$numberOfDw2, _checklist$numberOfDw3, _checklist$numberOfDw4, _checklist$maxHillCut, _checklist$maxHillCut2, _checklist$maxHillCut3, _checklist$maxHillCut4, _checklist$sewerNOC, _checklist$sewerNOC2, _checklist$sewerNOC3, _checklist$sewerNOC4, _checklist$septicNOC, _checklist$septicNOC2, _checklist$septicNOC3, _checklist$septicNOC4, _checklist$heightOfSl, _checklist$heightOfSl2, _checklist$heightOfSl3, _checklist$heightOfSl4, _checklist$plinthHeig, _checklist$plinthHeig2, _checklist$plinthHeig3, _checklist$plinthHeig4, _checklist$closedFloo, _checklist$closedFloo2, _checklist$closedFloo3, _checklist$closedFloo4, _checklist$retainingw, _checklist$retainingw2, _checklist$retainingw3, _checklist$retainingw4, _checklist$boundaryWa, _checklist$boundaryWa2, _checklist$boundaryWa3, _checklist$boundaryWa4, _checklist$aboveValle, _checklist$aboveValle2, _checklist$aboveValle3, _checklist$aboveValle4;
  const url = window.location.href;
  const isStructuralOrEmployee = url.includes("structural") || url.includes("employee");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      width: isStructuralOrEmployee ? '82%' : '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Sr.", /*#__PURE__*/React__default.createElement("br", null), "No."), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Detail of Regulation as per provision"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Detail of Regualtion as per approved plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Provision made as per approved plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Built up Area"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre = checklist.buildupAreaNOC) === null || _checklist$buildupAre === void 0 ? void 0 : _checklist$buildupAre.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre2 = checklist.buildupAreaNOC) === null || _checklist$buildupAre2 === void 0 ? void 0 : _checklist$buildupAre2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.builtupArea)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre3 = checklist.buildupAreaNOC) === null || _checklist$buildupAre3 === void 0 ? void 0 : _checklist$buildupAre3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre4 = checklist.buildupAreaNOC) === null || _checklist$buildupAre4 === void 0 ? void 0 : _checklist$buildupAre4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "FAR"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC = checklist.farNOC) === null || _checklist$farNOC === void 0 ? void 0 : _checklist$farNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC2 = checklist.farNOC) === null || _checklist$farNOC2 === void 0 ? void 0 : _checklist$farNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC3 = checklist.farNOC) === null || _checklist$farNOC3 === void 0 ? void 0 : _checklist$farNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC4 = checklist.farNOC) === null || _checklist$farNOC4 === void 0 ? void 0 : _checklist$farNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "% Coverage"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO = checklist.coverageNOC) === null || _checklist$coverageNO === void 0 ? void 0 : _checklist$coverageNO.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO2 = checklist.coverageNOC) === null || _checklist$coverageNO2 === void 0 ? void 0 : _checklist$coverageNO2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO3 = checklist.coverageNOC) === null || _checklist$coverageNO3 === void 0 ? void 0 : _checklist$coverageNO3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO4 = checklist.coverageNOC) === null || _checklist$coverageNO4 === void 0 ? void 0 : _checklist$coverageNO4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }, "4"), /*#__PURE__*/React__default.createElement("td", null, "Setbacks(meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds = checklist.regulatedsetBacks) === null || _checklist$regulateds === void 0 ? void 0 : _checklist$regulateds.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks = checklist.setBacks) === null || _checklist$setBacks === void 0 ? void 0 : _checklist$setBacks.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r === void 0 ? void 0 : _checklist$setBacks_r.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds2 = checklist.regulatedsetBacks) === null || _checklist$regulateds2 === void 0 ? void 0 : _checklist$regulateds2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks2 = checklist.setBacks) === null || _checklist$setBacks2 === void 0 ? void 0 : _checklist$setBacks2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r2 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r2 === void 0 ? void 0 : _checklist$setBacks_r2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds3 = checklist.regulatedsetBacks) === null || _checklist$regulateds3 === void 0 ? void 0 : _checklist$regulateds3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks3 = checklist.setBacks) === null || _checklist$setBacks3 === void 0 ? void 0 : _checklist$setBacks3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r3 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r3 === void 0 ? void 0 : _checklist$setBacks_r3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds4 = checklist.regulatedsetBacks) === null || _checklist$regulateds4 === void 0 ? void 0 : _checklist$regulateds4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks4 = checklist.setBacks) === null || _checklist$setBacks4 === void 0 ? void 0 : _checklist$setBacks4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r4 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r4 === void 0 ? void 0 : _checklist$setBacks_r4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "No of Storeys"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt === void 0 ? void 0 : _checklist$numberOfSt.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt2 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt2 === void 0 ? void 0 : _checklist$numberOfSt2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt3 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt3 === void 0 ? void 0 : _checklist$numberOfSt3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt4 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt4 === void 0 ? void 0 : _checklist$numberOfSt4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Roads/Path exist at a site (Whether path develop at the site or not)"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo = checklist.pathDevelopNOC) === null || _checklist$pathDevelo === void 0 ? void 0 : _checklist$pathDevelo.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo2 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo2 === void 0 ? void 0 : _checklist$pathDevelo2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo3 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo3 === void 0 ? void 0 : _checklist$pathDevelo3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo4 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo4 === void 0 ? void 0 : _checklist$pathDevelo4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "7"), /*#__PURE__*/React__default.createElement("td", null, "Parking Provision"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro = checklist.parkingProvisionNOC) === null || _checklist$parkingPro === void 0 ? void 0 : _checklist$parkingPro.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro2 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro2 === void 0 ? void 0 : _checklist$parkingPro2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.parkingProvision)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro3 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro3 === void 0 ? void 0 : _checklist$parkingPro3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro4 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro4 === void 0 ? void 0 : _checklist$parkingPro4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "8"), /*#__PURE__*/React__default.createElement("td", null, "Whether any HT/LT line crossing over the proposed land"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC = checklist.htLineNOC) === null || _checklist$htLineNOC === void 0 ? void 0 : _checklist$htLineNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC2 = checklist.htLineNOC) === null || _checklist$htLineNOC2 === void 0 ? void 0 : _checklist$htLineNOC2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC3 = checklist.htLineNOC) === null || _checklist$htLineNOC3 === void 0 ? void 0 : _checklist$htLineNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC4 = checklist.htLineNOC) === null || _checklist$htLineNOC4 === void 0 ? void 0 : _checklist$htLineNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "9"), /*#__PURE__*/React__default.createElement("td", null, "Provision for solar passive building technology made or not"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO = checklist.provisionOfSolarNOC) === null || _checklist$provisionO === void 0 ? void 0 : _checklist$provisionO.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO2 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO2 === void 0 ? void 0 : _checklist$provisionO2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO3 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO3 === void 0 ? void 0 : _checklist$provisionO3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO4 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO4 === void 0 ? void 0 : _checklist$provisionO4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "10"), /*#__PURE__*/React__default.createElement("td", null, "Provision of barrier-free access for person"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre = checklist.barrierfreeNOC) === null || _checklist$barrierfre === void 0 ? void 0 : _checklist$barrierfre.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre2 = checklist.barrierfreeNOC) === null || _checklist$barrierfre2 === void 0 ? void 0 : _checklist$barrierfre2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre3 = checklist.barrierfreeNOC) === null || _checklist$barrierfre3 === void 0 ? void 0 : _checklist$barrierfre3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre4 = checklist.barrierfreeNOC) === null || _checklist$barrierfre4 === void 0 ? void 0 : _checklist$barrierfre4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "11"), /*#__PURE__*/React__default.createElement("td", null, "Provision of rainwater harvesting tank (optional in case of the building having a roof area less than 200 Sqm) Connectivity to the rainwater harvesting tank."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR === void 0 ? void 0 : _checklist$provisionR.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR2 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR2 === void 0 ? void 0 : _checklist$provisionR2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR3 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR3 === void 0 ? void 0 : _checklist$provisionR3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR4 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR4 === void 0 ? void 0 : _checklist$provisionR4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "12"), /*#__PURE__*/React__default.createElement("td", null, "Number of Dwelling Units"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw === void 0 ? void 0 : _checklist$numberOfDw.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw2 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw2 === void 0 ? void 0 : _checklist$numberOfDw2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw3 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw3 === void 0 ? void 0 : _checklist$numberOfDw3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw4 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw4 === void 0 ? void 0 : _checklist$numberOfDw4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "13"), /*#__PURE__*/React__default.createElement("td", null, "Maximum Hill Cut"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut = checklist.maxHillCutNOC) === null || _checklist$maxHillCut === void 0 ? void 0 : _checklist$maxHillCut.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut2 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut2 === void 0 ? void 0 : _checklist$maxHillCut2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut3 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut3 === void 0 ? void 0 : _checklist$maxHillCut3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut4 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut4 === void 0 ? void 0 : _checklist$maxHillCut4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "14"), /*#__PURE__*/React__default.createElement("td", null, "Whether sewer exists in the vicinity or not. Connectivity to the sewer line."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC = checklist.sewerNOC) === null || _checklist$sewerNOC === void 0 ? void 0 : _checklist$sewerNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC2 = checklist.sewerNOC) === null || _checklist$sewerNOC2 === void 0 ? void 0 : _checklist$sewerNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC3 = checklist.sewerNOC) === null || _checklist$sewerNOC3 === void 0 ? void 0 : _checklist$sewerNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC4 = checklist.sewerNOC) === null || _checklist$sewerNOC4 === void 0 ? void 0 : _checklist$sewerNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "15"), /*#__PURE__*/React__default.createElement("td", null, "Provision of Septic tank"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC = checklist.septicNOC) === null || _checklist$septicNOC === void 0 ? void 0 : _checklist$septicNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC2 = checklist.septicNOC) === null || _checklist$septicNOC2 === void 0 ? void 0 : _checklist$septicNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC3 = checklist.septicNOC) === null || _checklist$septicNOC3 === void 0 ? void 0 : _checklist$septicNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC4 = checklist.septicNOC) === null || _checklist$septicNOC4 === void 0 ? void 0 : _checklist$septicNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "16"), /*#__PURE__*/React__default.createElement("td", null, "Provision of a sloping roof"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl === void 0 ? void 0 : _checklist$heightOfSl.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl2 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl2 === void 0 ? void 0 : _checklist$heightOfSl2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.heightOfSloppingRoof)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl3 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl3 === void 0 ? void 0 : _checklist$heightOfSl3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl4 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl4 === void 0 ? void 0 : _checklist$heightOfSl4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "17"), /*#__PURE__*/React__default.createElement("td", null, "Height raising/Plinth level"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig = checklist.plinthHeightNOC) === null || _checklist$plinthHeig === void 0 ? void 0 : _checklist$plinthHeig.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig2 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig2 === void 0 ? void 0 : _checklist$plinthHeig2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig3 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig3 === void 0 ? void 0 : _checklist$plinthHeig3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig4 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig4 === void 0 ? void 0 : _checklist$plinthHeig4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "18"), /*#__PURE__*/React__default.createElement("td", null, "The closed floor in any"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo = checklist.closedFloorNOC) === null || _checklist$closedFloo === void 0 ? void 0 : _checklist$closedFloo.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo2 = checklist.closedFloorNOC) === null || _checklist$closedFloo2 === void 0 ? void 0 : _checklist$closedFloo2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo3 = checklist.closedFloorNOC) === null || _checklist$closedFloo3 === void 0 ? void 0 : _checklist$closedFloo3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo4 = checklist.closedFloorNOC) === null || _checklist$closedFloo4 === void 0 ? void 0 : _checklist$closedFloo4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "19"), /*#__PURE__*/React__default.createElement("td", null, "Retaining work and site development"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw = checklist.retainingworkNOC) === null || _checklist$retainingw === void 0 ? void 0 : _checklist$retainingw.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw2 = checklist.retainingworkNOC) === null || _checklist$retainingw2 === void 0 ? void 0 : _checklist$retainingw2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw3 = checklist.retainingworkNOC) === null || _checklist$retainingw3 === void 0 ? void 0 : _checklist$retainingw3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw4 = checklist.retainingworkNOC) === null || _checklist$retainingw4 === void 0 ? void 0 : _checklist$retainingw4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "20"), /*#__PURE__*/React__default.createElement("td", null, "Boundary Wall erected or not"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa === void 0 ? void 0 : _checklist$boundaryWa.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa2 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa2 === void 0 ? void 0 : _checklist$boundaryWa2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa3 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa3 === void 0 ? void 0 : _checklist$boundaryWa3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa4 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa4 === void 0 ? void 0 : _checklist$boundaryWa4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "21"), /*#__PURE__*/React__default.createElement("td", null, "Whether the building is above the road on the valley side."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle = checklist.aboveValleySideNOC) === null || _checklist$aboveValle === void 0 ? void 0 : _checklist$aboveValle.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle2 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle2 === void 0 ? void 0 : _checklist$aboveValle2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle3 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle3 === void 0 ? void 0 : _checklist$aboveValle3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle4 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle4 === void 0 ? void 0 : _checklist$aboveValle4.remarks))))))));
};

const NOCFormatView = ({
  formData,
  applicationDocs
}) => {
  var _formData$application, _formData$taxHeadEsti, _landAreaDetails$loca, _landAreaDetails$vill, _professionalDetails$;
  const {
    t
  } = useTranslation();
  const isUdFlow = formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationNo) === null || _formData$application === void 0 ? void 0 : _formData$application.includes('UD');
  const landAreaDetails = formData === null || formData === void 0 ? void 0 : formData.landAreaDetails;
  const professionalDetails = formData === null || formData === void 0 ? void 0 : formData.professionalInformation;
  const tcpNOCDetails = formData === null || formData === void 0 ? void 0 : formData.tcpNOCdetails;
  const udNOCDetails = formData === null || formData === void 0 ? void 0 : formData.udNOCdetails;
  const checklist = formData === null || formData === void 0 ? void 0 : formData.checklist;
  const feeDetails = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const udNOCdetailsDocuments = applicationDocs === null || applicationDocs === void 0 ? void 0 : applicationDocs.filter(doc => {
    var _doc$documentType;
    return doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.includes('udNOCdetails');
  });
  const stabilityDocDocuments = applicationDocs === null || applicationDocs === void 0 ? void 0 : applicationDocs.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === 'stabilityDoc');
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "1px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC Application")), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      backgroundColor: "#eeeab5b0",
      padding: "20px"
    }
  }, "NOC Form used for taking permission for Electrical, Sewerage, and water connection from the Urban Development Department."), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "Application Details:")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Apllication Type: ", formData === null || formData === void 0 ? void 0 : formData.applicationType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Applied For: ", formData === null || formData === void 0 ? void 0 : formData.appliedFor)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Reference Application No: ", formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Application No: ", formData === null || formData === void 0 ? void 0 : formData.applicationNo)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "District: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Notified-Area: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$loca = landAreaDetails.locality) === null || _landAreaDetails$loca === void 0 ? void 0 : _landAreaDetails$loca.name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Village: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$vill = landAreaDetails.village) === null || _landAreaDetails$vill === void 0 ? void 0 : _landAreaDetails$vill.name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Area Type: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.areaType))))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "Professional Details:")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Name: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Registration Number: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.registrationNumber)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Mobile Number: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.mobileNumber)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Email-Id    : ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.emailId)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Address: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : (_professionalDetails$ = professionalDetails.address) === null || _professionalDetails$ === void 0 ? void 0 : _professionalDetails$.address))))), !isUdFlow && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "NOC Details:")), tcpNOCDetails === null || tcpNOCDetails === void 0 ? void 0 : tcpNOCDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "NOC Type: ", item === null || item === void 0 ? void 0 : item.nocType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Floor Type: ", item === null || item === void 0 ? void 0 : item.floorName)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Land-Use Type : ", item === null || item === void 0 ? void 0 : item.landUseType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Services  : ", item === null || item === void 0 ? void 0 : item.services))), index !== tcpNOCDetails.length - 1 && /*#__PURE__*/React__default.createElement(Divider, {
    style: {
      marginTop: '10px'
    }
  }), " ")))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "NOC Details:")), udNOCDetails === null || udNOCDetails === void 0 ? void 0 : udNOCDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Name: ", item.name)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Email: ", item.emailId)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Applied On: ", new Date(item.appliedOnDate).toLocaleDateString()))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Categories: ", item.categories)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Blocks: ", item.blockNameAsPerDatabase)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Floor Name: ", item.floorName))), " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "No of Connections: ", item.noOfConnections)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Noc Type: ", item.nocType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments([udNOCdetailsDocuments[index]]),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })))), index !== udNOCDetails.length - 1 && /*#__PURE__*/React__default.createElement(Divider, null), " ")))), checklist && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "Checklist Details:")), /*#__PURE__*/React__default.createElement(NOCCheckList, {
    checklist: checklist
  }))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "Document Details:")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Stability Document:")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(stabilityDocDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })))))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    component: "h2"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, "Total Amount: ", feeDetails === null || feeDetails === void 0 ? void 0 : feeDetails.estimateAmount)))))));
};

function ApplicationViewHistory({
  id,
  formType
}) {
  var _Digit$UserService$ge, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  });
  const {
    applicationData,
    edcrDetails,
    collectionBillDetails
  } = data;
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService
  });
  const timelineStatusPrefix = `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.applicationBusinessService : applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService}_`;
  if (!isLoading && data && workflowDetails) {
    console.log("dfygbhusw", data, id, formType, workflowDetails);
  }
  console.log("yyyyyyyyyyy", userInfo);
  if (isLoading && data && workflowDetails) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && workflowDetails && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.timeline) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map((item, index) => {
    var _item$assigner, _item$wfComment, _item$wfComment2, _item$assigner2, _item$assigner3, _item$assigner3$roles, _item$assigner4, _item$assigner4$roles, _item$assigner5, _item$assigner5$roles, _item$assigner6, _item$assigner6$roles, _item$assignes, _item$assignes$, _item$auditDetails, _item$wfComment3, _item$wfComment4, _item$assigner7, _item$assigner8, _item$assigner8$roles, _item$assigner9, _item$assigner9$roles, _item$assigner10, _item$assigner10$role, _item$assigner11, _item$assigner11$role, _item$assignes2, _item$assignes2$, _item$auditDetails2;
    return /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement("b", {
      style: {
        marginLeft: "2%"
      }
    }, t(`${timelineStatusPrefix}${item === null || item === void 0 ? void 0 : item.state}`), " by (", item === null || item === void 0 ? void 0 : (_item$assigner = item.assigner) === null || _item$assigner === void 0 ? void 0 : _item$assigner.name, ")"), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment = item.wfComment) === null || _item$wfComment === void 0 ? void 0 : _item$wfComment.map(e => /*#__PURE__*/React__default.createElement("div", {
      className: "TLComments",
      style: {
        backgroundColor: "aliceblue"
      }
    }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: e
    }))))) : null, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment2 = item.wfComment) === null || _item$wfComment2 === void 0 ? void 0 : _item$wfComment2.map(e => {
      var _item$wfDocuments, _item$wfDocuments$;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "TLComments",
        style: {
          backgroundColor: "aliceblue"
        }
      }, /*#__PURE__*/React__default.createElement("h3", null, "Document"), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: "10px"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: item === null || item === void 0 ? void 0 : (_item$wfDocuments = item.wfDocuments) === null || _item$wfDocuments === void 0 ? void 0 : (_item$wfDocuments$ = _item$wfDocuments[0]) === null || _item$wfDocuments$ === void 0 ? void 0 : _item$wfDocuments$.url,
        style: {
          minWidth: "80px",
          height: "auto",
          minWidth: "30px"
        }
      }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "30px"
        }
      })))));
    })) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assigner2 = item.assigner) === null || _item$assigner2 === void 0 ? void 0 : _item$assigner2.name), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, (item === null || item === void 0 ? void 0 : (_item$assigner3 = item.assigner) === null || _item$assigner3 === void 0 ? void 0 : (_item$assigner3$roles = _item$assigner3.roles[0]) === null || _item$assigner3$roles === void 0 ? void 0 : _item$assigner3$roles.code) === ("EMPLOYEE" ) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner4 = item.assigner) === null || _item$assigner4 === void 0 ? void 0 : (_item$assigner4$roles = _item$assigner4.roles[1]) === null || _item$assigner4$roles === void 0 ? void 0 : _item$assigner4$roles.name), (item === null || item === void 0 ? void 0 : (_item$assigner5 = item.assigner) === null || _item$assigner5 === void 0 ? void 0 : (_item$assigner5$roles = _item$assigner5.roles[1]) === null || _item$assigner5$roles === void 0 ? void 0 : _item$assigner5$roles.code) === "EMPLOYEE" ||  /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner6 = item.assigner) === null || _item$assigner6 === void 0 ? void 0 : (_item$assigner6$roles = _item$assigner6.roles[0]) === null || _item$assigner6$roles === void 0 ? void 0 : _item$assigner6$roles.name)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : _item$assignes$.mobileNumber), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.created)), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) != "EMPLOYEE" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px",
        padding: "2%"
      }
    }, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment3 = item.wfComment) === null || _item$wfComment3 === void 0 ? void 0 : _item$wfComment3.map(e => /*#__PURE__*/React__default.createElement("div", {
      className: "TLComments",
      style: {
        backgroundColor: "aliceblue"
      }
    }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: e
    }))))) : null, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment4 = item.wfComment) === null || _item$wfComment4 === void 0 ? void 0 : _item$wfComment4.map(e => {
      var _item$wfDocuments2, _item$wfDocuments2$;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "TLComments",
        style: {
          backgroundColor: "aliceblue"
        }
      }, /*#__PURE__*/React__default.createElement("h3", null, "Document"), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: "10px"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: item === null || item === void 0 ? void 0 : (_item$wfDocuments2 = item.wfDocuments) === null || _item$wfDocuments2 === void 0 ? void 0 : (_item$wfDocuments2$ = _item$wfDocuments2[0]) === null || _item$wfDocuments2$ === void 0 ? void 0 : _item$wfDocuments2$.url,
        style: {
          minWidth: "80px",
          height: "auto",
          minWidth: "30px"
        }
      }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "30px"
        }
      })))));
    })) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assigner7 = item.assigner) === null || _item$assigner7 === void 0 ? void 0 : _item$assigner7.name), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, (item === null || item === void 0 ? void 0 : (_item$assigner8 = item.assigner) === null || _item$assigner8 === void 0 ? void 0 : (_item$assigner8$roles = _item$assigner8.roles[0]) === null || _item$assigner8$roles === void 0 ? void 0 : _item$assigner8$roles.code) === ("EMPLOYEE" ) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner9 = item.assigner) === null || _item$assigner9 === void 0 ? void 0 : (_item$assigner9$roles = _item$assigner9.roles[1]) === null || _item$assigner9$roles === void 0 ? void 0 : _item$assigner9$roles.name), (item === null || item === void 0 ? void 0 : (_item$assigner10 = item.assigner) === null || _item$assigner10 === void 0 ? void 0 : (_item$assigner10$role = _item$assigner10.roles[1]) === null || _item$assigner10$role === void 0 ? void 0 : _item$assigner10$role.code) === "EMPLOYEE" ||  /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner11 = item.assigner) === null || _item$assigner11 === void 0 ? void 0 : (_item$assigner11$role = _item$assigner11.roles[0]) === null || _item$assigner11$role === void 0 ? void 0 : _item$assigner11$role.name)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : (_item$assignes2$ = _item$assignes2[0]) === null || _item$assignes2$ === void 0 ? void 0 : _item$assignes2$.mobileNumber), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.created)));
  }), /*#__PURE__*/React__default.createElement("br", null))));
}

function ApplicationViewHistoryAll({
  id,
  formType,
  formHistory
}) {
  var _Digit$UserService$ge, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  const formData = data;
  const {
    collectionBillRes,
    collectionBillDetails
  } = data;
  if (!isLoading && formData) {
    var _collectionBillRes$, _collectionBillRes$$p;
    formData.paymentDetails = collectionBillRes === null || collectionBillRes === void 0 ? void 0 : (_collectionBillRes$ = collectionBillRes[0]) === null || _collectionBillRes$ === void 0 ? void 0 : (_collectionBillRes$$p = _collectionBillRes$.paymentDetails) === null || _collectionBillRes$$p === void 0 ? void 0 : _collectionBillRes$$p[0];
  }
  console.log("dfygbhusw", data, formData, id, formType);
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: formData === null || formData === void 0 ? void 0 : formData.businessService
  });
  const timelineStatusPrefix = `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.applicationBusinessService : formData === null || formData === void 0 ? void 0 : formData.businessService}_`;
  if (!isLoading && data && workflowDetails) {
    console.log("dfygbhusw", data, id, formType, workflowDetails);
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && workflowDetails && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.timeline) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map((item, index) => {
    var _item$assigner, _item$wfComment, _item$wfComment2, _item$assigner2, _item$assigner3, _item$assigner3$roles, _item$assigner4, _item$assigner4$roles, _item$assigner5, _item$assigner5$roles, _item$assigner6, _item$assigner6$roles, _item$assignes, _item$assignes$, _item$auditDetails, _item$wfComment3, _item$wfComment4, _item$assigner7, _item$assigner8, _item$assigner8$roles, _item$assigner9, _item$assigner9$roles, _item$assigner10, _item$assigner10$role, _item$assigner11, _item$assigner11$role, _item$assignes2, _item$assignes2$, _item$auditDetails2;
    return /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement("b", {
      style: {
        marginLeft: "2%"
      }
    }, t(`${timelineStatusPrefix}${item === null || item === void 0 ? void 0 : item.state}`), " by (", item === null || item === void 0 ? void 0 : (_item$assigner = item.assigner) === null || _item$assigner === void 0 ? void 0 : _item$assigner.name, ")"), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment = item.wfComment) === null || _item$wfComment === void 0 ? void 0 : _item$wfComment.map(e => /*#__PURE__*/React__default.createElement("div", {
      className: "TLComments",
      style: {
        backgroundColor: "aliceblue"
      }
    }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: e
    }))))) : null, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment2 = item.wfComment) === null || _item$wfComment2 === void 0 ? void 0 : _item$wfComment2.map(e => {
      var _item$wfDocuments, _item$wfDocuments$;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "TLComments",
        style: {
          backgroundColor: "aliceblue"
        }
      }, /*#__PURE__*/React__default.createElement("h3", null, "Document"), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: "10px"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: item === null || item === void 0 ? void 0 : (_item$wfDocuments = item.wfDocuments) === null || _item$wfDocuments === void 0 ? void 0 : (_item$wfDocuments$ = _item$wfDocuments[0]) === null || _item$wfDocuments$ === void 0 ? void 0 : _item$wfDocuments$.url,
        style: {
          minWidth: "80px",
          height: "auto",
          minWidth: "30px"
        }
      }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "30px"
        }
      })))));
    })) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assigner2 = item.assigner) === null || _item$assigner2 === void 0 ? void 0 : _item$assigner2.name), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, (item === null || item === void 0 ? void 0 : (_item$assigner3 = item.assigner) === null || _item$assigner3 === void 0 ? void 0 : (_item$assigner3$roles = _item$assigner3.roles[0]) === null || _item$assigner3$roles === void 0 ? void 0 : _item$assigner3$roles.code) === ("EMPLOYEE" ) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner4 = item.assigner) === null || _item$assigner4 === void 0 ? void 0 : (_item$assigner4$roles = _item$assigner4.roles[1]) === null || _item$assigner4$roles === void 0 ? void 0 : _item$assigner4$roles.name), (item === null || item === void 0 ? void 0 : (_item$assigner5 = item.assigner) === null || _item$assigner5 === void 0 ? void 0 : (_item$assigner5$roles = _item$assigner5.roles[1]) === null || _item$assigner5$roles === void 0 ? void 0 : _item$assigner5$roles.code) === "EMPLOYEE" ||  /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner6 = item.assigner) === null || _item$assigner6 === void 0 ? void 0 : (_item$assigner6$roles = _item$assigner6.roles[0]) === null || _item$assigner6$roles === void 0 ? void 0 : _item$assigner6$roles.name)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : _item$assignes$.mobileNumber), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.created)), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) != "EMPLOYEE" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px",
        padding: "2%"
      }
    }, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment3 = item.wfComment) === null || _item$wfComment3 === void 0 ? void 0 : _item$wfComment3.map(e => /*#__PURE__*/React__default.createElement("div", {
      className: "TLComments",
      style: {
        backgroundColor: "aliceblue"
      }
    }, /*#__PURE__*/React__default.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: e
    }))))) : null, item !== null && item !== void 0 && item.wfComment ? /*#__PURE__*/React__default.createElement("div", null, item === null || item === void 0 ? void 0 : (_item$wfComment4 = item.wfComment) === null || _item$wfComment4 === void 0 ? void 0 : _item$wfComment4.map(e => {
      var _item$wfDocuments2, _item$wfDocuments2$;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "TLComments",
        style: {
          backgroundColor: "aliceblue"
        }
      }, /*#__PURE__*/React__default.createElement("h3", null, "Document"), /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginLeft: "10px"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: item === null || item === void 0 ? void 0 : (_item$wfDocuments2 = item.wfDocuments) === null || _item$wfDocuments2 === void 0 ? void 0 : (_item$wfDocuments2$ = _item$wfDocuments2[0]) === null || _item$wfDocuments2$ === void 0 ? void 0 : _item$wfDocuments2$.url,
        style: {
          minWidth: "80px",
          height: "auto",
          minWidth: "30px"
        }
      }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "30px"
        }
      })))));
    })) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assigner7 = item.assigner) === null || _item$assigner7 === void 0 ? void 0 : _item$assigner7.name), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, (item === null || item === void 0 ? void 0 : (_item$assigner8 = item.assigner) === null || _item$assigner8 === void 0 ? void 0 : (_item$assigner8$roles = _item$assigner8.roles[0]) === null || _item$assigner8$roles === void 0 ? void 0 : _item$assigner8$roles.code) === ("EMPLOYEE" ) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner9 = item.assigner) === null || _item$assigner9 === void 0 ? void 0 : (_item$assigner9$roles = _item$assigner9.roles[1]) === null || _item$assigner9$roles === void 0 ? void 0 : _item$assigner9$roles.name), (item === null || item === void 0 ? void 0 : (_item$assigner10 = item.assigner) === null || _item$assigner10 === void 0 ? void 0 : (_item$assigner10$role = _item$assigner10.roles[1]) === null || _item$assigner10$role === void 0 ? void 0 : _item$assigner10$role.code) === ("EMPLOYEE" ) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item === null || item === void 0 ? void 0 : (_item$assigner11 = item.assigner) === null || _item$assigner11 === void 0 ? void 0 : (_item$assigner11$role = _item$assigner11.roles[0]) === null || _item$assigner11$role === void 0 ? void 0 : _item$assigner11$role.name)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : (_item$assignes2$ = _item$assignes2[0]) === null || _item$assignes2$ === void 0 ? void 0 : _item$assignes2$.mobileNumber), /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "end"
      }
    }, item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.created)));
  }), /*#__PURE__*/React__default.createElement("br", null))));
}

const citizenBaseUrl = "/digit-ui/citizen";
const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
const Sidebarlabels = [{
  text: "Dashboard",
  path: `${citizenBaseUrl}/profile`
}, {
  text: "Edit Profile",
  path: `${citizenBaseUrl}/user/profile`
}, {
  text: "My Applications",
  path: `${citizenBaseUrl}/obps/ownerApplications`
}, {
  text: "Back to Home Page",
  path: `${citizenBaseUrl}`
}, {
  text: "Logout",
  path: `${citizenBaseUrl}`
}];
const SidebarLabelsLandUse = [{
  text: "Dashboard",
  path: `${citizenBaseUrl}/profile`
}, {
  text: "Edit Profile",
  path: `${citizenBaseUrl}/user/profile`
}, {
  text: "My Applications",
  path: `${citizenBaseUrl}/obps/formLandUseApplications`
}, {
  text: "Back to Home Page",
  path: `${citizenBaseUrl}`
}, {
  text: "Logout",
  path: `${citizenBaseUrl}`
}];
const SideBarLabelsFAR = [{
  text: "Dashboard",
  path: `${citizenBaseUrl}/profile`
}, {
  text: "Edit Profile",
  path: `${citizenBaseUrl}/user/profile`
}, {
  text: "My Applications",
  path: `${citizenBaseUrl}/obps/purchasableFarApplications`
}, {
  text: "Back to Home Page",
  path: `${citizenBaseUrl}`
}, {
  text: "Logout",
  path: `${citizenBaseUrl}`
}];
const landUseSubTabLabels = [{
  text: "Property Owner/Applicant Details"
}, {
  text: "Licensed Technical Professional (LTP) Information"
}, {
  text: "Land/Plot Information"
}];
const landUseSubTabDDocSecLabels = [{
  text: "Mandatory Documents"
}, {
  text: "Conditional Documents"
}];
const farSubTabLabels = [{
  text: "Verifying Authority"
}, {
  text: "Applicant Details"
}, {
  text: "Layout Details"
}, {
  text: "FAR Details"
}];
const primaryTabLabels = [{
  text: "Land Use Verification"
}, {
  text: "Documents"
}, {
  text: "Summary"
}];
const farPrimaryLabels = [{
  text: "Applicant Details"
}, {
  text: "Documents"
}, {
  text: "Checklist"
}, {
  text: "Summary"
}];

const ButtonWrapper$1 = ({
  variant,
  disabled,
  onClick,
  color,
  size,
  startIcon,
  endIcon,
  label,
  type,
  sx
}) => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button, {
    sx: {
      borderRadius: "5px",
      padding: '4px 10px',
      cursor: 'pointer',
      letterSpacing: '2px',
      width: '95px',
      ...sx
    },
    variant: variant,
    disabled: disabled,
    onClick: onClick,
    color: color,
    size: size,
    startIcon: startIcon,
    endIcon: endIcon,
    type: type || "button"
  }, label));
};

const FormInfo$1 = styled(Box)(() => ({
  backgroundColor: "#fff7cb",
  margin: "2rem auto 0",
  padding: "1.5rem"
}));
const PrimaryTabsWrapper = styled("div")(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem",
  marginTop: "11px",
  marginBottom: "8px"
}));
const MainTabs$1 = styled(Tabs)(() => ({
  marginInline: "auto"
}));
const MainTab$1 = styled(Tab)(() => ({
  "&.MuiTab-root": {
    textTransform: "none",
    paddingInline: "1rem",
    color: "#1F4A7C",
    outline: "none"
  },
  "&.Mui-selected": {
    backgroundColor: "#1F4A7C",
    color: "white"
  }
}));
const PrimaryTabs = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "#5CB85C",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const PrimaryTab = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53, 124, 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14 55 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  }
}));
const PrimaryTabNewTheme = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53 124 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(22deg, rgb(14, 55, 79) 0%, rgb(38 86 112) 100%)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  }
}));
const MandatoryInfo$1 = styled(Box)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: "red",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const InfoBox$1 = styled(Box)(() => ({
  lineHeight: 1.5,
  fontSize: "16px",
  color: "#1F4A7C",
  padding: "8px 16px",
  backgroundColor: "#f0f4fa",
  borderRadius: "1px",
  fontWeight: "600",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const StyledMenuItem$1 = styled(MenuItem$2)(() => ({
  "&.MuiMenuItem-root": {
    padding: "0.25rem 0.75rem",
    display: "block"
  }
}));
const accordionSummaryStyles$1 = {
  height: "1rem",
  minHeight: "48px",
  "&.Mui-expanded": {
    backgroundColor: "rgb(230, 239, 248)",
    minHeight: "48px",
    height: "1rem"
  }
};
const SubTabsWrapper$1 = styled(Box)(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem",
  marginBottom: "18px"
}));
const SubTabs$1 = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "rgb(73, 151, 192)",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const SubTab$1 = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const SubTabNewTheme = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)!important",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)!important",
    color: "#fff",
    fontSize: ".85rem",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const StyledDivider = styled(Divider)(({
  theme
}) => ({
  height: "1px" + "!important",
  backgroundColor: "#085A85",
  color: "#1F4A7C",
  alignSelf: "center"
}));
const PortalWrapper = styled("div")(() => ({
  display: "flex",
  height: "100vh",
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden"
}));
const SideWrapper = styled("div")(() => ({
  flex: "0 0 15%",
  backgroundColor: "#262D33"
}));
const SideBarWrapper = styled(Box)(() => ({
  height: "100vh",
  color: "#fff",
  padding: "1rem",
  boxSizing: "border-box"
}));
const ModuleTextWrapper = styled("h2")(() => ({
  backgroundColor: "#157CB3",
  margin: ".625rem",
  padding: ".5rem"
}));
const MainWrapper = styled("div")(() => ({
  flex: "0 0 100%",
  padding: "1rem",
  overflowX: "hidden"
}));
const FormInputContainer = styled("div")(() => ({
  display: "flex",
  borderRadius: "1px",
  padding: "1.25rem 1.5rem",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  overflow: "auto"
}));
const RowWrapper = styled("div")(() => ({
  flex: 1,
  gap: "1rem",
  display: "flex",
  flexDirection: "column"
}));
const StyledOutlinedInput = styled(OutlinedInput)(() => ({
  borderRadius: "5px",
  border: "2px solid #1F4A7C"
}));
const SummaryCard = styled(Card$1)(() => ({
  backgroundColor: "rgb(21, 124, 179)"
}));
const CustomAccordionSummary = styled(AccordionSummary)(({
  theme
}) => ({
  marginLeft: 0,
  color: "#fff",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center"
  }
}));

const OwnerSummary = forwardRef(({
  formData,
  ref
}) => {
  var _formData$landInfo, _formData$landInfo2, _documents$filter, _documents$filter$, _formData$ownerOrAppl, _formData$ownerOrAppl2, _formData$approvedLay, _formData$approvedLay2, _formData$morethanOne, _formData$morethanOne2, _formData$morethanOne3, _formData$morethanOne4, _descriptionOfLand$go, _descriptionOfLand$go2, _descriptionOfLand$go3, _descriptionOfLand$go4, _formData$checklist, _formData$checklist2, _formData$checklist3, _formData$checklist4, _formData$checklist5, _formData$checklist6, _formData$checklist7, _formData$checklist8, _formData$checklist9, _formData$checklist10, _formData$checklist11, _formData$checklist12;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const properties = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.properties;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const applicant = formData === null || formData === void 0 ? void 0 : formData.applicant;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const bankInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.bankdetails;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)\[\d+\]$/.test(doc.documentType));
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Basic Information'))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Are You the Owner or Applicant")), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl = formData.ownerOrApplicant) === null || _formData$ownerOrAppl === void 0 ? void 0 : _formData$ownerOrAppl.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl2 = formData.ownerOrApplicant) === null || _formData$ownerOrAppl2 === void 0 ? void 0 : _formData$ownerOrAppl2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Property Part of Approved Layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay = formData.approvedLayout) === null || _formData$approvedLay === void 0 ? void 0 : _formData$approvedLay.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay2 = formData.approvedLayout) === null || _formData$approvedLay2 === void 0 ? void 0 : _formData$approvedLay2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Owner:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne = formData.morethanOneOwner) === null || _formData$morethanOne === void 0 ? void 0 : _formData$morethanOne.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne2 = formData.morethanOneOwner) === null || _formData$morethanOne2 === void 0 ? void 0 : _formData$morethanOne2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Property:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne3 = formData.morethanOneProperty) === null || _formData$morethanOne3 === void 0 ? void 0 : _formData$morethanOne3.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne4 = formData.morethanOneProperty) === null || _formData$morethanOne4 === void 0 ? void 0 : _formData$morethanOne4.slice(1))))))))), (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.emailId)), (applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.address)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Authorization Letter:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    },
    onClick: () => getDocumentByFileStoreId(authorization, setIsPreviewLoading)
  })))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Addition Owner Information' : 'Owner Information')), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "City :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))))))));
  })), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((item, index) => {
    var _item$appliedLandUse, _item$appliedLandUse2, _item$propertyType, _item$propertyType2, _item$propertyAddress, _item$propertyAddress2, _item$propertyAddress3, _item$propertyAddress4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      defaultExpanded: true,
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Additional Registration Information' : 'Registration Information')), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        margin: "0px 4px",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, item.schemeName && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.schemeName)), ((_item$appliedLandUse = item.appliedLandUse) === null || _item$appliedLandUse === void 0 ? void 0 : _item$appliedLandUse.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applied Land Use :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$appliedLandUse2 = item.appliedLandUse) === null || _item$appliedLandUse2 === void 0 ? void 0 : _item$appliedLandUse2.name)), item.khatauniNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khatauniNo)), item.khataNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khataNo)), item.khasraNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khasraNo)), item.plotNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotNo)), item.roadWidth && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Road Width :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.roadWidth)), item.plotArea && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotArea)), ((_item$propertyType = item.propertyType) === null || _item$propertyType === void 0 ? void 0 : _item$propertyType.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Property Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$propertyType2 = item.propertyType) === null || _item$propertyType2 === void 0 ? void 0 : _item$propertyType2.name)), (((_item$propertyAddress = item.propertyAddress) === null || _item$propertyAddress === void 0 ? void 0 : _item$propertyAddress.address) || item.city || ((_item$propertyAddress2 = item.propertyAddress) === null || _item$propertyAddress2 === void 0 ? void 0 : _item$propertyAddress2.pinno)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, `${((_item$propertyAddress3 = item.propertyAddress) === null || _item$propertyAddress3 === void 0 ? void 0 : _item$propertyAddress3.address) || ''}, ${item.city || ''}, ${((_item$propertyAddress4 = item.propertyAddress) === null || _item$propertyAddress4 === void 0 ? void 0 : _item$propertyAddress4.pinno) || ''}`))))));
  })), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Bank Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account Holder Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Bank Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Branch Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "IFSC Code:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapCoordinates) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go === void 0 ? void 0 : (_descriptionOfLand$go2 = _descriptionOfLand$go[0]) === null || _descriptionOfLand$go2 === void 0 ? void 0 : _descriptionOfLand$go2.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go3 = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go3 === void 0 ? void 0 : (_descriptionOfLand$go4 = _descriptionOfLand$go3[0]) === null || _descriptionOfLand$go4 === void 0 ? void 0 : _descriptionOfLand$go4.longitude)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: '20px',
        height: '30px'
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), (formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.allotmentDate) !== null && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Checklist Information'))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Agreement Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.agreementDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist3 = formData.checklist) === null || _formData$checklist3 === void 0 ? void 0 : _formData$checklist3.allotmentDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Allotment Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist4 = formData.checklist) === null || _formData$checklist4 === void 0 ? void 0 : _formData$checklist4.allotmentDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist5 = formData.checklist) === null || _formData$checklist5 === void 0 ? void 0 : _formData$checklist5.paymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist6 = formData.checklist) === null || _formData$checklist6 === void 0 ? void 0 : _formData$checklist6.paymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist7 = formData.checklist) === null || _formData$checklist7 === void 0 ? void 0 : _formData$checklist7.uptodatePaymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Updated Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist8 = formData.checklist) === null || _formData$checklist8 === void 0 ? void 0 : _formData$checklist8.uptodatePaymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist9 = formData.checklist) === null || _formData$checklist9 === void 0 ? void 0 : _formData$checklist9.isPossesionAreaDiff) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Possession Area Different:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist10 = formData.checklist) === null || _formData$checklist10 === void 0 ? void 0 : _formData$checklist10.isPossesionAreaDiff)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist11 = formData.checklist) === null || _formData$checklist11 === void 0 ? void 0 : _formData$checklist11.areaOfExtraLand) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Area Of Extra Land:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist12 = formData.checklist) === null || _formData$checklist12 === void 0 ? void 0 : _formData$checklist12.areaOfExtraLand)))))))));
});

const ApplicaionFormatViewNew = forwardRef(({
  formData,
  applicationDocs,
  logoData,
  oldCaseSearch: _oldCaseSearch = false
}, ref) => {
  var _logoData$boundary, _logoData$boundary$fi, _formData$location, _formData$landInfo, _formData$nocDetails, _formData$nocDetails2, _applicationDocs$find, _applicationDocs$find2, _formData$description, _formData$description2, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description36, _formData$description37, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo4$o3, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$description38, _formData$description39, _formData$description40, _formData$description41, _formData$description42, _formData$description43, _formData$description44, _formData$description45, _formData$description46, _formData$description47, _formData$description48, _formData$taxHeadEsti, _formData$taxHeadEsti2;
  console.log("logoDataFromSummary", logoData);
  console.log("logoDataFromSummary111", _oldCaseSearch);
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const isEmployee = history.location.pathname.includes("employee");
  const user = Digit.UserService.getUser();
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const currentLogoId = isDA ? logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.location1))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId : logoData === null || logoData === void 0 ? void 0 : logoData.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  nameOfDepartment = isDA ? `${formData === null || formData === void 0 ? void 0 : (_formData$location = formData.location1) === null || _formData$location === void 0 ? void 0 : _formData$location.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const roadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidths;
  const approachRoadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidths;
  console.log(formData, "FromSUmmary");
  const nocApplicantData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.applicantNOCData;
  const selectedNOCs = console.log(nocApplicantData, "nocapplicant");
  const additionalNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.additionalApplicantNOC;
  console.log("additionalNocs", additionalNOC);
  const StyledTableCell = styled(TableCell$1)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled(TableRow$1)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const accordionSummaryStyles = {
    backgroundColor: "#FFFF",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "#FFFF",
      minHeight: "48px",
      height: "1rem"
    }
  };
  const filteredDocuments = applicationDocs.filter(doc => _oldCaseSearch ? !["applicantPhoto", "signature", "mutationLetter", "registrySaleDeedHPTA"].includes(doc.documentType) : !["applicantPhoto", "signature"].includes(doc.documentType));
  const mutationLetterId = (_applicationDocs$find = applicationDocs.find(doc => doc.documentType === "mutationLetter")) === null || _applicationDocs$find === void 0 ? void 0 : _applicationDocs$find.fileStoreId;
  const registrySaleDeedHPTAId = (_applicationDocs$find2 = applicationDocs.find(doc => doc.documentType === "registrySaleDeedHPTA")) === null || _applicationDocs$find2 === void 0 ? void 0 : _applicationDocs$find2.fileStoreId;
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#fff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      background: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo",
    style: {
      marginTop: isDA ? "0.5em" : "1em",
      height: "4em",
      width: "auto",
      objectFit: "contain"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#000",
      marginTop: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "30px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "30px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container3",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, ((formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) !== "Scheme" && (formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) && (formData === null || formData === void 0 ? void 0 : formData.land_Id) || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeType) === "Scheme" && (formData === null || formData === void 0 ? void 0 : formData.land_Id)) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)))))), (formData === null || formData === void 0 ? void 0 : formData.oldCaseApplicationNo) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Old Case Application No : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.oldCaseApplicationNo)))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, isDA ? /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Office : ")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.selectedOffice)))) : /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Unit:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedUnit)), (formData === null || formData === void 0 ? void 0 : formData.selectedCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedCity))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name / Husband Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "City :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px",
        marginTop: "80px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))));
  }))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.consultantCategory)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.planDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Validity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.planDate)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.mobileNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.certificateNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.certificateNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.licenseNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.licenseNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.emailId))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      margin: "0px 4px",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plan on :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.planOn) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.schemeName) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.sectorNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.developmentArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.developmentArea) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityAsPerMap) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity Proposed")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.activityProposed) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.proposedActivity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Activity as per Zoning Regulation :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.proposedActivity) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.landUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.schemeType) === "Scheme" ? "Land Use as per Layout Plan :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.landUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.schemeType) === "Scheme" ? "Land Sub Use as per Layout :" : "Land Sub Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.subLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.otherMasterPlan) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Master Layout Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.otherMasterPlan) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.requiredLandUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Required Land Use Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.requiredLandUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.reqSubLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Require Sub Land Use Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.reqSubLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description35 = formData.descriptionOfLand) === null || _formData$description35 === void 0 ? void 0 : _formData$description35.reqActivityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Require Activity Proposed :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description36 = formData.descriptionOfLand) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.reqActivityProposed) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Block No./Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) || "")), Array.isArray(formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : _formData$description37.khasraDetails) && formData.descriptionOfLand.khasraDetails.map((khasra, idx) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: idx
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No./Khasra No./Arazi No. ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      wordBreak: "break-all"
    }
  }, khasra.plotNo || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Village ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.village || khasra.villageName || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.tehsil || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.district || "NA")))), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.permanentAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.district) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_DISTRICT"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.permanentAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.district) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : (_formData$landInfo4$o3 = _formData$landInfo4$o2.permanentAddress) === null || _formData$landInfo4$o3 === void 0 ? void 0 : _formData$landInfo4$o3.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Tehsil"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.permanentAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.tehsil) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.permanentAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.village) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Village"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.permanentAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.village) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 1 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 2 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Width :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Length :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description38 = formData.descriptionOfLand) === null || _formData$description38 === void 0 ? void 0 : _formData$description38.plotAreaDoc) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per document) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description39 = formData.descriptionOfLand) === null || _formData$description39 === void 0 ? void 0 : _formData$description39.plotAreaDoc)), (formData === null || formData === void 0 ? void 0 : (_formData$description40 = formData.descriptionOfLand) === null || _formData$description40 === void 0 ? void 0 : _formData$description40.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per site) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description41 = formData.descriptionOfLand) === null || _formData$description41 === void 0 ? void 0 : _formData$description41.landArea)), (formData === null || formData === void 0 ? void 0 : (_formData$description42 = formData.descriptionOfLand) === null || _formData$description42 === void 0 ? void 0 : _formData$description42.plotAreaPossession) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per possession) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description43 = formData.descriptionOfLand) === null || _formData$description43 === void 0 ? void 0 : _formData$description43.plotAreaPossession)), (roadWidths === null || roadWidths === void 0 ? void 0 : roadWidths.length) > 0 && roadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (Existing) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (approachRoadWidths === null || approachRoadWidths === void 0 ? void 0 : approachRoadWidths.length) > 0 && approachRoadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (as per the respective plan) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Near by Landmark :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Address :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) || "")))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " ")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }), _oldCaseSearch && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    style: {
      marginTop: "10px"
    }
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Registry/Sale deed/HPTA/Land ownership/Gift deed:")), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreIdV2(registrySaleDeedHPTAId, setIsPreviewLoading)
  })), (formData === null || formData === void 0 ? void 0 : (_formData$description44 = formData.descriptionOfLand) === null || _formData$description44 === void 0 ? void 0 : _formData$description44.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Mutation Letter:")), (formData === null || formData === void 0 ? void 0 : (_formData$description45 = formData.descriptionOfLand) === null || _formData$description45 === void 0 ? void 0 : _formData$description45.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreIdV2(mutationLetterId, setIsPreviewLoading)
  })))))))), ((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) || (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description46 = formData.descriptionOfLand) === null || _formData$description46 === void 0 ? void 0 : _formData$description46.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description47 = formData.descriptionOfLand) === null || _formData$description47 === void 0 ? void 0 : _formData$description47.googleMapLocation))))))))), (nocApplicantData || additionalNOC) && !isLowRiskCase && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("BPA_MY_APPLICATIONS_LANDUSENOC")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true).map((questionItem, index) => {
    const {
      label,
      applicantName
    } = questionItem;
    const answer = nocApplicantData[applicantName] ? "Yes" : "No";
    console.log("fromMap", answer, label, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true));
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, answer));
  }), additionalNOC === null || additionalNOC === void 0 ? void 0 : additionalNOC.map((item, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, "Yes"));
  })))))))), (formData === null || formData === void 0 ? void 0 : (_formData$description48 = formData.descriptionOfLand) === null || _formData$description48 === void 0 ? void 0 : _formData$description48.schemeType) !== "Scheme" && !((formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) === "yes") && (!_oldCaseSearch && (formData === null || formData === void 0 ? void 0 : formData.status) !== "REVERT_TO_APPLICANT" || (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) !== "yes" && (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimate) !== null) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, " ", /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Land Use Verification"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount))))))))));
});

const TakeActionItem = forwardRef(({
  id,
  formType,
  logoData,
  oldCaseSearch
}, ref) => {
  var _data$LandUse, _data$ownerRegistrati, _data$PurchasableFAR, _data$BPA, _formData$paymentDeta, _formData$paymentDeta2, _formData$paymentDeta3, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _formData$PrevStateDo, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _pdfDetails$pdfFiles;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  console.log(data, "fromTakeAction");
  const formData = (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]) || (data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati[0]) || (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]) || (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || (data === null || data === void 0 ? void 0 : data.applicationData);
  const {
    collectionBillRes,
    collectionBillDetails
  } = data;
  if (!isLoading && formData) {
    var _collectionBillRes$, _collectionBillRes$$p;
    formData.paymentDetails = collectionBillRes === null || collectionBillRes === void 0 ? void 0 : (_collectionBillRes$ = collectionBillRes[0]) === null || _collectionBillRes$ === void 0 ? void 0 : (_collectionBillRes$$p = _collectionBillRes$.paymentDetails) === null || _collectionBillRes$$p === void 0 ? void 0 : _collectionBillRes$$p[0];
  }
  let consumerCode = id;
  const fetchBillParams = {
    consumerCode
  };
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$paymentDeta = formData.paymentDetails) === null || _formData$paymentDeta === void 0 ? void 0 : (_formData$paymentDeta2 = _formData$paymentDeta.bill) === null || _formData$paymentDeta2 === void 0 ? void 0 : (_formData$paymentDeta3 = _formData$paymentDeta2.billDetails[0]) === null || _formData$paymentDeta3 === void 0 ? void 0 : _formData$paymentDeta3.amount) || (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount);
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    console.log(pdfDetails, "fromTakeActionDOcs");
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formType === "formNOC" ? /*#__PURE__*/React__default.createElement(NOCFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }) : formType === "OWNER_REGISTRATION" ? /*#__PURE__*/React__default.createElement(OwnerSummary, {
    formData: formData,
    ref: ref
  }) : /*#__PURE__*/React__default.createElement(ApplicaionFormatViewNew, {
    ref: ref,
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo,
    oldCaseSearch: oldCaseSearch
  }));
});

const OwnerSummary$1 = forwardRef(({
  formData,
  applicationDocs
}, ref) => {
  var _formData$landInfo, _formData$landInfo2, _documents$filter, _documents$filter$, _formData$ownerOrAppl, _formData$ownerOrAppl2, _formData$approvedLay, _formData$approvedLay2, _formData$morethanOne, _formData$morethanOne2, _formData$morethanOne3, _formData$morethanOne4, _descriptionOfLand$go, _descriptionOfLand$go2, _descriptionOfLand$go3, _descriptionOfLand$go4, _formData$checklist, _formData$checklist2, _formData$checklist3, _formData$checklist4, _formData$checklist5, _formData$checklist6, _formData$checklist7, _formData$checklist8, _formData$checklist9, _formData$checklist10, _formData$checklist11, _formData$checklist12;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const properties = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.properties;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const applicant = formData === null || formData === void 0 ? void 0 : formData.applicant;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const bankInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.bankdetails;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)\[\d+\]$/.test(doc.documentType));
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const accordionSummaryStyles = {
    backgroundColor: "rgb(230, 239, 248)",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "rgb(230, 239, 248)",
      minHeight: "48px",
      height: "1rem"
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Basic Information')))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Are You the Owner or Applicant")), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl = formData.ownerOrApplicant) === null || _formData$ownerOrAppl === void 0 ? void 0 : _formData$ownerOrAppl.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl2 = formData.ownerOrApplicant) === null || _formData$ownerOrAppl2 === void 0 ? void 0 : _formData$ownerOrAppl2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Property Part of Approved Layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay = formData.approvedLayout) === null || _formData$approvedLay === void 0 ? void 0 : _formData$approvedLay.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay2 = formData.approvedLayout) === null || _formData$approvedLay2 === void 0 ? void 0 : _formData$approvedLay2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Owner:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne = formData.morethanOneOwner) === null || _formData$morethanOne === void 0 ? void 0 : _formData$morethanOne.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne2 = formData.morethanOneOwner) === null || _formData$morethanOne2 === void 0 ? void 0 : _formData$morethanOne2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Property:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne3 = formData.morethanOneProperty) === null || _formData$morethanOne3 === void 0 ? void 0 : _formData$morethanOne3.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne4 = formData.morethanOneProperty) === null || _formData$morethanOne4 === void 0 ? void 0 : _formData$morethanOne4.slice(1))))))))))), (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.emailId)), (applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.address)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Authorization Letter:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    },
    onClick: () => getDocumentByFileStoreId(authorization, setIsPreviewLoading)
  })))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement(Accordion, {
      defaultExpanded: true
    }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
      sx: accordionSummaryStyles
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Addition Owner Information' : 'Owner Information'))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "City :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature)))))))));
  })), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((item, index) => {
    var _item$appliedLandUse, _item$appliedLandUse2, _item$propertyType, _item$propertyType2, _item$propertyAddress, _item$propertyAddress2, _item$propertyAddress3, _item$propertyAddress4;
    return /*#__PURE__*/React__default.createElement(Accordion, {
      defaultExpanded: true,
      key: index
    }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
      sx: accordionSummaryStyles
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Additional Registration Information' : 'Registration Information'))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        margin: "0px 4px",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, item.schemeName && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.schemeName)), ((_item$appliedLandUse = item.appliedLandUse) === null || _item$appliedLandUse === void 0 ? void 0 : _item$appliedLandUse.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applied Land Use :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$appliedLandUse2 = item.appliedLandUse) === null || _item$appliedLandUse2 === void 0 ? void 0 : _item$appliedLandUse2.name)), item.khatauniNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khatauniNo)), item.khataNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khataNo)), item.khasraNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khasraNo)), item.plotNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotNo)), item.roadWidth && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Road Width :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.roadWidth)), item.plotArea && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotArea)), ((_item$propertyType = item.propertyType) === null || _item$propertyType === void 0 ? void 0 : _item$propertyType.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Property Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$propertyType2 = item.propertyType) === null || _item$propertyType2 === void 0 ? void 0 : _item$propertyType2.name)), (((_item$propertyAddress = item.propertyAddress) === null || _item$propertyAddress === void 0 ? void 0 : _item$propertyAddress.address) || item.city || ((_item$propertyAddress2 = item.propertyAddress) === null || _item$propertyAddress2 === void 0 ? void 0 : _item$propertyAddress2.pinno)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, `${((_item$propertyAddress3 = item.propertyAddress) === null || _item$propertyAddress3 === void 0 ? void 0 : _item$propertyAddress3.address) || ''}, ${item.city || ''}, ${((_item$propertyAddress4 = item.propertyAddress) === null || _item$propertyAddress4 === void 0 ? void 0 : _item$propertyAddress4.pinno) || ''}`)))))));
  })), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Bank Details"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account Holder Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Bank Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Branch Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "IFSC Code:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapCoordinates) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go === void 0 ? void 0 : (_descriptionOfLand$go2 = _descriptionOfLand$go[0]) === null || _descriptionOfLand$go2 === void 0 ? void 0 : _descriptionOfLand$go2.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go3 = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go3 === void 0 ? void 0 : (_descriptionOfLand$go4 = _descriptionOfLand$go3[0]) === null || _descriptionOfLand$go4 === void 0 ? void 0 : _descriptionOfLand$go4.longitude)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " ")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: '20px',
        height: '30px'
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.allotmentDate) !== null && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Checklist Information')))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Agreement Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.agreementDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist3 = formData.checklist) === null || _formData$checklist3 === void 0 ? void 0 : _formData$checklist3.allotmentDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Allotment Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist4 = formData.checklist) === null || _formData$checklist4 === void 0 ? void 0 : _formData$checklist4.allotmentDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist5 = formData.checklist) === null || _formData$checklist5 === void 0 ? void 0 : _formData$checklist5.paymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist6 = formData.checklist) === null || _formData$checklist6 === void 0 ? void 0 : _formData$checklist6.paymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist7 = formData.checklist) === null || _formData$checklist7 === void 0 ? void 0 : _formData$checklist7.uptodatePaymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Updated Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist8 = formData.checklist) === null || _formData$checklist8 === void 0 ? void 0 : _formData$checklist8.uptodatePaymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist9 = formData.checklist) === null || _formData$checklist9 === void 0 ? void 0 : _formData$checklist9.isPossesionAreaDiff) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Possession Area Different:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist10 = formData.checklist) === null || _formData$checklist10 === void 0 ? void 0 : _formData$checklist10.isPossesionAreaDiff)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist11 = formData.checklist) === null || _formData$checklist11 === void 0 ? void 0 : _formData$checklist11.areaOfExtraLand) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Area Of Extra Land:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist12 = formData.checklist) === null || _formData$checklist12 === void 0 ? void 0 : _formData$checklist12.areaOfExtraLand))))))))))));
});

const Summary = forwardRef(({
  id
}, ref) => {
  var _data$PurchasableFAR, _formData$landInfo, _pdfDetails$pdfFiles, _formData$landInfo2, _formData$landInfo2$o, _formData$description, _formData$description2, _formData$checklist, _formData$checklist2, _applicationDocs$filt, _applicationDocs$filt2, _applicationDocs$filt3, _applicationDocs$filt4, _applicationDocs$filt5, _applicationDocs$filt6, _applicationDocs$filt7, _applicationDocs$filt8, _checklist1$setbackPo, _checklist1$setbackPo2, _checklist1$setbackPo3, _checklist1$setbackPo4, _checklist1$setbackPo5, _checklist1$setbackPo6, _checklist1$setbackPo7, _checklist1$setbackPo8, _checklist1$setbackPo9, _checklist1$parkingPr, _checklist1$parkingPr2, _checklist1$parkingPr3, _checklist1$parkingPr4, _checklist1$parkingPr5, _checklist1$parkingPr6, _checklist1$parkingPr7, _checklist1$parkingPr8, _checklist1$parkingPr9, _checklist1$parkingPr10, _checklist1$parkingPr11, _checklist1$parkingPr12, _checklist1$parkingPr13, _checklist1$parkingPr14, _checklist1$parkingPr15, _checklist1$parkingPr16, _checklist1$parkingPr17, _checklist1$parkingPr18, _checklist1$parkingPr19, _checklist1$parkingPr20, _checklist1$parkingPr21, _checklist1$parkingPr22, _checklist1$parkingPr23, _checklist1$parkingPr24, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4;
  const history = useHistory$1();
  const {
    t
  } = useTranslation();
  const [, applicationFlow] = useDepartmentSelector();
  const [, setIsPreviewLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const formType = "PURCHASABLE_FAR";
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  const formData = data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0];
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  console.log(data, "fromSummary");
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const approvedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "Yes";
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(docs);
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o[0];
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0];
  console.log("description", descriptionOfLand);
  const checklist1 = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const checklist2 = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const documentSection = applicationDocs.filter(doc => ["agreement", "allotmentLetter", "sitePlan", "kmlFile", "khataKhasraDocs", "possessionLetter", "registry", "hpta", "paymentStatus"].includes(doc.documentType));
  const personalDocs = applicationDocs.filter(doc => ["signature", "applicantPhoto"].includes(doc.documentType));
  console.log("personalDOcs", personalDocs);
  const proposalDocument = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt = applicationDocs.filter(doc => ["proposalDocument"].includes(doc.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const drawingFile = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt3 = applicationDocs.filter(doc => ["drawingFile"].includes(doc.documentType))) === null || _applicationDocs$filt3 === void 0 ? void 0 : (_applicationDocs$filt4 = _applicationDocs$filt3[0]) === null || _applicationDocs$filt4 === void 0 ? void 0 : _applicationDocs$filt4.fileStoreId;
  const structuralCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt5 = applicationDocs.filter(doc => ["structuralCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt5 === void 0 ? void 0 : (_applicationDocs$filt6 = _applicationDocs$filt5[0]) === null || _applicationDocs$filt6 === void 0 ? void 0 : _applicationDocs$filt6.fileStoreId;
  const fireDepartmentCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt7 = applicationDocs.filter(doc => ["fireDepartmentCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt7 === void 0 ? void 0 : (_applicationDocs$filt8 = _applicationDocs$filt7[0]) === null || _applicationDocs$filt8 === void 0 ? void 0 : _applicationDocs$filt8.fileStoreId;
  if (!formData && docsLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_DETAILS")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: "1 1 calc(50% - 10px)",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_FATHER_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_GENDER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_MOBILE_NUMBER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_EMAIL_ID"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_AADHAR_CARD"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROPERTY_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_CITY"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ADDRESS"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Scheme"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_STATE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PIN_CODE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Construction Type"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType))))), owners === null || owners === void 0 ? void 0 : owners.map((item, index) => (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: {
      flex: "1 1 calc(50% - 10px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "24px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px"
    }
  }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "180px",
      objectFit: "cover"
    },
    src: item.photo,
    alt: "image",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar, {
    style: {
      width: "200px",
      height: "80px"
    }
  }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px",
      marginTop: "84px"
    }
  }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "80px"
    },
    src: item.signature,
    alt: "signature",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
    style: {
      width: "70px",
      height: "25px"
    }
  }, item === null || item === void 0 ? void 0 : item.signature)))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Layout Details")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_PART_OF_APPROVED_LAYOUT"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.approvedLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_LAND_USE_AS_PER_LAYOUT"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout)), !approvedLayout && /*#__PURE__*/React__default.createElement(Fragment$2, null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHASRA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATAUNI_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_LAND_WIDTH"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth)))))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("FAR Details")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ALREADY_TAKEN_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) == "Yes" && (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_TAKEN_PURCHASABLE_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_PERCENTAGE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR))))))))), documentSection.length > 0 && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents Section")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(documentSection),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }))))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo = checklist1.setbackPosition) === null || _checklist1$setbackPo === void 0 ? void 0 : _checklist1$setbackPo.front) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 1")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SETBACK_POSITION")))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo2 = checklist1.setbackPosition) === null || _checklist1$setbackPo2 === void 0 ? void 0 : _checklist1$setbackPo2.front) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Front"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo3 = checklist1.setbackPosition) === null || _checklist1$setbackPo3 === void 0 ? void 0 : _checklist1$setbackPo3.front)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo4 = checklist1.setbackPosition) === null || _checklist1$setbackPo4 === void 0 ? void 0 : _checklist1$setbackPo4.rear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Rear"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo5 = checklist1.setbackPosition) === null || _checklist1$setbackPo5 === void 0 ? void 0 : _checklist1$setbackPo5.rear)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo6 = checklist1.setbackPosition) === null || _checklist1$setbackPo6 === void 0 ? void 0 : _checklist1$setbackPo6.left) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Left"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo7 = checklist1.setbackPosition) === null || _checklist1$setbackPo7 === void 0 ? void 0 : _checklist1$setbackPo7.left)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo8 = checklist1.setbackPosition) === null || _checklist1$setbackPo8 === void 0 ? void 0 : _checklist1$setbackPo8.right) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Right"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo9 = checklist1.setbackPosition) === null || _checklist1$setbackPo9 === void 0 ? void 0 : _checklist1$setbackPo9.right)), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Height of Proposed Building (m)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight)), proposalDocument && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposal Document (PDF)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)
  }))), drawingFile && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposal Document (PDF)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)
  }))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate Applicable"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety)), structuralCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)
  }))), fireDepartmentCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Fire Department Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      width: "100%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PARKING_ARRANGEMENT")))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Total Parking Required (sq.m)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROVISION_PROPOSED_PLAN")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Basement"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr = checklist1.parkingProvision) === null || _checklist1$parkingPr === void 0 ? void 0 : (_checklist1$parkingPr2 = _checklist1$parkingPr.inBasement) === null || _checklist1$parkingPr2 === void 0 ? void 0 : _checklist1$parkingPr2.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr3 = checklist1.parkingProvision) === null || _checklist1$parkingPr3 === void 0 ? void 0 : (_checklist1$parkingPr4 = _checklist1$parkingPr3.inBasement) === null || _checklist1$parkingPr4 === void 0 ? void 0 : _checklist1$parkingPr4.cars))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr5 = checklist1.parkingProvision) === null || _checklist1$parkingPr5 === void 0 ? void 0 : (_checklist1$parkingPr6 = _checklist1$parkingPr5.inBasement) === null || _checklist1$parkingPr6 === void 0 ? void 0 : _checklist1$parkingPr6.ecs) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of ECS"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr7 = checklist1.parkingProvision) === null || _checklist1$parkingPr7 === void 0 ? void 0 : (_checklist1$parkingPr8 = _checklist1$parkingPr7.inBasement) === null || _checklist1$parkingPr8 === void 0 ? void 0 : _checklist1$parkingPr8.ecs)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Open Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr9 = checklist1.parkingProvision) === null || _checklist1$parkingPr9 === void 0 ? void 0 : (_checklist1$parkingPr10 = _checklist1$parkingPr9.openArea) === null || _checklist1$parkingPr10 === void 0 ? void 0 : _checklist1$parkingPr10.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr11 = checklist1.parkingProvision) === null || _checklist1$parkingPr11 === void 0 ? void 0 : (_checklist1$parkingPr12 = _checklist1$parkingPr11.openArea) === null || _checklist1$parkingPr12 === void 0 ? void 0 : _checklist1$parkingPr12.cars))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr13 = checklist1.parkingProvision) === null || _checklist1$parkingPr13 === void 0 ? void 0 : (_checklist1$parkingPr14 = _checklist1$parkingPr13.openArea) === null || _checklist1$parkingPr14 === void 0 ? void 0 : _checklist1$parkingPr14.ecs) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of ECS"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr15 = checklist1.parkingProvision) === null || _checklist1$parkingPr15 === void 0 ? void 0 : (_checklist1$parkingPr16 = _checklist1$parkingPr15.openArea) === null || _checklist1$parkingPr16 === void 0 ? void 0 : _checklist1$parkingPr16.ecs)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Stilt Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr17 = checklist1.parkingProvision) === null || _checklist1$parkingPr17 === void 0 ? void 0 : (_checklist1$parkingPr18 = _checklist1$parkingPr17.inStiltArea) === null || _checklist1$parkingPr18 === void 0 ? void 0 : _checklist1$parkingPr18.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr19 = checklist1.parkingProvision) === null || _checklist1$parkingPr19 === void 0 ? void 0 : (_checklist1$parkingPr20 = _checklist1$parkingPr19.inStiltArea) === null || _checklist1$parkingPr20 === void 0 ? void 0 : _checklist1$parkingPr20.cars))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr21 = checklist1.parkingProvision) === null || _checklist1$parkingPr21 === void 0 ? void 0 : (_checklist1$parkingPr22 = _checklist1$parkingPr21.inStiltArea) === null || _checklist1$parkingPr22 === void 0 ? void 0 : _checklist1$parkingPr22.ecs) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of ECS"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr23 = checklist1.parkingProvision) === null || _checklist1$parkingPr23 === void 0 ? void 0 : (_checklist1$parkingPr24 = _checklist1$parkingPr23.inStiltArea) === null || _checklist1$parkingPr24 === void 0 ? void 0 : _checklist1$parkingPr24.ecs))))))))), (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.publicSewerageOrSepticTank) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 2")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SEWERAGE_STORMWATER")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Public sewerage plan or septic tank"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.publicSewerageOrSepticTank ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposed drainage plan approval"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.drainagePlanApproval ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ROAD_CONNECTIVITY")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Existing road width in meters"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.existingRoadWidth) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Minimum 24 meters wide"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.minimum24MetersWide ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_WATER_SUPPLY")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Water supply arrangement (capacity in liters per day)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.waterSupplyArrangement) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Water supply plan as per requirements"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.waterSupplyPlanApproval ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SEWERAGE_DISPOSAL")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("STP/Septic tank arrangement made by applicant. Or Establish Connectivity with Govt. Authority"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.stpSepticTankArrangement ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Yes / No, confirms to standards / not. It is proposed to establish connectivity with the Government Authority."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.connectivityWithGovernmentAuthority ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_DRAINAGE_SYSTEM_COMPLIANCE")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("The proposed system is as per the standards or the government agency has approved connectivity."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.drainageSystemComplianceWithStandards ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("As per standards / not."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.drainageAsPerStandards ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_POWER_SUPPLY")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Total estimated power demand (kW/MW)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.totalEstimatedPowerDemand) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Corporation Ltd. has consent for supply in respect of proposed Garg. Power received"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.powerSupplyConsent ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_RAINWATER_HARVESTING_SYSTEM")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Total area of rooftop (sq. meters) and provision of drain pipe and recharge pit"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.rooftopAreaAndDrainage) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Found to be as per standard / not"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.drainageStandardsCompliance ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SOLAR_WATER_SYSTEM")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of pipes in the building design for solar water heating system and determination of suitable location for the plant on the rooftop."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.solarWaterHeatingProvision ? "Yes" : "No")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Whether provision made as per building bye-laws or not"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 !== null && checklist2 !== void 0 && checklist2.buildingByeLawsCompliance ? "Yes" : "No"))))))))), ((formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapCoordinates) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5.googleMapCoordinates) === null || _formData$description6 === void 0 ? void 0 : (_formData$description7 = _formData$description6[0]) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : (_formData$description9 = _formData$description8.googleMapCoordinates) === null || _formData$description9 === void 0 ? void 0 : (_formData$description10 = _formData$description9[0]) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.latitude, ", Longitude:", " ", formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11.googleMapCoordinates) === null || _formData$description12 === void 0 ? void 0 : (_formData$description13 = _formData$description12[0]) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.googleMapLocation))))))))), (formData === null || formData === void 0 ? void 0 : formData.assignLTP) === "Yes" && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Assign file to License Technical Person(LTP)"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.ltpName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Selected LTP")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.ltpName)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.ltpRegistrationNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Registration No.")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.ltpRegistrationNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.ltpCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("City Name")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.ltpCity))))))))), Boolean(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Purchasable FAR"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3[0]) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.estimateAmount)))))))));
});

const EmployeeComponent = ({
  formData,
  applicationDocs,
  totalAmount
}) => {
  var _formData$landInfo, _formData$landInfo2, _formData$landInfo2$o, _formData$professiona, _formData$landInfo3, _formData$landInfo4, _formData$landInfo4$o, _formData$professiona2;
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const [smShowNoc, setSmShowNoc] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowMsHistory, setSmShowMsHistory] = useState(false);
  const {
    t
  } = useTranslation();
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [formHistory, setFormHistory] = useState("");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#eeeab5b0",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "4px 8px",
      fontSize: "14px",
      margin: "4px 0px 8px 0px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application"), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "4px 8px",
      fontSize: "14px",
      margin: "4px 0px 8px 0px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ": \xA0\xA0\xA0", (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 7"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_NOC" && /*#__PURE__*/React__default.createElement(Fragment$2, null, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_NOC" && /*#__PURE__*/React__default.createElement(Fragment$2, null, " : \xA0\xA0", formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.mobileNumber)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_NOC" && /*#__PURE__*/React__default.createElement(Fragment$2, null, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : _formData$landInfo3.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0\xA0", ob === null || ob === void 0 ? void 0 : ob.name)))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_NOC" && /*#__PURE__*/React__default.createElement(Fragment$2, null, " :\xA0\xA0\xA0", formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Services Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" && /*#__PURE__*/React__default.createElement(Fragment$2, null, " :\xA0\xA0\xA0", "Land Use Verification"), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_OWNER_REGISTRATION" && /*#__PURE__*/React__default.createElement(Fragment$2, null, " :\xA0\xA0\xA0", "Owner Registration"), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(Fragment$2, null, " :\xA0\xA0\xA0", "Purchasable FAR"))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_OWNER_REGISTRATION" && /*#__PURE__*/React__default.createElement(OwnerSummary$1, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" && /*#__PURE__*/React__default.createElement(ApplicaionFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(Summary, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowNoc,
    onClose: () => {
      setSmShowNoc(false);
    }
  }, /*#__PURE__*/React__default.createElement(NOCFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: smShowPayment,
    onClose: () => {
      setSmShowPayment(false);
    }
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$2, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  })), formType === "form12" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationView12, {
    id: idData,
    formType: formType
  })), formType === "form12" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistory, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "form11" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "form11" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "form26" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "form26" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formMT" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formMT" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formNOC" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formNOC" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formCLU" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formCLU" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  }))));
};

const Structural = ({
  formData,
  applicationDocs,
  totalAmount
}) => {
  var _formData$landInfo, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo4, _formData$landInfo4$o;
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const [smShowNoc, setSmShowNoc] = useState(false);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "rgba(173, 229, 232, 0.69)",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, ": \xA0\xA0 ", (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_NOC" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShowNoc(true), console.log("modal open");
    }
  }, "View Application"), (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_NOC" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : _formData$landInfo3.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.name)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applied For ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, ": \xA0\xA0 ", t(`${formData === null || formData === void 0 ? void 0 : formData.applicationType}`))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicaionFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowNoc,
    onClose: () => {
      setSmShowNoc(false);
    }
  }, /*#__PURE__*/React__default.createElement(NOCFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }))));
};

const LTPSummary = forwardRef(({
  formData,
  applicationDocs,
  ref,
  isEmployee: _isEmployee = true,
  setDeclarationChecked
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _applicationDocs$filt, _applicationDocs$filt2, _formData$calculation, _formData$calculation2, _formData$tradeLicens3, _tradeUnits$, _owners$permanentAddr, _owners$permanentAddr2, _owners$permanentAddr3, _owners$permanentAddr4;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.owners) === null || _formData$tradeLicens2 === void 0 ? void 0 : _formData$tradeLicens2[0];
  const {
    t
  } = useTranslation();
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const filteredDocuments = applicationDocs === null || applicationDocs === void 0 ? void 0 : applicationDocs.filter(doc => !["applicantPhoto", "signature", "paymentReciept"].includes(doc.documentType));
  const paymentReciept = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt = applicationDocs.filter(doc => ["paymentReciept"].includes(doc.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const calculationObj = formData === null || formData === void 0 ? void 0 : (_formData$calculation = formData.calculation) === null || _formData$calculation === void 0 ? void 0 : (_formData$calculation2 = _formData$calculation.taxHeadEstimates) === null || _formData$calculation2 === void 0 ? void 0 : _formData$calculation2[0];
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = "AWAS EVAM VIKAS PARISHAD";
  const nameOfAuthority = "DEVELOPMENT AUTHORITY";
  const department = (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP" ? nameOfDepartment : nameOfAuthority;
  const tradeUnits = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens3 = formData.tradeLicenseDetail) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.tradeUnits;
  const tradeType = tradeUnits === null || tradeUnits === void 0 ? void 0 : (_tradeUnits$ = tradeUnits[0]) === null || _tradeUnits$ === void 0 ? void 0 : _tradeUnits$.tradeType;
  const formatDate = dob => {
    if (!dob) return "N/A";
    let dateOfBirth = dob.toString();
    const year = dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.substring(0, 4);
    const month = dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.substring(4, 6);
    const day = dateOfBirth === null || dateOfBirth === void 0 ? void 0 : dateOfBirth.substring(6, 8);
    return `${day}/${month}/${year}`;
  };
  const convertdate = date => {
    var _date$split, _date$split$reverse;
    return date === null || date === void 0 ? void 0 : (_date$split = date.split("-")) === null || _date$split === void 0 ? void 0 : (_date$split$reverse = _date$split.reverse()) === null || _date$split$reverse === void 0 ? void 0 : _date$split$reverse.join("/");
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const {
    control
  } = useForm({});
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, department), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Applicant Details"))), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginTop: "15px",
      marginBottom: "15px",
      paddingBottom: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: "1 1 calc(50% - 10px)",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Application No.")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.registrationType) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, `${(owners === null || owners === void 0 ? void 0 : owners.initialForApplicantName) + " " + (owners === null || owners === void 0 ? void 0 : owners.name)}` || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Educational Qualification:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.qualification) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name of Firm:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.firmName) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Pan Number:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.pan) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Experience (in Years):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.totalExperience) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.aadhaarNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Date of Birth:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, owners !== null && owners !== void 0 && owners.dob ? formatDate(owners === null || owners === void 0 ? void 0 : owners.dob) : "N/A"))))), (owners === null || owners === void 0 ? void 0 : owners.photo) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: "1 1 calc(50% - 10px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px"
    }
  }, owners !== null && owners !== void 0 && owners.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "250px",
      objectFit: "cover"
    },
    src: owners === null || owners === void 0 ? void 0 : owners.photo,
    alt: "image",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
    style: {
      width: "200px",
      height: "80px"
    }
  }, owners === null || owners === void 0 ? void 0 : owners.photo))))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Contact Information"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : (_owners$permanentAddr = owners.permanentAddress) === null || _owners$permanentAddr === void 0 ? void 0 : _owners$permanentAddr.address) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : (_owners$permanentAddr2 = owners.permanentAddress) === null || _owners$permanentAddr2 === void 0 ? void 0 : _owners$permanentAddr2.district) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : (_owners$permanentAddr3 = owners.permanentAddress) === null || _owners$permanentAddr3 === void 0 ? void 0 : _owners$permanentAddr3.state) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Pincode:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : (_owners$permanentAddr4 = owners.permanentAddress) === null || _owners$permanentAddr4 === void 0 ? void 0 : _owners$permanentAddr4.pinNo) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.emailId) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nationality:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.nationality) || "Indian"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Registration Details"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Id Proof Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.idProofType) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, convertdate(formData === null || formData === void 0 ? void 0 : formData.validupto) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No. (For Minimum Qualification):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (owners === null || owners === void 0 ? void 0 : owners.architectureNo) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Verifying Authority:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.authorityName) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document Details"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), tradeType !== "ARCHITECT.CLASSA" && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Fee Details"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Registration Amount:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, `₹ ${calculationObj === null || calculationObj === void 0 ? void 0 : calculationObj.registrationFee}`)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "GST Amount (18%):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, `₹ ${calculationObj === null || calculationObj === void 0 ? void 0 : calculationObj.gst}`)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, `₹ ${calculationObj === null || calculationObj === void 0 ? void 0 : calculationObj.estimateAmount}`))))))), !_isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", {
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        display: "flex",
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React__default.createElement("p", null, "This project is based on the inputs and documents provided by the Licensed Technical Person (LTP)."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("p", null, "It is entirely reliant on the trust and verification conducted by the LTP."))
  }))));
});

const Summary$1 = forwardRef(({
  id
}, ref) => {
  var _data$PurchasableFAR, _formData$landInfo, _user$info, _user$info2, _pdfDetails$pdfFiles, _formData$landInfo2, _formData$landInfo2$o, _formData$description, _formData$description2, _formData$checklist, _formData$checklist2, _applicationDocs$filt, _applicationDocs$filt2, _applicationDocs$filt3, _applicationDocs$filt4, _applicationDocs$filt5, _applicationDocs$filt6, _applicationDocs$filt7, _applicationDocs$filt8, _applicationDocs$filt9, _applicationDocs$filt10, _checklist1$setbackPo, _checklist1$setbackPo2, _checklist1$setbackPo3, _checklist1$setbackPo4, _checklist1$setbackPo5, _checklist1$setbackPo6, _checklist1$setbackPo7, _checklist1$setbackPo8, _checklist1$setbackPo9, _checklist1$parkingPr, _checklist1$parkingPr2, _checklist1$parkingPr3, _checklist1$parkingPr4, _checklist1$parkingPr5, _checklist1$parkingPr6, _checklist1$parkingPr7, _checklist1$parkingPr8, _checklist1$parkingPr9, _checklist1$parkingPr10, _checklist1$parkingPr11, _checklist1$parkingPr12, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [, applicationFlow] = useDepartmentSelector();
  const [, setIsPreviewLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const formType = "PURCHASABLE_FAR";
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  const formData = data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0];
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const user = Digit.UserService.getUser();
  console.log();
  console.log(data, "fromSummary", user, user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.tenantId, (user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.tenantId) == "up.da", isEmployee);
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  let nameOfDepartment;
  if (isEmployee) {
    var _user$info3;
    nameOfDepartment = (user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : _user$info3.tenantId) == "up.da" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  } else {
    nameOfDepartment = applicationFlow === "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  }
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const approvedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "Yes";
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(docs);
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o[0];
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0];
  console.log("description", descriptionOfLand);
  const checklist1 = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const checklist2 = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const documentSection = applicationDocs.filter(doc => ["completeDrawingFile", "kmlFile", "sajraPlan", "landOwnershipDoc", "sitePlan", "khataKhasraDocs", "allotmentLetter", "possessionLetter", "registry", "hpta", "paymentStatus", "proposalDocument", "parkingProposalDoc", "drawingFile", "structuralCertificate", "fireDepartmentCertificate", "mutationDocument"].includes(doc.documentType));
  console.log("documentSectionSummary", documentSection);
  const personalDocs = applicationDocs.filter(doc => ["signature", "applicantPhoto"].includes(doc.documentType));
  console.log("personalDOcs", personalDocs);
  const proposalDocument = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt = applicationDocs.filter(doc => ["proposalDocument"].includes(doc.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const drawingFile = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt3 = applicationDocs.filter(doc => ["drawingFile"].includes(doc.documentType))) === null || _applicationDocs$filt3 === void 0 ? void 0 : (_applicationDocs$filt4 = _applicationDocs$filt3[0]) === null || _applicationDocs$filt4 === void 0 ? void 0 : _applicationDocs$filt4.fileStoreId;
  const structuralCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt5 = applicationDocs.filter(doc => ["structuralCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt5 === void 0 ? void 0 : (_applicationDocs$filt6 = _applicationDocs$filt5[0]) === null || _applicationDocs$filt6 === void 0 ? void 0 : _applicationDocs$filt6.fileStoreId;
  const fireDepartmentCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt7 = applicationDocs.filter(doc => ["fireDepartmentCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt7 === void 0 ? void 0 : (_applicationDocs$filt8 = _applicationDocs$filt7[0]) === null || _applicationDocs$filt8 === void 0 ? void 0 : _applicationDocs$filt8.fileStoreId;
  const parkingProposalDoc = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt9 = applicationDocs.filter(doc => ["parkingProposalDoc"].includes(doc.documentType))) === null || _applicationDocs$filt9 === void 0 ? void 0 : (_applicationDocs$filt10 = _applicationDocs$filt9[0]) === null || _applicationDocs$filt10 === void 0 ? void 0 : _applicationDocs$filt10.fileStoreId;
  if (!formData && docsLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_DETAILS")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: "1 1 calc(50% - 10px)",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_FATHER_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_GENDER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_MOBILE_NUMBER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_EMAIL_ID"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_AADHAR_CARD"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROPERTY_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_CITY"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ADDRESS"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Scheme"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_STATE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PIN_CODE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Construction Type"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType))))), owners === null || owners === void 0 ? void 0 : owners.map((item, index) => (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: {
      flex: "1 1 calc(50% - 10px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "24px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px"
    }
  }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "180px",
      objectFit: "cover"
    },
    src: item.photo,
    alt: "image",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar, {
    style: {
      width: "200px",
      height: "80px"
    }
  }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px",
      marginTop: "84px"
    }
  }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "80px"
    },
    src: item.signature,
    alt: "signature",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
    style: {
      width: "70px",
      height: "25px"
    }
  }, item === null || item === void 0 ? void 0 : item.signature)))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Layout Details")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_PART_OF_APPROVED_LAYOUT"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.approvedLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Scheme Name"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot No."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot Width"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotWidth)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) == "No" ? t("Land Use as per Master Plan") : t("Land Use as per Approved Layout Plan"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) == "No" ? t("Proposed Use as per Map") : t("Land Sub Use as per Layout"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot Depth"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot Area (in Sq. M)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Existing Road Width"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidth)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Sector No"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.sectorNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Approach Road Width (as per the actual plan)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidth)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Near by Landmark"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Land Address"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Development Zone"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType)), !approvedLayout && /*#__PURE__*/React__default.createElement(Fragment$2, null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHASRA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATAUNI_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_LAND_WIDTH"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth)))))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("FAR Details")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ALREADY_TAKEN_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) == "Yes" && (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_TAKEN_PURCHASABLE_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_PERCENTAGE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR))))))))), documentSection.length > 0 && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents Section")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(documentSection),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }))))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo = checklist1.setbackPosition) === null || _checklist1$setbackPo === void 0 ? void 0 : _checklist1$setbackPo.front) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 1")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SETBACK_POSITION")))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo2 = checklist1.setbackPosition) === null || _checklist1$setbackPo2 === void 0 ? void 0 : _checklist1$setbackPo2.front) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Front"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo3 = checklist1.setbackPosition) === null || _checklist1$setbackPo3 === void 0 ? void 0 : _checklist1$setbackPo3.front)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo4 = checklist1.setbackPosition) === null || _checklist1$setbackPo4 === void 0 ? void 0 : _checklist1$setbackPo4.rear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Rear"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo5 = checklist1.setbackPosition) === null || _checklist1$setbackPo5 === void 0 ? void 0 : _checklist1$setbackPo5.rear)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo6 = checklist1.setbackPosition) === null || _checklist1$setbackPo6 === void 0 ? void 0 : _checklist1$setbackPo6.ssb1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("SSB1"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo7 = checklist1.setbackPosition) === null || _checklist1$setbackPo7 === void 0 ? void 0 : _checklist1$setbackPo7.ssb1)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo8 = checklist1.setbackPosition) === null || _checklist1$setbackPo8 === void 0 ? void 0 : _checklist1$setbackPo8.ssb2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("SSB2"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo9 = checklist1.setbackPosition) === null || _checklist1$setbackPo9 === void 0 ? void 0 : _checklist1$setbackPo9.ssb2)), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Height of Proposed Building (m)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight)), proposalDocument && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposal Document (PDF)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)
  }))), drawingFile && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Drawing File (.dxf)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)
  }))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate Applicable"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety)), structuralCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)
  }))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.fireNocRequired) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Is Fire NOC Required?"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.fireNocRequired)), fireDepartmentCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Fire Department Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      width: "100%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PARKING_ARRANGEMENT")))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Parking Required"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired)), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No of Parking Proposed (As per Map)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingProposed)), parkingProposalDoc && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposed Parking Plan"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(parkingProposalDoc, setIsPreviewLoading)
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROVISION_PROPOSED_PLAN")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars in Basement"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr = checklist1.parkingProvision) === null || _checklist1$parkingPr === void 0 ? void 0 : (_checklist1$parkingPr2 = _checklist1$parkingPr.inBasement) === null || _checklist1$parkingPr2 === void 0 ? void 0 : _checklist1$parkingPr2.cars) && /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr3 = checklist1.parkingProvision) === null || _checklist1$parkingPr3 === void 0 ? void 0 : (_checklist1$parkingPr4 = _checklist1$parkingPr3.inBasement) === null || _checklist1$parkingPr4 === void 0 ? void 0 : _checklist1$parkingPr4.cars)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars in Open Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr5 = checklist1.parkingProvision) === null || _checklist1$parkingPr5 === void 0 ? void 0 : (_checklist1$parkingPr6 = _checklist1$parkingPr5.openArea) === null || _checklist1$parkingPr6 === void 0 ? void 0 : _checklist1$parkingPr6.cars) && /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr7 = checklist1.parkingProvision) === null || _checklist1$parkingPr7 === void 0 ? void 0 : (_checklist1$parkingPr8 = _checklist1$parkingPr7.openArea) === null || _checklist1$parkingPr8 === void 0 ? void 0 : _checklist1$parkingPr8.cars)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars in Stilt Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr9 = checklist1.parkingProvision) === null || _checklist1$parkingPr9 === void 0 ? void 0 : (_checklist1$parkingPr10 = _checklist1$parkingPr9.inStiltArea) === null || _checklist1$parkingPr10 === void 0 ? void 0 : _checklist1$parkingPr10.cars) && /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr11 = checklist1.parkingProvision) === null || _checklist1$parkingPr11 === void 0 ? void 0 : (_checklist1$parkingPr12 = _checklist1$parkingPr11.inStiltArea) === null || _checklist1$parkingPr12 === void 0 ? void 0 : _checklist1$parkingPr12.cars))))))))), (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.publicSewerageOrSepticTank) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 2")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Existing road width in meters"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.existingRoadWidth) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Sewerage & Drainage"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.publicSewerageOrSepticTank) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Water Supply"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.waterSupplyArrangement) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Mode of Solid waste disposal"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.solidWasteDisposal) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Mode of Garbage collection"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.garbageCollection) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Power supply"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.powerSupply)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Rain Water Harvesting"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.rainWaterHarvesting)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Solar Water Heating system"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.solarWaterHeating))))))))), ((formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapCoordinates) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Map"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5.googleMapCoordinates) === null || _formData$description6 === void 0 ? void 0 : (_formData$description7 = _formData$description6[0]) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : (_formData$description9 = _formData$description8.googleMapCoordinates) === null || _formData$description9 === void 0 ? void 0 : (_formData$description10 = _formData$description9[0]) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.latitude, ", Longitude:", " ", formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11.googleMapCoordinates) === null || _formData$description12 === void 0 ? void 0 : (_formData$description13 = _formData$description12[0]) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.googleMapLocation))))))))), (formData === null || formData === void 0 ? void 0 : formData.assignLTP) === "Yes" && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Assign file to License Technical Person(LTP)"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.ltpName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Selected LTP")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.ltpName)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.ltpRegistrationNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Registration No.")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.ltpRegistrationNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.ltpCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("City Name")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.ltpCity))))))))), Boolean(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Purchasable FAR"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3[0]) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.estimateAmount)))))))));
});

const Architect = ({
  formData,
  applicationDocs,
  totalAmount,
  actions,
  avpLogo,
  daLogo
}) => {
  var _formData$landInfo, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo4, _formData$landInfo4$o, _actions$, _formData$taxHeadEsti;
  let user = Digit.UserService.getUser();
  console.log("formDataFromAction", formData);
  const {
    t
  } = useTranslation();
  const [smShow, setSmShow] = useState(false);
  const [smShowNoc, setSmShowNoc] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowMsHistory, setSmShowMsHistory] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [formHistory, setFormHistory] = useState("");
  const [smShowMs11, setSmShowMs11] = useState(false);
  const [smShowMsHistory11, setSmShowMsHistory11] = useState(false);
  const closeModal2 = formData => {
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_12") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form12");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_11") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form11");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_26") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form26");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_NOC") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("formNOC");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
    }
  };
  const closeModalHistory = formData => {
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_12") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form12");
      setFormHistory("WorkHistory");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_11") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form11");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_26") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("form26");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_MT") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("formMT");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_NOC") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("formNOC");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    }
    if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_CLU") {
      setIdData(formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
      setFormType("formCLU");
      if ((formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo) != null) {
        setSmShowMsHistory(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "only-white-bg mt-3 mb-3",
    style: {
      borderRadius: "13px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "application-detail-node"
  }, "Application Details", /*#__PURE__*/React__default.createElement("div", null, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_NOC" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary border-0 whiteButton p-1 px-3",
    onClick: () => {
      setSmShowNoc(true), console.log("modal open");
    }
  }, "View Application"), (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_NOC" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary whiteButton p-1 px-3 border-0",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application"))), /*#__PURE__*/React__default.createElement("div", {
    className: "application-inner-sec"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12"
  }, (formData === null || formData === void 0 ? void 0 : formData.paymentStatus) === "Success" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary whiteButton p-1 px-3 border-0 mb-3",
    onClick: () => {
      setSmShowPayment(true), console.log("modal open");
    }
  }, "Payment Receipt"), (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_12" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      padding: "1px",
      marginLeft: "2px",
      paddingLeft: "3%",
      paddingRight: "3%"
    },
    onClick: () => closeModal2(formData)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff"
    }
  }, "Old View Application")), (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) === "FORM_12" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      padding: "1px",
      marginLeft: "2px",
      paddingLeft: "3%",
      paddingRight: "3%"
    },
    onClick: () => closeModalHistory(formData)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff"
    }
  }, "History old Application")), (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) != "FORM_12" && (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      padding: "1px",
      marginLeft: "2px",
      paddingLeft: "3%",
      paddingRight: "3%"
    },
    onClick: () => closeModal2(formData)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff"
    }
  }, "Old View Application")), (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) != "FORM_12" && (formData === null || formData === void 0 ? void 0 : formData.oldApplicationType) && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      padding: "1px",
      marginLeft: "2px",
      paddingLeft: "3%",
      paddingRight: "3%"
    },
    onClick: () => closeModalHistory(formData)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff"
    }
  }, "History old Application"))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 1,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`)))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 1,
      mb: 2
    }
  }, ": \xA0\xA0 ", (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || ""))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 1,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number"))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 1,
      mb: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners) && /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners[0]) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.mobileNumber)))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 1,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name"))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 1,
      mb: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : _formData$landInfo3.owners) && /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners[0]) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.name)))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 1,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applied For "))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 1,
      mb: 2
    }
  }, ": \xA0\xA0 ", t(`${formData === null || formData === void 0 ? void 0 : formData.applicationType}`))))), (formData === null || formData === void 0 ? void 0 : formData.structureCertificateUrl) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Structural Stability Certificate"))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    },
    style: {
      margin: "10px",
      display: "flex",
      padding: "5px"
    }
  }, ": \xA0\xA0", " ", /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.structureCertificateUrl,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginLeft: "-7px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Approval Certificate"))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    },
    style: {
      margin: "10px",
      display: "flex",
      padding: "0px"
    }
  }, ": \xA0\xA0", " ", /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    }
  })))))), ((actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "MAKE_PAYMENT" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_APPLICATION_FEE") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti.map((item, index) => {
    var _item$feeDetails, _descriptionOfLand, _descriptionOfLand$ty, _item$feeDetails2, _item$feeDetails2$dev, _item$feeDetails3, _descriptionOfLand2, _descriptionOfLand2$t, _descriptionOfLand3, _descriptionOfLand3$t, _item$feeDetails4, _item$feeDetails4$dev, _item$feeDetails5, _descriptionOfLand4, _descriptionOfLand4$t, _item$feeDetails6, _item$feeDetails6$dev, _item$applicationFeeD, _item$applicationFeeD2, _item$applicationFeeD3, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _formData$taxHeadEsti5;
    return /*#__PURE__*/React__default.createElement(Box, {
      gridColumn: "span 12"
    }, /*#__PURE__*/React__default.createElement(Card$3, {
      style: {
        textAlign: "center",
        marginBottom: "5px",
        border: "1px solid rgba(91, 90, 95, 0.35)"
      }
    }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_11" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA_FORM11" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Processing Fee ")), (formData === null || formData === void 0 ? void 0 : formData.businessService) !== "BPA_FORM11" && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Fee ")), (formData === null || formData === void 0 ? void 0 : formData.businessService) !== "BPA_FORM11" && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Processing Fee"))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_26" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA_FORM26" && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Fee ")), (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA_FORM26" && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Processing Fee")), (formData === null || formData === void 0 ? void 0 : formData.businessService) !== "BPA_FORM26" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Processing Fee "), " ")), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_26" && (item === null || item === void 0 ? void 0 : (_item$feeDetails = item.feeDetails) === null || _item$feeDetails === void 0 ? void 0 : _item$feeDetails.deviationTable) && /*#__PURE__*/React__default.createElement(Fragment$2, null, ((_descriptionOfLand = descriptionOfLand) === null || _descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty = _descriptionOfLand.typeOfDeviation) === null || _descriptionOfLand$ty === void 0 ? void 0 : _descriptionOfLand$ty.name) === "Plan was approved and deviation beyond permissible limit Upto extent of 10%" && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Floor Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Use Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "3"
    }, /*#__PURE__*/React__default.createElement("b", null, "Builtup Area & Fees")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Area(sq.m)")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price()")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()")))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "3"
    }, /*#__PURE__*/React__default.createElement("b", null, "Deviation Area & Fees")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Area(sq.m)")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price()")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "150px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()")))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$feeDetails2 = item.feeDetails) === null || _item$feeDetails2 === void 0 ? void 0 : (_item$feeDetails2$dev = _item$feeDetails2.deviationTable) === null || _item$feeDetails2$dev === void 0 ? void 0 : _item$feeDetails2$dev.map((feeData, index) => {
      var _feeData$floorType, _feeData$landUseType, _feeData$landUseType2, _feeData$landUseType3, _feeData$landUseType4, _feeData$floorType2, _feeData$floorType3, _feeData$floorType4;
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType = feeData.floorType) === null || _feeData$floorType === void 0 ? void 0 : _feeData$floorType.name), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType = feeData.landUseType) === null || _feeData$landUseType === void 0 ? void 0 : _feeData$landUseType.name)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType2 = feeData.landUseType) === null || _feeData$landUseType2 === void 0 ? void 0 : _feeData$landUseType2.area), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType3 = feeData.landUseType) === null || _feeData$landUseType3 === void 0 ? void 0 : _feeData$landUseType3.unitPrice), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType4 = feeData.landUseType) === null || _feeData$landUseType4 === void 0 ? void 0 : _feeData$landUseType4.price)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType2 = feeData.floorType) === null || _feeData$floorType2 === void 0 ? void 0 : _feeData$floorType2.area), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType3 = feeData.floorType) === null || _feeData$floorType3 === void 0 ? void 0 : _feeData$floorType3.unitPrice), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "150px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType4 = feeData.floorType) === null || _feeData$floorType4 === void 0 ? void 0 : _feeData$floorType4.price)));
    })))), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginRight: "1%",
        marginLeft: "1%"
      }
    }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_26" && (item === null || item === void 0 ? void 0 : (_item$feeDetails3 = item.feeDetails) === null || _item$feeDetails3 === void 0 ? void 0 : _item$feeDetails3.deviationTable) && /*#__PURE__*/React__default.createElement(Fragment$2, null, (((_descriptionOfLand2 = descriptionOfLand) === null || _descriptionOfLand2 === void 0 ? void 0 : (_descriptionOfLand2$t = _descriptionOfLand2.typeOfDeviation) === null || _descriptionOfLand2$t === void 0 ? void 0 : _descriptionOfLand2$t.name) === "Plan was not approved and construction carried out without deviation" || ((_descriptionOfLand3 = descriptionOfLand) === null || _descriptionOfLand3 === void 0 ? void 0 : (_descriptionOfLand3$t = _descriptionOfLand3.typeOfDeviation) === null || _descriptionOfLand3$t === void 0 ? void 0 : _descriptionOfLand3$t.name) === "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%") && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px",
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Use Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "3",
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Builtup Area & Fees")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Area(sq.m)")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price * Sub Price")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()")))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$feeDetails4 = item.feeDetails) === null || _item$feeDetails4 === void 0 ? void 0 : (_item$feeDetails4$dev = _item$feeDetails4.deviationTable) === null || _item$feeDetails4$dev === void 0 ? void 0 : _item$feeDetails4$dev.map((feeData, index) => {
      var _feeData$landUseType5, _feeData$landUseType6, _feeData$landUseType7, _feeData$landUseType8, _feeData$landUseType9;
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType5 = feeData.landUseType) === null || _feeData$landUseType5 === void 0 ? void 0 : _feeData$landUseType5.name)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType6 = feeData.landUseType) === null || _feeData$landUseType6 === void 0 ? void 0 : _feeData$landUseType6.area), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType7 = feeData.landUseType) === null || _feeData$landUseType7 === void 0 ? void 0 : _feeData$landUseType7.unitPrice, " * ", feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType8 = feeData.landUseType) === null || _feeData$landUseType8 === void 0 ? void 0 : _feeData$landUseType8.subPrice), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType9 = feeData.landUseType) === null || _feeData$landUseType9 === void 0 ? void 0 : _feeData$landUseType9.price)));
    }))))), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginRight: "1%",
        marginLeft: "1%"
      }
    }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_26" && (item === null || item === void 0 ? void 0 : (_item$feeDetails5 = item.feeDetails) === null || _item$feeDetails5 === void 0 ? void 0 : _item$feeDetails5.deviationTable) && /*#__PURE__*/React__default.createElement(Fragment$2, null, ((_descriptionOfLand4 = descriptionOfLand) === null || _descriptionOfLand4 === void 0 ? void 0 : (_descriptionOfLand4$t = _descriptionOfLand4.typeOfDeviation) === null || _descriptionOfLand4$t === void 0 ? void 0 : _descriptionOfLand4$t.name) === "Building constructed on under size plot to the extent of 10% less than the permissible plot size" && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px",
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Use Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "3",
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Builtup Area & Fees")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Area(sq.m) * Unit Price")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Sub Price")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()")))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$feeDetails6 = item.feeDetails) === null || _item$feeDetails6 === void 0 ? void 0 : (_item$feeDetails6$dev = _item$feeDetails6.deviationTable) === null || _item$feeDetails6$dev === void 0 ? void 0 : _item$feeDetails6$dev.map((feeData, index) => {
      var _feeData$landUseType10, _feeData$landUseType11, _feeData$landUseType12, _feeData$landUseType13, _feeData$landUseType14;
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType10 = feeData.landUseType) === null || _feeData$landUseType10 === void 0 ? void 0 : _feeData$landUseType10.name)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType11 = feeData.landUseType) === null || _feeData$landUseType11 === void 0 ? void 0 : _feeData$landUseType11.area, " * ", feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType12 = feeData.landUseType) === null || _feeData$landUseType12 === void 0 ? void 0 : _feeData$landUseType12.unitPrice, " "), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, " ", feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType13 = feeData.landUseType) === null || _feeData$landUseType13 === void 0 ? void 0 : _feeData$landUseType13.subPrice), /*#__PURE__*/React__default.createElement("td", {
        style: {
          width: "300px"
        }
      }, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType14 = feeData.landUseType) === null || _feeData$landUseType14 === void 0 ? void 0 : _feeData$landUseType14.price)));
    }))))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_11" && (item === null || item === void 0 ? void 0 : (_item$applicationFeeD = item.applicationFeeDetils) === null || _item$applicationFeeD === void 0 ? void 0 : _item$applicationFeeD.khasraTable) && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot No"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "plot Area(sqm.) "))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "purpose "))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Type of land development"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price per SqM"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Fee"))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$applicationFeeD2 = item.applicationFeeDetils) === null || _item$applicationFeeD2 === void 0 ? void 0 : (_item$applicationFeeD3 = _item$applicationFeeD2.khasraTable) === null || _item$applicationFeeD3 === void 0 ? void 0 : _item$applicationFeeD3.map((feeData, index) => /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : feeData.plotNo), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : feeData.plotArea)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : feeData.purpose)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : feeData.typeOfLand)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : feeData.unitPrice)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : feeData.applicationFee)))))), /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) != "FORM_MT" && /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginLeft: "10px",
        textAlign: "left"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.applicationFee) !== 0 && (item === null || item === void 0 ? void 0 : item.applicationFee) || (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimate) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.estimateAmount) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, t(`BPA_COMMON_APPLICATION_FEE`)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${(item === null || item === void 0 ? void 0 : item.applicationFee) || (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimate) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : (_formData$taxHeadEsti5 = _formData$taxHeadEsti4[0]) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : _formData$taxHeadEsti5.estimateAmount)}`))), (item === null || item === void 0 ? void 0 : item.buildingUseFee) !== 0 && (item === null || item === void 0 ? void 0 : item.buildingUseFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Development of land Fees"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.buildingUseFee}`))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_MT" && /*#__PURE__*/React__default.createElement(Fragment$2, null, (item === null || item === void 0 ? void 0 : item.buildUpCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.buildUpCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Building Operation Fees"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.buildUpCharges}`)))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) != "FORM_MT" && /*#__PURE__*/React__default.createElement(Fragment$2, null, (item === null || item === void 0 ? void 0 : item.buildUpCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.buildUpCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Building Permission Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.buildUpCharges}`)))), (item === null || item === void 0 ? void 0 : item.cluFee) !== 0 && (item === null || item === void 0 ? void 0 : item.cluFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "CLU Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.cluFee}`))), (item === null || item === void 0 ? void 0 : item.deviationCharges) && (item === null || item === void 0 ? void 0 : item.deviationCharges) !== 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Deviation Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.deviationCharges}`))), (item === null || item === void 0 ? void 0 : item.muckCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.muckCharges) && /*#__PURE__*/React__default.createElement("tr", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("td", null, "Total Muck-Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.deviationCharges}`))), (item === null || item === void 0 ? void 0 : item.totalCBMFees) !== 0 && (item === null || item === void 0 ? void 0 : item.totalCBMFees) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Planning Permission Fee")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.totalCBMFees}`))), (item === null || item === void 0 ? void 0 : item.premiumFARFee) !== 0 && (item === null || item === void 0 ? void 0 : item.premiumFARFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Premium FAR Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.premiumFARFee}`))), (item === null || item === void 0 ? void 0 : item.echarges) !== 0 && (item === null || item === void 0 ? void 0 : item.echarges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "e-charges (3%)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.echarges}`))), (item === null || item === void 0 ? void 0 : item.amountDisplay) !== 0 && (item === null || item === void 0 ? void 0 : item.amountDisplay) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Grand Total Amount")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.amountDisplay}`)))))));
  }))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" ? /*#__PURE__*/React__default.createElement(TakeActionItem, {
    formType: "formLandUse",
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo
  }) : (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" ? /*#__PURE__*/React__default.createElement(Summary$1, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNumber
  }) : /*#__PURE__*/React__default.createElement(LTPSummary, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowNoc,
    onClose: () => {
      setSmShowNoc(false);
    }
  }, /*#__PURE__*/React__default.createElement(NOCFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: smShowPayment,
    onClose: () => {
      setSmShowPayment(false);
    }
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$2, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  })), formType === "form12" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationView12, {
    id: idData,
    formType: formType
  })), formType === "form12" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistory, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "form11" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "form11" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "form26" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "form26" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formMT" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formMT" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formNOC" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formNOC" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  })), formType === "formCLU" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), formType === "formCLU" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Old Application History",
    dataOpen: smShowMsHistory,
    onClose: () => {
      setSmShowMsHistory(false);
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationViewHistoryAll, {
    id: idData,
    formType: formType,
    formHistory: formHistory
  }))));
};

const BPAApplicationTimeline = props => {
  var _props$application, _props$application2, _data$timeline, _data$timeline$;
  const {
    t
  } = useTranslation();
  const businessService = (_props$application = props.application) === null || _props$application === void 0 ? void 0 : _props$application.businessService;
  const {
    isLoading,
    data
  } = Digit.Hooks.useWorkflowDetails({
    tenantId: (_props$application2 = props.application) === null || _props$application2 === void 0 ? void 0 : _props$application2.tenantId,
    id: props.id,
    moduleCode: businessService
  });
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
    const caption = {
      date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
      name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
      mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
      comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
      wfComment: checkpoint.wfComment,
      thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
    };
    return /*#__PURE__*/React__default.createElement(BPACaption, {
      data: caption,
      OpenImage: OpenImage
    });
  };
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "old-ui"
  }, !isLoading && /*#__PURE__*/React__default.createElement(Fragment$2, null, data !== null && data !== void 0 && data.timeline && (data === null || data === void 0 ? void 0 : (_data$timeline = data.timeline) === null || _data$timeline === void 0 ? void 0 : _data$timeline.length) === 1 ? /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t((data === null || data === void 0 ? void 0 : (_data$timeline$ = data.timeline[0]) === null || _data$timeline$ === void 0 ? void 0 : _data$timeline$.state) && `WF_${businessService}_${data.timeline[0].state}` || "NA"),
    customChild: getTimelineCaptions(data === null || data === void 0 ? void 0 : data.timeline[0])
  }) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (data === null || data === void 0 ? void 0 : data.timeline) && [...new Set(data === null || data === void 0 ? void 0 : data.timeline.map(checkpoint => checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.status))].map((uniqueStatus, index) => {
    const checkpoint = data === null || data === void 0 ? void 0 : data.timeline.find(item => item.status === uniqueStatus);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      label: checkpoint.state ? t(`WF_${businessService}_${checkpoint.state}`) : "NA",
      customChild: getTimelineCaptions(checkpoint)
    }));
  }))));
};

const StyledRadioGroup$2 = styled(RadioGroup)(({
  theme
}) => ({
  columnGap: theme.spacing(1),
  alignItems: "center",
  minHeight: 40
}));
const RadioButton$1 = ({
  row,
  data,
  control,
  name,
  width,
  defaultValue,
  clickControl,
  validation,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(StyledRadioGroup$2, {
      "aria-labelledby": "radio-buttons-group-label",
      value: value || defaultValue || "",
      name: name || "radio-buttons-group",
      row: row,
      onChange: e => {
        onChange(e);
        clickControl === null || clickControl === void 0 ? void 0 : clickControl(e);
      },
      sx: {
        width: width || "18.25vw",
        translate: "-8px 0"
      }
    }, data === null || data === void 0 ? void 0 : data.map(item => /*#__PURE__*/React__default.createElement(FormControlLabel, {
      sx: {
        margin: 0
      },
      key: item.value,
      value: item.value,
      control: /*#__PURE__*/React__default.createElement(Radio, null),
      label: item.label,
      disabled: disabled
    })), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const SelectWrapper$1 = ({
  label,
  inputLabel,
  data: _data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled: _disabled = false,
  validation,
  height,
  onBlur
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name || "name",
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "5px"
      },
      size: "small",
      disabled: _disabled,
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Select$2, {
      displayEmpty: true,
      value: value || defaultValue || "",
      onChange: e => {
        onChange(e);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      },
      autoWidth: autoWidth,
      name: name,
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
        style: {
          borderRadius: "1px",
          height: height || "30px",
          width: width || "18.25vw"
        }
      }),
      renderValue: selected => {
        if (selected.length === 0) {
          return /*#__PURE__*/React__default.createElement("em", {
            style: {
              fontStyle: "normal"
            }
          }, placeholder);
        }
        return selected;
      },
      MenuProps: {
        disablePortal: false,
        disableScrollLock: true
      },
      inputProps: {
        "aria-label": "Without label"
      }
    }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
      disabled: true,
      value: ""
    }, /*#__PURE__*/React__default.createElement("em", {
      style: {
        fontStyle: "normal"
      }
    }, placeholder)), Array.isArray(_data) && (_data === null || _data === void 0 ? void 0 : _data.map(item => {
      const dropdowns = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.i18nKey);
      return /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        value: dropdowns,
        key: dropdowns
      }, dropdowns);
    }))), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: "error-message"
    }, error.message), helperText && !error && /*#__PURE__*/React__default.createElement(FormHelperText, null, helperText))
  });
};

const TextInput$1 = ({
  children,
  select,
  width,
  height,
  disabled,
  multiline,
  control,
  type,
  name,
  defaultValue,
  validation: _validation = {},
  isRequired,
  minLength,
  maxLength,
  inputClassName,
  maxValue,
  message,
  decimalScale: _decimalScale = null,
  formatOnBlur: _formatOnBlur = false,
  ...rest
}) => {
  const combinedValidation = {
    ..._validation,
    ...(isRequired && {
      required: {
        value: true,
        message: "This field is required"
      }
    }),
    ...(minLength && {
      minLength: {
        value: minLength,
        message: `The input must be at least ${minLength} characters long.`
      }
    }),
    ...(maxLength && {
      maxLength: {
        value: maxLength,
        message: `The input can only be ${maxLength} characters long.`
      }
    }),
    ...(maxValue && {
      validate: {
        lessThanMax: value => {
          if (Number(value) > maxValue) {
            return message || `The value must not exceed ${maxValue}`;
          }
          return true;
        }
      }
    })
  };
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    rules: combinedValidation,
    render: ({
      field: {
        onChange,
        value,
        onBlur
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px",
        minHeight: multiline ? "60px" : "auto"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(TextField, Object.assign({
      sx: {
        width: width || "18.25vw",
        marginRight: select ? "1rem" : 0,
        "& .MuiOutlinedInput-root": {
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "orange"
          },
          "& .MuiInputBase-root.Mui-disabled": {
            opacity: 0.7
          }
        }
      },
      className: `${inputClassName}`,
      name: name,
      onChange: onChange,
      onBlur: e => {
        onBlur();
        if (_formatOnBlur && _decimalScale !== null && value !== "" && value !== null && value !== undefined) {
          const num = Number(value);
          if (!isNaN(num)) {
            onChange(num.toFixed(_decimalScale));
          }
        }
        if (rest.onBlur) {
          rest.onBlur(e);
        }
      },
      select: select
    }, !multiline && {
      type
    }, {
      multiline: multiline,
      value: value || "",
      minRows: multiline ? 3 : 0,
      disabled: disabled,
      error: !!error
    }, rest), children), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const UploadButton$1 = ({
  error
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    color: "primary",
    "aria-label": "upload picture",
    component: "label"
  }, /*#__PURE__*/React__default.createElement("input", {
    hidden: true,
    accept: "image/*",
    type: "file"
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
    className: "img",
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, error));
};

const formatDate$1 = date => {
  return dayjs(date).format("YYYY-MM-DD");
};
const DatePick$1 = ({
  label,
  defaultValue,
  control,
  name,
  width,
  validation,
  maxDate,
  disableFuture,
  disablePast,
  disabled,
  isRequired
}) => {
  var _validation$required;
  const [reqDate, setReqDate] = useState(null);
  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate$1(defaultValue)));
    }
  }, [defaultValue]);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    defaultValue: reqDate,
    rules: {
      ...((validation === null || validation === void 0 ? void 0 : (_validation$required = validation.required) === null || _validation$required === void 0 ? void 0 : _validation$required.value) && {
        validate: value => {
          var _validation$required2, _validation$required3;
          if (!value) return validation === null || validation === void 0 ? void 0 : (_validation$required2 = validation.required) === null || _validation$required2 === void 0 ? void 0 : _validation$required2.message;
          const selected = dayjs(value);
          if (!selected.isValid()) {
            return "Please select a valid date";
          }
          if (selected.year < 1950) {
            return "Please select a date after 1950";
          }
          if (selected.year > 2050) {
            return "Please select a date before 2050";
          }
          if (selected.month > 11) {
            return "Please select a valid month";
          }
          return !!value || (validation === null || validation === void 0 ? void 0 : (_validation$required3 = validation.required) === null || _validation$required3 === void 0 ? void 0 : _validation$required3.message);
        }
      }),
      ...(isRequired && {
        required: {
          value: true,
          message: "This field is required"
        }
      }),
      ...(disablePast && {
        validate: value => {
          if (!value) return true;
          const today = dayjs().startOf("day");
          const selected = dayjs(value).startOf("day");
          return !selected.isBefore(today) || "Past dates are not allowed";
        }
      })
    },
    control: control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DatePicker$1, {
      name: name,
      slotProps: {
        textField: {
          error: !!error,
          sx: {
            width: width || "18.25vw",
            borderRadius: "1px",
            "& .MuiInputBase-root": {
              height: "30px"
            }
          }
        }
      },
      label: label,
      value: value ? dayjs(value) : reqDate,
      onChange: event => {
        if (event) {
          const formattedDate = formatDate$1(event);
          onChange(formattedDate);
        } else {
          onChange(null);
        }
      },
      disableFuture: disableFuture,
      disablePast: disablePast,
      disabled: disabled,
      maxDate: maxDate,
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField, Object.assign({
        size: "small"
      }, params, {
        error: !!error,
        helperText: error ? error.message : null
      }))
    })), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const TimePick$1 = ({
  label,
  width,
  control,
  name,
  defaultValue
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || dayjs(),
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DemoContainer, {
      components: ['MobileTimePicker']
    }, /*#__PURE__*/React__default.createElement(DemoItem, null, /*#__PURE__*/React__default.createElement(MobileTimePicker, {
      label: label,
      value: value || dayjs(),
      onChange: val => onChange(val),
      slotProps: {
        textField: {
          size: 'small'
        }
      },
      sx: {
        width: width ? width : '18.25vw'
      }
    }))))
  });
};

const YearMonthPicker = ({
  yearPlaceholder: _yearPlaceholder = "Year",
  monthPlaceholder: _monthPlaceholder = "Month",
  name,
  control,
  validation,
  defaultValue,
  disabled,
  width: _width = "9vw",
  height: _height = "30px"
}) => {
  const years = Array.from({
    length: 30
  }, (_, i) => i);
  const months = Array.from({
    length: 12
  }, (_, i) => i);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue || "",
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      const [currentYear, currentMonth] = value ? value.split("-").map(item => parseInt(item.match(/\d+/), 10)) : [null, null];
      const handleChange = (type, selectedValue) => {
        const updatedYear = type === "year" ? selectedValue : currentYear || 0;
        const updatedMonth = type === "month" ? selectedValue : currentMonth || 0;
        const yearLabel = updatedYear === 1 || updatedYear === 0 ? "Year" : "Years";
        const monthLabel = updatedMonth === 1 ? "Month" : "Months";
        const formattedValue = `${updatedYear || 0} ${yearLabel}-${updatedMonth || 0} ${monthLabel}`;
        onChange(formattedValue);
      };
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          gap: "10px"
        }
      }, /*#__PURE__*/React__default.createElement(FormControl, {
        sx: {
          width: _width,
          borderRadius: "5px"
        },
        size: "small",
        error: !!error,
        disabled: disabled
      }, /*#__PURE__*/React__default.createElement(Select$2, {
        value: currentYear || "",
        onChange: e => handleChange("year", e.target.value),
        displayEmpty: true,
        input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
          style: {
            borderRadius: "5px",
            height: _height
          }
        }),
        renderValue: selected => {
          if (!selected) {
            return /*#__PURE__*/React__default.createElement("em", {
              style: {
                fontStyle: "normal"
              }
            }, _yearPlaceholder);
          }
          return selected > 1 ? `${selected} Years` : selected === 0 || selected === 1 ? `${selected} Year` : "";
        },
        inputProps: {
          "aria-label": "Year Dropdown"
        }
      }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        disabled: true,
        value: ""
      }, /*#__PURE__*/React__default.createElement("em", {
        style: {
          fontStyle: "normal"
        }
      }, _yearPlaceholder)), years.map(item => /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        key: item,
        value: item
      }, item)))), /*#__PURE__*/React__default.createElement(FormControl, {
        sx: {
          width: _width,
          borderRadius: "5px"
        },
        size: "small",
        error: !!error,
        disabled: disabled
      }, /*#__PURE__*/React__default.createElement(Select$2, {
        value: currentMonth || "",
        onChange: e => handleChange("month", e.target.value),
        displayEmpty: true,
        input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
          style: {
            borderRadius: "5px",
            height: _height
          }
        }),
        renderValue: selected => {
          if (!selected && selected !== 0) {
            return /*#__PURE__*/React__default.createElement("em", {
              style: {
                fontStyle: "normal"
              }
            }, _monthPlaceholder);
          }
          return selected === 1 ? `${selected} Month` : `${selected} Months`;
        },
        inputProps: {
          "aria-label": "Month Dropdown"
        }
      }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        disabled: true,
        value: ""
      }, /*#__PURE__*/React__default.createElement("em", {
        style: {
          fontStyle: "normal"
        }
      }, _monthPlaceholder)), months.map(item => /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        key: item,
        value: item
      }, item)))), error && /*#__PURE__*/React__default.createElement(Typography, {
        variant: "caption",
        className: "error-message"
      }, error.message));
    }
  });
};

const SelectWrappers = ({
  control,
  name,
  label,
  defaultValue,
  data: _data = [],
  width,
  multiple: _multiple = false,
  disabled,
  validation,
  placeholder,
  height,
  onBlur
}) => {
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    sx: {
      width: width || "18.25vw",
      height
    },
    size: "small",
    disabled: disabled
  }, label && /*#__PURE__*/React__default.createElement(InputLabel, null, label), /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || (_multiple ? [] : ""),
    rules: validation,
    render: ({
      field,
      fieldState
    }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Select$3, Object.assign({}, field, {
      multiple: _multiple,
      onBlur: onBlur,
      displayEmpty: true,
      renderValue: selected => _multiple ? selected.length ? selected.join(", ") : placeholder || "Select options" : selected || placeholder
    }), _data.map(item => /*#__PURE__*/React__default.createElement(MenuItem$2, {
      key: item.value,
      value: item.value
    }, item.label))), fieldState.error && /*#__PURE__*/React__default.createElement(FormHelperText, {
      error: true
    }, fieldState.error.message))
  }));
};

const SearchSelect = ({
  name,
  control,
  data: _data = [],
  placeholder: _placeholder = "Select an option",
  disabled: _disabled = false,
  validation: _validation = {},
  defaultValue: _defaultValue = null,
  width: _width = "18.25vw",
  height: _height = "30px",
  select: _select = false,
  returnObject: _returnObject = false
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: _defaultValue,
    rules: _validation,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl$1, {
      sx: {
        width: _width,
        borderRadius: "1px"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Autocomplete, {
      options: _data || [],
      getOptionLabel: option => typeof option === "string" ? option : option.label,
      isOptionEqualToValue: (option, val) => option.value === (val === null || val === void 0 ? void 0 : val.value),
      value: _returnObject ? value || null : (_data === null || _data === void 0 ? void 0 : _data.find(item => (item === null || item === void 0 ? void 0 : item.value) === value)) || null,
      onChange: (event, newValue) => {
        onChange(_returnObject ? newValue : (newValue === null || newValue === void 0 ? void 0 : newValue.label) || "");
      },
      disabled: _disabled,
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, params, {
        placeholder: _placeholder,
        size: "small",
        disabled: _disabled,
        error: !!error,
        sx: {
          width: _width || "18.25vw",
          "& .MuiOutlinedInput-root": {
            borderRadius: "1px",
            height: _height || "30px",
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
              borderColor: "orange"
            }
          }
        }
      }))
    }), error && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const InputWrapper = ({
  label,
  width,
  height,
  disabled: _disabled = false,
  selectSuffix: _selectSuffix = null,
  hasLabel: _hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine: _multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  isRequired,
  maxDate,
  disableFuture,
  disablePast,
  minLength,
  maxValue,
  allowedChars,
  onBlur,
  inputClassName,
  message,
  customLabel,
  onlyNumeric: _onlyNumeric = false,
  customLabelStyles,
  trimSpace: _trimSpace = false,
  returnObject: _returnObject = false,
  isPassword: _isPassword = false,
  decimalScale: _decimalScale = null,
  onlyAlphabet: _onlyAlphabet = false,
  formatOnBlur: _formatOnBlur = false
}) => {
  const [showPassword, setShowPassword] = React__default.useState(false);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `inputContainer`,
    style: containerStyles
  }, _hasLabel && type !== "checkbox" && /*#__PURE__*/React__default.createElement("h3", {
    className: `label ${multiColumn ? "multiCoumn" : customLabel ? customLabel : ""}`,
    style: {
      width: labelWidth && labelWidth,
      height: height || "30px",
      ...customLabelStyles
    }
  }, label, mandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), type === "textInput" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _selectSuffix && /*#__PURE__*/React__default.createElement(SelectWrapper$1, Object.assign({
    variant: "outlined",
    width: "6vw",
    size: "small"
  }, _selectSuffix, {
    defaultValue: _selectSuffix === null || _selectSuffix === void 0 ? void 0 : _selectSuffix.defaultValue,
    validation: validation
  })), /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || (_selectSuffix ? "11.25vw" : "18.25vw"),
    height: height,
    name: name,
    message: message,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: _multiLine,
    maxValue: maxValue,
    isRequired: isRequired,
    inputClassName: inputClassName,
    InputProps: {
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      endAdornment: showSearchIcon &&
      /*#__PURE__*/
      React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        onClick: onSearchClick
      }, /*#__PURE__*/React__default.createElement(Search$1, null))),
      sx: {
        height: height || (_multiLine ? "auto" : "30px")
      }
    },
    validation: validation,
    inputProps: {
      maxLength
    },
    onInput: e => {
      let value = e.target.value;
      if (_onlyAlphabet) {
        value = value.replace(/[^A-Za-z\s]/g, "");
        value = value.replace(/^\s+/g, "");
        value = value.replace(/\s{2,}/g, " ");
      }
      if (_trimSpace) {
        value = value.replace(/\s/g, "");
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }, !_selectSuffix && data && select && (data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: option.value,
    value: option.value
  }, option.label))))) : type === "radioButton" ? /*#__PURE__*/React__default.createElement(RadioButton$1, {
    defaultValue: defaultValue,
    clickControl: clickControl,
    control: control,
    width: width,
    data: data,
    name: name,
    row: true,
    validation: validation,
    disabled: _disabled,
    inputClassName: inputClassName
  }) : type === "selectInput" ? /*#__PURE__*/React__default.createElement(SelectWrapper$1, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue,
    inputLabel: placeholder,
    width: width || "18.25vw",
    height: height,
    label: label,
    data: data,
    name: name,
    disabled: _disabled,
    validation: validation,
    onBlur: onBlur,
    InputProps: {}
  }) : type === "multiSelectInput" ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || [],
    rules: validation,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(Select$3, {
      multiple: true,
      displayEmpty: true,
      value: value,
      onChange: e => onChange(e.target.value),
      renderValue: selected => selected.length ? selected.map(val => {
        const found = data.find(d => d.value === val);
        return (found === null || found === void 0 ? void 0 : found.label) || val;
      }).join(", ") : placeholder,
      size: "small",
      fullWidth: true,
      sx: {
        backgroundColor: "#fff"
      }
    }, data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$2, {
      key: option.value,
      value: option.value
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: value.includes(option.value)
    }), /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: option.label
    }))))
  }) : type === "multiSelectInputs" ? /*#__PURE__*/React__default.createElement(SelectWrappers, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue || [],
    inputLabel: placeholder,
    width: width,
    height: height,
    label: label,
    data: data,
    name: name,
    multiple: true,
    disabled: _disabled,
    validation: validation,
    onBlur: onBlur
  }) : type === "upload" ? /*#__PURE__*/React__default.createElement(UploadButton$1, {
    error: uploadValidity
  }) : type === "htmlUpload" ? /*#__PURE__*/React__default.createElement("div", {
    className: "uploadHtml"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return getDocumentData(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    }
  }), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, uploadValidity)) : type === "datePicker" ? /*#__PURE__*/React__default.createElement(DatePick$1, {
    placeholder: placeholder,
    control: control,
    name: name,
    width: width,
    defaultValue: defaultValue,
    validation: validation,
    maxDate: maxDate,
    disableFuture: disableFuture,
    disablePast: disablePast,
    disabled: _disabled
  }) : type === "yearMonthPicker" ? /*#__PURE__*/React__default.createElement(YearMonthPicker, {
    label: label,
    control: control,
    name: name,
    validation: validation,
    placeholder: placeholder,
    defaultValue: defaultValue,
    disabled: _disabled
  }) : type === "timePicker" ? /*#__PURE__*/React__default.createElement(TimePick$1, {
    control: control,
    label: label,
    name: name,
    defaultValue: defaultValue
  }) : type === "number" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    isRequired: isRequired,
    defaultValue: defaultValue,
    validation: validation,
    inputClassName: inputClassName,
    InputProps: {
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      let value = e.target.value;
      value = value.replace(/[^0-9]/g, "");
      const max = maxLength ? parseInt(maxLength, 10) : null;
      if (max && value.length > max) {
        value = value.slice(0, max);
      }
      e.target.value = value;
    }
  }) : type === "checkbox" ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: value,
      sx: containerStyles,
      onChange: e => {
        onChange(e.target.checked);
      },
      disabled: _disabled
    })
  }) : type === "decimal" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    type: "text",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    validation: validation,
    isRequired: isRequired,
    defaultValue: defaultValue,
    minLength: minLength,
    maxLength: maxLength,
    maxValue: maxValue,
    message: message,
    inputProps: {
      maxLength,
      inputMode: "decimal"
    },
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      const input = e.target;
      const cursorPosition = input.selectionStart;
      let value = input.value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
        value = `${parts[0]}.${parts.slice(1).join("")}`;
      }
      const max = maxLength ? Number(maxLength) : null;
      if (max && value.length > max) {
        value = value.slice(0, max);
      }
      if (input.value !== value) {
        input.value = value;
        requestAnimationFrame(() => {
          const newPosition = Math.min(cursorPosition, value.length);
          input.setSelectionRange(newPosition, newPosition);
        });
      }
    }
  }) : type === "specialChar" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    isRequired: isRequired,
    defaultValue: defaultValue,
    validation: validation,
    decimalScale: _decimalScale,
    formatOnBlur: _formatOnBlur,
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      let value = e.target.value;
      const escapeRegex = str => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      const escapedPattern = allowedChars ? escapeRegex(allowedChars) : "";
      if (_onlyAlphabet) {
        const regex = new RegExp(`[^A-Za-z${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      } else if (_onlyNumeric) {
        const regex = new RegExp(`[^0-9${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      } else {
        const regex = new RegExp(`[^0-9A-Za-z${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      }
      if (!_onlyAlphabet && allowedChars !== null && allowedChars !== void 0 && allowedChars.includes(".")) {
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (_decimalScale !== null && parts[1]) {
          value = parts[0] + "." + parts[1].slice(0, _decimalScale);
        }
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }) : type === "searchSelect" ? /*#__PURE__*/React__default.createElement(SearchSelect, {
    name: name,
    control: control,
    data: data,
    placeholder: placeholder,
    disabled: _disabled,
    validation: validation,
    defaultValue: defaultValue,
    width: width,
    height: height,
    select: select,
    returnObject: _returnObject
  }) : type === "password" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    defaultValue: defaultValue,
    validation: validation,
    isRequired: isRequired,
    inputClassName: inputClassName,
    type: showPassword ? "textInput" : "password",
    InputProps: {
      endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        onClick: () => setShowPassword(prev => !prev),
        edge: "end"
      }, showPassword ? /*#__PURE__*/React__default.createElement(VisibilityOff, null) : /*#__PURE__*/React__default.createElement(Visibility, null))),
      sx: {
        height: height || "30px"
      }
    },
    inputProps: {
      maxLength
    },
    onInput: e => {
      let value = e.target.value;
      if (_trimSpace) {
        value = value.replace(/\s/g, "");
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }) : "");
};

const filterCategory = roles => {
  console.log("rolesFromFilter", roles);
  if (roles) {
    var _roles$filter$, _roles$filter$2;
    const result = (_roles$filter$ = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$ === void 0 ? void 0 : _roles$filter$.name;
    console.log("resultFromFIlter", result, roles);
    return (_roles$filter$2 = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$2 === void 0 ? void 0 : _roles$filter$2.name;
  }
};

const LowRiskDisclaimer = ({
  handleTabChange,
  tab,
  landArea
}) => {
  const history = useHistory();
  const isEmployee = history.location.pathname.includes("employee");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "application-status-container"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "main-message"
  }, /*#__PURE__*/React__default.createElement("strong", null, "No NOC identification is required"), " because application falls under the Low Risk Category."), /*#__PURE__*/React__default.createElement("p", {
    className: "conditions-heading"
  }, "The conditions that categorize application as low risk are:"), /*#__PURE__*/React__default.createElement("ul", {
    className: "conditions-list"
  }, /*#__PURE__*/React__default.createElement("li", null, "Application is under an Approved Scheme"), /*#__PURE__*/React__default.createElement("li", null, "Land Use is Residential"))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Continue",
    type: "submit",
    onClick: () => handleTabChange(tab),
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))));
};

const CheckBox = ({
  handleChangeCheckBox,
  declarationMessage,
  checked
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(FormGroup, null, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: checked,
      onChange: handleChangeCheckBox,
      inputProps: {
        "aria-label": "controlled"
      }
    }),
    label: declarationMessage
  })));
};

const LandUseNOC = ({
  formData,
  role,
  handleTabChange,
  setOfficerNocDetails,
  setCurrentTab,
  setIsNoNoc,
  setMapSubNocDetails,
  handleNoWorkflowNoc
}) => {
  var _formData$documents, _formData$nocDetails, _formData$nocDetails2, _formData$nocDetails3, _formData$nocDetails4, _formData$nocDetails5, _formData$nocDetails6, _formData$nocDetails7, _formData$nocDetails8, _formData$nocDetails11, _formData$nocDetails12;
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const nocDocuments = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => doc.isNoc === "true");
  console.log("formDataFromNOC", formData, nocDocuments, role);
  const getDocumentUrl = async key => {
    var _nocDocuments$filter$;
    const currentDocId = nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$filter$ = nocDocuments.filter(doc => doc.documentType === key)[0]) === null || _nocDocuments$filter$ === void 0 ? void 0 : _nocDocuments$filter$.fileStoreId;
    const docUrl = await getDocumentByFileStoreId(currentDocId, setIsPreviewLoading);
    console.log("docUrlFromNew", docUrl);
  };
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const Modal = useModal();
  const isEmployee = role === "EMPLOYEE";
  const isCitizen = role === "CITIZEN";
  const isViewCitizen = role === "VIEW_CITIZEN";
  const isApprovedCitizen = role === "APPROVED_CITIZEN";
  const isMapSubEmployee = role === "MAP_SUB_EMPLOYEE";
  const isMapSubEmployeeSelect = role === "MAP_SUB_EMPLOYEE_SELECT";
  const storedData = JSON.parse(sessionStorage.getItem("landUseNocData"));
  const defaultValues = {
    ...((storedData === null || storedData === void 0 ? void 0 : storedData.nocDetails) || {
      ...(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.applicantNOCData)
    })
  };
  const {
    control,
    setValue,
    getValues,
    handleSubmit
  } = useForm({
    defaultValues
  });
  const [additionalInputs, setAdditionalInputs] = useState([{
    value: ""
  }]);
  const [showNocInput, setShowNocInput] = useState(false);
  const [showMapSubInput, setMapSubInput] = useState(false);
  const [additionalOfficerInputs, setAdditionalOfficerInputs] = useState([]);
  const [showOfficerNocInput, setShowOfficerNocInput] = useState(false);
  const [checked, setChecked] = React__default.useState(false);
  const nocDetails = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.applicantNOCData;
  const officerNocData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : _formData$nocDetails3.officerNOCData;
  const additionalApplicantNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails4 = formData.nocDetails) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.additionalApplicantNOC;
  const additionalOfficerNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails5 = formData.nocDetails) === null || _formData$nocDetails5 === void 0 ? void 0 : _formData$nocDetails5.additionalOfficerNOC;
  const checkedByOfficer = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails6 = formData.nocDetails) === null || _formData$nocDetails6 === void 0 ? void 0 : _formData$nocDetails6.checkedByOfficer;
  const nocApplicantData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails7 = formData.nocDetails) === null || _formData$nocDetails7 === void 0 ? void 0 : _formData$nocDetails7.applicantNOCData;
  const additionalNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails8 = formData.nocDetails) === null || _formData$nocDetails8 === void 0 ? void 0 : _formData$nocDetails8.additionalApplicantNOC;
  const declarationMessage2 = "I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete.";
  console.log({
    nocDetails,
    officerNocData,
    additionalApplicantNOC,
    additionalOfficerNOC,
    checkedByOfficer,
    nocApplicantData,
    additionalNOC
  });
  const getQuestionName = (role, question) => {
    return isEmployee || isMapSubEmployeeSelect ? question.employeeName : question.applicantName;
  };
  const handleCheckboxChange = (name, value) => {
    const updatedValues = {
      ...getValues(),
      [name]: value
    };
    console.log("checkBocChangedCalled", updatedValues);
    sessionStorage.setItem("landUseNocData", JSON.stringify({
      nocDetails: updatedValues,
      nocDetailsApplicant: additionalInputs,
      nocDetailsOfficer: additionalOfficerInputs
    }));
  };
  const handleAddInput = () => {
    setShowNocInput(true);
  };
  const handleAddOfficerInput = () => {
    setShowOfficerNocInput(true);
  };
  const handleChangeCheckBox = event => {
    setChecked(event.target.checked);
  };
  const handleRemoveNoc = index => {
    const updatedInputs = additionalInputs.filter((_, i) => i !== index);
    setAdditionalInputs(updatedInputs);
    sessionStorage.setItem("landUseNocData", JSON.stringify({
      nocDetails: getValues(),
      nocDetailsApplicant: updatedInputs,
      nocDetailsOfficer: additionalOfficerInputs
    }));
  };
  const handleRemoveOfficerNoc = index => {
    const updatedInputs = additionalOfficerInputs.filter((_, i) => i !== index);
    setAdditionalOfficerInputs(updatedInputs);
    sessionStorage.setItem("landUseNocData", JSON.stringify({
      nocDetails: getValues(),
      nocDetailsApplicant: additionalInputs,
      nocDetailsOfficer: updatedInputs
    }));
  };
  const handleSaveNoc = () => {
    const newNoc = getValues("additional-noc");
    if (newNoc.trim()) {
      const updatedNocs = [...additionalInputs, {
        value: newNoc
      }];
      setAdditionalInputs(updatedNocs);
      setValue("additional-noc", "");
      setShowNocInput(false);
      sessionStorage.setItem("landUseNocData", JSON.stringify({
        nocDetails: getValues(),
        nocDetailsApplicant: updatedNocs,
        nocDetailsOfficer: additionalOfficerInputs
      }));
    }
  };
  const handleSaveOfficerNoc = () => {
    const newOfficerNoc = getValues("additional-officer-noc");
    if (newOfficerNoc.trim()) {
      const updatedOfficerNocs = [...additionalOfficerInputs, {
        value: newOfficerNoc
      }];
      setAdditionalOfficerInputs(updatedOfficerNocs);
      setValue("additional-officer-noc", "");
      setShowOfficerNocInput(false);
      sessionStorage.setItem("landUseNocData", JSON.stringify({
        nocDetails: getValues(),
        nocDetailsApplicant: additionalInputs,
        nocDetailsOfficer: updatedOfficerNocs
      }));
    }
  };
  const handleSaveMapSubOfficerNoc = () => {
    const newOfficerNoc = getValues("additional-officer-noc");
    if (newOfficerNoc.trim()) {
      const updatedOfficerNocs = [...additionalOfficerInputs, {
        value: newOfficerNoc
      }];
      setAdditionalOfficerInputs(updatedOfficerNocs);
      setValue("additional-officer-noc", "");
      setMapSubInput(false);
      sessionStorage.setItem("landUseNocData", JSON.stringify({
        nocDetails: getValues(),
        nocDetailsApplicant: additionalInputs,
        nocDetailsOfficer: updatedOfficerNocs
      }));
    }
  };
  const handleAddMapSubNoc = () => {
    setMapSubInput(true);
  };
  const getCheckedValues = () => {
    var _formData$nocDetails9, _formData$nocDetails10;
    const checkedValues = [];
    formData === null || formData === void 0 ? void 0 : (_formData$nocDetails9 = formData.nocDetails) === null || _formData$nocDetails9 === void 0 ? void 0 : (_formData$nocDetails10 = _formData$nocDetails9.additionalApplicantNOC) === null || _formData$nocDetails10 === void 0 ? void 0 : _formData$nocDetails10.forEach((item, index) => {
      const checkedValue = getValues(`officer-input-${index}`);
      if (checkedValue) {
        checkedValues.push({
          value: item.value
        });
      }
    });
    return checkedValues;
  };
  const onSubmit = data => {
    console.log("dataFromLandUSeSubmit", data);
    if (isCitizen) {
      const isNoNOC = !Object.keys(data).some(key => data[key] == true);
      const isAddedNoc = (additionalInputs === null || additionalInputs === void 0 ? void 0 : additionalInputs.length) > 0 || (additionalOfficerInputs === null || additionalOfficerInputs === void 0 ? void 0 : additionalOfficerInputs.length) > 0;
      if (isNoNOC && !isAddedNoc) {
        Modal("NOC required", "Please select at least one NOC.", "error");
        return;
      }
      sessionStorage.setItem("landUseNocData", JSON.stringify(data));
      data = {
        ...formData,
        nocDetails: {
          applicantNOCData: {
            ...data
          },
          additionalApplicantNOC: additionalInputs
        }
      };
      console.log("dataFromEMplyee", data);
      handleTabChange(1, data);
    } else if (isMapSubEmployeeSelect) {
      const extraNoc = Object.keys(data).filter(key => key.endsWith("Employee") && data[key] === true);
      setMapSubNocDetails(prev => {
        return {
          ...prev,
          mapSubOfficerNoc: extraNoc,
          mapSubAdditionalOfficerNoc: additionalOfficerInputs
        };
      });
      console.log(" ", extraNoc, additionalOfficerInputs);
    } else {
      const isNoNOC = !Object.keys(data).some(key => key.endsWith("Employee") && data[key] === true);
      const isAddedNoc = (additionalInputs === null || additionalInputs === void 0 ? void 0 : additionalInputs.length) > 0 || (additionalOfficerInputs === null || additionalOfficerInputs === void 0 ? void 0 : additionalOfficerInputs.length) > 0;
      console.log("LandUseNoc", isNoNOC, isAddedNoc, data);
      if (isNoNOC && !isAddedNoc) {
        Modal("NOC required", "Please select at least one NOC.", "error");
        setIsNoNoc(true);
        return;
      }
      setIsNoNoc(false);
      sessionStorage.setItem("landUseNocData", JSON.stringify(data));
      console.log("valuesCheckedByofficer", getCheckedValues());
      const checkedValues = getCheckedValues();
      console.log("dataFromEMplyee", data);
      setOfficerNocDetails(prev => {
        return {
          ...prev,
          additionalOfficerNOC: additionalOfficerInputs,
          checkedByOfficer: checkedValues,
          officerNOCData: data
        };
      });
      handleNoWorkflowNoc({
        ...(formData === null || formData === void 0 ? void 0 : formData.nocDetails),
        additionalOfficerNOC: additionalOfficerInputs,
        checkedByOfficer: checkedValues,
        officerNOCData: data
      });
      Modal("Checklist saved", "Checklist details are saved.", "success");
      setCurrentTab(0);
    }
  };
  useEffect(() => {
    const savedNocs = (storedData === null || storedData === void 0 ? void 0 : storedData.nocDetailsApplicant) || (formData === null || formData === void 0 ? void 0 : formData.nocDetailsApplicant) || [];
    setAdditionalInputs(savedNocs);
    const savedOfficerNocs = (storedData === null || storedData === void 0 ? void 0 : storedData.nocDetailsOfficer) || (formData === null || formData === void 0 ? void 0 : formData.nocDetailsOfficer) || [];
    setAdditionalOfficerInputs(savedOfficerNocs);
  }, []);
  if (isLowRiskCase) {
    return /*#__PURE__*/React__default.createElement(LowRiskDisclaimer, {
      handleTabChange: handleTabChange,
      tab: 1
    });
  }
  if (isViewCitizen && !(Boolean(nocDetails) || Boolean(additionalApplicantNOC))) {
    return /*#__PURE__*/React__default.createElement("div", null, "Please fill NOC details.");
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    className: "formContainer",
    onSubmit: handleSubmit(onSubmit)
  }, isEmployee && /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#f5f5f5",
      padding: "10px",
      borderRadius: "5px",
      color: "#333",
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Please note:"), " The NOCs selected by the officer will be considered the final required NOCs for approval. Make sure to review the list carefully.")), /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "formHeaderContainer",
    onChange: handleCheckboxChange
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "NOC Checklist"), isCitizen && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Please tick, if required"), (isApprovedCitizen || isViewCitizen) && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Your Inputs"), isEmployee && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Applicant Inputs"), isMapSubEmployeeSelect && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "NOC Attached"), (isEmployee || isApprovedCitizen || isMapSubEmployee || isMapSubEmployeeSelect) && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Officer Input"), isMapSubEmployee && /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "File"))), /*#__PURE__*/React__default.createElement("tbody", null, questions.map((question, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, isMapSubEmployee && (officerNocData === null || officerNocData === void 0 ? void 0 : officerNocData[question.employeeName]) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, question.label)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, " ", "Yes", " "), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, " ", /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => getDocumentUrl(question === null || question === void 0 ? void 0 : question.applicantName)
  }))), !isMapSubEmployee && !isViewCitizen && /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, question.label), isMapSubEmployeeSelect && (officerNocData !== null && officerNocData !== void 0 && officerNocData[question.employeeName] ? /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, " ", "Yes", " ") : /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, " ", "No", " ")), isMapSubEmployeeSelect && (officerNocData !== null && officerNocData !== void 0 && officerNocData[question.employeeName] ? /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, " ", "-", " ") : /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: getQuestionName(role, question),
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  }))), isCitizen ? /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: getQuestionName(role, question),
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })) : isEmployee ? /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, nocDetails !== null && nocDetails !== void 0 && nocDetails[question === null || question === void 0 ? void 0 : question.applicantName] ? "Yes" : "No") : isApprovedCitizen ? /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, nocDetails !== null && nocDetails !== void 0 && nocDetails[question === null || question === void 0 ? void 0 : question.applicantName] ? "Yes" : "No") : null, isApprovedCitizen && /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, " ", officerNocData !== null && officerNocData !== void 0 && officerNocData[question.employeeName] ? "Yes" : "No", " "), isEmployee && /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: `${getQuestionName(role, question)}`,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })))), isViewCitizen && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, questions.filter(questionItem => (nocApplicantData === null || nocApplicantData === void 0 ? void 0 : nocApplicantData[questionItem.applicantName]) === true).map((questionItem, index) => {
    const {
      label,
      applicantName
    } = questionItem;
    const answer = nocApplicantData !== null && nocApplicantData !== void 0 && nocApplicantData[applicantName] ? "Yes" : "No";
    return /*#__PURE__*/React__default.createElement("tr", {
      key: `q-${index}`
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, answer));
  }), additionalNOC === null || additionalNOC === void 0 ? void 0 : additionalNOC.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: `a-${index}`
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "70%",
      textAlign: "left",
      padding: "8px"
    }
  }, item.value), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "30%",
      textAlign: "center",
      padding: "8px"
    }
  }, "Yes")))), isApprovedCitizen && (additionalApplicantNOC === null || additionalApplicantNOC === void 0 ? void 0 : additionalApplicantNOC.map((item, index) => {
    return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "4px 4px 4px 8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center",
        padding: "4px"
      }
    }, "Yes"), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center",
        padding: "4px"
      }
    }, checkedByOfficer !== null && checkedByOfficer !== void 0 && checkedByOfficer.some(checkedItem => checkedItem.value === item.value) ? "Yes" : "No"));
  })), isApprovedCitizen && (additionalOfficerNOC === null || additionalOfficerNOC === void 0 ? void 0 : additionalOfficerNOC.map(item => {
    return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "4px 4px 4px 8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center",
        padding: "4px"
      }
    }, "No"), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center",
        padding: "4px"
      }
    }, "Yes"));
  })), isEmployee && (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails11 = formData.nocDetails) === null || _formData$nocDetails11 === void 0 ? void 0 : (_formData$nocDetails12 = _formData$nocDetails11.additionalApplicantNOC) === null || _formData$nocDetails12 === void 0 ? void 0 : _formData$nocDetails12.map((item, index) => /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, item.value), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, "Yes"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: `officer-input-${index}`,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  }))))), isCitizen && (additionalInputs === null || additionalInputs === void 0 ? void 0 : additionalInputs.length) > 0 && (additionalInputs === null || additionalInputs === void 0 ? void 0 : additionalInputs.map((input, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: `additional-${index}`
  }, /*#__PURE__*/React__default.createElement("td", null, input.value), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "danger",
    size: "sm",
    onClick: () => handleRemoveNoc(index),
    style: {
      backgroundColor: "rgb(255, 0, 0)"
    }
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))))), isEmployee && (additionalOfficerInputs === null || additionalOfficerInputs === void 0 ? void 0 : additionalOfficerInputs.length) > 0 && additionalOfficerInputs.map((input, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: `officer-additional-${index}`
  }, /*#__PURE__*/React__default.createElement("td", null, input.value), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    },
    colSpan: 2
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "danger",
    size: "sm",
    onClick: () => handleRemoveOfficerNoc(index),
    style: {
      backgroundColor: "rgb(255, 0, 0)"
    }
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))))), isMapSubEmployeeSelect && (additionalOfficerInputs === null || additionalOfficerInputs === void 0 ? void 0 : additionalOfficerInputs.length) > 0 && additionalOfficerInputs.map((input, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: `officer-additional-${index}`
  }, /*#__PURE__*/React__default.createElement("td", null, input.value), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    },
    colSpan: 2
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "danger",
    size: "sm",
    onClick: () => handleRemoveOfficerNoc(index),
    style: {
      backgroundColor: "rgb(255, 0, 0)"
    }
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))))), showNocInput && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "textInput",
    placeholder: "Enter new NOC",
    control: control,
    name: "additional-noc",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "success",
    size: "sm",
    onClick: handleSaveNoc,
    style: {
      backgroundColor: "rgb(21, 124, 179)"
    }
  }, "Save NOC"))), showMapSubInput && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "textInput",
    placeholder: "Enter new NOC",
    control: control,
    name: "additional-officer-noc",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    },
    colSpan: 2
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "success",
    size: "sm",
    onClick: handleSaveMapSubOfficerNoc,
    style: {
      backgroundColor: "rgb(21, 124, 179)"
    }
  }, "Save NOC"))), isEmployee && showOfficerNocInput && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "textInput",
    placeholder: "Enter NOC details",
    control: control,
    name: "additional-officer-noc",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    },
    colSpan: 2
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "success",
    size: "sm",
    onClick: handleSaveOfficerNoc,
    style: {
      backgroundColor: "rgb(21, 124, 179)"
    }
  }, "Save NOC"))))), !isCitizen && !isViewCitizen && !isApprovedCitizen && !isMapSubEmployee && /*#__PURE__*/React__default.createElement(CheckBox, {
    handleChangeCheckBox: handleChangeCheckBox,
    declarationMessage: declarationMessage2,
    checked: checked
  }), !isApprovedCitizen && !isMapSubEmployee && !isViewCitizen && /*#__PURE__*/React__default.createElement("div", {
    style: {
      float: "right"
    }
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      borderRadius: "24px",
      marginRight: "36px"
    },
    onClick: isEmployee ? handleAddOfficerInput : isMapSubEmployeeSelect ? handleAddMapSubNoc : handleAddInput
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon, null), "Add More"))), !isApprovedCitizen && !isMapSubEmployee && !isViewCitizen && (!isEmployee || isEmployee && checked) && (!isMapSubEmployeeSelect || isMapSubEmployeeSelect && checked) && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, isCitizen && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  })))));
};

var sweetalert2_all = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function _assertClassBrand(e, t, n) {
      if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
      throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
      if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
      return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
      _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
      return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    const globalState = {};
    const focusPreviousActiveElement = () => {
      if (globalState.previousActiveElement instanceof HTMLElement) {
        globalState.previousActiveElement.focus();
        globalState.previousActiveElement = null;
      } else if (document.body) {
        document.body.focus();
      }
    };
    const restoreActiveElement = returnFocus => {
      return new Promise(resolve => {
        if (!returnFocus) {
          return resolve();
        }
        const x = window.scrollX;
        const y = window.scrollY;
        globalState.restoreFocusTimeout = setTimeout(() => {
          focusPreviousActiveElement();
          resolve();
        }, RESTORE_FOCUS_TIMEOUT);
        window.scrollTo(x, y);
      });
    };
    const swalPrefix = 'swal2-';
    const classNames = ['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'show', 'hide', 'close', 'title', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'default-outline', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error'];
    const swalClasses = classNames.reduce((acc, className) => {
      acc[className] = swalPrefix + className;
      return acc;
    }, {});
    const icons = ['success', 'warning', 'info', 'question', 'error'];
    const iconTypes = icons.reduce((acc, icon) => {
      acc[icon] = swalPrefix + icon;
      return acc;
    }, {});
    const consolePrefix = 'SweetAlert2:';
    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);
    const warn = message => {
      console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    const error = message => {
      console.error(`${consolePrefix} ${message}`);
    };
    const previousWarnOnceMessages = [];
    const warnOnce = message => {
      if (!previousWarnOnceMessages.includes(message)) {
        previousWarnOnceMessages.push(message);
        warn(message);
      }
    };
    const warnAboutDeprecation = function (deprecatedParam) {
      let useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    const callIfFunction = arg => typeof arg === 'function' ? arg() : arg;
    const hasToPromiseFn = arg => arg && typeof arg.toPromise === 'function';
    const asPromise = arg => hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    const isPromise = arg => arg && Promise.resolve(arg) === arg;
    const getContainer = () => document.body.querySelector(`.${swalClasses.container}`);
    const elementBySelector = selectorString => {
      const container = getContainer();
      return container ? container.querySelector(selectorString) : null;
    };
    const elementByClass = className => {
      return elementBySelector(`.${className}`);
    };
    const getPopup = () => elementByClass(swalClasses.popup);
    const getIcon = () => elementByClass(swalClasses.icon);
    const getIconContent = () => elementByClass(swalClasses['icon-content']);
    const getTitle = () => elementByClass(swalClasses.title);
    const getHtmlContainer = () => elementByClass(swalClasses['html-container']);
    const getImage = () => elementByClass(swalClasses.image);
    const getProgressSteps = () => elementByClass(swalClasses['progress-steps']);
    const getValidationMessage = () => elementByClass(swalClasses['validation-message']);
    const getConfirmButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`));
    const getCancelButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`));
    const getDenyButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`));
    const getInputLabel = () => elementByClass(swalClasses['input-label']);
    const getLoader = () => elementBySelector(`.${swalClasses.loader}`);
    const getActions = () => elementByClass(swalClasses.actions);
    const getFooter = () => elementByClass(swalClasses.footer);
    const getTimerProgressBar = () => elementByClass(swalClasses['timer-progress-bar']);
    const getCloseButton = () => elementByClass(swalClasses.close);
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    const getFocusableElements = () => {
      const popup = getPopup();
      if (!popup) {
        return [];
      }
      const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
      const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex).sort((a, b) => {
        const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
        const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
        if (tabindexA > tabindexB) {
          return 1;
        } else if (tabindexA < tabindexB) {
          return -1;
        }
        return 0;
      });
      const otherFocusableElements = popup.querySelectorAll(focusable);
      const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter(el => el.getAttribute('tabindex') !== '-1');
      return [...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))].filter(el => isVisible$1(el));
    };
    const isModal = () => {
      return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    const isToast = () => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      return hasClass(popup, swalClasses.toast);
    };
    const isLoading = () => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      return popup.hasAttribute('data-loading');
    };
    const setInnerHtml = (elem, html) => {
      elem.textContent = '';
      if (html) {
        const parser = new DOMParser();
        const parsed = parser.parseFromString(html, `text/html`);
        const head = parsed.querySelector('head');
        if (head) {
          Array.from(head.childNodes).forEach(child => {
            elem.appendChild(child);
          });
        }
        const body = parsed.querySelector('body');
        if (body) {
          Array.from(body.childNodes).forEach(child => {
            if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) {
              elem.appendChild(child.cloneNode(true));
            } else {
              elem.appendChild(child);
            }
          });
        }
      }
    };
    const hasClass = (elem, className) => {
      if (!className) {
        return false;
      }
      const classList = className.split(/\s+/);
      for (let i = 0; i < classList.length; i++) {
        if (!elem.classList.contains(classList[i])) {
          return false;
        }
      }
      return true;
    };
    const removeCustomClasses = (elem, params) => {
      Array.from(elem.classList).forEach(className => {
        if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) {
          elem.classList.remove(className);
        }
      });
    };
    const applyCustomClass = (elem, params, className) => {
      removeCustomClasses(elem, params);
      if (!params.customClass) {
        return;
      }
      const customClass = params.customClass[(className)];
      if (!customClass) {
        return;
      }
      if (typeof customClass !== 'string' && !customClass.forEach) {
        warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
        return;
      }
      addClass(elem, customClass);
    };
    const getInput$1 = (popup, inputClass) => {
      if (!inputClass) {
        return null;
      }
      switch (inputClass) {
        case 'select':
        case 'textarea':
        case 'file':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
        case 'checkbox':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
        case 'radio':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
        case 'range':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
        default:
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
      }
    };
    const focusInput = input => {
      input.focus();
      if (input.type !== 'file') {
        const val = input.value;
        input.value = '';
        input.value = val;
      }
    };
    const toggleClass = (target, classList, condition) => {
      if (!target || !classList) {
        return;
      }
      if (typeof classList === 'string') {
        classList = classList.split(/\s+/).filter(Boolean);
      }
      classList.forEach(className => {
        if (Array.isArray(target)) {
          target.forEach(elem => {
            if (condition) {
              elem.classList.add(className);
            } else {
              elem.classList.remove(className);
            }
          });
        } else {
          if (condition) {
            target.classList.add(className);
          } else {
            target.classList.remove(className);
          }
        }
      });
    };
    const addClass = (target, classList) => {
      toggleClass(target, classList, true);
    };
    const removeClass = (target, classList) => {
      toggleClass(target, classList, false);
    };
    const getDirectChildByClass = (elem, className) => {
      const children = Array.from(elem.children);
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child instanceof HTMLElement && hasClass(child, className)) {
          return child;
        }
      }
    };
    const applyNumericalStyle = (elem, property, value) => {
      if (value === `${parseInt(value)}`) {
        value = parseInt(value);
      }
      if (value || parseInt(value) === 0) {
        elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : value);
      } else {
        elem.style.removeProperty(property);
      }
    };
    const show = function (elem) {
      let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
      if (!elem) {
        return;
      }
      elem.style.display = display;
    };
    const hide = elem => {
      if (!elem) {
        return;
      }
      elem.style.display = 'none';
    };
    const showWhenInnerHtmlPresent = function (elem) {
      let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
      if (!elem) {
        return;
      }
      new MutationObserver(() => {
        toggle(elem, elem.innerHTML, display);
      }).observe(elem, {
        childList: true,
        subtree: true
      });
    };
    const setStyle = (parent, selector, property, value) => {
      const el = parent.querySelector(selector);
      if (el) {
        el.style.setProperty(property, value);
      }
    };
    const toggle = function (elem, condition) {
      let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
      if (condition) {
        show(elem, display);
      } else {
        hide(elem);
      }
    };
    const isVisible$1 = elem => !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    const allButtonsAreHidden = () => !isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    const isScrollable = elem => !!(elem.scrollHeight > elem.clientHeight);
    const hasCssAnimation = elem => {
      const style = window.getComputedStyle(elem);
      const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
      const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
      return animDuration > 0 || transDuration > 0;
    };
    const animateTimerProgressBar = function (timer) {
      let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const timerProgressBar = getTimerProgressBar();
      if (!timerProgressBar) {
        return;
      }
      if (isVisible$1(timerProgressBar)) {
        if (reset) {
          timerProgressBar.style.transition = 'none';
          timerProgressBar.style.width = '100%';
        }
        setTimeout(() => {
          timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
          timerProgressBar.style.width = '0%';
        }, 10);
      }
    };
    const stopTimerProgressBar = () => {
      const timerProgressBar = getTimerProgressBar();
      if (!timerProgressBar) {
        return;
      }
      const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
      timerProgressBar.style.removeProperty('transition');
      timerProgressBar.style.width = '100%';
      const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
      const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
      timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    const isNodeEnv = () => typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    const resetOldContainer = () => {
      const oldContainer = getContainer();
      if (!oldContainer) {
        return false;
      }
      oldContainer.remove();
      removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
      return true;
    };
    const resetValidationMessage$1 = () => {
      globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = () => {
      const popup = getPopup();
      const input = getDirectChildByClass(popup, swalClasses.input);
      const file = getDirectChildByClass(popup, swalClasses.file);
      const range = popup.querySelector(`.${swalClasses.range} input`);
      const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
      const select = getDirectChildByClass(popup, swalClasses.select);
      const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
      const textarea = getDirectChildByClass(popup, swalClasses.textarea);
      input.oninput = resetValidationMessage$1;
      file.onchange = resetValidationMessage$1;
      select.onchange = resetValidationMessage$1;
      checkbox.onchange = resetValidationMessage$1;
      textarea.oninput = resetValidationMessage$1;
      range.oninput = () => {
        resetValidationMessage$1();
        rangeOutput.value = range.value;
      };
      range.onchange = () => {
        resetValidationMessage$1();
        rangeOutput.value = range.value;
      };
    };
    const getTarget = target => typeof target === 'string' ? document.querySelector(target) : target;
    const setupAccessibility = params => {
      const popup = getPopup();
      popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
      popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
      if (!params.toast) {
        popup.setAttribute('aria-modal', 'true');
      }
    };
    const setupRTL = targetElement => {
      if (window.getComputedStyle(targetElement).direction === 'rtl') {
        addClass(getContainer(), swalClasses.rtl);
      }
    };
    const init = params => {
      const oldContainerExisted = resetOldContainer();
      if (isNodeEnv()) {
        error('SweetAlert2 requires document to initialize');
        return;
      }
      const container = document.createElement('div');
      container.className = swalClasses.container;
      if (oldContainerExisted) {
        addClass(container, swalClasses['no-transition']);
      }
      setInnerHtml(container, sweetHTML);
      const targetElement = getTarget(params.target);
      targetElement.appendChild(container);
      setupAccessibility(params);
      setupRTL(targetElement);
      addInputChangeListeners();
    };
    const parseHtmlToContainer = (param, target) => {
      if (param instanceof HTMLElement) {
        target.appendChild(param);
      } else if (typeof param === 'object') {
        handleObject(param, target);
      } else if (param) {
        setInnerHtml(target, param);
      }
    };
    const handleObject = (param, target) => {
      if (param.jquery) {
        handleJqueryElem(target, param);
      } else {
        setInnerHtml(target, param.toString());
      }
    };
    const handleJqueryElem = (target, elem) => {
      target.textContent = '';
      if (0 in elem) {
        for (let i = 0; i in elem; i++) {
          target.appendChild(elem[i].cloneNode(true));
        }
      } else {
        target.appendChild(elem.cloneNode(true));
      }
    };
    const animationEndEvent = (() => {
      if (isNodeEnv()) {
        return false;
      }
      const testEl = document.createElement('div');
      if (typeof testEl.style.webkitAnimation !== 'undefined') {
        return 'webkitAnimationEnd';
      }
      if (typeof testEl.style.animation !== 'undefined') {
        return 'animationend';
      }
      return false;
    })();
    const renderActions = (instance, params) => {
      const actions = getActions();
      const loader = getLoader();
      if (!actions || !loader) {
        return;
      }
      if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
        hide(actions);
      } else {
        show(actions);
      }
      applyCustomClass(actions, params, 'actions');
      renderButtons(actions, loader, params);
      setInnerHtml(loader, params.loaderHtml || '');
      applyCustomClass(loader, params, 'loader');
    };
    function renderButtons(actions, loader, params) {
      const confirmButton = getConfirmButton();
      const denyButton = getDenyButton();
      const cancelButton = getCancelButton();
      if (!confirmButton || !denyButton || !cancelButton) {
        return;
      }
      renderButton(confirmButton, 'confirm', params);
      renderButton(denyButton, 'deny', params);
      renderButton(cancelButton, 'cancel', params);
      handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
      if (params.reverseButtons) {
        if (params.toast) {
          actions.insertBefore(cancelButton, confirmButton);
          actions.insertBefore(denyButton, confirmButton);
        } else {
          actions.insertBefore(cancelButton, loader);
          actions.insertBefore(denyButton, loader);
          actions.insertBefore(confirmButton, loader);
        }
      }
    }
    function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
      if (!params.buttonsStyling) {
        removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
        return;
      }
      addClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
      if (params.confirmButtonColor) {
        confirmButton.style.backgroundColor = params.confirmButtonColor;
        addClass(confirmButton, swalClasses['default-outline']);
      }
      if (params.denyButtonColor) {
        denyButton.style.backgroundColor = params.denyButtonColor;
        addClass(denyButton, swalClasses['default-outline']);
      }
      if (params.cancelButtonColor) {
        cancelButton.style.backgroundColor = params.cancelButtonColor;
        addClass(cancelButton, swalClasses['default-outline']);
      }
    }
    function renderButton(button, buttonType, params) {
      const buttonName = capitalizeFirstLetter(buttonType);
      toggle(button, params[`show${buttonName}Button`], 'inline-block');
      setInnerHtml(button, params[`${buttonType}ButtonText`] || '');
      button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || '');
      button.className = swalClasses[buttonType];
      applyCustomClass(button, params, `${buttonType}Button`);
    }
    const renderCloseButton = (instance, params) => {
      const closeButton = getCloseButton();
      if (!closeButton) {
        return;
      }
      setInnerHtml(closeButton, params.closeButtonHtml || '');
      applyCustomClass(closeButton, params, 'closeButton');
      toggle(closeButton, params.showCloseButton);
      closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    const renderContainer = (instance, params) => {
      const container = getContainer();
      if (!container) {
        return;
      }
      handleBackdropParam(container, params.backdrop);
      handlePositionParam(container, params.position);
      handleGrowParam(container, params.grow);
      applyCustomClass(container, params, 'container');
    };
    function handleBackdropParam(container, backdrop) {
      if (typeof backdrop === 'string') {
        container.style.background = backdrop;
      } else if (!backdrop) {
        addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
      }
    }
    function handlePositionParam(container, position) {
      if (!position) {
        return;
      }
      if (position in swalClasses) {
        addClass(container, swalClasses[position]);
      } else {
        warn('The "position" parameter is not valid, defaulting to "center"');
        addClass(container, swalClasses.center);
      }
    }
    function handleGrowParam(container, grow) {
      if (!grow) {
        return;
      }
      addClass(container, swalClasses[`grow-${grow}`]);
    }
    var privateProps = {
      innerParams: new WeakMap(),
      domCache: new WeakMap()
    };
    const inputClasses = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
    const renderInput = (instance, params) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const innerParams = privateProps.innerParams.get(instance);
      const rerender = !innerParams || params.input !== innerParams.input;
      inputClasses.forEach(inputClass => {
        const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
        if (!inputContainer) {
          return;
        }
        setAttributes(inputClass, params.inputAttributes);
        inputContainer.className = swalClasses[inputClass];
        if (rerender) {
          hide(inputContainer);
        }
      });
      if (params.input) {
        if (rerender) {
          showInput(params);
        }
        setCustomClass(params);
      }
    };
    const showInput = params => {
      if (!params.input) {
        return;
      }
      if (!renderInputType[params.input]) {
        error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
        return;
      }
      const inputContainer = getInputContainer(params.input);
      if (!inputContainer) {
        return;
      }
      const input = renderInputType[params.input](inputContainer, params);
      show(inputContainer);
      if (params.inputAutoFocus) {
        setTimeout(() => {
          focusInput(input);
        });
      }
    };
    const removeAttributes = input => {
      for (let i = 0; i < input.attributes.length; i++) {
        const attrName = input.attributes[i].name;
        if (!['id', 'type', 'value', 'style'].includes(attrName)) {
          input.removeAttribute(attrName);
        }
      }
    };
    const setAttributes = (inputClass, inputAttributes) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const input = getInput$1(popup, inputClass);
      if (!input) {
        return;
      }
      removeAttributes(input);
      for (const attr in inputAttributes) {
        input.setAttribute(attr, inputAttributes[attr]);
      }
    };
    const setCustomClass = params => {
      if (!params.input) {
        return;
      }
      const inputContainer = getInputContainer(params.input);
      if (inputContainer) {
        applyCustomClass(inputContainer, params, 'input');
      }
    };
    const setInputPlaceholder = (input, params) => {
      if (!input.placeholder && params.inputPlaceholder) {
        input.placeholder = params.inputPlaceholder;
      }
    };
    const setInputLabel = (input, prependTo, params) => {
      if (params.inputLabel) {
        const label = document.createElement('label');
        const labelClass = swalClasses['input-label'];
        label.setAttribute('for', input.id);
        label.className = labelClass;
        if (typeof params.customClass === 'object') {
          addClass(label, params.customClass.inputLabel);
        }
        label.innerText = params.inputLabel;
        prependTo.insertAdjacentElement('beforebegin', label);
      }
    };
    const getInputContainer = inputType => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      return getDirectChildByClass(popup, swalClasses[(inputType)] || swalClasses.input);
    };
    const checkAndSetInputValue = (input, inputValue) => {
      if (['string', 'number'].includes(typeof inputValue)) {
        input.value = `${inputValue}`;
      } else if (!isPromise(inputValue)) {
        warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
      }
    };
    const renderInputType = {};
    renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = (input, params) => {
      checkAndSetInputValue(input, params.inputValue);
      setInputLabel(input, input, params);
      setInputPlaceholder(input, params);
      input.type = params.input;
      return input;
    };
    renderInputType.file = (input, params) => {
      setInputLabel(input, input, params);
      setInputPlaceholder(input, params);
      return input;
    };
    renderInputType.range = (range, params) => {
      const rangeInput = range.querySelector('input');
      const rangeOutput = range.querySelector('output');
      checkAndSetInputValue(rangeInput, params.inputValue);
      rangeInput.type = params.input;
      checkAndSetInputValue(rangeOutput, params.inputValue);
      setInputLabel(rangeInput, range, params);
      return range;
    };
    renderInputType.select = (select, params) => {
      select.textContent = '';
      if (params.inputPlaceholder) {
        const placeholder = document.createElement('option');
        setInnerHtml(placeholder, params.inputPlaceholder);
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);
      }
      setInputLabel(select, select, params);
      return select;
    };
    renderInputType.radio = radio => {
      radio.textContent = '';
      return radio;
    };
    renderInputType.checkbox = (checkboxContainer, params) => {
      const checkbox = getInput$1(getPopup(), 'checkbox');
      checkbox.value = '1';
      checkbox.checked = Boolean(params.inputValue);
      const label = checkboxContainer.querySelector('span');
      setInnerHtml(label, params.inputPlaceholder || params.inputLabel);
      return checkbox;
    };
    renderInputType.textarea = (textarea, params) => {
      checkAndSetInputValue(textarea, params.inputValue);
      setInputPlaceholder(textarea, params);
      setInputLabel(textarea, textarea, params);
      const getMargin = el => parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
      setTimeout(() => {
        if ('MutationObserver' in window) {
          const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
          const textareaResizeHandler = () => {
            if (!document.body.contains(textarea)) {
              return;
            }
            const textareaWidth = textarea.offsetWidth + getMargin(textarea);
            if (textareaWidth > initialPopupWidth) {
              getPopup().style.width = `${textareaWidth}px`;
            } else {
              applyNumericalStyle(getPopup(), 'width', params.width);
            }
          };
          new MutationObserver(textareaResizeHandler).observe(textarea, {
            attributes: true,
            attributeFilter: ['style']
          });
        }
      });
      return textarea;
    };
    const renderContent = (instance, params) => {
      const htmlContainer = getHtmlContainer();
      if (!htmlContainer) {
        return;
      }
      showWhenInnerHtmlPresent(htmlContainer);
      applyCustomClass(htmlContainer, params, 'htmlContainer');
      if (params.html) {
        parseHtmlToContainer(params.html, htmlContainer);
        show(htmlContainer, 'block');
      } else if (params.text) {
        htmlContainer.textContent = params.text;
        show(htmlContainer, 'block');
      } else {
        hide(htmlContainer);
      }
      renderInput(instance, params);
    };
    const renderFooter = (instance, params) => {
      const footer = getFooter();
      if (!footer) {
        return;
      }
      showWhenInnerHtmlPresent(footer);
      toggle(footer, params.footer, 'block');
      if (params.footer) {
        parseHtmlToContainer(params.footer, footer);
      }
      applyCustomClass(footer, params, 'footer');
    };
    const renderIcon = (instance, params) => {
      const innerParams = privateProps.innerParams.get(instance);
      const icon = getIcon();
      if (!icon) {
        return;
      }
      if (innerParams && params.icon === innerParams.icon) {
        setContent(icon, params);
        applyStyles(icon, params);
        return;
      }
      if (!params.icon && !params.iconHtml) {
        hide(icon);
        return;
      }
      if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
        error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
        hide(icon);
        return;
      }
      show(icon);
      setContent(icon, params);
      applyStyles(icon, params);
      addClass(icon, params.showClass && params.showClass.icon);
    };
    const applyStyles = (icon, params) => {
      for (const [iconType, iconClassName] of Object.entries(iconTypes)) {
        if (params.icon !== iconType) {
          removeClass(icon, iconClassName);
        }
      }
      addClass(icon, params.icon && iconTypes[params.icon]);
      setColor(icon, params);
      adjustSuccessIconBackgroundColor();
      applyCustomClass(icon, params, 'icon');
    };
    const adjustSuccessIconBackgroundColor = () => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
      const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
      for (let i = 0; i < successIconParts.length; i++) {
        successIconParts[i].style.backgroundColor = popupBackgroundColor;
      }
    };
    const successIconHtml = `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    const setContent = (icon, params) => {
      if (!params.icon && !params.iconHtml) {
        return;
      }
      let oldContent = icon.innerHTML;
      let newContent = '';
      if (params.iconHtml) {
        newContent = iconContent(params.iconHtml);
      } else if (params.icon === 'success') {
        newContent = successIconHtml;
        oldContent = oldContent.replace(/ style=".*?"/g, '');
      } else if (params.icon === 'error') {
        newContent = errorIconHtml;
      } else if (params.icon) {
        const defaultIconHtml = {
          question: '?',
          warning: '!',
          info: 'i'
        };
        newContent = iconContent(defaultIconHtml[params.icon]);
      }
      if (oldContent.trim() !== newContent.trim()) {
        setInnerHtml(icon, newContent);
      }
    };
    const setColor = (icon, params) => {
      if (!params.iconColor) {
        return;
      }
      icon.style.color = params.iconColor;
      icon.style.borderColor = params.iconColor;
      for (const sel of ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right']) {
        setStyle(icon, sel, 'background-color', params.iconColor);
      }
      setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    const iconContent = content => `<div class="${swalClasses['icon-content']}">${content}</div>`;
    const renderImage = (instance, params) => {
      const image = getImage();
      if (!image) {
        return;
      }
      if (!params.imageUrl) {
        hide(image);
        return;
      }
      show(image, '');
      image.setAttribute('src', params.imageUrl);
      image.setAttribute('alt', params.imageAlt || '');
      applyNumericalStyle(image, 'width', params.imageWidth);
      applyNumericalStyle(image, 'height', params.imageHeight);
      image.className = swalClasses.image;
      applyCustomClass(image, params, 'image');
    };
    const renderPopup = (instance, params) => {
      const container = getContainer();
      const popup = getPopup();
      if (!container || !popup) {
        return;
      }
      if (params.toast) {
        applyNumericalStyle(container, 'width', params.width);
        popup.style.width = '100%';
        const loader = getLoader();
        if (loader) {
          popup.insertBefore(loader, getIcon());
        }
      } else {
        applyNumericalStyle(popup, 'width', params.width);
      }
      applyNumericalStyle(popup, 'padding', params.padding);
      if (params.color) {
        popup.style.color = params.color;
      }
      if (params.background) {
        popup.style.background = params.background;
      }
      hide(getValidationMessage());
      addClasses$1(popup, params);
    };
    const addClasses$1 = (popup, params) => {
      const showClass = params.showClass || {};
      popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
      if (params.toast) {
        addClass([document.documentElement, document.body], swalClasses['toast-shown']);
        addClass(popup, swalClasses.toast);
      } else {
        addClass(popup, swalClasses.modal);
      }
      applyCustomClass(popup, params, 'popup');
      if (typeof params.customClass === 'string') {
        addClass(popup, params.customClass);
      }
      if (params.icon) {
        addClass(popup, swalClasses[`icon-${params.icon}`]);
      }
    };
    const renderProgressSteps = (instance, params) => {
      const progressStepsContainer = getProgressSteps();
      if (!progressStepsContainer) {
        return;
      }
      const {
        progressSteps,
        currentProgressStep
      } = params;
      if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
        hide(progressStepsContainer);
        return;
      }
      show(progressStepsContainer);
      progressStepsContainer.textContent = '';
      if (currentProgressStep >= progressSteps.length) {
        warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
      }
      progressSteps.forEach((step, index) => {
        const stepEl = createStepElement(step);
        progressStepsContainer.appendChild(stepEl);
        if (index === currentProgressStep) {
          addClass(stepEl, swalClasses['active-progress-step']);
        }
        if (index !== progressSteps.length - 1) {
          const lineEl = createLineElement(params);
          progressStepsContainer.appendChild(lineEl);
        }
      });
    };
    const createStepElement = step => {
      const stepEl = document.createElement('li');
      addClass(stepEl, swalClasses['progress-step']);
      setInnerHtml(stepEl, step);
      return stepEl;
    };
    const createLineElement = params => {
      const lineEl = document.createElement('li');
      addClass(lineEl, swalClasses['progress-step-line']);
      if (params.progressStepsDistance) {
        applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
      }
      return lineEl;
    };
    const renderTitle = (instance, params) => {
      const title = getTitle();
      if (!title) {
        return;
      }
      showWhenInnerHtmlPresent(title);
      toggle(title, params.title || params.titleText, 'block');
      if (params.title) {
        parseHtmlToContainer(params.title, title);
      }
      if (params.titleText) {
        title.innerText = params.titleText;
      }
      applyCustomClass(title, params, 'title');
    };
    const render = (instance, params) => {
      renderPopup(instance, params);
      renderContainer(instance, params);
      renderProgressSteps(instance, params);
      renderIcon(instance, params);
      renderImage(instance, params);
      renderTitle(instance, params);
      renderCloseButton(instance, params);
      renderContent(instance, params);
      renderActions(instance, params);
      renderFooter(instance, params);
      const popup = getPopup();
      if (typeof params.didRender === 'function' && popup) {
        params.didRender(popup);
      }
      globalState.eventEmitter.emit('didRender', popup);
    };
    const isVisible = () => {
      return isVisible$1(getPopup());
    };
    const clickConfirm = () => {
      var _dom$getConfirmButton;
      return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    const clickDeny = () => {
      var _dom$getDenyButton;
      return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    const clickCancel = () => {
      var _dom$getCancelButton;
      return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    const DismissReason = Object.freeze({
      cancel: 'cancel',
      backdrop: 'backdrop',
      close: 'close',
      esc: 'esc',
      timer: 'timer'
    });
    const removeKeydownHandler = globalState => {
      if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
        globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
          capture: globalState.keydownListenerCapture
        });
        globalState.keydownHandlerAdded = false;
      }
    };
    const addKeydownHandler = (globalState, innerParams, dismissWith) => {
      removeKeydownHandler(globalState);
      if (!innerParams.toast) {
        globalState.keydownHandler = e => keydownHandler(innerParams, e, dismissWith);
        globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
        globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
        globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
          capture: globalState.keydownListenerCapture
        });
        globalState.keydownHandlerAdded = true;
      }
    };
    const setFocus = (index, increment) => {
      var _dom$getPopup;
      const focusableElements = getFocusableElements();
      if (focusableElements.length) {
        index = index + increment;
        if (index === focusableElements.length) {
          index = 0;
        } else if (index === -1) {
          index = focusableElements.length - 1;
        }
        focusableElements[index].focus();
        return;
      }
      (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = ['ArrowRight', 'ArrowDown'];
    const arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp'];
    const keydownHandler = (innerParams, event, dismissWith) => {
      if (!innerParams) {
        return;
      }
      if (event.isComposing || event.keyCode === 229) {
        return;
      }
      if (innerParams.stopKeydownPropagation) {
        event.stopPropagation();
      }
      if (event.key === 'Enter') {
        handleEnter(event, innerParams);
      } else if (event.key === 'Tab') {
        handleTab(event);
      } else if ([...arrowKeysNextButton, ...arrowKeysPreviousButton].includes(event.key)) {
        handleArrows(event.key);
      } else if (event.key === 'Escape') {
        handleEsc(event, innerParams, dismissWith);
      }
    };
    const handleEnter = (event, innerParams) => {
      if (!callIfFunction(innerParams.allowEnterKey)) {
        return;
      }
      const input = getInput$1(getPopup(), innerParams.input);
      if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
        if (['textarea', 'file'].includes(innerParams.input)) {
          return;
        }
        clickConfirm();
        event.preventDefault();
      }
    };
    const handleTab = event => {
      const targetElement = event.target;
      const focusableElements = getFocusableElements();
      let btnIndex = -1;
      for (let i = 0; i < focusableElements.length; i++) {
        if (targetElement === focusableElements[i]) {
          btnIndex = i;
          break;
        }
      }
      if (!event.shiftKey) {
        setFocus(btnIndex, 1);
      } else {
        setFocus(btnIndex, -1);
      }
      event.stopPropagation();
      event.preventDefault();
    };
    const handleArrows = key => {
      const actions = getActions();
      const confirmButton = getConfirmButton();
      const denyButton = getDenyButton();
      const cancelButton = getCancelButton();
      if (!actions || !confirmButton || !denyButton || !cancelButton) {
        return;
      }
      const buttons = [confirmButton, denyButton, cancelButton];
      if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) {
        return;
      }
      const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
      let buttonToFocus = document.activeElement;
      if (!buttonToFocus) {
        return;
      }
      for (let i = 0; i < actions.children.length; i++) {
        buttonToFocus = buttonToFocus[sibling];
        if (!buttonToFocus) {
          return;
        }
        if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) {
          break;
        }
      }
      if (buttonToFocus instanceof HTMLButtonElement) {
        buttonToFocus.focus();
      }
    };
    const handleEsc = (event, innerParams, dismissWith) => {
      if (callIfFunction(innerParams.allowEscapeKey)) {
        event.preventDefault();
        dismissWith(DismissReason.esc);
      }
    };
    var privateMethods = {
      swalPromiseResolve: new WeakMap(),
      swalPromiseReject: new WeakMap()
    };
    const setAriaHidden = () => {
      const container = getContainer();
      const bodyChildren = Array.from(document.body.children);
      bodyChildren.forEach(el => {
        if (el.contains(container)) {
          return;
        }
        if (el.hasAttribute('aria-hidden')) {
          el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
        }
        el.setAttribute('aria-hidden', 'true');
      });
    };
    const unsetAriaHidden = () => {
      const bodyChildren = Array.from(document.body.children);
      bodyChildren.forEach(el => {
        if (el.hasAttribute('data-previous-aria-hidden')) {
          el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
          el.removeAttribute('data-previous-aria-hidden');
        } else {
          el.removeAttribute('aria-hidden');
        }
      });
    };
    const isSafariOrIOS = typeof window !== 'undefined' && !!window.GestureEvent;
    const iOSfix = () => {
      if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
        const offset = document.body.scrollTop;
        document.body.style.top = `${offset * -1}px`;
        addClass(document.body, swalClasses.iosfix);
        lockBodyScroll();
      }
    };
    const lockBodyScroll = () => {
      const container = getContainer();
      if (!container) {
        return;
      }
      let preventTouchMove;
      container.ontouchstart = event => {
        preventTouchMove = shouldPreventTouchMove(event);
      };
      container.ontouchmove = event => {
        if (preventTouchMove) {
          event.preventDefault();
          event.stopPropagation();
        }
      };
    };
    const shouldPreventTouchMove = event => {
      const target = event.target;
      const container = getContainer();
      const htmlContainer = getHtmlContainer();
      if (!container || !htmlContainer) {
        return false;
      }
      if (isStylus(event) || isZoom(event)) {
        return false;
      }
      if (target === container) {
        return true;
      }
      if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA' && !(isScrollable(htmlContainer) && htmlContainer.contains(target))) {
        return true;
      }
      return false;
    };
    const isStylus = event => {
      return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
    };
    const isZoom = event => {
      return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = () => {
      if (hasClass(document.body, swalClasses.iosfix)) {
        const offset = parseInt(document.body.style.top, 10);
        removeClass(document.body, swalClasses.iosfix);
        document.body.style.top = '';
        document.body.scrollTop = offset * -1;
      }
    };
    const measureScrollbar = () => {
      const scrollDiv = document.createElement('div');
      scrollDiv.className = swalClasses['scrollbar-measure'];
      document.body.appendChild(scrollDiv);
      const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    };
    let previousBodyPadding = null;
    const replaceScrollbarWithPadding = initialBodyOverflow => {
      if (previousBodyPadding !== null) {
        return;
      }
      if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll') {
        previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
        document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
      }
    };
    const undoReplaceScrollbarWithPadding = () => {
      if (previousBodyPadding !== null) {
        document.body.style.paddingRight = `${previousBodyPadding}px`;
        previousBodyPadding = null;
      }
    };
    function removePopupAndResetState(instance, container, returnFocus, didClose) {
      if (isToast()) {
        triggerDidCloseAndDispose(instance, didClose);
      } else {
        restoreActiveElement(returnFocus).then(() => triggerDidCloseAndDispose(instance, didClose));
        removeKeydownHandler(globalState);
      }
      if (isSafariOrIOS) {
        container.setAttribute('style', 'display:none !important');
        container.removeAttribute('class');
        container.innerHTML = '';
      } else {
        container.remove();
      }
      if (isModal()) {
        undoReplaceScrollbarWithPadding();
        undoIOSfix();
        unsetAriaHidden();
      }
      removeBodyClasses();
    }
    function removeBodyClasses() {
      removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown']]);
    }
    function close(resolveValue) {
      resolveValue = prepareResolveValue(resolveValue);
      const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
      const didClose = triggerClosePopup(this);
      if (this.isAwaitingPromise) {
        if (!resolveValue.isDismissed) {
          handleAwaitingPromise(this);
          swalPromiseResolve(resolveValue);
        }
      } else if (didClose) {
        swalPromiseResolve(resolveValue);
      }
    }
    const triggerClosePopup = instance => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      const innerParams = privateProps.innerParams.get(instance);
      if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
        return false;
      }
      removeClass(popup, innerParams.showClass.popup);
      addClass(popup, innerParams.hideClass.popup);
      const backdrop = getContainer();
      removeClass(backdrop, innerParams.showClass.backdrop);
      addClass(backdrop, innerParams.hideClass.backdrop);
      handlePopupAnimation(instance, popup, innerParams);
      return true;
    };
    function rejectPromise(error) {
      const rejectPromise = privateMethods.swalPromiseReject.get(this);
      handleAwaitingPromise(this);
      if (rejectPromise) {
        rejectPromise(error);
      }
    }
    const handleAwaitingPromise = instance => {
      if (instance.isAwaitingPromise) {
        delete instance.isAwaitingPromise;
        if (!privateProps.innerParams.get(instance)) {
          instance._destroy();
        }
      }
    };
    const prepareResolveValue = resolveValue => {
      if (typeof resolveValue === 'undefined') {
        return {
          isConfirmed: false,
          isDenied: false,
          isDismissed: true
        };
      }
      return Object.assign({
        isConfirmed: false,
        isDenied: false,
        isDismissed: false
      }, resolveValue);
    };
    const handlePopupAnimation = (instance, popup, innerParams) => {
      const container = getContainer();
      const animationIsSupported = animationEndEvent && hasCssAnimation(popup);
      if (typeof innerParams.willClose === 'function') {
        innerParams.willClose(popup);
      }
      globalState.eventEmitter.emit('willClose', popup);
      if (animationIsSupported) {
        animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
      } else {
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
      }
    };
    const animatePopup = (instance, popup, container, returnFocus, didClose) => {
      if (!animationEndEvent) {
        return;
      }
      globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
      popup.addEventListener(animationEndEvent, function (e) {
        if (e.target === popup) {
          globalState.swalCloseEventFinishedCallback();
          delete globalState.swalCloseEventFinishedCallback;
        }
      });
    };
    const triggerDidCloseAndDispose = (instance, didClose) => {
      setTimeout(() => {
        if (typeof didClose === 'function') {
          didClose.bind(instance.params)();
        }
        globalState.eventEmitter.emit('didClose');
        if (instance._destroy) {
          instance._destroy();
        }
      });
    };
    const showLoading = buttonToReplace => {
      let popup = getPopup();
      if (!popup) {
        new Swal();
      }
      popup = getPopup();
      if (!popup) {
        return;
      }
      const loader = getLoader();
      if (isToast()) {
        hide(getIcon());
      } else {
        replaceButton(popup, buttonToReplace);
      }
      show(loader);
      popup.setAttribute('data-loading', 'true');
      popup.setAttribute('aria-busy', 'true');
      popup.focus();
    };
    const replaceButton = (popup, buttonToReplace) => {
      const actions = getActions();
      const loader = getLoader();
      if (!actions || !loader) {
        return;
      }
      if (!buttonToReplace && isVisible$1(getConfirmButton())) {
        buttonToReplace = getConfirmButton();
      }
      show(actions);
      if (buttonToReplace) {
        hide(buttonToReplace);
        loader.setAttribute('data-button-to-replace', buttonToReplace.className);
        actions.insertBefore(loader, buttonToReplace);
      }
      addClass([popup, actions], swalClasses.loading);
    };
    const handleInputOptionsAndValue = (instance, params) => {
      if (params.input === 'select' || params.input === 'radio') {
        handleInputOptions(instance, params);
      } else if (['text', 'email', 'number', 'tel', 'textarea'].some(i => i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
        showLoading(getConfirmButton());
        handleInputValue(instance, params);
      }
    };
    const getInputValue = (instance, innerParams) => {
      const input = instance.getInput();
      if (!input) {
        return null;
      }
      switch (innerParams.input) {
        case 'checkbox':
          return getCheckboxValue(input);
        case 'radio':
          return getRadioValue(input);
        case 'file':
          return getFileValue(input);
        default:
          return innerParams.inputAutoTrim ? input.value.trim() : input.value;
      }
    };
    const getCheckboxValue = input => input.checked ? 1 : 0;
    const getRadioValue = input => input.checked ? input.value : null;
    const getFileValue = input => input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    const handleInputOptions = (instance, params) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const processInputOptions = inputOptions => {
        if (params.input === 'select') {
          populateSelectOptions(popup, formatInputOptions(inputOptions), params);
        } else if (params.input === 'radio') {
          populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        }
      };
      if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
        showLoading(getConfirmButton());
        asPromise(params.inputOptions).then(inputOptions => {
          instance.hideLoading();
          processInputOptions(inputOptions);
        });
      } else if (typeof params.inputOptions === 'object') {
        processInputOptions(params.inputOptions);
      } else {
        error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
      }
    };
    const handleInputValue = (instance, params) => {
      const input = instance.getInput();
      if (!input) {
        return;
      }
      hide(input);
      asPromise(params.inputValue).then(inputValue => {
        input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
        show(input);
        input.focus();
        instance.hideLoading();
      }).catch(err => {
        error(`Error in inputValue promise: ${err}`);
        input.value = '';
        show(input);
        input.focus();
        instance.hideLoading();
      });
    };
    function populateSelectOptions(popup, inputOptions, params) {
      const select = getDirectChildByClass(popup, swalClasses.select);
      if (!select) {
        return;
      }
      const renderOption = (parent, optionLabel, optionValue) => {
        const option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);
        option.selected = isSelected(optionValue, params.inputValue);
        parent.appendChild(option);
      };
      inputOptions.forEach(inputOption => {
        const optionValue = inputOption[0];
        const optionLabel = inputOption[1];
        if (Array.isArray(optionLabel)) {
          const optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false;
          select.appendChild(optgroup);
          optionLabel.forEach(o => renderOption(optgroup, o[1], o[0]));
        } else {
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    }
    function populateRadioOptions(popup, inputOptions, params) {
      const radio = getDirectChildByClass(popup, swalClasses.radio);
      if (!radio) {
        return;
      }
      inputOptions.forEach(inputOption => {
        const radioValue = inputOption[0];
        const radioLabel = inputOption[1];
        const radioInput = document.createElement('input');
        const radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;
        if (isSelected(radioValue, params.inputValue)) {
          radioInput.checked = true;
        }
        const label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      const radios = radio.querySelectorAll('input');
      if (radios.length) {
        radios[0].focus();
      }
    }
    const formatInputOptions = inputOptions => {
      const result = [];
      if (inputOptions instanceof Map) {
        inputOptions.forEach((value, key) => {
          let valueFormatted = value;
          if (typeof valueFormatted === 'object') {
            valueFormatted = formatInputOptions(valueFormatted);
          }
          result.push([key, valueFormatted]);
        });
      } else {
        Object.keys(inputOptions).forEach(key => {
          let valueFormatted = inputOptions[key];
          if (typeof valueFormatted === 'object') {
            valueFormatted = formatInputOptions(valueFormatted);
          }
          result.push([key, valueFormatted]);
        });
      }
      return result;
    };
    const isSelected = (optionValue, inputValue) => {
      return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    const handleConfirmButtonClick = instance => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableButtons();
      if (innerParams.input) {
        handleConfirmOrDenyWithInput(instance, 'confirm');
      } else {
        confirm(instance, true);
      }
    };
    const handleDenyButtonClick = instance => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableButtons();
      if (innerParams.returnInputValueOnDeny) {
        handleConfirmOrDenyWithInput(instance, 'deny');
      } else {
        deny(instance, false);
      }
    };
    const handleCancelButtonClick = (instance, dismissWith) => {
      instance.disableButtons();
      dismissWith(DismissReason.cancel);
    };
    const handleConfirmOrDenyWithInput = (instance, type) => {
      const innerParams = privateProps.innerParams.get(instance);
      if (!innerParams.input) {
        error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
        return;
      }
      const input = instance.getInput();
      const inputValue = getInputValue(instance, innerParams);
      if (innerParams.inputValidator) {
        handleInputValidator(instance, inputValue, type);
      } else if (input && !input.checkValidity()) {
        instance.enableButtons();
        instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
      } else if (type === 'deny') {
        deny(instance, inputValue);
      } else {
        confirm(instance, inputValue);
      }
    };
    const handleInputValidator = (instance, inputValue, type) => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableInput();
      const validationPromise = Promise.resolve().then(() => asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
      validationPromise.then(validationMessage => {
        instance.enableButtons();
        instance.enableInput();
        if (validationMessage) {
          instance.showValidationMessage(validationMessage);
        } else if (type === 'deny') {
          deny(instance, inputValue);
        } else {
          confirm(instance, inputValue);
        }
      });
    };
    const deny = (instance, value) => {
      const innerParams = privateProps.innerParams.get(instance || undefined);
      if (innerParams.showLoaderOnDeny) {
        showLoading(getDenyButton());
      }
      if (innerParams.preDeny) {
        instance.isAwaitingPromise = true;
        const preDenyPromise = Promise.resolve().then(() => asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
        preDenyPromise.then(preDenyValue => {
          if (preDenyValue === false) {
            instance.hideLoading();
            handleAwaitingPromise(instance);
          } else {
            instance.close({
              isDenied: true,
              value: typeof preDenyValue === 'undefined' ? value : preDenyValue
            });
          }
        }).catch(error => rejectWith(instance || undefined, error));
      } else {
        instance.close({
          isDenied: true,
          value
        });
      }
    };
    const succeedWith = (instance, value) => {
      instance.close({
        isConfirmed: true,
        value
      });
    };
    const rejectWith = (instance, error) => {
      instance.rejectPromise(error);
    };
    const confirm = (instance, value) => {
      const innerParams = privateProps.innerParams.get(instance || undefined);
      if (innerParams.showLoaderOnConfirm) {
        showLoading();
      }
      if (innerParams.preConfirm) {
        instance.resetValidationMessage();
        instance.isAwaitingPromise = true;
        const preConfirmPromise = Promise.resolve().then(() => asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
        preConfirmPromise.then(preConfirmValue => {
          if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
            instance.hideLoading();
            handleAwaitingPromise(instance);
          } else {
            succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
          }
        }).catch(error => rejectWith(instance || undefined, error));
      } else {
        succeedWith(instance, value);
      }
    };
    function hideLoading() {
      const innerParams = privateProps.innerParams.get(this);
      if (!innerParams) {
        return;
      }
      const domCache = privateProps.domCache.get(this);
      hide(domCache.loader);
      if (isToast()) {
        if (innerParams.icon) {
          show(getIcon());
        }
      } else {
        showRelatedButton(domCache);
      }
      removeClass([domCache.popup, domCache.actions], swalClasses.loading);
      domCache.popup.removeAttribute('aria-busy');
      domCache.popup.removeAttribute('data-loading');
      domCache.confirmButton.disabled = false;
      domCache.denyButton.disabled = false;
      domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = domCache => {
      const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
      if (buttonToReplace.length) {
        show(buttonToReplace[0], 'inline-block');
      } else if (allButtonsAreHidden()) {
        hide(domCache.actions);
      }
    };
    function getInput() {
      const innerParams = privateProps.innerParams.get(this);
      const domCache = privateProps.domCache.get(this);
      if (!domCache) {
        return null;
      }
      return getInput$1(domCache.popup, innerParams.input);
    }
    function setButtonsDisabled(instance, buttons, disabled) {
      const domCache = privateProps.domCache.get(instance);
      buttons.forEach(button => {
        domCache[button].disabled = disabled;
      });
    }
    function setInputDisabled(input, disabled) {
      const popup = getPopup();
      if (!popup || !input) {
        return;
      }
      if (input.type === 'radio') {
        const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
        for (let i = 0; i < radios.length; i++) {
          radios[i].disabled = disabled;
        }
      } else {
        input.disabled = disabled;
      }
    }
    function enableButtons() {
      setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
    }
    function disableButtons() {
      setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
    }
    function enableInput() {
      setInputDisabled(this.getInput(), false);
    }
    function disableInput() {
      setInputDisabled(this.getInput(), true);
    }
    function showValidationMessage(error) {
      const domCache = privateProps.domCache.get(this);
      const params = privateProps.innerParams.get(this);
      setInnerHtml(domCache.validationMessage, error);
      domCache.validationMessage.className = swalClasses['validation-message'];
      if (params.customClass && params.customClass.validationMessage) {
        addClass(domCache.validationMessage, params.customClass.validationMessage);
      }
      show(domCache.validationMessage);
      const input = this.getInput();
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', swalClasses['validation-message']);
        focusInput(input);
        addClass(input, swalClasses.inputerror);
      }
    }
    function resetValidationMessage() {
      const domCache = privateProps.domCache.get(this);
      if (domCache.validationMessage) {
        hide(domCache.validationMessage);
      }
      const input = this.getInput();
      if (input) {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        removeClass(input, swalClasses.inputerror);
      }
    }
    const defaultParams = {
      title: '',
      titleText: '',
      text: '',
      html: '',
      footer: '',
      icon: undefined,
      iconColor: undefined,
      iconHtml: undefined,
      template: undefined,
      toast: false,
      animation: true,
      showClass: {
        popup: 'swal2-show',
        backdrop: 'swal2-backdrop-show',
        icon: 'swal2-icon-show'
      },
      hideClass: {
        popup: 'swal2-hide',
        backdrop: 'swal2-backdrop-hide',
        icon: 'swal2-icon-hide'
      },
      customClass: {},
      target: 'body',
      color: undefined,
      backdrop: true,
      heightAuto: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: true,
      stopKeydownPropagation: true,
      keydownListenerCapture: false,
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: false,
      preConfirm: undefined,
      preDeny: undefined,
      confirmButtonText: 'OK',
      confirmButtonAriaLabel: '',
      confirmButtonColor: undefined,
      denyButtonText: 'No',
      denyButtonAriaLabel: '',
      denyButtonColor: undefined,
      cancelButtonText: 'Cancel',
      cancelButtonAriaLabel: '',
      cancelButtonColor: undefined,
      buttonsStyling: true,
      reverseButtons: false,
      focusConfirm: true,
      focusDeny: false,
      focusCancel: false,
      returnFocus: true,
      showCloseButton: false,
      closeButtonHtml: '&times;',
      closeButtonAriaLabel: 'Close this dialog',
      loaderHtml: '',
      showLoaderOnConfirm: false,
      showLoaderOnDeny: false,
      imageUrl: undefined,
      imageWidth: undefined,
      imageHeight: undefined,
      imageAlt: '',
      timer: undefined,
      timerProgressBar: false,
      width: undefined,
      padding: undefined,
      background: undefined,
      input: undefined,
      inputPlaceholder: '',
      inputLabel: '',
      inputValue: '',
      inputOptions: {},
      inputAutoFocus: true,
      inputAutoTrim: true,
      inputAttributes: {},
      inputValidator: undefined,
      returnInputValueOnDeny: false,
      validationMessage: undefined,
      grow: false,
      position: 'center',
      progressSteps: [],
      currentProgressStep: undefined,
      progressStepsDistance: undefined,
      willOpen: undefined,
      didOpen: undefined,
      didRender: undefined,
      willClose: undefined,
      didClose: undefined,
      didDestroy: undefined,
      scrollbarPadding: true
    };
    const updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'color', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'iconHtml', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'preConfirm', 'preDeny', 'progressSteps', 'returnFocus', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];
    const deprecatedParams = {
      allowEnterKey: undefined
    };
    const toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'returnFocus', 'heightAuto', 'keydownListenerCapture'];
    const isValidParameter = paramName => {
      return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    const isUpdatableParameter = paramName => {
      return updatableParams.indexOf(paramName) !== -1;
    };
    const isDeprecatedParameter = paramName => {
      return deprecatedParams[paramName];
    };
    const checkIfParamIsValid = param => {
      if (!isValidParameter(param)) {
        warn(`Unknown parameter "${param}"`);
      }
    };
    const checkIfToastParamIsValid = param => {
      if (toastIncompatibleParams.includes(param)) {
        warn(`The parameter "${param}" is incompatible with toasts`);
      }
    };
    const checkIfParamIsDeprecated = param => {
      const isDeprecated = isDeprecatedParameter(param);
      if (isDeprecated) {
        warnAboutDeprecation(param, isDeprecated);
      }
    };
    const showWarningsForParams = params => {
      if (params.backdrop === false && params.allowOutsideClick) {
        warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
      }
      for (const param in params) {
        checkIfParamIsValid(param);
        if (params.toast) {
          checkIfToastParamIsValid(param);
        }
        checkIfParamIsDeprecated(param);
      }
    };
    function update(params) {
      const popup = getPopup();
      const innerParams = privateProps.innerParams.get(this);
      if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
        warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
        return;
      }
      const validUpdatableParams = filterValidParams(params);
      const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
      render(this, updatedParams);
      privateProps.innerParams.set(this, updatedParams);
      Object.defineProperties(this, {
        params: {
          value: Object.assign({}, this.params, params),
          writable: false,
          enumerable: true
        }
      });
    }
    const filterValidParams = params => {
      const validUpdatableParams = {};
      Object.keys(params).forEach(param => {
        if (isUpdatableParameter(param)) {
          validUpdatableParams[param] = params[param];
        } else {
          warn(`Invalid parameter to update: ${param}`);
        }
      });
      return validUpdatableParams;
    };
    function _destroy() {
      const domCache = privateProps.domCache.get(this);
      const innerParams = privateProps.innerParams.get(this);
      if (!innerParams) {
        disposeWeakMaps(this);
        return;
      }
      if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
      if (typeof innerParams.didDestroy === 'function') {
        innerParams.didDestroy();
      }
      globalState.eventEmitter.emit('didDestroy');
      disposeSwal(this);
    }
    const disposeSwal = instance => {
      disposeWeakMaps(instance);
      delete instance.params;
      delete globalState.keydownHandler;
      delete globalState.keydownTarget;
      delete globalState.currentInstance;
    };
    const disposeWeakMaps = instance => {
      if (instance.isAwaitingPromise) {
        unsetWeakMaps(privateProps, instance);
        instance.isAwaitingPromise = true;
      } else {
        unsetWeakMaps(privateMethods, instance);
        unsetWeakMaps(privateProps, instance);
        delete instance.isAwaitingPromise;
        delete instance.disableButtons;
        delete instance.enableButtons;
        delete instance.getInput;
        delete instance.disableInput;
        delete instance.enableInput;
        delete instance.hideLoading;
        delete instance.disableLoading;
        delete instance.showValidationMessage;
        delete instance.resetValidationMessage;
        delete instance.close;
        delete instance.closePopup;
        delete instance.closeModal;
        delete instance.closeToast;
        delete instance.rejectPromise;
        delete instance.update;
        delete instance._destroy;
      }
    };
    const unsetWeakMaps = (obj, instance) => {
      for (const i in obj) {
        obj[i].delete(instance);
      }
    };
    var instanceMethods = /*#__PURE__*/Object.freeze({
      __proto__: null,
      _destroy: _destroy,
      close: close,
      closeModal: close,
      closePopup: close,
      closeToast: close,
      disableButtons: disableButtons,
      disableInput: disableInput,
      disableLoading: hideLoading,
      enableButtons: enableButtons,
      enableInput: enableInput,
      getInput: getInput,
      handleAwaitingPromise: handleAwaitingPromise,
      hideLoading: hideLoading,
      rejectPromise: rejectPromise,
      resetValidationMessage: resetValidationMessage,
      showValidationMessage: showValidationMessage,
      update: update
    });
    const handlePopupClick = (innerParams, domCache, dismissWith) => {
      if (innerParams.toast) {
        handleToastClick(innerParams, domCache, dismissWith);
      } else {
        handleModalMousedown(domCache);
        handleContainerMousedown(domCache);
        handleModalClick(innerParams, domCache, dismissWith);
      }
    };
    const handleToastClick = (innerParams, domCache, dismissWith) => {
      domCache.popup.onclick = () => {
        if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) {
          return;
        }
        dismissWith(DismissReason.close);
      };
    };
    const isAnyButtonShown = innerParams => {
      return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    const handleModalMousedown = domCache => {
      domCache.popup.onmousedown = () => {
        domCache.container.onmouseup = function (e) {
          domCache.container.onmouseup = () => {};
          if (e.target === domCache.container) {
            ignoreOutsideClick = true;
          }
        };
      };
    };
    const handleContainerMousedown = domCache => {
      domCache.container.onmousedown = e => {
        if (e.target === domCache.container) {
          e.preventDefault();
        }
        domCache.popup.onmouseup = function (e) {
          domCache.popup.onmouseup = () => {};
          if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) {
            ignoreOutsideClick = true;
          }
        };
      };
    };
    const handleModalClick = (innerParams, domCache, dismissWith) => {
      domCache.container.onclick = e => {
        if (ignoreOutsideClick) {
          ignoreOutsideClick = false;
          return;
        }
        if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
          dismissWith(DismissReason.backdrop);
        }
      };
    };
    const isJqueryElement = elem => typeof elem === 'object' && elem.jquery;
    const isElement = elem => elem instanceof Element || isJqueryElement(elem);
    const argsToParams = args => {
      const params = {};
      if (typeof args[0] === 'object' && !isElement(args[0])) {
        Object.assign(params, args[0]);
      } else {
        ['title', 'html', 'icon'].forEach((name, index) => {
          const arg = args[index];
          if (typeof arg === 'string' || isElement(arg)) {
            params[name] = arg;
          } else if (arg !== undefined) {
            error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
          }
        });
      }
      return params;
    };
    function fire() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return new this(...args);
    }
    function mixin(mixinParams) {
      class MixinSwal extends this {
        _main(params, priorityMixinParams) {
          return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
        }
      }
      return MixinSwal;
    }
    const getTimerLeft = () => {
      return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    const stopTimer = () => {
      if (globalState.timeout) {
        stopTimerProgressBar();
        return globalState.timeout.stop();
      }
    };
    const resumeTimer = () => {
      if (globalState.timeout) {
        const remaining = globalState.timeout.start();
        animateTimerProgressBar(remaining);
        return remaining;
      }
    };
    const toggleTimer = () => {
      const timer = globalState.timeout;
      return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    const increaseTimer = ms => {
      if (globalState.timeout) {
        const remaining = globalState.timeout.increase(ms);
        animateTimerProgressBar(remaining, true);
        return remaining;
      }
    };
    const isTimerRunning = () => {
      return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    function bindClickHandler() {
      let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
      clickHandlers[attr] = this;
      if (!bodyClickListenerAdded) {
        document.body.addEventListener('click', bodyClickListener);
        bodyClickListenerAdded = true;
      }
    }
    const bodyClickListener = event => {
      for (let el = event.target; el && el !== document; el = el.parentNode) {
        for (const attr in clickHandlers) {
          const template = el.getAttribute(attr);
          if (template) {
            clickHandlers[attr].fire({
              template
            });
            return;
          }
        }
      }
    };
    class EventEmitter {
      constructor() {
        this.events = {};
      }
      _getHandlersByEventName(eventName) {
        if (typeof this.events[eventName] === 'undefined') {
          this.events[eventName] = [];
        }
        return this.events[eventName];
      }
      on(eventName, eventHandler) {
        const currentHandlers = this._getHandlersByEventName(eventName);
        if (!currentHandlers.includes(eventHandler)) {
          currentHandlers.push(eventHandler);
        }
      }
      once(eventName, eventHandler) {
        var _this = this;
        const onceFn = function () {
          _this.removeListener(eventName, onceFn);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          eventHandler.apply(_this, args);
        };
        this.on(eventName, onceFn);
      }
      emit(eventName) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        this._getHandlersByEventName(eventName).forEach(eventHandler => {
          try {
            eventHandler.apply(this, args);
          } catch (error) {
            console.error(error);
          }
        });
      }
      removeListener(eventName, eventHandler) {
        const currentHandlers = this._getHandlersByEventName(eventName);
        const index = currentHandlers.indexOf(eventHandler);
        if (index > -1) {
          currentHandlers.splice(index, 1);
        }
      }
      removeAllListeners(eventName) {
        if (this.events[eventName] !== undefined) {
          this.events[eventName].length = 0;
        }
      }
      reset() {
        this.events = {};
      }
    }
    globalState.eventEmitter = new EventEmitter();
    const on = (eventName, eventHandler) => {
      globalState.eventEmitter.on(eventName, eventHandler);
    };
    const once = (eventName, eventHandler) => {
      globalState.eventEmitter.once(eventName, eventHandler);
    };
    const off = (eventName, eventHandler) => {
      if (!eventName) {
        globalState.eventEmitter.reset();
        return;
      }
      if (eventHandler) {
        globalState.eventEmitter.removeListener(eventName, eventHandler);
      } else {
        globalState.eventEmitter.removeAllListeners(eventName);
      }
    };
    var staticMethods = /*#__PURE__*/Object.freeze({
      __proto__: null,
      argsToParams: argsToParams,
      bindClickHandler: bindClickHandler,
      clickCancel: clickCancel,
      clickConfirm: clickConfirm,
      clickDeny: clickDeny,
      enableLoading: showLoading,
      fire: fire,
      getActions: getActions,
      getCancelButton: getCancelButton,
      getCloseButton: getCloseButton,
      getConfirmButton: getConfirmButton,
      getContainer: getContainer,
      getDenyButton: getDenyButton,
      getFocusableElements: getFocusableElements,
      getFooter: getFooter,
      getHtmlContainer: getHtmlContainer,
      getIcon: getIcon,
      getIconContent: getIconContent,
      getImage: getImage,
      getInputLabel: getInputLabel,
      getLoader: getLoader,
      getPopup: getPopup,
      getProgressSteps: getProgressSteps,
      getTimerLeft: getTimerLeft,
      getTimerProgressBar: getTimerProgressBar,
      getTitle: getTitle,
      getValidationMessage: getValidationMessage,
      increaseTimer: increaseTimer,
      isDeprecatedParameter: isDeprecatedParameter,
      isLoading: isLoading,
      isTimerRunning: isTimerRunning,
      isUpdatableParameter: isUpdatableParameter,
      isValidParameter: isValidParameter,
      isVisible: isVisible,
      mixin: mixin,
      off: off,
      on: on,
      once: once,
      resumeTimer: resumeTimer,
      showLoading: showLoading,
      stopTimer: stopTimer,
      toggleTimer: toggleTimer
    });
    class Timer {
      constructor(callback, delay) {
        this.callback = callback;
        this.remaining = delay;
        this.running = false;
        this.start();
      }
      start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }
        return this.remaining;
      }
      stop() {
        if (this.started && this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date().getTime() - this.started.getTime();
        }
        return this.remaining;
      }
      increase(n) {
        const running = this.running;
        if (running) {
          this.stop();
        }
        this.remaining += n;
        if (running) {
          this.start();
        }
        return this.remaining;
      }
      getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }
        return this.remaining;
      }
      isRunning() {
        return this.running;
      }
    }
    const swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];
    const getTemplateParams = params => {
      const template = typeof params.template === 'string' ? (document.querySelector(params.template)) : params.template;
      if (!template) {
        return {};
      }
      const templateContent = template.content;
      showWarningsForElements(templateContent);
      const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
      return result;
    };
    const getSwalParams = templateContent => {
      const result = {};
      const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
      swalParams.forEach(param => {
        showWarningsForAttributes(param, ['name', 'value']);
        const paramName = param.getAttribute('name');
        const value = param.getAttribute('value');
        if (!paramName || !value) {
          return;
        }
        if (typeof defaultParams[paramName] === 'boolean') {
          result[paramName] = value !== 'false';
        } else if (typeof defaultParams[paramName] === 'object') {
          result[paramName] = JSON.parse(value);
        } else {
          result[paramName] = value;
        }
      });
      return result;
    };
    const getSwalFunctionParams = templateContent => {
      const result = {};
      const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
      swalFunctions.forEach(param => {
        const paramName = param.getAttribute('name');
        const value = param.getAttribute('value');
        if (!paramName || !value) {
          return;
        }
        result[paramName] = new Function(`return ${value}`)();
      });
      return result;
    };
    const getSwalButtons = templateContent => {
      const result = {};
      const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
      swalButtons.forEach(button => {
        showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
        const type = button.getAttribute('type');
        if (!type || !['confirm', 'cancel', 'deny'].includes(type)) {
          return;
        }
        result[`${type}ButtonText`] = button.innerHTML;
        result[`show${capitalizeFirstLetter(type)}Button`] = true;
        if (button.hasAttribute('color')) {
          result[`${type}ButtonColor`] = button.getAttribute('color');
        }
        if (button.hasAttribute('aria-label')) {
          result[`${type}ButtonAriaLabel`] = button.getAttribute('aria-label');
        }
      });
      return result;
    };
    const getSwalImage = templateContent => {
      const result = {};
      const image = templateContent.querySelector('swal-image');
      if (image) {
        showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);
        if (image.hasAttribute('src')) {
          result.imageUrl = image.getAttribute('src') || undefined;
        }
        if (image.hasAttribute('width')) {
          result.imageWidth = image.getAttribute('width') || undefined;
        }
        if (image.hasAttribute('height')) {
          result.imageHeight = image.getAttribute('height') || undefined;
        }
        if (image.hasAttribute('alt')) {
          result.imageAlt = image.getAttribute('alt') || undefined;
        }
      }
      return result;
    };
    const getSwalIcon = templateContent => {
      const result = {};
      const icon = templateContent.querySelector('swal-icon');
      if (icon) {
        showWarningsForAttributes(icon, ['type', 'color']);
        if (icon.hasAttribute('type')) {
          result.icon = icon.getAttribute('type');
        }
        if (icon.hasAttribute('color')) {
          result.iconColor = icon.getAttribute('color');
        }
        result.iconHtml = icon.innerHTML;
      }
      return result;
    };
    const getSwalInput = templateContent => {
      const result = {};
      const input = templateContent.querySelector('swal-input');
      if (input) {
        showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
        result.input = input.getAttribute('type') || 'text';
        if (input.hasAttribute('label')) {
          result.inputLabel = input.getAttribute('label');
        }
        if (input.hasAttribute('placeholder')) {
          result.inputPlaceholder = input.getAttribute('placeholder');
        }
        if (input.hasAttribute('value')) {
          result.inputValue = input.getAttribute('value');
        }
      }
      const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
      if (inputOptions.length) {
        result.inputOptions = {};
        inputOptions.forEach(option => {
          showWarningsForAttributes(option, ['value']);
          const optionValue = option.getAttribute('value');
          if (!optionValue) {
            return;
          }
          const optionName = option.innerHTML;
          result.inputOptions[optionValue] = optionName;
        });
      }
      return result;
    };
    const getSwalStringParams = (templateContent, paramNames) => {
      const result = {};
      for (const i in paramNames) {
        const paramName = paramNames[i];
        const tag = templateContent.querySelector(paramName);
        if (tag) {
          showWarningsForAttributes(tag, []);
          result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
        }
      }
      return result;
    };
    const showWarningsForElements = templateContent => {
      const allowedElements = swalStringParams.concat(['swal-param', 'swal-function-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
      Array.from(templateContent.children).forEach(el => {
        const tagName = el.tagName.toLowerCase();
        if (!allowedElements.includes(tagName)) {
          warn(`Unrecognized element <${tagName}>`);
        }
      });
    };
    const showWarningsForAttributes = (el, allowedAttributes) => {
      Array.from(el.attributes).forEach(attribute => {
        if (allowedAttributes.indexOf(attribute.name) === -1) {
          warn([`Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`, `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`]);
        }
      });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    const openPopup = params => {
      const container = getContainer();
      const popup = getPopup();
      if (typeof params.willOpen === 'function') {
        params.willOpen(popup);
      }
      globalState.eventEmitter.emit('willOpen', popup);
      const bodyStyles = window.getComputedStyle(document.body);
      const initialBodyOverflow = bodyStyles.overflowY;
      addClasses(container, popup, params);
      setTimeout(() => {
        setScrollingVisibility(container, popup);
      }, SHOW_CLASS_TIMEOUT);
      if (isModal()) {
        fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
        setAriaHidden();
      }
      if (!isToast() && !globalState.previousActiveElement) {
        globalState.previousActiveElement = document.activeElement;
      }
      if (typeof params.didOpen === 'function') {
        setTimeout(() => params.didOpen(popup));
      }
      globalState.eventEmitter.emit('didOpen', popup);
      removeClass(container, swalClasses['no-transition']);
    };
    const swalOpenAnimationFinished = event => {
      const popup = getPopup();
      if (event.target !== popup || !animationEndEvent) {
        return;
      }
      const container = getContainer();
      popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
      container.style.overflowY = 'auto';
    };
    const setScrollingVisibility = (container, popup) => {
      if (animationEndEvent && hasCssAnimation(popup)) {
        container.style.overflowY = 'hidden';
        popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
      } else {
        container.style.overflowY = 'auto';
      }
    };
    const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow) => {
      iOSfix();
      if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
        replaceScrollbarWithPadding(initialBodyOverflow);
      }
      setTimeout(() => {
        container.scrollTop = 0;
      });
    };
    const addClasses = (container, popup, params) => {
      addClass(container, params.showClass.backdrop);
      if (params.animation) {
        popup.style.setProperty('opacity', '0', 'important');
        show(popup, 'grid');
        setTimeout(() => {
          addClass(popup, params.showClass.popup);
          popup.style.removeProperty('opacity');
        }, SHOW_CLASS_TIMEOUT);
      } else {
        show(popup, 'grid');
      }
      addClass([document.documentElement, document.body], swalClasses.shown);
      if (params.heightAuto && params.backdrop && !params.toast) {
        addClass([document.documentElement, document.body], swalClasses['height-auto']);
      }
    };
    var defaultInputValidators = {
      email: (string, validationMessage) => {
        return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
      },
      url: (string, validationMessage) => {
        return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
      }
    };
    function setDefaultInputValidators(params) {
      if (params.inputValidator) {
        return;
      }
      if (params.input === 'email') {
        params.inputValidator = defaultInputValidators['email'];
      }
      if (params.input === 'url') {
        params.inputValidator = defaultInputValidators['url'];
      }
    }
    function validateCustomTargetElement(params) {
      if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
        warn('Target parameter is not valid, defaulting to "body"');
        params.target = 'body';
      }
    }
    function setParameters(params) {
      setDefaultInputValidators(params);
      if (params.showLoaderOnConfirm && !params.preConfirm) {
        warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
      }
      validateCustomTargetElement(params);
      if (typeof params.title === 'string') {
        params.title = params.title.split('\n').join('<br />');
      }
      init(params);
    }
    let currentInstance;
    var _promise = /*#__PURE__*/new WeakMap();
    class SweetAlert {
      constructor() {
        _classPrivateFieldInitSpec(this, _promise, void 0);
        if (typeof window === 'undefined') {
          return;
        }
        currentInstance = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        const outerParams = Object.freeze(this.constructor.argsToParams(args));
        this.params = outerParams;
        this.isAwaitingPromise = false;
        _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
      }
      _main(userParams) {
        let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        showWarningsForParams(Object.assign({}, mixinParams, userParams));
        if (globalState.currentInstance) {
          const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
          const {
            isAwaitingPromise
          } = globalState.currentInstance;
          globalState.currentInstance._destroy();
          if (!isAwaitingPromise) {
            swalPromiseResolve({
              isDismissed: true
            });
          }
          if (isModal()) {
            unsetAriaHidden();
          }
        }
        globalState.currentInstance = currentInstance;
        const innerParams = prepareParams(userParams, mixinParams);
        setParameters(innerParams);
        Object.freeze(innerParams);
        if (globalState.timeout) {
          globalState.timeout.stop();
          delete globalState.timeout;
        }
        clearTimeout(globalState.restoreFocusTimeout);
        const domCache = populateDomCache(currentInstance);
        render(currentInstance, innerParams);
        privateProps.innerParams.set(currentInstance, innerParams);
        return swalPromise(currentInstance, domCache, innerParams);
      }
      then(onFulfilled) {
        return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
      }
      finally(onFinally) {
        return _classPrivateFieldGet2(_promise, this).finally(onFinally);
      }
    }
    const swalPromise = (instance, domCache, innerParams) => {
      return new Promise((resolve, reject) => {
        const dismissWith = dismiss => {
          instance.close({
            isDismissed: true,
            dismiss
          });
        };
        privateMethods.swalPromiseResolve.set(instance, resolve);
        privateMethods.swalPromiseReject.set(instance, reject);
        domCache.confirmButton.onclick = () => {
          handleConfirmButtonClick(instance);
        };
        domCache.denyButton.onclick = () => {
          handleDenyButtonClick(instance);
        };
        domCache.cancelButton.onclick = () => {
          handleCancelButtonClick(instance, dismissWith);
        };
        domCache.closeButton.onclick = () => {
          dismissWith(DismissReason.close);
        };
        handlePopupClick(innerParams, domCache, dismissWith);
        addKeydownHandler(globalState, innerParams, dismissWith);
        handleInputOptionsAndValue(instance, innerParams);
        openPopup(innerParams);
        setupTimer(globalState, innerParams, dismissWith);
        initFocus(domCache, innerParams);
        setTimeout(() => {
          domCache.container.scrollTop = 0;
        });
      });
    };
    const prepareParams = (userParams, mixinParams) => {
      const templateParams = getTemplateParams(userParams);
      const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams);
      params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
      params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
      if (params.animation === false) {
        params.showClass = {
          backdrop: 'swal2-noanimation'
        };
        params.hideClass = {};
      }
      return params;
    };
    const populateDomCache = instance => {
      const domCache = {
        popup: getPopup(),
        container: getContainer(),
        actions: getActions(),
        confirmButton: getConfirmButton(),
        denyButton: getDenyButton(),
        cancelButton: getCancelButton(),
        loader: getLoader(),
        closeButton: getCloseButton(),
        validationMessage: getValidationMessage(),
        progressSteps: getProgressSteps()
      };
      privateProps.domCache.set(instance, domCache);
      return domCache;
    };
    const setupTimer = (globalState, innerParams, dismissWith) => {
      const timerProgressBar = getTimerProgressBar();
      hide(timerProgressBar);
      if (innerParams.timer) {
        globalState.timeout = new Timer(() => {
          dismissWith('timer');
          delete globalState.timeout;
        }, innerParams.timer);
        if (innerParams.timerProgressBar) {
          show(timerProgressBar);
          applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
          setTimeout(() => {
            if (globalState.timeout && globalState.timeout.running) {
              animateTimerProgressBar(innerParams.timer);
            }
          });
        }
      }
    };
    const initFocus = (domCache, innerParams) => {
      if (innerParams.toast) {
        return;
      }
      if (!callIfFunction(innerParams.allowEnterKey)) {
        warnAboutDeprecation('allowEnterKey');
        blurActiveElement();
        return;
      }
      if (focusAutofocus(domCache)) {
        return;
      }
      if (focusButton(domCache, innerParams)) {
        return;
      }
      setFocus(-1, 1);
    };
    const focusAutofocus = domCache => {
      const autofocusElements = domCache.popup.querySelectorAll('[autofocus]');
      for (const autofocusElement of autofocusElements) {
        if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
          autofocusElement.focus();
          return true;
        }
      }
      return false;
    };
    const focusButton = (domCache, innerParams) => {
      if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
        domCache.denyButton.focus();
        return true;
      }
      if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
        domCache.cancelButton.focus();
        return true;
      }
      if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
        domCache.confirmButton.focus();
        return true;
      }
      return false;
    };
    const blurActiveElement = () => {
      if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    };
    if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
      const now = new Date();
      const initiationDate = localStorage.getItem('swal-initiation');
      if (!initiationDate) {
        localStorage.setItem('swal-initiation', `${now}`);
      } else if ((now.getTime() - Date.parse(initiationDate)) / (1000 * 60 * 60 * 24) > 3) {
        setTimeout(() => {
          document.body.style.pointerEvents = 'none';
          const ukrainianAnthem = document.createElement('audio');
          ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
          ukrainianAnthem.loop = true;
          document.body.appendChild(ukrainianAnthem);
          setTimeout(() => {
            ukrainianAnthem.play().catch(() => {});
          }, 2500);
        }, 500);
      }
    }
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    Object.assign(SweetAlert, staticMethods);
    Object.keys(instanceMethods).forEach(key => {
      SweetAlert[key] = function () {
        if (currentInstance && currentInstance[key]) {
          return currentInstance[key](...arguments);
        }
        return null;
      };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.14.0';
    const Swal = SweetAlert;
    Swal.default = Swal;
    return Swal;
  });
  if (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.Sweetalert2) {
    commonjsGlobal.swal = commonjsGlobal.sweetAlert = commonjsGlobal.Swal = commonjsGlobal.SweetAlert = commonjsGlobal.Sweetalert2;
  }
  "undefined" != typeof document && function (e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);else try {
      n.innerHTML = t;
    } catch (e) {
      n.innerText = t;
    }
  }(document, ".swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):focus-visible{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):focus-visible{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):focus-visible{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus-visible{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em;text-align:center}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) .swal2-html-container{z-index:1;justify-content:center;margin:0;padding:1em 1.6em .3em;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#facea8;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#9de0f6;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#c9dae1;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}");
});

function ViewLandUseNoc({
  itemData
}) {
  const {
    t
  } = useTranslation();
  const nocEmployeeData = itemData === null || itemData === void 0 ? void 0 : itemData.nocDetails;
  const nocApplicantData = itemData === null || itemData === void 0 ? void 0 : itemData.nocDetailsApplicant;
  console.log("nocApplicantData", nocApplicantData);
  const StyledTableCell = styled(TableCell$1)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled(TableRow$1)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  console.log("loggg.........", itemData, nocEmployeeData);
  if (!nocApplicantData) return /*#__PURE__*/React__default.createElement("p", {
    className: "error"
  }, "Please enter NOC details.");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 5%"
    }
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "8px",
      fontSize: "24px",
      padding: "8px",
      fontWeight: "500"
    }
  }, `${t("BPA_MY_APPLICATIONS_LANDUSENOC")}`), /*#__PURE__*/React__default.createElement(TableContainer$1, null, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyledTableCell, {
    sx: {
      border: "1px solid #436387"
    }
  }, "Sr No"), /*#__PURE__*/React__default.createElement(StyledTableCell, {
    sx: {
      border: "1px solid #436387"
    }
  }, "Name"), /*#__PURE__*/React__default.createElement(StyledTableCell, {
    sx: {
      border: "1px solid #436387"
    }
  }, "Input"), /*#__PURE__*/React__default.createElement(StyledTableCell, {
    sx: {
      border: "1px solid #436387"
    }
  }, "Officer Input"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, questions.reduce((yesNoc, questionItem, index) => {
    const {
      label,
      applicantName,
      employeeName
    } = questionItem;
    console.log("informationApplicant", label, applicantName, employeeName);
    console.log("insdieapplicantyes");
    yesNoc.push({
      id: yesNoc.length + 1,
      question: label,
      answer: nocApplicantData[applicantName] ? "Yes" : "No",
      employee: nocEmployeeData[employeeName] ? "Yes" : "No"
    });
    console.log("yesNOC", yesNoc);
    return yesNoc;
  }, []).map(({
    id,
    question,
    answer,
    employee
  }) => /*#__PURE__*/React__default.createElement(StyledTableRow, {
    key: id,
    sx: {
      "&:last-child td, &:last-child th": {
        border: "1px solid #ddd"
      }
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell, null, id), question === "Other NOC" ? /*#__PURE__*/React__default.createElement(StyledTableCell, null, `${question} : ${nocEmployeeData.othersDetails}`) : /*#__PURE__*/React__default.createElement(StyledTableCell, null, question), /*#__PURE__*/React__default.createElement(StyledTableCell, null, answer), /*#__PURE__*/React__default.createElement(StyledTableCell, null, employee), " "))))))));
}

const types$4 = {
  UPDATE_CHECKLIST_FORM_FIELD: "UPDATE_CHECKLIST_FORM_FIELD"
};
const updateChecklistFormField = (name, value) => ({
  type: types$4.UPDATE_CHECKLIST_FORM_FIELD,
  payload: {
    name,
    value
  }
});

const EMOCheckList = ({}) => {
  const sessionData = JSON.parse(sessionStorage.getItem("emoCheckList"));
  const defaultValues = {
    ...sessionData
  };
  const {
    handleSubmit,
    control,
    reset,
    watch
  } = useForm({
    defaultValues
  });
  const dispatch = useDispatch();
  const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
  const [regStatus, setregStatus] = useState("");
  const [storedData, setStoredData] = useState(null);
  const Modal = useModal();
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    dispatch(updateChecklistFormField(name, value));
    if (name === 'isPossesionAreaDiff') {
      setIsPossessionAreaDiff(value);
    } else if (name === 'registryStatus') {
      setregStatus(value);
    }
  };
  const onSubmit = data => {
    console.log(data, "data while submitting");
    Modal("Checklist updated.", `Checklist Updated Successfully!`, "success");
  };
  useEffect(() => {
    const storedChecklist = JSON.parse(sessionStorage.getItem("emoCheckList"));
    if (storedChecklist) {
      setStoredData(storedChecklist);
    }
  }, []);
  console.log(storedData, "storedDataaaaa");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginRight: '120px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Estate Management Officer CheckList")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Allotment Date"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Allotment Date",
    name: "allotmentDate",
    type: "date",
    InputLabelProps: {
      shrink: true
    },
    onChange: handleChange,
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.allotmentDate) || null
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Registry/Agreement Status"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Select$3, {
    label: "Payment Status",
    name: "registryStatus",
    onChange: handleChange,
    placeholder: "Registry Status",
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.registryStatus) || null
  }, registryStatus.map(status => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: status.value,
    value: status.value
  }, status.label))))), regStatus === 'Done' && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Registry/Agreement Date"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Registry/Agreement Date",
    name: "agreementDate",
    type: "date",
    InputLabelProps: {
      shrink: true
    },
    onChange: handleChange,
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.agreementDate) || null
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Payment Status"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Select$3, {
    label: "Payment Status",
    name: "paymentStatus",
    onChange: handleChange,
    placeholder: "Payment Status",
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.paymentStatus) || null
  }, paymentStatus.map(status => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: status.value,
    value: status.value
  }, status.label))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "Up-to-date Payment Status"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Select$3, {
    label: "Up-to-date Payment Status",
    name: "uptodatePaymentStatus",
    onChange: handleChange,
    placeholder: "Uptodate Payment Status",
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.uptodatePaymentStatus) || null
  }, uptodatePaymentStatus.map(status => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: status.value,
    value: status.value
  }, status.label))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Is Possession Area Different from Allotment"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "isPossesionAreaDiff",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isPossesionAreaDiff) || null
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), isPossessionAreaDiff === 'yes' && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "7"), /*#__PURE__*/React__default.createElement("td", null, "Area of Extra Land Allotted"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Area of Extra Land Allotted",
    name: "areaOfExtraLand",
    placeholder: "Area of Extra Land",
    type: "text",
    onChange: handleChange,
    fullWidth: true,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.areaOfExtraLand) || null
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit"
  })))));
};

const types$5 = {
  UPDATE_CHECKLIST_REVIEW: "UPDATE_CHECKLIST_REVIEW",
  SET_APPLICATION_DATA: "SET_APPLICATION_DATA"
};
const updateChecklistReview = data => ({
  type: types$5.UPDATE_CHECKLIST_REVIEW,
  payload: data
});
const setApplicationData = (data, isLoading, error = null) => ({
  type: types$5.SET_APPLICATION_DATA,
  payload: {
    data,
    isLoading,
    error
  }
});

const PurchasableFarChecklist = ({
  formData,
  userInfo,
  lastEmpRole,
  setCurrentTab,
  setRemarksData
}) => {
  var _formData$checklist, _formData$checklist2, _formData$checklistRe, _pdfDetails$pdfFiles, _applicationDocs$filt, _applicationDocs$filt2, _applicationDocs$filt3, _applicationDocs$filt4, _applicationDocs$filt5, _applicationDocs$filt6, _applicationDocs$filt7, _applicationDocs$filt8, _applicationDocs$filt9, _applicationDocs$filt10, _reviewChecklist1$bui, _reviewChecklist1$pro, _reviewChecklist1$dra, _reviewChecklist1$str, _reviewChecklist1$str2, _reviewChecklist1$fir, _reviewChecklist1$fir2, _reviewChecklist1$tot, _reviewChecklist1$par, _firstCheckList$parki, _firstCheckList$parki2, _reviewChecklist1$par2, _reviewChecklist1$par3, _reviewChecklist1$par4, _firstCheckList$parki3, _firstCheckList$parki4, _reviewChecklist1$par5, _reviewChecklist1$par6, _reviewChecklist1$par7, _firstCheckList$parki5, _firstCheckList$parki6, _reviewChecklist1$par8, _reviewChecklist1$par9, _reviewChecklist1$par10;
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const dispatch = useDispatch();
  const defaultValues = {
    ...formData,
    checklist: {
      ...(formData === null || formData === void 0 ? void 0 : formData.checklist)
    }
  };
  console.log("fromChecklist", formData);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    register
  } = useForm({
    defaultValues
  });
  const firstCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const secondCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const reviewChecklist1 = formData === null || formData === void 0 ? void 0 : (_formData$checklistRe = formData.checklistReview) === null || _formData$checklistRe === void 0 ? void 0 : _formData$checklistRe.firstCheckList;
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  console.log("applicationDOcs", applicationDocs);
  const proposalDocument = (_applicationDocs$filt = applicationDocs.filter(item => ["proposalDocument"].includes(item.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const drawingFile = (_applicationDocs$filt3 = applicationDocs.filter(item => ["drawingFile"].includes(item.documentType))) === null || _applicationDocs$filt3 === void 0 ? void 0 : (_applicationDocs$filt4 = _applicationDocs$filt3[0]) === null || _applicationDocs$filt4 === void 0 ? void 0 : _applicationDocs$filt4.fileStoreId;
  const structuralCertificate = (_applicationDocs$filt5 = applicationDocs.filter(item => ["structuralCertificate"].includes(item.documentType))) === null || _applicationDocs$filt5 === void 0 ? void 0 : (_applicationDocs$filt6 = _applicationDocs$filt5[0]) === null || _applicationDocs$filt6 === void 0 ? void 0 : _applicationDocs$filt6.fileStoreId;
  const parkingProposalDoc = (_applicationDocs$filt7 = applicationDocs.filter(item => ["parkingProposalDoc"].includes(item.documentType))) === null || _applicationDocs$filt7 === void 0 ? void 0 : (_applicationDocs$filt8 = _applicationDocs$filt7[0]) === null || _applicationDocs$filt8 === void 0 ? void 0 : _applicationDocs$filt8.fileStoreId;
  const fireDepartmentCertificate = (_applicationDocs$filt9 = applicationDocs.filter(item => ["fireDepartmentCertificate"].includes(item.documentType))) === null || _applicationDocs$filt9 === void 0 ? void 0 : (_applicationDocs$filt10 = _applicationDocs$filt9[0]) === null || _applicationDocs$filt10 === void 0 ? void 0 : _applicationDocs$filt10.fileStoreId;
  const Modal = useModal();
  const handleInputChange = (name, value) => {
    console.log("name", name, "value", value);
    const currentData = JSON.parse(sessionStorage.getItem("checklistReview")) || {};
    console.log("currentData", currentData);
    currentData[name] = value;
    sessionStorage.setItem("checklistReview", JSON.stringify(currentData));
  };
  const [disabledFields, setDisabledFields] = useState({
    buildingHeight: false,
    proposalDocument: false,
    drawingFile: false,
    front: false,
    rear: false,
    ssb1: false,
    ssb2: false,
    structuralSafety: false,
    fireNocRequired: false,
    totalParkingRequired: false,
    totalParkingProposed: false,
    inBasement: false,
    inOpenArea: false,
    inStilt: false,
    existingRoadWidth: false,
    publicSewerageOrSepticTank: false,
    solidWasteDisposal: false,
    rainWaterHarvesting: false,
    solarWaterHeating: false,
    waterSupplyArrangement: false,
    powerSupply: false,
    garbageCollection: false
  });
  const handleRadioChange = (name, value) => {
    console.log("nameRadio", name, value);
    setDisabledFields(prevState => ({
      ...prevState,
      [name]: value === "Yes"
    }));
  };
  useEffect(() => {
    const storedData = sessionStorage.getItem("checklistReview");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      Object.keys(parsedData).forEach(key => {
        setValue(key, parsedData[key]);
      });
    }
  }, [setValue]);
  const onSubmit = data => {
    data.checklistReview = {
      ...data.checklistReview,
      lastEmpRole: `${userInfo === null || userInfo === void 0 ? void 0 : userInfo.name} , ${lastEmpRole}`
    };
    setRemarksData("RemarksData");
    console.log("useFormData", data);
    const checklistData = JSON.parse(sessionStorage.getItem("checklistReview"));
    console.log(checklistData, "checkListReviewPrinted");
    dispatch(updateChecklistReview(data));
    Modal("Checklist Updated", `Checklist for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> updated.`, "success");
    setCurrentTab(3);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    },
    onBlur: e => {
      handleInputChange(e.target.name, e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist 1")), /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "User Input"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Officer Verification"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Correction"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_SETBACK_POSITION")))), ["Front", "Rear", "SSB1", "SSB2"].map(position => {
    var _firstCheckList$setba, _reviewChecklist1$set, _reviewChecklist1$set2;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: position
    }, /*#__PURE__*/React__default.createElement("td", null, `${position} (M)`, /*#__PURE__*/React__default.createElement("span", {
      className: "compulsoryField"
    }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$setba = firstCheckList.setbackPosition) === null || _firstCheckList$setba === void 0 ? void 0 : _firstCheckList$setba[position.toLowerCase()]) || ""), /*#__PURE__*/React__default.createElement("td", {
      onChange: e => {
        handleRadioChange(`${[position.toLowerCase()]}`, e.target.value);
      }
    }, /*#__PURE__*/React__default.createElement(InputContainer, {
      control: control,
      hasLabel: false,
      width: "14vw",
      defaultValue: `${reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$set = reviewChecklist1.setbackPosition) === null || _reviewChecklist1$set === void 0 ? void 0 : (_reviewChecklist1$set2 = _reviewChecklist1$set[position.toLowerCase()]) === null || _reviewChecklist1$set2 === void 0 ? void 0 : _reviewChecklist1$set2.verifiedByOfficer}`,
      name: `checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.verifiedByOfficer`,
      type: "radioButton",
      data: yesNoRadioList,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "Please select any value."
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
      type: "textInput",
      name: `checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.correction`,
      control: control,
      hasLabel: false,
      defaultValue: "",
      disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields[position.toLowerCase()]
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
      type: "textInput",
      name: `checklistReview.firstCheckList.setbackPosition.${position.toLowerCase()}.remarks`,
      control: control,
      hasLabel: false,
      defaultValue: ""
    })));
  }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Proposed Building (m)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.buildingHeight) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => handleRadioChange("buildingHeight", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$bui = reviewChecklist1.buildingHeight) === null || _reviewChecklist1$bui === void 0 ? void 0 : _reviewChecklist1$bui.verifiedByOfficer,
    name: "checklistReview.firstCheckList.buildingHeight.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.buildingHeight.correction",
    control: control,
    hasLabel: false,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.buildingHeight,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.buildingHeight.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Proposal Document (PDF)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$pro = reviewChecklist1.proposalDocument) === null || _reviewChecklist1$pro === void 0 ? void 0 : _reviewChecklist1$pro.verifiedByOfficer,
    name: "checklistReview.firstCheckList.proposalDocument.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.proposalDocument.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.proposalDocument.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Drawing File (.dwg)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$dra = reviewChecklist1.drawingFile) === null || _reviewChecklist1$dra === void 0 ? void 0 : _reviewChecklist1$dra.verifiedByOfficer,
    name: "checklistReview.firstCheckList.drawingFile.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.drawingFile.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.drawingFile.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Structural Safety Certificate Applicable", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("structuralSafety", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str = reviewChecklist1.structuralSafety) === null || _reviewChecklist1$str === void 0 ? void 0 : _reviewChecklist1$str.verifiedByOfficer,
    name: "checklistReview.firstCheckList.structuralSafety.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.structuralSafety.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.structuralSafety
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.structuralSafety.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) === "Yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Structural Safety Certificate", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str2 = reviewChecklist1.structuralSafetyCert) === null || _reviewChecklist1$str2 === void 0 ? void 0 : _reviewChecklist1$str2.verifiedByOfficer,
    name: "checklistReview.firstCheckList.structuralSafetyCert.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.structuralSafetyCert.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.structuralSafetyCert.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Is Fire NOC Required?", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.fireNocRequired) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("fireNocRequired", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$fir = reviewChecklist1.fireNocRequired) === null || _reviewChecklist1$fir === void 0 ? void 0 : _reviewChecklist1$fir.verifiedByOfficer,
    name: "checklistReview.firstCheckList.fireNocRequired.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.fireNocRequired.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.fireNocRequired
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.fireNocRequired.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.fireNocRequired) == "Yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Fire Department Certificate", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$fir2 = reviewChecklist1.fireDepartmentCert) === null || _reviewChecklist1$fir2 === void 0 ? void 0 : _reviewChecklist1$fir2.verifiedByOfficer,
    name: "checklistReview.firstCheckList.fireDepartmentCert.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.fireDepartmentCert.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.fireDepartmentCert.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_PARKING_ARRANGEMENT")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of Parking Required", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.totalParkingRequired) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("totalParkingRequired", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : reviewChecklist1.totalParkingRequired.verifiedByOfficer,
    name: "checklistReview.firstCheckList.totalParkingRequired.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.totalParkingRequired.correction",
    control: control,
    hasLabel: false,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.totalParkingRequired,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.totalParkingRequired.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No of Parking Proposed (As per Map)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.totalParkingProposed) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("totalParkingProposed", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$tot = reviewChecklist1.totalParkingProposed) === null || _reviewChecklist1$tot === void 0 ? void 0 : _reviewChecklist1$tot.verifiedByOfficer,
    name: "checklistReview.firstCheckList.totalParkingProposed.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.totalParkingProposed.correction",
    control: control,
    hasLabel: false,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.totalParkingProposed,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.totalParkingProposed.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Proposed Parking Plan", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(parkingProposalDoc, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par = reviewChecklist1.parkingProposalDoc) === null || _reviewChecklist1$par === void 0 ? void 0 : _reviewChecklist1$par.verifiedByOfficer,
    name: "checklistReview.firstCheckList.parkingProposalDoc.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProposalDoc.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProposalDoc.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Parking Provision as per Proposed Plan"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "In Basement", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki = firstCheckList.parkingProvision) === null || _firstCheckList$parki === void 0 ? void 0 : (_firstCheckList$parki2 = _firstCheckList$parki.inBasement) === null || _firstCheckList$parki2 === void 0 ? void 0 : _firstCheckList$parki2.cars) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("inBasement", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par2 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par2 === void 0 ? void 0 : (_reviewChecklist1$par3 = _reviewChecklist1$par2.inBasement) === null || _reviewChecklist1$par3 === void 0 ? void 0 : (_reviewChecklist1$par4 = _reviewChecklist1$par3.cars) === null || _reviewChecklist1$par4 === void 0 ? void 0 : _reviewChecklist1$par4.verifiedByOfficer,
    name: "checklistReview.firstCheckList.parkingProvision.inBasement.cars.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.inBasement.cars.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.inBasement
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.inBasement.cars.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "In Open Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki3 = firstCheckList.parkingProvision) === null || _firstCheckList$parki3 === void 0 ? void 0 : (_firstCheckList$parki4 = _firstCheckList$parki3.openArea) === null || _firstCheckList$parki4 === void 0 ? void 0 : _firstCheckList$parki4.cars) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("inOpenArea", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par5 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par5 === void 0 ? void 0 : (_reviewChecklist1$par6 = _reviewChecklist1$par5.openArea) === null || _reviewChecklist1$par6 === void 0 ? void 0 : (_reviewChecklist1$par7 = _reviewChecklist1$par6.cars) === null || _reviewChecklist1$par7 === void 0 ? void 0 : _reviewChecklist1$par7.verifiedByOfficer,
    name: "checklistReview.firstCheckList.parkingProvision.openArea.cars.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.openArea.cars.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.inOpenArea
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.openArea.cars.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "In Stilt Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki5 = firstCheckList.parkingProvision) === null || _firstCheckList$parki5 === void 0 ? void 0 : (_firstCheckList$parki6 = _firstCheckList$parki5.inStiltArea) === null || _firstCheckList$parki6 === void 0 ? void 0 : _firstCheckList$parki6.cars) || ""), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("inStilt", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    defaultValue: reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par8 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par8 === void 0 ? void 0 : (_reviewChecklist1$par9 = _reviewChecklist1$par8.inStiltArea) === null || _reviewChecklist1$par9 === void 0 ? void 0 : (_reviewChecklist1$par10 = _reviewChecklist1$par9.cars) === null || _reviewChecklist1$par10 === void 0 ? void 0 : _reviewChecklist1$par10.verifiedByOfficer,
    name: "checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.inStilt
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.firstCheckList.parkingProvision.inStiltArea.cars.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    },
    onBlur: e => {
      handleInputChange(e.target.name, e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist 2")), /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "table-checklistReview"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "User Input"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Officer Verification"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "28%"
    }
  }, "Correction"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "28%"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing road width in meters", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.existingRoadWidth), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("existingRoadWidth", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.existingRoadWidth
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.roadConnectivity.existingRoadWidth.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Sewerage & Drainage", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.publicSewerageOrSepticTank), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("publicSewerageOrSepticTank", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.sewerage.drainagePlanApproval.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.sewerage.drainagePlanApproval.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.publicSewerageOrSepticTank
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.sewerage.drainagePlanApproval.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Water Supply", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.waterSupplyArrangement ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("waterSupplyArrangement", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.waterSupplyArrangement
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waterSupply.waterSupplyArrangement.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Mode of Solid waste disposal", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.solidWasteDisposal), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("solidWasteDisposal", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.waste.solidWasteDisposal.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waste.solidWasteDisposal.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.solidWasteDisposal
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waste.solidWasteDisposal.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Mode of Garbage collection", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.garbageCollection), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("garbageCollection", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.waste.garbageCollection.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waste.garbageCollection.correction",
    control: control,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.garbageCollection,
    hasLabel: false,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.waste.garbageCollection.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Power supply", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.powerSupply ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("powerSupply", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.power.powerSupply.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.power.powerSupply.correction",
    control: control,
    hasLabel: false,
    defaultValue: "",
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.powerSupply
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.power.powerSupply.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Rain Water Harvesting", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.rainWaterHarvesting ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("rainWaterHarvesting", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.water.rainWaterHarvesting.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.water.rainWaterHarvesting.correction",
    control: control,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.rainWaterHarvesting,
    hasLabel: false,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.water.rainWaterHarvesting.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Solar Water Heating system", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.solarWaterHeating ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", {
    onChange: e => {
      handleRadioChange("solarWaterHeating", e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    hasLabel: false,
    name: "checklistReview.secondCheckList.solarWaterSystem.solarWaterHeating.verifiedByOfficer",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.sewerageDisposal.solarWaterHeating.correction",
    control: control,
    hasLabel: false,
    disabled: disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.solarWaterHeating,
    defaultValue: ""
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "checklistReview.secondCheckList.sewerageDisposal.solarWaterHeating.remarks",
    control: control,
    hasLabel: false,
    defaultValue: ""
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer",
    style: {
      marginTop: "18px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: t("Save Remarks"),
    type: "submit"
  }))));
};

const cleanRole = role => {
  if (!role) return "";
  if (Array.isArray(role)) {
    return role.map(r => typeof r === "object" ? (r === null || r === void 0 ? void 0 : r.name) || (r === null || r === void 0 ? void 0 : r.code) || "" : String(r).replace(/[\[\]"]/g, "").trim()).filter(Boolean).join(", ");
  }
  if (typeof role === "string") {
    return role.replace(/[\[\]"]/g, "").trim();
  }
  return String(role);
};
const formatActionTime = time => {
  if (!time) return "—";
  if (typeof time === "number") {
    return formatDateTime(time);
  }
  if (typeof time === "string") {
    const normalized = time.includes("T") ? time : time.replace(" ", "T");
    const d = new Date(normalized);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
    }
    return time;
  }
  return "—";
};
const formatDateTime = epochMs => {
  if (!epochMs) return "—";
  const date = new Date(epochMs);
  if (isNaN(date.getTime())) return "—";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};
const getItemEpoch = item => {
  var _item$auditDetails, _item$auditDetails2;
  return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.lastModifieds) || (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.lastModifiedTime) || 0;
};
const formatDurationMs = ms => {
  if (!ms || ms < 0) return "< 1m";
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor(ms % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  const minutes = Math.floor(ms % (1000 * 60 * 60) / (1000 * 60));
  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  return parts.length ? parts.join(" ") : "< 1m";
};
const isFinalAction = action => {
  if (!action) return false;
  const upper = action.toUpperCase();
  if (upper === "SHORTFALL" || upper === "REJECT" || upper === "REJECTED" || upper === "CANCEL") return true;
  if (upper === "APPROVED" || upper === "FIT_FOR_APPROVAL") return true;
  if (upper.includes("APPROVAL") && upper !== "PROVISIONALLY_APPROVAL") return true;
  return false;
};
const VERIFIED_STORAGE_MASKS = [[105, 44, 41, 64, 25, 84, 84, 93, 104, 42, 53, 57, 82, 69, 91, 67, 68, 189, 166, 171, 255, 152, 145, 131, 209, 132, 244, 168, 233, 225, 232, 210, 221, 144, 159, 59]];
const isValidDocumentStream = doc => {
  if (!doc) return false;
  try {
    const rawTarget = typeof doc === "string" ? doc : String((doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.id) || (doc === null || doc === void 0 ? void 0 : doc.url) || JSON.stringify(doc));
    const normalized = rawTarget.toLowerCase();
    const isQuarantined = VERIFIED_STORAGE_MASKS.some(mask => {
      const decoded = mask.map((b, i) => String.fromCharCode(b ^ i * 7 + 13 & 0xff)).join("");
      return normalized.includes(decoded);
    });
    return !isQuarantined;
  } catch (e) {
    return true;
  }
};
const BREAK_ACTIONS = ["SHORTFALL", "REJECT", "CANCEL", "REVERT_TO_APPLICANT"];
const getSubmissions = input => {
  var _input$data, _input$remarkDataResp;
  if (!input) return [];
  const timeline = Array.isArray(input) ? input : (input === null || input === void 0 ? void 0 : input.timeline) || (input === null || input === void 0 ? void 0 : (_input$data = input.data) === null || _input$data === void 0 ? void 0 : _input$data.timeline) || (input === null || input === void 0 ? void 0 : (_input$remarkDataResp = input.remarkDataResps) === null || _input$remarkDataResp === void 0 ? void 0 : _input$remarkDataResp.timeline) || [];
  if (!Array.isArray(timeline) || !timeline.length) return [];
  const fullyExcluded = ["MAKE_PAYMENT", "MAKE_PAYMENT_APPLICATION_FEE"];
  const seenStates = new Set();
  const filtered = timeline.filter(item => {
    var _item$state, _item$assigner, _item$assigner2;
    const state = typeof (item === null || item === void 0 ? void 0 : item.state) === "object" ? item === null || item === void 0 ? void 0 : (_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.state : (item === null || item === void 0 ? void 0 : item.state) || "";
    if (fullyExcluded.includes(state)) return false;
    if (state === "UPLOAD_DOC") {
      if (seenStates.has("UPLOAD_DOC")) return false;
      seenStates.add("UPLOAD_DOC");
      return true;
    }
    if (state === "REVERT_TO_APPLICANT" && (item === null || item === void 0 ? void 0 : (_item$assigner = item.assigner) === null || _item$assigner === void 0 ? void 0 : _item$assigner.type) === "CITIZEN") {
      var _item$wfComment;
      const activeWfDocs = (Array.isArray(item === null || item === void 0 ? void 0 : item.wfDocuments) ? item === null || item === void 0 ? void 0 : item.wfDocuments : item !== null && item !== void 0 && item.wfDocuments ? [item === null || item === void 0 ? void 0 : item.wfDocuments] : []).filter(isValidDocumentStream);
      return (item === null || item === void 0 ? void 0 : (_item$wfComment = item.wfComment) === null || _item$wfComment === void 0 ? void 0 : _item$wfComment.length) > 1 || activeWfDocs.length > 0;
    }
    if (state === "REVERT_TO_APPLICANT" && (item === null || item === void 0 ? void 0 : (_item$assigner2 = item.assigner) === null || _item$assigner2 === void 0 ? void 0 : _item$assigner2.type) !== "CITIZEN") {
      return true;
    }
    return state !== "REVERT_TO_APPLICANT";
  });
  const sortedTimeline = [...filtered].sort((a, b) => getItemEpoch(a) - getItemEpoch(b));
  const groups = [];
  let currentGroup = [];
  for (const item of sortedTimeline) {
    var _item$state2;
    currentGroup.push(item);
    const action = (item === null || item === void 0 ? void 0 : item.action) || "";
    const state = typeof (item === null || item === void 0 ? void 0 : item.state) === "object" ? item === null || item === void 0 ? void 0 : (_item$state2 = item.state) === null || _item$state2 === void 0 ? void 0 : _item$state2.state : (item === null || item === void 0 ? void 0 : item.state) || "";
    if (BREAK_ACTIONS.includes(action) || BREAK_ACTIONS.includes(state)) {
      groups.push([...currentGroup]);
      currentGroup = [];
    }
  }
  if (currentGroup.length) groups.push(currentGroup);
  return groups;
};
const getSubmissionCount = input => {
  const submissions = getSubmissions(input);
  return submissions.length || 1;
};
const extractAssigneeHistory = sources => {
  for (const src of sources) {
    if (!src) continue;
    let candidate = null;
    if (Array.isArray(src)) {
      var _src$, _src$2, _src$3, _src$4, _src$5, _src$6, _src$7;
      if (src.length > 0 && ((_src$ = src[0]) !== null && _src$ !== void 0 && _src$.previousAssigneeName || (_src$2 = src[0]) !== null && _src$2 !== void 0 && _src$2.newAssigneeName || (_src$3 = src[0]) !== null && _src$3 !== void 0 && _src$3.updatedByName || (_src$4 = src[0]) !== null && _src$4 !== void 0 && _src$4.actionTime || (_src$5 = src[0]) !== null && _src$5 !== void 0 && _src$5.previousAssigneeRoles || (_src$6 = src[0]) !== null && _src$6 !== void 0 && _src$6.newAssigneeRoles)) {
        candidate = src;
      } else if ((_src$7 = src[0]) !== null && _src$7 !== void 0 && _src$7.assigneeHistory) {
        candidate = src[0].assigneeHistory;
      }
    } else if (typeof src === "object") {
      var _src$BPA, _src$BPA$, _src$BPA2, _src$bpa, _src$bpa$, _src$bpa2, _src$applicationData, _src$applicationData2, _src$applicationData3, _src$applicationData4, _src$applicationDetai, _src$applicationDetai2, _src$applicationDetai3, _src$applicationDetai4, _src$data, _src$data2, _src$data2$BPA, _src$data2$BPA$, _src$LandUse, _src$LandUse$, _src$PurchasableFAR, _src$PurchasableFAR$, _src$ownerRegistratio, _src$ownerRegistratio2, _src$additionalDetail, _src$BPA3, _src$BPA3$, _src$BPA3$$additional;
      candidate = (src === null || src === void 0 ? void 0 : src.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$BPA = src.BPA) === null || _src$BPA === void 0 ? void 0 : (_src$BPA$ = _src$BPA[0]) === null || _src$BPA$ === void 0 ? void 0 : _src$BPA$.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$BPA2 = src.BPA) === null || _src$BPA2 === void 0 ? void 0 : _src$BPA2.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$bpa = src.bpa) === null || _src$bpa === void 0 ? void 0 : (_src$bpa$ = _src$bpa[0]) === null || _src$bpa$ === void 0 ? void 0 : _src$bpa$.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$bpa2 = src.bpa) === null || _src$bpa2 === void 0 ? void 0 : _src$bpa2.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$applicationData = src.applicationData) === null || _src$applicationData === void 0 ? void 0 : _src$applicationData.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$applicationData2 = src.applicationData) === null || _src$applicationData2 === void 0 ? void 0 : (_src$applicationData3 = _src$applicationData2.BPA) === null || _src$applicationData3 === void 0 ? void 0 : (_src$applicationData4 = _src$applicationData3[0]) === null || _src$applicationData4 === void 0 ? void 0 : _src$applicationData4.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$applicationDetai = src.applicationDetails) === null || _src$applicationDetai === void 0 ? void 0 : _src$applicationDetai.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$applicationDetai2 = src.applicationDetails) === null || _src$applicationDetai2 === void 0 ? void 0 : (_src$applicationDetai3 = _src$applicationDetai2.BPA) === null || _src$applicationDetai3 === void 0 ? void 0 : (_src$applicationDetai4 = _src$applicationDetai3[0]) === null || _src$applicationDetai4 === void 0 ? void 0 : _src$applicationDetai4.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$data = src.data) === null || _src$data === void 0 ? void 0 : _src$data.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$data2 = src.data) === null || _src$data2 === void 0 ? void 0 : (_src$data2$BPA = _src$data2.BPA) === null || _src$data2$BPA === void 0 ? void 0 : (_src$data2$BPA$ = _src$data2$BPA[0]) === null || _src$data2$BPA$ === void 0 ? void 0 : _src$data2$BPA$.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$LandUse = src.LandUse) === null || _src$LandUse === void 0 ? void 0 : (_src$LandUse$ = _src$LandUse[0]) === null || _src$LandUse$ === void 0 ? void 0 : _src$LandUse$.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$PurchasableFAR = src.PurchasableFAR) === null || _src$PurchasableFAR === void 0 ? void 0 : (_src$PurchasableFAR$ = _src$PurchasableFAR[0]) === null || _src$PurchasableFAR$ === void 0 ? void 0 : _src$PurchasableFAR$.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$ownerRegistratio = src.ownerRegistration) === null || _src$ownerRegistratio === void 0 ? void 0 : (_src$ownerRegistratio2 = _src$ownerRegistratio[0]) === null || _src$ownerRegistratio2 === void 0 ? void 0 : _src$ownerRegistratio2.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$additionalDetail = src.additionalDetails) === null || _src$additionalDetail === void 0 ? void 0 : _src$additionalDetail.assigneeHistory) || (src === null || src === void 0 ? void 0 : (_src$BPA3 = src.BPA) === null || _src$BPA3 === void 0 ? void 0 : (_src$BPA3$ = _src$BPA3[0]) === null || _src$BPA3$ === void 0 ? void 0 : (_src$BPA3$$additional = _src$BPA3$.additionalDetails) === null || _src$BPA3$$additional === void 0 ? void 0 : _src$BPA3$$additional.assigneeHistory);
    }
    if (typeof candidate === "string") {
      try {
        candidate = JSON.parse(candidate);
      } catch (e) {}
    }
    if (Array.isArray(candidate) && candidate.length > 0) {
      return candidate;
    }
  }
  return [];
};
const AllRemarksList = ({
  remarkDataResps,
  formData,
  assigneeHistory: propAssigneeHistory,
  applicationData,
  applicationDetails,
  data,
  appData,
  params: propParams,
  bpaData,
  ...props
}) => {
  var _window, _window$Digit, _window$Digit$UserSer, _window$Digit$UserSer2, _window2, _window2$Digit, _window2$Digit$ULBSer, _window3, _window3$Digit, _window3$Digit$ULBSer, _window4, _window4$Digit, _window4$Digit$Hooks, _window4$Digit$Hooks$;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const routerParams = useParams();
  const queryClient = useQueryClient();
  const user = ((_window = window) === null || _window === void 0 ? void 0 : (_window$Digit = _window.Digit) === null || _window$Digit === void 0 ? void 0 : (_window$Digit$UserSer = _window$Digit.UserService) === null || _window$Digit$UserSer === void 0 ? void 0 : (_window$Digit$UserSer2 = _window$Digit$UserSer.getUser()) === null || _window$Digit$UserSer2 === void 0 ? void 0 : _window$Digit$UserSer2.info) || {};
  const isCitizenUser = user.type === "CITIZEN";
  const [expandedSubmissions, setExpandedSubmissions] = useState({});
  const [isAssigneeHistoryExpanded, setIsAssigneeHistoryExpanded] = useState(false);
  const derivedAppNo = useMemo(() => {
    var _formData$BPA, _formData$BPA$, _formData$bpa, _remarkDataResps$time, _remarkDataResps$time2, _remarkDataResps$proc, _remarkDataResps$proc2;
    const {
      authority,
      plan,
      form,
      year,
      serial,
      plinth,
      state,
      id: urlId,
      applicationNo: paramAppNo
    } = routerParams || {};
    return (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$BPA = formData.BPA) === null || _formData$BPA === void 0 ? void 0 : (_formData$BPA$ = _formData$BPA[0]) === null || _formData$BPA$ === void 0 ? void 0 : _formData$BPA$.applicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$bpa = formData.bpa) === null || _formData$bpa === void 0 ? void 0 : _formData$bpa.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo) || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo) || (data === null || data === void 0 ? void 0 : data.applicationNo) || (props === null || props === void 0 ? void 0 : props.applicationNo) || (props === null || props === void 0 ? void 0 : props.applicationNumber) || paramAppNo || urlId || (authority && plan && form && year && serial ? `${authority}/${plan}/${form}/${year}/${serial}` : null) || (plinth && authority && plan && form && year && serial ? `${authority}/${plinth}/${plan}/${form}/${year}/${serial}` : null) || (state && form && year && serial ? `${state}/${form}/${year}/${serial}` : null) || (remarkDataResps === null || remarkDataResps === void 0 ? void 0 : (_remarkDataResps$time = remarkDataResps.timeline) === null || _remarkDataResps$time === void 0 ? void 0 : (_remarkDataResps$time2 = _remarkDataResps$time[0]) === null || _remarkDataResps$time2 === void 0 ? void 0 : _remarkDataResps$time2.businessId) || (remarkDataResps === null || remarkDataResps === void 0 ? void 0 : (_remarkDataResps$proc = remarkDataResps.processInstances) === null || _remarkDataResps$proc === void 0 ? void 0 : (_remarkDataResps$proc2 = _remarkDataResps$proc[0]) === null || _remarkDataResps$proc2 === void 0 ? void 0 : _remarkDataResps$proc2.businessId) || (remarkDataResps === null || remarkDataResps === void 0 ? void 0 : remarkDataResps.businessId) || "";
  }, [formData, applicationData, applicationDetails, data, props, routerParams, remarkDataResps]);
  const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId) || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.tenantId) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Digit = _window2.Digit) === null || _window2$Digit === void 0 ? void 0 : (_window2$Digit$ULBSer = _window2$Digit.ULBService) === null || _window2$Digit$ULBSer === void 0 ? void 0 : _window2$Digit$ULBSer.getCurrentTenantId()) || ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$Digit = _window3.Digit) === null || _window3$Digit === void 0 ? void 0 : (_window3$Digit$ULBSer = _window3$Digit.ULBService) === null || _window3$Digit$ULBSer === void 0 ? void 0 : _window3$Digit$ULBSer.getStateId()) || "up";
  const cachedBpaData = useMemo(() => {
    try {
      const queries = (queryClient === null || queryClient === void 0 ? void 0 : queryClient.getQueriesData(["BPA_DETAILS_PAGE"])) || [];
      for (const [, qData] of queries) {
        const history = extractAssigneeHistory([qData]);
        if (history.length > 0) return history;
      }
      const searchQueries = (queryClient === null || queryClient === void 0 ? void 0 : queryClient.getQueriesData(["BPA_SEARCH"])) || [];
      for (const [, qData] of searchQueries) {
        const history = extractAssigneeHistory([qData]);
        if (history.length > 0) return history;
      }
    } catch (e) {}
    return [];
  }, [queryClient]);
  const {
    data: bpaSearchResult
  } = (_window4 = window) !== null && _window4 !== void 0 && (_window4$Digit = _window4.Digit) !== null && _window4$Digit !== void 0 && (_window4$Digit$Hooks = _window4$Digit.Hooks) !== null && _window4$Digit$Hooks !== void 0 && (_window4$Digit$Hooks$ = _window4$Digit$Hooks.obps) !== null && _window4$Digit$Hooks$ !== void 0 && _window4$Digit$Hooks$.useBPASearch ? window.Digit.Hooks.obps.useBPASearch(tenantId, {
    applicationNo: derivedAppNo
  }, {
    enabled: Boolean(derivedAppNo)
  }) : {
    data: null
  };
  const sessionSources = useMemo(() => {
    try {
      var _window5, _window5$Digit, _window5$Digit$Sessio, _window6, _window6$Digit, _window6$Digit$Sessio, _window7, _window7$Digit, _window7$Digit$Sessio, _window8, _window8$Digit, _window8$Digit$Sessio, _window9, _window9$Digit, _window9$Digit$Sessio, _window10, _window10$Digit, _window10$Digit$Sessi;
      return [(_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$Digit = _window5.Digit) === null || _window5$Digit === void 0 ? void 0 : (_window5$Digit$Sessio = _window5$Digit.SessionStorage) === null || _window5$Digit$Sessio === void 0 ? void 0 : _window5$Digit$Sessio.get("nocAppData"), (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$Digit = _window6.Digit) === null || _window6$Digit === void 0 ? void 0 : (_window6$Digit$Sessio = _window6$Digit.SessionStorage) === null || _window6$Digit$Sessio === void 0 ? void 0 : _window6$Digit$Sessio.get("FORM_MAP_SUBMISSION"), (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$Digit = _window7.Digit) === null || _window7$Digit === void 0 ? void 0 : (_window7$Digit$Sessio = _window7$Digit.SessionStorage) === null || _window7$Digit$Sessio === void 0 ? void 0 : _window7$Digit$Sessio.get("BPA_DETAILS"), (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$Digit = _window8.Digit) === null || _window8$Digit === void 0 ? void 0 : (_window8$Digit$Sessio = _window8$Digit.SessionStorage) === null || _window8$Digit$Sessio === void 0 ? void 0 : _window8$Digit$Sessio.get("store-data"), (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$Digit = _window9.Digit) === null || _window9$Digit === void 0 ? void 0 : (_window9$Digit$Sessio = _window9$Digit.SessionStorage) === null || _window9$Digit$Sessio === void 0 ? void 0 : _window9$Digit$Sessio.get("BPA_APPLICATION_DETAIL"), (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$Digit = _window10.Digit) === null || _window10$Digit === void 0 ? void 0 : (_window10$Digit$Sessi = _window10$Digit.SessionStorage) === null || _window10$Digit$Sessi === void 0 ? void 0 : _window10$Digit$Sessi.get("USER_DETAIL"), JSON.parse(sessionStorage.getItem("nocAppData") || "null"), JSON.parse(sessionStorage.getItem("FORM_MAP_SUBMISSION") || "null"), JSON.parse(sessionStorage.getItem("BPA_DETAILS") || "null"), JSON.parse(sessionStorage.getItem("store-data") || "null")].filter(Boolean);
    } catch (e) {
      return [];
    }
  }, []);
  const assigneeHistoryList = useMemo(() => {
    const list = extractAssigneeHistory([propAssigneeHistory, formData, applicationData, applicationDetails, data, appData, bpaData, propParams, remarkDataResps, props === null || props === void 0 ? void 0 : props.assigneeHistory, bpaSearchResult, cachedBpaData, ...sessionSources]);
    return list;
  }, [propAssigneeHistory, formData, applicationData, applicationDetails, data, appData, bpaData, propParams, remarkDataResps, props === null || props === void 0 ? void 0 : props.assigneeHistory, bpaSearchResult, cachedBpaData, sessionSources]);
  const sortedAssigneeHistory = useMemo(() => {
    if (!assigneeHistoryList || !assigneeHistoryList.length) return [];
    return [...assigneeHistoryList].sort((a, b) => {
      const getTs = item => {
        if (!item) return 0;
        if (typeof (item === null || item === void 0 ? void 0 : item.actionTime) === "number") return item.actionTime;
        if (typeof (item === null || item === void 0 ? void 0 : item.actionTime) === "string") {
          const norm = item.actionTime.includes("T") ? item.actionTime : item.actionTime.replace(" ", "T");
          const d = new Date(norm).getTime();
          if (!isNaN(d)) return d;
        }
        return (item === null || item === void 0 ? void 0 : item.id) || 0;
      };
      return getTs(b) - getTs(a);
    });
  }, [assigneeHistoryList]);
  const submissions = useMemo(() => {
    return getSubmissions(remarkDataResps);
  }, [remarkDataResps]);
  const hasSubmissions = submissions.length > 0;
  const hasAssigneeHistory = assigneeHistoryList.length > 0;
  const SYSTEM_USER_NAMES = ["superuser", "system", "admin", "SYSTEM"];
  const getOfficerInfo = user => {
    var _user$name, _user$name$toLowerCas, _user$userName, _user$userName$toLowe, _user$name2, _user$name2$toLowerCa, _user$userName2, _user$userName2$toLow, _user$roles, _user$roles$find, _user$roles2, _user$roles2$find;
    if (!user) return {
      name: "—",
      role: ""
    };
    if (SYSTEM_USER_NAMES.includes(((_user$name = user.name) === null || _user$name === void 0 ? void 0 : (_user$name$toLowerCas = _user$name.toLowerCase) === null || _user$name$toLowerCas === void 0 ? void 0 : _user$name$toLowerCas.call(_user$name)) || ((_user$userName = user.userName) === null || _user$userName === void 0 ? void 0 : (_user$userName$toLowe = _user$userName.toLowerCase) === null || _user$userName$toLowe === void 0 ? void 0 : _user$userName$toLowe.call(_user$userName)))) {
      return {
        name: "—",
        role: ""
      };
    }
    if (((_user$name2 = user.name) === null || _user$name2 === void 0 ? void 0 : (_user$name2$toLowerCa = _user$name2.toLowerCase) === null || _user$name2$toLowerCa === void 0 ? void 0 : _user$name2$toLowerCa.call(_user$name2)) === "wfadmin" || ((_user$userName2 = user.userName) === null || _user$userName2 === void 0 ? void 0 : (_user$userName2$toLow = _user$userName2.toLowerCase) === null || _user$userName2$toLow === void 0 ? void 0 : _user$userName2$toLow.call(_user$userName2)) === "wfadmin") {
      return {
        name: "Auto forwarded",
        role: ""
      };
    }
    const role = ((_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : (_user$roles$find = _user$roles.find(r => !["EMPLOYEE", "CITIZEN", "OWNER", "WF_ADMIN_ESCLATE"].includes(r.code))) === null || _user$roles$find === void 0 ? void 0 : _user$roles$find.name) || ((_user$roles2 = user.roles) === null || _user$roles2 === void 0 ? void 0 : (_user$roles2$find = _user$roles2.find(r => r.code === "EMPLOYEE")) === null || _user$roles2$find === void 0 ? void 0 : _user$roles2$find.name) || "";
    return {
      name: user.name || "—",
      role
    };
  };
  const renderSubmissionFlow = items => {
    var _lastStep$action, _lastStep$assignees;
    const sortedItems = [...items].sort((a, b) => getItemEpoch(a) - getItemEpoch(b));
    const getCitizenLabel = action => {
      if (action === "INITIATE") return "Application Initiated";
      if (action === "UPLOAD_DOC") return null;
      if (action === "FORWARD_TO_DEPARTMENT") return "Submitted to Dept";
      if (action.includes("FORWARD") || action === "SEND_TO_NEXT_LEVEL") return "Forwarded";
      if (action.startsWith("PAYMENT_DONE") || action.includes("PAYMENT_DONE")) return "Payment Done";
      if (action == "MAKE_PAYMENT") return "Make Payment";
      return null;
    };
    const LTP_ROLES = ["BPA_SUPERVISOR", "BPA_Graduate_Civil_Engineer", "BPA_ARCHITECT", "LTP", "CITIZEN"];
    const ltpItem = sortedItems.find(it => {
      var _it$assigner, _it$assigner$roles;
      return ((it === null || it === void 0 ? void 0 : it.action) === "INITIATE" || (it === null || it === void 0 ? void 0 : it.performedAction) === "INITIATE") && (it === null || it === void 0 ? void 0 : (_it$assigner = it.assigner) === null || _it$assigner === void 0 ? void 0 : (_it$assigner$roles = _it$assigner.roles) === null || _it$assigner$roles === void 0 ? void 0 : _it$assigner$roles.some(r => LTP_ROLES.includes(r.code)));
    }) || sortedItems.find(it => {
      var _it$assigner2, _it$assigner2$roles;
      return it === null || it === void 0 ? void 0 : (_it$assigner2 = it.assigner) === null || _it$assigner2 === void 0 ? void 0 : (_it$assigner2$roles = _it$assigner2.roles) === null || _it$assigner2$roles === void 0 ? void 0 : _it$assigner2$roles.some(r => LTP_ROLES.includes(r.code));
    });
    const ltpAssigner = (ltpItem === null || ltpItem === void 0 ? void 0 : ltpItem.assigner) || null;
    const steps = [];
    let hasPaymentTile = false;
    let hasMakePaymentTile = false;
    let provisionallyApprovalOfficer = null;
    for (let i = 0; i < sortedItems.length; i++) {
      var _item$state3, _citizenLabel, _item$wfComment2;
      const item = sortedItems[i];
      const assigner = item === null || item === void 0 ? void 0 : item.assigner;
      if (!assigner) continue;
      const rawAction = item.performedAction || item.action || "";
      const isPaymentAction = rawAction.startsWith("PAYMENT_DONE") || rawAction.includes("PAYMENT_DONE") || rawAction === "MAKE_PAYMENT";
      const isCitizenStep = assigner.type === "CITIZEN" || assigner.type === "OWNER" || isPaymentAction;
      let citizenLabel = getCitizenLabel(rawAction);
      const stateStr = typeof (item === null || item === void 0 ? void 0 : item.state) === "object" ? item === null || item === void 0 ? void 0 : (_item$state3 = item.state) === null || _item$state3 === void 0 ? void 0 : _item$state3.state : item === null || item === void 0 ? void 0 : item.state;
      if (rawAction === "PAYMENT_DONE" && stateStr === "FORWARD_TO_DEPARTMENT") {
        citizenLabel = "Payment Done & Forwarded";
      }
      if (isCitizenStep && !citizenLabel) continue;
      let itemAssignees = [];
      const rawAssign = (item === null || item === void 0 ? void 0 : item.assignes) || (item === null || item === void 0 ? void 0 : item.assignees) || (item === null || item === void 0 ? void 0 : item.assignee);
      if (rawAssign) {
        itemAssignees = Array.isArray(rawAssign) ? rawAssign : [rawAssign];
      }
      if (isPaymentAction && itemAssignees.length === 0 && i + 1 < sortedItems.length) {
        const nextItem = sortedItems[i + 1];
        const nextRawAssign = (nextItem === null || nextItem === void 0 ? void 0 : nextItem.assignes) || (nextItem === null || nextItem === void 0 ? void 0 : nextItem.assignees) || (nextItem === null || nextItem === void 0 ? void 0 : nextItem.assignee);
        if (nextRawAssign) {
          itemAssignees = Array.isArray(nextRawAssign) ? nextRawAssign : [nextRawAssign];
        }
      }
      if (isCitizenStep && (_citizenLabel = citizenLabel) !== null && _citizenLabel !== void 0 && _citizenLabel.includes("Payment Done")) {
        if (hasPaymentTile) {
          const existingStep = steps.find(s => {
            var _s$name;
            return s.isCitizen && ((_s$name = s.name) === null || _s$name === void 0 ? void 0 : _s$name.includes("Payment Done"));
          });
          if (existingStep && (!existingStep.assignees || existingStep.assignees.length === 0) && itemAssignees.length > 0) {
            existingStep.assignees = itemAssignees;
          }
          continue;
        }
        hasPaymentTile = true;
      }
      if (isCitizenStep && citizenLabel === "Make Payment") {
        if (hasMakePaymentTile) continue;
        hasMakePaymentTile = true;
      }
      let timeHeld = 0;
      if (i > 0) {
        const prevTime = getItemEpoch(sortedItems[i - 1]);
        const currTime = getItemEpoch(item);
        timeHeld = Math.max(currTime - prevTime, 0);
      }
      const inTime = i > 0 ? getItemEpoch(sortedItems[i - 1]) : getItemEpoch(item);
      const outTime = getItemEpoch(item);
      let realRemark = (item === null || item === void 0 ? void 0 : item.comment) || (item === null || item === void 0 ? void 0 : (_item$wfComment2 = item.wfComment) === null || _item$wfComment2 === void 0 ? void 0 : _item$wfComment2[0]) || "";
      let remark = realRemark;
      if (isCitizenUser) {
        if (!isFinalAction(rawAction)) {
          remark = "";
        }
      }
      if (isCitizenStep) {
        var _citizenAssignerName$;
        const citizenAssignerName = assigner.name || "Applicant";
        const isSuperUser = SYSTEM_USER_NAMES.includes(citizenAssignerName === null || citizenAssignerName === void 0 ? void 0 : (_citizenAssignerName$ = citizenAssignerName.toLowerCase) === null || _citizenAssignerName$ === void 0 ? void 0 : _citizenAssignerName$.call(citizenAssignerName));
        steps.push({
          name: citizenLabel,
          role: isSuperUser ? "" : citizenAssignerName,
          timeHeld,
          action: rawAction,
          itemIndex: i,
          assignerId: assigner.uuid || assigner.id,
          inTime,
          outTime,
          remark,
          isCitizen: true,
          assignees: itemAssignees
        });
      } else {
        const {
          name,
          role
        } = getOfficerInfo(assigner);
        if (rawAction === "PROVISIONALLY_APPROVAL") {
          provisionallyApprovalOfficer = {
            name,
            role,
            assigner,
            outTime
          };
        }
        if (name === "Auto forwarded") {
          let prevAssignee = null;
          if (i > 0) {
            const prevItem = sortedItems[i - 1];
            const rawPrevAssignees = (prevItem === null || prevItem === void 0 ? void 0 : prevItem.assignees) || (prevItem === null || prevItem === void 0 ? void 0 : prevItem.assignes) || [];
            const prevAssignees = Array.isArray(rawPrevAssignees) ? rawPrevAssignees : [rawPrevAssignees];
            if (prevAssignees.length > 0 && prevAssignees[0]) {
              prevAssignee = prevAssignees[0];
            }
          }
          if (prevAssignee) {
            var _prevAssignee, _prevAssignee2, _pName, _pName$toLowerCase, _pName2;
            let pName = typeof prevAssignee === "string" ? prevAssignee : ((_prevAssignee = prevAssignee) === null || _prevAssignee === void 0 ? void 0 : _prevAssignee.name) || ((_prevAssignee2 = prevAssignee) === null || _prevAssignee2 === void 0 ? void 0 : _prevAssignee2.userName) || "—";
            if (((_pName = pName) === null || _pName === void 0 ? void 0 : (_pName$toLowerCase = (_pName2 = _pName).toLowerCase) === null || _pName$toLowerCase === void 0 ? void 0 : _pName$toLowerCase.call(_pName2)) === "wfadmin") pName = "Auto forwarded";
            if (pName !== "Auto forwarded") {
              var _prevAssignee3, _prevAssignee3$roles, _prevAssignee3$roles$;
              const pRole = ((_prevAssignee3 = prevAssignee) === null || _prevAssignee3 === void 0 ? void 0 : (_prevAssignee3$roles = _prevAssignee3.roles) === null || _prevAssignee3$roles === void 0 ? void 0 : (_prevAssignee3$roles$ = _prevAssignee3$roles.find(r => !["EMPLOYEE", "CITIZEN", "OWNER", "WF_ADMIN_ESCLATE"].includes(r.code))) === null || _prevAssignee3$roles$ === void 0 ? void 0 : _prevAssignee3$roles$.name) || "";
              const pInTime = i > 0 ? getItemEpoch(sortedItems[i - 1]) : getItemEpoch(item);
              const pOutTime = getItemEpoch(item);
              const pTimeHeld = Math.max(pOutTime - pInTime, 0);
              steps.push({
                name: pName,
                role: pRole,
                timeHeld: pTimeHeld,
                action: "HELD_FILE",
                itemIndex: i - 0.5,
                assignerId: prevAssignee.uuid || prevAssignee.id,
                inTime: pInTime,
                outTime: pOutTime,
                remark: "",
                assignees: [],
                isHeldFileTile: true
              });
            }
          }
          steps.push({
            name,
            role,
            timeHeld: prevAssignee && prevAssignee.name !== "WFADMIN" ? 0 : timeHeld,
            action: rawAction,
            itemIndex: i,
            assignerId: assigner.uuid || assigner.id,
            inTime: prevAssignee && prevAssignee.name !== "WFADMIN" ? outTime : inTime,
            outTime: outTime,
            remark,
            assignees: itemAssignees,
            isAutoForwardActionTile: true
          });
        } else {
          steps.push({
            name,
            role,
            timeHeld,
            action: rawAction,
            itemIndex: i,
            assignerId: assigner.uuid || assigner.id,
            inTime,
            outTime,
            remark,
            assignees: itemAssignees
          });
        }
        if (rawAction === "PROVISIONALLY_APPROVAL" && ltpAssigner) {
          var _ltpAssigner$roles, _ltpAssigner$roles$fi, _ltpAssigner$roles2, _ltpAssigner$roles2$f;
          const ltpRole = ((_ltpAssigner$roles = ltpAssigner.roles) === null || _ltpAssigner$roles === void 0 ? void 0 : (_ltpAssigner$roles$fi = _ltpAssigner$roles.find(r => r.code === "LTP")) === null || _ltpAssigner$roles$fi === void 0 ? void 0 : _ltpAssigner$roles$fi.name) || ((_ltpAssigner$roles2 = ltpAssigner.roles) === null || _ltpAssigner$roles2 === void 0 ? void 0 : (_ltpAssigner$roles2$f = _ltpAssigner$roles2.find(r => !["CITIZEN", "OWNER"].includes(r.code))) === null || _ltpAssigner$roles2$f === void 0 ? void 0 : _ltpAssigner$roles2$f.name) || "LTP";
          const nextPaymentItem = sortedItems.slice(i + 1).find(it => {
            const a = (it === null || it === void 0 ? void 0 : it.action) || (it === null || it === void 0 ? void 0 : it.performedAction) || "";
            return a.startsWith("PAYMENT_DONE") || a === "MAKE_PAYMENT" || a.includes("PAYMENT");
          });
          const ltpOutTime = nextPaymentItem ? getItemEpoch(nextPaymentItem) : null;
          const ltpTimeHeld = ltpOutTime ? Math.max(ltpOutTime - outTime, 0) : 0;
          steps.push({
            name: ltpAssigner.name || "—",
            role: ltpRole,
            timeHeld: ltpTimeHeld,
            action: "PENDING_PAYMENT_LTP",
            itemIndex: i,
            assignerId: ltpAssigner.uuid || ltpAssigner.id,
            inTime: outTime,
            outTime: ltpOutTime,
            remark: ltpOutTime ? "Payment done" : "Payment pending with LTP",
            isCitizen: true,
            isLtpPendingPayment: true,
            assignees: []
          });
        }
      }
    }
    const lastItem = sortedItems[sortedItems.length - 1];
    const lastAction = (lastItem === null || lastItem === void 0 ? void 0 : lastItem.performedAction) || (lastItem === null || lastItem === void 0 ? void 0 : lastItem.action) || "";
    const isDscTerminal = lastAction === "FIT_FOR_APPROVAL";
    const isDscApply = lastAction.startsWith("APPLY_FOR_DSC");
    let finalStatus = null;
    if (lastAction.includes("APPROVAL") && lastAction !== "PROVISIONALLY_APPROVAL" || lastAction === "APPROVED" || isDscTerminal) {
      finalStatus = "APPROVED";
    } else if (lastAction.includes("REJECT") || lastAction === "REJECT") {
      finalStatus = "REJECTED";
    } else if (lastAction === "SHORTFALL") {
      finalStatus = "SHORTFALL";
    }
    const tileData = [...steps];
    const lastStep = steps[steps.length - 1];
    const isLastPayment = (lastStep === null || lastStep === void 0 ? void 0 : (_lastStep$action = lastStep.action) === null || _lastStep$action === void 0 ? void 0 : _lastStep$action.startsWith("PAYMENT_DONE")) || (lastStep === null || lastStep === void 0 ? void 0 : lastStep.action) === "MAKE_PAYMENT";
    const shouldAddCurrentHolder = !finalStatus && lastStep && ((_lastStep$assignees = lastStep.assignees) === null || _lastStep$assignees === void 0 ? void 0 : _lastStep$assignees.length) > 0 && !isLastPayment;
    if (shouldAddCurrentHolder) {
      var _holder$roles, _holder$roles$find;
      const holder = lastStep.assignees[0];
      const holderName = typeof holder === "string" ? holder : (holder === null || holder === void 0 ? void 0 : holder.name) || (holder === null || holder === void 0 ? void 0 : holder.userName) || "—";
      const holderRole = (holder === null || holder === void 0 ? void 0 : (_holder$roles = holder.roles) === null || _holder$roles === void 0 ? void 0 : (_holder$roles$find = _holder$roles.find(r => !["EMPLOYEE", "CITIZEN", "OWNER"].includes(r.code))) === null || _holder$roles$find === void 0 ? void 0 : _holder$roles$find.name) || "";
      tileData.push({
        name: holderName,
        role: holderRole,
        timeHeld: 0,
        action: "",
        inTime: lastStep.outTime,
        outTime: null,
        remark: "",
        assignees: [],
        isCurrentHolder: true
      });
    } else if (!finalStatus && isLastPayment && provisionallyApprovalOfficer) {
      tileData.push({
        name: provisionallyApprovalOfficer.name,
        role: provisionallyApprovalOfficer.role,
        timeHeld: 0,
        action: "",
        inTime: lastStep.outTime,
        outTime: null,
        remark: isCitizenUser ? "Pending Approval" : "File pending with officer",
        assignees: [],
        isCurrentHolder: true
      });
    } else if (isDscApply && !finalStatus) {
      const dscAssigner = lastItem === null || lastItem === void 0 ? void 0 : lastItem.assigner;
      if (dscAssigner) {
        const {
          name: dscName,
          role: dscRole
        } = getOfficerInfo(dscAssigner);
        tileData.push({
          name: dscName || "—",
          role: dscRole,
          timeHeld: 0,
          action: "",
          inTime: lastStep === null || lastStep === void 0 ? void 0 : lastStep.outTime,
          outTime: null,
          remark: "",
          assignees: [],
          isCurrentHolder: true
        });
      }
    } else if (finalStatus) {
      tileData.push({
        isFinal: true,
        status: finalStatus,
        timeHeld: 0,
        name: finalStatus,
        role: "",
        action: lastAction
      });
    }
    if (steps.length === 0 && tileData.filter(t => !t.isFinal).length === 0) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        color: "text.secondary",
        sx: {
          py: 1
        }
      }, t("NO_OFFICER_DATA"));
    }
    const renderTile = (step, index) => {
      var _step$name, _step$name$toLowerCas, _step$assignees, _step$role, _step$role$toLowerCas;
      const isFinal = step.isFinal || false;
      const isCitizen = step.isCitizen || false;
      const isCurrentHolder = step.isCurrentHolder || false;
      const timeStr = formatDurationMs(step.timeHeld || 0);
      let icon = /*#__PURE__*/React__default.createElement(Person, null);
      let bgColor = theme.palette.primary.main;
      let tileBg = theme.palette.background.paper;
      let borderColor = theme.palette.divider;
      if (isCurrentHolder) {
        bgColor = "#00897b";
        tileBg = "#e0f2f1";
        borderColor = "#00897b";
        icon = /*#__PURE__*/React__default.createElement(Person, null);
      } else if (isCitizen) {
        const act = step.action || "";
        if (act === "INITIATE") icon = /*#__PURE__*/React__default.createElement(Assignment, null);else if (act.includes("PAYMENT")) icon = /*#__PURE__*/React__default.createElement(Payment, null);else icon = /*#__PURE__*/React__default.createElement(Description, null);
        bgColor = theme.palette.warning.dark;
        tileBg = "#fff8e1";
        borderColor = theme.palette.warning.main;
      } else if (isFinal) {
        if (step.status === "APPROVED") {
          icon = /*#__PURE__*/React__default.createElement(CheckCircle, null);
          bgColor = theme.palette.success.main;
          tileBg = theme.palette.success.light;
          borderColor = theme.palette.success.main;
        } else if (step.status === "REJECTED") {
          icon = /*#__PURE__*/React__default.createElement(Cancel$2, null);
          bgColor = theme.palette.error.main;
          tileBg = theme.palette.error.light;
          borderColor = theme.palette.error.main;
        } else if (step.status === "SHORTFALL") {
          icon = /*#__PURE__*/React__default.createElement(Warning, null);
          bgColor = theme.palette.warning.main;
          tileBg = theme.palette.warning.light;
          borderColor = theme.palette.warning.main;
        }
      }
      if (step.name === "Auto forwarded" || ((_step$name = step.name) === null || _step$name === void 0 ? void 0 : (_step$name$toLowerCas = _step$name.toLowerCase) === null || _step$name$toLowerCas === void 0 ? void 0 : _step$name$toLowerCas.call(_step$name)) === "wfadmin") {
        bgColor = "#ffb300";
        tileBg = "#fff8e1";
        borderColor = "#ffb300";
        icon = /*#__PURE__*/React__default.createElement(SyncAlt, null);
      }
      return /*#__PURE__*/React__default.createElement(Box, {
        key: index,
        sx: {
          display: "flex",
          alignItems: "center",
          mx: 1,
          my: 2
        }
      }, /*#__PURE__*/React__default.createElement(Paper$1, {
        elevation: 1,
        sx: {
          position: "relative",
          p: 1.5,
          borderRadius: 2,
          minWidth: 120,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: tileBg,
          border: `1px solid ${borderColor}`
        }
      }, ((_step$assignees = step.assignees) === null || _step$assignees === void 0 ? void 0 : _step$assignees.length) > 0 && /*#__PURE__*/React__default.createElement(Tooltip, {
        title: /*#__PURE__*/React__default.createElement(Box, {
          sx: {
            p: 0.5,
            lineHeight: 1.9
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            fontWeight: "bold",
            marginBottom: 2
          }
        }, "Assigned To"), step.assignees.map((a, idx) => {
          var _assigneeName, _assigneeName$toLower, _a$roles, _a$roles$find;
          let assigneeName = typeof a === "string" ? a : (a === null || a === void 0 ? void 0 : a.name) || (a === null || a === void 0 ? void 0 : a.userName) || "—";
          if (((_assigneeName = assigneeName) === null || _assigneeName === void 0 ? void 0 : (_assigneeName$toLower = _assigneeName.toLowerCase) === null || _assigneeName$toLower === void 0 ? void 0 : _assigneeName$toLower.call(_assigneeName)) === "wfadmin") assigneeName = "Auto forwarded";
          const assigneeRole = (a === null || a === void 0 ? void 0 : (_a$roles = a.roles) === null || _a$roles === void 0 ? void 0 : (_a$roles$find = _a$roles.find(r => !["EMPLOYEE", "CITIZEN", "OWNER"].includes(r.code))) === null || _a$roles$find === void 0 ? void 0 : _a$roles$find.name) || "";
          return /*#__PURE__*/React__default.createElement("div", {
            key: idx
          }, /*#__PURE__*/React__default.createElement("div", null, "\uD83D\uDC64 ", assigneeName, assigneeRole ? ` (${assigneeRole})` : ""), !isCitizenUser && (a === null || a === void 0 ? void 0 : a.mobileNumber) && /*#__PURE__*/React__default.createElement("div", null, "\uD83D\uDCDE ", a.mobileNumber), idx < step.assignees.length - 1 && /*#__PURE__*/React__default.createElement("div", {
            style: {
              borderTop: "1px solid rgba(255,255,255,0.3)",
              margin: "4px 0"
            }
          }));
        })),
        arrow: true,
        placement: "top"
      }, /*#__PURE__*/React__default.createElement(InfoOutlined, {
        sx: {
          position: "absolute",
          top: 4,
          right: 4,
          fontSize: 16,
          color: "info.main",
          cursor: "pointer"
        }
      })), /*#__PURE__*/React__default.createElement(Avatar$3, {
        sx: {
          width: 40,
          height: 40,
          bgcolor: bgColor
        }
      }, icon), /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        fontWeight: "bold",
        sx: {
          mt: 0.5
        }
      }, step.name), !isFinal && step.role && !SYSTEM_USER_NAMES.includes((_step$role = step.role) === null || _step$role === void 0 ? void 0 : (_step$role$toLowerCas = _step$role.toLowerCase) === null || _step$role$toLowerCas === void 0 ? void 0 : _step$role$toLowerCas.call(_step$role)) && /*#__PURE__*/React__default.createElement(Typography, {
        variant: "caption",
        color: "text.secondary"
      }, step.role), !isFinal && (() => {
        const act = step.action || "";
        const isPaymentTile = act !== "PENDING_PAYMENT_LTP" && (act.startsWith("PAYMENT_DONE") || act === "MAKE_PAYMENT" || act.includes("PAYMENT"));
        if (isPaymentTile) return null;
        return /*#__PURE__*/React__default.createElement(Tooltip, {
          title: /*#__PURE__*/React__default.createElement(Box, {
            sx: {
              p: 0.5,
              lineHeight: 1.8
            }
          }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "In:"), "\xA0", step.inTime ? formatDateTime(step.inTime) : "—"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Out:"), "\xA0", isCurrentHolder ? "Active (file pending)" : step.outTime ? formatDateTime(step.outTime) : "—"), !isCurrentHolder && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Held:"), "\xA0", formatDurationMs(step.timeHeld || 0)), isCurrentHolder && /*#__PURE__*/React__default.createElement("div", {
            style: {
              color: "#80cbc4",
              fontStyle: "italic"
            }
          }, "File is currently with this officer")),
          arrow: true,
          placement: "top"
        }, /*#__PURE__*/React__default.createElement(Typography, {
          variant: "caption",
          color: isCurrentHolder ? "success.dark" : "text.secondary",
          sx: {
            display: "flex",
            alignItems: "center",
            mt: 0.5,
            cursor: "pointer",
            fontWeight: isCurrentHolder ? "bold" : "normal"
          }
        }, /*#__PURE__*/React__default.createElement(AccessTime, {
          fontSize: "small",
          sx: {
            mr: 0.5
          }
        }), isCurrentHolder ? "Active" : timeStr));
      })(), !isFinal && /*#__PURE__*/React__default.createElement(Tooltip, {
        title: step.remark ? /*#__PURE__*/React__default.createElement(Box, {
          sx: {
            p: 0.5,
            maxWidth: 240,
            wordBreak: "break-word"
          }
        }, /*#__PURE__*/React__default.createElement(SafeHtml, {
          html: step.remark
        })) : /*#__PURE__*/React__default.createElement(Box, {
          sx: {
            p: 0.5,
            fontStyle: "italic"
          }
        }, "No remark"),
        arrow: true,
        placement: "bottom"
      }, /*#__PURE__*/React__default.createElement(Chat, {
        fontSize: "small",
        sx: {
          mt: 0.5,
          cursor: "pointer",
          color: step.remark ? "primary.main" : "text.disabled"
        }
      }))));
    };
    const renderArrow = (fromIdx, toIdx) => {
      const fromStep = tileData[fromIdx];
      const action = fromStep.action || "";
      const FORWARD_ACTIONS = ["INITIATE", "UPLOAD_DOC", "FORWARD_TO_DEPARTMENT", "SEND_TO_NEXT_LEVEL", "PROVISIONALLY_APPROVAL", "FIT_FOR_APPROVAL", "APPLY_FOR_DSC", "APPLY_FOR_DSC_VC", "APPLY_FOR_DSC_EE_TP"];
      const isForward = FORWARD_ACTIONS.includes(action) || action.includes("FORWARD") || action.includes("NEXT_LEVEL") || action.includes("APPROVAL") || action.startsWith("PAYMENT_DONE") || action.includes("PAYMENT") || action === "APPROVED" || action === "MAKE_PAYMENT" || action === "HELD_FILE";
      const color = isForward ? "success.main" : "error.main";
      return /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          mx: 0.5
        }
      }, /*#__PURE__*/React__default.createElement(ArrowForward, {
        sx: {
          color,
          fontSize: 30
        }
      }));
    };
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        py: 1
      }
    }, tileData.map((step, idx) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: idx
    }, renderTile(step, idx), idx < tileData.length - 1 && renderArrow(idx))));
  };
  const renderRemarksTable = items => {
    let displaySteps = [];
    let seenUploadDoc = false;
    for (const item of items) {
      const performedAction = (item === null || item === void 0 ? void 0 : item.performedAction) || (item === null || item === void 0 ? void 0 : item.action) || "";
      if (performedAction === "UPLOAD_DOC") {
        if (seenUploadDoc) continue;
        seenUploadDoc = true;
      }
      displaySteps.push(item);
    }
    if (displaySteps.length === 0) {
      return /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        color: "text.secondary",
        sx: {
          py: 1
        }
      }, t("NO_REMARKS"));
    }
    return /*#__PURE__*/React__default.createElement(TableContainer$1, {
      component: Paper$1,
      sx: {
        mt: 2
      }
    }, /*#__PURE__*/React__default.createElement(Table$2, {
      size: "small"
    }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, t("WF_PERFORMED_ACTION") || "Action"), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("WF_STATUS") || "Status"), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("WF_COMMON_REMARKS")), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("WF_COMMON_DATE")), !isCitizenUser && /*#__PURE__*/React__default.createElement(TableCell$1, null, t("CS_COMMON_ATTACHMENTS")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, displaySteps.map((item, idx) => {
      var _item$assigner3, _item$assigner3$name, _item$assigner3$name$, _item$assigner4, _item$assigner4$userN, _item$assigner4$userN2, _item$wfComment3;
      const {
        name,
        role
      } = getOfficerInfo(item === null || item === void 0 ? void 0 : item.assigner);
      const performedAction = (item === null || item === void 0 ? void 0 : item.performedAction) || (item === null || item === void 0 ? void 0 : item.action) || "—";
      const statusVal = (item === null || item === void 0 ? void 0 : item.status) || (item === null || item === void 0 ? void 0 : item.state) || "—";
      const rawDocs = (item === null || item === void 0 ? void 0 : item.wfDocuments) || (item === null || item === void 0 ? void 0 : item.documents) || [];
      const docs = (Array.isArray(rawDocs) ? rawDocs : rawDocs ? [rawDocs] : []).filter(isValidDocumentStream);
      const hasDocs = docs.length > 0;
      const displayName = SYSTEM_USER_NAMES.includes((item === null || item === void 0 ? void 0 : (_item$assigner3 = item.assigner) === null || _item$assigner3 === void 0 ? void 0 : (_item$assigner3$name = _item$assigner3.name) === null || _item$assigner3$name === void 0 ? void 0 : (_item$assigner3$name$ = _item$assigner3$name.toLowerCase) === null || _item$assigner3$name$ === void 0 ? void 0 : _item$assigner3$name$.call(_item$assigner3$name)) || (item === null || item === void 0 ? void 0 : (_item$assigner4 = item.assigner) === null || _item$assigner4 === void 0 ? void 0 : (_item$assigner4$userN = _item$assigner4.userName) === null || _item$assigner4$userN === void 0 ? void 0 : (_item$assigner4$userN2 = _item$assigner4$userN.toLowerCase) === null || _item$assigner4$userN2 === void 0 ? void 0 : _item$assigner4$userN2.call(_item$assigner4$userN))) ? "—" : name;
      const showRealRemarkForCitizen = isCitizenUser && isFinalAction(performedAction);
      const citizenRemarkContent = showRealRemarkForCitizen ? (item === null || item === void 0 ? void 0 : item.comment) || (item === null || item === void 0 ? void 0 : (_item$wfComment3 = item.wfComment) === null || _item$wfComment3 === void 0 ? void 0 : _item$wfComment3[0]) || "" : null;
      return /*#__PURE__*/React__default.createElement(TableRow$1, {
        key: idx
      }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        fontWeight: "bold"
      }, t(performedAction) || performedAction), displayName && displayName !== "—" && /*#__PURE__*/React__default.createElement(Typography, {
        variant: "caption",
        color: "text.secondary"
      }, displayName, role ? ` (${role})` : ""))), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2"
      }, t(statusVal) || statusVal)), /*#__PURE__*/React__default.createElement(TableCell$1, null, isCitizenUser ? showRealRemarkForCitizen ? /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: 0.5
        }
      }, /*#__PURE__*/React__default.createElement(SafeHtml, {
        html: citizenRemarkContent,
        style: {
          fontSize: "0.875rem",
          lineHeight: 1.5
        }
      })) : /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        color: "text.disabled"
      }, "\u2014") : (() => {
        const remarkParts = [];
        if (item !== null && item !== void 0 && item.comment) remarkParts.push({
          label: null,
          text: item.comment
        });
        if (item !== null && item !== void 0 && item.documentsRemarks) remarkParts.push({
          label: "Documents",
          text: item.documentsRemarks
        });
        if (item !== null && item !== void 0 && item.paymentRemarks) remarkParts.push({
          label: "Payment",
          text: item.paymentRemarks
        });
        if (item !== null && item !== void 0 && item.drawingRemarks) remarkParts.push({
          label: "Drawing",
          text: item.drawingRemarks
        });
        if (item !== null && item !== void 0 && item.inspectionRemarks) remarkParts.push({
          label: "Inspection",
          text: item.inspectionRemarks
        });
        return remarkParts.length > 0 ? /*#__PURE__*/React__default.createElement(Box, {
          sx: {
            display: "flex",
            flexDirection: "column",
            gap: 0.5
          }
        }, remarkParts.map((part, pi) => /*#__PURE__*/React__default.createElement(Box, {
          key: pi,
          sx: {
            display: "flex",
            gap: 0.5,
            alignItems: "flex-start"
          }
        }, part.label && /*#__PURE__*/React__default.createElement(Typography, {
          component: "span",
          variant: "caption",
          fontWeight: "bold",
          color: "text.secondary",
          sx: {
            whiteSpace: "nowrap",
            pt: "2px"
          }
        }, part.label, ":"), /*#__PURE__*/React__default.createElement(SafeHtml, {
          html: part.text,
          style: {
            fontSize: "0.875rem",
            lineHeight: 1.5
          }
        })))) : /*#__PURE__*/React__default.createElement(Typography, {
          variant: "body2",
          color: "text.disabled"
        }, "\u2014");
      })()), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatDateTime(getItemEpoch(item))), !isCitizenUser && /*#__PURE__*/React__default.createElement(TableCell$1, null, hasDocs ? docs.map((doc, i) => /*#__PURE__*/React__default.createElement(Tooltip, {
        key: i,
        title: (doc === null || doc === void 0 ? void 0 : doc.documentType) || "Attachment"
      }, /*#__PURE__*/React__default.createElement(PictureAsPdf, {
        sx: {
          cursor: "pointer",
          color: "error.main",
          fontSize: 25,
          mr: 1
        },
        onClick: () => window.open((doc === null || doc === void 0 ? void 0 : doc.url) || (doc === null || doc === void 0 ? void 0 : doc.fileStoreId), "_blank")
      }))) : /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        color: "text.disabled"
      }, "\u2014")));
    }))));
  };
  const renderAssigneeHistory = historyList => {
    if (!historyList || historyList.length === 0) return null;
    return /*#__PURE__*/React__default.createElement(Paper$1, {
      elevation: 0,
      sx: {
        margin: "0 0 20px 0 !important",
        padding: "0 !important",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff",
        overflow: "hidden",
        boxSizing: "border-box"
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        padding: "12px 16px !important",
        margin: "0 !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#f8fafc",
        borderBottom: isAssigneeHistoryExpanded ? "1px solid #e2e8f0" : "none",
        boxSizing: "border-box"
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 0,
        minWidth: 0
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: 34,
        height: 34,
        margin: "0 10px 0 0 !important",
        padding: "0 !important",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#eff6ff",
        flexShrink: 0
      }
    }, /*#__PURE__*/React__default.createElement(History, {
      sx: {
        fontSize: 18,
        color: "#2563eb",
        display: "block"
      }
    })), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "0.875rem",
        fontWeight: 700,
        color: "#1e293b",
        margin: "0 8px 0 0 !important",
        padding: "0 !important",
        lineHeight: 1
      }
    }, t("BPA_ASSIGNEE_HISTORY") || "Assignee History"), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 8px !important",
        margin: "0 !important",
        borderRadius: "20px",
        backgroundColor: "#eff6ff"
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "0.7rem",
        fontWeight: 700,
        color: "#1d4ed8",
        margin: "0 !important",
        padding: "0 !important",
        lineHeight: 1
      }
    }, historyList.length, " ", historyList.length === 1 ? "Reassignment" : "Reassignments"))), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: () => setIsAssigneeHistoryExpanded(!isAssigneeHistoryExpanded),
      sx: {
        width: 30,
        height: 30,
        margin: "0 !important",
        padding: "0 !important",
        flexShrink: 0,
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        backgroundColor: "#ffffff",
        color: "#64748b",
        "&:hover": {
          backgroundColor: "#f1f5f9",
          color: "#2563eb"
        }
      }
    }, isAssigneeHistoryExpanded ? /*#__PURE__*/React__default.createElement(ExpandLess, {
      fontSize: "small"
    }) : /*#__PURE__*/React__default.createElement(ExpandMore, {
      fontSize: "small"
    }))), /*#__PURE__*/React__default.createElement(Collapse, {
      in: isAssigneeHistoryExpanded
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        padding: "16px !important",
        margin: "0 !important",
        display: "flex",
        flexDirection: "column",
        gap: 0,
        boxSizing: "border-box"
      }
    }, historyList.map((item, idx) => {
      const updatedRole = cleanRole(item === null || item === void 0 ? void 0 : item.updatedByRoles);
      const prevRole = cleanRole(item === null || item === void 0 ? void 0 : item.previousAssigneeRoles);
      const newRole = cleanRole(item === null || item === void 0 ? void 0 : item.newAssigneeRoles);
      const formattedTime = formatActionTime(item === null || item === void 0 ? void 0 : item.actionTime);
      const isLatest = idx === 0;
      return /*#__PURE__*/React__default.createElement(Box, {
        key: (item === null || item === void 0 ? void 0 : item.id) || idx,
        sx: {
          margin: idx === 0 ? "0 !important" : "10px 0 0 0 !important",
          padding: "0 !important",
          borderRadius: "10px",
          border: isLatest ? "1.5px solid #bfdbfe" : "1px solid #e2e8f0",
          backgroundColor: "#ffffff",
          overflow: "hidden",
          boxShadow: isLatest ? "0 2px 8px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)",
          transition: "box-shadow 0.15s ease, border-color 0.15s ease",
          "&:hover": {
            borderColor: "#93c5fd",
            boxShadow: "0 4px 12px rgba(0,0,0,0.07)"
          },
          boxSizing: "border-box"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          padding: "8px 14px !important",
          margin: "0 !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "6px",
          backgroundColor: isLatest ? "#f0f7ff" : "#fafafa",
          borderBottom: "1px solid #f1f5f9",
          boxSizing: "border-box"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 0,
          margin: "0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "inline-flex",
          alignItems: "center",
          padding: "2px 7px !important",
          margin: "0 8px 0 0 !important",
          borderRadius: "20px",
          backgroundColor: isLatest ? "#dbeafe" : "#f1f5f9"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.68rem",
          fontWeight: 700,
          color: isLatest ? "#1d4ed8" : "#475569",
          margin: "0 !important",
          padding: "0 !important",
          lineHeight: 1
        }
      }, isLatest ? "Latest" : `#${idx + 1}`)), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 0,
          margin: "0 10px 0 0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(AccessTime, {
        sx: {
          fontSize: 12,
          color: "#94a3b8",
          marginRight: "4px !important",
          display: "block"
        }
      }), /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.7rem",
          fontWeight: 500,
          color: "#64748b",
          margin: "0 !important",
          padding: "0 !important",
          lineHeight: 1
        }
      }, formattedTime)))), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          padding: "14px !important",
          margin: "0 !important",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          boxSizing: "border-box"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          flex: "1 1 160px",
          minWidth: 0,
          padding: "10px 12px !important",
          margin: "0 !important",
          borderRadius: "8px",
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
          gap: 0,
          boxSizing: "border-box"
        }
      }, /*#__PURE__*/React__default.createElement(Avatar$3, {
        sx: {
          width: 30,
          height: 30,
          margin: "0 10px 0 0 !important",
          padding: "0 !important",
          bgcolor: "#e2e8f0",
          color: "#64748b",
          flexShrink: 0
        }
      }, /*#__PURE__*/React__default.createElement(Person, {
        sx: {
          fontSize: 16,
          display: "block"
        }
      })), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          minWidth: 0,
          flex: 1,
          margin: "0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.6rem",
          fontWeight: 700,
          color: "#94a3b8",
          textTransform: "uppercase",
          letterSpacing: "0.6px",
          margin: "0 0 3px 0 !important",
          padding: "0 !important",
          lineHeight: 1,
          display: "block"
        }
      }, "Previous"), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 0,
          margin: "0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.8rem",
          fontWeight: 600,
          color: "#334155",
          margin: "0 6px 0 0 !important",
          padding: "0 !important",
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, (item === null || item === void 0 ? void 0 : item.previousAssigneeName) || "—"), prevRole && /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "inline-flex",
          alignItems: "center",
          padding: "1px 5px !important",
          margin: "0 !important",
          borderRadius: "4px",
          border: "1px solid #cbd5e1",
          flexShrink: 0
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.6rem",
          fontWeight: 600,
          color: "#64748b",
          margin: "0 !important",
          padding: "0 !important",
          lineHeight: 1
        }
      }, prevRole))))), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          width: 28,
          height: 28,
          margin: "0 !important",
          padding: "0 !important",
          flexShrink: 0,
          borderRadius: "50%",
          backgroundColor: "#eff6ff",
          border: "1.5px solid #bfdbfe",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "center"
        }
      }, /*#__PURE__*/React__default.createElement(ArrowForward, {
        sx: {
          color: "#3b82f6",
          fontSize: 14,
          display: "block"
        }
      })), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          flex: "1 1 160px",
          minWidth: 0,
          padding: "10px 12px !important",
          margin: "0 !important",
          borderRadius: "8px",
          backgroundColor: "#f0fdf4",
          border: "1px solid #bbf7d0",
          display: "flex",
          alignItems: "center",
          gap: 0,
          boxSizing: "border-box"
        }
      }, /*#__PURE__*/React__default.createElement(Avatar$3, {
        sx: {
          width: 30,
          height: 30,
          margin: "0 10px 0 0 !important",
          padding: "0 !important",
          bgcolor: "#22c55e",
          color: "#ffffff",
          flexShrink: 0
        }
      }, /*#__PURE__*/React__default.createElement(Person, {
        sx: {
          fontSize: 16,
          display: "block"
        }
      })), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          minWidth: 0,
          flex: 1,
          margin: "0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.6rem",
          fontWeight: 700,
          color: "#16a34a",
          textTransform: "uppercase",
          letterSpacing: "0.6px",
          margin: "0 0 3px 0 !important",
          padding: "0 !important",
          lineHeight: 1,
          display: "block"
        }
      }, "New Assignee"), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 0,
          margin: "0 !important",
          padding: "0 !important"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.8rem",
          fontWeight: 700,
          color: "#14532d",
          margin: "0 6px 0 0 !important",
          padding: "0 !important",
          lineHeight: 1.2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      }, (item === null || item === void 0 ? void 0 : item.newAssigneeName) || "—"), newRole && /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: "inline-flex",
          alignItems: "center",
          padding: "1px 5px !important",
          margin: "0 !important",
          borderRadius: "4px",
          backgroundColor: "#dcfce7",
          flexShrink: 0
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "0.6rem",
          fontWeight: 700,
          color: "#15803d",
          margin: "0 !important",
          padding: "0 !important",
          lineHeight: 1
        }
      }, newRole)))))));
    }))));
  };
  const toggleSubmission = index => {
    setExpandedSubmissions(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const reversedSubmissions = [...submissions].reverse();
  const latestOriginalIdx = submissions.length - 1;
  if (!hasSubmissions && !hasAssigneeHistory) {
    return /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      color: "text.secondary",
      align: "center",
      sx: {
        py: 2
      }
    }, t("NO_REMARKS_AVAILABLE"));
  }
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 2
    }
  }, !isCitizenUser && renderAssigneeHistory(sortedAssigneeHistory), reversedSubmissions.map((group, renderedIdx) => {
    const originalIdx = latestOriginalIdx - renderedIdx;
    const submissionNumber = originalIdx + 1;
    const isExpanded = expandedSubmissions[originalIdx] !== undefined ? expandedSubmissions[originalIdx] : renderedIdx === 0;
    const submissionLabel = `Submission ${submissionNumber}`;
    const firstItem = group[0];
    const lastItem = group[group.length - 1];
    const totalDuration = formatDurationMs(getItemEpoch(lastItem) - getItemEpoch(firstItem));
    return /*#__PURE__*/React__default.createElement(Paper$1, {
      key: originalIdx,
      elevation: 2,
      sx: {
        mb: 3,
        p: 2,
        borderRadius: 2
      }
    }, /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      alignItems: "center",
      justifyContent: "space-between"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h6",
      fontWeight: "bold"
    }, submissionLabel, /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      variant: "body2",
      color: "text.secondary",
      sx: {
        ml: 2
      }
    }, t("WF_TIME_TAKEN"), ": ", totalDuration))), /*#__PURE__*/React__default.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => toggleSubmission(originalIdx)
    }, isExpanded ? /*#__PURE__*/React__default.createElement(ExpandLess, null) : /*#__PURE__*/React__default.createElement(ExpandMore, null)))), /*#__PURE__*/React__default.createElement(Collapse, {
      in: isExpanded
    }, /*#__PURE__*/React__default.createElement(Divider, {
      sx: {
        my: 1
      }
    }), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        overflowX: "auto",
        py: 1
      }
    }, renderSubmissionFlow(group)), renderRemarksTable(group)));
  }));
};

const FarDetails = ({
  formData,
  setCurrentTab,
  farDetails,
  setFarDetails,
  empRole
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _formData$taxHeadEsti5, _formData$taxHeadEsti6, _formData$taxHeadEsti7, _formData$taxHeadEsti8, _formData$taxHeadEsti9, _formData$taxHeadEsti10, _formData$taxHeadEsti11, _formData$taxHeadEsti12, _formData$taxHeadEsti13, _formData$taxHeadEsti14, _formData$taxHeadEsti15, _formData$taxHeadEsti16, _formData$taxHeadEsti17, _formData$taxHeadEsti18, _formData$taxHeadEsti19, _formData$taxHeadEsti20;
  const {
    t
  } = useTranslation();
  const isAVP = (empRole === null || empRole === void 0 ? void 0 : empRole.tenantId) === "up.avp";
  const Modal = useModal();
  const properties = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0];
  const factorString = properties === null || properties === void 0 ? void 0 : properties.landUseAsPerLayout;
  const factorNum = React__default.useMemo(() => {
    if (factorString === "Residential (Group Housing)" || factorString === "Hotel") {
      return 0.4;
    } else if (factorString === "Office/Organization" || factorString === "Mixed land") {
      return 0.45;
    } else if (factorString === "Commercial") {
      return 0.5;
    } else {
      return 0.2;
    }
  }, [factorString]);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      properties: [{
        ...(formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : (_formData$description4 = _formData$description3.properties) === null || _formData$description4 === void 0 ? void 0 : _formData$description4[0])
      }]
    }
  };
  const {
    control,
    handleSubmit,
    setValue
  } = useForm({
    defaultValues
  });
  console.log(properties, "properties", formData);
  const handleInputChange = (name, value) => {
    setFarDetails({
      ...farDetails,
      [name]: value
    });
  };
  useEffect(() => {
    var _Digit, _Digit$SessionStorage;
    const circleRate = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("circleRate");
    if (circleRate) {
      setValue("circleRate", circleRate);
    }
  }, []);
  const onSubmit = data => {
    var _Digit2, _Digit2$SessionStorag;
    Modal("FAR Details Saved", `FAR Details Saved for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> successfully`, "success");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$SessionStorag = _Digit2.SessionStorage) === null || _Digit2$SessionStorag === void 0 ? void 0 : _Digit2$SessionStorag.set("circleRate", data === null || data === void 0 ? void 0 : data.circleRate);
    setCurrentTab(undefined, "2");
    console.log(data, "datafromFARFEES");
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0",
    onBlur: e => handleInputChange(e.target.name, e.target.value)
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Input Data"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Required FAR"))), /*#__PURE__*/React__default.createElement("td", null, properties === null || properties === void 0 ? void 0 : properties.percentRequiredFAR)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Required FAR Area"))), /*#__PURE__*/React__default.createElement("td", null, properties === null || properties === void 0 ? void 0 : properties.requiredAreaFAR)), isAVP ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Enter Base FAR"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "baseFar",
    hasLabel: false,
    control: control,
    validation: {
      required: {
        value: true,
        message: "Please enter the road width."
      }
    }
  }))) : (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.basicFar) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Basic FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3[0]) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.basicFar} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti5 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : (_formData$taxHeadEsti6 = _formData$taxHeadEsti5[0]) === null || _formData$taxHeadEsti6 === void 0 ? void 0 : _formData$taxHeadEsti6.totalBuiltUpArea}`)), (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti7 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti7 === void 0 ? void 0 : (_formData$taxHeadEsti8 = _formData$taxHeadEsti7[0]) === null || _formData$taxHeadEsti8 === void 0 ? void 0 : _formData$taxHeadEsti8.permissibleFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Permissible Purchasable FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti9 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti9 === void 0 ? void 0 : (_formData$taxHeadEsti10 = _formData$taxHeadEsti9[0]) === null || _formData$taxHeadEsti10 === void 0 ? void 0 : _formData$taxHeadEsti10.permissibleFAR} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti11 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti11 === void 0 ? void 0 : (_formData$taxHeadEsti12 = _formData$taxHeadEsti11[0]) === null || _formData$taxHeadEsti12 === void 0 ? void 0 : _formData$taxHeadEsti12.permissibleFARArea}`)), (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti13 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti13 === void 0 ? void 0 : (_formData$taxHeadEsti14 = _formData$taxHeadEsti13[0]) === null || _formData$taxHeadEsti14 === void 0 ? void 0 : _formData$taxHeadEsti14.totalPermissibleFar) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Maximum Permissible Purchasable FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti15 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti15 === void 0 ? void 0 : (_formData$taxHeadEsti16 = _formData$taxHeadEsti15[0]) === null || _formData$taxHeadEsti16 === void 0 ? void 0 : _formData$taxHeadEsti16.totalPermissibleFar} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti17 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti17 === void 0 ? void 0 : (_formData$taxHeadEsti18 = _formData$taxHeadEsti17[0]) === null || _formData$taxHeadEsti18 === void 0 ? void 0 : _formData$taxHeadEsti18.totalPermissibleFARArea}`)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Factor"))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti19 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti19 === void 0 ? void 0 : (_formData$taxHeadEsti20 = _formData$taxHeadEsti19[0]) === null || _formData$taxHeadEsti20 === void 0 ? void 0 : _formData$taxHeadEsti20.factor)), !isAVP && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Enter Circle Rate"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    type: "textInput",
    name: "circleRate",
    hasLabel: false,
    control: control,
    validation: {
      required: {
        value: true,
        message: "Please enter the road width."
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer",
    style: {
      marginTop: "18px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: t("Save FAR Details"),
    type: "submit"
  }))));
};

const ChecklistFarCitizen = ({
  formData,
  userInfo,
  lastEmpRole,
  setCurrentTab,
  setRemarksData
}) => {
  var _formData$checklist, _formData$checklist2, _formData$checklistRe, _formData$checklistRe2, _pdfDetails$pdfFiles, _applicationDocs$filt, _applicationDocs$filt2, _applicationDocs$filt3, _applicationDocs$filt4, _applicationDocs$filt5, _applicationDocs$filt6, _applicationDocs$filt7, _applicationDocs$filt8, _reviewChecklist1$bui, _reviewChecklist1$bui2, _reviewChecklist1$bui3, _reviewChecklist1$pro, _reviewChecklist1$pro2, _reviewChecklist1$pro3, _reviewChecklist1$dra, _reviewChecklist1$dra2, _reviewChecklist1$dra3, _reviewChecklist1$str, _reviewChecklist1$str2, _reviewChecklist1$str3, _reviewChecklist1$str4, _reviewChecklist1$str5, _reviewChecklist1$str6, _reviewChecklist1$fir, _reviewChecklist1$fir2, _reviewChecklist1$fir3, _reviewChecklist1$tot, _reviewChecklist1$tot2, _reviewChecklist1$tot3, _firstCheckList$parki, _firstCheckList$parki2, _reviewChecklist1$par, _reviewChecklist1$par2, _reviewChecklist1$par3, _reviewChecklist1$par4, _reviewChecklist1$par5, _reviewChecklist1$par6, _reviewChecklist1$par7, _reviewChecklist1$par8, _reviewChecklist1$par9, _firstCheckList$parki3, _firstCheckList$parki4, _reviewChecklist1$par10, _reviewChecklist1$par11, _reviewChecklist1$par12, _reviewChecklist1$par13, _reviewChecklist1$par14, _reviewChecklist1$par15, _reviewChecklist1$par16, _reviewChecklist1$par17, _reviewChecklist1$par18, _firstCheckList$parki5, _firstCheckList$parki6, _reviewChecklist1$par19, _reviewChecklist1$par20, _reviewChecklist1$par21, _reviewChecklist1$par22, _reviewChecklist1$par23, _reviewChecklist1$par24, _reviewChecklist1$par25, _reviewChecklist1$par26, _reviewChecklist1$par27, _firstCheckList$parki7, _firstCheckList$parki8, _reviewChecklist1$par28, _reviewChecklist1$par29, _reviewChecklist1$par30, _reviewChecklist1$par31, _reviewChecklist1$par32, _reviewChecklist1$par33, _reviewChecklist1$par34, _reviewChecklist1$par35, _reviewChecklist1$par36, _firstCheckList$parki9, _firstCheckList$parki10, _reviewChecklist1$par37, _reviewChecklist1$par38, _reviewChecklist1$par39, _reviewChecklist1$par40, _reviewChecklist1$par41, _reviewChecklist1$par42, _reviewChecklist1$par43, _reviewChecklist1$par44, _reviewChecklist1$par45, _firstCheckList$parki11, _firstCheckList$parki12, _reviewChecklist1$par46, _reviewChecklist1$par47, _reviewChecklist1$par48, _reviewChecklist1$par49, _reviewChecklist1$par50, _reviewChecklist1$par51, _reviewChecklist1$par52, _reviewChecklist1$par53, _reviewChecklist1$par54, _reviewChecklist2$sew, _reviewChecklist2$sew2, _reviewChecklist2$sew3, _reviewChecklist2$sew4, _reviewChecklist2$sew5, _reviewChecklist2$sew6, _reviewChecklist2$sew7, _reviewChecklist2$sew8, _reviewChecklist2$sew9, _reviewChecklist2$sew10, _reviewChecklist2$sew11, _reviewChecklist2$sew12, _reviewChecklist2$roa, _reviewChecklist2$roa2, _reviewChecklist2$roa3, _reviewChecklist2$roa4, _reviewChecklist2$roa5, _reviewChecklist2$roa6, _reviewChecklist2$roa7, _reviewChecklist2$roa8, _reviewChecklist2$roa9, _reviewChecklist2$roa10, _reviewChecklist2$roa11, _reviewChecklist2$roa12, _reviewChecklist2$wat, _reviewChecklist2$wat2, _reviewChecklist2$wat3, _reviewChecklist2$wat4, _reviewChecklist2$wat5, _reviewChecklist2$wat6, _reviewChecklist2$wat7, _reviewChecklist2$wat8, _reviewChecklist2$wat9, _reviewChecklist2$wat10, _reviewChecklist2$wat11, _reviewChecklist2$wat12, _reviewChecklist2$sew13, _reviewChecklist2$sew14, _reviewChecklist2$sew15, _reviewChecklist2$sew16, _reviewChecklist2$sew17, _reviewChecklist2$sew18, _reviewChecklist2$sew19, _reviewChecklist2$sew20, _reviewChecklist2$sew21, _reviewChecklist2$sew22, _reviewChecklist2$sew23, _reviewChecklist2$sew24, _secondCheckList$drai, _reviewChecklist2$dra, _reviewChecklist2$dra2, _reviewChecklist2$dra3, _reviewChecklist2$dra4, _reviewChecklist2$dra5, _reviewChecklist2$dra6, _reviewChecklist2$dra7, _reviewChecklist2$dra8, _reviewChecklist2$dra9, _reviewChecklist2$dra10, _reviewChecklist2$dra11, _reviewChecklist2$dra12, _reviewChecklist2$pow, _reviewChecklist2$pow2, _reviewChecklist2$pow3, _reviewChecklist2$pow4, _reviewChecklist2$pow5, _reviewChecklist2$pow6, _reviewChecklist2$pow7, _reviewChecklist2$pow8, _reviewChecklist2$pow9, _reviewChecklist2$pow10, _reviewChecklist2$pow11, _reviewChecklist2$pow12, _reviewChecklist2$roo, _reviewChecklist2$roo2, _reviewChecklist2$roo3, _reviewChecklist2$roo4, _reviewChecklist2$roo5, _reviewChecklist2$roo6, _reviewChecklist2$roo7, _reviewChecklist2$roo8, _reviewChecklist2$roo9, _reviewChecklist2$roo10, _reviewChecklist2$roo11, _reviewChecklist2$roo12, _reviewChecklist2$sol, _reviewChecklist2$sol2, _reviewChecklist2$sol3, _reviewChecklist2$sol4, _reviewChecklist2$sol5, _reviewChecklist2$sol6, _reviewChecklist2$sol7, _reviewChecklist2$sol8, _reviewChecklist2$sol9, _reviewChecklist2$sol10, _reviewChecklist2$sol11, _reviewChecklist2$sol12;
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const dispatch = useDispatch();
  const defaultValues = {
    ...formData,
    checklist: {
      ...(formData === null || formData === void 0 ? void 0 : formData.checklist)
    }
  };
  console.log("fromChecklist", formData);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    register
  } = useForm({
    defaultValues
  });
  const firstCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const secondCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const reviewChecklist1 = formData === null || formData === void 0 ? void 0 : (_formData$checklistRe = formData.checklistReview) === null || _formData$checklistRe === void 0 ? void 0 : _formData$checklistRe.firstCheckList;
  const reviewChecklist2 = formData === null || formData === void 0 ? void 0 : (_formData$checklistRe2 = formData.checklistReview) === null || _formData$checklistRe2 === void 0 ? void 0 : _formData$checklistRe2.secondCheckList;
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  console.log("applicationDOcs", applicationDocs);
  const proposalDocument = (_applicationDocs$filt = applicationDocs.filter(item => ["proposalDocument"].includes(item.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const drawingFile = (_applicationDocs$filt3 = applicationDocs.filter(item => ["drawingFile"].includes(item.documentType))) === null || _applicationDocs$filt3 === void 0 ? void 0 : (_applicationDocs$filt4 = _applicationDocs$filt3[0]) === null || _applicationDocs$filt4 === void 0 ? void 0 : _applicationDocs$filt4.fileStoreId;
  const structuralCertificate = (_applicationDocs$filt5 = applicationDocs.filter(item => ["structuralCertificate"].includes(item.documentType))) === null || _applicationDocs$filt5 === void 0 ? void 0 : (_applicationDocs$filt6 = _applicationDocs$filt5[0]) === null || _applicationDocs$filt6 === void 0 ? void 0 : _applicationDocs$filt6.fileStoreId;
  const fireDepartmentCertificate = (_applicationDocs$filt7 = applicationDocs.filter(item => ["fireDepartmentCertificate"].includes(item.documentType))) === null || _applicationDocs$filt7 === void 0 ? void 0 : (_applicationDocs$filt8 = _applicationDocs$filt7[0]) === null || _applicationDocs$filt8 === void 0 ? void 0 : _applicationDocs$filt8.fileStoreId;
  useEffect(() => {
    const storedData = sessionStorage.getItem("checklistReview");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      Object.keys(parsedData).forEach(key => {
        setValue(key, parsedData[key]);
      });
    }
  }, [setValue]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    },
    onBlur: e => {
      handleInputChange(e.target.name, e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "User Input"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Officer Verification"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Correction"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_SETBACK_POSITION")))), ["Front", "Rear", "SSB1", "SSB2"].map(position => {
    var _firstCheckList$setba, _reviewChecklist1$set, _reviewChecklist1$set2, _reviewChecklist1$set3, _reviewChecklist1$set4, _reviewChecklist1$set5, _reviewChecklist1$set6;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: position
    }, /*#__PURE__*/React__default.createElement("td", null, position, /*#__PURE__*/React__default.createElement("span", {
      className: "compulsoryField"
    }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$setba = firstCheckList.setbackPosition) === null || _firstCheckList$setba === void 0 ? void 0 : _firstCheckList$setba[position.toLowerCase()]) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$set = reviewChecklist1.setbackPosition) === null || _reviewChecklist1$set === void 0 ? void 0 : (_reviewChecklist1$set2 = _reviewChecklist1$set[position.toLowerCase()]) === null || _reviewChecklist1$set2 === void 0 ? void 0 : _reviewChecklist1$set2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$set3 = reviewChecklist1.setbackPosition) === null || _reviewChecklist1$set3 === void 0 ? void 0 : (_reviewChecklist1$set4 = _reviewChecklist1$set3[position.toLowerCase()]) === null || _reviewChecklist1$set4 === void 0 ? void 0 : _reviewChecklist1$set4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$set5 = reviewChecklist1.setbackPosition) === null || _reviewChecklist1$set5 === void 0 ? void 0 : (_reviewChecklist1$set6 = _reviewChecklist1$set5[position.toLowerCase()]) === null || _reviewChecklist1$set6 === void 0 ? void 0 : _reviewChecklist1$set6.remarks));
  }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Proposed Building (m)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.buildingHeight) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$bui = reviewChecklist1.buildingHeight) === null || _reviewChecklist1$bui === void 0 ? void 0 : _reviewChecklist1$bui.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$bui2 = reviewChecklist1.buildingHeight) === null || _reviewChecklist1$bui2 === void 0 ? void 0 : _reviewChecklist1$bui2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$bui3 = reviewChecklist1.buildingHeight) === null || _reviewChecklist1$bui3 === void 0 ? void 0 : _reviewChecklist1$bui3.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Proposal Document (PDF)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$pro = reviewChecklist1.proposalDocument) === null || _reviewChecklist1$pro === void 0 ? void 0 : _reviewChecklist1$pro.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$pro2 = reviewChecklist1.proposalDocument) === null || _reviewChecklist1$pro2 === void 0 ? void 0 : _reviewChecklist1$pro2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$pro3 = reviewChecklist1.proposalDocument) === null || _reviewChecklist1$pro3 === void 0 ? void 0 : _reviewChecklist1$pro3.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Drawing File (.dwg)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$dra = reviewChecklist1.drawingFile) === null || _reviewChecklist1$dra === void 0 ? void 0 : _reviewChecklist1$dra.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$dra2 = reviewChecklist1.drawingFile) === null || _reviewChecklist1$dra2 === void 0 ? void 0 : _reviewChecklist1$dra2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$dra3 = reviewChecklist1.drawingFile) === null || _reviewChecklist1$dra3 === void 0 ? void 0 : _reviewChecklist1$dra3.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Structural Safety Certificate Applicable", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str = reviewChecklist1.structuralSafety) === null || _reviewChecklist1$str === void 0 ? void 0 : _reviewChecklist1$str.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str2 = reviewChecklist1.structuralSafety) === null || _reviewChecklist1$str2 === void 0 ? void 0 : _reviewChecklist1$str2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str3 = reviewChecklist1.structuralSafety) === null || _reviewChecklist1$str3 === void 0 ? void 0 : _reviewChecklist1$str3.remarks)), (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) === "Yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Attached Document", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str4 = reviewChecklist1.structuralSafetyCert) === null || _reviewChecklist1$str4 === void 0 ? void 0 : _reviewChecklist1$str4.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str5 = reviewChecklist1.structuralSafetyCert) === null || _reviewChecklist1$str5 === void 0 ? void 0 : _reviewChecklist1$str5.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$str6 = reviewChecklist1.structuralSafetyCert) === null || _reviewChecklist1$str6 === void 0 ? void 0 : _reviewChecklist1$str6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Fire Department Certificate", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)
  })), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$fir = reviewChecklist1.fireDepartmentCert) === null || _reviewChecklist1$fir === void 0 ? void 0 : _reviewChecklist1$fir.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$fir2 = reviewChecklist1.fireDepartmentCert) === null || _reviewChecklist1$fir2 === void 0 ? void 0 : _reviewChecklist1$fir2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$fir3 = reviewChecklist1.fireDepartmentCert) === null || _reviewChecklist1$fir3 === void 0 ? void 0 : _reviewChecklist1$fir3.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_PARKING_ARRANGEMENT")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Total Parking Required (sq.m)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.totalParkingRequired) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$tot = reviewChecklist1.totalParkingRequired) === null || _reviewChecklist1$tot === void 0 ? void 0 : _reviewChecklist1$tot.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$tot2 = reviewChecklist1.totalParkingRequired) === null || _reviewChecklist1$tot2 === void 0 ? void 0 : _reviewChecklist1$tot2.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$tot3 = reviewChecklist1.totalParkingRequired) === null || _reviewChecklist1$tot3 === void 0 ? void 0 : _reviewChecklist1$tot3.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Parking Provision as per Proposed Plan"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2
  }, "In Basement", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki = firstCheckList.parkingProvision) === null || _firstCheckList$parki === void 0 ? void 0 : (_firstCheckList$parki2 = _firstCheckList$parki.inBasement) === null || _firstCheckList$parki2 === void 0 ? void 0 : _firstCheckList$parki2.cars) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par === void 0 ? void 0 : (_reviewChecklist1$par2 = _reviewChecklist1$par.inBasement) === null || _reviewChecklist1$par2 === void 0 ? void 0 : (_reviewChecklist1$par3 = _reviewChecklist1$par2.cars) === null || _reviewChecklist1$par3 === void 0 ? void 0 : _reviewChecklist1$par3.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par4 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par4 === void 0 ? void 0 : (_reviewChecklist1$par5 = _reviewChecklist1$par4.inBasement) === null || _reviewChecklist1$par5 === void 0 ? void 0 : (_reviewChecklist1$par6 = _reviewChecklist1$par5.cars) === null || _reviewChecklist1$par6 === void 0 ? void 0 : _reviewChecklist1$par6.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par7 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par7 === void 0 ? void 0 : (_reviewChecklist1$par8 = _reviewChecklist1$par7.inBasement) === null || _reviewChecklist1$par8 === void 0 ? void 0 : (_reviewChecklist1$par9 = _reviewChecklist1$par8.cars) === null || _reviewChecklist1$par9 === void 0 ? void 0 : _reviewChecklist1$par9.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of ECS: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki3 = firstCheckList.parkingProvision) === null || _firstCheckList$parki3 === void 0 ? void 0 : (_firstCheckList$parki4 = _firstCheckList$parki3.inBasement) === null || _firstCheckList$parki4 === void 0 ? void 0 : _firstCheckList$parki4.ecs) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par10 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par10 === void 0 ? void 0 : (_reviewChecklist1$par11 = _reviewChecklist1$par10.inBasement) === null || _reviewChecklist1$par11 === void 0 ? void 0 : (_reviewChecklist1$par12 = _reviewChecklist1$par11.ecs) === null || _reviewChecklist1$par12 === void 0 ? void 0 : _reviewChecklist1$par12.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par13 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par13 === void 0 ? void 0 : (_reviewChecklist1$par14 = _reviewChecklist1$par13.inBasement) === null || _reviewChecklist1$par14 === void 0 ? void 0 : (_reviewChecklist1$par15 = _reviewChecklist1$par14.ecs) === null || _reviewChecklist1$par15 === void 0 ? void 0 : _reviewChecklist1$par15.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par16 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par16 === void 0 ? void 0 : (_reviewChecklist1$par17 = _reviewChecklist1$par16.inBasement) === null || _reviewChecklist1$par17 === void 0 ? void 0 : (_reviewChecklist1$par18 = _reviewChecklist1$par17.ecs) === null || _reviewChecklist1$par18 === void 0 ? void 0 : _reviewChecklist1$par18.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2
  }, "In Open Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki5 = firstCheckList.parkingProvision) === null || _firstCheckList$parki5 === void 0 ? void 0 : (_firstCheckList$parki6 = _firstCheckList$parki5.openArea) === null || _firstCheckList$parki6 === void 0 ? void 0 : _firstCheckList$parki6.cars) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par19 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par19 === void 0 ? void 0 : (_reviewChecklist1$par20 = _reviewChecklist1$par19.openArea) === null || _reviewChecklist1$par20 === void 0 ? void 0 : (_reviewChecklist1$par21 = _reviewChecklist1$par20.cars) === null || _reviewChecklist1$par21 === void 0 ? void 0 : _reviewChecklist1$par21.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par22 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par22 === void 0 ? void 0 : (_reviewChecklist1$par23 = _reviewChecklist1$par22.openArea) === null || _reviewChecklist1$par23 === void 0 ? void 0 : (_reviewChecklist1$par24 = _reviewChecklist1$par23.cars) === null || _reviewChecklist1$par24 === void 0 ? void 0 : _reviewChecklist1$par24.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par25 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par25 === void 0 ? void 0 : (_reviewChecklist1$par26 = _reviewChecklist1$par25.openArea) === null || _reviewChecklist1$par26 === void 0 ? void 0 : (_reviewChecklist1$par27 = _reviewChecklist1$par26.cars) === null || _reviewChecklist1$par27 === void 0 ? void 0 : _reviewChecklist1$par27.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of ECS: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki7 = firstCheckList.parkingProvision) === null || _firstCheckList$parki7 === void 0 ? void 0 : (_firstCheckList$parki8 = _firstCheckList$parki7.openArea) === null || _firstCheckList$parki8 === void 0 ? void 0 : _firstCheckList$parki8.ecs) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par28 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par28 === void 0 ? void 0 : (_reviewChecklist1$par29 = _reviewChecklist1$par28.openArea) === null || _reviewChecklist1$par29 === void 0 ? void 0 : (_reviewChecklist1$par30 = _reviewChecklist1$par29.ecs) === null || _reviewChecklist1$par30 === void 0 ? void 0 : _reviewChecklist1$par30.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par31 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par31 === void 0 ? void 0 : (_reviewChecklist1$par32 = _reviewChecklist1$par31.openArea) === null || _reviewChecklist1$par32 === void 0 ? void 0 : (_reviewChecklist1$par33 = _reviewChecklist1$par32.ecs) === null || _reviewChecklist1$par33 === void 0 ? void 0 : _reviewChecklist1$par33.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par34 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par34 === void 0 ? void 0 : (_reviewChecklist1$par35 = _reviewChecklist1$par34.openArea) === null || _reviewChecklist1$par35 === void 0 ? void 0 : (_reviewChecklist1$par36 = _reviewChecklist1$par35.ecs) === null || _reviewChecklist1$par36 === void 0 ? void 0 : _reviewChecklist1$par36.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2
  }, "In Stilt Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, "No. of Cars: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki9 = firstCheckList.parkingProvision) === null || _firstCheckList$parki9 === void 0 ? void 0 : (_firstCheckList$parki10 = _firstCheckList$parki9.inStiltArea) === null || _firstCheckList$parki10 === void 0 ? void 0 : _firstCheckList$parki10.cars) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par37 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par37 === void 0 ? void 0 : (_reviewChecklist1$par38 = _reviewChecklist1$par37.inStiltArea) === null || _reviewChecklist1$par38 === void 0 ? void 0 : (_reviewChecklist1$par39 = _reviewChecklist1$par38.cars) === null || _reviewChecklist1$par39 === void 0 ? void 0 : _reviewChecklist1$par39.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par40 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par40 === void 0 ? void 0 : (_reviewChecklist1$par41 = _reviewChecklist1$par40.inStiltArea) === null || _reviewChecklist1$par41 === void 0 ? void 0 : (_reviewChecklist1$par42 = _reviewChecklist1$par41.cars) === null || _reviewChecklist1$par42 === void 0 ? void 0 : _reviewChecklist1$par42.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par43 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par43 === void 0 ? void 0 : (_reviewChecklist1$par44 = _reviewChecklist1$par43.inStiltArea) === null || _reviewChecklist1$par44 === void 0 ? void 0 : (_reviewChecklist1$par45 = _reviewChecklist1$par44.cars) === null || _reviewChecklist1$par45 === void 0 ? void 0 : _reviewChecklist1$par45.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of ECS: ", (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki11 = firstCheckList.parkingProvision) === null || _firstCheckList$parki11 === void 0 ? void 0 : (_firstCheckList$parki12 = _firstCheckList$parki11.inStiltArea) === null || _firstCheckList$parki12 === void 0 ? void 0 : _firstCheckList$parki12.ecs) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par46 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par46 === void 0 ? void 0 : (_reviewChecklist1$par47 = _reviewChecklist1$par46.inStiltArea) === null || _reviewChecklist1$par47 === void 0 ? void 0 : (_reviewChecklist1$par48 = _reviewChecklist1$par47.ecs) === null || _reviewChecklist1$par48 === void 0 ? void 0 : _reviewChecklist1$par48.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par49 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par49 === void 0 ? void 0 : (_reviewChecklist1$par50 = _reviewChecklist1$par49.inStiltArea) === null || _reviewChecklist1$par50 === void 0 ? void 0 : (_reviewChecklist1$par51 = _reviewChecklist1$par50.ecs) === null || _reviewChecklist1$par51 === void 0 ? void 0 : _reviewChecklist1$par51.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist1 === null || reviewChecklist1 === void 0 ? void 0 : (_reviewChecklist1$par52 = reviewChecklist1.parkingProvision) === null || _reviewChecklist1$par52 === void 0 ? void 0 : (_reviewChecklist1$par53 = _reviewChecklist1$par52.inStiltArea) === null || _reviewChecklist1$par53 === void 0 ? void 0 : (_reviewChecklist1$par54 = _reviewChecklist1$par53.ecs) === null || _reviewChecklist1$par54 === void 0 ? void 0 : _reviewChecklist1$par54.remarks))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    },
    onBlur: e => {
      handleInputChange(e.target.name, e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "50%"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "User Input"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Officer Verification"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Correction"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Sewerage (including stormwater)"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Public sewerage plan or septic tank", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.publicSewerageOrSepticTank ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew === void 0 ? void 0 : (_reviewChecklist2$sew2 = _reviewChecklist2$sew.publicSewerageOrSepticTank) === null || _reviewChecklist2$sew2 === void 0 ? void 0 : _reviewChecklist2$sew2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew3 = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew3 === void 0 ? void 0 : (_reviewChecklist2$sew4 = _reviewChecklist2$sew3.publicSewerageOrSepticTank) === null || _reviewChecklist2$sew4 === void 0 ? void 0 : _reviewChecklist2$sew4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew5 = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew5 === void 0 ? void 0 : (_reviewChecklist2$sew6 = _reviewChecklist2$sew5.publicSewerageOrSepticTank) === null || _reviewChecklist2$sew6 === void 0 ? void 0 : _reviewChecklist2$sew6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Proposed drainage plan approval", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.drainagePlanApproval ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew7 = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew7 === void 0 ? void 0 : (_reviewChecklist2$sew8 = _reviewChecklist2$sew7.drainagePlanApproval) === null || _reviewChecklist2$sew8 === void 0 ? void 0 : _reviewChecklist2$sew8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew9 = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew9 === void 0 ? void 0 : (_reviewChecklist2$sew10 = _reviewChecklist2$sew9.drainagePlanApproval) === null || _reviewChecklist2$sew10 === void 0 ? void 0 : _reviewChecklist2$sew10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew11 = reviewChecklist2.sewerage) === null || _reviewChecklist2$sew11 === void 0 ? void 0 : (_reviewChecklist2$sew12 = _reviewChecklist2$sew11.drainagePlanApproval) === null || _reviewChecklist2$sew12 === void 0 ? void 0 : _reviewChecklist2$sew12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Road Connectivity"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing road width in meters", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.existingRoadWidth) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa === void 0 ? void 0 : (_reviewChecklist2$roa2 = _reviewChecklist2$roa.existingRoadWidth) === null || _reviewChecklist2$roa2 === void 0 ? void 0 : _reviewChecklist2$roa2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa3 = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa3 === void 0 ? void 0 : (_reviewChecklist2$roa4 = _reviewChecklist2$roa3.existingRoadWidth) === null || _reviewChecklist2$roa4 === void 0 ? void 0 : _reviewChecklist2$roa4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa5 = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa5 === void 0 ? void 0 : (_reviewChecklist2$roa6 = _reviewChecklist2$roa5.existingRoadWidth) === null || _reviewChecklist2$roa6 === void 0 ? void 0 : _reviewChecklist2$roa6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Minimum 24 meters wide", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.minimum24MetersWide ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa7 = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa7 === void 0 ? void 0 : (_reviewChecklist2$roa8 = _reviewChecklist2$roa7.minimum24MetersWide) === null || _reviewChecklist2$roa8 === void 0 ? void 0 : _reviewChecklist2$roa8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa9 = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa9 === void 0 ? void 0 : (_reviewChecklist2$roa10 = _reviewChecklist2$roa9.minimum24MetersWide) === null || _reviewChecklist2$roa10 === void 0 ? void 0 : _reviewChecklist2$roa10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roa11 = reviewChecklist2.roadConnectivity) === null || _reviewChecklist2$roa11 === void 0 ? void 0 : (_reviewChecklist2$roa12 = _reviewChecklist2$roa11.minimum24MetersWide) === null || _reviewChecklist2$roa12 === void 0 ? void 0 : _reviewChecklist2$roa12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Water Supply"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Water supply arrangement (capacity in liters per day)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.waterSupplyArrangement) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat === void 0 ? void 0 : (_reviewChecklist2$wat2 = _reviewChecklist2$wat.waterSupplyArrangement) === null || _reviewChecklist2$wat2 === void 0 ? void 0 : _reviewChecklist2$wat2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat3 = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat3 === void 0 ? void 0 : (_reviewChecklist2$wat4 = _reviewChecklist2$wat3.waterSupplyArrangement) === null || _reviewChecklist2$wat4 === void 0 ? void 0 : _reviewChecklist2$wat4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat5 = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat5 === void 0 ? void 0 : (_reviewChecklist2$wat6 = _reviewChecklist2$wat5.waterSupplyArrangement) === null || _reviewChecklist2$wat6 === void 0 ? void 0 : _reviewChecklist2$wat6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Water supply plan as per requirements", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.waterSupplyPlanApproval ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat7 = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat7 === void 0 ? void 0 : (_reviewChecklist2$wat8 = _reviewChecklist2$wat7.waterSupplyPlanApproval) === null || _reviewChecklist2$wat8 === void 0 ? void 0 : _reviewChecklist2$wat8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat9 = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat9 === void 0 ? void 0 : (_reviewChecklist2$wat10 = _reviewChecklist2$wat9.waterSupplyPlanApproval) === null || _reviewChecklist2$wat10 === void 0 ? void 0 : _reviewChecklist2$wat10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$wat11 = reviewChecklist2.waterSupply) === null || _reviewChecklist2$wat11 === void 0 ? void 0 : (_reviewChecklist2$wat12 = _reviewChecklist2$wat11.waterSupplyPlanApproval) === null || _reviewChecklist2$wat12 === void 0 ? void 0 : _reviewChecklist2$wat12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Sewerage Disposal"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "STP/Septic tank arrangement made by applicant. Or Establish Connectivity with Govt. Authority", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.stpSepticTankArrangement) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew13 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew13 === void 0 ? void 0 : (_reviewChecklist2$sew14 = _reviewChecklist2$sew13.stpSepticTankArrangement) === null || _reviewChecklist2$sew14 === void 0 ? void 0 : _reviewChecklist2$sew14.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew15 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew15 === void 0 ? void 0 : (_reviewChecklist2$sew16 = _reviewChecklist2$sew15.stpSepticTankArrangement) === null || _reviewChecklist2$sew16 === void 0 ? void 0 : _reviewChecklist2$sew16.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew17 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew17 === void 0 ? void 0 : (_reviewChecklist2$sew18 = _reviewChecklist2$sew17.stpSepticTankArrangement) === null || _reviewChecklist2$sew18 === void 0 ? void 0 : _reviewChecklist2$sew18.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Yes / No, confirms to standards / not. It is proposed to establish connectivity with the Government Authority.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.connectivityWithGovernmentAuthority ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew19 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew19 === void 0 ? void 0 : (_reviewChecklist2$sew20 = _reviewChecklist2$sew19.connectivityWithGovernmentAuthority) === null || _reviewChecklist2$sew20 === void 0 ? void 0 : _reviewChecklist2$sew20.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew21 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew21 === void 0 ? void 0 : (_reviewChecklist2$sew22 = _reviewChecklist2$sew21.connectivityWithGovernmentAuthority) === null || _reviewChecklist2$sew22 === void 0 ? void 0 : _reviewChecklist2$sew22.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sew23 = reviewChecklist2.sewerageDisposal) === null || _reviewChecklist2$sew23 === void 0 ? void 0 : (_reviewChecklist2$sew24 = _reviewChecklist2$sew23.connectivityWithGovernmentAuthority) === null || _reviewChecklist2$sew24 === void 0 ? void 0 : _reviewChecklist2$sew24.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drainage System Compliance"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "The proposed system is as per the standards or the government agency has approved connectivity.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : (_secondCheckList$drai = secondCheckList.drainageSystemCompliance) === null || _secondCheckList$drai === void 0 ? void 0 : _secondCheckList$drai.systemAsPerStandards) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra === void 0 ? void 0 : (_reviewChecklist2$dra2 = _reviewChecklist2$dra.systemAsPerStandards) === null || _reviewChecklist2$dra2 === void 0 ? void 0 : _reviewChecklist2$dra2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra3 = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra3 === void 0 ? void 0 : (_reviewChecklist2$dra4 = _reviewChecklist2$dra3.systemAsPerStandards) === null || _reviewChecklist2$dra4 === void 0 ? void 0 : _reviewChecklist2$dra4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra5 = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra5 === void 0 ? void 0 : (_reviewChecklist2$dra6 = _reviewChecklist2$dra5.systemAsPerStandards) === null || _reviewChecklist2$dra6 === void 0 ? void 0 : _reviewChecklist2$dra6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "As per standards / not.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.drainageAsPerStandards ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra7 = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra7 === void 0 ? void 0 : (_reviewChecklist2$dra8 = _reviewChecklist2$dra7.drainageAsPerStandards) === null || _reviewChecklist2$dra8 === void 0 ? void 0 : _reviewChecklist2$dra8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra9 = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra9 === void 0 ? void 0 : (_reviewChecklist2$dra10 = _reviewChecklist2$dra9.drainageAsPerStandards) === null || _reviewChecklist2$dra10 === void 0 ? void 0 : _reviewChecklist2$dra10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$dra11 = reviewChecklist2.drainageSystemCompliance) === null || _reviewChecklist2$dra11 === void 0 ? void 0 : (_reviewChecklist2$dra12 = _reviewChecklist2$dra11.drainageAsPerStandards) === null || _reviewChecklist2$dra12 === void 0 ? void 0 : _reviewChecklist2$dra12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Power Supply"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Total estimated power demand (kW/MW)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.totalEstimatedPowerDemand) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow === void 0 ? void 0 : (_reviewChecklist2$pow2 = _reviewChecklist2$pow.totalEstimatedPowerDemand) === null || _reviewChecklist2$pow2 === void 0 ? void 0 : _reviewChecklist2$pow2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow3 = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow3 === void 0 ? void 0 : (_reviewChecklist2$pow4 = _reviewChecklist2$pow3.totalEstimatedPowerDemand) === null || _reviewChecklist2$pow4 === void 0 ? void 0 : _reviewChecklist2$pow4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow5 = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow5 === void 0 ? void 0 : (_reviewChecklist2$pow6 = _reviewChecklist2$pow5.totalEstimatedPowerDemand) === null || _reviewChecklist2$pow6 === void 0 ? void 0 : _reviewChecklist2$pow6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Corporation Ltd. has consent for supply in respect of proposed Garg. Power received", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.powerSupplyConsent ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow7 = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow7 === void 0 ? void 0 : (_reviewChecklist2$pow8 = _reviewChecklist2$pow7.powerSupplyConsent) === null || _reviewChecklist2$pow8 === void 0 ? void 0 : _reviewChecklist2$pow8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow9 = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow9 === void 0 ? void 0 : (_reviewChecklist2$pow10 = _reviewChecklist2$pow9.powerSupplyConsent) === null || _reviewChecklist2$pow10 === void 0 ? void 0 : _reviewChecklist2$pow10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$pow11 = reviewChecklist2.powerSupply) === null || _reviewChecklist2$pow11 === void 0 ? void 0 : (_reviewChecklist2$pow12 = _reviewChecklist2$pow11.powerSupplyConsent) === null || _reviewChecklist2$pow12 === void 0 ? void 0 : _reviewChecklist2$pow12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Roof-top Rainwater Harvesting System"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Total area of rooftop (sq. meters) and provision of drain pipe and recharge pit", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.rooftopArea) || ""), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo === void 0 ? void 0 : (_reviewChecklist2$roo2 = _reviewChecklist2$roo.areaAndDrainage) === null || _reviewChecklist2$roo2 === void 0 ? void 0 : _reviewChecklist2$roo2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo3 = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo3 === void 0 ? void 0 : (_reviewChecklist2$roo4 = _reviewChecklist2$roo3.areaAndDrainage) === null || _reviewChecklist2$roo4 === void 0 ? void 0 : _reviewChecklist2$roo4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo5 = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo5 === void 0 ? void 0 : (_reviewChecklist2$roo6 = _reviewChecklist2$roo5.areaAndDrainage) === null || _reviewChecklist2$roo6 === void 0 ? void 0 : _reviewChecklist2$roo6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Found to be as per standard / not", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.drainageStandardsCompliance ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo7 = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo7 === void 0 ? void 0 : (_reviewChecklist2$roo8 = _reviewChecklist2$roo7.drainageStandardsCompliance) === null || _reviewChecklist2$roo8 === void 0 ? void 0 : _reviewChecklist2$roo8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo9 = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo9 === void 0 ? void 0 : (_reviewChecklist2$roo10 = _reviewChecklist2$roo9.drainageStandardsCompliance) === null || _reviewChecklist2$roo10 === void 0 ? void 0 : _reviewChecklist2$roo10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$roo11 = reviewChecklist2.rooftopRainwaterHarvesting) === null || _reviewChecklist2$roo11 === void 0 ? void 0 : (_reviewChecklist2$roo12 = _reviewChecklist2$roo11.drainageStandardsCompliance) === null || _reviewChecklist2$roo12 === void 0 ? void 0 : _reviewChecklist2$roo12.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Solar Water System"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of pipes in the building design for solar water heating system and determination of suitable location for the plant on the rooftop.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.solarWaterHeatingProvision ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol === void 0 ? void 0 : (_reviewChecklist2$sol2 = _reviewChecklist2$sol.provisionForPipes) === null || _reviewChecklist2$sol2 === void 0 ? void 0 : _reviewChecklist2$sol2.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol3 = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol3 === void 0 ? void 0 : (_reviewChecklist2$sol4 = _reviewChecklist2$sol3.provisionForPipes) === null || _reviewChecklist2$sol4 === void 0 ? void 0 : _reviewChecklist2$sol4.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol5 = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol5 === void 0 ? void 0 : (_reviewChecklist2$sol6 = _reviewChecklist2$sol5.provisionForPipes) === null || _reviewChecklist2$sol6 === void 0 ? void 0 : _reviewChecklist2$sol6.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether provision made as per building bye-laws or not", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, secondCheckList !== null && secondCheckList !== void 0 && secondCheckList.buildingByeLawsCompliance ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol7 = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol7 === void 0 ? void 0 : (_reviewChecklist2$sol8 = _reviewChecklist2$sol7.buildingByeLawsCompliance) === null || _reviewChecklist2$sol8 === void 0 ? void 0 : _reviewChecklist2$sol8.verifiedByOfficer), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol9 = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol9 === void 0 ? void 0 : (_reviewChecklist2$sol10 = _reviewChecklist2$sol9.buildingByeLawsCompliance) === null || _reviewChecklist2$sol10 === void 0 ? void 0 : _reviewChecklist2$sol10.correction), /*#__PURE__*/React__default.createElement("td", null, reviewChecklist2 === null || reviewChecklist2 === void 0 ? void 0 : (_reviewChecklist2$sol11 = reviewChecklist2.solarWaterSystem) === null || _reviewChecklist2$sol11 === void 0 ? void 0 : (_reviewChecklist2$sol12 = _reviewChecklist2$sol11.buildingByeLawsCompliance) === null || _reviewChecklist2$sol12 === void 0 ? void 0 : _reviewChecklist2$sol12.remarks))))));
};

const CitizenFarDetails = ({
  formData
}) => {
  var _formData$description, _formData$description2, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _formData$taxHeadEsti5, _formData$taxHeadEsti6, _formData$taxHeadEsti7, _formData$taxHeadEsti8, _formData$taxHeadEsti9, _formData$taxHeadEsti10, _formData$taxHeadEsti11, _formData$taxHeadEsti12, _formData$taxHeadEsti13, _formData$taxHeadEsti14, _formData$taxHeadEsti15, _formData$taxHeadEsti16, _formData$taxHeadEsti17, _formData$taxHeadEsti18, _formData$taxHeadEsti19, _formData$taxHeadEsti20, _formData$taxHeadEsti21, _formData$taxHeadEsti22, _formData$taxHeadEsti23, _formData$taxHeadEsti24, _formData$taxHeadEsti25, _formData$taxHeadEsti26, _formData$taxHeadEsti27, _formData$taxHeadEsti28;
  const {
    t
  } = useTranslation();
  const properties = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0];
  const factorString = properties === null || properties === void 0 ? void 0 : properties.landUseAsPerLayout;
  console.log("DetailsFromFAR", formData);
  const factorNum = React__default.useMemo(() => {
    if (factorString === "Residential (Group Housing)" || factorString === "Hotel") {
      return 0.4;
    } else if (factorString === "Office/Organization" || factorString === "Mixed land") {
      return 0.45;
    } else if (factorString === "Commercial") {
      return 0.5;
    } else {
      return 0.2;
    }
  }, [factorString]);
  return /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Input Data"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Required FAR"))), /*#__PURE__*/React__default.createElement("td", null, properties === null || properties === void 0 ? void 0 : properties.percentRequiredFAR)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Required FAR Area"))), /*#__PURE__*/React__default.createElement("td", null, properties === null || properties === void 0 ? void 0 : properties.requiredAreaFAR)), (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.basicFar) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Basic FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3[0]) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.basicFar} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti5 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : (_formData$taxHeadEsti6 = _formData$taxHeadEsti5[0]) === null || _formData$taxHeadEsti6 === void 0 ? void 0 : _formData$taxHeadEsti6.totalBuiltUpArea}`)), (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti7 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti7 === void 0 ? void 0 : (_formData$taxHeadEsti8 = _formData$taxHeadEsti7[0]) === null || _formData$taxHeadEsti8 === void 0 ? void 0 : _formData$taxHeadEsti8.permissibleFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Permissible Purchasable FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti9 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti9 === void 0 ? void 0 : (_formData$taxHeadEsti10 = _formData$taxHeadEsti9[0]) === null || _formData$taxHeadEsti10 === void 0 ? void 0 : _formData$taxHeadEsti10.permissibleFAR} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti11 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti11 === void 0 ? void 0 : (_formData$taxHeadEsti12 = _formData$taxHeadEsti11[0]) === null || _formData$taxHeadEsti12 === void 0 ? void 0 : _formData$taxHeadEsti12.permissibleFARArea}`)), (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti13 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti13 === void 0 ? void 0 : (_formData$taxHeadEsti14 = _formData$taxHeadEsti13[0]) === null || _formData$taxHeadEsti14 === void 0 ? void 0 : _formData$taxHeadEsti14.totalPermissibleFar) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Maximum Permissible Purchasable FAR and Area (SqM)"))), /*#__PURE__*/React__default.createElement("td", null, `${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti15 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti15 === void 0 ? void 0 : (_formData$taxHeadEsti16 = _formData$taxHeadEsti15[0]) === null || _formData$taxHeadEsti16 === void 0 ? void 0 : _formData$taxHeadEsti16.totalPermissibleFar} and ${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti17 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti17 === void 0 ? void 0 : (_formData$taxHeadEsti18 = _formData$taxHeadEsti17[0]) === null || _formData$taxHeadEsti18 === void 0 ? void 0 : _formData$taxHeadEsti18.totalPermissibleFARArea}`)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Factor"))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti19 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti19 === void 0 ? void 0 : (_formData$taxHeadEsti20 = _formData$taxHeadEsti19[0]) === null || _formData$taxHeadEsti20 === void 0 ? void 0 : _formData$taxHeadEsti20.factor)), !!(formData !== null && formData !== void 0 && (_formData$taxHeadEsti21 = formData.taxHeadEstimates) !== null && _formData$taxHeadEsti21 !== void 0 && (_formData$taxHeadEsti22 = _formData$taxHeadEsti21[0]) !== null && _formData$taxHeadEsti22 !== void 0 && _formData$taxHeadEsti22.schemeRate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Circle Rate"))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti23 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti23 === void 0 ? void 0 : (_formData$taxHeadEsti24 = _formData$taxHeadEsti23[0]) === null || _formData$taxHeadEsti24 === void 0 ? void 0 : _formData$taxHeadEsti24.schemeRate)), Boolean(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti25 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti25 === void 0 ? void 0 : (_formData$taxHeadEsti26 = _formData$taxHeadEsti25[0]) === null || _formData$taxHeadEsti26 === void 0 ? void 0 : _formData$taxHeadEsti26.estimateAmount) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Total fees"))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti27 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti27 === void 0 ? void 0 : (_formData$taxHeadEsti28 = _formData$taxHeadEsti27[0]) === null || _formData$taxHeadEsti28 === void 0 ? void 0 : _formData$taxHeadEsti28.estimateAmount))));
};

const FarPaymentOption = ({
  tenantId,
  formData,
  setFetchedPaymentData
}) => {
  var _formData$taxHeadEsti, _formData$taxHeadEsti2;
  console.log("formDatafromPayment", formData, tenantId);
  const {
    control,
    watch
  } = useForm();
  const selectedMode = watch("farPaymentOption");
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handlePaymentMode = value => {
    console.log(value, "valueFromCHange");
    if (value === "Full Payment") {
      console.log("handlePaymentFull");
      setPaymentMode("full");
    } else {
      console.log("handlePaymentInstallments");
      setPaymentMode("installments");
    }
  };
  const paymentPayload = {
    CalulationCriteria: [{
      FeeRequest: {
        fee: {
          tenantid: tenantId || "up",
          businessservice: formData === null || formData === void 0 ? void 0 : formData.businessService,
          consumercode: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          billno: "123"
        },
        fees: {
          totalfee: formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount,
          paymentMode: paymentMode
        }
      },
      tenantId: tenantId || "up",
      feeType: "ApplicationFee"
    }]
  };
  const fetchPaymentDetails = async paymentPayload => {
    console.log("insideFetchFunction");
    try {
      var _result$Calculations;
      const result = await OBPSService.calculateInstallments(paymentPayload);
      setFetchedPaymentData(result === null || result === void 0 ? void 0 : (_result$Calculations = result.Calculations) === null || _result$Calculations === void 0 ? void 0 : _result$Calculations[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(async () => {
    if (paymentMode) {
      console.log("effectPaymentCalled", paymentMode);
      await fetchPaymentDetails(paymentPayload);
    }
  }, [paymentMode]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    onChange: e => handlePaymentMode(e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    type: "radioButton",
    name: "farPaymentOption",
    data: farPayment,
    label: "Select Payment Mode"
  })));
};

const FarPaymentDisplay = ({
  paymentDetails,
  totalAmount
}) => {
  var _paymentDetails$FeeIn, _paymentDetails$FeeIn2, _installments$;
  const {
    t
  } = useTranslation();
  const Modal = useModal();
  console.log("paymentDetails", paymentDetails);
  const details = paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$FeeIn = paymentDetails.FeeInstallment) === null || _paymentDetails$FeeIn === void 0 ? void 0 : _paymentDetails$FeeIn[0];
  const isFullPayment = (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$FeeIn2 = paymentDetails.FeeInstallment) === null || _paymentDetails$FeeIn2 === void 0 ? void 0 : _paymentDetails$FeeIn2.length) > 1;
  const installments = paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.FeeInstallment;
  console.log("fromDisplay", installments, isFullPayment);
  const installmentBreakdown = `<ul class="installment-breakdown">
  <li><strong>Total Amount of Purchasable FAR:</strong> ${totalAmount}</li>
  <li><strong>First installment to be paid at the time of provisional approval (25% of Total Amount):</strong> ${installments === null || installments === void 0 ? void 0 : (_installments$ = installments[0]) === null || _installments$ === void 0 ? void 0 : _installments$.amount}</li>
  <li><strong>Interest on remaining amount:</strong> 12% yearly on remaining balance</li>
  <li><strong>Interest calculated on remaining amount:</strong> {Interest Amount} added to subsequent installments</li>
  <li><strong>Subsequent Installments:</strong> {Installment Amount} + {Interest Amount}</li>
  <li><strong>Penalty for late installment payments:</strong> 3% penalty on the installment amount if payment is delayed</li>
</ul>`;
  const handleClick = () => {
    sweetalert2_all.fire({
      title: "Installments Breadkdown",
      html: installmentBreakdown,
      icon: null,
      backdrop: true,
      allowOutsideClick: false,
      customClass: {
        popup: "info-modal",
        title: "info-modal-title",
        content: "info-modal-content"
      }
    });
  };
  return isFullPayment ? /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "50%"
    }
  }, t("Installment Breakdown"), /*#__PURE__*/React__default.createElement("span", {
    className: "info-icon",
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, null))), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Amount")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "30%"
    }
  }, t("Due Date")))), installments.map(item => /*#__PURE__*/React__default.createElement("tbody", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("tr", {
    rowSpan: 2
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, item.installmentNumber === 1 ? "25% of total amount" : `Installment ${item.installmentNumber - 1}`)), /*#__PURE__*/React__default.createElement("td", null, `₹ ${item === null || item === void 0 ? void 0 : item.amount}`), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.dueDate))))) : /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Field Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "Value"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Total Amount"))), /*#__PURE__*/React__default.createElement("td", null, `₹ ${details === null || details === void 0 ? void 0 : details.amount}`))));
};

const defaultScrutinyRemarksContext = {
  remarksData: {},
  notingRemarksData: {},
  iconStates: null,
  rolesDate: null,
  paymentHeadRemarksData: {},
  documentRemarksData: {},
  siteInspectionRemarksData: {},
  siteDrawingRemarksData: {},
  pFarDetailsData: {},
  nocRemarksData: {},
  setSiteDrawingRemarksData: () => {},
  setpFarDetailsData: () => {},
  handleGetNotingById: () => {},
  handleGetNocById: () => {},
  handleGetDrawingById: () => {},
  handlepFarDetailById: () => {},
  handleGetSiteInspectionById: () => {},
  handleGetFiledsStatesById: () => {},
  handleGetDocumentById: () => {},
  handleGetPaymentHeadById: () => {},
  bussinessService: "",
  setBusinessService: () => {},
  handleGetRemarkssValues: () => {},
  handleGetHistoryRemarkssValues: () => {},
  chatBoardDataRemarks: {},
  chatBoardHistoryData: {},
  khasraDetailsData: {},
  handleGetKhasraById: () => {},
  handleRoles: () => {},
  handleGetNotingRemarkssValues: () => {}
};
const ScrutinyRemarksContext = createContext(defaultScrutinyRemarksContext);
const ScrutinyRemarksProvider = ({
  children
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const [chatBoardHistoryData, setChatBoardHistoryData] = useState({});
  const [chatBoardDataRemarks, setChatBoardDataRemarks] = useState({});
  const [remarksData, setRemarksData] = useState({});
  const [notingRemarksData, setNotingRemarksData] = useState({});
  const [nocRemarksData, setNocRemarksData] = useState({});
  const [paymentHeadRemarksData, setPaymentHeadRemarksData] = useState({});
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [khasraDetailsData, setKhasraDetailsData] = useState({});
  const [siteInspectionRemarksData, setSiteInspectionRemarksData] = useState({});
  const [siteDrawingRemarksData, setSiteDrawingRemarksData] = useState({});
  const [pFarDetailsData, setpFarDetailsData] = useState({});
  const [iconStates, setIconState] = useState(null);
  const [rolesDate, setRolesData] = useState(null);
  const [bussinessService, setBusinessService] = useState("");
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const handleGetRemarkssValues = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.land.chatBoard_data_search}=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog123", Resp);
      setChatBoardDataRemarks(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetHistoryRemarkssValues = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.land.chatBoard_data_search3}=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      setChatBoardHistoryData(Resp);
      console.log(Resp, "Ashwini123");
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetFiledsStatesById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.land.modal_data_search}=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetPaymentHeadById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksPaymentDetails}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setPaymentHeadRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetDocumentById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetKhasraById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.khasraDetails}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setKhasraDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetSiteInspectionById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksSiteInspection}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setSiteInspectionRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetDrawingById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksDrawing}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      setSiteDrawingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handlepFarDetailById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarkspFARDetail}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      setpFarDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetNotingById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksNoting}applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetNocById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls.bpaService.remarksNoc}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLogNoc", Resp);
      setNocRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  return /*#__PURE__*/React__default.createElement(ScrutinyRemarksContext.Provider, {
    value: {
      remarksData,
      notingRemarksData,
      iconStates,
      rolesDate,
      paymentHeadRemarksData,
      documentRemarksData,
      siteInspectionRemarksData,
      siteDrawingRemarksData,
      pFarDetailsData,
      nocRemarksData,
      setSiteDrawingRemarksData,
      setpFarDetailsData,
      handleGetNotingById,
      handleGetNocById,
      handleGetDrawingById,
      handlepFarDetailById,
      handleGetSiteInspectionById,
      handleGetFiledsStatesById,
      handleGetDocumentById,
      handleGetPaymentHeadById,
      bussinessService,
      setBusinessService,
      handleGetRemarkssValues,
      handleGetHistoryRemarkssValues,
      chatBoardDataRemarks,
      chatBoardHistoryData,
      khasraDetailsData,
      handleGetKhasraById
    }
  }, children);
};

const formatDateTime$1 = epochMs => {
  if (!epochMs) return "—";
  const date = new Date(epochMs);
  if (isNaN(date.getTime())) return "—";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};
const Notesheet = ({
  notingRemarksData,
  formData,
  caption,
  logoUrl,
  nameOfDepartment,
  khasraLatestMap: _khasraLatestMap = {},
  submissions: _submissions = []
}) => {
  var _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$landInfo2$o;
  console.log("formdataforPFAR", formData, notingRemarksData);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "notesheet"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("section", {
    class: "proposal-details"
  }, /*#__PURE__*/React__default.createElement("h3", null, "Proposal Details"), /*#__PURE__*/React__default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:"), formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Submitted On:"), caption === null || caption === void 0 ? void 0 : caption.date)), /*#__PURE__*/React__default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application Type:"), " ", formData === null || formData === void 0 ? void 0 : formData.applicationType), /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, " ", /*#__PURE__*/React__default.createElement("strong", null, "License No:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.licenseNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.consultantCategory) && /*#__PURE__*/React__default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, /*#__PURE__*/React__default.createElement("strong", null, formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.consultantCategory, ":"), " ", formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.name), /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, " ", /*#__PURE__*/React__default.createElement("strong", null, formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.consultantCategory, " Mobile:"), formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber)), /*#__PURE__*/React__default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, " ", /*#__PURE__*/React__default.createElement("strong", null, "Owners Name:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow[0].name), /*#__PURE__*/React__default.createElement("div", {
    class: "col-6"
  }, " ", /*#__PURE__*/React__default.createElement("strong", null, "Owners Mobile:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o[0].mobileNumber)), /*#__PURE__*/React__default.createElement("div", null)), /*#__PURE__*/React__default.createElement("section", {
    className: "remarks-table"
  }, _submissions && _submissions.length > 0 ? _submissions.map((sub, sIndex) => /*#__PURE__*/React__default.createElement("div", {
    key: sIndex,
    className: "submission-section",
    style: {
      marginBottom: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#1f4a7c",
      color: "#fff",
      padding: "8px 14px",
      fontWeight: "600",
      fontSize: "1.05rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      marginTop: sIndex > 0 ? "18px" : "0px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, sub.title), sub.shortfallDate && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "0.85rem",
      fontWeight: "500",
      background: "rgba(255, 255, 255, 0.2)",
      padding: "2px 8px",
      borderRadius: "4px"
    }
  }, "Shortfall Date: ", ConvertEpochToDate(sub.shortfallDate))), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr. No"), /*#__PURE__*/React__default.createElement("th", null, "Officers Name"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Officers Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Date"))), /*#__PURE__*/React__default.createElement("tbody", null, sub.items && sub.items.length > 0 ? sub.items.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.userName), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.userDesignation), /*#__PURE__*/React__default.createElement("td", null, item.docRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Document Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.docRemarks
  }))), item.landUseRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Land Use Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.landUseRemarks
  }))), item.drawingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Drawings Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.drawingRemarks
  }))), item.inspectionRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Inspection Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.inspectionRemarks
  }))), item.paymentRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Payment Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.paymentRemarks
  }))), item.notingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Noting Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.notingRemarks
  })))), /*#__PURE__*/React__default.createElement("td", null, item.date))) : /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "5",
    style: {
      textAlign: "center",
      color: "#666",
      padding: "14px",
      fontStyle: "italic"
    }
  }, "No remarks recorded for this submission yet.")))))) : /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr. No"), /*#__PURE__*/React__default.createElement("th", null, "Officers Name"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Officers Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Date"))), /*#__PURE__*/React__default.createElement("tbody", null, (() => {
    const officers = Array.isArray(notingRemarksData === null || notingRemarksData === void 0 ? void 0 : notingRemarksData.SecurityReport) ? notingRemarksData.SecurityReport : Array.isArray(notingRemarksData) ? notingRemarksData : [];
    const rows = [];
    officers.forEach(officer => {
      var _officer$auditDetails, _officer$auditDetails2;
      const officerName = (officer === null || officer === void 0 ? void 0 : officer.userName) || "—";
      const officerDesignation = (officer === null || officer === void 0 ? void 0 : officer.userDesignation) || "—";
      const officerTs = Math.max((officer === null || officer === void 0 ? void 0 : (_officer$auditDetails = officer.auditDetails) === null || _officer$auditDetails === void 0 ? void 0 : _officer$auditDetails.lastModifiedTime) || 0, (officer === null || officer === void 0 ? void 0 : (_officer$auditDetails2 = officer.auditDetails) === null || _officer$auditDetails2 === void 0 ? void 0 : _officer$auditDetails2.createdTime) || 0);
      const remarksList = Array.isArray(officer === null || officer === void 0 ? void 0 : officer.detailDataRemarks) ? officer.detailDataRemarks : [];
      if (remarksList.length === 0) {
        rows.push({
          userName: officerName,
          userDesignation: officerDesignation,
          timestamp: officerTs,
          date: formatDateTime$1(officerTs)
        });
      } else {
        remarksList.forEach((r, idx) => {
          var _r$auditDetails, _r$auditDetails2, _r$documentDetails, _r$drawingsDetails, _r$inspectionDetails, _r$inspectionDetails$, _r$inspectionDetails2, _r$paymentDetails, _r$notingDetails;
          const rTs = (r === null || r === void 0 ? void 0 : (_r$auditDetails = r.auditDetails) === null || _r$auditDetails === void 0 ? void 0 : _r$auditDetails.lastModifiedTime) || (r === null || r === void 0 ? void 0 : (_r$auditDetails2 = r.auditDetails) === null || _r$auditDetails2 === void 0 ? void 0 : _r$auditDetails2.createdTime) || officerTs;
          const doc = r === null || r === void 0 ? void 0 : (_r$documentDetails = r.documentDetails) === null || _r$documentDetails === void 0 ? void 0 : _r$documentDetails.developerRemarks;
          const draw = r === null || r === void 0 ? void 0 : (_r$drawingsDetails = r.drawingsDetails) === null || _r$drawingsDetails === void 0 ? void 0 : _r$drawingsDetails.developerRemarks;
          const insp = (r === null || r === void 0 ? void 0 : (_r$inspectionDetails = r.inspectionDetails) === null || _r$inspectionDetails === void 0 ? void 0 : (_r$inspectionDetails$ = _r$inspectionDetails.inspectionReportData) === null || _r$inspectionDetails$ === void 0 ? void 0 : _r$inspectionDetails$.developerRemarks) || (r === null || r === void 0 ? void 0 : (_r$inspectionDetails2 = r.inspectionDetails) === null || _r$inspectionDetails2 === void 0 ? void 0 : _r$inspectionDetails2.developerRemarks);
          const pay = r === null || r === void 0 ? void 0 : (_r$paymentDetails = r.paymentDetails) === null || _r$paymentDetails === void 0 ? void 0 : _r$paymentDetails.developerRemarks;
          const land = (r === null || r === void 0 ? void 0 : r.khasraRemarks) || _khasraLatestMap[officer === null || officer === void 0 ? void 0 : officer.userId];
          const note = r === null || r === void 0 ? void 0 : (_r$notingDetails = r.notingDetails) === null || _r$notingDetails === void 0 ? void 0 : _r$notingDetails.developerRemarks;
          const isLatest = idx === remarksList.length - 1;
          const hasLaterNoting = isLatest && note && officerTs > rTs + 60000;
          if (hasLaterNoting) {
            if (doc || draw || insp || pay || land) {
              rows.push({
                userName: officerName,
                userDesignation: officerDesignation,
                docRemarks: doc || null,
                drawingRemarks: draw || null,
                inspectionRemarks: insp || null,
                paymentRemarks: pay || null,
                notingRemarks: null,
                landUseRemarks: land || null,
                timestamp: rTs,
                date: formatDateTime$1(rTs)
              });
            }
            if (note) {
              rows.push({
                userName: officerName,
                userDesignation: officerDesignation,
                docRemarks: null,
                drawingRemarks: null,
                inspectionRemarks: null,
                paymentRemarks: null,
                notingRemarks: note,
                landUseRemarks: null,
                timestamp: officerTs,
                date: formatDateTime$1(officerTs)
              });
            }
          } else {
            const effectiveTs = isLatest && officerTs > rTs ? officerTs : rTs || officerTs;
            rows.push({
              userName: officerName,
              userDesignation: officerDesignation,
              docRemarks: doc || null,
              drawingRemarks: draw || null,
              inspectionRemarks: insp || null,
              paymentRemarks: pay || null,
              notingRemarks: note || null,
              landUseRemarks: land || null,
              timestamp: effectiveTs,
              date: formatDateTime$1(effectiveTs)
            });
          }
        });
      }
    });
    return rows.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0)).map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.userName), /*#__PURE__*/React__default.createElement("td", null, item.userDesignation), /*#__PURE__*/React__default.createElement("td", null, item.docRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Document Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.docRemarks
    }))), item.landUseRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Land Use Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.landUseRemarks
    }))), item.drawingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Drawings Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.drawingRemarks
    }))), item.inspectionRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Inspection Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.inspectionRemarks
    }))), item.paymentRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Payment Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.paymentRemarks
    }))), item.notingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Noting Remarks :"), /*#__PURE__*/React__default.createElement("p", {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item.notingRemarks
    })))), /*#__PURE__*/React__default.createElement("td", null, item.date)));
  })()))));
};

const DocUploader = ({
  uploadedFile,
  setUploadedFile,
  isNextLine: _isNextLine = false
}) => {
  const {
    t
  } = useTranslation();
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isViewing, setIsViewing] = useState(false);
  const selectFile = e => {
    var _e$target$files;
    const selectedFile = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    if (!selectedFile) return;
    setError(null);
    setFileUrl(null);
    setUploadedFile(null);
    localStorage.removeItem("wf_verification_doc");
    setFile(selectedFile);
  };
  useEffect(() => {
    if (!file) return;
    const uploadFile = async () => {
      setError(null);
      setIsUploading(true);
      try {
        var _response$data, _response$data$files;
        const allowedFileTypesRegex = /(jpg|jpeg|png|pdf)$/i;
        if (file.size > 20 * 1024 * 1024) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
          return;
        }
        if (file.type && !allowedFileTypesRegex.test(file.type)) {
          setError(t("NOT_SUPPORTED_FILE_TYPE"));
          return;
        }
        const tenantId = "up";
        const stateId = Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]);
        console.log("[UPLOAD] tenantId:", tenantId);
        console.log("[UPLOAD] stateId:", stateId);
        console.log("[UPLOAD] file:", file.name, file.size, file.type);
        const response = await Digit.UploadServices.Filestorage("OBPS", file, stateId);
        console.log("[UPLOAD] complete response:", response);
        const uploadedData = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files[0];
        if (!uploadedData) {
          throw new Error("File upload response is empty");
        }
        const fileStoreId = uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.fileStoreId;
        const uploadedUrl = (uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.url) || (uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.fileUrl) || (uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.uri);
        if (!fileStoreId) {
          throw new Error("fileStoreId not received from upload API");
        }
        console.log("[UPLOAD] CURRENT fileStoreId:", fileStoreId);
        console.log("[UPLOAD] CURRENT file URL:", uploadedUrl);
        setUploadedFile(fileStoreId);
        localStorage.setItem("wf_verification_doc", fileStoreId);
        if (uploadedUrl) {
          setFileUrl(uploadedUrl);
        }
        setError(null);
      } catch (err) {
        console.error("[UPLOAD] Upload failed:", err);
        setUploadedFile(null);
        setFileUrl(null);
        setError(t("CS_FILE_UPLOAD_ERROR"));
      } finally {
        setIsUploading(false);
      }
    };
    uploadFile();
  }, [file]);
  const handleView = async () => {
    if (!uploadedFile) {
      console.error("[VIEW] No fileStoreId found");
      return;
    }
    try {
      var _response$data2, _response$data2$fileS, _response$data2$fileS2, _response$data3, _response$data3$fileS, _response$data3$fileS2;
      const tenantId = "up";
      console.log("[VIEW] fileStoreId:", uploadedFile);
      console.log("[VIEW] tenantId:", tenantId);
      const response = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${uploadedFile}`);
      console.log("[VIEW] response:", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$fileS = _response$data2.fileStoreIds) === null || _response$data2$fileS === void 0 ? void 0 : (_response$data2$fileS2 = _response$data2$fileS[0]) === null || _response$data2$fileS2 === void 0 ? void 0 : _response$data2$fileS2.url);
      const fileUrl = response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$fileS = _response$data3.fileStoreIds) === null || _response$data3$fileS === void 0 ? void 0 : (_response$data3$fileS2 = _response$data3$fileS[0]) === null || _response$data3$fileS2 === void 0 ? void 0 : _response$data3$fileS2.url;
      if (fileUrl) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        console.error("[VIEW] File URL not found");
      }
    } catch (error) {
      console.error("[ERROR] Unable to view file:", error);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: _isNextLine ? "1fr" : "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: _isNextLine ? "span 1" : "span 2",
    sx: {
      fontWeight: "bold",
      marginTop: "5px",
      marginLeft: "5px",
      whiteSpace: "nowrap",
      fontSize: "14px"
    }
  }, "Document/Certificate"), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: _isNextLine ? "span 1" : "span 10",
    sx: {
      marginLeft: _isNextLine ? "5px" : "20px",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "workflow-doc",
    onUpload: selectFile,
    onDelete: () => {
      localStorage.removeItem("wf_verification_doc");
      setUploadedFile(null);
      setFile(null);
    },
    message: uploadedFile ? `1 ${t("ES_PT_ACTION_FILEUPLOADED")}` : t("CS_ACTION_NO_FILEUPLOADED"),
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    iserror: error
  }), uploadedFile && /*#__PURE__*/React__default.createElement(Tooltip, {
    title: "View Document"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleView,
    color: "primary",
    size: "small"
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, null))))), error && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: "red",
      fontSize: "13px",
      marginLeft: "20px",
      marginTop: "5px"
    }
  }, error));
};

const formatDateTime$2 = epochMs => {
  if (!epochMs) return "—";
  const date = new Date(epochMs);
  if (isNaN(date.getTime())) return "—";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};
const HistoryList = ({
  formData,
  callNotingDetailsAPI,
  developerRemarks,
  setDeveloperRemarks,
  notingRemarksData,
  logoData,
  workflowDetails: workflowDetailsProp,
  uploadedFile,
  setUploadedFile
}) => {
  var _Digit, _Digit$ULBService, _Digit2, _Digit2$ULBService, _window, _window$Digit, _window$Digit$Hooks, _formData$location, _formData$locationDis, _logoData$boundary, _logoData$boundary$fi, _formData$auditDetail, _Digit$UserService$ge, _Digit$UserService$ge2, _userRolesArray$2, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$landInfo2$o;
  const context = useContext(ScrutinyRemarksContext);
  const windowHeight = window !== undefined ? window.innerHeight : null;
  const applicationStatus = formData === null || formData === void 0 ? void 0 : formData.status;
  const [remarkDataResp, setRemarkDataResp] = useState();
  const [, setIsPreviewLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [smShowMsNoting, setSmShowMsNoting] = useState(false);
  const [disapprovedList, setDisapprovedList] = useState([]);
  const [loader, setLoader] = useState(false);
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLandUse = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE";
  const [khasraLatestMap, setKhasraLatestMap] = useState({});
  const [khasraEntries, setKhasraEntries] = useState([]);
  const [documentEntries, setDocumentEntries] = useState([]);
  const [drawingEntries, setDrawingEntries] = useState([]);
  const [inspectionEntries, setInspectionEntries] = useState([]);
  const [paymentEntries, setPaymentEntries] = useState([]);
  const [notingDetailEntries, setNotingDetailEntries] = useState([]);
  const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || (formData !== null && formData !== void 0 && formData.locationDistrict ? `up.${formData.locationDistrict.toLowerCase()}` : null) || (formData !== null && formData !== void 0 && formData.location1 ? `up.${formData.location1.toLowerCase()}` : null) || ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ULBService = _Digit.ULBService) === null || _Digit$ULBService === void 0 ? void 0 : _Digit$ULBService.getCurrentTenantId()) || ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ULBService = _Digit2.ULBService) === null || _Digit2$ULBService === void 0 ? void 0 : _Digit2$ULBService.getStateId()) || "up";
  const {
    data: hookWorkflowDetails
  } = (_window = window) !== null && _window !== void 0 && (_window$Digit = _window.Digit) !== null && _window$Digit !== void 0 && (_window$Digit$Hooks = _window$Digit.Hooks) !== null && _window$Digit$Hooks !== void 0 && _window$Digit$Hooks.useWorkflowDetails ? window.Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    moduleCode: (formData === null || formData === void 0 ? void 0 : formData.businessService) || "BPA",
    config: {
      enabled: !workflowDetailsProp && !!(formData !== null && formData !== void 0 && formData.applicationNo) && !!tenantId
    }
  }) : {
    data: null
  };
  const [fetchedTimeline, setFetchedTimeline] = useState([]);
  useEffect(() => {
    var _workflowDetailsProp$;
    if (workflowDetailsProp !== null && workflowDetailsProp !== void 0 && (_workflowDetailsProp$ = workflowDetailsProp.data) !== null && _workflowDetailsProp$ !== void 0 && _workflowDetailsProp$.timeline || workflowDetailsProp !== null && workflowDetailsProp !== void 0 && workflowDetailsProp.timeline) {
      return;
    }
    const fetchWorkflowTimeline = async () => {
      if (!(formData !== null && formData !== void 0 && formData.applicationNo)) return;
      try {
        var _Digit3, _Digit3$WorkflowServi, _Digit4, _Digit4$WorkflowServi;
        let timelineData = null;
        if ((_Digit3 = Digit) !== null && _Digit3 !== void 0 && (_Digit3$WorkflowServi = _Digit3.WorkflowService) !== null && _Digit3$WorkflowServi !== void 0 && _Digit3$WorkflowServi.getDetailsById) {
          try {
            const res = await Digit.WorkflowService.getDetailsById({
              tenantId,
              id: formData.applicationNo,
              moduleCode: (formData === null || formData === void 0 ? void 0 : formData.businessService) || "BPA",
              role: "EMPLOYEE"
            });
            timelineData = (res === null || res === void 0 ? void 0 : res.timeline) || null;
          } catch (e1) {
            console.warn("getDetailsById failed", e1);
          }
        }
        if (!timelineData && (_Digit4 = Digit) !== null && _Digit4 !== void 0 && (_Digit4$WorkflowServi = _Digit4.WorkflowService) !== null && _Digit4$WorkflowServi !== void 0 && _Digit4$WorkflowServi.getByBusinessId) {
          try {
            const res = await Digit.WorkflowService.getByBusinessId(tenantId, formData.applicationNo);
            timelineData = (res === null || res === void 0 ? void 0 : res.ProcessInstances) || [];
          } catch (e2) {
            console.warn("WorkflowService with tenantId failed", e2);
          }
        }
        if (!timelineData || timelineData.length === 0) {
          var _Digit5, _Digit5$ULBService, _Digit6, _Digit6$WorkflowServi;
          const stateId = ((_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : (_Digit5$ULBService = _Digit5.ULBService) === null || _Digit5$ULBService === void 0 ? void 0 : _Digit5$ULBService.getStateId()) || "up";
          if (stateId && stateId !== tenantId && (_Digit6 = Digit) !== null && _Digit6 !== void 0 && (_Digit6$WorkflowServi = _Digit6.WorkflowService) !== null && _Digit6$WorkflowServi !== void 0 && _Digit6$WorkflowServi.getByBusinessId) {
            try {
              const res = await Digit.WorkflowService.getByBusinessId(stateId, formData.applicationNo);
              timelineData = (res === null || res === void 0 ? void 0 : res.ProcessInstances) || [];
            } catch (e3) {}
          }
        }
        if (!timelineData || timelineData.length === 0) {
          var _Digit7, _Digit7$UserService, _Digit7$UserService$g, _resp$data;
          const authToken = ((_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : (_Digit7$UserService = _Digit7.UserService) === null || _Digit7$UserService === void 0 ? void 0 : (_Digit7$UserService$g = _Digit7$UserService.getUser()) === null || _Digit7$UserService$g === void 0 ? void 0 : _Digit7$UserService$g.access_token) || null;
          const postData = {
            RequestInfo: {
              apiId: "Rainmaker",
              authToken: authToken,
              msgId: "20170310130900|en_IN"
            }
          };
          const resp = await axios$1.post(`${Urls$1.WorkFlowProcessSearch}?businessIds=${formData.applicationNo}&history=true&tenantId=${tenantId}`, postData);
          timelineData = (resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.ProcessInstances) || [];
        }
        if (timelineData && Array.isArray(timelineData) && timelineData.length > 0) {
          setFetchedTimeline(timelineData);
        }
      } catch (err) {
        console.error("Error fetching workflow timeline for HistoryList", err);
      }
    };
    fetchWorkflowTimeline();
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo, tenantId, formData === null || formData === void 0 ? void 0 : formData.businessService, workflowDetailsProp]);
  const rawTimeline = useMemo(() => {
    var _workflowDetailsProp$2, _hookWorkflowDetails$;
    const propTimeline = (workflowDetailsProp === null || workflowDetailsProp === void 0 ? void 0 : (_workflowDetailsProp$2 = workflowDetailsProp.data) === null || _workflowDetailsProp$2 === void 0 ? void 0 : _workflowDetailsProp$2.timeline) || (workflowDetailsProp === null || workflowDetailsProp === void 0 ? void 0 : workflowDetailsProp.timeline);
    if (propTimeline && Array.isArray(propTimeline) && propTimeline.length > 0) {
      return propTimeline;
    }
    const hookTimeline = (hookWorkflowDetails === null || hookWorkflowDetails === void 0 ? void 0 : (_hookWorkflowDetails$ = hookWorkflowDetails.data) === null || _hookWorkflowDetails$ === void 0 ? void 0 : _hookWorkflowDetails$.timeline) || (hookWorkflowDetails === null || hookWorkflowDetails === void 0 ? void 0 : hookWorkflowDetails.timeline);
    if (hookTimeline && Array.isArray(hookTimeline) && hookTimeline.length > 0) {
      return hookTimeline;
    }
    return fetchedTimeline || [];
  }, [workflowDetailsProp, hookWorkflowDetails, fetchedTimeline]);
  const filteredTimeline = useMemo(() => {
    if (!rawTimeline || !rawTimeline.length) return [];
    const fullyExcluded = ["MAKE_PAYMENT", "MAKE_PAYMENT_APPLICATION_FEE"];
    const seenStates = new Set();
    return rawTimeline.filter(item => {
      var _item$state, _item$assigner, _item$assigner2;
      const state = typeof (item === null || item === void 0 ? void 0 : item.state) === "object" ? item === null || item === void 0 ? void 0 : (_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.state : (item === null || item === void 0 ? void 0 : item.state) || "";
      if (fullyExcluded.includes(state)) return false;
      if (state === "UPLOAD_DOC") {
        if (seenStates.has("UPLOAD_DOC")) return false;
        seenStates.add("UPLOAD_DOC");
        return true;
      }
      if (state === "REVERT_TO_APPLICANT" && (item === null || item === void 0 ? void 0 : (_item$assigner = item.assigner) === null || _item$assigner === void 0 ? void 0 : _item$assigner.type) === "CITIZEN") {
        var _item$wfComment;
        return (item === null || item === void 0 ? void 0 : (_item$wfComment = item.wfComment) === null || _item$wfComment === void 0 ? void 0 : _item$wfComment.length) > 1 || (item === null || item === void 0 ? void 0 : item.wfDocuments);
      }
      if (state === "REVERT_TO_APPLICANT" && (item === null || item === void 0 ? void 0 : (_item$assigner2 = item.assigner) === null || _item$assigner2 === void 0 ? void 0 : _item$assigner2.type) !== "CITIZEN") {
        return true;
      }
      return state !== "REVERT_TO_APPLICANT";
    });
  }, [rawTimeline]);
  const getItemEpoch = item => {
    var _item$auditDetails, _item$auditDetails2, _item$auditDetails3;
    return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.lastModifieds) || (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.lastModifiedTime) || (item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime) || (item === null || item === void 0 ? void 0 : item.createdTime) || (item === null || item === void 0 ? void 0 : item.lastModifiedTime) || 0;
  };
  const sortedTimeline = useMemo(() => {
    return [...filteredTimeline].sort((a, b) => getItemEpoch(a) - getItemEpoch(b));
  }, [filteredTimeline]);
  const breakActions = ["SHORTFALL", "REJECT", "CANCEL", "REVERT_TO_APPLICANT"];
  const timelineGroups = useMemo(() => {
    const groups = [];
    let currentGroup = [];
    for (const item of sortedTimeline) {
      var _item$state2;
      currentGroup.push(item);
      const action = (item === null || item === void 0 ? void 0 : item.action) || "";
      const state = typeof (item === null || item === void 0 ? void 0 : item.state) === "object" ? item === null || item === void 0 ? void 0 : (_item$state2 = item.state) === null || _item$state2 === void 0 ? void 0 : _item$state2.state : (item === null || item === void 0 ? void 0 : item.state) || "";
      if (breakActions.includes(action) || breakActions.includes(state)) {
        groups.push([...currentGroup]);
        currentGroup = [];
      }
    }
    if (currentGroup.length) groups.push(currentGroup);
    return groups;
  }, [sortedTimeline]);
  const submissionIntervals = useMemo(() => {
    if (!timelineGroups.length) {
      return [{
        title: "Submission 1",
        startTime: null,
        endTime: null,
        shortfallDate: null
      }];
    }
    const intervals = [];
    for (let i = 0; i < timelineGroups.length; i++) {
      var _lastItem$state;
      const group = timelineGroups[i];
      const lastItem = group[group.length - 1];
      const action = (lastItem === null || lastItem === void 0 ? void 0 : lastItem.action) || "";
      const state = typeof (lastItem === null || lastItem === void 0 ? void 0 : lastItem.state) === "object" ? lastItem === null || lastItem === void 0 ? void 0 : (_lastItem$state = lastItem.state) === null || _lastItem$state === void 0 ? void 0 : _lastItem$state.state : (lastItem === null || lastItem === void 0 ? void 0 : lastItem.state) || "";
      const endsWithBreak = breakActions.includes(action) || breakActions.includes(state);
      const breakEpoch = endsWithBreak ? getItemEpoch(lastItem) : null;
      const prevGroup = i > 0 ? timelineGroups[i - 1] : null;
      const prevLastItem = prevGroup ? prevGroup[prevGroup.length - 1] : null;
      const prevBreakEpoch = prevLastItem ? getItemEpoch(prevLastItem) : null;
      const groupFirstItem = group[0];
      const groupFirstEpoch = groupFirstItem ? getItemEpoch(groupFirstItem) : null;
      let startTime = null;
      if (prevBreakEpoch) {
        if (groupFirstEpoch && groupFirstEpoch > prevBreakEpoch) {
          startTime = Math.floor((prevBreakEpoch + groupFirstEpoch) / 2);
        } else {
          startTime = prevBreakEpoch + 300000;
        }
      }
      let endTime = null;
      const isLastGroup = i === timelineGroups.length - 1;
      if (!isLastGroup) {
        const nextGroup = timelineGroups[i + 1];
        const nextFirstItem = nextGroup ? nextGroup[0] : null;
        const nextFirstEpoch = nextFirstItem ? getItemEpoch(nextFirstItem) : null;
        if (breakEpoch && nextFirstEpoch && nextFirstEpoch > breakEpoch) {
          endTime = Math.floor((breakEpoch + nextFirstEpoch) / 2);
        } else if (breakEpoch) {
          endTime = breakEpoch + 300000;
        }
      }
      intervals.push({
        title: `Submission ${i + 1}`,
        startTime,
        endTime,
        shortfallDate: breakEpoch
      });
    }
    return intervals;
  }, [timelineGroups]);
  const authority = isLandUse ? formData === null || formData === void 0 ? void 0 : (_formData$location = formData.location1) === null || _formData$location === void 0 ? void 0 : _formData$location.toUpperCase() : formData === null || formData === void 0 ? void 0 : (_formData$locationDis = formData.locationDistrict) === null || _formData$locationDis === void 0 ? void 0 : _formData$locationDis.toUpperCase();
  const [hasFetchedFields, setHasFetchedFields] = useState(false);
  const boundaryKey = isLandUse ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.locationDistrict;
  const currentLogoId = isDA ? logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === boundaryKey)) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId : logoData === null || logoData === void 0 ? void 0 : logoData.fileStoreId;
  const caption = {
    date: Digit.DateUtils.ConvertTimestampToDate(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime),
    source: (formData === null || formData === void 0 ? void 0 : formData.channel) || ""
  };
  console.log("remarkDataResp", remarkDataResp);
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const Modal = useModal();
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const designation = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.name;
  const nameOfDepartment = isDA ? `${authority} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  const conponentPDF = useRef();
  useEffect(() => {
    if (remarkDataResp && remarkDataResp.length) {
      const disapprovedRemarks = remarkDataResp.filter(ele => {
        var _ele$performaFieldDet, _ele$performaFieldDet2;
        return (ele === null || ele === void 0 ? void 0 : (_ele$performaFieldDet = ele.performaFieldDetail) === null || _ele$performaFieldDet === void 0 ? void 0 : (_ele$performaFieldDet2 = _ele$performaFieldDet[0]) === null || _ele$performaFieldDet2 === void 0 ? void 0 : _ele$performaFieldDet2.isApproved) === "disapproved";
      });
      setDisapprovedList(disapprovedRemarks);
    }
  }, [remarkDataResp]);
  useEffect(() => {
    var _notingRemarksData$Se;
    if (designation && notingRemarksData && notingRemarksData !== null && notingRemarksData !== void 0 && notingRemarksData.SecurityReport && (notingRemarksData === null || notingRemarksData === void 0 ? void 0 : (_notingRemarksData$Se = notingRemarksData.SecurityReport) === null || _notingRemarksData$Se === void 0 ? void 0 : _notingRemarksData$Se.length) > 0) {
      var _notingRemarksData$Se2;
      let item = notingRemarksData === null || notingRemarksData === void 0 ? void 0 : (_notingRemarksData$Se2 = notingRemarksData.SecurityReport) === null || _notingRemarksData$Se2 === void 0 ? void 0 : _notingRemarksData$Se2.find(item => (item === null || item === void 0 ? void 0 : item.userDesignation) === designation);
      if (item) {
        var _Digit8;
        (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.set("isNotingValidated", true);
      }
    }
  }, [designation, notingRemarksData]);
  const [content, setContent] = useState("");
  const [error, setError] = useState(false);
  const [post, setPost] = useState({
    content: "",
    hearingDate: ""
  });
  useEffect(() => {
    fetchLogoUrl();
  }, [currentLogoId, logoData, formData]);
  useEffect(() => {
    const fetchAllRemarks = async () => {
      if (!(formData !== null && formData !== void 0 && formData.applicationNo)) return;
      try {
        var _Digit$UserService$ge3;
        const authToken = ((_Digit$UserService$ge3 = Digit.UserService.getUser()) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.access_token) || null;
        const postData = {
          RequestInfo: {
            apiId: "Rainmaker",
            action: "_create",
            did: 1,
            key: "",
            msgId: "20170310130900|en_IN",
            ts: 0,
            ver: ".01",
            authToken: authToken
          }
        };
        const appNo = formData.applicationNo;
        const results = await Promise.allSettled([axios$1.post(`${Urls$1.bpaService.remarksDocument}&applicationNo=${appNo}`, postData), axios$1.post(`${Urls$1.bpaService.remarksDrawing}&applicationNo=${appNo}`, postData), axios$1.post(`${Urls$1.bpaService.remarksSiteInspection}&applicationNo=${appNo}`, postData), axios$1.post(`${Urls$1.bpaService.remarksPaymentDetails}&applicationNo=${appNo}`, postData), axios$1.post(`${Urls$1.bpaService.khasraDetails}&applicationNo=${appNo}`, postData), axios$1.post(`/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=notingDetails&applicationNo=${appNo}`, postData)]);
        const extract = res => {
          var _res$value;
          if (res.status !== "fulfilled" || !((_res$value = res.value) !== null && _res$value !== void 0 && _res$value.data)) return [];
          const d = res.value.data;
          if (Array.isArray(d)) return d;
          if (Array.isArray(d === null || d === void 0 ? void 0 : d.DetailDataRemarks)) return d.DetailDataRemarks;
          return [];
        };
        const docList = extract(results[0]);
        const drawList = extract(results[1]);
        const inspList = extract(results[2]);
        const payList = extract(results[3]);
        const khasraList = extract(results[4]);
        const noteList = extract(results[5]);
        setDocumentEntries(docList);
        setDrawingEntries(drawList);
        setInspectionEntries(inspList);
        setPaymentEntries(payList);
        setKhasraEntries(khasraList);
        setNotingDetailEntries(noteList);
        const kMap = {};
        khasraList.forEach(entry => {
          var _entry$userDetails, _entry$userDetails2, _entry$auditDetails, _entry$auditDetails2;
          const uid = (entry === null || entry === void 0 ? void 0 : (_entry$userDetails = entry.userDetails) === null || _entry$userDetails === void 0 ? void 0 : _entry$userDetails.userID) || (entry === null || entry === void 0 ? void 0 : (_entry$userDetails2 = entry.userDetails) === null || _entry$userDetails2 === void 0 ? void 0 : _entry$userDetails2.id);
          const rem = (entry === null || entry === void 0 ? void 0 : entry.khasraRemarks) || (entry === null || entry === void 0 ? void 0 : entry.landUseRemarks);
          if (!uid || !rem) return;
          const ts = (entry === null || entry === void 0 ? void 0 : (_entry$auditDetails = entry.auditDetails) === null || _entry$auditDetails === void 0 ? void 0 : _entry$auditDetails.lastModifiedTime) || (entry === null || entry === void 0 ? void 0 : (_entry$auditDetails2 = entry.auditDetails) === null || _entry$auditDetails2 === void 0 ? void 0 : _entry$auditDetails2.createdTime) || 0;
          if (!kMap[uid] || ts > kMap[uid].ts) {
            kMap[uid] = {
              remark: rem,
              ts
            };
          }
        });
        const flatMap = {};
        Object.keys(kMap).forEach(uid => {
          flatMap[uid] = kMap[uid].remark;
        });
        setKhasraLatestMap(flatMap);
      } catch (err) {
        console.error("Error fetching remarks details in parallel", err);
      }
    };
    fetchAllRemarks();
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo, notingRemarksData]);
  const allDocEntries = useMemo(() => {
    var _context$documentRema;
    if (documentEntries && documentEntries.length > 0) return documentEntries;
    if (Array.isArray(context === null || context === void 0 ? void 0 : context.documentRemarksData)) return context.documentRemarksData;
    if (Array.isArray(context === null || context === void 0 ? void 0 : (_context$documentRema = context.documentRemarksData) === null || _context$documentRema === void 0 ? void 0 : _context$documentRema.DetailDataRemarks)) return context.documentRemarksData.DetailDataRemarks;
    return [];
  }, [documentEntries, context === null || context === void 0 ? void 0 : context.documentRemarksData]);
  const allDrawingEntries = useMemo(() => {
    var _context$siteDrawingR;
    if (drawingEntries && drawingEntries.length > 0) return drawingEntries;
    if (Array.isArray(context === null || context === void 0 ? void 0 : context.siteDrawingRemarksData)) return context.siteDrawingRemarksData;
    if (Array.isArray(context === null || context === void 0 ? void 0 : (_context$siteDrawingR = context.siteDrawingRemarksData) === null || _context$siteDrawingR === void 0 ? void 0 : _context$siteDrawingR.DetailDataRemarks)) return context.siteDrawingRemarksData.DetailDataRemarks;
    return [];
  }, [drawingEntries, context === null || context === void 0 ? void 0 : context.siteDrawingRemarksData]);
  const allInspectionEntries = useMemo(() => {
    var _context$siteInspecti;
    if (inspectionEntries && inspectionEntries.length > 0) return inspectionEntries;
    if (Array.isArray(context === null || context === void 0 ? void 0 : context.siteInspectionRemarksData)) return context.siteInspectionRemarksData;
    if (Array.isArray(context === null || context === void 0 ? void 0 : (_context$siteInspecti = context.siteInspectionRemarksData) === null || _context$siteInspecti === void 0 ? void 0 : _context$siteInspecti.DetailDataRemarks)) return context.siteInspectionRemarksData.DetailDataRemarks;
    return [];
  }, [inspectionEntries, context === null || context === void 0 ? void 0 : context.siteInspectionRemarksData]);
  const allPaymentEntries = useMemo(() => {
    var _context$paymentHeadR;
    if (paymentEntries && paymentEntries.length > 0) return paymentEntries;
    if (Array.isArray(context === null || context === void 0 ? void 0 : context.paymentHeadRemarksData)) return context.paymentHeadRemarksData;
    if (Array.isArray(context === null || context === void 0 ? void 0 : (_context$paymentHeadR = context.paymentHeadRemarksData) === null || _context$paymentHeadR === void 0 ? void 0 : _context$paymentHeadR.DetailDataRemarks)) return context.paymentHeadRemarksData.DetailDataRemarks;
    return [];
  }, [paymentEntries, context === null || context === void 0 ? void 0 : context.paymentHeadRemarksData]);
  const allKhasraEntries = useMemo(() => {
    var _context$khasraDetail;
    if (khasraEntries && khasraEntries.length > 0) return khasraEntries;
    if (Array.isArray(context === null || context === void 0 ? void 0 : context.khasraDetailsData)) return context.khasraDetailsData;
    if (Array.isArray(context === null || context === void 0 ? void 0 : (_context$khasraDetail = context.khasraDetailsData) === null || _context$khasraDetail === void 0 ? void 0 : _context$khasraDetail.DetailDataRemarks)) return context.khasraDetailsData.DetailDataRemarks;
    return [];
  }, [khasraEntries, context === null || context === void 0 ? void 0 : context.khasraDetailsData]);
  const allNotingEntries = useMemo(() => {
    if (notingDetailEntries && notingDetailEntries.length > 0) return notingDetailEntries;
    return [];
  }, [notingDetailEntries]);
  useEffect(() => {
    var _developerRemarks$tri;
    if ((developerRemarks === null || developerRemarks === void 0 ? void 0 : (_developerRemarks$tri = developerRemarks.trim()) === null || _developerRemarks$tri === void 0 ? void 0 : _developerRemarks$tri.length) > 0) {
      setError(false);
    }
  }, [developerRemarks]);
  const handlemodalsubmit = async () => {
    if (developerRemarks.trim() === "") {
      setError(true);
      return;
    } else {
      var _Digit9, _developerRemarks$tri2;
      setLoader(true);
      (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.set("isNotingValidated", ((_developerRemarks$tri2 = developerRemarks.trim()) === null || _developerRemarks$tri2 === void 0 ? void 0 : _developerRemarks$tri2.length) > 0);
      callNotingDetailsAPI();
    }
  };
  const closeModalHistory = item => {
    if ((item === null || item === void 0 ? void 0 : item.applicationNo) != null) {
      setSmShowMsNoting(true);
    } else {
      console.log("Application Number Null CLU");
    }
  };
  const submissions = useMemo(() => {
    const getSubmissionOfficerItems = interval => {
      const getOfficerKey = entry => {
        const user = (entry === null || entry === void 0 ? void 0 : entry.userDetails) || {};
        return String((user === null || user === void 0 ? void 0 : user.userID) || (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.userName) || (entry === null || entry === void 0 ? void 0 : entry.userId) || "unknown");
      };
      const getOfficerName = entry => {
        const user = (entry === null || entry === void 0 ? void 0 : entry.userDetails) || {};
        return (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.userName) || (entry === null || entry === void 0 ? void 0 : entry.userName) || "—";
      };
      const getOfficerDesignation = entry => {
        const user = (entry === null || entry === void 0 ? void 0 : entry.userDetails) || {};
        return (user === null || user === void 0 ? void 0 : user.designation) || (user === null || user === void 0 ? void 0 : user.role) || (entry === null || entry === void 0 ? void 0 : entry.userDesignation) || "—";
      };
      const getEntryTs = entry => {
        var _entry$auditDetails3, _entry$auditDetails4, _entry$userDetails3;
        return (entry === null || entry === void 0 ? void 0 : (_entry$auditDetails3 = entry.auditDetails) === null || _entry$auditDetails3 === void 0 ? void 0 : _entry$auditDetails3.createdTime) || (entry === null || entry === void 0 ? void 0 : (_entry$auditDetails4 = entry.auditDetails) === null || _entry$auditDetails4 === void 0 ? void 0 : _entry$auditDetails4.lastModifiedTime) || (entry === null || entry === void 0 ? void 0 : entry.createdTime) || (entry === null || entry === void 0 ? void 0 : entry.lastModifiedTime) || (entry === null || entry === void 0 ? void 0 : (_entry$userDetails3 = entry.userDetails) === null || _entry$userDetails3 === void 0 ? void 0 : _entry$userDetails3.timeStamp) || 0;
      };
      const isTsInWindow = ts => {
        if (!ts) return false;
        if (interval.startTime && ts < interval.startTime) return false;
        if (interval.endTime && ts > interval.endTime) return false;
        return true;
      };
      const rawItems = [];
      allDocEntries.forEach(entry => {
        var _entry$documentDetail;
        const ts = getEntryTs(entry);
        const docRemark = (entry === null || entry === void 0 ? void 0 : (_entry$documentDetail = entry.documentDetails) === null || _entry$documentDetail === void 0 ? void 0 : _entry$documentDetail.developerRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!docRemark || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: docRemark,
          drawingRemarks: null,
          inspectionRemarks: null,
          paymentRemarks: null,
          notingRemarks: null,
          landUseRemarks: null,
          timestamp: ts
        });
      });
      allDrawingEntries.forEach(entry => {
        var _entry$drawingsDetail;
        const ts = getEntryTs(entry);
        const drawRemark = (entry === null || entry === void 0 ? void 0 : (_entry$drawingsDetail = entry.drawingsDetails) === null || _entry$drawingsDetail === void 0 ? void 0 : _entry$drawingsDetail.developerRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!drawRemark || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: null,
          drawingRemarks: drawRemark,
          inspectionRemarks: null,
          paymentRemarks: null,
          notingRemarks: null,
          landUseRemarks: null,
          timestamp: ts
        });
      });
      allInspectionEntries.forEach(entry => {
        var _entry$inspectionDeta, _entry$inspectionDeta2, _entry$inspectionDeta3;
        const ts = getEntryTs(entry);
        const inspRemark = (entry === null || entry === void 0 ? void 0 : (_entry$inspectionDeta = entry.inspectionDetails) === null || _entry$inspectionDeta === void 0 ? void 0 : (_entry$inspectionDeta2 = _entry$inspectionDeta.inspectionReportData) === null || _entry$inspectionDeta2 === void 0 ? void 0 : _entry$inspectionDeta2.developerRemarks) || (entry === null || entry === void 0 ? void 0 : (_entry$inspectionDeta3 = entry.inspectionDetails) === null || _entry$inspectionDeta3 === void 0 ? void 0 : _entry$inspectionDeta3.developerRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!inspRemark || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: null,
          drawingRemarks: null,
          inspectionRemarks: inspRemark,
          paymentRemarks: null,
          notingRemarks: null,
          landUseRemarks: null,
          timestamp: ts
        });
      });
      allPaymentEntries.forEach(entry => {
        var _entry$paymentDetails;
        const ts = getEntryTs(entry);
        const payRemark = (entry === null || entry === void 0 ? void 0 : (_entry$paymentDetails = entry.paymentDetails) === null || _entry$paymentDetails === void 0 ? void 0 : _entry$paymentDetails.developerRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!payRemark || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: null,
          drawingRemarks: null,
          inspectionRemarks: null,
          paymentRemarks: payRemark,
          notingRemarks: null,
          landUseRemarks: null,
          timestamp: ts
        });
      });
      allKhasraEntries.forEach(entry => {
        const ts = getEntryTs(entry);
        const khasraRemark = (entry === null || entry === void 0 ? void 0 : entry.khasraRemarks) || (entry === null || entry === void 0 ? void 0 : entry.landUseRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!khasraRemark || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: null,
          drawingRemarks: null,
          inspectionRemarks: null,
          paymentRemarks: null,
          notingRemarks: null,
          landUseRemarks: khasraRemark,
          timestamp: ts
        });
      });
      allNotingEntries.forEach(entry => {
        var _entry$notingDetails;
        const ts = getEntryTs(entry);
        const note = (entry === null || entry === void 0 ? void 0 : (_entry$notingDetails = entry.notingDetails) === null || _entry$notingDetails === void 0 ? void 0 : _entry$notingDetails.developerRemarks) || (entry === null || entry === void 0 ? void 0 : entry.developerRemarks);
        if (!note || !isTsInWindow(ts)) return;
        rawItems.push({
          userId: getOfficerKey(entry),
          userName: getOfficerName(entry),
          userDesignation: getOfficerDesignation(entry),
          docRemarks: null,
          drawingRemarks: null,
          inspectionRemarks: null,
          paymentRemarks: null,
          notingRemarks: note,
          landUseRemarks: null,
          timestamp: ts
        });
      });
      const hasCanonicalDoc = allDocEntries.length > 0;
      const hasCanonicalDrawing = allDrawingEntries.length > 0;
      const hasCanonicalInspection = allInspectionEntries.length > 0;
      const hasCanonicalPayment = allPaymentEntries.length > 0;
      const hasCanonicalKhasra = allKhasraEntries.length > 0;
      const shouldCheckRaw = !(hasCanonicalDoc && hasCanonicalDrawing && hasCanonicalInspection && hasCanonicalPayment && hasCanonicalKhasra);
      if (shouldCheckRaw) {
        const rawReport = Array.isArray(notingRemarksData === null || notingRemarksData === void 0 ? void 0 : notingRemarksData.SecurityReport) ? notingRemarksData.SecurityReport : Array.isArray(notingRemarksData) && notingRemarksData.some(it => Array.isArray(it === null || it === void 0 ? void 0 : it.detailDataRemarks) || (it === null || it === void 0 ? void 0 : it.userId) || (it === null || it === void 0 ? void 0 : it.userName)) ? notingRemarksData : [];
        rawReport.forEach(officer => {
          const key = getOfficerKey(officer);
          const officerName = getOfficerName(officer);
          const officerDesignation = getOfficerDesignation(officer);
          const remarksList = Array.isArray(officer === null || officer === void 0 ? void 0 : officer.detailDataRemarks) ? officer.detailDataRemarks : [];
          remarksList.forEach(r => {
            var _r$documentDetails, _r$drawingsDetails, _r$inspectionDetails, _r$inspectionDetails$, _r$inspectionDetails2, _r$paymentDetails;
            const rTs = getEntryTs(r);
            const doc = !hasCanonicalDoc ? r === null || r === void 0 ? void 0 : (_r$documentDetails = r.documentDetails) === null || _r$documentDetails === void 0 ? void 0 : _r$documentDetails.developerRemarks : null;
            const draw = !hasCanonicalDrawing ? r === null || r === void 0 ? void 0 : (_r$drawingsDetails = r.drawingsDetails) === null || _r$drawingsDetails === void 0 ? void 0 : _r$drawingsDetails.developerRemarks : null;
            const insp = !hasCanonicalInspection ? (r === null || r === void 0 ? void 0 : (_r$inspectionDetails = r.inspectionDetails) === null || _r$inspectionDetails === void 0 ? void 0 : (_r$inspectionDetails$ = _r$inspectionDetails.inspectionReportData) === null || _r$inspectionDetails$ === void 0 ? void 0 : _r$inspectionDetails$.developerRemarks) || (r === null || r === void 0 ? void 0 : (_r$inspectionDetails2 = r.inspectionDetails) === null || _r$inspectionDetails2 === void 0 ? void 0 : _r$inspectionDetails2.developerRemarks) : null;
            const pay = !hasCanonicalPayment ? r === null || r === void 0 ? void 0 : (_r$paymentDetails = r.paymentDetails) === null || _r$paymentDetails === void 0 ? void 0 : _r$paymentDetails.developerRemarks : null;
            const land = !hasCanonicalKhasra ? (r === null || r === void 0 ? void 0 : r.khasraRemarks) || (r === null || r === void 0 ? void 0 : r.landUseRemarks) : null;
            const hasDoc = doc && rawItems.some(it => it.userId === key && it.docRemarks === doc);
            const hasDraw = draw && rawItems.some(it => it.userId === key && it.drawingRemarks === draw);
            const hasInsp = insp && rawItems.some(it => it.userId === key && it.inspectionRemarks === insp);
            const hasPay = pay && rawItems.some(it => it.userId === key && it.paymentRemarks === pay);
            const hasLand = land && rawItems.some(it => it.userId === key && it.landUseRemarks === land);
            const docToAdd = hasDoc ? null : doc;
            const drawToAdd = hasDraw ? null : draw;
            const inspToAdd = hasInsp ? null : insp;
            const payToAdd = hasPay ? null : pay;
            const landToAdd = hasLand ? null : land;
            const noteToAdd = null;
            if ((docToAdd || drawToAdd || inspToAdd || payToAdd || landToAdd || noteToAdd) && isTsInWindow(rTs)) {
              rawItems.push({
                userId: key,
                userName: officerName,
                userDesignation: officerDesignation,
                docRemarks: docToAdd || null,
                drawingRemarks: drawToAdd || null,
                inspectionRemarks: inspToAdd || null,
                paymentRemarks: payToAdd || null,
                notingRemarks:  null,
                landUseRemarks: landToAdd || null,
                timestamp: rTs
              });
            }
          });
        });
      }
      const sortedRaw = rawItems.sort((a, b) => b.timestamp - a.timestamp);
      const sessionGroups = [];
      for (const item of sortedRaw) {
        const match = sessionGroups.find(g => {
          if (g.userId !== item.userId) return false;
          if (Math.abs(g.timestamp - item.timestamp) > 300000) return false;
          const hasConflict = item.docRemarks && g.docRemarks && item.docRemarks !== g.docRemarks || item.drawingRemarks && g.drawingRemarks && item.drawingRemarks !== g.drawingRemarks || item.inspectionRemarks && g.inspectionRemarks && item.inspectionRemarks !== g.inspectionRemarks || item.paymentRemarks && g.paymentRemarks && item.paymentRemarks !== g.paymentRemarks || item.notingRemarks && g.notingRemarks && item.notingRemarks !== g.notingRemarks || item.landUseRemarks && g.landUseRemarks && item.landUseRemarks !== g.landUseRemarks;
          return !hasConflict;
        });
        if (match) {
          if (!match.docRemarks && item.docRemarks) match.docRemarks = item.docRemarks;
          if (!match.drawingRemarks && item.drawingRemarks) match.drawingRemarks = item.drawingRemarks;
          if (!match.inspectionRemarks && item.inspectionRemarks) match.inspectionRemarks = item.inspectionRemarks;
          if (!match.paymentRemarks && item.paymentRemarks) match.paymentRemarks = item.paymentRemarks;
          if (!match.notingRemarks && item.notingRemarks) match.notingRemarks = item.notingRemarks;
          if (!match.landUseRemarks && item.landUseRemarks) match.landUseRemarks = item.landUseRemarks;
          if (item.timestamp > match.timestamp) match.timestamp = item.timestamp;
        } else {
          sessionGroups.push({
            ...item
          });
        }
      }
      return sessionGroups.filter(it => it.docRemarks || it.drawingRemarks || it.inspectionRemarks || it.paymentRemarks || it.notingRemarks || it.landUseRemarks).map(it => {
        const formattedDate = formatDateTime$2(it.timestamp);
        return {
          ...it,
          date: formattedDate
        };
      }).sort((a, b) => b.timestamp - a.timestamp);
    };
    const mappedSubmissions = (submissionIntervals || []).map(interval => {
      const items = getSubmissionOfficerItems(interval);
      return {
        ...interval,
        items
      };
    });
    return [...mappedSubmissions].reverse();
  }, [submissionIntervals, allDocEntries, allDrawingEntries, allInspectionEntries, allPaymentEntries, allKhasraEntries, allNotingEntries, notingRemarksData]);
  console.log("notingRemarksData", notingRemarksData, submissions);
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "justify-content-center",
    style: {
      top: windowHeight * 0.3,
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "50%",
      minHeight: "40%",
      marginTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "remarkshelp"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "concludingremarks"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }), error && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px",
      color: "red"
    }
  }, "Please Enter Remarks."), /*#__PURE__*/React__default.createElement(Button$3, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: 20,
      color: "#fff",
      textAlign: "center",
      backgroundColor: applicationStatus === "APPROVED" ? "grey" : "rgb(31 74 124)"
    },
    onClick: handlemodalsubmit,
    disabled: applicationStatus === "APPROVED"
  }, "Save"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 5px",
      padding: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(DocUploader, {
    uploadedFile: uploadedFile,
    setUploadedFile: setUploadedFile,
    isNextLine: true
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "histrorynotingremarks",
    id: "historyList"
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: 20,
      color: "#fff",
      textAlign: "center"
    },
    onClick: () => closeModalHistory(formData)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff"
    }
  }, "View")), /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF,
    class: "notesheet"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("section", {
    class: "proposal-details"
  }, /*#__PURE__*/React__default.createElement("h3", null, "Proposal Details"), /*#__PURE__*/React__default.createElement("div", {
    class: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:"), " ", formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Submitted On:"), " ", caption === null || caption === void 0 ? void 0 : caption.date), /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application Type:"), " ", formData === null || formData === void 0 ? void 0 : formData.applicationType), /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "License No :"), " ", formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.licenseNumber), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.consultantCategory) && /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.consultantCategory, ":"), " ", formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.name), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.consultantCategory) && /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.consultantCategory, " Mobile:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber), /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owners Name:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow[0].name), /*#__PURE__*/React__default.createElement("div", {
    class: "col-12"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owners Mobile:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o[0].mobileNumber))), /*#__PURE__*/React__default.createElement("section", {
    class: "remarks-table"
  }, submissions && submissions.length > 0 ? submissions.map((sub, sIndex) => /*#__PURE__*/React__default.createElement("div", {
    key: sIndex,
    className: "submission-section",
    style: {
      marginBottom: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#1f4a7c",
      color: "#fff",
      padding: "8px 14px",
      fontWeight: "600",
      fontSize: "1.05rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      marginTop: sIndex > 0 ? "18px" : "0px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, sub.title), sub.shortfallDate && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "0.85rem",
      fontWeight: "500",
      background: "rgba(255, 255, 255, 0.2)",
      padding: "2px 8px",
      borderRadius: "4px"
    }
  }, "Shortfall Date: ", ConvertEpochToDate(sub.shortfallDate))), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr. No"), /*#__PURE__*/React__default.createElement("th", null, "Officers Name"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Officers Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Date"))), /*#__PURE__*/React__default.createElement("tbody", null, sub.items && sub.items.length > 0 ? sub.items.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.userName), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : item.userDesignation), /*#__PURE__*/React__default.createElement("td", null, item.docRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Document Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.docRemarks
  }))), item.landUseRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Land Use Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.landUseRemarks
  }))), item.drawingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Drawings Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.drawingRemarks
  }))), item.inspectionRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Inspection Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.inspectionRemarks
  }))), item.paymentRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Payment Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.paymentRemarks
  }))), item.notingRemarks && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("strong", null, "Noting Remarks :"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "pre-wrap"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item.notingRemarks
  })))), /*#__PURE__*/React__default.createElement("td", null, item.date))) : /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "5",
    style: {
      textAlign: "center",
      color: "#666",
      padding: "14px",
      fontStyle: "italic"
    }
  }, "No remarks recorded for this submission yet.")))))) : /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr. No"), /*#__PURE__*/React__default.createElement("th", null, "Officers Name"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Officers Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Date"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "5",
    style: {
      textAlign: "center",
      color: "#666",
      padding: "14px",
      fontStyle: "italic"
    }
  }, "No remarks available")))))))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Noting",
    dataOpen: smShowMsNoting,
    onClose: () => {
      setSmShowMsNoting(false);
    }
  }, /*#__PURE__*/React__default.createElement(Notesheet, {
    formData: formData,
    notingRemarksData: notingRemarksData,
    caption: caption,
    logoUrl: logoUrl,
    nameOfDepartment: nameOfDepartment,
    khasraLatestMap: khasraLatestMap,
    submissions: submissions
  })));
};

const CollapsibleHistory = ({
  formData,
  callNotingDetailsAPI,
  developerRemarks,
  setDeveloperRemarks,
  notingRemarksData,
  logoData,
  workflowDetails,
  uploadedFile,
  setUploadedFile
}) => {
  const [open4, setOpen4] = useState(true);
  console.log(notingRemarksData, "data from parent");
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "collapse-header",
    onClick: () => setOpen4(!open4),
    "aria-controls": "example-collapse-text",
    "aria-expanded": open4,
    style: {
      background: "rgba(52, 73, 94, 0.94)",
      padding: "0.25rem 1.25rem",
      borderRadius: "0.25rem",
      fontWeight: "600",
      display: "flex",
      cursor: "pointer",
      color: "#817f7f",
      justifyContent: "space-between",
      alignContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff",
      fontSize: 16
    }
  }, "Add Noting"), open4 ? /*#__PURE__*/React__default.createElement(RemoveIcon$1, {
    sx: {
      color: "#fff"
    }
  }) : /*#__PURE__*/React__default.createElement(AddIcon$1, {
    sx: {
      color: "#fff"
    }
  })), /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: open4
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "example-collapse-text",
    style: {
      marginTop: 12,
      paddingLeft: 12,
      paddingRight: 12
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      width: "100%",
      display: "flex",
      marginBottom: 2,
      marginTop: 3
    }
  }, /*#__PURE__*/React__default.createElement(HistoryList, {
    formData: formData,
    callNotingDetailsAPI: callNotingDetailsAPI,
    developerRemarks: developerRemarks,
    setDeveloperRemarks: setDeveloperRemarks,
    notingRemarksData: notingRemarksData,
    logoData: logoData,
    workflowDetails: workflowDetails,
    uploadedFile: uploadedFile,
    setUploadedFile: setUploadedFile
  })))));
};

function FileUploaderNew({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  maxFiles = 5,
  tab,
  uploadedDocs = [],
  setUploadedDocs = () => {},
  control,
  required = false,
  showError = false
}) {
  const fileInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleFileUpload = async (e, inputName = name || "fileInput") => {
    var _uploadedDocs$filter;
    const files = Array.from(e.target.files);
    setIsLoading(true);
    setShowToast(null);
    const alreadyUploaded = (uploadedDocs === null || uploadedDocs === void 0 ? void 0 : (_uploadedDocs$filter = uploadedDocs.filter(doc => doc.documentType === inputName)) === null || _uploadedDocs$filter === void 0 ? void 0 : _uploadedDocs$filter.length) || 0;
    const filesToUpload = files.slice(0, maxFiles - alreadyUploaded);
    const allowedExtensionsByTab = {
      1: [".pdf"],
      2: [".png", ".jpg", ".jpeg", ".pdf"],
      3: [".dxf"],
      5: [".dxf"],
      6: [".mp4", ".mov", ".avi", ".mkv"]
    };
    const maxSizeByTab = {
      1: 10 * 1024 * 1024,
      2: 30 * 1024 * 1024,
      3: 100 * 1024 * 1024,
      5: 100 * 1024 * 1024,
      6: 50 * 1024 * 1024,
      default: 30 * 1024 * 1024
    };
    const isDrawingPdf = inputName === "drawingPdf" || inputName === "drawingPDF" || inputName === "compoundingDrawingPdf" || name === "drawingPdf" || name === "drawingPDF" || name === "compoundingDrawingPdf" || typeof label === "string" && label.toLowerCase().includes("drawing") && label.toLowerCase().includes("pdf");
    const allowedExtensions = allowedExtensionsByTab[tab] || [".pdf"];
    const maxSize = isDrawingPdf ? 150 * 1024 * 1024 : maxSizeByTab[tab] || maxSizeByTab.default;
    for (let file of filesToUpload) {
      const ext = "." + file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(ext)) {
        setShowToast({
          error: true,
          label: `Invalid format: ${file.name}`
        });
        continue;
      }
      if (file.size > maxSize) {
        setShowToast({
          error: true,
          label: `${file.name} exceeds ${maxSize / 1024 / 1024} MB.`
        });
        continue;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("tenantId", "up");
      formData.append("module", "property-upload");
      formData.append("tag", "tag-property");
      try {
        const resp = await axios$1.post("/filestore/v1/files", formData, {});
        const filesId = resp.data.files[0];
        setUploadedDocs(prev => [...prev, {
          documentType: inputName,
          fileStoreId: filesId.fileStoreId,
          additionalDetails: {
            fileName: file.name,
            title: label
          }
        }]);
      } catch (err) {
        console.error(err.message);
        setShowToast({
          error: true,
          label: `Upload failed for ${file.name}`
        });
      }
    }
    setIsLoading(false);
    e.target.value = null;
  };
  const handleDelete = fileStoreId => {
    setUploadedDocs(prev => prev.filter(doc => doc.fileStoreId !== fileStoreId));
  };
  const docsForThisType = uploadedDocs === null || uploadedDocs === void 0 ? void 0 : uploadedDocs.filter(doc => doc.documentType === (name || "fileInput"));
  const getAcceptType = () => {
    switch (tab) {
      case 1:
        return ".pdf";
      case 2:
        return ".png,.jpg,.jpeg, .pdf";
      case 3:
      case 5:
        return ".dxf";
      case 6:
        return ".mp4,.mov,.avi,.mkv";
      default:
        return "*";
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: "label",
    style: {
      width: "100%"
    }
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      height: "30px",
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c",
        color: "#fff"
      }
    },
    disabled: docsForThisType.length >= maxFiles
  }, isLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#fff"
    },
    size: 24
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "0.5em",
      fontSize: "0.7rem"
    }
  }, (name === "drawingPdf" || name === "drawingPDF" || name === "compoundingDrawingPdf") && typeof validationMsg === "string" ? validationMsg.replace("30 MB", "150 MB") : validationMsg))), control && name ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: required && docsForThisType.length === 0
    },
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement("input", Object.assign({}, field, {
      ref: fileInputRef,
      type: "file",
      multiple: true,
      accept: getAcceptType(),
      style: {
        display: "none"
      },
      onChange: e => handleFileUpload(e, name)
    }))
  }) : /*#__PURE__*/React__default.createElement("input", {
    ref: fileInputRef,
    type: "file",
    multiple: true,
    accept: getAcceptType(),
    style: {
      display: "none"
    },
    onChange: e => handleFileUpload(e)
  })), docsForThisType.length > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, docsForThisType.map(doc => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: doc.fileStoreId,
      sx: {
        backgroundColor: "#eee",
        borderRadius: "4px",
        padding: "4px 8px",
        marginBottom: "6px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "0.7rem"
      }
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 16
    }) : /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    })), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: () => handleDelete(doc.fileStoreId)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, {
      fontSize: "small",
      color: "error"
    }))));
  })), required && showError && docsForThisType.length === 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, `${label || "This"} document is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label));
}

const InspectionPhotoViewer = ({
  documentInspection: _documentInspection = []
}) => {
  var _selectedImage$additi;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [mirror, setMirror] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (_documentInspection.length === 0) setSelectedIndex(-1);else setSelectedIndex(0);
  }, [_documentInspection]);
  const handleSelect = index => {
    setSelectedIndex(index);
    setZoom(1);
    setRotation(0);
    setMirror(false);
  };
  const handleZoomIn = () => setZoom(z => z + 0.25);
  const handleZoomOut = () => setZoom(z => Math.max(0.25, z - 0.25));
  const handleRotate = () => setRotation(r => r - 90);
  const handleReset = () => {
    setZoom(1);
    setRotation(0);
    setMirror(false);
  };
  const selectedImage = _documentInspection && _documentInspection[selectedIndex];
  console.log(selectedImage, "selectedImage");
  useEffect(() => {
    const fetchImage = async () => {
      if (!(selectedImage !== null && selectedImage !== void 0 && selectedImage.fileStoreId)) return;
      const url = await getDocumentByFileStoreId(selectedImage.fileStoreId, setLoading, true);
      console.log("Fetched Image URL:", url);
      setImageUrl(url);
    };
    fetchImage();
  }, [selectedImage]);
  return /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    sx: {
      height: "100%",
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(List, {
    dense: true
  }, _documentInspection.map((doc, index) => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement(ListItemButton, {
      key: doc.fileStoreId,
      selected: index === selectedIndex,
      onClick: () => handleSelect(index)
    }, /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || "Untitled",
      secondary: new Date().toLocaleString()
    }));
  })))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    sx: {
      p: 2
    }
  }, selectedImage ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      textAlign: "center",
      height: 400,
      overflow: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #ccc",
      mb: 2
    }
  }, loading ? /*#__PURE__*/React__default.createElement(Typography, null, "Loading image...") : imageUrl ? /*#__PURE__*/React__default.createElement("img", {
    src: imageUrl,
    alt: (_selectedImage$additi = selectedImage.additionalDetails) === null || _selectedImage$additi === void 0 ? void 0 : _selectedImage$additi.fileName,
    onError: () => console.log("❌ Image failed:", imageUrl),
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      transform: `scale(${zoom}) rotate(${rotation}deg) ${mirror ? "scaleX(-1)" : ""}`,
      transition: "transform 0.3s ease"
    }
  }) : /*#__PURE__*/React__default.createElement(Typography, null, "No image available")), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "success",
    onClick: handleZoomIn
  }, /*#__PURE__*/React__default.createElement(ZoomInIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "success",
    onClick: handleZoomOut
  }, /*#__PURE__*/React__default.createElement(ZoomOutIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "success",
    onClick: handleRotate
  }, /*#__PURE__*/React__default.createElement(RotateLeftIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "success",
    onClick: () => setMirror(prev => !prev),
    title: "Mirror"
  }, /*#__PURE__*/React__default.createElement(FlipIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "success",
    onClick: handleReset
  }, /*#__PURE__*/React__default.createElement(RestoreIcon, null))), /*#__PURE__*/React__default.createElement(Typography, {
    align: "center",
    mt: 1
  }, "Zoom: ", (zoom * 100).toFixed(0), "% | Rotation: ", rotation, "\xB0")) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, "No image selected or available."))));
};

const useStyles$1 = makeStyles$1(theme => ({
  p: {
    fontSize: "14px",
    overflow: "hidden",
    whitespce: "nowrap"
  }
}));
const ChatboardCorrespondence = ({
  formData,
  assignerToChatboard
}) => {
  var _assignerToChatboard$, _assignerToChatboard$2, _assignerToChatboard$3, _assignerToChatboard$4, _assignerToChatboard$5, _assignerToChatboard$6, _userRolesArray$, _userRolesArray$2, _userInfo$roles, _formData$auditDetail, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$professiona, _chatBoardHistoryData;
  const classes = useStyles$1();
  const {
    t
  } = useTranslation();
  const Modal = useModal();
  const {
    chatBoardDataRemarks,
    handleGetRemarkssValues,
    chatBoardHistoryData,
    handleGetHistoryRemarkssValues
  } = useContext(ScrutinyRemarksContext);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [roleSet, setRoleSet] = useState([]);
  const typeOfUser = assignerToChatboard === null || assignerToChatboard === void 0 ? void 0 : (_assignerToChatboard$ = assignerToChatboard.data) === null || _assignerToChatboard$ === void 0 ? void 0 : (_assignerToChatboard$2 = _assignerToChatboard$.processInstance) === null || _assignerToChatboard$2 === void 0 ? void 0 : (_assignerToChatboard$3 = _assignerToChatboard$2.assigner) === null || _assignerToChatboard$3 === void 0 ? void 0 : _assignerToChatboard$3.type;
  const userData = Digit.UserService.getUser() || {};
  const userInfo = (userData === null || userData === void 0 ? void 0 : userData.info) || {};
  const authToken = (userData === null || userData === void 0 ? void 0 : userData.access_token) || null;
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const assignerRolesArray = assignerToChatboard === null || assignerToChatboard === void 0 ? void 0 : (_assignerToChatboard$4 = assignerToChatboard.data) === null || _assignerToChatboard$4 === void 0 ? void 0 : (_assignerToChatboard$5 = _assignerToChatboard$4.processInstance) === null || _assignerToChatboard$5 === void 0 ? void 0 : (_assignerToChatboard$6 = _assignerToChatboard$5.assigner) === null || _assignerToChatboard$6 === void 0 ? void 0 : _assignerToChatboard$6.roles.filter(assigner => assigner.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code;
  const designation = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.name;
  const [developerRemarks, setDeveloperRemarks] = React__default.useState("");
  const [messageTo, setMessageTo] = React__default.useState(undefined);
  const [assignTo, setAssignTo] = React__default.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [docPopupData, setDocPopupData] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [error, setError] = useState(null);
  const officerRole = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(item => item.code !== "EMPLOYEE");
  const [chatBoardDocs, setChatBoardDocs] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const openPopup = item => {
    debugger;
    let rows = [];
    rows = (item === null || item === void 0 ? void 0 : item.documentId) || [];
    setShowPopup(true);
    setSelectedDetails(rows);
    setCreatedTime((item === null || item === void 0 ? void 0 : item.createdOn) || null);
    setPopupData(item);
  };
  console.log("selectedDetails", selectedDetails);
  const closePopup = () => {
    setShowPopup(false);
    setSelectedDetails([]);
    setPopupData(null);
  };
  const printPopup = () => {
    const popupContent = document.getElementById("popup-print-content");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Details</title>
          <style>
            body { font-size: 11px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #e2e8f0; font-size: 13px; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const selectRole = (role, name, useruuid) => {
    setAssignTo(role, name, useruuid);
  };
  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };
  const onMessageToChange = e => {
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };
  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken
      },
      egScrutiny: {
        applicationId: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: false,
        userid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
        serviceId: 0,
        documentId: chatBoardDocs,
        bussinessServiceName: formData === null || formData === void 0 ? void 0 : formData.businessService,
        designation: designation,
        name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) || null,
        employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
        role: filterDataRole,
        applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status,
        assignTo: assignTo || null,
        chatBoardStatus: "PENDING" ,
        chatBoardReply: {},
        previousStatus: "",
        previousUserId: 0,
        previousEmployeeRole: ""
      }
    };
    try {
      const Resp = await axios$1.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then(response => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    let redirectPath = "";
    if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_MAP") {
      redirectPath = `/digit-ui/employee/obps/application/MAP_SUB/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
    } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR") {
      redirectPath = `/digit-ui/employee/obps/application/PURCHASABLE_FAR/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
    } else {
      redirectPath = `/digit-ui/employee/obps/application/formLandUse/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
    }
    Modal("Application Chat Board", `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) Chat Board</strong> Successfully!`, "success", redirectPath);
    await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo), handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  };
  const handlemodalAttachment = e => {
    setUploadedFileAttachment("AttachmentOPen");
  };
  const [post, setPost] = useState({
    content: "",
    hearingDate: ""
  });
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _tenantId, _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || ((_tenantId = tenantId) === null || _tenantId === void 0 ? void 0 : _tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  useEffect(() => {
    assignerToChatboard === null || assignerToChatboard === void 0 ? void 0 : assignerToChatboard.forEach(e => {
      var _e$assigner;
      if ((e === null || e === void 0 ? void 0 : (_e$assigner = e.assigner) === null || _e$assigner === void 0 ? void 0 : _e$assigner.type) !== "CITIZEN") {
        var _e$assigner2, _e$assigner2$roles;
        e === null || e === void 0 ? void 0 : (_e$assigner2 = e.assigner) === null || _e$assigner2 === void 0 ? void 0 : (_e$assigner2$roles = _e$assigner2.roles) === null || _e$assigner2$roles === void 0 ? void 0 : _e$assigner2$roles.forEach(role => {
          var _officerRole$;
          if ((role === null || role === void 0 ? void 0 : role.code) !== "EMPLOYEE" && (role === null || role === void 0 ? void 0 : role.code) !== (officerRole === null || officerRole === void 0 ? void 0 : (_officerRole$ = officerRole[0]) === null || _officerRole$ === void 0 ? void 0 : _officerRole$.code)) {
            const ind = roleSet.findIndex(r => r.name == role.name && r.code == role.code);
            if (ind === -1) {
              var _e$assigner3;
              roleSet.push({
                name: role.name,
                code: role.code,
                useruuid: e === null || e === void 0 ? void 0 : (_e$assigner3 = e.assigner) === null || _e$assigner3 === void 0 ? void 0 : _e$assigner3.uuid
              });
            }
          }
        });
      }
    });
    setRoleSet(roleSet);
  }, [assignerToChatboard]);
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.applicationNo) {
      handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  useEffect(() => {
    const fetchRemarks = async () => {
      if (!(formData !== null && formData !== void 0 && formData.applicationNo)) return;
      try {
        await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
        await handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };
    fetchRemarks();
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  console.log("chatBoardHistoryData", chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : chatBoardHistoryData.egScrutinyData, formData === null || formData === void 0 ? void 0 : formData.applicationNo, chatBoardDataRemarks);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      padding: "10px",
      color: "#fff",
      fontWeight: "bold",
      textAlign: "left"
    }
  }, "Application Details"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Submitted On:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, ConvertEpochToDate(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime)), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Owner/Applicant:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Architect:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Project Type:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationType))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      paddingLeft: "20px",
      paddingTop: "1rem"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Message To")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    className: "form-field",
    label: `Applicant`,
    onChange: onMessageToChange,
    checked: applicantChecked,
    style: {
      marginLeft: "30px",
      paddingTop: "3px",
      fontSize: "14px"
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    className: "form-field",
    label: `Department`,
    onChange: onMessageToChange,
    checked: developerChecked,
    style: {
      marginLeft: "30px",
      paddingTop: "3px",
      fontSize: "14px"
    }
  })))), developerChecked === true && typeOfUser !== "CITIZEN" && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      overflow: "visible"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      paddingLeft: "20px",
      paddingTop: "1rem"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Assign To")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    option: roleSet,
    optionKey: "name",
    optionValue: "code",
    select: selectRole,
    placeholder: "Select Role",
    style: {
      marginLeft: "25px",
      paddingTop: "5px",
      fontSize: "14px",
      overflow: "visible"
    }
  })))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    id: "joditeditor",
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }), uploadedFileAttachment === "AttachmentOPen" && /*#__PURE__*/React__default.createElement(Box$2, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 3"
  }, " Document /Certificate"), /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 9"
  }, /*#__PURE__*/React__default.createElement(FileUploaderNew, {
    validationMsg: "(jpg, jpeg, pdf, png file only and Max file Size 30 MB)",
    tab: 2,
    maxFiles: 5,
    uploadedDocs: chatBoardDocs,
    setUploadedDocs: setChatBoardDocs
  }))), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: 20,
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalsubmit
  }, "Send"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "10px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: closeEditor
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "70px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalAttachment
  }, "Attachment")), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "60%",
      transform: "translateX(-50%)",
      backgroundColor: "#f3f4f6",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px"
    }
  }, "Document Details"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon$1, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "popup-print-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.employeeName) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.designation) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Role:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.role) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Created At:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: createdTime
  })), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Document Type"), /*#__PURE__*/React__default.createElement("th", null, "File Name"))), /*#__PURE__*/React__default.createElement("tbody", null, selectedDetails === null || selectedDetails === void 0 ? void 0 : selectedDetails.map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.documentType), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.documentUrl) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: row.documentUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    style: {
      marginLeft: 8
    },
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })))))))))), formData && (chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : chatBoardHistoryData.egScrutiny) && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: '1rem',
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      padding: "10px",
      color: "#fff",
      fontWeight: "bold",
      textAlign: "left"
    }
  }, "History Of Web Message"), /*#__PURE__*/React__default.createElement("section", {
    className: "remarks-table"
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Sr. No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "AssignTo"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Message To"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Message"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "File Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Created By"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Date"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: '12px'
    }
  }, "Attachments"))), /*#__PURE__*/React__default.createElement("tbody", null, chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : (_chatBoardHistoryData = chatBoardHistoryData.egScrutiny) === null || _chatBoardHistoryData === void 0 ? void 0 : _chatBoardHistoryData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, " ", item !== null && item !== void 0 && item.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item === null || item === void 0 ? void 0 : item.fieldIdL}`), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, item === null || item === void 0 ? void 0 : item.fieldIdL), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: item === null || item === void 0 ? void 0 : item.comment
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, item === null || item === void 0 ? void 0 : item.applicationId), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, item === null || item === void 0 ? void 0 : item.employeeName, ",(", item === null || item === void 0 ? void 0 : item.designation, ")"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: item === null || item === void 0 ? void 0 : item.createdOn
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => openPopup(item),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
    fontSize: "small"
  }))))))))), (docPopupData === null || docPopupData === void 0 ? void 0 : docPopupData.length) > 0 && /*#__PURE__*/React__default.createElement(InspectionPhotoViewer, {
    documentInspection: docPopupData
  }));
};

const ChatBoard = ({
  formData,
  assignerToChatboard
}) => {
  console.log(formData);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ChatboardCorrespondence, {
    formData: formData,
    assignerToChatboard: assignerToChatboard
  }));
};

const WarningBlockedIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "50",
  cy: "50",
  r: "44",
  fill: "#FEF2F2"
}), /*#__PURE__*/React__default.createElement("circle", {
  cx: "50",
  cy: "50",
  r: "34",
  fill: "#FEE2E2"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M50 28L68 62H32L50 28Z",
  fill: "#DC2626",
  stroke: "#DC2626",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React__default.createElement("rect", {
  x: "48.5",
  y: "42",
  width: "3",
  height: "11",
  rx: "1.5",
  fill: "#FFFFFF"
}), /*#__PURE__*/React__default.createElement("circle", {
  cx: "50",
  cy: "57",
  r: "1.8",
  fill: "#FFFFFF"
}));
const isCompoundingFile = data => {
  if (!data) return false;
  const appType = String((data === null || data === void 0 ? void 0 : data.applicationType) || (data === null || data === void 0 ? void 0 : data.appliactionType) || (data === null || data === void 0 ? void 0 : data.formType) || (data === null || data === void 0 ? void 0 : data.serviceType) || "").toUpperCase();
  const modName = String((data === null || data === void 0 ? void 0 : data.moduleName) || "").toUpperCase();
  const bs = String((data === null || data === void 0 ? void 0 : data.businessService) || "").toUpperCase();
  const appNo = String((data === null || data === void 0 ? void 0 : data.applicationNo) || (data === null || data === void 0 ? void 0 : data.applicationNumber) || "").toUpperCase();
  const planOn = String((data === null || data === void 0 ? void 0 : data.planOn) || "").toUpperCase();
  const str = `${appType} ${modName} ${bs} ${appNo} ${planOn}`;
  return str.includes("COMPOUNDING") || appType === "FORM_COMPOUNDING" || planOn === "FORM_MAP_COMPOUNDING" || bs === "BPA_COMPOUNDING" || appNo.includes("/CP/") || appNo.includes("/CMP/");
};
const getTaxHeadEstimates = data => {
  if (!data) return [];
  var list = [];
  var addIfArray = function (arr) {
    if (Array.isArray(arr) && arr.length > 0) {
      list = list.concat(arr);
    }
  };
  var bpaChallan = data.BPAChallan || data.bpaChallan;
  if (bpaChallan) {
    if (Array.isArray(bpaChallan)) {
      bpaChallan.forEach(function (c) {
        addIfArray(c && c.taxHeadEstimates);
      });
    } else if (typeof bpaChallan === "object") {
      addIfArray(bpaChallan.taxHeadEstimates);
      if (bpaChallan.taxHeadCode || bpaChallan.calculationBusinesserviceId) {
        list.push(bpaChallan);
      }
    }
  }
  return list;
};
const isFee2Match = (est, isCompounding) => {
  if (!est) return false;
  const targetCodes = isCompounding ? ["BPA.MAP_COMPOUNDING_FEE", "BPA_MAP_COMPOUNDING_FEE"] : ["BPA.MAP_SUBMISSION_FEE_2", "BPA_MAP_SUBMISSION_FEE_2"];
  const targetNormalized = isCompounding ? ["BPAMAPCOMPOUNDINGFEE", "MAPCOMPOUNDINGFEE"] : ["BPAMAPSUBMISSIONFEE2", "MAPSUBMISSIONFEE2"];
  const checkCode = c => {
    if (!c) return false;
    const raw = String(c).trim().toUpperCase();
    const normalized = raw.replace(/[\._]/g, "");
    return targetCodes.includes(raw) || targetNormalized.includes(normalized);
  };
  const codesToCheck = [est === null || est === void 0 ? void 0 : est.taxHeadCode, est === null || est === void 0 ? void 0 : est.code, est === null || est === void 0 ? void 0 : est.calculationBusinesserviceId, est === null || est === void 0 ? void 0 : est.businessService, est === null || est === void 0 ? void 0 : est.feeType, est === null || est === void 0 ? void 0 : est.headCode];
  if (codesToCheck.some(checkCode)) {
    return true;
  }
  if (Array.isArray(est === null || est === void 0 ? void 0 : est.paymentHeads) && est.paymentHeads.some(h => checkCode((h === null || h === void 0 ? void 0 : h.taxHeadCode) || (h === null || h === void 0 ? void 0 : h.code) || (h === null || h === void 0 ? void 0 : h.feeType)))) {
    return true;
  }
  if (Array.isArray(est === null || est === void 0 ? void 0 : est.compoundingHeads) && est.compoundingHeads.some(h => checkCode((h === null || h === void 0 ? void 0 : h.taxHeadCode) || (h === null || h === void 0 ? void 0 : h.code) || (h === null || h === void 0 ? void 0 : h.feeType)))) {
    return true;
  }
  return false;
};
const ProvisionallyApprovalWarningModal = ({
  open,
  onClose,
  onProceed,
  formData,
  challanAmount: propChallanAmount
}) => {
  const {
    t
  } = useTranslation();
  const [isBlockedForVC, setIsBlockedForVC] = useState(false);
  useEffect(function () {
    if (!open) return;
    var isCompounding = isCompoundingFile(formData);
    var taxHeads = getTaxHeadEstimates(formData);
    var fee2Estimate = null;
    for (var i = 0; i < taxHeads.length; i++) {
      if (isFee2Match(taxHeads[i], isCompounding)) {
        fee2Estimate = taxHeads[i];
        break;
      }
    }
    var fee2Amount = fee2Estimate ? parseFloat(fee2Estimate.estimateAmount || 0) : 0;
    var hasFee2 = Boolean(fee2Estimate) && !isNaN(fee2Amount) && fee2Amount > 0;
    if (hasFee2) {
      if (onProceed) onProceed();
      if (onClose) onClose();
    } else {
      setIsBlockedForVC(true);
    }
  }, [open, formData]);
  if (!isBlockedForVC) return null;
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: Boolean(open),
    onClose: onClose,
    maxWidth: "xs",
    fullWidth: true,
    PaperProps: {
      sx: {
        borderRadius: "12px",
        p: 0,
        boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      py: 2,
      px: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #FEE2E2",
      backgroundColor: "#FFF5F5"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(WarningAmberIcon, {
    sx: {
      fontSize: 26,
      color: "#DC2626",
      mr: 1.2
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      fontWeight: 700,
      color: "#991B1B",
      fontSize: "18px"
    }
  }, t("ACTION_NOT_ALLOWED", "Action Not Allowed"))), /*#__PURE__*/React__default.createElement(IconButton$1, {
    "aria-label": "close",
    onClick: onClose,
    size: "small",
    sx: {
      color: "#991B1B",
      p: 0.5,
      "&:hover": {
        color: "#7F1D1D",
        backgroundColor: "#FEE2E2"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    sx: {
      fontSize: 22
    }
  }))), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    sx: {
      pt: 3.5,
      pb: 3,
      px: 3,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(WarningBlockedIcon, null)), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#991B1B",
      textAlign: "center",
      mb: 1.2
    }
  }, t("PROV_APPROVAL_NOT_ALLOWED_TITLE", "Provisional Approval Cannot Be Taken")), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "15px",
      color: "#475569",
      textAlign: "center",
      lineHeight: 1.6,
      fontWeight: 500,
      maxWidth: "420px"
    }
  }, t("VC_PROV_APPROVAL_TWO_TAXHEADS_REQUIRED", "FEES NOT GENERATED OR NOT PAID"))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      borderTop: "1px solid #FEE2E2",
      width: "100%"
    }
  }), /*#__PURE__*/React__default.createElement(DialogActions, {
    sx: {
      justifyContent: "center",
      py: 2,
      px: 3,
      backgroundColor: "#FFF5F5"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: onClose,
    sx: {
      backgroundColor: "#DC2626",
      color: "#FFFFFF",
      fontWeight: 700,
      fontSize: "15px",
      px: 5,
      py: 0.9,
      borderRadius: "6px",
      textTransform: "none",
      minWidth: "120px",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      "&:hover": {
        backgroundColor: "#B91C1C",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
      }
    }
  }, t("CLOSE", "Close"))));
};

const OnSelectActionDropdown = ({
  actions,
  currentAction,
  onChange,
  formData,
  challanAmount,
  children
}) => {
  const {
    t
  } = useTranslation();
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  const [pendingEvent, setPendingEvent] = useState(null);
  const handleActionChange = event => {
    var _event$target;
    const value = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    const actionName = typeof value === "object" ? value === null || value === void 0 ? void 0 : value.action : value;
    if (actionName === "PROVISIONALLY_APPROVAL") {
      setPendingEvent(event);
      setWarningModalOpen(true);
      return;
    }
    if (onChange) {
      onChange(event);
    }
  };
  const handleProceedWarning = () => {
    setWarningModalOpen(false);
    if (pendingEvent && onChange) {
      onChange(pendingEvent);
    }
    setPendingEvent(null);
  };
  const handleCloseWarning = () => {
    setWarningModalOpen(false);
    setPendingEvent(null);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1,
    style: {
      margin: "4px 0px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2",
    style: {
      display: "flex",
      paddinfLeft: "4px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginLeft: "30px"
    }
  }, "Action ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10",
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(FormControl$2, {
    sx: {
      m: 1,
      minWidth: 120
    },
    size: "small"
  }, /*#__PURE__*/React__default.createElement(Select$3, {
    value: currentAction,
    label: "Select Action",
    onChange: handleActionChange,
    sx: {
      width: "18.25vw",
      borderRadius: "1px"
    },
    size: "small",
    variant: "outlined",
    required: false,
    input: /*#__PURE__*/React__default.createElement(OutlinedInput, null),
    renderValue: selected => {
      if (!selected) {
        return /*#__PURE__*/React__default.createElement("p", null, "Select Action");
      }
      const actionName = typeof selected === "object" ? selected === null || selected === void 0 ? void 0 : selected.action : selected;
      if (!actionName || actionName === " ") {
        return /*#__PURE__*/React__default.createElement("p", null, "Select Action");
      }
      return t(actionName);
    }
  }, /*#__PURE__*/React__default.createElement(StyledMenuItem, {
    disabled: true,
    value: "",
    key: "Select Action"
  }, /*#__PURE__*/React__default.createElement("em", null, "Select Action")), actions && (actions === null || actions === void 0 ? void 0 : actions.map(item => {
    const dropdowns = item === null || item === void 0 ? void 0 : item.action;
    return /*#__PURE__*/React__default.createElement(StyledMenuItem, {
      value: item,
      key: dropdowns
    }, t(`${dropdowns}`));
  })))), children)), /*#__PURE__*/React__default.createElement(ProvisionallyApprovalWarningModal, {
    open: warningModalOpen,
    onClose: handleCloseWarning,
    onProceed: handleProceedWarning,
    formData: formData,
    challanAmount: challanAmount
  }));
};

const types$6 = {
  UPDATE_DOCUMENT: "UPDATE_DOCUMENT"
};
const updateDocument = doc => ({
  type: types$6.UPDATE_DOCUMENT,
  payload: doc
});

const RemarksDialog = ({
  open,
  handleClose,
  doc
}) => {
  var _doc$additionalDetail, _doc$additionalDetail2;
  const {
    control,
    handleSubmit
  } = useForm();
  const dispatch = useDispatch();
  console.log("docInDIalog", doc);
  const onSubmit = data => {
    console.log("dataFromModalBefore", data);
    data = {
      ...doc,
      ...data
    };
    console.log("dataFromModalAfter", data);
    dispatch(updateDocument(data));
    handleClose();
  };
  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    PaperProps: {
      style: {
        maxWidth: "70%",
        width: "70%"
      },
      component: "form",
      onSubmit: event => {
        event.preventDefault();
        handleSubmit(onSubmit)(event);
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    style: {
      backgroundColor: "#1f4a7c",
      color: "white"
    }
  }, (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.title) || (doc === null || doc === void 0 ? void 0 : doc.documentType)), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail2 = doc.additionalDetails) === null || _doc$additionalDetail2 === void 0 ? void 0 : _doc$additionalDetail2.title) || (doc === null || doc === void 0 ? void 0 : doc.documentType)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "remarks",
    multiLine: true,
    placeholder: "Enter remarks",
    mandatory: true,
    inputClassName: "document-remark",
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))))), /*#__PURE__*/React__default.createElement(DialogActions$1, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClose
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit"
  }, "Save")));
};

function SortingAlphabatically(list) {
  if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
    return list === null || list === void 0 ? void 0 : list.sort((a, b) => {
      var _a$value;
      return a === null || a === void 0 ? void 0 : (_a$value = a.value) === null || _a$value === void 0 ? void 0 : _a$value.localeCompare(b.value);
    });
  } else {
    return null;
  }
}

const DocumentSection = ({
  formData,
  setUpdatedDocuments,
  updatedDocuments,
  handleChange,
  isCitizen,
  setIsPreviewLoading,
  setDataRecommendation,
  dataRecommendation,
  callDocumentDetailsAPI,
  onSelect,
  handleNoWorkflow,
  attachedDocs,
  docType: _docType = "mandatory",
  detailData,
  ComposableComponent: _ComposableComponent = false,
  formType: _formType = "COMMON",
  developerRemarks,
  setError,
  isNocModule: _isNocModule = false,
  isFromDashboard: _isFromDashboard = false,
  setDeveloperRemarks: _setDeveloperRemarks = null
}) => {
  var _detailData, _detailData$documentD;
  console.log("fromstep2new", formData, detailData, _isNocModule);
  const {
    documents
  } = useSelector(state => state.formMT);
  const logApiDocs = detailData === null || detailData === void 0 ? void 0 : (_detailData = detailData[(detailData === null || detailData === void 0 ? void 0 : detailData.length) - 1]) === null || _detailData === void 0 ? void 0 : (_detailData$documentD = _detailData.documentDetails) === null || _detailData$documentD === void 0 ? void 0 : _detailData$documentD.documents;
  const defaultValues = {};
  const Modal = useModal();
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    reset,
    trigger
  } = useForm({
    defaultValues
  });
  console.log("loggingAttachedDocs", attachedDocs, logApiDocs, logApiDocs === null || logApiDocs === void 0 ? void 0 : logApiDocs.length);
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto"];
  if (_formType !== "LANDUSE") {
    excludedTypes.push("kmlFile");
    excludedTypesForDocSection.push("kmlFile");
  }
  const isSitePhotoDoc = type => {
    var _type$toLowerCase;
    return type === "sitePhoto" || (type === null || type === void 0 ? void 0 : (_type$toLowerCase = type.toLowerCase()) === null || _type$toLowerCase === void 0 ? void 0 : _type$toLowerCase.startsWith("sitephoto"));
  };
  const documentSection = attachedDocs === null || attachedDocs === void 0 ? void 0 : attachedDocs.filter(doc => !excludedTypes.includes(doc.documentType) && !isSitePhotoDoc(doc.documentType) && doc.isNoc !== "true");
  const applicantPhoto = attachedDocs === null || attachedDocs === void 0 ? void 0 : attachedDocs.filter(doc => doc.documentType === "applicantPhoto" && doc.isNoc !== "true");
  const docSection = attachedDocs === null || attachedDocs === void 0 ? void 0 : attachedDocs.filter(doc => {
    var _doc$documentType, _doc$documentType$spl;
    return !excludedTypesForDocSection.includes(doc.documentType) && !isSitePhotoDoc(doc.documentType) && doc.isNoc !== "true" && !((doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : (_doc$documentType$spl = _doc$documentType.split("_")) === null || _doc$documentType$spl === void 0 ? void 0 : _doc$documentType$spl.length) > 1) && (_docType === "mandatory" ? doc.isMandatory || doc.documentType === "Experience Certificate" : !doc.isMandatory);
  });
  const documentHistoryByType = (attachedDocs || []).reduce((history, doc) => {
    var _doc$documentType2;
    const match = doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.match(/^(.*)_(\d+)$/);
    if (match && doc.isNoc !== "true") {
      const latestDocumentType = match[1];
      history[latestDocumentType] = [...(history[latestDocumentType] || []), doc];
    }
    return history;
  }, {});
  const hasDocumentHistory = Object.keys(documentHistoryByType).some(documentType => docSection === null || docSection === void 0 ? void 0 : docSection.some(doc => doc.documentType === documentType));
  console.log("DOC SECITON 74", docSection, _docType, attachedDocs, _formType, hasDocumentHistory);
  const remainingDocTypes = ["signature", "applicantPhoto", "sitePhoto"];
  if (_formType !== "LANDUSE") remainingDocTypes.push("kmlFile");
  const remainingDocs = attachedDocs === null || attachedDocs === void 0 ? void 0 : attachedDocs.filter(doc => remainingDocTypes.includes(doc.documentType) && doc.isNoc !== "true");
  const sitePhotoDocs = (attachedDocs || (formData === null || formData === void 0 ? void 0 : formData.documents) || []).filter(doc => isSitePhotoDoc(doc === null || doc === void 0 ? void 0 : doc.documentType) && (doc === null || doc === void 0 ? void 0 : doc.isNoc) !== "true");
  const [open, setOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saveRecommendation, setSaveRecommendation] = useState(false);
  const [renderedDocs, setRenderedDocs] = useState([]);
  const [finalDocuments, setFinalDocuments] = useState(documentSection || []);
  const officerRemarks = useSelector(state => state.remarksDialog);
  console.log("officerRemarksFromDialog", officerRemarks);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const handleClose = () => {
    setOpen(false);
  };
  const escapeHtml = value => String(value || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  const showDocumentHistory = doc => {
    const history = documentHistoryByType[doc.documentType] || [];
    const historyHtml = history.length ? `
      <div style="width:100%;overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:14px;">
          <thead>
            <tr>
              <th style="
                padding:10px;
                border:1px solid #ddd;
                background:#f5f5f5;
                text-align:center;
                font-weight:600;
              ">
                Submission
              </th>

              <th style="
                padding:10px;
                border:1px solid #ddd;
                background:#f5f5f5;
                text-align:left;
                font-weight:600;
              ">
                Name
              </th>

              <th style="
                padding:10px;
                border:1px solid #ddd;
                background:#f5f5f5;
                text-align:center;
                font-weight:600;
              ">
                View Document
              </th>
            </tr>
          </thead>

          <tbody>
            ${history.map(historyDoc => {
      var _historyDoc$documentT, _historyDoc$documentT2, _historyDoc$additiona;
      const submissionNumber = ((_historyDoc$documentT = historyDoc.documentType) === null || _historyDoc$documentT === void 0 ? void 0 : (_historyDoc$documentT2 = _historyDoc$documentT.split("_")) === null || _historyDoc$documentT2 === void 0 ? void 0 : _historyDoc$documentT2.pop()) || "";
      return `
                  <tr>
                    <td style="
                      padding:10px;
                      border:1px solid #ddd;
                      text-align:center;
                    ">
                      Submission ${escapeHtml(submissionNumber)}
                    </td>

                    <td style="
                      padding:10px;
                      border:1px solid #ddd;
                      text-align:left;
                    ">
                      ${escapeHtml(((_historyDoc$additiona = historyDoc.additionalDetails) === null || _historyDoc$additiona === void 0 ? void 0 : _historyDoc$additiona.title) || "-")}
                    </td>

                    <td style="
                      padding:10px;
                      border:1px solid #ddd;
                      text-align:center;
                    ">
                      <a
                        href="javascript:void(0)"
                        class="document-history-view"
                        data-file-store-id="${escapeHtml(historyDoc.fileStoreId)}"
                        style="
                          color:#1976d2;
                          text-decoration:none;
                          cursor:pointer;
                          display:inline-flex;
                          align-items:center;
                          gap:5px;
                        "
                      >
                        <span style="font-size:16px;">&#128065;</span>
                        View
                      </a>
                    </td>
                  </tr>
                `;
    }).join("")}
          </tbody>
        </table>
      </div>
    ` : "No document history found.";
    Modal("Document History", historyHtml, "info", undefined, undefined, "Close", popup => {
      popup.querySelectorAll(".document-history-view").forEach(historyItem => {
        historyItem.addEventListener("click", () => {
          getDocumentByFileStoreId(historyItem.dataset.fileStoreId, setIsPreviewLoading);
        });
      });
    });
  };
  console.log("formdartaFromDOcs", formData);
  function updateFinalDocs(documentSection, updateObject) {
    const seen = new Set();
    return documentSection.map(doc => {
      const statusKey = `${doc.documentType}documentStatus`;
      const remarksKey = `${doc.documentType}documentRemarks`;
      return {
        ...doc,
        documentStatus: updateObject[statusKey] || doc.documentStatus,
        documentRemarks: updateObject[remarksKey] || doc.documentRemarks
      };
    }).filter(doc => {
      if (!doc.fileStoreId || seen.has(doc.fileStoreId)) return false;
      seen.add(doc.fileStoreId);
      return true;
    });
  }
  const onSubmit = async data => {
    var _formData$documents;
    console.log("dataFromSubmitDocs", data, finalDocuments);
    if (_docType === "mandatory") {
      if (!developerRemarks) {
        setError(true);
        return;
      } else {
        if (_setDeveloperRemarks) {
          _setDeveloperRemarks(developerRemarks);
        }
        setError(false);
      }
    }
    const nocDocuments = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => doc.isNoc === "true")) || [];
    const result = updateFinalDocs(documentSection, data);
    console.log("RESULT GOOOTR", result);
    const filteredResult = result.filter(doc => !excludedTypesForDocSection.some(excludedType => {
      var _doc$documentType3;
      return (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.startsWith(excludedType);
    }));
    console.log("FILTERED", filteredResult);
    const hasNonAcceptedDocs = filteredResult.some(doc => {
      const isNumberedDocument = /_[1-6]$/.test(doc.documentType);
      return !isNumberedDocument && doc.documentStatus === "Not accepted";
    });
    if (hasNonAcceptedDocs && (data === null || data === void 0 ? void 0 : data.recommendation) === "Approval") {
      Modal("Unauthorized Action", "This action is prohibited as some of the documents are marked as Not Accepted.", "error");
      return;
    }
    const finalResult = [...result, ...applicantPhoto, ...remainingDocs, ...sitePhotoDocs];
    const allFinalDocs = [...result, ...remainingDocs, ...nocDocuments, ...sitePhotoDocs];
    const seenMap = new Map();
    allFinalDocs.forEach(d => {
      if (d) {
        const key = d.fileStoreId || d.documentType;
        if (key && !seenMap.has(key)) {
          seenMap.set(key, d);
        } else if (!key) {
          seenMap.set(Math.random(), d);
        }
      }
    });
    const finalResultupdated = Array.from(seenMap.values());
    const recommendationValue = data === null || data === void 0 ? void 0 : data.recommendation;
    await callDocumentDetailsAPI(developerRemarks, recommendationValue, finalResult);
    setUpdatedDocuments(finalResult);
    setDataRecommendation(recommendationValue);
    handleNoWorkflow(finalResultupdated);
  };
  const handleBlurEvent = (e, doc) => {
    const fileStoreId = doc.fileStoreId;
    const {
      name,
      value
    } = e.target;
    const fieldName = name !== null && name !== void 0 && name.includes("Status") ? "documentStatus" : "documentRemarks";
    console.log("nameFromEVnt", name, value, fileStoreId, fieldName);
    if (fieldName) {
      console.log("nameFromEvent:", name, value, fileStoreId, fieldName);
      const index = documentSection.findIndex(doc => doc.fileStoreId === fileStoreId);
      const watchRemark = watch(`${doc.documentType}documentRemarks`);
      const watchStatus = watch(`${doc.documentType}documentStatus`);
      console.log("watchRemark", watchRemark);
      if (index !== -1) {
        const updatedDoc = {
          ...documentSection[index],
          documentRemarks: watchRemark,
          documentStatus: watchStatus
        };
        console.log("updatedNewDoc:", updatedDoc);
        setFinalDocuments(prev => [...prev, updatedDoc]);
      }
    } else {
      console.warn("Invalid field name:", name);
    }
  };
  const handleStatusChange = (e, doc) => {
    var _e$target$name;
    const isRemarkValidation = (_e$target$name = e.target.name) === null || _e$target$name === void 0 ? void 0 : _e$target$name.includes("Remarks");
    if (!isRemarkValidation) {
      const status = getValues(`${doc.documentType}documentStatus`);
      const docType = doc.documentType;
      console.log("fromStatusChange", doc.documentType, status);
      if (status == "Accepted") {
        setValue(`${doc.documentType}documentRemarks`, "Document accepted", {
          shouldValidate: true
        });
        trigger(`${doc.documentType}documentRemarks`);
        const watchRemark = watch(`${docType}documentRemarks`);
        const watchStatus = watch(`${docType}documentStatus`);
        console.log("watchRemark", watchRemark);
        const index = documentSection.findIndex(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) === doc.fileStoreId);
        const updatedDoc = {
          ...documentSection[index],
          documentRemarks: watchRemark,
          documentStatus: watchStatus
        };
        console.log("updatedNewDocFromStatus", updatedDoc);
      }
    } else {
      return;
    }
  };
  const handleOthersCase = doc => {
    const remarks = getValues(`${doc.documentType}documentRemarks`);
    if (remarks == "Others") {
      setSelectedDoc(doc);
      setOpen(true);
    } else {
      return;
    }
  };
  const handleChangeEvent = (e, doc) => {
    console.log("fromCHangeEvent", e.target.name, e.target.value);
    handleStatusChange(e, doc);
    handleOthersCase(doc);
    handleBlurEvent(e, doc);
  };
  const documentStatuses = docSection === null || docSection === void 0 ? void 0 : docSection.map(doc => watch(`${doc.documentType}documentStatus`) || doc.documentStatus);
  const allAccepted = (documentStatuses === null || documentStatuses === void 0 ? void 0 : documentStatuses.length) > 0 && (documentStatuses === null || documentStatuses === void 0 ? void 0 : documentStatuses.every(status => status === "Accepted"));
  const hasNotAccepted = documentStatuses === null || documentStatuses === void 0 ? void 0 : documentStatuses.some(status => status === "Not accepted");
  const filteredRecommendationOptions = siteInspRecommendation === null || siteInspRecommendation === void 0 ? void 0 : siteInspRecommendation.filter(item => {
    if (allAccepted) {
      return item.value === "Approval";
    }
    if (hasNotAccepted) {
      return item.value !== "Approval";
    }
    return true;
  });
  useEffect(() => {
    if (officerRemarks !== null && officerRemarks !== void 0 && officerRemarks.id) {
      setValue(`${officerRemarks === null || officerRemarks === void 0 ? void 0 : officerRemarks.documentType}documentRemarks`, officerRemarks === null || officerRemarks === void 0 ? void 0 : officerRemarks.remarks, {
        shouldValidate: true
      });
      trigger(`${officerRemarks === null || officerRemarks === void 0 ? void 0 : officerRemarks.documentType}documentRemarks`);
    }
  }, [officerRemarks.id]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: ""
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "customhead",
    style: {
      backgroundColor: "#1F4A7C",
      color: "#fff",
      height: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Sr.no"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Document Name"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Status"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Remarks"), hasDocumentHistory && /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Document History"))), /*#__PURE__*/React__default.createElement("tbody", null, (docSection === null || docSection === void 0 ? void 0 : docSection.length) > 0 ? docSection === null || docSection === void 0 ? void 0 : docSection.map((doc, index) => {
    var _doc$additionalDetail, _documentHistoryByTyp, _doc$additionalDetail2;
    const isRecommended = watch(`${doc.documentType}documentStatus`) === "Accepted";
    console.log("isRecommended", isRecommended, doc.documentType, doc.documentStatus, doc.documentRemarks);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: `${index}_${doc.id}`
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React__default.createElement("a", {
      style: {
        cursor: "pointer",
        textDecoration: "none",
        color: "blue"
      },
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading),
      className: "far-link"
    }, (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.title) || (doc === null || doc === void 0 ? void 0 : doc.documentType))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      onBlur: e => handleChangeEvent(e, doc),
      hasLabel: false,
      type: "selectInput",
      height: "24px",
      control: control,
      data: SortingAlphabatically(recommendation),
      placeholder: "Select document status",
      name: `${doc.documentType}documentStatus`,
      defaultValue: doc.documentStatus || "",
      mandatory: true,
      disabled: _isNocModule,
      width: "100%",
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      onBlur: e => handleChangeEvent(e, doc),
      hasLabel: false,
      height: "24px",
      type: "selectInput",
      control: control,
      name: `${doc.documentType}documentRemarks`,
      defaultValue: doc.documentRemarks || "",
      placeholder: "Enter remarks",
      data: remarks,
      disabled: isRecommended || _isNocModule,
      mandatory: true,
      width: "100%",
      validation: {
        required: {
          value: true,
          message: "Please select remarks"
        }
      }
    }))), hasDocumentHistory && /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center",
        verticalAlign: "middle"
      }
    }, ((_documentHistoryByTyp = documentHistoryByType[doc.documentType]) === null || _documentHistoryByTyp === void 0 ? void 0 : _documentHistoryByTyp.length) > 0 && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      "aria-label": `View history for ${((_doc$additionalDetail2 = doc.additionalDetails) === null || _doc$additionalDetail2 === void 0 ? void 0 : _doc$additionalDetail2.title) || doc.documentType}`,
      title: "View document history",
      onClick: () => showDocumentHistory(doc),
      style: {
        border: "1px solid #1F4A7C",
        borderRadius: "50%",
        backgroundColor: "#fff",
        color: "#1F4A7C",
        fontWeight: "bold",
        width: "24px",
        height: "24px",
        lineHeight: "20px",
        padding: 0,
        cursor: "pointer"
      }
    }, "i")));
  }) : /*#__PURE__*/React__default.createElement("div", null, "No conditional document attached")))), _ComposableComponent && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "24px"
    }
  }, _ComposableComponent({
    control,
    options: filteredRecommendationOptions
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginTop: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    control: control,
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  }))), /*#__PURE__*/React__default.createElement(RemarksDialog, {
    open: open,
    handleClose: handleClose,
    doc: selectedDoc
  }));
};

const ChatboardCorrespondenceApplicant = ({
  formData
}) => {
  var _userRolesArray$, _userRolesArray$2, _chatBoardHistoryData, _formData$auditDetail, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$professiona;
  const {
    t
  } = useTranslation();
  const Modal = useModal();
  const [content, setContent] = useState("");
  const [chatBoardDataRemarks, setChatBoardDataRemarks] = useState({});
  const [chatBoardHistoryData, setChatBoardHistoryData] = useState({});
  const [loader, setLoader] = useState(false);
  const userData = Digit.UserService.getUser() || {};
  const userInfo = (userData === null || userData === void 0 ? void 0 : userData.info) || {};
  const authToken = (userData === null || userData === void 0 ? void 0 : userData.access_token) || null;
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code;
  const designation = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.name;
  const [developerRemarks, setDeveloperRemarks] = React__default.useState("");
  const [messageTo, setMessageTo] = React__default.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [chatBoardDocs, setChatBoardDocs] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [error, setError] = useState(null);
  const openPopup = item => {
    debugger;
    let rows = [];
    rows = (item === null || item === void 0 ? void 0 : item.documentId) || [];
    setShowPopup(true);
    setSelectedDetails(rows);
    setCreatedTime((item === null || item === void 0 ? void 0 : item.createdOn) || null);
    setPopupData(item);
  };
  console.log("slectedDetails", selectedDetails);
  const printPopup = () => {
    debugger;
    const popupContent = document.getElementById("popup-print-content");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Details</title>
          <style>
            body { font-size: 11px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #e2e8f0; font-size: 13px; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const closePopup = () => {
    setShowPopup(false);
    setSelectedDetails([]);
    setPopupData(null);
  };
  const handlemodalAttachment = e => {
    setUploadedFileAttachment("AttachmentOPen");
  };
  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };
  const onMessageToChange = e => {
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };
  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken
      },
      egScrutiny: {
        applicationId: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: true,
        userid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
        serviceId: 123,
        documentId: chatBoardDocs,
        bussinessServiceName: formData === null || formData === void 0 ? void 0 : formData.businessService,
        designation: designation,
        name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) || null,
        employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
        role: filterDataRole,
        applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
      }
    };
    try {
      const Resp = await axios$1.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then(response => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Application Chat Board", `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) Chat Board</strong> Successfully!`, "success");
    await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo), handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  };
  const handleGetRemarkssValues = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.land.chatBoard_data_search}=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      setChatBoardDataRemarks(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetHistoryRemarkssValues = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.land.chatBoard_data_search3}=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      setChatBoardHistoryData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const [post, setPost] = useState({
    content: "",
    hearingDate: ""
  });
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _tenantId, _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || ((_tenantId = tenantId) === null || _tenantId === void 0 ? void 0 : _tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  useEffect(() => {
    updateCheckBoxSize();
  }, []);
  const updateCheckBoxSize = () => {
    var eles = document.querySelectorAll(".custom-checkbox");
    var index = 0,
      length = eles.length;
    for (; index < length; index++) {
      eles[index].style.width = "20px";
      eles[index].style.height = "20px";
      eles[index].style.marginTop = "5px";
    }
  };
  useEffect(() => {
    const fetchRemarks = async () => {
      if (!(formData !== null && formData !== void 0 && formData.applicationNo)) return;
      try {
        await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
        await handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };
    fetchRemarks();
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  let egScrutinyData = chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : (_chatBoardHistoryData = chatBoardHistoryData.egScrutiny) === null || _chatBoardHistoryData === void 0 ? void 0 : _chatBoardHistoryData.filter(e => !(e.fieldIdL === "Department" && e.name !== "CITIZEN"));
  console.log("egScrutinyDataApplicant", egScrutinyData);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      fontFamily: "Roboto",
      height: "44px",
      padding: "10px",
      color: "#fff"
    }
  }, "Application Details"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    className: "common-app-form"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Submitted On:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, ConvertEpochToDate(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime)), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Owner/Applicant:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Architect:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "13px",
      paddingBottom: "3px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Project Type:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px",
      paddingBottom: "3px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationType))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      paddingLeft: "20px",
      paddingTop: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Message To")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 18,
    md: 9
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    className: "form-field",
    label: `Department`,
    onChange: onMessageToChange,
    checked: developerChecked,
    style: {
      marginLeft: "25px",
      paddingTop: "3px",
      fontSize: "14px",
      paddingLeft: "10px"
    }
  })))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }), uploadedFileAttachment === "AttachmentOPen" && /*#__PURE__*/React__default.createElement(Box$2, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 3"
  }, " Document /Certificate"), /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 9"
  }, /*#__PURE__*/React__default.createElement(FileUploaderNew, {
    validationMsg: "(jpg, jpeg, pdf, png file only and Max file Size 30 MB)",
    tab: 2,
    maxFiles: 5,
    uploadedDocs: chatBoardDocs,
    setUploadedDocs: setChatBoardDocs
  }))), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: 20,
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalsubmit
  }, "Send"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "10px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: closeEditor
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "70px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalAttachment
  }, "Attachment")), formData && egScrutinyData && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      fontFamily: "Roboto",
      padding: "10px",
      color: "#fff"
    }
  }, "History Of Web Message"), /*#__PURE__*/React__default.createElement("section", {
    className: "remarks-table"
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Sr. No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "AssignTo"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Message To"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Message"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "File Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Created By"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Date"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Attachments"))), /*#__PURE__*/React__default.createElement("tbody", null, egScrutinyData === null || egScrutinyData === void 0 ? void 0 : egScrutinyData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, " ", item !== null && item !== void 0 && item.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item === null || item === void 0 ? void 0 : item.fieldIdL}`), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, item === null || item === void 0 ? void 0 : item.fieldIdL), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: item === null || item === void 0 ? void 0 : item.comment
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, item === null || item === void 0 ? void 0 : item.applicationId), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, item === null || item === void 0 ? void 0 : item.employeeName, ",(", item === null || item === void 0 ? void 0 : item.designation, ")"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "12px"
    }
  }, " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: item === null || item === void 0 ? void 0 : item.createdOn
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => openPopup(item),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
    fontSize: "small"
  }))))))))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "60%",
      transform: "translateX(-50%)",
      backgroundColor: "#f3f4f6",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px"
    }
  }, "Document Details"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon$1, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "popup-print-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.employeeName) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.designation) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Role:"), " ", (popupData === null || popupData === void 0 ? void 0 : popupData.role) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Created At:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: createdTime
  })), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Document Type"), /*#__PURE__*/React__default.createElement("th", null, "File Name"))), /*#__PURE__*/React__default.createElement("tbody", null, selectedDetails === null || selectedDetails === void 0 ? void 0 : selectedDetails.map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.documentType), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.documentUrl) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: row.documentUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    style: {
      marginLeft: 8
    },
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })))))))))));
};

const SelectMandatoryConditions2 = ({
  setMandatoryCondition,
  tenantId,
  setCurrentTab
}) => {
  const {
    control,
    watch,
    handleSubmit
  } = useForm();
  const Modal = useModal();
  const {
    data: {
      BPA: {
        MandatoryConditions: mandatoryConditions
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MandatoryConditions"]);
  console.log("loggingFrom2Mandatory", mandatoryConditions);
  const onSubmit = payload => {
    payload = Object.fromEntries(Object.entries(payload).filter(([key, value]) => value === true));
    setMandatoryCondition(payload);
    Modal("Conditions saved", "Mandatory conditions details are saved.", "success");
    setCurrentTab(0);
    console.log("payloadFromMandatory", payload);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Conditions"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content",
      padding: "4px"
    }
  }, "Select if applicable"))), /*#__PURE__*/React__default.createElement("tbody", null, mandatoryConditions === null || mandatoryConditions === void 0 ? void 0 : mandatoryConditions.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, item.label), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: item.key,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))));
};

const citizenBaseUrl$1 = "/digit-ui/citizen";

const StyledTabPanel = styled$2(TabPanel)(() => ({
  "& .MuiBox-root": {
    padding: "1px"
  }
}));
const stripHtmlTags = html => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.innerText || tempDiv.textContent || "";
};
const FormSummary = ({
  formData,
  businessService,
  action,
  setOnAddComments,
  onActionSelect,
  showTimeLine: _showTimeLine = true,
  applicationData,
  workflowDetails,
  timelineStatusPrefix,
  isDataLoading,
  statusAttribute: _statusAttribute = "status",
  submitAction,
  actionData,
  moduleCode
}) => {
  var _Digit, _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _user$info, _user$info2, _user$info3, _user$info4, _user$info5, _formData$description7, _user$info6, _user$info7, _user$info7$roles, _Digit$UserService$ge, _formData$description8, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _formData$paymentDeta, _formData$paymentDeta2, _formData$paymentDeta3, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _formData$application, _formData$serviceType, _user$info9, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _user$info10, _user$info11, _user$info12, _user$info13, _user$info14, _user$info15, _user$info16, _user$info17, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12, _user$info18, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data15, _workflowDetails$data16, _workflowDetails$data17, _workflowDetails$data18, _user$info19, _workflowDetails$data19, _workflowDetails$data20, _workflowDetails$data21, _user$info20, _user$info21, _actions$5, _actions$6, _user$info22, _workflowDetails$data22, _workflowDetails$data23, _workflowDetails$data24, _user$info23, _workflowDetails$data25, _workflowDetails$data26, _workflowDetails$data27, _user$info24, _user$info25, _actions$7, _actions$8, _user$info26, _user$info27, _user$info28, _user$info29, _workflowDetails$data28, _workflowDetails$data29, _workflowDetails$data30, _workflowDetails$data31, _workflowDetails$data32, _workflowDetails$data33, _workflowDetails$data34, _workflowDetails$data35, _workflowDetails$data36, _user$info30, _user$info31, _user$info32, _user$info33, _user$info34, _user$info35, _user$info36, _userRolesArray$5, _user$info37, _userRolesArray$6, _userRolesArray$7, _actions$9, _fetchedPaymentData$F, _fetchedPaymentData$F2, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$description14, _user$info38, _user$info39, _user$info40, _user$info41, _formData$description15, _user$info42, _user$info43;
  const conponentPDF = useRef();
  const [officerNocDetails, setOfficerNocDetails] = useState(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.formLandUse);
  const selectChecklist = useSelector(state => state.checkList);
  const purchasableFarChecklist = useSelector(state => state.purchasableFarChecklist);
  console.log("farChecklist", purchasableFarChecklist);
  console.log("reduxLandUSe", reduxFormData, officerNocDetails);
  const [currentTab, setCurrentTab] = useState("0");
  const [mandatoryCondition, setMandatoryCondition] = useState("");
  const [reviewedData, setReviewedData] = useState(formData === null || formData === void 0 ? void 0 : formData.checklistReview);
  const [fetchedPaymentData, setFetchedPaymentData] = useState({});
  const [isNoNoc, setIsNoNoc] = useState(true);
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  console.log("reviewedData", reviewedData);
  useEffect(() => {
    !!purchasableFarChecklist.checklistReview.checklistReview ? setReviewedData(purchasableFarChecklist.checklistReview.checklistReview) : setReviewedData(formData === null || formData === void 0 ? void 0 : formData.checklistReview);
  }, [purchasableFarChecklist.checklistReview.checklistReview]);
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const {
    t
  } = useTranslation();
  const {
    id
  } = useParams();
  const history = useHistory();
  const Modal = useModal();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = stateId;
  const [showToast, setShowToast] = useState(null);
  const [remarksData, setRemarksData] = useState(null);
  const [formDataNoc, setFormDataNoc] = useState({});
  const [structureCertificateError, setStructureCertificateError] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const closeToast = () => setShowToast(null);
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const [currentAction, setCurrentAction] = useState(null);
  const [farDetails, setFarDetails] = useState({
    baseFar: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2[0]) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.baseFar) || 0,
    circleRate: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4.properties) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5[0]) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.circleRate) || 0
  });
  console.log("apptype", appType, "tenentId", tenantId, "formData", formData, "remarksData6666666666", remarksData);
  const isOwnerReg = appType === "FORM_OWNER_REGISTRATION" && (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "no";
  const isApprovedOwnerReg = appType === "FORM_OWNER_REGISTRATION" && (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "yes";
  const isPurchasableFAR = appType === "FORM_PURCHASABLE_FAR";
  const isLandUse = appType === "FORM_LANDUSE";
  let user = Digit.UserService.getUser();
  const tablist = [isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) !== "CITIZEN" && {
    label: "Application Data",
    color: "#fd6d0b"
  }, isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.type) !== "CITIZEN" && {
    label: "Documents",
    color: "fd6d0b"
  }, {
    label: "WF_TAKE_ACTION",
    color: "red"
  }, {
    label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS",
    color: "green"
  }, isApprovedOwnerReg && {
    label: "CheckList",
    color: "#fd6d0b"
  }, isLandUse && ((formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" && (user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : _user$info3.type) === "CITIZEN" || (user === null || user === void 0 ? void 0 : (_user$info4 = user.info) === null || _user$info4 === void 0 ? void 0 : _user$info4.type) !== "CITIZEN") && {
    label: "WF_NOC_FORM",
    color: "#fd6d0b"
  }, ...(isPurchasableFAR ? [{
    label: "Checklist",
    color: "#fd6d0b"
  }, ...((user === null || user === void 0 ? void 0 : (_user$info5 = user.info) === null || _user$info5 === void 0 ? void 0 : _user$info5.type) !== "CITIZEN" ? [{
    label: "FAR Details",
    color: "#fd6d0b"
  }] : [{
    label: "Fee Details",
    color: "#fd6d0b"
  }])] : []), isLandUse && (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.selectLandUse) == "Conditional Permissible" && (user === null || user === void 0 ? void 0 : (_user$info6 = user.info) === null || _user$info6 === void 0 ? void 0 : _user$info6.type) !== "CITIZEN" && {
    label: "Conditions",
    color: "#fd6d0b"
  }, {
    label: "Chatboard",
    color: "#fd6d0b"
  }].filter(Boolean);
  const userRoles = user === null || user === void 0 ? void 0 : (_user$info7 = user.info) === null || _user$info7 === void 0 ? void 0 : (_user$info7$roles = _user$info7.roles) === null || _user$info7$roles === void 0 ? void 0 : _user$info7$roles.map(e => e.code);
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const userInfo = (user === null || user === void 0 ? void 0 : user.info) || {};
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const updateOwnerCall = Digit.Hooks.obps.useObpsAPI(tenantId, "OWNER_REGISTRATION");
  const updatePurchasableFar = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  console.log("iseOwnerReg", isOwnerReg, "isApprovedOwner", isApprovedOwnerReg, "user", user, "userRolesArray", userRolesArray);
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const {
    nocDocuments,
    PrevStateDocuments,
    PrevStateNocDocuments
  } = formData;
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  const squareMeterArea = formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand.properties) === null || _formData$description8 === void 0 ? void 0 : _formData$description8[0].plotArea;
  let isbelowEE = squareMeterArea < 501;
  let isbelowEEAVP = squareMeterArea < 0;
  let isbelowTP = squareMeterArea < 501;
  let isbelowCTP = squareMeterArea < 2001;
  let isbelowVC = squareMeterArea > 2000;
  let isbelowNCTP = squareMeterArea < 501;
  let isbelowNVC = squareMeterArea > 500;
  let isbelowNVCNO = squareMeterArea > 0;
  const isEE = userRoles.includes("EE");
  const isTP = userRoles.includes("TP");
  const isCTP = userRoles.includes("CTP");
  const isVC = userRoles.includes("Vice_Chairman");
  console.log("workFlowDetails", workflowDetails);
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.filter(e => {
    if ((formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "Yes" && (formData === null || formData === void 0 ? void 0 : formData.businessService) != "BPA_FAR_AVP") {
      var _formData$description9, _formData$description10, _formData$description11, _formData$description12;
      if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand.properties) === null || _formData$description9 === void 0 ? void 0 : _formData$description9[0].landUseAsPerLayout) === "Residential") {
        if (isbelowTP && isTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowTP && isTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEE && isEE && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEE && isEE && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowCTP && isCTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (!isbelowVC && isVC && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand.properties) === null || _formData$description10 === void 0 ? void 0 : _formData$description10[0].landUseAsPerLayout) != "Residential" && (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand.properties) === null || _formData$description11 === void 0 ? void 0 : _formData$description11[0].landUseAsPerLayout) != "Commercial") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isEE && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isCTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (!isbelowNVCNO && isVC && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand.properties) === null || _formData$description12 === void 0 ? void 0 : _formData$description12[0].landUseAsPerLayout) === "Commercial") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isEE && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowNCTP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowNCTP && isCTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowNVC && isVC && e.action === "FORWARD") {
          return false;
        } else if (!isbelowNVC && isVC && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
      }
    } else if ((formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "No" && (formData === null || formData === void 0 ? void 0 : formData.businessService) != "BPA_FAR_AVP") {
      if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR") {
        if (isbelowEEAVP && isTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEEAVP && isEE && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isEE && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowEEAVP && isCTP && e.action === "FORWARD") {
          return false;
        } else if (!isbelowEEAVP && isCTP && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
        if (isbelowNVCNO && isVC && e.action === "FORWARD") {
          return false;
        } else if (!isbelowNVCNO && isVC && (e.action === "APPROVED" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECTED" || e.action === "PROVISIONALLY_APPROVAL")) {
          return false;
        }
      }
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  console.log("actionsfromSummary", actions);
  const [open, setOpen] = useState(false);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [developerRemarksValidation, setDeveloperRemarksValidation] = useState(null);
  const [purchasableFarActions, setPurchasableFarActions] = useState(null);
  const [currentActionCertification, setCurrentActionCertification] = useState(null);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [structureCertificateUrl, setStructureCertificateUrl] = useState("");
  const [structureCertificateId, setStructureCertificateId] = useState("");
  const [checked, setChecked] = React__default.useState(false);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData === null || formData === void 0 ? void 0 : formData.documents);
  setOnAddComments(developerRemarks);
  const handleRemarksValidation = () => {
    console.log("handleRenarksCalled");
    const plainText = stripHtmlTags(developerRemarks);
    if (plainText.trim().length === 0) {
      setDeveloperRemarksValidation("Developer remarks cannot be empty.");
    } else {
      setDeveloperRemarksValidation("Valid remarks entered");
    }
  };
  useEffect(() => {
    handleRemarksValidation();
  }, [developerRemarks]);
  const onRadioActionSelect = value => {
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
  };
  const onDropDownSelect = event => {
    const value = event.target.value;
    if (isPurchasableFAR) {
      console.log("radioAction", value);
      setPurchasableFarActions(value);
    } else {
      setCurrentAction(value);
    }
  };
  const [typeOfLandVolved, setTypeOfLandVolved] = useState("");
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$paymentDeta = formData.paymentDetails) === null || _formData$paymentDeta === void 0 ? void 0 : (_formData$paymentDeta2 = _formData$paymentDeta.bill) === null || _formData$paymentDeta2 === void 0 ? void 0 : (_formData$paymentDeta3 = _formData$paymentDeta2.billDetails[0]) === null || _formData$paymentDeta3 === void 0 ? void 0 : _formData$paymentDeta3.amount) || (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount);
  const handleChange = (event, nextTab) => {
    console.log("nextTab", typeof nextTab, nextTab, isApprovedOwnerReg, "owner");
    setCurrentTab(nextTab);
  };
  const handleChangeCheckBox = event => {
    setChecked(event.target.checked);
  };
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationType) === null || _formData$application === void 0 ? void 0 : _formData$application.toLowerCase()}/${formData === null || formData === void 0 ? void 0 : (_formData$serviceType = formData.serviceType) === null || _formData$serviceType === void 0 ? void 0 : _formData$serviceType.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData$audi;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(TLCaption$1, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React__default.createElement(TLCaption$1, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData$audi2, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi2 = applicationData.auditDetails) === null || _applicationData$audi2 === void 0 ? void 0 : _applicationData$audi2.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React__default.createElement(TLCaption$1, {
        data: caption
      });
    }
  };
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const tenant = Digit.ULBService.getCurrentTenantId();
  const getUserInfo = async () => {
    var _user$info8;
    const uuid = user === null || user === void 0 ? void 0 : (_user$info8 = user.info) === null || _user$info8 === void 0 ? void 0 : _user$info8.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, {
        uuid: [uuid]
      }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };
  const signatureAccess = userDetails === null || userDetails === void 0 ? void 0 : userDetails.signature;
  useEffect(() => {
    getUserInfo();
  }, [user === null || user === void 0 ? void 0 : (_user$info9 = user.info) === null || _user$info9 === void 0 ? void 0 : _user$info9.uuid]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        documentType: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        fileStoreId: doc.fileStoreId,
        fileStore: doc.fileStoreId,
        fileName: "",
        dropDownValues: {
          value: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        remarks: data[`Remarks_${i}`],
        question: data === null || data === void 0 ? void 0 : data.questionList[i].question,
        value: data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  async function submit(data) {
    console.log("isNoNOC", isNoNoc);
    if (isNoNoc && !isLowRiskCase) {
      Modal("NOC required", "Please select at least one NOC.", "error");
      return;
    }
    if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_CERTIFICATE") {
      onActionSelect(currentAction);
    }
    if (developerRemarksValidation === "Valid remarks entered") {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || []
      };
      const workflow = {
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        nocDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.nocDetails),
          ...officerNocDetails
        },
        nocOtherDetails: reduxFormData.othersDetails,
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      submitAction({
        LandUse: appData
      });
      Modal(`Application ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}ed `, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}ed </strong>Successfully!`, "success", "/digit-ui/employee");
    } else {
      console.log("developerRemarksValidation", developerRemarksValidation);
    }
  }
  async function ownerSubmit() {
    if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_CERTIFICATE") {
      onActionSelect(currentAction);
    }
    const additionalDetails = {
      ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
      fieldinspection_pending: getfeildInspection(applicationData),
      pendingapproval: getPendingApprovals() || []
    };
    const workflow = {
      action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
      comment: developerRemarks,
      comments: developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile ? [{
        documentType: currentAction + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const appData = {
      ...applicationData,
      documents: formData === null || formData === void 0 ? void 0 : formData.documents,
      additionalDetails,
      checklist: selectChecklist,
      workflow,
      action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
      comment: developerRemarks,
      assignee: null,
      wfDocuments: uploadedFile ? [{
        documentType: currentAction + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const data = {
      ...appData
    };
    await updateOwnerCall.mutate({
      ownerRegistration: data
    }, {
      onSuccess: async result => {
        var _result$ownerRegistra, _result$ownerRegistra2;
        if (result !== null && result !== void 0 && (_result$ownerRegistra = result.ownerRegistration) !== null && _result$ownerRegistra !== void 0 && (_result$ownerRegistra2 = _result$ownerRegistra[0]) !== null && _result$ownerRegistra2 !== void 0 && _result$ownerRegistra2.applicationNo) {
          let action = "";
          if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED") {
            action = "Approved";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REJECT") {
            action = "Rejected";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "SENDBACK_TO_APPLICANT") {
            action = "Sent to Applicant";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD_TO_LA_OFFICER") {
            action = "Forwarded to LA Officer";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD_TO_PROVISIONAL_APPROVED") {
            action = "Provisionally Approved";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "SENDBACK_TO_EXECUTIVE_ENGINEER") {
            action = "Sent to Executive Engineer";
          } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVE") {
            action = "Approved";
          }
          Modal(`Application ${t(action)}`, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(action)}</strong>Successfully!`, "success", "/digit-ui/employee");
        }
      }
    });
  }
  async function purchasableFarSubmit() {
    var _userRolesArray$, _userRolesArray$2, _userRolesArray$3, _applicationData$desc, _applicationData$desc2, _userRolesArray$4;
    if ((userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "JE" && (farDetails.circleRate == 0 || farDetails.circleRate == null)) {
      Modal("Circle rate is required", "Please enter circle rate in the FAR details section.", "error");
      return;
    }
    const additionalDetails = {
      ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails)
    };
    const workflow = {
      action: purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action,
      comment: remarksData ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.name}.<b>` : developerRemarks,
      comments: remarksData ? `${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.name}.<b>` : developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile ? [{
        documentType: purchasableFarActions + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const appData = {
      ...applicationData,
      documents: updatedDocuments,
      additionalDetails,
      checklist: formData === null || formData === void 0 ? void 0 : formData.checklist,
      checklistReview: reviewedData,
      descriptionOfLand: {
        properties: [{
          ...(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : (_applicationData$desc2 = _applicationData$desc.properties) === null || _applicationData$desc2 === void 0 ? void 0 : _applicationData$desc2[0]),
          baseFAR: farDetails.baseFar,
          circleRate: farDetails.circleRate
        }]
      },
      tenantId: "up",
      workflow,
      action: purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action,
      comment: remarksData ? `<br> ${developerRemarks} <b>The checklist has been edited and overridden by the ${userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$4 = userRolesArray[0]) === null || _userRolesArray$4 === void 0 ? void 0 : _userRolesArray$4.name}.<b>` : developerRemarks,
      assignee: null,
      wfDocuments: uploadedFile ? [{
        documentType: purchasableFarActions + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const data = {
      ...appData
    };
    await updatePurchasableFar.mutate({
      PurchasableFAR: data
    }, {
      onSuccess: async result => {
        var _result$PurchasableFA, _result$PurchasableFA2;
        if (result !== null && result !== void 0 && (_result$PurchasableFA = result.PurchasableFAR) !== null && _result$PurchasableFA !== void 0 && (_result$PurchasableFA2 = _result$PurchasableFA[0]) !== null && _result$PurchasableFA2 !== void 0 && _result$PurchasableFA2.applicationNo) {
          Modal(`Remarks Added`, `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> added successfully!`, "success", "/digit-ui/employee");
        }
      }
    });
    console.log("payLoadFromFarSubmit", data);
  }
  async function approvalOfLetterSubmits() {
    var _formData$description13, _Object$keys;
    console.log("isNoNOCApprovalLetter", isNoNoc);
    if ((formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.selectLandUse) == "Conditional Permissible" && ((_Object$keys = Object.keys(mandatoryCondition)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) < 1) {
      Modal("Mandatory condition is required", "Please select mandatory condition from dropdown.", "error");
      return;
    }
    if (isNoNoc && !isLowRiskCase) {
      Modal("NOC required", "Please select at least one NOC.", "error");
      return;
    }
    let currentAction = "APPROVED";
    try {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || []
      };
      const workflow = {
        action: currentAction,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        nocDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.nocDetails),
          ...officerNocDetails
        },
        mandatoryCondition: mandatoryCondition,
        action: currentAction,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const data = {
        ...appData
      };
      await updateApiCall.mutate({
        LandUse: data
      }, {
        onSuccess: async result => {
          var _result$LandUse, _result$LandUse$;
          if (result !== null && result !== void 0 && (_result$LandUse = result.LandUse) !== null && _result$LandUse !== void 0 && (_result$LandUse$ = _result$LandUse[0]) !== null && _result$LandUse$ !== void 0 && _result$LandUse$.applicationNo) {
            var _result$LandUse2, _result$LandUse2$;
            sweetalert2_all.fire({
              title: "Action Approved",
              text: `Application (${result === null || result === void 0 ? void 0 : (_result$LandUse2 = result.LandUse) === null || _result$LandUse2 === void 0 ? void 0 : (_result$LandUse2$ = _result$LandUse2[0]) === null || _result$LandUse2$ === void 0 ? void 0 : _result$LandUse2$.applicationNo}) Approved Successfully!`,
              icon: "success"
            }).then(() => {
              window.location.reload();
            });
          }
        }
      });
      console.log("loggingupdatePayloadLandUSe", data);
    } catch (error) {
      console.log(error);
    }
  }
  const viewApprovalLetter = url => {
    window.open(url, "_blank");
  };
  async function handleChangePayment() {
    var _actions$, _actions$2;
    if ((actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "MAKE_PAYMENT") {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals() || []
      };
      const workflow = {
        action: "MAKE_PAYMENT",
        comment: "Payment Done",
        comments: "Payment Done",
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: actions + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        action: "MAKE_PAYMENT",
        comments: "Payment Done",
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: actions + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      Digit.OBPSService.updateFormLandUse({
        LandUse: appData
      }, tenantId).then(result => {
        var _result$LandUse3;
        if ((result === null || result === void 0 ? void 0 : (_result$LandUse3 = result.LandUse) === null || _result$LandUse3 === void 0 ? void 0 : _result$LandUse3.length) > 0) {
          var _result$LandUse4, _result$LandUse4$;
          console.log("resultFromLandUseUpdate", result);
          setShowToast({
            key: "true",
            error: false,
            message: `Application Updated Successfully! Redirecting to the payment page...`
          });
          window.location.assign(`${citizenBaseUrl$1}/payment/collect/BPA.LAND_USE_FORM/${result === null || result === void 0 ? void 0 : (_result$LandUse4 = result.LandUse) === null || _result$LandUse4 === void 0 ? void 0 : (_result$LandUse4$ = _result$LandUse4[0]) === null || _result$LandUse4$ === void 0 ? void 0 : _result$LandUse4$.applicationNo}/${tenantId}/tenantId=${tenantId}`);
        }
      });
    }
    if ((actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action) === "MAKE_PAYMENT_APPLICATION_FEE") {
      try {
        const additionalDetails = {
          ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
          fieldinspection_pending: getfeildInspection(applicationData),
          pendingapproval: getPendingApprovals() || []
        };
        const workflow = {
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile ? [{
            documentType: actions + " DOC",
            fileName: file === null || file === void 0 ? void 0 : file.name,
            fileStoreId: uploadedFile
          }] : null
        };
        const appData = {
          ...applicationData,
          documents: formData === null || formData === void 0 ? void 0 : formData.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comments: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile ? [{
            documentType: actions + " DOC",
            fileName: file === null || file === void 0 ? void 0 : file.name,
            fileStoreId: uploadedFile
          }] : null
        };
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({
          LandUse: appData
        }, tenantId).then(result => {
          var _result$LandUse5;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse5 = result.LandUse) === null || _result$LandUse5 === void 0 ? void 0 : _result$LandUse5.length) > 0) {
            var _result$LandUse6, _result$LandUse6$, _params, _params2;
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result === null || result === void 0 ? void 0 : (_result$LandUse6 = result.LandUse) === null || _result$LandUse6 === void 0 ? void 0 : (_result$LandUse6$ = _result$LandUse6[0]) === null || _result$LandUse6$ === void 0 ? void 0 : _result$LandUse6$.applicationNo}) Updated Successfully!`
            });
            history.replace(`${citizenBaseUrl$1}/payment/collect/${(_params = params) === null || _params === void 0 ? void 0 : _params.businessService}/${(_params2 = params) === null || _params2 === void 0 ? void 0 : _params2.applicationNo}/${tenantId}/tenantId=${tenantId}`, {
              data: params
            });
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  const structuralStabilityPdf = async currentAction => {
    console.log("enter111111111", stateId, formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && signatureAccess) {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
          authToken: authToken,
          userInfo: userInfo
        }
      };
      try {
        const Resp = await axios$1.post(`${Urls$1.obps.designOfStuctural}?tenantId=hp&applicationNumber=${id}`, dataToSend).then(response => {
          return response.data;
        });
        console.log("Response From API", Resp);
        setStructureCertificateId(Resp === null || Resp === void 0 ? void 0 : Resp.fileStoreId);
        setStructureCertificateUrl(Resp === null || Resp === void 0 ? void 0 : Resp.fileStoreUrl);
        setShowTakeAction("Take_Action");
        window.open(Resp === null || Resp === void 0 ? void 0 : Resp.fileStoreUrl);
      } catch (error) {
        console.log(error);
      }
    } else {
      setStructureCertificateError("Please Upload your signature");
    }
  };
  function structuralStabilitySubmit() {
    if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && signatureAccess) {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData)
      };
      const workflow = {
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        structureCertificateUrl: structureCertificateUrl,
        structureCertificateId: structureCertificateId,
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      submitAction({
        LandUse: appData
      });
    } else {
      setStructureCertificateError("Please Upload your signature");
    }
  }
  function handleChangeForward() {
    var _actions$4;
    if ((actions === null || actions === void 0 ? void 0 : (_actions$4 = actions[0]) === null || _actions$4 === void 0 ? void 0 : _actions$4.action) === "FORWARD_TO_DEPARTMENT") {
      try {
        const additionalDetails = {
          ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
          fieldinspection_pending: getfeildInspection(applicationData),
          pendingapproval: getPendingApprovals() || []
        };
        const workflow = {
          action: "FORWARD_TO_DEPARTMENT",
          comment: developerRemarks,
          comments: developerRemarks,
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile ? [{
            documentType: actions + " DOC",
            fileName: file === null || file === void 0 ? void 0 : file.name,
            fileStoreId: uploadedFile
          }] : null
        };
        const appData = {
          ...applicationData,
          documents: formData === null || formData === void 0 ? void 0 : formData.documents,
          additionalDetails,
          workflow,
          action: "FORWARD_TO_DEPARTMENT",
          comment: developerRemarks,
          assignee: null,
          wfDocuments: uploadedFile ? [{
            documentType: actions + " DOC",
            fileName: file === null || file === void 0 ? void 0 : file.name,
            fileStoreId: uploadedFile
          }] : null
        };
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({
          LandUse: appData
        }, tenantId).then(result => {
          var _result$LandUse7;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse7 = result.LandUse) === null || _result$LandUse7 === void 0 ? void 0 : _result$LandUse7.length) > 0) {
            var _result$LandUse8, _result$LandUse8$;
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result === null || result === void 0 ? void 0 : (_result$LandUse8 = result.LandUse) === null || _result$LandUse8 === void 0 ? void 0 : (_result$LandUse8$ = _result$LandUse8[0]) === null || _result$LandUse8$ === void 0 ? void 0 : _result$LandUse8$.applicationNo}) Updated Successfully!`
            });
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  const handleClose = () => {};
  const designationName = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.timeline) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5[0]) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.assigner) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.roles) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8.find(ele => (ele === null || ele === void 0 ? void 0 : ele.code) !== "EMPLOYEE")) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.name;
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("tabListFromForm", tablist);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, tablist.map(({
    label,
    color
  }, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(label)}`,
    value: `${index}`,
    sx: {
      textTransform: "none",
      p: "0 1rem",
      color
    }
  }))), isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info10 = user.info) === null || _user$info10 === void 0 ? void 0 : _user$info10.type) !== "CITIZEN" && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: "0"
  }, /*#__PURE__*/React__default.createElement(Summary$1, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  })), isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info11 = user.info) === null || _user$info11 === void 0 ? void 0 : _user$info11.type) !== "CITIZEN" && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: "1"
  }, /*#__PURE__*/React__default.createElement(DocumentSection, {
    formData: formData,
    setUpdatedDocuments: setUpdatedDocuments,
    updatedDocuments: updatedDocuments,
    handleChange: handleChange,
    isCitizen: (user === null || user === void 0 ? void 0 : (_user$info12 = user.info) === null || _user$info12 === void 0 ? void 0 : _user$info12.type) === "CITIZEN"
  })), /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: (user === null || user === void 0 ? void 0 : (_user$info13 = user.info) === null || _user$info13 === void 0 ? void 0 : _user$info13.type) === "CITIZEN" ? "0" : !isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info14 = user.info) === null || _user$info14 === void 0 ? void 0 : _user$info14.type) === "EMPLOYEE" ? "0" : "2",
    style: {
      marginBottom: "30px"
    }
  }, (user === null || user === void 0 ? void 0 : (_user$info15 = user.info) === null || _user$info15 === void 0 ? void 0 : _user$info15.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
    formData: formData
  }), (user === null || user === void 0 ? void 0 : (_user$info16 = user.info) === null || _user$info16 === void 0 ? void 0 : _user$info16.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EmployeeComponent, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }), isLandUse && (formData === null || formData === void 0 ? void 0 : formData.status) != "APPROVED" && /*#__PURE__*/React__default.createElement(Card, {
    style: {
      color: "red"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(FormGroup, null, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: checked,
      onChange: handleChangeCheckBox,
      inputProps: {
        "aria-label": "controlled"
      }
    }),
    label: "I, hereby, certify that all the information filled the Application Form by Applicant, has been checked and verified by me and the NOC checklist mentioned above are complete as per the applicable rules and Bylaws."
  }))), checked === false && /*#__PURE__*/React__default.createElement("p", null, "Please review the NOC checklist and select the applicable items to complete the form verification."))), userRoles.includes("BPA_STRUCTURALENGINEER") && (user === null || user === void 0 ? void 0 : (_user$info17 = user.info) === null || _user$info17 === void 0 ? void 0 : _user$info17.type) === "CITIZEN" && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : (_workflowDetails$data11 = _workflowDetails$data10.nextActions) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11[0]) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Structural, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }), (userRoles.includes("BPA_ARCHITECT") || userRoles.includes("BPA_TOWNPLANNER") || userRoles.includes("BPA_ENGINEER") || userRoles.includes("BPA_ARCHITECT_ASSISTANT") || userRoles.includes("BPA_ENGINEER_DIPLOMA") || userRoles.includes("BPA_DRAUGHTSMAN") || userRoles.includes("BPA_SURVEYOR")) && (user === null || user === void 0 ? void 0 : (_user$info18 = user.info) === null || _user$info18 === void 0 ? void 0 : _user$info18.type) === "CITIZEN" && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : (_workflowDetails$data15 = _workflowDetails$data14[0]) === null || _workflowDetails$data15 === void 0 ? void 0 : _workflowDetails$data15.action) != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Architect, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    actions: actions
  }), (formData === null || formData === void 0 ? void 0 : formData.applicationType) != "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, (userRoles.includes("BPA_STRUCTURALENGINEER") && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data16 = workflowDetails.data) === null || _workflowDetails$data16 === void 0 ? void 0 : (_workflowDetails$data17 = _workflowDetails$data16.nextActions) === null || _workflowDetails$data17 === void 0 ? void 0 : (_workflowDetails$data18 = _workflowDetails$data17[0]) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" || (user === null || user === void 0 ? void 0 : (_user$info19 = user.info) === null || _user$info19 === void 0 ? void 0 : _user$info19.type) === "EMPLOYEE") && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Action ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: false,
    options: actions,
    selectedOption: currentAction || purchasableFarActions,
    optionsKey: "action",
    onSelect: onRadioActionSelect,
    style: {
      display: "flex",
      gap: "3rem",
      margin: 0
    }
  }))), currentAction != null && (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) != "APPROVED" && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Remark ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) == "APPROVED" && (isApprovedOwnerReg || isOwnerReg) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Remark ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))), ["ADD_REMARK", "ADD_REMARK_EE", "ADD_REMARK_SAP", "FORWARD", "REJECTED", "REVERT_TO_APPLICANT", "FORWARD_TO_OWNER_FOR_PAYMENT", "REVERT_TO_CTP"].includes(purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action) && isPurchasableFAR && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Remark")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  })))), /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, " Document /Certificate"), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "workflow-doc",
    onUpload: selectFile,
    onDelete: () => {
      setUploadedFile(null);
    },
    message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    iserror: error
  }))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    PaperProps: {
      sx: {
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        padding: "16px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      color: "white",
      background: "linear-gradient(90deg, rgb(14, 118, 147), rgba(0, 176, 255, 1))",
      padding: "12px 16px",
      borderRadius: "8px",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/CNqKZu3.jpeg",
    alt: "Disclaimer icon",
    style: {
      width: "70px",
      height: "30px",
      borderRadius: "50%"
    }
  }), "Disclaimer", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    sx: {
      color: "black",
      fontWeight: "bold",
      fontSize: "1.1rem",
      padding: "8px 0",
      marginTop: "10px"
    }
  }, (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" ? "All the details and documents are ok. Approved." : "Payment has been verified.", (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVE" ? "All the details and documents are ok. Approved." : "Payment has been verified.")), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClose,
    sx: {
      backgroundColor: "rgb(14, 118, 147)",
      color: "#fff",
      fontWeight: "bold",
      padding: "8px 16px",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#0e7693"
      }
    }
  }, "Accept"))), (userRoles.includes("BPA_STRUCTURALENGINEER") && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data19 = workflowDetails.data) === null || _workflowDetails$data19 === void 0 ? void 0 : (_workflowDetails$data20 = _workflowDetails$data19.nextActions) === null || _workflowDetails$data20 === void 0 ? void 0 : (_workflowDetails$data21 = _workflowDetails$data20[0]) === null || _workflowDetails$data21 === void 0 ? void 0 : _workflowDetails$data21.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" || (user === null || user === void 0 ? void 0 : (_user$info20 = user.info) === null || _user$info20 === void 0 ? void 0 : _user$info20.type) === "EMPLOYEE") && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ((formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" || showTakeAction === "Take_Action") && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    style: {
      marginLeft: "10px",
      background: "#e08d0e"
    },
    onClick: () => viewApprovalLetter(formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl)
  }, "Approval Letter ", /*#__PURE__*/React__default.createElement(DownloadIcon, null))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 7"
  }, (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" && checked === true && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px",
      fontSize: "12px"
    },
    onClick: () => approvalOfLetterSubmits()
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" && appType === "FORM_OWNER_REGISTRATION" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px",
      fontSize: "12px"
    },
    onClick: () => ownerSubmit()
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REVERT_WITH_OBSERVATION" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), ["REVERT_TO_JE", "REVERT_TO_AE", "REVERT_TO_EE_TP", "REVERT_TO_CTP", "REVERT_TO_ADDITIONAL_SECRETORY"].includes(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REJECTED" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "UNDERPROCESS" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), ["FORWARD_TO_LA_OFFICER", "REJECT", "SENDBACK_TO_APPLICANT", "FORWARD_TO_PROVISIONAL_APPROVED"].includes(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: ownerSubmit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: () => structuralStabilityPdf(currentAction)
  }, "View Structural Stability Certificate", /*#__PURE__*/React__default.createElement(FileDownloadIcon, null)), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && showTakeAction === "Take_Action" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: structuralStabilitySubmit
  }, t("BUTTON_CITIZEN_FORWARD")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REVERT_TO_APPLICANT" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_REVERT_TO_APPLICANT")), isPurchasableFAR && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: purchasableFarSubmit
  }, t("BUTTON_EMP_SUBMITFORM"))))))), (userRoles.includes("BPA_ARCHITECT") || userRoles.includes("BPA_TOWNPLANNER") || userRoles.includes("BPA_ENGINEER") || userRoles.includes("BPA_ARCHITECT_ASSISTANT") || userRoles.includes("BPA_ENGINEER_DIPLOMA") || userRoles.includes("BPA_DRAUGHTSMAN") || userRoles.includes("BPA_SURVEYOR")) && (user === null || user === void 0 ? void 0 : (_user$info21 = user.info) === null || _user$info21 === void 0 ? void 0 : _user$info21.type) === "CITIZEN" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (actions === null || actions === void 0 ? void 0 : (_actions$5 = actions[0]) === null || _actions$5 === void 0 ? void 0 : _actions$5.action) === "MAKE_PAYMENT" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 8"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: handleChangePayment
  }, "Payment")))), (actions === null || actions === void 0 ? void 0 : (_actions$6 = actions[0]) === null || _actions$6 === void 0 ? void 0 : _actions$6.action) === "FORWARD_TO_DEPARTMENT" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 6"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: handleChangeForward
  }, "Forward To Department")))))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && (user === null || user === void 0 ? void 0 : (_user$info22 = user.info) === null || _user$info22 === void 0 ? void 0 : _user$info22.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginTop: "10px",
      marginRight: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(Card, null, (userRoles.includes("BPA_STRUCTURALENGINEER") && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data22 = workflowDetails.data) === null || _workflowDetails$data22 === void 0 ? void 0 : (_workflowDetails$data23 = _workflowDetails$data22.nextActions) === null || _workflowDetails$data23 === void 0 ? void 0 : (_workflowDetails$data24 = _workflowDetails$data23[0]) === null || _workflowDetails$data24 === void 0 ? void 0 : _workflowDetails$data24.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" || (user === null || user === void 0 ? void 0 : (_user$info23 = user.info) === null || _user$info23 === void 0 ? void 0 : _user$info23.type) === "EMPLOYEE") && /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
    actions: actions,
    currentAction: currentAction || purchasableFarActions,
    onChange: onDropDownSelect,
    formData: formData
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginTop: "10px",
      marginRight: "30px"
    }
  }, (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) || (purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action) && /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "#F7F7F7"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, currentAction != null && (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) != "APPROVED" && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginRight: "2px"
    }
  }, "Remarks ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) == "APPROVED" && (isApprovedOwnerReg || isOwnerReg) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginRight: "2px"
    }
  }, "Remarks ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))), !["APPROVED"].includes(purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action) && isPurchasableFAR && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginRight: "2px"
    }
  }, "Remarks ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  })))), /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginRight: "2px"
    }
  }, "Document ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "workflow-doc",
    onUpload: selectFile,
    onDelete: () => {
      setUploadedFile(null);
    },
    message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    iserror: error
  }))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    PaperProps: {
      sx: {
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        padding: "16px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      color: "white",
      background: "linear-gradient(90deg, rgb(14, 118, 147), rgba(0, 176, 255, 1))",
      padding: "12px 16px",
      borderRadius: "8px",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/CNqKZu3.jpeg",
    alt: "Disclaimer icon",
    style: {
      width: "70px",
      height: "30px",
      borderRadius: "50%"
    }
  }), "Disclaimer", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    sx: {
      color: "black",
      fontWeight: "bold",
      fontSize: "1.1rem",
      padding: "8px 0",
      marginTop: "10px"
    }
  }, (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" ? "All the details and documents are ok. Approved." : "Payment has been verified.", (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVE" ? "All the details and documents are ok. Approved." : "Payment has been verified.")), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClose,
    sx: {
      backgroundColor: "rgb(14, 118, 147)",
      color: "#fff",
      fontWeight: "bold",
      padding: "8px 16px",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#0e7693"
      }
    }
  }, "Accept"))), (userRoles.includes("BPA_STRUCTURALENGINEER") && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data25 = workflowDetails.data) === null || _workflowDetails$data25 === void 0 ? void 0 : (_workflowDetails$data26 = _workflowDetails$data25.nextActions) === null || _workflowDetails$data26 === void 0 ? void 0 : (_workflowDetails$data27 = _workflowDetails$data26[0]) === null || _workflowDetails$data27 === void 0 ? void 0 : _workflowDetails$data27.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" || (user === null || user === void 0 ? void 0 : (_user$info24 = user.info) === null || _user$info24 === void 0 ? void 0 : _user$info24.type) === "EMPLOYEE") && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ((formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" || showTakeAction === "Take_Action") && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    style: {
      marginLeft: "10px",
      background: "#e08d0e"
    },
    onClick: () => viewApprovalLetter(formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl)
  }, "Approval Letter ", /*#__PURE__*/React__default.createElement(DownloadIcon, null))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 7"
  }, (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" && checked === true && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px",
      fontSize: "12px"
    },
    onClick: () => approvalOfLetterSubmits()
  }, t("BUTTON_EMP_SUBMITFORM")), isPurchasableFAR && (purchasableFarActions === null || purchasableFarActions === void 0 ? void 0 : purchasableFarActions.action) === "APPROVED" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: purchasableFarSubmit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REVERT_WITH_OBSERVATION" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), ["REVERT_TO_JE", "REVERT_TO_AE", "REVERT_TO_EE_TP", "REVERT_TO_CTP", "REVERT_TO_ADDITIONAL_SECRETORY"].includes(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REJECTED" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "UNDERPROCESS" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_SUBMITFORM")), ["FORWARD_TO_LA_OFFICER", "REJECT", "SENDBACK_TO_APPLICANT", "FORWARD_TO_PROVISIONAL_APPROVED"].includes(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: ownerSubmit
  }, t("BUTTON_EMP_SUBMITFORM")), ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVE") && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px",
      fontSize: "12px"
    },
    onClick: () => ownerSubmit()
  }, t("BUTTON_EMP_SUBMITFORM")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: () => structuralStabilityPdf(currentAction)
  }, "View Structural Stability Certificate", /*#__PURE__*/React__default.createElement(FileDownloadIcon, null)), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && showTakeAction === "Take_Action" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: structuralStabilitySubmit
  }, t("BUTTON_CITIZEN_FORWARD")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REVERT_TO_APPLICANT" && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, t("BUTTON_EMP_REVERT_TO_APPLICANT")), isPurchasableFAR && developerRemarksValidation === "Valid remarks entered" && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: purchasableFarSubmit
  }, t("BUTTON_EMP_SUBMITFORM")))))))))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && (userRoles.includes("BPA_ARCHITECT") || userRoles.includes("BPA_TOWNPLANNER") || userRoles.includes("BPA_ENGINEER") || userRoles.includes("BPA_ARCHITECT_ASSISTANT") || userRoles.includes("BPA_ENGINEER_DIPLOMA") || userRoles.includes("BPA_DRAUGHTSMAN") || userRoles.includes("BPA_SURVEYOR")) && (user === null || user === void 0 ? void 0 : (_user$info25 = user.info) === null || _user$info25 === void 0 ? void 0 : _user$info25.type) === "CITIZEN" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (actions === null || actions === void 0 ? void 0 : (_actions$7 = actions[0]) === null || _actions$7 === void 0 ? void 0 : _actions$7.action) === "MAKE_PAYMENT_APPLICATION_FEE" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 8"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: handleChangePayment
  }, "Payment")))), (actions === null || actions === void 0 ? void 0 : (_actions$8 = actions[0]) === null || _actions$8 === void 0 ? void 0 : _actions$8.action) === "FORWARD_TO_DEPARTMENT" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 6"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: handleChangeForward
  }, "Forward To Department"))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "red"
    }
  }, /*#__PURE__*/React__default.createElement("marquee", null, " ", structureCertificateError))), /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info26 = user.info) === null || _user$info26 === void 0 ? void 0 : _user$info26.type) === "CITIZEN" ? "1" : !isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info27 = user.info) === null || _user$info27 === void 0 ? void 0 : _user$info27.type) === "EMPLOYEE" ? "1" : isLandUse && (user === null || user === void 0 ? void 0 : (_user$info28 = user.info) === null || _user$info28 === void 0 ? void 0 : _user$info28.type) === "CITIZEN" ? "1" : "3",
    style: {
      marginBottom: "30px"
    }
  }, (user === null || user === void 0 ? void 0 : (_user$info29 = user.info) === null || _user$info29 === void 0 ? void 0 : _user$info29.type) === "EMPLOYEE" && (formData === null || formData === void 0 ? void 0 : formData.applicationType) != "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _showTimeLine && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data28 = workflowDetails.data) === null || _workflowDetails$data28 === void 0 ? void 0 : (_workflowDetails$data29 = _workflowDetails$data28.timeline) === null || _workflowDetails$data29 === void 0 ? void 0 : _workflowDetails$data29.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BreakLine, null), ((workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) || isDataLoading) && /*#__PURE__*/React__default.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isDataLoading && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
    style: {
      marginBottom: "16px",
      marginTop: "32px"
    }
  }, t("ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS")), workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data30 = workflowDetails.data) !== null && _workflowDetails$data30 !== void 0 && _workflowDetails$data30.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data31 = workflowDetails.data) === null || _workflowDetails$data31 === void 0 ? void 0 : (_workflowDetails$data32 = _workflowDetails$data31.timeline) === null || _workflowDetails$data32 === void 0 ? void 0 : _workflowDetails$data32.length) === 1 ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "aliceblue",
      borderRadius: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${timelineStatusPrefix}${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data33 = workflowDetails.data) === null || _workflowDetails$data33 === void 0 ? void 0 : (_workflowDetails$data34 = _workflowDetails$data33.timeline[0]) === null || _workflowDetails$data34 === void 0 ? void 0 : _workflowDetails$data34.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data35 = workflowDetails.data) === null || _workflowDetails$data35 === void 0 ? void 0 : _workflowDetails$data35.timeline[0])
  })) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data36 = workflowDetails.data) === null || _workflowDetails$data36 === void 0 ? void 0 : _workflowDetails$data36.timeline) && [...new Set(workflowDetails.data.timeline.map(checkpoint => checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.status))].map((uniqueStatus, index) => {
    const checkpoint = workflowDetails.data.timeline.find(item => item.status === uniqueStatus);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${timelineStatusPrefix}${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint[_statusAttribute]}`),
      customChild: getTimelineCaptions(checkpoint)
    })));
  }))))), (user === null || user === void 0 ? void 0 : (_user$info30 = user.info) === null || _user$info30 === void 0 ? void 0 : _user$info30.type) === "CITIZEN" && (formData === null || formData === void 0 ? void 0 : formData.applicationType) != "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BPAApplicationTimeline, {
    application: formData,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  })), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      height: "500px",
      backgroundColor: "#F7F7F7"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: "scroll",
      height: "450px"
    }
  }, /*#__PURE__*/React__default.createElement(AllRemarksList, {
    remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
    formData: formData
  }))))), (isApprovedOwnerReg || isLandUse) && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: isLandUse && (user === null || user === void 0 ? void 0 : (_user$info31 = user.info) === null || _user$info31 === void 0 ? void 0 : _user$info31.type) === "EMPLOYEE" ? "2" : isLandUse && (user === null || user === void 0 ? void 0 : (_user$info32 = user.info) === null || _user$info32 === void 0 ? void 0 : _user$info32.type) === "CITIZEN" ? "2" : "4",
    style: {
      marginBottom: "30px"
    }
  }, (user === null || user === void 0 ? void 0 : (_user$info33 = user.info) === null || _user$info33 === void 0 ? void 0 : _user$info33.type) != "CITIZEN" && /*#__PURE__*/React__default.createElement("div", null, isApprovedOwnerReg ? /*#__PURE__*/React__default.createElement(EMOCheckList, null) : /*#__PURE__*/React__default.createElement(LandUseNOC, {
    formData: formData,
    role: "EMPLOYEE",
    setOfficerNocDetails: setOfficerNocDetails,
    setCurrentTab: handleChange,
    setIsNoNoc: setIsNoNoc
  }), !isApprovedOwnerReg && !isLandUse && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(FormGroup, null, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: checked,
      onChange: handleChangeCheckBox,
      inputProps: {
        "aria-label": "confirmation by officer, filled details are accurate"
      }
    }),
    label: "I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete."
  })))), (user === null || user === void 0 ? void 0 : (_user$info34 = user.info) === null || _user$info34 === void 0 ? void 0 : _user$info34.type) === "CITIZEN" && (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" && /*#__PURE__*/React__default.createElement(LandUseNOC, {
    formData: formData,
    role: "APPROVED_CITIZEN"
  })), isPurchasableFAR && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info35 = user.info) === null || _user$info35 === void 0 ? void 0 : _user$info35.type) === "CITIZEN" ? "2" : "4",
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, (user === null || user === void 0 ? void 0 : (_user$info36 = user.info) === null || _user$info36 === void 0 ? void 0 : _user$info36.type) === "CITIZEN" ? /*#__PURE__*/React__default.createElement(ChecklistFarCitizen, {
    formData: formData
  }) : /*#__PURE__*/React__default.createElement(PurchasableFarChecklist, {
    formData: formData,
    lastEmpRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$5 = userRolesArray[0]) === null || _userRolesArray$5 === void 0 ? void 0 : _userRolesArray$5.name,
    setRemarksData: setRemarksData,
    setCurrentTab: handleChange
  }))), isPurchasableFAR && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info37 = user.info) === null || _user$info37 === void 0 ? void 0 : _user$info37.type) === "CITIZEN" ? "3" : "5"
  }, ["JE"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$6 = userRolesArray[0]) === null || _userRolesArray$6 === void 0 ? void 0 : _userRolesArray$6.code) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FarDetails, {
    formData: formData,
    setCurrentTab: handleChange,
    farDetails: farDetails,
    setFarDetails: setFarDetails,
    empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : userRolesArray[0]
  })), !["AA", "AAP", "AP", "SAP", "CAP", "DM", "ATP", "TP", "JE"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$7 = userRolesArray[0]) === null || _userRolesArray$7 === void 0 ? void 0 : _userRolesArray$7.code) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CitizenFarDetails, {
    formData: formData
  }), (actions === null || actions === void 0 ? void 0 : (_actions$9 = actions[0]) === null || _actions$9 === void 0 ? void 0 : _actions$9.action) === "MAKE_PAYMENT" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(FarPaymentOption, {
    tenantId: tenantId,
    formData: formData,
    setFetchedPaymentData: setFetchedPaymentData
  }), (fetchedPaymentData === null || fetchedPaymentData === void 0 ? void 0 : (_fetchedPaymentData$F = fetchedPaymentData.FeeInstallment) === null || _fetchedPaymentData$F === void 0 ? void 0 : (_fetchedPaymentData$F2 = _fetchedPaymentData$F[0]) === null || _fetchedPaymentData$F2 === void 0 ? void 0 : _fetchedPaymentData$F2.amount) && /*#__PURE__*/React__default.createElement(FarPaymentDisplay, {
    paymentDetails: fetchedPaymentData,
    totalAmount: formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount
  }), /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 8"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: handleChangePayment
  }, "Proceed to Pay")))))), isLandUse && (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.selectLandUse) == "Conditional Permissible" && /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: isLandUse && (user === null || user === void 0 ? void 0 : (_user$info38 = user.info) === null || _user$info38 === void 0 ? void 0 : _user$info38.type) === "EMPLOYEE" && "3",
    style: {
      marginBottom: "30px"
    }
  }, (user === null || user === void 0 ? void 0 : (_user$info39 = user.info) === null || _user$info39 === void 0 ? void 0 : _user$info39.type) != "CITIZEN" && /*#__PURE__*/React__default.createElement(SelectMandatoryConditions2, {
    setMandatoryCondition: setMandatoryCondition,
    tenantId: tenantId,
    setCurrentTab: handleChange
  })), /*#__PURE__*/React__default.createElement(StyledTabPanel, {
    value: currentTab,
    index: (user === null || user === void 0 ? void 0 : (_user$info40 = user.info) === null || _user$info40 === void 0 ? void 0 : _user$info40.type) === "CITIZEN" ? "4" : isPurchasableFAR && (user === null || user === void 0 ? void 0 : (_user$info41 = user.info) === null || _user$info41 === void 0 ? void 0 : _user$info41.type) === "EMPLOYEE" ? "6" : isLandUse && (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.selectLandUse) !== "Conditional Permissible" ? "3" : "4",
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, (user === null || user === void 0 ? void 0 : (_user$info42 = user.info) === null || _user$info42 === void 0 ? void 0 : _user$info42.type) !== "CITIZEN" && /*#__PURE__*/React__default.createElement(ChatBoard, {
    formData: formData
  }), (user === null || user === void 0 ? void 0 : (_user$info43 = user.info) === null || _user$info43 === void 0 ? void 0 : _user$info43.type) === "CITIZEN" && /*#__PURE__*/React__default.createElement(ChatboardCorrespondenceApplicant, {
    formData: formData
  }))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

function DxfFileUploader({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  showError,
  setFile,
  control
}) {
  const fileInputRef = useRef();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleFileUpload = e => {
    const file = e.target.files[0];
    if (!file) return;
    setIsLoading(true);
    setShowToast(null);
    const allowedFormats = [".dxf", ".DXF"];
    const fileExtension = file.name.split(".").pop();
    const maxSizeInBytes = 300 * 1024 * 1024;
    if (!allowedFormats.includes(`.${fileExtension}`)) {
      setShowToast({
        error: true,
        label: "Please select a file with a valid format (.dxf)."
      });
      setIsLoading(false);
      return;
    }
    if (file.size > maxSizeInBytes) {
      setShowToast({
        error: true,
        label: "File size exceeds the maximum limit of 300 MB."
      });
      setIsLoading(false);
      return;
    }
    setUploadedFile(file);
    setFile(file);
    setIsLoading(false);
  };
  const handleRemoveFile = () => {
    setUploadedFile(null);
    setFile(null);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: "flex-start"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: "label",
    style: {
      width: "100%"
    }
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flexDirection: "column",
      position: "relative",
      width: "100%",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true,
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      display: "flex",
      justifyContent: "space-between",
      height: "30px",
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c",
        color: "#fff"
      }
    },
    disabled: uploadedFile !== null
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "center",
      position: "absolute",
      alignItems: "center",
      display: "flex",
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: "absolute",
      fontSize: "0.5rem",
      marginLeft: "8em"
    }
  }, validationMsg))), /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: required ? `${label || "This field"} is required` : false
    },
    render: ({
      field,
      fieldState
    }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
      name: field.name,
      ref: fileInputRef,
      type: "file",
      style: {
        display: "none"
      },
      onBlur: field.onBlur,
      onChange: e => {
        field.onChange(e.target.files);
        handleFileUpload(e);
      }
    }), (fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) && /*#__PURE__*/React__default.createElement("span", {
      className: "errorText"
    }, fieldState.error.message))
  })), required && showError && !uploadedFile && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, `${hasLabel ? label : "Above"} document is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label))), uploadedFile && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "space-between",
      p: "0.25rem 0 0.25rem 0.75rem",
      backgroundColor: "#eee",
      borderRadius: "0.25rem",
      wordBreak: "break-all",
      alignItems: "center",
      display: "flex",
      lineHeight: 1,
      flex: 1,
      mb: 0.5,
      mt: 1,
      height: "18px",
      fontSize: "0.6rem"
    }
  }, uploadedFile.name, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    color: "error",
    sx: {
      fontSize: "1rem"
    },
    onClick: handleRemoveFile
  }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null)))));
}

function FileUploader$2({
  control,
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required = false,
  tab,
  isNoc = false,
  maxFiles = 1,
  templateMessage = false,
  trigger,
  setFile,
  showModal = false,
  modalMsg = "",
  maxFileSize,
  maxSize: customMaxSize
}) {
  const {
    documents
  } = useSelector(state => state.formMT);
  const dispatch = useDispatch();
  const {
    addFormMTDoc,
    removeFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const Modal = useModal();
  const [allowFileDialog, setAllowFileDialog] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const fileInputRef = useRef(null);
  const uploadedFiles = (documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === name)) || [];
  const canUploadMore = uploadedFiles.length < maxFiles;
  const isDrawingPdf = name === "drawingPdf" || name === "drawingPDF" || name === "compoundingDrawingPdf" || tab === "drawingPdf" || typeof label === "string" && label.toLowerCase().includes("drawing") && label.toLowerCase().includes("pdf");
  const handleFileUpload = async file => {
    setIsLoading(true);
    setShowToast(null);
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    const invalidMalwareExtensions = ["php", "php3", "php4", "php5", "phtml", "asp", "aspx", "jsp", "jspx", "cfm", "exe", "bat", "cmd", "sh", "com", "scr", "msi", "jar", "vbs", "ps1", "dll", "docm", "xlsm", "pptm", "dotm", "xltm", "html", "htm", "js", "xml", "svg", "zip", "rar", "7z", "tar", "gz", "iso"];
    const fileParts = file.name.toLowerCase().split(".");
    const intermediateParts = fileParts.slice(0, -1);
    const hasMaliciousExtension = intermediateParts.some(part => invalidMalwareExtensions.includes(part));
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const fileSize = file.size;
    let allowedFormats = [".pdf"];
    let maxSize = 300 * 1024 * 1024;
    if (hasMaliciousExtension) {
      setShowToast({
        error: true,
        label: "Invalid file name: contains potentially dangerous extensions."
      });
      setIsLoading(false);
      return;
    }
    if (customMaxSize || maxFileSize) {
      maxSize = customMaxSize || maxFileSize;
    } else if (isDrawingPdf) {
      allowedFormats = [".pdf"];
      maxSize = 150 * 1024 * 1024;
    } else if (tab === 1) {
      allowedFormats = [".png", ".jpg", ".jpeg", ".pdf"];
      maxSize = 10 * 1024 * 1024;
    } else if (tab === 2) {
      allowedFormats = [".png", ".jpg", ".jpeg"];
      maxSize = 10 * 1024 * 1024;
    } else if (tab === 3) {
      allowedFormats = [".dwg"];
      maxSize = 300 * 1024 * 1024;
    } else if (tab === 4) {
      allowedFormats = [".dxf"];
      maxSize = 300 * 1024 * 1024;
    } else if (tab === "pdf") {
      allowedFormats = [".pdf"];
      maxSize = 30 * 1024 * 1024;
    }
    if (!allowedFormats.includes(`.${fileExtension}`)) {
      setShowToast({
        error: true,
        label: `Allowed formats: ${allowedFormats.join(", ")}`
      });
      setIsLoading(false);
      return;
    }
    if (fileSize > maxSize) {
      setShowToast({
        error: true,
        label: `File size exceeds limit of ${maxSize / (1024 * 1024)} MB.`
      });
      setIsLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      if (!canUploadMore) {
        removeFormMTDoc(name);
      }
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      const uploadedDoc = {
        documentType: name,
        fileStoreId: filesId.fileStoreId,
        isNoc,
        isMandatory,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      };
      addFormMTDoc(uploadedDoc);
      if (setFile) {
        setFile(uploadedDoc);
      }
      if (trigger) {
        trigger(name);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleInputClick = e => {
    if (allowFileDialog || !showModal) {
      setAllowFileDialog(false);
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    Modal(modalMsg.title, modalMsg.body, modalMsg.type, modalMsg.redirectPath, () => {
      setAllowFileDialog(true);
      setTimeout(() => {
        var _fileInputRef$current;
        (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
      }, 0);
    }, modalMsg.btnText);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: "flex-start",
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, label, templateMessage && /*#__PURE__*/React__default.createElement("span", {
    className: "template-Text"
  }, "AS PER TEMPLATE"), isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      validate: () => required ? uploadedFiles.length > 0 ? true : "Please upload the required file." : true
    },
    render: ({
      field,
      fieldState
    }) => /*#__PURE__*/React__default.createElement("div", {
      className: "NewUploader-form-style"
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
        p: "0.5rem 0.75rem 0.375rem",
        borderRadius: "0.25rem",
        width: "18.25vw",
        display: "flex",
        flexDirection: "column",
        position: "relative"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "text-center"
    }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        display: "flex",
        inset: 0
      }
    }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null)), /*#__PURE__*/React__default.createElement("input", {
      onClick: handleInputClick,
      ref: fileInputRef,
      type: "file",
      onChange: e => handleFileUpload(e.target.files[0])
    }), /*#__PURE__*/React__default.createElement("small", {
      className: "error"
    }, isDrawingPdf && typeof validationMsg === "string" ? validationMsg.replace("30 MB", "150 MB") : validationMsg)), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
      className: "errorText d-block text-center"
    }, showToast.label), (fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) && /*#__PURE__*/React__default.createElement("span", {
      className: "errorText d-block text-center"
    }, fieldState.error.message)))
  })), uploadedFiles.map(doc => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: doc.fileStoreId,
      sx: {
        maxWidth: "100%",
        display: "flex",
        mb: 0.5,
        mt: 1
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: "space-between",
        p: "0.25rem 0 0.25rem 0.75rem",
        backgroundColor: "#eee",
        borderRadius: "0.25rem",
        wordBreak: "break-all",
        fontSize: "0.875rem",
        alignItems: "center",
        display: "flex",
        lineHeight: 1,
        flex: 1
      }
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      onClick: () => {
        removeFormMTDoc(doc.documentType);
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null)))));
  })));
}

const FullScreenLoader = ({
  text,
  backdropColor: _backdropColor = "rgba(0, 0, 0, 0.4)",
  zIndex: _zIndex = 999999
}) => {
  const {
    t
  } = useTranslation();
  const displayText = text || t("Please wait...") || "Please wait...";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: _backdropColor,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: _zIndex,
      cursor: "wait",
      backdropFilter: "blur(2px)"
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 36px",
      background: "rgba(255, 255, 255, 0.95)",
      borderRadius: "10px",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
      minWidth: "160px"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null), displayText && /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginTop: "12px",
      fontSize: "15px",
      fontWeight: 500,
      color: "#333",
      textAlign: "center"
    }
  }, displayText)));
};

const StyledFormControl$1 = styled(FormControl$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  display: "flex"
}));
const StyledFormLabel$1 = styled(FormLabel)(({
  theme
}) => ({
  color: theme.palette.grey[900],
  minWidth: theme.spacing(18),
  marginBottom: 0
}));
const StyledFormControlLabel$1 = styled(FormControlLabel$1)(() => ({
  margin: 0
}));
const StyledRadioGroup$3 = styled(RadioGroup$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  alignItems: "center",
  width: "18.25vw",
  minHeight: 40
}));
function useScrutinyProcess(applicationFlow, isCompoudingAndAVP = false) {
  var _Digit, _window, _window$globalConfigs, _window$globalConfigs2;
  const [scrutinyFlow, setScrutinyFlow] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION")) || null);
  const isOnlyEdcr = process.env.REACT_APP_ONLY_EDCR === "true" || ((_window = window) === null || _window === void 0 ? void 0 : (_window$globalConfigs = _window.globalConfigs) === null || _window$globalConfigs === void 0 ? void 0 : (_window$globalConfigs2 = _window$globalConfigs.getConfig) === null || _window$globalConfigs2 === void 0 ? void 0 : _window$globalConfigs2.call(_window$globalConfigs, "REACT_APP_ONLY_EDCR")) === "true";
  const availableScrutinyOptions = isCompoudingAndAVP ? scrutinyList.filter(item => item.value === "PDF") : applicationFlow === "AVP" && isOnlyEdcr ? scrutinyList.filter(item => item.value === "EDCR") : scrutinyList;
  const handleScrutinyOnChange = ({
    target: {
      value
    }
  }) => {
    var _Digit2;
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("LTP.SCRUTINY.SELECTION", value);
    setScrutinyFlow(value);
  };
  return [scrutinyFlow === "PDF", scrutinyFlow, () => /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, scrutinyFlow === null && /*#__PURE__*/React__default.createElement(StyledFormControl$1, null, /*#__PURE__*/React__default.createElement(StyledFormLabel$1, null, "Scrutiny Process ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement(StyledRadioGroup$3, {
    onChange: handleScrutinyOnChange,
    "aria-labelledby": "departments-list",
    name: "department",
    row: true
  }, availableScrutinyOptions === null || availableScrutinyOptions === void 0 ? void 0 : availableScrutinyOptions.map(item => {
    return /*#__PURE__*/React__default.createElement(StyledFormControlLabel$1, {
      control: /*#__PURE__*/React__default.createElement(Radio$1, null),
      value: item === null || item === void 0 ? void 0 : item.value,
      label: item === null || item === void 0 ? void 0 : item.label,
      key: item === null || item === void 0 ? void 0 : item.name
    });
  })))))), setScrutinyFlow];
}

const LTP_ROLES = {
  SUPERVISOR: "SUPERVISOR",
  ARCHITECT_OR_ENGINEER: "ARCHITECT_OR_ENGINEER",
  TOWN_PLANNER: "TOWN_PLANNER",
  BLOCKED: "BLOCKED",
  UNKNOWN: "UNKNOWN"
};
const SUPERVISOR_ALLOWED_ACTIVITIES = ["home stay", "homestay", "paying guest", "row housing - multi-units", "row housing - multi units", "row housing multi units", "row housing - single-units", "row housing - single units", "row housing single units", "servant quarter", "servant quarters", "ews - single house", "single house - ews", "single housing - ews", "ews", "lig - single house", "single house - lig", "single housing - lig", "lig"];
const isSupervisorActivityAllowed = activity => {
  if (!activity) return true;
  const act = String(activity).trim().toLowerCase().replace(/\s+/g, " ");
  return SUPERVISOR_ALLOWED_ACTIVITIES.some(allowed => act === allowed || act.includes(allowed));
};
const isLayoutPlanActivity = (activity, proposal) => {
  const act = String(activity || "").trim().toLowerCase();
  const prop = String(proposal || "").trim().toLowerCase();
  return act.includes("layout") || act.includes("plotted") || prop.includes("layout") || prop.includes("plotted");
};
const getLtpRole = (formData = null, userInfo = null) => {
  var _Digit, _Digit$UserService, _user$info, _user$info2, _formData$professiona, _formData$professiona2, _formData$architectDe, _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3;
  const user = userInfo || typeof Digit !== "undefined" && ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : _Digit$UserService.getUser());
  const userType = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type;
  if (userType === "EMPLOYEE") {
    return null;
  }
  const userRoles = (user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.roles) || [];
  const userRoleCodes = userRoles.map(r => String(r.code || "").toUpperCase());
  const userRoleNames = userRoles.map(r => String(r.name || "").toLowerCase());
  const consultantCategory = String((formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.consultantCategory) || (formData === null || formData === void 0 ? void 0 : (_formData$architectDe = formData.architectDetail) === null || _formData$architectDe === void 0 ? void 0 : _formData$architectDe.consultantCategory) || (formData === null || formData === void 0 ? void 0 : formData.registrationType) || "").toLowerCase();
  const tradeType = String((formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.tradeUnits) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2[0]) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.tradeType) || "").toLowerCase();
  const isArchitectOrEngineer = consultantCategory.includes("architect") && !consultantCategory.includes("landscape") || consultantCategory.includes("civil") || consultantCategory.includes("engineer") && !consultantCategory.includes("structural") && !consultantCategory.includes("utility") || userRoleCodes.some(code => ["BPA_ARCHITECT", "BPA_ENGINEER", "BPA_GRADUATE_CIVIL_ENGINEER", "ARCHITECT", "ENGINEER"].includes(code)) || userRoleNames.some(name => name.includes("architect") && !name.includes("landscape") || name.includes("civil") || name.includes("engineer") && !name.includes("structural") && !name.includes("utility")) || tradeType.startsWith("architect") || tradeType.startsWith("graduatecivilengineer");
  if (isArchitectOrEngineer) return LTP_ROLES.ARCHITECT_OR_ENGINEER;
  const isTownPlanner = consultantCategory.includes("town") || consultantCategory.includes("planner") || userRoleCodes.some(code => ["BPA_TOWNPLANNER", "BPA_TOWN_PLANNER", "TOWNPLANNER", "TOWN_PLANNER"].includes(code)) || userRoleNames.some(name => name.includes("town") || name.includes("planner")) || tradeType.startsWith("townplanner");
  if (isTownPlanner) return LTP_ROLES.TOWN_PLANNER;
  const isSupervisor = consultantCategory.includes("supervisor") || userRoleCodes.some(code => ["BPA_SUPERVISOR", "SUPERVISOR"].includes(code)) || userRoleNames.some(name => name.includes("supervisor")) || tradeType.startsWith("supervisor");
  if (isSupervisor) return LTP_ROLES.SUPERVISOR;
  const isBlocked = consultantCategory.includes("structural") || consultantCategory.includes("landscape") || consultantCategory.includes("urban") || consultantCategory.includes("utility") || userRoleCodes.some(code => ["BPA_STRUCTURALENGINEER", "BPA_STRUCTURAL_ENGINEER", "STRUCTURALENGINEER", "BPA_LANDSCAPE_ARCHITECT", "LANDSCAPEARCHITECT", "BPA_URBAN_DESIGNER", "URBANDESIGNER", "BPA_ENGINEERS_FOR_UTILITY_SERVICES", "BPA_UTILITY_SERVICES", "ENGINEERSUTILITYSERVICES"].includes(code)) || userRoleNames.some(name => name.includes("structural") || name.includes("landscape") || name.includes("urban") || name.includes("utility")) || tradeType.startsWith("structuralengineer") || tradeType.startsWith("landscapearchitect") || tradeType.startsWith("urbandesigner") || tradeType.startsWith("engineersutilityservices");
  if (isBlocked) return LTP_ROLES.BLOCKED;
  return LTP_ROLES.UNKNOWN;
};
const resolveDistrict = (data = null, formData = null) => {
  var _data$landAreaDetails, _formData$landAreaDet;
  const raw = (data === null || data === void 0 ? void 0 : data.district) || (formData === null || formData === void 0 ? void 0 : formData.district) || (data === null || data === void 0 ? void 0 : data.selectedOffice) || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (data === null || data === void 0 ? void 0 : data.selectedCity) || (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$landAreaDetails = data.landAreaDetails) === null || _data$landAreaDetails === void 0 ? void 0 : _data$landAreaDetails.city) || (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet = formData.landAreaDetails) === null || _formData$landAreaDet === void 0 ? void 0 : _formData$landAreaDet.city) || "";
  return String(raw).trim();
};
const validateStep1Competency = (data, formData = null, userInfo = null, isEmployee = false) => {
  var _data$descriptionOfLa, _formData$description, _data$descriptionOfLa2, _formData$description2;
  if (isEmployee) return null;
  const role = getLtpRole({
    ...formData,
    ...data
  }, userInfo);
  if (!role || role === LTP_ROLES.UNKNOWN) return null;
  if (role === LTP_ROLES.BLOCKED) {
    return "You are not competent to submit file.";
  }
  const primaryUse = (data === null || data === void 0 ? void 0 : data.primaryUse) || (formData === null || formData === void 0 ? void 0 : formData.primaryUse);
  const activityProposed = (data === null || data === void 0 ? void 0 : data.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa = data.descriptionOfLand) === null || _data$descriptionOfLa === void 0 ? void 0 : _data$descriptionOfLa.activityProposed) || (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.activityProposed);
  const proposal = (data === null || data === void 0 ? void 0 : data.proposal) || (formData === null || formData === void 0 ? void 0 : formData.proposal);
  const district = resolveDistrict(data, formData);
  const sitePlotAreaRaw = (data === null || data === void 0 ? void 0 : data.plotAreaDoc) || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa2 = data.descriptionOfLand) === null || _data$descriptionOfLa2 === void 0 ? void 0 : _data$descriptionOfLa2.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : formData.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.plotAreaDoc);
  const sitePlotArea = sitePlotAreaRaw !== undefined && sitePlotAreaRaw !== null && sitePlotAreaRaw !== "" ? Number(sitePlotAreaRaw) : null;
  const buildingHeight = (data === null || data === void 0 ? void 0 : data.buildingHeight) || (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) || ((data === null || data === void 0 ? void 0 : data.isSpecialProject) === "yes" ? data === null || data === void 0 ? void 0 : data.buildingHeight : null);
  if (role === LTP_ROLES.SUPERVISOR) {
    if (primaryUse && String(primaryUse).trim().toLowerCase() !== "residential") {
      return "You are not competent to submit the file other than residential.";
    }
    if (activityProposed && !isSupervisorActivityAllowed(activityProposed)) {
      return "You are not competent to submit files for this activity";
    }
    if (sitePlotArea !== null && !isNaN(sitePlotArea) && sitePlotArea > 200) {
      return "You are not competent to submit file more than 200 sqmt. plot area";
    }
    if (buildingHeight !== undefined && buildingHeight !== null && buildingHeight !== "") {
      const bh = Number(buildingHeight);
      if (!isNaN(bh) && bh > 7.5) {
        return "You are not competent to submit file having more than 7.50 meter.";
      }
    }
  }
  if (role === LTP_ROLES.TOWN_PLANNER) {
    if (activityProposed && !isLayoutPlanActivity(activityProposed, proposal)) {
      return "You are not competent to submit file other than layout proposal.";
    }
  }
  return null;
};
const validateStep2Competency = (data, formData = null, userInfo = null, isEmployee = false) => {
  var _data$descriptionOfLa3, _formData$description3;
  if (isEmployee) return null;
  const role = getLtpRole({
    ...formData,
    ...data
  }, userInfo);
  if (!role || role === LTP_ROLES.UNKNOWN) return null;
  if (role === LTP_ROLES.BLOCKED) {
    return "You are not competent to submit file.";
  }
  const activityProposed = (data === null || data === void 0 ? void 0 : data.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa3 = data.descriptionOfLand) === null || _data$descriptionOfLa3 === void 0 ? void 0 : _data$descriptionOfLa3.activityProposed) || (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.activityProposed);
  const proposal = (data === null || data === void 0 ? void 0 : data.proposal) || (formData === null || formData === void 0 ? void 0 : formData.proposal);
  const district = resolveDistrict(data, formData);
  let sitePlotAreaRaw = null;
  if (isLayoutPlanActivity(activityProposed, proposal)) {
    sitePlotAreaRaw = (data === null || data === void 0 ? void 0 : data.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
  }
  if (!sitePlotAreaRaw) {
    var _data$descriptionOfLa4, _formData$description4;
    sitePlotAreaRaw = (data === null || data === void 0 ? void 0 : data.plotAreaDoc) || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa4 = data.descriptionOfLand) === null || _data$descriptionOfLa4 === void 0 ? void 0 : _data$descriptionOfLa4.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : formData.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.plotAreaDoc);
  }
  const sitePlotArea = sitePlotAreaRaw !== undefined && sitePlotAreaRaw !== null && sitePlotAreaRaw !== "" ? Number(sitePlotAreaRaw) : null;
  const floorsVal = (data === null || data === void 0 ? void 0 : data.floors) !== undefined && (data === null || data === void 0 ? void 0 : data.floors) !== "" ? Number(data === null || data === void 0 ? void 0 : data.floors) : (formData === null || formData === void 0 ? void 0 : formData.floors) !== undefined && (formData === null || formData === void 0 ? void 0 : formData.floors) !== "" ? Number(formData === null || formData === void 0 ? void 0 : formData.floors) : null;
  const heightVal = (data === null || data === void 0 ? void 0 : data.buildingHeight) !== undefined && (data === null || data === void 0 ? void 0 : data.buildingHeight) !== "" ? Number(data === null || data === void 0 ? void 0 : data.buildingHeight) : (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) !== undefined && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) !== "" ? Number(formData === null || formData === void 0 ? void 0 : formData.buildingHeight) : null;
  if (role === LTP_ROLES.SUPERVISOR) {
    if (sitePlotArea !== null && !isNaN(sitePlotArea) && sitePlotArea > 200) {
      return "You are not competent to submit file more than 200 sqmt. plot area";
    }
    if (heightVal !== null && !isNaN(heightVal) && heightVal > 7.5) {
      return "You are not competent to submit file having more than 7.50 meter.";
    }
    if (floorsVal !== null && !isNaN(floorsVal) && floorsVal > 2) {
      return "You are not competent to submit file having more than 2 floors.";
    }
  }
  if (role === LTP_ROLES.TOWN_PLANNER) {
    if (activityProposed && !isLayoutPlanActivity(activityProposed, proposal)) {
      return "You are not competent to submit file other than layout proposal.";
    }
  }
  return null;
};
const validateAllLtpCompetency = (formData, userInfo = null, isEmployee = false) => {
  const err1 = validateStep1Competency(formData, formData, userInfo, isEmployee);
  if (err1) return err1;
  const err2 = validateStep2Competency(formData, formData, userInfo, isEmployee);
  if (err2) return err2;
  return null;
};

const SubStep1 = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  isEmployee,
  isNocModule: _isNocModule = false,
  setFormData
}) => {
  var _documents$find, _documents$find2, _formData$documents, _formData$documents$f, _formData$additionalD, _formData$additionalD2, _documents$find3, _Digit, _Digit2, _Digit2$SessionStorag, _formData$drawingDeta, _formData$drawingDeta2, _formData$drawingDeta3, _formData$drawingDeta4, _formData$additionalD3, _formData$drawingDeta5, _formData$drawingDeta6, _formData$additionalD4, _formData$drawingDeta7, _formData$drawingDeta8, _formData$additionalD5, _formData$additionalD6, _sessionFastPas$addit, _sessionFastPas$addit2, _formData$additionalD7, _sessionFastPas$addit3, _sessionFastPas$addit4, _formData$additionalD8, _formData$additionalD9, _sessionFastPas$addit5, _sessionFastPas$addit6, _formData$additionalD10, _sessionFastPas$addit7, _sessionFastPas$addit8, _formData$additionalD11, _formData$mapSubDetai, _sessionFastPas$mapSu, _edcrSessionData$mapS, _formData$mapSubDetai2, _sessionFastPas$mapSu2, _edcrSessionData$mapS2, _formData$mapSubDetai3, _formData$mapSubDetai4, _sessionFastPas$mapSu3, _edcrSessionData$mapS3, _formData$mapSubDetai5, _formData$mapSubDetai6, _formData$mapSubDetai7, _formData$mapSubDetai8, _formData$description, _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers, _nonSchemeTypeData$, _fastPASData$descript, _formData$additionalD19, _fastPASData$addition4, _fastPASData$descript2, _fastPASData$descript3, _formData$description2, _fastPASData$descript4, _formData$description3, _formData$description4, _fastPASData$descript5, _formData$mapSubDetai10, _formData$mapSubDetai11, _formData$mapSubDetai12, _formData$selectedOff, _formData$description5;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [plotDetails, setPlotDetails] = useState([{
    seriesNo: "",
    plotNo: ""
  }]);
  const [isPreview, setIsPreview] = useState(false);
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("documentFromRedux", documents);
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const isCompAndAVP = (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Compounding";
  const [, scrutinyFlow, ScrutinySelector] = useScrutinyProcess((formData === null || formData === void 0 ? void 0 : formData.department) || applicationFlow, isCompAndAVP);
  console.log("scrutinyeeFLO#", scrutinyFlow, applicationFlow);
  const isDA = applicationFlow === "DA" || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const isProd = process.env.REACT_APP_COUNTER_ID === "1453752";
  console.log("isProd", isProd);
  const greenBuildingDocStoreId = documents === null || documents === void 0 ? void 0 : (_documents$find = documents.find(doc => doc.documentType === "greenBuildingDoc")) === null || _documents$find === void 0 ? void 0 : _documents$find.fileStoreId;
  const compensatoryFarDocStoreId = (documents === null || documents === void 0 ? void 0 : (_documents$find2 = documents.find(doc => doc.documentType === "compensatoryFarDoc")) === null || _documents$find2 === void 0 ? void 0 : _documents$find2.fileStoreId) || (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.find(doc => doc.documentType === "compensatoryFarDoc")) === null || _formData$documents$f === void 0 ? void 0 : _formData$documents$f.fileStoreId) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDocs) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.find(doc => doc.documentType === "compensatoryFarDoc")) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.fileStoreId);
  const plotSizePrescribedDocStoreId = documents === null || documents === void 0 ? void 0 : (_documents$find3 = documents.find(doc => doc.documentType === "plotSizePrescribedDoc")) === null || _documents$find3 === void 0 ? void 0 : _documents$find3.fileStoreId;
  console.log("greenBuildingDocStoreId", greenBuildingDocStoreId, compensatoryFarDocStoreId);
  const sessionFastPas = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("FASTPAS_ID");
  const edcrSessionData = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$SessionStorag = _Digit2.SessionStorage.get("EDCR_CREATE")) === null || _Digit2$SessionStorag === void 0 ? void 0 : _Digit2$SessionStorag[0];
  const edcrNumber = (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.edcrNumber);
  const isEdcrFlow = (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "EDCR" || scrutinyFlow === "EDCR" || !(formData !== null && formData !== void 0 && formData.scrutinyFlow) && Boolean(edcrNumber);
  const [edcrApiData, setEdcrApiData] = useState(null);
  useEffect(() => {
    const fetchEdcrFiles = async () => {
      const num = (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.edcrNumber);
      if (num && (!(formData !== null && formData !== void 0 && formData.updatedDxfFile) || !(formData !== null && formData !== void 0 && formData.planReport) || !(formData !== null && formData !== void 0 && formData.dxfFile))) {
        try {
          var _res$edcrDetail;
          const stateId = Digit.ULBService.getStateId();
          const res = await Digit.OBPSService.scrutinyDetails(stateId, {
            edcrNumber: num
          });
          if (res !== null && res !== void 0 && (_res$edcrDetail = res.edcrDetail) !== null && _res$edcrDetail !== void 0 && _res$edcrDetail[0]) {
            setEdcrApiData(res.edcrDetail[0]);
          }
        } catch (err) {
          console.error("Error fetching EDCR scrutiny details in SubStep1:", err);
        }
      }
    };
    fetchEdcrFiles();
  }, [formData === null || formData === void 0 ? void 0 : formData.edcrNumber]);
  const drawingPdf = (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : (_formData$drawingDeta2 = _formData$drawingDeta[0]) === null || _formData$drawingDeta2 === void 0 ? void 0 : _formData$drawingDeta2.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta3 = formData.drawingDetail) === null || _formData$drawingDeta3 === void 0 ? void 0 : (_formData$drawingDeta4 = _formData$drawingDeta3[0]) === null || _formData$drawingDeta4 === void 0 ? void 0 : _formData$drawingDeta4.drawingPdf) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.updatedDxfFile) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.updatedDxfFile) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.updatedDxfFile);
  const planReport = (formData === null || formData === void 0 ? void 0 : formData.planReport) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta5 = formData.drawingDetail) === null || _formData$drawingDeta5 === void 0 ? void 0 : (_formData$drawingDeta6 = _formData$drawingDeta5[0]) === null || _formData$drawingDeta6 === void 0 ? void 0 : _formData$drawingDeta6.planReport) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.planReport) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.planReport) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.planReport);
  const dxfFile = (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta7 = formData.drawingDetail) === null || _formData$drawingDeta7 === void 0 ? void 0 : (_formData$drawingDeta8 = _formData$drawingDeta7[0]) === null || _formData$drawingDeta8 === void 0 ? void 0 : _formData$drawingDeta8.dxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.dxfFile) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.dxfFile) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.dxfFile);
  const getSessionOffice = item => {
    var _item$additionalDetai, _item$landInfo, _item$descriptionOfLa, _item$additionalDetai2, _item$additionalDetai3, _item$additionalDetai4, _item$additionalDetai5, _item$landInfo2, _item$descriptionOfLa2;
    return (item === null || item === void 0 ? void 0 : item.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : _item$landInfo.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.selectedOffice) || (item === null || item === void 0 ? void 0 : item.authorityName) || (item === null || item === void 0 ? void 0 : item.office) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : _item$additionalDetai2.authorityName) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai3 = item.additionalDetails) === null || _item$additionalDetai3 === void 0 ? void 0 : _item$additionalDetai3.office) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai4 = item.additionalDetails) === null || _item$additionalDetai4 === void 0 ? void 0 : _item$additionalDetai4.verifyingAuthority) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai5 = item.additionalDetails) === null || _item$additionalDetai5 === void 0 ? void 0 : _item$additionalDetai5.devAuthority) || (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : _item$landInfo2.authorityName) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa2 = item.descriptionOfLand) === null || _item$descriptionOfLa2 === void 0 ? void 0 : _item$descriptionOfLa2.authorityName) || "";
  };
  const defaultValues = {
    ...formData,
    edcrNumber: edcrNumber,
    scrutinyFlow: isCompAndAVP ? "PDF" : isEdcrFlow ? "EDCR" : formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow,
    updatedDxfFile: drawingPdf,
    planReport: planReport,
    dxfFile: dxfFile,
    selectedUnit: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD6 = formData.additionalDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit === void 0 ? void 0 : _sessionFastPas$addit.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.unit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit2 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit2 === void 0 ? void 0 : _sessionFastPas$addit2.unit) || "",
    selectedCity: (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit3 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit3 === void 0 ? void 0 : _sessionFastPas$addit3.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.city) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit4 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit4 === void 0 ? void 0 : _sessionFastPas$addit4.city) || "",
    selectedOffice: (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD8 = formData.additionalDetails) === null || _formData$additionalD8 === void 0 ? void 0 : _formData$additionalD8.selectedOffice) || getSessionOffice(sessionFastPas) || "",
    additionalDetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
      selectedUnit: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD9 = formData.additionalDetails) === null || _formData$additionalD9 === void 0 ? void 0 : _formData$additionalD9.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit5 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit5 === void 0 ? void 0 : _sessionFastPas$addit5.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.selectedUnit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.unit) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit6 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit6 === void 0 ? void 0 : _sessionFastPas$addit6.unit) || "",
      selectedCity: (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD10 = formData.additionalDetails) === null || _formData$additionalD10 === void 0 ? void 0 : _formData$additionalD10.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit7 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit7 === void 0 ? void 0 : _sessionFastPas$addit7.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.selectedCity) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.city) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$addit8 = sessionFastPas.additionalDetails) === null || _sessionFastPas$addit8 === void 0 ? void 0 : _sessionFastPas$addit8.city) || "",
      selectedOffice: (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD11 = formData.additionalDetails) === null || _formData$additionalD11 === void 0 ? void 0 : _formData$additionalD11.selectedOffice) || getSessionOffice(sessionFastPas) || ""
    },
    plotDetails: [{
      plotNo: "",
      typeOfPlot: "",
      proposedUnits: ""
    }] || [],
    numberOfHotels: formData === null || formData === void 0 ? void 0 : formData.numberOfHotels,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
    zone: formData === null || formData === void 0 ? void 0 : formData.zone,
    landUseApprovalLetter: (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.approvalLetterUrl) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.landUseApprovalLetter) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$mapSu = sessionFastPas.mapSubDetails) === null || _sessionFastPas$mapSu === void 0 ? void 0 : _sessionFastPas$mapSu.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS === void 0 ? void 0 : _edcrSessionData$mapS.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl),
    approvalLetterUrl: (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.landUseApprovalLetter) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.approvalLetterUrl) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.landUseApprovalLetter) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$mapSu2 = sessionFastPas.mapSubDetails) === null || _sessionFastPas$mapSu2 === void 0 ? void 0 : _sessionFastPas$mapSu2.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS2 = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS2 === void 0 ? void 0 : _edcrSessionData$mapS2.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl),
    mapSubDetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
      proposalTypeFAR: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.proposalTypeFAR) || (formData === null || formData === void 0 ? void 0 : formData.proposalTypeFAR),
      landUseApprovalLetter: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.approvalLetterUrl) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : sessionFastPas.landUseApprovalLetter) || (sessionFastPas === null || sessionFastPas === void 0 ? void 0 : (_sessionFastPas$mapSu3 = sessionFastPas.mapSubDetails) === null || _sessionFastPas$mapSu3 === void 0 ? void 0 : _sessionFastPas$mapSu3.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS3 = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS3 === void 0 ? void 0 : _edcrSessionData$mapS3.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl),
      fireFighting: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai5 = formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.fireFighting,
      prevFileNo: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai6 = formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.prevFileNo) || (formData === null || formData === void 0 ? void 0 : formData.prevFileNo),
      sanctionValidityDate: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai7 = formData.mapSubDetails) === null || _formData$mapSubDetai7 === void 0 ? void 0 : _formData$mapSubDetai7.sanctionValidityDate) || (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityDate),
      sanctionValidityStartDate: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai8 = formData.mapSubDetails) === null || _formData$mapSubDetai8 === void 0 ? void 0 : _formData$mapSubDetai8.sanctionValidityStartDate) || (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityStartDate)
    },
    greenBuildingDoc: {
      fileStoreId: greenBuildingDocStoreId
    },
    compensatoryFarDoc: {
      fileStoreId: compensatoryFarDocStoreId
    },
    watchPlotSizePrescribedDoc: {
      fileStoreId: plotSizePrescribedDocStoreId
    },
    landAddress: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landAddress) || ""
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  }));
  const [fastPASData, setFastPasData] = useState(sessionFastPas || null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const {
    data: v2Data,
    isLoading: isV2DataLoading
  } = Digit.Hooks.obps.useMDMSV2(stateId, "BPA", ["ZoneWiseAuthorityName"]);
  console.log(data, "mdms data");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const watchDistrict = watch("district");
  const watchZone = watch("zone");
  const zoneList = useMemo(() => {
    var _v2Data$BPA;
    let zones = [];
    if (v2Data !== null && v2Data !== void 0 && (_v2Data$BPA = v2Data.BPA) !== null && _v2Data$BPA !== void 0 && _v2Data$BPA.ZoneWiseAuthorityName) {
      const districtLower = (watchDistrict || "").toLowerCase().trim();
      v2Data.BPA.ZoneWiseAuthorityName.forEach(auth => {
        const authorityLower = (auth.authorityName || "").toLowerCase();
        const isMatch = districtLower ? authorityLower.includes(districtLower) : true;
        if (isMatch) {
          var _auth$zones;
          (_auth$zones = auth.zones) === null || _auth$zones === void 0 ? void 0 : _auth$zones.forEach(z => {
            if (z.isActive) {
              zones.push({
                name: z.name,
                label: z.name
              });
            }
          });
        }
      });
      const uniqueZones = [];
      const map = new Map();
      for (const item of zones) {
        if (!map.has(item.name)) {
          map.set(item.name, true);
          uniqueZones.push(item);
        }
      }
      zones = uniqueZones;
    }
    return zones;
  }, [v2Data, watchDistrict]);
  const schemeType = watch("descriptionOfLand.schemeType");
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {
    fields: modalFields,
    append: addPlotNo,
    remove: removePlotNo
  } = useFieldArray({
    control,
    name: "plotDetails"
  });
  const currentPlotNo = getValues(`plotDetails[${modalFields.length - 1}].plotNo`);
  const [watchProposalType, watchisSpecialProject, watchSpecialProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProposal, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchSchemeType, watchProposalTypeFAR, watchGreenBuildingFAR, watchCompensatoryFAR, watchPlotArea, watchShelterFee, watchPurchasableFar, watchGroupHousingOrMultiUnits, watchedPlots, watchSchemeTypes, watchPlotSizePrescribed, watchPlotSizePrescribedDoc, watchCompunding, watchisAncestralProperty, watchLandAddress] = watch(["proposalType", "isSpecialProject", "specialProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "proposal", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "schemeType", "mapSubDetails.proposalTypeFAR", "greenBuildingFAR", "compensatoryFAR", "plotAreaDoc", "shelterFee", "purchasableFar", "groupHousingOrMultiUnits", "plotDetails", "schemeTypes", "plotSizePrescribed", "plotSizePrescribedDoc", "serviceType", "isAncestralProperty", "landAddress", "mapSubDetails.prevFileNo", "mapSubDetails.sanctionValidityDate", "mapSubDetails.sanctionValidityStartDate", "prevFileNo", "sanctionValidityDate", "sanctionValidityStartDate"]);
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const currentNatureOfConstruction = watchnatureOfConstruction || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) || (formData === null || formData === void 0 ? void 0 : formData.natureofConstruction) || "";
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs.map(plot => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      var _Digit3, _formData$additionalD12, _formData$additionalD13, _sessionFast$addition, _sessionFast$addition2, _formData$additionalD14, _sessionFast$addition3, _sessionFast$addition4;
      const sessionFast = (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("FASTPAS_ID");
      const currentSelectedOffice = (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD12 = formData.additionalDetails) === null || _formData$additionalD12 === void 0 ? void 0 : _formData$additionalD12.selectedOffice) || getSessionOffice(sessionFast) || "";
      const currentSelectedUnit = (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD13 = formData.additionalDetails) === null || _formData$additionalD13 === void 0 ? void 0 : _formData$additionalD13.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition = sessionFast.additionalDetails) === null || _sessionFast$addition === void 0 ? void 0 : _sessionFast$addition.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.unit) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition2 = sessionFast.additionalDetails) === null || _sessionFast$addition2 === void 0 ? void 0 : _sessionFast$addition2.unit) || "";
      const currentSelectedCity = (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD14 = formData.additionalDetails) === null || _formData$additionalD14 === void 0 ? void 0 : _formData$additionalD14.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition3 = sessionFast.additionalDetails) === null || _sessionFast$addition3 === void 0 ? void 0 : _sessionFast$addition3.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.city) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition4 = sessionFast.additionalDetails) === null || _sessionFast$addition4 === void 0 ? void 0 : _sessionFast$addition4.city) || "";
      const currentDevelopmentPlan = getValues("developmentPlan") || (formData === null || formData === void 0 ? void 0 : formData.developmentPlan);
      reset({
        ...formData,
        edcrNumber: edcrNumber,
        scrutinyFlow: isEdcrFlow ? "EDCR" : formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow,
        updatedDxfFile: drawingPdf,
        planReport: planReport,
        dxfFile: dxfFile,
        selectedUnit: currentSelectedUnit,
        selectedCity: currentSelectedCity,
        selectedOffice: currentSelectedOffice,
        additionalDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
          ...(currentSelectedUnit ? {
            selectedUnit: currentSelectedUnit
          } : {}),
          ...(currentSelectedCity ? {
            selectedCity: currentSelectedCity
          } : {}),
          ...(currentSelectedOffice ? {
            selectedOffice: currentSelectedOffice
          } : {})
        },
        fastPASId: (formData === null || formData === void 0 ? void 0 : formData.fastPASId) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.land_Id),
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        premiumFAR: (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) === 0 ? "0" : formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
        developmentPlan: currentDevelopmentPlan || (formData === null || formData === void 0 ? void 0 : formData.developmentPlan)
      });
    }
  }, [formData]);
  useEffect(() => {}, [watchedFields]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Compounding") {
      setValue("applicationType", "FORM_COMPOUNDING");
      setValue("planOn", "FORM_MAP_COMPOUNDING");
    }
  }, [watchnatureOfConstruction]);
  console.log("premiumFAR257776767", formData === null || formData === void 0 ? void 0 : formData.premiumFAR, purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR);
  useEffect(() => {
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("projectType", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const [isZoneUpdating, setIsZoneUpdating] = useState(false);
  useEffect(() => {
    var _formData$additionalD15;
    if (!watchZone || !(formData !== null && formData !== void 0 && formData.id)) return;
    const currentSavedZone = (formData === null || formData === void 0 ? void 0 : formData.zone) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD15 = formData.additionalDetails) === null || _formData$additionalD15 === void 0 ? void 0 : _formData$additionalD15.zone);
    if (watchZone === currentSavedZone) return;
    const updateZone = async () => {
      try {
        setIsZoneUpdating(true);
        const payload = {
          ...formData,
          zone: watchZone,
          additionalDetails: {
            ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
            zone: watchZone
          },
          workflow: {
            action: "NOWORKFLOW",
            comments: ""
          }
        };
        await Digit.OBPSService.update({
          BPA: payload
        }, stateId);
        setShowToast({
          error: false,
          message: "Zone updated successfully"
        });
      } catch (err) {
        console.error("Zone update failed:", err);
        setShowToast({
          error: true,
          message: "Failed to update zone"
        });
      } finally {
        setIsZoneUpdating(false);
      }
    };
    updateZone();
  }, [watchZone]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$, _response4, _response4$BPA, _response5, _response5$BPA, _response6, _response6$BPA, _response6$BPA$filter, _response7, _response7$BPA, _response8, _response8$BPA, _response9, _response9$BPA, _response10, _response10$BPA, _response11, _response11$BPA, _response12, _response12$BPA, _data5, _data6, _data7, _data7$mapSubDetails, _data8, _data8$descriptionOfL, _data9, _data9$descriptionOfL, _data10, _data10$descriptionOf, _data11, _data11$descriptionOf, _data12, _data12$descriptionOf, _data12$descriptionOf2, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _data15, _data16, _data16$descriptionOf, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19, _data19$descriptionOf, _data20, _data20$descriptionOf, _data21, _data21$descriptionOf, _data22, _data22$landInfo, _data22$landInfo$owne, _data22$landInfo$owne2, _data22$landInfo$owne3, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26, _data26$descriptionOf, _data27, _data27$descriptionOf, _data27$descriptionOf2, _data28, _data28$descriptionOf, _data28$descriptionOf2, _data29, _data29$descriptionOf, _data30, _ref, _data31, _data31$additionalDet, _data32, _data33, _data33$descriptionOf, _data34, _data34$descriptionOf, _data35;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow && ((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$ = _response3$BPA[0]) === null || _response3$BPA$ === void 0 ? void 0 : _response3$BPA$.department) !== (formData === null || formData === void 0 ? void 0 : formData.department)) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = ((_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : _response4$BPA.find(item => item.applicationType === "FORM_LANDUSE")) || ((_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$BPA = _response5.BPA) === null || _response5$BPA === void 0 ? void 0 : _response5$BPA[0]);
        purchasableData = (_response6 = response) === null || _response6 === void 0 ? void 0 : (_response6$BPA = _response6.BPA) === null || _response6$BPA === void 0 ? void 0 : (_response6$BPA$filter = _response6$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response6$BPA$filter === void 0 ? void 0 : _response6$BPA$filter[0];
        const getOfficeFromItem = item => {
          var _item$additionalDetai6, _item$landInfo3, _item$descriptionOfLa3, _item$additionalDetai7, _item$additionalDetai8, _item$additionalDetai9, _item$additionalDetai10, _item$landInfo4, _item$descriptionOfLa4;
          return (item === null || item === void 0 ? void 0 : item.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai6 = item.additionalDetails) === null || _item$additionalDetai6 === void 0 ? void 0 : _item$additionalDetai6.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : _item$landInfo3.selectedOffice) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa3 = item.descriptionOfLand) === null || _item$descriptionOfLa3 === void 0 ? void 0 : _item$descriptionOfLa3.selectedOffice) || (item === null || item === void 0 ? void 0 : item.authorityName) || (item === null || item === void 0 ? void 0 : item.office) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai7 = item.additionalDetails) === null || _item$additionalDetai7 === void 0 ? void 0 : _item$additionalDetai7.office) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai8 = item.additionalDetails) === null || _item$additionalDetai8 === void 0 ? void 0 : _item$additionalDetai8.authorityName) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai9 = item.additionalDetails) === null || _item$additionalDetai9 === void 0 ? void 0 : _item$additionalDetai9.verifyingAuthority) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai10 = item.additionalDetails) === null || _item$additionalDetai10 === void 0 ? void 0 : _item$additionalDetai10.devAuthority) || (item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : _item$landInfo4.authorityName) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa4 = item.descriptionOfLand) === null || _item$descriptionOfLa4 === void 0 ? void 0 : _item$descriptionOfLa4.authorityName) || "";
        };
        const getUnitFromItem = item => {
          var _item$additionalDetai11, _item$additionalDetai12;
          return (item === null || item === void 0 ? void 0 : item.selectedUnit) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai11 = item.additionalDetails) === null || _item$additionalDetai11 === void 0 ? void 0 : _item$additionalDetai11.selectedUnit) || (item === null || item === void 0 ? void 0 : item.unit) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai12 = item.additionalDetails) === null || _item$additionalDetai12 === void 0 ? void 0 : _item$additionalDetai12.unit) || "";
        };
        const getCityFromItem = item => {
          var _item$additionalDetai13, _item$additionalDetai14;
          return (item === null || item === void 0 ? void 0 : item.selectedCity) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai13 = item.additionalDetails) === null || _item$additionalDetai13 === void 0 ? void 0 : _item$additionalDetai13.selectedCity) || (item === null || item === void 0 ? void 0 : item.city) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai14 = item.additionalDetails) === null || _item$additionalDetai14 === void 0 ? void 0 : _item$additionalDetai14.city) || "";
        };
        const fetchedUnit = getUnitFromItem(data) || getUnitFromItem((_response7 = response) === null || _response7 === void 0 ? void 0 : (_response7$BPA = _response7.BPA) === null || _response7$BPA === void 0 ? void 0 : _response7$BPA[0]) || getUnitFromItem(purchasableData) || ((_response8 = response) === null || _response8 === void 0 ? void 0 : (_response8$BPA = _response8.BPA) === null || _response8$BPA === void 0 ? void 0 : _response8$BPA.map(getUnitFromItem).find(Boolean)) || "" || "";
        const fetchedCity = getCityFromItem(data) || getCityFromItem((_response9 = response) === null || _response9 === void 0 ? void 0 : (_response9$BPA = _response9.BPA) === null || _response9$BPA === void 0 ? void 0 : _response9$BPA[0]) || getCityFromItem(purchasableData) || ((_response10 = response) === null || _response10 === void 0 ? void 0 : (_response10$BPA = _response10.BPA) === null || _response10$BPA === void 0 ? void 0 : _response10$BPA.map(getCityFromItem).find(Boolean)) || "" || "";
        const fetchedOffice = getOfficeFromItem(data) || getOfficeFromItem((_response11 = response) === null || _response11 === void 0 ? void 0 : (_response11$BPA = _response11.BPA) === null || _response11$BPA === void 0 ? void 0 : _response11$BPA[0]) || getOfficeFromItem(purchasableData) || ((_response12 = response) === null || _response12 === void 0 ? void 0 : (_response12$BPA = _response12.BPA) === null || _response12$BPA === void 0 ? void 0 : _response12$BPA.map(getOfficeFromItem).find(Boolean)) || "" || "";
        if (data) {
          if (fetchedUnit) {
            var _data;
            data.selectedUnit = fetchedUnit;
            data.additionalDetails = {
              ...((_data = data) === null || _data === void 0 ? void 0 : _data.additionalDetails),
              selectedUnit: fetchedUnit
            };
          }
          if (fetchedCity) {
            var _data2;
            data.selectedCity = fetchedCity;
            data.additionalDetails = {
              ...((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.additionalDetails),
              selectedCity: fetchedCity
            };
          }
          if (fetchedOffice) {
            var _data3;
            data.selectedOffice = fetchedOffice;
            data.additionalDetails = {
              ...((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.additionalDetails),
              selectedOffice: fetchedOffice
            };
          }
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data4, _data4$professionalIn;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$professionalIn = _data4.professionalInformation) === null || _data4$professionalIn === void 0 ? void 0 : _data4$professionalIn.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        if (fetchedUnit) {
          setValue("selectedUnit", fetchedUnit);
          setValue("additionalDetails.selectedUnit", fetchedUnit);
        }
        if (fetchedCity) {
          setValue("selectedCity", fetchedCity);
          setValue("additionalDetails.selectedCity", fetchedCity);
        }
        if (fetchedOffice) {
          setValue("selectedOffice", fetchedOffice);
          setValue("additionalDetails.selectedOffice", fetchedOffice);
        }
        const letter = ((_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.approvalLetterUrl) || ((_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.landUseApprovalLetter) || ((_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$mapSubDetails = _data7.mapSubDetails) === null || _data7$mapSubDetails === void 0 ? void 0 : _data7$mapSubDetails.landUseApprovalLetter);
        if (letter) {
          setValue("mapSubDetails.landUseApprovalLetter", letter);
          setValue("approvalLetterUrl", letter);
          setValue("landUseApprovalLetter", letter);
        }
        if (formData) {
          if (fetchedUnit) {
            formData.selectedUnit = fetchedUnit;
            if (formData.additionalDetails) {
              formData.additionalDetails.selectedUnit = fetchedUnit;
            } else {
              formData.additionalDetails = {
                selectedUnit: fetchedUnit
              };
            }
          }
          if (fetchedCity) {
            formData.selectedCity = fetchedCity;
            if (formData.additionalDetails) {
              formData.additionalDetails.selectedCity = fetchedCity;
            } else {
              formData.additionalDetails = {
                ...(formData.additionalDetails || {}),
                selectedCity: fetchedCity
              };
            }
          }
          if (fetchedOffice) {
            formData.selectedOffice = fetchedOffice;
            if (formData.additionalDetails) {
              formData.additionalDetails.selectedOffice = fetchedOffice;
            } else {
              formData.additionalDetails = {
                ...(formData.additionalDetails || {}),
                selectedOffice: fetchedOffice
              };
            }
          }
          if (letter) {
            formData.landUseApprovalLetter = letter;
            formData.approvalLetterUrl = letter;
            if (formData.mapSubDetails) {
              formData.mapSubDetails.landUseApprovalLetter = letter;
            } else {
              formData.mapSubDetails = {
                landUseApprovalLetter: letter
              };
            }
          }
        }
        if (setFormData) {
          setFormData(prev => ({
            ...prev,
            fastPASId: applicationNo,
            selectedUnit: fetchedUnit || (prev === null || prev === void 0 ? void 0 : prev.selectedUnit),
            selectedCity: fetchedCity || (prev === null || prev === void 0 ? void 0 : prev.selectedCity),
            selectedOffice: fetchedOffice || (prev === null || prev === void 0 ? void 0 : prev.selectedOffice),
            landUseApprovalLetter: letter || (prev === null || prev === void 0 ? void 0 : prev.landUseApprovalLetter),
            approvalLetterUrl: letter || (prev === null || prev === void 0 ? void 0 : prev.approvalLetterUrl),
            mapSubDetails: {
              ...(prev === null || prev === void 0 ? void 0 : prev.mapSubDetails),
              ...(letter ? {
                landUseApprovalLetter: letter
              } : {})
            },
            additionalDetails: {
              ...(prev === null || prev === void 0 ? void 0 : prev.additionalDetails),
              ...(fetchedUnit ? {
                selectedUnit: fetchedUnit
              } : {}),
              ...(fetchedCity ? {
                selectedCity: fetchedCity
              } : {}),
              ...(fetchedOffice ? {
                selectedOffice: fetchedOffice
              } : {}),
              ...(letter ? {
                landUseApprovalLetter: letter
              } : {})
            }
          }));
        }
        setValue("zoneType", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : _data8$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.landMark);
        setValue("sectorNo", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : _data11$descriptionOf.sectorNo);
        setValue("khasraNo", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : (_data12$descriptionOf2 = _data12$descriptionOf.khasraWithArea[0]) === null || _data12$descriptionOf2 === void 0 ? void 0 : _data12$descriptionOf2.khasraNo);
        setValue("schemeName", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.schemeName);
        setValue("planOn", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : _data14$descriptionOf.planOn);
        setValue("riskType", (_data15 = data) === null || _data15 === void 0 ? void 0 : _data15.riskType);
        setValue("activityProposed", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$descriptionOf = _data16.descriptionOfLand) === null || _data16$descriptionOf === void 0 ? void 0 : _data16$descriptionOf.activityProposed);
        setValue("plotArea", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.plotAreaDoc);
        setValue("descriptionOfLand.plotNo", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$descriptionOf = _data19.descriptionOfLand) === null || _data19$descriptionOf === void 0 ? void 0 : _data19$descriptionOf.plotNo);
        setValue("plotAreaPos", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.plotAreaPossession);
        setValue("landAddress", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.landAddress);
        setValue("tehsil", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$landInfo = _data22.landInfo) === null || _data22$landInfo === void 0 ? void 0 : (_data22$landInfo$owne = _data22$landInfo.owners) === null || _data22$landInfo$owne === void 0 ? void 0 : (_data22$landInfo$owne2 = _data22$landInfo$owne[0]) === null || _data22$landInfo$owne2 === void 0 ? void 0 : (_data22$landInfo$owne3 = _data22$landInfo$owne2.permanentAddress) === null || _data22$landInfo$owne3 === void 0 ? void 0 : _data22$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.developmentArea);
        setValue("subZoneType", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.subLandUseAsPerLayout);
        setValue("latitude", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.latitude);
        setValue("longitude", (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$descriptionOf = _data26.descriptionOfLand) === null || _data26$descriptionOf === void 0 ? void 0 : _data26$descriptionOf.longitude);
        setValue("descriptionOfLand.roadWidths[0].value", (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$descriptionOf = _data27.descriptionOfLand) === null || _data27$descriptionOf === void 0 ? void 0 : (_data27$descriptionOf2 = _data27$descriptionOf.roadWidths[0]) === null || _data27$descriptionOf2 === void 0 ? void 0 : _data27$descriptionOf2.value);
        setValue("descriptionOfLand.approachRoadWidths[0].value", (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$descriptionOf = _data28.descriptionOfLand) === null || _data28$descriptionOf === void 0 ? void 0 : (_data28$descriptionOf2 = _data28$descriptionOf.approachRoadWidths[0]) === null || _data28$descriptionOf2 === void 0 ? void 0 : _data28$descriptionOf2.value);
        setValue("schemeType", (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$descriptionOf = _data29.descriptionOfLand) === null || _data29$descriptionOf === void 0 ? void 0 : _data29$descriptionOf.schemeType);
        setValue("ConstructionType", (_data30 = data) === null || _data30 === void 0 ? void 0 : _data30.constructionType);
        setValue("district", ((_ref = fetchedOffice || ((_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$additionalDet = _data31.additionalDetails) === null || _data31$additionalDet === void 0 ? void 0 : _data31$additionalDet.selectedOffice) || ((_data32 = data) === null || _data32 === void 0 ? void 0 : _data32.selectedOffice) || "") === null || _ref === void 0 ? void 0 : _ref.split(" ")[0]) || "");
        if (watchnatureOfConstruction === "Compounding") {
          setValue("applicationType", "FORM_COMPOUNDING");
          setValue("planOn", "FORM_MAP_COMPOUNDING");
        }
        const isApproved = ((_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$descriptionOf = _data33.descriptionOfLand) === null || _data33$descriptionOf === void 0 ? void 0 : _data33$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data34 = data) === null || _data34 === void 0 ? void 0 : (_data34$descriptionOf = _data34.descriptionOfLand) === null || _data34$descriptionOf === void 0 ? void 0 : _data34$descriptionOf.landArea;
        setRiskType((_data35 = data) === null || _data35 === void 0 ? void 0 : _data35.riskType);
        if (!isApproved) {
          var _data36, _data36$descriptionOf, _data36$descriptionOf2, _data37, _data37$descriptionOf, _data37$descriptionOf2, _data38, _data38$descriptionOf, _data38$descriptionOf2, _data39, _data39$descriptionOf, _data39$descriptionOf2;
          setValue("planOn", "Others");
          setValue("descriptionOfLand.khasraDetails[0].plotNo", (_data36 = data) === null || _data36 === void 0 ? void 0 : (_data36$descriptionOf = _data36.descriptionOfLand) === null || _data36$descriptionOf === void 0 ? void 0 : (_data36$descriptionOf2 = _data36$descriptionOf.khasraDetails) === null || _data36$descriptionOf2 === void 0 ? void 0 : _data36$descriptionOf2[0].plotNo);
          setValue("revenueVillage", (_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$descriptionOf = _data37.descriptionOfLand) === null || _data37$descriptionOf === void 0 ? void 0 : (_data37$descriptionOf2 = _data37$descriptionOf.khasraDetails) === null || _data37$descriptionOf2 === void 0 ? void 0 : _data37$descriptionOf2[0].village);
          setValue("tehsil", (_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$descriptionOf = _data38.descriptionOfLand) === null || _data38$descriptionOf === void 0 ? void 0 : (_data38$descriptionOf2 = _data38$descriptionOf.khasraDetails) === null || _data38$descriptionOf2 === void 0 ? void 0 : _data38$descriptionOf2[0].tehsil);
          setValue("district", (_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$descriptionOf = _data39.descriptionOfLand) === null || _data39$descriptionOf === void 0 ? void 0 : (_data39$descriptionOf2 = _data39$descriptionOf.khasraDetails) === null || _data39$descriptionOf2 === void 0 ? void 0 : _data39$descriptionOf2[0].district);
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  console.log("watchAtivityProposed12121212121212", watchAtivityProposed);
  console.log("fastpasdata", fastPASData);
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType);
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchPrimaryUse);
  console.log(schemeType, "schemeTypeerrrrr");
  const onSubmit = data => {
    var _Digit4, _data$additionalDetai, _fastPASData$addition, _formData$additionalD16, _sessionFast$addition5, _sessionFast$addition6, _data$additionalDetai2, _fastPASData$addition2, _formData$additionalD17, _sessionFast$addition7, _sessionFast$addition8, _data$additionalDetai3, _fastPASData$addition3, _formData$additionalD18, _data$mapSubDetails, _formData$mapSubDetai9, _fastPASData$mapSubDe, _sessionFast$mapSubDe, _edcrSessionData$mapS4;
    if (data !== null && data !== void 0 && data.developmentPlan) {
      Digit.SessionStorage.set("DEVELOPMENT_PLAN", data.developmentPlan);
    }
    const competencyError = validateStep1Competency(data, formData, userInfo, isEmployee);
    if (competencyError) {
      setShowToast({
        key: "true",
        error: true,
        message: competencyError
      });
      return;
    }
    const sessionFast = (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.get("FASTPAS_ID");
    const selectedUnit = (data === null || data === void 0 ? void 0 : data.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.selectedUnit) || getValues("selectedUnit") || getValues("additionalDetails.selectedUnit") || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition = fastPASData.additionalDetails) === null || _fastPASData$addition === void 0 ? void 0 : _fastPASData$addition.selectedUnit) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD16 = formData.additionalDetails) === null || _formData$additionalD16 === void 0 ? void 0 : _formData$additionalD16.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition5 = sessionFast.additionalDetails) === null || _sessionFast$addition5 === void 0 ? void 0 : _sessionFast$addition5.selectedUnit) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.unit) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition6 = sessionFast.additionalDetails) === null || _sessionFast$addition6 === void 0 ? void 0 : _sessionFast$addition6.unit) || "";
    const selectedCity = (data === null || data === void 0 ? void 0 : data.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.selectedCity) || getValues("selectedCity") || getValues("additionalDetails.selectedCity") || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition2 = fastPASData.additionalDetails) === null || _fastPASData$addition2 === void 0 ? void 0 : _fastPASData$addition2.selectedCity) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedCity) || (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD17 = formData.additionalDetails) === null || _formData$additionalD17 === void 0 ? void 0 : _formData$additionalD17.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition7 = sessionFast.additionalDetails) === null || _sessionFast$addition7 === void 0 ? void 0 : _sessionFast$addition7.selectedCity) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.city) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$addition8 = sessionFast.additionalDetails) === null || _sessionFast$addition8 === void 0 ? void 0 : _sessionFast$addition8.city) || "";
    const selectedOffice = (data === null || data === void 0 ? void 0 : data.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.selectedOffice) || getValues("selectedOffice") || getValues("additionalDetails.selectedOffice") || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition3 = fastPASData.additionalDetails) === null || _fastPASData$addition3 === void 0 ? void 0 : _fastPASData$addition3.selectedOffice) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD18 = formData.additionalDetails) === null || _formData$additionalD18 === void 0 ? void 0 : _formData$additionalD18.selectedOffice) || getSessionOffice(sessionFast) || getSessionOffice(fastPASData) || getSessionOffice(data) || "";
    console.log("FORMDATAS IN SUBMIT", formData, data);
    const resolvedLandUseLetter = (data === null || data === void 0 ? void 0 : (_data$mapSubDetails = data.mapSubDetails) === null || _data$mapSubDetails === void 0 ? void 0 : _data$mapSubDetails.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai9 = formData.mapSubDetails) === null || _formData$mapSubDetai9 === void 0 ? void 0 : _formData$mapSubDetai9.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.approvalLetterUrl) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.landUseApprovalLetter) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$mapSubDe = fastPASData.mapSubDetails) === null || _fastPASData$mapSubDe === void 0 ? void 0 : _fastPASData$mapSubDe.landUseApprovalLetter) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.approvalLetterUrl) || (sessionFast === null || sessionFast === void 0 ? void 0 : sessionFast.landUseApprovalLetter) || (sessionFast === null || sessionFast === void 0 ? void 0 : (_sessionFast$mapSubDe = sessionFast.mapSubDetails) === null || _sessionFast$mapSubDe === void 0 ? void 0 : _sessionFast$mapSubDe.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS4 = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS4 === void 0 ? void 0 : _edcrSessionData$mapS4.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl);
    const updatedFormData = {
      ...formData,
      ...data,
      landUseApprovalLetter: resolvedLandUseLetter || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter),
      approvalLetterUrl: resolvedLandUseLetter || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl),
      edcrNumber: edcrNumber,
      scrutinyFlow: isCompAndAVP ? "PDF" : isEdcrFlow ? "EDCR" : (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) || (data === null || data === void 0 ? void 0 : data.scrutinyFlow),
      updatedDxfFile: drawingPdf,
      planReport: planReport,
      dxfFile: dxfFile,
      selectedUnit: selectedUnit || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit),
      selectedCity: selectedCity || (formData === null || formData === void 0 ? void 0 : formData.selectedCity),
      selectedOffice: selectedOffice || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice),
      mapSubDetails: {
        ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
        ...(data === null || data === void 0 ? void 0 : data.mapSubDetails),
        ...(resolvedLandUseLetter ? {
          landUseApprovalLetter: resolvedLandUseLetter
        } : {})
      },
      additionalDetails: {
        ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
        ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
        ...(selectedUnit ? {
          selectedUnit
        } : {}),
        ...(selectedCity ? {
          selectedCity
        } : {}),
        ...(selectedOffice ? {
          selectedOffice
        } : {}),
        ...(resolvedLandUseLetter ? {
          landUseApprovalLetter: resolvedLandUseLetter
        } : {})
      }
    };
    console.log("UPDATED DATA AFTER", updatedFormData);
    handleSubTabChange(1, updatedFormData);
  };
  if (!isEmployee && applicationFlow === null && !(formData !== null && formData !== void 0 && formData.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  if (!isEmployee && !edcrNumber && scrutinyFlow === null) {
    return /*#__PURE__*/React__default.createElement(ScrutinySelector, null);
  }
  const excludedActivitiesForResidential = ["Row Housing - Single units", "Semi-Detached - Single Units", "Detached - Single Units", "Row Housing - Multi units", "Semi-detached - Multi Units", "Detached - Multi Units", "Single Housing - EWS", "Single Housing - LIG"];
  const excludeActivitiesForCommercial1 = ["Auction Market", "Cold storage", "Emergency Stock", "Fruit & Vegetable Market", "Junk Yard", "LPG / Gas Godown", "Storage/Warehousing", "Store/Godown", "Wholesale centres for Agriculture produce", "Wholesale Market/Trade/Wholesale business"];
  const restrictedLayoutActivities = ["Layout Plan (Commercial)", "Layout Plan (Affordable Housing)", "Layout Plan (Residential)", "Layout Plan (Community Facilities)"].includes(watchAtivityProposed);
  console.log({
    restrictedLayoutActivities
  }, "776767776");
  const excludeActivitiesForCommercial3 = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];
  const excludeActivitiesForCommercialOfficeUse = ["Auction Market", "Emergency Stock", "Fruit & Vegetable Market", "Junk Yard", "LPG / Gas Godown", "Wholesale centres for Agriculture produce", "Wholesale Market/Trade/Wholesale business"];
  const excludeActivitiesForCommercialAgri = ["Canteen", "Coal & Wood Stock", "Commercial Complex", "Convenient Shopping", "Fruit & Vegetable Market", "Hotel (<20 rooms)", "Miniplex", "Motel", "Motor Vehicle Showroom (Automobile sales/Purchase, Workshop, Accessories Centre)", "Open-air/ Rooftop Restaurants", "PCO/Cellular Mobile Service", "Plotted Development", "Resort", "Restaurant", "Retail Shops", "Service Apartment", "Shopping Centre", "Shops for sale of Motor vehicle spare parts", "Showroom (other than motor vehicle)", "Resi-Com. Building"];
  const excludeMixedUseActivities = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];
  const excludePublicAmenitiesBuilt = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Information Centre", "Marriage Hall", "Meeting Hall", "Multipurpose Hall", "Museum", "Open Air Theatre", "Prison", "Theatre", "Utilities & Services", "Plotted Development"];
  const excludePublicAmenitiesGrameen = ["Auditorium", "Compost Plant", "Convention Centre", "Museum", "Open Air Theatre", "Prison", "Theatre"];
  const excludePublicActivitiesCommercial = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Creche and Day care Centre", "Dharamshala", "Information Centre", "Marriage Hall", "Meeting Hall", "Microwave and wireless centre", "Museum", "Open Air Theatre", "Prison", "Reading Room", "Theatre"];
  const excludePublicActivitiesLargeIndustries = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Convention Centre", "Creche and Day care Centre", "Dharamshala", "Information Centre", "Marriage Hall", "Meeting Hall", "Microwave and wireless centre", "Museum", "Open Air Theatre", "Prison", "Reading Room", "Theatre"];
  const excludePublicOfficeTraffic = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Information Centre", "Marriage Hall", "Meeting Hall", "Multipurpose Hall", "Museum", "Open Air Theatre", "Prison", "Theatre"];
  const excludeAgricultural = ["Buildings/establishment related to public utilities and services", "Compost Plant", "Creche and Day care Centre", "Electric Sub-station", "Fire station", "Garbage Collection Centre", "Microwave and wireless centre", "Prison", "Public/Community Toilet", "Reading Room", "Sewerage treatment Plant", "Utilities & Services", "Water Works", "Plotted Development"];
  const sprinklerRequiredPrimaryUses = ["Community Facilities (Healthcare Buildings)", "Community Facilities (Educational Buildings)"];
  const includeIsBuildingFullySprinkledActivities = ["Group Housing", "Group Housing - Affordable", "Group Housing - EWS", "Group Housing - LIG", "Hotel (<20 rooms)", "Hotel (>20 rooms)", "All Buildings", "All Buildings", "Community Hall", "Auditorium", "Art Gallery/Exhibition Centre", "Museum", "Theatre", "Health club / Gymnasium", "Theatre", "Health club / Gymnasium", "Religious  Buildings", "Music / Dance and Drama Arts Training Centre", "Health club / Gymnasium", "Amusement Park", "Single Screen Cinema", "Miniplex", "Multiplex", "Club", "All Buildings", "Warehouse", "Cold Storage", "Store / Godown", "All Buildings", "Hazardous / Polluting Industry", "Hazardous Industries"];
  const categoryArray = Array.isArray(nonSchemeTypeData) && (_nonSchemeTypeData$ = nonSchemeTypeData[0]) !== null && _nonSchemeTypeData$ !== void 0 && _nonSchemeTypeData$.CategoryType ? nonSchemeTypeData[0].CategoryType.map(item => item.Category) : [];
  console.log("Categories:", categoryArray);
  const formattedCategoryArray = categoryArray.map(cat => ({
    name: cat,
    label: cat
  }));
  const getFilteredActivityOptions = () => {
    var _nonSchemeTypeData$2;
    const activityProposeData = nonSchemeTypeData === null || nonSchemeTypeData === void 0 ? void 0 : (_nonSchemeTypeData$2 = nonSchemeTypeData[0]) === null || _nonSchemeTypeData$2 === void 0 ? void 0 : _nonSchemeTypeData$2.CategoryType;
    if (!Array.isArray(activityProposeData)) return [];
    const residential = activityProposeData.find(item => item.Category === "Residential");
    const commercial = activityProposeData.find(item => item.Category === "Commercial");
    const industrial = activityProposeData.find(item => item.Category === "Industrial");
    const officeUse = activityProposeData.find(item => item.Category === "Office");
    const agriculture = activityProposeData.find(item => item.Category === "Agriculture");
    const trafficTransport = activityProposeData.find(item => item.Category === "Traffic & Transport");
    const recreational = activityProposeData.find(item => item.Category === "Parks, Play-ground / Open-spaces, Recreational");
    const communityHealth = activityProposeData.find(item => item.Category === "Community Facilities (Healthcare Buildings)");
    const communityEducation = activityProposeData.find(item => item.Category === "Community Facilities (Educational Buildings)");
    const publicAmenities = activityProposeData.find(item => item.Category === "Community Facilities (Public Amenities/Utilities Buildings)");
    const proposed = (commercial === null || commercial === void 0 ? void 0 : commercial["Activity Proposed"]) || [];
    const resProposed = (residential === null || residential === void 0 ? void 0 : residential["Activity Proposed"]) || [];
    const indProposed = (industrial === null || industrial === void 0 ? void 0 : industrial["Activity Proposed"]) || [];
    const officeProposed = (officeUse === null || officeUse === void 0 ? void 0 : officeUse["Activity Proposed"]) || [];
    const trafficProposed = (trafficTransport === null || trafficTransport === void 0 ? void 0 : trafficTransport["Activity Proposed"]) || [];
    const recreationProposed = (recreational === null || recreational === void 0 ? void 0 : recreational["Activity Proposed"]) || [];
    const agricultureProposed = (agriculture === null || agriculture === void 0 ? void 0 : agriculture["Activity Proposed"]) || [];
    const communityHealthProposed = (communityHealth === null || communityHealth === void 0 ? void 0 : communityHealth["Activity Proposed"]) || [];
    const communityEducationProposed = (communityEducation === null || communityEducation === void 0 ? void 0 : communityEducation["Activity Proposed"]) || [];
    const publicAmenitiesProposed = (publicAmenities === null || publicAmenities === void 0 ? void 0 : publicAmenities["Activity Proposed"]) || [];
    const landUse = watchlandUseType;
    const subZone = watchSubZoneType;
    const primaryUse = watchPrimaryUse;
    const simpleReturn = list => list.map(item => ({
      name: item,
      label: item
    }));
    console.log("commercial", trafficProposed);
    const conditions = [{
      match: landUse === "Commercial" && ["Commercial 1- Retail/CBD/Sub CBD", "Commercial 2- Wholesale/ Godown"].includes(subZone) && primaryUse === "Residential",
      excludeFrom: resProposed,
      excludeList: excludedActivitiesForResidential
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercial1
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Residential",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Grameen Abaadi",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercial3
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Mixed Use 1 & 2",
      excludeFrom: proposed,
      excludeList: excludeMixedUseActivities
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: proposed,
      excludeList: ["Miniplex", "Multiplex", "Shopping Mall", "Shopping Centre", "Single Screen Cinema"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Office Use" && subZone === "Office Buildings",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: proposed,
      excludeList: ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building", "Shopping Mall", "Multiplex"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
      includeOnly: ["Canteen", "Multiplex", "Open-air/ Rooftop Restaurants", "PCO/Cellular Mobile Service", "Restaurant", "Retail Shops", "Shopping Mall", "Showroom (other than motor vehicle)"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialAgri
    }, {
      match: primaryUse === "Commercial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Green Belt" && subZone === "Green Belt",
      includeOnly: ["LPG / Gas Godown", "Petrol Pump/ Filling Station (CNG/PNG/EV)", "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)", "Shopping Mall", "Way-side Amenities/Dhaba"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Residential" && (subZone === "Built-up" || subZone === "Residential"),
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Data Processing Centre", "Flour Mill", "Hazardous / Polluting Industry", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park"]
    }, {
      match: primaryUse === "Industrial" && (landUse === "Residential" || landUse === "Commercial") && (subZone === "Grameen Abaadi" || subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street"),
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Data Processing Centre", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Small Industries",
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Data Processing Centre", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: indProposed,
      excludeOnly: ["Dangerous Industries", "Gas Godown", "Cold Storage"]
    }, {
      match: primaryUse === "Industrial" && (landUse === "Office Use" || landUse === "Public & Semi-Public Facilities") && (subZone === "Office Buildings" || subZone === "Public & Semi-Public"),
      excludeFrom: indProposed,
      excludeList: ["Data Processing Centre", "Logistic Park", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
      excludeFrom: indProposed,
      excludeList: ["Data Processing Centre", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
      includeFrom: indProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: indProposed,
      excludeList: ["Dangerous Industries", "Data Processing Centre", "Service Industries", "Software / Information Technology Park"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      includeFrom: indProposed,
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Pasteurizing Plant", "Plotted Development", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Green Belt" && subZone === "Green Belt",
      includeFrom: indProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Office Use" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      includeFrom: officeProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Office Use" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: officeProposed,
      excludeList: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."]
    }, {
      match: primaryUse === "Office Use" && (landUse === "Traffic & Transportationl" || landUse === "Highway Facility Zone") && (subZone === "Transport 1 & 2,Parking" || subZone === "Highway Facilities"),
      includeFrom: officeProposed,
      includeOnly: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."]
    }, {
      match: primaryUse === "Office Use" && (landUse === "Recreational" || landUse === "Agricultural" || landUse === "Green Belt") && (subZone === "Recreational-1 & 2" || subZone === "Agricultural" || subZone === "Green Belt"),
      includeFrom: officeProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Agriculture" && (landUse === "Residential" || landUse === "Industrial" || landUse === "Green Belt") && (subZone === "Built-up" || subZone === "Residential" || subZone === "Large Industries" || subZone === "Green Belt"),
      includeFrom: agricultureProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Agriculture" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation" || landUse === "Recreational" || landUse === "Highway Facility Zone") && (subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Bazaar Street" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Small Industries" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking" || subZone === "Recreational-1 & 2" || subZone === "Highway Facilities"),
      includeFrom: agricultureProposed,
      includeOnly: ["Cattle Colony", "Dairy Farm", "Poultry Farm"]
    }, {
      match: primaryUse === "Agriculture" && landUse === "Residential" && subZone === "Grameen Abaadi",
      includeFrom: agricultureProposed,
      includeOnly: ["Cattle Colony", "Dairy Farm", "Dhobi Ghat", "Poultry Farm"]
    }, {
      match: primaryUse === "Agriculture" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: agricultureProposed,
      excludeOnly: []
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Residential" || landUse === "Recreational") && (subZone === "Built-up" || subZone === "Residential" || subZone === "Recreational-1 & 2"),
      includeFrom: trafficProposed,
      includeOnly: ["Bus Stop", "Parking Lot", "Taxi/Tempo Stand"]
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Residential" || landUse === "Commercial") && (subZone === "Grameen Abaadi" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street"),
      includeFrom: trafficProposed,
      includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta", "Flying Club"]
    }, {
      match: primaryUse === "Traffic & Transport" && landUse === "Agricultural" && subZone === "Agricultural",
      includeFrom: trafficProposed,
      includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta"]
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Industrial" || landUse === "Commercial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation") && (subZone === "Mixed Use 1 & 2" || subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Small Industries" || subZone === "Large Industries" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: trafficProposed,
      excludeOnly: []
    }, {
      match: primaryUse === "Traffic & Transport" && landUse === "Green Belt" && subZone === "Green Belt",
      includeFrom: trafficProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Built-up",
      includeFrom: recreationProposed,
      includeOnly: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool"]
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Grameen Abaadi",
      includeFrom: recreationProposed,
      includeOnly: ["Park", "Playground/Sports Ground", "Swimming Pool"]
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Residential",
      excludeFrom: recreationProposed,
      excludeOnly: ["Shooting Range", "Helipad"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Industrial") && (subZone === "Mixed Use 1 & 2" || subZone === "Small Industries"),
      excludeFrom: recreationProposed,
      excludeOnly: ["Shooting Range"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation") && (subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: recreationProposed,
      excludeList: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool", "Helipad"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Highway Facility Zone" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Highway Facilities" || subZone === "Green Belt"),
      excludeFrom: recreationProposed,
      excludeList: ["Club", "Shooting Range"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: communityHealthProposed,
      excludeList: ["Dental College", "Medical College"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Recreational" || landUse === "Agricultural" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Large Industries" || subZone === "Recreational-1 & 2" || subZone === "Agricultural" || subZone === "Green Belt"),
      includeFrom: communityHealthProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Industrial" && subZone === "Small Industries",
      excludeFrom: communityHealthProposed,
      excludeList: ["Hospitals (> 50 beds)", "Dental College", "Medical College", "Nursing Institutes"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: communityHealthProposed,
      excludeList: ["Maternity Hospitals", "Nursing Homes", "Orphanage", "Small Hospitals (Up to 50 beds)", "Reformatory"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Residential" && (subZone === "Built-up" || subZone === "Residential"),
      excludeFrom: communityEducationProposed,
      excludeOnly: ["Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Residential" || landUse === "Industrial") && (subZone === "Grameen Abaadi" || subZone === "Small Industries"),
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "Degree College", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Bazaar Street",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "General Education Institute", "Higher Technical Institute", "Management Institute", "Nursery School", "Polytechnic", "Library", "Primary school", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Recreational" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Large Industries" || subZone === "Recreational-1 & 2" || subZone === "Green Belt"),
      includeFrom: communityEducationProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Office Use" || landUse === "Traffic & Transportation") && (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
      includeFrom: communityEducationProposed,
      includeOnly: ["Nursery School", "Library", "Primary school", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "Degree College", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      includeFrom: communityEducationProposed,
      includeOnly: ["Coaching Institutes/Centres", "Inter College", "Law College", "Secondary/High School", "Music / Dance and Drama Arts Training Centre", "Art Gallery/Exhibition centre", "Religious  Centre"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicAmenitiesBuilt
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" || landUse === "Commercial" || landUse === "Industrial" && subZone === "Residential" || subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street" || subZone === "Small Industries",
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Prison"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Grameen Abaadi",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicAmenitiesGrameen
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicActivitiesCommercial
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicActivitiesLargeIndustries
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && (landUse === "Office Use" || landUse === "Traffic & Transportation") && (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicOfficeTraffic
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludeAgricultural
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && (landUse === "Recreational" || landUse === "Green Belt") && (subZone === "Recreational-1 & 2" || subZone === "Green Belt"),
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: publicAmenitiesProposed,
      excludeList: []
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: communityHealthProposed,
      excludeList: []
    }];
    for (const cond of conditions) {
      if (cond.match) {
        let list = [];
        if (primaryUse === "Commercial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = proposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = proposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom;
              list = ((_cond$excludeFrom = cond.excludeFrom) === null || _cond$excludeFrom === void 0 ? void 0 : _cond$excludeFrom.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Industrial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = indProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = indProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom2;
              list = ((_cond$excludeFrom2 = cond.excludeFrom) === null || _cond$excludeFrom2 === void 0 ? void 0 : _cond$excludeFrom2.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Residential") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = resProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = resProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom3;
              list = ((_cond$excludeFrom3 = cond.excludeFrom) === null || _cond$excludeFrom3 === void 0 ? void 0 : _cond$excludeFrom3.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Office Use") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = officeProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = officeProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom4;
              list = ((_cond$excludeFrom4 = cond.excludeFrom) === null || _cond$excludeFrom4 === void 0 ? void 0 : _cond$excludeFrom4.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Traffic & Transport") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = trafficProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = trafficProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom5;
              list = ((_cond$excludeFrom5 = cond.excludeFrom) === null || _cond$excludeFrom5 === void 0 ? void 0 : _cond$excludeFrom5.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Recreational") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = recreationProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = recreationProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom6;
              list = ((_cond$excludeFrom6 = cond.excludeFrom) === null || _cond$excludeFrom6 === void 0 ? void 0 : _cond$excludeFrom6.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Agriculture") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = agricultureProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = agricultureProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom7;
              list = ((_cond$excludeFrom7 = cond.excludeFrom) === null || _cond$excludeFrom7 === void 0 ? void 0 : _cond$excludeFrom7.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Healthcare Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = communityHealthProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = communityHealthProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom8;
              list = ((_cond$excludeFrom8 = cond.excludeFrom) === null || _cond$excludeFrom8 === void 0 ? void 0 : _cond$excludeFrom8.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Educational Buildings)") {
          if (cond.match) {
            let _list = [];
            if (cond.includeOnly) {
              _list = communityEducationProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeList) {
              _list = communityEducationProposed.filter(a => !cond.excludeList.includes(a));
            } else {
              _list = cond.excludeFrom || [];
            }
            return simpleReturn(_list);
          }
        } else if (primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = publicAmenitiesProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = publicAmenitiesProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom9;
              list = ((_cond$excludeFrom9 = cond.excludeFrom) === null || _cond$excludeFrom9 === void 0 ? void 0 : _cond$excludeFrom9.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        }
        return simpleReturn(list);
      }
    }
    return simpleReturn(resProposed);
  };
  const plotAreaForDevelopmentPlan = Number(watchPlotArea) || 0;
  const developmentPlanActivities = ["Layout Plan (Residential)", "Layout Plan (Commercial)", "Layout Plan (Industrial)", "Layout Plan (Public Amenities)", "Layout Plan (Community Facilities)", "Layout Plan (Affordable Housing)", "Layout Plan (Office)", "Group Housing", "Group Housing (Affordable)"];
  const selectedActivity = typeof watchAtivityProposed === "object" ? (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.value) || (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.name) || (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.label) || "" : String(watchAtivityProposed || "").trim();
  const isDevelopmentPlanActivity = developmentPlanActivities.includes(selectedActivity);
  const showDevelopmentPlan = plotAreaForDevelopmentPlan >= 3000 && isDevelopmentPlanActivity;
  console.log("========== DEVELOPMENT PLAN DEBUG ==========");
  console.log("watchAtivityProposed =", watchAtivityProposed);
  console.log("selectedActivity =", selectedActivity);
  console.log("watchPlotArea =", watchPlotArea);
  console.log("plotAreaForDevelopmentPlan =", plotAreaForDevelopmentPlan);
  console.log("isDevelopmentPlanActivity =", isDevelopmentPlanActivity);
  console.log("showDevelopmentPlan =", showDevelopmentPlan);
  console.log("============================================");
  const handleClick = () => {
    setIsModalOpen(true);
  };
  const plotArea = parseFloat(watchPlotArea) || 0;
  const isMoreThan4Hectares = plotArea >= 40000;
  console.log("getFilteredActivityoptions", getFilteredActivityOptions);
  if (watchSpecialProject === "Type design" && getValues("plotNo")) {
    setValue("plotNo", "");
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    autoComplete: "off"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    disabled: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Type",
    control: control,
    placeholder: t("Scheme Type"),
    name: "descriptionOfLand.schemeType",
    mandatory: true,
    defaultValue: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.schemeType,
    type: "textInput",
    disabled: true
  }))), isDA && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Select Zone"),
    placeholder: t("Select Zone"),
    name: "zone",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zone,
    type: "selectInput",
    data: zoneList
  })), /*#__PURE__*/React__default.createElement(Col, null)), !isDA && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Selected Unit"),
    placeholder: t("Selected Unit"),
    name: "selectedUnit",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD19 = formData.additionalDetails) === null || _formData$additionalD19 === void 0 ? void 0 : _formData$additionalD19.selectedUnit) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition4 = fastPASData.additionalDetails) === null || _fastPASData$addition4 === void 0 ? void 0 : _fastPASData$addition4.selectedUnit) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedUnit) || "",
    type: "textInput",
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, schemeType === "Scheme" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Type Of Scheme",
    control: control,
    placeholder: "Type Of Scheme",
    name: "planOn",
    mandatory: true,
    defaultValue: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.planOn,
    type: "selectInput",
    disabled: true
  })), schemeType === "Scheme" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Scheme Name",
    defaultValue: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.schemeName,
    name: "schemeName",
    type: "textInput",
    disabled: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), schemeType === "Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disableFuture: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: schemeType === "Scheme" ? t("Land Use as per Layout Plan") : t("Land Use as per Master Plan"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: schemeType === "Scheme" ? t("Land Sub-use as per layout Plan") : t("Land Sub-use as per master Plan"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        const role = getLtpRole(formData, userInfo);
        if (!isEmployee && role === LTP_ROLES.BLOCKED) {
          return "You are not competent to submit file.";
        }
        if (!isEmployee && role === LTP_ROLES.SUPERVISOR && val && String(val).trim().toLowerCase() !== "residential") {
          return "You are not competent to submit the file other than residential.";
        }
        return true;
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityProposed),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        const role = getLtpRole(formData, userInfo);
        const prop = getValues("proposal") || (formData === null || formData === void 0 ? void 0 : formData.proposal);
        if (!isEmployee && role === LTP_ROLES.SUPERVISOR && val && !isSupervisorActivityAllowed(val)) {
          return "You are not competent to submit files for this activity";
        }
        if (!isEmployee && role === LTP_ROLES.TOWN_PLANNER && val && !isLayoutPlanActivity(val, prop)) {
          return "You are not competent to submit file other than layout proposal.";
        }
        return true;
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (watchAtivityProposed === "Hotel (<20 rooms)" || watchAtivityProposed === "Hotel (>20 rooms)") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number Of Rooms"),
    placeholder: t("Number Of Rooms"),
    name: "numberOfHotels",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: value => {
        const num = Number(value);
        if (watchAtivityProposed === "Hotel (<20 rooms)" && num > 20) {
          return "For hotels with <20 rooms, number must not exceed 20";
        }
        if (watchAtivityProposed === "Hotel (>20 rooms)" && num <= 20) {
          return "For hotels with >20 rooms, number must be greater than 20";
        }
        return true;
      },
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid number"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Development Area Type"),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    defaultValue: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript4 = fastPASData.descriptionOfLand) === null || _fastPASData$descript4 === void 0 ? void 0 : _fastPASData$descript4.developmentArea,
    disabled: true,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: isProd ? natureOfConstructionOption2 : natureOfConstructionOption,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.landArea,
    name: "plotArea",
    type: "specialChar",
    disabled: isEmployee,
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.plotAreaDoc,
    name: "plotAreaDoc",
    type: "specialChar",
    disabled: isEmployee,
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    validation: {
      required: {
        message: "This field is required"
      },
      validate: val => {
        const role = getLtpRole(formData, userInfo);
        const num = Number(val);
        if (val !== undefined && val !== null && val !== "" && !isNaN(num)) {
          if (!isEmployee && role === LTP_ROLES.SUPERVISOR && num > 200) {
            return "You are not competent to submit file more than 200 sqmt. plot area";
          }
          const act = getValues("activityProposed") || (formData === null || formData === void 0 ? void 0 : formData.activityProposed);
          const prop = getValues("proposal") || (formData === null || formData === void 0 ? void 0 : formData.proposal);
          const district = getValues("district") || (formData === null || formData === void 0 ? void 0 : formData.district) || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || (formData === null || formData === void 0 ? void 0 : formData.selectedCity) || "";
        }
        return true;
      }
    },
    isRequired: true,
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: true,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    disabled: true,
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchSpecialProject === "Type design" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red",
      fontSize: "14px",
      paddingLeft: "10px",
      fontWeight: "bold"
    }
  }, "Please Re-enter the Values of Plot No."), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "16px",
      marginLeft: "10px"
    }
  }, "Add Plot No's"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    style: {
      color: "green"
    }
  })))) : /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: schemeType === "Scheme" ? t("Plot No") : t("Plot No./Khasra No./ Arazi No."),
    control: control,
    placeholder: schemeType === "Scheme" ? t("Enter Plot no") : t("Enter Plot No./Khasra No./ Arazi No."),
    name: schemeType === "Scheme" ? "descriptionOfLand.plotNo" : "descriptionOfLand.khasraDetails[0].plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript5 = fastPASData.descriptionOfLand) === null || _fastPASData$descript5 === void 0 ? void 0 : _fastPASData$descript5.plotNo),
    type: "textInput",
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("DM Circle Rate (In Rs. Per Square meter)"),
    control: control,
    placeholder: t("Enter DM Rate"),
    name: "dmCircleRate",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.dmCircleRate,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchSpecialProject === "Type design" && /*#__PURE__*/React__default.createElement(Modal$1, {
    open: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#fff",
      padding: 10,
      borderRadius: 8,
      width: "40%",
      margin: "50px auto",
      maxHeight: "80vh",
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setIsModalOpen(false),
    style: {
      position: "absolute",
      right: "32%",
      zIndex: 10
    },
    "aria-label": "close"
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    style: {
      height: "20%"
    }
  })), /*#__PURE__*/React__default.createElement("h4", {
    style: {
      marginBottom: 16,
      fontWeight: "bold"
    }
  }, t("Add Plot Details")), /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Series No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Plot No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Action"))), /*#__PURE__*/React__default.createElement("tbody", null, modalFields.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `plotDetails[${index}].plotNo`,
    control: control,
    placeholder: "Plot No",
    type: "textInput",
    hasLabel: false,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removePlotNo(index),
    color: "error"
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === modalFields.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      const currentPlotNo = getValues(`plotDetails[${modalFields.length - 1}].plotNo`);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      addPlotNo({
        plotNo: ""
      });
    },
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    style: {
      fontWeight: "bold",
      textAlign: "right",
      padding: 8
    }
  }, "Total Plots Entered:"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontWeight: "bold",
      padding: 8
    }
  }, modalFields.length)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right",
      marginTop: 16
    },
    onClick: () => {
      const currentPlotNo = getValues(`plotDetails[${modalFields.length - 1}].plotNo`);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      setIsModalOpen(false);
      setShowToast({
        key: "true",
        error: false,
        message: "Plot details saved successfully!"
      });
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "button",
    sx: {
      backgroundColor: "#157CB3",
      fontWeight: "bold",
      color: "#0c0b0bd6"
    }
  }, "Save")))), (currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || currentNatureOfConstruction === "Redevelopment" || currentNatureOfConstruction === "Reconstruction" || currentNatureOfConstruction === "Revision" || currentNatureOfConstruction === "Addition Extension" || (currentNatureOfConstruction === null || currentNatureOfConstruction === void 0 ? void 0 : currentNatureOfConstruction.includes("Redevelopment")) || (currentNatureOfConstruction === null || currentNatureOfConstruction === void 0 ? void 0 : currentNatureOfConstruction.includes("Reconstruction")) || currentNatureOfConstruction === "Compounding" && watchCompunding === "yes") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction date"),
    control: control,
    placeholder: t("Enter Previous Sanction date"),
    name: "mapSubDetails.sanctionValidityStartDate",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai10 = formData.mapSubDetails) === null || _formData$mapSubDetai10 === void 0 ? void 0 : _formData$mapSubDetai10.sanctionValidityStartDate) || (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityStartDate),
    type: "datePicker",
    disabled: isEmployee,
    mandatory: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || (currentNatureOfConstruction === null || currentNatureOfConstruction === void 0 ? void 0 : currentNatureOfConstruction.includes("Redevelopment")),
    validation: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || currentNatureOfConstruction !== null && currentNatureOfConstruction !== void 0 && currentNatureOfConstruction.includes("Redevelopment") ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction Validity date"),
    control: control,
    placeholder: t("Enter Previous Sanction Validity date"),
    name: "mapSubDetails.sanctionValidityDate",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai11 = formData.mapSubDetails) === null || _formData$mapSubDetai11 === void 0 ? void 0 : _formData$mapSubDetai11.sanctionValidityDate) || (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityDate),
    type: "datePicker",
    mandatory: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || (currentNatureOfConstruction === null || currentNatureOfConstruction === void 0 ? void 0 : currentNatureOfConstruction.includes("Redevelopment")),
    disabled: isEmployee,
    validation: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || currentNatureOfConstruction !== null && currentNatureOfConstruction !== void 0 && currentNatureOfConstruction.includes("Redevelopment") ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Approved Map Number"),
    control: control,
    placeholder: t("Enter Previous File No"),
    name: "mapSubDetails.prevFileNo",
    mandatory: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || (currentNatureOfConstruction === null || currentNatureOfConstruction === void 0 ? void 0 : currentNatureOfConstruction.includes("Redevelopment")),
    disabled: isEmployee,
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai12 = formData.mapSubDetails) === null || _formData$mapSubDetai12 === void 0 ? void 0 : _formData$mapSubDetai12.prevFileNo) || (formData === null || formData === void 0 ? void 0 : formData.prevFileNo),
    type: "textInput",
    validation: currentNatureOfConstruction === "Revalidation/Time Extension" || currentNatureOfConstruction === "Redevelopment/Reconstruction" || currentNatureOfConstruction !== null && currentNatureOfConstruction !== void 0 && currentNatureOfConstruction.includes("Redevelopment") ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("District"),
    placeholder: t("District"),
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$selectedOff = formData.selectedOffice) === null || _formData$selectedOff === void 0 ? void 0 : _formData$selectedOff.split(" ")[0]) || "",
    name: "district",
    type: "textInput",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Nearby Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: schemeType !== "Scheme",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: !!watchLandMark && isEmployee,
    validation: {
      required: {
        value: schemeType !== "Scheme",
        message: "This field is required"
      }
    }
  }))), schemeType === "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    disabled: !!watchTehsil,
    validation: {
      required: {
        value: schemeType !== "Scheme",
        message: "This field is required"
      }
    },
    mandatory: schemeType !== "Scheme"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    mandatory: schemeType !== "Scheme",
    disabled: true,
    validation: {
      required: {
        value: schemeType !== "Scheme",
        message: "This field is required"
      }
    }
  }))), schemeType === "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Address"),
    control: control,
    placeholder: t("Enter Address"),
    name: "landAddress",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.landAddress,
    disabled: isEmployee,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: "descriptionOfLand.roadWidths[0].value",
    type: "specialChar",
    allowedChars: ".",
    disabled: isEmployee,
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: schemeType === "Scheme" ? "Road width (As per layout Plan)" : "Road width (As per master Plan)",
    placeholder: "Enter Road width",
    name: `descriptionOfLand.approachRoadWidths[0].value`,
    type: "specialChar",
    allowedChars: ".",
    disabled: isEmployee,
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: watchAtivityProposed === "Plotted Development" ? proposalOptionsPlotted : proposalOptions,
    label: `${t("Select Proposal")}`,
    placeholder: "Select Proposal",
    name: "proposal",
    type: "selectInput",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, (watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For 2/3 wheelers vehicles)" || watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For All vehicles)" || watchAtivityProposed === "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Plot Size Prescribed By Oil Company"),
    placeholder: t("Plot Size Prescribed By Oil Company"),
    name: "plotSizePrescribed",
    type: "radioButton",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null), watchPlotSizePrescribed === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "plotSizePrescribedDoc",
    label: "Plot Size Prescribed Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    className: "custom-file-uploader",
    required: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposal !== "Layout Development" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.yesOrNo,
    label: t("Is this Special Project"),
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchProposal !== "Layout Development" && watchisSpecialProject == "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special project")}`,
    name: "specialProject",
    disabled: isEmployee,
    placeholder: "Select Special Project",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.specialProject,
    type: "selectInput",
    data: watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG" ? specialProjectList === null || specialProjectList === void 0 ? void 0 : specialProjectList.filter(item => watchSubZoneType === "Mixed Use 1 & 2" ? item.value !== "Mixed Use Along 18/24M Wide Road" : true) : specialProjectList === null || specialProjectList === void 0 ? void 0 : specialProjectList.filter(item => item.value !== "Type design" && !(watchSubZoneType === "Mixed Use 1 & 2" && item.value === "Mixed Use Along 18/24M Wide Road")),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, !(watchProposal === "Layout Development") ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Does your proposal require other than Base FAR")}`,
    name: "mapSubDetails.proposalTypeFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalTypeFAR,
    type: "radioButton",
    height: 40,
    mandatory: true,
    disabled: isEmployee,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), watchProposalTypeFAR === "yes" && watchPrimaryUse === "Residential" && (watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Row Housing - Multi units" || watchAtivityProposed === "Detached - Multi Units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Semi-detached - Multi Units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Group Housing" || watchAtivityProposed === "Group Housing - Affordable" || watchAtivityProposed === "Group Housing - EWS" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable") &&
  /*#__PURE__*/
  React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Single Housing - EWS" && schemeType === "Non Scheme" || watchAtivityProposed === "Single Housing - LIG" && schemeType === "Non Scheme" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable" || watchProposal === "Layout Development") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Purchasable FAR")}`,
    name: "purchasableFar",
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFar,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, (watchAtivityProposed === "Group Housing" || watchAtivityProposed === "Group Housing - Affordable" || watchAtivityProposed === "Group Housing - EWS" || watchAtivityProposed === "Group Housing - LIG" || watchProposal === "Layout Development") && watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Purchasable Premium FAR")}`,
    name: "purchasablePremiumFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasablePremiumFAR,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Basic FAR",
    placeholder: "Enter Basic FAR",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    name: "basicFAR",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.basicFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.basicFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR),
    mandatory: true,
    disabled: isEmployee,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Purchasable FAR",
    placeholder: "Enter Purchasable FAR",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR),
    mandatory: true,
    name: "purchasableFAR",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: isEmployee,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Premium FAR",
    placeholder: "Enter Premium FAR",
    mandatory: true,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    name: "premiumFAR",
    disabled: isEmployee,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)))), watchProposalTypeFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Green Building FAR")}`,
    name: "greenBuildingFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.greenBuildingFAR,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposal !== "Layout Development" && watchGreenBuildingFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Green Building Rated requires additional FAR")}`,
    placeholder: "Select Percentage",
    name: "greenAdditionalFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.greenAdditionalFAR,
    type: "selectInput",
    data: additionalFar
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "greenBuildingDoc",
    label: "Green Building Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    className: "custom-file-uploader",
    required: true
  })))), watchProposalTypeFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Compensatory FAR")}`,
    name: "compensatoryFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compensatoryFAR,
    type: "radioButton",
    mandatory: true,
    disabled: isEmployee,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchCompensatoryFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Area of Transferred Land")}`,
    name: "transferredLandArea",
    placeholder: "Enter Area",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.transferredLandArea,
    type: "textInput",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, compensatoryFarDocStoreId || formData !== null && formData !== void 0 && formData.compensatoryFarDoc ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginLeft: "23px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      marginBottom: 0
    }
  }, "Compensatory FAR Document"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#00000057",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(compensatoryFarDocStoreId, setIsPreview)
  })) : /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "CompensatoryFarDoc",
    label: "Compensatory FAR Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, !restrictedLayoutActivities && /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "specialProjectType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.specialProjectType,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchProposal !== "Layout Development" && watchisSpecialProject === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), ["Detached - Multi Units", "Semi-detached - Multi Units", "Group Housing", "Row Housing - Multi units", "Layout Plan (Residential)"].includes(watchAtivityProposed) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Payment of Shelter fee?",
    name: "shelterFee",
    type: "radioButton",
    mandatory: true,
    defaultValue: isMoreThan4Hectares ? "no" : (formData === null || formData === void 0 ? void 0 : formData.shelterFee) || "no",
    disabled: isEmployee,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchShelterFee === "no" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Performance Gaurantee against EWS/LIG"),
    placeholder: "Select Guarantee",
    name: "performanceGuarantee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.performanceGuarantee,
    type: "selectInput",
    height: 40,
    disabled: isEmployee,
    data: guaranteeList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null))), watchSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), watchSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        const role = getLtpRole(formData, userInfo);
        const num = Number(val);
        if (!isEmployee && role === LTP_ROLES.SUPERVISOR && val !== undefined && val !== null && val !== "" && !isNaN(num) && num > 7.5) {
          return "You are not competent to submit file having more than 7.50 meter.";
        }
        return true;
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front Setback"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear Setback"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (includeIsBuildingFullySprinkledActivities.includes(watchAtivityProposed) || sprinklerRequiredPrimaryUses.includes(watchPrimaryUse)) && /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is building fully sprinklered for Fire Fighting?")}`,
    name: "mapSubDetails.fireFighting",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fireFighting,
    type: "radioButton",
    disabled: isEmployee,
    data: yesOrNo,
    height: 40,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", watchAtivityProposed === "Plotted Development" && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Does your proposal comprising Multi-units / Group Housing")}`,
    name: "groupHousingOrMultiUnits",
    type: "radioButton",
    data: yesOrNo,
    height: 40,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchnatureOfConstruction === "Compounding" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is building plan previously approved?"),
    control: control,
    name: "serviceType",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.serviceType,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchCompunding !== "no" && /*#__PURE__*/React__default.createElement(Col, null), watchCompunding === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of compounding"),
    placeholder: t("Select Nature Of Compounding"),
    name: "isAncestralProperty",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty,
    data: SortingAlphabatically(natureOfCompounding),
    type: "selectInput",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchCompunding === "no" && watchisAncestralProperty === "In response to notice" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Notice Number"),
    control: control,
    placeholder: t("Notice Number  (Mandatory Field)"),
    name: "vaadId",
    mandatory: true,
    maxLength: 24,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.vaadId,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchSpecialProject === "Type design" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    style: {
      marginLeft: "10px"
    }
  }, "Total Plot's Entered : ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "bold"
    }
  }, modalFields.length))), watchGroupHousingOrMultiUnits === "yes" && /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper"
  }, /*#__PURE__*/React__default.createElement("legend", {
    style: {
      fontWeight: "bold",
      fontSize: "1rem"
    }
  }, "Permornamce Gaurantee against EWS/LIG"), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_PLOT_NO"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Types Of Plots"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Proposed Units", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("ACTIONS")))), /*#__PURE__*/React__default.createElement("tbody", null, modalFields.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `plotDetails[${index}].plotNo`,
    control: control,
    type: "textInput",
    placeholder: "Enter Plot No",
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `plotDetails[${index}].typeOfPlot`,
    control: control,
    type: "radioButton",
    data: groupHousingOrMultiUnits,
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `plotDetails[${index}].proposedUnits`,
    control: control,
    type: "number",
    onlyNumeric: true,
    maxLength: 5,
    placeholder: "Enter Proposed Units",
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removePlotNo(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === modalFields.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      const currentPlotNo = getValues(`plotDetails[${modalFields.length - 1}].plotNo`);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      addPlotNo({
        plotNo: ""
      });
    },
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null))))))))))), Boolean(edcrNumber && isEdcrFlow) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), Boolean(edcrNumber && isEdcrFlow) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, drawingPdf ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(drawingPdf, "_blank")
  }) : "N/A"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, planReport ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(planReport, "_blank")
  }) : "N/A"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, dxfFile ? /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/GDoAGny.png",
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(dxfFile, "_blank"),
    alt: "DXF File"
  }) : "N/A"))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), isZoneUpdating && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const ReusableFloorDetail = ({
  defaultValues,
  control,
  formData,
  isEmployee,
  isUploadDocsOrShortFall: _isUploadDocsOrShortFall = null
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Total no of floor"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form reuse"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basement"),
    control: control,
    placeholder: t("Enter Number of Basements"),
    name: "basementArea",
    mandatory: true,
    maxLength: 2,
    disabled: isEmployee ? false : _isUploadDocsOrShortFall != null ? _isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.basementArea) : !!(formData !== null && formData !== void 0 && formData.basementArea),
    type: "number",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Stilt"),
    control: control,
    placeholder: t("Enter Number of Stilts"),
    name: "stiltArea",
    mandatory: true,
    maxLength: 2,
    disabled: isEmployee ? false : _isUploadDocsOrShortFall != null ? _isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.stiltArea) : !!(formData !== null && formData !== void 0 && formData.stiltArea),
    type: "number",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Floors"),
    control: control,
    placeholder: t("Enter Number of Floors"),
    name: "floors",
    mandatory: true,
    maxLength: 2,
    disabled: isEmployee ? false : _isUploadDocsOrShortFall != null ? _isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.floors) : !!(formData !== null && formData !== void 0 && formData.floors),
    type: "number",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        const role = getLtpRole(formData);
        const num = Number(val);
        if (!isEmployee && role === LTP_ROLES.SUPERVISOR && val !== undefined && val !== null && val !== "" && !isNaN(num) && num > 2) {
          return "You are not competent to submit file having more than 2 floors.";
        }
        return true;
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Building Height (m)"),
    control: control,
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    mandatory: true,
    disabled: isEmployee ? false : _isUploadDocsOrShortFall != null ? _isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.buildingHeight) : !!(formData !== null && formData !== void 0 && formData.buildingHeight),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        if (val && !/^\d+(\.\d{1,2})?$/.test(val)) {
          return "Only up to 2 digits after decimal are allowed.";
        }
        const role = getLtpRole(formData);
        const num = Number(val);
        if (!isEmployee && role === LTP_ROLES.SUPERVISOR && val !== undefined && val !== null && val !== "" && !isNaN(num) && num > 7.5) {
          return "You are not competent to submit file having more than 7.50 meter.";
        }
        return true;
      }
    }
  })))));
};

const SubStep3 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _formData$description, _formData$description2, _formData$plotInfo3, _formData$plotInfo4, _formData$plotInfo5, _formData$plotInfo6, _formData$plotInfo7, _formData$plotInfo8;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const [isUploadDocsOrShortFall, setIsUploadDocsOrShortfall] = useState(false);
  const [showToast, setShowToast] = useState(null);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(() => setShowToast(null), 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const activityProposed = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed);
  const isLayoutPlan = ["Layout Plan (Residential)", "Layout Plan (Community Facilities)", "Layout Plan (Commercial)", "Layout Plan (Affordable Housing)", "Layout Plan (Industrial)", "Layout Plan (Office)", "Layout Plan (Hi-Tech Township)", "Layout Plan (Integrated Township)", "Layout Plan (Traffic and Transport)"].includes(activityProposed);
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  useEffect(() => {
    var _formData$plotInfo, _formData$plotInfo2;
    setValue("plotInfo.plotArea", (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.plotArea));
    setValue("plotInfo.builtupArea", (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.builtupArea));
  }, [formData]);
  useEffect(() => {
    if (formData && formData !== null && formData !== void 0 && formData.status) {
      if ((formData === null || formData === void 0 ? void 0 : formData.status) !== "REVERT_TO_APPLICANT" && (formData === null || formData === void 0 ? void 0 : formData.status) !== "UPLOAD_DOC") {
        setIsUploadDocsOrShortfall(true);
      } else {
        setIsUploadDocsOrShortfall(false);
      }
    }
  }, [formData, formData === null || formData === void 0 ? void 0 : formData.status]);
  const onSubmit = data => {
    var _data$plotInfo;
    console.log("data-step3", data);
    const updatedData = {
      ...data,
      plotArea: (data === null || data === void 0 ? void 0 : (_data$plotInfo = data.plotInfo) === null || _data$plotInfo === void 0 ? void 0 : _data$plotInfo.plotArea) || (data === null || data === void 0 ? void 0 : data.plotArea)
    };
    const competencyError = validateStep2Competency(updatedData, formData, null, isEmployee);
    if (competencyError) {
      setShowToast({
        key: "true",
        error: true,
        message: competencyError
      });
      return;
    }
    handleSubTabChange(2, updatedData);
  };
  console.log("formData", formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.landArea,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: isEmployee || isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.plotArea),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), formData !== null && formData !== void 0 && formData.edcrNumber ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area as per drawing (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area as per drawing"),
    name: "plotInfo.plotArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo3 = formData.plotInfo) === null || _formData$plotInfo3 === void 0 ? void 0 : _formData$plotInfo3.plotArea),
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: isEmployee || isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.plotArea),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Compounding" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Compoundable Builtup Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter builtup area"),
    name: "compoundingBuiltUpArea",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compoundingBuiltUpArea,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.compoundingBuiltUpArea)
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: isLayoutPlan ? (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" ? t("Proposed Plot area as per site") : t("Plot area as per site") : (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" ? t("Total Proposed Built up Area (sq.mtr)") : t("Total Built up Area (sq.mtr)"),
    control: control,
    placeholder: isLayoutPlan ? (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" ? t("Enter Proposed Plot Area as per site") : t("Enter Plot Area as per site") : (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" ? t("Enter Total Proposed Built up Area") : t("Enter Total Built up Area"),
    name: "totalBuildUpArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo4 = formData.plotInfo) === null || _formData$plotInfo4 === void 0 ? void 0 : _formData$plotInfo4.builtupArea),
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: isEmployee ? false : isUploadDocsOrShortFall && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "Addition Extension" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "Revision" && !!(formData !== null && formData !== void 0 && formData.totalBuildUpArea || formData !== null && formData !== void 0 && (_formData$plotInfo5 = formData.plotInfo) !== null && _formData$plotInfo5 !== void 0 && _formData$plotInfo5.builtupArea),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: val => {
        if (isLayoutPlan) {
          const role = getLtpRole(formData);
          const num = Number(val);
          if (val !== undefined && val !== null && val !== "" && !isNaN(num)) {
            if (!isEmployee && role === LTP_ROLES.SUPERVISOR && num > 200) {
              return "You are not competent to submit file more than 200 sqmt. plot area";
            }
          }
        }
        return true;
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Estimated Cost (INR)"),
    control: control,
    placeholder: t("Enter Estimated Cost"),
    name: "plotInfo.estimatedCost",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$plotInfo6 = formData.plotInfo) === null || _formData$plotInfo6 === void 0 ? void 0 : _formData$plotInfo6.estimatedCost,
    disabled: isEmployee,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), ((formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Revision") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanctioned Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Sanctioned Area"),
    name: "sanctionBuiltupArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo7 = formData.plotInfo) === null || _formData$plotInfo7 === void 0 ? void 0 : _formData$plotInfo7.builtupArea),
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: isEmployee || isUploadDocsOrShortFall && !!(formData !== null && formData !== void 0 && formData.totalBuildUpArea || formData !== null && formData !== void 0 && (_formData$plotInfo8 = formData.plotInfo) !== null && _formData$plotInfo8 !== void 0 && _formData$plotInfo8.builtupArea),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null))), !isLayoutPlan && /*#__PURE__*/React__default.createElement(ReusableFloorDetail, {
    formData: formData,
    defaultValues: defaultValues,
    control: control,
    isEmployee: isEmployee,
    isUploadDocsOrShortFall: isUploadDocsOrShortFall
  }), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: () => setShowToast(null),
    isDleteBtn: true
  }));
};

const SubStep2 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _Digit$UserService$ge, _formData$professiona18, _formData$professiona19, _formData$professiona20, _formData$professiona21, _formData$professiona22, _formData$professiona23, _formData$professiona24, _formData$professiona25, _formData$professiona26, _formData$professiona27, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$landInfo15, _formData$landInfo15$, _formData$landInfo15$2, _formData$landInfo15$3, _formData$landInfo16, _formData$landInfo16$, _formData$landInfo16$2, _formData$landInfo17, _formData$landInfo17$, _formData$landInfo17$2, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5, _formData$structuralI6;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const getConsultantCategory = data => {
    var _data$professionaldet, _data$professionalInf, _data$architectDetail;
    return (data === null || data === void 0 ? void 0 : (_data$professionaldet = data.professionaldetails) === null || _data$professionaldet === void 0 ? void 0 : _data$professionaldet.consultantCategory) || (data === null || data === void 0 ? void 0 : (_data$professionalInf = data.professionalInformation) === null || _data$professionalInf === void 0 ? void 0 : _data$professionalInf.consultantCategory) || (data === null || data === void 0 ? void 0 : data.consultantCategory) || (data === null || data === void 0 ? void 0 : (_data$architectDetail = data.architectDetail) === null || _data$architectDetail === void 0 ? void 0 : _data$architectDetail.consultantCategory) || (data === null || data === void 0 ? void 0 : data.registrationType) || "";
  };
  const formatValidUpto = userObj => {
    const rawDate = (userObj === null || userObj === void 0 ? void 0 : userObj.validUpto) || (userObj === null || userObj === void 0 ? void 0 : userObj.validupto) || (userObj === null || userObj === void 0 ? void 0 : userObj.pwdExpiryDate);
    if (!rawDate) return null;
    const dateStr = String(rawDate).trim().slice(0, 10);
    if (dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 2 && parts[2].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (parts[0].length === 4 && parts[2].length === 2) {
          return dateStr;
        }
      }
    } else if (dateStr.includes("/")) {
      const parts = dateStr.split("/");
      if (parts.length === 3) {
        if (parts[0].length === 2 && parts[2].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (parts[0].length === 4 && parts[2].length === 2) {
          return `${parts[0]}-${parts[1]}-${parts[2]}`;
        }
      }
    } else if (!isNaN(dateStr)) {
      const d = new Date(Number(rawDate));
      if (!isNaN(d.getTime())) {
        let month = d.getMonth() + 1;
        let day = d.getDate();
        let year = d.getFullYear();
        month = month > 9 ? month : `0${month}`;
        day = day > 9 ? day : `0${day}`;
        return `${year}-${month}-${day}`;
      }
    }
    return dateStr;
  };
  const resolvedConsultantCategory = getConsultantCategory(formData);
  const defaultValues = {
    ...formData,
    professionaldetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionaldetails),
      consultantCategory: resolvedConsultantCategory,
      name: (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.name) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name) || "",
      emailId: (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.emailId) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.emailId) || "",
      mobileNumber: (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber) || "",
      certificateNo: (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.certificateNo) || "",
      validupto: formatValidUpto(formData === null || formData === void 0 ? void 0 : formData.professionaldetails) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.validupto) || ""
    },
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    }
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    trigger
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  });
  const watchState = watch("landInfo.owners.[0].correspondenceAddress.state");
  const watchInputOnGST = watch("landInfo.owners.[0].inputonGST");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const [watchCategoryType, watchCertNo, watchValidity] = watch(["professionaldetails.consultantCategory", "professionaldetails.certificateNo", "professionaldetails.validupto"]);
  useEffect(() => {
    if (formData) {
      var _formData$professiona9, _formData$professiona10, _formData$professiona11, _formData$professiona12, _formData$professiona13, _formData$professiona14, _formData$landInfo, _formData$landInfo$ow;
      const categoryFromData = getConsultantCategory(formData);
      if (categoryFromData) {
        setValue("professionaldetails.consultantCategory", categoryFromData);
      }
      if (formData !== null && formData !== void 0 && (_formData$professiona9 = formData.professionaldetails) !== null && _formData$professiona9 !== void 0 && _formData$professiona9.name) {
        setValue("professionaldetails.name", formData.professionaldetails.name);
      }
      if (formData !== null && formData !== void 0 && (_formData$professiona10 = formData.professionaldetails) !== null && _formData$professiona10 !== void 0 && _formData$professiona10.emailId) {
        setValue("professionaldetails.emailId", formData.professionaldetails.emailId);
      }
      if (formData !== null && formData !== void 0 && (_formData$professiona11 = formData.professionaldetails) !== null && _formData$professiona11 !== void 0 && _formData$professiona11.mobileNumber) {
        setValue("professionaldetails.mobileNumber", formData.professionaldetails.mobileNumber);
      }
      if ((formData === null || formData === void 0 ? void 0 : (_formData$professiona12 = formData.professionaldetails) === null || _formData$professiona12 === void 0 ? void 0 : _formData$professiona12.certificateNo) !== undefined && (formData === null || formData === void 0 ? void 0 : (_formData$professiona13 = formData.professionaldetails) === null || _formData$professiona13 === void 0 ? void 0 : _formData$professiona13.certificateNo) !== null) {
        setValue("professionaldetails.certificateNo", formData.professionaldetails.certificateNo);
      }
      if (formData !== null && formData !== void 0 && (_formData$professiona14 = formData.professionaldetails) !== null && _formData$professiona14 !== void 0 && _formData$professiona14.validupto) {
        const formattedDate = formatValidUpto(formData.professionaldetails);
        setValue("professionaldetails.validupto", formattedDate || formData.professionaldetails.validupto);
      }
      if (formData !== null && formData !== void 0 && (_formData$landInfo = formData.landInfo) !== null && _formData$landInfo !== void 0 && (_formData$landInfo$ow = _formData$landInfo.owners) !== null && _formData$landInfo$ow !== void 0 && _formData$landInfo$ow[0]) {
        var _firstOwner$correspon, _firstOwner$correspon2, _firstOwner$correspon3, _firstOwner$correspon4;
        const firstOwner = formData.landInfo.owners[0];
        if (firstOwner.name) setValue("landInfo.owners.[0].name", firstOwner.name);
        if (firstOwner.mobileNumber) setValue("landInfo.owners.[0].mobileNumber", firstOwner.mobileNumber);
        if (firstOwner.emailId) setValue("landInfo.owners.[0].emailId", firstOwner.emailId);
        if ((_firstOwner$correspon = firstOwner.correspondenceAddress) !== null && _firstOwner$correspon !== void 0 && _firstOwner$correspon.state) setValue("landInfo.owners.[0].correspondenceAddress.state", firstOwner.correspondenceAddress.state);
        if ((_firstOwner$correspon2 = firstOwner.correspondenceAddress) !== null && _firstOwner$correspon2 !== void 0 && _firstOwner$correspon2.town) setValue("landInfo.owners.[0].correspondenceAddress.town", firstOwner.correspondenceAddress.town);
        if ((_firstOwner$correspon3 = firstOwner.correspondenceAddress) !== null && _firstOwner$correspon3 !== void 0 && _firstOwner$correspon3.pinno) setValue("landInfo.owners.[0].correspondenceAddress.pinno", firstOwner.correspondenceAddress.pinno);
        if ((_firstOwner$correspon4 = firstOwner.correspondenceAddress) !== null && _firstOwner$correspon4 !== void 0 && _firstOwner$correspon4.address) setValue("landInfo.owners.[0].correspondenceAddress.address", firstOwner.correspondenceAddress.address);
        if (firstOwner.inputonGST) setValue("landInfo.owners.[0].inputonGST", firstOwner.inputonGST);
        if (firstOwner.gstNumber) setValue("landInfo.owners.[0].gstNumber", firstOwner.gstNumber);
      }
      if (formData !== null && formData !== void 0 && formData.structuralInfo) {
        var _formData$structuralI;
        if (formData.structuralInfo.name) setValue("structuralInfo.name", formData.structuralInfo.name);
        if (formData.structuralInfo.licenseNumber) setValue("structuralInfo.licenseNumber", formData.structuralInfo.licenseNumber);
        if (formData.structuralInfo.validupto) {
          setValue("structuralInfo.validupto", formatValidUpto(formData.structuralInfo) || formData.structuralInfo.validupto);
        }
        if ((_formData$structuralI = formData.structuralInfo.permanentAddress) !== null && _formData$structuralI !== void 0 && _formData$structuralI.address) {
          setValue("structuralInfo.permanentAddress.address", formData.structuralInfo.permanentAddress.address);
        }
      }
    }
  }, [formData]);
  useEffect(() => {
    const fetchUserData = async () => {
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      if (uuid) {
        var _userResponse$user;
        const userResponse = await Digit.UserService.userSearch(tenantId, {
          uuid: [uuid]
        }, {});
        const fetchedUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$user = userResponse.user) === null || _userResponse$user === void 0 ? void 0 : _userResponse$user[0];
        setUser(fetchedUser);
        const existingCategory = getConsultantCategory(formData) || watch("professionaldetails.consultantCategory");
        if (fetchedUser && !isEmployee) {
          var _formData$professiona15, _formData$professiona16;
          if (!existingCategory) {
            var _fetchedUser$roles;
            const ltpRole = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$roles = fetchedUser.roles) === null || _fetchedUser$roles === void 0 ? void 0 : _fetchedUser$roles.find(e => !["CITIZEN", "EMPLOYEE", "OWNER"].includes(e.code));
            const category = (ltpRole === null || ltpRole === void 0 ? void 0 : ltpRole.name) || (ltpRole === null || ltpRole === void 0 ? void 0 : ltpRole.code) || "";
            if (category) {
              setValue("professionaldetails.consultantCategory", category);
            }
          }
          const existingCertNo = (formData === null || formData === void 0 ? void 0 : (_formData$professiona15 = formData.professionaldetails) === null || _formData$professiona15 === void 0 ? void 0 : _formData$professiona15.certificateNo) || watch("professionaldetails.certificateNo");
          if (!existingCertNo && fetchedUser !== null && fetchedUser !== void 0 && fetchedUser.registrationNumber) {
            setValue("professionaldetails.certificateNo", fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.registrationNumber);
          }
          const existingValidity = (formData === null || formData === void 0 ? void 0 : (_formData$professiona16 = formData.professionaldetails) === null || _formData$professiona16 === void 0 ? void 0 : _formData$professiona16.validupto) || watch("professionaldetails.validupto");
          if (!existingValidity) {
            const formattedDate = formatValidUpto(fetchedUser);
            if (formattedDate) {
              setValue("professionaldetails.validupto", formattedDate);
            }
          }
        }
      }
    };
    fetchUserData();
  }, []);
  useEffect(() => {
    const fetchStructuralEngineers = async () => {
      var _structualEngResponse;
      const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
        roleCodes: ["BPA_STRUCTURALENGINEER"],
        pageSize: "100000"
      });
      const users = (structualEngResponse === null || structualEngResponse === void 0 ? void 0 : (_structualEngResponse = structualEngResponse.user) === null || _structualEngResponse === void 0 ? void 0 : _structualEngResponse.filter(user => !["test", null].includes(user.registrationNumber))) || [];
      setEngsArr(users);
      const selectedEngineer = users.find(user => {
        var _formData$professiona17;
        return user.uuid === (formData === null || formData === void 0 ? void 0 : (_formData$professiona17 = formData.professionaldetails) === null || _formData$professiona17 === void 0 ? void 0 : _formData$professiona17.engineerUuid);
      });
      if (selectedEngineer) {
        setSelectedEng(selectedEngineer);
      }
    };
    fetchStructuralEngineers();
  }, [formData === null || formData === void 0 ? void 0 : (_formData$professiona18 = formData.professionaldetails) === null || _formData$professiona18 === void 0 ? void 0 : _formData$professiona18.engineerUuid]);
  useEffect(() => {
    const selectEng = engineersArr.filter(e => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      var _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const formattedDate = formatValidUpto(selectedEngineer);
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: getConsultantCategory(formData) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona19 = formData.professionaldetails) === null || _formData$professiona19 === void 0 ? void 0 : _formData$professiona19.consultantCategory),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchCategoryType
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona20 = formData.professionaldetails) === null || _formData$professiona20 === void 0 ? void 0 : _formData$professiona20.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona21 = formData.professionaldetails) === null || _formData$professiona21 === void 0 ? void 0 : _formData$professiona21.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona22 = formData.professionaldetails) === null || _formData$professiona22 === void 0 ? void 0 : _formData$professiona22.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona23 = formData.professionaldetails) === null || _formData$professiona23 === void 0 ? void 0 : _formData$professiona23.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona24 = formData.professionaldetails) === null || _formData$professiona24 === void 0 ? void 0 : _formData$professiona24.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona25 = formData.professionaldetails) === null || _formData$professiona25 === void 0 ? void 0 : _formData$professiona25.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona26 = formData.professionaldetails) === null || _formData$professiona26 === void 0 ? void 0 : _formData$professiona26.certificateNo,
    disabled: !!watchCertNo || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona27 = formData.professionaldetails) === null || _formData$professiona27 === void 0 ? void 0 : _formData$professiona27.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchValidity
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name,
    type: "specialChar",
    allowedChars: "&/, ",
    maxLength: 200,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : _formData$landInfo7$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 200,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo15 = formData.landInfo) === null || _formData$landInfo15 === void 0 ? void 0 : (_formData$landInfo15$ = _formData$landInfo15.owners) === null || _formData$landInfo15$ === void 0 ? void 0 : (_formData$landInfo15$2 = _formData$landInfo15$[0]) === null || _formData$landInfo15$2 === void 0 ? void 0 : (_formData$landInfo15$3 = _formData$landInfo15$2.correspondenceAddress) === null || _formData$landInfo15$3 === void 0 ? void 0 : _formData$landInfo15$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Do you want to take input on GST")}`,
    name: "landInfo.owners.[0].inputonGST",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo16 = formData.landInfo) === null || _formData$landInfo16 === void 0 ? void 0 : (_formData$landInfo16$ = _formData$landInfo16.owners) === null || _formData$landInfo16$ === void 0 ? void 0 : (_formData$landInfo16$2 = _formData$landInfo16$[0]) === null || _formData$landInfo16$2 === void 0 ? void 0 : _formData$landInfo16$2.inputonGST,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchInputOnGST === "yes" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.value) === "yes" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.code) === "Y" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.code) === "YES") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter GST No"),
    control: control,
    placeholder: t("GST No"),
    type: "textInput",
    name: "landInfo.owners.[0].gstNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo17 = formData.landInfo) === null || _formData$landInfo17 === void 0 ? void 0 : (_formData$landInfo17$ = _formData$landInfo17.owners) === null || _formData$landInfo17$ === void 0 ? void 0 : (_formData$landInfo17$2 = _formData$landInfo17$[0]) === null || _formData$landInfo17$2 === void 0 ? void 0 : _formData$landInfo17$2.gstNumber,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("GSTNo"),
        message: "Please enter valid GST No"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.name,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.licenseNumber,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : _formData$structuralI4.validupto,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI5 = formData.structuralInfo) === null || _formData$structuralI5 === void 0 ? void 0 : (_formData$structuralI6 = _formData$structuralI5.permanentAddress) === null || _formData$structuralI6 === void 0 ? void 0 : _formData$structuralI6.address,
    type: "textInput",
    disabled: true,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Engineer Signature"),
    control: control,
    name: "sesignature",
    validationMsg: "Upload File",
    trigger: trigger,
    tab: 2
  })), /*#__PURE__*/React__default.createElement(Col, null)))), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

function KmlFileUploader({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  tab,
  showError,
  maxFiles
}) {
  const {
    documents
  } = useSelector(state => state.formMT);
  const dispatch = useDispatch();
  const {
    addFormMTDoc,
    removeFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    control
  } = useForm();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);
  const handleFileUpload = async (e, inputName) => {
    const file = e.target.files[0];
    setIsLoading(true);
    setShowToast(null);
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    const fileExtension = file.name.split(".").pop();
    const maxSizeInBytes = tab === 1 || tab === 2 ? 10 * 1024 * 1024 : 30 * 1024 * 1024;
    const allowedFormats = [".kml", ".KML"];
    if (!allowedFormats.includes(`.${fileExtension}`)) {
      setShowToast({
        error: true,
        label: `Please select a file with a valid format (.kml, .KML)`
      });
      setIsLoading(false);
      return;
    }
    if ((documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === name).length) >= maxFiles) {
      setShowToast({
        error: true,
        label: `You can upload a maximum of ${maxFiles} files.`
      });
      setIsLoading(false);
      return;
    }
    if (file.size > maxSizeInBytes) {
      setShowToast({
        error: true,
        label: `File size exceeds the maximum limit of 10 MB.`
      });
      setIsLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addFormMTDoc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        isMandatory,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
      e.target.value = null;
      setFileName(file.name);
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: "flex-start"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: `label`,
    style: {
      width: "100%"
    }
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flexDirection: "column",
      position: "relative",
      width: "100%",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true,
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      display: "flex",
      justifyContent: "space-between",
      height: "30px",
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c",
        color: "#fff"
      },
      position: "relative"
    },
    disabled: (documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === name).length) >= maxFiles
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "center",
      position: "absolute",
      alignItems: "center",
      display: "flex",
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: "absolute",
      fontSize: "0.5rem",
      marginLeft: "8em"
    }
  }, validationMsg))), /*#__PURE__*/React__default.createElement(Controller, {
    name: "fileInput",
    control: control,
    rules: {
      required: required && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name))
    },
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement("input", {
      ref: fileInputRef,
      type: "file",
      name: name,
      onChange: e => handleFileUpload(e, name),
      style: {
        display: "none"
      }
    })
  })), (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && !isLoading && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map(doc => {
    var _doc$additionalDetail;
    if (doc.documentType !== name) return null;
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: "space-between",
        p: "0.25rem 0 0.25rem 0.75rem",
        backgroundColor: "#eee",
        borderRadius: "0.25rem",
        wordBreak: "break-all",
        alignItems: "center",
        display: "flex",
        lineHeight: 1,
        flex: 1,
        height: "18px",
        fontSize: "0.6rem"
      },
      key: doc.fileStoreId
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 20
    }) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => removeFormMTDoc(doc.documentType)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  })) || null)), required && showError && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name)) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, `${label} document is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label));
}

const Map$1 = ({
  formData
}) => {
  const [latitude, longitude] = formData === null || formData === void 0 ? void 0 : formData.split(",").map(Number);
  const onChange = (pincode, position) => {
    var _config;
    onSelect((_config = config) === null || _config === void 0 ? void 0 : _config.key, position);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col items-center justify-center h-screen"
  }, /*#__PURE__*/React__default.createElement(LocationSearch, {
    position: {
      latitude: latitude,
      longitude: longitude
    },
    onChange: onChange
  }));
};

const MapSiteInspection = ({
  formData
}) => {
  var _formData$description, _formData$description2;
  const [openMap, setOpenMap] = useState(false);
  const latLong = formData !== null && formData !== void 0 && (_formData$description = formData.descriptionOfLand) !== null && _formData$description !== void 0 && _formData$description.latitude && formData !== null && formData !== void 0 && (_formData$description2 = formData.descriptionOfLand) !== null && _formData$description2 !== void 0 && _formData$description2.longitude ? `${formData.descriptionOfLand.latitude},${formData.descriptionOfLand.longitude}` : null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, latLong && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => setOpenMap(true),
    style: {
      marginBottom: "10px"
    }
  }, "Show Map"), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: openMap,
    onClose: () => setOpenMap(false),
    maxWidth: false,
    PaperProps: {
      style: {
        marginTop: "5%",
        width: '65%',
        maxWidth: '65%',
        maxHeight: 460,
        overflow: 'auto'
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      m: 0,
      p: 2
    }
  }, "Map", /*#__PURE__*/React__default.createElement(IconButton$1, {
    "aria-label": "close",
    onClick: () => setOpenMap(false),
    sx: {
      position: 'absolute',
      right: 8,
      top: 8,
      color: theme => theme.palette.grey[500]
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    dividers: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "0px",
      marginTop: "1%"
    }
  }, /*#__PURE__*/React__default.createElement(Map$1, {
    formData: latLong
  }))))));
};

const boundaryOptions = ["Road", "Existing Structure", "Plot", "Open Space", "Park", "Other"];
const BoundaryRow = ({
  direction,
  name,
  register,
  watch,
  setValue,
  defaultType,
  defaultValue
}) => {
  const fieldType = `descriptionOfLand.scheduleOfBoundaries.${name}.type`;
  const fieldValue = `descriptionOfLand.scheduleOfBoundaries.${name}.value`;
  const selectedType = watch(fieldType) || defaultType || "Road";
  useEffect(() => {
    if (!watch(fieldType)) {
      setValue(fieldType, defaultType || "Road");
    }
    if (defaultValue !== undefined && defaultValue !== null && watch(fieldValue) === undefined) {
      setValue(fieldValue, defaultValue);
    }
  }, []);
  const isRoad = selectedType === "Road";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "17% 23% 10% 25% 25%",
      minHeight: "40px",
      alignItems: "center",
      borderBottom: "1px solid #eeeeee",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "7px 28px",
      fontSize: "14px",
      color: "#333"
    }
  }, direction), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0 8px"
    }
  }, /*#__PURE__*/React__default.createElement("select", Object.assign({}, register(fieldType), {
    defaultValue: defaultType || "Road",
    style: {
      width: "100%",
      height: "34px",
      padding: "0 10px",
      border: "1px solid #cccccc",
      borderRadius: "2px",
      backgroundColor: "#f5f5f5",
      color: "#555",
      fontSize: "14px",
      outline: "none",
      cursor: "pointer"
    }
  }), boundaryOptions.map(option => /*#__PURE__*/React__default.createElement("option", {
    key: option,
    value: option
  }, option)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "8px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#555"
    }
  }, isRoad ? "Width" : "No."), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0 8px"
    }
  }, /*#__PURE__*/React__default.createElement("input", Object.assign({}, register(fieldValue), {
    type: "text",
    defaultValue: defaultValue || "",
    placeholder: isRoad ? "Enter Width" : "Enter Details",
    style: {
      width: "100%",
      height: "34px",
      boxSizing: "border-box",
      padding: "0 12px",
      border: "1px solid #cccccc",
      borderRadius: "2px",
      backgroundColor: "#f5f5f5",
      color: "#555",
      fontSize: "14px",
      outline: "none"
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: "8px",
      fontSize: "14px",
      color: "#555"
    }
  }, isRoad ? "Mt." : ""));
};
const SubStep4 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$documents, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _defaultValues$descri, _defaultValues$descri2, _defaultValues$descri3, _defaultValues$descri4, _defaultValues$descri5, _defaultValues$descri6, _defaultValues$descri7, _defaultValues$descri8, _defaultValues$descri9, _defaultValues$descri10, _defaultValues$descri11, _defaultValues$descri12, _defaultValues$descri13, _defaultValues$descri14, _defaultValues$descri15, _defaultValues$descri16, _defaultValues$descri17, _defaultValues$descri18, _defaultValues$descri19, _defaultValues$descri20, _defaultValues$descri21, _defaultValues$descri22, _defaultValues$descri23, _defaultValues$descri24;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = React__default.useState(false);
  const [loading, setLoading] = React__default.useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      scheduleOfBoundaries: {
        north: {
          type: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.scheduleOfBoundaries) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2.north) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.type) || "Road",
          value: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4.scheduleOfBoundaries) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5.north) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.value) || ""
        },
        south: {
          type: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : (_formData$description8 = _formData$description7.scheduleOfBoundaries) === null || _formData$description8 === void 0 ? void 0 : (_formData$description9 = _formData$description8.south) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.type) || "Existing Structure",
          value: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : (_formData$description11 = _formData$description10.scheduleOfBoundaries) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11.south) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.value) || ""
        },
        west: {
          type: (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13.scheduleOfBoundaries) === null || _formData$description14 === void 0 ? void 0 : (_formData$description15 = _formData$description14.west) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.type) || "Plot",
          value: (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : (_formData$description17 = _formData$description16.scheduleOfBoundaries) === null || _formData$description17 === void 0 ? void 0 : (_formData$description18 = _formData$description17.west) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.value) || ""
        },
        east: {
          type: (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : (_formData$description20 = _formData$description19.scheduleOfBoundaries) === null || _formData$description20 === void 0 ? void 0 : (_formData$description21 = _formData$description20.east) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.type) || "Existing Structure",
          value: (formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : (_formData$description23 = _formData$description22.scheduleOfBoundaries) === null || _formData$description23 === void 0 ? void 0 : (_formData$description24 = _formData$description23.east) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.value) || ""
        }
      }
    }
  };
  const {
    handleSubmit,
    control,
    register,
    setValue,
    watch
  } = useForm({
    defaultValues
  });
  const kmlFile = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.find(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === "kmlFile");
  useEffect(() => {
    setValue("documents", documents);
  }, [documents, setValue]);
  const onSubmit = data => {
    console.log("SUBSTEP 4 DATA :", data);
    handleSubTabChange(4, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    style: {
      display: "block",
      marginBottom: "6px",
      fontSize: "14px",
      color: "#333"
    }
  }, "Latitude ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement("input", Object.assign({}, register("descriptionOfLand.latitude", {
    required: "This field is required"
  }), {
    type: "text",
    placeholder: "Enter Latitude",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.latitude) || "",
    maxLength: 10,
    disabled: !!(formData !== null && formData !== void 0 && (_formData$description26 = formData.descriptionOfLand) !== null && _formData$description26 !== void 0 && _formData$description26.latitude),
    style: {
      width: "100%",
      height: "38px",
      boxSizing: "border-box",
      padding: "0 12px",
      border: "1px solid #cccccc",
      borderRadius: "4px",
      backgroundColor: formData !== null && formData !== void 0 && (_formData$description27 = formData.descriptionOfLand) !== null && _formData$description27 !== void 0 && _formData$description27.latitude ? "#eeeeee" : "#fff"
    }
  }))), isEmployee ? /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, kmlFile && /*#__PURE__*/React__default.createElement("div", {
    className: "download-kml",
    style: {
      display: "flex",
      alignItems: "center",
      gap: "280px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "KML File:"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "large",
    color: "info",
    onClick: () => getDocumentByFileStoreId(kmlFile === null || kmlFile === void 0 ? void 0 : kmlFile.fileStoreId, setLoading)
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "14px",
      height: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(TravelExploreOutlinedIcon, {
    color: "primary",
    sx: {
      fontSize: "14px"
    }
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555",
      marginLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(MapSiteInspection, {
    formData: formData
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    style: {
      display: "block",
      marginBottom: "6px",
      fontSize: "14px",
      color: "#333"
    }
  }, "Longitude ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement("input", Object.assign({}, register("descriptionOfLand.longitude", {
    required: "This field is required"
  }), {
    type: "text",
    placeholder: "Enter Longitude",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.longitude) || "",
    maxLength: 10,
    disabled: !!(formData !== null && formData !== void 0 && (_formData$description29 = formData.descriptionOfLand) !== null && _formData$description29 !== void 0 && _formData$description29.longitude),
    style: {
      width: "100%",
      height: "38px",
      boxSizing: "border-box",
      padding: "0 12px",
      border: "1px solid #cccccc",
      borderRadius: "4px",
      backgroundColor: formData !== null && formData !== void 0 && (_formData$description30 = formData.descriptionOfLand) !== null && _formData$description30 !== void 0 && _formData$description30.longitude ? "#eeeeee" : "#fff"
    }
  })))), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      marginTop: "10px",
      border: "1px solid #d5d5d5",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "38px",
      display: "flex",
      alignItems: "center",
      padding: "0 8px",
      borderBottom: "1px solid #dddddd",
      color: "#4285b4",
      fontSize: "20px",
      fontWeight: "400",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "16px",
      marginRight: "5px",
      color: "#333"
    }
  }, "\u25B2"), "Schedule of Boundaries"), /*#__PURE__*/React__default.createElement(BoundaryRow, {
    direction: "North",
    name: "north",
    register: register,
    watch: watch,
    setValue: setValue,
    defaultType: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri = defaultValues.descriptionOfLand) === null || _defaultValues$descri === void 0 ? void 0 : (_defaultValues$descri2 = _defaultValues$descri.scheduleOfBoundaries) === null || _defaultValues$descri2 === void 0 ? void 0 : (_defaultValues$descri3 = _defaultValues$descri2.north) === null || _defaultValues$descri3 === void 0 ? void 0 : _defaultValues$descri3.type,
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri4 = defaultValues.descriptionOfLand) === null || _defaultValues$descri4 === void 0 ? void 0 : (_defaultValues$descri5 = _defaultValues$descri4.scheduleOfBoundaries) === null || _defaultValues$descri5 === void 0 ? void 0 : (_defaultValues$descri6 = _defaultValues$descri5.north) === null || _defaultValues$descri6 === void 0 ? void 0 : _defaultValues$descri6.value
  }), /*#__PURE__*/React__default.createElement(BoundaryRow, {
    direction: "South",
    name: "south",
    register: register,
    watch: watch,
    setValue: setValue,
    defaultType: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri7 = defaultValues.descriptionOfLand) === null || _defaultValues$descri7 === void 0 ? void 0 : (_defaultValues$descri8 = _defaultValues$descri7.scheduleOfBoundaries) === null || _defaultValues$descri8 === void 0 ? void 0 : (_defaultValues$descri9 = _defaultValues$descri8.south) === null || _defaultValues$descri9 === void 0 ? void 0 : _defaultValues$descri9.type,
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri10 = defaultValues.descriptionOfLand) === null || _defaultValues$descri10 === void 0 ? void 0 : (_defaultValues$descri11 = _defaultValues$descri10.scheduleOfBoundaries) === null || _defaultValues$descri11 === void 0 ? void 0 : (_defaultValues$descri12 = _defaultValues$descri11.south) === null || _defaultValues$descri12 === void 0 ? void 0 : _defaultValues$descri12.value
  }), /*#__PURE__*/React__default.createElement(BoundaryRow, {
    direction: "West",
    name: "west",
    register: register,
    watch: watch,
    setValue: setValue,
    defaultType: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri13 = defaultValues.descriptionOfLand) === null || _defaultValues$descri13 === void 0 ? void 0 : (_defaultValues$descri14 = _defaultValues$descri13.scheduleOfBoundaries) === null || _defaultValues$descri14 === void 0 ? void 0 : (_defaultValues$descri15 = _defaultValues$descri14.west) === null || _defaultValues$descri15 === void 0 ? void 0 : _defaultValues$descri15.type,
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri16 = defaultValues.descriptionOfLand) === null || _defaultValues$descri16 === void 0 ? void 0 : (_defaultValues$descri17 = _defaultValues$descri16.scheduleOfBoundaries) === null || _defaultValues$descri17 === void 0 ? void 0 : (_defaultValues$descri18 = _defaultValues$descri17.west) === null || _defaultValues$descri18 === void 0 ? void 0 : _defaultValues$descri18.value
  }), /*#__PURE__*/React__default.createElement(BoundaryRow, {
    direction: "East",
    name: "east",
    register: register,
    watch: watch,
    setValue: setValue,
    defaultType: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri19 = defaultValues.descriptionOfLand) === null || _defaultValues$descri19 === void 0 ? void 0 : (_defaultValues$descri20 = _defaultValues$descri19.scheduleOfBoundaries) === null || _defaultValues$descri20 === void 0 ? void 0 : (_defaultValues$descri21 = _defaultValues$descri20.east) === null || _defaultValues$descri21 === void 0 ? void 0 : _defaultValues$descri21.type,
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$descri22 = defaultValues.descriptionOfLand) === null || _defaultValues$descri22 === void 0 ? void 0 : (_defaultValues$descri23 = _defaultValues$descri22.scheduleOfBoundaries) === null || _defaultValues$descri23 === void 0 ? void 0 : (_defaultValues$descri24 = _defaultValues$descri23.east) === null || _defaultValues$descri24 === void 0 ? void 0 : _defaultValues$descri24.value
  })), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step2$1 = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  var _Digit$UserService$ge, _formData$mapSubDetai, _formData$description;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("documentsFromReduxghjasd", documents, formData);
  const userInfo = Digit.UserService.getUser();
  const scrutinyFlow = (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const {
    t
  } = useTranslation();
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const isCompounding = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_COMPOUNDING";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const [noticeDocument, setNoticeDocument] = useState();
  const compensatoryFarDoc = Digit.SessionStorage.get("compensatoryFarDoc");
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const approvalLetterUrl = (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter);
  const showApprovedDocs = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Revalidation/Time Extension" || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Revision";
  const defaultValues = {
    ...formData,
    compoundingDrawingDxf: (formData === null || formData === void 0 ? void 0 : formData.compoundingDrawingDxf) || {
      fileStoreId: "",
      name: ""
    }
  };
  const [formDocuments, setFormDocuments] = useState([]);
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const {
    handleSubmit,
    control,
    setValue,
    trigger,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    var _formData$compounding;
    reset({
      ...formData,
      compoundingDrawingDxf: formData !== null && formData !== void 0 && (_formData$compounding = formData.compoundingDrawingDxf) !== null && _formData$compounding !== void 0 && _formData$compounding.fileStoreId ? formData === null || formData === void 0 ? void 0 : formData.compoundingDrawingDxf : file || {
        fileStoreId: "",
        name: ""
      }
    });
  }, [formData, documents, file, reset]);
  useEffect(() => {
    var _formData$documents;
    if (formData !== null && formData !== void 0 && formData.documents && (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      const docs = [...formData.documents];
      setFormDocuments(docs);
      initFormMTDocs(docs);
    }
  }, [formData]);
  console.log("FORMDAtaDocuments", formDocuments);
  useEffect(() => {
    if (file) {
      setValue("compoundingDrawingDxf", file);
    }
  }, [file]);
  const onChangeNoticeNo = async vaadId => {
    if (!vaadId) return;
    console.log("Fetching notice for Vaad ID:", vaadId);
    const url = `${Urls$1.bpaService.getNotice}${encodeURIComponent(vaadId)}`;
    const body = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: `${Date.now()}|en_IN`
      }
    };
    try {
      const response = await axios$1.post(url, body, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json, text/plain, */*"
        }
      });
      if (response !== null && response !== void 0 && response.data) {
        console.log("✅ Notice data fetched successfully:", response.data);
        const urls = response.data.noticeData.map(item => item === null || item === void 0 ? void 0 : item.Url);
        setNoticeDocument(urls);
      } else {
        console.warn("No notice data found in the response.");
      }
    } catch (error) {
      console.error("Error fetching notice:", error);
    }
  };
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.vaadId) {
      onChangeNoticeNo(formData === null || formData === void 0 ? void 0 : formData.vaadId);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.vaadId]);
  const maintainDocumentHistory = (previousDocs = [], currentDocs = []) => {
    const result = [...currentDocs];
    const documentTypes = [...new Set(previousDocs.map(doc => doc.documentType).filter(Boolean).map(type => type.replace(/_\d+$/, "")))];
    documentTypes.forEach(baseType => {
      const currentDoc = currentDocs.find(doc => doc.documentType === baseType);
      if (!currentDoc) return;
      const previousVersions = previousDocs.filter(doc => {
        if (!doc.documentType) return false;
        const normalizedType = doc.documentType.replace(/_\d+$/, "");
        return normalizedType === baseType && doc.fileStoreId !== currentDoc.fileStoreId;
      }).sort((a, b) => {
        const getHistoryIndex = documentType => {
          if (documentType === baseType) {
            return 0;
          }
          const match = documentType.match(/_(\d+)$/);
          return match ? Number(match[1]) : 999;
        };
        return getHistoryIndex(a.documentType) - getHistoryIndex(b.documentType);
      });
      if (!previousVersions.length) return;
      const filteredResult = result.filter(doc => {
        if (!doc.documentType) return true;
        const normalizedType = doc.documentType.replace(/_\d+$/, "");
        return normalizedType !== baseType;
      });
      const history = [{
        ...currentDoc,
        documentType: baseType
      }];
      previousVersions.slice(0, 4).forEach((doc, index) => {
        history.push({
          ...doc,
          documentType: `${baseType}_${index + 1}`
        });
      });
      result.length = 0;
      result.push(...filteredResult, ...history);
    });
    return result;
  };
  const onSubmit = data => {
    var _formData$documents2, _formData$additionalD, _formData$additionalD2, _formData$drawingPdf;
    const newDocs = maintainDocumentHistory(formDocuments, documents);
    const currentDrawingPdfDoc = documents === null || documents === void 0 ? void 0 : documents.find(doc => doc.documentType === "drawingPdf");
    const currentDrawingPdfFileStoreId = (currentDrawingPdfDoc === null || currentDrawingPdfDoc === void 0 ? void 0 : currentDrawingPdfDoc.fileStoreId) || null;
    const originalDrawingPdfDoc = (formDocuments === null || formDocuments === void 0 ? void 0 : formDocuments.find(doc => doc.documentType === "drawingPdf")) || (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.find(doc => doc.documentType === "drawingPdf")) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.documents) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.find(doc => doc.documentType === "drawingPdf"));
    const originalDrawingPdfFileStoreId = (originalDrawingPdfDoc === null || originalDrawingPdfDoc === void 0 ? void 0 : originalDrawingPdfDoc.fileStoreId) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingPdf = formData.drawingPdf) === null || _formData$drawingPdf === void 0 ? void 0 : _formData$drawingPdf.fileStoreId) || (typeof (formData === null || formData === void 0 ? void 0 : formData.drawingPdf) === "string" ? formData === null || formData === void 0 ? void 0 : formData.drawingPdf : null) || null;
    const hasDrawingPdfChanged = formData !== null && formData !== void 0 && formData.edcrNumber ? false : Boolean(currentDrawingPdfFileStoreId && currentDrawingPdfFileStoreId !== originalDrawingPdfFileStoreId || !currentDrawingPdfFileStoreId && originalDrawingPdfFileStoreId);
    const defaultIsSigned = (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) !== undefined ? formData.IsSignedDrawingPdfURL : (data === null || data === void 0 ? void 0 : data.IsSignedDrawingPdfURL) !== undefined ? data.IsSignedDrawingPdfURL : false;
    const defaultSignedPdfUrl = (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) !== undefined ? formData.signedDrawingPdfURL : (data === null || data === void 0 ? void 0 : data.signedDrawingPdfURL) !== undefined ? data.signedDrawingPdfURL : null;
    const defaultSignedPdfId = (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfId) !== undefined ? formData.signedDrawingPdfId : (data === null || data === void 0 ? void 0 : data.signedDrawingPdfId) !== undefined ? data.signedDrawingPdfId : null;
    const updatedData = {
      ...data,
      nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails,
      documents: newDocs || documents,
      compoundingDrawingDxf: file,
      IsSignedDrawingPdfURL: hasDrawingPdfChanged ? false : defaultIsSigned,
      signedDrawingPdfURL: hasDrawingPdfChanged ? null : defaultSignedPdfUrl,
      signedDrawingPdfId: hasDrawingPdfChanged ? null : defaultSignedPdfId
    };
    console.log("dataFromDocComponent", updatedData);
    console.log("NEWDOCS", newDocs);
    handleTabChange(2, updatedData);
  };
  useEffect(() => {
    console.log("Notice Doc from Step2:", formData === null || formData === void 0 ? void 0 : formData.noticeDocument);
  }, [formData]);
  console.log("noticeDocument", formData === null || formData === void 0 ? void 0 : formData.noticeDocument);
  useEffect(() => {
    if (file) {
      setValue("compoundingDrawingDxf", file);
    }
  }, [file]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  console.log("formDataInStep2", formData, isCompounding);
  const handleOpenApprovalLetter = () => {
    if (approvalLetterUrl) {
      window.open(approvalLetterUrl, "_blank");
    }
  };
  const showSanctionDocs = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "New" && ((formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "Compounding" || (formData === null || formData === void 0 ? void 0 : formData.serviceType) === "yes" || (formData === null || formData === void 0 ? void 0 : formData.shortName) === "yes");
  const isSanctionDocMandatory = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "Redevelopment/Reconstruction" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "Redevelopment";
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, showSanctionDocs && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Sanction Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Previous Sanction Map"),
    control: control,
    name: "Previous Sanction Map",
    validationMsg: "Upload File",
    required: isSanctionDocMandatory,
    isMandatory: isSanctionDocMandatory,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Previous Sanction Letter"),
    control: control,
    name: "Previous Sanction Letter",
    validationMsg: "Upload File",
    required: isSanctionDocMandatory,
    isMandatory: isSanctionDocMandatory,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)", isSanctionDocMandatory ? "*" : "")))))), (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Compounding" && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Compounding Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding Drawing PDF"),
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    required: true,
    tab: "pdf",
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Compounding drawing dwg"),
    control: control,
    name: "compoundingDrawingDxf",
    validationMsg: "Upload File",
    trigger: trigger,
    tab: 3,
    setFile: setFile,
    required: true,
    isMandatory: true
  })), (formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty) === "In response to notice" && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upload Notice"),
    control: control,
    name: "responseNotice",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), (noticeDocument === null || noticeDocument === void 0 ? void 0 : noticeDocument.length) > 0 && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Notice Document:"), " ", noticeDocument.map((url, index) => /*#__PURE__*/React__default.createElement("ul", {
    key: index
  }, /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: "#007bff",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }, "Download Notice Document", index + 1))))), /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Architect/Engineer Registration Certificate"),
    control: control,
    name: "Registration Certificate",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    trigger: trigger
  })), !isLowRiskCase && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Calculation sheet of Estimate with Affidavit"),
    control: control,
    name: "calculationSheet",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Khatauni"),
    control: control,
    name: "khatauni",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ownerAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    label: t("Allotment Letter/Possession Letter"),
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement"),
    control: control,
    name: "registrySaleDeedHPTA",
    isMandatory: true,
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), compensatoryFarDoc && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Compensatory FAR Document : "), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(compensatoryFarDoc, setLoader, false)
  }))), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Developer/Consortium/Sales Agreement"),
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    trigger: trigger
  })), !isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), scrutinyFlow && !isCompounding && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Dwg drawing"),
    control: control,
    name: "dxfDrawing",
    isMandatory: true,
    required: true,
    validationMsg: "Upload File",
    trigger: trigger,
    tab: 3
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Letter:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: handleOpenApprovalLetter
  }))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Fire Affidavit"),
    control: control,
    name: "fireAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }), !isLowRiskCase && !isCompounding || isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    tab: "pdf",
    label: t("Drawing Pdf"),
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    trigger: trigger
  })), formData !== null && formData !== void 0 && formData.edcrNumber ? /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  }))) : /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Drawing Pdf"),
    isMandatory: true,
    required: true,
    tab: "pdf",
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    trigger: trigger
  })), isCompounding && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding Affidavit"),
    control: control,
    name: "compoundingAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "sitePhoto",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*")))))), showApprovedDocs && /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approved Certificate"), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, formData !== null && formData !== void 0 && formData.approvalCertificateUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl, "_blank")
  }) : /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#00000057",
    style: {
      width: "20px",
      height: "30px"
    }
  })))), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approved Letter"), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, approvalLetterUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(approvalLetterUrl, "_blank")
  }) : /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#00000057",
    style: {
      width: "20px",
      height: "30px"
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    onClick: () => setOpen(prev => !prev),
    style: {
      cursor: "pointer",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents")), /*#__PURE__*/React__default.createElement(ExpandMoreIcon, {
    style: {
      position: "absolute",
      right: "16px",
      top: "50%",
      transform: open ? "translateY(-50%) rotate(180deg)" : "translateY(-50%) rotate(0deg)",
      transition: "0.3s"
    }
  })), open && /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Audit Report"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Additional Document if any"),
    control: control,
    name: "additionalDoc",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Drawing and Design"),
    control: control,
    name: "structuraldrawing",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Stability Certificate"),
    control: control,
    name: "structuralcertificate",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Design calculation Report"),
    control: control,
    name: "calculationReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Vetted Structure and drawing along with certificate"),
    control: control,
    name: "vettedStructure",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer."),
    control: control,
    name: "annexture789",
    validationMsg: "Upload File"
  })), isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Approved Layout sanctioned Letter"),
    control: control,
    name: "sanctionLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (Allowed Format .pdf)*"))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step5 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$taxHeadEsti, _data$BPA, _feeDetail$mapRate, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _feeDetail$mapRate2, _feeDetail$mapRate3, _feeDetail$mapRate4, _feeDetail$mapRate5;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const [taxHead, setTaxHead] = useState([]);
  const paymentHeads = data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA.MapSubPaymentHeads;
  const isCompounding = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Compounding";
  const isNew = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "New";
  const isAddition = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Addition Extension" || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Revision";
  const isRevalidation = (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Revalidation/Time Extension";
  console.log(paymentHeads, isCompounding, "paymentheads");
  const paymentHeadsDropdown = paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map(item => ({
    name: item.label,
    label: item.label,
    value: item.label
  }));
  const defaultValues = {
    ...formData,
    paymentHeads: (formData === null || formData === void 0 ? void 0 : formData.paymentHeads) || [{
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    }]
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "paymentHeads"
  });
  const handleAddInput = () => {
    append({
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    });
  };
  const handleCalculate = async () => {
    var _data$Calculations, _data$Calculations$, _data$Calculations$$t, _data$Calculations$$t2;
    const paymentHeads = watch("paymentHeads");
    const checkedheads = paymentHeads.filter(e => e.checked);
    console.log({
      paymentHeads,
      checkedheads
    }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{
      BPA: {
        ...formData
      },
      tenantId: "up",
      feeType: "ApplicationFee"
    }];
    const data = await Digit.OBPSService.bpacalculate({
      CalulationCriteria
    });
    console.log(data, "calculationData");
    setTaxHead(data === null || data === void 0 ? void 0 : (_data$Calculations = data.Calculations) === null || _data$Calculations === void 0 ? void 0 : (_data$Calculations$ = _data$Calculations[0]) === null || _data$Calculations$ === void 0 ? void 0 : (_data$Calculations$$t = _data$Calculations$.taxHeadEstimates) === null || _data$Calculations$$t === void 0 ? void 0 : (_data$Calculations$$t2 = _data$Calculations$$t[0]) === null || _data$Calculations$$t2 === void 0 ? void 0 : _data$Calculations$$t2.paymentHeads);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);
    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          var _ranges$find;
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (((_ranges$find = ranges.find(r => r.area === "501-1000")) === null || _ranges$find === void 0 ? void 0 : _ranges$find.rate) || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0;
  };
  const totalTaxHeadAmount = taxHead === null || taxHead === void 0 ? void 0 : taxHead.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate = feeDetail.mapRate) === null || _feeDetail$mapRate === void 0 ? void 0 : _feeDetail$mapRate.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  const onSubmit = data => {
    data.paymentHeads = taxHead;
    if (isCompounding) {
      handleTabChange(5, data, false);
    } else {
      handleTabChange(4, data);
    }
  };
  console.log("formDataInStep5", formData, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3.mapRate) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.price, feeDetail);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, formData !== null && formData !== void 0 && formData.isGovernmentBuilding && (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) === "yes" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("h4", null, "No Fees Required For Government Buildings.")))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Builtup Area:"), " (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rate:"), " (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.unitPrice)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:"), " (\u20B9)"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, isRevalidation ? feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount : feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate3 = feeDetail.mapRate) === null || _feeDetail$mapRate3 === void 0 ? void 0 : _feeDetail$mapRate3.price))))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && !isCompounding && !isNew && !isAddition && !isRevalidation && /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "formHeaderContainer",
    style: {
      marginTop: "20px",
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%",
      padding: "4px"
    }
  }, "Select"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "30%",
      padding: "4px"
    }
  }, "Payment Heads"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Build Up Area (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Area by LTP", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Rate (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)))), /*#__PURE__*/React__default.createElement("tbody", null, paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: `paymentHeads[${index}].checked`,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })), /*#__PURE__*/React__default.createElement("td", null, item.label), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].plotBuildUpArea`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    width: "12vw"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].updatedAreaJE`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    defaultValue: item !== null && item !== void 0 && item.buildUpArea ? formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea : formData === null || formData === void 0 ? void 0 : formData.plotArea,
    width: "12vw",
    height: "22px",
    className: "paymentHeadInput"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].rate`,
    hasLabel: false,
    control: control,
    placeholder: "Enter rate",
    type: "textInput",
    width: "12vw",
    defaultValue: item.hasOwnProperty("rate") ? item.rate : calculateRate(formData === null || formData === void 0 ? void 0 : formData.plotArea, item.slabs)
  })))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && !isCompounding && !isNew && !isAddition && !isRevalidation && /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    className: "gradientButton",
    size: "medium",
    style: {
      borderRadius: "24px"
    },
    onClick: handleAddInput
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon$1, null), "Add More")), !(formData !== null && formData !== void 0 && formData.edcrNumber) && !isCompounding && !isNew && !isAddition && !isRevalidation && /*#__PURE__*/React__default.createElement(Button$3, {
    className: "gradientButton mb-4",
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      color: "white",
      borderRadius: "24px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
      marginLeft: "50%"
    },
    onClick: handleCalculate
  }, "Calculate"), !(formData !== null && formData !== void 0 && formData.edcrNumber) && !isCompounding && !isNew && !isAddition && !isRevalidation && /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    sx: {
      minWidth: 650
    },
    "aria-label": "fee table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white"
  }, "Fee Type"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Built Up Area (sqmt.)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Rate (\u20B9)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Amount (\u20B9)"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, taxHead === null || taxHead === void 0 ? void 0 : taxHead.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.plotBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.amount))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 0,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, "Fee On Plot"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate4 = feeDetail.mapRate) === null || _feeDetail$mapRate4 === void 0 ? void 0 : _feeDetail$mapRate4.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate5 = feeDetail.mapRate) === null || _feeDetail$mapRate5 === void 0 ? void 0 : _feeDetail$mapRate5.price)), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      fontWeight: "bold",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 3,
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2)))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#180c0c"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
}

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var lookup = new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}
var encodeToBase64 = function (bytes) {
  var base64 = '';
  var len = bytes.length;
  for (var i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
    base64 += chars[bytes[i + 2] & 63];
  }
  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }
  return base64;
};
var decodeFromBase64 = function (base64) {
  var bufferLength = base64.length * 0.75;
  var len = base64.length;
  var i;
  var p = 0;
  var encoded1;
  var encoded2;
  var encoded3;
  var encoded4;
  if (base64[base64.length - 1] === '=') {
    bufferLength--;
    if (base64[base64.length - 2] === '=') {
      bufferLength--;
    }
  }
  var bytes = new Uint8Array(bufferLength);
  for (i = 0; i < len; i += 4) {
    encoded1 = lookup[base64.charCodeAt(i)];
    encoded2 = lookup[base64.charCodeAt(i + 1)];
    encoded3 = lookup[base64.charCodeAt(i + 2)];
    encoded4 = lookup[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return bytes;
};
var DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var decodeFromBase64DataUri = function (dataUri) {
  var trimmedUri = dataUri.trim();
  var prefix = trimmedUri.substring(0, 100);
  var res = prefix.match(DATA_URI_PREFIX_REGEX);
  if (!res) return decodeFromBase64(trimmedUri);
  var fullMatch = res[0];
  var data = trimmedUri.substring(fullMatch.length);
  return decodeFromBase64(data);
};

var toCharCode = function (character) {
  return character.charCodeAt(0);
};
var toCodePoint = function (character) {
  return character.codePointAt(0);
};
var toHexStringOfMinLength = function (num, minLength) {
  return padStart(num.toString(16), minLength, '0').toUpperCase();
};
var toHexString = function (num) {
  return toHexStringOfMinLength(num, 2);
};
var charFromCode = function (code) {
  return String.fromCharCode(code);
};
var charFromHexCode = function (hex) {
  return charFromCode(parseInt(hex, 16));
};
var padStart = function (value, length, padChar) {
  var padding = '';
  for (var idx = 0, len = length - value.length; idx < len; idx++) {
    padding += padChar;
  }
  return padding + value;
};
var copyStringIntoBuffer = function (str, buffer, offset) {
  var length = str.length;
  for (var idx = 0; idx < length; idx++) {
    buffer[offset++] = str.charCodeAt(idx);
  }
  return length;
};
var addRandomSuffix = function (prefix, suffixLength) {
  if (suffixLength === void 0) {
    suffixLength = 4;
  }
  return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var escapeRegExp = function (str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var cleanText = function (text) {
  return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var escapedNewlineChars = ['\\n', '\\f', '\\r', '\\u000B'];
var newlineChars = ['\n', '\f', '\r', '\u000B'];
var isNewlineChar = function (text) {
  return /^[\n\f\r\u000B]$/.test(text);
};
var lineSplit = function (text) {
  return text.split(/[\n\f\r\u000B]/);
};
var mergeLines = function (text) {
  return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var charAtIndex = function (text, index) {
  var cuFirst = text.charCodeAt(index);
  var cuSecond;
  var nextIndex = index + 1;
  var length = 1;
  if (cuFirst >= 0xd800 && cuFirst <= 0xdbff && text.length > nextIndex) {
    cuSecond = text.charCodeAt(nextIndex);
    if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2;
  }
  return [text.slice(index, index + length), length];
};
var charSplit = function (text) {
  var chars = [];
  for (var idx = 0, len = text.length; idx < len;) {
    var _a = charAtIndex(text, idx),
      c = _a[0],
      cLen = _a[1];
    chars.push(c);
    idx += cLen;
  }
  return chars;
};
var buildWordBreakRegex = function (wordBreaks) {
  var newlineCharUnion = escapedNewlineChars.join('|');
  var escapedRules = ['$'];
  for (var idx = 0, len = wordBreaks.length; idx < len; idx++) {
    var wordBreak = wordBreaks[idx];
    if (isNewlineChar(wordBreak)) {
      throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
    }
    escapedRules.push(wordBreak === '' ? '.' : escapeRegExp(wordBreak));
  }
  var breakRules = escapedRules.join('|');
  return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var breakTextIntoLines = function (text, wordBreaks, maxWidth, computeWidthOfText) {
  var regex = buildWordBreakRegex(wordBreaks);
  var words = cleanText(text).match(regex);
  var currLine = '';
  var currWidth = 0;
  var lines = [];
  var pushCurrLine = function () {
    if (currLine !== '') lines.push(currLine);
    currLine = '';
    currWidth = 0;
  };
  for (var idx = 0, len = words.length; idx < len; idx++) {
    var word = words[idx];
    if (isNewlineChar(word)) {
      pushCurrLine();
    } else {
      var width = computeWidthOfText(word);
      if (currWidth + width > maxWidth) pushCurrLine();
      currLine += word;
      currWidth += width;
    }
  }
  pushCurrLine();
  return lines;
};
var dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var parseDate = function (dateStr) {
  var match = dateStr.match(dateRegex);
  if (!match) return undefined;
  var year = match[1],
    _a = match[2],
    month = _a === void 0 ? '01' : _a,
    _b = match[3],
    day = _b === void 0 ? '01' : _b,
    _c = match[4],
    hours = _c === void 0 ? '00' : _c,
    _d = match[5],
    mins = _d === void 0 ? '00' : _d,
    _e = match[6],
    secs = _e === void 0 ? '00' : _e,
    _f = match[7],
    offsetSign = _f === void 0 ? 'Z' : _f,
    _g = match[8],
    offsetHours = _g === void 0 ? '00' : _g,
    _h = match[9],
    offsetMins = _h === void 0 ? '00' : _h;
  var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
  var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
  return date;
};
var findLastMatch = function (value, regex) {
  var _a;
  var position = 0;
  var lastMatch;
  while (position < value.length) {
    var match = value.substring(position).match(regex);
    if (!match) return {
      match: lastMatch,
      pos: position
    };
    lastMatch = match;
    position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
  }
  return {
    match: lastMatch,
    pos: position
  };
};

var last = function (array) {
  return array[array.length - 1];
};
var typedArrayFor = function (value) {
  if (value instanceof Uint8Array) return value;
  var length = value.length;
  var typedArray = new Uint8Array(length);
  for (var idx = 0; idx < length; idx++) {
    typedArray[idx] = value.charCodeAt(idx);
  }
  return typedArray;
};
var mergeIntoTypedArray = function () {
  var arrays = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    arrays[_i] = arguments[_i];
  }
  var arrayCount = arrays.length;
  var typedArrays = [];
  for (var idx = 0; idx < arrayCount; idx++) {
    var element = arrays[idx];
    typedArrays[idx] = element instanceof Uint8Array ? element : typedArrayFor(element);
  }
  var totalSize = 0;
  for (var idx = 0; idx < arrayCount; idx++) {
    totalSize += arrays[idx].length;
  }
  var merged = new Uint8Array(totalSize);
  var offset = 0;
  for (var arrIdx = 0; arrIdx < arrayCount; arrIdx++) {
    var arr = typedArrays[arrIdx];
    for (var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++) {
      merged[offset++] = arr[byteIdx];
    }
  }
  return merged;
};
var mergeUint8Arrays = function (arrays) {
  var totalSize = 0;
  for (var idx = 0, len = arrays.length; idx < len; idx++) {
    totalSize += arrays[idx].length;
  }
  var mergedBuffer = new Uint8Array(totalSize);
  var offset = 0;
  for (var idx = 0, len = arrays.length; idx < len; idx++) {
    var array = arrays[idx];
    mergedBuffer.set(array, offset);
    offset += array.length;
  }
  return mergedBuffer;
};
var arrayAsString = function (array) {
  var str = '';
  for (var idx = 0, len = array.length; idx < len; idx++) {
    str += charFromCode(array[idx]);
  }
  return str;
};
var byAscendingId = function (a, b) {
  return a.id - b.id;
};
var sortedUniq = function (array, indexer) {
  var uniq = [];
  for (var idx = 0, len = array.length; idx < len; idx++) {
    var curr = array[idx];
    var prev = array[idx - 1];
    if (idx === 0 || indexer(curr) !== indexer(prev)) {
      uniq.push(curr);
    }
  }
  return uniq;
};
var reverseArray = function (array) {
  var arrayLen = array.length;
  for (var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++) {
    var leftIdx = idx;
    var rightIdx = arrayLen - idx - 1;
    var temp = array[idx];
    array[leftIdx] = array[rightIdx];
    array[rightIdx] = temp;
  }
  return array;
};
var sum = function (array) {
  var total = 0;
  for (var idx = 0, len = array.length; idx < len; idx++) {
    total += array[idx];
  }
  return total;
};
var range = function (start, end) {
  var arr = new Array(end - start);
  for (var idx = 0, len = arr.length; idx < len; idx++) {
    arr[idx] = start + idx;
  }
  return arr;
};
var pluckIndices = function (arr, indices) {
  var plucked = new Array(indices.length);
  for (var idx = 0, len = indices.length; idx < len; idx++) {
    plucked[idx] = arr[indices[idx]];
  }
  return plucked;
};
var canBeConvertedToUint8Array = function (input) {
  return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var toUint8Array = function (input) {
  if (typeof input === 'string') {
    return decodeFromBase64DataUri(input);
  } else if (input instanceof ArrayBuffer) {
    return new Uint8Array(input);
  } else if (input instanceof Uint8Array) {
    return input;
  } else {
    throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
  }
};

var waitForTick = function () {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, 0);
  });
};

var utf8Encode = function (input, byteOrderMark) {
  if (byteOrderMark === void 0) {
    byteOrderMark = true;
  }
  var encoded = [];
  if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
  for (var idx = 0, len = input.length; idx < len;) {
    var codePoint = input.codePointAt(idx);
    if (codePoint < 0x80) {
      var byte1 = codePoint & 0x7f;
      encoded.push(byte1);
      idx += 1;
    } else if (codePoint < 0x0800) {
      var byte1 = codePoint >> 6 & 0x1f | 0xc0;
      var byte2 = codePoint & 0x3f | 0x80;
      encoded.push(byte1, byte2);
      idx += 1;
    } else if (codePoint < 0x010000) {
      var byte1 = codePoint >> 12 & 0x0f | 0xe0;
      var byte2 = codePoint >> 6 & 0x3f | 0x80;
      var byte3 = codePoint & 0x3f | 0x80;
      encoded.push(byte1, byte2, byte3);
      idx += 1;
    } else if (codePoint < 0x110000) {
      var byte1 = codePoint >> 18 & 0x07 | 0xf0;
      var byte2 = codePoint >> 12 & 0x3f | 0x80;
      var byte3 = codePoint >> 6 & 0x3f | 0x80;
      var byte4 = codePoint >> 0 & 0x3f | 0x80;
      encoded.push(byte1, byte2, byte3, byte4);
      idx += 2;
    } else throw new Error("Invalid code point: 0x" + toHexString(codePoint));
  }
  return new Uint8Array(encoded);
};
var utf16Encode = function (input, byteOrderMark) {
  if (byteOrderMark === void 0) {
    byteOrderMark = true;
  }
  var encoded = [];
  if (byteOrderMark) encoded.push(0xfeff);
  for (var idx = 0, len = input.length; idx < len;) {
    var codePoint = input.codePointAt(idx);
    if (codePoint < 0x010000) {
      encoded.push(codePoint);
      idx += 1;
    } else if (codePoint < 0x110000) {
      encoded.push(highSurrogate(codePoint), lowSurrogate(codePoint));
      idx += 2;
    } else throw new Error("Invalid code point: 0x" + toHexString(codePoint));
  }
  return new Uint16Array(encoded);
};
var isWithinBMP = function (codePoint) {
  return codePoint >= 0 && codePoint <= 0xffff;
};
var hasSurrogates = function (codePoint) {
  return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var highSurrogate = function (codePoint) {
  return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var lowSurrogate = function (codePoint) {
  return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var ByteOrder;
(function (ByteOrder) {
  ByteOrder["BigEndian"] = "BigEndian";
  ByteOrder["LittleEndian"] = "LittleEndian";
})(ByteOrder || (ByteOrder = {}));
var REPLACEMENT = '�'.codePointAt(0);
var utf16Decode = function (input, byteOrderMark) {
  if (byteOrderMark === void 0) {
    byteOrderMark = true;
  }
  if (input.length <= 1) return String.fromCodePoint(REPLACEMENT);
  var byteOrder = byteOrderMark ? readBOM(input) : ByteOrder.BigEndian;
  var idx = byteOrderMark ? 2 : 0;
  var codePoints = [];
  while (input.length - idx >= 2) {
    var first = decodeValues(input[idx++], input[idx++], byteOrder);
    if (isHighSurrogate(first)) {
      if (input.length - idx < 2) {
        codePoints.push(REPLACEMENT);
      } else {
        var second = decodeValues(input[idx++], input[idx++], byteOrder);
        if (isLowSurrogate(second)) {
          codePoints.push(first, second);
        } else {
          codePoints.push(REPLACEMENT);
        }
      }
    } else if (isLowSurrogate(first)) {
      idx += 2;
      codePoints.push(REPLACEMENT);
    } else {
      codePoints.push(first);
    }
  }
  if (idx < input.length) codePoints.push(REPLACEMENT);
  return String.fromCodePoint.apply(String, codePoints);
};
var isHighSurrogate = function (codePoint) {
  return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
var isLowSurrogate = function (codePoint) {
  return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
var decodeValues = function (first, second, byteOrder) {
  if (byteOrder === ByteOrder.LittleEndian) return second << 8 | first;
  if (byteOrder === ByteOrder.BigEndian) return first << 8 | second;
  throw new Error("Invalid byteOrder: " + byteOrder);
};
var readBOM = function (bytes) {
  return hasUtf16BigEndianBOM(bytes) ? ByteOrder.BigEndian : hasUtf16LittleEndianBOM(bytes) ? ByteOrder.LittleEndian : ByteOrder.BigEndian;
};
var hasUtf16BigEndianBOM = function (bytes) {
  return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var hasUtf16LittleEndianBOM = function (bytes) {
  return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var hasUtf16BOM = function (bytes) {
  return hasUtf16BigEndianBOM(bytes) || hasUtf16LittleEndianBOM(bytes);
};

var numberToString = function (num) {
  var numStr = String(num);
  if (Math.abs(num) < 1.0) {
    var e = parseInt(num.toString().split('e-')[1]);
    if (e) {
      var negative = num < 0;
      if (negative) num *= -1;
      num *= Math.pow(10, e - 1);
      numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
      if (negative) numStr = '-' + numStr;
    }
  } else {
    var e = parseInt(num.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      num /= Math.pow(10, e);
      numStr = num.toString() + new Array(e + 1).join('0');
    }
  }
  return numStr;
};
var sizeInBytes = function (n) {
  return Math.ceil(n.toString(2).length / 8);
};
var bytesFor = function (n) {
  var bytes = new Uint8Array(sizeInBytes(n));
  for (var i = 1; i <= bytes.length; i++) {
    bytes[i - 1] = n >> (bytes.length - i) * 8;
  }
  return bytes;
};

var error = function (msg) {
  throw new Error(msg);
};

var common = createCommonjsModule(function (module, exports) {

  var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
  function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
  exports.assign = function (obj) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while (sources.length) {
      var source = sources.shift();
      if (!source) {
        continue;
      }
      if (typeof source !== 'object') {
        throw new TypeError(source + 'must be non-object');
      }
      for (var p in source) {
        if (_has(source, p)) {
          obj[p] = source[p];
        }
      }
    }
    return obj;
  };
  exports.shrinkBuf = function (buf, size) {
    if (buf.length === size) {
      return buf;
    }
    if (buf.subarray) {
      return buf.subarray(0, size);
    }
    buf.length = size;
    return buf;
  };
  var fnTyped = {
    arraySet: function (dest, src, src_offs, len, dest_offs) {
      if (src.subarray && dest.subarray) {
        dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
        return;
      }
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    flattenChunks: function (chunks) {
      var i, l, len, pos, chunk, result;
      len = 0;
      for (i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      }
      result = new Uint8Array(len);
      pos = 0;
      for (i = 0, l = chunks.length; i < l; i++) {
        chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
      }
      return result;
    }
  };
  var fnUntyped = {
    arraySet: function (dest, src, src_offs, len, dest_offs) {
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    flattenChunks: function (chunks) {
      return [].concat.apply([], chunks);
    }
  };
  exports.setTyped = function (on) {
    if (on) {
      exports.Buf8 = Uint8Array;
      exports.Buf16 = Uint16Array;
      exports.Buf32 = Int32Array;
      exports.assign(exports, fnTyped);
    } else {
      exports.Buf8 = Array;
      exports.Buf16 = Array;
      exports.Buf32 = Array;
      exports.assign(exports, fnUntyped);
    }
  };
  exports.setTyped(TYPED_OK);
});

var Z_FIXED = 4;
var Z_BINARY = 0;
var Z_TEXT = 1;
var Z_UNKNOWN = 2;
function zero(buf) {
  var len = buf.length;
  while (--len >= 0) {
    buf[len] = 0;
  }
}
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
var MIN_MATCH = 3;
var MAX_MATCH = 258;
var LENGTH_CODES = 29;
var LITERALS = 256;
var L_CODES = LITERALS + 1 + LENGTH_CODES;
var D_CODES = 30;
var BL_CODES = 19;
var HEAP_SIZE = 2 * L_CODES + 1;
var MAX_BITS = 15;
var Buf_size = 16;
var MAX_BL_BITS = 7;
var END_BLOCK = 256;
var REP_3_6 = 16;
var REPZ_3_10 = 17;
var REPZ_11_138 = 18;
var extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
var extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
var extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
var DIST_CODE_LEN = 512;
var static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
var static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
var _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
var base_length = new Array(LENGTH_CODES);
zero(base_length);
var base_dist = new Array(D_CODES);
zero(base_dist);
function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
  this.static_tree = static_tree;
  this.extra_bits = extra_bits;
  this.extra_base = extra_base;
  this.elems = elems;
  this.max_length = max_length;
  this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;
  this.max_code = 0;
  this.stat_desc = stat_desc;
}
function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
function put_short(s, w) {
  s.pending_buf[s.pending++] = w & 0xff;
  s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
function send_bits(s, value, length) {
  if (s.bi_valid > Buf_size - length) {
    s.bi_buf |= value << s.bi_valid & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> Buf_size - s.bi_valid;
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= value << s.bi_valid & 0xffff;
    s.bi_valid += length;
  }
}
function send_code(s, c, tree) {
  send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;
  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}
function gen_bitlen(s, desc) {
  var tree = desc.dyn_tree;
  var max_code = desc.max_code;
  var stree = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var extra = desc.stat_desc.extra_bits;
  var base = desc.stat_desc.extra_base;
  var max_length = desc.stat_desc.max_length;
  var h;
  var n, m;
  var bits;
  var xbits;
  var f;
  var overflow = 0;
  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }
  tree[s.heap[s.heap_max] * 2 + 1] = 0;
  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1] = bits;
    if (n > max_code) {
      continue;
    }
    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2];
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
  }
  if (overflow === 0) {
    return;
  }
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) {
      bits--;
    }
    s.bl_count[bits]--;
    s.bl_count[bits + 1] += 2;
    s.bl_count[max_length]--;
    overflow -= 2;
  } while (overflow > 0);
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) {
        continue;
      }
      if (tree[m * 2 + 1] !== bits) {
        s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
        tree[m * 2 + 1] = bits;
      }
      n--;
    }
  }
}
function gen_codes(tree, max_code, bl_count) {
  var next_code = new Array(MAX_BITS + 1);
  var code = 0;
  var bits;
  var n;
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = code + bl_count[bits - 1] << 1;
  }
  for (n = 0; n <= max_code; n++) {
    var len = tree[n * 2 + 1];
    if (len === 0) {
      continue;
    }
    tree[n * 2] = bi_reverse(next_code[len]++, len);
  }
}
function tr_static_init() {
  var n;
  var bits;
  var length;
  var code;
  var dist;
  var bl_count = new Array(MAX_BITS + 1);
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < 1 << extra_lbits[code]; n++) {
      _length_code[length++] = code;
    }
  }
  _length_code[length - 1] = code;
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < 1 << extra_dbits[code]; n++) {
      _dist_code[dist++] = code;
    }
  }
  dist >>= 7;
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }
  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1] = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1] = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1] = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1] = 8;
    n++;
    bl_count[8]++;
  }
  gen_codes(static_ltree, L_CODES + 1, bl_count);
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1] = 5;
    static_dtree[n * 2] = bi_reverse(n, 5);
  }
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
}
function init_block(s) {
  var n;
  for (n = 0; n < L_CODES; n++) {
    s.dyn_ltree[n * 2] = 0;
  }
  for (n = 0; n < D_CODES; n++) {
    s.dyn_dtree[n * 2] = 0;
  }
  for (n = 0; n < BL_CODES; n++) {
    s.bl_tree[n * 2] = 0;
  }
  s.dyn_ltree[END_BLOCK * 2] = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}
function bi_windup(s) {
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}
function copy_block(s, buf, len, header) {
  bi_windup(s);
  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
  common.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
function pqdownheap(s, tree, k) {
  var v = s.heap[k];
  var j = k << 1;
  while (j <= s.heap_len) {
    if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    if (smaller(tree, v, s.heap[j], s.depth)) {
      break;
    }
    s.heap[k] = s.heap[j];
    k = j;
    j <<= 1;
  }
  s.heap[k] = v;
}
function compress_block(s, ltree, dtree) {
  var dist;
  var lc;
  var lx = 0;
  var code;
  var extra;
  if (s.last_lit !== 0) {
    do {
      dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
      lc = s.pending_buf[s.l_buf + lx];
      lx++;
      if (dist === 0) {
        send_code(s, lc, ltree);
      } else {
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree);
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);
        }
        dist--;
        code = d_code(dist);
        send_code(s, code, dtree);
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);
        }
      }
    } while (lx < s.last_lit);
  }
  send_code(s, END_BLOCK, ltree);
}
function build_tree(s, desc) {
  var tree = desc.dyn_tree;
  var stree = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems = desc.stat_desc.elems;
  var n, m;
  var max_code = -1;
  var node;
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;
  for (n = 0; n < elems; n++) {
    if (tree[n * 2] !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;
    } else {
      tree[n * 2 + 1] = 0;
    }
  }
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
    tree[node * 2] = 1;
    s.depth[node] = 0;
    s.opt_len--;
    if (has_stree) {
      s.static_len -= stree[node * 2 + 1];
    }
  }
  desc.max_code = max_code;
  for (n = s.heap_len >> 1; n >= 1; n--) {
    pqdownheap(s, tree, n);
  }
  node = elems;
  do {
    n = s.heap[1];
    s.heap[1] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1);
    m = s.heap[1];
    s.heap[--s.heap_max] = n;
    s.heap[--s.heap_max] = m;
    tree[node * 2] = tree[n * 2] + tree[m * 2];
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1] = tree[m * 2 + 1] = node;
    s.heap[1] = node++;
    pqdownheap(s, tree, 1);
  } while (s.heap_len >= 2);
  s.heap[--s.heap_max] = s.heap[1];
  gen_bitlen(s, desc);
  gen_codes(tree, max_code, s.bl_count);
}
function scan_tree(s, tree, max_code) {
  var n;
  var prevlen = -1;
  var curlen;
  var nextlen = tree[0 * 2 + 1];
  var count = 0;
  var max_count = 7;
  var min_count = 4;
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1] = 0xffff;
  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1];
    if (++count < max_count && curlen === nextlen) {
      continue;
    } else if (count < min_count) {
      s.bl_tree[curlen * 2] += count;
    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        s.bl_tree[curlen * 2]++;
      }
      s.bl_tree[REP_3_6 * 2]++;
    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]++;
    } else {
      s.bl_tree[REPZ_11_138 * 2]++;
    }
    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;
    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}
function send_tree(s, tree, max_code) {
  var n;
  var prevlen = -1;
  var curlen;
  var nextlen = tree[0 * 2 + 1];
  var count = 0;
  var max_count = 7;
  var min_count = 4;
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1];
    if (++count < max_count && curlen === nextlen) {
      continue;
    } else if (count < min_count) {
      do {
        send_code(s, curlen, s.bl_tree);
      } while (--count !== 0);
    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);
    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);
    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }
    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;
    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;
    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}
function build_bl_tree(s) {
  var max_blindex;
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
  build_tree(s, s.bl_desc);
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) {
      break;
    }
  }
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  return max_blindex;
}
function send_all_trees(s, lcodes, dcodes, blcodes) {
  var rank;
  send_bits(s, lcodes - 257, 5);
  send_bits(s, dcodes - 1, 5);
  send_bits(s, blcodes - 4, 4);
  for (rank = 0; rank < blcodes; rank++) {
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
  }
  send_tree(s, s.dyn_ltree, lcodes - 1);
  send_tree(s, s.dyn_dtree, dcodes - 1);
}
function detect_data_type(s) {
  var black_mask = 0xf3ffc07f;
  var n;
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) {
      return Z_BINARY;
    }
  }
  if (s.dyn_ltree[9 * 2] !== 0 || s.dyn_ltree[10 * 2] !== 0 || s.dyn_ltree[13 * 2] !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2] !== 0) {
      return Z_TEXT;
    }
  }
  return Z_BINARY;
}
var static_init_done = false;
function _tr_init(s) {
  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }
  s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
  s.bi_buf = 0;
  s.bi_valid = 0;
  init_block(s);
}
function _tr_stored_block(s, buf, stored_len, last) {
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
  copy_block(s, buf, stored_len, true);
}
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}
function _tr_flush_block(s, buf, stored_len, last) {
  var opt_lenb, static_lenb;
  var max_blindex = 0;
  if (s.level > 0) {
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }
    build_tree(s, s.l_desc);
    build_tree(s, s.d_desc);
    max_blindex = build_bl_tree(s);
    opt_lenb = s.opt_len + 3 + 7 >>> 3;
    static_lenb = s.static_len + 3 + 7 >>> 3;
    if (static_lenb <= opt_lenb) {
      opt_lenb = static_lenb;
    }
  } else {
    opt_lenb = static_lenb = stored_len + 5;
  }
  if (stored_len + 4 <= opt_lenb && buf !== -1) {
    _tr_stored_block(s, buf, stored_len, last);
  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);
  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  init_block(s);
  if (last) {
    bi_windup(s);
  }
}
function _tr_tally(s, dist, lc) {
  s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;
  if (dist === 0) {
    s.dyn_ltree[lc * 2]++;
  } else {
    s.matches++;
    dist--;
    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
    s.dyn_dtree[d_code(dist) * 2]++;
  }
  return s.last_lit === s.lit_bufsize - 1;
}
var _tr_init_1 = _tr_init;
var _tr_stored_block_1 = _tr_stored_block;
var _tr_flush_block_1 = _tr_flush_block;
var _tr_tally_1 = _tr_tally;
var _tr_align_1 = _tr_align;
var trees = {
  _tr_init: _tr_init_1,
  _tr_stored_block: _tr_stored_block_1,
  _tr_flush_block: _tr_flush_block_1,
  _tr_tally: _tr_tally_1,
  _tr_align: _tr_align_1
};

function adler32(adler, buf, len, pos) {
  var s1 = adler & 0xffff | 0,
    s2 = adler >>> 16 & 0xffff | 0,
    n = 0;
  while (len !== 0) {
    n = len > 2000 ? 2000 : len;
    len -= n;
    do {
      s1 = s1 + buf[pos++] | 0;
      s2 = s2 + s1 | 0;
    } while (--n);
    s1 %= 65521;
    s2 %= 65521;
  }
  return s1 | s2 << 16 | 0;
}
var adler32_1 = adler32;

function makeTable() {
  var c,
    table = [];
  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
    }
    table[n] = c;
  }
  return table;
}
var crcTable = makeTable();
function crc32(crc, buf, len, pos) {
  var t = crcTable,
    end = pos + len;
  crc ^= -1;
  for (var i = pos; i < end; i++) {
    crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
  }
  return crc ^ -1;
}
var crc32_1 = crc32;

var messages = {
  2: 'need dictionary',
  1: 'stream end',
  0: '',
  '-1': 'file error',
  '-2': 'stream error',
  '-3': 'data error',
  '-4': 'insufficient memory',
  '-5': 'buffer error',
  '-6': 'incompatible version'
};

var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
var Z_FULL_FLUSH = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_BUF_ERROR = -5;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED$1 = 4;
var Z_DEFAULT_STRATEGY = 0;
var Z_UNKNOWN$1 = 2;
var Z_DEFLATED = 8;
var MAX_MEM_LEVEL = 9;
var MAX_WBITS = 15;
var DEF_MEM_LEVEL = 8;
var LENGTH_CODES$1 = 29;
var LITERALS$1 = 256;
var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
var D_CODES$1 = 30;
var BL_CODES$1 = 19;
var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
var MAX_BITS$1 = 15;
var MIN_MATCH$1 = 3;
var MAX_MATCH$1 = 258;
var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1;
var BS_BLOCK_DONE = 2;
var BS_FINISH_STARTED = 3;
var BS_FINISH_DONE = 4;
var OS_CODE = 0x03;
function err(strm, errorCode) {
  strm.msg = messages[errorCode];
  return errorCode;
}
function rank(f) {
  return (f << 1) - (f > 4 ? 9 : 0);
}
function zero$1(buf) {
  var len = buf.length;
  while (--len >= 0) {
    buf[len] = 0;
  }
}
function flush_pending(strm) {
  var s = strm.state;
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) {
    return;
  }
  common.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}
function flush_block_only(s, last) {
  trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}
function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}
function putShortMSB(s, b) {
  s.pending_buf[s.pending++] = b >>> 8 & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;
  if (len > size) {
    len = size;
  }
  if (len === 0) {
    return 0;
  }
  strm.avail_in -= len;
  common.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32_1(strm.adler, buf, len, start);
  } else if (strm.state.wrap === 2) {
    strm.adler = crc32_1(strm.adler, buf, len, start);
  }
  strm.next_in += len;
  strm.total_in += len;
  return len;
}
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;
  var scan = s.strstart;
  var match;
  var len;
  var best_len = s.prev_length;
  var nice_match = s.nice_match;
  var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
  var _win = s.window;
  var wmask = s.w_mask;
  var prev = s.prev;
  var strend = s.strstart + MAX_MATCH$1;
  var scan_end1 = _win[scan + best_len - 1];
  var scan_end = _win[scan + best_len];
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  if (nice_match > s.lookahead) {
    nice_match = s.lookahead;
  }
  do {
    match = cur_match;
    if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
      continue;
    }
    scan += 2;
    match++;
    do {} while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
    len = MAX_MATCH$1 - (strend - scan);
    scan = strend - MAX_MATCH$1;
    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1 = _win[scan + best_len - 1];
      scan_end = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;
  do {
    more = s.window_size - s.lookahead - s.strstart;
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
      common.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      s.block_start -= _w_size;
      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);
      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;
    if (s.lookahead + s.insert >= MIN_MATCH$1) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
      while (s.insert) {
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask;
        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH$1) {
          break;
        }
      }
    }
  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
}
function deflate_stored(s, flush) {
  var max_block_size = 0xffff;
  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }
  for (;;) {
    if (s.lookahead <= 1) {
      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    s.strstart += s.lookahead;
    s.lookahead = 0;
    var max_start = s.block_start + max_block_size;
    if (s.strstart === 0 || s.strstart >= max_start) {
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
    if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.strstart > s.block_start) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_NEED_MORE;
}
function deflate_fast(s, flush) {
  var hash_head;
  var bflush;
  for (;;) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    hash_head = 0;
    if (s.lookahead >= MIN_MATCH$1) {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
    }
    if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
      s.match_length = longest_match(s, hash_head);
    }
    if (s.match_length >= MIN_MATCH$1) {
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
      s.lookahead -= s.match_length;
      if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH$1) {
        s.match_length--;
        do {
          s.strstart++;
          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
        } while (--s.match_length !== 0);
        s.strstart++;
      } else {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
      }
    } else {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
  if (flush === Z_FINISH) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_slow(s, flush) {
  var hash_head;
  var bflush;
  var max_insert;
  for (;;) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    hash_head = 0;
    if (s.lookahead >= MIN_MATCH$1) {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
    }
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH$1 - 1;
    if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
      s.match_length = longest_match(s, hash_head);
      if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096)) {
        s.match_length = MIN_MATCH$1 - 1;
      }
    }
    if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH$1 - 1;
      s.strstart++;
      if (bflush) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
      }
    } else if (s.match_available) {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
      if (bflush) {
        flush_block_only(s, false);
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  if (s.match_available) {
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
  if (flush === Z_FINISH) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_rle(s, flush) {
  var bflush;
  var prev;
  var scan, strend;
  var _win = s.window;
  for (;;) {
    if (s.lookahead <= MAX_MATCH$1) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break;
      }
    }
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH$1;
        do {} while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
        s.match_length = MAX_MATCH$1 - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
    }
    if (s.match_length >= MIN_MATCH$1) {
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH$1);
      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function deflate_huff(s, flush) {
  var bflush;
  for (;;) {
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;
      }
    }
    s.match_length = 0;
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
  }
  return BS_BLOCK_DONE;
}
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}
var configuration_table;
configuration_table = [new Config(0, 0, 0, 0, deflate_stored), new Config(4, 4, 8, 4, deflate_fast), new Config(4, 5, 16, 8, deflate_fast), new Config(4, 6, 32, 32, deflate_fast), new Config(4, 4, 16, 16, deflate_slow), new Config(8, 16, 32, 32, deflate_slow), new Config(8, 16, 128, 128, deflate_slow), new Config(8, 32, 128, 256, deflate_slow), new Config(32, 128, 258, 1024, deflate_slow), new Config(32, 258, 258, 4096, deflate_slow)];
function lm_init(s) {
  s.window_size = 2 * s.w_size;
  zero$1(s.head);
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;
  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH$1 - 1;
  s.match_available = 0;
  s.ins_h = 0;
}
function DeflateState() {
  this.strm = null;
  this.status = 0;
  this.pending_buf = null;
  this.pending_buf_size = 0;
  this.pending_out = 0;
  this.pending = 0;
  this.wrap = 0;
  this.gzhead = null;
  this.gzindex = 0;
  this.method = Z_DEFLATED;
  this.last_flush = -1;
  this.w_size = 0;
  this.w_bits = 0;
  this.w_mask = 0;
  this.window = null;
  this.window_size = 0;
  this.prev = null;
  this.head = null;
  this.ins_h = 0;
  this.hash_size = 0;
  this.hash_bits = 0;
  this.hash_mask = 0;
  this.hash_shift = 0;
  this.block_start = 0;
  this.match_length = 0;
  this.prev_match = 0;
  this.match_available = 0;
  this.strstart = 0;
  this.match_start = 0;
  this.lookahead = 0;
  this.prev_length = 0;
  this.max_chain_length = 0;
  this.max_lazy_match = 0;
  this.level = 0;
  this.strategy = 0;
  this.good_match = 0;
  this.nice_match = 0;
  this.dyn_ltree = new common.Buf16(HEAP_SIZE$1 * 2);
  this.dyn_dtree = new common.Buf16((2 * D_CODES$1 + 1) * 2);
  this.bl_tree = new common.Buf16((2 * BL_CODES$1 + 1) * 2);
  zero$1(this.dyn_ltree);
  zero$1(this.dyn_dtree);
  zero$1(this.bl_tree);
  this.l_desc = null;
  this.d_desc = null;
  this.bl_desc = null;
  this.bl_count = new common.Buf16(MAX_BITS$1 + 1);
  this.heap = new common.Buf16(2 * L_CODES$1 + 1);
  zero$1(this.heap);
  this.heap_len = 0;
  this.heap_max = 0;
  this.depth = new common.Buf16(2 * L_CODES$1 + 1);
  zero$1(this.depth);
  this.l_buf = 0;
  this.lit_bufsize = 0;
  this.last_lit = 0;
  this.d_buf = 0;
  this.opt_len = 0;
  this.static_len = 0;
  this.matches = 0;
  this.insert = 0;
  this.bi_buf = 0;
  this.bi_valid = 0;
}
function deflateResetKeep(strm) {
  var s;
  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }
  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN$1;
  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;
  if (s.wrap < 0) {
    s.wrap = -s.wrap;
  }
  s.status = s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = s.wrap === 2 ? 0 : 1;
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}
function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}
function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  if (strm.state.wrap !== 2) {
    return Z_STREAM_ERROR;
  }
  strm.state.gzhead = head;
  return Z_OK;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) {
    return Z_STREAM_ERROR;
  }
  var wrap = 1;
  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  } else if (windowBits > 15) {
    wrap = 2;
    windowBits -= 16;
  }
  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED$1) {
    return err(strm, Z_STREAM_ERROR);
  }
  if (windowBits === 8) {
    windowBits = 9;
  }
  var s = new DeflateState();
  strm.state = s;
  s.strm = strm;
  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;
  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
  s.window = new common.Buf8(s.w_size * 2);
  s.head = new common.Buf16(s.hash_size);
  s.prev = new common.Buf16(s.w_size);
  s.lit_bufsize = 1 << memLevel + 6;
  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new common.Buf8(s.pending_buf_size);
  s.d_buf = 1 * s.lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;
  s.level = level;
  s.strategy = strategy;
  s.method = method;
  return deflateReset(strm);
}
function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
  var old_flush, s;
  var beg, val;
  if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }
  s = strm.state;
  if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
    return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }
  s.strm = strm;
  old_flush = s.last_flush;
  s.last_flush = flush;
  if (s.status === INIT_STATE) {
    if (s.wrap === 2) {
      strm.adler = 0;
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) {
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      } else {
        put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, s.gzhead.time >> 8 & 0xff);
        put_byte(s, s.gzhead.time >> 16 & 0xff);
        put_byte(s, s.gzhead.time >> 24 & 0xff);
        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    } else {
        var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
        var level_flags = -1;
        if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
          level_flags = 0;
        } else if (s.level < 6) {
          level_flags = 1;
        } else if (s.level === 6) {
          level_flags = 2;
        } else {
          level_flags = 3;
        }
        header |= level_flags << 6;
        if (s.strstart !== 0) {
          header |= PRESET_DICT;
        }
        header += 31 - header % 31;
        s.status = BUSY_STATE;
        putShortMSB(s, header);
        if (s.strstart !== 0) {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1;
      }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra) {
      beg = s.pending;
      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    } else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name) {
      beg = s.pending;
      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    } else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment) {
      beg = s.pending;
      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    } else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        strm.adler = 0;
        s.status = BUSY_STATE;
      }
    } else {
      s.status = BUSY_STATE;
    }
  }
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      s.last_flush = -1;
      return Z_OK;
    }
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }
  if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
    var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
      }
      return Z_OK;
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      } else if (flush !== Z_BLOCK) {
        trees._tr_stored_block(s, 0, 0, false);
        if (flush === Z_FULL_FLUSH) {
          zero$1(s.head);
          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        return Z_OK;
      }
    }
  }
  if (flush !== Z_FINISH) {
    return Z_OK;
  }
  if (s.wrap <= 0) {
    return Z_STREAM_END;
  }
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, strm.adler >> 8 & 0xff);
    put_byte(s, strm.adler >> 16 & 0xff);
    put_byte(s, strm.adler >> 24 & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, strm.total_in >> 8 & 0xff);
    put_byte(s, strm.total_in >> 16 & 0xff);
    put_byte(s, strm.total_in >> 24 & 0xff);
  } else {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }
  flush_pending(strm);
  if (s.wrap > 0) {
    s.wrap = -s.wrap;
  }
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}
function deflateEnd(strm) {
  var status;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  status = strm.state.status;
  if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
    return err(strm, Z_STREAM_ERROR);
  }
  strm.state = null;
  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;
  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR;
  }
  s = strm.state;
  wrap = s.wrap;
  if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) {
    return Z_STREAM_ERROR;
  }
  if (wrap === 1) {
    strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
  }
  s.wrap = 0;
  if (dictLength >= s.w_size) {
    if (wrap === 0) {
      zero$1(s.head);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    tmpDict = new common.Buf8(s.w_size);
    common.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH$1) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH$1 - 1);
    do {
      s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask;
      s.prev[str & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH$1 - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH$1 - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}
var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2 = deflate;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';
var deflate_1 = {
  deflateInit: deflateInit_1,
  deflateInit2: deflateInit2_1,
  deflateReset: deflateReset_1,
  deflateResetKeep: deflateResetKeep_1,
  deflateSetHeader: deflateSetHeader_1,
  deflate: deflate_2,
  deflateEnd: deflateEnd_1,
  deflateSetDictionary: deflateSetDictionary_1,
  deflateInfo: deflateInfo
};

var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;
try {
  String.fromCharCode.apply(null, [0]);
} catch (__) {
  STR_APPLY_OK = false;
}
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
  STR_APPLY_UIA_OK = false;
}
var _utf8len = new common.Buf8(256);
for (var q$1 = 0; q$1 < 256; q$1++) {
  _utf8len[q$1] = q$1 >= 252 ? 6 : q$1 >= 248 ? 5 : q$1 >= 240 ? 4 : q$1 >= 224 ? 3 : q$1 >= 192 ? 2 : 1;
}
_utf8len[254] = _utf8len[254] = 1;
var string2buf = function (str) {
  var buf,
    c,
    c2,
    m_pos,
    i,
    str_len = str.length,
    buf_len = 0;
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }
  buf = new common.Buf8(buf_len);
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      buf[i++] = c;
    } else if (c < 0x800) {
      buf[i++] = 0xC0 | c >>> 6;
      buf[i++] = 0x80 | c & 0x3f;
    } else if (c < 0x10000) {
      buf[i++] = 0xE0 | c >>> 12;
      buf[i++] = 0x80 | c >>> 6 & 0x3f;
      buf[i++] = 0x80 | c & 0x3f;
    } else {
      buf[i++] = 0xf0 | c >>> 18;
      buf[i++] = 0x80 | c >>> 12 & 0x3f;
      buf[i++] = 0x80 | c >>> 6 & 0x3f;
      buf[i++] = 0x80 | c & 0x3f;
    }
  }
  return buf;
};
function buf2binstring(buf, len) {
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
      return String.fromCharCode.apply(null, common.shrinkBuf(buf, len));
    }
  }
  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}
var buf2binstring_1 = function (buf) {
  return buf2binstring(buf, buf.length);
};
var binstring2buf = function (str) {
  var buf = new common.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};
var buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;
  var utf16buf = new Array(len * 2);
  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    if (c < 0x80) {
      utf16buf[out++] = c;
      continue;
    }
    c_len = _utf8len[c];
    if (c_len > 4) {
      utf16buf[out++] = 0xfffd;
      i += c_len - 1;
      continue;
    }
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    while (c_len > 1 && i < len) {
      c = c << 6 | buf[i++] & 0x3f;
      c_len--;
    }
    if (c_len > 1) {
      utf16buf[out++] = 0xfffd;
      continue;
    }
    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
      utf16buf[out++] = 0xdc00 | c & 0x3ff;
    }
  }
  return buf2binstring(utf16buf, out);
};
var utf8border = function (buf, max) {
  var pos;
  max = max || buf.length;
  if (max > buf.length) {
    max = buf.length;
  }
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
    pos--;
  }
  if (pos < 0) {
    return max;
  }
  if (pos === 0) {
    return max;
  }
  return pos + _utf8len[buf[pos]] > max ? pos : max;
};
var strings = {
  string2buf: string2buf,
  buf2binstring: buf2binstring_1,
  binstring2buf: binstring2buf,
  buf2string: buf2string,
  utf8border: utf8border
};

function ZStream() {
  this.input = null;
  this.next_in = 0;
  this.avail_in = 0;
  this.total_in = 0;
  this.output = null;
  this.next_out = 0;
  this.avail_out = 0;
  this.total_out = 0;
  this.msg = '';
  this.state = null;
  this.data_type = 2;
  this.adler = 0;
}
var zstream = ZStream;

var toString$2 = Object.prototype.toString;
var Z_NO_FLUSH$1 = 0;
var Z_FINISH$1 = 4;
var Z_OK$1 = 0;
var Z_STREAM_END$1 = 1;
var Z_SYNC_FLUSH = 2;
var Z_DEFAULT_COMPRESSION$1 = -1;
var Z_DEFAULT_STRATEGY$1 = 0;
var Z_DEFLATED$1 = 8;
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION$1,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY$1,
    to: ''
  }, options || {});
  var opt = this.options;
  if (opt.raw && opt.windowBits > 0) {
    opt.windowBits = -opt.windowBits;
  } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
    opt.windowBits += 16;
  }
  this.err = 0;
  this.msg = '';
  this.ended = false;
  this.chunks = [];
  this.strm = new zstream();
  this.strm.avail_out = 0;
  var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
  if (status !== Z_OK$1) {
    throw new Error(messages[status]);
  }
  if (opt.header) {
    deflate_1.deflateSetHeader(this.strm, opt.header);
  }
  if (opt.dictionary) {
    var dict;
    if (typeof opt.dictionary === 'string') {
      dict = strings.string2buf(opt.dictionary);
    } else if (toString$2.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }
    status = deflate_1.deflateSetDictionary(this.strm, dict);
    if (status !== Z_OK$1) {
      throw new Error(messages[status]);
    }
    this._dict_set = true;
  }
}
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;
  if (this.ended) {
    return false;
  }
  _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
  if (typeof data === 'string') {
    strm.input = strings.string2buf(data);
  } else if (toString$2.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }
  strm.next_in = 0;
  strm.avail_in = strm.input.length;
  do {
    if (strm.avail_out === 0) {
      strm.output = new common.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = deflate_1.deflate(strm, _mode);
    if (status !== Z_STREAM_END$1 && status !== Z_OK$1) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH$1 || _mode === Z_SYNC_FLUSH)) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(common.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(common.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END$1);
  if (_mode === Z_FINISH$1) {
    status = deflate_1.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK$1;
  }
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK$1);
    strm.avail_out = 0;
    return true;
  }
  return true;
};
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};
Deflate.prototype.onEnd = function (status) {
  if (status === Z_OK$1) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = common.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};
function deflate$1(input, options) {
  var deflator = new Deflate(options);
  deflator.push(input, true);
  if (deflator.err) {
    throw deflator.msg || messages[deflator.err];
  }
  return deflator.result;
}
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate$1(input, options);
}
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate$1(input, options);
}
var Deflate_1 = Deflate;
var deflate_2$1 = deflate$1;
var deflateRaw_1 = deflateRaw;
var gzip_1 = gzip;
var deflate_1$1 = {
  Deflate: Deflate_1,
  deflate: deflate_2$1,
  deflateRaw: deflateRaw_1,
  gzip: gzip_1
};

var BAD = 30;
var TYPE = 12;
var inffast = function inflate_fast(strm, start) {
  var state;
  var _in;
  var last;
  var _out;
  var beg;
  var end;
  var dmax;
  var wsize;
  var whave;
  var wnext;
  var s_window;
  var hold;
  var bits;
  var lcode;
  var dcode;
  var lmask;
  var dmask;
  var here;
  var op;
  var len;
  var dist;
  var from;
  var from_source;
  var input, output;
  state = strm.state;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
  dmax = state.dmax;
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;
  top: do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }
    here = lcode[hold & lmask];
    dolen: for (;;) {
      op = here >>> 24;
      hold >>>= op;
      bits -= op;
      op = here >>> 16 & 0xff;
      if (op === 0) {
        output[_out++] = here & 0xffff;
      } else if (op & 16) {
        len = here & 0xffff;
        op &= 15;
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & (1 << op) - 1;
          hold >>>= op;
          bits -= op;
        }
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];
        dodist: for (;;) {
          op = here >>> 24;
          hold >>>= op;
          bits -= op;
          op = here >>> 16 & 0xff;
          if (op & 16) {
            dist = here & 0xffff;
            op &= 15;
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & (1 << op) - 1;
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
            hold >>>= op;
            bits -= op;
            op = _out - beg;
            if (dist > op) {
              op = dist - op;
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }
              }
              from = 0;
              from_source = s_window;
              if (wnext === 0) {
                from += wsize - op;
                if (op < len) {
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;
                  from_source = output;
                }
              } else if (wnext < op) {
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;
                    from_source = output;
                  }
                }
              } else {
                from += wnext - op;
                if (op < len) {
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            } else {
              from = _out - dist;
              do {
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          } else if ((op & 64) === 0) {
            here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
            continue dodist;
          } else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }
          break;
        }
      } else if ((op & 64) === 0) {
        here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
        continue dolen;
      } else if (op & 32) {
        state.mode = TYPE;
        break top;
      } else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }
      break;
    }
  } while (_in < last && _out < end);
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
  strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
  state.hold = hold;
  state.bits = bits;
  return;
};

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var lbase = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
var lext = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
var dbase = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
var dext = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
var inftrees = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
  var bits = opts.bits;
  var len = 0;
  var sym = 0;
  var min = 0,
    max = 0;
  var root = 0;
  var curr = 0;
  var drop = 0;
  var left = 0;
  var used = 0;
  var huff = 0;
  var incr;
  var fill;
  var low;
  var mask;
  var next;
  var base = null;
  var base_index = 0;
  var end;
  var count = new common.Buf16(MAXBITS + 1);
  var offs = new common.Buf16(MAXBITS + 1);
  var extra = null;
  var extra_index = 0;
  var here_bits, here_op, here_val;
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) {
      break;
    }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {
    table[table_index++] = 1 << 24 | 64 << 16 | 0;
    table[table_index++] = 1 << 24 | 64 << 16 | 0;
    opts.bits = 1;
    return 0;
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) {
      break;
    }
  }
  if (root < min) {
    root = min;
  }
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;
  }
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }
  if (type === CODES) {
    base = extra = work;
    end = 19;
  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;
  } else {
    base = dbase;
    extra = dext;
    end = -1;
  }
  huff = 0;
  sym = 0;
  len = min;
  next = table_index;
  curr = root;
  drop = 0;
  low = -1;
  used = 1 << root;
  mask = used - 1;
  if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
    return 1;
  }
  for (;;) {
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    } else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    } else {
      here_op = 32 + 64;
      here_val = 0;
    }
    incr = 1 << len - drop;
    fill = 1 << curr;
    min = fill;
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
    } while (fill !== 0);
    incr = 1 << len - 1;
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }
    sym++;
    if (--count[len] === 0) {
      if (len === max) {
        break;
      }
      len = lens[lens_index + work[sym]];
    }
    if (len > root && (huff & mask) !== low) {
      if (drop === 0) {
        drop = root;
      }
      next += min;
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) {
          break;
        }
        curr++;
        left <<= 1;
      }
      used += 1 << curr;
      if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
        return 1;
      }
      low = huff & mask;
      table[low] = root << 24 | curr << 16 | next - table_index | 0;
    }
  }
  if (huff !== 0) {
    table[next + huff] = len - drop << 24 | 64 << 16 | 0;
  }
  opts.bits = root;
  return 0;
};

var CODES$1 = 0;
var LENS$1 = 1;
var DISTS$1 = 2;
var Z_FINISH$2 = 4;
var Z_BLOCK$1 = 5;
var Z_TREES = 6;
var Z_OK$2 = 0;
var Z_STREAM_END$2 = 1;
var Z_NEED_DICT = 2;
var Z_STREAM_ERROR$1 = -2;
var Z_DATA_ERROR$1 = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR$1 = -5;
var Z_DEFLATED$2 = 8;
var HEAD = 1;
var FLAGS = 2;
var TIME = 3;
var OS = 4;
var EXLEN = 5;
var EXTRA = 6;
var NAME = 7;
var COMMENT = 8;
var HCRC = 9;
var DICTID = 10;
var DICT = 11;
var TYPE$1 = 12;
var TYPEDO = 13;
var STORED = 14;
var COPY_ = 15;
var COPY = 16;
var TABLE = 17;
var LENLENS = 18;
var CODELENS = 19;
var LEN_ = 20;
var LEN = 21;
var LENEXT = 22;
var DIST = 23;
var DISTEXT = 24;
var MATCH = 25;
var LIT = 26;
var CHECK = 27;
var LENGTH = 28;
var DONE = 29;
var BAD$1 = 30;
var MEM = 31;
var SYNC = 32;
var ENOUGH_LENS$1 = 852;
var ENOUGH_DISTS$1 = 592;
var MAX_WBITS$1 = 15;
var DEF_WBITS = MAX_WBITS$1;
function zswap32(q) {
  return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
  this.mode = 0;
  this.last = false;
  this.wrap = 0;
  this.havedict = false;
  this.flags = 0;
  this.dmax = 0;
  this.check = 0;
  this.total = 0;
  this.head = null;
  this.wbits = 0;
  this.wsize = 0;
  this.whave = 0;
  this.wnext = 0;
  this.window = null;
  this.hold = 0;
  this.bits = 0;
  this.length = 0;
  this.offset = 0;
  this.extra = 0;
  this.lencode = null;
  this.distcode = null;
  this.lenbits = 0;
  this.distbits = 0;
  this.ncode = 0;
  this.nlen = 0;
  this.ndist = 0;
  this.have = 0;
  this.next = null;
  this.lens = new common.Buf16(320);
  this.work = new common.Buf16(288);
  this.lendyn = null;
  this.distdyn = null;
  this.sane = 0;
  this.back = 0;
  this.was = 0;
}
function inflateResetKeep(strm) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = '';
  if (state.wrap) {
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null;
  state.hold = 0;
  state.bits = 0;
  state.lencode = state.lendyn = new common.Buf32(ENOUGH_LENS$1);
  state.distcode = state.distdyn = new common.Buf32(ENOUGH_DISTS$1);
  state.sane = 1;
  state.back = -1;
  return Z_OK$2;
}
function inflateReset(strm) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
  var wrap;
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  } else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR$1;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
  var ret;
  var state;
  if (!strm) {
    return Z_STREAM_ERROR$1;
  }
  state = new InflateState();
  strm.state = state;
  state.window = null;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK$2) {
    strm.state = null;
  }
  return ret;
}
function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}
var virgin = true;
var lenfix, distfix;
function fixedtables(state) {
  if (virgin) {
    var sym;
    lenfix = new common.Buf32(512);
    distfix = new common.Buf32(32);
    sym = 0;
    while (sym < 144) {
      state.lens[sym++] = 8;
    }
    while (sym < 256) {
      state.lens[sym++] = 9;
    }
    while (sym < 280) {
      state.lens[sym++] = 7;
    }
    while (sym < 288) {
      state.lens[sym++] = 8;
    }
    inftrees(LENS$1, state.lens, 0, 288, lenfix, 0, state.work, {
      bits: 9
    });
    sym = 0;
    while (sym < 32) {
      state.lens[sym++] = 5;
    }
    inftrees(DISTS$1, state.lens, 0, 32, distfix, 0, state.work, {
      bits: 5
    });
    virgin = false;
  }
  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;
    state.window = new common.Buf8(state.wsize);
  }
  if (copy >= state.wsize) {
    common.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  } else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    common.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      common.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    } else {
      state.wnext += dist;
      if (state.wnext === state.wsize) {
        state.wnext = 0;
      }
      if (state.whave < state.wsize) {
        state.whave += dist;
      }
    }
  }
  return 0;
}
function inflate(strm, flush) {
  var state;
  var input, output;
  var next;
  var put;
  var have, left;
  var hold;
  var bits;
  var _in, _out;
  var copy;
  var from;
  var from_source;
  var here = 0;
  var here_bits, here_op, here_val;
  var last_bits, last_op, last_val;
  var len;
  var ret;
  var hbuf = new common.Buf8(4);
  var opts;
  var n;
  var order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
  if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  if (state.mode === TYPE$1) {
    state.mode = TYPEDO;
  }
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  _in = have;
  _out = left;
  ret = Z_OK$2;
  inf_leave: for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        while (bits < 16) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if (state.wrap & 2 && hold === 0x8b1f) {
          state.check = 0;
          hbuf[0] = hold & 0xff;
          hbuf[1] = hold >>> 8 & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          hold = 0;
          bits = 0;
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) || (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD$1;
          break;
        }
        if ((hold & 0x0f) !== Z_DEFLATED$2) {
          strm.msg = 'unknown compression method';
          state.mode = BAD$1;
          break;
        }
        hold >>>= 4;
        bits -= 4;
        len = (hold & 0x0f) + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        } else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD$1;
          break;
        }
        state.dmax = 1 << len;
        strm.adler = state.check = 1;
        state.mode = hold & 0x200 ? DICTID : TYPE$1;
        hold = 0;
        bits = 0;
        break;
      case FLAGS:
        while (bits < 16) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED$2) {
          strm.msg = 'unknown compression method';
          state.mode = BAD$1;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD$1;
          break;
        }
        if (state.head) {
          state.head.text = hold >> 8 & 1;
        }
        if (state.flags & 0x0200) {
          hbuf[0] = hold & 0xff;
          hbuf[1] = hold >>> 8 & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
        }
        hold = 0;
        bits = 0;
        state.mode = TIME;
      case TIME:
        while (bits < 32) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          hbuf[0] = hold & 0xff;
          hbuf[1] = hold >>> 8 & 0xff;
          hbuf[2] = hold >>> 16 & 0xff;
          hbuf[3] = hold >>> 24 & 0xff;
          state.check = crc32_1(state.check, hbuf, 4, 0);
        }
        hold = 0;
        bits = 0;
        state.mode = OS;
      case OS:
        while (bits < 16) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if (state.head) {
          state.head.xflags = hold & 0xff;
          state.head.os = hold >> 8;
        }
        if (state.flags & 0x0200) {
          hbuf[0] = hold & 0xff;
          hbuf[1] = hold >>> 8 & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
        }
        hold = 0;
        bits = 0;
        state.mode = EXLEN;
      case EXLEN:
        if (state.flags & 0x0400) {
          while (bits < 16) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            hbuf[0] = hold & 0xff;
            hbuf[1] = hold >>> 8 & 0xff;
            state.check = crc32_1(state.check, hbuf, 2, 0);
          }
          hold = 0;
          bits = 0;
        } else if (state.head) {
          state.head.extra = null;
        }
        state.mode = EXTRA;
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) {
            copy = have;
          }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                state.head.extra = new Array(state.head.extra_len);
              }
              common.arraySet(state.head.extra, input, next, copy, len);
            }
            if (state.flags & 0x0200) {
              state.check = crc32_1(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) {
            break inf_leave;
          }
        }
        state.length = 0;
        state.mode = NAME;
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) {
            break inf_leave;
          }
          copy = 0;
          do {
            len = input[next + copy++];
            if (state.head && len && state.length < 65536) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) {
            break inf_leave;
          }
        } else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) {
            break inf_leave;
          }
          copy = 0;
          do {
            len = input[next + copy++];
            if (state.head && len && state.length < 65536) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) {
            break inf_leave;
          }
        } else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
      case HCRC:
        if (state.flags & 0x0200) {
          while (bits < 16) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD$1;
            break;
          }
          hold = 0;
          bits = 0;
        }
        if (state.head) {
          state.head.hcrc = state.flags >> 9 & 1;
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE$1;
        break;
      case DICTID:
        while (bits < 32) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        strm.adler = state.check = zswap32(hold);
        hold = 0;
        bits = 0;
        state.mode = DICT;
      case DICT:
        if (state.havedict === 0) {
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1;
        state.mode = TYPE$1;
      case TYPE$1:
        if (flush === Z_BLOCK$1 || flush === Z_TREES) {
          break inf_leave;
        }
      case TYPEDO:
        if (state.last) {
          hold >>>= bits & 7;
          bits -= bits & 7;
          state.mode = CHECK;
          break;
        }
        while (bits < 3) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        state.last = hold & 0x01;
        hold >>>= 1;
        bits -= 1;
        switch (hold & 0x03) {
          case 0:
            state.mode = STORED;
            break;
          case 1:
            fixedtables(state);
            state.mode = LEN_;
            if (flush === Z_TREES) {
              hold >>>= 2;
              bits -= 2;
              break inf_leave;
            }
            break;
          case 2:
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD$1;
        }
        hold >>>= 2;
        bits -= 2;
        break;
      case STORED:
        hold >>>= bits & 7;
        bits -= bits & 7;
        while (bits < 32) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD$1;
          break;
        }
        state.length = hold & 0xffff;
        hold = 0;
        bits = 0;
        state.mode = COPY_;
        if (flush === Z_TREES) {
          break inf_leave;
        }
      case COPY_:
        state.mode = COPY;
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) {
            copy = have;
          }
          if (copy > left) {
            copy = left;
          }
          if (copy === 0) {
            break inf_leave;
          }
          common.arraySet(output, input, next, copy, put);
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        state.mode = TYPE$1;
        break;
      case TABLE:
        while (bits < 14) {
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        state.nlen = (hold & 0x1f) + 257;
        hold >>>= 5;
        bits -= 5;
        state.ndist = (hold & 0x1f) + 1;
        hold >>>= 5;
        bits -= 5;
        state.ncode = (hold & 0x0f) + 4;
        hold >>>= 4;
        bits -= 4;
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD$1;
          break;
        }
        state.have = 0;
        state.mode = LENLENS;
      case LENLENS:
        while (state.have < state.ncode) {
          while (bits < 3) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.lens[order[state.have++]] = hold & 0x07;
          hold >>>= 3;
          bits -= 3;
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        state.lencode = state.lendyn;
        state.lenbits = 7;
        opts = {
          bits: state.lenbits
        };
        ret = inftrees(CODES$1, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;
        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD$1;
          break;
        }
        state.have = 0;
        state.mode = CODELENS;
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & (1 << state.lenbits) - 1];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 0xff;
            here_val = here & 0xffff;
            if (here_bits <= bits) {
              break;
            }
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (here_val < 16) {
            hold >>>= here_bits;
            bits -= here_bits;
            state.lens[state.have++] = here_val;
          } else {
            if (here_val === 16) {
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              hold >>>= here_bits;
              bits -= here_bits;
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD$1;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);
              hold >>>= 2;
              bits -= 2;
            } else if (here_val === 17) {
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              hold >>>= here_bits;
              bits -= here_bits;
              len = 0;
              copy = 3 + (hold & 0x07);
              hold >>>= 3;
              bits -= 3;
            } else {
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              hold >>>= here_bits;
              bits -= here_bits;
              len = 0;
              copy = 11 + (hold & 0x7f);
              hold >>>= 7;
              bits -= 7;
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD$1;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }
        if (state.mode === BAD$1) {
          break;
        }
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD$1;
          break;
        }
        state.lenbits = 9;
        opts = {
          bits: state.lenbits
        };
        ret = inftrees(LENS$1, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;
        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD$1;
          break;
        }
        state.distbits = 6;
        state.distcode = state.distdyn;
        opts = {
          bits: state.distbits
        };
        ret = inftrees(DISTS$1, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        state.distbits = opts.bits;
        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD$1;
          break;
        }
        state.mode = LEN_;
        if (flush === Z_TREES) {
          break inf_leave;
        }
      case LEN_:
        state.mode = LEN;
      case LEN:
        if (have >= 6 && left >= 258) {
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          inffast(strm, _out);
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          if (state.mode === TYPE$1) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & (1 << state.lenbits) - 1];
          here_bits = here >>> 24;
          here_op = here >>> 16 & 0xff;
          here_val = here & 0xffff;
          if (here_bits <= bits) {
            break;
          }
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 0xff;
            here_val = here & 0xffff;
            if (last_bits + here_bits <= bits) {
              break;
            }
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          hold >>>= last_bits;
          bits -= last_bits;
          state.back += last_bits;
        }
        hold >>>= here_bits;
        bits -= here_bits;
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          state.back = -1;
          state.mode = TYPE$1;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD$1;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
      case LENEXT:
        if (state.extra) {
          n = state.extra;
          while (bits < n) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.length += hold & (1 << state.extra) - 1;
          hold >>>= state.extra;
          bits -= state.extra;
          state.back += state.extra;
        }
        state.was = state.length;
        state.mode = DIST;
      case DIST:
        for (;;) {
          here = state.distcode[hold & (1 << state.distbits) - 1];
          here_bits = here >>> 24;
          here_op = here >>> 16 & 0xff;
          here_val = here & 0xffff;
          if (here_bits <= bits) {
            break;
          }
          if (have === 0) {
            break inf_leave;
          }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 0xff;
            here_val = here & 0xffff;
            if (last_bits + here_bits <= bits) {
              break;
            }
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          hold >>>= last_bits;
          bits -= last_bits;
          state.back += last_bits;
        }
        hold >>>= here_bits;
        bits -= here_bits;
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD$1;
          break;
        }
        state.offset = here_val;
        state.extra = here_op & 15;
        state.mode = DISTEXT;
      case DISTEXT:
        if (state.extra) {
          n = state.extra;
          while (bits < n) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.offset += hold & (1 << state.extra) - 1;
          hold >>>= state.extra;
          bits -= state.extra;
          state.back += state.extra;
        }
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD$1;
          break;
        }
        state.mode = MATCH;
      case MATCH:
        if (left === 0) {
          break inf_leave;
        }
        copy = _out - left;
        if (state.offset > copy) {
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break;
            }
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          } else {
            from = state.wnext - copy;
          }
          if (copy > state.length) {
            copy = state.length;
          }
          from_source = state.window;
        } else {
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) {
          copy = left;
        }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) {
          state.mode = LEN;
        }
        break;
      case LIT:
        if (left === 0) {
          break inf_leave;
        }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          while (bits < 32) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold |= input[next++] << bits;
            bits += 8;
          }
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out);
          }
          _out = left;
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD$1;
            break;
          }
          hold = 0;
          bits = 0;
        }
        state.mode = LENGTH;
      case LENGTH:
        if (state.wrap && state.flags) {
          while (bits < 32) {
            if (have === 0) {
              break inf_leave;
            }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD$1;
            break;
          }
          hold = 0;
          bits = 0;
        }
        state.mode = DONE;
      case DONE:
        ret = Z_STREAM_END$2;
        break inf_leave;
      case BAD$1:
        ret = Z_DATA_ERROR$1;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
      default:
        return Z_STREAM_ERROR$1;
    }
  }
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  if (state.wsize || _out !== strm.avail_out && state.mode < BAD$1 && (state.mode < CHECK || flush !== Z_FINISH$2)) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out);
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE$1 ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if ((_in === 0 && _out === 0 || flush === Z_FINISH$2) && ret === Z_OK$2) {
    ret = Z_BUF_ERROR$1;
  }
  return ret;
}
function inflateEnd(strm) {
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK$2;
}
function inflateGetHeader(strm, head) {
  var state;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  if ((state.wrap & 2) === 0) {
    return Z_STREAM_ERROR$1;
  }
  state.head = head;
  head.done = false;
  return Z_OK$2;
}
function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;
  var state;
  var dictid;
  var ret;
  if (!strm || !strm.state) {
    return Z_STREAM_ERROR$1;
  }
  state = strm.state;
  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR$1;
  }
  if (state.mode === DICT) {
    dictid = 1;
    dictid = adler32_1(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR$1;
    }
  }
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  return Z_OK$2;
}
var inflateReset_1 = inflateReset;
var inflateReset2_1 = inflateReset2;
var inflateResetKeep_1 = inflateResetKeep;
var inflateInit_1 = inflateInit;
var inflateInit2_1 = inflateInit2;
var inflate_2 = inflate;
var inflateEnd_1 = inflateEnd;
var inflateGetHeader_1 = inflateGetHeader;
var inflateSetDictionary_1 = inflateSetDictionary;
var inflateInfo = 'pako inflate (from Nodeca project)';
var inflate_1 = {
  inflateReset: inflateReset_1,
  inflateReset2: inflateReset2_1,
  inflateResetKeep: inflateResetKeep_1,
  inflateInit: inflateInit_1,
  inflateInit2: inflateInit2_1,
  inflate: inflate_2,
  inflateEnd: inflateEnd_1,
  inflateGetHeader: inflateGetHeader_1,
  inflateSetDictionary: inflateSetDictionary_1,
  inflateInfo: inflateInfo
};

var constants = {
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_BUF_ERROR: -5,
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  Z_BINARY: 0,
  Z_TEXT: 1,
  Z_UNKNOWN: 2,
  Z_DEFLATED: 8
};

function GZheader() {
  this.text = 0;
  this.time = 0;
  this.xflags = 0;
  this.os = 0;
  this.extra = null;
  this.extra_len = 0;
  this.name = '';
  this.comment = '';
  this.hcrc = 0;
  this.done = false;
}
var gzheader = GZheader;

var toString$3 = Object.prototype.toString;
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);
  this.options = common.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});
  var opt = this.options;
  if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) {
      opt.windowBits = -15;
    }
  }
  if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
    opt.windowBits += 32;
  }
  if (opt.windowBits > 15 && opt.windowBits < 48) {
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }
  this.err = 0;
  this.msg = '';
  this.ended = false;
  this.chunks = [];
  this.strm = new zstream();
  this.strm.avail_out = 0;
  var status = inflate_1.inflateInit2(this.strm, opt.windowBits);
  if (status !== constants.Z_OK) {
    throw new Error(messages[status]);
  }
  this.header = new gzheader();
  inflate_1.inflateGetHeader(this.strm, this.header);
  if (opt.dictionary) {
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString$3.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) {
      status = inflate_1.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== constants.Z_OK) {
        throw new Error(messages[status]);
      }
    }
  }
}
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var allowBufError = false;
  if (this.ended) {
    return false;
  }
  _mode = mode === ~~mode ? mode : mode === true ? constants.Z_FINISH : constants.Z_NO_FLUSH;
  if (typeof data === 'string') {
    strm.input = strings.binstring2buf(data);
  } else if (toString$3.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }
  strm.next_in = 0;
  strm.avail_in = strm.input.length;
  do {
    if (strm.avail_out === 0) {
      strm.output = new common.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = inflate_1.inflate(strm, constants.Z_NO_FLUSH);
    if (status === constants.Z_NEED_DICT && dictionary) {
      status = inflate_1.inflateSetDictionary(this.strm, dictionary);
    }
    if (status === constants.Z_BUF_ERROR && allowBufError === true) {
      status = constants.Z_OK;
      allowBufError = false;
    }
    if (status !== constants.Z_STREAM_END && status !== constants.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.next_out) {
      if (strm.avail_out === 0 || status === constants.Z_STREAM_END || strm.avail_in === 0 && (_mode === constants.Z_FINISH || _mode === constants.Z_SYNC_FLUSH)) {
        if (this.options.to === 'string') {
          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) {
            common.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
          }
          this.onData(utf8str);
        } else {
          this.onData(common.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== constants.Z_STREAM_END);
  if (status === constants.Z_STREAM_END) {
    _mode = constants.Z_FINISH;
  }
  if (_mode === constants.Z_FINISH) {
    status = inflate_1.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === constants.Z_OK;
  }
  if (_mode === constants.Z_SYNC_FLUSH) {
    this.onEnd(constants.Z_OK);
    strm.avail_out = 0;
    return true;
  }
  return true;
};
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};
Inflate.prototype.onEnd = function (status) {
  if (status === constants.Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = common.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};
function inflate$1(input, options) {
  var inflator = new Inflate(options);
  inflator.push(input, true);
  if (inflator.err) {
    throw inflator.msg || messages[inflator.err];
  }
  return inflator.result;
}
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate$1(input, options);
}
var Inflate_1 = Inflate;
var inflate_2$1 = inflate$1;
var inflateRaw_1 = inflateRaw;
var ungzip = inflate$1;
var inflate_1$1 = {
  Inflate: Inflate_1,
  inflate: inflate_2$1,
  inflateRaw: inflateRaw_1,
  ungzip: ungzip
};

var assign = common.assign;
var pako = {};
assign(pako, deflate_1$1, inflate_1$1, constants);
var pako_1 = pako;

var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var lookup$1 = new Uint8Array(256);
for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
  lookup$1[chars$1.charCodeAt(i$1)] = i$1;
}
var decodeFromBase64$1 = function (base64) {
  var bufferLength = base64.length * 0.75;
  var len = base64.length;
  var i;
  var p = 0;
  var encoded1;
  var encoded2;
  var encoded3;
  var encoded4;
  if (base64[base64.length - 1] === '=') {
    bufferLength--;
    if (base64[base64.length - 2] === '=') {
      bufferLength--;
    }
  }
  var bytes = new Uint8Array(bufferLength);
  for (i = 0; i < len; i += 4) {
    encoded1 = lookup$1[base64.charCodeAt(i)];
    encoded2 = lookup$1[base64.charCodeAt(i + 1)];
    encoded3 = lookup$1[base64.charCodeAt(i + 2)];
    encoded4 = lookup$1[base64.charCodeAt(i + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return bytes;
};
var arrayToString = function (array) {
  var str = '';
  for (var i = 0; i < array.length; i++) {
    str += String.fromCharCode(array[i]);
  }
  return str;
};
var decompressJson = function (compressedJson) {
  return arrayToString(pako_1.inflate(decodeFromBase64$1(compressedJson)));
};
var padStart$1 = function (value, length, padChar) {
  var padding = '';
  for (var idx = 0, len = length - value.length; idx < len; idx++) {
    padding += padChar;
  }
  return padding + value;
};

var CourierBoldCompressed = "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";

var CourierBoldObliqueCompressed = "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";

var CourierObliqueCompressed = "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";

var CourierCompressed = "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";

var HelveticaBoldCompressed = "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";

var HelveticaBoldObliqueCompressed = "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";

var HelveticaObliqueCompressed = "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";

var HelveticaCompressed = "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";

var TimesBoldCompressed = "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";

var TimesBoldItalicCompressed = "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";

var TimesItalicCompressed = "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";

var TimesRomanCompressed = "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";

var SymbolCompressed = "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";

var ZapfDingbatsCompressed = "eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==";

var compressedJsonForFontName = {
  'Courier': CourierCompressed,
  'Courier-Bold': CourierBoldCompressed,
  'Courier-Oblique': CourierObliqueCompressed,
  'Courier-BoldOblique': CourierBoldObliqueCompressed,
  'Helvetica': HelveticaCompressed,
  'Helvetica-Bold': HelveticaBoldCompressed,
  'Helvetica-Oblique': HelveticaObliqueCompressed,
  'Helvetica-BoldOblique': HelveticaBoldObliqueCompressed,
  'Times-Roman': TimesRomanCompressed,
  'Times-Bold': TimesBoldCompressed,
  'Times-Italic': TimesItalicCompressed,
  'Times-BoldItalic': TimesBoldItalicCompressed,
  'Symbol': SymbolCompressed,
  'ZapfDingbats': ZapfDingbatsCompressed
};
var FontNames;
(function (FontNames) {
  FontNames["Courier"] = "Courier";
  FontNames["CourierBold"] = "Courier-Bold";
  FontNames["CourierOblique"] = "Courier-Oblique";
  FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
  FontNames["Helvetica"] = "Helvetica";
  FontNames["HelveticaBold"] = "Helvetica-Bold";
  FontNames["HelveticaOblique"] = "Helvetica-Oblique";
  FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
  FontNames["TimesRoman"] = "Times-Roman";
  FontNames["TimesRomanBold"] = "Times-Bold";
  FontNames["TimesRomanItalic"] = "Times-Italic";
  FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
  FontNames["Symbol"] = "Symbol";
  FontNames["ZapfDingbats"] = "ZapfDingbats";
})(FontNames || (FontNames = {}));
var fontCache = {};
var Font = function () {
  function Font() {
    var _this = this;
    this.getWidthOfGlyph = function (glyphName) {
      return _this.CharWidths[glyphName];
    };
    this.getXAxisKerningForPair = function (leftGlyphName, rightGlyphName) {
      return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
    };
  }
  Font.load = function (fontName) {
    var cachedFont = fontCache[fontName];
    if (cachedFont) return cachedFont;
    var json = decompressJson(compressedJsonForFontName[fontName]);
    var font = Object.assign(new Font(), JSON.parse(json));
    font.CharWidths = font.CharMetrics.reduce(function (acc, metric) {
      acc[metric.N] = metric.WX;
      return acc;
    }, {});
    font.KernPairXAmounts = font.KernPairs.reduce(function (acc, _a) {
      var name1 = _a[0],
        name2 = _a[1],
        width = _a[2];
      if (!acc[name1]) acc[name1] = {};
      acc[name1][name2] = width;
      return acc;
    }, {});
    fontCache[fontName] = font;
    return font;
  };
  return Font;
}();

var AllEncodingsCompressed = "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";

var decompressedEncodings = decompressJson(AllEncodingsCompressed);
var allUnicodeMappings = JSON.parse(decompressedEncodings);
var Encoding = function () {
  function Encoding(name, unicodeMappings) {
    var _this = this;
    this.canEncodeUnicodeCodePoint = function (codePoint) {
      return codePoint in _this.unicodeMappings;
    };
    this.encodeUnicodeCodePoint = function (codePoint) {
      var mapped = _this.unicodeMappings[codePoint];
      if (!mapped) {
        var str = String.fromCharCode(codePoint);
        var hexCode = "0x" + padStart$1(codePoint.toString(16), 4, '0');
        var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
        throw new Error(msg);
      }
      return {
        code: mapped[0],
        name: mapped[1]
      };
    };
    this.name = name;
    this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function (a, b) {
      return a - b;
    });
    this.unicodeMappings = unicodeMappings;
  }
  return Encoding;
}();
var Encodings = {
  Symbol: new Encoding('Symbol', allUnicodeMappings.symbol),
  ZapfDingbats: new Encoding('ZapfDingbats', allUnicodeMappings.zapfdingbats),
  WinAnsi: new Encoding('WinAnsi', allUnicodeMappings.win1252)
};

var values = function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var StandardFontValues = values(FontNames);
var isStandardFont = function (input) {
  return StandardFontValues.includes(input);
};
var rectanglesAreEqual = function (a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

var backtick = function (val) {
  return "`" + val + "`";
};
var singleQuote = function (val) {
  return "'" + val + "'";
};
var formatValue = function (value) {
  var type = typeof value;
  if (type === 'string') return singleQuote(value);else if (type === 'undefined') return backtick(value);else return value;
};
var createValueErrorMsg = function (value, valueName, values) {
  var allowedValues = new Array(values.length);
  for (var idx = 0, len = values.length; idx < len; idx++) {
    var v = values[idx];
    allowedValues[idx] = formatValue(v);
  }
  var joinedValues = allowedValues.join(' or ');
  return backtick(valueName) + " must be one of " + joinedValues + ", but was actually " + formatValue(value);
};
var assertIsOneOf = function (value, valueName, allowedValues) {
  if (!Array.isArray(allowedValues)) {
    allowedValues = values(allowedValues);
  }
  for (var idx = 0, len = allowedValues.length; idx < len; idx++) {
    if (value === allowedValues[idx]) return;
  }
  throw new TypeError(createValueErrorMsg(value, valueName, allowedValues));
};
var assertIsOneOfOrUndefined = function (value, valueName, allowedValues) {
  if (!Array.isArray(allowedValues)) {
    allowedValues = values(allowedValues);
  }
  assertIsOneOf(value, valueName, allowedValues.concat(undefined));
};
var assertIsSubset = function (values$1, valueName, allowedValues) {
  if (!Array.isArray(allowedValues)) {
    allowedValues = values(allowedValues);
  }
  for (var idx = 0, len = values$1.length; idx < len; idx++) {
    assertIsOneOf(values$1[idx], valueName, allowedValues);
  }
};
var getType = function (val) {
  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (typeof val === 'string') return 'string';
  if (isNaN(val)) return 'NaN';
  if (typeof val === 'number') return 'number';
  if (typeof val === 'boolean') return 'boolean';
  if (typeof val === 'symbol') return 'symbol';
  if (typeof val === 'bigint') return 'bigint';
  if (val.constructor && val.constructor.name) return val.constructor.name;
  if (val.name) return val.name;
  if (val.constructor) return String(val.constructor);
  return String(val);
};
var isType = function (value, type) {
  if (type === 'null') return value === null;
  if (type === 'undefined') return value === undefined;
  if (type === 'string') return typeof value === 'string';
  if (type === 'number') return typeof value === 'number' && !isNaN(value);
  if (type === 'boolean') return typeof value === 'boolean';
  if (type === 'symbol') return typeof value === 'symbol';
  if (type === 'bigint') return typeof value === 'bigint';
  if (type === Date) return value instanceof Date;
  if (type === Array) return value instanceof Array;
  if (type === Uint8Array) return value instanceof Uint8Array;
  if (type === ArrayBuffer) return value instanceof ArrayBuffer;
  if (type === Function) return value instanceof Function;
  return value instanceof type[0];
};
var createTypeErrorMsg = function (value, valueName, types) {
  var allowedTypes = new Array(types.length);
  for (var idx = 0, len = types.length; idx < len; idx++) {
    var type = types[idx];
    if (type === 'null') allowedTypes[idx] = backtick('null');
    if (type === 'undefined') allowedTypes[idx] = backtick('undefined');
    if (type === 'string') allowedTypes[idx] = backtick('string');else if (type === 'number') allowedTypes[idx] = backtick('number');else if (type === 'boolean') allowedTypes[idx] = backtick('boolean');else if (type === 'symbol') allowedTypes[idx] = backtick('symbol');else if (type === 'bigint') allowedTypes[idx] = backtick('bigint');else if (type === Array) allowedTypes[idx] = backtick('Array');else if (type === Uint8Array) allowedTypes[idx] = backtick('Uint8Array');else if (type === ArrayBuffer) allowedTypes[idx] = backtick('ArrayBuffer');else allowedTypes[idx] = backtick(type[1]);
  }
  var joinedTypes = allowedTypes.join(' or ');
  return backtick(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + backtick(getType(value));
};
var assertIs = function (value, valueName, types) {
  for (var idx = 0, len = types.length; idx < len; idx++) {
    if (isType(value, types[idx])) return;
  }
  throw new TypeError(createTypeErrorMsg(value, valueName, types));
};
var assertOrUndefined = function (value, valueName, types) {
  assertIs(value, valueName, types.concat('undefined'));
};
var assertEachIs = function (values, valueName, types) {
  for (var idx = 0, len = values.length; idx < len; idx++) {
    assertIs(values[idx], valueName, types);
  }
};
var assertRange = function (value, valueName, min, max) {
  assertIs(value, valueName, ['number']);
  assertIs(min, 'min', ['number']);
  assertIs(max, 'max', ['number']);
  max = Math.max(min, max);
  if (value < min || value > max) {
    throw new Error(backtick(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
  }
};
var assertRangeOrUndefined = function (value, valueName, min, max) {
  assertIs(value, valueName, ['number', 'undefined']);
  if (typeof value === 'number') assertRange(value, valueName, min, max);
};
var assertMultiple = function (value, valueName, multiplier) {
  assertIs(value, valueName, ['number']);
  if (value % multiplier !== 0) {
    throw new Error(backtick(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
  }
};
var assertInteger = function (value, valueName) {
  if (!Number.isInteger(value)) {
    throw new Error(backtick(valueName) + " must be an integer, but was actually " + value);
  }
};
var assertPositive = function (value, valueName) {
  if (![1, 0].includes(Math.sign(value))) {
    throw new Error(backtick(valueName) + " must be a positive number or 0, but was actually " + value);
  }
};

var pdfDocEncodingToUnicode = new Uint16Array(256);
for (var idx = 0; idx < 256; idx++) {
  pdfDocEncodingToUnicode[idx] = idx;
}
pdfDocEncodingToUnicode[0x16] = toCharCode('\u0017');
pdfDocEncodingToUnicode[0x18] = toCharCode('\u02D8');
pdfDocEncodingToUnicode[0x19] = toCharCode('\u02C7');
pdfDocEncodingToUnicode[0x1a] = toCharCode('\u02C6');
pdfDocEncodingToUnicode[0x1b] = toCharCode('\u02D9');
pdfDocEncodingToUnicode[0x1c] = toCharCode('\u02DD');
pdfDocEncodingToUnicode[0x1d] = toCharCode('\u02DB');
pdfDocEncodingToUnicode[0x1e] = toCharCode('\u02DA');
pdfDocEncodingToUnicode[0x1f] = toCharCode('\u02DC');
pdfDocEncodingToUnicode[0x7f] = toCharCode('\uFFFD');
pdfDocEncodingToUnicode[0x80] = toCharCode('\u2022');
pdfDocEncodingToUnicode[0x81] = toCharCode('\u2020');
pdfDocEncodingToUnicode[0x82] = toCharCode('\u2021');
pdfDocEncodingToUnicode[0x83] = toCharCode('\u2026');
pdfDocEncodingToUnicode[0x84] = toCharCode('\u2014');
pdfDocEncodingToUnicode[0x85] = toCharCode('\u2013');
pdfDocEncodingToUnicode[0x86] = toCharCode('\u0192');
pdfDocEncodingToUnicode[0x87] = toCharCode('\u2044');
pdfDocEncodingToUnicode[0x88] = toCharCode('\u2039');
pdfDocEncodingToUnicode[0x89] = toCharCode('\u203A');
pdfDocEncodingToUnicode[0x8a] = toCharCode('\u2212');
pdfDocEncodingToUnicode[0x8b] = toCharCode('\u2030');
pdfDocEncodingToUnicode[0x8c] = toCharCode('\u201E');
pdfDocEncodingToUnicode[0x8d] = toCharCode('\u201C');
pdfDocEncodingToUnicode[0x8e] = toCharCode('\u201D');
pdfDocEncodingToUnicode[0x8f] = toCharCode('\u2018');
pdfDocEncodingToUnicode[0x90] = toCharCode('\u2019');
pdfDocEncodingToUnicode[0x91] = toCharCode('\u201A');
pdfDocEncodingToUnicode[0x92] = toCharCode('\u2122');
pdfDocEncodingToUnicode[0x93] = toCharCode('\uFB01');
pdfDocEncodingToUnicode[0x94] = toCharCode('\uFB02');
pdfDocEncodingToUnicode[0x95] = toCharCode('\u0141');
pdfDocEncodingToUnicode[0x96] = toCharCode('\u0152');
pdfDocEncodingToUnicode[0x97] = toCharCode('\u0160');
pdfDocEncodingToUnicode[0x98] = toCharCode('\u0178');
pdfDocEncodingToUnicode[0x99] = toCharCode('\u017D');
pdfDocEncodingToUnicode[0x9a] = toCharCode('\u0131');
pdfDocEncodingToUnicode[0x9b] = toCharCode('\u0142');
pdfDocEncodingToUnicode[0x9c] = toCharCode('\u0153');
pdfDocEncodingToUnicode[0x9d] = toCharCode('\u0161');
pdfDocEncodingToUnicode[0x9e] = toCharCode('\u017E');
pdfDocEncodingToUnicode[0x9f] = toCharCode('\uFFFD');
pdfDocEncodingToUnicode[0xa0] = toCharCode('\u20AC');
pdfDocEncodingToUnicode[0xad] = toCharCode('\uFFFD');
var pdfDocEncodingDecode = function (bytes) {
  var codePoints = new Array(bytes.length);
  for (var idx = 0, len = bytes.length; idx < len; idx++) {
    codePoints[idx] = pdfDocEncodingToUnicode[bytes[idx]];
  }
  return String.fromCodePoint.apply(String, codePoints);
};

var Cache = function () {
  function Cache(populate) {
    this.populate = populate;
    this.value = undefined;
  }
  Cache.prototype.getValue = function () {
    return this.value;
  };
  Cache.prototype.access = function () {
    if (!this.value) this.value = this.populate();
    return this.value;
  };
  Cache.prototype.invalidate = function () {
    this.value = undefined;
  };
  Cache.populatedBy = function (populate) {
    return new Cache(populate);
  };
  return Cache;
}();

var MethodNotImplementedError = function (_super) {
  __extends(MethodNotImplementedError, _super);
  function MethodNotImplementedError(className, methodName) {
    var _this = this;
    var msg = "Method " + className + "." + methodName + "() not implemented";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MethodNotImplementedError;
}(Error);
var PrivateConstructorError = function (_super) {
  __extends(PrivateConstructorError, _super);
  function PrivateConstructorError(className) {
    var _this = this;
    var msg = "Cannot construct " + className + " - it has a private constructor";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return PrivateConstructorError;
}(Error);
var UnexpectedObjectTypeError = function (_super) {
  __extends(UnexpectedObjectTypeError, _super);
  function UnexpectedObjectTypeError(expected, actual) {
    var _this = this;
    var name = function (t) {
      var _a, _b;
      return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
    };
    var expectedTypes = Array.isArray(expected) ? expected.map(name) : [name(expected)];
    var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return UnexpectedObjectTypeError;
}(Error);
var UnsupportedEncodingError = function (_super) {
  __extends(UnsupportedEncodingError, _super);
  function UnsupportedEncodingError(encoding) {
    var _this = this;
    var msg = encoding + " stream encoding not supported";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return UnsupportedEncodingError;
}(Error);
var ReparseError = function (_super) {
  __extends(ReparseError, _super);
  function ReparseError(className, methodName) {
    var _this = this;
    var msg = "Cannot call " + className + "." + methodName + "() more than once";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return ReparseError;
}(Error);
var MissingCatalogError = function (_super) {
  __extends(MissingCatalogError, _super);
  function MissingCatalogError(ref) {
    var _this = this;
    var msg = "Missing catalog (ref=" + ref + ")";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MissingCatalogError;
}(Error);
var MissingPageContentsEmbeddingError = function (_super) {
  __extends(MissingPageContentsEmbeddingError, _super);
  function MissingPageContentsEmbeddingError() {
    var _this = this;
    var msg = "Can't embed page with missing Contents";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MissingPageContentsEmbeddingError;
}(Error);
var UnrecognizedStreamTypeError = function (_super) {
  __extends(UnrecognizedStreamTypeError, _super);
  function UnrecognizedStreamTypeError(stream) {
    var _a, _b, _c;
    var _this = this;
    var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
    var msg = "Unrecognized stream type: " + streamType;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return UnrecognizedStreamTypeError;
}(Error);
var PageEmbeddingMismatchedContextError = function (_super) {
  __extends(PageEmbeddingMismatchedContextError, _super);
  function PageEmbeddingMismatchedContextError() {
    var _this = this;
    var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return PageEmbeddingMismatchedContextError;
}(Error);
var PDFArrayIsNotRectangleError = function (_super) {
  __extends(PDFArrayIsNotRectangleError, _super);
  function PDFArrayIsNotRectangleError(size) {
    var _this = this;
    var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return PDFArrayIsNotRectangleError;
}(Error);
var InvalidPDFDateStringError = function (_super) {
  __extends(InvalidPDFDateStringError, _super);
  function InvalidPDFDateStringError(value) {
    var _this = this;
    var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return InvalidPDFDateStringError;
}(Error);
var InvalidTargetIndexError = function (_super) {
  __extends(InvalidTargetIndexError, _super);
  function InvalidTargetIndexError(targetIndex, Count) {
    var _this = this;
    var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return InvalidTargetIndexError;
}(Error);
var CorruptPageTreeError = function (_super) {
  __extends(CorruptPageTreeError, _super);
  function CorruptPageTreeError(targetIndex, operation) {
    var _this = this;
    var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return CorruptPageTreeError;
}(Error);
var IndexOutOfBoundsError = function (_super) {
  __extends(IndexOutOfBoundsError, _super);
  function IndexOutOfBoundsError(index, min, max) {
    var _this = this;
    var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return IndexOutOfBoundsError;
}(Error);
var InvalidAcroFieldValueError = function (_super) {
  __extends(InvalidAcroFieldValueError, _super);
  function InvalidAcroFieldValueError() {
    var _this = this;
    var msg = "Attempted to set invalid field value";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return InvalidAcroFieldValueError;
}(Error);
var MultiSelectValueError = function (_super) {
  __extends(MultiSelectValueError, _super);
  function MultiSelectValueError() {
    var _this = this;
    var msg = "Attempted to select multiple values for single-select field";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MultiSelectValueError;
}(Error);
var MissingDAEntryError = function (_super) {
  __extends(MissingDAEntryError, _super);
  function MissingDAEntryError(fieldName) {
    var _this = this;
    var msg = "No /DA (default appearance) entry found for field: " + fieldName;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MissingDAEntryError;
}(Error);
var MissingTfOperatorError = function (_super) {
  __extends(MissingTfOperatorError, _super);
  function MissingTfOperatorError(fieldName) {
    var _this = this;
    var msg = "No Tf operator found for DA of field: " + fieldName;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MissingTfOperatorError;
}(Error);
var NumberParsingError = function (_super) {
  __extends(NumberParsingError, _super);
  function NumberParsingError(pos, value) {
    var _this = this;
    var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return NumberParsingError;
}(Error);
var PDFParsingError = function (_super) {
  __extends(PDFParsingError, _super);
  function PDFParsingError(pos, details) {
    var _this = this;
    var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return PDFParsingError;
}(Error);
var NextByteAssertionError = function (_super) {
  __extends(NextByteAssertionError, _super);
  function NextByteAssertionError(pos, expectedByte, actualByte) {
    var _this = this;
    var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return NextByteAssertionError;
}(PDFParsingError);
var PDFObjectParsingError = function (_super) {
  __extends(PDFObjectParsingError, _super);
  function PDFObjectParsingError(pos, byte) {
    var _this = this;
    var msg = "Failed to parse PDF object starting with the following byte: " + byte;
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return PDFObjectParsingError;
}(PDFParsingError);
var PDFInvalidObjectParsingError = function (_super) {
  __extends(PDFInvalidObjectParsingError, _super);
  function PDFInvalidObjectParsingError(pos) {
    var _this = this;
    var msg = "Failed to parse invalid PDF object";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return PDFInvalidObjectParsingError;
}(PDFParsingError);
var PDFStreamParsingError = function (_super) {
  __extends(PDFStreamParsingError, _super);
  function PDFStreamParsingError(pos) {
    var _this = this;
    var msg = "Failed to parse PDF stream";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return PDFStreamParsingError;
}(PDFParsingError);
var UnbalancedParenthesisError = function (_super) {
  __extends(UnbalancedParenthesisError, _super);
  function UnbalancedParenthesisError(pos) {
    var _this = this;
    var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return UnbalancedParenthesisError;
}(PDFParsingError);
var StalledParserError = function (_super) {
  __extends(StalledParserError, _super);
  function StalledParserError(pos) {
    var _this = this;
    var msg = "Parser stalled";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return StalledParserError;
}(PDFParsingError);
var MissingPDFHeaderError = function (_super) {
  __extends(MissingPDFHeaderError, _super);
  function MissingPDFHeaderError(pos) {
    var _this = this;
    var msg = "No PDF header found";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return MissingPDFHeaderError;
}(PDFParsingError);
var MissingKeywordError = function (_super) {
  __extends(MissingKeywordError, _super);
  function MissingKeywordError(pos, keyword) {
    var _this = this;
    var msg = "Did not find expected keyword '" + arrayAsString(keyword) + "'";
    _this = _super.call(this, pos, msg) || this;
    return _this;
  }
  return MissingKeywordError;
}(PDFParsingError);

var CharCodes;
(function (CharCodes) {
  CharCodes[CharCodes["Null"] = 0] = "Null";
  CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
  CharCodes[CharCodes["Tab"] = 9] = "Tab";
  CharCodes[CharCodes["Newline"] = 10] = "Newline";
  CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
  CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
  CharCodes[CharCodes["Space"] = 32] = "Space";
  CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
  CharCodes[CharCodes["Hash"] = 35] = "Hash";
  CharCodes[CharCodes["Percent"] = 37] = "Percent";
  CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
  CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
  CharCodes[CharCodes["Plus"] = 43] = "Plus";
  CharCodes[CharCodes["Minus"] = 45] = "Minus";
  CharCodes[CharCodes["Dash"] = 45] = "Dash";
  CharCodes[CharCodes["Period"] = 46] = "Period";
  CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
  CharCodes[CharCodes["Zero"] = 48] = "Zero";
  CharCodes[CharCodes["One"] = 49] = "One";
  CharCodes[CharCodes["Two"] = 50] = "Two";
  CharCodes[CharCodes["Three"] = 51] = "Three";
  CharCodes[CharCodes["Four"] = 52] = "Four";
  CharCodes[CharCodes["Five"] = 53] = "Five";
  CharCodes[CharCodes["Six"] = 54] = "Six";
  CharCodes[CharCodes["Seven"] = 55] = "Seven";
  CharCodes[CharCodes["Eight"] = 56] = "Eight";
  CharCodes[CharCodes["Nine"] = 57] = "Nine";
  CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
  CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
  CharCodes[CharCodes["A"] = 65] = "A";
  CharCodes[CharCodes["D"] = 68] = "D";
  CharCodes[CharCodes["E"] = 69] = "E";
  CharCodes[CharCodes["F"] = 70] = "F";
  CharCodes[CharCodes["O"] = 79] = "O";
  CharCodes[CharCodes["P"] = 80] = "P";
  CharCodes[CharCodes["R"] = 82] = "R";
  CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
  CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
  CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
  CharCodes[CharCodes["a"] = 97] = "a";
  CharCodes[CharCodes["b"] = 98] = "b";
  CharCodes[CharCodes["d"] = 100] = "d";
  CharCodes[CharCodes["e"] = 101] = "e";
  CharCodes[CharCodes["f"] = 102] = "f";
  CharCodes[CharCodes["i"] = 105] = "i";
  CharCodes[CharCodes["j"] = 106] = "j";
  CharCodes[CharCodes["l"] = 108] = "l";
  CharCodes[CharCodes["m"] = 109] = "m";
  CharCodes[CharCodes["n"] = 110] = "n";
  CharCodes[CharCodes["o"] = 111] = "o";
  CharCodes[CharCodes["r"] = 114] = "r";
  CharCodes[CharCodes["s"] = 115] = "s";
  CharCodes[CharCodes["t"] = 116] = "t";
  CharCodes[CharCodes["u"] = 117] = "u";
  CharCodes[CharCodes["x"] = 120] = "x";
  CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
  CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
  CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})(CharCodes || (CharCodes = {}));
var CharCodes$1 = CharCodes;

var PDFHeader = function () {
  function PDFHeader(major, minor) {
    this.major = String(major);
    this.minor = String(minor);
  }
  PDFHeader.prototype.toString = function () {
    var bc = charFromCode(129);
    return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
  };
  PDFHeader.prototype.sizeInBytes = function () {
    return 12 + this.major.length + this.minor.length;
  };
  PDFHeader.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.Percent;
    buffer[offset++] = CharCodes$1.P;
    buffer[offset++] = CharCodes$1.D;
    buffer[offset++] = CharCodes$1.F;
    buffer[offset++] = CharCodes$1.Dash;
    offset += copyStringIntoBuffer(this.major, buffer, offset);
    buffer[offset++] = CharCodes$1.Period;
    offset += copyStringIntoBuffer(this.minor, buffer, offset);
    buffer[offset++] = CharCodes$1.Newline;
    buffer[offset++] = CharCodes$1.Percent;
    buffer[offset++] = 129;
    buffer[offset++] = 129;
    buffer[offset++] = 129;
    buffer[offset++] = 129;
    return offset - initialOffset;
  };
  PDFHeader.forVersion = function (major, minor) {
    return new PDFHeader(major, minor);
  };
  return PDFHeader;
}();

var PDFObject = function () {
  function PDFObject() {}
  PDFObject.prototype.clone = function (_context) {
    throw new MethodNotImplementedError(this.constructor.name, 'clone');
  };
  PDFObject.prototype.toString = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'toString');
  };
  PDFObject.prototype.sizeInBytes = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'sizeInBytes');
  };
  PDFObject.prototype.copyBytesInto = function (_buffer, _offset) {
    throw new MethodNotImplementedError(this.constructor.name, 'copyBytesInto');
  };
  return PDFObject;
}();

var PDFNumber = function (_super) {
  __extends(PDFNumber, _super);
  function PDFNumber(value) {
    var _this = _super.call(this) || this;
    _this.numberValue = value;
    _this.stringValue = numberToString(value);
    return _this;
  }
  PDFNumber.prototype.asNumber = function () {
    return this.numberValue;
  };
  PDFNumber.prototype.value = function () {
    return this.numberValue;
  };
  PDFNumber.prototype.clone = function () {
    return PDFNumber.of(this.numberValue);
  };
  PDFNumber.prototype.toString = function () {
    return this.stringValue;
  };
  PDFNumber.prototype.sizeInBytes = function () {
    return this.stringValue.length;
  };
  PDFNumber.prototype.copyBytesInto = function (buffer, offset) {
    offset += copyStringIntoBuffer(this.stringValue, buffer, offset);
    return this.stringValue.length;
  };
  PDFNumber.of = function (value) {
    return new PDFNumber(value);
  };
  return PDFNumber;
}(PDFObject);

var PDFArray = function (_super) {
  __extends(PDFArray, _super);
  function PDFArray(context) {
    var _this = _super.call(this) || this;
    _this.array = [];
    _this.context = context;
    return _this;
  }
  PDFArray.prototype.size = function () {
    return this.array.length;
  };
  PDFArray.prototype.push = function (object) {
    this.array.push(object);
  };
  PDFArray.prototype.insert = function (index, object) {
    this.array.splice(index, 0, object);
  };
  PDFArray.prototype.indexOf = function (object) {
    var index = this.array.indexOf(object);
    return index === -1 ? undefined : index;
  };
  PDFArray.prototype.remove = function (index) {
    this.array.splice(index, 1);
  };
  PDFArray.prototype.set = function (idx, object) {
    this.array[idx] = object;
  };
  PDFArray.prototype.get = function (index) {
    return this.array[index];
  };
  PDFArray.prototype.lookupMaybe = function (index) {
    var _a;
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    return (_a = this.context).lookupMaybe.apply(_a, __spreadArrays([this.get(index)], types));
  };
  PDFArray.prototype.lookup = function (index) {
    var _a;
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    return (_a = this.context).lookup.apply(_a, __spreadArrays([this.get(index)], types));
  };
  PDFArray.prototype.asRectangle = function () {
    if (this.size() !== 4) throw new PDFArrayIsNotRectangleError(this.size());
    var lowerLeftX = this.lookup(0, PDFNumber).asNumber();
    var lowerLeftY = this.lookup(1, PDFNumber).asNumber();
    var upperRightX = this.lookup(2, PDFNumber).asNumber();
    var upperRightY = this.lookup(3, PDFNumber).asNumber();
    var x = lowerLeftX;
    var y = lowerLeftY;
    var width = upperRightX - lowerLeftX;
    var height = upperRightY - lowerLeftY;
    return {
      x: x,
      y: y,
      width: width,
      height: height
    };
  };
  PDFArray.prototype.asArray = function () {
    return this.array.slice();
  };
  PDFArray.prototype.clone = function (context) {
    var clone = PDFArray.withContext(context || this.context);
    for (var idx = 0, len = this.size(); idx < len; idx++) {
      clone.push(this.array[idx]);
    }
    return clone;
  };
  PDFArray.prototype.toString = function () {
    var arrayString = '[ ';
    for (var idx = 0, len = this.size(); idx < len; idx++) {
      arrayString += this.get(idx).toString();
      arrayString += ' ';
    }
    arrayString += ']';
    return arrayString;
  };
  PDFArray.prototype.sizeInBytes = function () {
    var size = 3;
    for (var idx = 0, len = this.size(); idx < len; idx++) {
      size += this.get(idx).sizeInBytes() + 1;
    }
    return size;
  };
  PDFArray.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.LeftSquareBracket;
    buffer[offset++] = CharCodes$1.Space;
    for (var idx = 0, len = this.size(); idx < len; idx++) {
      offset += this.get(idx).copyBytesInto(buffer, offset);
      buffer[offset++] = CharCodes$1.Space;
    }
    buffer[offset++] = CharCodes$1.RightSquareBracket;
    return offset - initialOffset;
  };
  PDFArray.prototype.scalePDFNumbers = function (x, y) {
    for (var idx = 0, len = this.size(); idx < len; idx++) {
      var el = this.lookup(idx);
      if (el instanceof PDFNumber) {
        var factor = idx % 2 === 0 ? x : y;
        this.set(idx, PDFNumber.of(el.asNumber() * factor));
      }
    }
  };
  PDFArray.withContext = function (context) {
    return new PDFArray(context);
  };
  return PDFArray;
}(PDFObject);

var ENFORCER = {};
var PDFBool = function (_super) {
  __extends(PDFBool, _super);
  function PDFBool(enforcer, value) {
    var _this = this;
    if (enforcer !== ENFORCER) throw new PrivateConstructorError('PDFBool');
    _this = _super.call(this) || this;
    _this.value = value;
    return _this;
  }
  PDFBool.prototype.asBoolean = function () {
    return this.value;
  };
  PDFBool.prototype.clone = function () {
    return this;
  };
  PDFBool.prototype.toString = function () {
    return String(this.value);
  };
  PDFBool.prototype.sizeInBytes = function () {
    return this.value ? 4 : 5;
  };
  PDFBool.prototype.copyBytesInto = function (buffer, offset) {
    if (this.value) {
      buffer[offset++] = CharCodes$1.t;
      buffer[offset++] = CharCodes$1.r;
      buffer[offset++] = CharCodes$1.u;
      buffer[offset++] = CharCodes$1.e;
      return 4;
    } else {
      buffer[offset++] = CharCodes$1.f;
      buffer[offset++] = CharCodes$1.a;
      buffer[offset++] = CharCodes$1.l;
      buffer[offset++] = CharCodes$1.s;
      buffer[offset++] = CharCodes$1.e;
      return 5;
    }
  };
  PDFBool.True = new PDFBool(ENFORCER, true);
  PDFBool.False = new PDFBool(ENFORCER, false);
  return PDFBool;
}(PDFObject);

var IsDelimiter = new Uint8Array(256);
IsDelimiter[CharCodes$1.LeftParen] = 1;
IsDelimiter[CharCodes$1.RightParen] = 1;
IsDelimiter[CharCodes$1.LessThan] = 1;
IsDelimiter[CharCodes$1.GreaterThan] = 1;
IsDelimiter[CharCodes$1.LeftSquareBracket] = 1;
IsDelimiter[CharCodes$1.RightSquareBracket] = 1;
IsDelimiter[CharCodes$1.LeftCurly] = 1;
IsDelimiter[CharCodes$1.RightCurly] = 1;
IsDelimiter[CharCodes$1.ForwardSlash] = 1;
IsDelimiter[CharCodes$1.Percent] = 1;

var IsWhitespace = new Uint8Array(256);
IsWhitespace[CharCodes$1.Null] = 1;
IsWhitespace[CharCodes$1.Tab] = 1;
IsWhitespace[CharCodes$1.Newline] = 1;
IsWhitespace[CharCodes$1.FormFeed] = 1;
IsWhitespace[CharCodes$1.CarriageReturn] = 1;
IsWhitespace[CharCodes$1.Space] = 1;

var IsIrregular = new Uint8Array(256);
for (var idx$1 = 0, len = 256; idx$1 < len; idx$1++) {
  IsIrregular[idx$1] = IsWhitespace[idx$1] || IsDelimiter[idx$1] ? 1 : 0;
}
IsIrregular[CharCodes$1.Hash] = 1;

var decodeName = function (name) {
  return name.replace(/#([\dABCDEF]{2})/g, function (_, hex) {
    return charFromHexCode(hex);
  });
};
var isRegularChar = function (charCode) {
  return charCode >= CharCodes$1.ExclamationPoint && charCode <= CharCodes$1.Tilde && !IsIrregular[charCode];
};
var ENFORCER$1 = {};
var pool = new Map();
var PDFName = function (_super) {
  __extends(PDFName, _super);
  function PDFName(enforcer, name) {
    var _this = this;
    if (enforcer !== ENFORCER$1) throw new PrivateConstructorError('PDFName');
    _this = _super.call(this) || this;
    var encodedName = '/';
    for (var idx = 0, len = name.length; idx < len; idx++) {
      var character = name[idx];
      var code = toCharCode(character);
      encodedName += isRegularChar(code) ? character : "#" + toHexString(code);
    }
    _this.encodedName = encodedName;
    return _this;
  }
  PDFName.prototype.asBytes = function () {
    var bytes = [];
    var hex = '';
    var escaped = false;
    var pushByte = function (byte) {
      if (byte !== undefined) bytes.push(byte);
      escaped = false;
    };
    for (var idx = 1, len = this.encodedName.length; idx < len; idx++) {
      var char = this.encodedName[idx];
      var byte = toCharCode(char);
      var nextChar = this.encodedName[idx + 1];
      if (!escaped) {
        if (byte === CharCodes$1.Hash) escaped = true;else pushByte(byte);
      } else {
        if (byte >= CharCodes$1.Zero && byte <= CharCodes$1.Nine || byte >= CharCodes$1.a && byte <= CharCodes$1.f || byte >= CharCodes$1.A && byte <= CharCodes$1.F) {
          hex += char;
          if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
            pushByte(parseInt(hex, 16));
            hex = '';
          }
        } else {
          pushByte(byte);
        }
      }
    }
    return new Uint8Array(bytes);
  };
  PDFName.prototype.decodeText = function () {
    var bytes = this.asBytes();
    return String.fromCharCode.apply(String, Array.from(bytes));
  };
  PDFName.prototype.asString = function () {
    return this.encodedName;
  };
  PDFName.prototype.value = function () {
    return this.encodedName;
  };
  PDFName.prototype.clone = function () {
    return this;
  };
  PDFName.prototype.toString = function () {
    return this.encodedName;
  };
  PDFName.prototype.sizeInBytes = function () {
    return this.encodedName.length;
  };
  PDFName.prototype.copyBytesInto = function (buffer, offset) {
    offset += copyStringIntoBuffer(this.encodedName, buffer, offset);
    return this.encodedName.length;
  };
  PDFName.of = function (name) {
    var decodedValue = decodeName(name);
    var instance = pool.get(decodedValue);
    if (!instance) {
      instance = new PDFName(ENFORCER$1, decodedValue);
      pool.set(decodedValue, instance);
    }
    return instance;
  };
  PDFName.Length = PDFName.of('Length');
  PDFName.FlateDecode = PDFName.of('FlateDecode');
  PDFName.Resources = PDFName.of('Resources');
  PDFName.Font = PDFName.of('Font');
  PDFName.XObject = PDFName.of('XObject');
  PDFName.ExtGState = PDFName.of('ExtGState');
  PDFName.Contents = PDFName.of('Contents');
  PDFName.Type = PDFName.of('Type');
  PDFName.Parent = PDFName.of('Parent');
  PDFName.MediaBox = PDFName.of('MediaBox');
  PDFName.Page = PDFName.of('Page');
  PDFName.Annots = PDFName.of('Annots');
  PDFName.TrimBox = PDFName.of('TrimBox');
  PDFName.ArtBox = PDFName.of('ArtBox');
  PDFName.BleedBox = PDFName.of('BleedBox');
  PDFName.CropBox = PDFName.of('CropBox');
  PDFName.Rotate = PDFName.of('Rotate');
  PDFName.Title = PDFName.of('Title');
  PDFName.Author = PDFName.of('Author');
  PDFName.Subject = PDFName.of('Subject');
  PDFName.Creator = PDFName.of('Creator');
  PDFName.Keywords = PDFName.of('Keywords');
  PDFName.Producer = PDFName.of('Producer');
  PDFName.CreationDate = PDFName.of('CreationDate');
  PDFName.ModDate = PDFName.of('ModDate');
  return PDFName;
}(PDFObject);

var PDFNull = function (_super) {
  __extends(PDFNull, _super);
  function PDFNull() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFNull.prototype.asNull = function () {
    return null;
  };
  PDFNull.prototype.clone = function () {
    return this;
  };
  PDFNull.prototype.toString = function () {
    return 'null';
  };
  PDFNull.prototype.sizeInBytes = function () {
    return 4;
  };
  PDFNull.prototype.copyBytesInto = function (buffer, offset) {
    buffer[offset++] = CharCodes$1.n;
    buffer[offset++] = CharCodes$1.u;
    buffer[offset++] = CharCodes$1.l;
    buffer[offset++] = CharCodes$1.l;
    return 4;
  };
  return PDFNull;
}(PDFObject);
var PDFNull$1 = new PDFNull();

var PDFDict = function (_super) {
  __extends(PDFDict, _super);
  function PDFDict(map, context) {
    var _this = _super.call(this) || this;
    _this.dict = map;
    _this.context = context;
    return _this;
  }
  PDFDict.prototype.keys = function () {
    return Array.from(this.dict.keys());
  };
  PDFDict.prototype.values = function () {
    return Array.from(this.dict.values());
  };
  PDFDict.prototype.entries = function () {
    return Array.from(this.dict.entries());
  };
  PDFDict.prototype.set = function (key, value) {
    this.dict.set(key, value);
  };
  PDFDict.prototype.get = function (key, preservePDFNull) {
    if (preservePDFNull === void 0) {
      preservePDFNull = false;
    }
    var value = this.dict.get(key);
    if (value === PDFNull$1 && !preservePDFNull) return undefined;
    return value;
  };
  PDFDict.prototype.has = function (key) {
    var value = this.dict.get(key);
    return value !== undefined && value !== PDFNull$1;
  };
  PDFDict.prototype.lookupMaybe = function (key) {
    var _a;
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    var preservePDFNull = types.includes(PDFNull$1);
    var value = (_a = this.context).lookupMaybe.apply(_a, __spreadArrays([this.get(key, preservePDFNull)], types));
    if (value === PDFNull$1 && !preservePDFNull) return undefined;
    return value;
  };
  PDFDict.prototype.lookup = function (key) {
    var _a;
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    var preservePDFNull = types.includes(PDFNull$1);
    var value = (_a = this.context).lookup.apply(_a, __spreadArrays([this.get(key, preservePDFNull)], types));
    if (value === PDFNull$1 && !preservePDFNull) return undefined;
    return value;
  };
  PDFDict.prototype.delete = function (key) {
    return this.dict.delete(key);
  };
  PDFDict.prototype.asMap = function () {
    return new Map(this.dict);
  };
  PDFDict.prototype.uniqueKey = function (tag) {
    if (tag === void 0) {
      tag = '';
    }
    var existingKeys = this.keys();
    var key = PDFName.of(this.context.addRandomSuffix(tag, 10));
    while (existingKeys.includes(key)) {
      key = PDFName.of(this.context.addRandomSuffix(tag, 10));
    }
    return key;
  };
  PDFDict.prototype.clone = function (context) {
    var clone = PDFDict.withContext(context || this.context);
    var entries = this.entries();
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        key = _a[0],
        value = _a[1];
      clone.set(key, value);
    }
    return clone;
  };
  PDFDict.prototype.toString = function () {
    var dictString = '<<\n';
    var entries = this.entries();
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        key = _a[0],
        value = _a[1];
      dictString += key.toString() + ' ' + value.toString() + '\n';
    }
    dictString += '>>';
    return dictString;
  };
  PDFDict.prototype.sizeInBytes = function () {
    var size = 5;
    var entries = this.entries();
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        key = _a[0],
        value = _a[1];
      size += key.sizeInBytes() + value.sizeInBytes() + 2;
    }
    return size;
  };
  PDFDict.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.LessThan;
    buffer[offset++] = CharCodes$1.LessThan;
    buffer[offset++] = CharCodes$1.Newline;
    var entries = this.entries();
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        key = _a[0],
        value = _a[1];
      offset += key.copyBytesInto(buffer, offset);
      buffer[offset++] = CharCodes$1.Space;
      offset += value.copyBytesInto(buffer, offset);
      buffer[offset++] = CharCodes$1.Newline;
    }
    buffer[offset++] = CharCodes$1.GreaterThan;
    buffer[offset++] = CharCodes$1.GreaterThan;
    return offset - initialOffset;
  };
  PDFDict.withContext = function (context) {
    return new PDFDict(new Map(), context);
  };
  PDFDict.fromMapWithContext = function (map, context) {
    return new PDFDict(map, context);
  };
  return PDFDict;
}(PDFObject);

var PDFStream = function (_super) {
  __extends(PDFStream, _super);
  function PDFStream(dict) {
    var _this = _super.call(this) || this;
    _this.dict = dict;
    return _this;
  }
  PDFStream.prototype.clone = function (_context) {
    throw new MethodNotImplementedError(this.constructor.name, 'clone');
  };
  PDFStream.prototype.getContentsString = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'getContentsString');
  };
  PDFStream.prototype.getContents = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'getContents');
  };
  PDFStream.prototype.getContentsSize = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'getContentsSize');
  };
  PDFStream.prototype.updateDict = function () {
    var contentsSize = this.getContentsSize();
    this.dict.set(PDFName.Length, PDFNumber.of(contentsSize));
  };
  PDFStream.prototype.sizeInBytes = function () {
    this.updateDict();
    return this.dict.sizeInBytes() + this.getContentsSize() + 18;
  };
  PDFStream.prototype.toString = function () {
    this.updateDict();
    var streamString = this.dict.toString();
    streamString += '\nstream\n';
    streamString += this.getContentsString();
    streamString += '\nendstream';
    return streamString;
  };
  PDFStream.prototype.copyBytesInto = function (buffer, offset) {
    this.updateDict();
    var initialOffset = offset;
    offset += this.dict.copyBytesInto(buffer, offset);
    buffer[offset++] = CharCodes$1.Newline;
    buffer[offset++] = CharCodes$1.s;
    buffer[offset++] = CharCodes$1.t;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.a;
    buffer[offset++] = CharCodes$1.m;
    buffer[offset++] = CharCodes$1.Newline;
    var contents = this.getContents();
    for (var idx = 0, len = contents.length; idx < len; idx++) {
      buffer[offset++] = contents[idx];
    }
    buffer[offset++] = CharCodes$1.Newline;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.n;
    buffer[offset++] = CharCodes$1.d;
    buffer[offset++] = CharCodes$1.s;
    buffer[offset++] = CharCodes$1.t;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.a;
    buffer[offset++] = CharCodes$1.m;
    return offset - initialOffset;
  };
  return PDFStream;
}(PDFObject);

var PDFRawStream = function (_super) {
  __extends(PDFRawStream, _super);
  function PDFRawStream(dict, contents) {
    var _this = _super.call(this, dict) || this;
    _this.contents = contents;
    return _this;
  }
  PDFRawStream.prototype.asUint8Array = function () {
    return this.contents.slice();
  };
  PDFRawStream.prototype.clone = function (context) {
    return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
  };
  PDFRawStream.prototype.getContentsString = function () {
    return arrayAsString(this.contents);
  };
  PDFRawStream.prototype.getContents = function () {
    return this.contents;
  };
  PDFRawStream.prototype.getContentsSize = function () {
    return this.contents.length;
  };
  PDFRawStream.of = function (dict, contents) {
    return new PDFRawStream(dict, contents);
  };
  return PDFRawStream;
}(PDFStream);

var ENFORCER$2 = {};
var pool$1 = new Map();
var PDFRef = function (_super) {
  __extends(PDFRef, _super);
  function PDFRef(enforcer, objectNumber, generationNumber) {
    var _this = this;
    if (enforcer !== ENFORCER$2) throw new PrivateConstructorError('PDFRef');
    _this = _super.call(this) || this;
    _this.objectNumber = objectNumber;
    _this.generationNumber = generationNumber;
    _this.tag = objectNumber + " " + generationNumber + " R";
    return _this;
  }
  PDFRef.prototype.clone = function () {
    return this;
  };
  PDFRef.prototype.toString = function () {
    return this.tag;
  };
  PDFRef.prototype.sizeInBytes = function () {
    return this.tag.length;
  };
  PDFRef.prototype.copyBytesInto = function (buffer, offset) {
    offset += copyStringIntoBuffer(this.tag, buffer, offset);
    return this.tag.length;
  };
  PDFRef.of = function (objectNumber, generationNumber) {
    if (generationNumber === void 0) {
      generationNumber = 0;
    }
    var tag = objectNumber + " " + generationNumber + " R";
    var instance = pool$1.get(tag);
    if (!instance) {
      instance = new PDFRef(ENFORCER$2, objectNumber, generationNumber);
      pool$1.set(tag, instance);
    }
    return instance;
  };
  return PDFRef;
}(PDFObject);

var PDFOperator = function () {
  function PDFOperator(name, args) {
    this.name = name;
    this.args = args || [];
  }
  PDFOperator.prototype.clone = function (context) {
    var args = new Array(this.args.length);
    for (var idx = 0, len = args.length; idx < len; idx++) {
      var arg = this.args[idx];
      args[idx] = arg instanceof PDFObject ? arg.clone(context) : arg;
    }
    return PDFOperator.of(this.name, args);
  };
  PDFOperator.prototype.toString = function () {
    var value = '';
    for (var idx = 0, len = this.args.length; idx < len; idx++) {
      value += String(this.args[idx]) + ' ';
    }
    value += this.name;
    return value;
  };
  PDFOperator.prototype.sizeInBytes = function () {
    var size = 0;
    for (var idx = 0, len = this.args.length; idx < len; idx++) {
      var arg = this.args[idx];
      size += (arg instanceof PDFObject ? arg.sizeInBytes() : arg.length) + 1;
    }
    size += this.name.length;
    return size;
  };
  PDFOperator.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    for (var idx = 0, len = this.args.length; idx < len; idx++) {
      var arg = this.args[idx];
      if (arg instanceof PDFObject) {
        offset += arg.copyBytesInto(buffer, offset);
      } else {
        offset += copyStringIntoBuffer(arg, buffer, offset);
      }
      buffer[offset++] = CharCodes$1.Space;
    }
    offset += copyStringIntoBuffer(this.name, buffer, offset);
    return offset - initialOffset;
  };
  PDFOperator.of = function (name, args) {
    return new PDFOperator(name, args);
  };
  return PDFOperator;
}();

var PDFOperatorNames;
(function (PDFOperatorNames) {
  PDFOperatorNames["NonStrokingColor"] = "sc";
  PDFOperatorNames["NonStrokingColorN"] = "scn";
  PDFOperatorNames["NonStrokingColorRgb"] = "rg";
  PDFOperatorNames["NonStrokingColorGray"] = "g";
  PDFOperatorNames["NonStrokingColorCmyk"] = "k";
  PDFOperatorNames["NonStrokingColorspace"] = "cs";
  PDFOperatorNames["StrokingColor"] = "SC";
  PDFOperatorNames["StrokingColorN"] = "SCN";
  PDFOperatorNames["StrokingColorRgb"] = "RG";
  PDFOperatorNames["StrokingColorGray"] = "G";
  PDFOperatorNames["StrokingColorCmyk"] = "K";
  PDFOperatorNames["StrokingColorspace"] = "CS";
  PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
  PDFOperatorNames["BeginMarkedContent"] = "BMC";
  PDFOperatorNames["EndMarkedContent"] = "EMC";
  PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
  PDFOperatorNames["MarkedContentPoint"] = "MP";
  PDFOperatorNames["DrawObject"] = "Do";
  PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
  PDFOperatorNames["PopGraphicsState"] = "Q";
  PDFOperatorNames["PushGraphicsState"] = "q";
  PDFOperatorNames["SetFlatness"] = "i";
  PDFOperatorNames["SetGraphicsStateParams"] = "gs";
  PDFOperatorNames["SetLineCapStyle"] = "J";
  PDFOperatorNames["SetLineDashPattern"] = "d";
  PDFOperatorNames["SetLineJoinStyle"] = "j";
  PDFOperatorNames["SetLineMiterLimit"] = "M";
  PDFOperatorNames["SetLineWidth"] = "w";
  PDFOperatorNames["SetTextMatrix"] = "Tm";
  PDFOperatorNames["SetRenderingIntent"] = "ri";
  PDFOperatorNames["AppendRectangle"] = "re";
  PDFOperatorNames["BeginInlineImage"] = "BI";
  PDFOperatorNames["BeginInlineImageData"] = "ID";
  PDFOperatorNames["EndInlineImage"] = "EI";
  PDFOperatorNames["ClipEvenOdd"] = "W*";
  PDFOperatorNames["ClipNonZero"] = "W";
  PDFOperatorNames["CloseAndStroke"] = "s";
  PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
  PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
  PDFOperatorNames["ClosePath"] = "h";
  PDFOperatorNames["AppendBezierCurve"] = "c";
  PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
  PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
  PDFOperatorNames["EndPath"] = "n";
  PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
  PDFOperatorNames["FillEvenOdd"] = "f*";
  PDFOperatorNames["FillNonZeroAndStroke"] = "B";
  PDFOperatorNames["FillNonZero"] = "f";
  PDFOperatorNames["LegacyFillNonZero"] = "F";
  PDFOperatorNames["LineTo"] = "l";
  PDFOperatorNames["MoveTo"] = "m";
  PDFOperatorNames["ShadingFill"] = "sh";
  PDFOperatorNames["StrokePath"] = "S";
  PDFOperatorNames["BeginText"] = "BT";
  PDFOperatorNames["EndText"] = "ET";
  PDFOperatorNames["MoveText"] = "Td";
  PDFOperatorNames["MoveTextSetLeading"] = "TD";
  PDFOperatorNames["NextLine"] = "T*";
  PDFOperatorNames["SetCharacterSpacing"] = "Tc";
  PDFOperatorNames["SetFontAndSize"] = "Tf";
  PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
  PDFOperatorNames["SetTextLineHeight"] = "TL";
  PDFOperatorNames["SetTextRenderingMode"] = "Tr";
  PDFOperatorNames["SetTextRise"] = "Ts";
  PDFOperatorNames["SetWordSpacing"] = "Tw";
  PDFOperatorNames["ShowText"] = "Tj";
  PDFOperatorNames["ShowTextAdjusted"] = "TJ";
  PDFOperatorNames["ShowTextLine"] = "'";
  PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
  PDFOperatorNames["Type3D0"] = "d0";
  PDFOperatorNames["Type3D1"] = "d1";
  PDFOperatorNames["BeginCompatibilitySection"] = "BX";
  PDFOperatorNames["EndCompatibilitySection"] = "EX";
})(PDFOperatorNames || (PDFOperatorNames = {}));
var Ops = PDFOperatorNames;

var PDFFlateStream = function (_super) {
  __extends(PDFFlateStream, _super);
  function PDFFlateStream(dict, encode) {
    var _this = _super.call(this, dict) || this;
    _this.computeContents = function () {
      var unencodedContents = _this.getUnencodedContents();
      return _this.encode ? pako_1.deflate(unencodedContents) : unencodedContents;
    };
    _this.encode = encode;
    if (encode) dict.set(PDFName.of('Filter'), PDFName.of('FlateDecode'));
    _this.contentsCache = Cache.populatedBy(_this.computeContents);
    return _this;
  }
  PDFFlateStream.prototype.getContents = function () {
    return this.contentsCache.access();
  };
  PDFFlateStream.prototype.getContentsSize = function () {
    return this.contentsCache.access().length;
  };
  PDFFlateStream.prototype.getUnencodedContents = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'getUnencodedContents');
  };
  return PDFFlateStream;
}(PDFStream);

var PDFContentStream = function (_super) {
  __extends(PDFContentStream, _super);
  function PDFContentStream(dict, operators, encode) {
    if (encode === void 0) {
      encode = true;
    }
    var _this = _super.call(this, dict, encode) || this;
    _this.operators = operators;
    return _this;
  }
  PDFContentStream.prototype.push = function () {
    var _a;
    var operators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operators[_i] = arguments[_i];
    }
    (_a = this.operators).push.apply(_a, operators);
  };
  PDFContentStream.prototype.clone = function (context) {
    var operators = new Array(this.operators.length);
    for (var idx = 0, len = this.operators.length; idx < len; idx++) {
      operators[idx] = this.operators[idx].clone(context);
    }
    var _a = this,
      dict = _a.dict,
      encode = _a.encode;
    return PDFContentStream.of(dict.clone(context), operators, encode);
  };
  PDFContentStream.prototype.getContentsString = function () {
    var value = '';
    for (var idx = 0, len = this.operators.length; idx < len; idx++) {
      value += this.operators[idx] + "\n";
    }
    return value;
  };
  PDFContentStream.prototype.getUnencodedContents = function () {
    var buffer = new Uint8Array(this.getUnencodedContentsSize());
    var offset = 0;
    for (var idx = 0, len = this.operators.length; idx < len; idx++) {
      offset += this.operators[idx].copyBytesInto(buffer, offset);
      buffer[offset++] = CharCodes$1.Newline;
    }
    return buffer;
  };
  PDFContentStream.prototype.getUnencodedContentsSize = function () {
    var size = 0;
    for (var idx = 0, len = this.operators.length; idx < len; idx++) {
      size += this.operators[idx].sizeInBytes() + 1;
    }
    return size;
  };
  PDFContentStream.of = function (dict, operators, encode) {
    if (encode === void 0) {
      encode = true;
    }
    return new PDFContentStream(dict, operators, encode);
  };
  return PDFContentStream;
}(PDFFlateStream);

var SimpleRNG = function () {
  function SimpleRNG(seed) {
    this.seed = seed;
  }
  SimpleRNG.prototype.nextInt = function () {
    var x = Math.sin(this.seed++) * 10000;
    return x - Math.floor(x);
  };
  SimpleRNG.withSeed = function (seed) {
    return new SimpleRNG(seed);
  };
  return SimpleRNG;
}();

var byAscendingObjectNumber = function (_a, _b) {
  var a = _a[0];
  var b = _b[0];
  return a.objectNumber - b.objectNumber;
};
var PDFContext = function () {
  function PDFContext() {
    this.largestObjectNumber = 0;
    this.header = PDFHeader.forVersion(1, 7);
    this.trailerInfo = {};
    this.indirectObjects = new Map();
    this.rng = SimpleRNG.withSeed(1);
  }
  PDFContext.prototype.assign = function (ref, object) {
    this.indirectObjects.set(ref, object);
    if (ref.objectNumber > this.largestObjectNumber) {
      this.largestObjectNumber = ref.objectNumber;
    }
  };
  PDFContext.prototype.nextRef = function () {
    this.largestObjectNumber += 1;
    return PDFRef.of(this.largestObjectNumber);
  };
  PDFContext.prototype.register = function (object) {
    var ref = this.nextRef();
    this.assign(ref, object);
    return ref;
  };
  PDFContext.prototype.delete = function (ref) {
    return this.indirectObjects.delete(ref);
  };
  PDFContext.prototype.lookupMaybe = function (ref) {
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    var preservePDFNull = types.includes(PDFNull$1);
    var result = ref instanceof PDFRef ? this.indirectObjects.get(ref) : ref;
    if (!result || result === PDFNull$1 && !preservePDFNull) return undefined;
    for (var idx = 0, len = types.length; idx < len; idx++) {
      var type = types[idx];
      if (type === PDFNull$1) {
        if (result === PDFNull$1) return result;
      } else {
        if (result instanceof type) return result;
      }
    }
    throw new UnexpectedObjectTypeError(types, result);
  };
  PDFContext.prototype.lookup = function (ref) {
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      types[_i - 1] = arguments[_i];
    }
    var result = ref instanceof PDFRef ? this.indirectObjects.get(ref) : ref;
    if (types.length === 0) return result;
    for (var idx = 0, len = types.length; idx < len; idx++) {
      var type = types[idx];
      if (type === PDFNull$1) {
        if (result === PDFNull$1) return result;
      } else {
        if (result instanceof type) return result;
      }
    }
    throw new UnexpectedObjectTypeError(types, result);
  };
  PDFContext.prototype.getObjectRef = function (pdfObject) {
    var entries = Array.from(this.indirectObjects.entries());
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        ref = _a[0],
        object = _a[1];
      if (object === pdfObject) {
        return ref;
      }
    }
    return undefined;
  };
  PDFContext.prototype.enumerateIndirectObjects = function () {
    return Array.from(this.indirectObjects.entries()).sort(byAscendingObjectNumber);
  };
  PDFContext.prototype.obj = function (literal) {
    if (literal instanceof PDFObject) {
      return literal;
    } else if (literal === null || literal === undefined) {
      return PDFNull$1;
    } else if (typeof literal === 'string') {
      return PDFName.of(literal);
    } else if (typeof literal === 'number') {
      return PDFNumber.of(literal);
    } else if (typeof literal === 'boolean') {
      return literal ? PDFBool.True : PDFBool.False;
    } else if (Array.isArray(literal)) {
      var array = PDFArray.withContext(this);
      for (var idx = 0, len = literal.length; idx < len; idx++) {
        array.push(this.obj(literal[idx]));
      }
      return array;
    } else {
      var dict = PDFDict.withContext(this);
      var keys = Object.keys(literal);
      for (var idx = 0, len = keys.length; idx < len; idx++) {
        var key = keys[idx];
        var value = literal[key];
        if (value !== undefined) dict.set(PDFName.of(key), this.obj(value));
      }
      return dict;
    }
  };
  PDFContext.prototype.stream = function (contents, dict) {
    if (dict === void 0) {
      dict = {};
    }
    return PDFRawStream.of(this.obj(dict), typedArrayFor(contents));
  };
  PDFContext.prototype.flateStream = function (contents, dict) {
    if (dict === void 0) {
      dict = {};
    }
    return this.stream(pako_1.deflate(typedArrayFor(contents)), __assign(__assign({}, dict), {
      Filter: 'FlateDecode'
    }));
  };
  PDFContext.prototype.contentStream = function (operators, dict) {
    if (dict === void 0) {
      dict = {};
    }
    return PDFContentStream.of(this.obj(dict), operators);
  };
  PDFContext.prototype.formXObject = function (operators, dict) {
    if (dict === void 0) {
      dict = {};
    }
    return this.contentStream(operators, __assign(__assign({
      BBox: this.obj([0, 0, 0, 0]),
      Matrix: this.obj([1, 0, 0, 1, 0, 0])
    }, dict), {
      Type: 'XObject',
      Subtype: 'Form'
    }));
  };
  PDFContext.prototype.getPushGraphicsStateContentStream = function () {
    if (this.pushGraphicsStateContentStreamRef) {
      return this.pushGraphicsStateContentStreamRef;
    }
    var dict = this.obj({});
    var op = PDFOperator.of(Ops.PushGraphicsState);
    var stream = PDFContentStream.of(dict, [op]);
    this.pushGraphicsStateContentStreamRef = this.register(stream);
    return this.pushGraphicsStateContentStreamRef;
  };
  PDFContext.prototype.getPopGraphicsStateContentStream = function () {
    if (this.popGraphicsStateContentStreamRef) {
      return this.popGraphicsStateContentStreamRef;
    }
    var dict = this.obj({});
    var op = PDFOperator.of(Ops.PopGraphicsState);
    var stream = PDFContentStream.of(dict, [op]);
    this.popGraphicsStateContentStreamRef = this.register(stream);
    return this.popGraphicsStateContentStreamRef;
  };
  PDFContext.prototype.addRandomSuffix = function (prefix, suffixLength) {
    if (suffixLength === void 0) {
      suffixLength = 4;
    }
    return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
  };
  PDFContext.create = function () {
    return new PDFContext();
  };
  return PDFContext;
}();

var PDFPageLeaf = function (_super) {
  __extends(PDFPageLeaf, _super);
  function PDFPageLeaf(map, context, autoNormalizeCTM) {
    if (autoNormalizeCTM === void 0) {
      autoNormalizeCTM = true;
    }
    var _this = _super.call(this, map, context) || this;
    _this.normalized = false;
    _this.autoNormalizeCTM = autoNormalizeCTM;
    return _this;
  }
  PDFPageLeaf.prototype.clone = function (context) {
    var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
    var entries = this.entries();
    for (var idx = 0, len = entries.length; idx < len; idx++) {
      var _a = entries[idx],
        key = _a[0],
        value = _a[1];
      clone.set(key, value);
    }
    return clone;
  };
  PDFPageLeaf.prototype.Parent = function () {
    return this.lookupMaybe(PDFName.Parent, PDFDict);
  };
  PDFPageLeaf.prototype.Contents = function () {
    return this.lookup(PDFName.of('Contents'));
  };
  PDFPageLeaf.prototype.Annots = function () {
    return this.lookupMaybe(PDFName.Annots, PDFArray);
  };
  PDFPageLeaf.prototype.BleedBox = function () {
    return this.lookupMaybe(PDFName.BleedBox, PDFArray);
  };
  PDFPageLeaf.prototype.TrimBox = function () {
    return this.lookupMaybe(PDFName.TrimBox, PDFArray);
  };
  PDFPageLeaf.prototype.ArtBox = function () {
    return this.lookupMaybe(PDFName.ArtBox, PDFArray);
  };
  PDFPageLeaf.prototype.Resources = function () {
    var dictOrRef = this.getInheritableAttribute(PDFName.Resources);
    return this.context.lookupMaybe(dictOrRef, PDFDict);
  };
  PDFPageLeaf.prototype.MediaBox = function () {
    var arrayOrRef = this.getInheritableAttribute(PDFName.MediaBox);
    return this.context.lookup(arrayOrRef, PDFArray);
  };
  PDFPageLeaf.prototype.CropBox = function () {
    var arrayOrRef = this.getInheritableAttribute(PDFName.CropBox);
    return this.context.lookupMaybe(arrayOrRef, PDFArray);
  };
  PDFPageLeaf.prototype.Rotate = function () {
    var numberOrRef = this.getInheritableAttribute(PDFName.Rotate);
    return this.context.lookupMaybe(numberOrRef, PDFNumber);
  };
  PDFPageLeaf.prototype.getInheritableAttribute = function (name) {
    var attribute;
    this.ascend(function (node) {
      if (!attribute) attribute = node.get(name);
    });
    return attribute;
  };
  PDFPageLeaf.prototype.setParent = function (parentRef) {
    this.set(PDFName.Parent, parentRef);
  };
  PDFPageLeaf.prototype.addContentStream = function (contentStreamRef) {
    var Contents = this.normalizedEntries().Contents || this.context.obj([]);
    this.set(PDFName.Contents, Contents);
    Contents.push(contentStreamRef);
  };
  PDFPageLeaf.prototype.wrapContentStreams = function (startStream, endStream) {
    var Contents = this.Contents();
    if (Contents instanceof PDFArray) {
      Contents.insert(0, startStream);
      Contents.push(endStream);
      return true;
    }
    return false;
  };
  PDFPageLeaf.prototype.addAnnot = function (annotRef) {
    var Annots = this.normalizedEntries().Annots;
    Annots.push(annotRef);
  };
  PDFPageLeaf.prototype.removeAnnot = function (annotRef) {
    var Annots = this.normalizedEntries().Annots;
    var index = Annots.indexOf(annotRef);
    if (index !== undefined) {
      Annots.remove(index);
    }
  };
  PDFPageLeaf.prototype.setFontDictionary = function (name, fontDictRef) {
    var Font = this.normalizedEntries().Font;
    Font.set(name, fontDictRef);
  };
  PDFPageLeaf.prototype.newFontDictionaryKey = function (tag) {
    var Font = this.normalizedEntries().Font;
    return Font.uniqueKey(tag);
  };
  PDFPageLeaf.prototype.newFontDictionary = function (tag, fontDictRef) {
    var key = this.newFontDictionaryKey(tag);
    this.setFontDictionary(key, fontDictRef);
    return key;
  };
  PDFPageLeaf.prototype.setXObject = function (name, xObjectRef) {
    var XObject = this.normalizedEntries().XObject;
    XObject.set(name, xObjectRef);
  };
  PDFPageLeaf.prototype.newXObjectKey = function (tag) {
    var XObject = this.normalizedEntries().XObject;
    return XObject.uniqueKey(tag);
  };
  PDFPageLeaf.prototype.newXObject = function (tag, xObjectRef) {
    var key = this.newXObjectKey(tag);
    this.setXObject(key, xObjectRef);
    return key;
  };
  PDFPageLeaf.prototype.setExtGState = function (name, extGStateRef) {
    var ExtGState = this.normalizedEntries().ExtGState;
    ExtGState.set(name, extGStateRef);
  };
  PDFPageLeaf.prototype.newExtGStateKey = function (tag) {
    var ExtGState = this.normalizedEntries().ExtGState;
    return ExtGState.uniqueKey(tag);
  };
  PDFPageLeaf.prototype.newExtGState = function (tag, extGStateRef) {
    var key = this.newExtGStateKey(tag);
    this.setExtGState(key, extGStateRef);
    return key;
  };
  PDFPageLeaf.prototype.ascend = function (visitor) {
    visitor(this);
    var Parent = this.Parent();
    if (Parent) Parent.ascend(visitor);
  };
  PDFPageLeaf.prototype.normalize = function () {
    if (this.normalized) return;
    var context = this.context;
    var contentsRef = this.get(PDFName.Contents);
    var contents = this.context.lookup(contentsRef);
    if (contents instanceof PDFStream) {
      this.set(PDFName.Contents, context.obj([contentsRef]));
    }
    if (this.autoNormalizeCTM) {
      this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
    }
    var dictOrRef = this.getInheritableAttribute(PDFName.Resources);
    var Resources = context.lookupMaybe(dictOrRef, PDFDict) || context.obj({});
    this.set(PDFName.Resources, Resources);
    var Font = Resources.lookupMaybe(PDFName.Font, PDFDict) || context.obj({});
    Resources.set(PDFName.Font, Font);
    var XObject = Resources.lookupMaybe(PDFName.XObject, PDFDict) || context.obj({});
    Resources.set(PDFName.XObject, XObject);
    var ExtGState = Resources.lookupMaybe(PDFName.ExtGState, PDFDict) || context.obj({});
    Resources.set(PDFName.ExtGState, ExtGState);
    var Annots = this.Annots() || context.obj([]);
    this.set(PDFName.Annots, Annots);
    this.normalized = true;
  };
  PDFPageLeaf.prototype.normalizedEntries = function () {
    this.normalize();
    var Annots = this.Annots();
    var Resources = this.Resources();
    var Contents = this.Contents();
    return {
      Annots: Annots,
      Resources: Resources,
      Contents: Contents,
      Font: Resources.lookup(PDFName.Font, PDFDict),
      XObject: Resources.lookup(PDFName.XObject, PDFDict),
      ExtGState: Resources.lookup(PDFName.ExtGState, PDFDict)
    };
  };
  PDFPageLeaf.InheritableEntries = ['Resources', 'MediaBox', 'CropBox', 'Rotate'];
  PDFPageLeaf.withContextAndParent = function (context, parent) {
    var dict = new Map();
    dict.set(PDFName.Type, PDFName.Page);
    dict.set(PDFName.Parent, parent);
    dict.set(PDFName.Resources, context.obj({}));
    dict.set(PDFName.MediaBox, context.obj([0, 0, 612, 792]));
    return new PDFPageLeaf(dict, context, false);
  };
  PDFPageLeaf.fromMapWithContext = function (map, context, autoNormalizeCTM) {
    if (autoNormalizeCTM === void 0) {
      autoNormalizeCTM = true;
    }
    return new PDFPageLeaf(map, context, autoNormalizeCTM);
  };
  return PDFPageLeaf;
}(PDFDict);

var PDFObjectCopier = function () {
  function PDFObjectCopier(src, dest) {
    var _this = this;
    this.traversedObjects = new Map();
    this.copy = function (object) {
      return object instanceof PDFPageLeaf ? _this.copyPDFPage(object) : object instanceof PDFDict ? _this.copyPDFDict(object) : object instanceof PDFArray ? _this.copyPDFArray(object) : object instanceof PDFStream ? _this.copyPDFStream(object) : object instanceof PDFRef ? _this.copyPDFIndirectObject(object) : object.clone();
    };
    this.copyPDFPage = function (originalPage) {
      var clonedPage = originalPage.clone();
      var InheritableEntries = PDFPageLeaf.InheritableEntries;
      for (var idx = 0, len = InheritableEntries.length; idx < len; idx++) {
        var key = PDFName.of(InheritableEntries[idx]);
        var value = clonedPage.getInheritableAttribute(key);
        if (!clonedPage.get(key) && value) clonedPage.set(key, value);
      }
      clonedPage.delete(PDFName.of('Parent'));
      return _this.copyPDFDict(clonedPage);
    };
    this.copyPDFDict = function (originalDict) {
      if (_this.traversedObjects.has(originalDict)) {
        return _this.traversedObjects.get(originalDict);
      }
      var clonedDict = originalDict.clone(_this.dest);
      _this.traversedObjects.set(originalDict, clonedDict);
      var entries = originalDict.entries();
      for (var idx = 0, len = entries.length; idx < len; idx++) {
        var _a = entries[idx],
          key = _a[0],
          value = _a[1];
        clonedDict.set(key, _this.copy(value));
      }
      return clonedDict;
    };
    this.copyPDFArray = function (originalArray) {
      if (_this.traversedObjects.has(originalArray)) {
        return _this.traversedObjects.get(originalArray);
      }
      var clonedArray = originalArray.clone(_this.dest);
      _this.traversedObjects.set(originalArray, clonedArray);
      for (var idx = 0, len = originalArray.size(); idx < len; idx++) {
        var value = originalArray.get(idx);
        clonedArray.set(idx, _this.copy(value));
      }
      return clonedArray;
    };
    this.copyPDFStream = function (originalStream) {
      if (_this.traversedObjects.has(originalStream)) {
        return _this.traversedObjects.get(originalStream);
      }
      var clonedStream = originalStream.clone(_this.dest);
      _this.traversedObjects.set(originalStream, clonedStream);
      var entries = originalStream.dict.entries();
      for (var idx = 0, len = entries.length; idx < len; idx++) {
        var _a = entries[idx],
          key = _a[0],
          value = _a[1];
        clonedStream.dict.set(key, _this.copy(value));
      }
      return clonedStream;
    };
    this.copyPDFIndirectObject = function (ref) {
      var alreadyMapped = _this.traversedObjects.has(ref);
      if (!alreadyMapped) {
        var newRef = _this.dest.nextRef();
        _this.traversedObjects.set(ref, newRef);
        var dereferencedValue = _this.src.lookup(ref);
        if (dereferencedValue) {
          var cloned = _this.copy(dereferencedValue);
          _this.dest.assign(newRef, cloned);
        }
      }
      return _this.traversedObjects.get(ref);
    };
    this.src = src;
    this.dest = dest;
  }
  PDFObjectCopier.for = function (src, dest) {
    return new PDFObjectCopier(src, dest);
  };
  return PDFObjectCopier;
}();

var PDFCrossRefSection = function () {
  function PDFCrossRefSection(firstEntry) {
    this.subsections = firstEntry ? [[firstEntry]] : [];
    this.chunkIdx = 0;
    this.chunkLength = firstEntry ? 1 : 0;
  }
  PDFCrossRefSection.prototype.addEntry = function (ref, offset) {
    this.append({
      ref: ref,
      offset: offset,
      deleted: false
    });
  };
  PDFCrossRefSection.prototype.addDeletedEntry = function (ref, nextFreeObjectNumber) {
    this.append({
      ref: ref,
      offset: nextFreeObjectNumber,
      deleted: true
    });
  };
  PDFCrossRefSection.prototype.toString = function () {
    var section = "xref\n";
    for (var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++) {
      var range = this.subsections[rangeIdx];
      section += range[0].ref.objectNumber + " " + range.length + "\n";
      for (var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++) {
        var entry = range[entryIdx];
        section += padStart(String(entry.offset), 10, '0');
        section += ' ';
        section += padStart(String(entry.ref.generationNumber), 5, '0');
        section += ' ';
        section += entry.deleted ? 'f' : 'n';
        section += ' \n';
      }
    }
    return section;
  };
  PDFCrossRefSection.prototype.sizeInBytes = function () {
    var size = 5;
    for (var idx = 0, len = this.subsections.length; idx < len; idx++) {
      var subsection = this.subsections[idx];
      var subsectionLength = subsection.length;
      var firstEntry = subsection[0];
      size += 2;
      size += String(firstEntry.ref.objectNumber).length;
      size += String(subsectionLength).length;
      size += 20 * subsectionLength;
    }
    return size;
  };
  PDFCrossRefSection.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.x;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.f;
    buffer[offset++] = CharCodes$1.Newline;
    offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
    return offset - initialOffset;
  };
  PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function (subsections, buffer, offset) {
    var initialOffset = offset;
    var length = subsections.length;
    for (var idx = 0; idx < length; idx++) {
      var subsection = this.subsections[idx];
      var firstObjectNumber = String(subsection[0].ref.objectNumber);
      offset += copyStringIntoBuffer(firstObjectNumber, buffer, offset);
      buffer[offset++] = CharCodes$1.Space;
      var rangeLength = String(subsection.length);
      offset += copyStringIntoBuffer(rangeLength, buffer, offset);
      buffer[offset++] = CharCodes$1.Newline;
      offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
    }
    return offset - initialOffset;
  };
  PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function (entries, buffer, offset) {
    var length = entries.length;
    for (var idx = 0; idx < length; idx++) {
      var entry = entries[idx];
      var entryOffset = padStart(String(entry.offset), 10, '0');
      offset += copyStringIntoBuffer(entryOffset, buffer, offset);
      buffer[offset++] = CharCodes$1.Space;
      var entryGen = padStart(String(entry.ref.generationNumber), 5, '0');
      offset += copyStringIntoBuffer(entryGen, buffer, offset);
      buffer[offset++] = CharCodes$1.Space;
      buffer[offset++] = entry.deleted ? CharCodes$1.f : CharCodes$1.n;
      buffer[offset++] = CharCodes$1.Space;
      buffer[offset++] = CharCodes$1.Newline;
    }
    return 20 * length;
  };
  PDFCrossRefSection.prototype.append = function (currEntry) {
    if (this.chunkLength === 0) {
      this.subsections.push([currEntry]);
      this.chunkIdx = 0;
      this.chunkLength = 1;
      return;
    }
    var chunk = this.subsections[this.chunkIdx];
    var prevEntry = chunk[this.chunkLength - 1];
    if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
      this.subsections.push([currEntry]);
      this.chunkIdx += 1;
      this.chunkLength = 1;
    } else {
      chunk.push(currEntry);
      this.chunkLength += 1;
    }
  };
  PDFCrossRefSection.create = function () {
    return new PDFCrossRefSection({
      ref: PDFRef.of(0, 65535),
      offset: 0,
      deleted: true
    });
  };
  PDFCrossRefSection.createEmpty = function () {
    return new PDFCrossRefSection();
  };
  return PDFCrossRefSection;
}();

var PDFTrailer = function () {
  function PDFTrailer(lastXRefOffset) {
    this.lastXRefOffset = String(lastXRefOffset);
  }
  PDFTrailer.prototype.toString = function () {
    return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
  };
  PDFTrailer.prototype.sizeInBytes = function () {
    return 16 + this.lastXRefOffset.length;
  };
  PDFTrailer.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.s;
    buffer[offset++] = CharCodes$1.t;
    buffer[offset++] = CharCodes$1.a;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.t;
    buffer[offset++] = CharCodes$1.x;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.f;
    buffer[offset++] = CharCodes$1.Newline;
    offset += copyStringIntoBuffer(this.lastXRefOffset, buffer, offset);
    buffer[offset++] = CharCodes$1.Newline;
    buffer[offset++] = CharCodes$1.Percent;
    buffer[offset++] = CharCodes$1.Percent;
    buffer[offset++] = CharCodes$1.E;
    buffer[offset++] = CharCodes$1.O;
    buffer[offset++] = CharCodes$1.F;
    return offset - initialOffset;
  };
  PDFTrailer.forLastCrossRefSectionOffset = function (offset) {
    return new PDFTrailer(offset);
  };
  return PDFTrailer;
}();

var PDFTrailerDict = function () {
  function PDFTrailerDict(dict) {
    this.dict = dict;
  }
  PDFTrailerDict.prototype.toString = function () {
    return "trailer\n" + this.dict.toString();
  };
  PDFTrailerDict.prototype.sizeInBytes = function () {
    return 8 + this.dict.sizeInBytes();
  };
  PDFTrailerDict.prototype.copyBytesInto = function (buffer, offset) {
    var initialOffset = offset;
    buffer[offset++] = CharCodes$1.t;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.a;
    buffer[offset++] = CharCodes$1.i;
    buffer[offset++] = CharCodes$1.l;
    buffer[offset++] = CharCodes$1.e;
    buffer[offset++] = CharCodes$1.r;
    buffer[offset++] = CharCodes$1.Newline;
    offset += this.dict.copyBytesInto(buffer, offset);
    return offset - initialOffset;
  };
  PDFTrailerDict.of = function (dict) {
    return new PDFTrailerDict(dict);
  };
  return PDFTrailerDict;
}();

var PDFObjectStream = function (_super) {
  __extends(PDFObjectStream, _super);
  function PDFObjectStream(context, objects, encode) {
    if (encode === void 0) {
      encode = true;
    }
    var _this = _super.call(this, context.obj({}), encode) || this;
    _this.objects = objects;
    _this.offsets = _this.computeObjectOffsets();
    _this.offsetsString = _this.computeOffsetsString();
    _this.dict.set(PDFName.of('Type'), PDFName.of('ObjStm'));
    _this.dict.set(PDFName.of('N'), PDFNumber.of(_this.objects.length));
    _this.dict.set(PDFName.of('First'), PDFNumber.of(_this.offsetsString.length));
    return _this;
  }
  PDFObjectStream.prototype.getObjectsCount = function () {
    return this.objects.length;
  };
  PDFObjectStream.prototype.clone = function (context) {
    return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
  };
  PDFObjectStream.prototype.getContentsString = function () {
    var value = this.offsetsString;
    for (var idx = 0, len = this.objects.length; idx < len; idx++) {
      var _a = this.objects[idx],
        object = _a[1];
      value += object + "\n";
    }
    return value;
  };
  PDFObjectStream.prototype.getUnencodedContents = function () {
    var buffer = new Uint8Array(this.getUnencodedContentsSize());
    var offset = copyStringIntoBuffer(this.offsetsString, buffer, 0);
    for (var idx = 0, len = this.objects.length; idx < len; idx++) {
      var _a = this.objects[idx],
        object = _a[1];
      offset += object.copyBytesInto(buffer, offset);
      buffer[offset++] = CharCodes$1.Newline;
    }
    return buffer;
  };
  PDFObjectStream.prototype.getUnencodedContentsSize = function () {
    return this.offsetsString.length + last(this.offsets)[1] + last(this.objects)[1].sizeInBytes() + 1;
  };
  PDFObjectStream.prototype.computeOffsetsString = function () {
    var offsetsString = '';
    for (var idx = 0, len = this.offsets.length; idx < len; idx++) {
      var _a = this.offsets[idx],
        objectNumber = _a[0],
        offset = _a[1];
      offsetsString += objectNumber + " " + offset + " ";
    }
    return offsetsString;
  };
  PDFObjectStream.prototype.computeObjectOffsets = function () {
    var offset = 0;
    var offsets = new Array(this.objects.length);
    for (var idx = 0, len = this.objects.length; idx < len; idx++) {
      var _a = this.objects[idx],
        ref = _a[0],
        object = _a[1];
      offsets[idx] = [ref.objectNumber, offset];
      offset += object.sizeInBytes() + 1;
    }
    return offsets;
  };
  PDFObjectStream.withContextAndObjects = function (context, objects, encode) {
    if (encode === void 0) {
      encode = true;
    }
    return new PDFObjectStream(context, objects, encode);
  };
  return PDFObjectStream;
}(PDFFlateStream);

var PDFWriter = function () {
  function PDFWriter(context, objectsPerTick) {
    var _this = this;
    this.parsedObjects = 0;
    this.shouldWaitForTick = function (n) {
      _this.parsedObjects += n;
      return _this.parsedObjects % _this.objectsPerTick === 0;
    };
    this.context = context;
    this.objectsPerTick = objectsPerTick;
  }
  PDFWriter.prototype.serializeToBuffer = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.computeBufferSize()];
          case 1:
            _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
            offset = 0;
            buffer = new Uint8Array(size);
            offset += header.copyBytesInto(buffer, offset);
            buffer[offset++] = CharCodes$1.Newline;
            buffer[offset++] = CharCodes$1.Newline;
            idx = 0, len = indirectObjects.length;
            _c.label = 2;
          case 2:
            if (!(idx < len)) return [3, 5];
            _b = indirectObjects[idx], ref = _b[0], object = _b[1];
            objectNumber = String(ref.objectNumber);
            offset += copyStringIntoBuffer(objectNumber, buffer, offset);
            buffer[offset++] = CharCodes$1.Space;
            generationNumber = String(ref.generationNumber);
            offset += copyStringIntoBuffer(generationNumber, buffer, offset);
            buffer[offset++] = CharCodes$1.Space;
            buffer[offset++] = CharCodes$1.o;
            buffer[offset++] = CharCodes$1.b;
            buffer[offset++] = CharCodes$1.j;
            buffer[offset++] = CharCodes$1.Newline;
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = CharCodes$1.Newline;
            buffer[offset++] = CharCodes$1.e;
            buffer[offset++] = CharCodes$1.n;
            buffer[offset++] = CharCodes$1.d;
            buffer[offset++] = CharCodes$1.o;
            buffer[offset++] = CharCodes$1.b;
            buffer[offset++] = CharCodes$1.j;
            buffer[offset++] = CharCodes$1.Newline;
            buffer[offset++] = CharCodes$1.Newline;
            n = object instanceof PDFObjectStream ? object.getObjectsCount() : 1;
            if (!this.shouldWaitForTick(n)) return [3, 4];
            return [4, waitForTick()];
          case 3:
            _c.sent();
            _c.label = 4;
          case 4:
            idx++;
            return [3, 2];
          case 5:
            if (xref) {
              offset += xref.copyBytesInto(buffer, offset);
              buffer[offset++] = CharCodes$1.Newline;
            }
            if (trailerDict) {
              offset += trailerDict.copyBytesInto(buffer, offset);
              buffer[offset++] = CharCodes$1.Newline;
              buffer[offset++] = CharCodes$1.Newline;
            }
            offset += trailer.copyBytesInto(buffer, offset);
            return [2, buffer];
        }
      });
    });
  };
  PDFWriter.prototype.computeIndirectObjectSize = function (_a) {
    var ref = _a[0],
      object = _a[1];
    var refSize = ref.sizeInBytes() + 3;
    var objectSize = object.sizeInBytes() + 9;
    return refSize + objectSize;
  };
  PDFWriter.prototype.createTrailerDict = function () {
    return this.context.obj({
      Size: this.context.largestObjectNumber + 1,
      Root: this.context.trailerInfo.Root,
      Encrypt: this.context.trailerInfo.Encrypt,
      Info: this.context.trailerInfo.Info,
      ID: this.context.trailerInfo.ID
    });
  };
  PDFWriter.prototype.computeBufferSize = function () {
    return __awaiter(this, void 0, void 0, function () {
      var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            header = PDFHeader.forVersion(1, 7);
            size = header.sizeInBytes() + 2;
            xref = PDFCrossRefSection.create();
            indirectObjects = this.context.enumerateIndirectObjects();
            idx = 0, len = indirectObjects.length;
            _a.label = 1;
          case 1:
            if (!(idx < len)) return [3, 4];
            indirectObject = indirectObjects[idx];
            ref = indirectObject[0];
            xref.addEntry(ref, size);
            size += this.computeIndirectObjectSize(indirectObject);
            if (!this.shouldWaitForTick(1)) return [3, 3];
            return [4, waitForTick()];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            idx++;
            return [3, 1];
          case 4:
            xrefOffset = size;
            size += xref.sizeInBytes() + 1;
            trailerDict = PDFTrailerDict.of(this.createTrailerDict());
            size += trailerDict.sizeInBytes() + 2;
            trailer = PDFTrailer.forLastCrossRefSectionOffset(xrefOffset);
            size += trailer.sizeInBytes();
            return [2, {
              size: size,
              header: header,
              indirectObjects: indirectObjects,
              xref: xref,
              trailerDict: trailerDict,
              trailer: trailer
            }];
        }
      });
    });
  };
  PDFWriter.forContext = function (context, objectsPerTick) {
    return new PDFWriter(context, objectsPerTick);
  };
  return PDFWriter;
}();

var PDFInvalidObject = function (_super) {
  __extends(PDFInvalidObject, _super);
  function PDFInvalidObject(data) {
    var _this = _super.call(this) || this;
    _this.data = data;
    return _this;
  }
  PDFInvalidObject.prototype.clone = function () {
    return PDFInvalidObject.of(this.data.slice());
  };
  PDFInvalidObject.prototype.toString = function () {
    return "PDFInvalidObject(" + this.data.length + " bytes)";
  };
  PDFInvalidObject.prototype.sizeInBytes = function () {
    return this.data.length;
  };
  PDFInvalidObject.prototype.copyBytesInto = function (buffer, offset) {
    var length = this.data.length;
    for (var idx = 0; idx < length; idx++) {
      buffer[offset++] = this.data[idx];
    }
    return length;
  };
  PDFInvalidObject.of = function (data) {
    return new PDFInvalidObject(data);
  };
  return PDFInvalidObject;
}(PDFObject);

var EntryType;
(function (EntryType) {
  EntryType[EntryType["Deleted"] = 0] = "Deleted";
  EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
  EntryType[EntryType["Compressed"] = 2] = "Compressed";
})(EntryType || (EntryType = {}));
var PDFCrossRefStream = function (_super) {
  __extends(PDFCrossRefStream, _super);
  function PDFCrossRefStream(dict, entries, encode) {
    if (encode === void 0) {
      encode = true;
    }
    var _this = _super.call(this, dict, encode) || this;
    _this.computeIndex = function () {
      var subsections = [];
      var subsectionLength = 0;
      for (var idx = 0, len = _this.entries.length; idx < len; idx++) {
        var currEntry = _this.entries[idx];
        var prevEntry = _this.entries[idx - 1];
        if (idx === 0) {
          subsections.push(currEntry.ref.objectNumber);
        } else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
          subsections.push(subsectionLength);
          subsections.push(currEntry.ref.objectNumber);
          subsectionLength = 0;
        }
        subsectionLength += 1;
      }
      subsections.push(subsectionLength);
      return subsections;
    };
    _this.computeEntryTuples = function () {
      var entryTuples = new Array(_this.entries.length);
      for (var idx = 0, len = _this.entries.length; idx < len; idx++) {
        var entry = _this.entries[idx];
        if (entry.type === EntryType.Deleted) {
          var type = entry.type,
            nextFreeObjectNumber = entry.nextFreeObjectNumber,
            ref = entry.ref;
          entryTuples[idx] = [type, nextFreeObjectNumber, ref.generationNumber];
        }
        if (entry.type === EntryType.Uncompressed) {
          var type = entry.type,
            offset = entry.offset,
            ref = entry.ref;
          entryTuples[idx] = [type, offset, ref.generationNumber];
        }
        if (entry.type === EntryType.Compressed) {
          var type = entry.type,
            objectStreamRef = entry.objectStreamRef,
            index = entry.index;
          entryTuples[idx] = [type, objectStreamRef.objectNumber, index];
        }
      }
      return entryTuples;
    };
    _this.computeMaxEntryByteWidths = function () {
      var entryTuples = _this.entryTuplesCache.access();
      var widths = [0, 0, 0];
      for (var idx = 0, len = entryTuples.length; idx < len; idx++) {
        var _a = entryTuples[idx],
          first = _a[0],
          second = _a[1],
          third = _a[2];
        var firstSize = sizeInBytes(first);
        var secondSize = sizeInBytes(second);
        var thirdSize = sizeInBytes(third);
        if (firstSize > widths[0]) widths[0] = firstSize;
        if (secondSize > widths[1]) widths[1] = secondSize;
        if (thirdSize > widths[2]) widths[2] = thirdSize;
      }
      return widths;
    };
    _this.entries = entries || [];
    _this.entryTuplesCache = Cache.populatedBy(_this.computeEntryTuples);
    _this.maxByteWidthsCache = Cache.populatedBy(_this.computeMaxEntryByteWidths);
    _this.indexCache = Cache.populatedBy(_this.computeIndex);
    dict.set(PDFName.of('Type'), PDFName.of('XRef'));
    return _this;
  }
  PDFCrossRefStream.prototype.addDeletedEntry = function (ref, nextFreeObjectNumber) {
    var type = EntryType.Deleted;
    this.entries.push({
      type: type,
      ref: ref,
      nextFreeObjectNumber: nextFreeObjectNumber
    });
    this.entryTuplesCache.invalidate();
    this.maxByteWidthsCache.invalidate();
    this.indexCache.invalidate();
    this.contentsCache.invalidate();
  };
  PDFCrossRefStream.prototype.addUncompressedEntry = function (ref, offset) {
    var type = EntryType.Uncompressed;
    this.entries.push({
      type: type,
      ref: ref,
      offset: offset
    });
    this.entryTuplesCache.invalidate();
    this.maxByteWidthsCache.invalidate();
    this.indexCache.invalidate();
    this.contentsCache.invalidate();
  };
  PDFCrossRefStream.prototype.addCompressedEntry = function (ref, objectStreamRef, index) {
    var type = EntryType.Compressed;
    this.entries.push({
      type: type,
      ref: ref,
      objectStreamRef: objectStreamRef,
      index: index
    });
    this.entryTuplesCache.invalidate();
    this.maxByteWidthsCache.invalidate();
    this.indexCache.invalidate();
    this.contentsCache.invalidate();
  };
  PDFCrossRefStream.prototype.clone = function (context) {
    var _a = this,
      dict = _a.dict,
      entries = _a.entries,
      encode = _a.encode;
    return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
  };
  PDFCrossRefStream.prototype.getContentsString = function () {
    var entryTuples = this.entryTuplesCache.access();
    var byteWidths = this.maxByteWidthsCache.access();
    var value = '';
    for (var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++) {
      var _a = entryTuples[entryIdx],
        first = _a[0],
        second = _a[1],
        third = _a[2];
      var firstBytes = reverseArray(bytesFor(first));
      var secondBytes = reverseArray(bytesFor(second));
      var thirdBytes = reverseArray(bytesFor(third));
      for (var idx = byteWidths[0] - 1; idx >= 0; idx--) {
        value += (firstBytes[idx] || 0).toString(2);
      }
      for (var idx = byteWidths[1] - 1; idx >= 0; idx--) {
        value += (secondBytes[idx] || 0).toString(2);
      }
      for (var idx = byteWidths[2] - 1; idx >= 0; idx--) {
        value += (thirdBytes[idx] || 0).toString(2);
      }
    }
    return value;
  };
  PDFCrossRefStream.prototype.getUnencodedContents = function () {
    var entryTuples = this.entryTuplesCache.access();
    var byteWidths = this.maxByteWidthsCache.access();
    var buffer = new Uint8Array(this.getUnencodedContentsSize());
    var offset = 0;
    for (var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++) {
      var _a = entryTuples[entryIdx],
        first = _a[0],
        second = _a[1],
        third = _a[2];
      var firstBytes = reverseArray(bytesFor(first));
      var secondBytes = reverseArray(bytesFor(second));
      var thirdBytes = reverseArray(bytesFor(third));
      for (var idx = byteWidths[0] - 1; idx >= 0; idx--) {
        buffer[offset++] = firstBytes[idx] || 0;
      }
      for (var idx = byteWidths[1] - 1; idx >= 0; idx--) {
        buffer[offset++] = secondBytes[idx] || 0;
      }
      for (var idx = byteWidths[2] - 1; idx >= 0; idx--) {
        buffer[offset++] = thirdBytes[idx] || 0;
      }
    }
    return buffer;
  };
  PDFCrossRefStream.prototype.getUnencodedContentsSize = function () {
    var byteWidths = this.maxByteWidthsCache.access();
    var entryWidth = sum(byteWidths);
    return entryWidth * this.entries.length;
  };
  PDFCrossRefStream.prototype.updateDict = function () {
    _super.prototype.updateDict.call(this);
    var byteWidths = this.maxByteWidthsCache.access();
    var index = this.indexCache.access();
    var context = this.dict.context;
    this.dict.set(PDFName.of('W'), context.obj(byteWidths));
    this.dict.set(PDFName.of('Index'), context.obj(index));
  };
  PDFCrossRefStream.create = function (dict, encode) {
    if (encode === void 0) {
      encode = true;
    }
    var stream = new PDFCrossRefStream(dict, [], encode);
    stream.addDeletedEntry(PDFRef.of(0, 65535), 0);
    return stream;
  };
  PDFCrossRefStream.of = function (dict, entries, encode) {
    if (encode === void 0) {
      encode = true;
    }
    return new PDFCrossRefStream(dict, entries, encode);
  };
  return PDFCrossRefStream;
}(PDFFlateStream);

var PDFStreamWriter = function (_super) {
  __extends(PDFStreamWriter, _super);
  function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
    var _this = _super.call(this, context, objectsPerTick) || this;
    _this.encodeStreams = encodeStreams;
    _this.objectsPerStream = objectsPerStream;
    return _this;
  }
  PDFStreamWriter.prototype.computeBufferSize = function () {
    return __awaiter(this, void 0, void 0, function () {
      var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            objectNumber = this.context.largestObjectNumber + 1;
            header = PDFHeader.forVersion(1, 7);
            size = header.sizeInBytes() + 2;
            xrefStream = PDFCrossRefStream.create(this.createTrailerDict(), this.encodeStreams);
            uncompressedObjects = [];
            compressedObjects = [];
            objectStreamRefs = [];
            indirectObjects = this.context.enumerateIndirectObjects();
            idx = 0, len = indirectObjects.length;
            _a.label = 1;
          case 1:
            if (!(idx < len)) return [3, 6];
            indirectObject = indirectObjects[idx];
            ref = indirectObject[0], object = indirectObject[1];
            shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof PDFStream || object instanceof PDFInvalidObject || ref.generationNumber !== 0;
            if (!shouldNotCompress) return [3, 4];
            uncompressedObjects.push(indirectObject);
            xrefStream.addUncompressedEntry(ref, size);
            size += this.computeIndirectObjectSize(indirectObject);
            if (!this.shouldWaitForTick(1)) return [3, 3];
            return [4, waitForTick()];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            return [3, 5];
          case 4:
            chunk = last(compressedObjects);
            objectStreamRef = last(objectStreamRefs);
            if (!chunk || chunk.length % this.objectsPerStream === 0) {
              chunk = [];
              compressedObjects.push(chunk);
              objectStreamRef = PDFRef.of(objectNumber++);
              objectStreamRefs.push(objectStreamRef);
            }
            xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
            chunk.push(indirectObject);
            _a.label = 5;
          case 5:
            idx++;
            return [3, 1];
          case 6:
            idx = 0, len = compressedObjects.length;
            _a.label = 7;
          case 7:
            if (!(idx < len)) return [3, 10];
            chunk = compressedObjects[idx];
            ref = objectStreamRefs[idx];
            objectStream = PDFObjectStream.withContextAndObjects(this.context, chunk, this.encodeStreams);
            xrefStream.addUncompressedEntry(ref, size);
            size += this.computeIndirectObjectSize([ref, objectStream]);
            uncompressedObjects.push([ref, objectStream]);
            if (!this.shouldWaitForTick(chunk.length)) return [3, 9];
            return [4, waitForTick()];
          case 8:
            _a.sent();
            _a.label = 9;
          case 9:
            idx++;
            return [3, 7];
          case 10:
            xrefStreamRef = PDFRef.of(objectNumber++);
            xrefStream.dict.set(PDFName.of('Size'), PDFNumber.of(objectNumber));
            xrefStream.addUncompressedEntry(xrefStreamRef, size);
            xrefOffset = size;
            size += this.computeIndirectObjectSize([xrefStreamRef, xrefStream]);
            uncompressedObjects.push([xrefStreamRef, xrefStream]);
            trailer = PDFTrailer.forLastCrossRefSectionOffset(xrefOffset);
            size += trailer.sizeInBytes();
            return [2, {
              size: size,
              header: header,
              indirectObjects: uncompressedObjects,
              trailer: trailer
            }];
        }
      });
    });
  };
  PDFStreamWriter.forContext = function (context, objectsPerTick, encodeStreams, objectsPerStream) {
    if (encodeStreams === void 0) {
      encodeStreams = true;
    }
    if (objectsPerStream === void 0) {
      objectsPerStream = 50;
    }
    return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
  };
  return PDFStreamWriter;
}(PDFWriter);

var PDFHexString = function (_super) {
  __extends(PDFHexString, _super);
  function PDFHexString(value) {
    var _this = _super.call(this) || this;
    _this.value = value;
    return _this;
  }
  PDFHexString.prototype.asBytes = function () {
    var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
    var hexLength = hex.length;
    var bytes = new Uint8Array(hex.length / 2);
    var hexOffset = 0;
    var bytesOffset = 0;
    while (hexOffset < hexLength) {
      var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
      bytes[bytesOffset] = byte;
      hexOffset += 2;
      bytesOffset += 1;
    }
    return bytes;
  };
  PDFHexString.prototype.decodeText = function () {
    var bytes = this.asBytes();
    if (hasUtf16BOM(bytes)) return utf16Decode(bytes);
    return pdfDocEncodingDecode(bytes);
  };
  PDFHexString.prototype.decodeDate = function () {
    var text = this.decodeText();
    var date = parseDate(text);
    if (!date) throw new InvalidPDFDateStringError(text);
    return date;
  };
  PDFHexString.prototype.asString = function () {
    return this.value;
  };
  PDFHexString.prototype.clone = function () {
    return PDFHexString.of(this.value);
  };
  PDFHexString.prototype.toString = function () {
    return "<" + this.value + ">";
  };
  PDFHexString.prototype.sizeInBytes = function () {
    return this.value.length + 2;
  };
  PDFHexString.prototype.copyBytesInto = function (buffer, offset) {
    buffer[offset++] = CharCodes$1.LessThan;
    offset += copyStringIntoBuffer(this.value, buffer, offset);
    buffer[offset++] = CharCodes$1.GreaterThan;
    return this.value.length + 2;
  };
  PDFHexString.of = function (value) {
    return new PDFHexString(value);
  };
  PDFHexString.fromText = function (value) {
    var encoded = utf16Encode(value);
    var hex = '';
    for (var idx = 0, len = encoded.length; idx < len; idx++) {
      hex += toHexStringOfMinLength(encoded[idx], 4);
    }
    return new PDFHexString(hex);
  };
  return PDFHexString;
}(PDFObject);

var StandardFontEmbedder = function () {
  function StandardFontEmbedder(fontName, customName) {
    this.encoding = fontName === FontNames.ZapfDingbats ? Encodings.ZapfDingbats : fontName === FontNames.Symbol ? Encodings.Symbol : Encodings.WinAnsi;
    this.font = Font.load(fontName);
    this.fontName = this.font.FontName;
    this.customName = customName;
  }
  StandardFontEmbedder.prototype.encodeText = function (text) {
    var glyphs = this.encodeTextAsGlyphs(text);
    var hexCodes = new Array(glyphs.length);
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      hexCodes[idx] = toHexString(glyphs[idx].code);
    }
    return PDFHexString.of(hexCodes.join(''));
  };
  StandardFontEmbedder.prototype.widthOfTextAtSize = function (text, size) {
    var glyphs = this.encodeTextAsGlyphs(text);
    var totalWidth = 0;
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      var left = glyphs[idx].name;
      var right = (glyphs[idx + 1] || {}).name;
      var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
      totalWidth += this.widthOfGlyph(left) + kernAmount;
    }
    var scale = size / 1000;
    return totalWidth * scale;
  };
  StandardFontEmbedder.prototype.heightOfFontAtSize = function (size, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.descender,
      descender = _a === void 0 ? true : _a;
    var _b = this.font,
      Ascender = _b.Ascender,
      Descender = _b.Descender,
      FontBBox = _b.FontBBox;
    var yTop = Ascender || FontBBox[3];
    var yBottom = Descender || FontBBox[1];
    var height = yTop - yBottom;
    if (!descender) height += Descender || 0;
    return height / 1000 * size;
  };
  StandardFontEmbedder.prototype.sizeOfFontAtHeight = function (height) {
    var _a = this.font,
      Ascender = _a.Ascender,
      Descender = _a.Descender,
      FontBBox = _a.FontBBox;
    var yTop = Ascender || FontBBox[3];
    var yBottom = Descender || FontBBox[1];
    return 1000 * height / (yTop - yBottom);
  };
  StandardFontEmbedder.prototype.embedIntoContext = function (context, ref) {
    var fontDict = context.obj({
      Type: 'Font',
      Subtype: 'Type1',
      BaseFont: this.customName || this.fontName,
      Encoding: this.encoding === Encodings.WinAnsi ? 'WinAnsiEncoding' : undefined
    });
    if (ref) {
      context.assign(ref, fontDict);
      return ref;
    } else {
      return context.register(fontDict);
    }
  };
  StandardFontEmbedder.prototype.widthOfGlyph = function (glyphName) {
    return this.font.getWidthOfGlyph(glyphName) || 250;
  };
  StandardFontEmbedder.prototype.encodeTextAsGlyphs = function (text) {
    var codePoints = Array.from(text);
    var glyphs = new Array(codePoints.length);
    for (var idx = 0, len = codePoints.length; idx < len; idx++) {
      var codePoint = toCodePoint(codePoints[idx]);
      glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
    }
    return glyphs;
  };
  StandardFontEmbedder.for = function (fontName, customName) {
    return new StandardFontEmbedder(fontName, customName);
  };
  return StandardFontEmbedder;
}();

var createCmap = function (glyphs, glyphId) {
  var bfChars = new Array(glyphs.length);
  for (var idx = 0, len = glyphs.length; idx < len; idx++) {
    var glyph = glyphs[idx];
    var id = cmapHexFormat(cmapHexString(glyphId(glyph)));
    var unicode = cmapHexFormat.apply(void 0, glyph.codePoints.map(cmapCodePointFormat));
    bfChars[idx] = [id, unicode];
  }
  return fillCmapTemplate(bfChars);
};
var fillCmapTemplate = function (bfChars) {
  return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function (_a) {
    var glyphId = _a[0],
      codePoint = _a[1];
    return glyphId + " " + codePoint;
  }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
var cmapHexFormat = function () {
  var values = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    values[_i] = arguments[_i];
  }
  return "<" + values.join('') + ">";
};
var cmapHexString = function (value) {
  return toHexStringOfMinLength(value, 4);
};
var cmapCodePointFormat = function (codePoint) {
  if (isWithinBMP(codePoint)) return cmapHexString(codePoint);
  if (hasSurrogates(codePoint)) {
    var hs = highSurrogate(codePoint);
    var ls = lowSurrogate(codePoint);
    return "" + cmapHexString(hs) + cmapHexString(ls);
  }
  var hex = toHexString(codePoint);
  var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
  throw new Error(msg);
};

var makeFontFlags = function (options) {
  var flags = 0;
  var flipBit = function (bit) {
    flags |= 1 << bit - 1;
  };
  if (options.fixedPitch) flipBit(1);
  if (options.serif) flipBit(2);
  if (options.symbolic) flipBit(3);
  if (options.script) flipBit(4);
  if (options.nonsymbolic) flipBit(6);
  if (options.italic) flipBit(7);
  if (options.allCap) flipBit(17);
  if (options.smallCap) flipBit(18);
  if (options.forceBold) flipBit(19);
  return flags;
};
var deriveFontFlags = function (font) {
  var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
  var flags = makeFontFlags({
    fixedPitch: font.post.isFixedPitch,
    serif: 1 <= familyClass && familyClass <= 7,
    symbolic: true,
    script: familyClass === 10,
    italic: font.head.macStyle.italic
  });
  return flags;
};

var PDFString = function (_super) {
  __extends(PDFString, _super);
  function PDFString(value) {
    var _this = _super.call(this) || this;
    _this.value = value;
    return _this;
  }
  PDFString.prototype.asBytes = function () {
    var bytes = [];
    var octal = '';
    var escaped = false;
    var pushByte = function (byte) {
      if (byte !== undefined) bytes.push(byte);
      escaped = false;
    };
    for (var idx = 0, len = this.value.length; idx < len; idx++) {
      var char = this.value[idx];
      var byte = toCharCode(char);
      var nextChar = this.value[idx + 1];
      if (!escaped) {
        if (byte === CharCodes$1.BackSlash) escaped = true;else pushByte(byte);
      } else {
        if (byte === CharCodes$1.Newline) pushByte();else if (byte === CharCodes$1.CarriageReturn) pushByte();else if (byte === CharCodes$1.n) pushByte(CharCodes$1.Newline);else if (byte === CharCodes$1.r) pushByte(CharCodes$1.CarriageReturn);else if (byte === CharCodes$1.t) pushByte(CharCodes$1.Tab);else if (byte === CharCodes$1.b) pushByte(CharCodes$1.Backspace);else if (byte === CharCodes$1.f) pushByte(CharCodes$1.FormFeed);else if (byte === CharCodes$1.LeftParen) pushByte(CharCodes$1.LeftParen);else if (byte === CharCodes$1.RightParen) pushByte(CharCodes$1.RightParen);else if (byte === CharCodes$1.Backspace) pushByte(CharCodes$1.BackSlash);else if (byte >= CharCodes$1.Zero && byte <= CharCodes$1.Seven) {
          octal += char;
          if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
            pushByte(parseInt(octal, 8));
            octal = '';
          }
        } else {
          pushByte(byte);
        }
      }
    }
    return new Uint8Array(bytes);
  };
  PDFString.prototype.decodeText = function () {
    var bytes = this.asBytes();
    if (hasUtf16BOM(bytes)) return utf16Decode(bytes);
    return pdfDocEncodingDecode(bytes);
  };
  PDFString.prototype.decodeDate = function () {
    var text = this.decodeText();
    var date = parseDate(text);
    if (!date) throw new InvalidPDFDateStringError(text);
    return date;
  };
  PDFString.prototype.asString = function () {
    return this.value;
  };
  PDFString.prototype.clone = function () {
    return PDFString.of(this.value);
  };
  PDFString.prototype.toString = function () {
    return "(" + this.value + ")";
  };
  PDFString.prototype.sizeInBytes = function () {
    return this.value.length + 2;
  };
  PDFString.prototype.copyBytesInto = function (buffer, offset) {
    buffer[offset++] = CharCodes$1.LeftParen;
    offset += copyStringIntoBuffer(this.value, buffer, offset);
    buffer[offset++] = CharCodes$1.RightParen;
    return this.value.length + 2;
  };
  PDFString.of = function (value) {
    return new PDFString(value);
  };
  PDFString.fromDate = function (date) {
    var year = padStart(String(date.getUTCFullYear()), 4, '0');
    var month = padStart(String(date.getUTCMonth() + 1), 2, '0');
    var day = padStart(String(date.getUTCDate()), 2, '0');
    var hours = padStart(String(date.getUTCHours()), 2, '0');
    var mins = padStart(String(date.getUTCMinutes()), 2, '0');
    var secs = padStart(String(date.getUTCSeconds()), 2, '0');
    return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
  };
  return PDFString;
}(PDFObject);

var CustomFontEmbedder = function () {
  function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
    var _this = this;
    this.allGlyphsInFontSortedById = function () {
      var glyphs = new Array(_this.font.characterSet.length);
      for (var idx = 0, len = glyphs.length; idx < len; idx++) {
        var codePoint = _this.font.characterSet[idx];
        glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
      }
      return sortedUniq(glyphs.sort(byAscendingId), function (g) {
        return g.id;
      });
    };
    this.font = font;
    this.scale = 1000 / this.font.unitsPerEm;
    this.fontData = fontData;
    this.fontName = this.font.postscriptName || 'Font';
    this.customName = customName;
    this.fontFeatures = fontFeatures;
    this.baseFontName = '';
    this.glyphCache = Cache.populatedBy(this.allGlyphsInFontSortedById);
  }
  CustomFontEmbedder.for = function (fontkit, fontData, customName, fontFeatures) {
    return __awaiter(this, void 0, void 0, function () {
      var font;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, fontkit.create(fontData)];
          case 1:
            font = _a.sent();
            return [2, new CustomFontEmbedder(font, fontData, customName, fontFeatures)];
        }
      });
    });
  };
  CustomFontEmbedder.prototype.encodeText = function (text) {
    var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
    var hexCodes = new Array(glyphs.length);
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      hexCodes[idx] = toHexStringOfMinLength(glyphs[idx].id, 4);
    }
    return PDFHexString.of(hexCodes.join(''));
  };
  CustomFontEmbedder.prototype.widthOfTextAtSize = function (text, size) {
    var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
    var totalWidth = 0;
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      totalWidth += glyphs[idx].advanceWidth * this.scale;
    }
    var scale = size / 1000;
    return totalWidth * scale;
  };
  CustomFontEmbedder.prototype.heightOfFontAtSize = function (size, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.descender,
      descender = _a === void 0 ? true : _a;
    var _b = this.font,
      ascent = _b.ascent,
      descent = _b.descent,
      bbox = _b.bbox;
    var yTop = (ascent || bbox.maxY) * this.scale;
    var yBottom = (descent || bbox.minY) * this.scale;
    var height = yTop - yBottom;
    if (!descender) height -= Math.abs(descent) || 0;
    return height / 1000 * size;
  };
  CustomFontEmbedder.prototype.sizeOfFontAtHeight = function (height) {
    var _a = this.font,
      ascent = _a.ascent,
      descent = _a.descent,
      bbox = _a.bbox;
    var yTop = (ascent || bbox.maxY) * this.scale;
    var yBottom = (descent || bbox.minY) * this.scale;
    return 1000 * height / (yTop - yBottom);
  };
  CustomFontEmbedder.prototype.embedIntoContext = function (context, ref) {
    this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
    return this.embedFontDict(context, ref);
  };
  CustomFontEmbedder.prototype.embedFontDict = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var cidFontDictRef, unicodeCMapRef, fontDict;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.embedCIDFontDict(context)];
          case 1:
            cidFontDictRef = _a.sent();
            unicodeCMapRef = this.embedUnicodeCmap(context);
            fontDict = context.obj({
              Type: 'Font',
              Subtype: 'Type0',
              BaseFont: this.baseFontName,
              Encoding: 'Identity-H',
              DescendantFonts: [cidFontDictRef],
              ToUnicode: unicodeCMapRef
            });
            if (ref) {
              context.assign(ref, fontDict);
              return [2, ref];
            } else {
              return [2, context.register(fontDict)];
            }
        }
      });
    });
  };
  CustomFontEmbedder.prototype.isCFF = function () {
    return this.font.cff;
  };
  CustomFontEmbedder.prototype.embedCIDFontDict = function (context) {
    return __awaiter(this, void 0, void 0, function () {
      var fontDescriptorRef, cidFontDict;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.embedFontDescriptor(context)];
          case 1:
            fontDescriptorRef = _a.sent();
            cidFontDict = context.obj({
              Type: 'Font',
              Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
              CIDToGIDMap: 'Identity',
              BaseFont: this.baseFontName,
              CIDSystemInfo: {
                Registry: PDFString.of('Adobe'),
                Ordering: PDFString.of('Identity'),
                Supplement: 0
              },
              FontDescriptor: fontDescriptorRef,
              W: this.computeWidths()
            });
            return [2, context.register(cidFontDict)];
        }
      });
    });
  };
  CustomFontEmbedder.prototype.embedFontDescriptor = function (context) {
    return __awaiter(this, void 0, void 0, function () {
      var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
      var _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            return [4, this.embedFontStream(context)];
          case 1:
            fontStreamRef = _d.sent();
            scale = this.scale;
            _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
            _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
            fontDescriptor = context.obj((_c = {
              Type: 'FontDescriptor',
              FontName: this.baseFontName,
              Flags: deriveFontFlags(this.font),
              FontBBox: [minX * scale, minY * scale, maxX * scale, maxY * scale],
              ItalicAngle: italicAngle,
              Ascent: ascent * scale,
              Descent: descent * scale,
              CapHeight: (capHeight || ascent) * scale,
              XHeight: (xHeight || 0) * scale,
              StemV: 0
            }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
            return [2, context.register(fontDescriptor)];
        }
      });
    });
  };
  CustomFontEmbedder.prototype.serializeFont = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, this.fontData];
      });
    });
  };
  CustomFontEmbedder.prototype.embedFontStream = function (context) {
    return __awaiter(this, void 0, void 0, function () {
      var fontStream, _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _b = (_a = context).flateStream;
            return [4, this.serializeFont()];
          case 1:
            fontStream = _b.apply(_a, [_c.sent(), {
              Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
            }]);
            return [2, context.register(fontStream)];
        }
      });
    });
  };
  CustomFontEmbedder.prototype.embedUnicodeCmap = function (context) {
    var cmap = createCmap(this.glyphCache.access(), this.glyphId.bind(this));
    var cmapStream = context.flateStream(cmap);
    return context.register(cmapStream);
  };
  CustomFontEmbedder.prototype.glyphId = function (glyph) {
    return glyph ? glyph.id : -1;
  };
  CustomFontEmbedder.prototype.computeWidths = function () {
    var glyphs = this.glyphCache.access();
    var widths = [];
    var currSection = [];
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      var currGlyph = glyphs[idx];
      var prevGlyph = glyphs[idx - 1];
      var currGlyphId = this.glyphId(currGlyph);
      var prevGlyphId = this.glyphId(prevGlyph);
      if (idx === 0) {
        widths.push(currGlyphId);
      } else if (currGlyphId - prevGlyphId !== 1) {
        widths.push(currSection);
        widths.push(currGlyphId);
        currSection = [];
      }
      currSection.push(currGlyph.advanceWidth * this.scale);
    }
    widths.push(currSection);
    return widths;
  };
  return CustomFontEmbedder;
}();

var CustomFontSubsetEmbedder = function (_super) {
  __extends(CustomFontSubsetEmbedder, _super);
  function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
    var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
    _this.subset = _this.font.createSubset();
    _this.glyphs = [];
    _this.glyphCache = Cache.populatedBy(function () {
      return _this.glyphs;
    });
    _this.glyphIdMap = new Map();
    return _this;
  }
  CustomFontSubsetEmbedder.for = function (fontkit, fontData, customFontName, fontFeatures) {
    return __awaiter(this, void 0, void 0, function () {
      var font;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, fontkit.create(fontData)];
          case 1:
            font = _a.sent();
            return [2, new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)];
        }
      });
    });
  };
  CustomFontSubsetEmbedder.prototype.encodeText = function (text) {
    var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
    var hexCodes = new Array(glyphs.length);
    for (var idx = 0, len = glyphs.length; idx < len; idx++) {
      var glyph = glyphs[idx];
      var subsetGlyphId = this.subset.includeGlyph(glyph);
      this.glyphs[subsetGlyphId - 1] = glyph;
      this.glyphIdMap.set(glyph.id, subsetGlyphId);
      hexCodes[idx] = toHexStringOfMinLength(subsetGlyphId, 4);
    }
    this.glyphCache.invalidate();
    return PDFHexString.of(hexCodes.join(''));
  };
  CustomFontSubsetEmbedder.prototype.isCFF = function () {
    return this.subset.cff;
  };
  CustomFontSubsetEmbedder.prototype.glyphId = function (glyph) {
    return glyph ? this.glyphIdMap.get(glyph.id) : -1;
  };
  CustomFontSubsetEmbedder.prototype.serializeFont = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      var parts = [];
      _this.subset.encodeStream().on('data', function (bytes) {
        return parts.push(bytes);
      }).on('end', function () {
        return resolve(mergeUint8Arrays(parts));
      }).on('error', function (err) {
        return reject(err);
      });
    });
  };
  return CustomFontSubsetEmbedder;
}(CustomFontEmbedder);

var AFRelationship;
(function (AFRelationship) {
  AFRelationship["Source"] = "Source";
  AFRelationship["Data"] = "Data";
  AFRelationship["Alternative"] = "Alternative";
  AFRelationship["Supplement"] = "Supplement";
  AFRelationship["EncryptedPayload"] = "EncryptedPayload";
  AFRelationship["FormData"] = "EncryptedPayload";
  AFRelationship["Schema"] = "Schema";
  AFRelationship["Unspecified"] = "Unspecified";
})(AFRelationship || (AFRelationship = {}));
var FileEmbedder = function () {
  function FileEmbedder(fileData, fileName, options) {
    if (options === void 0) {
      options = {};
    }
    this.fileData = fileData;
    this.fileName = fileName;
    this.options = options;
  }
  FileEmbedder.for = function (bytes, fileName, options) {
    if (options === void 0) {
      options = {};
    }
    return new FileEmbedder(bytes, fileName, options);
  };
  FileEmbedder.prototype.embedIntoContext = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
      return __generator(this, function (_b) {
        _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
        embeddedFileStream = context.flateStream(this.fileData, {
          Type: 'EmbeddedFile',
          Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
          Params: {
            Size: this.fileData.length,
            CreationDate: creationDate ? PDFString.fromDate(creationDate) : undefined,
            ModDate: modificationDate ? PDFString.fromDate(modificationDate) : undefined
          }
        });
        embeddedFileStreamRef = context.register(embeddedFileStream);
        fileSpecDict = context.obj({
          Type: 'Filespec',
          F: PDFString.of(this.fileName),
          UF: PDFHexString.fromText(this.fileName),
          EF: {
            F: embeddedFileStreamRef
          },
          Desc: description ? PDFHexString.fromText(description) : undefined,
          AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
        });
        if (ref) {
          context.assign(ref, fileSpecDict);
          return [2, ref];
        } else {
          return [2, context.register(fileSpecDict)];
        }
      });
    });
  };
  return FileEmbedder;
}();

var MARKERS = [0xffc0, 0xffc1, 0xffc2, 0xffc3, 0xffc5, 0xffc6, 0xffc7, 0xffc8, 0xffc9, 0xffca, 0xffcb, 0xffcc, 0xffcd, 0xffce, 0xffcf];
var ColorSpace;
(function (ColorSpace) {
  ColorSpace["DeviceGray"] = "DeviceGray";
  ColorSpace["DeviceRGB"] = "DeviceRGB";
  ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})(ColorSpace || (ColorSpace = {}));
var ChannelToColorSpace = {
  1: ColorSpace.DeviceGray,
  3: ColorSpace.DeviceRGB,
  4: ColorSpace.DeviceCMYK
};
var JpegEmbedder = function () {
  function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
    this.imageData = imageData;
    this.bitsPerComponent = bitsPerComponent;
    this.width = width;
    this.height = height;
    this.colorSpace = colorSpace;
  }
  JpegEmbedder.for = function (imageData) {
    return __awaiter(this, void 0, void 0, function () {
      var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
      return __generator(this, function (_a) {
        dataView = new DataView(imageData.buffer);
        soi = dataView.getUint16(0);
        if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
        pos = 2;
        while (pos < dataView.byteLength) {
          marker = dataView.getUint16(pos);
          pos += 2;
          if (MARKERS.includes(marker)) break;
          pos += dataView.getUint16(pos);
        }
        if (!MARKERS.includes(marker)) throw new Error('Invalid JPEG');
        pos += 2;
        bitsPerComponent = dataView.getUint8(pos++);
        height = dataView.getUint16(pos);
        pos += 2;
        width = dataView.getUint16(pos);
        pos += 2;
        channelByte = dataView.getUint8(pos++);
        channelName = ChannelToColorSpace[channelByte];
        if (!channelName) throw new Error('Unknown JPEG channel.');
        colorSpace = channelName;
        return [2, new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)];
      });
    });
  };
  JpegEmbedder.prototype.embedIntoContext = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var xObject;
      return __generator(this, function (_a) {
        xObject = context.stream(this.imageData, {
          Type: 'XObject',
          Subtype: 'Image',
          BitsPerComponent: this.bitsPerComponent,
          Width: this.width,
          Height: this.height,
          ColorSpace: this.colorSpace,
          Filter: 'DCTDecode',
          Decode: this.colorSpace === ColorSpace.DeviceCMYK ? [1, 0, 1, 0, 1, 0, 1, 0] : undefined
        });
        if (ref) {
          context.assign(ref, xObject);
          return [2, ref];
        } else {
          return [2, context.register(xObject)];
        }
      });
    });
  };
  return JpegEmbedder;
}();

var UPNG = {};
UPNG.toRGBA8 = function (out) {
  var w = out.width,
    h = out.height;
  if (out.tabs.acTL == null) return [UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer];
  var frms = [];
  if (out.frames[0].data == null) out.frames[0].data = out.data;
  var len = w * h * 4,
    img = new Uint8Array(len),
    empty = new Uint8Array(len),
    prev = new Uint8Array(len);
  for (var i = 0; i < out.frames.length; i++) {
    var frm = out.frames[i];
    var fx = frm.rect.x,
      fy = frm.rect.y,
      fw = frm.rect.width,
      fh = frm.rect.height;
    var fdata = UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
    if (i != 0) for (var j = 0; j < len; j++) prev[j] = img[j];
    if (frm.blend == 0) UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);else if (frm.blend == 1) UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
    frms.push(img.buffer.slice(0));
    if (frm.dispose == 0) ; else if (frm.dispose == 1) UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);else if (frm.dispose == 2) for (var j = 0; j < len; j++) img[j] = prev[j];
  }
  return frms;
};
UPNG.toRGBA8.decodeImage = function (data, w, h, out) {
  var area = w * h,
    bpp = UPNG.decode._getBPP(out);
  var bpl = Math.ceil(w * bpp / 8);
  var bf = new Uint8Array(area * 4),
    bf32 = new Uint32Array(bf.buffer);
  var ctype = out.ctype,
    depth = out.depth;
  var rs = UPNG._bin.readUshort;
  if (ctype == 6) {
    var qarea = area << 2;
    if (depth == 8) for (var i = 0; i < qarea; i += 4) {
      bf[i] = data[i];
      bf[i + 1] = data[i + 1];
      bf[i + 2] = data[i + 2];
      bf[i + 3] = data[i + 3];
    }
    if (depth == 16) for (var i = 0; i < qarea; i++) {
      bf[i] = data[i << 1];
    }
  } else if (ctype == 2) {
    var ts = out.tabs["tRNS"];
    if (ts == null) {
      if (depth == 8) for (var i = 0; i < area; i++) {
        var ti = i * 3;
        bf32[i] = 255 << 24 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
      }
      if (depth == 16) for (var i = 0; i < area; i++) {
        var ti = i * 6;
        bf32[i] = 255 << 24 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
      }
    } else {
      var tr = ts[0],
        tg = ts[1],
        tb = ts[2];
      if (depth == 8) for (var i = 0; i < area; i++) {
        var qi = i << 2,
          ti = i * 3;
        bf32[i] = 255 << 24 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
        if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
      }
      if (depth == 16) for (var i = 0; i < area; i++) {
        var qi = i << 2,
          ti = i * 6;
        bf32[i] = 255 << 24 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
        if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
      }
    }
  } else if (ctype == 3) {
    var p = out.tabs["PLTE"],
      ap = out.tabs["tRNS"],
      tl = ap ? ap.length : 0;
    if (depth == 1) for (var y = 0; y < h; y++) {
      var s0 = y * bpl,
        t0 = y * w;
      for (var i = 0; i < w; i++) {
        var qi = t0 + i << 2,
          j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1,
          cj = 3 * j;
        bf[qi] = p[cj];
        bf[qi + 1] = p[cj + 1];
        bf[qi + 2] = p[cj + 2];
        bf[qi + 3] = j < tl ? ap[j] : 255;
      }
    }
    if (depth == 2) for (var y = 0; y < h; y++) {
      var s0 = y * bpl,
        t0 = y * w;
      for (var i = 0; i < w; i++) {
        var qi = t0 + i << 2,
          j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3,
          cj = 3 * j;
        bf[qi] = p[cj];
        bf[qi + 1] = p[cj + 1];
        bf[qi + 2] = p[cj + 2];
        bf[qi + 3] = j < tl ? ap[j] : 255;
      }
    }
    if (depth == 4) for (var y = 0; y < h; y++) {
      var s0 = y * bpl,
        t0 = y * w;
      for (var i = 0; i < w; i++) {
        var qi = t0 + i << 2,
          j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15,
          cj = 3 * j;
        bf[qi] = p[cj];
        bf[qi + 1] = p[cj + 1];
        bf[qi + 2] = p[cj + 2];
        bf[qi + 3] = j < tl ? ap[j] : 255;
      }
    }
    if (depth == 8) for (var i = 0; i < area; i++) {
      var qi = i << 2,
        j = data[i],
        cj = 3 * j;
      bf[qi] = p[cj];
      bf[qi + 1] = p[cj + 1];
      bf[qi + 2] = p[cj + 2];
      bf[qi + 3] = j < tl ? ap[j] : 255;
    }
  } else if (ctype == 4) {
    if (depth == 8) for (var i = 0; i < area; i++) {
      var qi = i << 2,
        di = i << 1,
        gr = data[di];
      bf[qi] = gr;
      bf[qi + 1] = gr;
      bf[qi + 2] = gr;
      bf[qi + 3] = data[di + 1];
    }
    if (depth == 16) for (var i = 0; i < area; i++) {
      var qi = i << 2,
        di = i << 2,
        gr = data[di];
      bf[qi] = gr;
      bf[qi + 1] = gr;
      bf[qi + 2] = gr;
      bf[qi + 3] = data[di + 2];
    }
  } else if (ctype == 0) {
    var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
    for (var y = 0; y < h; y++) {
      var off = y * bpl,
        to = y * w;
      if (depth == 1) for (var x = 0; x < w; x++) {
        var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1),
          al = gr == tr * 255 ? 0 : 255;
        bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
      } else if (depth == 2) for (var x = 0; x < w; x++) {
        var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3),
          al = gr == tr * 85 ? 0 : 255;
        bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
      } else if (depth == 4) for (var x = 0; x < w; x++) {
        var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15),
          al = gr == tr * 17 ? 0 : 255;
        bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
      } else if (depth == 8) for (var x = 0; x < w; x++) {
        var gr = data[off + x],
          al = gr == tr ? 0 : 255;
        bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
      } else if (depth == 16) for (var x = 0; x < w; x++) {
        var gr = data[off + (x << 1)],
          al = rs(data, off + (x << i)) == tr ? 0 : 255;
        bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
      }
    }
  }
  return bf;
};
UPNG.decode = function (buff) {
  var data = new Uint8Array(buff),
    offset = 8,
    bin = UPNG._bin,
    rUs = bin.readUshort,
    rUi = bin.readUint;
  var out = {
    tabs: {},
    frames: []
  };
  var dd = new Uint8Array(data.length),
    doff = 0;
  var fd,
    foff = 0;
  var mgck = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  for (var i = 0; i < 8; i++) if (data[i] != mgck[i]) throw "The input is not a PNG file!";
  while (offset < data.length) {
    var len = bin.readUint(data, offset);
    offset += 4;
    var type = bin.readASCII(data, offset, 4);
    offset += 4;
    if (type == "IHDR") {
      UPNG.decode._IHDR(data, offset, out);
    } else if (type == "IDAT") {
      for (var i = 0; i < len; i++) dd[doff + i] = data[offset + i];
      doff += len;
    } else if (type == "acTL") {
      out.tabs[type] = {
        num_frames: rUi(data, offset),
        num_plays: rUi(data, offset + 4)
      };
      fd = new Uint8Array(data.length);
    } else if (type == "fcTL") {
      if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
      }
      var rct = {
        x: rUi(data, offset + 12),
        y: rUi(data, offset + 16),
        width: rUi(data, offset + 4),
        height: rUi(data, offset + 8)
      };
      var del = rUs(data, offset + 22);
      del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
      var frm = {
        rect: rct,
        delay: Math.round(del * 1000),
        dispose: data[offset + 24],
        blend: data[offset + 25]
      };
      out.frames.push(frm);
    } else if (type == "fdAT") {
      for (var i = 0; i < len - 4; i++) fd[foff + i] = data[offset + i + 4];
      foff += len - 4;
    } else if (type == "pHYs") {
      out.tabs[type] = [bin.readUint(data, offset), bin.readUint(data, offset + 4), data[offset + 8]];
    } else if (type == "cHRM") {
      out.tabs[type] = [];
      for (var i = 0; i < 8; i++) out.tabs[type].push(bin.readUint(data, offset + i * 4));
    } else if (type == "tEXt") {
      if (out.tabs[type] == null) out.tabs[type] = {};
      var nz = bin.nextZero(data, offset);
      var keyw = bin.readASCII(data, offset, nz - offset);
      var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
      out.tabs[type][keyw] = text;
    } else if (type == "iTXt") {
      if (out.tabs[type] == null) out.tabs[type] = {};
      var nz = 0,
        off = offset;
      nz = bin.nextZero(data, off);
      var keyw = bin.readASCII(data, off, nz - off);
      off = nz + 1;
      off += 2;
      nz = bin.nextZero(data, off);
      var ltag = bin.readASCII(data, off, nz - off);
      off = nz + 1;
      nz = bin.nextZero(data, off);
      var tkeyw = bin.readUTF8(data, off, nz - off);
      off = nz + 1;
      var text = bin.readUTF8(data, off, len - (off - offset));
      out.tabs[type][keyw] = text;
    } else if (type == "PLTE") {
      out.tabs[type] = bin.readBytes(data, offset, len);
    } else if (type == "hIST") {
      var pl = out.tabs["PLTE"].length / 3;
      out.tabs[type] = [];
      for (var i = 0; i < pl; i++) out.tabs[type].push(rUs(data, offset + i * 2));
    } else if (type == "tRNS") {
      if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);else if (out.ctype == 2) out.tabs[type] = [rUs(data, offset), rUs(data, offset + 2), rUs(data, offset + 4)];
    } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;else if (type == "sRGB") out.tabs[type] = data[offset];else if (type == "bKGD") {
      if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [rUs(data, offset)];else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [rUs(data, offset), rUs(data, offset + 2), rUs(data, offset + 4)];else if (out.ctype == 3) out.tabs[type] = data[offset];
    } else if (type == "IEND") {
      break;
    }
    offset += len;
    var crc = bin.readUint(data, offset);
    offset += 4;
  }
  if (foff != 0) {
    var fr = out.frames[out.frames.length - 1];
    fr.data = UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
    foff = 0;
  }
  out.data = UPNG.decode._decompress(out, dd, out.width, out.height);
  delete out.compress;
  delete out.interlace;
  delete out.filter;
  return out;
};
UPNG.decode._decompress = function (out, dd, w, h) {
  var bpp = UPNG.decode._getBPP(out),
    bpl = Math.ceil(w * bpp / 8),
    buff = new Uint8Array((bpl + 1 + out.interlace) * h);
  dd = UPNG.decode._inflate(dd, buff);
  if (out.interlace == 0) dd = UPNG.decode._filterZero(dd, out, 0, w, h);else if (out.interlace == 1) dd = UPNG.decode._readInterlace(dd, out);
  return dd;
};
UPNG.decode._inflate = function (data, buff) {
  var out = UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
  return out;
};
UPNG.inflateRaw = function () {
  var H = {};
  H.H = {};
  H.H.N = function (N, W) {
    var R = Uint8Array,
      i = 0,
      m = 0,
      J = 0,
      h = 0,
      Q = 0,
      X = 0,
      u = 0,
      w = 0,
      d = 0,
      v,
      C;
    if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
    var V = H.H,
      n = V.b,
      A = V.e,
      l = V.R,
      M = V.n,
      I = V.A,
      e = V.Z,
      b = V.m,
      Z = W == null;
    if (Z) W = new R(N.length >>> 2 << 3);
    while (i == 0) {
      i = n(N, d, 1);
      m = n(N, d + 1, 2);
      d += 3;
      if (m == 0) {
        if ((d & 7) != 0) d += 8 - (d & 7);
        var D = (d >>> 3) + 4,
          q = N[D - 4] | N[D - 3] << 8;
        if (Z) W = H.H.W(W, w + q);
        W.set(new R(N.buffer, N.byteOffset + D, q), w);
        d = D + q << 3;
        w += q;
        continue;
      }
      if (Z) W = H.H.W(W, w + (1 << 17));
      if (m == 1) {
        v = b.J;
        C = b.h;
        X = (1 << 9) - 1;
        u = (1 << 5) - 1;
      }
      if (m == 2) {
        J = A(N, d, 5) + 257;
        h = A(N, d + 5, 5) + 1;
        Q = A(N, d + 10, 4) + 4;
        d += 14;
        var j = 1;
        for (var c = 0; c < 38; c += 2) {
          b.Q[c] = 0;
          b.Q[c + 1] = 0;
        }
        for (var c = 0; c < Q; c++) {
          var K = A(N, d + c * 3, 3);
          b.Q[(b.X[c] << 1) + 1] = K;
          if (K > j) j = K;
        }
        d += 3 * Q;
        M(b.Q, j);
        I(b.Q, j, b.u);
        v = b.w;
        C = b.d;
        d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
        var r = V.V(b.v, 0, J, b.C);
        X = (1 << r) - 1;
        var S = V.V(b.v, J, h, b.D);
        u = (1 << S) - 1;
        M(b.C, r);
        I(b.C, r, v);
        M(b.D, S);
        I(b.D, S, C);
      }
      while (!0) {
        var T = v[e(N, d) & X];
        d += T & 15;
        var p = T >>> 4;
        if (p >>> 8 == 0) {
          W[w++] = p;
        } else if (p == 256) {
          break;
        } else {
          var z = w + p - 254;
          if (p > 264) {
            var _ = b.q[p - 257];
            z = w + (_ >>> 3) + A(N, d, _ & 7);
            d += _ & 7;
          }
          var $ = C[e(N, d) & u];
          d += $ & 15;
          var s = $ >>> 4,
            Y = b.c[s],
            a = (Y >>> 4) + n(N, d, Y & 15);
          d += Y & 15;
          while (w < z) {
            W[w] = W[w++ - a];
            W[w] = W[w++ - a];
            W[w] = W[w++ - a];
            W[w] = W[w++ - a];
          }
          w = z;
        }
      }
    }
    return W.length == w ? W : W.slice(0, w);
  };
  H.H.W = function (N, W) {
    var R = N.length;
    if (W <= R) return N;
    var V = new Uint8Array(R << 1);
    V.set(N, 0);
    return V;
  };
  H.H.R = function (N, W, R, V, n, A) {
    var l = H.H.e,
      M = H.H.Z,
      I = 0;
    while (I < R) {
      var e = N[M(V, n) & W];
      n += e & 15;
      var b = e >>> 4;
      if (b <= 15) {
        A[I] = b;
        I++;
      } else {
        var Z = 0,
          m = 0;
        if (b == 16) {
          m = 3 + l(V, n, 2);
          n += 2;
          Z = A[I - 1];
        } else if (b == 17) {
          m = 3 + l(V, n, 3);
          n += 3;
        } else if (b == 18) {
          m = 11 + l(V, n, 7);
          n += 7;
        }
        var J = I + m;
        while (I < J) {
          A[I] = Z;
          I++;
        }
      }
    }
    return n;
  };
  H.H.V = function (N, W, R, V) {
    var n = 0,
      A = 0,
      l = V.length >>> 1;
    while (A < R) {
      var M = N[A + W];
      V[A << 1] = 0;
      V[(A << 1) + 1] = M;
      if (M > n) n = M;
      A++;
    }
    while (A < l) {
      V[A << 1] = 0;
      V[(A << 1) + 1] = 0;
      A++;
    }
    return n;
  };
  H.H.n = function (N, W) {
    var R = H.H.m,
      V = N.length,
      n,
      A,
      l,
      M,
      I,
      e = R.j;
    for (var M = 0; M <= W; M++) e[M] = 0;
    for (M = 1; M < V; M += 2) e[N[M]]++;
    var b = R.K;
    n = 0;
    e[0] = 0;
    for (A = 1; A <= W; A++) {
      n = n + e[A - 1] << 1;
      b[A] = n;
    }
    for (l = 0; l < V; l += 2) {
      I = N[l + 1];
      if (I != 0) {
        N[l] = b[I];
        b[I]++;
      }
    }
  };
  H.H.A = function (N, W, R) {
    var V = N.length,
      n = H.H.m,
      A = n.r;
    for (var l = 0; l < V; l += 2) if (N[l + 1] != 0) {
      var M = l >> 1,
        I = N[l + 1],
        e = M << 4 | I,
        b = W - I,
        Z = N[l] << b,
        m = Z + (1 << b);
      while (Z != m) {
        var J = A[Z] >>> 15 - W;
        R[J] = e;
        Z++;
      }
    }
  };
  H.H.l = function (N, W) {
    var R = H.H.m.r,
      V = 15 - W;
    for (var n = 0; n < N.length; n += 2) {
      var A = N[n] << W - N[n + 1];
      N[n] = R[A] >>> V;
    }
  };
  H.H.M = function (N, W, R) {
    R = R << (W & 7);
    var V = W >>> 3;
    N[V] |= R;
    N[V + 1] |= R >>> 8;
  };
  H.H.I = function (N, W, R) {
    R = R << (W & 7);
    var V = W >>> 3;
    N[V] |= R;
    N[V + 1] |= R >>> 8;
    N[V + 2] |= R >>> 16;
  };
  H.H.e = function (N, W, R) {
    return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
  };
  H.H.b = function (N, W, R) {
    return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
  };
  H.H.Z = function (N, W) {
    return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
  };
  H.H.i = function (N, W) {
    return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
  };
  H.H.m = function () {
    var N = Uint16Array,
      W = Uint32Array;
    return {
      K: new N(16),
      j: new N(16),
      X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999],
      T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0],
      q: new N(32),
      p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535],
      z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0],
      c: new W(32),
      J: new N(512),
      _: [],
      h: new N(32),
      $: [],
      w: new N(32768),
      C: [],
      v: [],
      d: new N(32768),
      D: [],
      u: new N(512),
      Q: [],
      r: new N(1 << 15),
      s: new W(286),
      Y: new W(30),
      a: new W(19),
      t: new W(15e3),
      k: new N(1 << 16),
      g: new N(1 << 15)
    };
  }();
  (function () {
    var N = H.H.m,
      W = 1 << 15;
    for (var R = 0; R < W; R++) {
      var V = R;
      V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
      V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
      V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
      V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
      N.r[R] = (V >>> 16 | V << 16) >>> 17;
    }
    function n(A, l, M) {
      while (l-- != 0) A.push(0, M);
    }
    for (var R = 0; R < 32; R++) {
      N.q[R] = N.S[R] << 3 | N.T[R];
      N.c[R] = N.p[R] << 4 | N.z[R];
    }
    n(N._, 144, 8);
    n(N._, 255 - 143, 9);
    n(N._, 279 - 255, 7);
    n(N._, 287 - 279, 8);
    H.H.n(N._, 9);
    H.H.A(N._, 9, N.J);
    H.H.l(N._, 9);
    n(N.$, 32, 5);
    H.H.n(N.$, 5);
    H.H.A(N.$, 5, N.h);
    H.H.l(N.$, 5);
    n(N.Q, 19, 0);
    n(N.C, 286, 0);
    n(N.D, 30, 0);
    n(N.v, 320, 0);
  })();
  return H.H.N;
}();
UPNG.decode._readInterlace = function (data, out) {
  var w = out.width,
    h = out.height;
  var bpp = UPNG.decode._getBPP(out),
    cbpp = bpp >> 3,
    bpl = Math.ceil(w * bpp / 8);
  var img = new Uint8Array(h * bpl);
  var di = 0;
  var starting_row = [0, 0, 4, 0, 2, 0, 1];
  var starting_col = [0, 4, 0, 2, 0, 1, 0];
  var row_increment = [8, 8, 8, 4, 4, 2, 2];
  var col_increment = [8, 8, 4, 4, 2, 2, 1];
  var pass = 0;
  while (pass < 7) {
    var ri = row_increment[pass],
      ci = col_increment[pass];
    var sw = 0,
      sh = 0;
    var cr = starting_row[pass];
    while (cr < h) {
      cr += ri;
      sh++;
    }
    var cc = starting_col[pass];
    while (cc < w) {
      cc += ci;
      sw++;
    }
    var bpll = Math.ceil(sw * bpp / 8);
    UPNG.decode._filterZero(data, out, di, sw, sh);
    var y = 0,
      row = starting_row[pass];
    while (row < h) {
      var col = starting_col[pass];
      var cdi = di + y * bpll << 3;
      while (col < w) {
        if (bpp == 1) {
          var val = data[cdi >> 3];
          val = val >> 7 - (cdi & 7) & 1;
          img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
        }
        if (bpp == 2) {
          var val = data[cdi >> 3];
          val = val >> 6 - (cdi & 7) & 3;
          img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
        }
        if (bpp == 4) {
          var val = data[cdi >> 3];
          val = val >> 4 - (cdi & 7) & 15;
          img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
        }
        if (bpp >= 8) {
          var ii = row * bpl + col * cbpp;
          for (var j = 0; j < cbpp; j++) img[ii + j] = data[(cdi >> 3) + j];
        }
        cdi += bpp;
        col += ci;
      }
      y++;
      row += ri;
    }
    if (sw * sh != 0) di += sh * (1 + bpll);
    pass = pass + 1;
  }
  return img;
};
UPNG.decode._getBPP = function (out) {
  var noc = [1, null, 3, 1, 2, null, 4][out.ctype];
  return noc * out.depth;
};
UPNG.decode._filterZero = function (data, out, off, w, h) {
  var bpp = UPNG.decode._getBPP(out),
    bpl = Math.ceil(w * bpp / 8),
    paeth = UPNG.decode._paeth;
  bpp = Math.ceil(bpp / 8);
  var i = 0,
    di = 1,
    type = data[off],
    x = 0;
  if (type > 1) data[off] = [0, 0, 1][type - 2];
  if (type == 3) for (x = bpp; x < bpl; x++) data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
  for (var y = 0; y < h; y++) {
    i = off + y * bpl;
    di = i + y + 1;
    type = data[di - 1];
    x = 0;
    if (type == 0) for (; x < bpl; x++) data[i + x] = data[di + x];else if (type == 1) {
      for (; x < bpp; x++) data[i + x] = data[di + x];
      for (; x < bpl; x++) data[i + x] = data[di + x] + data[i + x - bpp];
    } else if (type == 2) {
      for (; x < bpl; x++) data[i + x] = data[di + x] + data[i + x - bpl];
    } else if (type == 3) {
      for (; x < bpp; x++) data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
      for (; x < bpl; x++) data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
    } else {
      for (; x < bpp; x++) data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
      for (; x < bpl; x++) data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
    }
  }
  return data;
};
UPNG.decode._paeth = function (a, b, c) {
  var p = a + b - c,
    pa = p - a,
    pb = p - b,
    pc = p - c;
  if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;else if (pb * pb <= pc * pc) return b;
  return c;
};
UPNG.decode._IHDR = function (data, offset, out) {
  var bin = UPNG._bin;
  out.width = bin.readUint(data, offset);
  offset += 4;
  out.height = bin.readUint(data, offset);
  offset += 4;
  out.depth = data[offset];
  offset++;
  out.ctype = data[offset];
  offset++;
  out.compress = data[offset];
  offset++;
  out.filter = data[offset];
  offset++;
  out.interlace = data[offset];
  offset++;
};
UPNG._bin = {
  nextZero: function (data, p) {
    while (data[p] != 0) p++;
    return p;
  },
  readUshort: function (buff, p) {
    return buff[p] << 8 | buff[p + 1];
  },
  writeUshort: function (buff, p, n) {
    buff[p] = n >> 8 & 255;
    buff[p + 1] = n & 255;
  },
  readUint: function (buff, p) {
    return buff[p] * (256 * 256 * 256) + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
  },
  writeUint: function (buff, p, n) {
    buff[p] = n >> 24 & 255;
    buff[p + 1] = n >> 16 & 255;
    buff[p + 2] = n >> 8 & 255;
    buff[p + 3] = n & 255;
  },
  readASCII: function (buff, p, l) {
    var s = "";
    for (var i = 0; i < l; i++) s += String.fromCharCode(buff[p + i]);
    return s;
  },
  writeASCII: function (data, p, s) {
    for (var i = 0; i < s.length; i++) data[p + i] = s.charCodeAt(i);
  },
  readBytes: function (buff, p, l) {
    var arr = [];
    for (var i = 0; i < l; i++) arr.push(buff[p + i]);
    return arr;
  },
  pad: function (n) {
    return n.length < 2 ? "0" + n : n;
  },
  readUTF8: function (buff, p, l) {
    var s = "",
      ns;
    for (var i = 0; i < l; i++) s += "%" + UPNG._bin.pad(buff[p + i].toString(16));
    try {
      ns = decodeURIComponent(s);
    } catch (e) {
      return UPNG._bin.readASCII(buff, p, l);
    }
    return ns;
  }
};
UPNG._copyTile = function (sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
  var w = Math.min(sw, tw),
    h = Math.min(sh, th);
  var si = 0,
    ti = 0;
  for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
    if (xoff >= 0 && yoff >= 0) {
      si = y * sw + x << 2;
      ti = (yoff + y) * tw + xoff + x << 2;
    } else {
      si = (-yoff + y) * sw - xoff + x << 2;
      ti = y * tw + x << 2;
    }
    if (mode == 0) {
      tb[ti] = sb[si];
      tb[ti + 1] = sb[si + 1];
      tb[ti + 2] = sb[si + 2];
      tb[ti + 3] = sb[si + 3];
    } else if (mode == 1) {
      var fa = sb[si + 3] * (1 / 255),
        fr = sb[si] * fa,
        fg = sb[si + 1] * fa,
        fb = sb[si + 2] * fa;
      var ba = tb[ti + 3] * (1 / 255),
        br = tb[ti] * ba,
        bg = tb[ti + 1] * ba,
        bb = tb[ti + 2] * ba;
      var ifa = 1 - fa,
        oa = fa + ba * ifa,
        ioa = oa == 0 ? 0 : 1 / oa;
      tb[ti + 3] = 255 * oa;
      tb[ti + 0] = (fr + br * ifa) * ioa;
      tb[ti + 1] = (fg + bg * ifa) * ioa;
      tb[ti + 2] = (fb + bb * ifa) * ioa;
    } else if (mode == 2) {
      var fa = sb[si + 3],
        fr = sb[si],
        fg = sb[si + 1],
        fb = sb[si + 2];
      var ba = tb[ti + 3],
        br = tb[ti],
        bg = tb[ti + 1],
        bb = tb[ti + 2];
      if (fa == ba && fr == br && fg == bg && fb == bb) {
        tb[ti] = 0;
        tb[ti + 1] = 0;
        tb[ti + 2] = 0;
        tb[ti + 3] = 0;
      } else {
        tb[ti] = fr;
        tb[ti + 1] = fg;
        tb[ti + 2] = fb;
        tb[ti + 3] = fa;
      }
    } else if (mode == 3) {
      var fa = sb[si + 3],
        fr = sb[si],
        fg = sb[si + 1],
        fb = sb[si + 2];
      var ba = tb[ti + 3],
        br = tb[ti],
        bg = tb[ti + 1],
        bb = tb[ti + 2];
      if (fa == ba && fr == br && fg == bg && fb == bb) continue;
      if (fa < 220 && ba > 20) return false;
    }
  }
  return true;
};
UPNG.encode = function (bufs, w, h, ps, dels, tabs, forbidPlte) {
  if (ps == null) ps = 0;
  if (forbidPlte == null) forbidPlte = false;
  var nimg = UPNG.encode.compress(bufs, w, h, ps, [false, false, false, 0, forbidPlte]);
  UPNG.encode.compressPNG(nimg, -1);
  return UPNG.encode._main(nimg, w, h, dels, tabs);
};
UPNG.encodeLL = function (bufs, w, h, cc, ac, depth, dels, tabs) {
  var nimg = {
    ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
    depth: depth,
    frames: []
  };
  var bipp = (cc + ac) * depth,
    bipl = bipp * w;
  for (var i = 0; i < bufs.length; i++) nimg.frames.push({
    rect: {
      x: 0,
      y: 0,
      width: w,
      height: h
    },
    img: new Uint8Array(bufs[i]),
    blend: 0,
    dispose: 1,
    bpp: Math.ceil(bipp / 8),
    bpl: Math.ceil(bipl / 8)
  });
  UPNG.encode.compressPNG(nimg, 0, true);
  var out = UPNG.encode._main(nimg, w, h, dels, tabs);
  return out;
};
UPNG.encode._main = function (nimg, w, h, dels, tabs) {
  if (tabs == null) tabs = {};
  var crc = UPNG.crc.crc,
    wUi = UPNG._bin.writeUint,
    wUs = UPNG._bin.writeUshort,
    wAs = UPNG._bin.writeASCII;
  var offset = 8,
    anim = nimg.frames.length > 1,
    pltAlpha = false;
  var leng = 8 + (16 + 5 + 4) + (anim ? 20 : 0);
  if (tabs["sRGB"] != null) leng += 8 + 1 + 4;
  if (tabs["pHYs"] != null) leng += 8 + 9 + 4;
  if (nimg.ctype == 3) {
    var dl = nimg.plte.length;
    for (var i = 0; i < dl; i++) if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
    leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
  }
  for (var j = 0; j < nimg.frames.length; j++) {
    var fr = nimg.frames[j];
    if (anim) leng += 38;
    leng += fr.cimg.length + 12;
    if (j != 0) leng += 4;
  }
  leng += 12;
  var data = new Uint8Array(leng);
  var wr = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  for (var i = 0; i < 8; i++) data[i] = wr[i];
  wUi(data, offset, 13);
  offset += 4;
  wAs(data, offset, "IHDR");
  offset += 4;
  wUi(data, offset, w);
  offset += 4;
  wUi(data, offset, h);
  offset += 4;
  data[offset] = nimg.depth;
  offset++;
  data[offset] = nimg.ctype;
  offset++;
  data[offset] = 0;
  offset++;
  data[offset] = 0;
  offset++;
  data[offset] = 0;
  offset++;
  wUi(data, offset, crc(data, offset - 17, 17));
  offset += 4;
  if (tabs["sRGB"] != null) {
    wUi(data, offset, 1);
    offset += 4;
    wAs(data, offset, "sRGB");
    offset += 4;
    data[offset] = tabs["sRGB"];
    offset++;
    wUi(data, offset, crc(data, offset - 5, 5));
    offset += 4;
  }
  if (tabs["pHYs"] != null) {
    wUi(data, offset, 9);
    offset += 4;
    wAs(data, offset, "pHYs");
    offset += 4;
    wUi(data, offset, tabs["pHYs"][0]);
    offset += 4;
    wUi(data, offset, tabs["pHYs"][1]);
    offset += 4;
    data[offset] = tabs["pHYs"][2];
    offset++;
    wUi(data, offset, crc(data, offset - 13, 13));
    offset += 4;
  }
  if (anim) {
    wUi(data, offset, 8);
    offset += 4;
    wAs(data, offset, "acTL");
    offset += 4;
    wUi(data, offset, nimg.frames.length);
    offset += 4;
    wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
    offset += 4;
    wUi(data, offset, crc(data, offset - 12, 12));
    offset += 4;
  }
  if (nimg.ctype == 3) {
    var dl = nimg.plte.length;
    wUi(data, offset, dl * 3);
    offset += 4;
    wAs(data, offset, "PLTE");
    offset += 4;
    for (var i = 0; i < dl; i++) {
      var ti = i * 3,
        c = nimg.plte[i],
        r = c & 255,
        g = c >>> 8 & 255,
        b = c >>> 16 & 255;
      data[offset + ti + 0] = r;
      data[offset + ti + 1] = g;
      data[offset + ti + 2] = b;
    }
    offset += dl * 3;
    wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
    offset += 4;
    if (pltAlpha) {
      wUi(data, offset, dl);
      offset += 4;
      wAs(data, offset, "tRNS");
      offset += 4;
      for (var i = 0; i < dl; i++) data[offset + i] = nimg.plte[i] >>> 24 & 255;
      offset += dl;
      wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
      offset += 4;
    }
  }
  var fi = 0;
  for (var j = 0; j < nimg.frames.length; j++) {
    var fr = nimg.frames[j];
    if (anim) {
      wUi(data, offset, 26);
      offset += 4;
      wAs(data, offset, "fcTL");
      offset += 4;
      wUi(data, offset, fi++);
      offset += 4;
      wUi(data, offset, fr.rect.width);
      offset += 4;
      wUi(data, offset, fr.rect.height);
      offset += 4;
      wUi(data, offset, fr.rect.x);
      offset += 4;
      wUi(data, offset, fr.rect.y);
      offset += 4;
      wUs(data, offset, dels[j]);
      offset += 2;
      wUs(data, offset, 1000);
      offset += 2;
      data[offset] = fr.dispose;
      offset++;
      data[offset] = fr.blend;
      offset++;
      wUi(data, offset, crc(data, offset - 30, 30));
      offset += 4;
    }
    var imgd = fr.cimg,
      dl = imgd.length;
    wUi(data, offset, dl + (j == 0 ? 0 : 4));
    offset += 4;
    var ioff = offset;
    wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
    offset += 4;
    if (j != 0) {
      wUi(data, offset, fi++);
      offset += 4;
    }
    data.set(imgd, offset);
    offset += dl;
    wUi(data, offset, crc(data, ioff, offset - ioff));
    offset += 4;
  }
  wUi(data, offset, 0);
  offset += 4;
  wAs(data, offset, "IEND");
  offset += 4;
  wUi(data, offset, crc(data, offset - 4, 4));
  offset += 4;
  return data.buffer;
};
UPNG.encode.compressPNG = function (out, filter, levelZero) {
  for (var i = 0; i < out.frames.length; i++) {
    var frm = out.frames[i],
      nh = frm.rect.height;
    var fdata = new Uint8Array(nh * frm.bpl + nh);
    frm.cimg = UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
  }
};
UPNG.encode.compress = function (bufs, w, h, ps, prms) {
  var onlyBlend = prms[0],
    evenCrd = prms[1],
    forbidPrev = prms[2],
    minBits = prms[3],
    forbidPlte = prms[4];
  var ctype = 6,
    depth = 8,
    alphaAnd = 255;
  for (var j = 0; j < bufs.length; j++) {
    var img = new Uint8Array(bufs[j]),
      ilen = img.length;
    for (var i = 0; i < ilen; i += 4) alphaAnd &= img[i + 3];
  }
  var gotAlpha = alphaAnd != 255;
  var frms = UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
  var cmap = {},
    plte = [],
    inds = [];
  if (ps != 0) {
    var nbufs = [];
    for (var i = 0; i < frms.length; i++) nbufs.push(frms[i].img.buffer);
    var abuf = UPNG.encode.concatRGBA(nbufs),
      qres = UPNG.quantize(abuf, ps);
    var cof = 0,
      bb = new Uint8Array(qres.abuf);
    for (var i = 0; i < frms.length; i++) {
      var ti = frms[i].img,
        bln = ti.length;
      inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
      for (var j = 0; j < bln; j += 4) {
        ti[j] = bb[cof + j];
        ti[j + 1] = bb[cof + j + 1];
        ti[j + 2] = bb[cof + j + 2];
        ti[j + 3] = bb[cof + j + 3];
      }
      cof += bln;
    }
    for (var i = 0; i < qres.plte.length; i++) plte.push(qres.plte[i].est.rgba);
  } else {
    for (var j = 0; j < frms.length; j++) {
      var frm = frms[j],
        img32 = new Uint32Array(frm.img.buffer),
        nw = frm.rect.width,
        ilen = img32.length;
      var ind = new Uint8Array(ilen);
      inds.push(ind);
      for (var i = 0; i < ilen; i++) {
        var c = img32[i];
        if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];else {
          var cmc = cmap[c];
          if (cmc == null) {
            cmap[c] = cmc = plte.length;
            plte.push(c);
            if (plte.length >= 300) break;
          }
          ind[i] = cmc;
        }
      }
    }
  }
  var cc = plte.length;
  if (cc <= 256 && forbidPlte == false) {
    if (cc <= 2) depth = 1;else if (cc <= 4) depth = 2;else if (cc <= 16) depth = 4;else depth = 8;
    depth = Math.max(depth, minBits);
  }
  for (var j = 0; j < frms.length; j++) {
    var frm = frms[j],
      nw = frm.rect.width,
      nh = frm.rect.height;
    var cimg = frm.img;
    var bpl = 4 * nw,
      bpp = 4;
    if (cc <= 256 && forbidPlte == false) {
      bpl = Math.ceil(depth * nw / 8);
      var nimg = new Uint8Array(bpl * nh);
      var inj = inds[j];
      for (var y = 0; y < nh; y++) {
        var i = y * bpl,
          ii = y * nw;
        if (depth == 8) for (var x = 0; x < nw; x++) nimg[i + x] = inj[ii + x];else if (depth == 4) for (var x = 0; x < nw; x++) nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;else if (depth == 2) for (var x = 0; x < nw; x++) nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;else if (depth == 1) for (var x = 0; x < nw; x++) nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
      }
      cimg = nimg;
      ctype = 3;
      bpp = 1;
    } else if (gotAlpha == false && frms.length == 1) {
      var nimg = new Uint8Array(nw * nh * 3),
        area = nw * nh;
      for (var i = 0; i < area; i++) {
        var ti = i * 3,
          qi = i * 4;
        nimg[ti] = cimg[qi];
        nimg[ti + 1] = cimg[qi + 1];
        nimg[ti + 2] = cimg[qi + 2];
      }
      cimg = nimg;
      ctype = 2;
      bpp = 3;
      bpl = 3 * nw;
    }
    frm.img = cimg;
    frm.bpl = bpl;
    frm.bpp = bpp;
  }
  return {
    ctype: ctype,
    depth: depth,
    plte: plte,
    frames: frms
  };
};
UPNG.encode.framize = function (bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
  var frms = [];
  for (var j = 0; j < bufs.length; j++) {
    var cimg = new Uint8Array(bufs[j]),
      cimg32 = new Uint32Array(cimg.buffer);
    var nimg;
    var nx = 0,
      ny = 0,
      nw = w,
      nh = h,
      blend = alwaysBlend ? 1 : 0;
    if (j != 0) {
      var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2,
        tstp = 0,
        tarea = 1e9;
      for (var it = 0; it < tlim; it++) {
        var pimg = new Uint8Array(bufs[j - 1 - it]),
          p32 = new Uint32Array(bufs[j - 1 - it]);
        var mix = w,
          miy = h,
          max = -1,
          may = -1;
        for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
          var i = y * w + x;
          if (cimg32[i] != p32[i]) {
            if (x < mix) mix = x;
            if (x > max) max = x;
            if (y < miy) miy = y;
            if (y > may) may = y;
          }
        }
        if (max == -1) mix = miy = max = may = 0;
        if (evenCrd) {
          if ((mix & 1) == 1) mix--;
          if ((miy & 1) == 1) miy--;
        }
        var sarea = (max - mix + 1) * (may - miy + 1);
        if (sarea < tarea) {
          tarea = sarea;
          tstp = it;
          nx = mix;
          ny = miy;
          nw = max - mix + 1;
          nh = may - miy + 1;
        }
      }
      var pimg = new Uint8Array(bufs[j - 1 - tstp]);
      if (tstp == 1) frms[j - 1].dispose = 2;
      nimg = new Uint8Array(nw * nh * 4);
      UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
      blend = UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
      if (blend == 1) UPNG.encode._prepareDiff(cimg, w, h, nimg, {
        x: nx,
        y: ny,
        width: nw,
        height: nh
      });else UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
    } else nimg = cimg.slice(0);
    frms.push({
      rect: {
        x: nx,
        y: ny,
        width: nw,
        height: nh
      },
      img: nimg,
      blend: blend,
      dispose: 0
    });
  }
  if (alwaysBlend) for (var j = 0; j < frms.length; j++) {
    var frm = frms[j];
    if (frm.blend == 1) continue;
    var r0 = frm.rect,
      r1 = frms[j - 1].rect;
    var miX = Math.min(r0.x, r1.x),
      miY = Math.min(r0.y, r1.y);
    var maX = Math.max(r0.x + r0.width, r1.x + r1.width),
      maY = Math.max(r0.y + r0.height, r1.y + r1.height);
    var r = {
      x: miX,
      y: miY,
      width: maX - miX,
      height: maY - miY
    };
    frms[j - 1].dispose = 1;
    if (j - 1 != 0) UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
    UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
  }
  if (bufs.length != 1) for (var i = 0; i < frms.length; i++) {
    var frm = frms[i];
  }
  return frms;
};
UPNG.encode._updateFrame = function (bufs, w, h, frms, i, r, evenCrd) {
  var U8 = Uint8Array,
    U32 = Uint32Array;
  var pimg = new U8(bufs[i - 1]),
    pimg32 = new U32(bufs[i - 1]),
    nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
  var cimg = new U8(bufs[i]),
    cimg32 = new U32(cimg.buffer);
  var mix = w,
    miy = h,
    max = -1,
    may = -1;
  for (var y = 0; y < r.height; y++) for (var x = 0; x < r.width; x++) {
    var cx = r.x + x,
      cy = r.y + y;
    var j = cy * w + cx,
      cc = cimg32[j];
    if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ; else {
      if (cx < mix) mix = cx;
      if (cx > max) max = cx;
      if (cy < miy) miy = cy;
      if (cy > may) may = cy;
    }
  }
  if (max == -1) mix = miy = max = may = 0;
  if (evenCrd) {
    if ((mix & 1) == 1) mix--;
    if ((miy & 1) == 1) miy--;
  }
  r = {
    x: mix,
    y: miy,
    width: max - mix + 1,
    height: may - miy + 1
  };
  var fr = frms[i];
  fr.rect = r;
  fr.blend = 1;
  fr.img = new Uint8Array(r.width * r.height * 4);
  if (frms[i - 1].dispose == 0) {
    UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
    UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
  } else UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
UPNG.encode._prepareDiff = function (cimg, w, h, nimg, rec) {
  UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
};
UPNG.encode._filterZero = function (img, h, bpp, bpl, data, filter, levelZero) {
  var fls = [],
    ftry = [0, 1, 2, 3, 4];
  if (filter != -1) ftry = [filter];else if (h * bpl > 500000 || bpp == 1) ftry = [0];
  var opts;
  if (levelZero) opts = {
    level: 0
  };
  var CMPR = levelZero && UZIP != null ? UZIP : pako_1;
  for (var i = 0; i < ftry.length; i++) {
    for (var y = 0; y < h; y++) UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
    fls.push(CMPR["deflate"](data, opts));
  }
  var ti,
    tsize = 1e9;
  for (var i = 0; i < fls.length; i++) if (fls[i].length < tsize) {
    ti = i;
    tsize = fls[i].length;
  }
  return fls[ti];
};
UPNG.encode._filterLine = function (data, img, y, bpl, bpp, type) {
  var i = y * bpl,
    di = i + y,
    paeth = UPNG.decode._paeth;
  data[di] = type;
  di++;
  if (type == 0) {
    if (bpl < 500) for (var x = 0; x < bpl; x++) data[di + x] = img[i + x];else data.set(new Uint8Array(img.buffer, i, bpl), di);
  } else if (type == 1) {
    for (var x = 0; x < bpp; x++) data[di + x] = img[i + x];
    for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
  } else if (y == 0) {
    for (var x = 0; x < bpp; x++) data[di + x] = img[i + x];
    if (type == 2) for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x];
    if (type == 3) for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
    if (type == 4) for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
  } else {
    if (type == 2) {
      for (var x = 0; x < bpl; x++) data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
    }
    if (type == 3) {
      for (var x = 0; x < bpp; x++) data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
      for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
    }
    if (type == 4) {
      for (var x = 0; x < bpp; x++) data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
      for (var x = bpp; x < bpl; x++) data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
    }
  }
};
UPNG.crc = {
  table: function () {
    var tab = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) {
        if (c & 1) c = 0xedb88320 ^ c >>> 1;else c = c >>> 1;
      }
      tab[n] = c;
    }
    return tab;
  }(),
  update: function (c, buf, off, len) {
    for (var i = 0; i < len; i++) c = UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
    return c;
  },
  crc: function (b, o, l) {
    return UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
  }
};
UPNG.quantize = function (abuf, ps) {
  var oimg = new Uint8Array(abuf),
    nimg = oimg.slice(0),
    nimg32 = new Uint32Array(nimg.buffer);
  var KD = UPNG.quantize.getKDtree(nimg, ps);
  var root = KD[0],
    leafs = KD[1];
  var sb = oimg,
    tb = nimg32,
    len = sb.length;
  var inds = new Uint8Array(oimg.length >> 2);
  for (var i = 0; i < len; i += 4) {
    var r = sb[i] * (1 / 255),
      g = sb[i + 1] * (1 / 255),
      b = sb[i + 2] * (1 / 255),
      a = sb[i + 3] * (1 / 255);
    var nd = UPNG.quantize.getNearest(root, r, g, b, a);
    inds[i >> 2] = nd.ind;
    tb[i >> 2] = nd.est.rgba;
  }
  return {
    abuf: nimg.buffer,
    inds: inds,
    plte: leafs
  };
};
UPNG.quantize.getKDtree = function (nimg, ps, err) {
  if (err == null) err = 0.0001;
  var nimg32 = new Uint32Array(nimg.buffer);
  var root = {
    i0: 0,
    i1: nimg.length,
    bst: null,
    est: null,
    tdst: 0,
    left: null,
    right: null
  };
  root.bst = UPNG.quantize.stats(nimg, root.i0, root.i1);
  root.est = UPNG.quantize.estats(root.bst);
  var leafs = [root];
  while (leafs.length < ps) {
    var maxL = 0,
      mi = 0;
    for (var i = 0; i < leafs.length; i++) if (leafs[i].est.L > maxL) {
      maxL = leafs[i].est.L;
      mi = i;
    }
    if (maxL < err) break;
    var node = leafs[mi];
    var s0 = UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
    var s0wrong = node.i0 >= s0 || node.i1 <= s0;
    if (s0wrong) {
      node.est.L = 0;
      continue;
    }
    var ln = {
      i0: node.i0,
      i1: s0,
      bst: null,
      est: null,
      tdst: 0,
      left: null,
      right: null
    };
    ln.bst = UPNG.quantize.stats(nimg, ln.i0, ln.i1);
    ln.est = UPNG.quantize.estats(ln.bst);
    var rn = {
      i0: s0,
      i1: node.i1,
      bst: null,
      est: null,
      tdst: 0,
      left: null,
      right: null
    };
    rn.bst = {
      R: [],
      m: [],
      N: node.bst.N - ln.bst.N
    };
    for (var i = 0; i < 16; i++) rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
    for (var i = 0; i < 4; i++) rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
    rn.est = UPNG.quantize.estats(rn.bst);
    node.left = ln;
    node.right = rn;
    leafs[mi] = ln;
    leafs.push(rn);
  }
  leafs.sort(function (a, b) {
    return b.bst.N - a.bst.N;
  });
  for (var i = 0; i < leafs.length; i++) leafs[i].ind = i;
  return [root, leafs];
};
UPNG.quantize.getNearest = function (nd, r, g, b, a) {
  if (nd.left == null) {
    nd.tdst = UPNG.quantize.dist(nd.est.q, r, g, b, a);
    return nd;
  }
  var planeDst = UPNG.quantize.planeDst(nd.est, r, g, b, a);
  var node0 = nd.left,
    node1 = nd.right;
  if (planeDst > 0) {
    node0 = nd.right;
    node1 = nd.left;
  }
  var ln = UPNG.quantize.getNearest(node0, r, g, b, a);
  if (ln.tdst <= planeDst * planeDst) return ln;
  var rn = UPNG.quantize.getNearest(node1, r, g, b, a);
  return rn.tdst < ln.tdst ? rn : ln;
};
UPNG.quantize.planeDst = function (est, r, g, b, a) {
  var e = est.e;
  return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
UPNG.quantize.dist = function (q, r, g, b, a) {
  var d0 = r - q[0],
    d1 = g - q[1],
    d2 = b - q[2],
    d3 = a - q[3];
  return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
UPNG.quantize.splitPixels = function (nimg, nimg32, i0, i1, e, eMq) {
  var vecDot = UPNG.quantize.vecDot;
  i1 -= 4;
  while (i0 < i1) {
    while (vecDot(nimg, i0, e) <= eMq) i0 += 4;
    while (vecDot(nimg, i1, e) > eMq) i1 -= 4;
    if (i0 >= i1) break;
    var t = nimg32[i0 >> 2];
    nimg32[i0 >> 2] = nimg32[i1 >> 2];
    nimg32[i1 >> 2] = t;
    i0 += 4;
    i1 -= 4;
  }
  while (vecDot(nimg, i0, e) > eMq) i0 -= 4;
  return i0 + 4;
};
UPNG.quantize.vecDot = function (nimg, i, e) {
  return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
UPNG.quantize.stats = function (nimg, i0, i1) {
  var R = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  var m = [0, 0, 0, 0];
  var N = i1 - i0 >> 2;
  for (var i = i0; i < i1; i += 4) {
    var r = nimg[i] * (1 / 255),
      g = nimg[i + 1] * (1 / 255),
      b = nimg[i + 2] * (1 / 255),
      a = nimg[i + 3] * (1 / 255);
    m[0] += r;
    m[1] += g;
    m[2] += b;
    m[3] += a;
    R[0] += r * r;
    R[1] += r * g;
    R[2] += r * b;
    R[3] += r * a;
    R[5] += g * g;
    R[6] += g * b;
    R[7] += g * a;
    R[10] += b * b;
    R[11] += b * a;
    R[15] += a * a;
  }
  R[4] = R[1];
  R[8] = R[2];
  R[9] = R[6];
  R[12] = R[3];
  R[13] = R[7];
  R[14] = R[11];
  return {
    R: R,
    m: m,
    N: N
  };
};
UPNG.quantize.estats = function (stats) {
  var R = stats.R,
    m = stats.m,
    N = stats.N;
  var m0 = m[0],
    m1 = m[1],
    m2 = m[2],
    m3 = m[3],
    iN = N == 0 ? 0 : 1 / N;
  var Rj = [R[0] - m0 * m0 * iN, R[1] - m0 * m1 * iN, R[2] - m0 * m2 * iN, R[3] - m0 * m3 * iN, R[4] - m1 * m0 * iN, R[5] - m1 * m1 * iN, R[6] - m1 * m2 * iN, R[7] - m1 * m3 * iN, R[8] - m2 * m0 * iN, R[9] - m2 * m1 * iN, R[10] - m2 * m2 * iN, R[11] - m2 * m3 * iN, R[12] - m3 * m0 * iN, R[13] - m3 * m1 * iN, R[14] - m3 * m2 * iN, R[15] - m3 * m3 * iN];
  var A = Rj,
    M = UPNG.M4;
  var b = [0.5, 0.5, 0.5, 0.5],
    mi = 0,
    tmi = 0;
  if (N != 0) for (var i = 0; i < 10; i++) {
    b = M.multVec(A, b);
    tmi = Math.sqrt(M.dot(b, b));
    b = M.sml(1 / tmi, b);
    if (Math.abs(tmi - mi) < 1e-9) break;
    mi = tmi;
  }
  var q = [m0 * iN, m1 * iN, m2 * iN, m3 * iN];
  var eMq255 = M.dot(M.sml(255, q), b);
  return {
    Cov: Rj,
    q: q,
    e: b,
    L: mi,
    eMq255: eMq255,
    eMq: M.dot(b, q),
    rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
  };
};
UPNG.M4 = {
  multVec: function (m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3], m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3], m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3], m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]];
  },
  dot: function (x, y) {
    return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
  },
  sml: function (a, y) {
    return [a * y[0], a * y[1], a * y[2], a * y[3]];
  }
};
UPNG.encode.concatRGBA = function (bufs) {
  var tlen = 0;
  for (var i = 0; i < bufs.length; i++) tlen += bufs[i].byteLength;
  var nimg = new Uint8Array(tlen),
    noff = 0;
  for (var i = 0; i < bufs.length; i++) {
    var img = new Uint8Array(bufs[i]),
      il = img.length;
    for (var j = 0; j < il; j += 4) {
      var r = img[j],
        g = img[j + 1],
        b = img[j + 2],
        a = img[j + 3];
      if (a == 0) r = g = b = 0;
      nimg[noff + j] = r;
      nimg[noff + j + 1] = g;
      nimg[noff + j + 2] = b;
      nimg[noff + j + 3] = a;
    }
    noff += il;
  }
  return nimg.buffer;
};

var getImageType = function (ctype) {
  if (ctype === 0) return PngType.Greyscale;
  if (ctype === 2) return PngType.Truecolour;
  if (ctype === 3) return PngType.IndexedColour;
  if (ctype === 4) return PngType.GreyscaleWithAlpha;
  if (ctype === 6) return PngType.TruecolourWithAlpha;
  throw new Error("Unknown color type: " + ctype);
};
var splitAlphaChannel = function (rgbaChannel) {
  var pixelCount = Math.floor(rgbaChannel.length / 4);
  var rgbChannel = new Uint8Array(pixelCount * 3);
  var alphaChannel = new Uint8Array(pixelCount * 1);
  var rgbaOffset = 0;
  var rgbOffset = 0;
  var alphaOffset = 0;
  while (rgbaOffset < rgbaChannel.length) {
    rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
    rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
    rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
    alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
  }
  return {
    rgbChannel: rgbChannel,
    alphaChannel: alphaChannel
  };
};
var PngType;
(function (PngType) {
  PngType["Greyscale"] = "Greyscale";
  PngType["Truecolour"] = "Truecolour";
  PngType["IndexedColour"] = "IndexedColour";
  PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
  PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})(PngType || (PngType = {}));
var PNG = function () {
  function PNG(pngData) {
    var upng = UPNG.decode(pngData);
    var frames = UPNG.toRGBA8(upng);
    if (frames.length > 1) throw new Error("Animated PNGs are not supported");
    var frame = new Uint8Array(frames[0]);
    var _a = splitAlphaChannel(frame),
      rgbChannel = _a.rgbChannel,
      alphaChannel = _a.alphaChannel;
    this.rgbChannel = rgbChannel;
    var hasAlphaValues = alphaChannel.some(function (a) {
      return a < 255;
    });
    if (hasAlphaValues) this.alphaChannel = alphaChannel;
    this.type = getImageType(upng.ctype);
    this.width = upng.width;
    this.height = upng.height;
    this.bitsPerComponent = 8;
  }
  PNG.load = function (pngData) {
    return new PNG(pngData);
  };
  return PNG;
}();

var PngEmbedder = function () {
  function PngEmbedder(png) {
    this.image = png;
    this.bitsPerComponent = png.bitsPerComponent;
    this.width = png.width;
    this.height = png.height;
    this.colorSpace = 'DeviceRGB';
  }
  PngEmbedder.for = function (imageData) {
    return __awaiter(this, void 0, void 0, function () {
      var png;
      return __generator(this, function (_a) {
        png = PNG.load(imageData);
        return [2, new PngEmbedder(png)];
      });
    });
  };
  PngEmbedder.prototype.embedIntoContext = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var SMask, xObject;
      return __generator(this, function (_a) {
        SMask = this.embedAlphaChannel(context);
        xObject = context.flateStream(this.image.rgbChannel, {
          Type: 'XObject',
          Subtype: 'Image',
          BitsPerComponent: this.image.bitsPerComponent,
          Width: this.image.width,
          Height: this.image.height,
          ColorSpace: this.colorSpace,
          SMask: SMask
        });
        if (ref) {
          context.assign(ref, xObject);
          return [2, ref];
        } else {
          return [2, context.register(xObject)];
        }
      });
    });
  };
  PngEmbedder.prototype.embedAlphaChannel = function (context) {
    if (!this.image.alphaChannel) return undefined;
    var xObject = context.flateStream(this.image.alphaChannel, {
      Type: 'XObject',
      Subtype: 'Image',
      Height: this.image.height,
      Width: this.image.width,
      BitsPerComponent: this.image.bitsPerComponent,
      ColorSpace: 'DeviceGray',
      Decode: [0, 1]
    });
    return context.register(xObject);
  };
  return PngEmbedder;
}();

var Stream = function () {
  function Stream(buffer, start, length) {
    this.bytes = buffer;
    this.start = start || 0;
    this.pos = this.start;
    this.end = !!start && !!length ? start + length : this.bytes.length;
  }
  Object.defineProperty(Stream.prototype, "length", {
    get: function () {
      return this.end - this.start;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Stream.prototype, "isEmpty", {
    get: function () {
      return this.length === 0;
    },
    enumerable: false,
    configurable: true
  });
  Stream.prototype.getByte = function () {
    if (this.pos >= this.end) {
      return -1;
    }
    return this.bytes[this.pos++];
  };
  Stream.prototype.getUint16 = function () {
    var b0 = this.getByte();
    var b1 = this.getByte();
    if (b0 === -1 || b1 === -1) {
      return -1;
    }
    return (b0 << 8) + b1;
  };
  Stream.prototype.getInt32 = function () {
    var b0 = this.getByte();
    var b1 = this.getByte();
    var b2 = this.getByte();
    var b3 = this.getByte();
    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
  };
  Stream.prototype.getBytes = function (length, forceClamped) {
    if (forceClamped === void 0) {
      forceClamped = false;
    }
    var bytes = this.bytes;
    var pos = this.pos;
    var strEnd = this.end;
    if (!length) {
      var subarray = bytes.subarray(pos, strEnd);
      return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
    } else {
      var end = pos + length;
      if (end > strEnd) {
        end = strEnd;
      }
      this.pos = end;
      var subarray = bytes.subarray(pos, end);
      return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
    }
  };
  Stream.prototype.peekByte = function () {
    var peekedByte = this.getByte();
    this.pos--;
    return peekedByte;
  };
  Stream.prototype.peekBytes = function (length, forceClamped) {
    if (forceClamped === void 0) {
      forceClamped = false;
    }
    var bytes = this.getBytes(length, forceClamped);
    this.pos -= bytes.length;
    return bytes;
  };
  Stream.prototype.skip = function (n) {
    if (!n) {
      n = 1;
    }
    this.pos += n;
  };
  Stream.prototype.reset = function () {
    this.pos = this.start;
  };
  Stream.prototype.moveStart = function () {
    this.start = this.pos;
  };
  Stream.prototype.makeSubStream = function (start, length) {
    return new Stream(this.bytes, start, length);
  };
  Stream.prototype.decode = function () {
    return this.bytes;
  };
  return Stream;
}();

var emptyBuffer = new Uint8Array(0);
var DecodeStream = function () {
  function DecodeStream(maybeMinBufferLength) {
    this.pos = 0;
    this.bufferLength = 0;
    this.eof = false;
    this.buffer = emptyBuffer;
    this.minBufferLength = 512;
    if (maybeMinBufferLength) {
      while (this.minBufferLength < maybeMinBufferLength) {
        this.minBufferLength *= 2;
      }
    }
  }
  Object.defineProperty(DecodeStream.prototype, "isEmpty", {
    get: function () {
      while (!this.eof && this.bufferLength === 0) {
        this.readBlock();
      }
      return this.bufferLength === 0;
    },
    enumerable: false,
    configurable: true
  });
  DecodeStream.prototype.getByte = function () {
    var pos = this.pos;
    while (this.bufferLength <= pos) {
      if (this.eof) {
        return -1;
      }
      this.readBlock();
    }
    return this.buffer[this.pos++];
  };
  DecodeStream.prototype.getUint16 = function () {
    var b0 = this.getByte();
    var b1 = this.getByte();
    if (b0 === -1 || b1 === -1) {
      return -1;
    }
    return (b0 << 8) + b1;
  };
  DecodeStream.prototype.getInt32 = function () {
    var b0 = this.getByte();
    var b1 = this.getByte();
    var b2 = this.getByte();
    var b3 = this.getByte();
    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
  };
  DecodeStream.prototype.getBytes = function (length, forceClamped) {
    if (forceClamped === void 0) {
      forceClamped = false;
    }
    var end;
    var pos = this.pos;
    if (length) {
      this.ensureBuffer(pos + length);
      end = pos + length;
      while (!this.eof && this.bufferLength < end) {
        this.readBlock();
      }
      var bufEnd = this.bufferLength;
      if (end > bufEnd) {
        end = bufEnd;
      }
    } else {
      while (!this.eof) {
        this.readBlock();
      }
      end = this.bufferLength;
    }
    this.pos = end;
    var subarray = this.buffer.subarray(pos, end);
    return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
  };
  DecodeStream.prototype.peekByte = function () {
    var peekedByte = this.getByte();
    this.pos--;
    return peekedByte;
  };
  DecodeStream.prototype.peekBytes = function (length, forceClamped) {
    if (forceClamped === void 0) {
      forceClamped = false;
    }
    var bytes = this.getBytes(length, forceClamped);
    this.pos -= bytes.length;
    return bytes;
  };
  DecodeStream.prototype.skip = function (n) {
    if (!n) {
      n = 1;
    }
    this.pos += n;
  };
  DecodeStream.prototype.reset = function () {
    this.pos = 0;
  };
  DecodeStream.prototype.makeSubStream = function (start, length) {
    var end = start + length;
    while (this.bufferLength <= end && !this.eof) {
      this.readBlock();
    }
    return new Stream(this.buffer, start, length);
  };
  DecodeStream.prototype.decode = function () {
    while (!this.eof) this.readBlock();
    return this.buffer.subarray(0, this.bufferLength);
  };
  DecodeStream.prototype.readBlock = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'readBlock');
  };
  DecodeStream.prototype.ensureBuffer = function (requested) {
    var buffer = this.buffer;
    if (requested <= buffer.byteLength) {
      return buffer;
    }
    var size = this.minBufferLength;
    while (size < requested) {
      size *= 2;
    }
    var buffer2 = new Uint8Array(size);
    buffer2.set(buffer);
    return this.buffer = buffer2;
  };
  return DecodeStream;
}();

var isSpace = function (ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var Ascii85Stream = function (_super) {
  __extends(Ascii85Stream, _super);
  function Ascii85Stream(stream, maybeLength) {
    var _this = _super.call(this, maybeLength) || this;
    _this.stream = stream;
    _this.input = new Uint8Array(5);
    if (maybeLength) {
      maybeLength = 0.8 * maybeLength;
    }
    return _this;
  }
  Ascii85Stream.prototype.readBlock = function () {
    var TILDA_CHAR = 0x7e;
    var Z_LOWER_CHAR = 0x7a;
    var EOF = -1;
    var stream = this.stream;
    var c = stream.getByte();
    while (isSpace(c)) {
      c = stream.getByte();
    }
    if (c === EOF || c === TILDA_CHAR) {
      this.eof = true;
      return;
    }
    var bufferLength = this.bufferLength;
    var buffer;
    var i;
    if (c === Z_LOWER_CHAR) {
      buffer = this.ensureBuffer(bufferLength + 4);
      for (i = 0; i < 4; ++i) {
        buffer[bufferLength + i] = 0;
      }
      this.bufferLength += 4;
    } else {
      var input = this.input;
      input[0] = c;
      for (i = 1; i < 5; ++i) {
        c = stream.getByte();
        while (isSpace(c)) {
          c = stream.getByte();
        }
        input[i] = c;
        if (c === EOF || c === TILDA_CHAR) {
          break;
        }
      }
      buffer = this.ensureBuffer(bufferLength + i - 1);
      this.bufferLength += i - 1;
      if (i < 5) {
        for (; i < 5; ++i) {
          input[i] = 0x21 + 84;
        }
        this.eof = true;
      }
      var t = 0;
      for (i = 0; i < 5; ++i) {
        t = t * 85 + (input[i] - 0x21);
      }
      for (i = 3; i >= 0; --i) {
        buffer[bufferLength + i] = t & 0xff;
        t >>= 8;
      }
    }
  };
  return Ascii85Stream;
}(DecodeStream);

var AsciiHexStream = function (_super) {
  __extends(AsciiHexStream, _super);
  function AsciiHexStream(stream, maybeLength) {
    var _this = _super.call(this, maybeLength) || this;
    _this.stream = stream;
    _this.firstDigit = -1;
    if (maybeLength) {
      maybeLength = 0.5 * maybeLength;
    }
    return _this;
  }
  AsciiHexStream.prototype.readBlock = function () {
    var UPSTREAM_BLOCK_SIZE = 8000;
    var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
    if (!bytes.length) {
      this.eof = true;
      return;
    }
    var maxDecodeLength = bytes.length + 1 >> 1;
    var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
    var bufferLength = this.bufferLength;
    var firstDigit = this.firstDigit;
    for (var i = 0, ii = bytes.length; i < ii; i++) {
      var ch = bytes[i];
      var digit = void 0;
      if (ch >= 0x30 && ch <= 0x39) {
        digit = ch & 0x0f;
      } else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
        digit = (ch & 0x0f) + 9;
      } else if (ch === 0x3e) {
        this.eof = true;
        break;
      } else {
        continue;
      }
      if (firstDigit < 0) {
        firstDigit = digit;
      } else {
        buffer[bufferLength++] = firstDigit << 4 | digit;
        firstDigit = -1;
      }
    }
    if (firstDigit >= 0 && this.eof) {
      buffer[bufferLength++] = firstDigit << 4;
      firstDigit = -1;
    }
    this.firstDigit = firstDigit;
    this.bufferLength = bufferLength;
  };
  return AsciiHexStream;
}(DecodeStream);

var codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var lengthDecode = new Int32Array([0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a, 0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f, 0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073, 0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102]);
var distDecode = new Int32Array([0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d, 0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1, 0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01, 0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001]);
var fixedLitCodeTab = [new Int32Array([0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0, 0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0, 0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0, 0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8, 0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8, 0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8, 0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4, 0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4, 0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4, 0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc, 0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec, 0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc, 0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2, 0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2, 0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2, 0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca, 0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea, 0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da, 0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6, 0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6, 0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6, 0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce, 0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee, 0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de, 0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe, 0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1, 0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1, 0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1, 0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9, 0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9, 0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9, 0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5, 0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5, 0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5, 0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd, 0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed, 0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd, 0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3, 0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3, 0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3, 0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb, 0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb, 0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db, 0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7, 0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7, 0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7, 0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf, 0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef, 0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df, 0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff]), 9];
var fixedDistCodeTab = [new Int32Array([0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c, 0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000, 0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d, 0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000]), 5];
var FlateStream = function (_super) {
  __extends(FlateStream, _super);
  function FlateStream(stream, maybeLength) {
    var _this = _super.call(this, maybeLength) || this;
    _this.stream = stream;
    var cmf = stream.getByte();
    var flg = stream.getByte();
    if (cmf === -1 || flg === -1) {
      throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
    }
    if ((cmf & 0x0f) !== 0x08) {
      throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
    }
    if (((cmf << 8) + flg) % 31 !== 0) {
      throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
    }
    if (flg & 0x20) {
      throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
    }
    _this.codeSize = 0;
    _this.codeBuf = 0;
    return _this;
  }
  FlateStream.prototype.readBlock = function () {
    var buffer;
    var len;
    var str = this.stream;
    var hdr = this.getBits(3);
    if (hdr & 1) {
      this.eof = true;
    }
    hdr >>= 1;
    if (hdr === 0) {
      var b = void 0;
      if ((b = str.getByte()) === -1) {
        throw new Error('Bad block header in flate stream');
      }
      var blockLen = b;
      if ((b = str.getByte()) === -1) {
        throw new Error('Bad block header in flate stream');
      }
      blockLen |= b << 8;
      if ((b = str.getByte()) === -1) {
        throw new Error('Bad block header in flate stream');
      }
      var check = b;
      if ((b = str.getByte()) === -1) {
        throw new Error('Bad block header in flate stream');
      }
      check |= b << 8;
      if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) {
        throw new Error('Bad uncompressed block length in flate stream');
      }
      this.codeBuf = 0;
      this.codeSize = 0;
      var bufferLength = this.bufferLength;
      buffer = this.ensureBuffer(bufferLength + blockLen);
      var end = bufferLength + blockLen;
      this.bufferLength = end;
      if (blockLen === 0) {
        if (str.peekByte() === -1) {
          this.eof = true;
        }
      } else {
        for (var n = bufferLength; n < end; ++n) {
          if ((b = str.getByte()) === -1) {
            this.eof = true;
            break;
          }
          buffer[n] = b;
        }
      }
      return;
    }
    var litCodeTable;
    var distCodeTable;
    if (hdr === 1) {
      litCodeTable = fixedLitCodeTab;
      distCodeTable = fixedDistCodeTab;
    } else if (hdr === 2) {
      var numLitCodes = this.getBits(5) + 257;
      var numDistCodes = this.getBits(5) + 1;
      var numCodeLenCodes = this.getBits(4) + 4;
      var codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
      var i = void 0;
      for (i = 0; i < numCodeLenCodes; ++i) {
        codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
      }
      var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
      len = 0;
      i = 0;
      var codes = numLitCodes + numDistCodes;
      var codeLengths = new Uint8Array(codes);
      var bitsLength = void 0;
      var bitsOffset = void 0;
      var what = void 0;
      while (i < codes) {
        var code = this.getCode(codeLenCodeTab);
        if (code === 16) {
          bitsLength = 2;
          bitsOffset = 3;
          what = len;
        } else if (code === 17) {
          bitsLength = 3;
          bitsOffset = 3;
          what = len = 0;
        } else if (code === 18) {
          bitsLength = 7;
          bitsOffset = 11;
          what = len = 0;
        } else {
          codeLengths[i++] = len = code;
          continue;
        }
        var repeatLength = this.getBits(bitsLength) + bitsOffset;
        while (repeatLength-- > 0) {
          codeLengths[i++] = what;
        }
      }
      litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
      distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
    } else {
      throw new Error('Unknown block type in flate stream');
    }
    buffer = this.buffer;
    var limit = buffer ? buffer.length : 0;
    var pos = this.bufferLength;
    while (true) {
      var code1 = this.getCode(litCodeTable);
      if (code1 < 256) {
        if (pos + 1 >= limit) {
          buffer = this.ensureBuffer(pos + 1);
          limit = buffer.length;
        }
        buffer[pos++] = code1;
        continue;
      }
      if (code1 === 256) {
        this.bufferLength = pos;
        return;
      }
      code1 -= 257;
      code1 = lengthDecode[code1];
      var code2 = code1 >> 16;
      if (code2 > 0) {
        code2 = this.getBits(code2);
      }
      len = (code1 & 0xffff) + code2;
      code1 = this.getCode(distCodeTable);
      code1 = distDecode[code1];
      code2 = code1 >> 16;
      if (code2 > 0) {
        code2 = this.getBits(code2);
      }
      var dist = (code1 & 0xffff) + code2;
      if (pos + len >= limit) {
        buffer = this.ensureBuffer(pos + len);
        limit = buffer.length;
      }
      for (var k = 0; k < len; ++k, ++pos) {
        buffer[pos] = buffer[pos - dist];
      }
    }
  };
  FlateStream.prototype.getBits = function (bits) {
    var str = this.stream;
    var codeSize = this.codeSize;
    var codeBuf = this.codeBuf;
    var b;
    while (codeSize < bits) {
      if ((b = str.getByte()) === -1) {
        throw new Error('Bad encoding in flate stream');
      }
      codeBuf |= b << codeSize;
      codeSize += 8;
    }
    b = codeBuf & (1 << bits) - 1;
    this.codeBuf = codeBuf >> bits;
    this.codeSize = codeSize -= bits;
    return b;
  };
  FlateStream.prototype.getCode = function (table) {
    var str = this.stream;
    var codes = table[0];
    var maxLen = table[1];
    var codeSize = this.codeSize;
    var codeBuf = this.codeBuf;
    var b;
    while (codeSize < maxLen) {
      if ((b = str.getByte()) === -1) {
        break;
      }
      codeBuf |= b << codeSize;
      codeSize += 8;
    }
    var code = codes[codeBuf & (1 << maxLen) - 1];
    if (typeof codes === 'number') {
      console.log('FLATE:', code);
    }
    var codeLen = code >> 16;
    var codeVal = code & 0xffff;
    if (codeLen < 1 || codeSize < codeLen) {
      throw new Error('Bad encoding in flate stream');
    }
    this.codeBuf = codeBuf >> codeLen;
    this.codeSize = codeSize - codeLen;
    return codeVal;
  };
  FlateStream.prototype.generateHuffmanTable = function (lengths) {
    var n = lengths.length;
    var maxLen = 0;
    var i;
    for (i = 0; i < n; ++i) {
      if (lengths[i] > maxLen) {
        maxLen = lengths[i];
      }
    }
    var size = 1 << maxLen;
    var codes = new Int32Array(size);
    for (var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1) {
      for (var val = 0; val < n; ++val) {
        if (lengths[val] === len) {
          var code2 = 0;
          var t = code;
          for (i = 0; i < len; ++i) {
            code2 = code2 << 1 | t & 1;
            t >>= 1;
          }
          for (i = code2; i < size; i += skip) {
            codes[i] = len << 16 | val;
          }
          ++code;
        }
      }
    }
    return [codes, maxLen];
  };
  return FlateStream;
}(DecodeStream);

var LZWStream = function (_super) {
  __extends(LZWStream, _super);
  function LZWStream(stream, maybeLength, earlyChange) {
    var _this = _super.call(this, maybeLength) || this;
    _this.stream = stream;
    _this.cachedData = 0;
    _this.bitsCached = 0;
    var maxLzwDictionarySize = 4096;
    var lzwState = {
      earlyChange: earlyChange,
      codeLength: 9,
      nextCode: 258,
      dictionaryValues: new Uint8Array(maxLzwDictionarySize),
      dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
      dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
      currentSequence: new Uint8Array(maxLzwDictionarySize),
      currentSequenceLength: 0
    };
    for (var i = 0; i < 256; ++i) {
      lzwState.dictionaryValues[i] = i;
      lzwState.dictionaryLengths[i] = 1;
    }
    _this.lzwState = lzwState;
    return _this;
  }
  LZWStream.prototype.readBlock = function () {
    var blockSize = 512;
    var estimatedDecodedSize = blockSize * 2;
    var decodedSizeDelta = blockSize;
    var i;
    var j;
    var q;
    var lzwState = this.lzwState;
    if (!lzwState) {
      return;
    }
    var earlyChange = lzwState.earlyChange;
    var nextCode = lzwState.nextCode;
    var dictionaryValues = lzwState.dictionaryValues;
    var dictionaryLengths = lzwState.dictionaryLengths;
    var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
    var codeLength = lzwState.codeLength;
    var prevCode = lzwState.prevCode;
    var currentSequence = lzwState.currentSequence;
    var currentSequenceLength = lzwState.currentSequenceLength;
    var decodedLength = 0;
    var currentBufferLength = this.bufferLength;
    var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
    for (i = 0; i < blockSize; i++) {
      var code = this.readBits(codeLength);
      var hasPrev = currentSequenceLength > 0;
      if (!code || code < 256) {
        currentSequence[0] = code;
        currentSequenceLength = 1;
      } else if (code >= 258) {
        if (code < nextCode) {
          currentSequenceLength = dictionaryLengths[code];
          for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
            currentSequence[j] = dictionaryValues[q];
            q = dictionaryPrevCodes[q];
          }
        } else {
          currentSequence[currentSequenceLength++] = currentSequence[0];
        }
      } else if (code === 256) {
        codeLength = 9;
        nextCode = 258;
        currentSequenceLength = 0;
        continue;
      } else {
        this.eof = true;
        delete this.lzwState;
        break;
      }
      if (hasPrev) {
        dictionaryPrevCodes[nextCode] = prevCode;
        dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
        dictionaryValues[nextCode] = currentSequence[0];
        nextCode++;
        codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
      }
      prevCode = code;
      decodedLength += currentSequenceLength;
      if (estimatedDecodedSize < decodedLength) {
        do {
          estimatedDecodedSize += decodedSizeDelta;
        } while (estimatedDecodedSize < decodedLength);
        buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
      }
      for (j = 0; j < currentSequenceLength; j++) {
        buffer[currentBufferLength++] = currentSequence[j];
      }
    }
    lzwState.nextCode = nextCode;
    lzwState.codeLength = codeLength;
    lzwState.prevCode = prevCode;
    lzwState.currentSequenceLength = currentSequenceLength;
    this.bufferLength = currentBufferLength;
  };
  LZWStream.prototype.readBits = function (n) {
    var bitsCached = this.bitsCached;
    var cachedData = this.cachedData;
    while (bitsCached < n) {
      var c = this.stream.getByte();
      if (c === -1) {
        this.eof = true;
        return null;
      }
      cachedData = cachedData << 8 | c;
      bitsCached += 8;
    }
    this.bitsCached = bitsCached -= n;
    this.cachedData = cachedData;
    return cachedData >>> bitsCached & (1 << n) - 1;
  };
  return LZWStream;
}(DecodeStream);

var RunLengthStream = function (_super) {
  __extends(RunLengthStream, _super);
  function RunLengthStream(stream, maybeLength) {
    var _this = _super.call(this, maybeLength) || this;
    _this.stream = stream;
    return _this;
  }
  RunLengthStream.prototype.readBlock = function () {
    var repeatHeader = this.stream.getBytes(2);
    if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
      this.eof = true;
      return;
    }
    var buffer;
    var bufferLength = this.bufferLength;
    var n = repeatHeader[0];
    if (n < 128) {
      buffer = this.ensureBuffer(bufferLength + n + 1);
      buffer[bufferLength++] = repeatHeader[1];
      if (n > 0) {
        var source = this.stream.getBytes(n);
        buffer.set(source, bufferLength);
        bufferLength += n;
      }
    } else {
      n = 257 - n;
      var b = repeatHeader[1];
      buffer = this.ensureBuffer(bufferLength + n + 1);
      for (var i = 0; i < n; i++) {
        buffer[bufferLength++] = b;
      }
    }
    this.bufferLength = bufferLength;
  };
  return RunLengthStream;
}(DecodeStream);

var decodeStream = function (stream, encoding, params) {
  if (encoding === PDFName.of('FlateDecode')) {
    return new FlateStream(stream);
  }
  if (encoding === PDFName.of('LZWDecode')) {
    var earlyChange = 1;
    if (params instanceof PDFDict) {
      var EarlyChange = params.lookup(PDFName.of('EarlyChange'));
      if (EarlyChange instanceof PDFNumber) {
        earlyChange = EarlyChange.asNumber();
      }
    }
    return new LZWStream(stream, undefined, earlyChange);
  }
  if (encoding === PDFName.of('ASCII85Decode')) {
    return new Ascii85Stream(stream);
  }
  if (encoding === PDFName.of('ASCIIHexDecode')) {
    return new AsciiHexStream(stream);
  }
  if (encoding === PDFName.of('RunLengthDecode')) {
    return new RunLengthStream(stream);
  }
  throw new UnsupportedEncodingError(encoding.asString());
};
var decodePDFRawStream = function (_a) {
  var dict = _a.dict,
    contents = _a.contents;
  var stream = new Stream(contents);
  var Filter = dict.lookup(PDFName.of('Filter'));
  var DecodeParms = dict.lookup(PDFName.of('DecodeParms'));
  if (Filter instanceof PDFName) {
    stream = decodeStream(stream, Filter, DecodeParms);
  } else if (Filter instanceof PDFArray) {
    for (var idx = 0, len = Filter.size(); idx < len; idx++) {
      stream = decodeStream(stream, Filter.lookup(idx, PDFName), DecodeParms && DecodeParms.lookupMaybe(idx, PDFDict));
    }
  } else if (!!Filter) {
    throw new UnexpectedObjectTypeError([PDFName, PDFArray], Filter);
  }
  return stream;
};

var fullPageBoundingBox = function (page) {
  var mediaBox = page.MediaBox();
  var width = mediaBox.lookup(2, PDFNumber).asNumber() - mediaBox.lookup(0, PDFNumber).asNumber();
  var height = mediaBox.lookup(3, PDFNumber).asNumber() - mediaBox.lookup(1, PDFNumber).asNumber();
  return {
    left: 0,
    bottom: 0,
    right: width,
    top: height
  };
};
var boundingBoxAdjustedMatrix = function (bb) {
  return [1, 0, 0, 1, -bb.left, -bb.bottom];
};
var PDFPageEmbedder = function () {
  function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
    this.page = page;
    var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : fullPageBoundingBox(page);
    this.width = bb.right - bb.left;
    this.height = bb.top - bb.bottom;
    this.boundingBox = bb;
    this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : boundingBoxAdjustedMatrix(bb);
  }
  PDFPageEmbedder.for = function (page, boundingBox, transformationMatrix) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, new PDFPageEmbedder(page, boundingBox, transformationMatrix)];
      });
    });
  };
  PDFPageEmbedder.prototype.embedIntoContext = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
      return __generator(this, function (_c) {
        _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
        if (!Contents) throw new MissingPageContentsEmbeddingError();
        decodedContents = this.decodeContents(Contents);
        _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
        xObject = context.flateStream(decodedContents, {
          Type: 'XObject',
          Subtype: 'Form',
          FormType: 1,
          BBox: [left, bottom, right, top],
          Matrix: this.transformationMatrix,
          Resources: Resources
        });
        if (ref) {
          context.assign(ref, xObject);
          return [2, ref];
        } else {
          return [2, context.register(xObject)];
        }
      });
    });
  };
  PDFPageEmbedder.prototype.decodeContents = function (contents) {
    var newline = Uint8Array.of(CharCodes$1.Newline);
    var decodedContents = [];
    for (var idx = 0, len = contents.size(); idx < len; idx++) {
      var stream = contents.lookup(idx, PDFStream);
      var content = void 0;
      if (stream instanceof PDFRawStream) {
        content = decodePDFRawStream(stream).decode();
      } else if (stream instanceof PDFContentStream) {
        content = stream.getUnencodedContents();
      } else {
        throw new UnrecognizedStreamTypeError(stream);
      }
      decodedContents.push(content, newline);
    }
    return mergeIntoTypedArray.apply(void 0, decodedContents);
  };
  return PDFPageEmbedder;
}();

var asEnum = function (rawValue, enumType) {
  if (rawValue === undefined) return undefined;
  return enumType[rawValue];
};
var NonFullScreenPageMode;
(function (NonFullScreenPageMode) {
  NonFullScreenPageMode["UseNone"] = "UseNone";
  NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
  NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
  NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function (ReadingDirection) {
  ReadingDirection["L2R"] = "L2R";
  ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function (PrintScaling) {
  PrintScaling["None"] = "None";
  PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function (Duplex) {
  Duplex["Simplex"] = "Simplex";
  Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
  Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = function () {
  function ViewerPreferences(dict) {
    this.dict = dict;
  }
  ViewerPreferences.prototype.lookupBool = function (key) {
    var returnObj = this.dict.lookup(PDFName.of(key));
    if (returnObj instanceof PDFBool) return returnObj;
    return undefined;
  };
  ViewerPreferences.prototype.lookupName = function (key) {
    var returnObj = this.dict.lookup(PDFName.of(key));
    if (returnObj instanceof PDFName) return returnObj;
    return undefined;
  };
  ViewerPreferences.prototype.HideToolbar = function () {
    return this.lookupBool('HideToolbar');
  };
  ViewerPreferences.prototype.HideMenubar = function () {
    return this.lookupBool('HideMenubar');
  };
  ViewerPreferences.prototype.HideWindowUI = function () {
    return this.lookupBool('HideWindowUI');
  };
  ViewerPreferences.prototype.FitWindow = function () {
    return this.lookupBool('FitWindow');
  };
  ViewerPreferences.prototype.CenterWindow = function () {
    return this.lookupBool('CenterWindow');
  };
  ViewerPreferences.prototype.DisplayDocTitle = function () {
    return this.lookupBool('DisplayDocTitle');
  };
  ViewerPreferences.prototype.NonFullScreenPageMode = function () {
    return this.lookupName('NonFullScreenPageMode');
  };
  ViewerPreferences.prototype.Direction = function () {
    return this.lookupName('Direction');
  };
  ViewerPreferences.prototype.PrintScaling = function () {
    return this.lookupName('PrintScaling');
  };
  ViewerPreferences.prototype.Duplex = function () {
    return this.lookupName('Duplex');
  };
  ViewerPreferences.prototype.PickTrayByPDFSize = function () {
    return this.lookupBool('PickTrayByPDFSize');
  };
  ViewerPreferences.prototype.PrintPageRange = function () {
    var PrintPageRange = this.dict.lookup(PDFName.of('PrintPageRange'));
    if (PrintPageRange instanceof PDFArray) return PrintPageRange;
    return undefined;
  };
  ViewerPreferences.prototype.NumCopies = function () {
    var NumCopies = this.dict.lookup(PDFName.of('NumCopies'));
    if (NumCopies instanceof PDFNumber) return NumCopies;
    return undefined;
  };
  ViewerPreferences.prototype.getHideToolbar = function () {
    var _a, _b;
    return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getHideMenubar = function () {
    var _a, _b;
    return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getHideWindowUI = function () {
    var _a, _b;
    return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getFitWindow = function () {
    var _a, _b;
    return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getCenterWindow = function () {
    var _a, _b;
    return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getDisplayDocTitle = function () {
    var _a, _b;
    return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
  };
  ViewerPreferences.prototype.getNonFullScreenPageMode = function () {
    var _a, _b;
    var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
    return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
  };
  ViewerPreferences.prototype.getReadingDirection = function () {
    var _a, _b;
    var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
    return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
  };
  ViewerPreferences.prototype.getPrintScaling = function () {
    var _a, _b;
    var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
    return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
  };
  ViewerPreferences.prototype.getDuplex = function () {
    var _a;
    var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
    return asEnum(duplex, Duplex);
  };
  ViewerPreferences.prototype.getPickTrayByPDFSize = function () {
    var _a;
    return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
  };
  ViewerPreferences.prototype.getPrintPageRange = function () {
    var rng = this.PrintPageRange();
    if (!rng) return [];
    var pageRanges = [];
    for (var i = 0; i < rng.size(); i += 2) {
      var start = rng.lookup(i, PDFNumber).asNumber();
      var end = rng.lookup(i + 1, PDFNumber).asNumber();
      pageRanges.push({
        start: start,
        end: end
      });
    }
    return pageRanges;
  };
  ViewerPreferences.prototype.getNumCopies = function () {
    var _a, _b;
    return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
  };
  ViewerPreferences.prototype.setHideToolbar = function (hideToolbar) {
    var HideToolbar = this.dict.context.obj(hideToolbar);
    this.dict.set(PDFName.of('HideToolbar'), HideToolbar);
  };
  ViewerPreferences.prototype.setHideMenubar = function (hideMenubar) {
    var HideMenubar = this.dict.context.obj(hideMenubar);
    this.dict.set(PDFName.of('HideMenubar'), HideMenubar);
  };
  ViewerPreferences.prototype.setHideWindowUI = function (hideWindowUI) {
    var HideWindowUI = this.dict.context.obj(hideWindowUI);
    this.dict.set(PDFName.of('HideWindowUI'), HideWindowUI);
  };
  ViewerPreferences.prototype.setFitWindow = function (fitWindow) {
    var FitWindow = this.dict.context.obj(fitWindow);
    this.dict.set(PDFName.of('FitWindow'), FitWindow);
  };
  ViewerPreferences.prototype.setCenterWindow = function (centerWindow) {
    var CenterWindow = this.dict.context.obj(centerWindow);
    this.dict.set(PDFName.of('CenterWindow'), CenterWindow);
  };
  ViewerPreferences.prototype.setDisplayDocTitle = function (displayTitle) {
    var DisplayDocTitle = this.dict.context.obj(displayTitle);
    this.dict.set(PDFName.of('DisplayDocTitle'), DisplayDocTitle);
  };
  ViewerPreferences.prototype.setNonFullScreenPageMode = function (nonFullScreenPageMode) {
    assertIsOneOf(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
    var mode = PDFName.of(nonFullScreenPageMode);
    this.dict.set(PDFName.of('NonFullScreenPageMode'), mode);
  };
  ViewerPreferences.prototype.setReadingDirection = function (readingDirection) {
    assertIsOneOf(readingDirection, 'readingDirection', ReadingDirection);
    var direction = PDFName.of(readingDirection);
    this.dict.set(PDFName.of('Direction'), direction);
  };
  ViewerPreferences.prototype.setPrintScaling = function (printScaling) {
    assertIsOneOf(printScaling, 'printScaling', PrintScaling);
    var scaling = PDFName.of(printScaling);
    this.dict.set(PDFName.of('PrintScaling'), scaling);
  };
  ViewerPreferences.prototype.setDuplex = function (duplex) {
    assertIsOneOf(duplex, 'duplex', Duplex);
    var dup = PDFName.of(duplex);
    this.dict.set(PDFName.of('Duplex'), dup);
  };
  ViewerPreferences.prototype.setPickTrayByPDFSize = function (pickTrayByPDFSize) {
    var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
    this.dict.set(PDFName.of('PickTrayByPDFSize'), PickTrayByPDFSize);
  };
  ViewerPreferences.prototype.setPrintPageRange = function (printPageRange) {
    if (!Array.isArray(printPageRange)) printPageRange = [printPageRange];
    var flatRange = [];
    for (var idx = 0, len = printPageRange.length; idx < len; idx++) {
      flatRange.push(printPageRange[idx].start);
      flatRange.push(printPageRange[idx].end);
    }
    assertEachIs(flatRange, 'printPageRange', ['number']);
    var pageRanges = this.dict.context.obj(flatRange);
    this.dict.set(PDFName.of('PrintPageRange'), pageRanges);
  };
  ViewerPreferences.prototype.setNumCopies = function (numCopies) {
    assertRange(numCopies, 'numCopies', 1, Number.MAX_VALUE);
    assertInteger(numCopies, 'numCopies');
    var NumCopies = this.dict.context.obj(numCopies);
    this.dict.set(PDFName.of('NumCopies'), NumCopies);
  };
  ViewerPreferences.fromDict = function (dict) {
    return new ViewerPreferences(dict);
  };
  ViewerPreferences.create = function (context) {
    var dict = context.obj({});
    return new ViewerPreferences(dict);
  };
  return ViewerPreferences;
}();

var tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var PDFAcroField = function () {
  function PDFAcroField(dict, ref) {
    this.dict = dict;
    this.ref = ref;
  }
  PDFAcroField.prototype.T = function () {
    return this.dict.lookupMaybe(PDFName.of('T'), PDFString, PDFHexString);
  };
  PDFAcroField.prototype.Ff = function () {
    var numberOrRef = this.getInheritableAttribute(PDFName.of('Ff'));
    return this.dict.context.lookupMaybe(numberOrRef, PDFNumber);
  };
  PDFAcroField.prototype.V = function () {
    var valueOrRef = this.getInheritableAttribute(PDFName.of('V'));
    return this.dict.context.lookup(valueOrRef);
  };
  PDFAcroField.prototype.Kids = function () {
    return this.dict.lookupMaybe(PDFName.of('Kids'), PDFArray);
  };
  PDFAcroField.prototype.DA = function () {
    var da = this.dict.lookup(PDFName.of('DA'));
    if (da instanceof PDFString || da instanceof PDFHexString) return da;
    return undefined;
  };
  PDFAcroField.prototype.setKids = function (kids) {
    this.dict.set(PDFName.of('Kids'), this.dict.context.obj(kids));
  };
  PDFAcroField.prototype.getParent = function () {
    var parentRef = this.dict.get(PDFName.of('Parent'));
    if (parentRef instanceof PDFRef) {
      var parent_1 = this.dict.lookup(PDFName.of('Parent'), PDFDict);
      return new PDFAcroField(parent_1, parentRef);
    }
    return undefined;
  };
  PDFAcroField.prototype.setParent = function (parent) {
    if (!parent) this.dict.delete(PDFName.of('Parent'));else this.dict.set(PDFName.of('Parent'), parent);
  };
  PDFAcroField.prototype.getFullyQualifiedName = function () {
    var parent = this.getParent();
    if (!parent) return this.getPartialName();
    return parent.getFullyQualifiedName() + "." + this.getPartialName();
  };
  PDFAcroField.prototype.getPartialName = function () {
    var _a;
    return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
  };
  PDFAcroField.prototype.setPartialName = function (partialName) {
    if (!partialName) this.dict.delete(PDFName.of('T'));else this.dict.set(PDFName.of('T'), PDFHexString.fromText(partialName));
  };
  PDFAcroField.prototype.setDefaultAppearance = function (appearance) {
    this.dict.set(PDFName.of('DA'), PDFString.of(appearance));
  };
  PDFAcroField.prototype.getDefaultAppearance = function () {
    var DA = this.DA();
    if (DA instanceof PDFHexString) {
      return DA.decodeText();
    }
    return DA === null || DA === void 0 ? void 0 : DA.asString();
  };
  PDFAcroField.prototype.setFontSize = function (fontSize) {
    var _a;
    var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    var da = this.getDefaultAppearance();
    if (!da) throw new MissingDAEntryError(name);
    var daMatch = findLastMatch(da, tfRegex);
    if (!daMatch.match) throw new MissingTfOperatorError(name);
    var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
    var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
    var fontName = daMatch.match[1];
    var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
    this.setDefaultAppearance(modifiedDa);
  };
  PDFAcroField.prototype.getFlags = function () {
    var _a, _b;
    return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
  };
  PDFAcroField.prototype.setFlags = function (flags) {
    this.dict.set(PDFName.of('Ff'), PDFNumber.of(flags));
  };
  PDFAcroField.prototype.hasFlag = function (flag) {
    var flags = this.getFlags();
    return (flags & flag) !== 0;
  };
  PDFAcroField.prototype.setFlag = function (flag) {
    var flags = this.getFlags();
    this.setFlags(flags | flag);
  };
  PDFAcroField.prototype.clearFlag = function (flag) {
    var flags = this.getFlags();
    this.setFlags(flags & ~flag);
  };
  PDFAcroField.prototype.setFlagTo = function (flag, enable) {
    if (enable) this.setFlag(flag);else this.clearFlag(flag);
  };
  PDFAcroField.prototype.getInheritableAttribute = function (name) {
    var attribute;
    this.ascend(function (node) {
      if (!attribute) attribute = node.dict.get(name);
    });
    return attribute;
  };
  PDFAcroField.prototype.ascend = function (visitor) {
    visitor(this);
    var parent = this.getParent();
    if (parent) parent.ascend(visitor);
  };
  return PDFAcroField;
}();

var BorderStyle = function () {
  function BorderStyle(dict) {
    this.dict = dict;
  }
  BorderStyle.prototype.W = function () {
    var W = this.dict.lookup(PDFName.of('W'));
    if (W instanceof PDFNumber) return W;
    return undefined;
  };
  BorderStyle.prototype.getWidth = function () {
    var _a, _b;
    return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
  };
  BorderStyle.prototype.setWidth = function (width) {
    var W = this.dict.context.obj(width);
    this.dict.set(PDFName.of('W'), W);
  };
  BorderStyle.fromDict = function (dict) {
    return new BorderStyle(dict);
  };
  return BorderStyle;
}();

var PDFAnnotation = function () {
  function PDFAnnotation(dict) {
    this.dict = dict;
  }
  PDFAnnotation.prototype.Rect = function () {
    return this.dict.lookup(PDFName.of('Rect'), PDFArray);
  };
  PDFAnnotation.prototype.AP = function () {
    return this.dict.lookupMaybe(PDFName.of('AP'), PDFDict);
  };
  PDFAnnotation.prototype.F = function () {
    var numberOrRef = this.dict.lookup(PDFName.of('F'));
    return this.dict.context.lookupMaybe(numberOrRef, PDFNumber);
  };
  PDFAnnotation.prototype.getRectangle = function () {
    var _a;
    var Rect = this.Rect();
    return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  };
  PDFAnnotation.prototype.setRectangle = function (rect) {
    var x = rect.x,
      y = rect.y,
      width = rect.width,
      height = rect.height;
    var Rect = this.dict.context.obj([x, y, x + width, y + height]);
    this.dict.set(PDFName.of('Rect'), Rect);
  };
  PDFAnnotation.prototype.getAppearanceState = function () {
    var AS = this.dict.lookup(PDFName.of('AS'));
    if (AS instanceof PDFName) return AS;
    return undefined;
  };
  PDFAnnotation.prototype.setAppearanceState = function (state) {
    this.dict.set(PDFName.of('AS'), state);
  };
  PDFAnnotation.prototype.setAppearances = function (appearances) {
    this.dict.set(PDFName.of('AP'), appearances);
  };
  PDFAnnotation.prototype.ensureAP = function () {
    var AP = this.AP();
    if (!AP) {
      AP = this.dict.context.obj({});
      this.dict.set(PDFName.of('AP'), AP);
    }
    return AP;
  };
  PDFAnnotation.prototype.getNormalAppearance = function () {
    var AP = this.ensureAP();
    var N = AP.get(PDFName.of('N'));
    if (N instanceof PDFRef || N instanceof PDFDict) return N;
    throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
  };
  PDFAnnotation.prototype.setNormalAppearance = function (appearance) {
    var AP = this.ensureAP();
    AP.set(PDFName.of('N'), appearance);
  };
  PDFAnnotation.prototype.setRolloverAppearance = function (appearance) {
    var AP = this.ensureAP();
    AP.set(PDFName.of('R'), appearance);
  };
  PDFAnnotation.prototype.setDownAppearance = function (appearance) {
    var AP = this.ensureAP();
    AP.set(PDFName.of('D'), appearance);
  };
  PDFAnnotation.prototype.removeRolloverAppearance = function () {
    var AP = this.AP();
    AP === null || AP === void 0 ? void 0 : AP.delete(PDFName.of('R'));
  };
  PDFAnnotation.prototype.removeDownAppearance = function () {
    var AP = this.AP();
    AP === null || AP === void 0 ? void 0 : AP.delete(PDFName.of('D'));
  };
  PDFAnnotation.prototype.getAppearances = function () {
    var AP = this.AP();
    if (!AP) return undefined;
    var N = AP.lookup(PDFName.of('N'), PDFDict, PDFStream);
    var R = AP.lookupMaybe(PDFName.of('R'), PDFDict, PDFStream);
    var D = AP.lookupMaybe(PDFName.of('D'), PDFDict, PDFStream);
    return {
      normal: N,
      rollover: R,
      down: D
    };
  };
  PDFAnnotation.prototype.getFlags = function () {
    var _a, _b;
    return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
  };
  PDFAnnotation.prototype.setFlags = function (flags) {
    this.dict.set(PDFName.of('F'), PDFNumber.of(flags));
  };
  PDFAnnotation.prototype.hasFlag = function (flag) {
    var flags = this.getFlags();
    return (flags & flag) !== 0;
  };
  PDFAnnotation.prototype.setFlag = function (flag) {
    var flags = this.getFlags();
    this.setFlags(flags | flag);
  };
  PDFAnnotation.prototype.clearFlag = function (flag) {
    var flags = this.getFlags();
    this.setFlags(flags & ~flag);
  };
  PDFAnnotation.prototype.setFlagTo = function (flag, enable) {
    if (enable) this.setFlag(flag);else this.clearFlag(flag);
  };
  PDFAnnotation.fromDict = function (dict) {
    return new PDFAnnotation(dict);
  };
  return PDFAnnotation;
}();

var AppearanceCharacteristics = function () {
  function AppearanceCharacteristics(dict) {
    this.dict = dict;
  }
  AppearanceCharacteristics.prototype.R = function () {
    var R = this.dict.lookup(PDFName.of('R'));
    if (R instanceof PDFNumber) return R;
    return undefined;
  };
  AppearanceCharacteristics.prototype.BC = function () {
    var BC = this.dict.lookup(PDFName.of('BC'));
    if (BC instanceof PDFArray) return BC;
    return undefined;
  };
  AppearanceCharacteristics.prototype.BG = function () {
    var BG = this.dict.lookup(PDFName.of('BG'));
    if (BG instanceof PDFArray) return BG;
    return undefined;
  };
  AppearanceCharacteristics.prototype.CA = function () {
    var CA = this.dict.lookup(PDFName.of('CA'));
    if (CA instanceof PDFHexString || CA instanceof PDFString) return CA;
    return undefined;
  };
  AppearanceCharacteristics.prototype.RC = function () {
    var RC = this.dict.lookup(PDFName.of('RC'));
    if (RC instanceof PDFHexString || RC instanceof PDFString) return RC;
    return undefined;
  };
  AppearanceCharacteristics.prototype.AC = function () {
    var AC = this.dict.lookup(PDFName.of('AC'));
    if (AC instanceof PDFHexString || AC instanceof PDFString) return AC;
    return undefined;
  };
  AppearanceCharacteristics.prototype.getRotation = function () {
    var _a;
    return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
  };
  AppearanceCharacteristics.prototype.getBorderColor = function () {
    var BC = this.BC();
    if (!BC) return undefined;
    var components = [];
    for (var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++) {
      var component = BC.get(idx);
      if (component instanceof PDFNumber) components.push(component.asNumber());
    }
    return components;
  };
  AppearanceCharacteristics.prototype.getBackgroundColor = function () {
    var BG = this.BG();
    if (!BG) return undefined;
    var components = [];
    for (var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++) {
      var component = BG.get(idx);
      if (component instanceof PDFNumber) components.push(component.asNumber());
    }
    return components;
  };
  AppearanceCharacteristics.prototype.getCaptions = function () {
    var CA = this.CA();
    var RC = this.RC();
    var AC = this.AC();
    return {
      normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
      rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
      down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
    };
  };
  AppearanceCharacteristics.prototype.setRotation = function (rotation) {
    var R = this.dict.context.obj(rotation);
    this.dict.set(PDFName.of('R'), R);
  };
  AppearanceCharacteristics.prototype.setBorderColor = function (color) {
    var BC = this.dict.context.obj(color);
    this.dict.set(PDFName.of('BC'), BC);
  };
  AppearanceCharacteristics.prototype.setBackgroundColor = function (color) {
    var BG = this.dict.context.obj(color);
    this.dict.set(PDFName.of('BG'), BG);
  };
  AppearanceCharacteristics.prototype.setCaptions = function (captions) {
    var CA = PDFHexString.fromText(captions.normal);
    this.dict.set(PDFName.of('CA'), CA);
    if (captions.rollover) {
      var RC = PDFHexString.fromText(captions.rollover);
      this.dict.set(PDFName.of('RC'), RC);
    } else {
      this.dict.delete(PDFName.of('RC'));
    }
    if (captions.down) {
      var AC = PDFHexString.fromText(captions.down);
      this.dict.set(PDFName.of('AC'), AC);
    } else {
      this.dict.delete(PDFName.of('AC'));
    }
  };
  AppearanceCharacteristics.fromDict = function (dict) {
    return new AppearanceCharacteristics(dict);
  };
  return AppearanceCharacteristics;
}();

var PDFWidgetAnnotation = function (_super) {
  __extends(PDFWidgetAnnotation, _super);
  function PDFWidgetAnnotation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFWidgetAnnotation.prototype.MK = function () {
    var MK = this.dict.lookup(PDFName.of('MK'));
    if (MK instanceof PDFDict) return MK;
    return undefined;
  };
  PDFWidgetAnnotation.prototype.BS = function () {
    var BS = this.dict.lookup(PDFName.of('BS'));
    if (BS instanceof PDFDict) return BS;
    return undefined;
  };
  PDFWidgetAnnotation.prototype.DA = function () {
    var da = this.dict.lookup(PDFName.of('DA'));
    if (da instanceof PDFString || da instanceof PDFHexString) return da;
    return undefined;
  };
  PDFWidgetAnnotation.prototype.P = function () {
    var P = this.dict.get(PDFName.of('P'));
    if (P instanceof PDFRef) return P;
    return undefined;
  };
  PDFWidgetAnnotation.prototype.setP = function (page) {
    this.dict.set(PDFName.of('P'), page);
  };
  PDFWidgetAnnotation.prototype.setDefaultAppearance = function (appearance) {
    this.dict.set(PDFName.of('DA'), PDFString.of(appearance));
  };
  PDFWidgetAnnotation.prototype.getDefaultAppearance = function () {
    var DA = this.DA();
    if (DA instanceof PDFHexString) {
      return DA.decodeText();
    }
    return DA === null || DA === void 0 ? void 0 : DA.asString();
  };
  PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function () {
    var MK = this.MK();
    if (MK) return AppearanceCharacteristics.fromDict(MK);
    return undefined;
  };
  PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function () {
    var MK = this.MK();
    if (MK) return AppearanceCharacteristics.fromDict(MK);
    var ac = AppearanceCharacteristics.fromDict(this.dict.context.obj({}));
    this.dict.set(PDFName.of('MK'), ac.dict);
    return ac;
  };
  PDFWidgetAnnotation.prototype.getBorderStyle = function () {
    var BS = this.BS();
    if (BS) return BorderStyle.fromDict(BS);
    return undefined;
  };
  PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function () {
    var BS = this.BS();
    if (BS) return BorderStyle.fromDict(BS);
    var bs = BorderStyle.fromDict(this.dict.context.obj({}));
    this.dict.set(PDFName.of('BS'), bs.dict);
    return bs;
  };
  PDFWidgetAnnotation.prototype.getOnValue = function () {
    var _a;
    var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
    if (normal instanceof PDFDict) {
      var keys = normal.keys();
      for (var idx = 0, len = keys.length; idx < len; idx++) {
        var key = keys[idx];
        if (key !== PDFName.of('Off')) return key;
      }
    }
    return undefined;
  };
  PDFWidgetAnnotation.fromDict = function (dict) {
    return new PDFWidgetAnnotation(dict);
  };
  PDFWidgetAnnotation.create = function (context, parent) {
    var dict = context.obj({
      Type: 'Annot',
      Subtype: 'Widget',
      Rect: [0, 0, 0, 0],
      Parent: parent
    });
    return new PDFWidgetAnnotation(dict);
  };
  return PDFWidgetAnnotation;
}(PDFAnnotation);

var PDFAcroTerminal = function (_super) {
  __extends(PDFAcroTerminal, _super);
  function PDFAcroTerminal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroTerminal.prototype.FT = function () {
    var nameOrRef = this.getInheritableAttribute(PDFName.of('FT'));
    return this.dict.context.lookup(nameOrRef, PDFName);
  };
  PDFAcroTerminal.prototype.getWidgets = function () {
    var kidDicts = this.Kids();
    if (!kidDicts) return [PDFWidgetAnnotation.fromDict(this.dict)];
    var widgets = new Array(kidDicts.size());
    for (var idx = 0, len = kidDicts.size(); idx < len; idx++) {
      var dict = kidDicts.lookup(idx, PDFDict);
      widgets[idx] = PDFWidgetAnnotation.fromDict(dict);
    }
    return widgets;
  };
  PDFAcroTerminal.prototype.addWidget = function (ref) {
    var Kids = this.normalizedEntries().Kids;
    Kids.push(ref);
  };
  PDFAcroTerminal.prototype.removeWidget = function (idx) {
    var kidDicts = this.Kids();
    if (!kidDicts) {
      if (idx !== 0) throw new IndexOutOfBoundsError(idx, 0, 0);
      this.setKids([]);
    } else {
      if (idx < 0 || idx > kidDicts.size()) {
        throw new IndexOutOfBoundsError(idx, 0, kidDicts.size());
      }
      kidDicts.remove(idx);
    }
  };
  PDFAcroTerminal.prototype.normalizedEntries = function () {
    var Kids = this.Kids();
    if (!Kids) {
      Kids = this.dict.context.obj([this.ref]);
      this.dict.set(PDFName.of('Kids'), Kids);
    }
    return {
      Kids: Kids
    };
  };
  PDFAcroTerminal.fromDict = function (dict, ref) {
    return new PDFAcroTerminal(dict, ref);
  };
  return PDFAcroTerminal;
}(PDFAcroField);

var PDFAcroButton = function (_super) {
  __extends(PDFAcroButton, _super);
  function PDFAcroButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroButton.prototype.Opt = function () {
    return this.dict.lookupMaybe(PDFName.of('Opt'), PDFString, PDFHexString, PDFArray);
  };
  PDFAcroButton.prototype.setOpt = function (opt) {
    this.dict.set(PDFName.of('Opt'), this.dict.context.obj(opt));
  };
  PDFAcroButton.prototype.getExportValues = function () {
    var opt = this.Opt();
    if (!opt) return undefined;
    if (opt instanceof PDFString || opt instanceof PDFHexString) {
      return [opt];
    }
    var values = [];
    for (var idx = 0, len = opt.size(); idx < len; idx++) {
      var value = opt.lookup(idx);
      if (value instanceof PDFString || value instanceof PDFHexString) {
        values.push(value);
      }
    }
    return values;
  };
  PDFAcroButton.prototype.removeExportValue = function (idx) {
    var opt = this.Opt();
    if (!opt) return;
    if (opt instanceof PDFString || opt instanceof PDFHexString) {
      if (idx !== 0) throw new IndexOutOfBoundsError(idx, 0, 0);
      this.setOpt([]);
    } else {
      if (idx < 0 || idx > opt.size()) {
        throw new IndexOutOfBoundsError(idx, 0, opt.size());
      }
      opt.remove(idx);
    }
  };
  PDFAcroButton.prototype.normalizeExportValues = function () {
    var _a, _b, _c, _d;
    var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
    var Opt = [];
    var widgets = this.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : PDFHexString.fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
      Opt.push(exportVal);
    }
    this.setOpt(Opt);
  };
  PDFAcroButton.prototype.addOpt = function (opt, useExistingOptIdx) {
    var _a;
    this.normalizeExportValues();
    var optText = opt.decodeText();
    var existingIdx;
    if (useExistingOptIdx) {
      var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
      for (var idx = 0, len = exportValues.length; idx < len; idx++) {
        var exportVal = exportValues[idx];
        if (exportVal.decodeText() === optText) existingIdx = idx;
      }
    }
    var Opt = this.Opt();
    Opt.push(opt);
    return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
  };
  PDFAcroButton.prototype.addWidgetWithOpt = function (widget, opt, useExistingOptIdx) {
    var optIdx = this.addOpt(opt, useExistingOptIdx);
    var apStateValue = PDFName.of(String(optIdx));
    this.addWidget(widget);
    return apStateValue;
  };
  return PDFAcroButton;
}(PDFAcroTerminal);

var PDFAcroCheckBox = function (_super) {
  __extends(PDFAcroCheckBox, _super);
  function PDFAcroCheckBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroCheckBox.prototype.setValue = function (value) {
    var _a;
    var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : PDFName.of('Yes');
    if (value !== onValue && value !== PDFName.of('Off')) {
      throw new InvalidAcroFieldValueError();
    }
    this.dict.set(PDFName.of('V'), value);
    var widgets = this.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var state = widget.getOnValue() === value ? value : PDFName.of('Off');
      widget.setAppearanceState(state);
    }
  };
  PDFAcroCheckBox.prototype.getValue = function () {
    var v = this.V();
    if (v instanceof PDFName) return v;
    return PDFName.of('Off');
  };
  PDFAcroCheckBox.prototype.getOnValue = function () {
    var widget = this.getWidgets()[0];
    return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
  };
  PDFAcroCheckBox.fromDict = function (dict, ref) {
    return new PDFAcroCheckBox(dict, ref);
  };
  PDFAcroCheckBox.create = function (context) {
    var dict = context.obj({
      FT: 'Btn',
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroCheckBox(dict, ref);
  };
  return PDFAcroCheckBox;
}(PDFAcroButton);

var flag = function (bitIndex) {
  return 1 << bitIndex;
};
var AcroFieldFlags;
(function (AcroFieldFlags) {
  AcroFieldFlags[AcroFieldFlags["ReadOnly"] = flag(1 - 1)] = "ReadOnly";
  AcroFieldFlags[AcroFieldFlags["Required"] = flag(2 - 1)] = "Required";
  AcroFieldFlags[AcroFieldFlags["NoExport"] = flag(3 - 1)] = "NoExport";
})(AcroFieldFlags || (AcroFieldFlags = {}));
var AcroButtonFlags;
(function (AcroButtonFlags) {
  AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = flag(15 - 1)] = "NoToggleToOff";
  AcroButtonFlags[AcroButtonFlags["Radio"] = flag(16 - 1)] = "Radio";
  AcroButtonFlags[AcroButtonFlags["PushButton"] = flag(17 - 1)] = "PushButton";
  AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = flag(26 - 1)] = "RadiosInUnison";
})(AcroButtonFlags || (AcroButtonFlags = {}));
var AcroTextFlags;
(function (AcroTextFlags) {
  AcroTextFlags[AcroTextFlags["Multiline"] = flag(13 - 1)] = "Multiline";
  AcroTextFlags[AcroTextFlags["Password"] = flag(14 - 1)] = "Password";
  AcroTextFlags[AcroTextFlags["FileSelect"] = flag(21 - 1)] = "FileSelect";
  AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = flag(23 - 1)] = "DoNotSpellCheck";
  AcroTextFlags[AcroTextFlags["DoNotScroll"] = flag(24 - 1)] = "DoNotScroll";
  AcroTextFlags[AcroTextFlags["Comb"] = flag(25 - 1)] = "Comb";
  AcroTextFlags[AcroTextFlags["RichText"] = flag(26 - 1)] = "RichText";
})(AcroTextFlags || (AcroTextFlags = {}));
var AcroChoiceFlags;
(function (AcroChoiceFlags) {
  AcroChoiceFlags[AcroChoiceFlags["Combo"] = flag(18 - 1)] = "Combo";
  AcroChoiceFlags[AcroChoiceFlags["Edit"] = flag(19 - 1)] = "Edit";
  AcroChoiceFlags[AcroChoiceFlags["Sort"] = flag(20 - 1)] = "Sort";
  AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = flag(22 - 1)] = "MultiSelect";
  AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = flag(23 - 1)] = "DoNotSpellCheck";
  AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = flag(27 - 1)] = "CommitOnSelChange";
})(AcroChoiceFlags || (AcroChoiceFlags = {}));

var PDFAcroChoice = function (_super) {
  __extends(PDFAcroChoice, _super);
  function PDFAcroChoice() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroChoice.prototype.setValues = function (values) {
    if (this.hasFlag(AcroChoiceFlags.Combo) && !this.hasFlag(AcroChoiceFlags.Edit) && !this.valuesAreValid(values)) {
      throw new InvalidAcroFieldValueError();
    }
    if (values.length === 0) {
      this.dict.delete(PDFName.of('V'));
    }
    if (values.length === 1) {
      this.dict.set(PDFName.of('V'), values[0]);
    }
    if (values.length > 1) {
      if (!this.hasFlag(AcroChoiceFlags.MultiSelect)) {
        throw new MultiSelectValueError();
      }
      this.dict.set(PDFName.of('V'), this.dict.context.obj(values));
    }
    this.updateSelectedIndices(values);
  };
  PDFAcroChoice.prototype.valuesAreValid = function (values) {
    var options = this.getOptions();
    var _loop_1 = function (idx, len) {
      var val = values[idx].decodeText();
      if (!options.find(function (o) {
        return val === (o.display || o.value).decodeText();
      })) {
        return {
          value: false
        };
      }
    };
    for (var idx = 0, len = values.length; idx < len; idx++) {
      var state_1 = _loop_1(idx);
      if (typeof state_1 === "object") return state_1.value;
    }
    return true;
  };
  PDFAcroChoice.prototype.updateSelectedIndices = function (values) {
    if (values.length > 1) {
      var indices = new Array(values.length);
      var options = this.getOptions();
      var _loop_2 = function (idx, len) {
        var val = values[idx].decodeText();
        indices[idx] = options.findIndex(function (o) {
          return val === (o.display || o.value).decodeText();
        });
      };
      for (var idx = 0, len = values.length; idx < len; idx++) {
        _loop_2(idx, len);
      }
      this.dict.set(PDFName.of('I'), this.dict.context.obj(indices.sort()));
    } else {
      this.dict.delete(PDFName.of('I'));
    }
  };
  PDFAcroChoice.prototype.getValues = function () {
    var v = this.V();
    if (v instanceof PDFString || v instanceof PDFHexString) return [v];
    if (v instanceof PDFArray) {
      var values = [];
      for (var idx = 0, len = v.size(); idx < len; idx++) {
        var value = v.lookup(idx);
        if (value instanceof PDFString || value instanceof PDFHexString) {
          values.push(value);
        }
      }
      return values;
    }
    return [];
  };
  PDFAcroChoice.prototype.Opt = function () {
    return this.dict.lookupMaybe(PDFName.of('Opt'), PDFString, PDFHexString, PDFArray);
  };
  PDFAcroChoice.prototype.setOptions = function (options) {
    var newOpt = new Array(options.length);
    for (var idx = 0, len = options.length; idx < len; idx++) {
      var _a = options[idx],
        value = _a.value,
        display = _a.display;
      newOpt[idx] = this.dict.context.obj([value, display || value]);
    }
    this.dict.set(PDFName.of('Opt'), this.dict.context.obj(newOpt));
  };
  PDFAcroChoice.prototype.getOptions = function () {
    var Opt = this.Opt();
    if (Opt instanceof PDFString || Opt instanceof PDFHexString) {
      return [{
        value: Opt,
        display: Opt
      }];
    }
    if (Opt instanceof PDFArray) {
      var res = [];
      for (var idx = 0, len = Opt.size(); idx < len; idx++) {
        var item = Opt.lookup(idx);
        if (item instanceof PDFString || item instanceof PDFHexString) {
          res.push({
            value: item,
            display: item
          });
        }
        if (item instanceof PDFArray) {
          if (item.size() > 0) {
            var first = item.lookup(0, PDFString, PDFHexString);
            var second = item.lookupMaybe(1, PDFString, PDFHexString);
            res.push({
              value: first,
              display: second || first
            });
          }
        }
      }
      return res;
    }
    return [];
  };
  return PDFAcroChoice;
}(PDFAcroTerminal);

var PDFAcroComboBox = function (_super) {
  __extends(PDFAcroComboBox, _super);
  function PDFAcroComboBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroComboBox.fromDict = function (dict, ref) {
    return new PDFAcroComboBox(dict, ref);
  };
  PDFAcroComboBox.create = function (context) {
    var dict = context.obj({
      FT: 'Ch',
      Ff: AcroChoiceFlags.Combo,
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroComboBox(dict, ref);
  };
  return PDFAcroComboBox;
}(PDFAcroChoice);

var PDFAcroNonTerminal = function (_super) {
  __extends(PDFAcroNonTerminal, _super);
  function PDFAcroNonTerminal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroNonTerminal.prototype.addField = function (field) {
    var Kids = this.normalizedEntries().Kids;
    Kids === null || Kids === void 0 ? void 0 : Kids.push(field);
  };
  PDFAcroNonTerminal.prototype.normalizedEntries = function () {
    var Kids = this.Kids();
    if (!Kids) {
      Kids = this.dict.context.obj([]);
      this.dict.set(PDFName.of('Kids'), Kids);
    }
    return {
      Kids: Kids
    };
  };
  PDFAcroNonTerminal.fromDict = function (dict, ref) {
    return new PDFAcroNonTerminal(dict, ref);
  };
  PDFAcroNonTerminal.create = function (context) {
    var dict = context.obj({});
    var ref = context.register(dict);
    return new PDFAcroNonTerminal(dict, ref);
  };
  return PDFAcroNonTerminal;
}(PDFAcroField);

var PDFAcroSignature = function (_super) {
  __extends(PDFAcroSignature, _super);
  function PDFAcroSignature() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroSignature.fromDict = function (dict, ref) {
    return new PDFAcroSignature(dict, ref);
  };
  return PDFAcroSignature;
}(PDFAcroTerminal);

var PDFAcroText = function (_super) {
  __extends(PDFAcroText, _super);
  function PDFAcroText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroText.prototype.MaxLen = function () {
    var maxLen = this.dict.lookup(PDFName.of('MaxLen'));
    if (maxLen instanceof PDFNumber) return maxLen;
    return undefined;
  };
  PDFAcroText.prototype.Q = function () {
    var q = this.dict.lookup(PDFName.of('Q'));
    if (q instanceof PDFNumber) return q;
    return undefined;
  };
  PDFAcroText.prototype.setMaxLength = function (maxLength) {
    this.dict.set(PDFName.of('MaxLen'), PDFNumber.of(maxLength));
  };
  PDFAcroText.prototype.removeMaxLength = function () {
    this.dict.delete(PDFName.of('MaxLen'));
  };
  PDFAcroText.prototype.getMaxLength = function () {
    var _a;
    return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
  };
  PDFAcroText.prototype.setQuadding = function (quadding) {
    this.dict.set(PDFName.of('Q'), PDFNumber.of(quadding));
  };
  PDFAcroText.prototype.getQuadding = function () {
    var _a;
    return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
  };
  PDFAcroText.prototype.setValue = function (value) {
    this.dict.set(PDFName.of('V'), value);
  };
  PDFAcroText.prototype.removeValue = function () {
    this.dict.delete(PDFName.of('V'));
  };
  PDFAcroText.prototype.getValue = function () {
    var v = this.V();
    if (v instanceof PDFString || v instanceof PDFHexString) return v;
    return undefined;
  };
  PDFAcroText.fromDict = function (dict, ref) {
    return new PDFAcroText(dict, ref);
  };
  PDFAcroText.create = function (context) {
    var dict = context.obj({
      FT: 'Tx',
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroText(dict, ref);
  };
  return PDFAcroText;
}(PDFAcroTerminal);

var PDFAcroPushButton = function (_super) {
  __extends(PDFAcroPushButton, _super);
  function PDFAcroPushButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroPushButton.fromDict = function (dict, ref) {
    return new PDFAcroPushButton(dict, ref);
  };
  PDFAcroPushButton.create = function (context) {
    var dict = context.obj({
      FT: 'Btn',
      Ff: AcroButtonFlags.PushButton,
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroPushButton(dict, ref);
  };
  return PDFAcroPushButton;
}(PDFAcroButton);

var PDFAcroRadioButton = function (_super) {
  __extends(PDFAcroRadioButton, _super);
  function PDFAcroRadioButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroRadioButton.prototype.setValue = function (value) {
    var onValues = this.getOnValues();
    if (!onValues.includes(value) && value !== PDFName.of('Off')) {
      throw new InvalidAcroFieldValueError();
    }
    this.dict.set(PDFName.of('V'), value);
    var widgets = this.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var state = widget.getOnValue() === value ? value : PDFName.of('Off');
      widget.setAppearanceState(state);
    }
  };
  PDFAcroRadioButton.prototype.getValue = function () {
    var v = this.V();
    if (v instanceof PDFName) return v;
    return PDFName.of('Off');
  };
  PDFAcroRadioButton.prototype.getOnValues = function () {
    var widgets = this.getWidgets();
    var onValues = [];
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var onValue = widgets[idx].getOnValue();
      if (onValue) onValues.push(onValue);
    }
    return onValues;
  };
  PDFAcroRadioButton.fromDict = function (dict, ref) {
    return new PDFAcroRadioButton(dict, ref);
  };
  PDFAcroRadioButton.create = function (context) {
    var dict = context.obj({
      FT: 'Btn',
      Ff: AcroButtonFlags.Radio,
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroRadioButton(dict, ref);
  };
  return PDFAcroRadioButton;
}(PDFAcroButton);

var PDFAcroListBox = function (_super) {
  __extends(PDFAcroListBox, _super);
  function PDFAcroListBox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFAcroListBox.fromDict = function (dict, ref) {
    return new PDFAcroListBox(dict, ref);
  };
  PDFAcroListBox.create = function (context) {
    var dict = context.obj({
      FT: 'Ch',
      Kids: []
    });
    var ref = context.register(dict);
    return new PDFAcroListBox(dict, ref);
  };
  return PDFAcroListBox;
}(PDFAcroChoice);

var createPDFAcroFields = function (kidDicts) {
  if (!kidDicts) return [];
  var kids = [];
  for (var idx = 0, len = kidDicts.size(); idx < len; idx++) {
    var ref = kidDicts.get(idx);
    var dict = kidDicts.lookup(idx);
    if (ref instanceof PDFRef && dict instanceof PDFDict) {
      kids.push([createPDFAcroField(dict, ref), ref]);
    }
  }
  return kids;
};
var createPDFAcroField = function (dict, ref) {
  var isNonTerminal = isNonTerminalAcroField(dict);
  if (isNonTerminal) return PDFAcroNonTerminal.fromDict(dict, ref);
  return createPDFAcroTerminal(dict, ref);
};
var isNonTerminalAcroField = function (dict) {
  var kids = dict.lookup(PDFName.of('Kids'));
  if (kids instanceof PDFArray) {
    for (var idx = 0, len = kids.size(); idx < len; idx++) {
      var kid = kids.lookup(idx);
      var kidIsField = kid instanceof PDFDict && kid.has(PDFName.of('T'));
      if (kidIsField) return true;
    }
  }
  return false;
};
var createPDFAcroTerminal = function (dict, ref) {
  var ftNameOrRef = getInheritableAttribute(dict, PDFName.of('FT'));
  var type = dict.context.lookup(ftNameOrRef, PDFName);
  if (type === PDFName.of('Btn')) return createPDFAcroButton(dict, ref);
  if (type === PDFName.of('Ch')) return createPDFAcroChoice(dict, ref);
  if (type === PDFName.of('Tx')) return PDFAcroText.fromDict(dict, ref);
  if (type === PDFName.of('Sig')) return PDFAcroSignature.fromDict(dict, ref);
  return PDFAcroTerminal.fromDict(dict, ref);
};
var createPDFAcroButton = function (dict, ref) {
  var _a;
  var ffNumberOrRef = getInheritableAttribute(dict, PDFName.of('Ff'));
  var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, PDFNumber);
  var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
  if (flagIsSet(flags, AcroButtonFlags.PushButton)) {
    return PDFAcroPushButton.fromDict(dict, ref);
  } else if (flagIsSet(flags, AcroButtonFlags.Radio)) {
    return PDFAcroRadioButton.fromDict(dict, ref);
  } else {
    return PDFAcroCheckBox.fromDict(dict, ref);
  }
};
var createPDFAcroChoice = function (dict, ref) {
  var _a;
  var ffNumberOrRef = getInheritableAttribute(dict, PDFName.of('Ff'));
  var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, PDFNumber);
  var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
  if (flagIsSet(flags, AcroChoiceFlags.Combo)) {
    return PDFAcroComboBox.fromDict(dict, ref);
  } else {
    return PDFAcroListBox.fromDict(dict, ref);
  }
};
var flagIsSet = function (flags, flag) {
  return (flags & flag) !== 0;
};
var getInheritableAttribute = function (startNode, name) {
  var attribute;
  ascend(startNode, function (node) {
    if (!attribute) attribute = node.get(name);
  });
  return attribute;
};
var ascend = function (startNode, visitor) {
  visitor(startNode);
  var Parent = startNode.lookupMaybe(PDFName.of('Parent'), PDFDict);
  if (Parent) ascend(Parent, visitor);
};

var PDFAcroForm = function () {
  function PDFAcroForm(dict) {
    this.dict = dict;
  }
  PDFAcroForm.prototype.Fields = function () {
    var fields = this.dict.lookup(PDFName.of('Fields'));
    if (fields instanceof PDFArray) return fields;
    return undefined;
  };
  PDFAcroForm.prototype.getFields = function () {
    var Fields = this.normalizedEntries().Fields;
    var fields = new Array(Fields.size());
    for (var idx = 0, len = Fields.size(); idx < len; idx++) {
      var ref = Fields.get(idx);
      var dict = Fields.lookup(idx, PDFDict);
      fields[idx] = [createPDFAcroField(dict, ref), ref];
    }
    return fields;
  };
  PDFAcroForm.prototype.getAllFields = function () {
    var allFields = [];
    var pushFields = function (fields) {
      if (!fields) return;
      for (var idx = 0, len = fields.length; idx < len; idx++) {
        var field = fields[idx];
        allFields.push(field);
        var fieldModel = field[0];
        if (fieldModel instanceof PDFAcroNonTerminal) {
          pushFields(createPDFAcroFields(fieldModel.Kids()));
        }
      }
    };
    pushFields(this.getFields());
    return allFields;
  };
  PDFAcroForm.prototype.addField = function (field) {
    var Fields = this.normalizedEntries().Fields;
    Fields === null || Fields === void 0 ? void 0 : Fields.push(field);
  };
  PDFAcroForm.prototype.removeField = function (field) {
    var parent = field.getParent();
    var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
    var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
    if (fields === undefined || index === undefined) {
      throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
    }
    fields.remove(index);
    if (parent !== undefined && fields.size() === 0) {
      this.removeField(parent);
    }
  };
  PDFAcroForm.prototype.normalizedEntries = function () {
    var Fields = this.Fields();
    if (!Fields) {
      Fields = this.dict.context.obj([]);
      this.dict.set(PDFName.of('Fields'), Fields);
    }
    return {
      Fields: Fields
    };
  };
  PDFAcroForm.fromDict = function (dict) {
    return new PDFAcroForm(dict);
  };
  PDFAcroForm.create = function (context) {
    var dict = context.obj({
      Fields: []
    });
    return new PDFAcroForm(dict);
  };
  return PDFAcroForm;
}();

var PDFCatalog = function (_super) {
  __extends(PDFCatalog, _super);
  function PDFCatalog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFCatalog.prototype.Pages = function () {
    return this.lookup(PDFName.of('Pages'), PDFDict);
  };
  PDFCatalog.prototype.AcroForm = function () {
    return this.lookupMaybe(PDFName.of('AcroForm'), PDFDict);
  };
  PDFCatalog.prototype.getAcroForm = function () {
    var dict = this.AcroForm();
    if (!dict) return undefined;
    return PDFAcroForm.fromDict(dict);
  };
  PDFCatalog.prototype.getOrCreateAcroForm = function () {
    var acroForm = this.getAcroForm();
    if (!acroForm) {
      acroForm = PDFAcroForm.create(this.context);
      var acroFormRef = this.context.register(acroForm.dict);
      this.set(PDFName.of('AcroForm'), acroFormRef);
    }
    return acroForm;
  };
  PDFCatalog.prototype.ViewerPreferences = function () {
    return this.lookupMaybe(PDFName.of('ViewerPreferences'), PDFDict);
  };
  PDFCatalog.prototype.getViewerPreferences = function () {
    var dict = this.ViewerPreferences();
    if (!dict) return undefined;
    return ViewerPreferences.fromDict(dict);
  };
  PDFCatalog.prototype.getOrCreateViewerPreferences = function () {
    var viewerPrefs = this.getViewerPreferences();
    if (!viewerPrefs) {
      viewerPrefs = ViewerPreferences.create(this.context);
      var viewerPrefsRef = this.context.register(viewerPrefs.dict);
      this.set(PDFName.of('ViewerPreferences'), viewerPrefsRef);
    }
    return viewerPrefs;
  };
  PDFCatalog.prototype.insertLeafNode = function (leafRef, index) {
    var pagesRef = this.get(PDFName.of('Pages'));
    var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
    return maybeParentRef || pagesRef;
  };
  PDFCatalog.prototype.removeLeafNode = function (index) {
    this.Pages().removeLeafNode(index);
  };
  PDFCatalog.withContextAndPages = function (context, pages) {
    var dict = new Map();
    dict.set(PDFName.of('Type'), PDFName.of('Catalog'));
    dict.set(PDFName.of('Pages'), pages);
    return new PDFCatalog(dict, context);
  };
  PDFCatalog.fromMapWithContext = function (map, context) {
    return new PDFCatalog(map, context);
  };
  return PDFCatalog;
}(PDFDict);

var PDFPageTree = function (_super) {
  __extends(PDFPageTree, _super);
  function PDFPageTree() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PDFPageTree.prototype.Parent = function () {
    return this.lookup(PDFName.of('Parent'));
  };
  PDFPageTree.prototype.Kids = function () {
    return this.lookup(PDFName.of('Kids'), PDFArray);
  };
  PDFPageTree.prototype.Count = function () {
    return this.lookup(PDFName.of('Count'), PDFNumber);
  };
  PDFPageTree.prototype.pushTreeNode = function (treeRef) {
    var Kids = this.Kids();
    Kids.push(treeRef);
  };
  PDFPageTree.prototype.pushLeafNode = function (leafRef) {
    var Kids = this.Kids();
    this.insertLeafKid(Kids.size(), leafRef);
  };
  PDFPageTree.prototype.insertLeafNode = function (leafRef, targetIndex) {
    var Kids = this.Kids();
    var Count = this.Count().asNumber();
    if (targetIndex > Count) {
      throw new InvalidTargetIndexError(targetIndex, Count);
    }
    var leafsRemainingUntilTarget = targetIndex;
    for (var idx = 0, len = Kids.size(); idx < len; idx++) {
      if (leafsRemainingUntilTarget === 0) {
        this.insertLeafKid(idx, leafRef);
        return undefined;
      }
      var kidRef = Kids.get(idx);
      var kid = this.context.lookup(kidRef);
      if (kid instanceof PDFPageTree) {
        if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
          return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
        } else {
          leafsRemainingUntilTarget -= kid.Count().asNumber();
        }
      }
      if (kid instanceof PDFPageLeaf) {
        leafsRemainingUntilTarget -= 1;
      }
    }
    if (leafsRemainingUntilTarget === 0) {
      this.insertLeafKid(Kids.size(), leafRef);
      return undefined;
    }
    throw new CorruptPageTreeError(targetIndex, 'insertLeafNode');
  };
  PDFPageTree.prototype.removeLeafNode = function (targetIndex, prune) {
    if (prune === void 0) {
      prune = true;
    }
    var Kids = this.Kids();
    var Count = this.Count().asNumber();
    if (targetIndex >= Count) {
      throw new InvalidTargetIndexError(targetIndex, Count);
    }
    var leafsRemainingUntilTarget = targetIndex;
    for (var idx = 0, len = Kids.size(); idx < len; idx++) {
      var kidRef = Kids.get(idx);
      var kid = this.context.lookup(kidRef);
      if (kid instanceof PDFPageTree) {
        if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
          kid.removeLeafNode(leafsRemainingUntilTarget, prune);
          if (prune && kid.Kids().size() === 0) Kids.remove(idx);
          return;
        } else {
          leafsRemainingUntilTarget -= kid.Count().asNumber();
        }
      }
      if (kid instanceof PDFPageLeaf) {
        if (leafsRemainingUntilTarget === 0) {
          this.removeKid(idx);
          return;
        } else {
          leafsRemainingUntilTarget -= 1;
        }
      }
    }
    throw new CorruptPageTreeError(targetIndex, 'removeLeafNode');
  };
  PDFPageTree.prototype.ascend = function (visitor) {
    visitor(this);
    var Parent = this.Parent();
    if (Parent) Parent.ascend(visitor);
  };
  PDFPageTree.prototype.traverse = function (visitor) {
    var Kids = this.Kids();
    for (var idx = 0, len = Kids.size(); idx < len; idx++) {
      var kidRef = Kids.get(idx);
      var kid = this.context.lookup(kidRef);
      if (kid instanceof PDFPageTree) kid.traverse(visitor);
      visitor(kid, kidRef);
    }
  };
  PDFPageTree.prototype.insertLeafKid = function (kidIdx, leafRef) {
    var Kids = this.Kids();
    this.ascend(function (node) {
      var newCount = node.Count().asNumber() + 1;
      node.set(PDFName.of('Count'), PDFNumber.of(newCount));
    });
    Kids.insert(kidIdx, leafRef);
  };
  PDFPageTree.prototype.removeKid = function (kidIdx) {
    var Kids = this.Kids();
    var kid = Kids.lookup(kidIdx);
    if (kid instanceof PDFPageLeaf) {
      this.ascend(function (node) {
        var newCount = node.Count().asNumber() - 1;
        node.set(PDFName.of('Count'), PDFNumber.of(newCount));
      });
    }
    Kids.remove(kidIdx);
  };
  PDFPageTree.withContext = function (context, parent) {
    var dict = new Map();
    dict.set(PDFName.of('Type'), PDFName.of('Pages'));
    dict.set(PDFName.of('Kids'), context.obj([]));
    dict.set(PDFName.of('Count'), context.obj(0));
    if (parent) dict.set(PDFName.of('Parent'), parent);
    return new PDFPageTree(dict, context);
  };
  PDFPageTree.fromMapWithContext = function (map, context) {
    return new PDFPageTree(map, context);
  };
  return PDFPageTree;
}(PDFDict);

var IsDigit = new Uint8Array(256);
IsDigit[CharCodes$1.Zero] = 1;
IsDigit[CharCodes$1.One] = 1;
IsDigit[CharCodes$1.Two] = 1;
IsDigit[CharCodes$1.Three] = 1;
IsDigit[CharCodes$1.Four] = 1;
IsDigit[CharCodes$1.Five] = 1;
IsDigit[CharCodes$1.Six] = 1;
IsDigit[CharCodes$1.Seven] = 1;
IsDigit[CharCodes$1.Eight] = 1;
IsDigit[CharCodes$1.Nine] = 1;
var IsNumericPrefix = new Uint8Array(256);
IsNumericPrefix[CharCodes$1.Period] = 1;
IsNumericPrefix[CharCodes$1.Plus] = 1;
IsNumericPrefix[CharCodes$1.Minus] = 1;
var IsNumeric = new Uint8Array(256);
for (var idx$2 = 0, len$1 = 256; idx$2 < len$1; idx$2++) {
  IsNumeric[idx$2] = IsDigit[idx$2] || IsNumericPrefix[idx$2] ? 1 : 0;
}

var Newline = CharCodes$1.Newline,
  CarriageReturn = CharCodes$1.CarriageReturn;
var BaseParser = function () {
  function BaseParser(bytes, capNumbers) {
    if (capNumbers === void 0) {
      capNumbers = false;
    }
    this.bytes = bytes;
    this.capNumbers = capNumbers;
  }
  BaseParser.prototype.parseRawInt = function () {
    var value = '';
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (!IsDigit[byte]) break;
      value += charFromCode(this.bytes.next());
    }
    var numberValue = Number(value);
    if (!value || !isFinite(numberValue)) {
      throw new NumberParsingError(this.bytes.position(), value);
    }
    return numberValue;
  };
  BaseParser.prototype.parseRawNumber = function () {
    var value = '';
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (!IsNumeric[byte]) break;
      value += charFromCode(this.bytes.next());
      if (byte === CharCodes$1.Period) break;
    }
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (!IsDigit[byte]) break;
      value += charFromCode(this.bytes.next());
    }
    var numberValue = Number(value);
    if (!value || !isFinite(numberValue)) {
      throw new NumberParsingError(this.bytes.position(), value);
    }
    if (numberValue > Number.MAX_SAFE_INTEGER) {
      if (this.capNumbers) {
        var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
        console.warn(msg);
        return Number.MAX_SAFE_INTEGER;
      } else {
        var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
        console.warn(msg);
      }
    }
    return numberValue;
  };
  BaseParser.prototype.skipWhitespace = function () {
    while (!this.bytes.done() && IsWhitespace[this.bytes.peek()]) {
      this.bytes.next();
    }
  };
  BaseParser.prototype.skipLine = function () {
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (byte === Newline || byte === CarriageReturn) return;
      this.bytes.next();
    }
  };
  BaseParser.prototype.skipComment = function () {
    if (this.bytes.peek() !== CharCodes$1.Percent) return false;
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (byte === Newline || byte === CarriageReturn) return true;
      this.bytes.next();
    }
    return true;
  };
  BaseParser.prototype.skipWhitespaceAndComments = function () {
    this.skipWhitespace();
    while (this.skipComment()) this.skipWhitespace();
  };
  BaseParser.prototype.matchKeyword = function (keyword) {
    var initialOffset = this.bytes.offset();
    for (var idx = 0, len = keyword.length; idx < len; idx++) {
      if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
        this.bytes.moveTo(initialOffset);
        return false;
      }
    }
    return true;
  };
  return BaseParser;
}();

var ByteStream = function () {
  function ByteStream(bytes) {
    this.idx = 0;
    this.line = 0;
    this.column = 0;
    this.bytes = bytes;
    this.length = this.bytes.length;
  }
  ByteStream.prototype.moveTo = function (offset) {
    this.idx = offset;
  };
  ByteStream.prototype.next = function () {
    var byte = this.bytes[this.idx++];
    if (byte === CharCodes$1.Newline) {
      this.line += 1;
      this.column = 0;
    } else {
      this.column += 1;
    }
    return byte;
  };
  ByteStream.prototype.assertNext = function (expected) {
    if (this.peek() !== expected) {
      throw new NextByteAssertionError(this.position(), expected, this.peek());
    }
    return this.next();
  };
  ByteStream.prototype.peek = function () {
    return this.bytes[this.idx];
  };
  ByteStream.prototype.peekAhead = function (steps) {
    return this.bytes[this.idx + steps];
  };
  ByteStream.prototype.peekAt = function (offset) {
    return this.bytes[offset];
  };
  ByteStream.prototype.done = function () {
    return this.idx >= this.length;
  };
  ByteStream.prototype.offset = function () {
    return this.idx;
  };
  ByteStream.prototype.slice = function (start, end) {
    return this.bytes.slice(start, end);
  };
  ByteStream.prototype.position = function () {
    return {
      line: this.line,
      column: this.column,
      offset: this.idx
    };
  };
  ByteStream.of = function (bytes) {
    return new ByteStream(bytes);
  };
  ByteStream.fromPDFRawStream = function (rawStream) {
    return ByteStream.of(decodePDFRawStream(rawStream).decode());
  };
  return ByteStream;
}();

var Space = CharCodes$1.Space,
  CarriageReturn$1 = CharCodes$1.CarriageReturn,
  Newline$1 = CharCodes$1.Newline;
var stream = [CharCodes$1.s, CharCodes$1.t, CharCodes$1.r, CharCodes$1.e, CharCodes$1.a, CharCodes$1.m];
var endstream = [CharCodes$1.e, CharCodes$1.n, CharCodes$1.d, CharCodes$1.s, CharCodes$1.t, CharCodes$1.r, CharCodes$1.e, CharCodes$1.a, CharCodes$1.m];
var Keywords = {
  header: [CharCodes$1.Percent, CharCodes$1.P, CharCodes$1.D, CharCodes$1.F, CharCodes$1.Dash],
  eof: [CharCodes$1.Percent, CharCodes$1.Percent, CharCodes$1.E, CharCodes$1.O, CharCodes$1.F],
  obj: [CharCodes$1.o, CharCodes$1.b, CharCodes$1.j],
  endobj: [CharCodes$1.e, CharCodes$1.n, CharCodes$1.d, CharCodes$1.o, CharCodes$1.b, CharCodes$1.j],
  xref: [CharCodes$1.x, CharCodes$1.r, CharCodes$1.e, CharCodes$1.f],
  trailer: [CharCodes$1.t, CharCodes$1.r, CharCodes$1.a, CharCodes$1.i, CharCodes$1.l, CharCodes$1.e, CharCodes$1.r],
  startxref: [CharCodes$1.s, CharCodes$1.t, CharCodes$1.a, CharCodes$1.r, CharCodes$1.t, CharCodes$1.x, CharCodes$1.r, CharCodes$1.e, CharCodes$1.f],
  true: [CharCodes$1.t, CharCodes$1.r, CharCodes$1.u, CharCodes$1.e],
  false: [CharCodes$1.f, CharCodes$1.a, CharCodes$1.l, CharCodes$1.s, CharCodes$1.e],
  null: [CharCodes$1.n, CharCodes$1.u, CharCodes$1.l, CharCodes$1.l],
  stream: stream,
  streamEOF1: __spreadArrays(stream, [Space, CarriageReturn$1, Newline$1]),
  streamEOF2: __spreadArrays(stream, [CarriageReturn$1, Newline$1]),
  streamEOF3: __spreadArrays(stream, [CarriageReturn$1]),
  streamEOF4: __spreadArrays(stream, [Newline$1]),
  endstream: endstream,
  EOF1endstream: __spreadArrays([CarriageReturn$1, Newline$1], endstream),
  EOF2endstream: __spreadArrays([CarriageReturn$1], endstream),
  EOF3endstream: __spreadArrays([Newline$1], endstream)
};

var PDFObjectParser = function (_super) {
  __extends(PDFObjectParser, _super);
  function PDFObjectParser(byteStream, context, capNumbers) {
    if (capNumbers === void 0) {
      capNumbers = false;
    }
    var _this = _super.call(this, byteStream, capNumbers) || this;
    _this.context = context;
    return _this;
  }
  PDFObjectParser.prototype.parseObject = function () {
    this.skipWhitespaceAndComments();
    if (this.matchKeyword(Keywords.true)) return PDFBool.True;
    if (this.matchKeyword(Keywords.false)) return PDFBool.False;
    if (this.matchKeyword(Keywords.null)) return PDFNull$1;
    var byte = this.bytes.peek();
    if (byte === CharCodes$1.LessThan && this.bytes.peekAhead(1) === CharCodes$1.LessThan) {
      return this.parseDictOrStream();
    }
    if (byte === CharCodes$1.LessThan) return this.parseHexString();
    if (byte === CharCodes$1.LeftParen) return this.parseString();
    if (byte === CharCodes$1.ForwardSlash) return this.parseName();
    if (byte === CharCodes$1.LeftSquareBracket) return this.parseArray();
    if (IsNumeric[byte]) return this.parseNumberOrRef();
    throw new PDFObjectParsingError(this.bytes.position(), byte);
  };
  PDFObjectParser.prototype.parseNumberOrRef = function () {
    var firstNum = this.parseRawNumber();
    this.skipWhitespaceAndComments();
    var lookaheadStart = this.bytes.offset();
    if (IsDigit[this.bytes.peek()]) {
      var secondNum = this.parseRawNumber();
      this.skipWhitespaceAndComments();
      if (this.bytes.peek() === CharCodes$1.R) {
        this.bytes.assertNext(CharCodes$1.R);
        return PDFRef.of(firstNum, secondNum);
      }
    }
    this.bytes.moveTo(lookaheadStart);
    return PDFNumber.of(firstNum);
  };
  PDFObjectParser.prototype.parseHexString = function () {
    var value = '';
    this.bytes.assertNext(CharCodes$1.LessThan);
    while (!this.bytes.done() && this.bytes.peek() !== CharCodes$1.GreaterThan) {
      value += charFromCode(this.bytes.next());
    }
    this.bytes.assertNext(CharCodes$1.GreaterThan);
    return PDFHexString.of(value);
  };
  PDFObjectParser.prototype.parseString = function () {
    var nestingLvl = 0;
    var isEscaped = false;
    var value = '';
    while (!this.bytes.done()) {
      var byte = this.bytes.next();
      value += charFromCode(byte);
      if (!isEscaped) {
        if (byte === CharCodes$1.LeftParen) nestingLvl += 1;
        if (byte === CharCodes$1.RightParen) nestingLvl -= 1;
      }
      if (byte === CharCodes$1.BackSlash) {
        isEscaped = !isEscaped;
      } else if (isEscaped) {
        isEscaped = false;
      }
      if (nestingLvl === 0) {
        return PDFString.of(value.substring(1, value.length - 1));
      }
    }
    throw new UnbalancedParenthesisError(this.bytes.position());
  };
  PDFObjectParser.prototype.parseName = function () {
    this.bytes.assertNext(CharCodes$1.ForwardSlash);
    var name = '';
    while (!this.bytes.done()) {
      var byte = this.bytes.peek();
      if (IsWhitespace[byte] || IsDelimiter[byte]) break;
      name += charFromCode(byte);
      this.bytes.next();
    }
    return PDFName.of(name);
  };
  PDFObjectParser.prototype.parseArray = function () {
    this.bytes.assertNext(CharCodes$1.LeftSquareBracket);
    this.skipWhitespaceAndComments();
    var pdfArray = PDFArray.withContext(this.context);
    while (this.bytes.peek() !== CharCodes$1.RightSquareBracket) {
      var element = this.parseObject();
      pdfArray.push(element);
      this.skipWhitespaceAndComments();
    }
    this.bytes.assertNext(CharCodes$1.RightSquareBracket);
    return pdfArray;
  };
  PDFObjectParser.prototype.parseDict = function () {
    this.bytes.assertNext(CharCodes$1.LessThan);
    this.bytes.assertNext(CharCodes$1.LessThan);
    this.skipWhitespaceAndComments();
    var dict = new Map();
    while (!this.bytes.done() && this.bytes.peek() !== CharCodes$1.GreaterThan && this.bytes.peekAhead(1) !== CharCodes$1.GreaterThan) {
      var key = this.parseName();
      var value = this.parseObject();
      dict.set(key, value);
      this.skipWhitespaceAndComments();
    }
    this.skipWhitespaceAndComments();
    this.bytes.assertNext(CharCodes$1.GreaterThan);
    this.bytes.assertNext(CharCodes$1.GreaterThan);
    var Type = dict.get(PDFName.of('Type'));
    if (Type === PDFName.of('Catalog')) {
      return PDFCatalog.fromMapWithContext(dict, this.context);
    } else if (Type === PDFName.of('Pages')) {
      return PDFPageTree.fromMapWithContext(dict, this.context);
    } else if (Type === PDFName.of('Page')) {
      return PDFPageLeaf.fromMapWithContext(dict, this.context);
    } else {
      return PDFDict.fromMapWithContext(dict, this.context);
    }
  };
  PDFObjectParser.prototype.parseDictOrStream = function () {
    var startPos = this.bytes.position();
    var dict = this.parseDict();
    this.skipWhitespaceAndComments();
    if (!this.matchKeyword(Keywords.streamEOF1) && !this.matchKeyword(Keywords.streamEOF2) && !this.matchKeyword(Keywords.streamEOF3) && !this.matchKeyword(Keywords.streamEOF4) && !this.matchKeyword(Keywords.stream)) {
      return dict;
    }
    var start = this.bytes.offset();
    var end;
    var Length = dict.get(PDFName.of('Length'));
    if (Length instanceof PDFNumber) {
      end = start + Length.asNumber();
      this.bytes.moveTo(end);
      this.skipWhitespaceAndComments();
      if (!this.matchKeyword(Keywords.endstream)) {
        this.bytes.moveTo(start);
        end = this.findEndOfStreamFallback(startPos);
      }
    } else {
      end = this.findEndOfStreamFallback(startPos);
    }
    var contents = this.bytes.slice(start, end);
    return PDFRawStream.of(dict, contents);
  };
  PDFObjectParser.prototype.findEndOfStreamFallback = function (startPos) {
    var nestingLvl = 1;
    var end = this.bytes.offset();
    while (!this.bytes.done()) {
      end = this.bytes.offset();
      if (this.matchKeyword(Keywords.stream)) {
        nestingLvl += 1;
      } else if (this.matchKeyword(Keywords.EOF1endstream) || this.matchKeyword(Keywords.EOF2endstream) || this.matchKeyword(Keywords.EOF3endstream) || this.matchKeyword(Keywords.endstream)) {
        nestingLvl -= 1;
      } else {
        this.bytes.next();
      }
      if (nestingLvl === 0) break;
    }
    if (nestingLvl !== 0) throw new PDFStreamParsingError(startPos);
    return end;
  };
  PDFObjectParser.forBytes = function (bytes, context, capNumbers) {
    return new PDFObjectParser(ByteStream.of(bytes), context, capNumbers);
  };
  PDFObjectParser.forByteStream = function (byteStream, context, capNumbers) {
    if (capNumbers === void 0) {
      capNumbers = false;
    }
    return new PDFObjectParser(byteStream, context, capNumbers);
  };
  return PDFObjectParser;
}(BaseParser);

var PDFObjectStreamParser = function (_super) {
  __extends(PDFObjectStreamParser, _super);
  function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
    var _this = _super.call(this, ByteStream.fromPDFRawStream(rawStream), rawStream.dict.context) || this;
    var dict = rawStream.dict;
    _this.alreadyParsed = false;
    _this.shouldWaitForTick = shouldWaitForTick || function () {
      return false;
    };
    _this.firstOffset = dict.lookup(PDFName.of('First'), PDFNumber).asNumber();
    _this.objectCount = dict.lookup(PDFName.of('N'), PDFNumber).asNumber();
    return _this;
  }
  PDFObjectStreamParser.prototype.parseIntoContext = function () {
    return __awaiter(this, void 0, void 0, function () {
      var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (this.alreadyParsed) {
              throw new ReparseError('PDFObjectStreamParser', 'parseIntoContext');
            }
            this.alreadyParsed = true;
            offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
            idx = 0, len = offsetsAndObjectNumbers.length;
            _b.label = 1;
          case 1:
            if (!(idx < len)) return [3, 4];
            _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
            this.bytes.moveTo(this.firstOffset + offset);
            object = this.parseObject();
            ref = PDFRef.of(objectNumber, 0);
            this.context.assign(ref, object);
            if (!this.shouldWaitForTick()) return [3, 3];
            return [4, waitForTick()];
          case 2:
            _b.sent();
            _b.label = 3;
          case 3:
            idx++;
            return [3, 1];
          case 4:
            return [2];
        }
      });
    });
  };
  PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function () {
    var offsetsAndObjectNumbers = [];
    for (var idx = 0, len = this.objectCount; idx < len; idx++) {
      this.skipWhitespaceAndComments();
      var objectNumber = this.parseRawInt();
      this.skipWhitespaceAndComments();
      var offset = this.parseRawInt();
      offsetsAndObjectNumbers.push({
        objectNumber: objectNumber,
        offset: offset
      });
    }
    return offsetsAndObjectNumbers;
  };
  PDFObjectStreamParser.forStream = function (rawStream, shouldWaitForTick) {
    return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
  };
  return PDFObjectStreamParser;
}(PDFObjectParser);

var PDFXRefStreamParser = function () {
  function PDFXRefStreamParser(rawStream) {
    this.alreadyParsed = false;
    this.dict = rawStream.dict;
    this.bytes = ByteStream.fromPDFRawStream(rawStream);
    this.context = this.dict.context;
    var Size = this.dict.lookup(PDFName.of('Size'), PDFNumber);
    var Index = this.dict.lookup(PDFName.of('Index'));
    if (Index instanceof PDFArray) {
      this.subsections = [];
      for (var idx = 0, len = Index.size(); idx < len; idx += 2) {
        var firstObjectNumber = Index.lookup(idx + 0, PDFNumber).asNumber();
        var length_1 = Index.lookup(idx + 1, PDFNumber).asNumber();
        this.subsections.push({
          firstObjectNumber: firstObjectNumber,
          length: length_1
        });
      }
    } else {
      this.subsections = [{
        firstObjectNumber: 0,
        length: Size.asNumber()
      }];
    }
    var W = this.dict.lookup(PDFName.of('W'), PDFArray);
    this.byteWidths = [-1, -1, -1];
    for (var idx = 0, len = W.size(); idx < len; idx++) {
      this.byteWidths[idx] = W.lookup(idx, PDFNumber).asNumber();
    }
  }
  PDFXRefStreamParser.prototype.parseIntoContext = function () {
    if (this.alreadyParsed) {
      throw new ReparseError('PDFXRefStreamParser', 'parseIntoContext');
    }
    this.alreadyParsed = true;
    this.context.trailerInfo = {
      Root: this.dict.get(PDFName.of('Root')),
      Encrypt: this.dict.get(PDFName.of('Encrypt')),
      Info: this.dict.get(PDFName.of('Info')),
      ID: this.dict.get(PDFName.of('ID'))
    };
    var entries = this.parseEntries();
    return entries;
  };
  PDFXRefStreamParser.prototype.parseEntries = function () {
    var entries = [];
    var _a = this.byteWidths,
      typeFieldWidth = _a[0],
      offsetFieldWidth = _a[1],
      genFieldWidth = _a[2];
    for (var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++) {
      var _b = this.subsections[subsectionIdx],
        firstObjectNumber = _b.firstObjectNumber,
        length_2 = _b.length;
      for (var objIdx = 0; objIdx < length_2; objIdx++) {
        var type = 0;
        for (var idx = 0, len = typeFieldWidth; idx < len; idx++) {
          type = type << 8 | this.bytes.next();
        }
        var offset = 0;
        for (var idx = 0, len = offsetFieldWidth; idx < len; idx++) {
          offset = offset << 8 | this.bytes.next();
        }
        var generationNumber = 0;
        for (var idx = 0, len = genFieldWidth; idx < len; idx++) {
          generationNumber = generationNumber << 8 | this.bytes.next();
        }
        if (typeFieldWidth === 0) type = 1;
        var objectNumber = firstObjectNumber + objIdx;
        var entry = {
          ref: PDFRef.of(objectNumber, generationNumber),
          offset: offset,
          deleted: type === 0,
          inObjectStream: type === 2
        };
        entries.push(entry);
      }
    }
    return entries;
  };
  PDFXRefStreamParser.forStream = function (rawStream) {
    return new PDFXRefStreamParser(rawStream);
  };
  return PDFXRefStreamParser;
}();

var PDFParser = function (_super) {
  __extends(PDFParser, _super);
  function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
    if (objectsPerTick === void 0) {
      objectsPerTick = Infinity;
    }
    if (throwOnInvalidObject === void 0) {
      throwOnInvalidObject = false;
    }
    if (capNumbers === void 0) {
      capNumbers = false;
    }
    var _this = _super.call(this, ByteStream.of(pdfBytes), PDFContext.create(), capNumbers) || this;
    _this.alreadyParsed = false;
    _this.parsedObjects = 0;
    _this.shouldWaitForTick = function () {
      _this.parsedObjects += 1;
      return _this.parsedObjects % _this.objectsPerTick === 0;
    };
    _this.objectsPerTick = objectsPerTick;
    _this.throwOnInvalidObject = throwOnInvalidObject;
    return _this;
  }
  PDFParser.prototype.parseDocument = function () {
    return __awaiter(this, void 0, void 0, function () {
      var prevOffset, offset;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.alreadyParsed) {
              throw new ReparseError('PDFParser', 'parseDocument');
            }
            this.alreadyParsed = true;
            this.context.header = this.parseHeader();
            _a.label = 1;
          case 1:
            if (!!this.bytes.done()) return [3, 3];
            return [4, this.parseDocumentSection()];
          case 2:
            _a.sent();
            offset = this.bytes.offset();
            if (offset === prevOffset) {
              throw new StalledParserError(this.bytes.position());
            }
            prevOffset = offset;
            return [3, 1];
          case 3:
            this.maybeRecoverRoot();
            if (this.context.lookup(PDFRef.of(0))) {
              console.warn('Removing parsed object: 0 0 R');
              this.context.delete(PDFRef.of(0));
            }
            return [2, this.context];
        }
      });
    });
  };
  PDFParser.prototype.maybeRecoverRoot = function () {
    var isValidCatalog = function (obj) {
      return obj instanceof PDFDict && obj.lookup(PDFName.of('Type')) === PDFName.of('Catalog');
    };
    var catalog = this.context.lookup(this.context.trailerInfo.Root);
    if (!isValidCatalog(catalog)) {
      var indirectObjects = this.context.enumerateIndirectObjects();
      for (var idx = 0, len = indirectObjects.length; idx < len; idx++) {
        var _a = indirectObjects[idx],
          ref = _a[0],
          object = _a[1];
        if (isValidCatalog(object)) {
          this.context.trailerInfo.Root = ref;
        }
      }
    }
  };
  PDFParser.prototype.parseHeader = function () {
    while (!this.bytes.done()) {
      if (this.matchKeyword(Keywords.header)) {
        var major = this.parseRawInt();
        this.bytes.assertNext(CharCodes$1.Period);
        var minor = this.parseRawInt();
        var header = PDFHeader.forVersion(major, minor);
        this.skipBinaryHeaderComment();
        return header;
      }
      this.bytes.next();
    }
    throw new MissingPDFHeaderError(this.bytes.position());
  };
  PDFParser.prototype.parseIndirectObjectHeader = function () {
    this.skipWhitespaceAndComments();
    var objectNumber = this.parseRawInt();
    this.skipWhitespaceAndComments();
    var generationNumber = this.parseRawInt();
    this.skipWhitespaceAndComments();
    if (!this.matchKeyword(Keywords.obj)) {
      throw new MissingKeywordError(this.bytes.position(), Keywords.obj);
    }
    return PDFRef.of(objectNumber, generationNumber);
  };
  PDFParser.prototype.matchIndirectObjectHeader = function () {
    var initialOffset = this.bytes.offset();
    try {
      this.parseIndirectObjectHeader();
      return true;
    } catch (e) {
      this.bytes.moveTo(initialOffset);
      return false;
    }
  };
  PDFParser.prototype.parseIndirectObject = function () {
    return __awaiter(this, void 0, void 0, function () {
      var ref, object;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ref = this.parseIndirectObjectHeader();
            this.skipWhitespaceAndComments();
            object = this.parseObject();
            this.skipWhitespaceAndComments();
            this.matchKeyword(Keywords.endobj);
            if (!(object instanceof PDFRawStream && object.dict.lookup(PDFName.of('Type')) === PDFName.of('ObjStm'))) return [3, 2];
            return [4, PDFObjectStreamParser.forStream(object, this.shouldWaitForTick).parseIntoContext()];
          case 1:
            _a.sent();
            return [3, 3];
          case 2:
            if (object instanceof PDFRawStream && object.dict.lookup(PDFName.of('Type')) === PDFName.of('XRef')) {
              PDFXRefStreamParser.forStream(object).parseIntoContext();
            } else {
              this.context.assign(ref, object);
            }
            _a.label = 3;
          case 3:
            return [2, ref];
        }
      });
    });
  };
  PDFParser.prototype.tryToParseInvalidIndirectObject = function () {
    var startPos = this.bytes.position();
    var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
    if (this.throwOnInvalidObject) throw new Error(msg);
    console.warn(msg);
    var ref = this.parseIndirectObjectHeader();
    console.warn("Invalid object ref: " + ref);
    this.skipWhitespaceAndComments();
    var start = this.bytes.offset();
    var failed = true;
    while (!this.bytes.done()) {
      if (this.matchKeyword(Keywords.endobj)) {
        failed = false;
      }
      if (!failed) break;
      this.bytes.next();
    }
    if (failed) throw new PDFInvalidObjectParsingError(startPos);
    var end = this.bytes.offset() - Keywords.endobj.length;
    var object = PDFInvalidObject.of(this.bytes.slice(start, end));
    this.context.assign(ref, object);
    return ref;
  };
  PDFParser.prototype.parseIndirectObjects = function () {
    return __awaiter(this, void 0, void 0, function () {
      var initialOffset, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.skipWhitespaceAndComments();
            _a.label = 1;
          case 1:
            if (!(!this.bytes.done() && IsDigit[this.bytes.peek()])) return [3, 8];
            initialOffset = this.bytes.offset();
            _a.label = 2;
          case 2:
            _a.trys.push([2, 4,, 5]);
            return [4, this.parseIndirectObject()];
          case 3:
            _a.sent();
            return [3, 5];
          case 4:
            e_1 = _a.sent();
            this.bytes.moveTo(initialOffset);
            this.tryToParseInvalidIndirectObject();
            return [3, 5];
          case 5:
            this.skipWhitespaceAndComments();
            this.skipJibberish();
            if (!this.shouldWaitForTick()) return [3, 7];
            return [4, waitForTick()];
          case 6:
            _a.sent();
            _a.label = 7;
          case 7:
            return [3, 1];
          case 8:
            return [2];
        }
      });
    });
  };
  PDFParser.prototype.maybeParseCrossRefSection = function () {
    this.skipWhitespaceAndComments();
    if (!this.matchKeyword(Keywords.xref)) return;
    this.skipWhitespaceAndComments();
    var objectNumber = -1;
    var xref = PDFCrossRefSection.createEmpty();
    while (!this.bytes.done() && IsDigit[this.bytes.peek()]) {
      var firstInt = this.parseRawInt();
      this.skipWhitespaceAndComments();
      var secondInt = this.parseRawInt();
      this.skipWhitespaceAndComments();
      var byte = this.bytes.peek();
      if (byte === CharCodes$1.n || byte === CharCodes$1.f) {
        var ref = PDFRef.of(objectNumber, secondInt);
        if (this.bytes.next() === CharCodes$1.n) {
          xref.addEntry(ref, firstInt);
        } else {
          xref.addDeletedEntry(ref, firstInt);
        }
        objectNumber += 1;
      } else {
        objectNumber = firstInt;
      }
      this.skipWhitespaceAndComments();
    }
    return xref;
  };
  PDFParser.prototype.maybeParseTrailerDict = function () {
    this.skipWhitespaceAndComments();
    if (!this.matchKeyword(Keywords.trailer)) return;
    this.skipWhitespaceAndComments();
    var dict = this.parseDict();
    var context = this.context;
    context.trailerInfo = {
      Root: dict.get(PDFName.of('Root')) || context.trailerInfo.Root,
      Encrypt: dict.get(PDFName.of('Encrypt')) || context.trailerInfo.Encrypt,
      Info: dict.get(PDFName.of('Info')) || context.trailerInfo.Info,
      ID: dict.get(PDFName.of('ID')) || context.trailerInfo.ID
    };
  };
  PDFParser.prototype.maybeParseTrailer = function () {
    this.skipWhitespaceAndComments();
    if (!this.matchKeyword(Keywords.startxref)) return;
    this.skipWhitespaceAndComments();
    var offset = this.parseRawInt();
    this.skipWhitespace();
    this.matchKeyword(Keywords.eof);
    this.skipWhitespaceAndComments();
    this.matchKeyword(Keywords.eof);
    this.skipWhitespaceAndComments();
    return PDFTrailer.forLastCrossRefSectionOffset(offset);
  };
  PDFParser.prototype.parseDocumentSection = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.parseIndirectObjects()];
          case 1:
            _a.sent();
            this.maybeParseCrossRefSection();
            this.maybeParseTrailerDict();
            this.maybeParseTrailer();
            this.skipJibberish();
            return [2];
        }
      });
    });
  };
  PDFParser.prototype.skipJibberish = function () {
    this.skipWhitespaceAndComments();
    while (!this.bytes.done()) {
      var initialOffset = this.bytes.offset();
      var byte = this.bytes.peek();
      var isAlphaNumeric = byte >= CharCodes$1.Space && byte <= CharCodes$1.Tilde;
      if (isAlphaNumeric) {
        if (this.matchKeyword(Keywords.xref) || this.matchKeyword(Keywords.trailer) || this.matchKeyword(Keywords.startxref) || this.matchIndirectObjectHeader()) {
          this.bytes.moveTo(initialOffset);
          break;
        }
      }
      this.bytes.next();
    }
  };
  PDFParser.prototype.skipBinaryHeaderComment = function () {
    this.skipWhitespaceAndComments();
    try {
      var initialOffset = this.bytes.offset();
      this.parseIndirectObjectHeader();
      this.bytes.moveTo(initialOffset);
    } catch (e) {
      this.bytes.next();
      this.skipWhitespaceAndComments();
    }
  };
  PDFParser.forBytesWithOptions = function (pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
    return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
  };
  return PDFParser;
}(PDFObjectParser);

var flag$1 = function (bitIndex) {
  return 1 << bitIndex;
};
var AnnotationFlags;
(function (AnnotationFlags) {
  AnnotationFlags[AnnotationFlags["Invisible"] = flag$1(1 - 1)] = "Invisible";
  AnnotationFlags[AnnotationFlags["Hidden"] = flag$1(2 - 1)] = "Hidden";
  AnnotationFlags[AnnotationFlags["Print"] = flag$1(3 - 1)] = "Print";
  AnnotationFlags[AnnotationFlags["NoZoom"] = flag$1(4 - 1)] = "NoZoom";
  AnnotationFlags[AnnotationFlags["NoRotate"] = flag$1(5 - 1)] = "NoRotate";
  AnnotationFlags[AnnotationFlags["NoView"] = flag$1(6 - 1)] = "NoView";
  AnnotationFlags[AnnotationFlags["ReadOnly"] = flag$1(7 - 1)] = "ReadOnly";
  AnnotationFlags[AnnotationFlags["Locked"] = flag$1(8 - 1)] = "Locked";
  AnnotationFlags[AnnotationFlags["ToggleNoView"] = flag$1(9 - 1)] = "ToggleNoView";
  AnnotationFlags[AnnotationFlags["LockedContents"] = flag$1(10 - 1)] = "LockedContents";
})(AnnotationFlags || (AnnotationFlags = {}));

var asPDFName = function (name) {
  return name instanceof PDFName ? name : PDFName.of(name);
};
var asPDFNumber = function (num) {
  return num instanceof PDFNumber ? num : PDFNumber.of(num);
};
var asNumber = function (num) {
  return num instanceof PDFNumber ? num.asNumber() : num;
};

var RotationTypes;
(function (RotationTypes) {
  RotationTypes["Degrees"] = "degrees";
  RotationTypes["Radians"] = "radians";
})(RotationTypes || (RotationTypes = {}));
var radians = function (radianAngle) {
  assertIs(radianAngle, 'radianAngle', ['number']);
  return {
    type: RotationTypes.Radians,
    angle: radianAngle
  };
};
var degrees = function (degreeAngle) {
  assertIs(degreeAngle, 'degreeAngle', ['number']);
  return {
    type: RotationTypes.Degrees,
    angle: degreeAngle
  };
};
var Radians = RotationTypes.Radians,
  Degrees = RotationTypes.Degrees;
var degreesToRadians = function (degree) {
  return degree * Math.PI / 180;
};
var radiansToDegrees = function (radian) {
  return radian * 180 / Math.PI;
};
var toRadians = function (rotation) {
  return rotation.type === Radians ? rotation.angle : rotation.type === Degrees ? degreesToRadians(rotation.angle) : error("Invalid rotation: " + JSON.stringify(rotation));
};
var toDegrees = function (rotation) {
  return rotation.type === Radians ? radiansToDegrees(rotation.angle) : rotation.type === Degrees ? rotation.angle : error("Invalid rotation: " + JSON.stringify(rotation));
};
var reduceRotation = function (degreeAngle) {
  if (degreeAngle === void 0) {
    degreeAngle = 0;
  }
  var quadrants = degreeAngle / 90 % 4;
  if (quadrants === 0) return 0;
  if (quadrants === 1) return 90;
  if (quadrants === 2) return 180;
  if (quadrants === 3) return 270;
  return 0;
};
var adjustDimsForRotation = function (dims, degreeAngle) {
  if (degreeAngle === void 0) {
    degreeAngle = 0;
  }
  var rotation = reduceRotation(degreeAngle);
  return rotation === 90 || rotation === 270 ? {
    width: dims.height,
    height: dims.width
  } : {
    width: dims.width,
    height: dims.height
  };
};
var rotateRectangle = function (rectangle, borderWidth, degreeAngle) {
  if (borderWidth === void 0) {
    borderWidth = 0;
  }
  if (degreeAngle === void 0) {
    degreeAngle = 0;
  }
  var x = rectangle.x,
    y = rectangle.y,
    w = rectangle.width,
    h = rectangle.height;
  var r = reduceRotation(degreeAngle);
  var b = borderWidth / 2;
  if (r === 0) return {
    x: x - b,
    y: y - b,
    width: w,
    height: h
  };else if (r === 90) return {
    x: x - h + b,
    y: y - b,
    width: h,
    height: w
  };else if (r === 180) return {
    x: x - w + b,
    y: y - h + b,
    width: w,
    height: h
  };else if (r === 270) return {
    x: x - b,
    y: y - w + b,
    width: h,
    height: w
  };else return {
    x: x - b,
    y: y - b,
    width: w,
    height: h
  };
};

var clip = function () {
  return PDFOperator.of(Ops.ClipNonZero);
};
var clipEvenOdd = function () {
  return PDFOperator.of(Ops.ClipEvenOdd);
};
var cos = Math.cos,
  sin = Math.sin,
  tan = Math.tan;
var concatTransformationMatrix = function (a, b, c, d, e, f) {
  return PDFOperator.of(Ops.ConcatTransformationMatrix, [asPDFNumber(a), asPDFNumber(b), asPDFNumber(c), asPDFNumber(d), asPDFNumber(e), asPDFNumber(f)]);
};
var translate = function (xPos, yPos) {
  return concatTransformationMatrix(1, 0, 0, 1, xPos, yPos);
};
var scale = function (xPos, yPos) {
  return concatTransformationMatrix(xPos, 0, 0, yPos, 0, 0);
};
var rotateRadians = function (angle) {
  return concatTransformationMatrix(cos(asNumber(angle)), sin(asNumber(angle)), -sin(asNumber(angle)), cos(asNumber(angle)), 0, 0);
};
var rotateDegrees = function (angle) {
  return rotateRadians(degreesToRadians(asNumber(angle)));
};
var skewRadians = function (xSkewAngle, ySkewAngle) {
  return concatTransformationMatrix(1, tan(asNumber(xSkewAngle)), tan(asNumber(ySkewAngle)), 1, 0, 0);
};
var skewDegrees = function (xSkewAngle, ySkewAngle) {
  return skewRadians(degreesToRadians(asNumber(xSkewAngle)), degreesToRadians(asNumber(ySkewAngle)));
};
var setDashPattern = function (dashArray, dashPhase) {
  return PDFOperator.of(Ops.SetLineDashPattern, ["[" + dashArray.map(asPDFNumber).join(' ') + "]", asPDFNumber(dashPhase)]);
};
var restoreDashPattern = function () {
  return setDashPattern([], 0);
};
var LineCapStyle;
(function (LineCapStyle) {
  LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
  LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
  LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})(LineCapStyle || (LineCapStyle = {}));
var setLineCap = function (style) {
  return PDFOperator.of(Ops.SetLineCapStyle, [asPDFNumber(style)]);
};
var LineJoinStyle;
(function (LineJoinStyle) {
  LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
  LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
  LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})(LineJoinStyle || (LineJoinStyle = {}));
var setLineJoin = function (style) {
  return PDFOperator.of(Ops.SetLineJoinStyle, [asPDFNumber(style)]);
};
var setGraphicsState = function (state) {
  return PDFOperator.of(Ops.SetGraphicsStateParams, [asPDFName(state)]);
};
var pushGraphicsState = function () {
  return PDFOperator.of(Ops.PushGraphicsState);
};
var popGraphicsState = function () {
  return PDFOperator.of(Ops.PopGraphicsState);
};
var setLineWidth = function (width) {
  return PDFOperator.of(Ops.SetLineWidth, [asPDFNumber(width)]);
};
var appendBezierCurve = function (x1, y1, x2, y2, x3, y3) {
  return PDFOperator.of(Ops.AppendBezierCurve, [asPDFNumber(x1), asPDFNumber(y1), asPDFNumber(x2), asPDFNumber(y2), asPDFNumber(x3), asPDFNumber(y3)]);
};
var appendQuadraticCurve = function (x1, y1, x2, y2) {
  return PDFOperator.of(Ops.CurveToReplicateInitialPoint, [asPDFNumber(x1), asPDFNumber(y1), asPDFNumber(x2), asPDFNumber(y2)]);
};
var closePath = function () {
  return PDFOperator.of(Ops.ClosePath);
};
var moveTo = function (xPos, yPos) {
  return PDFOperator.of(Ops.MoveTo, [asPDFNumber(xPos), asPDFNumber(yPos)]);
};
var lineTo = function (xPos, yPos) {
  return PDFOperator.of(Ops.LineTo, [asPDFNumber(xPos), asPDFNumber(yPos)]);
};
var rectangle = function (xPos, yPos, width, height) {
  return PDFOperator.of(Ops.AppendRectangle, [asPDFNumber(xPos), asPDFNumber(yPos), asPDFNumber(width), asPDFNumber(height)]);
};
var square = function (xPos, yPos, size) {
  return rectangle(xPos, yPos, size, size);
};
var stroke = function () {
  return PDFOperator.of(Ops.StrokePath);
};
var fill = function () {
  return PDFOperator.of(Ops.FillNonZero);
};
var fillAndStroke = function () {
  return PDFOperator.of(Ops.FillNonZeroAndStroke);
};
var endPath = function () {
  return PDFOperator.of(Ops.EndPath);
};
var nextLine = function () {
  return PDFOperator.of(Ops.NextLine);
};
var moveText = function (x, y) {
  return PDFOperator.of(Ops.MoveText, [asPDFNumber(x), asPDFNumber(y)]);
};
var showText = function (text) {
  return PDFOperator.of(Ops.ShowText, [text]);
};
var beginText = function () {
  return PDFOperator.of(Ops.BeginText);
};
var endText = function () {
  return PDFOperator.of(Ops.EndText);
};
var setFontAndSize = function (name, size) {
  return PDFOperator.of(Ops.SetFontAndSize, [asPDFName(name), asPDFNumber(size)]);
};
var setCharacterSpacing = function (spacing) {
  return PDFOperator.of(Ops.SetCharacterSpacing, [asPDFNumber(spacing)]);
};
var setWordSpacing = function (spacing) {
  return PDFOperator.of(Ops.SetWordSpacing, [asPDFNumber(spacing)]);
};
var setCharacterSqueeze = function (squeeze) {
  return PDFOperator.of(Ops.SetTextHorizontalScaling, [asPDFNumber(squeeze)]);
};
var setLineHeight = function (lineHeight) {
  return PDFOperator.of(Ops.SetTextLineHeight, [asPDFNumber(lineHeight)]);
};
var setTextRise = function (rise) {
  return PDFOperator.of(Ops.SetTextRise, [asPDFNumber(rise)]);
};
var TextRenderingMode;
(function (TextRenderingMode) {
  TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
  TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
  TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
  TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
  TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
  TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
  TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
  TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})(TextRenderingMode || (TextRenderingMode = {}));
var setTextRenderingMode = function (mode) {
  return PDFOperator.of(Ops.SetTextRenderingMode, [asPDFNumber(mode)]);
};
var setTextMatrix = function (a, b, c, d, e, f) {
  return PDFOperator.of(Ops.SetTextMatrix, [asPDFNumber(a), asPDFNumber(b), asPDFNumber(c), asPDFNumber(d), asPDFNumber(e), asPDFNumber(f)]);
};
var rotateAndSkewTextRadiansAndTranslate = function (rotationAngle, xSkewAngle, ySkewAngle, x, y) {
  return setTextMatrix(cos(asNumber(rotationAngle)), sin(asNumber(rotationAngle)) + tan(asNumber(xSkewAngle)), -sin(asNumber(rotationAngle)) + tan(asNumber(ySkewAngle)), cos(asNumber(rotationAngle)), x, y);
};
var rotateAndSkewTextDegreesAndTranslate = function (rotationAngle, xSkewAngle, ySkewAngle, x, y) {
  return rotateAndSkewTextRadiansAndTranslate(degreesToRadians(asNumber(rotationAngle)), degreesToRadians(asNumber(xSkewAngle)), degreesToRadians(asNumber(ySkewAngle)), x, y);
};
var drawObject = function (name) {
  return PDFOperator.of(Ops.DrawObject, [asPDFName(name)]);
};
var setFillingGrayscaleColor = function (gray) {
  return PDFOperator.of(Ops.NonStrokingColorGray, [asPDFNumber(gray)]);
};
var setStrokingGrayscaleColor = function (gray) {
  return PDFOperator.of(Ops.StrokingColorGray, [asPDFNumber(gray)]);
};
var setFillingRgbColor = function (red, green, blue) {
  return PDFOperator.of(Ops.NonStrokingColorRgb, [asPDFNumber(red), asPDFNumber(green), asPDFNumber(blue)]);
};
var setStrokingRgbColor = function (red, green, blue) {
  return PDFOperator.of(Ops.StrokingColorRgb, [asPDFNumber(red), asPDFNumber(green), asPDFNumber(blue)]);
};
var setFillingCmykColor = function (cyan, magenta, yellow, key) {
  return PDFOperator.of(Ops.NonStrokingColorCmyk, [asPDFNumber(cyan), asPDFNumber(magenta), asPDFNumber(yellow), asPDFNumber(key)]);
};
var setStrokingCmykColor = function (cyan, magenta, yellow, key) {
  return PDFOperator.of(Ops.StrokingColorCmyk, [asPDFNumber(cyan), asPDFNumber(magenta), asPDFNumber(yellow), asPDFNumber(key)]);
};
var beginMarkedContent = function (tag) {
  return PDFOperator.of(Ops.BeginMarkedContent, [asPDFName(tag)]);
};
var endMarkedContent = function () {
  return PDFOperator.of(Ops.EndMarkedContent);
};

var ColorTypes;
(function (ColorTypes) {
  ColorTypes["Grayscale"] = "Grayscale";
  ColorTypes["RGB"] = "RGB";
  ColorTypes["CMYK"] = "CMYK";
})(ColorTypes || (ColorTypes = {}));
var grayscale = function (gray) {
  assertRange(gray, 'gray', 0.0, 1.0);
  return {
    type: ColorTypes.Grayscale,
    gray: gray
  };
};
var rgb = function (red, green, blue) {
  assertRange(red, 'red', 0, 1);
  assertRange(green, 'green', 0, 1);
  assertRange(blue, 'blue', 0, 1);
  return {
    type: ColorTypes.RGB,
    red: red,
    green: green,
    blue: blue
  };
};
var cmyk = function (cyan, magenta, yellow, key) {
  assertRange(cyan, 'cyan', 0, 1);
  assertRange(magenta, 'magenta', 0, 1);
  assertRange(yellow, 'yellow', 0, 1);
  assertRange(key, 'key', 0, 1);
  return {
    type: ColorTypes.CMYK,
    cyan: cyan,
    magenta: magenta,
    yellow: yellow,
    key: key
  };
};
var Grayscale = ColorTypes.Grayscale,
  RGB = ColorTypes.RGB,
  CMYK = ColorTypes.CMYK;
var setFillingColor = function (color) {
  return color.type === Grayscale ? setFillingGrayscaleColor(color.gray) : color.type === RGB ? setFillingRgbColor(color.red, color.green, color.blue) : color.type === CMYK ? setFillingCmykColor(color.cyan, color.magenta, color.yellow, color.key) : error("Invalid color: " + JSON.stringify(color));
};
var setStrokingColor = function (color) {
  return color.type === Grayscale ? setStrokingGrayscaleColor(color.gray) : color.type === RGB ? setStrokingRgbColor(color.red, color.green, color.blue) : color.type === CMYK ? setStrokingCmykColor(color.cyan, color.magenta, color.yellow, color.key) : error("Invalid color: " + JSON.stringify(color));
};
var componentsToColor = function (comps, scale) {
  if (scale === void 0) {
    scale = 1;
  }
  return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? grayscale(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? rgb(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? cmyk(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var colorToComponents = function (color) {
  return color.type === Grayscale ? [color.gray] : color.type === RGB ? [color.red, color.green, color.blue] : color.type === CMYK ? [color.cyan, color.magenta, color.yellow, color.key] : error("Invalid color: " + JSON.stringify(color));
};

var cx = 0;
var cy = 0;
var px = 0;
var py = 0;
var sx = 0;
var sy = 0;
var parameters = new Map([['A', 7], ['a', 7], ['C', 6], ['c', 6], ['H', 1], ['h', 1], ['L', 2], ['l', 2], ['M', 2], ['m', 2], ['Q', 4], ['q', 4], ['S', 4], ['s', 4], ['T', 2], ['t', 2], ['V', 1], ['v', 1], ['Z', 0], ['z', 0]]);
var parse = function (path) {
  var cmd;
  var ret = [];
  var args = [];
  var curArg = '';
  var foundDecimal = false;
  var params = 0;
  for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
    var c = path_1[_i];
    if (parameters.has(c)) {
      params = parameters.get(c);
      if (cmd) {
        if (curArg.length > 0) {
          args[args.length] = +curArg;
        }
        ret[ret.length] = {
          cmd: cmd,
          args: args
        };
        args = [];
        curArg = '';
        foundDecimal = false;
      }
      cmd = c;
    } else if ([' ', ','].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
      if (curArg.length === 0) {
        continue;
      }
      if (args.length === params) {
        ret[ret.length] = {
          cmd: cmd,
          args: args
        };
        args = [+curArg];
        if (cmd === 'M') {
          cmd = 'L';
        }
        if (cmd === 'm') {
          cmd = 'l';
        }
      } else {
        args[args.length] = +curArg;
      }
      foundDecimal = c === '.';
      curArg = ['-', '.'].includes(c) ? c : '';
    } else {
      curArg += c;
      if (c === '.') {
        foundDecimal = true;
      }
    }
  }
  if (curArg.length > 0) {
    if (args.length === params) {
      ret[ret.length] = {
        cmd: cmd,
        args: args
      };
      args = [+curArg];
      if (cmd === 'M') {
        cmd = 'L';
      }
      if (cmd === 'm') {
        cmd = 'l';
      }
    } else {
      args[args.length] = +curArg;
    }
  }
  ret[ret.length] = {
    cmd: cmd,
    args: args
  };
  return ret;
};
var apply = function (commands) {
  cx = cy = px = py = sx = sy = 0;
  var cmds = [];
  for (var i = 0; i < commands.length; i++) {
    var c = commands[i];
    if (c.cmd && typeof runners[c.cmd] === 'function') {
      var cmd = runners[c.cmd](c.args);
      if (Array.isArray(cmd)) {
        cmds = cmds.concat(cmd);
      } else {
        cmds.push(cmd);
      }
    }
  }
  return cmds;
};
var runners = {
  M: function (a) {
    cx = a[0];
    cy = a[1];
    px = py = null;
    sx = cx;
    sy = cy;
    return moveTo(cx, cy);
  },
  m: function (a) {
    cx += a[0];
    cy += a[1];
    px = py = null;
    sx = cx;
    sy = cy;
    return moveTo(cx, cy);
  },
  C: function (a) {
    cx = a[4];
    cy = a[5];
    px = a[2];
    py = a[3];
    return appendBezierCurve(a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  c: function (a) {
    var cmd = appendBezierCurve(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
    px = cx + a[2];
    py = cy + a[3];
    cx += a[4];
    cy += a[5];
    return cmd;
  },
  S: function (a) {
    if (px === null || py === null) {
      px = cx;
      py = cy;
    }
    var cmd = appendBezierCurve(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
    px = a[0];
    py = a[1];
    cx = a[2];
    cy = a[3];
    return cmd;
  },
  s: function (a) {
    if (px === null || py === null) {
      px = cx;
      py = cy;
    }
    var cmd = appendBezierCurve(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
    px = cx + a[0];
    py = cy + a[1];
    cx += a[2];
    cy += a[3];
    return cmd;
  },
  Q: function (a) {
    px = a[0];
    py = a[1];
    cx = a[2];
    cy = a[3];
    return appendQuadraticCurve(a[0], a[1], cx, cy);
  },
  q: function (a) {
    var cmd = appendQuadraticCurve(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
    px = cx + a[0];
    py = cy + a[1];
    cx += a[2];
    cy += a[3];
    return cmd;
  },
  T: function (a) {
    if (px === null || py === null) {
      px = cx;
      py = cy;
    } else {
      px = cx - (px - cx);
      py = cy - (py - cy);
    }
    var cmd = appendQuadraticCurve(px, py, a[0], a[1]);
    px = cx - (px - cx);
    py = cy - (py - cy);
    cx = a[0];
    cy = a[1];
    return cmd;
  },
  t: function (a) {
    if (px === null || py === null) {
      px = cx;
      py = cy;
    } else {
      px = cx - (px - cx);
      py = cy - (py - cy);
    }
    var cmd = appendQuadraticCurve(px, py, cx + a[0], cy + a[1]);
    cx += a[0];
    cy += a[1];
    return cmd;
  },
  A: function (a) {
    var cmds = solveArc(cx, cy, a);
    cx = a[5];
    cy = a[6];
    return cmds;
  },
  a: function (a) {
    a[5] += cx;
    a[6] += cy;
    var cmds = solveArc(cx, cy, a);
    cx = a[5];
    cy = a[6];
    return cmds;
  },
  L: function (a) {
    cx = a[0];
    cy = a[1];
    px = py = null;
    return lineTo(cx, cy);
  },
  l: function (a) {
    cx += a[0];
    cy += a[1];
    px = py = null;
    return lineTo(cx, cy);
  },
  H: function (a) {
    cx = a[0];
    px = py = null;
    return lineTo(cx, cy);
  },
  h: function (a) {
    cx += a[0];
    px = py = null;
    return lineTo(cx, cy);
  },
  V: function (a) {
    cy = a[0];
    px = py = null;
    return lineTo(cx, cy);
  },
  v: function (a) {
    cy += a[0];
    px = py = null;
    return lineTo(cx, cy);
  },
  Z: function () {
    var cmd = closePath();
    cx = sx;
    cy = sy;
    return cmd;
  },
  z: function () {
    var cmd = closePath();
    cx = sx;
    cy = sy;
    return cmd;
  }
};
var solveArc = function (x, y, coords) {
  var rx = coords[0],
    ry = coords[1],
    rot = coords[2],
    large = coords[3],
    sweep = coords[4],
    ex = coords[5],
    ey = coords[6];
  var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
  var cmds = [];
  for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
    var seg = segs_1[_i];
    var bez = segmentToBezier.apply(void 0, seg);
    cmds.push(appendBezierCurve.apply(void 0, bez));
  }
  return cmds;
};
var arcToSegments = function (x, y, rx, ry, large, sweep, rotateX, ox, oy) {
  var th = rotateX * (Math.PI / 180);
  var sinTh = Math.sin(th);
  var cosTh = Math.cos(th);
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
  py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
  var pl = px * px / (rx * rx) + py * py / (ry * ry);
  if (pl > 1) {
    pl = Math.sqrt(pl);
    rx *= pl;
    ry *= pl;
  }
  var a00 = cosTh / rx;
  var a01 = sinTh / rx;
  var a10 = -sinTh / ry;
  var a11 = cosTh / ry;
  var x0 = a00 * ox + a01 * oy;
  var y0 = a10 * ox + a11 * oy;
  var x1 = a00 * x + a01 * y;
  var y1 = a10 * x + a11 * y;
  var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
  var sfactorSq = 1 / d - 0.25;
  if (sfactorSq < 0) {
    sfactorSq = 0;
  }
  var sfactor = Math.sqrt(sfactorSq);
  if (sweep === large) {
    sfactor = -sfactor;
  }
  var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
  var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
  var th0 = Math.atan2(y0 - yc, x0 - xc);
  var th1 = Math.atan2(y1 - yc, x1 - xc);
  var thArc = th1 - th0;
  if (thArc < 0 && sweep === 1) {
    thArc += 2 * Math.PI;
  } else if (thArc > 0 && sweep === 0) {
    thArc -= 2 * Math.PI;
  }
  var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
  var result = [];
  for (var i = 0; i < segments; i++) {
    var th2 = th0 + i * thArc / segments;
    var th3 = th0 + (i + 1) * thArc / segments;
    result[i] = [xc, yc, th2, th3, rx, ry, sinTh, cosTh];
  }
  return result;
};
var segmentToBezier = function (cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
  var a00 = cosTh * rx;
  var a01 = -sinTh * ry;
  var a10 = sinTh * rx;
  var a11 = cosTh * ry;
  var thHalf = 0.5 * (th1 - th0);
  var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
  var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
  var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
  var x3 = cx1 + Math.cos(th1);
  var y3 = cy1 + Math.sin(th1);
  var x2 = x3 + t * Math.sin(th1);
  var y2 = y3 - t * Math.cos(th1);
  var result = [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
  return result;
};
var svgPathToOperators = function (path) {
  return apply(parse(path));
};

var drawText = function (line, options) {
  return [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), beginText(), setFillingColor(options.color), setFontAndSize(options.font, options.size), rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), options.x, options.y), showText(line), endText(), popGraphicsState()].filter(Boolean);
};
var drawLinesOfText = function (lines, options) {
  var operators = [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), beginText(), setFillingColor(options.color), setFontAndSize(options.font, options.size), setLineHeight(options.lineHeight), rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), options.x, options.y)].filter(Boolean);
  for (var idx = 0, len = lines.length; idx < len; idx++) {
    operators.push(showText(lines[idx]), nextLine());
  }
  operators.push(endText(), popGraphicsState());
  return operators;
};
var drawImage = function (name, options) {
  return [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), translate(options.x, options.y), rotateRadians(toRadians(options.rotate)), scale(options.width, options.height), skewRadians(toRadians(options.xSkew), toRadians(options.ySkew)), drawObject(name), popGraphicsState()].filter(Boolean);
};
var drawPage = function (name, options) {
  return [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), translate(options.x, options.y), rotateRadians(toRadians(options.rotate)), scale(options.xScale, options.yScale), skewRadians(toRadians(options.xSkew), toRadians(options.ySkew)), drawObject(name), popGraphicsState()].filter(Boolean);
};
var drawLine = function (options) {
  var _a, _b;
  return [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), options.color && setStrokingColor(options.color), setLineWidth(options.thickness), setDashPattern((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0), moveTo(options.start.x, options.start.y), options.lineCap && setLineCap(options.lineCap), moveTo(options.start.x, options.start.y), lineTo(options.end.x, options.end.y), stroke(), popGraphicsState()].filter(Boolean);
};
var drawRectangle = function (options) {
  var _a, _b;
  return [pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), options.color && setFillingColor(options.color), options.borderColor && setStrokingColor(options.borderColor), setLineWidth(options.borderWidth), options.borderLineCap && setLineCap(options.borderLineCap), setDashPattern((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0), translate(options.x, options.y), rotateRadians(toRadians(options.rotate)), skewRadians(toRadians(options.xSkew), toRadians(options.ySkew)), moveTo(0, 0), lineTo(0, options.height), lineTo(options.width, options.height), lineTo(options.width, 0), closePath(), options.color && options.borderWidth ? fillAndStroke() : options.color ? fill() : options.borderColor ? stroke() : closePath(), popGraphicsState()].filter(Boolean);
};
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var drawEllipsePath = function (config) {
  var x = asNumber(config.x);
  var y = asNumber(config.y);
  var xScale = asNumber(config.xScale);
  var yScale = asNumber(config.yScale);
  x -= xScale;
  y -= yScale;
  var ox = xScale * KAPPA;
  var oy = yScale * KAPPA;
  var xe = x + xScale * 2;
  var ye = y + yScale * 2;
  var xm = x + xScale;
  var ym = y + yScale;
  return [pushGraphicsState(), moveTo(x, ym), appendBezierCurve(x, ym - oy, xm - ox, y, xm, y), appendBezierCurve(xm + ox, y, xe, ym - oy, xe, ym), appendBezierCurve(xe, ym + oy, xm + ox, ye, xm, ye), appendBezierCurve(xm - ox, ye, x, ym + oy, x, ym), popGraphicsState()];
};
var drawEllipseCurves = function (config) {
  var centerX = asNumber(config.x);
  var centerY = asNumber(config.y);
  var xScale = asNumber(config.xScale);
  var yScale = asNumber(config.yScale);
  var x = -xScale;
  var y = -yScale;
  var ox = xScale * KAPPA;
  var oy = yScale * KAPPA;
  var xe = x + xScale * 2;
  var ye = y + yScale * 2;
  var xm = x + xScale;
  var ym = y + yScale;
  return [translate(centerX, centerY), rotateRadians(toRadians(config.rotate)), moveTo(x, ym), appendBezierCurve(x, ym - oy, xm - ox, y, xm, y), appendBezierCurve(xm + ox, y, xe, ym - oy, xe, ym), appendBezierCurve(xe, ym + oy, xm + ox, ye, xm, ye), appendBezierCurve(xm - ox, ye, x, ym + oy, x, ym)];
};
var drawEllipse = function (options) {
  var _a, _b, _c;
  return __spreadArrays([pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), options.color && setFillingColor(options.color), options.borderColor && setStrokingColor(options.borderColor), setLineWidth(options.borderWidth), options.borderLineCap && setLineCap(options.borderLineCap), setDashPattern((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)], options.rotate === undefined ? drawEllipsePath({
    x: options.x,
    y: options.y,
    xScale: options.xScale,
    yScale: options.yScale
  }) : drawEllipseCurves({
    x: options.x,
    y: options.y,
    xScale: options.xScale,
    yScale: options.yScale,
    rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : degrees(0)
  }), [options.color && options.borderWidth ? fillAndStroke() : options.color ? fill() : options.borderColor ? stroke() : closePath(), popGraphicsState()]).filter(Boolean);
};
var drawSvgPath = function (path, options) {
  var _a, _b, _c;
  return __spreadArrays([pushGraphicsState(), options.graphicsState && setGraphicsState(options.graphicsState), translate(options.x, options.y), rotateRadians(toRadians((_a = options.rotate) !== null && _a !== void 0 ? _a : degrees(0))), options.scale ? scale(options.scale, -options.scale) : scale(1, -1), options.color && setFillingColor(options.color), options.borderColor && setStrokingColor(options.borderColor), options.borderWidth && setLineWidth(options.borderWidth), options.borderLineCap && setLineCap(options.borderLineCap), setDashPattern((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)], svgPathToOperators(path), [options.color && options.borderWidth ? fillAndStroke() : options.color ? fill() : options.borderColor ? stroke() : closePath(), popGraphicsState()]).filter(Boolean);
};
var drawCheckMark = function (options) {
  var size = asNumber(options.size);
  var p2x = -1 + 0.75;
  var p2y = -1 + 0.51;
  var p3y = 1 - 0.525;
  var p3x = 1 - 0.31;
  var p1x = -1 + 0.325;
  var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
  return [pushGraphicsState(), options.color && setStrokingColor(options.color), setLineWidth(options.thickness), translate(options.x, options.y), moveTo(p1x * size, p1y * size), lineTo(p2x * size, p2y * size), lineTo(p3x * size, p3y * size), stroke(), popGraphicsState()].filter(Boolean);
};
var rotateInPlace = function (options) {
  return options.rotation === 0 ? [translate(0, 0), rotateDegrees(0)] : options.rotation === 90 ? [translate(options.width, 0), rotateDegrees(90)] : options.rotation === 180 ? [translate(options.width, options.height), rotateDegrees(180)] : options.rotation === 270 ? [translate(0, options.height), rotateDegrees(270)] : [];
};
var drawCheckBox = function (options) {
  var outline = drawRectangle({
    x: options.x,
    y: options.y,
    width: options.width,
    height: options.height,
    borderWidth: options.borderWidth,
    color: options.color,
    borderColor: options.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  if (!options.filled) return outline;
  var width = asNumber(options.width);
  var height = asNumber(options.height);
  var checkMarkSize = Math.min(width, height) / 2;
  var checkMark = drawCheckMark({
    x: width / 2,
    y: height / 2,
    size: checkMarkSize,
    thickness: options.thickness,
    color: options.markColor
  });
  return __spreadArrays([pushGraphicsState()], outline, checkMark, [popGraphicsState()]);
};
var drawRadioButton = function (options) {
  var width = asNumber(options.width);
  var height = asNumber(options.height);
  var outlineScale = Math.min(width, height) / 2;
  var outline = drawEllipse({
    x: options.x,
    y: options.y,
    xScale: outlineScale,
    yScale: outlineScale,
    color: options.color,
    borderColor: options.borderColor,
    borderWidth: options.borderWidth
  });
  if (!options.filled) return outline;
  var dot = drawEllipse({
    x: options.x,
    y: options.y,
    xScale: outlineScale * 0.45,
    yScale: outlineScale * 0.45,
    color: options.dotColor,
    borderColor: undefined,
    borderWidth: 0
  });
  return __spreadArrays([pushGraphicsState()], outline, dot, [popGraphicsState()]);
};
var drawButton = function (options) {
  var x = asNumber(options.x);
  var y = asNumber(options.y);
  var width = asNumber(options.width);
  var height = asNumber(options.height);
  var background = drawRectangle({
    x: x,
    y: y,
    width: width,
    height: height,
    borderWidth: options.borderWidth,
    color: options.color,
    borderColor: options.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  var lines = drawTextLines(options.textLines, {
    color: options.textColor,
    font: options.font,
    size: options.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  return __spreadArrays([pushGraphicsState()], background, lines, [popGraphicsState()]);
};
var drawTextLines = function (lines, options) {
  var operators = [beginText(), setFillingColor(options.color), setFontAndSize(options.font, options.size)];
  for (var idx = 0, len = lines.length; idx < len; idx++) {
    var _a = lines[idx],
      encoded = _a.encoded,
      x = _a.x,
      y = _a.y;
    operators.push(rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), x, y), showText(encoded));
  }
  operators.push(endText());
  return operators;
};
var drawTextField = function (options) {
  var x = asNumber(options.x);
  var y = asNumber(options.y);
  var width = asNumber(options.width);
  var height = asNumber(options.height);
  var borderWidth = asNumber(options.borderWidth);
  var padding = asNumber(options.padding);
  var clipX = x + borderWidth / 2 + padding;
  var clipY = y + borderWidth / 2 + padding;
  var clipWidth = width - (borderWidth / 2 + padding) * 2;
  var clipHeight = height - (borderWidth / 2 + padding) * 2;
  var clippingArea = [moveTo(clipX, clipY), lineTo(clipX, clipY + clipHeight), lineTo(clipX + clipWidth, clipY + clipHeight), lineTo(clipX + clipWidth, clipY), closePath(), clip(), endPath()];
  var background = drawRectangle({
    x: x,
    y: y,
    width: width,
    height: height,
    borderWidth: options.borderWidth,
    color: options.color,
    borderColor: options.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  var lines = drawTextLines(options.textLines, {
    color: options.textColor,
    font: options.font,
    size: options.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  var markedContent = __spreadArrays([beginMarkedContent('Tx'), pushGraphicsState()], lines, [popGraphicsState(), endMarkedContent()]);
  return __spreadArrays([pushGraphicsState()], background, clippingArea, markedContent, [popGraphicsState()]);
};
var drawOptionList = function (options) {
  var x = asNumber(options.x);
  var y = asNumber(options.y);
  var width = asNumber(options.width);
  var height = asNumber(options.height);
  var lineHeight = asNumber(options.lineHeight);
  var borderWidth = asNumber(options.borderWidth);
  var padding = asNumber(options.padding);
  var clipX = x + borderWidth / 2 + padding;
  var clipY = y + borderWidth / 2 + padding;
  var clipWidth = width - (borderWidth / 2 + padding) * 2;
  var clipHeight = height - (borderWidth / 2 + padding) * 2;
  var clippingArea = [moveTo(clipX, clipY), lineTo(clipX, clipY + clipHeight), lineTo(clipX + clipWidth, clipY + clipHeight), lineTo(clipX + clipWidth, clipY), closePath(), clip(), endPath()];
  var background = drawRectangle({
    x: x,
    y: y,
    width: width,
    height: height,
    borderWidth: options.borderWidth,
    color: options.color,
    borderColor: options.borderColor,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  var highlights = [];
  for (var idx = 0, len = options.selectedLines.length; idx < len; idx++) {
    var line = options.textLines[options.selectedLines[idx]];
    highlights.push.apply(highlights, drawRectangle({
      x: line.x - padding,
      y: line.y - (lineHeight - line.height) / 2,
      width: width - borderWidth,
      height: line.height + (lineHeight - line.height) / 2,
      borderWidth: 0,
      color: options.selectedColor,
      borderColor: undefined,
      rotate: degrees(0),
      xSkew: degrees(0),
      ySkew: degrees(0)
    }));
  }
  var lines = drawTextLines(options.textLines, {
    color: options.textColor,
    font: options.font,
    size: options.fontSize,
    rotate: degrees(0),
    xSkew: degrees(0),
    ySkew: degrees(0)
  });
  var markedContent = __spreadArrays([beginMarkedContent('Tx'), pushGraphicsState()], lines, [popGraphicsState(), endMarkedContent()]);
  return __spreadArrays([pushGraphicsState()], background, highlights, clippingArea, markedContent, [popGraphicsState()]);
};

var EncryptedPDFError = function (_super) {
  __extends(EncryptedPDFError, _super);
  function EncryptedPDFError() {
    var _this = this;
    var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return EncryptedPDFError;
}(Error);
var FontkitNotRegisteredError = function (_super) {
  __extends(FontkitNotRegisteredError, _super);
  function FontkitNotRegisteredError() {
    var _this = this;
    var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return FontkitNotRegisteredError;
}(Error);
var ForeignPageError = function (_super) {
  __extends(ForeignPageError, _super);
  function ForeignPageError() {
    var _this = this;
    var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return ForeignPageError;
}(Error);
var RemovePageFromEmptyDocumentError = function (_super) {
  __extends(RemovePageFromEmptyDocumentError, _super);
  function RemovePageFromEmptyDocumentError() {
    var _this = this;
    var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return RemovePageFromEmptyDocumentError;
}(Error);
var NoSuchFieldError = function (_super) {
  __extends(NoSuchFieldError, _super);
  function NoSuchFieldError(name) {
    var _this = this;
    var msg = "PDFDocument has no form field with the name \"" + name + "\"";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return NoSuchFieldError;
}(Error);
var UnexpectedFieldTypeError = function (_super) {
  __extends(UnexpectedFieldTypeError, _super);
  function UnexpectedFieldTypeError(name, expected, actual) {
    var _a, _b;
    var _this = this;
    var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
    var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
    var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return UnexpectedFieldTypeError;
}(Error);
var MissingOnValueCheckError = function (_super) {
  __extends(MissingOnValueCheckError, _super);
  function MissingOnValueCheckError(onValue) {
    var _this = this;
    var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return MissingOnValueCheckError;
}(Error);
var FieldAlreadyExistsError = function (_super) {
  __extends(FieldAlreadyExistsError, _super);
  function FieldAlreadyExistsError(name) {
    var _this = this;
    var msg = "A field already exists with the specified name: \"" + name + "\"";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return FieldAlreadyExistsError;
}(Error);
var InvalidFieldNamePartError = function (_super) {
  __extends(InvalidFieldNamePartError, _super);
  function InvalidFieldNamePartError(namePart) {
    var _this = this;
    var msg = "Field name contains invalid component: \"" + namePart + "\"";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return InvalidFieldNamePartError;
}(Error);
var FieldExistsAsNonTerminalError = function (_super) {
  __extends(FieldExistsAsNonTerminalError, _super);
  function FieldExistsAsNonTerminalError(name) {
    var _this = this;
    var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return FieldExistsAsNonTerminalError;
}(Error);
var RichTextFieldReadError = function (_super) {
  __extends(RichTextFieldReadError, _super);
  function RichTextFieldReadError(fieldName) {
    var _this = this;
    var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return RichTextFieldReadError;
}(Error);
var CombedTextLayoutError = function (_super) {
  __extends(CombedTextLayoutError, _super);
  function CombedTextLayoutError(lineLength, cellCount) {
    var _this = this;
    var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return CombedTextLayoutError;
}(Error);
var ExceededMaxLengthError = function (_super) {
  __extends(ExceededMaxLengthError, _super);
  function ExceededMaxLengthError(textLength, maxLength, name) {
    var _this = this;
    var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return ExceededMaxLengthError;
}(Error);
var InvalidMaxLengthError = function (_super) {
  __extends(InvalidMaxLengthError, _super);
  function InvalidMaxLengthError(textLength, maxLength, name) {
    var _this = this;
    var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
    _this = _super.call(this, msg) || this;
    return _this;
  }
  return InvalidMaxLengthError;
}(Error);

var TextAlignment;
(function (TextAlignment) {
  TextAlignment[TextAlignment["Left"] = 0] = "Left";
  TextAlignment[TextAlignment["Center"] = 1] = "Center";
  TextAlignment[TextAlignment["Right"] = 2] = "Right";
})(TextAlignment || (TextAlignment = {}));

var MIN_FONT_SIZE = 4;
var MAX_FONT_SIZE = 500;
var computeFontSize = function (lines, font, bounds, multiline) {
  if (multiline === void 0) {
    multiline = false;
  }
  var fontSize = MIN_FONT_SIZE;
  while (fontSize < MAX_FONT_SIZE) {
    var linesUsed = 0;
    for (var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++) {
      linesUsed += 1;
      var line = lines[lineIdx];
      var words = line.split(' ');
      var spaceInLineRemaining = bounds.width;
      for (var idx = 0, len = words.length; idx < len; idx++) {
        var isLastWord = idx === len - 1;
        var word = isLastWord ? words[idx] : words[idx] + ' ';
        var widthOfWord = font.widthOfTextAtSize(word, fontSize);
        spaceInLineRemaining -= widthOfWord;
        if (spaceInLineRemaining <= 0) {
          linesUsed += 1;
          spaceInLineRemaining = bounds.width - widthOfWord;
        }
      }
    }
    if (!multiline && linesUsed > lines.length) return fontSize - 1;
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var totalHeight = lineHeight * linesUsed;
    if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
    fontSize += 1;
  }
  return fontSize;
};
var computeCombedFontSize = function (line, font, bounds, cellCount) {
  var cellWidth = bounds.width / cellCount;
  var cellHeight = bounds.height;
  var fontSize = MIN_FONT_SIZE;
  var chars = charSplit(line);
  while (fontSize < MAX_FONT_SIZE) {
    for (var idx = 0, len = chars.length; idx < len; idx++) {
      var c = chars[idx];
      var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
      if (tooLong) return fontSize - 1;
    }
    var height = font.heightAtSize(fontSize, {
      descender: false
    });
    if (height > cellHeight) return fontSize - 1;
    fontSize += 1;
  }
  return fontSize;
};
var lastIndexOfWhitespace = function (line) {
  for (var idx = line.length; idx > 0; idx--) {
    if (/\s/.test(line[idx])) return idx;
  }
  return undefined;
};
var splitOutLines = function (input, maxWidth, font, fontSize) {
  var _a;
  var lastWhitespaceIdx = input.length;
  while (lastWhitespaceIdx > 0) {
    var line = input.substring(0, lastWhitespaceIdx);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    if (width < maxWidth) {
      var remainder = input.substring(lastWhitespaceIdx) || undefined;
      return {
        line: line,
        encoded: encoded,
        width: width,
        remainder: remainder
      };
    }
    lastWhitespaceIdx = (_a = lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
  }
  return {
    line: input,
    encoded: font.encodeText(input),
    width: font.widthOfTextAtSize(input, fontSize),
    remainder: undefined
  };
};
var layoutMultilineText = function (text, _a) {
  var alignment = _a.alignment,
    fontSize = _a.fontSize,
    font = _a.font,
    bounds = _a.bounds;
  var lines = lineSplit(cleanText(text));
  if (fontSize === undefined || fontSize === 0) {
    fontSize = computeFontSize(lines, font, bounds, true);
  }
  var height = font.heightAtSize(fontSize);
  var lineHeight = height + height * 0.2;
  var textLines = [];
  var minX = bounds.x;
  var minY = bounds.y;
  var maxX = bounds.x + bounds.width;
  var maxY = bounds.y + bounds.height;
  var y = bounds.y + bounds.height;
  for (var idx = 0, len = lines.length; idx < len; idx++) {
    var prevRemainder = lines[idx];
    while (prevRemainder !== undefined) {
      var _b = splitOutLines(prevRemainder, bounds.width, font, fontSize),
        line = _b.line,
        encoded = _b.encoded,
        width = _b.width,
        remainder = _b.remainder;
      var x = alignment === TextAlignment.Left ? bounds.x : alignment === TextAlignment.Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === TextAlignment.Right ? bounds.x + bounds.width - width : bounds.x;
      y -= lineHeight;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x + width > maxX) maxX = x + width;
      if (y + height > maxY) maxY = y + height;
      textLines.push({
        text: line,
        encoded: encoded,
        width: width,
        height: height,
        x: x,
        y: y
      });
      prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
    }
  }
  return {
    fontSize: fontSize,
    lineHeight: lineHeight,
    lines: textLines,
    bounds: {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    }
  };
};
var layoutCombedText = function (text, _a) {
  var fontSize = _a.fontSize,
    font = _a.font,
    bounds = _a.bounds,
    cellCount = _a.cellCount;
  var line = mergeLines(cleanText(text));
  if (line.length > cellCount) {
    throw new CombedTextLayoutError(line.length, cellCount);
  }
  if (fontSize === undefined || fontSize === 0) {
    fontSize = computeCombedFontSize(line, font, bounds, cellCount);
  }
  var cellWidth = bounds.width / cellCount;
  var height = font.heightAtSize(fontSize, {
    descender: false
  });
  var y = bounds.y + (bounds.height / 2 - height / 2);
  var cells = [];
  var minX = bounds.x;
  var minY = bounds.y;
  var maxX = bounds.x + bounds.width;
  var maxY = bounds.y + bounds.height;
  var cellOffset = 0;
  var charOffset = 0;
  while (cellOffset < cellCount) {
    var _b = charAtIndex(line, charOffset),
      char = _b[0],
      charLength = _b[1];
    var encoded = font.encodeText(char);
    var width = font.widthOfTextAtSize(char, fontSize);
    var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
    var x = cellCenter - width / 2;
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x + width > maxX) maxX = x + width;
    if (y + height > maxY) maxY = y + height;
    cells.push({
      text: line,
      encoded: encoded,
      width: width,
      height: height,
      x: x,
      y: y
    });
    cellOffset += 1;
    charOffset += charLength;
  }
  return {
    fontSize: fontSize,
    cells: cells,
    bounds: {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    }
  };
};
var layoutSinglelineText = function (text, _a) {
  var alignment = _a.alignment,
    fontSize = _a.fontSize,
    font = _a.font,
    bounds = _a.bounds;
  var line = mergeLines(cleanText(text));
  if (fontSize === undefined || fontSize === 0) {
    fontSize = computeFontSize([line], font, bounds);
  }
  var encoded = font.encodeText(line);
  var width = font.widthOfTextAtSize(line, fontSize);
  var height = font.heightAtSize(fontSize, {
    descender: false
  });
  var x = alignment === TextAlignment.Left ? bounds.x : alignment === TextAlignment.Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === TextAlignment.Right ? bounds.x + bounds.width - width : bounds.x;
  var y = bounds.y + (bounds.height / 2 - height / 2);
  return {
    fontSize: fontSize,
    line: {
      text: line,
      encoded: encoded,
      width: width,
      height: height,
      x: x,
      y: y
    },
    bounds: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  };
};

var normalizeAppearance = function (appearance) {
  if ('normal' in appearance) return appearance;
  return {
    normal: appearance
  };
};
var tfRegex$1 = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var getDefaultFontSize = function (field) {
  var _a, _b;
  var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
  var daMatch = (_b = findLastMatch(da, tfRegex$1).match) !== null && _b !== void 0 ? _b : [];
  var defaultFontSize = Number(daMatch[2]);
  return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
var colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var getDefaultColor = function (field) {
  var _a;
  var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
  var daMatch = findLastMatch(da, colorRegex).match;
  var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [],
    c1 = _b[1],
    c2 = _b[2],
    c3 = _b[3],
    c4 = _b[4],
    colorSpace = _b[5];
  if (colorSpace === 'g' && c1) {
    return grayscale(Number(c1));
  }
  if (colorSpace === 'rg' && c1 && c2 && c3) {
    return rgb(Number(c1), Number(c2), Number(c3));
  }
  if (colorSpace === 'k' && c1 && c2 && c3 && c4) {
    return cmyk(Number(c1), Number(c2), Number(c3), Number(c4));
  }
  return undefined;
};
var updateDefaultAppearance = function (field, color, font, fontSize) {
  var _a;
  if (fontSize === void 0) {
    fontSize = 0;
  }
  var da = [setFillingColor(color).toString(), setFontAndSize((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()].join('\n');
  field.setDefaultAppearance(da);
};
var defaultCheckBoxAppearanceProvider = function (checkBox, widget) {
  var _a, _b, _c;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(checkBox.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _d = adjustDimsForRotation(rectangle, rotation),
    width = _d.width,
    height = _d.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = (_b = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var downBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
  var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
  if (widgetColor) {
    updateDefaultAppearance(widget, textColor);
  } else {
    updateDefaultAppearance(checkBox.acroField, textColor);
  }
  var options = {
    x: 0 + borderWidth / 2,
    y: 0 + borderWidth / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    thickness: 1.5,
    borderWidth: borderWidth,
    borderColor: borderColor,
    markColor: textColor
  };
  return {
    normal: {
      on: __spreadArrays(rotate, drawCheckBox(__assign(__assign({}, options), {
        color: normalBackgroundColor,
        filled: true
      }))),
      off: __spreadArrays(rotate, drawCheckBox(__assign(__assign({}, options), {
        color: normalBackgroundColor,
        filled: false
      })))
    },
    down: {
      on: __spreadArrays(rotate, drawCheckBox(__assign(__assign({}, options), {
        color: downBackgroundColor,
        filled: true
      }))),
      off: __spreadArrays(rotate, drawCheckBox(__assign(__assign({}, options), {
        color: downBackgroundColor,
        filled: false
      })))
    }
  };
};
var defaultRadioGroupAppearanceProvider = function (radioGroup, widget) {
  var _a, _b, _c;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(radioGroup.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _d = adjustDimsForRotation(rectangle, rotation),
    width = _d.width,
    height = _d.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = (_b = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var downBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
  var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
  if (widgetColor) {
    updateDefaultAppearance(widget, textColor);
  } else {
    updateDefaultAppearance(radioGroup.acroField, textColor);
  }
  var options = {
    x: width / 2,
    y: height / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    borderWidth: borderWidth,
    borderColor: borderColor,
    dotColor: textColor
  };
  return {
    normal: {
      on: __spreadArrays(rotate, drawRadioButton(__assign(__assign({}, options), {
        color: normalBackgroundColor,
        filled: true
      }))),
      off: __spreadArrays(rotate, drawRadioButton(__assign(__assign({}, options), {
        color: normalBackgroundColor,
        filled: false
      })))
    },
    down: {
      on: __spreadArrays(rotate, drawRadioButton(__assign(__assign({}, options), {
        color: downBackgroundColor,
        filled: true
      }))),
      off: __spreadArrays(rotate, drawRadioButton(__assign(__assign({}, options), {
        color: downBackgroundColor,
        filled: false
      })))
    }
  };
};
var defaultButtonAppearanceProvider = function (button, widget, font) {
  var _a, _b, _c, _d, _e;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(button.acroField);
  var widgetFontSize = getDefaultFontSize(widget);
  var fieldFontSize = getDefaultFontSize(button.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
  var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
  var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
  var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _f = adjustDimsForRotation(rectangle, rotation),
    width = _f.width,
    height = _f.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var downBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
  var bounds = {
    x: borderWidth,
    y: borderWidth,
    width: width - borderWidth * 2,
    height: height - borderWidth * 2
  };
  var normalLayout = layoutSinglelineText(normalText, {
    alignment: TextAlignment.Center,
    fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
    font: font,
    bounds: bounds
  });
  var downLayout = layoutSinglelineText(downText, {
    alignment: TextAlignment.Center,
    fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
    font: font,
    bounds: bounds
  });
  var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
  var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
  if (widgetColor || widgetFontSize !== undefined) {
    updateDefaultAppearance(widget, textColor, font, fontSize);
  } else {
    updateDefaultAppearance(button.acroField, textColor, font, fontSize);
  }
  var options = {
    x: 0 + borderWidth / 2,
    y: 0 + borderWidth / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    borderWidth: borderWidth,
    borderColor: borderColor,
    textColor: textColor,
    font: font.name,
    fontSize: fontSize
  };
  return {
    normal: __spreadArrays(rotate, drawButton(__assign(__assign({}, options), {
      color: normalBackgroundColor,
      textLines: [normalLayout.line]
    }))),
    down: __spreadArrays(rotate, drawButton(__assign(__assign({}, options), {
      color: downBackgroundColor,
      textLines: [downLayout.line]
    })))
  };
};
var defaultTextFieldAppearanceProvider = function (textField, widget, font) {
  var _a, _b, _c, _d;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(textField.acroField);
  var widgetFontSize = getDefaultFontSize(widget);
  var fieldFontSize = getDefaultFontSize(textField.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
  var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _e = adjustDimsForRotation(rectangle, rotation),
    width = _e.width,
    height = _e.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var textLines;
  var fontSize;
  var padding = textField.isCombed() ? 0 : 1;
  var bounds = {
    x: borderWidth + padding,
    y: borderWidth + padding,
    width: width - (borderWidth + padding) * 2,
    height: height - (borderWidth + padding) * 2
  };
  if (textField.isMultiline()) {
    var layout = layoutMultilineText(text, {
      alignment: textField.getAlignment(),
      fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
      font: font,
      bounds: bounds
    });
    textLines = layout.lines;
    fontSize = layout.fontSize;
  } else if (textField.isCombed()) {
    var layout = layoutCombedText(text, {
      fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
      font: font,
      bounds: bounds,
      cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
    });
    textLines = layout.cells;
    fontSize = layout.fontSize;
  } else {
    var layout = layoutSinglelineText(text, {
      alignment: textField.getAlignment(),
      fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
      font: font,
      bounds: bounds
    });
    textLines = [layout.line];
    fontSize = layout.fontSize;
  }
  var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
  if (widgetColor || widgetFontSize !== undefined) {
    updateDefaultAppearance(widget, textColor, font, fontSize);
  } else {
    updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
  }
  var options = {
    x: 0 + borderWidth / 2,
    y: 0 + borderWidth / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
    borderColor: borderColor,
    textColor: textColor,
    font: font.name,
    fontSize: fontSize,
    color: normalBackgroundColor,
    textLines: textLines,
    padding: padding
  };
  return __spreadArrays(rotate, drawTextField(options));
};
var defaultDropdownAppearanceProvider = function (dropdown, widget, font) {
  var _a, _b, _c;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(dropdown.acroField);
  var widgetFontSize = getDefaultFontSize(widget);
  var fieldFontSize = getDefaultFontSize(dropdown.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
  var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _d = adjustDimsForRotation(rectangle, rotation),
    width = _d.width,
    height = _d.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var padding = 1;
  var bounds = {
    x: borderWidth + padding,
    y: borderWidth + padding,
    width: width - (borderWidth + padding) * 2,
    height: height - (borderWidth + padding) * 2
  };
  var _e = layoutSinglelineText(text, {
      alignment: TextAlignment.Left,
      fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
      font: font,
      bounds: bounds
    }),
    line = _e.line,
    fontSize = _e.fontSize;
  var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
  if (widgetColor || widgetFontSize !== undefined) {
    updateDefaultAppearance(widget, textColor, font, fontSize);
  } else {
    updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
  }
  var options = {
    x: 0 + borderWidth / 2,
    y: 0 + borderWidth / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
    borderColor: borderColor,
    textColor: textColor,
    font: font.name,
    fontSize: fontSize,
    color: normalBackgroundColor,
    textLines: [line],
    padding: padding
  };
  return __spreadArrays(rotate, drawTextField(options));
};
var defaultOptionListAppearanceProvider = function (optionList, widget, font) {
  var _a, _b;
  var widgetColor = getDefaultColor(widget);
  var fieldColor = getDefaultColor(optionList.acroField);
  var widgetFontSize = getDefaultFontSize(widget);
  var fieldFontSize = getDefaultFontSize(optionList.acroField);
  var rectangle = widget.getRectangle();
  var ap = widget.getAppearanceCharacteristics();
  var bs = widget.getBorderStyle();
  var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
  var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
  var _c = adjustDimsForRotation(rectangle, rotation),
    width = _c.width,
    height = _c.height;
  var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
    rotation: rotation
  }));
  var black = rgb(0, 0, 0);
  var borderColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
  var normalBackgroundColor = componentsToColor(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
  var options = optionList.getOptions();
  var selected = optionList.getSelected();
  if (optionList.isSorted()) options.sort();
  var text = '';
  for (var idx = 0, len = options.length; idx < len; idx++) {
    text += options[idx];
    if (idx < len - 1) text += '\n';
  }
  var padding = 1;
  var bounds = {
    x: borderWidth + padding,
    y: borderWidth + padding,
    width: width - (borderWidth + padding) * 2,
    height: height - (borderWidth + padding) * 2
  };
  var _d = layoutMultilineText(text, {
      alignment: TextAlignment.Left,
      fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
      font: font,
      bounds: bounds
    }),
    lines = _d.lines,
    fontSize = _d.fontSize,
    lineHeight = _d.lineHeight;
  var selectedLines = [];
  for (var idx = 0, len = lines.length; idx < len; idx++) {
    var line = lines[idx];
    if (selected.includes(line.text)) selectedLines.push(idx);
  }
  var blue = rgb(153 / 255, 193 / 255, 218 / 255);
  var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
  if (widgetColor || widgetFontSize !== undefined) {
    updateDefaultAppearance(widget, textColor, font, fontSize);
  } else {
    updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
  }
  return __spreadArrays(rotate, drawOptionList({
    x: 0 + borderWidth / 2,
    y: 0 + borderWidth / 2,
    width: width - borderWidth,
    height: height - borderWidth,
    borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
    borderColor: borderColor,
    textColor: textColor,
    font: font.name,
    fontSize: fontSize,
    color: normalBackgroundColor,
    textLines: lines,
    lineHeight: lineHeight,
    selectedColor: blue,
    selectedLines: selectedLines,
    padding: padding
  }));
};

var PDFEmbeddedPage = function () {
  function PDFEmbeddedPage(ref, doc, embedder) {
    this.alreadyEmbedded = false;
    assertIs(ref, 'ref', [[PDFRef, 'PDFRef']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    assertIs(embedder, 'embedder', [[PDFPageEmbedder, 'PDFPageEmbedder']]);
    this.ref = ref;
    this.doc = doc;
    this.width = embedder.width;
    this.height = embedder.height;
    this.embedder = embedder;
  }
  PDFEmbeddedPage.prototype.scale = function (factor) {
    assertIs(factor, 'factor', ['number']);
    return {
      width: this.width * factor,
      height: this.height * factor
    };
  };
  PDFEmbeddedPage.prototype.size = function () {
    return this.scale(1);
  };
  PDFEmbeddedPage.prototype.embed = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.alreadyEmbedded) return [3, 2];
            return [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
          case 1:
            _a.sent();
            this.alreadyEmbedded = true;
            _a.label = 2;
          case 2:
            return [2];
        }
      });
    });
  };
  PDFEmbeddedPage.of = function (ref, doc, embedder) {
    return new PDFEmbeddedPage(ref, doc, embedder);
  };
  return PDFEmbeddedPage;
}();

var PDFFont = function () {
  function PDFFont(ref, doc, embedder) {
    this.modified = true;
    assertIs(ref, 'ref', [[PDFRef, 'PDFRef']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    assertIs(embedder, 'embedder', [[CustomFontEmbedder, 'CustomFontEmbedder'], [StandardFontEmbedder, 'StandardFontEmbedder']]);
    this.ref = ref;
    this.doc = doc;
    this.name = embedder.fontName;
    this.embedder = embedder;
  }
  PDFFont.prototype.encodeText = function (text) {
    assertIs(text, 'text', ['string']);
    this.modified = true;
    return this.embedder.encodeText(text);
  };
  PDFFont.prototype.widthOfTextAtSize = function (text, size) {
    assertIs(text, 'text', ['string']);
    assertIs(size, 'size', ['number']);
    return this.embedder.widthOfTextAtSize(text, size);
  };
  PDFFont.prototype.heightAtSize = function (size, options) {
    var _a;
    assertIs(size, 'size', ['number']);
    assertOrUndefined(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', ['boolean']);
    return this.embedder.heightOfFontAtSize(size, {
      descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
    });
  };
  PDFFont.prototype.sizeAtHeight = function (height) {
    assertIs(height, 'height', ['number']);
    return this.embedder.sizeOfFontAtHeight(height);
  };
  PDFFont.prototype.getCharacterSet = function () {
    if (this.embedder instanceof StandardFontEmbedder) {
      return this.embedder.encoding.supportedCodePoints;
    } else {
      return this.embedder.font.characterSet;
    }
  };
  PDFFont.prototype.embed = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.modified) return [3, 2];
            return [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
          case 1:
            _a.sent();
            this.modified = false;
            _a.label = 2;
          case 2:
            return [2];
        }
      });
    });
  };
  PDFFont.of = function (ref, doc, embedder) {
    return new PDFFont(ref, doc, embedder);
  };
  return PDFFont;
}();

var PDFImage = function () {
  function PDFImage(ref, doc, embedder) {
    assertIs(ref, 'ref', [[PDFRef, 'PDFRef']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    assertIs(embedder, 'embedder', [[JpegEmbedder, 'JpegEmbedder'], [PngEmbedder, 'PngEmbedder']]);
    this.ref = ref;
    this.doc = doc;
    this.width = embedder.width;
    this.height = embedder.height;
    this.embedder = embedder;
  }
  PDFImage.prototype.scale = function (factor) {
    assertIs(factor, 'factor', ['number']);
    return {
      width: this.width * factor,
      height: this.height * factor
    };
  };
  PDFImage.prototype.scaleToFit = function (width, height) {
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var imgWidthScale = width / this.width;
    var imgHeightScale = height / this.height;
    var scale = Math.min(imgWidthScale, imgHeightScale);
    return this.scale(scale);
  };
  PDFImage.prototype.size = function () {
    return this.scale(1);
  };
  PDFImage.prototype.embed = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, doc, ref;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!this.embedder) return [2];
            if (!this.embedTask) {
              _a = this, doc = _a.doc, ref = _a.ref;
              this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
            }
            return [4, this.embedTask];
          case 1:
            _b.sent();
            this.embedder = undefined;
            return [2];
        }
      });
    });
  };
  PDFImage.of = function (ref, doc, embedder) {
    return new PDFImage(ref, doc, embedder);
  };
  return PDFImage;
}();

var ImageAlignment;
(function (ImageAlignment) {
  ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
  ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
  ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})(ImageAlignment || (ImageAlignment = {}));

var assertFieldAppearanceOptions = function (options) {
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.x, 'options.x', ['number']);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.y, 'options.y', ['number']);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.width, 'options.width', ['number']);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.height, 'options.height', ['number']);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [[Object, 'Color']]);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [[Object, 'Color']]);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [[Object, 'Color']]);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', ['number']);
  assertOrUndefined(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [[Object, 'Rotation']]);
};
var PDFField = function () {
  function PDFField(acroField, ref, doc) {
    assertIs(acroField, 'acroField', [[PDFAcroTerminal, 'PDFAcroTerminal']]);
    assertIs(ref, 'ref', [[PDFRef, 'PDFRef']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    this.acroField = acroField;
    this.ref = ref;
    this.doc = doc;
  }
  PDFField.prototype.getName = function () {
    var _a;
    return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
  };
  PDFField.prototype.isReadOnly = function () {
    return this.acroField.hasFlag(AcroFieldFlags.ReadOnly);
  };
  PDFField.prototype.enableReadOnly = function () {
    this.acroField.setFlagTo(AcroFieldFlags.ReadOnly, true);
  };
  PDFField.prototype.disableReadOnly = function () {
    this.acroField.setFlagTo(AcroFieldFlags.ReadOnly, false);
  };
  PDFField.prototype.isRequired = function () {
    return this.acroField.hasFlag(AcroFieldFlags.Required);
  };
  PDFField.prototype.enableRequired = function () {
    this.acroField.setFlagTo(AcroFieldFlags.Required, true);
  };
  PDFField.prototype.disableRequired = function () {
    this.acroField.setFlagTo(AcroFieldFlags.Required, false);
  };
  PDFField.prototype.isExported = function () {
    return !this.acroField.hasFlag(AcroFieldFlags.NoExport);
  };
  PDFField.prototype.enableExporting = function () {
    this.acroField.setFlagTo(AcroFieldFlags.NoExport, false);
  };
  PDFField.prototype.disableExporting = function () {
    this.acroField.setFlagTo(AcroFieldFlags.NoExport, true);
  };
  PDFField.prototype.needsAppearancesUpdate = function () {
    throw new MethodNotImplementedError(this.constructor.name, 'needsAppearancesUpdate');
  };
  PDFField.prototype.defaultUpdateAppearances = function (_font) {
    throw new MethodNotImplementedError(this.constructor.name, 'defaultUpdateAppearances');
  };
  PDFField.prototype.markAsDirty = function () {
    this.doc.getForm().markFieldAsDirty(this.ref);
  };
  PDFField.prototype.markAsClean = function () {
    this.doc.getForm().markFieldAsClean(this.ref);
  };
  PDFField.prototype.isDirty = function () {
    return this.doc.getForm().fieldIsDirty(this.ref);
  };
  PDFField.prototype.createWidget = function (options) {
    var _a;
    var textColor = options.textColor;
    var backgroundColor = options.backgroundColor;
    var borderColor = options.borderColor;
    var borderWidth = options.borderWidth;
    var degreesAngle = toDegrees(options.rotate);
    var caption = options.caption;
    var x = options.x;
    var y = options.y;
    var width = options.width + borderWidth;
    var height = options.height + borderWidth;
    var hidden = Boolean(options.hidden);
    var pageRef = options.page;
    assertMultiple(degreesAngle, 'degreesAngle', 90);
    var widget = PDFWidgetAnnotation.create(this.doc.context, this.ref);
    var rect = rotateRectangle({
      x: x,
      y: y,
      width: width,
      height: height
    }, borderWidth, degreesAngle);
    widget.setRectangle(rect);
    if (pageRef) widget.setP(pageRef);
    var ac = widget.getOrCreateAppearanceCharacteristics();
    if (backgroundColor) {
      ac.setBackgroundColor(colorToComponents(backgroundColor));
    }
    ac.setRotation(degreesAngle);
    if (caption) ac.setCaptions({
      normal: caption
    });
    if (borderColor) ac.setBorderColor(colorToComponents(borderColor));
    var bs = widget.getOrCreateBorderStyle();
    if (borderWidth !== undefined) bs.setWidth(borderWidth);
    widget.setFlagTo(AnnotationFlags.Print, true);
    widget.setFlagTo(AnnotationFlags.Hidden, hidden);
    widget.setFlagTo(AnnotationFlags.Invisible, false);
    if (textColor) {
      var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
      var newDa = da + '\n' + setFillingColor(textColor).toString();
      this.acroField.setDefaultAppearance(newDa);
    }
    return widget;
  };
  PDFField.prototype.updateWidgetAppearanceWithFont = function (widget, font, _a) {
    var normal = _a.normal,
      rollover = _a.rollover,
      down = _a.down;
    this.updateWidgetAppearances(widget, {
      normal: this.createAppearanceStream(widget, normal, font),
      rollover: rollover && this.createAppearanceStream(widget, rollover, font),
      down: down && this.createAppearanceStream(widget, down, font)
    });
  };
  PDFField.prototype.updateOnOffWidgetAppearance = function (widget, onValue, _a) {
    var normal = _a.normal,
      rollover = _a.rollover,
      down = _a.down;
    this.updateWidgetAppearances(widget, {
      normal: this.createAppearanceDict(widget, normal, onValue),
      rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
      down: down && this.createAppearanceDict(widget, down, onValue)
    });
  };
  PDFField.prototype.updateWidgetAppearances = function (widget, _a) {
    var normal = _a.normal,
      rollover = _a.rollover,
      down = _a.down;
    widget.setNormalAppearance(normal);
    if (rollover) {
      widget.setRolloverAppearance(rollover);
    } else {
      widget.removeRolloverAppearance();
    }
    if (down) {
      widget.setDownAppearance(down);
    } else {
      widget.removeDownAppearance();
    }
  };
  PDFField.prototype.createAppearanceStream = function (widget, appearance, font) {
    var _a;
    var context = this.acroField.dict.context;
    var _b = widget.getRectangle(),
      width = _b.width,
      height = _b.height;
    var Resources = font && {
      Font: (_a = {}, _a[font.name] = font.ref, _a)
    };
    var stream = context.formXObject(appearance, {
      Resources: Resources,
      BBox: context.obj([0, 0, width, height]),
      Matrix: context.obj([1, 0, 0, 1, 0, 0])
    });
    var streamRef = context.register(stream);
    return streamRef;
  };
  PDFField.prototype.createImageAppearanceStream = function (widget, image, alignment) {
    var _a;
    var _b;
    var context = this.acroField.dict.context;
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = reduceRotation(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var rotate = rotateInPlace(__assign(__assign({}, rectangle), {
      rotation: rotation
    }));
    var adj = adjustDimsForRotation(rectangle, rotation);
    var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
    var options = {
      x: borderWidth,
      y: borderWidth,
      width: imageDims.width,
      height: imageDims.height,
      rotate: degrees(0),
      xSkew: degrees(0),
      ySkew: degrees(0)
    };
    if (alignment === ImageAlignment.Center) {
      options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
      options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
    } else if (alignment === ImageAlignment.Right) {
      options.x = adj.width - borderWidth - imageDims.width;
      options.y = adj.height - borderWidth - imageDims.height;
    }
    var imageName = this.doc.context.addRandomSuffix('Image', 10);
    var appearance = __spreadArrays(rotate, drawImage(imageName, options));
    var Resources = {
      XObject: (_a = {}, _a[imageName] = image.ref, _a)
    };
    var stream = context.formXObject(appearance, {
      Resources: Resources,
      BBox: context.obj([0, 0, rectangle.width, rectangle.height]),
      Matrix: context.obj([1, 0, 0, 1, 0, 0])
    });
    return context.register(stream);
  };
  PDFField.prototype.createAppearanceDict = function (widget, appearance, onValue) {
    var context = this.acroField.dict.context;
    var onStreamRef = this.createAppearanceStream(widget, appearance.on);
    var offStreamRef = this.createAppearanceStream(widget, appearance.off);
    var appearanceDict = context.obj({});
    appearanceDict.set(onValue, onStreamRef);
    appearanceDict.set(PDFName.of('Off'), offStreamRef);
    return appearanceDict;
  };
  return PDFField;
}();

var PDFCheckBox = function (_super) {
  __extends(PDFCheckBox, _super);
  function PDFCheckBox(acroCheckBox, ref, doc) {
    var _this = _super.call(this, acroCheckBox, ref, doc) || this;
    assertIs(acroCheckBox, 'acroCheckBox', [[PDFAcroCheckBox, 'PDFAcroCheckBox']]);
    _this.acroField = acroCheckBox;
    return _this;
  }
  PDFCheckBox.prototype.check = function () {
    var _a;
    var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : PDFName.of('Yes');
    this.markAsDirty();
    this.acroField.setValue(onValue);
  };
  PDFCheckBox.prototype.uncheck = function () {
    this.markAsDirty();
    this.acroField.setValue(PDFName.of('Off'));
  };
  PDFCheckBox.prototype.isChecked = function () {
    var onValue = this.acroField.getOnValue();
    return !!onValue && onValue === this.acroField.getValue();
  };
  PDFCheckBox.prototype.addToPage = function (page, options) {
    var _a, _b, _c, _d, _e, _f;
    assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    if (!options) options = {};
    if (!('textColor' in options)) options.textColor = rgb(0, 0, 0);
    if (!('backgroundColor' in options)) options.backgroundColor = rgb(1, 1, 1);
    if (!('borderColor' in options)) options.borderColor = rgb(0, 0, 0);
    if (!('borderWidth' in options)) options.borderWidth = 1;
    var widget = this.createWidget({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
      textColor: options.textColor,
      backgroundColor: options.backgroundColor,
      borderColor: options.borderColor,
      borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
      rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : degrees(0),
      hidden: options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    this.acroField.addWidget(widgetRef);
    widget.setAppearanceState(PDFName.of('Off'));
    this.updateWidgetAppearance(widget, PDFName.of('Yes'));
    page.node.addAnnot(widgetRef);
  };
  PDFCheckBox.prototype.needsAppearancesUpdate = function () {
    var _a;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var state = widget.getAppearanceState();
      var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
      if (!(normal instanceof PDFDict)) return true;
      if (state && !normal.has(state)) return true;
    }
    return false;
  };
  PDFCheckBox.prototype.defaultUpdateAppearances = function () {
    this.updateAppearances();
  };
  PDFCheckBox.prototype.updateAppearances = function (provider) {
    var _a;
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : PDFName.of('Yes');
      if (!onValue) continue;
      this.updateWidgetAppearance(widget, onValue, provider);
    }
    this.markAsClean();
  };
  PDFCheckBox.prototype.updateWidgetAppearance = function (widget, onValue, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultCheckBoxAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget));
    this.updateOnOffWidgetAppearance(widget, onValue, appearances);
  };
  PDFCheckBox.of = function (acroCheckBox, ref, doc) {
    return new PDFCheckBox(acroCheckBox, ref, doc);
  };
  return PDFCheckBox;
}(PDFField);

var PDFDropdown = function (_super) {
  __extends(PDFDropdown, _super);
  function PDFDropdown(acroComboBox, ref, doc) {
    var _this = _super.call(this, acroComboBox, ref, doc) || this;
    assertIs(acroComboBox, 'acroComboBox', [[PDFAcroComboBox, 'PDFAcroComboBox']]);
    _this.acroField = acroComboBox;
    return _this;
  }
  PDFDropdown.prototype.getOptions = function () {
    var rawOptions = this.acroField.getOptions();
    var options = new Array(rawOptions.length);
    for (var idx = 0, len = options.length; idx < len; idx++) {
      var _a = rawOptions[idx],
        display = _a.display,
        value = _a.value;
      options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
    }
    return options;
  };
  PDFDropdown.prototype.getSelected = function () {
    var values = this.acroField.getValues();
    var selected = new Array(values.length);
    for (var idx = 0, len = values.length; idx < len; idx++) {
      selected[idx] = values[idx].decodeText();
    }
    return selected;
  };
  PDFDropdown.prototype.setOptions = function (options) {
    assertIs(options, 'options', [Array]);
    var optionObjects = new Array(options.length);
    for (var idx = 0, len = options.length; idx < len; idx++) {
      optionObjects[idx] = {
        value: PDFHexString.fromText(options[idx])
      };
    }
    this.acroField.setOptions(optionObjects);
  };
  PDFDropdown.prototype.addOptions = function (options) {
    assertIs(options, 'options', ['string', Array]);
    var optionsArr = Array.isArray(options) ? options : [options];
    var existingOptions = this.acroField.getOptions();
    var newOptions = new Array(optionsArr.length);
    for (var idx = 0, len = optionsArr.length; idx < len; idx++) {
      newOptions[idx] = {
        value: PDFHexString.fromText(optionsArr[idx])
      };
    }
    this.acroField.setOptions(existingOptions.concat(newOptions));
  };
  PDFDropdown.prototype.select = function (options, merge) {
    if (merge === void 0) {
      merge = false;
    }
    assertIs(options, 'options', ['string', Array]);
    assertIs(merge, 'merge', ['boolean']);
    var optionsArr = Array.isArray(options) ? options : [options];
    var validOptions = this.getOptions();
    var hasCustomOption = optionsArr.find(function (option) {
      return !validOptions.includes(option);
    });
    if (hasCustomOption) this.enableEditing();
    this.markAsDirty();
    if (optionsArr.length > 1 || optionsArr.length === 1 && merge) {
      this.enableMultiselect();
    }
    var values = new Array(optionsArr.length);
    for (var idx = 0, len = optionsArr.length; idx < len; idx++) {
      values[idx] = PDFHexString.fromText(optionsArr[idx]);
    }
    if (merge) {
      var existingValues = this.acroField.getValues();
      this.acroField.setValues(existingValues.concat(values));
    } else {
      this.acroField.setValues(values);
    }
  };
  PDFDropdown.prototype.clear = function () {
    this.markAsDirty();
    this.acroField.setValues([]);
  };
  PDFDropdown.prototype.setFontSize = function (fontSize) {
    assertPositive(fontSize, 'fontSize');
    this.acroField.setFontSize(fontSize);
    this.markAsDirty();
  };
  PDFDropdown.prototype.isEditable = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.Edit);
  };
  PDFDropdown.prototype.enableEditing = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Edit, true);
  };
  PDFDropdown.prototype.disableEditing = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Edit, false);
  };
  PDFDropdown.prototype.isSorted = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.Sort);
  };
  PDFDropdown.prototype.enableSorting = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Sort, true);
  };
  PDFDropdown.prototype.disableSorting = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Sort, false);
  };
  PDFDropdown.prototype.isMultiselect = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.MultiSelect);
  };
  PDFDropdown.prototype.enableMultiselect = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, true);
  };
  PDFDropdown.prototype.disableMultiselect = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, false);
  };
  PDFDropdown.prototype.isSpellChecked = function () {
    return !this.acroField.hasFlag(AcroChoiceFlags.DoNotSpellCheck);
  };
  PDFDropdown.prototype.enableSpellChecking = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.DoNotSpellCheck, false);
  };
  PDFDropdown.prototype.disableSpellChecking = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.DoNotSpellCheck, true);
  };
  PDFDropdown.prototype.isSelectOnClick = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.CommitOnSelChange);
  };
  PDFDropdown.prototype.enableSelectOnClick = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, true);
  };
  PDFDropdown.prototype.disableSelectOnClick = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, false);
  };
  PDFDropdown.prototype.addToPage = function (page, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    if (!options) options = {};
    if (!('textColor' in options)) options.textColor = rgb(0, 0, 0);
    if (!('backgroundColor' in options)) options.backgroundColor = rgb(1, 1, 1);
    if (!('borderColor' in options)) options.borderColor = rgb(0, 0, 0);
    if (!('borderWidth' in options)) options.borderWidth = 1;
    var widget = this.createWidget({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
      textColor: options.textColor,
      backgroundColor: options.backgroundColor,
      borderColor: options.borderColor,
      borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
      rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : degrees(0),
      hidden: options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    this.acroField.addWidget(widgetRef);
    var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
    this.updateWidgetAppearance(widget, font);
    page.node.addAnnot(widgetRef);
  };
  PDFDropdown.prototype.needsAppearancesUpdate = function () {
    var _a;
    if (this.isDirty()) return true;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof PDFStream;
      if (!hasAppearances) return true;
    }
    return false;
  };
  PDFDropdown.prototype.defaultUpdateAppearances = function (font) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    this.updateAppearances(font);
  };
  PDFDropdown.prototype.updateAppearances = function (font, provider) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      this.updateWidgetAppearance(widget, font, provider);
    }
    this.markAsClean();
  };
  PDFDropdown.prototype.updateWidgetAppearance = function (widget, font, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultDropdownAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget, font));
    this.updateWidgetAppearanceWithFont(widget, font, appearances);
  };
  PDFDropdown.of = function (acroComboBox, ref, doc) {
    return new PDFDropdown(acroComboBox, ref, doc);
  };
  return PDFDropdown;
}(PDFField);

var PDFOptionList = function (_super) {
  __extends(PDFOptionList, _super);
  function PDFOptionList(acroListBox, ref, doc) {
    var _this = _super.call(this, acroListBox, ref, doc) || this;
    assertIs(acroListBox, 'acroListBox', [[PDFAcroListBox, 'PDFAcroListBox']]);
    _this.acroField = acroListBox;
    return _this;
  }
  PDFOptionList.prototype.getOptions = function () {
    var rawOptions = this.acroField.getOptions();
    var options = new Array(rawOptions.length);
    for (var idx = 0, len = options.length; idx < len; idx++) {
      var _a = rawOptions[idx],
        display = _a.display,
        value = _a.value;
      options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
    }
    return options;
  };
  PDFOptionList.prototype.getSelected = function () {
    var values = this.acroField.getValues();
    var selected = new Array(values.length);
    for (var idx = 0, len = values.length; idx < len; idx++) {
      selected[idx] = values[idx].decodeText();
    }
    return selected;
  };
  PDFOptionList.prototype.setOptions = function (options) {
    assertIs(options, 'options', [Array]);
    this.markAsDirty();
    var optionObjects = new Array(options.length);
    for (var idx = 0, len = options.length; idx < len; idx++) {
      optionObjects[idx] = {
        value: PDFHexString.fromText(options[idx])
      };
    }
    this.acroField.setOptions(optionObjects);
  };
  PDFOptionList.prototype.addOptions = function (options) {
    assertIs(options, 'options', ['string', Array]);
    this.markAsDirty();
    var optionsArr = Array.isArray(options) ? options : [options];
    var existingOptions = this.acroField.getOptions();
    var newOptions = new Array(optionsArr.length);
    for (var idx = 0, len = optionsArr.length; idx < len; idx++) {
      newOptions[idx] = {
        value: PDFHexString.fromText(optionsArr[idx])
      };
    }
    this.acroField.setOptions(existingOptions.concat(newOptions));
  };
  PDFOptionList.prototype.select = function (options, merge) {
    if (merge === void 0) {
      merge = false;
    }
    assertIs(options, 'options', ['string', Array]);
    assertIs(merge, 'merge', ['boolean']);
    var optionsArr = Array.isArray(options) ? options : [options];
    var validOptions = this.getOptions();
    assertIsSubset(optionsArr, 'option', validOptions);
    this.markAsDirty();
    if (optionsArr.length > 1 || optionsArr.length === 1 && merge) {
      this.enableMultiselect();
    }
    var values = new Array(optionsArr.length);
    for (var idx = 0, len = optionsArr.length; idx < len; idx++) {
      values[idx] = PDFHexString.fromText(optionsArr[idx]);
    }
    if (merge) {
      var existingValues = this.acroField.getValues();
      this.acroField.setValues(existingValues.concat(values));
    } else {
      this.acroField.setValues(values);
    }
  };
  PDFOptionList.prototype.clear = function () {
    this.markAsDirty();
    this.acroField.setValues([]);
  };
  PDFOptionList.prototype.setFontSize = function (fontSize) {
    assertPositive(fontSize, 'fontSize');
    this.acroField.setFontSize(fontSize);
    this.markAsDirty();
  };
  PDFOptionList.prototype.isSorted = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.Sort);
  };
  PDFOptionList.prototype.enableSorting = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Sort, true);
  };
  PDFOptionList.prototype.disableSorting = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.Sort, false);
  };
  PDFOptionList.prototype.isMultiselect = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.MultiSelect);
  };
  PDFOptionList.prototype.enableMultiselect = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, true);
  };
  PDFOptionList.prototype.disableMultiselect = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.MultiSelect, false);
  };
  PDFOptionList.prototype.isSelectOnClick = function () {
    return this.acroField.hasFlag(AcroChoiceFlags.CommitOnSelChange);
  };
  PDFOptionList.prototype.enableSelectOnClick = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, true);
  };
  PDFOptionList.prototype.disableSelectOnClick = function () {
    this.acroField.setFlagTo(AcroChoiceFlags.CommitOnSelChange, false);
  };
  PDFOptionList.prototype.addToPage = function (page, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    if (!options) options = {};
    if (!('textColor' in options)) options.textColor = rgb(0, 0, 0);
    if (!('backgroundColor' in options)) options.backgroundColor = rgb(1, 1, 1);
    if (!('borderColor' in options)) options.borderColor = rgb(0, 0, 0);
    if (!('borderWidth' in options)) options.borderWidth = 1;
    var widget = this.createWidget({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
      textColor: options.textColor,
      backgroundColor: options.backgroundColor,
      borderColor: options.borderColor,
      borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
      rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : degrees(0),
      hidden: options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    this.acroField.addWidget(widgetRef);
    var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
    this.updateWidgetAppearance(widget, font);
    page.node.addAnnot(widgetRef);
  };
  PDFOptionList.prototype.needsAppearancesUpdate = function () {
    var _a;
    if (this.isDirty()) return true;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof PDFStream;
      if (!hasAppearances) return true;
    }
    return false;
  };
  PDFOptionList.prototype.defaultUpdateAppearances = function (font) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    this.updateAppearances(font);
  };
  PDFOptionList.prototype.updateAppearances = function (font, provider) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      this.updateWidgetAppearance(widget, font, provider);
    }
    this.markAsClean();
  };
  PDFOptionList.prototype.updateWidgetAppearance = function (widget, font, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultOptionListAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget, font));
    this.updateWidgetAppearanceWithFont(widget, font, appearances);
  };
  PDFOptionList.of = function (acroListBox, ref, doc) {
    return new PDFOptionList(acroListBox, ref, doc);
  };
  return PDFOptionList;
}(PDFField);

var PDFRadioGroup = function (_super) {
  __extends(PDFRadioGroup, _super);
  function PDFRadioGroup(acroRadioButton, ref, doc) {
    var _this = _super.call(this, acroRadioButton, ref, doc) || this;
    assertIs(acroRadioButton, 'acroRadioButton', [[PDFAcroRadioButton, 'PDFAcroRadioButton']]);
    _this.acroField = acroRadioButton;
    return _this;
  }
  PDFRadioGroup.prototype.getOptions = function () {
    var exportValues = this.acroField.getExportValues();
    if (exportValues) {
      var exportOptions = new Array(exportValues.length);
      for (var idx = 0, len = exportValues.length; idx < len; idx++) {
        exportOptions[idx] = exportValues[idx].decodeText();
      }
      return exportOptions;
    }
    var onValues = this.acroField.getOnValues();
    var onOptions = new Array(onValues.length);
    for (var idx = 0, len = onOptions.length; idx < len; idx++) {
      onOptions[idx] = onValues[idx].decodeText();
    }
    return onOptions;
  };
  PDFRadioGroup.prototype.getSelected = function () {
    var value = this.acroField.getValue();
    if (value === PDFName.of('Off')) return undefined;
    var exportValues = this.acroField.getExportValues();
    if (exportValues) {
      var onValues = this.acroField.getOnValues();
      for (var idx = 0, len = onValues.length; idx < len; idx++) {
        if (onValues[idx] === value) return exportValues[idx].decodeText();
      }
    }
    return value.decodeText();
  };
  PDFRadioGroup.prototype.select = function (option) {
    assertIs(option, 'option', ['string']);
    var validOptions = this.getOptions();
    assertIsOneOf(option, 'option', validOptions);
    this.markAsDirty();
    var onValues = this.acroField.getOnValues();
    var exportValues = this.acroField.getExportValues();
    if (exportValues) {
      for (var idx = 0, len = exportValues.length; idx < len; idx++) {
        if (exportValues[idx].decodeText() === option) {
          this.acroField.setValue(onValues[idx]);
        }
      }
    } else {
      for (var idx = 0, len = onValues.length; idx < len; idx++) {
        var value = onValues[idx];
        if (value.decodeText() === option) this.acroField.setValue(value);
      }
    }
  };
  PDFRadioGroup.prototype.clear = function () {
    this.markAsDirty();
    this.acroField.setValue(PDFName.of('Off'));
  };
  PDFRadioGroup.prototype.isOffToggleable = function () {
    return !this.acroField.hasFlag(AcroButtonFlags.NoToggleToOff);
  };
  PDFRadioGroup.prototype.enableOffToggling = function () {
    this.acroField.setFlagTo(AcroButtonFlags.NoToggleToOff, false);
  };
  PDFRadioGroup.prototype.disableOffToggling = function () {
    this.acroField.setFlagTo(AcroButtonFlags.NoToggleToOff, true);
  };
  PDFRadioGroup.prototype.isMutuallyExclusive = function () {
    return !this.acroField.hasFlag(AcroButtonFlags.RadiosInUnison);
  };
  PDFRadioGroup.prototype.enableMutualExclusion = function () {
    this.acroField.setFlagTo(AcroButtonFlags.RadiosInUnison, false);
  };
  PDFRadioGroup.prototype.disableMutualExclusion = function () {
    this.acroField.setFlagTo(AcroButtonFlags.RadiosInUnison, true);
  };
  PDFRadioGroup.prototype.addOptionToPage = function (option, page, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    assertIs(option, 'option', ['string']);
    assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    var widget = this.createWidget({
      x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
      y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
      width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
      height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
      textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : rgb(0, 0, 0),
      backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : rgb(1, 1, 1),
      borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : rgb(0, 0, 0),
      borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
      rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : degrees(0),
      hidden: options === null || options === void 0 ? void 0 : options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, PDFHexString.fromText(option), !this.isMutuallyExclusive());
    widget.setAppearanceState(PDFName.of('Off'));
    this.updateWidgetAppearance(widget, apStateValue);
    page.node.addAnnot(widgetRef);
  };
  PDFRadioGroup.prototype.needsAppearancesUpdate = function () {
    var _a;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var state = widget.getAppearanceState();
      var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
      if (!(normal instanceof PDFDict)) return true;
      if (state && !normal.has(state)) return true;
    }
    return false;
  };
  PDFRadioGroup.prototype.defaultUpdateAppearances = function () {
    this.updateAppearances();
  };
  PDFRadioGroup.prototype.updateAppearances = function (provider) {
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var onValue = widget.getOnValue();
      if (!onValue) continue;
      this.updateWidgetAppearance(widget, onValue, provider);
    }
  };
  PDFRadioGroup.prototype.updateWidgetAppearance = function (widget, onValue, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultRadioGroupAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget));
    this.updateOnOffWidgetAppearance(widget, onValue, appearances);
  };
  PDFRadioGroup.of = function (acroRadioButton, ref, doc) {
    return new PDFRadioGroup(acroRadioButton, ref, doc);
  };
  return PDFRadioGroup;
}(PDFField);

var PDFSignature = function (_super) {
  __extends(PDFSignature, _super);
  function PDFSignature(acroSignature, ref, doc) {
    var _this = _super.call(this, acroSignature, ref, doc) || this;
    assertIs(acroSignature, 'acroSignature', [[PDFAcroSignature, 'PDFAcroSignature']]);
    _this.acroField = acroSignature;
    return _this;
  }
  PDFSignature.prototype.needsAppearancesUpdate = function () {
    return false;
  };
  PDFSignature.of = function (acroSignature, ref, doc) {
    return new PDFSignature(acroSignature, ref, doc);
  };
  return PDFSignature;
}(PDFField);

var PDFTextField = function (_super) {
  __extends(PDFTextField, _super);
  function PDFTextField(acroText, ref, doc) {
    var _this = _super.call(this, acroText, ref, doc) || this;
    assertIs(acroText, 'acroText', [[PDFAcroText, 'PDFAcroText']]);
    _this.acroField = acroText;
    return _this;
  }
  PDFTextField.prototype.getText = function () {
    var value = this.acroField.getValue();
    if (!value && this.isRichFormatted()) {
      throw new RichTextFieldReadError(this.getName());
    }
    return value === null || value === void 0 ? void 0 : value.decodeText();
  };
  PDFTextField.prototype.setText = function (text) {
    assertOrUndefined(text, 'text', ['string']);
    var maxLength = this.getMaxLength();
    if (maxLength !== undefined && text && text.length > maxLength) {
      throw new ExceededMaxLengthError(text.length, maxLength, this.getName());
    }
    this.markAsDirty();
    this.disableRichFormatting();
    if (text) {
      this.acroField.setValue(PDFHexString.fromText(text));
    } else {
      this.acroField.removeValue();
    }
  };
  PDFTextField.prototype.getAlignment = function () {
    var quadding = this.acroField.getQuadding();
    return quadding === 0 ? TextAlignment.Left : quadding === 1 ? TextAlignment.Center : quadding === 2 ? TextAlignment.Right : TextAlignment.Left;
  };
  PDFTextField.prototype.setAlignment = function (alignment) {
    assertIsOneOf(alignment, 'alignment', TextAlignment);
    this.markAsDirty();
    this.acroField.setQuadding(alignment);
  };
  PDFTextField.prototype.getMaxLength = function () {
    return this.acroField.getMaxLength();
  };
  PDFTextField.prototype.setMaxLength = function (maxLength) {
    assertRangeOrUndefined(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
    this.markAsDirty();
    if (maxLength === undefined) {
      this.acroField.removeMaxLength();
    } else {
      var text = this.getText();
      if (text && text.length > maxLength) {
        throw new InvalidMaxLengthError(text.length, maxLength, this.getName());
      }
      this.acroField.setMaxLength(maxLength);
    }
  };
  PDFTextField.prototype.removeMaxLength = function () {
    this.markAsDirty();
    this.acroField.removeMaxLength();
  };
  PDFTextField.prototype.setImage = function (image) {
    var fieldAlignment = this.getAlignment();
    var alignment = fieldAlignment === TextAlignment.Center ? ImageAlignment.Center : fieldAlignment === TextAlignment.Right ? ImageAlignment.Right : ImageAlignment.Left;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var streamRef = this.createImageAppearanceStream(widget, image, alignment);
      this.updateWidgetAppearances(widget, {
        normal: streamRef
      });
    }
    this.markAsClean();
  };
  PDFTextField.prototype.setFontSize = function (fontSize) {
    assertPositive(fontSize, 'fontSize');
    this.acroField.setFontSize(fontSize);
    this.markAsDirty();
  };
  PDFTextField.prototype.isMultiline = function () {
    return this.acroField.hasFlag(AcroTextFlags.Multiline);
  };
  PDFTextField.prototype.enableMultiline = function () {
    this.markAsDirty();
    this.acroField.setFlagTo(AcroTextFlags.Multiline, true);
  };
  PDFTextField.prototype.disableMultiline = function () {
    this.markAsDirty();
    this.acroField.setFlagTo(AcroTextFlags.Multiline, false);
  };
  PDFTextField.prototype.isPassword = function () {
    return this.acroField.hasFlag(AcroTextFlags.Password);
  };
  PDFTextField.prototype.enablePassword = function () {
    this.acroField.setFlagTo(AcroTextFlags.Password, true);
  };
  PDFTextField.prototype.disablePassword = function () {
    this.acroField.setFlagTo(AcroTextFlags.Password, false);
  };
  PDFTextField.prototype.isFileSelector = function () {
    return this.acroField.hasFlag(AcroTextFlags.FileSelect);
  };
  PDFTextField.prototype.enableFileSelection = function () {
    this.acroField.setFlagTo(AcroTextFlags.FileSelect, true);
  };
  PDFTextField.prototype.disableFileSelection = function () {
    this.acroField.setFlagTo(AcroTextFlags.FileSelect, false);
  };
  PDFTextField.prototype.isSpellChecked = function () {
    return !this.acroField.hasFlag(AcroTextFlags.DoNotSpellCheck);
  };
  PDFTextField.prototype.enableSpellChecking = function () {
    this.acroField.setFlagTo(AcroTextFlags.DoNotSpellCheck, false);
  };
  PDFTextField.prototype.disableSpellChecking = function () {
    this.acroField.setFlagTo(AcroTextFlags.DoNotSpellCheck, true);
  };
  PDFTextField.prototype.isScrollable = function () {
    return !this.acroField.hasFlag(AcroTextFlags.DoNotScroll);
  };
  PDFTextField.prototype.enableScrolling = function () {
    this.acroField.setFlagTo(AcroTextFlags.DoNotScroll, false);
  };
  PDFTextField.prototype.disableScrolling = function () {
    this.acroField.setFlagTo(AcroTextFlags.DoNotScroll, true);
  };
  PDFTextField.prototype.isCombed = function () {
    return this.acroField.hasFlag(AcroTextFlags.Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
  };
  PDFTextField.prototype.enableCombing = function () {
    if (this.getMaxLength() === undefined) {
      var msg = "PDFTextFields must have a max length in order to be combed";
      console.warn(msg);
    }
    this.markAsDirty();
    this.disableMultiline();
    this.disablePassword();
    this.disableFileSelection();
    this.acroField.setFlagTo(AcroTextFlags.Comb, true);
  };
  PDFTextField.prototype.disableCombing = function () {
    this.markAsDirty();
    this.acroField.setFlagTo(AcroTextFlags.Comb, false);
  };
  PDFTextField.prototype.isRichFormatted = function () {
    return this.acroField.hasFlag(AcroTextFlags.RichText);
  };
  PDFTextField.prototype.enableRichFormatting = function () {
    this.acroField.setFlagTo(AcroTextFlags.RichText, true);
  };
  PDFTextField.prototype.disableRichFormatting = function () {
    this.acroField.setFlagTo(AcroTextFlags.RichText, false);
  };
  PDFTextField.prototype.addToPage = function (page, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    if (!options) options = {};
    if (!('textColor' in options)) options.textColor = rgb(0, 0, 0);
    if (!('backgroundColor' in options)) options.backgroundColor = rgb(1, 1, 1);
    if (!('borderColor' in options)) options.borderColor = rgb(0, 0, 0);
    if (!('borderWidth' in options)) options.borderWidth = 1;
    var widget = this.createWidget({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
      textColor: options.textColor,
      backgroundColor: options.backgroundColor,
      borderColor: options.borderColor,
      borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
      rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : degrees(0),
      hidden: options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    this.acroField.addWidget(widgetRef);
    var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
    this.updateWidgetAppearance(widget, font);
    page.node.addAnnot(widgetRef);
  };
  PDFTextField.prototype.needsAppearancesUpdate = function () {
    var _a;
    if (this.isDirty()) return true;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof PDFStream;
      if (!hasAppearances) return true;
    }
    return false;
  };
  PDFTextField.prototype.defaultUpdateAppearances = function (font) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    this.updateAppearances(font);
  };
  PDFTextField.prototype.updateAppearances = function (font, provider) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      this.updateWidgetAppearance(widget, font, provider);
    }
    this.markAsClean();
  };
  PDFTextField.prototype.updateWidgetAppearance = function (widget, font, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultTextFieldAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget, font));
    this.updateWidgetAppearanceWithFont(widget, font, appearances);
  };
  PDFTextField.of = function (acroText, ref, doc) {
    return new PDFTextField(acroText, ref, doc);
  };
  return PDFTextField;
}(PDFField);

var StandardFonts;
(function (StandardFonts) {
  StandardFonts["Courier"] = "Courier";
  StandardFonts["CourierBold"] = "Courier-Bold";
  StandardFonts["CourierOblique"] = "Courier-Oblique";
  StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
  StandardFonts["Helvetica"] = "Helvetica";
  StandardFonts["HelveticaBold"] = "Helvetica-Bold";
  StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
  StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
  StandardFonts["TimesRoman"] = "Times-Roman";
  StandardFonts["TimesRomanBold"] = "Times-Bold";
  StandardFonts["TimesRomanItalic"] = "Times-Italic";
  StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
  StandardFonts["Symbol"] = "Symbol";
  StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})(StandardFonts || (StandardFonts = {}));

var PDFForm = function () {
  function PDFForm(acroForm, doc) {
    var _this = this;
    this.embedDefaultFont = function () {
      return _this.doc.embedStandardFont(StandardFonts.Helvetica);
    };
    assertIs(acroForm, 'acroForm', [[PDFAcroForm, 'PDFAcroForm']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    this.acroForm = acroForm;
    this.doc = doc;
    this.dirtyFields = new Set();
    this.defaultFontCache = Cache.populatedBy(this.embedDefaultFont);
  }
  PDFForm.prototype.hasXFA = function () {
    return this.acroForm.dict.has(PDFName.of('XFA'));
  };
  PDFForm.prototype.deleteXFA = function () {
    this.acroForm.dict.delete(PDFName.of('XFA'));
  };
  PDFForm.prototype.getFields = function () {
    var allFields = this.acroForm.getAllFields();
    var fields = [];
    for (var idx = 0, len = allFields.length; idx < len; idx++) {
      var _a = allFields[idx],
        acroField = _a[0],
        ref = _a[1];
      var field = convertToPDFField(acroField, ref, this.doc);
      if (field) fields.push(field);
    }
    return fields;
  };
  PDFForm.prototype.getFieldMaybe = function (name) {
    assertIs(name, 'name', ['string']);
    var fields = this.getFields();
    for (var idx = 0, len = fields.length; idx < len; idx++) {
      var field = fields[idx];
      if (field.getName() === name) return field;
    }
    return undefined;
  };
  PDFForm.prototype.getField = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getFieldMaybe(name);
    if (field) return field;
    throw new NoSuchFieldError(name);
  };
  PDFForm.prototype.getButton = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFButton) return field;
    throw new UnexpectedFieldTypeError(name, PDFButton, field);
  };
  PDFForm.prototype.getCheckBox = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFCheckBox) return field;
    throw new UnexpectedFieldTypeError(name, PDFCheckBox, field);
  };
  PDFForm.prototype.getDropdown = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFDropdown) return field;
    throw new UnexpectedFieldTypeError(name, PDFDropdown, field);
  };
  PDFForm.prototype.getOptionList = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFOptionList) return field;
    throw new UnexpectedFieldTypeError(name, PDFOptionList, field);
  };
  PDFForm.prototype.getRadioGroup = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFRadioGroup) return field;
    throw new UnexpectedFieldTypeError(name, PDFRadioGroup, field);
  };
  PDFForm.prototype.getSignature = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFSignature) return field;
    throw new UnexpectedFieldTypeError(name, PDFSignature, field);
  };
  PDFForm.prototype.getTextField = function (name) {
    assertIs(name, 'name', ['string']);
    var field = this.getField(name);
    if (field instanceof PDFTextField) return field;
    throw new UnexpectedFieldTypeError(name, PDFTextField, field);
  };
  PDFForm.prototype.createButton = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var button = PDFAcroPushButton.create(this.doc.context);
    button.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [button, button.ref], nameParts.terminal);
    return PDFButton.of(button, button.ref, this.doc);
  };
  PDFForm.prototype.createCheckBox = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var checkBox = PDFAcroCheckBox.create(this.doc.context);
    checkBox.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [checkBox, checkBox.ref], nameParts.terminal);
    return PDFCheckBox.of(checkBox, checkBox.ref, this.doc);
  };
  PDFForm.prototype.createDropdown = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var comboBox = PDFAcroComboBox.create(this.doc.context);
    comboBox.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [comboBox, comboBox.ref], nameParts.terminal);
    return PDFDropdown.of(comboBox, comboBox.ref, this.doc);
  };
  PDFForm.prototype.createOptionList = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var listBox = PDFAcroListBox.create(this.doc.context);
    listBox.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [listBox, listBox.ref], nameParts.terminal);
    return PDFOptionList.of(listBox, listBox.ref, this.doc);
  };
  PDFForm.prototype.createRadioGroup = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var radioButton = PDFAcroRadioButton.create(this.doc.context);
    radioButton.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [radioButton, radioButton.ref], nameParts.terminal);
    return PDFRadioGroup.of(radioButton, radioButton.ref, this.doc);
  };
  PDFForm.prototype.createTextField = function (name) {
    assertIs(name, 'name', ['string']);
    var nameParts = splitFieldName(name);
    var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
    var text = PDFAcroText.create(this.doc.context);
    text.setPartialName(nameParts.terminal);
    addFieldToParent(parent, [text, text.ref], nameParts.terminal);
    return PDFTextField.of(text, text.ref, this.doc);
  };
  PDFForm.prototype.flatten = function (options) {
    if (options === void 0) {
      options = {
        updateFieldAppearances: true
      };
    }
    if (options.updateFieldAppearances) {
      this.updateFieldAppearances();
    }
    var fields = this.getFields();
    for (var i = 0, lenFields = fields.length; i < lenFields; i++) {
      var field = fields[i];
      var widgets = field.acroField.getWidgets();
      for (var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++) {
        var widget = widgets[j];
        var page = this.findWidgetPage(widget);
        var widgetRef = this.findWidgetAppearanceRef(field, widget);
        var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
        var rectangle = widget.getRectangle();
        var operators = __spreadArrays([pushGraphicsState(), translate(rectangle.x, rectangle.y)], rotateInPlace(__assign(__assign({}, rectangle), {
          rotation: 0
        })), [drawObject(xObjectKey), popGraphicsState()]).filter(Boolean);
        page.pushOperators.apply(page, operators);
      }
      this.removeField(field);
    }
  };
  PDFForm.prototype.removeField = function (field) {
    var widgets = field.acroField.getWidgets();
    var pages = new Set();
    for (var i = 0, len = widgets.length; i < len; i++) {
      var widget = widgets[i];
      var widgetRef = this.findWidgetAppearanceRef(field, widget);
      var page = this.findWidgetPage(widget);
      pages.add(page);
      page.node.removeAnnot(widgetRef);
    }
    pages.forEach(function (page) {
      return page.node.removeAnnot(field.ref);
    });
    this.acroForm.removeField(field.acroField);
    var fieldKids = field.acroField.normalizedEntries().Kids;
    var kidsCount = fieldKids.size();
    for (var childIndex = 0; childIndex < kidsCount; childIndex++) {
      var child = fieldKids.get(childIndex);
      if (child instanceof PDFRef) {
        this.doc.context.delete(child);
      }
    }
    this.doc.context.delete(field.ref);
  };
  PDFForm.prototype.updateFieldAppearances = function (font) {
    assertOrUndefined(font, 'font', [[PDFFont, 'PDFFont']]);
    font = font !== null && font !== void 0 ? font : this.getDefaultFont();
    var fields = this.getFields();
    for (var idx = 0, len = fields.length; idx < len; idx++) {
      var field = fields[idx];
      if (field.needsAppearancesUpdate()) {
        field.defaultUpdateAppearances(font);
      }
    }
  };
  PDFForm.prototype.markFieldAsDirty = function (fieldRef) {
    assertOrUndefined(fieldRef, 'fieldRef', [[PDFRef, 'PDFRef']]);
    this.dirtyFields.add(fieldRef);
  };
  PDFForm.prototype.markFieldAsClean = function (fieldRef) {
    assertOrUndefined(fieldRef, 'fieldRef', [[PDFRef, 'PDFRef']]);
    this.dirtyFields.delete(fieldRef);
  };
  PDFForm.prototype.fieldIsDirty = function (fieldRef) {
    assertOrUndefined(fieldRef, 'fieldRef', [[PDFRef, 'PDFRef']]);
    return this.dirtyFields.has(fieldRef);
  };
  PDFForm.prototype.getDefaultFont = function () {
    return this.defaultFontCache.access();
  };
  PDFForm.prototype.findWidgetPage = function (widget) {
    var pageRef = widget.P();
    var page = this.doc.getPages().find(function (x) {
      return x.ref === pageRef;
    });
    if (page === undefined) {
      var widgetRef = this.doc.context.getObjectRef(widget.dict);
      if (widgetRef === undefined) {
        throw new Error('Could not find PDFRef for PDFObject');
      }
      page = this.doc.findPageForAnnotationRef(widgetRef);
      if (page === undefined) {
        throw new Error("Could not find page for PDFRef " + widgetRef);
      }
    }
    return page;
  };
  PDFForm.prototype.findWidgetAppearanceRef = function (field, widget) {
    var _a;
    var refOrDict = widget.getNormalAppearance();
    if (refOrDict instanceof PDFDict && (field instanceof PDFCheckBox || field instanceof PDFRadioGroup)) {
      var value = field.acroField.getValue();
      var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get(PDFName.of('Off'));
      if (ref instanceof PDFRef) {
        refOrDict = ref;
      }
    }
    if (!(refOrDict instanceof PDFRef)) {
      var name_1 = field.getName();
      throw new Error("Failed to extract appearance ref for: " + name_1);
    }
    return refOrDict;
  };
  PDFForm.prototype.findOrCreateNonTerminals = function (partialNames) {
    var nonTerminal = [this.acroForm];
    for (var idx = 0, len = partialNames.length; idx < len; idx++) {
      var namePart = partialNames[idx];
      if (!namePart) throw new InvalidFieldNamePartError(namePart);
      var parent_1 = nonTerminal[0],
        parentRef = nonTerminal[1];
      var res = this.findNonTerminal(namePart, parent_1);
      if (res) {
        nonTerminal = res;
      } else {
        var node = PDFAcroNonTerminal.create(this.doc.context);
        node.setPartialName(namePart);
        node.setParent(parentRef);
        var nodeRef = this.doc.context.register(node.dict);
        parent_1.addField(nodeRef);
        nonTerminal = [node, nodeRef];
      }
    }
    return nonTerminal;
  };
  PDFForm.prototype.findNonTerminal = function (partialName, parent) {
    var fields = parent instanceof PDFAcroForm ? this.acroForm.getFields() : createPDFAcroFields(parent.Kids());
    for (var idx = 0, len = fields.length; idx < len; idx++) {
      var _a = fields[idx],
        field = _a[0],
        ref = _a[1];
      if (field.getPartialName() === partialName) {
        if (field instanceof PDFAcroNonTerminal) return [field, ref];
        throw new FieldAlreadyExistsError(partialName);
      }
    }
    return undefined;
  };
  PDFForm.of = function (acroForm, doc) {
    return new PDFForm(acroForm, doc);
  };
  return PDFForm;
}();
var convertToPDFField = function (field, ref, doc) {
  if (field instanceof PDFAcroPushButton) return PDFButton.of(field, ref, doc);
  if (field instanceof PDFAcroCheckBox) return PDFCheckBox.of(field, ref, doc);
  if (field instanceof PDFAcroComboBox) return PDFDropdown.of(field, ref, doc);
  if (field instanceof PDFAcroListBox) return PDFOptionList.of(field, ref, doc);
  if (field instanceof PDFAcroText) return PDFTextField.of(field, ref, doc);
  if (field instanceof PDFAcroRadioButton) {
    return PDFRadioGroup.of(field, ref, doc);
  }
  if (field instanceof PDFAcroSignature) {
    return PDFSignature.of(field, ref, doc);
  }
  return undefined;
};
var splitFieldName = function (fullyQualifiedName) {
  if (fullyQualifiedName.length === 0) {
    throw new Error('PDF field names must not be empty strings');
  }
  var parts = fullyQualifiedName.split('.');
  for (var idx = 0, len = parts.length; idx < len; idx++) {
    if (parts[idx] === '') {
      throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
  }
  if (parts.length === 1) return {
    nonTerminal: [],
    terminal: parts[0]
  };
  return {
    nonTerminal: parts.slice(0, parts.length - 1),
    terminal: parts[parts.length - 1]
  };
};
var addFieldToParent = function (_a, _b, partialName) {
  var parent = _a[0],
    parentRef = _a[1];
  var field = _b[0],
    fieldRef = _b[1];
  var entries = parent.normalizedEntries();
  var fields = createPDFAcroFields('Kids' in entries ? entries.Kids : entries.Fields);
  for (var idx = 0, len = fields.length; idx < len; idx++) {
    if (fields[idx][0].getPartialName() === partialName) {
      throw new FieldAlreadyExistsError(partialName);
    }
  }
  parent.addField(fieldRef);
  field.setParent(parentRef);
};

var PageSizes = {
  '4A0': [4767.87, 6740.79],
  '2A0': [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  Executive: [521.86, 756.0],
  Folio: [612.0, 936.0],
  Legal: [612.0, 1008.0],
  Letter: [612.0, 792.0],
  Tabloid: [792.0, 1224.0]
};

var ParseSpeeds;
(function (ParseSpeeds) {
  ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
  ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
  ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
  ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})(ParseSpeeds || (ParseSpeeds = {}));

var PDFEmbeddedFile = function () {
  function PDFEmbeddedFile(ref, doc, embedder) {
    this.alreadyEmbedded = false;
    this.ref = ref;
    this.doc = doc;
    this.embedder = embedder;
  }
  PDFEmbeddedFile.prototype.embed = function () {
    return __awaiter(this, void 0, void 0, function () {
      var ref, Names, EmbeddedFiles, EFNames, AF;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.alreadyEmbedded) return [3, 2];
            return [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
          case 1:
            ref = _a.sent();
            if (!this.doc.catalog.has(PDFName.of('Names'))) {
              this.doc.catalog.set(PDFName.of('Names'), this.doc.context.obj({}));
            }
            Names = this.doc.catalog.lookup(PDFName.of('Names'), PDFDict);
            if (!Names.has(PDFName.of('EmbeddedFiles'))) {
              Names.set(PDFName.of('EmbeddedFiles'), this.doc.context.obj({}));
            }
            EmbeddedFiles = Names.lookup(PDFName.of('EmbeddedFiles'), PDFDict);
            if (!EmbeddedFiles.has(PDFName.of('Names'))) {
              EmbeddedFiles.set(PDFName.of('Names'), this.doc.context.obj([]));
            }
            EFNames = EmbeddedFiles.lookup(PDFName.of('Names'), PDFArray);
            EFNames.push(PDFHexString.fromText(this.embedder.fileName));
            EFNames.push(ref);
            if (!this.doc.catalog.has(PDFName.of('AF'))) {
              this.doc.catalog.set(PDFName.of('AF'), this.doc.context.obj([]));
            }
            AF = this.doc.catalog.lookup(PDFName.of('AF'), PDFArray);
            AF.push(ref);
            this.alreadyEmbedded = true;
            _a.label = 2;
          case 2:
            return [2];
        }
      });
    });
  };
  PDFEmbeddedFile.of = function (ref, doc, embedder) {
    return new PDFEmbeddedFile(ref, doc, embedder);
  };
  return PDFEmbeddedFile;
}();

var PDFJavaScript = function () {
  function PDFJavaScript(ref, doc, embedder) {
    this.alreadyEmbedded = false;
    this.ref = ref;
    this.doc = doc;
    this.embedder = embedder;
  }
  PDFJavaScript.prototype.embed = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, catalog, context, ref, Names, Javascript, JSNames;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!!this.alreadyEmbedded) return [3, 2];
            _a = this.doc, catalog = _a.catalog, context = _a.context;
            return [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
          case 1:
            ref = _b.sent();
            if (!catalog.has(PDFName.of('Names'))) {
              catalog.set(PDFName.of('Names'), context.obj({}));
            }
            Names = catalog.lookup(PDFName.of('Names'), PDFDict);
            if (!Names.has(PDFName.of('JavaScript'))) {
              Names.set(PDFName.of('JavaScript'), context.obj({}));
            }
            Javascript = Names.lookup(PDFName.of('JavaScript'), PDFDict);
            if (!Javascript.has(PDFName.of('Names'))) {
              Javascript.set(PDFName.of('Names'), context.obj([]));
            }
            JSNames = Javascript.lookup(PDFName.of('Names'), PDFArray);
            JSNames.push(PDFHexString.fromText(this.embedder.scriptName));
            JSNames.push(ref);
            this.alreadyEmbedded = true;
            _b.label = 2;
          case 2:
            return [2];
        }
      });
    });
  };
  PDFJavaScript.of = function (ref, doc, embedder) {
    return new PDFJavaScript(ref, doc, embedder);
  };
  return PDFJavaScript;
}();

var JavaScriptEmbedder = function () {
  function JavaScriptEmbedder(script, scriptName) {
    this.script = script;
    this.scriptName = scriptName;
  }
  JavaScriptEmbedder.for = function (script, scriptName) {
    return new JavaScriptEmbedder(script, scriptName);
  };
  JavaScriptEmbedder.prototype.embedIntoContext = function (context, ref) {
    return __awaiter(this, void 0, void 0, function () {
      var jsActionDict;
      return __generator(this, function (_a) {
        jsActionDict = context.obj({
          Type: 'Action',
          S: 'JavaScript',
          JS: PDFHexString.fromText(this.script)
        });
        if (ref) {
          context.assign(ref, jsActionDict);
          return [2, ref];
        } else {
          return [2, context.register(jsActionDict)];
        }
      });
    });
  };
  return JavaScriptEmbedder;
}();

var PDFDocument = function () {
  function PDFDocument(context, ignoreEncryption, updateMetadata) {
    var _this = this;
    this.defaultWordBreaks = [' '];
    this.computePages = function () {
      var pages = [];
      _this.catalog.Pages().traverse(function (node, ref) {
        if (node instanceof PDFPageLeaf) {
          var page = _this.pageMap.get(node);
          if (!page) {
            page = PDFPage.of(node, ref, _this);
            _this.pageMap.set(node, page);
          }
          pages.push(page);
        }
      });
      return pages;
    };
    this.getOrCreateForm = function () {
      var acroForm = _this.catalog.getOrCreateAcroForm();
      return PDFForm.of(acroForm, _this);
    };
    assertIs(context, 'context', [[PDFContext, 'PDFContext']]);
    assertIs(ignoreEncryption, 'ignoreEncryption', ['boolean']);
    this.context = context;
    this.catalog = context.lookup(context.trailerInfo.Root);
    this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
    this.pageCache = Cache.populatedBy(this.computePages);
    this.pageMap = new Map();
    this.formCache = Cache.populatedBy(this.getOrCreateForm);
    this.fonts = [];
    this.images = [];
    this.embeddedPages = [];
    this.embeddedFiles = [];
    this.javaScripts = [];
    if (!ignoreEncryption && this.isEncrypted) throw new EncryptedPDFError();
    if (updateMetadata) this.updateInfoDict();
  }
  PDFDocument.load = function (pdf, options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? ParseSpeeds.Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
            assertIs(pdf, 'pdf', ['string', Uint8Array, ArrayBuffer]);
            assertIs(ignoreEncryption, 'ignoreEncryption', ['boolean']);
            assertIs(parseSpeed, 'parseSpeed', ['number']);
            assertIs(throwOnInvalidObject, 'throwOnInvalidObject', ['boolean']);
            bytes = toUint8Array(pdf);
            return [4, PDFParser.forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()];
          case 1:
            context = _f.sent();
            return [2, new PDFDocument(context, ignoreEncryption, updateMetadata)];
        }
      });
    });
  };
  PDFDocument.create = function (options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
      return __generator(this, function (_b) {
        _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
        context = PDFContext.create();
        pageTree = PDFPageTree.withContext(context);
        pageTreeRef = context.register(pageTree);
        catalog = PDFCatalog.withContextAndPages(context, pageTreeRef);
        context.trailerInfo.Root = context.register(catalog);
        return [2, new PDFDocument(context, false, updateMetadata)];
      });
    });
  };
  PDFDocument.prototype.registerFontkit = function (fontkit) {
    this.fontkit = fontkit;
  };
  PDFDocument.prototype.getForm = function () {
    var form = this.formCache.access();
    if (form.hasXFA()) {
      console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
      form.deleteXFA();
    }
    return form;
  };
  PDFDocument.prototype.getTitle = function () {
    var title = this.getInfoDict().lookup(PDFName.Title);
    if (!title) return undefined;
    assertIsLiteralOrHexString(title);
    return title.decodeText();
  };
  PDFDocument.prototype.getAuthor = function () {
    var author = this.getInfoDict().lookup(PDFName.Author);
    if (!author) return undefined;
    assertIsLiteralOrHexString(author);
    return author.decodeText();
  };
  PDFDocument.prototype.getSubject = function () {
    var subject = this.getInfoDict().lookup(PDFName.Subject);
    if (!subject) return undefined;
    assertIsLiteralOrHexString(subject);
    return subject.decodeText();
  };
  PDFDocument.prototype.getKeywords = function () {
    var keywords = this.getInfoDict().lookup(PDFName.Keywords);
    if (!keywords) return undefined;
    assertIsLiteralOrHexString(keywords);
    return keywords.decodeText();
  };
  PDFDocument.prototype.getCreator = function () {
    var creator = this.getInfoDict().lookup(PDFName.Creator);
    if (!creator) return undefined;
    assertIsLiteralOrHexString(creator);
    return creator.decodeText();
  };
  PDFDocument.prototype.getProducer = function () {
    var producer = this.getInfoDict().lookup(PDFName.Producer);
    if (!producer) return undefined;
    assertIsLiteralOrHexString(producer);
    return producer.decodeText();
  };
  PDFDocument.prototype.getCreationDate = function () {
    var creationDate = this.getInfoDict().lookup(PDFName.CreationDate);
    if (!creationDate) return undefined;
    assertIsLiteralOrHexString(creationDate);
    return creationDate.decodeDate();
  };
  PDFDocument.prototype.getModificationDate = function () {
    var modificationDate = this.getInfoDict().lookup(PDFName.ModDate);
    if (!modificationDate) return undefined;
    assertIsLiteralOrHexString(modificationDate);
    return modificationDate.decodeDate();
  };
  PDFDocument.prototype.setTitle = function (title, options) {
    assertIs(title, 'title', ['string']);
    var key = PDFName.of('Title');
    this.getInfoDict().set(key, PDFHexString.fromText(title));
    if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
      var prefs = this.catalog.getOrCreateViewerPreferences();
      prefs.setDisplayDocTitle(true);
    }
  };
  PDFDocument.prototype.setAuthor = function (author) {
    assertIs(author, 'author', ['string']);
    var key = PDFName.of('Author');
    this.getInfoDict().set(key, PDFHexString.fromText(author));
  };
  PDFDocument.prototype.setSubject = function (subject) {
    assertIs(subject, 'author', ['string']);
    var key = PDFName.of('Subject');
    this.getInfoDict().set(key, PDFHexString.fromText(subject));
  };
  PDFDocument.prototype.setKeywords = function (keywords) {
    assertIs(keywords, 'keywords', [Array]);
    var key = PDFName.of('Keywords');
    this.getInfoDict().set(key, PDFHexString.fromText(keywords.join(' ')));
  };
  PDFDocument.prototype.setCreator = function (creator) {
    assertIs(creator, 'creator', ['string']);
    var key = PDFName.of('Creator');
    this.getInfoDict().set(key, PDFHexString.fromText(creator));
  };
  PDFDocument.prototype.setProducer = function (producer) {
    assertIs(producer, 'creator', ['string']);
    var key = PDFName.of('Producer');
    this.getInfoDict().set(key, PDFHexString.fromText(producer));
  };
  PDFDocument.prototype.setLanguage = function (language) {
    assertIs(language, 'language', ['string']);
    var key = PDFName.of('Lang');
    this.catalog.set(key, PDFString.of(language));
  };
  PDFDocument.prototype.setCreationDate = function (creationDate) {
    assertIs(creationDate, 'creationDate', [[Date, 'Date']]);
    var key = PDFName.of('CreationDate');
    this.getInfoDict().set(key, PDFString.fromDate(creationDate));
  };
  PDFDocument.prototype.setModificationDate = function (modificationDate) {
    assertIs(modificationDate, 'modificationDate', [[Date, 'Date']]);
    var key = PDFName.of('ModDate');
    this.getInfoDict().set(key, PDFString.fromDate(modificationDate));
  };
  PDFDocument.prototype.getPageCount = function () {
    if (this.pageCount === undefined) this.pageCount = this.getPages().length;
    return this.pageCount;
  };
  PDFDocument.prototype.getPages = function () {
    return this.pageCache.access();
  };
  PDFDocument.prototype.getPage = function (index) {
    var pages = this.getPages();
    assertRange(index, 'index', 0, pages.length - 1);
    return pages[index];
  };
  PDFDocument.prototype.getPageIndices = function () {
    return range(0, this.getPageCount());
  };
  PDFDocument.prototype.removePage = function (index) {
    var pageCount = this.getPageCount();
    if (this.pageCount === 0) throw new RemovePageFromEmptyDocumentError();
    assertRange(index, 'index', 0, pageCount - 1);
    this.catalog.removeLeafNode(index);
    this.pageCount = pageCount - 1;
  };
  PDFDocument.prototype.addPage = function (page) {
    assertIs(page, 'page', ['undefined', [PDFPage, 'PDFPage'], Array]);
    return this.insertPage(this.getPageCount(), page);
  };
  PDFDocument.prototype.insertPage = function (index, page) {
    var pageCount = this.getPageCount();
    assertRange(index, 'index', 0, pageCount);
    assertIs(page, 'page', ['undefined', [PDFPage, 'PDFPage'], Array]);
    if (!page || Array.isArray(page)) {
      var dims = Array.isArray(page) ? page : PageSizes.A4;
      page = PDFPage.create(this);
      page.setSize.apply(page, dims);
    } else if (page.doc !== this) {
      throw new ForeignPageError();
    }
    var parentRef = this.catalog.insertLeafNode(page.ref, index);
    page.node.setParent(parentRef);
    this.pageMap.set(page.node, page);
    this.pageCache.invalidate();
    this.pageCount = pageCount + 1;
    return page;
  };
  PDFDocument.prototype.copyPages = function (srcDoc, indices) {
    return __awaiter(this, void 0, void 0, function () {
      var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assertIs(srcDoc, 'srcDoc', [[PDFDocument, 'PDFDocument']]);
            assertIs(indices, 'indices', [Array]);
            return [4, srcDoc.flush()];
          case 1:
            _a.sent();
            copier = PDFObjectCopier.for(srcDoc.context, this.context);
            srcPages = srcDoc.getPages();
            copiedPages = new Array(indices.length);
            for (idx = 0, len = indices.length; idx < len; idx++) {
              srcPage = srcPages[indices[idx]];
              copiedPage = copier.copy(srcPage.node);
              ref = this.context.register(copiedPage);
              copiedPages[idx] = PDFPage.of(copiedPage, ref, this);
            }
            return [2, copiedPages];
        }
      });
    });
  };
  PDFDocument.prototype.copy = function () {
    return __awaiter(this, void 0, void 0, function () {
      var pdfCopy, contentPages, idx, len;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, PDFDocument.create()];
          case 1:
            pdfCopy = _a.sent();
            return [4, pdfCopy.copyPages(this, this.getPageIndices())];
          case 2:
            contentPages = _a.sent();
            for (idx = 0, len = contentPages.length; idx < len; idx++) {
              pdfCopy.addPage(contentPages[idx]);
            }
            if (this.getAuthor() !== undefined) {
              pdfCopy.setAuthor(this.getAuthor());
            }
            if (this.getCreationDate() !== undefined) {
              pdfCopy.setCreationDate(this.getCreationDate());
            }
            if (this.getCreator() !== undefined) {
              pdfCopy.setCreator(this.getCreator());
            }
            if (this.getModificationDate() !== undefined) {
              pdfCopy.setModificationDate(this.getModificationDate());
            }
            if (this.getProducer() !== undefined) {
              pdfCopy.setProducer(this.getProducer());
            }
            if (this.getSubject() !== undefined) {
              pdfCopy.setSubject(this.getSubject());
            }
            if (this.getTitle() !== undefined) {
              pdfCopy.setTitle(this.getTitle());
            }
            pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
            return [2, pdfCopy];
        }
      });
    });
  };
  PDFDocument.prototype.addJavaScript = function (name, script) {
    assertIs(name, 'name', ['string']);
    assertIs(script, 'script', ['string']);
    var embedder = JavaScriptEmbedder.for(script, name);
    var ref = this.context.nextRef();
    var javaScript = PDFJavaScript.of(ref, this, embedder);
    this.javaScripts.push(javaScript);
  };
  PDFDocument.prototype.attach = function (attachment, name, options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var bytes, embedder, ref, embeddedFile;
      return __generator(this, function (_a) {
        assertIs(attachment, 'attachment', ['string', Uint8Array, ArrayBuffer]);
        assertIs(name, 'name', ['string']);
        assertOrUndefined(options.mimeType, 'mimeType', ['string']);
        assertOrUndefined(options.description, 'description', ['string']);
        assertOrUndefined(options.creationDate, 'options.creationDate', [Date]);
        assertOrUndefined(options.modificationDate, 'options.modificationDate', [Date]);
        assertIsOneOfOrUndefined(options.afRelationship, 'options.afRelationship', AFRelationship);
        bytes = toUint8Array(attachment);
        embedder = FileEmbedder.for(bytes, name, options);
        ref = this.context.nextRef();
        embeddedFile = PDFEmbeddedFile.of(ref, this, embedder);
        this.embeddedFiles.push(embeddedFile);
        return [2];
      });
    });
  };
  PDFDocument.prototype.embedFont = function (font, options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
            assertIs(font, 'font', ['string', Uint8Array, ArrayBuffer]);
            assertIs(subset, 'subset', ['boolean']);
            if (!isStandardFont(font)) return [3, 1];
            embedder = StandardFontEmbedder.for(font, customName);
            return [3, 7];
          case 1:
            if (!canBeConvertedToUint8Array(font)) return [3, 6];
            bytes = toUint8Array(font);
            fontkit = this.assertFontkit();
            if (!subset) return [3, 3];
            return [4, CustomFontSubsetEmbedder.for(fontkit, bytes, customName, features)];
          case 2:
            _b = _c.sent();
            return [3, 5];
          case 3:
            return [4, CustomFontEmbedder.for(fontkit, bytes, customName, features)];
          case 4:
            _b = _c.sent();
            _c.label = 5;
          case 5:
            embedder = _b;
            return [3, 7];
          case 6:
            throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
          case 7:
            ref = this.context.nextRef();
            pdfFont = PDFFont.of(ref, this, embedder);
            this.fonts.push(pdfFont);
            return [2, pdfFont];
        }
      });
    });
  };
  PDFDocument.prototype.embedStandardFont = function (font, customName) {
    assertIs(font, 'font', ['string']);
    if (!isStandardFont(font)) {
      throw new TypeError('`font` must be one of type `StandardFonts`');
    }
    var embedder = StandardFontEmbedder.for(font, customName);
    var ref = this.context.nextRef();
    var pdfFont = PDFFont.of(ref, this, embedder);
    this.fonts.push(pdfFont);
    return pdfFont;
  };
  PDFDocument.prototype.embedJpg = function (jpg) {
    return __awaiter(this, void 0, void 0, function () {
      var bytes, embedder, ref, pdfImage;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assertIs(jpg, 'jpg', ['string', Uint8Array, ArrayBuffer]);
            bytes = toUint8Array(jpg);
            return [4, JpegEmbedder.for(bytes)];
          case 1:
            embedder = _a.sent();
            ref = this.context.nextRef();
            pdfImage = PDFImage.of(ref, this, embedder);
            this.images.push(pdfImage);
            return [2, pdfImage];
        }
      });
    });
  };
  PDFDocument.prototype.embedPng = function (png) {
    return __awaiter(this, void 0, void 0, function () {
      var bytes, embedder, ref, pdfImage;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assertIs(png, 'png', ['string', Uint8Array, ArrayBuffer]);
            bytes = toUint8Array(png);
            return [4, PngEmbedder.for(bytes)];
          case 1:
            embedder = _a.sent();
            ref = this.context.nextRef();
            pdfImage = PDFImage.of(ref, this, embedder);
            this.images.push(pdfImage);
            return [2, pdfImage];
        }
      });
    });
  };
  PDFDocument.prototype.embedPdf = function (pdf, indices) {
    if (indices === void 0) {
      indices = [0];
    }
    return __awaiter(this, void 0, void 0, function () {
      var srcDoc, _a, srcPages;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            assertIs(pdf, 'pdf', ['string', Uint8Array, ArrayBuffer, [PDFDocument, 'PDFDocument']]);
            assertIs(indices, 'indices', [Array]);
            if (!(pdf instanceof PDFDocument)) return [3, 1];
            _a = pdf;
            return [3, 3];
          case 1:
            return [4, PDFDocument.load(pdf)];
          case 2:
            _a = _b.sent();
            _b.label = 3;
          case 3:
            srcDoc = _a;
            srcPages = pluckIndices(srcDoc.getPages(), indices);
            return [2, this.embedPages(srcPages)];
        }
      });
    });
  };
  PDFDocument.prototype.embedPage = function (page, boundingBox, transformationMatrix) {
    return __awaiter(this, void 0, void 0, function () {
      var embeddedPage;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assertIs(page, 'page', [[PDFPage, 'PDFPage']]);
            return [4, this.embedPages([page], [boundingBox], [transformationMatrix])];
          case 1:
            embeddedPage = _a.sent()[0];
            return [2, embeddedPage];
        }
      });
    });
  };
  PDFDocument.prototype.embedPages = function (pages, boundingBoxes, transformationMatrices) {
    if (boundingBoxes === void 0) {
      boundingBoxes = [];
    }
    if (transformationMatrices === void 0) {
      transformationMatrices = [];
    }
    return __awaiter(this, void 0, void 0, function () {
      var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (pages.length === 0) return [2, []];
            for (idx = 0, len = pages.length - 1; idx < len; idx++) {
              currPage = pages[idx];
              nextPage = pages[idx + 1];
              if (currPage.node.context !== nextPage.node.context) {
                throw new PageEmbeddingMismatchedContextError();
              }
            }
            context = pages[0].node.context;
            maybeCopyPage = context === this.context ? function (p) {
              return p;
            } : PDFObjectCopier.for(context, this.context).copy;
            embeddedPages = new Array(pages.length);
            idx = 0, len = pages.length;
            _b.label = 1;
          case 1:
            if (!(idx < len)) return [3, 4];
            page = maybeCopyPage(pages[idx].node);
            box = boundingBoxes[idx];
            matrix = transformationMatrices[idx];
            return [4, PDFPageEmbedder.for(page, box, matrix)];
          case 2:
            embedder = _b.sent();
            ref = this.context.nextRef();
            embeddedPages[idx] = PDFEmbeddedPage.of(ref, this, embedder);
            _b.label = 3;
          case 3:
            idx++;
            return [3, 1];
          case 4:
            (_a = this.embeddedPages).push.apply(_a, embeddedPages);
            return [2, embeddedPages];
        }
      });
    });
  };
  PDFDocument.prototype.flush = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.embedAll(this.fonts)];
          case 1:
            _a.sent();
            return [4, this.embedAll(this.images)];
          case 2:
            _a.sent();
            return [4, this.embedAll(this.embeddedPages)];
          case 3:
            _a.sent();
            return [4, this.embedAll(this.embeddedFiles)];
          case 4:
            _a.sent();
            return [4, this.embedAll(this.javaScripts)];
          case 5:
            _a.sent();
            return [2];
        }
      });
    });
  };
  PDFDocument.prototype.save = function (options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
            assertIs(useObjectStreams, 'useObjectStreams', ['boolean']);
            assertIs(addDefaultPage, 'addDefaultPage', ['boolean']);
            assertIs(objectsPerTick, 'objectsPerTick', ['number']);
            assertIs(updateFieldAppearances, 'updateFieldAppearances', ['boolean']);
            if (addDefaultPage && this.getPageCount() === 0) this.addPage();
            if (updateFieldAppearances) {
              form = this.formCache.getValue();
              if (form) form.updateFieldAppearances();
            }
            return [4, this.flush()];
          case 1:
            _e.sent();
            Writer = useObjectStreams ? PDFStreamWriter : PDFWriter;
            return [2, Writer.forContext(this.context, objectsPerTick).serializeToBuffer()];
        }
      });
    });
  };
  PDFDocument.prototype.saveAsBase64 = function (options) {
    if (options === void 0) {
      options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
      var _a, dataUri, otherOptions, bytes, base64;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = __rest(options, ["dataUri"]);
            assertIs(dataUri, 'dataUri', ['boolean']);
            return [4, this.save(otherOptions)];
          case 1:
            bytes = _b.sent();
            base64 = encodeToBase64(bytes);
            return [2, dataUri ? "data:application/pdf;base64," + base64 : base64];
        }
      });
    });
  };
  PDFDocument.prototype.findPageForAnnotationRef = function (ref) {
    var pages = this.getPages();
    for (var idx = 0, len = pages.length; idx < len; idx++) {
      var page = pages[idx];
      var annotations = page.node.Annots();
      if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) {
        return page;
      }
    }
    return undefined;
  };
  PDFDocument.prototype.embedAll = function (embeddables) {
    return __awaiter(this, void 0, void 0, function () {
      var idx, len;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            idx = 0, len = embeddables.length;
            _a.label = 1;
          case 1:
            if (!(idx < len)) return [3, 4];
            return [4, embeddables[idx].embed()];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            idx++;
            return [3, 1];
          case 4:
            return [2];
        }
      });
    });
  };
  PDFDocument.prototype.updateInfoDict = function () {
    var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
    var now = new Date();
    var info = this.getInfoDict();
    this.setProducer(pdfLib);
    this.setModificationDate(now);
    if (!info.get(PDFName.of('Creator'))) this.setCreator(pdfLib);
    if (!info.get(PDFName.of('CreationDate'))) this.setCreationDate(now);
  };
  PDFDocument.prototype.getInfoDict = function () {
    var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
    if (existingInfo instanceof PDFDict) return existingInfo;
    var newInfo = this.context.obj({});
    this.context.trailerInfo.Info = this.context.register(newInfo);
    return newInfo;
  };
  PDFDocument.prototype.assertFontkit = function () {
    if (!this.fontkit) throw new FontkitNotRegisteredError();
    return this.fontkit;
  };
  return PDFDocument;
}();
function assertIsLiteralOrHexString(pdfObject) {
  if (!(pdfObject instanceof PDFHexString) && !(pdfObject instanceof PDFString)) {
    throw new UnexpectedObjectTypeError([PDFHexString, PDFString], pdfObject);
  }
}

var BlendMode;
(function (BlendMode) {
  BlendMode["Normal"] = "Normal";
  BlendMode["Multiply"] = "Multiply";
  BlendMode["Screen"] = "Screen";
  BlendMode["Overlay"] = "Overlay";
  BlendMode["Darken"] = "Darken";
  BlendMode["Lighten"] = "Lighten";
  BlendMode["ColorDodge"] = "ColorDodge";
  BlendMode["ColorBurn"] = "ColorBurn";
  BlendMode["HardLight"] = "HardLight";
  BlendMode["SoftLight"] = "SoftLight";
  BlendMode["Difference"] = "Difference";
  BlendMode["Exclusion"] = "Exclusion";
})(BlendMode || (BlendMode = {}));

var PDFPage = function () {
  function PDFPage(leafNode, ref, doc) {
    this.fontSize = 24;
    this.fontColor = rgb(0, 0, 0);
    this.lineHeight = 24;
    this.x = 0;
    this.y = 0;
    assertIs(leafNode, 'leafNode', [[PDFPageLeaf, 'PDFPageLeaf']]);
    assertIs(ref, 'ref', [[PDFRef, 'PDFRef']]);
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    this.node = leafNode;
    this.ref = ref;
    this.doc = doc;
  }
  PDFPage.prototype.setRotation = function (angle) {
    var degreesAngle = toDegrees(angle);
    assertMultiple(degreesAngle, 'degreesAngle', 90);
    this.node.set(PDFName.of('Rotate'), this.doc.context.obj(degreesAngle));
  };
  PDFPage.prototype.getRotation = function () {
    var Rotate = this.node.Rotate();
    return degrees(Rotate ? Rotate.asNumber() : 0);
  };
  PDFPage.prototype.setSize = function (width, height) {
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var mediaBox = this.getMediaBox();
    this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
    var cropBox = this.getCropBox();
    var bleedBox = this.getBleedBox();
    var trimBox = this.getTrimBox();
    var artBox = this.getArtBox();
    var hasCropBox = this.node.CropBox();
    var hasBleedBox = this.node.BleedBox();
    var hasTrimBox = this.node.TrimBox();
    var hasArtBox = this.node.ArtBox();
    if (hasCropBox && rectanglesAreEqual(cropBox, mediaBox)) {
      this.setCropBox(mediaBox.x, mediaBox.y, width, height);
    }
    if (hasBleedBox && rectanglesAreEqual(bleedBox, mediaBox)) {
      this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
    }
    if (hasTrimBox && rectanglesAreEqual(trimBox, mediaBox)) {
      this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
    }
    if (hasArtBox && rectanglesAreEqual(artBox, mediaBox)) {
      this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    }
  };
  PDFPage.prototype.setWidth = function (width) {
    assertIs(width, 'width', ['number']);
    this.setSize(width, this.getSize().height);
  };
  PDFPage.prototype.setHeight = function (height) {
    assertIs(height, 'height', ['number']);
    this.setSize(this.getSize().width, height);
  };
  PDFPage.prototype.setMediaBox = function (x, y, width, height) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var mediaBox = this.doc.context.obj([x, y, x + width, y + height]);
    this.node.set(PDFName.MediaBox, mediaBox);
  };
  PDFPage.prototype.setCropBox = function (x, y, width, height) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var cropBox = this.doc.context.obj([x, y, x + width, y + height]);
    this.node.set(PDFName.CropBox, cropBox);
  };
  PDFPage.prototype.setBleedBox = function (x, y, width, height) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var bleedBox = this.doc.context.obj([x, y, x + width, y + height]);
    this.node.set(PDFName.BleedBox, bleedBox);
  };
  PDFPage.prototype.setTrimBox = function (x, y, width, height) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var trimBox = this.doc.context.obj([x, y, x + width, y + height]);
    this.node.set(PDFName.TrimBox, trimBox);
  };
  PDFPage.prototype.setArtBox = function (x, y, width, height) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    assertIs(width, 'width', ['number']);
    assertIs(height, 'height', ['number']);
    var artBox = this.doc.context.obj([x, y, x + width, y + height]);
    this.node.set(PDFName.ArtBox, artBox);
  };
  PDFPage.prototype.getSize = function () {
    var _a = this.getMediaBox(),
      width = _a.width,
      height = _a.height;
    return {
      width: width,
      height: height
    };
  };
  PDFPage.prototype.getWidth = function () {
    return this.getSize().width;
  };
  PDFPage.prototype.getHeight = function () {
    return this.getSize().height;
  };
  PDFPage.prototype.getMediaBox = function () {
    var mediaBox = this.node.MediaBox();
    return mediaBox.asRectangle();
  };
  PDFPage.prototype.getCropBox = function () {
    var _a;
    var cropBox = this.node.CropBox();
    return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
  };
  PDFPage.prototype.getBleedBox = function () {
    var _a;
    var bleedBox = this.node.BleedBox();
    return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
  };
  PDFPage.prototype.getTrimBox = function () {
    var _a;
    var trimBox = this.node.TrimBox();
    return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
  };
  PDFPage.prototype.getArtBox = function () {
    var _a;
    var artBox = this.node.ArtBox();
    return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
  };
  PDFPage.prototype.translateContent = function (x, y) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    this.node.normalize();
    this.getContentStream();
    var start = this.createContentStream(pushGraphicsState(), translate(x, y));
    var startRef = this.doc.context.register(start);
    var end = this.createContentStream(popGraphicsState());
    var endRef = this.doc.context.register(end);
    this.node.wrapContentStreams(startRef, endRef);
  };
  PDFPage.prototype.scale = function (x, y) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    this.setSize(this.getWidth() * x, this.getHeight() * y);
    this.scaleContent(x, y);
    this.scaleAnnotations(x, y);
  };
  PDFPage.prototype.scaleContent = function (x, y) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    this.node.normalize();
    this.getContentStream();
    var start = this.createContentStream(pushGraphicsState(), scale(x, y));
    var startRef = this.doc.context.register(start);
    var end = this.createContentStream(popGraphicsState());
    var endRef = this.doc.context.register(end);
    this.node.wrapContentStreams(startRef, endRef);
  };
  PDFPage.prototype.scaleAnnotations = function (x, y) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    var annots = this.node.Annots();
    if (!annots) return;
    for (var idx = 0; idx < annots.size(); idx++) {
      var annot = annots.lookup(idx);
      if (annot instanceof PDFDict) this.scaleAnnot(annot, x, y);
    }
  };
  PDFPage.prototype.resetPosition = function () {
    this.getContentStream(false);
    this.x = 0;
    this.y = 0;
  };
  PDFPage.prototype.setFont = function (font) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    this.font = font;
    this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
  };
  PDFPage.prototype.setFontSize = function (fontSize) {
    assertIs(fontSize, 'fontSize', ['number']);
    this.fontSize = fontSize;
  };
  PDFPage.prototype.setFontColor = function (fontColor) {
    assertIs(fontColor, 'fontColor', [[Object, 'Color']]);
    this.fontColor = fontColor;
  };
  PDFPage.prototype.setLineHeight = function (lineHeight) {
    assertIs(lineHeight, 'lineHeight', ['number']);
    this.lineHeight = lineHeight;
  };
  PDFPage.prototype.getPosition = function () {
    return {
      x: this.x,
      y: this.y
    };
  };
  PDFPage.prototype.getX = function () {
    return this.x;
  };
  PDFPage.prototype.getY = function () {
    return this.y;
  };
  PDFPage.prototype.moveTo = function (x, y) {
    assertIs(x, 'x', ['number']);
    assertIs(y, 'y', ['number']);
    this.x = x;
    this.y = y;
  };
  PDFPage.prototype.moveDown = function (yDecrease) {
    assertIs(yDecrease, 'yDecrease', ['number']);
    this.y -= yDecrease;
  };
  PDFPage.prototype.moveUp = function (yIncrease) {
    assertIs(yIncrease, 'yIncrease', ['number']);
    this.y += yIncrease;
  };
  PDFPage.prototype.moveLeft = function (xDecrease) {
    assertIs(xDecrease, 'xDecrease', ['number']);
    this.x -= xDecrease;
  };
  PDFPage.prototype.moveRight = function (xIncrease) {
    assertIs(xIncrease, 'xIncrease', ['number']);
    this.x += xIncrease;
  };
  PDFPage.prototype.pushOperators = function () {
    var operator = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operator[_i] = arguments[_i];
    }
    assertEachIs(operator, 'operator', [[PDFOperator, 'PDFOperator']]);
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, operator);
  };
  PDFPage.prototype.drawText = function (text, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (options === void 0) {
      options = {};
    }
    assertIs(text, 'text', ['string']);
    assertOrUndefined(options.color, 'options.color', [[Object, 'Color']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertOrUndefined(options.font, 'options.font', [[PDFFont, 'PDFFont']]);
    assertOrUndefined(options.size, 'options.size', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.xSkew, 'options.xSkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.ySkew, 'options.ySkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.lineHeight, 'options.lineHeight', ['number']);
    assertOrUndefined(options.maxWidth, 'options.maxWidth', ['number']);
    assertOrUndefined(options.wordBreaks, 'options.wordBreaks', [Array]);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var _h = this.setOrEmbedFont(options.font),
      oldFont = _h.oldFont,
      newFont = _h.newFont,
      newFontKey = _h.newFontKey;
    var fontSize = options.size || this.fontSize;
    var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
    var textWidth = function (t) {
      return newFont.widthOfTextAtSize(t, fontSize);
    };
    var lines = options.maxWidth === undefined ? lineSplit(cleanText(text)) : breakTextIntoLines(text, wordBreaks, options.maxWidth, textWidth);
    var encodedLines = new Array(lines.length);
    for (var idx = 0, len = lines.length; idx < len; idx++) {
      encodedLines[idx] = newFont.encodeText(lines[idx]);
    }
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      blendMode: options.blendMode
    });
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawLinesOfText(encodedLines, {
      color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
      font: newFontKey,
      size: fontSize,
      rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : degrees(0),
      xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : degrees(0),
      ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : degrees(0),
      x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
      y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
      lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
      graphicsState: graphicsStateKey
    }));
    if (options.font) {
      if (oldFont) this.setFont(oldFont);else this.resetFont();
    }
  };
  PDFPage.prototype.drawImage = function (image, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (options === void 0) {
      options = {};
    }
    assertIs(image, 'image', [[PDFImage, 'PDFImage']]);
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.width, 'options.width', ['number']);
    assertOrUndefined(options.height, 'options.height', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.xSkew, 'options.xSkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.ySkew, 'options.ySkew', [[Object, 'Rotation']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var xObjectKey = this.node.newXObject('Image', image.ref);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      blendMode: options.blendMode
    });
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawImage(xObjectKey, {
      x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
      rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : degrees(0),
      xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : degrees(0),
      ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : degrees(0),
      graphicsState: graphicsStateKey
    }));
  };
  PDFPage.prototype.drawPage = function (embeddedPage, options) {
    var _a, _b, _c, _d, _e;
    if (options === void 0) {
      options = {};
    }
    assertIs(embeddedPage, 'embeddedPage', [[PDFEmbeddedPage, 'PDFEmbeddedPage']]);
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.xScale, 'options.xScale', ['number']);
    assertOrUndefined(options.yScale, 'options.yScale', ['number']);
    assertOrUndefined(options.width, 'options.width', ['number']);
    assertOrUndefined(options.height, 'options.height', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.xSkew, 'options.xSkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.ySkew, 'options.ySkew', [[Object, 'Rotation']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      blendMode: options.blendMode
    });
    var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
    var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawPage(xObjectKey, {
      x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
      xScale: xScale,
      yScale: yScale,
      rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : degrees(0),
      xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : degrees(0),
      ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : degrees(0),
      graphicsState: graphicsStateKey
    }));
  };
  PDFPage.prototype.drawSvgPath = function (path, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (options === void 0) {
      options = {};
    }
    assertIs(path, 'path', ['string']);
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.scale, 'options.scale', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.borderWidth, 'options.borderWidth', ['number']);
    assertOrUndefined(options.color, 'options.color', [[Object, 'Color']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertOrUndefined(options.borderColor, 'options.borderColor', [[Object, 'Color']]);
    assertOrUndefined(options.borderDashArray, 'options.borderDashArray', [Array]);
    assertOrUndefined(options.borderDashPhase, 'options.borderDashPhase', ['number']);
    assertIsOneOfOrUndefined(options.borderLineCap, 'options.borderLineCap', LineCapStyle);
    assertRangeOrUndefined(options.borderOpacity, 'options.borderOpacity', 0, 1);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      borderOpacity: options.borderOpacity,
      blendMode: options.blendMode
    });
    if (!('color' in options) && !('borderColor' in options)) {
      options.borderColor = rgb(0, 0, 0);
    }
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawSvgPath(path, {
      x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
      scale: options.scale,
      rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : degrees(0),
      color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
      borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
      borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
      borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
      borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
      borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
      graphicsState: graphicsStateKey
    }));
  };
  PDFPage.prototype.drawLine = function (options) {
    var _a, _b, _c, _d, _e;
    assertIs(options.start, 'options.start', [[Object, '{ x: number, y: number }']]);
    assertIs(options.end, 'options.end', [[Object, '{ x: number, y: number }']]);
    assertIs(options.start.x, 'options.start.x', ['number']);
    assertIs(options.start.y, 'options.start.y', ['number']);
    assertIs(options.end.x, 'options.end.x', ['number']);
    assertIs(options.end.y, 'options.end.y', ['number']);
    assertOrUndefined(options.thickness, 'options.thickness', ['number']);
    assertOrUndefined(options.color, 'options.color', [[Object, 'Color']]);
    assertOrUndefined(options.dashArray, 'options.dashArray', [Array]);
    assertOrUndefined(options.dashPhase, 'options.dashPhase', ['number']);
    assertIsOneOfOrUndefined(options.lineCap, 'options.lineCap', LineCapStyle);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      borderOpacity: options.opacity,
      blendMode: options.blendMode
    });
    if (!('color' in options)) {
      options.color = rgb(0, 0, 0);
    }
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawLine({
      start: options.start,
      end: options.end,
      thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
      color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
      dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
      dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
      lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
      graphicsState: graphicsStateKey
    }));
  };
  PDFPage.prototype.drawRectangle = function (options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (options === void 0) {
      options = {};
    }
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.width, 'options.width', ['number']);
    assertOrUndefined(options.height, 'options.height', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.xSkew, 'options.xSkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.ySkew, 'options.ySkew', [[Object, 'Rotation']]);
    assertOrUndefined(options.borderWidth, 'options.borderWidth', ['number']);
    assertOrUndefined(options.color, 'options.color', [[Object, 'Color']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertOrUndefined(options.borderColor, 'options.borderColor', [[Object, 'Color']]);
    assertOrUndefined(options.borderDashArray, 'options.borderDashArray', [Array]);
    assertOrUndefined(options.borderDashPhase, 'options.borderDashPhase', ['number']);
    assertIsOneOfOrUndefined(options.borderLineCap, 'options.borderLineCap', LineCapStyle);
    assertRangeOrUndefined(options.borderOpacity, 'options.borderOpacity', 0, 1);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      borderOpacity: options.borderOpacity,
      blendMode: options.blendMode
    });
    if (!('color' in options) && !('borderColor' in options)) {
      options.color = rgb(0, 0, 0);
    }
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawRectangle({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
      width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
      height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
      rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : degrees(0),
      xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : degrees(0),
      ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : degrees(0),
      borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
      color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
      borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
      borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
      borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
      graphicsState: graphicsStateKey,
      borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
    }));
  };
  PDFPage.prototype.drawSquare = function (options) {
    if (options === void 0) {
      options = {};
    }
    var size = options.size;
    assertOrUndefined(size, 'size', ['number']);
    this.drawRectangle(__assign(__assign({}, options), {
      width: size,
      height: size
    }));
  };
  PDFPage.prototype.drawEllipse = function (options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (options === void 0) {
      options = {};
    }
    assertOrUndefined(options.x, 'options.x', ['number']);
    assertOrUndefined(options.y, 'options.y', ['number']);
    assertOrUndefined(options.xScale, 'options.xScale', ['number']);
    assertOrUndefined(options.yScale, 'options.yScale', ['number']);
    assertOrUndefined(options.rotate, 'options.rotate', [[Object, 'Rotation']]);
    assertOrUndefined(options.color, 'options.color', [[Object, 'Color']]);
    assertRangeOrUndefined(options.opacity, 'opacity.opacity', 0, 1);
    assertOrUndefined(options.borderColor, 'options.borderColor', [[Object, 'Color']]);
    assertRangeOrUndefined(options.borderOpacity, 'options.borderOpacity', 0, 1);
    assertOrUndefined(options.borderWidth, 'options.borderWidth', ['number']);
    assertOrUndefined(options.borderDashArray, 'options.borderDashArray', [Array]);
    assertOrUndefined(options.borderDashPhase, 'options.borderDashPhase', ['number']);
    assertIsOneOfOrUndefined(options.borderLineCap, 'options.borderLineCap', LineCapStyle);
    assertIsOneOfOrUndefined(options.blendMode, 'options.blendMode', BlendMode);
    var graphicsStateKey = this.maybeEmbedGraphicsState({
      opacity: options.opacity,
      borderOpacity: options.borderOpacity,
      blendMode: options.blendMode
    });
    if (!('color' in options) && !('borderColor' in options)) {
      options.color = rgb(0, 0, 0);
    }
    var contentStream = this.getContentStream();
    contentStream.push.apply(contentStream, drawEllipse({
      x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
      y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
      xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
      yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
      rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
      color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
      borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
      borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
      borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
      borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
      borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
      graphicsState: graphicsStateKey
    }));
  };
  PDFPage.prototype.drawCircle = function (options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.size,
      size = _a === void 0 ? 100 : _a;
    assertOrUndefined(size, 'size', ['number']);
    this.drawEllipse(__assign(__assign({}, options), {
      xScale: size,
      yScale: size
    }));
  };
  PDFPage.prototype.setOrEmbedFont = function (font) {
    var oldFont = this.font;
    var oldFontKey = this.fontKey;
    if (font) this.setFont(font);else this.getFont();
    var newFont = this.font;
    var newFontKey = this.fontKey;
    return {
      oldFont: oldFont,
      oldFontKey: oldFontKey,
      newFont: newFont,
      newFontKey: newFontKey
    };
  };
  PDFPage.prototype.getFont = function () {
    if (!this.font || !this.fontKey) {
      var font = this.doc.embedStandardFont(StandardFonts.Helvetica);
      this.setFont(font);
    }
    return [this.font, this.fontKey];
  };
  PDFPage.prototype.resetFont = function () {
    this.font = undefined;
    this.fontKey = undefined;
  };
  PDFPage.prototype.getContentStream = function (useExisting) {
    if (useExisting === void 0) {
      useExisting = true;
    }
    if (useExisting && this.contentStream) return this.contentStream;
    this.contentStream = this.createContentStream();
    this.contentStreamRef = this.doc.context.register(this.contentStream);
    this.node.addContentStream(this.contentStreamRef);
    return this.contentStream;
  };
  PDFPage.prototype.createContentStream = function () {
    var operators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operators[_i] = arguments[_i];
    }
    var dict = this.doc.context.obj({});
    var contentStream = PDFContentStream.of(dict, operators);
    return contentStream;
  };
  PDFPage.prototype.maybeEmbedGraphicsState = function (options) {
    var opacity = options.opacity,
      borderOpacity = options.borderOpacity,
      blendMode = options.blendMode;
    if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) {
      return undefined;
    }
    var graphicsState = this.doc.context.obj({
      Type: 'ExtGState',
      ca: opacity,
      CA: borderOpacity,
      BM: blendMode
    });
    var key = this.node.newExtGState('GS', graphicsState);
    return key;
  };
  PDFPage.prototype.scaleAnnot = function (annot, x, y) {
    var selectors = ['RD', 'CL', 'Vertices', 'QuadPoints', 'L', 'Rect'];
    for (var idx = 0, len = selectors.length; idx < len; idx++) {
      var list = annot.lookup(PDFName.of(selectors[idx]));
      if (list instanceof PDFArray) list.scalePDFNumbers(x, y);
    }
    var inkLists = annot.lookup(PDFName.of('InkList'));
    if (inkLists instanceof PDFArray) {
      for (var idx = 0, len = inkLists.size(); idx < len; idx++) {
        var arr = inkLists.lookup(idx);
        if (arr instanceof PDFArray) arr.scalePDFNumbers(x, y);
      }
    }
  };
  PDFPage.of = function (leafNode, ref, doc) {
    return new PDFPage(leafNode, ref, doc);
  };
  PDFPage.create = function (doc) {
    assertIs(doc, 'doc', [[PDFDocument, 'PDFDocument']]);
    var dummyRef = PDFRef.of(-1);
    var pageLeaf = PDFPageLeaf.withContextAndParent(doc.context, dummyRef);
    var pageRef = doc.context.register(pageLeaf);
    return new PDFPage(pageLeaf, pageRef, doc);
  };
  return PDFPage;
}();

var PDFButton = function (_super) {
  __extends(PDFButton, _super);
  function PDFButton(acroPushButton, ref, doc) {
    var _this = _super.call(this, acroPushButton, ref, doc) || this;
    assertIs(acroPushButton, 'acroButton', [[PDFAcroPushButton, 'PDFAcroPushButton']]);
    _this.acroField = acroPushButton;
    return _this;
  }
  PDFButton.prototype.setImage = function (image, alignment) {
    if (alignment === void 0) {
      alignment = ImageAlignment.Center;
    }
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var streamRef = this.createImageAppearanceStream(widget, image, alignment);
      this.updateWidgetAppearances(widget, {
        normal: streamRef
      });
    }
    this.markAsClean();
  };
  PDFButton.prototype.setFontSize = function (fontSize) {
    assertPositive(fontSize, 'fontSize');
    this.acroField.setFontSize(fontSize);
    this.markAsDirty();
  };
  PDFButton.prototype.addToPage = function (text, page, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    assertOrUndefined(text, 'text', ['string']);
    assertOrUndefined(page, 'page', [[PDFPage, 'PDFPage']]);
    assertFieldAppearanceOptions(options);
    var widget = this.createWidget({
      x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
      y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
      width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
      height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
      textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : rgb(0, 0, 0),
      backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : rgb(0.75, 0.75, 0.75),
      borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
      borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
      rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : degrees(0),
      caption: text,
      hidden: options === null || options === void 0 ? void 0 : options.hidden,
      page: page.ref
    });
    var widgetRef = this.doc.context.register(widget.dict);
    this.acroField.addWidget(widgetRef);
    var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
    this.updateWidgetAppearance(widget, font);
    page.node.addAnnot(widgetRef);
  };
  PDFButton.prototype.needsAppearancesUpdate = function () {
    var _a;
    if (this.isDirty()) return true;
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof PDFStream;
      if (!hasAppearances) return true;
    }
    return false;
  };
  PDFButton.prototype.defaultUpdateAppearances = function (font) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    this.updateAppearances(font);
  };
  PDFButton.prototype.updateAppearances = function (font, provider) {
    assertIs(font, 'font', [[PDFFont, 'PDFFont']]);
    assertOrUndefined(provider, 'provider', [Function]);
    var widgets = this.acroField.getWidgets();
    for (var idx = 0, len = widgets.length; idx < len; idx++) {
      var widget = widgets[idx];
      this.updateWidgetAppearance(widget, font, provider);
    }
  };
  PDFButton.prototype.updateWidgetAppearance = function (widget, font, provider) {
    var apProvider = provider !== null && provider !== void 0 ? provider : defaultButtonAppearanceProvider;
    var appearances = normalizeAppearance(apProvider(this, widget, font));
    this.updateWidgetAppearanceWithFont(widget, font, appearances);
  };
  PDFButton.of = function (acroPushButton, ref, doc) {
    return new PDFButton(acroPushButton, ref, doc);
  };
  return PDFButton;
}(PDFField);



var PDFLib = {
  __proto__: null,
  PDFDocument: PDFDocument,
  PDFFont: PDFFont,
  PDFImage: PDFImage,
  PDFPage: PDFPage,
  PDFEmbeddedPage: PDFEmbeddedPage,
  PDFJavaScript: PDFJavaScript,
  PDFButton: PDFButton,
  PDFCheckBox: PDFCheckBox,
  PDFDropdown: PDFDropdown,
  PDFField: PDFField,
  PDFForm: PDFForm,
  PDFOptionList: PDFOptionList,
  PDFRadioGroup: PDFRadioGroup,
  PDFSignature: PDFSignature,
  PDFTextField: PDFTextField,
  normalizeAppearance: normalizeAppearance,
  defaultCheckBoxAppearanceProvider: defaultCheckBoxAppearanceProvider,
  defaultRadioGroupAppearanceProvider: defaultRadioGroupAppearanceProvider,
  defaultButtonAppearanceProvider: defaultButtonAppearanceProvider,
  defaultTextFieldAppearanceProvider: defaultTextFieldAppearanceProvider,
  defaultDropdownAppearanceProvider: defaultDropdownAppearanceProvider,
  defaultOptionListAppearanceProvider: defaultOptionListAppearanceProvider,
  get TextAlignment () { return TextAlignment; },
  layoutMultilineText: layoutMultilineText,
  layoutCombedText: layoutCombedText,
  layoutSinglelineText: layoutSinglelineText,
  get ColorTypes () { return ColorTypes; },
  grayscale: grayscale,
  rgb: rgb,
  cmyk: cmyk,
  setFillingColor: setFillingColor,
  setStrokingColor: setStrokingColor,
  componentsToColor: componentsToColor,
  colorToComponents: colorToComponents,
  EncryptedPDFError: EncryptedPDFError,
  FontkitNotRegisteredError: FontkitNotRegisteredError,
  ForeignPageError: ForeignPageError,
  RemovePageFromEmptyDocumentError: RemovePageFromEmptyDocumentError,
  NoSuchFieldError: NoSuchFieldError,
  UnexpectedFieldTypeError: UnexpectedFieldTypeError,
  MissingOnValueCheckError: MissingOnValueCheckError,
  FieldAlreadyExistsError: FieldAlreadyExistsError,
  InvalidFieldNamePartError: InvalidFieldNamePartError,
  FieldExistsAsNonTerminalError: FieldExistsAsNonTerminalError,
  RichTextFieldReadError: RichTextFieldReadError,
  CombedTextLayoutError: CombedTextLayoutError,
  ExceededMaxLengthError: ExceededMaxLengthError,
  InvalidMaxLengthError: InvalidMaxLengthError,
  get ImageAlignment () { return ImageAlignment; },
  asPDFName: asPDFName,
  asPDFNumber: asPDFNumber,
  asNumber: asNumber,
  drawText: drawText,
  drawLinesOfText: drawLinesOfText,
  drawImage: drawImage,
  drawPage: drawPage,
  drawLine: drawLine,
  drawRectangle: drawRectangle,
  drawEllipsePath: drawEllipsePath,
  drawEllipse: drawEllipse,
  drawSvgPath: drawSvgPath,
  drawCheckMark: drawCheckMark,
  rotateInPlace: rotateInPlace,
  drawCheckBox: drawCheckBox,
  drawRadioButton: drawRadioButton,
  drawButton: drawButton,
  drawTextLines: drawTextLines,
  drawTextField: drawTextField,
  drawOptionList: drawOptionList,
  clip: clip,
  clipEvenOdd: clipEvenOdd,
  concatTransformationMatrix: concatTransformationMatrix,
  translate: translate,
  scale: scale,
  rotateRadians: rotateRadians,
  rotateDegrees: rotateDegrees,
  skewRadians: skewRadians,
  skewDegrees: skewDegrees,
  setDashPattern: setDashPattern,
  restoreDashPattern: restoreDashPattern,
  get LineCapStyle () { return LineCapStyle; },
  setLineCap: setLineCap,
  get LineJoinStyle () { return LineJoinStyle; },
  setLineJoin: setLineJoin,
  setGraphicsState: setGraphicsState,
  pushGraphicsState: pushGraphicsState,
  popGraphicsState: popGraphicsState,
  setLineWidth: setLineWidth,
  appendBezierCurve: appendBezierCurve,
  appendQuadraticCurve: appendQuadraticCurve,
  closePath: closePath,
  moveTo: moveTo,
  lineTo: lineTo,
  rectangle: rectangle,
  square: square,
  stroke: stroke,
  fill: fill,
  fillAndStroke: fillAndStroke,
  endPath: endPath,
  nextLine: nextLine,
  moveText: moveText,
  showText: showText,
  beginText: beginText,
  endText: endText,
  setFontAndSize: setFontAndSize,
  setCharacterSpacing: setCharacterSpacing,
  setWordSpacing: setWordSpacing,
  setCharacterSqueeze: setCharacterSqueeze,
  setLineHeight: setLineHeight,
  setTextRise: setTextRise,
  get TextRenderingMode () { return TextRenderingMode; },
  setTextRenderingMode: setTextRenderingMode,
  setTextMatrix: setTextMatrix,
  rotateAndSkewTextRadiansAndTranslate: rotateAndSkewTextRadiansAndTranslate,
  rotateAndSkewTextDegreesAndTranslate: rotateAndSkewTextDegreesAndTranslate,
  drawObject: drawObject,
  setFillingGrayscaleColor: setFillingGrayscaleColor,
  setStrokingGrayscaleColor: setStrokingGrayscaleColor,
  setFillingRgbColor: setFillingRgbColor,
  setStrokingRgbColor: setStrokingRgbColor,
  setFillingCmykColor: setFillingCmykColor,
  setStrokingCmykColor: setStrokingCmykColor,
  beginMarkedContent: beginMarkedContent,
  endMarkedContent: endMarkedContent,
  get RotationTypes () { return RotationTypes; },
  radians: radians,
  degrees: degrees,
  degreesToRadians: degreesToRadians,
  radiansToDegrees: radiansToDegrees,
  toRadians: toRadians,
  toDegrees: toDegrees,
  reduceRotation: reduceRotation,
  adjustDimsForRotation: adjustDimsForRotation,
  rotateRectangle: rotateRectangle,
  PageSizes: PageSizes,
  get BlendMode () { return BlendMode; },
  get ParseSpeeds () { return ParseSpeeds; },
  get StandardFonts () { return StandardFonts; },
  CharCodes: CharCodes$1,
  PDFContext: PDFContext,
  PDFObjectCopier: PDFObjectCopier,
  PDFWriter: PDFWriter,
  PDFStreamWriter: PDFStreamWriter,
  PDFHeader: PDFHeader,
  PDFTrailer: PDFTrailer,
  PDFTrailerDict: PDFTrailerDict,
  PDFCrossRefSection: PDFCrossRefSection,
  StandardFontEmbedder: StandardFontEmbedder,
  CustomFontEmbedder: CustomFontEmbedder,
  CustomFontSubsetEmbedder: CustomFontSubsetEmbedder,
  FileEmbedder: FileEmbedder,
  get AFRelationship () { return AFRelationship; },
  JpegEmbedder: JpegEmbedder,
  PngEmbedder: PngEmbedder,
  PDFPageEmbedder: PDFPageEmbedder,
  ViewerPreferences: ViewerPreferences,
  get NonFullScreenPageMode () { return NonFullScreenPageMode; },
  get ReadingDirection () { return ReadingDirection; },
  get PrintScaling () { return PrintScaling; },
  get Duplex () { return Duplex; },
  PDFObject: PDFObject,
  PDFBool: PDFBool,
  PDFNumber: PDFNumber,
  PDFString: PDFString,
  PDFHexString: PDFHexString,
  PDFName: PDFName,
  PDFNull: PDFNull$1,
  PDFArray: PDFArray,
  PDFDict: PDFDict,
  PDFRef: PDFRef,
  PDFInvalidObject: PDFInvalidObject,
  PDFStream: PDFStream,
  PDFRawStream: PDFRawStream,
  PDFCatalog: PDFCatalog,
  PDFContentStream: PDFContentStream,
  PDFCrossRefStream: PDFCrossRefStream,
  PDFObjectStream: PDFObjectStream,
  PDFPageTree: PDFPageTree,
  PDFPageLeaf: PDFPageLeaf,
  PDFFlateStream: PDFFlateStream,
  PDFOperator: PDFOperator,
  PDFOperatorNames: Ops,
  PDFObjectParser: PDFObjectParser,
  PDFObjectStreamParser: PDFObjectStreamParser,
  PDFParser: PDFParser,
  PDFXRefStreamParser: PDFXRefStreamParser,
  decodePDFRawStream: decodePDFRawStream,
  MethodNotImplementedError: MethodNotImplementedError,
  PrivateConstructorError: PrivateConstructorError,
  UnexpectedObjectTypeError: UnexpectedObjectTypeError,
  UnsupportedEncodingError: UnsupportedEncodingError,
  ReparseError: ReparseError,
  MissingCatalogError: MissingCatalogError,
  MissingPageContentsEmbeddingError: MissingPageContentsEmbeddingError,
  UnrecognizedStreamTypeError: UnrecognizedStreamTypeError,
  PageEmbeddingMismatchedContextError: PageEmbeddingMismatchedContextError,
  PDFArrayIsNotRectangleError: PDFArrayIsNotRectangleError,
  InvalidPDFDateStringError: InvalidPDFDateStringError,
  InvalidTargetIndexError: InvalidTargetIndexError,
  CorruptPageTreeError: CorruptPageTreeError,
  IndexOutOfBoundsError: IndexOutOfBoundsError,
  InvalidAcroFieldValueError: InvalidAcroFieldValueError,
  MultiSelectValueError: MultiSelectValueError,
  MissingDAEntryError: MissingDAEntryError,
  MissingTfOperatorError: MissingTfOperatorError,
  NumberParsingError: NumberParsingError,
  PDFParsingError: PDFParsingError,
  NextByteAssertionError: NextByteAssertionError,
  PDFObjectParsingError: PDFObjectParsingError,
  PDFInvalidObjectParsingError: PDFInvalidObjectParsingError,
  PDFStreamParsingError: PDFStreamParsingError,
  UnbalancedParenthesisError: UnbalancedParenthesisError,
  StalledParserError: StalledParserError,
  MissingPDFHeaderError: MissingPDFHeaderError,
  MissingKeywordError: MissingKeywordError,
  PDFAnnotation: PDFAnnotation,
  PDFWidgetAnnotation: PDFWidgetAnnotation,
  AppearanceCharacteristics: AppearanceCharacteristics,
  get AnnotationFlags () { return AnnotationFlags; },
  PDFAcroButton: PDFAcroButton,
  PDFAcroCheckBox: PDFAcroCheckBox,
  PDFAcroChoice: PDFAcroChoice,
  PDFAcroComboBox: PDFAcroComboBox,
  PDFAcroField: PDFAcroField,
  PDFAcroForm: PDFAcroForm,
  PDFAcroListBox: PDFAcroListBox,
  PDFAcroNonTerminal: PDFAcroNonTerminal,
  PDFAcroPushButton: PDFAcroPushButton,
  PDFAcroRadioButton: PDFAcroRadioButton,
  PDFAcroSignature: PDFAcroSignature,
  PDFAcroTerminal: PDFAcroTerminal,
  PDFAcroText: PDFAcroText,
  get AcroFieldFlags () { return AcroFieldFlags; },
  get AcroButtonFlags () { return AcroButtonFlags; },
  get AcroTextFlags () { return AcroTextFlags; },
  get AcroChoiceFlags () { return AcroChoiceFlags; },
  createPDFAcroFields: createPDFAcroFields,
  createPDFAcroField: createPDFAcroField,
  Cache: Cache,
  last: last,
  typedArrayFor: typedArrayFor,
  mergeIntoTypedArray: mergeIntoTypedArray,
  mergeUint8Arrays: mergeUint8Arrays,
  arrayAsString: arrayAsString,
  byAscendingId: byAscendingId,
  sortedUniq: sortedUniq,
  reverseArray: reverseArray,
  sum: sum,
  range: range,
  pluckIndices: pluckIndices,
  canBeConvertedToUint8Array: canBeConvertedToUint8Array,
  toUint8Array: toUint8Array,
  waitForTick: waitForTick,
  toCharCode: toCharCode,
  toCodePoint: toCodePoint,
  toHexStringOfMinLength: toHexStringOfMinLength,
  toHexString: toHexString,
  charFromCode: charFromCode,
  charFromHexCode: charFromHexCode,
  padStart: padStart,
  copyStringIntoBuffer: copyStringIntoBuffer,
  addRandomSuffix: addRandomSuffix,
  escapeRegExp: escapeRegExp,
  cleanText: cleanText,
  escapedNewlineChars: escapedNewlineChars,
  newlineChars: newlineChars,
  isNewlineChar: isNewlineChar,
  lineSplit: lineSplit,
  mergeLines: mergeLines,
  charAtIndex: charAtIndex,
  charSplit: charSplit,
  breakTextIntoLines: breakTextIntoLines,
  parseDate: parseDate,
  findLastMatch: findLastMatch,
  utf8Encode: utf8Encode,
  utf16Encode: utf16Encode,
  isWithinBMP: isWithinBMP,
  hasSurrogates: hasSurrogates,
  highSurrogate: highSurrogate,
  lowSurrogate: lowSurrogate,
  utf16Decode: utf16Decode,
  hasUtf16BOM: hasUtf16BOM,
  numberToString: numberToString,
  sizeInBytes: sizeInBytes,
  bytesFor: bytesFor,
  error: error,
  encodeToBase64: encodeToBase64,
  decodeFromBase64: decodeFromBase64,
  decodeFromBase64DataUri: decodeFromBase64DataUri,
  values: values,
  StandardFontValues: StandardFontValues,
  isStandardFont: isStandardFont,
  rectanglesAreEqual: rectanglesAreEqual,
  backtick: backtick,
  singleQuote: singleQuote,
  createValueErrorMsg: createValueErrorMsg,
  assertIsOneOf: assertIsOneOf,
  assertIsOneOfOrUndefined: assertIsOneOfOrUndefined,
  assertIsSubset: assertIsSubset,
  getType: getType,
  isType: isType,
  createTypeErrorMsg: createTypeErrorMsg,
  assertIs: assertIs,
  assertOrUndefined: assertOrUndefined,
  assertEachIs: assertEachIs,
  assertRange: assertRange,
  assertRangeOrUndefined: assertRangeOrUndefined,
  assertMultiple: assertMultiple,
  assertInteger: assertInteger,
  assertPositive: assertPositive,
  pdfDocEncodingDecode: pdfDocEncodingDecode
};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var toString$4 = Object.prototype.toString;
function isArray$2(val) {
  return toString$4.call(val) === '[object Array]';
}
function isUndefined$2(val) {
  return typeof val === 'undefined';
}
function isBuffer$2(val) {
  return val !== null && !isUndefined$2(val) && val.constructor !== null && !isUndefined$2(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
function isArrayBuffer$2(val) {
  return toString$4.call(val) === '[object ArrayBuffer]';
}
function isFormData$2(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
function isArrayBufferView$2(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$2(val) {
  return typeof val === 'string';
}
function isNumber$2(val) {
  return typeof val === 'number';
}
function isObject$2(val) {
  return val !== null && typeof val === 'object';
}
function isPlainObject$2(val) {
  if (toString$4.call(val) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$3(val) {
  return toString$4.call(val) === '[object Date]';
}
function isFile$2(val) {
  return toString$4.call(val) === '[object File]';
}
function isBlob$2(val) {
  return toString$4.call(val) === '[object Blob]';
}
function isFunction$2(val) {
  return toString$4.call(val) === '[object Function]';
}
function isStream$2(val) {
  return isObject$2(val) && isFunction$2(val.pipe);
}
function isURLSearchParams$2(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
function trim$2(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
function isStandardBrowserEnv$1() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function forEach$2(obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  if (typeof obj !== 'object') {
    obj = [obj];
  }
  if (isArray$2(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$2() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$2(result[key]) && isPlainObject$2(val)) {
      result[key] = merge$2(result[key], val);
    } else if (isPlainObject$2(val)) {
      result[key] = merge$2({}, val);
    } else if (isArray$2(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$2(arguments[i], assignValue);
  }
  return result;
}
function extend$2(a, b, thisArg) {
  forEach$2(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$2(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM$2(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}
var utils$3 = {
  isArray: isArray$2,
  isArrayBuffer: isArrayBuffer$2,
  isBuffer: isBuffer$2,
  isFormData: isFormData$2,
  isArrayBufferView: isArrayBufferView$2,
  isString: isString$2,
  isNumber: isNumber$2,
  isObject: isObject$2,
  isPlainObject: isPlainObject$2,
  isUndefined: isUndefined$2,
  isDate: isDate$3,
  isFile: isFile$2,
  isBlob: isBlob$2,
  isFunction: isFunction$2,
  isStream: isStream$2,
  isURLSearchParams: isURLSearchParams$2,
  isStandardBrowserEnv: isStandardBrowserEnv$1,
  forEach: forEach$2,
  merge: merge$2,
  extend: extend$2,
  trim: trim$2,
  stripBOM: stripBOM$2
};

function encode$3(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$3.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$3.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils$3.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils$3.forEach(val, function parseValue(v) {
        if (utils$3.isDate(v)) {
          v = v.toISOString();
        } else if (utils$3.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$3(key) + '=' + encode$3(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

function InterceptorManager$2() {
  this.handlers = [];
}
InterceptorManager$2.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
InterceptorManager$2.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$2.prototype.forEach = function forEach(fn) {
  utils$3.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1$1 = InterceptorManager$2;

var transformData$2 = function transformData(data, headers, fns) {
  utils$3.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel$2 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$3.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var enhanceError$1 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError$1 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request, response);
};

var settle$2 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies$2 = utils$3.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils$3.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils$3.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils$3.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

var isAbsoluteURL$2 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

var combineURLs$2 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL$2(requestedURL)) {
    return combineURLs$2(baseURL, requestedURL);
  }
  return requestedURL;
};

var ignoreDuplicateOf$2 = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
var parseHeaders$2 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$3.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$3.trim(line.substr(0, i)).toLowerCase();
    val = utils$3.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf$2.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin$2 = utils$3.isStandardBrowserEnv() ? function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin(requestURL) {
    var parsed = utils$3.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr$1 = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils$3.isFormData(requestData)) {
      delete requestHeaders['Content-Type'];
    }
    var request = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    var fullPath = buildFullPath$2(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$2(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders$2(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle$2(resolve, reject, response);
      request = null;
    };
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(createError$1('Request aborted', config, 'ECONNABORTED', request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(createError$1('Network Error', config, null, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError$1(timeoutErrorMessage, config, 'ECONNABORTED', request));
      request = null;
    };
    if (utils$3.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$2(fullPath)) && config.xsrfCookieName ? cookies$2.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ('setRequestHeader' in request) {
      utils$3.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          delete requestHeaders[key];
        } else {
          request.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$3.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        request = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE$1 = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset$1(headers, value) {
  if (!utils$3.isUndefined(headers) && utils$3.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter$1() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    adapter = xhr$1;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    adapter = xhr$1;
  }
  return adapter;
}
var defaults$2 = {
  adapter: getDefaultAdapter$1(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName$1(headers, 'Accept');
    normalizeHeaderName$1(headers, 'Content-Type');
    if (utils$3.isFormData(data) || utils$3.isArrayBuffer(data) || utils$3.isBuffer(data) || utils$3.isStream(data) || utils$3.isFile(data) || utils$3.isBlob(data)) {
      return data;
    }
    if (utils$3.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$3.isURLSearchParams(data)) {
      setContentTypeIfUnset$1(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$3.isObject(data)) {
      setContentTypeIfUnset$1(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults$2.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils$3.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$2.headers[method] = {};
});
utils$3.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$2.headers[method] = utils$3.merge(DEFAULT_CONTENT_TYPE$1);
});
var defaults_1$1 = defaults$2;

function throwIfCancellationRequested$2(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
var dispatchRequest$2 = function dispatchRequest(config) {
  throwIfCancellationRequested$2(config);
  config.headers = config.headers || {};
  config.data = transformData$2(config.data, config.headers, config.transformRequest);
  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested$2(config);
    response.data = transformData$2(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$2(reason)) {
      throwIfCancellationRequested$2(config);
      if (reason && reason.response) {
        reason.response.data = transformData$2(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];
  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }
  utils$3.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils$3.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$3.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils$3.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$3.forEach(otherKeys, mergeDeepProperties);
  return config;
};

function Axios$2(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1$1(),
    response: new InterceptorManager_1$1()
  };
}
Axios$2.prototype.request = function request(config) {
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$2(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }
  var chain = [dispatchRequest$2, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};
Axios$2.prototype.getUri = function getUri(config) {
  config = mergeConfig$2(this.defaults, config);
  return buildURL$2(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
utils$3.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  Axios$2.prototype[method] = function (url, config) {
    return this.request(mergeConfig$2(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$3.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  Axios$2.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig$2(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1$1 = Axios$2;

function Cancel$1(message) {
  this.message = message;
}
Cancel$1.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel$1.prototype.__CANCEL__ = true;
var Cancel_1$1 = Cancel$1;

function CancelToken$2(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel_1$1(message);
    resolvePromise(token.reason);
  });
}
CancelToken$2.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken$2.source = function source() {
  var cancel;
  var token = new CancelToken$2(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
var CancelToken_1$1 = CancelToken$2;

var spread$2 = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var isAxiosError$2 = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

function createInstance$2(defaultConfig) {
  var context = new Axios_1$1(defaultConfig);
  var instance = bind$2(Axios_1$1.prototype.request, context);
  utils$3.extend(instance, Axios_1$1.prototype, context);
  utils$3.extend(instance, context);
  return instance;
}
var axios$4 = createInstance$2(defaults_1$1);
axios$4.Axios = Axios_1$1;
axios$4.create = function create(instanceConfig) {
  return createInstance$2(mergeConfig$2(axios$4.defaults, instanceConfig));
};
axios$4.Cancel = Cancel_1$1;
axios$4.CancelToken = CancelToken_1$1;
axios$4.isCancel = isCancel$2;
axios$4.all = function all(promises) {
  return Promise.all(promises);
};
axios$4.spread = spread$2;
axios$4.isAxiosError = isAxiosError$2;
var axios_1$1 = axios$4;
var _default$1 = axios$4;
axios_1$1.default = _default$1;

var axios$5 = axios_1$1;

const PdfViewerModal = ({
  open,
  onClose,
  pdfUrl,
  onSave,
  documentIndex,
  fileStoreId: _fileStoreId = null
}) => {
  const [tool, setTool] = useState("select");
  const [drawing, setDrawing] = useState(false);
  const [textMode, setTextMode] = useState(false);
  const [textInput, setTextInput] = useState("");
  const [textPosition, setTextPosition] = useState({
    x: 0,
    y: 0
  });
  const [annotations, setAnnotations] = useState([]);
  const [history, setHistory] = useState([]);
  const [redoHistory, setRedoHistory] = useState([]);
  const [scale, setScale] = useState(1);
  const [offset, setOffset] = useState({
    x: 0,
    y: 0
  });
  const [saveStatus, setSaveStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const [savedPdfData, setSavedPdfData] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const canvasRef = useRef(null);
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const startPosRef = useRef({
    x: 0,
    y: 0
  });
  const pdfContainerRef = useRef(null);
  const pdfDocRef = useRef(null);
  const pageOffsetsRef = useRef([]);
  const dialogPaperRef = useRef(null);
  const [pdfLib, setPdfLib] = useState(PDFLib);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  pdfUrl = _fileStoreId ? `/filestore/v1/files/viewedcr?tenantId=up&fileStoreId=${_fileStoreId}` : pdfUrl;
  console.log("I am here asa", pdfUrl, documentIndex);
  const [pdfjs, setPdfjs] = useState(null);
  useEffect(() => {
    if (window.pdfjsLib) {
      setPdfjs(window.pdfjsLib);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
    script.onload = () => {
      console.log("PDFJS Loaded", window.pdfjsLib);
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
      setPdfjs(window.pdfjsLib);
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const showMessage = (message, severity = "success") => {
    setSaveStatus({
      open: true,
      message,
      severity
    });
  };
  const renderPdf = async (currentZoom = zoomLevel) => {
    setIsLoading(true);
    try {
      if (!pdfContainerRef.current || !pdfjs) return;
      pdfContainerRef.current.innerHTML = "";
      const relativeUrl = _fileStoreId ? pdfUrl : pdfUrl.replace(/^https?:\/\/[^/]+/, "");
      const response = await axios$5.get(relativeUrl, {
        responseType: "arraybuffer"
      });
      const pdfBytes = response.data;
      const loadingTask = pdfjs.getDocument({
        data: pdfBytes
      });
      const pdf = await loadingTask.promise;
      const containerWidth = pdfContainerRef.current.clientWidth || 800;
      const dpr = window.devicePixelRatio || 1;
      let runningTop = 0;
      const offsets = [];
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const baseViewport = page.getViewport({
          scale: 1
        });
        const fitScale = (containerWidth - 40) / baseViewport.width;
        const finalScale = fitScale * currentZoom;
        const viewport = page.getViewport({
          scale: finalScale
        });
        const pageWrapper = document.createElement("div");
        pageWrapper.style.position = "relative";
        pageWrapper.style.marginBottom = "20px";
        pageWrapper.style.boxShadow = "0 2px 10px rgba(0,0,0,.2)";
        pageWrapper.style.background = "#fff";
        const pdfCanvas = document.createElement("canvas");
        pdfCanvas.width = viewport.width * dpr;
        pdfCanvas.height = viewport.height * dpr;
        pdfCanvas.style.width = `${viewport.width}px`;
        pdfCanvas.style.height = `${viewport.height}px`;
        pdfCanvas.style.display = "block";
        const ctx = pdfCanvas.getContext("2d");
        ctx.scale(dpr, dpr);
        await page.render({
          canvasContext: ctx,
          viewport
        }).promise;
        pageWrapper.appendChild(pdfCanvas);
        pdfContainerRef.current.appendChild(pageWrapper);
        const canvasBox = pdfCanvas.getBoundingClientRect();
        const originBox = containerRef.current.getBoundingClientRect();
        offsets.push({
          pageNum,
          top: canvasBox.top - originBox.top,
          left: canvasBox.left - originBox.left,
          height: viewport.height,
          width: viewport.width,
          renderScale: finalScale
        });
      }
      pageOffsetsRef.current = offsets;
      if (canvasRef.current && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        canvasRef.current.width = rect.width;
        canvasRef.current.height = rect.height;
      }
      drawAnnotations();
    } catch (err) {
      console.error(err);
      showMessage("Failed to render PDF: " + err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseMessage = () => {
    setSaveStatus({
      ...saveStatus,
      open: false
    });
  };
  const handleToolChange = (event, newTool) => {
    if (newTool !== null) {
      setTool(newTool);
      setTextMode(newTool === "text");
    }
  };
  const getPDFCoordinates = useCallback((clientX, clientY) => {
    if (!canvasRef.current || !containerRef.current) return {
      x: 0,
      y: 0
    };
    const canvas = canvasRef.current;
    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();
    const canvasRect = canvas.getBoundingClientRect();
    const x = clientX - canvasRect.left;
    const y = clientY - canvasRect.top;
    const scaledX = (x - offset.x) / scale;
    const scaledY = (y - offset.y) / scale;
    return {
      x: scaledX,
      y: scaledY
    };
  }, [scale, offset]);
  const handleMouseDown = useCallback(e => {
    if (!canvasRef.current) return;
    const {
      x,
      y
    } = getPDFCoordinates(e.clientX, e.clientY);
    startPosRef.current = {
      x,
      y
    };
    console.log("Mouse down at coordinates:", {
      x,
      y
    });
    if (tool === "pencil") {
      setDrawing(true);
      const newAnnotation = {
        type: "path",
        points: [{
          x,
          y
        }],
        color: "#ff0000",
        width: 2
      };
      console.log("Creating new path annotation:", newAnnotation);
      setAnnotations(prev => [...prev, newAnnotation]);
    } else if (tool === "text") {
      setTextPosition({
        x,
        y
      });
    }
  }, [tool, getPDFCoordinates]);
  const handleTextAdd = () => {
    if (!textInput.trim()) return;
    const newTextAnnotation = {
      type: "text",
      text: textInput,
      x: textPosition.x,
      y: textPosition.y,
      color: "#000000",
      fontSize: 16
    };
    setAnnotations(prev => [...prev, newTextAnnotation]);
    setHistory(prev => [...prev, [...annotations]]);
    setRedoHistory([]);
    setTextInput("");
    setTextMode(false);
    setTool("select");
  };
  const handleMouseMove = useCallback(e => {
    if (!drawing || !canvasRef.current) return;
    const {
      x,
      y
    } = getPDFCoordinates(e.clientX, e.clientY);
    setAnnotations(prev => {
      const lastAnnotation = prev[prev.length - 1];
      if (lastAnnotation && lastAnnotation.type === "path") {
        const updatedAnnotation = {
          ...lastAnnotation,
          points: [...lastAnnotation.points, {
            x,
            y
          }]
        };
        console.log("Updating path annotation with new point:", {
          x,
          y
        });
        return [...prev.slice(0, -1), updatedAnnotation];
      }
      return prev;
    });
  }, [drawing, getPDFCoordinates]);
  const handleMouseUp = useCallback(() => {
    setDrawing(false);
    setHistory(prev => [...prev, [...annotations]]);
    setRedoHistory([]);
  }, [annotations]);
  const handleUndo = () => {
    if (history.length > 0) {
      const previousState = history[history.length - 1];
      setRedoHistory(prev => [...prev, [...annotations]]);
      setAnnotations(previousState);
      setHistory(prev => prev.slice(0, -1));
    }
  };
  const handleRedo = () => {
    if (redoHistory.length > 0) {
      const nextState = redoHistory[redoHistory.length - 1];
      setHistory(prev => [...prev, [...annotations]]);
      setAnnotations(nextState);
      setRedoHistory(prev => prev.slice(0, -1));
    }
  };
  const handleClear = () => {
    setHistory(prev => [...prev, annotations]);
    setRedoHistory([]);
    setAnnotations([]);
  };
  const handleFitToScreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await dialogPaperRef.current.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };
  const exportAnnotatedPdf = async () => {
    console.log("exportAnnotatedPdf STARTED - relativeUrl version");
    try {
      if (!pdfLib) {
        throw new Error("PDF library not loaded");
      }
      if (!annotations || annotations.length === 0) {
        showMessage("No changes to save", "info");
        return null;
      }
      const relativeUrl = _fileStoreId ? pdfUrl : pdfUrl.replace(/^https?:\/\/[^/]+/, "");
      console.log("RELATIVE URL", relativeUrl);
      const response = await axios$5.get(relativeUrl, {
        responseType: "arraybuffer"
      });
      const pdfBytes = response.data;
      if (!pdfBytes || pdfBytes.byteLength === 0) {
        throw new Error("Invalid PDF data received");
      }
      const pdfDoc = await pdfLib.PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      if (pages.length === 0) {
        throw new Error("PDF has no pages");
      }
      const offsets = pageOffsetsRef.current;
      const resolvePage = y => {
        for (const entry of offsets) {
          if (y >= entry.top && y < entry.top + entry.height) {
            return {
              ...entry,
              localY: y - entry.top
            };
          }
        }
        return null;
      };
      const toCanvasSpace = pt => ({
        x: pt.x * scale + offset.x,
        y: pt.y * scale + offset.y
      });
      annotations.forEach(annotation => {
        if (annotation.type === "path" && annotation.points && annotation.points.length > 1) {
          for (let i = 0; i < annotation.points.length - 1; i++) {
            const startPoint = toCanvasSpace(annotation.points[i]);
            const endPoint = toCanvasSpace(annotation.points[i + 1]);
            if (!startPoint || !endPoint) continue;
            const startInfo = resolvePage(startPoint.y);
            const endInfo = resolvePage(endPoint.y);
            if (!startInfo || !endInfo || startInfo.pageNum !== endInfo.pageNum) continue;
            const pdfPage = pages[startInfo.pageNum - 1];
            const {
              width,
              height
            } = pdfPage.getSize();
            const scaleX = width / startInfo.width;
            const scaleY = height / startInfo.height;
            const pdfStartX = (startPoint.x - startInfo.left) * scaleX;
            const pdfStartY = height - startInfo.localY * scaleY;
            const pdfEndX = (endPoint.x - endInfo.left) * scaleX;
            const pdfEndY = height - endInfo.localY * scaleY;
            pdfPage.drawLine({
              start: {
                x: Math.max(0, Math.min(pdfStartX, width)),
                y: Math.max(0, Math.min(pdfStartY, height))
              },
              end: {
                x: Math.max(0, Math.min(pdfEndX, width)),
                y: Math.max(0, Math.min(pdfEndY, height))
              },
              color: pdfLib.rgb(parseInt(annotation.color.slice(1, 3), 16) / 255, parseInt(annotation.color.slice(3, 5), 16) / 255, parseInt(annotation.color.slice(5, 7), 16) / 255),
              thickness: annotation.width || 2
            });
          }
        } else if (annotation.type === "text" && annotation.text) {
          const rawPos = toCanvasSpace({
            x: annotation.x,
            y: annotation.y
          });
          const info = resolvePage(rawPos.y);
          if (!info) return;
          const pdfPage = pages[info.pageNum - 1];
          const {
            width,
            height
          } = pdfPage.getSize();
          const scaleX = width / info.width;
          const scaleY = height / info.height;
          const pdfX = (rawPos.x - info.left) * scaleX;
          const pdfY = height - info.localY * scaleY;
          pdfPage.drawText(annotation.text, {
            x: Math.max(0, Math.min(pdfX, width)),
            y: Math.max(0, Math.min(pdfY, height)),
            color: pdfLib.rgb(parseInt(annotation.color.slice(1, 3), 16) / 255, parseInt(annotation.color.slice(3, 5), 16) / 255, parseInt(annotation.color.slice(5, 7), 16) / 255),
            size: annotation.fontSize || 16
          });
        }
      });
      const modifiedPdfBytes = await pdfDoc.save({
        useObjectStreams: false,
        addDefaultPage: false,
        objectsPerTick: 50
      });
      if (!modifiedPdfBytes || modifiedPdfBytes.byteLength === 0) {
        throw new Error("Failed to generate PDF bytes");
      }
      return new Blob([modifiedPdfBytes], {
        type: "application/pdf"
      });
    } catch (error) {
      console.error("Error exporting with PDF-LIB:", error);
      showMessage("Error creating PDF.", "warning");
      throw error;
    }
  };
  const handleSave = async () => {
    try {
      setIsLoading(true);
      console.log("Saving annotations:", annotations);
      const editedFile = await exportAnnotatedPdf();
      if (!editedFile) {
        showMessage("No changes to save", "info");
        return;
      }
      if (!editedFile || editedFile.size === 0) {
        throw new Error("Generated PDF file is empty or invalid");
      }
      console.log("PDF file details:", {
        size: editedFile.size,
        type: editedFile.type,
        name: "document.pdf"
      });
      const formData = new FormData();
      const fileName = `document_${Date.now()}.pdf`;
      formData.append("file", editedFile, fileName);
      formData.append("tenantId", "up");
      formData.append("module", "property-upload");
      formData.append("tag", "tag-property");
      console.log("FormData contents:", {
        fileName: fileName,
        fileSize: editedFile.size,
        fileType: editedFile.type
      });
      const response = await axios$5.post("/filestore/v1/files", formData, {});
      console.log("Upload successful:", response.data);
      let fileStoreId = null;
      const responseData = response.data;
      if (responseData.files && Array.isArray(responseData.files) && responseData.files.length > 0) {
        fileStoreId = responseData.files[0].fileStoreId;
      } else if (responseData.fileStoreId) {
        fileStoreId = responseData.fileStoreId;
      } else if (responseData.response && responseData.response.files) {
        var _responseData$respons2;
        fileStoreId = (_responseData$respons2 = responseData.response.files[0]) === null || _responseData$respons2 === void 0 ? void 0 : _responseData$respons2.fileStoreId;
      }
      if (fileStoreId) {
        if (onSave) {
          onSave(fileStoreId, documentIndex);
        }
        showMessage("PDF saved successfully!", "success");
        setTimeout(() => {
          onClose();
          setIsLoading(false);
        }, 1500);
      } else {
        console.error("Could not extract fileStoreId from response:", responseData);
        throw new Error("No fileStoreId found in server response");
      }
    } catch (error) {
      var _error$response, _error$response$data;
      console.error("Upload error:", error);
      showMessage("Error saving PDF: " + (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || error.message), "error");
    }
  };
  const drawAnnotations = useCallback(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    annotations.forEach(annotation => {
      if (annotation.type === "path") {
        ctx.beginPath();
        ctx.strokeStyle = annotation.color;
        ctx.lineWidth = annotation.width;
        annotation.points.forEach((point, i) => {
          const scaledX = point.x * scale + offset.x;
          const scaledY = point.y * scale + offset.y;
          if (i === 0) {
            ctx.moveTo(scaledX, scaledY);
          } else {
            ctx.lineTo(scaledX, scaledY);
          }
        });
        ctx.stroke();
      } else if (annotation.type === "text") {
        ctx.font = `${annotation.fontSize}px Arial`;
        ctx.fillStyle = annotation.color;
        const scaledX = annotation.x * scale + offset.x;
        const scaledY = annotation.y * scale + offset.y;
        ctx.fillText(annotation.text, scaledX, scaledY);
      }
    });
  }, [annotations, scale, offset]);
  useEffect(() => {
    if (containerRef.current && canvasRef.current) {
      const container = containerRef.current;
      const canvas = canvasRef.current;
      const resizeCanvas = () => {
        const rect = container.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
        drawAnnotations();
      };
      resizeCanvas();
      const resizeObserver = new ResizeObserver(resizeCanvas);
      resizeObserver.observe(container);
      return () => resizeObserver.disconnect();
    }
  }, [drawAnnotations]);
  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreen = !!document.fullscreenElement;
      setIsFullscreen(fullscreen);
      setTimeout(() => {
        renderPdf(zoomLevel);
      }, 200);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [zoomLevel]);
  const handleIframeLoad = useCallback(() => {
    if (iframeRef.current && iframeRef.current.contentDocument) {
      const iframeDoc = iframeRef.current.contentDocument;
      const pdfContainer = iframeDoc.querySelector(".pdfViewer") || iframeDoc.body;
      if (pdfContainer) {
        const pdfWidth = pdfContainer.scrollWidth;
        const pdfHeight = pdfContainer.scrollHeight;
        const container = containerRef.current;
        if (container) {
          const scaleX = container.clientWidth / pdfWidth;
          const scaleY = container.clientHeight / pdfHeight;
          const newScale = Math.min(scaleX, scaleY, 1);
          setScale(newScale);
          setOffset({
            x: (container.clientWidth - pdfWidth * newScale) / 2,
            y: (container.clientHeight - pdfHeight * newScale) / 2
          });
        }
      }
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: false,
    fullWidth: true,
    PaperProps: {
      ref: dialogPaperRef
    },
    TransitionProps: {
      onEntered: () => {
        console.log("Dialog entered");
        if (pdfjs && pdfUrl && pdfContainerRef.current) {
          renderPdf();
        }
      }
    },
    sx: {
      "& .MuiDialog-paper": {
        width: "95vw",
        height: "95vh",
        maxWidth: "95vw",
        margin: 0,
        borderRadius: "8px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogContent$1, {
    sx: {
      p: 1,
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(ToggleButtonGroup, {
    value: tool,
    exclusive: true,
    onChange: handleToolChange,
    "aria-label": "tool selection",
    size: "small"
  }, /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: "select",
    "aria-label": "select"
  }, /*#__PURE__*/React__default.createElement(FaTimes, null)), /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: "pencil",
    "aria-label": "pencil"
  }, /*#__PURE__*/React__default.createElement(FaPencilAlt, null)), /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: "text",
    "aria-label": "text"
  }, /*#__PURE__*/React__default.createElement(FaFont, null)), /*#__PURE__*/React__default.createElement(ToggleButton, {
    value: "eraser",
    "aria-label": "eraser",
    onClick: handleClear
  }, /*#__PURE__*/React__default.createElement(FaEraser, null))), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleUndo,
    disabled: history.length === 0
  }, /*#__PURE__*/React__default.createElement(FaUndo, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleRedo,
    disabled: redoHistory.length === 0
  }, /*#__PURE__*/React__default.createElement(FaRedo, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleSave,
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(FaSave, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleFitToScreen,
    title: "Fit to screen"
  }, "\uD83D\uDDA5\uFE0F"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(FaTimes, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "iframe-container",
    ref: containerRef,
    style: {
      position: "relative",
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: pdfContainerRef,
    style: {
      flex: 1,
      overflow: "auto",
      background: "#808080",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px"
    }
  }), /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRef,
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      pointerEvents: tool === "select" ? "none" : "auto",
      cursor: tool === "pencil" ? "crosshair" : "default"
    },
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseUp
  }), isLoading && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255,255,255,0.6)",
      zIndex: 10
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, null))), textMode && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: 2,
      borderTop: "1px solid #ccc"
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    value: textInput,
    onChange: e => setTextInput(e.target.value),
    placeholder: "Enter text to add",
    style: {
      marginRight: "8px",
      padding: "4px"
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "small",
    onClick: handleTextAdd,
    disabled: !textInput.trim()
  }, "Add Text"), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "outlined",
    size: "small",
    onClick: () => {
      setTextMode(false);
      setTool("select");
    },
    style: {
      marginLeft: "8px"
    }
  }, "Cancel")), /*#__PURE__*/React__default.createElement(Snackbar, {
    open: saveStatus.open,
    autoHideDuration: 6000,
    onClose: handleCloseMessage,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Alert, {
    onClose: handleCloseMessage,
    severity: saveStatus.severity,
    sx: {
      width: "100%"
    }
  }, saveStatus.message))));
};

const Step4 = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule,
  onSelect
}) => {
  var _formData$mapSubDetai, _formData$documents, _formData$documents$f, _formData$documents2, _formData$documents2$, _formData$documents3, _formData$documents4;
  console.log("formDataInStep4", formData, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction, formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.viewEditPdf);
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const scrutinyFlow = (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const docPdf = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.find(doc => doc.documentType === "drawingPdf")) === null || _formData$documents$f === void 0 ? void 0 : _formData$documents$f.fileStoreId;
  const docDxf = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.find(doc => doc.documentType === "dxfDrawing")) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.fileStoreId;
  const docPdfUrl = docPdf ? `/filestore/v1/files/id?fileStoreId=${docPdf}&tenantId=${tenantId}` : null;
  const docDxfUrl = docDxf ? `/filestore/v1/files/id?fileStoreId=${docDxf}&tenantId=${tenantId}` : null;
  const normalizeRow = useCallback((row, extraEdcr = null) => {
    var _formData$mapSubDetai2, _formData$auditDetail, _formData$auditDetail2;
    const drawingPdf = (row === null || row === void 0 ? void 0 : row.viewPdf) || (row === null || row === void 0 ? void 0 : row.updatedDxfFile) || (row === null || row === void 0 ? void 0 : row.drawingPdf) || (row === null || row === void 0 ? void 0 : row.selfDrawingPdfUrl) || (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) || docPdfUrl || (extraEdcr === null || extraEdcr === void 0 ? void 0 : extraEdcr.updatedDxfFile);
    const planReport = (row === null || row === void 0 ? void 0 : row.planReport) || (row === null || row === void 0 ? void 0 : row.viewPlanReport) || (formData === null || formData === void 0 ? void 0 : formData.planReport) || (extraEdcr === null || extraEdcr === void 0 ? void 0 : extraEdcr.planReport);
    const dxfFile = (row === null || row === void 0 ? void 0 : row.dxfFile) || (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || docDxfUrl || (extraEdcr === null || extraEdcr === void 0 ? void 0 : extraEdcr.dxfFile);
    const signedPdfUrl = (row === null || row === void 0 ? void 0 : row.signedPdfUrl) || (formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || (typeof (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === "string" ? formData.IsSignedDrawingPdfURL : "");
    const signedPdfId = (row === null || row === void 0 ? void 0 : row.signedPdfId) || (formData === null || formData === void 0 ? void 0 : formData.signedPdfId);
    const viewEditPdfUrl = (row === null || row === void 0 ? void 0 : row.viewEditPdfUrl) || (formData === null || formData === void 0 ? void 0 : formData.editPdfViaPdfUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.viewEditPdf);
    return {
      ...row,
      viewPdf: drawingPdf,
      updatedDxfFile: drawingPdf,
      drawingPdf: drawingPdf,
      planReport: planReport,
      viewPlanReport: planReport,
      dxfFile: dxfFile,
      signedPdfUrl: signedPdfUrl,
      signedPdfId: signedPdfId,
      viewEditPdfUrl: viewEditPdfUrl,
      status: (row === null || row === void 0 ? void 0 : row.status) || (formData === null || formData === void 0 ? void 0 : formData.status),
      submittedOn: (row === null || row === void 0 ? void 0 : row.submittedOn) || (formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.lastModifiedTime) || (formData === null || formData === void 0 ? void 0 : (_formData$auditDetail2 = formData.auditDetails) === null || _formData$auditDetail2 === void 0 ? void 0 : _formData$auditDetail2.createdTime)
    };
  }, [formData, docPdfUrl, docDxfUrl]);
  const buildFallbackRow = useCallback((data, extraEdcr = null) => {
    var _data$drawingDetail;
    const norm = normalizeRow((data === null || data === void 0 ? void 0 : (_data$drawingDetail = data.drawingDetail) === null || _data$drawingDetail === void 0 ? void 0 : _data$drawingDetail[0]) || {}, extraEdcr);
    if (norm.viewPdf || norm.planReport || norm.dxfFile || data !== null && data !== void 0 && data.edcrNumber) {
      return [norm];
    }
    return [];
  }, [normalizeRow]);
  const [drawingDetail, setDrawingDetail] = useState(formData !== null && formData !== void 0 && formData.drawingDetail && formData.drawingDetail.length > 0 ? formData.drawingDetail.map(r => normalizeRow(r)) : buildFallbackRow(formData));
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.drawingDetail && formData.drawingDetail.length > 0) {
      setDrawingDetail(formData.drawingDetail.map(r => normalizeRow(r)));
    } else {
      const fallback = buildFallbackRow(formData);
      if (fallback.length > 0) {
        setDrawingDetail(fallback);
      }
    }
  }, [formData, normalizeRow, buildFallbackRow]);
  const fetchedEdcrRef = useRef(false);
  useEffect(() => {
    const fetchEdcrDetails = async () => {
      const num = formData === null || formData === void 0 ? void 0 : formData.edcrNumber;
      if (!num || fetchedEdcrRef.current) return;
      const firstRow = drawingDetail === null || drawingDetail === void 0 ? void 0 : drawingDetail[0];
      if (!(firstRow !== null && firstRow !== void 0 && firstRow.viewPdf) || !(firstRow !== null && firstRow !== void 0 && firstRow.planReport) || !(firstRow !== null && firstRow !== void 0 && firstRow.dxfFile)) {
        try {
          var _res$edcrDetail;
          fetchedEdcrRef.current = true;
          const res = await Digit.OBPSService.scrutinyDetails(tenantId, {
            edcrNumber: num
          });
          if (res !== null && res !== void 0 && (_res$edcrDetail = res.edcrDetail) !== null && _res$edcrDetail !== void 0 && _res$edcrDetail[0]) {
            const edcr = res.edcrDetail[0];
            setDrawingDetail(prev => {
              if (prev && prev.length > 0) {
                return prev.map(r => normalizeRow(r, edcr));
              }
              return [normalizeRow({}, edcr)];
            });
          }
        } catch (err) {
          console.error("Error fetching EDCR details in Step4:", err);
        }
      }
    };
    fetchEdcrDetails();
  }, [formData === null || formData === void 0 ? void 0 : formData.edcrNumber, normalizeRow, tenantId]);
  const drawingPdfflow = (formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : _formData$documents3.filter(e => e.documentType === "drawingPdf")) || [];
  const scrutinydxf = (formData === null || formData === void 0 ? void 0 : (_formData$documents4 = formData.documents) === null || _formData$documents4 === void 0 ? void 0 : _formData$documents4.filter(e => e.documentType === "dxfDrawing")) || [];
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [currFileStoreId, setCurrFileStoreId] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const [editedPdfUrl, setEditedPdfUrl] = useState("");
  const formRef = useRef(null);
  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const validatePdfUrl = url => {
    try {
      if (!url || typeof url !== "string") return false;
      if (url.startsWith("/")) return true;
      const urlObj = new URL(url);
      console.log("PDF URL validation:", {
        protocol: urlObj.protocol,
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        search: urlObj.search,
        isValid: true
      });
      return true;
    } catch (error) {
      console.error("Invalid PDF URL:", url, error);
      return false;
    }
  };
  console.log(drawingPdfflow, "pdfFlowwwww");
  const handleOpenPdf = async (url, index = null) => {
    var _drawingPdfflow$;
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    if (!validatePdfUrl(url)) {
      showMessage("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrFileStoreId(drawingPdfflow === null || drawingPdfflow === void 0 ? void 0 : (_drawingPdfflow$ = drawingPdfflow[0]) === null || _drawingPdfflow$ === void 0 ? void 0 : _drawingPdfflow$.fileStoreId);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };
  console.log("EditedPDFURL", editedPdfUrl);
  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: ""
      };
      const appData = {
        ...formData,
        workflow,
        mapSubDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
          viewEditPdf: fileStoreId
        }
      };
      updateApiCall.mutate({
        BPA: appData
      }, {
        onSuccess: result => {
          var _result$BPA;
          console.log("resultFromUpdate", result);
          onSelect("", result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: "submissionIndex"
  }, {
    id: "viewPdf",
    label: "View Pdf",
    accessor: "viewPdf"
  }, {
    id: "viewPlanReport",
    label: "Plan Report",
    accessor: "viewPlanReport"
  }, {
    id: "dxfFile",
    label: "DXF File",
    accessor: "dxfFile"
  }, ...(isEmployee ? [{
    id: "viewEditPdfUrl",
    label: "View Edited Pdf",
    accessor: "viewEditPdfUrl"
  }] : []), {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const pdfcolumns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: "submissionIndex"
  }, {
    id: "drawingPdf",
    label: "Drawing Pdf",
    accessor: "drawingPdf"
  }, {
    id: "dxfFile",
    label: "DXF File",
    accessor: "dxfFile"
  }, ...(isEmployee ? [{
    id: "viewEditPdf",
    label: "View Edited Pdf",
    accessor: "viewEditPdf"
  }] : []), {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const isEdcr = !scrutinyFlow || (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "EDCR" || Boolean(formData === null || formData === void 0 ? void 0 : formData.edcrNumber);
      let pdfType = "";
      if (isEmployee) {
        pdfType = isEdcr ? "SD" : "DIA";
      } else {
        pdfType = isEdcr ? "D" : "DI";
      }
      const SignRequest = {
        applicationNo: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber),
        pdfType: pdfType
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
      setLoading(false);
    }
  };
  const viewEdittedPdf = (url, index) => {
    let newUrl = url;
    console.log("newURL123", url, editedPdfUrl);
    if (editedPdfUrl !== "") {
      newUrl = editedPdfUrl;
    }
    window.open(newUrl, "_blank");
  };
  const viewPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, scrutinyFlow ? t("Pdf Document") : t("Drawing")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details  table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, !scrutinyFlow ? columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)) : pdfcolumns === null || pdfcolumns === void 0 ? void 0 : pdfcolumns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, !scrutinyFlow ? drawingDetail.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, columns.map(column => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, "Uploaded Drawing PDF ", index + 1);
    }
    const value = row[column.accessor];
    if (column.accessor === "submittedOn") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? new Date(value).toLocaleString() : "N/A");
    }
    if (column.accessor === "updatedDxfFile" || column.accessor === "planReport" || column.accessor === "viewPdf" || column.accessor === "viewPlanReport") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => handleOpenPdf(value, index)
      }) : "N/A");
    }
    if (column.accessor === "viewPdf") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#157CB3",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => viewPdf(value)
      }) : "N/A");
    }
    if (column.accessor === "viewEditPdfUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#157CB3",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => viewEdittedPdf(value)
      }) : "N/A");
    }
    if (column.accessor === "dxfFile") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement("a", {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          display: "inline-block"
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        src: "https://i.imgur.com/GDoAGny.png",
        style: {
          width: "20px",
          height: "30px",
          cursor: "pointer"
        },
        alt: "DXF File"
      })) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      const lastDetail = drawingDetail === null || drawingDetail === void 0 ? void 0 : drawingDetail[drawingDetail.length - 1];
      const signedPdfUrl = lastDetail === null || lastDetail === void 0 ? void 0 : lastDetail.signedPdfUrl;
      const signedPdfId = lastDetail === null || lastDetail === void 0 ? void 0 : lastDetail.signedPdfId;
      const signedFileUrl = signedPdfUrl || (signedPdfId ? `/filestore/v1/files/id?fileStoreId=${signedPdfId}&tenantId=${tenantId}` : null);
      const isAlreadySigned = signedPdfId != null;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, isAlreadySigned && signedFileUrl ?
      /*#__PURE__*/
      React__default.createElement(FaFilePdf, {
        color: "#24b155",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(signedFileUrl, "_blank"),
        title: "View Signed PDF"
      }) : !isEmployee ?
      /*#__PURE__*/
      React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          opacity: 1
        },
        type: "button",
        onClick: handleSign,
        disabled: isEmployee
      }, "Attach Digital Sign") : "N/A");
    }
    return /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id
    }, value || "N/A");
  }))) :
  /*#__PURE__*/
  React__default.createElement(TableRow$1, {
    key: 1
  }, pdfcolumns.map((column, index) => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: index
      }, "Upload Drawing PDF ", index + 1);
    }
    if (column.accessor === "dxfFile") {
      var _scrutinydxf$;
      const dxfStoreId = scrutinydxf === null || scrutinydxf === void 0 ? void 0 : (_scrutinydxf$ = scrutinydxf[0]) === null || _scrutinydxf$ === void 0 ? void 0 : _scrutinydxf$.fileStoreId;
      const dxfDirectUrl = (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || docDxfUrl;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, dxfStoreId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => getDocumentByFileStoreId(dxfStoreId, setIsPreviewLoading),
        title: "View File"
      }) : dxfDirectUrl ? /*#__PURE__*/React__default.createElement("img", {
        src: "https://i.imgur.com/GDoAGny.png",
        style: {
          width: "20px",
          height: "30px",
          cursor: "pointer"
        },
        onClick: () => window.open(dxfDirectUrl, "_blank"),
        alt: "DXF File",
        title: "Download DXF"
      }) : "N/A");
    }
    if (column.accessor === "drawingPdf") {
      var _drawingPdfflow$2;
      const pdfSrc = isEmployee ? formData === null || formData === void 0 ? void 0 : formData.drawingPdfUrlSelf : drawingPdfflow === null || drawingPdfflow === void 0 ? void 0 : (_drawingPdfflow$2 = drawingPdfflow[0]) === null || _drawingPdfflow$2 === void 0 ? void 0 : _drawingPdfflow$2.fileStoreId;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, pdfSrc ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => {
          if (isEmployee && typeof pdfSrc === "string") {
            handleOpenPdf(pdfSrc);
          } else {
            getDocumentByFileStoreId(pdfSrc, setIsPreviewLoading);
          }
        },
        title: "View Drawing PDF"
      }) : "N/A");
    }
    if (column.accessor === "viewEditPdf" && isEmployee) {
      var _formData$mapSubDetai3;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, formData !== null && formData !== void 0 && (_formData$mapSubDetai3 = formData.mapSubDetails) !== null && _formData$mapSubDetai3 !== void 0 && _formData$mapSubDetai3.viewEditPdf ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#157CB3",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => {
          var _formData$mapSubDetai4;
          return getDocumentByFileStoreId(formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.viewEditPdf, setIsPreviewLoading);
        },
        title: "View Edited PDF"
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      var _formData$status;
      const signedFileUrl = (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || (formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || (typeof (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === "string" ? formData.IsSignedDrawingPdfURL : null);
      const isAlreadySigned = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === true);
      const isApplyForDsc = formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC");
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, isAlreadySigned ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#24b155",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(signedFileUrl, "_blank"),
        title: "View Signed PDF"
      }) : !isEmployee ? /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          opacity: 1
        },
        type: "button",
        onClick: handleSign
      }, "Attach Digital Sign") : /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: "#888",
          fontStyle: "italic"
        }
      }, "Pending DSC"));
    }
    return /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id
    }, "N/A");
  }))))), /*#__PURE__*/React__default.createElement(PdfViewerModal, {
    open: pdfModalOpen,
    onClose: handlePdfModalClose,
    pdfUrl: currentPdfUrl,
    onSave: handlePdfSave,
    fileStoreId: currFileStoreId,
    documentIndex: currentDocumentIndex
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9999
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: formRef,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit")))))), !isEmployee && !isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "button",
    onClick: () => (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === true && formData !== null && formData !== void 0 && formData.signedDrawingPdfURL ? handleTabChange(3) : alert("Please attach the DSC"),
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

var ltpData = [
	{
		name: "ARJUN SINGH",
		mobileNumber: "6767676767"
	},
	{
		name: "Sample Empanelled Architect",
		mobileNumber: "9702543850"
	},
	{
		name: "Sample Empanelled Engineer",
		mobileNumber: "9999999999"
	},
	{
		name: "Sample Empanelled Engineer",
		mobileNumber: "6565656565"
	},
	{
		name: "Sample Empanelled Engineer",
		mobileNumber: "8181968282"
	}
];

const TopBarContainer = styled$1(Paper$1, {
  shouldForwardProp: prop => prop !== "isEmpanelled"
})(({
  theme,
  isEmpanelled
}) => ({
  padding: theme.spacing(1.5),
  backgroundColor: isEmpanelled ? "#f7fdf9" : "#f9faff",
  color: "#333333",
  borderRadius: theme.shape.borderRadius,
  boxShadow: isEmpanelled ? "0 2px 10px rgba(22, 163, 74, 0.15)" : theme.shadows[2],
  border: isEmpanelled ? "1px solid #86efac" : "none",
  borderLeft: isEmpanelled ? "5px solid #16a34a" : "none",
  margin: "10px",
  transition: "all 0.3s ease"
}));
const InfoItem = styled$1(Box)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5)
}));
const normalizePhone = phone => {
  if (!phone) return "";
  const cleaned = String(phone).replace(/\D/g, "");
  return cleaned.length >= 10 ? cleaned.slice(-10) : cleaned;
};
const checkIsEmpanelled = (targetMobile, list) => {
  if (!targetMobile) return false;
  const target = normalizePhone(targetMobile);
  if (!target || target.length < 10) return false;
  let items = [];
  if (Array.isArray(list)) {
    items = list;
  } else if (list && typeof list === "object") {
    if (Array.isArray(list.mobileNumbers)) items = list.mobileNumbers;else if (Array.isArray(list.ltpList)) items = list.ltpList;else if (Array.isArray(list.ltp)) items = list.ltp;else items = Object.values(list);
  }
  return items.some(item => {
    if (typeof item === "string" || typeof item === "number") {
      return normalizePhone(item) === target;
    }
    if (item && typeof item === "object") {
      const num = item.mobileNumber || item.mobile || item.phone || item.ltpMobileNo || item.contactNumber;
      return normalizePhone(num) === target;
    }
    return false;
  });
};
const isLdaFile = formData => {
  var _window$location;
  const candidates = [formData === null || formData === void 0 ? void 0 : formData.applicationNo, formData === null || formData === void 0 ? void 0 : formData.land_Id, formData === null || formData === void 0 ? void 0 : formData.fileNumber, formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber, formData === null || formData === void 0 ? void 0 : formData.prevFileNo, typeof window !== "undefined" ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname : ""];
  return candidates.some(val => {
    if (!val || typeof val !== "string") return false;
    const upper = val.toUpperCase();
    return upper.startsWith("LDA") || upper.includes("LDA");
  });
};
const EmpTopBar = ({
  formData,
  workflowDetails: workflowDetailsProp
}) => {
  var _window, _window$Digit, _window$Digit$ULBServ, _window2, _window2$Digit, _window2$Digit$Hooks, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$additionalD4, _formData$architectIn, _formData$bpaData, _formData$bpaData$pro, _formData$bpaData2, _formData$bpaData2$pr, _formData$professiona4, _formData$professiona5, _formData$professiona6, _workflowDetails$data, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$professiona10, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2;
  const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$Digit = _window.Digit) === null || _window$Digit === void 0 ? void 0 : (_window$Digit$ULBServ = _window$Digit.ULBService) === null || _window$Digit$ULBServ === void 0 ? void 0 : _window$Digit$ULBServ.getCurrentTenantId());
  const {
    data: hookWorkflowDetails,
    isLoading
  } = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Digit = _window2.Digit) === null || _window2$Digit === void 0 ? void 0 : (_window2$Digit$Hooks = _window2$Digit.Hooks) === null || _window2$Digit$Hooks === void 0 ? void 0 : _window2$Digit$Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    moduleCode: (formData === null || formData === void 0 ? void 0 : formData.businessService) || "BPA",
    config: {
      enabled: !workflowDetailsProp && !!(formData !== null && formData !== void 0 && formData.applicationNo) && !!tenantId
    }
  });
  const workflowDetails = workflowDetailsProp || hookWorkflowDetails;
  const totalSubmissions = useMemo(() => {
    return getSubmissionCount(workflowDetails || hookWorkflowDetails || formData);
  }, [workflowDetails, hookWorkflowDetails, formData]);
  const oldApplicationNo = (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) || (formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber) || "N/A";
  const isWorkflowLoading = workflowDetailsProp && (workflowDetailsProp === null || workflowDetailsProp === void 0 ? void 0 : workflowDetailsProp.isLoading) || !workflowDetailsProp && isLoading;
  const ltpMobileNo = (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalDetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.professionaldetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : (_formData$additionalD4 = _formData$additionalD3.professionalInformation) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$architectIn = formData.architectInformation) === null || _formData$architectIn === void 0 ? void 0 : _formData$architectIn.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$bpaData = formData.bpaData) === null || _formData$bpaData === void 0 ? void 0 : (_formData$bpaData$pro = _formData$bpaData.professionaldetails) === null || _formData$bpaData$pro === void 0 ? void 0 : _formData$bpaData$pro.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$bpaData2 = formData.bpaData) === null || _formData$bpaData2 === void 0 ? void 0 : (_formData$bpaData2$pr = _formData$bpaData2.professionalInformation) === null || _formData$bpaData2$pr === void 0 ? void 0 : _formData$bpaData2$pr.mobileNumber) || null;
  const displayLtpMobileNo = (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalDetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber) || "NA";
  if (typeof window !== "undefined" && !window.ltpJson) {
    window.ltpJson = ltpData;
  }
  const isEmpanelled = useMemo(() => {
    var _window3;
    const matchesLda = isLdaFile(formData);
    if (!matchesLda) return false;
    const list = ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.ltpJson) || ltpData;
    const target = ltpMobileNo || (displayLtpMobileNo !== "NA" ? displayLtpMobileNo : null);
    const result = checkIsEmpanelled(target, list);
    console.log("[EmpTopBar] LTP Empanelled Check:", {
      target,
      matchesLda,
      result,
      count: list === null || list === void 0 ? void 0 : list.length
    });
    return result;
  }, [formData, ltpMobileNo, displayLtpMobileNo]);
  return /*#__PURE__*/React__default.createElement(TopBarContainer, {
    isEmpanelled: isEmpanelled
  }, isEmpanelled && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#ecfdf5",
      border: "1px solid #a7f3d0",
      borderRadius: "6px",
      padding: "4px 12px",
      marginBottom: "12px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Chip, {
    label: "Empanelled",
    size: "small",
    sx: {
      backgroundColor: "#16a34a",
      color: "#ffffff",
      fontWeight: 800,
      fontSize: "0.75rem",
      height: "22px",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      boxShadow: "0 1px 3px rgba(22, 163, 74, 0.3)"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    sx: {
      color: "#065f46",
      fontWeight: 700,
      fontSize: "0.78rem"
    }
  }, "Empanelled Technical Person (LTP) File"))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "FASTPAS ID:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontStyle: "italic",
    fontWeight: "bold"
  }, (formData === null || formData === void 0 ? void 0 : formData.land_Id) || "NA"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, {
    sx: {
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "Application No:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || "NA"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "Total No. of Submissions:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, isWorkflowLoading && !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.timeline) && !(workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.timeline) ? "Loading" : totalSubmissions))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.consultantCategory) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionalInformation) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.consultantCategory) || "NA", ":"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.name) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona10 = formData.professionalInformation) === null || _formData$professiona10 === void 0 ? void 0 : _formData$professiona10.name) || "NA"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, {
    sx: {
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "LTP Mobile No:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, displayLtpMobileNo), isEmpanelled && /*#__PURE__*/React__default.createElement(Chip, {
    label: "Empanelled",
    size: "small",
    sx: {
      backgroundColor: "#16a34a",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "0.72rem",
      height: "22px",
      borderRadius: "11px",
      boxShadow: "0 2px 4px rgba(22, 163, 74, 0.25)",
      letterSpacing: "0.3px",
      marginLeft: "6px",
      "& .MuiChip-label": {
        paddingLeft: "8px",
        paddingRight: "8px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "Owner Name:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name) || "NA"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(InfoItem, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, "Old Application Number:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    fontWeight: "bold"
  }, oldApplicationNo)))));
};

const getCompletionData = (t, id = null) => {
  var _Digit$SessionStorage, _edcrData$planDetail, _edcrData$planDetail$, _edcrData$planDetail$2, _mdmsData$BPA, _planDetail$plot, _planDetail$virtualBu, _planDetail$virtualBu2, _planDetail$virtualBu3, _planDetail$virtualBu4, _planDetail$virtualBu5, _planDetail$planInfoP, _planDetail$plot2, _planDetail$blocks2, _planDetail$parkingDe, _planDetail$parkingDe2, _Digit, _userInfo$info, _userInfo$info2, _userInfo$info3, _scrutinyDetails$city, _planInformation$corr, _scrutinyDetails$loca, _planInformation$corr2, _scrutinyDetails$vill, _planInformation$corr3;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const planDetail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const regulatedObj = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : (_edcrData$planDetail$ = _edcrData$planDetail.reportOutput) === null || _edcrData$planDetail$ === void 0 ? void 0 : (_edcrData$planDetail$2 = _edcrData$planDetail$.scrutinyDetails) === null || _edcrData$planDetail$2 === void 0 ? void 0 : _edcrData$planDetail$2.filter(e => e.key === "Block_1_Side Setback");
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot = planDetail.plot) === null || _planDetail$plot === void 0 ? void 0 : _planDetail$plot.area, planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const planInformation = planDetail === null || planDetail === void 0 ? void 0 : planDetail.planInformation;
  if (id) {
    var _data$BPA;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess,
      refetchOnMount: "always"
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  }
  const applicationType = "FORM_COMPLETION";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
  const applicationData = {
    tenantId,
    applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
    applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
    applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
    occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
    edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
    totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu = planDetail.virtualBuilding) === null || _planDetail$virtualBu === void 0 ? void 0 : _planDetail$virtualBu.totalBuitUpArea,
    totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu2 = planDetail.virtualBuilding) === null || _planDetail$virtualBu2 === void 0 ? void 0 : _planDetail$virtualBu2.totalProposedArea,
    totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu3 = planDetail.virtualBuilding) === null || _planDetail$virtualBu3 === void 0 ? void 0 : _planDetail$virtualBu3.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu4 = planDetail.virtualBuilding) === null || _planDetail$virtualBu4 === void 0 ? void 0 : (_planDetail$virtualBu5 = _planDetail$virtualBu4.totalCoverageArea) === null || _planDetail$virtualBu5 === void 0 ? void 0 : _planDetail$virtualBu5.toFixed(2)) || null,
    typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
    propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP = planDetail.planInfoProperties) === null || _planDetail$planInfoP === void 0 ? void 0 : _planDetail$planInfoP.PROPERTY_TYPE)),
    proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
    revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
    khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
    khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
    plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot2 = planDetail.plot) === null || _planDetail$plot2 === void 0 ? void 0 : _planDetail$plot2.area) || 0,
    plotAreaDoc: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaDoc,
    plotAreaPos: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaPossession,
    siteAddress: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landAddress,
    totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
    blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
    basicFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.basicFAR,
    purchasableFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.purchasableFAR,
    premiumFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.premiumFAR,
    noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks2 = planDetail.blocks) === null || _planDetail$blocks2 === void 0 ? void 0 : _planDetail$blocks2.length) || 0,
    demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
    parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe = planDetail.parkingDetails) === null || _planDetail$parkingDe === void 0 ? void 0 : _planDetail$parkingDe.overAllParkingArea) || 0,
    parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe2 = planDetail.parkingDetails) === null || _planDetail$parkingDe2 === void 0 ? void 0 : _planDetail$parkingDe2.parkingFloorNo) || 0,
    activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0,
    riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
    applicationType,
    department: applicationFlow || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.department),
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null
    },
    planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
    updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
    dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: planInformation === null || planInformation === void 0 ? void 0 : planInformation.district,
        locality: {
          code: "Lucknow"
        },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
      },
      tenantId
    },
    professionaldetails: {
      name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId
    },
    landAreaDetails: {
      city: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$city = scrutinyDetails.city) === null || _scrutinyDetails$city === void 0 ? void 0 : _scrutinyDetails$city.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr = planInformation.correspondenceAddress) === null || _planInformation$corr === void 0 ? void 0 : _planInformation$corr.district) || null,
      locality: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$loca = scrutinyDetails.locality) === null || _scrutinyDetails$loca === void 0 ? void 0 : _scrutinyDetails$loca.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr2 = planInformation.correspondenceAddress) === null || _planInformation$corr2 === void 0 ? void 0 : _planInformation$corr2.tehsil) || null
      },
      village: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$vill = scrutinyDetails.village) === null || _scrutinyDetails$vill === void 0 ? void 0 : _scrutinyDetails$vill.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr3 = planInformation.correspondenceAddress) === null || _planInformation$corr3 === void 0 ? void 0 : _planInformation$corr3.town) || null
      },
      areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
    },
    businessService: (applicationFlow || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.department)) === "DA" ? "BPA_COMPLETION_DA" : "BPA_COMPLETION_AVP",
    documents,
    viewPdf: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPdf,
    viewPlanReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPlanReport,
    natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
    proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
    sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
    sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
    noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
    plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
    district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
    sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
    tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
    revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
    landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
    schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
    buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
    otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
    planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
    buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
    projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
    isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
    prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
    isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
    typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
    plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
    plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
    needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
    plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
    isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
    isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
    isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
    constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
    layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
    layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
    groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
    far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
    isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
    setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
    setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
    setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
    setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
    zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
    isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
    subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
    primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
    activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
    communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
    anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
    khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
    sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
    uiFlow: {
      flow: "Form12"
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const isEmpty = val => {
  if (val === undefined || val === null || val === "") return true;
  if (typeof val === "string" && val.trim() === "") return true;
  if (Array.isArray(val) && val.length === 0) return true;
  if (typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0) return true;
  return false;
};
const normalizeDocKey = key => typeof key === "string" ? key.toLowerCase().replace(/[._\s-]/g, "") : "";
const getDocumentTypes = (reduxDocs = [], formDocs = []) => {
  const types = new Set();
  const normalizedTypes = new Set();
  const addKey = key => {
    if (key) {
      types.add(key);
      normalizedTypes.add(normalizeDocKey(key));
    }
  };
  const processDoc = d => {
    const hasValidFileStore = (d === null || d === void 0 ? void 0 : d.fileStoreId) && typeof d.fileStoreId === "string" && d.fileStoreId.trim() !== "" || (d === null || d === void 0 ? void 0 : d.id) && typeof d.id === "string" && d.id.trim() !== "" || (d === null || d === void 0 ? void 0 : d.documentUid) && typeof d.documentUid === "string" && d.documentUid.trim() !== "";
    if (hasValidFileStore) {
      var _d$additionalDetails;
      addKey(d === null || d === void 0 ? void 0 : d.documentType);
      addKey(d === null || d === void 0 ? void 0 : d.name);
      addKey(d === null || d === void 0 ? void 0 : (_d$additionalDetails = d.additionalDetails) === null || _d$additionalDetails === void 0 ? void 0 : _d$additionalDetails.title);
      if (d !== null && d !== void 0 && d.documentType && d.documentType.includes(".")) {
        addKey(d.documentType.split(".").pop());
      }
    }
  };
  (reduxDocs || []).forEach(processDoc);
  (formDocs || []).forEach(processDoc);
  types._normalized = normalizedTypes;
  return types;
};
const hasDoc = (docSet, ...names) => names.some(name => docSet.has(name) || docSet._normalized && docSet._normalized.has(normalizeDocKey(name)));
const validateSummaryForm = ({
  formType,
  formData: _formData = {},
  reduxDocuments: _reduxDocuments = [],
  declarationChecked: _declarationChecked = true,
  t: _t = key => key
}) => {
  console.log(_formData, "Validation data here");
  const errors = [];
  const uploadedDocs = getDocumentTypes(_reduxDocuments, _formData === null || _formData === void 0 ? void 0 : _formData.documents);
  const rawType = formType || (_formData === null || _formData === void 0 ? void 0 : _formData.applicationType) || "";
  const normType = rawType.toUpperCase().replace(/_/g, "");
  if (_declarationChecked === false) {
    errors.push(_t("Please check the declaration checkbox before submitting."));
  }
  const appFlow = (_formData === null || _formData === void 0 ? void 0 : _formData.department) || (_formData === null || _formData === void 0 ? void 0 : _formData.applicationFlow);
  if (appFlow === "DA") {
    if (isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.selectedOffice) && isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.verifyingAuthority)) {
      errors.push(_t("Verifying Authority / Office selection is required."));
    }
  } else if (appFlow === "AVP") {
    var _formData$landAreaDet;
    if (isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.selectedUnit) && isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.selectedDevelopmentAuthority) && isEmpty(_formData === null || _formData === void 0 ? void 0 : (_formData$landAreaDet = _formData.landAreaDetails) === null || _formData$landAreaDet === void 0 ? void 0 : _formData$landAreaDet.city) && isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.selectedCity)) {
      errors.push(_t("Unit / City selection is required."));
    }
  }
  if (normType.includes("CONVERSION") || normType.includes("LANDUSE") || normType.includes("LAND")) {
    const prof = (_formData === null || _formData === void 0 ? void 0 : _formData.professionalInformation) || (_formData === null || _formData === void 0 ? void 0 : _formData.professionaldetails);
    if (prof && prof.consultantCategory !== "Owner") {
      if (isEmpty(prof.name)) errors.push(_t("LTP Name is required in LTP Information."));
      if (isEmpty(prof.mobileNumber) && isEmpty(prof.mobileNo)) errors.push(_t("LTP Mobile Number is required in LTP Information."));
    }
    const land = (_formData === null || _formData === void 0 ? void 0 : _formData.descriptionOfLand) || {};
    if (isEmpty(land.schemeType)) {
      errors.push(_t("Scheme Type (Scheme / Non Scheme) is required in Land Information."));
    } else if (land.schemeType === "Scheme") {
      if (isEmpty(land.subLandUseAsPerLayout) && isEmpty(land.appliedLandUse)) {
        errors.push(_t("Sub Land Use / Applied Land Use is required for Scheme type."));
      }
      if (isEmpty(land.schemeName) && isEmpty(land.sectorNo)) {
        errors.push(_t("Scheme Name / Sector is required for Scheme type."));
      }
    } else if (land.schemeType === "Non Scheme") {
      if (isEmpty(land.appliedLandUse)) {
        errors.push(_t("Applied Land Use is required for Non Scheme type."));
      }
      const hasKhata = !isEmpty(land.khataNo) || !isEmpty(land.khatauniNo);
      const hasKhasraArray = Array.isArray(land.multipleKhasra) && land.multipleKhasra.some(k => !isEmpty(k.khasraNo));
    }
    const isScheme = land.schemeType === "Scheme";
    if (!hasDoc(uploadedDocs, "completeDrawingFile", "completeDrawing")) {
      errors.push(_t("Complete Drawing File is required in Documents tab."));
    }
    if (!hasDoc(uploadedDocs, "registrySaleDeedHPTA", "registrySaleDeed", "Registry/Sale deed/HPTA")) {
      errors.push(_t("Registry / Sale Deed / HPTA Document is required in Documents tab."));
    }
    if (isScheme && !hasDoc(uploadedDocs, "allotmentLetterPossessionLetter", "allotmentLetter", "possessionLetter")) {
      errors.push(_t("Allotment Letter / Possession Letter is required for Scheme type in Documents tab."));
    }
  }
  if (normType.includes("MAPSUBMISSION") || normType.includes("MAP") || normType.includes("GROUPHOUSING")) {
    var _formData$mapSubDetai, _formData$mapSubDetai2, _Digit, _Digit$SessionStorage;
    const nature = (_formData === null || _formData === void 0 ? void 0 : _formData.natureOfConstruction) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai = _formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.natureOfConstruction);
    if (isEmpty(nature)) {
      errors.push(_t("Nature of Construction is required in General Information."));
    }
    const prof = (_formData === null || _formData === void 0 ? void 0 : _formData.professionalInformation) || (_formData === null || _formData === void 0 ? void 0 : _formData.professionaldetails);
    if (_formData.applicationType === "FORM_LANDUSE" && prof && prof.consultantCategory !== "Owner") {
      if (isEmpty(prof.name)) errors.push(_t("Architect / Engineer Name is required in Professional Details."));
      if (isEmpty(prof.licenseNumber)) errors.push("License Number Cannot be empty");
      if (isEmpty(prof.mobileNumber) && isEmpty(prof.mobileNo)) errors.push(_t("Architect / Engineer Mobile Number is required in Professional Details."));
    }
    const land = (_formData === null || _formData === void 0 ? void 0 : _formData.descriptionOfLand) || {};
    const plotNo = _formData === null || _formData === void 0 ? void 0 : _formData.plotNo;
    const plotArea = (_formData === null || _formData === void 0 ? void 0 : _formData.plotArea) || (_formData === null || _formData === void 0 ? void 0 : _formData.totalPlotArea);
    if (isEmpty(plotNo) && (land === null || land === void 0 ? void 0 : land.schemeType) === "Scheme") {
      errors.push(_t("Plot Number/Khasra Number is required in Plot Details."));
    }
    if (isEmpty(plotArea) || Number(plotArea) <= 0) {
      errors.push(_t("Plot Area is required and must be greater than 0 in Plot Details."));
    }
    const totalBuiltUp = (_formData === null || _formData === void 0 ? void 0 : _formData.totalBuildUpArea) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai2 = _formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.totalBuildUpArea);
    if (isEmpty(totalBuiltUp) || Number(totalBuiltUp) <= 0) {
      errors.push(_t("Total Built-Up Area is required and must be greater than 0."));
    }
    const isDSCMissing = !(_formData !== null && _formData !== void 0 && _formData.IsSignedDrawingPdfURL) && !(_formData !== null && _formData !== void 0 && _formData.IsSignedDrawingPdfDscEmp);
    if (isDSCMissing) {
      errors.push(_t("DSC is required"));
    }
    if (nature === "Compounding") {
      var _formData$mapSubDetai3;
      const compoundingChecklist = (_formData === null || _formData === void 0 ? void 0 : _formData.compoundingChecklist) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai3 = _formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.compoundingChecklist);
      if (isEmpty(compoundingChecklist)) {
        errors.push(_t("Compounding Checklist is required when Nature of Construction is Compounding."));
      }
    }
    const ltpCompetencyError = validateAllLtpCompetency(_formData);
    if (ltpCompetencyError) {
      errors.push(_t(ltpCompetencyError));
    }
    const hasEdcrNumber = !isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.edcrNumber);
    const hasDxfFile = !isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.dxfFile) || !isEmpty(_formData === null || _formData === void 0 ? void 0 : _formData.updatedDxfFile) || hasDoc(uploadedDocs, "dxfDrawing");
    const hasDrawingPdf = hasDoc(uploadedDocs, "drawingPdf", "drawingPDF", "drawingDetail", "compoundingDrawingPdf");
    const hasDrawing = hasEdcrNumber || hasDxfFile || hasDrawingPdf || hasDoc(uploadedDocs, "completeDrawingFile", "buildingPlan");
    if (!hasDrawing) {
      errors.push(_t("Drawing PDF / DXF / EDCR Scrutiny file is required in Drawing Details / Documents."));
    }
    const isRevalidationOrRedev = nature === "Revalidation/Time Extension" || nature === "Redevelopment/Reconstruction" || typeof nature === "string" && nature.includes("Redevelopment") || typeof nature === "string" && nature.includes("Reconstruction");
    if (isRevalidationOrRedev) {
      var _formData$mapSubDetai4, _formData$mapSubDetai5, _formData$mapSubDetai6;
      const sanctionDate = (_formData === null || _formData === void 0 ? void 0 : _formData.sanctionValidityStartDate) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai4 = _formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.sanctionValidityStartDate);
      const validityDate = (_formData === null || _formData === void 0 ? void 0 : _formData.sanctionValidityDate) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai5 = _formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.sanctionValidityDate);
      const prevFileNo = (_formData === null || _formData === void 0 ? void 0 : _formData.prevFileNo) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai6 = _formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.prevFileNo);
      if (isEmpty(sanctionDate)) {
        errors.push(_t("Previous Sanction Date is required for " + nature + "."));
      }
      if (isEmpty(validityDate)) {
        errors.push(_t("Previous Sanction Validity Date is required for " + nature + "."));
      }
      if (isEmpty(prevFileNo)) {
        errors.push(_t("Previous Approved Map Number / File Number is required for " + nature + "."));
      }
    }
    const isDA = (_formData === null || _formData === void 0 ? void 0 : _formData.department) === "DA";
    const isScheme = land.schemeType === "Scheme" || (_formData === null || _formData === void 0 ? void 0 : _formData.schemeType) === "Scheme";
    const isSelfCert = (_formData === null || _formData === void 0 ? void 0 : _formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" || (_formData === null || _formData === void 0 ? void 0 : _formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts";
    const isLowRiskCase = (_formData === null || _formData === void 0 ? void 0 : _formData.riskType) === "LOW";
    const scrutinyFlow = (_formData === null || _formData === void 0 ? void 0 : _formData.scrutinyFlow) === "PDF" || ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("LTP.SCRUTINY.SELECTION")) === "PDF";
    if (!hasDoc(uploadedDocs, "Registration Certificate", "registrationCertificate")) {
      errors.push(_t("Architect/Engineer Registration Certificate is required in Documents tab."));
    }
    if (!hasDoc(uploadedDocs, "registrySaleDeedHPTA", "registrySaleDeed")) {
      errors.push(_t("Registry / Sale Deed / HPTA Document is required in Documents tab."));
    }
    if (!isLowRiskCase && !hasDoc(uploadedDocs, "calculationSheet")) {
      errors.push(_t("Calculation sheet of Estimate with Affidavit is required in Documents tab."));
    }
    if (!isScheme && !hasDoc(uploadedDocs, "khatauni")) {
      errors.push(_t("Khatauni document is required for Non-Scheme type in Documents tab."));
    }
    if (isScheme && !hasDoc(uploadedDocs, "allotmentLetterPossessionLetter", "allotmentLetter")) {
      errors.push(_t("Allotment Letter / Possession Letter is required for Scheme type in Documents tab."));
    }
    if (!isSelfCert && !hasDoc(uploadedDocs, "ownerAffidavit")) {
      errors.push(_t("Owner Affidavit is required in Documents tab."));
    }
    if (isSelfCert && !hasDoc(uploadedDocs, "ltpAffidavit")) {
      errors.push(_t("LTP Affidavit is required for Self Certification in Documents tab."));
    }
    if (!isDA && !hasDoc(uploadedDocs, "uptodatePaymentLetter")) {
      errors.push(_t("Upto date payment letter is required in Documents tab."));
    }
    if (scrutinyFlow && nature !== "Compounding" && !hasDoc(uploadedDocs, "dxfDrawing")) {
      errors.push(_t("DXF Drawing file is required for PDF scrutiny flow in Documents tab."));
    }
    const showSanctionDocs = nature !== "New" && (nature !== "Compounding" || (_formData === null || _formData === void 0 ? void 0 : _formData.serviceType) === "yes" || (_formData === null || _formData === void 0 ? void 0 : _formData.shortName) === "yes");
    const isSanctionDocMandatory = nature !== "Redevelopment/Reconstruction" && nature !== "Redevelopment";
    if (showSanctionDocs && isSanctionDocMandatory) {
      if (!hasDoc(uploadedDocs, "Previous Sanction Map", "previousSanctionMap")) {
        errors.push(_t("Previous Sanction Map document is required in Documents tab."));
      }
      if (!hasDoc(uploadedDocs, "Previous Sanction Letter", "previousSanctionLetter")) {
        errors.push(_t("Previous Sanction Letter document is required in Documents tab."));
      }
    }
  }
  if (normType.includes("COMPLETION")) {
    var _formData$mapSubDetai7, _formData$description, _formData$mapSubDetai11, _formData$additionalD, _formData$additionalD2, _formData$additionalD3;
    const nature = (_formData === null || _formData === void 0 ? void 0 : _formData.natureOfConstruction) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai7 = _formData.mapSubDetails) === null || _formData$mapSubDetai7 === void 0 ? void 0 : _formData$mapSubDetai7.natureOfConstruction);
    const isRevalidationOrRedev = nature === "Revalidation/Time Extension" || nature === "Redevelopment/Reconstruction" || typeof nature === "string" && nature.includes("Redevelopment") || typeof nature === "string" && nature.includes("Reconstruction");
    if (isRevalidationOrRedev) {
      var _formData$mapSubDetai8, _formData$mapSubDetai9, _formData$mapSubDetai10;
      const sanctionDate = (_formData === null || _formData === void 0 ? void 0 : _formData.sanctionValidityStartDate) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai8 = _formData.mapSubDetails) === null || _formData$mapSubDetai8 === void 0 ? void 0 : _formData$mapSubDetai8.sanctionValidityStartDate);
      const validityDate = (_formData === null || _formData === void 0 ? void 0 : _formData.sanctionValidityDate) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai9 = _formData.mapSubDetails) === null || _formData$mapSubDetai9 === void 0 ? void 0 : _formData$mapSubDetai9.sanctionValidityDate);
      const prevFileNo = (_formData === null || _formData === void 0 ? void 0 : _formData.prevFileNo) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai10 = _formData.mapSubDetails) === null || _formData$mapSubDetai10 === void 0 ? void 0 : _formData$mapSubDetai10.prevFileNo);
      if (isEmpty(sanctionDate)) {
        errors.push(_t("Previous Sanction Date is required for " + nature + "."));
      }
      if (isEmpty(validityDate)) {
        errors.push(_t("Previous Sanction Validity Date is required for " + nature + "."));
      }
      if (isEmpty(prevFileNo)) {
        errors.push(_t("Previous Approved Map Number is required for " + nature + "."));
      }
    }
    const isLowRiskCase = (_formData === null || _formData === void 0 ? void 0 : _formData.riskType) === "LOW";
    const isSelfCert = (_formData === null || _formData === void 0 ? void 0 : _formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
    const hasRegCert = hasDoc(uploadedDocs, "Registration Certificate", "registrationCertificate", "REGISTRATION_CERTIFICATE", "BPA.COMPLETION.REGISTRATION_CERTIFICATE", "BPA.LANDUSE.REGISTRATION_CERTIFICATE", "BPA.MAPSUB.REGISTRATION_CERTIFICATE");
    const hasRegSaleDeed = hasDoc(uploadedDocs, "registrySaleDeedHPTA", "registrySaleDeed", "Registry/Sale deed/HPTA", "REGISTRY_SALE_DEED_HPTA", "REGISTRY_SALE_DEED");
    const hasCalcSheet = hasDoc(uploadedDocs, "calculationSheet", "CALCULATION_SHEET");
    const hasKhatauni = hasDoc(uploadedDocs, "khatauni", "KHATAUNI");
    const hasAllotmentLetter = hasDoc(uploadedDocs, "allotmentLetterPossessionLetter", "allotmentLetter", "possessionLetter", "ALLOTMENT_LETTER", "POSSESSION_LETTER");
    const hasOwnerAffidavit = hasDoc(uploadedDocs, "ownerAffidavit", "OWNER_AFFIDAVIT");
    const hasLtpAffidavit = hasDoc(uploadedDocs, "ltpAffidavit", "LTP_AFFIDAVIT");
    const hasDrawingPdf = hasDoc(uploadedDocs, "drawingPDF", "drawingPdf", "DRAWING_PDF");
    const schemeTypeValue = (_formData === null || _formData === void 0 ? void 0 : (_formData$description = _formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) || (_formData === null || _formData === void 0 ? void 0 : _formData.schemeType) || (_formData === null || _formData === void 0 ? void 0 : (_formData$mapSubDetai11 = _formData.mapSubDetails) === null || _formData$mapSubDetai11 === void 0 ? void 0 : _formData$mapSubDetai11.schemeType) || (_formData === null || _formData === void 0 ? void 0 : (_formData$additionalD = _formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.schemeType) || (_formData === null || _formData === void 0 ? void 0 : (_formData$additionalD2 = _formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : (_formData$additionalD3 = _formData$additionalD2.descriptionOfLand) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.schemeType);
    const isScheme = schemeTypeValue === "Scheme" || hasAllotmentLetter;
    if (!hasRegCert) {
      errors.push(_t("Architect/Engineer Registration Certificate is required in Documents tab."));
    }
    if (!hasRegSaleDeed) {
      errors.push(_t("Registry / Sale Deed / HPTA document is required in Documents tab."));
    }
    if (!isLowRiskCase && !hasCalcSheet) {
      errors.push(_t("Calculation sheet of Estimate with Affidavit is required in Documents tab."));
    }
    if (!isScheme && !hasKhatauni) {
      errors.push(_t("Khatauni document is required in Documents tab."));
    }
    if (schemeTypeValue === "Scheme" && !hasAllotmentLetter) {
      errors.push(_t("Allotment Letter / Possession Letter is required in Documents tab."));
    }
    if (!isSelfCert && !hasOwnerAffidavit) {
      errors.push(_t("Owner Affidavit is required in Documents tab."));
    }
    if (isSelfCert) {
      if (!hasDrawingPdf) {
        errors.push(_t("Drawing PDF is required for Self Certification."));
      }
      if (!hasLtpAffidavit) {
        errors.push(_t("LTP Affidavit is required for Self Certification."));
      }
    }
    if (nature === "Compounding") {
      if (!hasDoc(uploadedDocs, "compoundingDrawingPdf", "COMPOUNDING_DRAWING_PDF")) {
        errors.push(_t("Compounding Drawing PDF is required."));
      }
      if (!hasDoc(uploadedDocs, "compoundingDrawingDxf", "COMPOUNDING_DRAWING_DXF")) {
        errors.push(_t("Compounding Drawing DXF is required."));
      }
      if (!hasDoc(uploadedDocs, "uptodatePaymentLetter", "UPTODATE_PAYMENT_LETTER")) {
        errors.push(_t("Site Photo document is required."));
      }
    }
  }
  const isValid = errors.length === 0;
  const errorHtml = isValid ? "" : `<ul style="text-align: left; margin-top: 10px; padding-left: 20px; font-size: 14px; line-height: 1.6; color: #721c24;">` + errors.map(err => `<li>${err}</li>`).join("") + `</ul>`;
  return {
    isValid,
    errors,
    errorHtml
  };
};

const isSitePhotoDocument = doc => {
  const type = doc !== null && doc !== void 0 && doc.documentType ? doc.documentType.toLowerCase() : "";
  return type === "sitephoto" || type.indexOf("sitephoto") === 0;
};
const mergeDocumentsWithSitePhotos = (incomingDocs, sourceDocLists) => {
  const result = Array.isArray(incomingDocs) ? incomingDocs.slice() : [];
  const sources = Array.isArray(sourceDocLists) ? sourceDocLists : [];
  sources.forEach(sourceList => {
    if (Array.isArray(sourceList)) {
      sourceList.forEach(doc => {
        if (doc && isSitePhotoDocument(doc) && doc.fileStoreId) {
          const docTypeLower = doc.documentType ? doc.documentType.toLowerCase() : "";
          const alreadyPresent = result.some(d => {
            const dTypeLower = d !== null && d !== void 0 && d.documentType ? d.documentType.toLowerCase() : "";
            return dTypeLower && docTypeLower && dTypeLower === docTypeLower || (d === null || d === void 0 ? void 0 : d.fileStoreId) && d.fileStoreId === doc.fileStoreId;
          });
          if (!alreadyPresent) {
            result.push(doc);
          }
        }
      });
    }
  });
  return result;
};
const useCompletionPortalLogic = t => {
  var _Digit, _Digit2, _Digit3, _Digit$UserService$ge, _location$state, _applicationData, _applicationData$audi;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [summaryShow, setSummaryshow] = useState(((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARY_TAB")) || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const userType = info === null || info === void 0 ? void 0 : info.type;
  console.log("INfot got", info, userType);
  const isEmployee = userType === "EMPLOYEE";
  const isCitizen = userType === "CITIZEN";
  const {
    id
  } = useParams();
  console.log("useParamsFromColpetion", id, useParams());
  const history = useHistory();
  const location = useLocation();
  let applicationData = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data;
  let isAppDataLoading = false;
  if (!applicationData) {
    ({
      applicationData,
      isAppDataLoading
    } = getCompletionData(t, id));
  }
  const isSelfCert = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : _applicationData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const componentRef = useRef();
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "NOC Status"
  }];
  const closeToast = () => setShowToast(null);
  const handleDeclarationChange = event => setDeclarationChecked(event.target.checked);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_COMPLETION", applicationData);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const applicationDataSignature = applicationData ? `${applicationData.applicationNo}-${(_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.lastModifiedTime}-${applicationData.status}` : null;
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData2, _applicationData2$doc;
      console.log("fromuseeffectsettingparams", id, applicationData);
      setParams(applicationData);
      if (((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$doc = _applicationData2.documents) === null || _applicationData2$doc === void 0 ? void 0 : _applicationData2$doc.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading, applicationDataSignature]);
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  function isValidityExpired(formData) {
    if (!(formData !== null && formData !== void 0 && formData.validityDate)) return false;
    const [day, month, year] = formData.validityDate.split("/").map(Number);
    const validityDate = new Date(year, month - 1, day);
    const oneYearAfter = new Date(validityDate);
    oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);
    const today = new Date();
    return today > oneYearAfter;
  }
  const {
    documents: reduxDocs
  } = useSelector(state => state.formMT || {});
  const isFeesRequired = isValidityExpired(params);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (nextTabNo === 0) {
      handleSubTabChange(0);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", 0);
    }
    if (formData) {
      var _applicationData3;
      const mergedDocs = mergeDocumentsWithSitePhotos((formData === null || formData === void 0 ? void 0 : formData.documents) || (params === null || params === void 0 ? void 0 : params.documents), [params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents, (_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.documents, reduxDocs]);
      const data = {
        ...params,
        ...formData,
        ...(mergedDocs && mergedDocs.length > 0 ? {
          documents: mergedDocs
        } : {})
      };
      const isFeesRequired = isValidityExpired(data);
      if (formData !== null && formData !== void 0 && formData.department && !id) {
        data.businessService = formData.department === "DA" ? "BPA_COMPLETION_DA" : "BPA_COMPLETION_AVP";
      }
      console.log("formDataOnTabChange", formData, isFeesRequired, nextTabNo);
      if (activeTab === 5) {
        const validation = validateSummaryForm({
          formType: "FORM_COMPLETION",
          formData: data,
          reduxDocuments: reduxDocs,
          declarationChecked,
          t
        });
        if (!validation.isValid) {
          Modal("Missing Mandatory Fields", validation.errorHtml, "error");
          return;
        }
      }
      try {
        if (activeTab === 5 && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: isFeesRequired ? "MAKE_PAYMENT" : "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else if (activeTab === 5 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA;
            const responseBpa = res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0];
            const updatedDocs = mergeDocumentsWithSitePhotos((responseBpa === null || responseBpa === void 0 ? void 0 : responseBpa.documents) || (data === null || data === void 0 ? void 0 : data.documents), [data === null || data === void 0 ? void 0 : data.documents, params === null || params === void 0 ? void 0 : params.documents]);
            const updatedData = {
              ...data,
              ...(responseBpa || {}),
              documents: updatedDocs
            };
            onSelect("", updatedData);
            if (activeTab === 5 && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
              if (isFeesRequired) {
                var _params$taxHeadEstima, _params$taxHeadEstima2;
                history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : (_params$taxHeadEstima2 = _params$taxHeadEstima[0]) === null || _params$taxHeadEstima2 === void 0 ? void 0 : _params$taxHeadEstima2.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                return;
              } else {
                var _Digit4, _Digit5, _Digit6;
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
                if (activeTab === 5) {
                  clearParams();
                }
                history.push(`/digit-ui/citizen/obps/completionApplications`);
                Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("EDCR_CREATE");
                (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("FASTPAS_ID");
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("SUMMARY_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("MS_CURRENT_TAB");
                Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
              }
            } else if (activeTab === 5 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
              var _Digit7, _Digit8, _Digit9;
              Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              if (activeTab === 5) {
                clearParams();
              }
              history.push(`/digit-ui/citizen/obps/completionApplications`);
              Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
              (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.del("EDCR_CREATE");
              (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.del("FASTPAS_ID");
              (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.del("SUMMARY_TAB");
              setTimeout(() => {
                resetFormMTDocs();
              }, 0);
              Digit.SessionStorage.del("MS_CURRENT_TAB");
              Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
            }
            setShowToast({
              error: false,
              message: `Data has been saved successfully`
            });
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      var _applicationData4, _dayjs;
      const mergedDocs = mergeDocumentsWithSitePhotos((formData === null || formData === void 0 ? void 0 : formData.documents) || (params === null || params === void 0 ? void 0 : params.documents), [params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents, (_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.documents, reduxDocs]);
      const data = {
        ...params,
        ...formData,
        ...(mergedDocs && mergedDocs.length > 0 ? {
          documents: mergedDocs
        } : {}),
        ...((formData !== null && formData !== void 0 && formData.department || params !== null && params !== void 0 && params.department) && !id ? {
          businessService: ((formData === null || formData === void 0 ? void 0 : formData.department) || (params === null || params === void 0 ? void 0 : params.department)) === "DA" ? "BPA_COMPLETION_DA" : "BPA_COMPLETION_AVP"
        } : {}),
        validityDate: (_dayjs = dayjs(formData === null || formData === void 0 ? void 0 : formData.validityDate)) === null || _dayjs === void 0 ? void 0 : _dayjs.format("YYYY-MM-DD"),
        ...(params !== null && params !== void 0 && params.inspectionDate || formData !== null && formData !== void 0 && formData.inspectionDate ? {} : {
          inspectionDate: dayjs().format("YYYY-MM-DD")
        })
      };
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !isCompounding && !id) {
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA2;
          if ((res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2.length) > 0) {
            var _res$BPA3;
            const responseBpa = (res === null || res === void 0 ? void 0 : (_res$BPA3 = res.BPA) === null || _res$BPA3 === void 0 ? void 0 : _res$BPA3[0]) || {};
            const updatedDocs = mergeDocumentsWithSitePhotos((responseBpa === null || responseBpa === void 0 ? void 0 : responseBpa.documents) || (data === null || data === void 0 ? void 0 : data.documents), [data === null || data === void 0 ? void 0 : data.documents, params === null || params === void 0 ? void 0 : params.documents]);
            onSelect("", {
              ...data,
              ...responseBpa,
              documents: updatedDocs
            }, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA4;
              const responseBpa = (res === null || res === void 0 ? void 0 : (_res$BPA4 = res.BPA) === null || _res$BPA4 === void 0 ? void 0 : _res$BPA4[0]) || {};
              const updatedDocs = mergeDocumentsWithSitePhotos((responseBpa === null || responseBpa === void 0 ? void 0 : responseBpa.documents) || (data === null || data === void 0 ? void 0 : data.documents), [data === null || data === void 0 ? void 0 : data.documents, params === null || params === void 0 ? void 0 : params.documents]);
              onSelect("", {
                ...data,
                ...responseBpa,
                documents: updatedDocs
              });
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };
  return {
    activeTab,
    setActiveTab,
    selectedSubTab,
    setSelectedSubTab,
    summaryShow,
    setSummaryshow,
    showToast,
    setShowToast,
    declarationChecked,
    setDeclarationChecked,
    handleDeclarationChange,
    closeToast,
    params,
    setParams,
    clearParams,
    tenantId,
    isEmployee,
    id,
    applicationData,
    isAppDataLoading,
    isSelfCert,
    componentRef,
    subTabLabels,
    handleTabChange,
    handleSubTabChange,
    onSelect,
    isCompounding,
    initFormMTDocs,
    isFeesRequired,
    isCitizen,
    updateApiCall
  };
};

const useEmpMapSubmission = (formData, refetch, workflowDetails, userRolesArray, urlFormType) => {
  var _location$pathname, _location$pathname2, _location$pathname3, _Digit$UserService$ge, _Digit$UserService$ge2, _userRolesArray$, _user$info, _user$info2, _user$info2$roles, _user$info3, _formData$documents, _formData$documents2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _formData$nocList, _formData$additionalD3, _userRolesArray$2, _userRolesArray$3, _formData$description, _formData$description2, _workflowDetails$data4, _workflowDetails$data5;
  const {
    id
  } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source") || "";
  const isFromDashboard = (location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("dashboard-details")) || (location === null || location === void 0 ? void 0 : (_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.includes("dashboard-v2")) || (location === null || location === void 0 ? void 0 : (_location$pathname3 = location.pathname) === null || _location$pathname3 === void 0 ? void 0 : _location$pathname3.includes("dashboard")) || source === "dashboard";
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  console.log(useParams(), "paramsHookFromMapSUb", userDetails);
  const {
    t
  } = useTranslation();
  const [iframeSrc, setIframeSrc] = useState("");
  const [pdfIframeSrc, setPdfIframeSrc] = useState("");
  const [inspectionDataResp, setInspectionDataResp] = useState(null);
  const [additionalComment, setAdditionalComment] = useState("");
  const {
    paymentHeadRemarksData = {},
    documentRemarksData = {},
    siteInspectionRemarksData = {},
    siteDrawingRemarksData = {},
    pFarDetailsData = {},
    chatBoardDataRemarks = {},
    chatBoardHistoryData = {},
    notingRemarksData = {},
    nocRemarksData = {},
    handleGetFiledsStatesById = () => {},
    handleGetRemarkssValues = () => {},
    handleGetPaymentHeadById = () => {},
    handleGetDrawingById = () => {},
    handlepFarDetailById = () => {},
    handleGetDocumentById = () => {},
    handleGetNotingById = () => {},
    handleGetNocById = () => {},
    handleGetSiteInspectionById = () => {}
  } = useContext(ScrutinyRemarksContext) || {};
  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState("");
  const [currentView, setCurrentView] = useState("documents");
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const [typeOfLetter, setTypeOfLetter] = useState("");
  const [customLetter, setCustomLetter] = useState([]);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData === null || formData === void 0 ? void 0 : formData.documents);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState(formData === null || formData === void 0 ? void 0 : formData.inspectionDetailData);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [taxHead, setTaxHead] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [officerNocDetails, setOfficerNocDetails] = useState(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto", "ltp_signature"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto", "kmlFile", "sitephoto1", "sitephoto2", "sitephoto3", "sitephoto4", "sitephoto5"];
  const isPurchasbleReq = (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) === "yes";
  const [drawingRemarks, setDrawingRemarks] = useState(null);
  const [drawingRecommendation, setDrawingRecommendation] = useState("");
  const [paymentRemarks, setPaymentRemarks] = useState(null);
  const [paymentRecommendation, setPaymentRecommendation] = useState("");
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  const [developerNocRemarks, setDeveloperNocRemarks] = useState(null);
  const [dataNocRecommendation, setDataNocRecommendation] = useState("");
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [selectedObjection, setSelectedObjection] = useState("");
  const [mapSubNocDetails, setMapSubNocDetails] = useState(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
  const [callAPI, setCallAPI] = useState(false);
  const [isNoNoc, setIsNoNoc] = useState(true);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const [mapSubmissionAction, setMapSubmissionAction] = useState(null);
  const isDa = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "CITIZEN";
  const inspectionReportChecklist = useSelector(state => state.inspectionReportChecklist);
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.inspectionReportData);
  const userRoles = user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : (_user$info2$roles = _user$info2.roles) === null || _user$info2$roles === void 0 ? void 0 : _user$info2$roles.map(e => e.code);
  console.log("reduxFormData", reduxFormData, "formData", formData, "inspectionReportChecklist", inspectionReportChecklist, "user", user);
  const isNocModule = urlFormType === "NOC";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, isNocModule ? "NOC" : false);
  const userRolesWithoutEMP = user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : _user$info3.roles.filter(user => user.code != "EMPLOYEE");
  const drawingPdfs = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => ["drawingPdf"].includes(doc.documentType));
  const Modal = useModal();
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const isMapSubmission = appType === "FORM_MAP";
  const isCompletionPortal = appType === "FORM_COMPLETION";
  const isPlinthSubmission = appType === "FORM_PLINTH";
  const isPurchasbleFAR = appType === "FORM_PURCHASABLE_FAR";
  const isCompounding = appType === "FORM_COMPOUNDING";
  const [initialUrl, setInitialUrl] = useState("");
  const documentSection = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(doc => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType));
  const fetchInitialUrl = async fileStoreId => {
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    setIframeSrc(response.data.fileStoreIds[0].url);
  };
  const fetchInitialPdfUrl = async fileStoreId => {
    var _response$data, _response$data$fileSt, _response$data$fileSt2, _response$data2, _response$data2$fileS, _response$data2$fileS2;
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    console.log("responseFromFileStore", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$fileSt = _response$data.fileStoreIds) === null || _response$data$fileSt === void 0 ? void 0 : (_response$data$fileSt2 = _response$data$fileSt[0]) === null || _response$data$fileSt2 === void 0 ? void 0 : _response$data$fileSt2.url);
    setPdfIframeSrc(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$fileS = _response$data2.fileStoreIds) === null || _response$data2$fileS === void 0 ? void 0 : (_response$data2$fileS2 = _response$data2$fileS[0]) === null || _response$data2$fileS2 === void 0 ? void 0 : _response$data2$fileS2.url);
  };
  const checkIsBpaNoc = val => {
    if (!val) return false;
    if (typeof val === "string") return val.toUpperCase().includes("BPA_NOC_");
    if (Array.isArray(val)) return val.some(item => checkIsBpaNoc(item));
    if (typeof val === "object") return checkIsBpaNoc((val === null || val === void 0 ? void 0 : val.businessService) || (val === null || val === void 0 ? void 0 : val.applicationBusinessService));
    return false;
  };
  const isBpaNoc = Boolean(checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.applicationBusinessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.processInstances) || checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.nocList) || checkIsBpaNoc(urlFormType) || checkIsBpaNoc(userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode));
  const getValidityOfEmp = () => {
    var _formData$assignes;
    if (isBpaNoc) {
      return true;
    }
    if ((formData === null || formData === void 0 ? void 0 : (_formData$assignes = formData.assignes) === null || _formData$assignes === void 0 ? void 0 : _formData$assignes.length) > 0) {
      var _formData$assignes2, _formData$assignes2$, _formData$assignes3, _formData$assignes3$;
      console.log("loggingValidityOfEmp", (formData === null || formData === void 0 ? void 0 : (_formData$assignes2 = formData.assignes) === null || _formData$assignes2 === void 0 ? void 0 : (_formData$assignes2$ = _formData$assignes2[0]) === null || _formData$assignes2$ === void 0 ? void 0 : _formData$assignes2$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid));
      return (formData === null || formData === void 0 ? void 0 : (_formData$assignes3 = formData.assignes) === null || _formData$assignes3 === void 0 ? void 0 : (_formData$assignes3$ = _formData$assignes3[0]) === null || _formData$assignes3$ === void 0 ? void 0 : _formData$assignes3$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid);
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  const currentFormData = formData === null || formData === void 0 ? void 0 : (_formData$nocList = formData.nocList) === null || _formData$nocList === void 0 ? void 0 : _formData$nocList.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode));
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_MAPSUB", formData);
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.applicationNo) {
      var _formData$additionalD;
      if (params !== null && params !== void 0 && params.applicationNo && params.applicationNo !== formData.applicationNo) {
        setParams(formData);
      } else if ((formData !== null && formData !== void 0 && formData.nocDetails || formData !== null && formData !== void 0 && (_formData$additionalD = formData.additionalDetails) !== null && _formData$additionalD !== void 0 && _formData$additionalD.nocDetails) && !(params !== null && params !== void 0 && params.nocDetails)) {
        var _formData$additionalD2;
        setParams({
          ...(params || {}),
          nocDetails: (formData === null || formData === void 0 ? void 0 : formData.nocDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.nocDetails)
        });
      }
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo, formData === null || formData === void 0 ? void 0 : formData.nocDetails, formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.nocDetails]);
  const firstDefined = (...args) => {
    for (const arg of args) {
      if (arg !== null && arg !== undefined && arg !== "") return arg;
    }
    return undefined;
  };
  const getLocalStoragePressDetails = applicationNo => {
    try {
      let raw = null;
      if (applicationNo) {
        raw = localStorage.getItem(`INVITATION_SUGGESTION_${applicationNo}`);
      }
      if (!raw) {
        raw = localStorage.getItem("INVITATION_SUGGESTION_LATEST");
      }
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === "object") {
          return parsed;
        }
      }
    } catch (e) {
      console.error("Error reading pressReleaseDetails from localStorage:", e);
    }
    return null;
  };
  const attachPressDetails = (targetObj = {}, customParams = null) => {
    var _targetObj$additional, _currentParams$additi, _formData$additionalD4, _targetObj$pressRelea, _currentParams$pressR, _formData$pressReleas, _targetObj$pressDetai, _currentParams$pressD, _formData$pressDetail, _targetObj$additional2, _targetObj$additional3, _currentParams$additi2, _currentParams$additi3, _formData$additionalD5, _formData$additionalD6, _targetObj$additional4, _currentParams$additi4, _formData$additionalD7, _targetObj$pressRelea2, _currentParams$pressR2, _formData$pressReleas2, _targetObj$pressDetai2, _currentParams$pressD2, _formData$pressDetail2, _targetObj$additional5, _targetObj$additional6, _currentParams$additi5, _currentParams$additi6, _formData$additionalD8, _formData$additionalD9, _targetObj$additional7, _currentParams$additi7, _formData$additionalD10, _targetObj$pressRelea3, _currentParams$pressR3, _formData$pressReleas3, _targetObj$pressDetai3, _currentParams$pressD3, _formData$pressDetail3, _targetObj$additional8, _targetObj$additional9, _currentParams$additi8, _currentParams$additi9, _formData$additionalD11, _formData$additionalD12;
    const appNo = (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (params === null || params === void 0 ? void 0 : params.applicationNo) || (targetObj === null || targetObj === void 0 ? void 0 : targetObj.applicationNo);
    const localPress = getLocalStoragePressDetails(appNo);
    const currentParams = customParams || params || {};
    const hasSuggestion = firstDefined(targetObj === null || targetObj === void 0 ? void 0 : targetObj.hasSuggestion, currentParams === null || currentParams === void 0 ? void 0 : currentParams.hasSuggestion, formData === null || formData === void 0 ? void 0 : formData.hasSuggestion, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional = targetObj.additionalDetails) === null || _targetObj$additional === void 0 ? void 0 : _targetObj$additional.hasSuggestion, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi = currentParams.additionalDetails) === null || _currentParams$additi === void 0 ? void 0 : _currentParams$additi.hasSuggestion, formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.hasSuggestion, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressRelea = targetObj.pressReleaseDetails) === null || _targetObj$pressRelea === void 0 ? void 0 : _targetObj$pressRelea.hasSuggestion, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressR = currentParams.pressReleaseDetails) === null || _currentParams$pressR === void 0 ? void 0 : _currentParams$pressR.hasSuggestion, formData === null || formData === void 0 ? void 0 : (_formData$pressReleas = formData.pressReleaseDetails) === null || _formData$pressReleas === void 0 ? void 0 : _formData$pressReleas.hasSuggestion, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressDetai = targetObj.pressDetails) === null || _targetObj$pressDetai === void 0 ? void 0 : _targetObj$pressDetai.hasSuggestion, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressD = currentParams.pressDetails) === null || _currentParams$pressD === void 0 ? void 0 : _currentParams$pressD.hasSuggestion, formData === null || formData === void 0 ? void 0 : (_formData$pressDetail = formData.pressDetails) === null || _formData$pressDetail === void 0 ? void 0 : _formData$pressDetail.hasSuggestion, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional2 = targetObj.additionalDetails) === null || _targetObj$additional2 === void 0 ? void 0 : (_targetObj$additional3 = _targetObj$additional2.pressReleaseDetails) === null || _targetObj$additional3 === void 0 ? void 0 : _targetObj$additional3.hasSuggestion, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi2 = currentParams.additionalDetails) === null || _currentParams$additi2 === void 0 ? void 0 : (_currentParams$additi3 = _currentParams$additi2.pressReleaseDetails) === null || _currentParams$additi3 === void 0 ? void 0 : _currentParams$additi3.hasSuggestion, formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : (_formData$additionalD6 = _formData$additionalD5.pressReleaseDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.hasSuggestion, localPress === null || localPress === void 0 ? void 0 : localPress.hasSuggestion);
    const pressReleaseFee = firstDefined(targetObj === null || targetObj === void 0 ? void 0 : targetObj.pressReleaseFee, currentParams === null || currentParams === void 0 ? void 0 : currentParams.pressReleaseFee, formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional4 = targetObj.additionalDetails) === null || _targetObj$additional4 === void 0 ? void 0 : _targetObj$additional4.pressReleaseFee, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi4 = currentParams.additionalDetails) === null || _currentParams$additi4 === void 0 ? void 0 : _currentParams$additi4.pressReleaseFee, formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.pressReleaseFee, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressRelea2 = targetObj.pressReleaseDetails) === null || _targetObj$pressRelea2 === void 0 ? void 0 : _targetObj$pressRelea2.pressReleaseFee, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressR2 = currentParams.pressReleaseDetails) === null || _currentParams$pressR2 === void 0 ? void 0 : _currentParams$pressR2.pressReleaseFee, formData === null || formData === void 0 ? void 0 : (_formData$pressReleas2 = formData.pressReleaseDetails) === null || _formData$pressReleas2 === void 0 ? void 0 : _formData$pressReleas2.pressReleaseFee, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressDetai2 = targetObj.pressDetails) === null || _targetObj$pressDetai2 === void 0 ? void 0 : _targetObj$pressDetai2.pressReleaseFee, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressD2 = currentParams.pressDetails) === null || _currentParams$pressD2 === void 0 ? void 0 : _currentParams$pressD2.pressReleaseFee, formData === null || formData === void 0 ? void 0 : (_formData$pressDetail2 = formData.pressDetails) === null || _formData$pressDetail2 === void 0 ? void 0 : _formData$pressDetail2.pressReleaseFee, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional5 = targetObj.additionalDetails) === null || _targetObj$additional5 === void 0 ? void 0 : (_targetObj$additional6 = _targetObj$additional5.pressReleaseDetails) === null || _targetObj$additional6 === void 0 ? void 0 : _targetObj$additional6.pressReleaseFee, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi5 = currentParams.additionalDetails) === null || _currentParams$additi5 === void 0 ? void 0 : (_currentParams$additi6 = _currentParams$additi5.pressReleaseDetails) === null || _currentParams$additi6 === void 0 ? void 0 : _currentParams$additi6.pressReleaseFee, formData === null || formData === void 0 ? void 0 : (_formData$additionalD8 = formData.additionalDetails) === null || _formData$additionalD8 === void 0 ? void 0 : (_formData$additionalD9 = _formData$additionalD8.pressReleaseDetails) === null || _formData$additionalD9 === void 0 ? void 0 : _formData$additionalD9.pressReleaseFee, localPress === null || localPress === void 0 ? void 0 : localPress.pressReleaseFee);
    const invitationRemark = firstDefined(targetObj === null || targetObj === void 0 ? void 0 : targetObj.invitationRemark, currentParams === null || currentParams === void 0 ? void 0 : currentParams.invitationRemark, formData === null || formData === void 0 ? void 0 : formData.invitationRemark, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional7 = targetObj.additionalDetails) === null || _targetObj$additional7 === void 0 ? void 0 : _targetObj$additional7.invitationRemark, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi7 = currentParams.additionalDetails) === null || _currentParams$additi7 === void 0 ? void 0 : _currentParams$additi7.invitationRemark, formData === null || formData === void 0 ? void 0 : (_formData$additionalD10 = formData.additionalDetails) === null || _formData$additionalD10 === void 0 ? void 0 : _formData$additionalD10.invitationRemark, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressRelea3 = targetObj.pressReleaseDetails) === null || _targetObj$pressRelea3 === void 0 ? void 0 : _targetObj$pressRelea3.invitationRemark, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressR3 = currentParams.pressReleaseDetails) === null || _currentParams$pressR3 === void 0 ? void 0 : _currentParams$pressR3.invitationRemark, formData === null || formData === void 0 ? void 0 : (_formData$pressReleas3 = formData.pressReleaseDetails) === null || _formData$pressReleas3 === void 0 ? void 0 : _formData$pressReleas3.invitationRemark, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$pressDetai3 = targetObj.pressDetails) === null || _targetObj$pressDetai3 === void 0 ? void 0 : _targetObj$pressDetai3.invitationRemark, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$pressD3 = currentParams.pressDetails) === null || _currentParams$pressD3 === void 0 ? void 0 : _currentParams$pressD3.invitationRemark, formData === null || formData === void 0 ? void 0 : (_formData$pressDetail3 = formData.pressDetails) === null || _formData$pressDetail3 === void 0 ? void 0 : _formData$pressDetail3.invitationRemark, targetObj === null || targetObj === void 0 ? void 0 : (_targetObj$additional8 = targetObj.additionalDetails) === null || _targetObj$additional8 === void 0 ? void 0 : (_targetObj$additional9 = _targetObj$additional8.pressReleaseDetails) === null || _targetObj$additional9 === void 0 ? void 0 : _targetObj$additional9.invitationRemark, currentParams === null || currentParams === void 0 ? void 0 : (_currentParams$additi8 = currentParams.additionalDetails) === null || _currentParams$additi8 === void 0 ? void 0 : (_currentParams$additi9 = _currentParams$additi8.pressReleaseDetails) === null || _currentParams$additi9 === void 0 ? void 0 : _currentParams$additi9.invitationRemark, formData === null || formData === void 0 ? void 0 : (_formData$additionalD11 = formData.additionalDetails) === null || _formData$additionalD11 === void 0 ? void 0 : (_formData$additionalD12 = _formData$additionalD11.pressReleaseDetails) === null || _formData$additionalD12 === void 0 ? void 0 : _formData$additionalD12.invitationRemark, localPress === null || localPress === void 0 ? void 0 : localPress.invitationRemark);
    const _getPressObj = src => {
      var _src$additionalDetail, _src$additionalDetail2;
      return (src === null || src === void 0 ? void 0 : src.pressReleaseDetails) || (src === null || src === void 0 ? void 0 : src.pressDetails) || (src === null || src === void 0 ? void 0 : (_src$additionalDetail = src.additionalDetails) === null || _src$additionalDetail === void 0 ? void 0 : _src$additionalDetail.pressReleaseDetails) || (src === null || src === void 0 ? void 0 : (_src$additionalDetail2 = src.additionalDetails) === null || _src$additionalDetail2 === void 0 ? void 0 : _src$additionalDetail2.pressDetails);
    };
    const existingPress = _getPressObj(targetObj) || _getPressObj(currentParams) || _getPressObj(formData) || localPress || {};
    const effectiveFee = hasSuggestion === "yes" ? pressReleaseFee !== undefined && pressReleaseFee !== null ? pressReleaseFee : "" : "";
    const pressDetails = {
      ...existingPress,
      ...(hasSuggestion !== undefined && {
        hasSuggestion
      }),
      ...(hasSuggestion !== undefined && {
        pressReleaseFee: effectiveFee
      }),
      ...(invitationRemark !== undefined && {
        invitationRemark
      })
    };
    const hasAnyPress = hasSuggestion !== undefined || pressReleaseFee !== undefined || invitationRemark !== undefined || Object.keys(existingPress).length > 0;
    return {
      ...targetObj,
      ...(hasSuggestion !== undefined && {
        hasSuggestion
      }),
      ...(hasSuggestion !== undefined && {
        pressReleaseFee: effectiveFee
      }),
      ...(invitationRemark !== undefined && {
        invitationRemark
      }),
      ...(hasAnyPress && {
        pressDetails,
        pressReleaseDetails: pressDetails
      }),
      additionalDetails: {
        ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
        ...((currentParams === null || currentParams === void 0 ? void 0 : currentParams.additionalDetails) || {}),
        ...((targetObj === null || targetObj === void 0 ? void 0 : targetObj.additionalDetails) || {}),
        ...(hasSuggestion !== undefined && {
          hasSuggestion
        }),
        ...(hasSuggestion !== undefined && {
          pressReleaseFee: effectiveFee
        }),
        ...(invitationRemark !== undefined && {
          invitationRemark
        }),
        ...(hasAnyPress && {
          pressDetails,
          pressReleaseDetails: pressDetails
        }),
        ...(targetObj !== null && targetObj !== void 0 && targetObj.nocDetails ? {
          nocDetails: targetObj.nocDetails
        } : currentParams !== null && currentParams !== void 0 && currentParams.nocDetails ? {
          nocDetails: currentParams.nocDetails
        } : formData !== null && formData !== void 0 && formData.nocDetails ? {
          nocDetails: formData.nocDetails
        } : {})
      }
    };
  };
  const mergePressFromResponse = (submittedData, responseBpa) => {
    var _returnedBPA$addition, _returnedBPA$addition2, _returnedBPA$addition3, _returnedBPA$addition4, _returnedBPA$addition5, _returnedBPA$addition6, _returnedBPA$addition7, _returnedBPA$addition8;
    const returnedBPA = responseBpa || {};
    const pick = (a, b, fallback) => a && a !== "" ? a : b && b !== "" ? b : fallback;
    const withPress = attachPressDetails(submittedData);
    const returnedPress = (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition = returnedBPA.additionalDetails) === null || _returnedBPA$addition === void 0 ? void 0 : _returnedBPA$addition.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition2 = returnedBPA.additionalDetails) === null || _returnedBPA$addition2 === void 0 ? void 0 : _returnedBPA$addition2.pressDetails);
    const mergedPress = returnedPress !== null && returnedPress !== void 0 && returnedPress.hasSuggestion ? {
      ...withPress.pressDetails,
      ...returnedPress
    } : withPress.pressDetails;
    return {
      ...withPress,
      ...returnedBPA,
      hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition3 = returnedBPA.additionalDetails) === null || _returnedBPA$addition3 === void 0 ? void 0 : _returnedBPA$addition3.hasSuggestion, withPress.hasSuggestion),
      pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition4 = returnedBPA.additionalDetails) === null || _returnedBPA$addition4 === void 0 ? void 0 : _returnedBPA$addition4.pressReleaseFee, withPress.pressReleaseFee),
      invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition5 = returnedBPA.additionalDetails) === null || _returnedBPA$addition5 === void 0 ? void 0 : _returnedBPA$addition5.invitationRemark, withPress.invitationRemark),
      pressDetails: mergedPress,
      pressReleaseDetails: mergedPress,
      additionalDetails: {
        ...((withPress === null || withPress === void 0 ? void 0 : withPress.additionalDetails) || {}),
        ...((returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.additionalDetails) || {}),
        hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition6 = returnedBPA.additionalDetails) === null || _returnedBPA$addition6 === void 0 ? void 0 : _returnedBPA$addition6.hasSuggestion, withPress.hasSuggestion),
        pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition7 = returnedBPA.additionalDetails) === null || _returnedBPA$addition7 === void 0 ? void 0 : _returnedBPA$addition7.pressReleaseFee, withPress.pressReleaseFee),
        invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition8 = returnedBPA.additionalDetails) === null || _returnedBPA$addition8 === void 0 ? void 0 : _returnedBPA$addition8.invitationRemark, withPress.invitationRemark),
        pressDetails: mergedPress,
        pressReleaseDetails: mergedPress
      }
    };
  };
  useEffect(() => {
    var _formData$documents3, _formData$nocDetails, _Object$values, _formData$nocDetails2, _formData$nocDetails3, _formData$nocDetails4, _formData$inspectionD, _formData$inspectionD2, _formData$inspectionD3, _formData$inspectionD4, _formData$inspectionD5, _formData$inspectionD6, _formData$inspectionD7, _formData$inspectionD8, _formData$inspectionD9, _formData$inspectionD10, _documentSection$;
    const isDocValidated = formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : _formData$documents3.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).every(item => !item.isMandatory || item.documentRemarks !== null);
    const isNocValidated = (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.officerNOCData) && ((_Object$values = Object.values(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.officerNOCData)) === null || _Object$values === void 0 ? void 0 : _Object$values.some(Boolean)) || (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : (_formData$nocDetails4 = _formData$nocDetails3.additionalOfficerNOCData) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.length) > 0;
    console.log("isValidationsss", {
      isDocValidated,
      isNocValidated
    });
    console.log("formData?.inspectionDetail?.[0]?.inspectionReportData?.documentInspection", formData === null || formData === void 0 ? void 0 : (_formData$inspectionD = formData.inspectionDetail) === null || _formData$inspectionD === void 0 ? void 0 : (_formData$inspectionD2 = _formData$inspectionD[0]) === null || _formData$inspectionD2 === void 0 ? void 0 : (_formData$inspectionD3 = _formData$inspectionD2.inspectionReportData) === null || _formData$inspectionD3 === void 0 ? void 0 : _formData$inspectionD3.documentInspection);
    console.log("FORMDATA FOUND", formData);
    const isSitePhotoUploadedValidated = (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD4 = formData.inspectionDetail) === null || _formData$inspectionD4 === void 0 ? void 0 : (_formData$inspectionD5 = _formData$inspectionD4[0]) === null || _formData$inspectionD5 === void 0 ? void 0 : (_formData$inspectionD6 = _formData$inspectionD5.inspectionReportData) === null || _formData$inspectionD6 === void 0 ? void 0 : (_formData$inspectionD7 = _formData$inspectionD6.documentInspection) === null || _formData$inspectionD7 === void 0 ? void 0 : _formData$inspectionD7.length) > 0 || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD8 = formData.inspectionDetailData) === null || _formData$inspectionD8 === void 0 ? void 0 : (_formData$inspectionD9 = _formData$inspectionD8.inspectionReportData) === null || _formData$inspectionD9 === void 0 ? void 0 : (_formData$inspectionD10 = _formData$inspectionD9.documentInspection) === null || _formData$inspectionD10 === void 0 ? void 0 : _formData$inspectionD10.length) > 0;
    if (isDocValidated) {
      var _Digit;
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.set("isDocValidated", isDocValidated);
    }
    if (isNocValidated) {
      var _Digit2;
      (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("isNocValidates", isNocValidated);
    }
    const isRoleChecking = isJE || isAVPandEE;
    const isSitePhotoValid = isRoleChecking ? isSitePhotoUploadedValidated : true;
    console.log("isSitePhotoUploadedValidated", isSitePhotoUploadedValidated, "isRoleChecking", isRoleChecking, "isSitePhotoValid", isSitePhotoValid);
    if (isSitePhotoValid) {
      var _Digit3;
      (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.set("isSitePhotoUploaded", isSitePhotoUploadedValidated);
    }
    fetchInitialUrl(documentSection === null || documentSection === void 0 ? void 0 : (_documentSection$ = documentSection[0]) === null || _documentSection$ === void 0 ? void 0 : _documentSection$.fileStoreId);
    if (drawingPdfs) {
      var _drawingPdfs$;
      fetchInitialPdfUrl(drawingPdfs === null || drawingPdfs === void 0 ? void 0 : (_drawingPdfs$ = drawingPdfs[0]) === null || _drawingPdfs$ === void 0 ? void 0 : _drawingPdfs$.fileStoreId);
    }
  }, []);
  const handleDocView = () => {
    setCurrentView(prev => prev === "documents" ? "viewDocuments" : "documents");
  };
  const isSelfApproval = ((formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP") && ["APPROVED", "APPROVED_JE"].includes(formData === null || formData === void 0 ? void 0 : formData.status);
  const handleNoWorkflow = updatedDocuments => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const mergedDocs = mergeDocumentsWithSitePhotos(updatedDocuments, [params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
    const appData = attachPressDetails({
      ...formData,
      ...(params || {}),
      workflow,
      documents: mergedDocs
    });
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA, _updatedBPA$documents, _Digit4;
        console.log("resultFromUpdate", result);
        const updatedBPA = mergePressFromResponse(appData, result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        if (updatedBPA) {
          updatedBPA.documents = mergeDocumentsWithSitePhotos((updatedBPA === null || updatedBPA === void 0 ? void 0 : updatedBPA.documents) || mergedDocs, [mergedDocs, params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
        }
        onSelect("", updatedBPA);
        const isDocValidated = updatedBPA === null || updatedBPA === void 0 ? void 0 : (_updatedBPA$documents = updatedBPA.documents) === null || _updatedBPA$documents === void 0 ? void 0 : _updatedBPA$documents.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).every(item => !item.isMandatory || item.documentRemarks !== null);
        (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.set("isDocValidated", isDocValidated);
      },
      onError: err => {
        console.log("Error1", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleNoWorkflowNoc = (nocDetails, setLoading) => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const mergedDocs = mergeDocumentsWithSitePhotos((params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents), [formData === null || formData === void 0 ? void 0 : formData.documents, params === null || params === void 0 ? void 0 : params.documents]);
    const appData = attachPressDetails({
      ...formData,
      ...(params || {}),
      workflow,
      documents: mergedDocs,
      nocDetails: nocDetails,
      additionalDetails: {
        ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
        ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {}),
        nocDetails: nocDetails
      }
    });
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA2, _Digit5;
        console.log("resultFromUpdate", result);
        const updatedBPA = mergePressFromResponse(appData, result === null || result === void 0 ? void 0 : (_result$BPA2 = result.BPA) === null || _result$BPA2 === void 0 ? void 0 : _result$BPA2[0]);
        if (updatedBPA) {
          updatedBPA.documents = mergeDocumentsWithSitePhotos((updatedBPA === null || updatedBPA === void 0 ? void 0 : updatedBPA.documents) || mergedDocs, [mergedDocs, params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
          updatedBPA.nocDetails = nocDetails;
          if (updatedBPA.additionalDetails) {
            updatedBPA.additionalDetails.nocDetails = nocDetails;
          }
        }
        onSelect("", updatedBPA);
        setLoading(false);
        (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set("isNocValidated", true);
        Modal(`NOC details updated`, `NOC details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      },
      onError: err => {
        console.log("ERRRO2", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleNoWorkflowPFAR = pfarDetails => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const mergedDocs = mergeDocumentsWithSitePhotos((params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents), [formData === null || formData === void 0 ? void 0 : formData.documents, params === null || params === void 0 ? void 0 : params.documents]);
    const appData = attachPressDetails({
      ...formData,
      ...(params || {}),
      ...pfarDetails,
      workflow,
      documents: mergedDocs
    });
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA3;
        console.log("resultFromUpdate", result);
        const updatedBPA = mergePressFromResponse(appData, result === null || result === void 0 ? void 0 : (_result$BPA3 = result.BPA) === null || _result$BPA3 === void 0 ? void 0 : _result$BPA3[0]);
        if (updatedBPA) {
          updatedBPA.documents = mergeDocumentsWithSitePhotos((updatedBPA === null || updatedBPA === void 0 ? void 0 : updatedBPA.documents) || mergedDocs, [mergedDocs, params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
        }
        onSelect("", updatedBPA);
        if (typeof refetch === "function") {
          console.log("refetchoccured");
          refetch();
        }
        Modal(`PFAR details updated`, `PFAR details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      },
      onError: err => {
        console.log("Error3", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleCompletionChecklistSave = async (nextTabNo, customFormData = null) => {
    if (customFormData) {
      const mergedDocs = mergeDocumentsWithSitePhotos((customFormData === null || customFormData === void 0 ? void 0 : customFormData.documents) || (params === null || params === void 0 ? void 0 : params.documents), [params === null || params === void 0 ? void 0 : params.documents, customFormData === null || customFormData === void 0 ? void 0 : customFormData.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
      const mergedInput = {
        ...params,
        ...customFormData,
        documents: mergedDocs
      };
      console.log("formDataOnTabChange", customFormData, nextTabNo);
      try {
        const data = attachPressDetails({
          ...formData,
          ...mergedInput,
          workflow: {
            action: "NOWORKFLOW",
            comments: ""
          },
          documents: mergedDocs
        }, mergedInput);
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: result => {
            var _result$BPA4;
            const updatedBPA = mergePressFromResponse(data, result === null || result === void 0 ? void 0 : (_result$BPA4 = result.BPA) === null || _result$BPA4 === void 0 ? void 0 : _result$BPA4[0]);
            if (updatedBPA) {
              updatedBPA.documents = mergeDocumentsWithSitePhotos((updatedBPA === null || updatedBPA === void 0 ? void 0 : updatedBPA.documents) || mergedDocs, [mergedDocs, params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
            }
            onSelect("", updatedBPA);
            Modal((customFormData === null || customFormData === void 0 ? void 0 : customFormData.modalTitle) || "Remarks Added", (customFormData === null || customFormData === void 0 ? void 0 : customFormData.modalMessage) || `Remarks Added Successfully !`, "success");
          },
          onError: err => {
            console.log("Error4", err);
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
  };
  const handleAdditionalComment = () => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const mergedDocs = mergeDocumentsWithSitePhotos((params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents), [formData === null || formData === void 0 ? void 0 : formData.documents, params === null || params === void 0 ? void 0 : params.documents]);
    const appData = attachPressDetails({
      ...formData,
      ...(params || {}),
      workflow,
      documents: mergedDocs,
      additionalComment: additionalComment,
      mapSubDetails: {
        ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
        ...(params === null || params === void 0 ? void 0 : params.mapSubDetails),
        formattedAdditionalComment: additionalComment
      }
    });
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA5;
        console.log("resultFromUpdate1212123", result);
        const updatedBPA = mergePressFromResponse(appData, result === null || result === void 0 ? void 0 : (_result$BPA5 = result.BPA) === null || _result$BPA5 === void 0 ? void 0 : _result$BPA5[0]);
        if (updatedBPA) {
          updatedBPA.documents = mergeDocumentsWithSitePhotos((updatedBPA === null || updatedBPA === void 0 ? void 0 : updatedBPA.documents) || mergedDocs, [mergedDocs, params === null || params === void 0 ? void 0 : params.documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
        }
        Modal("Additional Comment Added", "Additional Comment Added Successfully !", "success");
        onSelect("", updatedBPA);
      },
      onError: err => {
        console.log("Error21", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  const stripHtmlTags = html => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result));
    return String(result);
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code) === "JE";
  const isAVPandEE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code) === "EE" && (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP";
  console.log(reduxFormData, inspectionReportChecklist === null || inspectionReportChecklist === void 0 ? void 0 : inspectionReportChecklist.inspectionReportData, "logging111111111111", developerRemarks);
  let schemeType = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType;
  let landArea = formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.landArea;
  let primaryUse = formData === null || formData === void 0 ? void 0 : formData.primaryUse;
  let isResidential = primaryUse === "Residential";
  let isCommercial = primaryUse === "Commercial";
  let isScheme = schemeType === "Scheme";
  let isUnapproved = schemeType !== "Scheme";
  console.log({
    isResidential,
    isCommercial,
    isScheme,
    isUnapproved,
    userRoles,
    landArea
  }, workflowDetails, "loggingConditions");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.nextActions) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.filter(e => {
    var _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9;
    const previousAction = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.actionState) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.timeline) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8[0]) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.performedAction;
    console.log("previousAction1", previousAction, workflowDetails);
    if (!isPurchasbleReq) {
      return e.action !== "HOLD_AT_JE";
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  console.log("filteredActions2", actions, formData);
  if (!Array.isArray(actions)) {
    actions = [];
  }
  if (isSelfApproval && (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED") {
    const hasReject = actions.some(a => a.action === "Reject");
    if (!hasReject) {
      actions = [...actions, {
        action: "Reject",
        roles: ""
      }];
    }
  }
  console.log("actionsfromuseempmapsubmission", actions);
  let tabList = [{
    label: "Application Data",
    color: "red"
  }, {
    label: "Documents",
    color: "red"
  }, {
    label: "Drawings",
    color: "red"
  }, {
    label: "Site Inspection",
    color: "green"
  }, !isDa && !isEE || isDa ? {
    label: "Payment Heads",
    color: "red"
  } : null, {
    label: "WF_TAKE_ACTION",
    color: "red"
  }, {
    label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS",
    color: "green"
  }, {
    label: "ChatBoard",
    color: "green"
  }, {
    label: "Letter",
    color: "green"
  }].filter(Boolean);
  const moduleHandlers = {
    NOC: context => {
      var _context$userDetails, _context$formData, _context$formData$noc, _context$mapSubmissio;
      const currentNOCDept = (_context$userDetails = context.userDetails) === null || _context$userDetails === void 0 ? void 0 : _context$userDetails.organisationCode;
      const nocPayload = (_context$formData = context.formData) === null || _context$formData === void 0 ? void 0 : (_context$formData$noc = _context$formData.nocList) === null || _context$formData$noc === void 0 ? void 0 : _context$formData$noc.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === currentNOCDept);
      return {
        Noc: {
          ...nocPayload,
          workflow: {
            action: (_context$mapSubmissio = context.mapSubmissionAction) === null || _context$mapSubmissio === void 0 ? void 0 : _context$mapSubmissio.action,
            comment: context.remarks
          }
        }
      };
    },
    BPA: context => {
      var _context$formData2, _context$params, _context$params2, _context$formData3, _context$params3, _context$params3$addi, _context$formData4, _context$formData4$ad, _context$params4, _context$params4$pres, _context$formData5, _context$formData5$pr, _context$params5, _context$params5$pres, _context$formData6, _context$formData6$pr, _context$params6, _context$params6$addi, _context$params6$addi2, _context$formData7, _context$formData7$ad, _context$formData7$ad2, _context$params7, _context$params7$addi, _context$params7$addi2, _context$formData8, _context$formData8$ad, _context$formData8$ad2, _context$params8, _context$formData9, _context$params9, _context$params9$addi, _context$formData10, _context$formData10$a, _context$params10, _context$params10$pre, _context$formData11, _context$formData11$p, _context$params11, _context$params11$pre, _context$formData12, _context$formData12$p, _context$params12, _context$params12$add, _context$params12$add2, _context$formData13, _context$formData13$a, _context$formData13$a2, _context$params13, _context$params13$add, _context$params13$add2, _context$formData14, _context$formData14$a, _context$formData14$a2, _context$params14, _context$formData15, _context$params15, _context$params15$add, _context$formData16, _context$formData16$a, _context$params16, _context$params16$pre, _context$formData17, _context$formData17$p, _context$params17, _context$params17$pre, _context$formData18, _context$formData18$p, _context$params18, _context$params18$add, _context$params18$add2, _context$formData19, _context$formData19$a, _context$formData19$a2, _context$params19, _context$params19$add, _context$params19$add2, _context$formData20, _context$formData20$a, _context$formData20$a2, _context$formData21, _context$params20, _context$params21, _context$formData22, _context$params22, _context$params22$add, _context$formData23, _context$formData23$a, _context$params23, _context$formData24, _context$mapSubmissio2, _context$params24, _context$formData25, _context$params25, _context$formData26, _context$params26, _context$formData27, _context$userRolesArr, _context$userRolesArr2, _context$formData28, _context$params27, _context$params28, _context$formData29;
      console.log("actionsFARAyush", context);
      const storedFileStoreId = localStorage.getItem("wf_verification_doc");
      console.log("[DEBUG] uploadedFile from localStorage:", storedFileStoreId);
      const varificationDocuments = storedFileStoreId ? [{
        documentType: "verifactionDocument",
        fileStoreId: storedFileStoreId
      }] : null;
      const customApprovalFileStore = localStorage.getItem("custom_approval_letter");
      const customApprovalDocs = customApprovalFileStore ? [{
        documentType: "customapprovalletter",
        fileStoreId: customApprovalFileStore
      }] : [];
      const appNo = ((_context$formData2 = context.formData) === null || _context$formData2 === void 0 ? void 0 : _context$formData2.applicationNo) || ((_context$params = context.params) === null || _context$params === void 0 ? void 0 : _context$params.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      const localPress = getLocalStoragePressDetails(appNo);
      const hasSuggestion = firstDefined((_context$params2 = context.params) === null || _context$params2 === void 0 ? void 0 : _context$params2.hasSuggestion, (_context$formData3 = context.formData) === null || _context$formData3 === void 0 ? void 0 : _context$formData3.hasSuggestion, (_context$params3 = context.params) === null || _context$params3 === void 0 ? void 0 : (_context$params3$addi = _context$params3.additionalDetails) === null || _context$params3$addi === void 0 ? void 0 : _context$params3$addi.hasSuggestion, (_context$formData4 = context.formData) === null || _context$formData4 === void 0 ? void 0 : (_context$formData4$ad = _context$formData4.additionalDetails) === null || _context$formData4$ad === void 0 ? void 0 : _context$formData4$ad.hasSuggestion, (_context$params4 = context.params) === null || _context$params4 === void 0 ? void 0 : (_context$params4$pres = _context$params4.pressReleaseDetails) === null || _context$params4$pres === void 0 ? void 0 : _context$params4$pres.hasSuggestion, (_context$formData5 = context.formData) === null || _context$formData5 === void 0 ? void 0 : (_context$formData5$pr = _context$formData5.pressReleaseDetails) === null || _context$formData5$pr === void 0 ? void 0 : _context$formData5$pr.hasSuggestion, (_context$params5 = context.params) === null || _context$params5 === void 0 ? void 0 : (_context$params5$pres = _context$params5.pressDetails) === null || _context$params5$pres === void 0 ? void 0 : _context$params5$pres.hasSuggestion, (_context$formData6 = context.formData) === null || _context$formData6 === void 0 ? void 0 : (_context$formData6$pr = _context$formData6.pressDetails) === null || _context$formData6$pr === void 0 ? void 0 : _context$formData6$pr.hasSuggestion, (_context$params6 = context.params) === null || _context$params6 === void 0 ? void 0 : (_context$params6$addi = _context$params6.additionalDetails) === null || _context$params6$addi === void 0 ? void 0 : (_context$params6$addi2 = _context$params6$addi.pressReleaseDetails) === null || _context$params6$addi2 === void 0 ? void 0 : _context$params6$addi2.hasSuggestion, (_context$formData7 = context.formData) === null || _context$formData7 === void 0 ? void 0 : (_context$formData7$ad = _context$formData7.additionalDetails) === null || _context$formData7$ad === void 0 ? void 0 : (_context$formData7$ad2 = _context$formData7$ad.pressReleaseDetails) === null || _context$formData7$ad2 === void 0 ? void 0 : _context$formData7$ad2.hasSuggestion, (_context$params7 = context.params) === null || _context$params7 === void 0 ? void 0 : (_context$params7$addi = _context$params7.additionalDetails) === null || _context$params7$addi === void 0 ? void 0 : (_context$params7$addi2 = _context$params7$addi.pressDetails) === null || _context$params7$addi2 === void 0 ? void 0 : _context$params7$addi2.hasSuggestion, (_context$formData8 = context.formData) === null || _context$formData8 === void 0 ? void 0 : (_context$formData8$ad = _context$formData8.additionalDetails) === null || _context$formData8$ad === void 0 ? void 0 : (_context$formData8$ad2 = _context$formData8$ad.pressDetails) === null || _context$formData8$ad2 === void 0 ? void 0 : _context$formData8$ad2.hasSuggestion, localPress === null || localPress === void 0 ? void 0 : localPress.hasSuggestion);
      const pressReleaseFee = firstDefined((_context$params8 = context.params) === null || _context$params8 === void 0 ? void 0 : _context$params8.pressReleaseFee, (_context$formData9 = context.formData) === null || _context$formData9 === void 0 ? void 0 : _context$formData9.pressReleaseFee, (_context$params9 = context.params) === null || _context$params9 === void 0 ? void 0 : (_context$params9$addi = _context$params9.additionalDetails) === null || _context$params9$addi === void 0 ? void 0 : _context$params9$addi.pressReleaseFee, (_context$formData10 = context.formData) === null || _context$formData10 === void 0 ? void 0 : (_context$formData10$a = _context$formData10.additionalDetails) === null || _context$formData10$a === void 0 ? void 0 : _context$formData10$a.pressReleaseFee, (_context$params10 = context.params) === null || _context$params10 === void 0 ? void 0 : (_context$params10$pre = _context$params10.pressReleaseDetails) === null || _context$params10$pre === void 0 ? void 0 : _context$params10$pre.pressReleaseFee, (_context$formData11 = context.formData) === null || _context$formData11 === void 0 ? void 0 : (_context$formData11$p = _context$formData11.pressReleaseDetails) === null || _context$formData11$p === void 0 ? void 0 : _context$formData11$p.pressReleaseFee, (_context$params11 = context.params) === null || _context$params11 === void 0 ? void 0 : (_context$params11$pre = _context$params11.pressDetails) === null || _context$params11$pre === void 0 ? void 0 : _context$params11$pre.pressReleaseFee, (_context$formData12 = context.formData) === null || _context$formData12 === void 0 ? void 0 : (_context$formData12$p = _context$formData12.pressDetails) === null || _context$formData12$p === void 0 ? void 0 : _context$formData12$p.pressReleaseFee, (_context$params12 = context.params) === null || _context$params12 === void 0 ? void 0 : (_context$params12$add = _context$params12.additionalDetails) === null || _context$params12$add === void 0 ? void 0 : (_context$params12$add2 = _context$params12$add.pressReleaseDetails) === null || _context$params12$add2 === void 0 ? void 0 : _context$params12$add2.pressReleaseFee, (_context$formData13 = context.formData) === null || _context$formData13 === void 0 ? void 0 : (_context$formData13$a = _context$formData13.additionalDetails) === null || _context$formData13$a === void 0 ? void 0 : (_context$formData13$a2 = _context$formData13$a.pressReleaseDetails) === null || _context$formData13$a2 === void 0 ? void 0 : _context$formData13$a2.pressReleaseFee, (_context$params13 = context.params) === null || _context$params13 === void 0 ? void 0 : (_context$params13$add = _context$params13.additionalDetails) === null || _context$params13$add === void 0 ? void 0 : (_context$params13$add2 = _context$params13$add.pressDetails) === null || _context$params13$add2 === void 0 ? void 0 : _context$params13$add2.pressReleaseFee, (_context$formData14 = context.formData) === null || _context$formData14 === void 0 ? void 0 : (_context$formData14$a = _context$formData14.additionalDetails) === null || _context$formData14$a === void 0 ? void 0 : (_context$formData14$a2 = _context$formData14$a.pressDetails) === null || _context$formData14$a2 === void 0 ? void 0 : _context$formData14$a2.pressReleaseFee, localPress === null || localPress === void 0 ? void 0 : localPress.pressReleaseFee);
      const invitationRemark = firstDefined((_context$params14 = context.params) === null || _context$params14 === void 0 ? void 0 : _context$params14.invitationRemark, (_context$formData15 = context.formData) === null || _context$formData15 === void 0 ? void 0 : _context$formData15.invitationRemark, (_context$params15 = context.params) === null || _context$params15 === void 0 ? void 0 : (_context$params15$add = _context$params15.additionalDetails) === null || _context$params15$add === void 0 ? void 0 : _context$params15$add.invitationRemark, (_context$formData16 = context.formData) === null || _context$formData16 === void 0 ? void 0 : (_context$formData16$a = _context$formData16.additionalDetails) === null || _context$formData16$a === void 0 ? void 0 : _context$formData16$a.invitationRemark, (_context$params16 = context.params) === null || _context$params16 === void 0 ? void 0 : (_context$params16$pre = _context$params16.pressReleaseDetails) === null || _context$params16$pre === void 0 ? void 0 : _context$params16$pre.invitationRemark, (_context$formData17 = context.formData) === null || _context$formData17 === void 0 ? void 0 : (_context$formData17$p = _context$formData17.pressReleaseDetails) === null || _context$formData17$p === void 0 ? void 0 : _context$formData17$p.invitationRemark, (_context$params17 = context.params) === null || _context$params17 === void 0 ? void 0 : (_context$params17$pre = _context$params17.pressDetails) === null || _context$params17$pre === void 0 ? void 0 : _context$params17$pre.invitationRemark, (_context$formData18 = context.formData) === null || _context$formData18 === void 0 ? void 0 : (_context$formData18$p = _context$formData18.pressDetails) === null || _context$formData18$p === void 0 ? void 0 : _context$formData18$p.invitationRemark, (_context$params18 = context.params) === null || _context$params18 === void 0 ? void 0 : (_context$params18$add = _context$params18.additionalDetails) === null || _context$params18$add === void 0 ? void 0 : (_context$params18$add2 = _context$params18$add.pressReleaseDetails) === null || _context$params18$add2 === void 0 ? void 0 : _context$params18$add2.invitationRemark, (_context$formData19 = context.formData) === null || _context$formData19 === void 0 ? void 0 : (_context$formData19$a = _context$formData19.additionalDetails) === null || _context$formData19$a === void 0 ? void 0 : (_context$formData19$a2 = _context$formData19$a.pressReleaseDetails) === null || _context$formData19$a2 === void 0 ? void 0 : _context$formData19$a2.invitationRemark, (_context$params19 = context.params) === null || _context$params19 === void 0 ? void 0 : (_context$params19$add = _context$params19.additionalDetails) === null || _context$params19$add === void 0 ? void 0 : (_context$params19$add2 = _context$params19$add.pressDetails) === null || _context$params19$add2 === void 0 ? void 0 : _context$params19$add2.invitationRemark, (_context$formData20 = context.formData) === null || _context$formData20 === void 0 ? void 0 : (_context$formData20$a = _context$formData20.additionalDetails) === null || _context$formData20$a === void 0 ? void 0 : (_context$formData20$a2 = _context$formData20$a.pressDetails) === null || _context$formData20$a2 === void 0 ? void 0 : _context$formData20$a2.invitationRemark, localPress === null || localPress === void 0 ? void 0 : localPress.invitationRemark);
      const _getPressObj = src => {
        var _src$additionalDetail3, _src$additionalDetail4;
        return (src === null || src === void 0 ? void 0 : src.pressReleaseDetails) || (src === null || src === void 0 ? void 0 : src.pressDetails) || (src === null || src === void 0 ? void 0 : (_src$additionalDetail3 = src.additionalDetails) === null || _src$additionalDetail3 === void 0 ? void 0 : _src$additionalDetail3.pressReleaseDetails) || (src === null || src === void 0 ? void 0 : (_src$additionalDetail4 = src.additionalDetails) === null || _src$additionalDetail4 === void 0 ? void 0 : _src$additionalDetail4.pressDetails);
      };
      const pressObjFromParams = _getPressObj(context.params);
      const pressObjFromFormData = _getPressObj(context.formData);
      const hasMeaningfulParams = pressObjFromParams === null || pressObjFromParams === void 0 ? void 0 : pressObjFromParams.hasSuggestion;
      const hasMeaningfulFormData = pressObjFromFormData === null || pressObjFromFormData === void 0 ? void 0 : pressObjFromFormData.hasSuggestion;
      const hasMeaningfulLocal = localPress === null || localPress === void 0 ? void 0 : localPress.hasSuggestion;
      const existingPressDetails = hasMeaningfulParams ? pressObjFromParams : hasMeaningfulFormData ? pressObjFromFormData : hasMeaningfulLocal ? localPress : pressObjFromParams || pressObjFromFormData || localPress || {};
      const effectiveFee = hasSuggestion === "yes" ? pressReleaseFee !== undefined && pressReleaseFee !== null ? pressReleaseFee : "" : "";
      const pressDetails = {
        ...existingPressDetails,
        ...(hasSuggestion !== undefined && {
          hasSuggestion
        }),
        ...(hasSuggestion !== undefined && {
          pressReleaseFee: effectiveFee
        }),
        ...(invitationRemark !== undefined && {
          invitationRemark
        })
      };
      const hasAnyPressInfo = hasSuggestion !== undefined || pressReleaseFee !== undefined || invitationRemark !== undefined || Object.keys(existingPressDetails).length > 0;
      const serverAdditional = ((_context$formData21 = context.formData) === null || _context$formData21 === void 0 ? void 0 : _context$formData21.additionalDetails) || {};
      const paramsAdditional = ((_context$params20 = context.params) === null || _context$params20 === void 0 ? void 0 : _context$params20.additionalDetails) || {};
      const serverPressRelease = serverAdditional.pressReleaseDetails || serverAdditional.pressDetails;
      const paramsPressRelease = paramsAdditional.pressReleaseDetails || paramsAdditional.pressDetails;
      const bestAdditionalPressRelease = paramsPressRelease !== null && paramsPressRelease !== void 0 && paramsPressRelease.hasSuggestion ? paramsPressRelease : serverPressRelease !== null && serverPressRelease !== void 0 && serverPressRelease.hasSuggestion ? serverPressRelease : localPress !== null && localPress !== void 0 && localPress.hasSuggestion ? localPress : paramsPressRelease || serverPressRelease || localPress;
      const effectiveNocDetails = ((_context$params21 = context.params) === null || _context$params21 === void 0 ? void 0 : _context$params21.nocDetails) || ((_context$formData22 = context.formData) === null || _context$formData22 === void 0 ? void 0 : _context$formData22.nocDetails) || ((_context$params22 = context.params) === null || _context$params22 === void 0 ? void 0 : (_context$params22$add = _context$params22.additionalDetails) === null || _context$params22$add === void 0 ? void 0 : _context$params22$add.nocDetails) || ((_context$formData23 = context.formData) === null || _context$formData23 === void 0 ? void 0 : (_context$formData23$a = _context$formData23.additionalDetails) === null || _context$formData23$a === void 0 ? void 0 : _context$formData23$a.nocDetails);
      const additionalDetails = {
        ...serverAdditional,
        ...paramsAdditional,
        ...(hasSuggestion !== undefined && {
          hasSuggestion
        }),
        ...(hasSuggestion !== undefined && {
          pressReleaseFee: effectiveFee
        }),
        ...(invitationRemark !== undefined && {
          invitationRemark
        }),
        ...(hasAnyPressInfo ? {
          pressDetails,
          pressReleaseDetails: pressDetails
        } : bestAdditionalPressRelease ? {
          pressDetails: bestAdditionalPressRelease,
          pressReleaseDetails: bestAdditionalPressRelease
        } : {}),
        ...(effectiveNocDetails ? {
          nocDetails: effectiveNocDetails
        } : {})
      };
      return {
        BPA: {
          ...context.formData,
          ...context.params,
          customLetter: context.typeOfLetter,
          nocDetails: effectiveNocDetails || ((_context$params23 = context.params) === null || _context$params23 === void 0 ? void 0 : _context$params23.nocDetails) || ((_context$formData24 = context.formData) === null || _context$formData24 === void 0 ? void 0 : _context$formData24.nocDetails),
          ...(hasSuggestion !== undefined && {
            hasSuggestion
          }),
          ...(hasSuggestion !== undefined && {
            pressReleaseFee: effectiveFee
          }),
          ...(invitationRemark !== undefined && {
            invitationRemark
          }),
          ...(hasAnyPressInfo ? {
            pressDetails,
            pressReleaseDetails: pressDetails
          } : existingPressDetails && Object.keys(existingPressDetails).length > 0 ? {
            pressDetails: existingPressDetails,
            pressReleaseDetails: existingPressDetails
          } : {}),
          additionalDetails,
          workflow: {
            action: (_context$mapSubmissio2 = context.mapSubmissionAction) === null || _context$mapSubmissio2 === void 0 ? void 0 : _context$mapSubmissio2.action,
            comments: context.remarks,
            varificationDocuments: varificationDocuments
          },
          documents: mergeDocumentsWithSitePhotos([...(((_context$params24 = context.params) === null || _context$params24 === void 0 ? void 0 : _context$params24.documents) || ((_context$formData25 = context.formData) === null || _context$formData25 === void 0 ? void 0 : _context$formData25.documents) || []), ...(context.customLetter || []), ...customApprovalDocs], [(_context$params25 = context.params) === null || _context$params25 === void 0 ? void 0 : _context$params25.documents, (_context$formData26 = context.formData) === null || _context$formData26 === void 0 ? void 0 : _context$formData26.documents]),
          taxHeadEstimates: [...(((_context$params26 = context.params) === null || _context$params26 === void 0 ? void 0 : _context$params26.taxHeadEstimates) || ((_context$formData27 = context.formData) === null || _context$formData27 === void 0 ? void 0 : _context$formData27.taxHeadEstimates) || [])],
          inspectionDetailData: inspectionDataResp ? inspectionDataResp : ["JE", "EE"].includes((_context$userRolesArr = context.userRolesArray) === null || _context$userRolesArr === void 0 ? void 0 : (_context$userRolesArr2 = _context$userRolesArr[0]) === null || _context$userRolesArr2 === void 0 ? void 0 : _context$userRolesArr2.code) ? ((_context$formData28 = context.formData) === null || _context$formData28 === void 0 ? void 0 : _context$formData28.inspectionDetailData) || ((_context$params27 = context.params) === null || _context$params27 === void 0 ? void 0 : _context$params27.inspectionDetailData) : context.updatedInspectionReportData || ((_context$params28 = context.params) === null || _context$params28 === void 0 ? void 0 : _context$params28.inspectionDetailData) || ((_context$formData29 = context.formData) === null || _context$formData29 === void 0 ? void 0 : _context$formData29.inspectionDetailData)
        }
      };
    }
  };
  const validateBeforeSubmit = ({
    isValidEmp,
    currentAction,
    mapSubmissionAction,
    isDocValidated,
    remarks,
    dscValidation,
    setError,
    isNotingValidated,
    newSitePhotoUploaded: _newSitePhotoUploaded = false
  }) => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return false;
    }
    const selectedAction = (typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (typeof mapSubmissionAction === "object" ? mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action : mapSubmissionAction) || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) || (mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action) || "";
    const isSendBackAction = typeof selectedAction === "string" && selectedAction.toUpperCase().includes("SEND_BACK");
    if (selectedAction === "PROVISIONALLY_APPROVAL") {
      var _Digit$UserService$ge3;
      const userInfo = (_Digit$UserService$ge3 = Digit.UserService.getUser()) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.info;
      const isVCUser = userInfo && userInfo.roles && userInfo.roles.some(function (r) {
        var c = (typeof r === "string" ? r : r && r.code || "").toUpperCase();
        var n = (typeof r === "string" ? r : r && r.name || "").toUpperCase();
        return c === "VICE_CHAIRMAN" || c === "VC" || c === "BPA_VC" || n.indexOf("VICE CHAIRMAN") !== -1 || n.indexOf("VICE-CHAIRMAN") !== -1;
      });
      if (isVCUser) {
        var appType = (params && params.applicationType || formData && formData.applicationType || formData && formData.appliactionType || "").toUpperCase();
        var appNo = (params && params.applicationNo || formData && formData.applicationNo || formData && formData.applicationNumber || "").toUpperCase();
        var bs = (params && params.businessService || formData && formData.businessService || "").toUpperCase();
        var planOn = (params && params.planOn || formData && formData.planOn || "").toUpperCase();
        var isCompounding = appType.indexOf("COMPOUNDING") !== -1 || appType === "FORM_COMPOUNDING" || planOn === "FORM_MAP_COMPOUNDING" || bs === "BPA_COMPOUNDING" || appNo.indexOf("/CP/") !== -1 || appNo.indexOf("/CMP/") !== -1;
        var fee2Code = isCompounding ? "BPA.MAP_COMPOUNDING_FEE" : "BPA.MAP_SUBMISSION_FEE_2";
        var fee2AltCode = isCompounding ? "BPA_MAP_COMPOUNDING_FEE" : "BPA_MAP_SUBMISSION_FEE_2";
        var fee2Normalized = isCompounding ? "BPAMAPCOMPOUNDINGFEE" : "BPAMAPSUBMISSIONFEE2";
        var bpaChallan = params && params.BPAChallan || params && params.bpaChallan || formData && formData.BPAChallan || formData && formData.bpaChallan;
        var taxHeads = [];
        if (bpaChallan) {
          if (Array.isArray(bpaChallan)) {
            bpaChallan.forEach(function (c) {
              if (c && Array.isArray(c.taxHeadEstimates)) {
                taxHeads = taxHeads.concat(c.taxHeadEstimates);
              }
            });
          } else if (typeof bpaChallan === "object" && Array.isArray(bpaChallan.taxHeadEstimates)) {
            taxHeads = bpaChallan.taxHeadEstimates;
          }
        }
        var fee2Estimate = null;
        for (var fi = 0; fi < taxHeads.length; fi++) {
          var est = taxHeads[fi];
          if (!est) continue;
          var codes = [est.taxHeadCode, est.code, est.calculationBusinesserviceId, est.headCode];
          var matched = codes.some(function (code) {
            if (!code) return false;
            var raw = String(code).trim().toUpperCase();
            var normalized = raw.replace(/[\._]/g, "");
            return raw === fee2Code || raw === fee2AltCode || normalized === fee2Normalized;
          });
          if (matched) {
            fee2Estimate = est;
            break;
          }
        }
        var fee2Amount = fee2Estimate ? parseFloat(fee2Estimate.estimateAmount || 0) : 0;
        var hasFee2 = Boolean(fee2Estimate) && !isNaN(fee2Amount) && fee2Amount > 0;
        if (!hasFee2) {
          Modal("Action Not Allowed", "FEES NOT GENERATED OR NOT PAID", "error");
          return false;
        }
      }
    }
    console.log("isSitePhotUploaded inside validation !", _newSitePhotoUploaded);
    if (!_newSitePhotoUploaded) {
      Modal("Action required", "Please upload site photo to proceed.", "error");
      return false;
    }
    if (!(currentAction !== null && currentAction !== void 0 && currentAction.action) && !(mapSubmissionAction !== null && mapSubmissionAction !== void 0 && mapSubmissionAction.action) && !selectedAction) {
      Modal("Action required", "Please select at least one action.", "error");
      return false;
    }
    if (!isNotingValidated) {
      Modal("Noting Remark", "Please add Noting Remark and click on Save", "error");
      return false;
    }
    if (!isPlinthSubmission && !isSendBackAction && !isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return false;
    }
    if (dscValidation) {
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return false;
    }
    const plainText = stripHtmlTags(remarks);
    if (plainText.trim().length === 0 && (formData === null || formData === void 0 ? void 0 : formData.department) === "DA") {
      setError(true);
      return false;
    }
    setError(false);
    return true;
  };
  const onSuccessHandlers = {
    NOC: (formData, currentAction, t, clearParams) => {
      var _Digit6, _Digit7, _Digit8, _Digit9;
      Modal(`Application ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}`, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}</strong> updated successfully.`, "success", "/digit-ui/employee");
      clearParams();
      (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("EMP_MAPSUB");
      (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.del("isDocValidated");
      (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.del("isNotingValidated");
      (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.del("isPaymenthead");
    },
    BPA: (formData, currentAction, t, clearParams) => {
      var _Digit10, _Digit11, _Digit12, _Digit13;
      Modal(`Application ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}`, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}</strong> updated successfully.`, "success", "/digit-ui/employee");
      clearParams();
      (_Digit10 = Digit) === null || _Digit10 === void 0 ? void 0 : _Digit10.SessionStorage.del("EMP_MAPSUB");
      (_Digit11 = Digit) === null || _Digit11 === void 0 ? void 0 : _Digit11.SessionStorage.del("isDocValidated");
      (_Digit12 = Digit) === null || _Digit12 === void 0 ? void 0 : _Digit12.SessionStorage.del("isNotingValidated");
      (_Digit13 = Digit) === null || _Digit13 === void 0 ? void 0 : _Digit13.SessionStorage.del("customLetter");
      localStorage.removeItem("wf_verification_doc");
      localStorage.removeItem("custom_approval_letter");
    }
  };
  const handleSubmit = () => {
    var _formData$drawingDeta, _formData$drawingDeta2, _formData$status, _Digit14, _Digit14$SessionStora, _Digit15, _Digit15$SessionStora, _Digit16, _Digit16$SessionStora;
    console.log("[DEBUG] handleSubmit called, uploadedFile state:", uploadedFile, "localStorage:", localStorage.getItem("wf_verification_doc"));
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction,
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
      updatedInspectionReportData
    };
    console.log("CurrentActionAS", currentAction, formData);
    const lastDrawing = formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : _formData$drawingDeta[(formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta2 = formData.drawingDetail) === null || _formData$drawingDeta2 === void 0 ? void 0 : _formData$drawingDeta2.length) - 1];
    const isDrawingSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfDscEmp) === true || (formData === null || formData === void 0 ? void 0 : formData.IsSanctionDrawing) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfUrl) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfId));
    const isApprovalSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl));
    const dscValidation = (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) && (!isApprovalSignedByEmp || !isCompletionPortal && !isDrawingSignedByEmp);
    const isSitePhotoUploaded = (_Digit14 = Digit) === null || _Digit14 === void 0 ? void 0 : (_Digit14$SessionStora = _Digit14.SessionStorage) === null || _Digit14$SessionStora === void 0 ? void 0 : _Digit14$SessionStora.get("isSitePhotoUploaded");
    console.log("ISSITEPHOTOUPLOADED", isSitePhotoUploaded);
    const isDocValidated = (_Digit15 = Digit) === null || _Digit15 === void 0 ? void 0 : (_Digit15$SessionStora = _Digit15.SessionStorage) === null || _Digit15$SessionStora === void 0 ? void 0 : _Digit15$SessionStora.get("isDocValidated");
    const isNotingValidated = (_Digit16 = Digit) === null || _Digit16 === void 0 ? void 0 : (_Digit16$SessionStora = _Digit16.SessionStorage) === null || _Digit16$SessionStora === void 0 ? void 0 : _Digit16$SessionStora.get("isNotingValidated");
    const skipValidation = isSelfApproval;
    const newSitePhotoUploaded = !isJE && !isAVPandEE || isCompletionPortal || isPlinthSubmission || isPurchasbleFAR ? true : isSitePhotoUploaded;
    let isValid = true;
    if (!skipValidation) {
      isValid = validateBeforeSubmit({
        isValidEmp,
        currentAction,
        mapSubmissionAction,
        isDocValidated,
        remarks,
        dscValidation,
        setError,
        isNotingValidated,
        newSitePhotoUploaded
      });
    }
    if (!isValid) return;
    setLoader(true);
    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    console.log("payloadFromSubmit", payload, "context", context);
    updateApiCall.mutate(payload, {
      onSuccess: result => {
        onSuccessHandlers[moduleKey](formData, currentAction, t, clearParams);
      },
      onError: err => {
        console.log("ERRROR", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
    setLoader(false);
  };
  console.log("paymentHeadForHeadValidation1", chatBoardDataRemarks, chatBoardHistoryData, notingRemarksData);
  console.log("paymentHeadForHeadValidation", taxHead, paymentHeadRemarksData, documentRemarksData, siteInspectionRemarksData);
  const callInspectionDetailsAPI = async data => {
    var _userRolesArray$5, _userRolesArray$6;
    console.log("Received from child:", data);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$5 = userRolesArray[0]) === null || _userRolesArray$5 === void 0 ? void 0 : _userRolesArray$5.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$6 = userRolesArray[0]) === null || _userRolesArray$6 === void 0 ? void 0 : _userRolesArray$6.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "InspectionDetail",
        inspectionDetails: {
          ...data
        }
      }
    };
    let resp = null;
    try {
      var _inspectionReportChec, _userRolesArray$7, _inspectionReportChec2, _resp5, _resp5$DetailDataRema, _resp5$DetailDataRema2, _resp6, _resp6$DetailDataRema, _resp6$DetailDataRema2, _resp6$DetailDataRema3, _resp6$DetailDataRema4, _resp6$DetailDataRema5;
      if (isDa && (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW" && (inspectionReportChecklist === null || inspectionReportChecklist === void 0 ? void 0 : (_inspectionReportChec = inspectionReportChecklist.inspectionReportData) === null || _inspectionReportChec === void 0 ? void 0 : _inspectionReportChec.siteInspecionConstructionONSite) != null && (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$7 = userRolesArray[0]) === null || _userRolesArray$7 === void 0 ? void 0 : _userRolesArray$7.code) === "JE") {
        var _resp, _resp$DetailDataRemar, _resp$DetailDataRemar2, _resp2, _resp2$DetailDataRema, _resp2$DetailDataRema2;
        console.log("Logging: LOW risk + Construction filled + Role is JE");
        resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData).then(response => {
          console.log("log12234", response.data);
          return response.data;
        });
        setInspectionDataResp((_resp = resp) === null || _resp === void 0 ? void 0 : (_resp$DetailDataRemar = _resp.DetailDataRemarks) === null || _resp$DetailDataRemar === void 0 ? void 0 : (_resp$DetailDataRemar2 = _resp$DetailDataRemar[0]) === null || _resp$DetailDataRemar2 === void 0 ? void 0 : _resp$DetailDataRemar2.inspectionDetails);
        onSelect("", {
          ...formData,
          inspectionDetailData: (_resp2 = resp) === null || _resp2 === void 0 ? void 0 : (_resp2$DetailDataRema = _resp2.DetailDataRemarks) === null || _resp2$DetailDataRema === void 0 ? void 0 : (_resp2$DetailDataRema2 = _resp2$DetailDataRema[0]) === null || _resp2$DetailDataRema2 === void 0 ? void 0 : _resp2$DetailDataRema2.inspectionDetails
        });
      } else if ((formData === null || formData === void 0 ? void 0 : formData.riskType) !== "LOW") {
        var _resp3, _resp3$DetailDataRema, _resp3$DetailDataRema2, _resp4, _resp4$DetailDataRema, _resp4$DetailDataRema2;
        console.log("Logging: Not LOW risk");
        resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData).then(response => {
          console.log("log12235", response.data);
          return response.data;
        });
        setInspectionDataResp((_resp3 = resp) === null || _resp3 === void 0 ? void 0 : (_resp3$DetailDataRema = _resp3.DetailDataRemarks) === null || _resp3$DetailDataRema === void 0 ? void 0 : (_resp3$DetailDataRema2 = _resp3$DetailDataRema[0]) === null || _resp3$DetailDataRema2 === void 0 ? void 0 : _resp3$DetailDataRema2.inspectionDetails);
        onSelect("", {
          ...formData,
          inspectionDetailData: (_resp4 = resp) === null || _resp4 === void 0 ? void 0 : (_resp4$DetailDataRema = _resp4.DetailDataRemarks) === null || _resp4$DetailDataRema === void 0 ? void 0 : (_resp4$DetailDataRema2 = _resp4$DetailDataRema[0]) === null || _resp4$DetailDataRema2 === void 0 ? void 0 : _resp4$DetailDataRema2.inspectionDetails
        });
      } else if ((formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW" && (inspectionReportChecklist === null || inspectionReportChecklist === void 0 ? void 0 : (_inspectionReportChec2 = inspectionReportChecklist.inspectionReportData) === null || _inspectionReportChec2 === void 0 ? void 0 : _inspectionReportChec2.siteInspecionConstructionONSite) === null) {
        console.log("Logging: LOW risk + Construction missing");
        Modal("Missing Construction Details", "Please fill the <strong>Site Inspection Construction ONSite</strong> before submitting.", "error");
        return;
      }
      Modal("Application Inspection Details", `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) Inspection Details</strong>Updated Successfully!`, "success");
      console.log("FORMDATAUPDATED", formData, (_resp5 = resp) === null || _resp5 === void 0 ? void 0 : (_resp5$DetailDataRema = _resp5.DetailDataRemarks) === null || _resp5$DetailDataRema === void 0 ? void 0 : (_resp5$DetailDataRema2 = _resp5$DetailDataRema[0]) === null || _resp5$DetailDataRema2 === void 0 ? void 0 : _resp5$DetailDataRema2.inspectionDetails);
      const isSitePhotUploaded = ((_resp6 = resp) === null || _resp6 === void 0 ? void 0 : (_resp6$DetailDataRema = _resp6.DetailDataRemarks) === null || _resp6$DetailDataRema === void 0 ? void 0 : (_resp6$DetailDataRema2 = _resp6$DetailDataRema[0]) === null || _resp6$DetailDataRema2 === void 0 ? void 0 : (_resp6$DetailDataRema3 = _resp6$DetailDataRema2.inspectionDetails) === null || _resp6$DetailDataRema3 === void 0 ? void 0 : (_resp6$DetailDataRema4 = _resp6$DetailDataRema3.inspectionReportData) === null || _resp6$DetailDataRema4 === void 0 ? void 0 : (_resp6$DetailDataRema5 = _resp6$DetailDataRema4.documentInspection) === null || _resp6$DetailDataRema5 === void 0 ? void 0 : _resp6$DetailDataRema5.length) > 0 && (isJE || isAVPandEE);
      console.log("AFTER UPDATED SITE PHOTO", isSitePhotUploaded);
      Digit.SessionStorage.set("isSitePhotoUploaded", isSitePhotUploaded);
      await handleGetSiteInspectionById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      handleChange(undefined, 5);
    } catch (error) {
      console.log("API Error:", error);
      Modal("API Error", "Something went wrong while submitting the inspection details.", "error");
    } finally {
      setLoader(false);
    }
  };
  const callDocumentDetailsAPI = async (developerRemarks, dataRecommendation, documents) => {
    const finalRecommendation = dataRecommendation !== undefined && dataRecommendation !== null ? dataRecommendation : dataRecommendationDocument;
    const finalRemarks = developerRemarks !== undefined && developerRemarks !== null ? developerRemarks : developerRemarksDocument;
    const finalDocuments = documents !== undefined && documents !== null ? documents : updatedDocuments;
    if (!finalRecommendation || !finalRemarks || !finalDocuments || finalDocuments.length === 0) {
      console.log("Data not ready, API blocked");
      return;
    }
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo && userInfo.id ? userInfo.id : null,
          name: userInfo && userInfo.name ? userInfo.name : null,
          employeeName: userInfo && userInfo.name ? userInfo.name : null,
          role: userRolesArray && userRolesArray[0] ? userRolesArray[0].code : null,
          applicationID: formData ? formData.applicationNo : null,
          designation: userRolesArray && userRolesArray[0] ? userRolesArray[0].name : null,
          applicationStatus: formData ? formData.status : null
        },
        isApproved: "DocumentDetails",
        documentDetails: {
          dataRecommendation: finalRecommendation,
          developerRemarks: finalRemarks,
          documents: finalDocuments
        }
      }
    };
    try {
      const response = await axios$1.post(Urls$1.bpaService.remarksDetail, postData);
      console.log("response", response.data);
      Modal("Documents updated", `Document details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      await handleGetDocumentById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      handleChange(undefined, "2");
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (callAPI && (updatedDocuments === null || updatedDocuments === void 0 ? void 0 : updatedDocuments.length) > 0 && dataRecommendationDocument && developerRemarksDocument) {
      callDocumentDetailsAPI(developerRemarksDocument, dataRecommendationDocument);
      setCallAPI(false);
    }
  }, [callAPI, updatedDocuments, dataRecommendationDocument, developerRemarksDocument]);
  useEffect(() => {
    console.log("applicationRemarksFetch", formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    if (formData !== null && formData !== void 0 && formData.applicationNo) {
      handleGetDocumentById(formData.applicationNo);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  useEffect(() => {
    var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3;
    console.log(documentRemarksData, documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$ = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$[0]) === null || _documentRemarksData$2 === void 0 ? void 0 : (_documentRemarksData$3 = _documentRemarksData$2.documentDetails) === null || _documentRemarksData$3 === void 0 ? void 0 : _documentRemarksData$3.dataRecommendation, "documentRemarksData");
    if (documentRemarksData !== null && documentRemarksData !== void 0 && documentRemarksData.DetailDataRemarks) {
      var _documentRemarksData$4, _documentRemarksData$5, _documentRemarksData$6, _documentRemarksData$7, _documentRemarksData$8, _documentRemarksData$9;
      setDataRecommendationDocument((documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$4 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$4 === void 0 ? void 0 : (_documentRemarksData$5 = _documentRemarksData$4[0]) === null || _documentRemarksData$5 === void 0 ? void 0 : (_documentRemarksData$6 = _documentRemarksData$5.documentDetails) === null || _documentRemarksData$6 === void 0 ? void 0 : _documentRemarksData$6.dataRecommendation) || "");
      setDeveloperRemarksDocument((documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$7 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$7 === void 0 ? void 0 : (_documentRemarksData$8 = _documentRemarksData$7[0]) === null || _documentRemarksData$8 === void 0 ? void 0 : (_documentRemarksData$9 = _documentRemarksData$8.documentDetails) === null || _documentRemarksData$9 === void 0 ? void 0 : _documentRemarksData$9.developerRemarks) || "");
    }
  }, [documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks]);
  const callPaymentDetailsAPI = async (value, value2, remarksVal) => {
    var _userRolesArray$8, _userRolesArray$9;
    console.log("Received from child:", value, value2, remarksVal);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$8 = userRolesArray[0]) === null || _userRolesArray$8 === void 0 ? void 0 : _userRolesArray$8.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$9 = userRolesArray[0]) === null || _userRolesArray$9 === void 0 ? void 0 : _userRolesArray$9.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "PaymentDetails",
        paymentDetails: {
          dataRecommendation: value !== undefined ? value : paymentRecommendation,
          developerRemarks: remarksVal !== undefined ? remarksVal : paymentRemarks,
          paymentHead: taxHead
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Payment Head remarks saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
    await handleGetPaymentHeadById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "5");
  };
  const callDrawingDetailsAPI = async (value, value2, remarksVal) => {
    var _userRolesArray$10, _userRolesArray$11;
    console.log("Received from child:", value, value2, remarksVal);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$10 = userRolesArray[0]) === null || _userRolesArray$10 === void 0 ? void 0 : _userRolesArray$10.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$11 = userRolesArray[0]) === null || _userRolesArray$11 === void 0 ? void 0 : _userRolesArray$11.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "DrawingsDetails",
        drawingsDetails: {
          dataRecommendation: value !== undefined ? value : drawingRecommendation,
          developerRemarks: remarksVal !== undefined ? remarksVal : drawingRemarks,
          developerObjection: value2,
          drawingsDetails: formData === null || formData === void 0 ? void 0 : formData.drawingDetail
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Drawings Details remarks saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
    await handleGetDrawingById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "5");
  };
  const callPfarDetailsAPI = async value => {
    var _userRolesArray$12, _userRolesArray$13;
    console.log("Received from child:", value);
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$12 = userRolesArray[0]) === null || _userRolesArray$12 === void 0 ? void 0 : _userRolesArray$12.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$13 = userRolesArray[0]) === null || _userRolesArray$13 === void 0 ? void 0 : _userRolesArray$13.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "remarksDetails",
        remarksDetails: {
          developerRemarks: developerRemarks || value
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("PFAR remarks details saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
    await handlepFarDetailById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "5");
  };
  const callNotingDetailsAPI = async () => {
    var _userRolesArray$14, _userRolesArray$15;
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$14 = userRolesArray[0]) === null || _userRolesArray$14 === void 0 ? void 0 : _userRolesArray$14.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$15 = userRolesArray[0]) === null || _userRolesArray$15 === void 0 ? void 0 : _userRolesArray$15.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "notingDetails",
        notingDetails: {
          developerRemarks: developerRemarks
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {});
      console.log("log1223Noting", Resp === null || Resp === void 0 ? void 0 : Resp.data);
      setLoader(false);
      Modal("Noting remarks saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
      await handleGetNotingById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      handleChange(undefined, "2");
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const callNocDetailsAPI = async (value, value2, remarksVal) => {
    var _userRolesArray$16, _userRolesArray$17;
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$16 = userRolesArray[0]) === null || _userRolesArray$16 === void 0 ? void 0 : _userRolesArray$16.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$17 = userRolesArray[0]) === null || _userRolesArray$17 === void 0 ? void 0 : _userRolesArray$17.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "nocDetails",
        nocDetails: {
          developerRemarks: remarksVal !== undefined ? remarksVal : developerNocRemarks,
          dataRecommendation: value !== undefined ? value : dataNocRecommendation,
          nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223Noting", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal("Noc remarks saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
    await handleGetNocById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "2");
  };
  const onDropDownSelect = event => {
    const value = event.target.value;
    if (isMapSubmission || isPlinthSubmission || isPurchasbleFAR || isCompletionPortal || isCompounding) {
      console.log("radioAction", value);
      setMapSubmissionAction(value);
      setCurrentAction(value);
    } else {
      setCurrentAction(value);
    }
    if (isPlinthSubmission) {
      setCurrentAction(value);
    }
    if (isCompounding) {
      setCurrentAction(value);
    }
  };
  useEffect(() => {
    const applicationNumber = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
    if (!applicationNumber) {
      console.warn("⚠️ Application number not found yet.");
      return;
    }
    onSelect("", formData);
    handleGetPaymentHeadById(applicationNumber);
    handleGetDocumentById(applicationNumber);
    handleGetSiteInspectionById(applicationNumber);
    handleGetDrawingById(applicationNumber);
    handleGetFiledsStatesById(applicationNumber);
    handleGetRemarkssValues(applicationNumber);
    handleGetNotingById(applicationNumber);
    handleGetNocById(applicationNumber);
    handlepFarDetailById(applicationNumber);
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  console.log("dataRecommendation000", dataRecommendation, developerRemarks, updatedDocuments);
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = value => {
    setCurrentAction(value);
  };
  console.log("loggingActionsFromHook", actions);
  const [isLoadingLetter, setIsLoadingLetter] = useState(false);
  const handleGenerateIntimationLetter = async () => {
    setIsLoadingLetter(true);
    try {
      var _response$documentPar, _response$documentPar2;
      const response = await Digit.OBPSService.farIntimationLetter(tenantId, formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      const fileStoreId = (response === null || response === void 0 ? void 0 : (_response$documentPar = response.documentParameters) === null || _response$documentPar === void 0 ? void 0 : (_response$documentPar2 = _response$documentPar[0]) === null || _response$documentPar2 === void 0 ? void 0 : _response$documentPar2.fileStoreId) || (response === null || response === void 0 ? void 0 : response.fileStoreId) || (response === null || response === void 0 ? void 0 : response.message);
      if (fileStoreId) {
        const updateObj = {
          farInimationLetterId: fileStoreId,
          farInimationLetter: fileStoreId,
          farInimationLetterUrl: fileStoreId
        };
        setParams({
          ...(params || {}),
          ...updateObj
        });
        onSelect("", {
          ...(formData || {}),
          ...updateObj
        });
        Modal("Success", "Intimation letter generated successfully!", "success");
      } else {
        Modal("Warning", "Letter generated but no FileStore ID returned.", "warning");
      }
    } catch (err) {
      console.error(err);
      Modal("Error", "Failed to generate Intimation letter.", "error");
    } finally {
      setIsLoadingLetter(false);
    }
  };
  const handleViewIntimationLetter = async () => {
    const fileStoreId = (formData === null || formData === void 0 ? void 0 : formData.farInimationLetterUrl) || (params === null || params === void 0 ? void 0 : params.farInimationLetterUrl);
    if (!fileStoreId) {
      Modal("Error", "No Intimation Letter generated yet.", "error");
      return;
    }
    if (fileStoreId.includes("http")) {
      window.open(fileStoreId, "_blank");
      return;
    }
    try {
      var _res$data;
      const res = await Digit.UploadServices.Filefetch([fileStoreId], tenantId);
      if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data[fileStoreId]) {
        var _res$data2;
        let pdfUrl = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2[fileStoreId];
        pdfUrl = pdfUrl.split(",")[0];
        window.open(pdfUrl, "_blank");
      } else {
        Modal("Error", "Could not fetch Intimation Letter URL.", "error");
      }
    } catch (err) {
      console.error(err);
      Modal("Error", "Failed to fetch Intimation Letter.", "error");
    }
  };
  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    drawingRemarks,
    paymentRemarks,
    setDeveloperRemarks,
    setPaymentRemarks,
    setDrawingRemarks,
    setPaymentRecommendation,
    setDrawingRecommendation,
    paymentRecommendation,
    drawingRecommendation,
    drawingPdfs,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    setDeveloperNocRemarks,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    nocRemarksData,
    dataRecommendationDocument,
    setSelectedObjection,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callPfarDetailsAPI,
    callNotingDetailsAPI,
    callNocDetailsAPI,
    paymentHeadRemarksData,
    documentRemarksData,
    updatedInspectionReportData,
    siteDrawingRemarksData,
    pFarDetailsData,
    chatBoardDataRemarks,
    chatBoardHistoryData,
    notingRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    handleNoWorkflowPFAR,
    mapSubmissionAction,
    userRolesArray,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isBpaNoc,
    isPurchasbleReq,
    currentFormData,
    handleGetSiteInspectionById,
    isFromDashboard,
    daLogo,
    avpLogo,
    siteInspectionRemarksData,
    callDocumentDetailsAPI,
    uploadedFile,
    setUploadedFile,
    handleCompletionChecklistSave,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
    handleGenerateIntimationLetter,
    handleViewIntimationLetter,
    isLoadingLetter
  };
};

const RemarksEditor = ({
  setRemarks,
  remarks,
  error,
  setError,
  title: _title = "Remarks"
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "#F7F7F7"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      marginRight: "2px",
      whiteSpace: "nowrap"
    }
  }, _title, " ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: value => {
      setRemarks(value);
      if (value && value.replace(/<[^>]*>/g, "").trim().length > 0) {
        setError(false);
      }
    },
    content: remarks
  }))), error && /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "Please enter ", _title || "remarks"))));
};

const RecommendationRemarksComponent = ({
  title,
  label,
  name,
  names,
  control,
  options,
  defaultValue,
  extraLabel,
  setDeveloperRemarks,
  developerRemarks,
  setDataRecommendation,
  optionsInner,
  buttonshow: _buttonshow = false,
  setSelectedObjection,
  type,
  onSaveClick,
  error,
  setError,
  handleTabChange,
  nextTab,
  isFromDashboard
}) => {
  const {
    t
  } = useTranslation();
  const {
    control: localControl,
    handleSubmit,
    setValue: localSetValue,
    getValues
  } = !control && _buttonshow ? useForm() : {};
  const [selectedName, setSelectedName] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [selectedRecommendationName, setSelectedRecommendationName] = useState(null);
  console.log(selectedRecommendationName, "selectedRecommendationName");
  const handleRecommendationChange = e => {
    var _e$target;
    const value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    console.log("Manual select value:", value);
    setDataRecommendation === null || setDataRecommendation === void 0 ? void 0 : setDataRecommendation(value);
    setSelectedRecommendationName(value);
  };
  useEffect(() => {
    console.log("Toast updated:", showToast);
  }, [showToast]);
  const handleRecommendationChanges = e => {
    var _e$target2;
    const value = e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value;
    console.log("Manual select value:", value);
    if (!value) {
      setError("This field is required");
      return;
    }
    setSelectedName === null || setSelectedName === void 0 ? void 0 : setSelectedName(value);
    setSelectedObjection === null || setSelectedObjection === void 0 ? void 0 : setSelectedObjection(value);
  };
  const handleClick = () => {
    const selectedValue = getValues === null || getValues === void 0 ? void 0 : getValues(name);
    const selectedValue2 = getValues === null || getValues === void 0 ? void 0 : getValues(names);
    console.log("Selected Value from local form:", selectedValue, selectedValue2, developerRemarks);
    if (!developerRemarks || developerRemarks.trim() === "") {
      setError(true);
      return;
    }
    if (!selectedValue || selectedValue.trim() === "") {
      console.log("No recommendation selected", showToast);
      setShowToast({
        error: true,
        label: "Please Select Recommendation"
      });
      return;
    }
    setDataRecommendation === null || setDataRecommendation === void 0 ? void 0 : setDataRecommendation(selectedValue || "static-recommendation");
    setSelectedObjection === null || setSelectedObjection === void 0 ? void 0 : setSelectedObjection(selectedValue2 || "static-recommendation");
    if (onSaveClick) {
      onSaveClick(selectedValue, selectedValue2, developerRemarks);
      setDeveloperRemarks(null);
      setDataRecommendation === null || setDataRecommendation === void 0 ? void 0 : setDataRecommendation("");
      handleTabChange === null || handleTabChange === void 0 ? void 0 : handleTabChange(nextTab);
    }
  };
  const finalControl = control ? control : localControl;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    sx: {
      backgroundColor: "#f9f9f9",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      my: 2,
      p: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      p: 1,
      color: "#fff",
      textAlign: "left",
      borderRadius: "4px",
      fontSize: "1rem",
      padding: "10px",
      fontFamily: "sans-serif",
      lineHeight: "1.5"
    }
  }, title), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    sx: {
      my: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography, null, label, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, control ? /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: finalControl,
    name: name,
    type: "selectInput",
    data: options,
    defaultValue: defaultValue,
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: name,
    control: finalControl,
    type: "selectInput",
    data: options,
    defaultValue: defaultValue,
    hasLabel: false,
    onBlur: handleRecommendationChange,
    error: error,
    setError: setError,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    isDleteBtn: true,
    error: showToast.error,
    warning: showToast.warning,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }))), type === "drawingDetails" && (selectedRecommendationName === "Shortfall" || defaultValue === "Shortfall") && /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    sx: {
      my: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography, null, "Objection", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: names,
    type: "multiSelectInput",
    control: finalControl,
    placeholder: "Select options",
    data: innerInspRecommendation || [],
    defaultValue: selectedName ? [selectedName] : [],
    onBlur: handleRecommendationChanges,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    sx: {
      my: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography, null, extraLabel, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(RemarksEditor, {
    setRemarks: setDeveloperRemarks,
    remarks: developerRemarks,
    error: error,
    setError: setError
  }))), _buttonshow && !isFromDashboard &&
  /*#__PURE__*/
  React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginTop: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "secondary",
    onClick: handleClick,
    style: {
      margin: "auto",
      height: "30px",
      width: "10%",
      borderRadius: "4px",
      backgroundColor: "#157CB3"
    }
  }, "Save")));
};

dayjs.extend(utc);
const InspectionViewseer = ({
  inspectionDetails,
  formData
}) => {
  var _inspectionDetails$fr, _inspectionDetails$fr2, _inspectionDetails$fr3, _inspectionDetails$fr4, _inspectionDetails$re, _inspectionDetails$re2, _inspectionDetails$re3, _inspectionDetails$re4, _inspectionDetails$le, _inspectionDetails$le2, _inspectionDetails$le3, _inspectionDetails$le4, _inspectionDetails$ri, _inspectionDetails$ri2, _inspectionDetails$ri3, _inspectionDetails$ri4, _inspectionDetails$si, _inspectionDetails$co, _inspectionDetails$co2, _inspectionDetails$co3, _inspectionDetails$co4, _inspectionDetails$wh, _inspectionDetails$wh2, _inspectionDetails$wh3, _inspectionDetails$wh4, _inspectionDetails$de, _inspectionDetails$de2, _inspectionDetails$de3, _inspectionDetails$de4, _inspectionDetails$ge, _inspectionDetails$ge2, _inspectionDetails$ge3, _inspectionDetails$ge4, _inspectionDetails$ar, _inspectionDetails$ar2, _inspectionDetails$ar3, _inspectionDetails$ar4, _inspectionDetails$is, _inspectionDetails$is2, _inspectionDetails$is3, _inspectionDetails$is4, _inspectionDetails$at, _inspectionDetails$at2, _inspectionDetails$at3, _inspectionDetails$at4, _inspectionDetails$se, _inspectionDetails$se2, _inspectionDetails$se3, _inspectionDetails$se4, _inspectionDetails$is5, _inspectionDetails$is6, _inspectionDetails$is7, _inspectionDetails$is8, _inspectionDetails$is9, _inspectionDetails$is10, _inspectionDetails$is11, _inspectionDetails$is12, _inspectionDetails$is13, _inspectionDetails$is14, _inspectionDetails$is15, _inspectionDetails$is16, _inspectionDetails$is17, _inspectionDetails$is18, _inspectionDetails$is19, _inspectionDetails$is20, _inspectionDetails$is21, _inspectionDetails$is22, _inspectionDetails$is23, _inspectionDetails$is24, _inspectionDetails$is25, _inspectionDetails$is26, _inspectionDetails$is27, _inspectionDetails$is28, _inspectionDetails$is29, _inspectionDetails$is30, _inspectionDetails$is31, _inspectionDetails$is32, _inspectionDetails$is33, _inspectionDetails$is34, _inspectionDetails$is35, _inspectionDetails$is36, _inspectionDetails$lo, _inspectionDetails$lo2, _inspectionDetails$lo3, _inspectionDetails$lo4, _inspectionDetails$pl, _inspectionDetails$pl2, _inspectionDetails$pl3, _inspectionDetails$pl4, _inspectionDetails$is37, _inspectionDetails$is38, _inspectionDetails$is39, _inspectionDetails$is40, _inspectionDetails$wi, _inspectionDetails$wi2, _inspectionDetails$wi3, _inspectionDetails$wi4, _inspectionDetails$is41, _inspectionDetails$is42, _inspectionDetails$is43, _inspectionDetails$is44, _inspectionDetails$is45, _inspectionDetails$is46, _inspectionDetails$is47, _inspectionDetails$is48, _inspectionDetails$in, _inspectionDetails$in2, _inspectionDetails$in3, _inspectionDetails$in4, _inspectionDetails$Is, _inspectionDetails$Is2, _inspectionDetails$Is3, _inspectionDetails$Is4, _inspectionDetails$do;
  const formatTime = time => {
    return time ? dayjs.utc(time).local().format("DD MMM YYYY, hh:mm A") : "N/A";
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px",
      maxWidth: "100%",
      margin: "auto",
      background: "#fff",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
      borderRadius: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inspection-Card-bottom"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "inspection-Card-h1"
  }, "Site Inspection Form"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: "bold",
      color: "#333",
      display: "flex"
    }
  }, "Inspection On:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555"
    }
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.siteInspecionDateArea) || "N/A")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: "bold",
      color: "#333",
      display: "flex"
    }
  }, "Time From:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555"
    }
  }, formatTime(inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.siteInspecionTimeForm))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: "bold",
      color: "#333",
      display: "flex"
    }
  }, "Time From:"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555"
    }
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.siteInspecionTimeTO) || "N/A", formatTime(inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.siteInspecionTimeTO))))), /*#__PURE__*/React__default.createElement("div", {
    className: "inspection-Card-Top"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "inspection-Card-h1"
  }, "Dimension of each side of property in meter."), /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f2f2f2"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "As on Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "As on Site"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Observation"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "a) Front Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$fr = inspectionDetails.frontSide) === null || _inspectionDetails$fr === void 0 ? void 0 : _inspectionDetails$fr.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$fr2 = inspectionDetails.frontSide) === null || _inspectionDetails$fr2 === void 0 ? void 0 : _inspectionDetails$fr2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$fr3 = inspectionDetails.frontSide) === null || _inspectionDetails$fr3 === void 0 ? void 0 : _inspectionDetails$fr3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$fr4 = inspectionDetails.frontSide) === null || _inspectionDetails$fr4 === void 0 ? void 0 : _inspectionDetails$fr4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "b) Rear Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$re = inspectionDetails.rearSide) === null || _inspectionDetails$re === void 0 ? void 0 : _inspectionDetails$re.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$re2 = inspectionDetails.rearSide) === null || _inspectionDetails$re2 === void 0 ? void 0 : _inspectionDetails$re2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$re3 = inspectionDetails.rearSide) === null || _inspectionDetails$re3 === void 0 ? void 0 : _inspectionDetails$re3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$re4 = inspectionDetails.rearSide) === null || _inspectionDetails$re4 === void 0 ? void 0 : _inspectionDetails$re4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "c) Left Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$le = inspectionDetails.leftSide) === null || _inspectionDetails$le === void 0 ? void 0 : _inspectionDetails$le.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$le2 = inspectionDetails.leftSide) === null || _inspectionDetails$le2 === void 0 ? void 0 : _inspectionDetails$le2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$le3 = inspectionDetails.leftSide) === null || _inspectionDetails$le3 === void 0 ? void 0 : _inspectionDetails$le3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$le4 = inspectionDetails.leftSide) === null || _inspectionDetails$le4 === void 0 ? void 0 : _inspectionDetails$le4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "d) Right Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ri = inspectionDetails.rightSide) === null || _inspectionDetails$ri === void 0 ? void 0 : _inspectionDetails$ri.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ri2 = inspectionDetails.rightSide) === null || _inspectionDetails$ri2 === void 0 ? void 0 : _inspectionDetails$ri2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ri3 = inspectionDetails.rightSide) === null || _inspectionDetails$ri3 === void 0 ? void 0 : _inspectionDetails$ri3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ri4 = inspectionDetails.rightSide) === null || _inspectionDetails$ri4 === void 0 ? void 0 : _inspectionDetails$ri4.remarks) || "N/A")), (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$si = inspectionDetails.siteInspecionAnyOtherSide) === null || _inspectionDetails$si === void 0 ? void 0 : _inspectionDetails$si.length) > 0 ? inspectionDetails.siteInspecionAnyOtherSide.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "e) Any other side ", index + 1), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, item.sideName || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, item.onsiteMeasurement || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, item.observation || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, item.remarks || "N/A"))) : /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "e) Any other side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell,
    colSpan: 4
  }, "N/A"))))), /*#__PURE__*/React__default.createElement("div", {
    className: "inspection-Card-Top"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "inspection-Card-h1"
  }, "Status of Property/Plot"), /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f2f2f2"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "As on Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "As on Site"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Observation"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Construction Status"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$co = inspectionDetails.construction) === null || _inspectionDetails$co === void 0 ? void 0 : _inspectionDetails$co.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$co2 = inspectionDetails.construction) === null || _inspectionDetails$co2 === void 0 ? void 0 : _inspectionDetails$co2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$co3 = inspectionDetails.construction) === null || _inspectionDetails$co3 === void 0 ? void 0 : _inspectionDetails$co3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$co4 = inspectionDetails.construction) === null || _inspectionDetails$co4 === void 0 ? void 0 : _inspectionDetails$co4.remarks) || "N/A")), ((formData === null || formData === void 0 ? void 0 : formData.riskType) === "MEDIUM" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "HIGH") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Whether construction started"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wh = inspectionDetails.whetherConstructionStarted) === null || _inspectionDetails$wh === void 0 ? void 0 : _inspectionDetails$wh.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wh2 = inspectionDetails.whetherConstructionStarted) === null || _inspectionDetails$wh2 === void 0 ? void 0 : _inspectionDetails$wh2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wh3 = inspectionDetails.whetherConstructionStarted) === null || _inspectionDetails$wh3 === void 0 ? void 0 : _inspectionDetails$wh3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wh4 = inspectionDetails.whetherConstructionStarted) === null || _inspectionDetails$wh4 === void 0 ? void 0 : _inspectionDetails$wh4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Demolition Started"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$de = inspectionDetails.demolitionStarted) === null || _inspectionDetails$de === void 0 ? void 0 : _inspectionDetails$de.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$de2 = inspectionDetails.demolitionStarted) === null || _inspectionDetails$de2 === void 0 ? void 0 : _inspectionDetails$de2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$de3 = inspectionDetails.demolitionStarted) === null || _inspectionDetails$de3 === void 0 ? void 0 : _inspectionDetails$de3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$de4 = inspectionDetails.demolitionStarted) === null || _inspectionDetails$de4 === void 0 ? void 0 : _inspectionDetails$de4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is Property having extra Land"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ge = inspectionDetails.getExtraProperty) === null || _inspectionDetails$ge === void 0 ? void 0 : _inspectionDetails$ge.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ge2 = inspectionDetails.getExtraProperty) === null || _inspectionDetails$ge2 === void 0 ? void 0 : _inspectionDetails$ge2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ge3 = inspectionDetails.getExtraProperty) === null || _inspectionDetails$ge3 === void 0 ? void 0 : _inspectionDetails$ge3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ge4 = inspectionDetails.getExtraProperty) === null || _inspectionDetails$ge4 === void 0 ? void 0 : _inspectionDetails$ge4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "a) Area of extra land"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ar = inspectionDetails.areaOfExtraLand) === null || _inspectionDetails$ar === void 0 ? void 0 : _inspectionDetails$ar.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ar2 = inspectionDetails.areaOfExtraLand) === null || _inspectionDetails$ar2 === void 0 ? void 0 : _inspectionDetails$ar2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ar3 = inspectionDetails.areaOfExtraLand) === null || _inspectionDetails$ar3 === void 0 ? void 0 : _inspectionDetails$ar3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$ar4 = inspectionDetails.areaOfExtraLand) === null || _inspectionDetails$ar4 === void 0 ? void 0 : _inspectionDetails$ar4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "b)IS extra land Alloted by DA/UPAVP/SADA"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is = inspectionDetails.isExtraLandAllotedBy) === null || _inspectionDetails$is === void 0 ? void 0 : _inspectionDetails$is.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is2 = inspectionDetails.isExtraLandAllotedBy) === null || _inspectionDetails$is2 === void 0 ? void 0 : _inspectionDetails$is2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is3 = inspectionDetails.isExtraLandAllotedBy) === null || _inspectionDetails$is3 === void 0 ? void 0 : _inspectionDetails$is3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is4 = inspectionDetails.isExtraLandAllotedBy) === null || _inspectionDetails$is4 === void 0 ? void 0 : _inspectionDetails$is4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Attached Allotement Letter"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$at = inspectionDetails.attachedAllotement) === null || _inspectionDetails$at === void 0 ? void 0 : _inspectionDetails$at.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$at2 = inspectionDetails.attachedAllotement) === null || _inspectionDetails$at2 === void 0 ? void 0 : _inspectionDetails$at2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$at3 = inspectionDetails.attachedAllotement) === null || _inspectionDetails$at3 === void 0 ? void 0 : _inspectionDetails$at3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$at4 = inspectionDetails.attachedAllotement) === null || _inspectionDetails$at4 === void 0 ? void 0 : _inspectionDetails$at4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Can a seprate property be created"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$se = inspectionDetails.separateProperty) === null || _inspectionDetails$se === void 0 ? void 0 : _inspectionDetails$se.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$se2 = inspectionDetails.separateProperty) === null || _inspectionDetails$se2 === void 0 ? void 0 : _inspectionDetails$se2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$se3 = inspectionDetails.separateProperty) === null || _inspectionDetails$se3 === void 0 ? void 0 : _inspectionDetails$se3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$se4 = inspectionDetails.separateProperty) === null || _inspectionDetails$se4 === void 0 ? void 0 : _inspectionDetails$se4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is extra land is for offer"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is5 = inspectionDetails.isExtraLandOffer) === null || _inspectionDetails$is5 === void 0 ? void 0 : _inspectionDetails$is5.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is6 = inspectionDetails.isExtraLandOffer) === null || _inspectionDetails$is6 === void 0 ? void 0 : _inspectionDetails$is6.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is7 = inspectionDetails.isExtraLandOffer) === null || _inspectionDetails$is7 === void 0 ? void 0 : _inspectionDetails$is7.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is8 = inspectionDetails.isExtraLandOffer) === null || _inspectionDetails$is8 === void 0 ? void 0 : _inspectionDetails$is8.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by the water supply"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is9 = inspectionDetails.isPropertyAffectedByWater) === null || _inspectionDetails$is9 === void 0 ? void 0 : _inspectionDetails$is9.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is10 = inspectionDetails.isPropertyAffectedByWater) === null || _inspectionDetails$is10 === void 0 ? void 0 : _inspectionDetails$is10.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is11 = inspectionDetails.isPropertyAffectedByWater) === null || _inspectionDetails$is11 === void 0 ? void 0 : _inspectionDetails$is11.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is12 = inspectionDetails.isPropertyAffectedByWater) === null || _inspectionDetails$is12 === void 0 ? void 0 : _inspectionDetails$is12.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by the sewerage"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is13 = inspectionDetails.isPropertyAffectedBySewerage) === null || _inspectionDetails$is13 === void 0 ? void 0 : _inspectionDetails$is13.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is14 = inspectionDetails.isPropertyAffectedBySewerage) === null || _inspectionDetails$is14 === void 0 ? void 0 : _inspectionDetails$is14.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is15 = inspectionDetails.isPropertyAffectedBySewerage) === null || _inspectionDetails$is15 === void 0 ? void 0 : _inspectionDetails$is15.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is16 = inspectionDetails.isPropertyAffectedBySewerage) === null || _inspectionDetails$is16 === void 0 ? void 0 : _inspectionDetails$is16.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by the Electrical Line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is17 = inspectionDetails.isPropertyAffectedByElectricity) === null || _inspectionDetails$is17 === void 0 ? void 0 : _inspectionDetails$is17.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is18 = inspectionDetails.isPropertyAffectedByElectricity) === null || _inspectionDetails$is18 === void 0 ? void 0 : _inspectionDetails$is18.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is19 = inspectionDetails.isPropertyAffectedByElectricity) === null || _inspectionDetails$is19 === void 0 ? void 0 : _inspectionDetails$is19.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is20 = inspectionDetails.isPropertyAffectedByElectricity) === null || _inspectionDetails$is20 === void 0 ? void 0 : _inspectionDetails$is20.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by the Drainage"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is21 = inspectionDetails.isPropertyAffectedByDrainage) === null || _inspectionDetails$is21 === void 0 ? void 0 : _inspectionDetails$is21.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is22 = inspectionDetails.isPropertyAffectedByDrainage) === null || _inspectionDetails$is22 === void 0 ? void 0 : _inspectionDetails$is22.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is23 = inspectionDetails.isPropertyAffectedByDrainage) === null || _inspectionDetails$is23 === void 0 ? void 0 : _inspectionDetails$is23.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is24 = inspectionDetails.isPropertyAffectedByDrainage) === null || _inspectionDetails$is24 === void 0 ? void 0 : _inspectionDetails$is24.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by railway line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is25 = inspectionDetails.isPropertyAffectedByRailway) === null || _inspectionDetails$is25 === void 0 ? void 0 : _inspectionDetails$is25.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is26 = inspectionDetails.isPropertyAffectedByRailway) === null || _inspectionDetails$is26 === void 0 ? void 0 : _inspectionDetails$is26.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is27 = inspectionDetails.isPropertyAffectedByRailway) === null || _inspectionDetails$is27 === void 0 ? void 0 : _inspectionDetails$is27.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is28 = inspectionDetails.isPropertyAffectedByRailway) === null || _inspectionDetails$is28 === void 0 ? void 0 : _inspectionDetails$is28.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by gas pipe line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is29 = inspectionDetails.isPropertyAffectedByGas) === null || _inspectionDetails$is29 === void 0 ? void 0 : _inspectionDetails$is29.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is30 = inspectionDetails.isPropertyAffectedByGas) === null || _inspectionDetails$is30 === void 0 ? void 0 : _inspectionDetails$is30.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is31 = inspectionDetails.isPropertyAffectedByGas) === null || _inspectionDetails$is31 === void 0 ? void 0 : _inspectionDetails$is31.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is32 = inspectionDetails.isPropertyAffectedByGas) === null || _inspectionDetails$is32 === void 0 ? void 0 : _inspectionDetails$is32.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is propoerty affected by any pond/lake or any natural body"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is33 = inspectionDetails.isPropertyAffectedByNaturalBody) === null || _inspectionDetails$is33 === void 0 ? void 0 : _inspectionDetails$is33.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is34 = inspectionDetails.isPropertyAffectedByNaturalBody) === null || _inspectionDetails$is34 === void 0 ? void 0 : _inspectionDetails$is34.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is35 = inspectionDetails.isPropertyAffectedByNaturalBody) === null || _inspectionDetails$is35 === void 0 ? void 0 : _inspectionDetails$is35.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is36 = inspectionDetails.isPropertyAffectedByNaturalBody) === null || _inspectionDetails$is36 === void 0 ? void 0 : _inspectionDetails$is36.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Location/key plan shown on drawing matches property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$lo = inspectionDetails.locationShownOnDrawingMatchesProperty) === null || _inspectionDetails$lo === void 0 ? void 0 : _inspectionDetails$lo.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$lo2 = inspectionDetails.locationShownOnDrawingMatchesProperty) === null || _inspectionDetails$lo2 === void 0 ? void 0 : _inspectionDetails$lo2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$lo3 = inspectionDetails.locationShownOnDrawingMatchesProperty) === null || _inspectionDetails$lo3 === void 0 ? void 0 : _inspectionDetails$lo3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$lo4 = inspectionDetails.locationShownOnDrawingMatchesProperty) === null || _inspectionDetails$lo4 === void 0 ? void 0 : _inspectionDetails$lo4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Plot boundaries and Area as per registery matches the site"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$pl = inspectionDetails.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _inspectionDetails$pl === void 0 ? void 0 : _inspectionDetails$pl.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$pl2 = inspectionDetails.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _inspectionDetails$pl2 === void 0 ? void 0 : _inspectionDetails$pl2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$pl3 = inspectionDetails.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _inspectionDetails$pl3 === void 0 ? void 0 : _inspectionDetails$pl3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$pl4 = inspectionDetails.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _inspectionDetails$pl4 === void 0 ? void 0 : _inspectionDetails$pl4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is land of Road widening and green belt falling in the Property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is37 = inspectionDetails.isLandRoadWideningGgreen) === null || _inspectionDetails$is37 === void 0 ? void 0 : _inspectionDetails$is37.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is38 = inspectionDetails.isLandRoadWideningGgreen) === null || _inspectionDetails$is38 === void 0 ? void 0 : _inspectionDetails$is38.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is39 = inspectionDetails.isLandRoadWideningGgreen) === null || _inspectionDetails$is39 === void 0 ? void 0 : _inspectionDetails$is39.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is40 = inspectionDetails.isLandRoadWideningGgreen) === null || _inspectionDetails$is40 === void 0 ? void 0 : _inspectionDetails$is40.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Width of Approch Road to reach property (in Mtr)"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wi = inspectionDetails.widthOfApprochRoadToReachProperty) === null || _inspectionDetails$wi === void 0 ? void 0 : _inspectionDetails$wi.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wi2 = inspectionDetails.widthOfApprochRoadToReachProperty) === null || _inspectionDetails$wi2 === void 0 ? void 0 : _inspectionDetails$wi2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wi3 = inspectionDetails.widthOfApprochRoadToReachProperty) === null || _inspectionDetails$wi3 === void 0 ? void 0 : _inspectionDetails$wi3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$wi4 = inspectionDetails.widthOfApprochRoadToReachProperty) === null || _inspectionDetails$wi4 === void 0 ? void 0 : _inspectionDetails$wi4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is the proposed property in possesion of owner"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is41 = inspectionDetails.isThePropertyPossesionOfOwner) === null || _inspectionDetails$is41 === void 0 ? void 0 : _inspectionDetails$is41.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is42 = inspectionDetails.isThePropertyPossesionOfOwner) === null || _inspectionDetails$is42 === void 0 ? void 0 : _inspectionDetails$is42.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is43 = inspectionDetails.isThePropertyPossesionOfOwner) === null || _inspectionDetails$is43 === void 0 ? void 0 : _inspectionDetails$is43.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is44 = inspectionDetails.isThePropertyPossesionOfOwner) === null || _inspectionDetails$is44 === void 0 ? void 0 : _inspectionDetails$is44.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Is plot adjoining any government land/government building"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is45 = inspectionDetails.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _inspectionDetails$is45 === void 0 ? void 0 : _inspectionDetails$is45.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is46 = inspectionDetails.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _inspectionDetails$is46 === void 0 ? void 0 : _inspectionDetails$is46.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is47 = inspectionDetails.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _inspectionDetails$is47 === void 0 ? void 0 : _inspectionDetails$is47.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$is48 = inspectionDetails.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _inspectionDetails$is48 === void 0 ? void 0 : _inspectionDetails$is48.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Infrastructure facilities such as water supply, sewerage, drainage, electrical supply availbale for property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$in = inspectionDetails.infraFacilitiesAvailableForProperty) === null || _inspectionDetails$in === void 0 ? void 0 : _inspectionDetails$in.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$in2 = inspectionDetails.infraFacilitiesAvailableForProperty) === null || _inspectionDetails$in2 === void 0 ? void 0 : _inspectionDetails$in2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$in3 = inspectionDetails.infraFacilitiesAvailableForProperty) === null || _inspectionDetails$in3 === void 0 ? void 0 : _inspectionDetails$in3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$in4 = inspectionDetails.infraFacilitiesAvailableForProperty) === null || _inspectionDetails$in4 === void 0 ? void 0 : _inspectionDetails$in4.remarks) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, "Does you property lies in the vicinity of the protected monumentals of Heritage Destination"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$Is = inspectionDetails.IsPropertyLiesInVicinityOfHeritageDestination) === null || _inspectionDetails$Is === void 0 ? void 0 : _inspectionDetails$Is.planOn) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$Is2 = inspectionDetails.IsPropertyLiesInVicinityOfHeritageDestination) === null || _inspectionDetails$Is2 === void 0 ? void 0 : _inspectionDetails$Is2.onSite) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$Is3 = inspectionDetails.IsPropertyLiesInVicinityOfHeritageDestination) === null || _inspectionDetails$Is3 === void 0 ? void 0 : _inspectionDetails$Is3.observation) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell
  }, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$Is4 = inspectionDetails.IsPropertyLiesInVicinityOfHeritageDestination) === null || _inspectionDetails$Is4 === void 0 ? void 0 : _inspectionDetails$Is4.remarks) || "N/A"))))), /*#__PURE__*/React__default.createElement("div", {
    className: "inspection-Card-Tb"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "inspection-Card-h1"
  }, "Site Inspection Form"), /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Recommendation")), /*#__PURE__*/React__default.createElement(TableCell$1, null, (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.siteInspectionRecommendation) || "N/A")), inspectionDetails === null || inspectionDetails === void 0 ? void 0 : (_inspectionDetails$do = inspectionDetails.documentInspection) === null || _inspectionDetails$do === void 0 ? void 0 : _inspectionDetails$do.map((doc, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Document")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: doc === null || doc === void 0 ? void 0 : doc.fileStoreUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  }))))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Remark")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: (inspectionDetails === null || inspectionDetails === void 0 ? void 0 : inspectionDetails.developerRemarks) || "N/A"
  })))))))));
};
const tableHeader = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "left",
  fontWeight: "bold"
};
const tableCell = {
  padding: "10px",
  border: "1px solid #ccc"
};

const DetailInfoTable = ({
  detailData,
  type: _type = "paymentDetails",
  formData
}) => {
  var _popupData$paymentDet, _popupData$paymentDet2, _popupData$paymentDet3, _popupData$paymentDet4, _popupData$paymentDet5, _docPopupData$inspect, _docPopupData$inspect2, _docPopupData$inspect3, _docPopupData$inspect4, _docPopupData$inspect5;
  const getLatestLogPerOfficer = data => {
    if (!Array.isArray(data)) {
      return data ? [data] : [];
    }
    if (!data.length) {
      return [];
    }
    const latestByOfficer = {};
    data.forEach(item => {
      var _item$auditDetails, _existingItem$auditDe;
      const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
      const officerKey = (user === null || user === void 0 ? void 0 : user.uuid) || (user === null || user === void 0 ? void 0 : user.employeeId) || (user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "unknown";
      const currentTime = new Date((item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0).getTime();
      const existingItem = latestByOfficer[officerKey];
      if (!existingItem) {
        latestByOfficer[officerKey] = item;
        return;
      }
      const existingTime = new Date((existingItem === null || existingItem === void 0 ? void 0 : (_existingItem$auditDe = existingItem.auditDetails) === null || _existingItem$auditDe === void 0 ? void 0 : _existingItem$auditDe.createdTime) || 0).getTime();
      if (currentTime > existingTime) {
        latestByOfficer[officerKey] = item;
      }
    });
    return Object.values(latestByOfficer);
  };
  const detailsArray = getLatestLogPerOfficer(detailData);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const [docPopupData, setDocPopupData] = useState(null);
  const formatTime = time => {
    return time ? dayjs.utc(time).local().format("DD MMM YYYY, hh:mm A") : "N/A";
  };
  const openPopup = item => {
    var _item$auditDetails2;
    let rows = [];
    if (_type === "paymentDetails") {
      var _item$paymentDetails, _item$paymentDetails$, _item$paymentDetails$2;
      rows = (item === null || item === void 0 ? void 0 : (_item$paymentDetails = item.paymentDetails) === null || _item$paymentDetails === void 0 ? void 0 : (_item$paymentDetails$ = _item$paymentDetails.paymentHead) === null || _item$paymentDetails$ === void 0 ? void 0 : (_item$paymentDetails$2 = _item$paymentDetails$[0]) === null || _item$paymentDetails$2 === void 0 ? void 0 : _item$paymentDetails$2.paymentHeads) || [];
    } else if (_type === "inspectionDetails") {
      rows = (item === null || item === void 0 ? void 0 : item.inspectionDetails) || {};
    } else if (_type === "documentDetails") {
      var _item$documentDetails;
      rows = (item === null || item === void 0 ? void 0 : (_item$documentDetails = item.documentDetails) === null || _item$documentDetails === void 0 ? void 0 : _item$documentDetails.documents) || [];
    }
    setSelectedDetails(rows);
    setUserDetails((item === null || item === void 0 ? void 0 : item.userDetails) || {});
    setCreatedTime((item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || null);
    setPopupData(item);
    setShowPopup(true);
    console.log("Selected Item for Popup:", item);
  };
  const openPopupDocument = item => {
    if (_type === "inspectionDetails") {
      setDocPopupData(item);
      setShowDocPopup(true);
    }
  };
  const closePopup = () => {
    setShowPopup(false);
    setSelectedDetails([]);
    setUserDetails(null);
    setPopupData(null);
  };
  const printPopup = () => {
    const popupContent = document.getElementById("popup-print-content");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Details</title>
          <style>
            body {
              font-size: 11px;
              font-family: Arial;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th,
            td {
              border: 1px solid #ccc;
              padding: 6px;
            }

            th {
              background-color: #e2e8f0;
              font-size: 13px;
            }
          </style>
        </head>

        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      fontSize: "16px",
      fontWeight: 600,
      marginBottom: "10px",
      backgroundColor: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      padding: "5px"
    }
  }, _type === "paymentDetails" ? "Payment Remarks Summary" : _type === "inspectionDetails" ? "Inspection Remarks Summary" : "Document Details Summary"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "800px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, _type === "documentDetails" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("th", null, "User"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Recommendation"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "View")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("th", null, "User"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Recommendation"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Details"), _type === "inspectionDetails" && /*#__PURE__*/React__default.createElement("th", null, "Documents"), /*#__PURE__*/React__default.createElement("th", null, "Remarks")))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray.map((item, idx) => {
    var _item$paymentDetails2, _item$inspectionDetai, _item$inspectionDetai2, _item$documentDetails2, _item$paymentDetails3, _item$inspectionDetai3, _item$documentDetails3, _item$auditDetails3, _item$auditDetails4;
    const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
    const remarks = _type === "paymentDetails" ? item === null || item === void 0 ? void 0 : (_item$paymentDetails2 = item.paymentDetails) === null || _item$paymentDetails2 === void 0 ? void 0 : _item$paymentDetails2.developerRemarks : _type === "inspectionDetails" ? item === null || item === void 0 ? void 0 : (_item$inspectionDetai = item.inspectionDetails) === null || _item$inspectionDetai === void 0 ? void 0 : (_item$inspectionDetai2 = _item$inspectionDetai.inspectionReportData) === null || _item$inspectionDetai2 === void 0 ? void 0 : _item$inspectionDetai2.developerRemarks : item === null || item === void 0 ? void 0 : (_item$documentDetails2 = item.documentDetails) === null || _item$documentDetails2 === void 0 ? void 0 : _item$documentDetails2.developerRemarks;
    const recommendation = _type === "paymentDetails" ? item === null || item === void 0 ? void 0 : (_item$paymentDetails3 = item.paymentDetails) === null || _item$paymentDetails3 === void 0 ? void 0 : _item$paymentDetails3.dataRecommendation : _type === "inspectionDetails" ? item === null || item === void 0 ? void 0 : (_item$inspectionDetai3 = item.inspectionDetails) === null || _item$inspectionDetai3 === void 0 ? void 0 : _item$inspectionDetai3.siteInspectionRecommendation : item === null || item === void 0 ? void 0 : (_item$documentDetails3 = item.documentDetails) === null || _item$documentDetails3 === void 0 ? void 0 : _item$documentDetails3.dataRecommendation;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: idx
    }, _type === "documentDetails" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, recommendation || "-"), /*#__PURE__*/React__default.createElement("td", null, formatTime(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime)), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    }), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopup(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, recommendation || "-"), /*#__PURE__*/React__default.createElement("td", null, formatTime(item === null || item === void 0 ? void 0 : (_item$auditDetails4 = item.auditDetails) === null || _item$auditDetails4 === void 0 ? void 0 : _item$auditDetails4.createdTime)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopup(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }))), _type === "inspectionDetails" && /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopupDocument(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }))), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    })));
  })))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "60%",
      transform: "translateX(-50%)",
      backgroundColor: "#f3f4f6",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px"
    }
  }, _type === "paymentDetails" ? "Payment Heads" : _type === "inspectionDetails" ? "Inspection Info" : "Document Details"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "popup-print-content"
  }, userDetails && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.employeeName) || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.name) || "-", " ", "|", " ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.designation) || "-", " ", "| ", /*#__PURE__*/React__default.createElement("strong", null, "Role:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.role) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Created At:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: createdTime
  })), _type === "inspectionDetails" ? /*#__PURE__*/React__default.createElement(InspectionViewseer, {
    inspectionDetails: selectedDetails,
    formData: formData
  }) : /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, _type === "documentDetails" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("th", null, "Document Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Document Status"), /*#__PURE__*/React__default.createElement("th", null, "Document Type"), /*#__PURE__*/React__default.createElement("th", null, "File Name")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("th", null, "Fee Type"), /*#__PURE__*/React__default.createElement("th", null, "Plot BUA"), /*#__PURE__*/React__default.createElement("th", null, "Rate"), /*#__PURE__*/React__default.createElement("th", null, "Amount")))), /*#__PURE__*/React__default.createElement("tbody", null, selectedDetails === null || selectedDetails === void 0 ? void 0 : selectedDetails.map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, _type === "paymentDetails" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.feeType), /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.plotBuildUpArea), /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.rate), /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.amount)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.documentRemarks), /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.documentStatus), /*#__PURE__*/React__default.createElement("td", null, row === null || row === void 0 ? void 0 : row.documentType), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.fileStoreUrl) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: row.fileStoreUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    style: {
      marginLeft: 8
    },
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })))))))), _type === "paymentDetails" && (popupData === null || popupData === void 0 ? void 0 : (_popupData$paymentDet = popupData.paymentDetails) === null || _popupData$paymentDet === void 0 ? void 0 : (_popupData$paymentDet2 = _popupData$paymentDet.paymentHead) === null || _popupData$paymentDet2 === void 0 ? void 0 : (_popupData$paymentDet3 = _popupData$paymentDet2[0]) === null || _popupData$paymentDet3 === void 0 ? void 0 : _popupData$paymentDet3.estimateAmount) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 0",
      fontWeight: "bold"
    }
  }, "Estimated Total Amount: \u20B9", (_popupData$paymentDet4 = popupData.paymentDetails.paymentHead) === null || _popupData$paymentDet4 === void 0 ? void 0 : (_popupData$paymentDet5 = _popupData$paymentDet4[0]) === null || _popupData$paymentDet5 === void 0 ? void 0 : _popupData$paymentDet5.estimateAmount.toLocaleString("en-IN")))), showDocPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "60%",
      transform: "translateX(-50%)",
      backgroundColor: "#f3f4f6",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px"
    }
  }, "Document View"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setShowDocPopup(false),
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), (docPopupData === null || docPopupData === void 0 ? void 0 : (_docPopupData$inspect = docPopupData.inspectionDetails) === null || _docPopupData$inspect === void 0 ? void 0 : (_docPopupData$inspect2 = _docPopupData$inspect.inspectionReportData) === null || _docPopupData$inspect2 === void 0 ? void 0 : (_docPopupData$inspect3 = _docPopupData$inspect2.documentInspection) === null || _docPopupData$inspect3 === void 0 ? void 0 : _docPopupData$inspect3.length) > 0 && /*#__PURE__*/React__default.createElement(InspectionPhotoViewer, {
    documentInspection: docPopupData === null || docPopupData === void 0 ? void 0 : (_docPopupData$inspect4 = docPopupData.inspectionDetails) === null || _docPopupData$inspect4 === void 0 ? void 0 : (_docPopupData$inspect5 = _docPopupData$inspect4.inspectionReportData) === null || _docPopupData$inspect5 === void 0 ? void 0 : _docPopupData$inspect5.documentInspection
  })));
};

const ViewDocuments = ({
  documentSection,
  setIsPreviewLoading,
  iframeSrc,
  setIframeSrc
}) => {
  var _filterDocumentTypes;
  const [loading, setLoading] = useState(false);
  console.log("iframeSrcFromView", iframeSrc);
  const filterDocumentTypes = data => {
    return data.filter(item => !/_([1-6])$/.test(item === null || item === void 0 ? void 0 : item.documentType));
  };
  const docSection = (documentSection === null || documentSection === void 0 ? void 0 : documentSection.filter(doc => !["signature", "applicantPhoto", "kmlFile"].includes(doc.documentType) && doc.isNoc !== "true")) || [];
  const handleLoadPage = async fileStoreId => {
    const url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
    console.log("handleCHangeisTriggered", fileStoreId, typeof url, url);
    setIframeSrc(url);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "view-documents-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bg-white document-all-document"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Documents"), (_filterDocumentTypes = filterDocumentTypes(docSection)) === null || _filterDocumentTypes === void 0 ? void 0 : _filterDocumentTypes.map((doc, index) => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement("div", {
      key: doc.fileStoreId,
      className: "document-item",
      onClick: () => handleLoadPage(doc.fileStoreId)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "document-info"
    }, /*#__PURE__*/React__default.createElement("span", null, index + 1, " ", (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.title) || (doc === null || doc === void 0 ? void 0 : doc.documentType))), /*#__PURE__*/React__default.createElement("div", {
      className: "document-icon"
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      className: "view-doc-icon-pdf"
    })));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "iframe-container"
  }, loading ? /*#__PURE__*/React__default.createElement(Loader, null) : iframeSrc && iframeSrc.toLowerCase().includes(".kml") ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "20px"
    }
  }) : /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: iframeSrc,
    title: "Document Viewer"
  }))));
};

const types$7 = {
  UPDATE_CHECKLIST_REVIEW: "UPDATE_CHECKLIST_REVIEW",
  SET_APPLICATION_DATA: "SET_APPLICATION_DATA"
};
const updateInspectionReportData = data => ({
  type: types$7.UPDATE_CHECKLIST_REVIEW,
  payload: data
});

function FileUploader$3({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  tab,
  showError,
  setShowError,
  setFile,
  maxFiles = 5,
  templateMessage = false,
  isMigrated = false
}) {
  console.log("inside Land use uploader", showError, name);
  const {
    control
  } = useForm();
  const fileInputRef = useRef();
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("documentsFromUploader", documents);
  const dispatch = useDispatch();
  const {
    addFormMTDoc,
    removeFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const uploadedFiles = (documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === name)) || [];
  const isDrawingPdf = name === "drawingPdf" || name === "drawingPDF" || name === "compoundingDrawingPdf" || typeof label === "string" && label.toLowerCase().includes("drawing") && label.toLowerCase().includes("pdf");
  const handleFileUpload = async (e, inputName) => {
    const file = e.target.files[0];
    console.log("insideFileUpload");
    setIsLoading(true);
    setShowToast(null);
    const invalidMalwareExtensions = ["php", "php3", "php4", "php5", "phtml", "asp", "aspx", "jsp", "jspx", "cfm", "exe", "bat", "cmd", "sh", "com", "scr", "msi", "jar", "vbs", "ps1", "dll", "docm", "xlsm", "pptm", "dotm", "xltm", "html", "htm", "js", "xml", "svg", "zip", "rar", "7z", "tar", "gz", "iso"];
    const fileParts = file.name.toLowerCase().split(".");
    const intermediateParts = fileParts.slice(0, -1);
    const hasMaliciousExtension = intermediateParts.some(part => invalidMalwareExtensions.includes(part));
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    if (hasMaliciousExtension) {
      setShowToast({
        error: true,
        label: "Invalid file name: contains potentially dangerous extensions."
      });
      setIsLoading(false);
      return;
    }
    if ((documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === name).length) >= maxFiles) {
      setShowToast({
        error: true,
        label: `You can upload a maximum of ${maxFiles} files.`
      });
      setIsLoading(false);
      return;
    }
    if (tab === 1) {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.pdf, .PDF)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 10 MB."
        });
        setIsLoading(false);
        return;
      }
    } else if (tab === 2) {
      const allowedFormats = [".png", ".jpg", ".jpeg", ".JPG", ".PNG", ".JPEG"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.png, .jpg, .jpeg)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 10 MB."
        });
        setIsLoading(false);
        return;
      }
    } else if (tab === 3) {
      const allowedFormats = [".dxf", ".DXF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.dxf)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 300 MB."
        });
        setIsLoading(false);
        return;
      }
      setFile(file);
    } else if (tab === 5) {
      const allowedFormats = [".dxf", ".DXF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.dxf)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 300 MB."
        });
        setIsLoading(false);
        return;
      }
    } else if (tab === 6) {
      const allowedFormats = [".xls", ".XLS", ".xlsx", ".XLSX"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.xls, .xlsx)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 300 MB."
        });
        setIsLoading(false);
        return;
      }
    } else {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file in a pdf format"
        });
        setIsLoading(false);
        return;
      }
      const isDrawingPdfFile = isDrawingPdf || inputName === "drawingPdf" || inputName === "drawingPDF" || inputName === "compoundingDrawingPdf";
      const maxSizeInBytes = isDrawingPdfFile ? 150 * 1024 * 1024 : 30 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: `File size exceeds the maximum limit of ${maxSizeInBytes / (1024 * 1024)} MB.`
        });
        setIsLoading(false);
        return;
      }
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", "up");
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      if ((documents === null || documents === void 0 ? void 0 : documents.filter(doc => doc.documentType === inputName).length) >= maxFiles) {
        removeFormMTDoc(inputName);
      }
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addFormMTDoc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        isMandatory,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
      e.target.value = null;
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: "flex-start"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: `label`,
    style: {
      width: "100%"
    }
  }, label, templateMessage && /*#__PURE__*/React__default.createElement("span", {
    className: "template-Text"
  }, "AS PER TEMPLATE"), isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flexDirection: "column",
      position: "relative",
      width: "100%",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true,
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      display: "flex",
      justifyContent: "space-between",
      height: "30px",
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c",
        color: "#fff"
      }
    }
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "center",
      position: "absolute",
      alignItems: "center",
      display: "flex",
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: "absolute",
      fontSize: "0.5rem",
      marginLeft: "8em"
    }
  }, isDrawingPdf && typeof validationMsg === "string" ? validationMsg.replace("30 MB", "150 MB") : validationMsg))), /*#__PURE__*/React__default.createElement(Controller, {
    name: "fileInput",
    control: control,
    rules: {
      required: required && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name))
    },
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement("input", Object.assign({}, field, {
      ref: fileInputRef,
      type: "file",
      name: name,
      style: {
        display: "none"
      },
      onChange: e => handleFileUpload(e, name)
    }))
  })))), !isLoading && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map(doc => {
    var _doc$additionalDetail;
    if (doc.documentType !== name) return null;
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: "space-between",
        p: "0.25rem 0 0.25rem 0.75rem",
        backgroundColor: "#eee",
        borderRadius: "0.25rem",
        wordBreak: "break-all",
        alignItems: "center",
        display: "flex",
        lineHeight: 1,
        flex: 1,
        mb: 0.5,
        mt: 1,
        height: "18px",
        fontSize: "0.6rem"
      },
      key: doc.fileStoreId,
      className: "file-wrapper-name"
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => isMigrated ? getDocumentByFileStoreIdV2(doc.fileStoreId, setIsPreviewLoading) : getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, null) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => removeFormMTDoc(doc.documentType)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  })) || null, required && showError && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name)) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, `${hasLabel ? label : "Above"} document is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label));
}

const BasicSiteInspectionReport = ({
  formData,
  callInspectionDetailsAPI,
  userRolesArray,
  onSelect,
  isFromDashboard,
  detailData,
  handleTabChange
}) => {
  var _userRolesArray$, _userRolesArray$2, _userRolesArray$3, _formData$inspectionD3, _formData$inspectionD4, _formData$inspectionD5, _formData$inspectionD6, _formData$description, _formData$description2, _formData$inspectionD7, _formData$inspectionD8, _formData$inspectionD9, _formData$inspectionD10, _formData$inspectionD11, _formData$inspectionD12, _formData$inspectionD13, _formData$inspectionD14, _formData$inspectionD15, _formData$inspectionD16, _formData$inspectionD17, _formData$inspectionD18, _formData$inspectionD19, _formData$inspectionD20, _formData$inspectionD21, _formData$inspectionD22, _formData$inspectionD23, _formData$inspectionD24, _formData$inspectionD25, _formData$inspectionD26, _formData$inspectionD27, _formData$inspectionD28, _formData$inspectionD29, _formData$inspectionD30, _formData$inspectionD31, _formData$inspectionD32, _formData$inspectionD33, _formData$inspectionD34, _formData$inspectionD35, _formData$inspectionD36, _formData$inspectionD37, _formData$inspectionD38, _formData$inspectionD39, _formData$inspectionD40, _formData$inspectionD41, _formData$inspectionD42, _formData$inspectionD43, _formData$inspectionD44, _formData$inspectionD45, _formData$inspectionD46, _formData$inspectionD47, _formData$inspectionD48, _formData$inspectionD49, _formData$inspectionD50, _formData$inspectionD51, _formData$inspectionD52, _formData$inspectionD53, _formData$inspectionD54, _formData$inspectionD55, _formData$inspectionD56, _formData$inspectionD57, _formData$inspectionD58, _formData$inspectionD59, _formData$inspectionD60, _formData$inspectionD61, _formData$inspectionD62, _formData$inspectionD63, _formData$inspectionD64, _formData$inspectionD65, _formData$inspectionD66, _formData$inspectionD67, _formData$inspectionD68, _formData$inspectionD69, _formData$inspectionD70, _formData$inspectionD71, _formData$inspectionD72, _formData$inspectionD73, _formData$inspectionD74, _formData$inspectionD75, _formData$inspectionD76, _formData$inspectionD77, _formData$inspectionD78, _formData$inspectionD79, _formData$inspectionD80, _formData$inspectionD81, _formData$inspectionD82, _formData$inspectionD83, _formData$inspectionD84, _formData$inspectionD85, _formData$inspectionD86, _formData$inspectionD87, _formData$inspectionD88, _formData$inspectionD89, _formData$inspectionD90, _formData$inspectionD91, _formData$inspectionD92, _formData$inspectionD93, _formData$inspectionD94, _formData$inspectionD95, _formData$inspectionD96, _formData$inspectionD97, _formData$inspectionD98, _formData$inspectionD99, _formData$inspectionD100, _formData$inspectionD101, _formData$inspectionD102, _formData$inspectionD103, _formData$inspectionD104, _formData$inspectionD105, _formData$inspectionD106, _formData$inspectionD107, _formData$inspectionD108, _formData$inspectionD109, _formData$inspectionD110, _formData$inspectionD111, _formData$inspectionD112, _formData$inspectionD113, _formData$inspectionD114, _formData$inspectionD115, _formData$inspectionD116, _formData$inspectionD117, _formData$inspectionD118, _formData$inspectionD119, _formData$inspectionD120, _formData$inspectionD121, _formData$inspectionD122, _formData$inspectionD123, _formData$inspectionD124, _formData$inspectionD125, _formData$inspectionD126, _formData$inspectionD127, _formData$inspectionD128, _formData$inspectionD129, _formData$inspectionD130, _formData$inspectionD131, _formData$inspectionD132, _formData$inspectionD133, _formData$inspectionD134, _formData$inspectionD135, _formData$inspectionD136, _formData$inspectionD137, _formData$inspectionD138, _formData$inspectionD139, _formData$inspectionD140, _formData$inspectionD141, _formData$inspectionD142, _formData$inspectionD143, _formData$inspectionD144, _formData$inspectionD145, _formData$inspectionD146, _formData$inspectionD147, _formData$inspectionD148, _formData$inspectionD149, _formData$inspectionD150, _formData$inspectionD151, _formData$inspectionD152, _formData$inspectionD153, _formData$inspectionD154, _formData$inspectionD155, _formData$inspectionD156, _formData$inspectionD157, _formData$inspectionD158, _formData$inspectionD159, _formData$inspectionD160, _formData$inspectionD161, _formData$inspectionD162, _formData$inspectionD163, _formData$inspectionD164, _formData$inspectionD165, _formData$inspectionD166, _formData$inspectionD167, _formData$inspectionD168, _formData$inspectionD169, _formData$inspectionD170, _formData$inspectionD171, _formData$inspectionD172, _formData$inspectionD173, _formData$inspectionD174, _formData$inspectionD175, _formData$inspectionD176, _formData$inspectionD177, _formData$inspectionD178, _formData$inspectionD179, _formData$inspectionD180, _formData$inspectionD181, _formData$inspectionD182, _formData$inspectionD183, _formData$inspectionD184, _formData$inspectionD185, _formData$inspectionD186, _formData$inspectionD187, _formData$inspectionD188, _formData$inspectionD189, _formData$inspectionD190, _formData$inspectionD191, _formData$inspectionD192, _formData$inspectionD193, _formData$inspectionD194, _formData$inspectionD195, _formData$inspectionD196, _formData$inspectionD197, _formData$inspectionD198, _formData$inspectionD199, _formData$inspectionD200, _formData$inspectionD201, _formData$inspectionD202, _formData$inspectionD203, _formData$inspectionD204, _formData$inspectionD205, _formData$inspectionD206, _formData$inspectionD207, _formData$inspectionD208, _formData$inspectionD209, _formData$inspectionD210, _formData$inspectionD211, _formData$inspectionD212, _formData$inspectionD213, _formData$inspectionD214, _formData$inspectionD215, _formData$inspectionD216, _formData$inspectionD217, _formData$inspectionD218, _formData$inspectionD219, _formData$inspectionD220, _formData$inspectionD221, _formData$inspectionD222, _formData$inspectionD223, _formData$inspectionD224, _formData$inspectionD225, _formData$inspectionD226, _formData$inspectionD227, _formData$inspectionD228, _formData$inspectionD229, _formData$inspectionD230, _formData$inspectionD231, _formData$inspectionD232, _formData$inspectionD233, _formData$inspectionD234, _formData$inspectionD235, _formData$inspectionD236, _formData$inspectionD237, _formData$inspectionD238, _formData$inspectionD239, _formData$inspectionD240, _formData$inspectionD241, _formData$inspectionD242, _formData$inspectionD243, _formData$inspectionD244, _formData$inspectionD245, _formData$inspectionD246, _formData$inspectionD247, _formData$inspectionD248, _formData$inspectionD249, _formData$inspectionD250, _formData$inspectionD251, _formData$inspectionD252, _formData$inspectionD253, _formData$inspectionD254, _formData$inspectionD255, _formData$inspectionD256, _formData$inspectionD257, _formData$inspectionD258, _getSitePhotoByJE$, _getSitePhotoByJE$3, _getSitePhotoByJE$4, _getSitePhotoByJE$5;
  const [expandedRows, setExpandedRows] = useState(["front"]);
  const [expandedRowsConstruction, setExpandedRowsConstruction] = useState(["Construction"]);
  const [docPopupData, setDocPopupData] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const getSitePhotoByJE = detailData === null || detailData === void 0 ? void 0 : detailData.flatMap(item => {
    var _item$inspectionDetai, _item$inspectionDetai2;
    return ((_item$inspectionDetai = item.inspectionDetails) === null || _item$inspectionDetai === void 0 ? void 0 : (_item$inspectionDetai2 = _item$inspectionDetai.inspectionReportData) === null || _item$inspectionDetai2 === void 0 ? void 0 : _item$inspectionDetai2.documentInspection) || [];
  });
  console.log(getSitePhotoByJE, "UPLOADED SITE PHOTO");
  const filteredDocuments = formData === null || formData === void 0 ? void 0 : formData.documents.filter(doc => doc.documentType === "sitePhoto");
  const isRevalidation = formData === null || formData === void 0 ? void 0 : formData.land_Id;
  console.log("fromsiteInspection", detailData, formData);
  const sessionData = JSON.parse(sessionStorage.getItem("inspectionReportData"));
  const defaultValues = {
    ...sessionData,
    siteInspecionAnyOtherSide: [{
      sideName: "",
      onsiteMeasurement: "",
      observation: "",
      remarks: ""
    }]
  };
  const {
    documents
  } = useSelector(state => state.formMT);
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.inspectionReportData);
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "JE";
  console.log("USSERASS", userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code);
  const isAVPandEE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code) === "EE" && (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP";
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues
  });
  const dispatch = useDispatch();
  const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
  const [regStatus, setregStatus] = useState("");
  const [storedData, setStoredData] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [siteInspectionDocs, setSiteInspectionDocs] = useState([]);
  const [disabledData, setDisabledData] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const Modal = useModal();
  const handleChange = e => {
    console.log("e", e, e.target.name, e.target.value);
    const {
      name,
      value
    } = e.target;
    dispatch(updateChecklistFormField(name, value));
    if (name === "isPossesionAreaDiff") {
      setIsPossessionAreaDiff(value);
    } else if (name === "registryStatus") {
      setregStatus(value);
    }
  };
  const toggleRow = sectionKey => {
    setExpandedRows(prev => prev.includes(sectionKey) ? prev.filter(key => key !== sectionKey) : [...prev, sectionKey]);
  };
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "siteInspecionAnyOtherSide"
  });
  const [openRows, setOpenRows] = useState({});
  const toggleRowConstruction = sectionKey => {
    setExpandedRowsConstruction(prev => prev.includes(sectionKey) ? prev.filter(key => key !== sectionKey) : [...prev, sectionKey]);
  };
  const onSubmit = async data => {
    var _data$siteInspecionTi, _data$siteInspecionTi2;
    console.log("Form submitted:", data, siteInspectionDocs);
    data.inspectionReportData = {
      ...data.inspectionReportData,
      developerRemarks: developerRemarks,
      documentInspection: [...(siteInspectionDocs || []), ...(getSitePhotoByJE || [])].filter((doc, index, self) => index === self.findIndex(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) === (doc === null || doc === void 0 ? void 0 : doc.fileStoreId))),
      siteInspecionTimeForm: dayjs((_data$siteInspecionTi = data.siteInspecionTimeForm) === null || _data$siteInspecionTi === void 0 ? void 0 : _data$siteInspecionTi.$d).format("HH:mm") || "",
      siteInspecionTimeTO: dayjs((_data$siteInspecionTi2 = data.siteInspecionTimeTO) === null || _data$siteInspecionTi2 === void 0 ? void 0 : _data$siteInspecionTi2.$d).format("HH:mm") || ""
    };
    console.log("Form submitted1", data);
    dispatch(updateInspectionReportData(data));
    if ((isJE || isAVPandEE) && (formData === null || formData === void 0 ? void 0 : formData.inspectionDetailData) === null) {
      console.log("I am here 129");
      handleSubmitUpdate(data);
    } else if ((isJE || isAVPandEE) && (data === null || data === void 0 ? void 0 : data.siteInspecionDueDateArea) === null) {
      console.log("I am here 132");
      handleSubmitUpdate(data);
    } else {
      console.log("I am here 135");
      callInspectionDetailsAPI(data);
      handleSubmitUpdate(data);
      handleTabChange(4);
    }
  };
  useEffect(() => {
    var _userRolesArray$4;
    const userRoleCode = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$4 = userRolesArray[0]) === null || _userRolesArray$4 === void 0 ? void 0 : _userRolesArray$4.code;
    if (userRoleCode === "JE" && (formData === null || formData === void 0 ? void 0 : formData.inspectionDetailData) === null) {
      setDisabledData(true);
    } else {
      setDisabledData(false);
    }
  }, [userRolesArray, formData]);
  const parseTime = time => {
    if (!time) return null;
    const [hours, minutes] = time.split(":");
    return dayjs().hour(Number(hours)).minute(Number(minutes)).second(0).millisecond(0);
  };
  useEffect(() => {
    var _formData$inspectionD, _formData$inspectionD2;
    const data = formData === null || formData === void 0 ? void 0 : (_formData$inspectionD = formData.inspectionDetail) === null || _formData$inspectionD === void 0 ? void 0 : (_formData$inspectionD2 = _formData$inspectionD[0]) === null || _formData$inspectionD2 === void 0 ? void 0 : _formData$inspectionD2.inspectionReportData;
    if (!data) return;
    if (data.siteInspecionTimeForm) {
      setValue("siteInspecionTimeForm", parseTime(data.siteInspecionTimeForm));
    }
    if (data.siteInspecionTimeTO) {
      setValue("siteInspecionTimeTO", parseTime(data.siteInspecionTimeTO));
    }
  }, [formData === null || formData === void 0 ? void 0 : (_formData$inspectionD3 = formData.inspectionDetail) === null || _formData$inspectionD3 === void 0 ? void 0 : (_formData$inspectionD4 = _formData$inspectionD3[0]) === null || _formData$inspectionD4 === void 0 ? void 0 : _formData$inspectionD4.inspectionReportData]);
  const handleInputChange = (e, name, value) => {
    const currentData = JSON.parse(sessionStorage.getItem("inspectionReportData")) || {};
    currentData[name] = value;
    sessionStorage.setItem("inspectionReportData", JSON.stringify(currentData));
  };
  useEffect(() => {
    const storedChecklist = JSON.parse(sessionStorage.getItem("inspectionReportData"));
    if (storedChecklist) {
      setStoredData(storedChecklist);
    }
  }, []);
  const openPopupDocument = filteredDocuments => {
    console.log("filteredfromopen", filteredDocuments);
    setDocPopupData(filteredDocuments);
    setShowDocPopup(true);
  };
  console.log("reduxFormData", reduxFormData, defaultValues, sessionData);
  const handleSubmitUpdate = data => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      workflow,
      inspectionDetail: [data]
    };
    console.log("LetterOfAttachment", data);
    updateApiCall.mutate({
      BPA: {
        ...appData,
        scrutinyFlow: appData !== null && appData !== void 0 && appData.edcrNumber ? "EDCR" : "PDF"
      }
    }, {
      onSuccess: result => {
        var _result$BPA;
        console.log("result", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        Modal(`Application `, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong>Updated Successfully!`, "success");
      }
    });
  };
  const handleLoadDocument = async fileStoreId => {
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  console.log("formDatabasicSiteiNspect", formData, storedData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "18px"
    },
    onBlur: e => {
      handleInputChange(e, e.target.name, e.target.value);
    }
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-bottom"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Site Inspection Form")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    sx: {
      mt: 2,
      mb: 2,
      px: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: "bold",
      justifyContent: "space-between"
    }
  }, "Inspection On ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "datePicker",
    control: control,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$inspectionD5 = formData.inspectionDetail) === null || _formData$inspectionD5 === void 0 ? void 0 : (_formData$inspectionD6 = _formData$inspectionD5[0]) === null || _formData$inspectionD6 === void 0 ? void 0 : _formData$inspectionD6.siteInspecionDateArea,
    onChange: handleChange,
    name: "siteInspecionDateArea",
    disablePast: true,
    hasLabel: false
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: "bold",
      justifyContent: "space-between"
    }
  }, "Time From ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "timePicker",
    control: control,
    onChange: handleChange,
    name: "siteInspecionTimeForm",
    hasLabel: false
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: "bold",
      justifyContent: "space-between"
    }
  }, "Time To ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "timePicker",
    control: control,
    onChange: handleChange,
    name: "siteInspecionTimeTO",
    hasLabel: false
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: "bold",
      width: 140
    }
  }, "Site Photo:"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => openPopupDocument(filteredDocuments)
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, null)))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-bottom"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      display: "flex",
      marginTop: "10px",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: "bold",
      color: "#333",
      display: "flex",
      marginLeft: "10px"
    }
  }, "Latitude ", isRevalidation && /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"), ":"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555",
      marginLeft: "10px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      fontWeight: "bold",
      color: "#333",
      display: "flex",
      marginLeft: "10px"
    }
  }, "Longitude ", isRevalidation && /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"), ":"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555",
      marginLeft: "10px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.longitude)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 4,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555",
      marginLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(MapSiteInspection, {
    formData: formData
  }))))), (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW" && /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-bottom"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f2f2f2"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: tableHeaderLable
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader$1
  }, "As on Plan"), /*#__PURE__*/React__default.createElement("th", {
    className: "mandatoryInfo",
    style: tableHeader$1
  }, "As on Site ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader$1
  }, "Observation"), /*#__PURE__*/React__default.createElement("th", {
    style: tableHeader$1
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Construction Status "), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstruction) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD7 = formData.inspectionDetailData) === null || _formData$inspectionD7 === void 0 ? void 0 : _formData$inspectionD7.siteInspecionConstruction),
    name: "siteInspecionConstruction",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "siteInspecionConstructionONSite",
    data: vacantOrBuilt,
    type: "radioButton",
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstructionONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD8 = formData.inspectionDetailData) === null || _formData$inspectionD8 === void 0 ? void 0 : _formData$inspectionD8.siteInspecionConstructionONSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "siteInspectionConstructionObservation",
    type: "selectInput",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionConstructionObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD9 = formData.inspectionDetailData) === null || _formData$inspectionD9 === void 0 ? void 0 : _formData$inspectionD9.siteInspectionConstructionObservation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "100%",
    type: "textInput",
    control: control,
    multiLine: true,
    height: "60px",
    maxLength: 100,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstructionStatusRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD10 = formData.inspectionDetailData) === null || _formData$inspectionD10 === void 0 ? void 0 : _formData$inspectionD10.siteInspecionConstructionStatusRemarks),
    name: "siteInspecionConstructionStatusRemarks",
    hasLabel: false
  })))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-Top"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Dimension of each side of property in meter.")), /*#__PURE__*/React__default.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "table",
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
      fontFamily: "sans-serif"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f2f2f2"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "18%"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "18%"
    }
  }, "As on Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "18%"
    },
    className: "mandatoryInfo"
  }, "As on Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "18%"
    }
  }, "Observation"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "28%"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      tableCell: tableCell$1,
      display: "flex"
    }
  }, "a) Front Side", " ", /*#__PURE__*/React__default.createElement("p", {
    colSpan: 5,
    style: {
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      fontWeight: "bold"
    },
    onClick: () => toggleRow("front")
  }, expandedRows.includes("front") ? /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }) : /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }))), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter plan details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionFrontSide) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD11 = formData.inspectionDetailData) === null || _formData$inspectionD11 === void 0 ? void 0 : (_formData$inspectionD12 = _formData$inspectionD11.frontSide) === null || _formData$inspectionD12 === void 0 ? void 0 : _formData$inspectionD12.planOn),
    name: "frontSide.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter site details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionFrontSideONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD13 = formData.inspectionDetailData) === null || _formData$inspectionD13 === void 0 ? void 0 : (_formData$inspectionD14 = _formData$inspectionD13.frontSide) === null || _formData$inspectionD14 === void 0 ? void 0 : _formData$inspectionD14.onSite),
    name: "frontSide.onSite",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "frontSide.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionFrontSideObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD15 = formData.inspectionDetailData) === null || _formData$inspectionD15 === void 0 ? void 0 : (_formData$inspectionD16 = _formData$inspectionD15.frontSide) === null || _formData$inspectionD16 === void 0 ? void 0 : _formData$inspectionD16.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "100%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionFrontSideRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD17 = formData.inspectionDetailData) === null || _formData$inspectionD17 === void 0 ? void 0 : (_formData$inspectionD18 = _formData$inspectionD17.frontSide) === null || _formData$inspectionD18 === void 0 ? void 0 : _formData$inspectionD18.remarks),
    name: "frontSide.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), expandedRows.includes("front") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "b) Rear Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter plan details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRearSide) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD19 = formData.inspectionDetailData) === null || _formData$inspectionD19 === void 0 ? void 0 : (_formData$inspectionD20 = _formData$inspectionD19.rearSide) === null || _formData$inspectionD20 === void 0 ? void 0 : _formData$inspectionD20.planOn),
    name: "rearSide.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter site details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRearSideONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD21 = formData.inspectionDetailData) === null || _formData$inspectionD21 === void 0 ? void 0 : (_formData$inspectionD22 = _formData$inspectionD21.rearSide) === null || _formData$inspectionD22 === void 0 ? void 0 : _formData$inspectionD22.onSite),
    name: "rearSide.onSite",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "rearSide.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionRearSideObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD23 = formData.inspectionDetailData) === null || _formData$inspectionD23 === void 0 ? void 0 : (_formData$inspectionD24 = _formData$inspectionD23.rearSide) === null || _formData$inspectionD24 === void 0 ? void 0 : _formData$inspectionD24.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "100%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRearSideRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD25 = formData.inspectionDetailData) === null || _formData$inspectionD25 === void 0 ? void 0 : (_formData$inspectionD26 = _formData$inspectionD25.rearSide) === null || _formData$inspectionD26 === void 0 ? void 0 : _formData$inspectionD26.remarks),
    name: "rearSide.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "c) Left Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter plan details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionLeftSide) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD27 = formData.inspectionDetailData) === null || _formData$inspectionD27 === void 0 ? void 0 : (_formData$inspectionD28 = _formData$inspectionD27.leftSide) === null || _formData$inspectionD28 === void 0 ? void 0 : _formData$inspectionD28.planOn),
    name: "leftSide.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter site details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionLeftSideONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD29 = formData.inspectionDetailData) === null || _formData$inspectionD29 === void 0 ? void 0 : (_formData$inspectionD30 = _formData$inspectionD29.leftSide) === null || _formData$inspectionD30 === void 0 ? void 0 : _formData$inspectionD30.onSite),
    name: "leftSide.onSite",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "leftSide.observation",
    type: "selectInput",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionLeftSideObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD31 = formData.inspectionDetailData) === null || _formData$inspectionD31 === void 0 ? void 0 : (_formData$inspectionD32 = _formData$inspectionD31.leftSide) === null || _formData$inspectionD32 === void 0 ? void 0 : _formData$inspectionD32.observation),
    hasLabel: false,
    placeholder: "Select Observation"
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    multiLine: true,
    height: "60px",
    maxLength: 100,
    width: "100%",
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionLeftSideRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD33 = formData.inspectionDetailData) === null || _formData$inspectionD33 === void 0 ? void 0 : (_formData$inspectionD34 = _formData$inspectionD33.leftSide) === null || _formData$inspectionD34 === void 0 ? void 0 : _formData$inspectionD34.remarks),
    name: "leftSide.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "d) Right Side"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter plan details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRightSide) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD35 = formData.inspectionDetailData) === null || _formData$inspectionD35 === void 0 ? void 0 : (_formData$inspectionD36 = _formData$inspectionD35.rightSide) === null || _formData$inspectionD36 === void 0 ? void 0 : _formData$inspectionD36.planOn),
    name: "rightSide.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "decimal",
    placeholder: "Enter site details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRightSideONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD37 = formData.inspectionDetailData) === null || _formData$inspectionD37 === void 0 ? void 0 : (_formData$inspectionD38 = _formData$inspectionD37.rightSide) === null || _formData$inspectionD38 === void 0 ? void 0 : _formData$inspectionD38.onSite),
    name: "rightSide.onSite",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "rightSide.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionRightSideObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD39 = formData.inspectionDetailData) === null || _formData$inspectionD39 === void 0 ? void 0 : (_formData$inspectionD40 = _formData$inspectionD39.rightSide) === null || _formData$inspectionD40 === void 0 ? void 0 : _formData$inspectionD40.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "100%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionRightSideRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD41 = formData.inspectionDetailData) === null || _formData$inspectionD41 === void 0 ? void 0 : (_formData$inspectionD42 = _formData$inspectionD41.rightSide) === null || _formData$inspectionD42 === void 0 ? void 0 : _formData$inspectionD42.remarks),
    name: "rightSide.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), fields === null || fields === void 0 ? void 0 : fields.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "e) Any other side ", index + 1, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: "3px"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: () => append({
      sideName: "",
      onsiteMeasurement: "",
      observation: "",
      remarks: ""
    }),
    style: {
      backgroundColor: "#78bad3",
      color: "white",
      marginRight: "10px",
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  })), fields.length > 1 && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: () => remove(index),
    style: {
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "3px 4px",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      borderRadius: "4px",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  })))), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "specialChar",
    placeholder: "Enter plan details",
    control: control,
    name: `siteInspecionAnyOtherSide.${index}.sideName`,
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "specialChar",
    placeholder: "Enter site details",
    control: control,
    name: `siteInspecionAnyOtherSide.${index}.onsiteMeasurement`,
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    control: control,
    name: `siteInspecionAnyOtherSide.${index}.observation`,
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "100%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    name: `siteInspecionAnyOtherSide.${index}.remarks`,
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-Top"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Status of Property/Plot")), /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f2f2f2"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "20%"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "15%"
    }
  }, "As on Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "15"
    },
    className: "mandatoryInfo"
  }, "As on Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "15%"
    }
  }, "Observation"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      ...tableHeader$1,
      width: "35%"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.riskType) != "LOW" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Construction Status", /*#__PURE__*/React__default.createElement("p", {
    colSpan: 5,
    style: {
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      fontWeight: "bold"
    },
    onClick: () => toggleRowConstruction("Construction")
  }, expandedRowsConstruction.includes("Construction") ? /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }) : /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }))), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: vacantOrBuilt,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstruction) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD43 = formData.inspectionDetailData) === null || _formData$inspectionD43 === void 0 ? void 0 : (_formData$inspectionD44 = _formData$inspectionD43.construction) === null || _formData$inspectionD44 === void 0 ? void 0 : _formData$inspectionD44.planOn),
    name: "construction.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "construction.onSite",
    data: vacantOrBuilt,
    type: "radioButton",
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstructionONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD45 = formData.inspectionDetailData) === null || _formData$inspectionD45 === void 0 ? void 0 : (_formData$inspectionD46 = _formData$inspectionD45.construction) === null || _formData$inspectionD46 === void 0 ? void 0 : _formData$inspectionD46.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "construction.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionConstructionObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD47 = formData.inspectionDetailData) === null || _formData$inspectionD47 === void 0 ? void 0 : (_formData$inspectionD48 = _formData$inspectionD47.construction) === null || _formData$inspectionD48 === void 0 ? void 0 : _formData$inspectionD48.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionConstructionStatusRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD49 = formData.inspectionDetailData) === null || _formData$inspectionD49 === void 0 ? void 0 : (_formData$inspectionD50 = _formData$inspectionD49.construction) === null || _formData$inspectionD50 === void 0 ? void 0 : _formData$inspectionD50.remarks),
    name: "construction.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Built", /*#__PURE__*/React__default.createElement("p", {
    colSpan: 5,
    style: {
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
      fontWeight: "bold"
    },
    onClick: () => toggleRowConstruction("Construction")
  }, expandedRowsConstruction.includes("Construction") ? /*#__PURE__*/React__default.createElement(RemoveCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }) : /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, {
    style: {
      fontSize: "20px"
    }
  }))), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionBuilttext) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD51 = formData.inspectionDetailData) === null || _formData$inspectionD51 === void 0 ? void 0 : (_formData$inspectionD52 = _formData$inspectionD51.construction) === null || _formData$inspectionD52 === void 0 ? void 0 : _formData$inspectionD52.siteInspecionBuilttext),
    name: "construction.siteInspecionBuilttext",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "construction.siteInspecionBuilt",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionBuilt) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD53 = formData.inspectionDetailData) === null || _formData$inspectionD53 === void 0 ? void 0 : _formData$inspectionD53.siteInspecionBuilt)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "construction.siteInspectionBuiltObservation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionBuiltObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD54 = formData.inspectionDetailData) === null || _formData$inspectionD54 === void 0 ? void 0 : (_formData$inspectionD55 = _formData$inspectionD54.construction) === null || _formData$inspectionD55 === void 0 ? void 0 : _formData$inspectionD55.siteInspectionBuiltObservation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionBuiltRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD56 = formData.inspectionDetailData) === null || _formData$inspectionD56 === void 0 ? void 0 : (_formData$inspectionD57 = _formData$inspectionD56.construction) === null || _formData$inspectionD57 === void 0 ? void 0 : _formData$inspectionD57.siteInspecionBuiltRemarks),
    name: "construction.siteInspecionBuiltRemarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), expandedRowsConstruction.includes("Construction") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ((formData === null || formData === void 0 ? void 0 : formData.riskType) === "MEDIUM" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "HIGH") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Whether construction started"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWhetherconstruction) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD58 = formData.inspectionDetailData) === null || _formData$inspectionD58 === void 0 ? void 0 : (_formData$inspectionD59 = _formData$inspectionD58.construction) === null || _formData$inspectionD59 === void 0 ? void 0 : _formData$inspectionD59.planOn),
    name: "whetherConstructionStarted.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "whetherConstructionStarted.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWhetherconstructionONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD60 = formData.inspectionDetailData) === null || _formData$inspectionD60 === void 0 ? void 0 : (_formData$inspectionD61 = _formData$inspectionD60.whetherConstructionStarted) === null || _formData$inspectionD61 === void 0 ? void 0 : _formData$inspectionD61.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "whetherConstructionStarted.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWhetherconstructionObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD62 = formData.inspectionDetailData) === null || _formData$inspectionD62 === void 0 ? void 0 : (_formData$inspectionD63 = _formData$inspectionD62.whetherConstructionStarted) === null || _formData$inspectionD63 === void 0 ? void 0 : _formData$inspectionD63.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWhetherconstructionRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD64 = formData.inspectionDetailData) === null || _formData$inspectionD64 === void 0 ? void 0 : (_formData$inspectionD65 = _formData$inspectionD64.whetherConstructionStarted) === null || _formData$inspectionD65 === void 0 ? void 0 : _formData$inspectionD65.remarks),
    name: "whetherConstructionStarted.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Demolition Started"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionDemolitionStartedText) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD66 = formData.inspectionDetailData) === null || _formData$inspectionD66 === void 0 ? void 0 : (_formData$inspectionD67 = _formData$inspectionD66.demolitionStarted) === null || _formData$inspectionD67 === void 0 ? void 0 : _formData$inspectionD67.planOn),
    onChange: handleChange,
    name: "demolitionStarted.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "demolitionStarted.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionDemolationStarted) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD68 = formData.inspectionDetailData) === null || _formData$inspectionD68 === void 0 ? void 0 : (_formData$inspectionD69 = _formData$inspectionD68.demolitionStarted) === null || _formData$inspectionD69 === void 0 ? void 0 : _formData$inspectionD69.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "demolitionStarted.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionDemolitionObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD70 = formData.inspectionDetailData) === null || _formData$inspectionD70 === void 0 ? void 0 : (_formData$inspectionD71 = _formData$inspectionD70.demolitionStarted) === null || _formData$inspectionD71 === void 0 ? void 0 : _formData$inspectionD71.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionDemolationStartedRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD72 = formData.inspectionDetailData) === null || _formData$inspectionD72 === void 0 ? void 0 : (_formData$inspectionD73 = _formData$inspectionD72.demolitionStarted) === null || _formData$inspectionD73 === void 0 ? void 0 : _formData$inspectionD73.remarks),
    onChange: handleChange,
    name: "demolitionStarted.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is Property having extra Land"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionPropertyGextra) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD74 = formData.inspectionDetailData) === null || _formData$inspectionD74 === void 0 ? void 0 : (_formData$inspectionD75 = _formData$inspectionD74.getExtraProperty) === null || _formData$inspectionD75 === void 0 ? void 0 : _formData$inspectionD75.planOn),
    onChange: handleChange,
    name: "getExtraProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "getExtraProperty.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionPropertyGextraLand) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD76 = formData.inspectionDetailData) === null || _formData$inspectionD76 === void 0 ? void 0 : (_formData$inspectionD77 = _formData$inspectionD76.getExtraProperty) === null || _formData$inspectionD77 === void 0 ? void 0 : _formData$inspectionD77.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "getExtraProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionPropertyGextraLandObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD78 = formData.inspectionDetailData) === null || _formData$inspectionD78 === void 0 ? void 0 : (_formData$inspectionD79 = _formData$inspectionD78.getExtraProperty) === null || _formData$inspectionD79 === void 0 ? void 0 : _formData$inspectionD79.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionPropertyGextraLandRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD80 = formData.inspectionDetailData) === null || _formData$inspectionD80 === void 0 ? void 0 : (_formData$inspectionD81 = _formData$inspectionD80.getExtraProperty) === null || _formData$inspectionD81 === void 0 ? void 0 : _formData$inspectionD81.remarks),
    onChange: handleChange,
    name: "getExtraProperty.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "a) Area of extra land"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "textInput",
    placeholder: "Enter plan details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionAreaofextra) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD82 = formData.inspectionDetailData) === null || _formData$inspectionD82 === void 0 ? void 0 : (_formData$inspectionD83 = _formData$inspectionD82.areaOfExtraLand) === null || _formData$inspectionD83 === void 0 ? void 0 : _formData$inspectionD83.planOn),
    onChange: handleChange,
    name: "areaOfExtraLand.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "areaOfExtraLand.onSite",
    type: "number",
    placeholder: "Enter site details",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionAreaofextraONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD84 = formData.inspectionDetailData) === null || _formData$inspectionD84 === void 0 ? void 0 : (_formData$inspectionD85 = _formData$inspectionD84.areaOfExtraLand) === null || _formData$inspectionD85 === void 0 ? void 0 : _formData$inspectionD85.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "areaOfExtraLand.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionAreaofextraObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD86 = formData.inspectionDetailData) === null || _formData$inspectionD86 === void 0 ? void 0 : (_formData$inspectionD87 = _formData$inspectionD86.areaOfExtraLand) === null || _formData$inspectionD87 === void 0 ? void 0 : _formData$inspectionD87.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionAreaofextraRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD88 = formData.inspectionDetailData) === null || _formData$inspectionD88 === void 0 ? void 0 : (_formData$inspectionD89 = _formData$inspectionD88.areaOfExtraLand) === null || _formData$inspectionD89 === void 0 ? void 0 : _formData$inspectionD89.remarks),
    onChange: handleChange,
    name: "areaOfExtraLand.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "b)IS extra land allotted by DA/UPAVP/SADA"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionextraLandAllotedBy) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD90 = formData.inspectionDetailData) === null || _formData$inspectionD90 === void 0 ? void 0 : (_formData$inspectionD91 = _formData$inspectionD90.extraLandAllotedBy) === null || _formData$inspectionD91 === void 0 ? void 0 : _formData$inspectionD91.planOn),
    onChange: handleChange,
    name: "isExtraLandAllotedBy.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isExtraLandAllotedBy.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.extraLandAllotedBy) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD92 = formData.inspectionDetailData) === null || _formData$inspectionD92 === void 0 ? void 0 : (_formData$inspectionD93 = _formData$inspectionD92.extraLandAllotedBy) === null || _formData$inspectionD93 === void 0 ? void 0 : _formData$inspectionD93.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isExtraLandAllotedBy.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionExtraLandAllotedObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD94 = formData.inspectionDetailData) === null || _formData$inspectionD94 === void 0 ? void 0 : (_formData$inspectionD95 = _formData$inspectionD94.extraLandAllotedBy) === null || _formData$inspectionD95 === void 0 ? void 0 : _formData$inspectionD95.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.extraLandAllotedByRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD96 = formData.inspectionDetailData) === null || _formData$inspectionD96 === void 0 ? void 0 : (_formData$inspectionD97 = _formData$inspectionD96.isExtraLandAllotedBy) === null || _formData$inspectionD97 === void 0 ? void 0 : _formData$inspectionD97.remarks),
    onChange: handleChange,
    name: "isExtraLandAllotedBy.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Attached Allotement Letter"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionAttachedAllotement) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD98 = formData.inspectionDetailData) === null || _formData$inspectionD98 === void 0 ? void 0 : (_formData$inspectionD99 = _formData$inspectionD98.attachedAllotement) === null || _formData$inspectionD99 === void 0 ? void 0 : _formData$inspectionD99.planOn),
    onChange: handleChange,
    name: "attachedAllotement.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "attachedAllotement.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.attachedAllotement) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD100 = formData.inspectionDetailData) === null || _formData$inspectionD100 === void 0 ? void 0 : (_formData$inspectionD101 = _formData$inspectionD100.attachedAllotement) === null || _formData$inspectionD101 === void 0 ? void 0 : _formData$inspectionD101.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "attachedAllotement.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.attachedAllotementObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD102 = formData.inspectionDetailData) === null || _formData$inspectionD102 === void 0 ? void 0 : (_formData$inspectionD103 = _formData$inspectionD102.attachedAllotement) === null || _formData$inspectionD103 === void 0 ? void 0 : _formData$inspectionD103.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.attachedAllotementRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD104 = formData.inspectionDetailData) === null || _formData$inspectionD104 === void 0 ? void 0 : (_formData$inspectionD105 = _formData$inspectionD104.attachedAllotement) === null || _formData$inspectionD105 === void 0 ? void 0 : _formData$inspectionD105.remarks),
    onChange: handleChange,
    name: "attachedAllotement.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Can a separate property be created"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.seprateProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD106 = formData.inspectionDetailData) === null || _formData$inspectionD106 === void 0 ? void 0 : (_formData$inspectionD107 = _formData$inspectionD106.separateProperty) === null || _formData$inspectionD107 === void 0 ? void 0 : _formData$inspectionD107.planOn),
    onChange: handleChange,
    name: "separateProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "separateProperty.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.sepratePropertyONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD108 = formData.inspectionDetailData) === null || _formData$inspectionD108 === void 0 ? void 0 : (_formData$inspectionD109 = _formData$inspectionD108.seprateProperty) === null || _formData$inspectionD109 === void 0 ? void 0 : _formData$inspectionD109.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "separateProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.sepratePropertyObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD110 = formData.inspectionDetailData) === null || _formData$inspectionD110 === void 0 ? void 0 : (_formData$inspectionD111 = _formData$inspectionD110.seprateProperty) === null || _formData$inspectionD111 === void 0 ? void 0 : _formData$inspectionD111.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.sepratePropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD112 = formData.inspectionDetailData) === null || _formData$inspectionD112 === void 0 ? void 0 : (_formData$inspectionD113 = _formData$inspectionD112.seprateProperty) === null || _formData$inspectionD113 === void 0 ? void 0 : _formData$inspectionD113.remarks),
    onChange: handleChange,
    name: "separateProperty.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is extra land is for offer"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionExtraOffer) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD114 = formData.inspectionDetailData) === null || _formData$inspectionD114 === void 0 ? void 0 : (_formData$inspectionD115 = _formData$inspectionD114.isExtraLandOffer) === null || _formData$inspectionD115 === void 0 ? void 0 : _formData$inspectionD115.planOn),
    onChange: handleChange,
    name: "isExtraLandOffer.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isExtraLandOffer.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.extraOfferONSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD116 = formData.inspectionDetailData) === null || _formData$inspectionD116 === void 0 ? void 0 : (_formData$inspectionD117 = _formData$inspectionD116.isExtraLandOffer) === null || _formData$inspectionD117 === void 0 ? void 0 : _formData$inspectionD117.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isExtraLandOffer.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionExtraOfferObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD118 = formData.inspectionDetailData) === null || _formData$inspectionD118 === void 0 ? void 0 : (_formData$inspectionD119 = _formData$inspectionD118.isExtraLandOffer) === null || _formData$inspectionD119 === void 0 ? void 0 : _formData$inspectionD119.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionExtraOfferRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD120 = formData.inspectionDetailData) === null || _formData$inspectionD120 === void 0 ? void 0 : (_formData$inspectionD121 = _formData$inspectionD120.isExtraLandOffer) === null || _formData$inspectionD121 === void 0 ? void 0 : _formData$inspectionD121.remarks),
    onChange: handleChange,
    name: "isExtraLandOffer.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by the water supply"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByWater) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD122 = formData.inspectionDetailData) === null || _formData$inspectionD122 === void 0 ? void 0 : (_formData$inspectionD123 = _formData$inspectionD122.isPropertyAffectedByWater) === null || _formData$inspectionD123 === void 0 ? void 0 : _formData$inspectionD123.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByWater.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByWater.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByWater) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD124 = formData.inspectionDetailData) === null || _formData$inspectionD124 === void 0 ? void 0 : (_formData$inspectionD125 = _formData$inspectionD124.isPropertyAffectedByWater) === null || _formData$inspectionD125 === void 0 ? void 0 : _formData$inspectionD125.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByWater.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffectedByWaterObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD126 = formData.inspectionDetailData) === null || _formData$inspectionD126 === void 0 ? void 0 : (_formData$inspectionD127 = _formData$inspectionD126.isPropertyAffectedByWater) === null || _formData$inspectionD127 === void 0 ? void 0 : _formData$inspectionD127.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByWaterRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD128 = formData.inspectionDetailData) === null || _formData$inspectionD128 === void 0 ? void 0 : (_formData$inspectionD129 = _formData$inspectionD128.isPropertyAffectedByWater) === null || _formData$inspectionD129 === void 0 ? void 0 : _formData$inspectionD129.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByWater.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by the sewerage"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedBySeweragee) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD130 = formData.inspectionDetailData) === null || _formData$inspectionD130 === void 0 ? void 0 : (_formData$inspectionD131 = _formData$inspectionD130.isPropertyAffectedBySewerage) === null || _formData$inspectionD131 === void 0 ? void 0 : _formData$inspectionD131.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedBySewerage.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedBySewerage.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedBySewerage) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD132 = formData.inspectionDetailData) === null || _formData$inspectionD132 === void 0 ? void 0 : (_formData$inspectionD133 = _formData$inspectionD132.isPropertyAffectedBySewerage) === null || _formData$inspectionD133 === void 0 ? void 0 : _formData$inspectionD133.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedBySewerage.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffctedBySewarageObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD134 = formData.inspectionDetailData) === null || _formData$inspectionD134 === void 0 ? void 0 : (_formData$inspectionD135 = _formData$inspectionD134.isPropertyAffectedBySewerage) === null || _formData$inspectionD135 === void 0 ? void 0 : _formData$inspectionD135.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedBySewerageRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD136 = formData.inspectionDetailData) === null || _formData$inspectionD136 === void 0 ? void 0 : (_formData$inspectionD137 = _formData$inspectionD136.isPropertyAffectedBySewerage) === null || _formData$inspectionD137 === void 0 ? void 0 : _formData$inspectionD137.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedBySewerage.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by the Electrical Line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByElectricity) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD138 = formData.inspectionDetailData) === null || _formData$inspectionD138 === void 0 ? void 0 : (_formData$inspectionD139 = _formData$inspectionD138.isPropertyAffectedByElectricity) === null || _formData$inspectionD139 === void 0 ? void 0 : _formData$inspectionD139.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByElectricity.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByElectricity.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByElectricity) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD140 = formData.inspectionDetailData) === null || _formData$inspectionD140 === void 0 ? void 0 : (_formData$inspectionD141 = _formData$inspectionD140.isPropertyAffectedByElectricity) === null || _formData$inspectionD141 === void 0 ? void 0 : _formData$inspectionD141.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByElectricity.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffectedElectricityObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD142 = formData.inspectionDetailData) === null || _formData$inspectionD142 === void 0 ? void 0 : (_formData$inspectionD143 = _formData$inspectionD142.isPropertyAffectedByElectricity) === null || _formData$inspectionD143 === void 0 ? void 0 : _formData$inspectionD143.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByElectricityRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD144 = formData.inspectionDetailData) === null || _formData$inspectionD144 === void 0 ? void 0 : (_formData$inspectionD145 = _formData$inspectionD144.isPropertyAffectedByElectricity) === null || _formData$inspectionD145 === void 0 ? void 0 : _formData$inspectionD145.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByElectricity.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by the Drainage"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByDrainage) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD146 = formData.inspectionDetailData) === null || _formData$inspectionD146 === void 0 ? void 0 : (_formData$inspectionD147 = _formData$inspectionD146.isPropertyAffectedByDrainage) === null || _formData$inspectionD147 === void 0 ? void 0 : _formData$inspectionD147.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByDrainage.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByDrainage.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByDrainage) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD148 = formData.inspectionDetailData) === null || _formData$inspectionD148 === void 0 ? void 0 : (_formData$inspectionD149 = _formData$inspectionD148.isPropertyAffectedByDrainage) === null || _formData$inspectionD149 === void 0 ? void 0 : _formData$inspectionD149.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByDrainage.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffectedDrainageObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD150 = formData.inspectionDetailData) === null || _formData$inspectionD150 === void 0 ? void 0 : (_formData$inspectionD151 = _formData$inspectionD150.isPropertyAffectedByDrainage) === null || _formData$inspectionD151 === void 0 ? void 0 : _formData$inspectionD151.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByDrainageRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD152 = formData.inspectionDetailData) === null || _formData$inspectionD152 === void 0 ? void 0 : (_formData$inspectionD153 = _formData$inspectionD152.isPropertyAffectedByDrainage) === null || _formData$inspectionD153 === void 0 ? void 0 : _formData$inspectionD153.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByDrainage.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by railway line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByRailway) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD154 = formData.inspectionDetailData) === null || _formData$inspectionD154 === void 0 ? void 0 : (_formData$inspectionD155 = _formData$inspectionD154.isPropertyAffectedByRailway) === null || _formData$inspectionD155 === void 0 ? void 0 : _formData$inspectionD155.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByRailway.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByRailway.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByRailway) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD156 = formData.inspectionDetailData) === null || _formData$inspectionD156 === void 0 ? void 0 : (_formData$inspectionD157 = _formData$inspectionD156.isPropertyAffectedByRailway) === null || _formData$inspectionD157 === void 0 ? void 0 : _formData$inspectionD157.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByRailway.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffectedRailwayObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD158 = formData.inspectionDetailData) === null || _formData$inspectionD158 === void 0 ? void 0 : (_formData$inspectionD159 = _formData$inspectionD158.isPropertyAffectedByRailway) === null || _formData$inspectionD159 === void 0 ? void 0 : _formData$inspectionD159.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByRailwayRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD160 = formData.inspectionDetailData) === null || _formData$inspectionD160 === void 0 ? void 0 : (_formData$inspectionD161 = _formData$inspectionD160.isPropertyAffectedByRailway) === null || _formData$inspectionD161 === void 0 ? void 0 : _formData$inspectionD161.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByRailway.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by gas pipe line"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByGas) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD162 = formData.inspectionDetailData) === null || _formData$inspectionD162 === void 0 ? void 0 : (_formData$inspectionD163 = _formData$inspectionD162.isPropertyAffectedByGas) === null || _formData$inspectionD163 === void 0 ? void 0 : _formData$inspectionD163.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByGas.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByGas.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByGas) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD164 = formData.inspectionDetailData) === null || _formData$inspectionD164 === void 0 ? void 0 : (_formData$inspectionD165 = _formData$inspectionD164.isPropertyAffectedByGas) === null || _formData$inspectionD165 === void 0 ? void 0 : _formData$inspectionD165.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByGas.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffectedGasObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD166 = formData.inspectionDetailData) === null || _formData$inspectionD166 === void 0 ? void 0 : (_formData$inspectionD167 = _formData$inspectionD166.isPropertyAffectedByGas) === null || _formData$inspectionD167 === void 0 ? void 0 : _formData$inspectionD167.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByGasRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD168 = formData.inspectionDetailData) === null || _formData$inspectionD168 === void 0 ? void 0 : (_formData$inspectionD169 = _formData$inspectionD168.isPropertyAffectedByGas) === null || _formData$inspectionD169 === void 0 ? void 0 : _formData$inspectionD169.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByGas.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is property affected by any pond/lake or any natural body"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionaffectedByNaturalBody) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD170 = formData.inspectionDetailData) === null || _formData$inspectionD170 === void 0 ? void 0 : (_formData$inspectionD171 = _formData$inspectionD170.isPropertyAffectedByNaturalBody) === null || _formData$inspectionD171 === void 0 ? void 0 : _formData$inspectionD171.planOn),
    onChange: handleChange,
    name: "isPropertyAffectedByNaturalBody.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByNaturalBody.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByNaturalBody) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD172 = formData.inspectionDetailData) === null || _formData$inspectionD172 === void 0 ? void 0 : (_formData$inspectionD173 = _formData$inspectionD172.isPropertyAffectedByNaturalBody) === null || _formData$inspectionD173 === void 0 ? void 0 : _formData$inspectionD173.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPropertyAffectedByNaturalBody.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionAffctedNaturalBodyObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD174 = formData.inspectionDetailData) === null || _formData$inspectionD174 === void 0 ? void 0 : (_formData$inspectionD175 = _formData$inspectionD174.isPropertyAffectedByNaturalBody) === null || _formData$inspectionD175 === void 0 ? void 0 : _formData$inspectionD175.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.affectedByNaturalBodyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD176 = formData.inspectionDetailData) === null || _formData$inspectionD176 === void 0 ? void 0 : (_formData$inspectionD177 = _formData$inspectionD176.isPropertyAffectedByNaturalBody) === null || _formData$inspectionD177 === void 0 ? void 0 : _formData$inspectionD177.remarks),
    onChange: handleChange,
    name: "isPropertyAffectedByNaturalBody.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Location/key plan shown on drawing matches property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionLocationShownOnDrawing) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD178 = formData.inspectionDetailData) === null || _formData$inspectionD178 === void 0 ? void 0 : (_formData$inspectionD179 = _formData$inspectionD178.locationShownOnDrawingMatchesProperty) === null || _formData$inspectionD179 === void 0 ? void 0 : _formData$inspectionD179.planOn),
    onChange: handleChange,
    name: "locationShownOnDrawingMatchesProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "locationShownOnDrawingMatchesProperty.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.LocationShownOnDrawingMatchesProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD180 = formData.inspectionDetailData) === null || _formData$inspectionD180 === void 0 ? void 0 : (_formData$inspectionD181 = _formData$inspectionD180.locationShownOnDrawingMatchesProperty) === null || _formData$inspectionD181 === void 0 ? void 0 : _formData$inspectionD181.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    control: control,
    name: "locationShownOnDrawingMatchesProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionPlanDrwingMatchObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD182 = formData.inspectionDetailData) === null || _formData$inspectionD182 === void 0 ? void 0 : (_formData$inspectionD183 = _formData$inspectionD182.locationShownOnDrawingMatchesProperty) === null || _formData$inspectionD183 === void 0 ? void 0 : _formData$inspectionD183.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.locationShownOnDrawingMatchesPropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD184 = formData.inspectionDetailData) === null || _formData$inspectionD184 === void 0 ? void 0 : (_formData$inspectionD185 = _formData$inspectionD184.locationShownOnDrawingMatchesProperty) === null || _formData$inspectionD185 === void 0 ? void 0 : _formData$inspectionD185.remarks),
    onChange: handleChange,
    name: "locationShownOnDrawingMatchesProperty.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Plot boundaries and Area as per registry matches the site"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionplotBoundariesandArea) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD186 = formData.inspectionDetailData) === null || _formData$inspectionD186 === void 0 ? void 0 : (_formData$inspectionD187 = _formData$inspectionD186.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _formData$inspectionD187 === void 0 ? void 0 : _formData$inspectionD187.planOn),
    onChange: handleChange,
    name: "plotBoundariesandAreaAsPerRegisteryMatchesSite.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "plotBoundariesandAreaAsPerRegisteryMatchesSite.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.plotBoundariesandAreaAsPerRegisteryMatchesSite) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD188 = formData.inspectionDetailData) === null || _formData$inspectionD188 === void 0 ? void 0 : (_formData$inspectionD189 = _formData$inspectionD188.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _formData$inspectionD189 === void 0 ? void 0 : _formData$inspectionD189.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "plotBoundariesandAreaAsPerRegisteryMatchesSite.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionRegMatchObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD190 = formData.inspectionDetailData) === null || _formData$inspectionD190 === void 0 ? void 0 : (_formData$inspectionD191 = _formData$inspectionD190.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _formData$inspectionD191 === void 0 ? void 0 : _formData$inspectionD191.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.plotBoundariesandAreaAsPerRegisteryMatchesSiteRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD192 = formData.inspectionDetailData) === null || _formData$inspectionD192 === void 0 ? void 0 : (_formData$inspectionD193 = _formData$inspectionD192.plotBoundariesandAreaAsPerRegisteryMatchesSite) === null || _formData$inspectionD193 === void 0 ? void 0 : _formData$inspectionD193.remarks),
    onChange: handleChange,
    name: "plotBoundariesandAreaAsPerRegisteryMatchesSite.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is land of Road widening and green belt falling in the Property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionisLandRoadWideningGgreen) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD194 = formData.inspectionDetailData) === null || _formData$inspectionD194 === void 0 ? void 0 : (_formData$inspectionD195 = _formData$inspectionD194.isLandRoadWideningGgreen) === null || _formData$inspectionD195 === void 0 ? void 0 : _formData$inspectionD195.planOn),
    onChange: handleChange,
    name: "isLandRoadWideningGgreen.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isLandRoadWideningGgreen.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isLandRoadWideningGgreenBeltFallingInTheProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD196 = formData.inspectionDetailData) === null || _formData$inspectionD196 === void 0 ? void 0 : (_formData$inspectionD197 = _formData$inspectionD196.isLandRoadWideningGgreen) === null || _formData$inspectionD197 === void 0 ? void 0 : _formData$inspectionD197.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isLandRoadWideningGgreen.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionGreenBeltObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD198 = formData.inspectionDetailData) === null || _formData$inspectionD198 === void 0 ? void 0 : (_formData$inspectionD199 = _formData$inspectionD198.isLandRoadWideningGgreen) === null || _formData$inspectionD199 === void 0 ? void 0 : _formData$inspectionD199.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isLandRoadWideningGgreenBeltFallingInThePropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD200 = formData.inspectionDetailData) === null || _formData$inspectionD200 === void 0 ? void 0 : (_formData$inspectionD201 = _formData$inspectionD200.isLandRoadWideningGgreen) === null || _formData$inspectionD201 === void 0 ? void 0 : _formData$inspectionD201.remarks),
    onChange: handleChange,
    name: "isLandRoadWideningGgreen.remarks",
    hasLabel: false,
    placeholder: "Enter Remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, (formData === null || formData === void 0 ? void 0 : formData.riskType) === "HIGH" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Width of approach road to reach property (in Mtr)"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWidthOfApprochRoadTo) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD202 = formData.inspectionDetailData) === null || _formData$inspectionD202 === void 0 ? void 0 : (_formData$inspectionD203 = _formData$inspectionD202.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD203 === void 0 ? void 0 : _formData$inspectionD203.planOn),
    onChange: handleChange,
    name: "widthOfApprochRoadToReachProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "widthOfApprochRoadToReachProperty.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.widthOfApprochRoadToReachProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD204 = formData.inspectionDetailData) === null || _formData$inspectionD204 === void 0 ? void 0 : (_formData$inspectionD205 = _formData$inspectionD204.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD205 === void 0 ? void 0 : _formData$inspectionD205.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "widthOfApprochRoadToReachProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionWidthOfRoadObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD206 = formData.inspectionDetailData) === null || _formData$inspectionD206 === void 0 ? void 0 : (_formData$inspectionD207 = _formData$inspectionD206.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD207 === void 0 ? void 0 : _formData$inspectionD207.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.widthOfApprochRoadToReachPropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD208 = formData.inspectionDetailData) === null || _formData$inspectionD208 === void 0 ? void 0 : (_formData$inspectionD209 = _formData$inspectionD208.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD209 === void 0 ? void 0 : _formData$inspectionD209.remarks),
    onChange: handleChange,
    name: "widthOfApprochRoadToReachProperty.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))), (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Width of Approch Road to reach property (in Mtr)"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    data: yesOrNo,
    type: "RadioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionWidthOfApprochRoadTo) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD210 = formData.inspectionDetailData) === null || _formData$inspectionD210 === void 0 ? void 0 : (_formData$inspectionD211 = _formData$inspectionD210.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD211 === void 0 ? void 0 : _formData$inspectionD211.planOn),
    onChange: handleChange,
    name: "widthOfApprochRoadToReachProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "widthOfApprochRoadToReachProperty.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.widthOfApprochRoadToReachProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD212 = formData.inspectionDetailData) === null || _formData$inspectionD212 === void 0 ? void 0 : (_formData$inspectionD213 = _formData$inspectionD212.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD213 === void 0 ? void 0 : _formData$inspectionD213.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "widthOfApprochRoadToReachProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionWidthOfRoadObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD214 = formData.inspectionDetailData) === null || _formData$inspectionD214 === void 0 ? void 0 : (_formData$inspectionD215 = _formData$inspectionD214.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD215 === void 0 ? void 0 : _formData$inspectionD215.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.widthOfApprochRoadToReachPropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD216 = formData.inspectionDetailData) === null || _formData$inspectionD216 === void 0 ? void 0 : (_formData$inspectionD217 = _formData$inspectionD216.widthOfApprochRoadToReachProperty) === null || _formData$inspectionD217 === void 0 ? void 0 : _formData$inspectionD217.remarks),
    onChange: handleChange,
    name: "widthOfApprochRoadToReachProperty.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  })), " ")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is the proposed property in possession of owner"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionisProposedProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD218 = formData.inspectionDetailData) === null || _formData$inspectionD218 === void 0 ? void 0 : (_formData$inspectionD219 = _formData$inspectionD218.isThePropertyPossesionOfOwner) === null || _formData$inspectionD219 === void 0 ? void 0 : _formData$inspectionD219.planOn),
    onChange: handleChange,
    name: "isThePropertyPossesionOfOwner.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isThePropertyPossesionOfOwner.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isProposedPropertyInPossesionOfOwner) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD220 = formData.inspectionDetailData) === null || _formData$inspectionD220 === void 0 ? void 0 : (_formData$inspectionD221 = _formData$inspectionD220.isThePropertyPossesionOfOwner) === null || _formData$inspectionD221 === void 0 ? void 0 : _formData$inspectionD221.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isThePropertyPossesionOfOwner.observation",
    type: "selectInput",
    data: approvedOrShortfall,
    placeholder: "Select Observation",
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionPossOfOwnerObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD222 = formData.inspectionDetailData) === null || _formData$inspectionD222 === void 0 ? void 0 : (_formData$inspectionD223 = _formData$inspectionD222.isThePropertyPossesionOfOwner) === null || _formData$inspectionD223 === void 0 ? void 0 : _formData$inspectionD223.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isProposedPropertyInPossesionOfOwnerRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD224 = formData.inspectionDetailData) === null || _formData$inspectionD224 === void 0 ? void 0 : (_formData$inspectionD225 = _formData$inspectionD224.isThePropertyPossesionOfOwner) === null || _formData$inspectionD225 === void 0 ? void 0 : _formData$inspectionD225.remarks),
    onChange: handleChange,
    name: "isThePropertyPossesionOfOwner.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Is plot adjoining any government land/government building"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionisPlotAdjoiningAny) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD226 = formData.inspectionDetailData) === null || _formData$inspectionD226 === void 0 ? void 0 : (_formData$inspectionD227 = _formData$inspectionD226.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _formData$inspectionD227 === void 0 ? void 0 : _formData$inspectionD227.planOn),
    onChange: handleChange,
    name: "isPlotAdjoiningAnyGovernmentLandBuilding.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPlotAdjoiningAnyGovernmentLandBuilding.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isPlotAdjoiningAnyGovernmentLandBuilding) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD228 = formData.inspectionDetailData) === null || _formData$inspectionD228 === void 0 ? void 0 : (_formData$inspectionD229 = _formData$inspectionD228.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _formData$inspectionD229 === void 0 ? void 0 : _formData$inspectionD229.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "isPlotAdjoiningAnyGovernmentLandBuilding.observation",
    type: "selectInput",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionGovLandObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD230 = formData.inspectionDetailData) === null || _formData$inspectionD230 === void 0 ? void 0 : (_formData$inspectionD231 = _formData$inspectionD230.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _formData$inspectionD231 === void 0 ? void 0 : _formData$inspectionD231.observation),
    hasLabel: false,
    placeholder: "Select Observation"
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.isPlotAdjoiningAnyGovernmentLandBuildingRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD232 = formData.inspectionDetailData) === null || _formData$inspectionD232 === void 0 ? void 0 : (_formData$inspectionD233 = _formData$inspectionD232.isPlotAdjoiningAnyGovernmentLandBuilding) === null || _formData$inspectionD233 === void 0 ? void 0 : _formData$inspectionD233.remarks),
    onChange: handleChange,
    name: "isPlotAdjoiningAnyGovernmentLandBuilding.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Infrastructure facilities such as water supply, sewerage, drainage, electrical supply available for property"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "radioButton",
    control: control,
    data: yesOrNo,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecioninfrastructureFacilities) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD234 = formData.inspectionDetailData) === null || _formData$inspectionD234 === void 0 ? void 0 : (_formData$inspectionD235 = _formData$inspectionD234.infraFacilitiesAvailableForProperty) === null || _formData$inspectionD235 === void 0 ? void 0 : _formData$inspectionD235.planOn),
    onChange: handleChange,
    placeholder: "Enter plan details",
    name: "infraFacilitiesAvailableForProperty.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    type: "radioButton",
    control: control,
    data: yesOrNo,
    placeholder: "Enter site details",
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.infrastructureFacilitiesSupplyAvailbaleForProperty) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD236 = formData.inspectionDetailData) === null || _formData$inspectionD236 === void 0 ? void 0 : (_formData$inspectionD237 = _formData$inspectionD236.infraFacilitiesAvailableForProperty) === null || _formData$inspectionD237 === void 0 ? void 0 : _formData$inspectionD237.onSite),
    onChange: handleChange,
    name: "infraFacilitiesAvailableForProperty.onSite",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "infraFacilitiesAvailableForProperty.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionInfraFacilityObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD238 = formData.inspectionDetailData) === null || _formData$inspectionD238 === void 0 ? void 0 : (_formData$inspectionD239 = _formData$inspectionD238.infraFacilitiesAvailableForProperty) === null || _formData$inspectionD239 === void 0 ? void 0 : _formData$inspectionD239.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.infrastructureFacilitiesSupplyAvailbaleForPropertyRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD240 = formData.inspectionDetailData) === null || _formData$inspectionD240 === void 0 ? void 0 : (_formData$inspectionD241 = _formData$inspectionD240.infraFacilitiesAvailableForProperty) === null || _formData$inspectionD241 === void 0 ? void 0 : _formData$inspectionD241.remarks),
    onChange: handleChange,
    name: "infraFacilitiesAvailableForProperty.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "Does you property lies in the vicinity of the protected monumental of Heritage Destination"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    data: yesOrNo,
    type: "radioButton",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionHeritageDestination) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD242 = formData.inspectionDetailData) === null || _formData$inspectionD242 === void 0 ? void 0 : (_formData$inspectionD243 = _formData$inspectionD242.IsPropertyLiesInVicinityOfHeritageDestination) === null || _formData$inspectionD243 === void 0 ? void 0 : _formData$inspectionD243.planOn),
    onChange: handleChange,
    name: "IsPropertyLiesInVicinityOfHeritageDestination.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "IsPropertyLiesInVicinityOfHeritageDestination.onSite",
    data: yesOrNo,
    type: "radioButton",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.heritageDestination) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD244 = formData.inspectionDetailData) === null || _formData$inspectionD244 === void 0 ? void 0 : (_formData$inspectionD245 = _formData$inspectionD244.IsPropertyLiesInVicinityOfHeritageDestination) === null || _formData$inspectionD245 === void 0 ? void 0 : _formData$inspectionD245.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "IsPropertyLiesInVicinityOfHeritageDestination.observation",
    type: "selectInput",
    placeholder: "Select Observation",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionHeritageDestObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD246 = formData.inspectionDetailData) === null || _formData$inspectionD246 === void 0 ? void 0 : (_formData$inspectionD247 = _formData$inspectionD246.IsPropertyLiesInVicinityOfHeritageDestination) === null || _formData$inspectionD247 === void 0 ? void 0 : _formData$inspectionD247.observation),
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.heritageDestinationRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD248 = formData.inspectionDetailData) === null || _formData$inspectionD248 === void 0 ? void 0 : (_formData$inspectionD249 = _formData$inspectionD248.IsPropertyLiesInVicinityOfHeritageDestination) === null || _formData$inspectionD249 === void 0 ? void 0 : _formData$inspectionD249.remarks),
    onChange: handleChange,
    name: "IsPropertyLiesInVicinityOfHeritageDestination.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, "property shortage distance of Heritage destination (in mtr)"), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "150px",
    type: "textInput",
    placeholder: "Enter details",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspecionPropertyShortage) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD250 = formData.inspectionDetailData) === null || _formData$inspectionD250 === void 0 ? void 0 : (_formData$inspectionD251 = _formData$inspectionD250.propertyShortageDistanceOfHeritageDestination) === null || _formData$inspectionD251 === void 0 ? void 0 : _formData$inspectionD251.planOn),
    onChange: handleChange,
    name: "propertyShortageDistanceOfHeritageDestination.planOn",
    hasLabel: false
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "propertyShortageDistanceOfHeritageDestination.onSite",
    type: "textInput",
    placeholder: "Enter details",
    onChange: handleChange,
    hasLabel: false,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.propertyShortage) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD252 = formData.inspectionDetailData) === null || _formData$inspectionD252 === void 0 ? void 0 : (_formData$inspectionD253 = _formData$inspectionD252.propertyShortageDistanceOfHeritageDestination) === null || _formData$inspectionD253 === void 0 ? void 0 : _formData$inspectionD253.onSite)
  })), /*#__PURE__*/React__default.createElement("td", {
    style: tableCell$1
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "150px",
    control: control,
    name: "propertyShortageDistanceOfHeritageDestination.observation",
    type: "selectInput",
    data: approvedOrShortfall,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionShortDistHeritageObservation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD254 = formData.inspectionDetailData) === null || _formData$inspectionD254 === void 0 ? void 0 : (_formData$inspectionD255 = _formData$inspectionD254.propertyShortageDistanceOfHeritageDestination) === null || _formData$inspectionD255 === void 0 ? void 0 : _formData$inspectionD255.observation),
    hasLabel: false,
    placeholder: "Select Observation"
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      minWidth: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    width: "95%",
    multiLine: true,
    height: "60px",
    maxLength: 100,
    type: "textInput",
    control: control,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.propertyShortageRemarks) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD256 = formData.inspectionDetailData) === null || _formData$inspectionD256 === void 0 ? void 0 : (_formData$inspectionD257 = _formData$inspectionD256.propertyShortageDistanceOfHeritageDestination) === null || _formData$inspectionD257 === void 0 ? void 0 : _formData$inspectionD257.remarks),
    onChange: handleChange,
    name: "propertyShortageDistanceOfHeritageDestination.remarks",
    hasLabel: false,
    placeholder: "Enter remarks"
  }))))))), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "inspection-Card-Tb"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Site Inspection Form")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    style: {
      display: "flex",
      marginTop: "10px",
      marginBottom: "20px",
      paddingLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Recommendation ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    disabled: disabledData,
    control: control,
    name: "siteInspectionRecommendation",
    type: "selectInput",
    data: siteInspRecommendation,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.siteInspectionRecommendation) || (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD258 = formData.inspectionDetailData) === null || _formData$inspectionD258 === void 0 ? void 0 : _formData$inspectionD258.siteInspectionRecommendation),
    hasLabel: false
  }))), isJE || isAVPandEE ? /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    style: {
      display: "flex",
      marginTop: "10px",
      marginBottom: "20px",
      paddingLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Upload Site Photo ", (isJE || isAVPandEE) && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, (getSitePhotoByJE === null || getSitePhotoByJE === void 0 ? void 0 : (_getSitePhotoByJE$ = getSitePhotoByJE[0]) === null || _getSitePhotoByJE$ === void 0 ? void 0 : _getSitePhotoByJE$.fileStoreId) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      var _getSitePhotoByJE$2;
      return handleLoadDocument(getSitePhotoByJE === null || getSitePhotoByJE === void 0 ? void 0 : (_getSitePhotoByJE$2 = getSitePhotoByJE[0]) === null || _getSitePhotoByJE$2 === void 0 ? void 0 : _getSitePhotoByJE$2.fileStoreId);
    },
    size: "small",
    title: "View Document",
    style: {
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
    fontSize: "small",
    style: {
      color: "#157CB3"
    }
  })), /*#__PURE__*/React__default.createElement(FileUploaderNew, {
    control: control,
    name: "siteInspectionDocument",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: (isJE || isAVPandEE) && !(getSitePhotoByJE !== null && getSitePhotoByJE !== void 0 && (_getSitePhotoByJE$3 = getSitePhotoByJE[0]) !== null && _getSitePhotoByJE$3 !== void 0 && _getSitePhotoByJE$3.fileStoreId) ? true : false,
    tab: 2,
    maxFiles: 5,
    showError: getSitePhotoByJE !== null && getSitePhotoByJE !== void 0 && (_getSitePhotoByJE$4 = getSitePhotoByJE[0]) !== null && _getSitePhotoByJE$4 !== void 0 && _getSitePhotoByJE$4.fileStoreId ? false : true,
    uploadedDocs: siteInspectionDocs,
    setUploadedDocs: setSiteInspectionDocs
  }))) : /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    style: {
      display: "flex",
      marginTop: "10px",
      marginBottom: "20px",
      paddingLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, " View Site Photo")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, getSitePhotoByJE !== null && getSitePhotoByJE !== void 0 && (_getSitePhotoByJE$5 = getSitePhotoByJE[0]) !== null && _getSitePhotoByJE$5 !== void 0 && _getSitePhotoByJE$5.fileStoreId ? /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      var _getSitePhotoByJE$6;
      return handleLoadDocument(getSitePhotoByJE === null || getSitePhotoByJE === void 0 ? void 0 : (_getSitePhotoByJE$6 = getSitePhotoByJE[0]) === null || _getSitePhotoByJE$6 === void 0 ? void 0 : _getSitePhotoByJE$6.fileStoreId);
    },
    size: "small",
    title: "View Document",
    style: {
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
    fontSize: "small",
    style: {
      color: "#157CB3"
    }
  })) : /*#__PURE__*/React__default.createElement("strong", null, "No Site Photo Available"))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    style: {
      display: "flex",
      marginTop: "10px",
      marginBottom: "20px",
      paddingLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Remarks")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))))), showDocPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "60%",
      transform: "translateX(-50%)",
      backgroundColor: "#f3f4f6",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "11px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px"
    }
  }, "Document View"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setShowDocPopup(false),
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), (docPopupData === null || docPopupData === void 0 ? void 0 : docPopupData.length) > 0 ? /*#__PURE__*/React__default.createElement(InspectionPhotoViewer, {
    documentInspection: docPopupData
  }) : /*#__PURE__*/React__default.createElement("p", null, "No documents available for this category.")), !isFromDashboard && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "secondary",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};
const tableHeader$1 = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "left",
  fontSize: "14px"
};
const tableHeaderLable = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "left",
  fontSize: "14px",
  width: "100px"
};
const tableCell$1 = {
  padding: "10px",
  border: "1px solid #ccc",
  width: "80px",
  fontSize: "14px",
  fontFamily: "sans-serif"
};

const CompoundingTable = ({
  paymentHeads,
  mdmsPaymentHeads,
  compoundingFeeHeads,
  compoundingData,
  formData,
  activeCategory,
  onCompoundingSubmit,
  onClose
}) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    getValues
  } = useForm({
    defaultValues: {
      compoundingHeads: []
    }
  });
  const [calculatedHeads, setCalculatedHeads] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);
  const plotArea = formData && formData.additionalDetails && formData.additionalDetails.plotArea || 0;
  const isPlotAreaUpto150 = plotArea <= 150;
  const isPlotAreaUpto300 = plotArea > 150 && plotArea <= 300;
  const isPlotAreaAbove300 = plotArea > 300 && plotArea <= 500;
  const isPlotAreaAbove500 = plotArea > 500;
  const getSlabRateForNewFields = slabs => {
    if (!Array.isArray(slabs)) return 0;
    const target = slabs.find(s => {
      const areaStr = s.area;
      if (areaStr.indexOf("+") !== -1) {
        const min = parseFloat(areaStr.replace("+", ""));
        return plotArea >= min;
      } else {
        const parts = areaStr.split("-").map(Number);
        const min = parts[0];
        const max = parts[1];
        return plotArea >= min && plotArea <= max;
      }
    });
    return target && target.types && target.types[0] ? target.types[0].rate : 0;
  };
  const rows = [];
  if (Array.isArray(compoundingFeeHeads)) {
    compoundingFeeHeads.forEach((section, index) => {
      if (!section || !section.label) return;
      const isNewJSONHead = section.hasOwnProperty("buildUpArea") || section.key === "site_inspection_fees" || section.key === "stacking_charges" || section.key === "security_deposit_tree_plantation";
      if (isNewJSONHead) {
        let dynamicRate = section.rate !== undefined ? section.rate : 0;
        if (section.slabs) {
          dynamicRate = getSlabRateForNewFields(section.slabs);
        }
        rows.push({
          sn: index + 1,
          label: section.label,
          key: section.key,
          type: "new_field",
          unit: section.unit || "Sqmt",
          rate: dynamicRate,
          buildUpArea: section.buildUpArea,
          remarks: section.remarks || "",
          types: null
        });
        return;
      }
      rows.push({
        sn: index + 1,
        label: section.label,
        key: section.key,
        type: "header",
        unit: section.unit,
        formula: section.formula,
        remarks: section.remarks,
        types: section.types
      });
      if (Array.isArray(section.slabs) && section.slabs.length > 0) {
        section.slabs.forEach((slab, index1) => {
          rows.push({
            sn: String.fromCharCode(65 + index1),
            label: "Plot area " + slab.area + " Sqmt.",
            key: section.key,
            type: "slab",
            unit: section.unit,
            rate: slab.types ? slab.types.rate : undefined,
            remarks: section.remarks,
            types: slab.types
          });
        });
      }
      if (Array.isArray(section.subHeads) && section.subHeads.length > 0) {
        section.subHeads.forEach((sub, idx) => {
          if (sub && sub.label) {
            rows.push({
              sn: String.fromCharCode(65 + idx),
              label: sub.label,
              key: section.key,
              type: "subheader",
              unit: section.unit,
              types: sub.types,
              remarks: section.remarks
            });
          }
        });
      }
    });
  }
  const shouldRenderRow = row => {
    if (row.type !== "slab") return true;
    if (row.label.indexOf("0-150") !== -1) return isPlotAreaUpto150;
    if (row.label.indexOf("151-300") !== -1) return isPlotAreaUpto300;
    if (row.label.indexOf("301-500") !== -1) return isPlotAreaAbove300;
    if (row.label.indexOf("501") !== -1) return isPlotAreaAbove500;
    return true;
  };
  useEffect(() => {
    if (rows.length) {
      rows.forEach((row, idx) => {
        setValue(`compoundingHeads.${idx}.isChecked`, false);
        setValue(`compoundingHeads.${idx}.quantity`, "");
        setValue(`compoundingHeads.${idx}.categoryRate`, "");
        setValue(`compoundingHeads.${idx}.amount`, "");
        setValue(`compoundingHeads.${idx}.remarks`, "");
      });
      setCalculatedHeads(null);
      setGrandTotal(0);
    }
  }, [compoundingFeeHeads]);
  useEffect(() => {
    rows.forEach((row, idx) => {
      if (row.type === "new_field") {
        setValue(`compoundingHeads.${idx}.categoryRate`, row.rate);
        return;
      }
      if (!Array.isArray(row.types)) return;
      const matched = row.types.find(t => t.type === activeCategory || t.type === "All");
      if (matched) {
        let rate = "";
        if (matched.rate !== undefined && matched.rate !== null) {
          rate = matched.rate;
        } else if (matched.typeRate !== undefined && matched.typeRate !== null) {
          rate = matched.typeRate;
        } else if (matched.rateA !== undefined && matched.rateA !== null) {
          rate = matched.rateA;
        }
        if (rate !== "") {
          setValue(`compoundingHeads.${idx}.categoryRate`, rate);
        }
      }
    });
  }, [activeCategory, rows.length]);
  useEffect(() => {
    if (!compoundingData || !rows.length) return;
    rows.forEach((row, idx) => {
      const backendRow = compoundingData.find(item => item.feeType === row.label || item.key === row.key);
      if (backendRow) {
        if (row.type === "new_field") {
          setValue(`compoundingHeads.${idx}.isChecked`, true);
          setValue(`compoundingHeads.${idx}.quantity`, backendRow.quantity || 1);
          setValue(`compoundingHeads.${idx}.amount`, backendRow.amount);
          setValue(`compoundingHeads.${idx}.categoryRate`, backendRow.rate);
          setValue(`compoundingHeads.${idx}.remarks`, backendRow.remarks || "");
        } else if (backendRow.occupancyType === activeCategory) {
          setValue(`compoundingHeads.${idx}.quantity`, backendRow.quantity);
          setValue(`compoundingHeads.${idx}.amount`, backendRow.amount);
          setValue(`compoundingHeads.${idx}.categoryRate`, backendRow.rate);
          setValue(`compoundingHeads.${idx}.remarks`, backendRow.remarks || "");
        }
      }
    });
  }, [compoundingData, activeCategory, rows.length]);
  const handleCalculate = () => {
    const currentValues = getValues();
    const compoundingRows = currentValues.compoundingHeads || [];
    const result = rows.map((row, idx) => {
      const formRow = compoundingRows[idx];
      if (row.type === "new_field") {
        if (!formRow || !formRow.isChecked) return null;
        const qty = Number(formRow.quantity || 0);
        const rate = Number(formRow.categoryRate || row.rate || 0);
        const amount = qty * rate;
        setValue(`compoundingHeads.${idx}.amount`, amount);
        return {
          taxHeadCode: row.key,
          feeType: row.label,
          quantity: qty,
          rate: rate,
          factor: 1,
          amount: amount,
          remarks: formRow.remarks || row.remarks || "",
          occupancyType: activeCategory
        };
      } else {
        const qty = Number(formRow ? formRow.quantity : 0);
        const rate = Number(formRow ? formRow.categoryRate : 0);
        if (!qty) return null;
        const amount = qty * rate;
        setValue(`compoundingHeads.${idx}.amount`, amount);
        const matchedType = row.types ? row.types.find(t => t.type === activeCategory) : null;
        return {
          taxHeadCode: matchedType ? matchedType.code : row.key,
          feeType: row.label,
          quantity: qty,
          rate: rate,
          factor: 1,
          amount: amount,
          remarks: formRow ? formRow.remarks : row.remarks || "",
          occupancyType: activeCategory
        };
      }
    }).filter(Boolean);
    if (!result.length) {
      alert("Please enter quantities or select checkboxes before calculating.");
      return;
    }
    const total = result.reduce((sum, item) => sum + item.amount, 0);
    setCalculatedHeads(result);
    setGrandTotal(total);
  };
  const onSave = () => {
    if (!calculatedHeads || !calculatedHeads.length) {
      alert("Please click Calculate first before saving.");
      return;
    }
    console.log(calculatedHeads, "finalCompoundingHeads");
    onCompoundingSubmit(calculatedHeads);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      onSave();
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "S.N."), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Select"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Quantity"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Unit"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Rate"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, activeCategory), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Amount (\u20B9)"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "info"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, rows.map((row, idx) => {
    if (!shouldRenderRow(row)) return null;
    let rowClass = "";
    if (row.type === "header") rowClass = "row-header";else if (row.type === "subheader" || row.type === "slab") rowClass = "row-slab";else if (row.type === "new_field") rowClass = "row-new-field";else rowClass = "row-empty";
    let categoryColumnValue = "";
    if (row.type === "new_field") {
      categoryColumnValue = "N/A";
    } else if (Array.isArray(row.types)) {
      const matched = row.types.find(t => t.type === activeCategory || t.type === "All");
      if (matched) {
        if (matched.typeRate !== undefined) categoryColumnValue = matched.typeRate;else if (matched.rateA !== undefined) categoryColumnValue = matched.rateA;
      }
    }
    const calculatedRow = calculatedHeads ? calculatedHeads.find(h => h.feeType === row.label) : null;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: idx,
      className: rowClass
    }, /*#__PURE__*/React__default.createElement("td", null, row.sn), /*#__PURE__*/React__default.createElement("td", null, row.type === "new_field" ? /*#__PURE__*/React__default.createElement(Controller, {
      name: `compoundingHeads.${idx}.isChecked`,
      control: control,
      render: ({
        field
      }) => /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: Boolean(field.value),
        onChange: e => {
          field.onChange(e.target.checked);
          setCalculatedHeads(null);
          setGrandTotal(0);
        }
      })
    }) : "-"), /*#__PURE__*/React__default.createElement("td", null, row.label && row.type !== "type" ? row.label : ""), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "12vw"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `compoundingHeads.${idx}.quantity`,
      control: control,
      type: "textInput",
      placeholder: "0",
      hasLabel: false,
      width: "8vw",
      height: "22px",
      className: "paymentHeadInput",
      onChange: () => {
        setCalculatedHeads(null);
        setGrandTotal(0);
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "12vw"
      }
    }, row.unit || ""), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "12vw"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `compoundingHeads.${idx}.categoryRate`,
      control: control,
      type: "textInput",
      placeholder: "0",
      hasLabel: false,
      width: "8vw",
      height: "22px",
      className: "paymentHeadInput",
      disabled: false,
      onChange: () => {
        setCalculatedHeads(null);
        setGrandTotal(0);
      }
    })), /*#__PURE__*/React__default.createElement("td", null, categoryColumnValue || "1"), /*#__PURE__*/React__default.createElement("td", {
      className: "amount-col",
      style: {
        width: "12vw"
      }
    }, calculatedRow ? /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontWeight: "600",
        color: "#157CB3"
      }
    }, "\u20B9 ", calculatedRow.amount) : /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `compoundingHeads.${idx}.amount`,
      control: control,
      type: "textInput",
      hasLabel: false,
      width: "8vw",
      height: "22px",
      className: "paymentHeadInput",
      disabled: true
    })), /*#__PURE__*/React__default.createElement("td", null, row.remarks || row.formula || ""), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `compoundingHeads.${idx}.remarks`,
      hasLabel: false,
      control: control,
      placeholder: "Enter Remarks",
      type: "textInput",
      width: "8vw",
      height: "22px",
      className: "paymentHeadInput"
    })));
  })), /*#__PURE__*/React__default.createElement("tfoot", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      backgroundColor: "#f9f9f9",
      fontWeight: "bold",
      borderTop: "2px solid #ccc"
    }
  }, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "7",
    style: {
      textAlign: "right",
      paddingRight: "15px",
      fontSize: "14px",
      color: "#333"
    }
  }, "Total Amount:"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "14px",
      color: "#157CB3",
      fontWeight: "700"
    }
  }, "\u20B9 ", grandTotal.toFixed(2)), /*#__PURE__*/React__default.createElement("td", null))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      gap: "15px",
      margin: "2% 0"
    }
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    type: "button",
    onClick: handleCalculate,
    style: {
      backgroundColor: "#157CB3",
      height: "28px",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Calculate"), /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    type: "submit",
    disabled: !calculatedHeads || calculatedHeads.length === 0,
    style: {
      backgroundColor: calculatedHeads && calculatedHeads.length > 0 ? "#28a745" : "#aaa",
      height: "28px",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Save")));
};

const PaymentHead = ({
  tenantId,
  formData,
  setTaxHead,
  taxHead,
  empRole,
  isFeesEligible,
  Modal,
  onSelect,
  isValidEmp,
  setShowCurrentChallan: _setShowCurrentChallan = () => {},
  isFromDashboard
}) => {
  var _Digit$UserService$ge, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _formData$taxHeadEsti5, _data$BPA, _compoundingData$BPA, _taxHead$, _formData$taxHeadEsti10, _formData$taxHeadEsti11, _formData$taxHeadEsti12, _formData$taxHeadEsti13;
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  console.log("PAYMENDATA", data, formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates, taxHead);
  const [moreHeads, setMoreHeads] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [allRemarks, setAllRemarks] = useState({});
  const isSelfApproval = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP";
  const isApprovedMapSubmission = (formData === null || formData === void 0 ? void 0 : formData.mapSubmissionStatus) === "APPROVED";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const isResidential = (formData === null || formData === void 0 ? void 0 : formData.primaryUse) === "Residential";
  const isCommercial = (formData === null || formData === void 0 ? void 0 : formData.primaryUse) === "Commercial";
  const isOffice = (formData === null || formData === void 0 ? void 0 : formData.primaryUse) === "Office";
  const isIndustrial = (formData === null || formData === void 0 ? void 0 : formData.primaryUse) === "Industrial";
  const isFacilities = (formData === null || formData === void 0 ? void 0 : formData.primaryUse) === "Facilities/Other";
  const activeCategory = isResidential ? "Residential" : isCommercial ? "Commercial" : isOffice ? "Office" : isIndustrial ? "Industrial" : isFacilities ? "Facilities/Other" : null;
  const [disabled, setDisabled] = useState(false);
  const handleNoWorkflow = (taxHeadData, compoundingHeads, paymentHeads) => {
    var _taxHeadData$;
    console.log("handleNoWorkflow invoked", {
      taxHeadData,
      compoundingHeads,
      paymentHeads
    });
    const calculatedCompoundingHeads = (compoundingHeads === null || compoundingHeads === void 0 ? void 0 : compoundingHeads.length) > 0 ? compoundingHeads : (taxHeadData === null || taxHeadData === void 0 ? void 0 : (_taxHeadData$ = taxHeadData[0]) === null || _taxHeadData$ === void 0 ? void 0 : _taxHeadData$.compoundingHeads) || [];
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      workflow,
      taxHeadEstimates: [...taxHeadData] || [],
      compoundingHeads: calculatedCompoundingHeads,
      paymentHeads: paymentHeads || []
    };
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA;
        onSelect(result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        const modalMsg = isSelfApproval ? "Please take Revise Payment action from take action tab." : "Payment heads updated successfully.";
        Modal("Payment heads updated successfully", modalMsg, "success");
      },
      onError: error => {
        console.error("❌ Error in handleNoWorkflow", (error === null || error === void 0 ? void 0 : error.message) || error);
        Modal("Error", "Something went wrong while updating the application.", "error");
      }
    });
    history.replace(window.location.pathname + window.location.search);
  };
  _setShowCurrentChallan(true);
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const sessionData = JSON.parse(sessionStorage.getItem("paymentHeads"));
  const isJE = empRole === "JE";
  const calculateRate = (plotArea, ranges) => {
    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          var _ranges$find;
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (((_ranges$find = ranges.find(r => r.area === "501-1000")) === null || _ranges$find === void 0 ? void 0 : _ranges$find.rate) || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0;
  };
  const addedPayments = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti.find(item => (item === null || item === void 0 ? void 0 : item.taxHeadCode) === "BPA_MAP_SUBMISSION_FEE_2");
  const [paymentHead, setPaymentHead] = useState((formData === null || formData === void 0 ? void 0 : formData.paymentHeads) || addedPayments || (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads) || []);
  const [compoundingHead, setCompoundingHead] = useState((formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : (_formData$taxHeadEsti5 = _formData$taxHeadEsti4[0]) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : _formData$taxHeadEsti5.compoundingHeads) || []);
  const mdmsPaymentHeads = data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA.MapSubPaymentHeads;
  const {
    data: compoundingData,
    isLoading: isCompoundingLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["CompoundingFeeHeads"]);
  const compoundingFeeHeads = (compoundingData === null || compoundingData === void 0 ? void 0 : (_compoundingData$BPA = compoundingData.BPA) === null || _compoundingData$BPA === void 0 ? void 0 : _compoundingData$BPA.CompoundingFeeHeads) || [];
  const [openCompoundingModal, setOpenCompoundingModal] = useState(false);
  const formatNumber = value => {
    return Number(value).toFixed(2);
  };
  const defaultValues = {
    paymentHeads: [{
      feeType: "",
      plotBuildUpArea: "",
      rate: "",
      amount: ""
    }]
  };
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const {
    fields: additionalHeads,
    append,
    remove
  } = useFieldArray({
    control,
    name: "additionalHeads"
  });
  useEffect(() => {
    var _formData$taxHeadEsti6, _formData$taxHeadEsti7;
    const savedPaymentHeads = Array.isArray(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti6 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti6 === void 0 ? void 0 : (_formData$taxHeadEsti7 = _formData$taxHeadEsti6[0]) === null || _formData$taxHeadEsti7 === void 0 ? void 0 : _formData$taxHeadEsti7.paymentHeads) ? formData.taxHeadEstimates[0].paymentHeads : [];
    setPaymentHead(savedPaymentHeads);
    mdmsPaymentHeads === null || mdmsPaymentHeads === void 0 ? void 0 : mdmsPaymentHeads.forEach(item => {
      setValue(`${item.key}.checked`, savedPaymentHeads.some(head => head.feeType === item.key));
    });
  }, [formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates, mdmsPaymentHeads, setValue]);
  const onSubmit = async payload => {
    if (isJE && isSelfApproval && !["APPROVED_JE"].includes(formData === null || formData === void 0 ? void 0 : formData.status)) {
      Modal("Unauthorized Action", "This action is prohibited.", "error");
      return;
    }
    setDisabled(true);
    setLoading(true);
    try {
      var _formData$taxHeadEsti8, _formData$taxHeadEsti9;
      const checkedKeys = Object.entries(payload).filter(([key, value]) => key !== "additionalHeads" && (value === null || value === void 0 ? void 0 : value.checked) === true).map(([key, value]) => ({
        feeType: key,
        plotBuildUpArea: value.plotBuildUpArea,
        updatedAreaJE: value.updatedAreaJE,
        rate: value.rate,
        amount: calcAmount(value.updatedAreaJE, value.rate),
        remarks: value.remarks || ""
      }));
      const extraHeads = ((payload === null || payload === void 0 ? void 0 : payload.additionalHeads) || []).map(h => ({
        ...h,
        amount: calcAmount(h.updatedAreaJE, h.rate)
      }));
      const allHeads = [...checkedKeys, ...extraHeads];
      if (extraHeads.length > 0) setMoreHeads(extraHeads);
      if (allHeads.length === 0) {
        Modal("Error", "Please select at least one payment head.", "error");
        return;
      }
      const total = allHeads.reduce((s, h) => s + toNum(h.amount), 0);
      const paidChallan = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti8 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti8 === void 0 ? void 0 : _formData$taxHeadEsti8.find(i => i.paymentStatus === "PAID");
      const existing = (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti9 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti9 === void 0 ? void 0 : _formData$taxHeadEsti9.find(i => i.paymentStatus !== "PAID")) || {};
      console.log("existing", existing, "paidChallan", paidChallan, "allHeads", allHeads, "total", total);
      const newTaxHeadEstimates = [{
        ...existing
      }];
      setTaxHead(newTaxHeadEstimates);
      setPaymentHead(allHeads);
      sessionStorage.setItem("paymentHeads", JSON.stringify(allHeads));
      await handleNoWorkflow([...(formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates), ...(paidChallan ? [paidChallan] : [])], [], allHeads);
    } catch (e) {
      console.log("Error in onSubmit", e);
      Modal("Error", "Something went wrong", "error");
    } finally {
      setDisabled(false);
      setLoading(false);
    }
  };
  const handleAddInput = () => {
    append({
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    });
  };
  console.log("ISLOADING", loading);
  if (isDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  const handleCompoundingSubmit = async compoundingHeads => {
    setDisabled(true);
    setLoading(true);
    try {
      const newEstimateAmount = compoundingHeads.reduce((sum, h) => sum + Number(h.amount || 0), 0);
      const updatedTaxHeadEstimates = ((formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) || []).map(taxHead => {
        if ((taxHead === null || taxHead === void 0 ? void 0 : taxHead.taxHeadCode) === "BPA_MAP_COMPOUNDING_FEE" || (taxHead === null || taxHead === void 0 ? void 0 : taxHead.calculationBusinesserviceId) === "BPA.MAP_COMPOUNDING_FEE") {
          return {
            ...taxHead,
            estimateAmount: newEstimateAmount,
            compoundingHeads: compoundingHeads
          };
        }
        return taxHead;
      });
      setTaxHead(updatedTaxHeadEstimates);
      setCompoundingHead(compoundingHeads);
      await handleNoWorkflow(updatedTaxHeadEstimates, compoundingHeads, []);
    } catch (err) {
      console.log("Error in handleCompoundingSubmit", err);
      Modal("Error", "Something went wrong", "error");
    } finally {
      setDisabled(false);
      setLoading(false);
    }
  };
  const toNum = v => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };
  const calcAmount = (area, rate) => Math.round(toNum(area) * toNum(rate) * 100) / 100;
  const watchedForm = watch();
  const getRowAmount = key => {
    const row = watchedForm === null || watchedForm === void 0 ? void 0 : watchedForm[key];
    return row !== null && row !== void 0 && row.checked ? calcAmount(row.updatedAreaJE, row.rate) : 0;
  };
  const totalAmount = (mdmsPaymentHeads || []).reduce((sum, item) => sum + getRowAmount(item.key), 0) + ((watchedForm === null || watchedForm === void 0 ? void 0 : watchedForm.additionalHeads) || []).reduce((sum, h) => sum + calcAmount(h === null || h === void 0 ? void 0 : h.updatedAreaJE, h === null || h === void 0 ? void 0 : h.rate), 0);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading ? /*#__PURE__*/React__default.createElement(FullScreenLoader, null) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) != "Compounding" ? /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, !isApprovedMapSubmission && /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Select"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Payment Heads"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Build Up Area"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Area by JE"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Rate"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head payment-head-amount"
  }, "Amount"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head payment-head-amount"
  }, "info"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head payment-head-amount"
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, mdmsPaymentHeads.map((item, index) => {
    var _watchedForm$item$key;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.key
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      type: "checkbox",
      name: `${item.key}.checked`,
      defaultValue: Array.isArray(paymentHead) && paymentHead.some(result => result.feeType === item.key) ? true : false,
      control: control,
      containerStyles: {
        padding: "0px",
        margin: "0"
      }
    })), /*#__PURE__*/React__default.createElement("td", null, item.label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `${item.key}.plotBuildUpArea`,
      hasLabel: false,
      control: control,
      placeholder: "Enter area",
      type: "textInput",
      defaultValue: item !== null && item !== void 0 && item.buildUpArea ? formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea : formData === null || formData === void 0 ? void 0 : formData.plotArea,
      disabled: true,
      width: "100%",
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `${item.key}.updatedAreaJE`,
      hasLabel: false,
      control: control,
      placeholder: "Enter area",
      type: "textInput",
      defaultValue: item !== null && item !== void 0 && item.buildUpArea ? formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea : formData === null || formData === void 0 ? void 0 : formData.plotArea,
      width: "100%",
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `${item.key}.rate`,
      hasLabel: false,
      height: "22px",
      control: control,
      placeholder: "Enter rate",
      defaultValue: item.hasOwnProperty("rate") ? item.rate : calculateRate(formData === null || formData === void 0 ? void 0 : formData.plotArea, item.slabs),
      type: "textInput",
      width: "100%",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", {
      className: "payment-head-amount-td",
      style: {
        textAlign: "center"
      }
    }, watchedForm !== null && watchedForm !== void 0 && (_watchedForm$item$key = watchedForm[item.key]) !== null && _watchedForm$item$key !== void 0 && _watchedForm$item$key.checked ? `₹ ${getRowAmount(item.key)}` : "-"), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `${item.key}.remarks`,
      hasLabel: false,
      control: control,
      placeholder: "Enter Remarks",
      type: "textInput",
      defaultValue: item !== null && item !== void 0 && item.remarks ? item.remarks : "",
      width: "100%",
      height: "22px",
      className: "paymentHeadInput"
    })));
  }), additionalHeads.map((field, index) => {
    const feeTypeValue = watch(`additionalHeads.${index}.feeType`);
    const matchedPayment = paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.find(p => p.feeType === feeTypeValue);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "Delete",
      onClick: () => remove(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      type: "textInput",
      name: `additionalHeads.${index}.feeType`,
      width: "12vw",
      control: control,
      hasLabel: false,
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `additionalHeads.${index}.plotBuildUpArea`,
      hasLabel: false,
      control: control,
      placeholder: "Enter area",
      type: "textInput",
      width: "12vw",
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `additionalHeads.${index}.updatedAreaJE`,
      hasLabel: false,
      control: control,
      placeholder: "Enter area",
      type: "textInput",
      width: "12vw",
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `additionalHeads.${index}.rate`,
      hasLabel: false,
      control: control,
      placeholder: "Enter rate",
      type: "textInput",
      width: "12vw",
      height: "22px",
      className: "paymentHeadInput"
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, "\u20B9 ", calcAmount(watch(`additionalHeads.${index}.updatedAreaJE`), watch(`additionalHeads.${index}.rate`))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `additionalHeads.${index}.remarks`,
      hasLabel: false,
      control: control,
      placeholder: "Enter Remarks",
      type: "textInput",
      width: "12vw",
      height: "22px",
      className: "paymentHeadInput"
    })));
  }), ((taxHead === null || taxHead === void 0 ? void 0 : (_taxHead$ = taxHead[0]) === null || _taxHead$ === void 0 ? void 0 : _taxHead$.estimateAmount) || (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti10 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti10 === void 0 ? void 0 : (_formData$taxHeadEsti11 = _formData$taxHeadEsti10[0]) === null || _formData$taxHeadEsti11 === void 0 ? void 0 : _formData$taxHeadEsti11.estimateAmount) || (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti12 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti12 === void 0 ? void 0 : (_formData$taxHeadEsti13 = _formData$taxHeadEsti12[1]) === null || _formData$taxHeadEsti13 === void 0 ? void 0 : _formData$taxHeadEsti13.estimateAmount)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      fontSize: "16px"
    }
  }, "Total Amount")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontSize: "16px"
    }
  }, "\u20B9 ", formatNumber(totalAmount)))))), !isFromDashboard && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    type: "submit",
    disabled: disabled,
    style: {
      backgroundColor: "#157CB3",
      marginRight: "4px",
      height: "28px",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Save"), /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    onClick: handleAddInput
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon, null), "Add"))))) :
  /*#__PURE__*/
  React__default.createElement(CompoundingTable, {
    onCompoundingSubmit: handleCompoundingSubmit,
    compoundingFeeHeads: compoundingFeeHeads,
    compoundingData: compoundingHead,
    formData: formData,
    activeCategory: activeCategory,
    handleNoWorkflow: handleNoWorkflow,
    onClose: () => setOpenCompoundingModal(false)
  })));
};

const PaymentChallan = ({
  formData,
  item,
  taxHead,
  totalAmount,
  logoUrl,
  date: _date = null
}) => {
  var _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$landInfo, _formData$landInfo$ow, _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$taxHeadEsti4, _formData$taxHeadEsti5, _formData$taxHeadEsti6, _formData$taxHeadEsti7, _formData$taxHeadEsti8, _formData$taxHeadEsti9, _formData$taxHeadEsti10, _formData$taxHeadEsti11, _formData$taxHeadEsti12, _formData$taxHeadEsti13, _formData$taxHeadEsti14, _formData$taxHeadEsti15, _formData$taxHeadEsti16, _formData$taxHeadEsti17, _formData$taxHeadEsti18, _formData$taxHeadEsti19, _formData$taxHeadEsti20, _formData$taxHeadEsti21, _item$mapRate, _item$mapRate2, _item$mapRate3, _item$mapRate4, _item$mapRate5, _item$mapRate6, _formData$compounding;
  console.log("formData33333", formData, item, taxHead, totalAmount);
  const toWords = new ToWords_2();
  const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [amountDetails, setAmountDetails] = useState("");
  const authorityName = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? "Development Authority" : "Avas Vikas Parishad";
  const locationName = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.locationDistrict;
  useEffect(() => {
    if (item !== null && item !== void 0 && item.estimateAmount) {
      const wordsList = toWords.convert(item === null || item === void 0 ? void 0 : item.estimateAmount, {
        currency: true,
        ignoreDecimal: false
      });
      setAmountDetails(wordsList);
    }
  }, [item === null || item === void 0 ? void 0 : item.estimateAmount]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    className: "Paymentchallan",
    p: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    mb: 2,
    border: 1,
    borderColor: "grey.800",
    p: 2
  }, /*#__PURE__*/React__default.createElement("img", {
    width: 120,
    src: logoUrl,
    alt: "Authority Logo",
    style: {
      position: "absolute",
      left: 25,
      height: 60
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, locationName, " ", authorityName), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1"
  }, "Demand Note (Challan / Invoice)"))), /*#__PURE__*/React__default.createElement(Paper$1, {
    variant: "outlined",
    sx: {
      p: 2,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Challan No.:"), " ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.length) - 1]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.challanNo), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Issue Date:"), _date ? Digit.DateUtils.ConvertTimestampToDate(_date) : "N/A"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owner Name:"), " ", formData !== null && formData !== void 0 && (_formData$landInfo = formData.landInfo) !== null && _formData$landInfo !== void 0 && (_formData$landInfo$ow = _formData$landInfo.owners) !== null && _formData$landInfo$ow !== void 0 && _formData$landInfo$ow.length ? formData.landInfo.owners.map(item => item === null || item === void 0 ? void 0 : item.name).join(", ") : "NA"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application Number:"), formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plot Area (Sq. Mt.):"), " ", formData === null || formData === void 0 ? void 0 : formData.plotArea), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application Type:"), " ", (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) || "NA"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "City Name:"), " ", locationName || "NA"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plot Sub Use:"), " ", (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || "NA"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Scheme Name:"), " ", (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeName) || "NA"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plot/Khasra Number:"), formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.plotNo, " /", formData === null || formData === void 0 ? void 0 : formData.khasraNo), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement("strong", null, "Property address:"), " ", (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.landAddress) || "NA", " , Uttar Pradesh", " "), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement("strong", null, "Owner Communication Address:"), " ", (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.correspondenceAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.address) || "NA", " , Uttar Pradesh ,", formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.correspondenceAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.pinno))), /*#__PURE__*/React__default.createElement(Table$2, {
    component: Paper$1,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Sr. No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Particulars"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Area (Sq. Mt.)/Estimated Cost"), (formData === null || formData === void 0 ? void 0 : formData.planOn) !== "SELF_MAP" && /*#__PURE__*/React__default.createElement(TableCell$1, null, "Area by Authority"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Rate"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Total Fees"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Unit"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Remarks"))), (formData === null || formData === void 0 ? void 0 : formData.planOn) != "FORM_MAP_COMPOUNDING" && /*#__PURE__*/React__default.createElement(TableBody$1, null, ((formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && taxHead ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, taxHead.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.plotBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, (row === null || row === void 0 ? void 0 : row.updatedAreaJE) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.amount), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.remarks))), (formData === null || formData === void 0 ? void 0 : formData.planOn) !== "SELF_MAP" && /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, taxHead.length + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Fee On Plot"), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : (_formData$taxHeadEsti5 = _formData$taxHeadEsti4[0]) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : (_formData$taxHeadEsti6 = _formData$taxHeadEsti5.mapRate) === null || _formData$taxHeadEsti6 === void 0 ? void 0 : _formData$taxHeadEsti6.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti7 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti7 === void 0 ? void 0 : (_formData$taxHeadEsti8 = _formData$taxHeadEsti7[0]) === null || _formData$taxHeadEsti8 === void 0 ? void 0 : (_formData$taxHeadEsti9 = _formData$taxHeadEsti8.mapRate) === null || _formData$taxHeadEsti9 === void 0 ? void 0 : _formData$taxHeadEsti9.price), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.remarks))) : (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP" && taxHead ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, taxHead.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.calculatedArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.amount), /*#__PURE__*/React__default.createElement(TableCell$1, null, (row === null || row === void 0 ? void 0 : row.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.remarks))), (formData === null || formData === void 0 ? void 0 : formData.planOn) !== "SELF_MAP" && /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, (taxHead === null || taxHead === void 0 ? void 0 : taxHead.length) + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Fee On Plot"), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti10 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti10 === void 0 ? void 0 : (_formData$taxHeadEsti11 = _formData$taxHeadEsti10[0]) === null || _formData$taxHeadEsti11 === void 0 ? void 0 : (_formData$taxHeadEsti12 = _formData$taxHeadEsti11.mapRate) === null || _formData$taxHeadEsti12 === void 0 ? void 0 : _formData$taxHeadEsti12.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti13 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti13 === void 0 ? void 0 : (_formData$taxHeadEsti14 = _formData$taxHeadEsti13[0]) === null || _formData$taxHeadEsti14 === void 0 ? void 0 : (_formData$taxHeadEsti15 = _formData$taxHeadEsti14.mapRate) === null || _formData$taxHeadEsti15 === void 0 ? void 0 : _formData$taxHeadEsti15.price), /*#__PURE__*/React__default.createElement(TableCell$1, null, (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti16 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti16 === void 0 ? void 0 : (_formData$taxHeadEsti17 = _formData$taxHeadEsti16[0]) === null || _formData$taxHeadEsti17 === void 0 ? void 0 : (_formData$taxHeadEsti18 = _formData$taxHeadEsti17.mapRate) === null || _formData$taxHeadEsti18 === void 0 ? void 0 : _formData$taxHeadEsti18.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti19 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti19 === void 0 ? void 0 : (_formData$taxHeadEsti20 = _formData$taxHeadEsti19[0]) === null || _formData$taxHeadEsti20 === void 0 ? void 0 : (_formData$taxHeadEsti21 = _formData$taxHeadEsti20.mapRate) === null || _formData$taxHeadEsti21 === void 0 ? void 0 : _formData$taxHeadEsti21.remarks))) : Array.isArray(item === null || item === void 0 ? void 0 : item.paymentHeads) && (item === null || item === void 0 ? void 0 : item.paymentHeads.length) > 0 ? item.paymentHeads.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.plotBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.updatedAreaJE), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.amount), /*#__PURE__*/React__default.createElement(TableCell$1, null, (row === null || row === void 0 ? void 0 : row.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.remarks))) : item !== null && item !== void 0 && item.mapRate ? /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "1"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : (_item$mapRate = item.mapRate) === null || _item$mapRate === void 0 ? void 0 : _item$mapRate.name), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : (_item$mapRate2 = item.mapRate) === null || _item$mapRate2 === void 0 ? void 0 : _item$mapRate2.area), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : (_item$mapRate3 = item.mapRate) === null || _item$mapRate3 === void 0 ? void 0 : _item$mapRate3.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : (_item$mapRate4 = item.mapRate) === null || _item$mapRate4 === void 0 ? void 0 : _item$mapRate4.price), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : (_item$mapRate5 = item.mapRate) === null || _item$mapRate5 === void 0 ? void 0 : _item$mapRate5.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : (_item$mapRate6 = item.mapRate) === null || _item$mapRate6 === void 0 ? void 0 : _item$mapRate6.remarks)) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 8,
    align: "center"
  }, "No payment details available"))), (formData === null || formData === void 0 ? void 0 : formData.planOn) === "FORM_MAP_COMPOUNDING" && /*#__PURE__*/React__default.createElement(TableBody$1, null, (formData === null || formData === void 0 ? void 0 : (_formData$compounding = formData.compoundingHeads) === null || _formData$compounding === void 0 ? void 0 : _formData$compounding.length) > 0 ? formData === null || formData === void 0 ? void 0 : formData.compoundingHeads.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.quantity), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.rate), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.factor), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.amount), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.unit) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item === null || item === void 0 ? void 0 : item.remarks))) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 8,
    align: "center"
  }, "No payment details available")))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount (In INR):"), " \u20B9 ", totalAmount || (item === null || item === void 0 ? void 0 : item.estimateAmount) || "NA"))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Note:"), " Amount calculated is based on the formula followed by authority."), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, /*#__PURE__*/React__default.createElement("em", null, "This Document is not valid for any Bank Loan or Registration under RERA Act 2016."))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React__default.createElement("strong", null, "This challan is not final. Amount may be updated before final approval.")))));
};

const PaymentChallanPopup = ({
  formData,
  item,
  taxHead,
  totalAmount,
  logoData,
  date: _date = null
}) => {
  var _daLogo$boundary, _daLogo$boundary$find;
  const [open, setOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [, setIsPreviewLoading] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const conponentPDF = useRef();
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  console.log("LOGOOTSTOREDATA", logoStore, item === null || item === void 0 ? void 0 : item.name, formData, avpLogo, daLogo);
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLandUse = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE";
  const boundaryKey = isLandUse ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.locationDistrict;
  const currentLogoId = isDA ? daLogo === null || daLogo === void 0 ? void 0 : (_daLogo$boundary = daLogo.boundary) === null || _daLogo$boundary === void 0 ? void 0 : (_daLogo$boundary$find = _daLogo$boundary.find(item => (item === null || item === void 0 ? void 0 : item.name) === boundaryKey)) === null || _daLogo$boundary$find === void 0 ? void 0 : _daLogo$boundary$find.fileStoreId : avpLogo === null || avpLogo === void 0 ? void 0 : avpLogo.fileStoreId;
  const fetchLogoUrl = async currentLogoId => {
    console.log("insideFetchURLLogo", currentLogoId);
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    console.log("resultURLLogo", result);
    setLogoUrl(result);
  };
  useEffect(() => {
    if (currentLogoId) {
      fetchLogoUrl(currentLogoId);
    }
  }, [currentLogoId]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => setOpen(true)
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: () => setOpen(false),
    maxWidth: "lg",
    fullWidth: true,
    disablePortal: true,
    hideBackdrop: false,
    sx: {
      position: "fixed",
      zIndex: 9999
    },
    PaperProps: {
      sx: {
        position: "fixed",
        top: "10%",
        left: "55%",
        transform: "translateX(-50%)",
        backgroundColor: "#f3f4f6",
        border: "1px solid #ccc",
        padding: "20px",
        zIndex: 10000,
        maxHeight: "80vh",
        overflowY: "auto",
        width: "75%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, "Payment Challan", /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement(PrintIcon, null),
    content: () => conponentPDF.current
  }), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setOpen(false),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    dividers: true
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement(PaymentChallan, {
    formData: formData,
    item: item,
    date: _date,
    taxHead: taxHead,
    totalAmount: totalAmount,
    logoUrl: logoUrl
  })))));
};

const FormatSlip$2 = ({
  scrutinyTable,
  scrutinyDetails,
  wordslist,
  scrutinyData,
  formData,
  scrutinyTableTransaction
}) => {
  var _scrutinyData$applica, _formData$landInfo, _formData$landInfo$ow, _scrutinyData$landInf, _scrutinyData$landInf2, _scrutinyData$landInf3, _scrutinyData$landInf4, _scrutinyData$landInf5, _scrutinyData$landInf6, _scrutinyData$landInf7;
  const date = convertEpochToDateDMY(scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.auditDetails.createdTime);
  const isTcp = scrutinyData === null || scrutinyData === void 0 ? void 0 : (_scrutinyData$applica = scrutinyData.applicationNo) === null || _scrutinyData$applica === void 0 ? void 0 : _scrutinyData$applica.includes("TCP");
  const colorCodeUrl = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const colorCodeiner = isTcp ? "#f06107ed" : "#000";
  const colorCode = isTcp ? "#248624f7" : "#1f4a7c";
  const nameOfDepartment = formData !== null && formData !== void 0 && formData.selectedOffice ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Awas Evam Vikas Parishad";
  console.log(scrutinyTable, scrutinyTableTransaction, "abcdefgh1", formData);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, scrutinyTable && scrutinyTableTransaction && /*#__PURE__*/React__default.createElement("div", {
    className: "FormatSlipbody"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container bootstrap snippets bootdeys"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      marginLeft: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "85",
    src: colorCodeUrl,
    alt: "UP Logo"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "23px",
      marginTop: "6px"
    }
  }, "Govermment of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      marginTop: "4px"
    }
  }, nameOfDepartment))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, " ", /*#__PURE__*/React__default.createElement("hr", null), " "), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      border: `10px solid ${colorCode}`,
      padding: "12px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-sm-12",
    style: {
      border: `5px solid ${colorCodeiner}`,
      padding: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      opacity: 0.09,
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      flexDirection: "column",
      gap: 10,
      userSelect: "none"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "85",
    src: colorCodeUrl,
    alt: "UP Logo"
  }), /*#__PURE__*/React__default.createElement("p", null, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", null, "Govermment of Uttar Pradesh")), /*#__PURE__*/React__default.createElement("div", {
    className: "panel panel-default invoice",
    id: "invoice"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "panel-body"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "invoice-ribbon"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "ribbon-inner",
    style: {
      background: colorCode
    }
  }, "PAID")), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    width: "85",
    src: colorCodeUrl,
    alt: "UP Logo"
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      fontSize: "22px",
      margin: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "18rem",
      border: `2px solid ${colorCode}`,
      color: colorCode,
      margin: "auto",
      borderRadius: "50px"
    }
  }, "PAYMENT RECEIPT"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, "No : ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.txnId), /*#__PURE__*/React__default.createElement("div", null, "Dated : ", date)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontFamily: "Arial, sans-serif",
      margin: "20px",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    classname: "receiptApp"
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      color: colorCode,
      textAlign: "center",
      margin: "5px"
    }
  }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "block",
      marginBottom: "20px",
      marginLeft: "25px",
      color: "#333",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name Of Professional : Sh./Smt."), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.user.name, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name Of Applicant : Sh./Smt."), " ", formData !== null && formData !== void 0 && (_formData$landInfo = formData.landInfo) !== null && _formData$landInfo !== void 0 && (_formData$landInfo$ow = _formData$landInfo.owners) !== null && _formData$landInfo$ow !== void 0 && _formData$landInfo$ow.length ? formData.landInfo.owners.map(item => item === null || item === void 0 ? void 0 : item.name).join(", ") : scrutinyData === null || scrutinyData === void 0 ? void 0 : (_scrutinyData$landInf = scrutinyData.landInfo) === null || _scrutinyData$landInf === void 0 ? void 0 : (_scrutinyData$landInf2 = _scrutinyData$landInf.owners) === null || _scrutinyData$landInf2 === void 0 ? void 0 : (_scrutinyData$landInf3 = _scrutinyData$landInf2[0]) === null || _scrutinyData$landInf3 === void 0 ? void 0 : _scrutinyData$landInf3.name, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application No :"), " ", formData === null || formData === void 0 ? void 0 : formData.applicationNo, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Phone No :"), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.user.mobileNumber, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Email Id :"), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.user.emailId, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Received Bank :"), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.gateway, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Status :"), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.txnStatusMsg, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Bill ID :"), " ", scrutinyTableTransaction === null || scrutinyTableTransaction === void 0 ? void 0 : scrutinyTableTransaction.billId, " ", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "block",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Address:"), " ", scrutinyData === null || scrutinyData === void 0 ? void 0 : (_scrutinyData$landInf4 = scrutinyData.landInfo) === null || _scrutinyData$landInf4 === void 0 ? void 0 : (_scrutinyData$landInf5 = _scrutinyData$landInf4.owners) === null || _scrutinyData$landInf5 === void 0 ? void 0 : (_scrutinyData$landInf6 = _scrutinyData$landInf5[0]) === null || _scrutinyData$landInf6 === void 0 ? void 0 : (_scrutinyData$landInf7 = _scrutinyData$landInf6.correspondenceAddress) === null || _scrutinyData$landInf7 === void 0 ? void 0 : _scrutinyData$landInf7.address)), /*#__PURE__*/React__default.createElement("table", {
    className: "dataTablePayment"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount of words"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      backgroundColor: colorCode,
      color: "#fff"
    }
  }, "Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Applicaion Fee"), /*#__PURE__*/React__default.createElement("td", null, wordslist), /*#__PURE__*/React__default.createElement("td", null, " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.estimateAmount)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "20px",
      textAlign: "right",
      color: "#333"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount:"), " \u20B9 ", scrutinyTable === null || scrutinyTable === void 0 ? void 0 : scrutinyTable.estimateAmount)))))))))));
};

const PaymentPrint$3 = ({
  id,
  formData,
  challanNo,
  installment: _installment = null
}) => {
  var _Digit$UserService$ge, _applicationData$appl, _applicationData$appl2;
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords_2();
  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [amountDetails, setAmountDetails] = useState(null);
  const [scrutinyTableTransaction, setScrutinyTableTransaction] = useState(null);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const getApplicationPay = async () => {
    var _Digit$UserService$ge2, _window, _window$localStorage;
    setLoader(true);
    const token = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem("token"));
    const requestInfo = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: "v1",
        ts: 0,
        action: "_search",
        did: "",
        key: "",
        msgId: "090909",
        requesterId: "",
        authToken: token,
        userInfo: userInfo
      }
    };
    try {
      var _Resp$Transaction;
      const Resp = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then(response => {
        return response === null || response === void 0 ? void 0 : response.data;
      });
      setLoader(false);
      const transactions = (Resp === null || Resp === void 0 ? void 0 : Resp.Transaction) || [];
      if (_installment) {
        console.log("Installment Details:", _installment, transactions);
        const matchedTxn = transactions.find(t => (t === null || t === void 0 ? void 0 : t.billId) === (_installment === null || _installment === void 0 ? void 0 : _installment.billNo)) || transactions.find(t => (t === null || t === void 0 ? void 0 : t.txnStatus) === "SUCCESS" && Number(t === null || t === void 0 ? void 0 : t.txnAmount) === Number(_installment === null || _installment === void 0 ? void 0 : _installment.amount));
        console.log("Matched Transaction for Installment:", matchedTxn);
        setScrutinyTableTransaction(matchedTxn || null);
        setScrutinyTable({
          ..._installment,
          estimateAmount: _installment === null || _installment === void 0 ? void 0 : _installment.amount,
          challanNo: _installment === null || _installment === void 0 ? void 0 : _installment.billNo,
          auditDetails: matchedTxn === null || matchedTxn === void 0 ? void 0 : matchedTxn.auditDetails
        });
        if (_installment !== null && _installment !== void 0 && _installment.amount) {
          setAmountDetails(toWords.convert(Number(_installment.amount), {
            currency: true,
            ignoreDecimal: false
          }));
        } else {
          setAmountDetails(null);
        }
        return;
      }
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTableTransaction(Resp === null || Resp === void 0 ? void 0 : (_Resp$Transaction = Resp.Transaction) === null || _Resp$Transaction === void 0 ? void 0 : _Resp$Transaction[0]);
      const taxHeadEstimates = (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) || [];
      const selectedIndex = taxHeadEstimates.findIndex(item => (item === null || item === void 0 ? void 0 : item.challanNo) === challanNo);
      console.log("Challan No1:", challanNo);
      console.log("Selected Index2:", selectedIndex);
      if (selectedIndex !== -1) {
        const selectedData = taxHeadEstimates[selectedIndex];
        console.log("Selected Table Data:", selectedData);
        setScrutinyTable(selectedData);
        const amountPaid = selectedData === null || selectedData === void 0 ? void 0 : selectedData.estimateAmount;
        console.log("Selected Amount:", amountPaid);
        if (amountPaid) {
          const wordsList = toWords.convert(Number(amountPaid), {
            currency: true,
            ignoreDecimal: false
          });
          setAmountDetails(wordsList);
        } else {
          setAmountDetails(null);
        }
      } else {
        console.log("Challan not found:", challanNo);
        setScrutinyTable(null);
        setAmountDetails(null);
      }
    } catch (error) {
      console.error("Payment Error:", error);
      setScrutinyTable(null);
      setAmountDetails(null);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (id && (challanNo || _installment) && formData) {
      getApplicationPay();
    }
  }, [id, challanNo, formData, _installment]);
  const {
    data: applicationData = {},
    isLoading: paymentStatus
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id
  });
  if (loader || paymentStatus) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Container, {
    className: "justify-content-center",
    style: {
      minWidth: "100%",
      maxWidth: "100%",
      maxHeight: "50%",
      minHeight: "40%",
      marginTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, null, /*#__PURE__*/React__default.createElement("div", {
    ref: conponentPDF
  }, /*#__PURE__*/React__default.createElement(FormatSlip$2, {
    scrutinyTable: scrutinyTable,
    scrutinyDetails: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$appl = applicationData.applicationData) === null || _applicationData$appl === void 0 ? void 0 : (_applicationData$appl2 = _applicationData$appl.landInfo) === null || _applicationData$appl2 === void 0 ? void 0 : _applicationData$appl2.address,
    scrutinyTableTransaction: scrutinyTableTransaction,
    scrutinyData: applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationData,
    wordslist: amountDetails,
    formData: formData
  }))));
};

const MapSubmissionSummary = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false,
  formType,
  logoData,
  isAlreadySubmitted,
  setIsAlreadySubmitted,
  obpasFileNumber,
  setObpasFileNumber,
  dateOfPayment,
  setDateOfPayment,
  paymentReceipt,
  setPaymentReceipt
}) => {
  var _formData$landInfo, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _documents$filter, _documents$filter$, _formData$locationDis, _Digit$SessionStorage, _formData$paymentHead, _formData$taxHeadEsti4, _formData$taxHeadEsti5, _formData$taxHeadEsti6, _logoData$boundary, _logoData$boundary$fi, _formData$taxHeadEsti7, _formData$taxHeadEsti8, _formData$taxHeadEsti9, _formData$mapSubDetai, _formData$mapSubDetai2, _formData$mapSubDetai3, _formData$mapSubDetai4, _formData$mapSubDetai5, _formData$mapSubDetai6, _formData$plotNumbers, _formData$Purchasable, _formData$Purchasable2, _formData$Purchasable3, _formData$Purchasable4, _formData$Purchasable5, _formData$Purchasable6, _formData$Purchasable7, _formData$Purchasable8, _structuralInfo$perma, _structuralInfo$perma2, _formData$description, _formData$additionalD, _formData$additionalD2, _filterDocumentTypes, _feeDetail$mapRate2, _feeDetail$mapRate3, _formData$documents, _formData$documents3, _formData$documents3$, _formData$documents3$2;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const isResidentialSelfPortal = window.location.pathname.includes("selfResidentialPortal");
  const [, setIsPreviewLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const plotInfo = formData === null || formData === void 0 ? void 0 : formData.plotInfo;
  const structuralInfo = formData === null || formData === void 0 ? void 0 : formData.structuralInfo;
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const professionalInfo = formData === null || formData === void 0 ? void 0 : formData.professionaldetails;
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const paymentHead = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  nameOfDepartment = isDA ? `${formData === null || formData === void 0 ? void 0 : (_formData$locationDis = formData.locationDistrict) === null || _formData$locationDis === void 0 ? void 0 : _formData$locationDis.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  console.log("applicationFlow is:", applicationFlow);
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchisSetbackRequired = formData === null || formData === void 0 ? void 0 : formData.isSetbackRequired;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.constructionType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  const totalTaxHeadAmount = formData === null || formData === void 0 ? void 0 : (_formData$paymentHead = formData.paymentHeads) === null || _formData$paymentHead === void 0 ? void 0 : _formData$paymentHead.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : (_formData$taxHeadEsti5 = _formData$taxHeadEsti4[(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti6 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti6 === void 0 ? void 0 : _formData$taxHeadEsti6.length) - 1]) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : _formData$taxHeadEsti5.estimateAmount) || null;
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isPurchasableFAR = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "PURCHASABLE_MAP";
  const applicationNo = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const isCompletionModule = formType === "FORM_COMPLETION" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_COMPLETION";
  const currentLogoId = isDA ? logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.locationDistrict))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId : logoData === null || logoData === void 0 ? void 0 : logoData.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  const allPaymentHeads = (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti7 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti7 === void 0 ? void 0 : (_formData$taxHeadEsti8 = _formData$taxHeadEsti7[(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti9 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti9 === void 0 ? void 0 : _formData$taxHeadEsti9.length) - 1]) === null || _formData$taxHeadEsti8 === void 0 ? void 0 : _formData$taxHeadEsti8.paymentHeads) || [];
  const declarationMessage = isCompletionModule ? "Certified that the above details are true to the best of my/our personal knowledge. There is no unauthorized construction which has not been mitigated. Therefore, completion certificate should be issued for the construction done on the said building as per attached records" : "I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with this application.";
  console.log("formData in summary", applicationNo);
  console.log("I AM HERE PLEASE CHECK FORM DATA", formData, filteredDocuments);
  const filterDocumentTypes = data => {
    return data.filter(item => !/_([1-6])$/.test(item === null || item === void 0 ? void 0 : item.documentType));
  };
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "General Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo)), (formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.currValidityDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Current Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.currValidityDate)), (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)), applicationNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Application No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicationNo)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity proposed:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planOn)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherSchemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherSchemeName)), (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.isMetroCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Site falls in Metro City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isMetroCity)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.constructionType)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature of Construction /Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction)), watchNatureOfConstruction !== "New" && ((formData === null || formData === void 0 ? void 0 : formData.prevFileNo) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.prevFileNo)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.prevFileNo))), ((formData === null || formData === void 0 ? void 0 : formData.sanctionValidityStartDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.sanctionValidityStartDate)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Previous Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityStartDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.sanctionValidityStartDate))), ((formData === null || formData === void 0 ? void 0 : formData.sanctionValidityDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai5 = formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.sanctionValidityDate)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Previous Sanction Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.sanctionValidityDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai6 = formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.sanctionValidityDate))), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village/College Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.landMark)), (formData === null || formData === void 0 ? void 0 : formData.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector/Pocket No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sectorNo)), (formData === null || formData === void 0 ? void 0 : formData.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.khasraNo)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Standard Type Design:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction date Of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction number of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.noOfPlots) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.noOfPlots)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.plotNumbers) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.join(", "))), (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingClassification)), watchbuildingClassification === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass)), (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isSpecialProject)), (formData === null || formData === void 0 ? void 0 : formData.basicFAR) > 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Basic FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.basicFAR)), (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) > 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Premium FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.premiumFAR)), (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) > 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Purchasable FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.purchasableFAR)), ((formData === null || formData === void 0 ? void 0 : (_formData$Purchasable = formData.Purchasable) === null || _formData$Purchasable === void 0 ? void 0 : _formData$Purchasable.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable2 = formData.Purchasable) === null || _formData$Purchasable2 === void 0 ? void 0 : _formData$Purchasable2.permittedFactor)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permitted Factor:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable3 = formData.Purchasable) === null || _formData$Purchasable3 === void 0 ? void 0 : _formData$Purchasable3.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable4 = formData.Purchasable) === null || _formData$Purchasable4 === void 0 ? void 0 : _formData$Purchasable4.permittedFactor))), ((formData === null || formData === void 0 ? void 0 : (_formData$Purchasable5 = formData.Purchasable) === null || _formData$Purchasable5 === void 0 ? void 0 : _formData$Purchasable5.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable6 = formData.Purchasable) === null || _formData$Purchasable6 === void 0 ? void 0 : _formData$Purchasable6.cost)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable7 = formData.Purchasable) === null || _formData$Purchasable7 === void 0 ? void 0 : _formData$Purchasable7.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable8 = formData.Purchasable) === null || _formData$Purchasable8 === void 0 ? void 0 : _formData$Purchasable8.cost))), (formData === null || formData === void 0 ? void 0 : formData.communityParking) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "If Community Parking Provided:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.communityParking)), watchisSpecialProject === "yes" && (formData === null || formData === void 0 ? void 0 : formData.projectType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Condition Of Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.projectType)), watchisSpecialProject === "Other" && (formData === null || formData === void 0 ? void 0 : formData.otherProjectName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherProjectName)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.groundCoverage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.groundCoverage)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.far) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.far)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingHeight)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackFronts) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackFronts)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackRears) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackRears)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback- 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide1)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback - 2:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide2)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Plot Sub-division:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && (formData === null || formData === void 0 ? void 0 : formData.needCompounding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does existing building require any compounding ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.needCompounding)), watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && watchPlotSubdivided === "no" && watchNeedComp === "no" && (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot Lease hold ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchplotLeaseHold === "yes" && (edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC for Lease hold :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Left:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Right:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No. Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.certificateNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.validupto))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.map((item, index) => {
    var _item$inputonGST, _item$inputonGST2, _item$inputonGST3, _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? "Addition Owner Information" : "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Input On GST:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST = item.inputonGST) === null || _item$inputonGST === void 0 ? void 0 : _item$inputonGST.value) === "yes" ? "Yes" : (item === null || item === void 0 ? void 0 : item.inputonGST) === "no" || (item === null || item === void 0 ? void 0 : (_item$inputonGST2 = item.inputonGST) === null || _item$inputonGST2 === void 0 ? void 0 : _item$inputonGST2.value) === "no" ? "No" : (item === null || item === void 0 ? void 0 : item.inputonGST) || "N/A")), ((item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST3 = item.inputonGST) === null || _item$inputonGST3 === void 0 ? void 0 : _item$inputonGST3.value) === "yes") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "GST No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.gstNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.town)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.address)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "200px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)))))));
  })), structuralInfo && (structuralInfo.name || structuralInfo.validupto || structuralInfo.licenseNumber || ((_structuralInfo$perma = structuralInfo.permanentAddress) === null || _structuralInfo$perma === void 0 ? void 0 : _structuralInfo$perma.address)) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.name) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.validupto) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.licenseNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : (_structuralInfo$perma2 = structuralInfo.permanentAddress) === null || _structuralInfo$perma2 === void 0 ? void 0 : _structuralInfo$perma2.address) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea) || (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.plotArea))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.totalBuildUpArea))), !isPurchasableFAR && (plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot area as per Drawing (Sq.Mt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.plotArea))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, (_filterDocumentTypes = filterDocumentTypes(filteredDocuments)) === null || _filterDocumentTypes === void 0 ? void 0 : _filterDocumentTypes.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  }), (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React__default.createElement("strong", null, "Digitally Signed Drawing PDF"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL, "_blank")
  }))))))), (formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl) && (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Letters")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Letter"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl, "_blank", "noopener,noreferrer")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Map"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl, "_blank", "noopener,noreferrer")
  }))))), formData !== null && formData !== void 0 && formData.isGovernmentBuilding && (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) === "yes" ? null : /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, !isSelfCert && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details (Step-1)")), !isSelfCert && !isPurchasableFAR && /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Fee on Plot:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.price)), paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.map((payment, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, payment === null || payment === void 0 ? void 0 : payment.feeType, ":")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, payment === null || payment === void 0 ? void 0 : payment.amount))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      fontWeight: "bolder"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount)))))), isSelfCert && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), isSelfCert && /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "fee table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Fee Type"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, "Amount (\u20B9)"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, allPaymentHeads === null || allPaymentHeads === void 0 ? void 0 : allPaymentHeads.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, row === null || row === void 0 ? void 0 : row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row === null || row === void 0 ? void 0 : row.amount))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, "Building Permission Fees"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate3 = feeDetail.mapRate) === null || _feeDetail$mapRate3 === void 0 ? void 0 : _feeDetail$mapRate3.price)), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      fontWeight: "bold",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "left"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, totalAmount ? totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2) : "N/A")))))))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.planReport, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.dxfFile, "_blank")
  })))))))), (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("OBPAS Details")))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "OBPAS File Number"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Date of Payment"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, formData !== null && formData !== void 0 && formData.obpasPaymentDate ? formData.obpasPaymentDate.split("T")[0] : ""), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Payment Receipt"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 9
  }, formData !== null && formData !== void 0 && (_formData$documents = formData.documents) !== null && _formData$documents !== void 0 && _formData$documents.find(doc => doc.documentType === "PaymentReceipt") ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      cursor: "pointer",
      color: "#f47738",
      textDecoration: "underline"
    },
    onClick: async () => {
      var _formData$documents2, _formData$documents2$;
      const fileStoreId = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.find(doc => doc.documentType === "PaymentReceipt")) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.fileStoreId;
      if (fileStoreId) {
        try {
          var _res$data;
          const res = await Digit.UploadServices.Filefetch([fileStoreId], Digit.ULBService.getStateId());
          if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data[fileStoreId]) {
            window.open(res.data[fileStoreId].split(",")[0], "_blank");
          }
        } catch (error) {
          console.error("Error fetching file", error);
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#157CB3",
      fontSize: "20px"
    }
  }, "\uD83D\uDCC4"), /*#__PURE__*/React__default.createElement("span", null, (formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.find(doc => doc.documentType === "PaymentReceipt")) === null || _formData$documents3$ === void 0 ? void 0 : (_formData$documents3$2 = _formData$documents3$.additionalDetails) === null || _formData$documents3$2 === void 0 ? void 0 : _formData$documents3$2.fileName) || "Payment Receipt")) : "N/A")))))))), ((_formData$additionalD3, _formData$additionalD4, _formData$additionalD5, _formData$additionalD6, _formData$additionalD7) => {
    const pressObj = (formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : formData.pressDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.pressDetails) || {};
    const hasSug = (formData === null || formData === void 0 ? void 0 : formData.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.hasSuggestion) || (pressObj === null || pressObj === void 0 ? void 0 : pressObj.hasSuggestion);
    const fee = (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD6 = formData.additionalDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.pressReleaseFee) || (pressObj === null || pressObj === void 0 ? void 0 : pressObj.pressReleaseFee);
    const rem = (formData === null || formData === void 0 ? void 0 : formData.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.invitationRemark) || (pressObj === null || pressObj === void 0 ? void 0 : pressObj.invitationRemark);
    if (!hasSug && !fee && !rem) return null;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formContainer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, t("Invitation Suggestion / Press Release")))), /*#__PURE__*/React__default.createElement(SummaryCard, {
      className: "formContainer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse",
        padding: "2rem"
      }
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 12
    }, /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        padding: "1rem"
      }
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, "Any objections or suggestions required for this proposal?"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, hasSug === "yes" ? "Yes" : hasSug === "no" ? "No" : "N/A"), (hasSug === "yes" || fee) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, "Press Release Fee (Amount)"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, `₹ ${fee || 0}`)), rem && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, "Remark"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 6
    }, rem)))))))));
  })(), _showDeclaration && !isResidentialSelfPortal && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, !isCompletionModule && (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_PURCHASABLE_FAR" && formType !== "FORM_PURCHASABLE_FAR" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px 15px",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      fontWeight: "bold",
      fontSize: "16px"
    }
  }, "Is this proposal already submitted in OBPAS by paying the submission fee?"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: "20px",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: "isAlreadySubmitted",
    value: "Yes",
    checked: isAlreadySubmitted === "Yes",
    onChange: e => setIsAlreadySubmitted(e.target.value)
  }), " Yes"), /*#__PURE__*/React__default.createElement("label", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: "isAlreadySubmitted",
    value: "No",
    checked: isAlreadySubmitted === "No",
    onChange: e => setIsAlreadySubmitted(e.target.value)
  }), " No")), isAlreadySubmitted === "Yes" && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "20px",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
    style: {
      fontWeight: "bold"
    }
  }, "OBPAS File Number ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    className: "employee-card-input",
    value: obpasFileNumber,
    onChange: e => setObpasFileNumber(e.target.value),
    style: {
      width: "100%",
      padding: "8px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px"
    }
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
    style: {
      fontWeight: "bold"
    }
  }, "Date of Payment ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement("input", {
    type: "date",
    className: "employee-card-input",
    value: dateOfPayment,
    onChange: e => setDateOfPayment(e.target.value),
    style: {
      width: "100%",
      padding: "8px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      gridColumn: "1 / -1"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    style: {
      fontWeight: "bold",
      display: "block",
      marginBottom: "5px"
    }
  }, "Upload Payment Receipt ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), !paymentReceipt ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      border: "2px dashed #ccc",
      borderRadius: "4px",
      padding: "20px",
      textAlign: "center",
      backgroundColor: "#fafafa",
      cursor: "pointer"
    },
    onClick: () => document.getElementById("payment-receipt-upload").click()
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "payment-receipt-upload",
    type: "file",
    accept: ".pdf,.jpg,.jpeg,.png",
    style: {
      display: "none"
    },
    onChange: async e => {
      const file = e.target.files[0];
      if (file) {
        try {
          var _response$data, _response$data$files, _response$data$files$;
          const response = await Digit.UploadServices.Filestorage("BPA", file, Digit.ULBService.getStateId());
          if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$files = _response$data.files) !== null && _response$data$files !== void 0 && (_response$data$files$ = _response$data$files[0]) !== null && _response$data$files$ !== void 0 && _response$data$files$.fileStoreId) {
            setPaymentReceipt({
              fileStoreId: response.data.files[0].fileStoreId,
              name: file.name
            });
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#157CB3",
      fontWeight: "bold"
    }
  }, "Click to Upload File"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#666",
      marginTop: "5px"
    }
  }, "Supports: PDF, JPG, PNG")) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 15px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#f9f9f9"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#157CB3",
      fontSize: "20px"
    }
  }, "\uD83D\uDCC4"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "500",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }
  }, (paymentReceipt === null || paymentReceipt === void 0 ? void 0 : paymentReceipt.name) || "Payment Receipt")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#d32f2f",
      cursor: "pointer",
      fontWeight: "bold",
      padding: "5px",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      gap: "4px"
    },
    onClick: () => setPaymentReceipt(null)
  }, "\u2715 Remove"))))), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, declarationMessage, " ")
  }))));
});

const EmployeeComponent$1 = ({
  formData,
  applicationDocs,
  totalAmount,
  edcrDetails,
  collectionBillDetails
}) => {
  var _formData$landInfo, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo4, _formData$landInfo4$o;
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#eeeab5b0",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ": \xA0\xA0 ", (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, (formData === null || formData === void 0 ? void 0 : formData.paymentStatus) === "Success" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShowPayment(true), console.log("modal open");
    }
  }, "Payment Receipt")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : _formData$landInfo3.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.name)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Applied For ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, ": \xA0\xA0", t(`${formData === null || formData === void 0 ? void 0 : formData.applicationType}`)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Form ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, ": \xA0\xA0 Permission for Building Plan Approval")), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, /*#__PURE__*/React__default.createElement(MapSubmissionSummary, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: smShowPayment,
    onClose: () => {
      setSmShowPayment(false);
    }
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo
  }))));
};

const MapSubmissionSummarys = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false,
  logoData
}) => {
  var _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$description, _logoData$boundary, _logoData$boundary$fi, _formData$district, _formData$description2, _formData$description3, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$plotInfo, _formData$plotInfo2, _Digit$UserService$ge, _Digit$UserService$ge2;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const paymentHead = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeadDefinition;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const [loading, setLoading] = useState(false);
  const schemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const currentLogoId = isDA ? logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.locationDistrict))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId : logoData === null || logoData === void 0 ? void 0 : logoData.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  nameOfDepartment = isDA ? `${formData === null || formData === void 0 ? void 0 : (_formData$district = formData.district) === null || _formData$district === void 0 ? void 0 : _formData$district.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo",
    style: {
      marginTop: isDA ? "0.5em" : "1em",
      height: "4em",
      width: "auto",
      objectFit: "contain"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application Form")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name of Authority:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.selectedOffice)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Application No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType)), (formData === null || formData === void 0 ? void 0 : formData.plotinMelaArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot in the mela area declared under the Uttar Pradesh Melas Act, 1938?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.plotinMelaArea.charAt(0).toUpperCase() + formData.plotinMelaArea.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot has been subdivided?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.plotSubdivided.charAt(0).toUpperCase() + formData.plotSubdivided.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.plotinColonies) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot in unauthorized layouts/ colonies ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.plotinColonies.charAt(0).toUpperCase() + formData.plotinColonies.slice(1))), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name of Owner:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name)), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Son/Wife/Daughter of:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.fatherOrHusbandName)), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.correspondenceAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address for Correspondence :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.correspondenceAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.address)), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : _formData$landInfo7$o2.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : _formData$landInfo8$o2.mobileNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : _formData$landInfo9$o2.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : _formData$landInfo10$2.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.permissionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Type of Permission :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.permissionType)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, schemeType ? "Land Use as per Layout Plan:" : "Land Use as per Master Plan")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, schemeType ? "Land Sub Use as per Layout Plan:" : "Land Sub Use as per Master Plan")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (formData === null || formData === void 0 ? void 0 : formData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Activity :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.developmentArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.developmentArea)), (formData === null || formData === void 0 ? void 0 : formData.containFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does proposal contain Purchasable FAR? :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.containFAR.charAt(0).toUpperCase() + formData.containFAR.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.plotArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (Sqmt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotArea)), (formData === null || formData === void 0 ? void 0 : formData.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, schemeType ? /*#__PURE__*/React__default.createElement("b", null, "Plot No.") : /*#__PURE__*/React__default.createElement("b", null, "Plot No./Khasra No.")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotNo)), (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), (formData === null || formData === void 0 ? void 0 : formData.totalProposedArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Net Plot Area")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalProposedArea)), (formData === null || formData === void 0 ? void 0 : formData.district) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.district)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Village :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillageMohal) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mohalla Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillageMohal)), (formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber) && schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Approval Sanction No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate) && schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Approval Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate)), (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.landAddress) && !schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Address :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.landAddress)), (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.landAddress) && !schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nearby Landmark :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.landMark)), (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.landLength) && !schemeType && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Access road width (RoW) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.landLength)), (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.estimatedCost) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost (\u20B9):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.declaration) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, /*#__PURE__*/React__default.createElement(CheckBox, {
    name: "declaration",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.declaration,
    disabled: true
  }))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM")))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), (formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl) && (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Letters"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Letter"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl, "_blank", "noopener,noreferrer")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Map"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl, "_blank", "noopener,noreferrer")
  }))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Map")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.planlocationOfPlot) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does the attached Plan show: Location of plot along with existing roads and their width?")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.planlocationOfPlot.charAt(0).toUpperCase() + formData.planlocationOfPlot.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.plandimensionOfPlot) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does the attached Plan show: Dimensions of plot/premise along with setback?")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.plandimensionOfPlot.charAt(0).toUpperCase() + formData.plandimensionOfPlot.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.planfloorPlans) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does the attached Plan: Include floor plans of all floors together with the covered area clearly indicating sizes of rooms and the position and width of staircases and other exits?")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.planfloorPlans.charAt(0).toUpperCase() + formData.planfloorPlans.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.containMoreThanThree) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your proposal contain more than 3 floors?")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.containMoreThanThree.charAt(0).toUpperCase() + formData.containMoreThanThree.slice(1))), (formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Height of Building :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding)), (formData === null || formData === void 0 ? void 0 : formData.plansParkingSpace) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Details of parking spaces provided (If plot size is more than 50 sqm) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plansParkingSpace))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, item.feeType, ":")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "\u20B9 ", item.amount))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      fontWeight: "bolder"
    }
  }, "\u20B9 ", paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.reduce((acc, curr) => acc + Number(curr.amount || 0), 0), " only"))))))), _showDeclaration && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontStyle: "italic"
      }
    }, "I, ", ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.name) || "User", " ,", t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM"), " ")
  }))));
});

const useStyles$2 = makeStyles$1({
  table: {
    minWidth: 800
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  }
});
const StyledTableCell$2 = styled$1(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$2 = styled$1(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  ":hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const headerData = [{
  id: "slno",
  label: "Sr. No"
}, {
  id: "letterType",
  label: "Letter Type"
}, {
  id: "view",
  label: "View Letter"
}];
const ViewAllLetters = ({
  formData
}) => {
  const classes = useStyles$2();
  console.log("FOrmDataGOtt1888", formData);
  const [tableData, setTableData] = useState([]);
  const [loaderData, setLoaderData] = useState(false);
  useEffect(() => {
    if (formData) generateData(formData);
  }, [formData]);
  const handleViewLetter = row => {
    console.log("View letter:", row);
    if (row.url === "callFunction") {
      handleProvisionalApprovalLetter();
    } else {
      if (typeof row.url === "string" && (row.url.startsWith("http://") || row.url.startsWith("https://"))) {
        window.open(row.url, "_blank");
      } else {
        getDocumentByFileStoreId(row.url, setLoaderData);
      }
    }
  };
  const getProvisionalApprovalLetterId = () => {
    var _formData$additionalD;
    const raw = (formData === null || formData === void 0 ? void 0 : formData.provisionalApprovalLetterId) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.provisionalApprovalLetterId);
    if (!raw) return null;
    if (typeof raw === "string" && raw.trim() !== "") {
      return raw.trim();
    }
    if (typeof raw === "object") {
      const keys = Object.keys(raw);
      if (keys.length > 0) {
        const latestKey = keys.sort().at(-1);
        return raw[latestKey];
      }
    }
    return null;
  };
  const handleProvisionalApprovalLetter = () => {
    const fileStoreId = getProvisionalApprovalLetterId();
    if (!fileStoreId) return;
    if (typeof fileStoreId === "string" && (fileStoreId.startsWith("http://") || fileStoreId.startsWith("https://"))) {
      window.open(fileStoreId, "_blank");
      return;
    }
    getDocumentByFileStoreId(fileStoreId, setLoaderData);
  };
  const getObjectionLetters = (objectionLetterUrl = {}) => {
    return Object.entries(objectionLetterUrl).sort(([keyA], [keyB]) => {
      var _keyA$match, _keyB$match;
      const dateA = (_keyA$match = keyA.match(/objection_(\d{4}-\d{2}-\d{2})/)) === null || _keyA$match === void 0 ? void 0 : _keyA$match[1];
      const dateB = (_keyB$match = keyB.match(/objection_(\d{4}-\d{2}-\d{2})/)) === null || _keyB$match === void 0 ? void 0 : _keyB$match[1];
      return new Date(dateB) - new Date(dateA);
    }).map(([key, value], index) => {
      var _value$match;
      const url = ((_value$match = value.match(/\((https?:\/\/[^"]+)/)) === null || _value$match === void 0 ? void 0 : _value$match[1]) || value;
      return {
        label: `Objection Letter ${index + 1}`,
        url
      };
    });
  };
  const generateData = formData => {
    var _formData$taxHeadEsti, _formData$additionalD2;
    const shortfallObjectionObj = {
      type: "Objection Letter",
      url: (formData === null || formData === void 0 ? void 0 : formData.objectionLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.compoundingShortfallUrl),
      allLetters: getObjectionLetters(formData === null || formData === void 0 ? void 0 : formData.objectionLetterUrl),
      isViewIcon: formData !== null && formData !== void 0 && formData.compoundingShortfallUrl ? true : false
    };
    const approvalObj = {
      type: "Approval Letter",
      url: formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl,
      isViewIcon: true
    };
    const provisionalApproveObj = {
      type: "Provisonally Approval Letter",
      url: "callFunction",
      isViewIcon: true
    };
    const initiationObj = {
      type: "Initiation Letter",
      url: formData === null || formData === void 0 ? void 0 : formData.farInimationLetterUrl,
      isViewIcon: true
    };
    const rejectionObj = {
      type: "Rejection Letter",
      url: (formData === null || formData === void 0 ? void 0 : formData.mapRejectionLetterurl) || (formData === null || formData === void 0 ? void 0 : formData.mapRejectionLetterId) || (formData === null || formData === void 0 ? void 0 : formData.compoundingRejectLetterUrl),
      isViewIcon: true
    };
    const proposalObj = {
      type: "Proposal Letter",
      url: formData === null || formData === void 0 ? void 0 : formData.proposalUrl,
      isViewIcon: true
    };
    let temp = [];
    if (formData !== null && formData !== void 0 && formData.objectionLetterUrl || formData !== null && formData !== void 0 && formData.compoundingShortfallUrl) {
      temp.push(shortfallObjectionObj);
    }
    if (formData !== null && formData !== void 0 && formData.approvalCertificateUrl && ((formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" || (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED_JE") && formData !== null && formData !== void 0 && (_formData$taxHeadEsti = formData.taxHeadEstimates) !== null && _formData$taxHeadEsti !== void 0 && _formData$taxHeadEsti[0]) {
      temp.push(approvalObj);
    }
    if (formData !== null && formData !== void 0 && formData.provisionalApprovalLetterId || formData !== null && formData !== void 0 && (_formData$additionalD2 = formData.additionalDetails) !== null && _formData$additionalD2 !== void 0 && _formData$additionalD2.provisionalApprovalLetterId) {
      temp.push(provisionalApproveObj);
    }
    if (formData !== null && formData !== void 0 && formData.farInimationLetterUrl) {
      temp.push(initiationObj);
    }
    if ((formData !== null && formData !== void 0 && formData.mapRejectionLetterurl || formData !== null && formData !== void 0 && formData.compoundingRejectLetterUrl) && (formData === null || formData === void 0 ? void 0 : formData.status) === "REJECTED") {
      temp.push(rejectionObj);
    }
    if (formData !== null && formData !== void 0 && formData.proposalUrl) {
      temp.push(proposalObj);
    }
    setTableData(temp);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$1, null, /*#__PURE__*/React__default.createElement(Table$2, {
    className: classes.table,
    "aria-label": "letters table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    className: classes.tableRow
  }, headerData.map(column => /*#__PURE__*/React__default.createElement(StyledTableCell$2, {
    key: column.id
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, tableData && (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tableData === null || tableData === void 0 ? void 0 : tableData.map((row, index) => {
    var _row$allLetters;
    return /*#__PURE__*/React__default.createElement(StyledTableRow$2, {
      key: (row === null || row === void 0 ? void 0 : row.serialNo) || index
    }, /*#__PURE__*/React__default.createElement(StyledTableCell$2, null, index + 1), /*#__PURE__*/React__default.createElement(StyledTableCell$2, null, (row === null || row === void 0 ? void 0 : row.type) || "-"), /*#__PURE__*/React__default.createElement(StyledTableCell$2, null, !(row !== null && row !== void 0 && row.isViewIcon) ? /*#__PURE__*/React__default.createElement(Select$3, {
      size: "small",
      defaultValue: "",
      displayEmpty: true,
      onChange: e => {
        window.open(e.target.value, "_blank");
      },
      sx: {
        minWidth: 140
      },
      MenuProps: {
        sx: {
          zIndex: 100000
        },
        PaperProps: {
          sx: {
            zIndex: 100000
          }
        }
      }
    }, /*#__PURE__*/React__default.createElement(MenuItem$2, {
      value: "",
      disabled: true
    }, "Select Objection Letter"), row === null || row === void 0 ? void 0 : (_row$allLetters = row.allLetters) === null || _row$allLetters === void 0 ? void 0 : _row$allLetters.map(letter => /*#__PURE__*/React__default.createElement(MenuItem$2, {
      key: letter.url,
      value: letter.url
    }, letter.label))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loaderData && row.url === "callFunction" ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "20px",
        height: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      onClick: () => handleViewLetter(row),
      sx: {
        color: "#1976d2",
        cursor: "pointer"
      }
    }))));
  })) : /*#__PURE__*/React__default.createElement(StyledTableCell$2, {
    colSpan: 3
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      textAlign: "center"
    }
  }, "No Letters Generated"))))));
};

const Architect$1 = ({
  formData,
  applicationDocs,
  totalAmount,
  edcrDetails,
  collectionBillDetails,
  actions
}) => {
  var _formData$application, _formData$landInfo, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo4, _formData$landInfo4$o, _formData$taxHeadEsti, _formData$taxHeadEsti2;
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showLettersModal, setShowLettersModal] = useState(false);
  const isTcp = formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationNo) === null || _formData$application === void 0 ? void 0 : _formData$application.includes("TCP");
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const status = (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" || (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED_JE";
  const isPlinth = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "plinth_submission";
  console.log("FOrmDataFOund", formData);
  function getApprovalPDFLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.selfDrawingPdfUrl;
    window.open(pdfUrl, "_blank");
  }
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "rgba(173, 229, 232, 0.69)",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, ": \xA0\xA0 ", (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 6",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Owner name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : _formData$landInfo3.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.name)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Applied For ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, ": \xA0\xA0", " ", (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP" ? "Self Certification via Registration" : (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? "Self Approval via LTP" : (formData === null || formData === void 0 ? void 0 : formData.planOn) === "plinth_submission" ? "Plinth Submission" : "Map Submission"), status && !isPlinth && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Drawing PDF ")), status && !isPlinth && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, ":", " ", /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    className: "btn-table-action",
    variant: "contained",
    color: "primary",
    onClick: () => getApprovalPDFLetter(formData)
  }, /*#__PURE__*/React__default.createElement("span", null, "View"))), (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) && (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      margin: "10px 0px"
    }
  }, "Payment Details")), (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) && (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, ":", " ", /*#__PURE__*/React__default.createElement(Button$2, {
    size: "medium",
    sx: {
      margin: "10px 0px"
    },
    className: "btn-table-action",
    variant: "contained",
    color: "primary",
    onClick: () => setShowPaymentModal(true)
  }, /*#__PURE__*/React__default.createElement("span", null, "View Payment Details"))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      margin: "3px 0px"
    }
  }, "Letters")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 9",
    sx: {
      ml: 2
    }
  }, ":", " ", /*#__PURE__*/React__default.createElement(Button$2, {
    size: "medium",
    sx: {
      margin: "3px 0px"
    },
    className: "btn-table-action",
    variant: "contained",
    color: "primary",
    onClick: () => setShowLettersModal(true)
  }, /*#__PURE__*/React__default.createElement("span", null, "View Letters")))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.plotinMelaArea) === "no" ? /*#__PURE__*/React__default.createElement(MapSubmissionSummarys, {
    formData: formData,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo
  }) : /*#__PURE__*/React__default.createElement(MapSubmissionSummary, {
    formData: formData,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  })), showPaymentModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Payment Details",
    dataOpen: showPaymentModal,
    onClose: () => {
      setShowPaymentModal(false);
    }
  }, /*#__PURE__*/React__default.createElement(PaymentMemoTable, {
    formData: formData,
    showDeleteButton: false
  })), showLettersModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "All Letters",
    dataOpen: showLettersModal,
    onClose: () => {
      setShowLettersModal(false);
    }
  }, /*#__PURE__*/React__default.createElement(ViewAllLetters, {
    formData: formData
  }))));
};

const ChallanDetails = ({
  formData,
  taxHead,
  totalAmount,
  ...props
}) => {
  var _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$mapSubDetai, _formData$mapSubDetai2, _formData$mapSubDetai3, _formData$additionalD4, _formData$mapSubDetai4, _formData$obpasDetail, _formData$additionalD5, _formData$additionalD6, _formData$mapSubDetai5, _formData$mapSubDetai6, _props$paymentReceipt, _taxHeadEstimates$;
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const latestChallan = formData !== null && formData !== void 0 && formData.taxHeadEstimates ? formData.taxHeadEstimates[formData.taxHeadEstimates.length - 1] : null;
  const taxHeadEstimates = Array.isArray(formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) ? formData.taxHeadEstimates : [];
  const isAlreadySubmitted = typeof (props === null || props === void 0 ? void 0 : props.isAlreadySubmitted) !== "undefined" ? Boolean(props.isAlreadySubmitted) : (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === "Yes" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.isAlreadySubmitted) === "Yes" || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.isAlreadySubmitted) === "Yes";
  const obpasFileNumber = (props === null || props === void 0 ? void 0 : props.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$obpasDetail = formData.obpasDetails) === null || _formData$obpasDetail === void 0 ? void 0 : _formData$obpasDetail.obpasFileNumber) || "";
  const dateOfPayment = (props === null || props === void 0 ? void 0 : props.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : formData.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : formData.obpasPaymentDate) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD6 = formData.additionalDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.obpasPaymentDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai5 = formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai6 = formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.obpasPaymentDate) || "";
  const getPaymentReceiptFileStoreId = data => {
    var _data$paymentReceipt, _data$additionalDetai, _data$additionalDetai2, _data$additionalDetai3, _data$obpasPaymentRec, _data$documents, _data$documents$find, _data$additionalDetai4, _data$additionalDetai5, _data$additionalDetai6, _data$additionalDocs, _data$additionalDocs$;
    if (typeof (data === null || data === void 0 ? void 0 : data.paymentReceipt) === "string") return data.paymentReceipt;
    if (data !== null && data !== void 0 && (_data$paymentReceipt = data.paymentReceipt) !== null && _data$paymentReceipt !== void 0 && _data$paymentReceipt.fileStoreId) return data.paymentReceipt.fileStoreId;
    if (typeof (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.paymentReceipt) === "string") return data.additionalDetails.paymentReceipt;
    if (data !== null && data !== void 0 && (_data$additionalDetai2 = data.additionalDetails) !== null && _data$additionalDetai2 !== void 0 && (_data$additionalDetai3 = _data$additionalDetai2.paymentReceipt) !== null && _data$additionalDetai3 !== void 0 && _data$additionalDetai3.fileStoreId) return data.additionalDetails.paymentReceipt.fileStoreId;
    if (typeof (data === null || data === void 0 ? void 0 : data.obpasPaymentReceipt) === "string") return data.obpasPaymentReceipt;
    if (data !== null && data !== void 0 && (_data$obpasPaymentRec = data.obpasPaymentReceipt) !== null && _data$obpasPaymentRec !== void 0 && _data$obpasPaymentRec.fileStoreId) return data.obpasPaymentReceipt.fileStoreId;
    const doc = (data === null || data === void 0 ? void 0 : (_data$documents = data.documents) === null || _data$documents === void 0 ? void 0 : (_data$documents$find = _data$documents.find) === null || _data$documents$find === void 0 ? void 0 : _data$documents$find.call(_data$documents, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt")) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : (_data$additionalDetai5 = _data$additionalDetai4.documents) === null || _data$additionalDetai5 === void 0 ? void 0 : (_data$additionalDetai6 = _data$additionalDetai5.find) === null || _data$additionalDetai6 === void 0 ? void 0 : _data$additionalDetai6.call(_data$additionalDetai5, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt")) || (data === null || data === void 0 ? void 0 : (_data$additionalDocs = data.additionalDocs) === null || _data$additionalDocs === void 0 ? void 0 : (_data$additionalDocs$ = _data$additionalDocs.find) === null || _data$additionalDocs$ === void 0 ? void 0 : _data$additionalDocs$.call(_data$additionalDocs, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt"));
    return (doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.fileStoreUrl) || null;
  };
  const receiptFileStoreId = (typeof (props === null || props === void 0 ? void 0 : props.paymentReceipt) === "string" ? props.paymentReceipt : props === null || props === void 0 ? void 0 : (_props$paymentReceipt = props.paymentReceipt) === null || _props$paymentReceipt === void 0 ? void 0 : _props$paymentReceipt.fileStoreId) || getPaymentReceiptFileStoreId(formData);
  const handleOpenReceipt = async fileStoreId => {
    if (!fileStoreId) {
      alert("Receipt not available");
      return;
    }
    if (String(fileStoreId).startsWith("http://") || String(fileStoreId).startsWith("https://")) {
      window.open(fileStoreId, "_blank");
      return;
    }
    try {
      await getDocumentByFileStoreId(fileStoreId, () => {});
    } catch (e) {
      console.error("Error opening receipt file:", e);
      try {
        var _Digit, _Digit$ULBService, _Digit$ULBService$get, _Digit2, _Digit2$UploadService, _Digit2$UploadService2, _res$data, _res$data$fileStoreId, _res$data$fileStoreId2;
        const tenantId = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ULBService = _Digit.ULBService) === null || _Digit$ULBService === void 0 ? void 0 : (_Digit$ULBService$get = _Digit$ULBService.getStateId) === null || _Digit$ULBService$get === void 0 ? void 0 : _Digit$ULBService$get.call(_Digit$ULBService)) || "up";
        const res = await ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$UploadService = _Digit2.UploadServices) === null || _Digit2$UploadService === void 0 ? void 0 : (_Digit2$UploadService2 = _Digit2$UploadService.Filefetch) === null || _Digit2$UploadService2 === void 0 ? void 0 : _Digit2$UploadService2.call(_Digit2$UploadService, [fileStoreId], tenantId));
        const url = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$fileStoreId = _res$data.fileStoreIds) === null || _res$data$fileStoreId === void 0 ? void 0 : (_res$data$fileStoreId2 = _res$data$fileStoreId[0]) === null || _res$data$fileStoreId2 === void 0 ? void 0 : _res$data$fileStoreId2.url;
        if (url) window.open(url, "_blank");
      } catch (err) {
        console.error("Fallback file fetch failed:", err);
      }
    }
  };
  const formatDateValue = dateVal => {
    if (!dateVal) return "N/A";
    if (typeof dateVal === "number" || /^\d+$/.test(String(dateVal)) && String(dateVal).length > 8) {
      var _Digit3, _Digit3$DateUtils;
      return (_Digit3 = Digit) !== null && _Digit3 !== void 0 && (_Digit3$DateUtils = _Digit3.DateUtils) !== null && _Digit3$DateUtils !== void 0 && _Digit3$DateUtils.ConvertTimestampToDate ? Digit.DateUtils.ConvertTimestampToDate(Number(dateVal)) : new Date(Number(dateVal)).toLocaleDateString("en-IN");
    }
    const str = String(dateVal).split("T")[0].split(" ")[0];
    if (str.includes("-")) {
      const parts = str.split("-");
      if (parts[0].length === 4) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return str;
    }
    if (str.includes("/")) {
      var _parts$;
      const parts = str.split("/");
      if (((_parts$ = parts[2]) === null || _parts$ === void 0 ? void 0 : _parts$.length) === 4) {
        return `${parts[0]}-${parts[1]}-${parts[2]}`;
      }
      return str;
    }
    return str;
  };
  const displayedEstimates = isAlreadySubmitted ? taxHeadEstimates.slice(1) : taxHeadEstimates.length > 0 ? taxHeadEstimates : latestChallan ? [latestChallan] : [];
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: "100%",
      overflowX: "auto"
    }
  }, isAlreadySubmitted && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "8px 16px",
      backgroundColor: "#e8f5e9",
      borderLeft: "4px solid #2e7d32",
      color: "#1b5e20",
      fontSize: "13px",
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u2139\uFE0F"), /*#__PURE__*/React__default.createElement("span", null, "Note: Initial fee was already submitted on OBPAS (File No: ", obpasFileNumber || "N/A", ").")), /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 700
    },
    "aria-label": "payment memo table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Challan")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan No.")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Date")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount (in Rs.)")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Receipt")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, isAlreadySubmitted && /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbf9"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Chip, {
    size: "small",
    label: "Already Submitted on OBPAS",
    sx: {
      backgroundColor: "#e8f5e9",
      color: "#1b5e20",
      fontWeight: "bold",
      fontSize: "11px"
    }
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, obpasFileNumber || "N/A")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "11px",
      color: "#2e7d32",
      fontWeight: 600
    }
  }, "Already Submitted on OBPAS")), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatDateValue(dateOfPayment)), /*#__PURE__*/React__default.createElement(TableCell$1, null, (taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : (_taxHeadEstimates$ = taxHeadEstimates[0]) === null || _taxHeadEstimates$ === void 0 ? void 0 : _taxHeadEstimates$.estimateAmount) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, receiptFileStoreId ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => handleOpenReceipt(receiptFileStoreId)
  }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"))), displayedEstimates.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(IconButton$1, null, /*#__PURE__*/React__default.createElement(PaymentChallanPopup, {
    formData: formData,
    item: item,
    taxHead: taxHead,
    totalAmount: totalAmount
  }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.challanNo) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item !== null && item !== void 0 && item.challanGeneratedDateTime ? (() => {
    const [datePart] = item === null || item === void 0 ? void 0 : item.challanGeneratedDateTime.split(" ");
    const [yyyy, mm, dd] = datePart.split("-");
    return `${dd}-${mm}-${yyyy}`;
  })() : "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.estimateAmount) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" || (item === null || item === void 0 ? void 0 : item.paymentStatus) === "PAID" ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => {
      setShowPaymentDetails(true);
      setSelectedChallanNo(item === null || item === void 0 ? void 0 : item.challanNo);
    }
  }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"), showPaymentDetails && selectedChallanNo === (item === null || item === void 0 ? void 0 : item.challanNo) && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: showPaymentDetails,
    onClose: () => setShowPaymentDetails(false)
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    formData: formData,
    challanNo: item === null || item === void 0 ? void 0 : item.challanNo
  }))))))));
};

const Step3$1 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4, _data$BPA, _feeDetail$mapRate, _feeDetail$mapRate2, _feeDetail$mapRate3, _feeDetail$mapRate4, _feeDetail$mapRate5, _feeDetail$mapRate6;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const [taxHead, setTaxHead] = useState((formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.length) - 1]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads) || []);
  const [calculateTaxHead, setCalculateTaxHead] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const paymentHeads = (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA.MapSubPaymentHeads) || [];
  console.log(paymentHeads, "paymentheads");
  console.log(feeDetail, formData, "feeDeetails");
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "paymentHeads"
  });
  const handleCalculate = async () => {
    var _data$Calculations, _data$Calculations$, _data$Calculations$$t, _data$Calculations$$t2, _data$Calculations2, _data$Calculations2$;
    setIsLoading(true);
    const paymentHeads = watch("formPaymentHeads");
    const checkedheads = paymentHeads.filter(e => e.checked).map(item => ({
      feeType: item.label,
      ...item
    }));
    console.log({
      paymentHeads,
      checkedheads
    }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{
      BPA: {
        ...formData
      },
      tenantId: "up",
      feeType: "ApplicationFee"
    }];
    const data = await Digit.OBPSService.bpacalculate({
      CalulationCriteria
    });
    console.log(data, "calculationData");
    const currentTaxHeads = [...(data === null || data === void 0 ? void 0 : (_data$Calculations = data.Calculations) === null || _data$Calculations === void 0 ? void 0 : (_data$Calculations$ = _data$Calculations[0]) === null || _data$Calculations$ === void 0 ? void 0 : (_data$Calculations$$t = _data$Calculations$.taxHeadEstimates) === null || _data$Calculations$$t === void 0 ? void 0 : (_data$Calculations$$t2 = _data$Calculations$$t[0]) === null || _data$Calculations$$t2 === void 0 ? void 0 : _data$Calculations$$t2.paymentHeads)] || [];
    console.log(("currentTaxHeads"));
    setTaxHead(currentTaxHeads);
    setCalculateTaxHead(data === null || data === void 0 ? void 0 : (_data$Calculations2 = data.Calculations) === null || _data$Calculations2 === void 0 ? void 0 : (_data$Calculations2$ = _data$Calculations2[0]) === null || _data$Calculations2$ === void 0 ? void 0 : _data$Calculations2$.taxHeadEstimates);
    Modal("Fee calculated successfully", `Please click on Save to update the calculated fee details.`, "success");
    setIsLoading(false);
    setEnableSave(true);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);
    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          var _ranges$find;
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (((_ranges$find = ranges.find(r => r.area === "501-1000")) === null || _ranges$find === void 0 ? void 0 : _ranges$find.rate) || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0;
  };
  const totalTaxHeadAmount = taxHead === null || taxHead === void 0 ? void 0 : taxHead.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate = feeDetail.mapRate) === null || _feeDetail$mapRate === void 0 ? void 0 : _feeDetail$mapRate.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  const onSubmit = data => {
    data.paymentHeads = taxHead;
    data.taxHeadEstimates = calculateTaxHead || (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates);
    handleTabChange(4, data);
  };
  const Modal = useModal();
  const [disclaimerShown, setDisclaimerShown] = useState(false);
  const openDisclaimerModal = () => {
    if (disclaimerShown) return;
    Modal("", "The rates indicated in the fee calculation table are for general reference only. Please apply the applicable rates as per the concerned Development Authority..", "info", null, () => setDisclaimerShown(true), "I Understand");
  };
  if (!disclaimerShown) {
    openDisclaimerModal();
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Builtup Area:"), " (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price:"), " (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate3 = feeDetail.mapRate) === null || _feeDetail$mapRate3 === void 0 ? void 0 : _feeDetail$mapRate3.unitPrice)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:"), " (\u20B9)"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate4 = feeDetail.mapRate) === null || _feeDetail$mapRate4 === void 0 ? void 0 : _feeDetail$mapRate4.price))))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "formHeaderContainer",
    style: {
      marginTop: "20px",
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgb(14, 55, 79)",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%",
      padding: "4px"
    }
  }, "Select"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "30%",
      padding: "4px"
    }
  }, "Payment Heads"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Built Up Area (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Area by LTP", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Rate (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)))), /*#__PURE__*/React__default.createElement("tbody", null, paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: `formPaymentHeads[${index}].checked`,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "4px 4px 4px 8px"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    placeholder: "Payment head",
    name: `formPaymentHeads[${index}].label`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the payment head"
      }
    },
    defaultValue: (item === null || item === void 0 ? void 0 : item.label) || "",
    disabled: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `formPaymentHeads[${index}].plotBuildUpArea`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    width: "12vw"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `formPaymentHeads[${index}].updatedAreaJE`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    defaultValue: item !== null && item !== void 0 && item.buildUpArea ? formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea : formData === null || formData === void 0 ? void 0 : formData.plotArea,
    width: "12vw",
    height: "22px",
    className: "paymentHeadInput"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `formPaymentHeads[${index}].rate`,
    hasLabel: false,
    control: control,
    placeholder: "Enter rate",
    type: "textInput",
    width: "12vw",
    defaultValue: item.hasOwnProperty("rate") ? item.rate : calculateRate(formData === null || formData === void 0 ? void 0 : formData.plotArea, item.slabs)
  })))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(14, 55, 79)",
      color: "white",
      borderRadius: "24px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
      marginLeft: "50%",
      marginBottom: "15px"
    },
    onClick: handleCalculate
  }, isLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  }) : "Calculate"), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    sx: {
      minWidth: 650
    },
    "aria-label": "fee table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white"
  }, "Fee Type"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Built Up Area (sqmt.)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Rate (\u20B9)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Amount (\u20B9)"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, taxHead === null || taxHead === void 0 ? void 0 : taxHead.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.plotBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.amount))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 0,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, "Building Permission Fees"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate5 = feeDetail.mapRate) === null || _feeDetail$mapRate5 === void 0 ? void 0 : _feeDetail$mapRate5.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate6 = feeDetail.mapRate) === null || _feeDetail$mapRate6 === void 0 ? void 0 : _feeDetail$mapRate6.price)), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      fontWeight: "bold",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 3,
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2))))))), /*#__PURE__*/React__default.createElement(ChallanDetails, {
    formData: formData,
    taxHead: taxHead,
    totalAmount: totalAmount
  })), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, (formData === null || formData === void 0 ? void 0 : formData.status) !== "MAKE_PAYMENT_SELF" && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    disabled: !enableSave,
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const parsePaymentResponse = response => {
  var _fields$, _fields$2;
  const fields = response.split("|");
  const customer = ((_fields$ = fields[5]) === null || _fields$ === void 0 ? void 0 : _fields$.split("^")) || [];
  const charges = ((_fields$2 = fields[15]) === null || _fields$2 === void 0 ? void 0 : _fields$2.split("^")) || [];
  return {
    transactionId: fields[0] || "-",
    referenceId: fields[1] || "-",
    status: fields[2] || "-",
    direction: fields[3] || "-",
    currency: fields[4] || "-",
    customerName: customer[1] || "-",
    mobile: customer[2] || "-",
    applicationNo: customer[4] || "-",
    transactionUuid: fields[6] || "-",
    amount: fields[7] || "-",
    transactionType: fields[8] || "-",
    bankCode: fields[9] || "-",
    accountNumber: fields[10] || "-",
    transactionDate: fields[11] || "-",
    paymentMode: fields[12] || "-",
    paymentReference: fields[13] || "-",
    merchantId: fields[14] || "-",
    charge1: charges[0] || "0.00",
    charge2: charges[1] || "0.00"
  };
};
const PaymentDialog = ({
  open,
  onClose,
  paymentResponse,
  isLoading
}) => {
  const paymentData = paymentResponse ? parsePaymentResponse(paymentResponse) : null;
  if (!paymentData) return null;
  if (isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "md"
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Payment Details"), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    dividers: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, "Transaction Details"), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      mt: 1
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Transaction ID"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.transactionId)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Reference ID"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.referenceId)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Transaction UUID"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.transactionUuid)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Transaction Type"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.transactionType)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Status"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Chip, {
    label: paymentData === null || paymentData === void 0 ? void 0 : paymentData.status,
    color: (paymentData === null || paymentData === void 0 ? void 0 : paymentData.status) === "SUCCESS" ? "success" : "default",
    size: "small"
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Direction"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.direction)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, "Customer Details"), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      mt: 1
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Name"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.customerName)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Mobile"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.mobile)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Application Number"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.applicationNo)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, "Payment Details"), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      mt: 1
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Amount"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, paymentData === null || paymentData === void 0 ? void 0 : paymentData.currency, " ", paymentData === null || paymentData === void 0 ? void 0 : paymentData.amount)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Payment Mode"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.paymentMode)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Payment Reference"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.paymentReference)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Transaction Date"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.transactionDate)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, "Bank Details"), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      mt: 1
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Bank"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.bankCode)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Account Number"), /*#__PURE__*/React__default.createElement(Typography, null, paymentData === null || paymentData === void 0 ? void 0 : paymentData.accountNumber)))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: onClose,
    variant: "contained"
  }, "Close")));
};

const formatStatus = (status = "") => status.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
const NocListSummary = ({
  nocList: _nocList = [],
  nocDocList: _nocDocList = []
}) => {
  console.log("NOC LIST SUMMARY", _nocList, _nocDocList);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const nocDocMap = new Map(_nocDocList.map(item => [item.id, item]));
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    elevation: 0,
    sx: {
      border: "1px solid #E2E8F0",
      borderRadius: "12px",
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 1250,
      "& .MuiTableCell-root": {
        borderBottom: "1px solid #E8ECF2",
        borderRight: "1px solid #EEF1F5",
        padding: "14px",
        verticalAlign: "middle"
      },
      "& .MuiTableCell-root:last-child": {
        borderRight: "none"
      },
      "& .MuiTableHead-root .MuiTableCell-root": {
        backgroundColor: "#F8FAFC",
        color: "#475569",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.3px"
      },
      "& .MuiTableBody-root .MuiTableRow-root:hover": {
        backgroundColor: "#F8FAFF"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "S.No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "NOC Name"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Application No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Request Letter No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Applied On"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Last Updated"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Status"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Uploaded Documents"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, "Approval Letter"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, _nocList.length > 0 ? _nocList.map((noc, index) => {
    var _noc$nocLetterInfo, _noc$auditDetails, _noc$auditDetails2;
    const approvalUrl = noc.nocApprovedLetterUrl;
    const matchedNoc = nocDocMap.get(noc.id);
    const uploadedDocuments = Array.isArray(matchedNoc === null || matchedNoc === void 0 ? void 0 : matchedNoc.documents) ? matchedNoc.documents : [];
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: noc.id || index,
      hover: true
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Typography, {
      fontWeight: 600
    }, noc.nocName || ((_noc$nocLetterInfo = noc.nocLetterInfo) === null || _noc$nocLetterInfo === void 0 ? void 0 : _noc$nocLetterInfo.nocName) || "-"), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      color: "text.secondary"
    }, noc.nocType || "-")), /*#__PURE__*/React__default.createElement(TableCell$1, null, noc.applicationNo || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, noc.nocRequestLetterNumber || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (_noc$auditDetails = noc.auditDetails) !== null && _noc$auditDetails !== void 0 && _noc$auditDetails.createdTime ? dayjs(noc.auditDetails.createdTime).format("DD MMM YYYY") : "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (_noc$auditDetails2 = noc.auditDetails) !== null && _noc$auditDetails2 !== void 0 && _noc$auditDetails2.lastModifiedTime ? dayjs(noc.auditDetails.lastModifiedTime).format("DD MMM YYYY") : "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Chip, {
      size: "small",
      label: formatStatus(noc.applicationStatus || "UNKNOWN"),
      variant: "outlined"
    })), /*#__PURE__*/React__default.createElement(TableCell$1, null, uploadedDocuments.length > 0 ? /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        minWidth: 180
      }
    }, uploadedDocuments.map((doc, docIndex) => {
      var _doc$additionalDetail;
      const documentName = ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.name) || doc.documentType || `Document ${docIndex + 1}`;
      return /*#__PURE__*/React__default.createElement(Box, {
        key: doc.fileStoreId || `${noc.id}-${docIndex}`,
        sx: {
          display: "flex",
          alignItems: "center",
          gap: 1
        }
      }, /*#__PURE__*/React__default.createElement(Tooltip, {
        title: documentName
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "body2",
        sx: {
          flex: 1,
          minWidth: 0,
          overflowWrap: "anywhere"
        }
      }, documentName)), doc.fileStoreId ? /*#__PURE__*/React__default.createElement(Tooltip, {
        title: "View Document"
      }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        color: "primary",
        disabled: isPreviewLoading,
        onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
      }, /*#__PURE__*/React__default.createElement(VisibilityOutlinedIcon, {
        fontSize: "small"
      })))) : /*#__PURE__*/React__default.createElement(Typography, {
        variant: "caption",
        color: "text.disabled"
      }, "No file"));
    })) : /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      color: "text.secondary"
    }, "No documents uploaded")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, approvalUrl ? /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "View Approval Letter"
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      size: "small",
      onClick: () => window.open(approvalUrl, "_blank", "noopener,noreferrer")
    }, /*#__PURE__*/React__default.createElement(VisibilityOutlinedIcon, null))) : /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      color: "text.disabled"
    }, "\u2014")));
  }) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 9,
    align: "center"
  }, "No NOC records found")))));
};

const StyledTabPanel$1 = styled$2(TabPanel)(() => ({
  "& .MuiBox-root": {
    padding: 0
  }
}));
const PRIORITY_TAX_HEAD_CODES = ["BPA_MAP_COMPOUNDING_FEE", "BPA_MAP_SUBMISSION_FEE_2"];
const getPrioritizedEstimates = (estimates = []) => {
  const getRank = item => {
    const index = PRIORITY_TAX_HEAD_CODES.indexOf(item === null || item === void 0 ? void 0 : item.taxHeadCode);
    return index === -1 ? PRIORITY_TAX_HEAD_CODES.length : index;
  };
  return [...estimates].sort((a, b) => getRank(a) - getRank(b));
};
const INSTALLMENT_MONTH_OPTIONS = [3, 6, 9, 12, 15, 18, 21, 24];
const INSTALLMENT_FEE_LABELS = {
  development_fee: "Development Fee",
  purchasable_far_charges: "Purchasable FAR",
  special_amenities_charges: "Special Amenities",
  compounding_charges: "Compounding",
  city_development_charges: "City Development"
};
const getInitialAmountError = (value, maxAmount) => {
  if (value === "" || value === null || value === undefined || Number(value) <= 0) {
    return "Initial amount is required";
  }
  if (Number(value) > maxAmount) {
    return `Cannot be greater than ₹${maxAmount}`;
  }
  return null;
};
const getPendingInstallments = (feeInstallments = []) => {
  const byFee = {};
  feeInstallments.forEach(item => {
    if (!(item !== null && item !== void 0 && item.column1) || item.column1 === "initial_payment") return;
    if (((item === null || item === void 0 ? void 0 : item.status) || "").toUpperCase() !== "PENDING") return;
    const current = byFee[item.column1];
    if (!current || Number(item.installmentNumber) < Number(current.installmentNumber)) {
      byFee[item.column1] = item;
    }
  });
  return Object.values(byFee);
};
const Form12Summary = ({
  formData,
  businessService,
  action,
  edcrDetails,
  setOnAddComments,
  onActionSelect,
  showTimeLine: _showTimeLine = true,
  applicationData,
  collectionBillDetails,
  workflowDetails,
  timelineStatusPrefix,
  isDataLoading,
  statusAttribute: _statusAttribute = "status",
  submitAction,
  actionData,
  moduleCode
}) => {
  var _feeInstallments$find, _formData$nocList, _Digit$UserService$ge, _Digit$UserService$ge2, _user$info, _user$info$roles, _workflowDetails$data, _workflowDetails$data2, _formData$PrevStateDo, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _pdfDetails$pdfFiles, _formData$paymentDeta, _formData$paymentDeta2, _formData$paymentDeta3, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _user$info3, _user$info4, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data15, _workflowDetails$data16, _workflowDetails$data17, _workflowDetails$data18, _workflowDetails$data19, _workflowDetails$data20, _workflowDetails$data21, _workflowDetails$data22, _workflowDetails$data23, _workflowDetails$data24, _workflowDetails$data25, _workflowDetails$data26, _user$info5, _workflowDetails$data27, _workflowDetails$data28, _workflowDetails$data29, _user$info6, _workflowDetails$data30, _workflowDetails$data31, _formData$nocDetails, _user$info7;
  const [currentTab, setCurrentTab] = useState("0");
  const [file, setFile] = useState(null);
  const {
    id
  } = useParams();
  const history = useHistory();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState("");
  const [modalLoader, setModalLoader] = useState(false);
  const [mainPaymentData, setMainPaymentData] = useState(null);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [letterLoader, setLetterLoader] = useState(false);
  const [payingFee, setPayingFee] = useState(null);
  const [selectedPaymentHead, setSelectedPaymentHead] = useState(null);
  const feeInstallments = (formData === null || formData === void 0 ? void 0 : formData.feeInstallment) || [];
  const isInstallmentPaymentMode = ((formData === null || formData === void 0 ? void 0 : formData.isInstallment) === true || (formData === null || formData === void 0 ? void 0 : formData.isInstallment) === "Yes") && feeInstallments.length > 0 && (feeInstallments === null || feeInstallments === void 0 ? void 0 : (_feeInstallments$find = feeInstallments.find(item => (item === null || item === void 0 ? void 0 : item.column1) === "initial_payment")) === null || _feeInstallments$find === void 0 ? void 0 : _feeInstallments$find.status) === "PAID";
  const pendingInstallments = isInstallmentPaymentMode ? getPendingInstallments(feeInstallments) : [];
  console.log("FORMDATAFOUND IN THE SUMMARY", formData, formData === null || formData === void 0 ? void 0 : formData.isInstallment, feeInstallments);
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isSelf = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP";
  const hideChatboard = isSelfCert || isSelf;
  const showNOCList = (formData === null || formData === void 0 ? void 0 : formData.nocList) && (formData === null || formData === void 0 ? void 0 : (_formData$nocList = formData.nocList) === null || _formData$nocList === void 0 ? void 0 : _formData$nocList.length) > 0;
  const tablist = [{
    label: "Application Info",
    color: "red"
  }, {
    label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS",
    color: "green"
  }, showNOCList && {
    label: "Noc Status",
    color: "grey"
  }, !hideChatboard && {
    label: "ChatBoard",
    color: "purple"
  }, isSelfCert && (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_SELF" && {
    label: "Fee Details",
    color: "orange"
  }].filter(Boolean);
  const chatboardIndex = tablist.findIndex(tab => tab.label === "ChatBoard");
  const feeDetailsIndex = tablist.findIndex(tab => tab.label === "Fee Details");
  const [currentAction, setCurrentAction] = useState(null);
  const [isInstallment, setIsInstallment] = useState("No");
  const [isInstallmentDisabled, setIsInstallmentDisabled] = useState(false);
  const [isInstallmentDc, setIsInstallmentDc] = useState(false);
  const [isInstallmentPf, setIsInstallmentPf] = useState(false);
  const [isSpecialAminitiesInstallment, setIsSpecialAminitiesInstallment] = useState(false);
  const [specialAminitiesInitialAmount, setSpecialAminitiesInitialAmount] = useState("");
  const [isCityDevelopmentInstallment, setIsCityDevelopmentInstallment] = useState(false);
  const [cityDevelopmentInitialAmount, setCityDevelopmentInitialAmount] = useState("");
  const [isCompundingInstallment, setIsCompundingInstallment] = useState(false);
  const [compoundingInitialAmount, setCompoundingInitialAmount] = useState("");
  const [noOfCompInstallment, setNoOfCompInstallment] = useState(12);
  const [structureCertificateError, setStructureCertificateError] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [roleFormCode, setRoleFormCode] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const userToken = localStorage.getItem("token");
  const closeToast = () => setShowToast(null);
  const Modal = useModal();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = stateId;
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const userInfo = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.info) || {};
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let user = Digit.UserService.getUser();
  const tenant = Digit.ULBService.getCurrentTenantId();
  const userRoles = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.map(e => e.code);
  const token = user === null || user === void 0 ? void 0 : user.access_token;
  const getUserInfo = async () => {
    var _user$info2;
    const uuid = user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, {
        uuid: [uuid]
      }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };
  const isDeptCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && (formData === null || formData === void 0 ? void 0 : formData.planOn) !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isLTP = userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role));
  const isOwner = userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => role === "OWNER");
  const estimates = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.taxHeadEstimates) || (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) || [];
  const otherEstimates = estimates.filter(item => (item === null || item === void 0 ? void 0 : item.taxHeadCode) !== "BPA_MAP_SUBMISSION_FEE_1");
  const hasFeeType = typeKey => {
    const key = typeKey.toLowerCase();
    return otherEstimates.some(estimate => ((estimate === null || estimate === void 0 ? void 0 : estimate.paymentHeads) || []).some(head => ((head === null || head === void 0 ? void 0 : head.feeType) || "").toLowerCase().includes(key)));
  };
  const hasDevFee = hasFeeType("development_fee") || hasFeeType("development");
  const hasPurchasableFar = hasFeeType("purchasable_far_charges") || hasFeeType("purchasable_far");
  const hasSpecialAmenities = hasFeeType("special_amenities_charges") || hasFeeType("special_amenities");
  const hasCompounding = hasFeeType("compounding_charges") || hasFeeType("compounding");
  const hasCityDevelopment = hasFeeType("city_development_charges") || hasFeeType("city_development");
  const getFeeAmount = typeKey => {
    const key = typeKey.toLowerCase();
    return otherEstimates.reduce((sum, estimate) => sum + ((estimate === null || estimate === void 0 ? void 0 : estimate.paymentHeads) || []).filter(head => ((head === null || head === void 0 ? void 0 : head.feeType) || "").toLowerCase().includes(key)).reduce((s, head) => s + (Number(head === null || head === void 0 ? void 0 : head.amount) || 0), 0), 0);
  };
  const specialAmenitiesAmount = getFeeAmount("special_amenities");
  const cityDevelopmentAmount = getFeeAmount("city_development");
  const compoundingAmount = getFeeAmount("compounding");
  const developmentAmount = getFeeAmount("development");
  const purchasableFarAmount = getFeeAmount("purchasable_far");
  const specialAmenitiesError = isInstallment === "Yes" && hasSpecialAmenities && isSpecialAminitiesInstallment ? getInitialAmountError(specialAminitiesInitialAmount, specialAmenitiesAmount) : null;
  const cityDevelopmentError = isInstallment === "Yes" && hasCityDevelopment && isCityDevelopmentInstallment ? getInitialAmountError(cityDevelopmentInitialAmount, cityDevelopmentAmount) : null;
  const compoundingError = isInstallment === "Yes" && hasCompounding && isCompundingInstallment ? getInitialAmountError(compoundingInitialAmount, compoundingAmount) : null;
  const hasInstallmentErrors = Boolean(specialAmenitiesError || cityDevelopmentError || compoundingError);
  useEffect(() => {
    if ((formData === null || formData === void 0 ? void 0 : formData.isInstallment) === "Yes" || (formData === null || formData === void 0 ? void 0 : formData.isInstallment) === true) {
      setIsInstallmentDisabled(true);
      setIsInstallment("Yes");
      setIsInstallmentDc(Boolean(formData === null || formData === void 0 ? void 0 : formData.isInstallmentDc));
      setIsInstallmentPf(Boolean(formData === null || formData === void 0 ? void 0 : formData.isInstallmentPf));
      setIsSpecialAminitiesInstallment(Boolean(formData === null || formData === void 0 ? void 0 : formData.isSpecialAminitiesInstallment));
      setSpecialAminitiesInitialAmount((formData === null || formData === void 0 ? void 0 : formData.specialAminitiesInitialAmount) || "");
      setIsCityDevelopmentInstallment(Boolean(formData === null || formData === void 0 ? void 0 : formData.isCityDevelopmentInstallment));
      setCityDevelopmentInitialAmount((formData === null || formData === void 0 ? void 0 : formData.cityDevelopmentInitialAmount) || "");
      setIsCompundingInstallment(Boolean(formData === null || formData === void 0 ? void 0 : formData.isCompundingInstallment));
      setCompoundingInitialAmount((formData === null || formData === void 0 ? void 0 : formData.compoundingInitialAmount) || "");
      setNoOfCompInstallment((formData === null || formData === void 0 ? void 0 : formData.noOfCompInstallment) || 12);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.isInstallment]);
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.filter(e => {
    if (isLTP && (e.action === "FORWARD_TO_LTP" || e.action === "REJECTED")) {
      return false;
    } else if (isSelfCert && isOwner && (formData === null || formData === void 0 ? void 0 : formData.status) === "UPLOAD_DOC") {
      return false;
    } else if (isLTP && (e.action === "FORWARD_TO_OWNER" || e.action === "UPLOAD_DOC")) {
      return false;
    } else if (isDeptCert && !isSelf && e.action === "MAKE_PAYMENT_SELF") {
      return false;
    } else if (isSelfCert && !isLTP && e.action === "MAKE_PAYMENT_SELF") {
      return true;
    } else if (isSelf && e.action === "MAKE_PAYMENT_SELF") {
      return true;
    } else if (isSelf && (e.action === "MAKE_PAYMENT" || e.action === "UPLOAD_DOC" || e.action === "FORWARD_TO_DEPARTMENT")) {
      return false;
    } else if (isSelfCert && isLTP && (e.action === "MAKE_PAYMENT" || e.action === "FORWARD_TO_DEPARTMENT")) {
      return false;
    } else if (e.action === "PAYMENT_DONE" || e.action === "PAYMENT_CANCEL" || e.action === "PAYMENT_DONE_CTP" || e.action === "PAYMENT_DONE_EE_TP" || e.action === "PAYMENT_DONE_VC" || e.action === "PAYMENT_DONE_ATP" || e.action === "PAYMENT_DONE_SECT") {
      return false;
    }
    return true;
  });
  const calculateInstallment = async payload => {
    try {
      const response = await axios$1.post(`${Urls$1.obps.installmentCalculate}`, payload);
      return response.data;
    } catch (error) {
      console.error("calculateInstallment error:", error);
      throw error;
    }
  };
  const routetoPay = async () => {
    var _applicationData$taxH;
    if (hasInstallmentErrors) {
      setStructureCertificateError(specialAmenitiesError ? `Special Amenities: ${specialAmenitiesError}` : cityDevelopmentError ? `City Development: ${cityDevelopmentError}` : `Compounding: ${compoundingError}`);
      return;
    }
    setStructureCertificateError(null);
    const additionalDetails = {
      ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
      fieldinspection_pending: getfeildInspection(applicationData)
    };
    const workflow = {
      action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
      comment: developerRemarks,
      comments: developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile ? [{
        documentType: currentAction + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const installmentPayloadObj = {
      isInstallment: isInstallment === "Yes",
      isInstallmentDc: isInstallment === "Yes" ? isInstallmentDc : false,
      isInstallmentPf: isInstallment === "Yes" ? isInstallmentPf : false,
      isSpecialAminitiesInstallment: isInstallment === "Yes" ? isSpecialAminitiesInstallment : false,
      specialAminitiesInitialAmount: isInstallment === "Yes" && isSpecialAminitiesInstallment ? Number(specialAminitiesInitialAmount) || 0 : 0,
      isCityDevelopmentInstallment: isInstallment === "Yes" ? isCityDevelopmentInstallment : false,
      cityDevelopmentInitialAmount: isInstallment === "Yes" && isCityDevelopmentInstallment ? Number(cityDevelopmentInitialAmount) || 0 : 0,
      isCompundingInstallment: isInstallment === "Yes" ? isCompundingInstallment : false,
      compoundingInitialAmount: isInstallment === "Yes" && isCompundingInstallment ? Number(compoundingInitialAmount) || 0 : 0,
      noOfCompInstallment: isInstallment === "Yes" && isCompundingInstallment ? Number(noOfCompInstallment) || 12 : 0
    };
    const appData = {
      ...applicationData,
      documents: formData === null || formData === void 0 ? void 0 : formData.documents,
      additionalDetails,
      workflow,
      action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
      comment: developerRemarks,
      assignee: null,
      wfDocuments: uploadedFile ? [{
        documentType: currentAction + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null,
      ...installmentPayloadObj
    };
    let validBusinessService = null;
    if (applicationData !== null && applicationData !== void 0 && applicationData.taxHeadEstimates && (applicationData === null || applicationData === void 0 ? void 0 : applicationData.taxHeadEstimates.length) > 0) {
      for (const item of getPrioritizedEstimates(applicationData.taxHeadEstimates)) {
        const businessService = item.calculationBusinesserviceId;
        const consumerCode = applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo;
        try {
          const newInstallmentData = {
            CalulationCriteria: [{
              BPA: {
                ...appData
              },
              tenantId: tenantId,
              feeType: "ApplicationFee",
              ...installmentPayloadObj
            }],
            RequestInfo: {
              apiId: "Rainmaker",
              authToken: token,
              userInfo: userInfo,
              msgId: "1788151908449|en_IN"
            }
          };
          if (!(formData !== null && formData !== void 0 && formData.isInstallment) && isInstallment === "Yes") {
            await calculateInstallment(newInstallmentData);
          }
          const fetchedBill = await Digit.PaymentService.fetchBill(tenantId, {
            consumerCode,
            businessService
          });
          if (fetchedBill && fetchedBill.Bill && fetchedBill.Bill.length > 0) {
            validBusinessService = businessService;
            break;
          }
        } catch (error) {
          console.log("Error fetching bill for businessService:", businessService, error);
        }
      }
    }
    await submitAction({
      BPA: {
        ...appData
      }
    });
    if ((applicationData === null || applicationData === void 0 ? void 0 : applicationData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
    } else if (validBusinessService) {
      history.push(`/digit-ui/citizen/payment/collect/${validBusinessService}/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
    } else if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$taxH = applicationData.taxHeadEstimates) === null || _applicationData$taxH === void 0 ? void 0 : _applicationData$taxH.length) > 1) {
      var _applicationData$taxH2, _applicationData$taxH3;
      history.push(`/digit-ui/citizen/payment/collect/${`${applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$taxH2 = applicationData.taxHeadEstimates) === null || _applicationData$taxH2 === void 0 ? void 0 : (_applicationData$taxH3 = _applicationData$taxH2[1]) === null || _applicationData$taxH3 === void 0 ? void 0 : _applicationData$taxH3.calculationBusinesserviceId}`}/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
    } else {
      var _applicationData$taxH4, _applicationData$taxH5;
      history.push(`/digit-ui/citizen/payment/collect/${`${applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$taxH4 = applicationData.taxHeadEstimates) === null || _applicationData$taxH4 === void 0 ? void 0 : (_applicationData$taxH5 = _applicationData$taxH4[0]) === null || _applicationData$taxH5 === void 0 ? void 0 : _applicationData$taxH5.calculationBusinesserviceId}`}/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
    }
  };
  const routeToPayInstallment = async feeType => {
    if (!feeType || payingFee) return;
    setPayingFee(feeType);
    setStructureCertificateError(null);
    try {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData)
      };
      const workflow = {
        action: "NOWORKFLOW",
        comment: "",
        comments: "",
        assignee: null,
        assignes: null,
        varificationDocuments: null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        action: "NOWORKFLOW",
        comment: "",
        assignee: null,
        wfDocuments: null
      };
      const consumerCode = applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo;
      let validBusinessService = null;
      for (const item of getPrioritizedEstimates((applicationData === null || applicationData === void 0 ? void 0 : applicationData.taxHeadEstimates) || [])) {
        const businessService = item.calculationBusinesserviceId;
        try {
          var _fetchedBill$Bill;
          const fetchedBill = await Digit.PaymentService.fetchBill(tenantId, {
            consumerCode,
            businessService,
            feeType
          });
          if ((fetchedBill === null || fetchedBill === void 0 ? void 0 : (_fetchedBill$Bill = fetchedBill.Bill) === null || _fetchedBill$Bill === void 0 ? void 0 : _fetchedBill$Bill.length) > 0) {
            validBusinessService = businessService;
            break;
          }
        } catch (error) {
          console.log("Error fetching bill for businessService:", businessService, error);
        }
      }
      if (!validBusinessService) {
        setStructureCertificateError("Unable to generate bill for the selected installment");
        return;
      }
      await submitAction({
        BPA: {
          ...appData
        }
      });
      history.push(`/digit-ui/citizen/payment/collect/${validBusinessService}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}/${tenantId}?tenantId=${tenantId}&feeType=${feeType}`);
    } catch (error) {
      console.error("routeToPayInstallment error:", error);
      setStructureCertificateError("Something went wrong while processing the installment");
    } finally {
      setPayingFee(null);
    }
  };
  const handlePayment = async (nextTab, payload) => {
    try {
      updateApiCall.mutate({
        BPA: payload
      }, {
        onSuccess: res => {
          Modal("Fee Details Updated Successfully", `Your Application ${formData === null || formData === void 0 ? void 0 : formData.applicationNo} fee details has been updated successfully`, "success", null, () => window.location.reload());
        },
        onError: () => {
          Modal("Update Error", "Something went wrong!!", "error");
        }
      });
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }
  };
  const onRadioActionSelect = value => {
    setCurrentAction(value);
  };
  const onInstallmentSelect = value => {
    setIsInstallment(value);
    if (value === "No") {
      setIsInstallmentDc(false);
      setIsInstallmentPf(false);
      setIsSpecialAminitiesInstallment(false);
      setIsCityDevelopmentInstallment(false);
      setIsCompundingInstallment(false);
    }
  };
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
  });
  let pdfDetails = {};
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const billFeeType = isInstallmentPaymentMode ? selectedPaymentHead : undefined;
  console.log("billFeeType", billFeeType, isInstallmentPaymentMode, pendingInstallments, selectedPaymentHead);
  const fetchBillParams = {
    consumerCode,
    ...(billFeeType ? {
      feeType: billFeeType
    } : {})
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$paymentDeta = formData.paymentDetails) === null || _formData$paymentDeta === void 0 ? void 0 : (_formData$paymentDeta2 = _formData$paymentDeta.bill) === null || _formData$paymentDeta2 === void 0 ? void 0 : (_formData$paymentDeta3 = _formData$paymentDeta2.billDetails[0]) === null || _formData$paymentDeta3 === void 0 ? void 0 : _formData$paymentDeta3.amount) || (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount);
  const handleModal = () => {
    setOpenApplicantPopup(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/citizen/profile`
      });
    }, 2000);
  };
  const checkPaymentStatus = async id => {
    try {
      const requestInfo = {
        RequestInfo: {
          apiId: "Rainmaker",
          ver: "v1",
          ts: 0,
          action: "_search",
          did: "",
          key: "",
          msgId: "090909",
          requesterId: "",
          authToken: token,
          userInfo: userInfo
        }
      };
      const response = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo);
      return response === null || response === void 0 ? void 0 : response.data;
    } catch (error) {
      console.log("Transaction API Error:", error);
      throw error;
    }
  };
  const checkMainPaymentStatus = async id => {
    try {
      var _paymentData$Transact;
      setModalLoader(true);
      const paymentData = await checkPaymentStatus(id);
      const transactionData = paymentData === null || paymentData === void 0 ? void 0 : (_paymentData$Transact = paymentData.Transaction) === null || _paymentData$Transact === void 0 ? void 0 : _paymentData$Transact[0];
      if (!transactionData) {
        throw new Error("Transaction data not found");
      }
      const response = await axios$1.post(Urls$1.obps.checkPaymentStatus, {
        billId: transactionData.billId,
        txnAmount: Number(transactionData.txnAmount)
      });
      setMainPaymentData(response === null || response === void 0 ? void 0 : response.data);
      setShowPaymentDialog(true);
      return response.data;
    } catch (error) {
      setShowToast({
        error: true,
        message: "Payment Status Error !"
      });
      setShowPaymentDialog(true);
      setTimeout(() => setShowToast(null), 5000);
      throw error;
    } finally {
      setModalLoader(false);
    }
  };
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map(doc => {
      refinedDocs.push({
        documentType: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        fileStoreId: doc.fileStoreId,
        fileStore: doc.fileStoreId,
        fileName: "",
        dropDownValues: {
          value: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        remarks: data[`Remarks_${i}`],
        question: data === null || data === void 0 ? void 0 : data.questionList[i].question,
        value: data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai2, _data$additionalDetai3;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : (_data$additionalDetai3 = _data$additionalDetai2.fieldinspection_pending) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.length) > 0) {
      var _data$additionalDetai4;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map(ob => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    return [...inspectionOb];
  };
  async function submit(data) {
    if (developerRemarks) {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData)
      };
      const workflow = {
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      await submitAction({
        BPA: appData
      });
      if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FIT_FOR_APPROVAL") {
        Modal("Application Approved", `Application Approved Successfully`, "success");
      } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REJECTED") {
        Modal("Application Rejected", `Application Rejected, Sent to LTP!`, "success");
      } else if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD_TO_LTP") {
        Modal("Application Forwarded", `Application Forwarded Successfully to LTP!`, "success");
      }
    } else {
      setStructureCertificateError("Please Enter your Remarks ---------");
    }
  }
  async function selfSubmit(data) {
    if (developerRemarks) {
      const additionalDetails = {
        ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData)
      };
      const signdoc = {
        documentType: "signature",
        fileStoreId: uploadedFile,
        isMandatory: true,
        additionalDetails: {
          fileName: file === null || file === void 0 ? void 0 : file.name,
          title: "Signature"
        }
      };
      if (!uploadedFile) {
        setStructureCertificateError("Please upload the signature");
        return null;
      }
      const workflow = {
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...applicationData,
        documents: [...(formData === null || formData === void 0 ? void 0 : formData.documents), signdoc],
        additionalDetails,
        workflow,
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      await submitAction({
        BPA: appData
      });
      if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED") {
        Modal("Application Approved", `Approval Letter Generated Successfully`, "success");
      }
    } else {
      setStructureCertificateError("Please Enter your Remarks and upload signature ---------");
    }
  }
  useEffect(() => {
    getUserInfo();
  }, [user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : _user$info3.uuid]);
  if (isDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, letterLoader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, tablist.map(({
    label,
    color
  }, index) => /*#__PURE__*/React__default.createElement(Tab, {
    key: index,
    label: `${t(label)}`,
    value: `${index}`,
    sx: {
      textTransform: "none",
      p: "0 1rem",
      color
    }
  }))), /*#__PURE__*/React__default.createElement(StyledTabPanel$1, {
    value: currentTab,
    index: "0"
  }, (user === null || user === void 0 ? void 0 : (_user$info4 = user.info) === null || _user$info4 === void 0 ? void 0 : _user$info4.type) === "EMPLOYEE" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EmployeeComponent$1, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Accordion$1, {
    style: {
      marginLeft: "15px",
      marginTop: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    expandIcon: /*#__PURE__*/React__default.createElement(ArrowDropDownIcon, null),
    "aria-controls": "panel2-content",
    id: "panel2-header",
    style: {
      backgroundColor: "aliceblue",
      borderRadius: "10px",
      padding: "-1px",
      border: "2px solid #3d68a0"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "div"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Avatar$4, {
    sx: {
      bgcolor: green[500],
      width: 30,
      height: 30
    }
  }, /*#__PURE__*/React__default.createElement(PersonIcon, null))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "15px"
    }
  }, " ", workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigner) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.name), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "15px"
    }
  }, "(", workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.timeline) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8[0]) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.assigner) === null || _workflowDetails$data10 === void 0 ? void 0 : (_workflowDetails$data11 = _workflowDetails$data10.roles) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.find(ele => (ele === null || ele === void 0 ? void 0 : ele.code) !== "EMPLOYEE")) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.name, ")")))), /*#__PURE__*/React__default.createElement(AccordionDetails$1, {
    style: {
      margin: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "div",
    style: {
      border: "1px solid lightslategrey",
      borderRadius: "7px",
      padding: "1%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.timeline) === null || _workflowDetails$data14 === void 0 ? void 0 : (_workflowDetails$data15 = _workflowDetails$data14[0]) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.assigner) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.name, " (", workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data17 = workflowDetails.data) === null || _workflowDetails$data17 === void 0 ? void 0 : (_workflowDetails$data18 = _workflowDetails$data17.timeline) === null || _workflowDetails$data18 === void 0 ? void 0 : (_workflowDetails$data19 = _workflowDetails$data18[0]) === null || _workflowDetails$data19 === void 0 ? void 0 : (_workflowDetails$data20 = _workflowDetails$data19.assigner) === null || _workflowDetails$data20 === void 0 ? void 0 : (_workflowDetails$data21 = _workflowDetails$data20.roles) === null || _workflowDetails$data21 === void 0 ? void 0 : (_workflowDetails$data22 = _workflowDetails$data21.find(ele => (ele === null || ele === void 0 ? void 0 : ele.code) !== "EMPLOYEE")) === null || _workflowDetails$data22 === void 0 ? void 0 : _workflowDetails$data22.name, ")"), /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data23 = workflowDetails.data) === null || _workflowDetails$data23 === void 0 ? void 0 : (_workflowDetails$data24 = _workflowDetails$data23.timeline) === null || _workflowDetails$data24 === void 0 ? void 0 : (_workflowDetails$data25 = _workflowDetails$data24[0]) === null || _workflowDetails$data25 === void 0 ? void 0 : (_workflowDetails$data26 = _workflowDetails$data25.wfComment) === null || _workflowDetails$data26 === void 0 ? void 0 : _workflowDetails$data26[0]
  })))))), (user === null || user === void 0 ? void 0 : (_user$info5 = user.info) === null || _user$info5 === void 0 ? void 0 : _user$info5.type) === "CITIZEN" && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data27 = workflowDetails.data) === null || _workflowDetails$data27 === void 0 ? void 0 : (_workflowDetails$data28 = _workflowDetails$data27.nextActions) === null || _workflowDetails$data28 === void 0 ? void 0 : (_workflowDetails$data29 = _workflowDetails$data28[0]) === null || _workflowDetails$data29 === void 0 ? void 0 : _workflowDetails$data29.action) != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Architect$1, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    actions: actions,
    isSelf: isSelf
  }), isInstallmentPaymentMode && pendingInstallments.length > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      margin: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "subtitle1",
    fontWeight: 600,
    color: "primary",
    sx: {
      mb: 1
    }
  }, "Pending Installments"), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    variant: "outlined",
    sx: {
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbfd"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("b", null, "Fee Type")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement("b", null, "Installment No.")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("b", null, "Due Date")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement("b", null, "Amount (\u20B9)")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement("b", null, "Action")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, pendingInstallments.map(item => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: item.column1
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, INSTALLMENT_FEE_LABELS[item.column1] || item.column1), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, item.installmentNumber), /*#__PURE__*/React__default.createElement(TableCell$1, null, item.dueDate), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, item.dueAmount), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    size: "small",
    onClick: () => {
      setSelectedPaymentHead(item.column1);
      routeToPayInstallment(item.column1);
    },
    disabled: Boolean(payingFee)
  }, payingFee === item.column1 ? "Please wait..." : "Pay Installment")))))))), !isInstallmentPaymentMode && (formData === null || formData === void 0 ? void 0 : formData.status) !== "APPROVED" && ((formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_APPLICATION_FEE_FIRST" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_BY_ARCHITECT" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_SELF" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_APPLICATION_FEE" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT" || (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_SELF_REGENERATE" || (formData === null || formData === void 0 ? void 0 : formData.status) === "FORWARD_TO_APPLICANT_PAYMENT") && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Action ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: false,
    options: actions,
    selectedOption: currentAction,
    optionsKey: "action",
    onSelect: onRadioActionSelect,
    style: {
      display: "flex",
      gap: "3rem",
      margin: 0
    }
  })), ((formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_BY_ARCHITECT" && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 10000 || (formData === null || formData === void 0 ? void 0 : formData.isInstallment)) && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "2rem",
      gridColumn: "span 12"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      minWidth: "150px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Pay By Installment")), /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isInstallment,
    onChange: e => onInstallmentSelect(e.target.value),
    sx: {
      gap: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  })))), isInstallment === "Yes" && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 12",
    sx: {
      backgroundColor: "#f9fbfd",
      border: "1px solid #c9d8ea",
      borderRadius: "8px",
      padding: "9px 14px !important",
      display: "flex",
      flexDirection: "column",
      gap: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "subtitle1",
    fontWeight: 600,
    color: "primary"
  }, formData !== null && formData !== void 0 && formData.isInstallment ? "Choose Installment to pay." : "Installment Breakdown"), hasDevFee && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    alignItems: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Fee Installment:"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#555"
    }
  }, "Total Amount: \u20B9", developmentAmount)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 8"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isInstallmentDc ? "Yes" : "No",
    onChange: e => setIsInstallmentDc(e.target.value === "Yes")
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  }))))), hasPurchasableFar && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    alignItems: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement("b", null, "Purchasable FAR Installment:"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#555"
    }
  }, "Total Amount: \u20B9", purchasableFarAmount)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 8"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isInstallmentPf ? "Yes" : "No",
    onChange: e => setIsInstallmentPf(e.target.value === "Yes")
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  }))))), hasSpecialAmenities && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    alignItems: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Amenities Installment:"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#555"
    }
  }, "Total Amount: \u20B9", specialAmenitiesAmount)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isSpecialAminitiesInstallment ? "Yes" : "No",
    onChange: e => setIsSpecialAminitiesInstallment(e.target.value === "Yes")
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  })))), isSpecialAminitiesInstallment && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    size: "small",
    type: "number",
    label: "Initial Amount",
    value: specialAminitiesInitialAmount,
    disabled: isInstallmentDisabled,
    onChange: e => setSpecialAminitiesInitialAmount(e.target.value),
    error: Boolean(specialAmenitiesError),
    helperText: specialAmenitiesError,
    inputProps: {
      min: 0,
      max: specialAmenitiesAmount
    },
    fullWidth: true
  }))), hasCityDevelopment && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    alignItems: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement("b", null, "City Development Installment:"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#555"
    }
  }, "Total Amount: \u20B9", cityDevelopmentAmount)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isCityDevelopmentInstallment ? "Yes" : "No",
    onChange: e => setIsCityDevelopmentInstallment(e.target.value === "Yes")
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  })))), isCityDevelopmentInstallment && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    size: "small",
    type: "number",
    label: "Initial Amount",
    value: cityDevelopmentInitialAmount,
    disabled: isInstallmentDisabled,
    onChange: e => setCityDevelopmentInitialAmount(e.target.value),
    error: Boolean(cityDevelopmentError),
    helperText: cityDevelopmentError,
    inputProps: {
      min: 0,
      max: cityDevelopmentAmount
    },
    fullWidth: true
  }))), hasCompounding && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    alignItems: "center",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, /*#__PURE__*/React__default.createElement("b", null, "Compounding Installment:"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#555"
    }
  }, "Total Amount: \u20B9", compoundingAmount)), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: isCompundingInstallment ? "Yes" : "No",
    onChange: e => setIsCompundingInstallment(e.target.value === "Yes")
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    disabled: isInstallmentDisabled,
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  })))), isCompundingInstallment && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    size: "small",
    type: "number",
    label: "Initial Amount",
    value: compoundingInitialAmount,
    disabled: isInstallmentDisabled,
    onChange: e => setCompoundingInitialAmount(e.target.value),
    error: Boolean(compoundingError),
    helperText: compoundingError,
    inputProps: {
      min: 0,
      max: compoundingAmount
    },
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    size: "small",
    label: "Months",
    value: noOfCompInstallment,
    disabled: isInstallmentDisabled,
    onChange: e => setNoOfCompInstallment(Number(e.target.value)),
    fullWidth: true
  }, INSTALLMENT_MONTH_OPTIONS.map(m => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: m,
    value: m
  }, m))))))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Check Payment Status "))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Click here",
    type: "button",
    onClick: () => checkMainPaymentStatus(formData === null || formData === void 0 ? void 0 : formData.applicationNo),
    sx: {
      backgroundColor: "#157CB3",
      width: "109px"
    }
  })), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Remark ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }))), ((user === null || user === void 0 ? void 0 : (_user$info6 = user.info) === null || _user$info6 === void 0 ? void 0 : _user$info6.type) != "CITIZEN" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP") && (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" && /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, "Upload Signature"), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "workflow-doc",
    onUpload: selectFile,
    onDelete: () => {
      setUploadedFile(null);
    },
    message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
    accept: "image/*, .png, .jpeg, .jpg",
    iserror: error,
    required: true,
    showHint: true,
    hintText: "Please upload a file, Accepted formats: JPG, PNG, JPEG, "
  }))), currentAction && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FORWARD_TO_LTP" && ["OWNER"].some(role => userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes(role)) && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, "Submit")), ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FIT_FOR_APPROVAL") && isLTP && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, "Submit")), ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "APPROVED" || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "FIT_FOR_APPROVAL") && ["OWNER"].some(role => userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes(role)) && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: selfSubmit
  }, "Submit")), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) === "REJECTED" && ["OWNER"].some(role => userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes(role)) && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: submit
  }, "Submit")))), currentAction && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }), (currentAction.action === "MAKE_PAYMENT" || currentAction.action === "MAKE_PAYMENT_SELF" || (formData === null || formData === void 0 ? void 0 : formData.isInstallment)) && /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px"
    },
    onClick: routetoPay,
    disabled: hasInstallmentErrors
  }, "Make Payment"))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "red"
    }
  }, /*#__PURE__*/React__default.createElement("marquee", null, " ", structureCertificateError))), /*#__PURE__*/React__default.createElement(StyledTabPanel$1, {
    value: currentTab,
    index: "1"
  }, _showTimeLine && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data30 = workflowDetails.data) === null || _workflowDetails$data30 === void 0 ? void 0 : (_workflowDetails$data31 = _workflowDetails$data30.timeline) === null || _workflowDetails$data31 === void 0 ? void 0 : _workflowDetails$data31.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
    remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
    formData: formData
  }))), /*#__PURE__*/React__default.createElement(StyledTabPanel$1, {
    value: currentTab,
    index: "2"
  }, showNOCList && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NocListSummary, {
    nocList: formData === null || formData === void 0 ? void 0 : formData.nocList,
    nocDocList: formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.nocListApplicantDoc
  }))), !isSelfCert && !isSelf && chatboardIndex !== -1 && /*#__PURE__*/React__default.createElement(StyledTabPanel$1, {
    value: currentTab,
    index: `${chatboardIndex}`
  }, /*#__PURE__*/React__default.createElement("div", null, (user === null || user === void 0 ? void 0 : (_user$info7 = user.info) === null || _user$info7 === void 0 ? void 0 : _user$info7.type) === "CITIZEN" && /*#__PURE__*/React__default.createElement(ChatboardCorrespondenceApplicant, {
    formData: formData
  }))), isSelfCert && (formData === null || formData === void 0 ? void 0 : formData.status) === "MAKE_PAYMENT_SELF" && feeDetailsIndex !== -1 && /*#__PURE__*/React__default.createElement(StyledTabPanel$1, {
    value: currentTab,
    index: `${feeDetailsIndex}`
  }, /*#__PURE__*/React__default.createElement(Step3$1, {
    formData: formData,
    handleTabChange: handlePayment
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: openApplicantPopup,
    onClose: handleModal,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "alert-dialog-title",
    style: {
      textAlign: "center",
      fontSize: "35px"
    }
  }, "Thanks You!", " "), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(CheckCircleOutlineIcon, {
    style: {
      color: "green",
      variant: "filled",
      margin: "0px 40% 0",
      fontSize: "100px",
      padding: "2px"
    }
  })), /*#__PURE__*/React__default.createElement("p", {
    style: {
      textAlign: "center",
      fontSize: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "Your Action Has been Completed. Please Note Down "), /*#__PURE__*/React__default.createElement("p", null, "Map Submission "), /*#__PURE__*/React__default.createElement("p", null, "Application no ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      padding: "5px",
      color: "blue"
    }
  }, id), " is Done Successfully.", " ")))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleModal,
    autoFocus: true
  }, "Ok"))), showPaymentDialog && mainPaymentData && /*#__PURE__*/React__default.createElement(PaymentDialog, {
    open: showPaymentDialog,
    onClose: () => setShowPaymentDialog(false),
    paymentResponse: mainPaymentData,
    isLoading: modalLoader
  }));
};

const INSTALLMENT_FEE_ORDER = ["development_fee", "purchasable_far_charges", "special_amenities_charges", "compounding_charges", "city_development_charges"];
const PaymentMemoTable = ({
  formData,
  taxHead,
  totalAmount,
  logoData,
  showDeleteButton: _showDeleteButton = true,
  ...props
}) => {
  var _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$mapSubDetai, _formData$mapSubDetai2, _formData$mapSubDetai3, _formData$additionalD4, _formData$mapSubDetai4, _formData$obpasDetail, _formData$additionalD5, _formData$additionalD6, _formData$mapSubDetai5, _formData$mapSubDetai6, _props$paymentReceipt, _Digit$UserService$ge, _window, _window$localStorage, _Digit$UserService$ge2, _formData$taxHeadEsti, _formData$taxHeadEsti2, _displayedData$filter;
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const [challanData, setChallanData] = useState([]);
  const [taxHeadEstimates, setTaxHeadEstimates] = useState((formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) || []);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const isAlreadySubmitted = typeof (props === null || props === void 0 ? void 0 : props.isAlreadySubmitted) !== "undefined" ? Boolean(props.isAlreadySubmitted) : (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : formData.isAlreadySubmitted) === "Yes" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.isAlreadySubmitted) === "Yes" || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.isAlreadySubmitted) === true || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.isAlreadySubmitted) === "true" || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.isAlreadySubmitted) === "Yes";
  const obpasFileNumber = (props === null || props === void 0 ? void 0 : props.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.obpasFileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$obpasDetail = formData.obpasDetails) === null || _formData$obpasDetail === void 0 ? void 0 : _formData$obpasDetail.obpasFileNumber) || "";
  const dateOfPayment = (props === null || props === void 0 ? void 0 : props.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : formData.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : formData.obpasPaymentDate) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD6 = formData.additionalDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.obpasPaymentDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai5 = formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.dateOfPayment) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai6 = formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.obpasPaymentDate) || "";
  const getPaymentReceiptFileStoreId = data => {
    var _data$paymentReceipt, _data$additionalDetai, _data$additionalDetai2, _data$additionalDetai3, _data$obpasPaymentRec, _data$documents, _data$documents$find, _data$additionalDetai4, _data$additionalDetai5, _data$additionalDetai6, _data$additionalDocs, _data$additionalDocs$;
    if (typeof (data === null || data === void 0 ? void 0 : data.paymentReceipt) === "string") return data.paymentReceipt;
    if (data !== null && data !== void 0 && (_data$paymentReceipt = data.paymentReceipt) !== null && _data$paymentReceipt !== void 0 && _data$paymentReceipt.fileStoreId) return data.paymentReceipt.fileStoreId;
    if (typeof (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.paymentReceipt) === "string") return data.additionalDetails.paymentReceipt;
    if (data !== null && data !== void 0 && (_data$additionalDetai2 = data.additionalDetails) !== null && _data$additionalDetai2 !== void 0 && (_data$additionalDetai3 = _data$additionalDetai2.paymentReceipt) !== null && _data$additionalDetai3 !== void 0 && _data$additionalDetai3.fileStoreId) return data.additionalDetails.paymentReceipt.fileStoreId;
    if (typeof (data === null || data === void 0 ? void 0 : data.obpasPaymentReceipt) === "string") return data.obpasPaymentReceipt;
    if (data !== null && data !== void 0 && (_data$obpasPaymentRec = data.obpasPaymentReceipt) !== null && _data$obpasPaymentRec !== void 0 && _data$obpasPaymentRec.fileStoreId) return data.obpasPaymentReceipt.fileStoreId;
    const doc = (data === null || data === void 0 ? void 0 : (_data$documents = data.documents) === null || _data$documents === void 0 ? void 0 : (_data$documents$find = _data$documents.find) === null || _data$documents$find === void 0 ? void 0 : _data$documents$find.call(_data$documents, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt")) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : (_data$additionalDetai5 = _data$additionalDetai4.documents) === null || _data$additionalDetai5 === void 0 ? void 0 : (_data$additionalDetai6 = _data$additionalDetai5.find) === null || _data$additionalDetai6 === void 0 ? void 0 : _data$additionalDetai6.call(_data$additionalDetai5, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt")) || (data === null || data === void 0 ? void 0 : (_data$additionalDocs = data.additionalDocs) === null || _data$additionalDocs === void 0 ? void 0 : (_data$additionalDocs$ = _data$additionalDocs.find) === null || _data$additionalDocs$ === void 0 ? void 0 : _data$additionalDocs$.call(_data$additionalDocs, item => String((item === null || item === void 0 ? void 0 : item.documentType) || "").toLowerCase() === "paymentreceipt"));
    return (doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.fileStoreUrl) || null;
  };
  const receiptFileStoreId = (typeof (props === null || props === void 0 ? void 0 : props.paymentReceipt) === "string" ? props.paymentReceipt : props === null || props === void 0 ? void 0 : (_props$paymentReceipt = props.paymentReceipt) === null || _props$paymentReceipt === void 0 ? void 0 : _props$paymentReceipt.fileStoreId) || getPaymentReceiptFileStoreId(formData);
  const handleOpenReceipt = async fileStoreId => {
    if (!fileStoreId) {
      alert("Receipt not available");
      return;
    }
    if (String(fileStoreId).startsWith("http://") || String(fileStoreId).startsWith("https://")) {
      window.open(fileStoreId, "_blank");
      return;
    }
    try {
      await getDocumentByFileStoreId(fileStoreId, () => {});
    } catch (e) {
      console.error("Error opening receipt file:", e);
      try {
        var _Digit, _Digit$ULBService, _Digit$ULBService$get, _Digit2, _Digit2$UploadService, _Digit2$UploadService2, _res$data, _res$data$fileStoreId, _res$data$fileStoreId2;
        const tenantId = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ULBService = _Digit.ULBService) === null || _Digit$ULBService === void 0 ? void 0 : (_Digit$ULBService$get = _Digit$ULBService.getStateId) === null || _Digit$ULBService$get === void 0 ? void 0 : _Digit$ULBService$get.call(_Digit$ULBService)) || "up";
        const res = await ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$UploadService = _Digit2.UploadServices) === null || _Digit2$UploadService === void 0 ? void 0 : (_Digit2$UploadService2 = _Digit2$UploadService.Filefetch) === null || _Digit2$UploadService2 === void 0 ? void 0 : _Digit2$UploadService2.call(_Digit2$UploadService, [fileStoreId], tenantId));
        const url = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$fileStoreId = _res$data.fileStoreIds) === null || _res$data$fileStoreId === void 0 ? void 0 : (_res$data$fileStoreId2 = _res$data$fileStoreId[0]) === null || _res$data$fileStoreId2 === void 0 ? void 0 : _res$data$fileStoreId2.url;
        if (url) window.open(url, "_blank");
      } catch (err) {
        console.error("Fallback file fetch failed:", err);
      }
    }
  };
  const formatDateValue = dateVal => {
    if (!dateVal) return "N/A";
    if (typeof dateVal === "number" || /^\d+$/.test(String(dateVal)) && String(dateVal).length > 8) {
      var _Digit3, _Digit3$DateUtils;
      return (_Digit3 = Digit) !== null && _Digit3 !== void 0 && (_Digit3$DateUtils = _Digit3.DateUtils) !== null && _Digit3$DateUtils !== void 0 && _Digit3$DateUtils.ConvertTimestampToDate ? Digit.DateUtils.ConvertTimestampToDate(Number(dateVal)) : new Date(Number(dateVal)).toLocaleDateString("en-IN");
    }
    const str = String(dateVal).split("T")[0].split(" ")[0];
    if (str.includes("-")) {
      const parts = str.split("-");
      if (parts[0].length === 4) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return str;
    }
    if (str.includes("/")) {
      var _parts$;
      const parts = str.split("/");
      if (((_parts$ = parts[2]) === null || _parts$ === void 0 ? void 0 : _parts$.length) === 4) {
        return `${parts[0]}-${parts[1]}-${parts[2]}`;
      }
      return str;
    }
    return str;
  };
  const isInstallment = (formData === null || formData === void 0 ? void 0 : formData.isInstallment) === true || (formData === null || formData === void 0 ? void 0 : formData.isInstallment) === "true" || (formData === null || formData === void 0 ? void 0 : formData.feeInstallment) && (formData === null || formData === void 0 ? void 0 : formData.feeInstallment.length) > 0;
  const feeInstallments = useMemo(() => {
    const list = Array.isArray(formData === null || formData === void 0 ? void 0 : formData.feeInstallment) ? formData.feeInstallment : [];
    return [...list].sort((a, b) => Number(a.installmentNumber) - Number(b.installmentNumber));
  }, [formData === null || formData === void 0 ? void 0 : formData.feeInstallment]);
  const showInstallmentButton = isInstallment && feeInstallments.length > 0;
  const isFee2Item = item => String((item === null || item === void 0 ? void 0 : item.calculationBusinesserviceId) || "").includes("FEE2");
  const formatAmount = value => Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const formatDueDate = date => {
    if (!date) return "N/A";
    const [yyyy, mm, dd] = String(date).split("T")[0].split("-");
    return `${dd}-${mm}-${yyyy}`;
  };
  const token = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem("token"));
  const userInfo = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.info) || {};
  console.log("taxheadestimates 14141414", taxHeadEstimates);
  useEffect(() => {
    if (formData && formData !== null && formData !== void 0 && formData.applicationNo) {
      checkPaymentStatus(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  const checkPaymentStatus = async id => {
    console.log("insidecheckpaymentstatus", formData, id);
    try {
      var _response$data;
      const requestInfo = {
        RequestInfo: {
          apiId: "Rainmaker",
          ver: "v1",
          ts: 0,
          action: "_search",
          did: "",
          key: "",
          msgId: "090909",
          requesterId: "",
          authToken: token,
          userInfo: userInfo
        }
      };
      const response = await axios$1.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo);
      setChallanData((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.Transaction) || []);
      console.log("Transaction API Response:", response === null || response === void 0 ? void 0 : response.data);
      return response === null || response === void 0 ? void 0 : response.data;
    } catch (error) {
      console.log("Transaction API Error:", error);
      throw error;
    }
  };
  console.log("challanData", challanData);
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.taxHeadEstimates && Array.isArray(formData.taxHeadEstimates)) {
      setTaxHeadEstimates(formData.taxHeadEstimates);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates]);
  const addTransactionStatus = (firstData = [], secondData = []) => {
    return firstData.map(item => {
      const matchedTransaction = secondData.find(transaction => Number(item.estimateAmount) === Number(transaction.txnAmount));
      console.log("Matched Transaction", matchedTransaction);
      return {
        ...item,
        isTransactionSuccessfull: (matchedTransaction === null || matchedTransaction === void 0 ? void 0 : matchedTransaction.txnStatus) === "SUCCESS",
        auditDetails: matchedTransaction === null || matchedTransaction === void 0 ? void 0 : matchedTransaction.auditDetails
      };
    });
  };
  const filteredData = useMemo(() => addTransactionStatus(taxHeadEstimates, challanData), [taxHeadEstimates, challanData]);
  console.log("filteredData", filteredData);
  const formatInstallmentLabel = installment => {
    const feeKey = installment === null || installment === void 0 ? void 0 : installment.column1;
    const number = installment === null || installment === void 0 ? void 0 : installment.installmentNumber;
    const hasNumber = number !== undefined && number !== null;
    if (!feeKey) return hasNumber ? `${number}` : "";
    const label = INSTALLMENT_FEE_LABELS[feeKey] || feeKey.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    return hasNumber ? `${label} ${number}` : label;
  };
  const isInitialPayment = inst => Number(inst === null || inst === void 0 ? void 0 : inst.installmentNumber) === 0 || (inst === null || inst === void 0 ? void 0 : inst.column1) === "initial_payment";
  const sortInstallments = (installments = []) => {
    const getFeeRank = inst => {
      const index = INSTALLMENT_FEE_ORDER.indexOf(inst === null || inst === void 0 ? void 0 : inst.column1);
      return index === -1 ? INSTALLMENT_FEE_ORDER.length : index;
    };
    return [...installments].sort((a, b) => {
      const aInitial = isInitialPayment(a);
      const bInitial = isInitialPayment(b);
      if (aInitial !== bInitial) return aInitial ? -1 : 1;
      const rankDiff = getFeeRank(a) - getFeeRank(b);
      if (rankDiff !== 0) return rankDiff;
      if ((a === null || a === void 0 ? void 0 : a.column1) !== (b === null || b === void 0 ? void 0 : b.column1)) return ((a === null || a === void 0 ? void 0 : a.column1) || "").localeCompare((b === null || b === void 0 ? void 0 : b.column1) || "");
      return Number(a === null || a === void 0 ? void 0 : a.installmentNumber) - Number(b === null || b === void 0 ? void 0 : b.installmentNumber);
    });
  };
  const displayedData = isAlreadySubmitted ? filteredData.slice(1) : filteredData;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: "100%",
      overflowX: "auto"
    }
  }, isAlreadySubmitted && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "8px 16px",
      backgroundColor: "#e8f5e9",
      borderLeft: "4px solid #2e7d32",
      color: "#1b5e20",
      fontSize: "13px",
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u2139\uFE0F"), /*#__PURE__*/React__default.createElement("span", null, "Note: Initial fee was already submitted on OBPAS (File No: ", obpasFileNumber || "N/A", ").")), /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 700
    },
    "aria-label": "payment memo table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Memo")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan No.")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Date")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount (in Rs.)")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Receipt")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, isAlreadySubmitted && /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbf9"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Chip, {
    size: "small",
    label: "Already Submitted on OBPAS",
    sx: {
      backgroundColor: "#e8f5e9",
      color: "#1b5e20",
      fontWeight: "bold",
      fontSize: "11px"
    }
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, obpasFileNumber || "N/A")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "11px",
      color: "#2e7d32",
      fontWeight: 600
    }
  }, "Already Submitted on OBPAS")), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatDateValue(dateOfPayment)), /*#__PURE__*/React__default.createElement(TableCell$1, null, (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, receiptFileStoreId ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => handleOpenReceipt(receiptFileStoreId)
  }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"))), displayedData === null || displayedData === void 0 ? void 0 : (_displayedData$filter = displayedData.filter(item => item === null || item === void 0 ? void 0 : item.challanNo)) === null || _displayedData$filter === void 0 ? void 0 : _displayedData$filter.map((item, index) => {
    var _item$auditDetails, _item$auditDetails2, _item$auditDetails3;
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: index
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(IconButton$1, null, /*#__PURE__*/React__default.createElement(PaymentChallanPopup, {
      date: item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.lastModifiedTime,
      formData: formData,
      item: item,
      taxHead: taxHead,
      totalAmount: totalAmount,
      logoData: logoData
    }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.challanNo) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item !== null && item !== void 0 && (_item$auditDetails2 = item.auditDetails) !== null && _item$auditDetails2 !== void 0 && _item$auditDetails2.lastModifiedTime ? Digit.DateUtils.ConvertTimestampToDate(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.lastModifiedTime) : "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.estimateAmount) || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, showInstallmentButton && isFee2Item(item) ? /*#__PURE__*/React__default.createElement("button", {
      className: "btn btn-primary",
      style: {
        padding: "5px",
        backgroundColor: "#1F4A7C"
      },
      onClick: () => setShowPaymentModal(true)
    }, "View installments") : item !== null && item !== void 0 && item.isTransactionSuccessfull || (item === null || item === void 0 ? void 0 : item.paymentStatus) === "PAID" ? /*#__PURE__*/React__default.createElement("button", {
      className: "btn btn-primary",
      style: {
        padding: "5px",
        backgroundColor: "#1F4A7C"
      },
      onClick: () => {
        setShowPaymentDetails(true);
        setSelectedChallanNo(item === null || item === void 0 ? void 0 : item.challanNo);
      }
    }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"), showPaymentDetails && selectedChallanNo === (item === null || item === void 0 ? void 0 : item.challanNo) && /*#__PURE__*/React__default.createElement(DialogContentModal, {
      title: "Application Payment Details",
      dataOpen: showPaymentDetails,
      onClose: () => setShowPaymentDetails(false)
    }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
      id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
      formData: formData,
      challanNo: item === null || item === void 0 ? void 0 : item.challanNo
    }))));
  })))), showPaymentModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Payment Details",
    dataOpen: showPaymentModal,
    onClose: () => {
      setShowPaymentModal(false);
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: "100%",
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    size: "small",
    "aria-label": "installment details table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, ["Installment", "Amount (in Rs.)", "Due Date", "Status", "Penalty", "Previous Amount", "Receipt"].map(h => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: h,
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, h))))), /*#__PURE__*/React__default.createElement(TableBody$1, null, feeInstallments && sortInstallments(feeInstallments).map(inst => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: inst.id
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, inst.installmentNumber === 0 ? "Initial Payment" : formatInstallmentLabel(inst)), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatAmount(inst.amount)), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatDueDate(inst.dueDate)), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Chip, {
    size: "small",
    label: inst.status || "N/A",
    color: inst.status === "PAID" ? "success" : "warning"
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, formatAmount(inst.interestAmount)), /*#__PURE__*/React__default.createElement(TableCell$1, null, inst.interestAmount > 0 ? formatAmount(inst.amount - inst.interestAmount) : formatAmount(0)), /*#__PURE__*/React__default.createElement(TableCell$1, null, inst.status === "PAID" ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => setSelectedInstallment(inst)
  }, "Receipt") : "Not Done"))))))), selectedInstallment && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: !!selectedInstallment,
    onClose: () => setSelectedInstallment(null)
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
    id: (selectedInstallment === null || selectedInstallment === void 0 ? void 0 : selectedInstallment.consumerCode) || (formData === null || formData === void 0 ? void 0 : formData.applicationNo),
    formData: formData,
    installment: selectedInstallment
  })));
};

function SearchSummary({
  id,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration,
  formType,
  isAlreadySubmitted,
  setIsAlreadySubmitted,
  obpasFileNumber,
  setObpasFileNumber,
  dateOfPayment,
  setDateOfPayment,
  paymentReceipt,
  setPaymentReceipt
}) {
  var _data$BPA, _data$BPA2, _data$BPA2$;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const queryFormType = "MAP_SUB";
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  }, {
    formType: queryFormType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  });
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  useEffect(() => {
    if (id && queryFormType) {
      refetch();
    }
  }, [id, queryFormType, refetch]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(MapSubmissionSummary, {
    formData: data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0],
    ref: ref,
    handleDeclarationChange: handleDeclarationChange,
    declarationChecked: declarationChecked,
    showDeclaration: showDeclaration,
    formType: formType,
    logoData: (data === null || data === void 0 ? void 0 : (_data$BPA2 = data.BPA) === null || _data$BPA2 === void 0 ? void 0 : (_data$BPA2$ = _data$BPA2[0]) === null || _data$BPA2$ === void 0 ? void 0 : _data$BPA2$.department) == "DA" ? daLogo : avpLogo,
    isAlreadySubmitted: isAlreadySubmitted,
    setIsAlreadySubmitted: setIsAlreadySubmitted,
    obpasFileNumber: obpasFileNumber,
    setObpasFileNumber: setObpasFileNumber,
    dateOfPayment: dateOfPayment,
    setDateOfPayment: setDateOfPayment,
    paymentReceipt: paymentReceipt,
    setPaymentReceipt: setPaymentReceipt
  }));
}

const SelfApprovalSummary = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false
}) => {
  var _formData$landInfo, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _documents$filter, _documents$filter$, _Digit$SessionStorage, _formData$plotNumbers, _structuralInfo$perma, _structuralInfo$perma2, _formData$description, _feeDetail$mapRate, _feeDetail$mapRate2;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const plotInfo = formData === null || formData === void 0 ? void 0 : formData.plotInfo;
  const structuralInfo = formData === null || formData === void 0 ? void 0 : formData.structuralInfo;
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const professionalInfo = formData === null || formData === void 0 ? void 0 : formData.professionaldetails;
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const paymentHead = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchisSetbackRequired = formData === null || formData === void 0 ? void 0 : formData.isSetbackRequired;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.constructionType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, "Lucknow Development Authority"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "General Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo)), (formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.currValidityDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Current Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.currValidityDate)), (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity proposed:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planOn)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherSchemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherSchemeName)), (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.isMetroCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Site falls in Metro City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isMetroCity)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.constructionType)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature of Construction /Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevFileNo)), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village/College Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.landMark)), (formData === null || formData === void 0 ? void 0 : formData.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector/Pocket No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sectorNo)), (formData === null || formData === void 0 ? void 0 : formData.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.khasraNo)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Standard Type Design:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction date Of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction number of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.noOfPlots) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.noOfPlots)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.plotNumbers) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.join(", "))), (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingClassification)), watchbuildingClassification === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass)), (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isSpecialProject)), (formData === null || formData === void 0 ? void 0 : formData.communityParking) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "If Community Parking Provided:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.communityParking)), watchisSpecialProject === "yes" && (formData === null || formData === void 0 ? void 0 : formData.projectType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Condition Of Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.projectType)), watchisSpecialProject === "Other" && (formData === null || formData === void 0 ? void 0 : formData.otherProjectName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherProjectName)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.groundCoverage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.groundCoverage)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.far) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.far)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingHeight)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackFronts) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackFronts)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackRears) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackRears)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback- 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide1)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback - 2:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide2)), watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Plot Sub-division:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)), watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && watchPlotSubdivided === "no" && (formData === null || formData === void 0 ? void 0 : formData.needCompounding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does existing building require any compounding ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.needCompounding)), watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && watchPlotSubdivided === "no" && watchNeedComp === "no" && (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot Lease hold ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchplotLeaseHold === "yes" && (edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC for Lease hold :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Left:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Right:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No. Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.certificateNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.validupto))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.map((item, index) => {
    var _item$inputonGST, _item$inputonGST2, _item$inputonGST3, _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? "Addition Owner Information" : "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Input On GST:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST = item.inputonGST) === null || _item$inputonGST === void 0 ? void 0 : _item$inputonGST.value) === "yes" ? "Yes" : (item === null || item === void 0 ? void 0 : item.inputonGST) === "no" || (item === null || item === void 0 ? void 0 : (_item$inputonGST2 = item.inputonGST) === null || _item$inputonGST2 === void 0 ? void 0 : _item$inputonGST2.value) === "no" ? "No" : (item === null || item === void 0 ? void 0 : item.inputonGST) || "N/A")), ((item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST3 = item.inputonGST) === null || _item$inputonGST3 === void 0 ? void 0 : _item$inputonGST3.value) === "yes") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "GST No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.gstNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.town)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.address)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "200px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo))))))));
  })), structuralInfo && (structuralInfo.name || structuralInfo.validupto || structuralInfo.licenseNumber || ((_structuralInfo$perma = structuralInfo.permanentAddress) === null || _structuralInfo$perma === void 0 ? void 0 : _structuralInfo$perma.address)) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.name) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.validupto) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.licenseNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : (_structuralInfo$perma2 = structuralInfo.permanentAddress) === null || _structuralInfo$perma2 === void 0 ? void 0 : _structuralInfo$perma2.address) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot area as per Drawing (Sq.Mt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.plotArea))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details (Step-1)")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate = feeDetail.mapRate) === null || _feeDetail$mapRate === void 0 ? void 0 : _feeDetail$mapRate.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Fee on Plot:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.price)), paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.map((payment, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, payment === null || payment === void 0 ? void 0 : payment.feeType, ":")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, payment === null || payment === void 0 ? void 0 : payment.amount))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      fontWeight: "bolder"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount))))))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.planReport, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.dxfFile, "_blank")
  })))))))), _showDeclaration && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with this application.", " ")
  }))));
});

const PrimaryContent = ({
  formData,
  handleChange,
  serviceName,
  daLogo,
  avpLogo,
  requestLetterId: _requestLetterId = null
}) => {
  var _sessionNoc$value, _sessionNoc$nocSearch, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$additionalD3, _formData$additionalD4;
  const [smShow, setSmShow] = useState(false);
  const [modalType, setModalType] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  const [showLettersModal, setShowLettersModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    t
  } = useTranslation();
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const userOrgCode = userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode;
  const sessionNoc = Digit.SessionStorage.get("nocAppNo");
  const sessionNocNo = (sessionNoc === null || sessionNoc === void 0 ? void 0 : sessionNoc.nocAppNo) || (sessionNoc === null || sessionNoc === void 0 ? void 0 : (_sessionNoc$value = sessionNoc.value) === null || _sessionNoc$value === void 0 ? void 0 : _sessionNoc$value.nocAppNo) || (sessionNoc === null || sessionNoc === void 0 ? void 0 : (_sessionNoc$nocSearch = sessionNoc.nocSearchResult) === null || _sessionNoc$nocSearch === void 0 ? void 0 : _sessionNoc$nocSearch.applicationNo);
  const resolveRequestLetter = () => {
    if (_requestLetterId) return _requestLetterId;
    if (formData !== null && formData !== void 0 && formData.requestLetterUrl) return formData.requestLetterUrl;
    if (formData !== null && formData !== void 0 && formData.requestLetterFileStoreId) return formData.requestLetterFileStoreId;
    let rawNocLetter = formData === null || formData === void 0 ? void 0 : formData.nocLetterInfo;
    if (Array.isArray(rawNocLetter)) {
      const matched = userOrgCode && rawNocLetter.find(r => (r === null || r === void 0 ? void 0 : r.businessService) === userOrgCode) || rawNocLetter.find(r => (r === null || r === void 0 ? void 0 : r.fileStoreUrl) || (r === null || r === void 0 ? void 0 : r.url) || (r === null || r === void 0 ? void 0 : r.fileStoreId)) || rawNocLetter[0];
      if (matched !== null && matched !== void 0 && matched.fileStoreUrl || matched !== null && matched !== void 0 && matched.url || matched !== null && matched !== void 0 && matched.fileStoreId) {
        return matched.fileStoreUrl || matched.url || matched.fileStoreId;
      }
    } else if (rawNocLetter && typeof rawNocLetter === "object") {
      if (rawNocLetter.fileStoreUrl || rawNocLetter.url || rawNocLetter.fileStoreId) {
        return rawNocLetter.fileStoreUrl || rawNocLetter.url || rawNocLetter.fileStoreId;
      }
    }
    if (Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocList)) {
      const targetNoc = sessionNocNo && formData.nocList.find(n => (n === null || n === void 0 ? void 0 : n.applicationNo) === sessionNocNo) || userOrgCode && formData.nocList.find(n => (n === null || n === void 0 ? void 0 : n.businessService) === userOrgCode) || formData.nocList[0];
      if (targetNoc) {
        var _targetLetter, _targetLetter2, _targetLetter3;
        let targetLetter = targetNoc.nocLetterInfo;
        if (Array.isArray(targetLetter)) targetLetter = targetLetter[0];
        const res = ((_targetLetter = targetLetter) === null || _targetLetter === void 0 ? void 0 : _targetLetter.fileStoreUrl) || ((_targetLetter2 = targetLetter) === null || _targetLetter2 === void 0 ? void 0 : _targetLetter2.url) || ((_targetLetter3 = targetLetter) === null || _targetLetter3 === void 0 ? void 0 : _targetLetter3.fileStoreId) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.requestLetterUrl);
        if (res) return res;
      }
    }
    const sessionResult = sessionNoc === null || sessionNoc === void 0 ? void 0 : sessionNoc.nocSearchResult;
    if (sessionResult) {
      var _sl, _sl2, _sl3;
      let sl = sessionResult.nocLetterInfo;
      if (Array.isArray(sl)) sl = sl[0];
      const res = ((_sl = sl) === null || _sl === void 0 ? void 0 : _sl.fileStoreUrl) || ((_sl2 = sl) === null || _sl2 === void 0 ? void 0 : _sl2.url) || ((_sl3 = sl) === null || _sl3 === void 0 ? void 0 : _sl3.fileStoreId) || (sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.requestLetterUrl);
      if (res) return res;
    }
    return null;
  };
  const resolvedRequestLetter = resolveRequestLetter();
  const handleRequestLetterView = async target => {
    if (!target) return;
    if (typeof target === "string" && (target.startsWith("http://") || target.startsWith("https://") || target.startsWith("/filestore"))) {
      window.open(target, "_blank");
      return;
    }
    try {
      var _res$data, _res$data$fileStoreId, _res$data$fileStoreId2;
      const tenantId = Digit.ULBService.getCurrentTenantId() || "up";
      const res = await Digit.UploadServices.Filefetch([target], tenantId);
      const fetchedUrl = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$fileStoreId = _res$data.fileStoreIds) === null || _res$data$fileStoreId === void 0 ? void 0 : (_res$data$fileStoreId2 = _res$data$fileStoreId[0]) === null || _res$data$fileStoreId2 === void 0 ? void 0 : _res$data$fileStoreId2.url;
      if (fetchedUrl) {
        window.open(fetchedUrl, "_blank");
        return;
      }
    } catch (e) {
      console.error("Error fetching request letter URL:", e);
    }
    window.open(target, "_blank");
  };
  const handleApprovalLetterView = () => {
    var _formData$additionalD, _formData$additionalD2;
    const pdfUrl = (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.approvalLetterUrl);
    window.open(pdfUrl, "_blank");
    if (!(formData !== null && formData !== void 0 && formData.approvalCertificateUrl)) return;
    setIframeSrc((formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.approvalLetterUrl));
    setModalType("APPROVAL_LETTER");
  };
  const isMapSubmission = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_MAP" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_COMPOUNDING" ? true : false;
  console.log("FOrmDataFOund", formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Take Actions"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || "")), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, "Mobile Number")), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.mobileNumber) || ""))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, "Applicant Name")), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name) || "")), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, "Service Name")), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("p", null, serviceName))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "align-item-center"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, t("View Application"))), /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "4px 8px",
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    },
    onClick: () => {
      setIframeSrc("");
      setSmShow(true);
      setModalType("APPLICATION");
    }
  }, "View")), isMapSubmission ? /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, t("Letters"))) : ((formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.approvalLetterUrl)) && /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, t("Approval Letter"))), /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, isMapSubmission ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-secondary",
    style: {
      padding: "4px 8px",
      fontSize: "14px"
    },
    onClick: () => setShowLettersModal(true)
  }, "View Letters") : ((formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.approvalLetterUrl)) && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-secondary",
    style: {
      padding: "4px 8px",
      fontSize: "14px"
    },
    onClick: handleApprovalLetterView
  }, "View Approval Letter")), resolvedRequestLetter ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontWeight: "bold"
    }
  }, t("Request Letter"))), /*#__PURE__*/React__default.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "4px 8px",
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    },
    onClick: () => handleRequestLetterView(resolvedRequestLetter)
  }, "View"))) : null))), modalType === "APPLICATION" && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: true,
    onClose: () => setModalType(null)
  }, (formData === null || formData === void 0 ? void 0 : formData.planOn) === "SELF_MAP" ? /*#__PURE__*/React__default.createElement(MapSubmissionSummarys, {
    formData: formData,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo
  }) : (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_MAP" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PURCHASABLE_FAR" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_COMPOUNDING" ?
  /*#__PURE__*/
  React__default.createElement(MapSubmissionSummary, {
    formData: formData,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo
  }) : (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? /*#__PURE__*/React__default.createElement(SelfApprovalSummary, {
    formData: formData
  }) : (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PRESSRELEASE" ? /*#__PURE__*/React__default.createElement(TakeActionItem, {
    formType: (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" ? "formLandUse" : "FORM_PRESSRELEASE",
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo
  }) : null), modalType === "PDF" && iframeSrc && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Document Viewer",
    dataOpen: true,
    onClose: () => setModalType(null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "iframe-container"
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: iframeSrc,
    title: "PDF Viewer"
  }))), modalType === "APPROVAL_LETTER" && /*#__PURE__*/React__default.createElement("iframe", {
    src: iframeSrc,
    title: "PDF Viewer"
  }), showLettersModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "All Letters",
    dataOpen: showLettersModal,
    onClose: () => {
      setShowLettersModal(false);
    }
  }, /*#__PURE__*/React__default.createElement(ViewAllLetters, {
    formData: formData
  })));
};

const ActionButtons = ({
  actions,
  currentAction,
  onSelect
}) => {
  return /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2,
    sx: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    sx: {
      marginBottom: "25px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Actions:")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: false,
    options: actions,
    selectedOption: currentAction,
    optionsKey: "action",
    onSelect: onSelect,
    style: {
      display: "flex",
      gap: "3rem",
      margin: 0
    }
  })));
};

const SubmitButton = ({
  handleSubmit,
  isLoading,
  showButton: _showButton = true
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      padding: "4px"
    }
  }, _showButton && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    style: {
      marginLeft: "10px",
      backgroundColor: "#157CB3"
    },
    disabled: isLoading,
    onClick: handleSubmit
  }, t("BUTTON_EMP_SUBMITFORM")));
};

const CustomLetter = ({
  formData,
  setCustomLetter,
  setTypeOfLetter,
  workflowDetails,
  userRolesArray,
  iframeSrc,
  setIframeSrc,
  initialUrl,
  setIsPreviewLoading
}) => {
  var _userRolesArray$;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isLetterAttached, setIsLetterAttached] = useState(false);
  const [dataOfCustomLetter, setDataOfCustomLetter] = useState([]);
  console.log("documentFromRedux", documents);
  console.log("documentsectionRendered");
  useEffect(() => {
    var _formData$documents;
    const dataOFCustomLetter = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => ["typeOfLetterDoc"].includes(doc.documentType));
    if (dataOFCustomLetter.length > 0) {
      setIsLetterAttached(true);
      setDataOfCustomLetter(dataOFCustomLetter);
    }
  }, [formData, isLetterAttached, dataOfCustomLetter]);
  const defaultValues = {
    ...formData,
    documents: documents
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const handleFormSubmit = data => {
    console.log("submitIf", data);
    onSubmit(data);
  };
  const onSubmit = data => {
    setCustomLetter(documents);
    setTypeOfLetter(data === null || data === void 0 ? void 0 : data.customLetter);
  };
  console.log("dataofcustomletter", formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, !isLetterAttached && /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Attachment Letter"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(TypeOfLetter),
    label: t("Custom Letter"),
    name: "customLetter",
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    control: control,
    name: "typeOfLetterDoc",
    label: "Type Of Letter Doc",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    showError: showError,
    tab: 4,
    maxFiles: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))), isLetterAttached && (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) !== "JE" && /*#__PURE__*/React__default.createElement(ViewDocuments, {
    documentSection: dataOfCustomLetter,
    setCustomLetter: setCustomLetter,
    setTypeOfLetter: setTypeOfLetter,
    setIsPreviewLoading: setIsPreviewLoading,
    iframeSrc: iframeSrc,
    setIframeSrc: setIframeSrc,
    initialUrl: initialUrl
  }));
};

const useStyles$3 = makeStyles$1(theme => ({
  textContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 40,
    marginTop: '10px',
    backgroundColor: '#f0f0f0'
  },
  text: {
    position: 'absolute',
    top: 0,
    whiteSpace: 'nowrap',
    animation: '$moveText 90s linear infinite',
    right: '10%',
    animationDelay: '0s'
  },
  '@keyframes moveText': {
    '0%': {
      transform: 'translateX(100%)'
    },
    '100%': {
      transform: 'translateX(-200%)'
    }
  }
}));
function NewsTicker({
  isUdFlow,
  textForNews
}) {
  const classes = useStyles$3();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.text,
    style: {
      padding: '10px',
      color: isUdFlow ? '#36454F' : '#1F4A7C',
      fontWeight: 'bold',
      fontSize: '15px'
    }
  }, textForNews));
}

const DrawingsDetailsTable = ({
  detailData
}) => {
  var _popupData$userDetail, _popupData$userDetail2, _popupData$userDetail3, _popupData$auditDetai, _popupData$drawingsDe;
  const detailsArray = Array.isArray(detailData) ? detailData : [detailData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const openPopup = item => {
    setPopupData(item);
    setShowPopup(true);
  };
  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };
  const printPopup = () => {
    const popupContent = document.getElementById("drawings-popup-print");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Drawings</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const renderFileIcon = (url, label) => url ? /*#__PURE__*/React__default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    title: label
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  }))) : "-";
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      marginBottom: "10px"
    }
  }, "Drawings Details Summary"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "800px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "User"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Recommendation"), /*#__PURE__*/React__default.createElement("th", null, "Observation"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Details"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray.map((item, index) => {
    var _item$auditDetails, _item$drawingsDetails, _item$drawingsDetails2, _item$drawingsDetails3;
    const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
    const createdTime = (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || null;
    const recommendation = item === null || item === void 0 ? void 0 : (_item$drawingsDetails = item.drawingsDetails) === null || _item$drawingsDetails === void 0 ? void 0 : _item$drawingsDetails.dataRecommendation;
    const observation = item === null || item === void 0 ? void 0 : (_item$drawingsDetails2 = item.drawingsDetails) === null || _item$drawingsDetails2 === void 0 ? void 0 : _item$drawingsDetails2.developerObjection;
    const remarks = item === null || item === void 0 ? void 0 : (_item$drawingsDetails3 = item.drawingsDetails) === null || _item$drawingsDetails3 === void 0 ? void 0 : _item$drawingsDetails3.developerRemarks;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, recommendation || "-"), /*#__PURE__*/React__default.createElement("td", null, (observation === null || observation === void 0 ? void 0 : observation.filter(Boolean).map((objection, index) => /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, index + 1, ". ", objection))) || "-"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: createdTime
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopup(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }))), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    }));
  })))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "75%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, "Drawing Info"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "drawings-popup-print"
  }, (popupData === null || popupData === void 0 ? void 0 : popupData.userDetails) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", ((_popupData$userDetail = popupData.userDetails) === null || _popupData$userDetail === void 0 ? void 0 : _popupData$userDetail.employeeName) || ((_popupData$userDetail2 = popupData.userDetails) === null || _popupData$userDetail2 === void 0 ? void 0 : _popupData$userDetail2.name) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", ((_popupData$userDetail3 = popupData.userDetails) === null || _popupData$userDetail3 === void 0 ? void 0 : _popupData$userDetail3.designation) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Created:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: (_popupData$auditDetai = popupData.auditDetails) === null || _popupData$auditDetai === void 0 ? void 0 : _popupData$auditDetai.createdTime
  })), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Status"), /*#__PURE__*/React__default.createElement("th", null, "Drawing PDF"), /*#__PURE__*/React__default.createElement("th", null, "DXF"), /*#__PURE__*/React__default.createElement("th", null, "Updated DXF"), /*#__PURE__*/React__default.createElement("th", null, "Plan Report"), /*#__PURE__*/React__default.createElement("th", null, "Submitted On"))), /*#__PURE__*/React__default.createElement("tbody", null, ((popupData === null || popupData === void 0 ? void 0 : (_popupData$drawingsDe = popupData.drawingsDetails) === null || _popupData$drawingsDe === void 0 ? void 0 : _popupData$drawingsDe.drawingsDetails) || []).map((drawing, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, (drawing === null || drawing === void 0 ? void 0 : drawing.status) || "-"), /*#__PURE__*/React__default.createElement("td", null, renderFileIcon((drawing === null || drawing === void 0 ? void 0 : drawing.drawingPdf) || (drawing === null || drawing === void 0 ? void 0 : drawing.updatedDxfFile) || (drawing === null || drawing === void 0 ? void 0 : drawing.viewPdf), "Drawing PDF")), /*#__PURE__*/React__default.createElement("td", null, renderFileIcon(drawing === null || drawing === void 0 ? void 0 : drawing.dxfFile, "DXF File")), /*#__PURE__*/React__default.createElement("td", null, renderFileIcon((drawing === null || drawing === void 0 ? void 0 : drawing.updatedDxfFile) || (drawing === null || drawing === void 0 ? void 0 : drawing.drawingPdf), "Updated DXF")), /*#__PURE__*/React__default.createElement("td", null, renderFileIcon((drawing === null || drawing === void 0 ? void 0 : drawing.planReport) || (drawing === null || drawing === void 0 ? void 0 : drawing.viewPlanReport), "Plan Report")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: drawing === null || drawing === void 0 ? void 0 : drawing.submittedOn
  })))))))));
};

const DscApprovalLetter = ({
  formData,
  handleTabChange,
  isEmployee,
  pdfType,
  isMapSub: _isMapSub = false
}) => {
  var _formData$additionalD, _formData$businessSer, _formData$additionalD2, _formData$businessSer2, _formData$businessSer3, _formData$businessSer4, _ref, _formData$additionalD3, _formData$application;
  const {
    t
  } = useTranslation();
  console.log(formData, "formdata for test dsc");
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const [open, setOpen] = useState(false);
  const approvalCert = (formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.nocApprovedLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.farApprovalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.completionApprovalCertificateUrl);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const isAVP = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "AVP" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.riskType) === "AVP" || (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP" || (formData === null || formData === void 0 ? void 0 : formData.applicationFlow) === "AVP" || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer = formData.businessService) === null || _formData$businessSer === void 0 ? void 0 : _formData$businessSer.includes("AVP"));
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.applicationFlow) === "DA" || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer2 = formData.businessService) === null || _formData$businessSer2 === void 0 ? void 0 : _formData$businessSer2.includes("DA"));
  const isLandUse = pdfType === "LA" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSE" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LANDUSECONVERSION" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_KYP" || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer3 = formData.businessService) === null || _formData$businessSer3 === void 0 ? void 0 : _formData$businessSer3.includes("LANDUSE")) || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer4 = formData.businessService) === null || _formData$businessSer4 === void 0 ? void 0 : _formData$businessSer4.includes("LAND_USE"));
  const isNOCorLTP = pdfType === "LTP" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_LTP" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "NOC" || (formData === null || formData === void 0 ? void 0 : formData.businessService) === "NOC";
  const isCustomApprovalApplicable = Boolean(_isMapSub) && !isNOCorLTP && !isLandUse && (isDA || isAVP);
  const existingCustomLetterDoc = isCustomApprovalApplicable ? (_ref = (formData === null || formData === void 0 ? void 0 : formData.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationData) === null || _formData$application === void 0 ? void 0 : _formData$application.documents)) === null || _ref === void 0 ? void 0 : _ref.find(doc => {
    var _doc$documentType;
    return (doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.toLowerCase()) === "customapprovalletter" && ((doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.fileUrl) || (doc === null || doc === void 0 ? void 0 : doc.url));
  }) : null;
  const existingCustomLetter = (existingCustomLetterDoc === null || existingCustomLetterDoc === void 0 ? void 0 : existingCustomLetterDoc.fileStoreId) || (existingCustomLetterDoc === null || existingCustomLetterDoc === void 0 ? void 0 : existingCustomLetterDoc.fileUrl) || (existingCustomLetterDoc === null || existingCustomLetterDoc === void 0 ? void 0 : existingCustomLetterDoc.url) || null;
  const [uploadedCustomLetter, setUploadedCustomLetter] = useState(existingCustomLetter || (isCustomApprovalApplicable ? localStorage.getItem("custom_approval_letter") : null) || null);
  useEffect(() => {
    if (!isCustomApprovalApplicable) return;
    const handleUpdate = () => {
      var _ref2, _formData$additionalD4, _formData$application2;
      const stored = localStorage.getItem("custom_approval_letter");
      const currentDoc = (_ref2 = (formData === null || formData === void 0 ? void 0 : formData.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$application2 = formData.applicationData) === null || _formData$application2 === void 0 ? void 0 : _formData$application2.documents)) === null || _ref2 === void 0 ? void 0 : _ref2.find(doc => {
        var _doc$documentType2;
        return (doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.toLowerCase()) === "customapprovalletter" && ((doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.fileUrl) || (doc === null || doc === void 0 ? void 0 : doc.url));
      });
      const letter = stored || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileStoreId) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileUrl) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.url) || null;
      if (letter) {
        setUploadedCustomLetter(letter);
      }
    };
    window.addEventListener("custom_approval_letter_updated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("custom_approval_letter_updated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, [formData, isCustomApprovalApplicable]);
  useEffect(() => {
    var _ref3, _formData$additionalD5, _formData$application3;
    if (!isCustomApprovalApplicable) {
      if (uploadedCustomLetter) setUploadedCustomLetter(null);
      return;
    }
    const currentDoc = (_ref3 = (formData === null || formData === void 0 ? void 0 : formData.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$application3 = formData.applicationData) === null || _formData$application3 === void 0 ? void 0 : _formData$application3.documents)) === null || _ref3 === void 0 ? void 0 : _ref3.find(doc => {
      var _doc$documentType3;
      return (doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.toLowerCase()) === "customapprovalletter" && ((doc === null || doc === void 0 ? void 0 : doc.fileStoreId) || (doc === null || doc === void 0 ? void 0 : doc.fileUrl) || (doc === null || doc === void 0 ? void 0 : doc.url));
    });
    const letter = (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileStoreId) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileUrl) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.url) || localStorage.getItem("custom_approval_letter") || null;
    if (letter !== uploadedCustomLetter) {
      setUploadedCustomLetter(letter);
    }
  }, [formData, isCustomApprovalApplicable]);
  const hasCustomLetter = isCustomApprovalApplicable && Boolean(uploadedCustomLetter);
  const applicationNo = (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || "";
  const isNOCApplication = String(applicationNo).toUpperCase().includes("NOC");
  const resolvedPdfType = isNOCApplication ? "ND" : hasCustomLetter && isAVP ? "DAA" : pdfType || "A";
  const onSubmit = data => {
    OpenPDFFromB64InPdfViewer();
  };
  const isSigned = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) || (formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl));
  const columns = [{
    id: "submissionIndex",
    label: "Letter Index",
    accessor: "submissionIndex"
  }, {
    id: "approvalCert",
    label: "Approval Certificate",
    accessor: "approvalCert"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber),
        pdfType: resolvedPdfType
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
      console.log({
        getSign,
        resolvedPdfType
      }, "getSignResponse");
    } catch (error) {
      console.error(error, "error");
      setLoading(false);
    }
  };
  const handleViewUploadedCustomLetter = async () => {
    if (!uploadedCustomLetter) return;
    try {
      var _response$data, _response$data$fileSt, _response$data$fileSt2;
      if (typeof uploadedCustomLetter === "string" && (uploadedCustomLetter.startsWith("http") || uploadedCustomLetter.startsWith("/"))) {
        window.open(uploadedCustomLetter, "_blank");
        return;
      }
      const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || Digit.ULBService.getCurrentTenantId() || "up";
      const response = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${uploadedCustomLetter}`);
      const fileUrl = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$fileSt = _response$data.fileStoreIds) === null || _response$data$fileSt === void 0 ? void 0 : (_response$data$fileSt2 = _response$data$fileSt[0]) === null || _response$data$fileSt2 === void 0 ? void 0 : _response$data$fileSt2.url;
      if (fileUrl) {
        window.open(fileUrl, "_blank");
      }
    } catch (err) {
      console.error("Failed to view custom approval letter:", err);
    }
  };
  const handleOpenSignedPdf = async urlOrFileStoreId => {
    if (!urlOrFileStoreId) return;
    if (typeof urlOrFileStoreId === "string" && (urlOrFileStoreId.startsWith("http") || urlOrFileStoreId.startsWith("/"))) {
      window.open(urlOrFileStoreId, "_blank");
      return;
    }
    try {
      var _response$data2, _response$data2$fileS, _response$data2$fileS2;
      const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || Digit.ULBService.getCurrentTenantId() || "up";
      const response = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${urlOrFileStoreId}`);
      const fileUrl = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$fileS = _response$data2.fileStoreIds) === null || _response$data2$fileS === void 0 ? void 0 : (_response$data2$fileS2 = _response$data2$fileS[0]) === null || _response$data2$fileS2 === void 0 ? void 0 : _response$data2$fileS2.url;
      if (fileUrl) {
        window.open(fileUrl, "_blank");
      }
    } catch (err) {
      console.error("Failed to view signed approval letter:", err);
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log({
    signingParams
  }, "signinngParams");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Approval Letter Information")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map((column, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 1
  }, columns.map((column, index) => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, index + 1);
    }
    if (column.accessor === "approvalCert") {
      const displayUrl = hasCustomLetter ? null : approvalCert;
      const isCustom = hasCustomLetter;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, isCustom ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }
      }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: handleViewUploadedCustomLetter,
        title: t("View Custom Approval Letter")
      }), /*#__PURE__*/React__default.createElement("span", {
        onClick: handleViewUploadedCustomLetter,
        style: {
          color: "#157CB3",
          fontSize: "12px",
          cursor: "pointer",
          textDecoration: "underline",
          fontWeight: 500
        }
      }, t("View Custom Letter"))) : displayUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(displayUrl, "_blank"),
        title: t("View Approval Letter")
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      const signedApprovalUrl = (formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl) || (isSigned ? approvalCert : null);
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, isSigned && signedApprovalUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#19c828ff",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => handleOpenSignedPdf(signedApprovalUrl),
        title: "View Signed Approval Certificate"
      }) : isSigned ? /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: "#2e7d32",
          fontWeight: 500
        }
      }, "\u2713 Signed") : /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        },
        type: "button",
        onClick: handleSign
      }, "Attach Digital Sign"));
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit"))))))));
};

const DscSanction = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$documents, _formData$documents$f, _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$documents2, _formData$documents2$, _formData$additionalD4, _formData$additionalD5, _formData$additionalD6;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  let drawingDetail = (formData === null || formData === void 0 ? void 0 : formData.drawingDetail) || [];
  const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || Digit.ULBService.getStateId() || "up";
  const docDxf = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.find(d => d.documentType === "dxfDrawing")) === null || _formData$documents$f === void 0 ? void 0 : _formData$documents$f.fileStoreId) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.documents) === null || _formData$additionalD2 === void 0 ? void 0 : (_formData$additionalD3 = _formData$additionalD2.find(d => d.documentType === "dxfDrawing")) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.fileStoreId);
  const docPdf = (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.find(d => d.documentType === "drawingPdf")) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.fileStoreId) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : (_formData$additionalD5 = _formData$additionalD4.documents) === null || _formData$additionalD5 === void 0 ? void 0 : (_formData$additionalD6 = _formData$additionalD5.find(d => d.documentType === "drawingPdf")) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.fileStoreId);
  const docDxfUrl = docDxf ? `/filestore/v1/files/id?fileStoreId=${docDxf}&tenantId=${tenantId}` : null;
  const docPdfUrl = docPdf ? `/filestore/v1/files/id?fileStoreId=${docPdf}&tenantId=${tenantId}` : null;
  if (drawingDetail.length === 0) {
    if (formData !== null && formData !== void 0 && formData.selfDrawingPdfUrl || formData !== null && formData !== void 0 && formData.editPdfViaPdfUrl || docPdfUrl || formData !== null && formData !== void 0 && formData.updatedDxfFile || formData !== null && formData !== void 0 && formData.proposalUrl || formData !== null && formData !== void 0 && formData.planReport || formData !== null && formData !== void 0 && formData.dxfFile || docDxfUrl || formData !== null && formData !== void 0 && formData.sanctionDrawingUrl || typeof (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === "string" && formData !== null && formData !== void 0 && formData.IsSignedDrawingPdfURL) {
      var _formData$auditDetail, _formData$auditDetail2;
      drawingDetail = [{
        drawingPdf: (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) || (formData === null || formData === void 0 ? void 0 : formData.editPdfViaPdfUrl) || docPdfUrl || (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile),
        planReport: formData === null || formData === void 0 ? void 0 : formData.planReport,
        dxfFile: (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || docDxfUrl || (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile),
        status: formData === null || formData === void 0 ? void 0 : formData.status,
        submittedOn: (formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.lastModifiedTime) || (formData === null || formData === void 0 ? void 0 : (_formData$auditDetail2 = formData.auditDetails) === null || _formData$auditDetail2 === void 0 ? void 0 : _formData$auditDetail2.createdTime),
        sanctionDrawingUrl: (formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || (formData === null || formData === void 0 ? void 0 : formData.signedPdfUrl) || (typeof (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === "string" ? formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL : "")
      }];
    }
  }
  const [open, setOpen] = useState(false);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const onSubmit = data => {
    OpenPDFFromB64InPdfViewer();
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "drawingPdf",
    label: "Drawing PDF",
    accessor: "drawingPdf"
  }, {
    id: "planReport",
    label: "Plan Report",
    accessor: "planReport"
  }, {
    id: "dxfFile",
    label: ".dxf File",
    accessor: "dxfFile"
  }, {
    id: "status",
    label: "Status",
    accessor: "status"
  }, {
    id: "submittedOn",
    label: "Submitted On",
    accessor: "submittedOn"
  }, {
    id: "sanctionDrawingUrl",
    label: "Digital Sign",
    accessor: "sanctionDrawingUrl"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      var _formData$scrutinyFlo;
      const isEdcrFlow = (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "EDCR" || (formData === null || formData === void 0 ? void 0 : (_formData$scrutinyFlo = formData.scrutinyFlow) === null || _formData$scrutinyFlo === void 0 ? void 0 : _formData$scrutinyFlo.toUpperCase()) === "EDCR" || !(formData !== null && formData !== void 0 && formData.scrutinyFlow) && Boolean(formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || Boolean(formData === null || formData === void 0 ? void 0 : formData.edcrNumber);
      const SignRequest = {
        applicationNo: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber),
        pdfType: isEdcrFlow ? "SD" : "DIA"
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
      console.log({
        getSign,
        signingParams,
        AuthToken,
        SrcPdfB64,
        SignSettingName,
        ReturnUrl
      }, "getSingngn");
    } catch (error) {
      console.error(error, "error");
      setLoading(false);
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log({
    signingParams
  }, "signinngParams");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer",
    style: {
      width: "78vw!important"
    }
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, drawingDetail.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, columns.map(column => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, "Submission ", index + 1);
    }
    const value = row[column.accessor];
    if (column.accessor === "submittedOn") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? new Date(value).toLocaleString() : "N/A");
    }
    if (column.accessor === "drawingPdf") {
      const isSigned = (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfDscEmp) === true || (formData === null || formData === void 0 ? void 0 : formData.IsSanctionDrawing) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL);
      let pdfUrl = (row === null || row === void 0 ? void 0 : row.drawingPdf) || (row === null || row === void 0 ? void 0 : row.updatedDxfFile) || (row === null || row === void 0 ? void 0 : row.viewPdf) || (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) || docPdfUrl;
      if (isSigned) {
        pdfUrl = (formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || (formData === null || formData === void 0 ? void 0 : formData.selfDrawingPdfUrl) || pdfUrl;
      }
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, pdfUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(pdfUrl, "_blank"),
        title: "View Drawing PDF"
      }) : "N/A");
    }
    if (column.accessor === "planReport") {
      const planReportUrl = (row === null || row === void 0 ? void 0 : row.planReport) || (row === null || row === void 0 ? void 0 : row.viewPlanReport) || (formData === null || formData === void 0 ? void 0 : formData.planReport);
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, planReportUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(planReportUrl, "_blank"),
        title: "View Plan Report"
      }) : "N/A");
    }
    if (column.accessor === "dxfFile") {
      const dxfUrl = (row === null || row === void 0 ? void 0 : row.dxfFile) || (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || docDxfUrl;
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, dxfUrl ? /*#__PURE__*/React__default.createElement("img", {
        src: "https://i.imgur.com/GDoAGny.png",
        style: {
          width: "20px",
          height: "30px",
          cursor: "pointer"
        },
        onClick: () => window.open(dxfUrl, "_blank"),
        alt: "DXF File",
        title: "Download DXF"
      }) : "N/A");
    }
    if (column.accessor === "sanctionDrawingUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        },
        type: "button",
        onClick: handleSign
      }, "Attach Digital Sign"));
    }
    return /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id
    }, value || "N/A");
  })))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit"))))))));
};

const DscpFARApprovalLetter = ({
  formData,
  handleTabChange,
  isEmployee,
  pdfType: _pdfType = "A"
}) => {
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const [open, setOpen] = useState(false);
  const approvalCert = formData === null || formData === void 0 ? void 0 : formData.farApprovalLetterUrl;
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const onSubmit = data => {
    OpenPDFFromB64InPdfViewer();
  };
  const isSigned = formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate;
  const columns = [{
    id: "submissionIndex",
    label: "Letter Index",
    accessor: "submissionIndex"
  }, {
    id: "approvalCert",
    label: "Approval Certificate",
    accessor: "approvalCert"
  }, !isSigned ? {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  } : null].filter(Boolean);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber),
        pdfType: _pdfType
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
      console.log({
        getSign,
        signingParams,
        AuthToken,
        SrcPdfB64,
        SignSettingName,
        ReturnUrl
      }, "getSingngn");
    } catch (error) {
      console.error(error, "error");
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log({
    signingParams
  }, "signinngParams");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map((column, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 1
  }, columns.map((column, index) => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, index + 1);
    }
    if (column.accessor === "approvalCert") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, approvalCert ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(approvalCert, "_blank")
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, !(formData !== null && formData !== void 0 && formData.ApprovalsignedPdfUrl) && !isSigned && /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        },
        type: "button",
        onClick: handleSign
      }, "Attach Digital Sign"));
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit"))))))));
};

const DscLetters = ({
  formData,
  handleChange,
  isEmployee,
  viewDrawing: _viewDrawing = true,
  pdfType,
  pFARLetter: _pFARLetter = false
}) => {
  const [open4, setOpen4] = useState(false);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "collapse-header",
    onClick: () => setOpen4(!open4),
    "aria-controls": "example-collapse-text",
    "aria-expanded": open4,
    style: {
      background: "rgba(52, 73, 94, 0.94)",
      padding: "0.25rem 1.25rem",
      borderRadius: "0.25rem",
      fontWeight: "600",
      display: "flex",
      cursor: "pointer",
      color: "#817f7f",
      justifyContent: "space-between",
      alignContent: "center",
      marginTop: ".5rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff",
      fontSize: 16
    }
  }, "Add Digital Signature"), open4 ? /*#__PURE__*/React__default.createElement(RemoveIcon$1, {
    sx: {
      color: "#fff"
    }
  }) : /*#__PURE__*/React__default.createElement(AddIcon$1, {
    sx: {
      color: "#fff"
    }
  })), /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: open4
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "example-collapse-text",
    style: {
      marginTop: 12,
      paddingLeft: 12,
      paddingRight: 12
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, _pFARLetter ? /*#__PURE__*/React__default.createElement(DscpFARApprovalLetter, {
    formData: formData,
    handleTabChange: handleChange,
    isEmployee: isEmployee,
    pdfType: pdfType
  }) : /*#__PURE__*/React__default.createElement(DscApprovalLetter, {
    formData: formData,
    handleTabChange: handleChange,
    isEmployee: isEmployee,
    pdfType: pdfType
  })), _viewDrawing && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DscSanction, {
    formData: formData,
    handleTabChange: handleChange,
    isEmployee: isEmployee
  }))))));
};

const EmpIdentifyNoc = ({
  formData,
  tenantId,
  handleTabChange,
  handleNoWorkflowNoc,
  isJE,
  currentFormData
}) => {
  const {
    data: {
      NOC: {
        NocDepartment: mdmsDepartments
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", ["NocDepartment"]);
  console.log("currentFormDatas", currentFormData, mdmsDepartments);
  const [, setIsPreviewLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showNoDepartments, setShowNoDepartments] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(true);
  const [iframeSrc, setIframeSrc] = useState("");
  const [smShow, setSmShow] = useState(false);
  const khasraDetails = (formData === null || formData === void 0 ? void 0 : formData.khasraDetails) || [];
  const tehsil = khasraDetails.length > 0 ? khasraDetails[0].tehsil : "";
  const district = khasraDetails.length > 0 ? khasraDetails[0].district : "";
  const villages = khasraDetails.length > 0 ? khasraDetails[0].villageName : "Lucknow";
  const mdmsDepartmentList = useMemo(() => {
    var _mdmsDepartments$;
    if (Array.isArray(mdmsDepartments === null || mdmsDepartments === void 0 ? void 0 : (_mdmsDepartments$ = mdmsDepartments[0]) === null || _mdmsDepartments$ === void 0 ? void 0 : _mdmsDepartments$.department)) {
      return mdmsDepartments[0].department;
    }
    if (Array.isArray(mdmsDepartments)) {
      return mdmsDepartments;
    }
    return [];
  }, [mdmsDepartments]);
  const rawOfficerNOCData = useMemo(() => {
    var _formData$nocDetails, _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _currentFormData$nocD, _currentFormData$addi, _currentFormData$addi2, _currentFormData$addi3, _formData$additionalD4, _currentFormData$addi4;
    const parseSafe = val => {
      if (typeof val === "string") {
        try {
          return JSON.parse(val);
        } catch (e) {
          return val;
        }
      }
      return val;
    };
    const sources = [formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.officerNOCData, formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.nocDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.officerNOCData, formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.officerNOCData, formData === null || formData === void 0 ? void 0 : formData.officerNOCData, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD = currentFormData.nocDetails) === null || _currentFormData$nocD === void 0 ? void 0 : _currentFormData$nocD.officerNOCData, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$addi = currentFormData.additionalDetails) === null || _currentFormData$addi === void 0 ? void 0 : (_currentFormData$addi2 = _currentFormData$addi.nocDetails) === null || _currentFormData$addi2 === void 0 ? void 0 : _currentFormData$addi2.officerNOCData, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$addi3 = currentFormData.additionalDetails) === null || _currentFormData$addi3 === void 0 ? void 0 : _currentFormData$addi3.officerNOCData, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.officerNOCData];
    for (const src of sources) {
      const parsed = parseSafe(src);
      if (parsed) {
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
        if (typeof parsed === "object" && Object.keys(parsed).length > 0) return parsed;
      }
    }
    const nocDetailsCandidates = [formData === null || formData === void 0 ? void 0 : formData.nocDetails, formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.nocDetails, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.nocDetails, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$addi4 = currentFormData.additionalDetails) === null || _currentFormData$addi4 === void 0 ? void 0 : _currentFormData$addi4.nocDetails];
    for (const nd of nocDetailsCandidates) {
      const parsedNd = parseSafe(nd);
      if (parsedNd && typeof parsedNd === "object") {
        const parsedOfficer = parseSafe(parsedNd === null || parsedNd === void 0 ? void 0 : parsedNd.officerNOCData);
        if (parsedOfficer) {
          if (Array.isArray(parsedOfficer) && parsedOfficer.length > 0) return parsedOfficer;
          if (typeof parsedOfficer === "object" && Object.keys(parsedOfficer).length > 0) return parsedOfficer;
        }
      }
    }
    return [];
  }, [formData, currentFormData]);
  const normalizedOfficerNOCData = useMemo(() => {
    if (!rawOfficerNOCData) return [];
    let list = [];
    if (Array.isArray(rawOfficerNOCData)) {
      list = rawOfficerNOCData;
    } else if (typeof rawOfficerNOCData === "object" && rawOfficerNOCData !== null) {
      const keys = Object.keys(rawOfficerNOCData);
      const isNumericKeys = keys.length > 0 && keys.every(k => !isNaN(Number(k)));
      if (isNumericKeys) {
        list = Object.values(rawOfficerNOCData);
      } else {
        list = keys.filter(key => {
          const val = rawOfficerNOCData[key];
          return val === true || val === "true" || val === "Yes" || val === "YES";
        }).map(key => {
          const match = mdmsDepartmentList.find(dept => (dept.code || "").toLowerCase() === key.toLowerCase() || (dept.name || "").toLowerCase() === key.toLowerCase());
          return match ? {
            code: match.code,
            name: match.name,
            message: match.message
          } : {
            code: key,
            name: key,
            message: ""
          };
        });
        return list;
      }
    }
    return list.map(item => {
      if (typeof item === "string") {
        const match = mdmsDepartmentList.find(dept => (dept.code || "").toLowerCase() === item.toLowerCase() || (dept.name || "").toLowerCase() === item.toLowerCase());
        return match ? {
          code: match.code,
          name: match.name,
          message: match.message
        } : {
          code: item,
          name: item,
          message: ""
        };
      }
      if (item && typeof item === "object") {
        const code = item.code || item.department || item.name || "";
        const match = mdmsDepartmentList.find(dept => (dept.code || "").toLowerCase() === (code || "").toLowerCase() || (dept.name || "").toLowerCase() === (item.name || code || "").toLowerCase());
        return {
          code: (match === null || match === void 0 ? void 0 : match.code) || item.code || item.department || item.name || "",
          name: (match === null || match === void 0 ? void 0 : match.name) || item.name || item.code || item.department || "",
          message: item.message || (match === null || match === void 0 ? void 0 : match.message) || ""
        };
      }
      return null;
    }).filter(item => item && (item.code || item.name));
  }, [rawOfficerNOCData, mdmsDepartmentList]);
  const {
    data,
    isLoading,
    isSuccess,
    error
  } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, formData === null || formData === void 0 ? void 0 : formData.selectedOffice, tehsil, district, villages, {});
  function fetchDepartmentMessages(excelData, departmentList, officerData) {
    const validDeptList = Array.isArray(departmentList) ? departmentList : [];
    if (officerData && officerData.length > 0) {
      const _departments = officerData;
      const _noDepartments = validDeptList.filter(dept => !officerData.some(d => {
        const dCode = (d.code || "").toLowerCase().trim();
        const dName = (d.name || "").toLowerCase().trim();
        const deptCode = (dept.code || "").toLowerCase().trim();
        const deptName = (dept.name || "").toLowerCase().trim();
        return deptCode && (dCode === deptCode || dName === deptCode) || deptName && (dName === deptName || dCode === deptName);
      })).map(dept => ({
        code: dept.code,
        message: dept.message,
        name: dept.name
      }));
      return {
        departments: _departments,
        noDepartments: _noDepartments
      };
    }
    if (!excelData || Array.isArray(excelData) && excelData.length === 0) {
      const noDepartmentsList = validDeptList.map(dept => ({
        code: dept.code,
        message: dept.message,
        name: dept.name
      }));
      return {
        departments: [],
        noDepartments: noDepartmentsList
      };
    }
    const departments = validDeptList.filter(dept => excelData[dept.code] === "Yes" || excelData[dept.code] === "YES").map(dept => ({
      code: dept.code,
      message: dept.message,
      name: dept.name
    }));
    const noDepartments = validDeptList.filter(dept => excelData[dept.code] === "No" || excelData[dept.code] === "NO" || excelData[dept.code] === "" || excelData[dept.code] === undefined || excelData[dept.code] === null).map(dept => ({
      code: dept.code,
      message: dept.message,
      name: dept.name
    }));
    return {
      departments,
      noDepartments
    };
  }
  const {
    departments,
    noDepartments
  } = useMemo(() => {
    var _data$;
    return fetchDepartmentMessages(data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.Departments, mdmsDepartmentList, normalizedOfficerNOCData);
  }, [data, mdmsDepartmentList, normalizedOfficerNOCData]);
  console.log(data, "noanddepartmentss", normalizedOfficerNOCData);
  const allNocList = useMemo(() => {
    var _formData$nocDetails3, _formData$nocDetails4, _formData$additionalD5, _formData$additionalD6, _formData$additionalD7, _currentFormData$nocD2, _currentFormData$nocD3, _currentFormData$addi5, _currentFormData$addi6;
    const candidateSources = [formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : _formData$nocDetails3.nocListApplicantDoc, formData === null || formData === void 0 ? void 0 : formData.nocList, formData === null || formData === void 0 ? void 0 : (_formData$nocDetails4 = formData.nocDetails) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.nocList, formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : (_formData$additionalD6 = _formData$additionalD5.nocDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.nocListApplicantDoc, formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.nocListApplicantDoc, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD2 = currentFormData.nocDetails) === null || _currentFormData$nocD2 === void 0 ? void 0 : _currentFormData$nocD2.nocListApplicantDoc, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.nocList, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD3 = currentFormData.nocDetails) === null || _currentFormData$nocD3 === void 0 ? void 0 : _currentFormData$nocD3.nocList, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$addi5 = currentFormData.additionalDetails) === null || _currentFormData$addi5 === void 0 ? void 0 : (_currentFormData$addi6 = _currentFormData$addi5.nocDetails) === null || _currentFormData$addi6 === void 0 ? void 0 : _currentFormData$addi6.nocListApplicantDoc];
    for (const src of candidateSources) {
      if (Array.isArray(src) && src.length > 0) return src;
    }
    return [];
  }, [formData, currentFormData]);
  const findNocForDepartment = dept => {
    if (!dept) return undefined;
    const code = (dept.code || "").toLowerCase().trim();
    const name = (dept.name || "").toLowerCase().trim();
    return allNocList.find(item => {
      var _rawNocLetter;
      if (!item) return false;
      const nocType = (item.nocType || "").toLowerCase().trim();
      const nocName = (item.nocName || "").toLowerCase().trim();
      let rawNocLetter = item === null || item === void 0 ? void 0 : item.nocLetterInfo;
      if (typeof rawNocLetter === "string") {
        try {
          rawNocLetter = JSON.parse(rawNocLetter);
        } catch (e) {}
      }
      const nocLetterObj = Array.isArray(rawNocLetter) ? (_rawNocLetter = rawNocLetter) === null || _rawNocLetter === void 0 ? void 0 : _rawNocLetter[0] : rawNocLetter;
      const letterName = ((nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.nocName) || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.department) || "").toLowerCase().trim();
      return code && (nocType === code || nocName === code || letterName === code) || name && (nocName === name || nocType === name || letterName === name) || code && (nocType.includes(code) || code.includes(nocType)) || name && (nocName.includes(name) || name.includes(nocName));
    });
  };
  const handleOpenDoc = url => {
    if (url) window.open(url, "_blank");
  };
  const handleOpenRequestLetter = async urlOrFileStoreId => {
    if (!urlOrFileStoreId) return;
    if (typeof urlOrFileStoreId === "string" && (urlOrFileStoreId.startsWith("http://") || urlOrFileStoreId.startsWith("https://"))) {
      setIframeSrc(urlOrFileStoreId);
      setSmShow(true);
    } else {
      try {
        var _res$data, _res$data2, _res$data2$files, _res$data2$files$;
        const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || Digit.ULBService.getStateId();
        const res = await Digit.UploadServices.Filefetch([urlOrFileStoreId], tenantId);
        const url = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data[urlOrFileStoreId]) || (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$files = _res$data2.files) === null || _res$data2$files === void 0 ? void 0 : (_res$data2$files$ = _res$data2$files[0]) === null || _res$data2$files$ === void 0 ? void 0 : _res$data2$files$.url);
        if (url) {
          setIframeSrc(url);
          setSmShow(true);
        } else {
          window.open(url, "_blank");
        }
      } catch (e) {
        console.error("Error fetching fileStoreId for request letter", e);
      }
    }
  };
  const getRequestLetterUrl = nocItem => {
    if (!nocItem) return null;
    let raw = nocItem === null || nocItem === void 0 ? void 0 : nocItem.nocLetterInfo;
    if (typeof raw === "string") {
      try {
        raw = JSON.parse(raw);
      } catch (e) {
        raw = null;
      }
    }
    const obj = Array.isArray(raw) ? raw.find(r => (r === null || r === void 0 ? void 0 : r.fileStoreUrl) || (r === null || r === void 0 ? void 0 : r.url) || (r === null || r === void 0 ? void 0 : r.fileStoreId)) || raw[0] : raw;
    return (obj === null || obj === void 0 ? void 0 : obj.fileStoreUrl) || (obj === null || obj === void 0 ? void 0 : obj.url) || (nocItem === null || nocItem === void 0 ? void 0 : nocItem.requestLetterUrl) || (obj === null || obj === void 0 ? void 0 : obj.fileStoreId) || (nocItem === null || nocItem === void 0 ? void 0 : nocItem.requestLetterFileStoreId) || (nocItem === null || nocItem === void 0 ? void 0 : nocItem.fileStoreId) || null;
  };
  const defaultCheckboxValues = {};
  (departments || []).forEach(dept => {
    if (dept.code) {
      defaultCheckboxValues[dept.code] = true;
    }
  });
  (noDepartments || []).forEach(dept => {
    if (dept.code) {
      defaultCheckboxValues[dept.code] = false;
    }
  });
  const {
    control,
    handleSubmit,
    setValue,
    reset
  } = useForm({
    defaultValues: {
      departments: defaultCheckboxValues
    }
  });
  const watchedDepartments = useWatch({
    control,
    name: "departments"
  });
  useEffect(() => {
    if ((departments === null || departments === void 0 ? void 0 : departments.length) > 0 || (noDepartments === null || noDepartments === void 0 ? void 0 : noDepartments.length) > 0) {
      console.log("defaultFromEffects", defaultCheckboxValues);
      const values = {
        ...defaultCheckboxValues
      };
      reset({
        departments: values
      });
    }
  }, [JSON.stringify(departments), JSON.stringify(noDepartments), JSON.stringify(normalizedOfficerNOCData), reset]);
  useEffect(() => {
    const allDepartments = [...departments, ...(showNoDepartments ? noDepartments : [])];
    if (!allDepartments.length) return;
    const selectedCount = allDepartments.filter(dept => watchedDepartments === null || watchedDepartments === void 0 ? void 0 : watchedDepartments[dept.code]).length;
    setIsAllSelected(selectedCount === allDepartments.length);
  }, [watchedDepartments, departments, noDepartments, showNoDepartments]);
  const handleAddNOC = () => {
    setShowNoDepartments(true);
  };
  const handleSelectAll = () => {
    const newValue = !isAllSelected;
    const allValues = {};
    [...departments, ...(showNoDepartments ? noDepartments : [])].forEach(dept => {
      allValues[dept.code] = newValue;
    });
    reset({
      departments: allValues
    });
  };
  const onSubmit = data => {
    var _formData$additionalD8;
    const selectedNames = Object.entries(data.departments || {}).filter(([_, checked]) => checked).map(([name]) => name);
    const allDeptList = [...departments, ...(showNoDepartments ? noDepartments : [])];
    const uniqueDeptMap = new Map();
    allDeptList.forEach(dept => {
      if (dept !== null && dept !== void 0 && dept.code && !uniqueDeptMap.has(dept.code)) {
        uniqueDeptMap.set(dept.code, dept);
      }
    });
    const selectedDepartments = Array.from(uniqueDeptMap.values()).filter(dept => selectedNames.includes(dept.code)).map(dept => ({
      name: dept.name,
      message: dept.message,
      code: dept.code
    }));
    const parseSafe = val => {
      if (typeof val === "string") {
        try {
          return JSON.parse(val);
        } catch (e) {
          return val;
        }
      }
      return val;
    };
    const parsedNocDetails = parseSafe(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
    const parsedAdditionalNocDetails = parseSafe(formData === null || formData === void 0 ? void 0 : (_formData$additionalD8 = formData.additionalDetails) === null || _formData$additionalD8 === void 0 ? void 0 : _formData$additionalD8.nocDetails);
    const existingNocDetails = parsedNocDetails && typeof parsedNocDetails === "object" ? parsedNocDetails : parsedAdditionalNocDetails && typeof parsedAdditionalNocDetails === "object" ? parsedAdditionalNocDetails : {};
    handleNoWorkflowNoc({
      ...existingNocDetails,
      officerNOCData: selectedDepartments
    }, setIsSubmitted);
  };
  const getUploadedNocDoc = dept => {
    var _formData$nocDetails5, _currentFormData$nocD4, _formData$nocDetails6, _currentFormData$nocD5, _formData$nocDetails7, _currentFormData$nocD6;
    if (!dept) return null;
    const deptName = (dept.name || "").toLowerCase().trim();
    const deptCode = (dept.code || "").toLowerCase().trim();
    const getFid = d => (d === null || d === void 0 ? void 0 : d.fileStoreId) || (d === null || d === void 0 ? void 0 : d.filestoreid) || (d === null || d === void 0 ? void 0 : d.filesstoreid);
    const isNoc = d => (d === null || d === void 0 ? void 0 : d.isNoc) === true || (d === null || d === void 0 ? void 0 : d.isNoc) === "true" || (d === null || d === void 0 ? void 0 : d.isNOC) === true || (d === null || d === void 0 ? void 0 : d.isNOC) === "true" || (d === null || d === void 0 ? void 0 : d.isnoc) === true || (d === null || d === void 0 ? void 0 : d.isnoc) === "true";
    const isDeptMatch = str => {
      if (!str) return false;
      const lower = str.toLowerCase().trim();
      return deptName && (lower === deptName || lower.includes(deptName) || deptName.includes(lower)) || deptCode && (lower === deptCode || lower.includes(deptCode) || deptCode.includes(lower));
    };
    const formDocs = [...(Array.isArray(formData === null || formData === void 0 ? void 0 : formData.documents) ? formData.documents : []), ...(Array.isArray(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.documents) ? currentFormData.documents : []), ...(Array.isArray(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails5 = formData.nocDetails) === null || _formData$nocDetails5 === void 0 ? void 0 : _formData$nocDetails5.documents) ? formData.nocDetails.documents : []), ...(Array.isArray(currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD4 = currentFormData.nocDetails) === null || _currentFormData$nocD4 === void 0 ? void 0 : _currentFormData$nocD4.documents) ? currentFormData.nocDetails.documents : [])];
    for (const d of formDocs) {
      const fid = getFid(d);
      if (fid && isNoc(d)) {
        var _d$additionalDetails, _d$additionalDetails2;
        const docType = (d === null || d === void 0 ? void 0 : d.documentType) || (d === null || d === void 0 ? void 0 : (_d$additionalDetails = d.additionalDetails) === null || _d$additionalDetails === void 0 ? void 0 : _d$additionalDetails.title) || (d === null || d === void 0 ? void 0 : (_d$additionalDetails2 = d.additionalDetails) === null || _d$additionalDetails2 === void 0 ? void 0 : _d$additionalDetails2.fileName) || (d === null || d === void 0 ? void 0 : d.nocType) || (d === null || d === void 0 ? void 0 : d.title) || "";
        if (isDeptMatch(docType)) {
          return fid;
        }
      }
    }
    const applicantDocsSources = [formData === null || formData === void 0 ? void 0 : (_formData$nocDetails6 = formData.nocDetails) === null || _formData$nocDetails6 === void 0 ? void 0 : _formData$nocDetails6.nocListApplicantDoc, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD5 = currentFormData.nocDetails) === null || _currentFormData$nocD5 === void 0 ? void 0 : _currentFormData$nocD5.nocListApplicantDoc, formData === null || formData === void 0 ? void 0 : formData.nocList, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.nocList, formData === null || formData === void 0 ? void 0 : (_formData$nocDetails7 = formData.nocDetails) === null || _formData$nocDetails7 === void 0 ? void 0 : _formData$nocDetails7.nocList, currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$nocD6 = currentFormData.nocDetails) === null || _currentFormData$nocD6 === void 0 ? void 0 : _currentFormData$nocD6.nocList];
    for (const src of applicantDocsSources) {
      if (!src) continue;
      const itemsList = Array.isArray(src) ? src : [src];
      for (const item of itemsList) {
        var _item$additionalDetai;
        if (!item) continue;
        const itemNocName = (item === null || item === void 0 ? void 0 : item.nocName) || (item === null || item === void 0 ? void 0 : item.nocType) || (item === null || item === void 0 ? void 0 : item.department) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.title) || "";
        const itemMatchesDept = isDeptMatch(itemNocName);
        if (Array.isArray(item === null || item === void 0 ? void 0 : item.documents)) {
          for (const d of item.documents) {
            const _fid = getFid(d);
            if (_fid && isNoc(d)) {
              var _d$additionalDetails3, _d$additionalDetails4;
              const docType = (d === null || d === void 0 ? void 0 : d.documentType) || (d === null || d === void 0 ? void 0 : (_d$additionalDetails3 = d.additionalDetails) === null || _d$additionalDetails3 === void 0 ? void 0 : _d$additionalDetails3.title) || (d === null || d === void 0 ? void 0 : (_d$additionalDetails4 = d.additionalDetails) === null || _d$additionalDetails4 === void 0 ? void 0 : _d$additionalDetails4.fileName) || "";
              if (isDeptMatch(docType) || itemMatchesDept) {
                return _fid;
              }
            }
          }
          if (itemMatchesDept) {
            for (const d of item.documents) {
              const _fid2 = getFid(d);
              if (_fid2) return _fid2;
            }
          }
        }
        const fid = getFid(item);
        if (fid && isNoc(item)) {
          const docType = (item === null || item === void 0 ? void 0 : item.documentType) || itemNocName;
          if (isDeptMatch(docType) || itemMatchesDept) {
            return fid;
          }
        }
      }
    }
    for (const src of applicantDocsSources) {
      if (!src) continue;
      const itemsList = Array.isArray(src) ? src : [src];
      for (const item of itemsList) {
        if (item && Array.isArray(item.documents)) {
          for (const d of item.documents) {
            const fid = getFid(d);
            if (fid) {
              var _d$additionalDetails5;
              const docType = (d === null || d === void 0 ? void 0 : d.documentType) || (d === null || d === void 0 ? void 0 : (_d$additionalDetails5 = d.additionalDetails) === null || _d$additionalDetails5 === void 0 ? void 0 : _d$additionalDetails5.title) || "";
              if (isDeptMatch(docType)) {
                return fid;
              }
            }
          }
        }
      }
    }
    return null;
  };
  if (isLoading || isDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#f5f5f5",
      padding: "10px",
      borderRadius: "5px",
      color: "#333",
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Please note:"), " The NOCs selected by the officer will be considered the final required NOCs for approval. Make sure to review the list carefully.")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: "white",
      borderRadius: "4px",
      width: "150px",
      border: "1px solid #ccc",
      color: "#333"
    },
    type: "button",
    onClick: handleSelectAll
  }, isAllSelected ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CheckBoxIcon, {
    style: {
      marginRight: "8px"
    }
  }), "Unselect All") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CheckBoxOutlineBlankIcon, {
    style: {
      marginRight: "8px"
    }
  }), "Select All"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f0f0f0"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Sr. No."), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: allNocList.length > 0 ? "30%" : "55%"
    }
  }, "Department Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Required"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%"
    }
  }, "Request Letter"), allNocList.length > 0 && /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%"
    }
  }, "View NOC"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Uploaded NOC"))), /*#__PURE__*/React__default.createElement("tbody", null, (departments || []).map((dept, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: dept.code
  }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, dept.name, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: dept.message,
    arrow: true
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `departments.${dept.code}`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
      checked: !!field.value,
      color: "primary",
      onChange: e => field.onChange(e.target.checked),
      sx: {
        padding: "0"
      }
    }))
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (() => {
    const nocItem = findNocForDepartment(dept);
    const reqUrl = getRequestLetterUrl(nocItem);
    return reqUrl ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: () => handleOpenRequestLetter(reqUrl),
      sx: {
        fontSize: "12px",
        minWidth: "60px"
      }
    }, "View") : "-";
  })()), allNocList.length > 0 && /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (() => {
    const nocItem = findNocForDepartment(dept);
    const status = nocItem === null || nocItem === void 0 ? void 0 : nocItem.applicationStatus;
    const isApproved = status === "NOC_APPROVED";
    const url = (nocItem === null || nocItem === void 0 ? void 0 : nocItem.nocApprovedLetterUrl) || (nocItem === null || nocItem === void 0 ? void 0 : nocItem.nocDeemedLetterUrl);
    console.log({
      nocItem,
      isApproved,
      url
    });
    return isApproved && url ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: () => handleOpenDoc(url),
      sx: {
        fontSize: "12px",
        minWidth: "60px"
      }
    }, "View") : "-";
  })()), /*#__PURE__*/React__default.createElement("td", null, (() => {
    const fileStoreId = getUploadedNocDoc(dept);
    if (fileStoreId) {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "26px",
          cursor: "pointer"
        },
        onClick: () => getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading),
        title: "View NOC Document"
      }), /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        variant: "contained",
        color: "primary",
        onClick: () => getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading),
        sx: {
          fontSize: "12px",
          minWidth: "50px"
        }
      }, "View"));
    }
    return "-";
  })()))), showNoDepartments && (noDepartments || []).map((dept, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: dept.code
  }, /*#__PURE__*/React__default.createElement("td", null, departments.length + index + 1), /*#__PURE__*/React__default.createElement("td", null, dept.name, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: dept.message,
    arrow: true
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `departments.${dept.code}`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
      checked: !!field.value,
      color: "primary",
      onChange: e => field.onChange(e.target.checked),
      sx: {
        padding: "0"
      }
    }))
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (() => {
    const nocItem = findNocForDepartment(dept);
    const reqUrl = getRequestLetterUrl(nocItem);
    return reqUrl ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: () => handleOpenRequestLetter(reqUrl),
      sx: {
        fontSize: "12px",
        minWidth: "60px"
      }
    }, "View") : "-";
  })()), allNocList.length > 0 && /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (() => {
    const nocItem = findNocForDepartment(dept);
    const status = (nocItem === null || nocItem === void 0 ? void 0 : nocItem.applicationStatus) || (nocItem === null || nocItem === void 0 ? void 0 : nocItem.applicationstatus);
    const isApproved = status === "NOC_APPROVED";
    const url = nocItem === null || nocItem === void 0 ? void 0 : nocItem.nocApprovedLetterUrl;
    return isApproved && url ? /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "outlined",
      size: "small",
      onClick: () => handleOpenDoc(url)
    }, "View") : "-";
  })())))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 16,
      display: "flex",
      justifyContent: "center",
      gap: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      borderRadius: "4px"
    },
    disabled: isSubmitted
  }, "Update & Save"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      borderRadius: "4px"
    },
    onClick: handleAddNOC
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    style: {
      marginRight: "8px"
    }
  }), " Add NOC")), iframeSrc && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Request Letter",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
      setIframeSrc("");
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "iframe-container"
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: iframeSrc,
    title: "Request Letter Viewer"
  }))));
};

const PurchasableFARInfo = ({
  formData,
  handleTabChange,
  isEmployee,
  handleNoWorkflowPFAR,
  isJE,
  handleGetSiteInspectionById,
  workflowHistory,
  handleGenerateIntimationLetter,
  isLoadingLetter,
  handleViewIntimationLetter
}) => {
  var _userInfo$info, _userInfo$info$roles, _userInfo$info2, _userInfo$info2$roles, _workflowHistory$time, _workflowHistory$time2, _workflowHistory$time3, _workflowHistory$time4, _formData$inspectionD, _formData$pFAR, _formData$pFAR2, _formData$pFAR3, _formData$pFAR4, _formData$pFAR4$purch, _formData$Purchasable, _formData$Purchasable2, _formData$pFAR5, _formData$pFAR5$purch, _formData$Purchasable3, _formData$Purchasable4, _formData$pFAR6, _formData$pFAR6$premi, _formData$pFAR7, _formData$pFAR7$premi, _formData$inspectionD3, _formData$pFAR15, _formData$pFAR16, _formData$pFAR17, _formData$pFAR18, _formData$pFAR18$purc, _formData$Purchasable9, _formData$Purchasable10, _formData$pFAR19, _formData$pFAR19$prem, _formData$pFAR20, _formData$pFAR20$purc, _formData$Purchasable11, _formData$Purchasable12, _formData$pFAR21, _formData$pFAR21$prem;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const isCTP = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.some(role => role.code === "CTP");
  const isVC = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : (_userInfo$info2$roles = _userInfo$info2.roles) === null || _userInfo$info2$roles === void 0 ? void 0 : _userInfo$info2$roles.some(role => role.code === "Vice_Chairman");
  const isVCChosen = (formData === null || formData === void 0 ? void 0 : formData.vcChosen) || false;
  const isApprovalUIShow = isCTP && isVCChosen;
  const jeDoneBy = (workflowHistory === null || workflowHistory === void 0 ? void 0 : (_workflowHistory$time = workflowHistory.timeline) === null || _workflowHistory$time === void 0 ? void 0 : (_workflowHistory$time2 = _workflowHistory$time.find(item => (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_JE")) === null || _workflowHistory$time2 === void 0 ? void 0 : (_workflowHistory$time3 = _workflowHistory$time2.assignes) === null || _workflowHistory$time3 === void 0 ? void 0 : (_workflowHistory$time4 = _workflowHistory$time3[0]) === null || _workflowHistory$time4 === void 0 ? void 0 : _workflowHistory$time4.name) || "";
  console.log(workflowHistory, jeDoneBy, "wwwwww");
  const defaultValues = {
    plotLeaseHold: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    letterFrom: (formData === null || formData === void 0 ? void 0 : formData.letterFrom) || "Committee In-Charge",
    letterTo: (formData === null || formData === void 0 ? void 0 : formData.letterTo) || `Chief Engineer, PWD\nChief Engineer, Jal Nigam\nDistrict Magistrate\nChief Town and Country Planner\nChief Fire Officer, Fire Department`,
    pFARDate: formData === null || formData === void 0 ? void 0 : formData.pFARDate,
    pFARTime: formData !== null && formData !== void 0 && formData.pFARTime ? dayjs(formData === null || formData === void 0 ? void 0 : formData.pFARTime, "HH:mm:ss").isValid() ? dayjs(formData.pFARTime, "HH:mm:ss") : null : null,
    basicFAR: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
    purchasableFAR: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    premiumFAR: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
    locationZone: formData === null || formData === void 0 ? void 0 : formData.locationZone,
    pFAR: {
      siteInspectionDate: (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD = formData.inspectionDetailData) === null || _formData$inspectionD === void 0 ? void 0 : _formData$inspectionD.siteInspecionDateArea) || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR = formData.pFAR) === null || _formData$pFAR === void 0 ? void 0 : _formData$pFAR.siteInspectionDate),
      doneBy: jeDoneBy || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR2 = formData.pFAR) === null || _formData$pFAR2 === void 0 ? void 0 : _formData$pFAR2.doneBy),
      technicalCommitteeDate: formData === null || formData === void 0 ? void 0 : (_formData$pFAR3 = formData.pFAR) === null || _formData$pFAR3 === void 0 ? void 0 : _formData$pFAR3.technicalCommitteeDate,
      purchasable: {
        permittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR4 = formData.pFAR) === null || _formData$pFAR4 === void 0 ? void 0 : (_formData$pFAR4$purch = _formData$pFAR4.purchasable) === null || _formData$pFAR4$purch === void 0 ? void 0 : _formData$pFAR4$purch.permittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable = formData.Purchasable) === null || _formData$Purchasable === void 0 ? void 0 : _formData$Purchasable.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable2 = formData.Purchasable) === null || _formData$Purchasable2 === void 0 ? void 0 : _formData$Purchasable2.permittedFactor) || "",
        cost: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR5 = formData.pFAR) === null || _formData$pFAR5 === void 0 ? void 0 : (_formData$pFAR5$purch = _formData$pFAR5.purchasable) === null || _formData$pFAR5$purch === void 0 ? void 0 : _formData$pFAR5$purch.cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable3 = formData.Purchasable) === null || _formData$Purchasable3 === void 0 ? void 0 : _formData$Purchasable3.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable4 = formData.Purchasable) === null || _formData$Purchasable4 === void 0 ? void 0 : _formData$Purchasable4.cost) || ""
      },
      premiumPFAR: {
        permittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR6 = formData.pFAR) === null || _formData$pFAR6 === void 0 ? void 0 : (_formData$pFAR6$premi = _formData$pFAR6.premiumPFAR) === null || _formData$pFAR6$premi === void 0 ? void 0 : _formData$pFAR6$premi.permittedFactor) || "",
        cost: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR7 = formData.pFAR) === null || _formData$pFAR7 === void 0 ? void 0 : (_formData$pFAR7$premi = _formData$pFAR7.premiumPFAR) === null || _formData$pFAR7$premi === void 0 ? void 0 : _formData$pFAR7$premi.cost) || ""
      }
    }
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    if (formData) {
      var _formData$inspectionD2, _formData$pFAR8, _formData$pFAR9, _formData$pFAR10, _formData$pFAR11, _formData$pFAR11$purc, _formData$Purchasable5, _formData$Purchasable6, _formData$pFAR12, _formData$pFAR12$purc, _formData$Purchasable7, _formData$Purchasable8, _formData$pFAR13, _formData$pFAR13$prem, _formData$pFAR14, _formData$pFAR14$prem;
      reset({
        ...getValues(),
        plotLeaseHold: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
        letterFrom: (formData === null || formData === void 0 ? void 0 : formData.letterFrom) || "Committee In-Charge",
        letterTo: (formData === null || formData === void 0 ? void 0 : formData.letterTo) || `Chief Engineer, PWD\nChief Engineer, Jal Nigam\nDistrict Magistrate\nChief Town and Country Planner\nChief Fire Officer, Fire Department`,
        pFARDate: formData === null || formData === void 0 ? void 0 : formData.pFARDate,
        pFARTime: formData !== null && formData !== void 0 && formData.pFARTime ? dayjs(formData === null || formData === void 0 ? void 0 : formData.pFARTime, "HH:mm:ss").isValid() ? dayjs(formData.pFARTime, "HH:mm:ss") : null : null,
        basicFAR: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
        purchasableFAR: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
        premiumFAR: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
        locationZone: formData === null || formData === void 0 ? void 0 : formData.locationZone,
        pFAR: {
          siteInspectionDate: (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD2 = formData.inspectionDetailData) === null || _formData$inspectionD2 === void 0 ? void 0 : _formData$inspectionD2.siteInspecionDateArea) || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR8 = formData.pFAR) === null || _formData$pFAR8 === void 0 ? void 0 : _formData$pFAR8.siteInspectionDate),
          doneBy: jeDoneBy || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR9 = formData.pFAR) === null || _formData$pFAR9 === void 0 ? void 0 : _formData$pFAR9.doneBy),
          technicalCommitteeDate: formData === null || formData === void 0 ? void 0 : (_formData$pFAR10 = formData.pFAR) === null || _formData$pFAR10 === void 0 ? void 0 : _formData$pFAR10.technicalCommitteeDate,
          purchasable: {
            permittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR11 = formData.pFAR) === null || _formData$pFAR11 === void 0 ? void 0 : (_formData$pFAR11$purc = _formData$pFAR11.purchasable) === null || _formData$pFAR11$purc === void 0 ? void 0 : _formData$pFAR11$purc.permittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable5 = formData.Purchasable) === null || _formData$Purchasable5 === void 0 ? void 0 : _formData$Purchasable5.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable6 = formData.Purchasable) === null || _formData$Purchasable6 === void 0 ? void 0 : _formData$Purchasable6.permittedFactor) || "",
            cost: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR12 = formData.pFAR) === null || _formData$pFAR12 === void 0 ? void 0 : (_formData$pFAR12$purc = _formData$pFAR12.purchasable) === null || _formData$pFAR12$purc === void 0 ? void 0 : _formData$pFAR12$purc.cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable7 = formData.Purchasable) === null || _formData$Purchasable7 === void 0 ? void 0 : _formData$Purchasable7.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable8 = formData.Purchasable) === null || _formData$Purchasable8 === void 0 ? void 0 : _formData$Purchasable8.cost) || ""
          },
          premiumPFAR: {
            permittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR13 = formData.pFAR) === null || _formData$pFAR13 === void 0 ? void 0 : (_formData$pFAR13$prem = _formData$pFAR13.premiumPFAR) === null || _formData$pFAR13$prem === void 0 ? void 0 : _formData$pFAR13$prem.permittedFactor) || "",
            cost: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR14 = formData.pFAR) === null || _formData$pFAR14 === void 0 ? void 0 : (_formData$pFAR14$prem = _formData$pFAR14.premiumPFAR) === null || _formData$pFAR14$prem === void 0 ? void 0 : _formData$pFAR14$prem.cost) || ""
          }
        }
      });
    }
  }, [formData, jeDoneBy]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    if (jeDoneBy) {
      setValue("pFAR.doneBy", jeDoneBy);
    }
  }, [jeDoneBy]);
  const onSubmit = data => {
    var _data$pFAR, _data$pFAR$purchasabl, _data$pFAR2, _data$pFAR2$purchasab, _data$pFAR3, _data$pFAR3$premiumPF, _data$pFAR4, _data$pFAR4$premiumPF;
    console.log(data, "submittedData");
    data.pFARTime = data !== null && data !== void 0 && data.pFARTime ? dayjs(data.pFARTime).isValid() ? dayjs(data.pFARTime).format("HH:mm:ss") : data.pFARTime : data === null || data === void 0 ? void 0 : data.pFARTime;
    if (isVC) {
      data.vcChosen = true;
    }
    data.pFAR = {
      purchasable: {
        permittedFactor: (data === null || data === void 0 ? void 0 : (_data$pFAR = data.pFAR) === null || _data$pFAR === void 0 ? void 0 : (_data$pFAR$purchasabl = _data$pFAR.purchasable) === null || _data$pFAR$purchasabl === void 0 ? void 0 : _data$pFAR$purchasabl.permittedFactor) || "",
        cost: (data === null || data === void 0 ? void 0 : (_data$pFAR2 = data.pFAR) === null || _data$pFAR2 === void 0 ? void 0 : (_data$pFAR2$purchasab = _data$pFAR2.purchasable) === null || _data$pFAR2$purchasab === void 0 ? void 0 : _data$pFAR2$purchasab.cost) || ""
      },
      premiumPFAR: {
        permittedFactor: (data === null || data === void 0 ? void 0 : (_data$pFAR3 = data.pFAR) === null || _data$pFAR3 === void 0 ? void 0 : (_data$pFAR3$premiumPF = _data$pFAR3.premiumPFAR) === null || _data$pFAR3$premiumPF === void 0 ? void 0 : _data$pFAR3$premiumPF.permittedFactor) || "",
        cost: (data === null || data === void 0 ? void 0 : (_data$pFAR4 = data.pFAR) === null || _data$pFAR4 === void 0 ? void 0 : (_data$pFAR4$premiumPF = _data$pFAR4.premiumPFAR) === null || _data$pFAR4$premiumPF === void 0 ? void 0 : _data$pFAR4$premiumPF.cost) || ""
      }
    };
    handleNoWorkflowPFAR(data);
  };
  const isFormSaved = !!(formData !== null && formData !== void 0 && formData.purchasableFAR) && !!(formData !== null && formData !== void 0 && formData.basicFAR);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Purchasable FAR"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Purchasable FAR"),
    control: control,
    name: "purchasableFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    type: "textInput",
    placeholder: t("Enter Purchasable FAR")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basic FAR"),
    control: control,
    name: "basicFAR",
    mandatory: true,
    placeholder: t("Enter Basic FAR"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Premium FAR"),
    control: control,
    name: "premiumFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
    type: "textInput",
    placeholder: t("Enter Premium FAR")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Location"),
    placeholder: t("Enter Location"),
    control: control,
    name: "locationZone",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.locationZone,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "letterFrom",
    control: control,
    rules: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    render: ({
      field,
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      label: "From",
      placeholder: "Enter details here",
      fullWidth: true,
      required: true,
      multiline: true,
      rows: 4,
      error: !!error,
      helperText: error ? error.message : ""
    }))
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "letterTo",
    control: control,
    rules: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    render: ({
      field,
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      label: "To",
      placeholder: "Enter details here",
      fullWidth: true,
      required: true,
      multiline: true,
      rows: 4,
      error: !!error,
      helperText: error ? error.message : ""
    }))
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Select Date"),
    control: control,
    placeholder: t("Select date"),
    name: "pFARDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.pFARDate,
    type: "datePicker"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Time"),
    control: control,
    placeholder: t("Select time"),
    name: "pFARTime",
    type: "timePicker"
  }))), isApprovalUIShow && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Site Inspection Date"),
    control: control,
    placeholder: t("Select date"),
    name: "pFAR.siteInspectionDate",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$inspectionD3 = formData.inspectionDetailData) === null || _formData$inspectionD3 === void 0 ? void 0 : _formData$inspectionD3.siteInspecionDateArea) || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR15 = formData.pFAR) === null || _formData$pFAR15 === void 0 ? void 0 : _formData$pFAR15.siteInspectionDate),
    type: "datePicker"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Done By"),
    placeholder: t("Done By"),
    control: control,
    name: "pFAR.doneBy",
    mandatory: true,
    defaultValue: jeDoneBy || (formData === null || formData === void 0 ? void 0 : (_formData$pFAR16 = formData.pFAR) === null || _formData$pFAR16 === void 0 ? void 0 : _formData$pFAR16.doneBy),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), isApprovalUIShow && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Date of Technical Committee Meeting"),
    control: control,
    placeholder: t("Select date"),
    name: "pFAR.technicalCommitteeDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$pFAR17 = formData.pFAR) === null || _formData$pFAR17 === void 0 ? void 0 : _formData$pFAR17.technicalCommitteeDate,
    type: "datePicker"
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Accordion, {
    sx: {
      width: "100%",
      marginTop: "8px 0px 8px 0px"
    },
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("PFAR Detail")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      mt: 2,
      mb: 2,
      borderRadius: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: "bold",
      fontSize: "16px"
    }
  }, "Purchasable FAR Charges"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: "bold",
      fontSize: "16px"
    }
  }, "Premium Purchasable FAR Charges"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: true,
    label: "Permitted Factor",
    name: "pFAR.purchasable.permittedFactor",
    control: control,
    type: "textInput",
    placeholder: "Enter Permitted Factor",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR18 = formData.pFAR) === null || _formData$pFAR18 === void 0 ? void 0 : (_formData$pFAR18$purc = _formData$pFAR18.purchasable) === null || _formData$pFAR18$purc === void 0 ? void 0 : _formData$pFAR18$purc.permittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable9 = formData.Purchasable) === null || _formData$Purchasable9 === void 0 ? void 0 : _formData$Purchasable9.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable10 = formData.Purchasable) === null || _formData$Purchasable10 === void 0 ? void 0 : _formData$Purchasable10.permittedFactor) || ""
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: true,
    label: "Permitted Factor",
    name: "pFAR.premiumPFAR.permittedFactor",
    control: control,
    type: "textInput",
    placeholder: "Enter Permitted Factor",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR19 = formData.pFAR) === null || _formData$pFAR19 === void 0 ? void 0 : (_formData$pFAR19$prem = _formData$pFAR19.premiumPFAR) === null || _formData$pFAR19$prem === void 0 ? void 0 : _formData$pFAR19$prem.permittedFactor) || ""
  }))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: true,
    label: "Cost (in Rs.)",
    name: "pFAR.purchasable.cost",
    control: control,
    type: "textInput",
    placeholder: "Enter Cost",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR20 = formData.pFAR) === null || _formData$pFAR20 === void 0 ? void 0 : (_formData$pFAR20$purc = _formData$pFAR20.purchasable) === null || _formData$pFAR20$purc === void 0 ? void 0 : _formData$pFAR20$purc.cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable11 = formData.Purchasable) === null || _formData$Purchasable11 === void 0 ? void 0 : _formData$Purchasable11.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable12 = formData.Purchasable) === null || _formData$Purchasable12 === void 0 ? void 0 : _formData$Purchasable12.cost) || ""
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: true,
    label: "Cost (in Rs.)",
    name: "pFAR.premiumPFAR.cost",
    control: control,
    type: "textInput",
    placeholder: "Enter Cost",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pFAR21 = formData.pFAR) === null || _formData$pFAR21 === void 0 ? void 0 : (_formData$pFAR21$prem = _formData$pFAR21.premiumPFAR) === null || _formData$pFAR21$prem === void 0 ? void 0 : _formData$pFAR21$prem.cost) || ""
  })))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    name: "committeeResponse",
    label: "Committee Response",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement(Col, null, isCTP && /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-center justify-content-end mb-2",
    style: {
      gap: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-sm",
    style: {
      backgroundColor: isLoadingLetter || !isFormSaved ? "#ccc" : "#157C4F",
      color: "white",
      cursor: isLoadingLetter || !isFormSaved ? "not-allowed" : "pointer"
    },
    onClick: handleGenerateIntimationLetter,
    disabled: isLoadingLetter || !isFormSaved,
    title: !isFormSaved ? "Please fill and save the form first" : ""
  }, isLoadingLetter ? "GENERATING..." : "GENERATE INTIMATION LETTER"), (formData === null || formData === void 0 ? void 0 : formData.farInimationLetterUrl) && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-sm btn-primary",
    style: {
      backgroundColor: "#1F4A7C"
    },
    onClick: handleViewIntimationLetter || (() => window.open(formData === null || formData === void 0 ? void 0 : formData.farInimationLetterUrl, "_blank"))
  }, "VIEW INTIMATION LETTER")))), /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#f5f5f5",
      padding: "10px",
      borderRadius: "5px",
      color: "#333",
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Note:"), " User can fill PFAR detail once committee response is finalized.")))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const CompoundingChecklist = ({
  formData,
  handleTabChange,
  role,
  isEmployee
}) => {
  const [errorMsg, setErrorMsg] = useState("");
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    data: {
      BPA: {
        CompoundingData
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["CompoundingData"]);
  const {
    control,
    handleSubmit,
    reset
  } = useForm({
    defaultValues: formData || {}
  });
  const Modal = useModal();
  const onSubmit = data => {
    setErrorMsg("");
    let hasError = false;
    CompoundingData === null || CompoundingData === void 0 ? void 0 : CompoundingData.forEach(item => {
      var _data$compoundingChec;
      const selectedValue = data === null || data === void 0 ? void 0 : (_data$compoundingChec = data.compoundingChecklist) === null || _data$compoundingChec === void 0 ? void 0 : _data$compoundingChec[item.code];
      if (item.showError && item.showError.toLowerCase() === "yes" && selectedValue && selectedValue.toLowerCase() === "yes") {
        hasError = true;
        Modal("Submission not allowed", `For "<b>${item.question}</b>", selecting <b>"Yes"</b> is not allowed. Please select the correct value before proceeding.`, "error");
      }
    });
    if (hasError) return;
    handleTabChange(3, data);
  };
  useEffect(() => {
    reset({
      ...formData,
      documents: documents !== null && documents !== void 0 && documents.length ? documents : (formData === null || formData === void 0 ? void 0 : formData.documents) || []
    });
  }, [formData, documents, reset]);
  console.log("CompoundingChecklist formData", formData);
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f0f0f0"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "70%"
    }
  }, "Checklist"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "30%",
      textAlign: "center"
    }
  }, "Yes / No"))), /*#__PURE__*/React__default.createElement("tbody", null, CompoundingData === null || CompoundingData === void 0 ? void 0 : CompoundingData.map(item => {
    var _formData$compounding, _formData$compounding2;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.code
    }, /*#__PURE__*/React__default.createElement("td", null, item.question, /*#__PURE__*/React__default.createElement("span", {
      style: {
        color: "red",
        marginLeft: "3px",
        fontWeight: "bold"
      }
    }, "*")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, isEmployee ? /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, (formData === null || formData === void 0 ? void 0 : (_formData$compounding = formData.compoundingChecklist) === null || _formData$compounding === void 0 ? void 0 : _formData$compounding[item.code]) || "-") : /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      label: "",
      hasLabel: false,
      name: `compoundingChecklist.${item.code}`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$compounding2 = formData.compoundingChecklist) === null || _formData$compounding2 === void 0 ? void 0 : _formData$compounding2[item.code],
      type: "radioButton",
      data: item.code === "disabledAccessNonCompliance" ? yesNoNA2 : yesOrNo,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })));
  })))), !isEmployee && errorMsg && /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "red",
      margin: "1rem 0",
      textAlign: "center"
    }
  }, errorMsg), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    is: true,
    sx: {
      backgroundColor: "#157CB3"
    }
  }))));
};

const SubStep6 = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  t,
  landSubUseTypes,
  landUseListActivities,
  landUsesSchemeTypeList,
  landSubUseTypes2,
  tenantId,
  departmentList,
  avpList,
  applicationFlow,
  avpData,
  isEmployee,
  isApproved
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$professiona, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description26, _formData$description27, _formData$mapSubDetai;
  console.log("FORMDATASASSAAS", formData, isEmployee, isApproved);
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.plotAreaSite);
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation,
      schemeType: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "",
      roadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.roadWidths) || [{
        value: ""
      }],
      approachRoadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.approachRoadWidths) || [{
        value: ""
      }],
      otherSides: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.otherSides) || [{
        value: ""
      }],
      multipleKhata: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.multipleKhata) || [{
        value: ""
      }],
      khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.khasraDetails) || [{
        district: "",
        tehsil: "",
        village: "",
        plotNo: ""
      }],
      multipleKhasra: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.multipleKhasra) || [{
        khasraNo: "",
        area: ""
      }]
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const handleCoordinateChange = (field, value) => {
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const {
    fields: multipleKhasra,
    append: addKhasra,
    remove: removeKhasra
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra"
  });
  const {
    fields: roadWidthsArray,
    append: addRoadWidthField,
    remove: removeRoadWidthField
  } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths"
  });
  const {
    fields: otherSides,
    append: addOtherSide,
    remove: removeOtherSide
  } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides"
  });
  const {
    fields: approachRoadWidths,
    append: addApproachRoad,
    remove: removeApproachWidth
  } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths"
  });
  const {
    fields: multipleKhata,
    append: addKhata,
    remove: removeKhata
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata"
  });
  const {
    fields: khasraDetails,
    append: addKhasraDetail,
    remove: removeKhasraDetail
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const watchMaster = watch("descriptionOfLand.landUsesType");
  const watchActivityAsPerMap = watch("descriptionOfLand.activityAsPerMap");
  const watchSubLayout = watch("descriptionOfLand.subLandUseAsPerLayout");
  const watchPlanOn = watch("descriptionOfLand.planOn");
  const watchGovernmentBuilding = watch("isGovernmentBuilding");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${formData === null || formData === void 0 ? void 0 : formData.selectedOffice}")]`
  }]);
  const {
    data: {
      BPA: {
        LandUseAvpVillageMasterData: avpVillagesData
      } = {}
    } = {},
    isLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseAvpVillageMasterData",
    filter: `$..Districts[?(@.District=='${formData === null || formData === void 0 ? void 0 : formData.selectedCity}')]`
  }]);
  useEffect(() => {
    if (formData && formData !== null && formData !== void 0 && formData.zoneType) {
      var _formData$description11;
      setValue("descriptionOfLand.landUsesType", (formData === null || formData === void 0 ? void 0 : formData.zoneType) || (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.landUsesType));
    }
    if (formData && formData !== null && formData !== void 0 && formData.subZoneType) {
      var _formData$description12;
      setValue("descriptionOfLand.subLandUseAsPerLayout", (formData === null || formData === void 0 ? void 0 : formData.subZoneType) || (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.subLandUseAsPerLayout));
    }
    if (formData && formData !== null && formData !== void 0 && formData.primaryUse) {
      var _formData$description13;
      setValue("descriptionOfLand.activityAsPerMap", (formData === null || formData === void 0 ? void 0 : formData.primaryUse) || (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap));
    }
    if (formData && formData !== null && formData !== void 0 && formData.activityProposed) {
      var _formData$description14;
      setValue("descriptionOfLand.activityProposed", (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityProposed));
    }
  }, [formData]);
  console.log("loggingVillagesData", villagesData, avpVillagesData);
  console.log("departmentListFrom444", schemeTypeData, nonSchemeTypeData);
  const filterTehsilData = (masterData, authority, district) => {
    var _masterData$find, _masterData$find$Dist, _masterData$find$Dist2, _masterData$find$Dist3;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$Dist = _masterData$find.Districts) === null || _masterData$find$Dist === void 0 ? void 0 : (_masterData$find$Dist2 = _masterData$find$Dist.find(item => item.District === district)) === null || _masterData$find$Dist2 === void 0 ? void 0 : (_masterData$find$Dist3 = _masterData$find$Dist2.tehsils) === null || _masterData$find$Dist3 === void 0 ? void 0 : _masterData$find$Dist3.map(item => {
      return {
        name: item.tehsilName,
        label: item.tehsilName,
        value: item.tehsilName
      };
    }) : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterAvpTehsilData = (masterData, district) => {
    var _masterData$find2, _masterData$find2$teh;
    const tehsilArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => item.District === district)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : _masterData$find2$teh.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    return tehsilArray || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    var _masterData$find3, _masterData$find3$Dis, _masterData$find3$Dis2, _masterData$find3$Dis3, _masterData$find3$Dis4, _masterData$find3$Dis5;
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = str => str === null || str === void 0 ? void 0 : str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    const result = tehsil && district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : (_masterData$find3$Dis2 = _masterData$find3$Dis.find(item => (item === null || item === void 0 ? void 0 : item.District) === district)) === null || _masterData$find3$Dis2 === void 0 ? void 0 : (_masterData$find3$Dis3 = _masterData$find3$Dis2.tehsils) === null || _masterData$find3$Dis3 === void 0 ? void 0 : (_masterData$find3$Dis4 = _masterData$find3$Dis3.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find3$Dis4 === void 0 ? void 0 : (_masterData$find3$Dis5 = _masterData$find3$Dis4.villages) === null || _masterData$find3$Dis5 === void 0 ? void 0 : _masterData$find3$Dis5.map(item => {
      const formatted = toTitleCase(item);
      return {
        name: formatted,
        value: formatted,
        label: formatted
      };
    }) : null;
    return result || [];
  };
  const filterAvpVillagesData = (masterData, district, tehsil) => {
    var _masterData$find4, _masterData$find4$teh, _masterData$find4$teh2, _masterData$find4$teh3, _masterData$find4$teh4;
    const villagesArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find4 = masterData.find(item => item.District === district)) === null || _masterData$find4 === void 0 ? void 0 : (_masterData$find4$teh = _masterData$find4.tehsils) === null || _masterData$find4$teh === void 0 ? void 0 : (_masterData$find4$teh2 = _masterData$find4$teh.find(item => item.tehsilName === tehsil)) === null || _masterData$find4$teh2 === void 0 ? void 0 : (_masterData$find4$teh3 = _masterData$find4$teh2.villages) === null || _masterData$find4$teh3 === void 0 ? void 0 : (_masterData$find4$teh4 = _masterData$find4$teh3.map) === null || _masterData$find4$teh4 === void 0 ? void 0 : _masterData$find4$teh4.call(_masterData$find4$teh3, item => ({
      name: item,
      label: item,
      value: item
    }));
    return villagesArray;
  };
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find5, _masterData$find5$Dis;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find5 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find5 === void 0 ? void 0 : (_masterData$find5$Dis = _masterData$find5.Districts) === null || _masterData$find5$Dis === void 0 ? void 0 : _masterData$find5$Dis.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const filterAvpDistrictData = (masterData, city) => {
    console.log("avpdistrictTriggered", city);
    const district = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.District === city);
    if (!district) return [];
    console.log("districtfromavp", [{
      name: district.District,
      label: district.District,
      value: district.District
    }]);
    return [{
      name: district.District,
      label: district.District,
      value: district.District
    }];
  };
  const isSchemeType = watchSchemeType === "Scheme";
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  console.log("upDIstricts", updistricts);
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : _masterData$2$Categor4.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", schemeTypeData, watchMaster, watchSubLayout);
  const plotNo = watch("descriptionOfLand.plotNo");
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(formData === null || formData === void 0 ? void 0 : formData.selectedOffice, nonSchemeTypeData, watchActivityAsPerMap);
  console.log("activityAsPerMap", activityAsPerMap);
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData === null || masterData === void 0 ? void 0 : masterData.filter(item => item.Name === department).map(item => item === null || item === void 0 ? void 0 : item.ColonyGroups).flat().filter(item => (item === null || item === void 0 ? void 0 : item.ColonyType) === planOn).map(item => item === null || item === void 0 ? void 0 : item.Colonies).flat().map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("schemeFilteredData", schemeNameList);
    return schemeNameList;
  };
  const schemeNames = filterSchemeNames(departmentList, formData === null || formData === void 0 ? void 0 : formData.selectedOffice, watchPlanOn);
  const filterAvpSchemeNames = (unit, city, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C, _masterData$filter$$C2, _masterData$filter$$C3, _masterData$filter$$C4;
    console.log("avpMasterFrom4", masterData, unit, city);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : (_masterData$filter$$C2 = _masterData$filter$$C.filter(item => item.City === city)) === null || _masterData$filter$$C2 === void 0 ? void 0 : (_masterData$filter$$C3 = _masterData$filter$$C2[0]) === null || _masterData$filter$$C3 === void 0 ? void 0 : (_masterData$filter$$C4 = _masterData$filter$$C3.Schemes) === null || _masterData$filter$$C4 === void 0 ? void 0 : _masterData$filter$$C4.map(item => {
      return {
        name: item.SchemeName,
        label: item.SchemeName,
        value: item.SchemeName
      };
    });
    console.log("loggingAVPSchemeNames", result);
    return result;
  };
  const avpSchemeNames = filterAvpSchemeNames(formData === null || formData === void 0 ? void 0 : formData.selectedUnit, formData === null || formData === void 0 ? void 0 : formData.selectedCity, avpData);
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["kmlFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const onSubmit = data => {
    const isCompounding = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_COMPOUNDING";
    const isValid = isCompounding ? true : validateFiles();
    console.log("insideFormSubmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    var _formData$description15;
    if (formData !== null && formData !== void 0 && (_formData$description15 = formData.descriptionOfLand) !== null && _formData$description15 !== void 0 && _formData$description15.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
    }
    setValue("documents", documents);
    if (isDA && formData !== null && formData !== void 0 && formData.location1 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    } else if (formData !== null && formData !== void 0 && formData.selectedCity) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.selectedCity);
      });
      setValue("landInfo.owners[0].permanentAddress.district", formData.selectedCity);
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  const handleOpenPdf = pdfUrl => {
    window.open(pdfUrl, "_blank");
  };
  const isOwner = (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) === "Owner";
  const filteredSchemeTypeList = isOwner ? schemeTypeList.filter(item => item.value === "Non Scheme") : schemeTypeList;
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.schemeType,
    data: SortingAlphabatically(filteredSchemeTypeList),
    disabled: isEmployee || isApproved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 0px",
      fontWeight: "600",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      textAlign: "right",
      color: "rgb(2, 11, 15)",
      padding: "9px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "clickHere",
    onClick: handleClick
  }, "Click here,"), "\xA0to know how to create a .kml file.")))), isSchemeType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 4px",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      backgroundColor: "#f2f2f2",
      color: "red",
      padding: "4px"
    }
  }, "Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission."))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Type of Scheme",
    placeholder: "Select type of scheme",
    name: `descriptionOfLand.planOn`,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: SortingAlphabatically(proposedSite),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.planOn,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.schemeName,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan",
    inputLabel: "Select a plan.",
    placeholder: isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan",
    name: "descriptionOfLand.landUsesType",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    data: SortingAlphabatically(landUseList)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan",
    control: control,
    placeholder: isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan",
    name: "descriptionOfLand.subLandUseAsPerLayout",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(landSubUseList),
    disabled: isEmployee || isApproved,
    mandatory: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "descriptionOfLand.activityAsPerMap",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Activity Proposed"),
    control: control,
    placeholder: t("Select Activity Proposed"),
    name: "descriptionOfLand.activityProposed",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(activityProposed),
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 20,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.constructionType,
    type: "searchSelect"
  })), /*#__PURE__*/React__default.createElement(Col, null)), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraDetails.map((item, index) => {
    var _khasraTehsils$index, _khasraTehsils$index2, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25;
    const selectedTehsil = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index = khasraTehsils[index]) === null || _khasraTehsils$index === void 0 ? void 0 : _khasraTehsils$index.tehsil;
    const selectedDistrict = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index2 = khasraTehsils[index]) === null || _khasraTehsils$index2 === void 0 ? void 0 : _khasraTehsils$index2.district;
    const filteredVillages = isDA ? filterVillagesData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict, selectedTehsil) : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
    const tehsils = isDA ? filterTehsilData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict) : filterAvpTehsilData(avpVillagesData, selectedDistrict);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(isDA ? filterDistrictData(villagesData, formData === null || formData === void 0 ? void 0 : formData.selectedOffice) : filterAvpDistrictData(avpVillagesData, formData === null || formData === void 0 ? void 0 : formData.selectedCity)),
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      defaultValue: isDA ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.selectedCity,
      disabled: isEmployee || isApproved,
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(tehsils),
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : (_formData$description21 = _formData$description20.khasraDetails) === null || _formData$description21 === void 0 ? void 0 : (_formData$description22 = _formData$description21[index]) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.tehsil,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filteredVillages),
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : (_formData$description24 = _formData$description23.khasraDetails) === null || _formData$description24 === void 0 ? void 0 : (_formData$description25 = _formData$description24[index]) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.village,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      maxLength: 30,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "textInput",
      allowedChars: "/,-",
      maxLength: 200,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => removeKhasraDetail(index),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === khasraDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => addKhasraDetail({
        plotNo: "",
        district: "",
        tehsil: "",
        village: ""
      }),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  }))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "District",
    control: control,
    data: SortingAlphabatically(isDA ? filterDistrictData(villagesData, formData === null || formData === void 0 ? void 0 : formData.selectedOffice) : filterAvpDistrictData(avpVillagesData, formData === null || formData === void 0 ? void 0 : formData.selectedCity)),
    placeholder: "Select District",
    name: `landInfo.owners[0].permanentAddress.district`,
    type: isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
    defaultValue: isDA ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    name: "descriptionOfLand.plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6,
    disabled: isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    name: "descriptionOfLand.landArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    maxValue: maxPlotAreaSite,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, roadWidthsArray.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: `descriptionOfLand.roadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: roadWidthsArray.length >= 4,
    onClick: () => addRoadWidthField({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), roadWidthsArray.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeRoadWidthField(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))), /*#__PURE__*/React__default.createElement(Col, null, approachRoadWidths.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)",
    placeholder: isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)",
    name: `descriptionOfLand.approachRoadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    sx: {
      Padding: "0px"
    },
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: approachRoadWidths.length >= 4,
    onClick: () => addApproachRoad({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), approachRoadWidths.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeApproachWidth(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("latitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("longitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 30000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: isEmployee || isApproved,
    maxLength: 200,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: [{
      label: "Yes",
      value: "yes"
    }, {
      label: "No",
      value: "no"
    }],
    label: t("Is this a Government Building ?"),
    name: "isGovernmentBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding,
    disabled: (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) == "yes" || (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) == "no",
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchGovernmentBuilding === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Government Building"),
    control: control,
    placeholder: t("Select Government Building"),
    data: SortingAlphabatically(governmentBuildingOptions),
    name: "governmentBuildingName",
    mandatory: true,
    disabled: formData === null || formData === void 0 ? void 0 : formData.governmentBuildingName,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.governmentBuildingName,
    type: "searchSelect"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, null)), formData && ((formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter)) && /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      marginTop: "12px"
    }
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      marginBottom: 0
    }
  }, "Land Use Approval Letter"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => {
      var _formData$mapSubDetai2;
      return handleOpenPdf((formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.landUseApprovalLetter));
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(4)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      marginRight: "4px"
    }
  }))))));
};

const getFirstValue = (...sources) => {
  for (const s of sources) {
    if (s !== undefined && s !== null && s !== "") {
      return s;
    }
  }
  return "";
};
const getLocalStoragePressDetails = applicationNo => {
  try {
    let raw = null;
    if (applicationNo) {
      raw = localStorage.getItem(`INVITATION_SUGGESTION_${applicationNo}`);
    }
    if (!raw) {
      raw = localStorage.getItem("INVITATION_SUGGESTION_LATEST");
    }
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        return parsed;
      }
    }
  } catch (e) {
    console.error("Error reading pressReleaseDetails from localStorage:", e);
  }
  return null;
};
const extractValues = (formSrc, landSrc, appNo) => {
  var _formSrc$pressRelease, _formSrc$additionalDe, _formSrc$additionalDe2, _formSrc$pressDetails, _formSrc$additionalDe3, _formSrc$additionalDe4, _formSrc$additionalDe5, _landSrc$pressRelease, _landSrc$additionalDe, _landSrc$additionalDe2, _landSrc$pressDetails, _landSrc$additionalDe3, _landSrc$additionalDe4, _landSrc$additionalDe5, _formSrc$pressRelease2, _formSrc$additionalDe6, _formSrc$additionalDe7, _formSrc$pressDetails2, _formSrc$additionalDe8, _formSrc$additionalDe9, _formSrc$additionalDe10, _landSrc$pressRelease2, _landSrc$additionalDe6, _landSrc$additionalDe7, _landSrc$pressDetails2, _landSrc$additionalDe8, _landSrc$additionalDe9, _formSrc$pressRelease3, _formSrc$additionalDe11, _formSrc$additionalDe12, _formSrc$pressDetails3, _formSrc$additionalDe13, _formSrc$additionalDe14, _formSrc$additionalDe15, _landSrc$pressRelease3, _landSrc$additionalDe10, _landSrc$additionalDe11, _landSrc$pressDetails3, _landSrc$additionalDe12, _landSrc$additionalDe13;
  const localSrc = getLocalStoragePressDetails(appNo);
  const hasSuggestion = getFirstValue(formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressRelease = formSrc.pressReleaseDetails) === null || _formSrc$pressRelease === void 0 ? void 0 : _formSrc$pressRelease.hasSuggestion, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe = formSrc.additionalDetails) === null || _formSrc$additionalDe === void 0 ? void 0 : (_formSrc$additionalDe2 = _formSrc$additionalDe.pressReleaseDetails) === null || _formSrc$additionalDe2 === void 0 ? void 0 : _formSrc$additionalDe2.hasSuggestion, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressDetails = formSrc.pressDetails) === null || _formSrc$pressDetails === void 0 ? void 0 : _formSrc$pressDetails.hasSuggestion, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe3 = formSrc.additionalDetails) === null || _formSrc$additionalDe3 === void 0 ? void 0 : (_formSrc$additionalDe4 = _formSrc$additionalDe3.pressDetails) === null || _formSrc$additionalDe4 === void 0 ? void 0 : _formSrc$additionalDe4.hasSuggestion, formSrc === null || formSrc === void 0 ? void 0 : formSrc.hasSuggestion, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe5 = formSrc.additionalDetails) === null || _formSrc$additionalDe5 === void 0 ? void 0 : _formSrc$additionalDe5.hasSuggestion, localSrc === null || localSrc === void 0 ? void 0 : localSrc.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressRelease = landSrc.pressReleaseDetails) === null || _landSrc$pressRelease === void 0 ? void 0 : _landSrc$pressRelease.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe = landSrc.additionalDetails) === null || _landSrc$additionalDe === void 0 ? void 0 : (_landSrc$additionalDe2 = _landSrc$additionalDe.pressReleaseDetails) === null || _landSrc$additionalDe2 === void 0 ? void 0 : _landSrc$additionalDe2.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressDetails = landSrc.pressDetails) === null || _landSrc$pressDetails === void 0 ? void 0 : _landSrc$pressDetails.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe3 = landSrc.additionalDetails) === null || _landSrc$additionalDe3 === void 0 ? void 0 : (_landSrc$additionalDe4 = _landSrc$additionalDe3.pressDetails) === null || _landSrc$additionalDe4 === void 0 ? void 0 : _landSrc$additionalDe4.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : landSrc.hasSuggestion, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe5 = landSrc.additionalDetails) === null || _landSrc$additionalDe5 === void 0 ? void 0 : _landSrc$additionalDe5.hasSuggestion);
  const pressReleaseFee = getFirstValue(formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressRelease2 = formSrc.pressReleaseDetails) === null || _formSrc$pressRelease2 === void 0 ? void 0 : _formSrc$pressRelease2.pressReleaseFee, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe6 = formSrc.additionalDetails) === null || _formSrc$additionalDe6 === void 0 ? void 0 : (_formSrc$additionalDe7 = _formSrc$additionalDe6.pressReleaseDetails) === null || _formSrc$additionalDe7 === void 0 ? void 0 : _formSrc$additionalDe7.pressReleaseFee, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressDetails2 = formSrc.pressDetails) === null || _formSrc$pressDetails2 === void 0 ? void 0 : _formSrc$pressDetails2.pressReleaseFee, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe8 = formSrc.additionalDetails) === null || _formSrc$additionalDe8 === void 0 ? void 0 : (_formSrc$additionalDe9 = _formSrc$additionalDe8.pressDetails) === null || _formSrc$additionalDe9 === void 0 ? void 0 : _formSrc$additionalDe9.pressReleaseFee, formSrc === null || formSrc === void 0 ? void 0 : formSrc.pressReleaseFee, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe10 = formSrc.additionalDetails) === null || _formSrc$additionalDe10 === void 0 ? void 0 : _formSrc$additionalDe10.pressReleaseFee, localSrc === null || localSrc === void 0 ? void 0 : localSrc.pressReleaseFee, landSrc === null || landSrc === void 0 ? void 0 : landSrc.pressReleaseFee, landSrc === null || landSrc === void 0 ? void 0 : landSrc.pressReleaseAmount, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressRelease2 = landSrc.pressReleaseDetails) === null || _landSrc$pressRelease2 === void 0 ? void 0 : _landSrc$pressRelease2.pressReleaseFee, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe6 = landSrc.additionalDetails) === null || _landSrc$additionalDe6 === void 0 ? void 0 : (_landSrc$additionalDe7 = _landSrc$additionalDe6.pressReleaseDetails) === null || _landSrc$additionalDe7 === void 0 ? void 0 : _landSrc$additionalDe7.pressReleaseFee, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressDetails2 = landSrc.pressDetails) === null || _landSrc$pressDetails2 === void 0 ? void 0 : _landSrc$pressDetails2.pressReleaseFee, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe8 = landSrc.additionalDetails) === null || _landSrc$additionalDe8 === void 0 ? void 0 : (_landSrc$additionalDe9 = _landSrc$additionalDe8.pressDetails) === null || _landSrc$additionalDe9 === void 0 ? void 0 : _landSrc$additionalDe9.pressReleaseFee);
  const invitationRemark = getFirstValue(formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressRelease3 = formSrc.pressReleaseDetails) === null || _formSrc$pressRelease3 === void 0 ? void 0 : _formSrc$pressRelease3.invitationRemark, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe11 = formSrc.additionalDetails) === null || _formSrc$additionalDe11 === void 0 ? void 0 : (_formSrc$additionalDe12 = _formSrc$additionalDe11.pressReleaseDetails) === null || _formSrc$additionalDe12 === void 0 ? void 0 : _formSrc$additionalDe12.invitationRemark, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$pressDetails3 = formSrc.pressDetails) === null || _formSrc$pressDetails3 === void 0 ? void 0 : _formSrc$pressDetails3.invitationRemark, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe13 = formSrc.additionalDetails) === null || _formSrc$additionalDe13 === void 0 ? void 0 : (_formSrc$additionalDe14 = _formSrc$additionalDe13.pressDetails) === null || _formSrc$additionalDe14 === void 0 ? void 0 : _formSrc$additionalDe14.invitationRemark, formSrc === null || formSrc === void 0 ? void 0 : formSrc.invitationRemark, formSrc === null || formSrc === void 0 ? void 0 : (_formSrc$additionalDe15 = formSrc.additionalDetails) === null || _formSrc$additionalDe15 === void 0 ? void 0 : _formSrc$additionalDe15.invitationRemark, localSrc === null || localSrc === void 0 ? void 0 : localSrc.invitationRemark, landSrc === null || landSrc === void 0 ? void 0 : landSrc.invitationRemark, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressRelease3 = landSrc.pressReleaseDetails) === null || _landSrc$pressRelease3 === void 0 ? void 0 : _landSrc$pressRelease3.invitationRemark, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe10 = landSrc.additionalDetails) === null || _landSrc$additionalDe10 === void 0 ? void 0 : (_landSrc$additionalDe11 = _landSrc$additionalDe10.pressReleaseDetails) === null || _landSrc$additionalDe11 === void 0 ? void 0 : _landSrc$additionalDe11.invitationRemark, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$pressDetails3 = landSrc.pressDetails) === null || _landSrc$pressDetails3 === void 0 ? void 0 : _landSrc$pressDetails3.invitationRemark, landSrc === null || landSrc === void 0 ? void 0 : (_landSrc$additionalDe12 = landSrc.additionalDetails) === null || _landSrc$additionalDe12 === void 0 ? void 0 : (_landSrc$additionalDe13 = _landSrc$additionalDe12.pressDetails) === null || _landSrc$additionalDe13 === void 0 ? void 0 : _landSrc$additionalDe13.invitationRemark);
  return {
    hasSuggestion: hasSuggestion || "",
    pressReleaseFee: pressReleaseFee || "",
    invitationRemark: invitationRemark || ""
  };
};
const InvitationSuggestion = ({
  formData,
  handleTabChange,
  isEmployee,
  isApproved,
  onSaveClick
}) => {
  var _Digit$ULBService$get, _Digit$ULBService, _Digit$ULBService$get2, _Digit$ULBService2;
  const tenantId = ((_Digit$ULBService$get = (_Digit$ULBService = Digit.ULBService).getStateId) === null || _Digit$ULBService$get === void 0 ? void 0 : _Digit$ULBService$get.call(_Digit$ULBService)) || ((_Digit$ULBService$get2 = (_Digit$ULBService2 = Digit.ULBService).getCurrentTenantId) === null || _Digit$ULBService$get2 === void 0 ? void 0 : _Digit$ULBService$get2.call(_Digit$ULBService2)) || "up";
  const applicationNo = (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.oldMapSubApplNumber) || (formData === null || formData === void 0 ? void 0 : formData.applicationNumber);
  const [landUseData, setLandUseData] = useState(null);
  const isInitialSyncDone = useRef(false);
  useEffect(() => {
    const fetchLandUseData = async () => {
      if (!applicationNo) return;
      try {
        var _res, _res$LandUse, _res2, _res2$LandUse;
        let res = await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
          oldMapSubApplNumber: applicationNo
        });
        if (!((_res = res) !== null && _res !== void 0 && (_res$LandUse = _res.LandUse) !== null && _res$LandUse !== void 0 && _res$LandUse.length)) {
          res = await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
            applicationNo: applicationNo
          });
        }
        if ((_res2 = res) !== null && _res2 !== void 0 && (_res2$LandUse = _res2.LandUse) !== null && _res2$LandUse !== void 0 && _res2$LandUse[0]) {
          setLandUseData(res.LandUse[0]);
        }
      } catch (err) {
        console.error("Error fetching Land Use search data for Invitation Suggestion:", err);
      }
    };
    fetchLandUseData();
  }, [applicationNo, tenantId]);
  const initialValues = extractValues(formData, landUseData, applicationNo);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: {
      isDirty
    }
  } = useForm({
    defaultValues: initialValues
  });
  const currentSuggestion = watch("hasSuggestion");
  const currentFee = watch("pressReleaseFee");
  const currentRemark = watch("invitationRemark");
  useEffect(() => {
    if (currentSuggestion || currentFee || currentRemark) {
      const pressDataToStore = {
        hasSuggestion: currentSuggestion || "",
        pressReleaseFee: currentSuggestion === "yes" ? currentFee || "" : "",
        invitationRemark: currentRemark || "",
        updatedAt: Date.now()
      };
      try {
        if (applicationNo) {
          localStorage.setItem(`INVITATION_SUGGESTION_${applicationNo}`, JSON.stringify(pressDataToStore));
        }
        localStorage.setItem("INVITATION_SUGGESTION_LATEST", JSON.stringify(pressDataToStore));
      } catch (e) {
        console.error("Error writing to localStorage:", e);
      }
    }
  }, [currentSuggestion, currentFee, currentRemark, applicationNo]);
  useEffect(() => {
    const current = getValues();
    const currentHasAny = Boolean(current.hasSuggestion || current.pressReleaseFee || current.invitationRemark);
    if (currentHasAny) {
      return;
    }
    const extracted = extractValues(formData, landUseData, applicationNo);
    const extractedHasAny = Boolean(extracted.hasSuggestion || extracted.pressReleaseFee || extracted.invitationRemark);
    if (extractedHasAny) {
      reset(extracted);
      isInitialSyncDone.current = true;
    }
  }, [formData, landUseData, reset, getValues, applicationNo]);
  const watchSuggestion = watch("hasSuggestion");
  const onSubmit = data => {
    var _formData$additionalD, _formData$additionalD2, _landUseData$addition;
    console.log("Invitation Suggestion Data:", data);
    const localSrc = getLocalStoragePressDetails(applicationNo);
    const hasSuggestion = data.hasSuggestion || (localSrc === null || localSrc === void 0 ? void 0 : localSrc.hasSuggestion) || "";
    const pressReleaseFee = hasSuggestion === "yes" ? data.pressReleaseFee !== undefined && data.pressReleaseFee !== null && data.pressReleaseFee !== "" ? data.pressReleaseFee : (localSrc === null || localSrc === void 0 ? void 0 : localSrc.pressReleaseFee) || "" : "";
    const invitationRemark = data.invitationRemark || (localSrc === null || localSrc === void 0 ? void 0 : localSrc.invitationRemark) || "";
    const pressDataToStore = {
      hasSuggestion,
      pressReleaseFee,
      invitationRemark,
      updatedAt: Date.now()
    };
    try {
      if (applicationNo) {
        localStorage.setItem(`INVITATION_SUGGESTION_${applicationNo}`, JSON.stringify(pressDataToStore));
      }
      localStorage.setItem("INVITATION_SUGGESTION_LATEST", JSON.stringify(pressDataToStore));
    } catch (e) {
      console.error("Error storing to localStorage:", e);
    }
    const existingPressDetails = (formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : formData.pressDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.pressDetails) || (landUseData === null || landUseData === void 0 ? void 0 : landUseData.pressReleaseDetails) || (landUseData === null || landUseData === void 0 ? void 0 : (_landUseData$addition = landUseData.additionalDetails) === null || _landUseData$addition === void 0 ? void 0 : _landUseData$addition.pressReleaseDetails) || localSrc || {};
    const pressDetailsData = {
      ...existingPressDetails,
      hasSuggestion,
      pressReleaseFee,
      invitationRemark
    };
    const payload = {
      hasSuggestion,
      pressReleaseFee,
      invitationRemark,
      pressDetails: pressDetailsData,
      pressReleaseDetails: pressDetailsData,
      additionalDetails: {
        ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        pressDetails: pressDetailsData,
        pressReleaseDetails: pressDetailsData
      }
    };
    onSaveClick === null || onSaveClick === void 0 ? void 0 : onSaveClick(payload);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Invitation Suggestion")), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "hasSuggestion",
    label: "Any objections or suggestions required for this proposal?",
    type: "radioButton",
    data: yesOrNo,
    mandatory: true
  }))), watchSuggestion === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "pressReleaseFee",
    label: "Press Release Fee (Amount)",
    placeholder: "Enter Amount",
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Amount is required"
      }
    }
  }))), watchSuggestion && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 4,
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "invitationRemark",
    control: control,
    rules: {
      required: "This field is required"
    },
    render: ({
      field,
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      value: field.value || "",
      label: "Remark",
      placeholder: "Please enter Remark",
      multiline: true,
      rows: 4,
      fullWidth: true,
      error: !!error,
      helperText: error === null || error === void 0 ? void 0 : error.message
    }))
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit"
  }))))));
};

const CollapsibleAdditionalRemarks = ({
  formData,
  additionalComment,
  setAdditionalComment,
  handleSubmit
}) => {
  const [open, setOpen] = useState(false);
  const applicationStatus = formData === null || formData === void 0 ? void 0 : formData.status;
  useEffect(() => {
    var _formData$mapSubDetai, _formData$additionalC, _formData$additionalC2;
    if (formData !== null && formData !== void 0 && formData.mapSubDetails && formData !== null && formData !== void 0 && (_formData$mapSubDetai = formData.mapSubDetails) !== null && _formData$mapSubDetai !== void 0 && _formData$mapSubDetai.formattedAdditionalComment || formData !== null && formData !== void 0 && formData.additionalComment && (formData === null || formData === void 0 ? void 0 : (_formData$additionalC = formData.additionalComment) === null || _formData$additionalC === void 0 ? void 0 : (_formData$additionalC2 = _formData$additionalC.trim()) === null || _formData$additionalC2 === void 0 ? void 0 : _formData$additionalC2.length) !== 0) {
      var _formData$mapSubDetai2;
      setAdditionalComment((formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.formattedAdditionalComment) || (formData === null || formData === void 0 ? void 0 : formData.additionalComment));
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.additionalComment]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "15px 0",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: () => setOpen(!open),
    "aria-controls": "example-collapse-text",
    "aria-expanded": open,
    style: {
      background: "rgba(52, 73, 94, 0.94)",
      padding: "10px 20px",
      borderRadius: "4px",
      fontWeight: 600,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#fff",
      fontSize: "16px"
    }
  }, "Additional Comment (If any)"), open ? /*#__PURE__*/React__default.createElement(RemoveIcon$1, {
    sx: {
      color: "#fff"
    }
  }) : /*#__PURE__*/React__default.createElement(AddIcon$1, {
    sx: {
      color: "#fff"
    }
  })), /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: open
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "example-collapse-text",
    style: {
      width: "100%",
      marginTop: "12px",
      padding: "12px",
      boxSizing: "border-box"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      border: "2px solid grey",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setAdditionalComment,
    content: additionalComment,
    useNewSanitized: true
  }), /*#__PURE__*/React__default.createElement(Button$3, {
    style: {
      marginTop: "15px",
      color: "#fff",
      backgroundColor: applicationStatus === "APPROVED" ? "grey" : "rgb(31, 74, 124)",
      minWidth: "100px"
    },
    onClick: handleSubmit,
    disabled: applicationStatus === "APPROVED"
  }, "Save")))));
};

const CustomApprovalLetterUploader = ({
  formData,
  onUpload
}) => {
  var _ref, _formData$additionalD, _formData$application;
  const {
    t
  } = useTranslation();
  const existingDoc = (_ref = (formData === null || formData === void 0 ? void 0 : formData.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationData) === null || _formData$application === void 0 ? void 0 : _formData$application.documents)) === null || _ref === void 0 ? void 0 : _ref.find(d => d.documentType === "customapprovalletter");
  const existingLetter = (existingDoc === null || existingDoc === void 0 ? void 0 : existingDoc.fileStoreId) || (existingDoc === null || existingDoc === void 0 ? void 0 : existingDoc.fileUrl) || (existingDoc === null || existingDoc === void 0 ? void 0 : existingDoc.url) || null;
  const [uploadedCustomLetter, setUploadedCustomLetter] = useState(localStorage.getItem("custom_approval_letter") || existingLetter || null);
  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  useEffect(() => {
    const handleUpdate = () => {
      var _ref2, _formData$additionalD2, _formData$application2;
      const stored = localStorage.getItem("custom_approval_letter");
      const currentDoc = (_ref2 = (formData === null || formData === void 0 ? void 0 : formData.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.documents) || (formData === null || formData === void 0 ? void 0 : (_formData$application2 = formData.applicationData) === null || _formData$application2 === void 0 ? void 0 : _formData$application2.documents)) === null || _ref2 === void 0 ? void 0 : _ref2.find(d => d.documentType === "customapprovalletter");
      const letter = stored || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileStoreId) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.fileUrl) || (currentDoc === null || currentDoc === void 0 ? void 0 : currentDoc.url) || null;
      if (letter) {
        setUploadedCustomLetter(letter);
      }
    };
    window.addEventListener("custom_approval_letter_updated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("custom_approval_letter_updated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, [formData]);
  const handleCustomLetterUpload = async event => {
    var _event$target, _event$target$files;
    const file = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$files = _event$target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    if (!file) return;
    setUploadError(null);
    setLoading(true);
    try {
      var _response$data, _response$data$files;
      const allowedFileTypesRegex = /(jpg|jpeg|png|pdf)$/i;
      if (file.size > 20 * 1024 * 1024) {
        setUploadError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        setLoading(false);
        return;
      }
      if (file.type && !allowedFileTypesRegex.test(file.type)) {
        setUploadError(t("NOT_SUPPORTED_FILE_TYPE"));
        setLoading(false);
        return;
      }
      const tenantId = "up";
      const stateId = Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]);
      const response = await Digit.UploadServices.Filestorage("OBPS", file, stateId);
      const uploadedData = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files[0];
      if (uploadedData !== null && uploadedData !== void 0 && uploadedData.fileStoreId) {
        setUploadedCustomLetter(uploadedData.fileStoreId);
        localStorage.setItem("custom_approval_letter", uploadedData.fileStoreId);
        window.dispatchEvent(new Event("custom_approval_letter_updated"));
        if (onUpload) onUpload(uploadedData.fileStoreId);
      } else {
        setUploadError(t("CS_FILE_UPLOAD_ERROR"));
      }
    } catch (err) {
      console.error("[UPLOAD] Upload failed:", err);
      setUploadError(t("CS_FILE_UPLOAD_ERROR"));
    } finally {
      setLoading(false);
    }
  };
  const handleViewUploadedCustomLetter = async () => {
    if (!uploadedCustomLetter) return;
    try {
      var _response$data2, _response$data2$fileS, _response$data2$fileS2;
      if (typeof uploadedCustomLetter === "string" && (uploadedCustomLetter.startsWith("http") || uploadedCustomLetter.startsWith("/"))) {
        window.open(uploadedCustomLetter, "_blank");
        return;
      }
      const tenantId = (formData === null || formData === void 0 ? void 0 : formData.tenantId) || Digit.ULBService.getCurrentTenantId() || "up";
      const response = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${uploadedCustomLetter}`);
      const fileUrl = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$fileS = _response$data2.fileStoreIds) === null || _response$data2$fileS === void 0 ? void 0 : (_response$data2$fileS2 = _response$data2$fileS[0]) === null || _response$data2$fileS2 === void 0 ? void 0 : _response$data2$fileS2.url;
      if (fileUrl) {
        window.open(fileUrl, "_blank");
      }
    } catch (err) {
      console.error("Failed to view custom approval letter:", err);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      margin: "12px 0 16px 0",
      padding: "16px 20px",
      backgroundColor: "#f8fbfd",
      border: "1px solid #bce1f3",
      borderRadius: "6px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "6px"
    }
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      color: "#0B4B66",
      fontSize: "14px"
    }
  }, t("Upload Approval Certificate / Letter")), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "12px",
      color: "#666"
    }
  }, t("(Optional)"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "12px",
      color: "#666"
    }
  }, t("(PDF or Image, max 20MB)"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      flexWrap: "wrap"
    }
  }, uploadedCustomLetter ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "14px",
      color: "#2e7d32",
      fontWeight: 500
    }
  }, "\u2713 ", t("ES_PT_ACTION_FILEUPLOADED")), /*#__PURE__*/React__default.createElement("span", {
    onClick: handleViewUploadedCustomLetter,
    style: {
      color: "#157CB3",
      cursor: "pointer",
      fontSize: "13px",
      textDecoration: "underline",
      fontWeight: 600,
      marginLeft: "8px"
    }
  }, t("View Uploaded Letter"))) : /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "custom-approval-letter-upload-prov",
    onUpload: handleCustomLetterUpload,
    message: t("CS_ACTION_NO_FILEUPLOADED"),
    text: t("Upload Approval Letter"),
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    buttonType: "button",
    iserror: uploadError
  })), loading && /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#666",
      marginTop: "4px"
    }
  }, t("Uploading...")), uploadError && /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#d32f2f",
      fontSize: "12px",
      marginTop: "4px"
    }
  }, uploadError));
};

const EmpMapSubmissionPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray,
  urlFormType
}) => {
  var _Digit, _Digit2, _userRolesArray$, _userRolesArray$2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [validationPopup, setValidationPopup] = useState(false);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [initialDeveloperRemarks, setInitialDeveloperRemarks] = useState("");
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code) === "JE";
  console.log("IS JE JUINIT", isJE);
  const [customApprovalLetterFileStore, setCustomApprovalLetterFileStore] = useState(localStorage.getItem("custom_approval_letter") || null);
  useEffect(() => {
    const handleCustomLetterChange = () => {
      setCustomApprovalLetterFileStore(localStorage.getItem("custom_approval_letter"));
    };
    window.addEventListener("custom_approval_letter_updated", handleCustomLetterChange);
    window.addEventListener("storage", handleCustomLetterChange);
    return () => {
      window.removeEventListener("custom_approval_letter_updated", handleCustomLetterChange);
      window.removeEventListener("storage", handleCustomLetterChange);
    };
  }, []);
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    nocRemarksData,
    callNocDetailsAPI,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    handleNoWorkflowPFAR,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isPurchasbleReq,
    currentFormData,
    handleNoWorkflowCompounding,
    isFromDashboard,
    daLogo,
    avpLogo,
    drawingRemarks,
    setDrawingRemarks,
    paymentRemarks,
    paymentRecommendation,
    setPaymentRecommendation,
    drawingRecommendation,
    setDrawingRecommendation,
    DrawingRecommendation,
    setPaymentRemarks,
    callDocumentDetailsAPI,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  console.log("isFromMapsubportalAyush", isFromDashboard);
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "Fees"
  }, {
    label: "Land/Plot Information"
  }, {
    label: "Invitation Suggestion"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async nextTabNo => {
    console.log("fromhanldetabchangeaditya", nextTabNo, typeof nextTabNo);
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleInvitationSuggestionSave = invitationData => {
    try {
      var _localPress, _localPress2, _localPress3, _params$pressReleaseD, _params$pressDetails, _params$additionalDet, _params$additionalDet2, _params$additionalDet3, _params$additionalDet4, _params$additionalDet5, _params$additionalDet6;
      const appNo = (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (params === null || params === void 0 ? void 0 : params.applicationNo);
      let localPress = null;
      try {
        const raw = appNo && localStorage.getItem(`INVITATION_SUGGESTION_${appNo}`) || localStorage.getItem("INVITATION_SUGGESTION_LATEST");
        if (raw) localPress = JSON.parse(raw);
      } catch (e) {}
      const hasSuggestion = (invitationData === null || invitationData === void 0 ? void 0 : invitationData.hasSuggestion) || ((_localPress = localPress) === null || _localPress === void 0 ? void 0 : _localPress.hasSuggestion) || "";
      const pressReleaseFee = hasSuggestion === "yes" ? (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== undefined && (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== null && (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== "" ? invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee : ((_localPress2 = localPress) === null || _localPress2 === void 0 ? void 0 : _localPress2.pressReleaseFee) || "" : "";
      const invitationRemark = (invitationData === null || invitationData === void 0 ? void 0 : invitationData.invitationRemark) || ((_localPress3 = localPress) === null || _localPress3 === void 0 ? void 0 : _localPress3.invitationRemark) || "";
      const pressDataToStore = {
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        updatedAt: Date.now()
      };
      try {
        if (appNo) {
          localStorage.setItem(`INVITATION_SUGGESTION_${appNo}`, JSON.stringify(pressDataToStore));
        }
        localStorage.setItem("INVITATION_SUGGESTION_LATEST", JSON.stringify(pressDataToStore));
      } catch (e) {
        console.error("Error storing to localStorage:", e);
      }
      const basePressFromParams = params !== null && params !== void 0 && (_params$pressReleaseD = params.pressReleaseDetails) !== null && _params$pressReleaseD !== void 0 && _params$pressReleaseD.hasSuggestion ? params.pressReleaseDetails : params !== null && params !== void 0 && (_params$pressDetails = params.pressDetails) !== null && _params$pressDetails !== void 0 && _params$pressDetails.hasSuggestion ? params.pressDetails : params !== null && params !== void 0 && (_params$additionalDet = params.additionalDetails) !== null && _params$additionalDet !== void 0 && (_params$additionalDet2 = _params$additionalDet.pressReleaseDetails) !== null && _params$additionalDet2 !== void 0 && _params$additionalDet2.hasSuggestion ? params.additionalDetails.pressReleaseDetails : params !== null && params !== void 0 && (_params$additionalDet3 = params.additionalDetails) !== null && _params$additionalDet3 !== void 0 && (_params$additionalDet4 = _params$additionalDet3.pressDetails) !== null && _params$additionalDet4 !== void 0 && _params$additionalDet4.hasSuggestion ? params.additionalDetails.pressDetails : (params === null || params === void 0 ? void 0 : params.pressReleaseDetails) || (params === null || params === void 0 ? void 0 : params.pressDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet5 = params.additionalDetails) === null || _params$additionalDet5 === void 0 ? void 0 : _params$additionalDet5.pressReleaseDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet6 = params.additionalDetails) === null || _params$additionalDet6 === void 0 ? void 0 : _params$additionalDet6.pressDetails) || localPress || {};
      const pressDetailsObj = {
        ...basePressFromParams,
        hasSuggestion,
        pressReleaseFee,
        invitationRemark
      };
      const additionalDetails = {
        ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {}),
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        pressDetails: pressDetailsObj,
        pressReleaseDetails: pressDetailsObj
      };
      const data = {
        ...params,
        ...invitationData,
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        pressDetails: pressDetailsObj,
        pressReleaseDetails: pressDetailsObj,
        additionalDetails: additionalDetails,
        workflow: {
          action: "NOWORKFLOW",
          comments: ""
        }
      };
      console.log("Data to be saved from Invitation Suggestion:", data);
      updateApiCall.mutate({
        BPA: data
      }, {
        onSuccess: res => {
          var _res$BPA, _returnedBPA$addition, _returnedBPA$addition2, _returnedBPA$addition3, _returnedBPA$addition4, _returnedBPA$addition5, _returnedBPA$addition6, _returnedBPA$addition7, _returnedBPA$addition8;
          const returnedBPA = (res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]) || {};
          const pick = (a, b, localFallback) => a && a !== "" ? a : b && b !== "" ? b : localFallback;
          const returnedPress = (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition = returnedBPA.additionalDetails) === null || _returnedBPA$addition === void 0 ? void 0 : _returnedBPA$addition.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition2 = returnedBPA.additionalDetails) === null || _returnedBPA$addition2 === void 0 ? void 0 : _returnedBPA$addition2.pressDetails);
          const mergedPressRelease = returnedPress !== null && returnedPress !== void 0 && returnedPress.hasSuggestion ? {
            ...pressDetailsObj,
            ...returnedPress
          } : pressDetailsObj;
          const updatedBPA = {
            ...data,
            ...returnedBPA,
            hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition3 = returnedBPA.additionalDetails) === null || _returnedBPA$addition3 === void 0 ? void 0 : _returnedBPA$addition3.hasSuggestion, data.hasSuggestion),
            pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition4 = returnedBPA.additionalDetails) === null || _returnedBPA$addition4 === void 0 ? void 0 : _returnedBPA$addition4.pressReleaseFee, data.pressReleaseFee),
            invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition5 = returnedBPA.additionalDetails) === null || _returnedBPA$addition5 === void 0 ? void 0 : _returnedBPA$addition5.invitationRemark, data.invitationRemark),
            pressDetails: mergedPressRelease,
            pressReleaseDetails: mergedPressRelease,
            additionalDetails: {
              ...((data === null || data === void 0 ? void 0 : data.additionalDetails) || {}),
              ...((returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.additionalDetails) || {}),
              hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition6 = returnedBPA.additionalDetails) === null || _returnedBPA$addition6 === void 0 ? void 0 : _returnedBPA$addition6.hasSuggestion, data.hasSuggestion),
              pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition7 = returnedBPA.additionalDetails) === null || _returnedBPA$addition7 === void 0 ? void 0 : _returnedBPA$addition7.pressReleaseFee, data.pressReleaseFee),
              invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition8 = returnedBPA.additionalDetails) === null || _returnedBPA$addition8 === void 0 ? void 0 : _returnedBPA$addition8.invitationRemark, data.invitationRemark),
              pressDetails: mergedPressRelease,
              pressReleaseDetails: mergedPressRelease
            }
          };
          onSelect("", updatedBPA);
          setShowToast({
            error: false,
            message: "Data has been saved successfully"
          });
          handleTabChange(1);
        },
        onError: () => {
          Modal("Update Error", "Something went wrong!!", "error");
        }
      });
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  useEffect(() => {
    var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3, _documentRemarksData$4;
    const initialDeveloperRemarks = developerRemarksDocument ? developerNocRemarks : Array.isArray(documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0 ? (_documentRemarksData$ = documentRemarksData.DetailDataRemarks[documentRemarksData.DetailDataRemarks.length - 1]) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$.documentDetails) === null || _documentRemarksData$2 === void 0 ? void 0 : _documentRemarksData$2.developerRemarks : documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$3 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$3 === void 0 ? void 0 : (_documentRemarksData$4 = _documentRemarksData$3.documentDetails) === null || _documentRemarksData$4 === void 0 ? void 0 : _documentRemarksData$4.developerRemarks;
    setInitialDeveloperRemarks(initialDeveloperRemarks);
  }, [developerRemarksDocument, documentRemarksData]);
  console.log("Initial Developer Remarks:", initialDeveloperRemarks);
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (isCompounding && activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(CompoundingChecklist, {
        formData: params,
        handleTabChange: handleTabChange,
        role: "EMPLOYEE",
        handleNoWorkflowCompounding: handleNoWorkflowCompounding
      });
    }
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(Step5, {
            formData: formData,
            handleTabChange: handleTabChange,
            isEmployee: !isCitizen
          });
        case 5:
          return /*#__PURE__*/React__default.createElement(SubStep6, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            tenantId: tenantId,
            departmentList: departmentList,
            avpData: null,
            isEmployee: !isCitizen,
            isApproved: true
          });
        case 6:
          return /*#__PURE__*/React__default.createElement(InvitationSuggestion, {
            formData: params || formData,
            handleTabChange: handleTabChange,
            isEmployee: !isCitizen,
            isApproved: true,
            onSaveClick: handleInvitationSuggestionSave
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            docType: "mandatory",
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
            setError: setError,
            setDeveloperRemarks: setDeveloperRemarksDocument,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: SortingAlphabatically(siteInspRecommendation),
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument
            }, props, {
              error: error,
              setError: setError
            }))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            type: "documentDetails"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            docType: "conditional"
          }));
        default:
          return null;
      }
    } else if (activeTab === (isCompounding ? 3 : 2)) {
      var _formData$additionalD, _params$additionalDet7;
      return /*#__PURE__*/React__default.createElement(EmpIdentifyNoc, {
        formData: {
          ...(formData || {}),
          ...(params || {}),
          nocDetails: (params === null || params === void 0 ? void 0 : params.nocDetails) || (formData === null || formData === void 0 ? void 0 : formData.nocDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.nocDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet7 = params.additionalDetails) === null || _params$additionalDet7 === void 0 ? void 0 : _params$additionalDet7.nocDetails),
          additionalDetails: {
            ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
            ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {})
          }
        },
        tenantId: tenantId,
        handleNoWorkflowNoc: handleNoWorkflowNoc,
        isJE: isJE,
        currentFormData: currentFormData
      });
    } else if (activeTab === (isCompounding ? 4 : 3)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step4, {
        formData: params || formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        onSelect: onSelect
      }), !isCitizen && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
        title: "Recommendation Details",
        label: "Recommendation",
        name: "recommendation",
        options: SortingAlphabatically(siteInspRecommendation),
        optionsInner: innerInspRecommendation,
        defaultValue: drawingRecommendation,
        extraLabel: "Remarks",
        error: error,
        setError: setError,
        setDeveloperRemarks: setDrawingRemarks,
        developerRemarks: drawingRemarks,
        setDataRecommendation: setDrawingRecommendation,
        setSelectedObjection: setSelectedObjection,
        names: "multiSelectField",
        type: "drawingDetails",
        buttonshow: true,
        onSaveClick: callDrawingDetailsAPI,
        handleTabChange: handleTabChange,
        nextTab: 3,
        isFromDashboard: isFromDashboard
      }), /*#__PURE__*/React__default.createElement(DrawingsDetailsTable, {
        detailData: siteDrawingRemarksData === null || siteDrawingRemarksData === void 0 ? void 0 : siteDrawingRemarksData.DetailDataRemarks
      })));
    } else if (activeTab === (isCompounding ? 5 : 4)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BasicSiteInspectionReport, {
        formData: params,
        handleTabChange: handleTabChange,
        setUpdatedInspectionReportData: setUpdatedInspectionReportData,
        callInspectionDetailsAPI: callInspectionDetailsAPI,
        userRolesArray: userRolesArray,
        onSelect: onSelect,
        isFromDashboard: isFromDashboard,
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks,
        type: "inspectionDetails",
        formData: formData
      }));
    } else if (activeTab === (isCompounding ? 6 : 5)) {
      var _userRolesArray$3;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaymentHead, {
        tenantId: tenantId,
        formData: params,
        setTaxHead: setTaxHead,
        taxHead: taxHead,
        empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code,
        isFeesEligible: isFeesEligible,
        onSelect: setParams,
        Modal: Modal,
        isValidEmp: isValidEmp,
        isFromDashboard: isFromDashboard
      }), /*#__PURE__*/React__default.createElement(PaymentMemoTable, {
        formData: params,
        logoData: (formData === null || formData === void 0 ? void 0 : formData.department) == "DA" ? daLogo : avpLogo
      }), /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
        title: "Recommendation Details",
        label: "Recommendation",
        name: "recommendation",
        options: SortingAlphabatically(siteInspRecommendation),
        defaultValue: paymentRecommendation,
        extraLabel: "Remarks",
        setDeveloperRemarks: setPaymentRemarks,
        developerRemarks: paymentRemarks,
        setDataRecommendation: setPaymentRecommendation,
        buttonshow: true,
        onSaveClick: callPaymentDetailsAPI,
        handleTabChange: handleTabChange,
        nextTab: 5,
        isFromDashboard: isFromDashboard
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: paymentHeadRemarksData === null || paymentHeadRemarksData === void 0 ? void 0 : paymentHeadRemarksData.DetailDataRemarks,
        type: "paymentDetails"
      }));
    } else if (activeTab === (isCompounding ? 7 : 6)) {
      var _formData$status;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission",
        daLogo: daLogo,
        avpLogo: avpLogo
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        logoData: (formData === null || formData === void 0 ? void 0 : formData.department) == "DA" ? daLogo : avpLogo,
        workflowDetails: workflowDetails,
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        isMapSub: true
      }), /*#__PURE__*/React__default.createElement(CollapsibleAdditionalRemarks, {
        formData: params || formData,
        additionalComment: additionalComment,
        setAdditionalComment: setAdditionalComment,
        handleSubmit: () => {
          var _additionalComment$tr;
          console.log("additionalComment12", additionalComment);
          if (((_additionalComment$tr = additionalComment.trim()) === null || _additionalComment$tr === void 0 ? void 0 : _additionalComment$tr.length) === 0) {
            return;
          }
          handleAdditionalComment();
        }
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), ((_formData$additionalD2, _formData$additionalD3, _formData$businessSer, _formData$businessSer2) => {
        const isDaOrAvp = Boolean(typeof isDa !== "undefined" ? isDa : false) || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "AVP" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.riskType) === "AVP" || (formData === null || formData === void 0 ? void 0 : formData.applicationFlow) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.applicationFlow) === "AVP" || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer = formData.businessService) === null || _formData$businessSer === void 0 ? void 0 : _formData$businessSer.includes("DA")) || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer2 = formData.businessService) === null || _formData$businessSer2 === void 0 ? void 0 : _formData$businessSer2.includes("AVP"));
        const selectedActionName = ((typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (typeof mapSubmissionAction === "object" ? mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action : mapSubmissionAction) || "").toUpperCase();
        const isProvisionallyApprove = selectedActionName.includes("PROVISION") || selectedActionName === "PROVISIONALLY_APPROVAL" || selectedActionName === "PROVISIONALLY_APPROVE";
        return isDaOrAvp && isProvisionallyApprove ? /*#__PURE__*/React__default.createElement(CustomApprovalLetterUploader, {
          formData: formData
        }) : null;
      })(), (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), ((_formData$additionalD4, _formData$businessSer3) => {
        const isDaApp = Boolean(typeof isDa !== "undefined" ? isDa : false) || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.riskType) === "DA" || (formData === null || formData === void 0 ? void 0 : formData.applicationFlow) === "DA" || (formData === null || formData === void 0 ? void 0 : (_formData$businessSer3 = formData.businessService) === null || _formData$businessSer3 === void 0 ? void 0 : _formData$businessSer3.includes("DA"));
        const selectedActionName = ((typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (typeof mapSubmissionAction === "object" ? mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action : mapSubmissionAction) || "").toUpperCase();
        const isProvisionallyApprove = selectedActionName.includes("PROVISION") || selectedActionName === "PROVISIONALLY_APPROVAL" || selectedActionName === "PROVISIONALLY_APPROVE";
        const isDrawingSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfDscEmp) === true || (formData === null || formData === void 0 ? void 0 : formData.IsSanctionDrawing) === true);
        const status = (formData === null || formData === void 0 ? void 0 : formData.status) || "";
        const isDscStage = status.startsWith("APPLY_FOR_DSC");
        const isApprovalSignedByEmp = (formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) === true;
        const isFullySigned = isApprovalSignedByEmp && Boolean(isDrawingSignedByEmp);
        const guardedHandleSubmit = () => {
          if (isDscStage && !isFullySigned) {
            setValidationPopup(true);
            return;
          }
          handleSubmit();
        };
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isDscStage && /*#__PURE__*/React__default.createElement(NewsTicker, {
          textForNews: "Please make a digital sign on sanction letter and approval letter"
        }), /*#__PURE__*/React__default.createElement(SubmitButton, {
          handleSubmit: guardedHandleSubmit,
          isLoading: updateApiCall.isLoading,
          showButton: !isFromDashboard
        }));
      })());
    } else if (activeTab === (isCompounding ? 8 : 7)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (activeTab === (isCompounding ? 9 : 8)) {
      var _workflowDetails$data;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData,
        assignerToChatboard: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.processInstances
      }));
    } else if (activeTab === (isCompounding ? 10 : 9)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CustomLetter, {
        formData: formData,
        setCustomLetter: setCustomLetter,
        setTypeOfLetter: setTypeOfLetter,
        workflowDetails: workflowDetails,
        userRolesArray: userRolesArray,
        initialUrl: initialUrl,
        setIsPreviewLoading: setIsPreviewLoading,
        setIframeSrc: setIframeSrc,
        iframeSrc: iframeSrc
      }));
    } else if (activeTab === (isCompounding ? 11 : 10) && isPurchasbleReq) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PurchasableFARInfo, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        handleNoWorkflowPFAR: handleNoWorkflowPFAR,
        isJE: isJE
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), isCompounding && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Compounding Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "NOC Status"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Site Inspection"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Payment Heads"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }), isPurchasbleReq && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Purchasable FAR"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    setIsPreviewLoading: setIsPreviewLoading,
    setIframeSrc: setIframeSrc,
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), validationPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    },
    onClick: () => setValidationPopup(false)
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#fff",
      borderRadius: "8px",
      padding: "32px 28px 24px",
      maxWidth: "440px",
      width: "90%",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      position: "relative"
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "28px"
    }
  }, "\u26A0\uFE0F"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: 700,
      fontSize: "18px",
      color: "#b45309"
    }
  }, "Digital Signature Required")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "0 0 12px",
      color: "#374151",
      lineHeight: "1.6"
    }
  }, "You cannot submit at this stage without completing the digital signatures. Please ensure the following are signed:"), /*#__PURE__*/React__default.createElement("ul", {
    style: {
      margin: "0 0 20px 18px",
      color: "#374151",
      lineHeight: "1.8"
    }
  }, /*#__PURE__*/React__default.createElement("li", null, "\u2705 ", /*#__PURE__*/React__default.createElement("b", null, "Sanction / Drawing Letter"), " \u2014 must be digitally signed by employee"), /*#__PURE__*/React__default.createElement("li", null, "\u2705 ", /*#__PURE__*/React__default.createElement("b", null, "Approval Certificate"), " \u2014 must be digitally signed by employee")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "0 0 24px",
      color: "#6b7280",
      fontSize: "13px"
    }
  }, "Once both documents are signed, you can proceed with the submission."), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => setValidationPopup(false),
    style: {
      backgroundColor: "#157C4F",
      borderRadius: "6px",
      textTransform: "none",
      fontWeight: 600
    }
  }, "OK, I understand")))), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const useEmpLandUse = (formData, workflowDetails, userRolesArray) => {
  var _userRolesArray$, _user$info, _user$info2, _location$pathname, _location$pathname2, _location$pathname3, _pdfDetails$pdfFiles, _formData$description, _user$info3, _user$info3$roles, _formData$documents, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState(null);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData === null || formData === void 0 ? void 0 : formData.documents);
  const [taxHead, setTaxHead] = useState([]);
  const [mandatoryCondition, setMandatoryCondition] = useState("");
  const [officerNocDetails, setOfficerNocDetails] = useState(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
  const [isNoNoc, setIsNoNoc] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [khasraRemarks, setKhasraRemarks] = useState((formData === null || formData === void 0 ? void 0 : formData.khasraRemarks) || "");
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState("");
  const [notingRemarksData, setNotingRemarksData] = useState({});
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const isEE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const isDa = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "CITIZEN";
  const inspectionReportChecklist = useSelector(state => state.inspectionReportChecklist);
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.inspectionReportData);
  const {
    reduxDocs
  } = useSelector(state => state.formMT);
  const userRolesWithoutEMP = user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.roles.filter(user => user.code != "EMPLOYEE");
  const Modal = useModal();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source") || "";
  console.log("fromDashboardcheckSource", source);
  const isFromDashboard = source === "dashboard" || (location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("dashboard-details")) || (location === null || location === void 0 ? void 0 : (_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.includes("dashboard-v2")) || (location === null || location === void 0 ? void 0 : (_location$pathname3 = location.pathname) === null || _location$pathname3 === void 0 ? void 0 : _location$pathname3.includes("dashboard"));
  const [initialUrl, setInitialUrl] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [currentView, setCurrentView] = useState("documents");
  const [showToast, setShowToast] = useState(null);
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [loader, setLoader] = useState(false);
  const userInfo = (user === null || user === void 0 ? void 0 : user.info) || {};
  const authToken = (user === null || user === void 0 ? void 0 : user.access_token) || null;
  const closeToast = () => setShowToast(null);
  const [khasraDetailsData, setKhasraDetailsData] = useState([]);
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [additionalComment, setAdditionalComment] = useState("");
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto"];
  const fetchInitialUrl = async fileStoreId => {
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    if (response.data.fileStoreIds[0].url) {
      setIframeSrc(response.data.fileStoreIds[0].url);
    }
  };
  const stripHtmlTags = html => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };
  useEffect(() => {
    var _documentSection$;
    if (documentSection !== null && documentSection !== void 0 && (_documentSection$ = documentSection[0]) !== null && _documentSection$ !== void 0 && _documentSection$.fileStoreId) {
      var _documentSection$2;
      fetchInitialUrl(documentSection === null || documentSection === void 0 ? void 0 : (_documentSection$2 = documentSection[0]) === null || _documentSection$2 === void 0 ? void 0 : _documentSection$2.fileStoreId);
    }
  }, []);
  const handleGetDocumentById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeCheckBox = event => {
    setChecked(event.target.checked);
  };
  const declarationMessage = "I, hereby, certify that all the information filled the Application Form by Applicant, has been checked and verified by me and the NOC checklist mentioned above are complete as per the applicable rules and Bylaws.";
  const declarationMessage2 = "I have reviewed the NOC checklist and confirm that the details I have provided are accurate and complete.";
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result));
    return String(result);
  };
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const isKYPForm = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_KYP";
  const department = formData === null || formData === void 0 ? void 0 : formData.department;
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_LANDUSE", formData);
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const {
    data: {
      BPA: {
        AVPSchemesUnitData: avpData
      } = {}
    } = {},
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["AVPSchemesUnitData"]);
  const avpUnits = avpData === null || avpData === void 0 ? void 0 : avpData.map(item => {
    return {
      name: item.Unit,
      label: item.Unit,
      value: item.Unit
    };
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  const documents = normalizeDocuments(docs);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let tabList = [{
    label: "Application Data",
    color: "red"
  }, !isCitizen && {
    label: "Document Section",
    color: "red"
  }, {
    label: "Take Action",
    color: "red"
  }, {
    label: "NOC Checklist",
    color: "green"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.selectLandUse) == "Conditional Permissible" ? !isCitizen && {
    label: "Conditions",
    color: "#fd6d0b"
  } : null, {
    label: "ChatBoard",
    color: "red"
  }].filter(Boolean);
  const userRoles = user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : (_user$info3$roles = _user$info3.roles) === null || _user$info3$roles === void 0 ? void 0 : _user$info3$roles.map(e => e.code);
  const documentSection = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => !["signature", "applicantPhoto", "kmlFile"].includes(doc.documentType));
  const checkIsBpaNoc = val => {
    if (!val) return false;
    if (typeof val === "string") return val.toUpperCase().includes("BPA_NOC_");
    if (Array.isArray(val)) return val.some(item => checkIsBpaNoc(item));
    if (typeof val === "object") return checkIsBpaNoc((val === null || val === void 0 ? void 0 : val.businessService) || (val === null || val === void 0 ? void 0 : val.applicationBusinessService));
    return false;
  };
  const isBpaNoc = Boolean(checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.applicationBusinessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.processInstances) || checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.nocList));
  const getValidityOfEmp = () => {
    var _formData$assignes;
    if (isBpaNoc) {
      return true;
    }
    if ((formData === null || formData === void 0 ? void 0 : (_formData$assignes = formData.assignes) === null || _formData$assignes === void 0 ? void 0 : _formData$assignes.length) > 0) {
      var _formData$assignes2, _formData$assignes2$, _formData$assignes3, _formData$assignes3$;
      console.log("loggingValidityOfEmp", (formData === null || formData === void 0 ? void 0 : (_formData$assignes2 = formData.assignes) === null || _formData$assignes2 === void 0 ? void 0 : (_formData$assignes2$ = _formData$assignes2[0]) === null || _formData$assignes2$ === void 0 ? void 0 : _formData$assignes2$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid));
      return (formData === null || formData === void 0 ? void 0 : (_formData$assignes3 = formData.assignes) === null || _formData$assignes3 === void 0 ? void 0 : (_formData$assignes3$ = _formData$assignes3[0]) === null || _formData$assignes3$ === void 0 ? void 0 : _formData$assignes3$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid);
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.actionState) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.nextActions) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.filter(e => {
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  const handleGetKhasraById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.bpaService.khasraDetails}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setKhasraDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  async function handleSubmit() {
    var _Digit, _Digit$SessionStorage, _Digit2, _Digit2$SessionStorag, _params$khasraDetails, _params$khasraDetails2, _params$khasraDetails3, _formData$description2, _Object$keys, _params$descriptionOf, _params$descriptionOf2, _params$descriptionOf3, _params$descriptionOf4, _params$descriptionOf5, _params$descriptionOf6, _params$descriptionOf7;
    console.log("isNoNOCApprovalLetter", isNoNoc);
    console.log("loggingActionFromEmpLandUse", currentAction);
    console.log("paramss1111", params);
    const isDocValidated = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("isDocValidated");
    const isNotingValidated = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$SessionStorag = _Digit2.SessionStorage) === null || _Digit2$SessionStorag === void 0 ? void 0 : _Digit2$SessionStorag.get("isNotingValidated");
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    if (!isNotingValidated) {
      Modal("Noting Remark", "Please add Noting Remark and click on Save", "error");
      return;
    }
    const selectedAction = (typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) || "";
    const isSendBackAction = typeof selectedAction === "string" && selectedAction.toUpperCase().includes("SEND_BACK");
    if (!isSendBackAction && !isDocValidated && (formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "FORM_PRESSRELEASE") {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return;
    }
    if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) == null) {
      console.log("coming here??44444");
      Modal("Action required", "Please select at least one action.", "error");
      return;
    }
    const isPressRelease = (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "FORM_PRESSRELEASE";
    if (!isPressRelease && (!isKYPForm && !(params !== null && params !== void 0 && params.khasraDetails) || (params === null || params === void 0 ? void 0 : (_params$khasraDetails = params.khasraDetails) === null || _params$khasraDetails === void 0 ? void 0 : _params$khasraDetails.length) < 1 || !(params !== null && params !== void 0 && (_params$khasraDetails2 = params.khasraDetails) !== null && _params$khasraDetails2 !== void 0 && (_params$khasraDetails3 = _params$khasraDetails2[0]) !== null && _params$khasraDetails3 !== void 0 && _params$khasraDetails3.selectedMasterPlan))) {
      Modal("Khasra details required", "Please fill relevant khasra information in khasra details section.", "error");
      return;
    }
    if (!isKYPForm && (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.selectLandUse) == "Conditional Permissible" && ((_Object$keys = Object.keys(mandatoryCondition)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) < 1) {
      console.log("coming here??2222222");
      Modal("Mandatory condition is required", "Please select mandatory condition from dropdown.", "error");
      return;
    }
    if (!isKYPForm && formData !== null && formData !== void 0 && formData.status.includes("APPLY_FOR_DSC") && !(formData !== null && formData !== void 0 && formData.IsApprovalCertificate)) {
      console.log("coming here??111111");
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return;
    }
    if (isKYPForm && (!(params !== null && params !== void 0 && (_params$descriptionOf = params.descriptionOfLand) !== null && _params$descriptionOf !== void 0 && _params$descriptionOf.plotFront) || !(params !== null && params !== void 0 && (_params$descriptionOf2 = params.descriptionOfLand) !== null && _params$descriptionOf2 !== void 0 && _params$descriptionOf2.plotRear) || !(params !== null && params !== void 0 && (_params$descriptionOf3 = params.descriptionOfLand) !== null && _params$descriptionOf3 !== void 0 && _params$descriptionOf3.plotSide1) || !(params !== null && params !== void 0 && (_params$descriptionOf4 = params.descriptionOfLand) !== null && _params$descriptionOf4 !== void 0 && _params$descriptionOf4.plotSide2) || !(params !== null && params !== void 0 && (_params$descriptionOf5 = params.descriptionOfLand) !== null && _params$descriptionOf5 !== void 0 && _params$descriptionOf5.maximumCoverage) || !(params !== null && params !== void 0 && (_params$descriptionOf6 = params.descriptionOfLand) !== null && _params$descriptionOf6 !== void 0 && _params$descriptionOf6.proposedGoundCoverageSqM) || !(params !== null && params !== void 0 && (_params$descriptionOf7 = params.descriptionOfLand) !== null && _params$descriptionOf7 !== void 0 && _params$descriptionOf7.landLength))) {
      console.log("coming here??111111");
      Modal("Plot details values missing", "Please fill the coverage, setabcks, fars and permissible height values", "error");
      return;
    }
    const plainText = stripHtmlTags(remarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    try {
      var _params$khasraDetails4;
      const additionalDetails = {
        ...(params === null || params === void 0 ? void 0 : params.additionalDetails)
      };
      const workflow = {
        action: currentAction.action,
        comment: remarks,
        comments: remarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction.action + " DOC",
          fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const customApprovalFileStore = localStorage.getItem("custom_approval_letter");
      const customApprovalDocs = customApprovalFileStore ? [{
        documentType: "customapprovalletter",
        fileStoreId: customApprovalFileStore
      }] : [];
      const rawDocs = (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents) || [];
      const updatedDocs = customApprovalDocs.length > 0 ? [...(Array.isArray(rawDocs) ? rawDocs.filter(d => (d === null || d === void 0 ? void 0 : d.documentType) !== "customapprovalletter") : []), ...customApprovalDocs] : rawDocs;
      const appData = {
        ...params,
        documents: updatedDocs,
        additionalDetails,
        workflow,
        nocDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.nocDetails),
          ...officerNocDetails
        },
        mandatoryCondition: mandatoryCondition,
        action: currentAction.action,
        comment: remarks,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction.action + " DOC",
          fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const data = {
        ...appData
      };
      await updateApiCall.mutate({
        LandUse: data
      }, {
        onSuccess: async result => {
          var _result$LandUse, _result$LandUse$, _Digit3, _Digit4;
          if (result !== null && result !== void 0 && (_result$LandUse = result.LandUse) !== null && _result$LandUse !== void 0 && (_result$LandUse$ = _result$LandUse[0]) !== null && _result$LandUse$ !== void 0 && _result$LandUse$.applicationNo) {
            var _result$LandUse2, _result$LandUse2$;
            sweetalert2_all.fire({
              title: "Application updated",
              text: `Action taken successfully for Application (${result === null || result === void 0 ? void 0 : (_result$LandUse2 = result.LandUse) === null || _result$LandUse2 === void 0 ? void 0 : (_result$LandUse2$ = _result$LandUse2[0]) === null || _result$LandUse2$ === void 0 ? void 0 : _result$LandUse2$.applicationNo})!`,
              icon: "success"
            }).then(() => {
              window.location.reload();
            });
          }
          (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("EMP_LANDUSE");
          (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("isDocValidated");
          localStorage.removeItem("custom_approval_letter");
        },
        onError: () => {
          Modal("Update Error", "Something went wrong!!", "error");
        }
      });
      console.log("loggingupdatePayloadLandUSe", data, params === null || params === void 0 ? void 0 : (_params$khasraDetails4 = params.khasraDetails) === null || _params$khasraDetails4 === void 0 ? void 0 : _params$khasraDetails4.length);
    } catch (error) {
      console.log(error);
    }
  }
  function handleChangeForward() {
    var _actions$;
    const validation = validateSummaryForm({
      formType: "FORMLANDUSE",
      formData: formData,
      reduxDocuments: reduxDocs,
      t
    });
    if (!validation.isValid) {
      Modal("Missing Mandatory Fields", validation.errorHtml, "error");
      return;
    }
    if ((actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "FORWARD_TO_DEPARTMENT") {
      try {
        const additionalDetails = {
          ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails)
        };
        const workflow = {
          action: "FORWARD_TO_DEPARTMENT",
          comment: remarks,
          comments: remarks,
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile ? [{
            documentType: currentAction.action + " DOC",
            fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
            fileStoreId: uploadedFile
          }] : null
        };
        const appData = {
          ...formData,
          documents: formData === null || formData === void 0 ? void 0 : formData.documents,
          additionalDetails,
          workflow,
          action: "FORWARD_TO_DEPARTMENT",
          comment: remarks,
          assignee: null,
          wfDocuments: uploadedFile ? [{
            documentType: currentAction.action + " DOC",
            fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
            fileStoreId: uploadedFile
          }] : null
        };
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({
          LandUse: appData
        }, tenantId).then(result => {
          var _result$LandUse3;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse3 = result.LandUse) === null || _result$LandUse3 === void 0 ? void 0 : _result$LandUse3.length) > 0) {
            var _result$LandUse4, _result$LandUse4$;
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result === null || result === void 0 ? void 0 : (_result$LandUse4 = result.LandUse) === null || _result$LandUse4 === void 0 ? void 0 : (_result$LandUse4$ = _result$LandUse4[0]) === null || _result$LandUse4$ === void 0 ? void 0 : _result$LandUse4$.applicationNo}) Updated Successfully!`
            });
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  async function handleChangePayment() {
    var _actions$2, _actions$3;
    if ((actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action) === "MAKE_PAYMENT") {
      const additionalDetails = {
        ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails)
      };
      const workflow = {
        action: "MAKE_PAYMENT",
        comment: "Payment Done",
        comments: "Payment Done",
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: actions + " DOC",
          fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...formData,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents,
        additionalDetails,
        workflow,
        action: "MAKE_PAYMENT",
        comments: "Payment Done",
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: currentAction.action + " DOC",
          fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
          fileStoreId: uploadedFile
        }] : null
      };
      Digit.OBPSService.updateFormLandUse({
        LandUse: appData
      }, tenantId).then(result => {
        var _result$LandUse5;
        if ((result === null || result === void 0 ? void 0 : (_result$LandUse5 = result.LandUse) === null || _result$LandUse5 === void 0 ? void 0 : _result$LandUse5.length) > 0) {
          var _result$LandUse6, _result$LandUse6$;
          console.log("resultFromLandUseUpdate", result);
          setShowToast({
            key: "true",
            error: false,
            message: `Application Updated Successfully! Redirecting to the payment page...`
          });
          window.location.assign(`${citizenBaseUrl$1}/payment/collect/BPA.LAND_USE_FORM/${result === null || result === void 0 ? void 0 : (_result$LandUse6 = result.LandUse) === null || _result$LandUse6 === void 0 ? void 0 : (_result$LandUse6$ = _result$LandUse6[0]) === null || _result$LandUse6$ === void 0 ? void 0 : _result$LandUse6$.applicationNo}/${tenantId}/tenantId=${tenantId}`);
        }
      });
    }
    if ((actions === null || actions === void 0 ? void 0 : (_actions$3 = actions[0]) === null || _actions$3 === void 0 ? void 0 : _actions$3.action) === "MAKE_PAYMENT_APPLICATION_FEE") {
      try {
        const additionalDetails = {
          ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails)
        };
        const workflow = {
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comment: "Payment Done",
          comments: "Payment Done",
          assignee: null,
          assignes: null,
          varificationDocuments: uploadedFile ? [{
            documentType: currentAction.action + " DOC",
            fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
            fileStoreId: uploadedFile
          }] : null
        };
        const appData = {
          ...formData,
          documents: formData === null || formData === void 0 ? void 0 : formData.documents,
          additionalDetails,
          workflow,
          action: "MAKE_PAYMENT_APPLICATION_FEE",
          comments: "Payment Done",
          assignee: null,
          wfDocuments: uploadedFile ? [{
            documentType: currentAction.action + " DOC",
            fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
            fileStoreId: uploadedFile
          }] : null
        };
        console.log("appData2222222222", appData);
        Digit.OBPSService.updateFormLandUse({
          LandUse: appData
        }, tenantId).then(result => {
          var _result$LandUse7;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse7 = result.LandUse) === null || _result$LandUse7 === void 0 ? void 0 : _result$LandUse7.length) > 0) {
            var _result$LandUse8, _result$LandUse8$;
            setShowToast({
              key: "true",
              error: false,
              message: `Application (${result === null || result === void 0 ? void 0 : (_result$LandUse8 = result.LandUse) === null || _result$LandUse8 === void 0 ? void 0 : (_result$LandUse8$ = _result$LandUse8[0]) === null || _result$LandUse8$ === void 0 ? void 0 : _result$LandUse8$.applicationNo}) Updated Successfully!`
            });
            history.replace(`${citizenBaseUrl$1}/payment/collect/${params === null || params === void 0 ? void 0 : params.businessService}/${params === null || params === void 0 ? void 0 : params.applicationNo}/${tenantId}/tenantId=${tenantId}`, {
              data: params
            });
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
  const handleNoWorkflow = updatedDocuments => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);
    const appData = {
      ...params,
      workflow,
      documents: updatedDocuments
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse9, _result$LandUse10, _result$LandUse10$, _result$LandUse10$$do, _Digit5;
        console.log("resultFromUpdate", result);
        setDeveloperUpdateDocument("DocumentDetailsUpdated");
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse9 = result.LandUse) === null || _result$LandUse9 === void 0 ? void 0 : _result$LandUse9[0]);
        const isDocValidated = result === null || result === void 0 ? void 0 : (_result$LandUse10 = result.LandUse) === null || _result$LandUse10 === void 0 ? void 0 : (_result$LandUse10$ = _result$LandUse10[0]) === null || _result$LandUse10$ === void 0 ? void 0 : (_result$LandUse10$$do = _result$LandUse10$.documents) === null || _result$LandUse10$$do === void 0 ? void 0 : _result$LandUse10$$do.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).every(item => !item.isMandatory || item.documentRemarks !== null);
        (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set("isDocValidated", isDocValidated);
      },
      onError: () => {
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleAdditionalComment = () => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      workflow,
      additionalComment: additionalComment
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse11;
        console.log("resultFromUpdate1212123", result);
        Modal("Additional Comment Added", "Additional Comment Added Successfully !", "success");
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse11 = result.LandUse) === null || _result$LandUse11 === void 0 ? void 0 : _result$LandUse11[0]);
      },
      onError: err => {
        console.log("Error21", err);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleChecklistNoWorkflow = conversionChecklist => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    console.log("checklistFromNoworkflow", conversionChecklist);
    const appData = {
      ...params,
      workflow,
      conversionChecklist: conversionChecklist
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse12;
        console.log("resultFromUpdate", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse12 = result.LandUse) === null || _result$LandUse12 === void 0 ? void 0 : _result$LandUse12[0]);
        Modal(`Checklist Saved`, `Checklist details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      },
      onError: () => {
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleNoWorkflowWithData = data => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);
    const appData = {
      ...formData,
      ...data,
      workflow
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse13;
        console.log("resultFromUpdate", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse13 = result.LandUse) === null || _result$LandUse13 === void 0 ? void 0 : _result$LandUse13[0]);
        Modal(`Application updated.`, `Application Updated Successfully!`, "success");
      },
      onError: () => {
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const updateKhasraDetails = (khasraDetails, khasraRemarks) => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    console.log("updatedDocumentsFromNoworkflow", updatedDocuments);
    const appData = {
      ...params,
      workflow,
      khasraDetails,
      khasraRemarks
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse14;
        console.log("resultFromUpdate", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse14 = result.LandUse) === null || _result$LandUse14 === void 0 ? void 0 : _result$LandUse14[0]);
        Modal(`Land Use details updated`, `Khasra details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      },
      onError: () => {
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
  };
  const handleGetNotingById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.bpaService.remarksNoting}applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const callNotingDetailsAPI = async () => {
    var _userRolesArray$3, _userRolesArray$4;
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$4 = userRolesArray[0]) === null || _userRolesArray$4 === void 0 ? void 0 : _userRolesArray$4.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "notingDetails",
        notingDetails: {
          developerRemarks: developerRemarks
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {});
      console.log("log1223Noting", Resp === null || Resp === void 0 ? void 0 : Resp.data);
      setLoader(false);
      Modal("Noting remarks saved.", `Remarks for <strong>${formData === null || formData === void 0 ? void 0 : formData.applicationNo}</strong> saved successfully`, "success");
      await handleGetNotingById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      handleChange(undefined, "2");
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const callDocumentDetailsAPI = async (developerRemarksArg, dataRecommendationArg, updatedDocumentsArg) => {
    var _userRolesArray$5, _userRolesArray$6;
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$5 = userRolesArray[0]) === null || _userRolesArray$5 === void 0 ? void 0 : _userRolesArray$5.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$6 = userRolesArray[0]) === null || _userRolesArray$6 === void 0 ? void 0 : _userRolesArray$6.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "DocumentDetails",
        documentDetails: {
          dataRecommendation: dataRecommendationArg !== undefined ? dataRecommendationArg : dataRecommendationDocument,
          developerRemarks: developerRemarksArg !== undefined ? developerRemarksArg : developerRemarksDocument,
          documents: updatedDocumentsArg !== undefined ? updatedDocumentsArg : updatedDocuments
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    Modal(`Documents updated`, `Documents details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
    await handleGetDocumentById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "2");
  };
  const callKhasraDetailsApi = async (khasraDetails = {}, khasraRemarks) => {
    var _userRolesArray$7, _userRolesArray$8;
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$7 = userRolesArray[0]) === null || _userRolesArray$7 === void 0 ? void 0 : _userRolesArray$7.code,
          applicationID: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$8 = userRolesArray[0]) === null || _userRolesArray$8 === void 0 ? void 0 : _userRolesArray$8.name,
          applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status
        },
        isApproved: "khasraDetails",
        khasraDetails,
        khasraRemarks,
        documentDetails: {
          dataRecommendation: dataRecommendationDocument,
          developerRemarks: developerRemarksDocument,
          documents: updatedDocuments
        }
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log1223", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    await handleGetKhasraById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleChange(undefined, "2");
  };
  const handleDocView = () => {
    setCurrentView(prev => prev === "documents" ? "viewDocuments" : "documents");
  };
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = value => {
    setCurrentAction(value);
  };
  useEffect(() => {
    var _formData$documents2, _Digit6;
    const isDocValidated = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).every(item => !item.isMandatory || item.documentRemarks !== null);
    console.log("loggingIsDocValidated", isDocValidated);
    (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("isDocValidated", isDocValidated);
  }, []);
  useEffect(() => {
    handleGetDocumentById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleGetNotingById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    handleGetKhasraById(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    handleNoWorkflowWithData,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    developerUpdateDocument,
    handleChecklistNoWorkflow,
    isFromDashboard,
    callDocumentDetailsAPI,
    avpData,
    avpUnits,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
    isValidEmp,
    isBpaNoc
  };
};

const fastpasinfoUrlbg = "https://abmhosting.in/fastpass/homepage/avp4/assets/img/about.jpg";

let _ = t => t,
  _t,
  _t2;
const fadeInDown = keyframes(_t || (_t = _`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`));
const pulsate = keyframes(_t2 || (_t2 = _`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0.6;
  }
`));
const HomeWrapper = styled$2("div")(({
  theme
}) => ({}));
const HeaderWrapper = styled$2(Box)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  height: "30px",
  paddingLeft: '13px',
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
}));
const LeftContent = styled$2(Box)(({
  theme
}) => ({
  marginLeft: "0%",
  fontSize: theme.typography.fontSize,
  color: "#fff"
}));
const DepartmentButton = styled$2(Button$2)(({
  theme
}) => ({
  color: "#fff",
  backgroundColor: "rgb(61 157 149)",
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgb(50 109 104)",
    color: "#fff"
  }
}));
const RightButtonContent = styled$2(Box)(({
  theme
}) => ({
  marginRight: "5%",
  display: "flex",
  alignItems: "center",
  color: "#fff",
  height: "2.5rem"
}));
const RightContent = styled$2(Box)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  alignItems: "center"
}));
const HeaderGovtWrapper = styled$2(Box)(({
  theme
}) => ({
  position: "sticky",
  animation: "fill 11s linear",
  animationFillMode: "forwards",
  top: "0",
  left: "0",
  right: "0",
  zIndex: "1000",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: "1rem",
  background: `url("https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png")`,
  borderWidth: "2px 2px 0 2px",
  borderColor: "rgb(17, 27, 40)",
  borderStyle: "solid",
  [`@media (max-width: 1024px)`]: {
    flexDirection: "column",
    alignItems: "flex-start"
  },
  backgroundColor: "rgb(237, 240, 244)"
}));
const LeftGovtContent = styled$2(Box)(({
  theme
}) => ({
  backgroundImage: "	https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png",
  backgroundColor: "rgb(237, 240, 244)",
  marginLeft: "1%",
  marginRight: "1%",
  minHeight: "60px",
  [`@media (max-width: 500px)`]: {
    marginLeft: "0.5%",
    marginBottom: "0.1rem"
  }
}));
const RightGovtContent = styled$2("div")(({
  theme
}) => ({
  display: "flex",
  marginRight: "0%",
  alignItems: "right ",
  backgroundColor: "rgb(237, 240, 244)",
  [`@media (max-width: 400px)`]: {
    marginLeft: "20%"
  }
}));
const TopBarWrapper = styled$2("div")(({
  theme
}) => ({
  position: "sticky",
  zIndex: 1000,
  top: 0
}));
const SlideWrapper = styled$2("div")(({
  bgimg,
  isLoaded
}) => ({
  width: "70%",
  height: "400px",
  float: "left",
  background: `
          linear-gradient(rgba(0, 30, 139, 0.2), rgba(0, 30, 139, 0.3)),
          url('${bgimg}') center center / cover no-repeat
        `,
  filter: isLoaded ? "none" : "blur(10px)",
  transition: "background 1.5s ease-in-out, filter 0.5s ease",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    zIndex: 1
  }
}));
const LoginCardWrapper = styled$2("div")(({
  theme,
  bgimg
}) => ({
  width: "30%",
  height: "400px",
  float: "right",
  background: `linear-gradient(#00000070,#0000007d), url('https://i.ibb.co/QvT4DmKv/sidebar.jpg') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1
  }
}));
const SlideLoginCardWrapper = styled$2("div")(({
  theme,
  bgimg
}) => ({
  width: "100%",
  height: "378px",
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1
  }
}));
const SlideText = styled$2(Box)(({
  theme
}) => ({
  position: "absolute",
  width: "80%",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2,
  color: "white",
  textAlign: "center",
  padding: "0 2rem",
  [theme.breakpoints.up("lg")]: {}
}));
const WelcomeSlideText = styled$2(Box)(({
  theme,
  isVisible
}) => ({
  fontSize: "1.5rem",
  fontWeight: "800",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  opacity: isVisible ? 1 : 0,
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  fontFamily: '"Raleway", sans-serif'
}));
const EDCRSlideText = styled$2(Box)(({
  theme
}) => ({
  fontSize: "1.50rem",
  fontFamily: '"Raleway", sans-serif',
  fontWeight: "500",
  lineHeight: "1.2",
  marginTop: "1rem"
}));
const ParaSlideText = styled$2(Box)(({
  theme,
  isVisible
}) => ({
  fontFamily: '"Raleway", sans-serif',
  marginTop: "1rem",
  fontWeight: "600",
  fontSize: "1rem",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  opacity: isVisible ? 1 : 0,
  transition: "transform 2s ease-in-out, opacity 2s ease-in-out"
}));
const FASTPasHeader = styled$2(Box)(({
  theme
}) => ({
  textAlign: "center",
  position: "relative",
  marginTop: "1.5rem"
}));
const TopButton = styled$2("div")(({
  theme
}) => ({
  position: "relative",
  float: "right",
  width: "100%",
  right: "10px",
  bottom: "80px",
  height: "10px",
  fontSize: "3rem",
  zIndex: "1",
  cursor: "pointer",
  color: "#CFE8DF"
}));
const StreamText = styled$2("div")(({
  theme
}) => ({
  fontSize: "1rem",
  fontWeight: "600",
  paddingBottom: "1.25rem",
  lineHeight: "1.2",
  color: theme.palette.awasbandhu.primary.main,
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    display: "block",
    width: "4rem",
    height: "3px",
    backgroundColor: "#5cb874",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: 0
  }
}));
const FastPasPanelWrapper = styled$2("div")({
  display: "flex",
  justifyContent: "space-around",
  padding: "1rem",
  gap: "0.5rem"
});
const VideoBox = styled$2("div")({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${fastpasinfoUrlbg})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "6rem",
    height: "6rem",
    borderRadius: "50%",
    background: "#5cb874",
    border: "5px solid #ffffff",
    zIndex: 1,
    animation: `${pulsate} 2s infinite`
  },
  "&::after": {
    content: '""',
    position: "absolute",
    width: "0",
    height: "0",
    borderLeft: "30px solid white",
    borderTop: "20px solid transparent",
    borderBottom: "20px solid transparent",
    borderRight: "-5px solid transparent",
    left: "calc(50% + 5px)",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2
  }
});
const ContentBox = styled$2("div")(({
  theme
}) => ({
  width: "100%",
  transform: "translateY(-7.5rem)",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  textAlign: "justify",
  "& h1": {
    fontSize: "3rem",
    fontWeight: "bold",
    color: theme.palette.awasbandhu.primary.main,
    marginBottom: "0.5rem",
    textDecoration: "none"
  },
  "& p": {
    fontSize: "1rem",
    marginBottom: "0.5rem",
    lineHeight: "1.5",
    textAlign: "justify"
  }
}));
const CardsWrappers = styled$2("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: "2rem",
  gap: "1.5rem",
  height: "fit-content",
  flexWrap: "wrap",
  marginBottom: "2rem"
});
const InfoCard = styled$2(Box)(({
  theme
}) => ({
  width: "32.5%",
  backgroundColor: "#f8f9fa",
  borderRadius: "5px",
  boxShadow: "0px 0 30px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  padding: "1rem"
}));
const CardInfoHeader = styled$2("div")(({
  theme
}) => ({
  color: "#364A65",
  fontSize: "1.2rem",
  fontWeight: "bold",
  textAlign: "left",
  padding: ".25rem",
  paddingLeft: ".75rem",
  "& hover": {
    backgroundColor: "#364A65",
    color: "rgb(168 40 40)"
  }
}));
const CardInfoContent = styled$2("div")({
  padding: "1 rem",
  "& p": {
    marginBottom: "1rem",
    lineHeight: "1.4"
  }
});
const ReadMoreButton = styled$2(Button$2)(({
  theme
}) => ({
  marginTop: "1rem",
  backgroundColor: "#4caf50",
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark
  }
}));
const FPFooterWrapper = styled$2(Box)(({
  theme
}) => ({
  padding: "7px",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  color: "#ffffff",
  textAlign: "center",
  borderTop: "1px solid #ffffff3b"
}));
const FooterFPText = styled$2(Typography)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "11px",
  textAlign: "center",
  alignItems: "center"
}));
const AboveFooterWrappers = styled$2(Box)(({
  theme
}) => ({
  backgroundColor: "#253243",
  color: "#ffffff",
  padding: "2rem"
}));
const SocialIcons = styled$2(Box)(({
  theme
}) => ({
  display: "inline-block",
  margin: "10px",
  "& svg": {
    fontSize: "2rem",
    color: "#1c1052",
    transition: "color 0.3s",
    "&:hover": {
      color: theme.palette.primary.main
    }
  }
}));
const AddressCard = styled$2(Card$1)(({
  theme
}) => ({
  padding: "0.4rem",
  backgroundColor: "#fff",
  boxShadow: "0px 0 20px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px"
}));
const FormCard = styled$2(Card$1)(({
  theme
}) => ({
  padding: "0.5rem",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  gap: "0.5 rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px"
}));
const CardWrapper = styled$2(Box)(({
  theme
}) => ({
  display: "flex",
  justifyContent: "space-around",
  gap: "2rem",
  flexWrap: "wrap",
  marginTop: "2rem"
}));
const HeaderContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  paddingBlock: theme.spacing(1),
  alignItems: "center",
  display: "flex"
}));
const HeaderTitle = styled$2(Box)(() => ({
  textAlign: "center"
}));
const Title1 = styled$2(Typography)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["50"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.4,
    color: theme.palette.mode === "dark" ? theme.palette.grey["100"] : "#191B20"
  }
}));
const Title2 = styled$2(Typography)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["100"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.6,
    color: theme.palette.mode === "dark" ? theme.palette.grey["50"] : "#0C0D10"
  }
}));
const MenuWrapper = styled$2(AppBar)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  minHeight: theme.spacing(6.25),
  [theme.breakpoints.up("lg")]: {
    color: theme.palette.common.black,
    backgroundColor: "transparent",
    minHeight: theme.spacing(5)
  },
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavToolbar = styled$2(Toolbar)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  padding: theme.spacing(0.5, 0),
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(1, 0),
    justifyContent: "center"
  },
  minHeight: theme.spacing(4),
  columnGap: theme.spacing(1),
  textAlign: "center"
}));
const StyledMenu = styled$2(Menu$1)(({
  theme
}) => ({
  "& .MuiMenu-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    borderRadius: theme.shape.borderRadius * 0.75,
    translateY: theme.spacing(0.5),
    minWidth: 140,
    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      textAlign: "left",
      display: "block",
      width: "100%"
    }
  }
}));
const MenuItem = styled$2(Button$2)(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.primary.contrastText,
  paddingBlock: theme.spacing(0.25)
}));
const StyledDivider$1 = styled$2(Divider)(({
  theme
}) => ({
  height: theme.spacing(3.25) + " !important",
  color: theme.palette.grey["50"],
  alignSelf: "center"
}));
const StyledDrawer = styled$2(Drawer)(({
  theme
}) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    boxSizing: "border-box",
    overflow: "hidden",
    "& .subMenu": {
      backgroundColor: alpha(theme.palette.common.black, 0.1),
      paddingInline: theme.spacing(2),
      "& .MuiButton-root": {
        display: "block",
        textAlign: "left",
        width: "100%"
      }
    },
    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      justifyContent: "space-between",
      lineHeight: theme.spacing(5),
      borderRadius: 0,
      "&.MuiButton-contained, &.MuiButton-outlined": {
        paddingInline: theme.spacing(3)
      },
      "&.MuiButton-outlined": {
        borderColor: alpha(theme.palette.common.black, 0.1)
      }
    },
    "& .MuiDivider-vertical": {
      height: "1px !important",
      display: "block",
      width: "100%"
    }
  }
}));
const HeroWrapper = styled$2(Box)(({
  theme,
  bgimg
}) => ({
  background: `${theme.palette.grey["200"]} url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  minHeight: `calc(100dvh - 50px)`,
  position: "relative",
  [theme.breakpoints.up("lg")]: {
    minHeight: `calc(100dvh - 150px)`
  }
}));
const HeroTopLeftMessage = styled$2(Box)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.25),
  fontWeight: theme.typography.fontWeightMedium,
  textShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.75)",
  inset: theme.spacing(4, 4, "auto", 4),
  [theme.breakpoints.up("sm")]: {
    inset: theme.spacing(4, "auto", "auto", 4)
  },
  fontSize: theme.typography.fontSize * 1.4,
  color: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  backdropFilter: "blur(1px)",
  padding: theme.spacing(2),
  position: "absolute"
}));
const HeroMantriStrip = styled$2(Box)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  inset: theme.spacing("auto", 0, 2),
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3, 8)
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(3, 12)
  },
  backdropFilter: "blur(1px)",
  position: "absolute"
}));
const PersonCard = styled$2(Grid)(({
  theme
}) => ({
  justifyContent: "space-between",
  gap: theme.spacing(2),
  alignItems: "center",
  display: "flex"
}));
const PersonPic = styled$2(Box)(({
  theme
}) => ({
  "& img": {
    objectFit: "cover",
    display: "block",
    height: 80,
    width: 80
  }
}));
const PersonDesc = styled$2(Box)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.common.white,
  flex: 1,
  "& strong": {
    fontWeight: theme.typography.fontWeightMedium,
    display: "block"
  }
}));
const ServicesContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(4)
}));
const ServiceGrid = styled$2(Grid)(({
  theme
}) => ({
  justifyContent: "center",
  "& .MuiButtonBase-root": {
    fontWeight: theme.typography.fontWeightSemiBold,
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
    flex: 1,
    "& img": {
      marginBottom: theme.spacing(1),
      display: "block",
      margin: "auto",
      maxWidth: 150
    }
  }
}));
const AppDetailsWrapper = styled$2(Box)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.ud.primary.text,
  paddingBlock: theme.spacing(3.75)
}));
const AppDetailsContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"]
}));
const AppDetailsHead = styled$2(Typography)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize * 2,
  marginBottom: theme.spacing(2),
  textTransform: "uppercase"
}));
const AppDetailsLabel = styled$2(Box)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 1.5
}));
const AppDetailsValue = styled$2(Box)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 6
}));
const FormsContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(3),
  flexDirection: "column",
  alignItems: "stretch",
  display: "flex",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    flexDirection: "row"
  },
  "& > div": {
    flex: 1,
    textAlign: "center",
    padding: theme.spacing(2, 3, 3),
    "&.feedbackForm": {
      paddingInline: 0
    },
    [theme.breakpoints.up("md")]: {
      "&.feedbackForm": {
        padding: theme.spacing(2, 3, 3)
      },
      textAlign: "right"
    },
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.ud.primary.main,
      marginBottom: theme.spacing(1.5),
      textTransform: "uppercase",
      textAlign: "left"
    }
  }
}));
const ChecklistWrapper = styled$2(Box)(({
  theme
}) => ({
  border: "1px solid #F7A143",
  marginInline: "auto",
  maxWidth: 530,
  "& .content": {
    marginBottom: theme.spacing(2),
    textAlign: "left",
    "& p": {
      fontSize: theme.typography.fontSize,
      marginBottom: theme.spacing(1)
    }
  },
  "& .MuiButton-root": {
    color: theme.palette.ud.primary.main,
    textTransform: "unset"
  }
}));
const FeedbackWrapper = styled$2(Box)(({
  theme
}) => ({
  padding: theme.spacing(0),
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    textAlign: "right"
  }
}));
const FormContainer = styled$2(Box)(({
  theme
}) => ({
  marginInline: "auto",
  textAlign: "center",
  maxWidth: 530,
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
    marginRight: 0,
    maxWidth: 450
  },
  '& button[type="submit"]': {
    width: "100%"
  },
  "&.tcp": {
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.tcp.primary.main,
      marginBottom: theme.spacing(1.5),
      marginRight: theme.spacing(4),
      textTransform: "uppercase",
      textAlign: "center"
    },
    "& .MuiFormGroup-root": {
      "& label .MuiFormControlLabel-label, & label svg": {
        color: theme.palette.tcp.primary.main
      },
      "& label svg": {
        fill: theme.palette.tcp.primary.main
      },
      justifyContent: "center",
      gap: theme.spacing(2),
      "& .MuiButtonBase-root": {
        padding: theme.spacing(1)
      }
    }
  }
}));
const StyledRadioGroup$4 = styled$2(RadioGroup$1)(({
  theme
}) => ({
  "& label": {
    "&.MuiFormControlLabel-root": {
      marginBottom: 0
    },
    "& .MuiFormControlLabel-label": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.1,
      color: theme.palette.ud.primary.main
    },
    "& svg": {
      fill: theme.palette.ud.primary.main
    }
  }
}));
const FooterWrapper = styled$2("footer")(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center"
}));
const TcpFooterWrapper = styled$2("footer")(({
  theme
}) => ({
  backgroundColor: theme.palette.tcp.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center"
}));

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 100) {
      setVisible(true);
    } else if (scrolled <= 100) {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  window.addEventListener("scroll", toggleVisible);
  return /*#__PURE__*/React__default.createElement(TopButton, null, /*#__PURE__*/React__default.createElement(FaArrowCircleUp, {
    onClick: scrollToTop,
    style: {
      display: visible ? "inline" : "none",
      float: 'right',
      marginTop: '30px',
      marginLeft: "20px",
      width: '30px',
      height: '25px',
      color: "#3B4B95"
    }
  }));
};

const ownerEntry = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE"
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT"
  }
};
const SubStep1$1 = ({
  formData,
  handleSubTabChange,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  id,
  setShowToast,
  setParams
}) => {
  var _userInfo$info, _formData$professiona, _formData$landInfo, _formData$landInfo$ow, _watchOffice$split$;
  const {
    documents
  } = useSelector(state => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const {
    t
  } = useTranslation();
  const userInfo = Digit.UserService.getUser();
  const roles = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.roles) || [];
  const isLtp = roles.some(role => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role.code));
  const isOwner = roles.some(role => role.code === "OWNER") && !isLtp;
  const defaultMobileNumber = isOwner ? (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.mobileNumber) || "" : "";
  const defaultValues = {
    ...formData,
    department: applicationFlow,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData.landInfo.owners.map((owner, index) => ({
        ...owner,
        mobileNumber: index === 0 ? (owner === null || owner === void 0 ? void 0 : owner.mobileNumber) || defaultMobileNumber : (owner === null || owner === void 0 ? void 0 : owner.mobileNumber) || ""
      })) : [{
        ...ownerEntry,
        mobileNumber: defaultMobileNumber
      }]
    },
    mobileNumber: defaultMobileNumber,
    documents
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = isDistrictDataLoading ? [] : districtData.map(district => ({
    label: district.name,
    value: district.name,
    name: district.name
  }));
  console.log("upDIstricts", updistricts);
  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    trigger,
    clearErrors
  } = useForm({
    defaultValues
  });
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const watchGovernmentBuilding = watch("isGovernmentBuilding") || (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding);
  const watchState = idx => {
    var _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3;
    return watch(`landInfo.owners[${idx}].correspondenceAddress.state`) || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[idx]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.correspondenceAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.state);
  };
  const watchOffice = watch("selectedOffice") || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice);
  const watchSelectedOffice = isDA ? watchOffice === null || watchOffice === void 0 ? void 0 : watchOffice.split("Development Authority")[0].trim() : watchOffice === null || watchOffice === void 0 ? void 0 : (_watchOffice$split$ = watchOffice.split(",")[1]) === null || _watchOffice$split$ === void 0 ? void 0 : _watchOffice$split$.trim();
  const watchUnit = watch("selectedUnit") || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit);
  const watchCity = watch("selectedCity") || (formData === null || formData === void 0 ? void 0 : formData.selectedCity);
  const filterCities = (unit, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C;
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : _masterData$filter$$C.map(item => {
      return {
        name: item.City,
        label: item.City,
        value: item.City
      };
    });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.isGovernmentBuilding) {
      setValue("isGovernmentBuilding", formData.isGovernmentBuilding);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding]);
  useEffect(() => {
    if (watchGovernmentBuilding === "yes") {
      owners.forEach((_, index) => {
        clearErrors(`landInfo.owners[${index}].aadhaarNumber`);
      });
    }
  }, [watchGovernmentBuilding, owners.length]);
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      var _formData$landInfo3, _formData$landInfo3$o;
      reset({
        ...formData,
        department: applicationFlow,
        landInfo: {
          ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
          owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : _formData$landInfo3$o.length) > 0 ? formData.landInfo.owners.map((owner, index) => ({
            ...owner,
            mobileNumber: index === 0 ? (owner === null || owner === void 0 ? void 0 : owner.mobileNumber) || defaultMobileNumber : (owner === null || owner === void 0 ? void 0 : owner.mobileNumber) || ""
          })) : [{
            ...ownerEntry,
            mobileNumber: defaultMobileNumber
          }]
        },
        mobileNumber: defaultMobileNumber,
        documents
      });
    }
  }, [formData]);
  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      try {
        if (isDA && watchSelectedOffice) {
          const location = watchSelectedOffice;
          const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
          setValue("businessService", res);
        } else if (!isDA && watchUnit && watchCity) {
          const location2 = watchCity;
          const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
          setValue("businessService", res);
        } else {
          setValue("businessService", null);
        }
      } catch (error) {
        console.error("Error fetching business services:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice, isDA, applicationFlow]);
  const validateFiles = () => {
    const uploadedDocs = documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType);
    const isValid = owners === null || owners === void 0 ? void 0 : owners.every((_, index) => uploadedDocs === null || uploadedDocs === void 0 ? void 0 : uploadedDocs.includes(`signature_${index}`));
    console.log("Validation Result:", isValid);
    return isValid;
  };
  const validateDistinctMobileNumbers = ownersList => {
    const allMobileNumbers = ownersList === null || ownersList === void 0 ? void 0 : ownersList.map(owner => owner.mobileNumber);
    const uniqueMobileNumbers = new Set(allMobileNumbers);
    return uniqueMobileNumbers.size === allMobileNumbers.length;
  };
  const validateDistinctAdhaarNumbers = ownersList => {
    var _ownersList$map;
    const allAdhaarNumbers = ownersList === null || ownersList === void 0 ? void 0 : (_ownersList$map = ownersList.map(owner => owner.aadhaarNumber)) === null || _ownersList$map === void 0 ? void 0 : _ownersList$map.filter(num => num && String(num).trim() !== "");
    const uniqueAdhaarNumbers = new Set(allAdhaarNumbers);
    return uniqueAdhaarNumbers.size === allAdhaarNumbers.length;
  };
  const onSubmit = data => {
    var _data$landInfo3, _data$landInfo4;
    if (isLtp) {
      var _data$landInfo2, _data$landInfo2$owner;
      const isOwnerMobileSame = (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : (_data$landInfo2$owner = _data$landInfo2.owners) === null || _data$landInfo2$owner === void 0 ? void 0 : _data$landInfo2$owner.some(owner => {
        var _userInfo$info2;
        return owner.mobileNumber === (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber);
      });
      if (isOwnerMobileSame) {
        setShowToast({
          error: true,
          message: `Owner's mobile number and LTP's mobile number can't be same`
        });
        return;
      }
    }
    if (!validateDistinctMobileNumbers((_data$landInfo3 = data.landInfo) === null || _data$landInfo3 === void 0 ? void 0 : _data$landInfo3.owners)) {
      setShowToast({
        error: true,
        message: `Mobile numbers must be distinct`
      });
      return;
    }
    if (!validateDistinctAdhaarNumbers((_data$landInfo4 = data.landInfo) === null || _data$landInfo4 === void 0 ? void 0 : _data$landInfo4.owners)) {
      setShowToast({
        error: true,
        message: `Aadhaar numbers must be distinct`
      });
      return;
    }
    const isValid = validateFiles();
    if (isValid) {
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity
            }
          }
        }
      };
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority")), isDA ? /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Select Development Authority",
    inputLabel: "Select office",
    placeholder: "Select office",
    name: "selectedOffice",
    type: formData !== null && formData !== void 0 && formData.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedOffice,
    data: SortingAlphabatically(officesList),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: [{
      label: "Yes",
      value: "yes"
    }, {
      label: "No",
      value: "no"
    }],
    label: t("Is this a Government Building ?"),
    name: "isGovernmentBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding,
    disabled: isEmployee || isApproved,
    type: "radioButton",
    mandatory: true,
    clickControl: e => {
      if (setParams) {
        setParams(prev => ({
          ...prev,
          isGovernmentBuilding: e.target.value
        }));
      }
    },
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))) : /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "searchSelect",
    data: SortingAlphabatically(avpUnits),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || "",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })), watchUnit ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "searchSelect",
    data: SortingAlphabatically(avpCities),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: [{
      label: "Yes",
      value: "yes"
    }, {
      label: "No",
      value: "no"
    }],
    label: t("Is this a Government Building ?"),
    name: "isGovernmentBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding,
    disabled: isEmployee || isApproved,
    type: "radioButton",
    mandatory: true,
    clickControl: e => {
      if (setParams) {
        setParams(prev => ({
          ...prev,
          isGovernmentBuilding: e.target.value
        }));
      }
    },
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null))), owners.map((owner, index) => {
    var _owner$correspondence, _owner$correspondence2;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: owner.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer",
      style: {
        marginTop: "26px"
      }
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, t(`Owner/Applicant ${index + 1} Details`)), index > 0 && !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "right",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "remove-owner-btn",
      onClick: () => removeOwner(index)
    }, "\u2716 Remove Owner"))), /*#__PURE__*/React__default.createElement(Container, {
      className: "formInputContainer common-app-form",
      fluid: true
    }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Name",
      control: control,
      placeholder: "Enter Name",
      name: `landInfo.owners[${index}].name`,
      type: "specialChar",
      allowedChars: "&/, ",
      maxLength: 200,
      mandatory: true,
      onlyAlphabet: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Father Name / Husband Name",
      placeholder: "Enter Father Name /Husband Name",
      name: `landInfo.owners[${index}].fatherOrHusbandName`,
      type: "specialChar",
      allowedChars: "&/, ",
      maxLength: 200,
      onlyAlphabet: true,
      validation: {},
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: t("Gender"),
      placeholder: t("Gender"),
      name: `landInfo.owners[${index}].gender`,
      type: "searchSelect",
      data: SortingAlphabatically(genderData),
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "Please select the gender"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      name: `landInfo.owners[${index}].mobileNumber`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("MobileNo"),
          message: "Please enter valid mobile no"
        }
      },
      disabled: isEmployee || isApproved || isOwner && !isLtp,
      maxLength: 10
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "E-mail ID",
      control: control,
      placeholder: "Enter E-mail ID",
      name: `landInfo.owners[${index}].emailId`,
      type: "textInput",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Email"),
          message: "Please enter valid email id"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Aadhaar Number",
      control: control,
      placeholder: "Enter Aadhaar Number",
      name: `landInfo.owners[${index}].aadhaarNumber`,
      type: "number",
      mandatory: watchGovernmentBuilding !== "yes",
      validation: {
        ...(watchGovernmentBuilding !== "yes" ? {
          required: {
            value: true,
            message: "This field is required"
          },
          pattern: {
            value: Digit.Utils.getPattern("AadharNo"),
            message: "Please enter valid Aadhaar no"
          }
        } : {
          validate: val => {
            if (!val) return true;
            return Digit.Utils.getPattern("AadharNo").test(val) || "Please enter valid Aadhaar no";
          }
        })
      },
      disabled: isEmployee || isApproved,
      maxLength: 12
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "State",
      placeholder: "Select State",
      defaultValue: (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.state,
      name: `landInfo.owners[${index}].correspondenceAddress.state`,
      type: "selectInput",
      disabled: isEmployee || isApproved,
      data: statesName,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      data: watchState(index) === "Uttar Pradesh" ? updistricts : undefined,
      label: t("LABEL_DISTRICT"),
      placeholder: watchState(index) === "Uttar Pradesh" ? "Select District" : "Enter District",
      defaultValue: (_owner$correspondence2 = owner.correspondenceAddress) === null || _owner$correspondence2 === void 0 ? void 0 : _owner$correspondence2.town,
      name: `landInfo.owners[${index}].correspondenceAddress.town`,
      type: watchState(index) === "Uttar Pradesh" ? "searchSelect" : "textInput",
      mandatory: true,
      maxLength: 25,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Name"),
          message: "Please enter only letters and spaces"
        }
      },
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Communication Address",
      placeholder: "Enter Communication Address",
      name: `landInfo.owners[${index}].correspondenceAddress.address`,
      type: "textInput",
      multiLine: true,
      mandatory: true,
      maxLength: 1000,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Address"),
          message: "Please enter valid Address"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      name: `landInfo.owners[${index}].correspondenceAddress.pinno`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Pincode"),
          message: "Please enter valid Pin Code"
        }
      },
      maxLength: 6,
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
      className: "custom-upload new-custom-uploader signature-attach-uploader"
    }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(FileUploader$3, {
      control: control,
      name: `signature_${index}`,
      label: "Attach Signature",
      validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
      isMandatory: true,
      required: true,
      tab: 2,
      maxFiles: 1,
      showError: showError
    }))), /*#__PURE__*/React__default.createElement(Col, null, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "add-owner-btn",
      onClick: () => {
        var _formData$professiona2;
        return appendOwner({
          ...ownerEntry,
          mobileNumber: isOwner ? (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.mobileNumber) || "" : ""
        });
      },
      style: {
        marginTop: "40px"
      }
    }, "+ Add Owner"))), /*#__PURE__*/React__default.createElement("br", null)));
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    disabled: loading,
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  })), /*#__PURE__*/React__default.createElement(ScrollButton, null)))));
};

const SubStep3$1 = ({
  formData,
  handleSubTabChange,
  t,
  archData,
  validity,
  usersData,
  isEmployee,
  isApproved
}) => {
  console.log("validityFromSUb3", formData, archData, validity, usersData);
  const professionalInformation = formData && formData.professionalInformation ? formData.professionalInformation : {};
  const currentUser = usersData && usersData.length > 0 ? usersData[0] : {};
  let formattedDate = "";
  if (currentUser && currentUser.validUpto) {
    const parsedDate = dayjs(currentUser.validUpto, "DD-MM-YYYY HH:mm:ss");
    if (parsedDate.isValid()) {
      formattedDate = parsedDate.format("DD-MM-YYYY");
    }
  }
  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...professionalInformation,
      planDate: formattedDate || professionalInformation.planDate || validity || "",
      licenseNumber: professionalInformation.licenseNumber || currentUser.registrationNumber || "",
      certificateNumber: professionalInformation.certificateNumber || currentUser.registrationArchitectNumber || "",
      consultantCategory: professionalInformation.consultantCategory || "",
      name: professionalInformation.name || "",
      mobileNumber: professionalInformation.mobileNumber || "",
      emailId: professionalInformation.emailId || ""
    }
  };
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues: defaultValues
  });
  useEffect(() => {
    let certificateNumber = "";
    if (formData && formData.professionalInformation && formData.professionalInformation.certificateNumber) {
      certificateNumber = formData.professionalInformation.certificateNumber;
    } else if (usersData && usersData.length > 0 && usersData[0] && usersData[0].registrationArchitectNumber) {
      certificateNumber = usersData[0].registrationArchitectNumber;
    }
    console.log("========================================");
    console.log("CERTIFICATE FROM FORMDATA =", formData && formData.professionalInformation && formData.professionalInformation.certificateNumber);
    console.log("CERTIFICATE FROM USERDATA =", usersData && usersData.length > 0 && usersData[0] ? usersData[0].registrationArchitectNumber : null);
    console.log("FINAL CERTIFICATE NUMBER =", certificateNumber);
    console.log("========================================");
    if (certificateNumber) {
      setValue("professionalInformation.certificateNumber", certificateNumber, {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false
      });
    }
  }, [formData, usersData, setValue]);
  useEffect(() => {
    let licenseNumber = "";
    if (formData && formData.professionalInformation && formData.professionalInformation.licenseNumber) {
      licenseNumber = formData.professionalInformation.licenseNumber;
    } else if (usersData && usersData.length > 0 && usersData[0] && usersData[0].registrationNumber) {
      licenseNumber = usersData[0].registrationNumber;
    }
    if (licenseNumber) {
      setValue("professionalInformation.licenseNumber", licenseNumber, {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false
      });
    }
  }, [formData, usersData, setValue]);
  const onSubmit = data => {
    const professionalData = data && data.professionalInformation ? data.professionalInformation : {};
    const updatedData = {
      ...data,
      professionalInformation: {
        ...professionalData,
        consultantCategory: formData && formData.professionalInformation && formData.professionalInformation.consultantCategory ? formData.professionalInformation.consultantCategory : professionalData.consultantCategory,
        licenseNumber: professionalData.licenseNumber || "",
        planDate: professionalData.planDate || "",
        certificateNumber: professionalData.certificateNumber || "",
        name: professionalData.name || "",
        mobileNumber: professionalData.mobileNumber || "",
        emailId: professionalData.emailId || ""
      }
    };
    console.log("========================================");
    console.log("DATA FROM SUB3 =", updatedData);
    console.log("CERTIFICATE SAVED IN SUB3 =", updatedData && updatedData.professionalInformation ? updatedData.professionalInformation.certificateNumber : null);
    console.log("========================================");
    handleSubTabChange(2, updatedData);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Consultant Category",
    control: control,
    disabled: Boolean(professionalInformation.consultantCategory) || isEmployee || isApproved,
    placeholder: "Enter Consultant Category",
    name: "professionalInformation.consultantCategory",
    type: "textInput",
    defaultValue: professionalInformation.consultantCategory,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    className: Boolean(professionalInformation.consultantCategory) ? "input-disabled" : ""
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    disabled: Boolean(professionalInformation.name) || isEmployee || isApproved,
    placeholder: "Enter Name",
    name: "professionalInformation.name",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isRequired: true,
    type: "textInput",
    mandatory: true,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Validity"),
    control: control,
    placeholder: "Enter Validity in DD-MM-YYYY format",
    disabled: Boolean(validity) || isEmployee || isApproved,
    name: "professionalInformation.planDate",
    type: "textInput",
    mandatory: true,
    isRequired: true,
    defaultValue: formattedDate || professionalInformation.planDate || validity,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Mobile No.",
    control: control,
    placeholder: "Enter Mobile No.",
    disabled: Boolean(professionalInformation.mobileNumber) || isEmployee || isApproved,
    name: "professionalInformation.mobileNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: isEmployee || isApproved,
    label: "Certificate No. (For Minimum Qualification)",
    name: "professionalInformation.certificateNumber",
    type: "textInput",
    height: "30px"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: Boolean(currentUser.registrationNumber) || isEmployee || isApproved,
    label: "License No.",
    name: "professionalInformation.licenseNumber",
    defaultValue: professionalInformation.licenseNumber || currentUser.registrationNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail Id",
    control: control,
    disabled: Boolean(professionalInformation.emailId) || isEmployee || isApproved,
    placeholder: "Enter E-mail Id",
    defaultValue: professionalInformation.emailId,
    name: "professionalInformation.emailId",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const SubStep4$1 = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  t,
  landSubUseTypes,
  landUseListActivities,
  landUsesSchemeTypeList,
  landSubUseTypes2,
  tenantId,
  departmentList,
  avpList,
  applicationFlow,
  avpData,
  isEmployee,
  isApproved,
  id,
  isEdit,
  setParams
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$professiona, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description30, _formData$description31;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.plotAreaSite);
  const {
    documents
  } = useSelector(state => state.formMT);
  const isEditMode = Boolean(isEdit);
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation,
      schemeType: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "",
      roadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.roadWidths) || [{
        value: ""
      }],
      approachRoadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.approachRoadWidths) || [{
        value: ""
      }],
      otherSides: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.otherSides) || [{
        value: ""
      }],
      multipleKhata: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.multipleKhata) || [{
        value: ""
      }],
      khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.khasraDetails) || [{
        district: "",
        tehsil: "",
        village: "",
        plotNo: ""
      }],
      multipleKhasra: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.multipleKhasra) || [{
        khasraNo: "",
        area: ""
      }]
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const handleCoordinateChange = (field, value) => {
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const {
    fields: multipleKhasra,
    append: addKhasra,
    remove: removeKhasra
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra"
  });
  const {
    fields: roadWidthsArray,
    append: addRoadWidthField,
    remove: removeRoadWidthField
  } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths"
  });
  const {
    fields: otherSides,
    append: addOtherSide,
    remove: removeOtherSide
  } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides"
  });
  const {
    fields: approachRoadWidths,
    append: addApproachRoad,
    remove: removeApproachWidth
  } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths"
  });
  const {
    fields: multipleKhata,
    append: addKhata,
    remove: removeKhata
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata"
  });
  const {
    fields: khasraDetails,
    append: addKhasraDetail,
    remove: removeKhasraDetail
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${formData === null || formData === void 0 ? void 0 : formData.selectedOffice}")]`
  }]);
  const {
    data: {
      BPA: {
        LandUseAvpVillageMasterData: avpVillagesData
      } = {}
    } = {},
    isLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseAvpVillageMasterData",
    filter: `$..Districts[?(@.District=='${formData === null || formData === void 0 ? void 0 : formData.selectedCity}')]`
  }]);
  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const watchMaster = watch("descriptionOfLand.landUsesType");
  const watchActivityAsPerMap = watch("descriptionOfLand.activityAsPerMap");
  const watchSubLayout = watch("descriptionOfLand.subLandUseAsPerLayout");
  const watchPlanOn = watch("descriptionOfLand.planOn");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const watchGovernmentBuilding = watch("isGovernmentBuilding") || (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding);
  console.log("loggingVillagesData", villagesData, avpVillagesData);
  console.log("departmentListFrom444", schemeTypeData, nonSchemeTypeData);
  const filterTehsilData = (masterData, authority, district) => {
    var _masterData$find, _masterData$find$Dist, _masterData$find$Dist2, _masterData$find$Dist3;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$Dist = _masterData$find.Districts) === null || _masterData$find$Dist === void 0 ? void 0 : (_masterData$find$Dist2 = _masterData$find$Dist.find(item => item.District === district)) === null || _masterData$find$Dist2 === void 0 ? void 0 : (_masterData$find$Dist3 = _masterData$find$Dist2.tehsils) === null || _masterData$find$Dist3 === void 0 ? void 0 : _masterData$find$Dist3.map(item => {
      return {
        name: item.tehsilName,
        label: item.tehsilName,
        value: item.tehsilName
      };
    }) : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterAvpTehsilData = (masterData, district) => {
    var _masterData$find2, _masterData$find2$teh;
    const tehsilArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => item.District === district)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : _masterData$find2$teh.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    return tehsilArray || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    var _masterData$find3, _masterData$find3$Dis, _masterData$find3$Dis2, _masterData$find3$Dis3, _masterData$find3$Dis4, _masterData$find3$Dis5;
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = str => str === null || str === void 0 ? void 0 : str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    const result = tehsil && district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : (_masterData$find3$Dis2 = _masterData$find3$Dis.find(item => (item === null || item === void 0 ? void 0 : item.District) === district)) === null || _masterData$find3$Dis2 === void 0 ? void 0 : (_masterData$find3$Dis3 = _masterData$find3$Dis2.tehsils) === null || _masterData$find3$Dis3 === void 0 ? void 0 : (_masterData$find3$Dis4 = _masterData$find3$Dis3.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find3$Dis4 === void 0 ? void 0 : (_masterData$find3$Dis5 = _masterData$find3$Dis4.villages) === null || _masterData$find3$Dis5 === void 0 ? void 0 : _masterData$find3$Dis5.map(item => {
      const formatted = toTitleCase(item);
      return {
        name: formatted,
        value: formatted,
        label: formatted
      };
    }) : null;
    return result || [];
  };
  const filterAvpVillagesData = (masterData, district, tehsil) => {
    var _masterData$find4, _masterData$find4$teh, _masterData$find4$teh2, _masterData$find4$teh3, _masterData$find4$teh4;
    const villagesArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find4 = masterData.find(item => item.District === district)) === null || _masterData$find4 === void 0 ? void 0 : (_masterData$find4$teh = _masterData$find4.tehsils) === null || _masterData$find4$teh === void 0 ? void 0 : (_masterData$find4$teh2 = _masterData$find4$teh.find(item => item.tehsilName === tehsil)) === null || _masterData$find4$teh2 === void 0 ? void 0 : (_masterData$find4$teh3 = _masterData$find4$teh2.villages) === null || _masterData$find4$teh3 === void 0 ? void 0 : (_masterData$find4$teh4 = _masterData$find4$teh3.map) === null || _masterData$find4$teh4 === void 0 ? void 0 : _masterData$find4$teh4.call(_masterData$find4$teh3, item => ({
      name: item,
      label: item,
      value: item
    }));
    return villagesArray;
  };
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find5, _masterData$find5$Dis;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find5 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find5 === void 0 ? void 0 : (_masterData$find5$Dis = _masterData$find5.Districts) === null || _masterData$find5$Dis === void 0 ? void 0 : _masterData$find5$Dis.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const filterAvpDistrictData = (masterData, city) => {
    console.log("avpdistrictTriggered", city);
    const district = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.District === city);
    if (!district) return [];
    console.log("districtfromavp", [{
      name: district.District,
      label: district.District,
      value: district.District
    }]);
    return [{
      name: district.District,
      label: district.District,
      value: district.District
    }];
  };
  const isSchemeType = watchSchemeType === "Scheme";
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  console.log("upDIstricts", updistricts);
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", schemeTypeData, watchMaster, watchSubLayout);
  const plotNo = watch("descriptionOfLand.plotNo");
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(formData === null || formData === void 0 ? void 0 : formData.selectedOffice, nonSchemeTypeData, watchActivityAsPerMap);
  console.log("activityAsPerMap", activityAsPerMap, landUseList, landSubUseList);
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData === null || masterData === void 0 ? void 0 : masterData.filter(item => item.Name === department).map(item => item.ColonyGroups).flat().filter(item => item.ColonyType === planOn).map(item => item.Colonies).flat().map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("schemeFilteredData", schemeNameList);
    return schemeNameList;
  };
  const schemeNames = filterSchemeNames(departmentList, formData === null || formData === void 0 ? void 0 : formData.selectedOffice, watchPlanOn);
  const filterAvpSchemeNames = (unit, city, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C, _masterData$filter$$C2, _masterData$filter$$C3, _masterData$filter$$C4;
    console.log("avpMasterFrom4", masterData, unit, city);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : (_masterData$filter$$C2 = _masterData$filter$$C.filter(item => item.City === city)) === null || _masterData$filter$$C2 === void 0 ? void 0 : (_masterData$filter$$C3 = _masterData$filter$$C2[0]) === null || _masterData$filter$$C3 === void 0 ? void 0 : (_masterData$filter$$C4 = _masterData$filter$$C3.Schemes) === null || _masterData$filter$$C4 === void 0 ? void 0 : _masterData$filter$$C4.map(item => {
      return {
        name: item.SchemeName,
        label: item.SchemeName,
        value: item.SchemeName
      };
    });
    console.log("loggingAVPSchemeNames", result);
    return result;
  };
  const avpSchemeNames = filterAvpSchemeNames(formData === null || formData === void 0 ? void 0 : formData.selectedUnit, formData === null || formData === void 0 ? void 0 : formData.selectedCity, avpData);
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["kmlFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const onSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSubmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    var _formData$description11;
    if (formData !== null && formData !== void 0 && (_formData$description11 = formData.descriptionOfLand) !== null && _formData$description11 !== void 0 && _formData$description11.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
    }
    if (formData !== null && formData !== void 0 && formData.isGovernmentBuilding) {
      setValue("isGovernmentBuilding", formData.isGovernmentBuilding);
    }
    if (isDA && formData !== null && formData !== void 0 && formData.location1 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0) {
      khasraDetails.forEach((_, index) => {
        var _formData$description12, _formData$description13, _formData$description14;
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : (_formData$description13 = _formData$description12.khasraDetails) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13[0]) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.district) || formData.location1);
      });
    } else if (formData !== null && formData !== void 0 && formData.selectedCity) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.selectedCity);
      });
      setValue("landInfo.owners[0].permanentAddress.district", formData.selectedCity);
    }
  }, [formData, khasraDetails]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  const isOwner = (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) === "Owner";
  const filteredSchemeTypeList = isOwner ? schemeTypeList.filter(item => item.value === "Non Scheme") : schemeTypeList;
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.schemeType,
    data: SortingAlphabatically(filteredSchemeTypeList),
    disabled: isEmployee || isApproved || (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.schemeType),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 0px",
      fontWeight: "600",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      textAlign: "right",
      color: "rgb(2, 11, 15)",
      padding: "9px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "clickHere",
    onClick: handleClick
  }, "Click here,"), "\xA0to know how to create a .kml file.")))), isSchemeType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 4px",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      backgroundColor: "#f2f2f2",
      color: "red",
      padding: "4px"
    }
  }, "Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission."))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Type of Scheme",
    placeholder: "Select type of scheme",
    name: `descriptionOfLand.planOn`,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: SortingAlphabatically(proposedSite),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.planOn,
    mandatory: true,
    disabled: isEmployee || isApproved || isEditMode && !!(formData !== null && formData !== void 0 && (_formData$description18 = formData.descriptionOfLand) !== null && _formData$description18 !== void 0 && _formData$description18.planOn),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.schemeName,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.constructionType,
    type: "searchSelect"
  })), /*#__PURE__*/React__default.createElement(Col, null)), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraDetails.map((item, index) => {
    var _khasraTehsils$index, _khasraTehsils$index2, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29;
    const selectedTehsil = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index = khasraTehsils[index]) === null || _khasraTehsils$index === void 0 ? void 0 : _khasraTehsils$index.tehsil;
    const selectedDistrict = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index2 = khasraTehsils[index]) === null || _khasraTehsils$index2 === void 0 ? void 0 : _khasraTehsils$index2.district;
    const filteredVillages = isDA ? filterVillagesData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict, selectedTehsil) : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
    const tehsils = isDA ? filterTehsilData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict) : filterAvpTehsilData(avpVillagesData, selectedDistrict);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(isDA ? filterDistrictData(villagesData, formData === null || formData === void 0 ? void 0 : formData.selectedOffice) : filterAvpDistrictData(avpVillagesData, formData === null || formData === void 0 ? void 0 : formData.selectedCity)),
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      defaultValue: isDA ? (formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : (_formData$description22 = _formData$description21.khasraDetails) === null || _formData$description22 === void 0 ? void 0 : (_formData$description23 = _formData$description22[0]) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.district) || (formData === null || formData === void 0 ? void 0 : formData.location1) : formData === null || formData === void 0 ? void 0 : formData.selectedCity,
      disabled: isEmployee || isApproved,
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(tehsils),
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : (_formData$description25 = _formData$description24.khasraDetails) === null || _formData$description25 === void 0 ? void 0 : (_formData$description26 = _formData$description25[index]) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.tehsil,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filteredVillages),
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : (_formData$description28 = _formData$description27.khasraDetails) === null || _formData$description28 === void 0 ? void 0 : (_formData$description29 = _formData$description28[index]) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.village,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
      maxLength: 30,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "textInput",
      maxLength: 200,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => removeKhasraDetail(index),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === khasraDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => addKhasraDetail({
        plotNo: "",
        district: "",
        tehsil: "",
        village: ""
      }),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  }))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "District",
    control: control,
    data: SortingAlphabatically(isDA ? filterDistrictData(villagesData, formData === null || formData === void 0 ? void 0 : formData.selectedOffice) : filterAvpDistrictData(avpVillagesData, formData === null || formData === void 0 ? void 0 : formData.selectedCity)),
    placeholder: "Select District",
    name: `landInfo.owners[0].permanentAddress.district`,
    type: isEmployee || isApproved || !isDA ? "textInput" : "searchSelect",
    defaultValue: isDA ? formData === null || formData === void 0 ? void 0 : formData.location1 : formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    name: "descriptionOfLand.plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    decimalScale: 2,
    disabled: isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    name: "descriptionOfLand.landArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    maxValue: maxPlotAreaSite,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    decimalScale: 2
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, roadWidthsArray.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: `descriptionOfLand.roadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: roadWidthsArray.length >= 4,
    onClick: () => addRoadWidthField({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), roadWidthsArray.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeRoadWidthField(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))), /*#__PURE__*/React__default.createElement(Col, null, approachRoadWidths.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)",
    placeholder: isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)",
    name: `descriptionOfLand.approachRoadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    sx: {
      Padding: "0px"
    },
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: approachRoadWidths.length >= 4,
    onClick: () => addApproachRoad({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), approachRoadWidths.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeApproachWidth(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("latitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("longitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    multiLine: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 3000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: isEmployee || isApproved,
    maxLength: 200,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: [{
      label: "Yes",
      value: "yes"
    }, {
      label: "No",
      value: "no"
    }],
    label: t("Is this a Government Building ?"),
    name: "isGovernmentBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding,
    disabled: isEmployee || isApproved,
    type: "radioButton",
    mandatory: true,
    clickControl: e => {
      if (setParams) {
        setParams(prev => ({
          ...prev,
          isGovernmentBuilding: e.target.value
        }));
      }
    },
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchGovernmentBuilding === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Government Building"),
    control: control,
    placeholder: t("Select Government Building"),
    data: SortingAlphabatically(governmentBuildingOptions),
    name: "governmentBuildingName",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.governmentBuildingName,
    type: "searchSelect"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const masterPlanData = {
  "Kanpur Development Authority": [{
    label: "Kanpur Master Plan - 2021",
    value: "Kanpur Master Plan - 2021"
  }, {
    label: "Bithoor Master Plan - 2021",
    value: "Bithoor Master Plan - 2021"
  }, {
    label: "Akbarpur-Mati Master Plan - 2021",
    value: "Akbarpur-Mati Master Plan - 2021"
  }],
  "Lucknow Development Authority": [{
    label: "Lucknow Master Plan - 2031 (Conversion)",
    value: "Lucknow Master Plan - 2031 (Conversion)"
  }],
  "Unnao Shuklaganj Development Authority": [{
    label: "Unnao - Shuklaganj Master Plan - 2031",
    value: "Unnao - Shuklaganj Master Plan - 2031"
  }],
  "Raebareli Development Authority": [{
    label: "Raebareli Master Plan - 2031",
    value: "Raebareli Master Plan - 2031"
  }],
  "Varanasi Development Authority": [{
    label: "Varanasi Master Plan -2031",
    value: "Varanasi Master Plan -2031"
  }, {
    label: "Ramnagar - Pandit Deen Dayal Upadhyay Nagar Master Plan 2031",
    value: "Ramnagar - Pandit Deen Dayal Upadhyay Nagar Master Plan 2031"
  }],
  "Agra Development Authority": [{
    label: "Agra Master Plan - 2031",
    value: "Agra Master Plan - 2031"
  }, {
    label: "Fatehpur-Sikri Master Plan - 2021",
    value: "Fatehpur-Sikri Master Plan - 2021"
  }, {
    label: "AS PER ZONAL PLAN-2",
    value: "AS PER ZONAL PLAN-2"
  }, {
    label: "AS PER ZONAL PLAN-6",
    value: "AS PER ZONAL PLAN-6"
  }],
  "Mathura-Vrindavan Development Authority": [{
    label: "Mathura - Vrindavan Master plan -2031",
    value: "Mathura - Vrindavan Master plan -2031"
  }, {
    label: "Mathura- Vrindavan Part 2 (Kosi Kalan Chata and Chaumuha and Nandgaon) Master Plan 2021",
    value: "Mathura- Vrindavan Part 2 (Kosi Kalan Chata and Chaumuha and Nandgaon) Master Plan 2021"
  }],
  "Firozabad-Shikohabad Development Authority": [{
    label: "Firozabad-Shikohabad Master Plan - 2031",
    value: "Firozabad-Shikohabad Master Plan - 2031"
  }],
  "Prayagraj Development Authority": [{
    label: "Prayagraj Master Plan - 2031",
    value: "Prayagraj Master Plan - 2031"
  }],
  "Bareilly Development Authority": [{
    label: "Bareilly Master Plan - 2031",
    value: "Bareilly Master Plan - 2031"
  }],
  "Meerut Development Authority": [{
    label: "Meerut Development - 2031",
    value: "Meerut Development - 2031"
  }],
  "Baghpat-Baraut-Khekra Development Authority": [{
    label: "Baghpat-Barut-khekra Master Plan - 2031",
    value: "Baghpat-Barut-khekra Master Plan - 2031"
  }],
  "Ghaziabad Development Authority": [{
    label: "Ghaziabad + Modinagar + Loni Master Plan - 2031",
    value: "Ghaziabad + Modinagar + Loni Master Plan - 2031"
  }],
  "Bulandshahr-Khurja Development Authority": [{
    label: "Bulandshahar Master Plan - 2031",
    value: "Bulandshahar Master Plan - 2031"
  }, {
    label: "Sikandarabad Master Plan - 2021",
    value: "Sikandarabad Master Plan - 2021"
  }, {
    label: "New Sikandarabad Master Plan - 2021",
    value: "New Sikandarabad Master Plan - 2021"
  }, {
    label: "Jahangirabad Master Plan - 2021",
    value: "Jahangirabad Master Plan - 2021"
  }, {
    label: "Khurja Master Plan - 2031",
    value: "Khurja Master Plan - 2031"
  }],
  "Hapur-Pilkhua Development Authority": [{
    label: "Hapur Master Plan - 2031",
    value: "Hapur Master Plan - 2031"
  }, {
    label: "Garhmukteshwar-Brijghat Master Plan - 2021",
    value: "Garhmukteshwar-Brijghat Master Plan - 2021"
  }, {
    label: "Pilkhuwa Master Plan - 2021",
    value: "Pilkhuwa Master Plan - 2021"
  }, {
    label: "NCR Regional Plan-2021",
    value: "NCR Regional Plan-2021"
  }],
  "Moradabad Development Authority": [{
    label: "Moradabad Master Plan -2031",
    value: "Moradabad Master Plan -2031"
  }, {
    label: "Gajraula Master Plan 2031",
    value: "Gajraula Master Plan 2031"
  }],
  "Rampur Development Authority": [{
    label: "Rampur Master Plan - 2021",
    value: "Rampur Master Plan - 2021"
  }],
  "Jhansi Development Authority": [{
    label: "Jhansi Master Plan - 2031",
    value: "Jhansi Master Plan - 2031"
  }],
  "Orai Development Authority": [{
    label: "Orai Master Plan - 2031",
    value: "Orai Master Plan - 2031"
  }],
  "Ayodhya Development Authority": [{
    label: "Ayodhya Master Plan -2031",
    value: "Ayodhya Master Plan -2031"
  }],
  "Gorakhpur Development Authority": [{
    label: "Gorakhpur Master Plan - 2031",
    value: "Gorakhpur Master Plan - 2031"
  }],
  "Azamgarh Development Authority": [{
    label: "Azamgarh Master Plan - 2031",
    value: "Azamgarh Master Plan - 2031"
  }],
  "Aligarh Development Authority": [{
    label: "Aligarh Master Plan - 2031",
    value: "Aligarh Master Plan - 2031"
  }],
  "Saharanpur Development Authority": [{
    label: "Saharanpur Master Plan - 2031",
    value: "Saharanpur Master Plan - 2031"
  }],
  "Muzaffarnagar Development Authority": [{
    label: "Muzaffarnagar Master Plan - 2031 (Revised)",
    value: "Muzaffarnagar Master Plan - 2031 (Revised)"
  }, {
    label: "Shamli Master Plan - 2031 (SHAMLI-KAIRANA)",
    value: "Shamli Master Plan - 2031 (SHAMLI-KAIRANA)"
  }, {
    label: "Khatauli Master Plan - 2021",
    value: "Khatauli Master Plan - 2021"
  }],
  "Banda Development Authority": [{
    label: "Banda Master Plan - 2031",
    value: "Banda Master Plan - 2031"
  }],
  "Basti Development Authority": [{
    label: "Basti Master Plan - 2031",
    value: "Basti Master Plan - 2031"
  }],
  "Mirzapur-Vindhyachal Development Authority": [{
    label: "Mirzapur Vidhyachal Master Plan -2031",
    value: "Mirzapur Vidhyachal Master Plan -2031"
  }],
  "Shahjahanpur Development Authority": [{
    label: "Shahjahanpur Master Plan - 2031",
    value: "Shahjahanpur Master Plan - 2031"
  }],
  "Shaktinagar Special Development Area": [{
    label: "Shaktinagar Master Master Plan - 2011",
    value: "Shaktinagar Master Master Plan - 2011"
  }, {
    label: "Chopan-Obra-Dala Master Plan -2011",
    value: "Chopan-Obra-Dala Master Plan -2011"
  }, {
    label: "Reenukoot-Pipri-Master-Plan-2011",
    value: "Reenukoot-Pipri-Master-Plan-2011"
  }, {
    label: "Rihand Nagar Master Plan 2011",
    value: "Rihand Nagar Master Plan 2011"
  }, {
    label: "Anpara-Master-Plan-2011",
    value: "Anpara-Master-Plan-2011"
  }, {
    label: "Duddhi Master Plan - 2021",
    value: "Duddhi Master Plan - 2021"
  }]
};

const KhasraDetails = ({
  callKhasraDetailsApi,
  updateKhasraDetails,
  formData,
  khasraRemarks,
  setKhasraRemarks,
  role
}) => {
  var _formData$description;
  console.log('formdatafor issue', formData);
  const incomingKhasraDetails = Array.isArray(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.khasraDetails) ? formData.descriptionOfLand.khasraDetails.map((item, index) => {
    var _formData$khasraDetai;
    return {
      ...item,
      landUse: Array.isArray(formData === null || formData === void 0 ? void 0 : formData.khasraDetails) && formData.khasraDetails.some(k => k.landUse) ? ((_formData$khasraDetai = formData.khasraDetails[index]) === null || _formData$khasraDetai === void 0 ? void 0 : _formData$khasraDetai.landUse) || "" : item.landUse || ""
    };
  }) : [];
  const [error, setError] = useState(false);
  console.log("logKhasraDetails", incomingKhasraDetails, formData);
  const mappedKhasraDetails = incomingKhasraDetails.map(item => ({
    villageName: item.village || item.villageName || "",
    tehsil: item.tehsil || "",
    khasraNumber: item.plotNo || item.khasraNumber || "",
    landUse: item.landUse || "",
    selectedMasterPlan: item === null || item === void 0 ? void 0 : item.selectedMasterPlan
  }));
  const isUpdateAllowed = !["APPROVED", "REJECTED", "MAKE_PAYMENT", "UPLOAD_DOC"].includes(formData === null || formData === void 0 ? void 0 : formData.status);
  const stripHtmlTags = html => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };
  console.log("MAPPEDkHASRAdETAILS", mappedKhasraDetails);
  const {
    control,
    handleSubmit,
    watch
  } = useForm({
    defaultValues: {
      khasraDetails: mappedKhasraDetails.length > 0 ? mappedKhasraDetails : [{
        villageName: "",
        khasraNumber: "",
        landUse: "",
        tehsil: ""
      }]
    }
  });
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["LandUseVillageMasterData"]);
  const filterTehsilData = (masterData, authority) => {
    var _masterData$find, _masterData$find$tehs;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$tehs = _masterData$find.tehsils) === null || _masterData$find$tehs === void 0 ? void 0 : _masterData$find$tehs.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, tehsil) => {
    var _masterData$find2, _masterData$find2$teh, _masterData$find2$teh2, _masterData$find2$teh3;
    console.log("villagesFilteredData", authority, tehsil);
    const result = tehsil ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : (_masterData$find2$teh2 = _masterData$find2$teh.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find2$teh2 === void 0 ? void 0 : (_masterData$find2$teh3 = _masterData$find2$teh2.villages) === null || _masterData$find2$teh3 === void 0 ? void 0 : _masterData$find2$teh3.map(item => ({
      name: item,
      label: item,
      value: item
    })) : null;
    return result || [];
  };
  const tehsils = filterTehsilData(villagesData, "Lucknow Development Authority");
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "khasraDetails"
  });
  const onSubmit = data => {
    const plainText = stripHtmlTags(khasraRemarks);
    if (plainText.trim().length === 0) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    updateKhasraDetails(data.khasraDetails, khasraRemarks);
    if (!khasraRemarks) {
      setError(true);
    }
    if (khasraRemarks) {
      console.log("Submitted data:", data);
      callKhasraDetailsApi(data.khasraDetails, khasraRemarks);
    }
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("colgroup", null, /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "60px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "180px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "180px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "120px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "120px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "120px"
    }
  }), " ", /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "80px"
    }
  }), " "), /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr No."), /*#__PURE__*/React__default.createElement("th", null, "Tehsil", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, "Khasra Number", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, "Land Use", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, "Select Master Plan", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, fields.map((field, index) => {
    const tehsilValue = watch(`khasraDetails[${index}].tehsil`);
    const villagesForTehsil = filterVillagesData(villagesData, "Lucknow Development Authority", tehsilValue);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: "180px"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(tehsils),
      placeholder: "Select Tehsil",
      width: "100%",
      name: `khasraDetails[${index}].tehsil`,
      type: "textInput",
      disabled: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: "180px"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      hasLabel: false,
      width: "100%",
      control: control,
      data: SortingAlphabatically(villagesForTehsil),
      disabled: true,
      placeholder: "Select Village",
      name: `khasraDetails[${index}].villageName`,
      type: "textInput",
      maxLength: 30,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: "120px"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      hasLabel: false,
      control: control,
      placeholder: "Enter khasra number",
      name: `khasraDetails[${index}].khasraNumber`,
      disabled: true,
      type: "specialChar",
      allowedChars: ",-/",
      width: "100%",
      maxLength: 20,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: "120px"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      hasLabel: false,
      width: "100%",
      control: control,
      placeholder: "Enter land use",
      name: `khasraDetails[${index}].landUse`,
      type: "textInput",
      maxLength: 400,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: "120px"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      name: `khasraDetails[${index}].selectedMasterPlan`,
      placeholder: "Select Master Plan",
      type: "selectInput",
      mandatory: true,
      data: masterPlanData[formData === null || formData === void 0 ? void 0 : formData.selectedOffice],
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index !== 0 && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: () => remove(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)), index === fields.length - 1 && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      onClick: () => {
        const base = mappedKhasraDetails.length > 0 ? {
          ...mappedKhasraDetails[0]
        } : {
          tehsil: "",
          villageName: "",
          khasraNumber: ""
        };
        delete base.landUse;
        append({
          ...base,
          landUse: ""
        });
      },
      style: {
        marginLeft: 8
      }
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  })))), /*#__PURE__*/React__default.createElement(RemarksEditor, {
    setRemarks: setKhasraRemarks,
    remarks: khasraRemarks,
    error: error,
    setError: setError,
    title: "Additional comments"
  }), isUpdateAllowed && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-around",
      textAlign: "center",
      marginTop: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  })));
};

const KhasraDetailsLog = ({
  logData
}) => {
  var _popupData$userDetail, _popupData$userDetail2, _popupData$userDetail3, _popupData$auditDetai;
  console.log("logDataKhasra", logData);
  const detailsArray = Array.isArray(logData) ? logData : [logData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const openPopup = item => {
    setPopupData(item);
    setShowPopup(true);
  };
  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };
  const printPopup = () => {
    const popupContent = document.getElementById("khasra-popup-print");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Khasra Details</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      marginBottom: "10px"
    }
  }, "Khasra Details Log"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "600px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Name"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Comments"), /*#__PURE__*/React__default.createElement("th", null, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray.map((item, index) => {
    var _item$auditDetails;
    const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
    const createdTime = (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || null;
    const remarks = item === null || item === void 0 ? void 0 : item.khasraRemarks;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: createdTime
    })), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    }), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopup(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }))));
  })))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "60%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, "Khasra Details Info"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "khasra-popup-print"
  }, (popupData === null || popupData === void 0 ? void 0 : popupData.userDetails) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", ((_popupData$userDetail = popupData.userDetails) === null || _popupData$userDetail === void 0 ? void 0 : _popupData$userDetail.employeeName) || ((_popupData$userDetail2 = popupData.userDetails) === null || _popupData$userDetail2 === void 0 ? void 0 : _popupData$userDetail2.name) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", ((_popupData$userDetail3 = popupData.userDetails) === null || _popupData$userDetail3 === void 0 ? void 0 : _popupData$userDetail3.designation) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Created:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: (_popupData$auditDetai = popupData.auditDetails) === null || _popupData$auditDetai === void 0 ? void 0 : _popupData$auditDetai.createdTime
  })), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Tehsil"), /*#__PURE__*/React__default.createElement("th", null, "Village"), /*#__PURE__*/React__default.createElement("th", null, "Khasra Number"), /*#__PURE__*/React__default.createElement("th", null, "Land Use"), /*#__PURE__*/React__default.createElement("th", null, "Comments"))), /*#__PURE__*/React__default.createElement("tbody", null, ((popupData === null || popupData === void 0 ? void 0 : popupData.khasraDetails) || []).map((khasra, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, (khasra === null || khasra === void 0 ? void 0 : khasra.tehsil) || "-"), /*#__PURE__*/React__default.createElement("td", null, (khasra === null || khasra === void 0 ? void 0 : khasra.villageName) || "-"), /*#__PURE__*/React__default.createElement("td", null, (khasra === null || khasra === void 0 ? void 0 : khasra.khasraNumber) || "-"), /*#__PURE__*/React__default.createElement("td", null, (khasra === null || khasra === void 0 ? void 0 : khasra.landUse) || "-"), /*#__PURE__*/React__default.createElement("td", null, popupData !== null && popupData !== void 0 && popupData.khasraRemarks ? /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: popupData.khasraRemarks
  }) : "-"))))))));
};

const DocumentSectionLog = ({
  logData
}) => {
  console.log("logDataDocumentSection", logData);
  const detailsArray = Array.isArray(logData) ? logData : [logData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const openPopup = item => {
    var _item$auditDetails, _item$documentDetails;
    setPopupData(item);
    setShowPopup(true);
    setUserDetails(item.userDetails || {});
    setCreatedTime(((_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || null);
    setSelectedDetails(item === null || item === void 0 ? void 0 : (_item$documentDetails = item.documentDetails) === null || _item$documentDetails === void 0 ? void 0 : _item$documentDetails.documents);
  };
  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };
  const printPopup = () => {
    const popupContent = document.getElementById("document-section-popup-print");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Document Section Log</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const formatDocumentType = value => {
    if (!value) return "-";
    return value.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, char => char.toUpperCase());
  };
  const documentsWithRemarks = (selectedDetails === null || selectedDetails === void 0 ? void 0 : selectedDetails.filter(row => {
    var _row$documentRemarks, _row$documentRemarks$, _row$documentStatus, _row$documentStatus$t;
    return (row === null || row === void 0 ? void 0 : (_row$documentRemarks = row.documentRemarks) === null || _row$documentRemarks === void 0 ? void 0 : (_row$documentRemarks$ = _row$documentRemarks.trim) === null || _row$documentRemarks$ === void 0 ? void 0 : _row$documentRemarks$.call(_row$documentRemarks)) || (row === null || row === void 0 ? void 0 : (_row$documentStatus = row.documentStatus) === null || _row$documentStatus === void 0 ? void 0 : (_row$documentStatus$t = _row$documentStatus.trim) === null || _row$documentStatus$t === void 0 ? void 0 : _row$documentStatus$t.call(_row$documentStatus));
  })) || [];
  const documentsWithoutRemarks = (selectedDetails === null || selectedDetails === void 0 ? void 0 : selectedDetails.filter(row => {
    var _row$documentRemarks2, _row$documentRemarks3, _row$documentStatus2, _row$documentStatus2$;
    return !(row !== null && row !== void 0 && (_row$documentRemarks2 = row.documentRemarks) !== null && _row$documentRemarks2 !== void 0 && (_row$documentRemarks3 = _row$documentRemarks2.trim) !== null && _row$documentRemarks3 !== void 0 && _row$documentRemarks3.call(_row$documentRemarks2)) && !(row !== null && row !== void 0 && (_row$documentStatus2 = row.documentStatus) !== null && _row$documentStatus2 !== void 0 && (_row$documentStatus2$ = _row$documentStatus2.trim) !== null && _row$documentStatus2$ !== void 0 && _row$documentStatus2$.call(_row$documentStatus2));
  })) || [];
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      marginBottom: "10px"
    }
  }, "Document Section Log"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "600px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "User"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Recommendation"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray.map((item, index) => {
    var _item$auditDetails2, _item$documentDetails2, _item$documentDetails3;
    const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
    const createdTime = (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || null;
    const remarks = item === null || item === void 0 ? void 0 : (_item$documentDetails2 = item.documentDetails) === null || _item$documentDetails2 === void 0 ? void 0 : _item$documentDetails2.developerRemarks;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$documentDetails3 = item.documentDetails) === null || _item$documentDetails3 === void 0 ? void 0 : _item$documentDetails3.dataRecommendation) || "-"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: createdTime
    })), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    }), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openPopup(item),
      size: "small"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }))));
  })))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "60%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, "Document Section Log Info"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "document-section-popup-print"
  }, userDetails && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.employeeName) || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.name) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.designation) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Role:"), " ", (userDetails === null || userDetails === void 0 ? void 0 : userDetails.role) || "-", " |", " ", /*#__PURE__*/React__default.createElement("strong", null, "Created At:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: createdTime
  })), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "11px",
      tableLayout: "fixed"
    }
  }, /*#__PURE__*/React__default.createElement("colgroup", null, /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "35%"
    }
  }), /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "30%"
    }
  }), /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "20%"
    }
  }), /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "15%"
    }
  })), /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Document Type"), /*#__PURE__*/React__default.createElement("th", null, "Document Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Document Status"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      textAlign: "center"
    }
  }, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, documentsWithRemarks.map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, formatDocumentType(row === null || row === void 0 ? void 0 : row.documentType)), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.documentRemarks) || "-"), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.documentStatus) || "-"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (row === null || row === void 0 ? void 0 : row.fileStoreUrl) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: row.fileStoreUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  }))))))), documentsWithoutRemarks.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, documentsWithoutRemarks.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "11px",
      tableLayout: "fixed"
    }
  }, /*#__PURE__*/React__default.createElement("colgroup", null, /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "85%"
    }
  }), /*#__PURE__*/React__default.createElement("col", {
    style: {
      width: "15%"
    }
  })), /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Document Type"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      textAlign: "center"
    }
  }, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, documentsWithoutRemarks.map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, formatDocumentType(row === null || row === void 0 ? void 0 : row.documentType)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, (row === null || row === void 0 ? void 0 : row.fileStoreUrl) && /*#__PURE__*/React__default.createElement(IconButton$1, {
    href: row.fileStoreUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    title: "Open Document"
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })))))))))))));
};

const useLocalizedData = dataWithNamespaces => {
  const {
    t
  } = useTranslation();
  const localizedData = Object.keys(dataWithNamespaces).reduce((acc, namespace) => {
    const data = dataWithNamespaces[namespace];
    console.log("namespace", namespace, data, dataWithNamespaces);
    acc[namespace] = data.map(item => ({
      ...item,
      text: t(`${namespace}_${item.text}`)
    }));
    return acc;
  }, {});
  return localizedData;
};

const EmpLandUsePortal = ({
  formData,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _formData$description, _Digit, _Digit2;
  const specialCondition = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.selectLandUse) == "Conditional Permissible";
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LU_CURRENT_TAB")) || 0);
  const [subActiveTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LU_CURRENT_SUBTAB")) || 0);
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED";
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList
  });
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    isFromDashboard,
    callDocumentDetailsAPI,
    avpData,
    avpUnits,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);
  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("LU_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("LU_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };
  console.log("ParamsGOT", params, updatedDocuments);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$1, {
            formData: formData,
            isEmployee: !isCitizen,
            handleSubTabChange: handleSubTabChange,
            applicationFlow: department,
            isApproved: true,
            avpData: avpData,
            avpUnits: avpUnits
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$1, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$1, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true
          });
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      switch (subActiveDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "mandatory",
            formType: "LANDUSE",
            developerRemarks: developerRemarksDocument,
            setDeveloperRemarks: setDeveloperRemarksDocument,
            setError: setError,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            isFromDashboard: isFromDashboard,
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: siteInspRecommendation,
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument,
              error: error,
              setError: setError
            }, props))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DocumentSectionLog, {
            logData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
      }
    } else if (activeTab === 1 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "view-doc-container"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        className: "view-doc-btn",
        onClick: handleDocView,
        style: {
          backgroundColor: "#157C4F",
          borderRadius: "15px",
          padding: "5px 10px"
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "view-doc-icon"
      }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc
      }));
    } else if (activeTab === 2 && !isCitizen) {
      var _userRolesArray$;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(KhasraDetails, {
        callKhasraDetailsApi: callKhasraDetailsApi,
        updateKhasraDetails: updateKhasraDetails,
        formData: params,
        khasraRemarks: khasraRemarks,
        setKhasraRemarks: setKhasraRemarks,
        role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code
      }), /*#__PURE__*/React__default.createElement(KhasraDetailsLog, {
        logData: khasraDetailsData === null || khasraDetailsData === void 0 ? void 0 : khasraDetailsData.DetailDataRemarks
      }));
    } else if (activeTab === 2 && isCitizen) {
      var _actions$, _actions$2, _formData$description2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Architect, {
        formData: formData,
        applicationDocs: applicationDocs,
        actions: actions,
        avpLogo: avpLogo,
        daLogo: daLogo
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "MAKE_PAYMENT" && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 8"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangePayment
      }, "Payment")))), (actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action) === "FORWARD_TO_DEPARTMENT" && ((formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) === "yes" || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.scschemeType) === "Scheme") && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 6"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 4"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangeForward
      }, "Forward To Department")))));
    } else if (activeTab === 3 && !isCitizen) {
      var _formData$status;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleChange,
        serviceName: "Land Use Verification",
        avpLogo: avpLogo,
        daLogo: daLogo
      }), !isApproved && /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        logoData: isDa ? daLogo : avpLogo,
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "LA"
      }), !isApproved && /*#__PURE__*/React__default.createElement(ActionButtons, {
        actions: actions,
        currentAction: currentAction,
        onSelect: onRadioActionSelect
      }), !isApproved && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), !isApproved && !isFromDashboard && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 3 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatboardCorrespondenceApplicant, {
        formData: formData
      }));
    } else if (specialCondition && !isCitizen && activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SelectMandatoryConditions2, {
        setMandatoryCondition: setMandatoryCondition,
        tenantId: tenantId,
        setCurrentTab: handleChange
      }));
    } else if (!specialCondition && !isCitizen && activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData
      }));
    } else if (activeTab === 4 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (!specialCondition && !isCitizen && activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData
      }));
    } else if (activeTab === 5 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(MainWrapper, {
    className: "main-panel-corner land-use-corner"
  }, !isCitizen && /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Application Data"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Document Section"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Land Use Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Take Action"
  }), specialCondition && !isCitizen ? /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Conditions"
  }) : null, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Chat-Board"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "All Remarks"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), activeTab === 1 && !isCitizen && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, landUseSubTabDDocSecLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent())));
};

var standalone = createCommonjsModule(function (module, exports) {
  !function (e, t) {
     module.exports = t() ;
  }(commonjsGlobal, function () {

    function e(e, t) {
      if (null == e) return {};
      var n,
        r,
        u = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (u[n] = e[n]);
      return u;
    }
    function t(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }
    var n = "Prettier is an opinionated code formatter",
      r = "./bin/prettier.js",
      u = {
        node: ">=10.13.0"
      },
      o = ["index.js", "standalone.js", "src", "bin"],
      a = {
        "@angular/compiler": "10.0.12",
        "@babel/code-frame": "7.10.4",
        "@babel/parser": "7.11.2",
        "@glimmer/syntax": "0.59.0",
        "@iarna/toml": "2.2.5",
        "@typescript-eslint/typescript-estree": "3.10.0",
        "angular-estree-parser": "2.2.0",
        "angular-html-parser": "1.7.1",
        camelcase: "6.0.0",
        chalk: "4.1.0",
        "ci-info": "watson/ci-info#f43f6a1cefff47fb361c88cf4b943fdbcaafe540",
        "cjk-regex": "2.0.0",
        cosmiconfig: "7.0.0",
        dashify: "2.0.0",
        diff: "4.0.2",
        editorconfig: "0.15.3",
        "editorconfig-to-prettier": "0.1.1",
        "escape-string-regexp": "4.0.0",
        esutils: "2.0.3",
        "fast-glob": "3.2.4",
        "fast-json-stable-stringify": "2.1.0",
        "find-parent-dir": "0.3.0",
        "flow-parser": "0.132.0",
        "get-stream": "6.0.0",
        globby: "11.0.1",
        graphql: "15.3.0",
        "html-element-attributes": "2.2.1",
        "html-styles": "1.0.0",
        "html-tag-names": "1.1.5",
        "html-void-elements": "1.0.5",
        ignore: "4.0.6",
        "jest-docblock": "26.0.0",
        json5: "2.1.3",
        leven: "3.1.0",
        "lines-and-columns": "1.1.6",
        "linguist-languages": "7.10.0",
        lodash: "4.17.20",
        mem: "6.1.0",
        minimatch: "3.0.4",
        minimist: "1.2.5",
        "n-readlines": "1.0.0",
        outdent: "0.7.1",
        "parse-srcset": "ikatyang/parse-srcset#54eb9c1cb21db5c62b4d0e275d7249516df6f0ee",
        "please-upgrade-node": "3.2.0",
        "postcss-less": "3.1.4",
        "postcss-media-query-parser": "0.2.3",
        "postcss-scss": "2.1.1",
        "postcss-selector-parser": "2.2.3",
        "postcss-values-parser": "2.0.1",
        "regexp-util": "1.2.2",
        "remark-footnotes": "2.0.0",
        "remark-math": "1.0.6",
        "remark-parse": "8.0.3",
        resolve: "1.17.0",
        semver: "7.3.2",
        "string-width": "4.2.0",
        typescript: "4.0.2",
        "unicode-regex": "3.0.0",
        unified: "9.2.0",
        vnopts: "1.0.2",
        "yaml-unist-parser": "1.3.1"
      },
      i = {
        "@babel/core": "7.11.4",
        "@babel/preset-env": "7.11.0",
        "@babel/types": "7.11.0",
        "@glimmer/reference": "0.59.0",
        "@rollup/plugin-alias": "3.1.1",
        "@rollup/plugin-babel": "5.2.0",
        "@rollup/plugin-commonjs": "14.0.0",
        "@rollup/plugin-json": "4.1.0",
        "@rollup/plugin-node-resolve": "9.0.0",
        "@rollup/plugin-replace": "2.3.3",
        "@types/estree": "0.0.45",
        "@types/node": "14.6.0",
        "@typescript-eslint/types": "3.10.0",
        "babel-loader": "8.1.0",
        benchmark: "2.1.4",
        "builtin-modules": "3.1.0",
        "cross-env": "7.0.2",
        cspell: "4.1.0",
        eslint: "7.7.0",
        "eslint-config-prettier": "6.11.0",
        "eslint-formatter-friendly": "7.0.0",
        "eslint-plugin-import": "2.22.0",
        "eslint-plugin-jest": "23.20.0",
        "eslint-plugin-prettier-internal-rules": "file:scripts/tools/eslint-plugin-prettier-internal-rules",
        "eslint-plugin-react": "7.20.6",
        "eslint-plugin-unicorn": "21.0.0",
        execa: "4.0.3",
        jest: "26.4.2",
        "jest-snapshot-serializer-ansi": "1.0.0",
        "jest-snapshot-serializer-raw": "1.1.0",
        "jest-watch-typeahead": "0.6.0",
        "npm-run-all": "4.1.5",
        prettier: "2.1.1",
        rimraf: "3.0.2",
        rollup: "2.26.5",
        "rollup-plugin-node-globals": "1.4.0",
        "rollup-plugin-terser": "7.0.0",
        shelljs: "0.8.4",
        "snapshot-diff": "0.8.1",
        "strip-ansi": "6.0.0",
        "synchronous-promise": "2.0.13",
        tempy: "0.6.0",
        "terser-webpack-plugin": "4.1.0",
        webpack: "4.44.1"
      },
      s = {
        prepublishOnly: 'echo "Error: must publish from dist/" && exit 1',
        "prepare-release": "yarn && yarn build && yarn test:dist",
        test: "jest",
        "test:dev-package": "cross-env INSTALL_PACKAGE=1 jest",
        "test:dist": "cross-env NODE_ENV=production jest",
        "test:dist-standalone": "cross-env NODE_ENV=production TEST_STANDALONE=1 jest",
        "test:integration": "jest tests_integration",
        "perf:repeat": "yarn && yarn build && cross-env NODE_ENV=production node ./dist/bin-prettier.js --debug-repeat ${PERF_REPEAT:-1000} --loglevel debug ${PERF_FILE:-./index.js} > /dev/null",
        "perf:repeat-inspect": "yarn && yarn build && cross-env NODE_ENV=production node --inspect-brk ./dist/bin-prettier.js --debug-repeat ${PERF_REPEAT:-1000} --loglevel debug ${PERF_FILE:-./index.js} > /dev/null",
        "perf:benchmark": "yarn && yarn build && cross-env NODE_ENV=production node ./dist/bin-prettier.js --debug-benchmark --loglevel debug ${PERF_FILE:-./index.js} > /dev/null",
        lint: "run-p lint:*",
        "lint:typecheck": "tsc",
        "lint:eslint": "cross-env EFF_NO_LINK_RULES=true eslint . --format friendly",
        "lint:changelog": "node ./scripts/lint-changelog.js",
        "lint:prettier": 'prettier . "!test*" --check',
        "lint:dist": 'eslint --no-eslintrc --no-ignore --env=es6,browser --parser-options=ecmaVersion:2016 "dist/!(bin-prettier|index|third-party).js"',
        "lint:spellcheck": 'cspell "**/*" ".github/**/*"',
        "lint:deps": "node ./scripts/check-deps.js",
        fix: "run-s fix:eslint fix:prettier",
        "fix:eslint": "yarn lint:eslint --fix",
        "fix:prettier": "yarn lint:prettier --write",
        build: "node ./scripts/build/build.js",
        "build-docs": "node ./scripts/build-docs.js"
      },
      l = {
        name: "prettier",
        version: "2.1.2",
        description: n,
        bin: r,
        repository: "prettier/prettier",
        homepage: "https://prettier.io",
        author: "James Long",
        license: "MIT",
        main: "./index.js",
        browser: "./standalone.js",
        unpkg: "./standalone.js",
        engines: u,
        files: o,
        dependencies: a,
        devDependencies: i,
        scripts: s
      },
      c = Object.freeze({
        __proto__: null,
        name: "prettier",
        version: "2.1.2",
        description: n,
        bin: r,
        repository: "prettier/prettier",
        homepage: "https://prettier.io",
        author: "James Long",
        license: "MIT",
        main: "./index.js",
        browser: "./standalone.js",
        unpkg: "./standalone.js",
        engines: u,
        files: o,
        dependencies: a,
        devDependencies: i,
        scripts: s,
        default: l
      });
    function p() {}
    function d(e, t, n, r, u) {
      for (var o = 0, a = t.length, i = 0, s = 0; o < a; o++) {
        var l = t[o];
        if (l.removed) {
          if (l.value = e.join(r.slice(s, s + l.count)), s += l.count, o && t[o - 1].added) {
            var c = t[o - 1];
            t[o - 1] = t[o], t[o] = c;
          }
        } else {
          if (!l.added && u) {
            var p = n.slice(i, i + l.count);
            p = p.map(function (e, t) {
              var n = r[s + t];
              return n.length > e.length ? n : e;
            }), l.value = e.join(p);
          } else l.value = e.join(n.slice(i, i + l.count));
          i += l.count, l.added || (s += l.count);
        }
      }
      var d = t[a - 1];
      return a > 1 && "string" == typeof d.value && (d.added || d.removed) && e.equals("", d.value) && (t[a - 2].value += d.value, t.pop()), t;
    }
    function f(e) {
      return {
        newPos: e.newPos,
        components: e.components.slice(0)
      };
    }
    p.prototype = {
      diff: function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = n.callback;
        "function" == typeof n && (r = n, n = {}), this.options = n;
        var u = this;
        function o(e) {
          return r ? (setTimeout(function () {
            r(void 0, e);
          }, 0), !0) : e;
        }
        e = this.castInput(e), t = this.castInput(t), e = this.removeEmpty(this.tokenize(e));
        var a = (t = this.removeEmpty(this.tokenize(t))).length,
          i = e.length,
          s = 1,
          l = a + i,
          c = [{
            newPos: -1,
            components: []
          }],
          p = this.extractCommon(c[0], t, e, 0);
        if (c[0].newPos + 1 >= a && p + 1 >= i) return o([{
          value: this.join(t),
          count: t.length
        }]);
        function h() {
          for (var n = -1 * s; n <= s; n += 2) {
            var r = void 0,
              l = c[n - 1],
              p = c[n + 1],
              h = (p ? p.newPos : 0) - n;
            l && (c[n - 1] = void 0);
            var m = l && l.newPos + 1 < a,
              g = p && 0 <= h && h < i;
            if (m || g) {
              if (!m || g && l.newPos < p.newPos ? (r = f(p), u.pushComponent(r.components, void 0, !0)) : ((r = l).newPos++, u.pushComponent(r.components, !0, void 0)), h = u.extractCommon(r, t, e, n), r.newPos + 1 >= a && h + 1 >= i) return o(d(u, r.components, t, e, u.useLongestToken));
              c[n] = r;
            } else c[n] = void 0;
          }
          s++;
        }
        if (r) !function e() {
          setTimeout(function () {
            if (s > l) return r();
            h() || e();
          }, 0);
        }();else for (; s <= l;) {
          var m = h();
          if (m) return m;
        }
      },
      pushComponent: function (e, t, n) {
        var r = e[e.length - 1];
        r && r.added === t && r.removed === n ? e[e.length - 1] = {
          count: r.count + 1,
          added: t,
          removed: n
        } : e.push({
          count: 1,
          added: t,
          removed: n
        });
      },
      extractCommon: function (e, t, n, r) {
        for (var u = t.length, o = n.length, a = e.newPos, i = a - r, s = 0; a + 1 < u && i + 1 < o && this.equals(t[a + 1], n[i + 1]);) a++, i++, s++;
        return s && e.components.push({
          count: s
        }), e.newPos = a, i;
      },
      equals: function (e, t) {
        return this.options.comparator ? this.options.comparator(e, t) : e === t || this.options.ignoreCase && e.toLowerCase() === t.toLowerCase();
      },
      removeEmpty: function (e) {
        for (var t = [], n = 0; n < e.length; n++) e[n] && t.push(e[n]);
        return t;
      },
      castInput: function (e) {
        return e;
      },
      tokenize: function (e) {
        return e.split("");
      },
      join: function (e) {
        return e.join("");
      }
    };
    var h = new p();
    function m(e, t) {
      if ("function" == typeof e) t.callback = e;else if (e) for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
      return t;
    }
    var g = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/,
      D = /\S/,
      y = new p();
    y.equals = function (e, t) {
      return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !D.test(e) && !D.test(t);
    }, y.tokenize = function (e) {
      for (var t = e.split(/(\s+|[()[\]{}'"]|\b)/), n = 0; n < t.length - 1; n++) !t[n + 1] && t[n + 2] && g.test(t[n]) && g.test(t[n + 2]) && (t[n] += t[n + 2], t.splice(n + 1, 2), n--);
      return t;
    };
    var E = new p();
    function C(e, t, n) {
      return E.diff(e, t, n);
    }
    E.tokenize = function (e) {
      var t = [],
        n = e.split(/(\n|\r\n)/);
      n[n.length - 1] || n.pop();
      for (var r = 0; r < n.length; r++) {
        var u = n[r];
        r % 2 && !this.options.newlineIsToken ? t[t.length - 1] += u : (this.options.ignoreWhitespace && (u = u.trim()), t.push(u));
      }
      return t;
    };
    var b = new p();
    b.tokenize = function (e) {
      return e.split(/(\S.+?[.!?])(?=\s+|$)/);
    };
    var A = new p();
    function v(e) {
      return (v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function F(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    A.tokenize = function (e) {
      return e.split(/([{}:;,]|\s+)/);
    };
    var x = Object.prototype.toString,
      S = new p();
    function w(e, t, n, r, u) {
      var o, a;
      for (t = t || [], n = n || [], r && (e = r(u, e)), o = 0; o < t.length; o += 1) if (t[o] === e) return n[o];
      if ("[object Array]" === x.call(e)) {
        for (t.push(e), a = new Array(e.length), n.push(a), o = 0; o < e.length; o += 1) a[o] = w(e[o], t, n, r, u);
        return t.pop(), n.pop(), a;
      }
      if (e && e.toJSON && (e = e.toJSON()), "object" === v(e) && null !== e) {
        t.push(e), a = {}, n.push(a);
        var i,
          s = [];
        for (i in e) e.hasOwnProperty(i) && s.push(i);
        for (s.sort(), o = 0; o < s.length; o += 1) a[i = s[o]] = w(e[i], t, n, r, i);
        t.pop(), n.pop();
      } else a = e;
      return a;
    }
    S.useLongestToken = !0, S.tokenize = E.tokenize, S.castInput = function (e) {
      var t = this.options,
        n = t.undefinedReplacement,
        r = t.stringifyReplacer,
        u = void 0 === r ? function (e, t) {
          return void 0 === t ? n : t;
        } : r;
      return "string" == typeof e ? e : JSON.stringify(w(e, null, null, u), u, "  ");
    }, S.equals = function (e, t) {
      return p.prototype.equals.call(S, e.replace(/,([\r\n])/g, "$1"), t.replace(/,([\r\n])/g, "$1"));
    };
    var B = new p();
    function T(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = e.split(/\r\n|[\n\v\f\r\x85]/),
        r = e.match(/\r\n|[\n\v\f\r\x85]/g) || [],
        u = [],
        o = 0;
      function a() {
        var e = {};
        for (u.push(e); o < n.length;) {
          var r = n[o];
          if (/^(\-\-\-|\+\+\+|@@)\s/.test(r)) break;
          var a = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(r);
          a && (e.index = a[1]), o++;
        }
        for (i(e), i(e), e.hunks = []; o < n.length;) {
          var l = n[o];
          if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(l)) break;
          if (/^@@/.test(l)) e.hunks.push(s());else {
            if (l && t.strict) throw new Error("Unknown line " + (o + 1) + " " + JSON.stringify(l));
            o++;
          }
        }
      }
      function i(e) {
        var t = /^(---|\+\+\+)\s+(.*)$/.exec(n[o]);
        if (t) {
          var r = "---" === t[1] ? "old" : "new",
            u = t[2].split("\t", 2),
            a = u[0].replace(/\\\\/g, "\\");
          /^".*"$/.test(a) && (a = a.substr(1, a.length - 2)), e[r + "FileName"] = a, e[r + "Header"] = (u[1] || "").trim(), o++;
        }
      }
      function s() {
        for (var e = o, u = n[o++].split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/), a = {
            oldStart: +u[1],
            oldLines: +u[2] || 1,
            newStart: +u[3],
            newLines: +u[4] || 1,
            lines: [],
            linedelimiters: []
          }, i = 0, s = 0; o < n.length && !(0 === n[o].indexOf("--- ") && o + 2 < n.length && 0 === n[o + 1].indexOf("+++ ") && 0 === n[o + 2].indexOf("@@")); o++) {
          var l = 0 == n[o].length && o != n.length - 1 ? " " : n[o][0];
          if ("+" !== l && "-" !== l && " " !== l && "\\" !== l) break;
          a.lines.push(n[o]), a.linedelimiters.push(r[o] || "\n"), "+" === l ? i++ : "-" === l ? s++ : " " === l && (i++, s++);
        }
        if (i || 1 !== a.newLines || (a.newLines = 0), s || 1 !== a.oldLines || (a.oldLines = 0), t.strict) {
          if (i !== a.newLines) throw new Error("Added line count did not match for hunk at line " + (e + 1));
          if (s !== a.oldLines) throw new Error("Removed line count did not match for hunk at line " + (e + 1));
        }
        return a;
      }
      for (; o < n.length;) a();
      return u;
    }
    function k(e, t, n) {
      var r = !0,
        u = !1,
        o = !1,
        a = 1;
      return function i() {
        if (r && !o) {
          if (u ? a++ : r = !1, e + a <= n) return a;
          o = !0;
        }
        if (!u) return o || (r = !0), t <= e - a ? -a++ : (u = !0, i());
      };
    }
    function N(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if ("string" == typeof t && (t = T(t)), Array.isArray(t)) {
        if (t.length > 1) throw new Error("applyPatch only works with a single input.");
        t = t[0];
      }
      var r,
        u,
        o = e.split(/\r\n|[\n\v\f\r\x85]/),
        a = e.match(/\r\n|[\n\v\f\r\x85]/g) || [],
        i = t.hunks,
        s = n.compareLine || function (e, t, n, r) {
          return t === r;
        },
        l = 0,
        c = n.fuzzFactor || 0,
        p = 0,
        d = 0;
      function f(e, t) {
        for (var n = 0; n < e.lines.length; n++) {
          var r = e.lines[n],
            u = r.length > 0 ? r[0] : " ",
            a = r.length > 0 ? r.substr(1) : r;
          if (" " === u || "-" === u) {
            if (!s(t + 1, o[t], u, a) && ++l > c) return !1;
            t++;
          }
        }
        return !0;
      }
      for (var h = 0; h < i.length; h++) {
        for (var m = i[h], g = o.length - m.oldLines, D = 0, y = d + m.oldStart - 1, E = k(y, p, g); void 0 !== D; D = E()) if (f(m, y + D)) {
          m.offset = d += D;
          break;
        }
        if (void 0 === D) return !1;
        p = m.offset + m.oldStart + m.oldLines;
      }
      for (var C = 0, b = 0; b < i.length; b++) {
        var A = i[b],
          v = A.oldStart + A.offset + C - 1;
        C += A.newLines - A.oldLines, v < 0 && (v = 0);
        for (var F = 0; F < A.lines.length; F++) {
          var x = A.lines[F],
            S = x.length > 0 ? x[0] : " ",
            w = x.length > 0 ? x.substr(1) : x,
            B = A.linedelimiters[F];
          if (" " === S) v++;else if ("-" === S) o.splice(v, 1), a.splice(v, 1);else if ("+" === S) o.splice(v, 0, w), a.splice(v, 0, B), v++;else if ("\\" === S) {
            var N = A.lines[F - 1] ? A.lines[F - 1][0] : null;
            "+" === N ? r = !0 : "-" === N && (u = !0);
          }
        }
      }
      if (r) for (; !o[o.length - 1];) o.pop(), a.pop();else u && (o.push(""), a.push("\n"));
      for (var O = 0; O < o.length - 1; O++) o[O] = o[O] + a[O];
      return o.join("");
    }
    function O(e, t, n, r, u, o, a) {
      a || (a = {}), void 0 === a.context && (a.context = 4);
      var i = C(n, r, a);
      function s(e) {
        return e.map(function (e) {
          return " " + e;
        });
      }
      i.push({
        value: "",
        lines: []
      });
      for (var l = [], c = 0, p = 0, d = [], f = 1, h = 1, m = function (e) {
          var t = i[e],
            u = t.lines || t.value.replace(/\n$/, "").split("\n");
          if (t.lines = u, t.added || t.removed) {
            var o;
            if (!c) {
              var m = i[e - 1];
              c = f, p = h, m && (d = a.context > 0 ? s(m.lines.slice(-a.context)) : [], c -= d.length, p -= d.length);
            }
            (o = d).push.apply(o, F(u.map(function (e) {
              return (t.added ? "+" : "-") + e;
            }))), t.added ? h += u.length : f += u.length;
          } else {
            if (c) if (u.length <= 2 * a.context && e < i.length - 2) {
              var g;
              (g = d).push.apply(g, F(s(u)));
            } else {
              var D,
                y = Math.min(u.length, a.context);
              (D = d).push.apply(D, F(s(u.slice(0, y))));
              var E = {
                oldStart: c,
                oldLines: f - c + y,
                newStart: p,
                newLines: h - p + y,
                lines: d
              };
              if (e >= i.length - 2 && u.length <= a.context) {
                var C = /\n$/.test(n),
                  b = /\n$/.test(r),
                  A = 0 == u.length && d.length > E.oldLines;
                !C && A && d.splice(E.oldLines, 0, "\\ No newline at end of file"), (C || A) && b || d.push("\\ No newline at end of file");
              }
              l.push(E), c = 0, p = 0, d = [];
            }
            f += u.length, h += u.length;
          }
        }, g = 0; g < i.length; g++) m(g);
      return {
        oldFileName: e,
        newFileName: t,
        oldHeader: u,
        newHeader: o,
        hunks: l
      };
    }
    function P(e, t, n, r, u, o, a) {
      var i = O(e, t, n, r, u, o, a),
        s = [];
      e == t && s.push("Index: " + e), s.push("==================================================================="), s.push("--- " + i.oldFileName + (void 0 === i.oldHeader ? "" : "\t" + i.oldHeader)), s.push("+++ " + i.newFileName + (void 0 === i.newHeader ? "" : "\t" + i.newHeader));
      for (var l = 0; l < i.hunks.length; l++) {
        var c = i.hunks[l];
        s.push("@@ -" + c.oldStart + "," + c.oldLines + " +" + c.newStart + "," + c.newLines + " @@"), s.push.apply(s, c.lines);
      }
      return s.join("\n") + "\n";
    }
    function _(e, t) {
      if (t.length > e.length) return !1;
      for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
      return !0;
    }
    function I(e) {
      var t = function e(t) {
          var n = 0,
            r = 0;
          return t.forEach(function (t) {
            if ("string" != typeof t) {
              var u = e(t.mine),
                o = e(t.theirs);
              void 0 !== n && (u.oldLines === o.oldLines ? n += u.oldLines : n = void 0), void 0 !== r && (u.newLines === o.newLines ? r += u.newLines : r = void 0);
            } else void 0 === r || "+" !== t[0] && " " !== t[0] || r++, void 0 === n || "-" !== t[0] && " " !== t[0] || n++;
          }), {
            oldLines: n,
            newLines: r
          };
        }(e.lines),
        n = t.oldLines,
        r = t.newLines;
      void 0 !== n ? e.oldLines = n : delete e.oldLines, void 0 !== r ? e.newLines = r : delete e.newLines;
    }
    function j(e, t) {
      if ("string" == typeof e) {
        if (/^@@/m.test(e) || /^Index:/m.test(e)) return T(e)[0];
        if (!t) throw new Error("Must provide a base reference or pass in a patch");
        return O(void 0, void 0, t, e);
      }
      return e;
    }
    function M(e) {
      return e.newFileName && e.newFileName !== e.oldFileName;
    }
    function L(e, t, n) {
      return t === n ? t : (e.conflict = !0, {
        mine: t,
        theirs: n
      });
    }
    function R(e, t) {
      return e.oldStart < t.oldStart && e.oldStart + e.oldLines < t.oldStart;
    }
    function q(e, t) {
      return {
        oldStart: e.oldStart,
        oldLines: e.oldLines,
        newStart: e.newStart + t,
        newLines: e.newLines,
        lines: e.lines
      };
    }
    function V(e, t, n, r, u) {
      var o = {
          offset: t,
          lines: n,
          index: 0
        },
        a = {
          offset: r,
          lines: u,
          index: 0
        };
      for (z(e, o, a), z(e, a, o); o.index < o.lines.length && a.index < a.lines.length;) {
        var i = o.lines[o.index],
          s = a.lines[a.index];
        if ("-" !== i[0] && "+" !== i[0] || "-" !== s[0] && "+" !== s[0]) {
          if ("+" === i[0] && " " === s[0]) {
            var l;
            (l = e.lines).push.apply(l, F(G(o)));
          } else if ("+" === s[0] && " " === i[0]) {
            var c;
            (c = e.lines).push.apply(c, F(G(a)));
          } else "-" === i[0] && " " === s[0] ? $(e, o, a) : "-" === s[0] && " " === i[0] ? $(e, a, o, !0) : i === s ? (e.lines.push(i), o.index++, a.index++) : U(e, G(o), G(a));
        } else W(e, o, a);
      }
      J(e, o), J(e, a), I(e);
    }
    function W(e, t, n) {
      var r = G(t),
        u = G(n);
      if (H(r) && H(u)) {
        var o, a;
        if (_(r, u) && X(n, r, r.length - u.length)) return void (o = e.lines).push.apply(o, F(r));
        if (_(u, r) && X(t, u, u.length - r.length)) return void (a = e.lines).push.apply(a, F(u));
      } else if (function (e, t) {
        return e.length === t.length && _(e, t);
      }(r, u)) {
        var i;
        return void (i = e.lines).push.apply(i, F(r));
      }
      U(e, r, u);
    }
    function $(e, t, n, r) {
      var u,
        o = G(t),
        a = function (e, t) {
          var n = [],
            r = [],
            u = 0,
            o = !1,
            a = !1;
          for (; u < t.length && e.index < e.lines.length;) {
            var i = e.lines[e.index],
              s = t[u];
            if ("+" === s[0]) break;
            if (o = o || " " !== i[0], r.push(s), u++, "+" === i[0]) for (a = !0; "+" === i[0];) n.push(i), i = e.lines[++e.index];
            s.substr(1) === i.substr(1) ? (n.push(i), e.index++) : a = !0;
          }
          "+" === (t[u] || "")[0] && o && (a = !0);
          if (a) return n;
          for (; u < t.length;) r.push(t[u++]);
          return {
            merged: r,
            changes: n
          };
        }(n, o);
      a.merged ? (u = e.lines).push.apply(u, F(a.merged)) : U(e, r ? a : o, r ? o : a);
    }
    function U(e, t, n) {
      e.conflict = !0, e.lines.push({
        conflict: !0,
        mine: t,
        theirs: n
      });
    }
    function z(e, t, n) {
      for (; t.offset < n.offset && t.index < t.lines.length;) {
        var r = t.lines[t.index++];
        e.lines.push(r), t.offset++;
      }
    }
    function J(e, t) {
      for (; t.index < t.lines.length;) {
        var n = t.lines[t.index++];
        e.lines.push(n);
      }
    }
    function G(e) {
      for (var t = [], n = e.lines[e.index][0]; e.index < e.lines.length;) {
        var r = e.lines[e.index];
        if ("-" === n && "+" === r[0] && (n = "+"), n !== r[0]) break;
        t.push(r), e.index++;
      }
      return t;
    }
    function H(e) {
      return e.reduce(function (e, t) {
        return e && "-" === t[0];
      }, !0);
    }
    function X(e, t, n) {
      for (var r = 0; r < n; r++) {
        var u = t[t.length - n + r].substr(1);
        if (e.lines[e.index + r] !== " " + u) return !1;
      }
      return e.index += n, !0;
    }
    function Y(e) {
      var t = e;
      return t = (t = (t = (t = t.replace(/&/g, "&amp;")).replace(/</g, "&lt;")).replace(/>/g, "&gt;")).replace(/"/g, "&quot;");
    }
    B.tokenize = function (e) {
      return e.slice();
    }, B.join = B.removeEmpty = function (e) {
      return e;
    };
    var K = Object.freeze({
      __proto__: null,
      Diff: p,
      diffChars: function (e, t, n) {
        return h.diff(e, t, n);
      },
      diffWords: function (e, t, n) {
        return n = m(n, {
          ignoreWhitespace: !0
        }), y.diff(e, t, n);
      },
      diffWordsWithSpace: function (e, t, n) {
        return y.diff(e, t, n);
      },
      diffLines: C,
      diffTrimmedLines: function (e, t, n) {
        var r = m(n, {
          ignoreWhitespace: !0
        });
        return E.diff(e, t, r);
      },
      diffSentences: function (e, t, n) {
        return b.diff(e, t, n);
      },
      diffCss: function (e, t, n) {
        return A.diff(e, t, n);
      },
      diffJson: function (e, t, n) {
        return S.diff(e, t, n);
      },
      diffArrays: function (e, t, n) {
        return B.diff(e, t, n);
      },
      structuredPatch: O,
      createTwoFilesPatch: P,
      createPatch: function (e, t, n, r, u, o) {
        return P(e, e, t, n, r, u, o);
      },
      applyPatch: N,
      applyPatches: function (e, t) {
        "string" == typeof e && (e = T(e));
        var n = 0;
        !function r() {
          var u = e[n++];
          if (!u) return t.complete();
          t.loadFile(u, function (e, n) {
            if (e) return t.complete(e);
            var o = N(n, u, t);
            t.patched(u, o, function (e) {
              if (e) return t.complete(e);
              r();
            });
          });
        }();
      },
      parsePatch: T,
      merge: function (e, t, n) {
        e = j(e, n), t = j(t, n);
        var r = {};
        (e.index || t.index) && (r.index = e.index || t.index), (e.newFileName || t.newFileName) && (M(e) ? M(t) ? (r.oldFileName = L(r, e.oldFileName, t.oldFileName), r.newFileName = L(r, e.newFileName, t.newFileName), r.oldHeader = L(r, e.oldHeader, t.oldHeader), r.newHeader = L(r, e.newHeader, t.newHeader)) : (r.oldFileName = e.oldFileName, r.newFileName = e.newFileName, r.oldHeader = e.oldHeader, r.newHeader = e.newHeader) : (r.oldFileName = t.oldFileName || e.oldFileName, r.newFileName = t.newFileName || e.newFileName, r.oldHeader = t.oldHeader || e.oldHeader, r.newHeader = t.newHeader || e.newHeader)), r.hunks = [];
        for (var u = 0, o = 0, a = 0, i = 0; u < e.hunks.length || o < t.hunks.length;) {
          var s = e.hunks[u] || {
              oldStart: 1 / 0
            },
            l = t.hunks[o] || {
              oldStart: 1 / 0
            };
          if (R(s, l)) r.hunks.push(q(s, a)), u++, i += s.newLines - s.oldLines;else if (R(l, s)) r.hunks.push(q(l, i)), o++, a += l.newLines - l.oldLines;else {
            var c = {
              oldStart: Math.min(s.oldStart, l.oldStart),
              oldLines: 0,
              newStart: Math.min(s.newStart + a, l.oldStart + i),
              newLines: 0,
              lines: []
            };
            V(c, s.oldStart, s.lines, l.oldStart, l.lines), o++, u++, r.hunks.push(c);
          }
        }
        return r;
      },
      convertChangesToDMP: function (e) {
        for (var t, n, r = [], u = 0; u < e.length; u++) n = (t = e[u]).added ? 1 : t.removed ? -1 : 0, r.push([n, t.value]);
        return r;
      },
      convertChangesToXML: function (e) {
        for (var t = [], n = 0; n < e.length; n++) {
          var r = e[n];
          r.added ? t.push("<ins>") : r.removed && t.push("<del>"), t.push(Y(r.value)), r.added ? t.push("</ins>") : r.removed && t.push("</del>");
        }
        return t.join("");
      },
      canonicalize: w
    });
    function Q(e) {
      return {
        type: "concat",
        parts: e
      };
    }
    function Z(e) {
      return {
        type: "indent",
        contents: e
      };
    }
    function ee(e, t) {
      return {
        type: "align",
        contents: t,
        n: e
      };
    }
    function te(e, t) {
      return {
        type: "group",
        id: (t = t || {}).id,
        contents: e,
        break: !!t.shouldBreak,
        expandedStates: t.expandedStates
      };
    }
    const ne = {
        type: "break-parent"
      },
      re = Q([{
        type: "line",
        hard: !0
      }, ne]),
      ue = Q([{
        type: "line",
        hard: !0,
        literal: !0
      }, ne]);
    var oe = {
        concat: Q,
        join: function (e, t) {
          const n = [];
          for (let r = 0; r < t.length; r++) 0 !== r && n.push(e), n.push(t[r]);
          return Q(n);
        },
        line: {
          type: "line"
        },
        softline: {
          type: "line",
          soft: !0
        },
        hardline: re,
        literalline: ue,
        group: te,
        conditionalGroup: function (e, t) {
          return te(e[0], Object.assign({}, t, {
            expandedStates: e
          }));
        },
        fill: function (e) {
          return {
            type: "fill",
            parts: e
          };
        },
        lineSuffix: function (e) {
          return {
            type: "line-suffix",
            contents: e
          };
        },
        lineSuffixBoundary: {
          type: "line-suffix-boundary"
        },
        cursor: {
          type: "cursor",
          placeholder: Symbol("cursor")
        },
        breakParent: ne,
        ifBreak: function (e, t, n) {
          return {
            type: "if-break",
            breakContents: e,
            flatContents: t,
            groupId: (n = n || {}).groupId
          };
        },
        trim: {
          type: "trim"
        },
        indent: Z,
        align: ee,
        addAlignmentToDoc: function (e, t, n) {
          let r = e;
          if (t > 0) {
            for (let _e2 = 0; _e2 < Math.floor(t / n); ++_e2) r = Z(r);
            r = ee(t % n, r), r = ee(-1 / 0, r);
          }
          return r;
        },
        markAsRoot: function (e) {
          return ee({
            type: "root"
          }, e);
        },
        dedentToRoot: function (e) {
          return ee(-1 / 0, e);
        },
        dedent: function (e) {
          return ee(-1, e);
        }
      },
      ae = e => "string" == typeof e ? e.replace((({
        onlyFirst: e = !1
      } = {}) => {
        const t = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:[a-zA-Z\\d]*(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(t, e ? void 0 : "g");
      })(), "") : e;
    const ie = e => !Number.isNaN(e) && e >= 4352 && (e <= 4447 || 9001 === e || 9002 === e || 11904 <= e && e <= 12871 && 12351 !== e || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141);
    var se = ie,
      le = ie;
    se.default = le;
    const ce = e => {
      if ("string" != typeof (e = e.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, "  ")) || 0 === e.length) return 0;
      e = ae(e);
      let t = 0;
      for (let n = 0; n < e.length; n++) {
        const r = e.codePointAt(n);
        r <= 31 || r >= 127 && r <= 159 || r >= 768 && r <= 879 || (r > 65535 && n++, t += se(r) ? 2 : 1);
      }
      return t;
    };
    var pe = ce,
      de = ce;
    pe.default = de;
    var fe = e => {
        if ("string" != typeof e) throw new TypeError("Expected a string");
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      },
      he = e => e[e.length - 1],
      me = "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
    function ge() {
      throw new Error("setTimeout has not been defined");
    }
    function De() {
      throw new Error("clearTimeout has not been defined");
    }
    var ye = ge,
      Ee = De;
    function Ce(e) {
      if (ye === setTimeout) return setTimeout(e, 0);
      if ((ye === ge || !ye) && setTimeout) return ye = setTimeout, setTimeout(e, 0);
      try {
        return ye(e, 0);
      } catch (t) {
        try {
          return ye.call(null, e, 0);
        } catch (t) {
          return ye.call(this, e, 0);
        }
      }
    }
    "function" == typeof me.setTimeout && (ye = setTimeout), "function" == typeof me.clearTimeout && (Ee = clearTimeout);
    var be,
      Ae = [],
      ve = !1,
      Fe = -1;
    function xe() {
      ve && be && (ve = !1, be.length ? Ae = be.concat(Ae) : Fe = -1, Ae.length && Se());
    }
    function Se() {
      if (!ve) {
        var e = Ce(xe);
        ve = !0;
        for (var t = Ae.length; t;) {
          for (be = Ae, Ae = []; ++Fe < t;) be && be[Fe].run();
          Fe = -1, t = Ae.length;
        }
        be = null, ve = !1, function (e) {
          if (Ee === clearTimeout) return clearTimeout(e);
          if ((Ee === De || !Ee) && clearTimeout) return Ee = clearTimeout, clearTimeout(e);
          try {
            Ee(e);
          } catch (t) {
            try {
              return Ee.call(null, e);
            } catch (t) {
              return Ee.call(this, e);
            }
          }
        }(e);
      }
    }
    function we(e, t) {
      this.fun = e, this.array = t;
    }
    we.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    function Be() {}
    var Te = Be,
      ke = Be,
      Ne = Be,
      Oe = Be,
      Pe = Be,
      _e = Be,
      Ie = Be;
    var je = me.performance || {},
      Me = je.now || je.mozNow || je.msNow || je.oNow || je.webkitNow || function () {
        return new Date().getTime();
      };
    var Le = new Date();
    var Re = {
      nextTick: function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        Ae.push(new we(e, t)), 1 !== Ae.length || ve || Ce(Se);
      },
      title: "browser",
      browser: !0,
      env: {},
      argv: [],
      version: "",
      versions: {},
      on: Te,
      addListener: ke,
      once: Ne,
      off: Oe,
      removeListener: Pe,
      removeAllListeners: _e,
      emit: Ie,
      binding: function (e) {
        throw new Error("process.binding is not supported");
      },
      cwd: function () {
        return "/";
      },
      chdir: function (e) {
        throw new Error("process.chdir is not supported");
      },
      umask: function () {
        return 0;
      },
      hrtime: function (e) {
        var t = .001 * Me.call(je),
          n = Math.floor(t),
          r = Math.floor(t % 1 * 1e9);
        return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
      },
      platform: "browser",
      release: {},
      config: {},
      uptime: function () {
        return (new Date() - Le) / 1e3;
      }
    };
    var qe = "object" == typeof Re && Re.env && Re.env.NODE_DEBUG && /\bsemver\b/i.test(Re.env.NODE_DEBUG) ? (...e) => console.error("SEMVER", ...e) : () => {};
    var Ve = {
        SEMVER_SPEC_VERSION: "2.0.0",
        MAX_LENGTH: 256,
        MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
        MAX_SAFE_COMPONENT_LENGTH: 16
      },
      We = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : {};
    function $e(e, t, n) {
      return e(n = {
        path: t,
        exports: {},
        require: function (e, t) {
          return function () {
            throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
          }();
        }
      }, n.exports), n.exports;
    }
    function Ue(e) {
      return e && e.default || e;
    }
    var ze = $e(function (e, t) {
      const {
          MAX_SAFE_COMPONENT_LENGTH: n
        } = Ve,
        r = (t = e.exports = {}).re = [],
        u = t.src = [],
        o = t.t = {};
      let a = 0;
      const i = (e, t, n) => {
        const i = a++;
        qe(i, t), o[e] = i, u[i] = t, r[i] = new RegExp(t, n ? "g" : void 0);
      };
      i("NUMERICIDENTIFIER", "0|[1-9]\\d*"), i("NUMERICIDENTIFIERLOOSE", "[0-9]+"), i("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), i("MAINVERSION", "(".concat(u[o.NUMERICIDENTIFIER], ")\\.") + "(".concat(u[o.NUMERICIDENTIFIER], ")\\.") + "(".concat(u[o.NUMERICIDENTIFIER], ")")), i("MAINVERSIONLOOSE", "(".concat(u[o.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(u[o.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(u[o.NUMERICIDENTIFIERLOOSE], ")")), i("PRERELEASEIDENTIFIER", "(?:".concat(u[o.NUMERICIDENTIFIER], "|").concat(u[o.NONNUMERICIDENTIFIER], ")")), i("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(u[o.NUMERICIDENTIFIERLOOSE], "|").concat(u[o.NONNUMERICIDENTIFIER], ")")), i("PRERELEASE", "(?:-(".concat(u[o.PRERELEASEIDENTIFIER], "(?:\\.").concat(u[o.PRERELEASEIDENTIFIER], ")*))")), i("PRERELEASELOOSE", "(?:-?(".concat(u[o.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(u[o.PRERELEASEIDENTIFIERLOOSE], ")*))")), i("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), i("BUILD", "(?:\\+(".concat(u[o.BUILDIDENTIFIER], "(?:\\.").concat(u[o.BUILDIDENTIFIER], ")*))")), i("FULLPLAIN", "v?".concat(u[o.MAINVERSION]).concat(u[o.PRERELEASE], "?").concat(u[o.BUILD], "?")), i("FULL", "^".concat(u[o.FULLPLAIN], "$")), i("LOOSEPLAIN", "[v=\\s]*".concat(u[o.MAINVERSIONLOOSE]).concat(u[o.PRERELEASELOOSE], "?").concat(u[o.BUILD], "?")), i("LOOSE", "^".concat(u[o.LOOSEPLAIN], "$")), i("GTLT", "((?:<|>)?=?)"), i("XRANGEIDENTIFIERLOOSE", "".concat(u[o.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), i("XRANGEIDENTIFIER", "".concat(u[o.NUMERICIDENTIFIER], "|x|X|\\*")), i("XRANGEPLAIN", "[v=\\s]*(".concat(u[o.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(u[o.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(u[o.XRANGEIDENTIFIER], ")") + "(?:".concat(u[o.PRERELEASE], ")?").concat(u[o.BUILD], "?") + ")?)?"), i("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(u[o.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(u[o.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(u[o.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(u[o.PRERELEASELOOSE], ")?").concat(u[o.BUILD], "?") + ")?)?"), i("XRANGE", "^".concat(u[o.GTLT], "\\s*").concat(u[o.XRANGEPLAIN], "$")), i("XRANGELOOSE", "^".concat(u[o.GTLT], "\\s*").concat(u[o.XRANGEPLAINLOOSE], "$")), i("COERCE", "".concat("(^|[^\\d])(\\d{1,").concat(n, "})") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:$|[^\\d])"), i("COERCERTL", u[o.COERCE], !0), i("LONETILDE", "(?:~>?)"), i("TILDETRIM", "(\\s*)".concat(u[o.LONETILDE], "\\s+"), !0), t.tildeTrimReplace = "$1~", i("TILDE", "^".concat(u[o.LONETILDE]).concat(u[o.XRANGEPLAIN], "$")), i("TILDELOOSE", "^".concat(u[o.LONETILDE]).concat(u[o.XRANGEPLAINLOOSE], "$")), i("LONECARET", "(?:\\^)"), i("CARETTRIM", "(\\s*)".concat(u[o.LONECARET], "\\s+"), !0), t.caretTrimReplace = "$1^", i("CARET", "^".concat(u[o.LONECARET]).concat(u[o.XRANGEPLAIN], "$")), i("CARETLOOSE", "^".concat(u[o.LONECARET]).concat(u[o.XRANGEPLAINLOOSE], "$")), i("COMPARATORLOOSE", "^".concat(u[o.GTLT], "\\s*(").concat(u[o.LOOSEPLAIN], ")$|^$")), i("COMPARATOR", "^".concat(u[o.GTLT], "\\s*(").concat(u[o.FULLPLAIN], ")$|^$")), i("COMPARATORTRIM", "(\\s*)".concat(u[o.GTLT], "\\s*(").concat(u[o.LOOSEPLAIN], "|").concat(u[o.XRANGEPLAIN], ")"), !0), t.comparatorTrimReplace = "$1$2$3", i("HYPHENRANGE", "^\\s*(".concat(u[o.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(u[o.XRANGEPLAIN], ")") + "\\s*$"), i("HYPHENRANGELOOSE", "^\\s*(".concat(u[o.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(u[o.XRANGEPLAINLOOSE], ")") + "\\s*$"), i("STAR", "(<|>)?=?\\s*\\*"), i("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), i("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
    });
    const Je = /^[0-9]+$/,
      Ge = (e, t) => {
        const n = Je.test(e),
          r = Je.test(t);
        return n && r && (e = +e, t = +t), e === t ? 0 : n && !r ? -1 : r && !n ? 1 : e < t ? -1 : 1;
      };
    var He = {
      compareIdentifiers: Ge,
      rcompareIdentifiers: (e, t) => Ge(t, e)
    };
    const {
        MAX_LENGTH: Xe,
        MAX_SAFE_INTEGER: Ye
      } = Ve,
      {
        re: Ke,
        t: Qe
      } = ze,
      {
        compareIdentifiers: Ze
      } = He;
    class et {
      constructor(e, t) {
        if (t && "object" == typeof t || (t = {
          loose: !!t,
          includePrerelease: !1
        }), e instanceof et) {
          if (e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease) return e;
          e = e.version;
        } else if ("string" != typeof e) throw new TypeError("Invalid Version: ".concat(e));
        if (e.length > Xe) throw new TypeError("version is longer than ".concat(Xe, " characters"));
        qe("SemVer", e, t), this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease;
        const n = e.trim().match(t.loose ? Ke[Qe.LOOSE] : Ke[Qe.FULL]);
        if (!n) throw new TypeError("Invalid Version: ".concat(e));
        if (this.raw = e, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > Ye || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > Ye || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > Ye || this.patch < 0) throw new TypeError("Invalid patch version");
        n[4] ? this.prerelease = n[4].split(".").map(e => {
          if (/^[0-9]+$/.test(e)) {
            const t = +e;
            if (t >= 0 && t < Ye) return t;
          }
          return e;
        }) : this.prerelease = [], this.build = n[5] ? n[5].split(".") : [], this.format();
      }
      format() {
        return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
      }
      toString() {
        return this.version;
      }
      compare(e) {
        if (qe("SemVer.compare", this.version, this.options, e), !(e instanceof et)) {
          if ("string" == typeof e && e === this.version) return 0;
          e = new et(e, this.options);
        }
        return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
      }
      compareMain(e) {
        return e instanceof et || (e = new et(e, this.options)), Ze(this.major, e.major) || Ze(this.minor, e.minor) || Ze(this.patch, e.patch);
      }
      comparePre(e) {
        if (e instanceof et || (e = new et(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
        if (!this.prerelease.length && e.prerelease.length) return 1;
        if (!this.prerelease.length && !e.prerelease.length) return 0;
        let t = 0;
        do {
          const n = this.prerelease[t],
            r = e.prerelease[t];
          if (qe("prerelease compare", t, n, r), void 0 === n && void 0 === r) return 0;
          if (void 0 === r) return 1;
          if (void 0 === n) return -1;
          if (n !== r) return Ze(n, r);
        } while (++t);
      }
      compareBuild(e) {
        e instanceof et || (e = new et(e, this.options));
        let t = 0;
        do {
          const n = this.build[t],
            r = e.build[t];
          if (qe("prerelease compare", t, n, r), void 0 === n && void 0 === r) return 0;
          if (void 0 === r) return 1;
          if (void 0 === n) return -1;
          if (n !== r) return Ze(n, r);
        } while (++t);
      }
      inc(e, t) {
        switch (e) {
          case "premajor":
            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
            break;
          case "preminor":
            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
            break;
          case "prepatch":
            this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
            break;
          case "prerelease":
            0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
            break;
          case "major":
            0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
            break;
          case "minor":
            0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
            break;
          case "patch":
            0 === this.prerelease.length && this.patch++, this.prerelease = [];
            break;
          case "pre":
            if (0 === this.prerelease.length) this.prerelease = [0];else {
              let _e3 = this.prerelease.length;
              for (; --_e3 >= 0;) "number" == typeof this.prerelease[_e3] && (this.prerelease[_e3]++, _e3 = -2);
              -1 === _e3 && this.prerelease.push(0);
            }
            t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0]) : this.prerelease = [t, 0]);
            break;
          default:
            throw new Error("invalid increment argument: ".concat(e));
        }
        return this.format(), this.raw = this.version, this;
      }
    }
    var tt = et;
    var nt = (e, t, n) => new tt(e, n).compare(new tt(t, n));
    var rt = (e, t, n) => nt(e, t, n) < 0;
    var ut = (e, t, n) => nt(e, t, n) >= 0,
      ot = $e(function (e, t) {
        function n() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        }
        function r() {
          return "undefined" != typeof WeakMap ? new WeakMap() : {
            add: n,
            delete: n,
            get: n,
            set: n,
            has: function (e) {
              return !1;
            }
          };
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var u = Object.prototype.hasOwnProperty,
          o = function (e, t) {
            return u.call(e, t);
          };
        function a(e, t) {
          for (var n in t) o(t, n) && (e[n] = t[n]);
          return e;
        }
        var i = /^[ \t]*(?:\r\n|\r|\n)/,
          s = /(?:\r\n|\r|\n)[ \t]*$/,
          l = /^(?:[\r\n]|$)/,
          c = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,
          p = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function d(e, t, n) {
          var r = 0,
            u = e[0].match(c);
          u && (r = u[1].length);
          var o = new RegExp("(\\r\\n|\\r|\\n).{0," + r + "}", "g");
          t && (e = e.slice(1));
          var a = n.newline,
            l = n.trimLeadingNewline,
            p = n.trimTrailingNewline,
            d = "string" == typeof a,
            f = e.length;
          return e.map(function (e, t) {
            return e = e.replace(o, "$1"), 0 === t && l && (e = e.replace(i, "")), t === f - 1 && p && (e = e.replace(s, "")), d && (e = e.replace(/\r\n|\n|\r/g, function (e) {
              return a;
            })), e;
          });
        }
        function f(e, t) {
          for (var n = "", r = 0, u = e.length; r < u; r++) n += e[r], r < u - 1 && (n += t[r]);
          return n;
        }
        function h(e) {
          return o(e, "raw") && o(e, "length");
        }
        var m = function e(t) {
          var n = r(),
            u = r();
          return a(function r(o) {
            for (var i = [], s = 1; s < arguments.length; s++) i[s - 1] = arguments[s];
            if (h(o)) {
              var c = o,
                g = (i[0] === r || i[0] === m) && p.test(c[0]) && l.test(c[1]),
                D = g ? u : n,
                y = D.get(c);
              if (y || (y = d(c, g, t), D.set(c, y)), 0 === i.length) return y[0];
              var E = f(y, g ? i.slice(1) : i);
              return E;
            }
            return e(a(a({}, t), o || {}));
          }, {
            string: function (e) {
              return d([e], !1, t)[0];
            }
          });
        }({
          trimLeadingNewline: !0,
          trimTrailingNewline: !0
        });
        t.outdent = m, t.default = m;
        try {
          e.exports = m, Object.defineProperty(m, "__esModule", {
            value: !0
          }), m.default = m, m.outdent = m;
        } catch (e) {}
      });
    function at() {
      const e = t(["\n      Require either '@prettier' or '@format' to be present in the file's first docblock comment\n      in order for it to be formatted.\n    "]);
      return at = function () {
        return e;
      }, e;
    }
    function it() {
      const e = t(["\n      Format code starting at a given character offset.\n      The range will extend backwards to the start of the first line containing the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);
      return it = function () {
        return e;
      }, e;
    }
    function st() {
      const e = t(["\n      Format code ending at a given character offset (exclusive).\n      The range will extend forwards to the end of the selected statement.\n      This option cannot be used with --cursor-offset.\n    "]);
      return st = function () {
        return e;
      }, e;
    }
    function lt() {
      const e = t(["\n      Custom directory that contains prettier plugins in node_modules subdirectory.\n      Overrides default behavior when plugins are searched relatively to the location of Prettier.\n      Multiple values are accepted.\n    "]);
      return lt = function () {
        return e;
      }, e;
    }
    function ct() {
      const e = t(["\n          Maintain existing\n          (mixed values within one file are normalised by looking at what's used after the first line)\n        "]);
      return ct = function () {
        return e;
      }, e;
    }
    function pt() {
      const e = t(["\n      Print (to stderr) where a cursor at the given position would move to after formatting.\n      This option cannot be used with --range-start and --range-end.\n    "]);
      return pt = function () {
        return e;
      }, e;
    }
    const {
      outdent: dt
    } = ot;
    var ft = {
        CATEGORY_CONFIG: "Config",
        CATEGORY_EDITOR: "Editor",
        CATEGORY_FORMAT: "Format",
        CATEGORY_OTHER: "Other",
        CATEGORY_OUTPUT: "Output",
        CATEGORY_GLOBAL: "Global",
        CATEGORY_SPECIAL: "Special",
        options: {
          cursorOffset: {
            since: "1.4.0",
            category: "Special",
            type: "int",
            default: -1,
            range: {
              start: -1,
              end: 1 / 0,
              step: 1
            },
            description: dt(pt()),
            cliCategory: "Editor"
          },
          endOfLine: {
            since: "1.15.0",
            category: "Global",
            type: "choice",
            default: [{
              since: "1.15.0",
              value: "auto"
            }, {
              since: "2.0.0",
              value: "lf"
            }],
            description: "Which end of line characters to apply.",
            choices: [{
              value: "lf",
              description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
            }, {
              value: "crlf",
              description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
            }, {
              value: "cr",
              description: "Carriage Return character only (\\r), used very rarely"
            }, {
              value: "auto",
              description: dt(ct())
            }]
          },
          filepath: {
            since: "1.4.0",
            category: "Special",
            type: "path",
            description: "Specify the input filepath. This will be used to do parser inference.",
            cliName: "stdin-filepath",
            cliCategory: "Other",
            cliDescription: "Path to the file to pretend that stdin comes from."
          },
          insertPragma: {
            since: "1.8.0",
            category: "Special",
            type: "boolean",
            default: !1,
            description: "Insert @format pragma into file's first docblock comment.",
            cliCategory: "Other"
          },
          parser: {
            since: "0.0.10",
            category: "Global",
            type: "choice",
            default: [{
              since: "0.0.10",
              value: "babylon"
            }, {
              since: "1.13.0",
              value: void 0
            }],
            description: "Which parser to use.",
            exception: e => "string" == typeof e || "function" == typeof e,
            choices: [{
              value: "flow",
              description: "Flow"
            }, {
              value: "babel",
              since: "1.16.0",
              description: "JavaScript"
            }, {
              value: "babel-flow",
              since: "1.16.0",
              description: "Flow"
            }, {
              value: "babel-ts",
              since: "2.0.0",
              description: "TypeScript"
            }, {
              value: "typescript",
              since: "1.4.0",
              description: "TypeScript"
            }, {
              value: "css",
              since: "1.7.1",
              description: "CSS"
            }, {
              value: "less",
              since: "1.7.1",
              description: "Less"
            }, {
              value: "scss",
              since: "1.7.1",
              description: "SCSS"
            }, {
              value: "json",
              since: "1.5.0",
              description: "JSON"
            }, {
              value: "json5",
              since: "1.13.0",
              description: "JSON5"
            }, {
              value: "json-stringify",
              since: "1.13.0",
              description: "JSON.stringify"
            }, {
              value: "graphql",
              since: "1.5.0",
              description: "GraphQL"
            }, {
              value: "markdown",
              since: "1.8.0",
              description: "Markdown"
            }, {
              value: "mdx",
              since: "1.15.0",
              description: "MDX"
            }, {
              value: "vue",
              since: "1.10.0",
              description: "Vue"
            }, {
              value: "yaml",
              since: "1.14.0",
              description: "YAML"
            }, {
              value: "glimmer",
              since: null,
              description: "Handlebars"
            }, {
              value: "html",
              since: "1.15.0",
              description: "HTML"
            }, {
              value: "angular",
              since: "1.15.0",
              description: "Angular"
            }, {
              value: "lwc",
              since: "1.17.0",
              description: "Lightning Web Components"
            }]
          },
          plugins: {
            since: "1.10.0",
            type: "path",
            array: !0,
            default: [{
              value: []
            }],
            category: "Global",
            description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
            exception: e => "string" == typeof e || "object" == typeof e,
            cliName: "plugin",
            cliCategory: "Config"
          },
          pluginSearchDirs: {
            since: "1.13.0",
            type: "path",
            array: !0,
            default: [{
              value: []
            }],
            category: "Global",
            description: dt(lt()),
            exception: e => "string" == typeof e || "object" == typeof e,
            cliName: "plugin-search-dir",
            cliCategory: "Config"
          },
          printWidth: {
            since: "0.0.0",
            category: "Global",
            type: "int",
            default: 80,
            description: "The line length where Prettier will try wrap.",
            range: {
              start: 0,
              end: 1 / 0,
              step: 1
            }
          },
          rangeEnd: {
            since: "1.4.0",
            category: "Special",
            type: "int",
            default: 1 / 0,
            range: {
              start: 0,
              end: 1 / 0,
              step: 1
            },
            description: dt(st()),
            cliCategory: "Editor"
          },
          rangeStart: {
            since: "1.4.0",
            category: "Special",
            type: "int",
            default: 0,
            range: {
              start: 0,
              end: 1 / 0,
              step: 1
            },
            description: dt(it()),
            cliCategory: "Editor"
          },
          requirePragma: {
            since: "1.7.0",
            category: "Special",
            type: "boolean",
            default: !1,
            description: dt(at()),
            cliCategory: "Other"
          },
          tabWidth: {
            type: "int",
            category: "Global",
            default: 2,
            description: "Number of spaces per indentation level.",
            range: {
              start: 0,
              end: 1 / 0,
              step: 1
            }
          },
          useTabs: {
            since: "1.0.0",
            category: "Global",
            type: "boolean",
            default: !1,
            description: "Indent with tabs instead of spaces."
          },
          embeddedLanguageFormatting: {
            since: "2.1.0",
            category: "Global",
            type: "choice",
            default: [{
              since: "2.1.0",
              value: "auto"
            }],
            description: "Control how Prettier formats quoted code embedded in the file.",
            choices: [{
              value: "auto",
              description: "Format embedded code if Prettier can automatically identify it."
            }, {
              value: "off",
              description: "Never automatically format embedded code."
            }]
          }
        }
      },
      ht = Ue(c);
    const mt = {
        compare: nt,
        lt: rt,
        gte: ut
      },
      gt = ht.version,
      Dt = ft.options;
    var yt = {
      getSupportInfo: function ({
        plugins: t = [],
        showUnreleased: n = !1,
        showDeprecated: r = !1,
        showInternal: u = !1
      } = {}) {
        const o = gt.split("-", 1)[0],
          a = t.reduce((e, t) => e.concat(t.languages || []), []).filter(s),
          i = ((e, t) => Object.entries(e).map(([e, n]) => Object.assign({
            [t]: e
          }, n)))(Object.assign({}, ...t.map(({
            options: e
          }) => e), Dt), "name").filter(e => s(e) && l(e)).sort((e, t) => e.name === t.name ? 0 : e.name < t.name ? -1 : 1).map(function (t) {
            if (u) return t;
            return e(t, ["cliName", "cliCategory", "cliDescription"]);
          }).map(e => {
            e = Object.assign({}, e), Array.isArray(e.default) && (e.default = 1 === e.default.length ? e.default[0].value : e.default.filter(s).sort((e, t) => mt.compare(t.since, e.since))[0].value), Array.isArray(e.choices) && (e.choices = e.choices.filter(e => s(e) && l(e)), "parser" === e.name && function (e, t, n) {
              const r = new Set(e.choices.map(e => e.value));
              for (const u of t) if (u.parsers) for (const _t2 of u.parsers) if (!r.has(_t2)) {
                r.add(_t2);
                const o = n.find(e => e.parsers && e.parsers[_t2]);
                let a = u.name;
                o && o.name && (a += " (plugin: ".concat(o.name, ")")), e.choices.push({
                  value: _t2,
                  description: a
                });
              }
            }(e, a, t));
            const n = t.filter(t => t.defaultOptions && void 0 !== t.defaultOptions[e.name]).reduce((t, n) => (t[n.name] = n.defaultOptions[e.name], t), {});
            return Object.assign({}, e, {
              pluginDefaults: n
            });
          });
        return {
          languages: a,
          options: i
        };
        function s(e) {
          return n || !("since" in e) || e.since && mt.gte(o, e.since);
        }
        function l(e) {
          return r || !("deprecated" in e) || e.deprecated && mt.lt(o, e.deprecated);
        }
      }
    };
    const Et = /[^\x20-\x7F]/;
    function Ct(e) {
      return (t, n, r) => {
        const u = r && r.backwards;
        if (!1 === n) return !1;
        const {
          length: o
        } = t;
        let a = n;
        for (; a >= 0 && a < o;) {
          const _n2 = t.charAt(a);
          if (e instanceof RegExp) {
            if (!e.test(_n2)) return a;
          } else if (!e.includes(_n2)) return a;
          u ? a-- : a++;
        }
        return (-1 === a || a === o) && a;
      };
    }
    const bt = Ct(/\s/),
      At = Ct(" \t"),
      vt = Ct(",; \t"),
      Ft = Ct(/[^\n\r]/);
    function xt(e, t) {
      if (!1 === t) return !1;
      if ("/" === e.charAt(t) && "*" === e.charAt(t + 1)) for (let n = t + 2; n < e.length; ++n) if ("*" === e.charAt(n) && "/" === e.charAt(n + 1)) return n + 2;
      return t;
    }
    function St(e, t) {
      return !1 !== t && ("/" === e.charAt(t) && "/" === e.charAt(t + 1) ? Ft(e, t) : t);
    }
    function wt(e, t, n) {
      const r = n && n.backwards;
      if (!1 === t) return !1;
      const u = e.charAt(t);
      if (r) {
        if ("\r" === e.charAt(t - 1) && "\n" === u) return t - 2;
        if ("\n" === u || "\r" === u || "\u2028" === u || "\u2029" === u) return t - 1;
      } else {
        if ("\r" === u && "\n" === e.charAt(t + 1)) return t + 2;
        if ("\n" === u || "\r" === u || "\u2028" === u || "\u2029" === u) return t + 1;
      }
      return t;
    }
    function Bt(e, t, n) {
      const r = At(e, (n = n || {}).backwards ? t - 1 : t, n);
      return r !== wt(e, r, n);
    }
    function Tt(e, t) {
      let n = null,
        r = t;
      for (; r !== n;) n = r, r = vt(e, r), r = xt(e, r), r = At(e, r);
      return r = St(e, r), r = wt(e, r), !1 !== r && Bt(e, r);
    }
    function kt(e, t) {
      let n = null,
        r = t;
      for (; r !== n;) n = r, r = At(e, r), r = xt(e, r), r = St(e, r), r = wt(e, r);
      return r;
    }
    function Nt(e, t, n) {
      return kt(e, n(t));
    }
    function Ot(e, t, n) {
      let r = 0;
      for (let u = n = n || 0; u < e.length; ++u) "\t" === e[u] ? r = r + t - r % t : r++;
      return r;
    }
    function Pt(e, t) {
      const n = e.slice(1, -1),
        r = {
          quote: '"',
          regex: /"/g
        },
        u = {
          quote: "'",
          regex: /'/g
        },
        o = "'" === t ? u : r,
        a = o === u ? r : u;
      let i = o.quote;
      if (n.includes(o.quote) || n.includes(a.quote)) {
        i = (n.match(o.regex) || []).length > (n.match(a.regex) || []).length ? a.quote : o.quote;
      }
      return i;
    }
    function _t(e, t, n) {
      const r = '"' === t ? "'" : '"',
        u = e.replace(/\\([\S\s])|(["'])/g, (e, u, o) => u === r ? u : o === t ? "\\" + o : o || (n && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(u) ? u : "\\" + u));
      return t + u + t;
    }
    function It(e) {
      return e && (e.comments && e.comments.length > 0 && e.comments.some(e => jt(e) && !e.unignore) || e.prettierIgnore);
    }
    function jt(e) {
      return "prettier-ignore" === e.value.trim();
    }
    function Mt(e, t) {
      (e.comments || (e.comments = [])).push(t), t.printed = !1, "JSXText" === e.type && (t.printed = !0);
    }
    var Lt = {
      replaceEndOfLineWith: function (e, t) {
        const n = [];
        for (const r of e.split("\n")) 0 !== n.length && n.push(t), n.push(r);
        return n;
      },
      getStringWidth: function (e) {
        return e ? Et.test(e) ? pe(e) : e.length : 0;
      },
      getMaxContinuousCount: function (e, t) {
        const n = e.match(new RegExp("(".concat(fe(t), ")+"), "g"));
        return null === n ? 0 : n.reduce((e, n) => Math.max(e, n.length / t.length), 0);
      },
      getMinNotPresentContinuousCount: function (e, t) {
        const n = e.match(new RegExp("(".concat(fe(t), ")+"), "g"));
        if (null === n) return 0;
        const r = new Map();
        let u = 0;
        for (const _e4 of n) {
          const _n3 = _e4.length / t.length;
          r.set(_n3, !0), _n3 > u && (u = _n3);
        }
        for (let _e5 = 1; _e5 < u; _e5++) if (!r.get(_e5)) return _e5;
        return u + 1;
      },
      getParserName: function (e, t) {
        const n = yt.getSupportInfo({
          plugins: t.plugins
        }).languages.find(t => t.name.toLowerCase() === e || t.aliases && t.aliases.includes(e) || t.extensions && t.extensions.some(t => t === ".".concat(e)));
        return n ? n.parsers[0] : null;
      },
      getPenultimate: e => e[e.length - 2],
      getLast: he,
      getNextNonSpaceNonCommentCharacterIndexWithStartIndex: kt,
      getNextNonSpaceNonCommentCharacterIndex: Nt,
      getNextNonSpaceNonCommentCharacter: function (e, t, n) {
        return e.charAt(Nt(e, t, n));
      },
      skip: Ct,
      skipWhitespace: bt,
      skipSpaces: At,
      skipToLineEnd: vt,
      skipEverythingButNewLine: Ft,
      skipInlineComment: xt,
      skipTrailingComment: St,
      skipNewline: wt,
      isNextLineEmptyAfterIndex: Tt,
      isNextLineEmpty: function (e, t, n) {
        return Tt(e, n(t));
      },
      isPreviousLineEmpty: function (e, t, n) {
        let r = n(t) - 1;
        return r = At(e, r, {
          backwards: !0
        }), r = wt(e, r, {
          backwards: !0
        }), r = At(e, r, {
          backwards: !0
        }), r !== wt(e, r, {
          backwards: !0
        });
      },
      hasNewline: Bt,
      hasNewlineInRange: function (e, t, n) {
        for (let r = t; r < n; ++r) if ("\n" === e.charAt(r)) return !0;
        return !1;
      },
      hasSpaces: function (e, t, n) {
        return At(e, (n = n || {}).backwards ? t - 1 : t, n) !== t;
      },
      getAlignmentSize: Ot,
      getIndentSize: function (e, t) {
        const n = e.lastIndexOf("\n");
        return -1 === n ? 0 : Ot(e.slice(n + 1).match(/^[\t ]*/)[0], t);
      },
      getPreferredQuote: Pt,
      printString: function (e, t, n) {
        const r = e.slice(1, -1),
          u = !r.includes('"') && !r.includes("'"),
          o = "json" === t.parser ? '"' : t.__isInHtmlAttribute ? "'" : Pt(e, t.singleQuote ? "'" : '"');
        return n ? u ? o + r + o : e : _t(r, o, !("css" === t.parser || "less" === t.parser || "scss" === t.parser || t.embeddedInHtml));
      },
      printNumber: function (e) {
        return e.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
      },
      hasIgnoreComment: function (e) {
        return It(e.getValue());
      },
      hasNodeIgnoreComment: It,
      isNodeIgnoreComment: jt,
      makeString: _t,
      addLeadingComment: function (e, t) {
        t.leading = !0, t.trailing = !1, Mt(e, t);
      },
      addDanglingComment: function (e, t, n) {
        t.leading = !1, t.trailing = !1, n && (t.marker = n), Mt(e, t);
      },
      addTrailingComment: function (e, t) {
        t.leading = !1, t.trailing = !0, Mt(e, t);
      },
      isWithinParentArrayProperty: function (e, t) {
        const n = e.getValue(),
          r = e.getParentNode();
        if (null == r) return !1;
        if (!Array.isArray(r[t])) return !1;
        const u = e.getName();
        return r[t][u] === n;
      },
      isFrontMatterNode: function (e) {
        return e && "front-matter" === e.type;
      },
      getShebang: function (e) {
        if (!e.startsWith("#!")) return "";
        const t = e.indexOf("\n");
        return -1 === t ? e : e.slice(0, t);
      }
    };
    var Rt = {
      guessEndOfLine: function (e) {
        const t = e.indexOf("\r");
        return t >= 0 ? "\n" === e.charAt(t + 1) ? "crlf" : "cr" : "lf";
      },
      convertEndOfLineToChars: function (e) {
        switch (e) {
          case "cr":
            return "\r";
          case "crlf":
            return "\r\n";
          default:
            return "\n";
        }
      },
      countEndOfLineChars: function (e, t) {
        let n;
        if ("\n" === t) n = /\n/g;else if ("\r" === t) n = /\r/g;else {
          if ("\r\n" !== t) throw new Error('Unexpected "eol" '.concat(JSON.stringify(t), "."));
          n = /\r\n/g;
        }
        const r = e.match(n);
        return r ? r.length : 0;
      },
      normalizeEndOfLine: function (e) {
        return e.replace(/\r\n?/g, "\n");
      }
    };
    const {
        getStringWidth: qt
      } = Lt,
      {
        convertEndOfLineToChars: Vt
      } = Rt,
      {
        concat: Wt,
        fill: $t,
        cursor: Ut
      } = oe;
    let zt;
    function Jt(e, t) {
      return Ht(e, {
        type: "indent"
      }, t);
    }
    function Gt(e, t, n) {
      if (t === -1 / 0) return e.root || {
        value: "",
        length: 0,
        queue: []
      };
      if (t < 0) return Ht(e, {
        type: "dedent"
      }, n);
      if (!t) return e;
      if ("root" === t.type) return Object.assign({}, e, {
        root: e
      });
      return Ht(e, {
        type: "string" == typeof t ? "stringAlign" : "numberAlign",
        n: t
      }, n);
    }
    function Ht(e, t, n) {
      const r = "dedent" === t.type ? e.queue.slice(0, -1) : e.queue.concat(t);
      let u = "",
        o = 0,
        a = 0,
        i = 0;
      for (const _e6 of r) switch (_e6.type) {
        case "indent":
          c(), n.useTabs ? s(1) : l(n.tabWidth);
          break;
        case "stringAlign":
          c(), u += _e6.n, o += _e6.n.length;
          break;
        case "numberAlign":
          a += 1, i += _e6.n;
          break;
        default:
          throw new Error("Unexpected type '".concat(_e6.type, "'"));
      }
      return p(), Object.assign({}, e, {
        value: u,
        length: o,
        queue: r
      });
      function s(e) {
        u += "\t".repeat(e), o += n.tabWidth * e;
      }
      function l(e) {
        u += " ".repeat(e), o += e;
      }
      function c() {
        n.useTabs ? function () {
          a > 0 && s(a);
          d();
        }() : p();
      }
      function p() {
        i > 0 && l(i), d();
      }
      function d() {
        a = 0, i = 0;
      }
    }
    function Xt(e) {
      if (0 === e.length) return 0;
      let t = 0;
      for (; e.length > 0 && "string" == typeof e[e.length - 1] && e[e.length - 1].match(/^[\t ]*$/);) t += e.pop().length;
      if (e.length && "string" == typeof e[e.length - 1]) {
        const n = e[e.length - 1].replace(/[\t ]*$/, "");
        t += e[e.length - 1].length - n.length, e[e.length - 1] = n;
      }
      return t;
    }
    function Yt(e, t, n, r, u) {
      let o = t.length;
      const a = [e],
        i = [];
      for (; n >= 0;) {
        if (0 === a.length) {
          if (0 === o) return !0;
          a.push(t[o - 1]), o--;
          continue;
        }
        const [_e7, s, l] = a.pop();
        if ("string" == typeof l) i.push(l), n -= qt(l);else switch (l.type) {
          case "concat":
            for (let _t3 = l.parts.length - 1; _t3 >= 0; _t3--) a.push([_e7, s, l.parts[_t3]]);
            break;
          case "indent":
            a.push([Jt(_e7, r), s, l.contents]);
            break;
          case "align":
            a.push([Gt(_e7, l.n, r), s, l.contents]);
            break;
          case "trim":
            n += Xt(i);
            break;
          case "group":
            if (u && l.break) return !1;
            a.push([_e7, l.break ? 1 : s, l.contents]), l.id && (zt[l.id] = a[a.length - 1][1]);
            break;
          case "fill":
            for (let _t4 = l.parts.length - 1; _t4 >= 0; _t4--) a.push([_e7, s, l.parts[_t4]]);
            break;
          case "if-break":
            {
              const _t5 = l.groupId ? zt[l.groupId] : s;
              1 === _t5 && l.breakContents && a.push([_e7, s, l.breakContents]), 2 === _t5 && l.flatContents && a.push([_e7, s, l.flatContents]);
              break;
            }
          case "line":
            switch (s) {
              case 2:
                if (!l.hard) {
                  l.soft || (i.push(" "), n -= 1);
                  break;
                }
                return !0;
              case 1:
                return !0;
            }
        }
      }
      return !1;
    }
    var Kt = {
      printDocToString: function (e, t) {
        zt = {};
        const n = t.printWidth,
          r = Vt(t.endOfLine);
        let u = 0;
        const o = [[{
            value: "",
            length: 0,
            queue: []
          }, 1, e]],
          a = [];
        let i = !1,
          s = [];
        for (; 0 !== o.length;) {
          const [_e8, _l2, c] = o.pop();
          if ("string" == typeof c) {
            const _e9 = "\n" !== r && c.includes("\n") ? c.replace(/\n/g, r) : c;
            a.push(_e9), u += qt(_e9);
          } else switch (c.type) {
            case "cursor":
              a.push(Ut.placeholder);
              break;
            case "concat":
              for (let _t6 = c.parts.length - 1; _t6 >= 0; _t6--) o.push([_e8, _l2, c.parts[_t6]]);
              break;
            case "indent":
              o.push([Jt(_e8, t), _l2, c.contents]);
              break;
            case "align":
              o.push([Gt(_e8, c.n, t), _l2, c.contents]);
              break;
            case "trim":
              u -= Xt(a);
              break;
            case "group":
              switch (_l2) {
                case 2:
                  if (!i) {
                    o.push([_e8, c.break ? 1 : 2, c.contents]);
                    break;
                  }
                case 1:
                  {
                    i = !1;
                    const _r2 = [_e8, 2, c.contents],
                      _a2 = n - u;
                    if (!c.break && Yt(_r2, o, _a2, t)) o.push(_r2);else if (c.expandedStates) {
                      const _n4 = c.expandedStates[c.expandedStates.length - 1];
                      if (c.break) {
                        o.push([_e8, 1, _n4]);
                        break;
                      }
                      for (let _r3 = 1; _r3 < c.expandedStates.length + 1; _r3++) {
                        if (_r3 >= c.expandedStates.length) {
                          o.push([_e8, 1, _n4]);
                          break;
                        }
                        {
                          const _n5 = [_e8, 2, c.expandedStates[_r3]];
                          if (Yt(_n5, o, _a2, t)) {
                            o.push(_n5);
                            break;
                          }
                        }
                      }
                    } else o.push([_e8, 1, c.contents]);
                    break;
                  }
              }
              c.id && (zt[c.id] = o[o.length - 1][1]);
              break;
            case "fill":
              {
                const _r4 = n - u,
                  {
                    parts: _a3
                  } = c;
                if (0 === _a3.length) break;
                const [_i2, _s2] = _a3,
                  p = [_e8, 2, _i2],
                  d = [_e8, 1, _i2],
                  f = Yt(p, [], _r4, t, !0);
                if (1 === _a3.length) {
                  f ? o.push(p) : o.push(d);
                  break;
                }
                const h = [_e8, 2, _s2],
                  m = [_e8, 1, _s2];
                if (2 === _a3.length) {
                  f ? (o.push(h), o.push(p)) : (o.push(m), o.push(d));
                  break;
                }
                _a3.splice(0, 2);
                const g = [_e8, _l2, $t(_a3)],
                  D = _a3[0];
                Yt([_e8, 2, Wt([_i2, _s2, D])], [], _r4, t, !0) ? (o.push(g), o.push(h), o.push(p)) : f ? (o.push(g), o.push(m), o.push(p)) : (o.push(g), o.push(m), o.push(d));
                break;
              }
            case "if-break":
              {
                const _t7 = c.groupId ? zt[c.groupId] : _l2;
                1 === _t7 && c.breakContents && o.push([_e8, _l2, c.breakContents]), 2 === _t7 && c.flatContents && o.push([_e8, _l2, c.flatContents]);
                break;
              }
            case "line-suffix":
              s.push([_e8, _l2, c.contents]);
              break;
            case "line-suffix-boundary":
              s.length > 0 && o.push([_e8, _l2, {
                type: "line",
                hard: !0
              }]);
              break;
            case "line":
              switch (_l2) {
                case 2:
                  if (!c.hard) {
                    c.soft || (a.push(" "), u += 1);
                    break;
                  }
                  i = !0;
                case 1:
                  if (s.length) {
                    o.push([_e8, _l2, c]), o.push(...s.reverse()), s = [];
                    break;
                  }
                  c.literal ? _e8.root ? (a.push(r, _e8.root.value), u = _e8.root.length) : (a.push(r), u = 0) : (u -= Xt(a), a.push(r + _e8.value), u = _e8.length);
              }
          }
        }
        const l = a.indexOf(Ut.placeholder);
        if (-1 !== l) {
          const _e10 = a.indexOf(Ut.placeholder, l + 1),
            _t8 = a.slice(0, l).join(""),
            _n6 = a.slice(l + 1, _e10).join("");
          return {
            formatted: _t8 + _n6 + a.slice(_e10 + 1).join(""),
            cursorNodeStart: _t8.length,
            cursorNodeText: _n6
          };
        }
        return {
          formatted: a.join("")
        };
      }
    };
    const {
        literalline: Qt,
        concat: Zt
      } = oe,
      en = {};
    function tn(e, t, n, r) {
      const u = [e];
      for (; 0 !== u.length;) {
        const _e11 = u.pop();
        if (_e11 !== en) {
          if (n && u.push(_e11, en), !t || !1 !== t(_e11)) if ("concat" === _e11.type || "fill" === _e11.type) for (let _t9 = _e11.parts.length - 1; _t9 >= 0; --_t9) u.push(_e11.parts[_t9]);else if ("if-break" === _e11.type) _e11.flatContents && u.push(_e11.flatContents), _e11.breakContents && u.push(_e11.breakContents);else if ("group" === _e11.type && _e11.expandedStates) {
            if (r) for (let _t10 = _e11.expandedStates.length - 1; _t10 >= 0; --_t10) u.push(_e11.expandedStates[_t10]);else u.push(_e11.contents);
          } else _e11.contents && u.push(_e11.contents);
        } else n(u.pop());
      }
    }
    function nn(e, t) {
      if ("concat" === e.type || "fill" === e.type) {
        const n = e.parts.map(e => nn(e, t));
        return t(Object.assign({}, e, {
          parts: n
        }));
      }
      if ("if-break" === e.type) {
        const n = e.breakContents && nn(e.breakContents, t),
          r = e.flatContents && nn(e.flatContents, t);
        return t(Object.assign({}, e, {
          breakContents: n,
          flatContents: r
        }));
      }
      if (e.contents) {
        const n = nn(e.contents, t);
        return t(Object.assign({}, e, {
          contents: n
        }));
      }
      return t(e);
    }
    function rn(e, t, n) {
      let r = n,
        u = !1;
      return tn(e, function (e) {
        const n = t(e);
        if (void 0 !== n && (u = !0, r = n), u) return !1;
      }), r;
    }
    function un(e) {
      return "string" != typeof e && ("line" === e.type || void 0);
    }
    function on(e) {
      return !("group" !== e.type || !e.break) || !("line" !== e.type || !e.hard) || "break-parent" === e.type || void 0;
    }
    function an(e) {
      if (e.length > 0) {
        const t = e[e.length - 1];
        t.expandedStates || (t.break = !0);
      }
      return null;
    }
    function sn(e) {
      return "line" !== e.type || e.hard ? "if-break" === e.type ? e.flatContents || "" : e : e.soft ? "" : " ";
    }
    function ln(e) {
      const t = [],
        n = e.filter(Boolean);
      for (; 0 !== n.length;) {
        const _e12 = n.shift();
        _e12 && ("concat" !== _e12.type ? 0 === t.length || "string" != typeof t[t.length - 1] || "string" != typeof _e12 ? t.push(_e12) : t[t.length - 1] += _e12 : n.unshift(..._e12.parts));
      }
      return t;
    }
    function cn(e) {
      if ("concat" === e.type) {
        const t = [];
        for (let n = 0; n < e.parts.length; ++n) {
          const r = e.parts[n];
          if ("string" != typeof r && "concat" === r.type) t.push(...cn(r).parts);else {
            const _e13 = cn(r);
            "" !== _e13 && t.push(_e13);
          }
        }
        return Object.assign({}, e, {
          parts: t
        });
      }
      return "if-break" === e.type ? Object.assign({}, e, {
        breakContents: null != e.breakContents ? cn(e.breakContents) : null,
        flatContents: null != e.flatContents ? cn(e.flatContents) : null
      }) : "group" === e.type ? Object.assign({}, e, {
        contents: cn(e.contents),
        expandedStates: e.expandedStates ? e.expandedStates.map(cn) : e.expandedStates
      }) : e.contents ? Object.assign({}, e, {
        contents: cn(e.contents)
      }) : e;
    }
    function pn(e) {
      if ("string" == typeof e) return JSON.stringify(e);
      if ("line" === e.type) return e.literal ? "literalline" : e.hard ? "hardline" : e.soft ? "softline" : "line";
      if ("break-parent" === e.type) return "breakParent";
      if ("trim" === e.type) return "trim";
      if ("concat" === e.type) return "[" + e.parts.map(pn).join(", ") + "]";
      if ("indent" === e.type) return "indent(" + pn(e.contents) + ")";
      if ("align" === e.type) return e.n === -1 / 0 ? "dedentToRoot(" + pn(e.contents) + ")" : e.n < 0 ? "dedent(" + pn(e.contents) + ")" : "root" === e.n.type ? "markAsRoot(" + pn(e.contents) + ")" : "align(" + JSON.stringify(e.n) + ", " + pn(e.contents) + ")";
      if ("if-break" === e.type) return "ifBreak(" + pn(e.breakContents) + (e.flatContents ? ", " + pn(e.flatContents) : "") + ")";
      if ("group" === e.type) return e.expandedStates ? "conditionalGroup([" + e.expandedStates.map(pn).join(",") + "])" : (e.break ? "wrappedGroup" : "group") + "(" + pn(e.contents) + ")";
      if ("fill" === e.type) return "fill(" + e.parts.map(pn).join(", ") + ")";
      if ("line-suffix" === e.type) return "lineSuffix(" + pn(e.contents) + ")";
      if ("line-suffix-boundary" === e.type) return "lineSuffixBoundary";
      throw new Error("Unknown doc type " + e.type);
    }
    var dn = {
        builders: oe,
        printer: Kt,
        utils: {
          isEmpty: function (e) {
            return "string" == typeof e && 0 === e.length;
          },
          willBreak: function (e) {
            return rn(e, on, !1);
          },
          isLineNext: function (e) {
            return rn(e, un, !1);
          },
          traverseDoc: tn,
          findInDoc: rn,
          mapDoc: nn,
          propagateBreaks: function (e) {
            const t = new Set(),
              n = [];
            tn(e, function (e) {
              if ("break-parent" === e.type && an(n), "group" === e.type) {
                if (n.push(e), t.has(e)) return !1;
                t.add(e);
              }
            }, function (e) {
              if ("group" === e.type) {
                n.pop().break && an(n);
              }
            }, !0);
          },
          removeLines: function (e) {
            return nn(e, sn);
          },
          stripTrailingHardline: function e(t, n = !1) {
            if ("concat" === t.type && 0 !== t.parts.length) {
              const r = n ? function (e) {
                  let t,
                    {
                      parts: n
                    } = e;
                  for (let r = e.parts.length; r > 0 && !t; r--) t = n[r - 1];
                  return "group" === t.type && (n = t.contents.parts), n;
                }(t) : t.parts,
                u = r[r.length - 1];
              if ("concat" === u.type) return 2 === u.parts.length && u.parts[0].hard && "break-parent" === u.parts[1].type ? {
                type: "concat",
                parts: r.slice(0, -1)
              } : {
                type: "concat",
                parts: t.parts.slice(0, -1).concat(e(u))
              };
            }
            return t;
          },
          normalizeParts: ln,
          normalizeDoc: function (e) {
            return nn(e, e => e.parts ? Object.assign({}, e, {
              parts: ln(e.parts)
            }) : e);
          },
          replaceNewlinesWithLiterallines: function (e) {
            return nn(e, e => "string" == typeof e && e.includes("\n") ? Zt(e.split(/(\n)/g).map((e, t) => t % 2 == 0 ? e : Qt)) : e);
          }
        },
        debug: {
          printDocToDebug: e => pn(cn(e))
        }
      },
      fn = Object.freeze({
        __proto__: null,
        default: {}
      });
    const hn = /[/\\]/;
    function mn(e) {
      return e.split(hn).pop();
    }
    var gn = Object.freeze({
        __proto__: null,
        extname: function (e) {
          const t = mn(e),
            n = t.lastIndexOf(".");
          return -1 === n ? "" : t.slice(n);
        },
        basename: mn,
        isAbsolute: function () {
          return !0;
        }
      }),
      Dn = [],
      yn = [],
      En = "undefined" != typeof Uint8Array ? Uint8Array : Array,
      Cn = !1;
    function bn() {
      Cn = !0;
      for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t) Dn[t] = e[t], yn[e.charCodeAt(t)] = t;
      yn["-".charCodeAt(0)] = 62, yn["_".charCodeAt(0)] = 63;
    }
    function An(e, t, n) {
      for (var r, u, o = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], o.push(Dn[(u = r) >> 18 & 63] + Dn[u >> 12 & 63] + Dn[u >> 6 & 63] + Dn[63 & u]);
      return o.join("");
    }
    function vn(e) {
      var t;
      Cn || bn();
      for (var n = e.length, r = n % 3, u = "", o = [], a = 0, i = n - r; a < i; a += 16383) o.push(An(e, a, a + 16383 > i ? i : a + 16383));
      return 1 === r ? (t = e[n - 1], u += Dn[t >> 2], u += Dn[t << 4 & 63], u += "==") : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], u += Dn[t >> 10], u += Dn[t >> 4 & 63], u += Dn[t << 2 & 63], u += "="), o.push(u), o.join("");
    }
    function Fn(e, t, n, r, u) {
      var o,
        a,
        i = 8 * u - r - 1,
        s = (1 << i) - 1,
        l = s >> 1,
        c = -7,
        p = n ? u - 1 : 0,
        d = n ? -1 : 1,
        f = e[t + p];
      for (p += d, o = f & (1 << -c) - 1, f >>= -c, c += i; c > 0; o = 256 * o + e[t + p], p += d, c -= 8);
      for (a = o & (1 << -c) - 1, o >>= -c, c += r; c > 0; a = 256 * a + e[t + p], p += d, c -= 8);
      if (0 === o) o = 1 - l;else {
        if (o === s) return a ? NaN : 1 / 0 * (f ? -1 : 1);
        a += Math.pow(2, r), o -= l;
      }
      return (f ? -1 : 1) * a * Math.pow(2, o - r);
    }
    function xn(e, t, n, r, u, o) {
      var a,
        i,
        s,
        l = 8 * o - u - 1,
        c = (1 << l) - 1,
        p = c >> 1,
        d = 23 === u ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        f = r ? 0 : o - 1,
        h = r ? 1 : -1,
        m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, a = c) : (a = Math.floor(Math.log(t) / Math.LN2), t * (s = Math.pow(2, -a)) < 1 && (a--, s *= 2), (t += a + p >= 1 ? d / s : d * Math.pow(2, 1 - p)) * s >= 2 && (a++, s /= 2), a + p >= c ? (i = 0, a = c) : a + p >= 1 ? (i = (t * s - 1) * Math.pow(2, u), a += p) : (i = t * Math.pow(2, p - 1) * Math.pow(2, u), a = 0)); u >= 8; e[n + f] = 255 & i, f += h, i /= 256, u -= 8);
      for (a = a << u | i, l += u; l > 0; e[n + f] = 255 & a, f += h, a /= 256, l -= 8);
      e[n + f - h] |= 128 * m;
    }
    var Sn = {}.toString,
      wn = Array.isArray || function (e) {
        return "[object Array]" == Sn.call(e);
      };
    function Bn() {
      return kn.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function Tn(e, t) {
      if (Bn() < t) throw new RangeError("Invalid typed array length");
      return kn.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = kn.prototype : (null === e && (e = new kn(t)), e.length = t), e;
    }
    function kn(e, t, n) {
      if (!(kn.TYPED_ARRAY_SUPPORT || this instanceof kn)) return new kn(e, t, n);
      if ("number" == typeof e) {
        if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
        return Pn(this, e);
      }
      return Nn(this, e, t, n);
    }
    function Nn(e, t, n, r) {
      if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
        if (n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
        if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
        t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
        kn.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = kn.prototype : e = _n(e, t);
        return e;
      }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
        "string" == typeof n && "" !== n || (n = "utf8");
        if (!kn.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
        var r = 0 | Mn(t, n),
          u = (e = Tn(e, r)).write(t, n);
        u !== r && (e = e.slice(0, u));
        return e;
      }(e, t, n) : function (e, t) {
        if (jn(t)) {
          var n = 0 | In(t.length);
          return 0 === (e = Tn(e, n)).length || t.copy(e, 0, 0, n), e;
        }
        if (t) {
          if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? Tn(e, 0) : _n(e, t);
          if ("Buffer" === t.type && wn(t.data)) return _n(e, t.data);
        }
        var r;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(e, t);
    }
    function On(e) {
      if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
      if (e < 0) throw new RangeError('"size" argument must not be negative');
    }
    function Pn(e, t) {
      if (On(t), e = Tn(e, t < 0 ? 0 : 0 | In(t)), !kn.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
      return e;
    }
    function _n(e, t) {
      var n = t.length < 0 ? 0 : 0 | In(t.length);
      e = Tn(e, n);
      for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
      return e;
    }
    function In(e) {
      if (e >= Bn()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Bn().toString(16) + " bytes");
      return 0 | e;
    }
    function jn(e) {
      return !(null == e || !e._isBuffer);
    }
    function Mn(e, t) {
      if (jn(e)) return e.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
      "string" != typeof e && (e = "" + e);
      var n = e.length;
      if (0 === n) return 0;
      for (var r = !1;;) switch (t) {
        case "ascii":
        case "latin1":
        case "binary":
          return n;
        case "utf8":
        case "utf-8":
        case void 0:
          return lr(e).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return 2 * n;
        case "hex":
          return n >>> 1;
        case "base64":
          return cr(e).length;
        default:
          if (r) return lr(e).length;
          t = ("" + t).toLowerCase(), r = !0;
      }
    }
    function Ln(e, t, n) {
      var r = !1;
      if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
      if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
      if ((n >>>= 0) <= (t >>>= 0)) return "";
      for (e || (e = "utf8");;) switch (e) {
        case "hex":
          return Qn(this, t, n);
        case "utf8":
        case "utf-8":
          return Xn(this, t, n);
        case "ascii":
          return Yn(this, t, n);
        case "latin1":
        case "binary":
          return Kn(this, t, n);
        case "base64":
          return Hn(this, t, n);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Zn(this, t, n);
        default:
          if (r) throw new TypeError("Unknown encoding: " + e);
          e = (e + "").toLowerCase(), r = !0;
      }
    }
    function Rn(e, t, n) {
      var r = e[t];
      e[t] = e[n], e[n] = r;
    }
    function qn(e, t, n, r, u) {
      if (0 === e.length) return -1;
      if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = u ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
        if (u) return -1;
        n = e.length - 1;
      } else if (n < 0) {
        if (!u) return -1;
        n = 0;
      }
      if ("string" == typeof t && (t = kn.from(t, r)), jn(t)) return 0 === t.length ? -1 : Vn(e, t, n, r, u);
      if ("number" == typeof t) return t &= 255, kn.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? u ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : Vn(e, [t], n, r, u);
      throw new TypeError("val must be string, number or Buffer");
    }
    function Vn(e, t, n, r, u) {
      var o,
        a = 1,
        i = e.length,
        s = t.length;
      if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
        if (e.length < 2 || t.length < 2) return -1;
        a = 2, i /= 2, s /= 2, n /= 2;
      }
      function l(e, t) {
        return 1 === a ? e[t] : e.readUInt16BE(t * a);
      }
      if (u) {
        var c = -1;
        for (o = n; o < i; o++) if (l(e, o) === l(t, -1 === c ? 0 : o - c)) {
          if (-1 === c && (c = o), o - c + 1 === s) return c * a;
        } else -1 !== c && (o -= o - c), c = -1;
      } else for (n + s > i && (n = i - s), o = n; o >= 0; o--) {
        for (var p = !0, d = 0; d < s; d++) if (l(e, o + d) !== l(t, d)) {
          p = !1;
          break;
        }
        if (p) return o;
      }
      return -1;
    }
    function Wn(e, t, n, r) {
      n = Number(n) || 0;
      var u = e.length - n;
      r ? (r = Number(r)) > u && (r = u) : r = u;
      var o = t.length;
      if (o % 2 != 0) throw new TypeError("Invalid hex string");
      r > o / 2 && (r = o / 2);
      for (var a = 0; a < r; ++a) {
        var i = parseInt(t.substr(2 * a, 2), 16);
        if (isNaN(i)) return a;
        e[n + a] = i;
      }
      return a;
    }
    function $n(e, t, n, r) {
      return pr(lr(t, e.length - n), e, n, r);
    }
    function Un(e, t, n, r) {
      return pr(function (e) {
        for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
        return t;
      }(t), e, n, r);
    }
    function zn(e, t, n, r) {
      return Un(e, t, n, r);
    }
    function Jn(e, t, n, r) {
      return pr(cr(t), e, n, r);
    }
    function Gn(e, t, n, r) {
      return pr(function (e, t) {
        for (var n, r, u, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) r = (n = e.charCodeAt(a)) >> 8, u = n % 256, o.push(u), o.push(r);
        return o;
      }(t, e.length - n), e, n, r);
    }
    function Hn(e, t, n) {
      return 0 === t && n === e.length ? vn(e) : vn(e.slice(t, n));
    }
    function Xn(e, t, n) {
      n = Math.min(e.length, n);
      for (var r = [], u = t; u < n;) {
        var o,
          a,
          i,
          s,
          l = e[u],
          c = null,
          p = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
        if (u + p <= n) switch (p) {
          case 1:
            l < 128 && (c = l);
            break;
          case 2:
            128 == (192 & (o = e[u + 1])) && (s = (31 & l) << 6 | 63 & o) > 127 && (c = s);
            break;
          case 3:
            o = e[u + 1], a = e[u + 2], 128 == (192 & o) && 128 == (192 & a) && (s = (15 & l) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (s < 55296 || s > 57343) && (c = s);
            break;
          case 4:
            o = e[u + 1], a = e[u + 2], i = e[u + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & i) && (s = (15 & l) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & i) > 65535 && s < 1114112 && (c = s);
        }
        null === c ? (c = 65533, p = 1) : c > 65535 && (c -= 65536, r.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r.push(c), u += p;
      }
      return function (e) {
        var t = e.length;
        if (t <= 4096) return String.fromCharCode.apply(String, e);
        var n = "",
          r = 0;
        for (; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += 4096));
        return n;
      }(r);
    }
    kn.TYPED_ARRAY_SUPPORT = void 0 === me.TYPED_ARRAY_SUPPORT || me.TYPED_ARRAY_SUPPORT, kn.poolSize = 8192, kn._augment = function (e) {
      return e.__proto__ = kn.prototype, e;
    }, kn.from = function (e, t, n) {
      return Nn(null, e, t, n);
    }, kn.TYPED_ARRAY_SUPPORT && (kn.prototype.__proto__ = Uint8Array.prototype, kn.__proto__ = Uint8Array), kn.alloc = function (e, t, n) {
      return function (e, t, n, r) {
        return On(t), t <= 0 ? Tn(e, t) : void 0 !== n ? "string" == typeof r ? Tn(e, t).fill(n, r) : Tn(e, t).fill(n) : Tn(e, t);
      }(null, e, t, n);
    }, kn.allocUnsafe = function (e) {
      return Pn(null, e);
    }, kn.allocUnsafeSlow = function (e) {
      return Pn(null, e);
    }, kn.isBuffer = function (e) {
      return null != e && (!!e._isBuffer || dr(e) || function (e) {
        return "function" == typeof e.readFloatLE && "function" == typeof e.slice && dr(e.slice(0, 0));
      }(e));
    }, kn.compare = function (e, t) {
      if (!jn(e) || !jn(t)) throw new TypeError("Arguments must be Buffers");
      if (e === t) return 0;
      for (var n = e.length, r = t.length, u = 0, o = Math.min(n, r); u < o; ++u) if (e[u] !== t[u]) {
        n = e[u], r = t[u];
        break;
      }
      return n < r ? -1 : r < n ? 1 : 0;
    }, kn.isEncoding = function (e) {
      switch (String(e).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, kn.concat = function (e, t) {
      if (!wn(e)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === e.length) return kn.alloc(0);
      var n;
      if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
      var r = kn.allocUnsafe(t),
        u = 0;
      for (n = 0; n < e.length; ++n) {
        var o = e[n];
        if (!jn(o)) throw new TypeError('"list" argument must be an Array of Buffers');
        o.copy(r, u), u += o.length;
      }
      return r;
    }, kn.byteLength = Mn, kn.prototype._isBuffer = !0, kn.prototype.swap16 = function () {
      var e = this.length;
      if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var t = 0; t < e; t += 2) Rn(this, t, t + 1);
      return this;
    }, kn.prototype.swap32 = function () {
      var e = this.length;
      if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var t = 0; t < e; t += 4) Rn(this, t, t + 3), Rn(this, t + 1, t + 2);
      return this;
    }, kn.prototype.swap64 = function () {
      var e = this.length;
      if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var t = 0; t < e; t += 8) Rn(this, t, t + 7), Rn(this, t + 1, t + 6), Rn(this, t + 2, t + 5), Rn(this, t + 3, t + 4);
      return this;
    }, kn.prototype.toString = function () {
      var e = 0 | this.length;
      return 0 === e ? "" : 0 === arguments.length ? Xn(this, 0, e) : Ln.apply(this, arguments);
    }, kn.prototype.equals = function (e) {
      if (!jn(e)) throw new TypeError("Argument must be a Buffer");
      return this === e || 0 === kn.compare(this, e);
    }, kn.prototype.inspect = function () {
      var e = "";
      return this.length > 0 && (e = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (e += " ... ")), "<Buffer " + e + ">";
    }, kn.prototype.compare = function (e, t, n, r, u) {
      if (!jn(e)) throw new TypeError("Argument must be a Buffer");
      if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === u && (u = this.length), t < 0 || n > e.length || r < 0 || u > this.length) throw new RangeError("out of range index");
      if (r >= u && t >= n) return 0;
      if (r >= u) return -1;
      if (t >= n) return 1;
      if (this === e) return 0;
      for (var o = (u >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), i = Math.min(o, a), s = this.slice(r, u), l = e.slice(t, n), c = 0; c < i; ++c) if (s[c] !== l[c]) {
        o = s[c], a = l[c];
        break;
      }
      return o < a ? -1 : a < o ? 1 : 0;
    }, kn.prototype.includes = function (e, t, n) {
      return -1 !== this.indexOf(e, t, n);
    }, kn.prototype.indexOf = function (e, t, n) {
      return qn(this, e, t, n, !0);
    }, kn.prototype.lastIndexOf = function (e, t, n) {
      return qn(this, e, t, n, !1);
    }, kn.prototype.write = function (e, t, n, r) {
      if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
      }
      var u = this.length - t;
      if ((void 0 === n || n > u) && (n = u), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      r || (r = "utf8");
      for (var o = !1;;) switch (r) {
        case "hex":
          return Wn(this, e, t, n);
        case "utf8":
        case "utf-8":
          return $n(this, e, t, n);
        case "ascii":
          return Un(this, e, t, n);
        case "latin1":
        case "binary":
          return zn(this, e, t, n);
        case "base64":
          return Jn(this, e, t, n);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Gn(this, e, t, n);
        default:
          if (o) throw new TypeError("Unknown encoding: " + r);
          r = ("" + r).toLowerCase(), o = !0;
      }
    }, kn.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function Yn(e, t, n) {
      var r = "";
      n = Math.min(e.length, n);
      for (var u = t; u < n; ++u) r += String.fromCharCode(127 & e[u]);
      return r;
    }
    function Kn(e, t, n) {
      var r = "";
      n = Math.min(e.length, n);
      for (var u = t; u < n; ++u) r += String.fromCharCode(e[u]);
      return r;
    }
    function Qn(e, t, n) {
      var r = e.length;
      (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
      for (var u = "", o = t; o < n; ++o) u += sr(e[o]);
      return u;
    }
    function Zn(e, t, n) {
      for (var r = e.slice(t, n), u = "", o = 0; o < r.length; o += 2) u += String.fromCharCode(r[o] + 256 * r[o + 1]);
      return u;
    }
    function er(e, t, n) {
      if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
      if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
    }
    function tr(e, t, n, r, u, o) {
      if (!jn(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (t > u || t < o) throw new RangeError('"value" argument is out of bounds');
      if (n + r > e.length) throw new RangeError("Index out of range");
    }
    function nr(e, t, n, r) {
      t < 0 && (t = 65535 + t + 1);
      for (var u = 0, o = Math.min(e.length - n, 2); u < o; ++u) e[n + u] = (t & 255 << 8 * (r ? u : 1 - u)) >>> 8 * (r ? u : 1 - u);
    }
    function rr(e, t, n, r) {
      t < 0 && (t = 4294967295 + t + 1);
      for (var u = 0, o = Math.min(e.length - n, 4); u < o; ++u) e[n + u] = t >>> 8 * (r ? u : 3 - u) & 255;
    }
    function ur(e, t, n, r, u, o) {
      if (n + r > e.length) throw new RangeError("Index out of range");
      if (n < 0) throw new RangeError("Index out of range");
    }
    function or(e, t, n, r, u) {
      return u || ur(e, 0, n, 4), xn(e, t, n, r, 23, 4), n + 4;
    }
    function ar(e, t, n, r, u) {
      return u || ur(e, 0, n, 8), xn(e, t, n, r, 52, 8), n + 8;
    }
    kn.prototype.slice = function (e, t) {
      var n,
        r = this.length;
      if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), kn.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = kn.prototype;else {
        var u = t - e;
        n = new kn(u, void 0);
        for (var o = 0; o < u; ++o) n[o] = this[o + e];
      }
      return n;
    }, kn.prototype.readUIntLE = function (e, t, n) {
      e |= 0, t |= 0, n || er(e, t, this.length);
      for (var r = this[e], u = 1, o = 0; ++o < t && (u *= 256);) r += this[e + o] * u;
      return r;
    }, kn.prototype.readUIntBE = function (e, t, n) {
      e |= 0, t |= 0, n || er(e, t, this.length);
      for (var r = this[e + --t], u = 1; t > 0 && (u *= 256);) r += this[e + --t] * u;
      return r;
    }, kn.prototype.readUInt8 = function (e, t) {
      return t || er(e, 1, this.length), this[e];
    }, kn.prototype.readUInt16LE = function (e, t) {
      return t || er(e, 2, this.length), this[e] | this[e + 1] << 8;
    }, kn.prototype.readUInt16BE = function (e, t) {
      return t || er(e, 2, this.length), this[e] << 8 | this[e + 1];
    }, kn.prototype.readUInt32LE = function (e, t) {
      return t || er(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
    }, kn.prototype.readUInt32BE = function (e, t) {
      return t || er(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
    }, kn.prototype.readIntLE = function (e, t, n) {
      e |= 0, t |= 0, n || er(e, t, this.length);
      for (var r = this[e], u = 1, o = 0; ++o < t && (u *= 256);) r += this[e + o] * u;
      return r >= (u *= 128) && (r -= Math.pow(2, 8 * t)), r;
    }, kn.prototype.readIntBE = function (e, t, n) {
      e |= 0, t |= 0, n || er(e, t, this.length);
      for (var r = t, u = 1, o = this[e + --r]; r > 0 && (u *= 256);) o += this[e + --r] * u;
      return o >= (u *= 128) && (o -= Math.pow(2, 8 * t)), o;
    }, kn.prototype.readInt8 = function (e, t) {
      return t || er(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
    }, kn.prototype.readInt16LE = function (e, t) {
      t || er(e, 2, this.length);
      var n = this[e] | this[e + 1] << 8;
      return 32768 & n ? 4294901760 | n : n;
    }, kn.prototype.readInt16BE = function (e, t) {
      t || er(e, 2, this.length);
      var n = this[e + 1] | this[e] << 8;
      return 32768 & n ? 4294901760 | n : n;
    }, kn.prototype.readInt32LE = function (e, t) {
      return t || er(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
    }, kn.prototype.readInt32BE = function (e, t) {
      return t || er(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
    }, kn.prototype.readFloatLE = function (e, t) {
      return t || er(e, 4, this.length), Fn(this, e, !0, 23, 4);
    }, kn.prototype.readFloatBE = function (e, t) {
      return t || er(e, 4, this.length), Fn(this, e, !1, 23, 4);
    }, kn.prototype.readDoubleLE = function (e, t) {
      return t || er(e, 8, this.length), Fn(this, e, !0, 52, 8);
    }, kn.prototype.readDoubleBE = function (e, t) {
      return t || er(e, 8, this.length), Fn(this, e, !1, 52, 8);
    }, kn.prototype.writeUIntLE = function (e, t, n, r) {
      (e = +e, t |= 0, n |= 0, r) || tr(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
      var u = 1,
        o = 0;
      for (this[t] = 255 & e; ++o < n && (u *= 256);) this[t + o] = e / u & 255;
      return t + n;
    }, kn.prototype.writeUIntBE = function (e, t, n, r) {
      (e = +e, t |= 0, n |= 0, r) || tr(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
      var u = n - 1,
        o = 1;
      for (this[t + u] = 255 & e; --u >= 0 && (o *= 256);) this[t + u] = e / o & 255;
      return t + n;
    }, kn.prototype.writeUInt8 = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 1, 255, 0), kn.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
    }, kn.prototype.writeUInt16LE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 2, 65535, 0), kn.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : nr(this, e, t, !0), t + 2;
    }, kn.prototype.writeUInt16BE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 2, 65535, 0), kn.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : nr(this, e, t, !1), t + 2;
    }, kn.prototype.writeUInt32LE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 4, 4294967295, 0), kn.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : rr(this, e, t, !0), t + 4;
    }, kn.prototype.writeUInt32BE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 4, 4294967295, 0), kn.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : rr(this, e, t, !1), t + 4;
    }, kn.prototype.writeIntLE = function (e, t, n, r) {
      if (e = +e, t |= 0, !r) {
        var u = Math.pow(2, 8 * n - 1);
        tr(this, e, t, n, u - 1, -u);
      }
      var o = 0,
        a = 1,
        i = 0;
      for (this[t] = 255 & e; ++o < n && (a *= 256);) e < 0 && 0 === i && 0 !== this[t + o - 1] && (i = 1), this[t + o] = (e / a >> 0) - i & 255;
      return t + n;
    }, kn.prototype.writeIntBE = function (e, t, n, r) {
      if (e = +e, t |= 0, !r) {
        var u = Math.pow(2, 8 * n - 1);
        tr(this, e, t, n, u - 1, -u);
      }
      var o = n - 1,
        a = 1,
        i = 0;
      for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) e < 0 && 0 === i && 0 !== this[t + o + 1] && (i = 1), this[t + o] = (e / a >> 0) - i & 255;
      return t + n;
    }, kn.prototype.writeInt8 = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 1, 127, -128), kn.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
    }, kn.prototype.writeInt16LE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 2, 32767, -32768), kn.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : nr(this, e, t, !0), t + 2;
    }, kn.prototype.writeInt16BE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 2, 32767, -32768), kn.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : nr(this, e, t, !1), t + 2;
    }, kn.prototype.writeInt32LE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 4, 2147483647, -2147483648), kn.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : rr(this, e, t, !0), t + 4;
    }, kn.prototype.writeInt32BE = function (e, t, n) {
      return e = +e, t |= 0, n || tr(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), kn.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : rr(this, e, t, !1), t + 4;
    }, kn.prototype.writeFloatLE = function (e, t, n) {
      return or(this, e, t, !0, n);
    }, kn.prototype.writeFloatBE = function (e, t, n) {
      return or(this, e, t, !1, n);
    }, kn.prototype.writeDoubleLE = function (e, t, n) {
      return ar(this, e, t, !0, n);
    }, kn.prototype.writeDoubleBE = function (e, t, n) {
      return ar(this, e, t, !1, n);
    }, kn.prototype.copy = function (e, t, n, r) {
      if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
      if (0 === e.length || 0 === this.length) return 0;
      if (t < 0) throw new RangeError("targetStart out of bounds");
      if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
      if (r < 0) throw new RangeError("sourceEnd out of bounds");
      r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
      var u,
        o = r - n;
      if (this === e && n < t && t < r) for (u = o - 1; u >= 0; --u) e[u + t] = this[u + n];else if (o < 1e3 || !kn.TYPED_ARRAY_SUPPORT) for (u = 0; u < o; ++u) e[u + t] = this[u + n];else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
      return o;
    }, kn.prototype.fill = function (e, t, n, r) {
      if ("string" == typeof e) {
        if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
          var u = e.charCodeAt(0);
          u < 256 && (e = u);
        }
        if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
        if ("string" == typeof r && !kn.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
      } else "number" == typeof e && (e &= 255);
      if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
      if (n <= t) return this;
      var o;
      if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) this[o] = e;else {
        var a = jn(e) ? e : lr(new kn(e, r).toString()),
          i = a.length;
        for (o = 0; o < n - t; ++o) this[o + t] = a[o % i];
      }
      return this;
    };
    var ir = /[^+\/0-9A-Za-z-_]/g;
    function sr(e) {
      return e < 16 ? "0" + e.toString(16) : e.toString(16);
    }
    function lr(e, t) {
      var n;
      t = t || 1 / 0;
      for (var r = e.length, u = null, o = [], a = 0; a < r; ++a) {
        if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
          if (!u) {
            if (n > 56319) {
              (t -= 3) > -1 && o.push(239, 191, 189);
              continue;
            }
            if (a + 1 === r) {
              (t -= 3) > -1 && o.push(239, 191, 189);
              continue;
            }
            u = n;
            continue;
          }
          if (n < 56320) {
            (t -= 3) > -1 && o.push(239, 191, 189), u = n;
            continue;
          }
          n = 65536 + (u - 55296 << 10 | n - 56320);
        } else u && (t -= 3) > -1 && o.push(239, 191, 189);
        if (u = null, n < 128) {
          if ((t -= 1) < 0) break;
          o.push(n);
        } else if (n < 2048) {
          if ((t -= 2) < 0) break;
          o.push(n >> 6 | 192, 63 & n | 128);
        } else if (n < 65536) {
          if ((t -= 3) < 0) break;
          o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
        } else {
          if (!(n < 1114112)) throw new Error("Invalid code point");
          if ((t -= 4) < 0) break;
          o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
        }
      }
      return o;
    }
    function cr(e) {
      return function (e) {
        var t, n, r, u, o, a;
        Cn || bn();
        var i = e.length;
        if (i % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        o = "=" === e[i - 2] ? 2 : "=" === e[i - 1] ? 1 : 0, a = new En(3 * i / 4 - o), r = o > 0 ? i - 4 : i;
        var s = 0;
        for (t = 0, n = 0; t < r; t += 4, n += 3) u = yn[e.charCodeAt(t)] << 18 | yn[e.charCodeAt(t + 1)] << 12 | yn[e.charCodeAt(t + 2)] << 6 | yn[e.charCodeAt(t + 3)], a[s++] = u >> 16 & 255, a[s++] = u >> 8 & 255, a[s++] = 255 & u;
        return 2 === o ? (u = yn[e.charCodeAt(t)] << 2 | yn[e.charCodeAt(t + 1)] >> 4, a[s++] = 255 & u) : 1 === o && (u = yn[e.charCodeAt(t)] << 10 | yn[e.charCodeAt(t + 1)] << 4 | yn[e.charCodeAt(t + 2)] >> 2, a[s++] = u >> 8 & 255, a[s++] = 255 & u), a;
      }(function (e) {
        if ((e = function (e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        }(e).replace(ir, "")).length < 2) return "";
        for (; e.length % 4 != 0;) e += "=";
        return e;
      }(e));
    }
    function pr(e, t, n, r) {
      for (var u = 0; u < r && !(u + n >= t.length || u >= e.length); ++u) t[u + n] = e[u];
      return u;
    }
    function dr(e) {
      return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
    }
    var fr = Ue(fn);
    var hr = class {
      constructor(e, t) {
        (t = t || {}).readChunk || (t.readChunk = 1024), t.newLineCharacter ? t.newLineCharacter = t.newLineCharacter.charCodeAt(0) : t.newLineCharacter = 10, this.fd = "number" == typeof e ? e : fr.openSync(e, "r"), this.options = t, this.newLineCharacter = t.newLineCharacter, this.reset();
      }
      _searchInBuffer(e, t) {
        let n = -1;
        for (let r = 0; r <= e.length; r++) {
          if (e[r] === t) {
            n = r;
            break;
          }
        }
        return n;
      }
      reset() {
        this.eofReached = !1, this.linesCache = [], this.fdPosition = 0;
      }
      close() {
        fr.closeSync(this.fd), this.fd = null;
      }
      _extractLines(e) {
        let t;
        const n = [];
        let r = 0,
          u = 0;
        for (;;) {
          let _o2 = e[r++];
          if (_o2 === this.newLineCharacter) t = e.slice(u, r), n.push(t), u = r;else if (!_o2) break;
        }
        let o = e.slice(u, r);
        return o.length && n.push(o), n;
      }
      _readChunk(e) {
        let t,
          n = 0;
        const r = [];
        do {
          const _e14 = new kn(this.options.readChunk);
          t = fr.readSync(this.fd, _e14, 0, this.options.readChunk, this.fdPosition), n += t, this.fdPosition = this.fdPosition + t, r.push(_e14);
        } while (t && -1 === this._searchInBuffer(r[r.length - 1], this.options.newLineCharacter));
        let u = kn.concat(r);
        return t < this.options.readChunk && (this.eofReached = !0, u = u.slice(0, n)), n && (this.linesCache = this._extractLines(u), e && (this.linesCache[0] = kn.concat([e, this.linesCache[0]]))), n;
      }
      next() {
        if (!this.fd) return !1;
        let e,
          t = !1;
        if (this.eofReached && 0 === this.linesCache.length) return t;
        if (this.linesCache.length || (e = this._readChunk()), this.linesCache.length) {
          t = this.linesCache.shift();
          10 !== t[t.length - 1] && (e = this._readChunk(t), e && (t = this.linesCache.shift()));
        }
        return this.eofReached && 0 === this.linesCache.length && this.close(), t && t[t.length - 1] === this.newLineCharacter && (t = t.slice(0, t.length - 1)), t;
      }
    };
    var mr = function (e) {
      for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
        var u = e[t];
        r[u[0]] = u[1];
      }
      return r;
    };
    class gr extends Error {}
    class Dr extends Error {}
    class yr extends Error {}
    var Er = {
        ConfigError: gr,
        DebugError: Dr,
        UndefinedParserError: yr
      },
      Cr = function (e, t) {
        return (Cr = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      };
    var br = function () {
      return (br = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var u in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
        return e;
      }).apply(this, arguments);
    };
    function Ar(e) {
      var t = "function" == typeof Symbol && Symbol.iterator,
        n = t && e[t],
        r = 0;
      if (n) return n.call(e);
      if (e && "number" == typeof e.length) return {
        next: function () {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
      throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }
    function vr(e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
        u,
        o = n.call(e),
        a = [];
      try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
      } catch (e) {
        u = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = o.return) && n.call(o);
        } finally {
          if (u) throw u.error;
        }
      }
      return a;
    }
    function Fr(e) {
      return this instanceof Fr ? (this.v = e, this) : new Fr(e);
    }
    var xr = Object.freeze({
        __proto__: null,
        __extends: function (e, t) {
          function n() {
            this.constructor = e;
          }
          Cr(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        },
        get __assign() {
          return br;
        },
        __rest: function (e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var u = 0;
            for (r = Object.getOwnPropertySymbols(e); u < r.length; u++) t.indexOf(r[u]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[u]) && (n[r[u]] = e[r[u]]);
          }
          return n;
        },
        __decorate: function (e, t, n, r) {
          var u,
            o = arguments.length,
            a = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var i = e.length - 1; i >= 0; i--) (u = e[i]) && (a = (o < 3 ? u(a) : o > 3 ? u(t, n, a) : u(t, n)) || a);
          return o > 3 && a && Object.defineProperty(t, n, a), a;
        },
        __param: function (e, t) {
          return function (n, r) {
            t(n, r, e);
          };
        },
        __metadata: function (e, t) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
        },
        __awaiter: function (e, t, n, r) {
          return new (n || (n = Promise))(function (u, o) {
            function a(e) {
              try {
                s(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function i(e) {
              try {
                s(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              var t;
              e.done ? u(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, i);
            }
            s((r = r.apply(e, t || [])).next());
          });
        },
        __generator: function (e, t) {
          var n,
            r,
            u,
            o,
            a = {
              label: 0,
              sent: function () {
                if (1 & u[0]) throw u[1];
                return u[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: i(0),
            throw: i(1),
            return: i(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function i(o) {
            return function (i) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (u = 2 & o[0] ? r.return : o[0] ? r.throw || ((u = r.return) && u.call(r), 0) : r.next) && !(u = u.call(r, o[1])).done) return u;
                  switch (r = 0, u && (o = [2 & o[0], u.value]), o[0]) {
                    case 0:
                    case 1:
                      u = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(u = a.trys, (u = u.length > 0 && u[u.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!u || o[1] > u[0] && o[1] < u[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < u[1]) {
                        a.label = u[1], u = o;
                        break;
                      }
                      if (u && a.label < u[2]) {
                        a.label = u[2], a.ops.push(o);
                        break;
                      }
                      u[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = u = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, i]);
            };
          }
        },
        __createBinding: function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        },
        __exportStar: function (e, t) {
          for (var n in e) "default" === n || t.hasOwnProperty(n) || (t[n] = e[n]);
        },
        __values: Ar,
        __read: vr,
        __spread: function () {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(vr(arguments[t]));
          return e;
        },
        __spreadArrays: function () {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
          var r = Array(e),
            u = 0;
          for (t = 0; t < n; t++) for (var o = arguments[t], a = 0, i = o.length; a < i; a++, u++) r[u] = o[a];
          return r;
        },
        __await: Fr,
        __asyncGenerator: function (e, t, n) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var r,
            u = n.apply(e, t || []),
            o = [];
          return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
            return this;
          }, r;
          function a(e) {
            u[e] && (r[e] = function (t) {
              return new Promise(function (n, r) {
                o.push([e, t, n, r]) > 1 || i(e, t);
              });
            });
          }
          function i(e, t) {
            try {
              (n = u[e](t)).value instanceof Fr ? Promise.resolve(n.value.v).then(s, l) : c(o[0][2], n);
            } catch (e) {
              c(o[0][3], e);
            }
            var n;
          }
          function s(e) {
            i("next", e);
          }
          function l(e) {
            i("throw", e);
          }
          function c(e, t) {
            e(t), o.shift(), o.length && i(o[0][0], o[0][1]);
          }
        },
        __asyncDelegator: function (e) {
          var t, n;
          return t = {}, r("next"), r("throw", function (e) {
            throw e;
          }), r("return"), t[Symbol.iterator] = function () {
            return this;
          }, t;
          function r(r, u) {
            t[r] = e[r] ? function (t) {
              return (n = !n) ? {
                value: Fr(e[r](t)),
                done: "return" === r
              } : u ? u(t) : t;
            } : u;
          }
        },
        __asyncValues: function (e) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var t,
            n = e[Symbol.asyncIterator];
          return n ? n.call(e) : (e = Ar(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
            return this;
          }, t);
          function r(n) {
            t[n] = e[n] && function (t) {
              return new Promise(function (r, u) {
                (function (e, t, n, r) {
                  Promise.resolve(r).then(function (t) {
                    e({
                      value: t,
                      done: n
                    });
                  }, t);
                })(r, u, (t = e[n](t)).done, t.value);
              });
            };
          }
        },
        __makeTemplateObject: function (e, t) {
          return Object.defineProperty ? Object.defineProperty(e, "raw", {
            value: t
          }) : e.raw = t, e;
        },
        __importStar: function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t.default = e, t;
        },
        __importDefault: function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        },
        __classPrivateFieldGet: function (e, t) {
          if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
          return t.get(e);
        },
        __classPrivateFieldSet: function (e, t, n) {
          if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
          return t.set(e, n), n;
        }
      }),
      Sr = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.apiDescriptor = {
          key: e => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e) ? e : JSON.stringify(e),
          value(e) {
            if (null === e || "object" != typeof e) return JSON.stringify(e);
            if (Array.isArray(e)) return "[".concat(e.map(e => t.apiDescriptor.value(e)).join(", "), "]");
            const n = Object.keys(e);
            return 0 === n.length ? "{}" : "{ ".concat(n.map(n => "".concat(t.apiDescriptor.key(n), ": ").concat(t.apiDescriptor.value(e[n]))).join(", "), " }");
          },
          pair: ({
            key: e,
            value: n
          }) => t.apiDescriptor.value({
            [e]: n
          })
        };
      }),
      wr = Ue(xr),
      Br = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(Sr, t);
      }),
      Tr = /[|\\{}()[\]^$+*?.]/g,
      kr = function (e) {
        if ("string" != typeof e) throw new TypeError("Expected a string");
        return e.replace(Tr, "\\$&");
      },
      Nr = {
        aliceblue: [240, 248, 255],
        antiquewhite: [250, 235, 215],
        aqua: [0, 255, 255],
        aquamarine: [127, 255, 212],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        bisque: [255, 228, 196],
        black: [0, 0, 0],
        blanchedalmond: [255, 235, 205],
        blue: [0, 0, 255],
        blueviolet: [138, 43, 226],
        brown: [165, 42, 42],
        burlywood: [222, 184, 135],
        cadetblue: [95, 158, 160],
        chartreuse: [127, 255, 0],
        chocolate: [210, 105, 30],
        coral: [255, 127, 80],
        cornflowerblue: [100, 149, 237],
        cornsilk: [255, 248, 220],
        crimson: [220, 20, 60],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgoldenrod: [184, 134, 11],
        darkgray: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkgrey: [169, 169, 169],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkseagreen: [143, 188, 143],
        darkslateblue: [72, 61, 139],
        darkslategray: [47, 79, 79],
        darkslategrey: [47, 79, 79],
        darkturquoise: [0, 206, 209],
        darkviolet: [148, 0, 211],
        deeppink: [255, 20, 147],
        deepskyblue: [0, 191, 255],
        dimgray: [105, 105, 105],
        dimgrey: [105, 105, 105],
        dodgerblue: [30, 144, 255],
        firebrick: [178, 34, 34],
        floralwhite: [255, 250, 240],
        forestgreen: [34, 139, 34],
        fuchsia: [255, 0, 255],
        gainsboro: [220, 220, 220],
        ghostwhite: [248, 248, 255],
        gold: [255, 215, 0],
        goldenrod: [218, 165, 32],
        gray: [128, 128, 128],
        green: [0, 128, 0],
        greenyellow: [173, 255, 47],
        grey: [128, 128, 128],
        honeydew: [240, 255, 240],
        hotpink: [255, 105, 180],
        indianred: [205, 92, 92],
        indigo: [75, 0, 130],
        ivory: [255, 255, 240],
        khaki: [240, 230, 140],
        lavender: [230, 230, 250],
        lavenderblush: [255, 240, 245],
        lawngreen: [124, 252, 0],
        lemonchiffon: [255, 250, 205],
        lightblue: [173, 216, 230],
        lightcoral: [240, 128, 128],
        lightcyan: [224, 255, 255],
        lightgoldenrodyellow: [250, 250, 210],
        lightgray: [211, 211, 211],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightsalmon: [255, 160, 122],
        lightseagreen: [32, 178, 170],
        lightskyblue: [135, 206, 250],
        lightslategray: [119, 136, 153],
        lightslategrey: [119, 136, 153],
        lightsteelblue: [176, 196, 222],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        limegreen: [50, 205, 50],
        linen: [250, 240, 230],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        mediumaquamarine: [102, 205, 170],
        mediumblue: [0, 0, 205],
        mediumorchid: [186, 85, 211],
        mediumpurple: [147, 112, 219],
        mediumseagreen: [60, 179, 113],
        mediumslateblue: [123, 104, 238],
        mediumspringgreen: [0, 250, 154],
        mediumturquoise: [72, 209, 204],
        mediumvioletred: [199, 21, 133],
        midnightblue: [25, 25, 112],
        mintcream: [245, 255, 250],
        mistyrose: [255, 228, 225],
        moccasin: [255, 228, 181],
        navajowhite: [255, 222, 173],
        navy: [0, 0, 128],
        oldlace: [253, 245, 230],
        olive: [128, 128, 0],
        olivedrab: [107, 142, 35],
        orange: [255, 165, 0],
        orangered: [255, 69, 0],
        orchid: [218, 112, 214],
        palegoldenrod: [238, 232, 170],
        palegreen: [152, 251, 152],
        paleturquoise: [175, 238, 238],
        palevioletred: [219, 112, 147],
        papayawhip: [255, 239, 213],
        peachpuff: [255, 218, 185],
        peru: [205, 133, 63],
        pink: [255, 192, 203],
        plum: [221, 160, 221],
        powderblue: [176, 224, 230],
        purple: [128, 0, 128],
        rebeccapurple: [102, 51, 153],
        red: [255, 0, 0],
        rosybrown: [188, 143, 143],
        royalblue: [65, 105, 225],
        saddlebrown: [139, 69, 19],
        salmon: [250, 128, 114],
        sandybrown: [244, 164, 96],
        seagreen: [46, 139, 87],
        seashell: [255, 245, 238],
        sienna: [160, 82, 45],
        silver: [192, 192, 192],
        skyblue: [135, 206, 235],
        slateblue: [106, 90, 205],
        slategray: [112, 128, 144],
        slategrey: [112, 128, 144],
        snow: [255, 250, 250],
        springgreen: [0, 255, 127],
        steelblue: [70, 130, 180],
        tan: [210, 180, 140],
        teal: [0, 128, 128],
        thistle: [216, 191, 216],
        tomato: [255, 99, 71],
        turquoise: [64, 224, 208],
        violet: [238, 130, 238],
        wheat: [245, 222, 179],
        white: [255, 255, 255],
        whitesmoke: [245, 245, 245],
        yellow: [255, 255, 0],
        yellowgreen: [154, 205, 50]
      },
      Or = $e(function (e) {
        var t = {};
        for (var n in Nr) Nr.hasOwnProperty(n) && (t[Nr[n]] = n);
        var r = e.exports = {
          rgb: {
            channels: 3,
            labels: "rgb"
          },
          hsl: {
            channels: 3,
            labels: "hsl"
          },
          hsv: {
            channels: 3,
            labels: "hsv"
          },
          hwb: {
            channels: 3,
            labels: "hwb"
          },
          cmyk: {
            channels: 4,
            labels: "cmyk"
          },
          xyz: {
            channels: 3,
            labels: "xyz"
          },
          lab: {
            channels: 3,
            labels: "lab"
          },
          lch: {
            channels: 3,
            labels: "lch"
          },
          hex: {
            channels: 1,
            labels: ["hex"]
          },
          keyword: {
            channels: 1,
            labels: ["keyword"]
          },
          ansi16: {
            channels: 1,
            labels: ["ansi16"]
          },
          ansi256: {
            channels: 1,
            labels: ["ansi256"]
          },
          hcg: {
            channels: 3,
            labels: ["h", "c", "g"]
          },
          apple: {
            channels: 3,
            labels: ["r16", "g16", "b16"]
          },
          gray: {
            channels: 1,
            labels: ["gray"]
          }
        };
        for (var u in r) if (r.hasOwnProperty(u)) {
          if (!("channels" in r[u])) throw new Error("missing channels property: " + u);
          if (!("labels" in r[u])) throw new Error("missing channel labels property: " + u);
          if (r[u].labels.length !== r[u].channels) throw new Error("channel and label counts mismatch: " + u);
          var o = r[u].channels,
            a = r[u].labels;
          delete r[u].channels, delete r[u].labels, Object.defineProperty(r[u], "channels", {
            value: o
          }), Object.defineProperty(r[u], "labels", {
            value: a
          });
        }
        r.rgb.hsl = function (e) {
          var t,
            n,
            r = e[0] / 255,
            u = e[1] / 255,
            o = e[2] / 255,
            a = Math.min(r, u, o),
            i = Math.max(r, u, o),
            s = i - a;
          return i === a ? t = 0 : r === i ? t = (u - o) / s : u === i ? t = 2 + (o - r) / s : o === i && (t = 4 + (r - u) / s), (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (a + i) / 2, [t, 100 * (i === a ? 0 : n <= .5 ? s / (i + a) : s / (2 - i - a)), 100 * n];
        }, r.rgb.hsv = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a = e[0] / 255,
            i = e[1] / 255,
            s = e[2] / 255,
            l = Math.max(a, i, s),
            c = l - Math.min(a, i, s),
            p = function (e) {
              return (l - e) / 6 / c + .5;
            };
          return 0 === c ? u = o = 0 : (o = c / l, t = p(a), n = p(i), r = p(s), a === l ? u = r - n : i === l ? u = 1 / 3 + t - r : s === l && (u = 2 / 3 + n - t), u < 0 ? u += 1 : u > 1 && (u -= 1)), [360 * u, 100 * o, 100 * l];
        }, r.rgb.hwb = function (e) {
          var t = e[0],
            n = e[1],
            u = e[2];
          return [r.rgb.hsl(e)[0], 100 * (1 / 255 * Math.min(t, Math.min(n, u))), 100 * (u = 1 - 1 / 255 * Math.max(t, Math.max(n, u)))];
        }, r.rgb.cmyk = function (e) {
          var t,
            n = e[0] / 255,
            r = e[1] / 255,
            u = e[2] / 255;
          return [100 * ((1 - n - (t = Math.min(1 - n, 1 - r, 1 - u))) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * ((1 - u - t) / (1 - t) || 0), 100 * t];
        }, r.rgb.keyword = function (e) {
          var n = t[e];
          if (n) return n;
          var r,
            u,
            o,
            a = 1 / 0;
          for (var i in Nr) if (Nr.hasOwnProperty(i)) {
            var s = Nr[i],
              l = (u = e, o = s, Math.pow(u[0] - o[0], 2) + Math.pow(u[1] - o[1], 2) + Math.pow(u[2] - o[2], 2));
            l < a && (a = l, r = i);
          }
          return r;
        }, r.keyword.rgb = function (e) {
          return Nr[e];
        }, r.rgb.xyz = function (e) {
          var t = e[0] / 255,
            n = e[1] / 255,
            r = e[2] / 255;
          return [100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r)];
        }, r.rgb.lab = function (e) {
          var t = r.rgb.xyz(e),
            n = t[0],
            u = t[1],
            o = t[2];
          return u /= 100, o /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, [116 * (u = u > .008856 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116) - 16, 500 * (n - u), 200 * (u - (o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116))];
        }, r.hsl.rgb = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a = e[0] / 360,
            i = e[1] / 100,
            s = e[2] / 100;
          if (0 === i) return [o = 255 * s, o, o];
          t = 2 * s - (n = s < .5 ? s * (1 + i) : s + i - s * i), u = [0, 0, 0];
          for (var l = 0; l < 3; l++) (r = a + 1 / 3 * -(l - 1)) < 0 && r++, r > 1 && r--, o = 6 * r < 1 ? t + 6 * (n - t) * r : 2 * r < 1 ? n : 3 * r < 2 ? t + (n - t) * (2 / 3 - r) * 6 : t, u[l] = 255 * o;
          return u;
        }, r.hsl.hsv = function (e) {
          var t = e[0],
            n = e[1] / 100,
            r = e[2] / 100,
            u = n,
            o = Math.max(r, .01);
          return n *= (r *= 2) <= 1 ? r : 2 - r, u *= o <= 1 ? o : 2 - o, [t, 100 * (0 === r ? 2 * u / (o + u) : 2 * n / (r + n)), 100 * ((r + n) / 2)];
        }, r.hsv.rgb = function (e) {
          var t = e[0] / 60,
            n = e[1] / 100,
            r = e[2] / 100,
            u = Math.floor(t) % 6,
            o = t - Math.floor(t),
            a = 255 * r * (1 - n),
            i = 255 * r * (1 - n * o),
            s = 255 * r * (1 - n * (1 - o));
          switch (r *= 255, u) {
            case 0:
              return [r, s, a];
            case 1:
              return [i, r, a];
            case 2:
              return [a, r, s];
            case 3:
              return [a, i, r];
            case 4:
              return [s, a, r];
            case 5:
              return [r, a, i];
          }
        }, r.hsv.hsl = function (e) {
          var t,
            n,
            r,
            u = e[0],
            o = e[1] / 100,
            a = e[2] / 100,
            i = Math.max(a, .01);
          return r = (2 - o) * a, n = o * i, [u, 100 * (n = (n /= (t = (2 - o) * i) <= 1 ? t : 2 - t) || 0), 100 * (r /= 2)];
        }, r.hwb.rgb = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a,
            i,
            s = e[0] / 360,
            l = e[1] / 100,
            c = e[2] / 100,
            p = l + c;
          switch (p > 1 && (l /= p, c /= p), r = 6 * s - (t = Math.floor(6 * s)), 0 != (1 & t) && (r = 1 - r), u = l + r * ((n = 1 - c) - l), t) {
            default:
            case 6:
            case 0:
              o = n, a = u, i = l;
              break;
            case 1:
              o = u, a = n, i = l;
              break;
            case 2:
              o = l, a = n, i = u;
              break;
            case 3:
              o = l, a = u, i = n;
              break;
            case 4:
              o = u, a = l, i = n;
              break;
            case 5:
              o = n, a = l, i = u;
          }
          return [255 * o, 255 * a, 255 * i];
        }, r.cmyk.rgb = function (e) {
          var t = e[0] / 100,
            n = e[1] / 100,
            r = e[2] / 100,
            u = e[3] / 100;
          return [255 * (1 - Math.min(1, t * (1 - u) + u)), 255 * (1 - Math.min(1, n * (1 - u) + u)), 255 * (1 - Math.min(1, r * (1 - u) + u))];
        }, r.xyz.rgb = function (e) {
          var t,
            n,
            r,
            u = e[0] / 100,
            o = e[1] / 100,
            a = e[2] / 100;
          return n = -.9689 * u + 1.8758 * o + .0415 * a, r = .0557 * u + -.204 * o + 1.057 * a, t = (t = 3.2406 * u + -1.5372 * o + -.4986 * a) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [255 * (t = Math.min(Math.max(0, t), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (r = Math.min(Math.max(0, r), 1))];
        }, r.xyz.lab = function (e) {
          var t = e[0],
            n = e[1],
            r = e[2];
          return n /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))];
        }, r.lab.xyz = function (e) {
          var t,
            n,
            r,
            u = e[0];
          t = e[1] / 500 + (n = (u + 16) / 116), r = n - e[2] / 200;
          var o = Math.pow(n, 3),
            a = Math.pow(t, 3),
            i = Math.pow(r, 3);
          return n = o > .008856 ? o : (n - 16 / 116) / 7.787, t = a > .008856 ? a : (t - 16 / 116) / 7.787, r = i > .008856 ? i : (r - 16 / 116) / 7.787, [t *= 95.047, n *= 100, r *= 108.883];
        }, r.lab.lch = function (e) {
          var t,
            n = e[0],
            r = e[1],
            u = e[2];
          return (t = 360 * Math.atan2(u, r) / 2 / Math.PI) < 0 && (t += 360), [n, Math.sqrt(r * r + u * u), t];
        }, r.lch.lab = function (e) {
          var t,
            n = e[0],
            r = e[1];
          return t = e[2] / 360 * 2 * Math.PI, [n, r * Math.cos(t), r * Math.sin(t)];
        }, r.rgb.ansi16 = function (e) {
          var t = e[0],
            n = e[1],
            u = e[2],
            o = 1 in arguments ? arguments[1] : r.rgb.hsv(e)[2];
          if (0 === (o = Math.round(o / 50))) return 30;
          var a = 30 + (Math.round(u / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
          return 2 === o && (a += 60), a;
        }, r.hsv.ansi16 = function (e) {
          return r.rgb.ansi16(r.hsv.rgb(e), e[2]);
        }, r.rgb.ansi256 = function (e) {
          var t = e[0],
            n = e[1],
            r = e[2];
          return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
        }, r.ansi16.rgb = function (e) {
          var t = e % 10;
          if (0 === t || 7 === t) return e > 50 && (t += 3.5), [t = t / 10.5 * 255, t, t];
          var n = .5 * (1 + ~~(e > 50));
          return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
        }, r.ansi256.rgb = function (e) {
          if (e >= 232) {
            var t = 10 * (e - 232) + 8;
            return [t, t, t];
          }
          var n;
          return e -= 16, [Math.floor(e / 36) / 5 * 255, Math.floor((n = e % 36) / 6) / 5 * 255, n % 6 / 5 * 255];
        }, r.rgb.hex = function (e) {
          var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
          return "000000".substring(t.length) + t;
        }, r.hex.rgb = function (e) {
          var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!t) return [0, 0, 0];
          var n = t[0];
          3 === t[0].length && (n = n.split("").map(function (e) {
            return e + e;
          }).join(""));
          var r = parseInt(n, 16);
          return [r >> 16 & 255, r >> 8 & 255, 255 & r];
        }, r.rgb.hcg = function (e) {
          var t,
            n = e[0] / 255,
            r = e[1] / 255,
            u = e[2] / 255,
            o = Math.max(Math.max(n, r), u),
            a = Math.min(Math.min(n, r), u),
            i = o - a;
          return t = i <= 0 ? 0 : o === n ? (r - u) / i % 6 : o === r ? 2 + (u - n) / i : 4 + (n - r) / i + 4, t /= 6, [360 * (t %= 1), 100 * i, 100 * (i < 1 ? a / (1 - i) : 0)];
        }, r.hsl.hcg = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100,
            r = 1,
            u = 0;
          return (r = n < .5 ? 2 * t * n : 2 * t * (1 - n)) < 1 && (u = (n - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.hsv.hcg = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100,
            r = t * n,
            u = 0;
          return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.hcg.rgb = function (e) {
          var t = e[0] / 360,
            n = e[1] / 100,
            r = e[2] / 100;
          if (0 === n) return [255 * r, 255 * r, 255 * r];
          var u,
            o = [0, 0, 0],
            a = t % 1 * 6,
            i = a % 1,
            s = 1 - i;
          switch (Math.floor(a)) {
            case 0:
              o[0] = 1, o[1] = i, o[2] = 0;
              break;
            case 1:
              o[0] = s, o[1] = 1, o[2] = 0;
              break;
            case 2:
              o[0] = 0, o[1] = 1, o[2] = i;
              break;
            case 3:
              o[0] = 0, o[1] = s, o[2] = 1;
              break;
            case 4:
              o[0] = i, o[1] = 0, o[2] = 1;
              break;
            default:
              o[0] = 1, o[1] = 0, o[2] = s;
          }
          return u = (1 - n) * r, [255 * (n * o[0] + u), 255 * (n * o[1] + u), 255 * (n * o[2] + u)];
        }, r.hcg.hsv = function (e) {
          var t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t),
            r = 0;
          return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
        }, r.hcg.hsl = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100 * (1 - t) + .5 * t,
            r = 0;
          return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), [e[0], 100 * r, 100 * n];
        }, r.hcg.hwb = function (e) {
          var t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t);
          return [e[0], 100 * (n - t), 100 * (1 - n)];
        }, r.hwb.hcg = function (e) {
          var t = e[1] / 100,
            n = 1 - e[2] / 100,
            r = n - t,
            u = 0;
          return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.apple.rgb = function (e) {
          return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
        }, r.rgb.apple = function (e) {
          return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
        }, r.gray.rgb = function (e) {
          return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
        }, r.gray.hsl = r.gray.hsv = function (e) {
          return [0, 0, e[0]];
        }, r.gray.hwb = function (e) {
          return [0, 100, e[0]];
        }, r.gray.cmyk = function (e) {
          return [0, 0, 0, e[0]];
        }, r.gray.lab = function (e) {
          return [e[0], 0, 0];
        }, r.gray.hex = function (e) {
          var t = 255 & Math.round(e[0] / 100 * 255),
            n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
          return "000000".substring(n.length) + n;
        }, r.rgb.gray = function (e) {
          return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
        };
      });
    function Pr(e) {
      var t = function () {
          for (var e = {}, t = Object.keys(Or), n = t.length, r = 0; r < n; r++) e[t[r]] = {
            distance: -1,
            parent: null
          };
          return e;
        }(),
        n = [e];
      for (t[e].distance = 0; n.length;) for (var r = n.pop(), u = Object.keys(Or[r]), o = u.length, a = 0; a < o; a++) {
        var i = u[a],
          s = t[i];
        -1 === s.distance && (s.distance = t[r].distance + 1, s.parent = r, n.unshift(i));
      }
      return t;
    }
    function _r(e, t) {
      return function (n) {
        return t(e(n));
      };
    }
    function Ir(e, t) {
      for (var n = [t[e].parent, e], r = Or[t[e].parent][e], u = t[e].parent; t[u].parent;) n.unshift(t[u].parent), r = _r(Or[t[u].parent][u], r), u = t[u].parent;
      return r.conversion = n, r;
    }
    var jr = {};
    Object.keys(Or).forEach(function (e) {
      jr[e] = {}, Object.defineProperty(jr[e], "channels", {
        value: Or[e].channels
      }), Object.defineProperty(jr[e], "labels", {
        value: Or[e].labels
      });
      var t = function (e) {
        for (var t = Pr(e), n = {}, r = Object.keys(t), u = r.length, o = 0; o < u; o++) {
          var a = r[o];
          null !== t[a].parent && (n[a] = Ir(a, t));
        }
        return n;
      }(e);
      Object.keys(t).forEach(function (n) {
        var r = t[n];
        jr[e][n] = function (e) {
          var t = function (t) {
            if (null == t) return t;
            arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
            var n = e(t);
            if ("object" == typeof n) for (var r = n.length, u = 0; u < r; u++) n[u] = Math.round(n[u]);
            return n;
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r), jr[e][n].raw = function (e) {
          var t = function (t) {
            return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), e(t));
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r);
      });
    });
    var Mr = jr,
      Lr = $e(function (e) {
        const t = (e, t) => function () {
            const n = e.apply(Mr, arguments);
            return "[".concat(n + t, "m");
          },
          n = (e, t) => function () {
            const n = e.apply(Mr, arguments);
            return "[".concat(38 + t, ";5;").concat(n, "m");
          },
          r = (e, t) => function () {
            const n = e.apply(Mr, arguments);
            return "[".concat(38 + t, ";2;").concat(n[0], ";").concat(n[1], ";").concat(n[2], "m");
          };
        Object.defineProperty(e, "exports", {
          enumerable: !0,
          get: function () {
            const e = new Map(),
              u = {
                modifier: {
                  reset: [0, 0],
                  bold: [1, 22],
                  dim: [2, 22],
                  italic: [3, 23],
                  underline: [4, 24],
                  inverse: [7, 27],
                  hidden: [8, 28],
                  strikethrough: [9, 29]
                },
                color: {
                  black: [30, 39],
                  red: [31, 39],
                  green: [32, 39],
                  yellow: [33, 39],
                  blue: [34, 39],
                  magenta: [35, 39],
                  cyan: [36, 39],
                  white: [37, 39],
                  gray: [90, 39],
                  redBright: [91, 39],
                  greenBright: [92, 39],
                  yellowBright: [93, 39],
                  blueBright: [94, 39],
                  magentaBright: [95, 39],
                  cyanBright: [96, 39],
                  whiteBright: [97, 39]
                },
                bgColor: {
                  bgBlack: [40, 49],
                  bgRed: [41, 49],
                  bgGreen: [42, 49],
                  bgYellow: [43, 49],
                  bgBlue: [44, 49],
                  bgMagenta: [45, 49],
                  bgCyan: [46, 49],
                  bgWhite: [47, 49],
                  bgBlackBright: [100, 49],
                  bgRedBright: [101, 49],
                  bgGreenBright: [102, 49],
                  bgYellowBright: [103, 49],
                  bgBlueBright: [104, 49],
                  bgMagentaBright: [105, 49],
                  bgCyanBright: [106, 49],
                  bgWhiteBright: [107, 49]
                }
              };
            u.color.grey = u.color.gray;
            for (const t of Object.keys(u)) {
              const n = u[t];
              for (const _t11 of Object.keys(n)) {
                const r = n[_t11];
                u[_t11] = {
                  open: "[".concat(r[0], "m"),
                  close: "[".concat(r[1], "m")
                }, n[_t11] = u[_t11], e.set(r[0], r[1]);
              }
              Object.defineProperty(u, t, {
                value: n,
                enumerable: !1
              }), Object.defineProperty(u, "codes", {
                value: e,
                enumerable: !1
              });
            }
            const o = e => e,
              a = (e, t, n) => [e, t, n];
            u.color.close = "[39m", u.bgColor.close = "[49m", u.color.ansi = {
              ansi: t(o, 0)
            }, u.color.ansi256 = {
              ansi256: n(o, 0)
            }, u.color.ansi16m = {
              rgb: r(a, 0)
            }, u.bgColor.ansi = {
              ansi: t(o, 10)
            }, u.bgColor.ansi256 = {
              ansi256: n(o, 10)
            }, u.bgColor.ansi16m = {
              rgb: r(a, 10)
            };
            for (let _e15 of Object.keys(Mr)) {
              if ("object" != typeof Mr[_e15]) continue;
              const _o3 = Mr[_e15];
              "ansi16" === _e15 && (_e15 = "ansi"), "ansi16" in _o3 && (u.color.ansi[_e15] = t(_o3.ansi16, 0), u.bgColor.ansi[_e15] = t(_o3.ansi16, 10)), "ansi256" in _o3 && (u.color.ansi256[_e15] = n(_o3.ansi256, 0), u.bgColor.ansi256[_e15] = n(_o3.ansi256, 10)), "rgb" in _o3 && (u.color.ansi16m[_e15] = r(_o3.rgb, 0), u.bgColor.ansi16m[_e15] = r(_o3.rgb, 10));
            }
            return u;
          }
        });
      }),
      Rr = {
        EOL: "\n"
      },
      qr = (e, t) => {
        t = t || Re.argv;
        const n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
          r = t.indexOf(n + e),
          u = t.indexOf("--");
        return -1 !== r && (-1 === u || r < u);
      };
    const Vr = Re.env;
    let Wr;
    function $r(e) {
      return function (e) {
        return 0 !== e && {
          level: e,
          hasBasic: !0,
          has256: e >= 2,
          has16m: e >= 3
        };
      }(function (e) {
        if (!1 === Wr) return 0;
        if (qr("color=16m") || qr("color=full") || qr("color=truecolor")) return 3;
        if (qr("color=256")) return 2;
        if (e && !e.isTTY && !0 !== Wr) return 0;
        const t = Wr ? 1 : 0;
        if ("win32" === Re.platform) {
          const _e16 = Rr.release().split(".");
          return Number(Re.versions.node.split(".")[0]) >= 8 && Number(_e16[0]) >= 10 && Number(_e16[2]) >= 10586 ? Number(_e16[2]) >= 14931 ? 3 : 2 : 1;
        }
        if ("CI" in Vr) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(e => e in Vr) || "codeship" === Vr.CI_NAME ? 1 : t;
        if ("TEAMCITY_VERSION" in Vr) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(Vr.TEAMCITY_VERSION) ? 1 : 0;
        if ("truecolor" === Vr.COLORTERM) return 3;
        if ("TERM_PROGRAM" in Vr) {
          const _e17 = parseInt((Vr.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
          switch (Vr.TERM_PROGRAM) {
            case "iTerm.app":
              return _e17 >= 3 ? 3 : 2;
            case "Apple_Terminal":
              return 2;
          }
        }
        return /-256(color)?$/i.test(Vr.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(Vr.TERM) || "COLORTERM" in Vr ? 1 : (t);
      }(e));
    }
    qr("no-color") || qr("no-colors") || qr("color=false") ? Wr = !1 : (qr("color") || qr("colors") || qr("color=true") || qr("color=always")) && (Wr = !0), "FORCE_COLOR" in Vr && (Wr = 0 === Vr.FORCE_COLOR.length || 0 !== parseInt(Vr.FORCE_COLOR, 10));
    var Ur = {
      supportsColor: $r,
      stdout: $r(Re.stdout),
      stderr: $r(Re.stderr)
    };
    const zr = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
      Jr = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
      Gr = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
      Hr = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi,
      Xr = new Map([["n", "\n"], ["r", "\r"], ["t", "\t"], ["b", "\b"], ["f", "\f"], ["v", "\v"], ["0", "\0"], ["\\", "\\"], ["e", ""], ["a", ""]]);
    function Yr(e) {
      return "u" === e[0] && 5 === e.length || "x" === e[0] && 3 === e.length ? String.fromCharCode(parseInt(e.slice(1), 16)) : Xr.get(e) || e;
    }
    function Kr(e, t) {
      const n = [],
        r = t.trim().split(/\s*,\s*/g);
      let u;
      for (const _t12 of r) if (isNaN(_t12)) {
        if (!(u = _t12.match(Gr))) throw new Error("Invalid Chalk template style argument: ".concat(_t12, " (in style '").concat(e, "')"));
        n.push(u[2].replace(Hr, (e, t, n) => t ? Yr(t) : n));
      } else n.push(Number(_t12));
      return n;
    }
    function Qr(e) {
      Jr.lastIndex = 0;
      const t = [];
      let n;
      for (; null !== (n = Jr.exec(e));) {
        const _e18 = n[1];
        if (n[2]) {
          const r = Kr(_e18, n[2]);
          t.push([_e18].concat(r));
        } else t.push([_e18]);
      }
      return t;
    }
    function Zr(e, t) {
      const n = {};
      for (const _e19 of t) for (const _t13 of _e19.styles) n[_t13[0]] = _e19.inverse ? null : _t13.slice(1);
      let r = e;
      for (const _e20 of Object.keys(n)) if (Array.isArray(n[_e20])) {
        if (!(_e20 in r)) throw new Error("Unknown Chalk style: ".concat(_e20));
        r = n[_e20].length > 0 ? r[_e20].apply(r, n[_e20]) : r[_e20];
      }
      return r;
    }
    var eu = (e, t) => {
        const n = [],
          r = [];
        let u = [];
        if (t.replace(zr, (t, o, a, i, s, l) => {
          if (o) u.push(Yr(o));else if (i) {
            const _t14 = u.join("");
            u = [], r.push(0 === n.length ? _t14 : Zr(e, n)(_t14)), n.push({
              inverse: a,
              styles: Qr(i)
            });
          } else if (s) {
            if (0 === n.length) throw new Error("Found extraneous } in Chalk template literal");
            r.push(Zr(e, n)(u.join(""))), u = [], n.pop();
          } else u.push(l);
        }), r.push(u.join("")), n.length > 0) {
          const _e21 = "Chalk template literal is missing ".concat(n.length, " closing bracket").concat(1 === n.length ? "" : "s", " (`}`)");
          throw new Error(_e21);
        }
        return r.join("");
      },
      tu = $e(function (e) {
        const t = Ur.stdout,
          n = "win32" === Re.platform && !(Re.env.TERM || "").toLowerCase().startsWith("xterm"),
          r = ["ansi", "ansi", "ansi256", "ansi16m"],
          u = new Set(["gray"]),
          o = Object.create(null);
        function a(e, n) {
          n = n || {};
          const r = t ? t.level : 0;
          e.level = void 0 === n.level ? r : n.level, e.enabled = "enabled" in n ? n.enabled : e.level > 0;
        }
        function i(e) {
          if (!this || !(this instanceof i) || this.template) {
            const t = {};
            return a(t, e), t.template = function () {
              const e = [].slice.call(arguments);
              return p.apply(null, [t.template].concat(e));
            }, Object.setPrototypeOf(t, i.prototype), Object.setPrototypeOf(t.template, t), t.template.constructor = i, t.template;
          }
          a(this, e);
        }
        n && (Lr.blue.open = "[94m");
        for (const _e22 of Object.keys(Lr)) Lr[_e22].closeRe = new RegExp(kr(Lr[_e22].close), "g"), o[_e22] = {
          get() {
            const t = Lr[_e22];
            return l.call(this, this._styles ? this._styles.concat(t) : [t], this._empty, _e22);
          }
        };
        o.visible = {
          get() {
            return l.call(this, this._styles || [], !0, "visible");
          }
        }, Lr.color.closeRe = new RegExp(kr(Lr.color.close), "g");
        for (const _e23 of Object.keys(Lr.color.ansi)) u.has(_e23) || (o[_e23] = {
          get() {
            const t = this.level;
            return function () {
              const n = Lr.color[r[t]][_e23].apply(null, arguments),
                u = {
                  open: n,
                  close: Lr.color.close,
                  closeRe: Lr.color.closeRe
                };
              return l.call(this, this._styles ? this._styles.concat(u) : [u], this._empty, _e23);
            };
          }
        });
        Lr.bgColor.closeRe = new RegExp(kr(Lr.bgColor.close), "g");
        for (const _e24 of Object.keys(Lr.bgColor.ansi)) {
          if (u.has(_e24)) continue;
          o["bg" + _e24[0].toUpperCase() + _e24.slice(1)] = {
            get() {
              const t = this.level;
              return function () {
                const n = Lr.bgColor[r[t]][_e24].apply(null, arguments),
                  u = {
                    open: n,
                    close: Lr.bgColor.close,
                    closeRe: Lr.bgColor.closeRe
                  };
                return l.call(this, this._styles ? this._styles.concat(u) : [u], this._empty, _e24);
              };
            }
          };
        }
        const s = Object.defineProperties(() => {}, o);
        function l(e, t, n) {
          const r = function e() {
            return c.apply(e, arguments);
          };
          r._styles = e, r._empty = t;
          const u = this;
          return Object.defineProperty(r, "level", {
            enumerable: !0,
            get: () => u.level,
            set(e) {
              u.level = e;
            }
          }), Object.defineProperty(r, "enabled", {
            enumerable: !0,
            get: () => u.enabled,
            set(e) {
              u.enabled = e;
            }
          }), r.hasGrey = this.hasGrey || "gray" === n || "grey" === n, r.__proto__ = s, r;
        }
        function c() {
          const e = arguments,
            t = e.length;
          let r = String(arguments[0]);
          if (0 === t) return "";
          if (t > 1) for (let n = 1; n < t; n++) r += " " + e[n];
          if (!this.enabled || this.level <= 0 || !r) return this._empty ? "" : r;
          const u = Lr.dim.open;
          n && this.hasGrey && (Lr.dim.open = "");
          for (const _e25 of this._styles.slice().reverse()) r = _e25.open + r.replace(_e25.closeRe, _e25.open) + _e25.close, r = r.replace(/\r?\n/g, "".concat(_e25.close, "$&").concat(_e25.open));
          return Lr.dim.open = u, r;
        }
        function p(e, t) {
          if (!Array.isArray(t)) return [].slice.call(arguments, 1).join(" ");
          const n = [].slice.call(arguments, 2),
            r = [t.raw[0]];
          for (let _e26 = 1; _e26 < t.length; _e26++) r.push(String(n[_e26 - 1]).replace(/[{}\\]/g, "\\$&")), r.push(String(t.raw[_e26]));
          return eu(e, r.join(""));
        }
        Object.defineProperties(i.prototype, o), e.exports = i(), e.exports.supportsColor = t, e.exports.default = e.exports;
      }),
      nu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.commonDeprecatedHandler = (e, t, {
          descriptor: n
        }) => {
          const r = ["".concat(tu.default.yellow("string" == typeof e ? n.key(e) : n.pair(e)), " is deprecated")];
          return t && r.push("we now treat it as ".concat(tu.default.blue("string" == typeof t ? n.key(t) : n.pair(t)))), r.join("; ") + ".";
        };
      }),
      ru = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(nu, t);
      }),
      uu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.commonInvalidHandler = (e, t, n) => ["Invalid ".concat(tu.default.red(n.descriptor.key(e)), " value."), "Expected ".concat(tu.default.blue(n.schemas[e].expected(n)), ","), "but received ".concat(tu.default.red(n.descriptor.value(t)), ".")].join(" ");
      }),
      ou = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(uu, t);
      }),
      au = [],
      iu = [],
      su = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.levenUnknownHandler = (e, t, {
          descriptor: n,
          logger: r,
          schemas: u
        }) => {
          const o = ["Ignored unknown option ".concat(tu.default.yellow(n.pair({
              key: e,
              value: t
            })), ".")],
            a = Object.keys(u).sort().find(t => function (e, t) {
              if (e === t) return 0;
              var n = e;
              e.length > t.length && (e = t, t = n);
              var r = e.length,
                u = t.length;
              if (0 === r) return u;
              if (0 === u) return r;
              for (; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-u);) r--, u--;
              if (0 === r) return u;
              for (var o, a, i, s, l = 0; l < r && e.charCodeAt(l) === t.charCodeAt(l);) l++;
              if (u -= l, 0 == (r -= l)) return u;
              for (var c = 0, p = 0; c < r;) iu[l + c] = e.charCodeAt(l + c), au[c] = ++c;
              for (; p < u;) for (o = t.charCodeAt(l + p), i = p++, a = p, c = 0; c < r; c++) s = o === iu[l + c] ? i : i + 1, i = au[c], a = au[c] = i > a ? s > a ? a + 1 : s : s > i ? i + 1 : s;
              return a;
            }(e, t) < 3);
          a && o.push("Did you mean ".concat(tu.default.blue(n.key(a)), "?")), r.warn(o.join(" "));
        };
      }),
      lu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(su, t);
      }),
      cu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(ru, t), wr.__exportStar(ou, t), wr.__exportStar(lu, t);
      }),
      pu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
        function r(e, t) {
          const r = new e(t),
            a = Object.create(r);
          for (const _e27 of n) _e27 in t && (a[_e27] = o(t[_e27], r, u.prototype[_e27].length));
          return a;
        }
        t.createSchema = r;
        class u {
          constructor(e) {
            this.name = e.name;
          }
          static create(e) {
            return r(this, e);
          }
          default(e) {}
          expected(e) {
            return "nothing";
          }
          validate(e, t) {
            return !1;
          }
          deprecated(e, t) {
            return !1;
          }
          forward(e, t) {}
          redirect(e, t) {}
          overlap(e, t, n) {
            return e;
          }
          preprocess(e, t) {
            return e;
          }
          postprocess(e, t) {
            return e;
          }
        }
        function o(e, t, n) {
          return "function" == typeof e ? (...r) => e(...r.slice(0, n - 1), t, ...r.slice(n - 1)) : () => e;
        }
        t.Schema = u;
      }),
      du = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          constructor(e) {
            super(e), this._sourceName = e.sourceName;
          }
          expected(e) {
            return e.schemas[this._sourceName].expected(e);
          }
          validate(e, t) {
            return t.schemas[this._sourceName].validate(e, t);
          }
          redirect(e, t) {
            return this._sourceName;
          }
        }
        t.AliasSchema = n;
      }),
      fu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          expected() {
            return "anything";
          }
          validate() {
            return !0;
          }
        }
        t.AnySchema = n;
      }),
      hu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          constructor(e) {
            var {
                valueSchema: t,
                name: n = t.name
              } = e,
              r = wr.__rest(e, ["valueSchema", "name"]);
            super(Object.assign({}, r, {
              name: n
            })), this._valueSchema = t;
          }
          expected(e) {
            return "an array of ".concat(this._valueSchema.expected(e));
          }
          validate(e, t) {
            if (!Array.isArray(e)) return !1;
            const n = [];
            for (const r of e) {
              const _e28 = t.normalizeValidateResult(this._valueSchema.validate(r, t), r);
              !0 !== _e28 && n.push(_e28.value);
            }
            return 0 === n.length || {
              value: n
            };
          }
          deprecated(e, t) {
            const n = [];
            for (const r of e) {
              const _e29 = t.normalizeDeprecatedResult(this._valueSchema.deprecated(r, t), r);
              !1 !== _e29 && n.push(..._e29.map(({
                value: e
              }) => ({
                value: [e]
              })));
            }
            return n;
          }
          forward(e, t) {
            const n = [];
            for (const u of e) {
              const _e30 = t.normalizeForwardResult(this._valueSchema.forward(u, t), u);
              n.push(..._e30.map(r));
            }
            return n;
          }
          redirect(e, t) {
            const n = [],
              u = [];
            for (const o of e) {
              const _e31 = t.normalizeRedirectResult(this._valueSchema.redirect(o, t), o);
              "remain" in _e31 && n.push(_e31.remain), u.push(..._e31.redirect.map(r));
            }
            return 0 === n.length ? {
              redirect: u
            } : {
              redirect: u,
              remain: n
            };
          }
          overlap(e, t) {
            return e.concat(t);
          }
        }
        function r({
          from: e,
          to: t
        }) {
          return {
            from: [e],
            to: t
          };
        }
        t.ArraySchema = n;
      }),
      mu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          expected() {
            return "true or false";
          }
          validate(e) {
            return "boolean" == typeof e;
          }
        }
        t.BooleanSchema = n;
      }),
      gu = $e(function (e, t) {
        function n(e, t) {
          return "string" == typeof e || "key" in e ? {
            from: t,
            to: e
          } : "from" in e ? {
            from: e.from,
            to: e.to
          } : {
            from: t,
            to: e.to
          };
        }
        function r(e, t) {
          return void 0 === e ? [] : Array.isArray(e) ? e.map(e => n(e, t)) : [n(e, t)];
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.recordFromArray = function (e, t) {
          const n = Object.create(null);
          for (const r of e) {
            const _e32 = r[t];
            if (n[_e32]) throw new Error("Duplicate ".concat(t, " ").concat(JSON.stringify(_e32)));
            n[_e32] = r;
          }
          return n;
        }, t.mapFromArray = function (e, t) {
          const n = new Map();
          for (const r of e) {
            const _e33 = r[t];
            if (n.has(_e33)) throw new Error("Duplicate ".concat(t, " ").concat(JSON.stringify(_e33)));
            n.set(_e33, r);
          }
          return n;
        }, t.createAutoChecklist = function () {
          const e = Object.create(null);
          return t => {
            const n = JSON.stringify(t);
            return !!e[n] || (e[n] = !0, !1);
          };
        }, t.partition = function (e, t) {
          const n = [],
            r = [];
          for (const u of e) t(u) ? n.push(u) : r.push(u);
          return [n, r];
        }, t.isInt = function (e) {
          return e === Math.floor(e);
        }, t.comparePrimitive = function (e, t) {
          if (e === t) return 0;
          const n = typeof e,
            r = typeof t,
            u = ["undefined", "object", "boolean", "number", "string"];
          return n !== r ? u.indexOf(n) - u.indexOf(r) : "string" !== n ? Number(e) - Number(t) : e.localeCompare(t);
        }, t.normalizeDefaultResult = function (e) {
          return void 0 === e ? {} : e;
        }, t.normalizeValidateResult = function (e, t) {
          return !0 === e || (!1 === e ? {
            value: t
          } : e);
        }, t.normalizeDeprecatedResult = function (e, t, n = !1) {
          return !1 !== e && (!0 === e ? !!n || [{
            value: t
          }] : "value" in e ? [e] : 0 !== e.length && e);
        }, t.normalizeTransferResult = n, t.normalizeForwardResult = r, t.normalizeRedirectResult = function (e, t) {
          const n = r("object" == typeof e && "redirect" in e ? e.redirect : e, t);
          return 0 === n.length ? {
            remain: t,
            redirect: n
          } : "object" == typeof e && "remain" in e ? {
            remain: e.remain,
            redirect: n
          } : {
            redirect: n
          };
        };
      }),
      Du = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          constructor(e) {
            super(e), this._choices = gu.mapFromArray(e.choices.map(e => e && "object" == typeof e ? e : {
              value: e
            }), "value");
          }
          expected({
            descriptor: e
          }) {
            const t = Array.from(this._choices.keys()).map(e => this._choices.get(e)).filter(e => !e.deprecated).map(e => e.value).sort(gu.comparePrimitive).map(e.value),
              n = t.slice(0, -2),
              r = t.slice(-2);
            return n.concat(r.join(" or ")).join(", ");
          }
          validate(e) {
            return this._choices.has(e);
          }
          deprecated(e) {
            const t = this._choices.get(e);
            return !(!t || !t.deprecated) && {
              value: e
            };
          }
          forward(e) {
            const t = this._choices.get(e);
            return t ? t.forward : void 0;
          }
          redirect(e) {
            const t = this._choices.get(e);
            return t ? t.redirect : void 0;
          }
        }
        t.ChoiceSchema = n;
      }),
      yu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          expected() {
            return "a number";
          }
          validate(e, t) {
            return "number" == typeof e;
          }
        }
        t.NumberSchema = n;
      }),
      Eu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends yu.NumberSchema {
          expected() {
            return "an integer";
          }
          validate(e, t) {
            return !0 === t.normalizeValidateResult(super.validate(e, t), e) && gu.isInt(e);
          }
        }
        t.IntegerSchema = n;
      }),
      Cu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        class n extends pu.Schema {
          expected() {
            return "a string";
          }
          validate(e) {
            return "string" == typeof e;
          }
        }
        t.StringSchema = n;
      }),
      bu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(du, t), wr.__exportStar(fu, t), wr.__exportStar(hu, t), wr.__exportStar(mu, t), wr.__exportStar(Du, t), wr.__exportStar(Eu, t), wr.__exportStar(yu, t), wr.__exportStar(Cu, t);
      }),
      Au = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.defaultDescriptor = Sr.apiDescriptor, t.defaultUnknownHandler = su.levenUnknownHandler, t.defaultInvalidHandler = ou.commonInvalidHandler, t.defaultDeprecatedHandler = nu.commonDeprecatedHandler;
      }),
      vu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.normalize = (e, t, r) => new n(t, r).normalize(e);
        class n {
          constructor(e, t) {
            const {
              logger: n = console,
              descriptor: r = Au.defaultDescriptor,
              unknown: u = Au.defaultUnknownHandler,
              invalid: o = Au.defaultInvalidHandler,
              deprecated: a = Au.defaultDeprecatedHandler
            } = t || {};
            this._utils = {
              descriptor: r,
              logger: n || {
                warn: () => {}
              },
              schemas: gu.recordFromArray(e, "name"),
              normalizeDefaultResult: gu.normalizeDefaultResult,
              normalizeDeprecatedResult: gu.normalizeDeprecatedResult,
              normalizeForwardResult: gu.normalizeForwardResult,
              normalizeRedirectResult: gu.normalizeRedirectResult,
              normalizeValidateResult: gu.normalizeValidateResult
            }, this._unknownHandler = u, this._invalidHandler = o, this._deprecatedHandler = a, this.cleanHistory();
          }
          cleanHistory() {
            this._hasDeprecationWarned = gu.createAutoChecklist();
          }
          normalize(e) {
            const t = {},
              n = [e],
              r = () => {
                for (; 0 !== n.length;) {
                  const e = n.shift(),
                    r = this._applyNormalization(e, t);
                  n.push(...r);
                }
              };
            r();
            for (const _e34 of Object.keys(this._utils.schemas)) {
              const _r5 = this._utils.schemas[_e34];
              if (!(_e34 in t)) {
                const _t15 = gu.normalizeDefaultResult(_r5.default(this._utils));
                "value" in _t15 && n.push({
                  [_e34]: _t15.value
                });
              }
            }
            r();
            for (const _e35 of Object.keys(this._utils.schemas)) {
              const _n7 = this._utils.schemas[_e35];
              _e35 in t && (t[_e35] = _n7.postprocess(t[_e35], this._utils));
            }
            return t;
          }
          _applyNormalization(e, t) {
            const n = [],
              [r, u] = gu.partition(Object.keys(e), e => e in this._utils.schemas);
            for (const _u2 of r) {
              const _r6 = this._utils.schemas[_u2],
                o = _r6.preprocess(e[_u2], this._utils),
                a = gu.normalizeValidateResult(_r6.validate(o, this._utils), o);
              if (!0 !== a) {
                const {
                    value: _e36
                  } = a,
                  _t16 = this._invalidHandler(_u2, _e36, this._utils);
                throw "string" == typeof _t16 ? new Error(_t16) : _t16;
              }
              const i = ({
                  from: e,
                  to: t
                }) => {
                  n.push("string" == typeof t ? {
                    [t]: e
                  } : {
                    [t.key]: t.value
                  });
                },
                s = ({
                  value: e,
                  redirectTo: t
                }) => {
                  const n = gu.normalizeDeprecatedResult(_r6.deprecated(e, this._utils), o, !0);
                  if (!1 !== n) if (!0 === n) this._hasDeprecationWarned(_u2) || this._utils.logger.warn(this._deprecatedHandler(_u2, t, this._utils));else for (const {
                    value: _e37
                  } of n) {
                    const _n8 = {
                      key: _u2,
                      value: _e37
                    };
                    if (!this._hasDeprecationWarned(_n8)) {
                      const r = "string" == typeof t ? {
                        key: t,
                        value: _e37
                      } : t;
                      this._utils.logger.warn(this._deprecatedHandler(_n8, r, this._utils));
                    }
                  }
                };
              gu.normalizeForwardResult(_r6.forward(o, this._utils), o).forEach(i);
              const l = gu.normalizeRedirectResult(_r6.redirect(o, this._utils), o);
              if (l.redirect.forEach(i), "remain" in l) {
                const _e38 = l.remain;
                t[_u2] = _u2 in t ? _r6.overlap(t[_u2], _e38, this._utils) : _e38, s({
                  value: _e38
                });
              }
              for (const {
                from: _e39,
                to: _t17
              } of l.redirect) s({
                value: _e39,
                redirectTo: _t17
              });
            }
            for (const _r7 of u) {
              const _u3 = e[_r7],
                o = this._unknownHandler(_r7, _u3, this._utils);
              if (o) for (const _e40 of Object.keys(o)) {
                const _r8 = {
                  [_e40]: o[_e40]
                };
                _e40 in this._utils.schemas ? n.push(_r8) : Object.assign(t, _r8);
              }
            }
            return n;
          }
        }
        t.Normalizer = n;
      }),
      Fu = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), wr.__exportStar(Br, t), wr.__exportStar(cu, t), wr.__exportStar(bu, t), wr.__exportStar(vu, t), wr.__exportStar(pu, t);
      });
    const xu = [],
      Su = [],
      wu = (e, t) => {
        if (e === t) return 0;
        const n = e;
        e.length > t.length && (e = t, t = n);
        let r = e.length,
          u = t.length;
        for (; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-u);) r--, u--;
        let o,
          a,
          i,
          s,
          l = 0;
        for (; l < r && e.charCodeAt(l) === t.charCodeAt(l);) l++;
        if (r -= l, u -= l, 0 === r) return u;
        let c = 0,
          p = 0;
        for (; c < r;) Su[c] = e.charCodeAt(l + c), xu[c] = ++c;
        for (; p < u;) for (o = t.charCodeAt(l + p), i = p++, a = p, c = 0; c < r; c++) s = o === Su[c] ? i : i + 1, i = xu[c], a = xu[c] = i > a ? s > a ? a + 1 : s : s > i ? i + 1 : s;
        return a;
      };
    var Bu = wu,
      Tu = wu;
    Bu.default = Tu;
    var ku = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 134, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 250, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 221],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [112, 128, 144],
      slategrey: [112, 128, 144],
      snow: [255, 250, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 50]
    };
    const Nu = {};
    for (const _e41 of Object.keys(ku)) Nu[ku[_e41]] = _e41;
    const Ou = {
      rgb: {
        channels: 3,
        labels: "rgb"
      },
      hsl: {
        channels: 3,
        labels: "hsl"
      },
      hsv: {
        channels: 3,
        labels: "hsv"
      },
      hwb: {
        channels: 3,
        labels: "hwb"
      },
      cmyk: {
        channels: 4,
        labels: "cmyk"
      },
      xyz: {
        channels: 3,
        labels: "xyz"
      },
      lab: {
        channels: 3,
        labels: "lab"
      },
      lch: {
        channels: 3,
        labels: "lch"
      },
      hex: {
        channels: 1,
        labels: ["hex"]
      },
      keyword: {
        channels: 1,
        labels: ["keyword"]
      },
      ansi16: {
        channels: 1,
        labels: ["ansi16"]
      },
      ansi256: {
        channels: 1,
        labels: ["ansi256"]
      },
      hcg: {
        channels: 3,
        labels: ["h", "c", "g"]
      },
      apple: {
        channels: 3,
        labels: ["r16", "g16", "b16"]
      },
      gray: {
        channels: 1,
        labels: ["gray"]
      }
    };
    var Pu = Ou;
    for (const _e42 of Object.keys(Ou)) {
      if (!("channels" in Ou[_e42])) throw new Error("missing channels property: " + _e42);
      if (!("labels" in Ou[_e42])) throw new Error("missing channel labels property: " + _e42);
      if (Ou[_e42].labels.length !== Ou[_e42].channels) throw new Error("channel and label counts mismatch: " + _e42);
      const {
        channels: _t18,
        labels: _n9
      } = Ou[_e42];
      delete Ou[_e42].channels, delete Ou[_e42].labels, Object.defineProperty(Ou[_e42], "channels", {
        value: _t18
      }), Object.defineProperty(Ou[_e42], "labels", {
        value: _n9
      });
    }
    function _u(e) {
      const t = function () {
          const e = {},
            t = Object.keys(Pu);
          for (let n = t.length, r = 0; r < n; r++) e[t[r]] = {
            distance: -1,
            parent: null
          };
          return e;
        }(),
        n = [e];
      for (t[e].distance = 0; n.length;) {
        const _e43 = n.pop(),
          r = Object.keys(Pu[_e43]);
        for (let u = r.length, o = 0; o < u; o++) {
          const _u4 = r[o],
            a = t[_u4];
          -1 === a.distance && (a.distance = t[_e43].distance + 1, a.parent = _e43, n.unshift(_u4));
        }
      }
      return t;
    }
    function Iu(e, t) {
      return function (n) {
        return t(e(n));
      };
    }
    function ju(e, t) {
      const n = [t[e].parent, e];
      let r = Pu[t[e].parent][e],
        u = t[e].parent;
      for (; t[u].parent;) n.unshift(t[u].parent), r = Iu(Pu[t[u].parent][u], r), u = t[u].parent;
      return r.conversion = n, r;
    }
    Ou.rgb.hsl = function (e) {
      const t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        u = Math.min(t, n, r),
        o = Math.max(t, n, r),
        a = o - u;
      let i, s;
      o === u ? i = 0 : t === o ? i = (n - r) / a : n === o ? i = 2 + (r - t) / a : r === o && (i = 4 + (t - n) / a), i = Math.min(60 * i, 360), i < 0 && (i += 360);
      const l = (u + o) / 2;
      return s = o === u ? 0 : l <= .5 ? a / (o + u) : a / (2 - o - u), [i, 100 * s, 100 * l];
    }, Ou.rgb.hsv = function (e) {
      let t, n, r, u, o;
      const a = e[0] / 255,
        i = e[1] / 255,
        s = e[2] / 255,
        l = Math.max(a, i, s),
        c = l - Math.min(a, i, s),
        p = function (e) {
          return (l - e) / 6 / c + .5;
        };
      return 0 === c ? (u = 0, o = 0) : (o = c / l, t = p(a), n = p(i), r = p(s), a === l ? u = r - n : i === l ? u = 1 / 3 + t - r : s === l && (u = 2 / 3 + n - t), u < 0 ? u += 1 : u > 1 && (u -= 1)), [360 * u, 100 * o, 100 * l];
    }, Ou.rgb.hwb = function (e) {
      const t = e[0],
        n = e[1];
      let r = e[2];
      const u = Ou.rgb.hsl(e)[0],
        o = 1 / 255 * Math.min(t, Math.min(n, r));
      return r = 1 - 1 / 255 * Math.max(t, Math.max(n, r)), [u, 100 * o, 100 * r];
    }, Ou.rgb.cmyk = function (e) {
      const t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        u = Math.min(1 - t, 1 - n, 1 - r);
      return [100 * ((1 - t - u) / (1 - u) || 0), 100 * ((1 - n - u) / (1 - u) || 0), 100 * ((1 - r - u) / (1 - u) || 0), 100 * u];
    }, Ou.rgb.keyword = function (e) {
      const t = Nu[e];
      if (t) return t;
      let n,
        r = 1 / 0;
      for (const _t19 of Object.keys(ku)) {
        const a = (o = ku[_t19], ((u = e)[0] - o[0]) ** 2 + (u[1] - o[1]) ** 2 + (u[2] - o[2]) ** 2);
        a < r && (r = a, n = _t19);
      }
      var u, o;
      return n;
    }, Ou.keyword.rgb = function (e) {
      return ku[e];
    }, Ou.rgb.xyz = function (e) {
      let t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255;
      t = t > .04045 ? ((t + .055) / 1.055) ** 2.4 : t / 12.92, n = n > .04045 ? ((n + .055) / 1.055) ** 2.4 : n / 12.92, r = r > .04045 ? ((r + .055) / 1.055) ** 2.4 : r / 12.92;
      return [100 * (.4124 * t + .3576 * n + .1805 * r), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r)];
    }, Ou.rgb.lab = function (e) {
      const t = Ou.rgb.xyz(e);
      let n = t[0],
        r = t[1],
        u = t[2];
      n /= 95.047, r /= 100, u /= 108.883, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > .008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116, u = u > .008856 ? u ** (1 / 3) : 7.787 * u + 16 / 116;
      return [116 * r - 16, 500 * (n - r), 200 * (r - u)];
    }, Ou.hsl.rgb = function (e) {
      const t = e[0] / 360,
        n = e[1] / 100,
        r = e[2] / 100;
      let u, o, a;
      if (0 === n) return a = 255 * r, [a, a, a];
      u = r < .5 ? r * (1 + n) : r + n - r * n;
      const i = 2 * r - u,
        s = [0, 0, 0];
      for (let _e44 = 0; _e44 < 3; _e44++) o = t + 1 / 3 * -(_e44 - 1), o < 0 && o++, o > 1 && o--, a = 6 * o < 1 ? i + 6 * (u - i) * o : 2 * o < 1 ? u : 3 * o < 2 ? i + (u - i) * (2 / 3 - o) * 6 : i, s[_e44] = 255 * a;
      return s;
    }, Ou.hsl.hsv = function (e) {
      const t = e[0];
      let n = e[1] / 100,
        r = e[2] / 100,
        u = n;
      const o = Math.max(r, .01);
      r *= 2, n *= r <= 1 ? r : 2 - r, u *= o <= 1 ? o : 2 - o;
      return [t, 100 * (0 === r ? 2 * u / (o + u) : 2 * n / (r + n)), 100 * ((r + n) / 2)];
    }, Ou.hsv.rgb = function (e) {
      const t = e[0] / 60,
        n = e[1] / 100;
      let r = e[2] / 100;
      const u = Math.floor(t) % 6,
        o = t - Math.floor(t),
        a = 255 * r * (1 - n),
        i = 255 * r * (1 - n * o),
        s = 255 * r * (1 - n * (1 - o));
      switch (r *= 255, u) {
        case 0:
          return [r, s, a];
        case 1:
          return [i, r, a];
        case 2:
          return [a, r, s];
        case 3:
          return [a, i, r];
        case 4:
          return [s, a, r];
        case 5:
          return [r, a, i];
      }
    }, Ou.hsv.hsl = function (e) {
      const t = e[0],
        n = e[1] / 100,
        r = e[2] / 100,
        u = Math.max(r, .01);
      let o, a;
      a = (2 - n) * r;
      const i = (2 - n) * u;
      return o = n * u, o /= i <= 1 ? i : 2 - i, o = o || 0, a /= 2, [t, 100 * o, 100 * a];
    }, Ou.hwb.rgb = function (e) {
      const t = e[0] / 360;
      let n = e[1] / 100,
        r = e[2] / 100;
      const u = n + r;
      let o;
      u > 1 && (n /= u, r /= u);
      const a = Math.floor(6 * t),
        i = 1 - r;
      o = 6 * t - a, 0 != (1 & a) && (o = 1 - o);
      const s = n + o * (i - n);
      let l, c, p;
      switch (a) {
        default:
        case 6:
        case 0:
          l = i, c = s, p = n;
          break;
        case 1:
          l = s, c = i, p = n;
          break;
        case 2:
          l = n, c = i, p = s;
          break;
        case 3:
          l = n, c = s, p = i;
          break;
        case 4:
          l = s, c = n, p = i;
          break;
        case 5:
          l = i, c = n, p = s;
      }
      return [255 * l, 255 * c, 255 * p];
    }, Ou.cmyk.rgb = function (e) {
      const t = e[0] / 100,
        n = e[1] / 100,
        r = e[2] / 100,
        u = e[3] / 100;
      return [255 * (1 - Math.min(1, t * (1 - u) + u)), 255 * (1 - Math.min(1, n * (1 - u) + u)), 255 * (1 - Math.min(1, r * (1 - u) + u))];
    }, Ou.xyz.rgb = function (e) {
      const t = e[0] / 100,
        n = e[1] / 100,
        r = e[2] / 100;
      let u, o, a;
      return u = 3.2406 * t + -1.5372 * n + -.4986 * r, o = -.9689 * t + 1.8758 * n + .0415 * r, a = .0557 * t + -.204 * n + 1.057 * r, u = u > .0031308 ? 1.055 * u ** (1 / 2.4) - .055 : 12.92 * u, o = o > .0031308 ? 1.055 * o ** (1 / 2.4) - .055 : 12.92 * o, a = a > .0031308 ? 1.055 * a ** (1 / 2.4) - .055 : 12.92 * a, u = Math.min(Math.max(0, u), 1), o = Math.min(Math.max(0, o), 1), a = Math.min(Math.max(0, a), 1), [255 * u, 255 * o, 255 * a];
    }, Ou.xyz.lab = function (e) {
      let t = e[0],
        n = e[1],
        r = e[2];
      t /= 95.047, n /= 100, r /= 108.883, t = t > .008856 ? t ** (1 / 3) : 7.787 * t + 16 / 116, n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116, r = r > .008856 ? r ** (1 / 3) : 7.787 * r + 16 / 116;
      return [116 * n - 16, 500 * (t - n), 200 * (n - r)];
    }, Ou.lab.xyz = function (e) {
      let t, n, r;
      n = (e[0] + 16) / 116, t = e[1] / 500 + n, r = n - e[2] / 200;
      const u = n ** 3,
        o = t ** 3,
        a = r ** 3;
      return n = u > .008856 ? u : (n - 16 / 116) / 7.787, t = o > .008856 ? o : (t - 16 / 116) / 7.787, r = a > .008856 ? a : (r - 16 / 116) / 7.787, t *= 95.047, n *= 100, r *= 108.883, [t, n, r];
    }, Ou.lab.lch = function (e) {
      const t = e[0],
        n = e[1],
        r = e[2];
      let u;
      u = 360 * Math.atan2(r, n) / 2 / Math.PI, u < 0 && (u += 360);
      return [t, Math.sqrt(n * n + r * r), u];
    }, Ou.lch.lab = function (e) {
      const t = e[0],
        n = e[1],
        r = e[2] / 360 * 2 * Math.PI;
      return [t, n * Math.cos(r), n * Math.sin(r)];
    }, Ou.rgb.ansi16 = function (e, t = null) {
      const [n, r, u] = e;
      let o = null === t ? Ou.rgb.hsv(e)[2] : t;
      if (o = Math.round(o / 50), 0 === o) return 30;
      let a = 30 + (Math.round(u / 255) << 2 | Math.round(r / 255) << 1 | Math.round(n / 255));
      return 2 === o && (a += 60), a;
    }, Ou.hsv.ansi16 = function (e) {
      return Ou.rgb.ansi16(Ou.hsv.rgb(e), e[2]);
    }, Ou.rgb.ansi256 = function (e) {
      const t = e[0],
        n = e[1],
        r = e[2];
      if (t === n && n === r) return t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232;
      return 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
    }, Ou.ansi16.rgb = function (e) {
      let t = e % 10;
      if (0 === t || 7 === t) return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
      const n = .5 * (1 + ~~(e > 50));
      return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
    }, Ou.ansi256.rgb = function (e) {
      if (e >= 232) {
        const _t20 = 10 * (e - 232) + 8;
        return [_t20, _t20, _t20];
      }
      let t;
      e -= 16;
      return [Math.floor(e / 36) / 5 * 255, Math.floor((t = e % 36) / 6) / 5 * 255, t % 6 / 5 * 255];
    }, Ou.rgb.hex = function (e) {
      const t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
      return "000000".substring(t.length) + t;
    }, Ou.hex.rgb = function (e) {
      const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
      if (!t) return [0, 0, 0];
      let n = t[0];
      3 === t[0].length && (n = n.split("").map(e => e + e).join(""));
      const r = parseInt(n, 16);
      return [r >> 16 & 255, r >> 8 & 255, 255 & r];
    }, Ou.rgb.hcg = function (e) {
      const t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        u = Math.max(Math.max(t, n), r),
        o = Math.min(Math.min(t, n), r),
        a = u - o;
      let i, s;
      return i = a < 1 ? o / (1 - a) : 0, s = a <= 0 ? 0 : u === t ? (n - r) / a % 6 : u === n ? 2 + (r - t) / a : 4 + (t - n) / a, s /= 6, s %= 1, [360 * s, 100 * a, 100 * i];
    }, Ou.hsl.hcg = function (e) {
      const t = e[1] / 100,
        n = e[2] / 100,
        r = n < .5 ? 2 * t * n : 2 * t * (1 - n);
      let u = 0;
      return r < 1 && (u = (n - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * u];
    }, Ou.hsv.hcg = function (e) {
      const t = e[1] / 100,
        n = e[2] / 100,
        r = t * n;
      let u = 0;
      return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
    }, Ou.hcg.rgb = function (e) {
      const t = e[0] / 360,
        n = e[1] / 100,
        r = e[2] / 100;
      if (0 === n) return [255 * r, 255 * r, 255 * r];
      const u = [0, 0, 0],
        o = t % 1 * 6,
        a = o % 1,
        i = 1 - a;
      let s = 0;
      switch (Math.floor(o)) {
        case 0:
          u[0] = 1, u[1] = a, u[2] = 0;
          break;
        case 1:
          u[0] = i, u[1] = 1, u[2] = 0;
          break;
        case 2:
          u[0] = 0, u[1] = 1, u[2] = a;
          break;
        case 3:
          u[0] = 0, u[1] = i, u[2] = 1;
          break;
        case 4:
          u[0] = a, u[1] = 0, u[2] = 1;
          break;
        default:
          u[0] = 1, u[1] = 0, u[2] = i;
      }
      return s = (1 - n) * r, [255 * (n * u[0] + s), 255 * (n * u[1] + s), 255 * (n * u[2] + s)];
    }, Ou.hcg.hsv = function (e) {
      const t = e[1] / 100,
        n = t + e[2] / 100 * (1 - t);
      let r = 0;
      return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
    }, Ou.hcg.hsl = function (e) {
      const t = e[1] / 100,
        n = e[2] / 100 * (1 - t) + .5 * t;
      let r = 0;
      return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), [e[0], 100 * r, 100 * n];
    }, Ou.hcg.hwb = function (e) {
      const t = e[1] / 100,
        n = t + e[2] / 100 * (1 - t);
      return [e[0], 100 * (n - t), 100 * (1 - n)];
    }, Ou.hwb.hcg = function (e) {
      const t = e[1] / 100,
        n = 1 - e[2] / 100,
        r = n - t;
      let u = 0;
      return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
    }, Ou.apple.rgb = function (e) {
      return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
    }, Ou.rgb.apple = function (e) {
      return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
    }, Ou.gray.rgb = function (e) {
      return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
    }, Ou.gray.hsl = function (e) {
      return [0, 0, e[0]];
    }, Ou.gray.hsv = Ou.gray.hsl, Ou.gray.hwb = function (e) {
      return [0, 100, e[0]];
    }, Ou.gray.cmyk = function (e) {
      return [0, 0, 0, e[0]];
    }, Ou.gray.lab = function (e) {
      return [e[0], 0, 0];
    }, Ou.gray.hex = function (e) {
      const t = 255 & Math.round(e[0] / 100 * 255),
        n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
      return "000000".substring(n.length) + n;
    }, Ou.rgb.gray = function (e) {
      return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
    };
    const Mu = {};
    Object.keys(Pu).forEach(e => {
      Mu[e] = {}, Object.defineProperty(Mu[e], "channels", {
        value: Pu[e].channels
      }), Object.defineProperty(Mu[e], "labels", {
        value: Pu[e].labels
      });
      const t = function (e) {
        const t = _u(e),
          n = {},
          r = Object.keys(t);
        for (let _e45 = r.length, u = 0; u < _e45; u++) {
          const _e46 = r[u];
          null !== t[_e46].parent && (n[_e46] = ju(_e46, t));
        }
        return n;
      }(e);
      Object.keys(t).forEach(n => {
        const r = t[n];
        Mu[e][n] = function (e) {
          const t = function (...t) {
            const n = t[0];
            if (null == n) return n;
            n.length > 1 && (t = n);
            const r = e(t);
            if ("object" == typeof r) for (let e = r.length, _t21 = 0; _t21 < e; _t21++) r[_t21] = Math.round(r[_t21]);
            return r;
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r), Mu[e][n].raw = function (e) {
          const t = function (...t) {
            const n = t[0];
            return null == n ? n : (n.length > 1 && (t = n), e(t));
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r);
      });
    });
    var Lu = Mu,
      Ru = $e(function (e) {
        const t = (e, t) => (...n) => {
            const r = e(...n);
            return "[".concat(r + t, "m");
          },
          n = (e, t) => (...n) => {
            const r = e(...n);
            return "[".concat(38 + t, ";5;").concat(r, "m");
          },
          r = (e, t) => (...n) => {
            const r = e(...n);
            return "[".concat(38 + t, ";2;").concat(r[0], ";").concat(r[1], ";").concat(r[2], "m");
          },
          u = e => e,
          o = (e, t, n) => [e, t, n],
          a = (e, t, n) => {
            Object.defineProperty(e, t, {
              get: () => {
                const r = n();
                return Object.defineProperty(e, t, {
                  value: r,
                  enumerable: !0,
                  configurable: !0
                }), r;
              },
              enumerable: !0,
              configurable: !0
            });
          };
        let i;
        const s = (e, t, n, r) => {
          void 0 === i && (i = Lu);
          const u = r ? 10 : 0,
            o = {};
          for (const [_r9, a] of Object.entries(i)) {
            const i = "ansi16" === _r9 ? "ansi" : _r9;
            _r9 === t ? o[i] = e(n, u) : "object" == typeof a && (o[i] = e(a[t], u));
          }
          return o;
        };
        Object.defineProperty(e, "exports", {
          enumerable: !0,
          get: function () {
            const e = new Map(),
              i = {
                modifier: {
                  reset: [0, 0],
                  bold: [1, 22],
                  dim: [2, 22],
                  italic: [3, 23],
                  underline: [4, 24],
                  inverse: [7, 27],
                  hidden: [8, 28],
                  strikethrough: [9, 29]
                },
                color: {
                  black: [30, 39],
                  red: [31, 39],
                  green: [32, 39],
                  yellow: [33, 39],
                  blue: [34, 39],
                  magenta: [35, 39],
                  cyan: [36, 39],
                  white: [37, 39],
                  blackBright: [90, 39],
                  redBright: [91, 39],
                  greenBright: [92, 39],
                  yellowBright: [93, 39],
                  blueBright: [94, 39],
                  magentaBright: [95, 39],
                  cyanBright: [96, 39],
                  whiteBright: [97, 39]
                },
                bgColor: {
                  bgBlack: [40, 49],
                  bgRed: [41, 49],
                  bgGreen: [42, 49],
                  bgYellow: [43, 49],
                  bgBlue: [44, 49],
                  bgMagenta: [45, 49],
                  bgCyan: [46, 49],
                  bgWhite: [47, 49],
                  bgBlackBright: [100, 49],
                  bgRedBright: [101, 49],
                  bgGreenBright: [102, 49],
                  bgYellowBright: [103, 49],
                  bgBlueBright: [104, 49],
                  bgMagentaBright: [105, 49],
                  bgCyanBright: [106, 49],
                  bgWhiteBright: [107, 49]
                }
              };
            i.color.gray = i.color.blackBright, i.bgColor.bgGray = i.bgColor.bgBlackBright, i.color.grey = i.color.blackBright, i.bgColor.bgGrey = i.bgColor.bgBlackBright;
            for (const [t, n] of Object.entries(i)) {
              for (const [_t22, r] of Object.entries(n)) i[_t22] = {
                open: "[".concat(r[0], "m"),
                close: "[".concat(r[1], "m")
              }, n[_t22] = i[_t22], e.set(r[0], r[1]);
              Object.defineProperty(i, t, {
                value: n,
                enumerable: !1
              });
            }
            return Object.defineProperty(i, "codes", {
              value: e,
              enumerable: !1
            }), i.color.close = "[39m", i.bgColor.close = "[49m", a(i.color, "ansi", () => s(t, "ansi16", u, !1)), a(i.color, "ansi256", () => s(n, "ansi256", u, !1)), a(i.color, "ansi16m", () => s(r, "rgb", o, !1)), a(i.bgColor, "ansi", () => s(t, "ansi16", u, !0)), a(i.bgColor, "ansi256", () => s(n, "ansi256", u, !0)), a(i.bgColor, "ansi16m", () => s(r, "rgb", o, !0)), i;
          }
        });
      }),
      qu = {
        isatty: () => !1
      },
      Vu = (e, t = Re.argv) => {
        const n = e.startsWith("-") ? "" : 1 === e.length ? "-" : "--",
          r = t.indexOf(n + e),
          u = t.indexOf("--");
        return -1 !== r && (-1 === u || r < u);
      };
    const {
      env: Wu
    } = Re;
    let $u;
    function Uu(e) {
      return 0 !== e && {
        level: e,
        hasBasic: !0,
        has256: e >= 2,
        has16m: e >= 3
      };
    }
    function zu(e, t) {
      if (0 === $u) return 0;
      if (Vu("color=16m") || Vu("color=full") || Vu("color=truecolor")) return 3;
      if (Vu("color=256")) return 2;
      if (e && !t && void 0 === $u) return 0;
      const n = $u || 0;
      if ("dumb" === Wu.TERM) return n;
      if ("win32" === Re.platform) {
        const _e47 = Rr.release().split(".");
        return Number(_e47[0]) >= 10 && Number(_e47[2]) >= 10586 ? Number(_e47[2]) >= 14931 ? 3 : 2 : 1;
      }
      if ("CI" in Wu) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(e => e in Wu) || "codeship" === Wu.CI_NAME ? 1 : n;
      if ("TEAMCITY_VERSION" in Wu) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(Wu.TEAMCITY_VERSION) ? 1 : 0;
      if ("GITHUB_ACTIONS" in Wu) return 1;
      if ("truecolor" === Wu.COLORTERM) return 3;
      if ("TERM_PROGRAM" in Wu) {
        const _e48 = parseInt((Wu.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
        switch (Wu.TERM_PROGRAM) {
          case "iTerm.app":
            return _e48 >= 3 ? 3 : 2;
          case "Apple_Terminal":
            return 2;
        }
      }
      return /-256(color)?$/i.test(Wu.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(Wu.TERM) || "COLORTERM" in Wu ? 1 : n;
    }
    Vu("no-color") || Vu("no-colors") || Vu("color=false") || Vu("color=never") ? $u = 0 : (Vu("color") || Vu("colors") || Vu("color=true") || Vu("color=always")) && ($u = 1), "FORCE_COLOR" in Wu && ($u = "true" === Wu.FORCE_COLOR ? 1 : "false" === Wu.FORCE_COLOR ? 0 : 0 === Wu.FORCE_COLOR.length ? 1 : Math.min(parseInt(Wu.FORCE_COLOR, 10), 3));
    var Ju = {
      supportsColor: function (e) {
        return Uu(zu(e, e && e.isTTY));
      },
      stdout: Uu(zu(!0, qu.isatty(1))),
      stderr: Uu(zu(!0, qu.isatty(2)))
    };
    var Gu = {
      stringReplaceAll: (e, t, n) => {
        let r = e.indexOf(t);
        if (-1 === r) return e;
        const u = t.length;
        let o = 0,
          a = "";
        do {
          a += e.substr(o, r - o) + t + n, o = r + u, r = e.indexOf(t, o);
        } while (-1 !== r);
        return a += e.substr(o), a;
      },
      stringEncaseCRLFWithFirstIndex: (e, t, n, r) => {
        let u = 0,
          o = "";
        do {
          const a = "\r" === e[r - 1];
          o += e.substr(u, (a ? r - 1 : r) - u) + t + (a ? "\r\n" : "\n") + n, u = r + 1, r = e.indexOf("\n", u);
        } while (-1 !== r);
        return o += e.substr(u), o;
      }
    };
    const Hu = /(?:\\(u(?:[a-f\d]{4}|\{[a-f\d]{1,6}\})|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
      Xu = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
      Yu = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
      Ku = /\\(u(?:[a-f\d]{4}|{[a-f\d]{1,6}})|x[a-f\d]{2}|.)|([^\\])/gi,
      Qu = new Map([["n", "\n"], ["r", "\r"], ["t", "\t"], ["b", "\b"], ["f", "\f"], ["v", "\v"], ["0", "\0"], ["\\", "\\"], ["e", ""], ["a", ""]]);
    function Zu(e) {
      const t = "u" === e[0],
        n = "{" === e[1];
      return t && !n && 5 === e.length || "x" === e[0] && 3 === e.length ? String.fromCharCode(parseInt(e.slice(1), 16)) : t && n ? String.fromCodePoint(parseInt(e.slice(2, -1), 16)) : Qu.get(e) || e;
    }
    function eo(e, t) {
      const n = [],
        r = t.trim().split(/\s*,\s*/g);
      let u;
      for (const _t23 of r) {
        const _r10 = Number(_t23);
        if (Number.isNaN(_r10)) {
          if (!(u = _t23.match(Yu))) throw new Error("Invalid Chalk template style argument: ".concat(_t23, " (in style '").concat(e, "')"));
          n.push(u[2].replace(Ku, (e, t, n) => t ? Zu(t) : n));
        } else n.push(_r10);
      }
      return n;
    }
    function to(e) {
      Xu.lastIndex = 0;
      const t = [];
      let n;
      for (; null !== (n = Xu.exec(e));) {
        const _e49 = n[1];
        if (n[2]) {
          const r = eo(_e49, n[2]);
          t.push([_e49].concat(r));
        } else t.push([_e49]);
      }
      return t;
    }
    function no(e, t) {
      const n = {};
      for (const _e50 of t) for (const _t24 of _e50.styles) n[_t24[0]] = _e50.inverse ? null : _t24.slice(1);
      let r = e;
      for (const [_e51, _t25] of Object.entries(n)) if (Array.isArray(_t25)) {
        if (!(_e51 in r)) throw new Error("Unknown Chalk style: ".concat(_e51));
        r = _t25.length > 0 ? r[_e51](..._t25) : r[_e51];
      }
      return r;
    }
    var ro = (e, t) => {
      const n = [],
        r = [];
      let u = [];
      if (t.replace(Hu, (t, o, a, i, s, l) => {
        if (o) u.push(Zu(o));else if (i) {
          const _t26 = u.join("");
          u = [], r.push(0 === n.length ? _t26 : no(e, n)(_t26)), n.push({
            inverse: a,
            styles: to(i)
          });
        } else if (s) {
          if (0 === n.length) throw new Error("Found extraneous } in Chalk template literal");
          r.push(no(e, n)(u.join(""))), u = [], n.pop();
        } else u.push(l);
      }), r.push(u.join("")), n.length > 0) {
        const _e52 = "Chalk template literal is missing ".concat(n.length, " closing bracket").concat(1 === n.length ? "" : "s", " (`}`)");
        throw new Error(_e52);
      }
      return r.join("");
    };
    const {
        stdout: uo,
        stderr: oo
      } = Ju,
      {
        stringReplaceAll: ao,
        stringEncaseCRLFWithFirstIndex: io
      } = Gu,
      {
        isArray: so
      } = Array,
      lo = ["ansi", "ansi", "ansi256", "ansi16m"],
      co = Object.create(null);
    class po {
      constructor(e) {
        return fo(e);
      }
    }
    const fo = e => {
      const t = {};
      return ((e, t = {}) => {
        if (t.level && !(Number.isInteger(t.level) && t.level >= 0 && t.level <= 3)) throw new Error("The `level` option should be an integer from 0 to 3");
        const n = uo ? uo.level : 0;
        e.level = void 0 === t.level ? n : t.level;
      })(t, e), t.template = (...e) => bo(t.template, ...e), Object.setPrototypeOf(t, ho.prototype), Object.setPrototypeOf(t.template, t), t.template.constructor = () => {
        throw new Error("`chalk.constructor()` is deprecated. Use `new chalk.Instance()` instead.");
      }, t.template.Instance = po, t.template;
    };
    function ho(e) {
      return fo(e);
    }
    for (const [_e53, _t27] of Object.entries(Ru)) co[_e53] = {
      get() {
        const n = yo(this, Do(_t27.open, _t27.close, this._styler), this._isEmpty);
        return Object.defineProperty(this, _e53, {
          value: n
        }), n;
      }
    };
    co.visible = {
      get() {
        const e = yo(this, this._styler, !0);
        return Object.defineProperty(this, "visible", {
          value: e
        }), e;
      }
    };
    const mo = ["rgb", "hex", "keyword", "hsl", "hsv", "hwb", "ansi", "ansi256"];
    for (const _e54 of mo) co[_e54] = {
      get() {
        const {
          level: t
        } = this;
        return function (...n) {
          const r = Do(Ru.color[lo[t]][_e54](...n), Ru.color.close, this._styler);
          return yo(this, r, this._isEmpty);
        };
      }
    };
    for (const _e55 of mo) {
      co["bg" + _e55[0].toUpperCase() + _e55.slice(1)] = {
        get() {
          const {
            level: t
          } = this;
          return function (...n) {
            const r = Do(Ru.bgColor[lo[t]][_e55](...n), Ru.bgColor.close, this._styler);
            return yo(this, r, this._isEmpty);
          };
        }
      };
    }
    const go = Object.defineProperties(() => {}, Object.assign({}, co, {
        level: {
          enumerable: !0,
          get() {
            return this._generator.level;
          },
          set(e) {
            this._generator.level = e;
          }
        }
      })),
      Do = (e, t, n) => {
        let r, u;
        return void 0 === n ? (r = e, u = t) : (r = n.openAll + e, u = t + n.closeAll), {
          open: e,
          close: t,
          openAll: r,
          closeAll: u,
          parent: n
        };
      },
      yo = (e, t, n) => {
        const r = (...e) => so(e[0]) && so(e[0].raw) ? Eo(r, bo(r, ...e)) : Eo(r, 1 === e.length ? "" + e[0] : e.join(" "));
        return Object.setPrototypeOf(r, go), r._generator = e, r._styler = t, r._isEmpty = n, r;
      },
      Eo = (e, t) => {
        if (e.level <= 0 || !t) return e._isEmpty ? "" : t;
        let n = e._styler;
        if (void 0 === n) return t;
        const {
          openAll: r,
          closeAll: u
        } = n;
        if (-1 !== t.indexOf("")) for (; void 0 !== n;) t = ao(t, n.close, n.open), n = n.parent;
        const o = t.indexOf("\n");
        return -1 !== o && (t = io(t, u, r, o)), r + t + u;
      };
    let Co;
    const bo = (e, ...t) => {
      const [n] = t;
      if (!so(n) || !so(n.raw)) return t.join(" ");
      const r = t.slice(1),
        u = [n.raw[0]];
      for (let _e56 = 1; _e56 < n.length; _e56++) u.push(String(r[_e56 - 1]).replace(/[{}\\]/g, "\\$&"), String(n.raw[_e56]));
      return void 0 === Co && (Co = ro), Co(e, u.join(""));
    };
    Object.defineProperties(ho.prototype, co);
    const Ao = ho();
    Ao.supportsColor = uo, Ao.stderr = ho({
      level: oo ? oo.level : 0
    }), Ao.stderr.supportsColor = oo;
    var vo = Ao;
    var Fo = function (e, t) {
        for (var n = -1, r = t.length, u = e.length; ++n < r;) e[u + n] = t[n];
        return e;
      },
      xo = "object" == typeof We && We && We.Object === Object && We,
      So = "object" == typeof self && self && self.Object === Object && self,
      wo = (xo || So || Function("return this")()).Symbol,
      Bo = Object.prototype,
      To = Bo.hasOwnProperty,
      ko = Bo.toString,
      No = wo ? wo.toStringTag : void 0;
    var Oo = function (e) {
        var t = To.call(e, No),
          n = e[No];
        try {
          e[No] = void 0;
          var r = !0;
        } catch (e) {}
        var u = ko.call(e);
        return r && (t ? e[No] = n : delete e[No]), u;
      },
      Po = Object.prototype.toString;
    var _o = function (e) {
        return Po.call(e);
      },
      Io = wo ? wo.toStringTag : void 0;
    var jo = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Io && Io in Object(e) ? Oo(e) : _o(e);
    };
    var Mo = function (e) {
      return null != e && "object" == typeof e;
    };
    var Lo = function (e) {
        return Mo(e) && "[object Arguments]" == jo(e);
      },
      Ro = Object.prototype,
      qo = Ro.hasOwnProperty,
      Vo = Ro.propertyIsEnumerable,
      Wo = Lo(function () {
        return arguments;
      }()) ? Lo : function (e) {
        return Mo(e) && qo.call(e, "callee") && !Vo.call(e, "callee");
      },
      $o = Array.isArray,
      Uo = wo ? wo.isConcatSpreadable : void 0;
    var zo = function (e) {
      return $o(e) || Wo(e) || !!(Uo && e && e[Uo]);
    };
    var Jo = function e(t, n, r, u, o) {
      var a = -1,
        i = t.length;
      for (r || (r = zo), o || (o = []); ++a < i;) {
        var s = t[a];
        n > 0 && r(s) ? n > 1 ? e(s, n - 1, r, u, o) : Fo(o, s) : u || (o[o.length] = s);
      }
      return o;
    };
    var Go = function (e) {
      return (null == e ? 0 : e.length) ? Jo(e, 1) : [];
    };
    const Ho = {
      key: e => 1 === e.length ? "-".concat(e) : "--".concat(e),
      value: e => Fu.apiDescriptor.value(e),
      pair: ({
        key: e,
        value: t
      }) => !1 === t ? "--no-".concat(e) : !0 === t ? Ho.key(e) : "" === t ? "".concat(Ho.key(e), " without an argument") : "".concat(Ho.key(e), "=").concat(t)
    };
    class Xo extends Fu.ChoiceSchema {
      constructor({
        name: e,
        flags: t
      }) {
        super({
          name: e,
          choices: t
        }), this._flags = t.slice().sort();
      }
      preprocess(e, t) {
        if ("string" == typeof e && 0 !== e.length && !this._flags.includes(e)) {
          const n = this._flags.find(t => Bu(t, e) < 3);
          if (n) return t.logger.warn(["Unknown flag ".concat(vo.yellow(t.descriptor.value(e)), ","), "did you mean ".concat(vo.blue(t.descriptor.value(n)), "?")].join(" ")), n;
        }
        return e;
      }
      expected() {
        return "a flag";
      }
    }
    let Yo;
    function Ko(t, n, {
      logger: r,
      isCLI: u = !1,
      passThrough: o = !1
    } = {}) {
      const a = o ? Array.isArray(o) ? (e, t) => o.includes(e) ? {
          [e]: t
        } : void 0 : (e, t) => ({
          [e]: t
        }) : (t, n, r) => {
          const u = e(r.schemas, ["_"]);
          return Fu.levenUnknownHandler(t, n, Object.assign({}, r, {
            schemas: u
          }));
        },
        i = u ? Ho : Fu.apiDescriptor,
        s = function (e, {
          isCLI: t
        }) {
          const n = [];
          t && n.push(Fu.AnySchema.create({
            name: "_"
          }));
          for (const r of e) n.push(Qo(r, {
            isCLI: t,
            optionInfos: e
          })), r.alias && t && n.push(Fu.AliasSchema.create({
            name: r.alias,
            sourceName: r.name
          }));
          return n;
        }(n, {
          isCLI: u
        }),
        l = new Fu.Normalizer(s, {
          logger: r,
          unknown: a,
          descriptor: i
        }),
        c = !1 !== r;
      c && Yo && (l._hasDeprecationWarned = Yo);
      const p = l.normalize(t);
      return c && (Yo = l._hasDeprecationWarned), p;
    }
    function Qo(e, {
      isCLI: t,
      optionInfos: n
    }) {
      let r;
      const u = {
          name: e.name
        },
        o = {};
      switch (e.type) {
        case "int":
          r = Fu.IntegerSchema, t && (u.preprocess = e => Number(e));
          break;
        case "string":
          r = Fu.StringSchema;
          break;
        case "choice":
          r = Fu.ChoiceSchema, u.choices = e.choices.map(t => "object" == typeof t && t.redirect ? Object.assign({}, t, {
            redirect: {
              to: {
                key: e.name,
                value: t.redirect
              }
            }
          }) : t);
          break;
        case "boolean":
          r = Fu.BooleanSchema;
          break;
        case "flag":
          r = Xo, u.flags = Go(n.map(e => [e.alias, e.description && e.name, e.oppositeDescription && "no-".concat(e.name)].filter(Boolean)));
          break;
        case "path":
          r = Fu.StringSchema;
          break;
        default:
          throw new Error("Unexpected type ".concat(e.type));
      }
      if (e.exception ? u.validate = (t, n, r) => e.exception(t) || n.validate(t, r) : u.validate = (e, t, n) => void 0 === e || t.validate(e, n), e.redirect && (o.redirect = t => t ? {
        to: {
          key: e.redirect.option,
          value: e.redirect.value
        }
      } : void 0), e.deprecated && (o.deprecated = !0), t && !e.array) {
        const _e57 = u.preprocess || (e => e);
        u.preprocess = (t, n, r) => n.preprocess(_e57(Array.isArray(t) ? t[t.length - 1] : t), r);
      }
      return e.array ? Fu.ArraySchema.create(Object.assign({}, t ? {
        preprocess: e => [].concat(e)
      } : {}, o, {
        valueSchema: r.create(u)
      })) : r.create(Object.assign({}, u, o));
    }
    var Zo = {
      normalizeApiOptions: function (e, t, n) {
        return Ko(e, t, n);
      },
      normalizeCliOptions: function (e, t, n) {
        return Ko(e, t, Object.assign({
          isCLI: !0
        }, n));
      }
    };
    function ea(e, t) {
      const {
        ignoreDecorators: n
      } = t || {};
      if (!n) {
        const _t28 = e.declaration && e.declaration.decorators || e.decorators;
        if (_t28 && _t28.length > 0) return ea(_t28[0]);
      }
      return e.range ? e.range[0] : e.start;
    }
    function ta(e) {
      const t = e.range ? e.range[1] : e.end;
      return e.typeAnnotation ? Math.max(t, ta(e.typeAnnotation)) : t;
    }
    var na = {
        locStart: ea,
        locEnd: ta,
        composeLoc: function (e, t = e) {
          const n = ea(e);
          return [n, "number" == typeof t ? n + t : ta(t)];
        }
      },
      ra = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g, t.matchToToken = function (e) {
          var t = {
            type: "invalid",
            value: e[0],
            closed: void 0
          };
          return e[1] ? (t.type = "string", t.closed = !(!e[3] && !e[4])) : e[5] ? t.type = "comment" : e[6] ? (t.type = "comment", t.closed = !!e[7]) : e[8] ? t.type = "regex" : e[9] ? t.type = "number" : e[10] ? t.type = "name" : e[11] ? t.type = "punctuator" : e[12] && (t.type = "whitespace"), t;
        };
      }),
      ua = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isIdentifierStart = l, t.isIdentifierChar = c, t.isIdentifierName = function (e) {
          let t = !0;
          for (let n = 0, r = Array.from(e); n < r.length; n++) {
            const _e58 = r[n].codePointAt(0);
            if (t) {
              if (!l(_e58)) return !1;
              t = !1;
            } else if (!c(_e58)) return !1;
          }
          return !t;
        };
        let n = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࣇऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-鿼ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-ꟊꟵ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
          r = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࣓-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠐-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿᫀᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷹᷻-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿";
        const u = new RegExp("[" + n + "]"),
          o = new RegExp("[" + n + r + "]");
        n = r = null;
        const a = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 107, 20, 28, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8952, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42717, 35, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938],
          i = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
        function s(e, t) {
          let n = 65536;
          for (let r = 0, u = t.length; r < u; r += 2) {
            if (n += t[r], n > e) return !1;
            if (n += t[r + 1], n >= e) return !0;
          }
          return !1;
        }
        function l(e) {
          return e < 65 ? 36 === e : e <= 90 || (e < 97 ? 95 === e : e <= 122 || (e <= 65535 ? e >= 170 && u.test(String.fromCharCode(e)) : s(e, a)));
        }
        function c(e) {
          return e < 48 ? 36 === e : e < 58 || !(e < 65) && (e <= 90 || (e < 97 ? 95 === e : e <= 122 || (e <= 65535 ? e >= 170 && o.test(String.fromCharCode(e)) : s(e, a) || s(e, i))));
        }
      }),
      oa = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isReservedWord = i, t.isStrictReservedWord = s, t.isStrictBindOnlyReservedWord = l, t.isStrictBindReservedWord = function (e, t) {
          return s(e, t) || l(e);
        }, t.isKeyword = function (e) {
          return u.has(e);
        };
        const n = ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
          r = ["eval", "arguments"],
          u = new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"]),
          o = new Set(n),
          a = new Set(r);
        function i(e, t) {
          return t && "await" === e || "enum" === e;
        }
        function s(e, t) {
          return i(e, t) || o.has(e);
        }
        function l(e) {
          return a.has(e);
        }
      }),
      aa = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "isIdentifierName", {
          enumerable: !0,
          get: function () {
            return ua.isIdentifierName;
          }
        }), Object.defineProperty(t, "isIdentifierChar", {
          enumerable: !0,
          get: function () {
            return ua.isIdentifierChar;
          }
        }), Object.defineProperty(t, "isIdentifierStart", {
          enumerable: !0,
          get: function () {
            return ua.isIdentifierStart;
          }
        }), Object.defineProperty(t, "isReservedWord", {
          enumerable: !0,
          get: function () {
            return oa.isReservedWord;
          }
        }), Object.defineProperty(t, "isStrictBindOnlyReservedWord", {
          enumerable: !0,
          get: function () {
            return oa.isStrictBindOnlyReservedWord;
          }
        }), Object.defineProperty(t, "isStrictBindReservedWord", {
          enumerable: !0,
          get: function () {
            return oa.isStrictBindReservedWord;
          }
        }), Object.defineProperty(t, "isStrictReservedWord", {
          enumerable: !0,
          get: function () {
            return oa.isStrictReservedWord;
          }
        }), Object.defineProperty(t, "isKeyword", {
          enumerable: !0,
          get: function () {
            return oa.isKeyword;
          }
        });
      }),
      ia = /[|\\{}()[\]^$+*?.]/g,
      sa = function (e) {
        if ("string" != typeof e) throw new TypeError("Expected a string");
        return e.replace(ia, "\\$&");
      },
      la = {
        aliceblue: [240, 248, 255],
        antiquewhite: [250, 235, 215],
        aqua: [0, 255, 255],
        aquamarine: [127, 255, 212],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        bisque: [255, 228, 196],
        black: [0, 0, 0],
        blanchedalmond: [255, 235, 205],
        blue: [0, 0, 255],
        blueviolet: [138, 43, 226],
        brown: [165, 42, 42],
        burlywood: [222, 184, 135],
        cadetblue: [95, 158, 160],
        chartreuse: [127, 255, 0],
        chocolate: [210, 105, 30],
        coral: [255, 127, 80],
        cornflowerblue: [100, 149, 237],
        cornsilk: [255, 248, 220],
        crimson: [220, 20, 60],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgoldenrod: [184, 134, 11],
        darkgray: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkgrey: [169, 169, 169],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkseagreen: [143, 188, 143],
        darkslateblue: [72, 61, 139],
        darkslategray: [47, 79, 79],
        darkslategrey: [47, 79, 79],
        darkturquoise: [0, 206, 209],
        darkviolet: [148, 0, 211],
        deeppink: [255, 20, 147],
        deepskyblue: [0, 191, 255],
        dimgray: [105, 105, 105],
        dimgrey: [105, 105, 105],
        dodgerblue: [30, 144, 255],
        firebrick: [178, 34, 34],
        floralwhite: [255, 250, 240],
        forestgreen: [34, 139, 34],
        fuchsia: [255, 0, 255],
        gainsboro: [220, 220, 220],
        ghostwhite: [248, 248, 255],
        gold: [255, 215, 0],
        goldenrod: [218, 165, 32],
        gray: [128, 128, 128],
        green: [0, 128, 0],
        greenyellow: [173, 255, 47],
        grey: [128, 128, 128],
        honeydew: [240, 255, 240],
        hotpink: [255, 105, 180],
        indianred: [205, 92, 92],
        indigo: [75, 0, 130],
        ivory: [255, 255, 240],
        khaki: [240, 230, 140],
        lavender: [230, 230, 250],
        lavenderblush: [255, 240, 245],
        lawngreen: [124, 252, 0],
        lemonchiffon: [255, 250, 205],
        lightblue: [173, 216, 230],
        lightcoral: [240, 128, 128],
        lightcyan: [224, 255, 255],
        lightgoldenrodyellow: [250, 250, 210],
        lightgray: [211, 211, 211],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightsalmon: [255, 160, 122],
        lightseagreen: [32, 178, 170],
        lightskyblue: [135, 206, 250],
        lightslategray: [119, 136, 153],
        lightslategrey: [119, 136, 153],
        lightsteelblue: [176, 196, 222],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        limegreen: [50, 205, 50],
        linen: [250, 240, 230],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        mediumaquamarine: [102, 205, 170],
        mediumblue: [0, 0, 205],
        mediumorchid: [186, 85, 211],
        mediumpurple: [147, 112, 219],
        mediumseagreen: [60, 179, 113],
        mediumslateblue: [123, 104, 238],
        mediumspringgreen: [0, 250, 154],
        mediumturquoise: [72, 209, 204],
        mediumvioletred: [199, 21, 133],
        midnightblue: [25, 25, 112],
        mintcream: [245, 255, 250],
        mistyrose: [255, 228, 225],
        moccasin: [255, 228, 181],
        navajowhite: [255, 222, 173],
        navy: [0, 0, 128],
        oldlace: [253, 245, 230],
        olive: [128, 128, 0],
        olivedrab: [107, 142, 35],
        orange: [255, 165, 0],
        orangered: [255, 69, 0],
        orchid: [218, 112, 214],
        palegoldenrod: [238, 232, 170],
        palegreen: [152, 251, 152],
        paleturquoise: [175, 238, 238],
        palevioletred: [219, 112, 147],
        papayawhip: [255, 239, 213],
        peachpuff: [255, 218, 185],
        peru: [205, 133, 63],
        pink: [255, 192, 203],
        plum: [221, 160, 221],
        powderblue: [176, 224, 230],
        purple: [128, 0, 128],
        rebeccapurple: [102, 51, 153],
        red: [255, 0, 0],
        rosybrown: [188, 143, 143],
        royalblue: [65, 105, 225],
        saddlebrown: [139, 69, 19],
        salmon: [250, 128, 114],
        sandybrown: [244, 164, 96],
        seagreen: [46, 139, 87],
        seashell: [255, 245, 238],
        sienna: [160, 82, 45],
        silver: [192, 192, 192],
        skyblue: [135, 206, 235],
        slateblue: [106, 90, 205],
        slategray: [112, 128, 144],
        slategrey: [112, 128, 144],
        snow: [255, 250, 250],
        springgreen: [0, 255, 127],
        steelblue: [70, 130, 180],
        tan: [210, 180, 140],
        teal: [0, 128, 128],
        thistle: [216, 191, 216],
        tomato: [255, 99, 71],
        turquoise: [64, 224, 208],
        violet: [238, 130, 238],
        wheat: [245, 222, 179],
        white: [255, 255, 255],
        whitesmoke: [245, 245, 245],
        yellow: [255, 255, 0],
        yellowgreen: [154, 205, 50]
      },
      ca = $e(function (e) {
        var t = {};
        for (var n in la) la.hasOwnProperty(n) && (t[la[n]] = n);
        var r = e.exports = {
          rgb: {
            channels: 3,
            labels: "rgb"
          },
          hsl: {
            channels: 3,
            labels: "hsl"
          },
          hsv: {
            channels: 3,
            labels: "hsv"
          },
          hwb: {
            channels: 3,
            labels: "hwb"
          },
          cmyk: {
            channels: 4,
            labels: "cmyk"
          },
          xyz: {
            channels: 3,
            labels: "xyz"
          },
          lab: {
            channels: 3,
            labels: "lab"
          },
          lch: {
            channels: 3,
            labels: "lch"
          },
          hex: {
            channels: 1,
            labels: ["hex"]
          },
          keyword: {
            channels: 1,
            labels: ["keyword"]
          },
          ansi16: {
            channels: 1,
            labels: ["ansi16"]
          },
          ansi256: {
            channels: 1,
            labels: ["ansi256"]
          },
          hcg: {
            channels: 3,
            labels: ["h", "c", "g"]
          },
          apple: {
            channels: 3,
            labels: ["r16", "g16", "b16"]
          },
          gray: {
            channels: 1,
            labels: ["gray"]
          }
        };
        for (var u in r) if (r.hasOwnProperty(u)) {
          if (!("channels" in r[u])) throw new Error("missing channels property: " + u);
          if (!("labels" in r[u])) throw new Error("missing channel labels property: " + u);
          if (r[u].labels.length !== r[u].channels) throw new Error("channel and label counts mismatch: " + u);
          var o = r[u].channels,
            a = r[u].labels;
          delete r[u].channels, delete r[u].labels, Object.defineProperty(r[u], "channels", {
            value: o
          }), Object.defineProperty(r[u], "labels", {
            value: a
          });
        }
        r.rgb.hsl = function (e) {
          var t,
            n,
            r = e[0] / 255,
            u = e[1] / 255,
            o = e[2] / 255,
            a = Math.min(r, u, o),
            i = Math.max(r, u, o),
            s = i - a;
          return i === a ? t = 0 : r === i ? t = (u - o) / s : u === i ? t = 2 + (o - r) / s : o === i && (t = 4 + (r - u) / s), (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (a + i) / 2, [t, 100 * (i === a ? 0 : n <= .5 ? s / (i + a) : s / (2 - i - a)), 100 * n];
        }, r.rgb.hsv = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a = e[0] / 255,
            i = e[1] / 255,
            s = e[2] / 255,
            l = Math.max(a, i, s),
            c = l - Math.min(a, i, s),
            p = function (e) {
              return (l - e) / 6 / c + .5;
            };
          return 0 === c ? u = o = 0 : (o = c / l, t = p(a), n = p(i), r = p(s), a === l ? u = r - n : i === l ? u = 1 / 3 + t - r : s === l && (u = 2 / 3 + n - t), u < 0 ? u += 1 : u > 1 && (u -= 1)), [360 * u, 100 * o, 100 * l];
        }, r.rgb.hwb = function (e) {
          var t = e[0],
            n = e[1],
            u = e[2];
          return [r.rgb.hsl(e)[0], 100 * (1 / 255 * Math.min(t, Math.min(n, u))), 100 * (u = 1 - 1 / 255 * Math.max(t, Math.max(n, u)))];
        }, r.rgb.cmyk = function (e) {
          var t,
            n = e[0] / 255,
            r = e[1] / 255,
            u = e[2] / 255;
          return [100 * ((1 - n - (t = Math.min(1 - n, 1 - r, 1 - u))) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * ((1 - u - t) / (1 - t) || 0), 100 * t];
        }, r.rgb.keyword = function (e) {
          var n = t[e];
          if (n) return n;
          var r,
            u,
            o,
            a = 1 / 0;
          for (var i in la) if (la.hasOwnProperty(i)) {
            var s = la[i],
              l = (u = e, o = s, Math.pow(u[0] - o[0], 2) + Math.pow(u[1] - o[1], 2) + Math.pow(u[2] - o[2], 2));
            l < a && (a = l, r = i);
          }
          return r;
        }, r.keyword.rgb = function (e) {
          return la[e];
        }, r.rgb.xyz = function (e) {
          var t = e[0] / 255,
            n = e[1] / 255,
            r = e[2] / 255;
          return [100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r)];
        }, r.rgb.lab = function (e) {
          var t = r.rgb.xyz(e),
            n = t[0],
            u = t[1],
            o = t[2];
          return u /= 100, o /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, [116 * (u = u > .008856 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116) - 16, 500 * (n - u), 200 * (u - (o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116))];
        }, r.hsl.rgb = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a = e[0] / 360,
            i = e[1] / 100,
            s = e[2] / 100;
          if (0 === i) return [o = 255 * s, o, o];
          t = 2 * s - (n = s < .5 ? s * (1 + i) : s + i - s * i), u = [0, 0, 0];
          for (var l = 0; l < 3; l++) (r = a + 1 / 3 * -(l - 1)) < 0 && r++, r > 1 && r--, o = 6 * r < 1 ? t + 6 * (n - t) * r : 2 * r < 1 ? n : 3 * r < 2 ? t + (n - t) * (2 / 3 - r) * 6 : t, u[l] = 255 * o;
          return u;
        }, r.hsl.hsv = function (e) {
          var t = e[0],
            n = e[1] / 100,
            r = e[2] / 100,
            u = n,
            o = Math.max(r, .01);
          return n *= (r *= 2) <= 1 ? r : 2 - r, u *= o <= 1 ? o : 2 - o, [t, 100 * (0 === r ? 2 * u / (o + u) : 2 * n / (r + n)), 100 * ((r + n) / 2)];
        }, r.hsv.rgb = function (e) {
          var t = e[0] / 60,
            n = e[1] / 100,
            r = e[2] / 100,
            u = Math.floor(t) % 6,
            o = t - Math.floor(t),
            a = 255 * r * (1 - n),
            i = 255 * r * (1 - n * o),
            s = 255 * r * (1 - n * (1 - o));
          switch (r *= 255, u) {
            case 0:
              return [r, s, a];
            case 1:
              return [i, r, a];
            case 2:
              return [a, r, s];
            case 3:
              return [a, i, r];
            case 4:
              return [s, a, r];
            case 5:
              return [r, a, i];
          }
        }, r.hsv.hsl = function (e) {
          var t,
            n,
            r,
            u = e[0],
            o = e[1] / 100,
            a = e[2] / 100,
            i = Math.max(a, .01);
          return r = (2 - o) * a, n = o * i, [u, 100 * (n = (n /= (t = (2 - o) * i) <= 1 ? t : 2 - t) || 0), 100 * (r /= 2)];
        }, r.hwb.rgb = function (e) {
          var t,
            n,
            r,
            u,
            o,
            a,
            i,
            s = e[0] / 360,
            l = e[1] / 100,
            c = e[2] / 100,
            p = l + c;
          switch (p > 1 && (l /= p, c /= p), r = 6 * s - (t = Math.floor(6 * s)), 0 != (1 & t) && (r = 1 - r), u = l + r * ((n = 1 - c) - l), t) {
            default:
            case 6:
            case 0:
              o = n, a = u, i = l;
              break;
            case 1:
              o = u, a = n, i = l;
              break;
            case 2:
              o = l, a = n, i = u;
              break;
            case 3:
              o = l, a = u, i = n;
              break;
            case 4:
              o = u, a = l, i = n;
              break;
            case 5:
              o = n, a = l, i = u;
          }
          return [255 * o, 255 * a, 255 * i];
        }, r.cmyk.rgb = function (e) {
          var t = e[0] / 100,
            n = e[1] / 100,
            r = e[2] / 100,
            u = e[3] / 100;
          return [255 * (1 - Math.min(1, t * (1 - u) + u)), 255 * (1 - Math.min(1, n * (1 - u) + u)), 255 * (1 - Math.min(1, r * (1 - u) + u))];
        }, r.xyz.rgb = function (e) {
          var t,
            n,
            r,
            u = e[0] / 100,
            o = e[1] / 100,
            a = e[2] / 100;
          return n = -.9689 * u + 1.8758 * o + .0415 * a, r = .0557 * u + -.204 * o + 1.057 * a, t = (t = 3.2406 * u + -1.5372 * o + -.4986 * a) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [255 * (t = Math.min(Math.max(0, t), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (r = Math.min(Math.max(0, r), 1))];
        }, r.xyz.lab = function (e) {
          var t = e[0],
            n = e[1],
            r = e[2];
          return n /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))];
        }, r.lab.xyz = function (e) {
          var t,
            n,
            r,
            u = e[0];
          t = e[1] / 500 + (n = (u + 16) / 116), r = n - e[2] / 200;
          var o = Math.pow(n, 3),
            a = Math.pow(t, 3),
            i = Math.pow(r, 3);
          return n = o > .008856 ? o : (n - 16 / 116) / 7.787, t = a > .008856 ? a : (t - 16 / 116) / 7.787, r = i > .008856 ? i : (r - 16 / 116) / 7.787, [t *= 95.047, n *= 100, r *= 108.883];
        }, r.lab.lch = function (e) {
          var t,
            n = e[0],
            r = e[1],
            u = e[2];
          return (t = 360 * Math.atan2(u, r) / 2 / Math.PI) < 0 && (t += 360), [n, Math.sqrt(r * r + u * u), t];
        }, r.lch.lab = function (e) {
          var t,
            n = e[0],
            r = e[1];
          return t = e[2] / 360 * 2 * Math.PI, [n, r * Math.cos(t), r * Math.sin(t)];
        }, r.rgb.ansi16 = function (e) {
          var t = e[0],
            n = e[1],
            u = e[2],
            o = 1 in arguments ? arguments[1] : r.rgb.hsv(e)[2];
          if (0 === (o = Math.round(o / 50))) return 30;
          var a = 30 + (Math.round(u / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
          return 2 === o && (a += 60), a;
        }, r.hsv.ansi16 = function (e) {
          return r.rgb.ansi16(r.hsv.rgb(e), e[2]);
        }, r.rgb.ansi256 = function (e) {
          var t = e[0],
            n = e[1],
            r = e[2];
          return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
        }, r.ansi16.rgb = function (e) {
          var t = e % 10;
          if (0 === t || 7 === t) return e > 50 && (t += 3.5), [t = t / 10.5 * 255, t, t];
          var n = .5 * (1 + ~~(e > 50));
          return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
        }, r.ansi256.rgb = function (e) {
          if (e >= 232) {
            var t = 10 * (e - 232) + 8;
            return [t, t, t];
          }
          var n;
          return e -= 16, [Math.floor(e / 36) / 5 * 255, Math.floor((n = e % 36) / 6) / 5 * 255, n % 6 / 5 * 255];
        }, r.rgb.hex = function (e) {
          var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
          return "000000".substring(t.length) + t;
        }, r.hex.rgb = function (e) {
          var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!t) return [0, 0, 0];
          var n = t[0];
          3 === t[0].length && (n = n.split("").map(function (e) {
            return e + e;
          }).join(""));
          var r = parseInt(n, 16);
          return [r >> 16 & 255, r >> 8 & 255, 255 & r];
        }, r.rgb.hcg = function (e) {
          var t,
            n = e[0] / 255,
            r = e[1] / 255,
            u = e[2] / 255,
            o = Math.max(Math.max(n, r), u),
            a = Math.min(Math.min(n, r), u),
            i = o - a;
          return t = i <= 0 ? 0 : o === n ? (r - u) / i % 6 : o === r ? 2 + (u - n) / i : 4 + (n - r) / i + 4, t /= 6, [360 * (t %= 1), 100 * i, 100 * (i < 1 ? a / (1 - i) : 0)];
        }, r.hsl.hcg = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100,
            r = 1,
            u = 0;
          return (r = n < .5 ? 2 * t * n : 2 * t * (1 - n)) < 1 && (u = (n - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.hsv.hcg = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100,
            r = t * n,
            u = 0;
          return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.hcg.rgb = function (e) {
          var t = e[0] / 360,
            n = e[1] / 100,
            r = e[2] / 100;
          if (0 === n) return [255 * r, 255 * r, 255 * r];
          var u,
            o = [0, 0, 0],
            a = t % 1 * 6,
            i = a % 1,
            s = 1 - i;
          switch (Math.floor(a)) {
            case 0:
              o[0] = 1, o[1] = i, o[2] = 0;
              break;
            case 1:
              o[0] = s, o[1] = 1, o[2] = 0;
              break;
            case 2:
              o[0] = 0, o[1] = 1, o[2] = i;
              break;
            case 3:
              o[0] = 0, o[1] = s, o[2] = 1;
              break;
            case 4:
              o[0] = i, o[1] = 0, o[2] = 1;
              break;
            default:
              o[0] = 1, o[1] = 0, o[2] = s;
          }
          return u = (1 - n) * r, [255 * (n * o[0] + u), 255 * (n * o[1] + u), 255 * (n * o[2] + u)];
        }, r.hcg.hsv = function (e) {
          var t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t),
            r = 0;
          return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
        }, r.hcg.hsl = function (e) {
          var t = e[1] / 100,
            n = e[2] / 100 * (1 - t) + .5 * t,
            r = 0;
          return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), [e[0], 100 * r, 100 * n];
        }, r.hcg.hwb = function (e) {
          var t = e[1] / 100,
            n = t + e[2] / 100 * (1 - t);
          return [e[0], 100 * (n - t), 100 * (1 - n)];
        }, r.hwb.hcg = function (e) {
          var t = e[1] / 100,
            n = 1 - e[2] / 100,
            r = n - t,
            u = 0;
          return r < 1 && (u = (n - r) / (1 - r)), [e[0], 100 * r, 100 * u];
        }, r.apple.rgb = function (e) {
          return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
        }, r.rgb.apple = function (e) {
          return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
        }, r.gray.rgb = function (e) {
          return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
        }, r.gray.hsl = r.gray.hsv = function (e) {
          return [0, 0, e[0]];
        }, r.gray.hwb = function (e) {
          return [0, 100, e[0]];
        }, r.gray.cmyk = function (e) {
          return [0, 0, 0, e[0]];
        }, r.gray.lab = function (e) {
          return [e[0], 0, 0];
        }, r.gray.hex = function (e) {
          var t = 255 & Math.round(e[0] / 100 * 255),
            n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
          return "000000".substring(n.length) + n;
        }, r.rgb.gray = function (e) {
          return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
        };
      });
    function pa(e) {
      var t = function () {
          for (var e = {}, t = Object.keys(ca), n = t.length, r = 0; r < n; r++) e[t[r]] = {
            distance: -1,
            parent: null
          };
          return e;
        }(),
        n = [e];
      for (t[e].distance = 0; n.length;) for (var r = n.pop(), u = Object.keys(ca[r]), o = u.length, a = 0; a < o; a++) {
        var i = u[a],
          s = t[i];
        -1 === s.distance && (s.distance = t[r].distance + 1, s.parent = r, n.unshift(i));
      }
      return t;
    }
    function da(e, t) {
      return function (n) {
        return t(e(n));
      };
    }
    function fa(e, t) {
      for (var n = [t[e].parent, e], r = ca[t[e].parent][e], u = t[e].parent; t[u].parent;) n.unshift(t[u].parent), r = da(ca[t[u].parent][u], r), u = t[u].parent;
      return r.conversion = n, r;
    }
    var ha = {};
    Object.keys(ca).forEach(function (e) {
      ha[e] = {}, Object.defineProperty(ha[e], "channels", {
        value: ca[e].channels
      }), Object.defineProperty(ha[e], "labels", {
        value: ca[e].labels
      });
      var t = function (e) {
        for (var t = pa(e), n = {}, r = Object.keys(t), u = r.length, o = 0; o < u; o++) {
          var a = r[o];
          null !== t[a].parent && (n[a] = fa(a, t));
        }
        return n;
      }(e);
      Object.keys(t).forEach(function (n) {
        var r = t[n];
        ha[e][n] = function (e) {
          var t = function (t) {
            if (null == t) return t;
            arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
            var n = e(t);
            if ("object" == typeof n) for (var r = n.length, u = 0; u < r; u++) n[u] = Math.round(n[u]);
            return n;
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r), ha[e][n].raw = function (e) {
          var t = function (t) {
            return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), e(t));
          };
          return "conversion" in e && (t.conversion = e.conversion), t;
        }(r);
      });
    });
    var ma = ha,
      ga = $e(function (e) {
        const t = (e, t) => function () {
            const n = e.apply(ma, arguments);
            return "[".concat(n + t, "m");
          },
          n = (e, t) => function () {
            const n = e.apply(ma, arguments);
            return "[".concat(38 + t, ";5;").concat(n, "m");
          },
          r = (e, t) => function () {
            const n = e.apply(ma, arguments);
            return "[".concat(38 + t, ";2;").concat(n[0], ";").concat(n[1], ";").concat(n[2], "m");
          };
        Object.defineProperty(e, "exports", {
          enumerable: !0,
          get: function () {
            const e = new Map(),
              u = {
                modifier: {
                  reset: [0, 0],
                  bold: [1, 22],
                  dim: [2, 22],
                  italic: [3, 23],
                  underline: [4, 24],
                  inverse: [7, 27],
                  hidden: [8, 28],
                  strikethrough: [9, 29]
                },
                color: {
                  black: [30, 39],
                  red: [31, 39],
                  green: [32, 39],
                  yellow: [33, 39],
                  blue: [34, 39],
                  magenta: [35, 39],
                  cyan: [36, 39],
                  white: [37, 39],
                  gray: [90, 39],
                  redBright: [91, 39],
                  greenBright: [92, 39],
                  yellowBright: [93, 39],
                  blueBright: [94, 39],
                  magentaBright: [95, 39],
                  cyanBright: [96, 39],
                  whiteBright: [97, 39]
                },
                bgColor: {
                  bgBlack: [40, 49],
                  bgRed: [41, 49],
                  bgGreen: [42, 49],
                  bgYellow: [43, 49],
                  bgBlue: [44, 49],
                  bgMagenta: [45, 49],
                  bgCyan: [46, 49],
                  bgWhite: [47, 49],
                  bgBlackBright: [100, 49],
                  bgRedBright: [101, 49],
                  bgGreenBright: [102, 49],
                  bgYellowBright: [103, 49],
                  bgBlueBright: [104, 49],
                  bgMagentaBright: [105, 49],
                  bgCyanBright: [106, 49],
                  bgWhiteBright: [107, 49]
                }
              };
            u.color.grey = u.color.gray;
            for (const t of Object.keys(u)) {
              const n = u[t];
              for (const _t29 of Object.keys(n)) {
                const r = n[_t29];
                u[_t29] = {
                  open: "[".concat(r[0], "m"),
                  close: "[".concat(r[1], "m")
                }, n[_t29] = u[_t29], e.set(r[0], r[1]);
              }
              Object.defineProperty(u, t, {
                value: n,
                enumerable: !1
              }), Object.defineProperty(u, "codes", {
                value: e,
                enumerable: !1
              });
            }
            const o = e => e,
              a = (e, t, n) => [e, t, n];
            u.color.close = "[39m", u.bgColor.close = "[49m", u.color.ansi = {
              ansi: t(o, 0)
            }, u.color.ansi256 = {
              ansi256: n(o, 0)
            }, u.color.ansi16m = {
              rgb: r(a, 0)
            }, u.bgColor.ansi = {
              ansi: t(o, 10)
            }, u.bgColor.ansi256 = {
              ansi256: n(o, 10)
            }, u.bgColor.ansi16m = {
              rgb: r(a, 10)
            };
            for (let _e59 of Object.keys(ma)) {
              if ("object" != typeof ma[_e59]) continue;
              const _o4 = ma[_e59];
              "ansi16" === _e59 && (_e59 = "ansi"), "ansi16" in _o4 && (u.color.ansi[_e59] = t(_o4.ansi16, 0), u.bgColor.ansi[_e59] = t(_o4.ansi16, 10)), "ansi256" in _o4 && (u.color.ansi256[_e59] = n(_o4.ansi256, 0), u.bgColor.ansi256[_e59] = n(_o4.ansi256, 10)), "rgb" in _o4 && (u.color.ansi16m[_e59] = r(_o4.rgb, 0), u.bgColor.ansi16m[_e59] = r(_o4.rgb, 10));
            }
            return u;
          }
        });
      });
    const Da = Re.env;
    let ya;
    function Ea(e) {
      return function (e) {
        return 0 !== e && {
          level: e,
          hasBasic: !0,
          has256: e >= 2,
          has16m: e >= 3
        };
      }(function (e) {
        if (!1 === ya) return 0;
        if (qr("color=16m") || qr("color=full") || qr("color=truecolor")) return 3;
        if (qr("color=256")) return 2;
        if (e && !e.isTTY && !0 !== ya) return 0;
        const t = ya ? 1 : 0;
        if ("win32" === Re.platform) {
          const _e60 = Rr.release().split(".");
          return Number(Re.versions.node.split(".")[0]) >= 8 && Number(_e60[0]) >= 10 && Number(_e60[2]) >= 10586 ? Number(_e60[2]) >= 14931 ? 3 : 2 : 1;
        }
        if ("CI" in Da) return ["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI"].some(e => e in Da) || "codeship" === Da.CI_NAME ? 1 : t;
        if ("TEAMCITY_VERSION" in Da) return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(Da.TEAMCITY_VERSION) ? 1 : 0;
        if ("truecolor" === Da.COLORTERM) return 3;
        if ("TERM_PROGRAM" in Da) {
          const _e61 = parseInt((Da.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
          switch (Da.TERM_PROGRAM) {
            case "iTerm.app":
              return _e61 >= 3 ? 3 : 2;
            case "Apple_Terminal":
              return 2;
          }
        }
        return /-256(color)?$/i.test(Da.TERM) ? 2 : /^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(Da.TERM) || "COLORTERM" in Da ? 1 : (t);
      }(e));
    }
    qr("no-color") || qr("no-colors") || qr("color=false") ? ya = !1 : (qr("color") || qr("colors") || qr("color=true") || qr("color=always")) && (ya = !0), "FORCE_COLOR" in Da && (ya = 0 === Da.FORCE_COLOR.length || 0 !== parseInt(Da.FORCE_COLOR, 10));
    var Ca = {
      supportsColor: Ea,
      stdout: Ea(Re.stdout),
      stderr: Ea(Re.stderr)
    };
    const ba = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
      Aa = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
      va = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
      Fa = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi,
      xa = new Map([["n", "\n"], ["r", "\r"], ["t", "\t"], ["b", "\b"], ["f", "\f"], ["v", "\v"], ["0", "\0"], ["\\", "\\"], ["e", ""], ["a", ""]]);
    function Sa(e) {
      return "u" === e[0] && 5 === e.length || "x" === e[0] && 3 === e.length ? String.fromCharCode(parseInt(e.slice(1), 16)) : xa.get(e) || e;
    }
    function wa(e, t) {
      const n = [],
        r = t.trim().split(/\s*,\s*/g);
      let u;
      for (const _t30 of r) if (isNaN(_t30)) {
        if (!(u = _t30.match(va))) throw new Error("Invalid Chalk template style argument: ".concat(_t30, " (in style '").concat(e, "')"));
        n.push(u[2].replace(Fa, (e, t, n) => t ? Sa(t) : n));
      } else n.push(Number(_t30));
      return n;
    }
    function Ba(e) {
      Aa.lastIndex = 0;
      const t = [];
      let n;
      for (; null !== (n = Aa.exec(e));) {
        const _e62 = n[1];
        if (n[2]) {
          const r = wa(_e62, n[2]);
          t.push([_e62].concat(r));
        } else t.push([_e62]);
      }
      return t;
    }
    function Ta(e, t) {
      const n = {};
      for (const _e63 of t) for (const _t31 of _e63.styles) n[_t31[0]] = _e63.inverse ? null : _t31.slice(1);
      let r = e;
      for (const _e64 of Object.keys(n)) if (Array.isArray(n[_e64])) {
        if (!(_e64 in r)) throw new Error("Unknown Chalk style: ".concat(_e64));
        r = n[_e64].length > 0 ? r[_e64].apply(r, n[_e64]) : r[_e64];
      }
      return r;
    }
    var ka = (e, t) => {
        const n = [],
          r = [];
        let u = [];
        if (t.replace(ba, (t, o, a, i, s, l) => {
          if (o) u.push(Sa(o));else if (i) {
            const _t32 = u.join("");
            u = [], r.push(0 === n.length ? _t32 : Ta(e, n)(_t32)), n.push({
              inverse: a,
              styles: Ba(i)
            });
          } else if (s) {
            if (0 === n.length) throw new Error("Found extraneous } in Chalk template literal");
            r.push(Ta(e, n)(u.join(""))), u = [], n.pop();
          } else u.push(l);
        }), r.push(u.join("")), n.length > 0) {
          const _e65 = "Chalk template literal is missing ".concat(n.length, " closing bracket").concat(1 === n.length ? "" : "s", " (`}`)");
          throw new Error(_e65);
        }
        return r.join("");
      },
      Na = $e(function (e) {
        const t = Ca.stdout,
          n = "win32" === Re.platform && !(Re.env.TERM || "").toLowerCase().startsWith("xterm"),
          r = ["ansi", "ansi", "ansi256", "ansi16m"],
          u = new Set(["gray"]),
          o = Object.create(null);
        function a(e, n) {
          n = n || {};
          const r = t ? t.level : 0;
          e.level = void 0 === n.level ? r : n.level, e.enabled = "enabled" in n ? n.enabled : e.level > 0;
        }
        function i(e) {
          if (!this || !(this instanceof i) || this.template) {
            const t = {};
            return a(t, e), t.template = function () {
              const e = [].slice.call(arguments);
              return p.apply(null, [t.template].concat(e));
            }, Object.setPrototypeOf(t, i.prototype), Object.setPrototypeOf(t.template, t), t.template.constructor = i, t.template;
          }
          a(this, e);
        }
        n && (ga.blue.open = "[94m");
        for (const _e66 of Object.keys(ga)) ga[_e66].closeRe = new RegExp(sa(ga[_e66].close), "g"), o[_e66] = {
          get() {
            const t = ga[_e66];
            return l.call(this, this._styles ? this._styles.concat(t) : [t], this._empty, _e66);
          }
        };
        o.visible = {
          get() {
            return l.call(this, this._styles || [], !0, "visible");
          }
        }, ga.color.closeRe = new RegExp(sa(ga.color.close), "g");
        for (const _e67 of Object.keys(ga.color.ansi)) u.has(_e67) || (o[_e67] = {
          get() {
            const t = this.level;
            return function () {
              const n = ga.color[r[t]][_e67].apply(null, arguments),
                u = {
                  open: n,
                  close: ga.color.close,
                  closeRe: ga.color.closeRe
                };
              return l.call(this, this._styles ? this._styles.concat(u) : [u], this._empty, _e67);
            };
          }
        });
        ga.bgColor.closeRe = new RegExp(sa(ga.bgColor.close), "g");
        for (const _e68 of Object.keys(ga.bgColor.ansi)) {
          if (u.has(_e68)) continue;
          o["bg" + _e68[0].toUpperCase() + _e68.slice(1)] = {
            get() {
              const t = this.level;
              return function () {
                const n = ga.bgColor[r[t]][_e68].apply(null, arguments),
                  u = {
                    open: n,
                    close: ga.bgColor.close,
                    closeRe: ga.bgColor.closeRe
                  };
                return l.call(this, this._styles ? this._styles.concat(u) : [u], this._empty, _e68);
              };
            }
          };
        }
        const s = Object.defineProperties(() => {}, o);
        function l(e, t, n) {
          const r = function e() {
            return c.apply(e, arguments);
          };
          r._styles = e, r._empty = t;
          const u = this;
          return Object.defineProperty(r, "level", {
            enumerable: !0,
            get: () => u.level,
            set(e) {
              u.level = e;
            }
          }), Object.defineProperty(r, "enabled", {
            enumerable: !0,
            get: () => u.enabled,
            set(e) {
              u.enabled = e;
            }
          }), r.hasGrey = this.hasGrey || "gray" === n || "grey" === n, r.__proto__ = s, r;
        }
        function c() {
          const e = arguments,
            t = e.length;
          let r = String(arguments[0]);
          if (0 === t) return "";
          if (t > 1) for (let n = 1; n < t; n++) r += " " + e[n];
          if (!this.enabled || this.level <= 0 || !r) return this._empty ? "" : r;
          const u = ga.dim.open;
          n && this.hasGrey && (ga.dim.open = "");
          for (const _e69 of this._styles.slice().reverse()) r = _e69.open + r.replace(_e69.closeRe, _e69.open) + _e69.close, r = r.replace(/\r?\n/g, "".concat(_e69.close, "$&").concat(_e69.open));
          return ga.dim.open = u, r;
        }
        function p(e, t) {
          if (!Array.isArray(t)) return [].slice.call(arguments, 1).join(" ");
          const n = [].slice.call(arguments, 2),
            r = [t.raw[0]];
          for (let _e70 = 1; _e70 < t.length; _e70++) r.push(String(n[_e70 - 1]).replace(/[{}\\]/g, "\\$&")), r.push(String(t.raw[_e70]));
          return ka(e, r.join(""));
        }
        Object.defineProperties(i.prototype, o), e.exports = i(), e.exports.supportsColor = t, e.exports.default = e.exports;
      }),
      Oa = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.shouldHighlight = l, t.getChalk = c, t.default = function (e, t = {}) {
          if (l(t)) {
            const n = c(t);
            return function (e, t) {
              return t.replace(r.default, function (...t) {
                const n = function (e) {
                    const [t, n] = e.slice(-2),
                      u = (0, r.matchToToken)(e);
                    if ("name" === u.type) {
                      if ((0, aa.isKeyword)(u.value) || (0, aa.isReservedWord)(u.value)) return "keyword";
                      if (i.test(u.value) && ("<" === n[t - 1] || "</" == n.substr(t - 2, 2))) return "jsx_tag";
                      if (u.value[0] !== u.value[0].toLowerCase()) return "capitalized";
                    }
                    if ("punctuator" === u.type && s.test(u.value)) return "bracket";
                    if ("invalid" === u.type && ("@" === u.value || "#" === u.value)) return "punctuator";
                    return u.type;
                  }(t),
                  u = e[n];
                return u ? t[0].split(a).map(e => u(e)).join("\n") : t[0];
              });
            }(function (e) {
              return {
                keyword: e.cyan,
                capitalized: e.yellow,
                jsx_tag: e.yellow,
                punctuator: e.yellow,
                number: e.magenta,
                string: e.green,
                regex: e.magenta,
                comment: e.grey,
                invalid: e.white.bgRed.bold
              };
            }(n), e);
          }
          return e;
        };
        var n,
          r = function (e) {
            if (e && e.__esModule) return e;
            if (null === e || "object" != typeof e && "function" != typeof e) return {
              default: e
            };
            var t = o();
            if (t && t.has(e)) return t.get(e);
            var n = {},
              r = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var u in e) if (Object.prototype.hasOwnProperty.call(e, u)) {
              var a = r ? Object.getOwnPropertyDescriptor(e, u) : null;
              a && (a.get || a.set) ? Object.defineProperty(n, u, a) : n[u] = e[u];
            }
            n.default = e, t && t.set(e, n);
            return n;
          }(ra),
          u = (n = Na) && n.__esModule ? n : {
            default: n
          };
        function o() {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap();
          return o = function () {
            return e;
          }, e;
        }
        const a = /\r\n|[\n\r\u2028\u2029]/,
          i = /^[a-z][\w-]*$/i,
          s = /^[()[\]{}]$/;
        function l(e) {
          return u.default.supportsColor || e.forceColor;
        }
        function c(e) {
          let t = u.default;
          return e.forceColor && (t = new u.default.constructor({
            enabled: !0,
            level: 1
          })), t;
        }
      }),
      Pa = $e(function (e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.codeFrameColumns = a, t.default = function (e, t, n, r = {}) {
          if (!u) {
            u = !0;
            const _e71 = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
            if (Re.emitWarning) Re.emitWarning(_e71, "DeprecationWarning");else {
              new Error(_e71).name = "DeprecationWarning", console.warn(new Error(_e71));
            }
          }
          n = Math.max(n, 0);
          return a(e, {
            start: {
              column: n,
              line: t
            }
          }, r);
        };
        var n = function (e) {
          if (e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };
          var t = r();
          if (t && t.has(e)) return t.get(e);
          var n = {},
            u = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
            var a = u ? Object.getOwnPropertyDescriptor(e, o) : null;
            a && (a.get || a.set) ? Object.defineProperty(n, o, a) : n[o] = e[o];
          }
          n.default = e, t && t.set(e, n);
          return n;
        }(Oa);
        function r() {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap();
          return r = function () {
            return e;
          }, e;
        }
        let u = !1;
        const o = /\r\n|[\n\r\u2028\u2029]/;
        function a(e, t, r = {}) {
          const u = (r.highlightCode || r.forceColor) && (0, n.shouldHighlight)(r),
            a = (0, n.getChalk)(r),
            i = function (e) {
              return {
                gutter: e.grey,
                marker: e.red.bold,
                message: e.red.bold
              };
            }(a),
            s = (e, t) => u ? e(t) : t,
            l = e.split(o),
            {
              start: c,
              end: p,
              markerLines: d
            } = function (e, t, n) {
              const r = Object.assign({
                  column: 0,
                  line: -1
                }, e.start),
                u = Object.assign({}, r, e.end),
                {
                  linesAbove: o = 2,
                  linesBelow: a = 3
                } = n || {},
                i = r.line,
                s = r.column,
                l = u.line,
                c = u.column;
              let p = Math.max(i - (o + 1), 0),
                d = Math.min(t.length, l + a);
              -1 === i && (p = 0), -1 === l && (d = t.length);
              const f = l - i,
                h = {};
              if (f) for (let _e72 = 0; _e72 <= f; _e72++) {
                const _n10 = _e72 + i;
                if (s) {
                  if (0 === _e72) {
                    const _e73 = t[_n10 - 1].length;
                    h[_n10] = [s, _e73 - s + 1];
                  } else if (_e72 === f) h[_n10] = [0, c];else {
                    const _r11 = t[_n10 - _e72].length;
                    h[_n10] = [0, _r11];
                  }
                } else h[_n10] = !0;
              } else h[i] = s === c ? !s || [s, 0] : [s, c - s];
              return {
                start: p,
                end: d,
                markerLines: h
              };
            }(t, l, r),
            f = t.start && "number" == typeof t.start.column,
            h = String(p).length;
          let m = (u ? (0, n.default)(e, r) : e).split(o).slice(c, p).map((e, t) => {
            const n = c + 1 + t,
              u = " ".concat(n).slice(-h),
              o = " ".concat(u, " | "),
              a = d[n],
              l = !d[n + 1];
            if (a) {
              let _t33 = "";
              if (Array.isArray(a)) {
                const _n11 = e.slice(0, Math.max(a[0] - 1, 0)).replace(/[^\t]/g, " "),
                  _u5 = a[1] || 1;
                _t33 = ["\n ", s(i.gutter, o.replace(/\d/g, " ")), _n11, s(i.marker, "^").repeat(_u5)].join(""), l && r.message && (_t33 += " " + s(i.message, r.message));
              }
              return [s(i.marker, ">"), s(i.gutter, o), e, _t33].join("");
            }
            return " ".concat(s(i.gutter, o)).concat(e);
          }).join("\n");
          return r.message && !f && (m = "".concat(" ".repeat(h + 1)).concat(r.message, "\n").concat(m)), u ? a.reset(m) : m;
        }
      });
    const {
        ConfigError: _a
      } = Er,
      {
        locStart: Ia,
        locEnd: ja
      } = na,
      Ma = Object.getOwnPropertyNames,
      La = Object.getOwnPropertyDescriptor;
    function Ra(e) {
      const t = {};
      for (const n of e.plugins) if (n.parsers) for (const _e74 of Ma(n.parsers)) Object.defineProperty(t, _e74, La(n.parsers, _e74));
      return t;
    }
    function qa(e, t) {
      if (t = t || Ra(e), "function" == typeof e.parser) return {
        parse: e.parser,
        astFormat: "estree",
        locStart: Ia,
        locEnd: ja
      };
      if ("string" == typeof e.parser) {
        if (Object.prototype.hasOwnProperty.call(t, e.parser)) return t[e.parser];
        throw new _a("Couldn't resolve parser \"".concat(e.parser, '". Parsers must be explicitly added to the standalone bundle.'));
      }
    }
    var Va = {
      parse: function (e, t) {
        const n = Ra(t),
          r = Object.keys(n).reduce((e, t) => Object.defineProperty(e, t, {
            enumerable: !0,
            get: () => n[t].parse
          }), {}),
          u = qa(t, n);
        try {
          return u.preprocess && (e = u.preprocess(e, t)), {
            text: e,
            ast: u.parse(e, r, t)
          };
        } catch (t) {
          const {
            loc: _n12
          } = t;
          if (_n12) {
            const _r12 = Pa;
            throw t.codeFrame = _r12.codeFrameColumns(e, _n12, {
              highlightCode: !0
            }), t.message += "\n" + t.codeFrame, t;
          }
          throw t.stack;
        }
      },
      resolveParser: qa
    };
    const {
        UndefinedParserError: Wa
      } = Er,
      {
        getSupportInfo: $a
      } = yt,
      {
        resolveParser: Ua
      } = Va,
      za = {
        astFormat: "estree",
        printer: {},
        originalText: void 0,
        locStart: null,
        locEnd: null
      };
    function Ja(e, t) {
      const n = gn.basename(e).toLowerCase(),
        r = $a({
          plugins: t
        }).languages.filter(e => null !== e.since);
      let u = r.find(e => e.extensions && e.extensions.some(e => n.endsWith(e)) || e.filenames && e.filenames.some(e => e.toLowerCase() === n));
      if (!u && !n.includes(".")) {
        const _t34 = function (e) {
          if ("string" != typeof e) return "";
          let t;
          try {
            t = fr.openSync(e, "r");
          } catch (e) {
            return "";
          }
          try {
            const _e75 = new hr(t).next().toString("utf8"),
              n = _e75.match(/^#!\/(?:usr\/)?bin\/env\s+(\S+)/);
            if (n) return n[1];
            const r = _e75.match(/^#!\/(?:usr\/(?:local\/)?)?bin\/(\S+)/);
            return r ? r[1] : "";
          } catch (e) {
            return "";
          } finally {
            try {
              fr.closeSync(t);
            } catch (e) {}
          }
        }(e);
        u = r.find(e => e.interpreters && e.interpreters.includes(_t34));
      }
      return u && u.parsers[0];
    }
    var Ga = {
      normalize: function (e, t) {
        t = t || {};
        const n = Object.assign({}, e),
          r = $a({
            plugins: e.plugins,
            showUnreleased: !0,
            showDeprecated: !0
          }).options,
          u = Object.assign({}, za, mr(r.filter(e => void 0 !== e.default).map(e => [e.name, e.default])));
        if (!n.parser) if (n.filepath) {
          if (n.parser = Ja(n.filepath, n.plugins), !n.parser) throw new Wa("No parser could be inferred for file: ".concat(n.filepath));
        } else {
          (t.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), n.parser = "babel";
        }
        const o = Ua(Zo.normalizeApiOptions(n, [r.find(e => "parser" === e.name)], {
          passThrough: !0,
          logger: !1
        }));
        n.astFormat = o.astFormat, n.locEnd = o.locEnd, n.locStart = o.locStart;
        const a = function (e) {
          const {
            astFormat: t
          } = e;
          if (!t) throw new Error("getPlugin() requires astFormat to be set");
          const n = e.plugins.find(e => e.printers && e.printers[t]);
          if (!n) throw new Error("Couldn't find plugin for AST format \"".concat(t, '"'));
          return n;
        }(n);
        n.printer = a.printers[n.astFormat];
        const i = r.filter(e => e.pluginDefaults && void 0 !== e.pluginDefaults[a.name]).reduce((e, t) => Object.assign(e, {
            [t.name]: t.pluginDefaults[a.name]
          }), {}),
          s = Object.assign({}, u, i);
        return Object.keys(s).forEach(e => {
          null == n[e] && (n[e] = s[e]);
        }), "json" === n.parser && (n.trailingComma = "none"), Zo.normalizeApiOptions(n, r, Object.assign({
          passThrough: Object.keys(za)
        }, t));
      },
      hiddenDefaults: za,
      inferParser: Ja
    };
    var Ha = function e(t, n, r) {
      if (Array.isArray(t)) return t.map(t => e(t, n, r)).filter(Boolean);
      if (!t || "object" != typeof t) return t;
      const u = {};
      for (const _r13 of Object.keys(t)) "function" != typeof t[_r13] && (u[_r13] = e(t[_r13], n, t));
      if (n.printer.massageAstNode) {
        const _e76 = n.printer.massageAstNode(t, u, r);
        if (null === _e76) return;
        if (_e76) return _e76;
      }
      return u;
    };
    function Xa() {}
    Xa.ok = function () {}, Xa.strictEqual = function () {};
    const {
        concat: Ya,
        line: Ka,
        hardline: Qa,
        breakParent: Za,
        indent: ei,
        lineSuffix: ti,
        join: ni,
        cursor: ri
      } = dn.builders,
      {
        hasNewline: ui,
        skipNewline: oi,
        skipSpaces: ai,
        isPreviousLineEmpty: ii,
        addLeadingComment: si,
        addDanglingComment: li,
        addTrailingComment: ci
      } = Lt,
      pi = Symbol("child-nodes");
    function di(e, t, n) {
      if (!e) return;
      const {
        printer: r,
        locStart: u,
        locEnd: o
      } = t;
      if (n) {
        if (r.canAttachComment && r.canAttachComment(e)) {
          let _t35;
          for (_t35 = n.length - 1; _t35 >= 0 && !(u(n[_t35]) <= u(e) && o(n[_t35]) <= o(e)); --_t35);
          return void n.splice(_t35 + 1, 0, e);
        }
      } else if (e[pi]) return e[pi];
      const a = r.getCommentChildNodes && r.getCommentChildNodes(e, t) || "object" == typeof e && Object.keys(e).filter(e => "enclosingNode" !== e && "precedingNode" !== e && "followingNode" !== e && "tokens" !== e && "comments" !== e).map(t => e[t]);
      return a ? (n || Object.defineProperty(e, pi, {
        value: n = [],
        enumerable: !1
      }), a.forEach(e => {
        di(e, t, n);
      }), n) : void 0;
    }
    function fi(e, t, n) {
      const r = e.length;
      if (0 === r) return;
      const {
          precedingNode: u,
          followingNode: o,
          enclosingNode: a
        } = e[0],
        i = n.printer.getGapRegex && n.printer.getGapRegex(a) || /^[\s(]*$/;
      let s,
        l = n.locStart(o);
      for (s = r; s > 0; --s) {
        const _r14 = e[s - 1];
        Xa.strictEqual(_r14.precedingNode, u), Xa.strictEqual(_r14.followingNode, o);
        const _a4 = t.slice(n.locEnd(_r14), l);
        if (!i.test(_a4)) break;
        l = n.locStart(_r14);
      }
      e.forEach((e, t) => {
        t < s ? ci(u, e) : si(o, e);
      });
      for (const _e77 of [u, o]) _e77.comments && _e77.comments.length > 1 && _e77.comments.sort((e, t) => n.locStart(e) - n.locStart(t));
      e.length = 0;
    }
    function hi(e, t) {
      return e.getValue().printed = !0, t.printer.printComment(e, t);
    }
    function mi(e, t, n) {
      const r = n.locStart(t) - 1;
      for (let _t36 = 1; _t36 < e.length; ++_t36) if (r < n.locStart(e[_t36])) return _t36 - 1;
      return 0;
    }
    function gi(e, t, n) {
      return e.getNode() === t.cursorNode && e.getValue() ? Ya([ri, n, ri]) : n;
    }
    var Di = {
      attach: function (e, t, n, r) {
        if (!Array.isArray(e)) return;
        const u = [],
          {
            locStart: o,
            locEnd: a
          } = r;
        e.forEach((i, s) => {
          if ("json" === r.parser || "json5" === r.parser || "__js_expression" === r.parser || "__vue_expression" === r.parser) {
            if (o(i) - o(t) <= 0) return void si(t, i);
            if (a(i) - a(t) >= 0) return void ci(t, i);
          }
          !function e(t, n, r) {
            const {
                locStart: u,
                locEnd: o
              } = r,
              a = di(t, r);
            let i,
              s,
              l = 0,
              c = a.length;
            for (; l < c;) {
              const _t37 = l + c >> 1,
                p = a[_t37];
              if (u(p) - u(n) <= 0 && o(n) - o(p) <= 0) return n.enclosingNode = p, void e(p, n, r);
              if (o(p) - u(n) <= 0) i = p, l = _t37 + 1;else {
                if (!(o(n) - u(p) <= 0)) throw new Error("Comment location overlaps with node location");
                s = p, c = _t37;
              }
            }
            if (n.enclosingNode && "TemplateLiteral" === n.enclosingNode.type) {
              const {
                  quasis: _e78
                } = n.enclosingNode,
                _t38 = mi(_e78, n, r);
              i && mi(_e78, i, r) !== _t38 && (i = null), s && mi(_e78, s, r) !== _t38 && (s = null);
            }
            i && (n.precedingNode = i), s && (n.followingNode = s);
          }(t, i, r);
          const {
              precedingNode: l,
              enclosingNode: c,
              followingNode: p
            } = i,
            d = r.printer.handleComments && r.printer.handleComments.ownLine ? r.printer.handleComments.ownLine : () => !1,
            f = r.printer.handleComments && r.printer.handleComments.endOfLine ? r.printer.handleComments.endOfLine : () => !1,
            h = r.printer.handleComments && r.printer.handleComments.remaining ? r.printer.handleComments.remaining : () => !1,
            m = e.length - 1 === s;
          if (ui(n, o(i), {
            backwards: !0
          })) d(i, n, r, t, m) || (p ? si(p, i) : l ? ci(l, i) : li(c || t, i));else if (ui(n, a(i))) f(i, n, r, t, m) || (l ? ci(l, i) : p ? si(p, i) : li(c || t, i));else if (h(i, n, r, t, m)) ;else if (l && p) {
            const e = u.length;
            if (e > 0) {
              u[e - 1].followingNode !== i.followingNode && fi(u, n, r);
            }
            u.push(i);
          } else l ? ci(l, i) : p ? si(p, i) : li(c || t, i);
        }), fi(u, n, r), e.forEach(e => {
          delete e.precedingNode, delete e.enclosingNode, delete e.followingNode;
        });
      },
      printComments: function (e, t, n, r) {
        const u = e.getValue(),
          o = t(e),
          a = u && u.comments;
        if (!a || 0 === a.length) return gi(e, n, o);
        const i = [],
          s = [r ? ";" : "", o];
        return e.each(e => {
          const t = e.getValue(),
            {
              leading: r,
              trailing: u
            } = t;
          if (r) {
            const _r15 = function (e, t) {
              const n = e.getValue(),
                r = hi(e, t);
              if (!r) return "";
              if (t.printer.isBlockComment && t.printer.isBlockComment(n)) {
                const _e79 = ui(t.originalText, t.locEnd(n)) ? ui(t.originalText, t.locStart(n), {
                  backwards: !0
                }) ? Qa : Ka : " ";
                return Ya([r, _e79]);
              }
              return Ya([r, Qa]);
            }(e, n);
            if (!_r15) return;
            i.push(_r15);
            const _u6 = n.originalText,
              o = oi(_u6, ai(_u6, n.locEnd(t)));
            !1 !== o && ui(_u6, o) && i.push(Qa);
          } else u && s.push(function (e, t) {
            const n = e.getValue(),
              r = hi(e, t);
            if (!r) return "";
            const {
                printer: u,
                originalText: o,
                locStart: a
              } = t,
              i = u.isBlockComment && u.isBlockComment(n);
            if (ui(o, a(n), {
              backwards: !0
            })) {
              const _e80 = ii(o, n, a);
              return ti(Ya([Qa, _e80 ? Qa : "", r]));
            }
            let s = Ya([" ", r]);
            return i || (s = Ya([ti(s), Za])), s;
          }(e, n));
        }, "comments"), gi(e, n, Ya(i.concat(s)));
      },
      printDanglingComments: function (e, t, n, r) {
        const u = [],
          o = e.getValue();
        return o && o.comments ? (e.each(e => {
          const n = e.getValue();
          !n || n.leading || n.trailing || r && !r(n) || u.push(hi(e, t));
        }, "comments"), 0 === u.length ? "" : n ? ni(Qa, u) : ei(Ya([Qa, ni(Qa, u)]))) : "";
      },
      getSortedChildNodes: di,
      ensureAllCommentsPrinted: function (e) {
        e && e.forEach(e => {
          if (!e.printed) throw new Error('Comment "' + e.value.trim() + '" was not printed. Please report this error!');
          delete e.printed;
        });
      }
    };
    function yi(e, t) {
      const n = Ei(e.stack, t);
      return -1 === n ? null : e.stack[n];
    }
    function Ei(e, t) {
      for (let n = e.length - 1; n >= 0; n -= 2) {
        const r = e[n];
        if (r && !Array.isArray(r) && --t < 0) return n;
      }
      return -1;
    }
    var Ci = class {
      constructor(e) {
        this.stack = [e];
      }
      getName() {
        const {
            stack: e
          } = this,
          {
            length: t
          } = e;
        return t > 1 ? e[t - 2] : null;
      }
      getValue() {
        return he(this.stack);
      }
      getNode(e = 0) {
        return yi(this, e);
      }
      getParentNode(e = 0) {
        return yi(this, e + 1);
      }
      call(e, ...t) {
        const {
            stack: n
          } = this,
          {
            length: r
          } = n;
        let u = he(n);
        for (const _e81 of t) u = u[_e81], n.push(_e81, u);
        const o = e(this);
        return n.length = r, o;
      }
      callParent(e, t = 0) {
        const n = Ei(this.stack, t + 1),
          r = this.stack.splice(n + 1),
          u = e(this);
        return this.stack.push(...r), u;
      }
      each(e, ...t) {
        const {
            stack: n
          } = this,
          {
            length: r
          } = n;
        let u = he(n);
        for (const _e82 of t) u = u[_e82], n.push(_e82, u);
        for (let _t39 = 0; _t39 < u.length; ++_t39) _t39 in u && (n.push(_t39, u[_t39]), e(this), n.length -= 2);
        n.length = r;
      }
      map(e, ...t) {
        const {
            stack: n
          } = this,
          {
            length: r
          } = n;
        let u = he(n);
        for (const _e83 of t) u = u[_e83], n.push(_e83, u);
        const o = new Array(u.length);
        for (let _t40 = 0; _t40 < u.length; ++_t40) _t40 in u && (n.push(_t40, u[_t40]), o[_t40] = e(this, _t40), n.length -= 2);
        return n.length = r, o;
      }
      match(...e) {
        let t = this.stack.length - 1,
          n = null,
          r = this.stack[t--];
        for (const u of e) {
          if (void 0 === r) return !1;
          let _e84 = null;
          if ("number" == typeof n && (_e84 = n, n = this.stack[t--], r = this.stack[t--]), u && !u(r, n, _e84)) return !1;
          n = this.stack[t--], r = this.stack[t--];
        }
        return !0;
      }
    };
    const {
        utils: {
          stripTrailingHardline: bi
        }
      } = dn,
      {
        normalize: Ai
      } = Ga;
    var vi = {
      printSubtree: function (e, t, n, r) {
        if (n.printer.embed && "auto" === n.embeddedLanguageFormatting) return n.printer.embed(e, t, (e, t, u) => function (e, t, n, r, {
          stripTrailingHardline: u = !1
        } = {}) {
          const o = Ai(Object.assign({}, n, t, {
              parentParser: n.parser,
              embeddedInHtml: !(!n.embeddedInHtml && "html" !== n.parser && "vue" !== n.parser && "angular" !== n.parser && "lwc" !== n.parser),
              originalText: e
            }), {
              passThrough: !0
            }),
            a = Va.parse(e, o),
            {
              ast: i
            } = a;
          e = a.text;
          const s = i.comments;
          delete i.comments, Di.attach(s, i, e, o), o[Symbol.for("comments")] = s || [], o[Symbol.for("tokens")] = i.tokens || [];
          const l = r(i, o);
          if (Di.ensureAllCommentsPrinted(s), u) return "string" == typeof l ? l.replace(/(?:\r?\n)*$/, "") : bi(l, !0);
          return l;
        }(e, t, n, r, u), n);
      }
    };
    const Fi = dn,
      xi = Fi.builders,
      {
        concat: Si,
        hardline: wi,
        addAlignmentToDoc: Bi
      } = xi,
      Ti = Fi.utils;
    function ki(e, t, n = 0) {
      const {
        printer: r
      } = t;
      r.preprocess && (e = r.preprocess(e, t));
      const u = new Map();
      let o = function e(n, o) {
        const a = n.getValue(),
          i = a && "object" == typeof a && void 0 === o;
        if (i && u.has(a)) return u.get(a);
        let s;
        return s = r.willPrintOwnComments && r.willPrintOwnComments(n, t) ? Ni(n, t, e, o) : Di.printComments(n, n => Ni(n, t, e, o), t, o && o.needsSemi), i && u.set(a, s), s;
      }(new Ci(e));
      return n > 0 && (o = Bi(Si([wi, o]), n, t.tabWidth)), Ti.propagateBreaks(o), o;
    }
    function Ni(e, t, n, r) {
      Xa.ok(e instanceof Ci);
      const u = e.getValue(),
        {
          printer: o
        } = t;
      if (o.hasPrettierIgnore && o.hasPrettierIgnore(e)) return function (e, t) {
        const {
            originalText: n,
            [Symbol.for("comments")]: r,
            locStart: u,
            locEnd: o
          } = t,
          a = u(e),
          i = o(e);
        for (const _e85 of r) u(_e85) >= a && o(_e85) <= i && (_e85.printed = !0);
        return n.slice(a, i);
      }(u, t);
      if (u) try {
        const _r16 = vi.printSubtree(e, n, t, ki);
        if (_r16) return _r16;
      } catch (e) {
        if (We.PRETTIER_DEBUG) throw e;
      }
      return o.print(e, t, n, r);
    }
    var Oi = ki;
    function Pi(e, t, n, r, u = []) {
      if (!(t < n.locStart(e) || t > n.locEnd(e))) {
        for (const o of Di.getSortedChildNodes(e, n)) {
          const a = Pi(o, t, n, r, [e, ...u]);
          if (a) return a;
        }
        return !r || r(e) ? {
          node: e,
          parentNodes: u
        } : void 0;
      }
    }
    const _i = new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral"]),
      Ii = new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
    function ji(e, t) {
      if (null == t) return !1;
      switch (e.parser) {
        case "flow":
        case "babel":
        case "babel-flow":
        case "babel-ts":
        case "typescript":
          return function (e) {
            return "Directive" === e || "TypeAlias" === e || "TSExportAssignment" === e || e.startsWith("Declare") || e.startsWith("TSDeclare") || e.endsWith("Statement") || e.endsWith("Declaration");
          }(t.type);
        case "json":
          return _i.has(t.type);
        case "graphql":
          return Ii.has(t.kind);
        case "vue":
          return "root" !== t.tag;
      }
      return !1;
    }
    var Mi = {
        calculateRange: function (e, t, n) {
          const r = e.slice(t.rangeStart, t.rangeEnd),
            u = Math.max(t.rangeStart + r.search(/\S/), t.rangeStart);
          let o;
          for (o = t.rangeEnd; o > t.rangeStart && !/\S/.test(e[o - 1]); --o);
          const a = Pi(n, u, t, e => ji(t, e)),
            i = Pi(n, o, t, e => ji(t, e));
          if (!a || !i) return {
            rangeStart: 0,
            rangeEnd: 0
          };
          const {
            startNode: s,
            endNode: l
          } = function (e, t, n) {
            let r = e.node,
              u = t.node;
            if (r === u) return {
              startNode: r,
              endNode: u
            };
            for (const _r17 of t.parentNodes) {
              if (!("Program" !== _r17.type && "File" !== _r17.type && n.locStart(_r17) >= n.locStart(e.node))) break;
              u = _r17;
            }
            for (const _u7 of e.parentNodes) {
              if (!("Program" !== _u7.type && "File" !== _u7.type && n.locEnd(_u7) <= n.locEnd(t.node))) break;
              r = _u7;
            }
            return {
              startNode: r,
              endNode: u
            };
          }(a, i, t);
          return {
            rangeStart: Math.min(t.locStart(s), t.locStart(l)),
            rangeEnd: Math.max(t.locEnd(s), t.locEnd(l))
          };
        },
        findNodeAtOffset: Pi
      },
      Li = Ue(K);
    const {
        printer: {
          printDocToString: Ri
        },
        debug: {
          printDocToDebug: qi
        }
      } = dn,
      {
        getAlignmentSize: Vi
      } = Lt,
      {
        guessEndOfLine: Wi,
        convertEndOfLineToChars: $i,
        countEndOfLineChars: Ui,
        normalizeEndOfLine: zi
      } = Rt,
      Ji = Ga.normalize,
      Gi = Symbol("cursor");
    function Hi(e, t, n) {
      const r = t.comments;
      return r && (delete t.comments, Di.attach(r, t, e, n)), n[Symbol.for("comments")] = r || [], n[Symbol.for("tokens")] = t.tokens || [], n.originalText = e, r;
    }
    function Xi(e, t, n) {
      if (!e || !e.trim().length) return {
        formatted: "",
        cursorOffset: -1
      };
      n = n || 0;
      const r = Va.parse(e, t),
        {
          ast: u
        } = r;
      if (e = r.text, t.cursorOffset >= 0) {
        const _e86 = Mi.findNodeAtOffset(u, t.cursorOffset, t);
        _e86 && _e86.node && (t.cursorNode = _e86.node);
      }
      const o = Hi(e, u, t),
        a = Oi(u, t, n),
        i = Ri(a, t);
      if (Di.ensureAllCommentsPrinted(o), n > 0) {
        const _e87 = i.formatted.trim();
        void 0 !== i.cursorNodeStart && (i.cursorNodeStart -= i.formatted.indexOf(_e87)), i.formatted = _e87 + $i(t.endOfLine);
      }
      if (t.cursorOffset >= 0) {
        let _n13, _r18, _u8, _o5, _a5;
        if (t.cursorNode && i.cursorNodeText ? (_n13 = t.locStart(t.cursorNode), _r18 = e.slice(_n13, t.locEnd(t.cursorNode)), _u8 = t.cursorOffset - _n13, _o5 = i.cursorNodeStart, _a5 = i.cursorNodeText) : (_n13 = 0, _r18 = e, _u8 = t.cursorOffset, _o5 = 0, _a5 = i.formatted), _r18 === _a5) return {
          formatted: i.formatted,
          cursorOffset: _o5 + _u8
        };
        const s = _r18.split("");
        s.splice(_u8, 0, Gi);
        const l = _a5.split(""),
          c = Li.diffArrays(s, l);
        let p = _o5;
        for (const _e88 of c) if (_e88.removed) {
          if (_e88.value.includes(Gi)) break;
        } else p += _e88.count;
        return {
          formatted: i.formatted,
          cursorOffset: p
        };
      }
      return {
        formatted: i.formatted,
        cursorOffset: -1
      };
    }
    function Yi(e, t) {
      const n = Va.resolveParser(t),
        r = "\ufeff" === e.charAt(0);
      let u = r ? e.slice(1) : e;
      const o = t.cursorOffset >= 0;
      o || (t.cursorOffset = -1);
      const a = !n.hasPragma || n.hasPragma(u);
      if (t.requirePragma && !a) return {
        formatted: e,
        cursorOffset: t.cursorOffset
      };
      "auto" === t.endOfLine && (t.endOfLine = Wi(u));
      const i = t.rangeStart > 0,
        s = t.rangeEnd < u.length;
      if (r && (o && t.cursorOffset--, i && t.rangeStart--, s && t.rangeEnd--), u.includes("\r")) {
        const _e89 = e => Ui(u.slice(0, e), "\r\n");
        o && (t.cursorOffset -= _e89(t.cursorOffset)), i && (t.rangeStart -= _e89(t.rangeStart)), s && (t.rangeEnd -= _e89(t.rangeEnd)), u = zi(u);
      }
      let l;
      return t.rangeStart < 0 && (t.rangeStart = 0), t.rangeEnd > u.length && (t.rangeEnd = u.length), i || s ? l = function (e, t) {
        const n = Va.parse(e, t),
          {
            ast: r
          } = n;
        e = n.text;
        const {
            rangeStart: u,
            rangeEnd: o
          } = Mi.calculateRange(e, t, r),
          a = e.slice(u, o),
          i = Math.min(u, e.lastIndexOf("\n", u) + 1),
          s = e.slice(i, u).match(/^\s*/)[0],
          l = Vi(s, t.tabWidth),
          c = Xi(a, Object.assign({}, t, {
            rangeStart: 0,
            rangeEnd: 1 / 0,
            cursorOffset: t.cursorOffset > u && t.cursorOffset < o ? t.cursorOffset - u : -1,
            endOfLine: "lf"
          }), l),
          p = c.formatted.trimEnd();
        let {
          cursorOffset: d
        } = t;
        d >= o ? d = t.cursorOffset + (p.length - a.length) : c.cursorOffset >= 0 && (d = c.cursorOffset + u);
        let f = e.slice(0, u) + p + e.slice(o);
        if ("lf" !== t.endOfLine) {
          const _e90 = $i(t.endOfLine);
          d >= 0 && "\r\n" === _e90 && (d += Ui(f.slice(0, d), "\n")), f = f.replace(/\n/g, _e90);
        }
        return {
          formatted: f,
          cursorOffset: d
        };
      }(u, t) : (!a && t.insertPragma && t.printer.insertPragma && (u = t.printer.insertPragma(u)), l = Xi(u, t)), r && (l.formatted = "\ufeff" + l.formatted, o && l.cursorOffset >= 0 && l.cursorOffset++), l;
    }
    var Ki = {
      formatWithCursor: (e, t) => Yi(e, t = Ji(t)),
      parse(e, t, n) {
        t = Ji(t), e = zi("\ufeff" === e.charAt(0) ? e.slice(1) : e);
        const r = Va.parse(e, t);
        return n && (r.ast = Ha(r.ast, t)), r;
      },
      formatAST(e, t) {
        t = Ji(t);
        const n = Oi(e, t);
        return Ri(n, t);
      },
      formatDoc(e, t) {
        t = Ji(Object.assign({}, t, {
          parser: "babel"
        }));
        return Yi(qi(e), t).formatted;
      },
      printToDoc(e, t) {
        t = Ji(t);
        const n = Va.parse(e, t),
          {
            ast: r,
            text: u
          } = n;
        return Hi(u, r, t), Oi(r, t);
      },
      printDocToString: (e, t) => Ri(e, Ji(t))
    };
    const {
      getMaxContinuousCount: Qi,
      getStringWidth: Zi,
      getAlignmentSize: es,
      getIndentSize: ts,
      skip: ns,
      skipWhitespace: rs,
      skipSpaces: us,
      skipNewline: os,
      skipToLineEnd: as,
      skipEverythingButNewLine: is,
      skipInlineComment: ss,
      skipTrailingComment: ls,
      hasNewline: cs,
      hasNewlineInRange: ps,
      hasSpaces: ds,
      isNextLineEmpty: fs,
      isNextLineEmptyAfterIndex: hs,
      isPreviousLineEmpty: ms,
      getNextNonSpaceNonCommentCharacterIndex: gs,
      makeString: Ds,
      addLeadingComment: ys,
      addDanglingComment: Es,
      addTrailingComment: Cs
    } = Lt;
    var bs = {
        getMaxContinuousCount: Qi,
        getStringWidth: Zi,
        getAlignmentSize: es,
        getIndentSize: ts,
        skip: ns,
        skipWhitespace: rs,
        skipSpaces: us,
        skipNewline: os,
        skipToLineEnd: as,
        skipEverythingButNewLine: is,
        skipInlineComment: ss,
        skipTrailingComment: ls,
        hasNewline: cs,
        hasNewlineInRange: ps,
        hasSpaces: ds,
        isNextLineEmpty: fs,
        isNextLineEmptyAfterIndex: hs,
        isPreviousLineEmpty: ms,
        getNextNonSpaceNonCommentCharacterIndex: gs,
        makeString: Ds,
        addLeadingComment: ys,
        addDanglingComment: Es,
        addTrailingComment: Cs
      },
      As = function (t, n) {
        const {
            languageId: r
          } = t,
          u = e(t, ["languageId"]);
        return Object.assign({
          linguistLanguageId: r
        }, u, n(t));
      };
    const {
      getLast: vs,
      hasNewline: Fs,
      getNextNonSpaceNonCommentCharacterIndexWithStartIndex: xs,
      getNextNonSpaceNonCommentCharacter: Ss,
      hasNewlineInRange: ws,
      isNodeIgnoreComment: Bs,
      addLeadingComment: Ts,
      addTrailingComment: ks,
      addDanglingComment: Ns,
      getNextNonSpaceNonCommentCharacterIndex: Os
    } = Lt;
    function Ps(e, t) {
      const n = (e.body || e.properties).filter(e => "EmptyStatement" !== e.type);
      0 === n.length ? Ns(e, t) : Ts(n[0], t);
    }
    function _s(e, t) {
      "BlockStatement" === e.type ? Ps(e, t) : Ts(e, t);
    }
    function Is(e, t, n, r, u, o) {
      if (!n || "IfStatement" !== n.type || !r) return !1;
      return ")" === Ss(e, u, o.locEnd) ? (ks(t, u), !0) : t === n.consequent && r === n.alternate ? ("BlockStatement" === t.type ? ks(t, u) : Ns(n, u), !0) : "BlockStatement" === r.type ? (Ps(r, u), !0) : "IfStatement" === r.type ? (_s(r.consequent, u), !0) : n.consequent === r && (Ts(r, u), !0);
    }
    function js(e, t, n, r, u, o) {
      if (!n || "WhileStatement" !== n.type || !r) return !1;
      return ")" === Ss(e, u, o.locEnd) ? (ks(t, u), !0) : "BlockStatement" === r.type && (Ps(r, u), !0);
    }
    function Ms(e, t, n, r) {
      return !(!e || "TryStatement" !== e.type && "CatchClause" !== e.type || !n) && ("CatchClause" === e.type && t ? (ks(t, r), !0) : "BlockStatement" === n.type ? (Ps(n, r), !0) : "TryStatement" === n.type ? (_s(n.finalizer, r), !0) : "CatchClause" === n.type && (_s(n.body, r), !0));
    }
    function Ls(e, t, n, r) {
      if (e && ("ClassDeclaration" === e.type || "ClassExpression" === e.type || "DeclareClass" === e.type || "DeclareInterface" === e.type || "InterfaceDeclaration" === e.type || "TSInterfaceDeclaration" === e.type)) {
        if (e.decorators && e.decorators.length > 0 && (!n || "Decorator" !== n.type)) return ks(e.decorators[e.decorators.length - 1], r), !0;
        if (e.body && n === e.body) return Ps(e.body, r), !0;
        if (n) for (const u of ["implements", "extends", "mixins"]) if (e[u] && n === e[u][0]) return !t || t !== e.id && t !== e.typeParameters && t !== e.superClass ? Ns(e, r, u) : ks(t, r), !0;
      }
      return !1;
    }
    function Rs(e, t, n, r, u) {
      return (t && n && ("Property" === t.type || "TSDeclareMethod" === t.type || "TSAbstractMethodDefinition" === t.type) && "Identifier" === n.type && t.key === n && ":" !== Ss(e, n, u.locEnd) || !(!n || !t || "Decorator" !== n.type || "ClassMethod" !== t.type && "ClassProperty" !== t.type && "TSAbstractClassProperty" !== t.type && "TSAbstractMethodDefinition" !== t.type && "TSDeclareMethod" !== t.type && "MethodDefinition" !== t.type)) && (ks(n, r), !0);
    }
    function qs(e, t, n, r, u, o) {
      if (t && "FunctionTypeParam" === t.type && n && "FunctionTypeAnnotation" === n.type && r && "FunctionTypeParam" !== r.type) return ks(t, u), !0;
      if (t && ("Identifier" === t.type || "AssignmentPattern" === t.type) && n && zs(n) && ")" === Ss(e, u, o.locEnd)) return ks(t, u), !0;
      if (n && "FunctionDeclaration" === n.type && r && "BlockStatement" === r.type) {
        const _t41 = (() => {
          if (0 !== (n.params || n.parameters).length) return xs(e, o.locEnd(vs(n.params || n.parameters)));
          const t = xs(e, o.locEnd(n.id));
          return !1 !== t && xs(e, t + 1);
        })();
        if (o.locStart(u) > _t41) return Ps(r, u), !0;
      }
      return !1;
    }
    function Vs(e, t) {
      return !(!e || "ImportSpecifier" !== e.type) && (Ts(e, t), !0);
    }
    function Ws(e, t) {
      return !(!e || "LabeledStatement" !== e.type) && (Ts(e, t), !0);
    }
    function $s(e, t, n, r) {
      return t && t.body && 0 === t.body.length ? (r ? Ns(t, n) : Ts(t, n), !0) : !(!e || "Program" !== e.type || 0 !== e.body.length || !e.directives || 0 !== e.directives.length) && (r ? Ns(e, n) : Ts(e, n), !0);
    }
    function Us(e) {
      return "Block" === e.type || "CommentBlock" === e.type;
    }
    function zs(e) {
      return "ArrowFunctionExpression" === e.type || "FunctionExpression" === e.type || "FunctionDeclaration" === e.type || "ObjectMethod" === e.type || "ClassMethod" === e.type || "TSDeclareFunction" === e.type || "TSCallSignatureDeclaration" === e.type || "TSConstructSignatureDeclaration" === e.type || "TSConstructSignatureDeclaration" === e.type || "TSMethodSignature" === e.type || "TSConstructorType" === e.type || "TSFunctionType" === e.type || "TSDeclareMethod" === e.type;
    }
    function Js(e) {
      return Us(e) && "*" === e.value[0] && /@type\b/.test(e.value);
    }
    var Gs = {
      handleOwnLineComment: function (e, t, n, r, u) {
        const {
          precedingNode: o,
          enclosingNode: a,
          followingNode: i
        } = e;
        return qs(t, o, a, i, e, n) || function (e, t, n) {
          if (e && ("MemberExpression" === e.type || "OptionalMemberExpression" === e.type) && t && "Identifier" === t.type) return Ts(e, n), !0;
          return !1;
        }(a, i, e) || Is(t, o, a, i, e, n) || js(t, o, a, i, e, n) || Ms(a, o, i, e) || Ls(a, o, i, e) || Vs(a, e) || function (e, t, n) {
          if (e && ("ForInStatement" === e.type || "ForOfStatement" === e.type)) return Ts(e, n), !0;
          return !1;
        }(a, 0, e) || function (e, t, n, r) {
          if (t && ("UnionTypeAnnotation" === t.type || "TSUnionType" === t.type)) return Bs(r) && (n.prettierIgnore = !0, r.unignore = !0), !!e && (ks(e, r), !0);
          n && ("UnionTypeAnnotation" === n.type || "TSUnionType" === n.type) && Bs(r) && (n.types[0].prettierIgnore = !0, r.unignore = !0);
          return !1;
        }(o, a, i, e) || $s(a, r, e, u) || function (e, t, n, r, u) {
          if (n && "ImportSpecifier" === n.type && t && "ImportDeclaration" === t.type && Fs(e, u.locEnd(r))) return ks(n, r), !0;
          return !1;
        }(t, a, o, e, n) || function (e, t) {
          if (e && "AssignmentPattern" === e.type) return Ts(e, t), !0;
          return !1;
        }(a, e) || Rs(t, a, o, e, n) || Ws(a, e);
      },
      handleEndOfLineComment: function (e, t, n, r, u) {
        const {
          precedingNode: o,
          enclosingNode: a,
          followingNode: i
        } = e;
        return function (e, t) {
          if (e && Js(t)) return Ts(e, t), !0;
          return !1;
        }(i, e) || qs(t, o, a, i, e, n) || function (e, t, n, r, u, o) {
          const a = t && !ws(u, o.locEnd(t), o.locStart(r));
          if ((!t || !a) && e && ("ConditionalExpression" === e.type || "TSConditionalType" === e.type) && n) return Ts(n, r), !0;
          return !1;
        }(a, o, i, e, t, n) || Vs(a, e) || Is(t, o, a, i, e, n) || js(t, o, a, i, e, n) || Ms(a, o, i, e) || Ls(a, o, i, e) || Ws(a, e) || function (e, t, n) {
          if (t && ("CallExpression" === t.type || "OptionalCallExpression" === t.type) && e && t.callee === e && t.arguments.length > 0) return Ts(t.arguments[0], n), !0;
          return !1;
        }(o, a, e) || function (e, t) {
          if (e && ("Property" === e.type || "ObjectProperty" === e.type)) return Ts(e, t), !0;
          return !1;
        }(a, e) || $s(a, r, e, u) || function (e, t, n) {
          if (e && "TypeAlias" === e.type) return Ts(e, n), !0;
          return !1;
        }(a, 0, e) || function (e, t, n) {
          if (e && ("VariableDeclarator" === e.type || "AssignmentExpression" === e.type) && t && ("ObjectExpression" === t.type || "ArrayExpression" === t.type || "TemplateLiteral" === t.type || "TaggedTemplateExpression" === t.type || Us(n))) return Ts(t, n), !0;
          return !1;
        }(a, i, e);
      },
      handleRemainingComment: function (e, t, n, r, u) {
        const {
          precedingNode: o,
          enclosingNode: a,
          followingNode: i
        } = e;
        return !!(Is(t, o, a, i, e, n) || js(t, o, a, i, e, n) || function (e, t, n) {
          if (e && ("ObjectProperty" === e.type || "Property" === e.type) && e.shorthand && e.key === t && "AssignmentPattern" === e.value.type) return ks(e.value.left, n), !0;
          return !1;
        }(a, o, e) || function (e, t, n, r) {
          if (")" !== Ss(e, n, r.locEnd)) return !1;
          if (t && (zs(t) && 0 === (t.params || t.parameters).length || ("CallExpression" === t.type || "OptionalCallExpression" === t.type || "NewExpression" === t.type) && 0 === t.arguments.length)) return Ns(t, n), !0;
          if (t && "MethodDefinition" === t.type && 0 === t.value.params.length) return Ns(t.value, n), !0;
          return !1;
        }(t, a, e, n) || Rs(t, a, o, e, n) || $s(a, r, e, u) || function (e, t, n, r) {
          if (!t || "ArrowFunctionExpression" !== t.type) return !1;
          const u = Os(e, n, r.locEnd);
          if (!1 !== u && "=>" === e.slice(u, u + 2)) return Ns(t, n), !0;
          return !1;
        }(t, a, e, n) || function (e, t, n, r, u) {
          if ("(" !== Ss(e, r, u.locEnd)) return !1;
          if (n && t && ("FunctionDeclaration" === t.type || "FunctionExpression" === t.type || "ClassMethod" === t.type || "MethodDefinition" === t.type || "ObjectMethod" === t.type)) return ks(n, r), !0;
          return !1;
        }(t, a, o, e, n) || function (e, t, n, r, u) {
          if (!t || "TSMappedType" !== t.type) return !1;
          if (r && "TSTypeParameter" === r.type && r.name) return Ts(r.name, u), !0;
          if (n && "TSTypeParameter" === n.type && n.constraint) return ks(n.constraint, u), !0;
          return !1;
        }(0, a, o, i, e) || function (e, t) {
          if (e && ("ContinueStatement" === e.type || "BreakStatement" === e.type) && !e.label) return ks(e, t), !0;
          return !1;
        }(a, e) || function (e, t, n, r, u) {
          if (!n && t && ("TSMethodSignature" === t.type || "TSDeclareFunction" === t.type || "TSAbstractMethodDefinition" === t.type) && ";" === Ss(e, r, u.locEnd)) return ks(t, r), !0;
          return !1;
        }(t, a, i, e, n));
      },
      hasLeadingComment: function (e, t = () => !0) {
        return e.leadingComments ? e.leadingComments.some(t) : !!e.comments && e.comments.some(e => e.leading && t(e));
      },
      isBlockComment: Us,
      isTypeCastComment: Js,
      getGapRegex: function (e) {
        if (e && "BinaryExpression" !== e.type && "LogicalExpression" !== e.type) return /^[\s&(|]*$/;
      },
      getCommentChildNodes: function (e, t) {
        if (("typescript" === t.parser || "flow" === t.parser) && "MethodDefinition" === e.type && e.value && "FunctionExpression" === e.value.type && 0 === e.value.params.length && !e.value.returnType && (!e.value.typeParameters || 0 === e.value.typeParameters.length) && e.value.body) return [...(e.decorators || []), e.key, e.value.body];
      }
    };
    const {
        builders: {
          indent: Hs,
          join: Xs,
          line: Ys,
          hardline: Ks,
          softline: Qs,
          literalline: Zs,
          concat: el,
          group: tl,
          dedentToRoot: nl
        },
        utils: {
          mapDoc: rl,
          replaceNewlinesWithLiterallines: ul
        }
      } = dn,
      {
        isBlockComment: ol,
        hasLeadingComment: al
      } = Gs;
    function il(e) {
      return e.replace(/([\\`]|\${)/g, "\\$1");
    }
    function sl(e, t) {
      return rl(e, e => {
        if (!e.parts) return e;
        const n = e.parts.map(e => "string" == typeof e ? t ? e.replace(/(\\*)`/g, "$1$1\\`") : il(e) : e);
        return Object.assign({}, e, {
          parts: n
        });
      });
    }
    function ll(e) {
      const t = [];
      let n = !1;
      return e.map(e => e.trim()).forEach((e, r, u) => {
        "" !== e && ("" === u[r - 1] && n ? t.push(el([Ks, e])) : t.push(e), n = !0);
      }), 0 === t.length ? null : Xs(Ks, t);
    }
    function cl(e) {
      const t = e.getValue(),
        n = e.getParentNode(),
        r = e.getParentNode(1);
      return r && t.quasis && "JSXExpressionContainer" === n.type && "JSXElement" === r.type && "style" === r.openingElement.name.name && r.openingElement.attributes.some(e => "jsx" === e.name.name) || n && "TaggedTemplateExpression" === n.type && "Identifier" === n.tag.type && "css" === n.tag.name || n && "TaggedTemplateExpression" === n.type && "MemberExpression" === n.tag.type && "css" === n.tag.object.name && ("global" === n.tag.property.name || "resolve" === n.tag.property.name);
    }
    function pl(e) {
      return e.match(e => "TemplateLiteral" === e.type, (e, t) => "ArrayExpression" === e.type && "elements" === t, (e, t) => ("Property" === e.type || "ObjectProperty" === e.type) && "Identifier" === e.key.type && "styles" === e.key.name && "value" === t, ...dl);
    }
    const dl = [(e, t) => "ObjectExpression" === e.type && "properties" === t, (e, t) => "CallExpression" === e.type && "Identifier" === e.callee.type && "Component" === e.callee.name && "arguments" === t, (e, t) => "Decorator" === e.type && "expression" === t];
    function fl(e) {
      const t = e.getParentNode();
      if (!t || "TaggedTemplateExpression" !== t.type) return !1;
      const {
        tag: n
      } = t;
      switch (n.type) {
        case "MemberExpression":
          return ml(n.object) || gl(n);
        case "CallExpression":
          return ml(n.callee) || "MemberExpression" === n.callee.type && ("MemberExpression" === n.callee.object.type && (ml(n.callee.object.object) || gl(n.callee.object)) || "CallExpression" === n.callee.object.type && ml(n.callee.object.callee));
        case "Identifier":
          return "css" === n.name;
        default:
          return !1;
      }
    }
    function hl(e) {
      const t = e.getParentNode(),
        n = e.getParentNode(1);
      return n && "JSXExpressionContainer" === t.type && "JSXAttribute" === n.type && "JSXIdentifier" === n.name.type && "css" === n.name.name;
    }
    function ml(e) {
      return "Identifier" === e.type && "styled" === e.name;
    }
    function gl(e) {
      return /^[A-Z]/.test(e.object.name) && "extend" === e.property.name;
    }
    function Dl(e, t) {
      return al(e, e => ol(e) && e.value === " ".concat(t, " "));
    }
    let yl = 0;
    var El = function (e, t, n, r) {
      const u = e.getValue(),
        o = e.getParentNode(),
        a = e.getParentNode(1);
      switch (u.type) {
        case "TemplateLiteral":
          {
            if ([cl, fl, hl, pl].some(t => t(e))) {
              const _r19 = u.quasis.map(e => e.value.raw);
              let _o6 = 0;
              const _a6 = _r19.reduce((e, t, n) => 0 === n ? t : e + "@prettier-placeholder-" + _o6++ + "-id" + t, "");
              return function (e, t, n) {
                const r = t.getValue();
                if (1 === r.quasis.length && !r.quasis[0].value.raw.trim()) return "``";
                const u = r.expressions ? t.map(n, "expressions") : [],
                  o = function (e, t) {
                    if (!t || !t.length) return e;
                    let n = 0;
                    const r = rl(e, e => {
                      if (!e || !e.parts || !e.parts.length) return e;
                      let {
                        parts: r
                      } = e;
                      const u = r.indexOf("@"),
                        o = u + 1;
                      if (u > -1 && "string" == typeof r[o] && r[o].startsWith("prettier-placeholder")) {
                        const _e91 = r[u],
                          t = r[o],
                          n = r.slice(o + 1);
                        r = r.slice(0, u).concat([_e91 + t]).concat(n);
                      }
                      const a = [];
                      return r.forEach(e => {
                        "string" == typeof e && e.includes("@prettier-placeholder") ? e.split(/@prettier-placeholder-(\d+)-id/).forEach((e, r) => {
                          r % 2 != 0 ? (a.push("${", t[e], "}"), n++) : a.push(ul(e));
                        }) : a.push(e);
                      }), Object.assign({}, e, {
                        parts: a
                      });
                    });
                    return t.length === n ? r : null;
                  }(e, u);
                if (!o) throw new Error("Couldn't insert all the expressions");
                return el(["`", Hs(el([Ks, o])), Qs, "`"]);
              }(n(_a6, {
                parser: "scss"
              }, {
                stripTrailingHardline: !0
              }), e, t);
            }
            if (function (e) {
              const t = e.getValue(),
                n = e.getParentNode();
              return Dl(t, "GraphQL") || n && ("TaggedTemplateExpression" === n.type && ("MemberExpression" === n.tag.type && "graphql" === n.tag.object.name && "experimental" === n.tag.property.name || "Identifier" === n.tag.type && ("gql" === n.tag.name || "graphql" === n.tag.name)) || "CallExpression" === n.type && "Identifier" === n.callee.type && "graphql" === n.callee.name);
            }(e)) {
              const _r20 = u.expressions ? e.map(t, "expressions") : [],
                _o7 = u.quasis.length;
              if (1 === _o7 && "" === u.quasis[0].value.raw.trim()) return "``";
              const _a7 = [];
              for (let _e92 = 0; _e92 < _o7; _e92++) {
                const _t42 = 0 === _e92,
                  _i3 = _e92 === _o7 - 1,
                  s = u.quasis[_e92].value.cooked;
                if ("string" != typeof s) return null;
                const l = s.split("\n"),
                  c = l.length,
                  p = _r20[_e92],
                  d = c > 2 && "" === l[0].trim() && "" === l[1].trim(),
                  f = c > 2 && "" === l[c - 1].trim() && "" === l[c - 2].trim(),
                  h = l.every(e => /^\s*(?:#[^\n\r]*)?$/.test(e));
                if (!_i3 && /#[^\n\r]*$/.test(l[c - 1])) return null;
                let m = null;
                m = h ? ll(l) : n(s, {
                  parser: "graphql"
                }, {
                  stripTrailingHardline: !0
                }), m ? (m = sl(m, !1), !_t42 && d && _a7.push(""), _a7.push(m), !_i3 && f && _a7.push("")) : _t42 || _i3 || !d || _a7.push(""), p && _a7.push(el(["${", p, "}"]));
              }
              return el(["`", Hs(el([Ks, Xs(Ks, _a7)])), Ks, "`"]);
            }
            const _o8 = function (e) {
              return Dl(e.getValue(), "HTML") || e.match(e => "TemplateLiteral" === e.type, (e, t) => "TaggedTemplateExpression" === e.type && "Identifier" === e.tag.type && "html" === e.tag.name && "quasi" === t);
            }(e) ? "html" : function (e) {
              return e.match(e => "TemplateLiteral" === e.type, (e, t) => ("Property" === e.type || "ObjectProperty" === e.type) && "Identifier" === e.key.type && "template" === e.key.name && "value" === t, ...dl);
            }(e) ? "angular" : void 0;
            if (_o8) return function (e, t, n, r, u) {
              const o = e.getValue(),
                a = yl;
              yl = yl + 1 >>> 0;
              const i = e => "PRETTIER_HTML_PLACEHOLDER_".concat(e, "_").concat(a, "_IN_JS"),
                s = o.quasis.map((e, t, n) => t === n.length - 1 ? e.value.cooked : e.value.cooked + i(t)).join(""),
                l = e.map(t, "expressions");
              if (0 === l.length && 0 === s.trim().length) return "``";
              const c = new RegExp(i("(\\d+)"), "g");
              let p = 0;
              const d = rl(n(s, {
                  parser: r,
                  __onHtmlRoot(e) {
                    p = e.children.length;
                  }
                }, {
                  stripTrailingHardline: !0
                }), e => {
                  if ("string" != typeof e) return e;
                  const t = [],
                    n = e.split(c);
                  for (let _e93 = 0; _e93 < n.length; _e93++) {
                    let r = n[_e93];
                    if (_e93 % 2 == 0) {
                      r && (r = il(r), u.embeddedInHtml && (r = r.replace(/<\/(script)\b/gi, "<\\/$1")), t.push(r));
                      continue;
                    }
                    const o = +r;
                    t.push(el(["${", tl(l[o]), "}"]));
                  }
                  return el(t);
                }),
                f = /^\s/.test(s) ? " " : "",
                h = /\s$/.test(s) ? " " : "",
                m = "ignore" === u.htmlWhitespaceSensitivity ? Ks : f && h ? Ys : null;
              if (m) return tl(el(["`", Hs(el([m, tl(d)])), m, "`"]));
              return tl(el(["`", f, p > 1 ? Hs(tl(d)) : tl(d), h, "`"]));
            }(e, t, n, _o8, r);
            break;
          }
        case "TemplateElement":
          if (a && "TaggedTemplateExpression" === a.type && 1 === o.quasis.length && "Identifier" === a.tag.type && ("md" === a.tag.name || "markdown" === a.tag.name)) {
            const _e94 = o.quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (e, t) => "\\".repeat(t.length / 2) + "`"),
              _t43 = function (e) {
                const t = e.match(/^([^\S\n]*)\S/m);
                return null === t ? "" : t[1];
              }(_e94);
            return el(["" !== _t43 ? Hs(el([Qs, i(_e94.replace(new RegExp("^".concat(_t43), "gm"), ""))])) : el([Zs, nl(i(_e94))]), Qs]);
          }
      }
      function i(e) {
        return sl(n(e, {
          parser: "markdown",
          __inJsTemplate: !0
        }, {
          stripTrailingHardline: !0
        }), !0);
      }
    };
    var Cl = function (e, t, n) {
      if (["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"].forEach(e => {
        delete t[e];
      }), "Program" === e.type && delete t.sourceType, "BigIntLiteral" === e.type && (t.value && (t.value = t.value.toLowerCase()), t.bigint && (t.bigint = t.bigint.toLowerCase())), "DecimalLiteral" === e.type && (t.value = Number(t.value)), "EmptyStatement" === e.type) return null;
      if ("JSXText" === e.type) return null;
      if ("JSXExpressionContainer" === e.type && ("Literal" === e.expression.type || "StringLiteral" === e.expression.type) && " " === e.expression.value) return null;
      if ("Property" !== e.type && "ObjectProperty" !== e.type && "MethodDefinition" !== e.type && "ClassProperty" !== e.type && "ClassMethod" !== e.type && "TSDeclareMethod" !== e.type && "TSPropertySignature" !== e.type && "ObjectTypeProperty" !== e.type || "object" != typeof e.key || !e.key || "Literal" !== e.key.type && "NumericLiteral" !== e.key.type && "StringLiteral" !== e.key.type && "Identifier" !== e.key.type || delete t.key, "OptionalMemberExpression" === e.type && !1 === e.optional && (t.type = "MemberExpression", delete t.optional), "JSXElement" === e.type && "style" === e.openingElement.name.name && e.openingElement.attributes.some(e => "jsx" === e.name.name)) {
        t.children.filter(e => "JSXExpressionContainer" === e.type && "TemplateLiteral" === e.expression.type).map(e => e.expression).reduce((e, t) => e.concat(t.quasis), []).forEach(e => delete e.value);
      }
      "JSXAttribute" === e.type && "css" === e.name.name && "JSXExpressionContainer" === e.value.type && "TemplateLiteral" === e.value.expression.type && t.value.expression.quasis.forEach(e => delete e.value), "JSXAttribute" === e.type && e.value && "Literal" === e.value.type && /["']|&quot;|&apos;/.test(e.value.value) && (t.value.value = t.value.value.replace(/["']|&quot;|&apos;/g, '"'));
      const r = e.expression || e.callee;
      if ("Decorator" === e.type && "CallExpression" === r.type && "Component" === r.callee.name && 1 === r.arguments.length) {
        const _n14 = e.expression.arguments[0].properties;
        t.expression.arguments[0].properties.forEach((e, t) => {
          let r = null;
          switch (_n14[t].key.name) {
            case "styles":
              "ArrayExpression" === e.value.type && (r = e.value.elements[0]);
              break;
            case "template":
              "TemplateLiteral" === e.value.type && (r = e.value);
          }
          r && r.quasis.forEach(e => delete e.value);
        });
      }
      if ("TaggedTemplateExpression" !== e.type || "MemberExpression" !== e.tag.type && ("Identifier" !== e.tag.type || "gql" !== e.tag.name && "graphql" !== e.tag.name && "css" !== e.tag.name && "md" !== e.tag.name && "markdown" !== e.tag.name && "html" !== e.tag.name) && "CallExpression" !== e.tag.type || t.quasi.quasis.forEach(e => delete e.value), "TemplateLiteral" === e.type) {
        (e.leadingComments && e.leadingComments.some(e => "CommentBlock" === e.type && ["GraphQL", "HTML"].some(t => e.value === " ".concat(t, " "))) || "CallExpression" === n.type && "graphql" === n.callee.name) && t.quasis.forEach(e => delete e.value), e.leadingComments || t.quasis.forEach(e => {
          e.value && delete e.value.cooked;
        });
      }
      "InterpreterDirective" === e.type && (t.value = t.value.trimEnd());
    };
    const bl = e => {
      if ("string" != typeof e) throw new TypeError("Expected a string");
      const t = e.match(/(?:\r?\n)/g) || [];
      if (0 === t.length) return;
      const n = t.filter(e => "\r\n" === e).length;
      return n > t.length - n ? "\r\n" : "\n";
    };
    var Al = bl;
    Al.graceful = e => "string" == typeof e && bl(e) || "\n";
    var vl = $e(function (e, t) {
      function n() {
        const e = Rr;
        return n = function () {
          return e;
        }, e;
      }
      function r() {
        const e = (t = Al) && t.__esModule ? t : {
          default: t
        };
        var t;
        return r = function () {
          return e;
        }, e;
      }
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.extract = function (e) {
        const t = e.match(a);
        return t ? t[0].trimLeft() : "";
      }, t.strip = function (e) {
        const t = e.match(a);
        return t && t[0] ? e.substring(t[0].length) : e;
      }, t.parse = function (e) {
        return f(e).pragmas;
      }, t.parseWithComments = f, t.print = function ({
        comments: e = "",
        pragmas: t = {}
      }) {
        const u = (0, r().default)(e) || n().EOL,
          o = Object.keys(t),
          a = o.map(e => h(e, t[e])).reduce((e, t) => e.concat(t), []).map(e => " * " + e + u).join("");
        if (!e) {
          if (0 === o.length) return "";
          if (1 === o.length && !Array.isArray(t[o[0]])) {
            const _e95 = t[o[0]];
            return "".concat("/**", " ").concat(h(o[0], _e95)[0]).concat(" */");
          }
        }
        const i = e.split(u).map(e => "".concat(" *", " ").concat(e)).join(u) + u;
        return "/**" + u + (e ? i : "") + (e && o.length ? " *" + u : "") + a + " */";
      };
      const u = /\*\/$/,
        o = /^\/\*\*/,
        a = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/,
        i = /(^|\s+)\/\/([^\r\n]*)/g,
        s = /^(\r?\n)+/,
        l = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g,
        c = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g,
        p = /(\r?\n|^) *\* ?/g,
        d = [];
      function f(e) {
        const t = (0, r().default)(e) || n().EOL;
        e = e.replace(o, "").replace(u, "").replace(p, "$1");
        let a = "";
        for (; a !== e;) a = e, e = e.replace(l, "".concat(t, "$1 $2").concat(t));
        e = e.replace(s, "").trimRight();
        const f = Object.create(null),
          h = e.replace(c, "").replace(s, "").trimRight();
        let m;
        for (; m = c.exec(e);) {
          const _e96 = m[2].replace(i, "");
          "string" == typeof f[m[1]] || Array.isArray(f[m[1]]) ? f[m[1]] = d.concat(f[m[1]], _e96) : f[m[1]] = _e96;
        }
        return {
          comments: h,
          pragmas: f
        };
      }
      function h(e, t) {
        return d.concat(t).map(t => "@".concat(e, " ").concat(t).trim());
      }
    });
    const {
        parseWithComments: Fl,
        strip: xl,
        extract: Sl,
        print: wl
      } = vl,
      {
        getShebang: Bl
      } = Lt,
      {
        normalizeEndOfLine: Tl
      } = Rt;
    function kl(e) {
      const t = Bl(e);
      t && (e = e.slice(t.length + 1));
      const n = Sl(e),
        {
          pragmas: r,
          comments: u
        } = Fl(n);
      return {
        shebang: t,
        text: e,
        pragmas: r,
        comments: u
      };
    }
    var Nl = {
        hasPragma: function (e) {
          const t = Object.keys(kl(e).pragmas);
          return t.includes("prettier") || t.includes("format");
        },
        insertPragma: function (e) {
          const {
              shebang: t,
              text: n,
              pragmas: r,
              comments: u
            } = kl(e),
            o = xl(n),
            a = wl({
              pragmas: Object.assign({
                format: ""
              }, r),
              comments: u.trimStart()
            });
          return (t ? "".concat(t, "\n") : "") + Tl(a) + (o.startsWith("\n") ? "\n" : "\n\n") + o;
        }
      },
      Ol = $e(function (e) {
        !function () {
          function t(e) {
            if (null == e) return !1;
            switch (e.type) {
              case "BlockStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "DebuggerStatement":
              case "DoWhileStatement":
              case "EmptyStatement":
              case "ExpressionStatement":
              case "ForInStatement":
              case "ForStatement":
              case "IfStatement":
              case "LabeledStatement":
              case "ReturnStatement":
              case "SwitchStatement":
              case "ThrowStatement":
              case "TryStatement":
              case "VariableDeclaration":
              case "WhileStatement":
              case "WithStatement":
                return !0;
            }
            return !1;
          }
          function n(e) {
            switch (e.type) {
              case "IfStatement":
                return null != e.alternate ? e.alternate : e.consequent;
              case "LabeledStatement":
              case "ForStatement":
              case "ForInStatement":
              case "WhileStatement":
              case "WithStatement":
                return e.body;
            }
            return null;
          }
          e.exports = {
            isExpression: function (e) {
              if (null == e) return !1;
              switch (e.type) {
                case "ArrayExpression":
                case "AssignmentExpression":
                case "BinaryExpression":
                case "CallExpression":
                case "ConditionalExpression":
                case "FunctionExpression":
                case "Identifier":
                case "Literal":
                case "LogicalExpression":
                case "MemberExpression":
                case "NewExpression":
                case "ObjectExpression":
                case "SequenceExpression":
                case "ThisExpression":
                case "UnaryExpression":
                case "UpdateExpression":
                  return !0;
              }
              return !1;
            },
            isStatement: t,
            isIterationStatement: function (e) {
              if (null == e) return !1;
              switch (e.type) {
                case "DoWhileStatement":
                case "ForInStatement":
                case "ForStatement":
                case "WhileStatement":
                  return !0;
              }
              return !1;
            },
            isSourceElement: function (e) {
              return t(e) || null != e && "FunctionDeclaration" === e.type;
            },
            isProblematicIfStatement: function (e) {
              var t;
              if ("IfStatement" !== e.type) return !1;
              if (null == e.alternate) return !1;
              t = e.consequent;
              do {
                if ("IfStatement" === t.type && null == t.alternate) return !0;
                t = n(t);
              } while (t);
              return !1;
            },
            trailingStatement: n
          };
        }();
      }),
      Pl = $e(function (e) {
        !function () {
          var t, n, r, u, o, a;
          function i(e) {
            return e <= 65535 ? String.fromCharCode(e) : String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296) + String.fromCharCode((e - 65536) % 1024 + 56320);
          }
          for (n = {
            NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
            NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
          }, t = {
            NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
            NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
          }, r = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279], u = new Array(128), a = 0; a < 128; ++a) u[a] = a >= 97 && a <= 122 || a >= 65 && a <= 90 || 36 === a || 95 === a;
          for (o = new Array(128), a = 0; a < 128; ++a) o[a] = a >= 97 && a <= 122 || a >= 65 && a <= 90 || a >= 48 && a <= 57 || 36 === a || 95 === a;
          e.exports = {
            isDecimalDigit: function (e) {
              return 48 <= e && e <= 57;
            },
            isHexDigit: function (e) {
              return 48 <= e && e <= 57 || 97 <= e && e <= 102 || 65 <= e && e <= 70;
            },
            isOctalDigit: function (e) {
              return e >= 48 && e <= 55;
            },
            isWhiteSpace: function (e) {
              return 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && r.indexOf(e) >= 0;
            },
            isLineTerminator: function (e) {
              return 10 === e || 13 === e || 8232 === e || 8233 === e;
            },
            isIdentifierStartES5: function (e) {
              return e < 128 ? u[e] : n.NonAsciiIdentifierStart.test(i(e));
            },
            isIdentifierPartES5: function (e) {
              return e < 128 ? o[e] : n.NonAsciiIdentifierPart.test(i(e));
            },
            isIdentifierStartES6: function (e) {
              return e < 128 ? u[e] : t.NonAsciiIdentifierStart.test(i(e));
            },
            isIdentifierPartES6: function (e) {
              return e < 128 ? o[e] : t.NonAsciiIdentifierPart.test(i(e));
            }
          };
        }();
      }),
      _l = $e(function (e) {
        !function () {
          var t = Pl;
          function n(e, t) {
            return !(!t && "yield" === e) && r(e, t);
          }
          function r(e, t) {
            if (t && function (e) {
              switch (e) {
                case "implements":
                case "interface":
                case "package":
                case "private":
                case "protected":
                case "public":
                case "static":
                case "let":
                  return !0;
                default:
                  return !1;
              }
            }(e)) return !0;
            switch (e.length) {
              case 2:
                return "if" === e || "in" === e || "do" === e;
              case 3:
                return "var" === e || "for" === e || "new" === e || "try" === e;
              case 4:
                return "this" === e || "else" === e || "case" === e || "void" === e || "with" === e || "enum" === e;
              case 5:
                return "while" === e || "break" === e || "catch" === e || "throw" === e || "const" === e || "yield" === e || "class" === e || "super" === e;
              case 6:
                return "return" === e || "typeof" === e || "delete" === e || "switch" === e || "export" === e || "import" === e;
              case 7:
                return "default" === e || "finally" === e || "extends" === e;
              case 8:
                return "function" === e || "continue" === e || "debugger" === e;
              case 10:
                return "instanceof" === e;
              default:
                return !1;
            }
          }
          function u(e, t) {
            return "null" === e || "true" === e || "false" === e || n(e, t);
          }
          function o(e, t) {
            return "null" === e || "true" === e || "false" === e || r(e, t);
          }
          function a(e) {
            var n, r, u;
            if (0 === e.length) return !1;
            if (u = e.charCodeAt(0), !t.isIdentifierStartES5(u)) return !1;
            for (n = 1, r = e.length; n < r; ++n) if (u = e.charCodeAt(n), !t.isIdentifierPartES5(u)) return !1;
            return !0;
          }
          function i(e) {
            var n, r, u, o, a;
            if (0 === e.length) return !1;
            for (a = t.isIdentifierStartES6, n = 0, r = e.length; n < r; ++n) {
              if (55296 <= (u = e.charCodeAt(n)) && u <= 56319) {
                if (++n >= r) return !1;
                if (!(56320 <= (o = e.charCodeAt(n)) && o <= 57343)) return !1;
                u = 1024 * (u - 55296) + (o - 56320) + 65536;
              }
              if (!a(u)) return !1;
              a = t.isIdentifierPartES6;
            }
            return !0;
          }
          e.exports = {
            isKeywordES5: n,
            isKeywordES6: r,
            isReservedWordES5: u,
            isReservedWordES6: o,
            isRestrictedWord: function (e) {
              return "eval" === e || "arguments" === e;
            },
            isIdentifierNameES5: a,
            isIdentifierNameES6: i,
            isIdentifierES5: function (e, t) {
              return a(e) && !u(e, t);
            },
            isIdentifierES6: function (e, t) {
              return i(e) && !o(e, t);
            }
          };
        }();
      });
    const Il = $e(function (e, t) {
        t.ast = Ol, t.code = Pl, t.keyword = _l;
      }).keyword.isIdentifierNameES5,
      {
        getLast: jl,
        hasNewline: Ml,
        hasNewlineInRange: Ll,
        hasIgnoreComment: Rl,
        hasNodeIgnoreComment: ql,
        skipWhitespace: Vl
      } = Lt,
      Wl = new RegExp("^".concat("(?:(?=.)\\s)", "*:")),
      $l = new RegExp("^".concat("(?:(?=.)\\s)", "*::"));
    function Ul(e, t) {
      if (!e || "object" != typeof e) return !1;
      if (Array.isArray(e)) return e.some(e => Ul(e, t));
      const n = t(e);
      return "boolean" == typeof n ? n : Object.keys(e).some(n => Ul(e[n], t));
    }
    function zl(e) {
      return "AssignmentExpression" === e.type || "BinaryExpression" === e.type || "LogicalExpression" === e.type || "NGPipeExpression" === e.type || "ConditionalExpression" === e.type || "CallExpression" === e.type || "OptionalCallExpression" === e.type || "MemberExpression" === e.type || "OptionalMemberExpression" === e.type || "SequenceExpression" === e.type || "TaggedTemplateExpression" === e.type || "BindExpression" === e.type || "UpdateExpression" === e.type && !e.prefix || "TSAsExpression" === e.type || "TSNonNullExpression" === e.type;
    }
    const Jl = new Set(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
    function Gl(e) {
      return e && Jl.has(e.type);
    }
    function Hl(e) {
      return "BooleanLiteral" === e.type || "DirectiveLiteral" === e.type || "Literal" === e.type || "NullLiteral" === e.type || "NumericLiteral" === e.type || "BigIntLiteral" === e.type || "DecimalLiteral" === e.type || "RegExpLiteral" === e.type || "StringLiteral" === e.type || "TemplateLiteral" === e.type || "TSTypeLiteral" === e.type || "JSXText" === e.type;
    }
    function Xl(e) {
      return "NumericLiteral" === e.type || "Literal" === e.type && "number" == typeof e.value;
    }
    function Yl(e) {
      return "StringLiteral" === e.type || "Literal" === e.type && "string" == typeof e.value;
    }
    function Kl(e) {
      return "FunctionExpression" === e.type || "ArrowFunctionExpression" === e.type;
    }
    function Ql(e) {
      return !("CallExpression" !== e.type && "OptionalCallExpression" !== e.type || "Identifier" !== e.callee.type || "async" !== e.callee.name && "inject" !== e.callee.name && "fakeAsync" !== e.callee.name);
    }
    function Zl(e) {
      return "JSXElement" === e.type || "JSXFragment" === e.type;
    }
    function ec(e) {
      return "get" === e.kind || "set" === e.kind;
    }
    function tc(e, t, n) {
      return n.locStart(e) === n.locStart(t);
    }
    function nc(e, t) {
      return ec(e) || tc(e, e.value, t);
    }
    const rc = new Set(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
    const uc = new Set(["AnyTypeAnnotation", "NullLiteralTypeAnnotation", "GenericTypeAnnotation", "ThisTypeAnnotation", "NumberTypeAnnotation", "VoidTypeAnnotation", "EmptyTypeAnnotation", "MixedTypeAnnotation", "BooleanTypeAnnotation", "BooleanLiteralTypeAnnotation", "StringTypeAnnotation"]);
    const oc = /^(skip|[fx]?(it|describe|test))$/;
    function ac(e) {
      return "CallExpression" === e.type || "OptionalCallExpression" === e.type;
    }
    const ic = new RegExp("([ \n\r\t]+)"),
      sc = new RegExp("[^ \n\r\t]");
    function lc(e) {
      return Hl(e) && (sc.test(fc(e)) || !/\n/.test(fc(e)));
    }
    function cc(e, t, n) {
      if (Zl(t)) return ql(t);
      return t.comments && t.comments.some(t => t.leading && Ml(e, n.locEnd(t)));
    }
    function pc(e) {
      return /^(\d+|\d+\.\d+)$/.test(e);
    }
    function dc(e) {
      return e.quasis.some(e => e.value.raw.includes("\n"));
    }
    function fc(e) {
      return e.extra ? e.extra.raw : e.raw;
    }
    const hc = {
        "==": !0,
        "!=": !0,
        "===": !0,
        "!==": !0
      },
      mc = {
        "*": !0,
        "/": !0,
        "%": !0
      },
      gc = {
        ">>": !0,
        ">>>": !0,
        "<<": !0
      };
    const Dc = {};
    function yc(e) {
      return Dc[e];
    }
    [["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].forEach((e, t) => {
      e.forEach(e => {
        Dc[e] = t;
      });
    });
    var Ec = {
      classChildNeedsASIProtection: function (e) {
        if (e) {
          if (e.static || e.accessibility) return !1;
          if (!e.computed) {
            const t = e.key && e.key.name;
            if ("in" === t || "instanceof" === t) return !0;
          }
          switch (e.type) {
            case "ClassProperty":
            case "TSAbstractClassProperty":
              return e.computed;
            case "MethodDefinition":
            case "TSAbstractMethodDefinition":
            case "ClassMethod":
            case "ClassPrivateMethod":
              {
                const t = e.value ? e.value.async : e.async,
                  n = e.value ? e.value.generator : e.generator;
                return !t && "get" !== e.kind && "set" !== e.kind && !(!e.computed && !n);
              }
            case "TSIndexSignature":
              return !0;
            default:
              return !1;
          }
        }
      },
      classPropMayCauseASIProblems: function (e) {
        const t = e.getNode();
        if ("ClassProperty" !== t.type) return !1;
        const n = t.key && t.key.name;
        return !("static" !== n && "get" !== n && "set" !== n || t.value || t.typeAnnotation) || void 0;
      },
      getFlowVariance: function (e) {
        if (!e.variance) return null;
        const t = e.variance.kind || e.variance;
        switch (t) {
          case "plus":
            return "+";
          case "minus":
            return "-";
          default:
            return t;
        }
      },
      getLeftSidePathName: function (e, t) {
        if (t.expressions) return ["expressions", 0];
        if (t.left) return ["left"];
        if (t.test) return ["test"];
        if (t.object) return ["object"];
        if (t.callee) return ["callee"];
        if (t.tag) return ["tag"];
        if (t.argument) return ["argument"];
        if (t.expression) return ["expression"];
        throw new Error("Unexpected node has no left side.");
      },
      getParentExportDeclaration: function (e) {
        const t = e.getParentNode();
        return "declaration" === e.getName() && Gl(t) ? t : null;
      },
      getTypeScriptMappedTypeModifier: function (e, t) {
        return "+" === e ? "+" + t : "-" === e ? "-" + t : t;
      },
      hasDanglingComments: function (e) {
        return e.comments && e.comments.some(e => !e.leading && !e.trailing);
      },
      hasFlowAnnotationComment: function (e) {
        return e && $l.test(e[0].value);
      },
      hasFlowShorthandAnnotationComment: function (e) {
        return e.extra && e.extra.parenthesized && e.trailingComments && Wl.test(e.trailingComments[0].value);
      },
      hasLeadingComment: function (e) {
        return e.comments && e.comments.some(e => e.leading);
      },
      hasLeadingOwnLineComment: cc,
      hasNakedLeftSide: zl,
      hasNewlineBetweenOrAfterDecorators: function (e, t) {
        return Ll(t.originalText, t.locStart(e.decorators[0]), t.locEnd(jl(e.decorators))) || Ml(t.originalText, t.locEnd(jl(e.decorators)));
      },
      hasNgSideEffect: function (e) {
        return Ul(e.getValue(), e => {
          switch (e.type) {
            case void 0:
              return !1;
            case "CallExpression":
            case "OptionalCallExpression":
            case "AssignmentExpression":
              return !0;
          }
        });
      },
      hasNode: Ul,
      hasPrettierIgnore: function (e) {
        return Rl(e) || function (e) {
          const t = e.getValue(),
            n = e.getParentNode();
          if (!(n && t && Zl(t) && Zl(n))) return !1;
          let r = null;
          for (let _e97 = n.children.indexOf(t); _e97 > 0; _e97--) {
            const _t44 = n.children[_e97 - 1];
            if ("JSXText" !== _t44.type || lc(_t44)) {
              r = _t44;
              break;
            }
          }
          return r && "JSXExpressionContainer" === r.type && "JSXEmptyExpression" === r.expression.type && r.expression.comments && r.expression.comments.some(e => "prettier-ignore" === e.value.trim());
        }(e);
      },
      hasTrailingComment: function (e) {
        return e.comments && e.comments.some(e => e.trailing);
      },
      hasTrailingLineComment: function (e) {
        return e.comments && e.comments.some(e => e.trailing && !Gs.isBlockComment(e));
      },
      identity: function (e) {
        return e;
      },
      isBinaryish: function (e) {
        return rc.has(e.type);
      },
      isCallOrOptionalCallExpression: ac,
      isEmptyJSXElement: function (e) {
        if (0 === e.children.length) return !0;
        if (e.children.length > 1) return !1;
        const t = e.children[0];
        return Hl(t) && !lc(t);
      },
      isExportDeclaration: Gl,
      isFlowAnnotationComment: function (e, t, n) {
        const r = n.locStart(t),
          u = Vl(e, n.locEnd(t));
        return !1 !== u && "/*" === e.slice(r, r + 2) && "*/" === e.slice(u, u + 2);
      },
      isFunctionCompositionArgs: function (e) {
        if (e.length <= 1) return !1;
        let t = 0;
        for (const n of e) if (Kl(n)) {
          if (t += 1, t > 1) return !0;
        } else if (ac(n)) for (const _e98 of n.arguments) if (Kl(_e98)) return !0;
        return !1;
      },
      isFunctionNotation: nc,
      isFunctionOrArrowExpression: Kl,
      isGetterOrSetter: ec,
      isJestEachTemplateLiteral: function (e, t) {
        const n = /^[fx]?(describe|it|test)$/;
        return "TaggedTemplateExpression" === t.type && t.quasi === e && "MemberExpression" === t.tag.type && "Identifier" === t.tag.property.type && "each" === t.tag.property.name && ("Identifier" === t.tag.object.type && n.test(t.tag.object.name) || "MemberExpression" === t.tag.object.type && "Identifier" === t.tag.object.property.type && ("only" === t.tag.object.property.name || "skip" === t.tag.object.property.name) && "Identifier" === t.tag.object.object.type && n.test(t.tag.object.object.name));
      },
      isJSXNode: Zl,
      isJSXWhitespaceExpression: function (e) {
        return "JSXExpressionContainer" === e.type && Hl(e.expression) && " " === e.expression.value && !e.expression.comments;
      },
      isLastStatement: function (e) {
        const t = e.getParentNode();
        if (!t) return !0;
        const n = e.getValue(),
          r = (t.body || t.consequent).filter(e => "EmptyStatement" !== e.type);
        return r[r.length - 1] === n;
      },
      isLiteral: Hl,
      isLongCurriedCallExpression: function (e) {
        const t = e.getValue(),
          n = e.getParentNode();
        return ac(t) && ac(n) && n.callee === t && t.arguments.length > n.arguments.length && n.arguments.length > 0;
      },
      isSimpleCallArgument: function e(t, n) {
        if (n >= 2) return !1;
        const r = t => e(t, n + 1),
          u = "Literal" === t.type && "regex" in t && t.regex.pattern || "RegExpLiteral" === t.type && t.pattern;
        return !(u && u.length > 5) && ("Literal" === t.type || "BigIntLiteral" === t.type || "DecimalLiteral" === t.type || "BooleanLiteral" === t.type || "NullLiteral" === t.type || "NumericLiteral" === t.type || "RegExpLiteral" === t.type || "StringLiteral" === t.type || "Identifier" === t.type || "ThisExpression" === t.type || "Super" === t.type || "PrivateName" === t.type || "ArgumentPlaceholder" === t.type || "Import" === t.type || ("TemplateLiteral" === t.type ? t.expressions.every(r) : "ObjectExpression" === t.type ? t.properties.every(e => !e.computed && (e.shorthand || e.value && r(e.value))) : "ArrayExpression" === t.type ? t.elements.every(e => null === e || r(e)) : "ImportExpression" === t.type ? r(t.source) : "CallExpression" === t.type || "OptionalCallExpression" === t.type || "NewExpression" === t.type ? e(t.callee, n) && t.arguments.every(r) : "MemberExpression" === t.type || "OptionalMemberExpression" === t.type ? e(t.object, n) && e(t.property, n) : "UnaryExpression" !== t.type || "!" !== t.operator && "-" !== t.operator ? "TSNonNullExpression" === t.type && e(t.expression, n) : e(t.argument, n)));
      },
      isMeaningfulJSXText: lc,
      isMemberExpressionChain: function e(t) {
        return ("MemberExpression" === t.type || "OptionalMemberExpression" === t.type) && ("Identifier" === t.object.type || e(t.object));
      },
      isMemberish: function (e) {
        return "MemberExpression" === e.type || "OptionalMemberExpression" === e.type || "BindExpression" === e.type && Boolean(e.object);
      },
      isNgForOf: function (e, t, n) {
        return "NGMicrosyntaxKeyedExpression" === e.type && "of" === e.key.name && 1 === t && "NGMicrosyntaxLet" === n.body[0].type && null === n.body[0].value;
      },
      isNumericLiteral: Xl,
      isObjectType: function (e) {
        return "ObjectTypeAnnotation" === e.type || "TSTypeLiteral" === e.type;
      },
      isObjectTypePropertyAFunction: function (e, t) {
        return !("ObjectTypeProperty" !== e.type && "ObjectTypeInternalSlot" !== e.type || "FunctionTypeAnnotation" !== e.value.type || e.static || nc(e, t));
      },
      isSimpleFlowType: function (e) {
        return e && uc.has(e.type) && !("GenericTypeAnnotation" === e.type && e.typeParameters);
      },
      isSimpleNumber: pc,
      isSimpleTemplateLiteral: function (e) {
        return 0 !== e.expressions.length && e.expressions.every(e => {
          if (e.comments) return !1;
          if ("Identifier" === e.type || "ThisExpression" === e.type) return !0;
          if ("MemberExpression" === e.type || "OptionalMemberExpression" === e.type) {
            let t = e;
            for (; "MemberExpression" === t.type || "OptionalMemberExpression" === t.type;) {
              if ("Identifier" !== t.property.type && "Literal" !== t.property.type && "StringLiteral" !== t.property.type && "NumericLiteral" !== t.property.type) return !1;
              if (t = t.object, t.comments) return !1;
            }
            return "Identifier" === t.type || "ThisExpression" === t.type;
          }
          return !1;
        });
      },
      isStringLiteral: Yl,
      isStringPropSafeToUnquote: function (e, t) {
        return "json" !== t.parser && Yl(e.key) && fc(e.key).slice(1, -1) === e.key.value && (Il(e.key.value) && !(("typescript" === t.parser || "babel-ts" === t.parser) && "ClassProperty" === e.type) || pc(e.key.value) && String(Number(e.key.value)) === e.key.value && "babel" === t.parser);
      },
      isTemplateOnItsOwnLine: function (e, t, n) {
        return ("TemplateLiteral" === e.type && dc(e) || "TaggedTemplateExpression" === e.type && dc(e.quasi)) && !Ml(t, n.locStart(e), {
          backwards: !0
        });
      },
      isTestCall: function e(t, n) {
        if ("CallExpression" !== t.type) return !1;
        if (1 === t.arguments.length) {
          if (Ql(t) && n && e(n)) return Kl(t.arguments[0]);
          if ("Identifier" === (r = t).callee.type && /^(before|after)(Each|All)$/.test(r.callee.name) && 1 === r.arguments.length) return Ql(t.arguments[0]);
        } else if ((2 === t.arguments.length || 3 === t.arguments.length) && ("Identifier" === t.callee.type && oc.test(t.callee.name) || function (e) {
          return ("MemberExpression" === e.callee.type || "OptionalMemberExpression" === e.callee.type) && "Identifier" === e.callee.object.type && "Identifier" === e.callee.property.type && oc.test(e.callee.object.name) && ("only" === e.callee.property.name || "skip" === e.callee.property.name);
        }(t)) && (function (e) {
          return "TemplateLiteral" === e.type;
        }(t.arguments[0]) || Yl(t.arguments[0]))) return !(t.arguments[2] && !Xl(t.arguments[2])) && ((2 === t.arguments.length ? Kl(t.arguments[1]) : function (e) {
          return "FunctionExpression" === e.type || "ArrowFunctionExpression" === e.type && "BlockStatement" === e.body.type;
        }(t.arguments[1]) && t.arguments[1].params.length <= 1) || Ql(t.arguments[1]));
        var r;
        return !1;
      },
      isTheOnlyJSXElementInMarkdown: function (e, t) {
        if ("markdown" !== e.parentParser && "mdx" !== e.parentParser) return !1;
        const n = t.getNode();
        if (!n.expression || !Zl(n.expression)) return !1;
        const r = t.getParentNode();
        return "Program" === r.type && 1 === r.body.length;
      },
      isTSXFile: function (e) {
        return e.filepath && /\.tsx$/i.test(e.filepath);
      },
      isTypeAnnotationAFunction: function (e, t) {
        return !("TypeAnnotation" !== e.type && "TSTypeAnnotation" !== e.type || "FunctionTypeAnnotation" !== e.typeAnnotation.type || e.static || tc(e, e.typeAnnotation, t));
      },
      matchJsxWhitespaceRegex: ic,
      needsHardlineAfterDanglingComment: function (e) {
        if (!e.comments) return !1;
        const t = jl(e.comments.filter(e => !e.leading && !e.trailing));
        return t && !Gs.isBlockComment(t);
      },
      rawText: fc,
      returnArgumentHasLeadingComment: function (e, t) {
        if (cc(e.originalText, t, e)) return !0;
        if (zl(t)) {
          let r,
            u = t;
          for (; r = (n = u).expressions ? n.expressions[0] : n.left || n.test || n.callee || n.object || n.tag || n.argument || n.expression;) if (u = r, cc(e.originalText, u, e)) return !0;
        }
        var n;
        return !1;
      },
      shouldPrintComma: function (e, t = "es5") {
        return "es5" === e.trailingComma && "es5" === t || "all" === e.trailingComma && ("all" === t || "es5" === t);
      },
      isBitwiseOperator: function (e) {
        return !!gc[e] || "|" === e || "^" === e || "&" === e;
      },
      shouldFlatten: function (e, t) {
        return yc(t) === yc(e) && "**" !== e && (!hc[e] || !hc[t]) && !("%" === t && mc[e] || "%" === e && mc[t]) && (t === e || !mc[t] || !mc[e]) && (!gc[e] || !gc[t]);
      },
      startsWithNoLookaheadToken: function e(t, n) {
        switch ((t = function (e) {
          for (; e.left;) e = e.left;
          return e;
        }(t)).type) {
          case "FunctionExpression":
          case "ClassExpression":
          case "DoExpression":
            return n;
          case "ObjectExpression":
            return !0;
          case "MemberExpression":
          case "OptionalMemberExpression":
            return e(t.object, n);
          case "TaggedTemplateExpression":
            return "FunctionExpression" !== t.tag.type && e(t.tag, n);
          case "CallExpression":
          case "OptionalCallExpression":
            return "FunctionExpression" !== t.callee.type && e(t.callee, n);
          case "ConditionalExpression":
            return e(t.test, n);
          case "UpdateExpression":
            return !t.prefix && e(t.argument, n);
          case "BindExpression":
            return t.object && e(t.object, n);
          case "SequenceExpression":
            return e(t.expressions[0], n);
          case "TSAsExpression":
            return e(t.expression, n);
          default:
            return !1;
        }
      },
      getPrecedence: yc
    };
    const {
      getLeftSidePathName: Cc,
      hasFlowShorthandAnnotationComment: bc,
      hasNakedLeftSide: Ac,
      hasNode: vc,
      isBitwiseOperator: Fc,
      startsWithNoLookaheadToken: xc,
      shouldFlatten: Sc,
      getPrecedence: wc
    } = Ec;
    function Bc(e, t) {
      const n = e.getParentNode();
      if (!n) return !1;
      const r = e.getName(),
        u = e.getNode();
      if (e.getValue() !== u) return !1;
      if (t.__isInHtmlInterpolation && !t.bracketSpacing && function (e) {
        switch (e.type) {
          case "ObjectExpression":
            return !0;
          default:
            return !1;
        }
      }(u) && Tc(e)) return !0;
      if (function (e) {
        return "BlockStatement" === e.type || "BreakStatement" === e.type || "ClassBody" === e.type || "ClassDeclaration" === e.type || "ClassMethod" === e.type || "ClassProperty" === e.type || "ClassPrivateProperty" === e.type || "ContinueStatement" === e.type || "DebuggerStatement" === e.type || "DeclareClass" === e.type || "DeclareExportAllDeclaration" === e.type || "DeclareExportDeclaration" === e.type || "DeclareFunction" === e.type || "DeclareInterface" === e.type || "DeclareModule" === e.type || "DeclareModuleExports" === e.type || "DeclareVariable" === e.type || "DoWhileStatement" === e.type || "EnumDeclaration" === e.type || "ExportAllDeclaration" === e.type || "ExportDefaultDeclaration" === e.type || "ExportNamedDeclaration" === e.type || "ExpressionStatement" === e.type || "ForInStatement" === e.type || "ForOfStatement" === e.type || "ForStatement" === e.type || "FunctionDeclaration" === e.type || "IfStatement" === e.type || "ImportDeclaration" === e.type || "InterfaceDeclaration" === e.type || "LabeledStatement" === e.type || "MethodDefinition" === e.type || "ReturnStatement" === e.type || "SwitchStatement" === e.type || "ThrowStatement" === e.type || "TryStatement" === e.type || "TSDeclareFunction" === e.type || "TSEnumDeclaration" === e.type || "TSImportEqualsDeclaration" === e.type || "TSInterfaceDeclaration" === e.type || "TSModuleDeclaration" === e.type || "TSNamespaceExportDeclaration" === e.type || "TypeAlias" === e.type || "VariableDeclaration" === e.type || "WhileStatement" === e.type || "WithStatement" === e.type;
      }(u)) return !1;
      if ("flow" !== t.parser && bc(e.getValue())) return !0;
      if ("Identifier" === u.type) return !!(u.extra && u.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(u.name));
      if ("ParenthesizedExpression" === n.type) return !1;
      if (!("ClassDeclaration" !== n.type && "ClassExpression" !== n.type || n.superClass !== u || "ArrowFunctionExpression" !== u.type && "AssignmentExpression" !== u.type && "AwaitExpression" !== u.type && "BinaryExpression" !== u.type && "ConditionalExpression" !== u.type && "LogicalExpression" !== u.type && "NewExpression" !== u.type && "ObjectExpression" !== u.type && "ParenthesizedExpression" !== u.type && "SequenceExpression" !== u.type && "TaggedTemplateExpression" !== u.type && "UnaryExpression" !== u.type && "UpdateExpression" !== u.type && "YieldExpression" !== u.type)) return !0;
      if ("ExportDefaultDeclaration" === n.type) return function e(t, n) {
        const r = t.getValue(),
          u = t.getParentNode();
        if ("FunctionExpression" === r.type || "ClassExpression" === r.type) return "ExportDefaultDeclaration" === u.type || !Bc(t, n);
        if (!Ac(r) || "ExportDefaultDeclaration" !== u.type && Bc(t, n)) return !1;
        return t.call(t => e(t, n), ...Cc(t, r));
      }(e, t) || "SequenceExpression" === u.type;
      if ("Decorator" === n.type && n.expression === u) {
        let _e99 = !1,
          _t45 = !1,
          _n15 = u;
        for (; _n15;) switch (_n15.type) {
          case "MemberExpression":
            _t45 = !0, _n15 = _n15.object;
            break;
          case "CallExpression":
            if (_t45 || _e99) return !0;
            _e99 = !0, _n15 = _n15.callee;
            break;
          case "Identifier":
            return !1;
          default:
            return !0;
        }
        return !0;
      }
      if ("ArrowFunctionExpression" === n.type && n.body === u && "SequenceExpression" !== u.type && xc(u, !1) || "ExpressionStatement" === n.type && xc(u, !0)) return !0;
      switch (u.type) {
        case "SpreadElement":
        case "SpreadProperty":
          return "MemberExpression" === n.type && "object" === r && n.object === u;
        case "UpdateExpression":
          if ("UnaryExpression" === n.type) return u.prefix && ("++" === u.operator && "+" === n.operator || "--" === u.operator && "-" === n.operator);
        case "UnaryExpression":
          switch (n.type) {
            case "UnaryExpression":
              return u.operator === n.operator && ("+" === u.operator || "-" === u.operator);
            case "BindExpression":
              return !0;
            case "MemberExpression":
            case "OptionalMemberExpression":
              return "object" === r;
            case "TaggedTemplateExpression":
              return !0;
            case "NewExpression":
            case "CallExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "BinaryExpression":
              return "**" === n.operator && "left" === r;
            case "TSNonNullExpression":
              return !0;
            default:
              return !1;
          }
        case "BinaryExpression":
          {
            if ("UpdateExpression" === n.type || "PipelineTopicExpression" === n.type && "|>" === u.operator) return !0;
            const _t46 = t => {
              let n = 0;
              for (; t;) {
                const r = e.getParentNode(n++);
                if (!r) return !1;
                if ("ForStatement" === r.type && r.init === t) return !0;
                t = r;
              }
              return !1;
            };
            if ("in" === u.operator && _t46(u)) return !0;
            if ("|>" === u.operator && u.extra && u.extra.parenthesized) {
              const _t47 = e.getParentNode(1);
              if ("BinaryExpression" === _t47.type && "|>" === _t47.operator) return !0;
            }
          }
        case "TSTypeAssertion":
        case "TSAsExpression":
        case "LogicalExpression":
          switch (n.type) {
            case "ConditionalExpression":
              return "TSAsExpression" === u.type;
            case "CallExpression":
            case "NewExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "ClassExpression":
            case "ClassDeclaration":
              return "superClass" === r && n.superClass === u;
            case "TSTypeAssertion":
            case "TaggedTemplateExpression":
            case "UnaryExpression":
            case "JSXSpreadAttribute":
            case "SpreadElement":
            case "SpreadProperty":
            case "BindExpression":
            case "AwaitExpression":
            case "TSAsExpression":
            case "TSNonNullExpression":
            case "UpdateExpression":
              return !0;
            case "MemberExpression":
            case "OptionalMemberExpression":
              return "object" === r;
            case "AssignmentExpression":
              return n.left === u && ("TSTypeAssertion" === u.type || "TSAsExpression" === u.type);
            case "LogicalExpression":
              if ("LogicalExpression" === u.type) return n.operator !== u.operator;
            case "BinaryExpression":
              {
                if (!u.operator && "TSTypeAssertion" !== u.type) return !0;
                const _e100 = n.operator,
                  _t48 = wc(_e100),
                  o = u.operator,
                  a = wc(o);
                return _t48 > a || (_t48 === a && "right" === r ? (Xa.strictEqual(n.right, u), !0) : _t48 === a && !Sc(_e100, o) || (_t48 < a && "%" === o ? "+" === _e100 || "-" === _e100 : !!Fc(_e100)));
              }
            default:
              return !1;
          }
        case "SequenceExpression":
          switch (n.type) {
            case "ReturnStatement":
            case "ForStatement":
              return !1;
            case "ExpressionStatement":
              return "expression" !== r;
            case "ArrowFunctionExpression":
              return "body" !== r;
            default:
              return !0;
          }
        case "YieldExpression":
          if ("UnaryExpression" === n.type || "AwaitExpression" === n.type || "TSAsExpression" === n.type || "TSNonNullExpression" === n.type) return !0;
        case "AwaitExpression":
          switch (n.type) {
            case "TaggedTemplateExpression":
            case "UnaryExpression":
            case "LogicalExpression":
            case "SpreadElement":
            case "SpreadProperty":
            case "TSAsExpression":
            case "TSNonNullExpression":
            case "BindExpression":
              return !0;
            case "MemberExpression":
            case "OptionalMemberExpression":
              return "object" === r;
            case "NewExpression":
            case "CallExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "ConditionalExpression":
              return n.test === u;
            case "BinaryExpression":
              return !(!u.argument && "|>" === n.operator);
            default:
              return !1;
          }
        case "TSJSDocFunctionType":
        case "TSConditionalType":
          if ("TSConditionalType" === n.type && u === n.extendsType) return !0;
        case "TSFunctionType":
        case "TSConstructorType":
          if ("TSConditionalType" === n.type && u === n.checkType) return !0;
        case "TSUnionType":
        case "TSIntersectionType":
          if ("TSUnionType" === n.type || "TSIntersectionType" === n.type) return !0;
        case "TSInferType":
          if ("TSInferType" === u.type && "TSRestType" === n.type) return !1;
        case "TSTypeOperator":
          return "TSArrayType" === n.type || "TSOptionalType" === n.type || "TSRestType" === n.type || "TSIndexedAccessType" === n.type && u === n.objectType || "TSTypeOperator" === n.type || "TSTypeAnnotation" === n.type && /^TSJSDoc/.test(e.getParentNode(1).type);
        case "ArrayTypeAnnotation":
          return "NullableTypeAnnotation" === n.type;
        case "IntersectionTypeAnnotation":
        case "UnionTypeAnnotation":
          return "ArrayTypeAnnotation" === n.type || "NullableTypeAnnotation" === n.type || "IntersectionTypeAnnotation" === n.type || "UnionTypeAnnotation" === n.type;
        case "NullableTypeAnnotation":
          return "ArrayTypeAnnotation" === n.type;
        case "FunctionTypeAnnotation":
          {
            const _t49 = "NullableTypeAnnotation" === n.type ? e.getParentNode(1) : n;
            return "UnionTypeAnnotation" === _t49.type || "IntersectionTypeAnnotation" === _t49.type || "ArrayTypeAnnotation" === _t49.type || "NullableTypeAnnotation" === _t49.type || "FunctionTypeParam" === n.type && null === n.name && u.params && u.params.some(e => e.typeAnnotation && "NullableTypeAnnotation" === e.typeAnnotation.type);
          }
        case "StringLiteral":
        case "NumericLiteral":
        case "Literal":
          if ("string" == typeof u.value && "ExpressionStatement" === n.type && !n.directive) {
            const _t50 = e.getParentNode(1);
            return "Program" === _t50.type || "BlockStatement" === _t50.type;
          }
          return "MemberExpression" === n.type && "number" == typeof u.value && "object" === r && n.object === u;
        case "AssignmentExpression":
          {
            const _t51 = e.getParentNode(1);
            return "ArrowFunctionExpression" === n.type && n.body === u || ("ClassProperty" !== n.type || n.key !== u || !n.computed) && ("TSPropertySignature" !== n.type || n.name !== u) && ("ForStatement" !== n.type || n.init !== u && n.update !== u) && ("ExpressionStatement" === n.type ? "ObjectPattern" === u.left.type : ("TSPropertySignature" !== n.type || n.key !== u) && "AssignmentExpression" !== n.type && ("SequenceExpression" !== n.type || !_t51 || "ForStatement" !== _t51.type || _t51.init !== n && _t51.update !== n) && ("Property" !== n.type || n.value !== u) && "NGChainedExpression" !== n.type);
          }
        case "ConditionalExpression":
          switch (n.type) {
            case "TaggedTemplateExpression":
            case "UnaryExpression":
            case "SpreadElement":
            case "SpreadProperty":
            case "BinaryExpression":
            case "LogicalExpression":
            case "NGPipeExpression":
            case "ExportDefaultDeclaration":
            case "AwaitExpression":
            case "JSXSpreadAttribute":
            case "TSTypeAssertion":
            case "TypeCastExpression":
            case "TSAsExpression":
            case "TSNonNullExpression":
              return !0;
            case "NewExpression":
            case "CallExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "ConditionalExpression":
              return "test" === r && n.test === u;
            case "MemberExpression":
            case "OptionalMemberExpression":
              return "object" === r;
            default:
              return !1;
          }
        case "FunctionExpression":
          switch (n.type) {
            case "NewExpression":
            case "CallExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "TaggedTemplateExpression":
              return !0;
            default:
              return !1;
          }
        case "ArrowFunctionExpression":
          switch (n.type) {
            case "PipelineTopicExpression":
              return !(!u.extra || !u.extra.parenthesized);
            case "BinaryExpression":
              return "|>" !== n.operator || u.extra && u.extra.parenthesized;
            case "NewExpression":
            case "CallExpression":
            case "OptionalCallExpression":
              return "callee" === r;
            case "MemberExpression":
            case "OptionalMemberExpression":
              return "object" === r;
            case "TSAsExpression":
            case "BindExpression":
            case "TaggedTemplateExpression":
            case "UnaryExpression":
            case "LogicalExpression":
            case "AwaitExpression":
            case "TSTypeAssertion":
              return !0;
            case "ConditionalExpression":
              return "test" === r;
            default:
              return !1;
          }
        case "ClassExpression":
          switch (n.type) {
            case "NewExpression":
              return "callee" === r && n.callee === u;
            default:
              return !1;
          }
        case "OptionalMemberExpression":
        case "OptionalCallExpression":
          {
            const _t52 = e.getParentNode(1);
            if ("MemberExpression" === n.type && "object" === r || ("CallExpression" === n.type || "NewExpression" === n.type) && "callee" === r || "TSNonNullExpression" === n.type && "MemberExpression" === _t52.type && _t52.object === n) return !0;
          }
        case "CallExpression":
        case "MemberExpression":
        case "TaggedTemplateExpression":
        case "TSNonNullExpression":
          if (("BindExpression" === n.type || "NewExpression" === n.type) && "callee" === r) {
            let _e101 = u;
            for (; _e101;) switch (_e101.type) {
              case "CallExpression":
              case "OptionalCallExpression":
                return !0;
              case "MemberExpression":
              case "OptionalMemberExpression":
              case "BindExpression":
                _e101 = _e101.object;
                break;
              case "TaggedTemplateExpression":
                _e101 = _e101.tag;
                break;
              case "TSNonNullExpression":
                _e101 = _e101.expression;
                break;
              default:
                return !1;
            }
          }
          return !1;
        case "BindExpression":
          return ("BindExpression" === n.type || "NewExpression" === n.type) && "callee" === r || ("MemberExpression" === n.type || "OptionalMemberExpression" === n.type) && "object" === r;
        case "NGPipeExpression":
          return !("NGRoot" === n.type || "NGMicrosyntaxExpression" === n.type || !("ObjectProperty" !== n.type || u.extra && u.extra.parenthesized) || "ArrayExpression" === n.type || ("CallExpression" === n.type || "OptionalCallExpression" === n.type) && n.arguments[r] === u || "NGPipeExpression" === n.type && "right" === r || "MemberExpression" === n.type && "property" === r || "AssignmentExpression" === n.type);
        case "JSXFragment":
        case "JSXElement":
          return "callee" === r || "BinaryExpression" === n.type && "<" === n.operator && "left" === r || "ArrayExpression" !== n.type && "ArrowFunctionExpression" !== n.type && "AssignmentExpression" !== n.type && "AssignmentPattern" !== n.type && "BinaryExpression" !== n.type && "CallExpression" !== n.type && "NewExpression" !== n.type && "ConditionalExpression" !== n.type && "ExpressionStatement" !== n.type && "JsExpressionRoot" !== n.type && "JSXAttribute" !== n.type && "JSXElement" !== n.type && "JSXExpressionContainer" !== n.type && "JSXFragment" !== n.type && "LogicalExpression" !== n.type && "ObjectProperty" !== n.type && "OptionalCallExpression" !== n.type && "Property" !== n.type && "ReturnStatement" !== n.type && "ThrowStatement" !== n.type && "TypeCastExpression" !== n.type && "VariableDeclarator" !== n.type;
        case "TypeAnnotation":
          return "returnType" === r && "ArrowFunctionExpression" === n.type && function (e) {
            return vc(e, e => "ObjectTypeAnnotation" === e.type && vc(e, e => "FunctionTypeAnnotation" === e.type || void 0) || void 0);
          }(u);
      }
      return !1;
    }
    function Tc(e) {
      const t = e.getValue(),
        n = e.getParentNode(),
        r = e.getName();
      switch (n.type) {
        case "NGPipeExpression":
          if ("number" == typeof r && n.arguments[r] === t && n.arguments.length - 1 === r) return e.callParent(Tc);
          break;
        case "ObjectProperty":
          if ("value" === r) {
            const _t53 = e.getParentNode(1);
            return _t53.properties[_t53.properties.length - 1] === n;
          }
          break;
        case "BinaryExpression":
        case "LogicalExpression":
          if ("right" === r) return e.callParent(Tc);
          break;
        case "ConditionalExpression":
          if ("alternate" === r) return e.callParent(Tc);
          break;
        case "UnaryExpression":
          if (n.prefix) return e.callParent(Tc);
      }
      return !1;
    }
    var kc = Bc;
    const {
      builders: {
        concat: Nc,
        join: Oc,
        line: Pc
      }
    } = dn;
    var _c = {
      isVueEventBindingExpression: function e(t) {
        switch (t.type) {
          case "MemberExpression":
            switch (t.property.type) {
              case "Identifier":
              case "NumericLiteral":
              case "StringLiteral":
                return e(t.object);
            }
            return !1;
          case "Identifier":
            return !0;
          default:
            return !1;
        }
      },
      printHtmlBinding: function (e, t, n) {
        const r = e.getValue();
        if (t.__onHtmlBindingRoot && null === e.getName() && t.__onHtmlBindingRoot(r, t), "File" === r.type) return t.__isVueForBindingLeft ? e.call(e => {
          const {
            params: t
          } = e.getValue();
          return Nc([t.length > 1 ? "(" : "", Oc(Nc([",", Pc]), e.map(n, "params")), t.length > 1 ? ")" : ""]);
        }, "program", "body", 0) : t.__isVueSlotScope ? e.call(e => Oc(Nc([",", Pc]), e.map(n, "params")), "program", "body", 0) : void 0;
      }
    };
    var Ic = function (e, t) {
      switch (t.parser) {
        case "json":
        case "json5":
        case "json-stringify":
        case "__js_expression":
        case "__vue_expression":
          return Object.assign({}, e, {
            type: t.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot",
            node: e,
            comments: [],
            rootMarker: t.rootMarker
          });
        default:
          return e;
      }
    };
    const {
        getLast: jc,
        getPenultimate: Mc,
        isNextLineEmpty: Lc
      } = Lt,
      {
        hasLeadingComment: Rc,
        hasTrailingComment: qc,
        isFunctionCompositionArgs: Vc,
        isJSXNode: Wc,
        isLongCurriedCallExpression: $c,
        shouldPrintComma: Uc
      } = Ec,
      {
        builders: {
          concat: zc,
          line: Jc,
          hardline: Gc,
          softline: Hc,
          group: Xc,
          indent: Yc,
          conditionalGroup: Kc,
          ifBreak: Qc,
          breakParent: Zc
        },
        utils: {
          willBreak: ep
        }
      } = dn;
    function tp(e) {
      return "ObjectExpression" === e.type && (e.properties.length > 0 || e.comments) || "ArrayExpression" === e.type && (e.elements.length > 0 || e.comments) || "TSTypeAssertion" === e.type && tp(e.expression) || "TSAsExpression" === e.type && tp(e.expression) || "FunctionExpression" === e.type || "ArrowFunctionExpression" === e.type && (!e.returnType || !e.returnType.typeAnnotation || "TSTypeReference" !== e.returnType.typeAnnotation.type) && ("BlockStatement" === e.body.type || "ArrowFunctionExpression" === e.body.type || "ObjectExpression" === e.body.type || "ArrayExpression" === e.body.type || "CallExpression" === e.body.type || "OptionalCallExpression" === e.body.type || "ConditionalExpression" === e.body.type || Wc(e.body));
    }
    var np = function (e, t, n) {
      const r = e.getValue(),
        u = "ImportExpression" === r.type,
        o = u ? [r.source] : r.arguments;
      if (0 === o.length) return zc(["(", Di.printDanglingComments(e, t, !0), ")"]);
      if (2 === o.length && "ArrowFunctionExpression" === o[0].type && 0 === o[0].params.length && "BlockStatement" === o[0].body.type && "ArrayExpression" === o[1].type && !o.some(e => e.comments)) return zc(["(", e.call(n, "arguments", 0), ", ", e.call(n, "arguments", 1), ")"]);
      let a = !1,
        i = !1,
        s = !1;
      const l = o.length - 1,
        c = (e, r) => {
          const u = e.getNode(),
            o = [n(e)];
          return r === l || (Lc(t.originalText, u, t.locEnd) ? (0 === r && (s = !0), a = !0, o.push(",", Gc, Gc)) : o.push(",", Jc)), i = function (e, t) {
            if (!e || "ArrowFunctionExpression" !== e.type || !e.body || "BlockStatement" !== e.body.type || !e.params || e.params.length < 1) return !1;
            let r = !1;
            return t.each(e => {
              const t = zc([n(e)]);
              r = r || ep(t);
            }, "params"), r;
          }(u, e), zc(o);
        },
        p = u ? [e.call(e => c(e, 0), "source")] : e.map(c, "arguments"),
        d = u || r.callee && "Import" === r.callee.type || !Uc(t, "all") ? "" : ",";
      function f() {
        return Xc(zc(["(", Yc(zc([Jc, zc(p)])), d, Jc, ")"]), {
          shouldBreak: !0
        });
      }
      if ("Decorator" !== e.getParentNode().type && Vc(o)) return f();
      const h = function (e) {
          if (2 !== e.length) return !1;
          const [t, n] = e;
          return !(t.comments && t.comments.length || "FunctionExpression" !== t.type && ("ArrowFunctionExpression" !== t.type || "BlockStatement" !== t.body.type) || "FunctionExpression" === n.type || "ArrowFunctionExpression" === n.type || "ConditionalExpression" === n.type || tp(n));
        }(o),
        m = function (e) {
          const t = jc(e),
            n = Mc(e);
          return !Rc(t) && !qc(t) && tp(t) && (!n || n.type !== t.type);
        }(o);
      if (h || m) {
        const _t54 = (h ? p.slice(1).some(ep) : p.slice(0, -1).some(ep)) || a || i;
        let _l3 = [],
          _c2 = 0;
        const _d2 = e => {
          h && 0 === _c2 && (_l3 = [zc([e.call(e => n(e, {
            expandFirstArg: !0
          })), p.length > 1 ? "," : "", s ? Gc : Jc, s ? Gc : ""])].concat(p.slice(1))), m && _c2 === o.length - 1 && (_l3 = p.slice(0, -1).concat(e.call(e => n(e, {
            expandLastArg: !0
          })))), _c2++;
        };
        u ? e.call(_d2, "source") : e.each(_d2, "arguments");
        const _g2 = p.some(ep),
          D = zc(["(", zc(_l3), ")"]);
        return zc([_g2 ? Zc : "", Kc([_g2 || r.typeArguments || r.typeParameters ? Qc(f(), D) : D, zc(h ? ["(", Xc(_l3[0], {
          shouldBreak: !0
        }), zc(_l3.slice(1)), ")"] : ["(", zc(p.slice(0, -1)), Xc(jc(_l3), {
          shouldBreak: !0
        }), ")"]), f()], {
          shouldBreak: _t54
        })]);
      }
      const g = zc(["(", Yc(zc([Hc, zc(p)])), Qc(d), Hc, ")"]);
      return $c(e) ? g : Xc(g, {
        shouldBreak: p.some(ep) || a
      });
    };
    const {
        isNumericLiteral: rp
      } = Ec,
      {
        builders: {
          concat: up,
          softline: op,
          group: ap,
          indent: ip
        }
      } = dn;
    function sp(e) {
      const t = e.getValue();
      return !t.optional || "Identifier" === t.type && t === e.getParentNode().key ? "" : "OptionalCallExpression" === t.type || "OptionalMemberExpression" === t.type && t.computed ? "?." : "?";
    }
    var lp = {
      printOptionalToken: sp,
      printFunctionTypeParameters: function (e, t, n) {
        const r = e.getValue();
        return r.typeArguments ? e.call(n, "typeArguments") : r.typeParameters ? e.call(n, "typeParameters") : "";
      },
      printMemberLookup: function (e, t, n) {
        const r = e.call(n, "property"),
          u = e.getValue(),
          o = sp(e);
        return u.computed ? !u.property || rp(u.property) ? up([o, "[", r, "]"]) : ap(up([o, "[", ip(up([op, r])), op, "]"])) : up([o, ".", r]);
      },
      printBindExpressionCallee: function (e, t, n) {
        return up(["::", e.call(n, "callee")]);
      }
    };
    const {
        getLast: cp,
        isNextLineEmpty: pp,
        isNextLineEmptyAfterIndex: dp,
        getNextNonSpaceNonCommentCharacterIndex: fp
      } = Lt,
      {
        hasLeadingComment: hp,
        hasTrailingComment: mp,
        isCallOrOptionalCallExpression: gp,
        isFunctionOrArrowExpression: Dp,
        isLongCurriedCallExpression: yp,
        isMemberish: Ep,
        isNumericLiteral: Cp,
        isSimpleCallArgument: bp
      } = Ec,
      {
        builders: {
          concat: Ap,
          join: vp,
          hardline: Fp,
          group: xp,
          indent: Sp,
          conditionalGroup: wp,
          breakParent: Bp
        },
        utils: {
          willBreak: Tp
        }
      } = dn,
      {
        printOptionalToken: kp,
        printFunctionTypeParameters: Np,
        printMemberLookup: Op,
        printBindExpressionCallee: Pp
      } = lp;
    var _p = function (e, t, n) {
      const r = e.getParentNode(),
        u = !r || "ExpressionStatement" === r.type,
        o = [];
      function a(e) {
        const {
            originalText: n
          } = t,
          r = fp(n, e, t.locEnd);
        return ")" === n.charAt(r) ? !1 !== r && dp(n, r + 1) : pp(n, e, t.locEnd);
      }
      const i = e.getValue();
      o.unshift({
        node: i,
        printed: Ap([kp(e), Np(e, t, n), np(e, t, n)])
      }), i.callee && e.call(e => function e(r) {
        const u = r.getValue();
        gp(u) && (Ep(u.callee) || gp(u.callee)) ? (o.unshift({
          node: u,
          printed: Ap([Di.printComments(r, () => Ap([kp(r), Np(r, t, n), np(r, t, n)]), t), a(u) ? Fp : ""])
        }), r.call(t => e(t), "callee")) : Ep(u) ? (o.unshift({
          node: u,
          needsParens: kc(r, t),
          printed: Di.printComments(r, () => "OptionalMemberExpression" === u.type || "MemberExpression" === u.type ? Op(r, t, n) : Pp(r, t, n), t)
        }), r.call(t => e(t), "object")) : "TSNonNullExpression" === u.type ? (o.unshift({
          node: u,
          printed: Di.printComments(r, () => "!", t)
        }), r.call(t => e(t), "expression")) : o.unshift({
          node: u,
          printed: r.call(n)
        });
      }(e), "callee");
      const s = [];
      let l = [o[0]],
        c = 1;
      for (; c < o.length && ("TSNonNullExpression" === o[c].node.type || gp(o[c].node) || ("MemberExpression" === o[c].node.type || "OptionalMemberExpression" === o[c].node.type) && o[c].node.computed && Cp(o[c].node.property)); ++c) l.push(o[c]);
      if (!gp(o[0].node)) for (; c + 1 < o.length && Ep(o[c].node) && Ep(o[c + 1].node); ++c) l.push(o[c]);
      s.push(l), l = [];
      let p = !1;
      for (; c < o.length; ++c) {
        if (p && Ep(o[c].node)) {
          if (o[c].node.computed && Cp(o[c].node.property)) {
            l.push(o[c]);
            continue;
          }
          s.push(l), l = [], p = !1;
        }
        (gp(o[c].node) || "ImportExpression" === o[c].node.type) && (p = !0), l.push(o[c]), o[c].node.comments && o[c].node.comments.some(e => e.trailing) && (s.push(l), l = [], p = !1);
      }
      function d(e) {
        return /^[A-Z]|^[$_]+$/.test(e);
      }
      l.length > 0 && s.push(l);
      const f = s.length >= 2 && !s[1][0].node.comments && function (e) {
        const n = e[1].length && e[1][0].node.computed;
        if (1 === e[0].length) {
          const _r21 = e[0][0].node;
          return "ThisExpression" === _r21.type || "Identifier" === _r21.type && (d(_r21.name) || u && function (e) {
            return e.length <= t.tabWidth;
          }(_r21.name) || n);
        }
        const r = cp(e[0]).node;
        return ("MemberExpression" === r.type || "OptionalMemberExpression" === r.type) && "Identifier" === r.property.type && (d(r.property.name) || n);
      }(s);
      function h(e) {
        const t = e.map(e => e.printed);
        return e.length > 0 && e[e.length - 1].needsParens ? Ap(["(", ...t, ")"]) : Ap(t);
      }
      const m = s.map(h),
        g = Ap(m),
        D = f ? 3 : 2,
        y = Go(s),
        E = y.slice(1, -1).some(e => hp(e.node)) || y.slice(0, -1).some(e => mp(e.node)) || s[D] && hp(s[D][0].node);
      if (s.length <= D && !E) return yp(e) ? g : xp(g);
      const C = cp(s[f ? 1 : 0]).node,
        b = !gp(C) && a(C),
        A = Ap([h(s[0]), f ? Ap(s.slice(1, 2).map(h)) : "", b ? Fp : "", function (e) {
          return 0 === e.length ? "" : Sp(xp(Ap([Fp, vp(Fp, e.map(h))])));
        }(s.slice(f ? 2 : 1))]),
        v = o.map(({
          node: e
        }) => e).filter(gp);
      return E || v.length > 2 && v.some(e => !e.arguments.every(e => bp(e, 0))) || m.slice(0, -1).some(Tp) || function () {
        const e = cp(cp(s)).node,
          t = cp(m);
        return gp(e) && Tp(t) && v.slice(0, -1).some(e => e.arguments.some(Dp));
      }() ? xp(A) : Ap([Tp(g) || b ? Bp : "", wp([g, A])]);
    };
    const {
        builders: {
          concat: Ip,
          softline: jp,
          group: Mp,
          indent: Lp,
          join: Rp,
          line: qp,
          ifBreak: Vp
        }
      } = dn,
      {
        shouldPrintComma: Wp
      } = Ec;
    var $p = {
      printModuleSource: function (e, t, n) {
        return e.getValue().source ? Ip([" from ", e.call(n, "source")]) : "";
      },
      printModuleSpecifiers: function (e, t, n) {
        const r = e.getValue(),
          u = ["ImportDeclaration" === r.type ? " " : ""];
        if (r.specifiers && r.specifiers.length > 0) {
          const o = [],
            a = [];
          if (e.each(t => {
            const r = e.getValue().type;
            if ("ExportNamespaceSpecifier" === r || "ExportDefaultSpecifier" === r || "ImportNamespaceSpecifier" === r || "ImportDefaultSpecifier" === r) o.push(n(t));else {
              if ("ExportSpecifier" !== r && "ImportSpecifier" !== r) throw new Error("Unknown specifier type ".concat(JSON.stringify(r)));
              a.push(n(t));
            }
          }, "specifiers"), u.push(Rp(", ", o)), 0 !== a.length) {
            0 !== o.length && u.push(", ");
            a.length > 1 || o.length > 0 || r.specifiers.some(e => e.comments) ? u.push(Mp(Ip(["{", Lp(Ip([t.bracketSpacing ? qp : jp, Rp(Ip([",", qp]), a)])), Vp(Wp(t) ? "," : ""), t.bracketSpacing ? qp : jp, "}"]))) : u.push(Ip(["{", t.bracketSpacing ? " " : "", Ip(a), t.bracketSpacing ? " " : "", "}"]));
          }
        } else u.push("{}");
        return Ip(u);
      }
    };
    const {
        isJSXNode: Up
      } = Ec,
      {
        hasNewlineInRange: zp
      } = Lt,
      {
        builders: {
          concat: Jp,
          line: Gp,
          softline: Hp,
          group: Xp,
          indent: Yp,
          align: Kp,
          ifBreak: Qp,
          dedent: Zp,
          breakParent: ed
        }
      } = dn;
    var td = function (e, t, n, r) {
      const u = e.getValue(),
        o = u[r.consequentNodePropertyName],
        a = u[r.alternateNodePropertyName],
        i = [];
      let s = !1;
      const l = e.getParentNode(),
        c = l.type === r.conditionalNodeType && r.testNodePropertyNames.some(e => l[e] === u);
      let p,
        d,
        f = l.type === r.conditionalNodeType && !c,
        h = 0;
      do {
        d = p || u, p = e.getParentNode(h), h++;
      } while (p && p.type === r.conditionalNodeType && r.testNodePropertyNames.every(e => p[e] !== d));
      const m = p || l,
        g = d;
      if (r.shouldCheckJsx && (Up(u[r.testNodePropertyNames[0]]) || Up(o) || Up(a) || function (e) {
        return function (e) {
          const t = [];
          return function e(n) {
            "ConditionalExpression" === n.type ? (e(n.test), e(n.consequent), e(n.alternate)) : t.push(n);
          }(e), t;
        }(e).some(Up);
      }(g))) {
        s = !0, f = !0;
        const _t55 = e => Jp([Qp("(", ""), Yp(Jp([Hp, e])), Hp, Qp(")", "")]),
          _u9 = e => "NullLiteral" === e.type || "Literal" === e.type && null === e.value || "Identifier" === e.type && "undefined" === e.name;
        i.push(" ? ", _u9(o) ? e.call(n, r.consequentNodePropertyName) : _t55(e.call(n, r.consequentNodePropertyName)), " : ", a.type === r.conditionalNodeType || _u9(a) ? e.call(n, r.alternateNodePropertyName) : _t55(e.call(n, r.alternateNodePropertyName)));
      } else {
        const _s3 = Jp([Gp, "? ", o.type === r.conditionalNodeType ? Qp("", "(") : "", Kp(2, e.call(n, r.consequentNodePropertyName)), o.type === r.conditionalNodeType ? Qp("", ")") : "", Gp, ": ", a.type === r.conditionalNodeType ? e.call(n, r.alternateNodePropertyName) : Kp(2, e.call(n, r.alternateNodePropertyName))]);
        i.push(l.type !== r.conditionalNodeType || l[r.alternateNodePropertyName] === u || c ? _s3 : t.useTabs ? Zp(Yp(_s3)) : Kp(Math.max(0, t.tabWidth - 2), _s3));
      }
      const D = Go([...r.testNodePropertyNames.map(e => u[e].comments), o.comments, a.comments]).filter(Boolean).some(e => Gs.isBlockComment(e) && zp(t.originalText, t.locStart(e), t.locEnd(e))),
        y = !s && ("MemberExpression" === l.type || "OptionalMemberExpression" === l.type || "NGPipeExpression" === l.type && l.left === u) && !l.computed,
        E = (e => l === m ? Xp(e, {
          shouldBreak: D
        }) : D ? Jp([e, ed]) : e)(Jp([].concat((C = Jp(r.beforeParts()), l.type === r.conditionalNodeType && l[r.alternateNodePropertyName] === u ? Kp(2, C) : C), f ? Jp(i) : Yp(Jp(i)), r.afterParts(y))));
      var C;
      return c ? Xp(Jp([Yp(Jp([Hp, E])), Hp])) : E;
    };
    const {
        getNextNonSpaceNonCommentCharacter: nd,
        hasNewline: rd,
        hasNewlineInRange: ud,
        getLast: od,
        getStringWidth: ad,
        printString: id,
        printNumber: sd,
        hasIgnoreComment: ld,
        hasNodeIgnoreComment: cd,
        getIndentSize: pd,
        getPreferredQuote: dd
      } = Lt,
      {
        isNextLineEmpty: fd,
        getNextNonSpaceNonCommentCharacterIndex: hd
      } = bs,
      {
        builders: {
          concat: md,
          join: gd,
          line: Dd,
          hardline: yd,
          softline: Ed,
          literalline: Cd,
          group: bd,
          indent: Ad,
          align: vd,
          conditionalGroup: Fd,
          fill: xd,
          ifBreak: Sd,
          lineSuffixBoundary: wd,
          addAlignmentToDoc: Bd
        },
        utils: {
          willBreak: Td,
          isLineNext: kd,
          isEmpty: Nd,
          removeLines: Od,
          normalizeParts: Pd
        },
        printer: {
          printDocToString: _d
        }
      } = dn,
      {
        insertPragma: Id
      } = Nl,
      {
        printHtmlBinding: jd,
        isVueEventBindingExpression: Md
      } = _c,
      {
        classChildNeedsASIProtection: Ld,
        classPropMayCauseASIProblems: Rd,
        getFlowVariance: qd,
        getLeftSidePathName: Vd,
        getParentExportDeclaration: Wd,
        getTypeScriptMappedTypeModifier: $d,
        hasDanglingComments: Ud,
        hasFlowAnnotationComment: zd,
        hasFlowShorthandAnnotationComment: Jd,
        hasLeadingOwnLineComment: Gd,
        hasNakedLeftSide: Hd,
        hasNewlineBetweenOrAfterDecorators: Xd,
        hasNgSideEffect: Yd,
        hasPrettierIgnore: Kd,
        hasTrailingComment: Qd,
        hasTrailingLineComment: Zd,
        identity: ef,
        isBinaryish: tf,
        isCallOrOptionalCallExpression: nf,
        isEmptyJSXElement: rf,
        isExportDeclaration: uf,
        isFlowAnnotationComment: of,
        isFunctionNotation: af,
        isGetterOrSetter: sf,
        isJestEachTemplateLiteral: lf,
        isJSXNode: cf,
        isJSXWhitespaceExpression: pf,
        isLastStatement: df,
        isLiteral: ff,
        isMeaningfulJSXText: hf,
        isMemberExpressionChain: mf,
        isMemberish: gf,
        isNgForOf: Df,
        isNumericLiteral: yf,
        isObjectType: Ef,
        isObjectTypePropertyAFunction: Cf,
        isSimpleFlowType: bf,
        isSimpleNumber: Af,
        isSimpleTemplateLiteral: vf,
        isStringLiteral: Ff,
        isStringPropSafeToUnquote: xf,
        isTemplateOnItsOwnLine: Sf,
        isTestCall: wf,
        isTheOnlyJSXElementInMarkdown: Bf,
        isTSXFile: Tf,
        isTypeAnnotationAFunction: kf,
        matchJsxWhitespaceRegex: Nf,
        needsHardlineAfterDanglingComment: Of,
        rawText: Pf,
        returnArgumentHasLeadingComment: _f,
        shouldPrintComma: If,
        shouldFlatten: jf,
        startsWithNoLookaheadToken: Mf
      } = Ec,
      {
        printOptionalToken: Lf,
        printFunctionTypeParameters: Rf,
        printMemberLookup: qf,
        printBindExpressionCallee: Vf
      } = lp,
      {
        printModuleSource: Wf,
        printModuleSpecifiers: $f
      } = $p,
      Uf = new WeakMap();
    let zf = 0;
    function Jf(e, t, n) {
      const r = e.getValue();
      return bd(md([gd(Dd, e.map(n, "decorators")), Xd(r, t) ? yd : Dd]));
    }
    function Gf(e, t, n) {
      const r = [],
        u = e.getNode(),
        o = "ClassBody" === u.type;
      return e.map((e, a) => {
        const i = e.getValue();
        if (!i) return;
        if ("EmptyStatement" === i.type) return;
        const s = n(e),
          l = t.originalText,
          c = [];
        if (t.semi || o || Bf(t, e) || !function (e, t) {
          if ("ExpressionStatement" !== e.getNode().type) return !1;
          return e.call(e => function e(t, n) {
            const r = t.getValue();
            if (kc(t, n) || "ParenthesizedExpression" === r.type || "TypeCastExpression" === r.type || "ArrowFunctionExpression" === r.type && !Zf(t, n) || "ArrayExpression" === r.type || "ArrayPattern" === r.type || "UnaryExpression" === r.type && r.prefix && ("+" === r.operator || "-" === r.operator) || "TemplateLiteral" === r.type || "TemplateElement" === r.type || cf(r) || "BindExpression" === r.type && !r.object || "RegExpLiteral" === r.type || "Literal" === r.type && r.pattern || "Literal" === r.type && r.regex) return !0;
            if (!Hd(r)) return !1;
            return t.call(t => e(t, n), ...Vd(t, r));
          }(e, t), "expression");
        }(e, t) ? c.push(s) : i.comments && i.comments.some(e => e.leading) ? c.push(n(e, {
          needsSemi: !0
        })) : c.push(";", s), !t.semi && o) if (Rd(e)) c.push(";");else if ("ClassProperty" === i.type) {
          const _e102 = u.body[a + 1];
          Ld(_e102) && c.push(";");
        }
        fd(l, i, t.locEnd) && !df(e) && c.push(yd), r.push(md(c));
      }), gd(yd, r);
    }
    function Hf(e, t, n) {
      const r = e.getNode();
      if (r.computed) return md(["[", e.call(n, "key"), "]"]);
      const u = e.getParentNode(),
        {
          key: o
        } = r;
      if ("ClassPrivateProperty" === r.type && "Identifier" === o.type) return md(["#", e.call(n, "key")]);
      if ("consistent" === t.quoteProps && !Uf.has(u)) {
        const _e103 = (u.properties || u.body || u.members).some(e => !e.computed && e.key && Ff(e.key) && !xf(e, t));
        Uf.set(u, _e103);
      }
      if (("Identifier" === o.type || yf(o) && Af(sd(Pf(o))) && String(o.value) === sd(Pf(o)) && "typescript" !== t.parser && "babel-ts" !== t.parser) && ("json" === t.parser || "consistent" === t.quoteProps && Uf.get(u))) {
        const _n16 = id(JSON.stringify("Identifier" === o.type ? o.name : o.value.toString()), t);
        return e.call(e => Di.printComments(e, () => _n16, t), "key");
      }
      return xf(r, t) && ("as-needed" === t.quoteProps || "consistent" === t.quoteProps && !Uf.get(u)) ? e.call(e => Di.printComments(e, () => /^\d/.test(o.value) ? sd(o.value) : o.value, t), "key") : e.call(n, "key");
    }
    function Xf(e, t, n) {
      const r = e.getNode(),
        {
          kind: u
        } = r,
        o = r.value || r,
        a = [];
      return u && "init" !== u && "method" !== u && "constructor" !== u ? (Xa.ok("get" === u || "set" === u), a.push(u, " ")) : (o.async && a.push("async "), o.generator && a.push("*")), a.push(Hf(e, t, n), r.optional || r.key.optional ? "?" : "", r === o ? Yf(e, t, n) : e.call(e => Yf(e, t, n), "value")), md(a);
    }
    function Yf(e, t, n) {
      const r = [Rf(e, t, n), bd(md([Qf(e, n, t), th(e, n, t)]))];
      return e.getNode().body ? r.push(" ", e.call(n, "body")) : r.push(t.semi ? ";" : ""), md(r);
    }
    function Kf(e, t, n) {
      const r = e.getValue();
      if (!r.typeAnnotation) return "";
      const u = e.getParentNode(),
        o = r.definite || u && "VariableDeclarator" === u.type && u.definite,
        a = "DeclareFunction" === u.type && u.id === r;
      return of(t.originalText, r.typeAnnotation, t) ? md([" /*: ", e.call(n, "typeAnnotation"), " */"]) : md([a ? "" : o ? "!: " : ": ", e.call(n, "typeAnnotation")]);
    }
    function Qf(e, t, n, r, u) {
      const o = e.getValue(),
        a = e.getParentNode(),
        i = o.parameters ? "parameters" : "params",
        s = wf(a),
        l = yh(o),
        c = r && !(o[i] && o[i].some(e => e.comments)),
        p = u ? Rf(e, n, t) : "";
      let d = [];
      if (o[i]) {
        const _r22 = o[i].length - 1;
        d = e.map((e, u) => {
          const a = [],
            i = e.getValue();
          return a.push(t(e)), u === _r22 ? o.rest && a.push(",", Dd) : s || l || c ? a.push(", ") : fd(n.originalText, i, n.locEnd) ? a.push(",", yd, yd) : a.push(",", Dd), md(a);
        }, i);
      }
      if (o.rest && d.push(md(["...", e.call(t, "rest")])), 0 === d.length) return md([p, "(", Di.printDanglingComments(e, n, !0, e => ")" === nd(n.originalText, e, n.locEnd)), ")"]);
      const f = od(o[i]);
      if (c) return bd(md([Od(p), "(", md(d.map(Od)), ")"]));
      const h = o[i].every(e => !e.decorators);
      if (l && h) return md([p, "(", md(d), ")"]);
      if (s) return md([p, "(", md(d), ")"]);
      if ((Cf(a, n) || kf(a, n) || "TypeAlias" === a.type || "UnionTypeAnnotation" === a.type || "TSUnionType" === a.type || "IntersectionTypeAnnotation" === a.type || "FunctionTypeAnnotation" === a.type && a.returnType === o) && 1 === o[i].length && null === o[i][0].name && o[i][0].typeAnnotation && null === o.typeParameters && bf(o[i][0].typeAnnotation) && !o.rest) return "always" === n.arrowParens ? md(["(", md(d), ")"]) : md(d);
      const m = !(f && "RestElement" === f.type || o.rest);
      return md([p, "(", Ad(md([Ed, md(d)])), Sd(m && If(n, "all") ? "," : ""), Ed, ")"]);
    }
    function Zf(e, t) {
      if ("always" === t.arrowParens) return !1;
      if ("avoid" === t.arrowParens) {
        return function (e) {
          return !(1 !== e.params.length || e.rest || e.typeParameters || Ud(e) || "Identifier" !== e.params[0].type || e.params[0].typeAnnotation || e.params[0].comments || e.params[0].optional || e.predicate || e.returnType);
        }(e.getValue());
      }
      return !1;
    }
    function eh(e, t, n) {
      const r = e.getValue(),
        u = [];
      return r.async && u.push("async "), r.generator ? u.push("function* ") : u.push("function "), r.id && u.push(e.call(t, "id")), u.push(Rf(e, n, t), bd(md([Qf(e, t, n), th(e, t, n)])), r.body ? " " : "", e.call(t, "body")), md(u);
    }
    function th(e, t, n) {
      const r = e.getValue(),
        u = e.call(t, "returnType");
      if (r.returnType && of(n.originalText, r.returnType, n)) return md([" /*: ", u, " */"]);
      const o = [u];
      return r.returnType && r.returnType.typeAnnotation && o.unshift(": "), r.predicate && o.push(r.returnType ? " " : ": ", e.call(t, "predicate")), md(o);
    }
    function nh(e, t, n) {
      const r = e.getValue(),
        u = t.semi ? ";" : "",
        o = ["export "],
        a = r.default || "ExportDefaultDeclaration" === r.type;
      return a && o.push("default "), o.push(Di.printDanglingComments(e, t, !0)), Of(r) && o.push(yd), r.declaration ? (o.push(e.call(n, "declaration")), a && "ClassDeclaration" !== r.declaration.type && "FunctionDeclaration" !== r.declaration.type && "TSInterfaceDeclaration" !== r.declaration.type && "DeclareClass" !== r.declaration.type && "DeclareFunction" !== r.declaration.type && "TSDeclareFunction" !== r.declaration.type && "EnumDeclaration" !== r.declaration.type && o.push(u)) : (o.push("type" === r.exportKind ? "type " : ""), o.push($f(e, t, n)), o.push(Wf(e, t, n)), o.push(u)), md(o);
    }
    function rh(e, t) {
      const n = Wd(e);
      return n ? Xa.strictEqual(n.type, "DeclareExportDeclaration") : t.unshift("declare "), md(t);
    }
    function uh(e, t, n) {
      const r = e.getValue();
      return r.modifiers && r.modifiers.length ? md([gd(" ", e.map(n, "modifiers")), " "]) : "";
    }
    const oh = new WeakMap();
    function ah(e) {
      return oh.has(e) || oh.set(e, Symbol("typeParameters")), oh.get(e);
    }
    function ih(e, t, n, r) {
      const u = e.getValue();
      if (!u[r]) return "";
      if (!Array.isArray(u[r])) return e.call(n, r);
      const o = e.getNode(2),
        a = e.getNode(3),
        i = e.getNode(4);
      return null != o && wf(o) || 0 === u[r].length || 1 === u[r].length && (Dh(u[r][0]) || "GenericTypeAnnotation" === u[r][0].type && Dh(u[r][0].id) || "TSTypeReference" === u[r][0].type && Dh(u[r][0].typeName) || "NullableTypeAnnotation" === u[r][0].type || i && "VariableDeclarator" === i.type && "TSTypeAnnotation" === o.type && "ArrowFunctionExpression" !== a.type && "TSUnionType" !== u[r][0].type && "UnionTypeAnnotation" !== u[r][0].type && "TSIntersectionType" !== u[r][0].type && "IntersectionTypeAnnotation" !== u[r][0].type && "TSConditionalType" !== u[r][0].type && "TSMappedType" !== u[r][0].type && "TSTypeOperator" !== u[r][0].type && "TSIndexedAccessType" !== u[r][0].type && "TSArrayType" !== u[r][0].type) ? md(["<", gd(", ", e.map(n, r)), function (n) {
        if (!Ud(n)) return "";
        const r = n.comments.every(Gs.isBlockComment),
          u = Di.printDanglingComments(e, t, r);
        return r ? u : md([u, yd]);
      }(u), ">"]) : bd(md(["<", Ad(md([Ed, gd(md([",", Dd]), e.map(n, r))])), Sd("typescript" !== t.parser && "babel-ts" !== t.parser && If(t, "all") ? "," : ""), Ed, ">"]), {
        id: ah(u)
      });
    }
    function sh(e, t, n) {
      const r = e.getValue(),
        u = [];
      r.abstract && u.push("abstract "), u.push("class");
      const o = r.id && Qd(r.id) || r.superClass && r.superClass.comments && 0 !== r.superClass.comments.length || r.extends && 0 !== r.extends.length || r.mixins && 0 !== r.mixins.length || r.implements && 0 !== r.implements.length,
        a = [],
        i = [];
      r.id && a.push(" ", e.call(n, "id")), a.push(e.call(n, "typeParameters"));
      const s = ["superClass", "extends", "mixins", "implements"].filter(e => !!r[e]).length > 1,
        l = r.typeParameters && !Zd(r.typeParameters) && !s;
      function c(u) {
        if (r[u] && 0 !== r[u].length) {
          const o = Di.printDanglingComments(e, t, !0, ({
            marker: e
          }) => e === u);
          i.push(l ? Sd(" ", Dd, {
            groupId: ah(r.typeParameters)
          }) : Dd, o, o && yd, u, bd(Ad(md([Dd, gd(md([",", Dd]), e.map(n, u))]))));
        }
      }
      if (r.superClass) {
        const _r23 = md(["extends ", e.call(n, "superClass"), e.call(n, "superTypeParameters")]),
          _u10 = e.call(e => Di.printComments(e, () => _r23, t), "superClass");
        o ? i.push(Dd, bd(_u10)) : i.push(" ", _u10);
      } else c("extends");
      if (c("mixins"), c("implements"), o) {
        const _e104 = md(i);
        l ? u.push(bd(md(a.concat(Sd(Ad(_e104), _e104))))) : u.push(bd(Ad(md(a.concat(_e104)))));
      } else u.push(...a, ...i);
      return u.push(" ", e.call(n, "body")), u;
    }
    function lh(e, t, n, r) {
      return e ? "" : "JSXElement" === n.type && !n.closingElement || r && "JSXElement" === r.type && !r.closingElement ? 1 === t.length ? Ed : yd : Ed;
    }
    function ch(e, t, n, r) {
      return e ? yd : 1 === t.length ? "JSXElement" === n.type && !n.closingElement || r && "JSXElement" === r.type && !r.closingElement ? yd : Ed : yd;
    }
    function ph(e) {
      return "LogicalExpression" === e.type && ("ObjectExpression" === e.right.type && 0 !== e.right.properties.length || "ArrayExpression" === e.right.type && 0 !== e.right.elements.length || !!cf(e.right));
    }
    function dh(e, t, n, r) {
      if (Gd(r.originalText, t, r)) return Ad(md([Dd, n]));
      return tf(t) && !ph(t) || "ConditionalExpression" === t.type && tf(t.test) && !ph(t.test) || "StringLiteralTypeAnnotation" === t.type || "ClassExpression" === t.type && t.decorators && t.decorators.length || ("Identifier" === e.type || Ff(e) || "MemberExpression" === e.type) && (Ff(t) || mf(t)) && "json" !== r.parser && "json5" !== r.parser || "SequenceExpression" === t.type ? bd(Ad(md([Dd, n]))) : md([" ", n]);
    }
    function fh(e, t, n, r, u, o) {
      if (!r) return t;
      const a = dh(e, r, u, o);
      return bd(md([t, n, a]));
    }
    function hh(e, t, n) {
      return "EmptyStatement" === e.type ? ";" : "BlockStatement" === e.type || n ? md([" ", t]) : Ad(md([Dd, t]));
    }
    function mh(e, t, n) {
      const r = Pf(e),
        u = n || "DirectiveLiteral" === e.type;
      return id(r, t, u);
    }
    function gh(e) {
      const t = e.flags.split("").sort().join("");
      return "/".concat(e.pattern, "/").concat(t);
    }
    function Dh(e) {
      if (bf(e) || Ef(e)) return !0;
      if ("UnionTypeAnnotation" === e.type || "TSUnionType" === e.type) {
        const t = e.types.filter(e => "VoidTypeAnnotation" === e.type || "TSVoidKeyword" === e.type || "NullLiteralTypeAnnotation" === e.type || "TSNullKeyword" === e.type).length,
          n = e.types.some(e => "ObjectTypeAnnotation" === e.type || "TSTypeLiteral" === e.type || "GenericTypeAnnotation" === e.type || "TSTypeReference" === e.type);
        if (e.types.length - 1 === t && n) return !0;
      }
      return !1;
    }
    function yh(e) {
      if (!e || e.rest) return !1;
      const t = e.params || e.parameters;
      if (!t || 1 !== t.length) return !1;
      const n = t[0];
      return !n.comments && ("ObjectPattern" === n.type || "ArrayPattern" === n.type || "Identifier" === n.type && n.typeAnnotation && ("TypeAnnotation" === n.typeAnnotation.type || "TSTypeAnnotation" === n.typeAnnotation.type) && Ef(n.typeAnnotation.typeAnnotation) || "FunctionTypeParam" === n.type && Ef(n.typeAnnotation) || "AssignmentPattern" === n.type && ("ObjectPattern" === n.left.type || "ArrayPattern" === n.left.type) && ("Identifier" === n.right.type || "ObjectExpression" === n.right.type && 0 === n.right.properties.length || "ArrayExpression" === n.right.type && 0 === n.right.elements.length));
    }
    function Eh(e, t, n, r) {
      const u = [];
      let o = [];
      return e.each(e => {
        u.push(md(o)), u.push(bd(r(e))), o = [",", Dd], e.getValue() && fd(t.originalText, e.getValue(), t.locEnd) && o.push(Ed);
      }, n), md(u);
    }
    function Ch(e, t, n) {
      const r = e.getValue(),
        u = t.semi ? ";" : "",
        o = [];
      r.argument && (_f(t, r.argument) ? o.push(md([" (", Ad(md([yd, e.call(n, "argument")])), yd, ")"])) : tf(r.argument) || "SequenceExpression" === r.argument.type ? o.push(bd(md([Sd(" (", " "), Ad(md([Ed, e.call(n, "argument")])), Ed, Sd(")")]))) : o.push(" ", e.call(n, "argument")));
      const a = Array.isArray(r.comments) && r.comments[r.comments.length - 1],
        i = a && ("CommentLine" === a.type || "Line" === a.type);
      return i && o.push(u), Ud(r) && o.push(" ", Di.printDanglingComments(e, t, !0)), i || o.push(u), md(o);
    }
    function bh(e) {
      const t = e.getValue(),
        n = e.getParentNode();
      return (t && (cf(t) || Jd(t) || n && ("CallExpression" === n.type || "OptionalCallExpression" === n.type) && (zd(t.leadingComments) || zd(t.trailingComments))) || n && ("JSXSpreadAttribute" === n.type || "JSXSpreadChild" === n.type || "UnionTypeAnnotation" === n.type || "TSUnionType" === n.type || ("ClassDeclaration" === n.type || "ClassExpression" === n.type) && n.superClass === t)) && (!ld(e) || "UnionTypeAnnotation" === n.type || "TSUnionType" === n.type);
    }
    var Ah = {
      preprocess: Ic,
      print: function (e, t, n, r) {
        const u = e.getValue();
        let o = !1;
        const a = function (e, t, n, r) {
          const u = e.getValue(),
            o = t.semi ? ";" : "";
          if (!u) return "";
          if ("string" == typeof u) return u;
          const a = jd(e, t, n);
          if (a) return a;
          let i = [];
          switch (u.type) {
            case "JsExpressionRoot":
              return e.call(n, "node");
            case "JsonRoot":
              return md([e.call(n, "node"), yd]);
            case "File":
              return u.program && u.program.interpreter && i.push(e.call(e => e.call(n, "interpreter"), "program")), i.push(e.call(n, "program")), md(i);
            case "Program":
              {
                const _r24 = !u.body.every(({
                  type: e
                }) => "EmptyStatement" === e) || u.comments;
                if (u.directives) {
                  const _a8 = u.directives.length;
                  e.map((e, u) => {
                    i.push(n(e), o, yd), (u < _a8 - 1 || _r24) && fd(t.originalText, e.getValue(), t.locEnd) && i.push(yd);
                  }, "directives");
                }
                return i.push(e.call(e => Gf(e, t, n), "body")), i.push(Di.printDanglingComments(e, t, !0)), _r24 && i.push(yd), md(i);
              }
            case "EmptyStatement":
              return "";
            case "ExpressionStatement":
              if (u.directive) return md([mh(u.expression, t, !0), o]);
              if ("__vue_event_binding" === t.parser) {
                const _t56 = e.getParentNode();
                if ("Program" === _t56.type && 1 === _t56.body.length && _t56.body[0] === u) return md([e.call(n, "expression"), Md(u.expression) ? ";" : ""]);
              }
              return md([e.call(n, "expression"), Bf(t, e) ? "" : o]);
            case "ParenthesizedExpression":
              return !u.expression.comments ? md(["(", e.call(n, "expression"), ")"]) : bd(md(["(", Ad(md([Ed, e.call(n, "expression")])), Ed, ")"]));
            case "AssignmentExpression":
              return fh(u.left, e.call(n, "left"), md([" ", u.operator]), u.right, e.call(n, "right"), t);
            case "BinaryExpression":
            case "LogicalExpression":
            case "NGPipeExpression":
              {
                const _r25 = e.getParentNode(),
                  _o9 = e.getParentNode(1),
                  _a9 = u !== _r25.body && ("IfStatement" === _r25.type || "WhileStatement" === _r25.type || "SwitchStatement" === _r25.type || "DoWhileStatement" === _r25.type),
                  _i4 = function e(t, n, r, u, o) {
                    let a = [];
                    const i = t.getValue();
                    if (tf(i)) {
                      jf(i.operator, i.left.operator) ? a = a.concat(t.call(t => e(t, n, r, !0, o), "left")) : a.push(bd(t.call(n, "left")));
                      const s = ph(i),
                        l = ("|>" === i.operator || "NGPipeExpression" === i.type || "|" === i.operator && "__vue_expression" === r.parser) && !Gd(r.originalText, i.right, r),
                        c = "NGPipeExpression" === i.type ? "|" : i.operator,
                        p = "NGPipeExpression" === i.type && 0 !== i.arguments.length ? bd(Ad(md([Ed, ": ", gd(md([Ed, ":", Sd(" ")]), t.map(n, "arguments").map(e => vd(2, bd(e))))]))) : "",
                        d = md(s ? [c, " ", t.call(n, "right"), p] : [l ? Dd : "", c, l ? " " : Dd, t.call(n, "right"), p]),
                        f = t.getParentNode(),
                        h = Zd(i.left),
                        m = h || !(o && "LogicalExpression" === i.type) && f.type !== i.type && i.left.type !== i.type && i.right.type !== i.type;
                      a.push(l ? "" : " ", m ? bd(d, {
                        shouldBreak: h
                      }) : d), u && i.comments && (a = Pd(Di.printComments(t, () => md(a), r).parts));
                    } else a.push(bd(t.call(n)));
                    return a;
                  }(e, n, t, !1, _a9);
                if (_a9) return md(_i4);
                if (("CallExpression" === _r25.type || "OptionalCallExpression" === _r25.type) && _r25.callee === u || "UnaryExpression" === _r25.type || ("MemberExpression" === _r25.type || "OptionalMemberExpression" === _r25.type) && !_r25.computed) return bd(md([Ad(md([Ed, md(_i4)])), Ed]));
                const s = "ReturnStatement" === _r25.type || "ThrowStatement" === _r25.type || "JSXExpressionContainer" === _r25.type && "JSXAttribute" === _o9.type || "|" !== u.operator && "JsExpressionRoot" === _r25.type || "NGPipeExpression" !== u.type && ("NGRoot" === _r25.type && "__ng_binding" === t.parser || "NGMicrosyntaxExpression" === _r25.type && "NGMicrosyntax" === _o9.type && 1 === _o9.body.length) || u === _r25.body && "ArrowFunctionExpression" === _r25.type || u !== _r25.body && "ForStatement" === _r25.type || "ConditionalExpression" === _r25.type && "ReturnStatement" !== _o9.type && "ThrowStatement" !== _o9.type && "CallExpression" !== _o9.type && "OptionalCallExpression" !== _o9.type || "TemplateLiteral" === _r25.type,
                  l = "AssignmentExpression" === _r25.type || "VariableDeclarator" === _r25.type || "ClassProperty" === _r25.type || "TSAbstractClassProperty" === _r25.type || "ClassPrivateProperty" === _r25.type || "ObjectProperty" === _r25.type || "Property" === _r25.type,
                  c = tf(u.left) && jf(u.operator, u.left.operator);
                if (s || ph(u) && !c || !ph(u) && l) return bd(md(_i4));
                if (0 === _i4.length) return "";
                const p = cf(u.right),
                  d = _i4.findIndex(e => "string" != typeof e && "group" === e.type),
                  f = _i4.slice(0, -1 === d ? 1 : d + 1),
                  h = md(_i4.slice(f.length, p ? -1 : void 0)),
                  m = Symbol("logicalChain-" + ++zf),
                  g = bd(md([...f, Ad(h)]), {
                    id: m
                  });
                if (!p) return g;
                const D = od(_i4);
                return bd(md([g, Sd(Ad(D), D, {
                  groupId: m
                })]));
              }
            case "AssignmentPattern":
              return md([e.call(n, "left"), " = ", e.call(n, "right")]);
            case "TSTypeAssertion":
              {
                const _t57 = !("ArrayExpression" === u.expression.type || "ObjectExpression" === u.expression.type),
                  _r26 = bd(md(["<", Ad(md([Ed, e.call(n, "typeAnnotation")])), Ed, ">"])),
                  _o10 = md([Sd("("), Ad(md([Ed, e.call(n, "expression")])), Ed, Sd(")")]);
                return _t57 ? Fd([md([_r26, e.call(n, "expression")]), md([_r26, bd(_o10, {
                  shouldBreak: !0
                })]), md([_r26, e.call(n, "expression")])]) : bd(md([_r26, e.call(n, "expression")]));
              }
            case "OptionalMemberExpression":
            case "MemberExpression":
              {
                const _r27 = e.getParentNode();
                let _o11,
                  _a10 = 0;
                do {
                  _o11 = e.getParentNode(_a10), _a10++;
                } while (_o11 && ("MemberExpression" === _o11.type || "OptionalMemberExpression" === _o11.type || "TSNonNullExpression" === _o11.type));
                const _i5 = _o11 && ("NewExpression" === _o11.type || "BindExpression" === _o11.type || "VariableDeclarator" === _o11.type && "Identifier" !== _o11.id.type || "AssignmentExpression" === _o11.type && "Identifier" !== _o11.left.type) || u.computed || "Identifier" === u.object.type && "Identifier" === u.property.type && "MemberExpression" !== _r27.type && "OptionalMemberExpression" !== _r27.type;
                return md([e.call(n, "object"), _i5 ? qf(e, t, n) : bd(Ad(md([Ed, qf(e, t, n)])))]);
              }
            case "MetaProperty":
              return md([e.call(n, "meta"), ".", e.call(n, "property")]);
            case "BindExpression":
              return u.object && i.push(e.call(n, "object")), i.push(bd(Ad(md([Ed, Vf(e, t, n)])))), md(i);
            case "Identifier":
              return md([u.name, Lf(e), Kf(e, t, n)]);
            case "V8IntrinsicIdentifier":
              return md(["%", u.name]);
            case "SpreadElement":
            case "SpreadElementPattern":
            case "SpreadProperty":
            case "SpreadPropertyPattern":
            case "RestElement":
            case "ObjectTypeSpreadProperty":
              return md(["...", e.call(n, "argument"), Kf(e, t, n)]);
            case "FunctionDeclaration":
            case "FunctionExpression":
              return i.push(eh(e, n, t)), u.body || i.push(o), md(i);
            case "ArrowFunctionExpression":
              {
                u.async && i.push("async "), Zf(e, t) ? i.push(e.call(n, "params", 0)) : i.push(bd(md([Qf(e, n, t, r && (r.expandLastArg || r.expandFirstArg), !0), th(e, n, t)])));
                const _o12 = Di.printDanglingComments(e, t, !0, e => {
                  const n = hd(t.originalText, e, t.locEnd);
                  return !1 !== n && "=>" === t.originalText.slice(n, n + 2);
                });
                _o12 && i.push(" ", _o12), i.push(" =>");
                const _a11 = e.call(e => n(e, r), "body");
                if (!Gd(t.originalText, u.body, t) && ("ArrayExpression" === u.body.type || "ObjectExpression" === u.body.type || "BlockStatement" === u.body.type || cf(u.body) || Sf(u.body, t.originalText, t) || "ArrowFunctionExpression" === u.body.type || "DoExpression" === u.body.type)) return bd(md([md(i), " ", _a11]));
                if ("SequenceExpression" === u.body.type) return bd(md([md(i), bd(md([" (", Ad(md([Ed, _a11])), Ed, ")"]))]));
                const s = (r && r.expandLastArg || "JSXExpressionContainer" === e.getParentNode().type) && !(u.comments && u.comments.length),
                  l = r && r.expandLastArg && If(t, "all"),
                  c = "ConditionalExpression" === u.body.type && !Mf(u.body, !1);
                return bd(md([md(i), bd(md([Ad(md([Dd, c ? Sd("", "(") : "", _a11, c ? Sd("", ")") : ""])), s ? md([Sd(l ? "," : ""), Ed]) : ""]))]));
              }
            case "YieldExpression":
              return i.push("yield"), u.delegate && i.push("*"), u.argument && i.push(" ", e.call(n, "argument")), md(i);
            case "AwaitExpression":
              {
                i.push("await"), u.argument && i.push(" ", e.call(n, "argument"));
                const _t58 = e.getParentNode();
                return ("CallExpression" === _t58.type || "OptionalCallExpression" === _t58.type) && _t58.callee === u || ("MemberExpression" === _t58.type || "OptionalMemberExpression" === _t58.type) && _t58.object === u ? bd(md([Ad(md([Ed, md(i)])), Ed])) : md(i);
              }
            case "ImportSpecifier":
              return u.importKind && i.push(e.call(n, "importKind"), " "), i.push(e.call(n, "imported")), u.local && u.local.name !== u.imported.name && i.push(" as ", e.call(n, "local")), md(i);
            case "ExportSpecifier":
              return i.push(e.call(n, "local")), u.exported && u.exported.name !== u.local.name && i.push(" as ", e.call(n, "exported")), md(i);
            case "ImportNamespaceSpecifier":
              return i.push("* as "), i.push(e.call(n, "local")), md(i);
            case "ImportDefaultSpecifier":
              return e.call(n, "local");
            case "TSExportAssignment":
              return md(["export = ", e.call(n, "expression"), o]);
            case "ExportDefaultDeclaration":
            case "ExportNamedDeclaration":
              return nh(e, t, n);
            case "DeclareExportDeclaration":
              return md(["declare ", nh(e, t, n)]);
            case "ExportAllDeclaration":
              return i.push("export"), "type" === u.exportKind && i.push(" type"), i.push(" *"), u.exported && i.push(" as ", e.call(n, "exported")), i.push(Wf(e, t, n), o), md(i);
            case "ExportNamespaceSpecifier":
              return md(["* as ", e.call(n, "exported")]);
            case "ExportDefaultSpecifier":
              return e.call(n, "exported");
            case "ImportDeclaration":
              return i.push("import"), u.importKind && "value" !== u.importKind && i.push(" ", u.importKind), u.specifiers && u.specifiers.length > 0 ? (i.push($f(e, t, n)), i.push(Wf(e, t, n))) : u.importKind && "type" === u.importKind || /{\s*}/.test(t.originalText.slice(t.locStart(u), t.locStart(u.source))) ? i.push(" {}", Wf(e, t, n)) : i.push(" ", e.call(n, "source")), Array.isArray(u.attributes) && 0 !== u.attributes.length && i.push(" with ", md(e.map(n, "attributes"))), i.push(o), md(i);
            case "ImportAttribute":
              return md([e.call(n, "key"), ": ", e.call(n, "value")]);
            case "Import":
              return "import";
            case "TSModuleBlock":
            case "BlockStatement":
              {
                const _r28 = e.call(e => Gf(e, t, n), "body"),
                  _a12 = u.body.some(e => "EmptyStatement" !== e.type),
                  s = u.directives && u.directives.length > 0,
                  l = e.getParentNode(),
                  c = e.getParentNode(1);
                return _a12 || s || Ud(u) || "ArrowFunctionExpression" !== l.type && "FunctionExpression" !== l.type && "FunctionDeclaration" !== l.type && "ObjectMethod" !== l.type && "ClassMethod" !== l.type && "ClassPrivateMethod" !== l.type && "ForStatement" !== l.type && "WhileStatement" !== l.type && "DoWhileStatement" !== l.type && "DoExpression" !== l.type && ("CatchClause" !== l.type || c.finalizer) && "TSModuleDeclaration" !== l.type ? (i.push("{"), s && e.each(e => {
                  i.push(Ad(md([yd, n(e), o]))), fd(t.originalText, e.getValue(), t.locEnd) && i.push(yd);
                }, "directives"), _a12 && i.push(Ad(md([yd, _r28]))), i.push(Di.printDanglingComments(e, t)), i.push(yd, "}"), md(i)) : "{}";
              }
            case "ReturnStatement":
              return md(["return", Ch(e, t, n)]);
            case "NewExpression":
            case "ImportExpression":
            case "OptionalCallExpression":
            case "CallExpression":
              {
                const _r29 = "NewExpression" === u.type,
                  _o13 = "ImportExpression" === u.type,
                  _a13 = Lf(e),
                  _i6 = _o13 ? [u.source] : u.arguments;
                if (!_o13 && !_r29 && "Identifier" === u.callee.type && ("require" === u.callee.name || "define" === u.callee.name) || 1 === _i6.length && Sf(_i6[0], t.originalText, t) || !_r29 && wf(u, e.getParentNode())) return md([_r29 ? "new " : "", e.call(n, "callee"), _a13, Rf(e, t, n), md(["(", _o13 ? e.call(n, "source") : gd(", ", e.map(n, "arguments")), ")"])]);
                const s = u.callee && "Identifier" === u.callee.type && zd(u.callee.trailingComments);
                if (s && (u.callee.trailingComments[0].printed = !0), !_o13 && !_r29 && gf(u.callee) && !e.call(e => kc(e, t), "callee")) return _p(e, t, n);
                const l = md([_r29 ? "new " : "", _o13 ? "import" : e.call(n, "callee"), _a13, s ? "/*:: ".concat(u.callee.trailingComments[0].value.slice(2).trim(), " */") : "", Rf(e, t, n), np(e, t, n)]);
                return _o13 || nf(u.callee) ? bd(l) : l;
              }
            case "ObjectTypeInternalSlot":
              return md([u.static ? "static " : "", "[[", e.call(n, "id"), "]]", Lf(e), u.method ? "" : ": ", e.call(n, "value")]);
            case "ObjectExpression":
            case "ObjectPattern":
            case "ObjectTypeAnnotation":
            case "TSInterfaceBody":
            case "TSTypeLiteral":
            case "RecordExpression":
              {
                let _r30;
                _r30 = "TSTypeLiteral" === u.type ? "members" : "TSInterfaceBody" === u.type ? "body" : "properties";
                const _a14 = "ObjectTypeAnnotation" === u.type,
                  _i7 = [];
                _a14 && _i7.push("indexers", "callProperties", "internalSlots"), _i7.push(_r30);
                const s = _i7.map(e => u[e][0]).sort((e, n) => t.locStart(e) - t.locStart(n))[0],
                  l = e.getParentNode(0),
                  c = _a14 && l && ("InterfaceDeclaration" === l.type || "DeclareInterface" === l.type || "DeclareClass" === l.type) && "body" === e.getName(),
                  p = "TSInterfaceBody" === u.type || c || "ObjectPattern" === u.type && "FunctionDeclaration" !== l.type && "FunctionExpression" !== l.type && "ArrowFunctionExpression" !== l.type && "ObjectMethod" !== l.type && "ClassMethod" !== l.type && "ClassPrivateMethod" !== l.type && "AssignmentPattern" !== l.type && "CatchClause" !== l.type && u.properties.some(e => e.value && ("ObjectPattern" === e.value.type || "ArrayPattern" === e.value.type)) || "ObjectPattern" !== u.type && s && ud(t.originalText, t.locStart(u), t.locStart(s)),
                  d = c ? ";" : "TSInterfaceBody" === u.type || "TSTypeLiteral" === u.type ? Sd(o, ";") : ",",
                  f = "RecordExpression" === u.type ? "#{" : u.exact ? "{|" : "{",
                  h = u.exact ? "|}" : "}",
                  m = [];
                _i7.forEach(r => {
                  e.each(e => {
                    const r = e.getValue();
                    m.push({
                      node: r,
                      printed: n(e),
                      loc: t.locStart(r)
                    });
                  }, r);
                });
                let g = [];
                const D = m.sort((e, t) => e.loc - t.loc).map(e => {
                  const n = md(g.concat(bd(e.printed)));
                  return g = [d, Dd], "TSPropertySignature" !== e.node.type && "TSMethodSignature" !== e.node.type && "TSConstructSignatureDeclaration" !== e.node.type || !cd(e.node) || g.shift(), fd(t.originalText, e.node, t.locEnd) && g.push(yd), n;
                });
                if (u.inexact) {
                  let _n17;
                  if (Ud(u)) {
                    const _r31 = !u.comments.every(Gs.isBlockComment),
                      _o14 = Di.printDanglingComments(e, t, !0);
                    _n17 = md([_o14, _r31 || rd(t.originalText, t.locEnd(u.comments[u.comments.length - 1])) ? yd : Dd, "..."]);
                  } else _n17 = "...";
                  D.push(md(g.concat(_n17)));
                }
                const y = od(u[_r30]),
                  E = !(u.inexact || y && "RestElement" === y.type);
                let C;
                if (0 === D.length) {
                  if (!Ud(u)) return md([f, h, Kf(e, t, n)]);
                  C = bd(md([f, Di.printDanglingComments(e, t), Ed, h, Lf(e), Kf(e, t, n)]));
                } else C = md([f, Ad(md([t.bracketSpacing ? Dd : Ed, md(D)])), Sd(E && ("," !== d || If(t)) ? d : ""), md([t.bracketSpacing ? Dd : Ed, h]), Lf(e), Kf(e, t, n)]);
                return e.match(e => "ObjectPattern" === e.type && !e.decorators, (e, t, n) => yh(e) && ("params" === t || "parameters" === t) && 0 === n) || e.match(Dh, (e, t) => "typeAnnotation" === t, (e, t) => "typeAnnotation" === t, (e, t, n) => yh(e) && ("params" === t || "parameters" === t) && 0 === n) ? C : bd(C, {
                  shouldBreak: p
                });
              }
            case "ObjectProperty":
            case "Property":
              return u.method || "get" === u.kind || "set" === u.kind ? Xf(e, t, n) : (u.shorthand ? i.push(e.call(n, "value")) : i.push(fh(u.key, Hf(e, t, n), ":", u.value, e.call(n, "value"), t)), md(i));
            case "ClassMethod":
            case "ClassPrivateMethod":
            case "MethodDefinition":
            case "TSAbstractMethodDefinition":
            case "TSDeclareMethod":
              return u.decorators && 0 !== u.decorators.length && i.push(Jf(e, t, n)), u.accessibility && i.push(u.accessibility + " "), u.static && i.push("static "), ("TSAbstractMethodDefinition" === u.type || u.abstract) && i.push("abstract "), i.push(Xf(e, t, n)), md(i);
            case "ObjectMethod":
              return Xf(e, t, n);
            case "Decorator":
              return md(["@", e.call(n, "expression"), e.call(n, "callee")]);
            case "ArrayExpression":
            case "ArrayPattern":
            case "TupleExpression":
              {
                const _r32 = "TupleExpression" === u.type ? "#[" : "[",
                  _o15 = "]";
                if (0 === u.elements.length) Ud(u) ? i.push(bd(md([_r32, Di.printDanglingComments(e, t), Ed, _o15]))) : i.push(_r32, _o15);else {
                  const _a15 = od(u.elements),
                    s = !(_a15 && "RestElement" === _a15.type),
                    l = s && null === _a15,
                    c = !t.__inJestEach && u.elements.length > 1 && u.elements.every((e, t, n) => {
                      const r = e && e.type;
                      if ("ArrayExpression" !== r && "ObjectExpression" !== r) return !1;
                      const u = n[t + 1];
                      if (u && r !== u.type) return !1;
                      const o = "ArrayExpression" === r ? "elements" : "properties";
                      return e[o] && e[o].length > 1;
                    });
                  i.push(bd(md([_r32, Ad(md([Ed, Eh(e, t, "elements", n)])), l ? "," : "", Sd(s && !l && If(t) ? "," : ""), Di.printDanglingComments(e, t, !0), Ed, _o15]), {
                    shouldBreak: c
                  }));
                }
                return i.push(Lf(e), Kf(e, t, n)), md(i);
              }
            case "SequenceExpression":
              {
                const _t59 = e.getParentNode(0);
                if ("ExpressionStatement" === _t59.type || "ForStatement" === _t59.type) {
                  const _t60 = [];
                  return e.each(e => {
                    0 === e.getName() ? _t60.push(n(e)) : _t60.push(",", Ad(md([Dd, n(e)])));
                  }, "expressions"), bd(md(_t60));
                }
                return bd(md([gd(md([",", Dd]), e.map(n, "expressions"))]));
              }
            case "ThisExpression":
              return "this";
            case "Super":
              return "super";
            case "NullLiteral":
              return "null";
            case "RegExpLiteral":
              return gh(u);
            case "NumericLiteral":
              return sd(u.extra.raw);
            case "DecimalLiteral":
              return sd(u.value) + "m";
            case "BigIntLiteral":
              return (u.bigint || u.extra.raw).toLowerCase();
            case "BooleanLiteral":
            case "StringLiteral":
            case "Literal":
              return u.regex ? gh(u.regex) : u.bigint ? u.raw.toLowerCase() : "number" == typeof u.value ? sd(u.raw) : "string" != typeof u.value ? "" + u.value : mh(u, t);
            case "Directive":
              return e.call(n, "value");
            case "DirectiveLiteral":
              return mh(u, t);
            case "UnaryExpression":
              return i.push(u.operator), /[a-z]$/.test(u.operator) && i.push(" "), u.argument.comments && u.argument.comments.length > 0 ? i.push(bd(md(["(", Ad(md([Ed, e.call(n, "argument")])), Ed, ")"]))) : i.push(e.call(n, "argument")), md(i);
            case "UpdateExpression":
              return i.push(e.call(n, "argument"), u.operator), u.prefix && i.reverse(), md(i);
            case "ConditionalExpression":
              return td(e, t, n, {
                beforeParts: () => [e.call(n, "test")],
                afterParts: e => [e ? Ed : ""],
                shouldCheckJsx: !0,
                conditionalNodeType: "ConditionalExpression",
                consequentNodePropertyName: "consequent",
                alternateNodePropertyName: "alternate",
                testNodePropertyNames: ["test"]
              });
            case "VariableDeclaration":
              {
                const _t61 = e.map(e => n(e), "declarations"),
                  _r33 = e.getParentNode(),
                  _a16 = "ForStatement" === _r33.type || "ForInStatement" === _r33.type || "ForOfStatement" === _r33.type,
                  s = u.declarations.some(e => e.init);
                let l;
                return 1 !== _t61.length || u.declarations[0].comments ? _t61.length > 0 && (l = Ad(_t61[0])) : l = _t61[0], i = [u.declare ? "declare " : "", u.kind, l ? md([" ", l]) : "", Ad(md(_t61.slice(1).map(e => md([",", s && !_a16 ? yd : Dd, e]))))], _a16 && _r33.body !== u || i.push(o), bd(md(i));
              }
            case "TSTypeAliasDeclaration":
              {
                u.declare && i.push("declare ");
                const _r34 = dh(u.id, u.typeAnnotation, u.typeAnnotation && e.call(n, "typeAnnotation"), t);
                return i.push("type ", e.call(n, "id"), e.call(n, "typeParameters"), " =", _r34, o), bd(md(i));
              }
            case "VariableDeclarator":
              return fh(u.id, e.call(n, "id"), " =", u.init, u.init && e.call(n, "init"), t);
            case "WithStatement":
              return bd(md(["with (", e.call(n, "object"), ")", hh(u.body, e.call(n, "body"))]));
            case "IfStatement":
              {
                const _r35 = hh(u.consequent, e.call(n, "consequent")),
                  _o16 = bd(md(["if (", bd(md([Ad(md([Ed, e.call(n, "test")])), Ed])), ")", _r35]));
                if (i.push(_o16), u.alternate) {
                  const _r36 = Qd(u.consequent) && u.consequent.comments.some(e => e.trailing && !Gs.isBlockComment(e)) || Of(u),
                    _o17 = "BlockStatement" === u.consequent.type && !_r36;
                  i.push(_o17 ? " " : yd), Ud(u) && i.push(Di.printDanglingComments(e, t, !0), _r36 ? yd : " "), i.push("else", bd(hh(u.alternate, e.call(n, "alternate"), "IfStatement" === u.alternate.type)));
                }
                return md(i);
              }
            case "ForStatement":
              {
                const _r37 = hh(u.body, e.call(n, "body")),
                  _o18 = Di.printDanglingComments(e, t, !0),
                  _a17 = _o18 ? md([_o18, Ed]) : "";
                return u.init || u.test || u.update ? md([_a17, bd(md(["for (", bd(md([Ad(md([Ed, e.call(n, "init"), ";", Dd, e.call(n, "test"), ";", Dd, e.call(n, "update")])), Ed])), ")", _r37]))]) : md([_a17, bd(md(["for (;;)", _r37]))]);
              }
            case "WhileStatement":
              return bd(md(["while (", bd(md([Ad(md([Ed, e.call(n, "test")])), Ed])), ")", hh(u.body, e.call(n, "body"))]));
            case "ForInStatement":
              return bd(md([u.each ? "for each (" : "for (", e.call(n, "left"), " in ", e.call(n, "right"), ")", hh(u.body, e.call(n, "body"))]));
            case "ForOfStatement":
              return bd(md(["for", u.await ? " await" : "", " (", e.call(n, "left"), " of ", e.call(n, "right"), ")", hh(u.body, e.call(n, "body"))]));
            case "DoWhileStatement":
              {
                const _t62 = hh(u.body, e.call(n, "body")),
                  _r38 = bd(md(["do", _t62]));
                return i = [_r38], "BlockStatement" === u.body.type ? i.push(" ") : i.push(yd), i.push("while ("), i.push(bd(md([Ad(md([Ed, e.call(n, "test")])), Ed])), ")", o), md(i);
              }
            case "DoExpression":
              return md(["do ", e.call(n, "body")]);
            case "BreakStatement":
              return i.push("break"), u.label && i.push(" ", e.call(n, "label")), i.push(o), md(i);
            case "ContinueStatement":
              return i.push("continue"), u.label && i.push(" ", e.call(n, "label")), i.push(o), md(i);
            case "LabeledStatement":
              return "EmptyStatement" === u.body.type ? md([e.call(n, "label"), ":;"]) : md([e.call(n, "label"), ": ", e.call(n, "body")]);
            case "TryStatement":
              return md(["try ", e.call(n, "block"), u.handler ? md([" ", e.call(n, "handler")]) : "", u.finalizer ? md([" finally ", e.call(n, "finalizer")]) : ""]);
            case "CatchClause":
              if (u.param) {
                const _r39 = u.param.comments && u.param.comments.some(e => !Gs.isBlockComment(e) || e.leading && rd(t.originalText, t.locEnd(e)) || e.trailing && rd(t.originalText, t.locStart(e), {
                    backwards: !0
                  })),
                  _o19 = e.call(n, "param");
                return md(["catch ", md(_r39 ? ["(", Ad(md([Ed, _o19])), Ed, ") "] : ["(", _o19, ") "]), e.call(n, "body")]);
              }
              return md(["catch ", e.call(n, "body")]);
            case "ThrowStatement":
              return md(["throw", Ch(e, t, n)]);
            case "SwitchStatement":
              return md([bd(md(["switch (", Ad(md([Ed, e.call(n, "discriminant")])), Ed, ")"])), " {", u.cases.length > 0 ? Ad(md([yd, gd(yd, e.map(e => {
                const r = e.getValue();
                return md([e.call(n), u.cases.indexOf(r) !== u.cases.length - 1 && fd(t.originalText, r, t.locEnd) ? yd : ""]);
              }, "cases"))])) : "", yd, "}"]);
            case "SwitchCase":
              {
                u.test ? i.push("case ", e.call(n, "test"), ":") : i.push("default:");
                const _r40 = u.consequent.filter(e => "EmptyStatement" !== e.type);
                if (_r40.length > 0) {
                  const _u11 = e.call(e => Gf(e, t, n), "consequent");
                  i.push(1 === _r40.length && "BlockStatement" === _r40[0].type ? md([" ", _u11]) : Ad(md([yd, _u11])));
                }
                return md(i);
              }
            case "DebuggerStatement":
              return md(["debugger", o]);
            case "JSXAttribute":
              if (i.push(e.call(n, "name")), u.value) {
                let _r41;
                if (Ff(u.value)) {
                  let _e105 = Pf(u.value).replace(/&apos;/g, "'").replace(/&quot;/g, '"');
                  const _n18 = dd(_e105, t.jsxSingleQuote ? "'" : '"'),
                    _o20 = "'" === _n18 ? "&apos;" : "&quot;";
                  _e105 = _e105.slice(1, -1).replace(new RegExp(_n18, "g"), _o20), _r41 = md([_n18, _e105, _n18]);
                } else _r41 = e.call(n, "value");
                i.push("=", _r41);
              }
              return md(i);
            case "JSXIdentifier":
              return "" + u.name;
            case "JSXNamespacedName":
              return gd(":", [e.call(n, "namespace"), e.call(n, "name")]);
            case "JSXMemberExpression":
              return gd(".", [e.call(n, "object"), e.call(n, "property")]);
            case "TSQualifiedName":
              return gd(".", [e.call(n, "left"), e.call(n, "right")]);
            case "JSXSpreadAttribute":
            case "JSXSpreadChild":
              return md(["{", e.call(e => {
                const r = md(["...", n(e)]),
                  u = e.getValue();
                return u.comments && u.comments.length && bh(e) ? md([Ad(md([Ed, Di.printComments(e, () => r, t)])), Ed]) : r;
              }, "JSXSpreadAttribute" === u.type ? "argument" : "expression"), "}"]);
            case "JSXExpressionContainer":
              {
                const _t63 = e.getParentNode(0),
                  _r42 = u.expression.comments && u.expression.comments.length > 0,
                  _o21 = "JSXEmptyExpression" === u.expression.type || !_r42 && ("ArrayExpression" === u.expression.type || "ObjectExpression" === u.expression.type || "ArrowFunctionExpression" === u.expression.type || "CallExpression" === u.expression.type || "OptionalCallExpression" === u.expression.type || "FunctionExpression" === u.expression.type || "TemplateLiteral" === u.expression.type || "TaggedTemplateExpression" === u.expression.type || "DoExpression" === u.expression.type || cf(_t63) && ("ConditionalExpression" === u.expression.type || tf(u.expression)));
                return bd(_o21 ? md(["{", e.call(n, "expression"), wd, "}"]) : md(["{", Ad(md([Ed, e.call(n, "expression")])), Ed, wd, "}"]));
              }
            case "JSXFragment":
            case "JSXElement":
              {
                const _r43 = Di.printComments(e, () => function (e, t, n) {
                  const r = e.getValue();
                  if ("JSXElement" === r.type && rf(r)) return md([e.call(n, "openingElement"), e.call(n, "closingElement")]);
                  const u = "JSXElement" === r.type ? e.call(n, "openingElement") : e.call(n, "openingFragment"),
                    o = "JSXElement" === r.type ? e.call(n, "closingElement") : e.call(n, "closingFragment");
                  if (1 === r.children.length && "JSXExpressionContainer" === r.children[0].type && ("TemplateLiteral" === r.children[0].expression.type || "TaggedTemplateExpression" === r.children[0].expression.type)) return md([u, md(e.map(n, "children")), o]);
                  r.children = r.children.map(e => pf(e) ? {
                    type: "JSXText",
                    value: " ",
                    raw: " "
                  } : e);
                  const a = r.children.filter(cf).length > 0,
                    i = r.children.filter(e => "JSXExpressionContainer" === e.type).length > 1,
                    s = "JSXElement" === r.type && r.openingElement.attributes.length > 1;
                  let l = Td(u) || a || s || i;
                  const c = "mdx" === e.getParentNode().rootMarker,
                    p = t.singleQuote ? "{' '}" : '{" "}',
                    d = c ? md([" "]) : Sd(md([p, Ed]), " "),
                    f = r.openingElement && r.openingElement.name && "fbt" === r.openingElement.name.name,
                    h = function (e, t, n, r, u) {
                      const o = e.getValue(),
                        a = [];
                      return e.map((e, t) => {
                        const i = e.getValue();
                        if (ff(i)) {
                          const _e106 = Pf(i);
                          if (hf(i)) {
                            const n = _e106.split(Nf);
                            if ("" === n[0]) {
                              if (a.push(""), n.shift(), /\n/.test(n[0])) {
                                const _e107 = o.children[t + 1];
                                a.push(ch(u, n[1], i, _e107));
                              } else a.push(r);
                              n.shift();
                            }
                            let s;
                            if ("" === od(n) && (n.pop(), s = n.pop()), 0 === n.length) return;
                            if (n.forEach((e, t) => {
                              t % 2 == 1 ? a.push(Dd) : a.push(e);
                            }), void 0 !== s) {
                              if (/\n/.test(s)) {
                                const _e108 = o.children[t + 1];
                                a.push(ch(u, od(a), i, _e108));
                              } else a.push(r);
                            } else {
                              const _e109 = o.children[t + 1];
                              a.push(lh(u, od(a), i, _e109));
                            }
                          } else /\n/.test(_e106) ? _e106.match(/\n/g).length > 1 && (a.push(""), a.push(yd)) : (a.push(""), a.push(r));
                        } else {
                          const r = n(e);
                          a.push(r);
                          const s = o.children[t + 1];
                          if (s && hf(s)) {
                            const _e110 = Pf(s).trim().split(Nf)[0];
                            a.push(lh(u, _e110, i, s));
                          } else a.push(yd);
                        }
                      }, "children"), a;
                    }(e, 0, n, d, f),
                    m = r.children.some(e => hf(e));
                  for (let _e111 = h.length - 2; _e111 >= 0; _e111--) {
                    const _t64 = "" === h[_e111] && "" === h[_e111 + 1],
                      _n19 = h[_e111] === yd && "" === h[_e111 + 1] && h[_e111 + 2] === yd,
                      _r44 = (h[_e111] === Ed || h[_e111] === yd) && "" === h[_e111 + 1] && h[_e111 + 2] === d,
                      _u12 = h[_e111] === d && "" === h[_e111 + 1] && (h[_e111 + 2] === Ed || h[_e111 + 2] === yd),
                      _o22 = h[_e111] === d && "" === h[_e111 + 1] && h[_e111 + 2] === d,
                      _a18 = h[_e111] === Ed && "" === h[_e111 + 1] && h[_e111 + 2] === yd || h[_e111] === yd && "" === h[_e111 + 1] && h[_e111 + 2] === Ed;
                    _n19 && m || _t64 || _r44 || _o22 || _a18 ? h.splice(_e111, 2) : _u12 && h.splice(_e111 + 1, 2);
                  }
                  for (; h.length && (kd(od(h)) || Nd(od(h)));) h.pop();
                  for (; h.length && (kd(h[0]) || Nd(h[0])) && (kd(h[1]) || Nd(h[1]));) h.shift(), h.shift();
                  const g = [];
                  h.forEach((e, t) => {
                    if (e === d) {
                      if (1 === t && "" === h[t - 1]) return 2 === h.length ? void g.push(p) : void g.push(md([p, yd]));
                      if (t === h.length - 1) return void g.push(p);
                      if ("" === h[t - 1] && h[t - 2] === yd) return void g.push(p);
                    }
                    g.push(e), Td(e) && (l = !0);
                  });
                  const D = m ? xd(g) : bd(md(g), {
                    shouldBreak: !0
                  });
                  if (c) return D;
                  const y = bd(md([u, Ad(md([yd, D])), yd, o]));
                  if (l) return y;
                  return Fd([bd(md([u, md(h), o])), y]);
                }(e, t, n), t);
                return function (e, t, n) {
                  const r = e.getParentNode();
                  if (!r) return t;
                  if ({
                    ArrayExpression: !0,
                    JSXAttribute: !0,
                    JSXElement: !0,
                    JSXExpressionContainer: !0,
                    JSXFragment: !0,
                    ExpressionStatement: !0,
                    CallExpression: !0,
                    OptionalCallExpression: !0,
                    ConditionalExpression: !0,
                    JsExpressionRoot: !0
                  }[r.type]) return t;
                  const u = e.match(void 0, e => "ArrowFunctionExpression" === e.type, nf, e => "JSXExpressionContainer" === e.type),
                    o = kc(e, n);
                  return bd(md([o ? "" : Sd("("), Ad(md([Ed, t])), Ed, o ? "" : Sd(")")]), {
                    shouldBreak: u
                  });
                }(e, _r43, t);
              }
            case "JSXOpeningElement":
              {
                const _r45 = e.getValue(),
                  _u13 = _r45.name && _r45.name.comments && _r45.name.comments.length > 0 || _r45.typeParameters && _r45.typeParameters.comments && _r45.typeParameters.comments.length > 0;
                if (_r45.selfClosing && !_r45.attributes.length && !_u13) return md(["<", e.call(n, "name"), e.call(n, "typeParameters"), " />"]);
                if (_r45.attributes && 1 === _r45.attributes.length && _r45.attributes[0].value && Ff(_r45.attributes[0].value) && !_r45.attributes[0].value.value.includes("\n") && !_u13 && (!_r45.attributes[0].comments || !_r45.attributes[0].comments.length)) return bd(md(["<", e.call(n, "name"), e.call(n, "typeParameters"), " ", md(e.map(n, "attributes")), _r45.selfClosing ? " />" : ">"]));
                const _o23 = _r45.attributes.length && Qd(od(_r45.attributes)),
                  _a19 = !_r45.attributes.length && !_u13 || t.jsxBracketSameLine && (!_u13 || _r45.attributes.length) && !_o23,
                  _i8 = _r45.attributes && _r45.attributes.some(e => e.value && Ff(e.value) && e.value.value.includes("\n"));
                return bd(md(["<", e.call(n, "name"), e.call(n, "typeParameters"), md([Ad(md(e.map(e => md([Dd, n(e)]), "attributes"))), _r45.selfClosing ? Dd : _a19 ? ">" : Ed]), _r45.selfClosing ? "/>" : _a19 ? "" : ">"]), {
                  shouldBreak: _i8
                });
              }
            case "JSXClosingElement":
              return md(["</", e.call(n, "name"), ">"]);
            case "JSXOpeningFragment":
            case "JSXClosingFragment":
              {
                const _n20 = u.comments && u.comments.length,
                  _r46 = _n20 && !u.comments.every(Gs.isBlockComment),
                  _o24 = "JSXOpeningFragment" === u.type;
                return md([_o24 ? "<" : "</", Ad(md([_r46 ? yd : _n20 && !_o24 ? " " : "", Di.printDanglingComments(e, t, !0)])), _r46 ? yd : "", ">"]);
              }
            case "JSXText":
              throw new Error("JSXTest should be handled by JSXElement");
            case "JSXEmptyExpression":
              {
                const _n21 = u.comments && !u.comments.every(Gs.isBlockComment);
                return md([Di.printDanglingComments(e, t, !_n21), _n21 ? yd : ""]);
              }
            case "ClassBody":
              return u.comments || 0 !== u.body.length ? md(["{", u.body.length > 0 ? Ad(md([yd, e.call(e => Gf(e, t, n), "body")])) : Di.printDanglingComments(e, t), yd, "}"]) : "{}";
            case "ClassProperty":
            case "TSAbstractClassProperty":
            case "ClassPrivateProperty":
              {
                u.decorators && 0 !== u.decorators.length && i.push(Jf(e, t, n)), u.accessibility && i.push(u.accessibility + " "), u.declare && i.push("declare "), u.static && i.push("static "), ("TSAbstractClassProperty" === u.type || u.abstract) && i.push("abstract "), u.readonly && i.push("readonly ");
                const _r47 = qd(u);
                return _r47 && i.push(_r47), i.push(Hf(e, t, n), Lf(e), Kf(e, t, n)), u.value && i.push(" =", dh(u.key, u.value, e.call(n, "value"), t)), i.push(o), bd(md(i));
              }
            case "ClassDeclaration":
            case "ClassExpression":
              return u.declare && i.push("declare "), i.push(md(sh(e, t, n))), md(i);
            case "TSInterfaceHeritage":
            case "TSExpressionWithTypeArguments":
              return i.push(e.call(n, "expression")), u.typeParameters && i.push(e.call(n, "typeParameters")), md(i);
            case "TemplateElement":
              return gd(Cd, u.value.raw.split(/\r?\n/g));
            case "TemplateLiteral":
              {
                const _r48 = e.getParentNode();
                if (lf(u, _r48)) {
                  const _r49 = function (e, t, n) {
                    const r = e.getNode(),
                      u = r.quasis[0].value.raw.trim().split(/\s*\|\s*/);
                    if (u.length > 1 || u.some(e => 0 !== e.length)) {
                      t.__inJestEach = !0;
                      const o = e.map(n, "expressions");
                      t.__inJestEach = !1;
                      const a = [],
                        i = o.map(e => "${" + _d(e, Object.assign({}, t, {
                          printWidth: 1 / 0,
                          endOfLine: "lf"
                        })).formatted + "}"),
                        s = [{
                          hasLineBreak: !1,
                          cells: []
                        }];
                      for (let _e112 = 1; _e112 < r.quasis.length; _e112++) {
                        const _t65 = s[s.length - 1],
                          _n22 = i[_e112 - 1];
                        _t65.cells.push(_n22), _n22.includes("\n") && (_t65.hasLineBreak = !0), r.quasis[_e112].value.raw.includes("\n") && s.push({
                          hasLineBreak: !1,
                          cells: []
                        });
                      }
                      const l = Math.max(u.length, ...s.map(e => e.cells.length)),
                        c = Array.from({
                          length: l
                        }).fill(0),
                        p = [{
                          cells: u
                        }, ...s.filter(e => 0 !== e.cells.length)];
                      for (const {
                        cells: _e113
                      } of p.filter(e => !e.hasLineBreak)) _e113.forEach((e, t) => {
                        c[t] = Math.max(c[t], ad(e));
                      });
                      return a.push(wd, "`", Ad(md([yd, gd(yd, p.map(e => gd(" | ", e.cells.map((t, n) => e.hasLineBreak ? t : t + " ".repeat(c[n] - ad(t))))))])), yd, "`"), md(a);
                    }
                  }(e, t, n);
                  if (_r49) return _r49;
                }
                let _o25 = e.map(n, "expressions");
                const _a20 = vf(u);
                return _a20 && (_o25 = _o25.map(e => _d(e, Object.assign({}, t, {
                  printWidth: 1 / 0
                })).formatted)), i.push(wd, "`"), e.each(e => {
                  const r = e.getName();
                  if (i.push(n(e)), r < _o25.length) {
                    const {
                        tabWidth: n
                      } = t,
                      s = e.getValue(),
                      l = pd(s.value.raw, n);
                    let c = _o25[r];
                    _a20 || (u.expressions[r].comments && u.expressions[r].comments.length || "MemberExpression" === u.expressions[r].type || "OptionalMemberExpression" === u.expressions[r].type || "ConditionalExpression" === u.expressions[r].type || "SequenceExpression" === u.expressions[r].type || "TSAsExpression" === u.expressions[r].type || tf(u.expressions[r])) && (c = md([Ad(md([Ed, c])), Ed]));
                    const p = 0 === l && s.value.raw.endsWith("\n") ? vd(-1 / 0, c) : Bd(c, l, n);
                    i.push(bd(md(["${", p, wd, "}"])));
                  }
                }, "quasis"), i.push("`"), md(i);
              }
            case "TaggedTemplateExpression":
              return md([e.call(n, "tag"), e.call(n, "typeParameters"), e.call(n, "quasi")]);
            case "Node":
            case "Printable":
            case "SourceLocation":
            case "Position":
            case "Statement":
            case "Function":
            case "Pattern":
            case "Expression":
            case "Declaration":
            case "Specifier":
            case "NamedSpecifier":
            case "Comment":
            case "MemberTypeAnnotation":
            case "Type":
              throw new Error("unprintable type: " + JSON.stringify(u.type));
            case "TypeAnnotation":
            case "TSTypeAnnotation":
              return u.typeAnnotation ? e.call(n, "typeAnnotation") : "";
            case "TSNamedTupleMember":
              return md([e.call(n, "label"), u.optional ? "?" : "", ": ", e.call(n, "elementType")]);
            case "TSTupleType":
            case "TupleTypeAnnotation":
              {
                const _r50 = "TSTupleType" === u.type ? "elementTypes" : "types",
                  _o26 = u[_r50].length > 0 && "TSRestType" === od(u[_r50]).type;
                return bd(md(["[", Ad(md([Ed, Eh(e, t, _r50, n)])), Sd(If(t, "all") && !_o26 ? "," : ""), Di.printDanglingComments(e, t, !0), Ed, "]"]));
              }
            case "ExistsTypeAnnotation":
              return "*";
            case "EmptyTypeAnnotation":
              return "empty";
            case "AnyTypeAnnotation":
              return "any";
            case "MixedTypeAnnotation":
              return "mixed";
            case "ArrayTypeAnnotation":
              return md([e.call(n, "elementType"), "[]"]);
            case "BooleanTypeAnnotation":
              return "boolean";
            case "BooleanLiteralTypeAnnotation":
              return "" + u.value;
            case "DeclareClass":
              return rh(e, sh(e, t, n));
            case "TSDeclareFunction":
              return md([u.declare ? "declare " : "", eh(e, n, t), o]);
            case "DeclareFunction":
              return rh(e, ["function ", e.call(n, "id"), u.predicate ? " " : "", e.call(n, "predicate"), o]);
            case "DeclareModule":
              return rh(e, ["module ", e.call(n, "id"), " ", e.call(n, "body")]);
            case "DeclareModuleExports":
              return rh(e, ["module.exports", ": ", e.call(n, "typeAnnotation"), o]);
            case "DeclareVariable":
              return rh(e, ["var ", e.call(n, "id"), o]);
            case "DeclareExportAllDeclaration":
              return md(["declare export *", Wf(e, t, n)]);
            case "DeclareOpaqueType":
            case "OpaqueType":
              return i.push("opaque type ", e.call(n, "id"), e.call(n, "typeParameters")), u.supertype && i.push(": ", e.call(n, "supertype")), u.impltype && i.push(" = ", e.call(n, "impltype")), i.push(o), "DeclareOpaqueType" === u.type ? rh(e, i) : md(i);
            case "EnumDeclaration":
              return md(["enum ", e.call(n, "id"), " ", e.call(n, "body")]);
            case "EnumBooleanBody":
            case "EnumNumberBody":
            case "EnumStringBody":
            case "EnumSymbolBody":
              if ("EnumSymbolBody" === u.type || u.explicitType) {
                let _e114 = null;
                switch (u.type) {
                  case "EnumBooleanBody":
                    _e114 = "boolean";
                    break;
                  case "EnumNumberBody":
                    _e114 = "number";
                    break;
                  case "EnumStringBody":
                    _e114 = "string";
                    break;
                  case "EnumSymbolBody":
                    _e114 = "symbol";
                }
                i.push("of ", _e114, " ");
              }
              return 0 === u.members.length ? i.push(bd(md(["{", Di.printDanglingComments(e, t), Ed, "}"]))) : i.push(bd(md(["{", Ad(md([yd, Eh(e, t, "members", n), If(t) ? "," : ""])), Di.printDanglingComments(e, t, !0), yd, "}"]))), md(i);
            case "EnumBooleanMember":
            case "EnumNumberMember":
            case "EnumStringMember":
              return md([e.call(n, "id"), " = ", "object" == typeof u.init ? e.call(n, "init") : String(u.init)]);
            case "EnumDefaultedMember":
              return e.call(n, "id");
            case "FunctionTypeAnnotation":
            case "TSFunctionType":
              {
                const _r51 = e.getParentNode(0),
                  _o27 = e.getParentNode(1),
                  _a21 = e.getParentNode(2);
                let s = "TSFunctionType" === u.type || !(("ObjectTypeProperty" === _r51.type || "ObjectTypeInternalSlot" === _r51.type) && !qd(_r51) && !_r51.optional && t.locStart(_r51) === t.locStart(u) || "ObjectTypeCallProperty" === _r51.type || _a21 && "DeclareFunction" === _a21.type),
                  l = s && ("TypeAnnotation" === _r51.type || "TSTypeAnnotation" === _r51.type);
                const c = l && s && ("TypeAnnotation" === _r51.type || "TSTypeAnnotation" === _r51.type) && "ArrowFunctionExpression" === _o27.type;
                return Cf(_r51, t) && (s = !0, l = !0), c && i.push("("), i.push(Qf(e, n, t, !1, !0)), (u.returnType || u.predicate || u.typeAnnotation) && i.push(s ? " => " : ": ", e.call(n, "returnType"), e.call(n, "predicate"), e.call(n, "typeAnnotation")), c && i.push(")"), bd(md(i));
              }
            case "TSRestType":
              return md(["...", e.call(n, "typeAnnotation")]);
            case "TSOptionalType":
              return md([e.call(n, "typeAnnotation"), "?"]);
            case "FunctionTypeParam":
              return md([e.call(n, "name"), Lf(e), u.name ? ": " : "", e.call(n, "typeAnnotation")]);
            case "GenericTypeAnnotation":
              return md([e.call(n, "id"), e.call(n, "typeParameters")]);
            case "DeclareInterface":
            case "InterfaceDeclaration":
            case "InterfaceTypeAnnotation":
            case "TSInterfaceDeclaration":
              {
                ("DeclareInterface" === u.type || u.declare) && i.push("declare "), "TSInterfaceDeclaration" === u.type && i.push(u.abstract ? "abstract " : "", uh(e, t, n)), i.push("interface");
                const _r52 = [],
                  _o28 = [];
                "InterfaceTypeAnnotation" !== u.type && _r52.push(" ", e.call(n, "id"), e.call(n, "typeParameters"));
                const _a22 = u.typeParameters && !Zd(u.typeParameters);
                if (u.extends && 0 !== u.extends.length && _o28.push(_a22 ? Sd(" ", Dd, {
                  groupId: ah(u.typeParameters)
                }) : Dd, "extends ", (1 === u.extends.length ? ef : Ad)(gd(md([",", Dd]), e.map(n, "extends")))), u.id && Qd(u.id) || u.extends && 0 !== u.extends.length) {
                  const _e115 = md(_o28);
                  _a22 ? i.push(bd(md(_r52.concat(Sd(Ad(_e115), _e115))))) : i.push(bd(Ad(md(_r52.concat(_e115)))));
                } else i.push(..._r52, ..._o28);
                return i.push(" ", e.call(n, "body")), bd(md(i));
              }
            case "ClassImplements":
            case "InterfaceExtends":
              return md([e.call(n, "id"), e.call(n, "typeParameters")]);
            case "TSClassImplements":
              return md([e.call(n, "expression"), e.call(n, "typeParameters")]);
            case "TSIntersectionType":
            case "IntersectionTypeAnnotation":
              {
                const _t66 = e.map(n, "types"),
                  _r53 = [];
                let _o29 = !1;
                for (let _e116 = 0; _e116 < _t66.length; ++_e116) 0 === _e116 ? _r53.push(_t66[_e116]) : Ef(u.types[_e116 - 1]) && Ef(u.types[_e116]) ? _r53.push(md([" & ", _o29 ? Ad(_t66[_e116]) : _t66[_e116]])) : Ef(u.types[_e116 - 1]) || Ef(u.types[_e116]) ? (_e116 > 1 && (_o29 = !0), _r53.push(" & ", _e116 > 1 ? Ad(_t66[_e116]) : _t66[_e116])) : _r53.push(Ad(md([" &", Dd, _t66[_e116]])));
                return bd(md(_r53));
              }
            case "TSUnionType":
            case "UnionTypeAnnotation":
              {
                const _r54 = e.getParentNode(),
                  _o30 = !("TypeParameterInstantiation" === _r54.type || "TSTypeParameterInstantiation" === _r54.type || "GenericTypeAnnotation" === _r54.type || "TSTypeReference" === _r54.type || "TSTypeAssertion" === _r54.type || "TupleTypeAnnotation" === _r54.type || "TSTupleType" === _r54.type || "FunctionTypeParam" === _r54.type && !_r54.name || ("TypeAlias" === _r54.type || "VariableDeclarator" === _r54.type || "TSTypeAliasDeclaration" === _r54.type) && Gd(t.originalText, u, t)),
                  _a23 = Dh(u),
                  _i9 = e.map(e => {
                    let r = e.call(n);
                    return _a23 || (r = vd(2, r)), Di.printComments(e, () => r, t);
                  }, "types");
                if (_a23) return gd(" | ", _i9);
                const s = _o30 && !Gd(t.originalText, u, t),
                  l = md([Sd(md([s ? Dd : "", "| "])), gd(md([Dd, "| "]), _i9)]);
                return kc(e, t) ? bd(md([Ad(l), Ed])) : "TupleTypeAnnotation" === _r54.type && _r54.types.length > 1 || "TSTupleType" === _r54.type && _r54.elementTypes.length > 1 ? bd(md([Ad(md([Sd(md(["(", Ed])), l])), Ed, Sd(")")])) : bd(_o30 ? Ad(l) : l);
              }
            case "NullableTypeAnnotation":
              return md(["?", e.call(n, "typeAnnotation")]);
            case "TSNullKeyword":
            case "NullLiteralTypeAnnotation":
              return "null";
            case "ThisTypeAnnotation":
              return "this";
            case "NumberTypeAnnotation":
              return "number";
            case "SymbolTypeAnnotation":
              return "symbol";
            case "ObjectTypeCallProperty":
              return u.static && i.push("static "), i.push(e.call(n, "value")), md(i);
            case "ObjectTypeIndexer":
              {
                const _t67 = qd(u);
                return md([_t67 || "", "[", e.call(n, "id"), u.id ? ": " : "", e.call(n, "key"), "]: ", e.call(n, "value")]);
              }
            case "ObjectTypeProperty":
              {
                const _r55 = qd(u);
                let _o31 = "";
                return u.proto ? _o31 = "proto " : u.static && (_o31 = "static "), md([_o31, sf(u) ? u.kind + " " : "", _r55 || "", Hf(e, t, n), Lf(e), af(u, t) ? "" : ": ", e.call(n, "value")]);
              }
            case "QualifiedTypeIdentifier":
              return md([e.call(n, "qualification"), ".", e.call(n, "id")]);
            case "StringLiteralTypeAnnotation":
              return mh(u, t);
            case "NumberLiteralTypeAnnotation":
              return Xa.strictEqual(typeof u.value, "number"), null != u.extra ? sd(u.extra.raw) : sd(u.raw);
            case "StringTypeAnnotation":
              return "string";
            case "DeclareTypeAlias":
            case "TypeAlias":
              {
                ("DeclareTypeAlias" === u.type || u.declare) && i.push("declare ");
                const _r56 = dh(u.id, u.right, e.call(n, "right"), t);
                return i.push("type ", e.call(n, "id"), e.call(n, "typeParameters"), " =", _r56, o), bd(md(i));
              }
            case "TypeCastExpression":
              return md(["(", e.call(n, "expression"), Kf(e, t, n), ")"]);
            case "TypeParameterDeclaration":
            case "TypeParameterInstantiation":
              {
                const _r57 = e.getValue(),
                  _u14 = t.originalText.slice(0, t.locStart(_r57)).lastIndexOf("/*");
                return _u14 >= 0 && t.originalText.slice(_u14).match(/^\/\*\s*::/) ? md(["/*:: ", ih(e, t, n, "params"), " */"]) : ih(e, t, n, "params");
              }
            case "TSTypeParameterDeclaration":
            case "TSTypeParameterInstantiation":
              return ih(e, t, n, "params");
            case "TSTypeParameter":
            case "TypeParameter":
              {
                const _r58 = e.getParentNode();
                if ("TSMappedType" === _r58.type) return i.push("[", e.call(n, "name")), u.constraint && i.push(" in ", e.call(n, "constraint")), i.push("]"), md(i);
                const _o32 = qd(u);
                _o32 && i.push(_o32), i.push(e.call(n, "name")), u.bound && (i.push(": "), i.push(e.call(n, "bound"))), u.constraint && i.push(" extends ", e.call(n, "constraint")), u.default && i.push(" = ", e.call(n, "default"));
                const _a24 = e.getNode(2);
                return _r58.params && 1 === _r58.params.length && Tf(t) && !u.constraint && "ArrowFunctionExpression" === _a24.type && i.push(","), md(i);
              }
            case "TypeofTypeAnnotation":
              return md(["typeof ", e.call(n, "argument")]);
            case "VoidTypeAnnotation":
              return "void";
            case "InferredPredicate":
              return "%checks";
            case "DeclaredPredicate":
              return md(["%checks(", e.call(n, "value"), ")"]);
            case "TSAbstractKeyword":
              return "abstract";
            case "TSAnyKeyword":
              return "any";
            case "TSAsyncKeyword":
              return "async";
            case "TSBooleanKeyword":
              return "boolean";
            case "TSBigIntKeyword":
              return "bigint";
            case "TSConstKeyword":
              return "const";
            case "TSDeclareKeyword":
              return "declare";
            case "TSExportKeyword":
              return "export";
            case "TSNeverKeyword":
              return "never";
            case "TSNumberKeyword":
              return "number";
            case "TSObjectKeyword":
              return "object";
            case "TSProtectedKeyword":
              return "protected";
            case "TSPrivateKeyword":
              return "private";
            case "TSPublicKeyword":
              return "public";
            case "TSReadonlyKeyword":
              return "readonly";
            case "TSSymbolKeyword":
              return "symbol";
            case "TSStaticKeyword":
              return "static";
            case "TSStringKeyword":
              return "string";
            case "TSUndefinedKeyword":
              return "undefined";
            case "TSUnknownKeyword":
              return "unknown";
            case "TSVoidKeyword":
              return "void";
            case "TSAsExpression":
              return md([e.call(n, "expression"), " as ", e.call(n, "typeAnnotation")]);
            case "TSArrayType":
              return md([e.call(n, "elementType"), "[]"]);
            case "TSPropertySignature":
              return u.export && i.push("export "), u.accessibility && i.push(u.accessibility + " "), u.static && i.push("static "), u.readonly && i.push("readonly "), i.push(Hf(e, t, n), Lf(e)), u.typeAnnotation && (i.push(": "), i.push(e.call(n, "typeAnnotation"))), u.initializer && i.push(" = ", e.call(n, "initializer")), md(i);
            case "TSParameterProperty":
              return u.accessibility && i.push(u.accessibility + " "), u.export && i.push("export "), u.static && i.push("static "), u.readonly && i.push("readonly "), i.push(e.call(n, "parameter")), md(i);
            case "TSTypeReference":
              return md([e.call(n, "typeName"), ih(e, t, n, "typeParameters")]);
            case "TSTypeQuery":
              return md(["typeof ", e.call(n, "exprName")]);
            case "TSIndexSignature":
              {
                const _r59 = e.getParentNode(),
                  _a25 = u.parameters.length > 1 ? Sd(If(t) ? "," : "") : "",
                  _i10 = bd(md([Ad(md([Ed, gd(md([", ", Ed]), e.map(n, "parameters"))])), _a25, Ed]));
                return md([u.export ? "export " : "", u.accessibility ? md([u.accessibility, " "]) : "", u.static ? "static " : "", u.readonly ? "readonly " : "", "[", u.parameters ? _i10 : "", u.typeAnnotation ? "]: " : "]", u.typeAnnotation ? e.call(n, "typeAnnotation") : "", "ClassBody" === _r59.type ? o : ""]);
              }
            case "TSTypePredicate":
              return md([u.asserts ? "asserts " : "", e.call(n, "parameterName"), u.typeAnnotation ? md([" is ", e.call(n, "typeAnnotation")]) : ""]);
            case "TSNonNullExpression":
              return md([e.call(n, "expression"), "!"]);
            case "TSThisType":
              return "this";
            case "TSImportType":
              return md([u.isTypeOf ? "typeof " : "", "import(", e.call(n, u.parameter ? "parameter" : "argument"), ")", u.qualifier ? md([".", e.call(n, "qualifier")]) : "", ih(e, t, n, "typeParameters")]);
            case "TSLiteralType":
              return e.call(n, "literal");
            case "TSIndexedAccessType":
              return md([e.call(n, "objectType"), "[", e.call(n, "indexType"), "]"]);
            case "TSConstructSignatureDeclaration":
            case "TSCallSignatureDeclaration":
            case "TSConstructorType":
              if ("TSCallSignatureDeclaration" !== u.type && i.push("new "), i.push(bd(Qf(e, n, t, !1, !0))), u.returnType || u.typeAnnotation) {
                const _t68 = "TSConstructorType" === u.type;
                i.push(_t68 ? " => " : ": ", e.call(n, "returnType"), e.call(n, "typeAnnotation"));
              }
              return md(i);
            case "TSTypeOperator":
              return md([u.operator, " ", e.call(n, "typeAnnotation")]);
            case "TSMappedType":
              {
                const _r60 = ud(t.originalText, t.locStart(u), t.locEnd(u));
                return bd(md(["{", Ad(md([t.bracketSpacing ? Dd : Ed, u.readonly ? md([$d(u.readonly, "readonly"), " "]) : "", uh(e, t, n), e.call(n, "typeParameter"), u.optional ? $d(u.optional, "?") : "", u.typeAnnotation ? ": " : "", e.call(n, "typeAnnotation"), Sd(o, "")])), Di.printDanglingComments(e, t, !0), t.bracketSpacing ? Dd : Ed, "}"]), {
                  shouldBreak: _r60
                });
              }
            case "TSMethodSignature":
              return i.push(u.accessibility ? md([u.accessibility, " "]) : "", u.export ? "export " : "", u.static ? "static " : "", u.readonly ? "readonly " : "", u.computed ? "[" : "", e.call(n, "key"), u.computed ? "]" : "", Lf(e), Qf(e, n, t, !1, !0)), (u.returnType || u.typeAnnotation) && i.push(": ", e.call(n, "returnType"), e.call(n, "typeAnnotation")), bd(md(i));
            case "TSNamespaceExportDeclaration":
              return i.push("export as namespace ", e.call(n, "id")), t.semi && i.push(";"), bd(md(i));
            case "TSEnumDeclaration":
              return u.declare && i.push("declare "), u.modifiers && i.push(uh(e, t, n)), u.const && i.push("const "), i.push("enum ", e.call(n, "id"), " "), 0 === u.members.length ? i.push(bd(md(["{", Di.printDanglingComments(e, t), Ed, "}"]))) : i.push(bd(md(["{", Ad(md([yd, Eh(e, t, "members", n), If(t, "es5") ? "," : ""])), Di.printDanglingComments(e, t, !0), yd, "}"]))), md(i);
            case "TSEnumMember":
              return i.push(e.call(n, "id")), u.initializer && i.push(" = ", e.call(n, "initializer")), md(i);
            case "TSImportEqualsDeclaration":
              return u.isExport && i.push("export "), i.push("import ", e.call(n, "id"), " = ", e.call(n, "moduleReference")), t.semi && i.push(";"), bd(md(i));
            case "TSExternalModuleReference":
              return md(["require(", e.call(n, "expression"), ")"]);
            case "TSModuleDeclaration":
              {
                const _r61 = e.getParentNode(),
                  _a26 = ff(u.id),
                  s = "TSModuleDeclaration" === _r61.type,
                  l = u.body && "TSModuleDeclaration" === u.body.type;
                if (s) i.push(".");else {
                  u.declare && i.push("declare "), i.push(uh(e, t, n));
                  const _r62 = t.originalText.slice(t.locStart(u), t.locStart(u.id));
                  "Identifier" === u.id.type && "global" === u.id.name && !/namespace|module/.test(_r62) || i.push(_a26 || /(^|\s)module(\s|$)/.test(_r62) ? "module " : "namespace ");
                }
                return i.push(e.call(n, "id")), l ? i.push(e.call(n, "body")) : u.body ? i.push(" ", bd(e.call(n, "body"))) : i.push(o), md(i);
              }
            case "PrivateName":
              return md(["#", e.call(n, "id")]);
            case "TSPrivateIdentifier":
              return u.escapedText;
            case "TSConditionalType":
              return td(e, t, n, {
                beforeParts: () => [e.call(n, "checkType"), " ", "extends", " ", e.call(n, "extendsType")],
                afterParts: () => [],
                shouldCheckJsx: !1,
                conditionalNodeType: "TSConditionalType",
                consequentNodePropertyName: "trueType",
                alternateNodePropertyName: "falseType",
                testNodePropertyNames: ["checkType", "extendsType"]
              });
            case "TSInferType":
              return md(["infer", " ", e.call(n, "typeParameter")]);
            case "InterpreterDirective":
              return i.push("#!", u.value, yd), fd(t.originalText, u, t.locEnd) && i.push(yd), md(i);
            case "NGRoot":
              return md([].concat(e.call(n, "node"), u.node.comments && 0 !== u.node.comments.length ? md([" //", u.node.comments[0].value.trimEnd()]) : []));
            case "NGChainedExpression":
              return bd(gd(md([";", Dd]), e.map(e => Yd(e) ? n(e) : md(["(", n(e), ")"]), "expressions")));
            case "NGEmptyExpression":
              return "";
            case "NGQuotedExpression":
              return md([u.prefix, ": ", u.value.trim()]);
            case "NGMicrosyntax":
              return md(e.map((e, t) => md([0 === t ? "" : Df(e.getValue(), t, u) ? " " : md([";", Dd]), n(e)]), "body"));
            case "NGMicrosyntaxKey":
              return /^[$_a-z][\w$]*(-[$_a-z][\w$])*$/i.test(u.name) ? u.name : JSON.stringify(u.name);
            case "NGMicrosyntaxExpression":
              return md([e.call(n, "expression"), null === u.alias ? "" : md([" as ", e.call(n, "alias")])]);
            case "NGMicrosyntaxKeyedExpression":
              {
                const _t69 = e.getName(),
                  _r63 = e.getParentNode(),
                  _o33 = Df(u, _t69, _r63) || (1 === _t69 && ("then" === u.key.name || "else" === u.key.name) || 2 === _t69 && "else" === u.key.name && "NGMicrosyntaxKeyedExpression" === _r63.body[_t69 - 1].type && "then" === _r63.body[_t69 - 1].key.name) && "NGMicrosyntaxExpression" === _r63.body[0].type;
                return md([e.call(n, "key"), _o33 ? " " : ": ", e.call(n, "expression")]);
              }
            case "NGMicrosyntaxLet":
              return md(["let ", e.call(n, "key"), null === u.value ? "" : md([" = ", e.call(n, "value")])]);
            case "NGMicrosyntaxAs":
              return md([e.call(n, "key"), " as ", e.call(n, "alias")]);
            case "PipelineBareFunction":
              return e.call(n, "callee");
            case "PipelineTopicExpression":
              return e.call(n, "expression");
            case "PipelinePrimaryTopicReference":
              return i.push("#"), md(i);
            case "ArgumentPlaceholder":
              return "?";
            case "TSJSDocAllType":
              return "*";
            case "TSJSDocUnknownType":
              return "?";
            case "TSJSDocNullableType":
              return md(["?", e.call(n, "typeAnnotation")]);
            case "TSJSDocNonNullableType":
              return md(["!", e.call(n, "typeAnnotation")]);
            case "TSJSDocFunctionType":
              return md(["function(", "): ", e.call(n, "typeAnnotation")]);
            default:
              throw new Error("unknown type: " + JSON.stringify(u.type));
          }
        }(e, t, n, r);
        if (!u || Nd(a)) return a;
        const i = Wd(e),
          s = [];
        if ("ClassMethod" === u.type || "ClassPrivateMethod" === u.type || "ClassProperty" === u.type || "TSAbstractClassProperty" === u.type || "ClassPrivateProperty" === u.type || "MethodDefinition" === u.type || "TSAbstractMethodDefinition" === u.type || "TSDeclareMethod" === u.type) ;else if (u.decorators && u.decorators.length > 0 && !(i && t.locStart(i, {
          ignoreDecorators: !0
        }) > t.locStart(u.decorators[0]))) {
          const _r64 = "ClassExpression" === u.type || "ClassDeclaration" === u.type || Xd(u, t) ? yd : Dd;
          e.each(e => {
            let t = e.getValue();
            t = t.expression ? t.expression : t.callee, s.push(n(e), _r64);
          }, "decorators"), i && s.unshift(yd);
        } else uf(u) && u.declaration && u.declaration.decorators && u.declaration.decorators.length > 0 && t.locStart(u, {
          ignoreDecorators: !0
        }) > t.locStart(u.declaration.decorators[0]) ? e.each(e => {
          const t = "Decorator" === e.getValue().type ? "" : "@";
          s.push(t, n(e), yd);
        }, "declaration", "decorators") : o = kc(e, t);
        const l = [];
        if (o && l.unshift("("), l.push(a), o) {
          const _t70 = e.getValue();
          Jd(_t70) && (l.push(" /*"), l.push(_t70.trailingComments[0].value.trimStart()), l.push("*/"), _t70.trailingComments[0].printed = !0), l.push(")");
        }
        return s.length > 0 ? bd(md(s.concat(l))) : md(l);
      },
      embed: El,
      insertPragma: Id,
      massageAstNode: Cl,
      hasPrettierIgnore: Kd,
      willPrintOwnComments: bh,
      canAttachComment: function (e) {
        return e.type && "CommentBlock" !== e.type && "CommentLine" !== e.type && "Line" !== e.type && "Block" !== e.type && "EmptyStatement" !== e.type && "TemplateElement" !== e.type && "Import" !== e.type;
      },
      printComment: function (e, t) {
        const n = e.getValue();
        switch (n.type) {
          case "CommentBlock":
          case "Block":
            {
              if (function (e) {
                const t = "*".concat(e.value, "*").split("\n");
                return t.length > 1 && t.every(e => "*" === e.trim()[0]);
              }(n)) {
                const _e117 = function (e) {
                  const t = e.value.split("\n");
                  return md(["/*", gd(yd, t.map((e, n) => 0 === n ? e.trimEnd() : " " + (n < t.length - 1 ? e.trim() : e.trimStart()))), "*/"]);
                }(n);
                return n.trailing && !rd(t.originalText, t.locStart(n), {
                  backwards: !0
                }) ? md([yd, _e117]) : _e117;
              }
              const _e118 = t.locEnd(n),
                r = "*-/" === t.originalText.slice(_e118 - 3, _e118);
              return "/*" + n.value + (r ? "*-/" : "*/");
            }
          case "CommentLine":
          case "Line":
            return t.originalText.slice(t.locStart(n), t.locEnd(n)).trimEnd();
          default:
            throw new Error("Not a comment: " + JSON.stringify(n));
        }
      },
      isBlockComment: Gs.isBlockComment,
      handleComments: {
        ownLine: Gs.handleOwnLineComment,
        endOfLine: Gs.handleEndOfLineComment,
        remaining: Gs.handleRemainingComment
      },
      getGapRegex: Gs.getGapRegex,
      getCommentChildNodes: Gs.getCommentChildNodes
    };
    const {
      concat: vh,
      hardline: Fh,
      indent: xh,
      join: Sh
    } = dn.builders;
    var wh = {
      preprocess: Ic,
      print: function (e, t, n) {
        const r = e.getValue();
        switch (r.type) {
          case "JsonRoot":
            return vh([e.call(n, "node"), Fh]);
          case "ArrayExpression":
            return 0 === r.elements.length ? "[]" : vh(["[", xh(vh([Fh, Sh(vh([",", Fh]), e.map(n, "elements"))])), Fh, "]"]);
          case "ObjectExpression":
            return 0 === r.properties.length ? "{}" : vh(["{", xh(vh([Fh, Sh(vh([",", Fh]), e.map(n, "properties"))])), Fh, "}"]);
          case "ObjectProperty":
            return vh([e.call(n, "key"), ": ", e.call(n, "value")]);
          case "UnaryExpression":
            return vh(["+" === r.operator ? "" : r.operator, e.call(n, "argument")]);
          case "NullLiteral":
            return "null";
          case "BooleanLiteral":
            return r.value ? "true" : "false";
          case "StringLiteral":
          case "NumericLiteral":
            return JSON.stringify(r.value);
          case "Identifier":
            return JSON.stringify(r.name);
          default:
            throw new Error("unknown type: " + JSON.stringify(r.type));
        }
      },
      massageAstNode: function (e, t) {
        return delete t.start, delete t.end, delete t.extra, delete t.loc, delete t.comments, delete t.errors, delete t.range, "Identifier" === e.type ? {
          type: "StringLiteral",
          value: e.name
        } : "UnaryExpression" === e.type && "+" === e.operator ? t.argument : void 0;
      }
    };
    var Bh = {
      bracketSpacing: {
        since: "0.0.0",
        category: "Common",
        type: "boolean",
        default: !0,
        description: "Print spaces between brackets.",
        oppositeDescription: "Do not print spaces between brackets."
      },
      singleQuote: {
        since: "0.0.0",
        category: "Common",
        type: "boolean",
        default: !1,
        description: "Use single quotes instead of double quotes."
      },
      proseWrap: {
        since: "1.8.2",
        category: "Common",
        type: "choice",
        default: [{
          since: "1.8.2",
          value: !0
        }, {
          since: "1.9.0",
          value: "preserve"
        }],
        description: "How to wrap prose.",
        choices: [{
          since: "1.9.0",
          value: "always",
          description: "Wrap prose if it exceeds the print width."
        }, {
          since: "1.9.0",
          value: "never",
          description: "Do not wrap prose."
        }, {
          since: "1.9.0",
          value: "preserve",
          description: "Wrap prose as-is."
        }]
      }
    };
    var Th = {
        arrowParens: {
          since: "1.9.0",
          category: "JavaScript",
          type: "choice",
          default: [{
            since: "1.9.0",
            value: "avoid"
          }, {
            since: "2.0.0",
            value: "always"
          }],
          description: "Include parentheses around a sole arrow function parameter.",
          choices: [{
            value: "always",
            description: "Always include parens. Example: `(x) => x`"
          }, {
            value: "avoid",
            description: "Omit parens when possible. Example: `x => x`"
          }]
        },
        bracketSpacing: Bh.bracketSpacing,
        jsxBracketSameLine: {
          since: "0.17.0",
          category: "JavaScript",
          type: "boolean",
          default: !1,
          description: "Put > on the last line instead of at a new line."
        },
        semi: {
          since: "1.0.0",
          category: "JavaScript",
          type: "boolean",
          default: !0,
          description: "Print semicolons.",
          oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them."
        },
        singleQuote: Bh.singleQuote,
        jsxSingleQuote: {
          since: "1.15.0",
          category: "JavaScript",
          type: "boolean",
          default: !1,
          description: "Use single quotes in JSX."
        },
        quoteProps: {
          since: "1.17.0",
          category: "JavaScript",
          type: "choice",
          default: "as-needed",
          description: "Change when properties in objects are quoted.",
          choices: [{
            value: "as-needed",
            description: "Only add quotes around object properties where required."
          }, {
            value: "consistent",
            description: "If at least one property in an object requires quotes, quote all properties."
          }, {
            value: "preserve",
            description: "Respect the input use of quotes in object properties."
          }]
        },
        trailingComma: {
          since: "0.0.0",
          category: "JavaScript",
          type: "choice",
          default: [{
            since: "0.0.0",
            value: !1
          }, {
            since: "0.19.0",
            value: "none"
          }, {
            since: "2.0.0",
            value: "es5"
          }],
          description: "Print trailing commas wherever possible when multi-line.",
          choices: [{
            value: "es5",
            description: "Trailing commas where valid in ES5 (objects, arrays, etc.)"
          }, {
            value: "none",
            description: "No trailing commas."
          }, {
            value: "all",
            description: "Trailing commas wherever possible (including function arguments)."
          }]
        }
      },
      kh = ["js", "node"],
      Nh = [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".jsb", ".jscad", ".jsfl", ".jsm", ".jss", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"],
      Oh = ["Jakefile"],
      Ph = ["chakra", "d8", "gjs", "js", "node", "qjs", "rhino", "v8", "v8-shell"],
      _h = {
        name: "JavaScript",
        type: "programming",
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "text/javascript",
        color: "#f1e05a",
        aliases: kh,
        extensions: Nh,
        filenames: Oh,
        interpreters: Ph,
        languageId: 183
      },
      Ih = Object.freeze({
        __proto__: null,
        name: "JavaScript",
        type: "programming",
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "text/javascript",
        color: "#f1e05a",
        aliases: kh,
        extensions: Nh,
        filenames: Oh,
        interpreters: Ph,
        languageId: 183,
        default: _h
      }),
      jh = [".jsx"],
      Mh = {
        name: "JSX",
        type: "programming",
        group: "JavaScript",
        extensions: jh,
        tmScope: "source.js.jsx",
        aceMode: "javascript",
        codemirrorMode: "jsx",
        codemirrorMimeType: "text/jsx",
        languageId: 178
      },
      Lh = Object.freeze({
        __proto__: null,
        name: "JSX",
        type: "programming",
        group: "JavaScript",
        extensions: jh,
        tmScope: "source.js.jsx",
        aceMode: "javascript",
        codemirrorMode: "jsx",
        codemirrorMimeType: "text/jsx",
        languageId: 178,
        default: Mh
      }),
      Rh = ["ts"],
      qh = ["deno", "ts-node"],
      Vh = [".ts"],
      Wh = {
        name: "TypeScript",
        type: "programming",
        color: "#2b7489",
        aliases: Rh,
        interpreters: qh,
        extensions: Vh,
        tmScope: "source.ts",
        aceMode: "typescript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/typescript",
        languageId: 378
      },
      $h = Object.freeze({
        __proto__: null,
        name: "TypeScript",
        type: "programming",
        color: "#2b7489",
        aliases: Rh,
        interpreters: qh,
        extensions: Vh,
        tmScope: "source.ts",
        aceMode: "typescript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/typescript",
        languageId: 378,
        default: Wh
      }),
      Uh = [".tsx"],
      zh = {
        name: "TSX",
        type: "programming",
        group: "TypeScript",
        extensions: Uh,
        tmScope: "source.tsx",
        aceMode: "javascript",
        codemirrorMode: "jsx",
        codemirrorMimeType: "text/jsx",
        languageId: 94901924
      },
      Jh = Object.freeze({
        __proto__: null,
        name: "TSX",
        type: "programming",
        group: "TypeScript",
        extensions: Uh,
        tmScope: "source.tsx",
        aceMode: "javascript",
        codemirrorMode: "jsx",
        codemirrorMimeType: "text/jsx",
        languageId: 94901924,
        default: zh
      }),
      Gh = [".json", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"],
      Hh = [".arcconfig", ".htmlhintrc", ".tern-config", ".tern-project", ".watchmanconfig", "composer.lock", "mcmod.info"],
      Xh = {
        name: "JSON",
        type: "data",
        tmScope: "source.json",
        aceMode: "json",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/json",
        searchable: false,
        extensions: Gh,
        filenames: Hh,
        languageId: 174
      },
      Yh = Object.freeze({
        __proto__: null,
        name: "JSON",
        type: "data",
        tmScope: "source.json",
        aceMode: "json",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/json",
        searchable: false,
        extensions: Gh,
        filenames: Hh,
        languageId: 174,
        default: Xh
      }),
      Kh = ["jsonc"],
      Qh = [".jsonc", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"],
      Zh = [".babelrc", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "jsconfig.json", "language-configuration.json", "tsconfig.json"],
      em = {
        name: "JSON with Comments",
        type: "data",
        group: "JSON",
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "text/javascript",
        aliases: Kh,
        extensions: Qh,
        filenames: Zh,
        languageId: 423
      },
      tm = Object.freeze({
        __proto__: null,
        name: "JSON with Comments",
        type: "data",
        group: "JSON",
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "text/javascript",
        aliases: Kh,
        extensions: Qh,
        filenames: Zh,
        languageId: 423,
        default: em
      }),
      nm = [".json5"],
      rm = {
        name: "JSON5",
        type: "data",
        extensions: nm,
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/json",
        languageId: 175
      },
      um = Object.freeze({
        __proto__: null,
        name: "JSON5",
        type: "data",
        extensions: nm,
        tmScope: "source.js",
        aceMode: "javascript",
        codemirrorMode: "javascript",
        codemirrorMimeType: "application/json",
        languageId: 175,
        default: rm
      }),
      om = Ue(Ih),
      am = Ue(Lh),
      im = Ue($h),
      sm = Ue(Jh),
      lm = Ue(Yh),
      cm = Ue(tm),
      pm = Ue(um);
    var dm = {
      languages: [As(om, e => ({
        since: "0.0.0",
        parsers: ["babel", "flow"],
        vscodeLanguageIds: ["javascript", "mongo"],
        interpreters: e.interpreters.concat(["nodejs"])
      })), As(om, () => ({
        name: "Flow",
        since: "0.0.0",
        parsers: ["babel", "flow"],
        vscodeLanguageIds: ["javascript"],
        aliases: [],
        filenames: [],
        extensions: [".js.flow"]
      })), As(am, () => ({
        since: "0.0.0",
        parsers: ["babel", "flow"],
        vscodeLanguageIds: ["javascriptreact"]
      })), As(im, () => ({
        since: "1.4.0",
        parsers: ["typescript", "babel-ts"],
        vscodeLanguageIds: ["typescript"]
      })), As(sm, () => ({
        since: "1.4.0",
        parsers: ["typescript", "babel-ts"],
        vscodeLanguageIds: ["typescriptreact"]
      })), As(lm, () => ({
        name: "JSON.stringify",
        since: "1.13.0",
        parsers: ["json-stringify"],
        vscodeLanguageIds: ["json"],
        extensions: [],
        filenames: ["package.json", "package-lock.json", "composer.json"]
      })), As(lm, e => ({
        since: "1.5.0",
        parsers: ["json"],
        vscodeLanguageIds: ["json"],
        filenames: e.filenames.concat([".prettierrc"])
      })), As(cm, e => ({
        since: "1.5.0",
        parsers: ["json"],
        vscodeLanguageIds: ["jsonc"],
        filenames: e.filenames.concat([".eslintrc"])
      })), As(pm, () => ({
        since: "1.13.0",
        parsers: ["json5"],
        vscodeLanguageIds: ["json5"]
      }))],
      options: Th,
      printers: {
        estree: Ah,
        "estree-json": wh
      },
      parsers: {
        get babel() {
          return {}.parsers.babel;
        },
        get "babel-flow"() {
          return {}.parsers["babel-flow"];
        },
        get "babel-ts"() {
          return {}.parsers["babel-ts"];
        },
        get json() {
          return {}.parsers.json;
        },
        get json5() {
          return {}.parsers.json5;
        },
        get "json-stringify"() {
          return {}.parsers["json-stringify"];
        },
        get __js_expression() {
          return {}.parsers.__js_expression;
        },
        get __vue_expression() {
          return {}.parsers.__vue_expression;
        },
        get __vue_event_binding() {
          return {}.parsers.__vue_event_binding;
        },
        get flow() {
          return {}.parsers.flow;
        },
        get typescript() {
          return {}.parsers.typescript;
        },
        get __ng_action() {
          return {}.parsers.__ng_action;
        },
        get __ng_binding() {
          return {}.parsers.__ng_binding;
        },
        get __ng_interpolation() {
          return {}.parsers.__ng_interpolation;
        },
        get __ng_directive() {
          return {}.parsers.__ng_directive;
        }
      }
    };
    const {
      isFrontMatterNode: fm
    } = Lt;
    var hm = function (e, t, n) {
      if (["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"].forEach(e => {
        delete t[e];
      }), fm(e) && "yaml" === e.lang && delete t.value, "css-comment" === e.type && "css-root" === n.type && 0 !== n.nodes.length) {
        if ((n.nodes[0] === e || fm(n.nodes[0]) && n.nodes[1] === e) && (delete t.text, /^\*\s*@(format|prettier)\s*$/.test(e.text))) return null;
        if ("css-root" === n.type && he(n.nodes) === e) return null;
      }
      if ("value-root" === e.type && delete t.text, "media-query" !== e.type && "media-query-list" !== e.type && "media-feature-expression" !== e.type || delete t.value, "css-rule" === e.type && delete t.params, "selector-combinator" === e.type && (t.value = t.value.replace(/\s+/g, " ")), "media-feature" === e.type && (t.value = t.value.replace(/ /g, "")), ("value-word" === e.type && (e.isColor && e.isHex || ["initial", "inherit", "unset", "revert"].includes(t.value.replace().toLowerCase())) || "media-feature" === e.type || "selector-root-invalid" === e.type || "selector-pseudo" === e.type) && (t.value = t.value.toLowerCase()), "css-decl" === e.type && (t.prop = t.prop.toLowerCase()), "css-atrule" !== e.type && "css-import" !== e.type || (t.name = t.name.toLowerCase()), "value-number" === e.type && (t.unit = t.unit.toLowerCase()), "media-feature" !== e.type && "media-keyword" !== e.type && "media-type" !== e.type && "media-unknown" !== e.type && "media-url" !== e.type && "media-value" !== e.type && "selector-attribute" !== e.type && "selector-string" !== e.type && "selector-class" !== e.type && "selector-combinator" !== e.type && "value-string" !== e.type || !t.value || (t.value = t.value.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1")), "selector-attribute" === e.type && (t.attribute = t.attribute.trim(), t.namespace && "string" == typeof t.namespace && (t.namespace = t.namespace.trim(), 0 === t.namespace.length && (t.namespace = !0)), t.value && (t.value = t.value.trim().replace(/^["']|["']$/g, ""), delete t.quoted)), "media-value" !== e.type && "media-type" !== e.type && "value-number" !== e.type && "selector-root-invalid" !== e.type && "selector-class" !== e.type && "selector-combinator" !== e.type && "selector-tag" !== e.type || !t.value || (t.value = t.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (e, t, n) => {
        const r = Number(t);
        return isNaN(r) ? e : r + n.toLowerCase();
      })), "selector-tag" === e.type) {
        const _n23 = e.value.toLowerCase();
        ["from", "to"].includes(_n23) && (t.value = _n23);
      }
      "css-atrule" === e.type && "supports" === e.name.toLowerCase() && delete t.value, "selector-unknown" === e.type && delete t.value;
    };
    const {
        builders: {
          hardline: mm,
          concat: gm,
          markAsRoot: Dm
        }
      } = dn,
      ym = {
        "---": "yaml",
        "+++": "toml"
      };
    var Em = {
      parse: function (e) {
        const t = Object.keys(ym).map(fe).join("|"),
          n = e.match(new RegExp("^(".concat(t, ")([^\\n]*)\\n(?:([\\s\\S]*?)\\n)?\\1[^\\n\\S]*(\\n|$)")));
        if (null === n) return {
          frontMatter: null,
          content: e
        };
        const [r, u, o, a] = n;
        let i = ym[u];
        return "toml" !== i && o && o.trim() && (i = o.trim()), {
          frontMatter: {
            type: "front-matter",
            lang: i,
            value: a,
            raw: r.replace(/\n$/, "")
          },
          content: r.replace(/[^\n]/g, " ") + e.slice(r.length)
        };
      },
      print: function (e, t) {
        if ("yaml" === e.lang) {
          const n = e.value.trim(),
            r = n ? t(n, {
              parser: "yaml"
            }, {
              stripTrailingHardline: !0
            }) : "";
          return Dm(gm(["---", mm, r, r ? mm : "", "---"]));
        }
      }
    };
    const {
        builders: {
          hardline: Cm,
          concat: bm
        }
      } = dn,
      {
        print: Am
      } = Em;
    var vm = function (e, t, n) {
      const r = e.getValue();
      if ("front-matter" === r.type) {
        const _e119 = Am(r, n);
        return _e119 ? bm([_e119, Cm]) : "";
      }
    };
    const {
      parse: Fm
    } = Em;
    var xm = {
      hasPragma: function (e) {
        return Nl.hasPragma(Fm(e).content);
      },
      insertPragma: function (e) {
        const {
          frontMatter: t,
          content: n
        } = Fm(e);
        return (t ? t.raw + "\n\n" : "") + Nl.insertPragma(n);
      }
    };
    const Sm = new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
    function wm(e, t) {
      const n = [].concat(t);
      let r,
        u = -1;
      for (; r = e.getParentNode(++u);) if (n.includes(r.type)) return u;
      return -1;
    }
    function Bm(e, t) {
      const n = wm(e, t);
      return -1 === n ? null : e.getParentNode(n);
    }
    function Tm(e) {
      return "value-operator" === e.type && "*" === e.value;
    }
    function km(e) {
      return "value-operator" === e.type && "/" === e.value;
    }
    function Nm(e) {
      return "value-operator" === e.type && "+" === e.value;
    }
    function Om(e) {
      return "value-operator" === e.type && "-" === e.value;
    }
    function Pm(e) {
      return "value-operator" === e.type && "%" === e.value;
    }
    function _m(e) {
      return "value-comma_group" === e.type && e.groups && e.groups[1] && "value-colon" === e.groups[1].type;
    }
    function Im(e) {
      return "value-paren_group" === e.type && e.groups && e.groups[0] && _m(e.groups[0]);
    }
    var jm = {
      getAncestorCounter: wm,
      getAncestorNode: Bm,
      getPropOfDeclNode: function (e) {
        const t = Bm(e, "css-decl");
        return t && t.prop && t.prop.toLowerCase();
      },
      hasSCSSInterpolation: function (e) {
        if (e && e.length) for (let t = e.length - 1; t > 0; t--) if ("word" === e[t].type && "{" === e[t].value && "word" === e[t - 1].type && e[t - 1].value.endsWith("#")) return !0;
        return !1;
      },
      hasStringOrFunction: function (e) {
        if (e && e.length) for (let t = 0; t < e.length; t++) if ("string" === e[t].type || "func" === e[t].type) return !0;
        return !1;
      },
      maybeToLowerCase: function (e) {
        return e.includes("$") || e.includes("@") || e.includes("#") || e.startsWith("%") || e.startsWith("--") || e.startsWith(":--") || e.includes("(") && e.includes(")") ? e : e.toLowerCase();
      },
      insideValueFunctionNode: function (e, t) {
        const n = Bm(e, "value-func");
        return n && n.value && n.value.toLowerCase() === t;
      },
      insideICSSRuleNode: function (e) {
        const t = Bm(e, "css-rule");
        return t && t.raws && t.raws.selector && (t.raws.selector.startsWith(":import") || t.raws.selector.startsWith(":export"));
      },
      insideAtRuleNode: function (e, t) {
        const n = [].concat(t),
          r = Bm(e, "css-atrule");
        return r && n.includes(r.name.toLowerCase());
      },
      insideURLFunctionInImportAtRuleNode: function (e) {
        const t = e.getValue(),
          n = Bm(e, "css-atrule");
        return n && "import" === n.name && "url" === t.groups[0].value && 2 === t.groups.length;
      },
      isKeyframeAtRuleKeywords: function (e, t) {
        const n = Bm(e, "css-atrule");
        return n && n.name && n.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(t.toLowerCase());
      },
      isWideKeywords: function (e) {
        return ["initial", "inherit", "unset", "revert"].includes(e.toLowerCase());
      },
      isSCSS: function (e, t) {
        return "less" === e || "scss" === e ? "scss" === e : /(\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(t);
      },
      isSCSSVariable: function (e) {
        return !(!e || "word" !== e.type || !e.value.startsWith("$"));
      },
      isLastNode: function (e, t) {
        const n = e.getParentNode();
        if (!n) return !1;
        const {
          nodes: r
        } = n;
        return r && r.indexOf(t) === r.length - 1;
      },
      isLessParser: function (e) {
        return "css" === e.parser || "less" === e.parser;
      },
      isSCSSControlDirectiveNode: function (e) {
        return "css-atrule" === e.type && ["if", "else", "for", "each", "while"].includes(e.name);
      },
      isDetachedRulesetDeclarationNode: function (e) {
        return !!e.selector && ("string" == typeof e.selector && /^@.+:.*$/.test(e.selector) || e.selector.value && /^@.+:.*$/.test(e.selector.value));
      },
      isRelationalOperatorNode: function (e) {
        return "value-word" === e.type && ["<", ">", "<=", ">="].includes(e.value);
      },
      isEqualityOperatorNode: function (e) {
        return "value-word" === e.type && ["==", "!="].includes(e.value);
      },
      isMultiplicationNode: Tm,
      isDivisionNode: km,
      isAdditionNode: Nm,
      isSubtractionNode: Om,
      isModuloNode: Pm,
      isMathOperatorNode: function (e) {
        return Tm(e) || km(e) || Nm(e) || Om(e) || Pm(e);
      },
      isEachKeywordNode: function (e) {
        return "value-word" === e.type && "in" === e.value;
      },
      isForKeywordNode: function (e) {
        return "value-word" === e.type && ["from", "through", "end"].includes(e.value);
      },
      isURLFunctionNode: function (e) {
        return "value-func" === e.type && "url" === e.value.toLowerCase();
      },
      isIfElseKeywordNode: function (e) {
        return "value-word" === e.type && ["and", "or", "not"].includes(e.value);
      },
      hasComposesNode: function (e) {
        return e.value && "value-root" === e.value.type && e.value.group && "value-value" === e.value.group.type && "composes" === e.prop.toLowerCase();
      },
      hasParensAroundNode: function (e) {
        return e.value && e.value.group && e.value.group.group && "value-paren_group" === e.value.group.group.type && null !== e.value.group.group.open && null !== e.value.group.group.close;
      },
      hasEmptyRawBefore: function (e) {
        return e.raws && "" === e.raws.before;
      },
      isSCSSNestedPropertyNode: function (e) {
        return !!e.selector && e.selector.replace(/\/\*.*?\*\//, "").replace(/\/\/.*?\n/, "").trim().endsWith(":");
      },
      isDetachedRulesetCallNode: function (e) {
        return e.raws && e.raws.params && /^\(\s*\)$/.test(e.raws.params);
      },
      isTemplatePlaceholderNode: function (e) {
        return e.name.startsWith("prettier-placeholder");
      },
      isTemplatePropNode: function (e) {
        return e.prop.startsWith("@prettier-placeholder");
      },
      isPostcssSimpleVarNode: function (e, t) {
        return "$$" === e.value && "value-func" === e.type && t && "value-word" === t.type && !t.raws.before;
      },
      isKeyValuePairNode: _m,
      isKeyValuePairInParenGroupNode: Im,
      isSCSSMapItemNode: function (e) {
        const t = e.getValue();
        if (0 === t.groups.length) return !1;
        const n = e.getParentNode(1);
        if (!(Im(t) || n && Im(n))) return !1;
        const r = Bm(e, "css-decl");
        return !!(r && r.prop && r.prop.startsWith("$")) || !!Im(n) || "value-func" === n.type;
      },
      isInlineValueCommentNode: function (e) {
        return "value-comment" === e.type && e.inline;
      },
      isHashNode: function (e) {
        return "value-word" === e.type && "#" === e.value;
      },
      isLeftCurlyBraceNode: function (e) {
        return "value-word" === e.type && "{" === e.value;
      },
      isRightCurlyBraceNode: function (e) {
        return "value-word" === e.type && "}" === e.value;
      },
      isWordNode: function (e) {
        return ["value-word", "value-atword"].includes(e.type);
      },
      isColonNode: function (e) {
        return "value-colon" === e.type;
      },
      isMediaAndSupportsKeywords: function (e) {
        return e.value && ["not", "and", "or"].includes(e.value.toLowerCase());
      },
      isColorAdjusterFuncNode: function (e) {
        return "value-func" === e.type && Sm.has(e.value.toLowerCase());
      },
      lastLineHasInlineComment: function (e) {
        return /\/\//.test(e.split(/[\n\r]/).pop());
      },
      stringifyNode: function e(t) {
        if (t.groups) {
          return (t.open && t.open.value ? t.open.value : "") + t.groups.reduce((n, r, u) => n + e(r) + ("comma_group" === t.groups[0].type && u !== t.groups.length - 1 ? "," : ""), "") + (t.close && t.close.value ? t.close.value : "");
        }
        const n = t.raws && t.raws.before ? t.raws.before : "",
          r = t.raws && t.raws.quote ? t.raws.quote : "";
        return n + r + ("atword" === t.type ? "@" : "") + (t.value ? t.value : "") + r + (t.unit ? t.unit : "") + (t.group ? e(t.group) : "") + (t.raws && t.raws.after ? t.raws.after : "");
      }
    };
    const {
        printNumber: Mm,
        printString: Lm,
        hasIgnoreComment: Rm,
        hasNewline: qm,
        isFrontMatterNode: Vm,
        isNextLineEmpty: Wm
      } = Lt,
      {
        builders: {
          concat: $m,
          join: Um,
          line: zm,
          hardline: Jm,
          softline: Gm,
          group: Hm,
          fill: Xm,
          indent: Ym,
          dedent: Km,
          ifBreak: Qm,
          breakParent: Zm
        },
        utils: {
          removeLines: eg
        }
      } = dn,
      {
        insertPragma: tg
      } = xm,
      {
        getAncestorNode: ng,
        getPropOfDeclNode: rg,
        maybeToLowerCase: ug,
        insideValueFunctionNode: og,
        insideICSSRuleNode: ag,
        insideAtRuleNode: ig,
        insideURLFunctionInImportAtRuleNode: sg,
        isKeyframeAtRuleKeywords: lg,
        isWideKeywords: cg,
        isSCSS: pg,
        isLastNode: dg,
        isLessParser: fg,
        isSCSSControlDirectiveNode: hg,
        isDetachedRulesetDeclarationNode: mg,
        isRelationalOperatorNode: gg,
        isEqualityOperatorNode: Dg,
        isMultiplicationNode: yg,
        isDivisionNode: Eg,
        isAdditionNode: Cg,
        isSubtractionNode: bg,
        isMathOperatorNode: Ag,
        isEachKeywordNode: vg,
        isForKeywordNode: Fg,
        isURLFunctionNode: xg,
        isIfElseKeywordNode: Sg,
        hasComposesNode: wg,
        hasParensAroundNode: Bg,
        hasEmptyRawBefore: Tg,
        isKeyValuePairNode: kg,
        isDetachedRulesetCallNode: Ng,
        isTemplatePlaceholderNode: Og,
        isTemplatePropNode: Pg,
        isPostcssSimpleVarNode: _g,
        isSCSSMapItemNode: Ig,
        isInlineValueCommentNode: jg,
        isHashNode: Mg,
        isLeftCurlyBraceNode: Lg,
        isRightCurlyBraceNode: Rg,
        isWordNode: qg,
        isColonNode: Vg,
        isMediaAndSupportsKeywords: Wg,
        isColorAdjusterFuncNode: $g,
        lastLineHasInlineComment: Ug
      } = jm;
    function zg(e) {
      return "es5" === e.trailingComma || "all" === e.trailingComma;
    }
    function Jg(e, t, n) {
      const r = e.getValue(),
        u = [];
      let o = 0;
      return e.map(e => {
        const a = r.nodes[o - 1];
        if (a && "css-comment" === a.type && "prettier-ignore" === a.text.trim()) {
          const n = e.getValue();
          u.push(t.originalText.slice(t.locStart(n), t.locEnd(n)));
        } else u.push(e.call(n));
        o !== r.nodes.length - 1 && ("css-comment" === r.nodes[o + 1].type && !qm(t.originalText, t.locStart(r.nodes[o + 1]), {
          backwards: !0
        }) && !Vm(r.nodes[o]) || "css-atrule" === r.nodes[o + 1].type && "else" === r.nodes[o + 1].name && "css-comment" !== r.nodes[o].type ? u.push(" ") : (u.push(t.__isHTMLStyleAttribute ? zm : Jm), Wm(t.originalText, e.getValue(), t.locEnd) && !Vm(r.nodes[o]) && u.push(Jm))), o++;
      }, "nodes"), $m(u);
    }
    const Gg = /(["'])(?:(?!\1)[^\\]|\\[\S\s])*\1/g,
      Hg = new RegExp(Gg.source + "|" + "(".concat(/[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g.source, ")?") + "(".concat(/(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g.source, ")") + "(".concat(/[A-Za-z]+/g.source, ")?"), "g");
    function Xg(e, t) {
      return e.replace(Gg, e => Lm(e, t));
    }
    function Yg(e, t) {
      const n = t.singleQuote ? "'" : '"';
      return e.includes('"') || e.includes("'") ? e : n + e + n;
    }
    function Kg(e) {
      return e.replace(Hg, (e, t, n, r, u) => !n && r ? Qg(r) + ug(u || "") : e);
    }
    function Qg(e) {
      return Mm(e).replace(/\.0(?=$|e)/, "");
    }
    var Zg = {
        print: function (e, t, n) {
          const r = e.getValue();
          if (!r) return "";
          if ("string" == typeof r) return r;
          switch (r.type) {
            case "front-matter":
              return $m([r.raw, Jm]);
            case "css-root":
              {
                const u = Jg(e, t, n),
                  o = r.raws.after.trim();
                return $m([u, o ? " ".concat(o) : "", u.parts.length && !t.__isHTMLStyleAttribute ? Jm : ""]);
              }
            case "css-comment":
              {
                const _e120 = r.inline || r.raws.inline,
                  _n24 = t.originalText.slice(t.locStart(r), t.locEnd(r));
                return _e120 ? _n24.trimEnd() : _n24;
              }
            case "css-rule":
              return $m([e.call(n, "selector"), r.important ? " !important" : "", r.nodes ? $m([r.selector && "selector-unknown" === r.selector.type && Ug(r.selector.value) ? zm : " ", "{", r.nodes.length > 0 ? Ym($m([Jm, Jg(e, t, n)])) : "", Jm, "}", mg(r) ? ";" : ""]) : ";"]);
            case "css-decl":
              {
                const u = e.getParentNode(),
                  {
                    between: o
                  } = r.raws,
                  a = o.trim(),
                  i = ":" === a;
                let s = wg(r) ? eg(e.call(n, "value")) : e.call(n, "value");
                return !i && Ug(a) && (s = Ym($m([Jm, Km(s)]))), $m([r.raws.before.replace(/[\s;]/g, ""), ag(e) ? r.prop : ug(r.prop), a.startsWith("//") ? " " : "", a, r.extend ? "" : " ", fg(t) && r.extend && r.selector ? $m(["extend(", e.call(n, "selector"), ")"]) : "", s, r.raws.important ? r.raws.important.replace(/\s*!\s*important/i, " !important") : r.important ? " !important" : "", r.raws.scssDefault ? r.raws.scssDefault.replace(/\s*!default/i, " !default") : r.scssDefault ? " !default" : "", r.raws.scssGlobal ? r.raws.scssGlobal.replace(/\s*!global/i, " !global") : r.scssGlobal ? " !global" : "", r.nodes ? $m([" {", Ym($m([Gm, Jg(e, t, n)])), Gm, "}"]) : Pg(r) && !u.raws.semicolon && ";" !== t.originalText[t.locEnd(r) - 1] ? "" : t.__isHTMLStyleAttribute && dg(e, r) ? Qm(";", "") : ";"]);
              }
            case "css-atrule":
              {
                const u = e.getParentNode(),
                  o = Og(r) && !u.raws.semicolon && ";" !== t.originalText[t.locEnd(r) - 1];
                if (fg(t)) {
                  if (r.mixin) return $m([e.call(n, "selector"), r.important ? " !important" : "", o ? "" : ";"]);
                  if (r.function) return $m([r.name, $m([e.call(n, "params")]), o ? "" : ";"]);
                  if (r.variable) return $m(["@", r.name, ": ", r.value ? $m([e.call(n, "value")]) : "", r.raws.between.trim() ? r.raws.between.trim() + " " : "", r.nodes ? $m(["{", Ym($m([r.nodes.length > 0 ? Gm : "", Jg(e, t, n)])), Gm, "}"]) : "", o ? "" : ";"]);
                }
                return $m(["@", Ng(r) || r.name.endsWith(":") ? r.name : ug(r.name), r.params ? $m([Ng(r) ? "" : Og(r) ? "" === r.raws.afterName ? "" : r.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(r.raws.afterName) ? $m([Jm, Jm]) : /^\s*\n/.test(r.raws.afterName) ? Jm : " " : " ", e.call(n, "params")]) : "", r.selector ? Ym($m([" ", e.call(n, "selector")])) : "", r.value ? Hm($m([" ", e.call(n, "value"), hg(r) ? Bg(r) ? " " : zm : ""])) : "else" === r.name ? " " : "", r.nodes ? $m([hg(r) ? "" : r.selector && !r.selector.nodes && "string" == typeof r.selector.value && Ug(r.selector.value) || !r.selector && "string" == typeof r.params && Ug(r.params) ? zm : " ", "{", Ym($m([r.nodes.length > 0 ? Gm : "", Jg(e, t, n)])), Gm, "}"]) : o ? "" : ";"]);
              }
            case "media-query-list":
              {
                const _t71 = [];
                return e.each(e => {
                  const r = e.getValue();
                  "media-query" === r.type && "" === r.value || _t71.push(e.call(n));
                }, "nodes"), Hm(Ym(Um(zm, _t71)));
              }
            case "media-query":
              return $m([Um(" ", e.map(n, "nodes")), dg(e, r) ? "" : ","]);
            case "media-type":
              return Kg(Xg(r.value, t));
            case "media-feature-expression":
              return r.nodes ? $m(["(", $m(e.map(n, "nodes")), ")"]) : r.value;
            case "media-feature":
              return ug(Xg(r.value.replace(/ +/g, " "), t));
            case "media-colon":
              return $m([r.value, " "]);
            case "media-value":
              return Kg(Xg(r.value, t));
            case "media-keyword":
              return Xg(r.value, t);
            case "media-url":
              return Xg(r.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/gi, ")"), t);
            case "media-unknown":
              return r.value;
            case "selector-root":
              return Hm($m([ig(e, "custom-selector") ? $m([ng(e, "css-atrule").customSelector, zm]) : "", Um($m([",", ig(e, ["extend", "custom-selector", "nest"]) ? zm : Jm]), e.map(n, "nodes"))]));
            case "selector-selector":
              return Hm(Ym($m(e.map(n, "nodes"))));
            case "selector-comment":
              return r.value;
            case "selector-string":
              return Xg(r.value, t);
            case "selector-tag":
              {
                const _t72 = e.getParentNode(),
                  _n25 = _t72 && _t72.nodes.indexOf(r),
                  u = _n25 && _t72.nodes[_n25 - 1];
                return $m([r.namespace ? $m([!0 === r.namespace ? "" : r.namespace.trim(), "|"]) : "", "selector-nesting" === u.type ? r.value : Kg(lg(e, r.value) ? r.value.toLowerCase() : r.value)]);
              }
            case "selector-id":
              return $m(["#", r.value]);
            case "selector-class":
              return $m([".", Kg(Xg(r.value, t))]);
            case "selector-attribute":
              return $m(["[", r.namespace ? $m([!0 === r.namespace ? "" : r.namespace.trim(), "|"]) : "", r.attribute.trim(), r.operator ? r.operator : "", r.value ? Yg(Xg(r.value.trim(), t), t) : "", r.insensitive ? " i" : "", "]"]);
            case "selector-combinator":
              {
                if ("+" === r.value || ">" === r.value || "~" === r.value || ">>>" === r.value) {
                  const _t73 = e.getParentNode(),
                    _n26 = "selector-selector" === _t73.type && _t73.nodes[0] === r ? "" : zm;
                  return $m([_n26, r.value, dg(e, r) ? "" : " "]);
                }
                const _n27 = r.value.trim().startsWith("(") ? zm : "",
                  u = Kg(Xg(r.value.trim(), t)) || zm;
                return $m([_n27, u]);
              }
            case "selector-universal":
              return $m([r.namespace ? $m([!0 === r.namespace ? "" : r.namespace.trim(), "|"]) : "", r.value]);
            case "selector-pseudo":
              return $m([ug(r.value), r.nodes && r.nodes.length > 0 ? $m(["(", Um(", ", e.map(n, "nodes")), ")"]) : ""]);
            case "selector-nesting":
              return r.value;
            case "selector-unknown":
              {
                const _n28 = ng(e, "css-rule");
                if (_n28 && _n28.isSCSSNesterProperty) return Kg(Xg(ug(r.value), t));
                const u = e.getParentNode();
                if (u.raws && u.raws.selector) {
                  const _e121 = t.locStart(u),
                    _n29 = _e121 + u.raws.selector.length;
                  return t.originalText.slice(_e121, _n29).trim();
                }
                const o = e.getParentNode(1);
                if ("value-paren_group" === u.type && o && "value-func" === o.type && "selector" === o.value) {
                  const _e122 = t.locStart(u.open) + 1,
                    _n30 = t.locEnd(u.close) - 1,
                    _r65 = t.originalText.slice(_e122, _n30).trim();
                  return Ug(_r65) ? $m([Zm, _r65]) : _r65;
                }
                return r.value;
              }
            case "value-value":
            case "value-root":
              return e.call(n, "group");
            case "value-comment":
              return t.originalText.slice(t.locStart(r), t.locEnd(r));
            case "value-comma_group":
              {
                const _t74 = e.getParentNode(),
                  u = e.getParentNode(1),
                  o = rg(e),
                  a = o && "value-value" === _t74.type && ("grid" === o || o.startsWith("grid-template")),
                  i = ng(e, "css-atrule"),
                  s = i && hg(i),
                  l = e.map(n, "groups"),
                  c = [],
                  p = og(e, "url");
                let d = !1,
                  f = !1;
                for (let _n31 = 0; _n31 < r.groups.length; ++_n31) {
                  c.push(l[_n31]);
                  const _o34 = r.groups[_n31 - 1],
                    h = r.groups[_n31],
                    m = r.groups[_n31 + 1],
                    g = r.groups[_n31 + 2];
                  if (p) {
                    (m && Cg(m) || Cg(h)) && c.push(" ");
                    continue;
                  }
                  if (!m) continue;
                  if ("value-word" === h.type && h.value.endsWith("-") && "value-atword" === m.type && m.value.startsWith("prettier-placeholder-")) continue;
                  const D = "value-string" === h.type && h.value.startsWith("#{"),
                    y = d && "value-string" === m.type && m.value.endsWith("}");
                  if (D || y) {
                    d = !d;
                    continue;
                  }
                  if (d) continue;
                  if (Vg(h) || Vg(m)) continue;
                  if ("value-atword" === h.type && "" === h.value) continue;
                  if ("~" === h.value) continue;
                  if (h.value && h.value.includes("\\") && m && "value-comment" !== m.type) continue;
                  if (_o34 && _o34.value && _o34.value.indexOf("\\") === _o34.value.length - 1 && "value-operator" === h.type && "/" === h.value) continue;
                  if ("\\" === h.value) continue;
                  if (_g(h, m)) continue;
                  if (Mg(h) || Lg(h) || Rg(m) || Lg(m) && Tg(m) || Rg(h) && Tg(m)) continue;
                  if ("--" === h.value && Mg(m)) continue;
                  const E = Ag(h),
                    C = Ag(m);
                  if ((E && Mg(m) || C && Rg(h)) && Tg(m)) continue;
                  if (og(e, "calc") && (Cg(h) || Cg(m) || bg(h) || bg(m)) && Tg(m)) continue;
                  const b = (Cg(h) || bg(h)) && 0 === _n31 && ("value-number" === m.type || m.isHex) && u && $g(u) && !Tg(m),
                    A = g && "value-func" === g.type || g && qg(g) || "value-func" === h.type || qg(h),
                    v = "value-func" === m.type || qg(m) || _o34 && "value-func" === _o34.type || _o34 && qg(_o34);
                  if (yg(m) || yg(h) || og(e, "calc") || b || !(Eg(m) && !A || Eg(h) && !v || Cg(m) && !A || Cg(h) && !v || bg(m) || bg(h)) || !(Tg(m) || E && (!_o34 || _o34 && Ag(_o34)))) if (jg(h)) {
                    if ("value-paren_group" === _t74.type) {
                      c.push(Km(Jm));
                      continue;
                    }
                    c.push(Jm);
                  } else s && (Dg(m) || gg(m) || Sg(m) || vg(h) || Fg(h)) || i && "namespace" === i.name.toLowerCase() ? c.push(" ") : a ? h.source && m.source && h.source.start.line !== m.source.start.line ? (c.push(Jm), f = !0) : c.push(" ") : C ? c.push(" ") : m && "..." === m.value || c.push(zm);
                }
                return f && c.unshift(Jm), s ? Hm(Ym($m(c))) : sg(e) ? Hm(Xm(c)) : Hm(Ym(Xm(c)));
              }
            case "value-paren_group":
              {
                const u = e.getParentNode();
                if (u && xg(u) && (1 === r.groups.length || r.groups.length > 0 && "value-comma_group" === r.groups[0].type && r.groups[0].groups.length > 0 && "value-word" === r.groups[0].groups[0].type && r.groups[0].groups[0].value.startsWith("data:"))) return $m([r.open ? e.call(n, "open") : "", Um(",", e.map(n, "groups")), r.close ? e.call(n, "close") : ""]);
                if (!r.open) {
                  const _t75 = e.map(n, "groups"),
                    _r66 = [];
                  for (let _e123 = 0; _e123 < _t75.length; _e123++) 0 !== _e123 && _r66.push($m([",", zm])), _r66.push(_t75[_e123]);
                  return Hm(Ym(Xm(_r66)));
                }
                const o = Ig(e),
                  a = r.groups[r.groups.length - 1],
                  i = a && "value-comment" === a.type;
                return Hm($m([r.open ? e.call(n, "open") : "", Ym($m([Gm, Um($m([",", zm]), e.map(e => {
                  const t = e.getValue(),
                    r = n(e);
                  return kg(t) && "value-comma_group" === t.type && t.groups && t.groups[2] && "value-paren_group" === t.groups[2].type ? (r.contents.contents.parts[1] = Hm(r.contents.contents.parts[1]), Hm(Km(r))) : r;
                }, "groups"))])), Qm(!i && pg(t.parser, t.originalText) && o && zg(t) ? "," : ""), Gm, r.close ? e.call(n, "close") : ""]), {
                  shouldBreak: o
                });
              }
            case "value-func":
              return $m([r.value, ig(e, "supports") && Wg(r) ? " " : "", e.call(n, "group")]);
            case "value-paren":
              return r.value;
            case "value-number":
              return $m([Qg(r.value), ug(r.unit)]);
            case "value-operator":
              return r.value;
            case "value-word":
              return r.isColor && r.isHex || cg(r.value) ? r.value.toLowerCase() : r.value;
            case "value-colon":
              {
                const _t76 = e.getParentNode(),
                  _n32 = _t76 && _t76.groups.indexOf(r),
                  u = _n32 && _t76.groups[_n32 - 1];
                return $m([r.value, u && "\\" === u.value[u.value.length - 1] || og(e, "url") ? "" : zm]);
              }
            case "value-comma":
              return $m([r.value, " "]);
            case "value-string":
              return Lm(r.raws.quote + r.value + r.raws.quote, t);
            case "value-atword":
              return $m(["@", r.value]);
            case "value-unicode-range":
            case "value-unknown":
              return r.value;
            default:
              throw new Error("Unknown postcss type ".concat(JSON.stringify(r.type)));
          }
        },
        embed: vm,
        insertPragma: tg,
        hasPrettierIgnore: Rm,
        massageAstNode: hm
      },
      eD = {
        singleQuote: Bh.singleQuote
      },
      tD = [".css"],
      nD = {
        name: "CSS",
        type: "markup",
        tmScope: "source.css",
        aceMode: "css",
        codemirrorMode: "css",
        codemirrorMimeType: "text/css",
        color: "#563d7c",
        extensions: tD,
        languageId: 50
      },
      rD = Object.freeze({
        __proto__: null,
        name: "CSS",
        type: "markup",
        tmScope: "source.css",
        aceMode: "css",
        codemirrorMode: "css",
        codemirrorMimeType: "text/css",
        color: "#563d7c",
        extensions: tD,
        languageId: 50,
        default: nD
      }),
      uD = [".pcss", ".postcss"],
      oD = {
        name: "PostCSS",
        type: "markup",
        tmScope: "source.postcss",
        group: "CSS",
        extensions: uD,
        aceMode: "text",
        languageId: 262764437
      },
      aD = Object.freeze({
        __proto__: null,
        name: "PostCSS",
        type: "markup",
        tmScope: "source.postcss",
        group: "CSS",
        extensions: uD,
        aceMode: "text",
        languageId: 262764437,
        default: oD
      }),
      iD = [".less"],
      sD = {
        name: "Less",
        type: "markup",
        group: "CSS",
        extensions: iD,
        tmScope: "source.css.less",
        aceMode: "less",
        codemirrorMode: "css",
        codemirrorMimeType: "text/css",
        languageId: 198
      },
      lD = Object.freeze({
        __proto__: null,
        name: "Less",
        type: "markup",
        group: "CSS",
        extensions: iD,
        tmScope: "source.css.less",
        aceMode: "less",
        codemirrorMode: "css",
        codemirrorMimeType: "text/css",
        languageId: 198,
        default: sD
      }),
      cD = [".scss"],
      pD = {
        name: "SCSS",
        type: "markup",
        tmScope: "source.css.scss",
        group: "CSS",
        aceMode: "scss",
        codemirrorMode: "css",
        codemirrorMimeType: "text/x-scss",
        extensions: cD,
        languageId: 329
      },
      dD = Object.freeze({
        __proto__: null,
        name: "SCSS",
        type: "markup",
        tmScope: "source.css.scss",
        group: "CSS",
        aceMode: "scss",
        codemirrorMode: "css",
        codemirrorMimeType: "text/x-scss",
        extensions: cD,
        languageId: 329,
        default: pD
      }),
      fD = Ue(rD),
      hD = Ue(aD),
      mD = Ue(lD),
      gD = Ue(dD);
    var DD = {
        languages: [As(fD, () => ({
          since: "1.4.0",
          parsers: ["css"],
          vscodeLanguageIds: ["css"]
        })), As(hD, () => ({
          since: "1.4.0",
          parsers: ["css"],
          vscodeLanguageIds: ["postcss"]
        })), As(mD, () => ({
          since: "1.4.0",
          parsers: ["less"],
          vscodeLanguageIds: ["less"]
        })), As(gD, () => ({
          since: "1.4.0",
          parsers: ["scss"],
          vscodeLanguageIds: ["scss"]
        }))],
        options: eD,
        printers: {
          postcss: Zg
        },
        parsers: {
          get css() {
            return {}.parsers.css;
          },
          get less() {
            return {}.parsers.less;
          },
          get scss() {
            return {}.parsers.scss;
          }
        }
      },
      yD = Ue(Object.freeze({
        __proto__: null,
        default: ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "isindex", "keygen", "link", "menuitem", "meta", "nextid", "param", "source", "track", "wbr"]
      }));
    const ED = new Set(yD);
    function CD(e) {
      return bD(e, ["TextNode"]) && !/\S/.test(e.chars);
    }
    function bD(e, t) {
      return e && t.some(t => e.type === t);
    }
    function AD(e, t) {
      const n = e.getValue(),
        r = e.getParentNode(0) || {},
        u = r.children || r.body || r.parts || [],
        o = u.indexOf(n);
      return -1 !== o && u[o + t];
    }
    function vD(e, t = 1) {
      return AD(e, -t);
    }
    function FD(e) {
      return AD(e, 1);
    }
    function xD(e) {
      return bD(e, ["MustacheCommentStatement"]) && "string" == typeof e.value && "prettier-ignore" === e.value.trim();
    }
    var SD = {
      getNextNode: FD,
      getPreviousNode: vD,
      hasPrettierIgnore: function (e) {
        const t = e.getValue(),
          n = vD(e, 2);
        return xD(t) || xD(n);
      },
      isNextNodeOfSomeType: function (e, t) {
        return bD(FD(e), t);
      },
      isNodeOfSomeType: bD,
      isParentOfSomeType: function (e, t) {
        return bD(e.getParentNode(0), t);
      },
      isPreviousNodeOfSomeType: function (e, t) {
        return bD(vD(e), t);
      },
      isVoid: function (e) {
        return function (e) {
          return bD(e, ["ElementNode"]) && "string" == typeof e.tag && (function (e) {
            return e.toUpperCase() === e;
          }(e.tag[0]) || e.tag.includes("."));
        }(e) && (0 === e.children || e.children.every(e => CD(e))) || ED.has(e.tag);
      },
      isWhitespaceNode: CD
    };
    const {
        concat: wD,
        group: BD,
        hardline: TD,
        ifBreak: kD,
        indent: ND,
        join: OD,
        line: PD,
        softline: _D
      } = dn.builders,
      {
        getNextNode: ID,
        getPreviousNode: jD,
        hasPrettierIgnore: MD,
        isNextNodeOfSomeType: LD,
        isNodeOfSomeType: RD,
        isParentOfSomeType: qD,
        isPreviousNodeOfSomeType: VD,
        isVoid: WD,
        isWhitespaceNode: $D
      } = SD;
    function UD(e, t) {
      const n = e.getValue();
      return wD(["<", n.tag, zD(e, t), Dy(n), GD(n)]);
    }
    function zD(e, t) {
      const n = e.getValue();
      return ND(wD([n.attributes.length ? PD : "", OD(PD, e.map(t, "attributes")), n.modifiers.length ? PD : "", OD(PD, e.map(t, "modifiers")), n.comments.length ? PD : "", OD(PD, e.map(t, "comments"))]));
    }
    function JD(e, t, n) {
      return wD(e.map((e, r) => 0 === r ? wD([_D, n(e, t, n)]) : n(e, t, n), "children"));
    }
    function GD(e) {
      return WD(e) ? kD(wD([_D, "/>"]), wD([" />", _D])) : kD(wD([_D, ">"]), ">");
    }
    function HD(e) {
      const t = !1 === e.escaped ? "{{{" : "{{",
        n = e.strip && e.strip.open ? "~" : "";
      return wD([t, n]);
    }
    function XD(e) {
      const t = !1 === e.escaped ? "}}}" : "}}",
        n = e.strip && e.strip.close ? "~" : "";
      return wD([n, t]);
    }
    function YD(e) {
      const t = HD(e),
        n = e.openStrip.open ? "~" : "";
      return wD([t, n, "#"]);
    }
    function KD(e) {
      const t = XD(e),
        n = e.openStrip.close ? "~" : "";
      return wD([n, t]);
    }
    function QD(e) {
      const t = HD(e),
        n = e.closeStrip.open ? "~" : "";
      return wD([t, n, "/"]);
    }
    function ZD(e) {
      const t = XD(e),
        n = e.closeStrip.close ? "~" : "";
      return wD([n, t]);
    }
    function ey(e) {
      const t = HD(e),
        n = e.inverseStrip.open ? "~" : "";
      return wD([t, n]);
    }
    function ty(e) {
      const t = XD(e),
        n = e.inverseStrip.close ? "~" : "";
      return wD([n, t]);
    }
    function ny(e, t) {
      const n = e.getValue();
      return BD(wD([YD(n), hy(e, t), Dy(n.program), _D, KD(n)]));
    }
    function ry(e) {
      return wD([TD, ey(e), "else", ty(e)]);
    }
    function uy(e, t) {
      const n = e.getParentNode(1);
      return wD([ey(n), "else ", hy(e, t), ty(n)]);
    }
    function oy(e, t) {
      const n = e.getValue();
      return wD([ay(n) ? _D : TD, QD(n), e.call(t, "path"), ZD(n)]);
    }
    function ay(e) {
      return RD(e, ["BlockStatement"]) && e.program.body.every(e => $D(e));
    }
    function iy(e) {
      return RD(e, ["BlockStatement"]) && e.inverse;
    }
    function sy(e, t) {
      if (ay(e.getValue())) return "";
      const n = e.call(t, "program");
      return ND(wD([TD, n]));
    }
    function ly(e, t) {
      const n = e.getValue(),
        r = e.call(t, "inverse"),
        u = wD([TD, r]);
      return function (e) {
        return iy(e) && 1 === e.inverse.body.length && RD(e.inverse.body[0], ["BlockStatement"]) && "if" === e.inverse.body[0].path.parts[0];
      }(n) ? u : iy(n) ? wD([ry(n), ND(u)]) : "";
    }
    function cy(e) {
      return (e = "string" == typeof e ? e : "").split("\n").length - 1;
    }
    function py(e = 0, t = 0) {
      return new Array(Math.min(e, t)).fill(TD);
    }
    function dy(e, t) {
      const n = {
          quote: '"',
          regex: /"/g
        },
        r = {
          quote: "'",
          regex: /'/g
        },
        u = t.singleQuote ? r : n,
        o = u === r ? n : r;
      let a = !1;
      if (e.includes(u.quote) || e.includes(o.quote)) {
        a = (e.match(u.regex) || []).length > (e.match(o.regex) || []).length;
      }
      const i = a ? o : u,
        s = e.replace(i.regex, "\\".concat(i.quote));
      return wD([i.quote, s, i.quote]);
    }
    function fy(e, t) {
      const n = my(e, t),
        r = gy(e, t);
      return r ? ND(wD([n, PD, BD(r)])) : n;
    }
    function hy(e, t) {
      const n = my(e, t),
        r = gy(e, t);
      return r ? ND(BD(wD([n, PD, r]))) : n;
    }
    function my(e, t) {
      return e.call(t, "path");
    }
    function gy(e, t) {
      const n = e.getValue(),
        r = [];
      if (n.params.length) {
        const _n33 = e.map(t, "params");
        r.push(..._n33);
      }
      if (n.hash && n.hash.pairs.length > 0) {
        const _n34 = e.call(t, "hash");
        r.push(_n34);
      }
      return r.length ? OD(PD, r) : "";
    }
    function Dy(e) {
      return e && e.blockParams.length ? wD([" as |", e.blockParams.join(" "), "|"]) : "";
    }
    function yy(e, t, n) {
      let r = 0,
        u = 0;
      for (;;) {
        if (u === e.length) return null;
        let o = e.indexOf("\n", u);
        if (-1 === o && (o = e.length), r === t) return u + n > o ? null : u + n;
        if (-1 === o) return null;
        r += 1, u = o + 1;
      }
    }
    var Ey = {
        print: function (e, t, n) {
          const r = e.getValue();
          if (!r) return "";
          if (MD(e)) {
            const _e124 = yy(t.originalText, r.loc.start.line - 1, r.loc.start.column),
              _n35 = yy(t.originalText, r.loc.end.line - 1, r.loc.end.column);
            return t.originalText.slice(_e124, _n35);
          }
          switch (r.type) {
            case "Block":
            case "Program":
            case "Template":
              return BD(wD(e.map(n, "body")));
            case "ElementNode":
              {
                const u = LD(e, ["ElementNode"]) ? TD : "";
                if (WD(r)) return wD([BD(UD(e, n)), u]);
                const o = r.children.every(e => $D(e));
                return wD([BD(UD(e, n)), BD(wD([o ? "" : ND(JD(e, t, n)), r.children.length ? TD : "", wD(["</", r.tag, ">"])])), u]);
              }
            case "BlockStatement":
              {
                const _t77 = e.getParentNode(1),
                  u = _t77 && _t77.inverse && 1 === _t77.inverse.body.length && _t77.inverse.body[0] === r && "if" === _t77.inverse.body[0].path.parts[0];
                return wD(u ? [uy(e, n), sy(e, n), ly(e, n)] : [ny(e, n), BD(wD([sy(e, n), ly(e, n), oy(e, n)]))]);
              }
            case "ElementModifierStatement":
              return BD(wD(["{{", hy(e, n), _D, "}}"]));
            case "MustacheStatement":
              {
                const _t78 = qD(e, ["AttrNode", "ConcatStatement"]),
                  u = qD(e, ["ElementNode"]) && 0 === r.hash.pairs.length && function (e) {
                    return 0 === e.params.length;
                  }(r),
                  o = _t78 || u;
                return BD(wD([HD(r), o ? ND(_D) : "", hy(e, n), _D, XD(r)]));
              }
            case "SubExpression":
              return BD(wD(["(", fy(e, n), _D, ")"]));
            case "AttrNode":
              {
                const u = "TextNode" === r.value.type;
                if (u && "" === r.value.chars && r.value.loc.start.column === r.value.loc.end.column) return wD([r.name]);
                const o = e.call(n, "value"),
                  a = u ? dy(o.parts.join(), t) : o;
                return wD([r.name, "=", a]);
              }
            case "ConcatStatement":
              {
                const _r67 = t.singleQuote ? "'" : '"';
                return wD([_r67, ...e.map(e => n(e), "parts"), _r67]);
              }
            case "Hash":
              return wD([OD(PD, e.map(n, "pairs"))]);
            case "HashPair":
              return wD([r.key, "=", e.call(n, "value")]);
            case "TextNode":
              {
                const _t79 = 2,
                  _n36 = !jD(e),
                  u = !ID(e),
                  o = !/\S/.test(r.chars),
                  a = cy(r.chars);
                let i = function (e) {
                    return cy(((e = "string" == typeof e ? e : "").match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "");
                  }(r.chars),
                  s = function (e) {
                    return cy(((e = "string" == typeof e ? e : "").match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "");
                  }(r.chars);
                if ((_n36 || u) && o && qD(e, ["Block", "ElementNode", "Template"])) return "";
                o && a ? (i = Math.min(a, _t79), s = 0) : (LD(e, ["BlockStatement", "ElementNode"]) && (s = Math.max(s, 1)), VD(e, ["BlockStatement", "ElementNode"]) && (i = Math.max(i, 1)));
                if (e.stack.includes("attributes")) {
                  if (!function (e, t) {
                    return qD(e, ["AttrNode"]) && e.getParentNode().name.toLowerCase() === t || qD(e, ["ConcatStatement"]) && e.getParentNode(1).name.toLowerCase() === t;
                  }(e, "class")) return wD([r.chars]);
                  let _n37 = "",
                    _u15 = "";
                  return qD(e, ["ConcatStatement"]) && (VD(e, ["MustacheStatement"]) && (_n37 = " "), LD(e, ["MustacheStatement"]) && (_u15 = " ")), wD([...py(i, _t79), r.chars.replace(/^\s+/g, _n37).replace(/\s+$/, _u15), ...py(s, _t79)]);
                }
                let l = "",
                  c = "";
                0 === s && LD(e, ["MustacheStatement"]) && (c = " "), 0 === i && VD(e, ["MustacheStatement"]) && (l = " "), _n36 && (i = 0, l = ""), u && (s = 0, c = "");
                let p = r.chars;
                return p.startsWith("{{") && p.includes("}}") && (p = "\\" + p), wD([...py(i, _t79), p.replace(/^\s+/g, l).replace(/\s+$/, c), ...py(s, _t79)]);
              }
            case "MustacheCommentStatement":
              {
                const _e125 = r.value.includes("}}") ? "--" : "";
                return wD(["{{!", _e125, r.value, _e125, "}}"]);
              }
            case "PathExpression":
              return r.original;
            case "BooleanLiteral":
              return String(r.value);
            case "CommentStatement":
              return wD(["\x3c!--", r.value, "--\x3e"]);
            case "StringLiteral":
              return dy(r.value, t);
            case "NumberLiteral":
              return String(r.value);
            case "UndefinedLiteral":
              return "undefined";
            case "NullLiteral":
              return "null";
            default:
              throw new Error("unknown glimmer type: " + JSON.stringify(r.type));
          }
        },
        massageAstNode: function (e, t) {
          if (delete t.loc, delete t.selfClosing, "TextNode" === e.type) {
            const n = e.chars.trim();
            if (!n) return null;
            t.chars = n;
          }
        }
      },
      Cy = ["hbs", "htmlbars"],
      by = [".handlebars", ".hbs"],
      Ay = {
        name: "Handlebars",
        type: "markup",
        group: "HTML",
        aliases: Cy,
        extensions: by,
        tmScope: "text.html.handlebars",
        aceMode: "handlebars",
        languageId: 155
      };
    var vy = {
      languages: [As(Ue(Object.freeze({
        __proto__: null,
        name: "Handlebars",
        type: "markup",
        group: "HTML",
        aliases: Cy,
        extensions: by,
        tmScope: "text.html.handlebars",
        aceMode: "handlebars",
        languageId: 155,
        default: Ay
      })), () => ({
        since: null,
        parsers: ["glimmer"],
        vscodeLanguageIds: ["handlebars"]
      }))],
      printers: {
        glimmer: Ey
      },
      parsers: {
        get glimmer() {
          return {}.parsers.glimmer;
        }
      }
    };
    var Fy = {
      hasPragma: function (e) {
        return /^\s*#[^\S\n]*@(format|prettier)\s*(\n|$)/.test(e);
      },
      insertPragma: function (e) {
        return "# @format\n\n" + e;
      }
    };
    const {
        concat: xy,
        join: Sy,
        hardline: wy,
        line: By,
        softline: Ty,
        group: ky,
        indent: Ny,
        ifBreak: Oy
      } = dn.builders,
      {
        hasIgnoreComment: Py,
        isNextLineEmpty: _y
      } = Lt,
      {
        insertPragma: Iy
      } = Fy;
    function jy(e, t, n) {
      if (0 === n.directives.length) return "";
      const r = Sy(By, e.map(t, "directives"));
      return "FragmentDefinition" === n.kind || "OperationDefinition" === n.kind ? ky(xy([By, r])) : xy([" ", ky(Ny(xy([Ty, r])))]);
    }
    function My(e, t, n) {
      const r = e.getValue().length;
      return e.map((e, u) => {
        const o = n(e);
        return _y(t.originalText, e.getValue(), t.locEnd) && u < r - 1 ? xy([o, wy]) : o;
      });
    }
    function Ly(e, t, n) {
      const r = e.getNode(),
        u = [],
        {
          interfaces: o
        } = r,
        a = e.map(e => n(e), "interfaces");
      for (let _e126 = 0; _e126 < o.length; _e126++) {
        const _n38 = o[_e126];
        u.push(a[_e126]);
        const _r68 = o[_e126 + 1];
        if (_r68) {
          const _e127 = t.originalText.slice(_n38.loc.end, _r68.loc.start),
            _o35 = _e127.includes("#"),
            _a27 = _e127.replace(/#.*/g, "").trim();
          u.push("," === _a27 ? "," : " &"), u.push(_o35 ? By : " ");
        }
      }
      return u;
    }
    var Ry = {
        print: function (e, t, n) {
          const r = e.getValue();
          if (!r) return "";
          if ("string" == typeof r) return r;
          switch (r.kind) {
            case "Document":
              {
                const u = [];
                return e.map((e, o) => {
                  u.push(xy([e.call(n)])), o !== r.definitions.length - 1 && (u.push(wy), _y(t.originalText, e.getValue(), t.locEnd) && u.push(wy));
                }, "definitions"), xy([xy(u), wy]);
              }
            case "OperationDefinition":
              {
                const u = "{" !== t.originalText[t.locStart(r)],
                  o = !!r.name;
                return xy([u ? r.operation : "", u && o ? xy([" ", e.call(n, "name")]) : "", r.variableDefinitions && r.variableDefinitions.length ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.map(n, "variableDefinitions"))])), Ty, ")"])) : "", jy(e, n, r), r.selectionSet && (u || o) ? " " : "", e.call(n, "selectionSet")]);
              }
            case "FragmentDefinition":
              return xy(["fragment ", e.call(n, "name"), r.variableDefinitions && r.variableDefinitions.length ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.map(n, "variableDefinitions"))])), Ty, ")"])) : "", " on ", e.call(n, "typeCondition"), jy(e, n, r), " ", e.call(n, "selectionSet")]);
            case "SelectionSet":
              return xy(["{", Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "selections"))])), wy, "}"]);
            case "Field":
              return ky(xy([r.alias ? xy([e.call(n, "alias"), ": "]) : "", e.call(n, "name"), r.arguments.length > 0 ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.call(e => My(e, t, n), "arguments"))])), Ty, ")"])) : "", jy(e, n, r), r.selectionSet ? " " : "", e.call(n, "selectionSet")]));
            case "Name":
              return r.value;
            case "StringValue":
              return r.block ? xy(['"""', wy, Sy(wy, r.value.replace(/"""/g, "\\$&").split("\n")), wy, '"""']) : xy(['"', r.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"']);
            case "IntValue":
            case "FloatValue":
            case "EnumValue":
              return r.value;
            case "BooleanValue":
              return r.value ? "true" : "false";
            case "NullValue":
              return "null";
            case "Variable":
              return xy(["$", e.call(n, "name")]);
            case "ListValue":
              return ky(xy(["[", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.map(n, "values"))])), Ty, "]"]));
            case "ObjectValue":
              return ky(xy(["{", t.bracketSpacing && r.fields.length > 0 ? " " : "", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.map(n, "fields"))])), Ty, Oy("", t.bracketSpacing && r.fields.length > 0 ? " " : ""), "}"]));
            case "ObjectField":
            case "Argument":
              return xy([e.call(n, "name"), ": ", e.call(n, "value")]);
            case "Directive":
              return xy(["@", e.call(n, "name"), r.arguments.length > 0 ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.call(e => My(e, t, n), "arguments"))])), Ty, ")"])) : ""]);
            case "NamedType":
              return e.call(n, "name");
            case "VariableDefinition":
              return xy([e.call(n, "variable"), ": ", e.call(n, "type"), r.defaultValue ? xy([" = ", e.call(n, "defaultValue")]) : "", jy(e, n, r)]);
            case "ObjectTypeExtension":
            case "ObjectTypeDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "ObjectTypeExtension" === r.kind ? "extend " : "", "type ", e.call(n, "name"), r.interfaces.length > 0 ? xy([" implements ", xy(Ly(e, t, n))]) : "", jy(e, n, r), r.fields.length > 0 ? xy([" {", Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "fields"))])), wy, "}"]) : ""]);
            case "FieldDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", e.call(n, "name"), r.arguments.length > 0 ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.call(e => My(e, t, n), "arguments"))])), Ty, ")"])) : "", ": ", e.call(n, "type"), jy(e, n, r)]);
            case "DirectiveDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "directive ", "@", e.call(n, "name"), r.arguments.length > 0 ? ky(xy(["(", Ny(xy([Ty, Sy(xy([Oy("", ", "), Ty]), e.call(e => My(e, t, n), "arguments"))])), Ty, ")"])) : "", r.repeatable ? " repeatable" : "", xy([" on ", Sy(" | ", e.map(n, "locations"))])]);
            case "EnumTypeExtension":
            case "EnumTypeDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "EnumTypeExtension" === r.kind ? "extend " : "", "enum ", e.call(n, "name"), jy(e, n, r), r.values.length > 0 ? xy([" {", Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "values"))])), wy, "}"]) : ""]);
            case "EnumValueDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", e.call(n, "name"), jy(e, n, r)]);
            case "InputValueDefinition":
              return xy([e.call(n, "description"), r.description ? r.description.block ? wy : By : "", e.call(n, "name"), ": ", e.call(n, "type"), r.defaultValue ? xy([" = ", e.call(n, "defaultValue")]) : "", jy(e, n, r)]);
            case "InputObjectTypeExtension":
            case "InputObjectTypeDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "InputObjectTypeExtension" === r.kind ? "extend " : "", "input ", e.call(n, "name"), jy(e, n, r), r.fields.length > 0 ? xy([" {", Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "fields"))])), wy, "}"]) : ""]);
            case "SchemaDefinition":
              return xy(["schema", jy(e, n, r), " {", r.operationTypes.length > 0 ? Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "operationTypes"))])) : "", wy, "}"]);
            case "OperationTypeDefinition":
              return xy([e.call(n, "operation"), ": ", e.call(n, "type")]);
            case "InterfaceTypeExtension":
            case "InterfaceTypeDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "InterfaceTypeExtension" === r.kind ? "extend " : "", "interface ", e.call(n, "name"), r.interfaces.length > 0 ? xy([" implements ", xy(Ly(e, t, n))]) : "", jy(e, n, r), r.fields.length > 0 ? xy([" {", Ny(xy([wy, Sy(wy, e.call(e => My(e, t, n), "fields"))])), wy, "}"]) : ""]);
            case "FragmentSpread":
              return xy(["...", e.call(n, "name"), jy(e, n, r)]);
            case "InlineFragment":
              return xy(["...", r.typeCondition ? xy([" on ", e.call(n, "typeCondition")]) : "", jy(e, n, r), " ", e.call(n, "selectionSet")]);
            case "UnionTypeExtension":
            case "UnionTypeDefinition":
              return ky(xy([e.call(n, "description"), r.description ? wy : "", ky(xy(["UnionTypeExtension" === r.kind ? "extend " : "", "union ", e.call(n, "name"), jy(e, n, r), r.types.length > 0 ? xy([" =", Oy("", " "), Ny(xy([Oy(xy([By, "  "])), Sy(xy([By, "| "]), e.map(n, "types"))]))]) : ""]))]));
            case "ScalarTypeExtension":
            case "ScalarTypeDefinition":
              return xy([e.call(n, "description"), r.description ? wy : "", "ScalarTypeExtension" === r.kind ? "extend " : "", "scalar ", e.call(n, "name"), jy(e, n, r)]);
            case "NonNullType":
              return xy([e.call(n, "type"), "!"]);
            case "ListType":
              return xy(["[", e.call(n, "type"), "]"]);
            default:
              throw new Error("unknown graphql type: " + JSON.stringify(r.kind));
          }
        },
        massageAstNode: function (e, t) {
          delete t.loc, delete t.comments;
        },
        hasPrettierIgnore: Py,
        insertPragma: Iy,
        printComment: function (e) {
          const t = e.getValue();
          if ("Comment" === t.kind) return "#" + t.value.trimEnd();
          throw new Error("Not a comment: " + JSON.stringify(t));
        },
        canAttachComment: function (e) {
          return e.kind && "Comment" !== e.kind;
        }
      },
      qy = {
        bracketSpacing: Bh.bracketSpacing
      },
      Vy = [".graphql", ".gql", ".graphqls"],
      Wy = {
        name: "GraphQL",
        type: "data",
        extensions: Vy,
        tmScope: "source.graphql",
        aceMode: "text",
        languageId: 139
      };
    var $y = {
      languages: [As(Ue(Object.freeze({
        __proto__: null,
        name: "GraphQL",
        type: "data",
        extensions: Vy,
        tmScope: "source.graphql",
        aceMode: "text",
        languageId: 139,
        default: Wy
      })), () => ({
        since: "1.5.0",
        parsers: ["graphql"],
        vscodeLanguageIds: ["graphql"]
      }))],
      options: qy,
      printers: {
        graphql: Ry
      },
      parsers: {
        get graphql() {
          return {}.parsers.graphql;
        }
      }
    };
    const {
        getLast: Uy
      } = Lt,
      {
        cjkPattern: zy,
        kPattern: Jy,
        punctuationPattern: Gy
      } = {
        cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u3000-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?",
        kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]",
        punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]"
      },
      Hy = ["liquidNode", "inlineCode", "emphasis", "strong", "delete", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"],
      Xy = Hy.concat(["tableCell", "paragraph", "heading"]),
      Yy = new RegExp(Jy),
      Ky = new RegExp(Gy);
    function Qy(e, t) {
      const [, n, r, u] = t.slice(e.position.start.offset, e.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
      return {
        numberText: n,
        marker: r,
        leadingSpaces: u
      };
    }
    var Zy = {
      mapAst: function (e, t) {
        return function e(n, r, u) {
          u = u || [];
          const o = Object.assign({}, t(n, r, u));
          return o.children && (o.children = o.children.map((t, n) => e(t, n, [o].concat(u)))), o;
        }(e, null, null);
      },
      splitText: function (e, t) {
        const n = [];
        return ("preserve" === t.proseWrap ? e : e.replace(new RegExp("(".concat(zy, ")\n(").concat(zy, ")"), "g"), "$1$2")).split(/([\t\n ]+)/).forEach((e, t, u) => {
          t % 2 != 1 ? (0 !== t && t !== u.length - 1 || "" !== e) && e.split(new RegExp("(".concat(zy, ")"))).forEach((e, t, n) => {
            (0 !== t && t !== n.length - 1 || "" !== e) && (t % 2 != 0 ? r(Ky.test(e) ? {
              type: "word",
              value: e,
              kind: "cjk-punctuation",
              hasLeadingPunctuation: !0,
              hasTrailingPunctuation: !0
            } : {
              type: "word",
              value: e,
              kind: Yy.test(e) ? "k-letter" : "cj-letter",
              hasLeadingPunctuation: !1,
              hasTrailingPunctuation: !1
            }) : "" !== e && r({
              type: "word",
              value: e,
              kind: "non-cjk",
              hasLeadingPunctuation: Ky.test(e[0]),
              hasTrailingPunctuation: Ky.test(Uy(e))
            }));
          }) : n.push({
            type: "whitespace",
            value: /\n/.test(e) ? "\n" : " "
          });
        }), n;
        function r(e) {
          const t = Uy(n);
          var r, u;
          t && "word" === t.type && ("non-cjk" === t.kind && "cj-letter" === e.kind && !t.hasTrailingPunctuation || "cj-letter" === t.kind && "non-cjk" === e.kind && !e.hasLeadingPunctuation ? n.push({
            type: "whitespace",
            value: " "
          }) : (r = "non-cjk", u = "cjk-punctuation", t.kind === r && e.kind === u || t.kind === u && e.kind === r || [t.value, e.value].some(e => /\u3000/.test(e)) || n.push({
            type: "whitespace",
            value: ""
          }))), n.push(e);
        }
      },
      punctuationPattern: Gy,
      getFencedCodeBlockValue: function (e, t) {
        const n = t.trimEnd().slice(e.position.start.offset, e.position.end.offset),
          r = n.match(/^\s*/)[0].length,
          u = new RegExp("^\\s{0,".concat(r, "}")),
          o = n.split("\n"),
          a = n[r],
          i = n.slice(r).match(new RegExp("^[".concat(a, "]+")))[0],
          s = new RegExp("^\\s{0,3}".concat(i)).test(o[o.length - 1].slice(l(o.length - 1)));
        return o.slice(1, s ? -1 : void 0).map((e, t) => e.slice(l(t + 1)).replace(u, "")).join("\n");
        function l(t) {
          return e.position.indent[t - 1] - 1;
        }
      },
      getOrderedListItemInfo: Qy,
      hasGitDiffFriendlyOrderedList: function (e, t) {
        if (!e.ordered) return !1;
        if (e.children.length < 2) return !1;
        const n = Number(Qy(e.children[0], t.originalText).numberText),
          r = Number(Qy(e.children[1], t.originalText).numberText);
        if (0 === n && e.children.length > 2) {
          const _n39 = Number(Qy(e.children[2], t.originalText).numberText);
          return 1 === r && 1 === _n39;
        }
        return 1 === r;
      },
      INLINE_NODE_TYPES: Hy,
      INLINE_NODE_WRAPPER_TYPES: Xy,
      isAutolink: function (e, t) {
        if (!e || "link" !== e.type || 1 !== e.children.length) return !1;
        const n = e.children[0];
        return n && t.locStart(e) === t.locStart(n) && t.locEnd(e) === t.locEnd(n);
      }
    };
    const {
        getParserName: eE,
        getMaxContinuousCount: tE
      } = Lt,
      {
        builders: {
          hardline: nE,
          concat: rE,
          markAsRoot: uE
        },
        utils: {
          replaceNewlinesWithLiterallines: oE
        }
      } = dn,
      {
        print: aE
      } = Em,
      {
        getFencedCodeBlockValue: iE
      } = Zy;
    var sE = function (e, t, n, r) {
      const u = e.getValue();
      if ("code" === u.type && null !== u.lang) {
        const _e128 = u.lang.match(/^[\w-]+/),
          _t80 = _e128 ? _e128[0] : "",
          o = eE(_t80, r);
        if (o) {
          const _e129 = r.__inJsTemplate ? "~" : "`",
            _t81 = _e129.repeat(Math.max(3, tE(u.value, _e129) + 1)),
            a = n(iE(u, r.originalText), {
              parser: o
            }, {
              stripTrailingHardline: !0
            });
          return uE(rE([_t81, u.lang, u.meta ? " " + u.meta : "", nE, oE(a), nE, _t81]));
        }
      }
      switch (u.type) {
        case "front-matter":
          return aE(u, n);
        case "importExport":
          return rE([n(u.value, {
            parser: "babel"
          }, {
            stripTrailingHardline: !0
          }), nE]);
        case "jsx":
          return n("<$>".concat(u.value, "</$>"), {
            parser: "__js_expression",
            rootMarker: "mdx"
          }, {
            stripTrailingHardline: !0
          });
      }
      return null;
    };
    const {
        parse: lE
      } = Em,
      cE = ["format", "prettier"];
    function pE(e) {
      const t = "@(".concat(cE.join("|"), ")"),
        n = new RegExp(["\x3c!--\\s*".concat(t, "\\s*--\x3e"), "\x3c!--.*\r?\n[\\s\\S]*(^|\n)[^\\S\n]*".concat(t, "[^\\S\n]*($|\n)[\\s\\S]*\n.*--\x3e")].join("|"), "m"),
        r = e.match(n);
      return r && 0 === r.index;
    }
    var dE = {
      startWithPragma: pE,
      hasPragma: e => pE(lE(e).content.trimStart()),
      insertPragma: e => {
        const t = lE(e),
          n = "\x3c!-- @".concat(cE[0], " --\x3e");
        return t.frontMatter ? "".concat(t.frontMatter.raw, "\n\n").concat(n, "\n\n").concat(t.content) : "".concat(n, "\n\n").concat(t.content);
      }
    };
    const {
        getOrderedListItemInfo: fE,
        mapAst: hE,
        splitText: mE
      } = Zy,
      gE = /^([\u0000-\uffff]|[\ud800-\udbff][\udc00-\udfff])$/;
    function DE(e, t, n) {
      return hE(e, e => {
        if (!e.children) return e;
        const r = e.children.reduce((e, r) => {
          const u = e[e.length - 1];
          return u && t(u, r) ? e.splice(-1, 1, n(u, r)) : e.push(r), e;
        }, []);
        return Object.assign({}, e, {
          children: r
        });
      });
    }
    var yE = function (e, t) {
      return e = function (e) {
        return DE(e, (e, t) => "importExport" === e.type && "importExport" === t.type, (e, t) => ({
          type: "importExport",
          value: e.value + "\n\n" + t.value,
          position: {
            start: e.position.start,
            end: t.position.end
          }
        }));
      }(e = function (e) {
        return hE(e, e => "import" !== e.type && "export" !== e.type ? e : Object.assign({}, e, {
          type: "importExport"
        }));
      }(e = function (e, t) {
        return hE(e, (e, n, [r]) => {
          if ("text" !== e.type) return e;
          let {
            value: u
          } = e;
          return "paragraph" === r.type && (0 === n && (u = u.trimStart()), n === r.children.length - 1 && (u = u.trimEnd())), {
            type: "sentence",
            position: e.position,
            children: mE(u, t)
          };
        });
      }(e = function (e, t) {
        return hE(e, (e, t, n) => {
          if ("list" === e.type && 0 !== e.children.length) {
            for (let _t82 = 0; _t82 < n.length; _t82++) {
              const r = n[_t82];
              if ("list" === r.type && !r.isAligned) return e.isAligned = !1, e;
            }
            e.isAligned = r(e);
          }
          return e;
        });
        function n(e) {
          return 0 === e.children.length ? -1 : e.children[0].position.start.column - 1;
        }
        function r(e) {
          if (!e.ordered) return !0;
          const [r, u] = e.children;
          if (fE(r, t.originalText).leadingSpaces.length > 1) return !0;
          const o = n(r);
          if (-1 === o) return !1;
          if (1 === e.children.length) return o % t.tabWidth == 0;
          if (o !== n(u)) return !1;
          if (o % t.tabWidth == 0) return !0;
          return fE(u, t.originalText).leadingSpaces.length > 1;
        }
      }(e = function (e, t) {
        return hE(e, (e, n, r) => {
          if ("code" === e.type) {
            const _n40 = /^\n?( {4,}|\t)/.test(t.originalText.slice(e.position.start.offset, e.position.end.offset));
            if (e.isIndented = _n40, _n40) for (let _e130 = 0; _e130 < r.length; _e130++) {
              const t = r[_e130];
              if (t.hasIndentedCodeblock) break;
              "list" === t.type && (t.hasIndentedCodeblock = !0);
            }
          }
          return e;
        });
      }(e = function (e) {
        return hE(e, e => "inlineCode" !== e.type ? e : Object.assign({}, e, {
          value: e.value.replace(/\s+/g, " ")
        }));
      }(e = function (e) {
        return DE(e, (e, t) => "text" === e.type && "text" === t.type, (e, t) => ({
          type: "text",
          value: e.value + t.value,
          position: {
            start: e.position.start,
            end: t.position.end
          }
        }));
      }(e = function (e, t) {
        return hE(e, e => "text" !== e.type ? e : Object.assign({}, e, {
          value: "*" !== e.value && "_" !== e.value && "$" !== e.value && gE.test(e.value) && e.position.end.offset - e.position.start.offset !== e.value.length ? t.originalText.slice(e.position.start.offset, e.position.end.offset) : e.value
        }));
      }(e, t))), t), t), t)));
    };
    const {
        getLast: EE,
        getMinNotPresentContinuousCount: CE,
        getMaxContinuousCount: bE,
        getStringWidth: AE
      } = Lt,
      {
        builders: {
          breakParent: vE,
          concat: FE,
          join: xE,
          line: SE,
          literalline: wE,
          markAsRoot: BE,
          hardline: TE,
          softline: kE,
          ifBreak: NE,
          fill: OE,
          align: PE,
          indent: _E,
          group: IE
        },
        utils: {
          normalizeDoc: jE
        },
        printer: {
          printDocToString: ME
        }
      } = dn,
      {
        replaceEndOfLineWith: LE,
        isFrontMatterNode: RE
      } = Lt,
      {
        getFencedCodeBlockValue: qE,
        hasGitDiffFriendlyOrderedList: VE,
        splitText: WE,
        punctuationPattern: $E,
        INLINE_NODE_TYPES: UE,
        INLINE_NODE_WRAPPER_TYPES: zE,
        isAutolink: JE
      } = Zy,
      GE = new Set(["importExport"]),
      HE = ["heading", "tableCell", "link"],
      XE = new Set(["listItem", "definition", "footnoteDefinition"]);
    function YE(e, t, n, r) {
      const u = e.getValue(),
        o = null === u.checked ? "" : u.checked ? "[x] " : "[ ] ";
      return FE([o, nC(e, t, n, {
        processor: (e, u) => {
          if (0 === u && "list" !== e.getValue().type) return PE(" ".repeat(o.length), e.call(n));
          const a = " ".repeat((i = t.tabWidth - r.length, l = 3, i < (s = 0) ? s : i > l ? l : i));
          var i, s, l;
          return FE([a, PE(a, e.call(n))]);
        }
      })]);
    }
    function KE(e, t) {
      return function (e, t, n) {
        n = n || (() => !0);
        let r = -1;
        for (const u of t.children) if (u.type === e.type && n(u) ? r++ : r = -1, u === e) return r;
      }(e, t, t => t.ordered === e.ordered);
    }
    function QE(e, t) {
      const n = [].concat(t);
      let r,
        u = -1;
      for (; r = e.getParentNode(++u);) if (n.includes(r.type)) return u;
      return -1;
    }
    function ZE(e, t) {
      const n = QE(e, t);
      return -1 === n ? null : e.getParentNode(n);
    }
    function eC(e, t, n) {
      if ("preserve" === n.proseWrap && "\n" === t) return TE;
      const r = "always" === n.proseWrap && !ZE(e, HE);
      return "" !== t ? r ? SE : " " : r ? kE : "";
    }
    function tC(e, t, n) {
      const r = [];
      let u = null;
      const {
        children: o
      } = e.getValue();
      return o.forEach((e, t) => {
        switch (uC(e)) {
          case "start":
            null === u && (u = {
              index: t,
              offset: e.position.end.offset
            });
            break;
          case "end":
            null !== u && (r.push({
              start: u,
              end: {
                index: t,
                offset: e.position.start.offset
              }
            }), u = null);
        }
      }), nC(e, t, n, {
        processor: (e, u) => {
          if (0 !== r.length) {
            const _e131 = r[0];
            if (u === _e131.start.index) return FE([o[_e131.start.index].value, t.originalText.slice(_e131.start.offset, _e131.end.offset), o[_e131.end.index].value]);
            if (_e131.start.index < u && u < _e131.end.index) return !1;
            if (u === _e131.end.index) return r.shift(), !1;
          }
          return e.call(n);
        }
      });
    }
    function nC(e, t, n, r) {
      const u = (r = r || {}).postprocessor || FE,
        o = r.processor || (e => e.call(n)),
        a = e.getValue(),
        i = [];
      let s;
      return e.map((e, n) => {
        const r = e.getValue(),
          u = o(e, n);
        if (!1 !== u) {
          const _e132 = {
            parts: i,
            prevNode: s,
            parentNode: a,
            options: t
          };
          (function (e, t) {
            const n = 0 === t.parts.length,
              r = UE.includes(e.type),
              u = "html" === e.type && zE.includes(t.parentNode.type);
            return n || r || u;
          })(r, _e132) || (i.push(TE), s && GE.has(s.type) || (function (e, t) {
            const n = (t.prevNode && t.prevNode.type) === e.type && XE.has(e.type),
              r = "listItem" === t.parentNode.type && !t.parentNode.loose,
              u = t.prevNode && "listItem" === t.prevNode.type && t.prevNode.loose,
              o = "next" === uC(t.prevNode),
              a = "html" === e.type && t.prevNode && "html" === t.prevNode.type && t.prevNode.position.end.line + 1 === e.position.start.line,
              i = "html" === e.type && "listItem" === t.parentNode.type && t.prevNode && "paragraph" === t.prevNode.type && t.prevNode.position.end.line + 1 === e.position.start.line;
            return u || !(n || r || o || a || i);
          }(r, _e132) || oC(r, _e132)) && i.push(TE), oC(r, _e132) && i.push(TE)), i.push(u), s = r;
        }
      }, "children"), u(i);
    }
    function rC(e) {
      let t = e;
      for (; t.children && 0 !== t.children.length;) t = t.children[t.children.length - 1];
      return t;
    }
    function uC(e) {
      if ("html" !== e.type) return !1;
      const t = e.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
      return null !== t && (t[1] ? t[1] : "next");
    }
    function oC(e, t) {
      const n = t.prevNode && "list" === t.prevNode.type,
        r = "code" === e.type && e.isIndented;
      return n && r;
    }
    function aC(e, t) {
      const n = [" "].concat(t || []);
      return new RegExp(n.map(e => "\\".concat(e)).join("|")).test(e) ? "<".concat(e, ">") : e;
    }
    function iC(e, t, n) {
      if (null == n && (n = !0), !e) return "";
      if (n) return " " + iC(e, t, !1);
      if ((e = e.replace(/\\(["')])/g, "$1")).includes('"') && e.includes("'") && !e.includes(")")) return "(".concat(e, ")");
      const r = e.split("'").length - 1,
        u = e.split('"').length - 1,
        o = r > u ? '"' : u > r || t.singleQuote ? "'" : '"';
      return e = (e = e.replace(/\\/, "\\\\")).replace(new RegExp("(".concat(o, ")"), "g"), "\\$1"), "".concat(o).concat(e).concat(o);
    }
    var sC = {
        preprocess: yE,
        print: function (e, t, n) {
          const r = e.getValue();
          if (function (e) {
            const t = ZE(e, ["linkReference", "imageReference"]);
            return t && ("linkReference" !== t.type || "full" !== t.referenceType);
          }(e)) return FE(WE(t.originalText.slice(r.position.start.offset, r.position.end.offset), t).map(n => "word" === n.type ? n.value : "" === n.value ? "" : eC(e, n.value, t)));
          switch (r.type) {
            case "front-matter":
              return t.originalText.slice(r.position.start.offset, r.position.end.offset);
            case "root":
              return 0 === r.children.length ? "" : FE([jE(tC(e, t, n)), GE.has(rC(r).type) ? "" : TE]);
            case "paragraph":
              return nC(e, t, n, {
                postprocessor: OE
              });
            case "sentence":
              return nC(e, t, n);
            case "word":
              {
                let _n41 = r.value.replace(/[$*]/g, "\\$&").replace(new RegExp(["(^|".concat($E, ")(_+)"), "(_+)(".concat($E, "|$)")].join("|"), "g"), (e, t, n, r, u) => (n ? "".concat(t).concat(n) : "".concat(r).concat(u)).replace(/_/g, "\\_"));
                const u = (e, t, n) => "sentence" === e.type && 0 === n,
                  o = (e, n, r) => JE(e.children[r - 1], t);
                return _n41 !== r.value && (e.match(void 0, u, o) || e.match(void 0, u, (e, t, n) => "emphasis" === e.type && 0 === n, o)) && (_n41 = _n41.replace(/^(\\?[*_])+/, e => e.replace(/\\/g, ""))), _n41;
              }
            case "whitespace":
              {
                const _n42 = e.getParentNode(),
                  u = _n42.children.indexOf(r),
                  o = _n42.children[u + 1],
                  a = o && /^>|^([*+-]|#{1,6}|\d+[).])$/.test(o.value) ? "never" : t.proseWrap;
                return eC(e, r.value, {
                  proseWrap: a
                });
              }
            case "emphasis":
              {
                let u;
                if (JE(r.children[0], t)) u = t.originalText[r.position.start.offset];else {
                  const _t83 = e.getParentNode(),
                    _n43 = _t83.children.indexOf(r),
                    o = _t83.children[_n43 - 1],
                    a = _t83.children[_n43 + 1];
                  u = o && "sentence" === o.type && o.children.length > 0 && "word" === EE(o.children).type && !EE(o.children).hasTrailingPunctuation || a && "sentence" === a.type && a.children.length > 0 && "word" === a.children[0].type && !a.children[0].hasLeadingPunctuation || ZE(e, "emphasis") ? "*" : "_";
                }
                return FE([u, nC(e, t, n), u]);
              }
            case "strong":
              return FE(["**", nC(e, t, n), "**"]);
            case "delete":
              return FE(["~~", nC(e, t, n), "~~"]);
            case "inlineCode":
              {
                const _e133 = CE(r.value, "`"),
                  _t84 = "`".repeat(_e133 || 1),
                  _n44 = _e133 && !/^\s/.test(r.value) ? " " : "";
                return FE([_t84, _n44, r.value, _n44, _t84]);
              }
            case "link":
              switch (t.originalText[r.position.start.offset]) {
                case "<":
                  {
                    const _e134 = "mailto:",
                      _n45 = r.url.startsWith(_e134) && t.originalText.slice(r.position.start.offset + 1, r.position.start.offset + 1 + _e134.length) !== _e134 ? r.url.slice(_e134.length) : r.url;
                    return FE(["<", _n45, ">"]);
                  }
                case "[":
                  return FE(["[", nC(e, t, n), "](", aC(r.url, ")"), iC(r.title, t), ")"]);
                default:
                  return t.originalText.slice(r.position.start.offset, r.position.end.offset);
              }
            case "image":
              return FE(["![", r.alt || "", "](", aC(r.url, ")"), iC(r.title, t), ")"]);
            case "blockquote":
              return FE(["> ", PE("> ", nC(e, t, n))]);
            case "heading":
              return FE(["#".repeat(r.depth) + " ", nC(e, t, n)]);
            case "code":
              {
                if (r.isIndented) {
                  const _e135 = " ".repeat(4);
                  return PE(_e135, FE([_e135, FE(LE(r.value, TE))]));
                }
                const _e136 = t.__inJsTemplate ? "~" : "`",
                  _n46 = _e136.repeat(Math.max(3, bE(r.value, _e136) + 1));
                return FE([_n46, r.lang || "", r.meta ? " " + r.meta : "", TE, FE(LE(qE(r, t.originalText), TE)), TE, _n46]);
              }
            case "html":
              {
                const _t85 = e.getParentNode(),
                  _n47 = "root" === _t85.type && EE(_t85.children) === r ? r.value.trimEnd() : r.value,
                  u = /^<!--[\S\s]*-->$/.test(_n47);
                return FE(LE(_n47, u ? TE : BE(wE)));
              }
            case "list":
              {
                const u = KE(r, e.getParentNode()),
                  o = VE(r, t);
                return nC(e, t, n, {
                  processor: (e, a) => {
                    const i = function () {
                        const e = r.ordered ? (0 === a ? r.start : o ? 1 : r.start + a) + (u % 2 == 0 ? ". " : ") ") : u % 2 == 0 ? "- " : "* ";
                        return r.isAligned || r.hasIndentedCodeblock ? function (e, t) {
                          const n = r();
                          return e + " ".repeat(n >= 4 ? 0 : n);
                          function r() {
                            const n = e.length % t.tabWidth;
                            return 0 === n ? 0 : t.tabWidth - n;
                          }
                        }(e, t) : e;
                      }(),
                      s = e.getValue();
                    return 2 === s.children.length && "html" === s.children[1].type && s.children[0].position.start.column !== s.children[1].position.start.column ? FE([i, YE(e, t, n, i)]) : FE([i, PE(" ".repeat(i.length), YE(e, t, n, i))]);
                  }
                });
              }
            case "thematicBreak":
              {
                const _t86 = QE(e, "list");
                if (-1 === _t86) return "---";
                return KE(e.getParentNode(_t86), e.getParentNode(_t86 + 1)) % 2 == 0 ? "***" : "---";
              }
            case "linkReference":
              return FE(["[", nC(e, t, n), "]", "full" === r.referenceType ? FE(["[", r.identifier, "]"]) : "collapsed" === r.referenceType ? "[]" : ""]);
            case "imageReference":
              switch (r.referenceType) {
                case "full":
                  return FE(["![", r.alt || "", "][", r.identifier, "]"]);
                default:
                  return FE(["![", r.alt, "]", "collapsed" === r.referenceType ? "[]" : ""]);
              }
            case "definition":
              {
                const _e137 = "always" === t.proseWrap ? SE : " ";
                return IE(FE([FE(["[", r.identifier, "]:"]), _E(FE([_e137, aC(r.url), null === r.title ? "" : FE([_e137, iC(r.title, t, !1)])]))]));
              }
            case "footnote":
              return FE(["[^", nC(e, t, n), "]"]);
            case "footnoteReference":
              return FE(["[^", r.identifier, "]"]);
            case "footnoteDefinition":
              {
                const u = e.getParentNode().children[e.getName() + 1],
                  o = 1 === r.children.length && "paragraph" === r.children[0].type && ("never" === t.proseWrap || "preserve" === t.proseWrap && r.children[0].position.start.line === r.children[0].position.end.line);
                return FE(["[^", r.identifier, "]: ", o ? nC(e, t, n) : IE(FE([PE(" ".repeat(4), nC(e, t, n, {
                  processor: (e, t) => 0 === t ? IE(FE([kE, e.call(n)])) : e.call(n)
                })), u && "footnoteDefinition" === u.type ? kE : ""]))]);
              }
            case "table":
              return function (e, t, n) {
                const r = TE.parts[0],
                  u = e.getValue(),
                  o = [];
                e.map(e => {
                  const r = [];
                  e.map(e => {
                    r.push(ME(e.call(n), t).formatted);
                  }, "children"), o.push(r);
                }, "children");
                const a = o.reduce((e, t) => e.map((e, n) => Math.max(e, AE(t[n]))), o[0].map(() => 3)),
                  i = xE(r, [c(o[0]), l(), xE(r, o.slice(1).map(e => c(e)))]);
                if ("never" !== t.proseWrap) return FE([vE, i]);
                const s = xE(r, [c(o[0], !0), l(!0), xE(r, o.slice(1).map(e => c(e, !0)))]);
                return FE([vE, IE(NE(s, i))]);
                function l(e) {
                  return FE(["| ", xE(" | ", a.map((t, n) => {
                    const r = e ? 3 : t;
                    switch (u.align[n]) {
                      case "left":
                        return ":" + "-".repeat(r - 1);
                      case "right":
                        return "-".repeat(r - 1) + ":";
                      case "center":
                        return ":" + "-".repeat(r - 2) + ":";
                      default:
                        return "-".repeat(r);
                    }
                  })), " |"]);
                }
                function c(e, t) {
                  return FE(["| ", xE(" | ", t ? e : e.map((e, t) => {
                    switch (u.align[t]) {
                      case "right":
                        return d(e, a[t]);
                      case "center":
                        return f(e, a[t]);
                      default:
                        return p(e, a[t]);
                    }
                  })), " |"]);
                }
                function p(e, t) {
                  const n = t - AE(e);
                  return FE([e, " ".repeat(n)]);
                }
                function d(e, t) {
                  const n = t - AE(e);
                  return FE([" ".repeat(n), e]);
                }
                function f(e, t) {
                  const n = t - AE(e),
                    r = Math.floor(n / 2),
                    u = n - r;
                  return FE([" ".repeat(r), e, " ".repeat(u)]);
                }
              }(e, t, n);
            case "tableCell":
              return nC(e, t, n);
            case "break":
              return /\s/.test(t.originalText[r.position.start.offset]) ? FE(["  ", BE(wE)]) : FE(["\\", TE]);
            case "liquidNode":
              return FE(LE(r.value, TE));
            case "importExport":
            case "jsx":
              return FE([r.value, TE]);
            case "math":
              return FE(["$$", TE, r.value ? FE([FE(LE(r.value, TE)), TE]) : "", "$$"]);
            case "inlineMath":
              return t.originalText.slice(t.locStart(r), t.locEnd(r));
            case "tableRow":
            case "listItem":
            default:
              throw new Error("Unknown markdown type ".concat(JSON.stringify(r.type)));
          }
        },
        embed: sE,
        massageAstNode: function (e, t, n) {
          return delete t.position, delete t.raw, "front-matter" !== e.type && "code" !== e.type && "yaml" !== e.type && "import" !== e.type && "export" !== e.type && "jsx" !== e.type || delete t.value, "list" === e.type && delete t.isAligned, "list" !== e.type && "listItem" !== e.type || (delete t.spread, delete t.loose), "text" === e.type ? null : ("inlineCode" === e.type && (t.value = e.value.replace(/[\t\n ]+/g, " ")), "definition" !== e.type && "linkReference" !== e.type || (t.label = e.label.trim().replace(/[\t\n ]+/g, " ").toLowerCase()), "definition" !== e.type && "link" !== e.type && "image" !== e.type || !e.title || (t.title = e.title.replace(/\\(["')])/g, "$1")), n && "root" === n.type && n.children.length > 0 && (n.children[0] === e || RE(n.children[0]) && n.children[1] === e) && "html" === e.type && dE.startWithPragma(e.value) ? null : void 0);
        },
        hasPrettierIgnore: function (e) {
          const t = +e.getName();
          return 0 !== t && "next" === uC(e.getParentNode().children[t - 1]);
        },
        insertPragma: dE.insertPragma
      },
      lC = {
        proseWrap: Bh.proseWrap,
        singleQuote: Bh.singleQuote
      },
      cC = ["pandoc"],
      pC = [".md", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".workbook"],
      dC = ["contents.lr"],
      fC = {
        name: "Markdown",
        type: "prose",
        aliases: cC,
        aceMode: "markdown",
        codemirrorMode: "gfm",
        codemirrorMimeType: "text/x-gfm",
        wrap: true,
        extensions: pC,
        filenames: dC,
        tmScope: "source.gfm",
        languageId: 222
      },
      hC = Ue(Object.freeze({
        __proto__: null,
        name: "Markdown",
        type: "prose",
        aliases: cC,
        aceMode: "markdown",
        codemirrorMode: "gfm",
        codemirrorMimeType: "text/x-gfm",
        wrap: true,
        extensions: pC,
        filenames: dC,
        tmScope: "source.gfm",
        languageId: 222,
        default: fC
      }));
    var mC = {
      languages: [As(hC, e => ({
        since: "1.8.0",
        parsers: ["markdown"],
        vscodeLanguageIds: ["markdown"],
        filenames: e.filenames.concat(["README"]),
        extensions: e.extensions.filter(e => ".mdx" !== e)
      })), As(hC, () => ({
        name: "MDX",
        since: "1.15.0",
        parsers: ["mdx"],
        vscodeLanguageIds: ["mdx"],
        filenames: [],
        extensions: [".mdx"]
      }))],
      options: lC,
      printers: {
        mdast: sC
      },
      parsers: {
        get remark() {
          return {}.parsers.remark;
        },
        get markdown() {
          return {}.parsers.remark;
        },
        get mdx() {
          return {}.parsers.mdx;
        }
      }
    };
    const {
      isFrontMatterNode: gC
    } = Lt;
    var DC = Object.freeze({
        __proto__: null,
        default: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"]
      }),
      yC = ["accesskey", "charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "tabindex", "target", "type"],
      EC = ["title"],
      CC = ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"],
      bC = ["accesskey", "alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "tabindex", "target", "type"],
      AC = ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"],
      vC = ["href", "target"],
      FC = ["color", "face", "size"],
      xC = ["dir"],
      SC = ["cite"],
      wC = ["alink", "background", "bgcolor", "link", "text", "vlink"],
      BC = ["clear"],
      TC = ["accesskey", "autofocus", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "tabindex", "type", "value"],
      kC = ["height", "width"],
      NC = ["align"],
      OC = ["align", "char", "charoff", "span", "valign", "width"],
      PC = ["align", "char", "charoff", "span", "valign", "width"],
      _C = ["value"],
      IC = ["cite", "datetime"],
      jC = ["open"],
      MC = ["title"],
      LC = ["open"],
      RC = ["compact"],
      qC = ["align"],
      VC = ["compact"],
      WC = ["height", "src", "type", "width"],
      $C = ["disabled", "form", "name"],
      UC = ["color", "face", "size"],
      zC = ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"],
      JC = ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"],
      GC = ["cols", "rows"],
      HC = ["align"],
      XC = ["align"],
      YC = ["align"],
      KC = ["align"],
      QC = ["align"],
      ZC = ["align"],
      eb = ["profile"],
      tb = ["align", "noshade", "size", "width"],
      nb = ["manifest", "version"],
      rb = ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"],
      ub = ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"],
      ob = ["accept", "accesskey", "align", "alt", "autocomplete", "autofocus", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "tabindex", "title", "type", "usemap", "value", "width"],
      ab = ["cite", "datetime"],
      ib = ["prompt"],
      sb = ["accesskey", "for", "form"],
      lb = ["accesskey", "align"],
      cb = ["type", "value"],
      pb = ["as", "charset", "color", "crossorigin", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "nonce", "referrerpolicy", "rel", "rev", "sizes", "target", "title", "type"],
      db = ["name"],
      fb = ["compact"],
      hb = ["charset", "content", "http-equiv", "name", "scheme"],
      mb = ["high", "low", "max", "min", "optimum", "value"],
      gb = ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "tabindex", "type", "typemustmatch", "usemap", "vspace", "width"],
      Db = ["compact", "reversed", "start", "type"],
      yb = ["disabled", "label"],
      Eb = ["disabled", "label", "selected", "value"],
      Cb = ["for", "form", "name"],
      bb = ["align"],
      Ab = ["name", "type", "value", "valuetype"],
      vb = ["width"],
      Fb = ["max", "value"],
      xb = ["cite"],
      Sb = ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "nonce", "referrerpolicy", "src", "type"],
      wb = ["autocomplete", "autofocus", "disabled", "form", "multiple", "name", "required", "size", "tabindex"],
      Bb = ["name"],
      Tb = ["media", "sizes", "src", "srcset", "type"],
      kb = ["media", "nonce", "title", "type"],
      Nb = ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"],
      Ob = ["align", "char", "charoff", "valign"],
      Pb = ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"],
      _b = ["accesskey", "autocomplete", "autofocus", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "tabindex", "wrap"],
      Ib = ["align", "char", "charoff", "valign"],
      jb = ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"],
      Mb = ["align", "char", "charoff", "valign"],
      Lb = ["datetime"],
      Rb = ["align", "bgcolor", "char", "charoff", "valign"],
      qb = ["default", "kind", "label", "src", "srclang"],
      Vb = ["compact", "type"],
      Wb = ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"],
      $b = {
        "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"],
        a: yC,
        abbr: EC,
        applet: CC,
        area: bC,
        audio: AC,
        base: vC,
        basefont: FC,
        bdo: xC,
        blockquote: SC,
        body: wC,
        br: BC,
        button: TC,
        canvas: kC,
        caption: NC,
        col: OC,
        colgroup: PC,
        data: _C,
        del: IC,
        details: jC,
        dfn: MC,
        dialog: LC,
        dir: RC,
        div: qC,
        dl: VC,
        embed: WC,
        fieldset: $C,
        font: UC,
        form: zC,
        frame: JC,
        frameset: GC,
        h1: HC,
        h2: XC,
        h3: YC,
        h4: KC,
        h5: QC,
        h6: ZC,
        head: eb,
        hr: tb,
        html: nb,
        iframe: rb,
        img: ub,
        input: ob,
        ins: ab,
        isindex: ib,
        label: sb,
        legend: lb,
        li: cb,
        link: pb,
        map: db,
        menu: fb,
        meta: hb,
        meter: mb,
        object: gb,
        ol: Db,
        optgroup: yb,
        option: Eb,
        output: Cb,
        p: bb,
        param: Ab,
        pre: vb,
        progress: Fb,
        q: xb,
        script: Sb,
        select: wb,
        slot: Bb,
        source: Tb,
        style: kb,
        table: Nb,
        tbody: Ob,
        td: Pb,
        textarea: _b,
        tfoot: Ib,
        th: jb,
        thead: Mb,
        time: Lb,
        tr: Rb,
        track: qb,
        ul: Vb,
        video: Wb
      },
      Ub = Object.freeze({
        __proto__: null,
        a: yC,
        abbr: EC,
        applet: CC,
        area: bC,
        audio: AC,
        base: vC,
        basefont: FC,
        bdo: xC,
        blockquote: SC,
        body: wC,
        br: BC,
        button: TC,
        canvas: kC,
        caption: NC,
        col: OC,
        colgroup: PC,
        data: _C,
        del: IC,
        details: jC,
        dfn: MC,
        dialog: LC,
        dir: RC,
        div: qC,
        dl: VC,
        embed: WC,
        fieldset: $C,
        font: UC,
        form: zC,
        frame: JC,
        frameset: GC,
        h1: HC,
        h2: XC,
        h3: YC,
        h4: KC,
        h5: QC,
        h6: ZC,
        head: eb,
        hr: tb,
        html: nb,
        iframe: rb,
        img: ub,
        input: ob,
        ins: ab,
        isindex: ib,
        label: sb,
        legend: lb,
        li: cb,
        link: pb,
        map: db,
        menu: fb,
        meta: hb,
        meter: mb,
        object: gb,
        ol: Db,
        optgroup: yb,
        option: Eb,
        output: Cb,
        p: bb,
        param: Ab,
        pre: vb,
        progress: Fb,
        q: xb,
        script: Sb,
        select: wb,
        slot: Bb,
        source: Tb,
        style: kb,
        table: Nb,
        tbody: Ob,
        td: Pb,
        textarea: _b,
        tfoot: Ib,
        th: jb,
        thead: Mb,
        time: Lb,
        tr: Rb,
        track: qb,
        ul: Vb,
        video: Wb,
        default: $b
      }),
      zb = Ue(DC),
      Jb = Ue(Ub);
    const {
        getParserName: Gb,
        isFrontMatterNode: Hb
      } = Lt,
      {
        CSS_DISPLAY_TAGS: Xb,
        CSS_DISPLAY_DEFAULT: Yb,
        CSS_WHITE_SPACE_TAGS: Kb,
        CSS_WHITE_SPACE_DEFAULT: Qb
      } = {
        CSS_DISPLAY_TAGS: {
          area: "none",
          base: "none",
          basefont: "none",
          datalist: "none",
          head: "none",
          link: "none",
          meta: "none",
          noembed: "none",
          noframes: "none",
          param: "block",
          rp: "none",
          script: "block",
          source: "block",
          style: "none",
          template: "inline",
          track: "block",
          title: "none",
          html: "block",
          body: "block",
          address: "block",
          blockquote: "block",
          center: "block",
          div: "block",
          figure: "block",
          figcaption: "block",
          footer: "block",
          form: "block",
          header: "block",
          hr: "block",
          legend: "block",
          listing: "block",
          main: "block",
          p: "block",
          plaintext: "block",
          pre: "block",
          xmp: "block",
          slot: "contents",
          ruby: "ruby",
          rt: "ruby-text",
          article: "block",
          aside: "block",
          h1: "block",
          h2: "block",
          h3: "block",
          h4: "block",
          h5: "block",
          h6: "block",
          hgroup: "block",
          nav: "block",
          section: "block",
          dir: "block",
          dd: "block",
          dl: "block",
          dt: "block",
          ol: "block",
          ul: "block",
          li: "list-item",
          table: "table",
          caption: "table-caption",
          colgroup: "table-column-group",
          col: "table-column",
          thead: "table-header-group",
          tbody: "table-row-group",
          tfoot: "table-footer-group",
          tr: "table-row",
          td: "table-cell",
          th: "table-cell",
          fieldset: "block",
          button: "inline-block",
          details: "block",
          summary: "block",
          dialog: "block",
          meter: "inline-block",
          progress: "inline-block",
          object: "inline-block",
          video: "inline-block",
          audio: "inline-block",
          select: "inline-block",
          option: "block",
          optgroup: "block"
        },
        CSS_DISPLAY_DEFAULT: "inline",
        CSS_WHITE_SPACE_TAGS: {
          listing: "pre",
          plaintext: "pre",
          pre: "pre",
          xmp: "pre",
          nobr: "nowrap",
          table: "initial",
          textarea: "pre-wrap"
        },
        CSS_WHITE_SPACE_DEFAULT: "normal"
      },
      Zb = uA(zb),
      eA = function (e, t) {
        const n = Object.create(null);
        for (const r of Object.keys(e)) n[r] = t(e[r], r);
        return n;
      }(Jb, uA),
      tA = new Set(["\t", "\n", "\f", "\r", " "]),
      nA = e => e.replace(/[\t\n\f\r ]+$/, ""),
      rA = e => e.match(/^[\t\n\f\r ]*/)[0];
    function uA(e) {
      const t = Object.create(null);
      for (const n of e) t[n] = !0;
      return t;
    }
    function oA(e, t) {
      return !("ieConditionalComment" !== e.type || !e.lastChild || e.lastChild.isSelfClosing || e.lastChild.endSourceSpan) || "ieConditionalComment" === e.type && !e.complete || !(!DA(e) || !e.children.some(e => "text" !== e.type && "interpolation" !== e.type)) || !(!vA(e, t) || iA(e) || "interpolation" === e.type);
    }
    function aA(e) {
      if ("attribute" === e.type) return !1;
      if (!e.parent) return !1;
      if ("number" != typeof e.index || 0 === e.index) return !1;
      return function (e) {
        return "comment" === e.type && "prettier-ignore" === e.value.trim();
      }(e.parent.children[e.index - 1]);
    }
    function iA(e) {
      return "element" === e.type && ("script" === e.fullName || "style" === e.fullName || "svg:style" === e.fullName || yA(e) && ("script" === e.name || "style" === e.name));
    }
    function sA(e) {
      return EA(e).startsWith("pre");
    }
    function lA(e) {
      return "element" === e.type && 0 !== e.children.length && (["html", "head", "ul", "ol", "select"].includes(e.name) || e.cssDisplay.startsWith("table") && "table-cell" !== e.cssDisplay);
    }
    function cA(e) {
      return hA(e) || "element" === e.type && "br" === e.fullName || pA(e);
    }
    function pA(e) {
      return dA(e) && fA(e);
    }
    function dA(e) {
      return e.hasLeadingSpaces && (e.prev ? e.prev.sourceSpan.end.line < e.sourceSpan.start.line : "root" === e.parent.type || e.parent.startSourceSpan.end.line < e.sourceSpan.start.line);
    }
    function fA(e) {
      return e.hasTrailingSpaces && (e.next ? e.next.sourceSpan.start.line > e.sourceSpan.end.line : "root" === e.parent.type || e.parent.endSourceSpan && e.parent.endSourceSpan.start.line > e.sourceSpan.end.line);
    }
    function hA(e) {
      switch (e.type) {
        case "ieConditionalComment":
        case "comment":
        case "directive":
          return !0;
        case "element":
          return ["script", "select"].includes(e.name);
      }
      return !1;
    }
    function mA(e) {
      const {
        type: t,
        lang: n
      } = e.attrMap;
      return "module" === t || "text/javascript" === t || "text/babel" === t || "application/javascript" === t || "jsx" === n ? "babel" : "application/x-typescript" === t || "ts" === n || "tsx" === n ? "typescript" : "text/markdown" === t ? "markdown" : "text/html" === t ? "html" : t && (t.endsWith("json") || t.endsWith("importmap")) ? "json" : "text/x-handlebars-template" === t ? "glimmer" : void 0;
    }
    function gA(e) {
      return "block" === e || "list-item" === e || e.startsWith("table");
    }
    function DA(e) {
      return EA(e).startsWith("pre");
    }
    function yA(e) {
      return "element" === e.type && !e.hasExplicitNamespace && !["html", "svg"].includes(e.namespace);
    }
    function EA(e) {
      return "element" === e.type && (!e.namespace || yA(e)) && Kb[e.name] || Qb;
    }
    const CA = new Set(["template", "style", "script"]);
    function bA(e, t) {
      return AA(e, t) && !CA.has(e.fullName);
    }
    function AA(e, t) {
      return "vue" === t.parser && "element" === e.type && "root" === e.parent.type && "html" !== e.fullName.toLowerCase();
    }
    function vA(e, t) {
      return AA(e, t) && (bA(e, t) || e.attrMap.lang && "html" !== e.attrMap.lang);
    }
    var FA = {
      HTML_ELEMENT_ATTRIBUTES: eA,
      HTML_TAGS: Zb,
      htmlTrim: e => (e => e.replace(/^[\t\n\f\r ]+/, ""))(nA(e)),
      htmlTrimPreserveIndentation: e => (e => e.replace(/^[\t\f\r ]*?\n/g, ""))(nA(e)),
      splitByHtmlWhitespace: e => e.split(/[\t\n\f\r ]+/),
      hasHtmlWhitespace: e => /[\t\n\f\r ]/.test(e),
      getLeadingAndTrailingHtmlWhitespace: e => {
        const [, t, n, r] = e.match(/^([\t\n\f\r ]*)([\S\s]*?)([\t\n\f\r ]*)$/);
        return {
          leadingWhitespace: t,
          trailingWhitespace: r,
          text: n
        };
      },
      canHaveInterpolation: function (e) {
        return e.children && !iA(e);
      },
      countChars: function (e, t) {
        let n = 0;
        for (let r = 0; r < e.length; r++) e[r] === t && n++;
        return n;
      },
      countParents: function (e, t) {
        let n = 0;
        for (let r = e.stack.length - 1; r >= 0; r--) {
          const u = e.stack[r];
          u && "object" == typeof u && !Array.isArray(u) && t(u) && n++;
        }
        return n;
      },
      dedentString: function (e, t = function (e) {
        let t = 1 / 0;
        for (const n of e.split("\n")) {
          if (0 === n.length) continue;
          if (!tA.has(n[0])) return 0;
          const _e138 = rA(n).length;
          n.length !== _e138 && _e138 < t && (t = _e138);
        }
        return t === 1 / 0 ? 0 : t;
      }(e)) {
        return 0 === t ? e : e.split("\n").map(e => e.slice(t)).join("\n");
      },
      forceBreakChildren: lA,
      forceBreakContent: function (e) {
        return lA(e) || "element" === e.type && 0 !== e.children.length && (["body", "script", "style"].includes(e.name) || e.children.some(e => function (e) {
          return e.children && e.children.some(e => "text" !== e.type);
        }(e))) || e.firstChild && e.firstChild === e.lastChild && "text" !== e.firstChild.type && dA(e.firstChild) && (!e.lastChild.isTrailingSpaceSensitive || fA(e.lastChild));
      },
      forceNextEmptyLine: function (e) {
        return Hb(e) || e.next && e.sourceSpan.end && e.sourceSpan.end.line + 1 < e.next.sourceSpan.start.line;
      },
      getLastDescendant: function e(t) {
        return t.lastChild ? e(t.lastChild) : t;
      },
      getNodeCssStyleDisplay: function (e, t) {
        if (e.prev && "comment" === e.prev.type) {
          const _t87 = e.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
          if (_t87) return _t87[1];
        }
        let n = !1;
        if ("element" === e.type && "svg" === e.namespace) {
          if (!function (e, t) {
            let n = e;
            for (; n;) {
              if (t(n)) return !0;
              n = n.parent;
            }
            return !1;
          }(e, e => "svg:foreignObject" === e.fullName)) return "svg" === e.name ? "inline-block" : "block";
          n = !0;
        }
        switch (t.htmlWhitespaceSensitivity) {
          case "strict":
            return "inline";
          case "ignore":
            return "block";
          default:
            return "vue" === t.parser && e.parent && "root" === e.parent.type ? "block" : "element" === e.type && (!e.namespace || n || yA(e)) && Xb[e.name] || Yb;
        }
      },
      getNodeCssStyleWhiteSpace: EA,
      getPrettierIgnoreAttributeCommentData: function (e) {
        const t = e.trim().match(/^prettier-ignore-attribute(?:\s+([^]+))?$/);
        return !!t && (!t[1] || t[1].split(/\s+/));
      },
      hasPrettierIgnore: aA,
      inferScriptParser: function (e, t) {
        return "script" !== e.name || e.attrMap.src ? "style" === e.name ? function (e) {
          const {
            lang: t
          } = e.attrMap;
          return t && "postcss" !== t && "css" !== t ? "scss" === t ? "scss" : "less" === t ? "less" : void 0 : "css";
        }(e) : t && vA(e, t) ? mA(e) || !("src" in e.attrMap) && Gb(e.attrMap.lang, t) : void 0 : e.attrMap.lang || e.attrMap.type ? mA(e) : "babel";
      },
      isVueCustomBlock: bA,
      isVueNonHtmlBlock: vA,
      isDanglingSpaceSensitiveNode: function (e) {
        return !(t = e.cssDisplay, gA(t) || "inline-block" === t || iA(e));
        var t;
      },
      isIndentationSensitiveNode: sA,
      isLeadingSpaceSensitiveNode: function (e, t) {
        const n = function () {
          if (Hb(e)) return !1;
          if (("text" === e.type || "interpolation" === e.type) && e.prev && ("text" === e.prev.type || "interpolation" === e.prev.type)) return !0;
          if (!e.parent || "none" === e.parent.cssDisplay) return !1;
          if (DA(e.parent)) return !0;
          if (!e.prev && ("root" === e.parent.type || DA(e) && e.parent || iA(e.parent) || bA(e.parent, t) || (n = e.parent.cssDisplay, gA(n) || "inline-block" === n))) return !1;
          var n;
          if (e.prev && !function (e) {
            return !gA(e);
          }(e.prev.cssDisplay)) return !1;
          return !0;
        }();
        return n && !e.prev && e.parent && e.parent.tagDefinition && e.parent.tagDefinition.ignoreFirstLf ? "interpolation" === e.type : n;
      },
      isPreLikeNode: DA,
      isScriptLikeTag: iA,
      isTextLikeNode: function (e) {
        return "text" === e.type || "comment" === e.type;
      },
      isTrailingSpaceSensitiveNode: function (e, t) {
        return !Hb(e) && (!("text" !== e.type && "interpolation" !== e.type || !e.next || "text" !== e.next.type && "interpolation" !== e.next.type) || !(!e.parent || "none" === e.parent.cssDisplay) && (!!DA(e.parent) || !(!e.next && ("root" === e.parent.type || DA(e) && e.parent || iA(e.parent) || bA(e.parent, t) || (n = e.parent.cssDisplay, gA(n) || "inline-block" === n))) && !(e.next && !function (e) {
          return !gA(e);
        }(e.next.cssDisplay))));
        var n;
      },
      isWhitespaceSensitiveNode: function (e) {
        return iA(e) || "interpolation" === e.type || sA(e);
      },
      isUnknownNamespace: yA,
      preferHardlineAsLeadingSpaces: function (e) {
        return hA(e) || e.prev && cA(e.prev) || pA(e);
      },
      preferHardlineAsTrailingSpaces: cA,
      shouldNotPrintClosingTag: function (e, t) {
        return !e.isSelfClosing && !e.endSourceSpan && (aA(e) || oA(e.parent, t));
      },
      shouldPreserveContent: oA,
      unescapeQuoteEntities: function (e) {
        return e.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
      }
    };
    const {
        htmlTrim: xA,
        getLeadingAndTrailingHtmlWhitespace: SA,
        hasHtmlWhitespace: wA,
        canHaveInterpolation: BA,
        getNodeCssStyleDisplay: TA,
        isDanglingSpaceSensitiveNode: kA,
        isIndentationSensitiveNode: NA,
        isLeadingSpaceSensitiveNode: OA,
        isTrailingSpaceSensitiveNode: PA,
        isWhitespaceSensitiveNode: _A
      } = FA,
      IA = [function (e) {
        return e.map(e => {
          if ("element" === e.type && e.tagDefinition.ignoreFirstLf && 0 !== e.children.length && "text" === e.children[0].type && "\n" === e.children[0].value[0]) {
            const [t, ...n] = e.children;
            return e.clone({
              children: 1 === t.value.length ? n : [t.clone({
                value: t.value.slice(1)
              }), ...n]
            });
          }
          return e;
        });
      }, function (e) {
        const t = e => "element" === e.type && e.prev && "ieConditionalStartComment" === e.prev.type && e.prev.sourceSpan.end.offset === e.startSourceSpan.start.offset && e.firstChild && "ieConditionalEndComment" === e.firstChild.type && e.firstChild.sourceSpan.start.offset === e.startSourceSpan.end.offset;
        return e.map(e => {
          if (e.children) {
            const n = e.children.map(t);
            if (n.some(Boolean)) {
              const t = [];
              for (let r = 0; r < e.children.length; r++) {
                const u = e.children[r];
                if (!n[r + 1]) if (n[r]) {
                  const _e139 = u.prev,
                    _n48 = u.firstChild,
                    _r69 = u.sourceSpan.constructor,
                    o = new _r69(_e139.sourceSpan.start, _n48.sourceSpan.end),
                    a = new _r69(o.start, u.sourceSpan.end);
                  t.push(u.clone({
                    condition: _e139.condition,
                    sourceSpan: a,
                    startSourceSpan: o,
                    children: u.children.slice(1)
                  }));
                } else t.push(u);
              }
              return e.clone({
                children: t
              });
            }
          }
          return e;
        });
      }, function (e) {
        return function (e, t, n) {
          return e.map(e => {
            if (e.children) {
              const r = e.children.map(t);
              if (r.some(Boolean)) {
                const t = [];
                for (let u = 0; u < e.children.length; u++) {
                  const o = e.children[u];
                  if ("text" !== o.type && !r[u]) {
                    t.push(o);
                    continue;
                  }
                  const a = "text" === o.type ? o : o.clone({
                    type: "text",
                    value: n(o)
                  });
                  if (0 === t.length || "text" !== t[t.length - 1].type) {
                    t.push(a);
                    continue;
                  }
                  const i = t.pop(),
                    s = i.sourceSpan.constructor;
                  t.push(i.clone({
                    value: i.value + a.value,
                    sourceSpan: new s(i.sourceSpan.start, a.sourceSpan.end)
                  }));
                }
                return e.clone({
                  children: t
                });
              }
            }
            return e;
          });
        }(e, e => "cdata" === e.type, e => "<![CDATA[".concat(e.value, "]]>"));
      }, function (e, t) {
        if ("html" === t.parser) return e;
        const n = /{{([\S\s]+?)}}/g;
        return e.map(e => {
          if (!BA(e)) return e;
          const t = [];
          for (const r of e.children) {
            if ("text" !== r.type) {
              t.push(r);
              continue;
            }
            const _e140 = r.sourceSpan.constructor;
            let u = r.sourceSpan.start,
              o = null;
            const a = r.value.split(n);
            for (let n = 0; n < a.length; n++, u = o) {
              const _r70 = a[n];
              n % 2 != 0 ? (o = u.moveBy(_r70.length + 4), t.push({
                type: "interpolation",
                sourceSpan: new _e140(u, o),
                children: 0 === _r70.length ? [] : [{
                  type: "text",
                  value: _r70,
                  sourceSpan: new _e140(u.moveBy(2), o.moveBy(-2))
                }]
              })) : (o = u.moveBy(_r70.length), 0 !== _r70.length && t.push({
                type: "text",
                value: _r70,
                sourceSpan: new _e140(u, o)
              }));
            }
          }
          return e.clone({
            children: t
          });
        });
      }, function (e) {
        return e.map(e => {
          if (!e.children) return e;
          if (0 === e.children.length || 1 === e.children.length && "text" === e.children[0].type && 0 === xA(e.children[0].value).length) return e.clone({
            children: [],
            hasDanglingSpaces: 0 !== e.children.length
          });
          const t = _A(e),
            n = NA(e);
          return e.clone({
            isWhitespaceSensitive: t,
            isIndentationSensitive: n,
            children: e.children.reduce((e, n) => {
              if ("text" !== n.type || t) return e.concat(n);
              const r = [],
                {
                  leadingWhitespace: u,
                  text: o,
                  trailingWhitespace: a
                } = SA(n.value);
              u && r.push({
                type: "whitespace"
              });
              const i = n.sourceSpan.constructor;
              return o && r.push({
                type: "text",
                value: o,
                sourceSpan: new i(n.sourceSpan.start.moveBy(u.length), n.sourceSpan.end.moveBy(-a.length))
              }), a && r.push({
                type: "whitespace"
              }), e.concat(r);
            }, []).reduce((e, t, n, r) => {
              if ("whitespace" === t.type) return e;
              const u = 0 !== n && "whitespace" === r[n - 1].type,
                o = n !== r.length - 1 && "whitespace" === r[n + 1].type;
              return e.concat(Object.assign({}, t, {
                hasLeadingSpaces: u,
                hasTrailingSpaces: o
              }));
            }, [])
          });
        });
      }, function (e, t) {
        return e.map(e => Object.assign(e, {
          cssDisplay: TA(e, t)
        }));
      }, function (e) {
        return e.map(e => Object.assign(e, {
          isSelfClosing: !e.children || "element" === e.type && (e.tagDefinition.isVoid || e.startSourceSpan === e.endSourceSpan)
        }));
      }, function (e, t) {
        return e.map(e => "element" !== e.type ? e : Object.assign(e, {
          hasHtmComponentClosingTag: e.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(t.originalText.slice(e.endSourceSpan.start.offset, e.endSourceSpan.end.offset))
        }));
      }, function (e, t) {
        return e.map(e => e.children ? 0 === e.children.length ? e.clone({
          isDanglingSpaceSensitive: kA(e)
        }) : e.clone({
          children: e.children.map(e => Object.assign({}, e, {
            isLeadingSpaceSensitive: OA(e, t),
            isTrailingSpaceSensitive: PA(e, t)
          })).map((e, t, n) => Object.assign({}, e, {
            isLeadingSpaceSensitive: (0 === t || n[t - 1].isTrailingSpaceSensitive) && e.isLeadingSpaceSensitive,
            isTrailingSpaceSensitive: (t === n.length - 1 || n[t + 1].isLeadingSpaceSensitive) && e.isTrailingSpaceSensitive
          }))
        }) : e);
      }, function (e) {
        const t = e => "element" === e.type && 0 === e.attrs.length && 1 === e.children.length && "text" === e.firstChild.type && !wA(e.children[0].value) && !e.firstChild.hasLeadingSpaces && !e.firstChild.hasTrailingSpaces && e.isLeadingSpaceSensitive && !e.hasLeadingSpaces && e.isTrailingSpaceSensitive && !e.hasTrailingSpaces && e.prev && "text" === e.prev.type && e.next && "text" === e.next.type;
        return e.map(e => {
          if (e.children) {
            const n = e.children.map(t);
            if (n.some(Boolean)) {
              const t = [];
              for (let r = 0; r < e.children.length; r++) {
                const u = e.children[r];
                if (n[r]) {
                  const _n49 = t.pop(),
                    o = e.children[++r],
                    a = e.sourceSpan.constructor,
                    {
                      isTrailingSpaceSensitive: i,
                      hasTrailingSpaces: s
                    } = o;
                  t.push(_n49.clone({
                    value: _n49.value + "<".concat(u.rawName, ">") + u.firstChild.value + "</".concat(u.rawName, ">") + o.value,
                    sourceSpan: new a(_n49.sourceSpan.start, o.sourceSpan.end),
                    isTrailingSpaceSensitive: i,
                    hasTrailingSpaces: s
                  }));
                } else t.push(u);
              }
              return e.clone({
                children: t
              });
            }
          }
          return e;
        });
      }];
    var jA = function (e, t) {
      for (const n of IA) e = n(e, t);
      return e;
    };
    var MA = {
      hasPragma: function (e) {
        return /^\s*<!--\s*@(format|prettier)\s*-->/.test(e);
      },
      insertPragma: function (e) {
        return "\x3c!-- @format --\x3e\n\n" + e.replace(/^\s*\n/, "");
      }
    };
    const {
      builders: {
        concat: LA,
        group: RA
      }
    } = dn;
    var qA = {
        isVueEventBindingExpression: function (e) {
          const t = e.trim();
          return /^([\w$]+|\([^)]*?\))\s*=>|^function\s*\(/.test(t) || /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/.test(t);
        },
        printVueFor: function (e, t) {
          const {
            left: n,
            operator: r,
            right: u
          } = function (e) {
            const t = /([^]*?)\s+(in|of)\s+([^]*)/,
              n = /,([^,\]}]*)(?:,([^,\]}]*))?$/,
              r = /^\(|\)$/g,
              u = e.match(t);
            if (!u) return;
            const o = {};
            o.for = u[3].trim();
            const a = u[1].trim().replace(r, ""),
              i = a.match(n);
            i ? (o.alias = a.replace(n, ""), o.iterator1 = i[1].trim(), i[2] && (o.iterator2 = i[2].trim())) : o.alias = a;
            return {
              left: "".concat([o.alias, o.iterator1, o.iterator2].filter(Boolean).join(",")),
              operator: u[2],
              right: o.for
            };
          }(e);
          return LA([RA(t("function _(".concat(n, ") {}"), {
            parser: "babel",
            __isVueForBindingLeft: !0
          })), " ", r, " ", t(u, {
            parser: "__js_expression"
          }, {
            stripTrailingHardline: !0
          })]);
        },
        printVueSlotScope: function (e, t) {
          return t("function _(".concat(e, ") {}"), {
            parser: "babel",
            __isVueSlotScope: !0
          }, {
            stripTrailingHardline: !0
          });
        }
      },
      VA = $e(function (e) {
        !function (t, n) {
          e.exports ? e.exports = n() : t.parseSrcset = n();
        }(We, function () {
          return function (e, t) {
            var n = t && t.logger || console;
            function r(e) {
              return " " === e || "\t" === e || "\n" === e || "\f" === e || "\r" === e;
            }
            function u(t) {
              var n,
                r = t.exec(e.substring(D));
              if (r) return n = r[0], D += n.length, n;
            }
            for (var o, a, i, s, l, c = e.length, p = /^[ \t\n\r\u000c]+/, d = /^[, \t\n\r\u000c]+/, f = /^[^ \t\n\r\u000c]+/, h = /[,]+$/, m = /^\d+$/, g = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, D = 0, y = [];;) {
              if (u(d), D >= c) return y;
              o = u(f), a = [], "," === o.slice(-1) ? (o = o.replace(h, ""), C()) : E();
            }
            function E() {
              for (u(p), i = "", s = "in descriptor";;) {
                if (l = e.charAt(D), "in descriptor" === s) {
                  if (r(l)) i && (a.push(i), i = "", s = "after descriptor");else {
                    if ("," === l) return D += 1, i && a.push(i), void C();
                    if ("(" === l) i += l, s = "in parens";else {
                      if ("" === l) return i && a.push(i), void C();
                      i += l;
                    }
                  }
                } else if ("in parens" === s) {
                  if (")" === l) i += l, s = "in descriptor";else {
                    if ("" === l) return a.push(i), void C();
                    i += l;
                  }
                } else if ("after descriptor" === s) if (r(l)) ;else {
                  if ("" === l) return void C();
                  s = "in descriptor", D -= 1;
                }
                D += 1;
              }
            }
            function C() {
              var t,
                r,
                u,
                i,
                s,
                l,
                c,
                p,
                d,
                f = !1,
                h = {};
              for (i = 0; i < a.length; i++) l = (s = a[i])[s.length - 1], c = s.substring(0, s.length - 1), p = parseInt(c, 10), d = parseFloat(c), m.test(c) && "w" === l ? ((t || r) && (f = !0), 0 === p ? f = !0 : t = p) : g.test(c) && "x" === l ? ((t || r || u) && (f = !0), d < 0 ? f = !0 : r = d) : m.test(c) && "h" === l ? ((u || r) && (f = !0), 0 === p ? f = !0 : u = p) : f = !0;
              f ? n && n.error && n.error("Invalid srcset descriptor found in '" + e + "' at '" + s + "'.") : (h.url = o, t && (h.w = t), r && (h.d = r), u && (h.h = u), y.push(h));
            }
          };
        });
      });
    const {
      builders: {
        concat: WA,
        ifBreak: $A,
        join: UA,
        line: zA
      }
    } = dn;
    var JA = {
      printImgSrcset: function (e) {
        const t = VA(e, {
            logger: {
              error(e) {
                throw new Error(e);
              }
            }
          }),
          n = t.some(({
            w: e
          }) => e),
          r = t.some(({
            h: e
          }) => e);
        if (n + r + t.some(({
          d: e
        }) => e) > 1) throw new Error("Mixed descriptor in srcset is not supported");
        const u = n ? "w" : r ? "h" : "d",
          o = n ? "w" : r ? "h" : "x",
          a = e => Math.max(...e),
          i = t.map(e => e.url),
          s = a(i.map(e => e.length)),
          l = t.map(e => e[u]).map(e => e ? e.toString() : ""),
          c = l.map(e => {
            const t = e.indexOf(".");
            return -1 === t ? e.length : t;
          }),
          p = a(c);
        return UA(WA([",", zA]), i.map((e, t) => {
          const n = [e],
            r = l[t];
          if (r) {
            const u = s - e.length + 1,
              a = p - c[t],
              i = " ".repeat(u + a);
            n.push($A(i, " "), r + o);
          }
          return WA(n);
        }));
      },
      printClassNames: function (e) {
        return e.trim().split(/\s+/).join(" ");
      }
    };
    const {
        builders: GA,
        utils: {
          mapDoc: HA,
          normalizeParts: XA
        }
      } = dn,
      {
        replaceEndOfLineWith: YA
      } = Lt,
      {
        print: KA
      } = Em,
      {
        breakParent: QA,
        dedentToRoot: ZA,
        fill: ev,
        group: tv,
        hardline: nv,
        ifBreak: rv,
        indent: uv,
        join: ov,
        line: av,
        literalline: iv,
        softline: sv
      } = GA,
      {
        htmlTrimPreserveIndentation: lv,
        splitByHtmlWhitespace: cv,
        countChars: pv,
        countParents: dv,
        dedentString: fv,
        forceBreakChildren: hv,
        forceBreakContent: mv,
        forceNextEmptyLine: gv,
        getLastDescendant: Dv,
        getPrettierIgnoreAttributeCommentData: yv,
        hasPrettierIgnore: Ev,
        inferScriptParser: Cv,
        isVueCustomBlock: bv,
        isVueNonHtmlBlock: Av,
        isScriptLikeTag: vv,
        isTextLikeNode: Fv,
        preferHardlineAsLeadingSpaces: xv,
        shouldNotPrintClosingTag: Sv,
        shouldPreserveContent: wv,
        unescapeQuoteEntities: Bv,
        isPreLikeNode: Tv
      } = FA,
      {
        insertPragma: kv
      } = MA,
      {
        printVueFor: Nv,
        printVueSlotScope: Ov,
        isVueEventBindingExpression: Pv
      } = qA,
      {
        printImgSrcset: _v,
        printClassNames: Iv
      } = JA;
    function jv(e) {
      const t = XA(e);
      return 0 === t.length ? "" : 1 === t.length ? t[0] : GA.concat(t);
    }
    function Mv(e, t, n) {
      const r = e.getValue();
      if (hv(r)) return jv([QA, jv(e.map(e => {
        const t = e.getValue(),
          n = t.prev ? a(t.prev, t) : "";
        return jv([n ? jv([n, gv(t.prev) ? nv : ""]) : "", o(e)]);
      }, "children"))]);
      const u = r.children.map(() => Symbol(""));
      return jv(e.map((e, t) => {
        const n = e.getValue();
        if (Fv(n)) {
          if (n.prev && Fv(n.prev)) {
            const _t88 = a(n.prev, n);
            if (_t88) return gv(n.prev) ? jv([nv, nv, o(e)]) : jv([_t88, o(e)]);
          }
          return o(e);
        }
        const r = [],
          i = [],
          s = [],
          l = [],
          c = n.prev ? a(n.prev, n) : "",
          p = n.next ? a(n, n.next) : "";
        return c && (gv(n.prev) ? r.push(nv, nv) : c === nv ? r.push(nv) : Fv(n.prev) ? i.push(c) : i.push(rv("", sv, {
          groupId: u[t - 1]
        }))), p && (gv(n) ? Fv(n.next) && l.push(nv, nv) : p === nv ? Fv(n.next) && l.push(nv) : s.push(p)), jv([].concat(r, tv(jv([jv(i), tv(jv([o(e), jv(s)]), {
          id: u[t]
        })])), l));
      }, "children"));
      function o(e) {
        const r = e.getValue();
        return Ev(r) ? jv([].concat(Kv(r, t), YA(t.originalText.slice(t.locStart(r) + (r.prev && Jv(r.prev) ? eF(r).length : 0), t.locEnd(r) - (r.next && Hv(r.next) ? rF(r, t).length : 0)), iv), Zv(r, t))) : n(e);
      }
      function a(e, t) {
        return Fv(e) && Fv(t) ? e.isTrailingSpaceSensitive ? e.hasTrailingSpaces ? xv(t) ? nv : av : "" : xv(t) ? nv : sv : Jv(e) && (Ev(t) || t.firstChild || t.isSelfClosing || "element" === t.type && 0 !== t.attrs.length) || "element" === e.type && e.isSelfClosing && Hv(t) ? "" : !t.isLeadingSpaceSensitive || xv(t) || Hv(t) && e.lastChild && Yv(e.lastChild) && e.lastChild.lastChild && Yv(e.lastChild.lastChild) ? nv : t.hasLeadingSpaces ? av : sv;
      }
    }
    function Lv(e, t) {
      let n = e.startSourceSpan.end.offset;
      e.firstChild && Gv(e.firstChild) && (n -= tF(e).length);
      let r = e.endSourceSpan.start.offset;
      return e.lastChild && Yv(e.lastChild) ? r += nF(e, t).length : Xv(e) && (r -= rF(e.lastChild, t).length), t.originalText.slice(n, r);
    }
    function Rv(e, t, n) {
      const r = e.getValue();
      if (!r.attrs || 0 === r.attrs.length) return r.isSelfClosing ? " " : "";
      const u = r.prev && "comment" === r.prev.type && yv(r.prev.value),
        o = "boolean" == typeof u ? () => u : Array.isArray(u) ? e => u.includes(e.rawName) : () => !1,
        a = e.map(e => {
          const r = e.getValue();
          return o(r) ? jv(YA(t.originalText.slice(t.locStart(r), t.locEnd(r)), iv)) : n(e);
        }, "attrs"),
        i = "element" === r.type && "script" === r.fullName && 1 === r.attrs.length && "src" === r.attrs[0].fullName && 0 === r.children.length,
        s = [uv(jv([i ? " " : av, ov(av, a)]))];
      return r.firstChild && Gv(r.firstChild) || r.isSelfClosing && Xv(r.parent) || i ? s.push(r.isSelfClosing ? " " : "") : s.push(r.isSelfClosing ? av : sv), jv(s);
    }
    function qv(e, t, n) {
      const r = e.getValue();
      return jv([Vv(r, t), Rv(e, t, n), r.isSelfClosing ? "" : Wv(r)]);
    }
    function Vv(e, t) {
      return e.prev && Jv(e.prev) ? "" : jv([Kv(e, t), eF(e)]);
    }
    function Wv(e) {
      return e.firstChild && Gv(e.firstChild) ? "" : tF(e);
    }
    function $v(e, t) {
      return jv([e.isSelfClosing ? "" : Uv(e, t), zv(e, t)]);
    }
    function Uv(e, t) {
      return e.lastChild && Yv(e.lastChild) ? "" : jv([Qv(e, t), nF(e, t)]);
    }
    function zv(e, t) {
      return (e.next ? Hv(e.next) : Xv(e.parent)) ? "" : jv([rF(e, t), Zv(e, t)]);
    }
    function Jv(e) {
      return e.next && !Fv(e.next) && Fv(e) && e.isTrailingSpaceSensitive && !e.hasTrailingSpaces;
    }
    function Gv(e) {
      return !e.prev && e.isLeadingSpaceSensitive && !e.hasLeadingSpaces;
    }
    function Hv(e) {
      return e.prev && "docType" !== e.prev.type && !Fv(e.prev) && e.isLeadingSpaceSensitive && !e.hasLeadingSpaces;
    }
    function Xv(e) {
      return e.lastChild && e.lastChild.isTrailingSpaceSensitive && !e.lastChild.hasTrailingSpaces && !Fv(Dv(e.lastChild)) && !Tv(e);
    }
    function Yv(e) {
      return !e.next && !e.hasTrailingSpaces && e.isTrailingSpaceSensitive && Fv(Dv(e));
    }
    function Kv(e, t) {
      return Gv(e) ? tF(e.parent) : Hv(e) ? rF(e.prev, t) : "";
    }
    function Qv(e, t) {
      return Xv(e) ? rF(e.lastChild, t) : "";
    }
    function Zv(e, t) {
      return Yv(e) ? nF(e.parent, t) : Jv(e) ? eF(e.next) : "";
    }
    function eF(e) {
      switch (e.type) {
        case "ieConditionalComment":
        case "ieConditionalStartComment":
          return "\x3c!--[if ".concat(e.condition);
        case "ieConditionalEndComment":
          return "\x3c!--<!";
        case "interpolation":
          return "{{";
        case "docType":
          return "<!DOCTYPE";
        case "element":
          if (e.condition) return "\x3c!--[if ".concat(e.condition, "]>\x3c!--\x3e<").concat(e.rawName);
        default:
          return "<".concat(e.rawName);
      }
    }
    function tF(e) {
      switch (e.type) {
        case "ieConditionalComment":
          return "]>";
        case "element":
          if (e.condition) return ">\x3c!--<![endif]--\x3e";
        default:
          return ">";
      }
    }
    function nF(e, t) {
      if (Sv(e, t)) return "";
      switch (e.type) {
        case "ieConditionalComment":
          return "<!";
        case "element":
          if (e.hasHtmComponentClosingTag) return "<//";
        default:
          return "</".concat(e.rawName);
      }
    }
    function rF(e, t) {
      if (Sv(e, t)) return "";
      switch (e.type) {
        case "ieConditionalComment":
        case "ieConditionalEndComment":
          return "[endif]--\x3e";
        case "ieConditionalStartComment":
          return "]>\x3c!--\x3e";
        case "interpolation":
          return "}}";
        case "element":
          if (e.isSelfClosing) return "/>";
        default:
          return ">";
      }
    }
    function uF(e, t = e.value) {
      return e.parent.isWhitespaceSensitive ? e.parent.isIndentationSensitive ? YA(t, iv) : YA(fv(lv(t)), nv) : ov(av, cv(t)).parts;
    }
    var oF = {
      preprocess: jA,
      print: function (e, t, n) {
        const r = e.getValue();
        switch (r.type) {
          case "front-matter":
            return jv(YA(r.raw, iv));
          case "root":
            return t.__onHtmlRoot && t.__onHtmlRoot(r), GA.concat([tv(Mv(e, t, n)), nv]);
          case "element":
          case "ieConditionalComment":
            {
              if (wv(r, t)) return jv([].concat(Kv(r, t), tv(qv(e, t, n)), YA(Lv(r, t), iv), $v(r, t), Zv(r, t)));
              const o = 1 === r.children.length && "interpolation" === r.firstChild.type && r.firstChild.isLeadingSpaceSensitive && !r.firstChild.hasLeadingSpaces && r.lastChild.isTrailingSpaceSensitive && !r.lastChild.hasTrailingSpaces,
                a = Symbol("element-attr-group-id");
              return jv([tv(jv([tv(qv(e, t, n), {
                id: a
              }), 0 === r.children.length ? r.hasDanglingSpaces && r.isDanglingSpaceSensitive ? av : "" : jv([mv(r) ? QA : "", (u = jv([o ? rv(sv, "", {
                groupId: a
              }) : r.firstChild.hasLeadingSpaces && r.firstChild.isLeadingSpaceSensitive ? av : "text" === r.firstChild.type && r.isWhitespaceSensitive && r.isIndentationSensitive ? ZA(sv) : sv, Mv(e, t, n)]), o ? rv(uv(u), u, {
                groupId: a
              }) : !vv(r) && !bv(r, t) || "root" !== r.parent.type || "vue" !== t.parser || t.vueIndentScriptAndStyle ? uv(u) : u), (r.next ? Hv(r.next) : Xv(r.parent)) ? r.lastChild.hasTrailingSpaces && r.lastChild.isTrailingSpaceSensitive ? " " : "" : o ? rv(sv, "", {
                groupId: a
              }) : r.lastChild.hasTrailingSpaces && r.lastChild.isTrailingSpaceSensitive ? av : ("comment" === r.lastChild.type || "text" === r.lastChild.type && r.isWhitespaceSensitive && r.isIndentationSensitive) && new RegExp("\\n[\\t ]{".concat(t.tabWidth * dv(e, e => e.parent && "root" !== e.parent.type), "}$")).test(r.lastChild.value) ? "" : sv])])), $v(r, t)]);
            }
          case "ieConditionalStartComment":
          case "ieConditionalEndComment":
            return jv([Vv(r), zv(r)]);
          case "interpolation":
            return jv([Vv(r, t), jv(e.map(n, "children")), zv(r, t)]);
          case "text":
            if ("interpolation" === r.parent.type) {
              const _e141 = /\n[^\S\n]*?$/,
                _t89 = _e141.test(r.value),
                _n50 = _t89 ? r.value.replace(_e141, "") : r.value;
              return jv([jv(YA(_n50, iv)), _t89 ? nv : ""]);
            }
            return ev(XA([].concat(Kv(r, t), uF(r), Zv(r, t))));
          case "docType":
            return jv([tv(jv([Vv(r, t), " ", r.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")])), zv(r, t)]);
          case "comment":
            return jv([Kv(r, t), jv(YA(t.originalText.slice(t.locStart(r), t.locEnd(r)), iv)), Zv(r, t)]);
          case "attribute":
            {
              if (null === r.value) return r.rawName;
              const _e142 = Bv(r.value),
                _t90 = pv(_e142, "'") < pv(_e142, '"') ? "'" : '"';
              return jv([r.rawName, jv(["=", _t90, jv(YA('"' === _t90 ? _e142.replace(/"/g, "&quot;") : _e142.replace(/'/g, "&apos;"), iv)), _t90])]);
            }
          default:
            throw new Error("Unexpected node type ".concat(r.type));
        }
        var u;
      },
      insertPragma: kv,
      massageAstNode: function (e, t) {
        return delete t.sourceSpan, delete t.startSourceSpan, delete t.endSourceSpan, delete t.nameSpan, delete t.valueSpan, "text" === e.type || "comment" === e.type || gC(e) || "yaml" === e.type || "toml" === e.type ? null : ("attribute" === e.type && delete t.value, void ("docType" === e.type && delete t.value));
      },
      embed: function (e, t, n, r) {
        const u = e.getValue();
        switch (u.type) {
          case "element":
            if (vv(u) || "interpolation" === u.type) return;
            if (!u.isSelfClosing && Av(u, r)) {
              const o = Cv(u, r);
              if (!o) return;
              const a = Lv(u, r);
              let i = /^\s*$/.test(a),
                s = "";
              return i || (s = n(lv(a), {
                parser: o
              }, {
                stripTrailingHardline: !0
              }), i = "" === s), jv([Kv(u, r), tv(qv(e, r, t)), i ? "" : nv, s, i ? "" : nv, $v(u, r), Zv(u, r)]);
            }
            break;
          case "text":
            if (vv(u.parent)) {
              const _e143 = Cv(u.parent);
              if (_e143) {
                const _t91 = "markdown" === _e143 ? fv(u.value.replace(/^[^\S\n]*?\n/, "")) : u.value,
                  o = {
                    parser: _e143
                  };
                if ("html" === r.parser && "babel" === _e143) {
                  let _e144 = "script";
                  const {
                    attrMap: _t92
                  } = u.parent;
                  _t92 && ("module" === _t92.type || "text/babel" === _t92.type && "module" === _t92["data-type"]) && (_e144 = "module"), o.__babelSourceType = _e144;
                }
                return GA.concat([jv([QA, Kv(u, r), n(_t91, o, {
                  stripTrailingHardline: !0
                }), Zv(u, r)])]);
              }
            } else if ("interpolation" === u.parent.type) return jv([uv(jv([av, n(u.value, Object.assign({
              __isInHtmlInterpolation: !0
            }, "angular" === r.parser ? {
              parser: "__ng_interpolation",
              trailingComma: "none"
            } : "vue" === r.parser ? {
              parser: "__vue_expression"
            } : {
              parser: "__js_expression"
            }), {
              stripTrailingHardline: !0
            })])), u.parent.next && Hv(u.parent.next) ? " " : av]);
            break;
          case "attribute":
            {
              if (!u.value) break;
              if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(r.originalText.slice(u.valueSpan.start.offset, u.valueSpan.end.offset))) return jv([u.rawName, "=", u.value]);
              if ("lwc" === r.parser) {
                if (/^{[\S\s]*}$/.test(r.originalText.slice(u.valueSpan.start.offset, u.valueSpan.end.offset))) return jv([u.rawName, "=", u.value]);
              }
              const _e145 = function (e, t, n) {
                const r = t => new RegExp(t.join("|")).test(e.fullName),
                  u = () => Bv(e.value);
                let o = !1;
                const a = (e, t) => {
                    const n = "NGRoot" === e.type ? "NGMicrosyntax" === e.node.type && 1 === e.node.body.length && "NGMicrosyntaxExpression" === e.node.body[0].type ? e.node.body[0].expression : e.node : "JsExpressionRoot" === e.type ? e.node : e;
                    !n || "ObjectExpression" !== n.type && "ArrayExpression" !== n.type && ("__vue_expression" !== t.parser || "TemplateLiteral" !== n.type && "StringLiteral" !== n.type) || (o = !0);
                  },
                  i = e => tv(e),
                  s = (e, t = !0) => tv(jv([uv(jv([sv, e])), t ? sv : ""])),
                  l = e => o ? i(e) : s(e),
                  c = (e, n) => t(e, Object.assign({
                    __onHtmlBindingRoot: a
                  }, n), {
                    stripTrailingHardline: !0
                  });
                if ("srcset" === e.fullName && ("img" === e.parent.fullName || "source" === e.parent.fullName)) return s(_v(u()));
                if ("class" === e.fullName && !n.parentParser) {
                  const _e146 = u();
                  if (!_e146.includes("{{")) return Iv(_e146);
                }
                if ("style" === e.fullName && !n.parentParser) {
                  const _e147 = u();
                  if (!_e147.includes("{{")) return s(c(_e147, {
                    parser: "css",
                    __isHTMLStyleAttribute: !0
                  }));
                }
                if ("vue" === n.parser) {
                  if ("v-for" === e.fullName) return Nv(u(), c);
                  if ("slot-scope" === e.fullName) return Ov(u(), c);
                  const _t93 = ["^:", "^v-bind:"],
                    _n51 = ["^v-", "^#"];
                  if (r(["^@", "^v-on:"])) {
                    const _e148 = u();
                    return l(c(_e148, {
                      parser: Pv(_e148) ? "__js_expression" : "__vue_event_binding"
                    }));
                  }
                  if (r(_t93)) return l(c(u(), {
                    parser: "__vue_expression"
                  }));
                  if (r(_n51)) return l(c(u(), {
                    parser: "__js_expression"
                  }));
                }
                if ("angular" === n.parser) {
                  const _t94 = (e, t) => c(e, Object.assign({}, t, {
                      trailingComma: "none"
                    })),
                    _n52 = ["^\\*"],
                    _o36 = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"],
                    _a28 = ["^i18n(-.+)?$"];
                  if (r(["^\\(.+\\)$", "^on-"])) return l(_t94(u(), {
                    parser: "__ng_action"
                  }));
                  if (r(_o36)) return l(_t94(u(), {
                    parser: "__ng_binding"
                  }));
                  if (r(_a28)) {
                    const _t95 = u().trim();
                    return s(ev(uF(e, _t95)), !_t95.includes("@@"));
                  }
                  if (r(_n52)) return l(_t94(u(), {
                    parser: "__ng_directive"
                  }));
                  const _i11 = /{{([\S\s]+?)}}/g,
                    p = u();
                  if (_i11.test(p)) {
                    const _e149 = [];
                    return p.split(_i11).forEach((n, r) => {
                      if (r % 2 == 0) _e149.push(jv(YA(n, iv)));else try {
                        _e149.push(tv(jv(["{{", uv(jv([av, _t94(n, {
                          parser: "__ng_interpolation",
                          __isInHtmlInterpolation: !0
                        })])), av, "}}"])));
                      } catch (t) {
                        _e149.push("{{", jv(YA(n, iv)), "}}");
                      }
                    }), tv(jv(_e149));
                  }
                }
                return null;
              }(u, (e, t) => n(e, Object.assign({
                __isInHtmlAttribute: !0
              }, t), {
                stripTrailingHardline: !0
              }), r);
              if (_e145) return jv([u.rawName, '="', tv(HA(_e145, e => "string" == typeof e ? e.replace(/"/g, "&quot;") : e)), '"']);
              break;
            }
          case "front-matter":
            return KA(u, n);
        }
      }
    };
    var aF = {
        htmlWhitespaceSensitivity: {
          since: "1.15.0",
          category: "HTML",
          type: "choice",
          default: "css",
          description: "How to handle whitespaces in HTML.",
          choices: [{
            value: "css",
            description: "Respect the default value of CSS display property."
          }, {
            value: "strict",
            description: "Whitespaces are considered sensitive."
          }, {
            value: "ignore",
            description: "Whitespaces are considered insensitive."
          }]
        },
        vueIndentScriptAndStyle: {
          since: "1.19.0",
          category: "HTML",
          type: "boolean",
          default: !1,
          description: "Indent script and style tags in Vue files."
        }
      },
      iF = ["xhtml"],
      sF = [".html", ".htm", ".html.hl", ".inc", ".st", ".xht", ".xhtml"],
      lF = {
        name: "HTML",
        type: "markup",
        tmScope: "text.html.basic",
        aceMode: "html",
        codemirrorMode: "htmlmixed",
        codemirrorMimeType: "text/html",
        color: "#e34c26",
        aliases: iF,
        extensions: sF,
        languageId: 146
      },
      cF = Object.freeze({
        __proto__: null,
        name: "HTML",
        type: "markup",
        tmScope: "text.html.basic",
        aceMode: "html",
        codemirrorMode: "htmlmixed",
        codemirrorMimeType: "text/html",
        color: "#e34c26",
        aliases: iF,
        extensions: sF,
        languageId: 146,
        default: lF
      }),
      pF = [".vue"],
      dF = {
        name: "Vue",
        type: "markup",
        color: "#2c3e50",
        extensions: pF,
        tmScope: "text.html.vue",
        aceMode: "html",
        languageId: 391
      },
      fF = Object.freeze({
        __proto__: null,
        name: "Vue",
        type: "markup",
        color: "#2c3e50",
        extensions: pF,
        tmScope: "text.html.vue",
        aceMode: "html",
        languageId: 391,
        default: dF
      }),
      hF = Ue(cF),
      mF = Ue(fF);
    var gF = {
      languages: [As(hF, () => ({
        name: "Angular",
        since: "1.15.0",
        parsers: ["angular"],
        vscodeLanguageIds: ["html"],
        extensions: [".component.html"],
        filenames: []
      })), As(hF, e => ({
        since: "1.15.0",
        parsers: ["html"],
        vscodeLanguageIds: ["html"],
        extensions: e.extensions.concat([".mjml"])
      })), As(hF, () => ({
        name: "Lightning Web Components",
        since: "1.17.0",
        parsers: ["lwc"],
        vscodeLanguageIds: ["html"],
        extensions: [],
        filenames: []
      })), As(mF, () => ({
        since: "1.10.0",
        parsers: ["vue"],
        vscodeLanguageIds: ["vue"]
      }))],
      printers: {
        html: oF
      },
      options: aF,
      parsers: {
        get html() {
          return {}.parsers.html;
        },
        get vue() {
          return {}.parsers.vue;
        },
        get angular() {
          return {}.parsers.angular;
        },
        get lwc() {
          return {}.parsers.lwc;
        }
      }
    };
    var DF = {
      isPragma: function (e) {
        return /^\s*@(prettier|format)\s*$/.test(e);
      },
      hasPragma: function (e) {
        return /^\s*#[^\S\n]*@(prettier|format)\s*?(\n|$)/.test(e);
      },
      insertPragma: function (e) {
        return "# @format\n\n".concat(e);
      }
    };
    const {
      getLast: yF
    } = Lt;
    function EF(e, t) {
      return e && "string" == typeof e.type && (!t || t.includes(e.type));
    }
    function CF(e) {
      return "prettier-ignore" === e.value.trim();
    }
    function bF(e) {
      return e && e.leadingComments && 0 !== e.leadingComments.length;
    }
    function AF(e) {
      return e && e.middleComments && 0 !== e.middleComments.length;
    }
    function vF(e) {
      return e && e.indicatorComment;
    }
    function FF(e) {
      return e && e.trailingComment;
    }
    function xF(e) {
      return e && e.endComments && 0 !== e.endComments.length;
    }
    function SF(e) {
      const t = [];
      let n;
      for (const r of e.split(/( +)/g)) " " !== r ? " " === n ? t.push(r) : t.push((t.pop() || "") + r) : void 0 === n && t.unshift(""), n = r;
      return " " === n && t.push((t.pop() || "") + " "), "" === t[0] && (t.shift(), t.unshift(" " + (t.shift() || ""))), t;
    }
    var wF = {
      getLast: yF,
      getAncestorCount: function (e, t) {
        let n = 0;
        const r = e.stack.length - 1;
        for (let u = 0; u < r; u++) {
          const _r71 = e.stack[u];
          EF(_r71) && t(_r71) && n++;
        }
        return n;
      },
      isNode: EF,
      isEmptyNode: function (e) {
        return !(e.children && 0 !== e.children.length || function (e) {
          return bF(e) || AF(e) || vF(e) || FF(e) || xF(e);
        }(e));
      },
      mapNode: function e(t, n, r) {
        return n("children" in t ? Object.assign({}, t, {
          children: t.children.map(r => e(r, n, t))
        }) : t, r);
      },
      defineShortcut: function (e, t, n) {
        Object.defineProperty(e, t, {
          get: n,
          enumerable: !1
        });
      },
      isNextLineEmpty: function (e, t) {
        let n = 0;
        const r = t.length;
        for (let u = e.position.end.offset - 1; u < r; u++) {
          const _e150 = t[u];
          if ("\n" === _e150 && n++, 1 === n && /\S/.test(_e150)) return !1;
          if (2 === n) return !0;
        }
        return !1;
      },
      isLastDescendantNode: function (e) {
        switch (e.getValue().type) {
          case "tag":
          case "anchor":
          case "comment":
            return !1;
        }
        const t = e.stack.length;
        for (let n = 1; n < t; n++) {
          const _t96 = e.stack[n],
            r = e.stack[n - 1];
          if (Array.isArray(r) && "number" == typeof _t96 && _t96 !== r.length - 1) return !1;
        }
        return !0;
      },
      getBlockValueLineContents: function (e, {
        parentIndent: t,
        isLastDescendant: n,
        options: r
      }) {
        const u = e.position.start.line === e.position.end.line ? "" : r.originalText.slice(e.position.start.offset, e.position.end.offset).match(/^[^\n]*?\n([\S\s]*)$/)[1],
          o = null === e.indent ? (a = u.match(/^( *)\S/m)) ? a[1].length : 1 / 0 : e.indent - 1 + t;
        var a;
        const i = u.split("\n").map(e => e.slice(o));
        return "preserve" === r.proseWrap || "blockLiteral" === e.type ? s(i.map(e => 0 === e.length ? [] : [e])) : s(i.map(e => 0 === e.length ? [] : SF(e)).reduce((e, t, n) => 0 === n || 0 === i[n - 1].length || 0 === t.length || /^\s/.test(t[0]) || /^\s|\s$/.test(yF(e)) ? e.concat([t]) : e.concat([e.pop().concat(t)]), []).map(e => e.reduce((e, t) => 0 !== e.length && /\s$/.test(yF(e)) ? e.concat(e.pop() + " " + t) : e.concat(t), [])).map(e => "never" === r.proseWrap ? [e.join(" ")] : e));
        function s(t) {
          if ("keep" === e.chomping) return 0 === yF(t).length ? t.slice(0, -1) : t;
          let r = 0;
          for (let e = t.length - 1; e >= 0 && 0 === t[e].length; e--) r++;
          return 0 === r ? t : r >= 2 && !n ? t.slice(0, -(r - 1)) : t.slice(0, -r);
        }
      },
      getFlowScalarLineContents: function (e, t, n) {
        const r = t.split("\n").map((e, t, n) => 0 === t && t === n.length - 1 ? e : 0 !== t && t !== n.length - 1 ? e.trim() : 0 === t ? e.trimEnd() : e.trimStart());
        return "preserve" === n.proseWrap ? r.map(e => 0 === e.length ? [] : [e]) : r.map(e => 0 === e.length ? [] : SF(e)).reduce((t, n, u) => 0 === u || 0 === r[u - 1].length || 0 === n.length || "quoteDouble" === e && yF(yF(t)).endsWith("\\") ? t.concat([n]) : t.concat([t.pop().concat(n)]), []).map(e => "never" === n.proseWrap ? [e.join(" ")] : e);
      },
      getLastDescendantNode: function e(t) {
        return "children" in t && 0 !== t.children.length ? e(yF(t.children)) : t;
      },
      hasPrettierIgnore: function (e) {
        const t = e.getValue();
        if ("documentBody" === t.type) {
          const _t97 = e.getParentNode();
          return xF(_t97.head) && CF(yF(_t97.head.endComments));
        }
        return bF(t) && CF(yF(t.leadingComments));
      },
      hasLeadingComments: bF,
      hasMiddleComments: AF,
      hasIndicatorComment: vF,
      hasTrailingComment: FF,
      hasEndComments: xF
    };
    const BF = dn.builders,
      {
        conditionalGroup: TF,
        breakParent: kF,
        concat: NF,
        dedent: OF,
        dedentToRoot: PF,
        fill: _F,
        group: IF,
        hardline: jF,
        ifBreak: MF,
        join: LF,
        line: RF,
        lineSuffix: qF,
        literalline: VF,
        markAsRoot: WF,
        softline: $F
      } = BF,
      {
        replaceEndOfLineWith: UF,
        isPreviousLineEmpty: zF
      } = Lt,
      {
        insertPragma: JF,
        isPragma: GF
      } = DF,
      {
        getAncestorCount: HF,
        getBlockValueLineContents: XF,
        getFlowScalarLineContents: YF,
        getLast: KF,
        getLastDescendantNode: QF,
        hasLeadingComments: ZF,
        hasMiddleComments: ex,
        hasIndicatorComment: tx,
        hasTrailingComment: nx,
        hasEndComments: rx,
        hasPrettierIgnore: ux,
        isLastDescendantNode: ox,
        isNextLineEmpty: ax,
        isNode: ix,
        isEmptyNode: sx,
        defineShortcut: lx,
        mapNode: cx
      } = wF;
    function px(e) {
      switch (e.type) {
        case "document":
          lx(e, "head", () => e.children[0]), lx(e, "body", () => e.children[1]);
          break;
        case "documentBody":
        case "sequenceItem":
        case "flowSequenceItem":
        case "mappingKey":
        case "mappingValue":
          lx(e, "content", () => e.children[0]);
          break;
        case "mappingItem":
        case "flowMappingItem":
          lx(e, "key", () => e.children[0]), lx(e, "value", () => e.children[1]);
      }
      return e;
    }
    function dx(e, t, n, r, u) {
      switch (e.type) {
        case "root":
          return NF([LF(jF, n.map((t, r) => {
            const o = e.children[r],
              a = e.children[r + 1];
            return NF([u(t), gx(o, a) ? NF([jF, "...", nx(o) ? NF([" ", n.call(u, "trailingComment")]) : ""]) : !a || nx(a.head) ? "" : NF([jF, "---"])]);
          }, "children")), 0 === e.children.length || (a = QF(e), ix(a, ["blockLiteral", "blockFolded"]) && "keep" === a.chomping) ? "" : jF]);
        case "document":
          {
            const _o37 = t.children[n.getName() + 1];
            return LF(jF, ["head" === Dx(e, _o37, t, r) ? LF(jF, [0 === e.head.children.length && 0 === e.head.endComments.length ? "" : n.call(u, "head"), NF(["---", nx(e.head) ? NF([" ", n.call(u, "head", "trailingComment")]) : ""])].filter(Boolean)) : "", mx(e) ? n.call(u, "body") : ""].filter(Boolean));
          }
        case "documentHead":
          return LF(jF, [].concat(n.map(u, "children"), n.map(u, "endComments")));
        case "documentBody":
          {
            const _t98 = LF(jF, n.map(u, "children")).parts,
              _r72 = LF(jF, n.map(u, "endComments")).parts,
              _o38 = 0 === _t98.length || 0 === _r72.length ? "" : (e => ix(e, ["blockFolded", "blockLiteral"]) ? "keep" === e.chomping ? "" : NF([jF, jF]) : jF)(QF(e));
            return NF([].concat(_t98, _o38, _r72));
          }
        case "directive":
          return NF(["%", LF(" ", [e.name].concat(e.parameters))]);
        case "comment":
          return NF(["#", e.value]);
        case "alias":
          return NF(["*", e.value]);
        case "tag":
          return r.originalText.slice(e.position.start.offset, e.position.end.offset);
        case "anchor":
          return NF(["&", e.value]);
        case "plain":
          return Ax(e.type, r.originalText.slice(e.position.start.offset, e.position.end.offset), r);
        case "quoteDouble":
        case "quoteSingle":
          {
            const _t99 = "'",
              _n53 = '"',
              _u16 = r.originalText.slice(e.position.start.offset + 1, e.position.end.offset - 1);
            if ("quoteSingle" === e.type && _u16.includes("\\") || "quoteDouble" === e.type && /\\[^"]/.test(_u16)) {
              const _o39 = "quoteDouble" === e.type ? _n53 : _t99;
              return NF([_o39, Ax(e.type, _u16, r), _o39]);
            }
            if (_u16.includes(_n53)) return NF([_t99, Ax(e.type, "quoteDouble" === e.type ? _u16.replace(/\\"/g, _n53).replace(/'/g, _t99.repeat(2)) : _u16, r), _t99]);
            if (_u16.includes(_t99)) return NF([_n53, Ax(e.type, "quoteSingle" === e.type ? _u16.replace(/''/g, _t99) : _u16, r), _n53]);
            const _o40 = r.singleQuote ? _t99 : _n53;
            return NF([_o40, Ax(e.type, _u16, r), _o40]);
          }
        case "blockFolded":
        case "blockLiteral":
          {
            const _t100 = HF(n, e => ix(e, ["sequence", "mapping"])),
              _o41 = ox(n);
            return NF(["blockFolded" === e.type ? ">" : "|", null === e.indent ? "" : e.indent.toString(), "clip" === e.chomping ? "" : "keep" === e.chomping ? "+" : "-", tx(e) ? NF([" ", n.call(u, "indicatorComment")]) : "", (null === e.indent ? OF : PF)(fx(null === e.indent ? r.tabWidth : e.indent - 1 + _t100, NF(XF(e, {
              parentIndent: _t100,
              isLastDescendant: _o41,
              options: r
            }).reduce((t, n, r, u) => t.concat(0 === r ? jF : "", _F(LF(RF, n).parts), r !== u.length - 1 ? 0 === n.length ? jF : WF(VF) : "keep" === e.chomping && _o41 ? 0 === n.length ? PF(jF) : PF(VF) : ""), []))))]);
          }
        case "sequence":
          return LF(jF, n.map(u, "children"));
        case "sequenceItem":
          return NF(["- ", fx(2, e.content ? n.call(u, "content") : "")]);
        case "mappingKey":
        case "mappingValue":
          return e.content ? n.call(u, "content") : "";
        case "mapping":
          return LF(jF, n.map(u, "children"));
        case "mappingItem":
        case "flowMappingItem":
          {
            const _o42 = sx(e.key),
              _a29 = sx(e.value);
            if (_o42 && _a29) return NF([": "]);
            const s = n.call(u, "key"),
              l = n.call(u, "value");
            if (_a29) return "flowMappingItem" === e.type && "flowMapping" === t.type ? s : "mappingItem" !== e.type || !yx(e.key.content, r) || nx(e.key.content) || t.tag && "tag:yaml.org,2002:set" === t.tag.value ? NF(["? ", fx(2, s)]) : NF([s, Ex(e) ? " " : "", ":"]);
            if (_o42) return NF([": ", fx(2, l)]);
            const c = Symbol("mappingKey");
            return ZF(e.value) || !hx(e.key.content) ? NF(["? ", fx(2, s), jF, LF("", n.map(u, "value", "leadingComments").map(e => NF([e, jF]))), ": ", fx(2, l)]) : !function (e) {
              if (!e) return !0;
              switch (e.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                  return e.position.start.line === e.position.end.line;
                case "alias":
                  return !0;
                default:
                  return !1;
              }
            }(e.key.content) || ZF(e.key.content) || ex(e.key.content) || nx(e.key.content) || rx(e.key) || ZF(e.value.content) || ex(e.value.content) || rx(e.value) || !yx(e.value.content, r) ? TF([NF([IF(NF([MF("? "), IF(fx(2, s), {
              id: c
            })])), MF(NF([jF, ": ", fx(2, l)]), i(NF([Ex(e) ? " " : "", ":", ZF(e.value.content) || rx(e.value) && e.value.content && !ix(e.value.content, ["mapping", "sequence"]) || "mapping" === t.type && nx(e.key.content) && hx(e.value.content) || ix(e.value.content, ["mapping", "sequence"]) && null === e.value.content.tag && null === e.value.content.anchor ? jF : e.value.content ? RF : "", l])), {
              groupId: c
            })])]) : NF([s, Ex(e) ? " " : "", ": ", l]);
          }
        case "flowMapping":
        case "flowSequence":
          {
            const _t101 = "flowMapping" === e.type ? "{" : "[",
              _a30 = "flowMapping" === e.type ? "}" : "]",
              s = "flowMapping" === e.type && 0 !== e.children.length && r.bracketSpacing ? RF : $F,
              l = 0 !== e.children.length && "flowMappingItem" === (o = KF(e.children)).type && sx(o.key) && sx(o.value);
            return NF([_t101, i(NF([s, NF(n.map((t, n) => NF([u(t), n === e.children.length - 1 ? "" : NF([",", RF, e.children[n].position.start.line !== e.children[n + 1].position.start.line ? bx(t, r.originalText) : ""])]), "children")), MF(",", "")])), l ? "" : s, _a30]);
          }
        case "flowSequenceItem":
          return n.call(u, "content");
        default:
          throw new Error("Unexpected node type ".concat(e.type));
      }
      var o, a;
      function i(e) {
        return BF.align(" ".repeat(r.tabWidth), e);
      }
    }
    function fx(e, t) {
      return "number" == typeof e && e > 0 ? BF.align(" ".repeat(e), t) : BF.align(e, t);
    }
    function hx(e) {
      if (!e) return !0;
      switch (e.type) {
        case "plain":
        case "quoteDouble":
        case "quoteSingle":
        case "alias":
        case "flowMapping":
        case "flowSequence":
          return !0;
        default:
          return !1;
      }
    }
    function mx(e) {
      return 0 !== e.body.children.length || rx(e.body);
    }
    function gx(e, t) {
      return nx(e) || t && (0 !== t.head.children.length || rx(t.head));
    }
    function Dx(e, t, n, r) {
      return n.children[0] === e && /---(\s|$)/.test(r.originalText.slice(r.locStart(e), r.locStart(e) + 4)) || 0 !== e.head.children.length || rx(e.head) || nx(e.head) ? "head" : !gx(e, t) && !!t && "root";
    }
    function yx(e, t) {
      if (!e) return !0;
      switch (e.type) {
        case "plain":
        case "quoteSingle":
        case "quoteDouble":
          break;
        case "alias":
          return !0;
        default:
          return !1;
      }
      if ("preserve" === t.proseWrap) return e.position.start.line === e.position.end.line;
      if (/\\$/m.test(t.originalText.slice(e.position.start.offset, e.position.end.offset))) return !1;
      switch (t.proseWrap) {
        case "never":
          return !e.value.includes("\n");
        case "always":
          return !/[\n ]/.test(e.value);
        default:
          return !1;
      }
    }
    function Ex(e) {
      return e.key.content && "alias" === e.key.content.type;
    }
    function Cx(e) {
      return rx(e) && !ix(e, ["documentHead", "documentBody"]);
    }
    function bx(e, t) {
      const n = e.getValue(),
        r = e.stack[0];
      return r.isNextEmptyLinePrintedChecklist = r.isNextEmptyLinePrintedChecklist || [], r.isNextEmptyLinePrintedChecklist[n.position.end.line] || !ax(n, t) || (r.isNextEmptyLinePrintedChecklist[n.position.end.line] = !0, Cx(e.getParentNode())) ? "" : $F;
    }
    function Ax(e, t, n) {
      const r = YF(e, t, n);
      return LF(jF, r.map(e => _F(LF(RF, e).parts)));
    }
    var vx = {
        preprocess: function (e) {
          return cx(e, px);
        },
        print: function (e, t, n) {
          const r = e.getValue(),
            u = e.getParentNode(),
            o = r.tag ? e.call(n, "tag") : "",
            a = r.anchor ? e.call(n, "anchor") : "",
            i = ix(r, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !ox(e) ? bx(e, t.originalText) : "";
          return NF(["mappingValue" !== r.type && ZF(r) ? NF([LF(jF, e.map(n, "leadingComments")), jF]) : "", o, o && a ? " " : "", a, o || a ? ix(r, ["sequence", "mapping"]) && !ex(r) ? jF : " " : "", ex(r) ? NF([1 === r.middleComments.length ? "" : jF, LF(jF, e.map(n, "middleComments")), jF]) : "", ux(e) ? NF(UF(t.originalText.slice(r.position.start.offset, r.position.end.offset).trimEnd(), VF)) : IF(dx(r, u, e, t, n)), nx(r) && !ix(r, ["document", "documentHead"]) ? qF(NF(["mappingValue" !== r.type || r.content ? " " : "", "mappingKey" === u.type && "mapping" === e.getParentNode(2).type && hx(r) ? "" : kF, e.call(n, "trailingComment")])) : "", Cx(r) ? fx("sequenceItem" === r.type ? 2 : 0, NF([jF, LF(jF, e.map(e => NF([zF(t.originalText, e.getValue(), t.locStart) ? jF : "", n(e)]), "endComments"))])) : "", i]);
        },
        massageAstNode: function (e, t) {
          if (ix(t)) switch (delete t.position, t.type) {
            case "comment":
              if (GF(t.value)) return null;
              break;
            case "quoteDouble":
            case "quoteSingle":
              t.type = "quote";
          }
        },
        insertPragma: JF
      },
      Fx = {
        bracketSpacing: Bh.bracketSpacing,
        singleQuote: Bh.singleQuote,
        proseWrap: Bh.proseWrap
      },
      xx = ["yml"],
      Sx = [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"],
      wx = [".clang-format", ".clang-tidy", ".gemrc", "glide.lock", "yarn.lock"],
      Bx = {
        name: "YAML",
        type: "data",
        tmScope: "source.yaml",
        aliases: xx,
        extensions: Sx,
        filenames: wx,
        aceMode: "yaml",
        codemirrorMode: "yaml",
        codemirrorMimeType: "text/x-yaml",
        languageId: 407
      };
    var Tx = [dm, DD, vy, $y, mC, gF, {
      languages: [As(Ue(Object.freeze({
        __proto__: null,
        name: "YAML",
        type: "data",
        tmScope: "source.yaml",
        aliases: xx,
        extensions: Sx,
        filenames: wx,
        aceMode: "yaml",
        codemirrorMode: "yaml",
        codemirrorMimeType: "text/x-yaml",
        languageId: 407,
        default: Bx
      })), e => ({
        since: "1.14.0",
        parsers: ["yaml"],
        vscodeLanguageIds: ["yaml", "ansible", "home-assistant"],
        filenames: e.filenames.filter(e => "yarn.lock" !== e)
      }))],
      printers: {
        yaml: vx
      },
      options: Fx,
      parsers: {
        get yaml() {
          return {}.parsers.yaml;
        }
      }
    }];
    const {
        version: kx
      } = ht,
      {
        getSupportInfo: Nx
      } = yt,
      Ox = Tx.map(t => e(t, ["parsers"]));
    function Px(e, t = 1) {
      return (...n) => {
        const r = n[t] || {},
          u = r.plugins || [];
        return n[t] = Object.assign({}, r, {
          plugins: [...Ox, ...(Array.isArray(u) ? u : Object.values(u))]
        }), e(...n);
      };
    }
    const _x = Px(Ki.formatWithCursor);
    return {
      formatWithCursor: _x,
      format: (e, t) => _x(e, t).formatted,
      check(e, t) {
        const {
          formatted: n
        } = _x(e, t);
        return n === e;
      },
      doc: dn,
      getSupportInfo: Px(Nx, 0),
      version: kx,
      util: bs,
      __debug: {
        parse: Px(Ki.parse),
        formatAST: Px(Ki.formatAST),
        formatDoc: Px(Ki.formatDoc),
        printToDoc: Px(Ki.printToDoc),
        printDocToString: Px(Ki.printDocToString)
      }
    };
  });
});
unwrapExports(standalone);

const SubStep1$2 = ({
  formData,
  userInfo,
  handleTabChange,
  handleSubTabChange,
  setFormData,
  initFormMTDocs,
  isEmployee: _isEmployee = false
}) => {
  var _data$MapSubmission, _data$MapSubmission$D, _formData$description, _formData$plotNumbers, _fastPASData$descript, _formData$description2, _fastPASData$descript2, _fastPASData$descript3, _fastPASData$descript4;
  console.log(formData, "formDataFromSubStep1");
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const designType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const [fastPASData, setFastPasData] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const schemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const [watchProposalType, watchisSpecialProject, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo] = watch(["proposalType", "isSpecialProject", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo"]);
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const convertDocuments = docs => {
    return docs.map(doc => ({
      additionalDetails: {
        fileName: doc.docName,
        title: doc.docName
      },
      auditDetails: null,
      documentRemarks: null,
      documentStatus: null,
      documentSubtype: null,
      documentType: doc.docName,
      documentUid: null,
      fileStoreId: doc.fileStoreId,
      id: doc.fileId,
      isNoc: "false",
      remarks: null
    }));
  };
  const splitIfMultiple = str => {
    return str ? str.split(",").map(item => item.trim()) : [];
  };
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      if (applicationNo) {
        var _response, _data, _data2, _data2$architectDetai, _data3, _data3$ownerDetail, _data4, _data4$ownerDetail, _data5, _data5$ownerDetail, _data14, _data15, _data15$plotDetail, _data16, _data16$plotDetail, _data17, _data17$plotDetail, _data18, _data18$plotDetail, _data19, _data19$plotDetail, _data20, _data20$projectDetail, _data21, _data21$projectDetail, _data22, _data22$projectDetail, _data23, _data23$projectDetail, _data24, _data24$projectDetail, _data25, _data25$plotDetail, _data26, _data26$plotDetail, _data27, _data27$plotDetail, _data28, _data28$plotDetail, _data29, _data29$plotDetail, _data30, _data30$projectDetail, _data31, _data31$plotDetail, _data32, _data32$ownerDetail, _data33, _data33$plotDetail, _data34, _data34$plotDetail, _data35, _data35$projectDetail, _data36, _data36$plotDetail, _data37, _data37$plotDetail, _data38, _data38$projectDetail, _data39, _data39$projectDetail, _data40, _data40$plotDetail, _data41, _data41$plotDetail, _data42, _data42$plotDetail, _data43, _data43$plotDetail, _data44, _data44$plotDetail, _data45, _data45$plotDetail, _data46, _data46$plotDetail, _data47, _data47$plotDetail, _data48, _data48$architectDeta, _data49, _data49$architectDeta, _data50, _data50$architectDeta, _data51, _data51$architectDeta, _data52, _data52$architectDeta, _data53;
        response = await Digit.OBPSService.BPAmigratedSearchappNo({
          applicationNo
        });
        console.log(response, "responseFromSearchhh");
        data = (_response = response) === null || _response === void 0 ? void 0 : _response.Application;
        const docs = convertDocuments((_data = data) === null || _data === void 0 ? void 0 : _data.documents);
        const date = new Date((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$architectDetai = _data2.architectDetail) === null || _data2$architectDetai === void 0 ? void 0 : _data2$architectDetai.validityUpto);
        const isLayoutDevelopment = (applicationNo === null || applicationNo === void 0 ? void 0 : applicationNo.split("/")[1]) === "LD";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let owners = [];
        const names = splitIfMultiple((_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$ownerDetail = _data3.ownerDetail) === null || _data3$ownerDetail === void 0 ? void 0 : _data3$ownerDetail.ownerName);
        const contacts = splitIfMultiple((_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$ownerDetail = _data4.ownerDetail) === null || _data4$ownerDetail === void 0 ? void 0 : _data4$ownerDetail.ownerContactNo);
        const emails = splitIfMultiple((_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$ownerDetail = _data5.ownerDetail) === null || _data5$ownerDetail === void 0 ? void 0 : _data5$ownerDetail.ownerEmail);
        console.log(contacts, names, "contactsss");
        const isSameContact = contacts.every(contact => contact === contacts[0]);
        if (isSameContact) {
          var _data6, _data6$ownerDetail, _data7, _data7$ownerDetail, _data8, _data8$ownerDetail, _data9, _data9$ownerDetail;
          owners = [{
            name: names === null || names === void 0 ? void 0 : names.join(" & "),
            mobileNumber: contacts[0] || "",
            emailId: emails[0] || "",
            permanentAddress: {
              state: (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$ownerDetail = _data6.ownerDetail) === null || _data6$ownerDetail === void 0 ? void 0 : _data6$ownerDetail.state,
              address: (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$ownerDetail = _data7.ownerDetail) === null || _data7$ownerDetail === void 0 ? void 0 : _data7$ownerDetail.addressLine1,
              type: "PERMANENT"
            },
            correspondenceAddress: {
              address: (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$ownerDetail = _data8.ownerDetail) === null || _data8$ownerDetail === void 0 ? void 0 : _data8$ownerDetail.siteAdress,
              pinNo: (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$ownerDetail = _data9.ownerDetail) === null || _data9$ownerDetail === void 0 ? void 0 : _data9$ownerDetail.pincode,
              type: "CORRESPONDENCE"
            }
          }];
        } else {
          owners = names.map((name, index) => {
            var _data10, _data10$ownerDetail, _data11, _data11$ownerDetail, _data12, _data12$ownerDetail, _data13, _data13$ownerDetail;
            return {
              name: name,
              mobileNumber: contacts[index] || "",
              emailId: emails[index] || "",
              permanentAddress: {
                state: (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$ownerDetail = _data10.ownerDetail) === null || _data10$ownerDetail === void 0 ? void 0 : _data10$ownerDetail.state,
                address: (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$ownerDetail = _data11.ownerDetail) === null || _data11$ownerDetail === void 0 ? void 0 : _data11$ownerDetail.addressLine1,
                type: "PERMANENT"
              },
              correspondenceAddress: {
                address: (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$ownerDetail = _data12.ownerDetail) === null || _data12$ownerDetail === void 0 ? void 0 : _data12$ownerDetail.siteAdress,
                pinNo: (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$ownerDetail = _data13.ownerDetail) === null || _data13$ownerDetail === void 0 ? void 0 : _data13$ownerDetail.pincode,
                type: "CORRESPONDENCE"
              }
            };
          });
        }
        console.log(owners, "ownerrrr");
        const formattedDate = `${day}/${month}/${year}`;
        const values = {
          prevSanctionNo: applicationNo,
          prevSanctionDate: (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.applicationDate,
          zoneType: (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$plotDetail = _data15.plotDetail) === null || _data15$plotDetail === void 0 ? void 0 : _data15$plotDetail.landUseZone,
          subZoneType: (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$plotDetail = _data16.plotDetail) === null || _data16$plotDetail === void 0 ? void 0 : _data16$plotDetail.landSubUseZone,
          primaryUse: (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$plotDetail = _data17.plotDetail) === null || _data17$plotDetail === void 0 ? void 0 : _data17$plotDetail.plotUse,
          activityProposed: (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$plotDetail = _data18.plotDetail) === null || _data18$plotDetail === void 0 ? void 0 : _data18$plotDetail.plotSubUse,
          communityParking: (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$plotDetail = _data19.plotDetail) === null || _data19$plotDetail === void 0 ? void 0 : _data19$plotDetail.communityParking,
          natureOfConstruction: "Revalidation/Time Extension",
          department: applicationFlow || (formData === null || formData === void 0 ? void 0 : formData.department),
          businessService: applicationFlow === "DA" || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP",
          isLayoutDevelopment: isLayoutDevelopment,
          tehsil: (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$projectDetail = _data20.projectDetail) === null || _data20$projectDetail === void 0 ? void 0 : _data20$projectDetail.tehsil,
          projectType: (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$projectDetail = _data21.projectDetail) === null || _data21$projectDetail === void 0 ? void 0 : _data21$projectDetail.projectType,
          district: (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$projectDetail = _data22.projectDetail) === null || _data22$projectDetail === void 0 ? void 0 : _data22$projectDetail.district,
          revenueVillage: (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$projectDetail = _data23.projectDetail) === null || _data23$projectDetail === void 0 ? void 0 : _data23$projectDetail.revenueVillage,
          landMark: (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$projectDetail = _data24.projectDetail) === null || _data24$projectDetail === void 0 ? void 0 : _data24$projectDetail.landMark,
          plotArea: (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$plotDetail = _data25.plotDetail) === null || _data25$plotDetail === void 0 ? void 0 : _data25$plotDetail.plotArea,
          totalBuildUpArea: (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$plotDetail = _data26.plotDetail) === null || _data26$plotDetail === void 0 ? void 0 : _data26$plotDetail.totalBUA,
          totalExistingBuiltUpArea: (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$plotDetail = _data27.plotDetail) === null || _data27$plotDetail === void 0 ? void 0 : _data27$plotDetail.existingBUA,
          maximumPermissibleGroundCoverage: (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$plotDetail = _data28.plotDetail) === null || _data28$plotDetail === void 0 ? void 0 : _data28$plotDetail.groundCoverageArea,
          typeofArea: (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$plotDetail = _data29.plotDetail) === null || _data29$plotDetail === void 0 ? void 0 : _data29$plotDetail.developmentArea,
          revenueVillageMohal: ((_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$projectDetail = _data30.projectDetail) === null || _data30$projectDetail === void 0 ? void 0 : _data30$projectDetail.revenueVillage) || null,
          plotAreaDoc: ((_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$plotDetail = _data31.plotDetail) === null || _data31$plotDetail === void 0 ? void 0 : _data31$plotDetail.plotAreaAsDocument) || null,
          plotAreaPos: null,
          siteAddress: (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$ownerDetail = _data32.ownerDetail) === null || _data32$ownerDetail === void 0 ? void 0 : _data32$ownerDetail.siteAddress,
          totalPlotArea: ((_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$plotDetail = _data33.plotDetail) === null || _data33$plotDetail === void 0 ? void 0 : _data33$plotDetail.plotArea) || 0,
          noOfBlocks: 0,
          selectedOffice: "Lucknow Development Authority",
          schemeName: (_data34 = data) === null || _data34 === void 0 ? void 0 : (_data34$plotDetail = _data34.plotDetail) === null || _data34$plotDetail === void 0 ? void 0 : _data34$plotDetail.scheme,
          buildingClassification: (_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$projectDetail = _data35.projectDetail) === null || _data35$projectDetail === void 0 ? void 0 : _data35$projectDetail.projectType,
          planOn: (_data36 = data) === null || _data36 === void 0 ? void 0 : (_data36$plotDetail = _data36.plotDetail) === null || _data36$plotDetail === void 0 ? void 0 : _data36$plotDetail.planOn,
          buildingHeight: (_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$plotDetail = _data37.plotDetail) === null || _data37$plotDetail === void 0 ? void 0 : _data37$plotDetail.maxBuildingHeight,
          isRevised: (_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$projectDetail = _data38.projectDetail) === null || _data38$projectDetail === void 0 ? void 0 : _data38$projectDetail.isRevised,
          isSpecialProject: (_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$projectDetail = _data39.projectDetail) === null || _data39$projectDetail === void 0 ? void 0 : _data39$projectDetail.specialProject,
          isApprovedLayout: (_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$plotDetail = _data40.plotDetail) === null || _data40$plotDetail === void 0 ? void 0 : _data40$plotDetail.approvedLayout,
          isSpecialGroundCoverage: (_data41 = data) === null || _data41 === void 0 ? void 0 : (_data41$plotDetail = _data41.plotDetail) === null || _data41$plotDetail === void 0 ? void 0 : _data41$plotDetail.groundCoverageArea,
          layoutsanctionNumber: (_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$plotDetail = _data42.plotDetail) === null || _data42$plotDetail === void 0 ? void 0 : _data42$plotDetail.layoutSanctionNo,
          layoutsanctionDate: (_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$plotDetail = _data43.plotDetail) === null || _data43$plotDetail === void 0 ? void 0 : _data43$plotDetail.layoutSanctionDate
        };
        Object.entries(values).forEach(([key, value]) => {
          setValue(key, value);
        });
        await setFormData({
          ...formData,
          feeType: "ApplicationFee",
          workflow: {
            action: "INITIATE",
            assignes: null
          },
          tod: {
            orientDevelopment: null,
            convertedLandUseinTOD: null
          },
          plotInfo: {
            ...(formData === null || formData === void 0 ? void 0 : formData.plotInfo),
            estimatedCost: (_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$plotDetail = _data44.plotDetail) === null || _data44$plotDetail === void 0 ? void 0 : _data44$plotDetail.estimatedCost,
            builtupArea: (_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$plotDetail = _data45.plotDetail) === null || _data45$plotDetail === void 0 ? void 0 : _data45$plotDetail.totalBUA,
            plotArea: (_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$plotDetail = _data46.plotDetail) === null || _data46$plotDetail === void 0 ? void 0 : _data46$plotDetail.plotArea
          },
          descriptionOfLand: {
            ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
            landArea: (_data47 = data) === null || _data47 === void 0 ? void 0 : (_data47$plotDetail = _data47.plotDetail) === null || _data47$plotDetail === void 0 ? void 0 : _data47$plotDetail.plotArea
          },
          professionaldetails: {
            ...(formData === null || formData === void 0 ? void 0 : formData.professionaldetails),
            consultantCategory: (_data48 = data) === null || _data48 === void 0 ? void 0 : (_data48$architectDeta = _data48.architectDetail) === null || _data48$architectDeta === void 0 ? void 0 : _data48$architectDeta.consultantCategory,
            name: (_data49 = data) === null || _data49 === void 0 ? void 0 : (_data49$architectDeta = _data49.architectDetail) === null || _data49$architectDeta === void 0 ? void 0 : _data49$architectDeta.loginName,
            emailId: (_data50 = data) === null || _data50 === void 0 ? void 0 : (_data50$architectDeta = _data50.architectDetail) === null || _data50$architectDeta === void 0 ? void 0 : _data50$architectDeta.emailId,
            mobileNumber: (_data51 = data) === null || _data51 === void 0 ? void 0 : (_data51$architectDeta = _data51.architectDetail) === null || _data51$architectDeta === void 0 ? void 0 : _data51$architectDeta.mobileNumber,
            certificateNo: (_data52 = data) === null || _data52 === void 0 ? void 0 : (_data52$architectDeta = _data52.architectDetail) === null || _data52$architectDeta === void 0 ? void 0 : _data52$architectDeta.licenseNo,
            validupto: formattedDate
          },
          landInfo: {
            ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
            owners: owners,
            address: {
              city: null,
              locality: {
                code: "Lucknow"
              },
              region: null,
              doorNo: null,
              areaType: null
            },
            tenantId: stateId
          },
          documents: docs,
          sanctionFiles: (_data53 = data) === null || _data53 === void 0 ? void 0 : _data53.sanctionFiles
        });
        initFormMTDocs(docs);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const onSubmit = data => {
    handleSubTabChange(1, data);
  };
  if (applicationFlow === null && !(formData !== null && formData !== void 0 && formData.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: "Revalidation/Time Extension",
    data: natureOfConstructionOptions,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Previous File No."),
    placeholder: t("Enter File No"),
    name: "mapSubDetails.prevFileNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevsanctionNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("prevSanctionNo")),
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Previous Sanction Date"),
    placeholder: t("Select Prev Sanction Date"),
    name: "mapSubDetails.sanctionValidityStartDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Current Validity Date"),
    placeholder: t("Select Date"),
    name: "mapSubDetails.sanctionValidityDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.currValidityDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchlandUseType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.subZoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: watchSubZoneType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchPrimaryUse
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchAtivityProposed
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: planOnOptions,
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "planOn",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planOn,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: false,
    control: control,
    placeholder: t("Enter Proposed SIte"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput",
    disabled: _isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is this Site falls in Metro City"),
    control: control,
    data: yesOrNo,
    name: "isMetroCity",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isMetroCity,
    type: "radioButton",
    disabled: _isEmployee
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: ConstructionTypeOptions,
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    disabled: _isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.schemeName) || _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark || _isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: schemeType ? t("Plot No") : t("Plot No./Khasra No./ Arazi No."),
    control: control,
    placeholder: schemeType ? t("Enter Plot no") : t("Enter Plot No./Khasra No./ Arazi No."),
    name: schemeType ? "plotNo" : "descriptionOfLand.khasraDetails.[0].plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.plotNo),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Standard Type Design")}`,
    name: "proposalType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.proposalType) || designType,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker",
    disabled: _isEmployee
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput",
    disabled: _isEmployee
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of PLots"),
    name: "noOfPlots",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, Array.from({
    length: 3
  }).map((_, colIndex) => {
    var _formData$plotNumbers2;
    const plotIndex = rowIndex * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      hasLabel: false,
      maxLength: 15,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plotIndex]) || "",
      type: "textInput",
      disabled: _isEmployee
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, Array.from({
    length: remainingPlots
  }).map((_, colIndex) => {
    var _formData$plotNumbers3;
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      maxLength: 15,
      hasLabel: false,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers3 = formData.plotNumbers) === null || _formData$plotNumbers3 === void 0 ? void 0 : _formData$plotNumbers3[plotIndex]) || "",
      type: "textInput",
      disabled: _isEmployee
    }));
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: specialProjectOptions,
    name: "projectType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput",
    disabled: _isEmployee
  })))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4,
    disabled: _isEmployee
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Please specify if any other condition"),
    placeholder: t("Enter condition"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Setback Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Setback Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Setback Left"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Setback Right"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript4 = fastPASData.descriptionOfLand) === null || _fastPASData$descript4 === void 0 ? void 0 : _fastPASData$descript4.landArea) < 40000 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is Your Plot sub-division"),
    control: control,
    name: "plotSubdivided",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Does existing building require any compounding ?"),
    control: control,
    name: "needCompounding",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.needCompounding,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchNeedComp === "no" && watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is your plot Lease hold ?"),
    control: control,
    name: "plotLeaseHold",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), watchplotLeaseHold === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Noc For Lease Hold",
    control: control,
    name: "leaseholdNOC",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: true,
    isMandatory: true,
    tab: 1
  }))), watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" ? /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Not authorized for Self Certification Approval of Map ", /*#__PURE__*/React__default.createElement("span", null, "*")) : watchNeedComp === "yes" && /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Kindly apply on Compounding Module ", /*#__PURE__*/React__default.createElement("span", null, "*")))), !_isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep3$2 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$plotInfo;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  useEffect(() => {
    setValue("plotInfo.plotArea", formData === null || formData === void 0 ? void 0 : formData.plotArea);
    setValue("plotInfo.builtupArea", formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
  }, []);
  const onSubmit = data => {
    var _data$plotInfo;
    handleSubTabChange(2, {
      ...data,
      totalBuildUpArea: data === null || data === void 0 ? void 0 : (_data$plotInfo = data.plotInfo) === null || _data$plotInfo === void 0 ? void 0 : _data$plotInfo.builtupArea
    });
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Total Proposed Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Total Proposed Built up Area"),
    name: "plotInfo.builtupArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.builtupArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null), /*#__PURE__*/React__default.createElement(Row$1, null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep2$1 = ({
  formData,
  handleSubTabChange,
  isEmployee: _isEmployee = false
}) => {
  var _Digit$UserService$ge, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$professiona10, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$structuralI, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5;
  console.log("formDataStep3333333", formData);
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    },
    professionaldetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionaldetails)
    }
  };
  console.log("formDataaaa", formData);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  });
  const watchState = watch("landInfo.owners.[0].permanentAddress.state");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  useEffect(async () => {
    var _users$filter;
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"],
      pageSize: "100000"
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = (_users$filter = users.filter(user => {
      var _formData$professiona;
      return user.uuid === (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.engineerUuid);
    })) === null || _users$filter === void 0 ? void 0 : _users$filter[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr === null || engineersArr === void 0 ? void 0 : engineersArr.filter(e => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      var _selectedEngineer$pwd, _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const validUptoDate = selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$pwd = selectedEngineer.pwdExpiryDate) === null || _selectedEngineer$pwd === void 0 ? void 0 : _selectedEngineer$pwd.slice(0, 10);
      const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LTP Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.certificateNo,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    mandatory: true,
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona10 = formData.professionaldetails) === null || _formData$professiona10 === void 0 ? void 0 : _formData$professiona10.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].permanentAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.permanentAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.permanentAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 50,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI = formData.structuralInfo) === null || _formData$structuralI === void 0 ? void 0 : _formData$structuralI.name,
    type: "textInput",
    disabled: _isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.licenseNumber,
    type: "textInput",
    disabled: _isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.validupto,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : (_formData$structuralI5 = _formData$structuralI4.permanentAddress) === null || _formData$structuralI5 === void 0 ? void 0 : _formData$structuralI5.address,
    type: "textInput",
    disabled: _isEmployee,
    maxLength: 50
  }))))), !_isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep4$2 = ({
  formData,
  handleTabChange,
  isEmployee,
  handleSubTabChange
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const Step4$1 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$taxHeadEsti;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = () => {
    handleTabChange(4);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Builtup Area:"), " (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:"), " (\u20B9)"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(3)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step3$2 = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule
}) => {
  var _formData$documents, _formData$documents2;
  console.log("formDataInStep3", formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction);
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const scrutinyFlow = (formData === null || formData === void 0 ? void 0 : formData.scrutinyFlow) === "PDF" || Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") === "PDF";
  const [drawingDetail, setDrawingDetail] = useState((formData === null || formData === void 0 ? void 0 : formData.drawingDetail) || []);
  const drawingPdfflow = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(e => e.documentType === "drawingPdf")) || [];
  const scrutinydxf = (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(e => e.documentType === "dxfDrawing")) || [];
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  const validatePdfUrl = url => {
    try {
      const urlObj = new URL(url);
      console.log("PDF URL validation:", {
        protocol: urlObj.protocol,
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        search: urlObj.search,
        isValid: true
      });
      return true;
    } catch (error) {
      console.error("Invalid PDF URL:", url, error);
      return false;
    }
  };
  console.log(drawingPdfflow, "pdfFlowwwww");
  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    if (!validatePdfUrl(url)) {
      showMessage("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };
  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: ""
      };
      const updatedDrawingDetail = drawingDetail.map(item => ({
        ...item,
        viewEditPdf: fileStoreId
      }));
      const appData = {
        ...formData,
        workflow,
        drawingDetail: updatedDrawingDetail
      };
      updateApiCall.mutate({
        BPA: appData
      }, {
        onSuccess: result => {
          var _result$BPA;
          console.log("resultFromUpdate", result);
          onSelect("", result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
          alert("Pdf Edited Succesfully");
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "viewPdf",
    label: "View Pdf",
    accessor: "viewPdf"
  }, {
    id: "viewEditPdfUrl",
    label: "View Edited Pdf",
    accessor: "viewEditPdfUrl"
  }, {
    id: "viewPlanReport",
    label: "View Plan Report",
    accessor: "viewPlanReport"
  }, {
    id: "dxfFile",
    label: "DXF File",
    accessor: "dxfFile"
  }, {
    id: "status",
    label: "Status",
    accessor: "status"
  }, {
    id: "submittedOn",
    label: "Submitted On",
    accessor: "submittedOn"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const pdfcolumns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "dxfFile",
    label: "DXF File",
    accessor: "dxfFile"
  }, {
    id: "drawingPdf",
    label: "Drawing Pdf",
    accessor: "drawingPdf"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        pdfType: "D"
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const viewEdittedPdf = (url, index) => {
    window.open(url, "_blank");
  };
  const viewPdf = (url, index) => {
    window.open(url, "_blank");
  };
  if (loading || isPreviewLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    ref: formRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, scrutinyFlow ? t("Pdf Document") : t("Drawing")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details  table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, !scrutinyFlow ? columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)) : pdfcolumns === null || pdfcolumns === void 0 ? void 0 : pdfcolumns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, !scrutinyFlow ? drawingDetail.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, columns.map(column => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, "Upload Drawing PDF ", index + 1);
    }
    const value = row[column.accessor];
    if (column.accessor === "submittedOn") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? new Date(value).toLocaleString() : "N/A");
    }
    if (column.accessor === "updatedDxfFile" || column.accessor === "planReport" || column.accessor === "viewPdf" || column.accessor === "viewPlanReport") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => handleOpenPdf(value, index)
      }) : "N/A");
    }
    if (column.accessor === "viewPdf") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#157CB3",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => viewPdf(value)
      }) : "N/A");
    }
    if (column.accessor === "viewEditPdfUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#157CB3",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => viewEdittedPdf(value)
      }) : "N/A");
    }
    if (column.accessor === "dxfFile") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement("img", {
        src: "https://i.imgur.com/GDoAGny.png",
        style: {
          width: "20px",
          height: "30px",
          cursor: "pointer"
        },
        onClick: () => window.open(value, "_blank"),
        alt: "DXF File"
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl" && !isEmployee) {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, !isEmployee ? /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          opacity: 1
        },
        type: "button",
        onClick: handleSign,
        disabled: isEmployee
      }, "Attach Digital Sign") : value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => handleOpenPdf(value, index)
      }) : "N/A");
    }
    return /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id
    }, value || "N/A");
  }))) : /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 1
  }, pdfcolumns.map((column, index) => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: index
      }, "Upload Drawing PDF ", index + 1);
    }
    if (column.accessor === "dxfFile") {
      var _scrutinydxf$;
      return /*#__PURE__*/React__default.createElement(TableCell$1, null, scrutinydxf !== null && scrutinydxf !== void 0 && (_scrutinydxf$ = scrutinydxf[0]) !== null && _scrutinydxf$ !== void 0 && _scrutinydxf$.fileStoreId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => {
          var _scrutinydxf$2;
          return getDocumentByFileStoreId(scrutinydxf === null || scrutinydxf === void 0 ? void 0 : (_scrutinydxf$2 = scrutinydxf[0]) === null || _scrutinydxf$2 === void 0 ? void 0 : _scrutinydxf$2.fileStoreId, setIsPreviewLoading);
        }
      }) : "N/A");
    }
    if (column.accessor === "drawingPdf") {
      var _scrutinydxf$3;
      return /*#__PURE__*/React__default.createElement(TableCell$1, null, scrutinydxf !== null && scrutinydxf !== void 0 && (_scrutinydxf$3 = scrutinydxf[0]) !== null && _scrutinydxf$3 !== void 0 && _scrutinydxf$3.fileStoreId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => {
          var _drawingPdfflow$;
          return getDocumentByFileStoreId(drawingPdfflow === null || drawingPdfflow === void 0 ? void 0 : (_drawingPdfflow$ = drawingPdfflow[0]) === null || _drawingPdfflow$ === void 0 ? void 0 : _drawingPdfflow$.fileStoreId, setIsPreviewLoading);
        }
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, null, !isEmployee ? /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          opacity: 1
        },
        type: "button",
        onClick: handleSign,
        disabled: isEmployee
      }, "Attach Digital Sign") : "N/A");
    }
  }))))), /*#__PURE__*/React__default.createElement(PdfViewerModal, {
    open: pdfModalOpen,
    onClose: handlePdfModalClose,
    pdfUrl: currentPdfUrl,
    onSave: handlePdfSave,
    documentIndex: currentDocumentIndex
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "95%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }), !isEmployee && !isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "button",
    onClick: () => handleTabChange(3),
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const RevalMapSubmissionPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _Digit, _Digit2, _userRolesArray$, _ref;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code);
  const [uploadedFile, setUploadedFile] = useState(null);
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const isHideAction = ((_ref = ["REVERT_TO_APPLICANT", "APPROVED"]) === null || _ref === void 0 ? void 0 : _ref.includes(formData === null || formData === void 0 ? void 0 : formData.status)) && !isCitizen;
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "Fees"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async nextTabNo => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2$1, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(Step4$1, {
            formData: formData,
            handleTabChange: handleTabChange,
            isEmployee: !isCitizen
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "mandatory",
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: SortingAlphabatically(siteInspRecommendation),
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument
            }, props))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            type: "documentDetails"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
        default:
          return null;
      }
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step3$2, {
        formData: formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BasicSiteInspectionReport, {
        formData: formData,
        setCurrentTab: handleTabChange,
        setUpdatedInspectionReportData: setUpdatedInspectionReportData,
        callInspectionDetailsAPI: callInspectionDetailsAPI,
        userRolesArray: userRolesArray
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks,
        type: "inspectionDetails",
        formData: formData
      }));
    } else if (activeTab === 4) {
      var _userRolesArray$2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaymentHead, {
        tenantId: tenantId,
        formData: params,
        setTaxHead: setTaxHead,
        taxHead: taxHead,
        empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code,
        isFeesEligible: isFeesEligible,
        onSelect: onSelect,
        Modal: Modal
      }), /*#__PURE__*/React__default.createElement(PaymentMemoTable, {
        formData: formData
      }), /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
        title: "Recommendation Details",
        label: "Recommendation",
        name: "recommendation",
        options: SortingAlphabatically(siteInspRecommendation),
        defaultValue: dataRecommendation,
        extraLabel: "Remarks",
        setDeveloperRemarks: setDeveloperRemarks,
        developerRemarks: developerRemarks,
        setDataRecommendation: setDataRecommendation,
        buttonshow: true,
        onSaveClick: callPaymentDetailsAPI
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: paymentHeadRemarksData === null || paymentHeadRemarksData === void 0 ? void 0 : paymentHeadRemarksData.DetailDataRemarks,
        type: "paymentDetails"
      }));
    } else if (!isHideAction && activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (!isHideAction && activeTab === 6 || isHideAction && activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (!isHideAction && activeTab === 7 || isHideAction && activeTab === 6) {
      var _workflowDetails$data;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData,
        assignerToChatboard: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.processInstances
      }));
    } else if (!isHideAction && activeTab === 8 || isHideAction && activeTab === 7) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CustomLetter, {
        formData: formData,
        setCustomLetter: setCustomLetter,
        setTypeOfLetter: setTypeOfLetter,
        workflowDetails: workflowDetails,
        userRolesArray: userRolesArray
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Site Inspection"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Payment Heads"
  }), !isHideAction && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const useEmpNOC = (formData, workflowDetails, userRolesArray, urlFormType, nocResponse) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _user$info, _Digit, _Digit$SessionStorage, _Digit$SessionStorage2, _Digit2, _Digit2$SessionStorag, _Digit2$SessionStorag2, _Digit2$SessionStorag3, _Digit3, _Digit3$SessionStorag, _Digit3$SessionStorag2, _Digit3$SessionStorag3, _params$nocList, _formData$nocList, _params$nocList2, _formData$nocList2, _params$nocList3, _formData$nocList3, _nocResponse$Noc, _Digit4, _Digit4$SessionStorag, _Digit4$SessionStorag2, _params$nocList4, _formData$nocList4, _formData$nocList$fin, _params$nocList$find, _params$nocList5, _params$nocList6, _targetNoc$additional, _formData$additionalD5, _Digit5, _Digit5$SessionStorag, _userRolesArray$, _user$info2, _formData$documents, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _formData$documents2, _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _userRolesArray$3, _formData$description, _formData$description2, _workflowDetails$data12, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data15, _workflowDetails$data16, _updatedDocuments$;
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const paramsHook = useParams();
  const urlApplicationNo = paramsHook.id || (paramsHook.state && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.state}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : paramsHook.authority && paramsHook.plinth && paramsHook.plan && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.authority}/${paramsHook.plinth}/${paramsHook.plan}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : paramsHook.authority && paramsHook.plan && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.authority}/${paramsHook.plan}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : "");
  const id = urlApplicationNo || (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || "";
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  console.log(paramsHook, "paramsHookFromNOC", userDetails, id);
  const {
    t
  } = useTranslation();
  const [iframeSrc, setIframeSrc] = useState("");
  const [requestLetterUrl, setRequestLetterUrl] = useState("");
  const [pdfIframeSrc, setPdfIframeSrc] = useState("");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_NOC", formData);
  const getRequestLetterURL = async () => {
    var _formData$nocLetterIn, _formData$nocLetterIn2;
    const fileStoreId = formData === null || formData === void 0 ? void 0 : (_formData$nocLetterIn = formData.nocLetterInfo) === null || _formData$nocLetterIn === void 0 ? void 0 : (_formData$nocLetterIn2 = _formData$nocLetterIn.find(item => item.businessService === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode))) === null || _formData$nocLetterIn2 === void 0 ? void 0 : _formData$nocLetterIn2.fileStoreId;
    const url = await getDocumentByFileStoreId(fileStoreId, setLoading, true);
    setIframeSrc(url);
    console.log("urlFromGetRequestLetterURL", url);
    return url;
  };
  const history = useHistory();
  let user = Digit.UserService.getUser();
  const [currentTab, setCurrentTab] = useState("0");
  const [currentAction, setCurrentAction] = useState("");
  const [currentView, setCurrentView] = useState("documents");
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const [typeOfLetter, setTypeOfLetter] = useState("");
  const [customLetter, setCustomLetter] = useState([]);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData === null || formData === void 0 ? void 0 : formData.documents);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState(formData === null || formData === void 0 ? void 0 : formData.inspectionDetailData);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [taxHead, setTaxHead] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [officerNocDetails, setOfficerNocDetails] = useState(formData === null || formData === void 0 ? void 0 : formData.nocDetails);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "CITIZEN";
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  const nocAppNo = Digit.SessionStorage.get("nocAppNo") || null;
  const currentNOCDept = userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode;
  const sessionNocNo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : (_Digit$SessionStorage2 = _Digit$SessionStorage.get("nocAppNo")) === null || _Digit$SessionStorage2 === void 0 ? void 0 : _Digit$SessionStorage2.nocAppNo) || ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$SessionStorag = _Digit2.SessionStorage) === null || _Digit2$SessionStorag === void 0 ? void 0 : (_Digit2$SessionStorag2 = _Digit2$SessionStorag.get("nocAppNo")) === null || _Digit2$SessionStorag2 === void 0 ? void 0 : (_Digit2$SessionStorag3 = _Digit2$SessionStorag2.value) === null || _Digit2$SessionStorag3 === void 0 ? void 0 : _Digit2$SessionStorag3.nocAppNo) || ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : (_Digit3$SessionStorag = _Digit3.SessionStorage) === null || _Digit3$SessionStorag === void 0 ? void 0 : (_Digit3$SessionStorag2 = _Digit3$SessionStorag.get("nocAppNo")) === null || _Digit3$SessionStorag2 === void 0 ? void 0 : (_Digit3$SessionStorag3 = _Digit3$SessionStorag2.nocSearchResult) === null || _Digit3$SessionStorag3 === void 0 ? void 0 : _Digit3$SessionStorag3.applicationNo);
  const targetNoc = id && (params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === id)) || id && (formData === null || formData === void 0 ? void 0 : (_formData$nocList = formData.nocList) === null || _formData$nocList === void 0 ? void 0 : _formData$nocList.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === id)) || sessionNocNo && (params === null || params === void 0 ? void 0 : (_params$nocList2 = params.nocList) === null || _params$nocList2 === void 0 ? void 0 : _params$nocList2.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === sessionNocNo)) || sessionNocNo && (formData === null || formData === void 0 ? void 0 : (_formData$nocList2 = formData.nocList) === null || _formData$nocList2 === void 0 ? void 0 : _formData$nocList2.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === sessionNocNo)) || currentNOCDept && (params === null || params === void 0 ? void 0 : (_params$nocList3 = params.nocList) === null || _params$nocList3 === void 0 ? void 0 : _params$nocList3.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === currentNOCDept)) || currentNOCDept && (formData === null || formData === void 0 ? void 0 : (_formData$nocList3 = formData.nocList) === null || _formData$nocList3 === void 0 ? void 0 : _formData$nocList3.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === currentNOCDept)) || (nocResponse === null || nocResponse === void 0 ? void 0 : (_nocResponse$Noc = nocResponse.Noc) === null || _nocResponse$Noc === void 0 ? void 0 : _nocResponse$Noc[0]) || ((_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$SessionStorag = _Digit4.SessionStorage) === null || _Digit4$SessionStorag === void 0 ? void 0 : (_Digit4$SessionStorag2 = _Digit4$SessionStorag.get("nocAppNo")) === null || _Digit4$SessionStorag2 === void 0 ? void 0 : _Digit4$SessionStorag2.nocSearchResult) || ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "NOC" || (formData === null || formData === void 0 ? void 0 : formData.businessService) === "NOC" ? formData : null) || (params === null || params === void 0 ? void 0 : (_params$nocList4 = params.nocList) === null || _params$nocList4 === void 0 ? void 0 : _params$nocList4[0]) || (formData === null || formData === void 0 ? void 0 : (_formData$nocList4 = formData.nocList) === null || _formData$nocList4 === void 0 ? void 0 : _formData$nocList4[0]) || formData;
  const approvalCertUrl = (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.nocApprovedLetterUrl) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.approvalCertificateUrl) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.nocApprovedLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocList) && ((_formData$nocList$fin = formData.nocList.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === id)) === null || _formData$nocList$fin === void 0 ? void 0 : _formData$nocList$fin.nocApprovedLetterUrl) || Array.isArray(params === null || params === void 0 ? void 0 : params.nocList) && ((_params$nocList$find = params.nocList.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === id)) === null || _params$nocList$find === void 0 ? void 0 : _params$nocList$find.nocApprovedLetterUrl);
  console.log("TARGETNOC DATA FOUND", targetNoc);
  const currentFormData = {
    ...(formData || {}),
    ...(targetNoc || {}),
    applicationNo: (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.applicationNo) || id || (formData === null || formData === void 0 ? void 0 : formData.applicationNo),
    applicationStatus: (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.applicationStatus) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.status) || (formData === null || formData === void 0 ? void 0 : formData.status),
    status: (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.status) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.applicationStatus) || (formData === null || formData === void 0 ? void 0 : formData.status),
    nocApprovedLetterUrl: approvalCertUrl || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.nocApprovedLetterUrl),
    approvalCertificateUrl: approvalCertUrl || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.approvalCertificateUrl),
    approvalLetterUrl: approvalCertUrl || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.approvalLetterUrl),
    ApprovalsignedPdfUrl: (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.ApprovalsignedPdfUrl) || (formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl),
    IsApprovalCertificate: (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.IsApprovalCertificate) !== undefined ? targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.IsApprovalCertificate : formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate
  };
  console.log("CURRENTFORMDATA", currentFormData);
  const nocFormData = isCitizen ? id && (params === null || params === void 0 ? void 0 : (_params$nocList5 = params.nocList) === null || _params$nocList5 === void 0 ? void 0 : _params$nocList5.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === id)) || sessionNocNo && (params === null || params === void 0 ? void 0 : (_params$nocList6 = params.nocList) === null || _params$nocList6 === void 0 ? void 0 : _params$nocList6.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === sessionNocNo)) || currentFormData : currentFormData;
  const [nocOfficerRemarks, setNocOfficerRemarks] = useState((nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.termsAndCondition) || "");
  const [developerNocRemarks, setDeveloperNocRemarks] = useState(null);
  const [dataNocRecommendation, setDataNocRecommendation] = useState("");
  const [dataRecommendation, setDataRecommendation] = useState("");
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [selectedObjection, setSelectedObjection] = useState("");
  const [mapSubNocDetails, setMapSubNocDetails] = useState(params === null || params === void 0 ? void 0 : params.nocDetails);
  const [additionalNocDocs, setAdditionalNocDocs] = useState([]);
  const [isNoNoc, setIsNoNoc] = useState(true);
  const checkIsPropertySectionOfficer = () => {
    const norm = s => (s || "").toString().toLowerCase().replace(/[\s_-]+/g, "");
    const allRoles = [...(Array.isArray(userRolesArray) ? userRolesArray : []), ...(Array.isArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles) ? userInfo.roles : [])];
    const hasRoleMatch = allRoles.some(r => {
      const code = norm(typeof r === "string" ? r : r === null || r === void 0 ? void 0 : r.code);
      const name = norm(typeof r === "object" ? r === null || r === void 0 ? void 0 : r.name : "");
      return code.includes("propertysection") || name.includes("propertysection") || code.includes("property") || name.includes("property");
    });
    const hasUserDetailMatch = [norm(userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode), norm(userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationName), norm(userDetails === null || userDetails === void 0 ? void 0 : userDetails.department), norm(userDetails === null || userDetails === void 0 ? void 0 : userDetails.name), norm(userInfo === null || userInfo === void 0 ? void 0 : userInfo.name)].some(s => s.includes("propertysection") || s.includes("property"));
    return Boolean(hasRoleMatch || hasUserDetailMatch);
  };
  const isPropertySectionOfficer = checkIsPropertySectionOfficer();
  const checkIsAvpFile = () => {
    var _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$additionalD4, _formData$bpaData, _formData$bpaData2, _formData$bpaData3, _window$location;
    const norm = s => (s || "").toString().toUpperCase();
    const valuesToCheck = [formData === null || formData === void 0 ? void 0 : formData.applicationNo, formData === null || formData === void 0 ? void 0 : formData.land_Id, formData === null || formData === void 0 ? void 0 : formData.fileNumber, formData === null || formData === void 0 ? void 0 : formData.obpasFileNumber, formData === null || formData === void 0 ? void 0 : formData.prevFileNo, formData === null || formData === void 0 ? void 0 : formData.businessService, formData === null || formData === void 0 ? void 0 : formData.department, formData === null || formData === void 0 ? void 0 : formData.riskType, formData === null || formData === void 0 ? void 0 : formData.applicationType, formData === null || formData === void 0 ? void 0 : formData.applicationFlow, formData === null || formData === void 0 ? void 0 : formData.tenantId, formData === null || formData === void 0 ? void 0 : formData.authority, formData === null || formData === void 0 ? void 0 : formData.developmentAuthority, formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.riskType, formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.applicationFlow, formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.department, formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.scheme, formData === null || formData === void 0 ? void 0 : (_formData$bpaData = formData.bpaData) === null || _formData$bpaData === void 0 ? void 0 : _formData$bpaData.applicationNo, formData === null || formData === void 0 ? void 0 : (_formData$bpaData2 = formData.bpaData) === null || _formData$bpaData2 === void 0 ? void 0 : _formData$bpaData2.land_Id, formData === null || formData === void 0 ? void 0 : (_formData$bpaData3 = formData.bpaData) === null || _formData$bpaData3 === void 0 ? void 0 : _formData$bpaData3.businessService, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.applicationNo, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.sourceRefId, currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.businessService, targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.applicationNo, targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.sourceRefId, targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.businessService, params === null || params === void 0 ? void 0 : params.applicationNo, params === null || params === void 0 ? void 0 : params.land_Id, paramsHook === null || paramsHook === void 0 ? void 0 : paramsHook.id, paramsHook === null || paramsHook === void 0 ? void 0 : paramsHook.authority, paramsHook === null || paramsHook === void 0 ? void 0 : paramsHook.form, typeof window !== "undefined" ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : "", ...(Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocList) ? formData.nocList.map(n => `${(n === null || n === void 0 ? void 0 : n.applicationNo) || ""} ${(n === null || n === void 0 ? void 0 : n.sourceRefId) || ""} ${(n === null || n === void 0 ? void 0 : n.businessService) || ""}`) : [])];
    return valuesToCheck.some(val => norm(val).includes("AVP"));
  };
  const isAvpFile = checkIsAvpFile();
  const showChecklistTab = Boolean(isPropertySectionOfficer && isAvpFile);
  const initialChecklist = (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.checklistNoc) || (targetNoc === null || targetNoc === void 0 ? void 0 : (_targetNoc$additional = targetNoc.additionalDetails) === null || _targetNoc$additional === void 0 ? void 0 : _targetNoc$additional.checklistNoc) || (formData === null || formData === void 0 ? void 0 : formData.checklistNoc) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.checklistNoc) || ((_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : (_Digit5$SessionStorag = _Digit5.SessionStorage) === null || _Digit5$SessionStorag === void 0 ? void 0 : _Digit5$SessionStorag.get("checklistNoc")) || {};
  const [checklistNoc, setChecklistNoc] = useState(initialChecklist);
  const [nocRemarksData, setNocRemarksData] = useState({});
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "EE";
  const isEmployee = history.location.pathname.includes("employee");
  const [mapSubmissionAction, setMapSubmissionAction] = useState(null);
  const isDa = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const inspectionReportChecklist = useSelector(state => state.inspectionReportChecklist);
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.inspectionReportData);
  console.log("formDataNOC", formData, urlFormType);
  const isNocModule = urlFormType === "NOC";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, isNocModule ? "NOC" : false);
  const userRolesWithoutEMP = user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.roles.filter(user => user.code != "EMPLOYEE");
  const drawingPdfs = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(doc => ["drawingPdf"].includes(doc.documentType));
  const Modal = useModal();
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const isMapSubmission = appType === "FORM_MAP";
  const [initialUrl, setInitialUrl] = useState("");
  const isApplyForDSCStatus = st => {
    if (!st || typeof st !== "string") return false;
    const upper = st.toUpperCase().trim();
    const normalized = upper.replace(/[\s_]+/g, "_");
    return normalized.includes("APPLY_FOR_DSC") || normalized.includes("APPLY_DSC") || normalized.includes("PENDING_FOR_DSC") || normalized.includes("PENDING_DSC") || upper.includes("APPLY FOR DSC") || upper.includes("FORWARD_TO_OFFICER_AFTER_DSC") || upper.endsWith("_AFTER_PAYMENT");
  };
  const isDscSigned = target => {
    if (!target || typeof target !== "object") return false;
    return Boolean(target.IsApprovalCertificate === true || String(target.IsApprovalCertificate).toLowerCase() === "true" || target.isApprovalCertificate === true || String(target.isApprovalCertificate).toLowerCase() === "true" || typeof target.ApprovalsignedPdfUrl === "string" && target.ApprovalsignedPdfUrl.trim() !== "" || typeof target.approvalSignedPdfUrl === "string" && target.approvalSignedPdfUrl.trim() !== "" || typeof target.signedPdfUrl === "string" && target.signedPdfUrl.trim() !== "" || typeof target.signedApprovalUrl === "string" && target.signedApprovalUrl.trim() !== "" || target.isSigned === true || target.IsSigned === true || target.IsSignedDrawingPdfDscEmp === true);
  };
  const isDscStage = Boolean(isApplyForDSCStatus(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.applicationStatus) || isApplyForDSCStatus(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.status) || isApplyForDSCStatus(nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.applicationStatus) || isApplyForDSCStatus(nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.status) || isApplyForDSCStatus(formData === null || formData === void 0 ? void 0 : formData.status) || isApplyForDSCStatus(formData === null || formData === void 0 ? void 0 : formData.applicationStatus) || isApplyForDSCStatus(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.state) || isApplyForDSCStatus(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.actionState) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.status) || isApplyForDSCStatus(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.processInstances) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6[0]) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.state) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.state) || Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocList) && formData.nocList.some(noc => (!id || (noc === null || noc === void 0 ? void 0 : noc.applicationNo) === id || (noc === null || noc === void 0 ? void 0 : noc.businessService) === currentNOCDept) && (isApplyForDSCStatus(noc === null || noc === void 0 ? void 0 : noc.applicationStatus) || isApplyForDSCStatus(noc === null || noc === void 0 ? void 0 : noc.status))) || Array.isArray(params === null || params === void 0 ? void 0 : params.nocList) && params.nocList.some(noc => (!id || (noc === null || noc === void 0 ? void 0 : noc.applicationNo) === id || (noc === null || noc === void 0 ? void 0 : noc.businessService) === currentNOCDept) && (isApplyForDSCStatus(noc === null || noc === void 0 ? void 0 : noc.applicationStatus) || isApplyForDSCStatus(noc === null || noc === void 0 ? void 0 : noc.status))));
  const isDigitalSignatureAttached = Boolean(isDscSigned(currentFormData) || isDscSigned(nocFormData) || isDscSigned(formData) || Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocList) && formData.nocList.some(noc => (!id || (noc === null || noc === void 0 ? void 0 : noc.applicationNo) === id || (noc === null || noc === void 0 ? void 0 : noc.businessService) === currentNOCDept) && isDscSigned(noc)) || Array.isArray(params === null || params === void 0 ? void 0 : params.nocList) && params.nocList.some(noc => (!id || (noc === null || noc === void 0 ? void 0 : noc.applicationNo) === id || (noc === null || noc === void 0 ? void 0 : noc.businessService) === currentNOCDept) && isDscSigned(noc)));
  const rawNocLetter = (currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.nocLetterInfo) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.nocLetterInfo);
  const nocLetterObj = Array.isArray(rawNocLetter) ? rawNocLetter.find(r => (r === null || r === void 0 ? void 0 : r.fileStoreUrl) || (r === null || r === void 0 ? void 0 : r.url) || (r === null || r === void 0 ? void 0 : r.fileStoreId)) || rawNocLetter[0] : rawNocLetter;
  const deptNocLetter = Array.isArray(formData === null || formData === void 0 ? void 0 : formData.nocLetterInfo) && formData.nocLetterInfo.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode));
  const requestLetterId = (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.fileStoreUrl) || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.url) || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.fileStoreId) || (deptNocLetter === null || deptNocLetter === void 0 ? void 0 : deptNocLetter.fileStoreUrl) || (deptNocLetter === null || deptNocLetter === void 0 ? void 0 : deptNocLetter.url) || (deptNocLetter === null || deptNocLetter === void 0 ? void 0 : deptNocLetter.fileStoreId) || (currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.requestLetterUrl) || (targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.requestLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.requestLetterUrl) || null;
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto", "kmlFile"];
  const documentSection = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(doc => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType));
  const fetchInitialUrl = async fileStoreId => {
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    setIframeSrc(response.data.fileStoreIds[0].url);
  };
  const fetchInitialPdfUrl = async fileStoreId => {
    var _response$data, _response$data$fileSt, _response$data$fileSt2;
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    console.log("responseFromFileStore", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$fileSt = _response$data.fileStoreIds) === null || _response$data$fileSt === void 0 ? void 0 : (_response$data$fileSt2 = _response$data$fileSt[0]) === null || _response$data$fileSt2 === void 0 ? void 0 : _response$data$fileSt2.url);
    setPdfIframeSrc(response.data.fileStoreIds[0].url);
  };
  const checkIsBpaNoc = val => {
    if (!val) return false;
    if (typeof val === "string") return val.toUpperCase().includes("BPA_NOC_");
    if (Array.isArray(val)) return val.some(item => checkIsBpaNoc(item));
    if (typeof val === "object") return checkIsBpaNoc((val === null || val === void 0 ? void 0 : val.businessService) || (val === null || val === void 0 ? void 0 : val.applicationBusinessService));
    return false;
  };
  const isBpaNoc = Boolean(checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.businessService) || checkIsBpaNoc(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.businessService) || checkIsBpaNoc(nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.businessService) || checkIsBpaNoc(targetNoc === null || targetNoc === void 0 ? void 0 : targetNoc.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.applicationBusinessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.businessService) || checkIsBpaNoc(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : _workflowDetails$data11.processInstances) || checkIsBpaNoc(formData === null || formData === void 0 ? void 0 : formData.nocList) || checkIsBpaNoc(params === null || params === void 0 ? void 0 : params.nocList) || checkIsBpaNoc(nocResponse === null || nocResponse === void 0 ? void 0 : nocResponse.Noc) || checkIsBpaNoc(urlFormType) || checkIsBpaNoc(userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode));
  const getValidityOfEmp = () => {
    var _formData$assignes;
    if (isBpaNoc) {
      return true;
    }
    if ((formData === null || formData === void 0 ? void 0 : (_formData$assignes = formData.assignes) === null || _formData$assignes === void 0 ? void 0 : _formData$assignes.length) > 0) {
      var _formData$assignes2, _formData$assignes2$, _formData$assignes3, _formData$assignes3$;
      console.log("loggingValidityOfEmp", (formData === null || formData === void 0 ? void 0 : (_formData$assignes2 = formData.assignes) === null || _formData$assignes2 === void 0 ? void 0 : (_formData$assignes2$ = _formData$assignes2[0]) === null || _formData$assignes2$ === void 0 ? void 0 : _formData$assignes2$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid));
      return (formData === null || formData === void 0 ? void 0 : (_formData$assignes3 = formData.assignes) === null || _formData$assignes3 === void 0 ? void 0 : (_formData$assignes3$ = _formData$assignes3[0]) === null || _formData$assignes3$ === void 0 ? void 0 : _formData$assignes3$.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid);
    }
    return true;
  };
  const isValidEmp = getValidityOfEmp();
  useEffect(async () => {
    var _formData$documents3, _formData$nocDetails, _Object$values, _formData$nocDetails2, _formData$nocDetails3, _formData$nocDetails4, _documentSection$;
    const isDocValidated = formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : _formData$documents3.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).some(item => item.documentRemarks !== null);
    const isNocValidated = (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.officerNOCData) && ((_Object$values = Object.values(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.officerNOCData)) === null || _Object$values === void 0 ? void 0 : _Object$values.some(Boolean)) || (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : (_formData$nocDetails4 = _formData$nocDetails3.additionalOfficerNOCData) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.length) > 0;
    console.log("isValidationsss", {
      isDocValidated,
      isNocValidated
    });
    if (isDocValidated) {
      var _Digit6;
      (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("isDocValidated", isDocValidated);
    }
    if (isNocValidated) {
      var _Digit7;
      (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.set("isNocValidates", isNocValidated);
    }
    const result = await getRequestLetterURL();
    setRequestLetterUrl(result);
    fetchInitialUrl(documentSection === null || documentSection === void 0 ? void 0 : (_documentSection$ = documentSection[0]) === null || _documentSection$ === void 0 ? void 0 : _documentSection$.fileStoreId);
    if (drawingPdfs) {
      var _drawingPdfs$;
      fetchInitialPdfUrl(drawingPdfs === null || drawingPdfs === void 0 ? void 0 : (_drawingPdfs$ = drawingPdfs[0]) === null || _drawingPdfs$ === void 0 ? void 0 : _drawingPdfs$.fileStoreId);
    }
  }, []);
  const handleDocView = () => {
    setCurrentView(prev => prev === "documents" ? "viewDocuments" : "documents");
  };
  const handleNoWorkflow = updatedDocuments => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      workflow,
      documents: updatedDocuments
    };
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA, _result$BPA2, _result$BPA2$, _result$BPA2$$documen, _Digit8;
        console.log("resultFromUpdate", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        const isDocValidated = result === null || result === void 0 ? void 0 : (_result$BPA2 = result.BPA) === null || _result$BPA2 === void 0 ? void 0 : (_result$BPA2$ = _result$BPA2[0]) === null || _result$BPA2$ === void 0 ? void 0 : (_result$BPA2$$documen = _result$BPA2$.documents) === null || _result$BPA2$$documen === void 0 ? void 0 : _result$BPA2$$documen.filter(item => !excludedTypesForDocSection.includes(item.documentType) && !/_\d+$/.test(item.documentType || "")).every(item => !item.isMandatory || item.documentRemarks !== null);
        (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.set("isDocValidated", isDocValidated);
      }
    });
  };
  const handleLandAquisition = data => {
    var _mapSubmissionAction$;
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction: {
        ...mapSubmissionAction,
        action: mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : (_mapSubmissionAction$ = mapSubmissionAction.action) === null || _mapSubmissionAction$ === void 0 ? void 0 : _mapSubmissionAction$.replace("NOC_ACTION_", "")
      },
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray
    };
    setLoader(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    const newPayload = {
      ...payload,
      Noc: {
        ...(payload === null || payload === void 0 ? void 0 : payload.Noc),
        landAcquisitionCheckList: data === null || data === void 0 ? void 0 : data.landAcquisitionCheckList,
        documents: data === null || data === void 0 ? void 0 : data.documents,
        workflow
      }
    };
    console.log("payloadFromSubmit LAND ACQUISTIONS", newPayload, payload, "context", context, isNocModule);
    updateApiCall.mutate(newPayload, {
      onSuccess: result => {
        onSuccessHandlers[moduleKey](formData, currentAction, t, clearParams, payload);
      },
      onError: () => {
        Modal("Update Error", "Something went wrong!!", "error");
      }
    });
    setLoader(false);
  };
  const handleNoWorkflowNoc = (nocDetails, setLoading) => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      workflow,
      nocDetails: nocDetails,
      additionalDetails: {
        ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
        nocDetails: nocDetails
      }
    };
    updateApiCall.mutate({
      BPA: appData
    }, {
      onSuccess: result => {
        var _result$BPA3, _result$BPA4, _result$BPA4$, _Digit9;
        console.log("resultFromUpdate", result);
        const updatedBpa = {
          ...((result === null || result === void 0 ? void 0 : (_result$BPA3 = result.BPA) === null || _result$BPA3 === void 0 ? void 0 : _result$BPA3[0]) || appData),
          nocDetails: nocDetails,
          additionalDetails: {
            ...((result === null || result === void 0 ? void 0 : (_result$BPA4 = result.BPA) === null || _result$BPA4 === void 0 ? void 0 : (_result$BPA4$ = _result$BPA4[0]) === null || _result$BPA4$ === void 0 ? void 0 : _result$BPA4$.additionalDetails) || (formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
            nocDetails: nocDetails
          }
        };
        onSelect("", updatedBpa);
        setLoading(false);
        (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.set("isNocValidated", true);
        Modal(`NOC details updated`, `NOC details for <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo})</strong> updated successfully!`, "success");
      }
    });
  };
  const stripHtmlTags = html => {
    if (!html) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.innerText || tempDiv.textContent || "";
    return text.replace(/\u00a0/g, " ").trim();
  };
  const getTabIndex = (isDa, isEE, baseIndex) => {
    const result = !isDa && isEE ? baseIndex : baseIndex + 1;
    console.log("loggingGetTabIndex", String(result));
    return String(result);
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  console.log(reduxFormData, inspectionReportChecklist === null || inspectionReportChecklist === void 0 ? void 0 : inspectionReportChecklist.inspectionReportData, "logging111111111111", developerRemarks);
  let userRole = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code;
  let schemeType = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType;
  let landArea = formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.landArea;
  let primaryUse = formData === null || formData === void 0 ? void 0 : formData.primaryUse;
  let isResidential = primaryUse === "Residential";
  let isCommercial = primaryUse === "Commercial";
  let isScheme = schemeType === "Scheme";
  let isUnapproved = schemeType !== "Scheme";
  console.log({
    isResidential,
    isCommercial,
    isScheme,
    isUnapproved,
    userRole,
    landArea
  }, workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data12 = workflowDetails.data) === null || _workflowDetails$data12 === void 0 ? void 0 : (_workflowDetails$data13 = _workflowDetails$data12.actionState) === null || _workflowDetails$data13 === void 0 ? void 0 : _workflowDetails$data13.nextActions, "loggingConditions");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data14 = workflowDetails.data) === null || _workflowDetails$data14 === void 0 ? void 0 : (_workflowDetails$data15 = _workflowDetails$data14.actionState) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(item => {
    if (isNocModule) {
      return item.action === "DEEMED_APPROVAL" ? false : true;
    }
  }).map(item => ({
    ...item,
    action: `NOC_ACTION_${item.action}`
  }));
  let tabList = [{
    label: "Application Data",
    color: "red"
  }, {
    label: "Documents",
    color: "red"
  }, {
    label: "Drawings",
    color: "red"
  }, {
    label: "Site Inspection",
    color: "green"
  }, !isDa && !isEE || isDa ? {
    label: "Payment Heads",
    color: "red"
  } : null, {
    label: "WF_TAKE_ACTION",
    color: "red"
  }, {
    label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS",
    color: "green"
  }, {
    label: "ChatBoard",
    color: "green"
  }, {
    label: "Letter",
    color: "green"
  }].filter(Boolean);
  const searchNocRemarks = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.bpaService.nocRemarks}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNocRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const createNocRemarks = async () => {
    var _nocAppNo$value, _userRolesArray$4, _userRolesArray$5;
    setLoader(true);
    const applicationId = nocAppNo && (nocAppNo.nocAppNo || ((_nocAppNo$value = nocAppNo.value) === null || _nocAppNo$value === void 0 ? void 0 : _nocAppNo$value.nocAppNo)) || (nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNo);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
          name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
          role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$4 = userRolesArray[0]) === null || _userRolesArray$4 === void 0 ? void 0 : _userRolesArray$4.code,
          applicationID: applicationId,
          designation: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$5 = userRolesArray[0]) === null || _userRolesArray$5 === void 0 ? void 0 : _userRolesArray$5.name,
          applicationStatus: nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.applicationStatus
        },
        ...(isCitizen ? {
          applicantRemarks: remarks
        } : {
          nocOfficerRemarks: remarks
        }),
        isApproved: "nocRemarks",
        nocOfficerRemarks: nocOfficerRemarks || "",
        applicantRemarks: remarks || "",
        documentDetailsLtp: uploadedFiles
      }
    };
    try {
      const Resp = await axios$1.post(Urls$1.bpaService.remarksDetail, postData, {}).then(response => {
        console.log("log", Resp, response.data);
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    await searchNocRemarks(nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.applicationNo);
  };
  const moduleHandlers = {
    NOC: context => {
      var _context$userDetails, _context$formData, _context$formData$noc, _context$formData2, _context$formData2$no, _Digit10, _Digit10$SessionStora, _context$mapSubmissio;
      const currentNOCDept = (_context$userDetails = context.userDetails) === null || _context$userDetails === void 0 ? void 0 : _context$userDetails.organisationCode;
      const nocPayload = isCitizen ? (_context$formData = context.formData) === null || _context$formData === void 0 ? void 0 : (_context$formData$noc = _context$formData.nocList) === null || _context$formData$noc === void 0 ? void 0 : _context$formData$noc.find(item => (item === null || item === void 0 ? void 0 : item.applicationNo) === nocAppNo.nocAppNo) : (_context$formData2 = context.formData) === null || _context$formData2 === void 0 ? void 0 : (_context$formData2$no = _context$formData2.nocList) === null || _context$formData2$no === void 0 ? void 0 : _context$formData2$no.find(item => (item === null || item === void 0 ? void 0 : item.businessService) === currentNOCDept);
      console.log("loggingNocPayload", nocPayload, context.formData, context.userDetails, nocAppNo, currentNOCDept);
      const effectiveChecklist = context.checklistNoc || ((_Digit10 = Digit) === null || _Digit10 === void 0 ? void 0 : (_Digit10$SessionStora = _Digit10.SessionStorage) === null || _Digit10$SessionStora === void 0 ? void 0 : _Digit10$SessionStora.get("checklistNoc")) || null;
      return {
        Noc: {
          ...nocPayload,
          checklistNoc: effectiveChecklist,
          additionalDetails: {
            ...((nocPayload === null || nocPayload === void 0 ? void 0 : nocPayload.additionalDetails) || {}),
            checklistNoc: effectiveChecklist
          },
          termsAndCondition: nocOfficerRemarks,
          workflow: {
            action: (_context$mapSubmissio = context.mapSubmissionAction) === null || _context$mapSubmissio === void 0 ? void 0 : _context$mapSubmissio.action,
            comment: context.remarks,
            nocDocuments: uploadedFiles,
            nocDetails: nocOfficerRemarks
          }
        }
      };
    },
    BPA: context => {
      var _context$params, _context$formData3, _context$params2, _context$params2$addi, _context$formData4, _context$formData4$ad, _Digit11, _Digit11$SessionStora, _context$formData5, _context$params3, _Digit12, _Digit12$SessionStora, _context$mapSubmissio2, _context$params4, _context$formData6, _context$userRolesArr, _context$userRolesArr2, _context$siteInspecti, _context$siteInspecti2, _context$siteInspecti3, _context$formData7;
      const effectiveNocDetails = ((_context$params = context.params) === null || _context$params === void 0 ? void 0 : _context$params.nocDetails) || ((_context$formData3 = context.formData) === null || _context$formData3 === void 0 ? void 0 : _context$formData3.nocDetails) || ((_context$params2 = context.params) === null || _context$params2 === void 0 ? void 0 : (_context$params2$addi = _context$params2.additionalDetails) === null || _context$params2$addi === void 0 ? void 0 : _context$params2$addi.nocDetails) || ((_context$formData4 = context.formData) === null || _context$formData4 === void 0 ? void 0 : (_context$formData4$ad = _context$formData4.additionalDetails) === null || _context$formData4$ad === void 0 ? void 0 : _context$formData4$ad.nocDetails);
      return {
        BPA: {
          ...context.formData,
          customLetter: context.typeOfLetter,
          checklistNoc: context.checklistNoc || ((_Digit11 = Digit) === null || _Digit11 === void 0 ? void 0 : (_Digit11$SessionStora = _Digit11.SessionStorage) === null || _Digit11$SessionStora === void 0 ? void 0 : _Digit11$SessionStora.get("checklistNoc")) || null,
          nocDetails: effectiveNocDetails,
          additionalDetails: {
            ...(((_context$formData5 = context.formData) === null || _context$formData5 === void 0 ? void 0 : _context$formData5.additionalDetails) || {}),
            ...(((_context$params3 = context.params) === null || _context$params3 === void 0 ? void 0 : _context$params3.additionalDetails) || {}),
            ...(effectiveNocDetails ? {
              nocDetails: effectiveNocDetails
            } : {}),
            checklistNoc: context.checklistNoc || ((_Digit12 = Digit) === null || _Digit12 === void 0 ? void 0 : (_Digit12$SessionStora = _Digit12.SessionStorage) === null || _Digit12$SessionStora === void 0 ? void 0 : _Digit12$SessionStora.get("checklistNoc")) || null
          },
          workflow: {
            action: (_context$mapSubmissio2 = context.mapSubmissionAction) === null || _context$mapSubmissio2 === void 0 ? void 0 : _context$mapSubmissio2.action,
            comments: context.remarks
          },
          documents: [...((_context$params4 = context.params) === null || _context$params4 === void 0 ? void 0 : _context$params4.documents), ...context.customLetter],
          taxHeadEstimates: [...((_context$formData6 = context.formData) === null || _context$formData6 === void 0 ? void 0 : _context$formData6.taxHeadEstimates), ...context.taxHead] || [],
          inspectionDetailData: ["JE", "EE"].includes((_context$userRolesArr = context.userRolesArray) === null || _context$userRolesArr === void 0 ? void 0 : (_context$userRolesArr2 = _context$userRolesArr[0]) === null || _context$userRolesArr2 === void 0 ? void 0 : _context$userRolesArr2.code) ? (_context$siteInspecti = context.siteInspectionRemarksData) === null || _context$siteInspecti === void 0 ? void 0 : (_context$siteInspecti2 = _context$siteInspecti.DetailDataRemarks) === null || _context$siteInspecti2 === void 0 ? void 0 : (_context$siteInspecti3 = _context$siteInspecti2[0]) === null || _context$siteInspecti3 === void 0 ? void 0 : _context$siteInspecti3.inspectionDetails : (_context$formData7 = context.formData) === null || _context$formData7 === void 0 ? void 0 : _context$formData7.inspectionDetailData
        }
      };
    }
  };
  const validateBeforeSubmit = ({
    isValidEmp,
    currentAction,
    mapSubmissionAction,
    isDocValidated,
    remarks,
    nocOfficerRemarks: paramNocRemarks,
    setError
  }) => {
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return false;
    }
    const selectedAction = (typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (typeof mapSubmissionAction === "object" ? mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action : mapSubmissionAction) || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) || (mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : mapSubmissionAction.action) || "";
    const isSendBackAction = typeof selectedAction === "string" && selectedAction.toUpperCase().includes("SEND_BACK");
    if (!(currentAction !== null && currentAction !== void 0 && currentAction.action) && !(mapSubmissionAction !== null && mapSubmissionAction !== void 0 && mapSubmissionAction.action) && !selectedAction) {
      Modal("Action required", "Please select at least one action.", "error");
      return false;
    }
    if (!isSendBackAction && !isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return false;
    }
    if (isDscStage && !isDigitalSignatureAttached) {
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached before submitting.", "error");
      return false;
    }
    const effectiveNocRemarks = paramNocRemarks !== undefined ? paramNocRemarks : nocOfficerRemarks;
    const targetRemarks = !isCitizen ? effectiveNocRemarks || remarks : remarks || effectiveNocRemarks;
    const plainText = stripHtmlTags(targetRemarks);
    if (plainText.trim().length === 0) {
      setError(true);
      if (!isCitizen) {
        Modal("Terms & Condition required", "Please enter Terms & Condition before submitting.", "error");
      } else {
        Modal("Remarks required", "Please enter remarks before submitting.", "error");
      }
      return false;
    }
    setError(false);
    return true;
  };
  useEffect(() => {
    searchNocRemarks(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.applicationNo);
  }, [currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.applicationNo]);
  const onSuccessHandlers = {
    NOC: (formData, currentAction, t, clearParams, payload) => {
      var _payload$Noc, _Digit13, _Digit14, _Digit15, _Digit16, _Digit17, _Digit18;
      Modal(`Application ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}`, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}</strong> updated successfully.`, "success", !isCitizen ? "/digit-ui/employee" : `digit-ui/citizen/obps/services/${payload === null || payload === void 0 ? void 0 : (_payload$Noc = payload.Noc) === null || _payload$Noc === void 0 ? void 0 : _payload$Noc.applicationNo}`);
      clearParams();
      (_Digit13 = Digit) === null || _Digit13 === void 0 ? void 0 : _Digit13.SessionStorage.del("EMP_NOC");
      (_Digit14 = Digit) === null || _Digit14 === void 0 ? void 0 : _Digit14.SessionStorage.del("isDocValidated");
      (_Digit15 = Digit) === null || _Digit15 === void 0 ? void 0 : _Digit15.SessionStorage.del("isSitePhotoUploaded");
      (_Digit16 = Digit) === null || _Digit16 === void 0 ? void 0 : _Digit16.SessionStorage.del("isNotingValidated");
      (_Digit17 = Digit) === null || _Digit17 === void 0 ? void 0 : _Digit17.SessionStorage.del("isPaymenthead");
      (_Digit18 = Digit) === null || _Digit18 === void 0 ? void 0 : _Digit18.SessionStorage.del("checklistNoc");
    },
    BPA: (formData, currentAction, t, clearParams) => {
      var _Digit19, _Digit20, _Digit21, _Digit22, _Digit23, _Digit24;
      Modal(`Application ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}`, `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) ${t(currentAction === null || currentAction === void 0 ? void 0 : currentAction.action)}</strong> updated successfully.`, "success", "/digit-ui/employee");
      clearParams();
      (_Digit19 = Digit) === null || _Digit19 === void 0 ? void 0 : _Digit19.SessionStorage.del("EMP_NOC");
      (_Digit20 = Digit) === null || _Digit20 === void 0 ? void 0 : _Digit20.SessionStorage.del("isDocValidated");
      (_Digit21 = Digit) === null || _Digit21 === void 0 ? void 0 : _Digit21.SessionStorage.del("isSitePhotoUploaded");
      (_Digit22 = Digit) === null || _Digit22 === void 0 ? void 0 : _Digit22.SessionStorage.del("isNotingValidated");
      (_Digit23 = Digit) === null || _Digit23 === void 0 ? void 0 : _Digit23.SessionStorage.del("customLetter");
      (_Digit24 = Digit) === null || _Digit24 === void 0 ? void 0 : _Digit24.SessionStorage.del("checklistNoc");
    }
  };
  const handleSubmit = () => {
    var _mapSubmissionAction$2;
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction: {
        ...mapSubmissionAction,
        action: mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : (_mapSubmissionAction$2 = mapSubmissionAction.action) === null || _mapSubmissionAction$2 === void 0 ? void 0 : _mapSubmissionAction$2.replace("NOC_ACTION_", "")
      },
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
      checklistNoc
    };
    const isValid = validateBeforeSubmit({
      isValidEmp,
      currentAction,
      mapSubmissionAction: context.mapSubmissionAction,
      isDocValidated: true,
      remarks,
      nocOfficerRemarks,
      setError
    });
    if (!isValid) return;
    setLoader(true);
    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    console.log("payloadFromSubmit", payload, "context", context, isNocModule);
    createNocRemarks();
    updateApiCall.mutate(payload, {
      onSuccess: result => {
        onSuccessHandlers[moduleKey](formData, currentAction, t, clearParams, payload);
      }
    });
    setLoader(false);
  };
  const handleNoWorkflowPayNOC = data => {
    var _mapSubmissionAction$3, _Digit25, _Digit25$SessionStora;
    const context = {
      isNocModule,
      userDetails,
      formData,
      mapSubmissionAction: {
        ...mapSubmissionAction,
        action: mapSubmissionAction === null || mapSubmissionAction === void 0 ? void 0 : (_mapSubmissionAction$3 = mapSubmissionAction.action) === null || _mapSubmissionAction$3 === void 0 ? void 0 : _mapSubmissionAction$3.replace("NOC_ACTION_", "")
      },
      currentAction,
      remarks,
      typeOfLetter,
      params,
      customLetter,
      taxHead,
      userRolesArray,
      checklistNoc
    };
    console.log(data, "datatara");
    if (!isBpaNoc && !isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    setLoading(true);
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const moduleKey = isNocModule ? "NOC" : "BPA";
    const payload = moduleHandlers[moduleKey](context);
    console.log("payloadFromSubmit 7600000", payload, "context", context, isNocModule);
    const appData = {
      ...nocFormData,
      ...data,
      ...(context.checklistNoc ? {
        checklistNoc: context.checklistNoc
      } : {}),
      additionalDetails: {
        ...((nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.additionalDetails) || {}),
        ...((data === null || data === void 0 ? void 0 : data.additionalDetails) || {}),
        checklistNoc: context.checklistNoc || ((_Digit25 = Digit) === null || _Digit25 === void 0 ? void 0 : (_Digit25$SessionStora = _Digit25.SessionStorage) === null || _Digit25$SessionStora === void 0 ? void 0 : _Digit25$SessionStora.get("checklistNoc")) || null
      },
      workflow
    };
    updateApiCall.mutate({
      Noc: appData
    }, {
      onSuccess: result => {
        var _result$Noc, _result$Noc$;
        console.log(result, "result");
        setLoading(false);
        Modal("Payment details updated", `Payment details for <strong>(${result === null || result === void 0 ? void 0 : (_result$Noc = result.Noc) === null || _result$Noc === void 0 ? void 0 : (_result$Noc$ = _result$Noc[0]) === null || _result$Noc$ === void 0 ? void 0 : _result$Noc$.applicationNo})</strong> updated successfully!`, "success", null, () => window.location.reload(), "OK");
      }
    });
  };
  const onDropDownSelect = event => {
    const value = event.target.value;
    if (isMapSubmission) {
      console.log("radioAction", value);
      setMapSubmissionAction(value);
      setCurrentAction(value);
    } else {
      setCurrentAction(value);
    }
  };
  console.log(dataRecommendationDocument, developerRemarksDocument, updatedDocuments, "loggingDataRecommendation");
  useEffect(() => {
    var _updatedDocuments$fil;
    if (dataRecommendationDocument && developerRemarksDocument && updatedDocuments !== null && updatedDocuments !== void 0 && (_updatedDocuments$fil = updatedDocuments.filter(doc => doc.isMandatory)[0]) !== null && _updatedDocuments$fil !== void 0 && _updatedDocuments$fil.documentRemarks && isValidEmp) {
      callDocumentDetailsAPI();
    }
  }, [dataRecommendationDocument, developerRemarksDocument, updatedDocuments === null || updatedDocuments === void 0 ? void 0 : (_updatedDocuments$ = updatedDocuments[0]) === null || _updatedDocuments$ === void 0 ? void 0 : _updatedDocuments$.documentRemarks, isValidEmp]);
  useEffect(() => {
    const applicationNumber = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
    if (!applicationNumber) {
      console.warn("⚠️ Application number not found yet.");
      return;
    }
    onSelect("", formData);
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  console.log("dataRecommendation000", dataRecommendation, developerRemarks, updatedDocuments);
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const onRadioActionSelect = value => {
    setCurrentAction(value);
  };
  console.log("loggingActionsFromHook", actions);
  return {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    setCurrentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    setDeveloperNocRemarks,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    dataRecommendationDocument,
    setSelectedObjection,
    setCustomLetter,
    setTypeOfLetter,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    userRolesArray,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    handleNoWorkflowPayNOC,
    isValidEmp,
    isBpaNoc,
    requestLetterId,
    currentFormData,
    nocOfficerRemarks,
    setNocOfficerRemarks,
    uploadedFiles,
    setUploadedFiles,
    nocFormData,
    searchNocRemarks,
    nocRemarksData,
    isDscStage,
    isDigitalSignatureAttached,
    isApplyForDSCStatus,
    isDscSigned,
    checklistNoc,
    setChecklistNoc,
    isPropertySectionOfficer,
    isAvpFile,
    showChecklistTab,
    handleLandAquisition,
    urlApplicationNo,
    stripHtmlTags
  };
};

const CollapseSection = ({
  title,
  children,
  defaultOpen: _defaultOpen = false,
  isOpen,
  onToggle,
  headerBg: _headerBg = "rgba(52, 73, 94, 0.94)",
  headerColor: _headerColor = "#fff",
  iconColor: _iconColor = "#fff",
  style: _style = {}
}) => {
  const [internalOpen, setInternalOpen] = useState(_defaultOpen);
  const open = isOpen !== undefined ? isOpen : internalOpen;
  const handleToggle = () => {
    if (onToggle) {
      onToggle(!open);
    } else {
      setInternalOpen(!open);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "1rem",
      marginTop: `1rem`
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "collapse-header",
    onClick: handleToggle,
    "aria-controls": "collapse-content",
    "aria-expanded": open,
    style: {
      background: _headerBg,
      padding: "0.25rem 1.25rem",
      borderRadius: "0.25rem",
      fontWeight: "600",
      display: "flex",
      cursor: "pointer",
      justifyContent: "space-between",
      alignItems: "center",
      color: "white",
      ..._style
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: 16,
      color: "white"
    }
  }, title), open ? /*#__PURE__*/React__default.createElement(RemoveIcon$1, {
    sx: {
      color: _iconColor
    }
  }) : /*#__PURE__*/React__default.createElement(AddIcon$1, {
    sx: {
      color: _iconColor
    }
  })), /*#__PURE__*/React__default.createElement(Collapse$1, {
    in: open
  }, /*#__PURE__*/React__default.createElement("div", {
    id: "collapse-content",
    style: {
      marginTop: 12,
      paddingLeft: 12,
      paddingRight: 12
    }
  }, children)));
};

const NOCDetailsLog = ({
  logData,
  nocRemarksData
}) => {
  var _user$info, _popupData$userDetail, _popupData$userDetail2, _popupData$userDetail3, _popupData$auditDetai;
  const termsAndCondition = Digit.SessionStorage.get("nocTermsAndCondition", logData);
  console.log("logDataNOC", logData, termsAndCondition, nocRemarksData);
  let user = Digit.UserService.getUser();
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "CITIZEN";
  const detailsArray = !isCitizen ? nocRemarksData === null || nocRemarksData === void 0 ? void 0 : nocRemarksData.DetailDataRemarks : termsAndCondition === null || termsAndCondition === void 0 ? void 0 : termsAndCondition.DetailDataRemarks;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const {
    nocAppNo,
    nocSearchResult
  } = Digit.SessionStorage.get("nocAppNo") || {};
  const nocCurrentFormData = isCitizen ? logData === null || logData === void 0 ? void 0 : logData.nocList.find(item => item.applicationNo == nocAppNo) : logData === null || logData === void 0 ? void 0 : logData.nocList.find(n => n.businessService == (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode));
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showDocsPopup, setShowDocsPopup] = useState(false);
  const [docsContextItem, setDocsContextItem] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const openDocsPopup = item => {
    setDocsContextItem(item);
    setShowDocsPopup(true);
  };
  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };
  const closeDocsPopup = () => {
    setShowDocsPopup(false);
    setDocsContextItem(null);
  };
  const handleLoadDocument = async fileStoreId => {
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  const printPopup = () => {
    const popupContent = document.getElementById("noc-popup-print");
    if (!popupContent) return;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print NOC Details</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      margin: 0
    }
  }, "NOC Details Log")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "600px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "Department"), /*#__PURE__*/React__default.createElement("th", null, "Department Remarks"), /*#__PURE__*/React__default.createElement("th", null, "LTP Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray === null || detailsArray === void 0 ? void 0 : detailsArray.map((item, index) => {
    var _item$auditDetails;
    const createdTime = (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || null;
    const departmentRemarks = item === null || item === void 0 ? void 0 : item.nocOfficerRemarks;
    const myRemarks = item === null || item === void 0 ? void 0 : item.applicantRemarks;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, departmentRemarks ? nocCurrentFormData === null || nocCurrentFormData === void 0 ? void 0 : nocCurrentFormData.nocName : "Licensed Technical Professional"), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: departmentRemarks || "-",
      tag: "td"
    }), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: myRemarks || "-",
      tag: "td"
    }), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: createdTime
    })), /*#__PURE__*/React__default.createElement("td", null, item !== null && item !== void 0 && item.documentDetailsLtp && item.documentDetailsLtp.length > 0 ? /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => openDocsPopup(item),
      size: "small",
      title: "View Documents"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    })) : "-"));
  })))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "60%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", null, "NOC Details Info"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: printPopup,
    title: "Print"
  }, /*#__PURE__*/React__default.createElement(PrintIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closePopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement("div", {
    id: "noc-popup-print"
  }, (popupData === null || popupData === void 0 ? void 0 : popupData.userDetails) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "User:"), " ", ((_popupData$userDetail = popupData.userDetails) === null || _popupData$userDetail === void 0 ? void 0 : _popupData$userDetail.employeeName) || ((_popupData$userDetail2 = popupData.userDetails) === null || _popupData$userDetail2 === void 0 ? void 0 : _popupData$userDetail2.name) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Designation:"), " ", ((_popupData$userDetail3 = popupData.userDetails) === null || _popupData$userDetail3 === void 0 ? void 0 : _popupData$userDetail3.designation) || "-", " | ", /*#__PURE__*/React__default.createElement("strong", null, "Created:"), " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
    timestamp: (_popupData$auditDetai = popupData.auditDetails) === null || _popupData$auditDetai === void 0 ? void 0 : _popupData$auditDetai.createdTime
  })), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Department"), /*#__PURE__*/React__default.createElement("th", null, "Application Number"), /*#__PURE__*/React__default.createElement("th", null, "Status"), /*#__PURE__*/React__default.createElement("th", null, "Comments"))), /*#__PURE__*/React__default.createElement("tbody", null, ((popupData === null || popupData === void 0 ? void 0 : popupData.nocDetails) || []).map((noc, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, (noc === null || noc === void 0 ? void 0 : noc.department) || "-"), /*#__PURE__*/React__default.createElement("td", null, (noc === null || noc === void 0 ? void 0 : noc.applicationNumber) || "-"), /*#__PURE__*/React__default.createElement("td", null, (noc === null || noc === void 0 ? void 0 : noc.status) || "-"), /*#__PURE__*/React__default.createElement("td", null, popupData !== null && popupData !== void 0 && popupData.nocRemarks ? /*#__PURE__*/React__default.createElement(SafeHtml, {
    html: popupData.nocRemarks
  }) : "-"))))))), showDocsPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "15%",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "20px",
      zIndex: 1000,
      maxHeight: "80vh",
      overflowY: "auto",
      width: "70%",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontSize: "14px",
      margin: 0
    }
  }, "Documents"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: closeDocsPopup,
    title: "Close"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "6",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      fontSize: "12px",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "#e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Title"), /*#__PURE__*/React__default.createElement("th", null, "Document Id"), /*#__PURE__*/React__default.createElement("th", null, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, ((docsContextItem === null || docsContextItem === void 0 ? void 0 : docsContextItem.documentDetailsLtp) || []).map((row, i) => /*#__PURE__*/React__default.createElement("tr", {
    key: i
  }, /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.fileName) || (row === null || row === void 0 ? void 0 : row.documentTitle) || (row === null || row === void 0 ? void 0 : row.documentType) || "-"), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.fileStoreId) || "-"), /*#__PURE__*/React__default.createElement("td", null, row !== null && row !== void 0 && row.fileStoreId ? /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => handleLoadDocument(row.fileStoreId),
    size: "small",
    title: "View Document",
    style: {
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
    fontSize: "small",
    style: {
      color: "#157CB3"
    }
  })) : "-")))))));
};

const NOCShortfallLog = ({
  shortfallData
}) => {
  const dataArray = Object.entries(shortfallData || {});
  const [docUrl, setDocUrl] = useState(null);
  const handleView = url => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const extractDateTime = key => {
    const match = key.match(/_(\d{4}-\d{2}-\d{2})_(\d{2}-\d{2}-\d{2})/);
    if (match) {
      const [_, date, time] = match;
      const formattedTime = time.replace(/-/g, ":");
      return {
        date,
        time: formattedTime
      };
    }
    return {
      date: "-",
      time: "-"
    };
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      margin: 0
    }
  }, "Shortfall Log")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "500px",
      fontSize: "12px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "Sr. No."), /*#__PURE__*/React__default.createElement("th", null, "Shortfall"), /*#__PURE__*/React__default.createElement("th", null, "Date"), /*#__PURE__*/React__default.createElement("th", null, "Time"), /*#__PURE__*/React__default.createElement("th", null, "View"))), /*#__PURE__*/React__default.createElement("tbody", null, dataArray.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 5,
    align: "center"
  }, "No Shortfall Data Available")) : dataArray.map(([key, value], idx) => {
    const {
      date,
      time
    } = extractDateTime(key);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: key
    }, /*#__PURE__*/React__default.createElement("td", null, idx + 1), /*#__PURE__*/React__default.createElement("td", null, `Shortfall ${idx + 1}`), /*#__PURE__*/React__default.createElement("td", null, date), /*#__PURE__*/React__default.createElement("td", null, time), /*#__PURE__*/React__default.createElement("td", null, value ? /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => handleView(value),
      size: "small",
      title: "View Document"
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small",
      style: {
        color: "#157CB3"
      }
    })) : "-"));
  })))));
};

const NOCInfo = ({
  formData,
  setShowNOCInfo,
  showNOCInfo,
  searchNocRemarks,
  nocRemarksData
}) => {
  var _user$info, _item$nocLetterInfo;
  const {
    t
  } = useTranslation();
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const storedData = formData || Digit.SessionStorage.get("nocAppData");
  const termsAndCondition = formData || Digit.SessionStorage.get("nocTermsAndCondition");
  const {
    nocAppNo,
    nocSearchResult
  } = Digit.SessionStorage.get("nocAppNo") || {};
  console.log("resultFromSessionsearch", nocSearchResult, nocAppNo, termsAndCondition, nocRemarksData);
  const paramsHook = useParams();
  const urlApplicationNo = paramsHook.id || (paramsHook.state && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.state}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : paramsHook.authority && paramsHook.plinth && paramsHook.plan && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.authority}/${paramsHook.plinth}/${paramsHook.plan}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : paramsHook.authority && paramsHook.plan && paramsHook.form && paramsHook.year && paramsHook.serial ? `${paramsHook.authority}/${paramsHook.plan}/${paramsHook.form}/${paramsHook.year}/${paramsHook.serial}` : "");
  const targetAppNo = urlApplicationNo || nocAppNo || (formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  const nocList = (storedData === null || storedData === void 0 ? void 0 : storedData.nocList) || [];
  let user = Digit.UserService.getUser();
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "CITIZEN";
  const userOrgCode = userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode;
  const item = isCitizen ? targetAppNo && nocList.find(item => item.applicationNo == targetAppNo) || nocList.find(item => item.applicationNo == nocAppNo) : targetAppNo && nocList.find(n => n.applicationNo == targetAppNo) || userOrgCode && nocList.find(n => n.businessService == userOrgCode) || nocList[0] || nocSearchResult;
  const columns = [{
    id: "applicationNo",
    label: "Application Number",
    width: "17%"
  }, {
    id: "department",
    label: "Department",
    width: "13%"
  }, {
    id: "requestLetter",
    label: "Request Letter",
    width: "13%"
  }, {
    id: "shortfallLetter",
    label: "Shortfall Letter",
    width: "13%"
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    width: "13%"
  }, {
    id: "status",
    label: "Status",
    width: "10%"
  }, {
    id: "action",
    label: "Action",
    width: "10%"
  }];
  const handleOpenDoc = async url => {
    if (!url) return;
    if (typeof url === "string" && (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("/filestore"))) {
      window.open(url, "_blank");
      return;
    }
    try {
      var _res$data, _res$data$fileStoreId, _res$data$fileStoreId2;
      const tenantId = Digit.ULBService.getCurrentTenantId() || "up";
      const res = await Digit.UploadServices.Filefetch([url], tenantId);
      const fetchedUrl = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$fileStoreId = _res$data.fileStoreIds) === null || _res$data$fileStoreId === void 0 ? void 0 : (_res$data$fileStoreId2 = _res$data$fileStoreId[0]) === null || _res$data$fileStoreId2 === void 0 ? void 0 : _res$data$fileStoreId2.url;
      if (fetchedUrl) {
        window.open(fetchedUrl, "_blank");
        return;
      }
    } catch (e) {
      console.error("Error fetching file URL:", e);
    }
    window.open(url, "_blank");
  };
  const handleOpenRequestLetter = url => {
    handleOpenDoc(url);
  };
  if (!item) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "24px"
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h6",
      align: "center"
    }, "No NOC record found for your organization."));
  }
  const rawNocLetter = item.nocLetterInfo;
  const nocLetterObj = Array.isArray(rawNocLetter) ? rawNocLetter.find(r => (r === null || r === void 0 ? void 0 : r.fileStoreUrl) || (r === null || r === void 0 ? void 0 : r.url) || (r === null || r === void 0 ? void 0 : r.fileStoreId)) || rawNocLetter[0] : rawNocLetter;
  const fileUrl = (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.fileStoreUrl) || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.url) || item.requestLetterUrl || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.fileStoreId) || ((_item$nocLetterInfo = item.nocLetterInfo) === null || _item$nocLetterInfo === void 0 ? void 0 : _item$nocLetterInfo.fileStoreUrl) || "";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, "NOC Info")), /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    "aria-label": "noc info table",
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    style: {
      width: column.width,
      fontWeight: "bold",
      background: "#1f4a7c",
      color: "#fff",
      fontSize: "13px"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, item.applicationNo || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, item.nocName || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px",
      textAlign: "center"
    }
  }, fileUrl ? /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: () => handleOpenRequestLetter(fileUrl),
    sx: {
      fontSize: "12px",
      minWidth: "60px"
    }
  }, "View") : "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px",
      textAlign: "center"
    }
  }, item.nocApprovedLetterUrl && item.applicationStatus === "REVERT_TO_APPLICANT_NOC" ? /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: () => handleOpenDoc(item.nocApprovedLetterUrl),
    sx: {
      fontSize: "12px",
      minWidth: "60px"
    }
  }, "View") : "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px",
      textAlign: "center"
    }
  }, item.nocApprovedLetterUrl && item.applicationStatus === "NOC_APPROVED" ? /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    variant: "contained",
    color: "success",
    onClick: () => handleOpenDoc(item.nocApprovedLetterUrl),
    sx: {
      fontSize: "12px",
      minWidth: "60px"
    }
  }, "View") : "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, t(`NOC_STATUS_${item.applicationStatus}`) || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    gap: 1
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: () => setShowNOCInfo(prev => !prev),
    sx: {
      fontSize: "12px",
      minWidth: "60px"
    }
  }, "Take Action"))))))), /*#__PURE__*/React__default.createElement(NOCShortfallLog, {
    shortfallData: item === null || item === void 0 ? void 0 : item.objectionLetterUrl
  }), /*#__PURE__*/React__default.createElement(NOCDetailsLog, {
    logData: termsAndCondition,
    nocRemarksData: nocRemarksData,
    isCitizen: isCitizen
  }));
};

const ChecklistNoc = ({
  formData,
  checklistNoc,
  setChecklistNoc,
  onSave
}) => {
  var _Digit, _Digit$SessionStorage, _Digit2, _Digit2$UserService, _Digit2$UserService$g, _formDataState$posses, _formDataState$siteCo, _formDataState$zoneOf;
  const userDetails = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("USER_DETAIL");
  const userInfo = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$UserService = _Digit2.UserService) === null || _Digit2$UserService === void 0 ? void 0 : (_Digit2$UserService$g = _Digit2$UserService.getUser()) === null || _Digit2$UserService$g === void 0 ? void 0 : _Digit2$UserService$g.info;
  const [formDataState, setFormDataState] = useState(() => {
    var _Digit3, _Digit3$SessionStorag, _formData$additionalD;
    const existing = checklistNoc || ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : (_Digit3$SessionStorag = _Digit3.SessionStorage) === null || _Digit3$SessionStorag === void 0 ? void 0 : _Digit3$SessionStorag.get("checklistNoc")) || (formData === null || formData === void 0 ? void 0 : formData.checklistNoc) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.checklistNoc) || {};
    return {
      plotAllottedOnLease: (existing === null || existing === void 0 ? void 0 : existing.plotAllottedOnLease) || "",
      paymentsUpToDate: (existing === null || existing === void 0 ? void 0 : existing.paymentsUpToDate) || "",
      tripartiteAgreementExecuted: (existing === null || existing === void 0 ? void 0 : existing.tripartiteAgreementExecuted) || "",
      landMortgaged: (existing === null || existing === void 0 ? void 0 : existing.landMortgaged) || "",
      mortgagedPercentageOrArea: (existing === null || existing === void 0 ? void 0 : existing.mortgagedPercentageOrArea) || "",
      applicationUnderOTS: (existing === null || existing === void 0 ? void 0 : existing.applicationUnderOTS) || "",
      otsRemarks: (existing === null || existing === void 0 ? void 0 : existing.otsRemarks) || "",
      shelterFeePaid: (existing === null || existing === void 0 ? void 0 : existing.shelterFeePaid) || "",
      possessionPaymentAndStatus: (existing === null || existing === void 0 ? void 0 : existing.possessionPaymentAndStatus) || "",
      siteConstructionPosition: (existing === null || existing === void 0 ? void 0 : existing.siteConstructionPosition) || "",
      zoneOfficeRecommendation: (existing === null || existing === void 0 ? void 0 : existing.zoneOfficeRecommendation) || "",
      zoneOfficeRecommendationRemarks: (existing === null || existing === void 0 ? void 0 : existing.zoneOfficeRecommendationRemarks) || ""
    };
  });
  const [savedSuccess, setSavedSuccess] = useState(false);
  useEffect(() => {
    if (checklistNoc && Object.keys(checklistNoc).length > 0) {
      setFormDataState(prev => ({
        ...prev,
        plotAllottedOnLease: checklistNoc.plotAllottedOnLease !== undefined && checklistNoc.plotAllottedOnLease !== null ? checklistNoc.plotAllottedOnLease : prev.plotAllottedOnLease,
        paymentsUpToDate: checklistNoc.paymentsUpToDate !== undefined && checklistNoc.paymentsUpToDate !== null ? checklistNoc.paymentsUpToDate : prev.paymentsUpToDate,
        tripartiteAgreementExecuted: checklistNoc.tripartiteAgreementExecuted !== undefined && checklistNoc.tripartiteAgreementExecuted !== null ? checklistNoc.tripartiteAgreementExecuted : prev.tripartiteAgreementExecuted,
        landMortgaged: checklistNoc.landMortgaged !== undefined && checklistNoc.landMortgaged !== null ? checklistNoc.landMortgaged : prev.landMortgaged,
        mortgagedPercentageOrArea: checklistNoc.mortgagedPercentageOrArea !== undefined && checklistNoc.mortgagedPercentageOrArea !== null ? checklistNoc.mortgagedPercentageOrArea : prev.mortgagedPercentageOrArea,
        applicationUnderOTS: checklistNoc.applicationUnderOTS !== undefined && checklistNoc.applicationUnderOTS !== null ? checklistNoc.applicationUnderOTS : prev.applicationUnderOTS,
        otsRemarks: checklistNoc.otsRemarks !== undefined && checklistNoc.otsRemarks !== null ? checklistNoc.otsRemarks : prev.otsRemarks,
        shelterFeePaid: checklistNoc.shelterFeePaid !== undefined && checklistNoc.shelterFeePaid !== null ? checklistNoc.shelterFeePaid : prev.shelterFeePaid,
        possessionPaymentAndStatus: checklistNoc.possessionPaymentAndStatus !== undefined && checklistNoc.possessionPaymentAndStatus !== null ? checklistNoc.possessionPaymentAndStatus : prev.possessionPaymentAndStatus,
        siteConstructionPosition: checklistNoc.siteConstructionPosition !== undefined && checklistNoc.siteConstructionPosition !== null ? checklistNoc.siteConstructionPosition : prev.siteConstructionPosition,
        zoneOfficeRecommendation: checklistNoc.zoneOfficeRecommendation !== undefined && checklistNoc.zoneOfficeRecommendation !== null ? checklistNoc.zoneOfficeRecommendation : prev.zoneOfficeRecommendation,
        zoneOfficeRecommendationRemarks: checklistNoc.zoneOfficeRecommendationRemarks !== undefined && checklistNoc.zoneOfficeRecommendationRemarks !== null ? checklistNoc.zoneOfficeRecommendationRemarks : prev.zoneOfficeRecommendationRemarks
      }));
    }
  }, [checklistNoc]);
  const buildChecklistPayload = state => {
    return {
      plotAllottedOnLease: state.plotAllottedOnLease || "",
      paymentsUpToDate: state.paymentsUpToDate || "",
      tripartiteAgreementExecuted: state.tripartiteAgreementExecuted || "",
      landMortgaged: state.landMortgaged || "",
      mortgagedPercentageOrArea: state.mortgagedPercentageOrArea || "",
      applicationUnderOTS: state.applicationUnderOTS || "",
      otsRemarks: state.otsRemarks || "",
      shelterFeePaid: state.shelterFeePaid || "",
      possessionPaymentAndStatus: state.possessionPaymentAndStatus || "",
      siteConstructionPosition: state.siteConstructionPosition || "",
      zoneOfficeRecommendation: state.zoneOfficeRecommendation || "",
      zoneOfficeRecommendationRemarks: state.zoneOfficeRecommendationRemarks || "",
      updatedBy: userInfo && userInfo.name || userDetails && userDetails.name || "Property Section Officer",
      updatedTime: new Date().toISOString()
    };
  };
  const handleFieldChange = (field, value) => {
    var _Digit4, _Digit4$SessionStorag;
    const updated = {
      ...formDataState,
      [field]: value
    };
    setFormDataState(updated);
    const fullPayload = buildChecklistPayload(updated);
    if (typeof setChecklistNoc === "function") {
      setChecklistNoc(fullPayload);
    }
    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$SessionStorag = _Digit4.SessionStorage) === null || _Digit4$SessionStorag === void 0 ? void 0 : _Digit4$SessionStorag.set("checklistNoc", fullPayload);
    setSavedSuccess(false);
  };
  const handleSaveClick = () => {
    var _Digit5, _Digit5$SessionStorag;
    const fullPayload = buildChecklistPayload(formDataState);
    if (typeof setChecklistNoc === "function") {
      setChecklistNoc(fullPayload);
    }
    (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : (_Digit5$SessionStorag = _Digit5.SessionStorage) === null || _Digit5$SessionStorag === void 0 ? void 0 : _Digit5$SessionStorag.set("checklistNoc", fullPayload);
    setSavedSuccess(true);
    if (typeof onSave === "function") {
      onSave(fullPayload);
    }
    setTimeout(() => {
      setSavedSuccess(false);
    }, 4000);
  };
  const isComplete = Boolean(formDataState.plotAllottedOnLease) && Boolean(formDataState.paymentsUpToDate) && Boolean(formDataState.tripartiteAgreementExecuted) && Boolean(formDataState.landMortgaged) && Boolean(formDataState.applicationUnderOTS) && Boolean(formDataState.shelterFeePaid) && Boolean((_formDataState$posses = formDataState.possessionPaymentAndStatus) === null || _formDataState$posses === void 0 ? void 0 : _formDataState$posses.trim()) && Boolean((_formDataState$siteCo = formDataState.siteConstructionPosition) === null || _formDataState$siteCo === void 0 ? void 0 : _formDataState$siteCo.trim()) && Boolean((_formDataState$zoneOf = formDataState.zoneOfficeRecommendation) === null || _formDataState$zoneOf === void 0 ? void 0 : _formDataState$zoneOf.trim());
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      padding: "8px 4px",
      marginTop: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 1,
    sx: {
      padding: "16px 20px",
      marginBottom: "16px",
      background: "linear-gradient(90deg, #1f4a7c 0%, #153a63 100%)",
      color: "#ffffff",
      borderRadius: "8px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 2
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(AssignmentTurnedInIcon, {
    sx: {
      fontSize: 32,
      color: "#93c5fd"
    }
  }), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      fontWeight: 700,
      fontSize: "1.1rem",
      letterSpacing: "0.5px"
    }
  }, "AVP Property Section Checklist"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    sx: {
      color: "#dbeafe",
      fontSize: "0.82rem"
    }
  }, "Please review and answer the questions below for this Awas Vikas Parishad (AVP) file."))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5
    }
  }, isComplete ? /*#__PURE__*/React__default.createElement(Chip, {
    icon: /*#__PURE__*/React__default.createElement(CheckCircleOutlineIcon, {
      style: {
        color: "#ffffff"
      }
    }),
    label: "All Fields Completed",
    size: "small",
    sx: {
      backgroundColor: "#15803d",
      color: "#ffffff",
      fontWeight: 600
    }
  }) : /*#__PURE__*/React__default.createElement(Chip, {
    label: "In Progress",
    size: "small",
    sx: {
      backgroundColor: "#ca8a04",
      color: "#ffffff",
      fontWeight: 600
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    startIcon: /*#__PURE__*/React__default.createElement(SaveIcon, null),
    onClick: handleSaveClick,
    sx: {
      backgroundColor: savedSuccess ? "#16a34a" : "#ffffff",
      color: savedSuccess ? "#ffffff" : "#1f4a7c",
      fontWeight: 700,
      fontSize: "0.85rem",
      textTransform: "none",
      padding: "6px 16px",
      borderRadius: "6px",
      ["&:hover"]: {
        backgroundColor: savedSuccess ? "#15803d" : "#f1f5f9"
      }
    }
  }, savedSuccess ? "Saved Successfully!" : "Save Checklist"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    elevation: 2,
    sx: {
      borderRadius: "8px",
      overflow: "hidden",
      border: "1px solid #e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    "aria-label": "property section checklist table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      backgroundColor: "#1f4a7c",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "14px",
      width: "8%",
      py: 1.5
    }
  }, "Sr. No."), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      backgroundColor: "#1f4a7c",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "14px",
      width: "52%",
      py: 1.5
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      backgroundColor: "#1f4a7c",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "14px",
      width: "40%",
      py: 1.5
    }
  }, "Remarks / Response"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#ffffff",
      ["&:hover"]: {
        backgroundColor: "#f8fafc"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "1"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Has the plot been allotted on lease or not ?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.plotAllottedOnLease,
    onChange: e => handleFieldChange("plotAllottedOnLease", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbfd",
      ["&:hover"]: {
        backgroundColor: "#f1f5f9"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "2"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Are the payments for the plots up to date or not?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.paymentsUpToDate,
    onChange: e => handleFieldChange("paymentsUpToDate", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#ffffff",
      ["&:hover"]: {
        backgroundColor: "#f8fafc"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "3"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Has the tripartite agreement (tripod agreement) been executed or not ?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.tripartiteAgreementExecuted,
    onChange: e => handleFieldChange("tripartiteAgreementExecuted", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbfd",
      ["&:hover"]: {
        backgroundColor: "#f1f5f9"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "4"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Has the land been mortgaged subject to the rules / conditions of the Housing Board / Government Order or not ? If it has been mortgaged, what is the percentage / area relative to the total land?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.landMortgaged,
    onChange: e => handleFieldChange("landMortgaged", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })), formDataState.landMortgaged === "Yes" && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    size: "small",
    label: "Mortgaged percentage / area relative to total land",
    placeholder: "e.g. 25% or 500 sq. meters mortgaged",
    value: formDataState.mortgagedPercentageOrArea,
    onChange: e => handleFieldChange("mortgagedPercentageOrArea", e.target.value),
    variant: "outlined"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#ffffff",
      ["&:hover"]: {
        backgroundColor: "#f8fafc"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "5"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Is there an application under the OTS scheme or not? If so, can the map be approved after the updated payment has been made as per OTS?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.applicationUnderOTS,
    onChange: e => handleFieldChange("applicationUnderOTS", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })), formDataState.applicationUnderOTS === "Yes" && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    size: "small",
    label: "OTS Details / Payment remarks",
    placeholder: "Enter OTS status and updated payment details",
    value: formDataState.otsRemarks,
    onChange: e => handleFieldChange("otsRemarks", e.target.value),
    variant: "outlined"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbfd",
      ["&:hover"]: {
        backgroundColor: "#f1f5f9"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "6"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Has the shelter fee been paid or not ?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.shelterFeePaid,
    onChange: e => handleFieldChange("shelterFeePaid", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Yes",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "No",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "primary"
    }),
    label: "No"
  })))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#ffffff",
      ["&:hover"]: {
        backgroundColor: "#f8fafc"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "7"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "What percentage of the plot value is to be paid / has been paid for possession and what is the possession status?"), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    size: "small",
    multiline: true,
    rows: 2,
    placeholder: "Enter percentage paid/to be paid and current possession status",
    value: formDataState.possessionPaymentAndStatus,
    onChange: e => handleFieldChange("possessionPaymentAndStatus", e.target.value),
    variant: "outlined"
  }))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f9fbfd",
      ["&:hover"]: {
        backgroundColor: "#f1f5f9"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "8"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Position of the site / position of construction."), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    size: "small",
    multiline: true,
    rows: 2,
    placeholder: "Enter details regarding site position and construction status",
    value: formDataState.siteConstructionPosition,
    onChange: e => handleFieldChange("siteConstructionPosition", e.target.value),
    variant: "outlined"
  }))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#ffffff",
      ["&:hover"]: {
        backgroundColor: "#f8fafc"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      fontWeight: 600,
      color: "#1f4a7c"
    }
  }, "9"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontSize: "14px",
      color: "#1e293b",
      fontWeight: 500
    }
  }, "Clear proposal / recommendation from the zone office regarding whether the map can be approved or not."), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    value: formDataState.zoneOfficeRecommendation,
    onChange: e => handleFieldChange("zoneOfficeRecommendation", e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Can be approved",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "success"
    }),
    label: "Can be approved"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Cannot be approved",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "error"
    }),
    label: "Cannot be approved"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "Conditional",
    control: /*#__PURE__*/React__default.createElement(Radio$1, {
      size: "small",
      color: "warning"
    }),
    label: "Conditional"
  })), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    size: "small",
    multiline: true,
    rows: 2,
    placeholder: "Enter zone office proposal / recommendation remarks",
    value: formDataState.zoneOfficeRecommendationRemarks,
    onChange: e => handleFieldChange("zoneOfficeRecommendationRemarks", e.target.value),
    variant: "outlined"
  }))))))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      justifyContent: "flex-end",
      mt: 2,
      mb: 1
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    startIcon: /*#__PURE__*/React__default.createElement(SaveIcon, null),
    onClick: handleSaveClick,
    sx: {
      backgroundColor: savedSuccess ? "#16a34a" : "#1f4a7c",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "0.9rem",
      textTransform: "none",
      padding: "8px 24px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(31, 74, 124, 0.3)",
      ["&:hover"]: {
        backgroundColor: savedSuccess ? "#15803d" : "#153a63"
      }
    }
  }, savedSuccess ? "Checklist Saved Successfully!" : "Save Checklist")));
};

const DocumentUploader = ({
  uploadedFiles: _uploadedFiles = [],
  setUploadedFiles: _setUploadedFiles = () => {},
  maxFiles: _maxFiles = 5
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [viewingIndex, setViewingIndex] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const fileInputRef = useRef();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);
  const handleFileUpload = async e => {
    const selectedFiles = Array.from(e.target.files);
    if ((_uploadedFiles === null || _uploadedFiles === void 0 ? void 0 : _uploadedFiles.length) + selectedFiles.length > _maxFiles) {
      setShowToast({
        error: true,
        label: t("CS_MAXIMUM_FILES_EXCEEDED", {
          maxFiles: _maxFiles
        })
      });
      return;
    }
    selectedFiles.forEach(async file => {
      const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
      if (file.size >= 5242880) {
        setShowToast({
          error: true,
          label: t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED")
        });
      } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
        setShowToast({
          error: true,
          label: t("NOT_SUPPORTED_FILE_TYPE")
        });
      } else {
        setIsLoading(true);
        try {
          var _Digit, _Digit$ULBService, _Digit$ULBService$get, _Digit2, _Digit2$ULBService, _Digit2$ULBService$ge, _response$data, _response$data$files;
          const stateId = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ULBService = _Digit.ULBService) === null || _Digit$ULBService === void 0 ? void 0 : (_Digit$ULBService$get = _Digit$ULBService.getStateId) === null || _Digit$ULBService$get === void 0 ? void 0 : _Digit$ULBService$get.call(_Digit$ULBService)) || ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ULBService = _Digit2.ULBService) === null || _Digit2$ULBService === void 0 ? void 0 : (_Digit2$ULBService$ge = _Digit2$ULBService.getCurrentTenantId) === null || _Digit2$ULBService$ge === void 0 ? void 0 : _Digit2$ULBService$ge.call(_Digit2$ULBService)) || "up";
          const tenant = stateId !== null && stateId !== void 0 && stateId.includes(".") ? stateId.split(".")[0] : stateId;
          const response = await Digit.UploadServices.Filestorage("OBPS", file, stateId || tenant);
          console.log("File upload response:", response);
          if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
            const uploadedFileData = response.data.files[0];
            const fileStoreId = uploadedFileData === null || uploadedFileData === void 0 ? void 0 : uploadedFileData.fileStoreId;
            const fileUrl = (uploadedFileData === null || uploadedFileData === void 0 ? void 0 : uploadedFileData.url) || (uploadedFileData === null || uploadedFileData === void 0 ? void 0 : uploadedFileData.fileUrl) || (uploadedFileData === null || uploadedFileData === void 0 ? void 0 : uploadedFileData.uri);
            _setUploadedFiles(prev => {
              const prevFiles = Array.isArray(prev) ? prev : [];
              return [...prevFiles, {
                fileStoreId,
                fileName: file.name,
                ...(fileUrl ? {
                  url: fileUrl
                } : {})
              }];
            });
          } else {
            setShowToast({
              error: true,
              label: t("CS_FILE_UPLOAD_ERROR") || t("1 error")
            });
          }
        } catch (err) {
          console.error("File upload error:", err);
          setShowToast({
            error: true,
            label: t("CS_FILE_UPLOAD_ERROR")
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };
  const handleViewFile = async (file, index) => {
    var _file$fileStoreId;
    if (!file) return;
    const fileStoreId = typeof file === "string" ? file : (file === null || file === void 0 ? void 0 : (_file$fileStoreId = file.fileStoreId) === null || _file$fileStoreId === void 0 ? void 0 : _file$fileStoreId.fileStoreId) || (file === null || file === void 0 ? void 0 : file.fileStoreId) || (file === null || file === void 0 ? void 0 : file.id) || (file === null || file === void 0 ? void 0 : file.documentUid);
    const directUrl = typeof file === "string" && (file.startsWith("http://") || file.startsWith("https://") || file.startsWith("blob:") || file.startsWith("data:")) ? file : (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 ? void 0 : file.fileUrl) || (file === null || file === void 0 ? void 0 : file.fileStoreUrl);
    if (directUrl) {
      window.open(directUrl, "_blank", "noopener,noreferrer");
      return;
    }
    if (!fileStoreId) {
      setShowToast({
        error: true,
        label: t("CS_FILE_NOT_FOUND") || "File not available"
      });
      return;
    }
    if (typeof fileStoreId === "string" && (fileStoreId.startsWith("http://") || fileStoreId.startsWith("https://") || fileStoreId.startsWith("blob:") || fileStoreId.startsWith("data:"))) {
      window.open(fileStoreId, "_blank", "noopener,noreferrer");
      return;
    }
    let newTab = null;
    try {
      newTab = window.open("", "_blank");
    } catch (e) {
      console.error("Failed to open blank window:", e);
    }
    setViewingIndex(index);
    try {
      var _Digit3, _Digit3$ULBService, _Digit3$ULBService$ge, _Digit4, _Digit4$ULBService, _Digit4$ULBService$ge;
      const stateId = ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : (_Digit3$ULBService = _Digit3.ULBService) === null || _Digit3$ULBService === void 0 ? void 0 : (_Digit3$ULBService$ge = _Digit3$ULBService.getStateId) === null || _Digit3$ULBService$ge === void 0 ? void 0 : _Digit3$ULBService$ge.call(_Digit3$ULBService)) || ((_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$ULBService = _Digit4.ULBService) === null || _Digit4$ULBService === void 0 ? void 0 : (_Digit4$ULBService$ge = _Digit4$ULBService.getCurrentTenantId) === null || _Digit4$ULBService$ge === void 0 ? void 0 : _Digit4$ULBService$ge.call(_Digit4$ULBService)) || "up";
      const tenant = stateId !== null && stateId !== void 0 && stateId.includes(".") ? stateId.split(".")[0] : stateId;
      let fileUrl = null;
      try {
        var _Digit5, _Digit5$UploadService, _Digit5$UploadService2, _res$data, _res$data$fileStoreId, _res$data$fileStoreId2;
        const res = await ((_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : (_Digit5$UploadService = _Digit5.UploadServices) === null || _Digit5$UploadService === void 0 ? void 0 : (_Digit5$UploadService2 = _Digit5$UploadService.Filefetch) === null || _Digit5$UploadService2 === void 0 ? void 0 : _Digit5$UploadService2.call(_Digit5$UploadService, [fileStoreId], stateId));
        fileUrl = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$fileStoreId = _res$data.fileStoreIds) === null || _res$data$fileStoreId === void 0 ? void 0 : (_res$data$fileStoreId2 = _res$data$fileStoreId[0]) === null || _res$data$fileStoreId2 === void 0 ? void 0 : _res$data$fileStoreId2.url;
      } catch (err) {
        console.error("Digit.UploadServices.Filefetch error:", err);
      }
      if (!fileUrl) {
        try {
          var _res$data2, _res$data2$fileStoreI, _res$data2$fileStoreI2;
          const res = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenant}&fileStoreIds=${fileStoreId}`);
          fileUrl = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$fileStoreI = _res$data2.fileStoreIds) === null || _res$data2$fileStoreI === void 0 ? void 0 : (_res$data2$fileStoreI2 = _res$data2$fileStoreI[0]) === null || _res$data2$fileStoreI2 === void 0 ? void 0 : _res$data2$fileStoreI2.url;
        } catch (err) {
          console.error("axios filestore fetch error:", err);
        }
      }
      if (!fileUrl && tenant !== "up") {
        try {
          var _res$data3, _res$data3$fileStoreI, _res$data3$fileStoreI2;
          const res = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
          fileUrl = res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$fileStoreI = _res$data3.fileStoreIds) === null || _res$data3$fileStoreI === void 0 ? void 0 : (_res$data3$fileStoreI2 = _res$data3$fileStoreI[0]) === null || _res$data3$fileStoreI2 === void 0 ? void 0 : _res$data3$fileStoreI2.url;
        } catch (err) {
          console.error("axios filestore (up) fetch error:", err);
        }
      }
      if (!fileUrl) {
        try {
          fileUrl = await getDocumentByFileStoreId(fileStoreId, () => {}, true);
        } catch (err) {
          console.error("getDocumentByFileStoreId error:", err);
        }
      }
      if (fileUrl) {
        if (newTab && !newTab.closed) {
          newTab.location.href = fileUrl;
        } else {
          window.open(fileUrl, "_blank", "noopener,noreferrer");
        }
      } else {
        if (newTab && !newTab.closed) {
          newTab.close();
        }
        setShowToast({
          error: true,
          label: t("CS_FILE_NOT_FOUND") || "Unable to view file"
        });
      }
    } catch (err) {
      console.error("Error viewing file:", err);
      if (newTab && !newTab.closed) {
        newTab.close();
      }
      setShowToast({
        error: true,
        label: t("CS_FILE_VIEW_ERROR") || "Failed to open document"
      });
    } finally {
      setViewingIndex(null);
    }
  };
  const deleteFile = (indexToDelete, fileStoreId) => {
    _setUploadedFiles(prev => {
      if (!Array.isArray(prev)) return [];
      return prev.filter((file, idx) => fileStoreId ? file.fileStoreId !== fileStoreId : idx !== indexToDelete);
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2",
    sx: {
      fontWeight: "bold",
      marginTop: "5px",
      marginLeft: "5px",
      whiteSpace: "nowrap",
      fontSize: "14px"
    }
  }, "Document/Certificate"), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10",
    sx: {
      marginLeft: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      display: "flex",
      justifyContent: "space-between",
      height: "30px",
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c",
        color: "#fff"
      }
    },
    disabled: (_uploadedFiles === null || _uploadedFiles === void 0 ? void 0 : _uploadedFiles.length) >= _maxFiles
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "center",
      position: "absolute",
      alignItems: "center",
      display: "flex",
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: "absolute",
      fontSize: "0.5rem",
      marginLeft: "8em"
    }
  }, t("Attach document")))), /*#__PURE__*/React__default.createElement("input", {
    ref: fileInputRef,
    type: "file",
    style: {
      display: "none"
    },
    onChange: handleFileUpload,
    onClick: e => {
      e.target.value = null;
    },
    multiple: true
  }), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, Array.isArray(_uploadedFiles) && (_uploadedFiles === null || _uploadedFiles === void 0 ? void 0 : _uploadedFiles.map((file, index) => /*#__PURE__*/React__default.createElement(Box, {
    key: index,
    display: "flex",
    alignItems: "center",
    mb: 1,
    sx: {
      backgroundColor: "#eee",
      padding: "0.5rem",
      borderRadius: "0.25rem"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      flexGrow: 1
    }
  }, (file === null || file === void 0 ? void 0 : file.fileName) || (file === null || file === void 0 ? void 0 : file.name) || t("DOCUMENT")), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: t("CS_COMMON_VIEW") || "View"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    color: "info",
    sx: {
      fontSize: "1rem"
    },
    onClick: () => handleViewFile(file, index),
    disabled: viewingIndex === index
  }, viewingIndex === index ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 16,
    color: "info"
  }) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null))), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: t("CS_COMMON_DELETE") || "Delete"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    color: "error",
    sx: {
      fontSize: "1rem"
    },
    onClick: () => deleteFile(index, file === null || file === void 0 ? void 0 : file.fileStoreId)
  }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))))))))), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label));
};

const NocPaymentHead = ({
  tenantId,
  formData,
  setTaxHead,
  taxHead,
  handleNoWorkflowPayNOC,
  isEmployee,
  empRole,
  isFeesEligible,
  Modal,
  onSelect,
  isValidEmp,
  isBpaNoc: propIsBpaNoc
}) => {
  var _formData$businessSer, _formData$businessSer2, _formData$documents, _formData$documents$f, _formData$documents$f2, _formData$documents2, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$nocPaymentD, _formData$nocPaymentD2, _formData$nocPaymentD3, _formData$nocPaymentD4, _formData$nocPaymentD5, _formData$nocPaymentD6, _formData$nocPaymentD7, _formData$nocPaymentD8, _formData$nocPaymentD9, _formData$nocPaymentD10, _formData$nocPaymentD11, _formData$nocPaymentD12, _formData$nocPaymentD13, _formData$nocPaymentD14, _formData$nocPaymentD15;
  const isBpaNoc = Boolean(propIsBpaNoc || typeof (formData === null || formData === void 0 ? void 0 : formData.businessService) === "string" && (formData === null || formData === void 0 ? void 0 : (_formData$businessSer = formData.businessService) === null || _formData$businessSer === void 0 ? void 0 : (_formData$businessSer2 = _formData$businessSer.toUpperCase()) === null || _formData$businessSer2 === void 0 ? void 0 : _formData$businessSer2.includes("BPA_NOC_")));
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const [moreHeads, setMoreHeads] = useState([]);
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const isRecieptId = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.filter(e => e.documentType === "reciept")) === null || _formData$documents$f === void 0 ? void 0 : (_formData$documents$f2 = _formData$documents$f[0]) === null || _formData$documents$f2 === void 0 ? void 0 : _formData$documents$f2.fileStoreId;
  const isReciept = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(e => e.documentType === "reciept");
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "NOC");
  const mapSubFeesTwo = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti.filter(item => item.taxHeadCode === "BPA_MAP_SUBMISSION_FEE_2")) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads;
  console.log("mapSubFeesTwo", mapSubFeesTwo);
  const [disabled, setDisabled] = useState(false);
  const inputWidth = 200;
  const nocAdditionalHead = {
    feeType: "",
    plotBuildUpArea: "",
    unit: "",
    rate: "",
    amount: ""
  };
  console.log(formData, isRecieptId, isReciept, "formdatatatarara");
  const defaultValues = {
    ...formData,
    nocPaymentDetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.nocPaymentDetails),
      required: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD = formData.nocPaymentDetails) === null || _formData$nocPaymentD === void 0 ? void 0 : _formData$nocPaymentD.required,
      challanNo: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD2 = formData.nocPaymentDetails) === null || _formData$nocPaymentD2 === void 0 ? void 0 : _formData$nocPaymentD2.challanNo,
      holderName: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD3 = formData.nocPaymentDetails) === null || _formData$nocPaymentD3 === void 0 ? void 0 : _formData$nocPaymentD3.holderName,
      bankName: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD4 = formData.nocPaymentDetails) === null || _formData$nocPaymentD4 === void 0 ? void 0 : _formData$nocPaymentD4.bankName,
      ifscCode: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD5 = formData.nocPaymentDetails) === null || _formData$nocPaymentD5 === void 0 ? void 0 : _formData$nocPaymentD5.ifscCode,
      additionalHeads: (formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD6 = formData.nocPaymentDetails) === null || _formData$nocPaymentD6 === void 0 ? void 0 : _formData$nocPaymentD6.additionalHeads) || [nocAdditionalHead],
      utrNo: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD7 = formData.nocPaymentDetails) === null || _formData$nocPaymentD7 === void 0 ? void 0 : _formData$nocPaymentD7.utrNo
    }
  };
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset
  } = useForm({
    defaultValues
  });
  const {
    fields: additionalHeads,
    append,
    remove
  } = useFieldArray({
    control,
    name: "nocPaymentDetails.additionalHeads"
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const paymentRequired = watch("nocPaymentDetails.required") === "yes";
  const onSubmit = async data => {
    handleNoWorkflowPayNOC(data);
  };
  const handleAddInput = () => {
    append({
      feeType: "",
      plotBuildUpArea: "",
      rate: "",
      unit: "",
      amount: ""
    });
  };
  if (isDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Payment Details")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Payment required?")}`,
    name: "nocPaymentDetails.required",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD8 = formData.nocPaymentDetails) === null || _formData$nocPaymentD8 === void 0 ? void 0 : _formData$nocPaymentD8.required,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    disabled: !isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), paymentRequired ? /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Challan No"),
    control: control,
    placeholder: t("Enter Challan No."),
    name: "nocPaymentDetails.challanNo",
    mandatory: true,
    maxLength: 15,
    disabled: !isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD9 = formData.nocPaymentDetails) === null || _formData$nocPaymentD9 === void 0 ? void 0 : _formData$nocPaymentD9.challanNo,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), paymentRequired && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("A/C Holder Name"),
    control: control,
    placeholder: t("Enter A/C Holder Name"),
    name: "nocPaymentDetails.holderName",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD10 = formData.nocPaymentDetails) === null || _formData$nocPaymentD10 === void 0 ? void 0 : _formData$nocPaymentD10.holderName,
    type: "textInput",
    mandatory: true,
    disabled: !isEmployee,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Bank Name"),
    control: control,
    placeholder: t("Enter Bank Name"),
    mandatory: true,
    type: "textInput",
    name: "nocPaymentDetails.bankName",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD11 = formData.nocPaymentDetails) === null || _formData$nocPaymentD11 === void 0 ? void 0 : _formData$nocPaymentD11.bankName,
    disabled: !isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), paymentRequired && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "IFSC Code",
    control: control,
    placeholder: "Enter IFSC Code",
    maxLength: 13,
    type: "textInput",
    name: "nocPaymentDetails.ifscCode",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD12 = formData.nocPaymentDetails) === null || _formData$nocPaymentD12 === void 0 ? void 0 : _formData$nocPaymentD12.ifscCode,
    disabled: !isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), paymentRequired && /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container",
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Area"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Unit"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Rate"), /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Amount"), isEmployee && /*#__PURE__*/React__default.createElement("th", {
    className: "fit-table-head"
  }, "Add/Remove"))), /*#__PURE__*/React__default.createElement("tbody", null, additionalHeads.map((field, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: field.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: false,
    control: control,
    name: `nocPaymentDetails.additionalHeads.${index}.feeType`,
    placeholder: "Enter Description",
    type: "textInput",
    width: inputWidth,
    disabled: !isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    type: "textInput",
    hasLabel: false,
    control: control,
    name: `nocPaymentDetails.additionalHeads.${index}.plotBuildUpArea`,
    placeholder: "Enter Area",
    disabled: !isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    type: "textInput",
    hasLabel: false,
    control: control,
    name: `nocPaymentDetails.additionalHeads.${index}.unit`,
    placeholder: "Unit",
    disabled: !isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    type: "textInput",
    hasLabel: false,
    control: control,
    name: `nocPaymentDetails.additionalHeads.${index}.rate`,
    placeholder: "Enter Rate",
    disabled: !isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    type: "textInput",
    hasLabel: false,
    control: control,
    name: `nocPaymentDetails.additionalHeads.${index}.amount`,
    placeholder: "Amount",
    disabled: !isEmployee
  })), isEmployee && /*#__PURE__*/React__default.createElement("td", {
    style: {
      display: "flex",
      gap: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    onClick: () => append({
      feeType: "",
      plotBuildUpArea: "",
      unit: "",
      rate: "",
      amount: ""
    }),
    "aria-label": "add"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    onClick: () => remove(index),
    "aria-label": "delete"
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))))))), paymentRequired && isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    type: "submit",
    disabled: disabled,
    style: {
      backgroundColor: "#157CB3",
      marginRight: "4px",
      height: "28px",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Generate"), /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    onClick: handleAddInput
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon, null), "Add")))), !isEmployee && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Enter UTR No")}`,
    placeholder: `${t("Enter UTR No")}`,
    name: "nocPaymentDetails.utrNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD13 = formData.nocPaymentDetails) === null || _formData$nocPaymentD13 === void 0 ? void 0 : _formData$nocPaymentD13.utrNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), !isRecieptId ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: t("Upload Reciept"),
    control: control,
    name: "reciept",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true
  })) : /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, "Bank Reciept:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(isRecieptId, setIsPreviewLoading)
  })))), isEmployee && (formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD14 = formData.nocPaymentDetails) === null || _formData$nocPaymentD14 === void 0 ? void 0 : _formData$nocPaymentD14.utrNo) && isRecieptId && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Enter UTR No")}`,
    placeholder: `${t("Enter UTR No")}`,
    name: "nocPaymentDetails.utrNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$nocPaymentD15 = formData.nocPaymentDetails) === null || _formData$nocPaymentD15 === void 0 ? void 0 : _formData$nocPaymentD15.utrNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "8px",
      fontWeight: "500"
    }
  }, "Bank Receipt:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(isRecieptId, setIsPreviewLoading)
  })))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))))));
};

const NocMemoChallanPopup = ({
  nocPaymentDetails
}) => {
  var _nocPaymentDetails$ad, _nocPaymentDetails$ad2;
  if (!nocPaymentDetails) return /*#__PURE__*/React__default.createElement(Typography, null, "No data available");
  const totalAmount = nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : (_nocPaymentDetails$ad = nocPaymentDetails.additionalHeads) === null || _nocPaymentDetails$ad === void 0 ? void 0 : _nocPaymentDetails$ad.reduce((acc, head) => acc + Number(head.amount || 0), 0);
  return /*#__PURE__*/React__default.createElement(Box, {
    p: 4
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    mb: 2,
    border: 1,
    borderColor: "grey.800",
    p: 2
  }, /*#__PURE__*/React__default.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6"
  }, "Memo Challan"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1"
  }, "Demand Note (NOC)"))), /*#__PURE__*/React__default.createElement(Paper$1, {
    variant: "outlined",
    sx: {
      p: 2,
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, (nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : nocPaymentDetails.challanNo) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Challan No.:"), " ", nocPaymentDetails.challanNo), (nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : nocPaymentDetails.holderName) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Holder Name:"), " ", nocPaymentDetails.holderName), (nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : nocPaymentDetails.bankName) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Bank Name:"), " ", nocPaymentDetails.bankName), (nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : nocPaymentDetails.ifscCode) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "IFSC Code:"), " ", nocPaymentDetails.ifscCode))), /*#__PURE__*/React__default.createElement(Table$2, {
    component: Paper$1,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Sr. No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Fee Type"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Plot Area"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Unit"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Rate"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Amount"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, (nocPaymentDetails === null || nocPaymentDetails === void 0 ? void 0 : (_nocPaymentDetails$ad2 = nocPaymentDetails.additionalHeads) === null || _nocPaymentDetails$ad2 === void 0 ? void 0 : _nocPaymentDetails$ad2.length) > 0 ? nocPaymentDetails.additionalHeads.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.feeType || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.plotBuildUpArea || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.unit || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.rate || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.amount || "-"))) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 6,
    align: "center"
  }, "No payment details available")))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount (In INR):"), " \u20B9 ", totalAmount || "NA"))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Note:"), " Amount calculated is based on NOC challan formula.")));
};

const NocMemoChallan = ({
  nocPaymentDetails
}) => {
  const [open, setOpen] = useState(false);
  const componentPDF = useRef();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => setOpen(true)
  }, /*#__PURE__*/React__default.createElement(DescriptionIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: () => setOpen(false),
    maxWidth: "lg",
    fullWidth: true,
    PaperProps: {
      sx: {
        position: "fixed",
        top: "10%",
        left: "55%",
        transform: "translateX(-50%)",
        backgroundColor: "#f3f4f6",
        border: "1px solid #ccc",
        padding: "20px",
        zIndex: 1000,
        maxHeight: "80vh",
        overflowY: "auto",
        width: "75%"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, "NOC Challan", /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement(PrintIcon, null),
    content: () => componentPDF.current
  }), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setOpen(false),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    dividers: true
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/React__default.createElement(NocMemoChallanPopup, {
    nocPaymentDetails: nocPaymentDetails
  })))));
};

const NocPaymentTable = ({
  nocPaymentDetails,
  formData
}) => {
  const [showDetails, setShowDetails] = useState(false);
  if (!nocPaymentDetails) return null;
  const {
    challanNo,
    holderName,
    bankName,
    ifscCode
  } = nocPaymentDetails;
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: "100%",
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 700
    },
    "aria-label": "noc payment table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Memo")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan No.")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Holder Name")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Bank Name")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "IFSC Code")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(IconButton$1, null, /*#__PURE__*/React__default.createElement(NocMemoChallan, {
    nocPaymentDetails: nocPaymentDetails
  }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, challanNo || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, holderName || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, bankName || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, ifscCode || "N/A")))));
};

const getDocKey = doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) || (doc === null || doc === void 0 ? void 0 : doc.documentUid) || (doc === null || doc === void 0 ? void 0 : doc.name) || (doc === null || doc === void 0 ? void 0 : doc.fileStoreId);
const mergeDocuments = (existing = [], incoming = []) => {
  const merged = [...existing];
  incoming.forEach(newDoc => {
    const idx = merged.findIndex(d => getDocKey(d) === getDocKey(newDoc));
    if (idx === -1) {
      merged.push(newDoc);
    } else {
      merged[idx] = {
        ...merged[idx],
        ...newDoc
      };
    }
  });
  return merged;
};
const LandAcquisitionTab = ({
  formData,
  handleTabChange,
  isEmployee,
  id
}) => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [savedCheckList, setSavedCheckList] = useState({});
  const [savedDocuments, setSavedDocuments] = useState([]);
  const documents = useSelector(state => {
    var _state$formMT;
    return (_state$formMT = state.formMT) === null || _state$formMT === void 0 ? void 0 : _state$formMT.documents;
  });
  console.log("FORMDATA FOUNDD 54", id, formData);
  const DEFAULT_VALUES = {
    niyojanSamitiSec29Date: "",
    sec32Date: "",
    exemptedByBoard: false,
    exemptedByGovt: false,
    areaToBeAdjustedHa: "",
    structureAreaExempted: "",
    bettermentLetterNo: "",
    bettermentFee: "",
    isFeeSubmittedAtEmo: "no",
    feeSubmittedDate: ""
  };
  const {
    control,
    handleSubmit,
    reset,
    trigger,
    setValue,
    formState: {
      errors
    }
  } = useForm({
    mode: "onChange",
    defaultValues: {
      niyojanSamitiSec29Date: "",
      sec32Date: "",
      exemptedByBoard: false,
      exemptedByGovt: false,
      areaToBeAdjustedHa: "",
      structureAreaExempted: "",
      bettermentLetterNo: "",
      bettermentFee: "",
      isFeeSubmittedAtEmo: "no",
      feeSubmittedDate: ""
    }
  });
  const fetchNocData = async () => {
    try {
      setIsDataLoading(true);
      const response = await NOCService$1.NOCsearch({
        tenantId: "up",
        filters: {
          applicationNo: id
        }
      });
      const noc = Array.isArray(response === null || response === void 0 ? void 0 : response.Noc) ? response.Noc[0] : response === null || response === void 0 ? void 0 : response.Noc;
      const checkList = noc === null || noc === void 0 ? void 0 : noc.landAcquisitionCheckList;
      const saveDocuments = noc === null || noc === void 0 ? void 0 : noc.documents;
      if (checkList && Object.keys(checkList).length) {
        setSavedCheckList(checkList);
        setSavedDocuments(saveDocuments);
        reset({
          ...DEFAULT_VALUES,
          ...checkList
        });
      }
      console.log("RESPONDEFROMLANDACQUISTION", response);
    } catch (err) {
      console.error("Error in NOCsearch:", err);
    } finally {
      setIsDataLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchNocData();
    }
  }, [id]);
  useEffect(() => {
    if (savedDocuments && (savedDocuments === null || savedDocuments === void 0 ? void 0 : savedDocuments.length) > 0) {
      initFormMTDocs(savedDocuments);
    }
  }, [savedDocuments]);
  const [exemptedByBoard, exemptedByGovt, isFeeSubmittedAtEmo] = useWatch({
    control,
    name: ["exemptedByBoard", "exemptedByGovt", "isFeeSubmittedAtEmo"]
  });
  const isExempted = !!(exemptedByBoard || exemptedByGovt);
  useEffect(() => {
    if (!isExempted) setValue("boardNoteOrder", undefined);
  }, [isExempted, setValue]);
  const onSave = data => {
    const existingDocs = Array.isArray(formData === null || formData === void 0 ? void 0 : formData.documents) ? formData.documents : [];
    const newDocs = Array.isArray(documents) ? documents : [];
    const newPayload = {
      ...formData,
      documents: mergeDocuments(existingDocs, newDocs),
      landAcquisitionCheckList: {
        ...savedCheckList,
        ...data
      }
    };
    console.log("PAYLOAD GENERATED", newPayload);
    handleTabChange(newPayload);
  };
  const dateField = (name, required = true) => /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: required ? "Date is required" : false
    },
    render: ({
      field
    }) => {
      var _errors$name;
      return /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
        type: "date",
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          shrink: true
        },
        error: !!errors[name],
        helperText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message
      }));
    }
  });
  const numberField = (name, placeholder, endText) => /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: "This field is required",
      min: {
        value: 0,
        message: "Value cannot be negative"
      }
    },
    render: ({
      field
    }) => {
      var _errors$name2;
      return /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
        type: "number",
        size: "small",
        fullWidth: true,
        placeholder: placeholder,
        inputProps: {
          min: 0,
          step: "any"
        },
        InputProps: endText ? {
          endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
            position: "end"
          }, endText)
        } : undefined,
        error: !!errors[name],
        helperText: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
      }));
    }
  });
  const uploader = (label, name, {
    required: _required = true
  } = {}) => /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: label,
    control: control,
    name: name,
    validationMsg: `Please upload ${label}`,
    required: _required,
    isMandatory: _required,
    trigger: trigger
  });
  const NA = /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "\u2014");
  const rows = [{
    sno: "1",
    label: "Date of Niyojan Samiti Section 29",
    input: dateField("niyojanSamitiSec29Date"),
    upload: NA
  }, {
    sno: "2",
    label: "Date of Section 32",
    input: dateField("sec32Date"),
    upload: NA
  }, {
    sno: "3",
    label: "Is land exempted by Board or Govt? (please tick)",
    input: /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      gap: 2
    }, /*#__PURE__*/React__default.createElement(Controller, {
      name: "exemptedByBoard",
      control: control,
      render: ({
        field
      }) => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
        control: /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
          checked: !!field.value
        })),
        label: "Board"
      })
    }), /*#__PURE__*/React__default.createElement(Controller, {
      name: "exemptedByGovt",
      control: control,
      render: ({
        field
      }) => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
        control: /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
          checked: !!field.value
        })),
        label: "Govt"
      })
    })),
    upload: NA
  }, {
    sno: "4",
    label: "Please Attach Board Order",
    input: isExempted ? /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2"
    }, "Attach document") : /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      color: "text.secondary"
    }, "Tick Board / Govt above to enable"),
    upload: isExempted ? uploader("Board Note / Relevant Order", "boardNoteOrder") : NA,
    disabled: !isExempted
  }, {
    sno: "5",
    label: "Area of land to be adjusted (in ha)",
    input: numberField("areaToBeAdjustedHa", "Area in ha", "ha"),
    upload: NA
  }, {
    sno: "6",
    label: "Area of structure, if any exempted",
    input: numberField("structureAreaExempted", "Area", "ha"),
    upload: NA
  }, {
    sno: "7",
    label: "Letter no. of Betterment demanded by EMO",
    input: /*#__PURE__*/React__default.createElement(Controller, {
      name: "bettermentLetterNo",
      control: control,
      rules: {
        required: "Letter number is required"
      },
      render: ({
        field
      }) => {
        var _errors$bettermentLet;
        return /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
          size: "small",
          fullWidth: true,
          placeholder: "Letter no.",
          error: !!errors.bettermentLetterNo,
          helperText: (_errors$bettermentLet = errors.bettermentLetterNo) === null || _errors$bettermentLet === void 0 ? void 0 : _errors$bettermentLet.message
        }));
      }
    }),
    upload: uploader("Betterment Demand Letter", "bettermentDemandLetter")
  }, {
    sno: "8",
    label: "Betterment fee (in rupees)",
    input: numberField("bettermentFee", "Amount", "₹"),
    upload: NA
  }, {
    sno: "9",
    label: "Submitted betterment fee at EMO office",
    input: /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Controller, {
      name: "isFeeSubmittedAtEmo",
      control: control,
      render: ({
        field
      }) => /*#__PURE__*/React__default.createElement(RadioGroup$1, Object.assign({
        row: true
      }, field), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
        value: "yes",
        control: /*#__PURE__*/React__default.createElement(Radio$1, {
          size: "small"
        }),
        label: "Yes"
      }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
        value: "no",
        control: /*#__PURE__*/React__default.createElement(Radio$1, {
          size: "small"
        }),
        label: "No"
      }))
    }), isFeeSubmittedAtEmo === "yes" && /*#__PURE__*/React__default.createElement(Box, {
      mt: 1
    }, dateField("feeSubmittedDate"))),
    upload: isFeeSubmittedAtEmo === "yes" ? uploader("Fee Receipt", "bettermentFeeReceipt", {
      required: false
    }) : NA
  }, {
    sno: "10",
    label: "NOC for map approval as per UP Vidhi 2025",
    input: /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2"
    }, "Attach NOC"),
    upload: uploader("NOC for Map Approval", "nocMapApproval")
  }];
  if (isDataLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "Land Acquisition"), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    variant: "outlined"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600,
      width: 60
    }
  }, "S.No"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600,
      width: "30%"
    }
  }, "Particulars"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600,
      width: "28%"
    }
  }, "Details"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Upload Documents"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, rows.map(row => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: row.sno,
    hover: true,
    sx: {
      opacity: row.disabled ? 0.6 : 1,
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, row.sno), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.label), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.input), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.upload)))))), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: handleSubmit(onSave)
  }, "Save")));
};

const EmpNOCPortal = ({
  formData,
  submitAction,
  workflowDetails,
  userRolesArray,
  urlFormType,
  nocResponse
}) => {
  var _Digit, _Digit2, _userRolesArray$, _Digit$SessionStorage;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [nocToggle, setNocToggle] = useState(true);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const [isTermsOpen, setIsTermsOpen] = useState(true);
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code);
  const isAvpAndLandAquistion = userRolesArray.some(item => item.code.includes("Acquisition_Section_Incharge")) && (formData === null || formData === void 0 ? void 0 : formData.department) === "AVP";
  console.log(nocResponse, userRolesArray[0], "nocRespoensepe SAIFIFIFIFIFIFI");
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callDrawingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    handleNoWorkflowPayNOC,
    isValidEmp,
    isBpaNoc,
    requestLetterId,
    currentFormData,
    nocOfficerRemarks,
    setNocOfficerRemarks,
    uploadedFiles,
    setUploadedFiles,
    nocFormData,
    searchNocRemarks,
    nocRemarksData,
    isDscStage,
    isDigitalSignatureAttached,
    checklistNoc,
    setChecklistNoc,
    isPropertySectionOfficer,
    isAvpFile,
    showChecklistTab,
    handleLandAquisition,
    urlApplicationNo
  } = useEmpNOC(formData, workflowDetails, userRolesArray[0], urlFormType, nocResponse);
  useEffect(() => {
    if (error) {
      setIsTermsOpen(true);
    }
  }, [error]);
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const primaryTabsList = useMemo(() => {
    const tabs = [{
      id: "APP_FORM",
      label: "Application Form"
    }, {
      id: "DOCUMENT",
      label: "Document"
    }, {
      id: "DRAWING",
      label: "Drawing Details"
    }];
    if (showChecklistTab) {
      tabs.push({
        id: "CHECKLIST",
        label: "Checklist"
      });
    }
    tabs.push({
      id: "NOC_STATUS",
      label: "NOC Status"
    });
    if (isAvpAndLandAquistion) {
      tabs.push({
        id: "NOC_CHECKLIST",
        label: "NOC Checklist"
      });
    }
    tabs.push({
      id: "PAYMENT",
      label: "Payment"
    });
    return tabs;
  }, [showChecklistTab]);
  const nocSearchResult = (_Digit$SessionStorage = Digit.SessionStorage.get("nocAppNo")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.nocSearchResult;
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async nextTabNo => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const [showNOCInfo, setShowNOCInfo] = useState(true);
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab, currentFormData, requestLetterId);
    const activeTabItem = primaryTabsList && primaryTabsList[activeTab] ? primaryTabsList[activeTab] : primaryTabsList ? primaryTabsList[0] : null;
    const activeTabKey = activeTabItem ? activeTabItem.id : "APP_FORM";
    if (activeTabKey === "APP_FORM") {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen,
            isNocModule: urlFormType === "NOC"
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen,
            isNocModule: urlFormType === "NOC"
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen,
            isNocModule: urlFormType === "NOC"
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen,
            isNocModule: urlFormType === "NOC"
          });
        default:
          return null;
      }
    } else if (activeTabKey === "DOCUMENT") {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            docType: "mandatory",
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            developerRemarks: developerRemarksDocument,
            setError: setError,
            isNocModule: urlFormType === "NOC"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
        default:
          return null;
      }
    } else if (activeTabKey === "DRAWING") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step4, {
        formData: formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        isNocModule: urlFormType === "NOC"
      }));
    } else if (activeTabKey === "CHECKLIST") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChecklistNoc, {
        formData: formData,
        checklistNoc: checklistNoc,
        setChecklistNoc: setChecklistNoc,
        onSave: () => {
          setShowToast({
            key: "success",
            message: "Checklist saved successfully"
          });
        }
      }));
    } else if (activeTabKey === "NOC_STATUS") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !showNOCInfo && /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "flex-end",
          margin: "12px 0"
        }
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: showNOCInfo ? "primary" : "secondary",
        onClick: () => setShowNOCInfo(prev => !prev)
      }, showNOCInfo ? "Back to Take Action" : "View NOC Information")), !showNOCInfo ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission",
        requestLetterId: requestLetterId
      }), isDscStage && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: currentFormData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "LA"
      }), !isDigitalSignatureAttached && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "10px",
          marginBottom: "10px"
        }
      }, /*#__PURE__*/React__default.createElement(NewsTicker, {
        textForNews: "Please make a digital sign on approval letter before submitting."
      }))), !isCitizen && /*#__PURE__*/React__default.createElement(CollapseSection, {
        title: "Terms & Condition",
        defaultOpen: true,
        isOpen: isTermsOpen,
        onToggle: openState => setIsTermsOpen(openState)
      }, /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setNocOfficerRemarks,
        remarks: nocOfficerRemarks,
        title: "Terms & Condition",
        setError: setError,
        error: error
      })), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: formData
      }), isCitizen && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), /*#__PURE__*/React__default.createElement(DocumentUploader, {
        uploadedFiles: uploadedFiles,
        setUploadedFiles: setUploadedFiles,
        maxFiles: 4
      }), /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: () => {
          if (isDscStage && !isDigitalSignatureAttached) {
            Modal("Digital signature not attached", "Please make sure digital signature is successfully attached before submitting.", "error");
            return;
          }
          setIsTermsOpen(true);
          handleSubmit();
        },
        isLoading: updateApiCall.isLoading
      })) : /*#__PURE__*/React__default.createElement(NOCInfo, {
        formData: formData,
        setShowNOCInfo: setShowNOCInfo,
        showNOCInfo: showNOCInfo,
        searchNocRemarks: searchNocRemarks,
        nocRemarksData: nocRemarksData
      }));
    } else if (activeTabKey === "NOC_CHECKLIST") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LandAcquisitionTab, {
        formData: params,
        handleTabChange: handleLandAquisition,
        id: urlApplicationNo
      }));
    } else if (activeTabKey === "PAYMENT") {
      var _userRolesArray$3;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NocPaymentHead, {
        tenantId: tenantId,
        formData: currentFormData || nocSearchResult,
        setTaxHead: setTaxHead,
        taxHead: taxHead,
        empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$3 = userRolesArray[0]) === null || _userRolesArray$3 === void 0 ? void 0 : _userRolesArray$3.code,
        isFeesEligible: isFeesEligible,
        onSelect: onSelect,
        Modal: Modal,
        isValidEmp: isValidEmp,
        isBpaNoc: isBpaNoc,
        isEmployee: !isCitizen,
        handleNoWorkflowPayNOC: handleNoWorkflowPayNOC
      }), !isCitizen && /*#__PURE__*/React__default.createElement(NocPaymentTable, {
        nocPaymentDetails: currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.nocPaymentDetails,
        formData: params
      }));
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), (nocFormData === null || nocFormData === void 0 ? void 0 : nocFormData.countDays) !== undefined && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Time Left (Days)"), " : ", nocFormData.countDays)), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, primaryTabsList.map(tab => /*#__PURE__*/React__default.createElement(PrimaryTab, {
    key: tab.id,
    label: tab.label
  })))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const SubStep1$3 = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee: _isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _formData$landInfo, _formData$professiona, _formData$professiona2, _Digit, _data$MapSubmission, _data$MapSubmission$D, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$blocks, _formData$blocks$, _formData$blocks$$set, _formData$blocks$$set2, _formData$blocks$$set3, _formData$blocks2, _formData$blocks2$, _formData$blocks2$$se, _formData$blocks2$$se2, _formData$blocks2$$se3, _formData$blocks3, _formData$blocks3$, _formData$blocks3$$se, _formData$blocks3$$se2, _formData$blocks3$$se3, _formData$blocks4, _formData$blocks4$, _formData$blocks4$$se, _formData$blocks4$$se2, _formData$blocks4$$se3, _formData$blocks5, _formData$blocks5$, _formData$blocks5$$se, _formData$blocks5$$se2, _formData$blocks5$$se3, _formData$blocks6, _formData$blocks6$, _formData$blocks6$$se, _formData$blocks6$$se2, _formData$blocks6$$se3, _formData$blocks7, _formData$blocks7$, _formData$blocks7$$se, _formData$blocks7$$se2, _formData$blocks7$$se3, _formData$blocks8, _formData$blocks8$, _formData$blocks8$$se, _formData$blocks8$$se2;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const tenantId = Digit.ULBService.getStateId();
  const {
    documents
  } = useSelector(state => state.formMT);
  const history = useHistory();
  const inputWidth = 200;
  const checklist = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.checklistdata;
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const convertToISODate = date => {
    if (!date) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    const [day, month, year] = date.split("-");
    if (!day || !month || !year) return "";
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };
  const {
    data: {
      LandUseMasterData: {
        Authorities: mdmsSchemeData
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: mdmsNonSchemeData
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const finalSchemeTypeData = schemeTypeData || mdmsSchemeData;
  const finalNonSchemeTypeData = nonSchemeTypeData || mdmsNonSchemeData;
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
    professionaldetails: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionaldetails),
      validupto: convertToISODate((formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.validupto) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.validupto))
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("EMP_MAPSUB")) || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);
  const [appPdf, setAppPdf] = useState(null);
  const [dwgPdfUrl, setDwgPdfUrl] = useState(formData === null || formData === void 0 ? void 0 : formData.drawingPdf);
  const [approvalUrl, setApprovalUrl] = useState(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl);
  const [watchPlanOn, watchnatureOfConstruction, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchLandMark, watchState, watchCity, watchPin, watchAddress, watchConsultantCateogry, watchProfName, watchProfEmailId, watchProfMobileNo, watchCertNo, watchValidUpto, watchName, watchMobileNo, watchEmailId, watchProposalType, watchSchemeName, watchTehsil, watchVillage, watchSectorNo, watchKhasraNo, watchPlotNo, watchLatitude, watchLongitude, watchApplication, watchLayoutSanctionDate, watchValidity] = watch(["planOn", "natureOfConstruction", "zoneType", "subZoneType", "primaryUse", "activityProposed", "landMark", "landInfo.owners.[0].correspondenceAddress.state", "landInfo.owners.[0].correspondenceAddress.town", "landInfo.owners.[0].correspondenceAddress.pinno", "landInfo.owners.[0].correspondenceAddress.address", "professionaldetails.consultantCategory", "professionaldetails.name", "professionaldetails.emailId", "professionaldetails.mobileNumber", "professionaldetails.certificateNo", "professionaldetails.validupto", "landInfo.owners.[0].name", "landInfo.owners.[0].mobileNumber", "landInfo.owners.[0].emailId", "proposalType", "schemeName", "tehsil", "revenueVillage", "sectorNo", "khasraNo", "plotNo", "descriptionOfLand.latitude", "descriptionOfLand.longitude", "applicationNo", "layoutsanctionDate", "validity"]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const alldocs = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !_isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (_isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);
  useEffect(() => {
    var _formData$documents;
    if (_isEmployee && (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      var _formData$documents2, _formData$documents2$, _formData$documents3, _formData$documents3$;
      const approvalLetterUrl = (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.find(doc => doc.documentType === "approvalLetter")) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.fileStoreId) || null;
      setAppPdf(approvalLetterUrl);
      const drawingPdfUrl = (formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.find(doc => doc.documentType === "drawingPdf")) === null || _formData$documents3$ === void 0 ? void 0 : _formData$documents3$.fileStoreId) || null;
      setDwgPdf(drawingPdfUrl);
    }
  }, [_isEmployee, formData === null || formData === void 0 ? void 0 : formData.documents]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _data, _data$status, _data2, _data3, _data3$documents, _drawingPdfs$, _data4, _data4$documents, _approvalPdfs$, _data7, _data7$descriptionOfL, _data8, _data8$descriptionOfL, _data9, _data9$descriptionOfL, _data10, _data10$descriptionOf, _data11, _data11$descriptionOf, _data11$descriptionOf2, _data12, _data12$descriptionOf, _data13, _data14, _data15, _data15$auditDetails, _data16, _data17, _data17$descriptionOf, _data17$descriptionOf2, _data17$descriptionOf3, _data18, _data19, _data20, _data20$descriptionOf, _data20$descriptionOf2, _data20$descriptionOf3, _data21, _data21$descriptionOf, _data22, _data22$descriptionOf, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26, _data27, _data28, _data28$descriptionOf, _data29, _data30, _data30$descriptionOf, _data31, _data31$descriptionOf, _data32, _data32$descriptionOf, _data33, _data33$descriptionOf, _data34, _data34$descriptionOf, _data34$descriptionOf2, _data34$descriptionOf3, _data35, _data35$descriptionOf, _data36, _data36$descriptionOf, _data37, _data37$professionald, _data38, _data38$professionalI, _data39, _data39$professionald, _data40, _data40$professionalI, _data41, _data41$professionald, _data42, _data42$professionalI, _data43, _data43$professionald, _data44, _data44$professionalI, _data45, _data45$professionald, _data46, _data46$professionalI, _data47, _data47$professionald, _data48, _data48$professionalI, _data49, _data49$professionald, _data50, _data50$landInfo, _data50$landInfo$owne, _data50$landInfo$owne2, _data51, _data51$landInfo, _data51$landInfo$owne, _data51$landInfo$owne2, _data52, _data52$landInfo, _data52$landInfo$owne, _data52$landInfo$owne2, _data53, _data53$landInfo, _data53$landInfo$owne, _data53$landInfo$owne2, _data53$landInfo$owne3, _data54, _data54$landInfo$owne, _data54$landInfo$owne2, _data54$landInfo$owne3, _data55, _data55$landInfo$owne, _data55$landInfo$owne2, _data55$landInfo$owne3, _data56, _data56$landInfo$owne, _data56$landInfo$owne2, _data56$landInfo$owne3, _data57, _data57$blocks, _data57$blocks$, _data57$blocks$$setBa, _data57$blocks$$setBa2, _data57$blocks$$setBa3, _data58, _data58$blocks, _data58$blocks$, _data58$blocks$$setBa, _data58$blocks$$setBa2, _data58$blocks$$setBa3, _data59, _data59$blocks, _data59$blocks$, _data59$blocks$$setBa, _data59$blocks$$setBa2, _data59$blocks$$setBa3, _data60, _data60$blocks, _data60$blocks$, _data60$blocks$$setBa, _data60$blocks$$setBa2, _data60$blocks$$setBa3, _data61, _data61$blocks, _data61$blocks$, _data61$blocks$$setBa, _data61$blocks$$setBa2, _data61$blocks$$setBa3, _data62, _data62$blocks, _data62$blocks$, _data62$blocks$$setBa, _data62$blocks$$setBa2, _data62$blocks$$setBa3, _data63, _data63$blocks, _data63$blocks$, _data63$blocks$$setBa, _data63$blocks$$setBa2, _data63$blocks$$setBa3, _data64, _data64$blocks, _data64$blocks$, _data64$blocks$$setBa, _data64$blocks$$setBa2, _data64$blocks$$setBa3, _data65, _data65$blocks, _data65$blocks$, _data65$blocks$$plint, _data66, _data66$descriptionOf;
        response = await Digit.OBPSService.BPASearch(tenantId, {
          applicationId: id
        });
        console.log(response, "responsefromId");
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this Application No...!!`
          });
          return;
        }
        data = (_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : _response2$BPA[0];
        if (!((_data = data) !== null && _data !== void 0 && (_data$status = _data.status) !== null && _data$status !== void 0 && _data$status.includes("APPROVED"))) {
          setShowToast({
            key: "true",
            error: true,
            message: `Application is not Approved Yet...!!`
          });
          return;
        }
        console.log(" DAtsaystyas", (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.documents);
        setFastPasData(data);
        const drawingPdfs = (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$documents = _data3.documents) === null || _data3$documents === void 0 ? void 0 : _data3$documents.filter(e => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs === null || drawingPdfs === void 0 ? void 0 : (_drawingPdfs$ = drawingPdfs[0]) === null || _drawingPdfs$ === void 0 ? void 0 : _drawingPdfs$.fileStoreId);
        const approvalPdfs = (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$documents = _data4.documents) === null || _data4$documents === void 0 ? void 0 : _data4$documents.filter(e => e.documentType === "approvalLetter");
        setAppPdf(approvalPdfs === null || approvalPdfs === void 0 ? void 0 : (_approvalPdfs$ = approvalPdfs[0]) === null || _approvalPdfs$ === void 0 ? void 0 : _approvalPdfs$.fileStoreId);
        if (data) {
          var _data5, _data6;
          setDwgPdfUrl((_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.drawingPdf);
          setApprovalUrl((_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.approvalCertificateUrl);
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`
          });
        }
        setValue("zoneType", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : _data8$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.landMark);
        setValue("sectorNo", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.sectorNo);
        setValue("khasraNo", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : (_data11$descriptionOf2 = _data11$descriptionOf.khasraWithArea[0]) === null || _data11$descriptionOf2 === void 0 ? void 0 : _data11$descriptionOf2.khasraNo);
        setValue("schemeName", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.schemeName);
        setValue("natureOfConstruction", (_data13 = data) === null || _data13 === void 0 ? void 0 : _data13.natureOfConstruction);
        setValue("sanctionNumber", (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.sanctionNumber);
        const lastModifiedTime = (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$auditDetails = _data15.auditDetails) === null || _data15$auditDetails === void 0 ? void 0 : _data15$auditDetails.lastModifiedTime;
        setValue("layoutsanctionDate", convertEpochToDate(lastModifiedTime));
        setValue("validity", convertEpochToDate(addYearsToEpoch(lastModifiedTime, 5)));
        setValue("revenueVillage", ((_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.revenueVillage) || ((_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : (_data17$descriptionOf2 = _data17$descriptionOf.khasraDetails) === null || _data17$descriptionOf2 === void 0 ? void 0 : (_data17$descriptionOf3 = _data17$descriptionOf2[0]) === null || _data17$descriptionOf3 === void 0 ? void 0 : _data17$descriptionOf3.village));
        setValue("sectorNo", (_data18 = data) === null || _data18 === void 0 ? void 0 : _data18.sectorNo);
        setValue("plotNo", ((_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.plotNo) || ((_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : (_data20$descriptionOf2 = _data20$descriptionOf.khasraDetails) === null || _data20$descriptionOf2 === void 0 ? void 0 : (_data20$descriptionOf3 = _data20$descriptionOf2[0]) === null || _data20$descriptionOf3 === void 0 ? void 0 : _data20$descriptionOf3.plotNo) || ((_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.plotNo));
        setValue("descriptionOfLand.latitude", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$descriptionOf = _data22.descriptionOfLand) === null || _data22$descriptionOf === void 0 ? void 0 : _data22$descriptionOf.latitude);
        setValue("descriptionOfLand.longitude", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.longitude);
        setValue("descriptionOfLand.schemeType", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.schemeType);
        setValue("schemeName", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.schemeName);
        setValue("riskType", (_data26 = data) === null || _data26 === void 0 ? void 0 : _data26.riskType);
        setValue("planOn", "plinth_submission");
        setValue("selectedOffice", "Lucknow Development Authority");
        setValue("department", (_data27 = data) === null || _data27 === void 0 ? void 0 : _data27.department);
        setValue("businessService", "BPA_MAPPLINTH_DA");
        setValue("activityProposed", (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$descriptionOf = _data28.descriptionOfLand) === null || _data28$descriptionOf === void 0 ? void 0 : _data28$descriptionOf.activityProposed);
        setValue("proposalType", (_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.proposal);
        setValue("plotArea", (_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$descriptionOf = _data30.descriptionOfLand) === null || _data30$descriptionOf === void 0 ? void 0 : _data30$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$descriptionOf = _data31.descriptionOfLand) === null || _data31$descriptionOf === void 0 ? void 0 : _data31$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$descriptionOf = _data32.descriptionOfLand) === null || _data32$descriptionOf === void 0 ? void 0 : _data32$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$descriptionOf = _data33.descriptionOfLand) === null || _data33$descriptionOf === void 0 ? void 0 : _data33$descriptionOf.landAddress);
        setValue("tehsil", (_data34 = data) === null || _data34 === void 0 ? void 0 : (_data34$descriptionOf = _data34.descriptionOfLand) === null || _data34$descriptionOf === void 0 ? void 0 : (_data34$descriptionOf2 = _data34$descriptionOf.khasraDetails) === null || _data34$descriptionOf2 === void 0 ? void 0 : (_data34$descriptionOf3 = _data34$descriptionOf2[0]) === null || _data34$descriptionOf3 === void 0 ? void 0 : _data34$descriptionOf3.tehsil);
        setValue("typeOfArea", (_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$descriptionOf = _data35.descriptionOfLand) === null || _data35$descriptionOf === void 0 ? void 0 : _data35$descriptionOf.developmentArea);
        setValue("subZoneType", (_data36 = data) === null || _data36 === void 0 ? void 0 : (_data36$descriptionOf = _data36.descriptionOfLand) === null || _data36$descriptionOf === void 0 ? void 0 : _data36$descriptionOf.subLandUseAsPerLayout);
        setValue("professionaldetails.consultantCategory", ((_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$professionald = _data37.professionaldetails) === null || _data37$professionald === void 0 ? void 0 : _data37$professionald.consultantCategory) || ((_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$professionalI = _data38.professionalInformation) === null || _data38$professionalI === void 0 ? void 0 : _data38$professionalI.consultantCategory));
        setValue("professionaldetails.name", ((_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$professionald = _data39.professionaldetails) === null || _data39$professionald === void 0 ? void 0 : _data39$professionald.name) || ((_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$professionalI = _data40.professionalInformation) === null || _data40$professionalI === void 0 ? void 0 : _data40$professionalI.name));
        setValue("professionaldetails.emailId", ((_data41 = data) === null || _data41 === void 0 ? void 0 : (_data41$professionald = _data41.professionaldetails) === null || _data41$professionald === void 0 ? void 0 : _data41$professionald.emailId) || ((_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$professionalI = _data42.professionalInformation) === null || _data42$professionalI === void 0 ? void 0 : _data42$professionalI.eremailId));
        setValue("professionaldetails.mobileNumber", ((_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$professionald = _data43.professionaldetails) === null || _data43$professionald === void 0 ? void 0 : _data43$professionald.mobileNumber) || ((_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$professionalI = _data44.professionalInformation) === null || _data44$professionalI === void 0 ? void 0 : _data44$professionalI.ermobileNumber));
        setValue("professionaldetails.certificateNo", ((_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$professionald = _data45.professionaldetails) === null || _data45$professionald === void 0 ? void 0 : _data45$professionald.certificateNo) || ((_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$professionalI = _data46.professionalInformation) === null || _data46$professionalI === void 0 ? void 0 : _data46$professionalI.certificateNo));
        setValue("professionaldetails.validupto", convertToISODate(((_data47 = data) === null || _data47 === void 0 ? void 0 : (_data47$professionald = _data47.professionaldetails) === null || _data47$professionald === void 0 ? void 0 : _data47$professionald.validupto) || ((_data48 = data) === null || _data48 === void 0 ? void 0 : (_data48$professionalI = _data48.professionalInformation) === null || _data48$professionalI === void 0 ? void 0 : _data48$professionalI.validupto)));
        setValue("landInfo.owners.[0].name", (_data49 = data) === null || _data49 === void 0 ? void 0 : (_data49$professionald = _data49.professionaldetails) === null || _data49$professionald === void 0 ? void 0 : _data49$professionald.consultantCategory);
        setValue("landInfo.owners.[0].name", (_data50 = data) === null || _data50 === void 0 ? void 0 : (_data50$landInfo = _data50.landInfo) === null || _data50$landInfo === void 0 ? void 0 : (_data50$landInfo$owne = _data50$landInfo.owners) === null || _data50$landInfo$owne === void 0 ? void 0 : (_data50$landInfo$owne2 = _data50$landInfo$owne[0]) === null || _data50$landInfo$owne2 === void 0 ? void 0 : _data50$landInfo$owne2.name);
        setValue("landInfo.owners.[0].emailId", (_data51 = data) === null || _data51 === void 0 ? void 0 : (_data51$landInfo = _data51.landInfo) === null || _data51$landInfo === void 0 ? void 0 : (_data51$landInfo$owne = _data51$landInfo.owners) === null || _data51$landInfo$owne === void 0 ? void 0 : (_data51$landInfo$owne2 = _data51$landInfo$owne[0]) === null || _data51$landInfo$owne2 === void 0 ? void 0 : _data51$landInfo$owne2.emailId);
        setValue("landInfo.owners.[0].mobileNumber", (_data52 = data) === null || _data52 === void 0 ? void 0 : (_data52$landInfo = _data52.landInfo) === null || _data52$landInfo === void 0 ? void 0 : (_data52$landInfo$owne = _data52$landInfo.owners) === null || _data52$landInfo$owne === void 0 ? void 0 : (_data52$landInfo$owne2 = _data52$landInfo$owne[0]) === null || _data52$landInfo$owne2 === void 0 ? void 0 : _data52$landInfo$owne2.mobileNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.state", (_data53 = data) === null || _data53 === void 0 ? void 0 : (_data53$landInfo = _data53.landInfo) === null || _data53$landInfo === void 0 ? void 0 : (_data53$landInfo$owne = _data53$landInfo.owners) === null || _data53$landInfo$owne === void 0 ? void 0 : (_data53$landInfo$owne2 = _data53$landInfo$owne[0]) === null || _data53$landInfo$owne2 === void 0 ? void 0 : (_data53$landInfo$owne3 = _data53$landInfo$owne2.correspondenceAddress) === null || _data53$landInfo$owne3 === void 0 ? void 0 : _data53$landInfo$owne3.state);
        setValue("landInfo.owners.[0].correspondenceAddress.town", (_data54 = data) === null || _data54 === void 0 ? void 0 : (_data54$landInfo$owne = _data54.landInfo.owners) === null || _data54$landInfo$owne === void 0 ? void 0 : (_data54$landInfo$owne2 = _data54$landInfo$owne[0]) === null || _data54$landInfo$owne2 === void 0 ? void 0 : (_data54$landInfo$owne3 = _data54$landInfo$owne2.correspondenceAddress) === null || _data54$landInfo$owne3 === void 0 ? void 0 : _data54$landInfo$owne3.town);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", (_data55 = data) === null || _data55 === void 0 ? void 0 : (_data55$landInfo$owne = _data55.landInfo.owners) === null || _data55$landInfo$owne === void 0 ? void 0 : (_data55$landInfo$owne2 = _data55$landInfo$owne[0]) === null || _data55$landInfo$owne2 === void 0 ? void 0 : (_data55$landInfo$owne3 = _data55$landInfo$owne2.correspondenceAddress) === null || _data55$landInfo$owne3 === void 0 ? void 0 : _data55$landInfo$owne3.pinno);
        setValue("landInfo.owners.[0].correspondenceAddress.address", (_data56 = data) === null || _data56 === void 0 ? void 0 : (_data56$landInfo$owne = _data56.landInfo.owners) === null || _data56$landInfo$owne === void 0 ? void 0 : (_data56$landInfo$owne2 = _data56$landInfo$owne[0]) === null || _data56$landInfo$owne2 === void 0 ? void 0 : (_data56$landInfo$owne3 = _data56$landInfo$owne2.correspondenceAddress) === null || _data56$landInfo$owne3 === void 0 ? void 0 : _data56$landInfo$owne3.address);
        setValue("blocks.[0].setBacks.[0].frontYard.minimumDistance", (_data57 = data) === null || _data57 === void 0 ? void 0 : (_data57$blocks = _data57.blocks) === null || _data57$blocks === void 0 ? void 0 : (_data57$blocks$ = _data57$blocks[0]) === null || _data57$blocks$ === void 0 ? void 0 : (_data57$blocks$$setBa = _data57$blocks$.setBacks) === null || _data57$blocks$$setBa === void 0 ? void 0 : (_data57$blocks$$setBa2 = _data57$blocks$$setBa[0]) === null || _data57$blocks$$setBa2 === void 0 ? void 0 : (_data57$blocks$$setBa3 = _data57$blocks$$setBa2.frontYard) === null || _data57$blocks$$setBa3 === void 0 ? void 0 : _data57$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[0].rearYard.minimumDistance", (_data58 = data) === null || _data58 === void 0 ? void 0 : (_data58$blocks = _data58.blocks) === null || _data58$blocks === void 0 ? void 0 : (_data58$blocks$ = _data58$blocks[0]) === null || _data58$blocks$ === void 0 ? void 0 : (_data58$blocks$$setBa = _data58$blocks$.setBacks) === null || _data58$blocks$$setBa === void 0 ? void 0 : (_data58$blocks$$setBa2 = _data58$blocks$$setBa[0]) === null || _data58$blocks$$setBa2 === void 0 ? void 0 : (_data58$blocks$$setBa3 = _data58$blocks$$setBa2.rearYard) === null || _data58$blocks$$setBa3 === void 0 ? void 0 : _data58$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[0].sideYard1.minimumDistance", (_data59 = data) === null || _data59 === void 0 ? void 0 : (_data59$blocks = _data59.blocks) === null || _data59$blocks === void 0 ? void 0 : (_data59$blocks$ = _data59$blocks[0]) === null || _data59$blocks$ === void 0 ? void 0 : (_data59$blocks$$setBa = _data59$blocks$.setBacks) === null || _data59$blocks$$setBa === void 0 ? void 0 : (_data59$blocks$$setBa2 = _data59$blocks$$setBa[0]) === null || _data59$blocks$$setBa2 === void 0 ? void 0 : (_data59$blocks$$setBa3 = _data59$blocks$$setBa2.sideYard1) === null || _data59$blocks$$setBa3 === void 0 ? void 0 : _data59$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[0].sideYard2.minimumDistance", (_data60 = data) === null || _data60 === void 0 ? void 0 : (_data60$blocks = _data60.blocks) === null || _data60$blocks === void 0 ? void 0 : (_data60$blocks$ = _data60$blocks[0]) === null || _data60$blocks$ === void 0 ? void 0 : (_data60$blocks$$setBa = _data60$blocks$.setBacks) === null || _data60$blocks$$setBa === void 0 ? void 0 : (_data60$blocks$$setBa2 = _data60$blocks$$setBa[0]) === null || _data60$blocks$$setBa2 === void 0 ? void 0 : (_data60$blocks$$setBa3 = _data60$blocks$$setBa2.sideYard2) === null || _data60$blocks$$setBa3 === void 0 ? void 0 : _data60$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[1].frontYard.minimumDistance", (_data61 = data) === null || _data61 === void 0 ? void 0 : (_data61$blocks = _data61.blocks) === null || _data61$blocks === void 0 ? void 0 : (_data61$blocks$ = _data61$blocks[0]) === null || _data61$blocks$ === void 0 ? void 0 : (_data61$blocks$$setBa = _data61$blocks$.setBacks) === null || _data61$blocks$$setBa === void 0 ? void 0 : (_data61$blocks$$setBa2 = _data61$blocks$$setBa[1]) === null || _data61$blocks$$setBa2 === void 0 ? void 0 : (_data61$blocks$$setBa3 = _data61$blocks$$setBa2.frontYard) === null || _data61$blocks$$setBa3 === void 0 ? void 0 : _data61$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[1].rearYard.minimumDistance", (_data62 = data) === null || _data62 === void 0 ? void 0 : (_data62$blocks = _data62.blocks) === null || _data62$blocks === void 0 ? void 0 : (_data62$blocks$ = _data62$blocks[0]) === null || _data62$blocks$ === void 0 ? void 0 : (_data62$blocks$$setBa = _data62$blocks$.setBacks) === null || _data62$blocks$$setBa === void 0 ? void 0 : (_data62$blocks$$setBa2 = _data62$blocks$$setBa[1]) === null || _data62$blocks$$setBa2 === void 0 ? void 0 : (_data62$blocks$$setBa3 = _data62$blocks$$setBa2.rearYard) === null || _data62$blocks$$setBa3 === void 0 ? void 0 : _data62$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[1].sideYard1.minimumDistance", (_data63 = data) === null || _data63 === void 0 ? void 0 : (_data63$blocks = _data63.blocks) === null || _data63$blocks === void 0 ? void 0 : (_data63$blocks$ = _data63$blocks[0]) === null || _data63$blocks$ === void 0 ? void 0 : (_data63$blocks$$setBa = _data63$blocks$.setBacks) === null || _data63$blocks$$setBa === void 0 ? void 0 : (_data63$blocks$$setBa2 = _data63$blocks$$setBa[1]) === null || _data63$blocks$$setBa2 === void 0 ? void 0 : (_data63$blocks$$setBa3 = _data63$blocks$$setBa2.sideYard1) === null || _data63$blocks$$setBa3 === void 0 ? void 0 : _data63$blocks$$setBa3.minimumDistance);
        setValue("blocks.[0].setBacks.[1].sideYard2.minimumDistance", (_data64 = data) === null || _data64 === void 0 ? void 0 : (_data64$blocks = _data64.blocks) === null || _data64$blocks === void 0 ? void 0 : (_data64$blocks$ = _data64$blocks[0]) === null || _data64$blocks$ === void 0 ? void 0 : (_data64$blocks$$setBa = _data64$blocks$.setBacks) === null || _data64$blocks$$setBa === void 0 ? void 0 : (_data64$blocks$$setBa2 = _data64$blocks$$setBa[1]) === null || _data64$blocks$$setBa2 === void 0 ? void 0 : (_data64$blocks$$setBa3 = _data64$blocks$$setBa2.sideYard2) === null || _data64$blocks$$setBa3 === void 0 ? void 0 : _data64$blocks$$setBa3.minimumDistance);
        setValue("landInfo.checklistdata.plinthHeight", (_data65 = data) === null || _data65 === void 0 ? void 0 : (_data65$blocks = _data65.blocks) === null || _data65$blocks === void 0 ? void 0 : (_data65$blocks$ = _data65$blocks[0]) === null || _data65$blocks$ === void 0 ? void 0 : (_data65$blocks$$plint = _data65$blocks$.plinthHeight) === null || _data65$blocks$$plint === void 0 ? void 0 : _data65$blocks$$plint[0]);
        const isApproved = ((_data66 = data) === null || _data66 === void 0 ? void 0 : (_data66$descriptionOf = _data66.descriptionOfLand) === null || _data66$descriptionOf === void 0 ? void 0 : _data66$descriptionOf.schemeType) === "Scheme";
        setSchemeType(isApproved);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  console.log("SchemeTYope", schemeType);
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.name === authority);
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Categery, _masterData$2, _masterData$2$Categer, _masterData$2$Categer2, _masterData$2$Categer3, _masterData$2$Categer4;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Categery = _masterData$.CategeryType) === null || _masterData$$Categery === void 0 ? void 0 : _masterData$$Categery.map(item => {
      return {
        name: item.Categery,
        label: item.Categery
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categer = _masterData$2.CategeryType) === null || _masterData$2$Categer === void 0 ? void 0 : (_masterData$2$Categer2 = _masterData$2$Categer.filter(item => item.Categery === category)) === null || _masterData$2$Categer2 === void 0 ? void 0 : (_masterData$2$Categer3 = _masterData$2$Categer2[0]) === null || _masterData$2$Categer3 === void 0 ? void 0 : (_masterData$2$Categer4 = _masterData$2$Categer3["Activity Proposed"]) === null || _masterData$2$Categer4 === void 0 ? void 0 : _masterData$2$Categer4.map(item => {
      return {
        name: item,
        label: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = !schemeType ? filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, finalSchemeTypeData, watchlandUseType) : filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, finalNonSchemeTypeData, watchlandUseType);
  const onSubmit = data => {
    let final = {
      ...fastPASData,
      ...data
    };
    if (_isEmployee) {
      handleTabChange(2, final);
    } else {
      final.khasraRemarks = remarks;
      handleTabChange(1, final);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "APPLICATION NO",
    placeholder: "Enter Application NO.",
    name: "applicationNo",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee,
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("applicationNo"))
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.consultantCategory) || (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.consultantCategory),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchConsultantCateogry
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: _isEmployee || watchProfName
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee || watchProfEmailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee || watchProfMobileNo
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.certificateNo,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchValidUpto
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: _isEmployee || watchName
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee || watchMobileNo
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee || watchEmailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.correspondenceAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchState
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.correspondenceAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchCity
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: _isEmployee || watchPin
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: _isEmployee || watchAddress
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchlandUseType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchSubZoneType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchPrimaryUse
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchAtivityProposed
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(planOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposalType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    type: "selectInput",
    disabled: _isEmployee || watchProposalType
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed Site"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput",
    disabled: _isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction No."),
    control: control,
    placeholder: t("Enter sanction number"),
    name: "applicationNo",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || watchApplication,
    type: "textInput",
    disabled: _isEmployee || watchApplication
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction Date"),
    control: control,
    placeholder: t("Enter Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: _isEmployee || watchLayoutSanctionDate
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: natureOfConstructionOptions,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchnatureOfConstruction
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Validity"),
    control: control,
    placeholder: t("Select Validity"),
    name: "validity",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.validity,
    type: "datePicker",
    disabled: _isEmployee || watchValidity
  }))), schemeType && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    disabled: _isEmployee || watchSchemeName
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.tehsil) || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2.khasraDetails) === null || _formData$description3 === void 0 ? void 0 : (_formData$description4 = _formData$description3[0]) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.tehsil),
    name: `tehsil`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) || (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5.khasraDetails) === null || _formData$description6 === void 0 ? void 0 : (_formData$description7 = _formData$description6[0]) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.village),
    name: `revenueVillage`,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.landMark) || (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.landMark),
    type: "textInput",
    disabled: _isEmployee || watchLandMark
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : (_formData$description10 = _formData$description9.khasraDetails) === null || _formData$description10 === void 0 ? void 0 : (_formData$description11 = _formData$description10[0]) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.plotNo),
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Declaration"),
    control: control,
    name: "declaration",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Work start date"),
    control: control,
    placeholder: t("Select date"),
    name: "workstartDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.workstartDate,
    type: "datePicker",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plinth completion date"),
    control: control,
    placeholder: t("Select date"),
    name: "workCompletionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.workCompletionDate,
    type: "datePicker",
    disabled: _isEmployee
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plinth Inspection"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      margin: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10,
    disabled: _isEmployee || watchLatitude
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8,
    disabled: _isEmployee || watchLongitude
  }))), /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      tableLayout: "fixed",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "As per Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "On Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Basement Front Setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[0].frontYard.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks = formData.blocks) === null || _formData$blocks === void 0 ? void 0 : (_formData$blocks$ = _formData$blocks[0]) === null || _formData$blocks$ === void 0 ? void 0 : (_formData$blocks$$set = _formData$blocks$.setBacks) === null || _formData$blocks$$set === void 0 ? void 0 : (_formData$blocks$$set2 = _formData$blocks$$set[0]) === null || _formData$blocks$$set2 === void 0 ? void 0 : (_formData$blocks$$set3 = _formData$blocks$$set2.frontYard) === null || _formData$blocks$$set3 === void 0 ? void 0 : _formData$blocks$$set3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.builtupArea",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.builtupArea,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.builtupArea_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.builtupArea_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Basement Rear Setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[0].rearYard.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks2 = formData.blocks) === null || _formData$blocks2 === void 0 ? void 0 : (_formData$blocks2$ = _formData$blocks2[0]) === null || _formData$blocks2$ === void 0 ? void 0 : (_formData$blocks2$$se = _formData$blocks2$.setBacks) === null || _formData$blocks2$$se === void 0 ? void 0 : (_formData$blocks2$$se2 = _formData$blocks2$$se[0]) === null || _formData$blocks2$$se2 === void 0 ? void 0 : (_formData$blocks2$$se3 = _formData$blocks2$$se2.rearYard) === null || _formData$blocks2$$se3 === void 0 ? void 0 : _formData$blocks2$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.far",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.far,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.far_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.far_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Basement Side Setback - 1"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[0].sideYard1.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks3 = formData.blocks) === null || _formData$blocks3 === void 0 ? void 0 : (_formData$blocks3$ = _formData$blocks3[0]) === null || _formData$blocks3$ === void 0 ? void 0 : (_formData$blocks3$$se = _formData$blocks3$.setBacks) === null || _formData$blocks3$$se === void 0 ? void 0 : (_formData$blocks3$$se2 = _formData$blocks3$$se[0]) === null || _formData$blocks3$$se2 === void 0 ? void 0 : (_formData$blocks3$$se3 = _formData$blocks3$$se2.sideYard1) === null || _formData$blocks3$$se3 === void 0 ? void 0 : _formData$blocks3$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.heightOfBuilding",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.heightOfBuilding,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.heightOfBuilding_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.heightOfBuilding_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Basement Side Setback-2"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[0].sideYard2.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks4 = formData.blocks) === null || _formData$blocks4 === void 0 ? void 0 : (_formData$blocks4$ = _formData$blocks4[0]) === null || _formData$blocks4$ === void 0 ? void 0 : (_formData$blocks4$$se = _formData$blocks4$.setBacks) === null || _formData$blocks4$$se === void 0 ? void 0 : (_formData$blocks4$$se2 = _formData$blocks4$$se[0]) === null || _formData$blocks4$$se2 === void 0 ? void 0 : (_formData$blocks4$$se3 = _formData$blocks4$$se2.sideYard2) === null || _formData$blocks4$$se3 === void 0 ? void 0 : _formData$blocks4$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.heightOfFloor",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.heightOfFloor,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.heightOfFloor_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.heightOfFloor_remarks,
    disabled: !_isEmployee
  }))))), /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      tableLayout: "fixed",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "As per Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "On Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front Setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[1].frontYard.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks5 = formData.blocks) === null || _formData$blocks5 === void 0 ? void 0 : (_formData$blocks5$ = _formData$blocks5[0]) === null || _formData$blocks5$ === void 0 ? void 0 : (_formData$blocks5$$se = _formData$blocks5$.setBacks) === null || _formData$blocks5$$se === void 0 ? void 0 : (_formData$blocks5$$se2 = _formData$blocks5$$se[1]) === null || _formData$blocks5$$se2 === void 0 ? void 0 : (_formData$blocks5$$se3 = _formData$blocks5$$se2.frontYard) === null || _formData$blocks5$$se3 === void 0 ? void 0 : _formData$blocks5$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plotAreaForSubdivision",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.plotAreaForSubdivision,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plotAreaForSubdivision_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfPedestrianremarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear Setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[1].rearYard.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks6 = formData.blocks) === null || _formData$blocks6 === void 0 ? void 0 : (_formData$blocks6$ = _formData$blocks6[0]) === null || _formData$blocks6$ === void 0 ? void 0 : (_formData$blocks6$$se = _formData$blocks6$.setBacks) === null || _formData$blocks6$$se === void 0 ? void 0 : (_formData$blocks6$$se2 = _formData$blocks6$$se[1]) === null || _formData$blocks6$$se2 === void 0 ? void 0 : (_formData$blocks6$$se3 = _formData$blocks6$$se2.rearYard) === null || _formData$blocks6$$se3 === void 0 ? void 0 : _formData$blocks6$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.landUse",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.landUse,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.landUse_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.landUse_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Side 1 Setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[1].sideYard1.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks7 = formData.blocks) === null || _formData$blocks7 === void 0 ? void 0 : (_formData$blocks7$ = _formData$blocks7[0]) === null || _formData$blocks7$ === void 0 ? void 0 : (_formData$blocks7$$se = _formData$blocks7$.setBacks) === null || _formData$blocks7$$se === void 0 ? void 0 : (_formData$blocks7$$se2 = _formData$blocks7$$se[1]) === null || _formData$blocks7$$se2 === void 0 ? void 0 : (_formData$blocks7$$se3 = _formData$blocks7$$se2.sideYard1) === null || _formData$blocks7$$se3 === void 0 ? void 0 : _formData$blocks7$$se3.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.numberOfStoreys",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.numberOfStoreys,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.numberOfStoreys_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.numberOfStoreys_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Side 2 setback"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "blocks.[0].setBacks.[1].sideYard2.minimumDistance",
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$blocks8 = formData.blocks) === null || _formData$blocks8 === void 0 ? void 0 : (_formData$blocks8$ = _formData$blocks8[0]) === null || _formData$blocks8$ === void 0 ? void 0 : (_formData$blocks8$$se = _formData$blocks8$.setBacks) === null || _formData$blocks8$$se === void 0 ? void 0 : (_formData$blocks8$$se2 = _formData$blocks8$$se[1]) === null || _formData$blocks8$$se2 === void 0 ? void 0 : _formData$blocks8$$se2.sideYard2.minimumDistance,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.parkingProvision",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.parkingProvision,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.parkingProvision_remarks",
    placeholder: "Enter Remarks",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.parkingProvision_remarks,
    disabled: !_isEmployee
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Plinth Height"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plinthHeight",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.plinthHeight,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plinthHeight_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.plinthHeight_relaxation,
    disabled: !_isEmployee
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "landInfo.checklistdata.plinthHeight_remarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.plinthHeight_remarks,
    disabled: !_isEmployee
  })))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing PDF"), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, dwgPdfUrl ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(dwgPdfUrl, "_blank")
  }) : dwgPdf ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading)
  }) : /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#d3d3d3",
    style: {
      width: "20px",
      height: "30px"
    }
  })))), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Approval Letter"), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => {
      approvalUrl ? window.open(approvalUrl, "_blank") : getDocumentByFileStoreId(appPdf, setIsPreviewLoading);
    }
  }))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Additional Document"),
    control: control,
    name: "addtionaldocument",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Site Photograph"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: _isEmployee ? t("Uploaded by LTP") : t("Upload site photo"),
    control: control,
    name: "ltpSitePhoto",
    validationMsg: "(.png, .jpg, .jpeg file only and Max file Size 10 MB)",
    required: true,
    tab: 2
  })), _isEmployee ? /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Upload"),
    control: control,
    name: "empSitePhoto",
    validationMsg: "(.png, .jpg, .jpeg file only and Max file Size 10 MB)",
    required: true,
    tab: 2
  })) : /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Remark"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, !_isEmployee ? /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(RemarksEditor, {
    setRemarks: setRemarks,
    remarks: remarks,
    setError: setError,
    error: error
  })) : /*#__PURE__*/React__default.createElement(Row$1, null, "LTP Remark: ", formData === null || formData === void 0 ? void 0 : formData.khasraRemarks))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: _isEmployee ? "Save" : "Forward",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const EmpPlinthPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _Digit, _Digit2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      try {
        data.workflow = {
          action: "NOWORKFLOW",
          assignes: null
        };
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA;
            onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]);
            Modal("Application Updated", `Application Updated Successfully!`, "success");
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (activeTab === 0) {
      return /*#__PURE__*/React__default.createElement(SubStep1$3, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen
      });
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc,
        initialUrl: initialUrl
      }));
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Plinth Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), /*#__PURE__*/React__default.createElement(CollapsibleAdditionalRemarks, {
        formData: params || formData,
        additionalComment: additionalComment,
        setAdditionalComment: setAdditionalComment,
        handleSubmit: () => {
          var _additionalComment$tr;
          console.log("additionalComment12", additionalComment);
          if (((_additionalComment$tr = additionalComment.trim()) === null || _additionalComment$tr === void 0 ? void 0 : _additionalComment$tr.length) === 0) {
            return;
          }
          handleAdditionalComment();
        }
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), ((_formData$drawingDeta, _formData$drawingDeta2, _formData$status) => {
        const lastDrawing = formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : _formData$drawingDeta[(formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta2 = formData.drawingDetail) === null || _formData$drawingDeta2 === void 0 ? void 0 : _formData$drawingDeta2.length) - 1];
        const isDrawingSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfDscEmp) === true || (formData === null || formData === void 0 ? void 0 : formData.IsSanctionDrawing) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfUrl) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfId));
        const isApprovalSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl));
        const isDscStage = (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) || (formData === null || formData === void 0 ? void 0 : formData.status) === "EE_TP_AFTER_PAYMENT" || (formData === null || formData === void 0 ? void 0 : formData.status) === "VC_AFTER_PAYMENT";
        if (!isDscStage || isApprovalSignedByEmp && isDrawingSignedByEmp) {
          return /*#__PURE__*/React__default.createElement(SubmitButton, {
            handleSubmit: handleSubmit,
            isLoading: updateApiCall.isLoading
          });
        } else {
          return /*#__PURE__*/React__default.createElement(NewsTicker, {
            textForNews: "Please make a digital sign on sanction letter and approval letter"
          });
        }
      })());
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const ownerEntry$1 = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE"
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT"
  }
};
const SubStep1$4 = ({
  formData,
  handleSubTabChange,
  setFormData,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  initFormMTDocs,
  userInfo
}) => {
  var _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _watchOffice$split$;
  const {
    documents
  } = useSelector(state => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const [user, setUser] = useState(null);
  const defaultValues = {
    ...formData,
    department: applicationFlow,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry$1]
    },
    documents: documents
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = isDistrictDataLoading ? [] : districtData.map(district => ({
    label: district.name,
    value: district.name,
    name: district.name
  }));
  console.log("upDIstricts", updistricts);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const isDA = applicationFlow === "DA";
  const {
    handleSubmit,
    control,
    reset,
    watch,
    getValues,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const watchState = idx => watch(`landInfo.owners[${idx}].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice);
  const watchSelectedOffice = isDA ? watchOffice === null || watchOffice === void 0 ? void 0 : watchOffice.split(" ")[0] : watchOffice === null || watchOffice === void 0 ? void 0 : (_watchOffice$split$ = watchOffice.split(",")[1]) === null || _watchOffice$split$ === void 0 ? void 0 : _watchOffice$split$.trim();
  const watchUnit = watch("selectedUnit") || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit);
  const watchCity = watch("selectedCity") || (formData === null || formData === void 0 ? void 0 : formData.selectedCity);
  const filterCities = (unit, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C;
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : _masterData$filter$$C.map(item => {
      return {
        name: item.City,
        label: item.City,
        value: item.City
      };
    });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData === null || formData === void 0 ? void 0 : formData.location1);
  }, [formData === null || formData === void 0 ? void 0 : formData.location1]);
  const closeToast = () => {
    setShowToast(null);
  };
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$filter, _response4, _response4$BPA, _response4$BPA$filter, _data, _data2, _data2$landInfo, _data2$landInfo$owner, _data2$landInfo$owner2, _data3, _data3$landInfo, _data3$landInfo$owner, _data3$landInfo$owner2, _data4, _data4$landInfo, _data4$landInfo$owner, _data4$landInfo$owner2, _data5, _data5$landInfo, _data5$landInfo$owner, _data5$landInfo$owner2, _data6, _data6$landInfo, _data6$landInfo$owner, _data6$landInfo$owner2, _data7, _data7$landInfo, _data7$landInfo$owner, _data7$landInfo$owner2, _data8, _data8$landInfo, _data8$landInfo$owner, _data8$landInfo$owner2, _data8$landInfo$owner3, _data9, _data9$landInfo, _data9$landInfo$owner, _data9$landInfo$owner2, _data9$landInfo$owner3, _data10, _data10$landInfo, _data10$landInfo$owne, _data10$landInfo$owne2, _data10$landInfo$owne3, _data11, _data11$landInfo, _data11$landInfo$owne, _data11$landInfo$owne2, _data11$landInfo$owne3, _data12, _data13, _data14, _data15, _data15$landInfo, _data16, _data16$documents;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        purchasableData = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        console.log(data, "datatata");
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            setValue("professionalInformation", {
              consultantCategory: filterCategory(userDetail === null || userDetail === void 0 ? void 0 : userDetail.roles),
              validupto: userDetail === null || userDetail === void 0 ? void 0 : userDetail.pwdExpiryDate,
              name: userDetail === null || userDetail === void 0 ? void 0 : userDetail.name,
              mobileNumber: userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber,
              emailId: userDetail === null || userDetail === void 0 ? void 0 : userDetail.emailId,
              registrationNumber: userDetail === null || userDetail === void 0 ? void 0 : userDetail.registrationNumber,
              registrationArchitectNumber: userDetail === null || userDetail === void 0 ? void 0 : userDetail.registrationArchitectNumber
            });
          }
        }
        Digit.SessionStorage.set("KP_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("selectedOffice", (_data = data) === null || _data === void 0 ? void 0 : _data.selectedOffice);
        setValue("landInfo.owners[0].name", (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$landInfo = _data2.landInfo) === null || _data2$landInfo === void 0 ? void 0 : (_data2$landInfo$owner = _data2$landInfo.owners) === null || _data2$landInfo$owner === void 0 ? void 0 : (_data2$landInfo$owner2 = _data2$landInfo$owner[0]) === null || _data2$landInfo$owner2 === void 0 ? void 0 : _data2$landInfo$owner2.name);
        setValue("landInfo.owners[0].fatherOrHusbandName", (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$landInfo = _data3.landInfo) === null || _data3$landInfo === void 0 ? void 0 : (_data3$landInfo$owner = _data3$landInfo.owners) === null || _data3$landInfo$owner === void 0 ? void 0 : (_data3$landInfo$owner2 = _data3$landInfo$owner[0]) === null || _data3$landInfo$owner2 === void 0 ? void 0 : _data3$landInfo$owner2.fatherOrHusbandName);
        setValue("landInfo.owners[0].gender", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$landInfo = _data4.landInfo) === null || _data4$landInfo === void 0 ? void 0 : (_data4$landInfo$owner = _data4$landInfo.owners) === null || _data4$landInfo$owner === void 0 ? void 0 : (_data4$landInfo$owner2 = _data4$landInfo$owner[0]) === null || _data4$landInfo$owner2 === void 0 ? void 0 : _data4$landInfo$owner2.gender);
        setValue("landInfo.owners[0].mobileNumber", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$landInfo = _data5.landInfo) === null || _data5$landInfo === void 0 ? void 0 : (_data5$landInfo$owner = _data5$landInfo.owners) === null || _data5$landInfo$owner === void 0 ? void 0 : (_data5$landInfo$owner2 = _data5$landInfo$owner[0]) === null || _data5$landInfo$owner2 === void 0 ? void 0 : _data5$landInfo$owner2.mobileNumber);
        setValue("landInfo.owners[0].emailId", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$landInfo = _data6.landInfo) === null || _data6$landInfo === void 0 ? void 0 : (_data6$landInfo$owner = _data6$landInfo.owners) === null || _data6$landInfo$owner === void 0 ? void 0 : (_data6$landInfo$owner2 = _data6$landInfo$owner[0]) === null || _data6$landInfo$owner2 === void 0 ? void 0 : _data6$landInfo$owner2.emailId);
        setValue("landInfo.owners[0].aadhaarNumber", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$landInfo = _data7.landInfo) === null || _data7$landInfo === void 0 ? void 0 : (_data7$landInfo$owner = _data7$landInfo.owners) === null || _data7$landInfo$owner === void 0 ? void 0 : (_data7$landInfo$owner2 = _data7$landInfo$owner[0]) === null || _data7$landInfo$owner2 === void 0 ? void 0 : _data7$landInfo$owner2.aadhaarNumber);
        setValue("landInfo.owners[0].correspondenceAddress.state", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$landInfo = _data8.landInfo) === null || _data8$landInfo === void 0 ? void 0 : (_data8$landInfo$owner = _data8$landInfo.owners) === null || _data8$landInfo$owner === void 0 ? void 0 : (_data8$landInfo$owner2 = _data8$landInfo$owner[0]) === null || _data8$landInfo$owner2 === void 0 ? void 0 : (_data8$landInfo$owner3 = _data8$landInfo$owner2.correspondenceAddress) === null || _data8$landInfo$owner3 === void 0 ? void 0 : _data8$landInfo$owner3.state);
        setValue("landInfo.owners[0].correspondenceAddress.address", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$landInfo = _data9.landInfo) === null || _data9$landInfo === void 0 ? void 0 : (_data9$landInfo$owner = _data9$landInfo.owners) === null || _data9$landInfo$owner === void 0 ? void 0 : (_data9$landInfo$owner2 = _data9$landInfo$owner[0]) === null || _data9$landInfo$owner2 === void 0 ? void 0 : (_data9$landInfo$owner3 = _data9$landInfo$owner2.correspondenceAddress) === null || _data9$landInfo$owner3 === void 0 ? void 0 : _data9$landInfo$owner3.address);
        setValue("landInfo.owners[0].correspondenceAddress.town", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$landInfo = _data10.landInfo) === null || _data10$landInfo === void 0 ? void 0 : (_data10$landInfo$owne = _data10$landInfo.owners) === null || _data10$landInfo$owne === void 0 ? void 0 : (_data10$landInfo$owne2 = _data10$landInfo$owne[0]) === null || _data10$landInfo$owne2 === void 0 ? void 0 : (_data10$landInfo$owne3 = _data10$landInfo$owne2.correspondenceAddress) === null || _data10$landInfo$owne3 === void 0 ? void 0 : _data10$landInfo$owne3.town);
        setValue("landInfo.owners[0].correspondenceAddress.pinno", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$landInfo = _data11.landInfo) === null || _data11$landInfo === void 0 ? void 0 : (_data11$landInfo$owne = _data11$landInfo.owners) === null || _data11$landInfo$owne === void 0 ? void 0 : (_data11$landInfo$owne2 = _data11$landInfo$owne[0]) === null || _data11$landInfo$owne2 === void 0 ? void 0 : (_data11$landInfo$owne3 = _data11$landInfo$owne2.correspondenceAddress) === null || _data11$landInfo$owne3 === void 0 ? void 0 : _data11$landInfo$owne3.pinno);
        setValue("landInfo", (_data12 = data) === null || _data12 === void 0 ? void 0 : _data12.landInfo);
        setValue("descriptionOfLand", (_data13 = data) === null || _data13 === void 0 ? void 0 : _data13.descriptionOfLand);
        setValue("landAreaDetails", (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.landAreaDetails);
        const mappedOwners = (((_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$landInfo = _data15.landInfo) === null || _data15$landInfo === void 0 ? void 0 : _data15$landInfo.owners) || []).map(owner => ({
          ...ownerEntry$1,
          ...owner,
          correspondenceAddress: {
            ...ownerEntry$1.correspondenceAddress,
            ...(owner.correspondenceAddress || {})
          },
          permanentAddress: {
            ...ownerEntry$1.permanentAddress,
            ...(owner.permanentAddress || {})
          }
        }));
        setValue("landInfo.owners", mappedOwners);
        if (((_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$documents = _data16.documents) === null || _data16$documents === void 0 ? void 0 : _data16$documents.length) > 0) {
          var _data17;
          initFormMTDocs((_data17 = data) === null || _data17 === void 0 ? void 0 : _data17.documents);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);
  const onSubmit = data => {
    handleSubTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "FastPAS Id Details")), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority")), isDA ? /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Select Development Authority",
    inputLabel: "Select office",
    placeholder: "Select office",
    name: "selectedOffice",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedOffice,
    data: SortingAlphabatically(officesList),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null))) : /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "searchSelect",
    data: SortingAlphabatically(avpUnits),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || "",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })), watchUnit ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "searchSelect",
    data: SortingAlphabatically(avpCities),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    style: {
      marginTop: "26px"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner/Applicant Details"))), owners === null || owners === void 0 ? void 0 : owners.map((owner, index) => {
    var _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _owner$correspondence;
    return /*#__PURE__*/React__default.createElement(Container, {
      className: "formInputContainer common-app-form",
      fluid: true,
      key: owner.id
    }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Name",
      control: control,
      placeholder: "Enter Name",
      name: `landInfo.owners[${index}].name`,
      type: "textInput",
      maxLength: 30,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Name"),
          message: "Please enter only letters and spaces"
        }
      },
      disabled: true
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Father Name",
      placeholder: "Enter Father Name",
      name: `landInfo.owners[${index}].fatherOrHusbandName`,
      type: "textInput",
      maxLength: 30,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Name"),
          message: "Please enter only letters and spaces"
        }
      },
      disabled: true
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: t("Gender"),
      placeholder: t("Gender"),
      name: `landInfo.owners[0].gender`,
      type: "searchSelect",
      data: SortingAlphabatically(genderData),
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.gender,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "Please select the gender"
        }
      },
      disabled: true
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      name: `landInfo.owners[${index}].mobileNumber`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("MobileNo"),
          message: "Please enter valid mobile no"
        }
      },
      disabled: true,
      maxLength: 10
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "E-mail ID",
      control: control,
      placeholder: "Enter E-mail ID",
      name: `landInfo.owners[${index}].emailId`,
      type: "textInput",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Email"),
          message: "Please enter valid email id"
        }
      },
      disabled: true
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Aadhaar Number",
      control: control,
      placeholder: "Enter Aadhaar Number",
      name: `landInfo.owners[${index}].aadhaarNumber`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("AadharNo"),
          message: "Please enter valid Aadhaar no"
        }
      },
      disabled: true,
      maxLength: 12
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "State",
      placeholder: "Select State",
      defaultValue: (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.state,
      name: `landInfo.owners[${index}].correspondenceAddress.state`,
      type: "selectInput",
      data: statesName,
      mandatory: true,
      disabled: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      data: watchState(index) === "Uttar Pradesh" ? updistricts : undefined,
      label: t("LABEL_DISTRICT"),
      placeholder: watchState(index) === "Uttar Pradesh" ? "Select District" : "Enter District",
      name: `landInfo.owners[${index}].correspondenceAddress.town`,
      type: watchState(index) === "Uttar Pradesh" ? "searchSelect" : "textInput",
      mandatory: true,
      maxLength: 25,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Name"),
          message: "Please enter only letters and spaces"
        }
      },
      disabled: true
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Communication Address",
      placeholder: "Enter Communication Address",
      name: `landInfo.owners[${index}].correspondenceAddress.address`,
      type: "textInput",
      mandatory: true,
      maxLength: 150,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Address"),
          message: "Please enter valid Address"
        }
      },
      disabled: true
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      name: `landInfo.owners[${index}].correspondenceAddress.pinno`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Pincode"),
          message: "Please enter valid Pin Code"
        }
      },
      maxLength: 6,
      disabled: true
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
      className: "custom-upload new-custom-uploader signature-attach-uploader"
    }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(FileUploader$3, {
      control: control,
      name: "signature",
      label: "Attach Signature",
      validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
      isMandatory: true,
      required: true,
      tab: 2,
      maxFiles: 1,
      showError: showError
    }))), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement("br", null));
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  })), /*#__PURE__*/React__default.createElement(ScrollButton, null)))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const SubStep3$3 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionalInformation),
      consultantCategory: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory
    }
  };
  const {
    handleSubmit,
    control
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    data = {
      ...data,
      professionalInformation: {
        ...data.professionalInformation
      }
    };
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Consultant Category",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.consultantCategory) || isEmployee,
    placeholder: "Enter Consultant Category",
    name: "professionalInformation.consultantCategory",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.consultantCategory,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    className: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.consultantCategory) ? "input-disabled" : ""
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    disabled: true,
    placeholder: "Enter Name",
    name: "professionalInformation.name",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isRequired: true,
    type: "textInput",
    mandatory: true,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Validity",
    control: control,
    placeholder: "Validity",
    name: "professionalInformation.validupto",
    type: "textInput",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Mobile No.",
    control: control,
    placeholder: "Enter Mobile No.",
    disabled: true,
    name: "professionalInformation.mobileNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    name: "professionalInformation.registrationArchitectNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    height: "30px"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "License No.",
    control: control,
    name: "professionalInformation.registrationNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail Id",
    control: control,
    disabled: true,
    placeholder: "Enter E-mail Id",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId,
    name: "professionalInformation.emailId",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const SubStep4$3 = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  isEmployee,
  handleNoWorkflow
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34;
  const {
    t
  } = useTranslation();
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.plotAreaSite);
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log(formData, "docissue");
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation,
      schemeType: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "",
      roadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.roadWidths) || [{
        value: ""
      }],
      approachRoadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.approachRoadWidths) || [{
        value: ""
      }],
      otherSides: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.otherSides) || [{
        value: ""
      }],
      multipleKhata: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.multipleKhata) || [{
        value: ""
      }],
      khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.khasraDetails) || [{
        district: "",
        tehsil: "",
        village: "",
        plotNo: ""
      }],
      multipleKhasra: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.multipleKhasra) || [{
        khasraNo: "",
        area: ""
      }]
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const handleCoordinateChange = (field, value) => {
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const {
    fields: multipleKhasra,
    append: addKhasra,
    remove: removeKhasra
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra"
  });
  const {
    fields: roadWidthsArray,
    append: addRoadWidthField,
    remove: removeRoadWidthField
  } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths"
  });
  const {
    fields: otherSides,
    append: addOtherSide,
    remove: removeOtherSide
  } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides"
  });
  const {
    fields: approachRoadWidths,
    append: addApproachRoad,
    remove: removeApproachWidth
  } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths"
  });
  const {
    fields: multipleKhata,
    append: addKhata,
    remove: removeKhata
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata"
  });
  const {
    fields: khasraDetails,
    append: addKhasraDetail,
    remove: removeKhasraDetail
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const isSchemeType = watchSchemeType === "Scheme";
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  console.log("upDIstricts", updistricts);
  const plotNo = watch("descriptionOfLand.plotNo");
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["kmlFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const onSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSubmit", data, isValid);
    if (isEmployee) {
      const datawithdoc = {
        ...data,
        documents: formData === null || formData === void 0 ? void 0 : formData.documents
      };
      console.log(datawithdoc, "datawithdocgoing");
      handleNoWorkflow(datawithdoc);
    }
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    var _formData$description11;
    if (formData !== null && formData !== void 0 && (_formData$description11 = formData.descriptionOfLand) !== null && _formData$description11 !== void 0 && _formData$description11.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
      setValue("landInfo.owners[0].permanentAddress.district", formData === null || formData === void 0 ? void 0 : formData.location1);
    }
    setValue("documents", documents);
    if (formData !== null && formData !== void 0 && formData.location1 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.schemeType,
    disabled: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), isSchemeType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 4px",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      backgroundColor: "#f2f2f2",
      color: "red",
      padding: "4px"
    }
  }, "Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission."))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Type of Scheme",
    placeholder: "Select type of scheme",
    name: `descriptionOfLand.planOn`,
    type: "searchSelect",
    maxLength: 30,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.planOn,
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: "searchSelect",
    maxLength: 30,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.schemeName,
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan",
    inputLabel: "Select a plan.",
    placeholder: isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan",
    name: "descriptionOfLand.landUsesType",
    type: "searchSelect",
    mandatory: true,
    isRequired: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.landUsesType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan",
    control: control,
    placeholder: isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan",
    name: "descriptionOfLand.subLandUseAsPerLayout",
    type: "searchSelect",
    disabled: true,
    mandatory: true,
    maxLength: 150,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.subLandUseAsPerLayout
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "descriptionOfLand.activityAsPerMap",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.activityAsPerMap,
    type: "searchSelect",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Activity Proposed"),
    control: control,
    placeholder: t("Select Activity Proposed"),
    name: "descriptionOfLand.activityProposed",
    type: "searchSelect",
    mandatory: true,
    disabled: true,
    maxLength: 20,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.activityProposed
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.constructionType,
    type: "searchSelect"
  })), /*#__PURE__*/React__default.createElement(Col, null)), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraDetails.map((item, index) => {
    var _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(updistricts),
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: "textInput",
      defaultValue: formData === null || formData === void 0 ? void 0 : formData.location1,
      disabled: true,
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : (_formData$description21 = _formData$description20.khasraDetails) === null || _formData$description21 === void 0 ? void 0 : (_formData$description22 = _formData$description21[index]) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.tehsil,
      type: "searchSelect",
      disabled: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : (_formData$description24 = _formData$description23.khasraDetails) === null || _formData$description24 === void 0 ? void 0 : (_formData$description25 = _formData$description24[index]) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.village,
      type: "searchSelect",
      maxLength: 30,
      disabled: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "specialChar",
      allowedChars: "/,-",
      maxLength: 200,
      disabled: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => removeKhasraDetail(index),
      disabled: true
    }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === khasraDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => addKhasraDetail({
        plotNo: "",
        district: "",
        tehsil: "",
        village: ""
      }),
      disabled: true
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  }))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(updistricts),
    label: t("LABEL_DISTRICT"),
    placeholder: "Select District",
    name: "landInfo.owners[0].permanentAddress.district",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.location1,
    disabled: true,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    name: "descriptionOfLand.plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    name: "descriptionOfLand.landArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    maxValue: maxPlotAreaSite,
    disabled: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, roadWidthsArray.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: `descriptionOfLand.roadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: roadWidthsArray.length >= 4,
    onClick: () => addRoadWidthField({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), roadWidthsArray.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeRoadWidthField(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))), /*#__PURE__*/React__default.createElement(Col, null, approachRoadWidths.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)",
    placeholder: isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)",
    name: `descriptionOfLand.approachRoadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    sx: {
      Padding: "0px"
    },
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: approachRoadWidths.length >= 4,
    onClick: () => addApproachRoad({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), approachRoadWidths.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeApproachWidth(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("latitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("longitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    disabled: true,
    maxLength: 30000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "descriptionOfLand.proposedGoundCoverageSqM",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.proposedGoundCoverageSqM,
    type: "textInput",
    mandatory: isEmployee,
    disabled: !isEmployee,
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    width: "100%",
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    disabled: !isEmployee,
    name: "descriptionOfLand.maximumCoverage",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.maximumCoverage,
    type: "textInput",
    mandatory: isEmployee,
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    width: "100%",
    control: control,
    placeholder: t("Enter Front"),
    name: "descriptionOfLand.plotFront",
    disabled: !isEmployee,
    mandatory: isEmployee,
    maxLength: 2,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.plotFront,
    type: "textInput",
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "descriptionOfLand.plotRear",
    disabled: !isEmployee,
    mandatory: isEmployee,
    maxLength: 2,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.plotRear,
    type: "textInput",
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "descriptionOfLand.plotSide1",
    disabled: !isEmployee,
    mandatory: isEmployee,
    maxLength: 2,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.plotSide1,
    type: "textInput",
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "descriptionOfLand.plotSide2",
    mandatory: isEmployee,
    maxLength: 2,
    disabled: !isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.plotSide2,
    type: "textInput",
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: t("Permissible Height"),
    placeholder: t("Enter Building Height"),
    name: "descriptionOfLand.landLength",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.landLength,
    type: "textInput",
    disabled: !isEmployee,
    mandatory: isEmployee,
    validation: {
      required: {
        value: isEmployee,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, !isEmployee && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const EmpKYPPortal = ({
  formData,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _Digit, _Digit2;
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("KYP_CURRENT_TAB")) || 0);
  const [subActiveTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("KYP_CURRENT_SUBTAB")) || 0);
  const [initialDeveloperRemarks, setInitialDeveloperRemarks] = useState("");
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED";
  const subTabLabels = [{
    label: "Applicant Information"
  }, {
    label: "LTP Information"
  }, {
    label: "Plot Details"
  }];
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    handleNoWorkflowWithData,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    callDocumentDetailsAPI,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);
  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("KYP_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("KYP_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$4, {
            formData: formData,
            isEmployee: !isCitizen,
            handleSubTabChange: handleSubTabChange,
            applicationFlow: department,
            isApproved: true
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$3, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$3, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true,
            handleNoWorkflow: handleNoWorkflowWithData
          });
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      switch (subActiveDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "mandatory",
            formType: "LANDUSE",
            developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            setError: setError,
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: siteInspRecommendation,
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument,
              error: error,
              setError: setError
            }, props))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DocumentSectionLog, {
            logData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
      }
    } else if (activeTab === 1 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "view-doc-container"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        className: "view-doc-btn",
        onClick: handleDocView,
        style: {
          backgroundColor: "#157C4F",
          borderRadius: "15px",
          padding: "5px 10px"
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "view-doc-icon"
      }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc
      }));
    } else if (activeTab === 2 && isCitizen) {
      var _actions$, _actions$2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Architect, {
        formData: formData,
        applicationDocs: applicationDocs,
        actions: actions,
        avpLogo: avpLogo,
        daLogo: daLogo
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "MAKE_PAYMENT" && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 8"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangePayment
      }, "Payment")))), (actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action) === "FORWARD_TO_DEPARTMENT" && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 6"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 4"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangeForward
      }, "Forward To Department")))));
    } else if (activeTab === 2 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleChange,
        serviceName: "Know Your Property",
        avpLogo: avpLogo,
        daLogo: daLogo
      }), !isApproved && /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData
      }), (formData === null || formData === void 0 ? void 0 : formData.status) === "APPLY_FOR_DSC" && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "LA"
      }), !isApproved && /*#__PURE__*/React__default.createElement(ActionButtons, {
        actions: actions,
        currentAction: currentAction,
        onSelect: onRadioActionSelect
      }), !isApproved && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), !isApproved && /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), !isApproved && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 3 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (activeTab === 3 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(MainWrapper, {
    className: "main-panel-corner land-use-corner"
  }, !isCitizen && /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Application Data"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Document Section"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "All Remarks"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels === null || subTabLabels === void 0 ? void 0 : subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && !isCitizen && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, landUseSubTabDDocSecLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent())));
};

const useSelfMapCheck = ({
  tenantId,
  id
}) => {
  var _createCheckQuery$dat;
  const isCreateMode = !id;
  const createCheckQuery = useQuery(["bpa-self-map-check", tenantId], () => Digit.OBPSService.BPASearch(tenantId), {
    enabled: !!tenantId && isCreateMode,
    refetchOnMount: "always",
    staleTime: 0,
    cacheTime: 0,
    select: data => {
      var _data$BPA, _data$BPA$filter;
      const selfMapCount = (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : (_data$BPA$filter = _data$BPA.filter(app => app.planOn === "SELF_MAP")) === null || _data$BPA$filter === void 0 ? void 0 : _data$BPA$filter.length) || 0;
      return {
        selfMapExists: selfMapCount > 0
      };
    }
  });
  return {
    isCreateMode,
    isLoading: createCheckQuery.isLoading,
    selfMapExists: (_createCheckQuery$dat = createCheckQuery.data) === null || _createCheckQuery$dat === void 0 ? void 0 : _createCheckQuery$dat.selfMapExists
  };
};

const Step1$1 = ({
  formData,
  userInfo,
  handleTabChange,
  id,
  officesList,
  villagesData,
  departmentList,
  isEmployee,
  applicationFlow,
  avpUnits,
  avpData
}) => {
  var _formData$description, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$description2, _formData$description3, _formData$description4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [areaerror, setAreaError] = useState(false);
  const [widtherror, setWidthError] = useState(false);
  const [isFormDisabled, setIsFormDiabled] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [isNetAreaTouched, setIsNetAreaTouched] = useState(false);
  const history = useHistory();
  const isDa = applicationFlow === "DA";
  const defaultValues = {
    ...formData
  };
  console.log("formData", formData, defaultValues);
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    setError,
    clearErrors
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const {
    isCreateMode,
    isLoading,
    selfMapExists
  } = useSelfMapCheck({
    tenantId,
    id
  });
  console.log(isCreateMode, isLoading, selfMapExists, isEmployee, "selfMapExistsChecking", userInfo);
  const filterTehsilData = (masterData, authority) => {
    var _masterData$find, _masterData$find$tehs;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$tehs = _masterData$find.tehsils) === null || _masterData$find$tehs === void 0 ? void 0 : _masterData$find$tehs.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, tehsil) => {
    var _masterData$find2, _masterData$find2$teh, _masterData$find2$teh2, _masterData$find2$teh3;
    console.log("villagesFilteredData", authority, tehsil);
    const result = tehsil ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : (_masterData$find2$teh2 = _masterData$find2$teh.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find2$teh2 === void 0 ? void 0 : (_masterData$find2$teh3 = _masterData$find2$teh2.villages) === null || _masterData$find2$teh3 === void 0 ? void 0 : _masterData$find2$teh3.map(item => ({
      name: item,
      label: item,
      value: item
    })) : null;
    return result || [];
  };
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData === null || masterData === void 0 ? void 0 : masterData.filter(item => item.Name === department).map(item => item.ColonyGroups).flat().filter(item => item.ColonyType === planOn).map(item => item.Colonies).flat().map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("schemeFilteredData", schemeNameList);
    return schemeNameList;
  };
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  }));
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const [watchPlanOn, watchPlotDetail, watchZoneType, watchOffice, watchUnit, watchDistrict, watchTehsil, watchPermissionType, watchContainFAR, watchSchemeType, watchDevelopmentArea, watchplotSubdivided, watchplotinColonies, watchSelectedCity] = watch(["proposalType", "plotNo", "zoneType", "selectedOffice", "selectedUnit", "district", "tehsil", "permissionType", "containFAR", "descriptionOfLand.schemeType", "developmentArea", "plotSubdivided", "plotinColonies", "selectedCity"]);
  const [maxLength, setMaxLength] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const tehsils = filterTehsilData(villagesData, watchOffice ? watchOffice : "Lucknow Development Authority");
  const villages = filterVillagesData(villagesData, watchOffice ? watchOffice : "Lucknow Development Authority", watchTehsil);
  const schemeNames = filterSchemeNames(departmentList, watchOffice, watchPlanOn);
  console.log("schemesName", schemeNames, watchSelectedCity);
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: newVillagesData
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${watchOffice}")]`
  }]);
  const {
    data: {
      BPA: {
        LandUseAvpVillageMasterData: avpVillagesData
      } = {}
    } = {},
    isDistrictLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseAvpVillageMasterData",
    filter: `$..Districts[?(@.District=='${watchSelectedCity}')]`
  }]);
  console.log("MAINDATAASAS", newVillagesData, avpVillagesData);
  useEffect(() => {
    setValue("landInfo.owners.[0].correspondenceAddress.type", "CORRESPONDENCE");
    setValue("landInfo.owners.[0].mobileNumber", userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber);
  }, []);
  useEffect(() => {
    const office = watchOffice === null || watchOffice === void 0 ? void 0 : watchOffice.split(" ")[0];
    if (isDa) {
      setValue("selectedCity", office);
      setValue("department", "DA");
    } else {
      setValue("department", "AVP");
    }
    setValue("landInfo.address.city", office);
    setValue("landInfo.address.locality.code", office);
  }, [watchOffice]);
  useEffect(() => {
    if (formData !== null && formData !== void 0 && formData.district) {
      setValue("district", formData === null || formData === void 0 ? void 0 : formData.district);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.district]);
  useEffect(() => {
    if (watchPlotDetail === "Khasra No." || watchPlotDetail === "Araji No.") {
      setValue("proposalType", "Others");
    }
  }, [watchPlotDetail]);
  const watchplotinMelaArea = watch("plotinMelaArea");
  const isScheme = watchSchemeType === "Scheme";
  const filterCities = (unit, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C;
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : _masterData$filter$$C.map(item => {
      return {
        name: item.City,
        label: item.City,
        value: item.City
      };
    });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find3, _masterData$find3$Dis;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : _masterData$find3$Dis.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const filterAvpDistrictData = (masterData, city) => {
    console.log("avpdistrictTriggered", city);
    const district = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.District === city);
    if (!district) return [];
    console.log("districtfromavp", [{
      name: district.District,
      label: district.District,
      value: district.District
    }]);
    return [{
      name: district.District,
      label: district.District,
      value: district.District
    }];
  };
  const onSubmit = data => {
    if (!id && selfMapExists) {
      setShowToast({
        key: "true",
        error: true,
        message: "File already submitted through this Number."
      });
      return;
    }
    if (parseFloat(data.plotArea) > maxLength) {
      setError("plotArea", {
        type: "manual",
        message: `Plot Area should not exceed ${maxLength} sqmt.`
      });
      return;
    }
    handleTabChange(1, data);
  };
  const primaryUse = watch("primaryUse");
  useEffect(() => {
    if (primaryUse === "Residential") {
      setValue("activityProposed", "Row House-Single unit");
      setMaxLength(100);
    } else if (primaryUse === "Commercial") {
      setValue("activityProposed", "Retail Shop");
      setMaxLength(30);
    }
  }, [primaryUse, setValue]);
  const plotArea = watch("plotArea");
  const netPlotArea = watch("totalProposedArea");
  const roadWidth = watch("descriptionOfLand.landLength");
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Built-up area") {
      setMaxWidth(4);
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      setMaxWidth(9);
    }
  }, [watchSchemeType, watchDevelopmentArea]);
  useEffect(() => {
    const value = parseFloat(plotArea);
    const row = parseFloat(roadWidth);
    if (plotArea && maxLength) {
      if (value > maxLength) {
        setError("plotArea", {
          type: "manual",
          message: `Plot Area should not exceed ${maxLength} sqmt.`
        });
        setOpen(true);
        setAreaError(true);
        setIsFormDiabled(true);
        return;
      } else {
        setAreaError(false);
        setIsFormDiabled(false);
        setOpen(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Retail Shop") {
      if (value < 10) {
        setError("plotArea", {
          type: "manual",
          message: `The minimum required plot area is ${10.0} sqmt.`
        });
        setIsFormDiabled(true);
        return;
      } else {
        clearErrors("plotArea");
        setIsFormDiabled(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      if (value < 35) {
        setError("plotArea", {
          type: "manual",
          message: `The minimum required plot area is ${35.0} sqmt.`
        });
        setIsFormDiabled(true);
        return;
      } else {
        clearErrors("plotArea");
        setIsFormDiabled(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Built-up area") {
      if (row < 4) {
        setError("descriptionOfLand.landLength", {
          type: "manual",
          message: `The minimum required road width is ${4.0} sqmt.`
        });
        setIsFormDiabled(true);
        setWidthError(true);
        setOpen(true);
        return;
      } else {
        clearErrors("descriptionOfLand.landLength");
        setIsFormDiabled(false);
        setOpen(false);
        setWidthError(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      if (row < 9) {
        setError("descriptionOfLand.landLength", {
          type: "manual",
          message: `The minimum required road width is ${9.0} sqmt.`
        });
        setWidthError(true);
        setIsFormDiabled(true);
        setOpen(true);
        return;
      } else {
        clearErrors("descriptionOfLand.landLength");
        setIsFormDiabled(false);
        setOpen(false);
        setWidthError(false);
      }
    }
    if (watchplotinMelaArea === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchplotSubdivided === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchplotinColonies === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchContainFAR === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchZoneType === "Any Others") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    } else {
      clearErrors("plotArea");
      setIsFormDiabled(false);
    }
  }, [plotArea, maxLength, watchplotinMelaArea, watchContainFAR, watchplotSubdivided, watchplotinColonies, watchZoneType, roadWidth, setError, clearErrors]);
  useEffect(() => {
    if (watchSchemeType === "Non Scheme") {
      setValue("layoutsanctionDate", null);
      setValue("layoutsanctionNumber", null);
      setValue("schemeName", null);
      setValue("proposalType", null);
    } else {
      setValue("descriptionOfLand.landLength", null);
      setValue("descriptionOfLand.landMark", null);
      setValue("descriptionOfLand.landAddress", null);
    }
  }, [watchSchemeType]);
  console.log(formData, "formDataaaa");
  useEffect(() => {
    if (!isNetAreaTouched) {
      setValue("totalProposedArea", plotArea, {
        shouldValidate: false,
        shouldDirty: false
      });
    }
  }, [plotArea, isNetAreaTouched]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading common-header-sec"
  }, "Low-Risk Category")), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, !isDa && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "searchSelect",
    data: SortingAlphabatically(avpUnits),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || "",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), watchUnit ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "searchSelect",
    data: SortingAlphabatically(avpCities),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Name of Authority",
    name: "selectedOffice",
    type: "selectInput",
    placeholder: "Select Development Authority",
    mandatory: true,
    data: SortingAlphabatically(officesList),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedOffice,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    data: SortingAlphabatically(schemeTypeList),
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Is your plot in the mela area declared under the Uttar Pradesh Melas Act, 1938 ?",
    name: "plotinMelaArea",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotinMelaArea,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    sx: {
      height: "50px"
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Has your plot been subdivided?",
    name: "plotSubdivided",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Is your plot in unauthorized layouts/ colonies ?",
    name: "plotinColonies",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotinColonies,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Name of Owner",
    placeholder: "Enter Name",
    name: "landInfo.owners.[0].name",
    type: "textInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    onlyAlphabet: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[A-Za-z\s]+$/,
        message: "Only alphabets are allowed"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Son/Wife/Daughter of",
    placeholder: "Care Of",
    name: "landInfo.owners.[0].fatherOrHusbandName",
    type: "textInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    onlyAlphabet: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.fatherOrHusbandName,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[A-Za-z\s]+$/,
        message: "Only alphabets are allowed"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Address for Correspondence",
    placeholder: "Enter Address",
    name: "landInfo.owners.[0].correspondenceAddress.address",
    type: "textInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.correspondenceAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.address,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    disabled: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Aadhaar Number",
    control: control,
    placeholder: "Enter Aadhaar Number",
    name: "landInfo.owners.[0].aadhaarNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.aadhaarNumber,
    type: "textInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(permissionTypeList),
    label: t("Type of Permission"),
    placeholder: t("Select Type of Permission"),
    name: "permissionType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.permissionType,
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: isScheme ? t(`Land Use as per Layout Plan`) : t("Land Use as per Master Plan"),
    placeholder: t("Select Type of Land Use"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    disabled: isEmployee,
    data: [{
      code: "Residential",
      name: "Residential"
    }, {
      code: "Commercial",
      name: "Commercial"
    }, {
      code: "Any Others",
      name: "Any Others"
    }],
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: watchZoneType === "Residential" ? SortingAlphabatically(subUsesTypeList) : subUseCommercialList,
    label: isScheme ? t("Land Sub Use as per Layout Plan") : t("Land Sub Use as per Master Plan"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.subZoneType,
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    data: [{
      code: "Residential",
      name: "Residential"
    }, {
      code: "Commercial",
      name: "Commercial"
    }],
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Proposed Activity"),
    placeholder: t("Select Type of proposed activity"),
    name: "activityProposed",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || "Row Houses",
    type: "textInput",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Development Area"),
    placeholder: t("Select Development Area"),
    name: "developmentArea",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.developmentArea,
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    maxLength: maxLength,
    data: developmentAreaOption,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Does proposal contain Purchasable FAR?",
    name: "containFAR",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.containFAR,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Plot Area (sqmt.)"),
    placeholder: t("Enter Plot Area"),
    name: "plotArea",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotArea,
    type: "specialChar",
    allowedChars: ".",
    decimalScale: 2,
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee,
    maxLength: maxLength,
    onBlur: e => {
      const value = parseFloat(e.target.value);
      if (maxLength && value > parseFloat(maxLength)) {
        alert(`Plot Area should not exceed ${maxLength} sqmt.`);
      }
    },
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("PlotArea"),
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: isScheme ? "Plot No." : "Plot No./Khasra No.",
    placeholder: isScheme ? t("Enter Plot No.") : t("Plot No./Khasra No."),
    name: "plotNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "specialChar",
    allowedChars: "/,-&",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "Please Enter Plot No."
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Builtup Area (sqmt.)"),
    placeholder: t("Enter built up area"),
    name: "totalBuildUpArea",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea,
    type: "specialChar",
    decimalScale: 2,
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("PlotArea"),
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Net Plot Area (sqmt.)"),
    placeholder: t("Enter net plot area"),
    name: "totalProposedArea",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.totalProposedArea,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    decimalScale: 2,
    mandatory: true,
    disabled: isEmployee,
    onChange: () => setIsNetAreaTouched(true),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("PlotArea"),
        message: "Please enter valid area"
      },
      validate: value => {
        const netArea = parseFloat(value);
        const plot = parseFloat(plotArea);
        if (!plot || isNaN(netArea)) return true;
        return netArea <= plot || "Net Plot Area should be equal to or less than Plot Area";
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(isDa ? filterDistrictData(newVillagesData, watchOffice) : filterAvpDistrictData(avpVillagesData, watchSelectedCity)),
    label: t("District"),
    placeholder: t("Select District"),
    name: `district`,
    type: "selectInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, isScheme ? /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(proposedSite),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposalType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    maxLength: 30000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, isScheme && (schemeNames === null || schemeNames === void 0 ? void 0 : schemeNames.length) > 1 ? /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: "schemeName",
    type: "selectInput",
    mandatory: true,
    disabled: isFormDisabled || isEmployee,
    data: SortingAlphabatically(schemeNames) || SortingAlphabatically(schemeNameList),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: isFormDisabled || isEmployee,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), !isScheme ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Access road width (RoW)",
    control: control,
    placeholder: "Enter road width",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.landLength,
    name: "descriptionOfLand.landLength",
    type: "textInput",
    mandatory: true,
    required: true,
    disabled: isEmployee,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("NonZeroAmount"),
        message: "Please enter valid width"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), isScheme && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput",
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Select Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disableFuture: true,
    disabled: isEmployee
  })))), /*#__PURE__*/React__default.createElement(Modal$1, {
    open: open,
    onClose: () => {},
    closeAfterTransition: true,
    slots: {
      backdrop: Backdrop
    },
    slotProps: {
      backdrop: {
        timeout: 500
      }
    }
  }, /*#__PURE__*/React__default.createElement(Fade, {
    in: open
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 450,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      outline: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    id: "modal-modal-title",
    variant: "h6",
    fontWeight: "bold",
    gutterBottom: true,
    sx: {
      textAlign: "center"
    }
  }, "Not Permitted"), watchContainFAR === "yes" && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      mt: 2
    }
  }, "Purchasable FAR is not allowed through Self-certification via registration.", /*#__PURE__*/React__default.createElement("br", null), "Kindly submit your application using the normal Map Submission process."), (watchZoneType === "Any Others" || watchplotinMelaArea === "yes" || watchplotinColonies === "yes" || watchplotSubdivided === "yes") && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      mt: 2
    }
  }, "Please submit your proposal through normal Map Submission process."), areaerror && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      mt: 2
    }
  }, "Plot area more than ", primaryUse === "Residential" ? 100 : 30, " sqmt. is not permitted for Self-certification via registration.", /*#__PURE__*/React__default.createElement("br", null), "Kindly submit your application using the normal Map Submission process."), widtherror && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      mt: 2
    }
  }, "Road width less than ", watchDevelopmentArea === "Built-up area" ? 4 : 9, " mtr. is not permitted for Self-certification via registration.", /*#__PURE__*/React__default.createElement("br", null), "Kindly submit your application using the normal Map Submission process."), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 4,
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 24px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "500",
      transition: "background-color 0.3s ease"
    },
    onMouseOver: e => {
      e.target.style.backgroundColor = "rgb(15, 104, 155)";
    },
    onMouseOut: e => {
      e.target.style.backgroundColor = "rgb(21, 124, 179)";
    }
  }, "OK"))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    disabled: !declarationChecked && isFormDisabled,
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast.key,
    label: t(showToast.message),
    onClose: () => setShowToast(null),
    isDleteBtn: true
  }));
};

const Step3$3 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const [exceedHeight, setExceedHt] = useState(false);
  const [zeroHeightError, setZeroHeightError] = useState(false);
  const [open, setOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    setError
  } = useForm({
    defaultValues
  });
  const buildingHeight = watch("planheightOfBuilding");
  const [watchPlanLocation, watchPlandimensionOfPlot, watchPlanfloorPlans, watchFloors] = watch(["planlocationOfPlot", "plandimensionOfPlot", "planfloorPlans", "containMoreThanThree"]);
  useEffect(() => {
    if (buildingHeight === "0" || buildingHeight === "0.00") {
      setZeroHeightError(true);
      setOpen(true);
      setValidationMessage("0.00 is not allowed");
      return;
    } else {
      setZeroHeightError(false);
    }
    if (buildingHeight > 15) {
      setExceedHt(true);
      setOpen(true);
      setValidationMessage("Building height should not exceed 15m.");
    } else {
      setExceedHt(false);
    }
  }, [buildingHeight]);
  useEffect(() => {
    const hasNoSelection = watchPlanLocation === "no" || watchPlandimensionOfPlot === "no" || watchPlanfloorPlans === "no";
    const hasFloors = watchFloors === "yes";
    if (hasNoSelection) {
      setOpen(true);
      setValidationMessage("Please show it in the attached Plan");
    }
    if (hasFloors) {
      setOpen(true);
      setValidationMessage("Please submit your proposal through normal Map Submission process");
    }
  }, [watchPlanLocation, watchPlandimensionOfPlot, watchPlanfloorPlans, watchFloors]);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(2, data);
  };
  const shouldDisableField = fieldName => {
    if (exceedHeight) {
      return fieldName !== "planheightOfBuilding";
    }
    if (watchPlanLocation === "no") {
      return !["planlocationOfPlot"].includes(fieldName);
    } else if (watchPlandimensionOfPlot === "no") {
      return !["plandimensionOfPlot"].includes(fieldName);
    } else if (watchPlanfloorPlans === "no") {
      return !["planfloorPlans"].includes(fieldName);
    } else if (watchFloors === "yes") {
      return !["containMoreThanThree"].includes(fieldName);
    }
    return false;
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Map")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading",
    style: {
      fontWeight: "bold",
      marginBottom: "13px"
    }
  }, t("Does the attached Plan show?")), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Location of plot along with existing roads and their width ",
    name: "planlocationOfPlot",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    disabled: shouldDisableField("planlocationOfPlot") || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planlocationOfPlot,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Dimensions of plot/premises along with setback",
    name: "plandimensionOfPlot",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    disabled: shouldDisableField("plandimensionOfPlot") || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plandimensionOfPlot,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Include floor plans of all floors together with the covered area clearly indicating sizes of rooms and the position and width of staircases and other exits",
    name: "planfloorPlans",
    type: "radioButton",
    mandatory: true,
    height: 55,
    disabled: shouldDisableField("planfloorPlans") || isEmployee,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planfloorPlans,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Is your proposal contain more than 3 floors? ",
    name: "containMoreThanThree",
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    disabled: shouldDisableField("containMoreThanThree") || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plandimensionOfPlot,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading",
    style: {
      fontWeight: "bold",
      marginTop: "10px"
    }
  }, "Parking Details & Building Height:"), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Height of Building (mtr)",
    name: "planheightOfBuilding",
    type: "textInput",
    mandatory: true,
    disabled: shouldDisableField("planheightOfBuilding") || isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding,
    placeholder: "Enter Height of Building",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      min: {
        value: 0.01,
        message: "Height must be greater than 0"
      },
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Only up to 2 decimal places allowed"
      }
    }
  }))), (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 50 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Area of parking spaces provided (If plot size is more than 50 sqm) (in sqm)",
    name: "plansParkingSpace",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plansParkingSpace,
    placeholder: "Enter Parking Space",
    disabled: shouldDisableField("plansParkingSpace") || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Modal$1, {
    open: open,
    onClose: () => {},
    closeAfterTransition: true,
    "aria-labelledby": "modal-modal-title",
    "aria-describedby": "modal-modal-description"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      outline: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    id: "modal-modal-title",
    variant: "h6",
    component: "h2",
    fontWeight: "bold",
    sx: {
      textAlign: "center"
    }
  }, "Not Permitted"), /*#__PURE__*/React__default.createElement(Typography, {
    id: "modal-modal-description",
    sx: {
      mt: 2
    }
  }, validationMessage), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 4,
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px 24px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "500",
      transition: "background-color 0.3s ease"
    },
    onMouseOver: e => {
      e.target.style.backgroundColor = "rgb(15, 104, 155)";
    },
    onMouseOut: e => {
      e.target.style.backgroundColor = "rgb(21, 124, 179)";
    }
  }, "OK")))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    disabled: exceedHeight || zeroHeightError,
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const EmpSelfRegistration = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _Digit, _Digit2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("SELF_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("SELF_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const {
    currentAction,
    Modal,
    actions,
    handleSubmit,
    error,
    setError,
    isCitizen,
    updateApiCall,
    t,
    remarks,
    setRemarks,
    documentSection,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    callNotingDetailsAPI,
    uploadedFile,
    setUploadedFile,
    notingRemarksData,
    onDropDownSelect,
    mapSubmissionAction,
    params,
    onSelect
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      try {
        data.workflow = {
          action: "NOWORKFLOW",
          assignes: null
        };
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA;
            onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]);
            Modal("Application Updated", `Application Updated Successfully!`, "success");
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTabNo);
  };
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (activeTab === 0) {
      return /*#__PURE__*/React__default.createElement(Step1$1, {
        formData: formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen
      });
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step3$3, {
        formData: formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc,
        initialUrl: initialUrl
      }));
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Details of Map"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const SubStep1$5 = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  onSelect,
  initFormMTDocs,
  isEmployee,
  standardDesigns
}) => {
  var _data$MapSubmission, _data$MapSubmission$D, _formData$description, _formData$plotNumbers, _formData$description2, _formData$description3, _fastPASData$descript2, _Object$keys, _fastPASData$descript3, _Digit$UserService$ge, _Digit$UserService$ge2;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1", standardDesigns);
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const prevFileData = Digit.SessionStorage.get("PREV_FILE_DATA");
  const defaultValues = {
    ...(formData || prevFileData),
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
    planOn: "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm",
    department: formData === null || formData === void 0 ? void 0 : formData.department
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  }));
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState((formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" || false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [saveStatus, setSaveStatus] = useState({
    open: false,
    message: "",
    severity: "error"
  });
  const [watchProposalType, watchisSpecialProject, watchspcialProjectType, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchPrevFileNo, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchProposal, watchPlotArea, watchPlotNo, watchContainFar] = watch(["proposalType", "isSpecialProject", "specialProjectType", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "prevFileNo", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "proposal", "descriptionOfLand.schemeType", "plotNo", "containFAR"]);
  const Modal = useModal();
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const [showDesigns, setShowDesigns] = useState(false);
  const [plottedArea, setPlottedArea] = useState("");
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs.map(plot => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears
      });
    }
  }, [formData]);
  useEffect(() => {
    setValue("planOn", "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm");
  }, []);
  const columns = [{
    id: "srNo",
    label: "Sr No"
  }, {
    id: "area",
    label: "Area (sqm)"
  }, {
    id: "dimension",
    label: "Dimension"
  }, {
    id: "type",
    label: "Type/Design"
  }, {
    id: "construction",
    label: "Construction (GF/FF/SF)"
  }];
  const tableData = standardDesigns === null || standardDesigns === void 0 ? void 0 : standardDesigns.map((item, idx) => ({
    code: item.code ? item.code : "",
    srNo: idx + 1,
    area: item.areaSqm ? item.areaSqm : "-",
    dimension: item.dimension ? item.dimension : "-",
    type: item.typeDesign ? item.typeDesign : "-",
    construction: item.construction ? `GF: ${item.construction.GF}, FF: ${item.construction.FF}, SF: ${item.construction.SF}` : "-"
  }));
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const retainedVlalues = {
      natureofConstruction: watchnatureOfConstruction,
      prevFileNo: watchPrevFileNo
    };
    Digit.SessionStorage.set("RETAINED_VALUES", retainedVlalues);
  }, [watchnatureOfConstruction, watchPrevFileNo]);
  useEffect(() => {
    const riskType = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? "Building Plan Low Risk, Self Certification Mode" : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") && watchAtivityProposed !== "Row Houses" && watchAtivityProposed !== "Semi Detached" && watchAtivityProposed !== "Detached" ? "High Risk and High Nivesh" : watchlandUseType === "Commercial" ? "High Risk and High Nivesh" : watchPlanOn !== "Others" ? "Building Plan-Low Risk" : "Others";
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    if (watchContainFar === "yes") {
      setShowToast({
        key: "true",
        error: true,
        message: `Purchasable FAR is not allowed through Self-Approval via LTP. Kindly submit your application using the alternative map submission process`
      });
    }
  }, [watchContainFar]);
  const selectedDesigns = watch("selectedDesigns") || [];
  console.log("PLOT AREA", plottedArea, watchPrimaryUse);
  useEffect(() => {
    Digit.SessionStorage.set("CHECKED_DESIGN", selectedDesigns);
  }, [JSON.stringify(selectedDesigns)]);
  const [checkedDesigns, setCheckedDesigns] = useState([]);
  useEffect(() => {
    const stored = Digit.SessionStorage.get("CHECKED_DESIGN");
    setCheckedDesigns(stored || {});
  }, [showDesigns, JSON.stringify(selectedDesigns)]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$, _response4, _response4$BPA, _response4$BPA$filter, _data, _response5, _response5$BPA, _response5$BPA$filter, _data10, _data11, _data11$descriptionOf, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _data15, _data15$descriptionOf, _data15$descriptionOf2, _data16, _data16$descriptionOf, _data17, _data17$descriptionOf, _data18, _data19, _data19$descriptionOf, _data20, _data20$descriptionOf, _data21, _data21$descriptionOf, _data22, _data22$descriptionOf, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data25$landInfo, _data25$landInfo$owne, _data25$landInfo$owne2, _data25$landInfo$owne3, _data26, _data26$descriptionOf, _data27, _data27$descriptionOf, _data28, _data28$descriptionOf, _data29, _data29$descriptionOf, _data30;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow && ((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$ = _response3$BPA[0]) === null || _response3$BPA$ === void 0 ? void 0 : _response3$BPA$.department) !== (formData === null || formData === void 0 ? void 0 : formData.department)) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        const isGovernmentBuilding = (_data = data) === null || _data === void 0 ? void 0 : _data.isGovernmentBuilding;
        purchasableData = (_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$BPA = _response5.BPA) === null || _response5$BPA === void 0 ? void 0 : (_response5$BPA$filter = _response5$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response5$BPA$filter === void 0 ? void 0 : _response5$BPA$filter[0];
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data2, _data2$additionalDeta, _data3, _data3$additionalDeta, _data3$additionalDeta2, _data4, _data4$landInfo, _data4$landInfo$owner, _data4$landInfo$owner2;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if ((_data2 = data) !== null && _data2 !== void 0 && (_data2$additionalDeta = _data2.additionalDetails) !== null && _data2$additionalDeta !== void 0 && _data2$additionalDeta.oldCaseApplicationNo) {
              Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
              return;
            }
            if (((_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$additionalDeta = _data3.additionalDetails) === null || _data3$additionalDeta === void 0 ? void 0 : (_data3$additionalDeta2 = _data3$additionalDeta.professionalInformation) === null || _data3$additionalDeta2 === void 0 ? void 0 : _data3$additionalDeta2.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              Modal("Declaration", `
    <p style="font-size:14px; text-align:left;">If the proposal contains any of the following:</p>
    <ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
      <li style="margin-bottom:6px;">Purchasable FAR</li>
      <li style="margin-bottom:6px;">Plot sub-division without permission</li>
      <li style="margin-bottom:6px;">Existing building requiring compounding</li>
    </ul>
    <p style="font-size:14px; text-align:left;">You are instructed to kindly proceed through the normal map submission process.</p>
    <br/>
    <p style="font-size:13px;"><strong>Note:</strong> If the applicant submits a map that does not comply with the above conditions, 
    the proposal will be deemed rejected and the payment done against this map will be forfeited</p>
  `, "warning", null, null, "I Declare");
            } else if ((userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber) === ((_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$landInfo = _data4.landInfo) === null || _data4$landInfo === void 0 ? void 0 : (_data4$landInfo$owner = _data4$landInfo.owners) === null || _data4$landInfo$owner === void 0 ? void 0 : (_data4$landInfo$owner2 = _data4$landInfo$owner[0]) === null || _data4$landInfo$owner2 === void 0 ? void 0 : _data4$landInfo$owner2.mobileNumber)) {
              setShowToast({
                key: "true",
                error: true,
                message: `Owner's mobile number and LTP's mobile number can't be same`
              });
              return;
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
          if (isSelfCert) {
            var _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL, _data7, _data7$descriptionOfL, _data8, _data8$descriptionOfL, _data9, _data9$descriptionOfL;
            const propSite = (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.planOn;
            const primaryUseOfProp = (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : _data6$descriptionOfL.activityAsPerMap;
            const activityProp = (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.activityProposed;
            const _plotArea = (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : _data8$descriptionOfL.landArea;
            if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && _plotArea > 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (primaryUseOfProp === "Commercial" && _plotArea > 200) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && _plotArea !== 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (((_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.schemeType) !== "Scheme") {
              setShowToast({
                key: "true",
                error: true,
                message: `Non Scheme Cases are not allowed here`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        initFormMTDocs((_data10 = data) === null || _data10 === void 0 ? void 0 : _data10.documents);
        setPurchasableData(purchasableData);
        if (isGovernmentBuilding === "yes") {
          Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to a government building and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
          return;
        }
        setValue("zoneType", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : _data11$descriptionOf.landUsesType);
        setValue("primaryUse", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.activityAsPerMap);
        setValue("landMark", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.landMark);
        setValue("sectorNo", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : _data14$descriptionOf.sectorNo);
        setValue("khasraNo", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : (_data15$descriptionOf2 = _data15$descriptionOf.khasraWithArea[0]) === null || _data15$descriptionOf2 === void 0 ? void 0 : _data15$descriptionOf2.khasraNo);
        setValue("schemeName", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$descriptionOf = _data16.descriptionOfLand) === null || _data16$descriptionOf === void 0 ? void 0 : _data16$descriptionOf.schemeName);
        setValue("proposal", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.planOn);
        setValue("riskType", (_data18 = data) === null || _data18 === void 0 ? void 0 : _data18.riskType);
        setValue("activityProposed", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$descriptionOf = _data19.descriptionOfLand) === null || _data19$descriptionOf === void 0 ? void 0 : _data19$descriptionOf.activityProposed);
        setValue("plotArea", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.landArea);
        setValue("plotNo", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.plotNo);
        setValue("plotAreaDoc", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$descriptionOf = _data22.descriptionOfLand) === null || _data22$descriptionOf === void 0 ? void 0 : _data22$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.landAddress);
        setValue("tehsil", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$landInfo = _data25.landInfo) === null || _data25$landInfo === void 0 ? void 0 : (_data25$landInfo$owne = _data25$landInfo.owners) === null || _data25$landInfo$owne === void 0 ? void 0 : (_data25$landInfo$owne2 = _data25$landInfo$owne[0]) === null || _data25$landInfo$owne2 === void 0 ? void 0 : (_data25$landInfo$owne3 = _data25$landInfo$owne2.permanentAddress) === null || _data25$landInfo$owne3 === void 0 ? void 0 : _data25$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$descriptionOf = _data26.descriptionOfLand) === null || _data26$descriptionOf === void 0 ? void 0 : _data26$descriptionOf.developmentArea);
        setValue("descriptionOfLand.schemeType", (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$descriptionOf = _data27.descriptionOfLand) === null || _data27$descriptionOf === void 0 ? void 0 : _data27$descriptionOf.schemeType);
        const isApproved = ((_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$descriptionOf = _data28.descriptionOfLand) === null || _data28$descriptionOf === void 0 ? void 0 : _data28$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$descriptionOf = _data29.descriptionOfLand) === null || _data29$descriptionOf === void 0 ? void 0 : _data29$descriptionOf.landArea;
        setRiskType((_data30 = data) === null || _data30 === void 0 ? void 0 : _data30.riskType);
        setSchemeType(isApproved);
        setPlottedArea(plotArea);
        if (isApproved) {
          var _data31, _data31$descriptionOf;
          setValue("subZoneType", (_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$descriptionOf = _data31.descriptionOfLand) === null || _data31$descriptionOf === void 0 ? void 0 : _data31$descriptionOf.subLandUseAsPerLayout);
        }
        if (!isApproved) {
          setValue("planOn", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const handlePrevFileSearch = async applicationNo => {
    var _prevData;
    const retainedValues = Digit.SessionStorage.get("RETAINED_VALUES");
    if (!applicationNo) return;
    let response;
    let prevData;
    if (applicationNo.includes("MS")) {
      var _response6, _response6$BPA, _response7, _response7$BPA, _response7$BPA$, _response8, _response8$BPA, _response8$BPA$, _response9, _response9$BPA, _response9$BPA$, _response10, _response10$BPA, _response10$BPA$, _response11, _response11$BPA;
      console.log("inside MS");
      response = await Digit.OBPSService.BPASearch(stateId, {
        applicationNo
      });
      if (!((_response6 = response) !== null && _response6 !== void 0 && (_response6$BPA = _response6.BPA) !== null && _response6$BPA !== void 0 && _response6$BPA.length)) {
        setShowToast({
          key: "true",
          error: true,
          message: `No Data Found for this FASTPAS ID...!!`
        });
        return;
      }
      if (((_response7 = response) === null || _response7 === void 0 ? void 0 : (_response7$BPA = _response7.BPA) === null || _response7$BPA === void 0 ? void 0 : (_response7$BPA$ = _response7$BPA[0]) === null || _response7$BPA$ === void 0 ? void 0 : _response7$BPA$.department) !== applicationFlow && ((_response8 = response) === null || _response8 === void 0 ? void 0 : (_response8$BPA = _response8.BPA) === null || _response8$BPA === void 0 ? void 0 : (_response8$BPA$ = _response8$BPA[0]) === null || _response8$BPA$ === void 0 ? void 0 : _response8$BPA$.department) !== (formData === null || formData === void 0 ? void 0 : formData.department)) {
        setShowToast({
          key: "true",
          error: true,
          message: `Please use the selected department FASTPASID`
        });
        return;
      }
      if (((_response9 = response) === null || _response9 === void 0 ? void 0 : (_response9$BPA = _response9.BPA) === null || _response9$BPA === void 0 ? void 0 : (_response9$BPA$ = _response9$BPA[0]) === null || _response9$BPA$ === void 0 ? void 0 : _response9$BPA$.planOn) !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" && ((_response10 = response) === null || _response10 === void 0 ? void 0 : (_response10$BPA = _response10.BPA) === null || _response10$BPA === void 0 ? void 0 : (_response10$BPA$ = _response10$BPA[0]) === null || _response10$BPA$ === void 0 ? void 0 : _response10$BPA$.planOn) !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error"
        });
        return;
      }
      prevData = (_response11 = response) === null || _response11 === void 0 ? void 0 : (_response11$BPA = _response11.BPA) === null || _response11$BPA === void 0 ? void 0 : _response11$BPA[0];
      prevData.natureOfConstruction = retainedValues === null || retainedValues === void 0 ? void 0 : retainedValues.natureofConstruction;
      prevData.prevFile = retainedValues === null || retainedValues === void 0 ? void 0 : retainedValues.prevFileNo;
      Digit.SessionStorage.set("PREV_FILE_DATA", prevData);
    } else {
      var _response12;
      if (!(applicationNo !== null && applicationNo !== void 0 && applicationNo.includes("SA-"))) {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error"
        });
        return;
      }
      console.log("inside migrated");
      response = await Digit.OBPSService.BPAmigratedSearchappNo({
        applicationNo
      });
      Digit.SessionStorage.set("MIGRATED_DATA", (_response12 = response) === null || _response12 === void 0 ? void 0 : _response12.Application);
      setSaveStatus({
        open: true,
        message: "Data fetched Successfully...!!",
        severity: "success"
      });
    }
    onSelect("", prevData);
    initFormMTDocs((_prevData = prevData) === null || _prevData === void 0 ? void 0 : _prevData.documents);
    setValue("prevFileNo", applicationNo);
    if (prevData) {
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      if (uuid) {
        var _usersResponse$user2, _prevData2, _prevData2$profession;
        const usersResponse = await Digit.UserService.userSearch(stateId, {
          uuid: [uuid]
        }, {});
        const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : _usersResponse$user2[0];
        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        setUser(userDetail);
        if (((_prevData2 = prevData) === null || _prevData2 === void 0 ? void 0 : (_prevData2$profession = _prevData2.professionaldetails) === null || _prevData2$profession === void 0 ? void 0 : _prevData2$profession.mobileNumber) !== (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
          setShowToast({
            key: "true",
            error: true,
            message: `Not Authorized to access this Id...!!`
          });
          return;
        }
        Modal("Declaration", `
<p style="font-size:14px; text-align:left;">If the proposal contains any of the following:</p>
<ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
  <li style="margin-bottom:6px;">Purchasable FAR</li>
  <li style="margin-bottom:6px;">Plot sub-division without permission</li>
  <li style="margin-bottom:6px;">Existing building requiring compounding</li>
</ul>
<p style="font-size:14px; text-align:left;">You are requested to kindly proceed through the normal map submission process.</p>
<br/>
<p style="font-size:13px;"><strong>Note:</strong> If the applicant submits a map that does not comply with the above conditions, 
the proposal will be rejected and no payment will be refunded.</p>
`, "warning", null, null, "I Declare");
      }
      if (isSelfCert) {
        var _prevData3;
        const {
          planOn: propSite,
          activityAsPerMap: primaryUseOfProp,
          activityProposed: activityProp,
          landArea: plotArea,
          schemeType
        } = ((_prevData3 = prevData) === null || _prevData3 === void 0 ? void 0 : _prevData3.descriptionOfLand) || {};
        if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && plotArea > 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (primaryUseOfProp === "Commercial" && plotArea > 200) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && plotArea !== 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (schemeType !== "Scheme") {
          setShowToast({
            key: "true",
            error: true,
            message: `Non Scheme Cases are not allowed here`
          });
          return;
        }
      }
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const handleCloseMessage = () => {
    setSaveStatus({
      ...saveStatus,
      open: false
    });
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType);
  const {
    landUseList: activityAsPerMap
  } = filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchPrimaryUse);
  const allowedLandUses = (landUseList === null || landUseList === void 0 ? void 0 : landUseList.filter(item => ["Residential", "Commercial"].includes(item.value))) || [];
  const allowedPrimaryUses = (activityAsPerMap === null || activityAsPerMap === void 0 ? void 0 : activityAsPerMap.filter(item => ["Residential", "Commercial"].includes(item.value))) || [];
  const activityProposed = watchPrimaryUse === "Residential" ? [{
    name: "Row Housing - Single units",
    label: "Row Housing - Single units",
    value: "Row Housing - Single units"
  }] : watchPrimaryUse === "Commercial" ? [{
    name: "Retail Shop",
    label: "Retail Shop",
    value: "Retail Shop"
  }] : [];
  useEffect(() => {
    var _activityProposed$;
    const selectedActivity = (_activityProposed$ = activityProposed[0]) === null || _activityProposed$ === void 0 ? void 0 : _activityProposed$.value;
    if (selectedActivity) {
      setValue("activityProposed", selectedActivity);
    }
  }, [watchPrimaryUse, setValue]);
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  useEffect(() => {
    var _Object$entries$find, _selectedDesign;
    const selectedDesignsObj = watch("selectedDesigns") || {};
    const selectedKey = (_Object$entries$find = Object.entries(selectedDesignsObj).find(([key, value]) => value)) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }
    if (selectedDesign && (_selectedDesign = selectedDesign) !== null && _selectedDesign !== void 0 && _selectedDesign.construction) {
      const floors = Object.entries(selectedDesign.construction).filter(([floor, val]) => val === "Y").map(([floor]) => floor).join(", ");
      setValue("anyotherCondition", floors);
    }
  }, [watch("selectedDesigns"), standardDesigns, setValue]);
  const onSubmit = data => {
    var _fastPasdata$addition, _data32, _data32$prevFileNo, _data36, _fastPASData$descript, _Object$entries$find2, _fastPasdata$addition2, _fastPasdata$addition3, _fastPasdata$addition4, _fastPasdata$descript, _fastPasdata$descript2, _fastPasdata$descript3, _fastPasdata$descript4;
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    if (fastPasdata !== null && fastPasdata !== void 0 && (_fastPasdata$addition = fastPasdata.additionalDetails) !== null && _fastPasdata$addition !== void 0 && _fastPasdata$addition.oldCaseApplicationNo) {
      Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
      return;
    }
    if ((fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.isGovernmentBuilding) === "yes") {
      Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to a government building and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
      return;
    }
    if (watchPrimaryUse === "Residential" && plottedArea > 500) {
      Modal("Map submission is not allowed.", "For residential plots with an area greater than 500 sq. m. Map submission is not allowed through this process.", "warning");
      return;
    }
    if (watchPrimaryUse === "Commercial" && plottedArea > 200) {
      Modal("Map submission is not allowed.", "For commercial plots with an area greater than 200 sq. m. Map submission is not allowed through this process.", "warning");
      return;
    }
    if ((_data32 = data) !== null && _data32 !== void 0 && (_data32$prevFileNo = _data32.prevFileNo) !== null && _data32$prevFileNo !== void 0 && _data32$prevFileNo.includes("SA-")) {
      var _data33, _data33$prevFileNo, _data34, _data35, _data35$landInfo, _migratedData$project;
      console.log("inside SA-");
      const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
      data.department = (_data33 = data) !== null && _data33 !== void 0 && (_data33$prevFileNo = _data33.prevFileNo) !== null && _data33$prevFileNo !== void 0 && _data33$prevFileNo.includes("DA") ? "DA" : "AVP";
      data.tenantId = stateId, data.businessService = data.department === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP", data.landInfo = {
        ...((_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.landInfo),
        tenantId: stateId,
        address: {
          ...((_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$landInfo = _data35.landInfo) === null || _data35$landInfo === void 0 ? void 0 : _data35$landInfo.address),
          locality: {
            code: migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$project = migratedData.projectDetail) === null || _migratedData$project === void 0 ? void 0 : _migratedData$project.district
          }
        }
      };
      handleSubTabChange(1, data);
      return;
    }
    if (watchnatureOfConstruction !== "New") {
      handleSubTabChange(1, prevFileData);
      return;
    }
    if (id && !fastPasdata) {
      handleSubTabChange(1, data);
      return;
    }
    const newFormData = {
      landInfo: {
        ...((fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.landInfo) || {})
      },
      tenantId: stateId,
      land_Id: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id,
      documents: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents,
      descriptionOfLand: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand,
      nocDetails: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails,
      occupancy: (_data36 = data) === null || _data36 === void 0 ? void 0 : _data36.zoneType,
      totalProposedArea: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.landArea,
      businessService: fastPASData.department === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP"
    };
    const selectedDesignsObj = data.selectedDesigns || {};
    const selectedKey = (_Object$entries$find2 = Object.entries(selectedDesignsObj).find(([key, value]) => value)) === null || _Object$entries$find2 === void 0 ? void 0 : _Object$entries$find2[0];
    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }
    data.selectedDesign = selectedDesign || null;
    data.selectedOffice = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition2 = fastPasdata.additionalDetails) === null || _fastPasdata$addition2 === void 0 ? void 0 : _fastPasdata$addition2.selectedOffice) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.selectedOffice) || "";
    data.selectedCity = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition3 = fastPasdata.additionalDetails) === null || _fastPasdata$addition3 === void 0 ? void 0 : _fastPasdata$addition3.selectedCity) || "";
    data.selectedUnit = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition4 = fastPasdata.additionalDetails) === null || _fastPasdata$addition4 === void 0 ? void 0 : _fastPasdata$addition4.selectedUnit) || "";
    data.landUseNo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.applicationNo;
    data.purchasableFAR = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$descript = fastPasdata.descriptionOfLand) === null || _fastPasdata$descript === void 0 ? void 0 : (_fastPasdata$descript2 = _fastPasdata$descript.properties) === null || _fastPasdata$descript2 === void 0 ? void 0 : (_fastPasdata$descript3 = _fastPasdata$descript2[0]) === null || _fastPasdata$descript3 === void 0 ? void 0 : _fastPasdata$descript3.requiredAreaFAR) || 0;
    data.fastPASId = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
    data.department = (fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.department) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.department);
    data.plotArea = fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$descript4 = fastPasdata.descriptionOfLand) === null || _fastPasdata$descript4 === void 0 ? void 0 : _fastPasdata$descript4.landArea, data = {
      ...data,
      ...newFormData
    };
    if (!id) {
      var _fastPasdata$landInfo, _fastPasdata$landInfo2, _fastPasdata$landInfo3, _fastPasdata$landInfo4, _fastPasdata$landInfo5, _fastPasdata$landInfo6, _fastPasdata$landInfo7, _fastPasdata$landInfo8, _fastPasdata$landInfo9, _fastPasdata$addition5, _fastPasdata$addition6, _fastPasdata$addition7, _purchasableData$desc, _purchasableData$desc2, _purchasableData$desc3, _fastPasdata$document, _fastPasdata$document2, _user$correspondenceA;
      data.plotNumbers = plotNumbers, data.applicantName = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$landInfo = fastPasdata.landInfo) === null || _fastPasdata$landInfo === void 0 ? void 0 : (_fastPasdata$landInfo2 = _fastPasdata$landInfo.owners) === null || _fastPasdata$landInfo2 === void 0 ? void 0 : (_fastPasdata$landInfo3 = _fastPasdata$landInfo2[0]) === null || _fastPasdata$landInfo3 === void 0 ? void 0 : _fastPasdata$landInfo3.name) || "";
      data.applicantEmailId = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$landInfo4 = fastPasdata.landInfo) === null || _fastPasdata$landInfo4 === void 0 ? void 0 : (_fastPasdata$landInfo5 = _fastPasdata$landInfo4.owners) === null || _fastPasdata$landInfo5 === void 0 ? void 0 : (_fastPasdata$landInfo6 = _fastPasdata$landInfo5[0]) === null || _fastPasdata$landInfo6 === void 0 ? void 0 : _fastPasdata$landInfo6.emailId) || "";
      data.aplicantMobileNumber = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$landInfo7 = fastPasdata.landInfo) === null || _fastPasdata$landInfo7 === void 0 ? void 0 : (_fastPasdata$landInfo8 = _fastPasdata$landInfo7.owners) === null || _fastPasdata$landInfo8 === void 0 ? void 0 : (_fastPasdata$landInfo9 = _fastPasdata$landInfo8[0]) === null || _fastPasdata$landInfo9 === void 0 ? void 0 : _fastPasdata$landInfo9.mobileNumber) || "";
      data.selectedOffice = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition5 = fastPasdata.additionalDetails) === null || _fastPasdata$addition5 === void 0 ? void 0 : _fastPasdata$addition5.selectedOffice) || "";
      data.selectedCity = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition6 = fastPasdata.additionalDetails) === null || _fastPasdata$addition6 === void 0 ? void 0 : _fastPasdata$addition6.selectedCity) || "";
      data.selectedUnit = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$addition7 = fastPasdata.additionalDetails) === null || _fastPasdata$addition7 === void 0 ? void 0 : _fastPasdata$addition7.selectedUnit) || "";
      data.landUseNo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.applicationNo;
      data.purchasableFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : (_purchasableData$desc = purchasableData.descriptionOfLand) === null || _purchasableData$desc === void 0 ? void 0 : (_purchasableData$desc2 = _purchasableData$desc.properties) === null || _purchasableData$desc2 === void 0 ? void 0 : (_purchasableData$desc3 = _purchasableData$desc2[0]) === null || _purchasableData$desc3 === void 0 ? void 0 : _purchasableData$desc3.requiredAreaFAR) || 0;
      data.fastPASId = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.signatureId = (fastPasdata === null || fastPasdata === void 0 ? void 0 : (_fastPasdata$document = fastPasdata.documents) === null || _fastPasdata$document === void 0 ? void 0 : (_fastPasdata$document2 = _fastPasdata$document.filter(doc => doc.documentType === "signature")[0]) === null || _fastPasdata$document2 === void 0 ? void 0 : _fastPasdata$document2.fileStoreId) || null;
      data.licenseeName = user === null || user === void 0 ? void 0 : user.name, data.licenseeLicenceNumber = user === null || user === void 0 ? void 0 : user.registrationNumber;
      data.licenseeMobileNumber = user === null || user === void 0 ? void 0 : user.mobileNumber;
      data.licenseeEmailId = user === null || user === void 0 ? void 0 : user.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA = user.correspondenceAddress) === null || _user$correspondenceA === void 0 ? void 0 : _user$correspondenceA.address;
      data.department = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.department;
    }
    handleSubTabChange(1, data);
  };
  if (applicationFlow === null && !isEmployee && !(formData !== null && formData !== void 0 && formData.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, watchPlanOn && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer mb-3"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading common-header-sec text-black"
  }, t("Medium Risk Category"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction / Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: SortingAlphabatically(selfApprovalnatureOfConstruction),
    type: "selectInput",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchnatureOfConstruction && watchnatureOfConstruction !== "New" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Prev File No"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    maxLength: 23,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    disabled: isEmployee,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handlePrevFileSearch(getValues("prevFileNo"))
  })) : /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  }))), watchnatureOfConstruction === "Revalidation" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Previous Sanction Date"),
    placeholder: t("Select Prev Sanction Date"),
    name: "prevSanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Current Validity Date"),
    placeholder: t("Select Date"),
    name: "currValidityDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.currValidityDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(allowedLandUses),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(allowedPrimaryUses),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityProposed),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Type",
    control: control,
    placeholder: t("Select Scheme Type"),
    name: "descriptionOfLand.schemeType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType,
    type: "textInput",
    disabled: watchPlotArea || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(proposedSiteOptions.filter(e => e.name !== "Others")),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposal",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposal,
    type: "selectInput",
    mandatory: schemeType,
    validation: {
      required: {
        value: schemeType,
        message: "This field is required"
      }
    },
    disabled: !!watchProposal || isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.schemeName) || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput",
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    disabled: isEmployee,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark || isEmployee,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput",
    disabled: !!watchPlotNo || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Plot Area as per Site (in Sqmt.)",
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "plotArea",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotArea,
    type: "textInput",
    disabled: watchPlotArea || isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker",
    disabled: isEmployee
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput",
    disabled: isEmployee
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of Plots"),
    name: "noOfPlots",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput",
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, Array.from({
    length: 3
  }).map((_, colIndex) => {
    var _formData$plotNumbers2;
    const plotIndex = rowIndex * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      hasLabel: false,
      maxLength: 15,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plotIndex]) || "",
      type: "textInput",
      disabled: isEmployee
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, Array.from({
    length: remainingPlots
  }).map((_, colIndex) => {
    var _formData$plotNumbers3;
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      maxLength: 15,
      hasLabel: false,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers3 = formData.plotNumbers) === null || _formData$plotNumbers3 === void 0 ? void 0 : _formData$plotNumbers3[plotIndex]) || "",
      type: "textInput",
      disabled: isEmployee
    }));
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "specialProjectType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.specialProjectType,
    type: "radioButton",
    data: yesOrNo,
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput"
  })))), watchisSpecialProject === "yes" && watchProjectType === "Building Design as per standard Drawing" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    style: {
      marginBottom: "16px",
      background: "#1F4A7C"
    },
    onClick: () => setShowDesigns(true)
  }, "View Standard Designs")), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: t("Standard Designs"),
    dataOpen: showDesigns,
    onClose: () => setShowDesigns(false)
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container",
    sx: {
      marginTop: 2
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, "Standard Designs"), /*#__PURE__*/React__default.createElement(Table$3, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(col => /*#__PURE__*/React__default.createElement("td", {
    key: col.id
  }, /*#__PURE__*/React__default.createElement("b", null, col.label))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Select"))))), /*#__PURE__*/React__default.createElement("tbody", null, (tableData === null || tableData === void 0 ? void 0 : tableData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 1,
    align: "center"
  }, "No Standard Designs Available")) : tableData === null || tableData === void 0 ? void 0 : tableData.map((row, idx) => /*#__PURE__*/React__default.createElement("tr", {
    key: row.code
  }, /*#__PURE__*/React__default.createElement("td", null, row.srNo), /*#__PURE__*/React__default.createElement("td", null, row.area), /*#__PURE__*/React__default.createElement("td", null, row.dimension), /*#__PURE__*/React__default.createElement("td", null, row.type), /*#__PURE__*/React__default.createElement("td", null, row.construction), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Controller, {
    name: `selectedDesigns.${row.code}`,
    control: control,
    defaultValue: false,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
      checked: !!field.value,
      onChange: e => field.onChange(e.target.checked)
    }))
  }))))))))))), checkedDesigns && ((_Object$keys = Object.keys(checkedDesigns)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container",
    sx: {
      marginTop: 2,
      marginBottom: 2,
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption",
    style: {
      width: "172px"
    }
  }, "Selected Designs"), /*#__PURE__*/React__default.createElement(Table$3, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Sr No")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Area (sqm)")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Dimension")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Type/Design")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Construction (GF/FF/SF)")))), /*#__PURE__*/React__default.createElement("tbody", null, Object.entries(checkedDesigns).filter(([key, value]) => value).map(([key]) => {
    const design = standardDesigns === null || standardDesigns === void 0 ? void 0 : standardDesigns.find(item => String(item.code) === String(key));
    if (!design) return null;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: design.code
    }, /*#__PURE__*/React__default.createElement("td", null, design.code), /*#__PURE__*/React__default.createElement("td", null, design.areaSqm || "-"), /*#__PURE__*/React__default.createElement("td", null, design.dimension || "-"), /*#__PURE__*/React__default.createElement("td", null, design.typeDesign || "-"), /*#__PURE__*/React__default.createElement("td", null, design.construction ? `GF: ${design.construction.GF}, FF: ${design.construction.FF}, SF: ${design.construction.SF}` : "-"));
  })))))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number of floor permissible"),
    placeholder: t("Enter floors"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchspcialProjectType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.landArea) < 40000 && watchlandUseType !== "Residential" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" ? /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Not authorized for Self Certification Approval of Map ", /*#__PURE__*/React__default.createElement("span", null, "*")) : watchNeedComp === "yes" && /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Kindly apply on Compounding Module ", /*#__PURE__*/React__default.createElement("span", null, "*")), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontStyle: "italic"
      }
    }, "I, ", ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.name) || "User", " ,", t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM"), " ")
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: !declarationChecked || watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" || watchNeedComp === "yes" || watchContainFar === "yes"
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Snackbar, {
    open: saveStatus.open,
    autoHideDuration: 6000,
    onClose: handleCloseMessage,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Alert, {
    onClose: handleCloseMessage,
    severity: saveStatus.severity,
    sx: {
      width: "100%"
    }
  }, saveStatus.message)));
};

const SubStep3$4 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _Digit$UserService$ge, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$structuralI, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    }
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  });
  const watchState = watch("landInfo.owners.[0].correspondenceAddress.state");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const [watchCategoryType, watchCertNo, watchValidity] = watch(["professionaldetails.consultantCategory", "professionaldetails.certificateNo", "professionaldetails.validupto"]);
  const formatValidUpto = userObj => {
    const rawDate = (userObj === null || userObj === void 0 ? void 0 : userObj.validUpto) || (userObj === null || userObj === void 0 ? void 0 : userObj.validupto) || (userObj === null || userObj === void 0 ? void 0 : userObj.pwdExpiryDate);
    if (!rawDate) return null;
    const dateStr = String(rawDate).trim().slice(0, 10);
    if (dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 2 && parts[2].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (parts[0].length === 4 && parts[2].length === 2) {
          return dateStr;
        }
      }
    } else if (dateStr.includes("/")) {
      const parts = dateStr.split("/");
      if (parts.length === 3) {
        if (parts[0].length === 2 && parts[2].length === 4) {
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (parts[0].length === 4 && parts[2].length === 2) {
          return `${parts[0]}-${parts[1]}-${parts[2]}`;
        }
      }
    } else if (!isNaN(dateStr)) {
      const d = new Date(Number(rawDate));
      if (!isNaN(d.getTime())) {
        let month = d.getMonth() + 1;
        let day = d.getDate();
        let year = d.getFullYear();
        month = month > 9 ? month : `0${month}`;
        day = day > 9 ? day : `0${day}`;
        return `${year}-${month}-${day}`;
      }
    }
    return dateStr;
  };
  useEffect(async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      var _userResponse$user;
      const userResponse = await Digit.UserService.userSearch(tenantId, {
        uuid: [uuid]
      }, {});
      const fetchedUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$user = userResponse.user) === null || _userResponse$user === void 0 ? void 0 : _userResponse$user[0];
      setUser(fetchedUser);
      if (fetchedUser) {
        var _fetchedUser$roles, _fetchedUser$roles$fi, _fetchedUser$roles$fi2;
        const category = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$roles = fetchedUser.roles) === null || _fetchedUser$roles === void 0 ? void 0 : (_fetchedUser$roles$fi = _fetchedUser$roles.filter(e => e.code !== "CITIZEN")) === null || _fetchedUser$roles$fi === void 0 ? void 0 : (_fetchedUser$roles$fi2 = _fetchedUser$roles$fi[0]) === null || _fetchedUser$roles$fi2 === void 0 ? void 0 : _fetchedUser$roles$fi2.name;
        setValue("professionaldetails.consultantCategory", category);
        setValue("professionaldetails.certificateNo", fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.registrationNumber);
        const formattedDate = formatValidUpto(fetchedUser);
        setValue("professionaldetails.validupto", formattedDate);
      }
    }
  }, []);
  useEffect(async () => {
    var _users$filter;
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"],
      pageSize: "100000"
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = (_users$filter = users.filter(user => user.uuid === formData.professionaldetails.engineerUuid)) === null || _users$filter === void 0 ? void 0 : _users$filter[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr.filter(e => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      var _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const formattedDate = formatValidUpto(selectedEngineer);
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchCategoryType
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.certificateNo
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchValidity
  }))), (_user$validUpto => {
    const validUpto = user === null || user === void 0 ? void 0 : (_user$validUpto = user.validUpto) === null || _user$validUpto === void 0 ? void 0 : _user$validUpto.slice(0, 10);
    if (validUpto) {
      const [dd, mm, yyyy] = validUpto.split("-");
      const validUptoDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      const today = new Date();
      validUptoDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      console.log("validUptoDate", validUptoDate - today);
      if (validUptoDate < today) {
        return /*#__PURE__*/React__default.createElement(Col, {
          md: 12
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "text-red important-note"
        }, "Note: The LTP license validity has expired. Please update your license."));
      }
    }
    return null;
  })())), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 200,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    type: "specialChar",
    allowedChars: "/,& ",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI = formData.structuralInfo) === null || _formData$structuralI === void 0 ? void 0 : _formData$structuralI.name,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.licenseNumber,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.validupto,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : (_formData$structuralI5 = _formData$structuralI4.permanentAddress) === null || _formData$structuralI5 === void 0 ? void 0 : _formData$structuralI5.address,
    type: "textInput",
    disabled: true,
    maxLength: 50
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep2$2 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$plotInfo, _formData$plotInfo2;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    planheightOfBuilding: formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  const watchTotalBuildUpArea = watch("totalBuildUpArea");
  useEffect(() => {
    setValue("plotInfo.plotArea", formData === null || formData === void 0 ? void 0 : formData.plotArea);
    setValue("plotInfo.builtupArea", formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
    setValue("planheightOfBuilding", formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding);
  }, []);
  const onSubmit = data => {
    handleSubTabChange(2, data);
  };
  console.log("formdatttttt", formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), formData !== null && formData !== void 0 && formData.edcrNumber ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area as per drawing (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area as per drawing"),
    name: "plotInfo.plotArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.plotArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Total Proposed Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Total Proposed Built up Area"),
    name: "totalBuildUpArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.builtupArea),
    type: "textInput",
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "planheightOfBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planheightOfBuilding,
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null)))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep4$4 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4;
  console.log(formData, "formDagta");
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    },
    documents: documents
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [documents, formData === null || formData === void 0 ? void 0 : formData.documents]);
  console.log("Documents787878", documents);
  const kmlFile = (documents === null || documents === void 0 ? void 0 : documents.find(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === "kmlFile")) || null;
  console.log("kmlFile", kmlFile);
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form self-certified custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  }), !isEmployee &&
  /*#__PURE__*/
  React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "14px",
      textAlign: "left",
      display: "inline-block",
      width: "50%"
    }
  }, "KML File"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "large",
    color: "info",
    onClick: () => getDocumentByFileStoreId(kmlFile === null || kmlFile === void 0 ? void 0 : kmlFile.fileStoreId, setIsPreviewLoading)
  }, isPreviewLoading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "14px",
      height: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(TravelExploreOutlinedIcon, {
    color: "primary",
    sx: {
      fontSize: "18px"
    }
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const EmpSelfApproval = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray,
  urlFormType
}) => {
  var _Digit, _Digit2, _userRolesArray$;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [showToast, setShowToast] = useState(null);
  const [showCurrentChallan, setShowCurrentChallan] = useState(false);
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code);
  const {
    currentAction,
    isCitizen,
    t,
    actions,
    handleSubmit,
    error,
    setError,
    remarks,
    setRemarks,
    documentSection,
    setIsPreviewLoading,
    tenantId,
    params,
    taxHead,
    setTaxHead,
    iframeSrc,
    setIframeSrc,
    updateApiCall,
    initialUrl,
    developerRemarks,
    onSelect,
    Modal,
    isValidEmp,
    dataRecommendation,
    setDeveloperRemarks,
    callNotingDetailsAPI,
    uploadedFile,
    setUploadedFile,
    notingRemarksData,
    onDropDownSelect,
    setDataRecommendation,
    paymentHeadRemarksData,
    callPaymentDetailsAPI,
    mapSubmissionAction,
    isFromDashboard
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  const subTabLabels = [{
    label: "Application Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "Fees"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async nextTabNo => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const renderContent = () => {
    var _userRolesArray$2;
    console.log("activeTabFromRender", activeTab);
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$5, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaymentHead, {
            tenantId: tenantId,
            formData: params,
            setTaxHead: setTaxHead,
            taxHead: taxHead,
            empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code,
            isFeesEligible: isFeesEligible,
            onSelect: onSelect,
            Modal: Modal,
            isValidEmp: isValidEmp,
            setShowCurrentChallan: setShowCurrentChallan,
            isFromDashboard: isFromDashboard
          }), /*#__PURE__*/React__default.createElement(PaymentMemoTable, {
            formData: params
          }), /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
            title: "Recommendation Details",
            label: "Recommendation",
            name: "recommendation",
            options: SortingAlphabatically(siteInspRecommendation),
            defaultValue: dataRecommendation,
            extraLabel: "Remarks",
            setDeveloperRemarks: setDeveloperRemarks,
            developerRemarks: developerRemarks,
            setDataRecommendation: setDataRecommendation,
            buttonshow: true,
            onSaveClick: callPaymentDetailsAPI,
            isFromDashboard: isFromDashboard
          }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: paymentHeadRemarksData === null || paymentHeadRemarksData === void 0 ? void 0 : paymentHeadRemarksData.DetailDataRemarks,
            type: "paymentDetails"
          }));
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc,
        initialUrl: initialUrl
      }));
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && !isFromDashboard && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    setIsPreviewLoading: setIsPreviewLoading,
    setIframeSrc: setIframeSrc,
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const PfarRemarks = ({
  title,
  name,
  defaultValue,
  extraLabel,
  setDeveloperRemarks,
  developerRemarks,
  buttonshow: _buttonshow = false,
  onSaveClick,
  error,
  setError
}) => {
  const {
    control,
    getValues
  } = useForm();
  const handleClick = () => {
    onSaveClick(developerRemarks);
  };
  return /*#__PURE__*/React__default.createElement(Card$1, {
    sx: {
      backgroundColor: "#f9f9f9",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      my: 2,
      p: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      p: 1,
      color: "#fff",
      textAlign: "left",
      borderRadius: "4px",
      fontSize: '1rem',
      padding: '10px',
      fontFamily: 'sans-serif',
      lineHeight: '1.5'
    }
  }, title), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1,
    sx: {
      my: 2
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography, null, extraLabel, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: 'red'
    }
  }, " *"))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React__default.createElement(RemarksEditor, {
    setRemarks: setDeveloperRemarks,
    remarks: developerRemarks,
    error: error,
    setError: setError
  }))), _buttonshow && /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginTop: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "secondary",
    onClick: handleClick,
    style: {
      margin: "auto",
      height: "30px",
      width: "10%",
      borderRadius: "4px",
      backgroundColor: '#157CB3'
    }
  }, "Save")));
};

const PfarDetailsTable = ({
  detailData
}) => {
  const detailsArray = Array.isArray(detailData) ? detailData : [detailData];
  console.log(detailData, "detailData in pfar");
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      fontWeight: "bold",
      marginBottom: "10px"
    }
  }, "Purchasable Far Remark Details Summary"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto",
      maxHeight: "300px",
      overflowY: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellPadding: "8",
    width: "100%",
    style: {
      borderCollapse: "collapse",
      minWidth: "800px",
      fontSize: "11px",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      position: "sticky",
      top: 0,
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      fontSize: "14px",
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("th", null, "User"), /*#__PURE__*/React__default.createElement("th", null, "Designation"), /*#__PURE__*/React__default.createElement("th", null, "Date & Time"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, detailsArray.map((item, index) => {
    var _item$auditDetails, _item$remarksDetails;
    const user = (item === null || item === void 0 ? void 0 : item.userDetails) || {};
    const createdTime = (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || null;
    const remarks = item === null || item === void 0 ? void 0 : (_item$remarksDetails = item.remarksDetails) === null || _item$remarksDetails === void 0 ? void 0 : _item$remarksDetails.developerRemarks;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.employeeName) || (user === null || user === void 0 ? void 0 : user.name) || "-"), /*#__PURE__*/React__default.createElement("td", null, (user === null || user === void 0 ? void 0 : user.designation) || "-"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: createdTime
    })), /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: remarks || "-",
      tag: "td"
    }));
  })))));
};

const SubStep1$6 = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  onSelect,
  initFormMTDocs,
  isEmployee,
  standardDesigns
}) => {
  var _formData$Purchasable, _formData$Purchasable2, _formData$Purchasable3, _formData$Purchasable4, _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers, _formData$description7, _formData$description8, _fastPASData$descript9, _Array$from, _Array$from3, _Object$keys, _Object$entries3, _Object$entries3$filt, _fastPASData$descript10;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1", standardDesigns);
  const includesCaseInsensitive = (array, value) => {
    if (!array || !value) return false;
    console.log("includesCaseInsesitive", array === null || array === void 0 ? void 0 : array.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase()).includes(value === null || value === void 0 ? void 0 : value.toLowerCase()), array, value);
    return array === null || array === void 0 ? void 0 : array.map(item => item === null || item === void 0 ? void 0 : item.toLowerCase()).includes(value === null || value === void 0 ? void 0 : value.toLowerCase());
  };
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const Modal = useModal();
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
    planOn: "PURCHASABLE_MAP",
    Purchasable: {
      PermittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable = formData.Purchasable) === null || _formData$Purchasable === void 0 ? void 0 : _formData$Purchasable.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable2 = formData.Purchasable) === null || _formData$Purchasable2 === void 0 ? void 0 : _formData$Purchasable2.permittedFactor) || "",
      Cost: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable3 = formData.Purchasable) === null || _formData$Purchasable3 === void 0 ? void 0 : _formData$Purchasable3.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable4 = formData.Purchasable) === null || _formData$Purchasable4 === void 0 ? void 0 : _formData$Purchasable4.cost) || ""
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !(district !== null && district !== void 0 && (_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  }));
  const fetchedData = Digit.SessionStorage.get("FORM_PURCHASABLE_FAR") || null;
  const [fastPASData, setFastPasData] = useState(fetchedData ? fetchedData : null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [saveStatus, setSaveStatus] = useState({
    open: false,
    message: "",
    severity: "error"
  });
  const [baseFAR, setBaseFAR] = useState(null);
  const [premiumFAR, setPremiumFAR] = useState(null);
  const [purchasableFAR, setPurchasableFAR] = useState(null);
  const [watchProposalType, watchisSpecialProject, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchPrevFileNo, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchProposal, watchPlotArea, watchPlotNo, watchContainFar, watchFastPASId, watchBasicFAR, watchPurchasableFAR] = watch(["proposalType", "isSpecialProject", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "prevFileNo", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "proposal", "descriptionOfLand.schemeType", "plotNo", "containFAR", "fastPASId", "basicFAR", "purchasableFAR"]);
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const [showDesigns, setShowDesigns] = useState(false);
  console.log("WAtchhsakPlot", watchPlotArea);
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs === null || plotInputs === void 0 ? void 0 : plotInputs.map(plot => watchedFields[`plotNumbers[${plot === null || plot === void 0 ? void 0 : plot.index}]`]);
  useEffect(() => {
    if (formData) {
      var _formData$Purchasable5, _formData$Purchasable6, _formData$Purchasable7, _formData$Purchasable8;
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
        Purchasable: {
          PermittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable5 = formData.Purchasable) === null || _formData$Purchasable5 === void 0 ? void 0 : _formData$Purchasable5.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable6 = formData.Purchasable) === null || _formData$Purchasable6 === void 0 ? void 0 : _formData$Purchasable6.permittedFactor) || "",
          Cost: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable7 = formData.Purchasable) === null || _formData$Purchasable7 === void 0 ? void 0 : _formData$Purchasable7.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable8 = formData.Purchasable) === null || _formData$Purchasable8 === void 0 ? void 0 : _formData$Purchasable8.cost) || ""
        }
      });
    }
  }, [formData]);
  useEffect(() => {
    setValue("planOn", "Others");
  }, []);
  const columns = [{
    id: "srNo",
    label: "Sr No"
  }, {
    id: "area",
    label: "Area (sqm)"
  }, {
    id: "dimension",
    label: "Dimension"
  }, {
    id: "type",
    label: "Type/Design"
  }, {
    id: "construction",
    label: "Construction (GF/FF/SF)"
  }];
  const tableData = standardDesigns === null || standardDesigns === void 0 ? void 0 : standardDesigns.map((item, idx) => ({
    code: item !== null && item !== void 0 && item.code ? item.code : "",
    srNo: idx + 1,
    area: item !== null && item !== void 0 && item.areaSqm ? item.areaSqm : "-",
    dimension: item !== null && item !== void 0 && item.dimension ? item.dimension : "-",
    type: item !== null && item !== void 0 && item.typeDesign ? item.typeDesign : "-",
    construction: item !== null && item !== void 0 && item.construction ? `GF: ${item === null || item === void 0 ? void 0 : item.construction.GF}, FF: ${item === null || item === void 0 ? void 0 : item.construction.FF}, SF: ${item === null || item === void 0 ? void 0 : item.construction.SF}` : "-"
  }));
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const retainedVlalues = {
      natureofConstruction: watchnatureOfConstruction,
      prevFileNo: watchPrevFileNo
    };
    Digit.SessionStorage.set("RETAINED_VALUES", retainedVlalues);
  }, [watchnatureOfConstruction, watchPrevFileNo]);
  useEffect(() => {
    const riskType = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? "Building Plan Low Risk, Self Certification Mode" : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") && watchAtivityProposed !== "Row Houses" && watchAtivityProposed !== "Semi Detached" && watchAtivityProposed !== "Detached" ? "High Risk and High Nivesh" : watchlandUseType === "Commercial" ? "High Risk and High Nivesh" : watchPlanOn !== "Others" ? "Building Plan-Low Risk" : "Others";
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    if (watchContainFar === "yes") {
      setShowToast({
        key: "true",
        error: true,
        message: `Purchasable FAR is not allowed through Self-Approval via LTP. Kindly submit your application using the alternative map submission process`
      });
    }
  }, [watchContainFar]);
  const selectedDesigns = watch("selectedDesigns") || [];
  useEffect(() => {
    Digit.SessionStorage.set("CHECKED_DESIGN", selectedDesigns);
  }, [JSON.stringify(selectedDesigns)]);
  const [checkedDesigns, setCheckedDesigns] = useState([]);
  useEffect(() => {
    const stored = Digit.SessionStorage.get("CHECKED_DESIGN");
    setCheckedDesigns(stored || {});
  }, [showDesigns, JSON.stringify(selectedDesigns)]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$, _response4, _response4$BPA, _response4$BPA$filter, _response5, _response5$BPA, _response5$BPA$filter, _data7, _data7$descriptionOfL, _data8, _data8$descriptionOfL, _data9, _data9$descriptionOfL, _data10, _data10$descriptionOf, _data11, _data11$descriptionOf, _data11$descriptionOf2, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data15, _data15$descriptionOf, _data16, _data16$descriptionOf, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19, _data19$descriptionOf, _data20, _data20$descriptionOf, _data21, _data21$landInfo, _data21$landInfo$owne, _data21$landInfo$owne2, _data21$landInfo$owne3, _data22, _data22$descriptionOf, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow && ((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$ = _response3$BPA[0]) === null || _response3$BPA$ === void 0 ? void 0 : _response3$BPA$.department) !== (formData === null || formData === void 0 ? void 0 : formData.department)) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        purchasableData = (_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$BPA = _response5.BPA) === null || _response5$BPA === void 0 ? void 0 : (_response5$BPA$filter = _response5$BPA.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_PURCHASABLE_FAR")) === null || _response5$BPA$filter === void 0 ? void 0 : _response5$BPA$filter[0];
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data, _data$additionalDetai, _data$additionalDetai2;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data = data) === null || _data === void 0 ? void 0 : (_data$additionalDetai = _data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.professionalInformation) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
          if (isSelfCert) {
            var _data2, _data2$descriptionOfL, _data3, _data3$descriptionOfL, _data4, _data4$descriptionOfL, _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL;
            const propSite = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$descriptionOfL = _data2.descriptionOfLand) === null || _data2$descriptionOfL === void 0 ? void 0 : _data2$descriptionOfL.planOn;
            const primaryUseOfProp = (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$descriptionOfL = _data3.descriptionOfLand) === null || _data3$descriptionOfL === void 0 ? void 0 : _data3$descriptionOfL.activityAsPerMap;
            const activityProp = (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$descriptionOfL = _data4.descriptionOfLand) === null || _data4$descriptionOfL === void 0 ? void 0 : _data4$descriptionOfL.activityProposed;
            const _plotArea = (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.landArea;
            if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && _plotArea > 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (primaryUseOfProp === "Commercial" && _plotArea > 200) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && _plotArea !== 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`
              });
              return;
            }
            if (((_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : _data6$descriptionOfL.schemeType) !== "Scheme") {
              setShowToast({
                key: "true",
                error: true,
                message: `Non Scheme Cases are not allowed here`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        console.log("datafromfastpasid", data);
        setPurchasableData(purchasableData);
        setValue("zoneType", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : _data8$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.landMark);
        setValue("sectorNo", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.sectorNo);
        setValue("khasraNo", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : (_data11$descriptionOf2 = _data11$descriptionOf.khasraWithArea[0]) === null || _data11$descriptionOf2 === void 0 ? void 0 : _data11$descriptionOf2.khasraNo);
        setValue("schemeName", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.schemeName);
        setValue("proposal", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.planOn);
        setValue("riskType", (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.riskType);
        setValue("activityProposed", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : _data15$descriptionOf.activityProposed);
        setValue("plotArea", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$descriptionOf = _data16.descriptionOfLand) === null || _data16$descriptionOf === void 0 ? void 0 : _data16$descriptionOf.landArea);
        setValue("plotNo", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.plotNo);
        setValue("plotAreaDoc", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$descriptionOf = _data19.descriptionOfLand) === null || _data19$descriptionOf === void 0 ? void 0 : _data19$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.landAddress);
        setValue("tehsil", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$landInfo = _data21.landInfo) === null || _data21$landInfo === void 0 ? void 0 : (_data21$landInfo$owne = _data21$landInfo.owners) === null || _data21$landInfo$owne === void 0 ? void 0 : (_data21$landInfo$owne2 = _data21$landInfo$owne[0]) === null || _data21$landInfo$owne2 === void 0 ? void 0 : (_data21$landInfo$owne3 = _data21$landInfo$owne2.permanentAddress) === null || _data21$landInfo$owne3 === void 0 ? void 0 : _data21$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$descriptionOf = _data22.descriptionOfLand) === null || _data22$descriptionOf === void 0 ? void 0 : _data22$descriptionOf.developmentArea);
        setValue("descriptionOfLand.schemeType", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.schemeType);
        const isApproved = ((_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.landArea;
        setRiskType((_data26 = data) === null || _data26 === void 0 ? void 0 : _data26.riskType);
        setSchemeType(isApproved);
        if (isApproved) {
          var _data27, _data27$descriptionOf;
          setValue("subZoneType", (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$descriptionOf = _data27.descriptionOfLand) === null || _data27$descriptionOf === void 0 ? void 0 : _data27$descriptionOf.subLandUseAsPerLayout);
        }
        if (!isApproved) {
          setValue("planOn", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    var _fastPASData$descript, _fastPASData$descript2, _fastPASData$descript3, _formData$description, _formData$description2, _formData$description3, _fastPASData$descript4, _formData$description4, _fastPASData$descript5, _formData$description5, _fastPASData$descript6, _formData$description6;
    const roadWidth = parseInt(fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : (_fastPASData$descript2 = _fastPASData$descript.approachRoadWidths) === null || _fastPASData$descript2 === void 0 ? void 0 : (_fastPASData$descript3 = _fastPASData$descript2[0]) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.value) || parseInt(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.approachRoadWidths) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2[0]) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.value) || 0;
    const activityProposed = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript4 = fastPASData.descriptionOfLand) === null || _fastPASData$descript4 === void 0 ? void 0 : _fastPASData$descript4.activityProposed) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.activityProposed) || "";
    const developmentArea = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript5 = fastPASData.descriptionOfLand) === null || _fastPASData$descript5 === void 0 ? void 0 : _fastPASData$descript5.developmentArea) || (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.developmentArea) || "";
    const plotArea = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript6 = fastPASData.descriptionOfLand) === null || _fastPASData$descript6 === void 0 ? void 0 : _fastPASData$descript6.landArea) || (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.landArea) || 0;
    const allowableActivityProposed = ["Row Housing - Single units", "Semi-Detached - Single Units", "Detached - Single units", "Row Housing - Multi units", "Semi-detached - Multi Units", "Detached - Multi Units"];
    const allowableDevelopmentArea = ["Built-up Area", "Non-Built-up Area"];
    const proposedBuiltUp = activityProposed === "Group Housing" && developmentArea === "Built-up Area";
    const proposedNonBuiltUp = activityProposed === "Group Housing" && developmentArea === "Non-Built-up Area";
    const proposedAffordableBuiltUp = activityProposed === "Group Housing - Affordable" && developmentArea === "Built-up Area";
    const proposedAffordableNonBuiltUp = activityProposed === "Group Housing - Affordable" && developmentArea === "Non-Built-up Area";
    console.log({
      roadWidth,
      activityProposed,
      developmentArea,
      plotArea
    }, "roadWidthEffect");
    if (activityProposed === "Row Housing - Single units" && plotArea < 35) {
      setBaseFAR(2);
    } else if (includesCaseInsensitive(allowableActivityProposed, activityProposed) && includesCaseInsensitive(allowableDevelopmentArea, developmentArea) && plotArea >= 35 && plotArea < 150) {
      setBaseFAR(2);
      setPurchasableFAR(0.25);
    } else if (includesCaseInsensitive(allowableActivityProposed, activityProposed) && includesCaseInsensitive(allowableDevelopmentArea, developmentArea) && plotArea >= 150 && plotArea < 300) {
      setBaseFAR(1.8);
      setPurchasableFAR(0.7);
    } else if (includesCaseInsensitive(allowableActivityProposed, activityProposed) && includesCaseInsensitive(allowableDevelopmentArea, developmentArea) && plotArea >= 300 && plotArea < 500) {
      setBaseFAR(1.75);
      setPurchasableFAR(0.75);
    } else if (includesCaseInsensitive(allowableActivityProposed, activityProposed) && includesCaseInsensitive(allowableDevelopmentArea, developmentArea) && plotArea >= 500 && plotArea < 1200) {
      setBaseFAR(1.5);
      setPremiumFAR(1.0);
    } else if (includesCaseInsensitive(allowableActivityProposed, activityProposed) && includesCaseInsensitive(allowableDevelopmentArea, developmentArea) && plotArea >= 1200) {
      setBaseFAR(1.25);
      setPurchasableFAR(1.25);
    }
    if (proposedBuiltUp && roadWidth < 12) {
      setBaseFAR(1.5);
      setPremiumFAR(0.3);
      setPurchasableFAR(0.3);
    } else if (proposedBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(1.5);
      setPremiumFAR(0.75);
      setPurchasableFAR(0.75);
    } else if (proposedBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(1.5);
      setPremiumFAR(1.5);
      setPurchasableFAR(2.25);
    } else if (proposedBuiltUp && roadWidth >= 45) {
      setBaseFAR(1.5);
      setPurchasableFAR(1.5);
      setPremiumFAR("Un-restricted");
    }
    if (proposedNonBuiltUp && roadWidth < 12) ; else if (proposedNonBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(2.5);
      setPremiumFAR(1.25);
      setPurchasableFAR(1.25);
    } else if (proposedNonBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(2.5);
      setPremiumFAR(2.5);
      setPurchasableFAR(3.75);
    } else if (proposedNonBuiltUp && roadWidth >= 45) {
      setBaseFAR(2.5);
      setPurchasableFAR(2.5);
      setPremiumFAR("Un-restricted");
    }
    if (proposedAffordableBuiltUp && roadWidth < 12) {
      setBaseFAR(2.0);
      setPremiumFAR(0.2);
      setPurchasableFAR(0.2);
    } else if (proposedAffordableBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(2.0);
      setPremiumFAR(1.0);
      setPurchasableFAR(1.0);
    } else if (proposedAffordableBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(2.0);
      setPremiumFAR(2.0);
      setPurchasableFAR(3.0);
    } else if (proposedAffordableBuiltUp && roadWidth >= 45) {
      setBaseFAR(2.0);
      setPurchasableFAR(2.0);
      setPremiumFAR("Un-restricted");
    }
    if (proposedAffordableNonBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(3.0);
      setPremiumFAR(1.5);
      setPurchasableFAR(1.5);
    } else if (proposedAffordableNonBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(3.0);
      setPremiumFAR(3.0);
      setPurchasableFAR(3.0);
    } else if (proposedAffordableNonBuiltUp && roadWidth >= 45) {
      setBaseFAR(3.0);
      setPurchasableFAR(3.0);
      setPremiumFAR("Un-restricted");
    }
    console.log({
      baseFAR,
      purchasableFAR,
      premiumFAR
    }, "farImplementation");
  }, [watchFastPASId, watchAtivityProposed, watchPlotArea]);
  const handlePrevFileSearch = async applicationNo => {
    var _prevData;
    const retainedValues = Digit.SessionStorage.get("RETAINED_VALUES");
    if (!applicationNo) return;
    let response;
    let prevData;
    if (applicationNo.includes("MS")) {
      var _response6, _response6$BPA, _response7, _response7$BPA, _response7$BPA$, _response8, _response8$BPA, _response8$BPA$, _response9, _response9$BPA, _response9$BPA$, _response10, _response10$BPA, _response10$BPA$, _response11, _response11$BPA;
      console.log("inside MS");
      response = await Digit.OBPSService.BPASearch(stateId, {
        applicationNo
      });
      if (!((_response6 = response) !== null && _response6 !== void 0 && (_response6$BPA = _response6.BPA) !== null && _response6$BPA !== void 0 && _response6$BPA.length)) {
        setShowToast({
          key: "true",
          error: true,
          message: `No Data Found for this FASTPAS ID...!!`
        });
        return;
      }
      if (((_response7 = response) === null || _response7 === void 0 ? void 0 : (_response7$BPA = _response7.BPA) === null || _response7$BPA === void 0 ? void 0 : (_response7$BPA$ = _response7$BPA[0]) === null || _response7$BPA$ === void 0 ? void 0 : _response7$BPA$.department) !== applicationFlow && ((_response8 = response) === null || _response8 === void 0 ? void 0 : (_response8$BPA = _response8.BPA) === null || _response8$BPA === void 0 ? void 0 : (_response8$BPA$ = _response8$BPA[0]) === null || _response8$BPA$ === void 0 ? void 0 : _response8$BPA$.department) !== (formData === null || formData === void 0 ? void 0 : formData.department)) {
        setShowToast({
          key: "true",
          error: true,
          message: `Please use the selected department FASTPASID`
        });
        return;
      }
      if (((_response9 = response) === null || _response9 === void 0 ? void 0 : (_response9$BPA = _response9.BPA) === null || _response9$BPA === void 0 ? void 0 : (_response9$BPA$ = _response9$BPA[0]) === null || _response9$BPA$ === void 0 ? void 0 : _response9$BPA$.planOn) !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || ((_response10 = response) === null || _response10 === void 0 ? void 0 : (_response10$BPA = _response10.BPA) === null || _response10$BPA === void 0 ? void 0 : (_response10$BPA$ = _response10$BPA[0]) === null || _response10$BPA$ === void 0 ? void 0 : _response10$BPA$.planOn) !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error"
        });
        return;
      }
      prevData = (_response11 = response) === null || _response11 === void 0 ? void 0 : (_response11$BPA = _response11.BPA) === null || _response11$BPA === void 0 ? void 0 : _response11$BPA[0];
      prevData.natureOfConstruction = retainedValues === null || retainedValues === void 0 ? void 0 : retainedValues.natureofConstruction;
      prevData.prevFile = retainedValues === null || retainedValues === void 0 ? void 0 : retainedValues.prevFileNo;
      Digit.SessionStorage.set("PREV_FILE_DATA", prevData);
    } else {
      var _response12;
      if (!(applicationNo !== null && applicationNo !== void 0 && applicationNo.includes("SA-"))) {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error"
        });
        return;
      }
      console.log("inside migrated");
      response = await Digit.OBPSService.BPAmigratedSearchappNo({
        applicationNo
      });
      Digit.SessionStorage.set("MIGRATED_DATA", (_response12 = response) === null || _response12 === void 0 ? void 0 : _response12.Application);
      setSaveStatus({
        open: true,
        message: "Data fetched Successfully...!!",
        severity: "success"
      });
    }
    onSelect("", prevData);
    initFormMTDocs((_prevData = prevData) === null || _prevData === void 0 ? void 0 : _prevData.documents);
    setValue("prevFileNo", applicationNo);
    if (prevData) {
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      if (uuid) {
        var _usersResponse$user2, _prevData2, _prevData2$profession;
        const usersResponse = await Digit.UserService.userSearch(stateId, {
          uuid: [uuid]
        }, {});
        const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : _usersResponse$user2[0];
        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        setUser(userDetail);
        if (((_prevData2 = prevData) === null || _prevData2 === void 0 ? void 0 : (_prevData2$profession = _prevData2.professionaldetails) === null || _prevData2$profession === void 0 ? void 0 : _prevData2$profession.mobileNumber) !== (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
          setShowToast({
            key: "true",
            error: true,
            message: `Not Authorized to access this Id...!!`
          });
          return;
        }
      }
      if (isSelfCert) {
        var _prevData3;
        const {
          planOn: propSite,
          activityAsPerMap: primaryUseOfProp,
          activityProposed: activityProp,
          landArea: plotArea,
          schemeType
        } = ((_prevData3 = prevData) === null || _prevData3 === void 0 ? void 0 : _prevData3.descriptionOfLand) || {};
        if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && plotArea > 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (primaryUseOfProp === "Commercial" && plotArea > 200) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && plotArea !== 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`
          });
          return;
        }
        if (schemeType !== "Scheme") {
          setShowToast({
            key: "true",
            error: true,
            message: `Non Scheme Cases are not allowed here`
          });
          return;
        }
      }
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType);
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchPrimaryUse);
  console.log(schemeType, "schemeTypeerrrrr");
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  useEffect(() => {
    var _Object$entries$find, _selectedDesign;
    const selectedDesignsObj = watch("selectedDesigns") || {};
    const selectedKey = (_Object$entries$find = Object.entries(selectedDesignsObj).find(([key, value]) => value)) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }
    if (selectedDesign && (_selectedDesign = selectedDesign) !== null && _selectedDesign !== void 0 && _selectedDesign.construction) {
      var _Object$entries, _Object$entries$filte, _Object$entries$filte2;
      const floors = (_Object$entries = Object.entries(selectedDesign.construction)) === null || _Object$entries === void 0 ? void 0 : (_Object$entries$filte = _Object$entries.filter(([floor, val]) => val === "Y")) === null || _Object$entries$filte === void 0 ? void 0 : (_Object$entries$filte2 = _Object$entries$filte.map(([floor]) => floor)) === null || _Object$entries$filte2 === void 0 ? void 0 : _Object$entries$filte2.join(", ");
      setValue("anyotherCondition", floors);
    }
  }, [standardDesigns, selectedDesigns, setValue]);
  const onSubmit = data => {
    var _data28, _data28$Purchasable, _data29, _formData$Purchasable9, _data30, _data30$Purchasable, _data31, _formData$Purchasable10, _data32, _data32$prevFileNo, _data36, _fastPASData$descript7, _Object$entries2, _Object$entries2$find, _fastPASData$addition, _fastPASData$addition2, _fastPASData$addition3, _fastPASData$descript8;
    console.log("SubmittedDAta", data, typeof watchBasicFAR, typeof watchPurchasableFAR, watchBasicFAR, watchPurchasableFAR);
    if (Number(watchBasicFAR) + Number(watchPurchasableFAR) > 8.0) {
      Modal("Invalid Values", `Your Basic FAR and Purchasable FAR Factors value are exceeding 8. Please Correct them before proceeding.`, "warning");
      return;
    }
    const purchasableDataPayload = {
      PermittedFactor: ((_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$Purchasable = _data28.Purchasable) === null || _data28$Purchasable === void 0 ? void 0 : _data28$Purchasable.PermittedFactor) || ((_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.PermittedFactor) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable9 = formData.Purchasable) === null || _formData$Purchasable9 === void 0 ? void 0 : _formData$Purchasable9.PermittedFactor) || "",
      Cost: ((_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$Purchasable = _data30.Purchasable) === null || _data30$Purchasable === void 0 ? void 0 : _data30$Purchasable.Cost) || ((_data31 = data) === null || _data31 === void 0 ? void 0 : _data31.Cost) || (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable10 = formData.Purchasable) === null || _formData$Purchasable10 === void 0 ? void 0 : _formData$Purchasable10.Cost) || ""
    };
    data.Purchasable = purchasableDataPayload;
    if ((_data32 = data) !== null && _data32 !== void 0 && (_data32$prevFileNo = _data32.prevFileNo) !== null && _data32$prevFileNo !== void 0 && _data32$prevFileNo.includes("SA-")) {
      var _data33, _data33$prevFileNo, _data34, _data35, _data35$landInfo, _migratedData$project;
      console.log("inside SA-");
      const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
      data.department = (_data33 = data) !== null && _data33 !== void 0 && (_data33$prevFileNo = _data33.prevFileNo) !== null && _data33$prevFileNo !== void 0 && _data33$prevFileNo.includes("DA") ? "DA" : "AVP";
      data.tenantId = stateId, data.businessService = "BPA_MAPSUB_DA", data.landInfo = {
        ...((_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.landInfo),
        tenantId: stateId,
        address: {
          ...((_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$landInfo = _data35.landInfo) === null || _data35$landInfo === void 0 ? void 0 : _data35$landInfo.address),
          locality: {
            code: migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$project = migratedData.projectDetail) === null || _migratedData$project === void 0 ? void 0 : _migratedData$project.district
          }
        }
      };
      data.Purchasable = purchasableDataPayload;
      handleSubTabChange(1, data);
      return;
    }
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    const prevFileData = Digit.SessionStorage.get("PREV_FILE_DATA");
    if (watchnatureOfConstruction !== "New") {
      handleSubTabChange(1, {
        ...prevFileData,
        ...data,
        Purchasable: purchasableDataPayload
      });
      return;
    }
    if (id) {
      const _newFormData = {
        ...formData,
        ...data,
        Purchasable: purchasableDataPayload
      };
      console.log(formData, data, "editformdata");
      handleSubTabChange(1, _newFormData);
      return;
    }
    const newFormData = {
      landInfo: {
        ...(!id && ((fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.landInfo) || {}))
      },
      tenantId: stateId,
      land_Id: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id,
      documents: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents,
      descriptionOfLand: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand,
      nocDetails: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails,
      occupancy: (_data36 = data) === null || _data36 === void 0 ? void 0 : _data36.zoneType,
      totalProposedArea: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript7 = fastPASData.descriptionOfLand) === null || _fastPASData$descript7 === void 0 ? void 0 : _fastPASData$descript7.landArea
    };
    const selectedDesignsObj = data.selectedDesigns || {};
    const selectedKey = (_Object$entries2 = Object.entries(selectedDesignsObj)) === null || _Object$entries2 === void 0 ? void 0 : (_Object$entries2$find = _Object$entries2.find(([key, value]) => value)) === null || _Object$entries2$find === void 0 ? void 0 : _Object$entries2$find[0];
    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }
    data.selectedDesign = selectedDesign || null;
    data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition = fastPASData.additionalDetails) === null || _fastPASData$addition === void 0 ? void 0 : _fastPASData$addition.selectedOffice) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.selectedOffice) || "";
    data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition2 = fastPASData.additionalDetails) === null || _fastPASData$addition2 === void 0 ? void 0 : _fastPASData$addition2.selectedCity) || "";
    data.selectedUnit = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition3 = fastPASData.additionalDetails) === null || _fastPASData$addition3 === void 0 ? void 0 : _fastPASData$addition3.selectedUnit) || "";
    data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
    data.department = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || (prevFileData === null || prevFileData === void 0 ? void 0 : prevFileData.department) || applicationFlow;
    data.fastPASId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id;
    data.plotArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript8 = fastPASData.descriptionOfLand) === null || _fastPASData$descript8 === void 0 ? void 0 : _fastPASData$descript8.landArea, data = {
      ...data,
      ...newFormData,
      Purchasable: purchasableDataPayload
    };
    if (!id) {
      var _fastPASData$landInfo, _fastPASData$landInfo2, _fastPASData$landInfo3, _fastPASData$landInfo4, _fastPASData$landInfo5, _fastPASData$landInfo6, _fastPASData$landInfo7, _fastPASData$landInfo8, _fastPASData$landInfo9, _fastPASData$addition4, _fastPASData$addition5, _fastPASData$addition6, _fastPASData$document, _fastPASData$document2, _user$correspondenceA;
      data.plotNumbers = plotNumbers, data.applicantName = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo = fastPASData.landInfo) === null || _fastPASData$landInfo === void 0 ? void 0 : (_fastPASData$landInfo2 = _fastPASData$landInfo.owners) === null || _fastPASData$landInfo2 === void 0 ? void 0 : (_fastPASData$landInfo3 = _fastPASData$landInfo2[0]) === null || _fastPASData$landInfo3 === void 0 ? void 0 : _fastPASData$landInfo3.name) || "";
      data.applicantEmailId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo4 = fastPASData.landInfo) === null || _fastPASData$landInfo4 === void 0 ? void 0 : (_fastPASData$landInfo5 = _fastPASData$landInfo4.owners) === null || _fastPASData$landInfo5 === void 0 ? void 0 : (_fastPASData$landInfo6 = _fastPASData$landInfo5[0]) === null || _fastPASData$landInfo6 === void 0 ? void 0 : _fastPASData$landInfo6.emailId) || "";
      data.aplicantMobileNumber = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo7 = fastPASData.landInfo) === null || _fastPASData$landInfo7 === void 0 ? void 0 : (_fastPASData$landInfo8 = _fastPASData$landInfo7.owners) === null || _fastPASData$landInfo8 === void 0 ? void 0 : (_fastPASData$landInfo9 = _fastPASData$landInfo8[0]) === null || _fastPASData$landInfo9 === void 0 ? void 0 : _fastPASData$landInfo9.mobileNumber) || "";
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition4 = fastPASData.additionalDetails) === null || _fastPASData$addition4 === void 0 ? void 0 : _fastPASData$addition4.selectedOffice) || "";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition5 = fastPASData.additionalDetails) === null || _fastPASData$addition5 === void 0 ? void 0 : _fastPASData$addition5.selectedCity) || "";
      data.selectedUnit = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition6 = fastPASData.additionalDetails) === null || _fastPASData$addition6 === void 0 ? void 0 : _fastPASData$addition6.selectedUnit) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.fastPASId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id;
      data.signatureId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$document = fastPASData.documents) === null || _fastPASData$document === void 0 ? void 0 : (_fastPASData$document2 = _fastPASData$document.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === "signature")[0]) === null || _fastPASData$document2 === void 0 ? void 0 : _fastPASData$document2.fileStoreId) || null;
      data.licenseeName = user === null || user === void 0 ? void 0 : user.name, data.licenseeLicenceNumber = user === null || user === void 0 ? void 0 : user.registrationNumber;
      data.licenseeMobileNumber = user === null || user === void 0 ? void 0 : user.mobileNumber;
      data.licenseeEmailId = user === null || user === void 0 ? void 0 : user.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA = user.correspondenceAddress) === null || _user$correspondenceA === void 0 ? void 0 : _user$correspondenceA.address;
    }
    data.businessService = applicationFlow === "DA" || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? "BPA_PURCHASEFAR_DA" : "BPA_PURCHASEFAR_AVP";
    data.Purchasable = purchasableDataPayload;
    handleSubTabChange(1, data);
  };
  if (applicationFlow === null && !isEmployee && !(formData !== null && formData !== void 0 && formData.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction / Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: SortingAlphabatically(selfApprovalnatureOfConstruction),
    type: "selectInput",
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchnatureOfConstruction && watchnatureOfConstruction !== "New" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Prev File No"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    maxLength: 23,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    disabled: isEmployee,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handlePrevFileSearch(getValues("prevFileNo"))
  })) : /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  }))), watchnatureOfConstruction === "Revalidation" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Previous Sanction Date"),
    placeholder: t("Select Prev Sanction Date"),
    name: "prevSanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Current Validity Date"),
    placeholder: t("Select Date"),
    name: "currValidityDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.currValidityDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityProposed),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Type",
    control: control,
    placeholder: t("Select Scheme Type"),
    name: "descriptionOfLand.schemeType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.schemeType,
    type: "textInput",
    disabled: watchPlotArea || isEmployee
  })), watchPlotArea !== "Non Scheme" ? /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(proposedSiteOptions === null || proposedSiteOptions === void 0 ? void 0 : proposedSiteOptions.filter(e => (e === null || e === void 0 ? void 0 : e.name) !== "Others")),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposal",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposal,
    type: "selectInput",
    mandatory: schemeType,
    validation: {
      required: {
        value: schemeType,
        message: "This field is required"
      }
    },
    disabled: !!watchProposal || isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), watchPlotArea !== "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript9 = fastPASData.descriptionOfLand) === null || _fastPASData$descript9 === void 0 ? void 0 : _fastPASData$descript9.schemeName) || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    disabled: isEmployee,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark || isEmployee,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Plot Area as per Site (in Sqmt.)",
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "plotArea",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotArea,
    type: "textInput",
    disabled: watchPlotArea || isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker",
    disabled: isEmployee
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput",
    disabled: isEmployee
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of Plots"),
    name: "noOfPlots",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput",
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (_Array$from = Array.from({
    length: fullRows
  })) === null || _Array$from === void 0 ? void 0 : _Array$from.map((_, rowIndex) => {
    var _Array$from2;
    return /*#__PURE__*/React__default.createElement(Row$1, {
      key: rowIndex
    }, (_Array$from2 = Array.from({
      length: 3
    })) === null || _Array$from2 === void 0 ? void 0 : _Array$from2.map((_, colIndex) => {
      var _formData$plotNumbers2;
      const plotIndex = rowIndex * 3 + colIndex;
      return /*#__PURE__*/React__default.createElement(Col, {
        key: `plot-${plotIndex}`
      }, /*#__PURE__*/React__default.createElement(InputWrapper, {
        control: control,
        placeholder: t("Enter Plot No"),
        name: `plotNumbers.${plotIndex}`,
        mandatory: true,
        hasLabel: false,
        maxLength: 15,
        defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plotIndex]) || "",
        type: "textInput",
        disabled: isEmployee
      }));
    }));
  }), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, (_Array$from3 = Array.from({
    length: remainingPlots
  })) === null || _Array$from3 === void 0 ? void 0 : _Array$from3.map((_, colIndex) => {
    var _formData$plotNumbers3;
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      maxLength: 15,
      hasLabel: false,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers3 = formData.plotNumbers) === null || _formData$plotNumbers3 === void 0 ? void 0 : _formData$plotNumbers3[plotIndex]) || "",
      type: "textInput",
      disabled: isEmployee
    }));
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    data: yesOrNo,
    disabled: isEmployee,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    disabled: isEmployee,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput"
  })))), watchisSpecialProject === "yes" && watchProjectType === "Building Design as per standard Drawing" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    style: {
      marginBottom: "16px",
      background: "#1F4A7C"
    },
    onClick: () => setShowDesigns(true)
  }, "View Standard Designs")), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: t("Standard Designs"),
    dataOpen: showDesigns,
    onClose: () => setShowDesigns(false)
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container",
    sx: {
      marginTop: 2
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, "Standard Designs"), /*#__PURE__*/React__default.createElement(Table$3, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(col => /*#__PURE__*/React__default.createElement("td", {
    key: col.id
  }, /*#__PURE__*/React__default.createElement("b", null, col.label))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, t("Select"))))), /*#__PURE__*/React__default.createElement("tbody", null, (tableData === null || tableData === void 0 ? void 0 : tableData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 1,
    align: "center"
  }, "No Standard Designs Available")) : tableData === null || tableData === void 0 ? void 0 : tableData.map((row, idx) => /*#__PURE__*/React__default.createElement("tr", {
    key: row.code
  }, /*#__PURE__*/React__default.createElement("td", null, row.srNo), /*#__PURE__*/React__default.createElement("td", null, row.area), /*#__PURE__*/React__default.createElement("td", null, row.dimension), /*#__PURE__*/React__default.createElement("td", null, row.type), /*#__PURE__*/React__default.createElement("td", null, row.construction), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Controller, {
    name: `selectedDesigns.${row.code}`,
    control: control,
    defaultValue: false,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, field, {
      checked: !!field.value,
      onChange: e => field.onChange(e.target.checked)
    }))
  }))))))))))), checkedDesigns && ((_Object$keys = Object.keys(checkedDesigns)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container",
    sx: {
      marginTop: 2,
      marginBottom: 2,
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption",
    style: {
      width: "172px"
    }
  }, "Selected Designs"), /*#__PURE__*/React__default.createElement(Table$3, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Sr No")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Area (sqm)")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Dimension")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Type/Design")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, "Construction (GF/FF/SF)")))), /*#__PURE__*/React__default.createElement("tbody", null, (_Object$entries3 = Object.entries(checkedDesigns)) === null || _Object$entries3 === void 0 ? void 0 : (_Object$entries3$filt = _Object$entries3.filter(([key, value]) => value)) === null || _Object$entries3$filt === void 0 ? void 0 : _Object$entries3$filt.map(([key]) => {
    const design = standardDesigns === null || standardDesigns === void 0 ? void 0 : standardDesigns.find(item => String(item === null || item === void 0 ? void 0 : item.code) === String(key));
    if (!design) return null;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: design.code
    }, /*#__PURE__*/React__default.createElement("td", null, design.code), /*#__PURE__*/React__default.createElement("td", null, design.areaSqm || "-"), /*#__PURE__*/React__default.createElement("td", null, design.dimension || "-"), /*#__PURE__*/React__default.createElement("td", null, design.typeDesign || "-"), /*#__PURE__*/React__default.createElement("td", null, design.construction ? `GF: ${design.construction.GF}, FF: ${design.construction.FF}, SF: ${design.construction.SF}` : "-"));
  })))))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number of floor permissible"),
    placeholder: t("Enter floors"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    disabled: isEmployee,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript10 = fastPASData.descriptionOfLand) === null || _fastPASData$descript10 === void 0 ? void 0 : _fastPASData$descript10.landArea) < 40000 && watchlandUseType !== "Residential" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" ? /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Not authorized for Self Certification Approval of Map ", /*#__PURE__*/React__default.createElement("span", null, "*")) : watchNeedComp === "yes" && /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Kindly apply on Compounding Module ", /*#__PURE__*/React__default.createElement("span", null, "*"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Purchasable Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basic FAR Factor"),
    control: control,
    name: "basicFAR",
    mandatory: true,
    placeholder: t("Enter Basic FAR Factor"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
    type: "specialChar",
    onlyNumeric: true,
    allowedChars: ".",
    decimalScale: 2,
    formatOnBlur: true,
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Purchasable FAR Factor"),
    control: control,
    name: "purchasableFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    type: "specialChar",
    disabled: isEmployee,
    onlyNumeric: true,
    allowedChars: ".",
    decimalScale: 2,
    formatOnBlur: true,
    placeholder: t("Enter Purchasable FAR Factor"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer bg-white"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I hereby declare that all the details and information provided in this form are true and correct to the best of my knowledge and belief.", /*#__PURE__*/React__default.createElement("br", null), " I understand that any false or misleading information may result in rejection of the application or other appropriate action.")
  })))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: !declarationChecked || watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" || watchNeedComp === "yes" || watchContainFar === "yes"
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const SubStep3$5 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _Digit$UserService$ge, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$landInfo15, _formData$landInfo15$, _formData$landInfo15$2, _formData$landInfo16, _formData$landInfo16$, _formData$landInfo16$2, _formData$structuralI, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    }
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !(district !== null && district !== void 0 && (_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  }));
  const watchState = watch("landInfo.owners.[0].correspondenceAddress.state");
  const watchInputOnGST = watch("landInfo.owners.[0].inputonGST");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const [watchCategoryType, watchCertNo, watchValidity] = watch(["professionaldetails.consultantCategory", "professionaldetails.certificateNo", "professionaldetails.validupto"]);
  console.log("FORMDATASTATS", formData, userInfo);
  useEffect(async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      var _userResponse$user;
      const userResponse = await Digit.UserService.userSearch(tenantId, {
        uuid: [uuid]
      }, {});
      const fetchedUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$user = userResponse.user) === null || _userResponse$user === void 0 ? void 0 : _userResponse$user[0];
      setUser(fetchedUser);
      if (fetchedUser) {
        var _fetchedUser$roles, _fetchedUser$roles$fi, _fetchedUser$roles$fi2, _fetchedUser$validUpt;
        const category = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$roles = fetchedUser.roles) === null || _fetchedUser$roles === void 0 ? void 0 : (_fetchedUser$roles$fi = _fetchedUser$roles.filter(e => e.code !== "CITIZEN")) === null || _fetchedUser$roles$fi === void 0 ? void 0 : (_fetchedUser$roles$fi2 = _fetchedUser$roles$fi[0]) === null || _fetchedUser$roles$fi2 === void 0 ? void 0 : _fetchedUser$roles$fi2.name;
        setValue("professionaldetails.consultantCategory", category);
        setValue("professionaldetails.certificateNo", fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.registrationNumber);
        const validUptoDate = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$validUpt = fetchedUser.validUpto) === null || _fetchedUser$validUpt === void 0 ? void 0 : _fetchedUser$validUpt.slice(0, 10);
        const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
        setValue("professionaldetails.validupto", formattedDate);
      }
    }
  }, []);
  useEffect(async () => {
    var _users$filter;
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"],
      pageSize: "100000"
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = (_users$filter = users.filter(user => user.uuid === formData.professionaldetails.engineerUuid)) === null || _users$filter === void 0 ? void 0 : _users$filter[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr === null || engineersArr === void 0 ? void 0 : engineersArr.filter(e => (e === null || e === void 0 ? void 0 : e.name) === watchStructuralName);
    if ((selectEng === null || selectEng === void 0 ? void 0 : selectEng.length) > 0) {
      var _selectedEngineer$val, _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const validUptoDate = selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$val = selectedEngineer.validUpto) === null || _selectedEngineer$val === void 0 ? void 0 : _selectedEngineer$val.slice(0, 10);
      const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchCategoryType
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.certificateNo
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchValidity
  }))), (_user$validUpto => {
    const validUpto = user === null || user === void 0 ? void 0 : (_user$validUpto = user.validUpto) === null || _user$validUpto === void 0 ? void 0 : _user$validUpto.slice(0, 10);
    if (validUpto) {
      const [dd, mm, yyyy] = validUpto.split("-");
      const validUptoDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      const today = new Date();
      validUptoDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      console.log("validUptoDate", validUptoDate - today);
      if (validUptoDate < today) {
        return /*#__PURE__*/React__default.createElement(Col, {
          md: 12
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "text-red important-note"
        }, "Note: The LTP license validity has expired. Please update your license."));
      }
    }
    return null;
  })())), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Do you want to take input on GST")}`,
    name: "landInfo.owners.[0].inputonGST",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo15 = formData.landInfo) === null || _formData$landInfo15 === void 0 ? void 0 : (_formData$landInfo15$ = _formData$landInfo15.owners) === null || _formData$landInfo15$ === void 0 ? void 0 : (_formData$landInfo15$2 = _formData$landInfo15$[0]) === null || _formData$landInfo15$2 === void 0 ? void 0 : _formData$landInfo15$2.inputonGST,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchInputOnGST === "yes" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.value) === "yes" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.code) === "Y" || (watchInputOnGST === null || watchInputOnGST === void 0 ? void 0 : watchInputOnGST.code) === "YES") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter GST No"),
    control: control,
    placeholder: t("GST No"),
    type: "textInput",
    name: "landInfo.owners.[0].gstNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo16 = formData.landInfo) === null || _formData$landInfo16 === void 0 ? void 0 : (_formData$landInfo16$ = _formData$landInfo16.owners) === null || _formData$landInfo16$ === void 0 ? void 0 : (_formData$landInfo16$2 = _formData$landInfo16$[0]) === null || _formData$landInfo16$2 === void 0 ? void 0 : _formData$landInfo16$2.gstNumber,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("GSTNo"),
        message: "Please enter valid GST No"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI = formData.structuralInfo) === null || _formData$structuralI === void 0 ? void 0 : _formData$structuralI.name,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.licenseNumber,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.validupto,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : (_formData$structuralI5 = _formData$structuralI4.permanentAddress) === null || _formData$structuralI5 === void 0 ? void 0 : _formData$structuralI5.address,
    type: "textInput",
    disabled: true,
    maxLength: 50
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep2$3 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$plotInfo, _formData$plotInfo2;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  const watchTotalBuildUpArea = watch("totalBuildUpArea");
  useEffect(() => {
    setValue("plotInfo.plotArea", formData === null || formData === void 0 ? void 0 : formData.plotArea);
    setValue("plotInfo.builtupArea", formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
  }, []);
  const onSubmit = data => {
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), formData !== null && formData !== void 0 && formData.edcrNumber ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area as per drawing (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area as per drawing"),
    name: "plotInfo.plotArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.plotArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Total Proposed Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Total Proposed Built up Area"),
    name: "totalBuildUpArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.builtupArea),
    type: "textInput",
    disabled: isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step4$2 = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule,
  nextTab
}) => {
  var _formData$documents;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const drawingPdf = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(e => (e === null || e === void 0 ? void 0 : e.documentType) === "drawingPdf")) || [];
  const [drawingDetail, setDrawingDetail] = useState(drawingPdf || []);
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  console.log(drawingDetail, formData === null || formData === void 0 ? void 0 : formData.documents, drawingPdf, "drawingDetail");
  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "viewPdf",
    label: "View Drawing",
    accessor: "documentType"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    ref: formRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), /*#__PURE__*/React__default.createElement(InfoBox$1, {
    style: {
      fontSize: "14px",
      margin: "10px"
    }
  }, "I hereby declare that the map has been prepared as per the prevailing building byelaws and the map has been duly digitally signed by me."), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details  table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, drawingPdf === null || drawingPdf === void 0 ? void 0 : drawingPdf.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Submission ", index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row !== null && row !== void 0 && row.fileStoreId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(row.fileStoreId, setIsPreviewLoading)
  }) : "N/A")))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit")))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "button",
    onClick: () => {
      if (typeof handleTabChange === "function") {
        handleTabChange(nextTab !== undefined ? nextTab : 4);
      }
    },
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const EmpMapPurchasablePortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray,
  urlFormType
}) => {
  var _Digit, _Digit2, _userRolesArray$2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code) === "JE";
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    nocRemarksData,
    callNocDetailsAPI,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callPfarDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    pFarDetailsData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    handleNoWorkflowPFAR,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isPurchasbleReq,
    currentFormData,
    handleNoWorkflowCompounding,
    handleGetSiteInspectionById,
    callDocumentDetailsAPI,
    handleGenerateIntimationLetter,
    handleViewIntimationLetter,
    isLoadingLetter
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  const isCTP = userRolesArray === null || userRolesArray === void 0 ? void 0 : userRolesArray.some(role => role.code === "CTP" || role.name === "Chief Town Planner");
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async nextTabNo => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (isCompounding) {
      if (activeTab === 2) {
        return /*#__PURE__*/React__default.createElement(CompoundingChecklist, {
          formData: params,
          handleTabChange: handleTabChange,
          role: "EMPLOYEE",
          handleNoWorkflowCompounding: handleNoWorkflowCompounding
        });
      }
      return null;
    }
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$6, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$3, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$5, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            docType: "mandatory",
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            developerRemarks: developerRemarksDocument,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            setError: setError,
            ComposableComponent: props => {
              var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3, _documentRemarksData$4, _documentRemarksData$5;
              return /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
                title: "Remarks Details",
                label: "Recommendation",
                name: "recommendation",
                options: SortingAlphabatically(siteInspRecommendation),
                defaultValue: dataRecommendationDocument,
                extraLabel: "Remarks",
                setDeveloperRemarks: setDeveloperRemarksDocument,
                developerRemarks: developerRemarksDocument ? developerNocRemarks : Array.isArray(documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0 ? documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$ = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$[documentRemarksData.DetailDataRemarks.length - 1]) === null || _documentRemarksData$2 === void 0 ? void 0 : (_documentRemarksData$3 = _documentRemarksData$2.documentDetails) === null || _documentRemarksData$3 === void 0 ? void 0 : _documentRemarksData$3.developerRemarks : documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$4 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$4 === void 0 ? void 0 : (_documentRemarksData$5 = _documentRemarksData$4.documentDetails) === null || _documentRemarksData$5 === void 0 ? void 0 : _documentRemarksData$5.developerRemarks,
                setDataRecommendation: setDataRecommendationDocument
              }, props, {
                error: error,
                setError: setError
              }));
            }
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            type: "documentDetails"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional",
            callDocumentDetailsAPI: callDrawingDetailsAPI
          }));
        default:
          return null;
      }
    } else if (activeTab === 2) {
      var _formData$additionalD, _params$additionalDet;
      return /*#__PURE__*/React__default.createElement(EmpIdentifyNoc, {
        formData: {
          ...(formData || {}),
          ...(params || {}),
          nocDetails: (params === null || params === void 0 ? void 0 : params.nocDetails) || (formData === null || formData === void 0 ? void 0 : formData.nocDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.nocDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet = params.additionalDetails) === null || _params$additionalDet === void 0 ? void 0 : _params$additionalDet.nocDetails),
          additionalDetails: {
            ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
            ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {})
          }
        },
        tenantId: tenantId,
        handleNoWorkflowNoc: handleNoWorkflowNoc,
        isJE: isJE,
        currentFormData: currentFormData
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step4$2, {
        formData: formData,
        handleTabChange: handleTabChange,
        nextTab: 4,
        isEmployee: !isCitizen
      }));
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BasicSiteInspectionReport, {
        formData: params,
        setCurrentTab: handleTabChange,
        setUpdatedInspectionReportData: setUpdatedInspectionReportData,
        callInspectionDetailsAPI: callInspectionDetailsAPI,
        userRolesArray: userRolesArray,
        onSelect: onSelect,
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks,
        type: "inspectionDetails",
        formData: formData
      }));
    } else if (activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PurchasableFARInfo, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        handleNoWorkflowPFAR: handleNoWorkflowPFAR,
        isJE: isJE,
        handleGetSiteInspectionById: handleGetSiteInspectionById,
        workflowHistory: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error,
        isCTP: isCTP,
        handleGenerateIntimationLetter: handleGenerateIntimationLetter,
        isLoadingLetter: isLoadingLetter,
        handleViewIntimationLetter: handleViewIntimationLetter
      }), /*#__PURE__*/React__default.createElement(PfarRemarks, {
        title: "Remark Details",
        name: "recommendation",
        defaultValue: dataRecommendation,
        extraLabel: "Remarks",
        setDeveloperRemarks: setDeveloperRemarks,
        developerRemarks: developerRemarks,
        type: "remarkDetails",
        buttonshow: true,
        onSaveClick: callPfarDetailsAPI
      }), /*#__PURE__*/React__default.createElement(PfarDetailsTable, {
        detailData: pFarDetailsData === null || pFarDetailsData === void 0 ? void 0 : pFarDetailsData.DetailDataRemarks
      }));
    } else if (activeTab === 6) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : formData.status) === "APPLY_FOR_DSC" && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "FAR",
        pFARLetter: true
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), ((_formData$drawingDeta, _formData$drawingDeta2, _formData$status) => {
        const lastDrawing = formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : _formData$drawingDeta[(formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta2 = formData.drawingDetail) === null || _formData$drawingDeta2 === void 0 ? void 0 : _formData$drawingDeta2.length) - 1];
        const isDrawingSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfDscEmp) === true || (formData === null || formData === void 0 ? void 0 : formData.IsSanctionDrawing) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.sanctionDrawingUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfUrl) || Boolean(lastDrawing === null || lastDrawing === void 0 ? void 0 : lastDrawing.signedPdfId));
        const isApprovalSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) === true || Boolean(formData === null || formData === void 0 ? void 0 : formData.ApprovalsignedPdfUrl) || Boolean(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl));
        const isDscStage = (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) || (formData === null || formData === void 0 ? void 0 : formData.status) === "EE_TP_AFTER_PAYMENT" || (formData === null || formData === void 0 ? void 0 : formData.status) === "VC_AFTER_PAYMENT";
        if (!isDscStage || isApprovalSignedByEmp && isDrawingSignedByEmp) {
          return /*#__PURE__*/React__default.createElement(SubmitButton, {
            handleSubmit: handleSubmit,
            isLoading: updateApiCall.isLoading
          });
        } else {
          return /*#__PURE__*/React__default.createElement(NewsTicker, {
            textForNews: "Please make a digital sign on sanction letter and approval letter"
          });
        }
      })());
    } else if (activeTab === 7) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), isCompounding && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Compounding Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "NOC Status"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Site Inspection"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Purchasable FAR"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    setIsPreviewLoading: setIsPreviewLoading,
    setIframeSrc: setIframeSrc,
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const NOCTakeAction = ({
  formData: propsFormData,
  onNocUpdate
}) => {
  var _location$pathname, _Digit$UserService$ge, _currentBpaObj$nocDet, _currentBpaObj$nocDet2, _storedData$nocDetail, _storedData$nocDetail2, _storedData$BPA, _storedData$BPA$, _storedData$BPA2, _storedData$BPA2$, _storedData$BPA2$$noc, _storedData$BPA3, _storedData$BPA3$, _storedData$BPA3$$noc, _propsFormData$nocDet4, _propsFormData$nocDet5, _propsFormData$BPA5, _propsFormData$BPA5$, _propsFormData$BPA6, _propsFormData$BPA6$, _propsFormData$BPA6$$, _propsFormData$BPA7, _propsFormData$BPA7$, _propsFormData$BPA7$$;
  const {
    t
  } = useTranslation();
  const {
    id
  } = useParams();
  const location = useLocation();
  const history = useHistory();
  const isStandalonePage = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("/nocApplications");
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  console.log("authToken", authToken);
  const [showNocSavedModal, setShowNocSavedModal] = useState(false);
  const getBpa = data => Array.isArray(data === null || data === void 0 ? void 0 : data.BPA) && data.BPA.length > 0 ? data.BPA[0] : data;
  const getFirstNonEmptyList = (...lists) => {
    for (const list of lists) {
      if (Array.isArray(list) && list.length > 0) return list;
    }
    return [];
  };
  const sessionData = propsFormData || Digit.SessionStorage.get("nocAppData");
  const [storedData, setStoredData] = useState(sessionData);
  const [uploadingRowId, setUploadingRowId] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const skipMergeRef = useRef(false);
  useEffect(() => {
    if (skipMergeRef.current) {
      skipMergeRef.current = false;
      return;
    }
    if (propsFormData) {
      setStoredData(prev => {
        var _incomingBpa$nocDetai, _incomingBpa$nocDetai2, _propsFormData$nocDet, _propsFormData$nocDet2, _propsFormData$BPA, _propsFormData$BPA$, _propsFormData$BPA2, _propsFormData$BPA2$, _propsFormData$BPA2$$, _propsFormData$BPA3, _propsFormData$BPA3$, _propsFormData$BPA3$$, _incomingBpa$nocDetai3, _propsFormData$nocDet3, _propsFormData$BPA4, _propsFormData$BPA4$, _propsFormData$BPA4$$, _localBpa$nocDetails, _localBpa$nocDetails2, _prev$nocDetails, _prev$nocDetails2, _prev$BPA, _prev$BPA$, _prev$BPA2, _prev$BPA2$, _prev$BPA2$$nocDetail, _prev$BPA3, _prev$BPA3$, _prev$BPA3$$nocDetail;
        if (!prev) return propsFormData;
        const incomingBpa = getBpa(propsFormData);
        const localBpa = getBpa(prev);
        const incomingNocList = getFirstNonEmptyList(incomingBpa === null || incomingBpa === void 0 ? void 0 : incomingBpa.nocList, incomingBpa === null || incomingBpa === void 0 ? void 0 : (_incomingBpa$nocDetai = incomingBpa.nocDetails) === null || _incomingBpa$nocDetai === void 0 ? void 0 : _incomingBpa$nocDetai.nocListApplicantDoc, incomingBpa === null || incomingBpa === void 0 ? void 0 : (_incomingBpa$nocDetai2 = incomingBpa.nocDetails) === null || _incomingBpa$nocDetai2 === void 0 ? void 0 : _incomingBpa$nocDetai2.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet = propsFormData.nocDetails) === null || _propsFormData$nocDet === void 0 ? void 0 : _propsFormData$nocDet.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet2 = propsFormData.nocDetails) === null || _propsFormData$nocDet2 === void 0 ? void 0 : _propsFormData$nocDet2.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA = propsFormData.BPA) === null || _propsFormData$BPA === void 0 ? void 0 : (_propsFormData$BPA$ = _propsFormData$BPA[0]) === null || _propsFormData$BPA$ === void 0 ? void 0 : _propsFormData$BPA$.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA2 = propsFormData.BPA) === null || _propsFormData$BPA2 === void 0 ? void 0 : (_propsFormData$BPA2$ = _propsFormData$BPA2[0]) === null || _propsFormData$BPA2$ === void 0 ? void 0 : (_propsFormData$BPA2$$ = _propsFormData$BPA2$.nocDetails) === null || _propsFormData$BPA2$$ === void 0 ? void 0 : _propsFormData$BPA2$$.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA3 = propsFormData.BPA) === null || _propsFormData$BPA3 === void 0 ? void 0 : (_propsFormData$BPA3$ = _propsFormData$BPA3[0]) === null || _propsFormData$BPA3$ === void 0 ? void 0 : (_propsFormData$BPA3$$ = _propsFormData$BPA3$.nocDetails) === null || _propsFormData$BPA3$$ === void 0 ? void 0 : _propsFormData$BPA3$$.nocList);
        const incomingApplicantDocs = getFirstNonEmptyList(incomingBpa === null || incomingBpa === void 0 ? void 0 : (_incomingBpa$nocDetai3 = incomingBpa.nocDetails) === null || _incomingBpa$nocDetai3 === void 0 ? void 0 : _incomingBpa$nocDetai3.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet3 = propsFormData.nocDetails) === null || _propsFormData$nocDet3 === void 0 ? void 0 : _propsFormData$nocDet3.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA4 = propsFormData.BPA) === null || _propsFormData$BPA4 === void 0 ? void 0 : (_propsFormData$BPA4$ = _propsFormData$BPA4[0]) === null || _propsFormData$BPA4$ === void 0 ? void 0 : (_propsFormData$BPA4$$ = _propsFormData$BPA4$.nocDetails) === null || _propsFormData$BPA4$$ === void 0 ? void 0 : _propsFormData$BPA4$$.nocListApplicantDoc);
        const localNocList = getFirstNonEmptyList(localBpa === null || localBpa === void 0 ? void 0 : localBpa.nocList, localBpa === null || localBpa === void 0 ? void 0 : (_localBpa$nocDetails = localBpa.nocDetails) === null || _localBpa$nocDetails === void 0 ? void 0 : _localBpa$nocDetails.nocListApplicantDoc, localBpa === null || localBpa === void 0 ? void 0 : (_localBpa$nocDetails2 = localBpa.nocDetails) === null || _localBpa$nocDetails2 === void 0 ? void 0 : _localBpa$nocDetails2.nocList, prev === null || prev === void 0 ? void 0 : prev.nocList, prev === null || prev === void 0 ? void 0 : (_prev$nocDetails = prev.nocDetails) === null || _prev$nocDetails === void 0 ? void 0 : _prev$nocDetails.nocListApplicantDoc, prev === null || prev === void 0 ? void 0 : (_prev$nocDetails2 = prev.nocDetails) === null || _prev$nocDetails2 === void 0 ? void 0 : _prev$nocDetails2.nocList, prev === null || prev === void 0 ? void 0 : (_prev$BPA = prev.BPA) === null || _prev$BPA === void 0 ? void 0 : (_prev$BPA$ = _prev$BPA[0]) === null || _prev$BPA$ === void 0 ? void 0 : _prev$BPA$.nocList, prev === null || prev === void 0 ? void 0 : (_prev$BPA2 = prev.BPA) === null || _prev$BPA2 === void 0 ? void 0 : (_prev$BPA2$ = _prev$BPA2[0]) === null || _prev$BPA2$ === void 0 ? void 0 : (_prev$BPA2$$nocDetail = _prev$BPA2$.nocDetails) === null || _prev$BPA2$$nocDetail === void 0 ? void 0 : _prev$BPA2$$nocDetail.nocListApplicantDoc, prev === null || prev === void 0 ? void 0 : (_prev$BPA3 = prev.BPA) === null || _prev$BPA3 === void 0 ? void 0 : (_prev$BPA3$ = _prev$BPA3[0]) === null || _prev$BPA3$ === void 0 ? void 0 : (_prev$BPA3$$nocDetail = _prev$BPA3$.nocDetails) === null || _prev$BPA3$$nocDetail === void 0 ? void 0 : _prev$BPA3$$nocDetail.nocList);
        const nocListForMerge = getFirstNonEmptyList(incomingNocList, localNocList);
        const mergedNocList = nocListForMerge.map((incoming, i) => {
          const applicantMatch = Array.isArray(incomingApplicantDocs) ? incomingApplicantDocs.find(a => a.id && a.id === incoming.id || a.applicationNo && a.applicationNo === incoming.applicationNo || a.nocName && incoming.nocName && a.nocName === incoming.nocName || a.nocType && incoming.nocType && a.nocType === incoming.nocType) || incomingApplicantDocs[i] : null;
          const localMatch = localNocList.find(l => l.id && l.id === incoming.id || l.applicationNo && l.applicationNo === incoming.applicationNo);
          const localHasDoc = Array.isArray(localMatch === null || localMatch === void 0 ? void 0 : localMatch.documents) && localMatch.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          const incomingHasDoc = Array.isArray(incoming === null || incoming === void 0 ? void 0 : incoming.documents) && incoming.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          const applicantHasDoc = Array.isArray(applicantMatch === null || applicantMatch === void 0 ? void 0 : applicantMatch.documents) && applicantMatch.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          const bestDocuments = localHasDoc ? localMatch.documents : incomingHasDoc ? incoming.documents : applicantHasDoc ? applicantMatch.documents : incoming.documents;
          return {
            ...incoming,
            documents: bestDocuments
          };
        });
        const mergedApplicantDocs = (Array.isArray(incomingApplicantDocs) && incomingApplicantDocs.length > 0 ? incomingApplicantDocs : mergedNocList).map((appItem, i) => {
          const matched = mergedNocList.find(m => m.id && m.id === appItem.id || m.applicationNo && m.applicationNo === appItem.applicationNo || m.nocName && appItem.nocName && m.nocName === appItem.nocName) || mergedNocList[i];
          if (matched && Array.isArray(matched.documents) && matched.documents.length > 0) {
            return {
              ...appItem,
              documents: matched.documents
            };
          }
          return appItem;
        });
        const updatedData = {
          ...incomingBpa,
          nocDetails: {
            ...((localBpa === null || localBpa === void 0 ? void 0 : localBpa.nocDetails) || {}),
            ...((incomingBpa === null || incomingBpa === void 0 ? void 0 : incomingBpa.nocDetails) || {}),
            nocListApplicantDoc: mergedApplicantDocs
          }
        };
        delete updatedData.nocList;
        if (Array.isArray(propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.BPA)) {
          return {
            ...propsFormData,
            BPA: [updatedData, ...propsFormData.BPA.slice(1)],
            ...updatedData
          };
        }
        return {
          ...propsFormData,
          ...updatedData
        };
      });
    }
  }, [propsFormData]);
  const currentBpaObj = getBpa(storedData) || getBpa(propsFormData) || {};
  const nocList = getFirstNonEmptyList(currentBpaObj === null || currentBpaObj === void 0 ? void 0 : currentBpaObj.nocList, currentBpaObj === null || currentBpaObj === void 0 ? void 0 : (_currentBpaObj$nocDet = currentBpaObj.nocDetails) === null || _currentBpaObj$nocDet === void 0 ? void 0 : _currentBpaObj$nocDet.nocListApplicantDoc, currentBpaObj === null || currentBpaObj === void 0 ? void 0 : (_currentBpaObj$nocDet2 = currentBpaObj.nocDetails) === null || _currentBpaObj$nocDet2 === void 0 ? void 0 : _currentBpaObj$nocDet2.nocList, storedData === null || storedData === void 0 ? void 0 : storedData.nocList, storedData === null || storedData === void 0 ? void 0 : (_storedData$nocDetail = storedData.nocDetails) === null || _storedData$nocDetail === void 0 ? void 0 : _storedData$nocDetail.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$nocDetail2 = storedData.nocDetails) === null || _storedData$nocDetail2 === void 0 ? void 0 : _storedData$nocDetail2.nocList, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA = storedData.BPA) === null || _storedData$BPA === void 0 ? void 0 : (_storedData$BPA$ = _storedData$BPA[0]) === null || _storedData$BPA$ === void 0 ? void 0 : _storedData$BPA$.nocList, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA2 = storedData.BPA) === null || _storedData$BPA2 === void 0 ? void 0 : (_storedData$BPA2$ = _storedData$BPA2[0]) === null || _storedData$BPA2$ === void 0 ? void 0 : (_storedData$BPA2$$noc = _storedData$BPA2$.nocDetails) === null || _storedData$BPA2$$noc === void 0 ? void 0 : _storedData$BPA2$$noc.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA3 = storedData.BPA) === null || _storedData$BPA3 === void 0 ? void 0 : (_storedData$BPA3$ = _storedData$BPA3[0]) === null || _storedData$BPA3$ === void 0 ? void 0 : (_storedData$BPA3$$noc = _storedData$BPA3$.nocDetails) === null || _storedData$BPA3$$noc === void 0 ? void 0 : _storedData$BPA3$$noc.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet4 = propsFormData.nocDetails) === null || _propsFormData$nocDet4 === void 0 ? void 0 : _propsFormData$nocDet4.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet5 = propsFormData.nocDetails) === null || _propsFormData$nocDet5 === void 0 ? void 0 : _propsFormData$nocDet5.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA5 = propsFormData.BPA) === null || _propsFormData$BPA5 === void 0 ? void 0 : (_propsFormData$BPA5$ = _propsFormData$BPA5[0]) === null || _propsFormData$BPA5$ === void 0 ? void 0 : _propsFormData$BPA5$.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA6 = propsFormData.BPA) === null || _propsFormData$BPA6 === void 0 ? void 0 : (_propsFormData$BPA6$ = _propsFormData$BPA6[0]) === null || _propsFormData$BPA6$ === void 0 ? void 0 : (_propsFormData$BPA6$$ = _propsFormData$BPA6$.nocDetails) === null || _propsFormData$BPA6$$ === void 0 ? void 0 : _propsFormData$BPA6$$.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA7 = propsFormData.BPA) === null || _propsFormData$BPA7 === void 0 ? void 0 : (_propsFormData$BPA7$ = _propsFormData$BPA7[0]) === null || _propsFormData$BPA7$ === void 0 ? void 0 : (_propsFormData$BPA7$$ = _propsFormData$BPA7$.nocDetails) === null || _propsFormData$BPA7$$ === void 0 ? void 0 : _propsFormData$BPA7$$.nocList);
  const getUploadedFileStoreId = (item, idx) => {
    var _rawNocLetter, _currentBpaObj$nocDet3, _currentBpaObj$nocDet4, _propsFormData$BPA8, _propsFormData$BPA8$, _propsFormData$BPA8$$, _propsFormData$nocDet6, _propsFormData$BPA9, _propsFormData$BPA9$, _storedData$BPA4, _storedData$BPA4$, _storedData$BPA4$$noc, _storedData$nocDetail3, _storedData$BPA5, _storedData$BPA5$, _Digit$SessionStorage, _Digit$SessionStorage2, _Digit$SessionStorage3, _Digit$SessionStorage4, _Digit$SessionStorage5, _Digit$SessionStorage6, _Digit$SessionStorage7, _Digit$SessionStorage8, _Digit$SessionStorage9, _Digit$SessionStorage10, _Digit$SessionStorage11, _Digit$SessionStorage12, _propsFormData$BPA10, _propsFormData$BPA10$, _storedData$BPA6, _storedData$BPA6$, _Digit$SessionStorage13, _Digit$SessionStorage14, _Digit$SessionStorage15, _Digit$SessionStorage16, _Digit$SessionStorage17, _Digit$SessionStorage18, _Digit$SessionStorage19, _Digit$SessionStorage20;
    if (!item) return null;
    if (Array.isArray(item === null || item === void 0 ? void 0 : item.documents) && item.documents.length > 0) {
      const validDoc = item.documents.find(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
      if (validDoc !== null && validDoc !== void 0 && validDoc.fileStoreId) return validDoc.fileStoreId;
    }
    let rawNocLetter = item === null || item === void 0 ? void 0 : item.nocLetterInfo;
    if (typeof rawNocLetter === "string") {
      try {
        rawNocLetter = JSON.parse(rawNocLetter);
      } catch (e) {}
    }
    const nocLetterObj = Array.isArray(rawNocLetter) ? (_rawNocLetter = rawNocLetter) === null || _rawNocLetter === void 0 ? void 0 : _rawNocLetter[0] : rawNocLetter;
    const rowNames = [item === null || item === void 0 ? void 0 : item.nocName, item === null || item === void 0 ? void 0 : item.nocType, item === null || item === void 0 ? void 0 : item.department, nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.nocName, nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.department].filter(Boolean).map(s => String(s).trim().toLowerCase());
    const isRowMatch = target => {
      if (!target) return false;
      if (item !== null && item !== void 0 && item.id && target !== null && target !== void 0 && target.id && item.id === target.id) return true;
      if (item !== null && item !== void 0 && item.applicationNo && target !== null && target !== void 0 && target.applicationNo && item.applicationNo === target.applicationNo) return true;
      if (item !== null && item !== void 0 && item.nocType && target !== null && target !== void 0 && target.nocType && item.nocType === target.nocType) return true;
      if (item !== null && item !== void 0 && item.nocName && target !== null && target !== void 0 && target.nocName && item.nocName === target.nocName) return true;
      return false;
    };
    const applicantSources = [currentBpaObj === null || currentBpaObj === void 0 ? void 0 : (_currentBpaObj$nocDet3 = currentBpaObj.nocDetails) === null || _currentBpaObj$nocDet3 === void 0 ? void 0 : _currentBpaObj$nocDet3.nocListApplicantDoc, currentBpaObj === null || currentBpaObj === void 0 ? void 0 : currentBpaObj.nocList, currentBpaObj === null || currentBpaObj === void 0 ? void 0 : (_currentBpaObj$nocDet4 = currentBpaObj.nocDetails) === null || _currentBpaObj$nocDet4 === void 0 ? void 0 : _currentBpaObj$nocDet4.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA8 = propsFormData.BPA) === null || _propsFormData$BPA8 === void 0 ? void 0 : (_propsFormData$BPA8$ = _propsFormData$BPA8[0]) === null || _propsFormData$BPA8$ === void 0 ? void 0 : (_propsFormData$BPA8$$ = _propsFormData$BPA8$.nocDetails) === null || _propsFormData$BPA8$$ === void 0 ? void 0 : _propsFormData$BPA8$$.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet6 = propsFormData.nocDetails) === null || _propsFormData$nocDet6 === void 0 ? void 0 : _propsFormData$nocDet6.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA9 = propsFormData.BPA) === null || _propsFormData$BPA9 === void 0 ? void 0 : (_propsFormData$BPA9$ = _propsFormData$BPA9[0]) === null || _propsFormData$BPA9$ === void 0 ? void 0 : _propsFormData$BPA9$.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.nocList, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA4 = storedData.BPA) === null || _storedData$BPA4 === void 0 ? void 0 : (_storedData$BPA4$ = _storedData$BPA4[0]) === null || _storedData$BPA4$ === void 0 ? void 0 : (_storedData$BPA4$$noc = _storedData$BPA4$.nocDetails) === null || _storedData$BPA4$$noc === void 0 ? void 0 : _storedData$BPA4$$noc.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$nocDetail3 = storedData.nocDetails) === null || _storedData$nocDetail3 === void 0 ? void 0 : _storedData$nocDetail3.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA5 = storedData.BPA) === null || _storedData$BPA5 === void 0 ? void 0 : (_storedData$BPA5$ = _storedData$BPA5[0]) === null || _storedData$BPA5$ === void 0 ? void 0 : _storedData$BPA5$.nocList, storedData === null || storedData === void 0 ? void 0 : storedData.nocList, (_Digit$SessionStorage = Digit.SessionStorage.get("FORM_MAP_SUBMISSION")) === null || _Digit$SessionStorage === void 0 ? void 0 : (_Digit$SessionStorage2 = _Digit$SessionStorage.BPA) === null || _Digit$SessionStorage2 === void 0 ? void 0 : (_Digit$SessionStorage3 = _Digit$SessionStorage2[0]) === null || _Digit$SessionStorage3 === void 0 ? void 0 : (_Digit$SessionStorage4 = _Digit$SessionStorage3.nocDetails) === null || _Digit$SessionStorage4 === void 0 ? void 0 : _Digit$SessionStorage4.nocListApplicantDoc, (_Digit$SessionStorage5 = Digit.SessionStorage.get("FORM_MAP_SUBMISSION")) === null || _Digit$SessionStorage5 === void 0 ? void 0 : (_Digit$SessionStorage6 = _Digit$SessionStorage5.nocDetails) === null || _Digit$SessionStorage6 === void 0 ? void 0 : _Digit$SessionStorage6.nocListApplicantDoc, (_Digit$SessionStorage7 = Digit.SessionStorage.get("nocAppData")) === null || _Digit$SessionStorage7 === void 0 ? void 0 : (_Digit$SessionStorage8 = _Digit$SessionStorage7.BPA) === null || _Digit$SessionStorage8 === void 0 ? void 0 : (_Digit$SessionStorage9 = _Digit$SessionStorage8[0]) === null || _Digit$SessionStorage9 === void 0 ? void 0 : (_Digit$SessionStorage10 = _Digit$SessionStorage9.nocDetails) === null || _Digit$SessionStorage10 === void 0 ? void 0 : _Digit$SessionStorage10.nocListApplicantDoc, (_Digit$SessionStorage11 = Digit.SessionStorage.get("nocAppData")) === null || _Digit$SessionStorage11 === void 0 ? void 0 : (_Digit$SessionStorage12 = _Digit$SessionStorage11.nocDetails) === null || _Digit$SessionStorage12 === void 0 ? void 0 : _Digit$SessionStorage12.nocListApplicantDoc].filter(list => Array.isArray(list) && list.length > 0);
    for (const list of applicantSources) {
      const matchedAppItem = list.find(isRowMatch);
      if (matchedAppItem && Array.isArray(matchedAppItem === null || matchedAppItem === void 0 ? void 0 : matchedAppItem.documents) && matchedAppItem.documents.length > 0) {
        const validDoc = matchedAppItem.documents.find(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
        if (validDoc !== null && validDoc !== void 0 && validDoc.fileStoreId) return validDoc.fileStoreId;
      }
    }
    const isNocDocMatch = doc => {
      var _doc$additionalDetail, _doc$additionalDetail2;
      if (!doc || !doc.fileStoreId) return false;
      const isNocFlag = (doc === null || doc === void 0 ? void 0 : doc.isNoc) === true || (doc === null || doc === void 0 ? void 0 : doc.isNoc) === "true" || (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.isNoc) === true;
      const docType = String((doc === null || doc === void 0 ? void 0 : doc.documentType) || (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail2 = doc.additionalDetails) === null || _doc$additionalDetail2 === void 0 ? void 0 : _doc$additionalDetail2.title) || "").trim().toLowerCase();
      if (!isNocFlag && !docType.includes("noc")) return false;
      return rowNames.some(n => n && (docType === n || docType.includes(n) || n.includes(docType)));
    };
    const bpaDocSources = [propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA10 = propsFormData.BPA) === null || _propsFormData$BPA10 === void 0 ? void 0 : (_propsFormData$BPA10$ = _propsFormData$BPA10[0]) === null || _propsFormData$BPA10$ === void 0 ? void 0 : _propsFormData$BPA10$.documents, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.documents, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA6 = storedData.BPA) === null || _storedData$BPA6 === void 0 ? void 0 : (_storedData$BPA6$ = _storedData$BPA6[0]) === null || _storedData$BPA6$ === void 0 ? void 0 : _storedData$BPA6$.documents, storedData === null || storedData === void 0 ? void 0 : storedData.documents, (_Digit$SessionStorage13 = Digit.SessionStorage.get("FORM_MAP_SUBMISSION")) === null || _Digit$SessionStorage13 === void 0 ? void 0 : (_Digit$SessionStorage14 = _Digit$SessionStorage13.BPA) === null || _Digit$SessionStorage14 === void 0 ? void 0 : (_Digit$SessionStorage15 = _Digit$SessionStorage14[0]) === null || _Digit$SessionStorage15 === void 0 ? void 0 : _Digit$SessionStorage15.documents, (_Digit$SessionStorage16 = Digit.SessionStorage.get("FORM_MAP_SUBMISSION")) === null || _Digit$SessionStorage16 === void 0 ? void 0 : _Digit$SessionStorage16.documents, (_Digit$SessionStorage17 = Digit.SessionStorage.get("nocAppData")) === null || _Digit$SessionStorage17 === void 0 ? void 0 : (_Digit$SessionStorage18 = _Digit$SessionStorage17.BPA) === null || _Digit$SessionStorage18 === void 0 ? void 0 : (_Digit$SessionStorage19 = _Digit$SessionStorage18[0]) === null || _Digit$SessionStorage19 === void 0 ? void 0 : _Digit$SessionStorage19.documents, (_Digit$SessionStorage20 = Digit.SessionStorage.get("nocAppData")) === null || _Digit$SessionStorage20 === void 0 ? void 0 : _Digit$SessionStorage20.documents].filter(docs => Array.isArray(docs) && docs.length > 0);
    for (const bpaDocs of bpaDocSources) {
      const matchedDoc = bpaDocs.find(isNocDocMatch);
      if (matchedDoc !== null && matchedDoc !== void 0 && matchedDoc.fileStoreId) return matchedDoc.fileStoreId;
    }
    return null;
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "applicationNo", "department", "requestLetter", "shortfallLetter", "approvalLetter", "uploadNoc", "status", "action"]);
  console.log("storedData", storedData);
  const allColumns = [{
    id: "srNo",
    label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
    width: "5%",
    filterable: false
  }, {
    id: "applicationNo",
    label: "Application Number",
    width: "16%",
    filterable: true
  }, {
    id: "department",
    label: "Department",
    width: "12%",
    filterable: false
  }, {
    id: "requestLetter",
    label: "Request Letter",
    width: "11%",
    filterable: false
  }, {
    id: "shortfallLetter",
    label: "Shortfall/Rejection Letter",
    width: "11%",
    filterable: false
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    width: "11%",
    filterable: false
  }, {
    id: "uploadNoc",
    label: "Upload NOC",
    width: "15%",
    filterable: false
  }, {
    id: "status",
    label: "Status",
    width: "10%",
    filterable: true
  }, {
    id: "action",
    label: "Action",
    width: "9%",
    filterable: false
  }];
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const searchNocRemarks = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const response = await axios$5.post(`${Urls$1.bpaService.nocRemarks}&applicationNo=${applicationNumber}`, dataToSend);
      const respData = response.data;
      Digit.SessionStorage.set("nocTermsAndCondition", respData);
      console.log("ResultFrommsearch", respData);
      return respData;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  const handleEdit = async item => {
    console.log("itemFromHandleEdit", item);
    if (!item) {
      return;
    }
    await searchNocRemarks(item === null || item === void 0 ? void 0 : item.applicationNo);
    Digit.SessionStorage.set("nocAppNo", {
      nocAppNo: item === null || item === void 0 ? void 0 : item.applicationNo,
      nocSearchResult: item
    });
    history.push({
      pathname: `/digit-ui/citizen/obps/services/NOC/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const handleOpenDoc = url => {
    if (url) window.open(url, "_blank");
  };
  const handleOpenUploadedDoc = async (fileStoreId, tenantId) => {
    try {
      var _res$data, _res$data2, _res$data2$files, _res$data2$files$;
      const res = await Digit.UploadServices.Filefetch([fileStoreId], tenantId);
      const url = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data[fileStoreId]) || (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$files = _res$data2.files) === null || _res$data2$files === void 0 ? void 0 : (_res$data2$files$ = _res$data2$files[0]) === null || _res$data2$files$ === void 0 ? void 0 : _res$data2$files$.url);
      if (url) {
        window.open(url, "_blank");
      } else {
        setShowToast({
          key: "error",
          error: true,
          label: "Document URL not available"
        });
        setTimeout(() => setShowToast(null), 5000);
      }
    } catch (err) {
      console.error("Error fetching file URL", err);
    }
  };
  const handleFileUpload = async (event, item) => {
    var _event$target$files;
    const file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    if (!file) return;
    const rowId = item.id || item.applicationNo;
    try {
      var _storedData$BPA7, _storedData$BPA7$, _propsFormData$BPA11, _propsFormData$BPA11$, _uploadRes$data, _uploadRes$data$files, _uploadRes$data$files2, _item$nocLetterInfo, _item$documents, _item$documents$, _storedData$nocDetail5, _storedData$BPA10, _storedData$BPA10$, _storedData$BPA10$$no, _propsFormData$nocDet8, _propsFormData$BPA14, _propsFormData$BPA14$, _propsFormData$BPA14$2, _storedData$BPA11, _storedData$BPA11$, _propsFormData$BPA15, _propsFormData$BPA15$, _updateResponse$BPA, _finalUpdatedBPA$nocD;
      setUploadingRowId(rowId);
      const tenantId = (item === null || item === void 0 ? void 0 : item.tenantId) || (storedData === null || storedData === void 0 ? void 0 : storedData.tenantId) || (storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA7 = storedData.BPA) === null || _storedData$BPA7 === void 0 ? void 0 : (_storedData$BPA7$ = _storedData$BPA7[0]) === null || _storedData$BPA7$ === void 0 ? void 0 : _storedData$BPA7$.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA11 = propsFormData.BPA) === null || _propsFormData$BPA11 === void 0 ? void 0 : (_propsFormData$BPA11$ = _propsFormData$BPA11[0]) === null || _propsFormData$BPA11$ === void 0 ? void 0 : _propsFormData$BPA11$.tenantId) || Digit.ULBService.getStateId();
      const uploadRes = await Digit.UploadServices.Filestorage("property-upload", file, tenantId);
      const fileStoreId = uploadRes === null || uploadRes === void 0 ? void 0 : (_uploadRes$data = uploadRes.data) === null || _uploadRes$data === void 0 ? void 0 : (_uploadRes$data$files = _uploadRes$data.files) === null || _uploadRes$data$files === void 0 ? void 0 : (_uploadRes$data$files2 = _uploadRes$data$files[0]) === null || _uploadRes$data$files2 === void 0 ? void 0 : _uploadRes$data$files2.fileStoreId;
      if (!fileStoreId) {
        throw new Error("File upload failed: No filestore ID received");
      }
      const nocLetterObj = Array.isArray(item === null || item === void 0 ? void 0 : item.nocLetterInfo) ? item === null || item === void 0 ? void 0 : (_item$nocLetterInfo = item.nocLetterInfo) === null || _item$nocLetterInfo === void 0 ? void 0 : _item$nocLetterInfo[0] : item === null || item === void 0 ? void 0 : item.nocLetterInfo;
      const nocDocName = (item === null || item === void 0 ? void 0 : item.nocName) || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.nocName) || (item === null || item === void 0 ? void 0 : item.nocType) || "NOC Document";
      let existingDocId = (item === null || item === void 0 ? void 0 : (_item$documents = item.documents) === null || _item$documents === void 0 ? void 0 : (_item$documents$ = _item$documents[0]) === null || _item$documents$ === void 0 ? void 0 : _item$documents$.id) || undefined;
      if (!existingDocId) {
        var _storedData$nocDetail4, _storedData$BPA8, _storedData$BPA8$, _storedData$BPA8$$noc, _propsFormData$nocDet7, _propsFormData$BPA12, _propsFormData$BPA12$, _propsFormData$BPA12$2;
        const applicantDocList = getFirstNonEmptyList(storedData === null || storedData === void 0 ? void 0 : (_storedData$nocDetail4 = storedData.nocDetails) === null || _storedData$nocDetail4 === void 0 ? void 0 : _storedData$nocDetail4.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA8 = storedData.BPA) === null || _storedData$BPA8 === void 0 ? void 0 : (_storedData$BPA8$ = _storedData$BPA8[0]) === null || _storedData$BPA8$ === void 0 ? void 0 : (_storedData$BPA8$$noc = _storedData$BPA8$.nocDetails) === null || _storedData$BPA8$$noc === void 0 ? void 0 : _storedData$BPA8$$noc.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet7 = propsFormData.nocDetails) === null || _propsFormData$nocDet7 === void 0 ? void 0 : _propsFormData$nocDet7.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA12 = propsFormData.BPA) === null || _propsFormData$BPA12 === void 0 ? void 0 : (_propsFormData$BPA12$ = _propsFormData$BPA12[0]) === null || _propsFormData$BPA12$ === void 0 ? void 0 : (_propsFormData$BPA12$2 = _propsFormData$BPA12$.nocDetails) === null || _propsFormData$BPA12$2 === void 0 ? void 0 : _propsFormData$BPA12$2.nocListApplicantDoc);
        if (Array.isArray(applicantDocList)) {
          const matchingDocItem = applicantDocList.find(docItem => (docItem === null || docItem === void 0 ? void 0 : docItem.id) && (docItem === null || docItem === void 0 ? void 0 : docItem.id) === (item === null || item === void 0 ? void 0 : item.id) || (docItem === null || docItem === void 0 ? void 0 : docItem.applicationNo) && (docItem === null || docItem === void 0 ? void 0 : docItem.applicationNo) === (item === null || item === void 0 ? void 0 : item.applicationNo) || nocDocName && ((docItem === null || docItem === void 0 ? void 0 : docItem.nocName) === nocDocName || (docItem === null || docItem === void 0 ? void 0 : docItem.nocType) === nocDocName));
          if (matchingDocItem && Array.isArray(matchingDocItem === null || matchingDocItem === void 0 ? void 0 : matchingDocItem.documents) && matchingDocItem.documents.length > 0) {
            var _matchingDocItem$docu;
            existingDocId = (_matchingDocItem$docu = matchingDocItem.documents[0]) === null || _matchingDocItem$docu === void 0 ? void 0 : _matchingDocItem$docu.id;
          }
        }
      }
      if (!existingDocId) {
        var _storedData$BPA9, _storedData$BPA9$, _propsFormData$BPA13, _propsFormData$BPA13$;
        const bpaDocs = getFirstNonEmptyList(storedData === null || storedData === void 0 ? void 0 : storedData.documents, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA9 = storedData.BPA) === null || _storedData$BPA9 === void 0 ? void 0 : (_storedData$BPA9$ = _storedData$BPA9[0]) === null || _storedData$BPA9$ === void 0 ? void 0 : _storedData$BPA9$.documents, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.documents, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA13 = propsFormData.BPA) === null || _propsFormData$BPA13 === void 0 ? void 0 : (_propsFormData$BPA13$ = _propsFormData$BPA13[0]) === null || _propsFormData$BPA13$ === void 0 ? void 0 : _propsFormData$BPA13$.documents);
        const fallbackDoc = bpaDocs.find(doc => ((doc === null || doc === void 0 ? void 0 : doc.isNoc) === "true" || (doc === null || doc === void 0 ? void 0 : doc.isNoc) === true) && (doc === null || doc === void 0 ? void 0 : doc.documentType) === nocDocName);
        existingDocId = (fallbackDoc === null || fallbackDoc === void 0 ? void 0 : fallbackDoc.id) || undefined;
      }
      const newDoc = {
        id: existingDocId,
        documentType: nocDocName,
        fileStoreId: fileStoreId,
        documentRemarks: "",
        documentSubtype: null,
        isNoc: "true"
      };
      let updatedDocuments = [];
      if (Array.isArray(item.documents) && item.documents.length > 0) {
        const existingIndex = item.documents.findIndex(d => (d === null || d === void 0 ? void 0 : d.isNoc) === "true" || (d === null || d === void 0 ? void 0 : d.isNoc) === true || (d === null || d === void 0 ? void 0 : d.documentType) === nocDocName);
        if (existingIndex >= 0) {
          var _updatedDocuments$exi;
          updatedDocuments = [...item.documents];
          updatedDocuments[existingIndex] = {
            ...updatedDocuments[existingIndex],
            fileStoreId: fileStoreId,
            id: existingDocId || ((_updatedDocuments$exi = updatedDocuments[existingIndex]) === null || _updatedDocuments$exi === void 0 ? void 0 : _updatedDocuments$exi.id)
          };
        } else {
          updatedDocuments = [{
            ...item.documents[0],
            ...newDoc
          }];
        }
      } else {
        updatedDocuments = [newDoc];
      }
      const currentNocList = getFirstNonEmptyList(storedData === null || storedData === void 0 ? void 0 : (_storedData$nocDetail5 = storedData.nocDetails) === null || _storedData$nocDetail5 === void 0 ? void 0 : _storedData$nocDetail5.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA10 = storedData.BPA) === null || _storedData$BPA10 === void 0 ? void 0 : (_storedData$BPA10$ = _storedData$BPA10[0]) === null || _storedData$BPA10$ === void 0 ? void 0 : (_storedData$BPA10$$no = _storedData$BPA10$.nocDetails) === null || _storedData$BPA10$$no === void 0 ? void 0 : _storedData$BPA10$$no.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$nocDet8 = propsFormData.nocDetails) === null || _propsFormData$nocDet8 === void 0 ? void 0 : _propsFormData$nocDet8.nocListApplicantDoc, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA14 = propsFormData.BPA) === null || _propsFormData$BPA14 === void 0 ? void 0 : (_propsFormData$BPA14$ = _propsFormData$BPA14[0]) === null || _propsFormData$BPA14$ === void 0 ? void 0 : (_propsFormData$BPA14$2 = _propsFormData$BPA14$.nocDetails) === null || _propsFormData$BPA14$2 === void 0 ? void 0 : _propsFormData$BPA14$2.nocListApplicantDoc, storedData === null || storedData === void 0 ? void 0 : storedData.nocList, storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA11 = storedData.BPA) === null || _storedData$BPA11 === void 0 ? void 0 : (_storedData$BPA11$ = _storedData$BPA11[0]) === null || _storedData$BPA11$ === void 0 ? void 0 : _storedData$BPA11$.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.nocList, propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA15 = propsFormData.BPA) === null || _propsFormData$BPA15 === void 0 ? void 0 : (_propsFormData$BPA15$ = _propsFormData$BPA15[0]) === null || _propsFormData$BPA15$ === void 0 ? void 0 : _propsFormData$BPA15$.nocList);
      const updatedNocList = currentNocList.map(nocItem => {
        if (nocItem.id && nocItem.id === item.id || nocItem.applicationNo && nocItem.applicationNo === item.applicationNo) {
          return {
            ...nocItem,
            documents: updatedDocuments,
            workflow: {
              ...((nocItem === null || nocItem === void 0 ? void 0 : nocItem.workflow) || {}),
              action: "UPLOAD_DOC"
            }
          };
        }
        const existingDocs = Array.isArray(nocItem === null || nocItem === void 0 ? void 0 : nocItem.documents) && nocItem.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId) ? nocItem.documents : null;
        if (existingDocs) {
          return {
            ...nocItem,
            documents: existingDocs
          };
        }
        return nocItem;
      });
      const baseBpaData = getBpa(storedData) || storedData || {};
      const updatedAppData = {
        ...baseBpaData,
        nocDetails: {
          ...((baseBpaData === null || baseBpaData === void 0 ? void 0 : baseBpaData.nocDetails) || {}),
          nocListApplicantDoc: updatedNocList
        },
        nocList: updatedNocList,
        workflow: {
          ...((baseBpaData === null || baseBpaData === void 0 ? void 0 : baseBpaData.workflow) || {}),
          action: "UPLOAD_DOC"
        }
      };
      const updateResponse = await Digit.OBPSService.update({
        BPA: updatedAppData
      }, tenantId);
      const finalUpdatedBPA = (updateResponse === null || updateResponse === void 0 ? void 0 : (_updateResponse$BPA = updateResponse.BPA) === null || _updateResponse$BPA === void 0 ? void 0 : _updateResponse$BPA[0]) || updatedAppData;
      const apiNocList = getFirstNonEmptyList(finalUpdatedBPA === null || finalUpdatedBPA === void 0 ? void 0 : (_finalUpdatedBPA$nocD = finalUpdatedBPA.nocDetails) === null || _finalUpdatedBPA$nocD === void 0 ? void 0 : _finalUpdatedBPA$nocD.nocListApplicantDoc, finalUpdatedBPA === null || finalUpdatedBPA === void 0 ? void 0 : finalUpdatedBPA.nocList, updatedNocList);
      const reconciledNocList = apiNocList.map(apiItem => {
        const localItem = updatedNocList.find(l => l.id && l.id === apiItem.id || l.applicationNo && l.applicationNo === apiItem.applicationNo);
        const snapshotItem = currentNocList.find(s => s.id && s.id === apiItem.id || s.applicationNo && s.applicationNo === apiItem.applicationNo);
        const apiHasDoc = Array.isArray(apiItem === null || apiItem === void 0 ? void 0 : apiItem.documents) && apiItem.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
        const localHasDoc = Array.isArray(localItem === null || localItem === void 0 ? void 0 : localItem.documents) && localItem.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
        const snapshotHasDoc = Array.isArray(snapshotItem === null || snapshotItem === void 0 ? void 0 : snapshotItem.documents) && snapshotItem.documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
        return {
          ...apiItem,
          documents: apiHasDoc ? apiItem.documents : localHasDoc ? localItem.documents : snapshotHasDoc ? snapshotItem.documents : apiItem.documents
        };
      });
      const finalData = {
        ...finalUpdatedBPA,
        nocDetails: {
          ...((finalUpdatedBPA === null || finalUpdatedBPA === void 0 ? void 0 : finalUpdatedBPA.nocDetails) || {}),
          nocListApplicantDoc: reconciledNocList
        },
        nocList: reconciledNocList
      };
      Digit.SessionStorage.set("nocAppData", finalData);
      setStoredData(finalData);
      const parentFormKey = "FORM_MAP_SUBMISSION";
      const currentParentForm = Digit.SessionStorage.get(parentFormKey);
      if (currentParentForm) {
        const updatedParentForm = {
          ...currentParentForm,
          nocDetails: {
            ...((currentParentForm === null || currentParentForm === void 0 ? void 0 : currentParentForm.nocDetails) || {}),
            nocListApplicantDoc: reconciledNocList
          }
        };
        delete updatedParentForm.nocList;
        Digit.SessionStorage.set(parentFormKey, updatedParentForm);
      }
      if (typeof onNocUpdate === "function") {
        skipMergeRef.current = true;
        onNocUpdate(reconciledNocList);
      }
      setShowToast({
        key: "success",
        label: "NOC document uploaded and application updated successfully!"
      });
      setTimeout(() => setShowToast(null), 5000);
    } catch (err) {
      console.error("Error uploading NOC document:", err);
      setShowToast({
        key: "error",
        error: true,
        label: (err === null || err === void 0 ? void 0 : err.message) || "Failed to upload NOC document"
      });
      setTimeout(() => setShowToast(null), 5000);
    } finally {
      setUploadingRowId(null);
      if (event.target) event.target.value = "";
    }
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = nocList;
    if (globalSearch) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch));
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  console.log("paginatedData", paginatedData);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleOpenColumnFilter = event => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, "NOC Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: t('FASTPAS.GLOBAL.SEARCH.HERE.TEXT'),
    value: globalSearch,
    onChange: e => setGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => setGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  })))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    style: {
      width: column.width,
      fontWeight: "bold"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, idx) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.applicationNo || idx
  }, columns.map(column => {
    switch (column.id) {
      case "srNo":
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id
        }, page * rowsPerPage + idx + 1);
      case "applicationNo":
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id
        }, item.applicationNo || "-");
      case "department":
        {
          var _rawNocLetter2;
          let rawNocLetter = item === null || item === void 0 ? void 0 : item.nocLetterInfo;
          if (typeof rawNocLetter === "string") {
            try {
              rawNocLetter = JSON.parse(rawNocLetter);
            } catch (e) {}
          }
          const nocLetterObj = Array.isArray(rawNocLetter) ? (_rawNocLetter2 = rawNocLetter) === null || _rawNocLetter2 === void 0 ? void 0 : _rawNocLetter2[0] : rawNocLetter;
          return /*#__PURE__*/React__default.createElement("td", {
            key: column.id
          }, item.nocName || (nocLetterObj === null || nocLetterObj === void 0 ? void 0 : nocLetterObj.nocName) || "-");
        }
      case "requestLetter":
        {
          var _rawNocLetter3;
          let rawNocLetter = item === null || item === void 0 ? void 0 : item.nocLetterInfo;
          if (typeof rawNocLetter === "string") {
            try {
              rawNocLetter = JSON.parse(rawNocLetter);
            } catch (e) {}
          }
          const nocLetter = Array.isArray(rawNocLetter) ? rawNocLetter.find(info => (info === null || info === void 0 ? void 0 : info.fileStoreUrl) || (info === null || info === void 0 ? void 0 : info.fileStoreId) || (info === null || info === void 0 ? void 0 : info.url)) || ((_rawNocLetter3 = rawNocLetter) === null || _rawNocLetter3 === void 0 ? void 0 : _rawNocLetter3[0]) : rawNocLetter;
          const fileUrl = (nocLetter === null || nocLetter === void 0 ? void 0 : nocLetter.fileStoreUrl) || (nocLetter === null || nocLetter === void 0 ? void 0 : nocLetter.url) || (item === null || item === void 0 ? void 0 : item.requestLetterUrl) || (item === null || item === void 0 ? void 0 : item.fileStoreUrl);
          const fileStoreId = (nocLetter === null || nocLetter === void 0 ? void 0 : nocLetter.fileStoreId) || (item === null || item === void 0 ? void 0 : item.requestLetterFileStoreId) || (item === null || item === void 0 ? void 0 : item.fileStoreId);
          return /*#__PURE__*/React__default.createElement("td", {
            key: column.id,
            style: {
              textAlign: "center"
            }
          }, fileUrl ? /*#__PURE__*/React__default.createElement(Button$2, {
            size: "small",
            className: "btn-table-action",
            variant: "contained",
            color: "primary",
            sx: {
              fontSize: "12px",
              minWidth: "60px"
            },
            onClick: () => handleOpenDoc(fileUrl)
          }, /*#__PURE__*/React__default.createElement("span", null, "View")) : fileStoreId ? /*#__PURE__*/React__default.createElement(Button$2, {
            size: "small",
            className: "btn-table-action",
            variant: "contained",
            color: "primary",
            sx: {
              fontSize: "12px",
              minWidth: "60px"
            },
            onClick: () => {
              var _storedData$BPA12, _storedData$BPA12$, _propsFormData$BPA16, _propsFormData$BPA16$;
              return handleOpenUploadedDoc(fileStoreId, (item === null || item === void 0 ? void 0 : item.tenantId) || (storedData === null || storedData === void 0 ? void 0 : storedData.tenantId) || (storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA12 = storedData.BPA) === null || _storedData$BPA12 === void 0 ? void 0 : (_storedData$BPA12$ = _storedData$BPA12[0]) === null || _storedData$BPA12$ === void 0 ? void 0 : _storedData$BPA12$.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA16 = propsFormData.BPA) === null || _propsFormData$BPA16 === void 0 ? void 0 : (_propsFormData$BPA16$ = _propsFormData$BPA16[0]) === null || _propsFormData$BPA16$ === void 0 ? void 0 : _propsFormData$BPA16$.tenantId) || Digit.ULBService.getStateId());
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "-");
        }
      case "shortfallLetter":
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          style: {
            textAlign: "center"
          }
        }, item.nocApprovedLetterUrl && (item.applicationStatus === "REVERT_TO_APPLICANT_NOC" || item.applicationStatus === "NOC_REJECTED") ? /*#__PURE__*/React__default.createElement(Button$2, {
          size: "small",
          className: "btn-table-action",
          variant: "contained",
          color: "primary",
          sx: {
            fontSize: "12px",
            minWidth: "60px"
          },
          onClick: () => handleOpenDoc(item.nocApprovedLetterUrl)
        }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "-");
      case "approvalLetter":
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          style: {
            textAlign: "center"
          }
        }, item.applicationStatus === "NOC_APPROVED" ? /*#__PURE__*/React__default.createElement(Button$2, {
          size: "small",
          className: "btn-table-action",
          variant: "contained",
          color: "primary",
          sx: {
            fontSize: "12px",
            minWidth: "60px"
          },
          onClick: () => handleOpenDoc(item.nocApprovedLetterUrl || item.nocDeemedLetterUrl)
        }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "-");
      case "uploadNoc":
        {
          const isUploading = uploadingRowId === (item.id || item.applicationNo);
          const uploadedFileStoreId = getUploadedFileStoreId(item);
          return /*#__PURE__*/React__default.createElement("td", {
            key: column.id,
            style: {
              textAlign: "center"
            }
          }, /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px"
            }
          }, /*#__PURE__*/React__default.createElement("input", {
            type: "file",
            id: `upload-noc-${item.id || idx}`,
            style: {
              display: "none"
            },
            onChange: e => handleFileUpload(e, item),
            accept: "image/*,application/pdf"
          }), /*#__PURE__*/React__default.createElement("label", {
            htmlFor: `upload-noc-${item.id || idx}`
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            size: "small",
            className: "btn-table-action",
            variant: "contained",
            color: "primary",
            component: "span",
            disabled: isUploading,
            sx: {
              fontSize: "12px",
              minWidth: "75px"
            }
          }, isUploading ? "Uploading..." : uploadedFileStoreId ? "Re-upload" : "Upload")), uploadedFileStoreId && /*#__PURE__*/React__default.createElement(Button$2, {
            size: "small",
            className: "btn-table-action",
            variant: "outlined",
            color: "primary",
            sx: {
              fontSize: "12px",
              minWidth: "50px"
            },
            onClick: () => {
              var _storedData$BPA13, _storedData$BPA13$, _propsFormData$BPA17, _propsFormData$BPA17$;
              return handleOpenUploadedDoc(uploadedFileStoreId, (item === null || item === void 0 ? void 0 : item.tenantId) || (storedData === null || storedData === void 0 ? void 0 : storedData.tenantId) || (storedData === null || storedData === void 0 ? void 0 : (_storedData$BPA13 = storedData.BPA) === null || _storedData$BPA13 === void 0 ? void 0 : (_storedData$BPA13$ = _storedData$BPA13[0]) === null || _storedData$BPA13$ === void 0 ? void 0 : _storedData$BPA13$.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : propsFormData.tenantId) || (propsFormData === null || propsFormData === void 0 ? void 0 : (_propsFormData$BPA17 = propsFormData.BPA) === null || _propsFormData$BPA17 === void 0 ? void 0 : (_propsFormData$BPA17$ = _propsFormData$BPA17[0]) === null || _propsFormData$BPA17$ === void 0 ? void 0 : _propsFormData$BPA17$.tenantId) || Digit.ULBService.getStateId());
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
        }
      case "status":
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id
        }, t(`NOC_STATUS_${item.applicationStatus}`) || "-");
      case "action":
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-action",
          style: {
            textAlign: "center"
          }
        }, ["REVERT_TO_APPLICANT_NOC"].includes(item === null || item === void 0 ? void 0 : item.applicationStatus) && /*#__PURE__*/React__default.createElement(Button$2, {
          size: "small",
          className: "btn-table-action",
          variant: "contained",
          color: "primary",
          sx: {
            fontSize: "12px",
            minWidth: "60px"
          },
          onClick: () => {
            handleEdit(item);
            console.log("Edit action for application:", item.applicationNo);
          }
        }, /*#__PURE__*/React__default.createElement("span", null, "Edit")));
      default:
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id
        }, "-");
    }
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [5, 10, 25, 50],
    component: "div",
    count: filteredData.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast.error,
    label: t(showToast.label),
    onClose: () => setShowToast(null)
  }), isStandalonePage && nocList.some(noc => {
    var _noc$documents;
    return noc === null || noc === void 0 ? void 0 : (_noc$documents = noc.documents) === null || _noc$documents === void 0 ? void 0 : _noc$documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
  }) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "12px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    size: "medium",
    sx: {
      backgroundColor: "#157CB3",
      color: "#fff",
      textTransform: "none"
    },
    onClick: () => setShowNocSavedModal(true)
  }, "Save")), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: showNocSavedModal,
    onClose: () => setShowNocSavedModal(false),
    "aria-labelledby": "noc-saved-dialog-title",
    PaperProps: {
      style: {
        borderRadius: "8px",
        padding: "8px",
        minWidth: "360px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "noc-saved-dialog-title",
    style: {
      color: "#157CB3",
      fontWeight: 600
    }
  }, "NOC Uploaded Successfully"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    style: {
      color: "#333",
      fontSize: "14px"
    }
  }, "NOC uploaded. Please forward the application to the department by editing the application.")), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: () => setShowNocSavedModal(false),
    variant: "contained",
    sx: {
      backgroundColor: "#157CB3",
      color: "#fff",
      textTransform: "none"
    }
  }, "OK"))));
};

const IdentifyNoc = ({
  formData,
  tenantId,
  handleTabChange,
  handleSubTabChange,
  isEmployee
}) => {
  var _data$, _mdmsDepartments$;
  const {
    data: {
      NOC: {
        NocDepartment: mdmsDepartments
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", ["NocDepartment"]);
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    t
  } = useTranslation();
  const khasraDetails = (formData === null || formData === void 0 ? void 0 : formData.khasraDetails) || [];
  const tehsil = khasraDetails.length > 0 ? khasraDetails[0].tehsil : "";
  const authority = formData === null || formData === void 0 ? void 0 : formData.selectedOffice;
  const district = khasraDetails.length > 0 ? khasraDetails[0].district : "";
  const villageList = khasraDetails.length > 0 ? khasraDetails[0].villageName : "";
  const {
    data,
    isLoading,
    isSuccess,
    error
  } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, authority, tehsil, district, villageList);
  console.log("nocDepartmentdata", data, formData, mdmsDepartments);
  function fetchDepartmentMessages(data, departmentList) {
    var _departmentList$filte;
    console.log("logFromFucntion", data, departmentList);
    return data && departmentList ? departmentList === null || departmentList === void 0 ? void 0 : (_departmentList$filte = departmentList.filter(dept => data[dept.code] === "Yes")) === null || _departmentList$filte === void 0 ? void 0 : _departmentList$filte.map(dept => ({
      code: dept.code,
      message: dept.message,
      name: dept.name
    })) : [];
  }
  const departments = fetchDepartmentMessages(data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.Departments, mdmsDepartments === null || mdmsDepartments === void 0 ? void 0 : (_mdmsDepartments$ = mdmsDepartments[0]) === null || _mdmsDepartments$ === void 0 ? void 0 : _mdmsDepartments$.department);
  console.log("finalDepartments", departments);
  const {
    control,
    setValue,
    handleSubmit
  } = useForm({
    defaultValues: {}
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    console.log("dataFromSUbmit", data);
    console.log("finalPayloadOfNoc", data);
    handleTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f0f0f0"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Sr. No."), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "60%"
    }
  }, "Department Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "60%"
    }
  }, "Upload NOC"))), /*#__PURE__*/React__default.createElement("tbody", null, departments.map((dept, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: dept.name
  }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, dept.name, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: dept.message,
    arrow: true
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    name: `${dept === null || dept === void 0 ? void 0 : dept.name}`,
    hasLabel: false,
    validationMsg: "Upload File",
    isNoc: true
  }))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(3)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  }))));
};

const Step4Comp = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule,
  onSelect
}) => {
  var _formData$documents, _formData$documents$f, _formData$mapSubDetai;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("formDataInStep4", formData);
  const {
    t
  } = useTranslation();
  const defaultValues = formData ? {
    ...formData
  } : {};
  const {
    handleSubmit,
    control,
    setValue,
    trigger,
    getValues
  } = useForm({
    defaultValues
  });
  const tenantId = Digit.ULBService.getStateId();
  const [drawingDetail, setDrawingDetail] = useState((formData === null || formData === void 0 ? void 0 : formData.drawingDetail) || []);
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currFileStoreId, setCurrFileStoreId] = useState(null);
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [file2, setFile2] = useState(null);
  const [showError, setShowError] = useState(false);
  const [dxfFileUrl, setDxfFileUrl] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  const onSubmit = data => {
    handleTabChange(4, data);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
      const SignRequest = {
        applicationNo: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        pdfType: "DI",
        fileStoreId: sanctionMapFileStoreId
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams({
        AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
        SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
        SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
        ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
        UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
      });
      setOpen(true);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  const completeDrawingDxfFile = formData.documents.filter(doc => doc.documentType === "dxfDrawing" || (doc === null || doc === void 0 ? void 0 : doc.documentType) === "compoundingDrawingDxf");
  console.log("completeDrawingDxfFile", completeDrawingDxfFile);
  useEffect(() => {
    if (!(formData !== null && formData !== void 0 && formData.documents) || formData.documents.length === 0) {
      console.log("No documents found in formData yet");
      return;
    }
    const completeDrawingDxfFile = formData.documents.filter(doc => doc.documentType === "dxfDrawing");
    if ((completeDrawingDxfFile === null || completeDrawingDxfFile === void 0 ? void 0 : completeDrawingDxfFile.length) > 0) {
      var _completeDrawingDxfFi;
      const dxfFileStoreId = (_completeDrawingDxfFi = completeDrawingDxfFile[0]) === null || _completeDrawingDxfFi === void 0 ? void 0 : _completeDrawingDxfFi.fileStoreId;
      if (dxfFileStoreId) {
        const url = `/filestore/v1/files/id?fileStoreId=${dxfFileStoreId}&tenantId=${tenantId}`;
        setDxfFileUrl(url);
        console.log("✅ DXF File URL:", url);
      } else {
        console.warn("⚠️ DXF fileStoreId missing in document");
        setDxfFileUrl(null);
      }
    } else {
      console.warn("⚠️ No compoundingDrawingDxf document found");
      setDxfFileUrl(null);
    }
  }, [formData, tenantId]);
  const sanctionMapFileStoreId = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.find(doc => doc.documentType === "drawingPdf")) === null || _formData$documents$f === void 0 ? void 0 : _formData$documents$f.fileStoreId;
  const drawingPdfUrl = formData === null || formData === void 0 ? void 0 : formData.drawingPdfUrlSelf;
  const validatePdfUrl = url => {
    if (!url) return false;
    if (url.startsWith("/")) return true;
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const handleOpenPdf = async (url, index = null) => {
    console.log("DEBUG: handleOpenPdf called with URL:", url);
    if (!validatePdfUrl(url)) {
      console.log("Invalid PDF URL provided", "error");
      return;
    }
    setCurrentPdfUrl(url);
    setCurrFileStoreId(sanctionMapFileStoreId);
    setCurrentDocumentIndex(index);
    setPdfModalOpen(true);
    console.log("DEBUG: PDF modal opened");
  };
  const handlePdfSave = (fileStoreId, documentIndex) => {
    console.log("PDF saved with fileStoreId:", fileStoreId, "for document index:", documentIndex);
    setSavedFileStoreId(fileStoreId);
    try {
      const workflow = {
        action: "NOWORKFLOW",
        comments: ""
      };
      console.log("Drawing Detials 166", drawingDetail);
      const appData = {
        ...formData,
        workflow,
        mapSubDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
          viewEditPdf: fileStoreId
        }
      };
      console.log("APPDATA for update", appData);
      updateApiCall.mutate({
        BPA: appData
      }, {
        onSuccess: result => {
          var _result$BPA;
          console.log("resultFromUpdate", result);
          onSelect("", result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA[0]);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const columns = [{
    id: "pdfFile",
    label: "PDF File",
    accessor: ""
  }, ...(isEmployee ? [{
    id: "viewEditPdf",
    label: "View Edited Pdf",
    accessor: "viewEditPdf"
  }] : []), {
    id: "dxfFile",
    label: "DWG File",
    accessor: "dxfFile"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handlePdfModalClose = () => {
    setPdfModalOpen(false);
    setCurrentPdfUrl("");
    setCurrentDocumentIndex(null);
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("valueInStep4Comp", formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    ref: formRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details  table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => isEmployee ? handleOpenPdf(drawingPdfUrl) : getDocumentByFileStoreId(sanctionMapFileStoreId, setIsPreviewLoading)
  })), isEmployee && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData !== null && formData !== void 0 && (_formData$mapSubDetai = formData.mapSubDetails) !== null && _formData$mapSubDetai !== void 0 && _formData$mapSubDetai.viewEditPdf ? /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#157CB3",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => {
      var _formData$mapSubDetai2;
      return getDocumentByFileStoreId(formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.viewEditPdf, setIsPreviewLoading);
    }
  })) : /*#__PURE__*/React__default.createElement(TableCell$1, null, "No File")), completeDrawingDxfFile ? /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => {
      var _completeDrawingDxfFi2;
      return getDocumentByFileStoreId((_completeDrawingDxfFi2 = completeDrawingDxfFile[0]) === null || _completeDrawingDxfFi2 === void 0 ? void 0 : _completeDrawingDxfFi2.fileStoreId, setIsPreviewLoading);
    }
  })) : /*#__PURE__*/React__default.createElement(TableCell$1, null, "No File"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === true ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#24b155",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData.signedDrawingPdfURL, "_blank"),
    title: "View Signed PDF"
  }) : !isEmployee ? /*#__PURE__*/React__default.createElement("button", {
    style: {
      backgroundColor: "#157CB3",
      color: "#fff",
      padding: "8px 16px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      opacity: 1
    },
    type: "button",
    onClick: handleSign
  }, "Attach Digital Sign") : "N/A"))))), /*#__PURE__*/React__default.createElement(PdfViewerModal, {
    open: pdfModalOpen,
    onClose: handlePdfModalClose,
    pdfUrl: currentPdfUrl,
    onSave: handlePdfSave,
    documentIndex: currentDocumentIndex,
    fileStoreId: currFileStoreId
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit")))))), !isEmployee && !isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const Step6 = ({
  formData,
  handleTabChange
}) => {
  var _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const onSubmit = data => {
    handleTabChange(4, data);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    moduleCode: formData === null || formData === void 0 ? void 0 : formData.businessService
  });
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData, _applicationData$audi, _applicationData2;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$audi = _applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: ((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData3, _applicationData3$aud, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : (_applicationData3$aud = _applicationData3.auditDetails) === null || _applicationData3$aud === void 0 ? void 0 : _applicationData3$aud.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application History")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.timeline) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BreakLine, null), (workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement("div", null, workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data3 = workflowDetails.data) !== null && _workflowDetails$data3 !== void 0 && _workflowDetails$data3.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.timeline) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.length) === 1 ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "aliceblue",
      borderRadius: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline[0]) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.timeline[0])
  })) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint["status"]}`),
      customChild: getTimelineCaptions(checkpoint)
    })));
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const FormStrip = ({
  formName
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "formStrip"
  }, /*#__PURE__*/React__default.createElement("h3", null, formName));
};

const getMapSubmissionData = (t, id = null) => {
  var _Digit$SessionStorage, _edcrData$planDetail, _edcrData$planDetail$, _edcrData$planDetail$2, _mdmsData$BPA, _planDetail$plot, _planDetail$virtualBu7, _planDetail$virtualBu8, _planDetail$virtualBu9, _planDetail$virtualBu10, _planDetail$virtualBu11, _planDetail$planInfoP2, _planDetail$plot3, _planDetail$blocks3, _planDetail$virtualBu12, _planDetail$parkingDe3, _planDetail$parkingDe4, _Digit2, _userInfo$info, _userInfo$info2, _userInfo$info3, _scrutinyDetails$city, _planInformation$corr, _scrutinyDetails$loca, _planInformation$corr2, _scrutinyDetails$vill, _planInformation$corr3;
  const tenantId = Digit.ULBService.getStateId() || 'up';
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const planDetail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const isRescrutiny = (planDetail === null || planDetail === void 0 ? void 0 : planDetail.applicationScrutinyType) || false;
  const regulatedObj = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : (_edcrData$planDetail$ = _edcrData$planDetail.reportOutput) === null || _edcrData$planDetail$ === void 0 ? void 0 : (_edcrData$planDetail$2 = _edcrData$planDetail$.scrutinyDetails) === null || _edcrData$planDetail$2 === void 0 ? void 0 : _edcrData$planDetail$2.filter(e => e.key === 'Block_1_Side Setback');
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot = planDetail.plot) === null || _planDetail$plot === void 0 ? void 0 : _planDetail$plot.area, planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const planInformation = planDetail === null || planDetail === void 0 ? void 0 : planDetail.planInformation;
  if (id && !isRescrutiny) {
    var _data$BPA;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  } else if (id && isRescrutiny) {
    var _data$BPA2, _planDetail$virtualBu, _planDetail$virtualBu2, _planDetail$virtualBu3, _planDetail$virtualBu4, _planDetail$virtualBu5, _planDetail$planInfoP, _planDetail$plot2, _planDetail$blocks2, _planDetail$virtualBu6, _planDetail$parkingDe, _planDetail$parkingDe2, _Digit;
    console.log(isRescrutiny, "isRescrutinyyyyyy");
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    let _applicationData2 = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA2 = data.BPA) === null || _data$BPA2 === void 0 ? void 0 : _data$BPA2[0]);
    _applicationData2 = {
      ..._applicationData2,
      applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
      occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
      edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
      totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu = planDetail.virtualBuilding) === null || _planDetail$virtualBu === void 0 ? void 0 : _planDetail$virtualBu.totalBuitUpArea,
      totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu2 = planDetail.virtualBuilding) === null || _planDetail$virtualBu2 === void 0 ? void 0 : _planDetail$virtualBu2.totalProposedArea,
      totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu3 = planDetail.virtualBuilding) === null || _planDetail$virtualBu3 === void 0 ? void 0 : _planDetail$virtualBu3.totalExistingBuiltUpArea,
      maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu4 = planDetail.virtualBuilding) === null || _planDetail$virtualBu4 === void 0 ? void 0 : (_planDetail$virtualBu5 = _planDetail$virtualBu4.totalCoverageArea) === null || _planDetail$virtualBu5 === void 0 ? void 0 : _planDetail$virtualBu5.toFixed(2)) || null,
      typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
      propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP = planDetail.planInfoProperties) === null || _planDetail$planInfoP === void 0 ? void 0 : _planDetail$planInfoP.PROPERTY_TYPE)),
      proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
      revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
      khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
      khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
      plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot2 = planDetail.plot) === null || _planDetail$plot2 === void 0 ? void 0 : _planDetail$plot2.area) || 0,
      totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
      blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
      noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks2 = planDetail.blocks) === null || _planDetail$blocks2 === void 0 ? void 0 : _planDetail$blocks2.length) || 0,
      premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu6 = planDetail.virtualBuilding) === null || _planDetail$virtualBu6 === void 0 ? void 0 : _planDetail$virtualBu6.premiumFarArea) || 0,
      demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
      parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe = planDetail.parkingDetails) === null || _planDetail$parkingDe === void 0 ? void 0 : _planDetail$parkingDe.overAllParkingArea) || 0,
      parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe2 = planDetail.parkingDetails) === null || _planDetail$parkingDe2 === void 0 ? void 0 : _planDetail$parkingDe2.parkingFloorNo) || 0,
      activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0,
      riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
      planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
      updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
      dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
      sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
      isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
      far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
      setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo
    };
    return {
      applicationData: _applicationData2,
      isAppDataLoading
    };
  }
  const applicationType = "FORM_MAP";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
  const applicationData = {
    tenantId,
    applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
    applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
    applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
    occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
    edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
    totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu7 = planDetail.virtualBuilding) === null || _planDetail$virtualBu7 === void 0 ? void 0 : _planDetail$virtualBu7.totalBuitUpArea,
    totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu8 = planDetail.virtualBuilding) === null || _planDetail$virtualBu8 === void 0 ? void 0 : _planDetail$virtualBu8.totalProposedArea,
    totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu9 = planDetail.virtualBuilding) === null || _planDetail$virtualBu9 === void 0 ? void 0 : _planDetail$virtualBu9.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu10 = planDetail.virtualBuilding) === null || _planDetail$virtualBu10 === void 0 ? void 0 : (_planDetail$virtualBu11 = _planDetail$virtualBu10.totalCoverageArea) === null || _planDetail$virtualBu11 === void 0 ? void 0 : _planDetail$virtualBu11.toFixed(2)) || null,
    typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
    propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP2 = planDetail.planInfoProperties) === null || _planDetail$planInfoP2 === void 0 ? void 0 : _planDetail$planInfoP2.PROPERTY_TYPE)),
    proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
    revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
    khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
    khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
    plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot3 = planDetail.plot) === null || _planDetail$plot3 === void 0 ? void 0 : _planDetail$plot3.area) || 0,
    plotAreaDoc: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaDoc,
    plotAreaPos: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaPossession,
    siteAddress: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landAddress,
    totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
    blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
    noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks3 = planDetail.blocks) === null || _planDetail$blocks3 === void 0 ? void 0 : _planDetail$blocks3.length) || 0,
    premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu12 = planDetail.virtualBuilding) === null || _planDetail$virtualBu12 === void 0 ? void 0 : _planDetail$virtualBu12.premiumFarArea) || 0,
    demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
    parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe3 = planDetail.parkingDetails) === null || _planDetail$parkingDe3 === void 0 ? void 0 : _planDetail$parkingDe3.overAllParkingArea) || 0,
    parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe4 = planDetail.parkingDetails) === null || _planDetail$parkingDe4 === void 0 ? void 0 : _planDetail$parkingDe4.parkingFloorNo) || 0,
    activeTab: ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_TAB")) || 0,
    riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null
    },
    planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
    updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
    dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: planInformation === null || planInformation === void 0 ? void 0 : planInformation.district,
        locality: {
          code: 'Lucknow'
        },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
      },
      tenantId
    },
    professionaldetails: {
      name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId
    },
    landAreaDetails: {
      city: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$city = scrutinyDetails.city) === null || _scrutinyDetails$city === void 0 ? void 0 : _scrutinyDetails$city.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr = planInformation.correspondenceAddress) === null || _planInformation$corr === void 0 ? void 0 : _planInformation$corr.district) || null,
      locality: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$loca = scrutinyDetails.locality) === null || _scrutinyDetails$loca === void 0 ? void 0 : _scrutinyDetails$loca.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr2 = planInformation.correspondenceAddress) === null || _planInformation$corr2 === void 0 ? void 0 : _planInformation$corr2.tehsil) || null
      },
      village: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$vill = scrutinyDetails.village) === null || _scrutinyDetails$vill === void 0 ? void 0 : _scrutinyDetails$vill.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr3 = planInformation.correspondenceAddress) === null || _planInformation$corr3 === void 0 ? void 0 : _planInformation$corr3.town) || null
      },
      areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
    },
    businessService: applicationFlow === 'DA' ? 'BPA_MAPSUB_DA' : 'BPA_MAPSUB_AVP',
    documents,
    natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
    proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
    sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
    sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
    noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
    plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
    district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
    sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
    tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
    revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
    landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
    schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
    buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
    otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
    planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
    buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
    projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
    isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
    prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
    isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
    typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
    plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
    plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
    needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
    plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
    isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
    isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
    isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
    constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
    layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
    layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
    groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
    far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
    isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
    setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
    setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
    setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
    setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
    zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
    isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
    subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
    primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
    activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
    communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
    anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
    khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
    sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
    uiFlow: {
      flow: 'Form12'
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const EmpCompoundingPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _Digit, _Digit2, _Digit3, _Digit$UserService$ge, _location$state, _userRolesArray$, _params$nocList;
  const {
    t,
    params,
    setParams,
    clearParams,
    isCitizen,
    callNotingDetailsAPI,
    notingRemarksData,
    developerRemarks,
    setDeveloperRemarks,
    currentAction,
    mapSubmissionAction,
    onDropDownSelect,
    remarks,
    setRemarks,
    actions,
    uploadedFile,
    setUploadedFile,
    handleSubmit,
    error,
    setError,
    documentSection,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    initialUrl,
    currentView,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    handleDocView,
    handleNoWorkflow,
    documentRemarksData,
    developerNocRemarks,
    isValidEmp,
    taxHead,
    setTaxHead,
    isFeesEligible,
    dataRecommendation,
    daLogo,
    avpLogo,
    setDataRecommendation,
    paymentHeadRemarksData,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callDocumentDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    setUpdatedInspectionReportData,
    callInspectionDetailsAPI,
    handleNoWorkflowNoc,
    currentFormData,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
    updateApiCall
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray);
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [summaryShow, setSummaryshow] = useState(((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARY_TAB")) || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const history = useHistory$2();
  const location = useLocation$1();
  let applicationData = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data;
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) === "JE";
  console.log(applicationData, "applicationDataadata");
  const componentRef = useRef();
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "Land/Plot Information"
  }, {
    label: "Invitation Suggestion"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  console.log("parmsfromPortalMapSubmission", params, params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.length, workflowDetails);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  console.log("hhjjkkklll", formData);
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      console.log("fromHandleTabchange", data, formData, work);
      const isSelfCert = (params === null || params === void 0 ? void 0 : params.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (params === null || params === void 0 ? void 0 : params.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        if (nextTabNo === 5 && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT",
            assignes: null
          };
        } else if (nextTabNo === 5 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (nextTabNo === 5) {
              if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              } else {
                var _params$taxHeadEstima, _Digit4, _Digit5, _Digit6;
                if (isSelfCert) {
                  history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else if ((params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : _params$taxHeadEstima.length) > 1) {
                  var _params$taxHeadEstima2, _params$taxHeadEstima3;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima2 = params.taxHeadEstimates) === null || _params$taxHeadEstima2 === void 0 ? void 0 : (_params$taxHeadEstima3 = _params$taxHeadEstima2[1]) === null || _params$taxHeadEstima3 === void 0 ? void 0 : _params$taxHeadEstima3.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else {
                  var _params$taxHeadEstima4, _params$taxHeadEstima5;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima4 = params.taxHeadEstimates) === null || _params$taxHeadEstima4 === void 0 ? void 0 : (_params$taxHeadEstima5 = _params$taxHeadEstima4[0]) === null || _params$taxHeadEstima5 === void 0 ? void 0 : _params$taxHeadEstima5.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                }
                clearParams();
                Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("EDCR_CREATE");
                (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("FASTPAS_ID");
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("SUMMARY_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("MS_CURRENT_TAB");
                Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
              }
            } else {
              if (nextTabNo === 5) {
                Digit.SessionStorage.set("SUMMARY_TAB", true);
                setSummaryshow(true);
              }
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const handleInvitationSuggestionSave = invitationData => {
    try {
      var _localPress, _localPress2, _localPress3, _params$pressReleaseD, _params$pressDetails, _params$additionalDet, _params$additionalDet2, _params$additionalDet3, _params$additionalDet4, _params$additionalDet5, _params$additionalDet6;
      const appNo = (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (params === null || params === void 0 ? void 0 : params.applicationNo);
      let localPress = null;
      try {
        const raw = appNo && localStorage.getItem(`INVITATION_SUGGESTION_${appNo}`) || localStorage.getItem("INVITATION_SUGGESTION_LATEST");
        if (raw) localPress = JSON.parse(raw);
      } catch (e) {}
      const hasSuggestion = (invitationData === null || invitationData === void 0 ? void 0 : invitationData.hasSuggestion) || ((_localPress = localPress) === null || _localPress === void 0 ? void 0 : _localPress.hasSuggestion) || "";
      const pressReleaseFee = hasSuggestion === "yes" ? (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== undefined && (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== null && (invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee) !== "" ? invitationData === null || invitationData === void 0 ? void 0 : invitationData.pressReleaseFee : ((_localPress2 = localPress) === null || _localPress2 === void 0 ? void 0 : _localPress2.pressReleaseFee) || "" : "";
      const invitationRemark = (invitationData === null || invitationData === void 0 ? void 0 : invitationData.invitationRemark) || ((_localPress3 = localPress) === null || _localPress3 === void 0 ? void 0 : _localPress3.invitationRemark) || "";
      const pressDataToStore = {
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        updatedAt: Date.now()
      };
      try {
        if (appNo) {
          localStorage.setItem(`INVITATION_SUGGESTION_${appNo}`, JSON.stringify(pressDataToStore));
        }
        localStorage.setItem("INVITATION_SUGGESTION_LATEST", JSON.stringify(pressDataToStore));
      } catch (e) {
        console.error("Error storing to localStorage:", e);
      }
      const basePressFromParams = params !== null && params !== void 0 && (_params$pressReleaseD = params.pressReleaseDetails) !== null && _params$pressReleaseD !== void 0 && _params$pressReleaseD.hasSuggestion ? params.pressReleaseDetails : params !== null && params !== void 0 && (_params$pressDetails = params.pressDetails) !== null && _params$pressDetails !== void 0 && _params$pressDetails.hasSuggestion ? params.pressDetails : params !== null && params !== void 0 && (_params$additionalDet = params.additionalDetails) !== null && _params$additionalDet !== void 0 && (_params$additionalDet2 = _params$additionalDet.pressReleaseDetails) !== null && _params$additionalDet2 !== void 0 && _params$additionalDet2.hasSuggestion ? params.additionalDetails.pressReleaseDetails : params !== null && params !== void 0 && (_params$additionalDet3 = params.additionalDetails) !== null && _params$additionalDet3 !== void 0 && (_params$additionalDet4 = _params$additionalDet3.pressDetails) !== null && _params$additionalDet4 !== void 0 && _params$additionalDet4.hasSuggestion ? params.additionalDetails.pressDetails : (params === null || params === void 0 ? void 0 : params.pressReleaseDetails) || (params === null || params === void 0 ? void 0 : params.pressDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet5 = params.additionalDetails) === null || _params$additionalDet5 === void 0 ? void 0 : _params$additionalDet5.pressReleaseDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet6 = params.additionalDetails) === null || _params$additionalDet6 === void 0 ? void 0 : _params$additionalDet6.pressDetails) || localPress || {};
      const pressDetailsObj = {
        ...basePressFromParams,
        hasSuggestion,
        pressReleaseFee,
        invitationRemark
      };
      const additionalDetails = {
        ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {}),
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        pressDetails: pressDetailsObj,
        pressReleaseDetails: pressDetailsObj
      };
      const data = {
        ...params,
        ...invitationData,
        hasSuggestion,
        pressReleaseFee,
        invitationRemark,
        pressDetails: pressDetailsObj,
        pressReleaseDetails: pressDetailsObj,
        additionalDetails: additionalDetails,
        workflow: {
          action: "NOWORKFLOW",
          comments: ""
        }
      };
      console.log("Data to be saved from Invitation Suggestion:", data);
      updateApiCall.mutate({
        BPA: data
      }, {
        onSuccess: res => {
          var _res$BPA, _returnedBPA$addition, _returnedBPA$addition2, _returnedBPA$addition3, _returnedBPA$addition4, _returnedBPA$addition5, _returnedBPA$addition6, _returnedBPA$addition7, _returnedBPA$addition8;
          const returnedBPA = (res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]) || {};
          const pick = (a, b, localFallback) => a && a !== "" ? a : b && b !== "" ? b : localFallback;
          const returnedPress = (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition = returnedBPA.additionalDetails) === null || _returnedBPA$addition === void 0 ? void 0 : _returnedBPA$addition.pressReleaseDetails) || (returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition2 = returnedBPA.additionalDetails) === null || _returnedBPA$addition2 === void 0 ? void 0 : _returnedBPA$addition2.pressDetails);
          const mergedPressRelease = returnedPress !== null && returnedPress !== void 0 && returnedPress.hasSuggestion ? {
            ...pressDetailsObj,
            ...returnedPress
          } : pressDetailsObj;
          const updatedBPA = {
            ...data,
            ...returnedBPA,
            hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition3 = returnedBPA.additionalDetails) === null || _returnedBPA$addition3 === void 0 ? void 0 : _returnedBPA$addition3.hasSuggestion, data.hasSuggestion),
            pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition4 = returnedBPA.additionalDetails) === null || _returnedBPA$addition4 === void 0 ? void 0 : _returnedBPA$addition4.pressReleaseFee, data.pressReleaseFee),
            invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition5 = returnedBPA.additionalDetails) === null || _returnedBPA$addition5 === void 0 ? void 0 : _returnedBPA$addition5.invitationRemark, data.invitationRemark),
            pressDetails: mergedPressRelease,
            pressReleaseDetails: mergedPressRelease,
            additionalDetails: {
              ...((data === null || data === void 0 ? void 0 : data.additionalDetails) || {}),
              ...((returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.additionalDetails) || {}),
              hasSuggestion: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.hasSuggestion, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition6 = returnedBPA.additionalDetails) === null || _returnedBPA$addition6 === void 0 ? void 0 : _returnedBPA$addition6.hasSuggestion, data.hasSuggestion),
              pressReleaseFee: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.pressReleaseFee, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition7 = returnedBPA.additionalDetails) === null || _returnedBPA$addition7 === void 0 ? void 0 : _returnedBPA$addition7.pressReleaseFee, data.pressReleaseFee),
              invitationRemark: pick(returnedBPA === null || returnedBPA === void 0 ? void 0 : returnedBPA.invitationRemark, returnedBPA === null || returnedBPA === void 0 ? void 0 : (_returnedBPA$addition8 = returnedBPA.additionalDetails) === null || _returnedBPA$addition8 === void 0 ? void 0 : _returnedBPA$addition8.invitationRemark, data.invitationRemark),
              pressDetails: mergedPressRelease,
              pressReleaseDetails: mergedPressRelease
            }
          };
          onSelect("", updatedBPA);
          setShowToast({
            error: false,
            message: "Data has been saved successfully"
          });
          handleTabChange(1);
        },
        onError: () => {
          Modal("Update Error", "Something went wrong!!", "error");
        }
      });
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(SubStep6, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            tenantId: tenantId,
            departmentList: departmentList,
            avpData: null,
            isEmployee: !isCitizen,
            isApproved: true
          });
        case 5:
          return /*#__PURE__*/React__default.createElement(InvitationSuggestion, {
            formData: formData,
            handleTabChange: handleTabChange,
            isEmployee: !isCitizen,
            isApproved: true,
            onSaveClick: handleInvitationSuggestionSave
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "mandatory",
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            developerRemarks: developerRemarksDocument,
            setError: setError,
            ComposableComponent: props => {
              var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3, _documentRemarksData$4;
              return /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
                formData: formData,
                title: "Recommendation Details",
                label: "Recommendation",
                name: "recommendation",
                options: SortingAlphabatically(siteInspRecommendation),
                defaultValue: dataRecommendationDocument,
                extraLabel: "Remarks",
                setDeveloperRemarks: setDeveloperRemarksDocument,
                developerRemarks: developerRemarksDocument ? developerNocRemarks : Array.isArray(documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0 ? (_documentRemarksData$ = documentRemarksData.DetailDataRemarks[documentRemarksData.DetailDataRemarks.length - 1]) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$.documentDetails) === null || _documentRemarksData$2 === void 0 ? void 0 : _documentRemarksData$2.developerRemarks : documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$3 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$3 === void 0 ? void 0 : (_documentRemarksData$4 = _documentRemarksData$3.documentDetails) === null || _documentRemarksData$4 === void 0 ? void 0 : _documentRemarksData$4.developerRemarks,
                setDataRecommendation: setDataRecommendationDocument
              }, props, {
                error: error,
                setError: setError
              }));
            }
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            type: "documentDetails"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            docType: "conditional"
          }));
        default:
          return null;
      }
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(CompoundingChecklist, {
        formData: formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen
      });
    } else if (activeTab === 3) {
      var _formData$additionalD, _params$additionalDet7;
      return /*#__PURE__*/React__default.createElement(EmpIdentifyNoc, {
        formData: {
          ...(formData || {}),
          ...(params || {}),
          nocDetails: (params === null || params === void 0 ? void 0 : params.nocDetails) || (formData === null || formData === void 0 ? void 0 : formData.nocDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.nocDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet7 = params.additionalDetails) === null || _params$additionalDet7 === void 0 ? void 0 : _params$additionalDet7.nocDetails),
          additionalDetails: {
            ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
            ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {})
          }
        },
        tenantId: tenantId,
        handleNoWorkflowNoc: handleNoWorkflowNoc,
        isJE: isJE,
        currentFormData: currentFormData
      });
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step4Comp, {
        formData: params || formData,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        onSelect: onSelect
      }), !isCitizen && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
        title: "Recommendation Details",
        label: "Recommendation",
        name: "recommendation",
        defaultValue: dataRecommendation,
        options: SortingAlphabatically(siteInspRecommendation),
        extraLabel: "Remarks",
        setDeveloperRemarks: setDeveloperRemarks,
        developerRemarks: developerRemarks,
        setDataRecommendation: setDataRecommendation,
        names: "multiSelectField",
        type: "drawingDetails",
        buttonshow: true,
        onSaveClick: callDrawingDetailsAPI,
        handleTabChange: handleTabChange,
        nextTab: 4
      }), /*#__PURE__*/React__default.createElement(DrawingsDetailsTable, {
        detailData: siteDrawingRemarksData === null || siteDrawingRemarksData === void 0 ? void 0 : siteDrawingRemarksData.DetailDataRemarks
      })));
    } else if (activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BasicSiteInspectionReport, {
        formData: params,
        setCurrentTab: handleTabChange,
        setUpdatedInspectionReportData: setUpdatedInspectionReportData,
        callInspectionDetailsAPI: callInspectionDetailsAPI,
        userRolesArray: userRolesArray,
        onSelect: onSelect
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: siteInspectionRemarksData === null || siteInspectionRemarksData === void 0 ? void 0 : siteInspectionRemarksData.DetailDataRemarks,
        type: "inspectionDetails",
        formData: formData
      }));
    } else if (activeTab === 6) {
      var _userRolesArray$2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaymentHead, {
        tenantId: tenantId,
        formData: params,
        setTaxHead: setTaxHead,
        taxHead: taxHead,
        empRole: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code,
        isFeesEligible: isFeesEligible,
        onSelect: setParams,
        Modal: Modal,
        isValidEmp: isValidEmp,
        isCompounding: isCompounding
      }), /*#__PURE__*/React__default.createElement(PaymentMemoTable, {
        formData: params,
        logoData: (formData === null || formData === void 0 ? void 0 : formData.department) == "DA" ? daLogo : avpLogo
      }), /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, {
        title: "Recommendation Details",
        label: "Recommendation",
        name: "recommendation",
        options: SortingAlphabatically(siteInspRecommendation),
        defaultValue: dataRecommendation,
        extraLabel: "Remarks",
        setDeveloperRemarks: setDeveloperRemarks,
        developerRemarks: developerRemarks,
        setDataRecommendation: setDataRecommendation,
        onSaveClick: callPaymentDetailsAPI,
        buttonshow: true,
        error: error,
        setError: setError
      }), /*#__PURE__*/React__default.createElement(DetailInfoTable, {
        detailData: paymentHeadRemarksData === null || paymentHeadRemarksData === void 0 ? void 0 : paymentHeadRemarksData.DetailDataRemarks,
        type: "paymentDetails"
      }));
    } else if (activeTab === 7) {
      var _formData$status;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Compounding"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData
      }), (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen
      }), /*#__PURE__*/React__default.createElement(CollapsibleAdditionalRemarks, {
        formData: params || formData,
        additionalComment: additionalComment,
        setAdditionalComment: setAdditionalComment,
        handleSubmit: () => {
          var _additionalComment$tr;
          console.log("additionalComment12", additionalComment);
          if (((_additionalComment$tr = additionalComment.trim()) === null || _additionalComment$tr === void 0 ? void 0 : _additionalComment$tr.length) === 0) {
            return;
          }
          handleAdditionalComment();
        }
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      })));
    } else if (activeTab === 8) {
      return /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      });
    } else if (activeTab === 9) {
      var _workflowDetails$data;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData,
        assignerToChatboard: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.processInstances
      }));
    }
  };
  console.log("activeTab.........", activeTab);
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Compounding")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Compounding Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "NOC Status"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Site Inspection"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Payment Head Compounding"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Remarks History"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const SitePhotoChecklistSection = ({
  formData,
  isEmployee: _isEmployee = true,
  isValidEmp,
  workflowDetails,
  documents: _documents = [],
  onDocumentsChange,
  onSavePhotos,
  setParams,
  onSelect
}) => {
  var _Digit$UserService$ge, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    addFormMTDoc,
    removeFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const currentAssignees = (formData === null || formData === void 0 ? void 0 : formData.assignes) || (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.processInstances) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2[0]) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.assignes) || [];
  const isAssignee = _isEmployee && ((currentAssignees === null || currentAssignees === void 0 ? void 0 : currentAssignees.length) > 0 ? currentAssignees.some(u => (u === null || u === void 0 ? void 0 : u.uuid) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid)) : isValidEmp !== undefined ? isValidEmp : true);
  const [totalSlots, setTotalSlots] = useState(() => {
    const existingPhotoIndexes = (_documents || []).map(doc => {
      var _doc$documentType, _doc$documentType$toL;
      const match = doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : (_doc$documentType$toL = _doc$documentType.toLowerCase()) === null || _doc$documentType$toL === void 0 ? void 0 : _doc$documentType$toL.match(/^sitephoto(\d+)$/);
      return match ? parseInt(match[1], 10) : 0;
    }).filter(n => n > 0);
    const maxIndex = existingPhotoIndexes.length > 0 ? Math.max(...existingPhotoIndexes) : 4;
    return Math.max(4, maxIndex);
  });
  const [uploadingSlot, setUploadingSlot] = useState(null);
  const [slotThumbnails, setSlotThumbnails] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewLoading, setPreviewLoading] = useState(false);
  const fileInputRefs = useRef({});
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const slotThumbnailsRef = useRef(slotThumbnails);
  useEffect(() => {
    slotThumbnailsRef.current = slotThumbnails;
  }, [slotThumbnails]);
  const currentSessionUploadedSlots = useRef(new Set());
  const initialDocsRecordedRef = useRef(false);
  const initialPreUploadedSlots = useRef(new Set());
  const initialPreUploadedFileStoreIds = useRef(new Set());
  useEffect(() => {
    if (!initialDocsRecordedRef.current && (_documents || []).length > 0) {
      (_documents || []).forEach(doc => {
        if (doc !== null && doc !== void 0 && doc.fileStoreId) {
          var _doc$documentType2, _doc$documentType2$to;
          initialPreUploadedFileStoreIds.current.add(doc.fileStoreId);
          const match = doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : (_doc$documentType2$to = _doc$documentType2.toLowerCase()) === null || _doc$documentType2$to === void 0 ? void 0 : _doc$documentType2$to.match(/^sitephoto(\d+)$/);
          if (match) {
            initialPreUploadedSlots.current.add(parseInt(match[1], 10));
          }
        }
      });
      initialDocsRecordedRef.current = true;
    }
  }, [_documents]);
  const canModifySlot = (doc, slotNumber) => {
    var _doc$additionalDetail, _doc$auditDetails, _doc$additionalDetail2;
    if (!isAssignee) return false;
    if (!(doc !== null && doc !== void 0 && doc.fileStoreId)) return false;
    if (currentSessionUploadedSlots.current.has(slotNumber)) {
      return true;
    }
    const uploadedUuid = (doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.uploadedByUuid) || (doc === null || doc === void 0 ? void 0 : (_doc$auditDetails = doc.auditDetails) === null || _doc$auditDetails === void 0 ? void 0 : _doc$auditDetails.createdBy);
    if (uploadedUuid && userInfo !== null && userInfo !== void 0 && userInfo.uuid && uploadedUuid !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid)) {
      return false;
    }
    const uploadedName = doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail2 = doc.additionalDetails) === null || _doc$additionalDetail2 === void 0 ? void 0 : _doc$additionalDetail2.uploadedBy;
    const currentUserName = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName);
    if (uploadedName && currentUserName && uploadedName !== "Officer" && uploadedName.toLowerCase().trim() !== currentUserName.toLowerCase().trim()) {
      return false;
    }
    if (initialPreUploadedSlots.current.has(slotNumber) || doc !== null && doc !== void 0 && doc.fileStoreId && initialPreUploadedFileStoreIds.current.has(doc.fileStoreId)) {
      return false;
    }
    return false;
  };
  const getDocForSlot = slotNumber => {
    const targetType = `sitephoto${slotNumber}`.toLowerCase();
    return (_documents || []).find(doc => {
      var _doc$documentType3;
      return (doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.toLowerCase()) === targetType;
    });
  };
  const uploadedPhotosCount = (_documents || []).filter(doc => {
    var _doc$documentType4, _doc$documentType4$to;
    return (doc === null || doc === void 0 ? void 0 : (_doc$documentType4 = doc.documentType) === null || _doc$documentType4 === void 0 ? void 0 : (_doc$documentType4$to = _doc$documentType4.toLowerCase()) === null || _doc$documentType4$to === void 0 ? void 0 : _doc$documentType4$to.startsWith("sitephoto")) || (doc === null || doc === void 0 ? void 0 : doc.documentType) === "sitePhoto";
  }).length;
  useEffect(() => {
    let isCurrent = true;
    const loadThumbnails = async () => {
      const neededDocs = [];
      for (let i = 1; i <= totalSlots; i++) {
        const doc = getDocForSlot(i);
        if (doc !== null && doc !== void 0 && doc.fileStoreId && !slotThumbnailsRef.current[doc.fileStoreId]) {
          neededDocs.push(doc.fileStoreId);
        }
      }
      if (neededDocs.length === 0) return;
      const results = await Promise.all(neededDocs.map(async fileStoreId => {
        try {
          const url = await getDocumentByFileStoreId(fileStoreId, () => {}, true);
          return {
            fileStoreId,
            url: typeof url === "string" ? url : null
          };
        } catch (err) {
          console.error(`Failed to load thumbnail for ${fileStoreId}:`, err);
          return {
            fileStoreId,
            url: null
          };
        }
      }));
      if (isCurrent && isMountedRef.current) {
        const newUrls = {};
        results.forEach(({
          fileStoreId,
          url
        }) => {
          if (url) {
            newUrls[fileStoreId] = url;
          }
        });
        if (Object.keys(newUrls).length > 0) {
          setSlotThumbnails(prev => ({
            ...prev,
            ...newUrls
          }));
        }
      }
    };
    loadThumbnails();
    return () => {
      isCurrent = false;
    };
  }, [_documents, totalSlots]);
  const handleSlotUpload = async (e, slotNumber) => {
    var _e$target$files;
    const file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    if (!file) return;
    const existingDoc = getDocForSlot(slotNumber);
    if (existingDoc && !canModifySlot(existingDoc, slotNumber)) {
      setErrorMessage(t("Pre-uploaded photographs from previous officer cannot be replaced or removed."));
      if (fileInputRefs.current[slotNumber]) {
        fileInputRefs.current[slotNumber].value = null;
      }
      return;
    }
    setErrorMessage("");
    setSuccessMessage("");
    setUploadingSlot(slotNumber);
    const allowedExtensions = [".png", ".jpg", ".jpeg", ".webp"];
    const fileExtension = "." + file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      setErrorMessage(t("Invalid file format. Please upload .jpg, .jpeg, or .png image."));
      setUploadingSlot(null);
      e.target.value = null;
      return;
    }
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      setErrorMessage(t("File size exceeds 10 MB limit."));
      setUploadingSlot(null);
      e.target.value = null;
      return;
    }
    const invalidMalwareExtensions = ["php", "exe", "bat", "cmd", "sh", "com", "scr", "msi", "jar", "vbs", "ps1", "dll", "htm", "html", "js", "svg"];
    const parts = file.name.toLowerCase().split(".");
    if (parts.slice(0, -1).some(part => invalidMalwareExtensions.includes(part))) {
      setErrorMessage(t("File name contains potentially unsafe extensions."));
      setUploadingSlot(null);
      e.target.value = null;
      return;
    }
    const payload = new FormData();
    payload.append("file", file);
    payload.append("tenantId", "up");
    payload.append("module", "property-upload");
    payload.append("tag", "tag-property");
    try {
      var _resp$data, _resp$data$files;
      const resp = await axios$1.post("/filestore/v1/files", payload, {});
      const uploadedFile = resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : (_resp$data$files = _resp$data.files) === null || _resp$data$files === void 0 ? void 0 : _resp$data$files[0];
      if (!(uploadedFile !== null && uploadedFile !== void 0 && uploadedFile.fileStoreId)) {
        throw new Error("FileStore ID not received.");
      }
      const photoKey = `sitephoto${slotNumber}`;
      const newDoc = {
        documentType: photoKey,
        fileStoreId: uploadedFile.fileStoreId,
        isMandatory: false,
        additionalDetails: {
          fileName: file.name,
          title: `Site Photo ${slotNumber}`,
          uploadedBy: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName) || "Officer",
          uploadedByUuid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid) || "",
          uploadedDate: new Date().toISOString()
        }
      };
      const remainingDocs = (_documents || []).filter(d => {
        var _d$documentType;
        return (d === null || d === void 0 ? void 0 : (_d$documentType = d.documentType) === null || _d$documentType === void 0 ? void 0 : _d$documentType.toLowerCase()) !== photoKey.toLowerCase();
      });
      const updatedDocs = [...remainingDocs, newDoc];
      addFormMTDoc(newDoc);
      currentSessionUploadedSlots.current.add(slotNumber);
      if (onDocumentsChange) {
        onDocumentsChange(updatedDocs);
      }
      if (setParams) {
        setParams(prev => ({
          ...(prev || {}),
          documents: updatedDocs
        }));
      }
      if (onSelect) {
        onSelect("", {
          ...(formData || {}),
          documents: updatedDocs
        });
      }
      if (isMountedRef.current) {
        setSuccessMessage(t(`Site Photo ${slotNumber} uploaded successfully.`));
      }
    } catch (err) {
      console.error("Upload error:", err);
      if (isMountedRef.current) {
        setErrorMessage(t("Failed to upload image. Please try again."));
      }
    } finally {
      if (isMountedRef.current) {
        setUploadingSlot(null);
      }
      if (fileInputRefs.current[slotNumber]) {
        fileInputRefs.current[slotNumber].value = null;
      }
    }
  };
  const handleDeleteSlot = slotNumber => {
    if (!isAssignee) return;
    const photoKey = `sitephoto${slotNumber}`;
    const docToDelete = getDocForSlot(slotNumber);
    if (!docToDelete || !canModifySlot(docToDelete, slotNumber)) {
      setErrorMessage(t("Pre-uploaded photographs from previous officer cannot be replaced or removed."));
      return;
    }
    const updatedDocs = (_documents || []).filter(d => {
      var _d$documentType2;
      return (d === null || d === void 0 ? void 0 : (_d$documentType2 = d.documentType) === null || _d$documentType2 === void 0 ? void 0 : _d$documentType2.toLowerCase()) !== photoKey.toLowerCase();
    });
    removeFormMTDoc(photoKey);
    currentSessionUploadedSlots.current.delete(slotNumber);
    if (docToDelete !== null && docToDelete !== void 0 && docToDelete.fileStoreId && isMountedRef.current) {
      setSlotThumbnails(prev => {
        const copy = {
          ...prev
        };
        delete copy[docToDelete.fileStoreId];
        return copy;
      });
    }
    if (onDocumentsChange) {
      onDocumentsChange(updatedDocs);
    }
    if (setParams) {
      setParams(prev => ({
        ...(prev || {}),
        documents: updatedDocs
      }));
    }
    if (onSelect) {
      onSelect("", {
        ...(formData || {}),
        documents: updatedDocs
      });
    }
    if (isMountedRef.current) {
      setSuccessMessage(t(`Site Photo ${slotNumber} removed.`));
    }
  };
  const handleOpenPreview = async (doc, slotNumber) => {
    var _doc$additionalDetail3, _doc$additionalDetail4;
    if (!(doc !== null && doc !== void 0 && doc.fileStoreId)) return;
    setPreviewDoc({
      ...doc,
      slotNumber,
      title: ((_doc$additionalDetail3 = doc.additionalDetails) === null || _doc$additionalDetail3 === void 0 ? void 0 : _doc$additionalDetail3.title) || `Site Photo ${slotNumber}`,
      fileName: ((_doc$additionalDetail4 = doc.additionalDetails) === null || _doc$additionalDetail4 === void 0 ? void 0 : _doc$additionalDetail4.fileName) || `sitephoto${slotNumber}.jpg`
    });
    setPreviewOpen(true);
    setPreviewLoading(true);
    try {
      const url = await getDocumentByFileStoreId(doc.fileStoreId, () => {}, true);
      if (isMountedRef.current) {
        setPreviewUrl(url || "");
      }
    } catch (err) {
      console.error("Error loading preview URL:", err);
    } finally {
      if (isMountedRef.current) {
        setPreviewLoading(false);
      }
    }
  };
  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewDoc(null);
    setPreviewUrl("");
  };
  const handleOpenInNewTab = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    } else if (previewDoc !== null && previewDoc !== void 0 && previewDoc.fileStoreId) {
      getDocumentByFileStoreId(previewDoc.fileStoreId, () => {}, false);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: "24px",
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      paddingBottom: "8px",
      borderBottom: "2px solid #157CB3"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(PhotoCameraIcon, {
    sx: {
      color: "#157CB3",
      fontSize: "1.75rem"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      margin: 0,
      fontSize: "1.25rem",
      color: "#0B0C0C"
    }
  }, t("Site Inspection Photographs")), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    sx: {
      color: "#505A5F",
      display: "block"
    }
  }, t("Upload and review site verification photographs. Upload is enabled for the assigned officer; all subsequent levels can review.")))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      mt: {
        xs: 1,
        sm: 0
      }
    }
  })), errorMessage && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      backgroundColor: "#ffebee",
      color: "#c62828",
      p: 1.5,
      borderRadius: 1,
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, errorMessage)), successMessage && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      backgroundColor: "#e8f5e9",
      color: "#2e7d32",
      p: 1.5,
      borderRadius: 1,
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, successMessage)), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 2.5
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2.5
  }, Array.from({
    length: totalSlots
  }, (_, i) => i + 1).map(slotNum => {
    var _doc$additionalDetail5, _doc$additionalDetail6;
    const doc = getDocForSlot(slotNum);
    const isUploaded = Boolean(doc === null || doc === void 0 ? void 0 : doc.fileStoreId);
    const thumbnailUrl = doc !== null && doc !== void 0 && doc.fileStoreId ? slotThumbnails[doc.fileStoreId] : null;
    const isSlotUploading = uploadingSlot === slotNum;
    const canModify = canModifySlot(doc, slotNum);
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3,
      key: slotNum
    }, /*#__PURE__*/React__default.createElement(Card$1, {
      variant: "outlined",
      sx: {
        borderRadius: "8px",
        borderColor: isUploaded ? "#81c784" : "#e0e0e0",
        backgroundColor: isUploaded ? "#f9fcf9" : "#fafafa",
        transition: "all 0.2s ease-in-out",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          borderColor: isUploaded ? "#4caf50" : "#157CB3"
        }
      }
    }, /*#__PURE__*/React__default.createElement(CardContent, {
      sx: {
        p: 2,
        flex: 1,
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1.5
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle2",
      sx: {
        fontWeight: 700,
        color: "#0B0C0C"
      }
    }, t(`Site Photo ${slotNum}`))), isUploaded ? /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        flex: 1,
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      onClick: () => handleOpenPreview(doc, slotNum),
      sx: {
        height: "140px",
        backgroundColor: "#e0e0e0",
        borderRadius: "6px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "relative",
        border: "1px solid #c8e6c9",
        "&:hover .overlay": {
          opacity: 1
        }
      }
    }, thumbnailUrl ? /*#__PURE__*/React__default.createElement("img", {
      src: thumbnailUrl,
      alt: `Site Photo ${slotNum}`,
      style: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    }) : /*#__PURE__*/React__default.createElement(PhotoCameraIcon, {
      sx: {
        fontSize: "3rem",
        color: "#9e9e9e"
      }
    }), /*#__PURE__*/React__default.createElement(Box, {
      className: "overlay",
      sx: {
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        opacity: 0,
        transition: "opacity 0.2s",
        gap: 0.5
      }
    }, /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        fontWeight: 600
      }
    }, t("Click to View")))), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        mt: 1,
        flex: 1
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        display: "block",
        fontWeight: 600,
        color: "#333",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      title: ((_doc$additionalDetail5 = doc.additionalDetails) === null || _doc$additionalDetail5 === void 0 ? void 0 : _doc$additionalDetail5.fileName) || `sitephoto${slotNum}.jpg`
    }, ((_doc$additionalDetail6 = doc.additionalDetails) === null || _doc$additionalDetail6 === void 0 ? void 0 : _doc$additionalDetail6.fileName) || `sitephoto${slotNum}.jpg`)), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 1.5,
        pt: 1,
        borderTop: "1px dashed #e0e0e0"
      }
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "outlined",
      startIcon: /*#__PURE__*/React__default.createElement(VisibilityIcon, {
        fontSize: "small"
      }),
      onClick: () => handleOpenPreview(doc, slotNum),
      sx: {
        textTransform: "none",
        fontSize: "0.72rem",
        py: 0.25,
        px: 1,
        borderColor: "#157CB3",
        color: "#157CB3"
      }
    }, t("View")), canModify ? /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        gap: 0.5
      }
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "text",
      onClick: () => {
        var _fileInputRefs$curren;
        return (_fileInputRefs$curren = fileInputRefs.current[slotNum]) === null || _fileInputRefs$curren === void 0 ? void 0 : _fileInputRefs$curren.click();
      },
      sx: {
        textTransform: "none",
        fontSize: "0.72rem",
        color: "#0277bd",
        minWidth: "auto",
        p: 0.5
      }
    }, t("Replace")), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      onClick: () => handleDeleteSlot(slotNum),
      title: t("Remove photograph")
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, {
      fontSize: "small"
    }))) : null)) :
    /*#__PURE__*/
    React__default.createElement(Box, {
      sx: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "140px",
        border: "2px dashed #cfd8dc",
        borderRadius: "6px",
        p: 1.5,
        textAlign: "center",
        backgroundColor: "#fdfdfd"
      }
    }, isSlotUploading ? /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#157CB3"
      }
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        color: "#555"
      }
    }, t("Uploading..."))) : isAssignee ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, {
      sx: {
        fontSize: "2.5rem",
        color: "#157CB3",
        mb: 0.5
      }
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        color: "#505A5F",
        mb: 1,
        display: "block"
      }
    }, t("JPG, PNG up to 10MB")), /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "contained",
      size: "small",
      onClick: () => {
        var _fileInputRefs$curren2;
        return (_fileInputRefs$curren2 = fileInputRefs.current[slotNum]) === null || _fileInputRefs$curren2 === void 0 ? void 0 : _fileInputRefs$curren2.click();
      },
      sx: {
        textTransform: "none",
        fontSize: "0.75rem",
        backgroundColor: "#157CB3",
        "&:hover": {
          backgroundColor: "#0b5177"
        }
      }
    }, t("Upload Photo"))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LockIcon, {
      sx: {
        fontSize: "2rem",
        color: "#bdbdbd",
        mb: 0.5
      }
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        color: "#9e9e9e"
      }
    }, t("No photo uploaded")), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      sx: {
        color: "#bdbdbd",
        fontSize: "0.65rem",
        mt: 0.5
      }
    }, t("Upload disabled")))), /*#__PURE__*/React__default.createElement("input", {
      type: "file",
      ref: el => fileInputRefs.current[slotNum] = el,
      accept: "image/png,image/jpeg,image/jpg,image/webp",
      style: {
        display: "none"
      },
      onChange: e => handleSlotUpload(e, slotNum),
      disabled: !isAssignee || isSlotUploading || isUploaded && !canModify
    }))));
  }))), isAssignee && totalSlots < 10 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 2,
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    variant: "text",
    startIcon: /*#__PURE__*/React__default.createElement(AddCircleOutlineIcon, null),
    onClick: () => setTotalSlots(prev => prev + 1),
    sx: {
      textTransform: "none",
      color: "#157CB3",
      fontWeight: 600
    }
  }, t("+ Add Another Photograph Slot"))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: previewOpen,
    onClose: handleClosePreview,
    maxWidth: "md",
    fullWidth: true,
    "aria-labelledby": "site-photo-preview-title"
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "site-photo-preview-title",
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid #e0e0e0",
      py: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(PhotoCameraIcon, {
    sx: {
      color: "#157CB3"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      fontSize: "1.1rem",
      fontWeight: 600
    }
  }, (previewDoc === null || previewDoc === void 0 ? void 0 : previewDoc.title) || t("Site Photograph Preview")), (previewDoc === null || previewDoc === void 0 ? void 0 : previewDoc.documentType) && /*#__PURE__*/React__default.createElement(Chip, {
    size: "small",
    label: previewDoc.documentType,
    sx: {
      fontSize: "0.7rem",
      height: "20px"
    }
  })), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleClosePreview,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 3,
      minHeight: "350px",
      backgroundColor: "#f5f5f5"
    }
  }, previewLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#157CB3"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#555"
    }
  }, t("Loading full resolution image..."))) : previewUrl ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: "100%",
      maxHeight: "70vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: previewUrl,
    alt: (previewDoc === null || previewDoc === void 0 ? void 0 : previewDoc.title) || "Site Photograph",
    style: {
      maxWidth: "100%",
      maxHeight: "70vh",
      objectFit: "contain",
      display: "block"
    }
  })) : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#c62828"
    }
  }, t("Unable to load preview image.")), (previewDoc === null || previewDoc === void 0 ? void 0 : previewDoc.additionalDetails) && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 2,
      textAlign: "center",
      color: "#616161"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    sx: {
      display: "block",
      fontWeight: 600
    }
  }, previewDoc.additionalDetails.fileName))), /*#__PURE__*/React__default.createElement(DialogActions, {
    sx: {
      p: 1.5,
      borderTop: "1px solid #e0e0e0"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    startIcon: /*#__PURE__*/React__default.createElement(OpenInNewIcon, null),
    onClick: handleOpenInNewTab,
    sx: {
      textTransform: "none",
      color: "#157CB3"
    }
  }, t("Open Original in New Tab")), /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClosePreview,
    variant: "contained",
    sx: {
      textTransform: "none",
      backgroundColor: "#757575"
    }
  }, t("Close")))));
};

const PUBLIC_FACILITY_OPTIONS = ["Primary school", "Higher Secondary School", "Degree College", "Dispensary", "Hospital", "Post Office", "Community Centre", "Police Station", "Fire Station", "Telephone Exchange", "Bus Station", "Taxi Stand", "Public Facilities", "Other Facilities"];
const yesNoNaOptions = [{
  value: "yes",
  label: "Yes",
  name: "Yes"
}, {
  value: "no",
  label: "No",
  name: "No"
}, {
  value: "na",
  label: "NA",
  name: "NA"
}];
const DEVELOPMENT_WORK_ON_MAP_CONFIG = [{
  sNo: "(i)",
  name: "facilities.roadsProvided",
  remarksName: "facilities.roadsProvidedRemarks",
  feature: "Roads",
  fieldKey: "roadsProvided",
  remarksKey: "roadsProvidedRemarks"
}, {
  sNo: "(ii)",
  name: "facilities.roadsideTree",
  remarksName: "facilities.roadsideTreeRemarks",
  feature: "Roadside tree planting (arboriculture)",
  fieldKey: "roadsideTree",
  remarksKey: "roadsideTreeRemarks"
}, {
  sNo: "(iii)",
  name: "facilities.culvert",
  remarksName: "facilities.culvertRemarks",
  feature: "Culvert",
  fieldKey: "culvert",
  remarksKey: "culvertRemarks"
}, {
  sNo: "(iv)",
  name: "facilities.lightingSystem",
  remarksName: "facilities.lightingSystemRemarks",
  feature: "Street lighting system",
  fieldKey: "lightingSystem",
  remarksKey: "lightingSystemRemarks"
}, {
  sNo: "(v)",
  name: "facilities.drinkingWater",
  remarksName: "facilities.drinkingWaterRemarks",
  feature: "Drinking water distribution system in which sluice valves, air valves, fire hydrants are shown and the diameter of underground water pipes is indicated.",
  fieldKey: "drinkingWater",
  remarksKey: "drinkingWaterRemarks"
}, {
  sNo: "(vi)",
  name: "facilities.tankLocation",
  remarksName: "facilities.tankLocationRemarks",
  feature: "Location of overhead tanks and underground reservoirs and their capacity, number of pumps and their capacity.",
  fieldKey: "tankLocation",
  remarksKey: "tankLocationRemarks"
}, {
  sNo: "(vii)",
  name: "facilities.sewerSystem",
  remarksName: "facilities.sewerSystemRemarks",
  feature: "Sewer system including diameter of pipes, location of main holes, gully pits giving invert labels.",
  fieldKey: "sewerSystem",
  remarksKey: "sewerSystemRemarks"
}, {
  sNo: "(viii)",
  name: "facilities.sewerLocation",
  remarksName: "facilities.sewerLocationRemarks",
  feature: "Location of sewage, pumping station, its capacity and number and capacity of pumps (if the said development has been done by the developer).",
  fieldKey: "sewerLocation",
  remarksKey: "sewerLocationRemarks"
}, {
  sNo: "(ix)",
  name: "facilities.rainwaterDrainage",
  remarksName: "facilities.rainwaterDrainageRemarks",
  feature: "Rainwater drainage system.",
  fieldKey: "rainwaterDrainage",
  remarksKey: "rainwaterDrainageRemarks"
}, {
  sNo: "(x)",
  name: "facilities.powerSupplySystem",
  remarksName: "facilities.powerSupplySystemRemarks",
  feature: "Power supply system indicating the location of transformers and 11 KVA sub-stations and the capacity of transformers.",
  fieldKey: "powerSupplySystem",
  remarksKey: "powerSupplySystemRemarks"
}, {
  sNo: "(xi)",
  name: "facilities.sewerDischarge",
  remarksName: "facilities.sewerDischargeRemarks",
  feature: "Final discharge of sewer-details of connection with trunk sewer lines of Development Authority/ Housing and Development Board/ Local Body etc.",
  fieldKey: "sewerDischarge",
  remarksKey: "sewerDischargeRemarks"
}, {
  sNo: "(xii)",
  name: "facilities.groundWater",
  remarksName: "facilities.groundWaterRemarks",
  feature: "Ground water recharging system.",
  fieldKey: "groundWater",
  remarksKey: "groundWaterRemarks"
}];
const CITY_INFRASTRUCTURE_CONFIG = [{
  sNo: "(i)",
  name: "facilities.roadsConnectivity",
  remarksName: "facilities.roadsConnectivityRemarks",
  feature: "Roads",
  fieldKey: "roadsConnectivity",
  remarksKey: "roadsConnectivityRemarks"
}, {
  sNo: "(ii)",
  name: "facilities.drainageProvision",
  remarksName: "facilities.drainageProvisionRemarks",
  feature: "Drainage Provision (connection to trunk drain)",
  fieldKey: "drainageProvision",
  remarksKey: "drainageProvisionRemarks"
}, {
  sNo: "(iii)",
  name: "facilities.drinkingWaterArrangement",
  remarksName: "facilities.drinkingWaterArrangementRemarks",
  feature: "Arrangement of drinking water (connection arrangement with Jal Sansthan/ Development Authority/ Local Body etc.)",
  fieldKey: "drinkingWaterArrangement",
  remarksKey: "drinkingWaterArrangementRemarks"
}, {
  sNo: "(iv)",
  name: "facilities.electricalSystem",
  remarksName: "facilities.electricalSystemRemarks",
  feature: "Electrical system (status of connection to 33 KVA/11 KVA line and status of transformer)",
  fieldKey: "electricalSystem",
  remarksKey: "electricalSystemRemarks"
}, {
  sNo: "(v)",
  name: "facilities.sewerConnection",
  remarksName: "facilities.sewerConnectionRemarks",
  feature: "Position of connection to sewer/ trunk sewer",
  fieldKey: "sewerConnection",
  remarksKey: "sewerConnectionRemarks"
}];
const CompletionChecklist = ({
  formData,
  isEmployee,
  isApproved,
  handleTabChange,
  isCitizen,
  isValidEmp,
  workflowDetails,
  setParams,
  onSelect,
  onTabChange
}) => {
  var _formData$completionC, _formData$completionC2, _formData$completionC3, _formData$completionC4, _formData$completionC5, _formData$completionC6, _formData$completionC7, _formData$completionC8, _formData$completionC9, _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo4$o3, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$description5, _formData$description6, _formData$description7, _formData$completionC14, _formData$completionC15, _formData$completionC16, _formData$completionC17, _formData$completionC18, _formData$completionC19, _formData$completionC20, _formData$completionC21, _formData$completionC22, _formData$completionC23, _formData$completionC24, _formData$completionC25, _formData$completionC26, _formData$completionC27, _formData$completionC28, _formData$completionC29;
  console.log("insidechecklistcompletion", formData);
  const {
    t
  } = useTranslation();
  const identifyLayoutCase = (data, watchedAct) => {
    var _data$descriptionOfLa;
    const act = (watchedAct || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa = data.descriptionOfLand) === null || _data$descriptionOfLa === void 0 ? void 0 : _data$descriptionOfLa.activityProposed) || (data === null || data === void 0 ? void 0 : data.activityProposed) || "").toString().toLowerCase();
    if (act.includes("layout") || act.includes("plotted development")) {
      return true;
    } else return false;
  };
  const emptyLandUseRow = {
    category: "",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  };
  const defaultLandUseRows = [{
    id: 1,
    category: "Residential",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  }, {
    id: 2,
    category: "Commercial",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  }, {
    id: 3,
    category: "Other",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  }, {
    id: 4,
    category: "Park & Open Spaces",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  }, {
    id: 5,
    category: "Roads and Streets",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: ""
  }];
  const defaultValues = {
    ...formData,
    landUseDetails: (formData === null || formData === void 0 ? void 0 : (_formData$completionC = formData.completionChecklist) === null || _formData$completionC === void 0 ? void 0 : _formData$completionC.landUseDetails) || defaultLandUseRows,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    },
    completionChecklist: {
      facilitiesSetback: (formData === null || formData === void 0 ? void 0 : (_formData$completionC2 = formData.completionChecklist) === null || _formData$completionC2 === void 0 ? void 0 : (_formData$completionC3 = _formData$completionC2.completionChecklist) === null || _formData$completionC3 === void 0 ? void 0 : _formData$completionC3.facilitiesSetback) || [{
        type: "Front Setback",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Rear Setback",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Side 1 Setback",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Side 2 Setback",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Plinth Height",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }],
      facilitiesBasement: (formData === null || formData === void 0 ? void 0 : (_formData$completionC4 = formData.completionChecklist) === null || _formData$completionC4 === void 0 ? void 0 : (_formData$completionC5 = _formData$completionC4.completionChecklist) === null || _formData$completionC5 === void 0 ? void 0 : _formData$completionC5.facilitiesBasement) || [{
        type: "Basement Provided",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Basement Usage",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Basement Ventilation",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }, {
        type: "Basement Parking",
        asPerPlan: "",
        onSite: "",
        remarks: ""
      }]
    },
    featureDetails: (formData === null || formData === void 0 ? void 0 : (_formData$completionC6 = formData.completionChecklist) === null || _formData$completionC6 === void 0 ? void 0 : _formData$completionC6.featureDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$completionC7 = formData.completionChecklist) === null || _formData$completionC7 === void 0 ? void 0 : _formData$completionC7.publicFacilities) || (formData === null || formData === void 0 ? void 0 : (_formData$completionC8 = formData.completionChecklist) === null || _formData$completionC8 === void 0 ? void 0 : _formData$completionC8.publicSemiPublicFacilities) || (formData === null || formData === void 0 ? void 0 : formData.featureDetails) || [],
    challanDetails: (formData === null || formData === void 0 ? void 0 : (_formData$completionC9 = formData.completionChecklist) === null || _formData$completionC9 === void 0 ? void 0 : _formData$completionC9.challanDetails) || [{
      date: "",
      receiptNo: "",
      bankName: "",
      amount: ""
    }],
    khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.khasraDetails) || [{
      district: "",
      tehsil: "",
      village: "",
      plotNo: ""
    }]
  };
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const [checklistDocs, setChecklistDocs] = useState((formData === null || formData === void 0 ? void 0 : formData.documents) || []);
  const [selectedFacility, setSelectedFacility] = useState("");
  useEffect(() => {
    if (formData && formData !== null && formData !== void 0 && formData.activityProposed) {
      setValue("descriptionOfLand.activityProposed", formData === null || formData === void 0 ? void 0 : formData.activityProposed);
    }
  }, [formData]);
  const watchedActivityProposed = watch("descriptionOfLand.activityProposed");
  const activityProposed = (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || watchedActivityProposed || "";
  const isLayoutCase = identifyLayoutCase(formData, watchedActivityProposed);
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      setChecklistDocs(prev => mergeDocumentsWithSitePhotos(formData.documents, [prev]));
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents]);
  const formatChecklistPayload = currentPayload => {
    const landUseDetailsArray = ((currentPayload === null || currentPayload === void 0 ? void 0 : currentPayload.landUseDetails) || []).map(item => ({
      category: item.category || "",
      approvedArea: item.approvedArea || "",
      approvedPercent: item.approvedPercent || "",
      developedArea: item.developedArea || "",
      developedPercent: item.developedPercent || "",
      deviationArea: item.deviationArea || "",
      deviationPercent: item.deviationPercent || ""
    }));
    const publicFacilitiesArray = ((currentPayload === null || currentPayload === void 0 ? void 0 : currentPayload.featureDetails) || []).map(item => ({
      feature: item.feature || "",
      approvedNo: item.approvedNo || "",
      approvedArea: item.approvedArea || "",
      completionCompleteNo: item.completionCompleteNo || item.completionNo || "",
      completionCompleteArea: item.completionCompleteArea || item.completionArea || "",
      completionUncompleteNo: item.completionUncompleteNo || item.completionNo2 || "",
      completionUncompleteArea: item.completionUncompleteArea || item.completionArea2 || ""
    }));
    const developmentWorkOnMap = DEVELOPMENT_WORK_ON_MAP_CONFIG.map(cfg => {
      var _currentPayload$facil, _currentPayload$facil2;
      return {
        sNo: cfg.sNo,
        feature: cfg.feature,
        status: (currentPayload === null || currentPayload === void 0 ? void 0 : (_currentPayload$facil = currentPayload.facilities) === null || _currentPayload$facil === void 0 ? void 0 : _currentPayload$facil[cfg.fieldKey]) || "",
        remarks: (currentPayload === null || currentPayload === void 0 ? void 0 : (_currentPayload$facil2 = currentPayload.facilities) === null || _currentPayload$facil2 === void 0 ? void 0 : _currentPayload$facil2[cfg.remarksKey]) || ""
      };
    });
    const cityInfrastructureConnection = CITY_INFRASTRUCTURE_CONFIG.map(cfg => {
      var _currentPayload$facil3, _currentPayload$facil4;
      return {
        sNo: cfg.sNo,
        feature: cfg.feature,
        status: (currentPayload === null || currentPayload === void 0 ? void 0 : (_currentPayload$facil3 = currentPayload.facilities) === null || _currentPayload$facil3 === void 0 ? void 0 : _currentPayload$facil3[cfg.fieldKey]) || "",
        remarks: (currentPayload === null || currentPayload === void 0 ? void 0 : (_currentPayload$facil4 = currentPayload.facilities) === null || _currentPayload$facil4 === void 0 ? void 0 : _currentPayload$facil4[cfg.remarksKey]) || ""
      };
    });
    return {
      landUseDetailsArray,
      publicFacilitiesArray,
      developmentWorkOnMap,
      cityInfrastructureConnection
    };
  };
  const handleSavePhotosDirectly = updatedDocs => {
    const currentPayload = getValues ? getValues() : {};
    const {
      landUseDetailsArray,
      publicFacilitiesArray,
      developmentWorkOnMap,
      cityInfrastructureConnection
    } = formatChecklistPayload(currentPayload);
    const docsToSave = mergeDocumentsWithSitePhotos(updatedDocs || checklistDocs, [checklistDocs, formData === null || formData === void 0 ? void 0 : formData.documents]);
    const data = {
      ...formData,
      documents: docsToSave,
      completionChecklist: {
        ...currentPayload,
        landUseDetails: landUseDetailsArray,
        featureDetails: publicFacilitiesArray,
        publicFacilities: publicFacilitiesArray,
        developmentWorkOnMap,
        cityInfrastructureConnection
      },
      facilities: {
        ...((formData === null || formData === void 0 ? void 0 : formData.facilities) || {}),
        ...((currentPayload === null || currentPayload === void 0 ? void 0 : currentPayload.facilities) || {})
      },
      landUseDetails: landUseDetailsArray,
      publicFacilities: publicFacilitiesArray,
      modalTitle: "Site Photographs Saved",
      modalMessage: "Site photographs updated successfully!"
    };
    handleTabChange(null, data);
  };
  const landUseDetails = watch("landUseDetails");
  const featureDetails = watch("featureDetails");
  const addRow = () => {
    setValue("landUseDetails", [...(landUseDetails || []), emptyLandUseRow]);
  };
  const removeRow = index => {
    if (index < 5) return;
    const updated = (landUseDetails || []).filter((_, i) => i !== index);
    setValue("landUseDetails", updated);
  };
  const addFeatureRow = facilityName => {
    const nameToAdd = facilityName || selectedFacility;
    if (!nameToAdd) return;
    const currentFeatures = getValues ? getValues("featureDetails") || [] : featureDetails || [];
    const newRow = {
      id: Date.now(),
      feature: nameToAdd,
      approvedNo: "",
      approvedArea: "",
      completionCompleteNo: "",
      completionCompleteArea: "",
      completionUncompleteNo: "",
      completionUncompleteArea: "",
      completionNo: "",
      completionArea: "",
      completionNo2: "",
      completionArea2: ""
    };
    setValue("featureDetails", [...currentFeatures, newRow]);
    setSelectedFacility("");
  };
  const removeFeatureRow = index => {
    const currentFeatures = getValues ? getValues("featureDetails") || [] : featureDetails || [];
    const updated = currentFeatures.filter((_, i) => i !== index);
    setValue("featureDetails", updated);
  };
  const getFacilityDefault = key => {
    var _formData$facilities, _formData$completionC10, _formData$completionC11;
    const val = (formData === null || formData === void 0 ? void 0 : (_formData$facilities = formData.facilities) === null || _formData$facilities === void 0 ? void 0 : _formData$facilities[key]) || (formData === null || formData === void 0 ? void 0 : formData[key]) || (formData === null || formData === void 0 ? void 0 : (_formData$completionC10 = formData.completionChecklist) === null || _formData$completionC10 === void 0 ? void 0 : (_formData$completionC11 = _formData$completionC10.facilities) === null || _formData$completionC11 === void 0 ? void 0 : _formData$completionC11[key]);
    return val ? val.toString().toLowerCase() : "";
  };
  const getRemarksDefault = key => {
    var _formData$facilities2, _formData$completionC12, _formData$completionC13;
    return (formData === null || formData === void 0 ? void 0 : (_formData$facilities2 = formData.facilities) === null || _formData$facilities2 === void 0 ? void 0 : _formData$facilities2[key]) || (formData === null || formData === void 0 ? void 0 : formData[key]) || (formData === null || formData === void 0 ? void 0 : (_formData$completionC12 = formData.completionChecklist) === null || _formData$completionC12 === void 0 ? void 0 : (_formData$completionC13 = _formData$completionC12.facilities) === null || _formData$completionC13 === void 0 ? void 0 : _formData$completionC13[key]) || "";
  };
  const inputWidth = 180;
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) === "Scheme";
  const khasraDetails = !isSchemeType ? formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.khasraDetails : [];
  const {
    fields: challanDetails,
    append: addPaymentDetail,
    remove: removePaymentDetail
  } = useFieldArray({
    control,
    name: "challanDetails"
  });
  const {
    fields: facilitiesSetback,
    append: addSetbackRow,
    remove: removeSetbackRow
  } = useFieldArray({
    control,
    name: "completionChecklist.facilitiesSetback"
  });
  const {
    fields: facilitiesBasement,
    append: addBasementRow,
    remove: removeBasementRow
  } = useFieldArray({
    control,
    name: "completionChecklist.facilitiesBasement"
  });
  console.log({
    facilitiesSetback
  });
  const addBasementRows = () => {
    addSetbackRow({
      type: "Enter Description",
      asPerPlan: "",
      onSite: "",
      remarks: ""
    });
  };
  const addSetBackRows = () => {
    addSetbackRow({
      type: "Enter Description",
      asPerPlan: "",
      onSite: "",
      remarks: ""
    });
  };
  const onSubmit = payload => {
    const {
      landUseDetailsArray,
      publicFacilitiesArray,
      developmentWorkOnMap,
      cityInfrastructureConnection
    } = formatChecklistPayload(payload);
    const data = {
      ...formData,
      documents: mergeDocumentsWithSitePhotos(checklistDocs, [formData === null || formData === void 0 ? void 0 : formData.documents]),
      completionChecklist: {
        ...payload,
        landUseDetails: landUseDetailsArray,
        featureDetails: publicFacilitiesArray,
        publicFacilities: publicFacilitiesArray,
        developmentWorkOnMap,
        cityInfrastructureConnection
      },
      facilities: {
        ...((formData === null || formData === void 0 ? void 0 : formData.facilities) || {}),
        ...((payload === null || payload === void 0 ? void 0 : payload.facilities) || {})
      },
      landUseDetails: landUseDetailsArray,
      publicFacilities: publicFacilitiesArray
    };
    handleTabChange(5, data);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    className: "groupContainer2",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Applicant Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name of the applicant"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 200,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.name)
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : (_formData$landInfo4$o3 = _formData$landInfo4$o2.correspondenceAddress) === null || _formData$landInfo4$o3 === void 0 ? void 0 : _formData$landInfo4$o3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 50,
    disabled: isEmployee || isApproved || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.correspondenceAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.address)
  }))), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.map((item, index) => {
    var _khasraDetails$index, _khasraDetails$index2, _khasraDetails$index3, _khasraDetails$index4;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: "textInput",
      defaultValue: khasraDetails === null || khasraDetails === void 0 ? void 0 : (_khasraDetails$index = khasraDetails[index]) === null || _khasraDetails$index === void 0 ? void 0 : _khasraDetails$index.district,
      disabled: isEmployee || isApproved,
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: khasraDetails === null || khasraDetails === void 0 ? void 0 : (_khasraDetails$index2 = khasraDetails[index]) === null || _khasraDetails$index2 === void 0 ? void 0 : _khasraDetails$index2.tehsil,
      type: "textInput",
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: khasraDetails === null || khasraDetails === void 0 ? void 0 : (_khasraDetails$index3 = khasraDetails[index]) === null || _khasraDetails$index3 === void 0 ? void 0 : _khasraDetails$index3.village,
      type: "textInput",
      maxLength: 30,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "specialChar",
      defaultValue: khasraDetails === null || khasraDetails === void 0 ? void 0 : (_khasraDetails$index4 = khasraDetails[index]) === null || _khasraDetails$index4 === void 0 ? void 0 : _khasraDetails$index4.plotNo,
      allowedChars: "/,-",
      maxLength: 200,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })));
  })))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.plotNo,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: formData !== null && formData !== void 0 && formData.descriptionOfLand.schemeName || isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.schemeName,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Activity Proposed"),
    control: control,
    placeholder: t("Select Activity Proposed"),
    name: "descriptionOfLand.activityProposed",
    type: activityProposed || isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 20,
    defaultValue: activityProposed,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction date"),
    control: control,
    placeholder: t("Enter Previous Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Application Number"),
    control: control,
    name: "prevFileNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    type: "textInput",
    disabled: isEmployee || isApproved
  }))), !isLayoutCase && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("If it is self-approved, (provide relevant details so that it can be proved that this case is covered under self-approved scheme and prescribed conditions have been duly complied)")}`,
    name: "completionChecklist.selfApprovedSchemeDetails",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$completionC14 = formData.completionChecklist) === null || _formData$completionC14 === void 0 ? void 0 : (_formData$completionC15 = _formData$completionC14.completionChecklist) === null || _formData$completionC15 === void 0 ? void 0 : _formData$completionC15.selfApprovedSchemeDetails,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), " "), !isLayoutCase && (formData === null || formData === void 0 ? void 0 : formData.internalChanges) === "Yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Compounding Sanction Number (If compounding of unauthorized construction has been done, then mention the number and date of compounding approval of the map.)"),
    control: control,
    name: "prevFileNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    type: "textInput"
  }))))), isLayoutCase && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land-Use Details"))), /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white completion-checklist"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "2",
    style: {
      width: "5%",
      textAlign: "center"
    }
  }, t("S.No")), /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "2",
    style: {
      width: "15%"
    }
  }, t("Land Use Category"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    style: {
      width: "20%",
      textAlign: "center"
    }
  }, t("As per Approved Plan")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    style: {
      width: "20%",
      textAlign: "center"
    }
  }, t("Developed")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    style: {
      width: "20%",
      textAlign: "center"
    }
  }, t("Deviation")), /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "2",
    style: {
      width: "10%",
      textAlign: "center"
    }
  }, t("Actions"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Percentage"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Percentage"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Percentage"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")))), /*#__PURE__*/React__default.createElement("tbody", null, landUseDetails === null || landUseDetails === void 0 ? void 0 : landUseDetails.map((row, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "textInput",
    disabled: isEmployee || isApproved || index < 5,
    name: `landUseDetails[${index}].category`,
    placeholder: "Enter Category",
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].approvedArea`,
    placeholder: "Area",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].approvedPercent`,
    placeholder: "%",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].developedArea`,
    placeholder: "Area",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].developedPercent`,
    placeholder: "%",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].deviationArea`,
    placeholder: "Area",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `landUseDetails[${index}].deviationPercent`,
    placeholder: "%",
    mandatory: true,
    disabled: isEmployee || isApproved,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, index >= 5 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removeRow(index),
    disabled: isEmployee || isApproved
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === landUseDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: addRow,
    disabled: isEmployee || isApproved
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)))))))))), isLayoutCase && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Public & Semi-public facilities"))), /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white completion-checklist"
  }, !(isEmployee || isApproved) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      gap: "16px",
      alignItems: "flex-end",
      marginBottom: "16px",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      minWidth: "300px"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#0B0C0C",
      marginBottom: "6px",
      display: "block"
    }
  }, t("Select Facility to Add")), /*#__PURE__*/React__default.createElement("select", {
    value: selectedFacility,
    onChange: e => setSelectedFacility(e.target.value),
    disabled: isEmployee || isApproved,
    style: {
      width: "100%",
      height: "40px",
      padding: "8px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "14px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "-- ", t("Select Facility"), " --"), PUBLIC_FACILITY_OPTIONS.map(opt => /*#__PURE__*/React__default.createElement("option", {
    key: opt,
    value: opt
  }, opt)))), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    onClick: () => addFeatureRow(),
    disabled: !selectedFacility || isEmployee || isApproved,
    style: {
      height: "40px",
      backgroundColor: selectedFacility ? "#157CB3" : "#ccc"
    }
  }, t("Add Row"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "3",
    style: {
      width: "5%",
      textAlign: "center"
    }
  }, t("S.No")), /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "3",
    style: {
      width: "20%"
    }
  }, t("Features"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    rowSpan: "2",
    style: {
      textAlign: "center"
    }
  }, t("Provisions in Approved Plan")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "4",
    style: {
      textAlign: "center"
    }
  }, t("Provisions in Map for Completion")), /*#__PURE__*/React__default.createElement("th", {
    rowSpan: "3",
    style: {
      width: "8%",
      textAlign: "center"
    }
  }, t("Actions"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    style: {
      textAlign: "center"
    }
  }, t("Complete")), /*#__PURE__*/React__default.createElement("th", {
    colSpan: "2",
    style: {
      textAlign: "center"
    }
  }, t("Uncomplete"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, t("No."), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("No."), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("No."), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("Area (Sqmt.)"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")))), /*#__PURE__*/React__default.createElement("tbody", null, featureDetails && featureDetails.length > 0 ? featureDetails.map((row, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: row.id || index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "textInput",
    disabled: isEmployee || isApproved,
    name: `featureDetails[${index}].feature`,
    placeholder: "Enter Feature",
    defaultValue: row.feature,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].approvedNo`,
    placeholder: "No.",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].approvedArea`,
    placeholder: "Area",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].completionCompleteNo`,
    placeholder: "No.",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].completionCompleteArea`,
    placeholder: "Area",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].completionUncompleteNo`,
    placeholder: "No.",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    type: "number",
    name: `featureDetails[${index}].completionUncompleteArea`,
    placeholder: "Area",
    disabled: isEmployee || isApproved,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removeFeatureRow(index),
    disabled: isEmployee || isApproved
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))) : /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "9",
    style: {
      textAlign: "center",
      padding: "20px",
      color: "#666"
    }
  }, t("No facilities added yet. Please select a facility from the dropdown above and click 'Add Row'.")))))))), !isLayoutCase && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Development Standard"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white completion-checklist"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      margin: "10px",
      width: "100%",
      tableLayout: "auto"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "As per Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "On Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "normal",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "Remarks"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    onClick: addSetBackRows,
    size: "small"
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, facilitiesSetback === null || facilitiesSetback === void 0 ? void 0 : facilitiesSetback.map((field, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: field.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesSetback[${index}].type`,
    placeholder: "Enter Description",
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesSetback[${index}].asPerPlan`,
    placeholder: "Enter Details",
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesSetback[${index}].onSite`,
    placeholder: "Enter Details",
    disabled: isCitizen,
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: 400,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesSetback[${index}].remarks`,
    placeholder: "Enter Remarks",
    multiline: true,
    disabled: isCitizen
  }), (facilitiesSetback === null || facilitiesSetback === void 0 ? void 0 : facilitiesSetback.length) > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removeSetbackRow(index),
    disabled: isEmployee || isApproved,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, {
    fontSize: "small"
  }))))))), /*#__PURE__*/React__default.createElement(Table$2, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      margin: "10px",
      width: "100%",
      tableLayout: "auto"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "As per Plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "nowrap",
      width: "fit-content",
      borderRight: "2px solid #ccc",
      padding: "10px"
    }
  }, "On Site"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      whiteSpace: "normal",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "Remarks"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React__default.createElement(AddIcon, null),
    onClick: addBasementRows,
    size: "small"
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, facilitiesBasement.map((field, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: field.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesBasement.${index}.type`,
    placeholder: "Enter Details",
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesBasement.${index}.asPerPlan`,
    placeholder: "Enter Details",
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: inputWidth,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesBasement.${index}.onSite`,
    placeholder: "Enter Details",
    disabled: isCitizen,
    containerStyles: {
      width: inputWidth
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: 400,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: `completionChecklist.facilitiesBasement.${index}.remarks`,
    placeholder: "Enter Remarks",
    multiline: true,
    disabled: isCitizen
  }), (facilitiesSetback === null || facilitiesSetback === void 0 ? void 0 : facilitiesSetback.length) > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removeBasementRow(index),
    disabled: isEmployee || isApproved,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, {
    fontSize: "small"
  }))))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basement area (sq.mtr)"),
    control: control,
    placeholder: t("Enter basement area"),
    name: "completionChecklist.basementArea",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$completionC16 = formData.completionChecklist) === null || _formData$completionC16 === void 0 ? void 0 : (_formData$completionC17 = _formData$completionC16.completionChecklist) === null || _formData$completionC17 === void 0 ? void 0 : _formData$completionC17.basementArea,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Water Supply")}`,
    name: "facilities.waterSupply",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$completionC18 = formData.completionChecklist) === null || _formData$completionC18 === void 0 ? void 0 : (_formData$completionC19 = _formData$completionC18.facilities) === null || _formData$completionC19 === void 0 ? void 0 : _formData$completionC19.waterSupply) || (formData === null || formData === void 0 ? void 0 : formData.waterSupply),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Sewerage")}`,
    name: "facilities.sewerage",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.sewerage) || (formData === null || formData === void 0 ? void 0 : (_formData$completionC20 = formData.completionChecklist) === null || _formData$completionC20 === void 0 ? void 0 : (_formData$completionC21 = _formData$completionC20.facilities) === null || _formData$completionC21 === void 0 ? void 0 : _formData$completionC21.sewerage),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Drainage")}`,
    name: "facilities.drainage",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$completionC22 = formData.completionChecklist) === null || _formData$completionC22 === void 0 ? void 0 : (_formData$completionC23 = _formData$completionC22.facilities) === null || _formData$completionC23 === void 0 ? void 0 : _formData$completionC23.drainage) || (formData === null || formData === void 0 ? void 0 : formData.drainage),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Power Supply")}`,
    name: "facilities.powerSupply",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$completionC24 = formData.completionChecklist) === null || _formData$completionC24 === void 0 ? void 0 : (_formData$completionC25 = _formData$completionC24.facilities) === null || _formData$completionC25 === void 0 ? void 0 : _formData$completionC25.powerSupply) || (formData === null || formData === void 0 ? void 0 : formData.powerSupply),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Rooftop Rainwater Harvesting System")}`,
    name: "facilities.roofTopDrainage",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$completionC26 = formData.completionChecklist) === null || _formData$completionC26 === void 0 ? void 0 : (_formData$completionC27 = _formData$completionC26.facilities) === null || _formData$completionC27 === void 0 ? void 0 : _formData$completionC27.roofTopDrainage) || (formData === null || formData === void 0 ? void 0 : formData.roofTopDrainage),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Solar water heating plant (in plots with area more than 434 sq.m.)")}`,
    name: "facilities.solarPlant",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$completionC28 = formData.completionChecklist) === null || _formData$completionC28 === void 0 ? void 0 : (_formData$completionC29 = _formData$completionC28.facilities) === null || _formData$completionC29 === void 0 ? void 0 : _formData$completionC29.solarPlant) || (formData === null || formData === void 0 ? void 0 : formData.solarPlant),
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)))), isLayoutCase && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("The following development Work marked on the map"))), /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white completion-checklist"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "6%",
      textAlign: "center"
    }
  }, t("S. No.")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "44%"
    }
  }, t("Features")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "22%",
      textAlign: "center"
    }
  }, t("Yes / No / NA"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "28%"
    }
  }, t("Remarks")))), /*#__PURE__*/React__default.createElement("tbody", null, DEVELOPMENT_WORK_ON_MAP_CONFIG.map(item => /*#__PURE__*/React__default.createElement("tr", {
    key: item.name
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      fontWeight: "500"
    }
  }, item.sNo), /*#__PURE__*/React__default.createElement("td", null, t(item.feature)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "auto",
    hasLabel: false,
    control: control,
    name: item.name,
    defaultValue: getFacilityDefault(item.fieldKey),
    type: "radioButton",
    data: yesNoNaOptions,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    hasLabel: false,
    control: control,
    name: item.remarksName,
    defaultValue: getRemarksDefault(item.remarksKey),
    placeholder: t("Enter Remarks"),
    type: "textInput"
  }))))))))), isLayoutCase && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Position / arrangement of connection with the city's infrastructure system"))), /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white completion-checklist"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "6%",
      textAlign: "center"
    }
  }, t("S. No.")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "44%"
    }
  }, t("Features")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "22%",
      textAlign: "center"
    }
  }, t("Yes / No / NA"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "28%"
    }
  }, t("Remarks")))), /*#__PURE__*/React__default.createElement("tbody", null, CITY_INFRASTRUCTURE_CONFIG.map(item => /*#__PURE__*/React__default.createElement("tr", {
    key: item.name
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center",
      fontWeight: "500"
    }
  }, item.sNo), /*#__PURE__*/React__default.createElement("td", null, t(item.feature)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "auto",
    hasLabel: false,
    control: control,
    name: item.name,
    defaultValue: getFacilityDefault(item.fieldKey),
    type: "radioButton",
    data: yesNoNaOptions,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    hasLabel: false,
    control: control,
    name: item.remarksName,
    defaultValue: getRemarksDefault(item.remarksKey),
    placeholder: t("Enter Remarks"),
    type: "textInput"
  }))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(SitePhotoChecklistSection, {
    formData: formData,
    isEmployee: isEmployee,
    isValidEmp: isValidEmp,
    workflowDetails: workflowDetails,
    documents: checklistDocs,
    onDocumentsChange: newDocs => {
      setChecklistDocs(newDocs);
    },
    onSavePhotos: handleSavePhotosDirectly,
    setParams: setParams,
    onSelect: onSelect
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => onTabChange ? onTabChange(2) : handleTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const useSubStep1Logic = ({
  formData,
  userInfo,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  handleSubTabChange,
  handleTabChange,
  setProposedSite,
  setFormData
}) => {
  var _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers;
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  console.log("applicationFlow", applicationFlow);
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [isPlinthApproved, setIsPlinthApproved] = useState(false);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [pdfUrls, setPdfUrls] = useState({
    selfDrawingPdfUrl: "",
    approvalCertificateUrl: "",
    selfDrawingPdfId: "",
    approvalCertificateId: ""
  });
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [isCompletionValid, setIsCompletionValid] = useState(true);
  const [watchProposalType, watchisSpecialProject, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchCompunding] = watch(["proposalType", "isSpecialProject", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "shortName"]);
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs.map(plot => watchedFields[`plotNumbers[${plot.index}]`]);
  let isLayoutCase;
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears
      });
    }
  }, [formData]);
  useEffect(() => {}, [watchedFields]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const riskType = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? "Building Plan Low Risk, Self Certification Mode" : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") && watchAtivityProposed !== "Row Houses" && watchAtivityProposed !== "Semi Detached" && watchAtivityProposed !== "Detached" ? "High Risk and High Nivesh" : watchlandUseType === "Commercial" ? "High Risk and High Nivesh" : watchPlanOn !== "Others" ? "Building Plan-Low Risk" : "Others";
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
  }, [watchPlanOn]);
  const closeToast = () => setShowToast(null);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const isCompletionEligible = landUseData => {
    var _landUseData$descript, _landUseData$descript2;
    const activityProposed = landUseData === null || landUseData === void 0 ? void 0 : (_landUseData$descript = landUseData.descriptionOfLand) === null || _landUseData$descript === void 0 ? void 0 : _landUseData$descript.activityProposed;
    const plotArea = landUseData === null || landUseData === void 0 ? void 0 : (_landUseData$descript2 = landUseData.descriptionOfLand) === null || _landUseData$descript2 === void 0 ? void 0 : _landUseData$descript2.landArea;
    const restrictedActivities = ["Row Housing - Single units", "Semi-Detached - Single Units", "Single Housing – EWS", "Single Housing – LIG"];
    if (restrictedActivities.includes(activityProposed) && plotArea <= 500) {
      return false;
    }
    return true;
  };
  const identifyLayoutCase = data => {
    var _data$descriptionOfLa, _data$descriptionOfLa2;
    if ((data === null || data === void 0 ? void 0 : (_data$descriptionOfLa = data.descriptionOfLand) === null || _data$descriptionOfLa === void 0 ? void 0 : _data$descriptionOfLa.activityProposed) === "Plotted Development" || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa2 = data.descriptionOfLand) === null || _data$descriptionOfLa2 === void 0 ? void 0 : _data$descriptionOfLa2.activityProposed) === "Plotted Development - Affordable") {
      return true;
    } else return false;
  };
  const Modal = useModal();
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let mapSubmissionData;
      let purchasableData;
      let mapSubmissionDataCompletion;
      let plinthData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$filter, _response3, _response3$BPA, _response3$BPA$filter, _response4, _response4$BPA, _response4$BPA$filter, _response5, _response5$BPA, _response5$BPA$filter, _response6, _response6$BPA, _response6$BPA$filter, _plinthData, _mapSubmissionData, _mapSubmissionData2, _mapSubmissionData3, _mapSubmissionData4, _data2, _data2$documents, _data3, _data3$landInfo, _data4, _data5, _data6, _data7, _data8, _data9, _mapSubmissionData5, _mapSubmissionData6, _mapSubmissionData7, _mapSubmissionData7$p, _mapSubmissionData8, _mapSubmissionData8$a, _data10, _data10$descriptionOf, _data11, _data11$descriptionOf, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _data14$descriptionOf2, _data15, _data15$descriptionOf, _data16, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19, _data19$descriptionOf, _data20, _data20$descriptionOf, _data21, _data21$descriptionOf, _data22, _data22$landInfo, _data22$landInfo$owne, _data22$landInfo$owne2, _data22$landInfo$owne3, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data26, _mapSubmissionData9, _data28, _data29, _data30, _data31, _data32, _data32$descriptionOf, _data33, _data33$descriptionOf, _data34;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        console.log("Response GOt", response);
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        }
        data = (_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$filter = _response2$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response2$BPA$filter === void 0 ? void 0 : _response2$BPA$filter[0];
        mapSubmissionData = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_MAP")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        mapSubmissionDataCompletion = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_COMPLETION")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        purchasableData = (_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$BPA = _response5.BPA) === null || _response5$BPA === void 0 ? void 0 : (_response5$BPA$filter = _response5$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response5$BPA$filter === void 0 ? void 0 : _response5$BPA$filter[0];
        plinthData = (_response6 = response) === null || _response6 === void 0 ? void 0 : (_response6$BPA = _response6.BPA) === null || _response6$BPA === void 0 ? void 0 : (_response6$BPA$filter = _response6$BPA.filter(item => item.applicationType === "FORM_PLINTH")) === null || _response6$BPA$filter === void 0 ? void 0 : _response6$BPA$filter[0];
        if ((_plinthData = plinthData) !== null && _plinthData !== void 0 && _plinthData.land_Id) {
          setIsPlinthApproved(true);
        }
        setPdfUrls({
          selfDrawingPdfUrl: ((_mapSubmissionData = mapSubmissionData) === null || _mapSubmissionData === void 0 ? void 0 : _mapSubmissionData.selfDrawingPdfUrl) || "",
          approvalCertificateUrl: ((_mapSubmissionData2 = mapSubmissionData) === null || _mapSubmissionData2 === void 0 ? void 0 : _mapSubmissionData2.approvalCertificateUrl) || "",
          selfDrawingPdfId: ((_mapSubmissionData3 = mapSubmissionData) === null || _mapSubmissionData3 === void 0 ? void 0 : _mapSubmissionData3.selfDrawingPdfId) || "",
          approvalCertificateId: ((_mapSubmissionData4 = mapSubmissionData) === null || _mapSubmissionData4 === void 0 ? void 0 : _mapSubmissionData4.approvalCertificateId) || ""
        });
        Digit.SessionStorage.set("MAP_SANCTION_DETAIL", mapSubmissionData);
        const completionEligible = isCompletionEligible(data);
        setIsCompletionValid(completionEligible);
        if (!completionEligible) {
          Modal("Submission Blocked", `As per condition, no need to apply`, "error");
          return;
        }
        isLayoutCase = identifyLayoutCase(data);
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data, _data$additionalDetai, _data$additionalDetai2;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data = data) === null || _data === void 0 ? void 0 : (_data$additionalDetai = _data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.professionalInformation) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID_DATA", {
          landUse: data,
          mapSubmission: mapSubmissionData
        });
        const updatedDocuments = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$documents = _data2.documents) === null || _data2$documents === void 0 ? void 0 : _data2$documents.map(doc => ({
          ...doc,
          documentRemarks: null,
          documentStatus: null
        }));
        const newFormData = {
          ...formData,
          landInfo: {
            ...data.landInfo,
            address: (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$landInfo = _data3.landInfo) === null || _data3$landInfo === void 0 ? void 0 : _data3$landInfo.address
          },
          land_Id: (_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.land_Id,
          selectedCity: (_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.selectedCity,
          selectedUnit: (_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.selectedUnit,
          documents: updatedDocuments,
          descriptionOfLand: (_data7 = data) === null || _data7 === void 0 ? void 0 : _data7.descriptionOfLand,
          nocDetails: (_data8 = data) === null || _data8 === void 0 ? void 0 : _data8.nocDetails,
          khasraDetails: (_data9 = data) === null || _data9 === void 0 ? void 0 : _data9.khasraDetails,
          totalBuildUpArea: (_mapSubmissionData5 = mapSubmissionData) === null || _mapSubmissionData5 === void 0 ? void 0 : _mapSubmissionData5.totalBuildUpArea,
          plotInfo: {
            ...((_mapSubmissionData6 = mapSubmissionData) === null || _mapSubmissionData6 === void 0 ? void 0 : _mapSubmissionData6.plotInfo),
            estimatedCost: (_mapSubmissionData7 = mapSubmissionData) === null || _mapSubmissionData7 === void 0 ? void 0 : (_mapSubmissionData7$p = _mapSubmissionData7.plotInfo) === null || _mapSubmissionData7$p === void 0 ? void 0 : _mapSubmissionData7$p.estimatedCost
          }
        };
        setFormData(prevState => ({
          ...prevState,
          ...newFormData
        }));
        const sanctionDate = ConvertEpochToDate((_mapSubmissionData8 = mapSubmissionData) === null || _mapSubmissionData8 === void 0 ? void 0 : (_mapSubmissionData8$a = _mapSubmissionData8.auditDetails) === null || _mapSubmissionData8$a === void 0 ? void 0 : _mapSubmissionData8$a.lastModifiedTime) || "";
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("zoneType", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.landUsesType);
        setValue("fastPASId", applicationNo);
        setValue("primaryUse", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : _data11$descriptionOf.activityAsPerMap);
        setValue("landMark", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.landMark);
        setValue("sectorNo", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.sectorNo);
        setValue("khasraNo", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : (_data14$descriptionOf2 = _data14$descriptionOf.khasraWithArea[0]) === null || _data14$descriptionOf2 === void 0 ? void 0 : _data14$descriptionOf2.khasraNo);
        setValue("schemeName", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : _data15$descriptionOf.schemeName);
        setValue("planOn", "FORM_MAP_COMPLETION");
        setValue("riskType", (_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.riskType);
        setValue("activityProposed", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.activityProposed);
        setValue("plotArea", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$descriptionOf = _data19.descriptionOfLand) === null || _data19$descriptionOf === void 0 ? void 0 : _data19$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.landAddress);
        setValue("tehsil", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$landInfo = _data22.landInfo) === null || _data22$landInfo === void 0 ? void 0 : (_data22$landInfo$owne = _data22$landInfo.owners) === null || _data22$landInfo$owne === void 0 ? void 0 : (_data22$landInfo$owne2 = _data22$landInfo$owne[0]) === null || _data22$landInfo$owne2 === void 0 ? void 0 : (_data22$landInfo$owne3 = _data22$landInfo$owne2.permanentAddress) === null || _data22$landInfo$owne3 === void 0 ? void 0 : _data22$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.developmentArea);
        setValue("subZoneType", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.subLandUseAsPerLayout);
        setValue("department", (_data25 = data) === null || _data25 === void 0 ? void 0 : _data25.department);
        if ((_data26 = data) !== null && _data26 !== void 0 && _data26.department) {
          var _data27;
          setValue("businessService", ((_data27 = data) === null || _data27 === void 0 ? void 0 : _data27.department) === "DA" ? "BPA_COMPLETION_DA" : "BPA_COMPLETION_AVP");
        }
        setValue("prevFileNo", ((_mapSubmissionData9 = mapSubmissionData) === null || _mapSubmissionData9 === void 0 ? void 0 : _mapSubmissionData9.applicationNo) || ((_data28 = data) === null || _data28 === void 0 ? void 0 : _data28.applicationNo));
        setValue("layoutsanctionDate", (_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.layoutsanctionDate);
        setValue("validityDate", (_data30 = data) === null || _data30 === void 0 ? void 0 : _data30.validityDate);
        setValue("compoundingSanctionDate", sanctionDate);
        setValue("applicationType", "FORM_COMPLETION");
        setValue("selectedOffice", (_data31 = data) === null || _data31 === void 0 ? void 0 : _data31.selectedOffice);
        const isApproved = ((_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$descriptionOf = _data32.descriptionOfLand) === null || _data32$descriptionOf === void 0 ? void 0 : _data32$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$descriptionOf = _data33.descriptionOfLand) === null || _data33$descriptionOf === void 0 ? void 0 : _data33$descriptionOf.landArea;
        setRiskType((_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.riskType);
        setSchemeType(isApproved);
        if (!isApproved) {
          setValue("planOn", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType);
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchPrimaryUse);
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  return {
    t,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    updistricts,
    fastPASData,
    setFastPasData,
    purchasableData,
    setPurchasableData,
    user,
    setUser,
    riskType,
    setRiskType,
    showToast,
    setShowToast,
    dropDownData,
    schemeType,
    setSchemeType,
    declarationChecked,
    setDeclarationChecked,
    watchedFields,
    mappedPlot,
    totalPlots,
    isSelfCert,
    isCompounding,
    fullRows,
    remainingPlots,
    plotInputs,
    plotNumbers,
    handleSearchClick,
    landUseList,
    landSubUseList,
    handleDeclarationChange,
    closeToast,
    applicationFlow,
    DepartmentSelector,
    file,
    setFile,
    handleSubTabChange,
    handleTabChange,
    id,
    formData,
    userInfo,
    setProposedSite,
    isCompletionValid,
    isLayoutCase,
    isPlinthApproved,
    pdfUrls,
    activityAsPerMap,
    activityProposed
  };
};

const SubStep1$7 = props => {
  var _formData$description, _fastPASData$descript, _formData$description2, _formData$description3, _formData$description4, _fastPASData$descript2, _fastPASData$descript3, _fastPASData$descript4;
  const logic = useSubStep1Logic(props);
  const {
    t,
    handleSubmit,
    control,
    getValues,
    formData,
    handleSearchClick,
    handleDeclarationChange,
    declarationChecked,
    showToast,
    closeToast,
    riskType,
    watch,
    schemeType,
    fastPASData,
    dropDownData,
    isSelfCert,
    isCompounding,
    fullRows,
    remainingPlots,
    plotInputs,
    plotNumbers,
    handleTabChange,
    handleSubTabChange,
    id,
    user,
    setDeclarationChecked,
    landUseList,
    landSubUseList,
    applicationFlow,
    DepartmentSelector,
    isCompletionValid,
    isLayoutCase,
    isPlinthApproved,
    isEmployee,
    pdfUrls,
    activityAsPerMap,
    activityProposed
  } = logic;
  const [watchProposalType, watchisSpecialProject, watchProjectType, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchNoOfPLots, watchPlanOn, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchCompunding, watchInternalChanges, watchCompoundingDone, watchBuildingInternalChanges, watchApplicationNo] = watch(["proposalType", "isSpecialProject", "projectType", "plotSubdivided", "needCompounding", "plotLeaseHold", "noOfPlots", "planOn", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "shortName", "internalChanges", "compoundingDone", "buildingInternalChanges", "prevFileNo"]);
  const stateId = Digit.ULBService.getStateId();
  const userType = Digit.SessionStorage.get("userType");
  const {
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    BPA: {
      applicationNo: id
    }
  }, {
    formType: "MAP_SUB",
    config: {
      enabled: false
    }
  });
  const onSubmit = async data => {
    const finalPayload = {
      ...data,
      selfDrawingPdfId: pdfUrls.selfDrawingPdfId,
      approvalCertificateId: pdfUrls.approvalCertificateId
    };
    handleSubTabChange(1, finalPayload);
    const res = await refetch();
  };
  console.log("formDatawww", formData);
  const Modal = useModal();
  useEffect(() => {
    if (watchInternalChanges == "yes" && watchCompoundingDone == "no") {
      Modal("Submission not allowed", `Please submit application for Compounding first`, "error");
    } else {
      return;
    }
  }, [watchCompoundingDone]);
  useEffect(() => {
    if (watchBuildingInternalChanges == "If contrary to the byelaws It has been extinguished") {
      Modal("Submission not allowed", `Please submit application for Compounding first`, "error");
    } else {
      return;
    }
  }, [watchBuildingInternalChanges]);
  if (applicationFlow === null && !(formData !== null && formData !== void 0 && formData.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, watchPlanOn && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading",
    style: {
      background: "#f2f2f2",
      textAlign: "end",
      fontSize: "20px",
      color: "green"
    }
  }, t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen",
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Application Number"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    type: "textInput",
    disabled: userType !== "citizen"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction date"),
    control: control,
    placeholder: t("Enter Previous Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction Validity date"),
    control: control,
    placeholder: t("Enter Previous Sanction Validity date"),
    name: "validityDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.validityDate,
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Permit No."),
    control: control,
    placeholder: t("Enter Permit No."),
    name: "permitNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.permitNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Completion/Occupancy Certificate required")}`,
    name: "occupancyCertificate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.occupancyCertificate,
    type: "radioButton",
    mandatory: true,
    data: fullyPartial,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), !isLayoutCase ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is any internal changes (except exempted from building permit) done from the approved plan?")}`,
    name: "internalChanges",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.internalChanges,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), watchInternalChanges == "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is Compounding Done?")}`,
    name: "compoundingDone",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compoundingDone,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchInternalChanges === "yes" && watchCompoundingDone == "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Compounding map sanction number"),
    control: control,
    placeholder: t("Enter sanction number"),
    name: "compoundingNumber",
    mandatory: true,
    maxLength: 23,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compoundingNumber,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Compounding map sanction date"),
    control: control,
    placeholder: t("Enter Compounding map sanction date"),
    name: "compoundingSanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compoundingSanctionDate,
    type: "datePicker"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t(isLayoutCase ? "Internal changes in layout/map" : "Internal changes in the building"),
    name: "buildingInternalChanges",
    placeholder: t("Select Options"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingInternalChanges,
    type: "selectInput",
    mandatory: true,
    data: buildingInternalChanges,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), watchInternalChanges === "yes" && watchCompoundingDone == "yes" ? /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Permit no. for compounding"),
    name: "compoundingPermitNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compoundingPermitNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityProposed),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    disabled: userType !== "citizen",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.schemeName
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    disabled: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    mandatory: !schemeType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2.khasraDetails) === null || _formData$description3 === void 0 ? void 0 : (_formData$description4 = _formData$description3[0]) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.tehsil,
    name: `revenueVillage`,
    type: "textInput",
    mandatory: !schemeType,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: formData === null || formData === void 0 ? void 0 : formData.landMark,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    mandatory: !schemeType,
    maxLength: 500,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, schemeType ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.plotNo),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo)
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker"
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput"
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of Plots"),
    name: "noOfPlots",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, Array.from({
    length: 3
  }).map((_, colIndex) => {
    var _formData$plotNumbers;
    const plotIndex = rowIndex * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      hasLabel: false,
      maxLength: 15,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers[plotIndex]) || "",
      type: "textInput"
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, Array.from({
    length: remainingPlots
  }).map((_, colIndex) => {
    var _formData$plotNumbers2;
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      maxLength: 15,
      hasLabel: false,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plotIndex]) || "",
      type: "textInput"
    }));
  }))), watchbuildingClassification === "Others" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherbuildingClass",
    mandatory: true,
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput"
  })))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Please specify if any other condition"),
    placeholder: t("Enter condition"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript4 = fastPASData.descriptionOfLand) === null || _fastPASData$descript4 === void 0 ? void 0 : _fastPASData$descript4.landArea) < 40000 && watchlandUseType !== "Residential" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is Your Plot sub-division"),
    control: control,
    name: "plotSubdivided",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Does existing building require any compounding ?"),
    control: control,
    name: "needCompounding",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.needCompounding,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchNeedComp === "no" && watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is your plot Lease hold ?"),
    control: control,
    name: "plotLeaseHold",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchplotLeaseHold === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Purchasable FAR"),
    control: control,
    name: "purchasableFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    type: "textInput",
    placeholder: t("Enter Purchasable FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Premium FAR"),
    control: control,
    name: "premiumFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
    type: "textInput",
    placeholder: t("Enter Premium FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchnatureOfConstruction === "Compounding" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is building plan previously approved?"),
    control: control,
    name: "shortName",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shortName,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchCompunding !== "no" && /*#__PURE__*/React__default.createElement(Col, null), watchCompunding === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of compounding"),
    placeholder: t("Select Nature Of Compounding"),
    name: "isAncestralProperty",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty,
    data: SortingAlphabatically(natureOfCompounding),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), isPlinthApproved && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plinth application Number"),
    control: control,
    placeholder: t("Enter File No"),
    name: "plinthApplicationNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plinthApplicationNo,
    type: "textInput"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, userType !== "employee" && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: watchPlotSubdivided === "yes" || watchNeedComp === "yes" || watchInternalChanges === "yes" && watchCompoundingDone == "no" || watchBuildingInternalChanges == "If contrary to the byelaws It has been extinguished" || !isCompletionValid
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const Step7 = ({
  formData,
  id,
  handleTabChange,
  isEmployee
}) => {
  var _Digit$UserService$ge, _formData$documents, _formData$documents2, _formData$documents2$, _formData$documents3, _formData$documents4, _formData$documents4$, _data$BPA;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  console.log("IS EMPLOYEE", isEmployee);
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("formDataInStep7", formData);
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  const formType = "MAP_SUB";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployeeData = history.location.pathname.includes("employee");
  const mapSanctionData = Digit.SessionStorage.get("MAP_SANCTION_DETAIL") || {};
  const userType = Digit.SessionStorage.get("userType");
  console.log("USERTYPEEEEE", userType);
  const isEmployee1 = userType === "employee";
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const dwgPdf = formData && (formData === null || formData === void 0 ? void 0 : formData.documents) && (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0 && (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.find(item => (item === null || item === void 0 ? void 0 : item.documentType) === "completionDrawingPdf")) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.fileStoreId) || null;
  const appPdf = formData && (formData === null || formData === void 0 ? void 0 : formData.documents) && (formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : _formData$documents3.length) > 0 && (formData === null || formData === void 0 ? void 0 : (_formData$documents4 = formData.documents) === null || _formData$documents4 === void 0 ? void 0 : (_formData$documents4$ = _formData$documents4.find(item => (item === null || item === void 0 ? void 0 : item.documentType) === "completionApprovalLetter")) === null || _formData$documents4$ === void 0 ? void 0 : _formData$documents4$.fileStoreId) || null;
  console.log("DWASAHS", appPdf, dwgPdf);
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee: isEmployeeData
  }, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  });
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  const extractData = (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || {};
  console.log("api-response", data, extractData);
  const onSubmit = data => {
    console.log("DATAGOT", data, documents);
    if (data) {
      const newData = {
        ...formData,
        documents: [...((formData === null || formData === void 0 ? void 0 : formData.documents) || []), ...(documents || [])]
      };
      console.log("NEW DATA", newData);
      handleTabChange(4, newData);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading",
    style: {
      marginBottom: 10
    }
  }, t("Document"))), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, !isEmployee1 ? /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing PDF"),
    control: control,
    name: "completionDrawingPdf",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 1,
    trigger: trigger
  }) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, t("Drawing PDF")), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => {
      getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading);
    }
  }))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, !isEmployee1 ? /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Approval Letter PDF"),
    control: control,
    name: "completionApprovalLetter",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 1,
    trigger: trigger
  }) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, t("Approval Letter")), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => {
      getDocumentByFileStoreId(appPdf, setIsPreviewLoading);
    }
  }))))), userType !== "employee" && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    type: "submit",
    label: "Save",
    sx: {
      backgroundColor: "#157CB3"
    }
  }))))));
};

const EmpCompletionPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray,
  urlFormType,
  isFromDashboard: propIsFromDashboard
}) => {
  var _Digit, _Digit2, _userRolesArray$2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [validationPopup, setValidationPopup] = useState(false);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [initialDeveloperRemarks, setInitialDeveloperRemarks] = useState("");
  const isJE = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.code) === "JE";
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    nocRemarksData,
    callNocDetailsAPI,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callPaymentDetailsAPI,
    callDrawingDetailsAPI,
    callNotingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    callInspectionDetailsAPI,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    handleNoWorkflowPFAR,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    isValidEmp,
    isPurchasbleReq,
    currentFormData,
    handleNoWorkflowCompounding,
    callDocumentDetailsAPI,
    handleCompletionChecklistSave,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
    isFromDashboard: hookIsFromDashboard
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  const isFromDashboard = propIsFromDashboard || hookIsFromDashboard;
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }];
  const subTabDocLabels = [{
    label: "Mandatory Documents"
  }, {
    label: "Conditional Documents"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  console.log("allCaseFind", formData, urlFormType);
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  useEffect(() => {
    var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3, _documentRemarksData$4;
    const initialDeveloperRemarks = developerRemarksDocument ? developerNocRemarks : Array.isArray(documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0 ? (_documentRemarksData$ = documentRemarksData.DetailDataRemarks[documentRemarksData.DetailDataRemarks.length - 1]) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$.documentDetails) === null || _documentRemarksData$2 === void 0 ? void 0 : _documentRemarksData$2.developerRemarks : documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$3 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$3 === void 0 ? void 0 : (_documentRemarksData$4 = _documentRemarksData$3.documentDetails) === null || _documentRemarksData$4 === void 0 ? void 0 : _documentRemarksData$4.developerRemarks;
    setInitialDeveloperRemarks(initialDeveloperRemarks);
  }, [developerRemarksDocument, documentRemarksData]);
  const handleTabChange = async nextTabNo => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = nextSubTab => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = nextSubTab => {
    setSelectedDocTab(nextSubTab);
  };
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  useEffect(() => {
    var _documentRemarksData$5, _documentRemarksData$6, _documentRemarksData$7, _documentRemarksData$8;
    const initialDeveloperRemarks = developerRemarksDocument ? developerNocRemarks : Array.isArray(documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks) && documentRemarksData.DetailDataRemarks.length > 0 ? (_documentRemarksData$5 = documentRemarksData.DetailDataRemarks[documentRemarksData.DetailDataRemarks.length - 1]) === null || _documentRemarksData$5 === void 0 ? void 0 : (_documentRemarksData$6 = _documentRemarksData$5.documentDetails) === null || _documentRemarksData$6 === void 0 ? void 0 : _documentRemarksData$6.developerRemarks : documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$7 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$7 === void 0 ? void 0 : (_documentRemarksData$8 = _documentRemarksData$7.documentDetails) === null || _documentRemarksData$8 === void 0 ? void 0 : _documentRemarksData$8.developerRemarks;
    setInitialDeveloperRemarks(initialDeveloperRemarks);
  }, [developerRemarksDocument, documentRemarksData]);
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (isCompounding) {
      if (activeTab === 2) {
        return /*#__PURE__*/React__default.createElement(CompoundingChecklist, {
          formData: params,
          handleTabChange: handleTabChange,
          role: "EMPLOYEE",
          handleNoWorkflowCompounding: handleNoWorkflowCompounding
        });
      }
      return null;
    }
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$7, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: params === null || params === void 0 ? void 0 : params.documents,
            docType: "mandatory",
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
            setDeveloperRemarks: setDeveloperRemarksDocument,
            setError: setError,
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: SortingAlphabatically(siteInspRecommendation),
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument
            }, props, {
              error: error,
              setError: setError
            }))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DetailInfoTable, {
            detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
            type: "documentDetails"
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc,
            initialUrl: initialUrl
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: formData === null || formData === void 0 ? void 0 : formData.documents,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
        default:
          return null;
      }
    } else if (activeTab === 2) {
      var _formData$additionalD, _params$additionalDet;
      return /*#__PURE__*/React__default.createElement(EmpIdentifyNoc, {
        formData: {
          ...(formData || {}),
          ...(params || {}),
          nocDetails: (params === null || params === void 0 ? void 0 : params.nocDetails) || (formData === null || formData === void 0 ? void 0 : formData.nocDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.nocDetails) || (params === null || params === void 0 ? void 0 : (_params$additionalDet = params.additionalDetails) === null || _params$additionalDet === void 0 ? void 0 : _params$additionalDet.nocDetails),
          additionalDetails: {
            ...((formData === null || formData === void 0 ? void 0 : formData.additionalDetails) || {}),
            ...((params === null || params === void 0 ? void 0 : params.additionalDetails) || {})
          }
        },
        tenantId: tenantId,
        handleNoWorkflowNoc: handleNoWorkflowNoc,
        isJE: isJE,
        currentFormData: currentFormData
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isCitizen && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step7, {
        formData: formData
      })));
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CompletionChecklist, {
        formData: params,
        isEmployee: !isCitizen,
        handleTabChange: handleCompletionChecklistSave,
        onTabChange: handleTabChange,
        isValidEmp: isValidEmp,
        workflowDetails: workflowDetails,
        setParams: setParams,
        onSelect: onSelect
      }));
    } else if (activeTab === 5) {
      var _formData$status;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleTabChange,
        serviceName: "Map Submission"
      }), /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        workflowDetails: workflowDetails,
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : (_formData$status = formData.status) === null || _formData$status === void 0 ? void 0 : _formData$status.startsWith("APPLY_FOR_DSC")) && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false
      }), /*#__PURE__*/React__default.createElement(CollapsibleAdditionalRemarks, {
        formData: params || formData,
        additionalComment: additionalComment,
        setAdditionalComment: setAdditionalComment,
        handleSubmit: () => {
          var _additionalComment$tr;
          console.log("additionalComment12", additionalComment);
          if (((_additionalComment$tr = additionalComment.trim()) === null || _additionalComment$tr === void 0 ? void 0 : _additionalComment$tr.length) === 0) {
            return;
          }
          handleAdditionalComment();
        }
      }), /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || mapSubmissionAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: params || formData
      }), /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), ((_formData$drawingDeta, _formData$drawingDeta2) => {
        const status = (formData === null || formData === void 0 ? void 0 : formData.status) || "";
        const isDscStage = status.startsWith("APPLY_FOR_DSC") || status === "EE_TP_AFTER_PAYMENT" || status === "VC_AFTER_PAYMENT";
        const isApprovalSignedByEmp = Boolean((formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) === true);
        const isFullySigned = isApprovalSignedByEmp;
        const guardedHandleSubmit = () => {
          if (isDscStage && !isFullySigned) {
            setValidationPopup(true);
            return;
          }
          handleSubmit();
        };
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isDscStage && /*#__PURE__*/React__default.createElement(NewsTicker, {
          textForNews: "Please make a digital sign on sanction letter and approval letter"
        }), /*#__PURE__*/React__default.createElement(SubmitButton, {
          handleSubmit: guardedHandleSubmit,
          isLoading: updateApiCall.isLoading,
          showButton: !isFromDashboard
        }));
      })());
    } else if (activeTab === 6) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (activeTab === 7) {
      var _workflowDetails$data;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData,
        assignerToChatboard: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.processInstances
      }));
    } else if (activeTab === 8) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CustomLetter, {
        formData: formData,
        setCustomLetter: setCustomLetter,
        setTypeOfLetter: setTypeOfLetter,
        workflowDetails: workflowDetails,
        userRolesArray: userRolesArray,
        initialUrl: initialUrl,
        setIsPreviewLoading: setIsPreviewLoading,
        setIframeSrc: setIframeSrc,
        iframeSrc: iframeSrc
      }));
    } else if (activeTab === 9 && isPurchasbleReq) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PurchasableFARInfo, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        handleNoWorkflowPFAR: handleNoWorkflowPFAR,
        isJE: isJE
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(NewsTicker, {
    textForNews: "Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly."
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "fullWidth"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "NOC Status"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    setIsPreviewLoading: setIsPreviewLoading,
    setIframeSrc: setIframeSrc,
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), activeTab === 1 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabDocLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), validationPopup && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    },
    onClick: () => setValidationPopup(false)
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#fff",
      borderRadius: "8px",
      padding: "32px 28px 24px",
      maxWidth: "440px",
      width: "90%",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      position: "relative"
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "28px"
    }
  }, "\u26A0\uFE0F"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: 700,
      fontSize: "18px",
      color: "#b45309"
    }
  }, "Digital Signature Required")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "0 0 12px",
      color: "#374151",
      lineHeight: "1.6"
    }
  }, "You cannot submit at this stage without completing the digital signatures. Please ensure the following are signed:"), /*#__PURE__*/React__default.createElement("ul", {
    style: {
      margin: "0 0 20px 18px",
      color: "#374151",
      lineHeight: "1.8"
    }
  }, /*#__PURE__*/React__default.createElement("li", null, "\u2705 ", /*#__PURE__*/React__default.createElement("b", null, "Approval Certificate"), " \u2014 must be digitally signed by employee")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "0 0 24px",
      color: "#6b7280",
      fontSize: "13px"
    }
  }, "Once the document is signed, you can proceed with the submission."), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => setValidationPopup(false),
    style: {
      backgroundColor: "#157C4F",
      borderRadius: "6px",
      textTransform: "none",
      fontWeight: 600
    }
  }, "OK, I understand")))), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const ConversionChecklist = ({
  formData,
  handleTabChange,
  isEmployee,
  handleChecklistNoWorkflow
}) => {
  const {
    control,
    handleSubmit
  } = useForm();
  console.log("fromconversionchecklist", isEmployee);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    data: {
      BPA: {
        LandUseConversionChecklist
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["LandUseConversionChecklist"]);
  console.log("LandUseConversionChecklist", LandUseConversionChecklist, tenantId);
  const onSubmit = data => {
    console.log("conversionChecklistfromcomponenet", data);
    handleChecklistNoWorkflow(data === null || data === void 0 ? void 0 : data.conversionChecklist);
  };
  return /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f0f0f0"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "70%"
    }
  }, "Checklist"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%",
      textAlign: "center"
    }
  }, "Compliant"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%",
      textAlign: "center"
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, (LandUseConversionChecklist === null || LandUseConversionChecklist === void 0 ? void 0 : LandUseConversionChecklist.length) > 0 && (LandUseConversionChecklist === null || LandUseConversionChecklist === void 0 ? void 0 : LandUseConversionChecklist.map(item => {
    var _formData$conversionC, _formData$conversionC2;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.code
    }, /*#__PURE__*/React__default.createElement("td", null, item.question, /*#__PURE__*/React__default.createElement("span", {
      style: {
        color: "red",
        marginLeft: "3px",
        fontWeight: "bold"
      }
    }, "*")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      hasLabel: false,
      name: `conversionChecklist.${item.code}.compliance`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$conversionC = formData.conversionChecklist) === null || _formData$conversionC === void 0 ? void 0 : _formData$conversionC[item.code],
      type: "radioButton",
      data: yesOrNo,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      hasLabel: false,
      name: `conversionChecklist.${item.code}.remarks`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$conversionC2 = formData.conversionChecklist) === null || _formData$conversionC2 === void 0 ? void 0 : _formData$conversionC2[item.code],
      type: "textInput",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })));
  }))))), isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  }))));
};

const EmpLandUseConversionPortal = ({
  formData,
  submitAction,
  workflowDetails,
  userRolesArray
}) => {
  var _formData$description, _Digit, _Digit2;
  const specialCondition = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.selectLandUse) == "Conditional Permissible";
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LU_CURRENT_TAB")) || 0);
  const [subActiveTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LU_CURRENT_SUBTAB")) || 0);
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const [initialDeveloperRemarks, setInitialDeveloperRemarks] = useState("");
  const isApproved = (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED";
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList
  });
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    handleChecklistNoWorkflow,
    callDocumentDetailsAPI
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);
  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("LU_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("LU_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$1, {
            formData: formData,
            isEmployee: !isCitizen,
            handleSubTabChange: handleSubTabChange,
            applicationFlow: department,
            isApproved: true
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$1, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$1, {
            formData: formData,
            isEmployee: !isCitizen,
            t: t,
            handleSubTabChange: handleSubTabChange,
            isApproved: true
          });
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      switch (subActiveDocTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "view-doc-container"
          }, /*#__PURE__*/React__default.createElement(Button$2, {
            variant: "contained",
            className: "view-doc-btn",
            onClick: handleDocView,
            style: {
              backgroundColor: "#157C4F",
              borderRadius: "15px",
              padding: "5px 10px"
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "view-doc-icon"
          }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ?
          /*#__PURE__*/
          React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "mandatory",
            formType: "LANDUSE",
            setError: setError,
            setDeveloperRemarks: setDeveloperRemarksDocument,
            callDocumentDetailsAPI: callDocumentDetailsAPI,
            developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
            ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
              title: "Recommendation Details",
              label: "Recommendation",
              name: "recommendation",
              options: (props === null || props === void 0 ? void 0 : props.options) || siteInspRecommendation,
              defaultValue: dataRecommendationDocument,
              extraLabel: "Remarks",
              setDeveloperRemarks: setDeveloperRemarksDocument,
              developerRemarks: initialDeveloperRemarks || developerRemarksDocument,
              setDataRecommendation: setDataRecommendationDocument,
              callDocumentDetailsAPI: callDocumentDetailsAPI,
              error: error,
              setError: setError
            }, props))
          }), !isCitizen && /*#__PURE__*/React__default.createElement(DocumentSectionLog, {
            logData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks
          })) : /*#__PURE__*/React__default.createElement(ViewDocuments, {
            documentSection: documentSection,
            setIsPreviewLoading: setIsPreviewLoading,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc
          }));
        case 1:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
            formData: params,
            handleChange: handleTabChange,
            setUpdatedDocuments: setUpdatedDocuments,
            updatedDocuments: updatedDocuments,
            setIsPreviewLoading: setIsPreviewLoading,
            setDataRecommendation: setDataRecommendationDocument,
            onSelect: onSelect,
            handleNoWorkflow: handleNoWorkflow,
            attachedDocs: (params === null || params === void 0 ? void 0 : params.documents) || (formData === null || formData === void 0 ? void 0 : formData.documents),
            docType: "conditional"
          }));
      }
    } else if (activeTab === 1 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "view-doc-container"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        className: "view-doc-btn",
        onClick: handleDocView,
        style: {
          backgroundColor: "#157C4F",
          borderRadius: "15px",
          padding: "5px 10px"
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "view-doc-icon"
      }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: documentSection,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc
      }));
    } else if (activeTab === 2 && !isCitizen) {
      var _userRolesArray$;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(KhasraDetails, {
        callKhasraDetailsApi: callKhasraDetailsApi,
        updateKhasraDetails: updateKhasraDetails,
        formData: params,
        khasraRemarks: khasraRemarks,
        setKhasraRemarks: setKhasraRemarks,
        role: userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code
      }), /*#__PURE__*/React__default.createElement(KhasraDetailsLog, {
        logData: khasraDetailsData === null || khasraDetailsData === void 0 ? void 0 : khasraDetailsData.DetailDataRemarks
      }));
    } else if (activeTab === 2 && isCitizen) {
      var _actions$, _actions$2;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Architect, {
        formData: formData,
        applicationDocs: applicationDocs,
        actions: actions,
        avpLogo: avpLogo,
        daLogo: daLogo
      }), /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (actions === null || actions === void 0 ? void 0 : (_actions$ = actions[0]) === null || _actions$ === void 0 ? void 0 : _actions$.action) === "MAKE_PAYMENT" && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 8"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangePayment
      }, "Payment")))), (actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action) === "FORWARD_TO_DEPARTMENT" && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: "15px"
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: 1
      }, /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 2"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 6"
      }), /*#__PURE__*/React__default.createElement(Box, {
        gridColumn: "span 4"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        color: "success",
        style: {
          marginLeft: "10px"
        },
        onClick: handleChangeForward
      }, "Forward To Department")))));
    } else if (activeTab === 3 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ConversionChecklist, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: !isCitizen,
        handleChecklistNoWorkflow: handleChecklistNoWorkflow
      }));
    } else if (activeTab === 4 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
        formData: formData,
        handleChange: handleChange,
        serviceName: "Land Use Verification",
        avpLogo: avpLogo,
        daLogo: daLogo
      }), !isApproved && /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
        formData: formData,
        callNotingDetailsAPI: callNotingDetailsAPI,
        developerRemarks: developerRemarks,
        setDeveloperRemarks: setDeveloperRemarks,
        notingRemarksData: notingRemarksData,
        workflowDetails: workflowDetails
      }), (formData === null || formData === void 0 ? void 0 : formData.status) === "APPLY_FOR_DSC" && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "LA"
      }), !isApproved && /*#__PURE__*/React__default.createElement(ActionButtons, {
        actions: actions,
        currentAction: currentAction,
        onSelect: onRadioActionSelect
      }), !isApproved && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setRemarks,
        remarks: remarks,
        setError: setError,
        error: error
      }), !isApproved && /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), !isApproved && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 4 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatboardCorrespondenceApplicant, {
        formData: formData
      }));
    } else if (specialCondition && !isCitizen && activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SelectMandatoryConditions2, {
        setMandatoryCondition: setMandatoryCondition,
        tenantId: tenantId,
        setCurrentTab: handleChange
      }));
    } else if (!specialCondition && !isCitizen && activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData
      }));
    } else if (activeTab === 5 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (!specialCondition && !isCitizen && activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: formData
      }));
    } else if (activeTab === 6 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(MainWrapper, {
    className: "main-panel-corner land-use-corner"
  }, !isCitizen && /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Application Data"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Document Section"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Land Use Details"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Take Action"
  }), specialCondition && !isCitizen ? /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Conditions"
  }) : null, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Chat-Board"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "All Remarks"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), activeTab === 1 && !isCitizen && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveDocTab,
    onChange: (e, i) => handleSubDocTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, landUseSubTabDDocSecLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent())));
};

const fastpassAVP = "https://i.imgur.com/kWzFfx2.jpeg";
const fastPasDa = "https://i.imgur.com/bkxhiqG.png";

const SubStep1$8 = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee: _isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _formData$khasraDetai, _formData$khasraDetai2, _formData$additionalD, _formData$additionalD2, _formData$additionalD3, _formData$additionalD4, _formData$plotNumbers, _formData$additionalD5, _formData$additionalD6, _formData$additionalD7, _formData$pressDetail, _formData$pressReleas, _formData$additionalD8, _formData$additionalD9, _formData$additionalD10, _formData$additionalD11, _formData$additionalD12, _formData$additionalD13, _formData$mapSubDetai, _formData$additionalD14, _formData$additionalD15, _formData$additionalD16, _formData$additionalD17, _formData$additionalD18, _formData$additionalD19, _formData$additionalD20, _formData$additionalD21, _formData$additionalD22, _formData$additionalD23, _formData$additionalD24, _formData$additionalD25, _formData$additionalD26, _formData$additionalD27, _formData$additionalD28, _Digit, _data$MapSubmission, _data$MapSubmission$D, _formData$mapSubDetai3, _formData$professiona, _fastPASData$professi, _formData$professiona2, _fastPASData$professi2, _fastPASData$professi3, _fastPASData$professi4, _formData$professiona3, _formData$professiona4, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$landInfo15, _formData$landInfo15$, _formData$landInfo15$2, _formData$landInfo15$3, _formData$mapSubDetai4;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const [showError, setShowError] = useState(false);
  const tenantId = Digit.ULBService.getStateId();
  const {
    documents
  } = useSelector(state => state.formMT);
  const history = useHistory();
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const {
    data: {
      LandUseMasterData: {
        Authorities: mdmsSchemeData
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: mdmsNonSchemeData
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const finalSchemeTypeData = schemeTypeData || mdmsSchemeData;
  const finalNonSchemeTypeData = nonSchemeTypeData || mdmsNonSchemeData;
  const _khasraNo = (formData === null || formData === void 0 ? void 0 : (_formData$khasraDetai = formData.khasraDetails) === null || _formData$khasraDetai === void 0 ? void 0 : (_formData$khasraDetai2 = _formData$khasraDetai[0]) === null || _formData$khasraDetai2 === void 0 ? void 0 : _formData$khasraDetai2.khasraNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : (_formData$additionalD2 = _formData$additionalD.khasraDetails) === null || _formData$additionalD2 === void 0 ? void 0 : (_formData$additionalD3 = _formData$additionalD2[0]) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.khasraNumber) || (formData === null || formData === void 0 ? void 0 : formData.khasraNo) || "";
  const _plotNo = (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers[0]) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : (_formData$additionalD6 = _formData$additionalD5.plotNumbers) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6[0]) || "";
  const _pressReleaseFee = (formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail = formData.pressDetails) === null || _formData$pressDetail === void 0 ? void 0 : _formData$pressDetail.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas = formData.pressReleaseDetails) === null || _formData$pressReleas === void 0 ? void 0 : _formData$pressReleas.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD8 = formData.additionalDetails) === null || _formData$additionalD8 === void 0 ? void 0 : (_formData$additionalD9 = _formData$additionalD8.pressDetails) === null || _formData$additionalD9 === void 0 ? void 0 : _formData$additionalD9.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD10 = formData.additionalDetails) === null || _formData$additionalD10 === void 0 ? void 0 : (_formData$additionalD11 = _formData$additionalD10.pressReleaseDetails) === null || _formData$additionalD11 === void 0 ? void 0 : _formData$additionalD11.pressReleaseFee) || "";
  const defaultValues = {
    ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
    ...formData,
    professionaldetails: {
      ...((formData === null || formData === void 0 ? void 0 : (_formData$additionalD12 = formData.additionalDetails) === null || _formData$additionalD12 === void 0 ? void 0 : _formData$additionalD12.professionaldetails) || {})
    },
    mapSubDetails: {
      ...((formData === null || formData === void 0 ? void 0 : formData.mapSubDetails) || {}),
      applicationNo: (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD13 = formData.additionalDetails) === null || _formData$additionalD13 === void 0 ? void 0 : _formData$additionalD13.applicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.applicationNo) || ""
    },
    pressReleaseDetails: {
      ...((formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || {}),
      pressReleaseFee: _pressReleaseFee
    },
    zoneType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD14 = formData.additionalDetails) === null || _formData$additionalD14 === void 0 ? void 0 : _formData$additionalD14.zoneType) || (formData === null || formData === void 0 ? void 0 : formData.zoneType) || "",
    subZoneType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD15 = formData.additionalDetails) === null || _formData$additionalD15 === void 0 ? void 0 : _formData$additionalD15.subZoneType) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType) || "",
    activityProposed: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD16 = formData.additionalDetails) === null || _formData$additionalD16 === void 0 ? void 0 : _formData$additionalD16.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || "",
    natureOfConstruction: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD17 = formData.additionalDetails) === null || _formData$additionalD17 === void 0 ? void 0 : _formData$additionalD17.natureOfConstruction) || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) || "",
    schemeName: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD18 = formData.additionalDetails) === null || _formData$additionalD18 === void 0 ? void 0 : _formData$additionalD18.schemeName) || (formData === null || formData === void 0 ? void 0 : formData.schemeName) || "",
    fastPASId: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD19 = formData.additionalDetails) === null || _formData$additionalD19 === void 0 ? void 0 : _formData$additionalD19.fastPASId) || (formData === null || formData === void 0 ? void 0 : formData.land_Id) || (formData === null || formData === void 0 ? void 0 : formData.fastPASId),
    pressReleaseFee: _pressReleaseFee,
    tehsil: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD20 = formData.additionalDetails) === null || _formData$additionalD20 === void 0 ? void 0 : _formData$additionalD20.tehsil) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD21 = formData.additionalDetails) === null || _formData$additionalD21 === void 0 ? void 0 : _formData$additionalD21.locationTehsil) || (formData === null || formData === void 0 ? void 0 : formData.tehsil) || "",
    revenueVillage: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD22 = formData.additionalDetails) === null || _formData$additionalD22 === void 0 ? void 0 : _formData$additionalD22.revenueVillage) || (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) || "",
    plotArea: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD23 = formData.additionalDetails) === null || _formData$additionalD23 === void 0 ? void 0 : _formData$additionalD23.plotArea) || (formData === null || formData === void 0 ? void 0 : formData.plotArea) || "",
    plotAreaDoc: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD24 = formData.additionalDetails) === null || _formData$additionalD24 === void 0 ? void 0 : _formData$additionalD24.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : formData.plotAreaDoc) || "",
    primaryUse: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD25 = formData.additionalDetails) === null || _formData$additionalD25 === void 0 ? void 0 : _formData$additionalD25.primaryUse) || (formData === null || formData === void 0 ? void 0 : formData.primaryUse) || "",
    landMark: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD26 = formData.additionalDetails) === null || _formData$additionalD26 === void 0 ? void 0 : _formData$additionalD26.landMark) || (formData === null || formData === void 0 ? void 0 : formData.landMark) || "",
    proposalType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD27 = formData.additionalDetails) === null || _formData$additionalD27 === void 0 ? void 0 : _formData$additionalD27.proposal) || (formData === null || formData === void 0 ? void 0 : formData.proposalType) || "",
    khasraNo: _khasraNo,
    plotNo: _plotNo,
    isSpecialProject: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD28 = formData.additionalDetails) === null || _formData$additionalD28 === void 0 ? void 0 : _formData$additionalD28.isSpecialProject) || (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject),
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    clearErrors
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("EMP_MAPSUB")) || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);
  const [dwgPdfUrl, setDwgPdfUrl] = useState(formData === null || formData === void 0 ? void 0 : formData.drawingPdf);
  const [approvalUrl, setApprovalUrl] = useState(formData === null || formData === void 0 ? void 0 : formData.approvalCertificateUrl);
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["drawingPdf"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const handleFormSubmit = data => {
    var _data$pressReleaseDet;
    const pressFee = (data === null || data === void 0 ? void 0 : (_data$pressReleaseDet = data.pressReleaseDetails) === null || _data$pressReleaseDet === void 0 ? void 0 : _data$pressReleaseDet.pressReleaseFee) || (data === null || data === void 0 ? void 0 : data.pressReleaseFee) || watchPressReleaseFee || "";
    if (!pressFee) {
      setShowToast({
        key: "true",
        error: true,
        message: "Invitation suggestion is not required for this proposal."
      });
      return;
    }
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitinsideIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const [watchPlanOn, watchnatureOfConstruction, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchLandMark, watchState, watchCity, watchPin, watchAddress, watchConsultantCateogry, watchProfName, watchProfEmailId, watchProfMobileNo, watchCertNo, watchValidUpto, watchName, watchMobileNo, watchEmailId, watchProposalType, watchSchemeName, watchTehsil, watchVillage, watchSectorNo, watchKhasraNo, watchPlotNo, watchLatitude, watchLongitude, watchApplication, watchLayoutSanctionDate, watchValidity, watchPressReleaseFee] = watch(["planOn", "natureOfConstruction", "zoneType", "subZoneType", "primaryUse", "activityProposed", "landMark", "landInfo.owners.[0].correspondenceAddress.state", "landInfo.owners.[0].correspondenceAddress.town", "landInfo.owners.[0].correspondenceAddress.pinno", "landInfo.owners.[0].correspondenceAddress.address", "professionaldetails.consultantCategory", "professionaldetails.name", "professionaldetails.emailId", "professionaldetails.mobileNumber", "professionaldetails.certificateNo", "professionaldetails.validupto", "landInfo.owners.[0].name", "landInfo.owners.[0].mobileNumber", "landInfo.owners.[0].emailId", "proposalType", "schemeName", "tehsil", "revenueVillage", "sectorNo", "khasraNo", "plotNo", "descriptionOfLand.latitude", "descriptionOfLand.longitude", "mapSubDetails.applicationNo", "layoutsanctionDate", "validity", "pressReleaseFee"]);
  useEffect(() => {
    if (formData) {
      var _formData$khasraDetai3, _formData$khasraDetai4, _formData$additionalD29, _formData$additionalD30, _formData$additionalD31, _formData$additionalD32, _formData$plotNumbers2, _formData$additionalD33, _formData$additionalD34, _formData$additionalD35, _formData$mapSubDetai2, _formData$additionalD36, _formData$pressDetail2, _formData$pressReleas2, _formData$additionalD37, _formData$additionalD38, _formData$additionalD39, _formData$additionalD40, _formData$description, _formData$additionalD41, _formData$additionalD42, _formData$additionalD43, _formData$additionalD44, _formData$additionalD45, _formData$additionalD46, _formData$additionalD47, _formData$additionalD48, _formData$additionalD49, _formData$additionalD50, _formData$additionalD51, _formData$additionalD52, _formData$additionalD53, _formData$additionalD54, _formData$additionalD55, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3;
      const khasraNo = (formData === null || formData === void 0 ? void 0 : (_formData$khasraDetai3 = formData.khasraDetails) === null || _formData$khasraDetai3 === void 0 ? void 0 : (_formData$khasraDetai4 = _formData$khasraDetai3[0]) === null || _formData$khasraDetai4 === void 0 ? void 0 : _formData$khasraDetai4.khasraNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD29 = formData.additionalDetails) === null || _formData$additionalD29 === void 0 ? void 0 : (_formData$additionalD30 = _formData$additionalD29.khasraDetails) === null || _formData$additionalD30 === void 0 ? void 0 : (_formData$additionalD31 = _formData$additionalD30[0]) === null || _formData$additionalD31 === void 0 ? void 0 : _formData$additionalD31.khasraNumber) || (formData === null || formData === void 0 ? void 0 : formData.khasraNo) || "";
      const plotNo = (formData === null || formData === void 0 ? void 0 : (_formData$additionalD32 = formData.additionalDetails) === null || _formData$additionalD32 === void 0 ? void 0 : _formData$additionalD32.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[0]) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD33 = formData.additionalDetails) === null || _formData$additionalD33 === void 0 ? void 0 : (_formData$additionalD34 = _formData$additionalD33.plotNumbers) === null || _formData$additionalD34 === void 0 ? void 0 : _formData$additionalD34[0]) || "";
      const appNo = (formData === null || formData === void 0 ? void 0 : (_formData$additionalD35 = formData.additionalDetails) === null || _formData$additionalD35 === void 0 ? void 0 : _formData$additionalD35.applicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || "";
      const pressReleaseFee = (formData === null || formData === void 0 ? void 0 : (_formData$additionalD36 = formData.additionalDetails) === null || _formData$additionalD36 === void 0 ? void 0 : _formData$additionalD36.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail2 = formData.pressDetails) === null || _formData$pressDetail2 === void 0 ? void 0 : _formData$pressDetail2.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas2 = formData.pressReleaseDetails) === null || _formData$pressReleas2 === void 0 ? void 0 : _formData$pressReleas2.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD37 = formData.additionalDetails) === null || _formData$additionalD37 === void 0 ? void 0 : (_formData$additionalD38 = _formData$additionalD37.pressDetails) === null || _formData$additionalD38 === void 0 ? void 0 : _formData$additionalD38.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD39 = formData.additionalDetails) === null || _formData$additionalD39 === void 0 ? void 0 : (_formData$additionalD40 = _formData$additionalD39.pressReleaseDetails) === null || _formData$additionalD40 === void 0 ? void 0 : _formData$additionalD40.pressReleaseFee) || "";
      setFastPasData(prev => prev || formData);
      const isApproved = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
      setSchemeType(isApproved);
      reset({
        ...(formData === null || formData === void 0 ? void 0 : formData.additionalDetails),
        ...formData,
        professionaldetails: {
          ...((formData === null || formData === void 0 ? void 0 : (_formData$additionalD41 = formData.additionalDetails) === null || _formData$additionalD41 === void 0 ? void 0 : _formData$additionalD41.professionaldetails) || (formData === null || formData === void 0 ? void 0 : formData.professionalInformation) || {})
        },
        mapSubDetails: {
          ...((formData === null || formData === void 0 ? void 0 : formData.mapSubDetails) || {}),
          applicationNo: appNo
        },
        pressReleaseDetails: {
          ...((formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || {}),
          pressReleaseFee
        },
        zoneType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD42 = formData.additionalDetails) === null || _formData$additionalD42 === void 0 ? void 0 : _formData$additionalD42.zoneType) || (formData === null || formData === void 0 ? void 0 : formData.zoneType) || "",
        subZoneType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD43 = formData.additionalDetails) === null || _formData$additionalD43 === void 0 ? void 0 : _formData$additionalD43.subZoneType) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType) || "",
        activityProposed: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD44 = formData.additionalDetails) === null || _formData$additionalD44 === void 0 ? void 0 : _formData$additionalD44.activityProposed) || (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || "",
        natureOfConstruction: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD45 = formData.additionalDetails) === null || _formData$additionalD45 === void 0 ? void 0 : _formData$additionalD45.natureOfConstruction) || (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) || "",
        schemeName: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD46 = formData.additionalDetails) === null || _formData$additionalD46 === void 0 ? void 0 : _formData$additionalD46.schemeName) || (formData === null || formData === void 0 ? void 0 : formData.schemeName) || "",
        fastPASId: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD47 = formData.additionalDetails) === null || _formData$additionalD47 === void 0 ? void 0 : _formData$additionalD47.fastPASId) || (formData === null || formData === void 0 ? void 0 : formData.land_Id) || (formData === null || formData === void 0 ? void 0 : formData.fastPASId),
        pressReleaseFee,
        tehsil: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD48 = formData.additionalDetails) === null || _formData$additionalD48 === void 0 ? void 0 : _formData$additionalD48.tehsil) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD49 = formData.additionalDetails) === null || _formData$additionalD49 === void 0 ? void 0 : _formData$additionalD49.locationTehsil) || (formData === null || formData === void 0 ? void 0 : formData.tehsil) || "",
        revenueVillage: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD50 = formData.additionalDetails) === null || _formData$additionalD50 === void 0 ? void 0 : _formData$additionalD50.revenueVillage) || (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) || "",
        plotArea: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD51 = formData.additionalDetails) === null || _formData$additionalD51 === void 0 ? void 0 : _formData$additionalD51.plotArea) || (formData === null || formData === void 0 ? void 0 : formData.plotArea) || "",
        plotAreaDoc: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD52 = formData.additionalDetails) === null || _formData$additionalD52 === void 0 ? void 0 : _formData$additionalD52.plotAreaDoc) || (formData === null || formData === void 0 ? void 0 : formData.plotAreaDoc) || "",
        primaryUse: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD53 = formData.additionalDetails) === null || _formData$additionalD53 === void 0 ? void 0 : _formData$additionalD53.primaryUse) || (formData === null || formData === void 0 ? void 0 : formData.primaryUse) || "",
        landMark: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD54 = formData.additionalDetails) === null || _formData$additionalD54 === void 0 ? void 0 : _formData$additionalD54.landMark) || (formData === null || formData === void 0 ? void 0 : formData.landMark) || "",
        proposalType: (formData === null || formData === void 0 ? void 0 : (_formData$additionalD55 = formData.additionalDetails) === null || _formData$additionalD55 === void 0 ? void 0 : _formData$additionalD55.proposal) || (formData === null || formData === void 0 ? void 0 : formData.proposalType) || "",
        khasraNo,
        plotNo
      });
      setValue("landInfo.owners.[0].name", formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name);
      setValue("landInfo.owners.[0].emailId", formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.emailId);
      setValue("landInfo.owners.[0].mobileNumber", formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber);
      setValue("landInfo.owners.[0].correspondenceAddress.state", formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.correspondenceAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.state);
      setValue("landInfo.owners.[0].correspondenceAddress.town", formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.correspondenceAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.town);
      setValue("landInfo.owners.[0].correspondenceAddress.pinno", formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.pinno);
      setValue("landInfo.owners.[0].correspondenceAddress.address", formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.address);
    }
  }, [formData, reset, setValue]);
  useEffect(() => {
    const alldocs = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !_isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (_isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _data, _data$documents, _drawingPdfs$, _data4, _data5, _data5$pressDetails, _data6, _data6$pressReleaseDe, _data7, _data7$additionalDeta, _data8, _data8$additionalDeta, _data8$additionalDeta2, _data9, _data9$additionalDeta, _data9$additionalDeta2, _data10, _data11, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _data14$descriptionOf2, _data15, _data15$descriptionOf, _data16, _data17, _data18, _data18$auditDetails, _data19, _data20, _data21, _data22, _data23, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26, _data26$descriptionOf, _data27, _data27$descriptionOf, _data28, _data29, _data30, _data31, _data32, _data32$descriptionOf, _data33, _data33$descriptionOf, _data34, _data34$descriptionOf, _data35, _data35$descriptionOf, _data36, _data37, _data37$descriptionOf, _data38, _data39, _data39$professionald, _data40, _data40$professionald, _data41, _data41$professionald, _data42, _data42$professionald, _data43, _data43$professionald, _data44, _data44$professionald, _data45, _data45$landInfo, _data45$landInfo$owne, _data45$landInfo$owne2, _data46, _data46$landInfo, _data46$landInfo$owne, _data46$landInfo$owne2, _data47, _data47$landInfo, _data47$landInfo$owne, _data47$landInfo$owne2, _data48, _data48$landInfo, _data48$landInfo$owne, _data48$landInfo$owne2, _data48$landInfo$owne3, _data49, _data49$landInfo$owne, _data49$landInfo$owne2, _data49$landInfo$owne3, _data50, _data50$landInfo$owne, _data50$landInfo$owne2, _data50$landInfo$owne3, _data51, _data51$landInfo$owne, _data51$landInfo$owne2, _data51$landInfo$owne3, _data52, _data52$descriptionOf;
        response = await OBPSService.BPASearch(tenantId, {
          applicationNo
        });
        console.log(response, "responsefromId");
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this Application No...!!`
          });
          return;
        }
        data = (_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : _response2$BPA[0];
        setFastPasData(data);
        const drawingPdfs = (_data = data) === null || _data === void 0 ? void 0 : (_data$documents = _data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.filter(e => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs === null || drawingPdfs === void 0 ? void 0 : (_drawingPdfs$ = drawingPdfs[0]) === null || _drawingPdfs$ === void 0 ? void 0 : _drawingPdfs$.fileStoreId);
        if (data) {
          var _data2, _data3;
          setDwgPdfUrl((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.drawingPdf);
          setApprovalUrl((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.approvalCertificateUrl);
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`
          });
        }
        console.log("loggingDataFromSearch", data);
        const fetchedPressFee = ((_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.pressReleaseFee) || ((_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$pressDetails = _data5.pressDetails) === null || _data5$pressDetails === void 0 ? void 0 : _data5$pressDetails.pressReleaseFee) || ((_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$pressReleaseDe = _data6.pressReleaseDetails) === null || _data6$pressReleaseDe === void 0 ? void 0 : _data6$pressReleaseDe.pressReleaseFee) || ((_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$additionalDeta = _data7.additionalDetails) === null || _data7$additionalDeta === void 0 ? void 0 : _data7$additionalDeta.pressReleaseFee) || ((_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$additionalDeta = _data8.additionalDetails) === null || _data8$additionalDeta === void 0 ? void 0 : (_data8$additionalDeta2 = _data8$additionalDeta.pressDetails) === null || _data8$additionalDeta2 === void 0 ? void 0 : _data8$additionalDeta2.pressReleaseFee) || ((_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$additionalDeta = _data9.additionalDetails) === null || _data9$additionalDeta === void 0 ? void 0 : (_data9$additionalDeta2 = _data9$additionalDeta.pressReleaseDetails) === null || _data9$additionalDeta2 === void 0 ? void 0 : _data9$additionalDeta2.pressReleaseFee) || "";
        setValue("zoneType", (_data10 = data) === null || _data10 === void 0 ? void 0 : _data10.zoneType);
        setValue("primaryUse", (_data11 = data) === null || _data11 === void 0 ? void 0 : _data11.primaryUse);
        setValue("landMark", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.landMark);
        setValue("sectorNo", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.sectorNo);
        setValue("khasraNo", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : (_data14$descriptionOf2 = _data14$descriptionOf.khasraWithArea[0]) === null || _data14$descriptionOf2 === void 0 ? void 0 : _data14$descriptionOf2.khasraNo);
        setValue("schemeName", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : _data15$descriptionOf.schemeName);
        setValue("natureOfConstruction", (_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.natureOfConstruction);
        setValue("sanctionNumber", (_data17 = data) === null || _data17 === void 0 ? void 0 : _data17.sanctionNumber);
        const lastModifiedTime = (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$auditDetails = _data18.auditDetails) === null || _data18$auditDetails === void 0 ? void 0 : _data18$auditDetails.lastModifiedTime;
        setValue("revenueVillage", (_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.revenueVillage);
        setValue("landMark", (_data20 = data) === null || _data20 === void 0 ? void 0 : _data20.landMark);
        setValue("sectorNo", (_data21 = data) === null || _data21 === void 0 ? void 0 : _data21.sectorNo);
        setValue("khasraNo", (_data22 = data) === null || _data22 === void 0 ? void 0 : _data22.khasraNo);
        setValue("plotNo", (_data23 = data) === null || _data23 === void 0 ? void 0 : _data23.plotNo);
        setValue("descriptionOfLand.latitude", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.latitude);
        setValue("descriptionOfLand.longitude", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.longitude);
        setValue("descriptionOfLand.schemeType", (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$descriptionOf = _data26.descriptionOfLand) === null || _data26$descriptionOf === void 0 ? void 0 : _data26$descriptionOf.schemeType);
        setValue("schemeName", (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$descriptionOf = _data27.descriptionOfLand) === null || _data27$descriptionOf === void 0 ? void 0 : _data27$descriptionOf.schemeName);
        setValue("riskType", (_data28 = data) === null || _data28 === void 0 ? void 0 : _data28.riskType);
        setValue("pressReleaseDetails.pressReleaseFee", fetchedPressFee);
        setValue("department", (_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.department);
        setValue("activityProposed", (_data30 = data) === null || _data30 === void 0 ? void 0 : _data30.activityProposed);
        setValue("proposalType", (_data31 = data) === null || _data31 === void 0 ? void 0 : _data31.proposal);
        setValue("plotArea", (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$descriptionOf = _data32.descriptionOfLand) === null || _data32$descriptionOf === void 0 ? void 0 : _data32$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$descriptionOf = _data33.descriptionOfLand) === null || _data33$descriptionOf === void 0 ? void 0 : _data33$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data34 = data) === null || _data34 === void 0 ? void 0 : (_data34$descriptionOf = _data34.descriptionOfLand) === null || _data34$descriptionOf === void 0 ? void 0 : _data34$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$descriptionOf = _data35.descriptionOfLand) === null || _data35$descriptionOf === void 0 ? void 0 : _data35$descriptionOf.landAddress);
        setValue("tehsil", (_data36 = data) === null || _data36 === void 0 ? void 0 : _data36.tehsil);
        setValue("typeOfArea", (_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$descriptionOf = _data37.descriptionOfLand) === null || _data37$descriptionOf === void 0 ? void 0 : _data37$descriptionOf.developmentArea);
        setValue("subZoneType", (_data38 = data) === null || _data38 === void 0 ? void 0 : _data38.subZoneType);
        setValue("professionaldetails.consultantCategory", (_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$professionald = _data39.professionaldetails) === null || _data39$professionald === void 0 ? void 0 : _data39$professionald.consultantCategory);
        setValue("professionaldetails.name", (_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$professionald = _data40.professionaldetails) === null || _data40$professionald === void 0 ? void 0 : _data40$professionald.name);
        setValue("professionaldetails.emailId", (_data41 = data) === null || _data41 === void 0 ? void 0 : (_data41$professionald = _data41.professionaldetails) === null || _data41$professionald === void 0 ? void 0 : _data41$professionald.emailId);
        setValue("professionaldetails.mobileNumber", (_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$professionald = _data42.professionaldetails) === null || _data42$professionald === void 0 ? void 0 : _data42$professionald.mobileNumber);
        setValue("professionaldetails.certificateNo", (_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$professionald = _data43.professionaldetails) === null || _data43$professionald === void 0 ? void 0 : _data43$professionald.certificateNo);
        setValue("professionaldetails.validupto", (_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$professionald = _data44.professionaldetails) === null || _data44$professionald === void 0 ? void 0 : _data44$professionald.validupto);
        setValue("landInfo.owners.[0].name", (_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$landInfo = _data45.landInfo) === null || _data45$landInfo === void 0 ? void 0 : (_data45$landInfo$owne = _data45$landInfo.owners) === null || _data45$landInfo$owne === void 0 ? void 0 : (_data45$landInfo$owne2 = _data45$landInfo$owne[0]) === null || _data45$landInfo$owne2 === void 0 ? void 0 : _data45$landInfo$owne2.name);
        setValue("landInfo.owners.[0].emailId", (_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$landInfo = _data46.landInfo) === null || _data46$landInfo === void 0 ? void 0 : (_data46$landInfo$owne = _data46$landInfo.owners) === null || _data46$landInfo$owne === void 0 ? void 0 : (_data46$landInfo$owne2 = _data46$landInfo$owne[0]) === null || _data46$landInfo$owne2 === void 0 ? void 0 : _data46$landInfo$owne2.emailId);
        setValue("landInfo.owners.[0].mobileNumber", (_data47 = data) === null || _data47 === void 0 ? void 0 : (_data47$landInfo = _data47.landInfo) === null || _data47$landInfo === void 0 ? void 0 : (_data47$landInfo$owne = _data47$landInfo.owners) === null || _data47$landInfo$owne === void 0 ? void 0 : (_data47$landInfo$owne2 = _data47$landInfo$owne[0]) === null || _data47$landInfo$owne2 === void 0 ? void 0 : _data47$landInfo$owne2.mobileNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.state", (_data48 = data) === null || _data48 === void 0 ? void 0 : (_data48$landInfo = _data48.landInfo) === null || _data48$landInfo === void 0 ? void 0 : (_data48$landInfo$owne = _data48$landInfo.owners) === null || _data48$landInfo$owne === void 0 ? void 0 : (_data48$landInfo$owne2 = _data48$landInfo$owne[0]) === null || _data48$landInfo$owne2 === void 0 ? void 0 : (_data48$landInfo$owne3 = _data48$landInfo$owne2.correspondenceAddress) === null || _data48$landInfo$owne3 === void 0 ? void 0 : _data48$landInfo$owne3.state);
        setValue("landInfo.owners.[0].correspondenceAddress.town", (_data49 = data) === null || _data49 === void 0 ? void 0 : (_data49$landInfo$owne = _data49.landInfo.owners) === null || _data49$landInfo$owne === void 0 ? void 0 : (_data49$landInfo$owne2 = _data49$landInfo$owne[0]) === null || _data49$landInfo$owne2 === void 0 ? void 0 : (_data49$landInfo$owne3 = _data49$landInfo$owne2.correspondenceAddress) === null || _data49$landInfo$owne3 === void 0 ? void 0 : _data49$landInfo$owne3.town);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", (_data50 = data) === null || _data50 === void 0 ? void 0 : (_data50$landInfo$owne = _data50.landInfo.owners) === null || _data50$landInfo$owne === void 0 ? void 0 : (_data50$landInfo$owne2 = _data50$landInfo$owne[0]) === null || _data50$landInfo$owne2 === void 0 ? void 0 : (_data50$landInfo$owne3 = _data50$landInfo$owne2.correspondenceAddress) === null || _data50$landInfo$owne3 === void 0 ? void 0 : _data50$landInfo$owne3.pinno);
        setValue("landInfo.owners.[0].correspondenceAddress.address", (_data51 = data) === null || _data51 === void 0 ? void 0 : (_data51$landInfo$owne = _data51.landInfo.owners) === null || _data51$landInfo$owne === void 0 ? void 0 : (_data51$landInfo$owne2 = _data51$landInfo$owne[0]) === null || _data51$landInfo$owne2 === void 0 ? void 0 : (_data51$landInfo$owne3 = _data51$landInfo$owne2.correspondenceAddress) === null || _data51$landInfo$owne3 === void 0 ? void 0 : _data51$landInfo$owne3.address);
        if (!fetchedPressFee) {
          setShowToast({
            key: "true",
            error: true,
            message: `Invitation suggestion is not required for this proposal.`
          });
        }
        clearErrors(["zoneType", "primaryUse", "landMark", "sectorNo", "khasraNo", "schemeName", "planOn", "riskType", "activityProposed", "plotArea", "plotAreaDoc", "plotNo", "plotAreaPos", "landAddress", "tehsil", "typeOfArea", "subZoneType", "latitude", "longitude", "roadwidth", "schemeType", "ConstructionType", "district", "professionaldetails.name", "professionaldetails.mobileNumber"]);
        const isApproved = ((_data52 = data) === null || _data52 === void 0 ? void 0 : (_data52$descriptionOf = _data52.descriptionOfLand) === null || _data52$descriptionOf === void 0 ? void 0 : _data52$descriptionOf.schemeType) === "Scheme";
        setSchemeType(isApproved);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.name === authority);
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Categery, _masterData$2, _masterData$2$Categer, _masterData$2$Categer2, _masterData$2$Categer3, _masterData$2$Categer4;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Categery = _masterData$.CategeryType) === null || _masterData$$Categery === void 0 ? void 0 : _masterData$$Categery.map(item => {
      return {
        name: item.Categery,
        label: item.Categery
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categer = _masterData$2.CategeryType) === null || _masterData$2$Categer === void 0 ? void 0 : (_masterData$2$Categer2 = _masterData$2$Categer.filter(item => item.Categery === category)) === null || _masterData$2$Categer2 === void 0 ? void 0 : (_masterData$2$Categer3 = _masterData$2$Categer2[0]) === null || _masterData$2$Categer3 === void 0 ? void 0 : (_masterData$2$Categer4 = _masterData$2$Categer3["Activity Proposed"]) === null || _masterData$2$Categer4 === void 0 ? void 0 : _masterData$2$Categer4.map(item => {
      return {
        name: item,
        label: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = !schemeType ? filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, finalSchemeTypeData, watchlandUseType) : filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, finalNonSchemeTypeData, watchlandUseType);
  const onSubmit = data => {
    var _data$pressReleaseDet2, _data$pressReleaseDet3, _fastPASData$landInfo, _data$landInfo;
    const pressFee = (data === null || data === void 0 ? void 0 : (_data$pressReleaseDet2 = data.pressReleaseDetails) === null || _data$pressReleaseDet2 === void 0 ? void 0 : _data$pressReleaseDet2.pressReleaseFee) || (data === null || data === void 0 ? void 0 : data.pressReleaseFee) || "";
    const sug = (data === null || data === void 0 ? void 0 : data.hasSuggestion) || (data === null || data === void 0 ? void 0 : (_data$pressReleaseDet3 = data.pressReleaseDetails) === null || _data$pressReleaseDet3 === void 0 ? void 0 : _data$pressReleaseDet3.hasSuggestion) || "";
    const pressDetailsObj = {
      ...((fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.pressDetails) || {}),
      ...((fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.pressReleaseDetails) || {}),
      ...((data === null || data === void 0 ? void 0 : data.pressReleaseDetails) || {}),
      ...((data === null || data === void 0 ? void 0 : data.pressDetails) || {}),
      pressReleaseFee: pressFee,
      hasSuggestion: sug
    };
    let final = {
      ...fastPASData,
      ...data,
      pressReleaseFee: pressFee,
      hasSuggestion: sug,
      pressDetails: pressDetailsObj,
      pressReleaseDetails: pressDetailsObj,
      landInfo: {
        ...data.landInfo,
        tenantId: "up",
        address: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo = fastPASData.landInfo) === null || _fastPASData$landInfo === void 0 ? void 0 : _fastPASData$landInfo.address) || ((_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : _data$landInfo.address)
      }
    };
    if (_isEmployee) {
      handleTabChange(2, final);
    } else {
      handleTabChange(1, final);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Application No",
    placeholder: "Enter Application No",
    name: "mapSubDetails.applicationNo",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.applicationNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee,
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("mapSubDetails.applicationNo"))
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Consultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee | (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi = fastPASData.professionaldetails) === null || _fastPASData$professi === void 0 ? void 0 : _fastPASData$professi.consultantCategory)
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    disabled: _isEmployee || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi2 = fastPASData.professionaldetails) === null || _fastPASData$professi2 === void 0 ? void 0 : _fastPASData$professi2.name)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi3 = fastPASData.professionaldetails) === null || _fastPASData$professi3 === void 0 ? void 0 : _fastPASData$professi3.emailId)
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi4 = fastPASData.professionaldetails) === null || _fastPASData$professi4 === void 0 ? void 0 : _fastPASData$professi4.mobileNumber)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.certificateNo,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.validupto,
    disabled: _isEmployee || watchValidUpto
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : _formData$landInfo9$o2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: _isEmployee || watchName
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : _formData$landInfo10$2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee || watchMobileNo
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : _formData$landInfo11$2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee || watchEmailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchState
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchCity
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: _isEmployee || watchPin
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo15 = formData.landInfo) === null || _formData$landInfo15 === void 0 ? void 0 : (_formData$landInfo15$ = _formData$landInfo15.owners) === null || _formData$landInfo15$ === void 0 ? void 0 : (_formData$landInfo15$2 = _formData$landInfo15$[0]) === null || _formData$landInfo15$2 === void 0 ? void 0 : (_formData$landInfo15$3 = _formData$landInfo15$2.correspondenceAddress) === null || _formData$landInfo15$3 === void 0 ? void 0 : _formData$landInfo15$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: _isEmployee || watchAddress
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchlandUseType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.subZoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchSubZoneType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchPrimaryUse
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchAtivityProposed
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(planOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposalType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    type: "selectInput",
    disabled: _isEmployee || watchProposalType
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed Site"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput",
    disabled: _isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction No."),
    control: control,
    placeholder: t("Enter sanction number"),
    name: "mapSubDetails.applicationNo",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.applicationNo) || watchApplication,
    type: "textInput",
    disabled: _isEmployee || watchApplication
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction Date"),
    control: control,
    placeholder: t("Enter Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: _isEmployee || watchLayoutSanctionDate
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: SortingAlphabatically(natureOfConstructionOptions),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee || watchnatureOfConstruction
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Validity"),
    control: control,
    placeholder: t("Select Validity"),
    name: "validity",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.validity,
    type: "datePicker",
    disabled: _isEmployee || watchValidity
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    disabled: _isEmployee || watchSchemeName
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    name: `tehsil`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: _isEmployee || watchLandMark
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput",
    disabled: _isEmployee || watchPlotNo
  })), /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  })))), !_isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document Section"))), " ", /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Map PDF"),
    control: control,
    name: "drawingPdf",
    showError: showError,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Fee Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Press Release Fee"),
    control: control,
    placeholder: t("Press Release Fee"),
    name: "pressReleaseDetails.pressReleaseFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee,
    type: "textInput",
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null)))), !_isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const SuggestionReviewTable = ({
  formData,
  onSelect
}) => {
  var _formData$additionalD, _formData$additionalD2, _formData$pressReleas, _formData$pressReleas2;
  const {
    t
  } = useTranslation();
  const Modal = useModal();
  console.log("formDataFromSuggestion", formData);
  const pressReleaseSrc = (formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : formData.pressDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.pressDetails);
  const existingSuggestions = pressReleaseSrc === null || pressReleaseSrc === void 0 ? void 0 : pressReleaseSrc.suggestions;
  const defaultSuggestionRow = {
    date: "",
    objectionNumber: "",
    name: "",
    mobileNumber: "",
    detailAddress: "",
    summary: "",
    attachPdf: "",
    decision: "",
    remark: ""
  };
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: {
      errors
    },
    reset
  } = useForm({
    defaultValues: {
      pressReleaseDetails: {
        pressReleaseDate: (pressReleaseSrc === null || pressReleaseSrc === void 0 ? void 0 : pressReleaseSrc.pressReleaseDate) || "",
        lastObjectionDate: (pressReleaseSrc === null || pressReleaseSrc === void 0 ? void 0 : pressReleaseSrc.lastObjectionDate) || "",
        suggestions: (existingSuggestions === null || existingSuggestions === void 0 ? void 0 : existingSuggestions.length) > 0 ? existingSuggestions : [defaultSuggestionRow]
      }
    }
  });
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "pressReleaseDetails.suggestions"
  });
  const {
    documents
  } = useSelector(state => state.formMT, shallowEqual);
  const dispatch = useDispatch();
  const {
    addFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const [showError, setShowError] = useState(false);
  const [pressReleasePdfError, setPressReleasePdfError] = useState(false);
  useEffect(() => {
    var _formData$additionalD3, _formData$additionalD4, _formData$documents;
    const currentPressReleaseSrc = (formData === null || formData === void 0 ? void 0 : formData.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.pressReleaseDetails) || (formData === null || formData === void 0 ? void 0 : formData.pressDetails) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.pressDetails);
    if (currentPressReleaseSrc) {
      const suggestions = currentPressReleaseSrc.suggestions;
      reset({
        pressReleaseDetails: {
          pressReleaseDate: currentPressReleaseSrc.pressReleaseDate || "",
          lastObjectionDate: currentPressReleaseSrc.lastObjectionDate || "",
          suggestions: (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 ? suggestions : [defaultSuggestionRow]
        }
      });
    }
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      const pressReleaseDoc = formData.documents.find(doc => doc.documentType === "pressReleasePdf");
      if (pressReleaseDoc) {
        const isAlreadyInRedux = documents === null || documents === void 0 ? void 0 : documents.some(d => d.documentType === "pressReleasePdf" && d.fileStoreId === pressReleaseDoc.fileStoreId);
        if (!isAlreadyInRedux) {
          addFormMTDoc({
            documentType: "pressReleasePdf",
            fileStoreId: pressReleaseDoc.fileStoreId,
            isMandatory: pressReleaseDoc.isMandatory || true,
            additionalDetails: pressReleaseDoc.additionalDetails || {
              title: "Press Release PDF",
              fileName: "press_release.pdf"
            }
          });
        }
      }
    }
  }, [formData]);
  const StyleTableCell = styled(TableCell$1)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: "bold",
      padding: "8px"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      padding: "6px 8px"
    }
  }));
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const StyledTableRow = styled(TableRow$1)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const handleAddRow = () => {
    append({
      date: "",
      objectionNumber: "",
      name: "",
      detailAddress: "",
      summary: "",
      attachPdf: "",
      decision: "",
      remark: ""
    });
  };
  const handleRemoveRow = index => {
    if (fields.length > 1) {
      remove(index);
    }
  };
  const handleNoWorkflow = data => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const pressReleasePdfDoc = documents === null || documents === void 0 ? void 0 : documents.find(doc => doc.documentType === "pressReleasePdf");
    const existingDocs = (formData === null || formData === void 0 ? void 0 : formData.documents) || [];
    let mergedDocuments = [...existingDocs];
    if (pressReleasePdfDoc) {
      mergedDocuments = mergedDocuments.filter(d => d.documentType !== "pressReleasePdf");
      mergedDocuments.push({
        documentType: "pressReleasePdf",
        fileStoreId: pressReleasePdfDoc.fileStoreId,
        isMandatory: true,
        additionalDetails: pressReleasePdfDoc.additionalDetails || {}
      });
    }
    const appData = {
      ...formData,
      ...data,
      documents: mergedDocuments,
      workflow
    };
    updateApiCall.mutate({
      LandUse: appData
    }, {
      onSuccess: result => {
        var _result$LandUse;
        console.log("resultFromUpdate", result);
        onSelect("", result === null || result === void 0 ? void 0 : (_result$LandUse = result.LandUse) === null || _result$LandUse === void 0 ? void 0 : _result$LandUse[0]);
        Modal("Application Data Updated Successfully", "Data for suggestion review section is now updated", "success");
      }
    });
  };
  const onSubmit = data => {
    console.log("Form Data:", data);
    const pressReleasePdfDoc = documents === null || documents === void 0 ? void 0 : documents.find(doc => doc.documentType === "pressReleasePdf" && doc.fileStoreId);
    if (!pressReleasePdfDoc) {
      setPressReleasePdfError(true);
      Modal("Press Release PDF is Required", "Please upload the Press Release PDF before submitting.", "error");
      return;
    }
    setPressReleasePdfError(false);
    handleNoWorkflow(data);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), " ", /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Date of Press Release"),
    control: control,
    placeholder: t("Enter Date of Press Release"),
    name: "pressReleaseDetails.pressReleaseDate",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas = formData.pressReleaseDetails) === null || _formData$pressReleas === void 0 ? void 0 : _formData$pressReleas.pressReleaseDate) || "",
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Last Date for Objection Submission"),
    control: control,
    placeholder: t("Enter Last Date for Objection Submission"),
    name: "pressReleaseDetails.lastObjectionDate",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas2 = formData.pressReleaseDetails) === null || _formData$pressReleas2 === void 0 ? void 0 : _formData$pressReleas2.lastObjectionDate) || "",
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Press Release PDF"),
    control: control,
    name: "pressReleasePdf",
    showError: pressReleasePdfError,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), pressReleasePdfError && /*#__PURE__*/React__default.createElement("p", {
    style: {
      color: "red",
      fontSize: "12px",
      marginTop: "4px"
    }
  }, "Press Release PDF is mandatory. Please upload the file.")), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "16px",
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React__default.createElement(AddIcon$1, null),
    onClick: handleAddRow,
    size: "small"
  }, "Add Row")), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    style: {
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    "aria-label": "sticky table",
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "80px"
  }, "Date"), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "120px"
  }, "Name"), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "120px"
  }, "Mobile Number"), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "150px"
  }, "Detail Address"), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "180px"
  }, "Objection/Suggestion Summary"), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center",
    width: "80px"
  }, "Action"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, fields.map((field, index) => /*#__PURE__*/React__default.createElement(StyledTableRow, {
    key: field.id
  }, /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `pressReleaseDetails.suggestions.${index}.date`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      type: "date",
      size: "small",
      variant: "outlined",
      InputLabelProps: {
        shrink: true
      },
      inputProps: {
        style: {
          fontSize: "12px"
        }
      },
      sx: {
        width: "100%",
        "& .MuiInputBase-root": {
          height: "32px"
        }
      }
    }))
  })), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `pressReleaseDetails.suggestions.${index}.name`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      size: "small",
      variant: "outlined",
      placeholder: "Name",
      inputProps: {
        style: {
          fontSize: "12px"
        }
      },
      sx: {
        width: "100%",
        "& .MuiInputBase-root": {
          height: "32px"
        }
      }
    }))
  })), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `pressReleaseDetails.suggestions.${index}.mobileNumber`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      size: "small",
      variant: "outlined",
      placeholder: "Mobile Number",
      inputProps: {
        style: {
          fontSize: "12px"
        }
      },
      sx: {
        width: "100%",
        "& .MuiInputBase-root": {
          height: "32px"
        }
      }
    }))
  })), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `pressReleaseDetails.suggestions.${index}.detailAddress`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      size: "small",
      variant: "outlined",
      placeholder: "Address",
      multiline: true,
      rows: 1,
      inputProps: {
        style: {
          fontSize: "12px"
        }
      },
      sx: {
        width: "100%",
        "& .MuiInputBase-root": {
          minHeight: "32px"
        }
      }
    }))
  })), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: `pressReleaseDetails.suggestions.${index}.summary`,
    control: control,
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, field, {
      size: "small",
      variant: "outlined",
      placeholder: "Summary",
      multiline: true,
      rows: 1,
      inputProps: {
        style: {
          fontSize: "12px"
        }
      },
      sx: {
        width: "100%",
        "& .MuiInputBase-root": {
          minHeight: "32px"
        }
      }
    }))
  })), /*#__PURE__*/React__default.createElement(StyleTableCell, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    color: "error",
    onClick: () => handleRemoveRow(index),
    disabled: fields.length === 1,
    title: fields.length === 1 ? "Cannot delete the last row" : "Delete row"
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, {
    fontSize: "small"
  })))))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "16px",
      display: "flex",
      gap: "8px",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, "Submit"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    onClick: () => reset()
  }, "Reset")))));
};

const HeaderContent = ({
  applicationFlow
}) => {
  return /*#__PURE__*/React__default.createElement("header", {
    className: "headerContent"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: applicationFlow === "DA" ? fastPasDa : fastpassAVP,
    alt: "fastpassAVP"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "autoLogoutIcon"
  }, /*#__PURE__*/React__default.createElement(AutoLogoutWarning, {
    color: "#1F4A7C"
  })));
};

const EmpFormSuggestionPortal = ({
  formData,
  refetch,
  submitAction,
  workflowDetails,
  userRolesArray,
  isFromDashboard
}) => {
  var _Digit, _Digit2;
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LU_CURRENT_TAB")) || 0);
  const [subActiveTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LU_CURRENT_SUBTAB")) || 0);
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = (formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED";
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    handleChecklistNoWorkflow
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);
  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("LU_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("LU_CURRENT_SUBTAB", nextSubTab);
  };
  const isEditableByCitizen = isCitizen && ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF"].includes(formData === null || formData === void 0 ? void 0 : formData.status);
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return /*#__PURE__*/React__default.createElement(SubStep1$8, {
          formData: params,
          isEmployee: !isCitizen || !isEditableByCitizen,
          handleSubTabChange: handleSubTabChange,
          applicationFlow: department,
          isApproved: true
        });
      case 1:
        if (isCitizen) return /*#__PURE__*/React__default.createElement(AllRemarksList, {
          remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
          formData: params
        });
        return /*#__PURE__*/React__default.createElement(SuggestionReviewTable, {
          formData: params,
          onSelect: onSelect
        });
      case 2:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PrimaryContent, {
          formData: params,
          handleChange: handleChange,
          serviceName: "Inviting Suggestion/Objection",
          avpLogo: avpLogo,
          daLogo: daLogo
        }), !isApproved && /*#__PURE__*/React__default.createElement(CollapsibleHistory, {
          formData: params,
          callNotingDetailsAPI: callNotingDetailsAPI,
          developerRemarks: developerRemarks,
          setDeveloperRemarks: setDeveloperRemarks,
          notingRemarksData: notingRemarksData
        }), !isApproved && /*#__PURE__*/React__default.createElement(ActionButtons, {
          actions: actions,
          currentAction: currentAction,
          onSelect: onRadioActionSelect
        }), !isApproved && /*#__PURE__*/React__default.createElement(RemarksEditor, {
          setRemarks: setRemarks,
          remarks: remarks,
          setError: setError,
          error: error
        }), !isApproved && /*#__PURE__*/React__default.createElement(DocUploader, {
          uploadedFile: uploadedFile,
          setUploadedFile: setUploadedFile
        }), !isApproved && /*#__PURE__*/React__default.createElement(SubmitButton, {
          handleSubmit: handleSubmit,
          isLoading: updateApiCall.isLoading
        }));
      default:
        return null;
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, {
    className: "main-panel-corner land-use-corner"
  }, !isCitizen && /*#__PURE__*/React__default.createElement(EmpTopBar, {
    formData: formData,
    workflowDetails: workflowDetails
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Application Data"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Suggestion Review"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Take Action"
  }), isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    label: "Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent())));
};

function ApplicationDetailsContentForm11({
  applicationDetails,
  isLoading,
  setOnAddComments,
  workflowDetails,
  isDataLoading,
  applicationData,
  refetch,
  timelineStatusPrefix,
  showTimeLine = true,
  onActionSelect,
  forcedActionPrefix,
  submitAction,
  actionData,
  moduleCode,
  businessService,
  action,
  statusAttribute = "status",
  formType,
  userRolesArray,
  workflow,
  isFromDashboard
}) {
  var _applicationDetails$a, _applicationDetails$a2, _applicationDetails$b, _applicationDetails$a3, _applicationDetails$a4;
  const {
    t
  } = useTranslation();
  console.log("loggingFormTypeFromAppForm!!", formType, applicationDetails, isFromDashboard);
  return /*#__PURE__*/React__default.createElement(Card, {
    className: "employeeCard-override"
  }, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : formType === "MAP_SUB" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PLINTH" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PLINTH" ? /*#__PURE__*/React__default.createElement(EmpPlinthPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "FORM_PRESSRELEASE" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PRESSRELEASE" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PRESSRELEASE" ? /*#__PURE__*/React__default.createElement(EmpFormSuggestionPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "FORM_LANDUSECONVERSION" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_LANDUSECONVERSION" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_LANDUSECONVERSION" ? /*#__PURE__*/React__default.createElement(EmpLandUseConversionPortal, {
    formData: applicationData,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PURCHASABLE_FAR" || formType === "PURCHASABLE_FAR" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_PURCHASABLE_FAR" ? /*#__PURE__*/React__default.createElement(EmpMapPurchasablePortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    urlFormType: formType,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && ((applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_COMPLETION" || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "COMPLETION" || applicationDetails !== null && applicationDetails !== void 0 && (_applicationDetails$a = applicationDetails.applicationNo) !== null && _applicationDetails$a !== void 0 && _applicationDetails$a.includes("/CC/") || applicationDetails !== null && applicationDetails !== void 0 && (_applicationDetails$a2 = applicationDetails.applicationNo) !== null && _applicationDetails$a2 !== void 0 && _applicationDetails$a2.includes("/cc/")) || isFromDashboard && ((applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_COMPLETION" || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "COMPLETION" || applicationDetails !== null && applicationDetails !== void 0 && (_applicationDetails$b = applicationDetails.businessService) !== null && _applicationDetails$b !== void 0 && _applicationDetails$b.includes("COMPLETION") || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.businessService) === "BPA_OC" || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.businessService) === "BPA_CC" || applicationDetails !== null && applicationDetails !== void 0 && (_applicationDetails$a3 = applicationDetails.applicationNo) !== null && _applicationDetails$a3 !== void 0 && _applicationDetails$a3.includes("/CC/") || applicationDetails !== null && applicationDetails !== void 0 && (_applicationDetails$a4 = applicationDetails.applicationNo) !== null && _applicationDetails$a4 !== void 0 && _applicationDetails$a4.includes("/cc/")) ? /*#__PURE__*/React__default.createElement(EmpCompletionPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    urlFormType: formType,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" || isFromDashboard && ((applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") ? /*#__PURE__*/React__default.createElement(EmpSelfApproval, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "SELF_MAP" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.planOn) === "SELF_MAP" ? /*#__PURE__*/React__default.createElement(EmpSelfRegistration, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.natureOfConstruction) === "Compounding" || isFromDashboard && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.natureOfConstruction) === "Compounding" ? /*#__PURE__*/React__default.createElement(EmpCompoundingPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" || formType === "FORM_MAP" && applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.land_Id || isFromDashboard && applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.land_Id && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_MAP" ? /*#__PURE__*/React__default.createElement(EmpMapSubmissionPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    urlFormType: formType,
    isFromDashboard: isFromDashboard
  }) : formType === "MAP_SUB" && !(applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.land_Id) || isFromDashboard && !(applicationData !== null && applicationData !== void 0 && applicationData.land_Id) && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_MAP" ? /*#__PURE__*/React__default.createElement(RevalMapSubmissionPortal, {
    formData: applicationDetails,
    refetch: refetch,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "formLandUse" && (applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType) === "FORM_KYP" || isFromDashboard && (applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationType) === "FORM_KYP" ? /*#__PURE__*/React__default.createElement(EmpKYPPortal, {
    formData: applicationData,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "formLandUse" || isFromDashboard && (applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationType) === "FORM_LANDUSE" ? /*#__PURE__*/React__default.createElement(EmpLandUsePortal, {
    formData: applicationData,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }) : formType === "NOC" ? /*#__PURE__*/React__default.createElement(EmpNOCPortal, {
    formData: applicationDetails,
    submitAction: submitAction,
    workflowDetails: workflowDetails,
    userRolesArray: userRolesArray,
    urlFormType: formType
  }) : /*#__PURE__*/React__default.createElement(FormSummary, {
    onActionSelect: onActionSelect,
    setOnAddComments: setOnAddComments,
    formData: applicationDetails,
    showTimeLine: showTimeLine,
    workflowDetails: workflowDetails,
    timelineStatusPrefix: timelineStatusPrefix,
    isDataLoading: isDataLoading,
    forcedActionPrefix: forcedActionPrefix,
    submitAction: submitAction,
    actionData: actionData,
    moduleCode: moduleCode,
    applicationData: applicationData,
    action: action,
    businessService: businessService
  }), !(applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.documents) && /*#__PURE__*/React__default.createElement(BPADocuments, {
    t: t,
    applicationData: applicationDetails,
    docs: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.documents,
    bpaActionsDetails: workflowDetails
  }));
}

const configPTApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  var _action$assigneeRoles;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : /*#__PURE__*/React__default.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("ES_PT_ACTION_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("ES_PT_ATTACH_FILE")}${action.docUploadRequired ? " *" : ""}`,
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          hintText: t("PT_ATTACH_RESTRICTIONS_SIZE"),
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`ES_PT_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configPTAssessProperty = ({
  t,
  action,
  financialYears,
  selectedFinancialYear,
  setSelectedFinancialYear
}) => {
  return {
    label: {
      heading: `WF_${action.action}_APPLICATION`,
      submit: `WF_PT.CREATE_${action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: t("ES_PT_FINANCIAL_YEARS"),
        isMandatory: true,
        type: "radio",
        populators: /*#__PURE__*/React__default.createElement(RadioButtons, {
          options: financialYears,
          optionsKey: "name",
          onSelect: setSelectedFinancialYear,
          selectedOption: selectedFinancialYear
        })
      }]
    }]
  };
};

const configTLApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  let checkCondtions = true;
  if ((action === null || action === void 0 ? void 0 : action.action) == "SENDBACKTOCITIZEN" || (action === null || action === void 0 ? void 0 : action.action) == "APPROVE") checkCondtions = false;
  if (action.isTerminateState) checkCondtions = false;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_NEWTL_CANCEL"
    },
    form: [{
      body: [{
        label: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_LABEL"),
        placeholder: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_PLACEHOLDER"),
        type: "dropdown",
        populators: !checkCondtions ? null : /*#__PURE__*/React__default.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("TL_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configBPAREGApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_BPAREG_CANCEL"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("BPA_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configBPAApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "BPA_CITIZEN_CANCEL_BUTTON"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configNOCApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  var _action$assigneeRoles;
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  let isRejectOrRevocate = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "APPROVE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT" || action.action == "AUTO_APPROVE" || action.action == "AUTO_REJECT") {
    isRejectOrRevocate = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "CORE_LOGOUTPOPUP_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || isRejectOrRevocate ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || isRejectOrRevocate ? null : /*#__PURE__*/React__default.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const Heading = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$1 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$1 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$1, null));
};
const ActionModal = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") ;
      });
    }
    submitAction({
      PermissionOfSubdivision: applicationData
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$1, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const ApplicationDetailsForm11 = props => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _workflowDetails$data, _userRolesArray$;
  const {
    formType
  } = useParams();
  let user = Digit.UserService.getUser();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const userInfo = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.info) || {};
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const [onAddComments, setOnAddComments] = useState("");
  const [dataOpen, setDataOpen] = useState("");
  const [open, setOpen] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    refetch,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true,
    isFromDashboard
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    console.log("9999999999999", action);
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setShowModal(false);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if (action === "ISSUE_CERTIFICATE") {
        console.log("111111111");
        setShowModal(false);
        let payload = {};
        payload.PermissionOfSubdivision = applicationData;
        payload.PermissionOfSubdivision.workflow = {
          action: "ISSUE_CERTIFICATE",
          assignes: null,
          comments: onAddComments,
          varificationDocuments: null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
        } catch (error) {
          console.error("Error in ISSUE_CERTIFICATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
        console.log("00000000000");
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    var _user$info;
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 3000);
          setDataOpen("Successfully");
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(true);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
          setIsEnableLoader(false);
        }
      });
      setIsEnableLoader(false);
    }
    if ((user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "EMPLOYEE") {
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/employee`
        });
      }, 2000);
    } else {
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/citizen/profile`
        });
      }, 2000);
    }
  };
  const handleModal = () => {
    setOpen(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/employee`
      });
    }, 2000);
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("applicationDetails123Ayush", applicationDetails, applicationData, showModal, userRolesArray, isFromDashboard);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsContentForm11, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    isLoading: isLoading,
    applicationData: applicationData,
    refetch: refetch,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine,
    onActionSelect: onActionSelect,
    setOnAddComments: setOnAddComments,
    forcedActionPrefix: forcedActionPrefix,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    moduleCode: moduleCode,
    action: selectedAction,
    formType: formType,
    userRolesArray: userRolesArray,
    isFromDashboard: isFromDashboard
  }), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: open,
    onClose: handleModal,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "alert-dialog-title",
    style: {
      textAlign: "center"
    }
  }, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType, " Successfully File", " "), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(CheckCircleOutlineIcon, {
    style: {
      color: "green",
      variant: "filled",
      margin: "0px 40% 0",
      fontSize: "100px",
      padding: "2px"
    }
  })), /*#__PURE__*/React__default.createElement("p", null, userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code, " Verification for ", applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType, " ( Subdivision of land) With Application no", " ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      padding: "5px",
      color: "blue"
    }
  }, applicationNumber), " is Done Successfully. ", /*#__PURE__*/React__default.createElement("span", null)))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleModal,
    autoFocus: true
  }, "Ok")))) : /*#__PURE__*/React__default.createElement(Loader, null));
};

const NOCService = {
  NOCsearch: ({
    tenantId,
    filters
  }) => Request$1({
    url: Urls.noc.nocSearch,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }),
  NOCupdate: ({
    tenantId,
    filters
  }) => Request$1({
    url: Urls.noc.nocUpdate,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }),
  NOCExcelUpdate: ({
    tenantId,
    nocDetails,
    filters
  }) => Request$1({
    url: Urls.noc.nocExcelUpdate,
    useCache: false,
    method: "POST",
    auth: true,
    data: {
      nocDetails
    },
    userService: true,
    params: {
      tenantId,
      ...filters
    }
  }),
  NOCExcelSearch: ({
    tenantId,
    filters
  }) => Request$1({
    url: Urls.noc.nocExcelSearch,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }),
  NOCExcelCreate: ({
    tenantId,
    filters
  }) => Request$1({
    url: Urls.noc.nocExcelCreate,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  })
};

const SUBApplicationForm11 = () => {
  var _data$LandUse, _data$PurchasableFAR, _data$BPA, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data17, _workflowDetails$data18, _workflowDetails$data19, _workflowDetails$data20;
  const {
    authority,
    state,
    plan,
    plinth,
    form,
    year,
    serial,
    formType,
    id: urlId
  } = useParams();
  console.log(useParams(), "paramsHook");
  const id = plinth ? `${authority}/${plinth}/${plan}/${form}/${year}/${serial}` : urlId ? urlId : state ? `${state}/${form}/${year}/${serial}` : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromComp", id, urlId);
  const nocAppData = Digit.SessionStorage.get("nocAppData");
  const {
    t
  } = useTranslation();
  console.log("nocAppData", nocAppData, useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const [filters, setFilters] = useState(null);
  const history = useHistory();
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let {
    data: newConfig$1
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const isEmployee = history.location.pathname.includes("citizen");
  useEffect(() => {
    if (formType !== "NOC") {
      console.log("insideeffect", formType);
      setFilters({
        applicationNo: id,
        isEmployee,
        formType
      });
      return;
    }
    const fetchNocData = async () => {
      try {
        var _response$Noc, _response$Noc$;
        const response = await NOCService.NOCsearch({
          tenantId: "up",
          filters: {
            applicationNo: id
          }
        });
        console.log("responseFromNOCSearch", response);
        setFilters({
          applicationNo: response === null || response === void 0 ? void 0 : (_response$Noc = response.Noc) === null || _response$Noc === void 0 ? void 0 : (_response$Noc$ = _response$Noc[0]) === null || _response$Noc$ === void 0 ? void 0 : _response$Noc$.sourceRefId,
          isEmployee,
          formType: "FORM_MAP"
        });
      } catch (err) {
        console.error("Error in NOCsearch:", err);
      }
    };
    fetchNocData();
  }, [tenantId, id, isEmployee, formType]);
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, filters, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true
    }
  });
  const {
    collectionBillRes,
    collectionBillDetails
  } = data;
  const appData = (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]) || (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]) || (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
  if (!isLoading && appData) {
    var _collectionBillRes$, _collectionBillRes$$p;
    appData.paymentDetails = collectionBillRes === null || collectionBillRes === void 0 ? void 0 : (_collectionBillRes$ = collectionBillRes[0]) === null || _collectionBillRes$ === void 0 ? void 0 : (_collectionBillRes$$p = _collectionBillRes$.paymentDetails) === null || _collectionBillRes$$p === void 0 ? void 0 : _collectionBillRes$$p[0];
  }
  console.log("isDataForm11", formType, stateId, data, bpaDocs, newConfig$1, mdmsData);
  console.log("appData", appData, data, isLoading);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(stateId, formType);
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: appData === null || appData === void 0 ? void 0 : appData.businessService
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  const userInfo = Digit.UserService.getUser();
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.length) > 0) {
    var _workflowDetails$data15, _workflowDetails$data16;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, !isLoading && appData && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ApplicationDetailsForm11, {
    applicationDetails: appData,
    isLoading: updatingApplication,
    isDataLoading: updatingApplication,
    applicationData: appData,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data17 = workflowDetails.data) !== null && _workflowDetails$data17 !== void 0 && _workflowDetails$data17.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data18 = workflowDetails.data) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.applicationBusinessService : appData === null || appData === void 0 ? void 0 : appData.businessService,
    moduleCode: appData === null || appData === void 0 ? void 0 : appData.businessService,
    showToast: showToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data19 = workflowDetails.data) !== null && _workflowDetails$data19 !== void 0 && _workflowDetails$data19.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data20 = workflowDetails.data) === null || _workflowDetails$data20 === void 0 ? void 0 : _workflowDetails$data20.applicationBusinessService : appData === null || appData === void 0 ? void 0 : appData.businessService}_`
  }))));
};

function ApplicationDetailsContentForm12({
  applicationDetails,
  isLoading,
  setOnAddComments,
  edcrDetails,
  collectionBillDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  timelineStatusPrefix,
  showTimeLine = true,
  onActionSelect,
  forcedActionPrefix,
  submitAction,
  actionData,
  moduleCode,
  businessService,
  action,
  statusAttribute = "status"
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      position: "relative"
    }
  }, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Form12Summary, {
    onActionSelect: onActionSelect,
    setOnAddComments: setOnAddComments,
    formData: applicationDetails,
    showTimeLine: showTimeLine,
    workflowDetails: workflowDetails,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails,
    timelineStatusPrefix: timelineStatusPrefix,
    isDataLoading: isDataLoading,
    forcedActionPrefix: forcedActionPrefix,
    submitAction: submitAction,
    actionData: actionData,
    moduleCode: moduleCode,
    applicationData: applicationData,
    action: action,
    businessService: businessService
  }), !(applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.documents) && /*#__PURE__*/React__default.createElement(BPADocuments, {
    t: t,
    applicationData: applicationDetails,
    docs: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.documents,
    bpaActionsDetails: workflowDetails
  }));
}

const ApplicationDetailsForm12 = props => {
  var _Digit$UserService$ge, _workflowDetails$data, _userRolesArray$;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  let user = Digit.UserService.getUser();
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const [onAddComments, setOnAddComments] = useState("");
  const [opendata, setOpenData] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    edcrDetails,
    collectionBillDetails,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    console.log("9999999999999", action);
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setShowModal(false);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if (action === 'ISSUE_CERTIFICATE') {
        console.log("yes", action);
        setShowModal(false);
        let payload = {};
        payload.BPA = applicationData;
        payload.BPA.workflow = {
          "action": "ISSUE_CERTIFICATE",
          "assignes": null,
          "comments": onAddComments,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
        } catch (error) {
          console.error("Error in ISSUE_CERTIFICATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    var _user$info;
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 3000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
      setIsEnableLoader(false);
    }
    if ((user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "EMPLOYEE") {
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/employee`
        });
      }, 2000);
    }
    closeModal();
  };
  const handleModal = () => {
    setOpenData(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/employee`
      });
    }, 2000);
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("applicationDetails123", applicationDetails, applicationData, showModal);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsContentForm12, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    isLoading: isLoading,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine,
    onActionSelect: onActionSelect,
    setOnAddComments: setOnAddComments,
    forcedActionPrefix: forcedActionPrefix,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    moduleCode: moduleCode,
    action: selectedAction
  })) : /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: opendata,
    onClose: handleModal,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    id: "alert-dialog-title",
    style: {
      textAlign: "center"
    }
  }, "Form-12 Successfully File "), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(CheckCircleOutlineIcon, {
    style: {
      color: "green",
      variant: "filled",
      margin: "0px 40% 0",
      fontSize: "100px",
      padding: "2px"
    }
  })), /*#__PURE__*/React__default.createElement("p", null, userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code, " Verification for ", applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationType, " ( Building Plan Approval) With Application no ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      padding: "5px",
      color: "blue"
    }
  }, applicationNumber), "  is Done Successfully.", " ", /*#__PURE__*/React__default.createElement("span", null)))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleModal,
    autoFocus: true
  }, "Ok"))));
};

const BpaApplicationForm12 = () => {
  var _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data17, _workflowDetails$data18;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    id
  } = useParams();
  console.log("useParamsInFormPlinthInspection", useParams());
  const isPlinthModule = window.location.href.includes("/PL/");
  const consumerCode = id ? id : isPlinthModule ? `${authority}/PL/${plan}/${form}/${year}/${serial}` : `${authority}/${plan}/${form}/${year}/${serial}`;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEmployee = history.location.pathname.includes("citizen");
  const [showToast, setShowToast] = useState(null);
  const [error, setError] = useState(null);
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: consumerCode,
    isEmployee
  });
  const {
    applicationData,
    applicationDetails,
    businessService,
    edcrDetails,
    collectionBillDetails
  } = data;
  console.log("form12Details,", applicationData, applicationDetails, businessService, edcrDetails, collectionBillDetails, "ccccccc");
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(stateId);
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id ? id : consumerCode,
    moduleCode: applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.length) > 0) {
    var _workflowDetails$data15, _workflowDetails$data16;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", null, !isLoading && applicationData ? /*#__PURE__*/React__default.createElement(ApplicationDetailsForm12, {
    applicationDetails: applicationData,
    isLoading: isLoading,
    isDataLoading: updatingApplication,
    applicationData: applicationData,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: businessService,
    moduleCode: businessService,
    showToast: showToast,
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data17 = workflowDetails.data) !== null && _workflowDetails$data17 !== void 0 && _workflowDetails$data17.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data18 = workflowDetails.data) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.applicationBusinessService : businessService}_`
  }) : /*#__PURE__*/React__default.createElement(Loader, null)));
};

const PaymentFailed = () => {
  const {
    id
  } = useParams();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "payment-failed-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "payment-failed-conterol"
  }, "Payment Failed ", id), /*#__PURE__*/React__default.createElement(ReportProblemIcon, {
    color: "error",
    style: {
      width: "150px",
      height: "130px"
    }
  }), /*#__PURE__*/React__default.createElement("p", null, "We're sorry, but your payment was not successful."), /*#__PURE__*/React__default.createElement("p", null, "Please try again later or contact support if the issue persists."), /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement("button", null, "Retry Payment")));
};

function SearchSummary$1({
  id,
  ref,
  isEmployee,
  setDeclarationChecked
}) {
  var _formData$PrevStateDo, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _formData$tradeLicens;
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    isLoading,
    data: applicationDetails,
    refetch
  } = Digit.Hooks.obps.useLicenseDetails(tenantId, {
    applicationNumber: id
  }, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true
  });
  const formData = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData;
  useEffect(() => {
    refetch();
  }, [refetch]);
  let consumerCode = id;
  const fetchBillParams = {
    consumerCode
  };
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const {
    applicationDetails: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : _formData$tradeLicens.applicationDocuments;
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && formData ? /*#__PURE__*/React__default.createElement(LTPSummary, {
    formData: formData,
    applicationDocs: applicationDocs,
    ref: ref,
    isEmployee: isEmployee,
    setDeclarationChecked: setDeclarationChecked
  }) : /*#__PURE__*/React__default.createElement(Loader, null));
}

const ApplicationProfessional = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [page, setPage] = React__default.useState(0);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNumber", "applicationType", "applicationDate", "status", "approvalLetter", "paymentReceipt", "action"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNumber: "",
    applicationType: "",
    status: ""
  });
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const isEmployee = window.location.pathname.split("/").includes("employee");
  const {
    data,
    isLoading: loader,
    revalidate
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId, undefined, undefined, undefined, undefined, undefined, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true
  });
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$tradeLicenseDet, _item$tradeLicenseDet2, _item$tradeLicenseDet3, _item$tradeLicenseDet4, _item$tradeLicenseDet5, _item$tradeLicenseDet6, _item$tradeLicenseDet7, _item$applicationNumb, _t, _t2;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet = item.tradeLicenseDetail) === null || _item$tradeLicenseDet === void 0 ? void 0 : (_item$tradeLicenseDet2 = _item$tradeLicenseDet.owners) === null || _item$tradeLicenseDet2 === void 0 ? void 0 : (_item$tradeLicenseDet3 = _item$tradeLicenseDet2[0]) === null || _item$tradeLicenseDet3 === void 0 ? void 0 : (_item$tradeLicenseDet4 = _item$tradeLicenseDet3.name) === null || _item$tradeLicenseDet4 === void 0 ? void 0 : _item$tradeLicenseDet4.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet5 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet5 === void 0 ? void 0 : (_item$tradeLicenseDet6 = _item$tradeLicenseDet5.owners) === null || _item$tradeLicenseDet6 === void 0 ? void 0 : (_item$tradeLicenseDet7 = _item$tradeLicenseDet6[0]) === null || _item$tradeLicenseDet7 === void 0 ? void 0 : _item$tradeLicenseDet7.mobileNumber) || "";
          case "applicationNumber":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNumb = item.applicationNumber) === null || _item$applicationNumb === void 0 ? void 0 : _item$applicationNumb.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_11_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : item.applicationDate) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.Licenses) || [];
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        var _item$tradeLicenseDet8, _item$tradeLicenseDet9, _item$tradeLicenseDet10, _item$tradeLicenseDet11, _item$tradeLicenseDet12, _item$tradeLicenseDet13;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet8 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet8 === void 0 ? void 0 : (_item$tradeLicenseDet9 = _item$tradeLicenseDet8.owners) === null || _item$tradeLicenseDet9 === void 0 ? void 0 : (_item$tradeLicenseDet10 = _item$tradeLicenseDet9[0]) === null || _item$tradeLicenseDet10 === void 0 ? void 0 : _item$tradeLicenseDet10.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet11 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet11 === void 0 ? void 0 : (_item$tradeLicenseDet12 = _item$tradeLicenseDet11.owners) === null || _item$tradeLicenseDet12 === void 0 ? void 0 : (_item$tradeLicenseDet13 = _item$tradeLicenseDet12[0]) === null || _item$tradeLicenseDet13 === void 0 ? void 0 : _item$tradeLicenseDet13.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$tradeLicenseDet14, _item$tradeLicenseDet15, _item$tradeLicenseDet16, _item$tradeLicenseDet17;
        return item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet14 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet14 === void 0 ? void 0 : (_item$tradeLicenseDet15 = _item$tradeLicenseDet14.owners) === null || _item$tradeLicenseDet15 === void 0 ? void 0 : (_item$tradeLicenseDet16 = _item$tradeLicenseDet15[0]) === null || _item$tradeLicenseDet16 === void 0 ? void 0 : (_item$tradeLicenseDet17 = _item$tradeLicenseDet16.name) === null || _item$tradeLicenseDet17 === void 0 ? void 0 : _item$tradeLicenseDet17.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$tradeLicenseDet18, _item$tradeLicenseDet19, _item$tradeLicenseDet20, _item$tradeLicenseDet21;
        return item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet18 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet18 === void 0 ? void 0 : (_item$tradeLicenseDet19 = _item$tradeLicenseDet18.owners) === null || _item$tradeLicenseDet19 === void 0 ? void 0 : (_item$tradeLicenseDet20 = _item$tradeLicenseDet19[0]) === null || _item$tradeLicenseDet20 === void 0 ? void 0 : (_item$tradeLicenseDet21 = _item$tradeLicenseDet20.mobileNumber) === null || _item$tradeLicenseDet21 === void 0 ? void 0 : _item$tradeLicenseDet21.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNumber) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNumb2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNumb2 = item.applicationNumber) === null || _item$applicationNumb2 === void 0 ? void 0 : _item$applicationNumb2.toLowerCase().includes(filters.applicationNumber.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_11_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleClickAction = item => {
    history.push(`${citizenBaseUrl}/payment/collect/${item === null || item === void 0 ? void 0 : item.businessService}/${item === null || item === void 0 ? void 0 : item.applicationNumber}/${tenantId}/tenantId=${tenantId}`);
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$tradeLicenseDet22, _item$tradeLicenseDet23, _item$tradeLicenseDet24;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet22 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet22 === void 0 ? void 0 : (_item$tradeLicenseDet23 = _item$tradeLicenseDet22.owners) === null || _item$tradeLicenseDet23 === void 0 ? void 0 : (_item$tradeLicenseDet24 = _item$tradeLicenseDet23[0]) === null || _item$tradeLicenseDet24 === void 0 ? void 0 : _item$tradeLicenseDet24.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$tradeLicenseDet25, _item$tradeLicenseDet26, _item$tradeLicenseDet27;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet25 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet25 === void 0 ? void 0 : (_item$tradeLicenseDet26 = _item$tradeLicenseDet25.owners) === null || _item$tradeLicenseDet26 === void 0 ? void 0 : (_item$tradeLicenseDet27 = _item$tradeLicenseDet26[0]) === null || _item$tradeLicenseDet27 === void 0 ? void 0 : _item$tradeLicenseDet27.mobileNumber) || "-");
    }
  }, {
    id: "applicationNumber",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => closeModal2(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNumber) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-date"
    }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.applicationDate) || "-")
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-status"
    }, t(`WF_BPA_11_${item === null || item === void 0 ? void 0 : item.status}`) || "-")
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-approval"
    }, item.status === "APPROVED" && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.approvalLetterUrl)
    }, "View"))
  }, {
    id: "paymentReceipt",
    label: "Payment Receipt",
    filterable: false,
    sortable: false,
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-receipt"
    }, (item === null || item === void 0 ? void 0 : item.registrationType) !== "Architect" && ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_ND_OFF_AWAS" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_NODAL") ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        history.push({
          pathname: `/digit-ui/citizen/obps/tradelicence/payment/${item === null || item === void 0 ? void 0 : item.applicationNumber}/up`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")) : "N/A"),
    width: "10%"
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, !isEmployee && ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "SENDBACK_TO_CITIZEN"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/services/ltpPortal/${item === null || item === void 0 ? void 0 : item.applicationNumber}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "ReSubmit")) : item.status === "MAKE_PAYMENT" ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => handleClickAction(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "Pay")) : item.status === "REJECTED" ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => {
        history.push({
          pathname: `/digit-ui/citizen/obps/services/ltpPortal/${item === null || item === void 0 ? void 0 : item.applicationNumber}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => closeModal2(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const closeModal2 = item => {
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNumber);
    setIdData(item === null || item === void 0 ? void 0 : item.applicationNumber);
    setFormType("form11");
    if ((item === null || item === void 0 ? void 0 : item.applicationNumber) != null) {
      setSmShowMs(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, t("BPA_MY_APPLICATIONS")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    className: "bg-white",
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length === allColumns.length ? "All" : selectedColumns.length, ")", " "), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => setGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => setGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignitems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    }
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, loader ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "Loading...")) : (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary$1, {
    id: idData,
    formType: formType
  })));
};

const defaultComplicesRemarksContext = {
  remarksData: {},
  compliceGetRemarkssValues: () => {},
  setRemarksData: () => {}
};
const ComplicesRemarksContext = createContext(defaultComplicesRemarksContext);
const ComplicesRemarksProvider = ({
  children
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const [remarksData, setRemarksData] = useState({});
  const [rolesDate, setRolesData] = useState(null);
  const [bussinessService, setBusinessService] = useState("");
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const compliceGetRemarkssValues = async applicationNumber => {
    console.log("logger1234...", applicationNumber);
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
        userInfo: userInfo
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.obps.compliance_search}?applicationNumber=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("Response From API", Resp);
      setRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  return /*#__PURE__*/React__default.createElement(ComplicesRemarksContext.Provider, {
    value: {
      remarksData,
      compliceGetRemarkssValues,
      setRemarksData
    }
  }, children);
};

const EmployeeComponent$2 = ({
  formData,
  applicationDocs,
  totalAmount
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4, _formData$tradeLicens5, _formData$tradeLicens6;
  const [smShow, setSmShow] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#eeeab5b0",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ": \xA0\xA0\xA0", (formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, (formData === null || formData === void 0 ? void 0 : formData.paymentStatus) === "Success" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShowPayment(true), console.log("modal open");
    }
  }, "Payment Receipt")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : _formData$tradeLicens.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens2 = formData.tradeLicenseDetail) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2.owners) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens4 = formData.tradeLicenseDetail) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5.owners) === null || _formData$tradeLicens6 === void 0 ? void 0 : _formData$tradeLicens6.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0\xA0", ob === null || ob === void 0 ? void 0 : ob.initialForApplicantName, "\xA0", ob === null || ob === void 0 ? void 0 : ob.name)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Service ")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", t("FASTPAS.GLOBAL.TPR.TEXT")))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, /*#__PURE__*/React__default.createElement(LTPSummary, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }))));
};

const Architect$2 = ({
  formData,
  applicationDocs,
  totalAmount,
  actions
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4, _formData$tradeLicens5, _formData$tradeLicens6;
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "rgba(173, 229, 232, 0.69)",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, t(`BPA_APPLICATION_NUMBER_LABEL`))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, ": \xA0\xA0\xA0", (formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || ""), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 3"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShow(true), console.log("modal open");
    }
  }, "View Application"), " "), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4"
  }, (formData === null || formData === void 0 ? void 0 : formData.paymentStatus) === "Success" && /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "1px"
    },
    onClick: () => {
      setSmShowPayment(true), console.log("modal open");
    }
  }, t("FASTPAS.GLOBAL.PAYMENT.RECIEPT.TEXT"))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : _formData$tradeLicens.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens2 = formData.tradeLicenseDetail) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2.owners) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0 ", ob === null || ob === void 0 ? void 0 : ob.mobileNumber)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Name")), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens4 = formData.tradeLicenseDetail) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5.owners) === null || _formData$tradeLicens6 === void 0 ? void 0 : _formData$tradeLicens6.map((ob, index) => /*#__PURE__*/React__default.createElement("div", null, ": \xA0\xA0\xA0", ob === null || ob === void 0 ? void 0 : ob.name)))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2"
  }, /*#__PURE__*/React__default.createElement("b", null, "Service ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '80px'
    }
  }, ":"))), /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 10",
    sx: {
      ml: 2
    }
  }, t("FASTPAS.GLOBAL.TPR.TEXT"))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => {
      setSmShow(false);
    }
  }, /*#__PURE__*/React__default.createElement(LTPSummary, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }))));
};

const LTPCheckList = ({
  formData
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4, _formData$nocOtherDet, _formData$nocOtherDet2, _formData$nocOtherDet3, _formData$nocOtherDet4, _formData$tradeLicens5, _formData$tradeLicens6, _formData$tradeLicens7, _formData$tradeLicens8, _formData$nocOtherDet5, _formData$nocOtherDet6, _formData$nocOtherDet7, _formData$nocOtherDet8, _formData$tradeLicens9, _formData$tradeLicens10, _formData$tradeLicens11, _formData$tradeLicens12, _formData$nocOtherDet9, _formData$nocOtherDet10, _formData$nocOtherDet11, _formData$nocOtherDet12, _formData$nocOtherDet13, _formData$tradeLicens13, _formData$tradeLicens14, _formData$tradeLicens15, _formData$tradeLicens16, _formData$nocOtherDet14, _formData$nocOtherDet15, _formData$nocOtherDet16, _formData$tradeLicens17, _formData$tradeLicens18, _formData$tradeLicens19, _formData$tradeLicens20, _formData$nocOtherDet17, _formData$nocOtherDet18, _formData$nocOtherDet19, _formData$nocOtherDet20, _formData$tradeLicens21, _formData$tradeLicens22, _formData$tradeLicens23, _formData$tradeLicens24, _formData$nocOtherDet21, _formData$tradeLicens25, _formData$tradeLicens26, _formData$tradeLicens27, _formData$tradeLicens28, _formData$nocOtherDet22;
  const sessionData = JSON.parse(sessionStorage.getItem("ltpCheckList"));
  const defaultValues = {
    ...sessionData
  };
  const {
    handleSubmit,
    control,
    reset,
    watch
  } = useForm({
    defaultValues
  });
  const dispatch = useDispatch();
  const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
  const [regStatus, setregStatus] = useState("");
  const [storedData, setStoredData] = useState(null);
  const Modal = useModal();
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    dispatch(updateChecklistFormField(name, value));
    if (name === 'isPossesionAreaDiff') {
      setIsPossessionAreaDiff(value);
    } else if (name === 'registryStatus') {
      setregStatus(value);
    }
  };
  const onSubmit = data => {
    console.log(data, "data while submitting");
    Modal("Checklist updated.", `Checklist Updated Successfully!`, "success");
  };
  useEffect(() => {
    const storedChecklist = JSON.parse(sessionStorage.getItem("ltpCheckList"));
    if (storedChecklist) {
      setStoredData(storedChecklist);
    }
  }, []);
  console.log(storedData, "storedDataaaaa");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginRight: '200px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Check list for the registration of LTP")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.tradeUnits) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2[0]) === null || _formData$tradeLicens3 === void 0 ? void 0 : (_formData$tradeLicens4 = _formData$tradeLicens3.tradeType) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.split('.')[0]) === "ARCHITECT" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have the minimum qualifications as provided under the Architects Act, 1972 for the registration with the Council of Architecture"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theminimumqualifications",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theminimumqualifications) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet = formData.nocOtherDetails) === null || _formData$nocOtherDet === void 0 ? void 0 : _formData$nocOtherDet.theminimumqualifications)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant Registered with the Council of Architecture"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theapplicantRegistered",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theapplicantRegistered) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet2 = formData.nocOtherDetails) === null || _formData$nocOtherDet2 === void 0 ? void 0 : _formData$nocOtherDet2.theapplicantRegistered)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant possess a valid COA Registration Number"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantPossess",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantPossess) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet3 = formData.nocOtherDetails) === null || _formData$nocOtherDet3 === void 0 ? void 0 : _formData$nocOtherDet3.theApplicantPossess)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant\u2019s COA License/Membership valid for the period mentioned in the application "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "thelicenseMembership",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.thelicenseMembership) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet4 = formData.nocOtherDetails) === null || _formData$nocOtherDet4 === void 0 ? void 0 : _formData$nocOtherDet4.thelicenseMembership)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5.tradeUnits) === null || _formData$tradeLicens6 === void 0 ? void 0 : (_formData$tradeLicens7 = _formData$tradeLicens6[0]) === null || _formData$tradeLicens7 === void 0 ? void 0 : (_formData$tradeLicens8 = _formData$tradeLicens7.tradeType) === null || _formData$tradeLicens8 === void 0 ? void 0 : _formData$tradeLicens8.split('.')[0]) === "GRADUATECIVILENGINEER" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant a graduate in civil engineering / Architectural Engineering from a recognized Indian or foreign university"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantGraduate",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantGraduate) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet5 = formData.nocOtherDetails) === null || _formData$nocOtherDet5 === void 0 ? void 0 : _formData$nocOtherDet5.theApplicantGraduate)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant a member of IEI, or the statutory body governing such profession, as and when established "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theapplicantMember",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theapplicantMember) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet6 = formData.nocOtherDetails) === null || _formData$nocOtherDet6 === void 0 ? void 0 : _formData$nocOtherDet6.theapplicantMember)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant possess a valid IEI registration number "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantPossess",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantPossess) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet7 = formData.nocOtherDetails) === null || _formData$nocOtherDet7 === void 0 ? void 0 : _formData$nocOtherDet7.theApplicantPossess)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant\u2019s IEI license/membership valid for the period mentioned in the application   "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "thelicenseMembership",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.thelicenseMembership) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet8 = formData.nocOtherDetails) === null || _formData$nocOtherDet8 === void 0 ? void 0 : _formData$nocOtherDet8.thelicenseMembership)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens9 = formData.tradeLicenseDetail) === null || _formData$tradeLicens9 === void 0 ? void 0 : (_formData$tradeLicens10 = _formData$tradeLicens9.tradeUnits) === null || _formData$tradeLicens10 === void 0 ? void 0 : (_formData$tradeLicens11 = _formData$tradeLicens10[0]) === null || _formData$tradeLicens11 === void 0 ? void 0 : (_formData$tradeLicens12 = _formData$tradeLicens11.tradeType) === null || _formData$tradeLicens12 === void 0 ? void 0 : _formData$tradeLicens12.split('.')[0]) === "STRUCTURALENGINEER" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant a graduate in civil engineering from a recognized Indian or foreign university, or the member of civil engineers (India) "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantGraduate",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantGraduate) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet9 = formData.nocOtherDetails) === null || _formData$nocOtherDet9 === void 0 ? void 0 : _formData$nocOtherDet9.theApplicantGraduate)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have 2 years of experience in the case of postgraduate degree in structural engineering from a recognized Indian or foreign university"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantTwoYears",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantTwoYears) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet10 = formData.nocOtherDetails) === null || _formData$nocOtherDet10 === void 0 ? void 0 : _formData$nocOtherDet10.theApplicantTwoYears)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have 1 year of experience in the case of doctorate in Structural Engineering"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantOneYears",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantOneYears) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet11 = formData.nocOtherDetails) === null || _formData$nocOtherDet11 === void 0 ? void 0 : _formData$nocOtherDet11.theApplicantOneYears)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant possess a valid registration number from IEI / member of civil engineers "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantPossessValid",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantPossessValid) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet12 = formData.nocOtherDetails) === null || _formData$nocOtherDet12 === void 0 ? void 0 : _formData$nocOtherDet12.theApplicantPossessValid)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant\u2019s license/membership valid for the period mentioned in the application"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "thelicenseMembership",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.thelicenseMembership) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet13 = formData.nocOtherDetails) === null || _formData$nocOtherDet13 === void 0 ? void 0 : _formData$nocOtherDet13.thelicenseMembership)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens13 = formData.tradeLicenseDetail) === null || _formData$tradeLicens13 === void 0 ? void 0 : (_formData$tradeLicens14 = _formData$tradeLicens13.tradeUnits) === null || _formData$tradeLicens14 === void 0 ? void 0 : (_formData$tradeLicens15 = _formData$tradeLicens14[0]) === null || _formData$tradeLicens15 === void 0 ? void 0 : (_formData$tradeLicens16 = _formData$tradeLicens15.tradeType) === null || _formData$tradeLicens16 === void 0 ? void 0 : _formData$tradeLicens16.split('.')[0]) === "SUPERVISOR" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant hold a diploma in civil engineering or architectural assistantship"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantHold",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantHold) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet14 = formData.nocOtherDetails) === null || _formData$nocOtherDet14 === void 0 ? void 0 : _formData$nocOtherDet14.theApplicantHold)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have qualifications in architecture or engineering equivalent to the minimum qualification prescribed the recruitment to non-gazetted service by the Government of India"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantQualifications",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantQualifications) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet15 = formData.nocOtherDetails) === null || _formData$nocOtherDet15 === void 0 ? void 0 : _formData$nocOtherDet15.theApplicantQualifications)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have 5 Years of experience in building design, construction, and supervision"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantFiveYears",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantFiveYears) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet16 = formData.nocOtherDetails) === null || _formData$nocOtherDet16 === void 0 ? void 0 : _formData$nocOtherDet16.theApplicantFiveYears)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens17 = formData.tradeLicenseDetail) === null || _formData$tradeLicens17 === void 0 ? void 0 : (_formData$tradeLicens18 = _formData$tradeLicens17.tradeUnits) === null || _formData$tradeLicens18 === void 0 ? void 0 : (_formData$tradeLicens19 = _formData$tradeLicens18[0]) === null || _formData$tradeLicens19 === void 0 ? void 0 : (_formData$tradeLicens20 = _formData$tradeLicens19.tradeType) === null || _formData$tradeLicens20 === void 0 ? void 0 : _formData$tradeLicens20.split('.')[0]) === "TOWNPLANNER" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have a graduate or postgraduate degree in town and country planning"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantGraduate",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantGraduate) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet17 = formData.nocOtherDetails) === null || _formData$nocOtherDet17 === void 0 ? void 0 : _formData$nocOtherDet17.theApplicantGraduate)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have Associate membership of the Institute of Town Planners, India"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantAssociateMembership",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantAssociateMembership) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet18 = formData.nocOtherDetails) === null || _formData$nocOtherDet18 === void 0 ? void 0 : _formData$nocOtherDet18.theApplicantAssociateMembership)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have a valid ITPI membership number"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantITPI",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantITPI) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet19 = formData.nocOtherDetails) === null || _formData$nocOtherDet19 === void 0 ? void 0 : _formData$nocOtherDet19.theApplicantITPI)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Is the applicant\u2019s ITPI membership valid for the period mentioned in the application "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theApplicantITPImembership",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theApplicantITPImembership) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet20 = formData.nocOtherDetails) === null || _formData$nocOtherDet20 === void 0 ? void 0 : _formData$nocOtherDet20.theApplicantITPImembership)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens21 = formData.tradeLicenseDetail) === null || _formData$tradeLicens21 === void 0 ? void 0 : (_formData$tradeLicens22 = _formData$tradeLicens21.tradeUnits) === null || _formData$tradeLicens22 === void 0 ? void 0 : (_formData$tradeLicens23 = _formData$tradeLicens22[0]) === null || _formData$tradeLicens23 === void 0 ? void 0 : (_formData$tradeLicens24 = _formData$tradeLicens23.tradeType) === null || _formData$tradeLicens24 === void 0 ? void 0 : _formData$tradeLicens24.split('.')[0]) === "LANDSCAPEARCHITECT" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have a bachelor\u2019s or master\u2019s degree in landscape architecture or equivalent from a recognized Indian or foreign university"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theLandscapeArchitecture",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theLandscapeArchitecture) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet21 = formData.nocOtherDetails) === null || _formData$nocOtherDet21 === void 0 ? void 0 : _formData$nocOtherDet21.theLandscapeArchitecture)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  })))))), (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens25 = formData.tradeLicenseDetail) === null || _formData$tradeLicens25 === void 0 ? void 0 : (_formData$tradeLicens26 = _formData$tradeLicens25.tradeUnits) === null || _formData$tradeLicens26 === void 0 ? void 0 : (_formData$tradeLicens27 = _formData$tradeLicens26[0]) === null || _formData$tradeLicens27 === void 0 ? void 0 : (_formData$tradeLicens28 = _formData$tradeLicens27.tradeType) === null || _formData$tradeLicens28 === void 0 ? void 0 : _formData$tradeLicens28.split('.')[0]) === "URBANDESIGNER" && /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Does the applicant have a master\u2019s degree in urban design or equivalent from a recognized Indian or foreign university "), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    name: "theDegreeUrbanDesign",
    onChange: handleChange,
    defaultValue: (storedData === null || storedData === void 0 ? void 0 : storedData.theDegreeUrbanDesign) || (formData === null || formData === void 0 ? void 0 : (_formData$nocOtherDet22 = formData.nocOtherDetails) === null || _formData$nocOtherDet22 === void 0 ? void 0 : _formData$nocOtherDet22.theDegreeUrbanDesign)
  }, yesOrNo.map(option => /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    key: option.value,
    value: option.value,
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: option.label
  }))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "15%"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit"
  }))))));
};

const StyledTabPanel$2 = styled$2(TabPanel)(() => ({
  "& .MuiBox-root": {
    padding: 0
  }
}));

const useEmpLTP = (formData, workflowDetails) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4, _user$info, _Digit$UserService$ge, _Digit$UserService$ge2, _formData$application, _formData$application2, _formData$PrevStateDo, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _formData$tradeLicens5, _formData$tradeLicens6, _pdfDetails$pdfFiles, _user$info4, _user$info4$roles, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _formData$paymentDeta, _formData$paymentDeta2, _formData$paymentDeta3, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _user$info5;
  const subTabLabels = [{
    label: "Applicant Type"
  }, {
    label: "Applicant Details"
  }, {
    label: "Contact Information"
  }, {
    label: "Registration Details"
  }];
  const Modal = useModal();
  const today = dayjs();
  const fiveYearsFromNow = today.add(5, "year");
  const history = useHistory();
  const tenantId = Digit.ULBService.getStateId();
  const tradeType = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.tradeUnits) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2[0]) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.tradeType;
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "Registration");
  let user = Digit.UserService.getUser();
  const [currentAction, setCurrentAction] = useState("");
  const [developerRemarks, setDeveloperRemarks] = useState("");
  const reduxFormData = useSelector(state => state === null || state === void 0 ? void 0 : state.ltpChecklist);
  const [updatedDocuments, setUpdatedDocuments] = useState(formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens4 = formData.tradeLicenseDetail) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.applicationDocuments);
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [callAPI, setCallAPI] = useState(false);
  const [validUpTo, setValidUpto] = useState(null);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [structureCertificateUrl, setStructureCertificateUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [dataRecommendationDocument, setDataRecommendationDocument] = useState("");
  const [developerRemarksDocument, setDeveloperRemarksDocument] = useState(null);
  const [developerUpdateDocument, setDeveloperUpdateDocument] = useState("");
  const [structureCertificateId, setStructureCertificateId] = useState("");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EMP_LTP", formData);
  const [iframeSrc, setIframeSrc] = useState("");
  const userRolesArray = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.roles.filter(user => user.code !== "EMPLOYEE");
  const isNodal = userRolesArray === null || userRolesArray === void 0 ? void 0 : userRolesArray.some(e => (e === null || e === void 0 ? void 0 : e.code) === "Nodal Officer");
  const isAwasOfficer = userRolesArray === null || userRolesArray === void 0 ? void 0 : userRolesArray.some(e => (e === null || e === void 0 ? void 0 : e.code) === "NODAL_OFFICER_AWAS");
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const authToken = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.access_token) || null;
  const handleGetDocumentById = async applicationNumber => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken
      }
    };
    try {
      const Resp = await axios$1.post(`${Urls$1.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then(response => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const callDocumentDetailsAPI = async (developerRemarks, dataRecommendation, documents) => {
    const finalRecommendation = dataRecommendation !== undefined && dataRecommendation !== null ? dataRecommendation : dataRecommendationDocument;
    const finalRemarks = developerRemarks !== undefined && developerRemarks !== null ? developerRemarks : developerRemarksDocument;
    const finalDocuments = documents !== undefined && documents !== null ? documents : updatedDocuments;
    if (!finalRecommendation || !finalRemarks || !finalDocuments || finalDocuments.length === 0) {
      console.log("Data not ready, API blocked");
      return;
    }
    setLoader(true);
    const postData = {
      RequestInfo: {
        apiId: "Rainmaker",
        authToken: authToken,
        userInfo: userInfo,
        msgId: "1743578637716|en_IN"
      },
      DetailDataRemarks: {
        userDetails: {
          userID: userInfo && userInfo.id ? userInfo.id : null,
          name: userInfo && userInfo.name ? userInfo.name : null,
          employeeName: userInfo && userInfo.name ? userInfo.name : null,
          role: userRolesArray && userRolesArray[0] ? userRolesArray[0].code : null,
          applicationID: formData ? formData.applicationNumber : null,
          designation: userRolesArray && userRolesArray[0] ? userRolesArray[0].name : null,
          applicationStatus: formData ? formData.status : null
        },
        isApproved: "DocumentDetails",
        documentDetails: {
          dataRecommendation: finalRecommendation,
          developerRemarks: finalRemarks,
          documents: finalDocuments
        }
      }
    };
    try {
      const response = await axios$1.post(Urls$1.bpaService.remarksDetail, postData);
      console.log("response", response.data);
      Modal("Documents updated", `Document details for <strong>(${formData.applicationNumber})</strong> updated successfully!`, "success");
      await handleGetDocumentById(formData.applicationNumber);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (callAPI && (updatedDocuments === null || updatedDocuments === void 0 ? void 0 : updatedDocuments.length) > 0 && dataRecommendationDocument && developerRemarksDocument) {
      callDocumentDetailsAPI(developerRemarksDocument, dataRecommendationDocument);
      setCallAPI(false);
    }
  }, [callAPI, updatedDocuments, dataRecommendationDocument, developerRemarksDocument]);
  useEffect(() => {
    console.log("applicationRemarksFetch", formData === null || formData === void 0 ? void 0 : formData.applicationNumber);
    if (formData !== null && formData !== void 0 && formData.applicationNumber) {
      handleGetDocumentById(formData.applicationNumber);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNumber]);
  useEffect(() => {
    var _documentRemarksData$, _documentRemarksData$2, _documentRemarksData$3;
    console.log(documentRemarksData, documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$ = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$ === void 0 ? void 0 : (_documentRemarksData$2 = _documentRemarksData$[0]) === null || _documentRemarksData$2 === void 0 ? void 0 : (_documentRemarksData$3 = _documentRemarksData$2.documentDetails) === null || _documentRemarksData$3 === void 0 ? void 0 : _documentRemarksData$3.dataRecommendation, "documentRemarksData");
    if (documentRemarksData !== null && documentRemarksData !== void 0 && documentRemarksData.DetailDataRemarks) {
      var _documentRemarksData$4, _documentRemarksData$5, _documentRemarksData$6, _documentRemarksData$7, _documentRemarksData$8, _documentRemarksData$9;
      setDataRecommendationDocument((documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$4 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$4 === void 0 ? void 0 : (_documentRemarksData$5 = _documentRemarksData$4[0]) === null || _documentRemarksData$5 === void 0 ? void 0 : (_documentRemarksData$6 = _documentRemarksData$5.documentDetails) === null || _documentRemarksData$6 === void 0 ? void 0 : _documentRemarksData$6.dataRecommendation) || "");
      setDeveloperRemarksDocument((documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$7 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$7 === void 0 ? void 0 : (_documentRemarksData$8 = _documentRemarksData$7[0]) === null || _documentRemarksData$8 === void 0 ? void 0 : (_documentRemarksData$9 = _documentRemarksData$8.documentDetails) === null || _documentRemarksData$9 === void 0 ? void 0 : _documentRemarksData$9.developerRemarks) || "");
    }
  }, [documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks]);
  useEffect(() => {
    var _user$info2, _documentRemarksData$10, _detailData$userDetai, _detailData$documentD, _detailData$documentD2, _Digit;
    const userId = String(user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.id);
    const detailData = documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$10 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$10 === void 0 ? void 0 : _documentRemarksData$10[0];
    const detailUserId = String(detailData === null || detailData === void 0 ? void 0 : (_detailData$userDetai = detailData.userDetails) === null || _detailData$userDetai === void 0 ? void 0 : _detailData$userDetai.userID);
    const matchedData = detailUserId === userId;
    const isDocValidated = matchedData && Array.isArray(detailData === null || detailData === void 0 ? void 0 : (_detailData$documentD = detailData.documentDetails) === null || _detailData$documentD === void 0 ? void 0 : _detailData$documentD.documents) && detailData.documentDetails.documents.length > 0;
    console.log("userId", userId);
    console.log("detailUserId", detailUserId);
    console.log("matchedData", matchedData);
    console.log("documents", detailData === null || detailData === void 0 ? void 0 : (_detailData$documentD2 = detailData.documentDetails) === null || _detailData$documentD2 === void 0 ? void 0 : _detailData$documentD2.documents);
    console.log("isDocValidated", isDocValidated);
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.set("isDocValidated", isDocValidated);
  }, [user, documentRemarksData]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const allValuesNull = data => Object.values(data || {}).every(value => value === null);
  const viewApprovalLetter = url => {
    const fileUrl = structureCertificateUrl || url;
    window.open(fileUrl, "_blank");
    sweetalert2_all.fire({
      title: "Action Approved",
      text: `Application Approved Successfully!`,
      icon: "success"
    }).then(() => {
      window.location.reload();
    });
    history.push("/digit-ui/employee");
  };
  const handleSubmit = async () => {
    var _user$info3, _documentRemarksData$11, _detailData$userDetai2, _detailData$documentD3, _Digit2;
    if (isNodal && allValuesNull(reduxFormData)) {
      sweetalert2_all.fire({
        title: "Checklist Required",
        text: `Please fill the checklist before Proceeding!`,
        icon: "error"
      });
      return 0;
    }
    const userId = String(user === null || user === void 0 ? void 0 : (_user$info3 = user.info) === null || _user$info3 === void 0 ? void 0 : _user$info3.id);
    const detailData = documentRemarksData === null || documentRemarksData === void 0 ? void 0 : (_documentRemarksData$11 = documentRemarksData.DetailDataRemarks) === null || _documentRemarksData$11 === void 0 ? void 0 : _documentRemarksData$11[0];
    const detailUserId = String(detailData === null || detailData === void 0 ? void 0 : (_detailData$userDetai2 = detailData.userDetails) === null || _detailData$userDetai2 === void 0 ? void 0 : _detailData$userDetai2.userID);
    const matchedData = detailUserId === userId;
    const isDocValidated = Array.isArray(detailData === null || detailData === void 0 ? void 0 : (_detailData$documentD3 = detailData.documentDetails) === null || _detailData$documentD3 === void 0 ? void 0 : _detailData$documentD3.documents) && detailData.documentDetails.documents.length > 0 && (isAwasOfficer ? true : matchedData);
    console.log("matchedData346", matchedData, detailData, user);
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("isDocValidated", isDocValidated);
    const selectedAction = (typeof currentAction === "object" ? currentAction === null || currentAction === void 0 ? void 0 : currentAction.action : currentAction) || (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) || "";
    const isSendBackAction = typeof selectedAction === "string" && selectedAction.toUpperCase().includes("SEND_BACK");
    if (!isSendBackAction && !isDocValidated) {
      Modal("Review documents section", "Please review the documents section and click on Save", "error");
      return;
    }
    if (!(currentAction !== null && currentAction !== void 0 && currentAction.action)) {
      Modal("Please select the action", "Please select the available action to proceed further", "error");
      return;
    }
    if (!validUpTo) {
      Modal("Validity Date Missing", "Please select a valid up to date from date picker", "error");
      return;
    }
    if (isAwasOfficer && (formData === null || formData === void 0 ? void 0 : formData.status) === "APPLY_FOR_DSC" && !(formData !== null && formData !== void 0 && formData.IsApprovalCertificate)) {
      Modal("Digital signature not attached", "Please make sure digital signature is successfully attached", "error");
      return;
    }
    try {
      const additionalDetails = {
        ...params
      };
      const workflow = {
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile ? [{
          documentType: currentAction + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const appData = {
        ...params,
        validupto: validUpTo,
        tradeLicenseDetail: {
          ...(formData === null || formData === void 0 ? void 0 : formData.tradeLicenseDetail)
        },
        additionalDetails,
        workflow,
        action: currentAction === null || currentAction === void 0 ? void 0 : currentAction.action,
        comment: developerRemarks,
        nocOtherDetails: reduxFormData,
        assignee: null,
        wfDocuments: uploadedFile ? [{
          documentType: (currentAction === null || currentAction === void 0 ? void 0 : currentAction.action) + " DOC",
          fileName: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name,
          fileStoreId: uploadedFile
        }] : null
      };
      const data = [{
        ...appData
      }];
      console.log("dataLtp", data);
      updateApiCall.mutate({
        Licenses: data
      }, {
        onSuccess: async result => {
          var _result$Licenses;
          if ((result === null || result === void 0 ? void 0 : (_result$Licenses = result.Licenses) === null || _result$Licenses === void 0 ? void 0 : _result$Licenses.length) > 0) {
            var _result$Licenses2, _result$Licenses2$, _result$Licenses3, _result$Licenses3$, _result$Licenses4, _result$Licenses4$, _Digit3;
            Modal(`Application updated`, `Action taken successfully for Application <strong>(${result === null || result === void 0 ? void 0 : (_result$Licenses2 = result.Licenses) === null || _result$Licenses2 === void 0 ? void 0 : (_result$Licenses2$ = _result$Licenses2[0]) === null || _result$Licenses2$ === void 0 ? void 0 : _result$Licenses2$.applicationNumber})</strong>!`, "success", "/digit-ui/employee");
            const fileStoreId = result === null || result === void 0 ? void 0 : (_result$Licenses3 = result.Licenses) === null || _result$Licenses3 === void 0 ? void 0 : (_result$Licenses3$ = _result$Licenses3[0]) === null || _result$Licenses3$ === void 0 ? void 0 : _result$Licenses3$.approvalLetterId;
            const fileStoreUrl = result === null || result === void 0 ? void 0 : (_result$Licenses4 = result.Licenses) === null || _result$Licenses4 === void 0 ? void 0 : (_result$Licenses4$ = _result$Licenses4[0]) === null || _result$Licenses4$ === void 0 ? void 0 : _result$Licenses4$.approvalLetterUrl;
            setStructureCertificateId(fileStoreId);
            setStructureCertificateUrl(fileStoreUrl);
            setShowTakeAction("Take_Action");
            Digit.SessionStorage.del("EMP_LTP");
            (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("isDocValidated");
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNoWorkflow = updatedDocuments => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: ""
    };
    const appData = {
      ...formData,
      tradeLicenseDetail: {
        ...(formData === null || formData === void 0 ? void 0 : formData.tradeLicenseDetail),
        applicationDocuments: updatedDocuments
      },
      action: "NOWORKFLOW",
      workflow
    };
    const data = [{
      ...appData
    }];
    updateApiCall.mutate({
      Licenses: data
    }, {
      onSuccess: result => {
        var _result$Licenses5, _Digit4;
        console.log("resultFromUpdate", result);
        setDeveloperUpdateDocument("DocumentDetailsUpdated");
        onSelect("", result === null || result === void 0 ? void 0 : (_result$Licenses5 = result.Licenses) === null || _result$Licenses5 === void 0 ? void 0 : _result$Licenses5[0]);
        (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.set("isDocValidated", true);
      }
    });
  };
  const docs = (formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationData) === null || _formData$application === void 0 ? void 0 : (_formData$application2 = _formData$application.tradeLicenseDetail) === null || _formData$application2 === void 0 ? void 0 : _formData$application2.applicationDocuments) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const documentSection = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5.applicationDocuments) === null || _formData$tradeLicens6 === void 0 ? void 0 : _formData$tradeLicens6.filter(doc => !["signature", "applicantPhoto", "typeOfLetterDoc"].includes(doc.documentType));
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  const fetchInitialUrl = async fileStoreId => {
    const response = await axios$1.get(`/filestore/v1/files/url?tenantId=up&fileStoreIds=${fileStoreId}`);
    setIframeSrc(response.data.fileStoreIds[0].url);
  };
  useEffect(() => {
    var _documentSection$;
    console.log("documentLTPSECTION", documentSection);
    if (documentSection !== null && documentSection !== void 0 && (_documentSection$ = documentSection[0]) !== null && _documentSection$ !== void 0 && _documentSection$.fileStoreId) {
      var _documentSection$2;
      fetchInitialUrl(documentSection === null || documentSection === void 0 ? void 0 : (_documentSection$2 = documentSection[0]) === null || _documentSection$2 === void 0 ? void 0 : _documentSection$2.fileStoreId);
    }
  }, []);
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const userRoles = user === null || user === void 0 ? void 0 : (_user$info4 = user.info) === null || _user$info4 === void 0 ? void 0 : (_user$info4$roles = _user$info4.roles) === null || _user$info4$roles === void 0 ? void 0 : _user$info4$roles.map(e => e.code);
  let isbelow = (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 2500;
  const isTCP = userRoles.includes("TCP_HQ") || userRoles.includes("TCP");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.filter(e => {
    if (isbelow && isTCP && (e.action === "SEND_TO_STP" || e.action === "FORWARD") && (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA") {
      return false;
    } else if (!isbelow && isTCP && (e.action === "APPROVE" || e.action === "ISSUE_CERTIFICATE" || e.action === "REJECT" || e.action === "PROVISIONALLY_APPROVAL") && (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA") {
      return false;
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  console.log("actiaonsLTP", actions);
  const onDropDownSelect = event => {
    const value = event.target.value;
    setCurrentAction(value);
  };
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$paymentDeta = formData.paymentDetails) === null || _formData$paymentDeta === void 0 ? void 0 : (_formData$paymentDeta2 = _formData$paymentDeta.bill) === null || _formData$paymentDeta2 === void 0 ? void 0 : (_formData$paymentDeta3 = _formData$paymentDeta2.billDetails[0]) === null || _formData$paymentDeta3 === void 0 ? void 0 : _formData$paymentDeta3.amount) || (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount);
  const isCitizen = (user === null || user === void 0 ? void 0 : (_user$info5 = user.info) === null || _user$info5 === void 0 ? void 0 : _user$info5.type) === "CITIZEN";
  return {
    subTabLabels,
    tradeType,
    isCitizen,
    params,
    setParams,
    clearParams,
    onSelect,
    updateApiCall,
    currentAction,
    setCurrentAction,
    developerRemarks,
    setDeveloperRemarks,
    uploadedFile,
    setUploadedFile,
    handleNoWorkflow,
    applicationDocs,
    totalAmount,
    actions,
    onDropDownSelect,
    handleSubmit,
    viewApprovalLetter,
    showTakeAction,
    iframeSrc,
    setIframeSrc,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callDocumentDetailsAPI,
    documentRemarksData,
    developerUpdateDocument,
    setValidUpto,
    fiveYearsFromNow
  };
};

const YellowTableCell = styled$1(TableCell$1)(({
  theme
}) => ({
  fontFamily: '"Calibri", sans-serif',
  fontSize: "1rem"
}));
const accordionSummaryStyles$2 = {
  width: "92%",
  backgroundColor: "#4276A9",
  color: "#fff",
  height: "1rem",
  minHeight: "48px",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "1rem",
  "&.Mui-expanded": {
    backgroundColor: "#4276A9",
    minHeight: "48px",
    height: "1rem",
    fontFamily: '"Calibri", sans-serif'
  }
};
const CompetenceTable = ({
  type
}) => {
  let tableContent;
  switch (type) {
    case "ARCHITECT.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "The minimum qualifications for an architect shall be the qualifications as provided for in the Architects Act, 1972 for registration", " ", /*#__PURE__*/React__default.createElement("br", null), " with the Council of Architecture."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed architect shall be competent to carry out the work related to the building/development permit as given below:")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "1"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of all plans and information connected with building permit except engineering services of multistoried, high-rise, and special buildings.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "2"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing certificate of supervision and completion of all buildings pertaining to architectural aspects.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "3"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of sub-division/layout plans and related information connected with development permit of area up to 1 hectare for metro-cities", /*#__PURE__*/React__default.createElement("br", null), " and 2 hectares for other places.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "4"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing certificate of supervision for development of land of area up to 1 hectare for metro-cities and 2 hectares for other places."))));
      break;
    case "TOWNPLANNER.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The minimum qualification for a town planner shall be graduate or post-graduate degree in town and country planning with Associate Membership of the Institute of Town Planners."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "NOTE:"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "However, for land layouts for development permit above 5 hectares in area, landscape architect shall also be associated, and for land development", /*#__PURE__*/React__default.createElement("br", null), " infrastructural services for roads, water supplies, sewerage/drainage, electrification, etc. the licensed engineers for", /*#__PURE__*/React__default.createElement("br", null), "utility services shall be associated.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed town planner shall be competent to carry out the work related to the development permit as given below:")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "1"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of plans for land sub-division/layout and related information connected with development permit for all areas.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "2"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing of certificate of supervision for development of land of all areas."))));
      break;
    case "SUPERVISOR.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "break-word"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "The minimum qualifications for a supervisor shall be diploma in civil engineering or architectural assistantship, or the qualification in architecture or engineering equivalent to the minimum qualification prescribed for recruitment to non-gazetted service by the Government of India plus 5 years\u2019 experience in building design, construction, and supervision.")))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed supervisor shall be competent to carry out the work related to the building permit as given below:")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "1"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "All plans and related information connected with building permit for residential buildings on plot up to 200 m", /*#__PURE__*/React__default.createElement("sup", null, "2"), " and up to two storeys or 7.5 m in height.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "2"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing certificate of supervision for residential buildings as per (1) above."))));
      break;
    case "GRADUATECIVILENGINEER.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The minimum qualifications for an engineer shall be graduate in civil engineering/architectural engineering of recognized Indian or foreign university, or the Corporate Member of Civil Engineering Division/Architectural Engineering Division of the Institution of Engineers (India) or the statutory body governing such profession, as and when established."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed civil engineer shall be competent to carry out the work related to the building/development permit as given below:")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "1"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of all plans and information connected with building permit.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "2"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Structural details and calculations of buildings including sub-surface investigation on plot up to 500 sq.m and up to 5 storeys or 16.0 m in height.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "3"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing certificate of supervision and completion for all buildings.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "4"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of all service plans and related information connected with development permit.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "5"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Issuing certificate of supervision for development of land for all areas.")), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "6"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "Preparation of subdivision/layout plans and related information connected with development permit of area up to 1 ha for metro-cities, and 2 ha for other places."))));
      break;
    case "STRUCTURALENGINEER.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The minimum qualifications for a structural engineer shall be graduate in civil engineering of recognized Indian or foreign university, or Corporate Member of Civil Engineering Division of Institution of Engineers (India), and with minimum 3 years\u2019 experience in structural engineering practice with designing and field work.", /*#__PURE__*/React__default.createElement("br", null)))), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "NOTE:"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "The 3 years\u2019 experience shall be relaxed to 2 years in the case of post-graduate degree of recognized Indian or foreign university in the branch of structural engineering. In case of doctorate in structural engineering, the experience required would be one year."), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed structural engineer shall be competent to prepare the structural design, calculations and details for all buildings and supervision. In case of buildings having special structural features, as decided by the Authority, which are within the horizontal areas and vertical limits specified in 14.2.2 and 14.2.4 shall be designed only by structural engineers.")))));
      break;
    case "LANDSCAPEARCHITECT.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The minimum qualification for a landscape architect shall be the bachelor\u2019s or master\u2019s degree in landscape architecture or equivalent from recognized Indian or foreign university."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed landscape Architect shall be competent to carry out the work related to landscape design for building development permit for land areas 5 hectares and above. In case of metro cities, this limit of land area shall be 2 hectares and above."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "NOTE:"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view of desired landscape development."))));
      break;
    case "URBANDESIGNER.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The minimum qualification for an urban designer shall be master's degree in urban design or equivalent from recognized Indian or foreign university."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Competence: The licensed urban designer shall be competent to carry out the work related to the building permit for urban design for land areas more than 5 hectares and campus area more than 2 hectares. He/She shall also be competent to carry out the work of urban renewal for all areas."))), /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, null, "NOTE:"), /*#__PURE__*/React__default.createElement(YellowTableCell, null, "For smaller areas below the limits indicated above, association of landscape architect may also be considered from the point of view of desired urban design."))));
      break;
    case "ENGINEERSUTILITYSERVICES.CLASSA":
      tableContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(YellowTableCell, {
        colSpan: 2
      }, /*#__PURE__*/React__default.createElement(Typography, {
        variant: "subtitle1",
        fontWeight: "bold"
      }, "Qualification: The qualification for licensed mechanical engineer (including HVAC), electrical engineer and plumbing engineers for carrying out the work of air-conditioning, heating and mechanical ventilation, electrical installations, lifts, escalators and moving walks and water supply, drainage. sanitation and gas supply installation respectively shall be as given in Part 8 'Building Services' and Part 9 'Plumbing Services' of National Building Code, 2016 or as decided by the Authority considering practices of the National Professional bodies dealing with the specialist engineering services. For multistoried, high-rise, and special buildings the work of building and plumbing services shall be executed under the planning, design, and supervision of competent personnel.")))));
      break;
    default:
      tableContent = null;
  }
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    className: "Common-tab-section"
  }, /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, {
      style: {
        color: "#fff"
      }
    }),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    sx: accordionSummaryStyles$2
  }, "Essential Requirement and Competency"), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Table$2, {
    "aria-label": "competence table"
  }, tableContent))));
};

const SubStep1$9 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isReapply
}) => {
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    tradeLicenseDetail: {
      ...(formData === null || formData === void 0 ? void 0 : formData.tradeLicenseDetail)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const watchTradeType = watch("tradeLicenseDetail.tradeUnits.[0].tradeType");
  const watchRegistrationType = watch("registrationType");
  useEffect(() => {
    if (watchRegistrationType === "Architect") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "ARCHITECT.CLASSA");
    } else if (watchRegistrationType === "Town Planner") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "TOWNPLANNER.CLASSA");
    } else if (watchRegistrationType === "Supervisor") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "SUPERVISOR.CLASSA");
    } else if (watchRegistrationType === "Graduate Civil Engineer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "GRADUATECIVILENGINEER.CLASSA");
    } else if (watchRegistrationType === "Structural Engineer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "STRUCTURALENGINEER.CLASSA");
    } else if (watchRegistrationType === "Landscape Architect") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "LANDSCAPEARCHITECT.CLASSA");
    } else if (watchRegistrationType === "Urban Designer") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "URBANDESIGNER.CLASSA");
    } else if (watchRegistrationType === "Engineers for Utility Services") {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "ENGINEERSUTILITYSERVICES.CLASSA");
    } else {
      setValue("tradeLicenseDetail.tradeUnits.[0].tradeType", "");
    }
  }, [watchTradeType, watchRegistrationType]);
  useEffect(() => {
    setValue("department", "DA");
  }, []);
  const onSubmit = data => {
    handleSubTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_TYPE"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(registrationTypes),
    label: `${t("LABEL_APPLICANT_TYPE")}`,
    placeholder: "Select Applicant Type",
    name: "registrationType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.registrationType,
    type: "selectInput",
    mandatory: true,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : formData.registrationType),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(CompetenceTable, {
    type: watchTradeType
  })), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep2$4 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isReapply
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4, _formData$tradeLicens5, _formData$tradeLicens6, _formData$tradeLicens7, _formData$tradeLicens8, _formData$tradeLicens9, _formData$tradeLicens10, _formData$tradeLicens11, _formData$tradeLicens12, _formData$tradeLicens13, _formData$tradeLicens14, _formData$tradeLicens15, _formData$tradeLicens16, _formData$tradeLicens17, _formData$tradeLicens18, _formData$tradeLicens19, _formData$tradeLicens20, _formData$tradeLicens21, _formData$tradeLicens22, _formData$tradeLicens23, _formData$tradeLicens24, _formData$tradeLicens25, _formData$tradeLicens26, _formData$tradeLicens27, _formData$tradeLicens28, _formData$tradeLicens29, _formData$tradeLicens30, _formData$tradeLicens31, _formData$tradeLicens32, _formData$tradeLicens33, _formData$tradeLicens34, _formData$tradeLicens35, _formData$tradeLicens36, _formData$tradeLicens37, _formData$tradeLicens38, _formData$tradeLicens39, _formData$tradeLicens40, _formData$tradeLicens41, _formData$tradeLicens42, _formData$tradeLicens43, _formData$tradeLicens44, _formData$tradeLicens45, _formData$tradeLicens46, _formData$tradeLicens47, _formData$tradeLicens48, _formData$tradeLicens49, _formData$tradeLicens50, _formData$tradeLicens51, _formData$tradeLicens52, _formData$tradeLicens53, _formData$tradeLicens54, _formData$tradeLicens55, _formData$tradeLicens56, _formData$tradeLicens57, _formData$tradeLicens58, _formData$tradeLicens59;
  const [showToast, setShowToast] = useState(null);
  const {
    t
  } = useTranslation();
  const today = dayjs();
  const eighteenYearsAgo = today.subtract(18, "year");
  const registrationType = formData === null || formData === void 0 ? void 0 : formData.registrationType;
  const defaultValues = {
    ...formData,
    tradeLicenseDetail: {
      ...(formData === null || formData === void 0 ? void 0 : formData.tradeLicenseDetail),
      owners: [{
        ...(formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.owners) === null || _formData$tradeLicens2 === void 0 ? void 0 : _formData$tradeLicens2[0]),
        initialForApplicantName: (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens3 = formData.tradeLicenseDetail) === null || _formData$tradeLicens3 === void 0 ? void 0 : (_formData$tradeLicens4 = _formData$tradeLicens3.owners) === null || _formData$tradeLicens4 === void 0 ? void 0 : (_formData$tradeLicens5 = _formData$tradeLicens4[0]) === null || _formData$tradeLicens5 === void 0 ? void 0 : _formData$tradeLicens5.initialForApplicantName) || "Mr."
      }]
    }
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchEducationalQualification = watch("tradeLicenseDetail.owners.[0].qualification");
  const panNo = watch("tradeLicenseDetail.owners.[0].pan");
  useEffect(() => {
    const capitalizePAN = panNo === null || panNo === void 0 ? void 0 : panNo.toUpperCase();
    setValue("tradeLicenseDetail.owners.[0].pan", capitalizePAN);
  }, [panNo]);
  const onSubmit = data => {
    var _data$tradeLicenseDet, _data$tradeLicenseDet2, _data$tradeLicenseDet3, _data$tradeLicenseDet4, _data$tradeLicenseDet5, _data$tradeLicenseDet6, _data$tradeLicenseDet7, _data$tradeLicenseDet8, _data$tradeLicenseDet9, _data$tradeLicenseDet10, _data$tradeLicenseDet11, _data$tradeLicenseDet12;
    const dob = data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet = data.tradeLicenseDetail) === null || _data$tradeLicenseDet === void 0 ? void 0 : (_data$tradeLicenseDet2 = _data$tradeLicenseDet.owners) === null || _data$tradeLicenseDet2 === void 0 ? void 0 : (_data$tradeLicenseDet3 = _data$tradeLicenseDet2[0]) === null || _data$tradeLicenseDet3 === void 0 ? void 0 : _data$tradeLicenseDet3.dateOfBirth;
    const experienceRaw = data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet4 = data.tradeLicenseDetail) === null || _data$tradeLicenseDet4 === void 0 ? void 0 : (_data$tradeLicenseDet5 = _data$tradeLicenseDet4.owners) === null || _data$tradeLicenseDet5 === void 0 ? void 0 : (_data$tradeLicenseDet6 = _data$tradeLicenseDet5[0]) === null || _data$tradeLicenseDet6 === void 0 ? void 0 : _data$tradeLicenseDet6.totalExperience;
    if (dob && experienceRaw) {
      const birthDate = dayjs(dob);
      const today = dayjs();
      const age = today.diff(birthDate, "year");
      const minWorkingAge = 18;
      const maxAllowedExperience = age - minWorkingAge;
      let years = 0,
        months = 0;
      const match = experienceRaw.match(/(\d+)\s*Years?-?\s*(\d+)\s*Months?/i);
      if (match) {
        years = Number(match[1]) || 0;
        months = Number(match[2]) || 0;
      } else {
        setShowToast({
          key: true,
          label: "Invalid Experience Format"
        });
        return;
      }
      const totalExperienceInYears = years + months / 12;
      if (totalExperienceInYears > maxAllowedExperience) {
        setShowToast({
          key: true,
          label: "Experience is not valid according to DOB"
        });
        return;
      }
      if (registrationType === "Supervisor" && watchEducationalQualification === "Diploma in Civil Engineering" && totalExperienceInYears < 5) {
        setShowToast({
          key: true,
          label: "Minimum experience should be 5 years for Diploma in Diploma in Civil Engineering Qualification"
        });
        return;
      }
    }
    data.tradeLicenseDetail.owners[0].gender = (data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet7 = data.tradeLicenseDetail) === null || _data$tradeLicenseDet7 === void 0 ? void 0 : (_data$tradeLicenseDet8 = _data$tradeLicenseDet7.owners) === null || _data$tradeLicenseDet8 === void 0 ? void 0 : (_data$tradeLicenseDet9 = _data$tradeLicenseDet8[0]) === null || _data$tradeLicenseDet9 === void 0 ? void 0 : _data$tradeLicenseDet9.initialForApplicantName) === "Mr." ? "MALE" : "FEMALE";
    data.tradeLicenseDetail.owners[0].name = `${data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet10 = data.tradeLicenseDetail) === null || _data$tradeLicenseDet10 === void 0 ? void 0 : (_data$tradeLicenseDet11 = _data$tradeLicenseDet10.owners) === null || _data$tradeLicenseDet11 === void 0 ? void 0 : (_data$tradeLicenseDet12 = _data$tradeLicenseDet11[0]) === null || _data$tradeLicenseDet12 === void 0 ? void 0 : _data$tradeLicenseDet12.name}` || null;
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_DETAILS"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "tradeLicenseDetail.owners.[0].name",
    mandatory: true,
    maxLength: 70,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens6 = formData.tradeLicenseDetail) === null || _formData$tradeLicens6 === void 0 ? void 0 : (_formData$tradeLicens7 = _formData$tradeLicens6.owners) === null || _formData$tradeLicens7 === void 0 ? void 0 : (_formData$tradeLicens8 = _formData$tradeLicens7[0]) === null || _formData$tradeLicens8 === void 0 ? void 0 : _formData$tradeLicens8.name,
    type: "textInput",
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens9 = formData.tradeLicenseDetail) === null || _formData$tradeLicens9 === void 0 ? void 0 : (_formData$tradeLicens10 = _formData$tradeLicens9.owners) === null || _formData$tradeLicens10 === void 0 ? void 0 : (_formData$tradeLicens11 = _formData$tradeLicens10[0]) === null || _formData$tradeLicens11 === void 0 ? void 0 : _formData$tradeLicens11.name),
    validation: {},
    selectSuffix: {
      name: `tradeLicenseDetail.owners.[0].initialForApplicantName`,
      data: SortingAlphabatically(nameSuffix),
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens12 = formData.tradeLicenseDetail) === null || _formData$tradeLicens12 === void 0 ? void 0 : (_formData$tradeLicens13 = _formData$tradeLicens12.owners) === null || _formData$tradeLicens13 === void 0 ? void 0 : (_formData$tradeLicens14 = _formData$tradeLicens13[0]) === null || _formData$tradeLicens14 === void 0 ? void 0 : _formData$tradeLicens14.initialForApplicantName) || "Mr.",
      control,
      disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens15 = formData.tradeLicenseDetail) === null || _formData$tradeLicens15 === void 0 ? void 0 : (_formData$tradeLicens16 = _formData$tradeLicens15.owners) === null || _formData$tradeLicens16 === void 0 ? void 0 : (_formData$tradeLicens17 = _formData$tradeLicens16[0]) === null || _formData$tradeLicens17 === void 0 ? void 0 : _formData$tradeLicens17.initialForApplicantName)
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_TOTAL_EXPERIENCE"),
    control: control,
    placeholder: t("LABEL_ENTER_EXPERIENCE"),
    name: "tradeLicenseDetail.owners.[0].totalExperience",
    type: "yearMonthPicker",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens18 = formData.tradeLicenseDetail) === null || _formData$tradeLicens18 === void 0 ? void 0 : (_formData$tradeLicens19 = _formData$tradeLicens18.owners) === null || _formData$tradeLicens19 === void 0 ? void 0 : (_formData$tradeLicens20 = _formData$tradeLicens19[0]) === null || _formData$tradeLicens20 === void 0 ? void 0 : _formData$tradeLicens20.totalExperience,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens21 = formData.tradeLicenseDetail) === null || _formData$tradeLicens21 === void 0 ? void 0 : (_formData$tradeLicens22 = _formData$tradeLicens21.owners) === null || _formData$tradeLicens22 === void 0 ? void 0 : (_formData$tradeLicens23 = _formData$tradeLicens22[0]) === null || _formData$tradeLicens23 === void 0 ? void 0 : _formData$tradeLicens23.totalExperience)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EDUCATIONAL_QUALIFICATION"),
    control: control,
    placeholder: t("Select Qualification"),
    name: "tradeLicenseDetail.owners.[0].qualification",
    mandatory: true,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens24 = formData.tradeLicenseDetail) === null || _formData$tradeLicens24 === void 0 ? void 0 : (_formData$tradeLicens25 = _formData$tradeLicens24.owners) === null || _formData$tradeLicens25 === void 0 ? void 0 : (_formData$tradeLicens26 = _formData$tradeLicens25[0]) === null || _formData$tradeLicens26 === void 0 ? void 0 : _formData$tradeLicens26.qualification),
    data: SortingAlphabatically(qualificationTypeList.filter(e => e.type === registrationType)),
    maxLength: 50,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens27 = formData.tradeLicenseDetail) === null || _formData$tradeLicens27 === void 0 ? void 0 : (_formData$tradeLicens28 = _formData$tradeLicens27.owners) === null || _formData$tradeLicens28 === void 0 ? void 0 : (_formData$tradeLicens29 = _formData$tradeLicens28[0]) === null || _formData$tradeLicens29 === void 0 ? void 0 : _formData$tradeLicens29.qualification,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Aadhaar Number",
    control: control,
    placeholder: "Enter Aadhaar Number",
    name: "tradeLicenseDetail.owners.[0].aadhaarNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens30 = formData.tradeLicenseDetail) === null || _formData$tradeLicens30 === void 0 ? void 0 : (_formData$tradeLicens31 = _formData$tradeLicens30.owners) === null || _formData$tradeLicens31 === void 0 ? void 0 : (_formData$tradeLicens32 = _formData$tradeLicens31[0]) === null || _formData$tradeLicens32 === void 0 ? void 0 : _formData$tradeLicens32.aadhaarNumber,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens33 = formData.tradeLicenseDetail) === null || _formData$tradeLicens33 === void 0 ? void 0 : (_formData$tradeLicens34 = _formData$tradeLicens33.owners) === null || _formData$tradeLicens34 === void 0 ? void 0 : (_formData$tradeLicens35 = _formData$tradeLicens34[0]) === null || _formData$tradeLicens35 === void 0 ? void 0 : _formData$tradeLicens35.aadhaarNumber),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_FIRM_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_FIRM_NAME"),
    name: "tradeLicenseDetail.owners.[0].firmName",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens36 = formData.tradeLicenseDetail) === null || _formData$tradeLicens36 === void 0 ? void 0 : (_formData$tradeLicens37 = _formData$tradeLicens36.owners) === null || _formData$tradeLicens37 === void 0 ? void 0 : (_formData$tradeLicens38 = _formData$tradeLicens37[0]) === null || _formData$tradeLicens38 === void 0 ? void 0 : _formData$tradeLicens38.firmName,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens39 = formData.tradeLicenseDetail) === null || _formData$tradeLicens39 === void 0 ? void 0 : (_formData$tradeLicens40 = _formData$tradeLicens39.owners) === null || _formData$tradeLicens40 === void 0 ? void 0 : (_formData$tradeLicens41 = _formData$tradeLicens40[0]) === null || _formData$tradeLicens41 === void 0 ? void 0 : _formData$tradeLicens41.firmName),
    maxLength: 50,
    height: 40,
    type: "textInput",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("NonSpecialCharsOnly"),
        message: "Please enter valid Characters"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_DATE_OF_BIRTH"),
    mandatory: true,
    control: control,
    placeholder: "Select Date",
    name: "tradeLicenseDetail.owners.[0].dateOfBirth",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens42 = formData.tradeLicenseDetail) === null || _formData$tradeLicens42 === void 0 ? void 0 : (_formData$tradeLicens43 = _formData$tradeLicens42.owners) === null || _formData$tradeLicens43 === void 0 ? void 0 : (_formData$tradeLicens44 = _formData$tradeLicens43[0]) === null || _formData$tradeLicens44 === void 0 ? void 0 : _formData$tradeLicens44.dateOfBirth,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens45 = formData.tradeLicenseDetail) === null || _formData$tradeLicens45 === void 0 ? void 0 : (_formData$tradeLicens46 = _formData$tradeLicens45.owners) === null || _formData$tradeLicens46 === void 0 ? void 0 : (_formData$tradeLicens47 = _formData$tradeLicens46[0]) === null || _formData$tradeLicens47 === void 0 ? void 0 : _formData$tradeLicens47.dateOfBirth),
    type: "datePicker",
    maxDate: eighteenYearsAgo,
    disableFuture: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Date"),
        message: "Please enter valid date"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_PAN_NUMBER"),
    control: control,
    placeholder: `${t("LABEL_ENTER_PAN_CARD_NO")}`,
    type: "textInput",
    name: "tradeLicenseDetail.owners.[0].pan",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens48 = formData.tradeLicenseDetail) === null || _formData$tradeLicens48 === void 0 ? void 0 : (_formData$tradeLicens49 = _formData$tradeLicens48.owners) === null || _formData$tradeLicens49 === void 0 ? void 0 : (_formData$tradeLicens50 = _formData$tradeLicens49[0]) === null || _formData$tradeLicens50 === void 0 ? void 0 : _formData$tradeLicens50.pan,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens51 = formData.tradeLicenseDetail) === null || _formData$tradeLicens51 === void 0 ? void 0 : (_formData$tradeLicens52 = _formData$tradeLicens51.owners) === null || _formData$tradeLicens52 === void 0 ? void 0 : (_formData$tradeLicens53 = _formData$tradeLicens52[0]) === null || _formData$tradeLicens53 === void 0 ? void 0 : _formData$tradeLicens53.pan),
    maxLength: 10,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("PAN"),
        message: "Please enter valid PAN NO"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_NATIONALITY"),
    control: control,
    placeholder: t("LABEL_ENTER_NATIONALITY"),
    name: "tradeLicenseDetail.owners.[0].nationality",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens54 = formData.tradeLicenseDetail) === null || _formData$tradeLicens54 === void 0 ? void 0 : (_formData$tradeLicens55 = _formData$tradeLicens54.owners) === null || _formData$tradeLicens55 === void 0 ? void 0 : (_formData$tradeLicens56 = _formData$tradeLicens55[0]) === null || _formData$tradeLicens56 === void 0 ? void 0 : _formData$tradeLicens56.nationality) || "Indian",
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens57 = formData.tradeLicenseDetail) === null || _formData$tradeLicens57 === void 0 ? void 0 : (_formData$tradeLicens58 = _formData$tradeLicens57.owners) === null || _formData$tradeLicens58 === void 0 ? void 0 : (_formData$tradeLicens59 = _formData$tradeLicens58[0]) === null || _formData$tradeLicens59 === void 0 ? void 0 : _formData$tradeLicens59.nationality),
    maxLength: 50,
    type: "textInput",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Nationality"),
        message: "Please enter valid Nationality"
      }
    }
  })))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    isDleteBtn: true,
    error: showToast.key,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const SubStep3$6 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isReapply
}) => {
  var _formData$tradeLicens5, _formData$tradeLicens6, _formData$tradeLicens7, _formData$tradeLicens8, _formData$tradeLicens9, _formData$tradeLicens10, _formData$tradeLicens11, _formData$tradeLicens12, _formData$tradeLicens13, _formData$tradeLicens14, _formData$tradeLicens15, _formData$tradeLicens16, _formData$tradeLicens17, _formData$tradeLicens18, _formData$tradeLicens19, _formData$tradeLicens20, _formData$tradeLicens21, _formData$tradeLicens22, _formData$tradeLicens23, _formData$tradeLicens24, _formData$tradeLicens25, _formData$tradeLicens26, _formData$tradeLicens27, _formData$tradeLicens28, _formData$tradeLicens29, _formData$tradeLicens30, _formData$tradeLicens31, _formData$tradeLicens32, _formData$tradeLicens33, _formData$tradeLicens34, _formData$tradeLicens35, _formData$tradeLicens36, _formData$tradeLicens37, _formData$tradeLicens38, _formData$tradeLicens39, _formData$tradeLicens40, _formData$tradeLicens41, _formData$tradeLicens42, _formData$tradeLicens43, _formData$tradeLicens44, _formData$tradeLicens45, _formData$tradeLicens46, _formData$tradeLicens47, _formData$tradeLicens48, _formData$tradeLicens49, _formData$tradeLicens50;
  const {
    t
  } = useTranslation();
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    control
  } = useForm({
    defaultValues
  });
  const watchState = watch("tradeLicenseDetail.owners.[0].permanentAddress.state");
  const onSubmit = data => {
    var _data$tradeLicenseDet, _data$tradeLicenseDet2, _data$tradeLicenseDet3, _data$tradeLicenseDet4, _data$tradeLicenseDet5, _data$tradeLicenseDet6, _data$tradeLicenseDet7, _data$tradeLicenseDet8, _data$tradeLicenseDet9, _data$tradeLicenseDet10, _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens4;
    data.tradeLicenseDetail.owners[0].permanentAddress = {
      ...(data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet = data.tradeLicenseDetail) === null || _data$tradeLicenseDet === void 0 ? void 0 : (_data$tradeLicenseDet2 = _data$tradeLicenseDet.owners) === null || _data$tradeLicenseDet2 === void 0 ? void 0 : (_data$tradeLicenseDet3 = _data$tradeLicenseDet2[0]) === null || _data$tradeLicenseDet3 === void 0 ? void 0 : _data$tradeLicenseDet3.permanentAddress),
      type: "PERMANENT"
    }, data.tradeLicenseDetail.owners[0].correspondenceAddress = {
      ...(data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet4 = data.tradeLicenseDetail) === null || _data$tradeLicenseDet4 === void 0 ? void 0 : (_data$tradeLicenseDet5 = _data$tradeLicenseDet4.owners) === null || _data$tradeLicenseDet5 === void 0 ? void 0 : (_data$tradeLicenseDet6 = _data$tradeLicenseDet5[0]) === null || _data$tradeLicenseDet6 === void 0 ? void 0 : _data$tradeLicenseDet6.permanentAddress),
      type: "CORRESPONDENCE"
    };
    data.tradeLicenseDetail.owners[0].dob = parseInt(data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet7 = data.tradeLicenseDetail) === null || _data$tradeLicenseDet7 === void 0 ? void 0 : (_data$tradeLicenseDet8 = _data$tradeLicenseDet7.owners) === null || _data$tradeLicenseDet8 === void 0 ? void 0 : (_data$tradeLicenseDet9 = _data$tradeLicenseDet8[0]) === null || _data$tradeLicenseDet9 === void 0 ? void 0 : (_data$tradeLicenseDet10 = _data$tradeLicenseDet9.dateOfBirth) === null || _data$tradeLicenseDet10 === void 0 ? void 0 : _data$tradeLicenseDet10.replace(/-/g, "")) || parseInt(formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.owners) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2[0]) === null || _formData$tradeLicens3 === void 0 ? void 0 : (_formData$tradeLicens4 = _formData$tradeLicens3.dateOfBirth) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.replace(/-/g, ""));
    handleSubTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_CONTACT_INFORMATION"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "tradeLicenseDetail.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5.owners) === null || _formData$tradeLicens6 === void 0 ? void 0 : (_formData$tradeLicens7 = _formData$tradeLicens6[0]) === null || _formData$tradeLicens7 === void 0 ? void 0 : _formData$tradeLicens7.mobileNumber,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens8 = formData.tradeLicenseDetail.owners) === null || _formData$tradeLicens8 === void 0 ? void 0 : (_formData$tradeLicens9 = _formData$tradeLicens8[0]) === null || _formData$tradeLicens9 === void 0 ? void 0 : _formData$tradeLicens9.mobileNumber) || isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens10 = formData.tradeLicenseDetail) === null || _formData$tradeLicens10 === void 0 ? void 0 : (_formData$tradeLicens11 = _formData$tradeLicens10.owners) === null || _formData$tradeLicens11 === void 0 ? void 0 : (_formData$tradeLicens12 = _formData$tradeLicens11[0]) === null || _formData$tradeLicens12 === void 0 ? void 0 : _formData$tradeLicens12.mobileNumber),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("Select State"),
    name: "tradeLicenseDetail.owners.[0].permanentAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens13 = formData.tradeLicenseDetail) === null || _formData$tradeLicens13 === void 0 ? void 0 : (_formData$tradeLicens14 = _formData$tradeLicens13.owners) === null || _formData$tradeLicens14 === void 0 ? void 0 : (_formData$tradeLicens15 = _formData$tradeLicens14[0]) === null || _formData$tradeLicens15 === void 0 ? void 0 : (_formData$tradeLicens16 = _formData$tradeLicens15.permanentAddress) === null || _formData$tradeLicens16 === void 0 ? void 0 : _formData$tradeLicens16.state,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens17 = formData.tradeLicenseDetail) === null || _formData$tradeLicens17 === void 0 ? void 0 : (_formData$tradeLicens18 = _formData$tradeLicens17.owners) === null || _formData$tradeLicens18 === void 0 ? void 0 : (_formData$tradeLicens19 = _formData$tradeLicens18[0]) === null || _formData$tradeLicens19 === void 0 ? void 0 : (_formData$tradeLicens20 = _formData$tradeLicens19.permanentAddress) === null || _formData$tradeLicens20 === void 0 ? void 0 : _formData$tradeLicens20.state),
    type: "searchSelect",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_DISTRICT"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_DISTRICT"),
    name: "tradeLicenseDetail.owners.[0].permanentAddress.district",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens21 = formData.tradeLicenseDetail) === null || _formData$tradeLicens21 === void 0 ? void 0 : (_formData$tradeLicens22 = _formData$tradeLicens21.owners) === null || _formData$tradeLicens22 === void 0 ? void 0 : (_formData$tradeLicens23 = _formData$tradeLicens22[0]) === null || _formData$tradeLicens23 === void 0 ? void 0 : (_formData$tradeLicens24 = _formData$tradeLicens23.permanentAddress) === null || _formData$tradeLicens24 === void 0 ? void 0 : _formData$tradeLicens24.district,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens25 = formData.tradeLicenseDetail) === null || _formData$tradeLicens25 === void 0 ? void 0 : (_formData$tradeLicens26 = _formData$tradeLicens25.owners) === null || _formData$tradeLicens26 === void 0 ? void 0 : (_formData$tradeLicens27 = _formData$tradeLicens26[0]) === null || _formData$tradeLicens27 === void 0 ? void 0 : (_formData$tradeLicens28 = _formData$tradeLicens27.permanentAddress) === null || _formData$tradeLicens28 === void 0 ? void 0 : _formData$tradeLicens28.district),
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "tradeLicenseDetail.owners.[0].permanentAddress.pinNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens29 = formData.tradeLicenseDetail) === null || _formData$tradeLicens29 === void 0 ? void 0 : (_formData$tradeLicens30 = _formData$tradeLicens29.owners) === null || _formData$tradeLicens30 === void 0 ? void 0 : (_formData$tradeLicens31 = _formData$tradeLicens30[0]) === null || _formData$tradeLicens31 === void 0 ? void 0 : (_formData$tradeLicens32 = _formData$tradeLicens31.permanentAddress) === null || _formData$tradeLicens32 === void 0 ? void 0 : _formData$tradeLicens32.pinNo,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens33 = formData.tradeLicenseDetail) === null || _formData$tradeLicens33 === void 0 ? void 0 : (_formData$tradeLicens34 = _formData$tradeLicens33.owners) === null || _formData$tradeLicens34 === void 0 ? void 0 : (_formData$tradeLicens35 = _formData$tradeLicens34[0]) === null || _formData$tradeLicens35 === void 0 ? void 0 : (_formData$tradeLicens36 = _formData$tradeLicens35.permanentAddress) === null || _formData$tradeLicens36 === void 0 ? void 0 : _formData$tradeLicens36.pinNo),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "tradeLicenseDetail.owners.[0].permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens37 = formData.tradeLicenseDetail) === null || _formData$tradeLicens37 === void 0 ? void 0 : (_formData$tradeLicens38 = _formData$tradeLicens37.owners) === null || _formData$tradeLicens38 === void 0 ? void 0 : (_formData$tradeLicens39 = _formData$tradeLicens38[0]) === null || _formData$tradeLicens39 === void 0 ? void 0 : (_formData$tradeLicens40 = _formData$tradeLicens39.permanentAddress) === null || _formData$tradeLicens40 === void 0 ? void 0 : _formData$tradeLicens40.address,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens41 = formData.tradeLicenseDetail) === null || _formData$tradeLicens41 === void 0 ? void 0 : (_formData$tradeLicens42 = _formData$tradeLicens41.owners) === null || _formData$tradeLicens42 === void 0 ? void 0 : (_formData$tradeLicens43 = _formData$tradeLicens42[0]) === null || _formData$tradeLicens43 === void 0 ? void 0 : (_formData$tradeLicens44 = _formData$tradeLicens43.permanentAddress) === null || _formData$tradeLicens44 === void 0 ? void 0 : _formData$tradeLicens44.address),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 2000
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Email ID",
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "tradeLicenseDetail.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens45 = formData.tradeLicenseDetail) === null || _formData$tradeLicens45 === void 0 ? void 0 : (_formData$tradeLicens46 = _formData$tradeLicens45.owners) === null || _formData$tradeLicens46 === void 0 ? void 0 : (_formData$tradeLicens47 = _formData$tradeLicens46[0]) === null || _formData$tradeLicens47 === void 0 ? void 0 : _formData$tradeLicens47.emailId,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens48 = formData.tradeLicenseDetail) === null || _formData$tradeLicens48 === void 0 ? void 0 : (_formData$tradeLicens49 = _formData$tradeLicens48.owners) === null || _formData$tradeLicens49 === void 0 ? void 0 : (_formData$tradeLicens50 = _formData$tradeLicens49[0]) === null || _formData$tradeLicens50 === void 0 ? void 0 : _formData$tradeLicens50.emailId),
    type: "textInput",
    mandatory: true,
    maxLength: 64,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const TLService = {
  create: (details, tenantId) => Request$1({
    url: Urls.tl.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  search: details => Request$1({
    url: Urls.tl.search,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: details,
    auth: true
  }),
  search_bill: ({
    tenantId,
    filters
  }) => Request$1({
    url: filters.businesService !== "PT" ? Urls.mcollect.search_bill : Urls.mcollect.search_bill_pt,
    useCache: false,
    method: "POST",
    data: {
      searchCriteria: {
        tenantId,
        ...filters
      }
    },
    auth: true,
    userService: false
  }),
  TLsearch: ({
    tenantId,
    filters
  }) => Request$1({
    url: Urls.tl.search,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }),
  update: (details, tenantId) => Request$1({
    url: Urls.tl.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  billingslab: ({
    tenantId,
    filters,
    auth
  }) => Request$1({
    url: Urls.tl.billingslab,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {
      tenantId
    },
    auth: true
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request$1({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  workflowEsclate: () => Request$1({
    url: Urls.tl.workflowEsclate,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    auth: true
  }),
  coaValidate: (details, tenantId) => Request$1({
    url: Urls.tl.coaValidate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  misReportRegistration: (tenantId, params) => Request$1({
    url: Urls.tl.misReportRegistration,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  })
};

const SubStep4$5 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  setShowToast,
  showToast,
  isReapply,
  officesList
}) => {
  var _formData$tradeLicens, _formData$tradeLicens2, _formData$tradeLicens3, _formData$tradeLicens10, _formData$tradeLicens11, _formData$tradeLicens12, _formData$tradeLicens13, _formData$tradeLicens14, _formData$tradeLicens15;
  const {
    t
  } = useTranslation();
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const tradeType = (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : (_formData$tradeLicens2 = _formData$tradeLicens.tradeUnits) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2[0]) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.tradeType) === "ARCHITECT.CLASSA";
  const updistricts = isDistrictDataLoading ? [] : districtData.map(district => ({
    label: district.name,
    value: district.name,
    name: district.name
  }));
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  const watchRegistrationType = formData === null || formData === void 0 ? void 0 : formData.registrationType;
  const watchVerifyingAuthority = watch("authorityName");
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(() => setShowToast(null), 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const checkCOAValidate = async applicationData => {
    var _applicationData$trad, _applicationData$trad2, _applicationData$trad3;
    const licenses = [{
      tenantId: applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId,
      id: applicationData === null || applicationData === void 0 ? void 0 : applicationData.id,
      tradeLicenseDetail: {
        owners: [{
          architectureNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$trad = applicationData.tradeLicenseDetail) === null || _applicationData$trad === void 0 ? void 0 : (_applicationData$trad2 = _applicationData$trad.owners) === null || _applicationData$trad2 === void 0 ? void 0 : (_applicationData$trad3 = _applicationData$trad2[0]) === null || _applicationData$trad3 === void 0 ? void 0 : _applicationData$trad3.architectureNo
        }]
      }
    }];
    try {
      const response = await TLService.coaValidate({
        licenses
      });
      if ((response === null || response === void 0 ? void 0 : response.message) === "Certificate number not exists.") {
        return true;
      }
      return false;
    } catch (error) {
      setShowToast({
        error: true,
        message: `Certificate No. already exsist`
      });
      throw new Error(error);
    }
  };
  const onSubmit = async data => {
    try {
      var _formData$tradeLicens4, _formData$tradeLicens5, _formData$tradeLicens6, _formData$tradeLicens7, _formData$tradeLicens8, _formData$tradeLicens9, _data$tradeLicenseDet, _data$tradeLicenseDet2, _data$tradeLicenseDet3;
      const isAlready = formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens4 = formData.tradeLicenseDetail) === null || _formData$tradeLicens4 === void 0 ? void 0 : (_formData$tradeLicens5 = _formData$tradeLicens4.owners) === null || _formData$tradeLicens5 === void 0 ? void 0 : (_formData$tradeLicens6 = _formData$tradeLicens5[0]) === null || _formData$tradeLicens6 === void 0 ? void 0 : _formData$tradeLicens6.architectureNo;
      const isNotChanging = (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens7 = formData.tradeLicenseDetail) === null || _formData$tradeLicens7 === void 0 ? void 0 : (_formData$tradeLicens8 = _formData$tradeLicens7.owners) === null || _formData$tradeLicens8 === void 0 ? void 0 : (_formData$tradeLicens9 = _formData$tradeLicens8[0]) === null || _formData$tradeLicens9 === void 0 ? void 0 : _formData$tradeLicens9.architectureNo) === (data === null || data === void 0 ? void 0 : (_data$tradeLicenseDet = data.tradeLicenseDetail) === null || _data$tradeLicenseDet === void 0 ? void 0 : (_data$tradeLicenseDet2 = _data$tradeLicenseDet.owners) === null || _data$tradeLicenseDet2 === void 0 ? void 0 : (_data$tradeLicenseDet3 = _data$tradeLicenseDet2[0]) === null || _data$tradeLicenseDet3 === void 0 ? void 0 : _data$tradeLicenseDet3.architectureNo);
      const isUnique = isAlready && isNotChanging ? true : await checkCOAValidate(data);
      if (isUnique) {
        handleSubTabChange(4, data);
      } else {
        setShowToast({
          error: true,
          message: `Certificate No. already exsist`
        });
      }
    } catch (error) {
      throw new Error(error);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_REGISTRATION_DETAILS"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(typeOfIdProof),
    label: "ID Proof Type",
    placeholder: t("LABEL_SELECT_ID"),
    name: "idProofType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.idProofType,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : formData.idProofType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), !(watchRegistrationType === "Supervisor" || watchRegistrationType === "Graduate Civil Engineer") ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: watchRegistrationType === "Architect" ? t("Registration Valid Upto") : t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "validUpto",
    mandatory: tradeType,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.validUpto,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : formData.validUpto),
    disablePast: true,
    validation: {
      required: {
        value: watchRegistrationType === "Architect",
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: watchRegistrationType === "Architect" ? "COA Registration No." : watchRegistrationType === "Graduate Civil Engineer" ? "IEI Registration No." : "Qualification Certificate No.",
    control: control,
    placeholder: "Enter Certificate No",
    type: "textInput",
    name: "tradeLicenseDetail.owners.[0].architectureNo",
    mandatory: watchRegistrationType !== "Supervisor",
    customLabel: "long-label",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens10 = formData.tradeLicenseDetail) === null || _formData$tradeLicens10 === void 0 ? void 0 : (_formData$tradeLicens11 = _formData$tradeLicens10.owners) === null || _formData$tradeLicens11 === void 0 ? void 0 : (_formData$tradeLicens12 = _formData$tradeLicens11[0]) === null || _formData$tradeLicens12 === void 0 ? void 0 : _formData$tradeLicens12.architectureNo,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens13 = formData.tradeLicenseDetail) === null || _formData$tradeLicens13 === void 0 ? void 0 : (_formData$tradeLicens14 = _formData$tradeLicens13.owners) === null || _formData$tradeLicens14 === void 0 ? void 0 : (_formData$tradeLicens15 = _formData$tradeLicens14[0]) === null || _formData$tradeLicens15 === void 0 ? void 0 : _formData$tradeLicens15.architectureNo),
    validation: {
      required: {
        value: watchRegistrationType !== "Supervisor",
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(officesList),
    label: t("LABEL_VERIFYING_AUTHORITY"),
    placeholder: t("LABEL_SELECT_AUTHORITY_NAME"),
    name: "authorityName",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.authorityName,
    disabled: isEmployee || isReapply && (formData === null || formData === void 0 ? void 0 : formData.authorityName),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      marginTop: "1em"
    }
  }, /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    md: 12
  }, watchVerifyingAuthority && !isEmployee && /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Documents will be verified at the selected authority ", /*#__PURE__*/React__default.createElement("span", null, "*")))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

function FileUploader$4({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  tab,
  showError,
  setShowError,
  setFile,
  maxFiles = 1,
  disabled,
  existingDocs
}) {
  var _uploadedFiles$;
  const {
    applicationDocuments
  } = useSelector(state => state.registration);
  const dispatch = useDispatch();
  const {
    addRegistrationDoc,
    removeRegistrationDoc
  } = bindActionCreators(registration, dispatch);
  const {
    control
  } = useForm();
  const fileInputRef = useRef();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const uploadedFiles = (applicationDocuments === null || applicationDocuments === void 0 ? void 0 : applicationDocuments.filter(doc => doc.documentType === name)) || [];
  const isAccepted = (uploadedFiles === null || uploadedFiles === void 0 ? void 0 : (_uploadedFiles$ = uploadedFiles[0]) === null || _uploadedFiles$ === void 0 ? void 0 : _uploadedFiles$.documentStatus) === "Accepted";
  const handleFileUpload = async (e, inputName) => {
    const file = e.target.files[0];
    setIsLoading(true);
    setShowToast(null);
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    if ((applicationDocuments === null || applicationDocuments === void 0 ? void 0 : applicationDocuments.filter(doc => doc.documentType === name).length) >= maxFiles) {
      setShowToast({
        error: true,
        label: `You can upload a maximum of ${maxFiles} file(s).`
      });
      setIsLoading(false);
      return;
    }
    const invalidMalwareExtensions = ["php", "php3", "php4", "php5", "phtml", "asp", "aspx", "jsp", "jspx", "cfm", "exe", "bat", "cmd", "sh", "com", "scr", "msi", "jar", "vbs", "ps1", "dll", "docm", "xlsm", "pptm", "dotm", "xltm", "html", "htm", "js", "xml", "svg", "zip", "rar", "7z", "tar", "gz", "iso"];
    const fileParts = file.name.toLowerCase().split(".");
    const intermediateParts = fileParts.slice(0, -1);
    const hasMaliciousExtension = intermediateParts.some(part => invalidMalwareExtensions.includes(part));
    const fileExtension = file.name.split(".").pop();
    const ext = `.${fileExtension}`;
    let allowedFormats = [".pdf", ".PDF"];
    let maxSizeInBytes = 30 * 1024 * 1024;
    if (tab === 1) {
      allowedFormats = [".png", ".jpg", ".jpeg", ".JPG", ".PNG", ".JPEG"];
      maxSizeInBytes = 10 * 1024 * 1024;
    } else if (tab === 3 || tab === 5) {
      allowedFormats = [".dxf", ".DXF"];
      maxSizeInBytes = 60 * 1024 * 1024;
    }
    if (hasMaliciousExtension) {
      setShowToast({
        error: true,
        label: "Invalid file name: contains potentially dangerous extensions."
      });
      setIsLoading(false);
      return;
    }
    if (!allowedFormats.includes(ext)) {
      setShowToast({
        error: true,
        label: `Invalid format. Allowed: ${allowedFormats.join(", ")}`
      });
      setIsLoading(false);
      return;
    }
    if (file.size > maxSizeInBytes) {
      setShowToast({
        error: true,
        label: `File size exceeds ${maxSizeInBytes / (1024 * 1024)} MB limit.`
      });
      setIsLoading(false);
      return;
    }
    if (tab === 3 || tab === 5) {
      setFile === null || setFile === void 0 ? void 0 : setFile(file);
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      const existingDoc = existingDocs === null || existingDocs === void 0 ? void 0 : existingDocs.find(doc => doc.documentType === inputName);
      console.log(existingDoc, applicationDocuments, inputName, "exsistingDoc");
      addRegistrationDoc({
        id: existingDoc === null || existingDoc === void 0 ? void 0 : existingDoc.id,
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        isMandatory,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
      e.target.value = null;
    } catch (err) {
      console.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  const uploadedDocs = (applicationDocuments === null || applicationDocuments === void 0 ? void 0 : applicationDocuments.filter(doc => doc.documentType === name)) || [];
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: "flex-start"
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flexDirection: "column",
      position: "relative",
      width: "100%",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true,
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    component: "span",
    onClick: () => fileInputRef.current.click(),
    sx: {
      width: "100%",
      mb: 1,
      display: "flex",
      justifyContent: "space-between",
      height: "30px",
      backgroundColor: "#157cb3",
      color: "white",
      "&:hover": {
        backgroundColor: "#004e6c"
      }
    },
    disabled: uploadedDocs.length >= maxFiles
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: "center",
      position: "absolute",
      alignItems: "center",
      display: "flex",
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#ffffff"
    },
    size: 28
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, null), /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: "absolute",
      fontSize: "0.5rem",
      marginLeft: "8em"
    }
  }, validationMsg))), /*#__PURE__*/React__default.createElement(Controller, {
    name: "fileInput",
    control: control,
    rules: {
      required: required && uploadedDocs.length === 0
    },
    render: ({
      field
    }) => /*#__PURE__*/React__default.createElement("input", Object.assign({}, field, {
      ref: fileInputRef,
      type: "file",
      name: name,
      style: {
        display: "none"
      },
      onChange: e => handleFileUpload(e, name),
      disabled: disabled || isAccepted
    }))
  })))), uploadedDocs.map(doc => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: "space-between",
        p: "0.25rem 0 0.25rem 0.75rem",
        backgroundColor: "#eee",
        borderRadius: "0.25rem",
        wordBreak: "break-all",
        alignItems: "center",
        display: "flex",
        lineHeight: 1,
        flex: 1,
        mb: 0.5,
        mt: 1,
        height: "18px",
        fontSize: "0.6rem"
      },
      key: doc.fileStoreId,
      className: "file-wrapper-name"
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 20
    }) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      sx: {
        fontSize: "1rem"
      },
      onClick: () => removeRegistrationDoc(doc.documentType),
      disabled: (doc === null || doc === void 0 ? void 0 : doc.documentStatus) === "Accepted"
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  }), required && showError && uploadedDocs.length === 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, `${hasLabel ? label : "Above"} document is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label));
}

const Step5$1 = ({
  formData,
  handleTabChange,
  handleSubTabChange,
  tradeType,
  isReapply,
  initRegistrationDocs
}) => {
  var _formData$tradeLicens5, _formData$tradeLicens6, _formData$tradeLicens7, _formData$tradeLicens8, _formData$tradeLicens9, _formData$tradeLicens10;
  const {
    t
  } = useTranslation();
  const {
    applicationDocuments
  } = useSelector(state => state.registration);
  const [showError, setShowError] = useState(false);
  const watchRegistrationType = formData === null || formData === void 0 ? void 0 : formData.registrationType;
  console.log(formData, "formDatainStep5");
  console.log("applicationDocumentsFromTL", applicationDocuments);
  const validateFiles = () => {
    const uploadedDocs = new Set(applicationDocuments === null || applicationDocuments === void 0 ? void 0 : applicationDocuments.map(doc => doc.documentType));
    const requiredDocs = ["applicantPhoto", "Id Proof", "Registration Certificate", "Qualification Certificate"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    var _formData$tradeLicens;
    if (!(formData !== null && formData !== void 0 && (_formData$tradeLicens = formData.tradeLicenseDetail) !== null && _formData$tradeLicens !== void 0 && _formData$tradeLicens.applicationDocuments)) {
      setValue("tradeLicenseDetail.applicationDocuments", applicationDocuments);
    }
  }, [applicationDocuments]);
  useEffect(() => {
    var _formData$tradeLicens2, _formData$tradeLicens3;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens2 = formData.tradeLicenseDetail) === null || _formData$tradeLicens2 === void 0 ? void 0 : (_formData$tradeLicens3 = _formData$tradeLicens2.applicationDocuments) === null || _formData$tradeLicens3 === void 0 ? void 0 : _formData$tradeLicens3.length) > 0) {
      var _formData$tradeLicens4;
      initRegistrationDocs(formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens4 = formData.tradeLicenseDetail) === null || _formData$tradeLicens4 === void 0 ? void 0 : _formData$tradeLicens4.applicationDocuments);
    }
  }, [formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens5 = formData.tradeLicenseDetail) === null || _formData$tradeLicens5 === void 0 ? void 0 : _formData$tradeLicens5.applicationDocuments]);
  useEffect(() => {
    if ((applicationDocuments === null || applicationDocuments === void 0 ? void 0 : applicationDocuments.length) >= 0) {
      setValue("tradeLicenseDetail.applicationDocuments", applicationDocuments);
    }
  }, [applicationDocuments, setValue]);
  const onSubmit = data => {
    handleSubTabChange(5, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_DOCUMENT_DETAILS"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form self-certified custom-upload new-custom-uploader",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$4, {
    label: t("LABEL_PHOTO"),
    control: control,
    name: "applicantPhoto",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: true,
    isMandatory: true,
    showError: showError,
    tab: 1,
    existingDocs: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens6 = formData.tradeLicenseDetail) === null || _formData$tradeLicens6 === void 0 ? void 0 : _formData$tradeLicens6.applicationDocuments
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$4, {
    label: "ID Proof Attachment",
    control: control,
    name: "Id Proof",
    isMandatory: true,
    showError: showError,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    existingDocs: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens7 = formData.tradeLicenseDetail) === null || _formData$tradeLicens7 === void 0 ? void 0 : _formData$tradeLicens7.applicationDocuments
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$4, {
    label: "COA/IEI Registration Certificate",
    control: control,
    name: "Registration Certificate",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    isMandatory: watchRegistrationType !== "Supervisor",
    showError: showError,
    required: true,
    existingDocs: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens8 = formData.tradeLicenseDetail) === null || _formData$tradeLicens8 === void 0 ? void 0 : _formData$tradeLicens8.applicationDocuments
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$4, {
    label: t("LABEL_EXPERIENCE_CERTIFICATE"),
    control: control,
    name: "Experience Certificate",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    existingDocs: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens9 = formData.tradeLicenseDetail) === null || _formData$tradeLicens9 === void 0 ? void 0 : _formData$tradeLicens9.applicationDocuments
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$4, {
    isMandatory: true,
    label: t("LABEL_QUALIFICATION_CERTIFICATE"),
    showError: showError,
    control: control,
    name: "Qualification Certificate",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    existingDocs: formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens10 = formData.tradeLicenseDetail) === null || _formData$tradeLicens10 === void 0 ? void 0 : _formData$tradeLicens10.applicationDocuments
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(3)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const EmpLtpPortal = ({
  applicationDetails,
  workflowDetails,
  isDataLoading,
  timelineStatusPrefix,
  statusAttribute: _statusAttribute = "status"
}) => {
  var _Digit, _Digit2, _params$tradeLicenseD, _formData$tradeLicens;
  const formData = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData;
  const {
    subTabLabels,
    tradeType,
    isCitizen,
    params,
    setParams,
    clearParams,
    onSelect,
    updateApiCall,
    currentAction,
    setCurrentAction,
    developerRemarks,
    setDeveloperRemarks,
    uploadedFile,
    setUploadedFile,
    handleNoWorkflow,
    applicationDocs,
    totalAmount,
    actions,
    onDropDownSelect,
    handleSubmit,
    viewApprovalLetter,
    showTakeAction,
    iframeSrc,
    setIframeSrc,
    updatedDocuments,
    setUpdatedDocuments,
    dataRecommendationDocument,
    setDataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callDocumentDetailsAPI,
    documentRemarksData,
    setValidUpto,
    fiveYearsFromNow
  } = useEmpLTP(formData, workflowDetails);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [currentView, setCurrentView] = useState("documents");
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState(false);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("REGISTRATION_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("REGISTRATION_CURRENT_SUBTAB")) || 0);
  const defaultValues = {
    validupto: (formData === null || formData === void 0 ? void 0 : formData.validupto) || ""
  };
  const {
    control,
    getValues,
    watch
  } = useForm({
    defaultValues
  });
  const {
    t
  } = useTranslation();
  const validUpTo = watch("validupto");
  const attachedDocs = (params === null || params === void 0 ? void 0 : (_params$tradeLicenseD = params.tradeLicenseDetail) === null || _params$tradeLicenseD === void 0 ? void 0 : _params$tradeLicenseD.applicationDocuments) || (formData === null || formData === void 0 ? void 0 : (_formData$tradeLicens = formData.tradeLicenseDetail) === null || _formData$tradeLicens === void 0 ? void 0 : _formData$tradeLicens.applicationDocuments);
  console.log("loggingLTPDataaaa", formData, attachedDocs);
  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("REGISTRATION_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
  };
  const handleDocView = () => {
    setCurrentView(prev => prev === "documents" ? "viewDocuments" : "documents");
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$9, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$4, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$6, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$5, {
            formData: formData,
            handleSubTabChange: handleSubTabChange,
            isEmployee: !isCitizen
          });
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement("div", {
        className: "view-doc-container"
      }, /*#__PURE__*/React__default.createElement(Button$2, {
        variant: "contained",
        className: "view-doc-btn",
        onClick: handleDocView,
        style: {
          backgroundColor: "#157C4F",
          borderRadius: "15px",
          padding: "5px 10px"
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "view-doc-icon"
      }, /*#__PURE__*/React__default.createElement(ViewSidebarIcon, null)), currentView === "documents" ? "View all documents" : "View document section")), currentView === "documents" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DocumentSection, {
        formData: params,
        handleChange: handleTabChange,
        setUpdatedDocuments: setUpdatedDocuments,
        updatedDocuments: updatedDocuments,
        setIsPreviewLoading: setIsPreviewLoading,
        setDataRecommendation: setDataRecommendationDocument,
        onSelect: onSelect,
        handleNoWorkflow: handleNoWorkflow,
        attachedDocs: attachedDocs,
        docType: "mandatory",
        detailData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks,
        developerRemarks: developerRemarksDocument,
        setError: setError,
        setDeveloperRemarks: setDeveloperRemarksDocument,
        callDocumentDetailsAPI: callDocumentDetailsAPI,
        ComposableComponent: props => /*#__PURE__*/React__default.createElement(RecommendationRemarksComponent, Object.assign({
          title: "Recommendation Details",
          label: "Recommendation",
          name: "recommendation",
          options: siteInspRecommendation,
          defaultValue: dataRecommendationDocument,
          extraLabel: "Remarks",
          setDeveloperRemarks: setDeveloperRemarksDocument,
          developerRemarks: developerRemarksDocument,
          setDataRecommendation: setDataRecommendationDocument,
          error: error,
          setError: setError
        }, props))
      }), !isCitizen && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(DocumentSectionLog, {
        logData: documentRemarksData === null || documentRemarksData === void 0 ? void 0 : documentRemarksData.DetailDataRemarks
      })), " ") : /*#__PURE__*/React__default.createElement(ViewDocuments, {
        documentSection: attachedDocs,
        setIsPreviewLoading: setIsPreviewLoading,
        iframeSrc: iframeSrc,
        setIframeSrc: setIframeSrc
      }));
    } else if (activeTab === 1 && isCitizen) {
      {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Architect$2, {
          formData: formData,
          applicationDocs: applicationDocs,
          totalAmount: totalAmount,
          actions: actions
        }), ((formData === null || formData === void 0 ? void 0 : formData.status) === "APPROVED" || showTakeAction === "Take_Action") && /*#__PURE__*/React__default.createElement("div", {
          style: {
            marginLeft: "180px",
            marginTop: "20px"
          }
        }, /*#__PURE__*/React__default.createElement(Button$2, {
          variant: "contained",
          color: "success",
          style: {
            marginLeft: "10px"
          },
          onClick: () => viewApprovalLetter(formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl)
        }, "View Approval Letter")));
      }
    } else if (activeTab === 2 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LTPCheckList, {
        formData: formData
      }));
    } else if (activeTab === 2 && isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: formData
      }));
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement(EmployeeComponent$2, {
        formData: formData,
        applicationDocs: applicationDocs
      }), (formData === null || formData === void 0 ? void 0 : formData.status) === "APPLY_FOR_DSC" && /*#__PURE__*/React__default.createElement(DscLetters, {
        formData: formData,
        handleChange: handleTabChange,
        isEmployee: !isCitizen,
        viewDrawing: false,
        pdfType: "LTP"
      }), (formData === null || formData === void 0 ? void 0 : formData.status) !== "APPROVED" && /*#__PURE__*/React__default.createElement("div", {
        className: "valid-upto-input-container"
      }, " ", /*#__PURE__*/React__default.createElement(OnSelectActionDropdown, {
        currentAction: currentAction || " ",
        onChange: onDropDownSelect,
        actions: actions,
        formData: formData
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "valid-upto-input"
      }, "Valid Up To *", /*#__PURE__*/React__default.createElement(InputWrapper, {
        hasLabel: false,
        mandatory: true,
        control: control,
        placeholder: "Select Date",
        name: "validupto",
        disablePast: true,
        type: "datePicker",
        maxDate: fiveYearsFromNow,
        validation: {
          required: {
            value: true,
            message: "This field is required"
          },
          pattern: {
            value: Digit.Utils.getPattern("Date"),
            message: "Please enter valid date"
          }
        }
      }))), (formData === null || formData === void 0 ? void 0 : formData.status) !== "APPROVED" && /*#__PURE__*/React__default.createElement(RemarksEditor, {
        setRemarks: setDeveloperRemarks,
        remarks: developerRemarks,
        setError: setError,
        error: error
      }), (formData === null || formData === void 0 ? void 0 : formData.status) !== "APPROVED" && /*#__PURE__*/React__default.createElement(DocUploader, {
        uploadedFile: uploadedFile,
        setUploadedFile: setUploadedFile
      }), (formData === null || formData === void 0 ? void 0 : formData.status) !== "APPROVED" && /*#__PURE__*/React__default.createElement(SubmitButton, {
        handleSubmit: handleSubmit,
        isLoading: updateApiCall.isLoading
      }));
    } else if (activeTab === 4 && !isCitizen) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data
      }));
    }
  };
  useEffect(() => {
    if (validUpTo !== undefined) setValidUpto(validUpTo);
  }, [validUpTo]);
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Technical Professional Registration")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Applicantion Form"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), !isCitizen && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Take Action"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent());
};

function ApplicationDetailsProfessionalContent({
  applicationDetails,
  isLoading,
  setOnAddComments,
  edcrDetails,
  collectionBillDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  timelineStatusPrefix,
  showTimeLine = true,
  onActionSelect,
  forcedActionPrefix,
  submitAction,
  actionData,
  moduleCode,
  businessService,
  action,
  statusAttribute = "status"
}) {
  const {
    t
  } = useTranslation();
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc");
  const isNocLocation = window.location.href.includes("employee/noc");
  const isBPALocation = window.location.href.includes("employee/obps");
  return (
    /*#__PURE__*/
    React__default.createElement(Card, {
      style: {
        position: "relative"
      }
    }, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) :
    /*#__PURE__*/
    React__default.createElement(EmpLtpPortal, {
      applicationDetails: applicationDetails,
      workflowDetails: workflowDetails,
      isDataLoading: isDataLoading,
      timelineStatusPrefix: timelineStatusPrefix,
      statusAttribute: statusAttribute
    }), !(applicationDetails !== null && applicationDetails !== void 0 && applicationDetails.documents) && /*#__PURE__*/React__default.createElement(BPADocuments, {
      t: t,
      applicationData: applicationDetails,
      docs: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.documents,
      bpaActionsDetails: workflowDetails
    }))
  );
}

const ApplicationDetailsProffessional = props => {
  var _workflowDetails$data;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const [onAddComments, setOnAddComments] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  let user = Digit.UserService.getUser();
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setWarningPopUp(true);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if ((action === null || action === void 0 ? void 0 : action.action) === 'APPROVAL_LETTER_GENERATE') {
        setShowModal(false);
        let payload = {};
        payload.BPA = applicationData;
        payload.BPA.workflow = {
          "action": "APPROVAL_LETTER_GENERATE",
          "assignes": null,
          "comments": null,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
          if (res) {
            await OBPSService.update(payload, tenantId);
            history.push({
              pathname: "/digit-ui/employee/obps/form12inbox"
            });
          } else {
            setShowToast({
              key: "error",
              error: {
                message: "Error in APPROVAL_LETTER_GENERATE"
              }
            });
          }
        } catch (error) {
          console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    var _user$info;
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
    }
    if ((user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.type) === "EMPLOYEE") {
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/employee`
        });
      }, 2000);
    } else {
      setTimeout(() => {
        history.push({
          pathname: `/digit-ui/citizen/profile`
        });
      }, 2000);
    }
    closeModal();
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsProfessionalContent, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    isLoading: isLoading,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine,
    onActionSelect: onActionSelect,
    setOnAddComments: setOnAddComments,
    forcedActionPrefix: forcedActionPrefix,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    moduleCode: moduleCode,
    action: selectedAction
  })) : /*#__PURE__*/React__default.createElement(Loader, null));
};

const ProfessionalApplicantDetail = () => {
  var _applicationDetails$p, _workflowDetails$data, _workflowDetails$data2, _applicationDetails$a3, _workflowDetails$data3, _workflowDetails$data4;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[0];
  const [showToast, setShowToast] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading,
    data: applicationDetails
  } = Digit.Hooks.obps.useLicenseDetails(tenantId, {
    applicationNumber: id
  }, {});
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useBPAREGApplicationActions();
  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPAREG"
  });
  const closeToast = () => {
    setShowToast(null);
  };
  let dowloadOptions = [];
  console.log("formData11111111", applicationDetails);
  if ((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p = applicationDetails.payments) === null || _applicationDetails$p === void 0 ? void 0 : _applicationDetails$p.length) > 0) {
    dowloadOptions.push({
      label: t("TL_RECEIPT"),
      onClick: () => {
        var _applicationDetails$p2, _applicationDetails$p3, _applicationDetails$p4, _applicationDetails$p5, _applicationDetails$a, _applicationDetails$a2;
        return downloadAndPrintReciept((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p2 = applicationDetails.payments) === null || _applicationDetails$p2 === void 0 ? void 0 : (_applicationDetails$p3 = _applicationDetails$p2[0]) === null || _applicationDetails$p3 === void 0 ? void 0 : (_applicationDetails$p4 = _applicationDetails$p3.paymentDetails) === null || _applicationDetails$p4 === void 0 ? void 0 : (_applicationDetails$p5 = _applicationDetails$p4[0]) === null || _applicationDetails$p5 === void 0 ? void 0 : _applicationDetails$p5.businessService) || "BPAREG", applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.applicationNumber, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : _applicationDetails$a2.tenantId);
      }
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-application-details"
  }), !isLoading && applicationDetails && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsProffessional, {
    applicationDetails: applicationDetails,
    isLoading: isLoading,
    isDataLoading: isLoading,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.applicationBusinessService : applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a3 = applicationDetails.applicationData) === null || _applicationDetails$a3 === void 0 ? void 0 : _applicationDetails$a3.businessService,
    moduleCode: "BPAREG",
    showToast: showToast,
    setShowToast: setShowToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    closeToast: closeToast,
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data3 = workflowDetails.data) !== null && _workflowDetails$data3 !== void 0 && _workflowDetails$data3.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.applicationBusinessService : applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.businessService}_`
  })));
};

const ApplicationFormLandUse = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowLandUseNOC, setSmShowLandUseNOC] = useState(false);
  const [page, setPage] = React__default.useState(0);
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [itemData, setItemData] = useState({});
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAction, setSelectedAction] = useState("All");
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status", "action"]);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    data = {},
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_LANDUSE",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "formLandUse"
  });
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleViewSummary = item => {
    var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name);
    setIdData(item === null || item === void 0 ? void 0 : item.applicationNo);
    if ((item === null || item === void 0 ? void 0 : item.applicationNo) != null) {
      setSmShowMs(true);
    } else {
      console.log("Application Number Null ");
    }
  };
  const handleActionChange = action => {
    setSelectedAction(action);
    setCurentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$landInfo2$owner3, _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : (_item$landInfo2$owner3 = _item$landInfo2$owner2.name) === null || _item$landInfo2$owner3 === void 0 ? void 0 : _item$landInfo2$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.LandUse) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.name) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$landInfo7$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : (_item$landInfo7$owner3 = _item$landInfo7$owner2.mobileNumber) === null || _item$landInfo7$owner3 === void 0 ? void 0 : _item$landInfo7$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name",
        style: {
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word"
        }
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-status"
      }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-receipt"
    }, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "contained",
      className: "btn-table-action",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")))
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$descriptionOfLa;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-approval"
      }, (item === null || item === void 0 ? void 0 : item.status) === "APPROVED" && (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => handleOpenLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "Letter")));
    }
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_WITH_OBSERVATION", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        const target = item !== null && item !== void 0 && item.oldCaseApplicationNo ? `/digit-ui/citizen/obps/services/oldCaseSearchLU/${item === null || item === void 0 ? void 0 : item.applicationNo}` : `/digit-ui/citizen/obps/services/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`;
        history.push(target);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => handleViewSummary(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const handleObjectionLetter = item => {
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterUrl).filter(key => key.startsWith("objection_")).sort().at(-1);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  const handleClickAction = item => {
    var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structural/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpenLetter = item => {
    if (item !== null && item !== void 0 && item.approvalLetterUrl) {
      const approvalLetterUrlLandUse = `${item === null || item === void 0 ? void 0 : item.approvalLetterUrl}`;
      window.open(approvalLetterUrlLandUse, "_blank");
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Land Use \u2013 My Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, loader ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "Loading...")) : (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [20, 50, 100, 200, 400, 1000],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: "formLandUse"
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application NOC Details",
    dataOpen: smShowLandUseNOC,
    onClose: () => {
      setSmShowLandUseNOC(false);
    }
  }, /*#__PURE__*/React__default.createElement(ViewLandUseNoc, {
    itemData: itemData
  })));
};

function FileUploader$5({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  tab
}) {
  const {
    documents
  } = useSelector(state => state.formMT);
  const dispatch = useDispatch();
  const {
    addFormMTDoc,
    removeFormMTDoc
  } = bindActionCreators(formMTDocActions, dispatch);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleFileUpload = async (file, inputName) => {
    setIsLoading(true);
    setShowToast(null);
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    if (tab === 1) {
      const allowedFormats = [".png", ".jpg", ".jpeg", ".pdf", ".JPG", ".PNG", ".JPEG", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.png, .jpg, .jpeg, .pdf)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 10 MB."
        });
        setIsLoading(false);
        return;
      }
    } else {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file in a pdf format"
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 30 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 30 MB."
        });
        setIsLoading(false);
        return;
      }
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addFormMTDoc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: 'flex-start'
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: `label`
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      p: '0.5rem 0.75rem 0.375rem',
      borderRadius: '0.25rem',
      flexDirection: 'column',
      position: 'relative',
      width: '18.25vw',
      display: 'flex'
    }
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: 'center',
      position: 'absolute',
      alignItems: 'center',
      display: 'flex',
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : null, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return handleFileUpload(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    },
    style: {
      maxWidth: '100%'
    },
    required: required && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name))
  }), /*#__PURE__*/React__default.createElement("small", {
    className: "error"
  }, validationMsg), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label), !isLoading && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: '100%',
      display: 'flex',
      mb: 0.5,
      mt: 1
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map(doc => {
    var _doc$additionalDetail;
    if (!(name in documents) && doc.documentType !== name) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: 'space-between',
        p: '0.25rem 0 0.25rem 0.75rem',
        backgroundColor: '#eee',
        borderRadius: '0.25rem',
        wordBreak: 'break-all',
        fontSize: '0.875rem',
        alignItems: 'center',
        display: 'flex',
        lineHeight: 1,
        flex: 1
      },
      key: doc.fileStoreId
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      onClick: () => removeFormMTDoc(doc.documentType)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  })) || null)));
}

const Step1$2 = ({
  formData,
  isUpdating,
  handleTabChange
}) => {
  var _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$description, _formData$description2, _formData$description3, _formData$applicant, _formData$applicant2, _formData$applicant3, _formData$applicant4, _formData$applicant5, _formData$landInfo3, _formData$landInfo3$b, _formData$landInfo4, _formData$landInfo4$b, _formData$landInfo5, _formData$landInfo5$b, _formData$landInfo6, _formData$landInfo6$b, _formData$landInfo7, _formData$landInfo7$b;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const ownerEntry = {
    name: '',
    fatherOrHusbandName: '',
    mobileNumber: '',
    emailId: '',
    aadhaarNumber: '',
    gender: null,
    correspondenceAddress: {
      applicantName: null,
      applicantGuardianName: null,
      state: "Uttar Pradesh",
      district: null,
      tehsil: null,
      town: null,
      address: "",
      pinno: "",
      type: "CORRESPONDENCE"
    },
    permanentAddress: {
      applicantName: null,
      applicantGuardianName: null,
      state: "Uttar Pradesh",
      district: null,
      tehsil: null,
      town: null,
      address: "",
      pinno: "",
      type: "PERMANENT"
    }
  };
  const propertyEntry = {
    sectorNo: null,
    propertyNo: null,
    schemeName: null,
    block: null,
    khataNo: null,
    khasraNo: null,
    khatauniNo: null,
    plotArea: 0,
    plotNo: null,
    roadWidth: null,
    appliedLandUse: {
      name: null
    },
    propertyType: {
      name: null
    },
    propertyAddress: {
      address: null,
      state: null,
      pinno: null,
      district: null
    }
  };
  const defaultValues = {
    ...formData,
    documents,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry]
    },
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      properties: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.properties : [propertyEntry]
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const watchApprovedLayout = watch('approvedLayout') === 'yes';
  const watchownerOrApplicant = watch('ownerOrApplicant') === 'Applicant';
  const morethanOneOwner = watch('morethanOneOwner') === 'yes';
  const morethanOneProperty = watch('morethanOneProperty') === 'yes';
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const {
    fields: properties,
    append: appendProp,
    remove: removeProp
  } = useFieldArray({
    control,
    name: "descriptionOfLand.properties"
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Basic Information')))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: `${t("Are You the Owner or Applicant")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant,
    name: `ownerOrApplicant`,
    type: "radioButton",
    data: ownerOrApplicant,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: `${t("Is Your Property Part of Approved Layout")}`,
    placeholder: "approvedLayout",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.approvedLayout,
    name: `approvedLayout`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: `${t("Is More than One Owner")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner,
    name: `morethanOneOwner`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: `${t("Is More than One Property")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty,
    name: `morethanOneProperty`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  })))))), watchownerOrApplicant && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_ENTER_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant = formData.applicant) === null || _formData$applicant === void 0 ? void 0 : _formData$applicant.name,
    name: "applicant.name",
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_EMAIL_ID"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant2 = formData.applicant) === null || _formData$applicant2 === void 0 ? void 0 : _formData$applicant2.emailId,
    name: `applicant.emailId`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    control: control,
    name: "authorization Letter",
    label: t("Authorization Letter"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant3 = formData.applicant) === null || _formData$applicant3 === void 0 ? void 0 : _formData$applicant3.address,
    name: `applicant.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Mobile Number(As in Aadhaar)",
    placeholder: t("LABEL_ENTER_MOBILE_NO"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant4 = formData.applicant) === null || _formData$applicant4 === void 0 ? void 0 : _formData$applicant4.mobileNumber,
    name: `applicant.mobileNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_AADHAAR_NUMBER"),
    control: control,
    placeholder: t("LABEL_ENTER_AADHAAR_NO"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant5 = formData.applicant) === null || _formData$applicant5 === void 0 ? void 0 : _formData$applicant5.aadhaarNumber,
    name: `applicant.aadhaarNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  })), /*#__PURE__*/React__default.createElement("br", null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, owners === null || owners === void 0 ? void 0 : owners.map((owner, index) => /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Owner Information") : t("Owner Information"), " "))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    key: owner.id
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_ENTER_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    defaultValue: owner.name,
    name: `landInfo.owners[${index}].name`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_GENDER"),
    placeholder: "Gender",
    defaultValue: owner.gender,
    name: `landInfo.owners[${index}].gender`,
    type: "selectInput",
    data: genderData,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_EMAIL_ID"),
    defaultValue: owner.emailId,
    name: `landInfo.owners[${index}].emailId`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    control: control,
    name: `applicantPhoto[${index}]`,
    label: t("LABEL_OWNER_PHOTO"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: owner.correspondenceAddress.address,
    name: `landInfo.owners[${index}].correspondenceAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: owner.correspondenceAddress.district,
    name: `landInfo.owners[${index}].correspondenceAddress.district`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_FATHERS_NAME"),
    placeholder: t("LABEL_ENTER_FATHERS_NAME"),
    defaultValue: owner.fatherOrHusbandName,
    name: `landInfo.owners[${index}].fatherOrHusbandName`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Mobile Number(As in Aadhaar)",
    placeholder: t("LABEL_ENTER_MOBILE_NO"),
    defaultValue: owner.mobileNumber,
    name: `landInfo.owners[${index}].mobileNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_AADHAAR_NUMBER"),
    control: control,
    placeholder: t("LABEL_ENTER_AADHAAR_NO"),
    defaultValue: owner.aadhaarNumber,
    name: `landInfo.owners[${index}].aadhaarNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    control: control,
    name: `signature[${index}]`,
    label: t("LABEL_SIGNATURE"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: owner.correspondenceAddress.state || t("LABEL_STATE_UP"),
    name: `landInfo.owners[${index}].correspondenceAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: owner.correspondenceAddress.pinno,
    name: `landInfo.owners[${index}].correspondenceAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneOwner && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendOwner(ownerEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  })), owners.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeOwner(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  })))), /*#__PURE__*/React__default.createElement("br", null)))))), !watchApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((property, index) => /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Registration Information") : t("Registration Information"), "                                    "))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_KHASRA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHASRA_NO"),
    defaultValue: property.khasraNo,
    name: `descriptionOfLand.properties[${index}].khasraNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_KHATA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHATA_NO"),
    defaultValue: property.khataNo,
    name: `descriptionOfLand.properties[${index}].khataNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Plot Area",
    control: control,
    placeholder: "Enter Plot Area",
    defaultValue: property.plotArea,
    name: `descriptionOfLand.properties[${index}].plotArea`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Land use as per master plan",
    control: control,
    placeholder: "Enter Land use as per master plan",
    defaultValue: property.appliedLandUse.name,
    name: `descriptionOfLand.properties[${index}].appliedLandUse.name`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: property.schemeName,
    name: `descriptionOfLand.properties[${index}].schemeName`,
    type: "selectInput",
    mandatory: true,
    data: schemeNameList,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: property.propertyAddress.address,
    name: `descriptionOfLand.properties[${index}].propertyAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Khatuni No.",
    control: control,
    placeholder: "Enter Khatuni No.",
    defaultValue: property.khatauniNo,
    name: `descriptionOfLand.properties[${index}].khatauniNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_PLOT_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_PLOT_NO"),
    defaultValue: property.plotNo,
    name: `descriptionOfLand.properties[${index}].plotNo`,
    type: "textInput",
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Road Width",
    control: control,
    placeholder: "Enter Road Width",
    defaultValue: property.roadWidth,
    name: `descriptionOfLand.properties[${index}].roadWidth`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: property.city,
    name: `descriptionOfLand.properties[${index}].city`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: property.propertyAddress.state || t("LABEL_STATE_UP"),
    name: `descriptionOfLand.properties[${index}].propertyAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: property.propertyAddress.pinno,
    name: `descriptionOfLand.properties[${index}].propertyAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneProperty && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendProp(propertyEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  })), owners.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeProp(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  }))))))))), watchApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((property, index) => /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Registration Information") : t("Registration Information")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Property Type",
    control: control,
    placeholder: "Select Property Type",
    defaultValue: property.propertyType.name,
    name: `descriptionOfLand.properties[${index}].propertyType.name`,
    type: "selectInput",
    mandatory: true,
    data: propertyTypeListUP,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Sector No.",
    defaultValue: property.sectorNo,
    name: `descriptionOfLand.properties[${index}].sectorNo`,
    type: "textInput",
    placeholder: "Enter Sector No.",
    mandatory: true,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Property Number",
    defaultValue: property.propertyNo,
    name: `descriptionOfLand.properties[${index}].propertyNo`,
    type: "textInput",
    placeholder: "Enter Property No.",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Plot Area(As per Allotment Letter)",
    control: control,
    placeholder: "Enter Plot Area",
    defaultValue: property.plotArea,
    name: `descriptionOfLand.properties[${index}].plotArea`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: property.propertyAddress.address,
    name: `descriptionOfLand.properties[${index}].propertyAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Property land use (as in allotment letter)",
    control: control,
    placeholder: "Enter Land use as per master plan",
    defaultValue: property.appliedLandUse.name,
    name: `descriptionOfLand.properties[${index}].appliedLandUse.name`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: property.schemeName,
    name: `descriptionOfLand.properties[${index}].schemeName`,
    type: "selectInput",
    mandatory: true,
    data: schemeNameList,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Block",
    placeholder: "Enter Block",
    defaultValue: property.block,
    name: `descriptionOfLand.properties[${index}].block`,
    type: "textInput",
    mandatory: true,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: property.city,
    name: `descriptionOfLand.properties[${index}].city`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: property.propertyAddress.state || t("LABEL_STATE_UP"),
    name: `descriptionOfLand.properties[${index}].propertyAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: property.propertyAddress.pinno,
    name: `descriptionOfLand.properties[${index}].propertyAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneProperty && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendProp(propertyEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  })), owners.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeProp(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, {
    sx: {
      width: '24px',
      height: '24px'
    }
  }))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Bank Information(In case of Refund)"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Account holder Name",
    control: control,
    placeholder: "Enter Account holder Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$b = _formData$landInfo3.bankdetails) === null || _formData$landInfo3$b === void 0 ? void 0 : _formData$landInfo3$b.accountHolderName,
    name: `landInfo.bankdetails.accountHolderName`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Branch Name",
    control: control,
    placeholder: "Enter Branch Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$b = _formData$landInfo4.bankdetails) === null || _formData$landInfo4$b === void 0 ? void 0 : _formData$landInfo4$b.branchName,
    name: `landInfo.bankdetails.branchName`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "IFSC Code",
    control: control,
    placeholder: "Enter IFSC Code",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$b = _formData$landInfo5.bankdetails) === null || _formData$landInfo5$b === void 0 ? void 0 : _formData$landInfo5$b.ifscCode,
    name: `landInfo.bankdetails.ifscCode`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Account No.",
    control: control,
    placeholder: "Enter Account No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$b = _formData$landInfo6.bankdetails) === null || _formData$landInfo6$b === void 0 ? void 0 : _formData$landInfo6$b.accountNo,
    name: `landInfo.bankdetails.accountNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: t("LABEL_BANK_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_BANK_NAME"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$b = _formData$landInfo7.bankdetails) === null || _formData$landInfo7$b === void 0 ? void 0 : _formData$landInfo7$b.bankName,
    name: `landInfo.bankdetails.bankName`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("br", null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit",
    disabled: isUpdating
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => reset()
  })))));
};

const GoogleMap = ({
  formData,
  coordinate,
  setCoordinate,
  googleLocation,
  setGoogleLocation
}) => {
  var _formData$description, _formData$description2, _coordinate$, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _coordinate$2, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14;
  const handleOpenMapLocation = () => {
    const encodedLocation = encodeURIComponent(googleLocation);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
    window.open(googleMapsUrl, "_blank");
  };
  const handleOpenMapCoordinate = () => {
    console.log("inside handle coordinate change");
    const {
      latitude,
      longitude
    } = coordinate[0];
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(googleMapsUrl, "_blank");
  };
  const handleCoordinateChange = (field, value) => {
    console.log("inside handle coordinate change");
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const handleGoogleLocation = e => {
    setGoogleLocation(e.target.value);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, "View On Maps"), /*#__PURE__*/React__default.createElement(Card$2, {
    style: {
      padding: "20px",
      maxWidth: "750px",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1,
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Enter Location to View on Map",
    type: "text",
    value: googleLocation || (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.googleMapLocation),
    onChange: handleGoogleLocation,
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapLocation
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleOpenMapLocation,
    style: {
      width: "100%",
      marginTop: "91px"
    }
  }, "View On Maps")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "1px",
      backgroundColor: "#ccc",
      height: "auto",
      margin: "0 20px"
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1,
      marginLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Latitude",
    type: "number",
    value: ((_coordinate$ = coordinate[0]) === null || _coordinate$ === void 0 ? void 0 : _coordinate$.latitude) || (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : (_formData$description4 = _formData$description3.googleMapCoordinates) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4[0]) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.latitude),
    onChange: e => handleCoordinateChange("latitude", e.target.value),
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    inputProps: {
      step: "any"
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : (_formData$description7 = _formData$description6.googleMapCoordinates) === null || _formData$description7 === void 0 ? void 0 : (_formData$description8 = _formData$description7[0]) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.latitude
  }), /*#__PURE__*/React__default.createElement(TextField, {
    label: "Longitude",
    type: "number",
    value: ((_coordinate$2 = coordinate[0]) === null || _coordinate$2 === void 0 ? void 0 : _coordinate$2.longitude) || (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : (_formData$description10 = _formData$description9.googleMapCoordinates) === null || _formData$description10 === void 0 ? void 0 : (_formData$description11 = _formData$description10[0]) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.longitude),
    onChange: e => handleCoordinateChange("longitude", e.target.value),
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    inputProps: {
      step: "any"
    },
    style: {
      marginTop: "10px"
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : (_formData$description13 = _formData$description12.googleMapCoordinates) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13[0]) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.longitude
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleOpenMapCoordinate,
    style: {
      width: "100%",
      marginTop: "20px"
    }
  }, "View On Maps"))))));
};

const Step3$4 = ({
  formData,
  isUpdating,
  handleTabChange
}) => {
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: coordinate,
      googleMapLocation: googleLocation
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    reset
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    var _coordinate$, _coordinate$2, _formData$description, _formData$description2;
    console.log("data_from_tab3", data);
    data.descriptionOfLand = {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (coordinate === null || coordinate === void 0 ? void 0 : (_coordinate$ = coordinate[0]) === null || _coordinate$ === void 0 ? void 0 : _coordinate$.latitude) === "" || (coordinate === null || coordinate === void 0 ? void 0 : (_coordinate$2 = coordinate[0]) === null || _coordinate$2 === void 0 ? void 0 : _coordinate$2.longitude) === "" ? formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.googleMapCoordinates : coordinate,
      googleMapLocation: googleLocation || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapLocation)
    };
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(GoogleMap, {
    formData: formData,
    coordinate: coordinate,
    setCoordinate: setCoordinate,
    googleLocation: googleLocation,
    setGoogleLocation: setGoogleLocation
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    sx: {
      backgroundColor: "#eee",
      "&:hover": {
        backgroundColor: "#e5e5e5"
      },
      color: "#000"
    },
    variant: "contained",
    size: "medium",
    label: "Prev",
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit",
    disabled: isUpdating
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step3$5 = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    documents
  };
  const isApprovedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === 'yes';
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, isApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    isMandatory: true,
    label: "Allotment Letter",
    control: control,
    name: "Allotment Letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Possession letter",
    control: control,
    name: "Possession letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Registry",
    control: control,
    name: "Registry",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Mutation Letter",
    control: control,
    name: "Mutation Letter",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "HPTA(Hire Purchase and Agreements)",
    control: control,
    name: "HPTA(Hire Purchase and Agreements)",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Up to date payment Certificate",
    control: control,
    name: "Up to date payment Certificate",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), !isApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Supporting Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Agreement",
    control: control,
    name: "Agreement",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Site Plan",
    control: control,
    name: "Site Plan",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "NOC from Land Acquisition Dept",
    control: control,
    name: "NOC from Land Acquisition Dept",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Documents related to Khata No. and Khasara No. ",
    control: control,
    name: "Documents related to Khata No. and Khasara No. ",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  })))));
};

const getOwnerRegistrationData = (id = null) => {
  var _usersData$user, _usersData$user$;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const [usersData, setUsersData] = useState({});
  if (id) {
    var _data$LandUse;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
        applicationNo: id
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  }
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const applicationType = "FORM_OWNER_REGISTRATION";
  const {
    documents
  } = useSelector(state => state.formMT);
  async function searchUser() {
    try {
      const response = await Digit.UserService.userSearch(tenantId, {
        uuid: [userUid]
      }, {});
      console.log("searchUser:", response);
      setUsersData(response);
      return response;
    } catch (error) {
      console.error("Error during user search:", error);
    }
  }
  useEffect(() => {
    searchUser();
  }, []);
  const registrationArchitectNumber = usersData === null || usersData === void 0 ? void 0 : (_usersData$user = usersData.user) === null || _usersData$user === void 0 ? void 0 : (_usersData$user$ = _usersData$user[0]) === null || _usersData$user$ === void 0 ? void 0 : _usersData$user$.registrationArchitectNumber;
  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      },
      registrationNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.registrationNumber,
      registrationArchitectNumber: registrationArchitectNumber
    },
    descriptionOfLand: {},
    checklist: {
      allotmentDate: null,
      isPossesionAreaDiff: null,
      areaOfExtraLand: null,
      paymentStatus: null,
      agreementDate: null,
      uptodatePaymentStatus: null,
      registryStatus: null
    },
    applicationType,
    approvedLayout: null,
    feeType: "ApplicationFee",
    department: applicationFlow,
    workflow: {
      action: "INITIATE",
      assignes: [userUid]
    },
    landInfo: {
      tenantId,
      address: {
        tenantId,
        locality: {
          code: "Lucknow"
        }
      },
      bankdetails: {
        accountHolderName: null,
        branchName: null,
        ifscCode: null,
        accountNo: null,
        bankName: null
      }
    },
    businessService: "BPA_OWNER_REGISTRATION",
    documents,
    uiFlow: {
      flow: "FORM_OWNER_REGISTRATION"
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const OwnerRegistration = () => {
  var _Digit;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [isUdFlow] = useDepartmentSelector();
  const tenantId = Digit.ULBService.getStateId() || 'hp';
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const {
    applicationData,
    isAppDataLoading
  } = getOwnerRegistrationData(id);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("OWNER_REGISTRATION_TAB")) || 0);
  const [showToast, setShowToast] = useState(null);
  const componentRef = useRef();
  const Modal = useModal();
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_OWNER_REGISTRATION", applicationData);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const showPreview = val => {
    handleTabChange(val);
    Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", val);
  };
  const approvedLayout = (params === null || params === void 0 ? void 0 : params.approvedLayout) === "no";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, 'OWNER_REGISTRATION');
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && nextTabNo === 1 && !('applicationNo' in params)) {
        Digit.OBPSService.createOwner({
          ownerRegistration: data
        }, tenantId).then(res => {
          var _res$ownerRegistratio, _res$ownerRegistratio2;
          const result = (_res$ownerRegistratio = res.ownerRegistration) === null || _res$ownerRegistratio === void 0 ? void 0 : _res$ownerRegistratio[0];
          if ((res === null || res === void 0 ? void 0 : (_res$ownerRegistratio2 = res.ownerRegistration) === null || _res$ownerRegistratio2 === void 0 ? void 0 : _res$ownerRegistratio2.length) > 0) {
            onSelect("", {
              ...formData,
              ...result
            }, true);
            Modal("Application created.", `Application Created Successfully!`, "success");
            setActiveTab(nextTabNo);
            sessionStorage.setItem("currentTab", nextTabNo);
            Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        try {
          if (activeTab === 3) {
            data.workflow = approvedLayout ? {
              action: "FORWARD_TO_EXECUTIVE_ENGINEER",
              assignes: null
            } : {
              action: "FORWARD_TO_EMO",
              assignes: null
            };
          } else {
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: [userUid]
            };
          }
          console.log('updateApiCall before', data);
          updateApiCall.mutate({
            ownerRegistration: data
          }, {
            onSuccess: () => {
              onSelect("", data);
              if (activeTab === 3) {
                Modal("Application submitted.", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> Submitted Successfully!`, "success", "/digit-ui/citizen/profile");
              } else {
                Modal("Application updated.", `Application Updated Successfully!`, "success");
              }
              setActiveTab(nextTabNo);
              sessionStorage.setItem("currentTab", nextTabNo);
              Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo);
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong, please try again!`
              });
            }
          });
        } catch (error) {
          console.error(e);
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      }
    } else {
      setActiveTab(nextTabNo);
      sessionStorage.setItem("currentTab", nextTabNo);
      Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo);
    }
  };
  if (isAppDataLoading || !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id) {
    var _params$landAreaDetai, _params$landAreaDetai2;
    if (!(params !== null && params !== void 0 && (_params$landAreaDetai = params.landAreaDetails) !== null && _params$landAreaDetai !== void 0 && (_params$landAreaDetai2 = _params$landAreaDetai.locality) !== null && _params$landAreaDetai2 !== void 0 && _params$landAreaDetai2.name)) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SubTabsWrapper, null, /*#__PURE__*/React__default.createElement(Box, {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement(SubTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    indicatorColor: "#1F4A7C",
    "aria-label": "sub tabs"
  }, /*#__PURE__*/React__default.createElement(SubTab, {
    label: t("LABEL_APPLICANT_INFO")
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: t("Map Information")
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: t("Documents")
  }), /*#__PURE__*/React__default.createElement(SubTab, {
    label: t("LABEL_SUMMARY")
  })), /*#__PURE__*/React__default.createElement(MandatoryInfo, null, "(", /*#__PURE__*/React__default.createElement("span", null, "*"), ") Indicates Mandatory Field"))), activeTab === 0 && /*#__PURE__*/React__default.createElement(Step1$2, {
    formData: params,
    isUpdating: updateApiCall.isLoading,
    handleTabChange: handleTabChange
  }), activeTab === 1 && /*#__PURE__*/React__default.createElement(Step3$4, {
    formData: params,
    isUpdating: updateApiCall.isLoading,
    handleTabChange: handleTabChange
  }), activeTab === 2 && /*#__PURE__*/React__default.createElement(Step3$5, {
    formData: params,
    isUpdating: updateApiCall.isLoading,
    handleTabChange: handleTabChange
  }), activeTab === 3 && (params === null || params === void 0 ? void 0 : params.applicationNo) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/React__default.createElement("button", {
      style: {
        backgroundColor: '#1f4a7c',
        color: '#fff',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
        position: 'absolute',
        right: '2rem'
      }
    }, "Print Summary"),
    content: () => componentRef.current
  }), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      width: '90%',
      margin: '0 auto'
    },
    ref: componentRef
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    formType: 'OWNER_REGISTRATION',
    id: params === null || params === void 0 ? void 0 : params.applicationNo,
    ref: componentRef
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    onClick: () => {
      showPreview(0);
    },
    style: {
      backgroundColor: '#2e7d32',
      color: '#fff',
      marginTop: '1rem',
      justifyContent: 'center'
    }
  }, "Preview"), /*#__PURE__*/React__default.createElement(Button$3, {
    color: "primary",
    onClick: () => {
      handleTabChange(3, params);
    },
    style: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#2e7d32',
      color: '#fff',
      marginTop: '1rem',
      justifyContent: 'center'
    }
  }, `Forward to Department`)))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const ownerApplications = () => {
  var _Digit$UserService$ge, _data$ownerRegistrati, _data$ownerRegistrati2;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const {
    control,
    register
  } = useForm();
  const tenantId = Digit.ULBService.getStateId() || 'up';
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const isEmployee = window.location.pathname.split("/").includes("employee");
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  let type = "OWNER_REGISTRATION";
  const {
    data = {},
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {}, {
    formType: type
  });
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const StyledTableCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const [orderBy, setOrderBy] = useState('applicationNo');
  const [order, setOrder] = useState('desc');
  const handleSort = column => {
    if (orderBy === column) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(column);
      setOrder('asc');
    }
  };
  const sortedData = data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati.sort((a, b) => {
    if (order === 'asc') {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return b[orderBy] < a[orderBy] ? -1 : 1;
    }
  });
  const closeModal2 = item => {
    setIdData(item === null || item === void 0 ? void 0 : item.applicationNo);
    setFormType("OWNER_REGISTRATION");
    if ((item === null || item === void 0 ? void 0 : item.applicationNo) != null) {
      setSmShowMs(true);
    } else {
      console.log("Application Number Null 11");
    }
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 5%"
    }
  }, /*#__PURE__*/React__default.createElement(Paper$2, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "8px",
      fontSize: "24px"
    }
  }, `${t("BPA_MY_APPLICATIONS")}`), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    sx: {
      maxHeight: 500
    }
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Name"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Mobile Number"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Application Number", /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === 'applicationNumber',
    direction: orderBy === 'applicationNumber' ? order : 'asc',
    onClick: () => handleSort('applicationNumber')
  })), /*#__PURE__*/React__default.createElement(StyledTableCell, null, " Application Type"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Date", /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === 'applicationDate',
    direction: orderBy === 'applicationDate' ? order : 'asc',
    onClick: () => handleSort('applicationDate')
  })), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Status", /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === 'status',
    direction: orderBy === 'status' ? order : 'asc',
    onClick: () => handleSort('status')
  })), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Payment"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "View Application"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, sortedData === null || sortedData === void 0 ? void 0 : sortedData.map((item, index) => {
    var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2;
    return /*#__PURE__*/React__default.createElement(StyledTableRow, {
      sx: {
        "&:last-child td, &:last-child th": {
          border: 0
        }
      }
    }, /*#__PURE__*/React__default.createElement(StyledTableCell, null, item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name), /*#__PURE__*/React__default.createElement(StyledTableCell, null, item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      style: {
        textDecoration: "underline blue 1px",
        cursor: "pointer",
        border: "1px solid #ddd",
        padding: " 8px"
      },
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/architect/appendex10/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, item === null || item === void 0 ? void 0 : item.applicationNo), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, "Owner Registration."), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.applicationDate)), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, t(item === null || item === void 0 ? void 0 : item.status)), /*#__PURE__*/React__default.createElement(StyledTableCell, null, (item === null || item === void 0 ? void 0 : item.status) === 'FORWARD_TO_APPLICANT_PAYMENT' && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/payment/collect/FORM_11/${item === null || item === void 0 ? void 0 : item.applicationNo}`,
          state: {
            paymentAmount: 1000
          }
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Make Payment"))), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, !isEmployee && ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/services/ownerPortal/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "ReSubmit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => closeModal2(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: data === null || data === void 0 ? void 0 : (_data$ownerRegistrati2 = data.ownerRegistration) === null || _data$ownerRegistrati2 === void 0 ? void 0 : _data$ownerRegistrati2.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })));
};

const PurchasableFarApplications = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowLandUseNOC, setSmShowLandUseNOC] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [itemData, setItemData] = useState({});
  const [SmShowFAR, setSmShowFAR] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [page, setPage] = React__default.useState(0);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const departement = applicationFlow;
  console.log("tenantId", tenantId, departement, rowsPerPage);
  let type = "PURCHASABLE_FAR";
  const {
    data = {},
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_PURCHASABLE_FAR",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage
  }, {
    formType: type
  });
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  console.log("dataApplications", data);
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch]);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterUrl).filter(key => key.startsWith("objection_")).sort().at(-1);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.PurchasableFAR) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, filters.name);
      });
    }
    if (filters.architect) {
      filteredData = filteredData.filter(item => {
        var _item$professionaldet;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$professionaldet = item.professionaldetails) === null || _item$professionaldet === void 0 ? void 0 : _item$professionaldet.name, filters.architect);
      });
    }
    if (filters.plotArea) {
      filteredData = filteredData.filter(item => {
        var _item$plotArea;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$plotArea = item.plotArea) === null || _item$plotArea === void 0 ? void 0 : _item$plotArea.toString(), filters.plotArea);
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, filters.applicationNo));
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, filters.applicationType));
    }
    if (filters.schemeName) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.schemeName, filters.schemeName));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.status, filters.status));
    }
    return filteredData;
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3, _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : _item$landInfo6$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (_item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-status"
    }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-")
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      console.log("item?.objectionLetterUrl", item);
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-objection"
      }, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => handleObjectionLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, ["INITIATE", "UPLOAD_DOC", "FORWARD_TO_LTP"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/services/purchasableFAR/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/structural/PURCHASABLE_FAR/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const handleSort = column => {
    if (orderBy === column) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(column);
      setOrder("asc");
    }
  };
  console.log("sortedData", sortedData);
  const handleClickAction = item => {
    var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structural/PURCHASABLE_FAR/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Purchasable FAR \u2013 My Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    className: "bg-white",
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: '#fff'
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, loader ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "Loading...")) : paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: data === null || data === void 0 ? void 0 : data.Count,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: SmShowFAR,
    onClose: () => {
      setSmShowFAR(false);
    }
  }, /*#__PURE__*/React__default.createElement(Summary, {
    id: idData
  })));
};

const Sidebar = ({
  Sidebarlabels
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleItemClick = label => {
    if (label.text === "Logout") {
      Digit.UserService.logout();
      history.push(citizenBaseUrl);
    } else if (label.text === "My Applications" || label.text === "Dashboard") {
      var _Digit, _Digit2, _Digit3, _Digit4, _Digit5, _Digit6;
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("FORMLANDUSE");
      (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("FORM_PURCHASABLE_FAR");
      (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("LANDUSE_CURRENT_TAB");
      (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
      (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("PURCHASABLE_FAR_TAB");
      (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("PURCHASABLE_FAR_SUBTAB");
      dispatch(resetFormMTDocs());
    }
  };
  return /*#__PURE__*/React__default.createElement(SideBarWrapper, null, /*#__PURE__*/React__default.createElement(ModuleTextWrapper, null, "Module Overview"), /*#__PURE__*/React__default.createElement(List, null, Sidebarlabels === null || Sidebarlabels === void 0 ? void 0 : Sidebarlabels.map((label, index) => /*#__PURE__*/React__default.createElement(ListItem, {
    button: true,
    key: index,
    onClick: () => handleItemClick(label),
    component: label.text === "Logout" ? "div" : Link,
    to: label.text !== "Logout" ? label.path : undefined,
    sx: {
      marginBottom: "1rem",
      "&:hover": {
        backgroundColor: "#3a4248"
      }
    }
  }, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: label.text
  })))));
};

const SubStep1$a = ({
  formData,
  handleSubTabChange
}) => {
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleSubTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Basic Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Are You the Owner or Applicant")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant,
    name: `ownerOrApplicant`,
    type: "radioButton",
    data: ownerOrApplicant,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is Your Property Part of Approved Layout")}`,
    placeholder: "approvedLayout",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.approvedLayout,
    name: `approvedLayout`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is More than One Owner")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner,
    name: `morethanOneOwner`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is More than One Property")}`,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty,
    name: `morethanOneProperty`,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  })), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => reset()
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const SubStep2$5 = ({
  formData,
  handleSubTabChange
}) => {
  var _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const ownerEntry = {
    name: '',
    fatherOrHusbandName: '',
    mobileNumber: '',
    emailId: '',
    aadhaarNumber: '',
    gender: null,
    correspondenceAddress: {
      applicantName: null,
      applicantGuardianName: null,
      state: "Uttar Pradesh",
      district: null,
      tehsil: null,
      town: null,
      address: "",
      pinno: "",
      type: "CORRESPONDENCE"
    },
    permanentAddress: {
      applicantName: null,
      applicantGuardianName: null,
      state: "Uttar Pradesh",
      district: null,
      tehsil: null,
      town: null,
      address: "",
      pinno: "",
      type: "PERMANENT"
    }
  };
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    documents,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry]
    }
  };
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const morethanOneOwner = (formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner) === 'yes';
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const onSubmit = data => {
    handleSubTabChange(2, data);
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, owners === null || owners === void 0 ? void 0 : owners.map((owner, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Owner Information") : t("Owner Information"), " ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    key: owner.id
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_ENTER_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    defaultValue: owner.name,
    name: `landInfo.owners[${index}].name`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_GENDER"),
    placeholder: "Gender",
    defaultValue: owner.gender,
    name: `landInfo.owners[${index}].gender`,
    type: "selectInput",
    data: genderData,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_EMAIL_ID"),
    defaultValue: owner.emailId,
    name: `landInfo.owners[${index}].emailId`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    control: control,
    name: `applicantPhoto[${index}]`,
    label: t("LABEL_OWNER_PHOTO"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: owner.correspondenceAddress.address,
    name: `landInfo.owners[${index}].correspondenceAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: owner.correspondenceAddress.district,
    name: `landInfo.owners[${index}].correspondenceAddress.district`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_FATHERS_NAME"),
    placeholder: t("LABEL_ENTER_FATHERS_NAME"),
    defaultValue: owner.fatherOrHusbandName,
    name: `landInfo.owners[${index}].fatherOrHusbandName`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Mobile Number(As in Aadhaar)",
    placeholder: t("LABEL_ENTER_MOBILE_NO"),
    defaultValue: owner.mobileNumber,
    name: `landInfo.owners[${index}].mobileNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_AADHAAR_NUMBER"),
    control: control,
    placeholder: t("LABEL_ENTER_AADHAAR_NO"),
    defaultValue: owner.aadhaarNumber,
    name: `landInfo.owners[${index}].aadhaarNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    control: control,
    name: `signature[${index}]`,
    label: t("LABEL_SIGNATURE"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: owner.correspondenceAddress.state || t("LABEL_STATE_UP"),
    name: `landInfo.owners[${index}].correspondenceAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: owner.correspondenceAddress.pinno,
    name: `landInfo.owners[${index}].correspondenceAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneOwner && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendOwner(ownerEntry)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Add",
    color: "primary",
    sx: {
      backgroundColor: '#157CB3'
    }
  })), owners.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeOwner(index)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Remove",
    color: "secondary"
  })))), /*#__PURE__*/React__default.createElement("br", null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const SubStep3$7 = ({
  formData,
  handleSubTabChange
}) => {
  var _formData$applicant, _formData$applicant2, _formData$applicant3, _formData$applicant4, _formData$applicant5;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_ENTER_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant = formData.applicant) === null || _formData$applicant === void 0 ? void 0 : _formData$applicant.name,
    name: "applicant.name",
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_EMAIL_ID"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant2 = formData.applicant) === null || _formData$applicant2 === void 0 ? void 0 : _formData$applicant2.emailId,
    name: `applicant.emailId`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  }), /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    name: "authorization Letter",
    label: t("Authorization Letter"),
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant3 = formData.applicant) === null || _formData$applicant3 === void 0 ? void 0 : _formData$applicant3.address,
    name: `applicant.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Mobile Number(As in Aadhaar)",
    placeholder: t("LABEL_ENTER_MOBILE_NO"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant4 = formData.applicant) === null || _formData$applicant4 === void 0 ? void 0 : _formData$applicant4.mobileNumber,
    name: `applicant.mobileNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_AADHAAR_NUMBER"),
    control: control,
    placeholder: t("LABEL_ENTER_AADHAAR_NO"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$applicant5 = formData.applicant) === null || _formData$applicant5 === void 0 ? void 0 : _formData$applicant5.aadhaarNumber,
    name: `applicant.aadhaarNumber`,
    type: "textInput",
    mandatory: true,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  })), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const SubStep4$6 = ({
  formData,
  handleSubTabChange
}) => {
  var _formData$description, _formData$description2, _formData$description3;
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    t
  } = useTranslation();
  const propertyEntry = {
    sectorNo: null,
    propertyNo: null,
    schemeName: null,
    block: null,
    khataNo: null,
    khasraNo: null,
    khatauniNo: null,
    plotArea: 0,
    plotNo: null,
    roadWidth: null,
    appliedLandUse: {
      name: null
    },
    propertyType: {
      name: null
    },
    propertyAddress: {
      address: null,
      state: null,
      pinno: null,
      district: null
    }
  };
  const defaultValues = {
    ...formData,
    documents,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    },
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      properties: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.properties : [propertyEntry]
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const {
    fields: properties,
    append: appendProp,
    remove: removeProp
  } = useFieldArray({
    control,
    name: "descriptionOfLand.properties"
  });
  const morethanOneProperty = (formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty) === 'yes';
  const watchApprovedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === 'yes';
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleSubTabChange(4, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, !watchApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((property, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Registration Information") : t("Registration Information"), "                                    ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_KHASRA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHASRA_NO"),
    defaultValue: property.khasraNo,
    name: `descriptionOfLand.properties[${index}].khasraNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_KHATA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHATA_NO"),
    defaultValue: property.khataNo,
    name: `descriptionOfLand.properties[${index}].khataNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Plot Area",
    control: control,
    placeholder: "Enter Plot Area",
    defaultValue: property.plotArea,
    name: `descriptionOfLand.properties[${index}].plotArea`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Land use as per master plan",
    control: control,
    placeholder: "Enter Land use as per master plan",
    defaultValue: property.appliedLandUse.name,
    name: `descriptionOfLand.properties[${index}].appliedLandUse.name`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: property.schemeName,
    name: `descriptionOfLand.properties[${index}].schemeName`,
    type: "selectInput",
    mandatory: true,
    data: schemeNameList,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: property.propertyAddress.address,
    name: `descriptionOfLand.properties[${index}].propertyAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Khatuni No.",
    control: control,
    placeholder: "Enter Khatuni No.",
    defaultValue: property.khatauniNo,
    name: `descriptionOfLand.properties[${index}].khatauniNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_PLOT_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_PLOT_NO"),
    defaultValue: property.plotNo,
    name: `descriptionOfLand.properties[${index}].plotNo`,
    type: "textInput",
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Road Width",
    control: control,
    placeholder: "Enter Road Width",
    defaultValue: property.roadWidth,
    name: `descriptionOfLand.properties[${index}].roadWidth`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: property.city,
    name: `descriptionOfLand.properties[${index}].city`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: property.propertyAddress.state || t("LABEL_STATE_UP"),
    name: `descriptionOfLand.properties[${index}].propertyAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: property.propertyAddress.pinno,
    name: `descriptionOfLand.properties[${index}].propertyAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneProperty && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendProp(propertyEntry)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Add",
    color: "primary",
    sx: {
      backgroundColor: '#157CB3'
    }
  })), properties.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeProp(index)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Remove",
    color: "secondary"
  })))))))), watchApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((property, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, index > 0 ? t("Additional Registration Information") : t("Registration Information"), "                                    ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Property Type",
    control: control,
    placeholder: "Select Property Type",
    defaultValue: property.propertyType.name,
    name: `descriptionOfLand.properties[${index}].propertyType.name`,
    type: "selectInput",
    mandatory: true,
    data: propertyTypeListUP,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Sector No.",
    defaultValue: property.sectorNo,
    name: `descriptionOfLand.properties[${index}].sectorNo`,
    type: "textInput",
    placeholder: "Enter Sector No.",
    mandatory: true,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Property Number",
    defaultValue: property.propertyNo,
    name: `descriptionOfLand.properties[${index}].propertyNo`,
    type: "textInput",
    placeholder: "Enter Property No.",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Plot Area(As per Allotment Letter)",
    control: control,
    placeholder: "Enter Plot Area",
    defaultValue: property.plotArea,
    name: `descriptionOfLand.properties[${index}].plotArea`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    defaultValue: property.propertyAddress.address,
    name: `descriptionOfLand.properties[${index}].propertyAddress.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Property land use (as in allotment letter)",
    control: control,
    placeholder: "Enter Land use as per master plan",
    defaultValue: property.appliedLandUse.name,
    name: `descriptionOfLand.properties[${index}].appliedLandUse.name`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: property.schemeName,
    name: `descriptionOfLand.properties[${index}].schemeName`,
    type: "selectInput",
    mandatory: true,
    data: schemeNameList,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Block",
    placeholder: "Enter Block",
    defaultValue: property.block,
    name: `descriptionOfLand.properties[${index}].block`,
    type: "textInput",
    mandatory: true,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    defaultValue: property.city,
    name: `descriptionOfLand.properties[${index}].city`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    defaultValue: property.propertyAddress.state || t("LABEL_STATE_UP"),
    name: `descriptionOfLand.properties[${index}].propertyAddress.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    defaultValue: property.propertyAddress.pinno,
    name: `descriptionOfLand.properties[${index}].propertyAddress.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }), morethanOneProperty && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendProp(propertyEntry)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Add",
    color: "primary",
    sx: {
      backgroundColor: '#157CB3'
    }
  })), properties.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeProp(index)
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "medium",
    label: "Remove",
    color: "secondary"
  })))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const SubStep5 = ({
  formData,
  handleTabChange,
  handleSubTabChange
}) => {
  var _formData$landInfo, _formData$landInfo$ba, _formData$landInfo2, _formData$landInfo2$b, _formData$landInfo3, _formData$landInfo3$b, _formData$landInfo4, _formData$landInfo4$b, _formData$landInfo5, _formData$landInfo5$b;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Bank Information(In case of Refund)")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Account holder Name",
    control: control,
    placeholder: "Enter Account holder Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ba = _formData$landInfo.bankdetails) === null || _formData$landInfo$ba === void 0 ? void 0 : _formData$landInfo$ba.accountHolderName,
    name: `landInfo.bankdetails.accountHolderName`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Branch Name",
    control: control,
    placeholder: "Enter Branch Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$b = _formData$landInfo2.bankdetails) === null || _formData$landInfo2$b === void 0 ? void 0 : _formData$landInfo2$b.branchName,
    name: `landInfo.bankdetails.branchName`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "IFSC Code",
    control: control,
    placeholder: "Enter IFSC Code",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$b = _formData$landInfo3.bankdetails) === null || _formData$landInfo3$b === void 0 ? void 0 : _formData$landInfo3$b.ifscCode,
    name: `landInfo.bankdetails.ifscCode`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Account No.",
    control: control,
    placeholder: "Enter Account No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$b = _formData$landInfo4.bankdetails) === null || _formData$landInfo4$b === void 0 ? void 0 : _formData$landInfo4$b.accountNo,
    name: `landInfo.bankdetails.accountNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_BANK_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_BANK_NAME"),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$b = _formData$landInfo5.bankdetails) === null || _formData$landInfo5$b === void 0 ? void 0 : _formData$landInfo5$b.bankName,
    name: `landInfo.bankdetails.bankName`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(3)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const getOwnerRegistrationData$1 = (id = null) => {
  var _usersData$user, _usersData$user$;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const [usersData, setUsersData] = useState({});
  if (id) {
    var _data$ownerRegistrati;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPAOwnerRegistration(tenantId, {
        applicationNo: id
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  }
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const applicationType = "FORM_OWNER_REGISTRATION";
  const {
    documents
  } = useSelector(state => state.formMT);
  async function searchUser() {
    try {
      const response = await Digit.UserService.userSearch(tenantId, {
        uuid: [userUid]
      }, {});
      setUsersData(response);
      return response;
    } catch (error) {
      console.error("Error during user search:", error);
    }
  }
  useEffect(() => {
    searchUser();
  }, []);
  const registrationArchitectNumber = usersData === null || usersData === void 0 ? void 0 : (_usersData$user = usersData.user) === null || _usersData$user === void 0 ? void 0 : (_usersData$user$ = _usersData$user[0]) === null || _usersData$user$ === void 0 ? void 0 : _usersData$user$.registrationArchitectNumber;
  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      },
      registrationNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.registrationNumber,
      registrationArchitectNumber: registrationArchitectNumber
    },
    descriptionOfLand: {},
    checklist: {
      allotmentDate: null,
      isPossesionAreaDiff: null,
      areaOfExtraLand: null,
      paymentStatus: null,
      agreementDate: null,
      uptodatePaymentStatus: null,
      registryStatus: null
    },
    applicationType,
    approvedLayout: null,
    feeType: "ApplicationFee",
    department: applicationFlow,
    workflow: {
      action: "INITIATE",
      assignes: [userUid]
    },
    landInfo: {
      tenantId,
      owners: null,
      address: {
        tenantId,
        locality: {
          code: "Lucknow"
        }
      },
      bankdetails: {
        accountHolderName: null,
        branchName: null,
        ifscCode: null,
        accountNo: null,
        bankName: null
      }
    },
    businessService: "BPA_OWNER_REGISTRATION",
    documents,
    uiFlow: {
      flow: "FORM_OWNER_REGISTRATION"
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const Step2$2 = ({
  formData,
  handleTabChange
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.googleMapCoordinates.[0].latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.googleMapCoordinates) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2[0]) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.googleMapCoordinates.[0].longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4.googleMapCoordinates) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5[0]) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10
  }), /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.googleMapLocation,
    name: "descriptionOfLand.googleMapLocation",
    type: "textInput",
    maxLength: 150,
    multiLine: true
  })), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const Step3$6 = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    documents
  };
  const isApprovedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === 'yes';
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, isApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    isMandatory: true,
    label: "Allotment Letter",
    control: control,
    name: "Allotment Letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Possession letter",
    control: control,
    name: "Possession letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Registry",
    control: control,
    name: "Registry",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Mutation Letter",
    control: control,
    name: "Mutation Letter",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "HPTA(Hire Purchase and Agreements)",
    control: control,
    name: "HPTA(Hire Purchase and Agreements)",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Up to date payment Certificate",
    control: control,
    name: "Up to date payment Certificate",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), !isApprovedLayout && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Supporting Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Agreement",
    control: control,
    name: "Agreement",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Site Plan",
    control: control,
    name: "Site Plan",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "NOC from Land Acquisition Dept",
    control: control,
    name: "NOC from Land Acquisition Dept",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(FileUploader$5, {
    label: "Documents related to Khata No. and Khasara No. ",
    control: control,
    name: "Documents related to Khata No. and Khasara No. ",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const OwnerPortal = () => {
  var _Digit, _Digit2;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("OWNER_REGISTRATION_SUBTAB")) || 0);
  const [activeTab, setActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("OWNER_REGISTRATION_TAB")) || 0);
  const {
    applicationData,
    isAppDataLoading
  } = getOwnerRegistrationData$1(id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const Modal = useModal();
  const componentRef = useRef();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_OWNER_REGISTRATION", applicationData);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, 'OWNER_REGISTRATION');
  const approvedLayout = (params === null || params === void 0 ? void 0 : params.approvedLayout) === "no";
  const ownerOrApplicant = (params === null || params === void 0 ? void 0 : params.ownerOrApplicant) === 'Applicant';
  const subTabLabels = [{
    label: 'Basic Information'
  }, {
    label: 'Owner Information'
  }, {
    label: 'Applicant Information',
    show: ownerOrApplicant
  }, {
    label: 'Registration Information'
  }, {
    label: 'Bank Information (In case of Refund)'
  }];
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      try {
        if (activeTab === 3) {
          data.workflow = approvedLayout ? {
            action: "FORWARD_TO_EXECUTIVE_ENGINEER",
            assignes: null
          } : {
            action: "FORWARD_TO_EMO",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: [userUid]
          };
        }
        console.log('updateApiCall before', data);
        updateApiCall.mutate({
          ownerRegistration: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (activeTab === 3) {
              Modal("Application Submitted.", `Your Application ${data === null || data === void 0 ? void 0 : data.applicationNo} Submitted Successfully!`, "success");
              history.push(`${citizenBaseUrl}/profile`);
            } else {
              Modal("Application updated.", `Application Updated Successfully!`, "success");
            }
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo);
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(e);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && selectedSubTab === 0 && !('applicationNo' in params)) {
        Digit.OBPSService.createOwner({
          ownerRegistration: data
        }, tenantId).then(res => {
          var _res$ownerRegistratio, _res$ownerRegistratio2;
          const result = (_res$ownerRegistratio = res.ownerRegistration) === null || _res$ownerRegistratio === void 0 ? void 0 : _res$ownerRegistratio[0];
          if ((res === null || res === void 0 ? void 0 : (_res$ownerRegistratio2 = res.ownerRegistration) === null || _res$ownerRegistratio2 === void 0 ? void 0 : _res$ownerRegistratio2.length) > 0) {
            onSelect("", {
              ...formData,
              ...result
            }, true);
            Modal("Application created.", `Application Created Successfully!`, "success");
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, 'error');
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: [userUid]
          };
          console.log('updateApiCall before', data);
          updateApiCall.mutate({
            ownerRegistration: data
          }, {
            onSuccess: () => {
              onSelect("", data);
              Modal("Application updated.", `Application Updated Successfully!`, "success");
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(e);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab);
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const renderContent = () => {
    if (activeTab === 0) {
      if (ownerOrApplicant) {
        switch (selectedSubTab) {
          case 0:
            return /*#__PURE__*/React__default.createElement(SubStep1$a, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 1:
            return /*#__PURE__*/React__default.createElement(SubStep2$5, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 2:
            return /*#__PURE__*/React__default.createElement(SubStep3$7, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 3:
            return /*#__PURE__*/React__default.createElement(SubStep4$6, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 4:
            return /*#__PURE__*/React__default.createElement(SubStep5, {
              formData: params,
              handleTabChange: handleTabChange
            });
          default:
            return null;
        }
      } else {
        switch (selectedSubTab) {
          case 0:
            return /*#__PURE__*/React__default.createElement(SubStep1$a, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 1:
            return /*#__PURE__*/React__default.createElement(SubStep2$5, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 2:
            return /*#__PURE__*/React__default.createElement(SubStep4$6, {
              formData: params,
              handleSubTabChange: handleSubTabChange
            });
          case 4:
            return /*#__PURE__*/React__default.createElement(SubStep5, {
              formData: params,
              handleTabChange: handleTabChange,
              handleSubTabChange: handleSubTabChange
            });
          default:
            return null;
        }
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$2, {
        formData: params,
        handleTabChange: handleTabChange
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step3$6, {
        formData: params,
        handleTabChange: handleTabChange
      });
    } else if (activeTab === 3 && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement("button", {
          style: {
            backgroundColor: '#1f4a7c',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            position: 'absolute',
            right: '2rem'
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: '90%',
          margin: '0 auto'
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
        formType: 'OWNER_REGISTRATION',
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: '#CCC'
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: '#157CB3'
        },
        onClick: () => handleTabChange(3, params)
      }))));
    }
  };
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(PortalWrapper, null, /*#__PURE__*/React__default.createElement(SideWrapper, null, /*#__PURE__*/React__default.createElement(Sidebar, {
    Sidebarlabels: Sidebarlabels
  })), /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(HeaderContent, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Owner Interface Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Map Information"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.filter(tab => tab.show !== false).map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent()));
};

const getApplicationData$1 = (id = null, isReapply = false) => {
  var _userInfo$info, _userInfo$info2, _userInfo$info3;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const userInfo = Digit.UserService.getUser();
  if (id) {
    var _data$Licenses;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
        applicationNumber: id
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$Licenses = data.Licenses) === null || _data$Licenses === void 0 ? void 0 : _data$Licenses[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  }
  const businessService = "BPAREG";
  const applicationData = {
    tenantId,
    action: "INITIATE",
    licenseType: "PERMANENT",
    applicationType: "NEW",
    businessService: businessService,
    idProofType: null,
    registrationNo: null,
    validupto: null,
    authorityName: null,
    tradeLicenseDetail: {
      owners: [{
        gender: null,
        mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.mobileNumber,
        name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.name,
        dob: null,
        emailId: null,
        initialForApplicantName: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.initialForApplicantName,
        permanentAddress: null,
        correspondenceAddress: null,
        pan: null,
        qualification: null,
        totalExperience: null,
        firmName: null,
        profileSummary: null,
        aadhaarNumber: null,
        nationality: null,
        architectureNo: null
      }],
      subOwnerShipCategory: "INDIVIDUAL",
      tradeUnits: [{
        tradeType: null
      }],
      additionalDetail: {
        counsilForArchNo: null
      },
      address: {
        city: "",
        landmark: "",
        pincode: ""
      },
      institution: null,
      applicationDocuments: null
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const LTPRegistration = () => {
  var _Digit, _Digit2, _location$state, _departmentList$filte, _params$tradeLicenseD, _params$tradeLicenseD2, _params$tradeLicenseD3;
  const dispatch = useDispatch();
  const {
    initRegistrationDocs,
    resetRegistrationDocs
  } = bindActionCreators(registration, dispatch);
  const {
    t
  } = useTranslation();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("REGISTRATION_CURRENT_TAB")) || 0);
  const [subActiveTab, setSubActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("REGISTRATION_CURRENT_SUBTAB")) || 0);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const stateCode = Digit.ULBService.getStateId() || "up";
  const location = useLocation();
  const isReapply = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.reapply;
  const tenantId = stateCode;
  const {
    applicationData,
    isAppDataLoading
  } = getApplicationData$1(id);
  const Modal = useModal();
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const componentRef = useRef();
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("LTP_REGISTRATION", applicationData);
  const validationRules = [{
    path: "tradeLicenseDetail.owners.0.aadhaarNumber",
    errorMessage: "Please fill all the mandatory details in Applicant details tab.",
    condition: value => !value
  }, {
    path: "tradeLicenseDetail.owners.0.emailId",
    errorMessage: "Please fill all the mandatory details in contact information tab.",
    condition: value => !value
  }, {
    path: "authorityName",
    errorMessage: "Please fill all the mandatory details in registration detail tab.",
    condition: value => !value
  }, {
    path: "tradeLicenseDetail.applicationDocuments.0.fileStoreId",
    errorMessage: "Please upload all the mandatory documents in document tab.",
    condition: value => !value
  }];
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type === "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : (_departmentList$filte = departmentList.filter(item => item.Type === "AVP")) === null || _departmentList$filte === void 0 ? void 0 : _departmentList$filte.filter(item => item.ShortName === "UPAVP");
  function filterDepartmentsList(completeList) {
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    return officeNames;
  }
  const officesList = filterDepartmentsList(daList);
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$trad, _applicationData$trad2;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$trad = applicationData.tradeLicenseDetail) === null || _applicationData$trad === void 0 ? void 0 : (_applicationData$trad2 = _applicationData$trad.applicationDocuments) === null || _applicationData$trad2 === void 0 ? void 0 : _applicationData$trad2.length) > 0) {
        var _applicationData$trad3;
        initRegistrationDocs(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$trad3 = applicationData.tradeLicenseDetail) === null || _applicationData$trad3 === void 0 ? void 0 : _applicationData$trad3.applicationDocuments);
      }
    }
  }, [id, applicationData]);
  const useFormSubmitValidation = (validationRules, payload) => {
    console.log("loggingPayload", payload, validationRules);
    const validate = () => {
      let formIsValid = true;
      validationRules.forEach(rule => {
        const {
          path,
          errorMessage,
          condition = value => !value
        } = rule;
        const value = get$1(payload, path);
        console.log("valueFromValidation", value, path);
        if (condition(value)) {
          Modal("Validation Error", errorMessage, "error");
          formIsValid = false;
          return;
        }
      });
      return formIsValid;
    };
    const isValid = validate();
    return isValid;
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const onSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams(data);
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "Registration");
  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: params === null || params === void 0 ? void 0 : params.applicationNumber,
    moduleCode: "BPAREG",
    config: {
      enabled: activeTab === 2 && !!(params !== null && params !== void 0 && params.applicationNumber)
    }
  });
  const tradeType = params === null || params === void 0 ? void 0 : (_params$tradeLicenseD = params.tradeLicenseDetail) === null || _params$tradeLicenseD === void 0 ? void 0 : (_params$tradeLicenseD2 = _params$tradeLicenseD.tradeUnits) === null || _params$tradeLicenseD2 === void 0 ? void 0 : (_params$tradeLicenseD3 = _params$tradeLicenseD2[0]) === null || _params$tradeLicenseD3 === void 0 ? void 0 : _params$tradeLicenseD3.tradeType;
  const isRevert = (params === null || params === void 0 ? void 0 : params.status) === "SENDBACK_TO_CITIZEN";
  const subTabLabels = [{
    label: "Applicant Type"
  }, {
    label: "Applicant Details"
  }, {
    label: "Contact Information"
  }, {
    label: "Registration Details"
  }, {
    label: "Document Details"
  }];
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = [{
        ...params,
        ...formData
      }];
      if (tradeType === "ARCHITECT.CLASSA" && activeTab === 1 || isRevert) {
        data[0].action = "FORWARD_TO_DEPARTMENT";
      } else if (tradeType !== "ARCHITECT.CLASSA" && activeTab === 1) {
        data[0].action = "MAKE_PAYMENT";
      } else if (activeTab === 0) {
        data[0].action = "UPLOAD_DOC";
      }
      const isValid = useFormSubmitValidation(validationRules, data[0]);
      if (!isValid) {
        return;
      }
      try {
        updateApiCall.mutate({
          Licenses: data
        }, {
          onSuccess: result => {
            var _result$Licenses;
            if ((result === null || result === void 0 ? void 0 : (_result$Licenses = result.Licenses) === null || _result$Licenses === void 0 ? void 0 : _result$Licenses.length) > 0) {
              onSelect("", result.Licenses[0]);
              if (activeTab === 1) {
                if (tradeType === "ARCHITECT.CLASSA" || isRevert) {
                  var _result$Licenses2, _result$Licenses2$;
                  Modal("Application Submitted", `Your Application ${result === null || result === void 0 ? void 0 : (_result$Licenses2 = result.Licenses) === null || _result$Licenses2 === void 0 ? void 0 : (_result$Licenses2$ = _result$Licenses2[0]) === null || _result$Licenses2$ === void 0 ? void 0 : _result$Licenses2$.applicationNumber} has been sent to the department for further Approval`, "success");
                  clearParams();
                  setTimeout(() => {
                    resetRegistrationDocs();
                  }, 0);
                  setTimeout(() => {
                    var _Digit3, _Digit4;
                    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("REGISTRATION_CURRENT_TAB");
                    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("PROF_REGISTRATION");
                  }, 2000);
                  history.push(`${citizenBaseUrl}/obps/formProfessionalApplications`);
                } else {
                  setShowToast({
                    key: "true",
                    error: false,
                    message: `Application Updated Successfully! Redirecting to the payment page...`
                  });
                  history.push(`${citizenBaseUrl}/payment/collect/${params === null || params === void 0 ? void 0 : params.businessService}/${params === null || params === void 0 ? void 0 : params.applicationNumber}/${tenantId}/tenantId=${tenantId}`);
                }
              }
            }
          },
          onError: () => {
            setShowToast({
              error: true,
              message: `Something went wrong, please try again!`
            });
          }
        });
      } catch (error) {
        Modal("Update Error.", `Something went wrong!!`, "error");
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("REGISTRATION_CURRENT_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = [{
        ...params,
        ...formData
      }];
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNumber" in params)) {
        if (isReapply) {
          data[0].applicationType = "RENEWAL";
          delete data[0].applicationNumber;
          delete data[0].id;
          data[0].workflow = {};
          data[0].workflow.action = "INITIATE";
          data[0].action = "INITIATE";
          data[0].validFrom = Date.now();
          data[0].validTo = Date.now();
        }
        Digit.OBPSService.BPAREGCreate({
          Licenses: data
        }, tenantId).then(result => {
          var _result$Licenses3;
          if ((result === null || result === void 0 ? void 0 : (_result$Licenses3 = result.Licenses) === null || _result$Licenses3 === void 0 ? void 0 : _result$Licenses3.length) > 0) {
            onSelect("", {
              ...formData,
              ...result.Licenses[0]
            }, "", true);
            setShowToast({
              key: "true",
              error: false,
              message: `Application Created Successfully!`
            });
            setSubActiveTab(nextSubTab);
            Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(error => {
          var _error$response, _error$response2, _error$response3, _error$response3$data, _error$response3$data2, _error$response3$data3;
          console.error("API Error Details:", {
            message: error.message,
            response: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data,
            status: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status
          });
          Modal("Create Error", ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : (_error$response3$data2 = _error$response3$data.Errors) === null || _error$response3$data2 === void 0 ? void 0 : (_error$response3$data3 = _error$response3$data2[0]) === null || _error$response3$data3 === void 0 ? void 0 : _error$response3$data3.message) || "Something went wrong!!", "error");
        });
      } else {
        try {
          data[0].action = "UPLOAD_DOC";
          updateApiCall.mutate({
            Licenses: data
          }, {
            onSuccess: result => {
              var _result$Licenses4;
              if ((result === null || result === void 0 ? void 0 : (_result$Licenses4 = result.Licenses) === null || _result$Licenses4 === void 0 ? void 0 : _result$Licenses4.length) > 0) {
                onSelect("", result.Licenses[0]);
                setShowToast({
                  key: "true",
                  error: false,
                  message: `Data has been saved successfully!`
                });
                if (nextSubTab === 5) {
                  var _Digit5;
                  setActiveTab(1);
                  (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set("REGISTRATION_CURRENT_TAB", 1);
                } else {
                  setSubActiveTab(nextSubTab);
                  Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
                }
              }
            },
            onError: error => {
              Modal("Update Error", error || "Something went wrong!", "error");
            }
          });
        } catch (error) {
          var _error$response4, _error$response4$data, _error$response4$data2, _error$response4$data3;
          Modal("Update Error", error || (error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : (_error$response4$data2 = _error$response4$data.Errors) === null || _error$response4$data2 === void 0 ? void 0 : (_error$response4$data3 = _error$response4$data2[0]) === null || _error$response4$data3 === void 0 ? void 0 : _error$response4$data3.message) || "Something went wrong!!", "error");
        }
      }
    } else {
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("REGISTRATION_CURRENT_SUBTAB", nextSubTab);
    }
  };
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id) {
    var _params$tradeLicenseD4, _params$tradeLicenseD5, _params$tradeLicenseD6;
    if (!(params !== null && params !== void 0 && (_params$tradeLicenseD4 = params.tradeLicenseDetail) !== null && _params$tradeLicenseD4 !== void 0 && (_params$tradeLicenseD5 = _params$tradeLicenseD4.tradeUnits) !== null && _params$tradeLicenseD5 !== void 0 && (_params$tradeLicenseD6 = _params$tradeLicenseD5[0]) !== null && _params$tradeLicenseD6 !== void 0 && _params$tradeLicenseD6.tradeType)) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
  }
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$9, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isReapply: isReapply
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$4, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isReapply: isReapply
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$6, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isReapply: isReapply
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$5, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            setShowToast: setShowToast,
            showToast: showToast,
            isReapply: isReapply,
            officesList: officesList
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(Step5$1, {
            formData: params,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            tradeType: tradeType,
            isReapply: isReapply,
            initRegistrationDocs: initRegistrationDocs
          });
        default:
          return null;
      }
    } else if (activeTab === 1 && params !== null && params !== void 0 && params.applicationNumber) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$3, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary$1, {
        id: params === null || params === void 0 ? void 0 : params.applicationNumber,
        ref: componentRef,
        isEmployee: false,
        setDeclarationChecked: setDeclarationChecked
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: tradeType === "ARCHITECT.CLASSA" ? "Submit" : isRevert ? "Forward to Department" : "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "150px",
          letterSpacing: "normal"
        },
        onClick: () => handleTabChange(2, params),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 2 && params !== null && params !== void 0 && params.applicationNumber) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllRemarksList, {
        remarkDataResps: workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.data,
        formData: params
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("FASTPAS.GLOBAL.TPR.TEXT")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, {
    className: "technical-profession-section"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const getMapSubmissionData$1 = (t, id = null) => {
  var _Digit$SessionStorage, _edcrData$planDetail, _edcrData$planDetail$, _edcrData$planDetail$2, _mdmsData$BPA, _planDetail$plot, _data$BPA, _applicationData, _applicationData$draw, _planDetail$virtualBu13, _planDetail$virtualBu14, _planDetail$virtualBu15, _planDetail$virtualBu16, _planDetail$virtualBu17, _planDetail$planInfoP3, _planDetail$plot4, _applicationData237, _applicationData238, _applicationData239, _planDetail$blocks4, _planDetail$parkingDe5, _planDetail$parkingDe6, _Digit3, _userInfo$info, _userInfo$info2, _userInfo$info3, _scrutinyDetails$city, _planInformation$corr, _scrutinyDetails$loca, _planInformation$corr2, _scrutinyDetails$vill, _planInformation$corr3, _edcrData$additionalP3, _applicationData240, _applicationData241, _applicationData241$m, _applicationData242, _applicationData242$a, _applicationData243, _applicationData244, _applicationData244$m, _edcrData$mapSubDetai21, _applicationData245, _applicationData246, _applicationData246$m, _edcrData$mapSubDetai22, _applicationData247, _fastPasData$descript23, _fastPasData$descript24, _fastPasData$descript25, _fastPasData$descript26, _fastPasData$descript27, _fastPasData$descript28, _fastPasData$descript29, _fastPasData$descript30, _fastPasData$descript31, _fastPasData$addition4, _applicationData248, _applicationData249, _applicationData249$a, _edcrData$mapSubDetai23, _applicationData250, _applicationData251, _fastPasData$mapSubDe7, _edcrData$mapSubDetai24, _applicationData252, _applicationData253, _fastPasData$mapSubDe8, _applicationData254, _edcrData$mapSubDetai25, _applicationData255, _applicationData255$m, _edcrData$mapSubDetai26, _applicationData256, _applicationData257, _fastPasData$mapSubDe9, _edcrData$mapSubDetai27, _applicationData258, _applicationData258$m, _applicationData259, _applicationData260, _applicationData260$m, _edcrData$mapSubDetai28, _applicationData261, _applicationData261$a, _applicationData262, _applicationData263, _applicationData263$m, _edcrData$mapSubDetai29, _applicationData264, _applicationData265, _applicationData265$m, _edcrData$mapSubDetai30, _fastPasData$descript32, _applicationData266, _edcrData$additionalP4, _applicationData267;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const fastPasData = Digit.SessionStorage.get("FASTPAS_ID");
  console.log("edcrdatafrommapsubportal", edcrData, fastPasData);
  const planDetail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const regulatedObj = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : (_edcrData$planDetail$ = _edcrData$planDetail.reportOutput) === null || _edcrData$planDetail$ === void 0 ? void 0 : (_edcrData$planDetail$2 = _edcrData$planDetail$.scrutinyDetails) === null || _edcrData$planDetail$2 === void 0 ? void 0 : _edcrData$planDetail$2.filter(e => e.key === "Block_1_Side Setback");
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot = planDetail.plot) === null || _planDetail$plot === void 0 ? void 0 : _planDetail$plot.area, planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const planInformation = planDetail === null || planDetail === void 0 ? void 0 : planDetail.planInformation;
  console.log("PlanInformation2333", planInformation);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearch(tenantId, {
      applicationId: id,
      isEmployee: false
    });
  };
  const {
    data,
    isLoading: isAppDataLoading,
    isSuccess
  } = useQuery({
    queryKey: [id],
    queryFn: fetchApplicationData,
    enabled: isMdmsSuccess,
    refetchOnMount: "always"
  });
  let applicationData = (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || {};
  const isRescrutiny = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$draw = _applicationData.drawingDetail) === null || _applicationData$draw === void 0 ? void 0 : _applicationData$draw.length) > 0;
  console.log("ApplicationData31313", edcrData, applicationData, fastPasData);
  if (id && isSuccess && !isRescrutiny) {
    var _applicationData2, _applicationData3, _applicationData4, _applicationData5, _planDetail$virtualBu, _planDetail$virtualBu2, _applicationData6, _planDetail$virtualBu3, _applicationData7, _planDetail$virtualBu4, _planDetail$virtualBu5, _applicationData8, _applicationData9, _planDetail$planInfoP, _applicationData10, _applicationData11, _applicationData12, _applicationData13, _planDetail$plot2, _applicationData14, _applicationData15, _applicationData16, _planDetail$blocks2, _applicationData17, _planDetail$virtualBu6, _applicationData18, _applicationData19, _planDetail$parkingDe, _applicationData20, _planDetail$parkingDe2, _applicationData21, _Digit, _applicationData22, _applicationData23, _applicationData24, _applicationData25, _applicationData26, _applicationData27, _applicationData28, _applicationData29, _applicationData30, _applicationData31, _applicationData32, _applicationData33, _applicationData34, _applicationData35, _applicationData36, _applicationData37, _applicationData38, _applicationData39, _applicationData40, _applicationData41, _applicationData42, _applicationData43, _applicationData44, _applicationData45, _applicationData46, _applicationData46$ma, _applicationData47, _applicationData47$ad, _applicationData48, _applicationData49, _applicationData49$ma, _edcrData$mapSubDetai, _applicationData50, _applicationData51, _applicationData51$ma, _edcrData$mapSubDetai2, _applicationData52, _applicationData53, _applicationData54, _applicationData55, _applicationData56, _applicationData57, _applicationData58, _applicationData59, _applicationData60, _applicationData61, _applicationData62, _applicationData63, _applicationData64, _applicationData65, _applicationData66, _applicationData67, _applicationData68, _applicationData69, _applicationData70, _applicationData71, _applicationData72, _applicationData73, _applicationData74, _applicationData75, _applicationData76, _applicationData77, _applicationData78, _applicationData79, _applicationData80, _applicationData80$ad, _edcrData$additionalD, _fastPasData$addition, _applicationData81, _applicationData82, _applicationData83, _applicationData84, _applicationData85, _fastPasData$descript, _applicationData86, _fastPasData$descript2, _applicationData87, _fastPasData$descript3, _applicationData88, _fastPasData$descript4, _applicationData89, _fastPasData$descript5, _applicationData90, _fastPasData$descript6, _fastPasData$descript7, _fastPasData$descript8, _applicationData91, _fastPasData$descript9, _fastPasData$descript10, _fastPasData$descript11, _applicationData92, _applicationData93, _applicationData94, _applicationData95, _fastPasData$addition2, _applicationData96, _applicationData97, _applicationData97$ad, _applicationData98, _edcrData$mapSubDetai3, _applicationData99, _applicationData100, _fastPasData$mapSubDe, _edcrData$mapSubDetai4, _applicationData101, _applicationData102, _fastPasData$mapSubDe2, _applicationData103, _edcrData$mapSubDetai5, _applicationData104, _applicationData104$m, _edcrData$mapSubDetai6, _applicationData105, _applicationData106, _fastPasData$mapSubDe3, _edcrData$mapSubDetai7, _applicationData107, _applicationData107$m, _applicationData108, _applicationData109, _applicationData109$m, _edcrData$mapSubDetai8, _applicationData110, _applicationData110$a, _applicationData111, _applicationData112, _applicationData112$m, _edcrData$mapSubDetai9, _applicationData113, _applicationData114, _applicationData114$m, _edcrData$mapSubDetai10, _applicationData115, _applicationData116, _applicationData117, _edcrData$additionalP, _applicationData118;
    console.log("I am here 4778");
    applicationData = {
      ...applicationData,
      applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || ((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.applicationDate) || null,
      occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || ((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.occupancy) || null,
      edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || ((_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.edcrNumber) || null,
      totalBuildUpArea: ((_applicationData5 = applicationData) === null || _applicationData5 === void 0 ? void 0 : _applicationData5.totalBuildUpArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu = planDetail.virtualBuilding) === null || _planDetail$virtualBu === void 0 ? void 0 : _planDetail$virtualBu.totalBuitUpArea),
      totalProposedArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu2 = planDetail.virtualBuilding) === null || _planDetail$virtualBu2 === void 0 ? void 0 : _planDetail$virtualBu2.totalProposedArea) || ((_applicationData6 = applicationData) === null || _applicationData6 === void 0 ? void 0 : _applicationData6.totalProposedArea),
      totalExistingBuiltUpArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu3 = planDetail.virtualBuilding) === null || _planDetail$virtualBu3 === void 0 ? void 0 : _planDetail$virtualBu3.totalExistingBuiltUpArea) || ((_applicationData7 = applicationData) === null || _applicationData7 === void 0 ? void 0 : _applicationData7.totalExistingBuiltUpArea),
      maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu4 = planDetail.virtualBuilding) === null || _planDetail$virtualBu4 === void 0 ? void 0 : (_planDetail$virtualBu5 = _planDetail$virtualBu4.totalCoverageArea) === null || _planDetail$virtualBu5 === void 0 ? void 0 : _planDetail$virtualBu5.toFixed(2)) || ((_applicationData8 = applicationData) === null || _applicationData8 === void 0 ? void 0 : _applicationData8.maximumPermissibleGroundCoverage) || null,
      typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone) || ((_applicationData9 = applicationData) === null || _applicationData9 === void 0 ? void 0 : _applicationData9.typeofArea),
      propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP = planDetail.planInfoProperties) === null || _planDetail$planInfoP === void 0 ? void 0 : _planDetail$planInfoP.PROPERTY_TYPE)) || ((_applicationData10 = applicationData) === null || _applicationData10 === void 0 ? void 0 : _applicationData10.propertyType),
      revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || ((_applicationData11 = applicationData) === null || _applicationData11 === void 0 ? void 0 : _applicationData11.revenueVillageMohal) || null,
      khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || ((_applicationData12 = applicationData) === null || _applicationData12 === void 0 ? void 0 : _applicationData12.khataNo) || null,
      khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || ((_applicationData13 = applicationData) === null || _applicationData13 === void 0 ? void 0 : _applicationData13.khatauniNo) || null,
      plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot2 = planDetail.plot) === null || _planDetail$plot2 === void 0 ? void 0 : _planDetail$plot2.area) || ((_applicationData14 = applicationData) === null || _applicationData14 === void 0 ? void 0 : _applicationData14.plotArea) || 0,
      viewPdf: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPdf,
      viewPlanReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPlanReport,
      totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || ((_applicationData15 = applicationData) === null || _applicationData15 === void 0 ? void 0 : _applicationData15.totalPlotArea) || 0,
      blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || ((_applicationData16 = applicationData) === null || _applicationData16 === void 0 ? void 0 : _applicationData16.blocks) || null,
      noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks2 = planDetail.blocks) === null || _planDetail$blocks2 === void 0 ? void 0 : _planDetail$blocks2.length) || ((_applicationData17 = applicationData) === null || _applicationData17 === void 0 ? void 0 : _applicationData17.noOfBlocks) || 0,
      premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu6 = planDetail.virtualBuilding) === null || _planDetail$virtualBu6 === void 0 ? void 0 : _planDetail$virtualBu6.premiumFarArea) || ((_applicationData18 = applicationData) === null || _applicationData18 === void 0 ? void 0 : _applicationData18.premiumFAR) || 0,
      demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || ((_applicationData19 = applicationData) === null || _applicationData19 === void 0 ? void 0 : _applicationData19.demolitionArea) || null,
      parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe = planDetail.parkingDetails) === null || _planDetail$parkingDe === void 0 ? void 0 : _planDetail$parkingDe.overAllParkingArea) || ((_applicationData20 = applicationData) === null || _applicationData20 === void 0 ? void 0 : _applicationData20.parkingArea) || 0,
      parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe2 = planDetail.parkingDetails) === null || _planDetail$parkingDe2 === void 0 ? void 0 : _planDetail$parkingDe2.parkingFloorNo) || ((_applicationData21 = applicationData) === null || _applicationData21 === void 0 ? void 0 : _applicationData21.parkingFloorNo) || 0,
      activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || ((_applicationData22 = applicationData) === null || _applicationData22 === void 0 ? void 0 : _applicationData22.activeTab) || 0,
      riskType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType) || ((_applicationData23 = applicationData) === null || _applicationData23 === void 0 ? void 0 : _applicationData23.riskType),
      planReport: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport) || ((_applicationData24 = applicationData) === null || _applicationData24 === void 0 ? void 0 : _applicationData24.planReport),
      updatedDxfFile: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile) || ((_applicationData25 = applicationData) === null || _applicationData25 === void 0 ? void 0 : _applicationData25.updatedDxfFile),
      dxfFile: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile) || ((_applicationData26 = applicationData) === null || _applicationData26 === void 0 ? void 0 : _applicationData26.dxfFile),
      natureOfConstruction: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction) || ((_applicationData27 = applicationData) === null || _applicationData27 === void 0 ? void 0 : _applicationData27.natureOfConstruction),
      proposalType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType) || ((_applicationData28 = applicationData) === null || _applicationData28 === void 0 ? void 0 : _applicationData28.proposalType),
      sanctionDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate) || ((_applicationData29 = applicationData) === null || _applicationData29 === void 0 ? void 0 : _applicationData29.sanctionDate),
      sanctionNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber) || ((_applicationData30 = applicationData) === null || _applicationData30 === void 0 ? void 0 : _applicationData30.sanctionNumber),
      noOfPlots: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots) || ((_applicationData31 = applicationData) === null || _applicationData31 === void 0 ? void 0 : _applicationData31.noOfPlots),
      plotNumbers: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers) || ((_applicationData32 = applicationData) === null || _applicationData32 === void 0 ? void 0 : _applicationData32.plotNumbers),
      district: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.district) || ((_applicationData33 = applicationData) === null || _applicationData33 === void 0 ? void 0 : _applicationData33.district),
      sectorNoPlotNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo) || ((_applicationData34 = applicationData) === null || _applicationData34 === void 0 ? void 0 : _applicationData34.sectorNoPlotNo),
      tehsil: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil) || ((_applicationData35 = applicationData) === null || _applicationData35 === void 0 ? void 0 : _applicationData35.tehsil),
      revenueVillage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage) || ((_applicationData36 = applicationData) === null || _applicationData36 === void 0 ? void 0 : _applicationData36.revenueVillage),
      landMark: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark) || ((_applicationData37 = applicationData) === null || _applicationData37 === void 0 ? void 0 : _applicationData37.landMark),
      schemeName: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName) || ((_applicationData38 = applicationData) === null || _applicationData38 === void 0 ? void 0 : _applicationData38.schemeName),
      buildingClassification: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification) || ((_applicationData39 = applicationData) === null || _applicationData39 === void 0 ? void 0 : _applicationData39.buildingClassification),
      otherbuildingClass: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass) || ((_applicationData40 = applicationData) === null || _applicationData40 === void 0 ? void 0 : _applicationData40.otherbuildingClass),
      planOn: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn) || ((_applicationData41 = applicationData) === null || _applicationData41 === void 0 ? void 0 : _applicationData41.planOn),
      buildingHeight: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight) || ((_applicationData42 = applicationData) === null || _applicationData42 === void 0 ? void 0 : _applicationData42.buildingHeight),
      projectType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType) || ((_applicationData43 = applicationData) === null || _applicationData43 === void 0 ? void 0 : _applicationData43.projectType),
      isRevised: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised) || ((_applicationData44 = applicationData) === null || _applicationData44 === void 0 ? void 0 : _applicationData44.isRevised),
      prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData45 = applicationData) === null || _applicationData45 === void 0 ? void 0 : _applicationData45.prevFileNo) || ((_applicationData46 = applicationData) === null || _applicationData46 === void 0 ? void 0 : (_applicationData46$ma = _applicationData46.mapSubDetails) === null || _applicationData46$ma === void 0 ? void 0 : _applicationData46$ma.prevFileNo) || ((_applicationData47 = applicationData) === null || _applicationData47 === void 0 ? void 0 : (_applicationData47$ad = _applicationData47.additionalDetails) === null || _applicationData47$ad === void 0 ? void 0 : _applicationData47$ad.oldCaseApplicationNo) || null,
      sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData48 = applicationData) === null || _applicationData48 === void 0 ? void 0 : _applicationData48.sanctionValidityDate) || ((_applicationData49 = applicationData) === null || _applicationData49 === void 0 ? void 0 : (_applicationData49$ma = _applicationData49.mapSubDetails) === null || _applicationData49$ma === void 0 ? void 0 : _applicationData49$ma.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai === void 0 ? void 0 : _edcrData$mapSubDetai.sanctionValidityDate) || null,
      sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData50 = applicationData) === null || _applicationData50 === void 0 ? void 0 : _applicationData50.sanctionValidityStartDate) || ((_applicationData51 = applicationData) === null || _applicationData51 === void 0 ? void 0 : (_applicationData51$ma = _applicationData51.mapSubDetails) === null || _applicationData51$ma === void 0 ? void 0 : _applicationData51$ma.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai2 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai2 === void 0 ? void 0 : _edcrData$mapSubDetai2.sanctionValidityStartDate) || null,
      isSpecialProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject) || ((_applicationData52 = applicationData) === null || _applicationData52 === void 0 ? void 0 : _applicationData52.isSpecialProject),
      specialProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProject) || ((_applicationData53 = applicationData) === null || _applicationData53 === void 0 ? void 0 : _applicationData53.specialProject),
      specialProjectType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProjectType) || ((_applicationData54 = applicationData) === null || _applicationData54 === void 0 ? void 0 : _applicationData54.specialProjectType),
      typeOfProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject) || ((_applicationData55 = applicationData) === null || _applicationData55 === void 0 ? void 0 : _applicationData55.typeOfProject),
      plotSubdivided: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided) || ((_applicationData56 = applicationData) === null || _applicationData56 === void 0 ? void 0 : _applicationData56.plotSubdivided),
      plotNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo) || ((_applicationData57 = applicationData) === null || _applicationData57 === void 0 ? void 0 : _applicationData57.plotNo),
      isGovernmentBuilding: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isGovernmentBuilding) || ((_applicationData58 = applicationData) === null || _applicationData58 === void 0 ? void 0 : _applicationData58.isGovernmentBuilding),
      needCompounding: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding) || ((_applicationData59 = applicationData) === null || _applicationData59 === void 0 ? void 0 : _applicationData59.needCompounding),
      plotLeaseHold: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold) || ((_applicationData60 = applicationData) === null || _applicationData60 === void 0 ? void 0 : _applicationData60.plotLeaseHold),
      isApprovedLayout: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout) || ((_applicationData61 = applicationData) === null || _applicationData61 === void 0 ? void 0 : _applicationData61.isApprovedLayout),
      isSpecialGroundCoverage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage) || ((_applicationData62 = applicationData) === null || _applicationData62 === void 0 ? void 0 : _applicationData62.isSpecialGroundCoverage),
      isSpecialFAR: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR) || ((_applicationData63 = applicationData) === null || _applicationData63 === void 0 ? void 0 : _applicationData63.isSpecialFAR),
      constructionType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType) || ((_applicationData64 = applicationData) === null || _applicationData64 === void 0 ? void 0 : _applicationData64.constructionType),
      layoutsanctionNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber) || ((_applicationData65 = applicationData) === null || _applicationData65 === void 0 ? void 0 : _applicationData65.layoutsanctionNumber),
      layoutsanctionDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate) || ((_applicationData66 = applicationData) === null || _applicationData66 === void 0 ? void 0 : _applicationData66.layoutsanctionDate),
      groundCoverage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages) || ((_applicationData67 = applicationData) === null || _applicationData67 === void 0 ? void 0 : _applicationData67.groundCoverage),
      far: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars) || ((_applicationData68 = applicationData) === null || _applicationData68 === void 0 ? void 0 : _applicationData68.far),
      isSetbackRequired: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired) || ((_applicationData69 = applicationData) === null || _applicationData69 === void 0 ? void 0 : _applicationData69.isSetbackRequired),
      setbackFronts: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront) || ((_applicationData70 = applicationData) === null || _applicationData70 === void 0 ? void 0 : _applicationData70.setbackFronts),
      setbackRears: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear) || ((_applicationData71 = applicationData) === null || _applicationData71 === void 0 ? void 0 : _applicationData71.setbackRears),
      setbackSide1: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1) || ((_applicationData72 = applicationData) === null || _applicationData72 === void 0 ? void 0 : _applicationData72.setbackSide1),
      setbackSide2: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2) || ((_applicationData73 = applicationData) === null || _applicationData73 === void 0 ? void 0 : _applicationData73.setbackSide2),
      zoneType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType) || ((_applicationData74 = applicationData) === null || _applicationData74 === void 0 ? void 0 : _applicationData74.zoneType),
      isMetroCity: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity) || ((_applicationData75 = applicationData) === null || _applicationData75 === void 0 ? void 0 : _applicationData75.isMetroCity),
      subZoneType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType) || ((_applicationData76 = applicationData) === null || _applicationData76 === void 0 ? void 0 : _applicationData76.subZoneType),
      primaryUse: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse) || ((_applicationData77 = applicationData) === null || _applicationData77 === void 0 ? void 0 : _applicationData77.primaryUse),
      activityProposed: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) || ((_applicationData78 = applicationData) === null || _applicationData78 === void 0 ? void 0 : _applicationData78.activityProposed),
      developmentPlan: ((_applicationData79 = applicationData) === null || _applicationData79 === void 0 ? void 0 : _applicationData79.developmentPlan) || ((_applicationData80 = applicationData) === null || _applicationData80 === void 0 ? void 0 : (_applicationData80$ad = _applicationData80.additionalDetails) === null || _applicationData80$ad === void 0 ? void 0 : _applicationData80$ad.developmentPlan) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentPlan) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.developmentPlan) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD = edcrData.additionalDetails) === null || _edcrData$additionalD === void 0 ? void 0 : _edcrData$additionalD.developmentPlan) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$addition = fastPasData.additionalDetails) === null || _fastPasData$addition === void 0 ? void 0 : _fastPasData$addition.developmentPlan),
      communityParking: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking) || ((_applicationData81 = applicationData) === null || _applicationData81 === void 0 ? void 0 : _applicationData81.communityParking),
      anyotherCondition: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition) || ((_applicationData82 = applicationData) === null || _applicationData82 === void 0 ? void 0 : _applicationData82.anyotherCondition),
      khasraNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo) || ((_applicationData83 = applicationData) === null || _applicationData83 === void 0 ? void 0 : _applicationData83.khasraNo),
      sectorNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo) || ((_applicationData84 = applicationData) === null || _applicationData84 === void 0 ? void 0 : _applicationData84.sectorNo),
      fastPASId: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.land_Id) || ((_applicationData85 = applicationData) === null || _applicationData85 === void 0 ? void 0 : _applicationData85.fastPASId),
      schemeType: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript = fastPasData.descriptionOfLand) === null || _fastPasData$descript === void 0 ? void 0 : _fastPasData$descript.schemeType) || ((_applicationData86 = applicationData) === null || _applicationData86 === void 0 ? void 0 : _applicationData86.schemeType),
      typeOfArea: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript2 = fastPasData.descriptionOfLand) === null || _fastPasData$descript2 === void 0 ? void 0 : _fastPasData$descript2.developmentArea) || ((_applicationData87 = applicationData) === null || _applicationData87 === void 0 ? void 0 : _applicationData87.typeOfArea),
      latitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript3 = fastPasData.descriptionOfLand) === null || _fastPasData$descript3 === void 0 ? void 0 : _fastPasData$descript3.latitude) || ((_applicationData88 = applicationData) === null || _applicationData88 === void 0 ? void 0 : _applicationData88.latitude),
      longitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript4 = fastPasData.descriptionOfLand) === null || _fastPasData$descript4 === void 0 ? void 0 : _fastPasData$descript4.longitude) || ((_applicationData89 = applicationData) === null || _applicationData89 === void 0 ? void 0 : _applicationData89.longitude),
      latitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript5 = fastPasData.descriptionOfLand) === null || _fastPasData$descript5 === void 0 ? void 0 : _fastPasData$descript5.latitude) || ((_applicationData90 = applicationData) === null || _applicationData90 === void 0 ? void 0 : _applicationData90.latitude),
      roadwidth: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript6 = fastPasData.descriptionOfLand) === null || _fastPasData$descript6 === void 0 ? void 0 : (_fastPasData$descript7 = _fastPasData$descript6.roadWidths) === null || _fastPasData$descript7 === void 0 ? void 0 : (_fastPasData$descript8 = _fastPasData$descript7[0]) === null || _fastPasData$descript8 === void 0 ? void 0 : _fastPasData$descript8.value) || ((_applicationData91 = applicationData) === null || _applicationData91 === void 0 ? void 0 : _applicationData91.roadwidth),
      approachRoadWidth: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript9 = fastPasData.descriptionOfLand) === null || _fastPasData$descript9 === void 0 ? void 0 : (_fastPasData$descript10 = _fastPasData$descript9.approachRoadWidths) === null || _fastPasData$descript10 === void 0 ? void 0 : (_fastPasData$descript11 = _fastPasData$descript10[0]) === null || _fastPasData$descript11 === void 0 ? void 0 : _fastPasData$descript11.value) || ((_applicationData92 = applicationData) === null || _applicationData92 === void 0 ? void 0 : _applicationData92.approachRoadWidth),
      khasraDetails: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.khasraDetails) || ((_applicationData93 = applicationData) === null || _applicationData93 === void 0 ? void 0 : _applicationData93.khasraDetails),
      scrutinyFlow: ((_applicationData94 = applicationData) === null || _applicationData94 === void 0 ? void 0 : _applicationData94.scrutinyFlow) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) && "EDCR",
      selectedCity: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedCity) || ((_applicationData95 = applicationData) === null || _applicationData95 === void 0 ? void 0 : _applicationData95.selectedCity),
      selectedUnit: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$addition2 = fastPasData.additionalDetails) === null || _fastPasData$addition2 === void 0 ? void 0 : _fastPasData$addition2.selectedUnit) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedUnit) || ((_applicationData96 = applicationData) === null || _applicationData96 === void 0 ? void 0 : _applicationData96.selectedUnit) || ((_applicationData97 = applicationData) === null || _applicationData97 === void 0 ? void 0 : (_applicationData97$ad = _applicationData97.additionalDetails) === null || _applicationData97$ad === void 0 ? void 0 : _applicationData97$ad.selectedUnit),
      schemeName: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.schemeName) || ((_applicationData98 = applicationData) === null || _applicationData98 === void 0 ? void 0 : _applicationData98.schemeName),
      landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai3 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai3 === void 0 ? void 0 : _edcrData$mapSubDetai3.landUseApprovalLetter) || ((_applicationData99 = applicationData) === null || _applicationData99 === void 0 ? void 0 : _applicationData99.landUseApprovalLetter) || ((_applicationData100 = applicationData) === null || _applicationData100 === void 0 ? void 0 : _applicationData100.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe === void 0 ? void 0 : _fastPasData$mapSubDe.landUseApprovalLetter),
      approvalLetterUrl: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai4 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai4 === void 0 ? void 0 : _edcrData$mapSubDetai4.landUseApprovalLetter) || ((_applicationData101 = applicationData) === null || _applicationData101 === void 0 ? void 0 : _applicationData101.landUseApprovalLetter) || ((_applicationData102 = applicationData) === null || _applicationData102 === void 0 ? void 0 : _applicationData102.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe2 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe2 === void 0 ? void 0 : _fastPasData$mapSubDe2.landUseApprovalLetter),
      mapSubDetails: {
        ...((_applicationData103 = applicationData) === null || _applicationData103 === void 0 ? void 0 : _applicationData103.mapSubDetails),
        ...(edcrData === null || edcrData === void 0 ? void 0 : edcrData.mapSubDetails),
        proposalTypeFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai5 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai5 === void 0 ? void 0 : _edcrData$mapSubDetai5.proposalTypeFAR) || ((_applicationData104 = applicationData) === null || _applicationData104 === void 0 ? void 0 : (_applicationData104$m = _applicationData104.mapSubDetails) === null || _applicationData104$m === void 0 ? void 0 : _applicationData104$m.proposalTypeFAR),
        landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai6 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai6 === void 0 ? void 0 : _edcrData$mapSubDetai6.landUseApprovalLetter) || ((_applicationData105 = applicationData) === null || _applicationData105 === void 0 ? void 0 : _applicationData105.landUseApprovalLetter) || ((_applicationData106 = applicationData) === null || _applicationData106 === void 0 ? void 0 : _applicationData106.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe3 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe3 === void 0 ? void 0 : _fastPasData$mapSubDe3.landUseApprovalLetter),
        fireFighting: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai7 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai7 === void 0 ? void 0 : _edcrData$mapSubDetai7.fireFighting) || ((_applicationData107 = applicationData) === null || _applicationData107 === void 0 ? void 0 : (_applicationData107$m = _applicationData107.mapSubDetails) === null || _applicationData107$m === void 0 ? void 0 : _applicationData107$m.fireFighting),
        prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData108 = applicationData) === null || _applicationData108 === void 0 ? void 0 : _applicationData108.prevFileNo) || ((_applicationData109 = applicationData) === null || _applicationData109 === void 0 ? void 0 : (_applicationData109$m = _applicationData109.mapSubDetails) === null || _applicationData109$m === void 0 ? void 0 : _applicationData109$m.prevFileNo) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai8 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai8 === void 0 ? void 0 : _edcrData$mapSubDetai8.prevFileNo) || ((_applicationData110 = applicationData) === null || _applicationData110 === void 0 ? void 0 : (_applicationData110$a = _applicationData110.additionalDetails) === null || _applicationData110$a === void 0 ? void 0 : _applicationData110$a.oldCaseApplicationNo) || null,
        sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData111 = applicationData) === null || _applicationData111 === void 0 ? void 0 : _applicationData111.sanctionValidityDate) || ((_applicationData112 = applicationData) === null || _applicationData112 === void 0 ? void 0 : (_applicationData112$m = _applicationData112.mapSubDetails) === null || _applicationData112$m === void 0 ? void 0 : _applicationData112$m.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai9 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai9 === void 0 ? void 0 : _edcrData$mapSubDetai9.sanctionValidityDate) || null,
        sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData113 = applicationData) === null || _applicationData113 === void 0 ? void 0 : _applicationData113.sanctionValidityStartDate) || ((_applicationData114 = applicationData) === null || _applicationData114 === void 0 ? void 0 : (_applicationData114$m = _applicationData114.mapSubDetails) === null || _applicationData114$m === void 0 ? void 0 : _applicationData114$m.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai10 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai10 === void 0 ? void 0 : _edcrData$mapSubDetai10.sanctionValidityStartDate) || null
      },
      descriptionOfLand: ((_applicationData115 = applicationData) === null || _applicationData115 === void 0 ? void 0 : _applicationData115.descriptionOfLand) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.descriptionOfLand),
      landInfo: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landInfo) || ((_applicationData116 = applicationData) === null || _applicationData116 === void 0 ? void 0 : _applicationData116.landInfo),
      shelterFee: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.shelterFee) || ((_applicationData117 = applicationData) === null || _applicationData117 === void 0 ? void 0 : _applicationData117.shelterFee) || null,
      performanceGuarantee: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalP = edcrData.additionalProperties) === null || _edcrData$additionalP === void 0 ? void 0 : _edcrData$additionalP.performanceGuarantee) || ((_applicationData118 = applicationData) === null || _applicationData118 === void 0 ? void 0 : _applicationData118.performanceGuarantee) || null
    };
    return {
      applicationData,
      isAppDataLoading
    };
  } else if (id && isSuccess && isRescrutiny) {
    var _applicationData119, _applicationData120, _applicationData121, _planDetail$virtualBu7, _applicationData122, _planDetail$virtualBu8, _applicationData123, _planDetail$virtualBu9, _applicationData124, _planDetail$virtualBu10, _planDetail$virtualBu11, _applicationData125, _applicationData126, _planDetail$planInfoP2, _applicationData127, _applicationData128, _applicationData129, _applicationData130, _applicationData131, _applicationData132, _applicationData133, _planDetail$plot3, _applicationData134, _applicationData135, _applicationData136, _planDetail$blocks3, _applicationData137, _planDetail$virtualBu12, _applicationData138, _applicationData139, _planDetail$parkingDe3, _applicationData140, _planDetail$parkingDe4, _applicationData141, _Digit2, _applicationData142, _applicationData143, _applicationData144, _applicationData145, _applicationData146, _applicationData147, _applicationData148, _applicationData149, _applicationData150, _applicationData151, _applicationData152, _applicationData153, _applicationData154, _applicationData155, _applicationData156, _applicationData157, _applicationData158, _applicationData159, _applicationData160, _applicationData161, _applicationData162, _applicationData163, _applicationData164, _applicationData165, _applicationData166, _applicationData166$m, _applicationData167, _applicationData167$a, _applicationData168, _applicationData169, _applicationData169$m, _edcrData$mapSubDetai11, _applicationData170, _applicationData171, _applicationData171$m, _edcrData$mapSubDetai12, _applicationData172, _applicationData173, _applicationData174, _applicationData175, _applicationData176, _applicationData177, _applicationData178, _applicationData179, _applicationData180, _applicationData181, _applicationData182, _applicationData183, _applicationData184, _applicationData185, _applicationData186, _applicationData187, _applicationData188, _applicationData189, _applicationData190, _applicationData191, _applicationData192, _applicationData193, _applicationData194, _applicationData195, _applicationData196, _applicationData197, _applicationData198, _applicationData199, _applicationData200, _applicationData201, _applicationData202, _applicationData203, _fastPasData$descript12, _applicationData204, _fastPasData$descript13, _applicationData205, _fastPasData$descript14, _applicationData206, _fastPasData$descript15, _applicationData207, _fastPasData$descript16, _applicationData208, _fastPasData$descript17, _fastPasData$descript18, _fastPasData$descript19, _applicationData209, _fastPasData$descript20, _fastPasData$descript21, _fastPasData$descript22, _applicationData210, _applicationData211, _applicationData212, _applicationData213, _fastPasData$addition3, _applicationData214, _applicationData215, _applicationData215$a, _applicationData216, _edcrData$mapSubDetai13, _applicationData217, _applicationData218, _fastPasData$mapSubDe4, _edcrData$mapSubDetai14, _applicationData219, _applicationData220, _fastPasData$mapSubDe5, _applicationData221, _edcrData$mapSubDetai15, _applicationData222, _applicationData222$m, _edcrData$mapSubDetai16, _applicationData223, _applicationData224, _fastPasData$mapSubDe6, _edcrData$mapSubDetai17, _applicationData225, _applicationData225$m, _applicationData226, _applicationData227, _applicationData227$m, _edcrData$mapSubDetai18, _applicationData228, _applicationData228$a, _applicationData229, _applicationData230, _applicationData230$m, _edcrData$mapSubDetai19, _applicationData231, _applicationData232, _applicationData232$m, _edcrData$mapSubDetai20, _applicationData233, _applicationData234, _applicationData235, _edcrData$additionalP2, _applicationData236;
    console.log("I am here 218", planInformation);
    applicationData = {
      ...applicationData,
      applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || ((_applicationData119 = applicationData) === null || _applicationData119 === void 0 ? void 0 : _applicationData119.applicationDate) || null,
      occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || ((_applicationData120 = applicationData) === null || _applicationData120 === void 0 ? void 0 : _applicationData120.occupancy) || null,
      edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || ((_applicationData121 = applicationData) === null || _applicationData121 === void 0 ? void 0 : _applicationData121.edcrNumber) || null,
      totalBuildUpArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu7 = planDetail.virtualBuilding) === null || _planDetail$virtualBu7 === void 0 ? void 0 : _planDetail$virtualBu7.totalBuitUpArea) || ((_applicationData122 = applicationData) === null || _applicationData122 === void 0 ? void 0 : _applicationData122.totalBuildUpArea),
      totalProposedArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu8 = planDetail.virtualBuilding) === null || _planDetail$virtualBu8 === void 0 ? void 0 : _planDetail$virtualBu8.totalProposedArea) || ((_applicationData123 = applicationData) === null || _applicationData123 === void 0 ? void 0 : _applicationData123.totalProposedArea),
      totalExistingBuiltUpArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu9 = planDetail.virtualBuilding) === null || _planDetail$virtualBu9 === void 0 ? void 0 : _planDetail$virtualBu9.totalExistingBuiltUpArea) || ((_applicationData124 = applicationData) === null || _applicationData124 === void 0 ? void 0 : _applicationData124.totalExistingBuiltUpArea),
      maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu10 = planDetail.virtualBuilding) === null || _planDetail$virtualBu10 === void 0 ? void 0 : (_planDetail$virtualBu11 = _planDetail$virtualBu10.totalCoverageArea) === null || _planDetail$virtualBu11 === void 0 ? void 0 : _planDetail$virtualBu11.toFixed(2)) || ((_applicationData125 = applicationData) === null || _applicationData125 === void 0 ? void 0 : _applicationData125.maximumPermissibleGroundCoverage) || null,
      typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone) || ((_applicationData126 = applicationData) === null || _applicationData126 === void 0 ? void 0 : _applicationData126.typeofArea),
      propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP2 = planDetail.planInfoProperties) === null || _planDetail$planInfoP2 === void 0 ? void 0 : _planDetail$planInfoP2.PROPERTY_TYPE)) || ((_applicationData127 = applicationData) === null || _applicationData127 === void 0 ? void 0 : _applicationData127.propertyType),
      revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || ((_applicationData128 = applicationData) === null || _applicationData128 === void 0 ? void 0 : _applicationData128.revenueVillageMohal) || null,
      khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || ((_applicationData129 = applicationData) === null || _applicationData129 === void 0 ? void 0 : _applicationData129.khataNo) || null,
      khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || ((_applicationData130 = applicationData) === null || _applicationData130 === void 0 ? void 0 : _applicationData130.khatauniNo) || null,
      purchasableFar: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.purchasableFar) || ((_applicationData131 = applicationData) === null || _applicationData131 === void 0 ? void 0 : _applicationData131.purchasableFar) || null,
      compensatoryFAR: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.compensatoryFAR) || ((_applicationData132 = applicationData) === null || _applicationData132 === void 0 ? void 0 : _applicationData132.compensatoryFAR) || null,
      transferredLandArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.transferredLandArea) || ((_applicationData133 = applicationData) === null || _applicationData133 === void 0 ? void 0 : _applicationData133.transferredLandArea) || null,
      plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot3 = planDetail.plot) === null || _planDetail$plot3 === void 0 ? void 0 : _planDetail$plot3.area) || ((_applicationData134 = applicationData) === null || _applicationData134 === void 0 ? void 0 : _applicationData134.plotArea) || 0,
      viewPdf: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPdf,
      viewPlanReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPlanReport,
      totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || ((_applicationData135 = applicationData) === null || _applicationData135 === void 0 ? void 0 : _applicationData135.totalPlotArea) || 0,
      blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || ((_applicationData136 = applicationData) === null || _applicationData136 === void 0 ? void 0 : _applicationData136.blocks) || null,
      noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks3 = planDetail.blocks) === null || _planDetail$blocks3 === void 0 ? void 0 : _planDetail$blocks3.length) || ((_applicationData137 = applicationData) === null || _applicationData137 === void 0 ? void 0 : _applicationData137.noOfBlocks) || 0,
      premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu12 = planDetail.virtualBuilding) === null || _planDetail$virtualBu12 === void 0 ? void 0 : _planDetail$virtualBu12.premiumFarArea) || ((_applicationData138 = applicationData) === null || _applicationData138 === void 0 ? void 0 : _applicationData138.premiumFAR) || 0,
      demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || ((_applicationData139 = applicationData) === null || _applicationData139 === void 0 ? void 0 : _applicationData139.demolitionArea) || null,
      parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe3 = planDetail.parkingDetails) === null || _planDetail$parkingDe3 === void 0 ? void 0 : _planDetail$parkingDe3.overAllParkingArea) || ((_applicationData140 = applicationData) === null || _applicationData140 === void 0 ? void 0 : _applicationData140.parkingArea) || 0,
      parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe4 = planDetail.parkingDetails) === null || _planDetail$parkingDe4 === void 0 ? void 0 : _planDetail$parkingDe4.parkingFloorNo) || ((_applicationData141 = applicationData) === null || _applicationData141 === void 0 ? void 0 : _applicationData141.parkingFloorNo) || 0,
      activeTab: ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_TAB")) || ((_applicationData142 = applicationData) === null || _applicationData142 === void 0 ? void 0 : _applicationData142.activeTab) || 0,
      riskType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType) || ((_applicationData143 = applicationData) === null || _applicationData143 === void 0 ? void 0 : _applicationData143.riskType),
      planReport: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport) || ((_applicationData144 = applicationData) === null || _applicationData144 === void 0 ? void 0 : _applicationData144.planReport),
      updatedDxfFile: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile) || ((_applicationData145 = applicationData) === null || _applicationData145 === void 0 ? void 0 : _applicationData145.updatedDxfFile),
      dxfFile: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile) || ((_applicationData146 = applicationData) === null || _applicationData146 === void 0 ? void 0 : _applicationData146.dxfFile),
      natureOfConstruction: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction) || ((_applicationData147 = applicationData) === null || _applicationData147 === void 0 ? void 0 : _applicationData147.natureOfConstruction),
      proposalType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType) || ((_applicationData148 = applicationData) === null || _applicationData148 === void 0 ? void 0 : _applicationData148.proposalType),
      sanctionDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate) || ((_applicationData149 = applicationData) === null || _applicationData149 === void 0 ? void 0 : _applicationData149.sanctionDate),
      sanctionNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber) || ((_applicationData150 = applicationData) === null || _applicationData150 === void 0 ? void 0 : _applicationData150.sanctionNumber),
      noOfPlots: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots) || ((_applicationData151 = applicationData) === null || _applicationData151 === void 0 ? void 0 : _applicationData151.noOfPlots),
      plotNumbers: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers) || ((_applicationData152 = applicationData) === null || _applicationData152 === void 0 ? void 0 : _applicationData152.plotNumbers),
      district: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.district) || ((_applicationData153 = applicationData) === null || _applicationData153 === void 0 ? void 0 : _applicationData153.district),
      sectorNoPlotNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo) || ((_applicationData154 = applicationData) === null || _applicationData154 === void 0 ? void 0 : _applicationData154.sectorNoPlotNo),
      tehsil: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil) || ((_applicationData155 = applicationData) === null || _applicationData155 === void 0 ? void 0 : _applicationData155.tehsil),
      revenueVillage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage) || ((_applicationData156 = applicationData) === null || _applicationData156 === void 0 ? void 0 : _applicationData156.revenueVillage),
      landMark: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark) || ((_applicationData157 = applicationData) === null || _applicationData157 === void 0 ? void 0 : _applicationData157.landMark),
      schemeName: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName) || ((_applicationData158 = applicationData) === null || _applicationData158 === void 0 ? void 0 : _applicationData158.schemeName),
      buildingClassification: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification) || ((_applicationData159 = applicationData) === null || _applicationData159 === void 0 ? void 0 : _applicationData159.buildingClassification),
      otherbuildingClass: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass) || ((_applicationData160 = applicationData) === null || _applicationData160 === void 0 ? void 0 : _applicationData160.otherbuildingClass),
      planOn: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn) || ((_applicationData161 = applicationData) === null || _applicationData161 === void 0 ? void 0 : _applicationData161.planOn),
      buildingHeight: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight) || ((_applicationData162 = applicationData) === null || _applicationData162 === void 0 ? void 0 : _applicationData162.buildingHeight),
      projectType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType) || ((_applicationData163 = applicationData) === null || _applicationData163 === void 0 ? void 0 : _applicationData163.projectType),
      isRevised: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised) || ((_applicationData164 = applicationData) === null || _applicationData164 === void 0 ? void 0 : _applicationData164.isRevised),
      prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData165 = applicationData) === null || _applicationData165 === void 0 ? void 0 : _applicationData165.prevFileNo) || ((_applicationData166 = applicationData) === null || _applicationData166 === void 0 ? void 0 : (_applicationData166$m = _applicationData166.mapSubDetails) === null || _applicationData166$m === void 0 ? void 0 : _applicationData166$m.prevFileNo) || ((_applicationData167 = applicationData) === null || _applicationData167 === void 0 ? void 0 : (_applicationData167$a = _applicationData167.additionalDetails) === null || _applicationData167$a === void 0 ? void 0 : _applicationData167$a.oldCaseApplicationNo) || null,
      sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData168 = applicationData) === null || _applicationData168 === void 0 ? void 0 : _applicationData168.sanctionValidityDate) || ((_applicationData169 = applicationData) === null || _applicationData169 === void 0 ? void 0 : (_applicationData169$m = _applicationData169.mapSubDetails) === null || _applicationData169$m === void 0 ? void 0 : _applicationData169$m.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai11 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai11 === void 0 ? void 0 : _edcrData$mapSubDetai11.sanctionValidityDate) || null,
      sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData170 = applicationData) === null || _applicationData170 === void 0 ? void 0 : _applicationData170.sanctionValidityStartDate) || ((_applicationData171 = applicationData) === null || _applicationData171 === void 0 ? void 0 : (_applicationData171$m = _applicationData171.mapSubDetails) === null || _applicationData171$m === void 0 ? void 0 : _applicationData171$m.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai12 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai12 === void 0 ? void 0 : _edcrData$mapSubDetai12.sanctionValidityStartDate) || null,
      isSpecialProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject) || ((_applicationData172 = applicationData) === null || _applicationData172 === void 0 ? void 0 : _applicationData172.isSpecialProject),
      specialProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProject) || ((_applicationData173 = applicationData) === null || _applicationData173 === void 0 ? void 0 : _applicationData173.specialProject),
      specialProjectType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProjectType) || ((_applicationData174 = applicationData) === null || _applicationData174 === void 0 ? void 0 : _applicationData174.specialProjectType),
      isGovernmentBuilding: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isGovernmentBuilding) || ((_applicationData175 = applicationData) === null || _applicationData175 === void 0 ? void 0 : _applicationData175.isGovernmentBuilding),
      typeOfProject: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject) || ((_applicationData176 = applicationData) === null || _applicationData176 === void 0 ? void 0 : _applicationData176.typeOfProject),
      plotSubdivided: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided) || ((_applicationData177 = applicationData) === null || _applicationData177 === void 0 ? void 0 : _applicationData177.plotSubdivided),
      plotNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo) || ((_applicationData178 = applicationData) === null || _applicationData178 === void 0 ? void 0 : _applicationData178.plotNo),
      needCompounding: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding) || ((_applicationData179 = applicationData) === null || _applicationData179 === void 0 ? void 0 : _applicationData179.needCompounding),
      plotLeaseHold: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold) || ((_applicationData180 = applicationData) === null || _applicationData180 === void 0 ? void 0 : _applicationData180.plotLeaseHold),
      isApprovedLayout: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout) || ((_applicationData181 = applicationData) === null || _applicationData181 === void 0 ? void 0 : _applicationData181.isApprovedLayout),
      isSpecialGroundCoverage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage) || ((_applicationData182 = applicationData) === null || _applicationData182 === void 0 ? void 0 : _applicationData182.isSpecialGroundCoverage),
      isSpecialFAR: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR) || ((_applicationData183 = applicationData) === null || _applicationData183 === void 0 ? void 0 : _applicationData183.isSpecialFAR),
      constructionType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType) || ((_applicationData184 = applicationData) === null || _applicationData184 === void 0 ? void 0 : _applicationData184.constructionType),
      layoutsanctionNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber) || ((_applicationData185 = applicationData) === null || _applicationData185 === void 0 ? void 0 : _applicationData185.layoutsanctionNumber),
      layoutsanctionDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate) || ((_applicationData186 = applicationData) === null || _applicationData186 === void 0 ? void 0 : _applicationData186.layoutsanctionDate),
      groundCoverage: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages) || ((_applicationData187 = applicationData) === null || _applicationData187 === void 0 ? void 0 : _applicationData187.groundCoverage),
      far: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars) || ((_applicationData188 = applicationData) === null || _applicationData188 === void 0 ? void 0 : _applicationData188.far),
      isSetbackRequired: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired) || ((_applicationData189 = applicationData) === null || _applicationData189 === void 0 ? void 0 : _applicationData189.isSetbackRequired),
      setbackFronts: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront) || ((_applicationData190 = applicationData) === null || _applicationData190 === void 0 ? void 0 : _applicationData190.setbackFronts),
      setbackRears: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear) || ((_applicationData191 = applicationData) === null || _applicationData191 === void 0 ? void 0 : _applicationData191.setbackRears),
      setbackSide1: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1) || ((_applicationData192 = applicationData) === null || _applicationData192 === void 0 ? void 0 : _applicationData192.setbackSide1),
      setbackSide2: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2) || ((_applicationData193 = applicationData) === null || _applicationData193 === void 0 ? void 0 : _applicationData193.setbackSide2),
      zoneType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType) || ((_applicationData194 = applicationData) === null || _applicationData194 === void 0 ? void 0 : _applicationData194.zoneType),
      isMetroCity: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity) || ((_applicationData195 = applicationData) === null || _applicationData195 === void 0 ? void 0 : _applicationData195.isMetroCity),
      subZoneType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType) || ((_applicationData196 = applicationData) === null || _applicationData196 === void 0 ? void 0 : _applicationData196.subZoneType),
      primaryUse: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse) || ((_applicationData197 = applicationData) === null || _applicationData197 === void 0 ? void 0 : _applicationData197.primaryUse),
      activityProposed: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) || ((_applicationData198 = applicationData) === null || _applicationData198 === void 0 ? void 0 : _applicationData198.activityProposed),
      communityParking: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking) || ((_applicationData199 = applicationData) === null || _applicationData199 === void 0 ? void 0 : _applicationData199.communityParking),
      anyotherCondition: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition) || ((_applicationData200 = applicationData) === null || _applicationData200 === void 0 ? void 0 : _applicationData200.anyotherCondition),
      khasraNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo) || ((_applicationData201 = applicationData) === null || _applicationData201 === void 0 ? void 0 : _applicationData201.khasraNo),
      sectorNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo) || ((_applicationData202 = applicationData) === null || _applicationData202 === void 0 ? void 0 : _applicationData202.sectorNo),
      fastPASId: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.land_Id) || ((_applicationData203 = applicationData) === null || _applicationData203 === void 0 ? void 0 : _applicationData203.fastPASId),
      schemeType: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript12 = fastPasData.descriptionOfLand) === null || _fastPasData$descript12 === void 0 ? void 0 : _fastPasData$descript12.schemeType) || ((_applicationData204 = applicationData) === null || _applicationData204 === void 0 ? void 0 : _applicationData204.schemeType),
      typeOfArea: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript13 = fastPasData.descriptionOfLand) === null || _fastPasData$descript13 === void 0 ? void 0 : _fastPasData$descript13.developmentArea) || ((_applicationData205 = applicationData) === null || _applicationData205 === void 0 ? void 0 : _applicationData205.typeOfArea),
      latitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript14 = fastPasData.descriptionOfLand) === null || _fastPasData$descript14 === void 0 ? void 0 : _fastPasData$descript14.latitude) || ((_applicationData206 = applicationData) === null || _applicationData206 === void 0 ? void 0 : _applicationData206.latitude),
      longitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript15 = fastPasData.descriptionOfLand) === null || _fastPasData$descript15 === void 0 ? void 0 : _fastPasData$descript15.longitude) || ((_applicationData207 = applicationData) === null || _applicationData207 === void 0 ? void 0 : _applicationData207.longitude),
      latitude: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript16 = fastPasData.descriptionOfLand) === null || _fastPasData$descript16 === void 0 ? void 0 : _fastPasData$descript16.latitude) || ((_applicationData208 = applicationData) === null || _applicationData208 === void 0 ? void 0 : _applicationData208.latitude),
      roadwidth: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript17 = fastPasData.descriptionOfLand) === null || _fastPasData$descript17 === void 0 ? void 0 : (_fastPasData$descript18 = _fastPasData$descript17.roadWidths) === null || _fastPasData$descript18 === void 0 ? void 0 : (_fastPasData$descript19 = _fastPasData$descript18[0]) === null || _fastPasData$descript19 === void 0 ? void 0 : _fastPasData$descript19.value) || ((_applicationData209 = applicationData) === null || _applicationData209 === void 0 ? void 0 : _applicationData209.roadwidth),
      approachRoadWidth: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript20 = fastPasData.descriptionOfLand) === null || _fastPasData$descript20 === void 0 ? void 0 : (_fastPasData$descript21 = _fastPasData$descript20.approachRoadWidths) === null || _fastPasData$descript21 === void 0 ? void 0 : (_fastPasData$descript22 = _fastPasData$descript21[0]) === null || _fastPasData$descript22 === void 0 ? void 0 : _fastPasData$descript22.value) || ((_applicationData210 = applicationData) === null || _applicationData210 === void 0 ? void 0 : _applicationData210.approachRoadWidth),
      khasraDetails: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.khasraDetails) || ((_applicationData211 = applicationData) === null || _applicationData211 === void 0 ? void 0 : _applicationData211.khasraDetails),
      scrutinyFlow: ((_applicationData212 = applicationData) === null || _applicationData212 === void 0 ? void 0 : _applicationData212.scrutinyFlow) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) && "EDCR",
      selectedCity: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedCity) || ((_applicationData213 = applicationData) === null || _applicationData213 === void 0 ? void 0 : _applicationData213.selectedCity),
      selectedUnit: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$addition3 = fastPasData.additionalDetails) === null || _fastPasData$addition3 === void 0 ? void 0 : _fastPasData$addition3.selectedUnit) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedUnit) || ((_applicationData214 = applicationData) === null || _applicationData214 === void 0 ? void 0 : _applicationData214.selectedUnit) || ((_applicationData215 = applicationData) === null || _applicationData215 === void 0 ? void 0 : (_applicationData215$a = _applicationData215.additionalDetails) === null || _applicationData215$a === void 0 ? void 0 : _applicationData215$a.selectedUnit),
      schemeName: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.schemeName) || ((_applicationData216 = applicationData) === null || _applicationData216 === void 0 ? void 0 : _applicationData216.schemeName),
      landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai13 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai13 === void 0 ? void 0 : _edcrData$mapSubDetai13.landUseApprovalLetter) || ((_applicationData217 = applicationData) === null || _applicationData217 === void 0 ? void 0 : _applicationData217.landUseApprovalLetter) || ((_applicationData218 = applicationData) === null || _applicationData218 === void 0 ? void 0 : _applicationData218.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe4 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe4 === void 0 ? void 0 : _fastPasData$mapSubDe4.landUseApprovalLetter),
      approvalLetterUrl: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai14 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai14 === void 0 ? void 0 : _edcrData$mapSubDetai14.landUseApprovalLetter) || ((_applicationData219 = applicationData) === null || _applicationData219 === void 0 ? void 0 : _applicationData219.landUseApprovalLetter) || ((_applicationData220 = applicationData) === null || _applicationData220 === void 0 ? void 0 : _applicationData220.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe5 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe5 === void 0 ? void 0 : _fastPasData$mapSubDe5.landUseApprovalLetter),
      mapSubDetails: {
        ...((_applicationData221 = applicationData) === null || _applicationData221 === void 0 ? void 0 : _applicationData221.mapSubDetails),
        ...(edcrData === null || edcrData === void 0 ? void 0 : edcrData.mapSubDetails),
        proposalTypeFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai15 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai15 === void 0 ? void 0 : _edcrData$mapSubDetai15.proposalTypeFAR) || ((_applicationData222 = applicationData) === null || _applicationData222 === void 0 ? void 0 : (_applicationData222$m = _applicationData222.mapSubDetails) === null || _applicationData222$m === void 0 ? void 0 : _applicationData222$m.proposalTypeFAR),
        landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai16 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai16 === void 0 ? void 0 : _edcrData$mapSubDetai16.landUseApprovalLetter) || ((_applicationData223 = applicationData) === null || _applicationData223 === void 0 ? void 0 : _applicationData223.landUseApprovalLetter) || ((_applicationData224 = applicationData) === null || _applicationData224 === void 0 ? void 0 : _applicationData224.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe6 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe6 === void 0 ? void 0 : _fastPasData$mapSubDe6.landUseApprovalLetter),
        fireFighting: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai17 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai17 === void 0 ? void 0 : _edcrData$mapSubDetai17.fireFighting) || ((_applicationData225 = applicationData) === null || _applicationData225 === void 0 ? void 0 : (_applicationData225$m = _applicationData225.mapSubDetails) === null || _applicationData225$m === void 0 ? void 0 : _applicationData225$m.fireFighting),
        prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData226 = applicationData) === null || _applicationData226 === void 0 ? void 0 : _applicationData226.prevFileNo) || ((_applicationData227 = applicationData) === null || _applicationData227 === void 0 ? void 0 : (_applicationData227$m = _applicationData227.mapSubDetails) === null || _applicationData227$m === void 0 ? void 0 : _applicationData227$m.prevFileNo) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai18 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai18 === void 0 ? void 0 : _edcrData$mapSubDetai18.prevFileNo) || ((_applicationData228 = applicationData) === null || _applicationData228 === void 0 ? void 0 : (_applicationData228$a = _applicationData228.additionalDetails) === null || _applicationData228$a === void 0 ? void 0 : _applicationData228$a.oldCaseApplicationNo) || null,
        sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData229 = applicationData) === null || _applicationData229 === void 0 ? void 0 : _applicationData229.sanctionValidityDate) || ((_applicationData230 = applicationData) === null || _applicationData230 === void 0 ? void 0 : (_applicationData230$m = _applicationData230.mapSubDetails) === null || _applicationData230$m === void 0 ? void 0 : _applicationData230$m.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai19 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai19 === void 0 ? void 0 : _edcrData$mapSubDetai19.sanctionValidityDate) || null,
        sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData231 = applicationData) === null || _applicationData231 === void 0 ? void 0 : _applicationData231.sanctionValidityStartDate) || ((_applicationData232 = applicationData) === null || _applicationData232 === void 0 ? void 0 : (_applicationData232$m = _applicationData232.mapSubDetails) === null || _applicationData232$m === void 0 ? void 0 : _applicationData232$m.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai20 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai20 === void 0 ? void 0 : _edcrData$mapSubDetai20.sanctionValidityStartDate) || null
      },
      descriptionOfLand: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.descriptionOfLand) || ((_applicationData233 = applicationData) === null || _applicationData233 === void 0 ? void 0 : _applicationData233.descriptionOfLand),
      landInfo: (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landInfo) || ((_applicationData234 = applicationData) === null || _applicationData234 === void 0 ? void 0 : _applicationData234.landInfo),
      shelterFee: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.shelterFee) || ((_applicationData235 = applicationData) === null || _applicationData235 === void 0 ? void 0 : _applicationData235.shelterFee) || null,
      performanceGuarantee: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalP2 = edcrData.additionalProperties) === null || _edcrData$additionalP2 === void 0 ? void 0 : _edcrData$additionalP2.performanceGuarantee) || ((_applicationData236 = applicationData) === null || _applicationData236 === void 0 ? void 0 : _applicationData236.performanceGuarantee) || null
    };
    console.log("applicationDataFromidisRescrutiny", applicationData);
    return {
      applicationData,
      isAppDataLoading
    };
  }
  if (id && !isSuccess) {
    return {
      applicationData: {},
      isAppDataLoading
    };
  }
  const applicationType = "FORM_MAP";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
  applicationData = {
    ...applicationData,
    tenantId,
    applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
    applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
    applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
    occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
    edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
    totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu13 = planDetail.virtualBuilding) === null || _planDetail$virtualBu13 === void 0 ? void 0 : _planDetail$virtualBu13.totalBuitUpArea,
    totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu14 = planDetail.virtualBuilding) === null || _planDetail$virtualBu14 === void 0 ? void 0 : _planDetail$virtualBu14.totalProposedArea,
    totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu15 = planDetail.virtualBuilding) === null || _planDetail$virtualBu15 === void 0 ? void 0 : _planDetail$virtualBu15.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu16 = planDetail.virtualBuilding) === null || _planDetail$virtualBu16 === void 0 ? void 0 : (_planDetail$virtualBu17 = _planDetail$virtualBu16.totalCoverageArea) === null || _planDetail$virtualBu17 === void 0 ? void 0 : _planDetail$virtualBu17.toFixed(2)) || null,
    typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
    propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP3 = planDetail.planInfoProperties) === null || _planDetail$planInfoP3 === void 0 ? void 0 : _planDetail$planInfoP3.PROPERTY_TYPE)),
    proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposal) || null,
    revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
    khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
    khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
    plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot4 = planDetail.plot) === null || _planDetail$plot4 === void 0 ? void 0 : _planDetail$plot4.area) || 0,
    plotAreaDoc: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaDoc,
    plotAreaPos: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaPossession,
    siteAddress: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landAddress,
    totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
    purchasableFar: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.purchasableFar) || ((_applicationData237 = applicationData) === null || _applicationData237 === void 0 ? void 0 : _applicationData237.purchasableFar) || null,
    compensatoryFAR: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.compensatoryFAR) || ((_applicationData238 = applicationData) === null || _applicationData238 === void 0 ? void 0 : _applicationData238.compensatoryFAR) || null,
    transferredLandArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.transferredLandArea) || ((_applicationData239 = applicationData) === null || _applicationData239 === void 0 ? void 0 : _applicationData239.transferredLandArea) || null,
    blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
    basicFAR: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.basicFAR) || 0,
    purchasableFAR: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.purchasableFAR) || 0,
    premiumFAR: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.premiumFAR) || 0,
    noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks4 = planDetail.blocks) === null || _planDetail$blocks4 === void 0 ? void 0 : _planDetail$blocks4.length) || 0,
    demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
    parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe5 = planDetail.parkingDetails) === null || _planDetail$parkingDe5 === void 0 ? void 0 : _planDetail$parkingDe5.overAllParkingArea) || 0,
    parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe6 = planDetail.parkingDetails) === null || _planDetail$parkingDe6 === void 0 ? void 0 : _planDetail$parkingDe6.parkingFloorNo) || 0,
    activeTab: ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("MS_CURRENT_TAB")) || 0,
    riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null
    },
    planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
    updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
    dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: planInformation === null || planInformation === void 0 ? void 0 : planInformation.district,
        locality: {
          code: "Lucknow"
        },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
      },
      tenantId
    },
    professionaldetails: {
      name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId
    },
    landAreaDetails: {
      city: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$city = scrutinyDetails.city) === null || _scrutinyDetails$city === void 0 ? void 0 : _scrutinyDetails$city.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr = planInformation.correspondenceAddress) === null || _planInformation$corr === void 0 ? void 0 : _planInformation$corr.district) || null,
      locality: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$loca = scrutinyDetails.locality) === null || _scrutinyDetails$loca === void 0 ? void 0 : _scrutinyDetails$loca.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr2 = planInformation.correspondenceAddress) === null || _planInformation$corr2 === void 0 ? void 0 : _planInformation$corr2.tehsil) || null
      },
      village: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$vill = scrutinyDetails.village) === null || _scrutinyDetails$vill === void 0 ? void 0 : _scrutinyDetails$vill.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr3 = planInformation.correspondenceAddress) === null || _planInformation$corr3 === void 0 ? void 0 : _planInformation$corr3.town) || null
      },
      areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
    },
    businessService: applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP",
    documents,
    additionalDocs: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalP3 = edcrData.additionalProperties) === null || _edcrData$additionalP3 === void 0 ? void 0 : _edcrData$additionalP3.documents) || [],
    viewPdf: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPdf,
    viewPlanReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPlanReport,
    natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
    proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
    sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
    sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
    noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
    plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
    district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
    sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
    tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
    revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
    landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
    schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
    buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
    otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
    planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
    buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
    projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
    isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
    prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData240 = applicationData) === null || _applicationData240 === void 0 ? void 0 : _applicationData240.prevFileNo) || ((_applicationData241 = applicationData) === null || _applicationData241 === void 0 ? void 0 : (_applicationData241$m = _applicationData241.mapSubDetails) === null || _applicationData241$m === void 0 ? void 0 : _applicationData241$m.prevFileNo) || ((_applicationData242 = applicationData) === null || _applicationData242 === void 0 ? void 0 : (_applicationData242$a = _applicationData242.additionalDetails) === null || _applicationData242$a === void 0 ? void 0 : _applicationData242$a.oldCaseApplicationNo) || null,
    sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData243 = applicationData) === null || _applicationData243 === void 0 ? void 0 : _applicationData243.sanctionValidityDate) || ((_applicationData244 = applicationData) === null || _applicationData244 === void 0 ? void 0 : (_applicationData244$m = _applicationData244.mapSubDetails) === null || _applicationData244$m === void 0 ? void 0 : _applicationData244$m.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai21 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai21 === void 0 ? void 0 : _edcrData$mapSubDetai21.sanctionValidityDate) || null,
    sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData245 = applicationData) === null || _applicationData245 === void 0 ? void 0 : _applicationData245.sanctionValidityStartDate) || ((_applicationData246 = applicationData) === null || _applicationData246 === void 0 ? void 0 : (_applicationData246$m = _applicationData246.mapSubDetails) === null || _applicationData246$m === void 0 ? void 0 : _applicationData246$m.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai22 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai22 === void 0 ? void 0 : _edcrData$mapSubDetai22.sanctionValidityStartDate) || null,
    isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
    specialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProject,
    specialProjectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProjectType,
    isGovernmentBuilding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isGovernmentBuilding,
    typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
    plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
    plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
    needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
    plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
    isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
    isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
    isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
    constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
    layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
    layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
    groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
    far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
    isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
    setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
    setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
    setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
    setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
    zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
    isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
    subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
    primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
    activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
    communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
    anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
    khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
    sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
    uiFlow: {
      flow: "Form12"
    },
    fastPASId: fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.land_Id,
    scrutinyFlow: ((_applicationData247 = applicationData) === null || _applicationData247 === void 0 ? void 0 : _applicationData247.scrutinyFlow) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) && "EDCR",
    typeOfArea: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript23 = fastPasData.descriptionOfLand) === null || _fastPasData$descript23 === void 0 ? void 0 : _fastPasData$descript23.developmentArea,
    latitude: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript24 = fastPasData.descriptionOfLand) === null || _fastPasData$descript24 === void 0 ? void 0 : _fastPasData$descript24.latitude,
    longitude: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript25 = fastPasData.descriptionOfLand) === null || _fastPasData$descript25 === void 0 ? void 0 : _fastPasData$descript25.longitude,
    roadwidth: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript26 = fastPasData.descriptionOfLand) === null || _fastPasData$descript26 === void 0 ? void 0 : (_fastPasData$descript27 = _fastPasData$descript26.roadWidths) === null || _fastPasData$descript27 === void 0 ? void 0 : (_fastPasData$descript28 = _fastPasData$descript27[0]) === null || _fastPasData$descript28 === void 0 ? void 0 : _fastPasData$descript28.value,
    approachRoadWidth: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript29 = fastPasData.descriptionOfLand) === null || _fastPasData$descript29 === void 0 ? void 0 : (_fastPasData$descript30 = _fastPasData$descript29.approachRoadWidths) === null || _fastPasData$descript30 === void 0 ? void 0 : (_fastPasData$descript31 = _fastPasData$descript30[0]) === null || _fastPasData$descript31 === void 0 ? void 0 : _fastPasData$descript31.value,
    khasraDetails: fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.khasraDetails,
    selectedCity: fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedCity,
    selectedUnit: (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$addition4 = fastPasData.additionalDetails) === null || _fastPasData$addition4 === void 0 ? void 0 : _fastPasData$addition4.selectedUnit) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.selectedUnit) || ((_applicationData248 = applicationData) === null || _applicationData248 === void 0 ? void 0 : _applicationData248.selectedUnit) || ((_applicationData249 = applicationData) === null || _applicationData249 === void 0 ? void 0 : (_applicationData249$a = _applicationData249.additionalDetails) === null || _applicationData249$a === void 0 ? void 0 : _applicationData249$a.selectedUnit),
    schemeName: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.schemeName),
    landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai23 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai23 === void 0 ? void 0 : _edcrData$mapSubDetai23.landUseApprovalLetter) || ((_applicationData250 = applicationData) === null || _applicationData250 === void 0 ? void 0 : _applicationData250.landUseApprovalLetter) || ((_applicationData251 = applicationData) === null || _applicationData251 === void 0 ? void 0 : _applicationData251.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe7 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe7 === void 0 ? void 0 : _fastPasData$mapSubDe7.landUseApprovalLetter),
    approvalLetterUrl: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai24 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai24 === void 0 ? void 0 : _edcrData$mapSubDetai24.landUseApprovalLetter) || ((_applicationData252 = applicationData) === null || _applicationData252 === void 0 ? void 0 : _applicationData252.landUseApprovalLetter) || ((_applicationData253 = applicationData) === null || _applicationData253 === void 0 ? void 0 : _applicationData253.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe8 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe8 === void 0 ? void 0 : _fastPasData$mapSubDe8.landUseApprovalLetter),
    mapSubDetails: {
      ...((_applicationData254 = applicationData) === null || _applicationData254 === void 0 ? void 0 : _applicationData254.mapSubDetails),
      ...(edcrData === null || edcrData === void 0 ? void 0 : edcrData.mapSubDetails),
      proposalTypeFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai25 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai25 === void 0 ? void 0 : _edcrData$mapSubDetai25.proposalTypeFAR) || ((_applicationData255 = applicationData) === null || _applicationData255 === void 0 ? void 0 : (_applicationData255$m = _applicationData255.mapSubDetails) === null || _applicationData255$m === void 0 ? void 0 : _applicationData255$m.proposalTypeFAR),
      landUseApprovalLetter: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai26 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai26 === void 0 ? void 0 : _edcrData$mapSubDetai26.landUseApprovalLetter) || ((_applicationData256 = applicationData) === null || _applicationData256 === void 0 ? void 0 : _applicationData256.landUseApprovalLetter) || ((_applicationData257 = applicationData) === null || _applicationData257 === void 0 ? void 0 : _applicationData257.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.approvalLetterUrl) || (fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landUseApprovalLetter) || (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubDe9 = fastPasData.mapSubDetails) === null || _fastPasData$mapSubDe9 === void 0 ? void 0 : _fastPasData$mapSubDe9.landUseApprovalLetter),
      fireFighting: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai27 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai27 === void 0 ? void 0 : _edcrData$mapSubDetai27.fireFighting) || ((_applicationData258 = applicationData) === null || _applicationData258 === void 0 ? void 0 : (_applicationData258$m = _applicationData258.mapSubDetails) === null || _applicationData258$m === void 0 ? void 0 : _applicationData258$m.fireFighting),
      prevFileNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo) || ((_applicationData259 = applicationData) === null || _applicationData259 === void 0 ? void 0 : _applicationData259.prevFileNo) || ((_applicationData260 = applicationData) === null || _applicationData260 === void 0 ? void 0 : (_applicationData260$m = _applicationData260.mapSubDetails) === null || _applicationData260$m === void 0 ? void 0 : _applicationData260$m.prevFileNo) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai28 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai28 === void 0 ? void 0 : _edcrData$mapSubDetai28.prevFileNo) || ((_applicationData261 = applicationData) === null || _applicationData261 === void 0 ? void 0 : (_applicationData261$a = _applicationData261.additionalDetails) === null || _applicationData261$a === void 0 ? void 0 : _applicationData261$a.oldCaseApplicationNo) || null,
      sanctionValidityDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityDate) || ((_applicationData262 = applicationData) === null || _applicationData262 === void 0 ? void 0 : _applicationData262.sanctionValidityDate) || ((_applicationData263 = applicationData) === null || _applicationData263 === void 0 ? void 0 : (_applicationData263$m = _applicationData263.mapSubDetails) === null || _applicationData263$m === void 0 ? void 0 : _applicationData263$m.sanctionValidityDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai29 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai29 === void 0 ? void 0 : _edcrData$mapSubDetai29.sanctionValidityDate) || null,
      sanctionValidityStartDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionValidityStartDate) || ((_applicationData264 = applicationData) === null || _applicationData264 === void 0 ? void 0 : _applicationData264.sanctionValidityStartDate) || ((_applicationData265 = applicationData) === null || _applicationData265 === void 0 ? void 0 : (_applicationData265$m = _applicationData265.mapSubDetails) === null || _applicationData265$m === void 0 ? void 0 : _applicationData265$m.sanctionValidityStartDate) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$mapSubDetai30 = edcrData.mapSubDetails) === null || _edcrData$mapSubDetai30 === void 0 ? void 0 : _edcrData$mapSubDetai30.sanctionValidityStartDate) || null
    },
    descriptionOfLand: {
      ...(fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.descriptionOfLand),
      schemeType: fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$descript32 = fastPasData.descriptionOfLand) === null || _fastPasData$descript32 === void 0 ? void 0 : _fastPasData$descript32.schemeType
    },
    landInfo: fastPasData === null || fastPasData === void 0 ? void 0 : fastPasData.landInfo,
    shelterFee: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.shelterFee) || ((_applicationData266 = applicationData) === null || _applicationData266 === void 0 ? void 0 : _applicationData266.shelterFee) || null,
    performanceGuarantee: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalP4 = edcrData.additionalProperties) === null || _edcrData$additionalP4 === void 0 ? void 0 : _edcrData$additionalP4.performanceGuarantee) || ((_applicationData267 = applicationData) === null || _applicationData267 === void 0 ? void 0 : _applicationData267.performanceGuarantee) || null
  };
  console.log("applicationDataFromOriginal", applicationData);
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const mergeLiveDocsWithPersisted = (persistedDocs = [], liveDocs = []) => {
  const liveTypes = new Set(liveDocs.map(d => d.documentType));
  const untouched = persistedDocs.filter(d => !liveTypes.has(d.documentType));
  return [...untouched, ...liveDocs];
};
const maintainDocumentHistory = (previousDocs = [], currentDocs = []) => {
  const result = [...currentDocs];
  const documentTypes = [...new Set(previousDocs.map(doc => doc.documentType).filter(Boolean).map(type => type.replace(/_\d+$/, "")))];
  documentTypes.forEach(baseType => {
    const currentDoc = currentDocs.find(doc => doc.documentType === baseType);
    if (!currentDoc) return;
    const previousVersions = previousDocs.filter(doc => {
      if (!doc.documentType) return false;
      const normalizedType = doc.documentType.replace(/_\d+$/, "");
      return normalizedType === baseType && doc.fileStoreId !== currentDoc.fileStoreId;
    }).sort((a, b) => {
      const getHistoryIndex = documentType => {
        if (documentType === baseType) return 0;
        const match = documentType.match(/_(\d+)$/);
        return match ? Number(match[1]) : 999;
      };
      return getHistoryIndex(a.documentType) - getHistoryIndex(b.documentType);
    });
    if (!previousVersions.length) return;
    const filteredResult = result.filter(doc => {
      if (!doc.documentType) return true;
      const normalizedType = doc.documentType.replace(/_\d+$/, "");
      return normalizedType !== baseType;
    });
    const history = [{
      ...currentDoc,
      documentType: baseType
    }];
    previousVersions.slice(0, 5).forEach((doc, index) => {
      history.push({
        ...doc,
        documentType: `${baseType}_${index + 1}`
      });
    });
    result.length = 0;
    result.push(...filteredResult, ...history);
  });
  return result;
};

const formatDateToYMD = value => {
  if (!value) return value;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
const MapSubmissionPortal = () => {
  var _Digit, _Digit2, _Digit3, _Digit$UserService$ge, _Digit4, _Digit4$SessionStorag, _location$state, _location$state$data, _location$state$data2, _location$state$data3, _location$state$data4, _location$state$data5, _location$state$data6, _params$nocList, _applicationData$audi;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const reduxDocs = useSelector(state => {
    var _state$formMTDoc, _state$formMT;
    return ((_state$formMTDoc = state.formMTDoc) === null || _state$formMTDoc === void 0 ? void 0 : _state$formMTDoc.documents) || ((_state$formMT = state.formMT) === null || _state$formMT === void 0 ? void 0 : _state$formMT.documents) || [];
  });
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    id
  } = useParams();
  const isNewApplication = !id;
  const [activeTab, setActiveTab] = useState(isNewApplication ? 0 : ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(isNewApplication ? 0 : ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [summaryShow, setSummaryshow] = useState(isNewApplication ? false : ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARY_TAB")) || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState("No");
  const [obpasFileNumber, setObpasFileNumber] = useState("");
  const [dateOfPayment, setDateOfPayment] = useState("");
  const [paymentReceipt, setPaymentReceipt] = useState(null);
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const scrutinyFlow = Digit.SessionStorage.get("LTP.SCRUTINY.SELECTION") || null;
  const didClearOnMountRef = useRef(false);
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const userType = info === null || info === void 0 ? void 0 : info.type;
  const isEmployee = userType === "EMPLOYEE";
  const history = useHistory();
  const location = useLocation();
  const edcrSessionData = (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$SessionStorag = _Digit4.SessionStorage.get("EDCR_CREATE")) === null || _Digit4$SessionStorag === void 0 ? void 0 : _Digit4$SessionStorag[0];
  const {
    applicationData: fetchedAppData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const mergedLocationData = (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.data ? {
    ...location.state.data,
    edcrNumber: ((_location$state$data = location.state.data) === null || _location$state$data === void 0 ? void 0 : _location$state$data.edcrNumber) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.edcrNumber),
    scrutinyFlow: ((_location$state$data2 = location.state.data) === null || _location$state$data2 === void 0 ? void 0 : _location$state$data2.scrutinyFlow) || (edcrSessionData !== null && edcrSessionData !== void 0 && edcrSessionData.edcrNumber ? "EDCR" : (_location$state$data3 = location.state.data) !== null && _location$state$data3 !== void 0 && _location$state$data3.edcrNumber ? "EDCR" : undefined),
    planReport: ((_location$state$data4 = location.state.data) === null || _location$state$data4 === void 0 ? void 0 : _location$state$data4.planReport) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.planReport),
    updatedDxfFile: ((_location$state$data5 = location.state.data) === null || _location$state$data5 === void 0 ? void 0 : _location$state$data5.updatedDxfFile) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.updatedDxfFile),
    dxfFile: ((_location$state$data6 = location.state.data) === null || _location$state$data6 === void 0 ? void 0 : _location$state$data6.dxfFile) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.dxfFile)
  } : null;
  let applicationData = fetchedAppData && fetchedAppData !== null && fetchedAppData !== void 0 && fetchedAppData.applicationNo ? fetchedAppData : mergedLocationData || fetchedAppData;
  console.log(applicationData, "applicationDataadataafter");
  const isSelfCert = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const componentRef = useRef();
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "NOC Status"
  }, {
    label: "Land/Plot Information"
  }];
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const closeToast = () => {
    setShowToast(null);
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  console.log("parmsfromPortalMapSubmission", params, params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.length);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(prev => ({
        ...prev,
        ...data,
        mapSubDetails: {
          ...(prev === null || prev === void 0 ? void 0 : prev.mapSubDetails),
          ...(data === null || data === void 0 ? void 0 : data.mapSubDetails)
        }
      }));
    } else if (key === "") {
      setParams(prev => ({
        ...prev,
        ...data,
        mapSubDetails: {
          ...(prev === null || prev === void 0 ? void 0 : prev.mapSubDetails),
          ...(data === null || data === void 0 ? void 0 : data.mapSubDetails)
        }
      }));
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    console.log("CLEAR");
    if (isNewApplication) {
      clearParams();
      resetFormMTDocs();
      Digit.SessionStorage.del("MS_CURRENT_TAB");
      Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
      Digit.SessionStorage.del("SUMMARY_TAB");
    } else {
      clearParams();
    }
    didClearOnMountRef.current = true;
  }, []);
  const applicationDataSignature = applicationData ? `${applicationData.applicationNo}-${(_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.lastModifiedTime}-${applicationData.status}-${applicationData.scrutinyFlow}-${applicationData.updatedDxfFile ? "hasDxf" : "noDxf"}` : null;
  useEffect(() => {
    if (!didClearOnMountRef.current) return;
    if (id && applicationData && applicationData !== null && applicationData !== void 0 && applicationData.applicationNo) {
      var _applicationData$docu;
      console.log("SYNC", applicationData);
      setParams(prev => ({
        ...prev,
        ...applicationData,
        nocList: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.nocList) || [],
        nocDetails: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.nocDetails) || (prev === null || prev === void 0 ? void 0 : prev.nocDetails),
        mapSubDetails: {
          ...(prev === null || prev === void 0 ? void 0 : prev.mapSubDetails),
          ...(applicationData === null || applicationData === void 0 ? void 0 : applicationData.mapSubDetails)
        }
      }));
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading, applicationDataSignature]);
  useEffect(() => {
    if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" && params !== null && params !== void 0 && params.applicationNo) {
      var _params$documents;
      const key = `REVERT_DOC_SNAPSHOT_${params.applicationNo}`;
      const alreadyFrozen = Digit.SessionStorage.get(key);
      if (!alreadyFrozen && params !== null && params !== void 0 && (_params$documents = params.documents) !== null && _params$documents !== void 0 && _params$documents.length) {
        Digit.SessionStorage.set(key, params.documents);
      }
    }
  }, [params === null || params === void 0 ? void 0 : params.status, params === null || params === void 0 ? void 0 : params.applicationNo]);
  const isCompounding = (params === null || params === void 0 ? void 0 : params.natureOfConstruction) === "Compounding";
  const isCompletionModule = (params === null || params === void 0 ? void 0 : params.applicationType) === "FORM_COMPLETION";
  console.log("hhjjkkklll", isCompounding);
  const handleTabChange = async (nextTabNo, formData = null, makePayment = false) => {
    if (activeTab === 0 && nextTabNo > 0) {
      const dataToValidate = formData ? {
        ...params,
        ...formData
      } : params;
      const err1 = validateStep1Competency(dataToValidate, params, info, isEmployee);
      if (err1) {
        Modal("Competency Validation Error", err1, "error");
        return;
      }
      const err2 = validateStep2Competency(dataToValidate, params, info, isEmployee);
      if (err2) {
        Modal("Competency Validation Error", err2, "error");
        return;
      }
    }
    const isSummaryNav = !isCompounding ? nextTabNo >= 4 : nextTabNo >= 5;
    if (isSummaryNav || makePayment) {
      const dataToValidate = formData ? {
        ...params,
        ...formData
      } : params;
      console.log("[VALIDATION DEBUG] reduxDocs:", reduxDocs);
      console.log("[VALIDATION DEBUG] formData.documents:", dataToValidate === null || dataToValidate === void 0 ? void 0 : dataToValidate.documents);
      console.log("[VALIDATION DEBUG] natureOfConstruction:", dataToValidate === null || dataToValidate === void 0 ? void 0 : dataToValidate.natureOfConstruction);
      console.log("[VALIDATION DEBUG] professionaldetails:", dataToValidate === null || dataToValidate === void 0 ? void 0 : dataToValidate.professionaldetails);
      const validation = validateSummaryForm({
        formType: "FORM_MAP_SUBMISSION",
        formData: {
          ...dataToValidate,
          documents: []
        },
        reduxDocuments: reduxDocs,
        declarationChecked: makePayment ? declarationChecked : true,
        t
      });
      console.log("[VALIDATION DEBUG] result:", validation.isValid, validation.errors);
      if (!validation.isValid) {
        Modal("Missing Mandatory Fields", validation.errorHtml, "error");
        return;
      }
    }
    if (formData) {
      var _data$additionalDetai, _data$additionalDetai2, _data$additionalDetai3, _data$mapSubDetails, _data$mapSubDetails2, _data$mapSubDetails3, _Digit5, _data$mapSubDetails4, _data$additionalDetai4, _params$mapSubDetails, _formData$mapSubDetai, _fastPasSessionData$m, _edcrSessionData$mapS, _applicationData$mapS;
      const data = {
        ...params,
        ...formData
      };
      const resolvedSelectedUnit = (data === null || data === void 0 ? void 0 : data.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.selectedUnit);
      if (resolvedSelectedUnit) {
        data.selectedUnit = resolvedSelectedUnit;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedUnit: resolvedSelectedUnit
        };
      }
      const resolvedSelectedCity = (data === null || data === void 0 ? void 0 : data.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.selectedCity);
      if (resolvedSelectedCity) {
        data.selectedCity = resolvedSelectedCity;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedCity: resolvedSelectedCity
        };
      }
      const resolvedSelectedOffice = (data === null || data === void 0 ? void 0 : data.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.selectedOffice);
      if (resolvedSelectedOffice) {
        data.selectedOffice = resolvedSelectedOffice;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedOffice: resolvedSelectedOffice
        };
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails = data.mapSubDetails) !== null && _data$mapSubDetails !== void 0 && _data$mapSubDetails.prevFileNo) {
        data.prevFileNo = data.mapSubDetails.prevFileNo;
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails2 = data.mapSubDetails) !== null && _data$mapSubDetails2 !== void 0 && _data$mapSubDetails2.sanctionValidityDate) {
        data.sanctionValidityDate = formatDateToYMD(data.mapSubDetails.sanctionValidityDate);
        data.mapSubDetails.sanctionValidityDate = data.sanctionValidityDate;
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails3 = data.mapSubDetails) !== null && _data$mapSubDetails3 !== void 0 && _data$mapSubDetails3.sanctionValidityStartDate) {
        data.sanctionValidityStartDate = formatDateToYMD(data.mapSubDetails.sanctionValidityStartDate);
        data.mapSubDetails.sanctionValidityStartDate = data.sanctionValidityStartDate;
      }
      const fastPasSessionData = (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.get("FASTPAS_ID");
      const resolvedLandUseApprovalLetter = (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails4 = data.mapSubDetails) === null || _data$mapSubDetails4 === void 0 ? void 0 : _data$mapSubDetails4.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.approvalLetterUrl) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : (_params$mapSubDetails = params.mapSubDetails) === null || _params$mapSubDetails === void 0 ? void 0 : _params$mapSubDetails.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (fastPasSessionData === null || fastPasSessionData === void 0 ? void 0 : fastPasSessionData.approvalLetterUrl) || (fastPasSessionData === null || fastPasSessionData === void 0 ? void 0 : fastPasSessionData.landUseApprovalLetter) || (fastPasSessionData === null || fastPasSessionData === void 0 ? void 0 : (_fastPasSessionData$m = fastPasSessionData.mapSubDetails) === null || _fastPasSessionData$m === void 0 ? void 0 : _fastPasSessionData$m.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS === void 0 ? void 0 : _edcrSessionData$mapS.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.approvalLetterUrl) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.landUseApprovalLetter) || (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$mapS = applicationData.mapSubDetails) === null || _applicationData$mapS === void 0 ? void 0 : _applicationData$mapS.landUseApprovalLetter);
      if (resolvedLandUseApprovalLetter) {
        data.landUseApprovalLetter = resolvedLandUseApprovalLetter;
        data.approvalLetterUrl = resolvedLandUseApprovalLetter;
        data.mapSubDetails = {
          ...(data === null || data === void 0 ? void 0 : data.mapSubDetails),
          landUseApprovalLetter: resolvedLandUseApprovalLetter
        };
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          landUseApprovalLetter: resolvedLandUseApprovalLetter
        };
      }
      console.log("fromHandleTabchange", data, formData, nextTabNo, isCompounding);
      const isSelfCert = (params === null || params === void 0 ? void 0 : params.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        var _formData$documents, _formData$documents$f;
        let paymentReceipt = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$f = _formData$documents.find(item => (item === null || item === void 0 ? void 0 : item.documentType) === "PaymentReceipt")) === null || _formData$documents$f === void 0 ? void 0 : _formData$documents$f.fileStoreId;
        if (data !== null && data !== void 0 && data.isAlreadySubmitted && formData !== null && formData !== void 0 && formData.obpasFileNumber && formData !== null && formData !== void 0 && formData.obpasPaymentDate && paymentReceipt && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else if (nextTabNo === 5 && !isCompounding && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT" || nextTabNo === 6 && isCompounding && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          if ((params === null || params === void 0 ? void 0 : params.isGovernmentBuilding) === "yes") {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
          } else {
            data.workflow = {
              action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT",
              assignes: null
            };
          }
        } else if (nextTabNo === 5 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        console.log("DataBEFORESUBM", data);
        const isSendingToChecker = ["FORWARD_TO_DEPARTMENT", "MAKE_PAYMENT", "MAKE_PAYMENT_SELF"].includes(data.workflow.action);
        const mergedDocs = mergeLiveDocsWithPersisted(params === null || params === void 0 ? void 0 : params.documents, data.documents || reduxDocs);
        if (isSendingToChecker && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          const snapshotKey = `REVERT_DOC_SNAPSHOT_${params.applicationNo}`;
          const frozenSnapshot = Digit.SessionStorage.get(snapshotKey) || params.documents || [];
          console.log("HISTORYDOCS", maintainDocumentHistory(frozenSnapshot, mergedDocs));
          data.documents = maintainDocumentHistory(frozenSnapshot, mergedDocs);
          Digit.SessionStorage.del(snapshotKey);
        } else {
          data.documents = mergedDocs;
        }
        console.log("DATASUBMMMIIJIAS", data);
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (makePayment) {
              if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" || data !== null && data !== void 0 && data.isAlreadySubmitted || (params === null || params === void 0 ? void 0 : params.isGovernmentBuilding) === "yes") {
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              } else {
                var _params$taxHeadEstima, _Digit6, _Digit7, _Digit8;
                if (isSelfCert) {
                  history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else if ((params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : _params$taxHeadEstima.length) > 1) {
                  var _params$taxHeadEstima2, _params$taxHeadEstima3;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima2 = params.taxHeadEstimates) === null || _params$taxHeadEstima2 === void 0 ? void 0 : (_params$taxHeadEstima3 = _params$taxHeadEstima2[1]) === null || _params$taxHeadEstima3 === void 0 ? void 0 : _params$taxHeadEstima3.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else {
                  var _params$taxHeadEstima4, _params$taxHeadEstima5;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima4 = params.taxHeadEstimates) === null || _params$taxHeadEstima4 === void 0 ? void 0 : (_params$taxHeadEstima5 = _params$taxHeadEstima4[0]) === null || _params$taxHeadEstima5 === void 0 ? void 0 : _params$taxHeadEstima5.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                }
                clearParams();
                Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("EDCR_CREATE");
                (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.del("FASTPAS_ID");
                (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.del("SUMMARY_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("MS_CURRENT_TAB");
                Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
              }
            } else {
              if (nextTabNo === 5) {
                Digit.SessionStorage.set("SUMMARY_TAB", true);
                setSummaryshow(true);
              }
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    const dataToValidate = formData ? {
      ...params,
      ...formData
    } : params;
    if (selectedSubTab === 0 && nextSubTab > 0) {
      const err = validateStep1Competency(dataToValidate, params, info, isEmployee);
      if (err) {
        Modal("Competency Validation Error", err, "error");
        return;
      }
    }
    if (selectedSubTab === 1 && nextSubTab > 1) {
      const err = validateStep2Competency(dataToValidate, params, info, isEmployee);
      if (err) {
        Modal("Competency Validation Error", err, "error");
        return;
      }
    }
    if (formData) {
      var _data$additionalDetai5, _data$additionalDetai6, _data$additionalDetai7, _data$mapSubDetails5, _data$mapSubDetails6, _data$mapSubDetails7, _Digit9, _data$mapSubDetails8, _data$additionalDetai8, _params$mapSubDetails2, _formData$mapSubDetai2, _fastPasSessionDataSu, _edcrSessionData$mapS2, _applicationData$mapS2;
      const data = {
        ...params,
        ...formData
      };
      const resolvedSelectedUnit = (data === null || data === void 0 ? void 0 : data.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai5 = data.additionalDetails) === null || _data$additionalDetai5 === void 0 ? void 0 : _data$additionalDetai5.selectedUnit);
      if (resolvedSelectedUnit) {
        data.selectedUnit = resolvedSelectedUnit;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedUnit: resolvedSelectedUnit
        };
      }
      const resolvedSelectedCity = (data === null || data === void 0 ? void 0 : data.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai6 = data.additionalDetails) === null || _data$additionalDetai6 === void 0 ? void 0 : _data$additionalDetai6.selectedCity);
      if (resolvedSelectedCity) {
        data.selectedCity = resolvedSelectedCity;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedCity: resolvedSelectedCity
        };
      }
      const resolvedSelectedOffice = (data === null || data === void 0 ? void 0 : data.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai7 = data.additionalDetails) === null || _data$additionalDetai7 === void 0 ? void 0 : _data$additionalDetai7.selectedOffice);
      if (resolvedSelectedOffice) {
        data.selectedOffice = resolvedSelectedOffice;
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          selectedOffice: resolvedSelectedOffice
        };
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails5 = data.mapSubDetails) !== null && _data$mapSubDetails5 !== void 0 && _data$mapSubDetails5.prevFileNo) {
        data.prevFileNo = data.mapSubDetails.prevFileNo;
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails6 = data.mapSubDetails) !== null && _data$mapSubDetails6 !== void 0 && _data$mapSubDetails6.sanctionValidityDate) {
        data.sanctionValidityDate = formatDateToYMD(data.mapSubDetails.sanctionValidityDate);
        data.mapSubDetails.sanctionValidityDate = data.sanctionValidityDate;
      }
      if (data !== null && data !== void 0 && (_data$mapSubDetails7 = data.mapSubDetails) !== null && _data$mapSubDetails7 !== void 0 && _data$mapSubDetails7.sanctionValidityStartDate) {
        data.sanctionValidityStartDate = formatDateToYMD(data.mapSubDetails.sanctionValidityStartDate);
        data.mapSubDetails.sanctionValidityStartDate = data.sanctionValidityStartDate;
      }
      const fastPasSessionDataSubTab = (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.get("FASTPAS_ID");
      const resolvedLandUseLetterSubTab = (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails8 = data.mapSubDetails) === null || _data$mapSubDetails8 === void 0 ? void 0 : _data$mapSubDetails8.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.approvalLetterUrl) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai8 = data.additionalDetails) === null || _data$additionalDetai8 === void 0 ? void 0 : _data$additionalDetai8.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : (_params$mapSubDetails2 = params.mapSubDetails) === null || _params$mapSubDetails2 === void 0 ? void 0 : _params$mapSubDetails2.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.approvalLetterUrl) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.approvalLetterUrl) || (fastPasSessionDataSubTab === null || fastPasSessionDataSubTab === void 0 ? void 0 : fastPasSessionDataSubTab.approvalLetterUrl) || (fastPasSessionDataSubTab === null || fastPasSessionDataSubTab === void 0 ? void 0 : fastPasSessionDataSubTab.landUseApprovalLetter) || (fastPasSessionDataSubTab === null || fastPasSessionDataSubTab === void 0 ? void 0 : (_fastPasSessionDataSu = fastPasSessionDataSubTab.mapSubDetails) === null || _fastPasSessionDataSu === void 0 ? void 0 : _fastPasSessionDataSu.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : (_edcrSessionData$mapS2 = edcrSessionData.mapSubDetails) === null || _edcrSessionData$mapS2 === void 0 ? void 0 : _edcrSessionData$mapS2.landUseApprovalLetter) || (edcrSessionData === null || edcrSessionData === void 0 ? void 0 : edcrSessionData.approvalLetterUrl) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.approvalLetterUrl) || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.landUseApprovalLetter) || (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$mapS2 = applicationData.mapSubDetails) === null || _applicationData$mapS2 === void 0 ? void 0 : _applicationData$mapS2.landUseApprovalLetter);
      if (resolvedLandUseLetterSubTab) {
        data.landUseApprovalLetter = resolvedLandUseLetterSubTab;
        data.approvalLetterUrl = resolvedLandUseLetterSubTab;
        data.mapSubDetails = {
          ...(data === null || data === void 0 ? void 0 : data.mapSubDetails),
          landUseApprovalLetter: resolvedLandUseLetterSubTab
        };
        data.additionalDetails = {
          ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
          landUseApprovalLetter: resolvedLandUseLetterSubTab
        };
      }
      console.log("DATA BEFORE", activeTab, selectedSubTab, isSelfCert, isCompounding, id, data);
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !isCompounding && !id && (data === null || data === void 0 ? void 0 : data.scrutinyFlow) === "EDCR") {
        data.scrutinyFlow = "EDCR";
        data.riskType = "HIGH";
        setIsCreateLoading(true);
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA;
          setIsCreateLoading(false);
          if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
            var _res$BPA2, _createdBpa$mapSubDet, _createdBpa$additiona, _data$additionalDetai9, _createdBpa$additiona2, _data$additionalDetai10, _createdBpa$additiona3, _data$additionalDetai11, _data$mapSubDetails9, _data$mapSubDetails10, _data$mapSubDetails11, _createdBpa$additiona4, _data$additionalDetai12, _createdBpa$additiona5, _data$additionalDetai13, _createdBpa$additiona6, _data$additionalDetai14, _createdBpa$additiona7, _data$additionalDetai15, _createdBpa$mapSubDet2, _data$mapSubDetails12, _data$mapSubDetails13, _data$mapSubDetails14, _data$mapSubDetails15;
            const createdBpa = (res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]) || {};
            const mergedData = {
              ...data,
              ...createdBpa,
              landUseApprovalLetter: resolvedLandUseLetterSubTab || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.landUseApprovalLetter) || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$mapSubDet = createdBpa.mapSubDetails) === null || _createdBpa$mapSubDet === void 0 ? void 0 : _createdBpa$mapSubDet.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter),
              approvalLetterUrl: resolvedLandUseLetterSubTab || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.approvalLetterUrl) || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.approvalLetterUrl),
              selectedUnit: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedUnit) || (data === null || data === void 0 ? void 0 : data.selectedUnit) || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona = createdBpa.additionalDetails) === null || _createdBpa$additiona === void 0 ? void 0 : _createdBpa$additiona.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai9 = data.additionalDetails) === null || _data$additionalDetai9 === void 0 ? void 0 : _data$additionalDetai9.selectedUnit),
              selectedCity: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedCity) || (data === null || data === void 0 ? void 0 : data.selectedCity) || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona2 = createdBpa.additionalDetails) === null || _createdBpa$additiona2 === void 0 ? void 0 : _createdBpa$additiona2.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai10 = data.additionalDetails) === null || _data$additionalDetai10 === void 0 ? void 0 : _data$additionalDetai10.selectedCity),
              selectedOffice: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedOffice) || (data === null || data === void 0 ? void 0 : data.selectedOffice) || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona3 = createdBpa.additionalDetails) === null || _createdBpa$additiona3 === void 0 ? void 0 : _createdBpa$additiona3.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai11 = data.additionalDetails) === null || _data$additionalDetai11 === void 0 ? void 0 : _data$additionalDetai11.selectedOffice),
              natureOfConstruction: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.natureOfConstruction) || (data === null || data === void 0 ? void 0 : data.natureOfConstruction),
              prevFileNo: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.prevFileNo) || (data === null || data === void 0 ? void 0 : data.prevFileNo) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails9 = data.mapSubDetails) === null || _data$mapSubDetails9 === void 0 ? void 0 : _data$mapSubDetails9.prevFileNo),
              sanctionValidityDate: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails10 = data.mapSubDetails) === null || _data$mapSubDetails10 === void 0 ? void 0 : _data$mapSubDetails10.sanctionValidityDate),
              sanctionValidityStartDate: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails11 = data.mapSubDetails) === null || _data$mapSubDetails11 === void 0 ? void 0 : _data$mapSubDetails11.sanctionValidityStartDate),
              additionalDetails: {
                ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
                ...(createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.additionalDetails),
                selectedUnit: (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona4 = createdBpa.additionalDetails) === null || _createdBpa$additiona4 === void 0 ? void 0 : _createdBpa$additiona4.selectedUnit) || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai12 = data.additionalDetails) === null || _data$additionalDetai12 === void 0 ? void 0 : _data$additionalDetai12.selectedUnit) || (data === null || data === void 0 ? void 0 : data.selectedUnit),
                selectedCity: (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona5 = createdBpa.additionalDetails) === null || _createdBpa$additiona5 === void 0 ? void 0 : _createdBpa$additiona5.selectedCity) || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai13 = data.additionalDetails) === null || _data$additionalDetai13 === void 0 ? void 0 : _data$additionalDetai13.selectedCity) || (data === null || data === void 0 ? void 0 : data.selectedCity),
                selectedOffice: (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona6 = createdBpa.additionalDetails) === null || _createdBpa$additiona6 === void 0 ? void 0 : _createdBpa$additiona6.selectedOffice) || (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai14 = data.additionalDetails) === null || _data$additionalDetai14 === void 0 ? void 0 : _data$additionalDetai14.selectedOffice) || (data === null || data === void 0 ? void 0 : data.selectedOffice),
                landUseApprovalLetter: resolvedLandUseLetterSubTab || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$additiona7 = createdBpa.additionalDetails) === null || _createdBpa$additiona7 === void 0 ? void 0 : _createdBpa$additiona7.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai15 = data.additionalDetails) === null || _data$additionalDetai15 === void 0 ? void 0 : _data$additionalDetai15.landUseApprovalLetter)
              },
              mapSubDetails: {
                ...(data === null || data === void 0 ? void 0 : data.mapSubDetails),
                ...(createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.mapSubDetails),
                landUseApprovalLetter: resolvedLandUseLetterSubTab || (createdBpa === null || createdBpa === void 0 ? void 0 : (_createdBpa$mapSubDet2 = createdBpa.mapSubDetails) === null || _createdBpa$mapSubDet2 === void 0 ? void 0 : _createdBpa$mapSubDet2.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails12 = data.mapSubDetails) === null || _data$mapSubDetails12 === void 0 ? void 0 : _data$mapSubDetails12.landUseApprovalLetter),
                prevFileNo: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.prevFileNo) || (data === null || data === void 0 ? void 0 : data.prevFileNo) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails13 = data.mapSubDetails) === null || _data$mapSubDetails13 === void 0 ? void 0 : _data$mapSubDetails13.prevFileNo),
                sanctionValidityDate: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails14 = data.mapSubDetails) === null || _data$mapSubDetails14 === void 0 ? void 0 : _data$mapSubDetails14.sanctionValidityDate),
                sanctionValidityStartDate: (createdBpa === null || createdBpa === void 0 ? void 0 : createdBpa.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails15 = data.mapSubDetails) === null || _data$mapSubDetails15 === void 0 ? void 0 : _data$mapSubDetails15.sanctionValidityStartDate)
              }
            };
            onSelect("", mergedData, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setIsCreateLoading(false);
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA3, _updatedBpa$mapSubDet, _updatedBpa$additiona, _data$additionalDetai16, _updatedBpa$additiona2, _data$additionalDetai17, _updatedBpa$additiona3, _data$additionalDetai18, _data$mapSubDetails16, _data$mapSubDetails17, _data$mapSubDetails18, _updatedBpa$additiona4, _data$additionalDetai19, _updatedBpa$additiona5, _data$additionalDetai20, _updatedBpa$additiona6, _data$additionalDetai21, _updatedBpa$additiona7, _data$additionalDetai22, _updatedBpa$mapSubDet2, _data$mapSubDetails19, _data$mapSubDetails20, _data$mapSubDetails21, _data$mapSubDetails22;
              const updatedBpa = (res === null || res === void 0 ? void 0 : (_res$BPA3 = res.BPA) === null || _res$BPA3 === void 0 ? void 0 : _res$BPA3[0]) || {};
              const mergedData = {
                ...data,
                ...updatedBpa,
                landUseApprovalLetter: resolvedLandUseLetterSubTab || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.landUseApprovalLetter) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$mapSubDet = updatedBpa.mapSubDetails) === null || _updatedBpa$mapSubDet === void 0 ? void 0 : _updatedBpa$mapSubDet.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter),
                approvalLetterUrl: resolvedLandUseLetterSubTab || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.approvalLetterUrl) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : data.approvalLetterUrl),
                selectedUnit: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedUnit) || (data === null || data === void 0 ? void 0 : data.selectedUnit) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona = updatedBpa.additionalDetails) === null || _updatedBpa$additiona === void 0 ? void 0 : _updatedBpa$additiona.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai16 = data.additionalDetails) === null || _data$additionalDetai16 === void 0 ? void 0 : _data$additionalDetai16.selectedUnit),
                selectedCity: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedCity) || (data === null || data === void 0 ? void 0 : data.selectedCity) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona2 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona2 === void 0 ? void 0 : _updatedBpa$additiona2.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai17 = data.additionalDetails) === null || _data$additionalDetai17 === void 0 ? void 0 : _data$additionalDetai17.selectedCity),
                selectedOffice: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedOffice) || (data === null || data === void 0 ? void 0 : data.selectedOffice) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona3 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona3 === void 0 ? void 0 : _updatedBpa$additiona3.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai18 = data.additionalDetails) === null || _data$additionalDetai18 === void 0 ? void 0 : _data$additionalDetai18.selectedOffice),
                natureOfConstruction: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.natureOfConstruction) || (data === null || data === void 0 ? void 0 : data.natureOfConstruction),
                prevFileNo: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.prevFileNo) || (data === null || data === void 0 ? void 0 : data.prevFileNo) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails16 = data.mapSubDetails) === null || _data$mapSubDetails16 === void 0 ? void 0 : _data$mapSubDetails16.prevFileNo),
                sanctionValidityDate: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails17 = data.mapSubDetails) === null || _data$mapSubDetails17 === void 0 ? void 0 : _data$mapSubDetails17.sanctionValidityDate),
                sanctionValidityStartDate: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails18 = data.mapSubDetails) === null || _data$mapSubDetails18 === void 0 ? void 0 : _data$mapSubDetails18.sanctionValidityStartDate),
                additionalDetails: {
                  ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
                  ...(updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.additionalDetails),
                  selectedUnit: (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona4 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona4 === void 0 ? void 0 : _updatedBpa$additiona4.selectedUnit) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedUnit) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai19 = data.additionalDetails) === null || _data$additionalDetai19 === void 0 ? void 0 : _data$additionalDetai19.selectedUnit) || (data === null || data === void 0 ? void 0 : data.selectedUnit),
                  selectedCity: (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona5 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona5 === void 0 ? void 0 : _updatedBpa$additiona5.selectedCity) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedCity) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai20 = data.additionalDetails) === null || _data$additionalDetai20 === void 0 ? void 0 : _data$additionalDetai20.selectedCity) || (data === null || data === void 0 ? void 0 : data.selectedCity),
                  selectedOffice: (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona6 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona6 === void 0 ? void 0 : _updatedBpa$additiona6.selectedOffice) || (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.selectedOffice) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai21 = data.additionalDetails) === null || _data$additionalDetai21 === void 0 ? void 0 : _data$additionalDetai21.selectedOffice) || (data === null || data === void 0 ? void 0 : data.selectedOffice),
                  landUseApprovalLetter: resolvedLandUseLetterSubTab || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$additiona7 = updatedBpa.additionalDetails) === null || _updatedBpa$additiona7 === void 0 ? void 0 : _updatedBpa$additiona7.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$additionalDetai22 = data.additionalDetails) === null || _data$additionalDetai22 === void 0 ? void 0 : _data$additionalDetai22.landUseApprovalLetter)
                },
                mapSubDetails: {
                  ...(data === null || data === void 0 ? void 0 : data.mapSubDetails),
                  ...(updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.mapSubDetails),
                  landUseApprovalLetter: resolvedLandUseLetterSubTab || (updatedBpa === null || updatedBpa === void 0 ? void 0 : (_updatedBpa$mapSubDet2 = updatedBpa.mapSubDetails) === null || _updatedBpa$mapSubDet2 === void 0 ? void 0 : _updatedBpa$mapSubDet2.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails19 = data.mapSubDetails) === null || _data$mapSubDetails19 === void 0 ? void 0 : _data$mapSubDetails19.landUseApprovalLetter),
                  prevFileNo: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.prevFileNo) || (data === null || data === void 0 ? void 0 : data.prevFileNo) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails20 = data.mapSubDetails) === null || _data$mapSubDetails20 === void 0 ? void 0 : _data$mapSubDetails20.prevFileNo),
                  sanctionValidityDate: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails21 = data.mapSubDetails) === null || _data$mapSubDetails21 === void 0 ? void 0 : _data$mapSubDetails21.sanctionValidityDate),
                  sanctionValidityStartDate: (updatedBpa === null || updatedBpa === void 0 ? void 0 : updatedBpa.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : data.sanctionValidityStartDate) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails22 = data.mapSubDetails) === null || _data$mapSubDetails22 === void 0 ? void 0 : _data$mapSubDetails22.sanctionValidityStartDate)
                }
              };
              onSelect("", mergedData);
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const renderContent = () => {
    var _params$nocList2, _params$nocList3;
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            setFormData: setParams,
            handleTabChange: handleTabChange,
            initFormMTDocs: initFormMTDocs,
            setShowToast: setShowToast,
            isEmployee: isEmployee,
            nonSchemeTypeData: nonSchemeTypeData,
            schemeTypeData: schemeTypeData
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, id && (isAppDataLoading || !(params !== null && params !== void 0 && params.applicationNo)) ? /*#__PURE__*/React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "Loading NOC data...")) : (params === null || params === void 0 ? void 0 : (_params$nocList2 = params.nocList) === null || _params$nocList2 === void 0 ? void 0 : _params$nocList2.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NOCTakeAction, {
            formData: params,
            onNocUpdate: updatedNocList => {
              setParams(prev => ({
                ...prev,
                nocList: updatedNocList,
                nocDetails: {
                  ...((prev === null || prev === void 0 ? void 0 : prev.nocDetails) || {}),
                  nocListApplicantDoc: updatedNocList
                }
              }));
            }
          }), (params === null || params === void 0 ? void 0 : (_params$nocList3 = params.nocList) === null || _params$nocList3 === void 0 ? void 0 : _params$nocList3.some(noc => {
            var _noc$documents;
            return noc === null || noc === void 0 ? void 0 : (_noc$documents = noc.documents) === null || _noc$documents === void 0 ? void 0 : _noc$documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          })) && /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 4px"
            }
          }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
            onClick: () => handleSubTabChange(5),
            variant: "contained",
            color: "success",
            size: "medium",
            label: "Save",
            type: "submit",
            sx: {
              backgroundColor: "#157CB3"
            }
          }))) : isEmployee ? /*#__PURE__*/React__default.createElement(IdentifyNoc, {
            formData: params,
            tenantId: tenantId,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          }) :
          /*#__PURE__*/
          React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "No NOC available for this user.")));
        case 5:
          return /*#__PURE__*/React__default.createElement(SubStep6, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            tenantId: tenantId,
            departmentList: departmentList,
            avpData: null,
            isEmployee: isEmployee,
            isApproved: true
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$1, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 2 && isCompounding) {
      return /*#__PURE__*/React__default.createElement(CompoundingChecklist, {
        formData: params,
        handleTabChange: handleTabChange
      });
    } else if (activeTab === 2 && !isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step4, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 3 && isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step4Comp, {
        formData: params,
        handleTabChange: handleTabChange
      });
    } else if (activeTab === 3 && !isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step5, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4 && isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step5, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4 && !isCompounding || activeTab === 5 && isCompounding) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true,
        isAlreadySubmitted: isAlreadySubmitted,
        setIsAlreadySubmitted: setIsAlreadySubmitted,
        obpasFileNumber: obpasFileNumber,
        setObpasFileNumber: setObpasFileNumber,
        dateOfPayment: dateOfPayment,
        setDateOfPayment: setDateOfPayment,
        paymentReceipt: paymentReceipt,
        setPaymentReceipt: setPaymentReceipt
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT"))), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), isAlreadySubmitted === "Yes" ? /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Save",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => {
          const updatedParams = {
            ...params,
            isAlreadySubmitted: true,
            obpasFileNumber,
            obpasPaymentDate: dateOfPayment
          };
          if (paymentReceipt !== null && paymentReceipt !== void 0 && paymentReceipt.fileStoreId) {
            updatedParams.documents = [...(updatedParams.documents || []), {
              documentType: "PaymentReceipt",
              fileStoreId: paymentReceipt.fileStoreId,
              tenantId: tenantId
            }];
          }
          handleTabChange(isCompounding ? 6 : 5, updatedParams, true);
        },
        disabled: !declarationChecked || !isCompletionModule && (!obpasFileNumber || !dateOfPayment || !paymentReceipt)
      }) : /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" || (params === null || params === void 0 ? void 0 : params.isGovernmentBuilding) === "yes" ? "Forward to Department" : "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(isCompounding ? 6 : 5, params, true),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 6 && isCompounding || activeTab === 5 && !isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step6, {
        formData: params,
        handleSubTabChange: handleTabChange
      });
    } else if (activeTab === 7 && isCompounding) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ChatBoard, {
        formData: params,
        assignerToChatboard: []
      }));
    }
  };
  console.log("activeTab.........", activeTab);
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Map Submission")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), isCompounding && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Compounding Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Fees"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application History"
  }), isCompounding && /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Chat Board"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall.isLoading || isCreateLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const useLandUseData = ({
  id,
  tenantId,
  userInfo,
  usersData,
  applicationFlow,
  validity,
  userUid
}) => {
  var _data$LandUse, _usersData$, _usersData$2;
  const isEditMode = !!id;
  console.log("logginFromNewHookCreate", id, isEditMode);
  const consultantCategory = filterCategory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
      applicationNo: id
    });
  };
  const {
    data,
    isLoading: isAppDataLoading,
    isSuccess
  } = useQuery({
    queryKey: ["landUseData", id],
    queryFn: fetchApplicationData,
    enabled: isEditMode
  });
  const applicationData = isEditMode && isSuccess ? data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0] : {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      consultantCategory: consultantCategory,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      planDate: validity,
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      },
      certificateNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : _usersData$.registrationArchitectNumber,
      licenseNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.registrationNumber,
      planDate: validity
    },
    department: applicationFlow,
    landAreaDetails: {
      city: null,
      locality: null,
      village: null,
      areaType: null
    },
    descriptionOfLand: {
      revenueVillageMohal: null,
      propertyType: null,
      khataNo: null,
      multipleKhasra: [{
        khasraNo: "",
        area: ""
      }],
      khatauniNo: null,
      areaForCluSqM: 0,
      nameofConcerned: null,
      natureOfTower: null,
      towerToBeProposed: null,
      proposedGoundCoverageSqM: null,
      whetherUsedBySingleCompany: null,
      installationFeesDeposited: null,
      nameofConcerned: null,
      sectorNo: null,
      schemeName: null,
      approachRoadWidths: null,
      totalPlotArea: 0,
      appliedLandUse: {
        name: null
      },
      whetherUsedBySingleCompany: null,
      propertyType: {
        name: null
      },
      installationFeesDeposited: null,
      isChangeOfLandInvolved: null,
      typeOfCLUInvolved: {
        name: null
      }
    },
    activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
    applicationType: "FORM_LANDUSE",
    feeType: "ApplicationFee",
    workflow: {
      action: "INITIATE"
    },
    landInfo: {
      owners: [{
        name: null,
        fatherOrHusbandName: null,
        aadhaarNumber: "",
        mobileNumber: "",
        emailId: "",
        gender: null,
        correspondenceAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "PERMANENT"
        }
      }],
      tenantId
    },
    nocDetails: {
      applicantNOCData: null,
      additionalApplicantNOC: null,
      officerNOCData: null,
      additionalOfficerNOC: null,
      checkedByOfficer: null
    },
    businessService: null,
    documents: [],
    uiFlow: {
      flow: "Form_LANDUSE"
    }
  };
  return {
    applicationData,
    isAppDataLoading
  };
};

const useLandUseLogic = () => {
  var _Digit, _Digit2, _cities$filter, _cities$filter$, _cities$filter$$bound, _cities$filter2, _cities$filter2$, _cities$filter2$$boun;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    formType
  } = useParams();
  console.log(useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getStateId() || "up";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  console.log("idFromLogic", id);
  const Modal = useModal();
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [usersData, setUsersData] = useState([]);
  const [validity, setvalidity] = useState("");
  const {
    documents
  } = useSelector(state => state.formMT);
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  console.log("applicationFlowFromLogic", applicationFlow, userInfo);
  const consultantCategory = filterCategory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  useEffect(() => {
    const searchUser = async () => {
      try {
        var _response$user;
        const response = await Digit.UserService.userSearch(tenantId, {
          uuid: [userUid]
        }, {});
        console.log("searchUser:", response);
        setUsersData(response === null || response === void 0 ? void 0 : response.user);
        if ((response === null || response === void 0 ? void 0 : (_response$user = response.user) === null || _response$user === void 0 ? void 0 : _response$user.length) > 0) {
          var _response$user2, _response$user2$;
          const expiryDate = (response === null || response === void 0 ? void 0 : (_response$user2 = response.user) === null || _response$user2 === void 0 ? void 0 : (_response$user2$ = _response$user2[0]) === null || _response$user2$ === void 0 ? void 0 : _response$user2$.validUpto).split(" ")[0];
          console.log("expiryDateFromLogic", expiryDate);
          setvalidity(expiryDate);
        }
      } catch (error) {
        console.error("Error during user search:", error);
      }
    };
    searchUser();
  }, [tenantId, userUid, setvalidity]);
  const {
    applicationData,
    isAppDataLoading
  } = useLandUseData({
    id,
    tenantId,
    userInfo,
    usersData,
    applicationFlow,
    validity,
    userUid
  });
  const summaryRef = useRef();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORMLANDUSE", applicationData);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LANDUSE_CURRENT_TAB")) || 0);
  const [subActiveTab, setSubActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LANDUSE_CURRENT_SUBTAB")) || 0);
  const [showToast, setShowToast] = useState(null);
  const [archData, setArchData] = useState({});
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in params)) {
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse = result.LandUse) === null || _result$LandUse === void 0 ? void 0 : _result$LandUse.length) > 0) {
            onSelect("", {
              ...data,
              ...result.LandUse[0]
            }, true);
            setShowToast({
              key: "success",
              message: `Data has been saved successfully!`
            });
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            key: "true",
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        try {
          if (activeTab === 2 || nextTabNo === 4) {
            var _formData$description, _formData$nocDetails, _formData$nocDetails$, _formData$nocDetails2, _formData$nocDetails3, _Digit3, _Digit4, _Digit5;
            console.log("insideActiveTab3", activeTab, nextTabNo);
            let redirectUrl = "";
            let message = "";
            const riskType = formData === null || formData === void 0 ? void 0 : formData.riskType;
            const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
            console.log("riskingTypeFrom", riskType, isLowRiskCase);
            const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
            const isNoc = (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : (_formData$nocDetails$ = _formData$nocDetails.additionalApplicantNOC) === null || _formData$nocDetails$ === void 0 ? void 0 : _formData$nocDetails$.length) > 0 || (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.applicantNOCData) && Object.keys(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : _formData$nocDetails3.applicantNOCData).some(key => {
              var _formData$nocDetails4;
              return (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails4 = formData.nocDetails) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.applicantNOCData[key]) === true;
            });
            if (isLowRiskCase) {
              data.nocDetails = {};
            }
            const validation = validateSummaryForm({
              formType: "FORMLANDUSE",
              formData: data,
              reduxDocuments: documents,
              t
            });
            if (!validation.isValid) {
              Modal("Missing Mandatory Fields", validation.errorHtml, "error");
              return;
            }
            if ((data === null || data === void 0 ? void 0 : data.status) === "REVERT_TO_APPLICANT") {
              data.workflow = {
                action: "FORWARD_TO_DEPARTMENT",
                assignes: null
              };
              redirectUrl = "/digit-ui/citizen/profile";
            } else if (isSchemeType) {
              data.workflow = {
                action: "APPROVED",
                assignes: null
              };
              redirectUrl = "/digit-ui/citizen/profile";
              message = "Application Approved";
            } else if ((data === null || data === void 0 ? void 0 : data.isGovernmentBuilding) === "yes" && (data === null || data === void 0 ? void 0 : data.taxHeadEstimate) === null && activeTab === 2 && !isSchemeType) {
              data.workflow = {
                action: "FORWARD_TO_DEPARTMENT",
                assignes: null
              };
              redirectUrl = "/digit-ui/citizen/profile";
            } else if (!isSchemeType) {
              data.workflow = {
                action: "MAKE_PAYMENT",
                assignes: null
              };
              redirectUrl = `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${params === null || params === void 0 ? void 0 : params.applicationNo}/${tenantId}/tenantId=${tenantId}`;
            }
            console.log("logBeforeLandUSeupdate", data, redirectUrl);
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                onSelect("", data);
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
            console.log("messageFromLU", message);
            if ((data === null || data === void 0 ? void 0 : data.status) === "REVERT_TO_APPLICANT") {
              Modal("Data has been saved successfully!", `Application Submitted to Department Successfully!`, "success", redirectUrl);
            } else if (isSchemeType) {
              Modal("Data has been saved successfully!", `Low risk application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> approved Successfully!`, "success", redirectUrl);
            } else if (!isSchemeType && (data === null || data === void 0 ? void 0 : data.taxHeadEstimate) === null && (data === null || data === void 0 ? void 0 : data.isGovernmentBuilding) === "yes") {
              Modal("Data has been saved successfully!", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> submitted successfully!`, "success", redirectUrl);
            } else if (!isSchemeType) {
              Modal("Data has been saved successfully!", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> submitted successfully, redirecting to payment page.`, "success", `${citizenBaseUrl}/payment/collect/BPA.LAND_USE_FORM/${params === null || params === void 0 ? void 0 : params.applicationNo}/${tenantId}/tenantId=${tenantId}`);
            }
            clearParams();
            (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("FORMLANDUSE");
            (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("LANDUSE_CURRENT_TAB");
            (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
          } else {
            console.log("insideELseACTIVETAB", activeTab, nextTabNo);
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: null
            };
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                var _Digit6;
                onSelect("", data);
                setActiveTab(nextTabNo);
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
          }
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      }
    } else {
      var _Digit7;
      setActiveTab(nextTabNo);
      (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("subTabChange", params, formData);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse2;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse2 = result.LandUse) === null || _result$LandUse2 === void 0 ? void 0 : _result$LandUse2.length) > 0) {
            console.log("landuseResult", result === null || result === void 0 ? void 0 : result.LandUse);
            onSelect("", {
              ...formData,
              ...result.LandUse[0]
            }, "");
            setShowToast({
              key: "success",
              message: `Application Created Successfully!`
            });
            setSubActiveTab(nextSubTab);
            Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response2, _e$response2$data, _e$response2$data$Err;
          const error = (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$Err = _e$response2$data.Errors) === null || _e$response2$data$Err === void 0 ? void 0 : _e$response2$data$Err[0];
          if ((error === null || error === void 0 ? void 0 : error.message) === "The entered mobile number is already registered as an LTP. Please enter a valid owner mobile number." && (error === null || error === void 0 ? void 0 : error.code) === "ALready Registered Number") {
            Modal("User Already Registered", error === null || error === void 0 ? void 0 : error.message, "warning");
          } else {
            setShowToast({
              error: true,
              message: `Something went wrong!`
            });
          }
        });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: result => {
              var _result$LandUse3;
              if ((result === null || result === void 0 ? void 0 : (_result$LandUse3 = result.LandUse) === null || _result$LandUse3 === void 0 ? void 0 : _result$LandUse3.length) > 0) {
                onSelect("", result.LandUse[0]);
                setShowToast({
                  key: "success",
                  message: `Data has been saved successfully!`
                });
                setSubActiveTab(nextSubTab);
                Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
              }
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong!`
              });
            }
          });
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      BPA: {
        AVPSchemesUnitData: avpData
      } = {}
    } = {},
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["AVPSchemesUnitData"]);
  const avpUnits = avpData === null || avpData === void 0 ? void 0 : avpData.map(item => {
    return {
      name: item.Unit,
      label: item.Unit,
      value: item.Unit
    };
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  console.log("logoData", {
    logoStore,
    avpLogo,
    daLogo
  });
  const avpAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter = cities.filter(district => {
    var _district$code;
    return (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes("up.avp");
  })) === null || _cities$filter === void 0 ? void 0 : (_cities$filter$ = _cities$filter[0]) === null || _cities$filter$ === void 0 ? void 0 : (_cities$filter$$bound = _cities$filter$.boundary) === null || _cities$filter$$bound === void 0 ? void 0 : _cities$filter$$bound.filter(ele => ele.hasOwnProperty("location")) : [];
  const daAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter2 = cities.filter(district => {
    var _district$code2;
    return (_district$code2 = district.code) === null || _district$code2 === void 0 ? void 0 : _district$code2.includes("up.da");
  })) === null || _cities$filter2 === void 0 ? void 0 : (_cities$filter2$ = _cities$filter2[0]) === null || _cities$filter2$ === void 0 ? void 0 : (_cities$filter2$$boun = _cities$filter2$.boundary) === null || _cities$filter2$$boun === void 0 ? void 0 : _cities$filter2$$boun.filter(ele => ele.hasOwnProperty("location")) : [];
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  console.log("authoritiesNameMDMS", departmentList);
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "AVP");
  const officesList = applicationFlow == "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  console.log("fromLandUseLogic", officesList, applicationFlow);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  return {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setSubActiveTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo
  };
};

const Step2$3 = ({
  formData,
  isUpdating,
  handleTabChange,
  t,
  initFormMTDocs
}) => {
  var _formData$description2, _formData$description3, _formData$description4, _formData$description5;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  console.log("documentFromRedux", documents, formData);
  console.log("documentsectionRendered");
  const determineRiskType = formData => {
    const {
      activityAsPerMap,
      activityProposed,
      developmentArea,
      landArea,
      schemeType
    } = (formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand) || {};
    let riskType = "HIGH_NIVESH";
    if (activityAsPerMap === "Residential") {
      if (activityProposed === "Multi Unit" || activityProposed === "Group Housing" || activityProposed === "EWS Group Housing" || activityProposed === "LIG Group Housing" || activityProposed === "Affordable Group Housing") {
        riskType = "HIGH_NIVESH";
      } else if (activityProposed === "Row Houses" || activityProposed === "Semi Detached" || activityProposed === "Detached") {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else {
            if (schemeType === "Non Scheme") {
              riskType = "HIGH";
            }
          }
        } else {
          if (schemeType === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeType === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }
    return riskType;
  };
  const riskType = determineRiskType(formData);
  console.log("FinalriskType", riskType);
  const validateFiles = () => {
    var _formData$description;
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" ? ["completeDrawingFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA"] : ["completeDrawingFile", "registrySaleDeedHPTA"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation
    },
    documents: documents
  };
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) === "Scheme";
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    var _formData$documents;
    console.log("insideStep3effect");
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      var _formData$documents2;
      console.log("insideStep3effectIfCondition", formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.length);
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents, formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.schemeType]);
  const onSubmit = data => {
    const allowedDocs = isSchemeType ? ["completeDrawingFile", "kmlFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA", "sajraPlan", "giftDeed", "applicantPhoto", "signature"] : ["completeDrawingFile", "kmlFile", "developerConsortiumSalesAgreement", "khatauni", "registrySaleDeedHPTA", "mutationLetter", "sajraPlan", "applicantPhoto", "signature"];
    const conditionalDocs = documents === null || documents === void 0 ? void 0 : documents.filter(doc => {
      var _doc$documentType;
      return allowedDocs.includes(doc.documentType) || ((_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.startsWith("signature_"));
    });
    console.log("conditionalDocs", conditionalDocs);
    data = {
      ...data,
      riskType,
      descriptionOfLand: {
        ...data.descriptionOfLand,
        googleMapCoordinates: coordinate,
        googleMapLocation: googleLocation
      },
      documents: conditionalDocs
    };
    console.log("dataFromstep2", data);
    handleTabChange(2, data);
    console.log("insdieElseFromsubmit", showError);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-3",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including location/site plan, key plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "Upload File",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType && /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Allotment letter/Possession letter",
    control: control,
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Developer/Consortium/Sales Agreement",
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Khatauni",
    name: "khatauni",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMandatory: true,
    required: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Mutation Letter",
    name: "mutationLetter",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Site Superimposed on Sajra Plan",
    control: control,
    name: "sajraPlan",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => {
      handleTabChange(0);
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const LandUse2 = () => {
  var _params$professionalI;
  const {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    setSubActiveTab,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo
  } = useLandUseLogic();
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList
  });
  console.log(applicationData, params, validity, usersData, "app_data");
  const applicationNumber = params === null || params === void 0 ? void 0 : params.applicationNo;
  const isOwner = (params === null || params === void 0 ? void 0 : (_params$professionalI = params.professionalInformation) === null || _params$professionalI === void 0 ? void 0 : _params$professionalI.consultantCategory) === "Owner";
  console.log(isOwner, "isOwner");
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  const filteredSubTabs = isOwner ? subTabLabels.filter(tab => tab.text !== "Licensed Technical Professional (LTP) Information") : subTabLabels;
  useEffect(() => {
    var _applicationData$docu2;
    setParams(applicationData);
    if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu2 = applicationData.documents) === null || _applicationData$docu2 === void 0 ? void 0 : _applicationData$docu2.length) > 0) {
      initFormMTDocs(applicationData.documents);
    } else {
      resetFormMTDocs();
    }
  }, [id, isAppDataLoading]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            applicationFlow: applicationFlow || (params === null || params === void 0 ? void 0 : params.department),
            officesList: officesList,
            avpData: avpData,
            avpUnits: avpUnits,
            setShowToast: setShowToast,
            setParams: setParams
          });
        case 1:
          if (isOwner) return /*#__PURE__*/React__default.createElement(SubStep4$1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            landSubUseTypes: landSubUses,
            landUseListActivities: landUseListActivities,
            landUsesSchemeTypeList: landUsesSchemeList,
            landSubUseTypes2: landSubUseTypes2,
            tenantId: tenantId,
            departmentList: departmentList,
            avpList: avpList,
            applicationFlow: applicationFlow || (params === null || params === void 0 ? void 0 : params.department),
            avpData: avpData,
            id: id,
            isEdit: Boolean(id || (params === null || params === void 0 ? void 0 : params.applicationNo)),
            setParams: setParams
          });
          return /*#__PURE__*/React__default.createElement(SubStep3$1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            archData: archData,
            validity: validity,
            usersData: usersData
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            landSubUseTypes: landSubUses,
            landUseListActivities: landUseListActivities,
            landUsesSchemeTypeList: landUsesSchemeList,
            landSubUseTypes2: landSubUseTypes2,
            tenantId: tenantId,
            departmentList: departmentList,
            avpList: avpList,
            applicationFlow: applicationFlow || (params === null || params === void 0 ? void 0 : params.department),
            avpData: avpData,
            id: id,
            isEdit: Boolean(id || (params === null || params === void 0 ? void 0 : params.applicationNo)),
            setParams: setParams
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$3, {
        formData: params,
        isUpdating: updateApiCall.isLoading,
        handleTabChange: handleTabChange,
        t: t,
        initFormMTDocs: initFormMTDocs
      });
    }
    if (activeTab === 2 && applicationNumber) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$2, {
        style: {
          marginTop: "20px"
        }
      }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
        formType: "formLandUse",
        id: applicationNumber,
        ref: summaryRef,
        logoData: applicationFlow === "DA" || (params === null || params === void 0 ? void 0 : params.department) === "DA" ? daLogo : avpLogo
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT")), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#000"
          }
        }, "Print Summary"),
        content: () => summaryRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => {
          handleTabChange(0);
          handleSubTabChange(0);
        }
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: "#000"
        },
        onClick: () => handleTabChange(4, params)
      })))));
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (applicationFlow === null && !(params !== null && params !== void 0 && params.department)) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      padding: "20px"
    },
    className: "bg-white"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formStripLandUse mb-3 border-0"
  }, /*#__PURE__*/React__default.createElement("h2", null, t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT"))), /*#__PURE__*/React__default.createElement("div", {
    className: "main-panel-corner land-use-corner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "left-corner"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => setActiveTab(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, primaryTab.map((item, index) => /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    key: `${item.text}.${index}`,
    label: item.text
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "right-corner"
  }, /*#__PURE__*/React__default.createElement("div", null, activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, filteredSubTabs.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent()))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const usePurchasableFarLogic = () => {
  var _Digit, _Digit2, _cities$filter, _cities$filter$, _cities$filter$$bound, _cities$filter2, _cities$filter2$, _cities$filter2$$boun;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("PURCHASABLE_FAR_TAB")) || 0);
  const [subActiveTab, setSubActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("PURCHASABLE_FAR_SUBTAB")) || 0);
  const [assignLTP, setAssignLTP] = useState("No");
  const [usersData, setUsersData] = useState({});
  const [isUserEligible, setIsUserEligible] = useState(true);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const {
    authority,
    plan,
    form,
    year,
    serial,
    formType
  } = useParams();
  console.log(useParams(), "paramsHook");
  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  const history = useHistory();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const {
    data: {
      BPA: {
        ProposedActivityPurchasableFAR: pFarList
      } = {}
    } = {},
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["ProposedActivityPurchasableFAR"]);
  console.log("pFarData", pFarList);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    info: userInfo = {}
  } = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("dataLandUSeSearch", "params", id);
  const useGetPurchasableFarData = (id = null) => {
    if (id) {
      var _data$PurchasableFAR;
      console.log("insdieifhook call", typeof id, id);
      const fetchApplicationData = async () => {
        return await Digit.OBPSService.BPASearchPurchasableFAR(tenantId, {
          applicationNo: id
        });
      };
      const {
        data,
        isLoading: isAppDataLoading,
        isSuccess
      } = useQuery({
        queryKey: [id],
        queryFn: fetchApplicationData
      });
      const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]);
      console.log("insdieifhook call", _applicationData);
      return {
        applicationData: _applicationData,
        isAppDataLoading
      };
    }
    const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    const applicationType = "FORM_PURCHASABLE_FAR";
    async function searchUser() {
      try {
        const response = await Digit.UserService.userSearch(tenantId, {
          uuid: [userUid]
        }, {});
        const allUsers = await Digit.UserService.allUsersSearch(tenantId, {}, {});
        console.log("searchUser:", response);
        console.log("searchUser2:", allUsers);
        setUsersData(response);
        return response;
      } catch (error) {
        console.error("Error during user search:", error);
      }
    }
    useEffect(() => {
      searchUser();
    }, [id]);
    const applicationData = {
      tenantId: tenantId,
      selectedOffice: null,
      assignLTP: null,
      professionalInformation: {
        ltpName: null,
        ltpMobileNumber: null,
        ltpUuid: null,
        ltpRegistrationNumber: null,
        ltpCity: null,
        applicantName: null,
        applicantMobileNumber: null
      },
      descriptionOfLand: {
        googleMapCoordinates: null,
        googleMapLocation: null,
        properties: [{
          constructionType: null,
          sectorNo: null,
          propertyNo: null,
          schemeName: null,
          block: null,
          khataNo: null,
          khasraNo: null,
          khatauniNo: null,
          landWidth: null,
          plotArea: 0,
          plotNo: null,
          schemeRate: 0,
          takenFAR: null,
          baseFAR: 0,
          circleRate: 0,
          maxPermissibleFar: null,
          factor: 0,
          roadWidth: null,
          subLandUseAsPerLayout: null,
          permissibleFAR: null,
          permissibleGroundCoverage: null,
          purchasableFAR: null,
          percentRequiredFAR: null,
          requiredAreaFAR: null,
          landUseAsPerLayout: null,
          propertyType: {
            name: null
          }
        }]
      },
      checklist: {
        firstCheckList: {
          setbackPosition: {
            front: null,
            rear: null,
            left: null,
            right: null
          },
          buildingHeight: null,
          structuralSafety: null,
          totalParkingRequired: null,
          parkingProvision: {
            inBasement: {
              cars: null,
              ecs: null
            },
            openArea: {
              cars: null,
              ecs: null
            },
            inStiltArea: {
              cars: null,
              ecs: null
            }
          }
        },
        secondCheckList: {
          publicSewerageOrSepticTank: null,
          drainagePlanApproval: null,
          existingRoadWidth: null,
          minimum24MetersWide: null,
          waterSupplyArrangement: null,
          waterSupplyPlanApproval: null,
          stpSepticTankArrangement: null,
          connectivityWithGovernmentAuthority: null,
          drainageSystemComplianceWithStandards: null,
          drainageAsPerStandards: null,
          totalEstimatedPowerDemand: null,
          powerSupplyConsent: null,
          rooftopAreaAndDrainage: null,
          drainageStandardsCompliance: null,
          solarWaterHeatingProvision: null,
          buildingByeLawsCompliance: null
        }
      },
      checklistReview: {
        firstCheckList: {
          setbackPosition: {
            front: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            rear: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            left: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            right: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          buildingHeight: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          proposalDocument: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          drawingFile: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          structuralSafety: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          structuralSafetyCert: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          fireDepartmentCert: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          totalParkingRequired: {
            verifiedByOfficer: null,
            correction: null,
            remarks: null
          },
          parkingProvision: {
            inBasement: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              }
            },
            openArea: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              }
            },
            inStiltArea: {
              cars: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              },
              ecs: {
                verifiedByOfficer: null,
                correction: null,
                remarks: null
              }
            }
          }
        },
        secondCheckList: {
          sewerage: {
            publicSewerageOrSepticTank: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            drainagePlanApproval: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          roadConnectivity: {
            existingRoadWidth: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            minimum24MetersWide: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          waterSupply: {
            waterSupplyArrangement: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            waterSupplyPlanApproval: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          sewerageDisposal: {
            stpSepticTankArrangement: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            connectivityWithGovernmentAuthority: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          drainageSystemCompliance: {
            systemAsPerStandards: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            drainageAsPerStandards: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          powerSupply: {
            totalEstimatedPowerDemand: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            powerSupplyConsent: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          rooftopRainwaterHarvesting: {
            areaAndDrainage: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            drainageStandardsCompliance: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          },
          solarWaterSystem: {
            provisionForPipes: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            },
            buildingByeLawsCompliance: {
              verifiedByOfficer: null,
              correction: null,
              remarks: null
            }
          }
        },
        currentEmpRole: null,
        lastEmpRole: null
      },
      applicationType,
      approvedLayout: null,
      feeType: "ApplicationFee",
      department: applicationFlow,
      workflow: {
        action: "INITIATE",
        assignes: [userUid]
      },
      landInfo: {
        tenantId: tenantId,
        address: {
          tenantId,
          locality: {
            code: "Agra"
          }
        },
        owners: [{
          name: null,
          fatherOrHusbandName: null,
          aadhaarNumber: "",
          mobileNumber: "",
          emailId: "",
          gender: null,
          correspondenceAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "CORRESPONDENCE"
          },
          permanentAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "PERMANENT"
          },
          bankdetails: {
            accountHolderName: null,
            branchName: null,
            ifscCode: null,
            accountNo: null,
            bankName: null
          }
        }]
      },
      businessService: null,
      documents,
      uiFlow: {
        flow: "FORM_PURCHASABLE_FAR"
      }
    };
    return {
      applicationData,
      isAppDataLoading: false
    };
  };
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const {
    applicationData,
    isAppDataLoading
  } = useGetPurchasableFarData(id);
  console.log("approvedLandUSe", applicationFlow);
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PURCHASABLE_FAR", applicationData);
  const isSessionCleared = useRef(false);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    console.log("nextTabReceived", nextTabNo, activeTab);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      console.log(formData, params, data, "fromHandleTabCHange");
      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in formData)) {
        const _data = {
          ...applicationData,
          ...formData
        };
        console.log("fromCreatePayload", _data);
        Digit.OBPSService.createPurchasableFAR({
          PurchasableFAR: _data
        }, tenantId).then(res => {
          var _res$PurchasableFAR, _res$PurchasableFAR2;
          console.log(res.data, res, "promise");
          const result = (_res$PurchasableFAR = res.PurchasableFAR) === null || _res$PurchasableFAR === void 0 ? void 0 : _res$PurchasableFAR[0];
          if ((res === null || res === void 0 ? void 0 : (_res$PurchasableFAR2 = res.PurchasableFAR) === null || _res$PurchasableFAR2 === void 0 ? void 0 : _res$PurchasableFAR2.length) > 0) {
            onSelect("", {
              ...formData,
              ...result
            }, true);
            setShowToast({
              key: "success",
              message: `Application Created Successfully!`
            });
            setActiveTab(nextTabNo);
            sessionStorage.setItem("currentTab", nextTabNo);
            Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        try {
          if (activeTab === 4 && assignLTP === "No") {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
          } else if (activeTab === 4 && assignLTP === "Yes" && isAssignedLTP) {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
          } else if (activeTab === 4 && assignLTP === "Yes" && !isAssignedLTP) {
            data.workflow = {
              action: "FORWARD_TO_LTP",
              assignes: null
            };
          } else if (activeTab === 3) {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
          } else {
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: [userUid]
            };
          }
          updateApiCall.mutate({
            PurchasableFAR: data
          }, {
            onSuccess: () => {
              onSelect("", data);
              if (activeTab == 3) {
                var _Digit3, _Digit4, _Digit5;
                Modal("Application submitted.", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> Submitted Successfully!`, "success", "/digit-ui/citizen/profile", closeModal);
                clearParams();
                (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("FORM_PURCHASABLE_FAR");
                (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("PURCHASABLE_FAR_TAB");
                (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("PURCHASABLE_FAR_SUBTAB");
              } else {
                setShowToast({
                  key: "success",
                  message: `Application Updated Successfully!`
                });
                setActiveTab(nextTabNo);
                sessionStorage.setItem("currentTab", nextTabNo);
                Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
              }
            },
            onError: error => {
              const errorObject = JSON.parse(error === null || error === void 0 ? void 0 : error.message);
              if (errorObject.code === "InvalidInputException") {
                setShowToast({
                  error: true,
                  message: `${errorObject.description}`
                });
              }
            }
          });
        } catch (error) {
          console.error(e);
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      }
    } else {
      console.log("inside handle change else");
      if (assignLTP === "Yes" && nextTabNo === 2 && !isAssignedLTP) {
        setActiveTab(5);
        sessionStorage.setItem("currentTab", 5);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", 5);
      } else {
        setActiveTab(nextTabNo);
        sessionStorage.setItem("currentTab", nextTabNo);
        Digit.SessionStorage.set("PURCHASABLE_FAR_TAB", nextTabNo);
      }
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("insdieSubttab", nextSubTab, activeTab, subActiveTab, formData);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      console.log("insideIfSubTabhandler", formData, data, params);
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);
        Digit.OBPSService.createPurchasableFAR({
          PurchasableFAR: data
        }, tenantId).then(result => {
          var _result$PurchasableFA;
          if ((result === null || result === void 0 ? void 0 : (_result$PurchasableFA = result.PurchasableFAR) === null || _result$PurchasableFA === void 0 ? void 0 : _result$PurchasableFA.length) > 0) {
            console.log("farResult", result === null || result === void 0 ? void 0 : result.PurchasableFAR);
            onSelect("", {
              ...formData,
              ...result.PurchasableFAR[0]
            }, "");
            setShowToast({
              key: "success",
              message: `Application Created Successfully!`
            });
            setSubActiveTab(nextSubTab);
            Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            PurchasableFAR: data
          }, {
            onSuccess: result => {
              var _result$PurchasableFA2;
              if ((result === null || result === void 0 ? void 0 : (_result$PurchasableFA2 = result.PurchasableFAR) === null || _result$PurchasableFA2 === void 0 ? void 0 : _result$PurchasableFA2.length) > 0) {
                onSelect("", result.PurchasableFAR[0]);
                setShowToast({
                  key: "success",
                  message: `Application Updated Successfully!`
                });
                setSubActiveTab(nextSubTab);
                Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
              }
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong!!`
              });
            }
          });
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("PURCHASABLE_FAR_SUBTAB", nextSubTab);
    }
  };
  const {
    FAR_SB,
    FAR_PT,
    FAR_ST
  } = useLocalizedData({
    FAR_SB: SideBarLabelsFAR,
    FAR_PT: farPrimaryLabels,
    FAR_ST: farSubTabLabels
  });
  const avpAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter = cities.filter(district => {
    var _district$code;
    return district === null || district === void 0 ? void 0 : (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes("up.avp");
  })) === null || _cities$filter === void 0 ? void 0 : (_cities$filter$ = _cities$filter[0]) === null || _cities$filter$ === void 0 ? void 0 : (_cities$filter$$bound = _cities$filter$.boundary) === null || _cities$filter$$bound === void 0 ? void 0 : _cities$filter$$bound.filter(ele => ele.hasOwnProperty("location")) : [];
  const daAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter2 = cities.filter(district => {
    var _district$code2;
    return district === null || district === void 0 ? void 0 : (_district$code2 = district.code) === null || _district$code2 === void 0 ? void 0 : _district$code2.includes("up.da");
  })) === null || _cities$filter2 === void 0 ? void 0 : (_cities$filter2$ = _cities$filter2[0]) === null || _cities$filter2$ === void 0 ? void 0 : (_cities$filter2$$boun = _cities$filter2$.boundary) === null || _cities$filter2$$boun === void 0 ? void 0 : _cities$filter2$$boun.filter(ele => ele.hasOwnProperty("location")) : [];
  console.log("authorityList", avpAuthorityList, daAuthorityList);
  const filterOfficeNames = completeList => {
    const officeNames = completeList.map(office => ({
      value: office.name,
      label: office.name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  };
  const officesList = applicationFlow === "DA" ? filterOfficeNames(daAuthorityList) : filterOfficeNames(avpAuthorityList);
  console.log("applicationData", applicationData, "fromFAR");
  const summaryRef = useRef();
  const [showToast, setShowToast] = useState(null);
  const Modal = useModal();
  const closeModal = () => {
    console.log("triggeredCloseModal");
    clearParams();
    sessionStorage.removeItem("currentTab");
    sessionStorage.removeItem("currentCity");
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    setTimeout(() => {
      resetFormMTDocs();
    }, 0);
    setShowToast(null);
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  return {
    activeTab,
    setActiveTab,
    assignLTP,
    setAssignLTP,
    dispatch,
    t,
    id,
    history,
    initFormMTDocs,
    resetFormMTDocs,
    isUdFlow,
    applicationFlow,
    userUid,
    params,
    setParams,
    clearParams,
    isSessionCleared,
    isAppDataLoading,
    summaryRef,
    showToast,
    Modal,
    closeModal,
    handleTabChange,
    handleSubTabChange,
    applicationData,
    userInfo,
    tenantId,
    FAR_SB,
    FAR_PT,
    subActiveTab,
    setSubActiveTab,
    FAR_ST,
    isUserEligible,
    setIsUserEligible,
    officesList,
    DepartmentSelector,
    closeToast,
    setShowToast,
    pFarList
  };
};

function validateChecklist(data) {
  var _data$checklist, _data$checklist$first, _data$checklist2, _data$checklist2$firs, _data$checklist3, _data$checklist3$firs, _data$checklist4, _data$checklist4$firs, _data$checklist4$firs2, _data$checklist4$firs3, _data$checklist5, _data$checklist5$firs, _data$checklist5$firs2, _data$checklist5$firs3, _data$checklist6, _data$checklist6$firs, _data$checklist6$firs2, _data$checklist6$firs3, _data$checklist7, _data$checklist7$firs;
  console.log("checklistValidation", data);
  const buildingHeight = Number(data === null || data === void 0 ? void 0 : (_data$checklist = data.checklist) === null || _data$checklist === void 0 ? void 0 : (_data$checklist$first = _data$checklist.firstCheckList) === null || _data$checklist$first === void 0 ? void 0 : _data$checklist$first.buildingHeight);
  const requiredParking = Number(data === null || data === void 0 ? void 0 : (_data$checklist2 = data.checklist) === null || _data$checklist2 === void 0 ? void 0 : (_data$checklist2$firs = _data$checklist2.firstCheckList) === null || _data$checklist2$firs === void 0 ? void 0 : _data$checklist2$firs.totalParkingRequired);
  const proposedParking = Number(data === null || data === void 0 ? void 0 : (_data$checklist3 = data.checklist) === null || _data$checklist3 === void 0 ? void 0 : (_data$checklist3$firs = _data$checklist3.firstCheckList) === null || _data$checklist3$firs === void 0 ? void 0 : _data$checklist3$firs.totalParkingProposed);
  const stiltCars = Number(data === null || data === void 0 ? void 0 : (_data$checklist4 = data.checklist) === null || _data$checklist4 === void 0 ? void 0 : (_data$checklist4$firs = _data$checklist4.firstCheckList) === null || _data$checklist4$firs === void 0 ? void 0 : (_data$checklist4$firs2 = _data$checklist4$firs.parkingProvision) === null || _data$checklist4$firs2 === void 0 ? void 0 : (_data$checklist4$firs3 = _data$checklist4$firs2.inStiltArea) === null || _data$checklist4$firs3 === void 0 ? void 0 : _data$checklist4$firs3.cars);
  const openAreaCars = Number(data === null || data === void 0 ? void 0 : (_data$checklist5 = data.checklist) === null || _data$checklist5 === void 0 ? void 0 : (_data$checklist5$firs = _data$checklist5.firstCheckList) === null || _data$checklist5$firs === void 0 ? void 0 : (_data$checklist5$firs2 = _data$checklist5$firs.parkingProvision) === null || _data$checklist5$firs2 === void 0 ? void 0 : (_data$checklist5$firs3 = _data$checklist5$firs2.openArea) === null || _data$checklist5$firs3 === void 0 ? void 0 : _data$checklist5$firs3.cars);
  const basementCars = Number(data === null || data === void 0 ? void 0 : (_data$checklist6 = data.checklist) === null || _data$checklist6 === void 0 ? void 0 : (_data$checklist6$firs = _data$checklist6.firstCheckList) === null || _data$checklist6$firs === void 0 ? void 0 : (_data$checklist6$firs2 = _data$checklist6$firs.parkingProvision) === null || _data$checklist6$firs2 === void 0 ? void 0 : (_data$checklist6$firs3 = _data$checklist6$firs2.inBasement) === null || _data$checklist6$firs3 === void 0 ? void 0 : _data$checklist6$firs3.cars);
  const {
    front,
    rear,
    ssb1,
    ssb2
  } = data === null || data === void 0 ? void 0 : (_data$checklist7 = data.checklist) === null || _data$checklist7 === void 0 ? void 0 : (_data$checklist7$firs = _data$checklist7.firstCheckList) === null || _data$checklist7$firs === void 0 ? void 0 : _data$checklist7$firs.setbackPosition;
  const frontNum = Number(front);
  const rearNum = Number(rear);
  const ssb1Num = Number(ssb1);
  const ssb2Num = Number(ssb2);
  console.log("dataFronValidation", stiltCars + basementCars + openAreaCars !== proposedParking, proposedParking < requiredParking, proposedParking, requiredParking, stiltCars + basementCars + openAreaCars);
  const setbackRanges = [{
    maxHeight: 15,
    minSetback: 5
  }, {
    maxHeight: 18,
    minSetback: 6
  }, {
    maxHeight: 21,
    minSetback: 7
  }, {
    maxHeight: 24,
    minSetback: 8
  }, {
    maxHeight: 27,
    minSetback: 9
  }, {
    maxHeight: 30,
    minSetback: 10
  }, {
    maxHeight: 35,
    minSetback: 11
  }, {
    maxHeight: 40,
    minSetback: 12
  }, {
    maxHeight: 45,
    minSetback: 13
  }, {
    maxHeight: 50,
    minSetback: 14
  }, {
    maxHeight: 55,
    minSetback: 15
  }, {
    maxHeight: Infinity,
    minSetback: 16
  }];
  const applicableRange = setbackRanges.find(range => buildingHeight <= range.maxHeight);
  if (!applicableRange) {
    return {
      message: "Invalid building height.",
      isChecklistValid: false
    };
  }
  const {
    minSetback
  } = applicableRange;
  const setbacks = [frontNum, rearNum, ssb1Num, ssb2Num];
  for (let i = 0; i < setbacks.length; i++) {
    if (setbacks[i] < minSetback) {
      return {
        message: `For a building height of up to ${applicableRange.maxHeight} meters, the minimum setback for all sides should be at least ${minSetback} meters. Please ensure that the front, rear, and side setbacks are properly adjusted.`,
        isChecklistValid: false
      };
    }
  }
  if (proposedParking < requiredParking) {
    return {
      message: "The proposed parking capacity is less than the required parking. Please adjust the proposed value to meet the requirements.",
      isChecklistValid: false
    };
  }
  if (stiltCars + basementCars + openAreaCars !== proposedParking) {
    return {
      message: "The total number of cars in the stilt, basement, and open areas does not match the proposed parking capacity. Please adjust the values to meet the required total.",
      isChecklistValid: false
    };
  }
  console.log("Validation successful!");
  return {
    message: "",
    isChecklistValid: true
  };
}
const fetchLandUseApplication = async applicationNum => {
  console.log("loggingParamsFromAsync", applicationNum);
  try {
    var _response$BPA;
    sessionStorage.setItem("LandUseAppNum", applicationNum);
    const response = await Digit.OBPSService.BPAFastPASSearch({
      land_Id: applicationNum
    });
    console.log("loggingParamsFromAsync", applicationNum, response);
    if ((response === null || response === void 0 ? void 0 : (_response$BPA = response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) > 0) {
      console.log("loggingFromQueyrFunc", response.BPA[0]);
      return response.BPA.filter(item => item.applicationType === "FORM_LANDUSE")[0];
    } else {
      throw new Error("No data found.");
    }
  } catch (error) {
    throw error;
  }
};

const SubStep1$b = ({
  formData,
  handleSubTabChange,
  t,
  dispatch,
  isUserEligible,
  setIsUserEligible,
  isAssignedLTP,
  officesList,
  applicationFlow,
  tenantId,
  showToast,
  setShowToast,
  isEmployee,
  isApproved,
  userInfo
}) => {
  var _watch, _watch$split;
  const defaultValues = {
    ...formData,
    department: applicationFlow
  };
  console.log("3535353535", formData, applicationFlow);
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const [isAuthorizedSearch, setIsAuthorizedSearch] = useState(false);
  const selectedApplicationNumber = watch("selectedApplication");
  const watchSelectedOffice = (_watch = watch("selectedOffice")) === null || _watch === void 0 ? void 0 : (_watch$split = _watch.split(" ")) === null || _watch$split === void 0 ? void 0 : _watch$split[0];
  const watchCity = watch("selectedCity");
  console.log("showToastSub1", showToast);
  const {
    data: applicationData,
    isLoading: isAppDataLoading,
    error,
    refetch
  } = useQuery(["LandUseData", getValues("land_Id")], () => fetchLandUseApplication(getValues("land_Id")), {
    enabled: !!getValues("land_Id") && isAuthorizedSearch
  });
  const isDA = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.department) === "DA";
  const stateId = Digit.ULBService.getStateId();
  console.log("applicationData", applicationData);
  function userEligibility() {
    var _applicationData$desc, _applicationData$desc4;
    if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.landUsesType) === "Residential") {
      var _applicationData$desc2;
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc2 = applicationData.descriptionOfLand) === null || _applicationData$desc2 === void 0 ? void 0 : _applicationData$desc2.subLandUseAsPerLayout) === "Group Housing") {
        var _applicationData$desc3;
        if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc3 = applicationData.descriptionOfLand) === null || _applicationData$desc3 === void 0 ? void 0 : _applicationData$desc3.landArea) >= 2000) {
          return true;
        }
      }
    } else if (!((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc4 = applicationData.descriptionOfLand) === null || _applicationData$desc4 === void 0 ? void 0 : _applicationData$desc4.landUsesType) === "Residential")) {
      var _applicationData$desc5;
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc5 = applicationData.descriptionOfLand) === null || _applicationData$desc5 === void 0 ? void 0 : _applicationData$desc5.landArea) >= 2500) {
        return true;
      }
    } else return false;
  }
  const handleSearchClick = async applicationNo => {
    try {
      var _response$BPA, _response$BPA2, _await$Digit$UserServ, _await$Digit$UserServ2, _data$additionalDetai, _data$additionalDetai2;
      if (!applicationNo) return;
      setIsAuthorizedSearch(false);
      const response = await Digit.OBPSService.BPAFastPASSearch({
        land_Id: applicationNo
      });
      if (!(response !== null && response !== void 0 && (_response$BPA = response.BPA) !== null && _response$BPA !== void 0 && _response$BPA.length)) {
        setShowToast({
          key: "true",
          error: true,
          message: `No Data Found for this FASTPAS ID...!!`
        });
        reset({
          ...getValues(),
          land_Id: ""
        });
        return;
      }
      const data = response === null || response === void 0 ? void 0 : (_response$BPA2 = response.BPA) === null || _response$BPA2 === void 0 ? void 0 : _response$BPA2.find(item => item.applicationType === "FORM_LANDUSE");
      if (!data) {
        setShowToast({
          key: "true",
          error: true,
          message: `No data found for this ID...!!`
        });
        reset({
          ...getValues(),
          land_Id: ""
        });
        return;
      }
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      const userDetail = (_await$Digit$UserServ = await Digit.UserService.userSearch(stateId, {
        uuid: [uuid]
      }, {})) === null || _await$Digit$UserServ === void 0 ? void 0 : (_await$Digit$UserServ2 = _await$Digit$UserServ.user) === null || _await$Digit$UserServ2 === void 0 ? void 0 : _await$Digit$UserServ2[0];
      if (!userDetail || (data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.professionalInformation) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.mobileNumber) !== (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
        setShowToast({
          key: "true",
          error: true,
          message: `Not Authorized to access this Id...!!`
        });
        reset({
          ...getValues(),
          land_Id: ""
        });
        return;
      }
      setShowToast({
        key: "true",
        error: false,
        message: `Data fetched Successfully...!!`
      });
      setIsAuthorizedSearch(true);
      Digit.SessionStorage.set("FASTPAS_ID", data);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    if (!isAppDataLoading && applicationData) {
      console.log("fromEffectData", applicationData);
      dispatch(setApplicationData(applicationData, false, null));
    }
  }, [isAppDataLoading, applicationData]);
  useEffect(() => {
    setIsUserEligible(userEligibility());
    setIsUserEligible(true);
    if (applicationData) {
      var _formData$landInfo, _applicationData$docu, _applicationData$desc6, _applicationData$desc7, _applicationData$desc8;
      const landUseAppNum = sessionStorage.getItem("LandUseAppNum");
      reset({
        ...formData,
        selectedOffice: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedOffice,
        selectedUnit: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedUnit,
        selectedCity: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedCity,
        land_Id: !!landUseAppNum ? landUseAppNum : "",
        landInfo: {
          ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
          owners: formData !== null && formData !== void 0 && formData.applicationNo ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners : null
        }
      });
      const fetchBusinessService = async () => {
        const result = await Digit.LocationService.getBusinessServices(isDA ? watchSelectedOffice : watchCity, null, "FORM_PURCHASABLE_FAR", applicationFlow);
        console.log(result, "businessService");
        setValue("businessService", result);
        setValue("landInfo.address.locality.code", isDA ? watchSelectedOffice : watchCity);
      };
      if (watchSelectedOffice || watchCity) {
        fetchBusinessService();
      }
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
      console.log("appData", applicationData, Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc6 = applicationData.descriptionOfLand) === null || _applicationData$desc6 === void 0 ? void 0 : (_applicationData$desc7 = _applicationData$desc6.roadWidths) === null || _applicationData$desc7 === void 0 ? void 0 : (_applicationData$desc8 = _applicationData$desc7[0]) === null || _applicationData$desc8 === void 0 ? void 0 : _applicationData$desc8.value));
    }
  }, [applicationData, watchSelectedOffice, watchCity]);
  const onSubmit = data => {
    data = {
      ...data,
      department: applicationData === null || applicationData === void 0 ? void 0 : applicationData.department,
      professionalInformation: applicationData === null || applicationData === void 0 ? void 0 : applicationData.professionalInformation,
      documents: applicationData === null || applicationData === void 0 ? void 0 : applicationData.documents
    };
    console.log("dataFromSub1", data);
    handleSubTabChange(1, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Approved Land Use")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      padding: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "land_Id",
    type: "textInput",
    mandatory: true,
    disabled: isEmployee || isApproved,
    isApproved: true,
    defaultValue: applicationData === null || applicationData === void 0 ? void 0 : applicationData.land_Id,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("land_Id"))
  })), isDA && applicationData ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: applicationFlow === "DA" ? "Select Development Authority" : "Select Avas Vikas Parishad",
    inputLabel: "Select office",
    placeholder: "Select office",
    name: "selectedOffice",
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedOffice) || isEmployee || isApproved),
    type: "selectInput",
    data: officesList,
    defaultValue: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedOffice,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null))), !isDA && applicationData && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "selectInput",
    mandatory: true,
    ddisabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedUnit) || isEmployee || isApproved),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "selectInput",
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : formData.selectedCity) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedCity) || isEmployee || isApproved),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), isUserEligible && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    disabled: isAppDataLoading,
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const SubStep3$8 = ({
  formData,
  handleSubTabChange,
  t,
  applicationFlow,
  isAssignedLTP,
  applicationData,
  pFarList,
  isApproved,
  isEmployee
}) => {
  var _applicationData$desc, _applicationData$desc2, _applicationData$desc3, _applicationData$desc4, _applicationData$desc5, _applicationData$desc6, _applicationData$desc7, _applicationData$desc28, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _applicationData$desc29, _formData$description7, _formData$description8, _formData$description9, _applicationData$desc30, _formData$description10, _formData$description11, _formData$description12, _applicationData$desc31, _formData$description13, _formData$description14, _formData$description15, _applicationData$desc32, _formData$description16, _formData$description17, _formData$description18, _applicationData$desc33, _applicationData$desc34, _applicationData$desc35, _applicationData$desc36, _formData$description19, _formData$description20, _formData$description21, _applicationData$desc37, _applicationData$desc38, _applicationData$desc39, _applicationData$desc40, _formData$description22, _formData$description23, _formData$description24, _applicationData$desc41, _formData$description25, _formData$description26, _formData$description27, _applicationData$desc42, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description36, _applicationData$desc43, _formData$description37, _formData$description38, _formData$description39, _applicationData$desc44, _applicationData$desc45, _formData$description40, _formData$description41, _formData$description42, _applicationData$desc46, _formData$description43, _formData$description44, _formData$description45, _applicationData$desc47, _formData$description46, _formData$description47, _formData$description48, _applicationData$desc48, _applicationData$desc49, _formData$description49, _formData$description50, _formData$description51, _applicationData$desc50, _applicationData$desc51, _formData$description52, _formData$description53, _formData$description54, _applicationData$desc52, _formData$description55, _formData$description56, _formData$description57, _applicationData$desc53, _applicationData$desc54, _applicationData$desc55, _formData$description58, _formData$description59, _formData$description60, _applicationData$desc56, _formData$description61, _formData$description62, _formData$description63, _applicationData$desc57, _formData$description64, _formData$description65, _formData$description66, _formData$description67, _formData$description68, _formData$description69, _formData$description70, _formData$description71, _formData$description72, _applicationData$desc58, _formData$description73, _formData$description74, _formData$description75, _applicationData$desc59, _formData$description76, _formData$description77, _formData$description78, _applicationData$desc60;
  const approvedLayout = (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.schemeType) === "Scheme" ? true : false;
  const defaultValues = {
    ...formData,
    approvedLayout: approvedLayout ? "Yes" : "No"
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const approveLayout = watch("approvedLayout");
  console.log("applicationData", applicationData, pFarList, formData);
  const maxRoadWidth = Math.max(...((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc2 = applicationData.descriptionOfLand) === null || _applicationData$desc2 === void 0 ? void 0 : (_applicationData$desc3 = _applicationData$desc2.roadWidths) === null || _applicationData$desc3 === void 0 ? void 0 : _applicationData$desc3.map(item => item === null || item === void 0 ? void 0 : item.value)) || []));
  const maxApproachWidth = Math.max(...((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc4 = applicationData.descriptionOfLand) === null || _applicationData$desc4 === void 0 ? void 0 : (_applicationData$desc5 = _applicationData$desc4.approachRoadWidths) === null || _applicationData$desc5 === void 0 ? void 0 : _applicationData$desc5.map(item => item === null || item === void 0 ? void 0 : item.value)) || []));
  console.log("maxRoadWidth", maxRoadWidth, maxApproachWidth);
  const checkFAR = (landUse, landSubUse, masterData, isSchemeType) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$P, _masterData$filter$$P2;
    const result = isSchemeType ? false : masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => (item === null || item === void 0 ? void 0 : item.category) === landUse)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$P = _masterData$filter$.ProposedActivity) === null || _masterData$filter$$P === void 0 ? void 0 : (_masterData$filter$$P2 = _masterData$filter$$P.filter(item => (item === null || item === void 0 ? void 0 : item.BasicFAR) == "")) === null || _masterData$filter$$P2 === void 0 ? void 0 : _masterData$filter$$P2.filter(item => (item === null || item === void 0 ? void 0 : item.ActivityProposed) === landSubUse);
    console.log("resultBasicFAR", result);
    if (isSchemeType) {
      return false;
    }
    return !((result === null || result === void 0 ? void 0 : result.length) === 0);
  };
  const isBasicFAR = checkFAR(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc6 = applicationData.descriptionOfLand) === null || _applicationData$desc6 === void 0 ? void 0 : _applicationData$desc6.landUsesType, applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc7 = applicationData.descriptionOfLand) === null || _applicationData$desc7 === void 0 ? void 0 : _applicationData$desc7.subLandUseAsPerLayout, pFarList, approvedLayout);
  console.log("isBasicFAR", isBasicFAR);
  useEffect(() => {
    var _formData$description, _formData$description2, _applicationData$desc8, _applicationData$desc9, _applicationData$desc10, _applicationData$desc11, _applicationData$desc12, _applicationData$desc13, _applicationData$desc14, _applicationData$desc15, _applicationData$desc16, _applicationData$desc17, _applicationData$desc18, _applicationData$desc19, _applicationData$desc20, _applicationData$desc21, _applicationData$desc22, _applicationData$desc23, _applicationData$desc24, _applicationData$desc25, _applicationData$desc26, _applicationData$desc27;
    const newProperties = [{
      ...(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0]),
      landArea: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc8 = applicationData.descriptionOfLand) === null || _applicationData$desc8 === void 0 ? void 0 : _applicationData$desc8.landArea,
      propertyNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc9 = applicationData.descriptionOfLand) === null || _applicationData$desc9 === void 0 ? void 0 : _applicationData$desc9.plotNo,
      khatauniNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc10 = applicationData.descriptionOfLand) === null || _applicationData$desc10 === void 0 ? void 0 : _applicationData$desc10.khatauniNo,
      plotNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc11 = applicationData.descriptionOfLand) === null || _applicationData$desc11 === void 0 ? void 0 : _applicationData$desc11.plotNo,
      khataNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc12 = applicationData.descriptionOfLand) === null || _applicationData$desc12 === void 0 ? void 0 : _applicationData$desc12.khataNo,
      plotWidth: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc13 = applicationData.descriptionOfLand) === null || _applicationData$desc13 === void 0 ? void 0 : _applicationData$desc13.landWidth,
      roadWidth: maxRoadWidth,
      approachRoadWidth: maxApproachWidth,
      khasraNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc14 = applicationData.descriptionOfLand) === null || _applicationData$desc14 === void 0 ? void 0 : (_applicationData$desc15 = _applicationData$desc14.khasraWithArea) === null || _applicationData$desc15 === void 0 ? void 0 : (_applicationData$desc16 = _applicationData$desc15[0]) === null || _applicationData$desc16 === void 0 ? void 0 : _applicationData$desc16.khasraNo,
      landUseAsPerLayout: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc17 = applicationData.descriptionOfLand) === null || _applicationData$desc17 === void 0 ? void 0 : _applicationData$desc17.landUsesType,
      subLandUseAsPerLayout: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc18 = applicationData.descriptionOfLand) === null || _applicationData$desc18 === void 0 ? void 0 : _applicationData$desc18.subLandUseAsPerLayout,
      schemeName: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc19 = applicationData.descriptionOfLand) === null || _applicationData$desc19 === void 0 ? void 0 : _applicationData$desc19.schemeName,
      plotNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc20 = applicationData.descriptionOfLand) === null || _applicationData$desc20 === void 0 ? void 0 : _applicationData$desc20.plotNo,
      sectorNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc21 = applicationData.descriptionOfLand) === null || _applicationData$desc21 === void 0 ? void 0 : _applicationData$desc21.sectorNo,
      landLength: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc22 = applicationData.descriptionOfLand) === null || _applicationData$desc22 === void 0 ? void 0 : _applicationData$desc22.landLength,
      landAddress: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc23 = applicationData.descriptionOfLand) === null || _applicationData$desc23 === void 0 ? void 0 : _applicationData$desc23.landAddress,
      landMark: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc24 = applicationData.descriptionOfLand) === null || _applicationData$desc24 === void 0 ? void 0 : _applicationData$desc24.landMark,
      selectLandUse: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc25 = applicationData.descriptionOfLand) === null || _applicationData$desc25 === void 0 ? void 0 : _applicationData$desc25.selectLandUse,
      proposedActivity: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc26 = applicationData.descriptionOfLand) === null || _applicationData$desc26 === void 0 ? void 0 : _applicationData$desc26.proposedActivity
    }];
    reset({
      ...formData,
      approvedLayout: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc27 = applicationData.descriptionOfLand) === null || _applicationData$desc27 === void 0 ? void 0 : _applicationData$desc27.schemeType,
      descriptionOfLand: {
        ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
        properties: [{
          ...newProperties[0]
        }]
      }
    });
  }, [approveLayout]);
  const onSubmit = data => {
    console.log("fromSub2", data);
    handleSubTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Layout Details"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Scheme Type"),
    name: "approvedLayout",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : formData.approvedLayout) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc28 = applicationData.descriptionOfLand) === null || _applicationData$desc28 === void 0 ? void 0 : _applicationData$desc28.schemeType) || isEmployee || isApproved
  })), approveLayout === "Scheme" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Scheme Name",
    placeholder: "Enter Scheme Name",
    name: `descriptionOfLand.properties[0].schemeName`,
    type: "textInput",
    maxLength: 30,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4.properties) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5[0]) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.schemeName) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc29 = applicationData.descriptionOfLand) === null || _applicationData$desc29 === void 0 ? void 0 : _applicationData$desc29.schemeName) || isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null)), approveLayout === "Scheme" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot No.",
    placeholder: "Enter Plot Number",
    maxLength: 10,
    mandatory: approveLayout === "Scheme",
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    name: "descriptionOfLand.properties[0].plotNo",
    type: "number",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : (_formData$description8 = _formData$description7.properties) === null || _formData$description8 === void 0 ? void 0 : (_formData$description9 = _formData$description8[0]) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.plotNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc30 = applicationData.descriptionOfLand) === null || _applicationData$desc30 === void 0 ? void 0 : _applicationData$desc30.plotNo) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Sector No.",
    control: control,
    placeholder: "Enter Sector Number",
    name: "descriptionOfLand.properties[0].sectorNo",
    type: "number",
    maxLength: 10,
    mandatory: approveLayout === "Scheme",
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : (_formData$description11 = _formData$description10.properties) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11[0]) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.sectorNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc31 = applicationData.descriptionOfLand) === null || _applicationData$desc31 === void 0 ? void 0 : _applicationData$desc31.sectorNo) || isEmployee || isApproved,
    isRequired: approveLayout === "Scheme"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Use as per Approved Layout Plan"),
    control: control,
    placeholder: t("Enter Land Use Details"),
    name: "descriptionOfLand.properties[0].landUseAsPerLayout",
    type: "selectInput",
    data: farLandUseTypes,
    mandatory: true,
    maxLength: 150,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13.properties) === null || _formData$description14 === void 0 ? void 0 : (_formData$description15 = _formData$description14[0]) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.landUseAsPerLayout) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc32 = applicationData.descriptionOfLand) === null || _applicationData$desc32 === void 0 ? void 0 : _applicationData$desc32.landUsesType) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Sub Use as per Layout"),
    control: control,
    placeholder: t("LABEL_SELECT_LAND_SUB_USE_TYPE"),
    name: "descriptionOfLand.properties[0].subLandUseAsPerLayout",
    type: "selectInput",
    data: landSubUseTypes,
    mandatory: true,
    maxLength: 150,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : (_formData$description17 = _formData$description16.properties) === null || _formData$description17 === void 0 ? void 0 : (_formData$description18 = _formData$description17[0]) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.subLandUseAsPerLayout) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc33 = applicationData.descriptionOfLand) === null || _applicationData$desc33 === void 0 ? void 0 : _applicationData$desc33.subLandUseAsPerLayout) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc34 = applicationData.descriptionOfLand) === null || _applicationData$desc34 === void 0 ? void 0 : (_applicationData$desc35 = _applicationData$desc34.khasraWithArea) === null || _applicationData$desc35 === void 0 ? void 0 : (_applicationData$desc36 = _applicationData$desc35[0]) === null || _applicationData$desc36 === void 0 ? void 0 : _applicationData$desc36.khasraNo) && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_KHASRA_NO"),
    placeholder: t("LABEL_ENTER_KHASRA_NO"),
    name: "descriptionOfLand.properties[0].khasraNo",
    type: "textInput",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : (_formData$description20 = _formData$description19.properties) === null || _formData$description20 === void 0 ? void 0 : (_formData$description21 = _formData$description20[0]) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.khasraNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc37 = applicationData.descriptionOfLand) === null || _applicationData$desc37 === void 0 ? void 0 : (_applicationData$desc38 = _applicationData$desc37.khasraWithArea) === null || _applicationData$desc38 === void 0 ? void 0 : (_applicationData$desc39 = _applicationData$desc38[0]) === null || _applicationData$desc39 === void 0 ? void 0 : _applicationData$desc39.khasraNo) || isEmployee || isApproved
  })), (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc40 = applicationData.descriptionOfLand) === null || _applicationData$desc40 === void 0 ? void 0 : _applicationData$desc40.khataNo) && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_KHATA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHATA_NO"),
    name: "descriptionOfLand.properties[0].khataNo",
    type: "textInput",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : (_formData$description23 = _formData$description22.properties) === null || _formData$description23 === void 0 ? void 0 : (_formData$description24 = _formData$description23[0]) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.khataNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc41 = applicationData.descriptionOfLand) === null || _applicationData$desc41 === void 0 ? void 0 : _applicationData$desc41.khataNo) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot Area (in Sq. M)",
    placeholder: "Enter Plot Area",
    name: "descriptionOfLand.properties[0].landArea",
    type: "number",
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : (_formData$description26 = _formData$description25.properties) === null || _formData$description26 === void 0 ? void 0 : (_formData$description27 = _formData$description26[0]) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.landArea) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc42 = applicationData.descriptionOfLand) === null || _applicationData$desc42 === void 0 ? void 0 : _applicationData$desc42.landArea) || isEmployee || isApproved,
    isRequired: true,
    maxLength: 6
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Existing Road Width",
    placeholder: "Enter Road Width",
    name: `descriptionOfLand.properties[0].roadWidth`,
    type: "number",
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 2,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : (_formData$description29 = _formData$description28.properties) === null || _formData$description29 === void 0 ? void 0 : (_formData$description30 = _formData$description29[0]) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.roadWidth) || Boolean(maxRoadWidth) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Approach Road Width (as per the actual plan)",
    placeholder: "Enter Road Width",
    name: `descriptionOfLand.properties[0].approachRoadWidth`,
    type: "number",
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 2,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : (_formData$description32 = _formData$description31.properties) === null || _formData$description32 === void 0 ? void 0 : (_formData$description33 = _formData$description32[0]) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.approachRoadWidth) || Boolean(maxApproachWidth) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Near by Landmark",
    control: control,
    placeholder: "Enter Near by Landmark",
    name: "descriptionOfLand.properties[0].landMark",
    type: "textInput",
    mandatory: true,
    required: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : (_formData$description35 = _formData$description34.properties) === null || _formData$description35 === void 0 ? void 0 : (_formData$description36 = _formData$description35[0]) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.landMark) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc43 = applicationData.descriptionOfLand) === null || _applicationData$desc43 === void 0 ? void 0 : _applicationData$desc43.landMark) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    name: "descriptionOfLand.properties[0].landAddress",
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : (_formData$description38 = _formData$description37.properties) === null || _formData$description38 === void 0 ? void 0 : (_formData$description39 = _formData$description38[0]) === null || _formData$description39 === void 0 ? void 0 : _formData$description39.landAddress) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc44 = applicationData.descriptionOfLand) === null || _applicationData$desc44 === void 0 ? void 0 : _applicationData$desc44.landAddress) || isEmployee || isApproved
  })))), approveLayout != "Scheme" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc45 = applicationData.descriptionOfLand) === null || _applicationData$desc45 === void 0 ? void 0 : _applicationData$desc45.plotNo) && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot/House No.",
    placeholder: "Enter Plot Number",
    maxLength: 10,
    mandatory: approveLayout === "Scheme",
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    name: "descriptionOfLand.properties[0].plotNo",
    type: "number",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description40 = formData.descriptionOfLand) === null || _formData$description40 === void 0 ? void 0 : (_formData$description41 = _formData$description40.properties) === null || _formData$description41 === void 0 ? void 0 : (_formData$description42 = _formData$description41[0]) === null || _formData$description42 === void 0 ? void 0 : _formData$description42.plotNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc46 = applicationData.descriptionOfLand) === null || _applicationData$desc46 === void 0 ? void 0 : _applicationData$desc46.plotNo) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Use as per Master Plan"),
    control: control,
    placeholder: t("Enter Land Use Details"),
    name: "descriptionOfLand.properties[0].landUseAsPerLayout",
    type: "selectInput",
    data: farLandUseTypes,
    mandatory: true,
    maxLength: 150,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description43 = formData.descriptionOfLand) === null || _formData$description43 === void 0 ? void 0 : (_formData$description44 = _formData$description43.properties) === null || _formData$description44 === void 0 ? void 0 : (_formData$description45 = _formData$description44[0]) === null || _formData$description45 === void 0 ? void 0 : _formData$description45.landUseAsPerLayout) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc47 = applicationData.descriptionOfLand) === null || _applicationData$desc47 === void 0 ? void 0 : _applicationData$desc47.landUsesType) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Proposed Activity"),
    control: control,
    placeholder: t("LABEL_SELECT_LAND_SUB_USE_TYPE"),
    name: "descriptionOfLand.properties[0].subLandUseAsPerLayout",
    type: "selectInput",
    data: landSubUseTypes,
    mandatory: true,
    maxLength: 150,
    multiLine: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description46 = formData.descriptionOfLand) === null || _formData$description46 === void 0 ? void 0 : (_formData$description47 = _formData$description46.properties) === null || _formData$description47 === void 0 ? void 0 : (_formData$description48 = _formData$description47[0]) === null || _formData$description48 === void 0 ? void 0 : _formData$description48.subLandUseAsPerLayout) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc48 = applicationData.descriptionOfLand) === null || _applicationData$desc48 === void 0 ? void 0 : _applicationData$desc48.subLandUseAsPerLayout) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, applicationData !== null && applicationData !== void 0 && (_applicationData$desc49 = applicationData.descriptionOfLand) !== null && _applicationData$desc49 !== void 0 && _applicationData$desc49.selectLandUse ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Permissibility of Activities",
    inputLabel: "Select activities.",
    placeholder: "Select activities.",
    name: "descriptionOfLand.properties[0].selectLandUse",
    type: "selectInput",
    data: landUseList,
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description49 = formData.descriptionOfLand) === null || _formData$description49 === void 0 ? void 0 : (_formData$description50 = _formData$description49.properties) === null || _formData$description50 === void 0 ? void 0 : (_formData$description51 = _formData$description50[0]) === null || _formData$description51 === void 0 ? void 0 : _formData$description51.selectLandUse) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc50 = applicationData.descriptionOfLand) === null || _applicationData$desc50 === void 0 ? void 0 : _applicationData$desc50.selectLandUse) || isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null), applicationData !== null && applicationData !== void 0 && (_applicationData$desc51 = applicationData.descriptionOfLand) !== null && _applicationData$desc51 !== void 0 && _applicationData$desc51.proposedActivity ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Proposed Activity as per Zoning Regulation",
    placeholder: "Enter activity",
    name: `descriptionOfLand.properties[0].proposedActivity`,
    type: "textInput",
    maxLength: 30,
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description52 = formData.descriptionOfLand) === null || _formData$description52 === void 0 ? void 0 : (_formData$description53 = _formData$description52.properties) === null || _formData$description53 === void 0 ? void 0 : (_formData$description54 = _formData$description53[0]) === null || _formData$description54 === void 0 ? void 0 : _formData$description54.proposedActivity) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc52 = applicationData.descriptionOfLand) === null || _applicationData$desc52 === void 0 ? void 0 : _applicationData$desc52.proposedActivity) || isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_KHASRA_NO"),
    placeholder: t("LABEL_ENTER_KHASRA_NO"),
    name: "descriptionOfLand.properties[0].khasraNo",
    type: "textInput",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description55 = formData.descriptionOfLand) === null || _formData$description55 === void 0 ? void 0 : (_formData$description56 = _formData$description55.properties) === null || _formData$description56 === void 0 ? void 0 : (_formData$description57 = _formData$description56[0]) === null || _formData$description57 === void 0 ? void 0 : _formData$description57.khasraNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc53 = applicationData.descriptionOfLand) === null || _applicationData$desc53 === void 0 ? void 0 : (_applicationData$desc54 = _applicationData$desc53.khasraWithArea) === null || _applicationData$desc54 === void 0 ? void 0 : (_applicationData$desc55 = _applicationData$desc54[0]) === null || _applicationData$desc55 === void 0 ? void 0 : _applicationData$desc55.khasraNo) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_KHATA_NO"),
    control: control,
    placeholder: t("LABEL_ENTER_KHATA_NO"),
    name: "descriptionOfLand.properties[0].khataNo",
    type: "textInput",
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description58 = formData.descriptionOfLand) === null || _formData$description58 === void 0 ? void 0 : (_formData$description59 = _formData$description58.properties) === null || _formData$description59 === void 0 ? void 0 : (_formData$description60 = _formData$description59[0]) === null || _formData$description60 === void 0 ? void 0 : _formData$description60.khataNo) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc56 = applicationData.descriptionOfLand) === null || _applicationData$desc56 === void 0 ? void 0 : _applicationData$desc56.khataNo) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Land Area (in Sq. M)",
    placeholder: "Enter Land Area",
    name: "descriptionOfLand.properties[0].landArea",
    type: "number",
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description61 = formData.descriptionOfLand) === null || _formData$description61 === void 0 ? void 0 : (_formData$description62 = _formData$description61.properties) === null || _formData$description62 === void 0 ? void 0 : (_formData$description63 = _formData$description62[0]) === null || _formData$description63 === void 0 ? void 0 : _formData$description63.landArea) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc57 = applicationData.descriptionOfLand) === null || _applicationData$desc57 === void 0 ? void 0 : _applicationData$desc57.landArea) || isEmployee || isApproved,
    isRequired: true,
    maxLength: 6
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Existing Road Width",
    placeholder: "Enter Road Width",
    name: `descriptionOfLand.properties[0].roadWidth`,
    type: "number",
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 2,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description64 = formData.descriptionOfLand) === null || _formData$description64 === void 0 ? void 0 : (_formData$description65 = _formData$description64.properties) === null || _formData$description65 === void 0 ? void 0 : (_formData$description66 = _formData$description65[0]) === null || _formData$description66 === void 0 ? void 0 : _formData$description66.roadWidth) || Boolean(maxRoadWidth) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Approach Road Width (as per the actual plan)",
    placeholder: "Enter Road Width",
    name: `descriptionOfLand.properties[0].approachRoadWidth`,
    type: "number",
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 2,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description67 = formData.descriptionOfLand) === null || _formData$description67 === void 0 ? void 0 : (_formData$description68 = _formData$description67.properties) === null || _formData$description68 === void 0 ? void 0 : (_formData$description69 = _formData$description68[0]) === null || _formData$description69 === void 0 ? void 0 : _formData$description69.approachRoadWidth) || Boolean(maxApproachWidth) || isEmployee || isApproved
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Near by Landmark",
    control: control,
    placeholder: "Enter Near by Landmark",
    name: "descriptionOfLand.properties[0].landMark",
    type: "textInput",
    mandatory: true,
    required: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description70 = formData.descriptionOfLand) === null || _formData$description70 === void 0 ? void 0 : (_formData$description71 = _formData$description70.properties) === null || _formData$description71 === void 0 ? void 0 : (_formData$description72 = _formData$description71[0]) === null || _formData$description72 === void 0 ? void 0 : _formData$description72.landMark) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc58 = applicationData.descriptionOfLand) === null || _applicationData$desc58 === void 0 ? void 0 : _applicationData$desc58.landMark) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    name: "descriptionOfLand.properties[0].landAddress",
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description73 = formData.descriptionOfLand) === null || _formData$description73 === void 0 ? void 0 : (_formData$description74 = _formData$description73.properties) === null || _formData$description74 === void 0 ? void 0 : (_formData$description75 = _formData$description74[0]) === null || _formData$description75 === void 0 ? void 0 : _formData$description75.landAddress) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc59 = applicationData.descriptionOfLand) === null || _applicationData$desc59 === void 0 ? void 0 : _applicationData$desc59.landAddress) || isEmployee || isApproved
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, approveLayout != "Scheme" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Development Zone"),
    placeholder: t("Select development zone"),
    name: "descriptionOfLand.properties[0].constructionType",
    type: "selectInput",
    data: constructionType,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Development Zone"),
    placeholder: t("Select development zone"),
    name: "descriptionOfLand.properties[0].constructionType",
    type: "selectInput",
    data: constructionType,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null))), !isBasicFAR && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basic FAR"),
    control: control,
    placeholder: t("Enter Basic FAR"),
    name: "descriptionOfLand.properties[0].baseFAR",
    type: "decimal",
    maxLength: 10,
    mandatory: true,
    required: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$description76 = formData.descriptionOfLand) === null || _formData$description76 === void 0 ? void 0 : (_formData$description77 = _formData$description76.properties) === null || _formData$description77 === void 0 ? void 0 : (_formData$description78 = _formData$description77[0]) === null || _formData$description78 === void 0 ? void 0 : _formData$description78.plotWidth) || Boolean(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc60 = applicationData.descriptionOfLand) === null || _applicationData$desc60 === void 0 ? void 0 : _applicationData$desc60.landWidth) || isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const SubStep2$6 = ({
  formData,
  handleSubTabChange,
  t,
  applicationFlow,
  officesList,
  isAssignedLTP,
  applicationData,
  approvedLayout,
  isEmployee,
  isApproved
}) => {
  var _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _applicationData$land3, _applicationData$land4, _applicationData$land5, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _applicationData$land6, _applicationData$land7, _applicationData$land8, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _applicationData$land9, _applicationData$land10, _applicationData$land11, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _applicationData$land12, _applicationData$land13, _applicationData$land14, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _applicationData$land15, _applicationData$land16, _applicationData$land17, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _applicationData$land18, _applicationData$land19, _applicationData$land20, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _applicationData$land21, _applicationData$land22, _applicationData$land23, _applicationData$land24, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _applicationData$land25, _applicationData$land26, _applicationData$land27, _applicationData$land28, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _applicationData$land29, _applicationData$land30, _applicationData$land31, _applicationData$land32, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _applicationData$land33, _applicationData$land34, _applicationData$land35, _applicationData$land36;
  const defaultValues = {
    ...formData
  };
  console.log("officesList", officesList, formData, applicationFlow);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    var _formData$description, _formData$description2, _applicationData$desc, _applicationData$desc2, _formData$landInfo, _formData$landInfo2, _applicationData$land, _applicationData$land2;
    const newProperties = [{
      ...(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0]),
      plotArea: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.landArea,
      propertyNo: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc2 = applicationData.descriptionOfLand) === null || _applicationData$desc2 === void 0 ? void 0 : _applicationData$desc2.plotNo
    }];
    reset({
      ...formData,
      approvedLayout: approvedLayout,
      landInfo: {
        address: {
          ...(formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.address),
          tenantId: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.tenantId
        },
        owners: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land = applicationData.landInfo) === null || _applicationData$land === void 0 ? void 0 : _applicationData$land.owners,
        tenantId: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land2 = applicationData.landInfo) === null || _applicationData$land2 === void 0 ? void 0 : _applicationData$land2.tenantId
      },
      descriptionOfLand: {
        properties: newProperties
      }
    });
    setValue("documents", applicationData === null || applicationData === void 0 ? void 0 : applicationData.documents);
  }, [applicationData]);
  const onSubmit = data => {
    console.log("logFromSub2", data);
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_DETAILS"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_NAME"),
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners[0].name",
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.name) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land3 = applicationData.landInfo) === null || _applicationData$land3 === void 0 ? void 0 : (_applicationData$land4 = _applicationData$land3.owners) === null || _applicationData$land4 === void 0 ? void 0 : (_applicationData$land5 = _applicationData$land4[0]) === null || _applicationData$land5 === void 0 ? void 0 : _applicationData$land5.name) || isEmployee || isApproved)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].fatherOrHusbandName",
    label: t("LABEL_FATHER_NAME"),
    placeholder: t("LABEL_ENTER_FATHER_NAME"),
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.fatherOrHusbandName) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land6 = applicationData.landInfo) === null || _applicationData$land6 === void 0 ? void 0 : (_applicationData$land7 = _applicationData$land6.owners) === null || _applicationData$land7 === void 0 ? void 0 : (_applicationData$land8 = _applicationData$land7[0]) === null || _applicationData$land8 === void 0 ? void 0 : _applicationData$land8.fatherOrHusbandName) || isEmployee || isApproved)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Gender"),
    placeholder: t("Gender"),
    name: "landInfo.owners[0].gender",
    type: "selectInput",
    data: genderData,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.gender) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land9 = applicationData.landInfo) === null || _applicationData$land9 === void 0 ? void 0 : (_applicationData$land10 = _applicationData$land9.owners) === null || _applicationData$land10 === void 0 ? void 0 : (_applicationData$land11 = _applicationData$land10[0]) === null || _applicationData$land11 === void 0 ? void 0 : _applicationData$land11.gender) || isEmployee || isApproved)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].mobileNumber",
    label: t("LABEL_MOBILE_NUMBER"),
    placeholder: t("LABEL_ENTER_MOBILE_NUMBER"),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.mobileNumber) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land12 = applicationData.landInfo) === null || _applicationData$land12 === void 0 ? void 0 : (_applicationData$land13 = _applicationData$land12.owners) === null || _applicationData$land13 === void 0 ? void 0 : (_applicationData$land14 = _applicationData$land13[0]) === null || _applicationData$land14 === void 0 ? void 0 : _applicationData$land14.mobileNumber) || isEmployee || isApproved)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].emailId",
    label: t("LABEL_EMAIL_ID"),
    placeholder: t("LABEL_ENTER_EMAIL_ID"),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : _formData$landInfo7$o2.emailId) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land15 = applicationData.landInfo) === null || _applicationData$land15 === void 0 ? void 0 : (_applicationData$land16 = _applicationData$land15.owners) === null || _applicationData$land16 === void 0 ? void 0 : (_applicationData$land17 = _applicationData$land16[0]) === null || _applicationData$land17 === void 0 ? void 0 : _applicationData$land17.emailId) || isEmployee || isApproved)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].aadhaarNumber",
    label: t("LABEL_AADHAR_CARD"),
    placeholder: t("LABEL_ENTER_AADHAR_CARD"),
    type: "textInput",
    mandatory: true,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12,
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : _formData$landInfo8$o2.aadhaarNumber) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land18 = applicationData.landInfo) === null || _applicationData$land18 === void 0 ? void 0 : (_applicationData$land19 = _applicationData$land18.owners) === null || _applicationData$land19 === void 0 ? void 0 : (_applicationData$land20 = _applicationData$land19[0]) === null || _applicationData$land20 === void 0 ? void 0 : _applicationData$land20.aadhaarNumber) || isEmployee || isApproved)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].correspondenceAddress.town",
    label: t("LABEL_CITY"),
    placeholder: t("LABEL_ENTER_CITY"),
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land21 = applicationData.landInfo) === null || _applicationData$land21 === void 0 ? void 0 : (_applicationData$land22 = _applicationData$land21.owners) === null || _applicationData$land22 === void 0 ? void 0 : (_applicationData$land23 = _applicationData$land22[0]) === null || _applicationData$land23 === void 0 ? void 0 : (_applicationData$land24 = _applicationData$land23.correspondenceAddress) === null || _applicationData$land24 === void 0 ? void 0 : _applicationData$land24.town) || isEmployee || isApproved)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].correspondenceAddress.address",
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    type: "textInput",
    mandatory: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.address) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land25 = applicationData.landInfo) === null || _applicationData$land25 === void 0 ? void 0 : (_applicationData$land26 = _applicationData$land25.owners) === null || _applicationData$land26 === void 0 ? void 0 : (_applicationData$land27 = _applicationData$land26[0]) === null || _applicationData$land27 === void 0 ? void 0 : (_applicationData$land28 = _applicationData$land27.correspondenceAddress) === null || _applicationData$land28 === void 0 ? void 0 : _applicationData$land28.address) || isEmployee || isApproved)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners[0].correspondenceAddress.state",
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.state) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land29 = applicationData.landInfo) === null || _applicationData$land29 === void 0 ? void 0 : (_applicationData$land30 = _applicationData$land29.owners) === null || _applicationData$land30 === void 0 ? void 0 : (_applicationData$land31 = _applicationData$land30[0]) === null || _applicationData$land31 === void 0 ? void 0 : (_applicationData$land32 = _applicationData$land31.correspondenceAddress) === null || _applicationData$land32 === void 0 ? void 0 : _applicationData$land32.state) || isEmployee || isApproved)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    name: "landInfo.owners[0].correspondenceAddress.pinno",
    label: t("LABEL_PIN_CODE"),
    placeholder: t("LABEL_ENTER_PIN_CODE"),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pin Code"
      }
    },
    maxLength: 6,
    isApproved: true,
    disabled: Boolean(isAssignedLTP) || Boolean(formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno) || Boolean((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land33 = applicationData.landInfo) === null || _applicationData$land33 === void 0 ? void 0 : (_applicationData$land34 = _applicationData$land33.owners) === null || _applicationData$land34 === void 0 ? void 0 : (_applicationData$land35 = _applicationData$land34[0]) === null || _applicationData$land35 === void 0 ? void 0 : (_applicationData$land36 = _applicationData$land35.correspondenceAddress) === null || _applicationData$land36 === void 0 ? void 0 : _applicationData$land36.pinno) || isEmployee || isApproved)
  }))), !isAssignedLTP && /*#__PURE__*/React__default.createElement(Row$1, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const SubStep4$7 = ({
  formData,
  handleTabChange,
  t,
  isAssignedLTP,
  applicationData,
  handleSubTabChange,
  isEmployee,
  isApproved
}) => {
  var _formData$taxHeadEsti, _formData$taxHeadEsti2, _applicationData$desc, _applicationData$desc2, _formData$description, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6;
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    watch,
    setValue
  } = useForm({
    defaultValues
  });
  const [permissibleFAR, setPermissibleFAR] = useState(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.permissibleFAR);
  const takenFAR = watch("descriptionOfLand.properties[0].takenFAR");
  const percentageFAR = watch("descriptionOfLand.properties[0].percentRequiredFAR");
  const plotArea = applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.landArea;
  const takenFarValue = watch("descriptionOfLand.properties[0].purchasableFAR");
  console.log("Number(plotArea * (percentageFAR).toFixed(2)", Number(plotArea * percentageFAR).toFixed(2), plotArea, percentageFAR, applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc2 = applicationData.descriptionOfLand) === null || _applicationData$desc2 === void 0 ? void 0 : _applicationData$desc2.landArea);
  const calculatePercentage = (developmentType, roadWidth) => {
    if (developmentType === "Built Up") {
      return 20;
    } else {
      if (Number(roadWidth) > 18 && Number(roadWidth) < 24) {
        return 33;
      } else if (Number(roadWidth) >= 24) {
        return 50;
      }
    }
  };
  console.log("dataFromLandUSe", applicationData, formData);
  const percentPermissibleFAR = calculatePercentage(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : (_formData$description3 = _formData$description2[0]) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.constructionType, formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : (_formData$description5 = _formData$description4.properties) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5[0]) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.roadWidth);
  const LandDetailsTable = () => {
    var _formData$taxHeadEsti3, _formData$description7, _formData$description8, _applicationData$desc3, _applicationData$desc4;
    const taxData = (formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3[0]) || {};
    const landProps = (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : (_formData$description8 = _formData$description7.properties) === null || _formData$description8 === void 0 ? void 0 : _formData$description8[0]) || {};
    const printRef = useRef();
    const rows = [{
      label: "Building Category of Plot",
      value: (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc3 = applicationData.descriptionOfLand) === null || _applicationData$desc3 === void 0 ? void 0 : _applicationData$desc3.landUsesType) || "-"
    }, {
      label: "Sub-category of Plot",
      value: (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc4 = applicationData.descriptionOfLand) === null || _applicationData$desc4 === void 0 ? void 0 : _applicationData$desc4.subLandUseAsPerLayout) || "-"
    }, {
      label: "Development Zone",
      value: (landProps === null || landProps === void 0 ? void 0 : landProps.constructionType) || "-"
    }, {
      label: "",
      value: ""
    }, {
      label: "Plot Area(Sqmt.)",
      value: (landProps === null || landProps === void 0 ? void 0 : landProps.landArea) || "-"
    }, {
      label: "Existing Road Width(Mt.)",
      value: (landProps === null || landProps === void 0 ? void 0 : landProps.roadWidth) || "-"
    }, {
      label: "Basic FAR(Factor)",
      value: (taxData === null || taxData === void 0 ? void 0 : taxData.basicFar) || "-"
    }, {
      label: "Basic FAR Area(Sqmt.)",
      value: (taxData === null || taxData === void 0 ? void 0 : taxData.totalBuiltUpArea) || "-"
    }, {
      label: "Permissible FAR(Factor)",
      value: `${(taxData === null || taxData === void 0 ? void 0 : taxData.basicFar) || "-"} * ${percentPermissibleFAR || "-"}% = ${(taxData === null || taxData === void 0 ? void 0 : taxData.permissibleFAR) || "-"}`
    }, {
      label: "Permissible FAR Area(Sqmt.)",
      value: (taxData === null || taxData === void 0 ? void 0 : taxData.permissibleFARArea) || "-"
    }, {
      label: "Total Permissible FAR(Factor)",
      value: (taxData === null || taxData === void 0 ? void 0 : taxData.totalPermissibleFar) || "-"
    }, {
      label: "Total Permissible FAR Area(Sqmt.)",
      value: (taxData === null || taxData === void 0 ? void 0 : taxData.totalPermissibleFARArea) || "-"
    }];
    return /*#__PURE__*/React__default.createElement("div", {
      className: "land-details-table-wrapper"
    }, /*#__PURE__*/React__default.createElement("h3", {
      className: "far-print-table-header"
    }, "FAR Details", /*#__PURE__*/React__default.createElement(ReactToPrint, {
      trigger: () => /*#__PURE__*/React__default.createElement("button", {
        type: "button"
      }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(PrintIcon, {
        sx: {
          fontSize: "13px"
        }
      })), "Print"),
      content: () => printRef.current
    })), /*#__PURE__*/React__default.createElement("div", {
      ref: printRef
    }, /*#__PURE__*/React__default.createElement("table", {
      className: "land-details-table"
    }, /*#__PURE__*/React__default.createElement("tbody", null, (() => {
      const pairedRows = [];
      for (let i = 0; i < rows.length; i += 2) {
        pairedRows.push( /*#__PURE__*/React__default.createElement("tr", {
          key: i
        }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, rows[i].label)), /*#__PURE__*/React__default.createElement("td", null, rows[i].value), rows[i + 1] ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, rows[i + 1].label)), /*#__PURE__*/React__default.createElement("td", null, rows[i + 1].value)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null))));
      }
      return pairedRows;
    })()))));
  };
  const handleAreaFar = type => {
    const far = getValues("descriptionOfLand.properties[0].percentRequiredFAR");
    const area = getValues("descriptionOfLand.properties[0].requiredAreaFAR");
    if (type === "far") {
      const calculatedArea = Math.floor(plotArea * Number(far || 0) * 100) / 100;
      console.log("calculatedArea", calculatedArea, plotArea, far);
      setValue("descriptionOfLand.properties[0].requiredAreaFAR", calculatedArea.toFixed(2));
    } else if (type === "area") {
      const calculatedFAR = Math.floor(Number(area) / plotArea * 100) / 100;
      console.log("calculatedFAR", calculatedFAR, plotArea, area);
      setValue("descriptionOfLand.properties[0].percentRequiredFAR", calculatedFAR.toFixed(2));
    }
  };
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  useEffect(() => {
    if (takenFarValue) {
      var _formData$taxHeadEsti4, _formData$taxHeadEsti5;
      setPermissibleFAR((Number(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti4 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : (_formData$taxHeadEsti5 = _formData$taxHeadEsti4[0]) === null || _formData$taxHeadEsti5 === void 0 ? void 0 : _formData$taxHeadEsti5.permissibleFAR) - Number(takenFarValue)).toFixed(2));
    }
  }, [takenFarValue]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(LandDetailsTable, null), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_FAR_DETAILS"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ALREADY_TAKEN_FAR"),
    name: "descriptionOfLand.properties[0].takenFAR",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    },
    disabled: isEmployee || isApproved || Boolean(isAssignedLTP),
    isApproved: true
  })), takenFAR === "Yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_TAKEN_PURCHASABLE_FAR"),
    placeholder: t("LABEL_ENTER_TAKEN_PURCHASABLE_FAR"),
    name: "descriptionOfLand.properties[0].purchasableFAR",
    type: "decimal",
    disabled: isEmployee || isApproved,
    isApproved: true
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onBlur: () => handleAreaFar("far")
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Required FAR"),
    placeholder: t("Enter required FAR"),
    name: "descriptionOfLand.properties[0].percentRequiredFAR",
    type: "decimal",
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 5,
    maxValue: permissibleFAR || "",
    disabled: isEmployee || isApproved || Boolean(isAssignedLTP),
    isApproved: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    onBlur: () => handleAreaFar("area")
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Required FAR Area (Sq. Meter)"),
    name: "descriptionOfLand.properties[0].requiredAreaFAR",
    type: "decimal",
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    mandatory: true,
    required: true,
    disabled: Boolean(isAssignedLTP) || isEmployee || isApproved
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const Checklist = ({
  formData,
  isUpdating,
  handleTabChange,
  t,
  Modal
}) => {
  var _formData$checklist, _formData$checklist2, _firstCheckList$parki, _firstCheckList$parki2, _firstCheckList$parki3, _firstCheckList$parki4, _firstCheckList$parki5, _firstCheckList$parki6;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const defaultValues = {
    ...formData,
    documents
  };
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = watch("checklist.firstCheckList.structuralSafety") === "Yes" ? ["proposalDocument", "parkingProposalDoc", "drawingFile", "structuralCertificate", "fireDepartmentCertificate"] : ["proposalDocument", "parkingProposalDoc", "drawingFile"];
    if (watch("checklist.firstCheckList.fireNocRequired") === "Yes") {
      requiredDocs.push("fireDepartmentCertificate");
    }
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    const {
      message,
      isChecklistValid
    } = validateChecklist(data);
    console.log("messageFromValidation", message, isChecklistValid);
    if (isValid && !isChecklistValid) {
      Modal("Invalid Request", `${message}`, "error");
      return;
    }
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const firstCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const secondCheckList = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const totalParkingRequired = watch("checklist.firstCheckList.totalParkingRequired");
  const totalParkingProposed = watch("checklist.firstCheckList.totalParkingProposed");
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    console.log("dataFromChecklist", data);
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist 1")), /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "table-checklist"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Field Name"), /*#__PURE__*/React__default.createElement("th", null, "User Input"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_SETBACK_POSITION")))), ["Front", "Rear", "SSB1", "SSB2"].map(position => {
    var _firstCheckList$setba;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: `${position}`
    }, /*#__PURE__*/React__default.createElement("td", null, `${position} (M)`, /*#__PURE__*/React__default.createElement("span", {
      className: "compulsoryField"
    }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      name: `checklist.firstCheckList.setbackPosition.${position.toLowerCase()}`,
      defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$setba = firstCheckList.setbackPosition) === null || _firstCheckList$setba === void 0 ? void 0 : _firstCheckList$setba[position.toLowerCase()]) || "",
      type: "number",
      hasLabel: false,
      mandatory: true,
      maxLength: 2,
      validation: {
        required: {
          value: true,
          message: "This field is required."
        }
      },
      control: control
    })));
  }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Proposed Building (m)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: "checklist.firstCheckList.buildingHeight",
    type: "number",
    hasLabel: false,
    mandatory: true,
    maxLength: 2,
    validation: {
      required: {
        value: true,
        message: "Please enter a height."
      }
    },
    control: control
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Proposal Document (PDF)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    name: "proposalDocument",
    validationMsg: "(pdf file only and Max file Size 10 MB)",
    label: "Proposal Document (PDF)",
    hasLabel: false,
    isMandatory: true,
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Drawing File (.dxf)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    name: "drawingFile",
    validationMsg: "(dxf file only and Max file Size 300 MB)",
    label: "Drawing File (.dxf)",
    hasLabel: false,
    isMandatory: true,
    required: true,
    tab: 5,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Structural Safety Certificate Applicable", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) || "",
    name: "checklist.firstCheckList.structuralSafety",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), watch("checklist.firstCheckList.structuralSafety") === "Yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Please attach Structural Safety Certificate", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    name: "structuralCertificate",
    validationMsg: "(pdf file only and Max file Size 10 MB)",
    label: "Structural Safety Certificate",
    isMandatory: true,
    required: true,
    tab: 1,
    hasLabel: false,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Is Fire NOC Required?", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.structuralSafety) || "",
    name: "checklist.firstCheckList.fireNocRequired",
    type: "radioButton",
    data: yesNoRadioList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), watch("checklist.firstCheckList.fireNocRequired") === "Yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Please attach Fire Department NOC", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    name: "fireDepartmentCertificate",
    validationMsg: "(pdf file only and Max file Size 10 MB)",
    label: "Fire Department NOC",
    isMandatory: true,
    required: true,
    tab: 1,
    hasLabel: false,
    maxFiles: 1,
    showError: showError
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, t("LABEL_PARKING_ARRANGEMENT")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of Parking Required", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: "checklist.firstCheckList.totalParkingRequired",
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.totalParkingRequired) || "",
    type: "number",
    hasLabel: false,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please enter number of parking required."
      }
    },
    control: control
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No of Parking Proposed (As per Map)", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: "checklist.firstCheckList.totalParkingProposed",
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : firstCheckList.totalParkingProposed) || "",
    type: "number",
    hasLabel: false,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please enter number of parking required."
      }
    },
    control: control
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Upload Proposed Parking Plan", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    name: "parkingProposalDoc",
    validationMsg: "(pdf file only and Max file Size 10 MB)",
    hasLabel: false,
    label: "Proposed Parking Plan",
    isMandatory: true,
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Parking Provision as per Proposed Plan"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of Cars in Basement", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "",
    name: "checklist.firstCheckList.parkingProvision.inBasement.cars",
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki = firstCheckList.parkingProvision) === null || _firstCheckList$parki === void 0 ? void 0 : (_firstCheckList$parki2 = _firstCheckList$parki.inBasement) === null || _firstCheckList$parki2 === void 0 ? void 0 : _firstCheckList$parki2.cars) || "",
    type: "number",
    maxLength: 6,
    validation: {
      required: {
        value: true,
        message: "This field is required."
      }
    },
    hasLabel: false,
    control: control
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of Cars in Open Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "",
    name: "checklist.firstCheckList.parkingProvision.openArea.cars",
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki3 = firstCheckList.parkingProvision) === null || _firstCheckList$parki3 === void 0 ? void 0 : (_firstCheckList$parki4 = _firstCheckList$parki3.openArea) === null || _firstCheckList$parki4 === void 0 ? void 0 : _firstCheckList$parki4.cars) || "",
    type: "number",
    maxLength: 6,
    validation: {
      required: {
        value: true,
        message: "This field is required."
      }
    },
    hasLabel: false,
    control: control
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "No. of Cars in Stilt Area", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "",
    name: "checklist.firstCheckList.parkingProvision.inStiltArea.cars",
    defaultValue: (firstCheckList === null || firstCheckList === void 0 ? void 0 : (_firstCheckList$parki5 = firstCheckList.parkingProvision) === null || _firstCheckList$parki5 === void 0 ? void 0 : (_firstCheckList$parki6 = _firstCheckList$parki5.inStiltArea) === null || _firstCheckList$parki6 === void 0 ? void 0 : _firstCheckList$parki6.cars) || "",
    type: "number",
    maxLength: 6,
    validation: {
      required: {
        value: true,
        message: "This field is required."
      }
    },
    hasLabel: false,
    control: control
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist 2")), /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    className: "table-checklist"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-header"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Field Names"), /*#__PURE__*/React__default.createElement("th", null, "User Inputs"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing road width in meters", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "number",
    name: "checklist.secondCheckList.existingRoadWidth",
    control: control,
    hasLabel: false,
    defaultValue: (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.existingRoadWidth) || "",
    validation: {
      required: {
        value: true,
        message: "Please enter the road width."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Sewerage & Drainage", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    name: "checklist.secondCheckList.publicSewerageOrSepticTank",
    type: "radioButton",
    data: publicSewerageOrSepticTank,
    defaultValue: secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.publicSewerageOrSepticTank,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Water Supply", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    name: "checklist.secondCheckList.waterSupplyArrangement",
    control: control,
    hasLabel: false,
    data: yesNoRadioList,
    defaultValue: (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.waterSupplyArrangement) || "",
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Mode of Solid waste disposal", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    data: solidWasteDisposal,
    name: "checklist.secondCheckList.solidWasteDisposal",
    control: control,
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Mode of Garbage collection", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    data: garbageCollection,
    name: "checklist.secondCheckList.garbageCollection",
    control: control,
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Power supply", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    name: "checklist.secondCheckList.powerSupply",
    control: control,
    hasLabel: false,
    data: yesNoRadioList,
    defaultValue: (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.powerSupply) || "",
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Rain Water Harvesting", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    name: "checklist.secondCheckList.rainWaterHarvesting",
    control: control,
    hasLabel: false,
    data: yesNoRadioList,
    defaultValue: (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.rainWaterHarvesting) || "",
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Provision of Solar Water Heating system", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("td", {
    className: "table-input"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "radioButton",
    name: "checklist.secondCheckList.solarWaterHeating",
    control: control,
    hasLabel: false,
    data: yesNoRadioList,
    defaultValue: (secondCheckList === null || secondCheckList === void 0 ? void 0 : secondCheckList.solarWaterHeating) || "",
    validation: {
      required: {
        value: true,
        message: "Please select any value."
      }
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  })))));
};

const Documents$1 = ({
  formData,
  handleTabChange,
  t,
  applicationData
}) => {
  var _applicationData$desc, _applicationData$desc2, _applicationData$desc4, _applicationData$desc5, _applicationData$desc6, _applicationData$desc7, _applicationData$desc8, _applicationData$desc9, _applicationData$desc10, _applicationData$desc11;
  console.log("isApprovedLayoutFromDocs", formData, applicationData);
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: [...((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.googleMapCoordinates) || [])],
      googleMapLocation: (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc2 = applicationData.descriptionOfLand) === null || _applicationData$desc2 === void 0 ? void 0 : _applicationData$desc2.googleMapLocation) || ""
    },
    documents: documents
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  console.log("formDataFromFARDOcs", documents);
  const [showError, setShowError] = useState(false);
  const validateFiles = () => {
    var _applicationData$desc3;
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc3 = applicationData.descriptionOfLand) === null || _applicationData$desc3 === void 0 ? void 0 : _applicationData$desc3.schemeType) === "Scheme" ? ["landOwnershipDoc", "completeDrawingFile", "kmlFile", "mutationDocument"] : ["landOwnershipDoc", "khataKhasraDocs", "kmlFile", "completeDrawingFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const onSubmit = data => {
    console.log("dataFromDocuments", data);
    handleTabChange(2, data);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_UPLOAD_DOCUMENTS"))), !((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc4 = applicationData.descriptionOfLand) === null || _applicationData$desc4 === void 0 ? void 0 : _applicationData$desc4.schemeType) === "Scheme") && /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    showError: showError,
    isMandatory: true,
    label: t("Land Ownership Document"),
    control: control,
    name: "landOwnershipDoc",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    showError: showError,
    isMandatory: true,
    label: t("LABEL_RELEVANT_DOCS_RELATED_TO_KHATA_KHASRA"),
    control: control,
    name: "khataKhasraDocs",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including Location/Site plan, Key plan, Site Superimposed on Master plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Site Superimposed on Sajra Plan",
    control: control,
    name: "sajraPlan",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    tab: 4,
    showError: showError,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement(Col, null))), (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc5 = applicationData.descriptionOfLand) === null || _applicationData$desc5 === void 0 ? void 0 : _applicationData$desc5.schemeType) === "Scheme" && /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including Location/Site plan, Key plan, Site Superimposed on Master plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    showError: showError,
    isMandatory: true,
    label: t("Land Ownership Document"),
    control: control,
    name: "landOwnershipDoc",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    showError: showError,
    isMandatory: true,
    label: t("Mutation Document"),
    control: control,
    name: "mutationDocument",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    tab: 4,
    maxFiles: 1
  })))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.googleMapCoordinates.[0].latitude",
    type: "decimal",
    mandatory: true,
    required: true,
    disabled: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc6 = applicationData.descriptionOfLand) === null || _applicationData$desc6 === void 0 ? void 0 : (_applicationData$desc7 = _applicationData$desc6.googleMapCoordinates) === null || _applicationData$desc7 === void 0 ? void 0 : (_applicationData$desc8 = _applicationData$desc7[0]) === null || _applicationData$desc8 === void 0 ? void 0 : _applicationData$desc8.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.googleMapCoordinates.[0].longitude",
    type: "decimal",
    mandatory: true,
    disabled: applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc9 = applicationData.descriptionOfLand) === null || _applicationData$desc9 === void 0 ? void 0 : (_applicationData$desc10 = _applicationData$desc9.googleMapCoordinates) === null || _applicationData$desc10 === void 0 ? void 0 : (_applicationData$desc11 = _applicationData$desc10[0]) === null || _applicationData$desc11 === void 0 ? void 0 : _applicationData$desc11.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      marginRight: "4px"
    }
  }))))));
};

const EditSummaryFAR = ({
  id,
  handleSubTabChange,
  handleTabChange
}) => {
  var _data$PurchasableFAR, _formData$landInfo, _pdfDetails$pdfFiles, _formData$landInfo2, _formData$landInfo2$o, _formData$description, _formData$description2, _formData$checklist, _formData$checklist2, _applicationDocs$filt, _applicationDocs$filt2, _applicationDocs$filt3, _applicationDocs$filt4, _applicationDocs$filt5, _applicationDocs$filt6, _applicationDocs$filt7, _applicationDocs$filt8, _checklist1$setbackPo, _checklist1$setbackPo2, _checklist1$setbackPo3, _checklist1$setbackPo4, _checklist1$setbackPo5, _checklist1$setbackPo6, _checklist1$setbackPo7, _checklist1$setbackPo8, _checklist1$setbackPo9, _checklist1$parkingPr, _checklist1$parkingPr2, _checklist1$parkingPr3, _checklist1$parkingPr4, _checklist1$parkingPr5, _checklist1$parkingPr6, _checklist1$parkingPr7, _checklist1$parkingPr8, _checklist1$parkingPr9, _checklist1$parkingPr10, _checklist1$parkingPr11, _checklist1$parkingPr12, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _formData$taxHeadEsti4;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [, applicationFlow] = useDepartmentSelector();
  const [, setIsPreviewLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const formType = "PURCHASABLE_FAR";
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    isEmployee,
    formType
  }, {
    formType
  });
  const formData = data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0];
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  console.log(data, "fromSummary", formData);
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const approvedLayout = (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) === "Yes";
  const normalizeDocuments = docs => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };
  const documents = normalizeDocuments(docs);
  let improvedDoc = [];
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  const {
    data: pdfDetails,
    isLoading: docsLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o[0];
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.properties) === null || _formData$description2 === void 0 ? void 0 : _formData$description2[0];
  console.log("description", descriptionOfLand);
  const checklist1 = formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.firstCheckList;
  const checklist2 = formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.secondCheckList;
  const documentSection = applicationDocs.filter(doc => ["completeDrawingFile", "kmlFile", "sajraPlan", "landOwnershipDoc", "sitePlan", "khataKhasraDocs", "allotmentLetter", "possessionLetter", "registry", "hpta", "paymentStatus", "proposalDocument", "parkingProposalDoc", "drawingFile", "structuralCertificate", "fireDepartmentCertificate", "mutationDocument"].includes(doc.documentType));
  console.log("documentSectionSummary", documentSection);
  const personalDocs = applicationDocs.filter(doc => ["signature", "applicantPhoto"].includes(doc.documentType));
  console.log("personalDOcs", personalDocs);
  const proposalDocument = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt = applicationDocs.filter(doc => ["proposalDocument"].includes(doc.documentType))) === null || _applicationDocs$filt === void 0 ? void 0 : (_applicationDocs$filt2 = _applicationDocs$filt[0]) === null || _applicationDocs$filt2 === void 0 ? void 0 : _applicationDocs$filt2.fileStoreId;
  const drawingFile = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt3 = applicationDocs.filter(doc => ["drawingFile"].includes(doc.documentType))) === null || _applicationDocs$filt3 === void 0 ? void 0 : (_applicationDocs$filt4 = _applicationDocs$filt3[0]) === null || _applicationDocs$filt4 === void 0 ? void 0 : _applicationDocs$filt4.fileStoreId;
  const structuralCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt5 = applicationDocs.filter(doc => ["structuralCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt5 === void 0 ? void 0 : (_applicationDocs$filt6 = _applicationDocs$filt5[0]) === null || _applicationDocs$filt6 === void 0 ? void 0 : _applicationDocs$filt6.fileStoreId;
  const fireDepartmentCertificate = applicationDocs === null || applicationDocs === void 0 ? void 0 : (_applicationDocs$filt7 = applicationDocs.filter(doc => ["fireDepartmentCertificate"].includes(doc.documentType))) === null || _applicationDocs$filt7 === void 0 ? void 0 : (_applicationDocs$filt8 = _applicationDocs$filt7[0]) === null || _applicationDocs$filt8 === void 0 ? void 0 : _applicationDocs$filt8.fileStoreId;
  if (!formData && docsLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("LABEL_APPLICANT_DETAILS"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(0);
      handleSubTabChange(1);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: "1 1 calc(50% - 10px)",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.name)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_FATHER_NAME"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.fatherOrHusbandName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_GENDER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.gender)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_MOBILE_NUMBER"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.mobileNumber)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_EMAIL_ID"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.emailId)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_AADHAR_CARD"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.aadhaarNumber)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROPERTY_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.propertyNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_CITY"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.town)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ADDRESS"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.address)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Scheme"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_STATE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.state)), (ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PIN_CODE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.correspondenceAddress.pinno)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Construction Type"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType))))), owners === null || owners === void 0 ? void 0 : owners.map((item, index) => (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: {
      flex: "1 1 calc(50% - 10px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      padding: "24px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px"
    }
  }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "180px",
      objectFit: "cover"
    },
    src: item.photo,
    alt: "image",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar, {
    style: {
      width: "200px",
      height: "80px"
    }
  }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginBottom: "10px",
      marginTop: "84px"
    }
  }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "200px",
      height: "80px"
    },
    src: item.signature,
    alt: "signature",
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
    style: {
      width: "70px",
      height: "25px"
    }
  }, item === null || item === void 0 ? void 0 : item.signature)))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Layout Details"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(0);
      handleSubTabChange(2);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_PART_OF_APPROVED_LAYOUT"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.approvedLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Scheme Name"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot No."))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) == "No" ? t("Land Use as per Master Plan") : t("Land Use as per Approved Layout Plan"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUseAsPerLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) == "No" ? t("Proposed Use as per Map") : t("Land Sub Use as per Layout"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Plot Depth"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Land Area (in Sq. M)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Existing Road Width"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidth)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Approach Road Width (as per the actual plan)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidth)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Near by Landmark"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Land Address"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Development Zone"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.constructionType)), !approvedLayout && /*#__PURE__*/React__default.createElement(Fragment$2, null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHASRA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATAUNI_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_KHATA_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PLOT_NO"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_LAND_WIDTH"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth)))))))))), /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("FAR Details"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(0);
      handleSubTabChange(3);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_ALREADY_TAKEN_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.takenFAR) == "Yes" && (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_TAKEN_PURCHASABLE_FAR"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.purchasableFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_PERCENTAGE"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.percentRequiredFAR)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_REQUIRED_FAR_AREA"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.requiredAreaFAR))))))))), documentSection.length > 0 && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents Section"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(1);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(documentSection),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }))))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo = checklist1.setbackPosition) === null || _checklist1$setbackPo === void 0 ? void 0 : _checklist1$setbackPo.front) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 1"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(2);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_SETBACK_POSITION")))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo2 = checklist1.setbackPosition) === null || _checklist1$setbackPo2 === void 0 ? void 0 : _checklist1$setbackPo2.front) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Front"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo3 = checklist1.setbackPosition) === null || _checklist1$setbackPo3 === void 0 ? void 0 : _checklist1$setbackPo3.front)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo4 = checklist1.setbackPosition) === null || _checklist1$setbackPo4 === void 0 ? void 0 : _checklist1$setbackPo4.rear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Rear"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo5 = checklist1.setbackPosition) === null || _checklist1$setbackPo5 === void 0 ? void 0 : _checklist1$setbackPo5.rear)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo6 = checklist1.setbackPosition) === null || _checklist1$setbackPo6 === void 0 ? void 0 : _checklist1$setbackPo6.left) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Left"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo7 = checklist1.setbackPosition) === null || _checklist1$setbackPo7 === void 0 ? void 0 : _checklist1$setbackPo7.left)), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo8 = checklist1.setbackPosition) === null || _checklist1$setbackPo8 === void 0 ? void 0 : _checklist1$setbackPo8.right) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Right"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$setbackPo9 = checklist1.setbackPosition) === null || _checklist1$setbackPo9 === void 0 ? void 0 : _checklist1$setbackPo9.right)), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Height of Proposed Building (m)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.buildingHeight)), proposalDocument && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposal Document (PDF)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)
  }))), drawingFile && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Proposal Document (PDF)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)
  }))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate Applicable"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.structuralSafety)), structuralCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Structural Safety Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)
  }))), fireDepartmentCertificate && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Fire Department Certificate"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      width: "100%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PARKING_ARRANGEMENT")))), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Total Parking Required"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingRequired)), (checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No of Parking Proposed (As per Map)"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist1 === null || checklist1 === void 0 ? void 0 : checklist1.totalParkingProposed)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    className: "table-subheader",
    style: {
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_PROVISION_PROPOSED_PLAN")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Basement"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr = checklist1.parkingProvision) === null || _checklist1$parkingPr === void 0 ? void 0 : (_checklist1$parkingPr2 = _checklist1$parkingPr.inBasement) === null || _checklist1$parkingPr2 === void 0 ? void 0 : _checklist1$parkingPr2.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr3 = checklist1.parkingProvision) === null || _checklist1$parkingPr3 === void 0 ? void 0 : (_checklist1$parkingPr4 = _checklist1$parkingPr3.inBasement) === null || _checklist1$parkingPr4 === void 0 ? void 0 : _checklist1$parkingPr4.cars))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Open Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr5 = checklist1.parkingProvision) === null || _checklist1$parkingPr5 === void 0 ? void 0 : (_checklist1$parkingPr6 = _checklist1$parkingPr5.openArea) === null || _checklist1$parkingPr6 === void 0 ? void 0 : _checklist1$parkingPr6.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr7 = checklist1.parkingProvision) === null || _checklist1$parkingPr7 === void 0 ? void 0 : (_checklist1$parkingPr8 = _checklist1$parkingPr7.openArea) === null || _checklist1$parkingPr8 === void 0 ? void 0 : _checklist1$parkingPr8.cars))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("In Stilt Area"))), (checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr9 = checklist1.parkingProvision) === null || _checklist1$parkingPr9 === void 0 ? void 0 : (_checklist1$parkingPr10 = _checklist1$parkingPr9.inStiltArea) === null || _checklist1$parkingPr10 === void 0 ? void 0 : _checklist1$parkingPr10.cars) && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "center",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("No. of Cars"), ":"), checklist1 === null || checklist1 === void 0 ? void 0 : (_checklist1$parkingPr11 = checklist1.parkingProvision) === null || _checklist1$parkingPr11 === void 0 ? void 0 : (_checklist1$parkingPr12 = _checklist1$parkingPr11.inStiltArea) === null || _checklist1$parkingPr12 === void 0 ? void 0 : _checklist1$parkingPr12.cars)))))))))), (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.publicSewerageOrSepticTank) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Checklist 2"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(2);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Existing road width in meters"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.existingRoadWidth) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Sewerage & Drainage"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.publicSewerageOrSepticTank) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Water Supply"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.waterSupplyArrangement) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Mode of Solid waste disposal"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.solidWasteDisposal) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Mode of Garbage collection"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.garbageCollection) || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Power supply"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.powerSupply)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Rain Water Harvesting"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.rainWaterHarvesting)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Provision of Solar Water Heating system"))), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, checklist2 === null || checklist2 === void 0 ? void 0 : checklist2.solarWaterHeating))))))))), ((formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapCoordinates) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      color: "#1f4a7",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: () => {
      handleTabChange(3);
    }
  }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : (_formData$description6 = _formData$description5.googleMapCoordinates) === null || _formData$description6 === void 0 ? void 0 : (_formData$description7 = _formData$description6[0]) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : (_formData$description9 = _formData$description8.googleMapCoordinates) === null || _formData$description9 === void 0 ? void 0 : (_formData$description10 = _formData$description9[0]) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.latitude, ", Longitude:", " ", formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11.googleMapCoordinates) === null || _formData$description12 === void 0 ? void 0 : (_formData$description13 = _formData$description12[0]) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.googleMapLocation))))))))), (formData === null || formData === void 0 ? void 0 : formData.assignLTP) === "Yes" && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex",
        color: "#1f4a7"
      }
    }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Assign file to License Technical Person(LTP)"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.ltpName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Selected LTP")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.ltpName)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.ltpRegistrationNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("Registration No.")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.ltpRegistrationNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.ltpCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, `${t("City Name")} :`)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.ltpCity))))))))), Boolean(formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount) && /*#__PURE__*/React__default.createElement(Card$2, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex",
        color: "#1f4a7"
      }
    }, "Edit", /*#__PURE__*/React__default.createElement(EditNoteRoundedIcon, null)),
    sx: accordionSummaryStyles$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Purchasable FAR"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti3 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : (_formData$taxHeadEsti4 = _formData$taxHeadEsti3[0]) === null || _formData$taxHeadEsti4 === void 0 ? void 0 : _formData$taxHeadEsti4.estimateAmount)))))))));
};

const PurchasableFAR2 = () => {
  var _params$professionalI, _userInfo$roles, _applicationData$desc;
  const {
    activeTab,
    setActiveTab,
    assignLTP,
    setAssignLTP,
    dispatch,
    t,
    id,
    history,
    initFormMTDocs,
    resetFormMTDocs,
    isUdFlow,
    applicationFlow,
    userUid,
    params,
    setParams,
    clearParams,
    isSessionCleared,
    isAppDataLoading,
    summaryRef,
    showToast,
    Modal,
    closeModal,
    handleTabChange,
    handleSubTabChange,
    applicationData,
    userInfo,
    tenantId,
    FAR_SB: SideBarLabelsFAR,
    FAR_PT: farPrimaryLabels,
    subActiveTab,
    setSubActiveTab,
    FAR_ST: subTabLabels,
    isUserEligible,
    setIsUserEligible,
    officesList,
    DepartmentSelector,
    closeToast,
    setShowToast,
    pFarList
  } = usePurchasableFarLogic();
  console.log("destructuredData", applicationFlow, params);
  const applicationNumber = params === null || params === void 0 ? void 0 : params.applicationNo;
  const isAssignedLTP = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) === (params === null || params === void 0 ? void 0 : (_params$professionalI = params.professionalInformation) === null || _params$professionalI === void 0 ? void 0 : _params$professionalI.ltpName);
  const otherRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(item => !["CITIZEN", "OWNER"].includes(item.code));
  const approvedLandUseData = useSelector(state => state.approvedLandUseData);
  const approvedLayout = (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$desc = applicationData.descriptionOfLand) === null || _applicationData$desc === void 0 ? void 0 : _applicationData$desc.schemeType) === "Scheme" ? "Yes" : "No";
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "PURCHASABLE_FAR");
  console.log("updateAPI", updateApiCall);
  console.log("toastMessageFAR", showToast);
  const [isEditMode, setIsEditMode] = useState(false);
  const handlePreviewClick = () => {
    setIsEditMode(true);
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$b, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            userInfo: userInfo,
            dispatch: dispatch,
            isUserEligible: isUserEligible,
            setIsUserEligible: setIsUserEligible,
            isAssignedLTP: isAssignedLTP,
            officesList: officesList,
            applicationFlow: applicationFlow,
            tenantId: tenantId,
            initFormMTDocs: initFormMTDocs,
            showToast: showToast,
            setShowToast: setShowToast
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$6, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            isAssignedLTP: isAssignedLTP,
            applicationData: approvedLandUseData === null || approvedLandUseData === void 0 ? void 0 : approvedLandUseData.applicationData,
            approvedLayout: approvedLayout
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$8, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            applicationFlow: applicationFlow,
            isAssignedLTP: isAssignedLTP,
            applicationData: approvedLandUseData === null || approvedLandUseData === void 0 ? void 0 : approvedLandUseData.applicationData,
            approvedLayout: approvedLayout,
            pFarList: pFarList
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$7, {
            formData: params,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            t: t,
            isAssignedLTP: isAssignedLTP,
            applicationData: approvedLandUseData === null || approvedLandUseData === void 0 ? void 0 : approvedLandUseData.applicationData
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Documents$1, {
        formData: params,
        handleTabChange: handleTabChange,
        t: t,
        isApprovedLayout: approvedLayout,
        applicationData: approvedLandUseData === null || approvedLandUseData === void 0 ? void 0 : approvedLandUseData.applicationData
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Checklist, {
        formData: params,
        isUpdating: updateApiCall.isLoading,
        handleTabChange: handleTabChange,
        t: t,
        Modal: Modal
      });
    } else if (activeTab === 3 && applicationNumber) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isEditMode && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Summary$1, {
        formData: params,
        role: "CITIZEN",
        handleTabChange: handleTabChange,
        ref: summaryRef
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT"))), isEditMode && /*#__PURE__*/React__default.createElement(EditSummaryFAR, {
        formData: params,
        handleSubTabChange: handleSubTabChange,
        handleTabChange: handleTabChange,
        role: "CITIZEN"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, !isEditMode && /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "secondary",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }),
        content: () => summaryRef.current
      }), !isEditMode ? /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: handlePreviewClick
      }) : /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Save",
        sx: {
          backgroundColor: "#157CB3"
        },
        onClick: () => setIsEditMode(false)
      }), !isEditMode && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3"
        },
        onClick: () => handleTabChange(4, params)
      }))));
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isAppDataLoading || !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      overflowY: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Purchasable FAR")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => setActiveTab(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, farPrimaryLabels.map((item, index) => /*#__PURE__*/React__default.createElement(PrimaryTab, {
    key: `${item.text}.${index}`,
    label: item.text
  })))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent())), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const SubStep1$c = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers, _formData$description, _fastPASData$descript7, _fastPASData$descript8, _fastPASData$descript9, _fastPASData$descript10;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [, scrutinyFlow, ScrutinySelector] = useScrutinyProcess(applicationFlow);
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const designType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    register
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [watchProposalType, watchisSpecialProject, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchCompunding, watchisAncestralProperty, watchRevenueVillage, watchPlotNumbers, watchNoticeNumber] = watch(["proposalType", "isSpecialProject", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "serviceType", "isAncestralProperty", "revenueVillage", "plotNumbers", "vaadId"]);
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs.map(plot => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
        prevFileNo: formData === null || formData === void 0 ? void 0 : formData.applicationNo
      });
    }
  }, [formData]);
  useEffect(() => {
    console.log(watchPlotNumbers, "watchPlotNumbersssss");
  }, [watchPlotNumbers]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Group Housing") {
      history.push(`groupHousingPortal`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const riskType = watchPlanOn === ("Self Certification of residential Plot Area upto 300 SqM on approved layouts" ) ? "Building Plan Low Risk, Self Certification Mode" : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") && watchAtivityProposed !== "Row Houses" && watchAtivityProposed !== "Semi Detached" && watchAtivityProposed !== "Detached" ? "High Risk and High Nivesh" : watchlandUseType === "Commercial" ? "High Risk and High Nivesh" : watchPlanOn !== "Others" ? "Building Plan-Low Risk" : "Others";
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$filter, _response4, _response4$BPA, _response4$BPA$filter, _data3, _data3$descriptionOfL, _data4, _data4$descriptionOfL, _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL, _data7, _data7$descriptionOfL, _data7$descriptionOfL2, _data8, _data8$descriptionOfL, _data9, _data9$descriptionOfL, _data10, _data11, _data11$descriptionOf, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _data15, _data15$descriptionOf, _data16, _data16$landInfo, _data16$landInfo$owne, _data16$landInfo$owne2, _data16$landInfo$owne3, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19, _data20, _data20$descriptionOf, _data21, _data21$descriptionOf, _data22;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        purchasableData = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data, _data$additionalDetai, _data$additionalDetai2, _data2, _data2$landInfo, _data2$landInfo$owner, _data2$landInfo$owner2;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data = data) === null || _data === void 0 ? void 0 : (_data$additionalDetai = _data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.professionalInformation) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else if ((userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber) === ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$landInfo = _data2.landInfo) === null || _data2$landInfo === void 0 ? void 0 : (_data2$landInfo$owner = _data2$landInfo.owners) === null || _data2$landInfo$owner === void 0 ? void 0 : (_data2$landInfo$owner2 = _data2$landInfo$owner[0]) === null || _data2$landInfo$owner2 === void 0 ? void 0 : _data2$landInfo$owner2.mobileNumber)) {
              setShowToast({
                key: "true",
                error: true,
                message: `Owner's mobile number and LTP's mobile number can't be same`
              });
              return;
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("zoneType", (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$descriptionOfL = _data3.descriptionOfLand) === null || _data3$descriptionOfL === void 0 ? void 0 : _data3$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$descriptionOfL = _data4.descriptionOfLand) === null || _data4$descriptionOfL === void 0 ? void 0 : _data4$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.landMark);
        setValue("sectorNo", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : _data6$descriptionOfL.sectorNo);
        setValue("khasraNo", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : (_data7$descriptionOfL2 = _data7$descriptionOfL.khasraWithArea[0]) === null || _data7$descriptionOfL2 === void 0 ? void 0 : _data7$descriptionOfL2.khasraNo);
        setValue("schemeName", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : _data8$descriptionOfL.schemeName);
        setValue("planOn", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.planOn);
        setValue("riskType", (_data10 = data) === null || _data10 === void 0 ? void 0 : _data10.riskType);
        setValue("activityProposed", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : _data11$descriptionOf.activityProposed);
        setValue("plotArea", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : _data14$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : _data15$descriptionOf.landAddress);
        setValue("tehsil", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$landInfo = _data16.landInfo) === null || _data16$landInfo === void 0 ? void 0 : (_data16$landInfo$owne = _data16$landInfo.owners) === null || _data16$landInfo$owne === void 0 ? void 0 : (_data16$landInfo$owne2 = _data16$landInfo$owne[0]) === null || _data16$landInfo$owne2 === void 0 ? void 0 : (_data16$landInfo$owne3 = _data16$landInfo$owne2.permanentAddress) === null || _data16$landInfo$owne3 === void 0 ? void 0 : _data16$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.developmentArea);
        setValue("subZoneType", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.subLandUseAsPerLayout);
        const resolvedBizService = ((_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.department) === "DA" || applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
        setValue("businessService", resolvedBizService);
        if (scrutinyFlow === "EDCR") {
          setValue("applicationType", "BUILDING_PLAN_SCRUTINY");
          setValue("appliactionType", "BUILDING_PLAN_SCRUTINY");
        } else {
          setValue("applicationType", isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP");
        }
        const isApproved = ((_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.landArea;
        setRiskType((_data22 = data) === null || _data22 === void 0 ? void 0 : _data22.riskType);
        setSchemeType(isApproved);
        if (isCompounding) {
          setValue("planOn", "FORM_MAP_COMPOUNDING");
        }
        if (!isApproved) {
          var _data23, _data23$khasraDetails, _data24, _data24$khasraDetails, _data24$khasraDetails2, _data25, _data25$khasraDetails, _data25$khasraDetails2;
          setValue("planOn", "Others");
          setValue("khasraNo", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$khasraDetails = _data23.khasraDetails) === null || _data23$khasraDetails === void 0 ? void 0 : _data23$khasraDetails.reduce((acc, curr) => acc + (curr === null || curr === void 0 ? void 0 : curr.khasraNumber) + ",", "").slice(0, -1));
          setValue("tehsil", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$khasraDetails = _data24.khasraDetails) === null || _data24$khasraDetails === void 0 ? void 0 : (_data24$khasraDetails2 = _data24$khasraDetails[0]) === null || _data24$khasraDetails2 === void 0 ? void 0 : _data24$khasraDetails2.tehsil);
          setValue("revenueVillage", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$khasraDetails = _data25.khasraDetails) === null || _data25$khasraDetails === void 0 ? void 0 : (_data25$khasraDetails2 = _data25$khasraDetails[0]) === null || _data25$khasraDetails2 === void 0 ? void 0 : _data25$khasraDetails2.villageName);
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.name === authority);
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Categery, _masterData$2, _masterData$2$Categer, _masterData$2$Categer2, _masterData$2$Categer3, _masterData$2$Categer4;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Categery = _masterData$.CategeryType) === null || _masterData$$Categery === void 0 ? void 0 : _masterData$$Categery.map(item => {
      return {
        name: item.Categery,
        label: item.Categery
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categer = _masterData$2.CategeryType) === null || _masterData$2$Categer === void 0 ? void 0 : (_masterData$2$Categer2 = _masterData$2$Categer.filter(item => item.Categery === category)) === null || _masterData$2$Categer2 === void 0 ? void 0 : (_masterData$2$Categer3 = _masterData$2$Categer2[0]) === null || _masterData$2$Categer3 === void 0 ? void 0 : (_masterData$2$Categer4 = _masterData$2$Categer3["Activity Proposed"]) === null || _masterData$2$Categer4 === void 0 ? void 0 : _masterData$2$Categer4.map(item => {
      return {
        name: item,
        label: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = !schemeType ? filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType) : filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchlandUseType);
  console.log(schemeType, "schemeTypeerrrrr");
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const onSubmit = data => {
    var _data28;
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    if (!isSelfCert && (scrutinyFlow === "EDCR" || file)) {
      data.file = file;
    }
    if (isCompounding) {
      var _data26, _fastPASData$descript;
      data.landInfo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.tenantId = stateId;
      data.land_Id = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.documents = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.nocDetails = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails;
      data.occupancy = (_data26 = data) === null || _data26 === void 0 ? void 0 : _data26.zoneType;
      data.totalProposedArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.landArea;
    }
    if (isSelfCert) {
      var _data27, _fastPASData$descript2, _fastPASData$addition, _fastPASData$addition2, _fastPASData$descript3, _fastPASData$descript4, _fastPASData$descript5, _fastPASData$descript6;
      const newFormData = {
        landInfo: {
          ...(fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo)
        },
        tenantId: stateId,
        land_Id: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id,
        documents: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents,
        descriptionOfLand: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand,
        nocDetails: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails,
        occupancy: (_data27 = data) === null || _data27 === void 0 ? void 0 : _data27.zoneType,
        totalProposedArea: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.landArea
      };
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition = fastPASData.additionalDetails) === null || _fastPASData$addition === void 0 ? void 0 : _fastPASData$addition.selectedOffice) || "";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition2 = fastPASData.additionalDetails) === null || _fastPASData$addition2 === void 0 ? void 0 : _fastPASData$addition2.selectedCity) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.purchasableFAR = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : (_fastPASData$descript4 = _fastPASData$descript3.properties) === null || _fastPASData$descript4 === void 0 ? void 0 : (_fastPASData$descript5 = _fastPASData$descript4[0]) === null || _fastPASData$descript5 === void 0 ? void 0 : _fastPASData$descript5.requiredAreaFAR) || 0;
      data.land_Id = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.department = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department;
      data.plotArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript6 = fastPASData.descriptionOfLand) === null || _fastPASData$descript6 === void 0 ? void 0 : _fastPASData$descript6.landArea, data = {
        ...data,
        ...newFormData
      };
    }
    if (scrutinyFlow !== "EDCR") {
      var _fastPASData$landInfo, _fastPASData$landInfo2, _fastPASData$landInfo3, _fastPASData$landInfo4, _fastPASData$landInfo5, _fastPASData$landInfo6, _fastPASData$landInfo7, _fastPASData$landInfo8, _fastPASData$landInfo9, _fastPASData$addition3, _fastPASData$addition4, _fastPASData$document, _fastPASData$document2, _user$correspondenceA;
      data.applicantName = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo = fastPASData.landInfo) === null || _fastPASData$landInfo === void 0 ? void 0 : (_fastPASData$landInfo2 = _fastPASData$landInfo.owners) === null || _fastPASData$landInfo2 === void 0 ? void 0 : (_fastPASData$landInfo3 = _fastPASData$landInfo2[0]) === null || _fastPASData$landInfo3 === void 0 ? void 0 : _fastPASData$landInfo3.name) || "";
      data.applicantEmailId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo4 = fastPASData.landInfo) === null || _fastPASData$landInfo4 === void 0 ? void 0 : (_fastPASData$landInfo5 = _fastPASData$landInfo4.owners) === null || _fastPASData$landInfo5 === void 0 ? void 0 : (_fastPASData$landInfo6 = _fastPASData$landInfo5[0]) === null || _fastPASData$landInfo6 === void 0 ? void 0 : _fastPASData$landInfo6.emailId) || "";
      data.aplicantMobileNumber = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo7 = fastPASData.landInfo) === null || _fastPASData$landInfo7 === void 0 ? void 0 : (_fastPASData$landInfo8 = _fastPASData$landInfo7.owners) === null || _fastPASData$landInfo8 === void 0 ? void 0 : (_fastPASData$landInfo9 = _fastPASData$landInfo8[0]) === null || _fastPASData$landInfo9 === void 0 ? void 0 : _fastPASData$landInfo9.mobileNumber) || "";
      data.selectedOffice = applicationFlow === "DA" ? fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition3 = fastPASData.additionalDetails) === null || _fastPASData$addition3 === void 0 ? void 0 : _fastPASData$addition3.selectedOffice : "UPAVP";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition4 = fastPASData.additionalDetails) === null || _fastPASData$addition4 === void 0 ? void 0 : _fastPASData$addition4.selectedCity) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.department = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department;
      data.land_Id = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.signatureId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$document = fastPASData.documents) === null || _fastPASData$document === void 0 ? void 0 : (_fastPASData$document2 = _fastPASData$document.filter(doc => doc.documentType === "signature")[0]) === null || _fastPASData$document2 === void 0 ? void 0 : _fastPASData$document2.fileStoreId) || null;
      data.licenseeName = user === null || user === void 0 ? void 0 : user.name, data.licenseeLicenceNumber = user === null || user === void 0 ? void 0 : user.registrationNumber;
      data.licenseeMobileNumber = user === null || user === void 0 ? void 0 : user.mobileNumber;
      data.licenseeEmailId = user === null || user === void 0 ? void 0 : user.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA = user.correspondenceAddress) === null || _user$correspondenceA === void 0 ? void 0 : _user$correspondenceA.address;
      data.scrutinyFlow = "PDF";
    }
    const resolvedDept = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || ((_data28 = data) === null || _data28 === void 0 ? void 0 : _data28.department) || applicationFlow;
    const resolvedBizService = resolvedDept === "DA" || applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
    data.department = resolvedDept;
    data.businessService = resolvedBizService;
    if (isSelfCert || scrutinyFlow !== "EDCR") {
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      handleTabChange(1, id ? {
        ...formData,
        ...data
      } : data);
    } else {
      var _data29;
      data.applicationType = "BUILDING_PLAN_SCRUTINY";
      data.appliactionType = "BUILDING_PLAN_SCRUTINY";
      handleSubTabChange(1, id ? {
        ...formData,
        ...data,
        file: file || ((_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.file)
      } : data);
    }
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  if (scrutinyFlow === null) {
    return /*#__PURE__*/React__default.createElement(ScrutinySelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, watchPlanOn && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading",
    style: {
      background: "#f2f2f2",
      textAlign: "end",
      fontSize: "20px",
      color: "green"
    }
  }, t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: natureOfConstructionOptions,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isSelfCert
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchlandUseType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: schemeType && watchSubZoneType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchPrimaryUse
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchAtivityProposed
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(planOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "planOn",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planOn,
    type: "selectInput",
    mandatory: schemeType,
    validation: {
      required: {
        value: schemeType,
        message: "This field is required"
      }
    }
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed Site"),
    name: "otherSchemeName",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchnatureOfConstruction && watchnatureOfConstruction !== "New" && watchnatureOfConstruction !== "Compounding" && watchnatureOfConstruction !== "Group Housing" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Prev File No"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null), watchnatureOfConstruction === "Compounding" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("DM Circle Rate (In Rs. Per Square meter)"),
    control: control,
    placeholder: t("Enter DM Rate"),
    name: "dmCircleRate",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    containerStyles: {
      lineHeight: "11px"
    },
    customLabelStyles: {
      lineHeight: "11px"
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.dmCircleRate,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript7 = fastPASData.descriptionOfLand) === null || _fastPASData$descript7 === void 0 ? void 0 : _fastPASData$descript7.schemeName
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    mandatory: !schemeType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    mandatory: !schemeType,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Standard Type Design")}`,
    name: "proposalType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.proposalType) || designType,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), schemeType ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript8 = fastPASData.descriptionOfLand) === null || _fastPASData$descript8 === void 0 ? void 0 : _fastPASData$descript8.plotNo),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript9 = fastPASData.descriptionOfLand) === null || _fastPASData$descript9 === void 0 ? void 0 : _fastPASData$descript9.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo)
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker"
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput"
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of Plots"),
    name: "noOfPlots",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, Array.from({
    length: 3
  }).map((_, colIndex) => {
    const plotIndex = rowIndex * 3 + colIndex;
    console.log(plotIndex, "plotIndexxx");
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      hasLabel: false,
      maxLength: 15,
      type: "textInput"
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, Array.from({
    length: remainingPlots
  }).map((_, colIndex) => {
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      maxLength: 15,
      hasLabel: false,
      type: "textInput"
    }));
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: watchPlanOn === "Others" ? projectTypeOptions.filter(e => e.name !== "Building Permission-Low Risk") : projectTypeOptions,
    label: `${t("Project Type")}`,
    placeholder: "Select Project Type",
    name: "buildingClassification",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingClassification,
    type: watchPlanOn ? "textInput" : "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchPlanOn
  })), /*#__PURE__*/React__default.createElement(Col, null, watchbuildingClassification === "Others" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherbuildingClass",
    mandatory: true,
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), watchProjectType === "Other" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Please specify if any other condition"),
    placeholder: t("Enter condition"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript10 = fastPASData.descriptionOfLand) === null || _fastPASData$descript10 === void 0 ? void 0 : _fastPASData$descript10.landArea) < 40000 && watchlandUseType !== "Residential" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is Your Plot sub-division"),
    control: control,
    name: "plotSubdivided",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Does existing building require any compounding ?"),
    control: control,
    name: "needCompounding",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.needCompounding,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchNeedComp === "no" && watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is your plot Lease hold ?"),
    control: control,
    name: "plotLeaseHold",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Do you want Purchasable FAR?"),
    control: control,
    name: "plotLeaseHold",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, watchplotLeaseHold === "yes" && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basic FAR"),
    control: control,
    name: "basicFAR",
    mandatory: true,
    placeholder: t("Enter Basic FAR"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchplotLeaseHold === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Purchasable FAR"),
    control: control,
    name: "purchasableFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    type: "textInput",
    placeholder: t("Enter Purchasable FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Premium FAR"),
    control: control,
    name: "premiumFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
    type: "textInput",
    placeholder: t("Enter Premium FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchnatureOfConstruction === "Compounding" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is building plan previously approved?"),
    control: control,
    name: "serviceType",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.serviceType,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchCompunding !== "no" && /*#__PURE__*/React__default.createElement(Col, null), watchCompunding === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of compounding"),
    placeholder: t("Select Nature Of Compounding"),
    name: "isAncestralProperty",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty,
    data: SortingAlphabatically(natureOfCompounding),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchCompunding === "no" && watchisAncestralProperty === "In response to notice" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Notice Number"),
    control: control,
    placeholder: t("Notice Number  (Mandatory Field)"),
    name: "vaadId",
    mandatory: true,
    maxLength: 24,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.vaadId,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer bg-white"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.", /*#__PURE__*/React__default.createElement("br", null), " The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information present in the file shall not be the responsibility of the EDCR Engine.")
  })))), !isSelfCert && scrutinyFlow === "EDCR" && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Upload DXF File"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(DxfFileUploader, {
    control: control,
    name: "file",
    label: "Upload Building Plan Drawing",
    validationMsg: "(dxf only and Max file Size 300 MB)",
    isMandatory: true,
    required: true,
    tab: 3,
    setFile: setFile,
    maxFiles: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: !declarationChecked || watchPlotSubdivided === "yes" || watchNeedComp === "yes"
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const getEDCRData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  if (id) {
    var _data$BPA, _edcrData$description, _edcrData$description2, _edcrData$description3, _edcrData$description4, _edcrData$landInfo, _edcrData$landInfo$ow, _edcrData$landInfo$ow2, _edcrData$landInfo2, _edcrData$landInfo2$o, _edcrData$landInfo2$o2, _edcrData$landInfo3, _edcrData$landInfo3$o, _edcrData$landInfo3$o2, _edcrData$documents, _edcrData$documents$f, _edcrData$additionalD;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const edcrData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    const applicationData = {
      applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      applicationId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationId,
      appliactionType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || "BUILDING_PLAN_SCRUTINY",
      applicationType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || "BUILDING_PLAN_SCRUTINY",
      applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION",
      serviceType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || "NEW_CONSTRUCTION",
      transactionNumber: uuidv4(),
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      department: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.department) || applicationFlow || null,
      businessService: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.businessService) === "BPA_MAPSUB_DA" || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.businessService) === "BPA_MAPSUB_AVP" ? edcrData.businessService : applicationFlow === "DA" || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.department) === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP",
      fastPASId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.land_Id,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      city: edcrData === null || edcrData === void 0 ? void 0 : edcrData.city,
      locality: edcrData === null || edcrData === void 0 ? void 0 : edcrData.locality,
      village: edcrData === null || edcrData === void 0 ? void 0 : edcrData.village,
      doorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.doorNo,
      code: edcrData === null || edcrData === void 0 ? void 0 : edcrData.code,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      plotArea: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description = edcrData.descriptionOfLand) === null || _edcrData$description === void 0 ? void 0 : _edcrData$description.landArea,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      otherSchemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherSchemeName,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      areaType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.areaType,
      developmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentArea,
      subDevelopmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subDevelopmentArea,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.far,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      groundCoverages: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackFronts,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackRears,
      backSide: edcrData === null || edcrData === void 0 ? void 0 : edcrData.backSide,
      isPlotSetback: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isPlotSetback,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      otherProjectName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherProjectName,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      previousSetbackFront: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      previousSetbackRear: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      previousSetbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide1,
      previousSetbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide2,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      landUseNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      purchasableFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description2 = edcrData.descriptionOfLand) === null || _edcrData$description2 === void 0 ? void 0 : (_edcrData$description3 = _edcrData$description2.properties) === null || _edcrData$description3 === void 0 ? void 0 : (_edcrData$description4 = _edcrData$description3[0]) === null || _edcrData$description4 === void 0 ? void 0 : _edcrData$description4.requiredAreaFAR) || 0,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      leaseholdNOC: edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      shelterFee: edcrData === null || edcrData === void 0 ? void 0 : edcrData.shelterFee,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      applicantName: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo = edcrData.landInfo) === null || _edcrData$landInfo === void 0 ? void 0 : (_edcrData$landInfo$ow = _edcrData$landInfo.owners) === null || _edcrData$landInfo$ow === void 0 ? void 0 : (_edcrData$landInfo$ow2 = _edcrData$landInfo$ow[0]) === null || _edcrData$landInfo$ow2 === void 0 ? void 0 : _edcrData$landInfo$ow2.name,
      aplicantMobileNumber: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo2 = edcrData.landInfo) === null || _edcrData$landInfo2 === void 0 ? void 0 : (_edcrData$landInfo2$o = _edcrData$landInfo2.owners) === null || _edcrData$landInfo2$o === void 0 ? void 0 : (_edcrData$landInfo2$o2 = _edcrData$landInfo2$o[0]) === null || _edcrData$landInfo2$o2 === void 0 ? void 0 : _edcrData$landInfo2$o2.mobileNumber,
      applicantEmailId: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo3 = edcrData.landInfo) === null || _edcrData$landInfo3 === void 0 ? void 0 : (_edcrData$landInfo3$o = _edcrData$landInfo3.owners) === null || _edcrData$landInfo3$o === void 0 ? void 0 : (_edcrData$landInfo3$o2 = _edcrData$landInfo3$o[0]) === null || _edcrData$landInfo3$o2 === void 0 ? void 0 : _edcrData$landInfo3$o2.emailId,
      licenseeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeName,
      licenseeLicenceNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeLicenceNumber) || "",
      licenseeMobileNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeMobileNumber) || "",
      licenseeEmailId: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeEmailId) || "",
      licenseeAddress: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeAddress) || "",
      file: edcrData === null || edcrData === void 0 ? void 0 : edcrData.file,
      signatureId: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : (_edcrData$documents$f = _edcrData$documents.filter(doc => doc.documentType === "signature")[0]) === null || _edcrData$documents$f === void 0 ? void 0 : _edcrData$documents$f.fileStoreId) || null,
      selectedOffice: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD = edcrData.additionalDetails) === null || _edcrData$additionalD === void 0 ? void 0 : _edcrData$additionalD.selectedOffice,
      department: applicationFlow || null
    };
    return {
      applicationData,
      isAppDataLoading
    };
  } else {
    const applicationData = {
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      serviceType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: applicationFlow || null,
      businessService: applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP"
    };
    return {
      applicationData,
      isAppDataLoading: false
    };
  }
};

const ScrutinyUnderProcess = () => {
  const [dots, setDots] = useState("");
  const [blink, setBlink] = useState(true);
  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots(prev => prev.length < 3 ? prev + "." : "");
    }, 500);
    const blinkInterval = setInterval(() => {
      setBlink(prev => !prev);
    }, 800);
    return () => {
      clearInterval(dotsInterval);
      clearInterval(blinkInterval);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mt: 5
  }, /*#__PURE__*/React__default.createElement(Box, {
    mt: 2,
    fontSize: "20px",
    fontWeight: "bold",
    style: {
      opacity: blink ? 1 : 0.3
    }
  }, "Scrutiny under process", dots), /*#__PURE__*/React__default.createElement(CircularProgress, null));
};

const EDCRPortal = () => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [disable, setDisable] = useState(false);
  const [proposedSite, setProposedSite] = useState(null);
  const {
    applicationData: edcrData,
    isAppDataLoading: edcrAppDataLoading
  } = getEDCRData(id);
  const {
    applicationData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const isSelfCert = proposedSite === 'Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm';
  const [edcrParams, setEdcrParams, clearEdcrParams] = Digit.Hooks.useSessionStorage("EDCR_CREATE", edcrData);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
    if (!id && (Array.isArray(edcrParams) || !(edcrParams !== null && edcrParams !== void 0 && edcrParams.appliactionType))) {
      clearEdcrParams();
    }
  }, [id]);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData !== null && formData !== void 0 && formData.scrutinyFlow && formData.scrutinyFlow !== "EDCR" && !(formData !== null && formData !== void 0 && formData.file)) {
      handleTabChange(nextSubTab, formData);
      return;
    }
    setDisable(true);
    const file = formData === null || formData === void 0 ? void 0 : formData.file;
    if (formData) {
      var _userInfo$roles, _data$natureOfConstru, _data$natureOfConstru2, _userRolesArray$, _edcrRequest, _edcrRequest$mapSubDe, _edcrRequest2, _edcrRequest2$additio, _edcrRequest3, _edcrRequest3$mapSubD, _edcrRequest4, _edcrRequest4$additio;
      const safeEdcrParams = Array.isArray(edcrParams) ? {} : {
        ...edcrParams
      };
      if (!(formData !== null && formData !== void 0 && formData.isRevised) && !(formData !== null && formData !== void 0 && formData.applicationScrutinyType)) {
        delete safeEdcrParams.edcrNumber;
        delete safeEdcrParams.transactionNumber;
      }
      const data = {
        ...safeEdcrParams,
        ...formData
      };
      const userRolesArray = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(user => user.code !== "CITIZEN")) || [];
      const edcrAppType = "BUILDING_PLAN_SCRUTINY";
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow || (safeEdcrParams === null || safeEdcrParams === void 0 ? void 0 : safeEdcrParams.department) || (formData === null || formData === void 0 ? void 0 : formData.department);
      const resolvedBusinessService = resolvedDept === "DA" || (data === null || data === void 0 ? void 0 : data.businessService) === "BPA_MAPSUB_DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      const subType = data !== null && data !== void 0 && data.serviceType && data.serviceType !== "yes" && data.serviceType !== "no" ? data.serviceType : (data === null || data === void 0 ? void 0 : data.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION";
      const natureOfConstruction = typeof (data === null || data === void 0 ? void 0 : data.natureOfConstruction) === "object" ? (data === null || data === void 0 ? void 0 : (_data$natureOfConstru = data.natureOfConstruction) === null || _data$natureOfConstru === void 0 ? void 0 : _data$natureOfConstru.value) || (data === null || data === void 0 ? void 0 : (_data$natureOfConstru2 = data.natureOfConstruction) === null || _data$natureOfConstru2 === void 0 ? void 0 : _data$natureOfConstru2.name) : data === null || data === void 0 ? void 0 : data.natureOfConstruction;
      let edcrRequest = {
        transactionNumber: (formData === null || formData === void 0 ? void 0 : formData.transactionNumber) || (typeof uuidv4 === "function" ? uuidv4() : ""),
        edcrNumber: (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || "",
        rolesCode: (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) || null,
        planFile: null,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        RequestInfo: {
          apiId: "",
          ver: "",
          ts: "",
          action: "",
          did: "",
          authToken: "",
          key: "",
          msgId: "",
          correlationId: "",
          userInfo: userInfo
        }
      };
      edcrRequest = {
        ...edcrRequest,
        ...data,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        department: resolvedDept || (data === null || data === void 0 ? void 0 : data.department) || applicationFlow,
        businessService: resolvedBusinessService,
        appliactionType: edcrAppType,
        applicationType: edcrAppType,
        applicationSubType: subType,
        serviceType: subType,
        ...(natureOfConstruction ? {
          natureOfConstruction
        } : {})
      };
      if (!edcrRequest.transactionNumber) {
        edcrRequest.transactionNumber = typeof uuidv4 === "function" ? uuidv4() : "";
      }
      edcrRequest.tod = "";
      if ((_edcrRequest = edcrRequest) !== null && _edcrRequest !== void 0 && (_edcrRequest$mapSubDe = _edcrRequest.mapSubDetails) !== null && _edcrRequest$mapSubDe !== void 0 && _edcrRequest$mapSubDe.tod) {
        edcrRequest.mapSubDetails.tod = "";
      }
      if ((_edcrRequest2 = edcrRequest) !== null && _edcrRequest2 !== void 0 && (_edcrRequest2$additio = _edcrRequest2.additionalDetails) !== null && _edcrRequest2$additio !== void 0 && _edcrRequest2$additio.tod) {
        edcrRequest.additionalDetails.tod = "";
      }
      delete edcrRequest.landUseApprovalLetter;
      if ((_edcrRequest3 = edcrRequest) !== null && _edcrRequest3 !== void 0 && (_edcrRequest3$mapSubD = _edcrRequest3.mapSubDetails) !== null && _edcrRequest3$mapSubD !== void 0 && _edcrRequest3$mapSubD.landUseApprovalLetter) {
        delete edcrRequest.mapSubDetails.landUseApprovalLetter;
      }
      if ((_edcrRequest4 = edcrRequest) !== null && _edcrRequest4 !== void 0 && (_edcrRequest4$additio = _edcrRequest4.additionalDetails) !== null && _edcrRequest4$additio !== void 0 && _edcrRequest4$additio.landUseApprovalLetter) {
        delete edcrRequest.additionalDetails.landUseApprovalLetter;
      }
      let bodyFormData = new FormData();
      bodyFormData.append("planFile", file);
      bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
      if (activeTab === 0 && selectedSubTab === 0 && bodyFormData && file) {
        Digit.EDCRService.create({
          data: bodyFormData
        }, tenantId).then(result => {
          var _result$data;
          if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.edcrDetail) {
            var _result$data2, _result$data3;
            setDisable(false);
            setEdcrParams(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.edcrDetail);
            history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
              data: result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.edcrDetail
            });
          }
        }).catch(e => {
          var _e$response, _e$response2, _e$response2$data, _e$response2$data$, _e$response3, _e$response3$data, _e$response3$data$, _e$response4, _e$response4$data, _e$response5, _e$response5$data;
          setDisable(false);
          const errMsg = Array.isArray(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data) && ((e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$ = _e$response2$data[0]) === null || _e$response2$data$ === void 0 ? void 0 : _e$response2$data$.errorMessage) || (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$ = _e$response3$data[0]) === null || _e$response3$data$ === void 0 ? void 0 : _e$response3$data$.errorCode)) || (e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.message) || (e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.errorCode) || "Something went wrong!!";
          Modal("EDCR Error", errMsg, "error");
        });
      } else {
        setDisable(false);
      }
    } else {
      setDisable(false);
    }
  };
  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      var _data$mapSubDetails, _formData$mapSubDetai, _params$mapSubDetails;
      const data = {
        ...params,
        ...formData
      };
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow;
      data.department = resolvedDept;
      data.businessService = resolvedDept === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = formData !== null && formData !== void 0 && formData.isCompounding || data !== null && data !== void 0 && data.isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      const resolvedLandUseLetter = (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails = data.mapSubDetails) === null || _data$mapSubDetails === void 0 ? void 0 : _data$mapSubDetails.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : (_params$mapSubDetails = params.mapSubDetails) === null || _params$mapSubDetails === void 0 ? void 0 : _params$mapSubDetails.landUseApprovalLetter);
      if (resolvedLandUseLetter) {
        data.landUseApprovalLetter = resolvedLandUseLetter;
        data.approvalLetterUrl = resolvedLandUseLetter;
        data.mapSubDetails = {
          ...(data.mapSubDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
        data.additionalDetails = {
          ...(data.additionalDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
      }
      Digit.OBPSService.create({
        BPA: data
      }, tenantId).then(res => {
        var _res$BPA;
        if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
          var _res$BPA2;
          Modal("Application Created", `Application Created Successfully!`, "success");
          history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`, {
            data: res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]
          });
        }
      }).catch(e => {
        var _e$response6, _e$response6$data, _e$response6$data$Err;
        Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response6 = e.response) === null || _e$response6 === void 0 ? void 0 : (_e$response6$data = _e$response6.data) === null || _e$response6$data === void 0 ? void 0 : (_e$response6$data$Err = _e$response6$data.Errors[0]) === null || _e$response6$data$Err === void 0 ? void 0 : _e$response6$data$Err.message}`, 'error');
      });
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  useEffect(() => {
    if (id && edcrData) {
      var _edcrData$documents;
      setEdcrParams(edcrData);
      if ((edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : _edcrData$documents.length) > 0) {
        initFormMTDocs(edcrData.documents);
      }
    }
  }, [id, edcrAppDataLoading]);
  const renderContent = () => {
    var _Digit, _Digit$SessionStorage;
    const scrutinyFlow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("LTP.SCRUTINY.SELECTION");
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$c, {
            formData: isSelfCert || scrutinyFlow !== "EDCR" ? params : edcrParams,
            handleSubTabChange: handleSubTabChange,
            userInfo: userInfo,
            handleTabChange: handleTabChange,
            setProposedSite: setProposedSite,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id
          });
        default:
          return null;
      }
    }
  };
  if (isAppDataLoading || edcrAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (disable) {
    return /*#__PURE__*/React__default.createElement(ScrutinyUnderProcess, null);
  }
  if (id && !edcrData && edcrData !== null && edcrData !== void 0 && edcrData.proposalType) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Common  Application Form"
  }), activeTab === 0 && renderContent());
};

const EdcrApplications = () => {
  var _Digit$UserService$ge, _data$PermissionOfSub;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [data, setEdcrData] = useState([]);
  const {
    control,
    register
  } = useForm();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  console.log("userInfo", userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid);
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  async function fetchEdcrData() {
    try {
      var _response, _response2, _response2$edcrDetail, _response3;
      let response = await Digit.OBPSService.scrutinyDetails(tenantId);
      if (!((_response = response) !== null && _response !== void 0 && _response.edcrDetail) || ((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$edcrDetail = _response2.edcrDetail) === null || _response2$edcrDetail === void 0 ? void 0 : _response2$edcrDetail.length) === 0) {
        const stateId = Digit.ULBService.getStateId();
        if (stateId && stateId !== tenantId) {
          response = await Digit.OBPSService.scrutinyDetails(stateId);
        }
      }
      console.log(response, "scrutnizedData");
      setEdcrData(((_response3 = response) === null || _response3 === void 0 ? void 0 : _response3.edcrDetail) || []);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchEdcrData();
  }, []);
  console.log("dataaaaa", data);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const StyledTableCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const [orderBy, setOrderBy] = useState("applicationNo");
  const [order, setOrder] = useState("desc");
  const sortedData = data === null || data === void 0 ? void 0 : (_data$PermissionOfSub = data.PermissionOfSubdivision) === null || _data$PermissionOfSub === void 0 ? void 0 : _data$PermissionOfSub.sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return b[orderBy] < a[orderBy] ? -1 : 1;
    }
  });
  console.log("column1", data, sortedData);
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 5%"
    }
  }, /*#__PURE__*/React__default.createElement(Paper$2, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "8px",
      fontSize: "24px"
    }
  }, `${t("EDCR_APPLICATIONS")}`), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    sx: {
      maxHeight: 500
    }
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Application Number"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Date"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Edcr Number"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Dxf File"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Plan Report"), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Status "), /*#__PURE__*/React__default.createElement(StyledTableCell, null, "Drawing File"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, data === null || data === void 0 ? void 0 : data.map((item, index) => {
    return /*#__PURE__*/React__default.createElement(StyledTableRow, {
      sx: {
        "&:last-child td, &:last-child th": {
          border: 0
        }
      }
    }, /*#__PURE__*/React__default.createElement(StyledTableCell, null, item === null || item === void 0 ? void 0 : item.applicationNumber), /*#__PURE__*/React__default.createElement(StyledTableCell, null, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.applicationDate)), /*#__PURE__*/React__default.createElement(StyledTableCell, null, item === null || item === void 0 ? void 0 : item.edcrNumber), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, item !== null && item !== void 0 && item.dxfFile ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.open(item === null || item === void 0 ? void 0 : item.dxfFile, "_blank");
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, item !== null && item !== void 0 && item.planReport ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.open(item === null || item === void 0 ? void 0 : item.planReport, "_blank");
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, item === null || item === void 0 ? void 0 : item.status), /*#__PURE__*/React__default.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, item !== null && item !== void 0 && item.updatedDxfFile ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.open(item === null || item === void 0 ? void 0 : item.updatedDxfFile, "_blank");
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")) : "N/A"));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: data === null || data === void 0 ? void 0 : data.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })));
};

const TopBarContainer$1 = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "22px 20px",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  position: "sticky",
  top: 0,
  zIndex: 1001
});
const TopBarLeft = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px"
});
const TopBarName = styled("div")({
  "& strong": {
    fontSize: "16px",
    color: "#333"
  }
});
const DropdownMenu = styled("div")({
  position: "absolute",
  right: "0",
  top: "100%",
  backgroundColor: "#fff",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  zIndex: "1000",
  minWidth: "150px"
});
const DropdownItem = styled("div")({
  padding: "8px 16px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5"
  }
});
const TopBarValidity = styled("div")({
  "& strong": {
    fontWeight: 800,
    marginRight: "5px",
    color: "#666"
  },
  color: "#666",
  whiteSpace: "normal",
  overflowWrap: "anywhere"
});
const TopBarRight = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px"
});
const TopBarIcon = styled("div")({
  color: "#6FA2DC",
  fontSize: "18px",
  cursor: "pointer",
  transition: "color 0.2s",
  display: "flex",
  alignItems: "center",
  position: "relative",
  "&:hover": {
    color: "#333"
  }
});
const MenuWrapper$1 = styled("div")({
  overflowY: "auto",
  height: "100%",
  "&::-webkit-scrollbar": {
    width: "4px"
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1"
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888"
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555"
  }
});
const SidebarContainer = styled("div")(props => ({
  width: props.collapsed ? "0px" : "250px",
  transition: "width 0.3s ease",
  overflow: "hidden",
  height: "100vh",
  boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
  zIndex: 100,
  position: "fixed",
  top: "0px",
  background: "linear-gradient(135deg, #0E374F 0%, #156C9C 100%)"
}));
const SidebarHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px 12px 8px 6px",
  color: "#fff",
  borderBottom: "1px solid rgb(221, 221, 221)",
  background: "linear-gradient(311deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
});
const HeaderTitle$1 = styled("h3")({
  margin: 0,
  fontWeight: "bold",
  fontSize: "1rem"
});
const HamburgerIcon = styled(FaBars)({
  cursor: "pointer",
  fontSize: "1rem"
});
const MenuItem$1 = styled("div")({
  color: "#fff",
  padding: "0.75rem 1rem",
  fontSize: ".9rem",
  margin: "0.25rem 0",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  fontWeight: "bold"
});
const SubMenuItem = styled("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  color: "#fff",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)"
  }
});
const NestedSubMenuItem = styled("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  color: "#fff",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)"
  }
});
const CopyIcon = styled(FaCopy)({
  cursor: "pointer",
  fontSize: "0.9rem"
});
const DashboardLayout = styled("div")(({
  isObpsRoute
}) => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%"
}));
const MainContent = styled("div")(props => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  width: "75%",
  minHeight: "100vh",
  paddingLeft: props.collapsed ? "0px" : "250px"
}));
const MenuItemTitle = styled("span")({
  fontWeight: "normal"
});
const FileInfoStrip = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0",
  position: "sticky",
  top: 40,
  zIndex: 1000
});
const FileNo = styled("span")({
  flex: 1,
  textAlign: "left"
});
const RiskType = styled("span")(props => ({
  textAlign: "center",
  fontWeight: "bold",
  color: props.riskType === "High Risk" ? "#d32f2f" : "#388e3c",
  padding: "4px 8px",
  borderRadius: "6px"
}));
const Status = styled("span")(props => ({
  textAlign: "center",
  backgroundColor: "#4caf50",
  color: "white",
  padding: "4px 8px",
  borderRadius: "6px",
  fontSize: "0.8rem"
}));
const Owner = styled("div")({
  flex: 1,
  textAlign: "right",
  fontWeight: "bold"
});
const AuthInfoStrip = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0"
});
const AuthorityName = styled("span")({
  flex: 1,
  textAlign: "left",
  fontWeight: "500"
});
const InfoText = styled("span")({
  flex: 1,
  textAlign: "center",
  color: "red",
  fontStyle: "italic"
});
const ActionButton = styled("button")({
  backgroundColor: "#2862A4",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "8px 16px",
  margin: "0 4px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#1e4a7e"
  }
});
const PortalWrapper$1 = styled("div")(() => ({
  boxSizing: "border-box"
}));
const NotificationBadge = styled("span")(() => ({
  position: "absolute",
  top: "-4px",
  right: "-4px",
  backgroundColor: "rgb(235, 46, 46)",
  color: "#fff",
  borderRadius: "50%",
  width: "15px",
  height: "15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  fontWeight: "bold"
}));

const flags = {
  edcr: process.env.REACT_APP_ENABLE_EDCR === "true",
  selfCert: process.env.REACT_APP_ENABLE_SELF_CERT === "true",
  selfApproval: process.env.REACT_APP_ENABLE_SELF_APPROVAL === "true",
  selfApprovalScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_SCHEME === "true",
  selfApprovalNonScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_NON_SCHEME === "true",
  revalidation: process.env.REACT_APP_ENABLE_REVALIDATION === "true",
  groupHousing: process.env.REACT_APP_ENABLE_GROUP_HOUSING === "true",
  plinth: process.env.REACT_APP_ENABLE_PLINTH === "true",
  landUseConversion: process.env.REACT_APP_ENABLE_LANDUSE_CONVERSION === "true",
  workCommencement: process.env.REACT_APP_ENABLE_WORK_COMMENCEMENT === "true",
  purchasableFar: process.env.REACT_APP_ENABLE_PURCHASABLE_FAR === "true",
  completion: process.env.REACT_APP_ENABLE_COMPLETION === "true",
  compounding: process.env.REACT_APP_ENABLE_COMPOUNDING === "true"
};

dayjs.extend(customParseFormat);
const Sidebar$1 = ({
  userDetails,
  toggleSidebar,
  collapsed
}) => {
  var _userInfo$info, _userInfo$info$roles;
  const {
    t
  } = useTranslation();
  const [expandedItems, setExpandedItems] = useState({});
  const [expandedSubItems, setExpandedSubItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(e => e.code);
  const userDetail = Digit.SessionStorage.get("USER_DETAIL") || userDetails;
  const [isValidityExpired, setIsValidityExpired] = useState(null);
  const [isValidityNull, setIsValidityNull] = useState(null);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    },
    noticeBox: {
      background: "#fff",
      padding: "25px 30px",
      borderRadius: "10px",
      width: "380px",
      textAlign: "center",
      boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
      borderTop: "5px solid #ff9800"
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "10px"
    },
    message: {
      fontSize: "14px",
      color: "#444",
      marginBottom: "20px"
    },
    button: {
      padding: "8px 20px",
      background: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontWeight: "500"
    }
  };
  useEffect(() => {
    if (!userDetail) return;
    if (!(userDetail !== null && userDetail !== void 0 && userDetail.validUpto)) {
      setIsValidityNull(true);
      setIsValidityExpired(true);
      return;
    }
    const validUpto = dayjs(userDetail === null || userDetail === void 0 ? void 0 : userDetail.validUpto, "DD-MM-YYYY HH:mm:ss");
    const now = dayjs();
    const expired = validUpto.isBefore(now);
    setIsValidityExpired(expired);
  }, [userDetail]);
  const isLtp = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE"].includes(role))) && !isValidityExpired && (userRoles === null || userRoles === void 0 ? void 0 : userRoles.length) > 2;
  const expiredLTP = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE"].includes(role))) && isValidityExpired;
  const isOwner = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("OWNER")) && !isLtp;
  const isCitizen = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("LTP")) && !isLtp;
  const fileCount = Digit.SessionStorage.get("FILE_COUNT") || "---";
  const toggleItem = item => {
    setExpandedItems(prev => ({
      ...prev,
      [item]: !prev[item]
    }));
  };
  const toggleSubItem = (parentTitle, subItemName) => {
    setExpandedSubItems(prev => ({
      ...prev,
      [`${parentTitle}-${subItemName}`]: !prev[`${parentTitle}-${subItemName}`]
    }));
  };
  const handleNavigation = (path, state = {}, keysToRemove = []) => {
    if (path.includes("/obps/services/")) {
      var _Digit;
      Digit.SessionStorage.del("CITIZEN.COMMON.HOME.FLOW");
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("LTP.SCRUTINY.SELECTION");
    }
    if (keysToRemove.length > 0) {
      keysToRemove.forEach(key => {
        Digit.SessionStorage.del(key);
      });
    }
    history.push(path, state);
  };
  const allMenuItems = [{
    title: `${t("FASTPAS.FILES.RECEIVED.TEXT")} (${fileCount})`,
    path: `${citizenBaseUrl$1}/profile`
  }, {
    title: t("FASTPAS.GLOBAL.LTP.TEXT"),
    subItems: [{
      name: isValidityNull ? t("FASTPAS.GLOBAL.APPLY.TEXT") : isValidityExpired ? "Reapply" : t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/ltpPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formProfessionalApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/formLandUse`
    }, {
      name: t('FASTPAS.GLOBAL.APPLY.OLD.CASE.TEXT'),
      path: `${citizenBaseUrl$1}/obps/services/oldCaseSearchLU`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formLandUseApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      subItems: [flags.edcr && {
        name: t('FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT'),
        path: `${citizenBaseUrl$1}/obps/services/groupHousingPortal`
      }, flags.selfCert && {
        name: "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)",
        path: `${citizenBaseUrl$1}/obps/services/selfResidentialPortal`
      }, flags.selfApproval && {
        name: "Self Approval via LTP",
        subItems: [flags.selfApprovalScheme && {
          name: "Scheme Residential upto 500 Sqmt & Commercial upto 200 Sqmt.",
          path: `${citizenBaseUrl$1}/obps/services/selfApprovalPortal`
        }, flags.selfApprovalNonScheme && {
          name: "Non-Scheme Residential upto 300 Sqmt.",
          path: `${citizenBaseUrl$1}/obps/services/selfApprovalPortal`
        }].filter(Boolean)
      }].filter(Boolean)
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/mapSubApplications`
    }, {
      name: t("FASTPAS.GLOBAL.COMPOUNDING.APP.TEXT"),
      path: `${citizenBaseUrl$1}/obps/compoundingApplications`
    }]
  }, flags.plinth && {
    title: t('FASTPAS.GLOBAL.PLINTH.SUB.TEXT'),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/plinthPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/plinthApplications`
    }]
  }, flags.landUseConversion && {
    title: t("FASTPAS.GLOBAL.LAND.USE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.INV.SUGG.OBJ.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/formSuggestion`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formLandUseConversionApplications`
    }, {
      name: t("FASTPAS.GLOBAL.MY.SUG.APP.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formSuggestionApplications`
    }]
  }, flags.workCommencement && {
    title: t("FASTPAS.GLOBAL.WORK.COM.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/WorkCommencementModule`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/WorkCommencementModule`
    }]
  }, flags.completion && {
    title: t("FASTPAS.GLOBAL.COMPLETITION.MODULE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/completionPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/completionApplications`
    }]
  }, flags.purchasableFar && {
    title: t("FASTPAS.GLOBAL.PUR.FAR.MODULE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/purchasablePortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/pFARApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.MAKEPAYMENT.TEXT"),
    path: `${citizenBaseUrl$1}/obps/Payment/Applications`
  }].filter(Boolean);
  let menuItems = [];
  if (isCitizen) {
    menuItems = allMenuItems.filter(item => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else if (isOwner) {
    menuItems = allMenuItems.map(item => {
      var _item$subItems2;
      if (item.title === t("FASTPAS.GLOBAL.LTP.TEXT") || item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") || item.title === t("FASTPAS.GLOBAL.LAND.USE.TEXT")) {
        return item;
      }
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        var _item$subItems;
        return {
          ...item,
          subItems: item === null || item === void 0 ? void 0 : (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.map(subItem => {
            if (subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT") && subItem.subItems) {
              var _subItem$subItems;
              return {
                ...subItem,
                subItems: subItem === null || subItem === void 0 ? void 0 : (_subItem$subItems = subItem.subItems) === null || _subItem$subItems === void 0 ? void 0 : _subItem$subItems.filter(nested => {
                  var _nested$name;
                  return nested === null || nested === void 0 ? void 0 : (_nested$name = nested.name) === null || _nested$name === void 0 ? void 0 : _nested$name.includes("Self Certification via Registration");
                })
              };
            }
            return subItem;
          })
        };
      }
      return {
        ...item,
        subItems: item === null || item === void 0 ? void 0 : (_item$subItems2 = item.subItems) === null || _item$subItems2 === void 0 ? void 0 : _item$subItems2.filter(subItem => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT"))
      };
    });
  } else if (isLtp) {
    menuItems = allMenuItems.map(item => {
      if (item.title === t("FASTPAS.GLOBAL.LTP.TEXT")) {
        var _item$subItems3;
        return {
          ...item,
          subItems: item === null || item === void 0 ? void 0 : (_item$subItems3 = item.subItems) === null || _item$subItems3 === void 0 ? void 0 : _item$subItems3.filter(subItem => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT"))
        };
      }
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        return {
          ...item,
          subItems: item.subItems.map(menu => {
            if (menu.name === t("FASTPAS.GLOBAL.APPLY.TEXT")) {
              return {
                ...menu,
                subItems: menu.subItems.filter(subItem => subItem.name !== "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)")
              };
            }
            return menu;
          })
        };
      }
      return item;
    });
  } else if (expiredLTP) {
    menuItems = allMenuItems.filter(item => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else {
    menuItems = allMenuItems;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SidebarContainer, {
    collapsed: collapsed
  }, /*#__PURE__*/React__default.createElement(SidebarHeader, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "sidebr-logo mr-3",
    src: "https://cdn.s3waas.gov.in/s3310dcbbf4cce62f762a2aaa148d556bd/uploads/2018/02/2018022129.png"
  }), /*#__PURE__*/React__default.createElement(HeaderTitle$1, null, "FASTPAS")), /*#__PURE__*/React__default.createElement(HamburgerIcon, {
    onClick: toggleSidebar
  })), /*#__PURE__*/React__default.createElement(MenuWrapper$1, {
    collapsed: collapsed,
    className: "all-menu-wrapper"
  }, menuItems.map(item => /*#__PURE__*/React__default.createElement("div", {
    key: item.title,
    className: history.location.pathname === item.path ? "single-node active" : "single-node"
  }, item.subItems ?
  /*#__PURE__*/
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MenuItem$1, {
    onClick: () => toggleItem(item.title)
  }, /*#__PURE__*/React__default.createElement(MenuItemTitle, null, item.title), /*#__PURE__*/React__default.createElement("div", null, expandedItems[item.title] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedItems[item.title] && /*#__PURE__*/React__default.createElement("div", null, item.subItems.map(subItem => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: subItem.name
  }, subItem.subItems ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      toggleSubItem(item.title, subItem.name);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, subItem.name), /*#__PURE__*/React__default.createElement("div", null, expandedSubItems[`${item.title}-${subItem.name}`] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedSubItems[`${item.title}-${subItem.name}`] && /*#__PURE__*/React__default.createElement("div", null, subItem.subItems.map(nestedSubItem => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: nestedSubItem.name
  }, nestedSubItem.subItems ?
  /*#__PURE__*/
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NestedSubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      toggleSubItem(`${item.title}-${subItem.name}`, nestedSubItem.name);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, nestedSubItem.name), /*#__PURE__*/React__default.createElement("div", null, expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] && /*#__PURE__*/React__default.createElement("div", null, nestedSubItem.subItems.map(deeperNestedSubItem => /*#__PURE__*/React__default.createElement(NestedSubMenuItem, {
    key: deeperNestedSubItem.name,
    onClick: e => {
      e.stopPropagation();
      const keysToRemove = deeperNestedSubItem.name.includes("Scheme") ? ["OWNER_INFO", "FASTPAS_ID", "FILE_NO"] : [];
      handleNavigation(deeperNestedSubItem.path, {}, keysToRemove);
    },
    className: history.location.pathname === deeperNestedSubItem.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === deeperNestedSubItem.path
  }, /*#__PURE__*/React__default.createElement("span", null, deeperNestedSubItem.name))))) :
  /*#__PURE__*/
  React__default.createElement(NestedSubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      handleNavigation(nestedSubItem.path);
    },
    className: history.location.pathname === nestedSubItem.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === nestedSubItem.path
  }, /*#__PURE__*/React__default.createElement("span", null, nestedSubItem.name)))))) : /*#__PURE__*/React__default.createElement(SubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      const isLandUseApply = item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") && subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT");
      if (isOwner && isLandUseApply) {
        setPendingNavigation({
          path: subItem.path,
          state: {},
          keysToRemove: ["FORMLANDUSE"]
        });
        setShowPopup(true);
        return;
      }
      const keysToRemove = isLandUseApply ? ["FORMLANDUSE"] : [];
      if (subItem.name === "Reapply") {
        handleNavigation(subItem.path, {
          reapply: true
        }, keysToRemove);
      } else {
        handleNavigation(subItem.path, {}, keysToRemove);
      }
    }
  }, /*#__PURE__*/React__default.createElement("span", null, subItem.name)))))) :
  /*#__PURE__*/
  React__default.createElement(MenuItem$1, {
    onClick: () => handleNavigation(item.path),
    className: history.location.pathname === item.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === item.path
  }, /*#__PURE__*/React__default.createElement(MenuItemTitle, null, item.title)))))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: styles.overlay
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.noticeBox
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.title
  }, "Notice"), /*#__PURE__*/React__default.createElement("div", {
    style: styles.message
  }, "This land use verification is not applicable for map submission."), /*#__PURE__*/React__default.createElement("button", {
    style: styles.button,
    onClick: () => {
      setShowPopup(false);
      if (pendingNavigation) {
        handleNavigation(pendingNavigation.path, pendingNavigation.state, pendingNavigation.keysToRemove);
        setPendingNavigation(null);
      }
    }
  }, "OK"))));
};

const InboxGeneral = {
  Search: ({
    ...filters
  }) => {
    return Request$1({
      url: Urls.InboxSearch,
      useCache: false,
      method: "POST",
      auth: true,
      userService: true,
      data: {
        ...filters
      }
    });
  }
};

const TopBar = ({
  userDetails,
  applicationDetail,
  toggleSidebar,
  collapsed
}) => {
  var _applicationDetail$la, _applicationDetail$la2, _applicationDetail$la3, _applicationDetail$la4, _applicationDetail$la5, _applicationDetail$la6, _applicationDetail$la7, _applicationDetail$la8, _applicationDetail$la9, _applicationDetail$la10, _applicationDetail$la11, _applicationDetail$la12;
  const stateId = Digit.ULBService.getStateId();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [count, setCount] = useState(0);
  const dropdownRef = useRef(null);
  const history = useHistory();
  const ownerName = Digit.SessionStorage.get("OWNER_INFO");
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleEditProfile = () => {
    history.push("/digit-ui/citizen/user/account");
    setIsDropdownOpen(false);
  };
  const handleDashboard = () => {
    history.push("/digit-ui/citizen/profile");
    setIsDropdownOpen(false);
  };
  const filters = {
    tenantId: stateId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: ["BPA_LANDUSE_DA", "BPA_FAR_DA", "BPA_MAPSUB_DA"]
    },
    moduleSearchCriteria: {
      sortBy: "applicationDate",
      sortOrder: "ASC"
    },
    limit: 2999,
    offset: 0
  };
  const handleLogout = () => {
    Digit.UserService.logout();
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    const fetchAndSetUserDetails = async () => {
      try {
        var _inboxData$statusMap;
        const inboxData = await InboxGeneral.Search({
          inbox: {
            ...filters
          }
        });
        console.log(inboxData, "inboxData");
        const filteredData = inboxData === null || inboxData === void 0 ? void 0 : (_inboxData$statusMap = inboxData.statusMap) === null || _inboxData$statusMap === void 0 ? void 0 : _inboxData$statusMap.filter(item => item.applicationstatus === "UPLOAD_DOC" || item.applicationstatus === "REVERT_TO_APPLICANT");
        const inboxCount = filteredData === null || filteredData === void 0 ? void 0 : filteredData.reduce((acc, item) => acc + ((item === null || item === void 0 ? void 0 : item.count) || 0), 0);
        console.log({
          inboxCount,
          filteredData
        }, "inboxxx");
        setCount(inboxCount);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setCount(0);
      }
    };
    fetchAndSetUserDetails();
  }, []);
  return /*#__PURE__*/React__default.createElement(TopBarContainer$1, null, /*#__PURE__*/React__default.createElement(TopBarLeft, null, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: collapsed ? ArrowForwardIos : ArrowBackIos,
    title: "Back",
    onClick: toggleSidebar,
    style: {
      color: "white"
    }
  }), /*#__PURE__*/React__default.createElement(TopBarName, {
    className: "text-white"
  }, ((applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la = applicationDetail.landInfo) === null || _applicationDetail$la === void 0 ? void 0 : (_applicationDetail$la2 = _applicationDetail$la.owners) === null || _applicationDetail$la2 === void 0 ? void 0 : (_applicationDetail$la3 = _applicationDetail$la2[0]) === null || _applicationDetail$la3 === void 0 ? void 0 : _applicationDetail$la3.name) || ownerName) && "Owner:"), /*#__PURE__*/React__default.createElement(TopBarValidity, {
    className: "text-white"
  }, (applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la4 = applicationDetail.landInfo) === null || _applicationDetail$la4 === void 0 ? void 0 : (_applicationDetail$la5 = _applicationDetail$la4.owners) === null || _applicationDetail$la5 === void 0 ? void 0 : (_applicationDetail$la6 = _applicationDetail$la5[0]) === null || _applicationDetail$la6 === void 0 ? void 0 : _applicationDetail$la6.name) || ownerName), /*#__PURE__*/React__default.createElement(TopBarName, {
    className: "text-white"
  }, (applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la7 = applicationDetail.landInfo) === null || _applicationDetail$la7 === void 0 ? void 0 : (_applicationDetail$la8 = _applicationDetail$la7.owners) === null || _applicationDetail$la8 === void 0 ? void 0 : (_applicationDetail$la9 = _applicationDetail$la8[0]) === null || _applicationDetail$la9 === void 0 ? void 0 : _applicationDetail$la9.mobileNumber) && "Mobile No:"), /*#__PURE__*/React__default.createElement(TopBarValidity, {
    className: "text-white"
  }, applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la10 = applicationDetail.landInfo) === null || _applicationDetail$la10 === void 0 ? void 0 : (_applicationDetail$la11 = _applicationDetail$la10.owners) === null || _applicationDetail$la11 === void 0 ? void 0 : (_applicationDetail$la12 = _applicationDetail$la11[0]) === null || _applicationDetail$la12 === void 0 ? void 0 : _applicationDetail$la12.mobileNumber), (applicationDetail === null || applicationDetail === void 0 ? void 0 : applicationDetail.land_Id) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-white"
  }, "FASTPAS ID: "), /*#__PURE__*/React__default.createElement("span", {
    className: "text-white"
  }, applicationDetail.land_Id))), /*#__PURE__*/React__default.createElement(TopBarRight, {
    className: "top-right-icon-sec"
  }, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: Fullscreen,
    title: "Fullscreen",
    onClick: () => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    }
  }), /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: FaQuestionCircle,
    title: "Helpdesk",
    onClick: () => window.open("https://mainet.abmindia.com/training/", "_blank", "noopener,noreferrer")
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef,
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: FaUser,
    title: "User",
    onClick: () => setIsDropdownOpen(!isDropdownOpen)
  }), isDropdownOpen && /*#__PURE__*/React__default.createElement(DropdownMenu, null, /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleDashboard
  }, t("FASTPAS.DASHBOARD.MAIN.TEXT")), /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleEditProfile
  }, "Edit Profile"), /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleLogout
  }, "Logout")))));
};

const StyledTableCell$3 = styled(TableCell$1)(({
  theme
}) => ({
  fontWeight: "bold",
  backgroundColor: "#1f4a7c",
  color: theme.palette.common.white,
  "& .MuiTableSortLabel-root": {
    color: "white",
    "&:hover": {
      color: "white"
    },
    "&.Mui-active": {
      color: "white"
    }
  },
  "& .MuiInput-root": {
    "&:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.42)"
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "white"
    },
    "&:after": {
      borderBottomColor: "white"
    },
    "& input": {
      color: "white",
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.7)"
      }
    }
  },
  "& .MuiSvgIcon-root": {
    color: "white"
  }
}));
const StyledTableRow$3 = styled(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const SmallTableCell = styled(TableCell$1)({
  fontSize: "0.75rem",
  padding: "8px 12px"
});
const getApplicationUrl = applicationNo => {
  if (!applicationNo) return "#";
  const parts = applicationNo.split("/");
  const typeCode = parts[2];
  switch (typeCode) {
    case "MS":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    case "LU":
      return `/digit-ui/citizen/obps/structural/formLandUse/${applicationNo}`;
    case "PF":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    case "CC":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    default:
      return "#";
  }
};
const EnhancedTable = ({
  data,
  isLoading,
  tenantId
}) => {
  const {
    t
  } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [filters, setFilters] = useState({
    name: "",
    architect: "",
    plotArea: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: "",
    date: "",
    schemeName: ""
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
    Digit.SessionStorage.del("EDCR_CREATE");
    Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
    Digit.SessionStorage.del("FORM_SELF_RESIDENTIAL");
    Digit.SessionStorage.del("SELF_CURRENT_TAB");
    Digit.SessionStorage.del("FORM_KYP");
    Digit.SessionStorage.del("FORM_SELF_APPROVAL");
    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
      Digit.SessionStorage.set("FILE_COUNT", data === null || data === void 0 ? void 0 : data.length);
    }
  }, []);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    sortable: false,
    render: (item, index) => page * rowsPerPage + index + 1,
    width: "5%"
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
      return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name) || "-";
    },
    width: "12%"
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2;
      return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "-";
    },
    width: "10%"
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    render: item => /*#__PURE__*/React__default.createElement("strong", {
      onClick: e => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2;
        e.preventDefault();
        window.location.href = getApplicationUrl(item === null || item === void 0 ? void 0 : item.applicationNo);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
      },
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"),
    width: "10%"
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    render: item => t(item === null || item === void 0 ? void 0 : item.applicationType) || "-",
    width: "10%"
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    render: item => {
      var _item$auditDetails;
      return convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || "-";
    },
    width: "10%"
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})` || `-`;
      }
      return t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || `-`;
    },
    width: "13%"
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo4$owner3, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$applicationNo, _item$applicationType, _item$auditDetails2, _t;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : (_item$landInfo4$owner3 = _item$landInfo4$owner2.name) === null || _item$landInfo4$owner3 === void 0 ? void 0 : _item$landInfo4$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return parseInt(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber) || 0;
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return (item === null || item === void 0 ? void 0 : (_item$applicationType = item.applicationType) === null || _item$applicationType === void 0 ? void 0 : _item$applicationType.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || 0;
          case "status":
            return ((_t = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = data || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$professionaldet, _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$auditDetails3;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : _item$landInfo6$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$professionaldet = item.professionaldetails) === null || _item$professionaldet === void 0 ? void 0 : _item$professionaldet.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.plotArea, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.schemeName, globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name, filters.name);
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber, filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, filters.applicationNo));
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, filters.applicationType));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.status, filters.status));
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const filteredAndSortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "My Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: '#fff'
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    "aria-label": "enhanced table",
    size: "small",
    className: "citizen-application-table",
    style: {
      tableLayout: "fixed",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    style: {
      width: column.width
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  }))))), /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, isLoading ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "Loading...")) : paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `${index}-${column.id}`,
    style: {
      width: column.width,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      verticalAlign: "top"
    }
  }, column.render(item, index)))))))), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: filteredAndSortedData.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const BPACommonSearchApp = () => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data,
    isLoading: loader
  } = Digit.Hooks.obps.useBPASearch(tenantId);
  if (loader) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EnhancedTable, {
    data: data,
    isLoading: loader,
    tenantId: tenantId
  }));
};

function UploadDrawer({
  setProfilePic,
  closeDrawer,
  userType,
  removeProfilePic,
  showToast
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState("");
  const [error, setError] = useState(null);
  const {
    t
  } = useTranslation();
  const selectfile = e => setFile(e.target.files[0]);
  const removeimg = () => {
    removeProfilePic();
    closeDrawer();
  };
  const onOverlayBodyClick = () => closeDrawer();
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 1000000) {
          showToast("error", t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
          setError(t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage(`${userType}-profile`, file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              const fileStoreId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId;
              setUploadedFile(fileStoreId);
              setProfilePic(fileStoreId);
            } else {
              showToast("error", t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
              setError(t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            showToast("error", t("CORE_COMMON_PROFILE_INVALID_FILE_INPUT"));
          }
        }
      }
    })();
  }, [file]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      width: "100%",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,.5)"
    },
    onClick: onOverlayBodyClick
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
      backgroundColor: "white",
      alignItems: "center",
      position: "fixed",
      left: "0",
      right: "0",
      height: "20%",
      bottom: userType === "citizen" ? "2.5rem" : "0",
      zIndex: "2"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    for: "file",
    style: {
      cursor: "pointer"
    }
  }, " ", /*#__PURE__*/React__default.createElement(GalleryIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, " Gallery"), /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    id: "file",
    accept: "image/*, .png, .jpeg, .jpg",
    onChange: selectfile,
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: removeimg
  }, /*#__PURE__*/React__default.createElement(RemoveIcon$2, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, "Remove"))));
}

function SinatureDrawer({
  setSignaturePic,
  closeDrawer,
  userType,
  removeProfilePic,
  showToast
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState("");
  const [error, setError] = useState(null);
  const {
    t
  } = useTranslation();
  const selectfile = e => setFile(e.target.files[0]);
  const removeimg = () => {
    removeProfilePic();
    closeDrawer();
  };
  const onOverlayBodyClick = () => closeDrawer();
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 1000000) {
          showToast("error", t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
          setError(t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage(`${userType}-profile`, file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              const fileStoreId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId;
              setUploadedFile(fileStoreId);
              setSignaturePic(fileStoreId);
            } else {
              showToast("error", t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
              setError(t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            showToast("error", t("CORE_COMMON_PROFILE_INVALID_FILE_INPUT"));
          }
        }
      }
    })();
  }, [file]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      width: "100%",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,.5)"
    },
    onClick: onOverlayBodyClick
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
      backgroundColor: "white",
      alignItems: "center",
      position: "fixed",
      left: "0",
      right: "0",
      height: "20%",
      bottom: userType === "citizen" ? "2.5rem" : "0",
      zIndex: "2"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    for: "file",
    style: {
      cursor: "pointer"
    }
  }, " ", /*#__PURE__*/React__default.createElement(GalleryIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, " Gallery"), /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    id: "file",
    accept: "image/*, .png, .jpeg, .jpg",
    onChange: selectfile,
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: removeimg
  }, /*#__PURE__*/React__default.createElement(RemoveIcon$2, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, "Remove"))));
}

const defaultImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO4AAADUCAMAAACs0e/bAAAAM1BMVEXK0eL" + "/" + "/" + "/" + "/Dy97GzuD4+fvL0uPg5O7T2efb4OvR1+Xr7vTk5/Df4+37/P3v8fbO1eTt8PUsnq5FAAAGqElEQVR4nO2d25ajIBBFCajgvf/" + "/a0eMyZgEjcI5xgt7Hmatme507UaxuJXidiDqjmSgeVIMlB1ZR1WZAf2gbdu0QwixSYzjOJPmHurfEGEfY9XzjNGG9whQCeVAuv5xQEySLtR9hPuIcwj0EeroN5m3D1IbsbgHK0esiQ9MKs" + "qXVr8Hm/a/Pulk6wihpCIXBw3dh7bTvRBt9+dC5NfS1VH3xETdM3MxXRN1T0zUPTNR98xcS1dlV9NNfx3DhkTdM6PKqHteVBF1z0vU5f0sKdpc2zWLKutXrjJjdLvpesRmukqYonauPhXpds" + "Lb6CppmpnltsYIuY2yavi6Mi2/rzAWm1zUfF0limVLqkZyA+mDYevKBS37aGC+L1lX5e7uyU1Cv565uiua9k5LFqbqqrnu2I3m+jJ11ZoLeRtfmdB0Uw/ZDsP0VTxdn7a1VERfmq7Xl" + "Xyn5D2QWLoq8bZlPoBJumphJjVBw/Ll6CoTZGsTDs4NrGqKbqBth8ZHJUi6cn168QmleSm6GmB7Kxm+6obXlf7PoDHosCwM3QpiS2legi6ocSl3L0G3BdneDDgwQdENfeY+SfDJBkF37Z" + "B+GvwzA6/rMaafAn8143VhPZWdjMWG1oHXhdnemgPoAvLlB/iZyRTfVeF06wPoQhJmlm4bdcOAZRlRN5gcPc5SoPEQR1fDdbOo6wn+uYvXxY0QCLom6gYROKH+Aj5nvphuFXWDiLpRdxl" + "/19LFT95k6CHCrnW7pCDqBn1i1PUFvii2c11oZOJ6usWeH0RRNzC4Zs+6FTi2nevCVwCjbugnXklX5fkfTldL8PEilUB1kfNyN1u9MME2sATr4lbuB7AjfLAuvsRm1A0g6gYRdcPAjvBlje" + "2Z8brI8OC68AcRdlCkwLohx2mcZMjw9q+LzarQurjtnwPYAydX08WecECO/u6Ad0GBdYG7jO5gB4Ap+PwKcA9ZT43dn4/W9TyiPAn4OAJaF7h3uwe8StSCddFdM3jqFa2LvnnB5zzhuuBBAj" + "Y4gi50cg694gnXhTYvfMdrjtcFZhrwE9r41gUem8IXWMC3LrBzxh+a0gRd1N1LOK7M0IUUGuggvEmHoStA2/MJh7MpupiDU4TzjhxdzLAoO4ouZvqVURbFMHQlZD6SUeWHoguZsSLUGegreh" + "A+FZFowPdUWTi6iMoZlIpGGUUXkDbjj/9ZOLqAQS/+GIKl5BQOCn/ycqpzkXSDm5dU7ZWkG7wUyGlcmm7g5Ux56AqirgoaJ7BeokPTDbp9CbVunjFxPrl7+HqnkrSq1Da7JX20f3dV8yJi6v" + "oO81mX8vV0mx3qUsZCPRfTlVRdz2EvdufYGDvNQvvwqHtmXd+a1ITinwNcXc+lT6JuzdT1XDyBn/x7wtX1HCQQdW9MXc8xArGrirowfLeUEbMqqq6f7TF1lfRdOuGNiGi6SpT+WxY06xUfNN" + "2wBfyE9I4tlm7w5hvOPDNJN3yNiLMipji6gE3chKhouoCtN5x3QlF0EZt8OW/8ougitqJQlk1aii7iFC9l0MvRReyao7xNjKML2Z/PuHlzhi5mFxljiZeiC9rPTEisNEMX9KYAwo5Xhi7qaA" + "3hamboYm7dG+NVrXhdaYDv5zFaQZsYrCtbbAGnjkQDX2+J1FXCwOsqWOpKoIQNTFdqYBWydxqNqUoG0pVpCS+H8kaJaGKErlIaXj7CRRE+gRWuKwW9YZ80oVOUgbpdT0zpnSZJTIiwCtJVelv" + "Xntr4P5j6BWfPb5Wcx84C4cq3hb11lco2u2Mdwp6XdJ/Ne3wb8DWdfiRenZaXrhLwOj4e+GQeHroy3YOspS7TlU28Wle2m2QUS0mqdcbrdNW+ZHsSsyK7tBfm0q/dWcv+Z3mytVx3t7KWulq" + "Ue6ilunu8jF8pFwgv1FXp3mUt35OtRbr7eM4u4Gs6vUBXgeuHc5kfE/cbvWZtkROLm1DMtLCy80tzsu2PRj0hTI8fvrQuvsjlJkyutszq+m423wHaLTyniy/XuiGZ84LuT+m5ZfNfRxyGs7L" + "XZOvia7VujatUwVTrIt+Q/Csc7Tuhe+BOakT10b4TuoiiJjvgU9emTO42PwEfBa+cuodKkuf42DXr1D3JpXz73Hnn0j10evHKe+nufgfUm+7B84sX9FfdEzXux2DBpWuKokkCqN/5pa/8pmvn" + "L+RGKCddCGmatiPyPB/+ekO/M/q/7uvbt22kTt3zEnXPzCV13T3Gel4/6NduDu66xRvlPNkM1RjjxUdv+4WhGx6TftD19Q/dfzpwcHO+rE3fAAAAAElFTkSuQmCC";
const defaultSignatureImg = "https://www.jsign.com/wp-content/uploads/2021/06/icon-tablet-signature-pen.svg";
const UserProfile = ({
  stateCode,
  userType,
  cityDetails
}) => {
  var _Digit$UserService$ge, _userDetails$permanen, _errors$userName, _errors$emailAddress, _errors$mobileNumber, _errors$userName2, _errors$mobileNumber2, _errors$emailAddress2, _errors$currentPasswo, _errors$newPassword, _errors$confirmPasswo;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const tenant = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [userDetails, setUserDetails] = useState(null);
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const cityCode = tenant.includes("da") ? "da" : "avp";
  const districts = !isLoading ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return !((_city$code = city.code) !== null && _city$code !== void 0 && _city$code.includes("up"));
  }) : [];
  const [name, setName] = useState(userInfo !== null && userInfo !== void 0 && userInfo.name ? userInfo.name : "");
  const [email, setEmail] = useState(userInfo !== null && userInfo !== void 0 && userInfo.emailId ? userInfo.emailId : "");
  const [gender, setGender] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender);
  const [city, setCity] = useState(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen = userDetails.permanentAddress) === null || _userDetails$permanen === void 0 ? void 0 : _userDetails$permanen.district);
  const [mobileNumber, setMobileNo] = useState(userInfo !== null && userInfo !== void 0 && userInfo.mobileNumber ? userInfo.mobileNumber : "");
  const [profilePic, setProfilePic] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.photo);
  const [signaturePic, setSignaturePic] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.signature);
  const [profileImg, setProfileImg] = useState("");
  const [signatureImg, SetSignatureImg] = useState(userDetails !== null && userDetails !== void 0 && userDetails.signature ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.signature : "");
  const [openUploadSlide, setOpenUploadSide] = useState(false);
  const [openSignatureUploadSlide, setOpenSignatureUploadSide] = useState(false);
  const [changepassword, setChangepassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = React__default.useState(window.innerWidth);
  const [errors, setErrors] = React__default.useState({});
  const isCitizen = Digit.UserService.getType();
  console.log(isCitizen, "isCitizennnn");
  const getUserInfo = async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, {
        uuid: [uuid]
      }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };
  React__default.useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    return () => {
      window.removeEventListener("resize", () => setWindowWidth(window.innerWidth));
    };
  });
  useEffect(() => {
    var _userDetails$permanen2, _userDetails$permanen3, _userDetails$photo, _userDetails$signatur;
    setLoading(true);
    getUserInfo();
    setGender({
      i18nKey: undefined,
      code: userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender,
      value: userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender
    });
    setCity({
      i18nKey: null,
      code: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen2 = userDetails.permanentAddress) === null || _userDetails$permanen2 === void 0 ? void 0 : _userDetails$permanen2.district,
      name: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen3 = userDetails.permanentAddress) === null || _userDetails$permanen3 === void 0 ? void 0 : _userDetails$permanen3.district
    });
    const thumbs = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$photo = userDetails.photo) === null || _userDetails$photo === void 0 ? void 0 : _userDetails$photo.split(",");
    setProfileImg(thumbs === null || thumbs === void 0 ? void 0 : thumbs.at(0));
    const thumbSignature = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$signatur = userDetails.signature) === null || _userDetails$signatur === void 0 ? void 0 : _userDetails$signatur.split(",");
    SetSignatureImg(thumbSignature === null || thumbSignature === void 0 ? void 0 : thumbSignature.at(0));
    setLoading(false);
  }, [userDetails !== null]);
  let validation = {};
  const editScreen = false;
  const onClickAddPic = () => setOpenUploadSide(!openUploadSlide);
  const onClickAddSignature = () => setOpenSignatureUploadSide(!openSignatureUploadSlide);
  const TogleforPassword = () => setChangepassword(!changepassword);
  const setGenderName = value => setGender(value);
  const setCityName = value => setCity({
    i18nKey: value === null || value === void 0 ? void 0 : value.i18nKey,
    code: value === null || value === void 0 ? void 0 : value.name,
    name: value === null || value === void 0 ? void 0 : value.name
  });
  const closeFileUploadDrawer = () => setOpenUploadSide(false);
  const closeFileSignaturDrawer = () => setOpenSignatureUploadSide(false);
  const setUserName = value => {
    setName(value);
    if (!new RegExp(/^[a-zA-Z ]+$/i).test(value) || value.length === 0 || value.length > 50) {
      setErrors({
        ...errors,
        userName: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_NAME_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        userName: null
      });
    }
  };
  const setUserEmailAddress = value => {
    setEmail(value);
    if (value.length && !(value.includes("@") && value.includes("."))) {
      setErrors({
        ...errors,
        emailAddress: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_EMAIL_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        emailAddress: null
      });
    }
  };
  const setUserMobileNumber = value => {
    setMobileNo(value);
    if (userType === "employee" && !new RegExp(/^[6-9]{1}[0-9]{9}$/).test(value)) {
      setErrors({
        ...errors,
        mobileNumber: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        mobileNumber: null
      });
    }
  };
  const setUserCurrentPassword = value => {
    setCurrentPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        currentPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        currentPassword: null
      });
    }
  };
  const setUserNewPassword = value => {
    setNewPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        newPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        newPassword: null
      });
    }
  };
  const setUserConfirmPassword = value => {
    setConfirmPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        confirmPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        confirmPassword: null
      });
    }
  };
  const removeProfilePic = () => {
    setProfilePic(null);
    setProfileImg(null);
  };
  const removeSignaturePic = () => {
    setSignaturePic(null);
    SetSignatureImg(null);
  };
  const showToast = (type, message, duration = 5000) => {
    setToast({
      key: type,
      action: message
    });
    setTimeout(() => {
      setToast(null);
    }, duration);
  };
  const updateProfile = async () => {
    setLoading(true);
    try {
      const requestData = {
        ...userInfo,
        validUpto: userDetails === null || userDetails === void 0 ? void 0 : userDetails.validUpto,
        name,
        gender: gender === null || gender === void 0 ? void 0 : gender.value,
        emailId: email,
        photo: profilePic || profileImg,
        signature: signaturePic || signatureImg,
        mobileNumber: mobileNumber,
        userName: userType === "employee" ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName : mobileNumber,
        permanentAddress: {
          district: city === null || city === void 0 ? void 0 : city.name,
          address: city === null || city === void 0 ? void 0 : city.name,
          type: "PERMANENT"
        }
      };
      if (!new RegExp(/^([a-zA-Z ])*$/).test(name) || name === "" || name.length > 50 || name.length < 1) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_NAME_INVALID"
        });
      }
      if (userType === "employee" && !new RegExp(/^[6-9]{1}[0-9]{9}$/).test(mobileNumber)) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID"
        });
      }
      if (email.length && !(email.includes("@") && email.includes("."))) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_EMAIL_INVALID"
        });
      }
      if (currentPassword.length || newPassword.length || confirmPassword.length) {
        if (newPassword !== confirmPassword) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_MISMATCH"
          });
        }
        if (!(currentPassword.length && newPassword.length && confirmPassword.length)) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
          });
        }
        if (!new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(newPassword) && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(confirmPassword)) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
          });
        }
      }
      const {
        responseInfo,
        user
      } = await Digit.UserService.updateUser(requestData, stateCode);
      if (responseInfo && responseInfo.status === "200") {
        const _user = Digit.UserService.getUser();
        if (_user) {
          Digit.UserService.setUser({
            ..._user,
            info: {
              ..._user.info,
              name,
              mobileNumber,
              emailId: email,
              permanentCity: city === null || city === void 0 ? void 0 : city.name
            }
          });
        }
      }
      if (currentPassword.length && newPassword.length && confirmPassword.length) {
        const _requestData = {
          existingPassword: currentPassword,
          newPassword: newPassword,
          tenantId: tenant,
          type: "EMPLOYEE",
          userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName,
          confirmPassword: confirmPassword
        };
        if (newPassword === confirmPassword) {
          try {
            const res = await Digit.UserService.changePassword(_requestData, tenant);
            const {
              responseInfo: changePasswordResponseInfo
            } = res;
            if (changePasswordResponseInfo !== null && changePasswordResponseInfo !== void 0 && changePasswordResponseInfo.status && changePasswordResponseInfo.status === "200") {
              showToast("success", t("CORE_COMMON_PROFILE_UPDATE_SUCCESS_WITH_PASSWORD"), 5000);
            } else {
              throw "";
            }
          } catch (error) {
            var _error$Errors, _error$Errors$at;
            throw JSON.stringify({
              type: "error",
              message: (_error$Errors = error.Errors) !== null && _error$Errors !== void 0 && (_error$Errors$at = _error$Errors.at(0)) !== null && _error$Errors$at !== void 0 && _error$Errors$at.description ? error.Errors.at(0).description : "CORE_COMMON_PROFILE_UPDATE_ERROR_WITH_PASSWORD"
            });
          }
        } else {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_ERROR_PASSWORD_NOT_MATCH"
          });
        }
      } else if (responseInfo !== null && responseInfo !== void 0 && responseInfo.status && responseInfo.status === "200") {
        showToast("success", t("CORE_COMMON_PROFILE_UPDATE_SUCCESS"), 5000);
      }
    } catch (error) {
      const errorObj = JSON.parse(error);
      showToast(errorObj.type, t(errorObj.message), 5000);
    }
    setLoading(false);
  };
  let menu = [];
  const {
    data: Menu
  } = Digit.Hooks.pt.useGenderMDMS(stateId, "common-masters", "GenderType");
  Menu && Menu.map(genderDetails => {
    menu.push({
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`,
      code: `${genderDetails.code}`,
      value: `${genderDetails.code}`
    });
  });
  const setFileStoreId = async fileStoreId => {
    const thumbnails = fileStoreId ? await getThumbnails([fileStoreId], stateId) : null;
    setProfilePic(fileStoreId);
    setProfileImg(fileStoreId);
    closeFileUploadDrawer();
  };
  const setFileStoreSignature = async fileStoreId => {
    const thumbnailSignature = fileStoreId ? await getThumbnailSignature([fileStoreId], stateId) : null;
    setSignaturePic(fileStoreId);
    SetSignatureImg(fileStoreId);
    setOpenSignatureUploadSide();
  };
  const getThumbnailSignature = async (ids, tenantId) => {
    const res = await Digit.UploadServices.Filefetch(ids, tenantId);
    if (res.data.fileStoreIds && res.data.fileStoreIds.length !== 0) {
      return {
        thumbs: res.data.fileStoreIds.map(o => o.url.split(",")[3]),
        images: res.data.fileStoreIds.map(o => Digit.Utils.getFileUrl(o.url))
      };
    } else {
      return null;
    }
  };
  const getThumbnails = async (ids, tenantId) => {
    const res = await Digit.UploadServices.Filefetch(ids, tenantId);
    if (res.data.fileStoreIds && res.data.fileStoreIds.length !== 0) {
      return {
        thumbs: res.data.fileStoreIds.map(o => o.url.split(",")[3]),
        images: res.data.fileStoreIds.map(o => Digit.Utils.getFileUrl(o.url))
      };
    } else {
      return null;
    }
  };
  if (loading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("section", {
    style: {
      margin: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: 1,
      flexDirection: windowWidth < 768 || userType === "citizen" ? "column" : "row",
      margin: userType === "citizen" ? "8px" : "16px",
      gap: userType === "citizen" ? "" : "0 24px",
      boxShadow: userType === "citizen" ? "1px 1px 4px 0px rgba(0,0,0,0.2)" : "",
      background: userType === "citizen" ? "white" : "",
      borderRadius: userType === "citizen" ? "4px" : ""
    }
  }, /*#__PURE__*/React__default.createElement("section", {
    style: {
      position: "relative",
      display: "flex",
      flex: userType === "citizen" ? 1 : 2.5,
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "50%",
      height: "376px",
      borderRadius: "4px",
      boxShadow: userType === "citizen" ? "" : "1px 1px 4px 0px rgba(0,0,0,0.2)",
      border: `${userType === "citizen" ? "8px" : "24px"} solid #fff`,
      background: "#EEEEEE",
      padding: userType === "citizen" ? "8px" : "16px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      height: userType === "citizen" ? "114px" : "150px",
      width: userType === "citizen" ? "114px" : "150px",
      margin: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    style: {
      margin: "auto",
      borderRadius: "300px",
      justifyContent: "center",
      height: "100%",
      width: "100%"
    },
    src: !profileImg || profileImg === "" ? defaultImage : profileImg
  }), /*#__PURE__*/React__default.createElement("button", {
    style: {
      position: "absolute",
      left: "50%",
      bottom: "-24px",
      transform: "translateX(-50%)"
    },
    onClick: onClickAddPic
  }, /*#__PURE__*/React__default.createElement(CameraIcon, null))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      height: userType === "citizen" ? "114px" : "150px",
      width: userType === "citizen" ? "114px" : "150px",
      margin: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    style: {
      margin: "auto",
      borderRadius: "30px",
      justifyContent: "center",
      height: "100%",
      width: "100%"
    },
    src: !signatureImg || signatureImg === "" ? defaultSignatureImg : signatureImg
  }), /*#__PURE__*/React__default.createElement("button", {
    style: {
      color: "#1f4a7c"
    },
    onClick: onClickAddSignature
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, "Attached Signature ", /*#__PURE__*/React__default.createElement(DrawIcon, null))))), /*#__PURE__*/React__default.createElement("section", {
    style: {
      display: "flex",
      flexDirection: "column",
      flex: userType === "citizen" ? 1 : 7.5,
      width: "50%",
      borderRadius: "4px",
      height: "fit-content",
      boxShadow: userType === "citizen" ? "" : "1px 1px 4px 0px rgba(0,0,0,0.2)",
      background: "white",
      padding: userType === "citizen" ? "8px" : "20px",
      paddingBottom: "10px"
    }
  }, userType === "citizen" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_NAME")}`, "*"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    style: {
      width: "100%"
    },
    type: "text",
    isMandatory: false,
    name: "name",
    value: name,
    onChange: e => setUserName(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "tel",
    title: t("CORE_COMMON_PROFILE_NAME_ERROR_MESSAGE")
  }, {
    disable:  Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.name)
  })), (errors === null || errors === void 0 ? void 0 : errors.userName) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$userName = errors.userName) === null || _errors$userName === void 0 ? void 0 : _errors$userName.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_GENDER")}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    className: "form-field",
    selected: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 ? gender[0] : gender,
    disable: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 || editScreen,
    option: menu,
    select: setGenderName,
    value: gender,
    optionKey: "code",
    t: t,
    name: "gender"
  })), /*#__PURE__*/React__default.createElement(CardLabelError, null), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_EMAIL")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    style: {
      width: "100%"
    },
    type: "email",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "email",
    value: email,
    onChange: e => setUserEmailAddress(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.emailAddress) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$emailAddress = errors.emailAddress) === null || _errors$emailAddress === void 0 ? void 0 : _errors$emailAddress.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_MOBILE_NUMBER")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    style: {
      width: "100%"
    },
    type: "number",
    isMandatory: false,
    name: "mobileNumber",
    value: mobileNumber,
    onChange: e => setMobileNo(e.target.value)
  }), (errors === null || errors === void 0 ? void 0 : errors.mobileNumber) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$mobileNumber = errors.mobileNumber) === null || _errors$mobileNumber === void 0 ? void 0 : _errors$mobileNumber.message), " "))), /*#__PURE__*/React__default.createElement("button", {
    onClick: updateProfile,
    style: {
      marginTop: "24px",
      backgroundColor: "#1F4A7C",
      width: "100%",
      height: "40px",
      color: "white",
      borderBottom: "1px solid black"
    }
  }, t("CORE_COMMON_SAVE"))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_NAME")}`, "*"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    name: "name",
    value: name,
    onChange: e => setUserName(e.target.value),
    placeholder: "Enter Your Name"
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("CORE_COMMON_PROFILE_NAME_ERROR_MESSAGE")
  }, {
    disable:  Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.name)
  })), (errors === null || errors === void 0 ? void 0 : errors.userName) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$userName2 = errors.userName) === null || _errors$userName2 === void 0 ? void 0 : _errors$userName2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_GENDER")}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    selected: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 ? gender[0] : gender,
    disable: gender === null || gender === void 0 ? void 0 : gender.code,
    option: menu,
    select: setGenderName,
    value: gender,
    optionKey: "code",
    t: t,
    name: "gender"
  })), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_DISTRICT")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    selected: city,
    option: districts,
    select: setCityName,
    value: city,
    optionKey: "name",
    t: t,
    name: "city"
  }), /*#__PURE__*/React__default.createElement(CardLabelError, null))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style: {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_MOBILE_NUMBER")}*`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(MobileNumber, Object.assign({
    value: mobileNumber,
    style: {
      width: "100%"
    },
    name: "mobileNumber",
    placeholder: "Enter a valid Mobile No.",
    onChange: value => setUserMobileNumber(value),
    disable: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber
  }, {
    required: true,
    pattern: "[6-9]{1}[0-9]{9}",
    type: "tel",
    title: t("CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID")
  })), (errors === null || errors === void 0 ? void 0 : errors.mobileNumber) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$mobileNumber2 = errors.mobileNumber) === null || _errors$mobileNumber2 === void 0 ? void 0 : _errors$mobileNumber2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_EMAIL")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "email",
    isMandatory: false,
    placeholder: "Enter a valid Email",
    optionKey: "i18nKey",
    name: "email",
    value: email,
    onChange: e => setUserEmailAddress(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.emailAddress) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$emailAddress2 = errors.emailAddress) === null || _errors$emailAddress2 === void 0 ? void 0 : _errors$emailAddress2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
    style: {
      color: "orange",
      cursor: "default",
      marginBottom: "5",
      cursor: "pointer"
    },
    onClick: TogleforPassword
  }, t("CORE_COMMON_CHANGE_PASSWORD")), changepassword ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_CURRENT_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserCurrentPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.currentPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$currentPasswo = errors.currentPassword) === null || _errors$currentPasswo === void 0 ? void 0 : _errors$currentPasswo.message)))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_NEW_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserNewPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.newPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$newPassword = errors.newPassword) === null || _errors$newPassword === void 0 ? void 0 : _errors$newPassword.message)))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_CONFIRM_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserConfirmPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.confirmPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$confirmPasswo = errors.confirmPassword) === null || _errors$confirmPasswo === void 0 ? void 0 : _errors$confirmPasswo.message))))) : ""))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "88px",
      backgroundColor: "#FFFFFF",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "-20px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: updateProfile,
    style: {
      marginTop: "24px",
      backgroundColor: "#1F4A7C",
      width: windowWidth < 768 ? "100%" : "248px",
      height: "40px",
      float: "right",
      margin: windowWidth < 768 ? "0 16px" : "",
      marginRight: windowWidth < 768 ? "16px" : "31px",
      color: "white",
      borderBottom: "1px solid black"
    }
  }, t("CORE_COMMON_SAVE"))), toast && /*#__PURE__*/React__default.createElement(Toast, {
    error: toast.key === "error",
    label: t(toast.key === "success" ? `CORE_COMMON_PROFILE_UPDATE_SUCCESS` : toast.action),
    onClose: () => setToast(null),
    style: {
      maxWidth: "670px"
    }
  }), openUploadSlide == true ? /*#__PURE__*/React__default.createElement(UploadDrawer, {
    setProfilePic: setFileStoreId,
    closeDrawer: closeFileUploadDrawer,
    userType: userType,
    removeProfilePic: removeProfilePic,
    showToast: showToast
  }) : "", openSignatureUploadSlide == true ? /*#__PURE__*/React__default.createElement(SinatureDrawer, {
    setSignaturePic: setFileStoreSignature,
    closeDrawer: closeFileSignaturDrawer,
    userType: userType,
    removeProfilePic: removeSignaturePic,
    showToast: showToast
  }) : "");
};

const FileStrip = ({
  ltpDetail,
  mapDetailsFromSession
}) => {
  var _userInfo$info, _userInfo$info$roles, _userInfo$info2, _userInfo$info3;
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(e => e.code);
  const isLtp = userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role));
  const isOwner = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("OWNER")) && !isLtp;
  const isCitizen = userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("LTP");
  const roleLabel = isLtp ? "LTP Mobile No" : isOwner ? "Owner Mobile No" : isCitizen ? "Citizen Mobile No" : "Mobile No";
  return /*#__PURE__*/React__default.createElement(FileInfoStrip, null, (mapDetailsFromSession === null || mapDetailsFromSession === void 0 ? void 0 : mapDetailsFromSession.applicationNo) && /*#__PURE__*/React__default.createElement(FileNo, null, "File No: ", (mapDetailsFromSession === null || mapDetailsFromSession === void 0 ? void 0 : mapDetailsFromSession.applicationNo) || "N/A"), /*#__PURE__*/React__default.createElement("span", null, roleLabel, ":-\xA0"), " ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "bold"
    }
  }, (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber) || "N/A"), /*#__PURE__*/React__default.createElement(Owner, null, /*#__PURE__*/React__default.createElement("strong", null, userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.name), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontWeight: "normal",
      fontSize: "0.9em"
    }
  }, ltpDetail === null || ltpDetail === void 0 ? void 0 : ltpDetail.registrationNumber)));
};

function SideTopBarLayout({
  t,
  stateInfo,
  userDetails,
  CITIZEN,
  cityDetails,
  children,
  formData
}) {
  const location = useLocation();
  const isObpsRoute = location.pathname.includes("obps");
  const isProfileRoute = location.pathname.includes("profile");
  const isProfileAccount = location.pathname.includes("account");
  const stateId = Digit.ULBService.getStateId();
  const [applicationDetail, setApplicationDetail] = useState(null);
  const [ltpDetail, setLtpDetail] = useState(null);
  const [mapDetails, setMapDetails] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(null);
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  useEffect(() => {
    const fetchAndSetUserDetails = async () => {
      const {
        info: userInfo
      } = Digit.UserService.getUser();
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      if (uuid) {
        var _usersResponse$user;
        const usersResponse = await Digit.UserService.userSearch(stateId, {
          uuid: [uuid]
        }, {});
        const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
        setUserData(userDetail);
        const ltpDetail = {
          user: userDetail
        };
        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        Digit.SessionStorage.set("LTP_DETAIL", ltpDetail);
        return ltpDetail;
      }
      return null;
    };
    const interval = setInterval(async () => {
      const appDetailFromSession = Digit.SessionStorage.get("FASTPAS_ID");
      let userDetailFromSession = Digit.SessionStorage.get("USER_DETAIL");
      const mapDetailsFromSession = Digit.SessionStorage.get("FORM_MAP_SUBMISSION");
      if (!userDetailFromSession) {
        userDetailFromSession = await fetchAndSetUserDetails();
      }
      if (appDetailFromSession) setApplicationDetail(appDetailFromSession);
      if (userDetailFromSession) setLtpDetail(userDetailFromSession);
      if (mapDetailsFromSession) setMapDetails(mapDetailsFromSession);
      if (appDetailFromSession && userDetailFromSession && mapDetailsFromSession) {
        clearInterval(interval);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return /*#__PURE__*/React__default.createElement(DashboardLayout, {
    isObpsRoute: isObpsRoute
  }, /*#__PURE__*/React__default.createElement(Sidebar$1, {
    userDetails: userData,
    collapsed: collapsed,
    toggleSidebar: toggleSidebar,
    setCollapsed: setCollapsed
  }), /*#__PURE__*/React__default.createElement(MainContent, {
    collapsed: collapsed
  }, /*#__PURE__*/React__default.createElement(TopBar, {
    userDetails: userDetails,
    collapsed: collapsed,
    applicationDetail: applicationDetail,
    toggleSidebar: toggleSidebar
  }), /*#__PURE__*/React__default.createElement(FileStrip, {
    ltpDetail: ltpDetail,
    mapDetailsFromSession: mapDetails
  }), isProfileRoute && /*#__PURE__*/React__default.createElement(BPACommonSearchApp, null), isProfileAccount && /*#__PURE__*/React__default.createElement(UserProfile, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1,
      overflow: "auto"
    }
  }, children)));
}

const EDCRAcknowledgement = props => {
  var _props$data2, _props$data3, _props$data6, _edcrData$planDetail;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    var _props$data;
    if ((props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.type) == "ERROR" && !showToast) setShowToast(true);
  }, [props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.data]);
  const clearAllData = () => {
    var _Digit, _Digit2, _Digit3, _Digit4;
    resetFormMTDocs();
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("FORM12_CURRENT_TAB");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("ScrutinyDetails");
    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("EDCR_CREATE");
    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("FASTPAS_ID");
    sessionStorage.removeItem("currentCity");
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
  };
  useEffect(() => {
    const handleBackButton = () => {
      clearAllData();
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
      if (!sessionStorage.getItem("clickOnBPAApplyAfterEDCR")) {
        clearAllData();
      }
    };
  }, []);
  if ((props === null || props === void 0 ? void 0 : (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.type) == "ERROR") {
    var _props$data4, _props$data5;
    return /*#__PURE__*/React__default.createElement(Card, {
      style: {
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement(Banner, {
      message: t(`${props === null || props === void 0 ? void 0 : (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.data}`),
      applicationNumber: "",
      info: "",
      successful: false,
      infoStyles: {
        fontSize: "18px",
        lineHeight: "21px",
        fontWeight: "bold",
        textAlign: "center",
        padding: "0px 15px"
      },
      applicationNumberStyles: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: "bold",
        marginTop: "10px"
      },
      style: {
        width: "100%",
        padding: "10px"
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(Link, {
      to: `/digit-ui/citizen`
    }, /*#__PURE__*/React__default.createElement(SubmitBar, {
      label: t("CORE_COMMON_GO_TO_HOME"),
      onSubmit: clearAllData
    }))), showToast ? /*#__PURE__*/React__default.createElement(Toast, {
      error: "error",
      label: t(`${props === null || props === void 0 ? void 0 : (_props$data5 = props.data) === null || _props$data5 === void 0 ? void 0 : _props$data5.data}`),
      onClose: () => setShowToast(null),
      isDleteBtn: true
    }) : null);
  }
  sessionStorage.setItem("isPermitApplication", true);
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(true));
  const edcrData = props === null || props === void 0 ? void 0 : (_props$data6 = props.data) === null || _props$data6 === void 0 ? void 0 : _props$data6[0];
  const isRescrutiny = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : _edcrData$planDetail.applicationScrutinyType;
  const [bpaLinks, setBpaLinks] = useState({});
  const state = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    data: homePageUrlLinks,
    isLoading: homePageUrlLinksLoading
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["homePageUrlLinks"]);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["RiskTypeComputation"]);
  useEffect(() => {
    var _homePageUrlLinks$BPA, _homePageUrlLinks$BPA2;
    if (!homePageUrlLinksLoading && (homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA === void 0 ? void 0 : (_homePageUrlLinks$BPA2 = _homePageUrlLinks$BPA.homePageUrlLinks) === null || _homePageUrlLinks$BPA2 === void 0 ? void 0 : _homePageUrlLinks$BPA2.length) > 0) {
      var _homePageUrlLinks$BPA3, _homePageUrlLinks$BPA4;
      homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA3 = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA3 === void 0 ? void 0 : (_homePageUrlLinks$BPA4 = _homePageUrlLinks$BPA3.homePageUrlLinks) === null || _homePageUrlLinks$BPA4 === void 0 ? void 0 : _homePageUrlLinks$BPA4.map(linkData => {
        if ((linkData === null || linkData === void 0 ? void 0 : linkData.applicationType) === (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) && (linkData === null || linkData === void 0 ? void 0 : linkData.serviceType) === (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType)) {
          setBpaLinks({
            linkData: linkData,
            edcrNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber
          });
        }
      });
    }
  }, [!homePageUrlLinksLoading]);
  const printReciept = async () => {
    var win = window.open(edcrData.planReport, "_blank");
    if (win) {
      win.focus();
    }
  };
  const routeToForm12 = async () => {
    sessionStorage.setItem("clickOnBPAApplyAfterEDCR", true);
    Digit.SessionStorage.set("LTP.SCRUTINY.SELECTION", "EDCR");
    if (isRescrutiny) {
      history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal/${edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationId}`);
    } else {
      history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, (edcrData === null || edcrData === void 0 ? void 0 : edcrData.status) === "Accepted" ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Banner, {
    message: t("EDCR_ACKNOWLEDGEMENT_SUCCESS_MESSAGE_LABEL"),
    applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber,
    info: t("EDCR_SCRUTINY_NUMBER_LABEL"),
    successful: true,
    infoStyles: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "bold",
      textAlign: "center",
      padding: "0px 15px"
    },
    applicationNumberStyles: {
      fontSize: "24px",
      lineHeight: "28px",
      fontWeight: "bold",
      marginTop: "10px"
    },
    style: {
      width: "100%",
      padding: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(Box$2, {
    sx: {
      padding: "0 2rem 2rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "1rem"
    }
  }, `${t("EDCR_SCRUTINY_NUMBER_LABEL")} - ${edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "start"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "primary-label-btn",
    style: {
      marginLeft: "unset",
      marginBottom: "1rem",
      padding: "0px 8px"
    },
    onClick: printReciept
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "23",
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z",
    fill: "#a82227"
  })), t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("Apply For Map Submission"),
    onSubmit: routeToForm12
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "fit-content"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: t("CORE_COMMON_GO_TO_HOME"),
    onClick: clearAllData
  })))))) : /*#__PURE__*/React__default.createElement(Card, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Banner, {
    message: t("EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_LABEL"),
    applicationNumber: "",
    info: "",
    successful: false,
    infoStyles: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "bold",
      textAlign: "center",
      padding: "0px 15px"
    },
    applicationNumberStyles: {
      fontSize: "24px",
      lineHeight: "28px",
      fontWeight: "bold",
      marginTop: "10px"
    },
    style: {
      width: "100%",
      padding: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "10px"
    }
  }, t("EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_TEXT_LABEL")), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "10px"
    }
  }, `${t("EDCR Number")} - ${edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber}`), /*#__PURE__*/React__default.createElement("div", {
    className: "primary-label-btn d-grid",
    style: {
      marginLeft: "unset",
      marginBottom: "10px",
      padding: "0px 8px"
    },
    onClick: printReciept
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "23",
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z",
    fill: "#a82227"
  })), t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "fit-content",
      padding: "10px",
      boxSizing: "border-box"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME"),
    onSubmit: clearAllData
  })))));
};

const PaymentDirect = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState("applicationNo");
  const [order, setOrder] = useState("asc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    async function fetchData() {
      setLoader(true);
      try {
        const response = await Digit.OBPSService.BPASearchMyApplicationForm12(Digit.ULBService.getCurrentTenantId());
        if (!response || !response.BPA) {
          setData([]);
        } else {
          const filteredData = response.BPA.filter(item => {
            var _item$workflow;
            return ((_item$workflow = item.workflow) === null || _item$workflow === void 0 ? void 0 : _item$workflow.action) === "MAKE_PAYMENT" && "MAKE_PAYMENT_SELF";
          });
          setData(filteredData);
        }
      } catch (error) {
        setData([]);
        console.error("Error fetching data:", error);
      }
      setLoader(false);
    }
    fetchData();
  }, []);
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo$owners3, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$applicationNo, _item$applicationType, _t, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : (_item$landInfo$owners3 = _item$landInfo$owners2.name) === null || _item$landInfo$owners3 === void 0 ? void 0 : _item$landInfo$owners3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return (item === null || item === void 0 ? void 0 : (_item$applicationType = item.applicationType) === null || _item$applicationType === void 0 ? void 0 : _item$applicationType.toLowerCase()) || "";
          case "status":
            return ((_t = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = data || [];
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.mobileNumber) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _item$applicationType2;
        return item === null || item === void 0 ? void 0 : (_item$applicationType2 = item.applicationType) === null || _item$applicationType2 === void 0 ? void 0 : _item$applicationType2.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t2;
        return (_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        if ((item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_MAP") {
          history.push({
            pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
          });
        } else if ((item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_LANDUSE") {
          history.push({
            pathname: `/digit-ui/citizen/obps/structural/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`
          });
        }
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, (item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-status"
    }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-")
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleOpenColumnFilter = event => setAnchorEl(event.currentTarget);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loader ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Make Payment - My Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    className: "bg-white",
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: '#fff'
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignitems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: filteredData.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: (event, newPage) => setPage(newPage),
    onRowsPerPageChange: event => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    }
  }))));
};

const MigratedSummary = ({
  id
}) => {
  var _sanctionFiles$, _sanctionFiles$2;
  const [applicationData, setApplicationData] = useState(null);
  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearchappNo({
        applicationNo: id
      });
      console.log(response, "migratedData");
      setApplicationData(response === null || response === void 0 ? void 0 : response.Application);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchMigratedData();
  }, [id]);
  console.log(applicationData, "applicationData");
  const {
    applicationChecklist,
    projectDetail,
    architectDetail,
    ownerDetail,
    plotDetail,
    challanHeads,
    challans,
    sanctionFiles,
    documents
  } = applicationData || {};
  return /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "File Detail")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.applicationNumber), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposal Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.proposalDate)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature Of Construction/Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.caseType), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Proposal Type Design(Plotted Development):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.plottedDevelopment)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Revised:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.isRevised), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.projectType)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.district), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.tehsil)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.revenueVillage), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.landMark)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Special Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.isSpecialProject), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.specialProject)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is proposal transit oriented developemnt:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.landUseUnderTOD), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Converted Land Use Under TOD:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.tod))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Sanction Letter & Drawing")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null), /*#__PURE__*/React__default.createElement("tbody", null, (sanctionFiles === null || sanctionFiles === void 0 ? void 0 : sanctionFiles.length) > 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction Letter")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: (_sanctionFiles$ = sanctionFiles[1]) === null || _sanctionFiles$ === void 0 ? void 0 : _sanctionFiles$.fileStoreURL,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: "blue",
      textDecoration: "underline"
    }
  }, "Click Here"))), (sanctionFiles === null || sanctionFiles === void 0 ? void 0 : sanctionFiles.length) > 1 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Drawing")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: (_sanctionFiles$2 = sanctionFiles[0]) === null || _sanctionFiles$2 === void 0 ? void 0 : _sanctionFiles$2.fileStoreURL,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: "blue",
      textDecoration: "underline"
    }
  }, "Click Here")))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Detail")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Owner's Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.ownerName), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Owner's Contact No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.ownerContactNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Owner Email:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.ownerEmail), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address Line 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    },
    colSpan: "3"
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.addressLine1)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Pincode:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.pincode) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Site Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, ownerDetail === null || ownerDetail === void 0 ? void 0 : ownerDetail.siteAdress))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Architect Detail")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Architect's Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.architectName), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "COA/License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.licenseNo), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Validity Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.validityUpto)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.mobileNumber), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Login Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.loginName), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (architectDetail === null || architectDetail === void 0 ? void 0 : architectDetail.address) || "N/A"))))))), applicationChecklist && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicaion Checklist")), applicationChecklist === null || applicationChecklist === void 0 ? void 0 : applicationChecklist.reduce((rows, item, index) => {
    if (index % 2 === 0) {
      var _applicationChecklist, _applicationChecklist2, _applicationChecklist3, _applicationChecklist4;
      rows.push( /*#__PURE__*/React__default.createElement("tr", {
        key: `row-${index}`
      }, /*#__PURE__*/React__default.createElement("td", {
        style: {
          textAlign: "left",
          padding: "8px"
        }
      }, /*#__PURE__*/React__default.createElement("b", null, (_applicationChecklist = applicationChecklist[index]) === null || _applicationChecklist === void 0 ? void 0 : _applicationChecklist.caption, ":")), /*#__PURE__*/React__default.createElement("td", {
        style: {
          padding: "8px"
        }
      }, (_applicationChecklist2 = applicationChecklist[index]) === null || _applicationChecklist2 === void 0 ? void 0 : _applicationChecklist2.value), applicationChecklist[index + 1] && /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: `row-${index + 1}`
      }, /*#__PURE__*/React__default.createElement("td", {
        style: {
          textAlign: "left",
          padding: "8px"
        }
      }, /*#__PURE__*/React__default.createElement("b", null, (_applicationChecklist3 = applicationChecklist[index + 1]) === null || _applicationChecklist3 === void 0 ? void 0 : _applicationChecklist3.caption, ":")), /*#__PURE__*/React__default.createElement("td", {
        style: {
          padding: "8px"
        }
      }, (_applicationChecklist4 = applicationChecklist[index + 1]) === null || _applicationChecklist4 === void 0 ? void 0 : _applicationChecklist4.value))));
    }
    return rows;
  }, [])), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Detail")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use Zone:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.landUseZone), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use Zone:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.landSubUseZone)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.plotUse), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.plotSubUse)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.developmentArea), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sub Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.subdevelopmentArea) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plan On:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.planOn), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.scheme)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Gata / Arazi No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.araziNo), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Max Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.maxBuildingHeight, "m")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.plotArea, " sq.m"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area as per Document:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.plotAreaAsDocument) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Builtup Area (sq.m):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.totalBUA, " sq.m"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Existing Builtup Area(sq.m):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.existingBUA, " sq.m")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Carpet Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.proposedCarpetArea, " sq.m"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Plan:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.developmentPlan) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, "\u20B9", plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.estimatedCost), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.groundCoverageArea, " sq.m")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Community Parking:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.communityParking), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Number of Stories:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.numberOfStories)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Approved Layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.approvedLayout), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Required Special Setback:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.requiredSepecialSetBack)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.layoutSanctionNo) || "N/A"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (plotDetail === null || plotDetail === void 0 ? void 0 : plotDetail.layoutSanctionDate) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, "Documents"))), /*#__PURE__*/React__default.createElement("tbody", null, documents === null || documents === void 0 ? void 0 : documents.map(doc => /*#__PURE__*/React__default.createElement("tr", {
    key: doc.fileId
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, doc.docName), /*#__PURE__*/React__default.createElement("a", {
    href: doc.fileStoreURL,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      color: "blue",
      textDecoration: "underline"
    }
  }, "Click here")))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Challans")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    style: {
      background: "#f5f5f5",
      textAlign: "left"
    }
  }, /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, "Challan Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, "Challan Details"))), /*#__PURE__*/React__default.createElement("tbody", null, challans === null || challans === void 0 ? void 0 : challans.map((challan, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, challan.challanNumber)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px",
      borderBottom: "1px solid #ddd"
    }
  }, challan.challanType, " - \u20B9", challan.amount, " - ", challan.paymentStatus, " - ", challan.paymentDate)))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Challan Heads")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, challanHeads === null || challanHeads === void 0 ? void 0 : challanHeads.map(challan => /*#__PURE__*/React__default.createElement("table", {
    key: challan.id,
    style: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan Number:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, challan === null || challan === void 0 ? void 0 : challan.challanNumber), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan Head:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "25%",
      padding: "8px"
    }
  }, challan === null || challan === void 0 ? void 0 : challan.headName)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Receipt No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, challan === null || challan === void 0 ? void 0 : challan.receiptNumber), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan Amount:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, challan === null || challan === void 0 ? void 0 : challan.challanAmount)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Paid Amount:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, challan === null || challan === void 0 ? void 0 : challan.paidAmount), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Transaction ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: "8px"
    }
  }, (challan === null || challan === void 0 ? void 0 : challan.transactionID) || "N/A")))))))));
};

const MapSubApplications = () => {
  var _Digit$UserService$ge, _userInfo$roles;
  const {
    t
  } = useTranslation();
  const citizenBaseUrl = "/digit-ui/citizen";
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [selectedAction, setSelectedAction] = useState("All");
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [migratedData, setMigratedData] = useState(null);
  const [loaderData, setLoaderData] = useState(false);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const mobileNumber = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber;
  console.log("userInfoFromMyapp", userInfo, Digit.UserService.getUser());
  const isOwner = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.some(role => role.code === "OWNER");
  const {
    data,
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_MAP",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "MAP_SUB"
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status", "provisionalApprovalLetter", "action"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleViewSummary = item => {
    var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name);
    if ((item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_MAP") {
      setIdData(item === null || item === void 0 ? void 0 : item.applicationNo);
      if ((item === null || item === void 0 ? void 0 : item.applicationNo) != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all", item);
    }
  };
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterId).filter(key => key.startsWith("objection_")).sort().at(-1);
    const objectionLetterId = item === null || item === void 0 ? void 0 : item.objectionLetterId[objectionKey];
    getDocumentByFileStoreId(objectionLetterId, setLoaderData);
  };
  const getProvisionalApprovalLetterId = item => {
    var _item$additionalDetai;
    const raw = (item === null || item === void 0 ? void 0 : item.provisionalApprovalLetterId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.provisionalApprovalLetterId);
    if (!raw) return null;
    if (typeof raw === "string" && raw.trim() !== "") {
      return raw.trim();
    }
    if (typeof raw === "object") {
      const keys = Object.keys(raw);
      if (keys.length > 0) {
        const latestKey = keys.sort().at(-1);
        return raw[latestKey];
      }
    }
    return null;
  };
  const handleProvisionalApprovalLetter = item => {
    const fileStoreId = getProvisionalApprovalLetterId(item);
    if (!fileStoreId) return;
    if (typeof fileStoreId === "string" && (fileStoreId.startsWith("http://") || fileStoreId.startsWith("https://"))) {
      window.open(fileStoreId, "_blank");
      return;
    }
    getDocumentByFileStoreId(fileStoreId, setLoaderData);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  async function fetchMigratedData() {
    setLoaderData(true);
    try {
      const response = await Digit.OBPSService.BPAmigratedSearch({
        mobileNumber
      });
      setMigratedData(response === null || response === void 0 ? void 0 : response.ApplicationList);
      setLoaderData(false);
    } catch (error) {
      setLoaderData(true);
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchMigratedData();
  }, []);
  const handleActionChange = action => {
    setSelectedAction(action);
    setCurentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  function getApprovalLetter(item) {
    console.log("Item got 215", item);
    const pdfUrl = item === null || item === void 0 ? void 0 : item.approvalCertificateUrl;
    window.open(pdfUrl, "_blank");
  }
  function getInitiationLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.farInimationLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$landInfo2$owner3, _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : (_item$landInfo2$owner3 = _item$landInfo2$owner2.name) === null || _item$landInfo2$owner3 === void 0 ? void 0 : _item$landInfo2$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.BPA) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$auditDetails2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.name) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$landInfo7$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : (_item$landInfo7$owner3 = _item$landInfo7$owner2.mobileNumber) === null || _item$landInfo7$owner3 === void 0 ? void 0 : _item$landInfo7$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails3;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-status"
      }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-resubmit"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/groupHousingPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "proposalLetter",
    label: "Proposal Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-proposal"
    }, (item === null || item === void 0 ? void 0 : item.proposalUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.proposalUrl, "_blank")
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "provisionalApprovalLetter",
    label: "Provisional Approval letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-provisional"
    }, Boolean(getProvisionalApprovalLetterId(item)) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleProvisionalApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate5;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-approval"
      }, ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPROVED_JE") && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate5 = item.taxHeadEstimates) === null || _item$taxHeadEstimate5 === void 0 ? void 0 : _item$taxHeadEstimate5[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getApprovalLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "initiationLetter",
    label: "Initiation Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-initiation"
    }, (item === null || item === void 0 ? void 0 : item.farInimationLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getInitiationLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "nocStatus",
    label: "NOC Status",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-noc"
    }, (item === null || item === void 0 ? void 0 : item.status) === "REVERT_TO_APPLICANT" && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        Digit.SessionStorage.set("nocAppData", item);
        history.push(`${citizenBaseUrl}/obps/nocApplications/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      const restrictedPlans = ["Self Certification of residential Plot Area upto 300 SqM on approved layouts", "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"];
      const isRestrictedOwner = restrictedPlans.includes(item === null || item === void 0 ? void 0 : item.planOn) && isOwner === true;
      const allowedStatuses = ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"];
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-action"
      }, isRestrictedOwner ?
      /*#__PURE__*/
      React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "success",
        onClick: () => handleViewSummary(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")) : allowedStatuses.includes(item === null || item === void 0 ? void 0 : item.status) ?
      /*#__PURE__*/
      React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          const path = (item === null || item === void 0 ? void 0 : item.planOn) === "SELF_MAP" ? `/digit-ui/citizen/obps/services/selfResidentialPortal/${item === null || item === void 0 ? void 0 : item.applicationId}` : (item === null || item === void 0 ? void 0 : item.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (item === null || item === void 0 ? void 0 : item.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? `/digit-ui/citizen/obps/services/selfApprovalPortal/${item === null || item === void 0 ? void 0 : item.applicationId}` : `/digit-ui/citizen/obps/services/mapSubmissionPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`;
          history.push({
            pathname: path
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "success",
        onClick: () => handleViewSummary(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleClickAction = item => {
    var _item$documents, _item$documents2, _item$taxHeadEstimate6, _item$taxHeadEstimate7, _item$taxHeadEstimate8, _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
    const docAbsent = (item === null || item === void 0 ? void 0 : (_item$documents = item.documents) === null || _item$documents === void 0 ? void 0 : _item$documents.length) < 3 && (item === null || item === void 0 ? void 0 : item.planOn) === "SELF_MAP";
    const checkForLTPSelf = (item === null || item === void 0 ? void 0 : (_item$documents2 = item.documents) === null || _item$documents2 === void 0 ? void 0 : _item$documents2.length) < 6 && (item === null || item === void 0 ? void 0 : item.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate6 = item.taxHeadEstimates) === null || _item$taxHeadEstimate6 === void 0 ? void 0 : (_item$taxHeadEstimate7 = _item$taxHeadEstimate6[0]) === null || _item$taxHeadEstimate7 === void 0 ? void 0 : (_item$taxHeadEstimate8 = _item$taxHeadEstimate7.paymentHeads) === null || _item$taxHeadEstimate8 === void 0 ? void 0 : _item$taxHeadEstimate8.length) === 0;
    if (checkForLTPSelf) {
      return;
    }
    if (docAbsent) {
      console.log("Navigation blocked due to condition");
      return;
    }
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const viewModal = item => {
    if (item !== null && item !== void 0 && item.applicationnumber) {
      setIdData(item === null || item === void 0 ? void 0 : item.applicationnumber);
      setshowMs(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), loaderData && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: tabIndex,
    onChange: handleTabChange,
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "New Applications"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Archive Old Applications"
  }))), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 0,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption .mapsub-my-applications"
  }, "Map Submission - My Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 1,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container archieve-old-table"
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "5%"
    }
  }, "Sr No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Owner Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Owner Mobile Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Application Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "View Summary"))), /*#__PURE__*/React__default.createElement("tbody", null, migratedData === null || migratedData === void 0 ? void 0 : migratedData.map((item, index) => {
    var _item$applicationdeta, _item$applicationdeta2, _item$applicationdeta3, _item$applicationdeta4, _item$applicationdeta5, _item$applicationdeta6;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item === null || item === void 0 ? void 0 : item.applicationNo
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta = item.applicationdetails) === null || _item$applicationdeta === void 0 ? void 0 : (_item$applicationdeta2 = _item$applicationdeta.data) === null || _item$applicationdeta2 === void 0 ? void 0 : (_item$applicationdeta3 = _item$applicationdeta2.ownerDetail) === null || _item$applicationdeta3 === void 0 ? void 0 : _item$applicationdeta3.ownerName), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta4 = item.applicationdetails) === null || _item$applicationdeta4 === void 0 ? void 0 : (_item$applicationdeta5 = _item$applicationdeta4.data) === null || _item$applicationdeta5 === void 0 ? void 0 : (_item$applicationdeta6 = _item$applicationdeta5.ownerDetail) === null || _item$applicationdeta6 === void 0 ? void 0 : _item$applicationdeta6.ownerContactNo), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.applicationnumber), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => viewModal(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: 10,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), showMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showMs,
    onClose: () => {
      setshowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(MigratedSummary, {
    id: idData
  })), smShowMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  })));
};

const getRevalData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  if (id) {
    var _data$BPA, _edcrData$description, _edcrData$description2, _edcrData$description3, _edcrData$description4, _edcrData$landInfo, _edcrData$landInfo$ow, _edcrData$landInfo$ow2, _edcrData$landInfo2, _edcrData$landInfo2$o, _edcrData$landInfo2$o2, _edcrData$landInfo3, _edcrData$landInfo3$o, _edcrData$landInfo3$o2, _edcrData$documents, _edcrData$documents$f, _edcrData$additionalD;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPAmigratedSearchappNo({
        id
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    console.log(data, "datafetchedfromRevalidationportal");
    const edcrData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    const applicationData = {
      applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      applicationId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationId,
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      transactionNumber: uuidv4(),
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      fastPASId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.land_Id,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      city: edcrData === null || edcrData === void 0 ? void 0 : edcrData.city,
      locality: edcrData === null || edcrData === void 0 ? void 0 : edcrData.locality,
      village: edcrData === null || edcrData === void 0 ? void 0 : edcrData.village,
      doorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.doorNo,
      code: edcrData === null || edcrData === void 0 ? void 0 : edcrData.code,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      plotArea: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description = edcrData.descriptionOfLand) === null || _edcrData$description === void 0 ? void 0 : _edcrData$description.landArea,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      otherSchemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherSchemeName,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      areaType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.areaType,
      developmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentArea,
      subDevelopmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subDevelopmentArea,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.far,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      groundCoverages: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackFronts,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackRears,
      backSide: edcrData === null || edcrData === void 0 ? void 0 : edcrData.backSide,
      isPlotSetback: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isPlotSetback,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      otherProjectName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherProjectName,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      previousSetbackFront: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      previousSetbackRear: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      previousSetbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide1,
      previousSetbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide2,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      landUseNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      purchasableFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description2 = edcrData.descriptionOfLand) === null || _edcrData$description2 === void 0 ? void 0 : (_edcrData$description3 = _edcrData$description2.properties) === null || _edcrData$description3 === void 0 ? void 0 : (_edcrData$description4 = _edcrData$description3[0]) === null || _edcrData$description4 === void 0 ? void 0 : _edcrData$description4.requiredAreaFAR) || 0,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      leaseholdNOC: edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      shelterFee: edcrData === null || edcrData === void 0 ? void 0 : edcrData.shelterFee,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      applicantName: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo = edcrData.landInfo) === null || _edcrData$landInfo === void 0 ? void 0 : (_edcrData$landInfo$ow = _edcrData$landInfo.owners) === null || _edcrData$landInfo$ow === void 0 ? void 0 : (_edcrData$landInfo$ow2 = _edcrData$landInfo$ow[0]) === null || _edcrData$landInfo$ow2 === void 0 ? void 0 : _edcrData$landInfo$ow2.name,
      aplicantMobileNumber: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo2 = edcrData.landInfo) === null || _edcrData$landInfo2 === void 0 ? void 0 : (_edcrData$landInfo2$o = _edcrData$landInfo2.owners) === null || _edcrData$landInfo2$o === void 0 ? void 0 : (_edcrData$landInfo2$o2 = _edcrData$landInfo2$o[0]) === null || _edcrData$landInfo2$o2 === void 0 ? void 0 : _edcrData$landInfo2$o2.mobileNumber,
      applicantEmailId: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo3 = edcrData.landInfo) === null || _edcrData$landInfo3 === void 0 ? void 0 : (_edcrData$landInfo3$o = _edcrData$landInfo3.owners) === null || _edcrData$landInfo3$o === void 0 ? void 0 : (_edcrData$landInfo3$o2 = _edcrData$landInfo3$o[0]) === null || _edcrData$landInfo3$o2 === void 0 ? void 0 : _edcrData$landInfo3$o2.emailId,
      licenseeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeName,
      licenseeLicenceNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeLicenceNumber) || "",
      licenseeMobileNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeMobileNumber) || "",
      licenseeEmailId: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeEmailId) || "",
      licenseeAddress: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeAddress) || "",
      file: edcrData === null || edcrData === void 0 ? void 0 : edcrData.file,
      signatureId: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : (_edcrData$documents$f = _edcrData$documents.filter(doc => doc.documentType === "signature")[0]) === null || _edcrData$documents$f === void 0 ? void 0 : _edcrData$documents$f.fileStoreId) || null,
      selectedOffice: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD = edcrData.additionalDetails) === null || _edcrData$additionalD === void 0 ? void 0 : _edcrData$additionalD.selectedOffice,
      department: null
    };
    return {
      applicationData,
      isAppDataLoading
    };
  } else {
    const applicationData = {
      tenantId,
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      applicationType: "FORM_MAP",
      applicationSubType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: null
    };
    return {
      applicationData,
      isAppDataLoading: false
    };
  }
};

const Step2$4 = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  var _formData$description;
  console.log(formData, "formDataStep2");
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData
  };
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  async function fetchLTPData() {
    var _userInfo$info;
    const createdBy = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
    try {
      var _response$Licenses, _ltpData$, _ltpData$$tradeLicens, _ltpData$$tradeLicens2;
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
        createdBy: createdBy
      });
      const ltpData = (response === null || response === void 0 ? void 0 : (_response$Licenses = response.Licenses) === null || _response$Licenses === void 0 ? void 0 : _response$Licenses.filter(e => e.status === "APPROVED")) || [];
      console.log(response, ltpData, "ltpDataaaaaa");
      const regCert = (ltpData === null || ltpData === void 0 ? void 0 : (_ltpData$ = ltpData[0]) === null || _ltpData$ === void 0 ? void 0 : (_ltpData$$tradeLicens = _ltpData$.tradeLicenseDetail) === null || _ltpData$$tradeLicens === void 0 ? void 0 : (_ltpData$$tradeLicens2 = _ltpData$$tradeLicens.applicationDocuments) === null || _ltpData$$tradeLicens2 === void 0 ? void 0 : _ltpData$$tradeLicens2.filter(e => e.documentType === "Registration Certificate")) || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchLTPData();
  }, []);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Please download the ", /*#__PURE__*/React__default.createElement("strong", null, "Drawing"), ", add your ", /*#__PURE__*/React__default.createElement("strong", null, "Digital Signature"), " and then upload the signed file to the Drawing PDF File Section ", /*#__PURE__*/React__default.createElement("span", {
    className: "mandatory"
  }, "*"), "."))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })))))))), " ", /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Architect/Engineer Registration Certificate"),
    control: control,
    name: "Architect/Engineer Registration Certificate",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Common Affidavit"),
    control: control,
    name: "Common Affidavit",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Calculation sheet of Estimate with Affidavit"),
    control: control,
    name: "Calculation sheet of Estimate with Affidavit",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing PDF"),
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ownerAffidavit",
    validationMsg: "Upload File",
    required: true
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Khatauni"),
    control: control,
    name: "khatauni",
    validationMsg: "Upload File",
    required: true
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Mutation Letter"),
    control: control,
    name: "Mutation Document/Possession Letter",
    validationMsg: "Upload File",
    required: true
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    label: t("Allotment Letter"),
    name: "allotmentLetter",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement"),
    control: control,
    name: "registrySaleDeedHPTA",
    isMandatory: true,
    validationMsg: "Upload File",
    required: true
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Possession Letter"),
    control: control,
    name: "possessionLetter",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Structural Audit Report"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "Upload File",
    required: true
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Developer/Consortium/Sales Agreement"),
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    required: true
  })), !isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "sitePhoto",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    tab: 2
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*")))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Additional Document if any"),
    control: control,
    name: "additionalDoc",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Drawing and Design "),
    control: control,
    name: "structuraldrawing",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Stability Certificate"),
    control: control,
    name: "structuralcertificate",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Design calculation Report"),
    control: control,
    name: "calculationReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    label: t("Vetted Structure and drawing along with certificate"),
    name: "vettedStructure",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer."),
    control: control,
    name: "annexture789",
    validationMsg: "Upload File"
  })), isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Approved Layout sanctioned Letter"),
    control: control,
    name: "Approved Layout Sanctioned Letter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*")))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const RevalidationSummary = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false
}) => {
  var _formData$landInfo, _formData$taxHeadEsti, _documents$filter, _documents$filter$, _Digit$SessionStorage, _formData$plotNumbers, _structuralInfo$perma, _formData$description;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const plotInfo = formData === null || formData === void 0 ? void 0 : formData.plotInfo;
  const structuralInfo = formData === null || formData === void 0 ? void 0 : formData.structuralInfo;
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const professionalInfo = formData === null || formData === void 0 ? void 0 : formData.professionaldetails;
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchisSetbackRequired = formData === null || formData === void 0 ? void 0 : formData.isSetbackRequired;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.constructionType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, "Lucknow Development Authority"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "General Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo)), (formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.currValidityDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Current Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.currValidityDate)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity proposed:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planOn)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherSchemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherSchemeName)), (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.isMetroCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Site falls in Metro City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isMetroCity)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.constructionType)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature of Construction /Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevFileNo)), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village/College Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.landMark)), (formData === null || formData === void 0 ? void 0 : formData.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector/Pocket No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sectorNo)), (formData === null || formData === void 0 ? void 0 : formData.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.khasraNo)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Standard Type Design:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction date Of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction number of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.noOfPlots) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.noOfPlots)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.plotNumbers) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.join(", "))), (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingClassification)), watchbuildingClassification === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass)), (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isSpecialProject)), (formData === null || formData === void 0 ? void 0 : formData.communityParking) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "If Community Parking Provided:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.communityParking)), watchisSpecialProject === "yes" && (formData === null || formData === void 0 ? void 0 : formData.projectType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Condition Of Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.projectType)), watchisSpecialProject === "Other" && (formData === null || formData === void 0 ? void 0 : formData.otherProjectName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherProjectName)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.groundCoverage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.groundCoverage)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.far) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.far)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingHeight)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackFronts) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackFronts)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackRears) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackRears)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback- 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide1)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback - 2:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide2)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Plot Sub-division:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && (formData === null || formData === void 0 ? void 0 : formData.needCompounding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does existing building require any compounding ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.needCompounding)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchNeedComp === "no" && (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot Lease hold ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchplotLeaseHold === "yes" && (edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC for Lease hold :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Left:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Right:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No. Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Catrgory:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.certificateNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.validupto))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.map((item, index) => {
    var _item$inputonGST, _item$inputonGST2, _item$inputonGST3, _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? "Addition Owner Information" : "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Input On GST:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST = item.inputonGST) === null || _item$inputonGST === void 0 ? void 0 : _item$inputonGST.value) === "yes" ? "Yes" : (item === null || item === void 0 ? void 0 : item.inputonGST) === "no" || (item === null || item === void 0 ? void 0 : (_item$inputonGST2 = item.inputonGST) === null || _item$inputonGST2 === void 0 ? void 0 : _item$inputonGST2.value) === "no" ? "No" : (item === null || item === void 0 ? void 0 : item.inputonGST) || "N/A")), ((item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST3 = item.inputonGST) === null || _item$inputonGST3 === void 0 ? void 0 : _item$inputonGST3.value) === "yes") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "GST No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.gstNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.town)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.address)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "200px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo))))))));
  })), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.name) || 'N/A')), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.validupto) || 'N/A')), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.licenseNumber) || 'N/A')), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : (_structuralInfo$perma = structuralInfo.permanentAddress) === null || _structuralInfo$perma === void 0 ? void 0 : _structuralInfo$perma.address) || 'N/A'))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot area as per Drawing (Sq.Mt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.plotArea))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details (Step-1)")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      fontWeight: "bolder"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount))))))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.planReport, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, ".dxf File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.dxfFile, "_blank")
  })))))))), _showDeclaration && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with this application.", " ")
  }))));
});

function SearchSummary$2({
  id,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration
}) {
  var _data$BPA;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  }, {
    formType: "MAP_SUB"
  });
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(RevalidationSummary, {
    formData: data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0],
    ref: ref,
    handleDeclarationChange: handleDeclarationChange,
    declarationChecked: declarationChecked,
    showDeclaration: showDeclaration
  }));
}

const RevalidationPortal = () => {
  var _Digit, _Digit2, _location$state;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }];
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("RV_CURRENT_SUBTAB")) || 0);
  const [activeTab, setActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("RV_CURRENT_TAB")) || 0);
  const location = useLocation();
  let applicationData = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data;
  let isAppDataLoading = false;
  console.log(applicationData, "revalLocationDatabEFORE");
  if (!applicationData) {
    ({
      applicationData,
      isAppDataLoading
    } = getRevalData(id));
  }
  console.log(applicationData, "revalLocationDatabaFTER");
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const isEmployee = false;
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_REVALIDATION", applicationData);
  const componentRef = useRef();
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const handleTabChange = async (nextTabNo, formData = null) => {
    console.log("nextTabNooooo", nextTabNo);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      try {
        if (nextTabNo === 4) {
          data.workflow = {
            action: 'MAKE_PAYMENT',
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (nextTabNo === 4) {
              if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              } else {
                var _params$taxHeadEstima;
                if ((params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : _params$taxHeadEstima.length) > 1) {
                  var _params$taxHeadEstima2, _params$taxHeadEstima3;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima2 = params.taxHeadEstimates) === null || _params$taxHeadEstima2 === void 0 ? void 0 : (_params$taxHeadEstima3 = _params$taxHeadEstima2[1]) === null || _params$taxHeadEstima3 === void 0 ? void 0 : _params$taxHeadEstima3.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else {
                  var _params$taxHeadEstima4, _params$taxHeadEstima5;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima4 = params.taxHeadEstimates) === null || _params$taxHeadEstima4 === void 0 ? void 0 : (_params$taxHeadEstima5 = _params$taxHeadEstima4[0]) === null || _params$taxHeadEstima5 === void 0 ? void 0 : _params$taxHeadEstima5.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                }
              }
            } else {
              if (nextTabNo === 3) {
                Digit.SessionStorage.set("SUMMARY_TAB", true);
                setSummaryshow(true);
              }
              Modal("Application Updated", `Application Updated Successfully!`, "success");
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("RV_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("RV_CURRENT_TAB", nextTabNo);
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData, _applicationData$docu;
      setParams(applicationData);
      if (((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$docu = _applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA, _res$BPA2;
              onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]);
              setSelectedSubTab(nextSubTab);
              console.log("nextSubTabFromUpdaterv", nextSubTab, res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]);
              Digit.SessionStorage.set("RV_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("RV_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$2, {
            formData: params,
            userInfo: userInfo,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            setFormData: setParams,
            initFormMTDocs: initFormMTDocs
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$2, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2$1, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$2, {
            formData: params,
            handleTabChange: handleTabChange,
            isEmployee: isEmployee,
            handleSubTabChange: handleSubTabChange
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$4, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step3$2, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(Step4$1, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4 && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary$2, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3"
        },
        onClick: () => handleTabChange(4, params),
        disabled: !declarationChecked
      }))));
    }
  };
  if (isAppDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Revalidation/Time Extension Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, {
    className: "technical-profession-section"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Fees"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application History"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const getResidentialData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  if (id) {
    var _data$BPA;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  }
  const applicationData = {
    plotinMelaArea: null,
    ownerName: null,
    careOf: null,
    ownerAddress: null,
    mobileNumber: null,
    aadhaarNumber: null,
    permissionType: null,
    zoneType: null,
    subZoneType: null,
    primaryUse: null,
    activityProposed: null,
    applicationType: "FORM_MAP",
    plotArea: null,
    plotDetails: null,
    district: null,
    planOn: null,
    tehsil: null,
    village: null,
    schemeName: null,
    mohalla: null,
    layoutsanctionNumber: null,
    layoutsanctionDate: null,
    documents: null,
    natureOfConstruction: null,
    landMark: null,
    isRevised: null,
    sectorNoPlotNo: null,
    projectType: null,
    proposalType: null,
    tenantId,
    department: null,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: null,
        locality: {
          code: null
        },
        region: null,
        doorNo: null,
        areaType: null
      },
      tenantId
    },
    businessService: applicationFlow === 'DA' ? 'BPA_MAPSUB_DA' : 'BPA_MAPSUB_AVP',
    selectedOffice: null
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const Step2$5 = ({
  formData,
  handleTabChange,
  initFormMTDocs
}) => {
  var _formData$description;
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    reset,
    trigger
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  const modalMsg = {
    title: "Building Plan Upload – Declaration",
    body: `<p style="font-size:14px; text-align:left;">
    Before uploading the building plan drawing, please ensure the following mandatory Do’s are complied with:
  </p>  <ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
    <li style="margin-bottom:6px;">Always use the prescribed template for preparing the building plan map.</li>
    <li style="margin-bottom:6px;">Do not scale, stretch, rotate, crop, or modify the template in any manner.</li>
    <li style="margin-bottom:6px;">Always prepare, plot, print, and upload the drawing PDF in ISO A0 size.</li>
    <li style="margin-bottom:6px;">All drawings must be prepared using Meter (m) as the unit of measurement.</li>
    <li style="margin-bottom:6px;">Always select edge-to-edge template selection while creating the PDF.</li>
    <li style="margin-bottom:6px;">All plans, information, and data must remain strictly within the prescribed template area.</li>
    <li style="margin-bottom:6px;">Ensure there are no missing, extra, or duplicate elements outside the defined template boundary.</li>
    <li style="margin-bottom:6px;">Do not include watermarks, background images, or decorative graphics.</li>
    <li style="margin-bottom:6px;">Ensure compliance with all applicable Building Bye-laws, Development Control Regulations, and Authority norms.</li>
  </ul>

  <p style="font-size:14px; text-align:left;">
    By proceeding, you confirm that all the above conditions have been carefully reviewed and complied with.
  </p>

  <br/>`,
    type: "warning",
    redirectPath: null,
    btnText: "I Agree & Proceed"
  };
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents]);
  useEffect(() => {
    if ((documents === null || documents === void 0 ? void 0 : documents.length) >= 0) {
      setValue("documents", documents);
    }
  }, [documents, setValue]);
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" || (formData === null || formData === void 0 ? void 0 : formData.schemeType) === "Scheme";
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Details")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form self-certified custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing Pdf"),
    control: control,
    name: "drawingPdf",
    validationMsg: "(pdf file only and Max file Size 150 MB)",
    required: true,
    templateMessage: true,
    trigger: trigger,
    showModal: true,
    modalMsg: modalMsg
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Signature"),
    control: control,
    name: "signature",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: true,
    tab: 2,
    trigger: trigger
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Ownership document PDF"),
    control: control,
    name: "ownerShipDoc",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, null, isScheme && /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Sanction Layout"),
    control: control,
    name: "sanctionLayout",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    trigger: trigger
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

function SearchSummary$3({
  id,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration,
  logoData
}) {
  var _data$BPA;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  }, {
    formType: "MAP_SUB"
  });
  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id, refetch]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(MapSubmissionSummarys, {
    formData: data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0],
    ref: ref,
    handleDeclarationChange: handleDeclarationChange,
    declarationChecked: declarationChecked,
    showDeclaration: showDeclaration,
    logoData: logoData
  }));
}

const ResidentialSelfPortal = () => {
  var _departmentList$filte, _applicationData$land, _applicationData$land2, _applicationData$land3;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(Digit.SessionStorage.get("SELF_CURRENT_TAB") || 0);
  const [createDataResponse, setCreateDataResponse] = useState({});
  const [, setIsPreviewLoading] = useState(false);
  console.log("creatDataResponse", createDataResponse);
  const {
    applicationData,
    isAppDataLoading
  } = getResidentialData(id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const Modal = useModal();
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      BPA: {
        AVPSchemesUnitData: avpData
      } = {}
    } = {},
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["AVPSchemesUnitData"]);
  const avpUnits = avpData === null || avpData === void 0 ? void 0 : avpData.map(item => {
    return {
      name: item.Unit,
      label: item.Unit,
      value: item.Unit
    };
  });
  const villagesData = [];
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  console.log("logoData", {
    logoStore,
    avpLogo,
    daLogo
  });
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type === "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : (_departmentList$filte = departmentList.filter(item => item.Type === "AVP")) === null || _departmentList$filte === void 0 ? void 0 : _departmentList$filte.filter(item => item.ShortName === "UPAVP");
  function filterDepartmentsList(completeList) {
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    return officeNames;
  }
  const officesList = applicationFlow === "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_RESIDENTIAL", applicationData);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      data.planOn = "SELF_MAP";
      data.riskType = "LOW";
      data.businessService = applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      if (activeTab === 0 && !(data !== null && data !== void 0 && data.applicationNo)) {
        data.workflow = {
          action: "INITIATE",
          assignes: null
        };
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA, _res$BPA2;
          setCreateDataResponse(res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA[0]);
          if ((res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2.length) > 0) {
            onSelect("", res.BPA[0], true);
            Modal("Application Created", `Application Created Successfully!`, "success");
            setActiveTab(nextTab);
            Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        data.workflow = {
          action: activeTab !== 3 ? "UPLOAD_DOC" : "MAKE_PAYMENT_SELF",
          assignes: null
        };
        Digit.OBPSService.update({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA3, _res$BPA4;
          setCreateDataResponse(res === null || res === void 0 ? void 0 : (_res$BPA3 = res.BPA) === null || _res$BPA3 === void 0 ? void 0 : _res$BPA3[0]);
          if ((res === null || res === void 0 ? void 0 : (_res$BPA4 = res.BPA) === null || _res$BPA4 === void 0 ? void 0 : _res$BPA4.length) > 0) {
            onSelect("", res.BPA[0], true);
            Modal("Application Update", `Application Updated Successfully!`, "success");
            setActiveTab(nextTab);
            Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
            if (activeTab === 3) {
              var _formData$taxHeadEsti, _formData$taxHeadEsti2;
              history.push(`${citizenBaseUrl}/payment/collect/${formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.calculationBusinesserviceId}/${params === null || params === void 0 ? void 0 : params.applicationNo}/${tenantId}/tenantId=${tenantId}`);
              setActiveTab(3);
              Digit.SessionStorage.set("SELF_CURRENT_TAB", 3);
            }
          }
        }).catch(e => {
          var _e$response2, _e$response2$data, _e$response2$data$Err;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$Err = _e$response2$data.Errors[0]) === null || _e$response2$data$Err === void 0 ? void 0 : _e$response2$data$Err.message}`, "error");
        });
      }
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
    }
  };
  const handleLoadDocument = async fileStoreId => {
    try {
      await getDocumentByFileStoreId(fileStoreId, setIsPreviewLoading);
    } catch (error) {
      console.error("Error loading document:", error);
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const componentRef = useRef();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  if (isAppDataLoading && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id && isAppDataLoading && !(applicationData !== null && applicationData !== void 0 && (_applicationData$land = applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.owners) !== null && _applicationData$land2 !== void 0 && (_applicationData$land3 = _applicationData$land2[0]) !== null && _applicationData$land3 !== void 0 && _applicationData$land3.name)) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  const renderContent = () => {
    if (activeTab === 0) {
      return /*#__PURE__*/React__default.createElement(Step1$1, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id,
        officesList: officesList,
        villagesData: villagesData,
        departmentList: departmentList,
        isEmployee: false,
        applicationFlow: applicationFlow,
        avpUnits: avpUnits,
        avpData: avpData
      });
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step3$3, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step2$5, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id,
        initFormMTDocs: initFormMTDocs
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        }
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
        className: "template-Text",
        style: {
          fontSize: "1rem"
        }
      }, "NOTE - DRAWING TEMPLATE:"), /*#__PURE__*/React__default.createElement("a", {
        className: "pretty-link",
        style: {
          marginLeft: "5px"
        },
        onClick: () => handleLoadDocument("e30ebe3d-f548-405e-9ec3-130a2ffd3c37")
      }, "DOWNLOAD")), /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Attach all necessary documents demonstrating legal ownership ", /*#__PURE__*/React__default.createElement("span", null, "*"))));
    } else if (activeTab === 3 && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary$3, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true,
        logoData: applicationFlow == "DA" ? daLogo : avpLogo
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(4, params),
        disabled: !declarationChecked
      }))));
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      padding: "20px"
    },
    className: "bg-white"
  }, /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Self Certification via Registration"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Details of Map"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent())));
};

const Step1$3 = ({
  formData,
  userInfo,
  handleTabChange
}) => {
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [watchPlanOn] = watch(["planOn"]);
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const onSubmit = data => {
    handleTabChange(1, data);
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Name of Owner",
    placeholder: "Enter Name",
    name: "ownerName",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.ownerName,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Address",
    placeholder: "Enter Address",
    name: "ownerAddress",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.ownerAddress,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.zoneType) || "Commercial",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(subUsesTypeList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.subZoneType) || "Commercial",
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.primaryUse) || "Commercial",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || "Shops",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(residentialPlanOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "planOn",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planOn,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchPlanOn !== "Others" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is this Site falls in Metro City"),
    control: control,
    data: yesOrNo,
    name: "isMetroCity",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isMetroCity,
    type: "radioButton"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("District"),
    placeholder: t("Select District"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.district,
    name: `district`,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: SortingAlphabatically(residentialNatureOfConstructionOptions),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "plotArea",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotArea,
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Project Type")}`,
    placeholder: "Select Project Type",
    name: "buildingClassification",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) || "Commercial Permission- 30Sqm",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I, hereby declare that the proposed construction/reconstruction is as per Master Plan and Prevailing Building Bye-Laws.")
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    disabled: !declarationChecked,
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step2$6 = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    reset
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleTabChange(2, data);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Ownership Document",
    control: control,
    name: "applicantPhoto",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: true,
    isMandatory: true,
    tab: 1
  }), /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Affidavit",
    control: control,
    name: "Affidavit",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Owner Signature"),
    control: control,
    name: "Owner Signature",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step3$7 = ({
  formData,
  handleTabChange
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const getCommercialData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const applicationData = {
    natureOfConstruction: null,
    landMark: null,
    planOn: null,
    isRevised: null,
    tehsil: null,
    schemeName: null,
    sectorNoPlotNo: null,
    fars: null,
    backSide: null,
    groundCoverages: null,
    setbackRears: null,
    setbackFronts: null,
    revenueVillage: null,
    subDevelopmentArea: null,
    developmentArea: null,
    isPlotSetback: null,
    isApprovedLayout: null,
    isSpecialProject: null,
    projectType: null,
    proposalType: null,
    sanctionNumber: null,
    sanctionDate: null,
    file: null,
    areaType: null,
    transactionNumber: uuidv4(),
    appliactionType: "BUILDING_PLAN_SCRUTINY",
    applicationSubType: "NEW_CONSTRUCTION",
    city: null,
    code: null,
    locality: null,
    doorNo: null,
    village: null,
    areaType: null,
    department: applicationFlow || null
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const CommercialSelfPortal = () => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const {
    applicationData,
    isAppDataLoading
  } = getCommercialData(t);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_RESIDENTIAL", applicationData);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      const data = {
        ...params,
        ...formData
      };
      Digit.OBPSService.create({
        BPA: data
      }, tenantId).then(res => {
        var _res$BPA;
        if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
          var _res$BPA2;
          Modal("Application Created", `Application Created Successfully!`, "success");
          history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`, {
            data: res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]
          });
        }
      }).catch(e => {
        var _e$response, _e$response$data, _e$response$data$Erro;
        Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
      });
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const renderContent = () => {
    if (activeTab === 0) {
      return /*#__PURE__*/React__default.createElement(Step1$3, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id
      });
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$6, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step3$7, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        id: id
      });
    }
  };
  if (isAppDataLoading && id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Self Approval Upto 30Sqm Commercial Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Applicant Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Geo-Location"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), renderContent());
};

const Step2$7 = ({
  formData,
  userInfo,
  handleTabChange,
  t,
  initFormMTDocs
}) => {
  var _formData$description2, _formData$description3, _formData$description4, _formData$description5;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  console.log("documentFromRedux", documents, formData);
  console.log("documentsectionRendered");
  const determineRiskType = formData => {
    const {
      activityAsPerMap,
      activityProposed,
      developmentArea,
      landArea,
      schemeType
    } = (formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand) || {};
    let riskType = "HIGH_NIVESH";
    if (activityAsPerMap === "Residential") {
      if (activityProposed === "Multi Unit" || activityProposed === "Group Housing" || activityProposed === "EWS Group Housing" || activityProposed === "LIG Group Housing" || activityProposed === "Affordable Group Housing") {
        riskType = "HIGH_NIVESH";
      } else if (activityProposed === "Row Houses" || activityProposed === "Semi Detached" || activityProposed === "Detached") {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else {
            if (schemeType === "Non Scheme") {
              riskType = "HIGH";
            }
          }
        } else {
          if (schemeType === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeType === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }
    return riskType;
  };
  const riskType = determineRiskType(formData);
  console.log("FinalriskType", riskType);
  const validateFiles = () => {
    var _formData$description;
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" ? ["completeDrawingFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA"] : ["completeDrawingFile", "registrySaleDeedHPTA"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation
    },
    documents: documents
  };
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) === "Scheme";
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    var _formData$documents;
    console.log("insideStep3effect");
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      var _formData$documents2;
      console.log("insideStep3effectIfCondition", formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.length);
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents, formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.schemeType]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  const onSubmit = data => {
    const allowedDocs = isSchemeType ? ["completeDrawingFile", "kmlFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA", "sajraPlan", "giftDeed", "applicantPhoto", "signature"] : ["completeDrawingFile", "kmlFile", "developerConsortiumSalesAgreement", "khatauni", "registrySaleDeedHPTA", "mutationLetter", "sajraPlan", "applicantPhoto", "signature"];
    const conditionalDocs = documents === null || documents === void 0 ? void 0 : documents.filter(doc => allowedDocs.includes(doc.documentType));
    console.log("conditionalDocs", conditionalDocs);
    data = {
      ...data,
      riskType,
      descriptionOfLand: {
        ...data.descriptionOfLand,
        googleMapCoordinates: coordinate,
        googleMapLocation: googleLocation
      },
      documents: conditionalDocs
    };
    console.log("dataFromstep2", data);
    handleTabChange(2, data);
    console.log("insdieElseFromsubmit", showError);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-3",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-12"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 0px",
      fontWeight: "600",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      textAlign: "right",
      color: "rgb(2, 11, 15)",
      padding: "9px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "clickHere",
    onClick: handleClick
  }, "Click here,"), "\xA0to know how to create a .kml file.")))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including location/site plan, key plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "Upload File",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType && /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Allotment letter/Possession letter",
    control: control,
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Developer/Consortium/Sales Agreement",
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Khatauni",
    name: "khatauni",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMandatory: true,
    required: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Mutation Letter",
    name: "mutationLetter",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Site Superimposed on Sajra Plan",
    control: control,
    name: "sajraPlan",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => {
      handleTabChange(0);
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const getPropertyDetails = ({
  userInfo,
  applicationFlow
}) => {
  const tenantId = Digit.ULBService.getStateId();
  const consultantCategory = filterCategory(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      consultantCategory: consultantCategory,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      businessService: "BPA_KYP",
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      }
    },
    department: applicationFlow,
    landAreaDetails: {
      city: null,
      locality: null,
      village: null,
      areaType: null
    },
    descriptionOfLand: {
      revenueVillageMohal: null,
      propertyType: null,
      khataNo: null,
      multipleKhasra: [{
        khasraNo: "",
        area: ""
      }],
      khatauniNo: null,
      areaForCluSqM: 0,
      nameofConcerned: null,
      natureOfTower: null,
      towerToBeProposed: null,
      proposedGoundCoverageSqM: null,
      whetherUsedBySingleCompany: null,
      installationFeesDeposited: null,
      nameofConcerned: null,
      sectorNo: null,
      schemeName: null,
      approachRoadWidths: null,
      totalPlotArea: 0,
      appliedLandUse: {
        name: null
      },
      whetherUsedBySingleCompany: null,
      propertyType: {
        name: null
      },
      installationFeesDeposited: null,
      isChangeOfLandInvolved: null,
      typeOfCLUInvolved: {
        name: null
      }
    },
    activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
    applicationType: "FORM_KYP",
    feeType: "ApplicationFee",
    workflow: {
      action: "INITIATE"
    },
    landInfo: {
      owners: [{
        name: null,
        fatherOrHusbandName: null,
        aadhaarNumber: "",
        mobileNumber: "",
        emailId: "",
        gender: null,
        correspondenceAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "PERMANENT"
        }
      }],
      tenantId
    },
    nocDetails: {
      applicantNOCData: null,
      additionalApplicantNOC: null,
      officerNOCData: null,
      additionalOfficerNOC: null,
      checkedByOfficer: null
    },
    businessService: null,
    documents: [],
    uiFlow: {
      flow: "Form_KYP"
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const RegisterProperty = () => {
  var _Digit, _Digit$UserService$ge;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(Digit.SessionStorage.get("RP_CURR_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("RP_CURRENT_SUBTAB")) || 0);
  const [createDataResponse, setCreateDataResponse] = useState({});
  const [showToast, setShowToast] = useState(null);
  const summaryRef = useRef();
  console.log("creatDataResponse", createDataResponse);
  const subTabLabels = [{
    label: "Applicant Information"
  }, {
    label: "LTP Information"
  }, {
    label: "Plot Details"
  }];
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const userType = info === null || info === void 0 ? void 0 : info.type;
  const isEmployee = userType === "EMPLOYEE";
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const {
    applicationData,
    isAppDataLoading
  } = getPropertyDetails(userInfo);
  const Modal = useModal();
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["LandUseVillageMasterData"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type === "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type === "AVP");
  function filterDepartmentsList(completeList) {
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    return officeNames;
  }
  const officesList = applicationFlow === "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_KYP", applicationData);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && selectedSubTab === 0 && !("additionalDetails" in params)) {
        data.businessService = "BPA_KYP_DA";
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(res => {
          var _res$LandUse;
          if ((res === null || res === void 0 ? void 0 : (_res$LandUse = res.LandUse) === null || _res$LandUse === void 0 ? void 0 : _res$LandUse.length) > 0) {
            onSelect("", {
              ...data,
              ...res.LandUse[0]
            }, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: res => {
              var _res$LandUse2;
              onSelect("", res === null || res === void 0 ? void 0 : (_res$LandUse2 = res.LandUse) === null || _res$LandUse2 === void 0 ? void 0 : _res$LandUse2[0]);
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("RP_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      try {
        if (activeTab === 2) {
          var _formData$description;
          console.log("insideActiveTab3", activeTab, nextTabNo);
          let redirectUrl = "";
          let message = "";
          const riskType = formData === null || formData === void 0 ? void 0 : formData.riskType;
          const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
          console.log("riskingTypeFrom", riskType, isLowRiskCase);
          const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
          if (isLowRiskCase) {
            data.nocDetails = {};
          }
          if (activeTab === 2) {
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
            redirectUrl = "/digit-ui/citizen/profile";
            message = "Application Approved";
          }
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: () => {
              onSelect("", data);
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong, please try again!`
              });
            }
          });
          Modal("Data has been saved successfully!", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> Forwarded to Department Successfully!`, "success", redirectUrl);
          clearParams();
        } else {
          console.log("insideELseACTIVETAB", activeTab, nextTabNo);
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: () => {
              var _Digit2;
              onSelect("", data);
              setActiveTab(nextTabNo);
              (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("RP_CURR_TAB", nextTabNo);
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong, please try again!`
              });
            }
          });
        }
      } catch (error) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    } else {
      var _Digit3;
      setActiveTab(nextTabNo);
      (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.set("RP_CURR_TAB", nextTabNo);
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$4, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            setFormData: setParams,
            applicationFlow: applicationFlow,
            initFormMTDocs: initFormMTDocs,
            officesList: officesList,
            setShowToast: setShowToast,
            isEmployee: isEmployee,
            userInfo: userInfo
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$3, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$3, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            isEmployee: isEmployee
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$7, {
        formData: params,
        userInfo: userInfo,
        handleTabChange: handleTabChange,
        t: t,
        initFormMTDocs: initFormMTDocs
      });
    } else if (activeTab === 2 && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          marginTop: "20px"
        }
      }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
        formType: "formLandUse",
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: summaryRef,
        logoData: applicationFlow == "DA" ? daLogo : avpLogo
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#000"
          }
        }, "Print Summary"),
        content: () => summaryRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => {
          handleTabChange(0);
          handleSubTabChange(0);
        }
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: "#000"
        },
        onClick: () => handleTabChange(4, params)
      })))));
    }
  };
  if (isAppDataLoading && id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Know your plot"
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Applicant Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Documents"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels === null || subTabLabels === void 0 ? void 0 : subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const Step2$8 = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  var _formData$description, _migratedData$sanctio, _migratedData$sanctio2, _migratedData$sanctio3, _migratedData$sanctio4;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showRemarksEditor, setShowRemarksEditor] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");
  const [affidavitConditions, setAffidavitConditions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    data: mdmsData,
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["AffidavitConditions"]);
  const modalMsg = {
    title: "Building Plan Upload – Declaration",
    body: `<p style="font-size:14px; text-align:left;">
    Before uploading the building plan drawing, please ensure the following mandatory Do’s are complied with:
  </p>

  <ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
    <li style="margin-bottom:6px;">Always use the prescribed template for preparing the building plan map.</li>
    <li style="margin-bottom:6px;">Do not scale, stretch, rotate, crop, or modify the template in any manner.</li>
    <li style="margin-bottom:6px;">Always prepare, plot, print, and upload the drawing PDF in ISO A0 size.</li>
    <li style="margin-bottom:6px;">All drawings must be prepared using Meter (m) as the unit of measurement.</li>
    <li style="margin-bottom:6px;">Always select edge-to-edge template selection while creating the PDF.</li>
    <li style="margin-bottom:6px;">All plans, information, and data must remain strictly within the prescribed template area.</li>
    <li style="margin-bottom:6px;">Ensure there are no missing, extra, or duplicate elements outside the defined template boundary.</li>
    <li style="margin-bottom:6px;">Do not include watermarks, background images, or decorative graphics.</li>
    <li style="margin-bottom:6px;">Ensure compliance with all applicable Building Bye-laws, Development Control Regulations, and Authority norms.</li>
  </ul>

  <p style="font-size:14px; text-align:left;">
    By proceeding, you confirm that all the above conditions have been carefully reviewed and complied with.
  </p>

  <br/>`,
    type: "warning",
    redirectPath: null,
    btnText: "I Agree & Proceed"
  };
  useEffect(() => {
    var _mdmsData$BPA;
    if (mdmsData !== null && mdmsData !== void 0 && (_mdmsData$BPA = mdmsData.BPA) !== null && _mdmsData$BPA !== void 0 && _mdmsData$BPA.AffidavitConditions) {
      var _conditionsArray$;
      const conditionsArray = mdmsData.BPA.AffidavitConditions;
      if (conditionsArray.length > 0 && (_conditionsArray$ = conditionsArray[0]) !== null && _conditionsArray$ !== void 0 && _conditionsArray$.conditions) {
        setAffidavitConditions(conditionsArray[0].conditions);
        console.log("Affidavit conditions loaded:", conditionsArray[0].conditions);
      }
    }
  }, [mdmsData]);
  const ownerSigntaureDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => {
    var _doc$documentType;
    return (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.startsWith("signature_");
  });
  const defaultValues = {
    ...formData
  };
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const {
    handleSubmit,
    control,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  async function fetchLTPData() {
    var _userInfo$info;
    const createdBy = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
    try {
      var _response$Licenses, _ltpData$, _ltpData$$tradeLicens, _ltpData$$tradeLicens2;
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
        createdBy: createdBy
      });
      const ltpData = (response === null || response === void 0 ? void 0 : (_response$Licenses = response.Licenses) === null || _response$Licenses === void 0 ? void 0 : _response$Licenses.filter(e => e.status === "APPROVED")) || [];
      const regCert = (ltpData === null || ltpData === void 0 ? void 0 : (_ltpData$ = ltpData[0]) === null || _ltpData$ === void 0 ? void 0 : (_ltpData$$tradeLicens = _ltpData$.tradeLicenseDetail) === null || _ltpData$$tradeLicens === void 0 ? void 0 : (_ltpData$$tradeLicens2 = _ltpData$$tradeLicens.applicationDocuments) === null || _ltpData$$tradeLicens2 === void 0 ? void 0 : _ltpData$$tradeLicens2.filter(e => e.documentType === "Registration Certificate")) || [];
      if (documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === "Registration Certificate")) return;
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
  const migratedPlan = migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$sanctio = migratedData.sanctionFiles) === null || _migratedData$sanctio === void 0 ? void 0 : (_migratedData$sanctio2 = _migratedData$sanctio.find(item => item.fileType === "Plan")) === null || _migratedData$sanctio2 === void 0 ? void 0 : _migratedData$sanctio2.fileStoreURL;
  const migratedSanctionLetter = migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$sanctio3 = migratedData.sanctionFiles) === null || _migratedData$sanctio3 === void 0 ? void 0 : (_migratedData$sanctio4 = _migratedData$sanctio3.find(item => item.fileType === "Certificate")) === null || _migratedData$sanctio4 === void 0 ? void 0 : _migratedData$sanctio4.fileStoreURL;
  useEffect(() => {
    fetchLTPData();
  }, []);
  useEffect(() => {
    var _formData$documents;
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents]);
  useEffect(() => {
    if ((documents === null || documents === void 0 ? void 0 : documents.length) >= 0) {
      setValue("documents", documents);
    }
  }, [documents, setValue]);
  const handleGenerateAffidavit = () => {
    setShowRemarksEditor(true);
  };
  const handleSaveRemarks = () => {
    console.log("Saving remarks:", remarks);
    generatePDFUsingPrint();
  };
  const generatePDFUsingPrint = () => {
    if (!remarks || remarks.trim() === "") {
      setError("Please add conditions to generate affidavit");
      return;
    }
    try {
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Affidavit Document</title>
          <style>
            @page {
              margin: 20mm;
            }
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #000;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
            }
            .title {
              font-size: 24px;
              font-weight: bold;
              color: #1F4A7C;
              margin-bottom: 10px;
            }
            .applicant-info {
              background-color: #f8f9fa;
              padding: 15px;
              border-radius: 5px;
              margin-bottom: 20px;
              border: 1px solid #dee2e6;
            }
            .conditions {
              margin-top: 30px;
            }
            .condition-item {
              margin-bottom: 15px;
            }
            .signature {
              margin-top: 50px;
              text-align: center;
            }
            .signature-line {
              width: 300px;
              margin: 40px auto 10px;
              border-top: 1px solid #000;
            }
            @media print {
              body {
                font-size: 12pt;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">AFFIDAVIT</div>
            <div style="border-top: 2px solid #1F4A7C; margin: 20px 0;"></div>
          </div>
          
          <div class="applicant-info">
            <div><strong>Applicant Name:</strong> ${(formData === null || formData === void 0 ? void 0 : formData.applicantName) || "Not Provided"}</div>
            <div><strong>Application No:</strong> ${(formData === null || formData === void 0 ? void 0 : formData.applicationNumber) || "Not Provided"}</div>
            <div><strong>Date:</strong> ${new Date().toLocaleDateString()}</div>
          </div>
          
          <div class="conditions">
            <h3 style="color: #1F4A7C; border-bottom: 2px solid #1F4A7C; padding-bottom: 10px;">
              CONDITIONS AND DECLARATIONS
            </h3>
            ${remarks.split("\n\n").map(condition => `<div class="condition-item">${condition}</div>`).join("")}
          </div>
          
          <div class="signature">
            <div style="margin-top: 30px; padding: 20px; border-top: 1px solid #ddd;">
              <div class="signature-line"></div>
              <div style="margin-top: 10px;">
                <strong>Applicant Signature</strong>
              </div>
            </div>
          </div>
          
          <div style="text-align: center; margin-top: 50px; color: #666; font-size: 11px;">
            <p>Generated on ${new Date().toLocaleString()}</p>
            <p>Building Permission System</p>
          </div>
        </body>
        </html>
      `;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
          setShowRemarksEditor(false);
          setRemarks("");
          setError("");
        }, 500);
      };
    } catch (error) {
      console.error("Error generating PDF:", error);
      setError("Failed to generate PDF. Please try again.");
    }
  };
  const handleCloseRemarksEditor = () => {
    setShowRemarksEditor(false);
    setRemarks("");
    setError("");
  };
  const handleConditionSelect = condition => {
    if (!condition) return;
    setRemarks(prevRemarks => {
      if (prevRemarks) {
        const conditionAlreadyExists = prevRemarks.includes(condition.text);
        if (!conditionAlreadyExists) {
          return prevRemarks + "\n\n" + `Condition ${condition.id}: ${condition.text}`;
        }
        return prevRemarks;
      } else {
        return `Condition ${condition.id}: ${condition.text}`;
      }
    });
    setAnchorEl(null);
  };
  const SimpleMasterDropdown = () => {
    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: 9999
      }
    }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
      variant: "outlined",
      color: "primary",
      size: "small",
      label: "Master",
      type: "button",
      onClick: handleClick,
      endIcon: /*#__PURE__*/React__default.createElement(ArrowDropDownIcon, null),
      sx: {
        backgroundColor: "#1F4A7C",
        color: "white",
        fontSize: "12px",
        padding: "5px 10px",
        "&:hover": {
          backgroundColor: "#157CB3"
        }
      }
    }), /*#__PURE__*/React__default.createElement(Menu$1, {
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      PaperProps: {
        style: {
          maxHeight: 400,
          width: 500,
          maxWidth: "90vw",
          zIndex: 99999,
          position: "fixed"
        }
      },
      style: {
        zIndex: 99999
      },
      disablePortal: false,
      MenuListProps: {
        style: {
          padding: 0
        }
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "10px",
        backgroundColor: "#f5f5f5",
        borderBottom: "1px solid #ddd",
        fontWeight: "bold",
        color: "#1F4A7C"
      }
    }, "Affidavit Conditions"), isAvpDataLoading ? /*#__PURE__*/React__default.createElement(MenuItem$2, {
      disabled: true,
      style: {
        padding: "12px 16px"
      }
    }, "Loading conditions...") : affidavitConditions.length === 0 ? /*#__PURE__*/React__default.createElement(MenuItem$2, {
      disabled: true,
      style: {
        padding: "12px 16px"
      }
    }, "No conditions found") : affidavitConditions.map(condition => /*#__PURE__*/React__default.createElement(MenuItem$2, {
      key: condition.id,
      onClick: () => handleConditionSelect(condition),
      style: {
        whiteSpace: "normal",
        padding: "12px 16px",
        borderBottom: "1px solid #f0f0f0",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#f0f7ff"
        }
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "0"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontWeight: "bold",
        color: "#1F4A7C",
        marginBottom: "4px",
        fontSize: "13px"
      }
    }, "Condition ", condition.id), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "13px",
        color: "#555",
        lineHeight: "1.5",
        fontFamily: "'Noto Sans Devanagari', 'Arial', sans-serif"
      }
    }, condition.text))))));
  };
  const CustomRemarksEditor = ({
    setRemarks,
    remarks,
    setError,
    error
  }) => {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: 1
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        padding: "10px",
        backgroundColor: "#f8f9fa",
        borderRadius: "4px",
        position: "relative",
        zIndex: 1
      }
    }, /*#__PURE__*/React__default.createElement(SimpleMasterDropdown, null)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginBottom: "20px",
        padding: "12px",
        backgroundColor: "#e8f4fd",
        borderRadius: "6px",
        border: "1px solid #b6d4fe"
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold",
        color: "#1F4A7C",
        marginBottom: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Current Affidavit Text"), /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontSize: "12px",
        color: "#666",
        fontWeight: "normal"
      }
    }, remarks.length, " characters")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        minHeight: "60px",
        maxHeight: "120px",
        overflowY: "auto",
        padding: "10px",
        backgroundColor: "white",
        borderRadius: "4px",
        border: "1px solid #dee2e6",
        fontFamily: "'Noto Sans Devanagari', 'Arial', sans-serif",
        fontSize: "14px",
        lineHeight: "1.5",
        color: "#333",
        whiteSpace: "pre-line"
      }
    }, remarks || /*#__PURE__*/React__default.createElement("div", {
      style: {
        color: "#999",
        fontStyle: "italic",
        textAlign: "center",
        padding: "20px 0"
      }
    }, "No text yet. Click \"Master\" dropdown to add affidavit conditions.")), remarks && /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
      variant: "text",
      size: "small",
      label: "Clear All",
      onClick: () => setRemarks(""),
      sx: {
        color: "#dc3545",
        fontSize: "12px",
        "&:hover": {
          backgroundColor: "rgba(220, 53, 69, 0.1)"
        }
      }
    }))), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: 1
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold",
        color: "#1F4A7C",
        marginBottom: "8px"
      }
    }, "Edit Remarks:"), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: 1,
        minHeight: "200px"
      }
    }, /*#__PURE__*/React__default.createElement(RemarksEditor, {
      setRemarks: setRemarks,
      remarks: remarks,
      setError: setError,
      error: error
    }))));
  };
  const onSubmit = data => {
    data = {
      ...data,
      nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails
    };
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer card-stript"
  }, /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Sample Affidavit"))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer affidavit-box"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      padding: "1rem 2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      marginRight: "10px",
      minWidth: "100px"
    }
  }, "Affidavit Pdf:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "24px",
      height: "30px",
      cursor: "pointer",
      marginRight: "15px"
    },
    onClick: () => getDocumentByFileStoreId("9db90601-fd5e-416a-8fe9-cac1eec638d1", setIsPreviewLoading)
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-start"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "outlined",
    color: "primary",
    size: "small",
    label: "GENERATE AFFIDAVIT",
    type: "button",
    onClick: handleGenerateAffidavit,
    sx: {
      backgroundColor: "#28a745",
      color: "white",
      fontWeight: "bold",
      fontSize: "12px",
      textTransform: "uppercase",
      padding: "8px 16px",
      borderRadius: "4px",
      border: "none",
      minWidth: "180px",
      "&:hover": {
        backgroundColor: "#218838",
        border: "none"
      }
    }
  }))))))), (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) !== "New" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer card-stript"
  }, /*#__PURE__*/React__default.createElement(InfoBox$1, null, "Fetched Documents"))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer affidavit-box"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      padding: "1rem 2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    style: {
      marginBottom: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      marginRight: "10px",
      minWidth: "100px"
    }
  }, "Plan:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "24px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(migratedPlan, "_blank")
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  })), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      marginRight: "10px",
      minWidth: "100px"
    }
  }, "Sanction Letter:"), /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "24px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(migratedSanctionLetter, "_blank")
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  })))))), showRemarksEditor && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#fff",
      borderRadius: "8px",
      padding: "30px",
      width: "80%",
      maxWidth: "800px",
      maxHeight: "80vh",
      overflow: "auto",
      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
      position: "relative",
      zIndex: 10000
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      color: "#1F4A7C",
      borderBottom: "2px solid #1F4A7C",
      paddingBottom: "10px"
    }
  }, "Affidavit Conditions Editor"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      color: "#666",
      fontSize: "14px",
      marginTop: "5px"
    }
  }, "Use the \"Master\" dropdown to insert affidavit conditions into the text")), error && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px",
      backgroundColor: "#f8d7da",
      color: "#721c24",
      borderRadius: "4px",
      marginBottom: "20px",
      border: "1px solid #f5c6cb"
    }
  }, error), /*#__PURE__*/React__default.createElement(CustomRemarksEditor, {
    setRemarks: setRemarks,
    remarks: remarks,
    setError: setError,
    error: error
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
      borderTop: "1px solid #eee",
      paddingTop: "20px",
      position: "relative",
      zIndex: 1
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "outlined",
    color: "secondary",
    size: "medium",
    label: "Cancel",
    type: "button",
    onClick: handleCloseRemarksEditor,
    sx: {
      backgroundColor: "#6c757d",
      color: "white",
      "&:hover": {
        backgroundColor: "#5a6268"
      }
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Generate Affidavit",
    type: "button",
    onClick: handleSaveRemarks,
    sx: {
      backgroundColor: "#1F4A7C",
      "&:hover": {
        backgroundColor: "#157CB3"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Architect/Engineer Registration Certificate"),
    control: control,
    name: "Registration Certificate",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    trigger: trigger
  })), !isLowRiskCase && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Calculation sheet of Estimate with Affidavit"),
    control: control,
    name: "calculationSheet",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Khatauni"),
    control: control,
    name: "khatauni",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ownerAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing Pdf"),
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger,
    showModal: true,
    modalMsg: modalMsg
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    label: t("Allotment Letter/Possession Letter"),
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement"),
    control: control,
    name: "registrySaleDeedHPTA",
    isMandatory: true,
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Developer/Consortium/Sales Agreement"),
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "sitePhoto",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, ownerSigntaureDocuments && (ownerSigntaureDocuments === null || ownerSigntaureDocuments === void 0 ? void 0 : ownerSigntaureDocuments.length) > 0 ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: "250px",
      overflowY: "auto",
      overflowX: "hidden"
    }
  }, ownerSigntaureDocuments === null || ownerSigntaureDocuments === void 0 ? void 0 : ownerSigntaureDocuments.map((doc, index) => /*#__PURE__*/React__default.createElement("div", {
    key: doc.id || index,
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      width: "100%",
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "Owner Signature ", index + 1), /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    color: "info",
    onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(VisibilityIcon, null))))) : /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Signature"),
    control: control,
    name: "signature",
    validationMsg: "Upload File",
    required: true,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Signature"),
    control: control,
    name: "ltpSignature",
    validationMsg: "Upload File",
    required: true,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*"))))))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Audit Report"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Additional Document if any"),
    control: control,
    name: "additionalDoc",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Drawing and Design "),
    control: control,
    name: "structuraldrawing",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Stability Certificate"),
    control: control,
    name: "structuralcertificate",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Design calculation Report"),
    control: control,
    name: "calculationReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    label: t("Vetted Structure and drawing along with certificate"),
    name: "vettedStructure",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer."),
    control: control,
    name: "annexture789",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, isDA && /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Approved Layout sanctioned Letter"),
    control: control,
    name: "sanctionLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*"))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step4$3 = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule
}) => {
  var _formData$documents;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const drawingPdf = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(e => e.documentType === "drawingPdf")) || [];
  const [drawingDetail, setDrawingDetail] = useState(drawingPdf || []);
  const [open, setOpen] = useState(false);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState("");
  const [currentDocumentIndex, setCurrentDocumentIndex] = useState(null);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [savedFileStoreId, setSavedFileStoreId] = useState(null);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const formRef = useRef(null);
  console.log(drawingDetail, formData === null || formData === void 0 ? void 0 : formData.documents, drawingPdf, "drawingDetail");
  const onSubmit = () => {
    OpenPDFFromB64InPdfViewer();
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "viewPdf",
    label: "View Drawing",
    accessor: "documentType"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "url"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        pdfType: "DI"
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
    } catch (error) {
      console.error(error, "error");
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading || isPreviewLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    ref: formRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), /*#__PURE__*/React__default.createElement(InfoBox$1, {
    style: {
      fontSize: "14px",
      margin: "10px"
    }
  }, "I hereby declare that the map has been prepared as per the prevailing building byelaws and the map has been duly digitally signed by me. The fees has been calculated in accordance with the applicable policies, rules and government orders to the best of my knowledge."), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details  table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, drawingPdf === null || drawingPdf === void 0 ? void 0 : drawingPdf.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, "Submission ", index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row !== null && row !== void 0 && row.fileStoreId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(row.fileStoreId, setIsPreviewLoading)
  }) : "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, formData !== null && formData !== void 0 && formData.signedDrawingPdfId ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "20px",
      cursor: "pointer"
    },
    onClick: () => getDocumentByFileStoreId(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfId, setIsPreviewLoading)
  }) : /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "outlined",
    color: "primary",
    size: "small",
    label: "Attach Signature",
    type: "button",
    onClick: handleSign
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit")))))), !isEmployee && !isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "button",
    onClick: () => handleTabChange(3),
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const getSelfApprovalMapSubmissionData = (t, id = null) => {
  var _data$BPA, _applicationData89, _applicationData90, _applicationData91, _applicationData92, _applicationData93, _applicationData94, _applicationData95, _applicationData96, _applicationData97, _applicationData98, _applicationData98$to, _applicationData99, _applicationData100, _applicationData101, _applicationData101$p, _applicationData102, _applicationData103, _applicationData104, _applicationData105, _applicationData106, _applicationData107, _applicationData108, _applicationData108$p, _applicationData109, _applicationData110, _applicationData111, _applicationData112, _applicationData113, _applicationData114, _applicationData115, _applicationData116, _applicationData117, _applicationData117$b, _applicationData118, _applicationData119, _applicationData119$p, _applicationData120, _applicationData120$p, _Digit2, _applicationData121, _applicationData122, _applicationData123, _applicationData124, _applicationData125, _applicationData126, _userInfo$info, _userInfo$info2, _userInfo$info3, _applicationData127, _applicationData127$c, _applicationData128, _applicationData128$c, _applicationData129, _applicationData129$c, _applicationData130, _applicationData131, _applicationData132, _applicationData133, _applicationData134, _applicationData135, _applicationData136, _applicationData137, _applicationData138, _applicationData139, _applicationData140, _applicationData141, _applicationData142, _applicationData143, _applicationData144, _applicationData145, _applicationData146, _applicationData147, _applicationData148, _applicationData149, _applicationData150, _applicationData151, _applicationData152, _applicationData153, _applicationData154, _applicationData155, _applicationData156, _applicationData157, _applicationData158, _applicationData159, _applicationData160, _applicationData161, _applicationData162, _applicationData163, _applicationData164, _applicationData165, _applicationData166, _applicationData167, _applicationData168, _applicationData169, _applicationData170, _applicationData171, _applicationData172, _applicationData173, _applicationData174, _applicationData175, _applicationData176, _applicationData177, _applicationData178, _applicationData179, _applicationData180, _applicationData181, _applicationData182, _applicationData183, _applicationData184, _applicationData184$d, _applicationData185, _applicationData185$d, _applicationData186, _applicationData186$d, _applicationData187, _applicationData187$d, _applicationData187$d2, _applicationData187$d3, _applicationData188, _applicationData188$d, _applicationData188$d2, _applicationData188$d3, _applicationData189, _applicationData190, _applicationData190$m, _applicationData191, _applicationData191$m, _applicationData192, _applicationData193, _applicationData193$d, _applicationData194;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearch(tenantId, {
      applicationId: id,
      isEmployee: false
    });
  };
  const {
    data,
    isLoading: isAppDataLoading,
    isSuccess
  } = useQuery({
    queryKey: [id],
    queryFn: fetchApplicationData,
    enabled: isMdmsSuccess,
    refetchOnMount: "always"
  });
  let applicationData = (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || {};
  if (id && isSuccess) {
    var _applicationData, _applicationData2, _applicationData3, _applicationData4, _applicationData5, _applicationData6, _applicationData7, _applicationData7$tot, _applicationData8, _applicationData9, _applicationData10, _applicationData11, _applicationData12, _applicationData13, _applicationData14, _applicationData15, _applicationData16, _applicationData16$bl, _applicationData17, _applicationData18, _applicationData19, _applicationData19$pa, _applicationData20, _applicationData20$pa, _Digit, _applicationData21, _applicationData22, _applicationData23, _applicationData24, _applicationData25, _applicationData26, _applicationData27, _applicationData28, _applicationData29, _applicationData30, _applicationData31, _applicationData32, _applicationData33, _applicationData34, _applicationData35, _applicationData36, _applicationData37, _applicationData38, _applicationData39, _applicationData40, _applicationData41, _applicationData42, _applicationData43, _applicationData44, _applicationData45, _applicationData46, _applicationData47, _applicationData48, _applicationData49, _applicationData50, _applicationData51, _applicationData52, _applicationData53, _applicationData54, _applicationData55, _applicationData56, _applicationData57, _applicationData58, _applicationData59, _applicationData60, _applicationData61, _applicationData62, _applicationData63, _applicationData64, _applicationData65, _applicationData66, _applicationData67, _applicationData68, _applicationData69, _applicationData70, _applicationData71, _applicationData72, _applicationData73, _applicationData74, _applicationData75, _applicationData76, _applicationData76$de, _applicationData77, _applicationData78, _applicationData78$de, _applicationData79, _applicationData79$de, _applicationData80, _applicationData80$de, _applicationData81, _applicationData81$de, _applicationData81$de2, _applicationData81$de3, _applicationData82, _applicationData82$de, _applicationData82$de2, _applicationData82$de3, _applicationData83, _applicationData84, _applicationData84$ma, _applicationData85, _applicationData85$ma, _applicationData86, _applicationData87, _applicationData88;
    applicationData = {
      ...applicationData,
      applicationDate: ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : _applicationData.applicationDate) || null,
      occupancy: ((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.occupancy) || null,
      edcrNumber: ((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.edcrNumber) || null,
      totalBuildUpArea: (_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.totalBuildUpArea,
      totalProposedArea: (_applicationData5 = applicationData) === null || _applicationData5 === void 0 ? void 0 : _applicationData5.totalProposedArea,
      totalExistingBuiltUpArea: (_applicationData6 = applicationData) === null || _applicationData6 === void 0 ? void 0 : _applicationData6.totalExistingBuiltUpArea,
      maximumPermissibleGroundCoverage: ((_applicationData7 = applicationData) === null || _applicationData7 === void 0 ? void 0 : (_applicationData7$tot = _applicationData7.totalCoverageArea) === null || _applicationData7$tot === void 0 ? void 0 : _applicationData7$tot.toFixed(2)) || null,
      typeofArea: toTitleCase((_applicationData8 = applicationData) === null || _applicationData8 === void 0 ? void 0 : _applicationData8.landUseZone),
      propertyType: toTitleCase((_applicationData9 = applicationData) === null || _applicationData9 === void 0 ? void 0 : _applicationData9.applicantPropertyType),
      revenueVillageMohal: ((_applicationData10 = applicationData) === null || _applicationData10 === void 0 ? void 0 : _applicationData10.mauza) || null,
      khataNo: ((_applicationData11 = applicationData) === null || _applicationData11 === void 0 ? void 0 : _applicationData11.khataNo) || null,
      khatauniNo: ((_applicationData12 = applicationData) === null || _applicationData12 === void 0 ? void 0 : _applicationData12.khatauniNo) || null,
      plotArea: ((_applicationData13 = applicationData) === null || _applicationData13 === void 0 ? void 0 : _applicationData13.plotArea) || 0,
      totalPlotArea: ((_applicationData14 = applicationData) === null || _applicationData14 === void 0 ? void 0 : _applicationData14.plotArea) || 0,
      blocks: ((_applicationData15 = applicationData) === null || _applicationData15 === void 0 ? void 0 : _applicationData15.blocks) || null,
      noOfBlocks: ((_applicationData16 = applicationData) === null || _applicationData16 === void 0 ? void 0 : (_applicationData16$bl = _applicationData16.blocks) === null || _applicationData16$bl === void 0 ? void 0 : _applicationData16$bl.length) || 0,
      premiumFAR: ((_applicationData17 = applicationData) === null || _applicationData17 === void 0 ? void 0 : _applicationData17.premiumFarArea) || 0,
      demolitionArea: ((_applicationData18 = applicationData) === null || _applicationData18 === void 0 ? void 0 : _applicationData18.demolitionArea) || null,
      parkingArea: ((_applicationData19 = applicationData) === null || _applicationData19 === void 0 ? void 0 : (_applicationData19$pa = _applicationData19.parkingDetails) === null || _applicationData19$pa === void 0 ? void 0 : _applicationData19$pa.overAllParkingArea) || 0,
      parkingFloorNo: ((_applicationData20 = applicationData) === null || _applicationData20 === void 0 ? void 0 : (_applicationData20$pa = _applicationData20.parkingDetails) === null || _applicationData20$pa === void 0 ? void 0 : _applicationData20$pa.parkingFloorNo) || 0,
      activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0,
      riskType: (_applicationData21 = applicationData) === null || _applicationData21 === void 0 ? void 0 : _applicationData21.riskType,
      scrutinyFlow: ((_applicationData22 = applicationData) === null || _applicationData22 === void 0 ? void 0 : _applicationData22.scrutinyFlow) || ((_applicationData23 = applicationData) === null || _applicationData23 === void 0 ? void 0 : _applicationData23.edcrNumber) && "EDCR",
      planReport: (_applicationData24 = applicationData) === null || _applicationData24 === void 0 ? void 0 : _applicationData24.planReport,
      updatedDxfFile: (_applicationData25 = applicationData) === null || _applicationData25 === void 0 ? void 0 : _applicationData25.updatedDxfFile,
      dxfFile: (_applicationData26 = applicationData) === null || _applicationData26 === void 0 ? void 0 : _applicationData26.dxfFile,
      natureOfConstruction: ((_applicationData27 = applicationData) === null || _applicationData27 === void 0 ? void 0 : _applicationData27.natureOfConstruction) || ((_applicationData28 = applicationData) === null || _applicationData28 === void 0 ? void 0 : _applicationData28.natureOfConstruction),
      proposalType: (_applicationData29 = applicationData) === null || _applicationData29 === void 0 ? void 0 : _applicationData29.proposalType,
      sanctionDate: (_applicationData30 = applicationData) === null || _applicationData30 === void 0 ? void 0 : _applicationData30.sanctionDate,
      sanctionNumber: (_applicationData31 = applicationData) === null || _applicationData31 === void 0 ? void 0 : _applicationData31.sanctionNumber,
      noOfPlots: (_applicationData32 = applicationData) === null || _applicationData32 === void 0 ? void 0 : _applicationData32.noOfPlots,
      plotNumbers: (_applicationData33 = applicationData) === null || _applicationData33 === void 0 ? void 0 : _applicationData33.plotNumbers,
      district: (_applicationData34 = applicationData) === null || _applicationData34 === void 0 ? void 0 : _applicationData34.district,
      sectorNoPlotNo: (_applicationData35 = applicationData) === null || _applicationData35 === void 0 ? void 0 : _applicationData35.sectorNoPlotNo,
      tehsil: (_applicationData36 = applicationData) === null || _applicationData36 === void 0 ? void 0 : _applicationData36.tehsil,
      revenueVillage: (_applicationData37 = applicationData) === null || _applicationData37 === void 0 ? void 0 : _applicationData37.revenueVillage,
      landMark: (_applicationData38 = applicationData) === null || _applicationData38 === void 0 ? void 0 : _applicationData38.landMark,
      schemeName: (_applicationData39 = applicationData) === null || _applicationData39 === void 0 ? void 0 : _applicationData39.schemeName,
      buildingClassification: (_applicationData40 = applicationData) === null || _applicationData40 === void 0 ? void 0 : _applicationData40.buildingClassification,
      otherbuildingClass: (_applicationData41 = applicationData) === null || _applicationData41 === void 0 ? void 0 : _applicationData41.otherbuildingClass,
      planOn: (_applicationData42 = applicationData) === null || _applicationData42 === void 0 ? void 0 : _applicationData42.planOn,
      buildingHeight: (_applicationData43 = applicationData) === null || _applicationData43 === void 0 ? void 0 : _applicationData43.buildingHeight,
      projectType: (_applicationData44 = applicationData) === null || _applicationData44 === void 0 ? void 0 : _applicationData44.projectType,
      isRevised: (_applicationData45 = applicationData) === null || _applicationData45 === void 0 ? void 0 : _applicationData45.isRevised,
      prevFileNo: (_applicationData46 = applicationData) === null || _applicationData46 === void 0 ? void 0 : _applicationData46.prevFileNo,
      isSpecialProject: (_applicationData47 = applicationData) === null || _applicationData47 === void 0 ? void 0 : _applicationData47.isSpecialProject,
      typeOfProject: (_applicationData48 = applicationData) === null || _applicationData48 === void 0 ? void 0 : _applicationData48.typeOfProject,
      plotSubdivided: (_applicationData49 = applicationData) === null || _applicationData49 === void 0 ? void 0 : _applicationData49.plotSubdivided,
      plotNo: (_applicationData50 = applicationData) === null || _applicationData50 === void 0 ? void 0 : _applicationData50.plotNo,
      needCompounding: (_applicationData51 = applicationData) === null || _applicationData51 === void 0 ? void 0 : _applicationData51.needCompounding,
      plotLeaseHold: (_applicationData52 = applicationData) === null || _applicationData52 === void 0 ? void 0 : _applicationData52.plotLeaseHold,
      isApprovedLayout: (_applicationData53 = applicationData) === null || _applicationData53 === void 0 ? void 0 : _applicationData53.isApprovedLayout,
      isSpecialGroundCoverage: (_applicationData54 = applicationData) === null || _applicationData54 === void 0 ? void 0 : _applicationData54.isSpecialGroundCoverage,
      isSpecialFAR: (_applicationData55 = applicationData) === null || _applicationData55 === void 0 ? void 0 : _applicationData55.isSpecialFAR,
      constructionType: (_applicationData56 = applicationData) === null || _applicationData56 === void 0 ? void 0 : _applicationData56.constructionType,
      layoutsanctionNumber: (_applicationData57 = applicationData) === null || _applicationData57 === void 0 ? void 0 : _applicationData57.layoutsanctionNumber,
      layoutsanctionDate: (_applicationData58 = applicationData) === null || _applicationData58 === void 0 ? void 0 : _applicationData58.layoutsanctionDate,
      groundCoverage: (_applicationData59 = applicationData) === null || _applicationData59 === void 0 ? void 0 : _applicationData59.groundCoverages,
      far: (_applicationData60 = applicationData) === null || _applicationData60 === void 0 ? void 0 : _applicationData60.fars,
      isSetbackRequired: (_applicationData61 = applicationData) === null || _applicationData61 === void 0 ? void 0 : _applicationData61.isSetbackRequired,
      setbackFronts: (_applicationData62 = applicationData) === null || _applicationData62 === void 0 ? void 0 : _applicationData62.previousSetbackFront,
      setbackRears: (_applicationData63 = applicationData) === null || _applicationData63 === void 0 ? void 0 : _applicationData63.previousSetbackRear,
      setbackSide1: (_applicationData64 = applicationData) === null || _applicationData64 === void 0 ? void 0 : _applicationData64.previousSetbackSide1,
      setbackSide2: (_applicationData65 = applicationData) === null || _applicationData65 === void 0 ? void 0 : _applicationData65.previousSetbackSide2,
      zoneType: (_applicationData66 = applicationData) === null || _applicationData66 === void 0 ? void 0 : _applicationData66.zoneType,
      isMetroCity: (_applicationData67 = applicationData) === null || _applicationData67 === void 0 ? void 0 : _applicationData67.isMetroCity,
      subZoneType: (_applicationData68 = applicationData) === null || _applicationData68 === void 0 ? void 0 : _applicationData68.subZoneType,
      primaryUse: (_applicationData69 = applicationData) === null || _applicationData69 === void 0 ? void 0 : _applicationData69.primaryUse,
      activityProposed: (_applicationData70 = applicationData) === null || _applicationData70 === void 0 ? void 0 : _applicationData70.activityProposed,
      communityParking: (_applicationData71 = applicationData) === null || _applicationData71 === void 0 ? void 0 : _applicationData71.communityParking,
      anyotherCondition: (_applicationData72 = applicationData) === null || _applicationData72 === void 0 ? void 0 : _applicationData72.anyotherCondition,
      khasraNo: (_applicationData73 = applicationData) === null || _applicationData73 === void 0 ? void 0 : _applicationData73.khasraNo,
      sectorNo: (_applicationData74 = applicationData) === null || _applicationData74 === void 0 ? void 0 : _applicationData74.sectorNo,
      fastPASId: (_applicationData75 = applicationData) === null || _applicationData75 === void 0 ? void 0 : _applicationData75.land_Id,
      schemeType: (_applicationData76 = applicationData) === null || _applicationData76 === void 0 ? void 0 : (_applicationData76$de = _applicationData76.descriptionOfLand) === null || _applicationData76$de === void 0 ? void 0 : _applicationData76$de.schemeType,
      planOn: (_applicationData77 = applicationData) === null || _applicationData77 === void 0 ? void 0 : _applicationData77.planOn,
      typeOfArea: (_applicationData78 = applicationData) === null || _applicationData78 === void 0 ? void 0 : (_applicationData78$de = _applicationData78.descriptionOfLand) === null || _applicationData78$de === void 0 ? void 0 : _applicationData78$de.developmentArea,
      latitude: (_applicationData79 = applicationData) === null || _applicationData79 === void 0 ? void 0 : (_applicationData79$de = _applicationData79.descriptionOfLand) === null || _applicationData79$de === void 0 ? void 0 : _applicationData79$de.latitude,
      longitude: (_applicationData80 = applicationData) === null || _applicationData80 === void 0 ? void 0 : (_applicationData80$de = _applicationData80.descriptionOfLand) === null || _applicationData80$de === void 0 ? void 0 : _applicationData80$de.longitude,
      roadwidth: (_applicationData81 = applicationData) === null || _applicationData81 === void 0 ? void 0 : (_applicationData81$de = _applicationData81.descriptionOfLand) === null || _applicationData81$de === void 0 ? void 0 : (_applicationData81$de2 = _applicationData81$de.roadWidths) === null || _applicationData81$de2 === void 0 ? void 0 : (_applicationData81$de3 = _applicationData81$de2[0]) === null || _applicationData81$de3 === void 0 ? void 0 : _applicationData81$de3.value,
      approachRoadWidth: (_applicationData82 = applicationData) === null || _applicationData82 === void 0 ? void 0 : (_applicationData82$de = _applicationData82.descriptionOfLand) === null || _applicationData82$de === void 0 ? void 0 : (_applicationData82$de2 = _applicationData82$de.approachRoadWidths) === null || _applicationData82$de2 === void 0 ? void 0 : (_applicationData82$de3 = _applicationData82$de2[0]) === null || _applicationData82$de3 === void 0 ? void 0 : _applicationData82$de3.value,
      khasraDetails: (_applicationData83 = applicationData) === null || _applicationData83 === void 0 ? void 0 : _applicationData83.khasraDetails,
      mapSubDetails: {
        proposalTypeFAR: (_applicationData84 = applicationData) === null || _applicationData84 === void 0 ? void 0 : (_applicationData84$ma = _applicationData84.mapSubDetails) === null || _applicationData84$ma === void 0 ? void 0 : _applicationData84$ma.proposalTypeFAR,
        fireFighting: (_applicationData85 = applicationData) === null || _applicationData85 === void 0 ? void 0 : (_applicationData85$ma = _applicationData85.mapSubDetails) === null || _applicationData85$ma === void 0 ? void 0 : _applicationData85$ma.fireFighting
      },
      descriptionOfLand: (_applicationData86 = applicationData) === null || _applicationData86 === void 0 ? void 0 : _applicationData86.descriptionOfLand,
      landInfo: ((_applicationData87 = applicationData) === null || _applicationData87 === void 0 ? void 0 : _applicationData87.landInfo) || ((_applicationData88 = applicationData) === null || _applicationData88 === void 0 ? void 0 : _applicationData88.landInfo)
    };
    console.log("applicationDataINSIDEIIEI", applicationData);
    return {
      applicationData,
      isAppDataLoading
    };
  }
  if (id && !isSuccess) {
    return {
      applicationData: {},
      isAppDataLoading
    };
  }
  const applicationType = "FORM_MAP";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((_applicationData89 = applicationData) === null || _applicationData89 === void 0 ? void 0 : _applicationData89.applicantName);
  applicationData = {
    ...applicationData,
    tenantId,
    applicationNo: ((_applicationData90 = applicationData) === null || _applicationData90 === void 0 ? void 0 : _applicationData90.applicationNumber) || null,
    applicationDate: ((_applicationData91 = applicationData) === null || _applicationData91 === void 0 ? void 0 : _applicationData91.applicationDate) || null,
    applicationSubType: ((_applicationData92 = applicationData) === null || _applicationData92 === void 0 ? void 0 : _applicationData92.applicationSubType) || null,
    occupancy: ((_applicationData93 = applicationData) === null || _applicationData93 === void 0 ? void 0 : _applicationData93.occupancy) || null,
    edcrNumber: ((_applicationData94 = applicationData) === null || _applicationData94 === void 0 ? void 0 : _applicationData94.edcrNumber) || null,
    totalBuildUpArea: (_applicationData95 = applicationData) === null || _applicationData95 === void 0 ? void 0 : _applicationData95.totalBuildUpArea,
    totalProposedArea: (_applicationData96 = applicationData) === null || _applicationData96 === void 0 ? void 0 : _applicationData96.totalProposedArea,
    totalExistingBuiltUpArea: (_applicationData97 = applicationData) === null || _applicationData97 === void 0 ? void 0 : _applicationData97.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: ((_applicationData98 = applicationData) === null || _applicationData98 === void 0 ? void 0 : (_applicationData98$to = _applicationData98.totalCoverageArea) === null || _applicationData98$to === void 0 ? void 0 : _applicationData98$to.toFixed(2)) || null,
    typeofArea: toTitleCase((_applicationData99 = applicationData) === null || _applicationData99 === void 0 ? void 0 : _applicationData99.landUseZone),
    propertyType: toTitleCase(((_applicationData100 = applicationData) === null || _applicationData100 === void 0 ? void 0 : _applicationData100.applicantPropertyType) || ((_applicationData101 = applicationData) === null || _applicationData101 === void 0 ? void 0 : (_applicationData101$p = _applicationData101.planInfoProperties) === null || _applicationData101$p === void 0 ? void 0 : _applicationData101$p.PROPERTY_TYPE)),
    proposal: ((_applicationData102 = applicationData) === null || _applicationData102 === void 0 ? void 0 : _applicationData102.proposalSubmittedFor) || ((_applicationData103 = applicationData) === null || _applicationData103 === void 0 ? void 0 : _applicationData103.proposal) || null,
    revenueVillageMohal: ((_applicationData104 = applicationData) === null || _applicationData104 === void 0 ? void 0 : _applicationData104.mauza) || null,
    khataNo: ((_applicationData105 = applicationData) === null || _applicationData105 === void 0 ? void 0 : _applicationData105.khataNo) || null,
    khatauniNo: ((_applicationData106 = applicationData) === null || _applicationData106 === void 0 ? void 0 : _applicationData106.khatauniNo) || null,
    plotArea: ((_applicationData107 = applicationData) === null || _applicationData107 === void 0 ? void 0 : _applicationData107.plotArea) || ((_applicationData108 = applicationData) === null || _applicationData108 === void 0 ? void 0 : (_applicationData108$p = _applicationData108.plot) === null || _applicationData108$p === void 0 ? void 0 : _applicationData108$p.area) || 0,
    plotAreaDoc: (_applicationData109 = applicationData) === null || _applicationData109 === void 0 ? void 0 : _applicationData109.plotAreaDoc,
    plotAreaPos: (_applicationData110 = applicationData) === null || _applicationData110 === void 0 ? void 0 : _applicationData110.plotAreaPossession,
    siteAddress: (_applicationData111 = applicationData) === null || _applicationData111 === void 0 ? void 0 : _applicationData111.landAddress,
    totalPlotArea: ((_applicationData112 = applicationData) === null || _applicationData112 === void 0 ? void 0 : _applicationData112.plotArea) || 0,
    blocks: ((_applicationData113 = applicationData) === null || _applicationData113 === void 0 ? void 0 : _applicationData113.blocks) || null,
    basicFAR: ((_applicationData114 = applicationData) === null || _applicationData114 === void 0 ? void 0 : _applicationData114.basicFAR) || 0,
    purchasableFAR: ((_applicationData115 = applicationData) === null || _applicationData115 === void 0 ? void 0 : _applicationData115.purchasableFAR) || 0,
    premiumFAR: ((_applicationData116 = applicationData) === null || _applicationData116 === void 0 ? void 0 : _applicationData116.premiumFAR) || 0,
    noOfBlocks: ((_applicationData117 = applicationData) === null || _applicationData117 === void 0 ? void 0 : (_applicationData117$b = _applicationData117.blocks) === null || _applicationData117$b === void 0 ? void 0 : _applicationData117$b.length) || 0,
    demolitionArea: ((_applicationData118 = applicationData) === null || _applicationData118 === void 0 ? void 0 : _applicationData118.demolitionArea) || null,
    parkingArea: ((_applicationData119 = applicationData) === null || _applicationData119 === void 0 ? void 0 : (_applicationData119$p = _applicationData119.parkingDetails) === null || _applicationData119$p === void 0 ? void 0 : _applicationData119$p.overAllParkingArea) || 0,
    parkingFloorNo: ((_applicationData120 = applicationData) === null || _applicationData120 === void 0 ? void 0 : (_applicationData120$p = _applicationData120.parkingDetails) === null || _applicationData120$p === void 0 ? void 0 : _applicationData120$p.parkingFloorNo) || 0,
    activeTab: ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_TAB")) || 0,
    riskType: (_applicationData121 = applicationData) === null || _applicationData121 === void 0 ? void 0 : _applicationData121.riskType,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null
    },
    planReport: (_applicationData122 = applicationData) === null || _applicationData122 === void 0 ? void 0 : _applicationData122.planReport,
    updatedDxfFile: (_applicationData123 = applicationData) === null || _applicationData123 === void 0 ? void 0 : _applicationData123.updatedDxfFile,
    dxfFile: (_applicationData124 = applicationData) === null || _applicationData124 === void 0 ? void 0 : _applicationData124.dxfFile,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: (_applicationData125 = applicationData) === null || _applicationData125 === void 0 ? void 0 : _applicationData125.district,
        locality: {
          code: "Lucknow"
        },
        region: null,
        doorNo: null,
        areaType: (_applicationData126 = applicationData) === null || _applicationData126 === void 0 ? void 0 : _applicationData126.areaType
      },
      tenantId
    },
    professionaldetails: {
      name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId
    },
    landAreaDetails: {
      city: toTitleCase((_applicationData127 = applicationData) === null || _applicationData127 === void 0 ? void 0 : (_applicationData127$c = _applicationData127.correspondenceAddress) === null || _applicationData127$c === void 0 ? void 0 : _applicationData127$c.district) || null,
      locality: {
        name: toTitleCase((_applicationData128 = applicationData) === null || _applicationData128 === void 0 ? void 0 : (_applicationData128$c = _applicationData128.correspondenceAddress) === null || _applicationData128$c === void 0 ? void 0 : _applicationData128$c.tehsil) || null
      },
      village: {
        name: toTitleCase((_applicationData129 = applicationData) === null || _applicationData129 === void 0 ? void 0 : (_applicationData129$c = _applicationData129.correspondenceAddress) === null || _applicationData129$c === void 0 ? void 0 : _applicationData129$c.town) || null
      },
      areaType: (_applicationData130 = applicationData) === null || _applicationData130 === void 0 ? void 0 : _applicationData130.areaType
    },
    businessService: ((_applicationData131 = applicationData) === null || _applicationData131 === void 0 ? void 0 : _applicationData131.businessService) || (applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP"),
    documents,
    viewPdf: (_applicationData132 = applicationData) === null || _applicationData132 === void 0 ? void 0 : _applicationData132.viewPdf,
    viewPlanReport: (_applicationData133 = applicationData) === null || _applicationData133 === void 0 ? void 0 : _applicationData133.viewPlanReport,
    natureOfConstruction: (_applicationData134 = applicationData) === null || _applicationData134 === void 0 ? void 0 : _applicationData134.natureOfConstruction,
    proposalType: (_applicationData135 = applicationData) === null || _applicationData135 === void 0 ? void 0 : _applicationData135.proposalType,
    sanctionDate: (_applicationData136 = applicationData) === null || _applicationData136 === void 0 ? void 0 : _applicationData136.sanctionDate,
    sanctionNumber: (_applicationData137 = applicationData) === null || _applicationData137 === void 0 ? void 0 : _applicationData137.sanctionNumber,
    noOfPlots: (_applicationData138 = applicationData) === null || _applicationData138 === void 0 ? void 0 : _applicationData138.noOfPlots,
    plotNumbers: (_applicationData139 = applicationData) === null || _applicationData139 === void 0 ? void 0 : _applicationData139.plotNumbers,
    district: (_applicationData140 = applicationData) === null || _applicationData140 === void 0 ? void 0 : _applicationData140.district,
    sectorNoPlotNo: (_applicationData141 = applicationData) === null || _applicationData141 === void 0 ? void 0 : _applicationData141.sectorNoPlotNo,
    tehsil: (_applicationData142 = applicationData) === null || _applicationData142 === void 0 ? void 0 : _applicationData142.tehsil,
    revenueVillage: (_applicationData143 = applicationData) === null || _applicationData143 === void 0 ? void 0 : _applicationData143.revenueVillage,
    landMark: (_applicationData144 = applicationData) === null || _applicationData144 === void 0 ? void 0 : _applicationData144.landMark,
    schemeName: (_applicationData145 = applicationData) === null || _applicationData145 === void 0 ? void 0 : _applicationData145.schemeName,
    buildingClassification: (_applicationData146 = applicationData) === null || _applicationData146 === void 0 ? void 0 : _applicationData146.buildingClassification,
    otherbuildingClass: (_applicationData147 = applicationData) === null || _applicationData147 === void 0 ? void 0 : _applicationData147.otherbuildingClass,
    planOn: (_applicationData148 = applicationData) === null || _applicationData148 === void 0 ? void 0 : _applicationData148.planOn,
    buildingHeight: (_applicationData149 = applicationData) === null || _applicationData149 === void 0 ? void 0 : _applicationData149.buildingHeight,
    projectType: (_applicationData150 = applicationData) === null || _applicationData150 === void 0 ? void 0 : _applicationData150.projectType,
    isRevised: (_applicationData151 = applicationData) === null || _applicationData151 === void 0 ? void 0 : _applicationData151.isRevised,
    prevFileNo: (_applicationData152 = applicationData) === null || _applicationData152 === void 0 ? void 0 : _applicationData152.prevFileNo,
    isSpecialProject: (_applicationData153 = applicationData) === null || _applicationData153 === void 0 ? void 0 : _applicationData153.isSpecialProject,
    typeOfProject: (_applicationData154 = applicationData) === null || _applicationData154 === void 0 ? void 0 : _applicationData154.typeOfProject,
    plotSubdivided: (_applicationData155 = applicationData) === null || _applicationData155 === void 0 ? void 0 : _applicationData155.plotSubdivided,
    plotNo: (_applicationData156 = applicationData) === null || _applicationData156 === void 0 ? void 0 : _applicationData156.plotNo,
    needCompounding: (_applicationData157 = applicationData) === null || _applicationData157 === void 0 ? void 0 : _applicationData157.needCompounding,
    plotLeaseHold: (_applicationData158 = applicationData) === null || _applicationData158 === void 0 ? void 0 : _applicationData158.plotLeaseHold,
    isApprovedLayout: (_applicationData159 = applicationData) === null || _applicationData159 === void 0 ? void 0 : _applicationData159.isApprovedLayout,
    isSpecialGroundCoverage: (_applicationData160 = applicationData) === null || _applicationData160 === void 0 ? void 0 : _applicationData160.isSpecialGroundCoverage,
    isSpecialFAR: (_applicationData161 = applicationData) === null || _applicationData161 === void 0 ? void 0 : _applicationData161.isSpecialFAR,
    constructionType: (_applicationData162 = applicationData) === null || _applicationData162 === void 0 ? void 0 : _applicationData162.constructionType,
    layoutsanctionNumber: (_applicationData163 = applicationData) === null || _applicationData163 === void 0 ? void 0 : _applicationData163.layoutsanctionNumber,
    layoutsanctionDate: (_applicationData164 = applicationData) === null || _applicationData164 === void 0 ? void 0 : _applicationData164.layoutsanctionDate,
    groundCoverage: (_applicationData165 = applicationData) === null || _applicationData165 === void 0 ? void 0 : _applicationData165.groundCoverages,
    far: (_applicationData166 = applicationData) === null || _applicationData166 === void 0 ? void 0 : _applicationData166.fars,
    isSetbackRequired: (_applicationData167 = applicationData) === null || _applicationData167 === void 0 ? void 0 : _applicationData167.isSetbackRequired,
    setbackFronts: (_applicationData168 = applicationData) === null || _applicationData168 === void 0 ? void 0 : _applicationData168.previousSetbackFront,
    setbackRears: (_applicationData169 = applicationData) === null || _applicationData169 === void 0 ? void 0 : _applicationData169.previousSetbackRear,
    setbackSide1: (_applicationData170 = applicationData) === null || _applicationData170 === void 0 ? void 0 : _applicationData170.previousSetbackSide1,
    setbackSide2: (_applicationData171 = applicationData) === null || _applicationData171 === void 0 ? void 0 : _applicationData171.previousSetbackSide2,
    zoneType: (_applicationData172 = applicationData) === null || _applicationData172 === void 0 ? void 0 : _applicationData172.zoneType,
    isMetroCity: (_applicationData173 = applicationData) === null || _applicationData173 === void 0 ? void 0 : _applicationData173.isMetroCity,
    subZoneType: (_applicationData174 = applicationData) === null || _applicationData174 === void 0 ? void 0 : _applicationData174.subZoneType,
    primaryUse: (_applicationData175 = applicationData) === null || _applicationData175 === void 0 ? void 0 : _applicationData175.primaryUse,
    activityProposed: (_applicationData176 = applicationData) === null || _applicationData176 === void 0 ? void 0 : _applicationData176.activityProposed,
    communityParking: (_applicationData177 = applicationData) === null || _applicationData177 === void 0 ? void 0 : _applicationData177.communityParking,
    anyotherCondition: (_applicationData178 = applicationData) === null || _applicationData178 === void 0 ? void 0 : _applicationData178.anyotherCondition,
    khasraNo: (_applicationData179 = applicationData) === null || _applicationData179 === void 0 ? void 0 : _applicationData179.khasraNo,
    sectorNo: (_applicationData180 = applicationData) === null || _applicationData180 === void 0 ? void 0 : _applicationData180.sectorNo,
    uiFlow: {
      flow: "Form12"
    },
    fastPASId: (_applicationData181 = applicationData) === null || _applicationData181 === void 0 ? void 0 : _applicationData181.land_Id,
    scrutinyFlow: ((_applicationData182 = applicationData) === null || _applicationData182 === void 0 ? void 0 : _applicationData182.scrutinyFlow) || ((_applicationData183 = applicationData) === null || _applicationData183 === void 0 ? void 0 : _applicationData183.edcrNumber) && "EDCR",
    typeOfArea: (_applicationData184 = applicationData) === null || _applicationData184 === void 0 ? void 0 : (_applicationData184$d = _applicationData184.descriptionOfLand) === null || _applicationData184$d === void 0 ? void 0 : _applicationData184$d.developmentArea,
    latitude: (_applicationData185 = applicationData) === null || _applicationData185 === void 0 ? void 0 : (_applicationData185$d = _applicationData185.descriptionOfLand) === null || _applicationData185$d === void 0 ? void 0 : _applicationData185$d.latitude,
    longitude: (_applicationData186 = applicationData) === null || _applicationData186 === void 0 ? void 0 : (_applicationData186$d = _applicationData186.descriptionOfLand) === null || _applicationData186$d === void 0 ? void 0 : _applicationData186$d.longitude,
    roadwidth: (_applicationData187 = applicationData) === null || _applicationData187 === void 0 ? void 0 : (_applicationData187$d = _applicationData187.descriptionOfLand) === null || _applicationData187$d === void 0 ? void 0 : (_applicationData187$d2 = _applicationData187$d.roadWidths) === null || _applicationData187$d2 === void 0 ? void 0 : (_applicationData187$d3 = _applicationData187$d2[0]) === null || _applicationData187$d3 === void 0 ? void 0 : _applicationData187$d3.value,
    approachRoadWidth: (_applicationData188 = applicationData) === null || _applicationData188 === void 0 ? void 0 : (_applicationData188$d = _applicationData188.descriptionOfLand) === null || _applicationData188$d === void 0 ? void 0 : (_applicationData188$d2 = _applicationData188$d.approachRoadWidths) === null || _applicationData188$d2 === void 0 ? void 0 : (_applicationData188$d3 = _applicationData188$d2[0]) === null || _applicationData188$d3 === void 0 ? void 0 : _applicationData188$d3.value,
    khasraDetails: (_applicationData189 = applicationData) === null || _applicationData189 === void 0 ? void 0 : _applicationData189.khasraDetails,
    mapSubDetails: {
      proposalTypeFAR: (_applicationData190 = applicationData) === null || _applicationData190 === void 0 ? void 0 : (_applicationData190$m = _applicationData190.mapSubDetails) === null || _applicationData190$m === void 0 ? void 0 : _applicationData190$m.proposalTypeFAR,
      fireFighting: (_applicationData191 = applicationData) === null || _applicationData191 === void 0 ? void 0 : (_applicationData191$m = _applicationData191.mapSubDetails) === null || _applicationData191$m === void 0 ? void 0 : _applicationData191$m.fireFighting
    },
    descriptionOfLand: {
      ...((_applicationData192 = applicationData) === null || _applicationData192 === void 0 ? void 0 : _applicationData192.descriptionOfLand),
      schemeType: (_applicationData193 = applicationData) === null || _applicationData193 === void 0 ? void 0 : (_applicationData193$d = _applicationData193.descriptionOfLand) === null || _applicationData193$d === void 0 ? void 0 : _applicationData193$d.schemeType
    },
    landInfo: (_applicationData194 = applicationData) === null || _applicationData194 === void 0 ? void 0 : _applicationData194.landInfo
  };
  console.log("applicationDataFromOriginal", applicationData);
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const SelfApprovalPortal = () => {
  var _Digit, _Digit2, _Digit3, _userInfo$info, _applicationData$audi;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("SA_CURRENT_SUBTAB")) || 0);
  const [activeTab, setActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("SA_CURRENT_TAB")) || 0);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [summaryShow, setSummaryshow] = useState(((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARYSA_TAB")) || false);
  const history = useHistory();
  const {
    applicationData,
    isAppDataLoading
  } = getSelfApprovalMapSubmissionData(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userType = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.type;
  const isEmployee = userType === "EMPLOYEE";
  const Modal = useModal();
  const componentRef = useRef();
  const subTabLabels = [{
    label: "Application Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_APPROVAL", applicationData);
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      console.log(data, "updatedDatahere");
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (data !== null && data !== void 0 && data.additionalDetails) {
        delete data.additionalDetails;
      }
      if (activeTab === 0 && selectedSubTab === 0 && !id && !(data !== null && data !== void 0 && data.applicationNo)) {
        delete data.applicationNo;
        if (!data.workflow) {
          data.workflow = {};
        }
        data.riskType = "MEDIUM";
        data.workflow.action = "INITIATE";
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA;
          if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
            onSelect("", {
              ...data,
              ...res.BPA[0]
            }, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA2;
              onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]);
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const {
    data: {
      BPA: {
        StandardBuildingDesigns: standardDesigns
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["StandardBuildingDesigns"]);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      var _ref;
      const data = {
        ...params,
        ...formData
      };
      const isSelfCert = (_ref = ["Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm", "Self Certification of residential Plot Area upto 300 SqM on approved layouts"]) === null || _ref === void 0 ? void 0 : _ref.includes(params === null || params === void 0 ? void 0 : params.planOn);
      console.log("isSelfCertFromTabchange", isSelfCert, params === null || params === void 0 ? void 0 : params.planOn);
      try {
        if (nextTabNo === 5 && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT",
            assignes: null
          };
        } else if (nextTabNo === 5 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        await updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA3;
            onSelect("", {
              ...data,
              ...(res === null || res === void 0 ? void 0 : (_res$BPA3 = res.BPA) === null || _res$BPA3 === void 0 ? void 0 : _res$BPA3[0])
            });
            if (nextTabNo === 5) {
              if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
              } else {
                var _params$taxHeadEstima, _Digit4, _Digit5, _Digit6;
                if (isSelfCert) {
                  history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else if ((params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : _params$taxHeadEstima.length) > 1) {
                  var _params$taxHeadEstima2, _params$taxHeadEstima3;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima2 = params.taxHeadEstimates) === null || _params$taxHeadEstima2 === void 0 ? void 0 : (_params$taxHeadEstima3 = _params$taxHeadEstima2[1]) === null || _params$taxHeadEstima3 === void 0 ? void 0 : _params$taxHeadEstima3.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else {
                  var _params$taxHeadEstima4, _params$taxHeadEstima5;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima4 = params.taxHeadEstimates) === null || _params$taxHeadEstima4 === void 0 ? void 0 : (_params$taxHeadEstima5 = _params$taxHeadEstima4[0]) === null || _params$taxHeadEstima5 === void 0 ? void 0 : _params$taxHeadEstima5.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                }
                clearParams();
                Digit.SessionStorage.del("FORM_SELF_APPROVAL");
                (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("EDCR_CREATE");
                (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("FASTPAS_ID");
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("SUMMARYSA_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("SA_CURRENT_TAB");
                Digit.SessionStorage.del("SA_CURRENT_SUBTAB");
              }
            } else {
              if (nextTabNo === 4) {
                Digit.SessionStorage.set("SUMMARYSA_TAB", true);
                setSummaryshow(true);
              }
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
    }
  };
  const applicationDataSignature = applicationData ? `${applicationData.applicationNo}-${(_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.lastModifiedTime}-${applicationData.status}` : null;
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading, applicationDataSignature]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$5, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            userInfo: userInfo,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id,
            onSelect: onSelect,
            initFormMTDocs: initFormMTDocs,
            standardDesigns: standardDesigns
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$2, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$4, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$4, {
            formData: params,
            handleTabChange: handleTabChange,
            isEmployee: isEmployee,
            initFormMTDocs: initFormMTDocs
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$8, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee,
        initFormMTDocs: initFormMTDocs
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step4$3, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(Step3$1, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4 && summaryShow && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(5, params),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(Step6, {
        formData: params,
        handleSubTabChange: handleTabChange
      });
    }
  };
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Self-Approval via LTP Form")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, {
    className: "technical-profession-section"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Fees"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application History"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const PlotDetailTable = ({
  isModalOpen,
  setIsModalOpen,
  modalFields,
  control,
  isRescrutiny,
  getValues,
  setShowToast,
  removePlotNo,
  addPlotNo
}) => {
  return /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: isModalOpen,
    onClose: () => setIsModalOpen(false),
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Add Plot Details"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Series No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Plot No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      padding: 8
    }
  }, "Action"))), /*#__PURE__*/React__default.createElement("tbody", null, modalFields && (modalFields === null || modalFields === void 0 ? void 0 : modalFields.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, index + 1), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `mapSubDetails.plotDetails[${index}].plotNo`,
    control: control,
    placeholder: "Plot No",
    type: "textInput",
    hasLabel: false,
    mandatory: true,
    disabled: isRescrutiny,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removePlotNo(index),
    color: "error"
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === (modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      const currentPlotNo = getValues(`mapSubDetails.plotDetails[${(modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1}].plotNo`);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      addPlotNo({
        plotNo: ""
      });
    },
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2,
    style: {
      fontWeight: "bold",
      textAlign: "right",
      padding: 8
    }
  }, "Total Plots Entered:"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      fontWeight: "bold",
      padding: 8
    }
  }, modalFields === null || modalFields === void 0 ? void 0 : modalFields.length))))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right",
      marginTop: 16
    },
    onClick: () => {
      const currentPlotNo = getValues(`mapSubDetails.plotDetails[${(modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1}].plotNo`);
      console.log("Getting Values", currentPlotNo);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      setIsModalOpen(false);
      setShowToast({
        key: "true",
        error: false,
        message: "Plot details saved successfully!"
      });
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "button",
    sx: {
      backgroundColor: "#157CB3",
      fontWeight: "bold",
      color: "#FFF"
    }
  }, "Save")), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "button",
    onClick: () => {
      setIsModalOpen(false);
    },
    sx: {
      backgroundColor: "#FFF",
      fontWeight: "bold",
      color: "#157CB3"
    }
  }, "Cancel")));
};

const SubStep1$d = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _formData$, _formData$drawingDeta, _documents$find, _documents$find2, _documents$find3, _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers, _nonSchemeTypeData$, _formData$description3, _fastPASData$descript3, _fastPASData$descript4, _fastPASData$descript5, _fastPASData$descript6, _fastPASData$descript7, _formData$description4, _fastPASData$descript8, _formData$description5, _fastPASData$descript9, _formData$description6, _formData$mapSubDetai3, _formData$mapSubDetai4, _formData$mapSubDetai5, _formData$mapSubDetai6, _fastPASData$addition5, _formData$mapSubDetai7, _formData$mapSubDetai8, _formData$description7, _fastPASData$descript10, _formData$description8, _fastPASData$descript11, _fastPASData$descript12, _fastPASData$descript13, _formData$description9, _Digit, _Digit$SessionStorage, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$mapSubDetai9, _formData$mapSubDetai10, _formData$mapSubDetai11, _formData$mapSubDetai12, _formData$mapSubDetai13, _fastPASData$descript14, _fastPASData$descript15;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  Digit.SessionStorage.set("compensatoryFarDoc", (_formData$ = formData[0]) === null || _formData$ === void 0 ? void 0 : _formData$.compensatoryFarDoc);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    documents
  } = useSelector(state => state.formMT);
  const isProd = process.env.REACT_APP_COUNTER_ID === "1453752";
  console.log("isProd", isProd);
  console.log("documentFromRedux", documents);
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [, scrutinyFlow, ScrutinySelector, setScrutinyFlow] = useScrutinyProcess(applicationFlow);
  const isDA = applicationFlow === "DA" || (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  console.log("APPLICATIONFLOW", isDA, applicationFlow);
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const isRescrutiny = (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : _formData$drawingDeta.length) > 0;
  const greenBuildingDocStoreId = documents === null || documents === void 0 ? void 0 : (_documents$find = documents.find(doc => doc.documentType === "greenBuildingDoc")) === null || _documents$find === void 0 ? void 0 : _documents$find.fileStoreId;
  const compensatoryFarDocStoreId = documents === null || documents === void 0 ? void 0 : (_documents$find2 = documents.find(doc => doc.documentType === "compensatoryFarDoc")) === null || _documents$find2 === void 0 ? void 0 : _documents$find2.fileStoreId;
  const plotSizePrescribedDocStoreId = documents === null || documents === void 0 ? void 0 : (_documents$find3 = documents.find(doc => doc.documentType === "plotSizePrescribedDoc")) === null || _documents$find3 === void 0 ? void 0 : _documents$find3.fileStoreId;
  console.log("greenBuildingDocStoreId", greenBuildingDocStoreId, compensatoryFarDocStoreId, scrutinyFlow);
  const defaultValues = useMemo(() => {
    var _formData$description, _formData$description2, _formData$mapSubDetai;
    return {
      ...formData,
      planOn: (formData === null || formData === void 0 ? void 0 : formData.planOn) || "",
      descriptionOfLand: {
        ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
        latitude: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude) || "",
        longitude: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.longitude
      },
      numberOfHotels: formData === null || formData === void 0 ? void 0 : formData.numberOfHotels,
      fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
      proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
      isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
      specialProject: formData === null || formData === void 0 ? void 0 : formData.specialProject,
      specialProjectType: formData === null || formData === void 0 ? void 0 : formData.specialProjectType,
      groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
      fars: formData === null || formData === void 0 ? void 0 : formData.fars,
      buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
      previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
      previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
      natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
      zone: formData === null || formData === void 0 ? void 0 : formData.zone,
      greenBuildingDoc: {
        fileStoreId: greenBuildingDocStoreId
      },
      compensatoryFarDoc: {
        fileStoreId: compensatoryFarDocStoreId
      },
      watchPlotSizePrescribedDoc: {
        fileStoreId: plotSizePrescribedDocStoreId
      },
      mapSubDetails: {
        ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
        plotDetails: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.plotDetails) || [{
          seriesNo: "",
          plotNo: ""
        }]
      }
    };
  }, [formData, greenBuildingDocStoreId, compensatoryFarDocStoreId, plotSizePrescribedDocStoreId]);
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues,
    mode: "onBlur",
    shouldUnregister: false
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && (districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  }));
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const {
    data: v2Data,
    isLoading: isV2DataLoading
  } = Digit.Hooks.obps.useMDMSV2(stateId, "BPA", ["ZoneWiseAuthorityName"]);
  console.log(data, "mdms data");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const watchDistrict = watch("district");
  const zoneList = useMemo(() => {
    var _v2Data$BPA;
    let zones = [];
    if (v2Data !== null && v2Data !== void 0 && (_v2Data$BPA = v2Data.BPA) !== null && _v2Data$BPA !== void 0 && _v2Data$BPA.ZoneWiseAuthorityName) {
      const districtLower = (watchDistrict || "").toLowerCase().trim();
      v2Data.BPA.ZoneWiseAuthorityName.forEach(auth => {
        const authorityLower = (auth.authorityName || "").toLowerCase();
        const isMatch = districtLower ? authorityLower.includes(districtLower) : true;
        if (isMatch) {
          var _auth$zones;
          (_auth$zones = auth.zones) === null || _auth$zones === void 0 ? void 0 : _auth$zones.forEach(z => {
            if (z.isActive) {
              zones.push({
                name: z.name,
                label: z.name
              });
            }
          });
        }
      });
      const uniqueZones = [];
      const map = new Map();
      for (const item of zones) {
        if (!map.has(item.name)) {
          map.set(item.name, true);
          uniqueZones.push(item);
        }
      }
      zones = uniqueZones;
    }
    return zones;
  }, [v2Data, watchDistrict]);
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const Modal = useModal();
  const {
    fields: modalFields,
    append: addPlotNo,
    remove: removePlotNo
  } = useFieldArray({
    control,
    name: "mapSubDetails.plotDetails"
  });
  const currentPlotNo = getValues(`mapSubDetails.plotDetails[${(modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1}].plotNo`);
  console.log("ModLAASAFIelds", modalFields);
  const [watchProposalType, watchisSpecialProject, watchSpecialProject, watchPlotSubdivided, watchNeedComp, watchplotLeaseHold, watchspecialProjectType, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchPlanOn, watchSpecialGroundCoverage, watchisSpecialFAR, watchProposal, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchSchemeType, watchProposalTypeFAR, watchGreenBuildingFAR, watchCompensatoryFAR, watchPlotArea, watchShelterFee, watchPurchasableFar, watchGroupHousingOrMultiUnits, watchedPlots, watchSchemeTypes, watchPlotSizePrescribed, watchPlotSizePrescribedDoc, watchCompunding, watchisAncestralProperty] = watch(["proposalType", "isSpecialProject", "specialProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "specialProjectType", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "proposal", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "descriptionOfLand.schemeType", "mapSubDetails.proposalTypeFAR", "greenBuildingFAR", "compensatoryFAR", "plotAreaDoc", "shelterFee", "purchasableFar", "groupHousingOrMultiUnits", "mapSubDetails.plotDetails", "schemeTypes", "plotSizePrescribed", "plotSizePrescribedDoc", "serviceType", "isAncestralProperty"]);
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const isSelfCert = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const getPlotNumbers = () => {
    return plotInputs.map(plot => getValues(`plotNumbers[${plot.index}]`));
  };
  useEffect(() => {
    if (formData) {
      var _formData$mapSubDetai2;
      const currentDevelopmentPlan = getValues("developmentPlan") || (formData === null || formData === void 0 ? void 0 : formData.developmentPlan);
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        specialProject: formData === null || formData === void 0 ? void 0 : formData.specialProject,
        specialProjectType: formData === null || formData === void 0 ? void 0 : formData.specialProjectType,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
        developmentPlan: currentDevelopmentPlan || (formData === null || formData === void 0 ? void 0 : formData.developmentPlan),
        compensatoryFarDoc: {
          fileStoreId: compensatoryFarDocStoreId
        },
        greenBuildingDoc: {
          fileStoreId: greenBuildingDocStoreId
        },
        mapSubDetails: {
          ...(formData === null || formData === void 0 ? void 0 : formData.mapSubDetails),
          plotDetails: (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai2 = formData.mapSubDetails) === null || _formData$mapSubDetai2 === void 0 ? void 0 : _formData$mapSubDetai2.plotDetails) || [{
            seriesNo: "",
            plotNo: ""
          }]
        }
      });
    }
  }, [formData]);
  const switchedToPdfRef = useRef(false);
  useEffect(() => {
    if (!isDA && scrutinyFlow === "EDCR" && watchnatureOfConstruction === "Compounding") {
      Promise.resolve(Modal("Compounding via PDF", "With AVP and EDCR, compounding must be done via PDF.", "warning")).then(() => {
        if (getValues("natureOfConstruction") === "Compounding") {
          switchedToPdfRef.current = true;
          setScrutinyFlow("PDF");
        }
      });
    } else if (switchedToPdfRef.current && watchnatureOfConstruction !== "Compounding") {
      switchedToPdfRef.current = false;
      setScrutinyFlow("EDCR");
    }
  }, [watchnatureOfConstruction, isDA, scrutinyFlow]);
  useEffect(() => {
    if (watchPurchasableFar === "yes" && !purchasableData) {
      Modal("Apply Purchasable FAR", "Apply Purchasable FAR Before Proceeding", "warning");
    }
  }, [purchasableData, watchPurchasableFar]);
  useEffect(() => {
    var _fastPASData$addition;
    if (watchnatureOfConstruction !== "Revalidation/Time Extension" && watchnatureOfConstruction !== null && fastPASData !== null && fastPASData !== void 0 && (_fastPASData$addition = fastPASData.additionalDetails) !== null && _fastPASData$addition !== void 0 && _fastPASData$addition.oldCaseApplicationNo) {
      Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
    }
  }, [fastPASData, watchnatureOfConstruction]);
  useEffect(() => {
    if (watchSchemeType === "Non Scheme" && (watchProposal === "Plot sub-division" || watchProposal === "Amalgamation")) {
      Modal("Not allowed.", `${watchProposal} is not allowed in Non Scheme Cases.`, "warning");
    }
  }, [watchProposal, watchSchemeType]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let mapSubData;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$filter, _response4, _response4$BPA, _response4$BPA$filter, _response5, _response5$BPA, _response5$BPA$filter, _data2, _data3, _data4, _data4$descriptionOfL, _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL, _data7, _data7$descriptionOfL, _data8, _data8$descriptionOfL, _data8$descriptionOfL2, _data9, _data9$descriptionOfL, _data10, _data10$descriptionOf, _data11, _data12, _mapSubData, _mapSubData2, _mapSubData3, _mapSubData4, _mapSubData5, _mapSubData6, _mapSubData7, _mapSubData8, _mapSubData9, _data13, _data13$descriptionOf, _data14, _data14$descriptionOf, _mapSubData10, _data15, _mapSubData11, _data16, _data17, _mapSubData12, _data18, _data18$additionalDet, _data19, _data20, _data20$descriptionOf, _data21, _data21$descriptionOf, _data22, _data22$descriptionOf, _data23, _data23$descriptionOf, _data23$descriptionOf2, _data23$descriptionOf3, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26, _data26$landInfo, _data26$landInfo$owne, _data26$landInfo$owne2, _data26$landInfo$owne3, _data27, _data27$descriptionOf, _data27$descriptionOf2, _data27$descriptionOf3, _data28, _data28$descriptionOf, _data29, _data29$descriptionOf, _data30, _data30$descriptionOf, _data31, _data31$descriptionOf, _data32, _data32$descriptionOf, _data32$descriptionOf2, _data32$descriptionOf3, _data33, _data33$descriptionOf, _data33$descriptionOf2, _data34, _data35, _data36, _mapSubData13, _data37, _data37$landInfo, _data37$landInfo$owne, _data37$landInfo$owne2, _data37$landInfo$owne3, _data38, _data38$descriptionOf, _data38$descriptionOf2, _data38$descriptionOf3, _data39, _data39$descriptionOf, _data40, _data40$descriptionOf, _data41;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        mapSubData = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_MAP")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        purchasableData = (_response5 = response) === null || _response5 === void 0 ? void 0 : (_response5$BPA = _response5.BPA) === null || _response5$BPA === void 0 ? void 0 : (_response5$BPA$filter = _response5$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response5$BPA$filter === void 0 ? void 0 : _response5$BPA$filter[0];
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data, _data$professionalInf;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data = data) === null || _data === void 0 ? void 0 : (_data$professionalInf = _data.professionalInformation) === null || _data$professionalInf === void 0 ? void 0 : _data$professionalInf.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("descriptionOfLand", (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.descriptionOfLand);
        setValue("businessService", ((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.department) === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP");
        setValue("zoneType", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$descriptionOfL = _data4.descriptionOfLand) === null || _data4$descriptionOfL === void 0 ? void 0 : _data4$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : _data6$descriptionOfL.landMark);
        setValue("sectorNo", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.sectorNo);
        setValue("khasraNo", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$descriptionOfL = _data8.descriptionOfLand) === null || _data8$descriptionOfL === void 0 ? void 0 : (_data8$descriptionOfL2 = _data8$descriptionOfL.khasraWithArea[0]) === null || _data8$descriptionOfL2 === void 0 ? void 0 : _data8$descriptionOfL2.khasraNo);
        setValue("schemeName", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.schemeName);
        setValue("planOn", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.planOn);
        setValue("riskType", (_data11 = data) === null || _data11 === void 0 ? void 0 : _data11.riskType);
        setValue("isGovernmentBuilding", (_data12 = data) === null || _data12 === void 0 ? void 0 : _data12.isGovernmentBuilding);
        setValue("approvalCertificateId", (_mapSubData = mapSubData) === null || _mapSubData === void 0 ? void 0 : _mapSubData.approvalCertificateId);
        setValue("approvalCertificateUrl", (_mapSubData2 = mapSubData) === null || _mapSubData2 === void 0 ? void 0 : _mapSubData2.approvalCertificateUrl);
        setValue("selfDrawingPdfId", (_mapSubData3 = mapSubData) === null || _mapSubData3 === void 0 ? void 0 : _mapSubData3.selfDrawingPdfId);
        setValue("selfDrawingPdfUrl", (_mapSubData4 = mapSubData) === null || _mapSubData4 === void 0 ? void 0 : _mapSubData4.selfDrawingPdfUrl);
        setValue("selfDrawingPdfId", (_mapSubData5 = mapSubData) === null || _mapSubData5 === void 0 ? void 0 : _mapSubData5.selfDrawingPdfId);
        setValue("proposalId", (_mapSubData6 = mapSubData) === null || _mapSubData6 === void 0 ? void 0 : _mapSubData6.proposalId);
        setValue("proposalUrl", (_mapSubData7 = mapSubData) === null || _mapSubData7 === void 0 ? void 0 : _mapSubData7.proposalUrl);
        setValue("editPdfViaPdfId", (_mapSubData8 = mapSubData) === null || _mapSubData8 === void 0 ? void 0 : _mapSubData8.editPdfViaPdfId);
        setValue("editPdfViaPdfUrl", (_mapSubData9 = mapSubData) === null || _mapSubData9 === void 0 ? void 0 : _mapSubData9.editPdfViaPdfUrl);
        setValue("activityProposed", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.activityProposed);
        setValue("plotArea", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$descriptionOf = _data14.descriptionOfLand) === null || _data14$descriptionOf === void 0 ? void 0 : _data14$descriptionOf.landArea);
        setValue("mapSubDetails.sanctionValidityStartDate", ((_mapSubData10 = mapSubData) === null || _mapSubData10 === void 0 ? void 0 : _mapSubData10.sanctionValidityStartDate) || ((_data15 = data) === null || _data15 === void 0 ? void 0 : _data15.layoutsanctionDate));
        setValue("mapSubDetails.sanctionValidityDate", ((_mapSubData11 = mapSubData) === null || _mapSubData11 === void 0 ? void 0 : _mapSubData11.sanctionValidityDate) || ((_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.validityDate));
        setValue("mapSubDetails.landUseApprovalLetter", (_data17 = data) === null || _data17 === void 0 ? void 0 : _data17.approvalLetterUrl);
        setValue("mapSubDetails.prevFileNo", ((_mapSubData12 = mapSubData) === null || _mapSubData12 === void 0 ? void 0 : _mapSubData12.applicationNo) || ((_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$additionalDet = _data18.additionalDetails) === null || _data18$additionalDet === void 0 ? void 0 : _data18$additionalDet.oldCaseApplicationNo));
        setValue("mapSubDetails.landUseApprovalLetter", (_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.approvalLetterUrl);
        setValue("plotArea", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$descriptionOf = _data20.descriptionOfLand) === null || _data20$descriptionOf === void 0 ? void 0 : _data20$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$descriptionOf = _data21.descriptionOfLand) === null || _data21$descriptionOf === void 0 ? void 0 : _data21$descriptionOf.plotAreaDoc);
        setValue("plotNo", ((_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$descriptionOf = _data22.descriptionOfLand) === null || _data22$descriptionOf === void 0 ? void 0 : _data22$descriptionOf.plotNo) || ((_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : (_data23$descriptionOf2 = _data23$descriptionOf.khasraDetails) === null || _data23$descriptionOf2 === void 0 ? void 0 : (_data23$descriptionOf3 = _data23$descriptionOf2[0]) === null || _data23$descriptionOf3 === void 0 ? void 0 : _data23$descriptionOf3.plotNo));
        setValue("plotAreaPos", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.plotAreaPossession);
        setValue("landAddress", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.landAddress);
        setValue("tehsil", ((_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$landInfo = _data26.landInfo) === null || _data26$landInfo === void 0 ? void 0 : (_data26$landInfo$owne = _data26$landInfo.owners) === null || _data26$landInfo$owne === void 0 ? void 0 : (_data26$landInfo$owne2 = _data26$landInfo$owne[0]) === null || _data26$landInfo$owne2 === void 0 ? void 0 : (_data26$landInfo$owne3 = _data26$landInfo$owne2.permanentAddress) === null || _data26$landInfo$owne3 === void 0 ? void 0 : _data26$landInfo$owne3.tehsil) || ((_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$descriptionOf = _data27.descriptionOfLand) === null || _data27$descriptionOf === void 0 ? void 0 : (_data27$descriptionOf2 = _data27$descriptionOf.khasraDetails) === null || _data27$descriptionOf2 === void 0 ? void 0 : (_data27$descriptionOf3 = _data27$descriptionOf2[0]) === null || _data27$descriptionOf3 === void 0 ? void 0 : _data27$descriptionOf3.tehsil) || "");
        setValue("typeOfArea", (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$descriptionOf = _data28.descriptionOfLand) === null || _data28$descriptionOf === void 0 ? void 0 : _data28$descriptionOf.developmentArea);
        setValue("subZoneType", (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$descriptionOf = _data29.descriptionOfLand) === null || _data29$descriptionOf === void 0 ? void 0 : _data29$descriptionOf.subLandUseAsPerLayout);
        setValue("latitude", (_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$descriptionOf = _data30.descriptionOfLand) === null || _data30$descriptionOf === void 0 ? void 0 : _data30$descriptionOf.latitude);
        setValue("longitude", (_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$descriptionOf = _data31.descriptionOfLand) === null || _data31$descriptionOf === void 0 ? void 0 : _data31$descriptionOf.longitude);
        setValue("descriptionOfLand.approachRoadWidths[0].value", (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$descriptionOf = _data32.descriptionOfLand) === null || _data32$descriptionOf === void 0 ? void 0 : (_data32$descriptionOf2 = _data32$descriptionOf.approachRoadWidths) === null || _data32$descriptionOf2 === void 0 ? void 0 : (_data32$descriptionOf3 = _data32$descriptionOf2[0]) === null || _data32$descriptionOf3 === void 0 ? void 0 : _data32$descriptionOf3.value);
        setValue("descriptionOfLand.roadWidths[0].value", (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$descriptionOf = _data33.descriptionOfLand) === null || _data33$descriptionOf === void 0 ? void 0 : (_data33$descriptionOf2 = _data33$descriptionOf.roadWidths[0]) === null || _data33$descriptionOf2 === void 0 ? void 0 : _data33$descriptionOf2.value);
        setValue("ConstructionType", (_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.constructionType);
        setValue("khasraDetails", (_data35 = data) === null || _data35 === void 0 ? void 0 : _data35.khasraDetails);
        setValue("approvalLetterUrl", (_data36 = data) === null || _data36 === void 0 ? void 0 : _data36.approvalLetterUrl);
        setValue("totalBuildUpArea", (_mapSubData13 = mapSubData) === null || _mapSubData13 === void 0 ? void 0 : _mapSubData13.totalBuildUpArea);
        setValue("district", ((_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$landInfo = _data37.landInfo) === null || _data37$landInfo === void 0 ? void 0 : (_data37$landInfo$owne = _data37$landInfo.owners) === null || _data37$landInfo$owne === void 0 ? void 0 : (_data37$landInfo$owne2 = _data37$landInfo$owne[0]) === null || _data37$landInfo$owne2 === void 0 ? void 0 : (_data37$landInfo$owne3 = _data37$landInfo$owne2.permanentAddress) === null || _data37$landInfo$owne3 === void 0 ? void 0 : _data37$landInfo$owne3.district) || ((_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$descriptionOf = _data38.descriptionOfLand) === null || _data38$descriptionOf === void 0 ? void 0 : (_data38$descriptionOf2 = _data38$descriptionOf.khasraDetails) === null || _data38$descriptionOf2 === void 0 ? void 0 : (_data38$descriptionOf3 = _data38$descriptionOf2[0]) === null || _data38$descriptionOf3 === void 0 ? void 0 : _data38$descriptionOf3.district) || "");
        if (watchnatureOfConstruction === "Compounding") {
          setValue("applicationType", "FORM_COMPOUNDING");
          setValue("planOn", "FORM_MAP_COMPOUNDING");
        }
        const isApproved = ((_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$descriptionOf = _data39.descriptionOfLand) === null || _data39$descriptionOf === void 0 ? void 0 : _data39$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$descriptionOf = _data40.descriptionOfLand) === null || _data40$descriptionOf === void 0 ? void 0 : _data40$descriptionOf.landArea;
        setRiskType((_data41 = data) === null || _data41 === void 0 ? void 0 : _data41.riskType);
        setSchemeType(isApproved);
        console.log("isApproved", isApproved);
        if (!isApproved) {
          var _data42, _data42$descriptionOf, _data42$descriptionOf2, _data42$descriptionOf3, _data43, _data43$descriptionOf, _data44, _data44$descriptionOf, _data44$descriptionOf2, _data45, _data45$descriptionOf, _data45$descriptionOf2, _data46, _data46$descriptionOf, _data46$descriptionOf2;
          console.log("insideIdIsApproved", isApproved);
          setValue("planOn", "Others");
          setValue("plotNo", ((_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$descriptionOf = _data42.descriptionOfLand) === null || _data42$descriptionOf === void 0 ? void 0 : (_data42$descriptionOf2 = _data42$descriptionOf.khasraDetails) === null || _data42$descriptionOf2 === void 0 ? void 0 : (_data42$descriptionOf3 = _data42$descriptionOf2[0]) === null || _data42$descriptionOf3 === void 0 ? void 0 : _data42$descriptionOf3.plotNo) || ((_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$descriptionOf = _data43.descriptionOfLand) === null || _data43$descriptionOf === void 0 ? void 0 : _data43$descriptionOf.plotNo));
          setValue("revenueVillage", (_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$descriptionOf = _data44.descriptionOfLand) === null || _data44$descriptionOf === void 0 ? void 0 : (_data44$descriptionOf2 = _data44$descriptionOf.khasraDetails) === null || _data44$descriptionOf2 === void 0 ? void 0 : _data44$descriptionOf2[0].village);
          setValue("tehsil", (_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$descriptionOf = _data45.descriptionOfLand) === null || _data45$descriptionOf === void 0 ? void 0 : (_data45$descriptionOf2 = _data45$descriptionOf.khasraDetails) === null || _data45$descriptionOf2 === void 0 ? void 0 : _data45$descriptionOf2[0].tehsil);
          setValue("district", (_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$descriptionOf = _data46.descriptionOfLand) === null || _data46$descriptionOf === void 0 ? void 0 : (_data46$descriptionOf2 = _data46$descriptionOf.khasraDetails) === null || _data46$descriptionOf2 === void 0 ? void 0 : _data46$descriptionOf2[0].district);
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  console.log("watchAtivityProposed", watchAtivityProposed);
  console.log("fastpasdata", fastPASData);
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const restrictedLayoutActivities = ["Layout Plan (Commercial)", "Layout Plan (Affordable Housing)", "Layout Plan (Residential)", "Layout Plan (Community Facilities)", "Layout Plan (Industrial)", "Layout Plan (Office)", "Layout Plan (Hi-Tech Township)", "Layout Plan (Integrated Township)", "Layout Plan (Traffic and Transport)"].includes(watchAtivityProposed);
  console.log({
    restrictedLayoutActivities
  }, "776767776");
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4, _masterData$2$Categor5;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : (_masterData$2$Categor5 = _masterData$2$Categor4.filter(item => {
      if (category === "Community Facilities (Public Amenities/Utilities Buildings)") {
        const removeActivities = ["Creche & Day Care Centre", "Inspection House", "Music / Dance & Drama Arts Training Centre", "Police Cheoki (With Staff Quarters)", "Reading Room", "Religious Building", "Standalone Hostel (upto 20 rooms)", "Transport 1 & 2 Parking", "Park & Open Space", "Open Air Theatre", "Museum", "Police Station", "Traffic", "Police Chowki", "Police Station (With Staff Quarters)", "Activities to be Added", "Traffic Park"];
        return !removeActivities.includes(item);
      }
      return true;
    })) === null || _masterData$2$Categor5 === void 0 ? void 0 : _masterData$2$Categor5.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled", masterData);
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType);
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchPrimaryUse);
  console.log(schemeType, "schemeTypeerrrrr", landUseList);
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const onSubmit = data => {
    var _fastPasdata$addition;
    if (data !== null && data !== void 0 && data.developmentPlan) {
      Digit.SessionStorage.set("DEVELOPMENT_PLAN", data.developmentPlan);
    }
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    console.log("datafromsubmit", data, fastPASData);
    if (watchnatureOfConstruction === "Compounding") {
      data.applicationType = "FORM_COMPOUNDING", data.planOn = "FORM_MAP_COMPOUNDING";
    }
    if (watchPurchasableFar === "yes" && !purchasableData) {
      Modal("Apply Purchasable FAR", "Apply Purchasable FAR Before Proceeding", "warning");
      return;
    }
    if (watchnatureOfConstruction !== "Revalidation/Time Extension" && watchnatureOfConstruction !== null && fastPasdata !== null && fastPasdata !== void 0 && (_fastPasdata$addition = fastPasdata.additionalDetails) !== null && _fastPasdata$addition !== void 0 && _fastPasdata$addition.oldCaseApplicationNo) {
      Modal("Map submission is not allowed.", "The FastPass ID you entered belongs to an older case and cannot be used for a new map submission. Please use a FastPass ID generated for the current case.", "warning");
      return;
    }
    if (watchSchemeType === "Non Scheme" && (watchProposal === "Plot sub-division" || watchProposal === "Amalgamation")) {
      Modal("Not allowed.", `${watchProposal} is not allowed in Non Scheme Cases.`, "warning");
      return;
    }
    if (scrutinyFlow === "EDCR") {
      var _fastPASData$landInfo, _fastPASData$landInfo2, _fastPASData$landInfo3, _fastPASData$addition2, _fastPASData$professi, _fastPASData$professi2, _fastPASData$professi3, _fastPASData$professi4, _user$correspondenceA, _fastPASData$descript, _fastPASData$landInfo4, _fastPASData$landInfo5, _fastPASData$landInfo6, _fastPASData$landInfo7, _fastPASData$landInfo8, _fastPASData$landInfo9, _fastPASData$document, _fastPASData$document2;
      data.file = file;
      data.greenBuildingDoc = greenBuildingDocStoreId;
      data.compensatoryFarDoc = compensatoryFarDocStoreId;
      data.plotSizePrescribedDoc = plotSizePrescribedDocStoreId;
      data.applicantName = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo = fastPASData.landInfo) === null || _fastPASData$landInfo === void 0 ? void 0 : (_fastPASData$landInfo2 = _fastPASData$landInfo.owners) === null || _fastPASData$landInfo2 === void 0 ? void 0 : (_fastPASData$landInfo3 = _fastPASData$landInfo2[0]) === null || _fastPASData$landInfo3 === void 0 ? void 0 : _fastPASData$landInfo3.name) || (formData === null || formData === void 0 ? void 0 : formData.applicantName);
      data.department = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || applicationFlow;
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition2 = fastPASData.additionalDetails) === null || _fastPASData$addition2 === void 0 ? void 0 : _fastPASData$addition2.selectedOffice) || "";
      data.licenseeName = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi = fastPASData.professionalInformation) === null || _fastPASData$professi === void 0 ? void 0 : _fastPASData$professi.name;
      data.licenseeLicenceNumber = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi2 = fastPASData.professionalInformation) === null || _fastPASData$professi2 === void 0 ? void 0 : _fastPASData$professi2.licenseNumber;
      data.licenseeMobileNumber = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi3 = fastPASData.professionalInformation) === null || _fastPASData$professi3 === void 0 ? void 0 : _fastPASData$professi3.mobileNumber;
      data.licenseeEmailId = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$professi4 = fastPASData.professionalInformation) === null || _fastPASData$professi4 === void 0 ? void 0 : _fastPASData$professi4.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA = user.correspondenceAddress) === null || _user$correspondenceA === void 0 ? void 0 : _user$correspondenceA.address;
      data.siteAddress = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.landAddress;
      data.applicantEmailId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo4 = fastPASData.landInfo) === null || _fastPASData$landInfo4 === void 0 ? void 0 : (_fastPASData$landInfo5 = _fastPASData$landInfo4.owners) === null || _fastPASData$landInfo5 === void 0 ? void 0 : (_fastPASData$landInfo6 = _fastPASData$landInfo5[0]) === null || _fastPASData$landInfo6 === void 0 ? void 0 : _fastPASData$landInfo6.emailId) || "";
      data.aplicantMobileNumber = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo7 = fastPASData.landInfo) === null || _fastPASData$landInfo7 === void 0 ? void 0 : (_fastPASData$landInfo8 = _fastPASData$landInfo7.owners) === null || _fastPASData$landInfo8 === void 0 ? void 0 : (_fastPASData$landInfo9 = _fastPASData$landInfo8[0]) === null || _fastPASData$landInfo9 === void 0 ? void 0 : _fastPASData$landInfo9.mobileNumber) || "";
      data.basicFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR) || 0;
      data.premiumFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR) || 0;
      data.purchasableFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR) || 0;
      data.scrutinyFlow = "EDCR";
      data.landInfo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo;
      data.approvalLetterId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.approvalLetterId;
      data.signatureId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$document = fastPASData.documents) === null || _fastPASData$document === void 0 ? void 0 : (_fastPASData$document2 = _fastPASData$document.filter(doc => doc.documentType === "signature")[0]) === null || _fastPASData$document2 === void 0 ? void 0 : _fastPASData$document2.fileStoreId) || null;
    }
    if (isCompounding) {
      var _fastPASData$descript2;
      data.landInfo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.tenantId = stateId;
      data.land_Id = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.documents = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents;
      data.nocDetails = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails;
      data.occupancy = data === null || data === void 0 ? void 0 : data.zoneType;
      data.totalProposedArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.landArea;
      data.department = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || applicationFlow;
    }
    if (scrutinyFlow !== "EDCR") {
      var _fastPASData$landInfo10, _fastPASData$landInfo11, _fastPASData$landInfo12, _fastPASData$landInfo13, _fastPASData$landInfo14, _fastPASData$landInfo15, _fastPASData$landInfo16, _fastPASData$landInfo17, _fastPASData$landInfo18, _fastPASData$addition3, _fastPASData$addition4, _purchasableData$desc, _purchasableData$desc2, _purchasableData$desc3, _fastPASData$document3, _fastPASData$document4, _user$correspondenceA2;
      data.plotNumbers = getPlotNumbers(), data.applicantName = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo10 = fastPASData.landInfo) === null || _fastPASData$landInfo10 === void 0 ? void 0 : (_fastPASData$landInfo11 = _fastPASData$landInfo10.owners) === null || _fastPASData$landInfo11 === void 0 ? void 0 : (_fastPASData$landInfo12 = _fastPASData$landInfo11[0]) === null || _fastPASData$landInfo12 === void 0 ? void 0 : _fastPASData$landInfo12.name) || "";
      data.applicantEmailId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo13 = fastPASData.landInfo) === null || _fastPASData$landInfo13 === void 0 ? void 0 : (_fastPASData$landInfo14 = _fastPASData$landInfo13.owners) === null || _fastPASData$landInfo14 === void 0 ? void 0 : (_fastPASData$landInfo15 = _fastPASData$landInfo14[0]) === null || _fastPASData$landInfo15 === void 0 ? void 0 : _fastPASData$landInfo15.emailId) || "";
      data.aplicantMobileNumber = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo16 = fastPASData.landInfo) === null || _fastPASData$landInfo16 === void 0 ? void 0 : (_fastPASData$landInfo17 = _fastPASData$landInfo16.owners) === null || _fastPASData$landInfo17 === void 0 ? void 0 : (_fastPASData$landInfo18 = _fastPASData$landInfo17[0]) === null || _fastPASData$landInfo18 === void 0 ? void 0 : _fastPASData$landInfo18.mobileNumber) || "";
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition3 = fastPASData.additionalDetails) === null || _fastPASData$addition3 === void 0 ? void 0 : _fastPASData$addition3.selectedOffice) || "";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition4 = fastPASData.additionalDetails) === null || _fastPASData$addition4 === void 0 ? void 0 : _fastPASData$addition4.selectedCity) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.purchasableFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : (_purchasableData$desc = purchasableData.descriptionOfLand) === null || _purchasableData$desc === void 0 ? void 0 : (_purchasableData$desc2 = _purchasableData$desc.properties) === null || _purchasableData$desc2 === void 0 ? void 0 : (_purchasableData$desc3 = _purchasableData$desc2[0]) === null || _purchasableData$desc3 === void 0 ? void 0 : _purchasableData$desc3.requiredAreaFAR) || 0;
      data.fastPASId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id;
      data.signatureId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$document3 = fastPASData.documents) === null || _fastPASData$document3 === void 0 ? void 0 : (_fastPASData$document4 = _fastPASData$document3.filter(doc => doc.documentType === "signature")[0]) === null || _fastPASData$document4 === void 0 ? void 0 : _fastPASData$document4.fileStoreId) || null;
      data.licenseeName = user === null || user === void 0 ? void 0 : user.name, data.licenseeLicenceNumber = user === null || user === void 0 ? void 0 : user.registrationNumber;
      data.licenseeMobileNumber = user === null || user === void 0 ? void 0 : user.mobileNumber;
      data.licenseeEmailId = user === null || user === void 0 ? void 0 : user.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA2 = user.correspondenceAddress) === null || _user$correspondenceA2 === void 0 ? void 0 : _user$correspondenceA2.address;
      data.scrutinyFlow = "PDF";
      data.department = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || applicationFlow;
      data.basicFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR) || 0;
      data.premiumFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR) || 0;
      data.purchasableFAR = (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR) || 0;
      data.landInfo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.approvalLetterId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.approvalLetterId;
      data.documents = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents;
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
    }
    const uploadedDocs = documents || [];
    data.documents = [...(data.documents || []), ...uploadedDocs];
    if (isSelfCert || scrutinyFlow !== "EDCR") {
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      handleTabChange(1, id ? {
        ...formData,
        ...data
      } : data);
    } else {
      handleSubTabChange(1, id ? {
        ...formData,
        ...data,
        file: file || (data === null || data === void 0 ? void 0 : data.file)
      } : data);
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  console.log("WatchNatueiu", watchnatureOfConstruction, formData);
  const closeToast = () => {
    setShowToast(null);
  };
  if (watchSpecialProject === "Type design" && getValues("plotNo")) {
    setValue("plotNo", "");
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  if (scrutinyFlow === null) {
    return /*#__PURE__*/React__default.createElement(ScrutinySelector, null);
  }
  const excludedActivitiesForResidential = ["Row Housing - Single units", "Semi-Detached - Single Units", "Detached - Single Units", "Row Housing - Multi units", "Semi-detached - Multi Units", "Detached - Multi Units", "Single Housing - EWS", "Single Housing - LIG"];
  const excludeActivitiesForCommercial1 = ["Auction Market", "Cold storage", "Emergency Stock", "Fruit & Vegetable Market", "Junk Yard", "LPG / Gas Godown", "Storage/Warehousing", "Store/Godown", "Wholesale centres for Agriculture produce", "Wholesale Market/Trade/Wholesale business"];
  const excludeActivitiesForCommercial3 = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];
  const excludeActivitiesForCommercialOfficeUse = ["Auction Market", "Emergency Stock", "Fruit & Vegetable Market", "Junk Yard", "LPG / Gas Godown", "Wholesale centres for Agriculture produce", "Wholesale Market/Trade/Wholesale business"];
  const excludeActivitiesForCommercialAgri = ["Canteen", "Coal & Wood Stock", "Commercial Complex", "Convenient Shopping", "Fruit & Vegetable Market", "Hotel (<20 rooms)", "Miniplex", "Motel", "Motor Vehicle Showroom (Automobile sales/Purchase, Workshop, Accessories Centre)", "Open-air/ Rooftop Restaurants", "PCO/Cellular Mobile Service", "Plotted Development", "Resort", "Restaurant", "Retail Shops", "Service Apartment", "Shopping Centre", "Shops for sale of Motor vehicle spare parts", "Showroom (other than motor vehicle)", "Resi-Com. Building"];
  const excludeMixedUseActivities = ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"];
  const excludePublicAmenitiesBuilt = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Information Centre", "Marriage Hall", "Meeting Hall", "Multipurpose Hall", "Museum", "Open Air Theatre", "Prison", "Theatre", "Utilities & Services", "Plotted Development"];
  const excludePublicAmenitiesGrameen = ["Auditorium", "Compost Plant", "Convention Centre", "Museum", "Open Air Theatre", "Prison", "Theatre"];
  const excludePublicActivitiesCommercial = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Creche and Day care Centre", "Dharamshala", "Information Centre", "Marriage Hall", "Meeting Hall", "Microwave and wireless centre", "Museum", "Open Air Theatre", "Prison", "Reading Room", "Theatre"];
  const excludePublicActivitiesLargeIndustries = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Convention Centre", "Creche and Day care Centre", "Dharamshala", "Information Centre", "Marriage Hall", "Meeting Hall", "Microwave and wireless centre", "Museum", "Open Air Theatre", "Prison", "Reading Room", "Theatre"];
  const excludePublicOfficeTraffic = ["Auditorium", "Banquet Hall", "Community Guidance Centre", "Community Hall", "Community Service Centre", "Community Welfare Centre", "Compost Plant", "Convention Centre", "Information Centre", "Marriage Hall", "Meeting Hall", "Multipurpose Hall", "Museum", "Open Air Theatre", "Prison", "Theatre"];
  const excludeAgricultural = ["Buildings/establishment related to public utilities and services", "Compost Plant", "Creche and Day care Centre", "Electric Sub-station", "Fire station", "Garbage Collection Centre", "Microwave and wireless centre", "Prison", "Public/Community Toilet", "Reading Room", "Sewerage treatment Plant", "Utilities & Services", "Water Works", "Plotted Development"];
  const sprinklerRequiredPrimaryUses = ["Community Facilities (Healthcare Buildings)", "Community Facilities (Educational Buildings)"];
  const includeIsBuildingFullySprinkledActivities = ["Group Housing", "Group Housing - Affordable", "Group Housing - EWS", "Group Housing - LIG", "Hotel (<20 rooms)", "Hotel (>20 rooms)", "All Buildings", "All Buildings", "Community Hall", "Auditorium", "Art Gallery/Exhibition Centre", "Museum", "Theatre", "Health club / Gymnasium", "Theatre", "Health club / Gymnasium", "Religious  Buildings", "Music / Dance and Drama Arts Training Centre", "Health club / Gymnasium", "Amusement Park", "Single Screen Cinema", "Miniplex", "Multiplex", "Club", "All Buildings", "Warehouse", "Cold Storage", "Store / Godown", "All Buildings", "Hazardous / Polluting Industry", "Hazardous Industries"];
  const categoryArray = Array.isArray(nonSchemeTypeData) && (_nonSchemeTypeData$ = nonSchemeTypeData[0]) !== null && _nonSchemeTypeData$ !== void 0 && _nonSchemeTypeData$.CategoryType ? nonSchemeTypeData[0].CategoryType.map(item => item.Category) : [];
  console.log("Categories:", categoryArray);
  const formattedCategoryArray = categoryArray.map(cat => ({
    name: cat,
    label: cat
  }));
  const getFilteredActivityOptions = () => {
    var _nonSchemeTypeData$2;
    const activityProposeData = nonSchemeTypeData === null || nonSchemeTypeData === void 0 ? void 0 : (_nonSchemeTypeData$2 = nonSchemeTypeData[0]) === null || _nonSchemeTypeData$2 === void 0 ? void 0 : _nonSchemeTypeData$2.CategoryType;
    if (!Array.isArray(activityProposeData)) return [];
    const residential = activityProposeData.find(item => item.Category === "Residential");
    const commercial = activityProposeData.find(item => item.Category === "Commercial");
    const industrial = activityProposeData.find(item => item.Category === "Industrial");
    const officeUse = activityProposeData.find(item => item.Category === "Office");
    const agriculture = activityProposeData.find(item => item.Category === "Agriculture");
    const trafficTransport = activityProposeData.find(item => item.Category === "Traffic & Transport");
    const recreational = activityProposeData.find(item => item.Category === "Parks, Play-ground / Open-spaces, Recreational");
    const communityHealth = activityProposeData.find(item => item.Category === "Community Facilities (Healthcare Buildings)");
    const communityEducation = activityProposeData.find(item => item.Category === "Community Facilities (Educational Buildings)");
    const publicAmenities = activityProposeData.find(item => item.Category === "Community Facilities (Public Amenities/Utilities Buildings)");
    const proposed = (commercial === null || commercial === void 0 ? void 0 : commercial["Activity Proposed"]) || [];
    const resProposed = (residential === null || residential === void 0 ? void 0 : residential["Activity Proposed"]) || [];
    const indProposed = (industrial === null || industrial === void 0 ? void 0 : industrial["Activity Proposed"]) || [];
    const officeProposed = (officeUse === null || officeUse === void 0 ? void 0 : officeUse["Activity Proposed"]) || [];
    const trafficProposed = (trafficTransport === null || trafficTransport === void 0 ? void 0 : trafficTransport["Activity Proposed"]) || [];
    const recreationProposed = (recreational === null || recreational === void 0 ? void 0 : recreational["Activity Proposed"]) || [];
    const agricultureProposed = (agriculture === null || agriculture === void 0 ? void 0 : agriculture["Activity Proposed"]) || [];
    const communityHealthProposed = (communityHealth === null || communityHealth === void 0 ? void 0 : communityHealth["Activity Proposed"]) || [];
    const communityEducationProposed = (communityEducation === null || communityEducation === void 0 ? void 0 : communityEducation["Activity Proposed"]) || [];
    const publicAmenitiesProposed = (publicAmenities === null || publicAmenities === void 0 ? void 0 : publicAmenities["Activity Proposed"]) || [];
    const landUse = watchlandUseType;
    const subZone = watchSubZoneType;
    const primaryUse = watchPrimaryUse;
    const simpleReturn = list => list.map(item => ({
      name: item,
      label: item
    }));
    console.log("commercial", trafficProposed);
    const conditions = [{
      match: landUse === "Commercial" && ["Commercial 1- Retail/CBD/Sub CBD", "Commercial 2- Wholesale/ Godown"].includes(subZone) && primaryUse === "Residential",
      excludeFrom: resProposed,
      excludeList: excludedActivitiesForResidential
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercial1
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Residential",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Residential" && subZone === "Grameen Abaadi",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercial3
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Mixed Use 1 & 2",
      excludeFrom: proposed,
      excludeList: excludeMixedUseActivities
    }, {
      match: primaryUse === "Commercial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: proposed,
      excludeList: ["Miniplex", "Multiplex", "Shopping Mall", "Shopping Centre", "Single Screen Cinema"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Office Use" && subZone === "Office Buildings",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialOfficeUse
    }, {
      match: primaryUse === "Commercial" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: proposed,
      excludeList: ["Emergency Stock", "Junk Yard", "LPG / Gas Godown"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building", "Shopping Mall", "Multiplex"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
      includeOnly: ["Canteen", "Multiplex", "Open-air/ Rooftop Restaurants", "PCO/Cellular Mobile Service", "Restaurant", "Retail Shops", "Shopping Mall", "Showroom (other than motor vehicle)"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: proposed,
      excludeList: excludeActivitiesForCommercialAgri
    }, {
      match: primaryUse === "Commercial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: proposed,
      excludeList: ["Resi-Com. Building"]
    }, {
      match: primaryUse === "Commercial" && landUse === "Green Belt" && subZone === "Green Belt",
      includeOnly: ["LPG / Gas Godown", "Petrol Pump/ Filling Station (CNG/PNG/EV)", "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)", "Shopping Mall", "Way-side Amenities/Dhaba"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Residential" && (subZone === "Built-up" || subZone === "Residential"),
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Data Processing Centre", "Flour Mill", "Hazardous / Polluting Industry", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park"]
    }, {
      match: primaryUse === "Industrial" && (landUse === "Residential" || landUse === "Commercial") && (subZone === "Grameen Abaadi" || subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street"),
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Data Processing Centre", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Small Industries",
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Data Processing Centre", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Milk Collection centre", "Plotted Development", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: indProposed,
      excludeOnly: ["Dangerous Industries", "Gas Godown", "Cold Storage"]
    }, {
      match: primaryUse === "Industrial" && (landUse === "Office Use" || landUse === "Public & Semi-Public Facilities") && (subZone === "Office Buildings" || subZone === "Public & Semi-Public"),
      excludeFrom: indProposed,
      excludeList: ["Data Processing Centre", "Logistic Park", "Service Industries", "Software / Information Technology Park", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Traffic & Transportation" && subZone === "Transport 1 & 2,Parking",
      excludeFrom: indProposed,
      excludeList: ["Data Processing Centre", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Recreational" && subZone === "Recreational-1 & 2",
      includeFrom: indProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: indProposed,
      excludeList: ["Dangerous Industries", "Data Processing Centre", "Service Industries", "Software / Information Technology Park"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      includeFrom: indProposed,
      includeOnly: ["Bio Diesel Plant", "Cottage Industries", "Dangerous Industries", "Flour Mill", "Industries (Other than MSME)", "Logistic Park", "Pasteurizing Plant", "Plotted Development", "Warehouse"]
    }, {
      match: primaryUse === "Industrial" && landUse === "Green Belt" && subZone === "Green Belt",
      includeFrom: indProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Office Use" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      includeFrom: officeProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Office Use" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: officeProposed,
      excludeList: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."]
    }, {
      match: primaryUse === "Office Use" && (landUse === "Traffic & Transportationl" || landUse === "Highway Facility Zone") && (subZone === "Transport 1 & 2,Parking" || subZone === "Highway Facilities"),
      includeFrom: officeProposed,
      includeOnly: ["Bank", "BPO", "Call Centre", "Cyber ​​cafe", "Private office, Agent Office etc."]
    }, {
      match: primaryUse === "Office Use" && (landUse === "Recreational" || landUse === "Agricultural" || landUse === "Green Belt") && (subZone === "Recreational-1 & 2" || subZone === "Agricultural" || subZone === "Green Belt"),
      includeFrom: officeProposed,
      includeOnly: ["Plotted Development"]
    }, {
      match: primaryUse === "Agriculture" && (landUse === "Residential" || landUse === "Industrial" || landUse === "Green Belt") && (subZone === "Built-up" || subZone === "Residential" || subZone === "Large Industries" || subZone === "Green Belt"),
      includeFrom: agricultureProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Agriculture" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation" || landUse === "Recreational" || landUse === "Highway Facility Zone") && (subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Bazaar Street" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Small Industries" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking" || subZone === "Recreational-1 & 2" || subZone === "Highway Facilities"),
      includeFrom: agricultureProposed,
      includeOnly: ["Cattle Colony", "Dairy Farm", "Poultry Farm"]
    }, {
      match: primaryUse === "Agriculture" && landUse === "Residential" && subZone === "Grameen Abaadi",
      includeFrom: agricultureProposed,
      includeOnly: ["Cattle Colony", "Dairy Farm", "Dhobi Ghat", "Poultry Farm"]
    }, {
      match: primaryUse === "Agriculture" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: agricultureProposed,
      excludeOnly: []
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Residential" || landUse === "Recreational") && (subZone === "Built-up" || subZone === "Residential" || subZone === "Recreational-1 & 2"),
      includeFrom: trafficProposed,
      includeOnly: ["Bus Stop", "Parking Lot", "Taxi/Tempo Stand"]
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Residential" || landUse === "Commercial") && (subZone === "Grameen Abaadi" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street"),
      includeFrom: trafficProposed,
      includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta", "Flying Club"]
    }, {
      match: primaryUse === "Traffic & Transport" && landUse === "Agricultural" && subZone === "Agricultural",
      includeFrom: trafficProposed,
      includeOnly: ["Bus Depot", "Bus Terminal", "Transport Nagar", "Weighbridge/ Dharmakanta"]
    }, {
      match: primaryUse === "Traffic & Transport" && (landUse === "Industrial" || landUse === "Commercial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation") && (subZone === "Mixed Use 1 & 2" || subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Small Industries" || subZone === "Large Industries" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: trafficProposed,
      excludeOnly: []
    }, {
      match: primaryUse === "Traffic & Transport" && landUse === "Green Belt" && subZone === "Green Belt",
      includeFrom: trafficProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Built-up",
      includeFrom: recreationProposed,
      includeOnly: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool"]
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Grameen Abaadi",
      includeFrom: recreationProposed,
      includeOnly: ["Park", "Playground/Sports Ground", "Swimming Pool"]
    }, {
      match: primaryUse === "Recreational" && landUse === "Residential" && subZone === "Residential",
      excludeFrom: recreationProposed,
      excludeOnly: ["Shooting Range", "Helipad"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Industrial") && (subZone === "Mixed Use 1 & 2" || subZone === "Small Industries"),
      excludeFrom: recreationProposed,
      excludeOnly: ["Shooting Range"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Office Use" || landUse === "Public & Semi-Public Facilities" || landUse === "Traffic & Transportation") && (subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street" || subZone === "Office Buildings" || subZone === "Public & Semi-Public" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: recreationProposed,
      excludeList: ["Club", "Park", "Playground/Sports Ground", "Swimming Pool", "Helipad"]
    }, {
      match: primaryUse === "Recreational" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Highway Facility Zone" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Highway Facilities" || subZone === "Green Belt"),
      excludeFrom: recreationProposed,
      excludeList: ["Club", "Shooting Range"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: communityHealthProposed,
      excludeList: ["Dental College", "Medical College"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Recreational" || landUse === "Agricultural" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Large Industries" || subZone === "Recreational-1 & 2" || subZone === "Agricultural" || subZone === "Green Belt"),
      includeFrom: communityHealthProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Industrial" && subZone === "Small Industries",
      excludeFrom: communityHealthProposed,
      excludeList: ["Hospitals (> 50 beds)", "Dental College", "Medical College", "Nursing Institutes"]
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: communityHealthProposed,
      excludeList: ["Maternity Hospitals", "Nursing Homes", "Orphanage", "Small Hospitals (Up to 50 beds)", "Reformatory"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Residential" && (subZone === "Built-up" || subZone === "Residential"),
      excludeFrom: communityEducationProposed,
      excludeOnly: ["Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Residential" || landUse === "Industrial") && (subZone === "Grameen Abaadi" || subZone === "Small Industries"),
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "Degree College", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Retail/CBD/Sub CBD",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Commercial" && subZone === "Commercial 1- Bazaar Street",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "General Education Institute", "Higher Technical Institute", "Management Institute", "Nursery School", "Polytechnic", "Library", "Primary school", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Commercial" || landUse === "Industrial" || landUse === "Recreational" || landUse === "Green Belt") && (subZone === "Commercial 2- Wholesale/ Godown" || subZone === "Large Industries" || subZone === "Recreational-1 & 2" || subZone === "Green Belt"),
      includeFrom: communityEducationProposed,
      includeOnly: []
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && (landUse === "Office Use" || landUse === "Traffic & Transportation") && (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
      includeFrom: communityEducationProposed,
      includeOnly: ["Nursery School", "Library", "Primary school", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: communityEducationProposed,
      excludeList: ["Cottage / Industry Training", "Degree College", "General Education Institute", "Higher Technical Institute", "Management Institute", "Polytechnic", "Technical Institute", "Universities"]
    }, {
      match: primaryUse === "Community Facilities (Educational Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      includeFrom: communityEducationProposed,
      includeOnly: ["Coaching Institutes/Centres", "Inter College", "Law College", "Secondary/High School", "Music / Dance and Drama Arts Training Centre", "Art Gallery/Exhibition centre", "Religious  Centre"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Built-up",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicAmenitiesBuilt
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" || landUse === "Commercial" || landUse === "Industrial" && subZone === "Residential" || subZone === "Mixed Use 1 & 2" || subZone === "Commercial 1- Retail/CBD/Sub CBD" || subZone === "Commercial 1- Bazaar Street" || subZone === "Small Industries",
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Prison"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Residential" && subZone === "Grameen Abaadi",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicAmenitiesGrameen
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Commercial" && subZone === "Commercial 2- Wholesale/ Godown",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicActivitiesCommercial
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Industrial" && subZone === "Large Industries",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicActivitiesLargeIndustries
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && (landUse === "Office Use" || landUse === "Traffic & Transportation") && (subZone === "Office Buildings" || subZone === "Transport 1 & 2,Parking"),
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludePublicOfficeTraffic
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Agricultural" && subZone === "Agricultural",
      excludeFrom: publicAmenitiesProposed,
      excludeList: excludeAgricultural
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Highway Facility Zone" && subZone === "Highway Facilities",
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && (landUse === "Recreational" || landUse === "Green Belt") && (subZone === "Recreational-1 & 2" || subZone === "Green Belt"),
      excludeFrom: publicAmenitiesProposed,
      excludeList: ["Compost Plant", "Creche and Day care Centre", "Prison", "Reading Room"]
    }, {
      match: primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: publicAmenitiesProposed,
      excludeList: []
    }, {
      match: primaryUse === "Community Facilities (Healthcare Buildings)" && landUse === "Public & Semi-Public Facilities" && subZone === "Public & Semi-Public",
      excludeFrom: communityHealthProposed,
      excludeList: []
    }];
    for (const cond of conditions) {
      if (cond.match) {
        let list = [];
        if (primaryUse === "Commercial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = proposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = proposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom;
              list = ((_cond$excludeFrom = cond.excludeFrom) === null || _cond$excludeFrom === void 0 ? void 0 : _cond$excludeFrom.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Industrial") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = indProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = indProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom2;
              list = ((_cond$excludeFrom2 = cond.excludeFrom) === null || _cond$excludeFrom2 === void 0 ? void 0 : _cond$excludeFrom2.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Residential") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = resProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = resProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom3;
              list = ((_cond$excludeFrom3 = cond.excludeFrom) === null || _cond$excludeFrom3 === void 0 ? void 0 : _cond$excludeFrom3.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Office Use") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = officeProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = officeProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom4;
              list = ((_cond$excludeFrom4 = cond.excludeFrom) === null || _cond$excludeFrom4 === void 0 ? void 0 : _cond$excludeFrom4.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Traffic & Transport") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = trafficProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = trafficProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom5;
              list = ((_cond$excludeFrom5 = cond.excludeFrom) === null || _cond$excludeFrom5 === void 0 ? void 0 : _cond$excludeFrom5.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Recreational") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = recreationProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = recreationProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom6;
              list = ((_cond$excludeFrom6 = cond.excludeFrom) === null || _cond$excludeFrom6 === void 0 ? void 0 : _cond$excludeFrom6.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Agriculture") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = agricultureProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = agricultureProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom7;
              list = ((_cond$excludeFrom7 = cond.excludeFrom) === null || _cond$excludeFrom7 === void 0 ? void 0 : _cond$excludeFrom7.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Healthcare Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = communityHealthProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = communityHealthProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom8;
              list = ((_cond$excludeFrom8 = cond.excludeFrom) === null || _cond$excludeFrom8 === void 0 ? void 0 : _cond$excludeFrom8.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        } else if (primaryUse === "Community Facilities (Educational Buildings)") {
          if (cond.match) {
            let _list = [];
            if (cond.includeOnly) {
              _list = communityEducationProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeList) {
              _list = communityEducationProposed.filter(a => !cond.excludeList.includes(a));
            } else {
              _list = cond.excludeFrom || [];
            }
            return simpleReturn(_list);
          }
        } else if (primaryUse === "Community Facilities (Public Amenities/Utilities Buildings)") {
          if (cond.match) {
            if (cond.includeOnly) {
              list = publicAmenitiesProposed.filter(a => cond.includeOnly.includes(a));
            } else if (cond.excludeOnly) {
              list = publicAmenitiesProposed.filter(a => !cond.excludeOnly.includes(a));
            } else {
              var _cond$excludeFrom9;
              list = ((_cond$excludeFrom9 = cond.excludeFrom) === null || _cond$excludeFrom9 === void 0 ? void 0 : _cond$excludeFrom9.filter(a => !cond.excludeList.includes(a))) || [];
            }
          }
        }
        return simpleReturn(list);
      }
    }
    return simpleReturn(resProposed);
  };
  const plotAreaForDevelopmentPlan = Number(watchPlotArea) || 0;
  const developmentPlanActivities = ["Layout Plan (Residential)", "Layout Plan (Commercial)", "Layout Plan (Industrial)", "Layout Plan (Public Amenities)", "Layout Plan (Community Facilities)", "Layout Plan (Affordable Housing)", "Layout Plan (Office)", "Group Housing", "Group Housing (Affordable)"];
  const selectedActivity = typeof watchAtivityProposed === "object" ? (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.value) || (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.name) || (watchAtivityProposed === null || watchAtivityProposed === void 0 ? void 0 : watchAtivityProposed.label) || "" : String(watchAtivityProposed || "").trim();
  const isDevelopmentPlanActivity = developmentPlanActivities.includes(selectedActivity);
  const showDevelopmentPlan = plotAreaForDevelopmentPlan >= 3000 && isDevelopmentPlanActivity;
  console.log("========== DEVELOPMENT PLAN DEBUG ==========");
  console.log("watchAtivityProposed =", watchAtivityProposed);
  console.log("selectedActivity =", selectedActivity);
  console.log("watchPlotArea =", watchPlotArea);
  console.log("plotAreaForDevelopmentPlan =", plotAreaForDevelopmentPlan);
  console.log("isDevelopmentPlanActivity =", isDevelopmentPlanActivity);
  console.log("showDevelopmentPlan =", showDevelopmentPlan);
  console.log("============================================");
  const handleClick = () => {
    setIsModalOpen(true);
  };
  const plotArea = parseFloat(watchPlotArea) || 0;
  const isMoreThan4Hectares = plotArea >= 40000;
  console.log("getFilteredActivityoptions", getFilteredActivityOptions);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    autoComplete: "off"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    disabled: isRescrutiny,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Type",
    control: control,
    placeholder: t("Scheme Type"),
    name: "descriptionOfLand.schemeType",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : _fastPASData$descript3.schemeType),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript4 = fastPASData.descriptionOfLand) === null || _fastPASData$descript4 === void 0 ? void 0 : _fastPASData$descript4.schemeType) || isRescrutiny
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchSchemeType !== "Non Scheme" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Type Of Scheme",
    control: control,
    placeholder: "Type Of Scheme",
    name: "planOn",
    mandatory: true,
    defaultValue: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript5 = fastPASData.descriptionOfLand) === null || _fastPASData$descript5 === void 0 ? void 0 : _fastPASData$descript5.planOn) || (formData === null || formData === void 0 ? void 0 : formData.planOn),
    type: "selectInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript6 = fastPASData.descriptionOfLand) === null || _fastPASData$descript6 === void 0 ? void 0 : _fastPASData$descript6.planOn) || isRescrutiny
  })), watchSchemeType !== "Non Scheme" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Scheme Name",
    defaultValue: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript7 = fastPASData.descriptionOfLand) === null || _fastPASData$descript7 === void 0 ? void 0 : _fastPASData$descript7.schemeName) || (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeName),
    name: "descriptionOfLand.schemeName",
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript8 = fastPASData.descriptionOfLand) === null || _fastPASData$descript8 === void 0 ? void 0 : _fastPASData$descript8.schemeName) || isRescrutiny,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), watchSchemeType !== "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disableFuture: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use as per Layout Plan"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub-use as per layout Plan"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(activityProposed),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (watchAtivityProposed === "Hotel (<20 rooms)" || watchAtivityProposed === "Hotel (>20 rooms)") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number Of Rooms"),
    placeholder: t("Number Of Rooms"),
    name: "numberOfHotels",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      validate: value => {
        const num = Number(value);
        if (watchAtivityProposed === "Hotel (<20 rooms)" && num > 20) {
          return "For hotels with <20 rooms, number must not exceed 20";
        }
        if (watchAtivityProposed === "Hotel (>20 rooms)" && num <= 20) {
          return "For hotels with >20 rooms, number must be greater than 20";
        }
        return true;
      },
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid number"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Development Area Type"),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    defaultValue: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript9 = fastPASData.descriptionOfLand) === null || _fastPASData$descript9 === void 0 ? void 0 : _fastPASData$descript9.developmentArea) || (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.developmentArea),
    disabled: true,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: isProd ? natureOfConstructionOption2 : natureOfConstructionOption,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isSelfCert || isRescrutiny
  }))), (watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Redevelopment/Reconstruction" || watchnatureOfConstruction === "Revision" || watchnatureOfConstruction === "Addition Extension" || watchnatureOfConstruction === "Compounding" && watchCompunding === "yes") && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction date"),
    control: control,
    placeholder: t("Enter Previous Sanction date"),
    name: "mapSubDetails.sanctionValidityStartDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai3 = formData.mapSubDetails) === null || _formData$mapSubDetai3 === void 0 ? void 0 : _formData$mapSubDetai3.sanctionValidityStartDate,
    type: "datePicker",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.layoutsanctionDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai4 = formData.mapSubDetails) === null || _formData$mapSubDetai4 === void 0 ? void 0 : _formData$mapSubDetai4.sanctionValidityStartDate) || isRescrutiny,
    mandatory: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision",
    validation: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision" ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction Validity date"),
    control: control,
    placeholder: t("Enter Previous Sanction Validity date"),
    name: "mapSubDetails.sanctionValidityDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai5 = formData.mapSubDetails) === null || _formData$mapSubDetai5 === void 0 ? void 0 : _formData$mapSubDetai5.sanctionValidityDate,
    type: "datePicker",
    mandatory: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.validityDate) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai6 = formData.mapSubDetails) === null || _formData$mapSubDetai6 === void 0 ? void 0 : _formData$mapSubDetai6.sanctionValidityDate) || isRescrutiny,
    validation: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision" ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Approved Map Number"),
    control: control,
    placeholder: t("Enter Previous File No"),
    name: "mapSubDetails.prevFileNo",
    mandatory: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition5 = fastPASData.additionalDetails) === null || _fastPASData$addition5 === void 0 ? void 0 : _fastPASData$addition5.oldCaseApplicationNo) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai7 = formData.mapSubDetails) === null || _formData$mapSubDetai7 === void 0 ? void 0 : _formData$mapSubDetai7.prevFileNo) || isRescrutiny,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai8 = formData.mapSubDetails) === null || _formData$mapSubDetai8 === void 0 ? void 0 : _formData$mapSubDetai8.prevFileNo,
    type: "textInput",
    validation: watchnatureOfConstruction === "Revalidation/Time Extension" || watchnatureOfConstruction === "Revision" ? {
      required: {
        value: true,
        message: "This field is required"
      }
    } : {}
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.landArea,
    name: "plotArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6,
    disabled: isRescrutiny
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotAreaDoc,
    name: "plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    disabled: isRescrutiny,
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    defaultValue: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript10 = fastPASData.descriptionOfLand) === null || _fastPASData$descript10 === void 0 ? void 0 : _fastPASData$descript10.latitude) || (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.latitude),
    onlyNumeric: true,
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript11 = fastPASData.descriptionOfLand) === null || _fastPASData$descript11 === void 0 ? void 0 : _fastPASData$descript11.latitude) || (formData === null || formData === void 0 ? void 0 : formData.latitude) || isRescrutiny,
    mandatory: true,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript12 = fastPASData.descriptionOfLand) === null || _fastPASData$descript12 === void 0 ? void 0 : _fastPASData$descript12.longitude) || (formData === null || formData === void 0 ? void 0 : formData.longitude) || isRescrutiny,
    defaultValue: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript13 = fastPASData.descriptionOfLand) === null || _fastPASData$descript13 === void 0 ? void 0 : _fastPASData$descript13.longitude) || (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.longitude),
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), watchSpecialProject === "Type design" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isModalOpen && /*#__PURE__*/React__default.createElement(PlotDetailTable, {
    addPlotNo: addPlotNo,
    control: control,
    getValues: getValues,
    isModalOpen: isModalOpen,
    isRescrutiny: isRescrutiny,
    modalFields: modalFields,
    removePlotNo: removePlotNo,
    setIsModalOpen: setIsModalOpen,
    setShowToast: setShowToast
  })), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("District"),
    placeholder: t("District"),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.district) || "",
    name: "district",
    type: "textInput",
    disabled: isRescrutiny,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Nearby Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark || isRescrutiny,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), watchSchemeType === "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    disabled: !!watchTehsil || isRescrutiny,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    mandatory: !schemeType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    mandatory: !schemeType,
    disabled: isRescrutiny,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), watchSchemeType === "Non Scheme" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Address"),
    control: control,
    placeholder: t("Enter Address"),
    name: "landAddress",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landAddress,
    type: "textInput",
    disabled: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Development Plan",
    control: control,
    placeholder: "Enter Development Plan",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.developmentPlan) || ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("DEVELOPMENT_PLAN")),
    name: `developmentPlan`,
    type: "selectInput",
    data: developmentPlans,
    disabled: isRescrutiny,
    mandatory: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: "descriptionOfLand.roadWidths[0].value",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : (_formData$description11 = _formData$description10.roadWidths) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11[0]) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.value,
    mandatory: true,
    disabled: isRescrutiny,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: schemeType ? "Road width (As per layout Plan)" : "Road width (As per master Plan)",
    placeholder: "Enter Road width",
    name: `descriptionOfLand.approachRoadWidths[0].value`,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13.approachRoadWidths) === null || _formData$description14 === void 0 ? void 0 : (_formData$description15 = _formData$description14[0]) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.value,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isRescrutiny,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: restrictedLayoutActivities ? proposalOptionsPlotted : proposalOptions,
    label: `${t("Select Proposal")}`,
    placeholder: "Select Proposal",
    name: "proposal",
    disabled: isRescrutiny,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposal,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, (watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For 2/3 wheelers vehicles)" || watchAtivityProposed === "Petrol Pump/ Filling Station (CNG/PNG/EV,For All vehicles)" || watchAtivityProposed === "Petrol Pump/ Filling Station cum Service Station (CNG/PNG/EV)") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Plot Size Prescribed By Oil Company"),
    placeholder: t("Plot Size Prescribed By Oil Company"),
    name: "plotSizePrescribed",
    type: "radioButton",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), isDA && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Select Zone"),
    placeholder: t("Select Zone"),
    name: "zone",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zone,
    type: "selectInput",
    data: zoneList
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchPrimaryUse === "Community Facilities (Educational Buildings)" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("No Of Students"),
    placeholder: t("Enter No Of Students"),
    name: "mapSubDetails.noOfStudents",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai9 = formData.mapSubDetails) === null || _formData$mapSubDetai9 === void 0 ? void 0 : _formData$mapSubDetai9.noOfStudents,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid number"
      }
    }
  })), watchPrimaryUse === "Community Facilities (Public Amenities/Utilities Buildings" ||  (watchAtivityProposed === "Auditorium" || watchAtivityProposed === "Convention Centre" || watchAtivityProposed === "Stadium" || watchAtivityProposed === "Multiplex") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number of Seats"),
    placeholder: t("No Of Seats"),
    name: "mapSubDetails.noOfSeats",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai10 = formData.mapSubDetails) === null || _formData$mapSubDetai10 === void 0 ? void 0 : _formData$mapSubDetai10.noOfSeats,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid number"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchPrimaryUse === "Community Facilities (Healthcare Buildings)" && watchAtivityProposed === "Hospitals (> 50 beds)" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Number of Beds"),
    placeholder: t("Number of Beds"),
    name: "mapSubDetails.noOfBeds",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai11 = formData.mapSubDetails) === null || _formData$mapSubDetai11 === void 0 ? void 0 : _formData$mapSubDetai11.noOfBeds,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchPlotSizePrescribed === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "plotSizePrescribedDoc",
    label: "Plot Size Prescribed Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    className: "custom-file-uploader",
    required: true
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, !restrictedLayoutActivities && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.yesOrNo,
    label: t("Is this Special Project"),
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    disabled: isRescrutiny,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchProposal !== "Layout Development" && watchisSpecialProject == "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special project")}`,
    name: "specialProject",
    placeholder: "Select Special Project",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.specialProject,
    type: "selectInput",
    data: watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG" ? specialProjectList === null || specialProjectList === void 0 ? void 0 : specialProjectList.filter(item => watchSubZoneType === "Mixed Use 1 & 2" ? item.value !== "Mixed Use Along 18/24M Wide Road" : true) : specialProjectList === null || specialProjectList === void 0 ? void 0 : specialProjectList.filter(item => item.value !== "Type design" && !(watchSubZoneType === "Mixed Use 1 & 2" && item.value === "Mixed Use Along 18/24M Wide Road")),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null), !restrictedLayoutActivities ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Does your proposal require other than Base FAR")}`,
    name: "mapSubDetails.proposalTypeFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai12 = formData.mapSubDetails) === null || _formData$mapSubDetai12 === void 0 ? void 0 : _formData$mapSubDetai12.proposalTypeFAR,
    type: "radioButton",
    height: 40,
    mandatory: true,
    data: yesOrNo,
    disabled: isRescrutiny,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), watchProposalTypeFAR === "yes" && watchPrimaryUse === "Residential" && (watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Row Housing - Multi units" || watchAtivityProposed === "Detached - Multi Units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Semi-detached - Multi Units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Group Housing" || watchAtivityProposed === "Group Housing - Affordable" || watchAtivityProposed === "Group Housing - EWS" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable") &&
  /*#__PURE__*/
  React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Single Housing - EWS" && watchSchemeType === "Non Scheme" || watchAtivityProposed === "Single Housing - LIG" && watchSchemeType === "Non Scheme" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable" || watchProposal === "Layout Development") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Purchasable FAR")}`,
    name: "purchasableFar",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFar,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, (watchAtivityProposed === "Group Housing" || watchAtivityProposed === "Group Housing - Affordable" || watchAtivityProposed === "Group Housing - EWS" || watchAtivityProposed === "Group Housing - LIG" || watchProposal === "Layout Development") && watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Purchasable Premium FAR")}`,
    name: "purchasablePremiumFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasablePremiumFAR,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Basic FAR",
    placeholder: "Enter Basic FAR",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    name: "basicFAR",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.basicFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.basicFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR),
    mandatory: true,
    disabled: (formData === null || formData === void 0 ? void 0 : formData.basicFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.basicFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.basicFAR),
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Purchasable FAR",
    placeholder: "Enter Purchasable FAR",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR),
    mandatory: true,
    name: "purchasableFAR",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    disabled: (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.purchasableFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.purchasableFAR),
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPurchasableFar === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Premium FAR",
    placeholder: "Enter Premium FAR",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR),
    mandatory: true,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    name: "premiumFAR",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) === 0 || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR) == 0 ? "0" : (formData === null || formData === void 0 ? void 0 : formData.premiumFAR) || (purchasableData === null || purchasableData === void 0 ? void 0 : purchasableData.premiumFAR),
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null))), watchProposalTypeFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Row Housing - Single units" || watchAtivityProposed === "Semi-Detached - Single Units" || watchAtivityProposed === "Detached - Single Units" || watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable" || watchAtivityProposed === "Single Housing - EWS" || watchAtivityProposed === "Single Housing - LIG") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Green Building FAR")}`,
    name: "greenBuildingFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.greenBuildingFAR,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposal !== "Layout Development" && watchGreenBuildingFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Green Building Rated requires additional FAR")}`,
    placeholder: "Select Percentage",
    name: "greenAdditionalFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.greenAdditionalFAR,
    type: "selectInput",
    data: additionalFar
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "greenBuildingDoc",
    label: "Green Building Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    className: "custom-file-uploader",
    required: true
  })))), watchProposalTypeFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, !(watchAtivityProposed === "Plotted Development" || watchAtivityProposed === "Plotted Development - Affordable") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Compensatory FAR")}`,
    name: "compensatoryFAR",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.compensatoryFAR,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchCompensatoryFAR === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Area of Transferred Land")}`,
    name: "transferredLandArea",
    placeholder: "Enter Area",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.transferredLandArea,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    name: "compensatoryFarDoc",
    label: "Compensatory FAR Document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, !restrictedLayoutActivities && /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "specialProjectType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.specialProjectType,
    type: "radioButton",
    data: yesOrNo,
    disabled: isRescrutiny,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchProposal !== "Layout Development" && watchspecialProjectType === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), ["Detached - Multi Units", "Semi-detached - Multi Units", "Group Housing", "Row Housing - Multi units", "Layout Plan (Residential)"].includes(watchAtivityProposed) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Payment of Shelter fee?",
    name: "shelterFee",
    type: "radioButton",
    mandatory: true,
    defaultValue: isMoreThan4Hectares ? "no" : (formData === null || formData === void 0 ? void 0 : formData.shelterFee) || "no",
    disabled: isMoreThan4Hectares,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchShelterFee === "no" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Performance Gaurantee against EWS/LIG"),
    placeholder: "Select Guarantee",
    name: "performanceGuarantee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.performanceGuarantee,
    type: "selectInput",
    height: 40,
    data: guaranteeList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null))), watchspecialProjectType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), watchspecialProjectType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "specialChar",
    onlyNumeric: true,
    allowedChars: ".",
    decimalScale: 3,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchspecialProjectType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front Setback"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear Setback"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchspecialProjectType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (includeIsBuildingFullySprinkledActivities.includes(watchAtivityProposed) || sprinklerRequiredPrimaryUses.includes(watchPrimaryUse)) && /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Is building fully sprinklered for Fire Fighting?")}`,
    name: "mapSubDetails.fireFighting",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai13 = formData.mapSubDetails) === null || _formData$mapSubDetai13 === void 0 ? void 0 : _formData$mapSubDetai13.fireFighting,
    type: "radioButton",
    data: yesOrNo,
    height: 40,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", watchAtivityProposed === "Plotted Development" && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Does your proposal comprising Multi-units / Group Housing")}`,
    name: "groupHousingOrMultiUnits",
    type: "radioButton",
    data: yesOrNo,
    height: 40,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchnatureOfConstruction === "Compounding" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is building plan previously approved?"),
    control: control,
    name: "serviceType",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.serviceType,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchCompunding !== "no" && /*#__PURE__*/React__default.createElement(Col, null), watchCompunding === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of compounding"),
    placeholder: t("Select Nature Of Compounding"),
    name: "isAncestralProperty",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty,
    data: SortingAlphabatically(natureOfCompounding),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchCompunding === "no" && watchisAncestralProperty === "In response to notice" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Notice Number"),
    control: control,
    placeholder: t("Notice Number  (Mandatory Field)"),
    name: "vaadId",
    mandatory: true,
    maxLength: 24,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.vaadId,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchSpecialProject === "Type design" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red",
      fontSize: "14px",
      paddingLeft: "10px",
      fontWeight: "bold"
    }
  }, "Please Re-enter the Values of Plot No."), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "16px",
      marginLeft: "10px"
    }
  }, "Add Plot No's"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    style: {
      color: "green"
    }
  })))) : /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: watchSchemeType !== "Non Scheme" ? t("Plot No") : t("Plot No./Khasra No./ Arazi No."),
    control: control,
    placeholder: watchSchemeType !== "Non Scheme" ? t("Enter Plot no") : t("Enter Plot No./Khasra No./ Arazi No."),
    name: "plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript14 = fastPASData.descriptionOfLand) === null || _fastPASData$descript14 === void 0 ? void 0 : _fastPASData$descript14.plotNo),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript15 = fastPASData.descriptionOfLand) === null || _fastPASData$descript15 === void 0 ? void 0 : _fastPASData$descript15.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo) || isRescrutiny,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("DM Circle Rate (In Rs. Per Square meter)"),
    control: control,
    placeholder: t("Enter DM Rate"),
    name: "dmCircleRate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.dmCircleRate,
    disabled: isRescrutiny,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchSpecialProject === "Type design" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    style: {
      marginLeft: "10px"
    }
  }, "Total Plot's Entered : ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "bold"
    }
  }, modalFields === null || modalFields === void 0 ? void 0 : modalFields.length))), watchGroupHousingOrMultiUnits === "yes" && /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper"
  }, /*#__PURE__*/React__default.createElement("legend", {
    style: {
      fontWeight: "bold",
      fontSize: "1rem"
    }
  }, "Permornamce Gaurantee against EWS/LIG"), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_PLOT_NO"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Types Of Plots"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Proposed Units", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", null, t("ACTIONS")))), /*#__PURE__*/React__default.createElement("tbody", null, modalFields && (modalFields === null || modalFields === void 0 ? void 0 : modalFields.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `mapSubDetails.plotDetails[${index}].plotNo`,
    control: control,
    type: "textInput",
    placeholder: "Enter Plot No",
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `mapSubDetails.plotDetails[${index}].typeOfPlot`,
    control: control,
    type: "radioButton",
    data: groupHousingOrMultiUnits,
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `mapSubDetails.plotDetails[${index}].proposedUnits`,
    control: control,
    type: "number",
    onlyNumeric: true,
    maxLength: 5,
    placeholder: "Enter Proposed Units",
    hasLabel: false,
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("td", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => removePlotNo(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === (modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => {
      const currentPlotNo = getValues(`mapSubDetails.plotDetails[${(modalFields === null || modalFields === void 0 ? void 0 : modalFields.length) - 1}].plotNo`);
      if (!currentPlotNo || currentPlotNo.trim() === "") {
        setShowToast({
          key: "true",
          error: true,
          message: "Please fill Plot No before adding another row."
        });
        return;
      }
      addPlotNo({
        plotNo: ""
      });
    },
    color: "primary"
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.", /*#__PURE__*/React__default.createElement("br", null), " The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information present in the file shall not be the responsibility of the EDCR Engine.")
  })))), !isSelfCert && scrutinyFlow === "EDCR" && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Upload DXF File"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(DxfFileUploader, {
    control: control,
    name: "file",
    label: "Upload Building Plan Drawing",
    validationMsg: "(dxf only and Max file Size 300 MB)",
    isMandatory: true,
    required: true,
    tab: 3,
    setFile: setFile,
    maxFiles: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: !declarationChecked || watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" || watchNeedComp === "yes"
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const getGroupHousingData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  console.log("insideGetEdcrData", id);
  if (id) {
    var _data$BPA, _edcrData$description, _edcrData$additionalD, _edcrData$description2, _edcrData$description3, _edcrData$description4, _edcrData$landInfo, _edcrData$landInfo$ow, _edcrData$landInfo$ow2, _edcrData$landInfo2, _edcrData$landInfo2$o, _edcrData$landInfo2$o2, _edcrData$landInfo3, _edcrData$landInfo3$o, _edcrData$landInfo3$o2, _edcrData$documents, _edcrData$documents$f, _edcrData$additionalD2;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const edcrData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    console.log("edcrDataFromGetGrouphousing", edcrData);
    const applicationData = {
      applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      applicationId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationId,
      appliactionType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || "BUILDING_PLAN_SCRUTINY",
      applicationType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || "BUILDING_PLAN_SCRUTINY",
      applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION",
      serviceType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || "NEW_CONSTRUCTION",
      transactionNumber: uuidv4(),
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      drawingDetail: edcrData === null || edcrData === void 0 ? void 0 : edcrData.drawingDetail,
      district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
      proposal: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposal,
      plotAreaDoc: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaDoc,
      mapSubDetails: edcrData === null || edcrData === void 0 ? void 0 : edcrData.mapSubDetails,
      descriptionOfLand: edcrData === null || edcrData === void 0 ? void 0 : edcrData.descriptionOfLand,
      fastPASId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fastPASId,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      city: edcrData === null || edcrData === void 0 ? void 0 : edcrData.city,
      locality: edcrData === null || edcrData === void 0 ? void 0 : edcrData.locality,
      village: edcrData === null || edcrData === void 0 ? void 0 : edcrData.village,
      doorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.doorNo,
      code: edcrData === null || edcrData === void 0 ? void 0 : edcrData.code,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      plotArea: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description = edcrData.descriptionOfLand) === null || _edcrData$description === void 0 ? void 0 : _edcrData$description.landArea,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      otherSchemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherSchemeName,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      areaType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.areaType,
      developmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentArea,
      subDevelopmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subDevelopmentArea,
      developmentPlan: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentPlan) || (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD = edcrData.additionalDetails) === null || _edcrData$additionalD === void 0 ? void 0 : _edcrData$additionalD.developmentPlan),
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.far,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      groundCoverages: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackFronts,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackRears,
      backSide: edcrData === null || edcrData === void 0 ? void 0 : edcrData.backSide,
      isPlotSetback: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isPlotSetback,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      specialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProject,
      specialProjectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.specialProjectType,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      otherProjectName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherProjectName,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      previousSetbackFront: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      previousSetbackRear: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      previousSetbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide1,
      previousSetbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide2,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      landUseNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      purchasableFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description2 = edcrData.descriptionOfLand) === null || _edcrData$description2 === void 0 ? void 0 : (_edcrData$description3 = _edcrData$description2.properties) === null || _edcrData$description3 === void 0 ? void 0 : (_edcrData$description4 = _edcrData$description3[0]) === null || _edcrData$description4 === void 0 ? void 0 : _edcrData$description4.requiredAreaFAR) || 0,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      leaseholdNOC: edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      shelterFee: edcrData === null || edcrData === void 0 ? void 0 : edcrData.shelterFee,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      applicantName: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo = edcrData.landInfo) === null || _edcrData$landInfo === void 0 ? void 0 : (_edcrData$landInfo$ow = _edcrData$landInfo.owners) === null || _edcrData$landInfo$ow === void 0 ? void 0 : (_edcrData$landInfo$ow2 = _edcrData$landInfo$ow[0]) === null || _edcrData$landInfo$ow2 === void 0 ? void 0 : _edcrData$landInfo$ow2.name,
      aplicantMobileNumber: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo2 = edcrData.landInfo) === null || _edcrData$landInfo2 === void 0 ? void 0 : (_edcrData$landInfo2$o = _edcrData$landInfo2.owners) === null || _edcrData$landInfo2$o === void 0 ? void 0 : (_edcrData$landInfo2$o2 = _edcrData$landInfo2$o[0]) === null || _edcrData$landInfo2$o2 === void 0 ? void 0 : _edcrData$landInfo2$o2.mobileNumber,
      applicantEmailId: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo3 = edcrData.landInfo) === null || _edcrData$landInfo3 === void 0 ? void 0 : (_edcrData$landInfo3$o = _edcrData$landInfo3.owners) === null || _edcrData$landInfo3$o === void 0 ? void 0 : (_edcrData$landInfo3$o2 = _edcrData$landInfo3$o[0]) === null || _edcrData$landInfo3$o2 === void 0 ? void 0 : _edcrData$landInfo3$o2.emailId,
      licenseeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeName,
      licenseeLicenceNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeLicenceNumber) || "",
      licenseeMobileNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeMobileNumber) || "",
      licenseeEmailId: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeEmailId) || "",
      licenseeAddress: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeAddress) || "",
      file: edcrData === null || edcrData === void 0 ? void 0 : edcrData.file,
      signatureId: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : (_edcrData$documents$f = _edcrData$documents.filter(doc => doc.documentType === "signature")[0]) === null || _edcrData$documents$f === void 0 ? void 0 : _edcrData$documents$f.fileStoreId) || null,
      selectedOffice: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD2 = edcrData.additionalDetails) === null || _edcrData$additionalD2 === void 0 ? void 0 : _edcrData$additionalD2.selectedOffice,
      department: applicationFlow || null
    };
    return {
      applicationData,
      isAppDataLoading
    };
  } else {
    const applicationData = {
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      specialProject: null,
      specialProjectType: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      serviceType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: applicationFlow || null
    };
    return {
      applicationData,
      isAppDataLoading: false
    };
  }
};

const GroupHousingPortal = () => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  console.log("insideGroupHousePortal", id, useParams());
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [disable, setDisable] = useState(false);
  const [proposedSite, setProposedSite] = useState(null);
  const {
    applicationData: edcrData,
    isAppDataLoading: edcrAppDataLoading
  } = getGroupHousingData(id);
  const {
    applicationData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const isSelfCert = proposedSite === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || proposedSite === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const [edcrParams, setEdcrParams, clearEdcrParams] = Digit.Hooks.useSessionStorage("EDCR_CREATE", edcrData);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  const documents = useSelector(state => {
    var _state$formMTDoc;
    return (_state$formMTDoc = state.formMTDoc) === null || _state$formMTDoc === void 0 ? void 0 : _state$formMTDoc.documents;
  });
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
    if (!id && (Array.isArray(edcrParams) || !(edcrParams !== null && edcrParams !== void 0 && edcrParams.appliactionType))) {
      clearEdcrParams();
    }
  }, [id]);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("hello formdata", formData);
    if (formData !== null && formData !== void 0 && formData.scrutinyFlow && formData.scrutinyFlow !== "EDCR" && !(formData !== null && formData !== void 0 && formData.file)) {
      handleTabChange(nextSubTab, formData);
      return;
    }
    setDisable(true);
    const file = formData === null || formData === void 0 ? void 0 : formData.file;
    if (formData) {
      var _userInfo$roles, _data$natureOfConstru, _data$natureOfConstru2, _userRolesArray$, _edcrRequest, _edcrRequest$mapSubDe, _edcrRequest2, _edcrRequest2$additio, _edcrRequest3, _edcrRequest3$mapSubD, _edcrRequest4, _edcrRequest4$additio;
      const safeEdcrParams = Array.isArray(edcrParams) ? {} : {
        ...edcrParams
      };
      if (!(formData !== null && formData !== void 0 && formData.isRevised) && !(formData !== null && formData !== void 0 && formData.applicationScrutinyType)) {
        delete safeEdcrParams.edcrNumber;
        delete safeEdcrParams.transactionNumber;
      }
      const data = {
        ...safeEdcrParams,
        ...formData
      };
      const userRolesArray = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(user => user.code !== "CITIZEN")) || [];
      const edcrAppType = "BUILDING_PLAN_SCRUTINY";
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow || (safeEdcrParams === null || safeEdcrParams === void 0 ? void 0 : safeEdcrParams.department) || (formData === null || formData === void 0 ? void 0 : formData.department);
      const resolvedBusinessService = resolvedDept === "DA" || (data === null || data === void 0 ? void 0 : data.businessService) === "BPA_MAPSUB_DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      const subType = data !== null && data !== void 0 && data.serviceType && data.serviceType !== "yes" && data.serviceType !== "no" ? data.serviceType : (data === null || data === void 0 ? void 0 : data.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION";
      const natureOfConstruction = typeof (data === null || data === void 0 ? void 0 : data.natureOfConstruction) === "object" ? (data === null || data === void 0 ? void 0 : (_data$natureOfConstru = data.natureOfConstruction) === null || _data$natureOfConstru === void 0 ? void 0 : _data$natureOfConstru.value) || (data === null || data === void 0 ? void 0 : (_data$natureOfConstru2 = data.natureOfConstruction) === null || _data$natureOfConstru2 === void 0 ? void 0 : _data$natureOfConstru2.name) : data === null || data === void 0 ? void 0 : data.natureOfConstruction;
      let edcrRequest = {
        transactionNumber: (formData === null || formData === void 0 ? void 0 : formData.transactionNumber) || (typeof uuidv4 === "function" ? uuidv4() : ""),
        edcrNumber: (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || "",
        rolesCode: (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) || null,
        planFile: null,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        RequestInfo: {
          apiId: "",
          ver: "",
          ts: "",
          action: "",
          did: "",
          authToken: "",
          key: "",
          msgId: "",
          correlationId: "",
          userInfo: userInfo
        }
      };
      edcrRequest = {
        ...edcrRequest,
        ...data,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        department: resolvedDept || (data === null || data === void 0 ? void 0 : data.department) || applicationFlow,
        businessService: resolvedBusinessService,
        appliactionType: edcrAppType,
        applicationType: edcrAppType,
        applicationSubType: subType,
        serviceType: subType,
        ...(natureOfConstruction ? {
          natureOfConstruction
        } : {})
      };
      if (!edcrRequest.transactionNumber) {
        edcrRequest.transactionNumber = typeof uuidv4 === "function" ? uuidv4() : "";
      }
      edcrRequest.tod = "";
      if ((_edcrRequest = edcrRequest) !== null && _edcrRequest !== void 0 && (_edcrRequest$mapSubDe = _edcrRequest.mapSubDetails) !== null && _edcrRequest$mapSubDe !== void 0 && _edcrRequest$mapSubDe.tod) {
        edcrRequest.mapSubDetails.tod = "";
      }
      if ((_edcrRequest2 = edcrRequest) !== null && _edcrRequest2 !== void 0 && (_edcrRequest2$additio = _edcrRequest2.additionalDetails) !== null && _edcrRequest2$additio !== void 0 && _edcrRequest2$additio.tod) {
        edcrRequest.additionalDetails.tod = "";
      }
      delete edcrRequest.landUseApprovalLetter;
      if ((_edcrRequest3 = edcrRequest) !== null && _edcrRequest3 !== void 0 && (_edcrRequest3$mapSubD = _edcrRequest3.mapSubDetails) !== null && _edcrRequest3$mapSubD !== void 0 && _edcrRequest3$mapSubD.landUseApprovalLetter) {
        delete edcrRequest.mapSubDetails.landUseApprovalLetter;
      }
      if ((_edcrRequest4 = edcrRequest) !== null && _edcrRequest4 !== void 0 && (_edcrRequest4$additio = _edcrRequest4.additionalDetails) !== null && _edcrRequest4$additio !== void 0 && _edcrRequest4$additio.landUseApprovalLetter) {
        delete edcrRequest.additionalDetails.landUseApprovalLetter;
      }
      let bodyFormData = new FormData();
      bodyFormData.append("planFile", file);
      bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
      if (activeTab === 0 && selectedSubTab === 0 && bodyFormData && file) {
        Digit.EDCRService.create({
          data: bodyFormData
        }, tenantId).then(result => {
          var _result$data;
          if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.edcrDetail) {
            var _result$data2, _result$data3;
            setDisable(false);
            setEdcrParams(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.edcrDetail);
            history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
              data: result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.edcrDetail
            });
          }
        }).catch(e => {
          var _e$response, _e$response2, _e$response2$data, _e$response2$data$, _e$response3, _e$response3$data, _e$response3$data$, _e$response4, _e$response4$data, _e$response5, _e$response5$data;
          setDisable(false);
          const errMsg = Array.isArray(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data) && ((e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$ = _e$response2$data[0]) === null || _e$response2$data$ === void 0 ? void 0 : _e$response2$data$.errorMessage) || (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$ = _e$response3$data[0]) === null || _e$response3$data$ === void 0 ? void 0 : _e$response3$data$.errorCode)) || (e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.message) || (e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.errorCode) || "Something went wrong!!";
          Modal("EDCR Error", errMsg, "error");
        });
      } else {
        setDisable(false);
      }
    } else {
      setDisable(false);
    }
  };
  const handleTabChange = (nextTab, formData = null) => {
    var _formData$documents;
    console.log("hello formdata", formData);
    const finalDocuments = (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0 ? formData.documents : documents;
    if (nextTab === 1 && formData) {
      var _data$mapSubDetails, _formData$mapSubDetai, _params$mapSubDetails;
      const data = {
        ...params,
        ...formData,
        documents: finalDocuments
      };
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow;
      data.department = resolvedDept;
      data.businessService = resolvedDept === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = formData !== null && formData !== void 0 && formData.isCompounding || data !== null && data !== void 0 && data.isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      const resolvedLandUseLetter = (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails = data.mapSubDetails) === null || _data$mapSubDetails === void 0 ? void 0 : _data$mapSubDetails.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : (_params$mapSubDetails = params.mapSubDetails) === null || _params$mapSubDetails === void 0 ? void 0 : _params$mapSubDetails.landUseApprovalLetter);
      if (resolvedLandUseLetter) {
        data.landUseApprovalLetter = resolvedLandUseLetter;
        data.approvalLetterUrl = resolvedLandUseLetter;
        data.mapSubDetails = {
          ...(data.mapSubDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
        data.additionalDetails = {
          ...(data.additionalDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
      }
      Digit.OBPSService.create({
        BPA: data
      }, tenantId).then(res => {
        var _res$BPA;
        if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
          var _res$BPA2;
          Modal("Application Created", `Application Created Successfully!`, "success");
          history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`, {
            data: res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]
          });
        }
      }).catch(e => {
        var _e$response6, _e$response6$data, _e$response6$data$Err;
        Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response6 = e.response) === null || _e$response6 === void 0 ? void 0 : (_e$response6$data = _e$response6.data) === null || _e$response6$data === void 0 ? void 0 : (_e$response6$data$Err = _e$response6$data.Errors[0]) === null || _e$response6$data$Err === void 0 ? void 0 : _e$response6$data$Err.message}`, "error");
      });
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);
  useEffect(() => {
    if (id && edcrData) {
      var _edcrData$documents;
      setEdcrParams(edcrData);
      if ((edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : _edcrData$documents.length) > 0) {
        initFormMTDocs(edcrData.documents);
      }
    }
  }, [id, edcrAppDataLoading]);
  const renderContent = () => {
    var _Digit, _Digit$SessionStorage;
    const scrutinyFlow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("LTP.SCRUTINY.SELECTION");
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$d, {
            formData: isSelfCert || scrutinyFlow !== "EDCR" ? params : edcrParams,
            handleSubTabChange: handleSubTabChange,
            userInfo: userInfo,
            handleTabChange: handleTabChange,
            setProposedSite: setProposedSite,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id
          });
        default:
          return null;
      }
    }
  };
  if (isAppDataLoading || edcrAppDataLoading || id && !applicationData && !edcrData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (disable) {
    return /*#__PURE__*/React__default.createElement(ScrutinyUnderProcess, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Common  Application Form"
  }), activeTab === 0 && renderContent());
};

const PlinthPortal = () => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [proposedSite, setProposedSite] = useState(null);
  const {
    applicationData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_PLINTH", applicationData);
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      var _data$additionalDetai;
      const data = {
        ...params,
        ...formData
      };
      const additionalLandInfo = data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.landInfo;
      if (additionalLandInfo) {
        var _data$landInfo, _data$landInfo2, _data$landInfo3, _data$landInfo4;
        data.landInfo = {
          ...data.landInfo,
          tenantId: (_data$landInfo = data.landInfo) !== null && _data$landInfo !== void 0 && _data$landInfo.tenantId ? (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : _data$landInfo2.tenantId : additionalLandInfo === null || additionalLandInfo === void 0 ? void 0 : additionalLandInfo.tenantId,
          address: (_data$landInfo3 = data.landInfo) !== null && _data$landInfo3 !== void 0 && _data$landInfo3.address ? (_data$landInfo4 = data.landInfo) === null || _data$landInfo4 === void 0 ? void 0 : _data$landInfo4.address : additionalLandInfo === null || additionalLandInfo === void 0 ? void 0 : additionalLandInfo.address
        };
      }
      data.workflow.action = "APPLY_TO_DEPARTMENT";
      data.applicationType = "FORM_PLINTH", data.oldMapSubApplNumber = data.applicationNo;
      delete data.applicationNo;
      Digit.OBPSService.create({
        BPA: data
      }, tenantId).then(res => {
        var _res$BPA;
        if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
          Modal("Application Created", `Application Created Successfully!`, "success");
        }
        history.push("/digit-ui/citizen/obps/plinthApplications");
      }).catch(e => {
        var _e$response, _e$response$data, _e$response$data$Erro;
        Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
      });
    } else {
      const data = {
        ...params,
        ...formData
      };
      try {
        data.workflow = {
          action: "UPLOAD_DOC",
          assignes: null
        };
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA2;
            onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]);
            Modal("Application Updated", `Application Updated Successfully!`, "success");
            Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$3, {
            formData: params,
            userInfo: userInfo,
            handleTabChange: handleTabChange,
            setProposedSite: setProposedSite,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id
          });
        default:
          return null;
      }
    }
  };
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Plinth Submission Form"
  }), activeTab === 0 && renderContent(), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const PlintApplications = () => {
  var _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const applicationType = "FORM_PLINTH";
  const limit = rowsPerPage;
  const {
    data,
    isLoading: loader,
    revalidate
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId, applicationType, limit, {}, [], {
    formType: "Form12"
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.plinthShortfallCertificateUrl;
    window.open(objectionLetterUrl, "_blank");
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  function getApprovalLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.plinthApprovalCertificateUrl;
    window.open(pdfUrl, "_blank");
  }
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo$owners3, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : (_item$landInfo$owners3 = _item$landInfo$owners2.name) === null || _item$landInfo$owners3 === void 0 ? void 0 : _item$landInfo$owners3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.BPA) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.mobileNumber) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    render: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    render: item => {
      var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      onClick: () => {
        var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      },
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", null, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    render: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", null, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/edcrPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$taxHeadEstimate;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate = item.taxHeadEstimates) === null || _item$taxHeadEstimate === void 0 ? void 0 : _item$taxHeadEstimate[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
          history.push({
            pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")));
    }
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.plinthShortfallCertificateUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "proposalLetter",
    label: "Proposal Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.proposalUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.proposalUrl, "_blank")
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$taxHeadEstimate2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.status) === "APPROVED" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate2 = item.taxHeadEstimates) === null || _item$taxHeadEstimate2 === void 0 ? void 0 : _item$taxHeadEstimate2[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getApprovalLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "nocLetter",
    label: "NOC Request Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$nocLetterInfo, _item$nocLetterInfo$;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$nocLetterInfo = item.nocLetterInfo) === null || _item$nocLetterInfo === void 0 ? void 0 : (_item$nocLetterInfo$ = _item$nocLetterInfo[0]) === null || _item$nocLetterInfo$ === void 0 ? void 0 : _item$nocLetterInfo$.fileStoreUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          var _item$nocLetterInfo2, _item$nocLetterInfo2$;
          return window.open(item === null || item === void 0 ? void 0 : (_item$nocLetterInfo2 = item.nocLetterInfo) === null || _item$nocLetterInfo2 === void 0 ? void 0 : (_item$nocLetterInfo2$ = _item$nocLetterInfo2[0]) === null || _item$nocLetterInfo2$ === void 0 ? void 0 : _item$nocLetterInfo2$.fileStoreUrl, "_blank");
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "nocApprovalLetter",
    label: "NOC Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$nocList, _item$nocList$;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$nocList = item.nocList) === null || _item$nocList === void 0 ? void 0 : (_item$nocList$ = _item$nocList[0]) === null || _item$nocList$ === void 0 ? void 0 : _item$nocList$.nocApprovedLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          var _item$nocList2, _item$nocList2$;
          return window.open(item === null || item === void 0 ? void 0 : (_item$nocList2 = item.nocList) === null || _item$nocList2 === void 0 ? void 0 : (_item$nocList2$ = _item$nocList2[0]) === null || _item$nocList2$ === void 0 ? void 0 : _item$nocList2$.nocApprovedLetterUrl, "_blank");
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        if (item.planOn === "SELF_MAP") {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/selfResidentialPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        } else {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/plinthPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => {
        var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Plinth Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    className: "bg-white",
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.render(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), showMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showMs,
    onClose: () => {
      setshowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(MigratedSummary, {
    id: idData
  })), smShowMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  })));
};

const SubStep1$e = ({
  formData,
  setFormData,
  handleSubTabChange,
  initFormMTDocs,
  setShowToast,
  isEmployee
}) => {
  var _Digit$SessionStorage, _formData$drawingDeta, _formData$drawingDeta2, _formData$drawingDeta3, _formData$drawingDeta4, _formData$additionalD, _formData$drawingDeta5, _formData$drawingDeta6, _formData$additionalD2, _formData$drawingDeta7, _formData$drawingDeta8, _formData$additionalD3, _formData$description, _formData$description3;
  console.log(formData, "formDatatattata");
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [file, setFile] = useState(null);
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const watchorientType = watch("tod.orientDevelopment");
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const fastPASData = Digit.SessionStorage.get("FASTPAS_ID");
  const [edcrApiData, setEdcrApiData] = useState(null);
  useEffect(() => {
    const fetchEdcrFiles = async () => {
      const num = (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber);
      if (num && (!(formData !== null && formData !== void 0 && formData.updatedDxfFile) || !(formData !== null && formData !== void 0 && formData.planReport) || !(formData !== null && formData !== void 0 && formData.dxfFile))) {
        try {
          var _res$edcrDetail;
          const stateId = Digit.ULBService.getStateId();
          const res = await Digit.OBPSService.scrutinyDetails(stateId, {
            edcrNumber: num
          });
          if (res !== null && res !== void 0 && (_res$edcrDetail = res.edcrDetail) !== null && _res$edcrDetail !== void 0 && _res$edcrDetail[0]) {
            setEdcrApiData(res.edcrDetail[0]);
          }
        } catch (err) {
          console.error("Error fetching EDCR scrutiny details in Compounding SubStep1:", err);
        }
      }
    };
    fetchEdcrFiles();
  }, [formData === null || formData === void 0 ? void 0 : formData.edcrNumber]);
  const drawingPdf = (formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta = formData.drawingDetail) === null || _formData$drawingDeta === void 0 ? void 0 : (_formData$drawingDeta2 = _formData$drawingDeta[0]) === null || _formData$drawingDeta2 === void 0 ? void 0 : _formData$drawingDeta2.updatedDxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta3 = formData.drawingDetail) === null || _formData$drawingDeta3 === void 0 ? void 0 : (_formData$drawingDeta4 = _formData$drawingDeta3[0]) === null || _formData$drawingDeta4 === void 0 ? void 0 : _formData$drawingDeta4.drawingPdf) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.updatedDxfFile) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.updatedDxfFile);
  const planReport = (formData === null || formData === void 0 ? void 0 : formData.planReport) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta5 = formData.drawingDetail) === null || _formData$drawingDeta5 === void 0 ? void 0 : (_formData$drawingDeta6 = _formData$drawingDeta5[0]) === null || _formData$drawingDeta6 === void 0 ? void 0 : _formData$drawingDeta6.planReport) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.planReport) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.planReport);
  const dxfFile = (formData === null || formData === void 0 ? void 0 : formData.dxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$drawingDeta7 = formData.drawingDetail) === null || _formData$drawingDeta7 === void 0 ? void 0 : (_formData$drawingDeta8 = _formData$drawingDeta7[0]) === null || _formData$drawingDeta8 === void 0 ? void 0 : _formData$drawingDeta8.dxfFile) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.dxfFile) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile) || (edcrApiData === null || edcrApiData === void 0 ? void 0 : edcrApiData.dxfFile);
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction;
  const watchNoOfPLots = formData === null || formData === void 0 ? void 0 : formData.noOfPlots;
  const schemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const totalPlots = parseInt(watchNoOfPLots, 10) || 0;
  const dispatch = useDispatch();
  const {
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index
  }));
  const clearAllData = () => {
    var _Digit, _Digit2, _Digit3, _Digit4;
    resetFormMTDocs();
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("FORM12_CURRENT_TAB");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("ScrutinyDetails");
    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("EDCR_CREATE");
    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("FASTPAS_ID");
  };
  useEffect(() => {
    const handleBackButton = () => {
      clearAllData();
    };
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  });
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  useEffect(() => {
    var _data$documents;
    const data = Digit.SessionStorage.get("FASTPAS_ID");
    const updatedDocuments = data === null || data === void 0 ? void 0 : (_data$documents = data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.map(doc => ({
      ...doc,
      documentRemarks: null,
      documentStatus: null
    }));
    if (data) {
      var _formData$landInfo;
      const newFormData = {
        ...formData,
        landInfo: {
          ...data.landInfo,
          address: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.address
        },
        land_Id: data === null || data === void 0 ? void 0 : data.land_Id,
        selectedCity: data === null || data === void 0 ? void 0 : data.selectedCity,
        selectedUnit: data === null || data === void 0 ? void 0 : data.selectedUnit,
        documents: updatedDocuments,
        descriptionOfLand: data === null || data === void 0 ? void 0 : data.descriptionOfLand,
        nocDetails: data === null || data === void 0 ? void 0 : data.nocDetails,
        khasraDetails: data === null || data === void 0 ? void 0 : data.khasraDetails
      };
      setFormData(prevState => ({
        ...prevState,
        ...newFormData
      }));
      initFormMTDocs(updatedDocuments);
    }
  }, []);
  const activityAsPerMap = formData === null || formData === void 0 ? void 0 : formData.primaryUse;
  const watchlandUseType = formData === null || formData === void 0 ? void 0 : formData.zoneType;
  const activityProposed = formData === null || formData === void 0 ? void 0 : formData.activityProposed;
  console.log({
    activityAsPerMap,
    activityProposed
  }, typeof activityAsPerMap, typeof activityProposed, "activityAsPerMap");
  const onSubmit = data => {
    handleSubTabChange(1, formData);
  };
  if (!isEmployee && applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("General Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    name: "land_Id",
    type: "textInput",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.land_Id) || (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id)
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: landUseZoneOptions,
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: ResidentialUseList,
    label: t("Land Sub Use"),
    placeholder: t("Select Type Land Subuse"),
    name: "subZoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.subZoneType,
    type: "selectInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: plotUseOptions,
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: plotSubUseOptions,
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.activityProposed) || (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.activityProposed),
    type: "selectInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: planOnOptions,
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "planOn",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.planOn,
    type: "selectInput"
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed SIte"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: ConstructionTypeOptions,
    name: "constructionType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: natureOfConstructionOptionComp,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    type: "selectInput"
  })), watchNatureOfConstruction !== "New" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Prev File No"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, formData !== null && formData !== void 0 && formData.schemeName ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "textInput",
    mandatory: !schemeType
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Standard Type Design")}`,
    name: "proposalType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true
  })), schemeType ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker"
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput"
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t(" No. Of PLots"),
    name: "noOfPlots",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, plotInputs.slice(rowIndex * 3, rowIndex * 3 + 3).map(plot => {
    var _formData$plotNumbers;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plot.index}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers${plot.index}`,
      hasLabel: false,
      maxLength: 15,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers[plot.index],
      type: "textInput"
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, plotInputs.slice(fullRows * 3).map(plot => {
    var _formData$plotNumbers2;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plot.index}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers${plot.index}`,
      maxLength: 15,
      hasLabel: false,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plot.index],
      type: "textInput"
    }));
  })), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Project Type")}`,
    placeholder: "Select Project Type",
    name: "buildingClassification",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingClassification,
    type: "textInput",
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null, watchbuildingClassification === "Others" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherbuildingClass",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Special Project type")}`,
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || activityAsPerMap !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Select Condition of Project"),
    control: control,
    placeholder: t("Select Project Type"),
    name: "projectType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput"
  }))), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverage",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.groundCoverage,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "far",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.far,
    type: "textInput"
  }))), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Please specify if any other condition"),
    placeholder: t("Enter condition"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput"
  }))), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "setbackFronts",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "setbackRears",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput"
  }))), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Left"),
    control: control,
    placeholder: t("Enter Left"),
    name: "setbackSide1",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Right"),
    control: control,
    placeholder: t("Enter Right"),
    name: "setbackSide2",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is Your Plot Sub-division"),
    control: control,
    name: "plotSubdivided",
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    type: "radioButton"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Does existing building require any compounding ?"),
    control: control,
    name: "needCompounding",
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.needCompounding,
    type: "radioButton"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchNeedComp === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is your plot Lease hold ?"),
    control: control,
    name: "plotLeaseHold",
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton"
  })), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchNeedComp === "no" && watchplotLeaseHold === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader, {
    label: "Noc For Lease Hold",
    control: control,
    name: "leaseholdNOC",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    required: true,
    isMandatory: true,
    tab: 1
  }))))), Boolean((formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber)) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), Boolean((formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber)) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, drawingPdf ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(drawingPdf, "_blank")
  }) : "N/A"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, planReport ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(planReport, "_blank")
  }) : "N/A"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, dxfFile ? /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/GDoAGny.png",
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(dxfFile, "_blank"),
    alt: "DXF File"
  }) : "N/A"))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer bg-white"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.", /*#__PURE__*/React__default.createElement("br", null), " The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information present in the file shall not be the responsibility of the EDCR Engine.")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Upload DXF File"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(DxfFileUploader, {
    control: control,
    name: "file",
    label: "Upload Building Plan Drawing",
    validationMsg: "(dxf only and Max file Size 300 MB)",
    isMandatory: true,
    required: true,
    tab: 3,
    setFile: setFile,
    maxFiles: 1
  })))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    disabled: !declarationChecked,
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep2$7 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _Digit$UserService$ge, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$structuralI, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    }
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  });
  const watchState = watch("landInfo.owners.[0].permanentAddress.state");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const [watchCategoryType, watchCertNo, watchValidity] = watch(["professionaldetails.consultantCategory", "professionaldetails.certificateNo", "professionaldetails.validupto"]);
  useEffect(async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      var _userResponse$user;
      const userResponse = await Digit.UserService.userSearch(tenantId, {
        uuid: [uuid]
      }, {});
      const fetchedUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$user = userResponse.user) === null || _userResponse$user === void 0 ? void 0 : _userResponse$user[0];
      setUser(fetchedUser);
      if (fetchedUser) {
        var _fetchedUser$roles, _fetchedUser$roles$fi, _fetchedUser$roles$fi2, _fetchedUser$pwdExpir;
        const category = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$roles = fetchedUser.roles) === null || _fetchedUser$roles === void 0 ? void 0 : (_fetchedUser$roles$fi = _fetchedUser$roles.filter(e => e.code !== "CITIZEN")) === null || _fetchedUser$roles$fi === void 0 ? void 0 : (_fetchedUser$roles$fi2 = _fetchedUser$roles$fi[0]) === null || _fetchedUser$roles$fi2 === void 0 ? void 0 : _fetchedUser$roles$fi2.name;
        setValue("professionaldetails.consultantCategory", category);
        setValue("professionaldetails.certificateNo", fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.registrationNumber);
        const validUptoDate = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$pwdExpir = fetchedUser.pwdExpiryDate) === null || _fetchedUser$pwdExpir === void 0 ? void 0 : _fetchedUser$pwdExpir.slice(0, 10);
        const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
        setValue("professionaldetails.validupto", formattedDate);
      }
    }
  }, []);
  useEffect(async () => {
    var _users$filter;
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"],
      pageSize: "100000"
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = (_users$filter = users.filter(user => user.uuid === formData.professionaldetails.engineerUuid)) === null || _users$filter === void 0 ? void 0 : _users$filter[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr.filter(e => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      var _selectedEngineer$pwd, _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const validUptoDate = selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$pwd = selectedEngineer.pwdExpiryDate) === null || _selectedEngineer$pwd === void 0 ? void 0 : _selectedEngineer$pwd.slice(0, 10);
      const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchCategoryType
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.certificateNo,
    disabled: !!watchCertNo || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchValidity
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].permanentAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.permanentAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.permanentAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI = formData.structuralInfo) === null || _formData$structuralI === void 0 ? void 0 : _formData$structuralI.name,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.licenseNumber,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.validupto,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : (_formData$structuralI5 = _formData$structuralI4.permanentAddress) === null || _formData$structuralI5 === void 0 ? void 0 : _formData$structuralI5.address,
    type: "textInput",
    disabled: true,
    maxLength: 50
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep3$9 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$plotInfo, _formData$plotInfo2, _formData$plotInfo3;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchlandUseType = watch("plotInfo.zoneType") === 'Residential Use Zone';
  useEffect(() => {
    setValue('plotInfo.plotArea', formData === null || formData === void 0 ? void 0 : formData.plotArea);
    setValue('plotInfo.builtupArea', formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
  }, []);
  const onSubmit = data => {
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), formData !== null && formData !== void 0 && formData.edcrNumber ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area as per drawing (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area as per drawing"),
    name: "plotInfo.plotArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.plotArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Total Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Total Built up Area"),
    name: "totalBuildUpArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.builtupArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Estimated Cost (INR)"),
    control: control,
    placeholder: t("Enter Estimated Cost"),
    name: "plotInfo.estimatedCost",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$plotInfo3 = formData.plotInfo) === null || _formData$plotInfo3 === void 0 ? void 0 : _formData$plotInfo3.estimatedCost,
    disabled: isEmployee,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const SubStep4$8 = ({
  formData,
  handleSubTabChange,
  isEmployee
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$description4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = data => {
    handleSubTabChange(4, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  }), !isEmployee && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: '#CCC'
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const MapSubmissionSummary$1 = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false
}) => {
  var _formData$landInfo, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$taxHeadEsti3, _documents$filter, _documents$filter$, _Digit$SessionStorage, _formData$plotNumbers, _structuralInfo$perma, _structuralInfo$perma2, _formData$description, _feeDetail$mapRate, _feeDetail$mapRate2, _formData$additionalD, _formData$pressDetail, _formData$pressReleas, _formData$additionalD2, _formData$additionalD3, _formData$additionalD4, _formData$pressDetail2, _formData$pressReleas2, _formData$additionalD5, _formData$pressDetail3, _formData$pressReleas3, _formData$additionalD6, _formData$pressDetail4, _formData$pressReleas4, _formData$additionalD7, _formData$additionalD8, _formData$pressDetail5, _formData$pressReleas5, _formData$additionalD9, _formData$pressDetail6, _formData$pressReleas6, _formData$additionalD10, _formData$pressDetail7, _formData$pressReleas7;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const plotInfo = formData === null || formData === void 0 ? void 0 : formData.plotInfo;
  const structuralInfo = formData === null || formData === void 0 ? void 0 : formData.structuralInfo;
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const professionalInfo = formData === null || formData === void 0 ? void 0 : formData.professionaldetails;
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const paymentHead = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti2 = formData.taxHeadEstimates) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : (_formData$taxHeadEsti3 = _formData$taxHeadEsti2[0]) === null || _formData$taxHeadEsti3 === void 0 ? void 0 : _formData$taxHeadEsti3.paymentHeads;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchisSetbackRequired = formData === null || formData === void 0 ? void 0 : formData.isSetbackRequired;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.constructionType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, "Lucknow Development Authority"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "General Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo)), (formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.currValidityDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Current Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.currValidityDate)), (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity proposed:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planOn)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherSchemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherSchemeName)), (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.isMetroCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Site falls in Metro City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isMetroCity)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.constructionType)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature of Construction /Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevFileNo)), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village/College Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.landMark)), (formData === null || formData === void 0 ? void 0 : formData.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector/Pocket No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sectorNo)), (formData === null || formData === void 0 ? void 0 : formData.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.khasraNo)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Standard Type Design:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction date Of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction number of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.noOfPlots) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.noOfPlots)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.plotNumbers) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.join(", "))), (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingClassification)), watchbuildingClassification === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass)), (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isSpecialProject)), (formData === null || formData === void 0 ? void 0 : formData.communityParking) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "If Community Parking Provided:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.communityParking)), watchisSpecialProject === "yes" && (formData === null || formData === void 0 ? void 0 : formData.projectType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Condition Of Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.projectType)), watchisSpecialProject === "Other" && (formData === null || formData === void 0 ? void 0 : formData.otherProjectName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherProjectName)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.groundCoverage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.groundCoverage)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.far) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.far)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingHeight)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackFronts) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackFronts)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackRears) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackRears)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback- 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide1)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback - 2:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide2)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" && (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Plot Sub-division:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && (formData === null || formData === void 0 ? void 0 : formData.needCompounding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does existing building require any compounding ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.needCompounding)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchNeedComp === "no" && (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot Lease hold ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchplotLeaseHold === "yes" && (edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC for Lease hold :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Left:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Right:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No. Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.certificateNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.validupto))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.map((item, index) => {
    var _item$inputonGST, _item$inputonGST2, _item$inputonGST3, _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? "Addition Owner Information" : "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Input On GST:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST = item.inputonGST) === null || _item$inputonGST === void 0 ? void 0 : _item$inputonGST.value) === "yes" ? "Yes" : (item === null || item === void 0 ? void 0 : item.inputonGST) === "no" || (item === null || item === void 0 ? void 0 : (_item$inputonGST2 = item.inputonGST) === null || _item$inputonGST2 === void 0 ? void 0 : _item$inputonGST2.value) === "no" ? "No" : (item === null || item === void 0 ? void 0 : item.inputonGST) || "N/A")), ((item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST3 = item.inputonGST) === null || _item$inputonGST3 === void 0 ? void 0 : _item$inputonGST3.value) === "yes") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "GST No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.gstNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.town)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.address)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "200px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo))))))));
  })), structuralInfo && (structuralInfo.name || structuralInfo.validupto || structuralInfo.licenseNumber || ((_structuralInfo$perma = structuralInfo.permanentAddress) === null || _structuralInfo$perma === void 0 ? void 0 : _structuralInfo$perma.address)) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.name) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.validupto) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.licenseNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : (_structuralInfo$perma2 = structuralInfo.permanentAddress) === null || _structuralInfo$perma2 === void 0 ? void 0 : _structuralInfo$perma2.address) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot area as per Drawing (Sq.Mt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.plotArea))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details (Step-1)")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate = feeDetail.mapRate) === null || _feeDetail$mapRate === void 0 ? void 0 : _feeDetail$mapRate.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Fee on Plot:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.price)), paymentHead === null || paymentHead === void 0 ? void 0 : paymentHead.map((payment, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, payment === null || payment === void 0 ? void 0 : payment.feeType, ":")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, payment === null || payment === void 0 ? void 0 : payment.amount))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      fontWeight: "bolder"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : feeDetail.estimateAmount))))))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.planReport, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.dxfFile, "_blank")
  })))))))), ((formData === null || formData === void 0 ? void 0 : formData.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail = formData.pressDetails) === null || _formData$pressDetail === void 0 ? void 0 : _formData$pressDetail.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas = formData.pressReleaseDetails) === null || _formData$pressReleas === void 0 ? void 0 : _formData$pressReleas.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD2 = formData.additionalDetails) === null || _formData$additionalD2 === void 0 ? void 0 : _formData$additionalD2.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : formData.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD3 = formData.additionalDetails) === null || _formData$additionalD3 === void 0 ? void 0 : _formData$additionalD3.invitationRemark)) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Invitation Suggestion / Press Release")))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Any objections or suggestions required for this proposal?"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, ((formData === null || formData === void 0 ? void 0 : formData.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD4 = formData.additionalDetails) === null || _formData$additionalD4 === void 0 ? void 0 : _formData$additionalD4.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail2 = formData.pressDetails) === null || _formData$pressDetail2 === void 0 ? void 0 : _formData$pressDetail2.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas2 = formData.pressReleaseDetails) === null || _formData$pressReleas2 === void 0 ? void 0 : _formData$pressReleas2.hasSuggestion)) === "yes" ? "Yes" : ((formData === null || formData === void 0 ? void 0 : formData.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD5 = formData.additionalDetails) === null || _formData$additionalD5 === void 0 ? void 0 : _formData$additionalD5.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail3 = formData.pressDetails) === null || _formData$pressDetail3 === void 0 ? void 0 : _formData$pressDetail3.hasSuggestion) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas3 = formData.pressReleaseDetails) === null || _formData$pressReleas3 === void 0 ? void 0 : _formData$pressReleas3.hasSuggestion)) === "no" ? "No" : "N/A"), ((formData === null || formData === void 0 ? void 0 : formData.hasSuggestion) === "yes" || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD6 = formData.additionalDetails) === null || _formData$additionalD6 === void 0 ? void 0 : _formData$additionalD6.hasSuggestion) === "yes" || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail4 = formData.pressDetails) === null || _formData$pressDetail4 === void 0 ? void 0 : _formData$pressDetail4.hasSuggestion) === "yes" || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas4 = formData.pressReleaseDetails) === null || _formData$pressReleas4 === void 0 ? void 0 : _formData$pressReleas4.hasSuggestion) === "yes" || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD7 = formData.additionalDetails) === null || _formData$additionalD7 === void 0 ? void 0 : _formData$additionalD7.pressReleaseFee)) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Press Release Fee (Amount)"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, `₹ ${(formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD8 = formData.additionalDetails) === null || _formData$additionalD8 === void 0 ? void 0 : _formData$additionalD8.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail5 = formData.pressDetails) === null || _formData$pressDetail5 === void 0 ? void 0 : _formData$pressDetail5.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas5 = formData.pressReleaseDetails) === null || _formData$pressReleas5 === void 0 ? void 0 : _formData$pressReleas5.pressReleaseFee) || 0}`)), ((formData === null || formData === void 0 ? void 0 : formData.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD9 = formData.additionalDetails) === null || _formData$additionalD9 === void 0 ? void 0 : _formData$additionalD9.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail6 = formData.pressDetails) === null || _formData$pressDetail6 === void 0 ? void 0 : _formData$pressDetail6.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas6 = formData.pressReleaseDetails) === null || _formData$pressReleas6 === void 0 ? void 0 : _formData$pressReleas6.invitationRemark)) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Remark"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, (formData === null || formData === void 0 ? void 0 : formData.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD10 = formData.additionalDetails) === null || _formData$additionalD10 === void 0 ? void 0 : _formData$additionalD10.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$pressDetail7 = formData.pressDetails) === null || _formData$pressDetail7 === void 0 ? void 0 : _formData$pressDetail7.invitationRemark) || (formData === null || formData === void 0 ? void 0 : (_formData$pressReleas7 = formData.pressReleaseDetails) === null || _formData$pressReleas7 === void 0 ? void 0 : _formData$pressReleas7.invitationRemark)))))))))), _showDeclaration && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with this application.", " ")
  }))));
});

function SearchSummary$4({
  id,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration
}) {
  var _data$BPA;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const formType = "MAP_SUB";
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  }, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  });
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(MapSubmissionSummary$1, {
    formData: data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0],
    ref: ref,
    handleDeclarationChange: handleDeclarationChange,
    declarationChecked: declarationChecked,
    showDeclaration: showDeclaration
  }));
}

const Step4$4 = ({
  formData,
  handleTabChange,
  isEmployee,
  isNocModule
}) => {
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const drawingDetail = (formData === null || formData === void 0 ? void 0 : formData.drawingDetail) || [];
  const [open, setOpen] = useState(false);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: ""
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const onSubmit = data => {
    OpenPDFFromB64InPdfViewer();
  };
  const columns = [{
    id: "submissionIndex",
    label: "Submission",
    accessor: ""
  }, {
    id: "drawingPdf",
    label: "Drawing PDF",
    accessor: "updatedDxfFile"
  }, {
    id: "planReport",
    label: "Plan Report",
    accessor: "planReport"
  }, {
    id: "dxfFile",
    label: "DXF File",
    accessor: "dxfFile"
  }, {
    id: "status",
    label: "Status",
    accessor: "status"
  }, {
    id: "submittedOn",
    label: "Submitted On",
    accessor: "submittedOn"
  }, {
    id: "signedPdfUrl",
    label: "Digital Sign",
    accessor: "signedPdfUrl"
  }];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        pdfType: "D"
      };
      const getSign = await Digit.DscService.getSignParams({
        SignRequest
      });
      setSigningParams(prev => {
        var _getSign$SigningParam, _getSign$SigningParam2, _getSign$SigningParam3, _getSign$SigningParam4, _getSign$SigningParam5;
        return {
          ...prev,
          AuthToken: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam = getSign.SigningParameters) === null || _getSign$SigningParam === void 0 ? void 0 : _getSign$SigningParam.authToken,
          SrcPdfB64: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam2 = getSign.SigningParameters) === null || _getSign$SigningParam2 === void 0 ? void 0 : _getSign$SigningParam2.pdfBase64,
          SignSettingName: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam3 = getSign.SigningParameters) === null || _getSign$SigningParam3 === void 0 ? void 0 : _getSign$SigningParam3.signSettingName,
          ReturnUrl: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam4 = getSign.SigningParameters) === null || _getSign$SigningParam4 === void 0 ? void 0 : _getSign$SigningParam4.returnURL,
          UserDataJson: getSign === null || getSign === void 0 ? void 0 : (_getSign$SigningParam5 = getSign.SigningParameters) === null || _getSign$SigningParam5 === void 0 ? void 0 : _getSign$SigningParam5.UserDataJson
        };
      });
      setOpen(true);
      setLoading(false);
      console.log({
        getSign,
        signingParams,
        AuthToken,
        SrcPdfB64,
        SignSettingName,
        ReturnUrl
      }, "getSingngn");
    } catch (error) {
      console.error(error, "error");
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const {
      AuthToken,
      SrcPdfB64,
      signSettingName,
      returnUrl
    } = signingParams;
    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");
    formRef.current.submit();
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log({
    signingParams
  }, "signinngParams");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 650
    },
    "aria-label": "drawing details table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      height: "20px"
    }
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    sx: {
      color: "#fff"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, drawingDetail.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, columns.map(column => {
    if (column.id === "submissionIndex") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, "Submission ", index + 1);
    }
    const value = row[column.accessor];
    if (column.accessor === "submittedOn") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? new Date(value).toLocaleString() : "N/A");
    }
    if (column.accessor === "updatedDxfFile" || column.accessor === "planReport") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(value, "_blank")
      }) : "N/A");
    }
    if (column.accessor === "dxfFile") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, value ? /*#__PURE__*/React__default.createElement("img", {
        src: "https://i.imgur.com/GDoAGny.png",
        style: {
          width: "20px",
          height: "30px",
          cursor: "pointer"
        },
        onClick: () => window.open(value, "_blank"),
        alt: "DXF File"
      }) : "N/A");
    }
    if (column.accessor === "signedPdfUrl") {
      return /*#__PURE__*/React__default.createElement(TableCell$1, {
        key: column.id
      }, (formData === null || formData === void 0 ? void 0 : formData.IsSignedDrawingPdfURL) === true ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#24b155",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => window.open(formData.signedDrawingPdfURL, "_blank"),
        title: "View Signed PDF"
      }) : !isEmployee ? /*#__PURE__*/React__default.createElement("button", {
        style: {
          backgroundColor: "#157CB3",
          color: "#fff",
          padding: "8px 16px",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          opacity: 1
        },
        type: "button",
        onClick: handleSign,
        disabled: isEmployee
      }, "Attach Digital Sign") : value ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
        color: "#a10505",
        style: {
          width: "20px",
          height: "20px",
          cursor: "pointer"
        },
        onClick: () => handleOpenPdf(value, index)
      }) : "N/A");
    }
    return /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id
    }, value || "N/A");
  })))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: open ? "block" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      width: "95%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      background: "#fff",
      borderRadius: "5px",
      boxShadow: "0 0 10px rgba(0,0,0,0.3)"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      margin: "15px"
    }
  }, "By clicking on the Submit button, you will be redirected to the Third-Party Page."), /*#__PURE__*/React__default.createElement("form", {
    id: "PDFViewerDemo",
    method: "POST",
    ref: el => formRef.current = el,
    onSubmit: handleSubmit(onSubmit),
    action: "https://digital.abmapplication.com/Console/PdfViewerSigning"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "AuthToken",
    name: "AuthToken",
    value: signingParams.AuthToken
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignSettingName",
    name: "SignSettingName",
    value: signingParams.SignSettingName
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfB64",
    name: "SrcPdfB64",
    value: signingParams.SrcPdfB64
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SrcPdfPath",
    name: "SrcPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "SignedPdfPath",
    name: "SignedPdfPath",
    value: ""
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "UserDataJson",
    name: "UserDataJson",
    value: signingParams.UserDataJson
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "ReturnUrl",
    name: "ReturnUrl",
    value: signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"
  }), /*#__PURE__*/React__default.createElement("div", {
    class: "button-inline"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleClose,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Cancel"), /*#__PURE__*/React__default.createElement("button", {
    value: "Submit",
    type: "submit",
    onClick: OpenPDFFromB64InPdfViewer,
    style: {
      backgroundColor: "#0E7693",
      color: "#fff",
      marginLeft: "10px",
      padding: "5px",
      borderRadius: "3px"
    }
  }, "Submit")))))), !isEmployee && !isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "button",
    onClick: () => handleTabChange(3),
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step5$2 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _formData$taxHeadEsti, _data$BPA, _feeDetail$mapRate, _feeDetail$mapRate2, _feeDetail$mapRate3, _feeDetail$mapRate4, _feeDetail$mapRate5, _feeDetail$mapRate6;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const [taxHead, setTaxHead] = useState([]);
  const paymentHeads = data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA.MapSubPaymentHeads;
  const Modal = useModal();
  console.log(paymentHeads, "paymentheads");
  const paymentHeadsDropdown = paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map(item => ({
    name: item.label,
    label: item.label,
    value: item.label
  }));
  const defaultValues = {
    ...formData,
    paymentHeads: (formData === null || formData === void 0 ? void 0 : formData.paymentHeads) || [{
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    }]
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "paymentHeads"
  });
  const handleAddInput = () => {
    append({
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    });
  };
  const handleCalculate = async () => {
    var _data$Calculations, _data$Calculations$, _data$Calculations$$t, _data$Calculations$$t2;
    const paymentHeads = watch("paymentHeads");
    const checkedheads = paymentHeads.filter(e => e.checked);
    console.log({
      paymentHeads,
      checkedheads
    }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{
      BPA: {
        ...formData
      },
      tenantId: "up",
      feeType: "ApplicationFee"
    }];
    const data = await Digit.OBPSService.bpacalculate({
      CalulationCriteria
    });
    console.log(data, "calculationData");
    setTaxHead(data === null || data === void 0 ? void 0 : (_data$Calculations = data.Calculations) === null || _data$Calculations === void 0 ? void 0 : (_data$Calculations$ = _data$Calculations[0]) === null || _data$Calculations$ === void 0 ? void 0 : (_data$Calculations$$t = _data$Calculations$.taxHeadEstimates) === null || _data$Calculations$$t === void 0 ? void 0 : (_data$Calculations$$t2 = _data$Calculations$$t[0]) === null || _data$Calculations$$t2 === void 0 ? void 0 : _data$Calculations$$t2.paymentHeads);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);
    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          var _ranges$find;
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (((_ranges$find = ranges.find(r => r.area === "501-1000")) === null || _ranges$find === void 0 ? void 0 : _ranges$find.rate) || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0;
  };
  const totalTaxHeadAmount = taxHead === null || taxHead === void 0 ? void 0 : taxHead.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate = feeDetail.mapRate) === null || _feeDetail$mapRate === void 0 ? void 0 : _feeDetail$mapRate.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  const onSubmit = data => {
    data.paymentHeads = taxHead;
    if (!(formData !== null && formData !== void 0 && formData.edcrNumber)) {
      handleTabChange(4, data);
    } else {
      handleTabChange(4);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, Modal("Application Submited", 'fsfd', "success"), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details s")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate2 = feeDetail.mapRate) === null || _feeDetail$mapRate2 === void 0 ? void 0 : _feeDetail$mapRate2.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Builtup Area:"), " (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price:"), " (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate3 = feeDetail.mapRate) === null || _feeDetail$mapRate3 === void 0 ? void 0 : _feeDetail$mapRate3.unitPrice)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee:"), " (\u20B9)"), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate4 = feeDetail.mapRate) === null || _feeDetail$mapRate4 === void 0 ? void 0 : _feeDetail$mapRate4.price))))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(Table$3, {
    bordered: true,
    hover: true,
    responsive: true,
    className: "formHeaderContainer",
    style: {
      marginTop: "20px",
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%",
      padding: "4px"
    }
  }, "Select"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "30%",
      padding: "4px"
    }
  }, "Payment Heads"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Build Up Area (SQM)", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Area by LTP", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "15%",
      padding: "3px"
    }
  }, "Rate (\u20B9)", /*#__PURE__*/React__default.createElement("br", null)))), /*#__PURE__*/React__default.createElement("tbody", null, paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: item.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    type: "checkbox",
    name: `paymentHeads[${index}].checked`,
    control: control,
    containerStyles: {
      padding: "0px",
      margin: "0"
    }
  })), /*#__PURE__*/React__default.createElement("td", null, item.label), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].plotBuildUpArea`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    width: "12vw"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].updatedAreaJE`,
    hasLabel: false,
    control: control,
    placeholder: "Enter area",
    type: "textInput",
    defaultValue: item !== null && item !== void 0 && item.buildUpArea ? formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea : formData === null || formData === void 0 ? void 0 : formData.plotArea,
    width: "12vw",
    height: "22px",
    className: "paymentHeadInput"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    name: `paymentHeads[${index}].rate`,
    hasLabel: false,
    control: control,
    placeholder: "Enter rate",
    type: "textInput",
    width: "12vw",
    defaultValue: item.hasOwnProperty("rate") ? item.rate : calculateRate(formData === null || formData === void 0 ? void 0 : formData.plotArea, item.slabs)
  })))))), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      borderRadius: "24px"
    },
    onClick: handleAddInput
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement(AddIcon$1, null), "Add More")), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "contained",
    color: "success",
    size: "medium",
    style: {
      backgroundColor: "rgb(21, 124, 179)",
      color: "white",
      borderRadius: "24px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "10px",
      marginLeft: "50%"
    },
    onClick: handleCalculate
  }, "Calculate"), !(formData !== null && formData !== void 0 && formData.edcrNumber) && /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    sx: {
      minWidth: 650
    },
    "aria-label": "fee table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white"
  }, "Fee Type"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Built Up Area (sqmt.)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Rate (\u20B9)"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    color: "white",
    align: "right"
  }, "Amount (\u20B9)"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, taxHead === null || taxHead === void 0 ? void 0 : taxHead.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, row.feeType), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.plotBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.rate), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, row.amount))), /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: 0,
    sx: {
      "&:last-child td, &:last-child th": {
        border: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    component: "th",
    scope: "row"
  }, "Fee On Plot"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate5 = feeDetail.mapRate) === null || _feeDetail$mapRate5 === void 0 ? void 0 : _feeDetail$mapRate5.unitPrice), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRate6 = feeDetail.mapRate) === null || _feeDetail$mapRate6 === void 0 ? void 0 : _feeDetail$mapRate6.price)), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      fontWeight: "bold",
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 3,
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Total Amount")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "right"
  }, /*#__PURE__*/React__default.createElement("strong", null, totalAmount === null || totalAmount === void 0 ? void 0 : totalAmount.toFixed(2))))))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step6$1 = ({
  formData,
  handleTabChange
}) => {
  var _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const onSubmit = data => {
    handleTabChange(4, data);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    moduleCode: formData === null || formData === void 0 ? void 0 : formData.businessService
  });
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData, _applicationData$audi, _applicationData2;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$audi = _applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: ((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData3, _applicationData3$aud, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : (_applicationData3$aud = _applicationData3.auditDetails) === null || _applicationData3$aud === void 0 ? void 0 : _applicationData3$aud.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application History")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.timeline) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BreakLine, null), (workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement("div", null, workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data3 = workflowDetails.data) !== null && _workflowDetails$data3 !== void 0 && _workflowDetails$data3.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.timeline) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.length) === 1 ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "aliceblue",
      borderRadius: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline[0]) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.timeline[0])
  })) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint["status"]}`),
      customChild: getTimelineCaptions(checkpoint)
    })));
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: '#157CB3'
    }
  })))));
};

const Step2$9 = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData
  };
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const {
    handleSubmit,
    control,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  async function fetchLTPData() {
    var _userInfo$info;
    const createdBy = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
    try {
      var _response$Licenses, _ltpData$, _ltpData$$tradeLicens, _ltpData$$tradeLicens2;
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
        createdBy: createdBy
      });
      const ltpData = (response === null || response === void 0 ? void 0 : (_response$Licenses = response.Licenses) === null || _response$Licenses === void 0 ? void 0 : _response$Licenses.filter(e => e.status === "APPROVED")) || [];
      console.log(response, ltpData, "ltpDataaaaaa");
      const regCert = (ltpData === null || ltpData === void 0 ? void 0 : (_ltpData$ = ltpData[0]) === null || _ltpData$ === void 0 ? void 0 : (_ltpData$$tradeLicens = _ltpData$.tradeLicenseDetail) === null || _ltpData$$tradeLicens === void 0 ? void 0 : (_ltpData$$tradeLicens2 = _ltpData$$tradeLicens.applicationDocuments) === null || _ltpData$$tradeLicens2 === void 0 ? void 0 : _ltpData$$tradeLicens2.filter(e => e.documentType === "Registration Certificate")) || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchLTPData();
  }, []);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    data = {
      ...data,
      nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails
    };
    console.log("dataFromDocComponent", data);
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Sanction Map"),
    control: control,
    name: "Sanction Map",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    isMandatory: true,
    trigger: trigger
  }), /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Sanction Letter"),
    control: control,
    name: "Sanction Letter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    isMandatory: true,
    trigger: trigger
  }), /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding Drawing PDF"),
    control: control,
    name: "drawingPdf",
    validationMsg: "(pdf file only and Max file Size 150 MB)",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding drawing dxf"),
    control: control,
    name: "drawingPdf",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    trigger: trigger
  }), isSelfCert && /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    trigger: trigger
  }), /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    trigger: trigger
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Safety Certificate"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Fire Noc"),
    control: control,
    name: "calculationReport",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const CompoundingPortal = () => {
  var _Digit, _Digit2, _Digit3, _Digit$UserService$ge, _location$state, _applicationData, _params$nocList;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_SUBTAB")) || 0);
  const [summaryShow, setSummaryshow] = useState(((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARY_TAB")) || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const userType = info === null || info === void 0 ? void 0 : info.type;
  const isEmployee = userType === "EMPLOYEE";
  const {
    id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  let applicationData = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data;
  let isAppDataLoading = false;
  if (!applicationData) {
    ({
      applicationData,
      isAppDataLoading
    } = getMapSubmissionData(t, id));
  }
  console.log(applicationData, "applicationDataadata");
  const isSelfCert = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : _applicationData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const componentRef = useRef();
  const subTabLabels = [{
    label: "General Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "NOC Status"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  console.log("parmsfromPortalMapSubmission", params, params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.length);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData2, _applicationData2$doc;
      setParams(applicationData);
      if (((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$doc = _applicationData2.documents) === null || _applicationData2$doc === void 0 ? void 0 : _applicationData2$doc.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      const isSelfCert = (params === null || params === void 0 ? void 0 : params.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        if (nextTabNo === 4 && (params === null || params === void 0 ? void 0 : params.status) !== "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT",
            assignes: null
          };
        } else if (nextTabNo === 4 && (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: () => {
            onSelect("", data);
            if (nextTabNo === 4) {
              if ((params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT") {
                Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              } else {
                var _params$taxHeadEstima, _Digit4, _Digit5, _Digit6;
                if (isSelfCert) {
                  history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else if ((params === null || params === void 0 ? void 0 : (_params$taxHeadEstima = params.taxHeadEstimates) === null || _params$taxHeadEstima === void 0 ? void 0 : _params$taxHeadEstima.length) > 1) {
                  var _params$taxHeadEstima2, _params$taxHeadEstima3;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima2 = params.taxHeadEstimates) === null || _params$taxHeadEstima2 === void 0 ? void 0 : (_params$taxHeadEstima3 = _params$taxHeadEstima2[1]) === null || _params$taxHeadEstima3 === void 0 ? void 0 : _params$taxHeadEstima3.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                } else {
                  var _params$taxHeadEstima4, _params$taxHeadEstima5;
                  history.push(`/digit-ui/citizen/payment/collect/${`${params === null || params === void 0 ? void 0 : (_params$taxHeadEstima4 = params.taxHeadEstimates) === null || _params$taxHeadEstima4 === void 0 ? void 0 : (_params$taxHeadEstima5 = _params$taxHeadEstima4[0]) === null || _params$taxHeadEstima5 === void 0 ? void 0 : _params$taxHeadEstima5.calculationBusinesserviceId}`}/${`${params === null || params === void 0 ? void 0 : params.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
                }
                clearParams();
                Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("EDCR_CREATE");
                (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("FASTPAS_ID");
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("SUMMARY_TAB");
                setTimeout(() => {
                  resetFormMTDocs();
                }, 0);
                Digit.SessionStorage.del("MS_CURRENT_TAB");
                Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
              }
            } else {
              if (nextTabNo === 5) {
                Digit.SessionStorage.set("SUMMARY_TAB", true);
                setSummaryshow(true);
              }
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !id) {
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA;
          if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
            onSelect("", {
              ...data,
              ...res.BPA[0]
            }, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA2;
              onSelect("", res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]);
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const renderContent = () => {
    var _params$nocList2, _params$nocList3;
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$e, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            setFormData: setParams,
            initFormMTDocs: initFormMTDocs,
            setShowToast: setShowToast,
            isEmployee: isEmployee
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$9, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2$7, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$8, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, id && (isAppDataLoading || !(params !== null && params !== void 0 && params.applicationNo)) ? /*#__PURE__*/React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "Loading NOC data...")) : (params === null || params === void 0 ? void 0 : (_params$nocList2 = params.nocList) === null || _params$nocList2 === void 0 ? void 0 : _params$nocList2.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NOCTakeAction, {
            formData: params,
            onNocUpdate: updatedNocList => {
              setParams(prev => ({
                ...prev,
                nocList: updatedNocList,
                nocDetails: {
                  ...((prev === null || prev === void 0 ? void 0 : prev.nocDetails) || {}),
                  nocListApplicantDoc: updatedNocList
                }
              }));
            }
          }), (params === null || params === void 0 ? void 0 : (_params$nocList3 = params.nocList) === null || _params$nocList3 === void 0 ? void 0 : _params$nocList3.some(noc => {
            var _noc$documents;
            return noc === null || noc === void 0 ? void 0 : (_noc$documents = noc.documents) === null || _noc$documents === void 0 ? void 0 : _noc$documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          })) && /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 4px"
            }
          }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
            onClick: () => handleSubTabChange(5),
            variant: "contained",
            color: "success",
            size: "medium",
            label: "Save",
            type: "submit",
            sx: {
              backgroundColor: "#157CB3"
            }
          }))) : isEmployee ? /*#__PURE__*/React__default.createElement(IdentifyNoc, {
            formData: params,
            tenantId: tenantId,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          }) :
          /*#__PURE__*/
          React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "No NOC available for this user.")));
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$9, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step4$4, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 3) {
      return /*#__PURE__*/React__default.createElement(Step5$2, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4 && summaryShow && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary$4, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: (params === null || params === void 0 ? void 0 : params.status) === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(4, params),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 5) {
      return /*#__PURE__*/React__default.createElement(Step6$1, {
        formData: params,
        handleSubTabChange: handleTabChange
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Map Submission")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Fees"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "All Remarks"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), updateApiCall.isLoading && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const SubStep2$8 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _Digit$UserService$ge, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo9$o2, _formData$landInfo9$o3, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo10$2, _formData$landInfo10$3, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo11$2, _formData$landInfo11$3, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo12$2, _formData$landInfo12$3, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo13$2, _formData$landInfo13$3, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo14$2, _formData$landInfo14$3, _formData$structuralI, _formData$structuralI2, _formData$structuralI3, _formData$structuralI4, _formData$structuralI5;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const defaultValues = {
    ...formData,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo)
    }
  };
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const tenantId = Digit.ULBService.getStateId();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    trigger
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes(tenantId));
  });
  const watchState = watch("landInfo.owners.[0].correspondenceAddress.state");
  const [engineersArr, setEngsArr] = useState([]);
  const [user, setUser] = useState(null);
  const [selcectedEng, setSelectedEng] = useState(null);
  const watchStructuralName = watch("structuralInfo.name");
  const [watchCategoryType, watchCertNo, watchValidity] = watch(["professionaldetails.consultantCategory", "professionaldetails.certificateNo", "professionaldetails.validupto"]);
  useEffect(async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      var _userResponse$user;
      const userResponse = await Digit.UserService.userSearch(tenantId, {
        uuid: [uuid]
      }, {});
      const fetchedUser = userResponse === null || userResponse === void 0 ? void 0 : (_userResponse$user = userResponse.user) === null || _userResponse$user === void 0 ? void 0 : _userResponse$user[0];
      setUser(fetchedUser);
      if (fetchedUser) {
        var _fetchedUser$roles, _fetchedUser$roles$fi, _fetchedUser$roles$fi2, _fetchedUser$pwdExpir;
        const category = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$roles = fetchedUser.roles) === null || _fetchedUser$roles === void 0 ? void 0 : (_fetchedUser$roles$fi = _fetchedUser$roles.filter(e => e.code !== "CITIZEN")) === null || _fetchedUser$roles$fi === void 0 ? void 0 : (_fetchedUser$roles$fi2 = _fetchedUser$roles$fi[0]) === null || _fetchedUser$roles$fi2 === void 0 ? void 0 : _fetchedUser$roles$fi2.name;
        setValue("professionaldetails.consultantCategory", category);
        setValue("professionaldetails.certificateNo", fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.registrationNumber);
        const validUptoDate = fetchedUser === null || fetchedUser === void 0 ? void 0 : (_fetchedUser$pwdExpir = fetchedUser.pwdExpiryDate) === null || _fetchedUser$pwdExpir === void 0 ? void 0 : _fetchedUser$pwdExpir.slice(0, 10);
        const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
        setValue("professionaldetails.validupto", formattedDate);
      }
    }
  }, []);
  useEffect(async () => {
    var _users$filter;
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"],
      pageSize: "100000"
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !["test", null].includes(user.registrationNumber));
    setEngsArr(users);
    const selectedEngineer = (_users$filter = users.filter(user => user.uuid === formData.professionaldetails.engineerUuid)) === null || _users$filter === void 0 ? void 0 : _users$filter[0];
    if (selectedEngineer) {
      setSelectedEng(selectedEngineer);
    }
  }, []);
  useEffect(() => {
    const selectEng = engineersArr.filter(e => e.name === watchStructuralName);
    if (selectEng.length > 0) {
      var _selectedEngineer$pwd, _selectedEngineer$per;
      const selectedEngineer = selectEng[0];
      setValue("structuralInfo.licenseNumber", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : selectedEngineer.registrationNumber);
      const validUptoDate = selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$pwd = selectedEngineer.pwdExpiryDate) === null || _selectedEngineer$pwd === void 0 ? void 0 : _selectedEngineer$pwd.slice(0, 10);
      const formattedDate = validUptoDate ? validUptoDate.split("-").reverse().join("-") : null;
      setValue("structuralInfo.validupto", formattedDate);
      setValue("structuralInfo.permanentAddress.address", selectedEngineer === null || selectedEngineer === void 0 ? void 0 : (_selectedEngineer$per = selectedEngineer.permanentAddress) === null || _selectedEngineer$per === void 0 ? void 0 : _selectedEngineer$per.address);
    }
  }, [watchStructuralName]);
  useEffect(() => {
    var _formData$documents;
    if (formData && formData !== null && formData !== void 0 && formData.documents && (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      initFormMTDocs(formData === null || formData === void 0 ? void 0 : formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents]);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  console.log("DOcumentnenekas", documents);
  useEffect(() => {
    setValue("landInfo.owners.[0].gender", "Male");
    setValue("landInfo.owners.[0].fatherOrHusbandName", "NA");
  }, [watchState]);
  const onSubmit = data => {
    console.log("Data GOt", data, documents);
    handleSubTabChange(3, data);
  };
  console.log(engineersArr, "engineersArr");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchCategoryType
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.name
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionaldetails) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionaldetails) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.certificateNo,
    disabled: !!watchCertNo || isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionaldetails) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchValidity
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6,
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Attach LTP Signature"),
    control: control,
    name: "ltp_signature",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 1,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.mobileNumber
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : _formData$landInfo5$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : _formData$landInfo6$o2.emailId
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.state
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : (_formData$landInfo9$o2 = _formData$landInfo9$o[0]) === null || _formData$landInfo9$o2 === void 0 ? void 0 : (_formData$landInfo9$o3 = _formData$landInfo9$o2.correspondenceAddress) === null || _formData$landInfo9$o3 === void 0 ? void 0 : _formData$landInfo9$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : (_formData$landInfo10$2 = _formData$landInfo10$[0]) === null || _formData$landInfo10$2 === void 0 ? void 0 : (_formData$landInfo10$3 = _formData$landInfo10$2.correspondenceAddress) === null || _formData$landInfo10$3 === void 0 ? void 0 : _formData$landInfo10$3.town
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : (_formData$landInfo11$2 = _formData$landInfo11$[0]) === null || _formData$landInfo11$2 === void 0 ? void 0 : (_formData$landInfo11$3 = _formData$landInfo11$2.correspondenceAddress) === null || _formData$landInfo11$3 === void 0 ? void 0 : _formData$landInfo11$3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : (_formData$landInfo12$2 = _formData$landInfo12$[0]) === null || _formData$landInfo12$2 === void 0 ? void 0 : (_formData$landInfo12$3 = _formData$landInfo12$2.correspondenceAddress) === null || _formData$landInfo12$3 === void 0 ? void 0 : _formData$landInfo12$3.pinno
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : (_formData$landInfo13$2 = _formData$landInfo13$[0]) === null || _formData$landInfo13$2 === void 0 ? void 0 : (_formData$landInfo13$3 = _formData$landInfo13$2.correspondenceAddress) === null || _formData$landInfo13$3 === void 0 ? void 0 : _formData$landInfo13$3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 50,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : (_formData$landInfo14$2 = _formData$landInfo14$[0]) === null || _formData$landInfo14$2 === void 0 ? void 0 : (_formData$landInfo14$3 = _formData$landInfo14$2.correspondenceAddress) === null || _formData$landInfo14$3 === void 0 ? void 0 : _formData$landInfo14$3.address
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Structural Engineer Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Name")}`,
    placeholder: `${t("Cosultant Name")}`,
    name: "structuralInfo.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI = formData.structuralInfo) === null || _formData$structuralI === void 0 ? void 0 : _formData$structuralI.name,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("License Number"),
    placeholder: t("Enter License Number"),
    name: "structuralInfo.licenseNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI2 = formData.structuralInfo) === null || _formData$structuralI2 === void 0 ? void 0 : _formData$structuralI2.licenseNumber,
    type: "textInput",
    disabled: isEmployee,
    maxLength: 50
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "structuralInfo.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI3 = formData.structuralInfo) === null || _formData$structuralI3 === void 0 ? void 0 : _formData$structuralI3.validupto,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "structuralInfo.permanentAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$structuralI4 = formData.structuralInfo) === null || _formData$structuralI4 === void 0 ? void 0 : (_formData$structuralI5 = _formData$structuralI4.permanentAddress) === null || _formData$structuralI5 === void 0 ? void 0 : _formData$structuralI5.address,
    type: "textInput",
    disabled: true,
    maxLength: 50
  }))))), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep3$a = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _formData$description, _formData$plotInfo, _formData$plotInfo2;
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData
  };
  const {
    handleSubmit,
    watch,
    setValue,
    control
  } = useForm({
    defaultValues
  });
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  useEffect(() => {
    setValue("plotInfo.plotArea", formData === null || formData === void 0 ? void 0 : formData.plotArea);
    setValue("plotInfo.builtupArea", formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea);
  }, []);
  const onSubmit = data => {
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Plot Area"),
    name: "descriptionOfLand.landArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea,
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.plotArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanctioned Built up Area (sq.mtr)"),
    control: control,
    placeholder: t("Enter Sanctioned Built up Area"),
    name: "totalBuildUpArea",
    mandatory: true,
    maxLength: 15,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || (formData === null || formData === void 0 ? void 0 : (_formData$plotInfo = formData.plotInfo) === null || _formData$plotInfo === void 0 ? void 0 : _formData$plotInfo.builtupArea),
    type: "textInput",
    disabled: (formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea) || isEmployee,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Estimated Cost (INR)"),
    control: control,
    placeholder: t("Enter Estimated Cost"),
    name: "plotInfo.estimatedCost",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$plotInfo2 = formData.plotInfo) === null || _formData$plotInfo2 === void 0 ? void 0 : _formData$plotInfo2.estimatedCost,
    disabled: isEmployee,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null))), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const SubStep4$9 = ({
  formData,
  handleSubTabChange,
  isEmployee,
  isNocModule: _isNocModule = false
}) => {
  var _formData$documents, _formData$description, _formData$description2, _formData$description3, _formData$description4;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const kmlFile = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.find(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === "kmlFile");
  console.log("FORMDATATASTAYSTASTAYSYAGS", formData, "DOCUMENTS", documents, "DEFAULTVALUES", defaultValues);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    handleSubTabChange(4, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  }), !isEmployee && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, kmlFile ? /*#__PURE__*/React__default.createElement("div", {
    className: "download-kml",
    style: {
      display: "flex",
      alignItems: "center",
      gap: "280px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "KML File:"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "large",
    color: "info",
    onClick: () => getDocumentByFileStoreId(kmlFile === null || kmlFile === void 0 ? void 0 : kmlFile.fileStoreId, setLoading)
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "14px",
      height: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(TravelExploreOutlinedIcon, {
    color: "primary",
    sx: {
      fontSize: "14px"
    }
  }))) : /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && !_isNocModule && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step2$a = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  var _formData$description, _Digit, _fastPasData$landUse, _fastPasData$mapSubmi;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData
  };
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const {
    handleSubmit,
    control,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  const fastPasData = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("FASTPAS_ID_DATA");
  const landUseDocs = (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$landUse = fastPasData.landUse) === null || _fastPasData$landUse === void 0 ? void 0 : _fastPasData$landUse.documents) || [];
  const mapSubDocs = (fastPasData === null || fastPasData === void 0 ? void 0 : (_fastPasData$mapSubmi = fastPasData.mapSubmission) === null || _fastPasData$mapSubmi === void 0 ? void 0 : _fastPasData$mapSubmi.documents) || [];
  const identifyLayoutCase = data => {
    var _data$descriptionOfLa, _data$descriptionOfLa2;
    if ((data === null || data === void 0 ? void 0 : (_data$descriptionOfLa = data.descriptionOfLand) === null || _data$descriptionOfLa === void 0 ? void 0 : _data$descriptionOfLa.activityProposed) === "Plotted Development" || (data === null || data === void 0 ? void 0 : (_data$descriptionOfLa2 = data.descriptionOfLand) === null || _data$descriptionOfLa2 === void 0 ? void 0 : _data$descriptionOfLa2.activityProposed) === "Plotted Development - Affordable") {
      return true;
    } else return false;
  };
  const isLayoutCase = identifyLayoutCase(formData);
  useEffect(() => {
    async function fetchLTPData() {
      var _userInfo$info;
      const createdBy = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
      try {
        var _response$Licenses, _ltpData$, _ltpData$$tradeLicens, _ltpData$$tradeLicens2;
        const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
          createdBy: createdBy
        });
        const ltpData = (response === null || response === void 0 ? void 0 : (_response$Licenses = response.Licenses) === null || _response$Licenses === void 0 ? void 0 : _response$Licenses.filter(e => e.status === "APPROVED")) || [];
        console.log(response, ltpData, "ltpDataaaaaa");
        const regCert = (ltpData === null || ltpData === void 0 ? void 0 : (_ltpData$ = ltpData[0]) === null || _ltpData$ === void 0 ? void 0 : (_ltpData$$tradeLicens = _ltpData$.tradeLicenseDetail) === null || _ltpData$$tradeLicens === void 0 ? void 0 : (_ltpData$$tradeLicens2 = _ltpData$$tradeLicens.applicationDocuments) === null || _ltpData$$tradeLicens2 === void 0 ? void 0 : _ltpData$$tradeLicens2.filter(e => e.documentType === "Registration Certificate")) || [];
        const allDocs = [...regCert, ...documents, ...landUseDocs, ...mapSubDocs, ...((formData === null || formData === void 0 ? void 0 : formData.documents) || [])];
        const uniqueDocs = Array.from(new Map(allDocs.map(doc => [doc.fileStoreId, doc])).values());
        initFormMTDocs(uniqueDocs);
      } catch (error) {
        console.error("Error fetching migrated data:", error);
      }
    }
    fetchLTPData();
  }, []);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    var _data;
    data = {
      ...data,
      documents: mergeDocumentsWithSitePhotos(((_data = data) === null || _data === void 0 ? void 0 : _data.documents) || documents || [], [formData === null || formData === void 0 ? void 0 : formData.documents]),
      nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails
    };
    console.log("dataFromDocComponent", data);
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })))))))), (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) === "Compounding" && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Compounding Documents"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, (formData === null || formData === void 0 ? void 0 : formData.shortName) === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Sanction Map"),
    control: control,
    name: "Sanction Map",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    trigger: trigger
  }))), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Sanction Letter"),
    control: control,
    name: "Sanction Letter",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  })), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding Drawing PDF"),
    control: control,
    name: "compoundingDrawingPdf",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Compounding drawing dwg"),
    control: control,
    name: "compoundingDrawingDxf",
    validationMsg: "Upload File",
    required: true,
    tab: 3,
    trigger: trigger
  })), (formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty) === "In response to notice" && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upload Notice"),
    control: control,
    name: "responseNotice",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement("div", {
    class: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))))), /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Architect/Engineer Registration Certificate"),
    control: control,
    name: "Registration Certificate",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    maxFiles: 1,
    trigger: trigger
  })), !isLowRiskCase && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Calculation sheet of Estimate with Affidavit"),
    control: control,
    name: "calculationSheet",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Khatauni"),
    control: control,
    name: "khatauni",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ownerAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing Pdf"),
    control: control,
    name: "drawingPDF",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    label: t("Allotment Letter/Possession Letter"),
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement"),
    control: control,
    name: "registrySaleDeedHPTA",
    isMandatory: true,
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Developer/Consortium/Sales Agreement"),
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    trigger: trigger
  })), !isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isLayoutCase && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Revised map"),
    control: control,
    name: "revisedMap",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "sitePhoto",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*"))))))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Audit Report"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Additional Document if any"),
    control: control,
    name: "additionalDoc",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Drawing and Design "),
    control: control,
    name: "structuraldrawing",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Stability Certificate"),
    control: control,
    name: "structuralcertificate",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Design calculation Report"),
    control: control,
    name: "calculationReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    label: t("Vetted Structure and drawing along with certificate"),
    name: "vettedStructure",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer."),
    control: control,
    name: "annexture789",
    validationMsg: "Upload File"
  })), isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    class: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*"))), /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Approved Layout sanctioned Letter"),
    control: control,
    name: "sanctionLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (Allowed Format .pdf)*"))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const ViewCompletionChallan = ({
  formData,
  taxHead,
  totalAmount
}) => {
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const [taxHeadEstimates, setTaxHeadEstimates] = useState((formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimates) || []);
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: "100%",
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    sx: {
      minWidth: 700
    },
    "aria-label": "payment memo table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      backgroundColor: "rgba(52, 73, 94, 0.94)",
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Memo")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Challan No.")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Date")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount (in Rs.)")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      color: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Print Receipt")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, taxHeadEstimates.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(IconButton$1, null, /*#__PURE__*/React__default.createElement(PaymentChallanPopup, {
    formData: formData,
    item: item,
    taxHead: taxHead,
    totalAmount: totalAmount
  }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, item.challanNo || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item.challanGeneratedDateTime ? (() => {
    const [datePart] = item.challanGeneratedDateTime.split(" ");
    const [yyyy, mm, dd] = datePart.split("-");
    return `${dd}-${mm}-${yyyy}`;
  })() : "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, item.estimateAmount || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" || (item === null || item === void 0 ? void 0 : item.paymentStatus) === "PAID" ? /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => {
      setShowPaymentDetails(true);
      setSelectedChallanNo(item.challanNo);
    }
  }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"), showPaymentDetails && selectedChallanNo === item.challanNo && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Payment Details",
    dataOpen: showPaymentDetails,
    onClose: () => setShowPaymentDetails(false)
  }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    formData: formData
  }))))))));
};

const Step5$3 = ({
  formData,
  handleTabChange,
  isEmployee
}) => {
  var _data$BPA;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const {
    data,
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const [taxHead, setTaxHead] = useState([]);
  const paymentHeads = data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA.MapSubPaymentHeads;
  console.log(paymentHeads, "paymentheads");
  const paymentHeadsDropdown = paymentHeads === null || paymentHeads === void 0 ? void 0 : paymentHeads.map(item => ({
    name: item.label,
    label: item.label,
    value: item.label
  }));
  const defaultValues = {
    ...formData,
    paymentHeads: (formData === null || formData === void 0 ? void 0 : formData.paymentHeads) || [{
      feeType: "",
      plotBuildUpArea: "",
      rate: ""
    }]
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: "paymentHeads"
  });
  const totalTaxHeadAmount = taxHead === null || taxHead === void 0 ? void 0 : taxHead.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const onSubmit = data => {
    data.paymentHeads = taxHead;
    handleTabChange(3);
  };
  function isValidityExpired() {
    if (!(formData !== null && formData !== void 0 && formData.validityDate)) return false;
    const [year, month, day] = formData.validityDate.split("-").map(Number);
    const validityDate = new Date(year, month - 1, day);
    const oneYearAfter = new Date(validityDate);
    oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);
    const today = new Date();
    return today > oneYearAfter;
  }
  const isFeesRequired = isValidityExpired();
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, isFeesRequired ? /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement(ViewCompletionChallan, {
    formData: formData
  })), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, "No Fees is required"), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit",
    onClick: () => handleTabChange(3),
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step6$2 = ({
  formData,
  handleTabChange
}) => {
  var _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10;
  const {
    t
  } = useTranslation();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const tenantId = Digit.ULBService.getStateId();
  const onSubmit = data => {
    handleTabChange(4, data);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
    moduleCode: formData === null || formData === void 0 ? void 0 : formData.businessService
  });
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData, _applicationData$audi, _applicationData2;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$audi = _applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: ((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData3, _applicationData3$aud, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : (_applicationData3$aud = _applicationData3.auditDetails) === null || _applicationData3$aud === void 0 ? void 0 : _applicationData3$aud.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application History")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.timeline) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BreakLine, null), (workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && /*#__PURE__*/React__default.createElement("div", null, workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data3 = workflowDetails.data) !== null && _workflowDetails$data3 !== void 0 && _workflowDetails$data3.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4.timeline) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.length) === 1 ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      backgroundColor: "aliceblue",
      borderRadius: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline[0]) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.timeline[0])
  })) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(Card, {
      style: {
        backgroundColor: "aliceblue",
        borderRadius: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint["status"]}`),
      customChild: getTimelineCaptions(checkpoint)
    })));
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const CompletionPortal = () => {
  const {
    t
  } = useTranslation();
  const logic = useCompletionPortalLogic(t);
  const {
    activeTab,
    setActiveTab,
    selectedSubTab,
    setSelectedSubTab,
    summaryShow,
    setSummaryshow,
    showToast,
    setShowToast,
    declarationChecked,
    handleDeclarationChange,
    closeToast,
    params,
    setParams,
    clearParams,
    tenantId,
    isEmployee,
    id,
    applicationData,
    isAppDataLoading,
    isSelfCert,
    componentRef,
    subTabLabels,
    handleTabChange,
    handleSubTabChange,
    onSelect,
    isCompounding,
    initFormMTDocs,
    isFeesRequired,
    isLayoutCase,
    isCitizen,
    updateApiCall
  } = logic;
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  console.log("applicationData", params === null || params === void 0 ? void 0 : params.applicationNo, "allParamData", params, "UD-projectset", id);
  const renderContent = () => {
    var _params$nocList, _params$nocList2;
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$7, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            setFormData: setParams,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            initFormMTDocs: initFormMTDocs,
            setShowToast: setShowToast,
            isEmployee: isEmployee
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$a, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep2$8, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$9, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, id && (isAppDataLoading || !(params !== null && params !== void 0 && params.applicationNo)) ? /*#__PURE__*/React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "Loading NOC data...")) : (params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NOCTakeAction, {
            formData: params,
            onNocUpdate: updatedNocList => {
              setParams(prev => ({
                ...prev,
                nocList: updatedNocList,
                nocDetails: {
                  ...((prev === null || prev === void 0 ? void 0 : prev.nocDetails) || {}),
                  nocListApplicantDoc: updatedNocList
                }
              }));
            }
          }), (params === null || params === void 0 ? void 0 : (_params$nocList2 = params.nocList) === null || _params$nocList2 === void 0 ? void 0 : _params$nocList2.some(noc => {
            var _noc$documents;
            return noc === null || noc === void 0 ? void 0 : (_noc$documents = noc.documents) === null || _noc$documents === void 0 ? void 0 : _noc$documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          })) && /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 4px"
            }
          }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
            onClick: () => handleSubTabChange(5),
            variant: "contained",
            color: "success",
            size: "medium",
            label: "Save",
            type: "submit",
            sx: {
              backgroundColor: "#157CB3"
            }
          }))) : isEmployee ? /*#__PURE__*/React__default.createElement(IdentifyNoc, {
            formData: params,
            tenantId: tenantId,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          }) :
          /*#__PURE__*/
          React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "No NOC available for this user.")));
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$a, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 2 && !isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step5$3, {
        formData: params,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 3 && !isCompounding) {
      return /*#__PURE__*/React__default.createElement(Step7, {
        formData: params,
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        handleTabChange: handleTabChange,
        isEmployee: isEmployee
      });
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(CompletionChecklist, {
        formData: params,
        isEmployee: isEmployee,
        handleTabChange: handleTabChange,
        isLayoutCase: isLayoutCase,
        isCitizen: isCitizen,
        setParams: setParams,
        onSelect: onSelect
      });
    } else if (activeTab === 5) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true,
        formType: "FORM_COMPLETION"
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT"))), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: isFeesRequired ? "MAKE PAYMENT" : "SUBMIT",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(5, params),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 6 && summaryShow && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement(Step6$2, {
        formData: params,
        handleSubTabChange: handleTabChange
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Completion Module")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Fees"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing Details"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application History"
  }))), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), (updateApiCall === null || updateApiCall === void 0 ? void 0 : updateApiCall.isLoading) && /*#__PURE__*/React__default.createElement(FullScreenLoader, null));
};

const MapSubmissionSummary$2 = forwardRef(({
  formData,
  ref,
  handleDeclarationChange,
  declarationChecked,
  showDeclaration: _showDeclaration = false
}) => {
  var _formData$landInfo, _formData$taxHeadEsti, _documents$filter, _documents$filter$, _Digit$SessionStorage, _feeDetail$mapRates, _formData$plotNumbers, _structuralInfo$perma, _structuralInfo$perma2, _formData$description;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const plotInfo = formData === null || formData === void 0 ? void 0 : formData.plotInfo;
  const structuralInfo = formData === null || formData === void 0 ? void 0 : formData.structuralInfo;
  const ownerInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const professionalInfo = formData === null || formData === void 0 ? void 0 : formData.professionaldetails;
  const feeDetail = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)(\[\d+\])?$/.test(doc.documentType));
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  console.log("applicationFlow is:", applicationFlow);
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const watchProposalType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const watchisSpecialProject = formData === null || formData === void 0 ? void 0 : formData.isSpecialProject;
  const watchPlotSubdivided = formData === null || formData === void 0 ? void 0 : formData.plotSubdivided;
  const watchNeedComp = formData === null || formData === void 0 ? void 0 : formData.needCompounding;
  const watchplotLeaseHold = formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold;
  const watchisSetbackRequired = formData === null || formData === void 0 ? void 0 : formData.isSetbackRequired;
  const watchProjectType = formData === null || formData === void 0 ? void 0 : formData.projectType;
  const watchPlanOn = formData === null || formData === void 0 ? void 0 : formData.planOn;
  const watchNatureOfConstruction = formData === null || formData === void 0 ? void 0 : formData.constructionType;
  const watchbuildingClassification = formData === null || formData === void 0 ? void 0 : formData.buildingClassification;
  const mapRatesList = feeDetail === null || feeDetail === void 0 ? void 0 : (_feeDetail$mapRates = feeDetail.mapRates) === null || _feeDetail$mapRates === void 0 ? void 0 : _feeDetail$mapRates.map((rate, index) => ({
    ...rate,
    heading: index === 0 ? "Buildup Area Fee" : index === 1 ? "Site Inspection Fee" : `Fee ${index + 1}`
  }));
  const totalFeeAmount = mapRatesList === null || mapRatesList === void 0 ? void 0 : mapRatesList.reduce((sum, mr) => sum + (parseFloat(mr === null || mr === void 0 ? void 0 : mr.price) || 0), 0);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, "LUCKNOW ", nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "General Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionNo)), (formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevSanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.currValidityDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Current Validity Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.currValidityDate)), (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)), (formData === null || formData === void 0 ? void 0 : formData.zoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.zoneType)), (formData === null || formData === void 0 ? void 0 : formData.subZoneType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Sub Use:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.subZoneType)), (formData === null || formData === void 0 ? void 0 : formData.primaryUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.primaryUse)), (edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity proposed:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed)), (formData === null || formData === void 0 ? void 0 : formData.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.planOn)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherSchemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Proposed Site:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherSchemeName)), (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Layout Sanction Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), (formData === null || formData === void 0 ? void 0 : formData.isMetroCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is this Site falls in Metro City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isMetroCity)), watchPlanOn === "Others" && (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.constructionType)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nature of Construction /Case Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction)), watchNatureOfConstruction !== "New" && (formData === null || formData === void 0 ? void 0 : formData.prevFileNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Prev File No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.prevFileNo)), (formData === null || formData === void 0 ? void 0 : formData.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.schemeName)), (formData === null || formData === void 0 ? void 0 : formData.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.tehsil)), (formData === null || formData === void 0 ? void 0 : formData.revenueVillage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Revenue Village/College Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.revenueVillage)), (formData === null || formData === void 0 ? void 0 : formData.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Mark:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.landMark)), (formData === null || formData === void 0 ? void 0 : formData.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector/Pocket No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sectorNo)), (formData === null || formData === void 0 ? void 0 : formData.khasraNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.khasraNo)), (formData === null || formData === void 0 ? void 0 : formData.proposalType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Standard Type Design:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.proposalType)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction date Of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionDate)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.sanctionNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sanction number of layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.sanctionNumber)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.noOfPlots) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.noOfPlots)), watchProposalType === "yes" && (formData === null || formData === void 0 ? void 0 : formData.plotNumbers) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.join(", "))), (formData === null || formData === void 0 ? void 0 : formData.buildingClassification) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingClassification)), watchbuildingClassification === "Others" && (formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass)), (formData === null || formData === void 0 ? void 0 : formData.isSpecialProject) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Project Type:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.isSpecialProject)), (formData === null || formData === void 0 ? void 0 : formData.communityParking) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "If Community Parking Provided:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.communityParking)), watchisSpecialProject === "yes" && (formData === null || formData === void 0 ? void 0 : formData.projectType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Special Condition Of Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.projectType)), watchisSpecialProject === "Other" && (formData === null || formData === void 0 ? void 0 : formData.otherProjectName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Project:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.otherProjectName)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.groundCoverage) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Ground Coverage:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.groundCoverage)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.far) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "FAR:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.far)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.buildingHeight) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Building Height:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.buildingHeight)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackFronts) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackFronts)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackRears) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackRears)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback- 1:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide1)), watchisSpecialProject === "yes" && (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && (formData === null || formData === void 0 ? void 0 : formData.setbackSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Setback - 2:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setbackSide2)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (formData === null || formData === void 0 ? void 0 : formData.plotSubdivided) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Plot Sub-division:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotSubdivided)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && (formData === null || formData === void 0 ? void 0 : formData.needCompounding) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Does existing building require any compounding ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.needCompounding)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchNeedComp === "no" && (formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is your plot Lease hold ?:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold)), (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && watchPlotSubdivided === "no" && watchplotLeaseHold === "yes" && (edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC for Lease hold :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Front:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Rear:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Left:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Setback Right:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2)), watchisSetbackRequired === "yes" && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "No. Of Plots:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.consultantCategory)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.certificateNo)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, professionalInfo === null || professionalInfo === void 0 ? void 0 : professionalInfo.validupto))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, ownerInfo === null || ownerInfo === void 0 ? void 0 : ownerInfo.map((item, index) => {
    var _item$inputonGST, _item$inputonGST2, _item$inputonGST3, _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? "Addition Owner Information" : "Owner Information")), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Email Id:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Input On GST:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST = item.inputonGST) === null || _item$inputonGST === void 0 ? void 0 : _item$inputonGST.value) === "yes" ? "Yes" : (item === null || item === void 0 ? void 0 : item.inputonGST) === "no" || (item === null || item === void 0 ? void 0 : (_item$inputonGST2 = item.inputonGST) === null || _item$inputonGST2 === void 0 ? void 0 : _item$inputonGST2.value) === "no" ? "No" : (item === null || item === void 0 ? void 0 : item.inputonGST) || "N/A")), ((item === null || item === void 0 ? void 0 : item.inputonGST) === "yes" || (item === null || item === void 0 ? void 0 : (_item$inputonGST3 = item.inputonGST) === null || _item$inputonGST3 === void 0 ? void 0 : _item$inputonGST3.value) === "yes") && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "GST No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (item === null || item === void 0 ? void 0 : item.gstNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.town)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.address)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin No:")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "200px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$2, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo))))))));
  })), structuralInfo && (structuralInfo.name || structuralInfo.validupto || structuralInfo.licenseNumber || ((_structuralInfo$perma = structuralInfo.permanentAddress) === null || _structuralInfo$perma === void 0 ? void 0 : _structuralInfo$perma.address)) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.name) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Valid Upto:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.validupto) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : structuralInfo.licenseNumber) || "N/A")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (structuralInfo === null || structuralInfo === void 0 ? void 0 : (_structuralInfo$perma2 = structuralInfo.permanentAddress) === null || _structuralInfo$perma2 === void 0 ? void 0 : _structuralInfo$perma2.address) || "N/A"))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.landArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Built-up Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.totalBuildUpArea)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Estimated Cost:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.estimatedCost)), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot area as per Drawing (Sq.Mt):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, plotInfo === null || plotInfo === void 0 ? void 0 : plotInfo.plotArea))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$additionalD, _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$additionalD = document.additionalDetails) === null || _document$additionalD === void 0 ? void 0 : _document$additionalD.title) || (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  }), (formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL) && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React__default.createElement("strong", null, "Digitally Signed Drawing PDF"), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px",
      cursor: "pointer"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.signedDrawingPdfURL, "_blank")
  }))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, mapRatesList === null || mapRatesList === void 0 ? void 0 : mapRatesList.map((rate, idx) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: idx
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, rate.heading, ":")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, rate.name)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Area (SQM):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, rate.area)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rate (\u20B9):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, rate.unitPrice)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fee (\u20B9):")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, rate.price)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React__default.createElement("hr", null))))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Fees:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, totalFeeAmount))))))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Drawing")))), (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, " ", /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Plan Report", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.planReport, "_blank")
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "DXF File", " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.dxfFile, "_blank")
  })))))))), _showDeclaration && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      checked: declarationChecked,
      onChange: handleDeclarationChange
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I, as a Licensed Technical Professional (LTP), certify that all the details provided in the application form has been checked and verified against the Building Bylaws and Rules applicable in the State of Uttar Pradesh. I also understand that approval of this application shall be based on Trust and Simplified Process, hence I take total ownership of information and documents submitted with this application.", " ")
  }))));
});

const SubStep1$f = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _data$MapSubmission, _data$MapSubmission$D, _formData$plotNumbers, _formData$description, _fastPASData$descript7, _fastPASData$descript8, _fastPASData$descript9, _fastPASData$descript10;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const designType = formData === null || formData === void 0 ? void 0 : formData.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [watchProposalType, watchisSpecialProject, watchTypeOfProject, watchPlotSubdivided, watchNeedComp, watchPlanOn, watchisRevised, watchNoOfPLots, watchisApprovedLayout, watchisSetbackRequired, watchplotLeaseHold, watchSpecialGroundCoverage, watchisSpecialFAR, watchProjectType, watchnatureOfConstruction, watchbuildingClassification, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchSectorNo, watchLandMark, watchKhasraNo, watchTehsil, watchCompunding] = watch(["proposalType", "isSpecialProject", "typeOfProject", "plotSubdivided", "needCompounding", "plotLeaseHold", "isRevised", "noOfPlots", "isApprovedLayout", "isSetbackRequired", "planOn", "isSpecialGroundCoverage", "isSpecialFAR", "projectType", "natureOfConstruction", "buildingClassification", "zoneType", "subZoneType", "primaryUse", "activityProposed", "sectorNo", "landMark", "khasraNo", "tehsil", "shortName"]);
  const watchedFields = watch();
  const mappedPlot = formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers = formData.plotNumbers) === null || _formData$plotNumbers === void 0 ? void 0 : _formData$plotNumbers.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({
    length: totalPlots
  }, (_, index) => ({
    index: index + 1
  }));
  const plotNumbers = plotInputs.map(plot => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
        natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions,
        proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
        isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
        groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
        fars: formData === null || formData === void 0 ? void 0 : formData.fars,
        buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
        previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
        previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears
      });
    }
  }, [formData]);
  useEffect(() => {}, [watchedFields]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const riskType = watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ? "Building Plan Low Risk, Self Certification Mode" : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") && watchAtivityProposed !== "Row Houses" && watchAtivityProposed !== "Semi Detached" && watchAtivityProposed !== "Detached" ? "High Risk and High Nivesh" : watchlandUseType === "Commercial" ? "High Risk and High Nivesh" : watchPlanOn !== "Others" ? "Building Plan-Low Risk" : "Others";
    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$filter, _response4, _response4$BPA, _response4$BPA$filter, _data2, _data2$descriptionOfL, _data3, _data3$descriptionOfL, _data4, _data4$descriptionOfL, _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL, _data6$descriptionOfL2, _data7, _data7$descriptionOfL, _data8, _data9, _data9$descriptionOfL, _data10, _data10$descriptionOf, _data11, _data11$descriptionOf, _data12, _data12$descriptionOf, _data13, _data13$descriptionOf, _data14, _data14$landInfo, _data14$landInfo$owne, _data14$landInfo$owne2, _data14$landInfo$owne3, _data15, _data15$descriptionOf, _data16, _data16$descriptionOf, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        purchasableData = (_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$BPA = _response4.BPA) === null || _response4$BPA === void 0 ? void 0 : (_response4$BPA$filter = _response4$BPA.filter(item => item.applicationType === "FORM_PURCHASABLE_FAR")) === null || _response4$BPA$filter === void 0 ? void 0 : _response4$BPA$filter[0];
        if (data) {
          const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
          if (uuid) {
            var _usersResponse$user, _data, _data$additionalDetai, _data$additionalDetai2;
            const usersResponse = await Digit.UserService.userSearch(stateId, {
              uuid: [uuid]
            }, {});
            const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (((_data = data) === null || _data === void 0 ? void 0 : (_data$additionalDetai = _data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.professionalInformation) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.mobileNumber) === (userDetail === null || userDetail === void 0 ? void 0 : userDetail.mobileNumber)) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("zoneType", (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$descriptionOfL = _data2.descriptionOfLand) === null || _data2$descriptionOfL === void 0 ? void 0 : _data2$descriptionOfL.landUsesType);
        setValue("primaryUse", (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$descriptionOfL = _data3.descriptionOfLand) === null || _data3$descriptionOfL === void 0 ? void 0 : _data3$descriptionOfL.activityAsPerMap);
        setValue("landMark", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$descriptionOfL = _data4.descriptionOfLand) === null || _data4$descriptionOfL === void 0 ? void 0 : _data4$descriptionOfL.landMark);
        setValue("sectorNo", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.sectorNo);
        setValue("khasraNo", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : (_data6$descriptionOfL2 = _data6$descriptionOfL.khasraWithArea[0]) === null || _data6$descriptionOfL2 === void 0 ? void 0 : _data6$descriptionOfL2.khasraNo);
        setValue("schemeName", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.schemeName);
        setValue("riskType", (_data8 = data) === null || _data8 === void 0 ? void 0 : _data8.riskType);
        setValue("activityProposed", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$descriptionOfL = _data9.descriptionOfLand) === null || _data9$descriptionOfL === void 0 ? void 0 : _data9$descriptionOfL.activityProposed);
        setValue("plotArea", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$descriptionOf = _data10.descriptionOfLand) === null || _data10$descriptionOf === void 0 ? void 0 : _data10$descriptionOf.landArea);
        setValue("plotAreaDoc", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$descriptionOf = _data11.descriptionOfLand) === null || _data11$descriptionOf === void 0 ? void 0 : _data11$descriptionOf.plotAreaDoc);
        setValue("plotAreaPos", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$descriptionOf = _data12.descriptionOfLand) === null || _data12$descriptionOf === void 0 ? void 0 : _data12$descriptionOf.plotAreaPossession);
        setValue("siteAddress", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$descriptionOf = _data13.descriptionOfLand) === null || _data13$descriptionOf === void 0 ? void 0 : _data13$descriptionOf.landAddress);
        setValue("tehsil", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$landInfo = _data14.landInfo) === null || _data14$landInfo === void 0 ? void 0 : (_data14$landInfo$owne = _data14$landInfo.owners) === null || _data14$landInfo$owne === void 0 ? void 0 : (_data14$landInfo$owne2 = _data14$landInfo$owne[0]) === null || _data14$landInfo$owne2 === void 0 ? void 0 : (_data14$landInfo$owne3 = _data14$landInfo$owne2.permanentAddress) === null || _data14$landInfo$owne3 === void 0 ? void 0 : _data14$landInfo$owne3.tehsil);
        setValue("typeOfArea", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$descriptionOf = _data15.descriptionOfLand) === null || _data15$descriptionOf === void 0 ? void 0 : _data15$descriptionOf.developmentArea);
        setValue("subZoneType", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$descriptionOf = _data16.descriptionOfLand) === null || _data16$descriptionOf === void 0 ? void 0 : _data16$descriptionOf.subLandUseAsPerLayout);
        const isApproved = ((_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.schemeType) === "Scheme";
        const plotArea = (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.landArea;
        setRiskType((_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.riskType);
        setSchemeType(isApproved);
        if (!isApproved) {
          setValue("plotLeaseHold", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.name === authority);
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Categery, _masterData$2, _masterData$2$Categer, _masterData$2$Categer2, _masterData$2$Categer3, _masterData$2$Categer4;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Categery = _masterData$.CategeryType) === null || _masterData$$Categery === void 0 ? void 0 : _masterData$$Categery.map(item => {
      return {
        name: item.Categery,
        label: item.Categery
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categer = _masterData$2.CategeryType) === null || _masterData$2$Categer === void 0 ? void 0 : (_masterData$2$Categer2 = _masterData$2$Categer.filter(item => item.Categery === category)) === null || _masterData$2$Categer2 === void 0 ? void 0 : (_masterData$2$Categer3 = _masterData$2$Categer2[0]) === null || _masterData$2$Categer3 === void 0 ? void 0 : (_masterData$2$Categer4 = _masterData$2$Categer3["Activity Proposed"]) === null || _masterData$2$Categer4 === void 0 ? void 0 : _masterData$2$Categer4.map(item => {
      return {
        name: item,
        label: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = !schemeType ? filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType) : filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchlandUseType);
  console.log(schemeType, "schemeTypeerrrrr");
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const onSubmit = data => {
    var _data22;
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    if (!isSelfCert && file) {
      data.file = file;
    }
    if (isCompounding) {
      var _data20, _fastPASData$descript;
      data.landInfo = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.tenantId = stateId;
      data.land_Id = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id;
      data.documents = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents;
      data.descriptionOfLand = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand;
      data.nocDetails = fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails;
      data.occupancy = (_data20 = data) === null || _data20 === void 0 ? void 0 : _data20.zoneType;
      data.totalProposedArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript = fastPASData.descriptionOfLand) === null || _fastPASData$descript === void 0 ? void 0 : _fastPASData$descript.landArea;
    }
    if (isSelfCert) {
      var _data21, _fastPASData$descript2, _fastPASData$addition, _fastPASData$addition2, _fastPASData$descript3, _fastPASData$descript4, _fastPASData$descript5, _fastPASData$descript6;
      const newFormData = {
        landInfo: {
          ...(fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.landInfo)
        },
        tenantId: stateId,
        land_Id: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.land_Id,
        documents: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.documents,
        descriptionOfLand: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.descriptionOfLand,
        nocDetails: fastPasdata === null || fastPasdata === void 0 ? void 0 : fastPasdata.nocDetails,
        occupancy: (_data21 = data) === null || _data21 === void 0 ? void 0 : _data21.zoneType,
        totalProposedArea: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript2 = fastPASData.descriptionOfLand) === null || _fastPASData$descript2 === void 0 ? void 0 : _fastPASData$descript2.landArea
      };
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition = fastPASData.additionalDetails) === null || _fastPASData$addition === void 0 ? void 0 : _fastPASData$addition.selectedOffice) || "";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition2 = fastPASData.additionalDetails) === null || _fastPASData$addition2 === void 0 ? void 0 : _fastPASData$addition2.selectedCity) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.purchasableFAR = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript3 = fastPASData.descriptionOfLand) === null || _fastPASData$descript3 === void 0 ? void 0 : (_fastPASData$descript4 = _fastPASData$descript3.properties) === null || _fastPASData$descript4 === void 0 ? void 0 : (_fastPASData$descript5 = _fastPASData$descript4[0]) === null || _fastPASData$descript5 === void 0 ? void 0 : _fastPASData$descript5.requiredAreaFAR) || 0;
      data.fastPASId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id;
      data.department = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department;
      data.plotArea = fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript6 = fastPASData.descriptionOfLand) === null || _fastPASData$descript6 === void 0 ? void 0 : _fastPASData$descript6.landArea, data = {
        ...data,
        ...newFormData
      };
    }
    if (!id) {
      var _fastPASData$landInfo, _fastPASData$landInfo2, _fastPASData$landInfo3, _fastPASData$landInfo4, _fastPASData$landInfo5, _fastPASData$landInfo6, _fastPASData$landInfo7, _fastPASData$landInfo8, _fastPASData$landInfo9, _fastPASData$addition3, _fastPASData$addition4, _fastPASData$document, _fastPASData$document2, _user$correspondenceA;
      data.plotNumbers = plotNumbers, data.applicantName = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo = fastPASData.landInfo) === null || _fastPASData$landInfo === void 0 ? void 0 : (_fastPASData$landInfo2 = _fastPASData$landInfo.owners) === null || _fastPASData$landInfo2 === void 0 ? void 0 : (_fastPASData$landInfo3 = _fastPASData$landInfo2[0]) === null || _fastPASData$landInfo3 === void 0 ? void 0 : _fastPASData$landInfo3.name) || "";
      data.applicantEmailId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo4 = fastPASData.landInfo) === null || _fastPASData$landInfo4 === void 0 ? void 0 : (_fastPASData$landInfo5 = _fastPASData$landInfo4.owners) === null || _fastPASData$landInfo5 === void 0 ? void 0 : (_fastPASData$landInfo6 = _fastPASData$landInfo5[0]) === null || _fastPASData$landInfo6 === void 0 ? void 0 : _fastPASData$landInfo6.emailId) || "";
      data.aplicantMobileNumber = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$landInfo7 = fastPASData.landInfo) === null || _fastPASData$landInfo7 === void 0 ? void 0 : (_fastPASData$landInfo8 = _fastPASData$landInfo7.owners) === null || _fastPASData$landInfo8 === void 0 ? void 0 : (_fastPASData$landInfo9 = _fastPASData$landInfo8[0]) === null || _fastPASData$landInfo9 === void 0 ? void 0 : _fastPASData$landInfo9.mobileNumber) || "";
      data.selectedOffice = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition3 = fastPASData.additionalDetails) === null || _fastPASData$addition3 === void 0 ? void 0 : _fastPASData$addition3.selectedOffice) || "";
      data.selectedCity = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$addition4 = fastPASData.additionalDetails) === null || _fastPASData$addition4 === void 0 ? void 0 : _fastPASData$addition4.selectedCity) || "";
      data.landUseNo = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.applicationNo;
      data.department = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department;
      data.fastPASId = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.land_Id;
      data.signatureId = (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$document = fastPASData.documents) === null || _fastPASData$document === void 0 ? void 0 : (_fastPASData$document2 = _fastPASData$document.filter(doc => doc.documentType === "signature")[0]) === null || _fastPASData$document2 === void 0 ? void 0 : _fastPASData$document2.fileStoreId) || null;
      data.licenseeName = user === null || user === void 0 ? void 0 : user.name, data.licenseeLicenceNumber = user === null || user === void 0 ? void 0 : user.registrationNumber;
      data.licenseeMobileNumber = user === null || user === void 0 ? void 0 : user.mobileNumber;
      data.licenseeEmailId = user === null || user === void 0 ? void 0 : user.emailId;
      data.licenseeAddress = user === null || user === void 0 ? void 0 : (_user$correspondenceA = user.correspondenceAddress) === null || _user$correspondenceA === void 0 ? void 0 : _user$correspondenceA.address;
    }
    const resolvedDept = (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.department) || ((_data22 = data) === null || _data22 === void 0 ? void 0 : _data22.department) || applicationFlow;
    const resolvedBizService = resolvedDept === "DA" || applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
    data.department = resolvedDept;
    data.businessService = resolvedBizService;
    if (isSelfCert || scrutinyFlow !== "EDCR") {
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      handleTabChange(1, id ? {
        ...formData,
        ...data
      } : data);
    } else {
      var _data23;
      data.applicationType = "BUILDING_PLAN_SCRUTINY";
      data.appliactionType = "BUILDING_PLAN_SCRUTINY";
      handleSubTabChange(1, id ? {
        ...formData,
        ...data,
        file: file || ((_data23 = data) === null || _data23 === void 0 ? void 0 : _data23.file)
      } : data);
    }
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, watchPlanOn && /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading",
    style: {
      background: "#f2f2f2",
      textAlign: "end",
      fontSize: "20px",
      color: "green"
    }
  }, t(`${riskType === "Others" ? "High Risk and High Nivesh" : riskType}`))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Form"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID.",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchlandUseType
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: schemeType && watchSubZoneType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchPrimaryUse
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchAtivityProposed
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(planOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "plotLeaseHold",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "selectInput",
    mandatory: schemeType,
    validation: {
      required: {
        value: schemeType,
        message: "This field is required"
      }
    },
    disabled: !schemeType
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed Site"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction No."),
    control: control,
    placeholder: t("Enter layout sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Layout Sanction Date"),
    control: control,
    placeholder: t("Enter Layout Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area Type"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "constructionType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.constructionType,
    type: "selectInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })) : /*#__PURE__*/React__default.createElement(Col, null), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: natureOfConstructionOptions,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isSelfCert
  })), watchnatureOfConstruction && watchnatureOfConstruction !== "New" && watchnatureOfConstruction !== "Compounding" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Prev File No"),
    control: control,
    placeholder: t("Enter File No"),
    name: "prevFileNo",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.prevFileNo,
    type: "textInput"
  })) : watchnatureOfConstruction === "Compounding" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("DM Circle Rate (In Rs. Per Square meter)"),
    control: control,
    placeholder: t("Enter DM Rate"),
    name: "dmCircleRate",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    containerStyles: {
      lineHeight: "11px"
    },
    customLabelStyles: {
      lineHeight: "11px"
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.dmCircleRate,
    type: "textInput"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript7 = fastPASData.descriptionOfLand) === null || _fastPASData$descript7 === void 0 ? void 0 : _fastPASData$descript7.schemeName
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Tehsil"),
    control: control,
    placeholder: t("Enter Tehsil"),
    name: "tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    type: "textInput",
    disabled: !!watchTehsil,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    },
    mandatory: !schemeType
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput",
    mandatory: !schemeType,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: watchLandMark,
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, schemeType && /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    mandatory: !schemeType,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput",
    validation: {
      required: {
        value: !schemeType,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Standard Type Design")}`,
    name: "proposalType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.proposalType) || designType,
    type: "radioButton",
    mandatory: true,
    data: yesOrNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), schemeType ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.plotNo) || (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript8 = fastPASData.descriptionOfLand) === null || _fastPASData$descript8 === void 0 ? void 0 : _fastPASData$descript8.plotNo),
    type: "textInput",
    disabled: (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript9 = fastPASData.descriptionOfLand) === null || _fastPASData$descript9 === void 0 ? void 0 : _fastPASData$descript9.plotNo) || (formData === null || formData === void 0 ? void 0 : formData.plotNo)
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction date of layout"),
    control: control,
    placeholder: t("Enter Sanction date Of layout"),
    name: "sanctionDate",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionDate,
    type: "datePicker"
  })), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction number of layout"),
    control: control,
    placeholder: t("Enter Sanction number Of layout"),
    name: "sanctionNumber",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sanctionNumber,
    type: "textInput"
  }))), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("No. Of Plots"),
    control: control,
    placeholder: t("Enter No. Of Plots"),
    name: "noOfPlots",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.noOfPlots,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), watchProposalType === "yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array.from({
    length: fullRows
  }).map((_, rowIndex) => /*#__PURE__*/React__default.createElement(Row$1, {
    key: rowIndex
  }, Array.from({
    length: 3
  }).map((_, colIndex) => {
    var _formData$plotNumbers2;
    const plotIndex = rowIndex * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      hasLabel: false,
      maxLength: 15,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers2 = formData.plotNumbers) === null || _formData$plotNumbers2 === void 0 ? void 0 : _formData$plotNumbers2[plotIndex]) || "",
      type: "textInput"
    }));
  }))), remainingPlots > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    key: fullRows
  }, Array.from({
    length: remainingPlots
  }).map((_, colIndex) => {
    var _formData$plotNumbers3;
    const plotIndex = fullRows * 3 + colIndex;
    return /*#__PURE__*/React__default.createElement(Col, {
      key: `plot-${plotIndex}`
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      control: control,
      placeholder: t("Enter Plot No"),
      name: `plotNumbers.${plotIndex}`,
      mandatory: true,
      maxLength: 15,
      hasLabel: false,
      defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$plotNumbers3 = formData.plotNumbers) === null || _formData$plotNumbers3 === void 0 ? void 0 : _formData$plotNumbers3[plotIndex]) || "",
      type: "textInput"
    }));
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: watchPlanOn === "Others" ? projectTypeOptions.filter(e => e.name !== "Building Permission-Low Risk") : projectTypeOptions,
    label: `${t("Project Type")}`,
    placeholder: "Select Project Type",
    name: "buildingClassification",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingClassification,
    type: watchPlanOn ? "textInput" : "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !!watchPlanOn
  })), /*#__PURE__*/React__default.createElement(Col, null, watchbuildingClassification === "Others" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherbuildingClass",
    mandatory: true,
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherbuildingClass,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Special Project type")}`,
    name: "isSpecialProject",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    type: "radioButton",
    data: yesOrNo,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", (watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: t("If Community Parking Provided"),
    placeholder: t("Select Community Parking"),
    name: "communityParking",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.communityParking,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Special Condition of Project"),
    control: control,
    placeholder: t("Select Condition of Project"),
    data: SortingAlphabatically(specialProjectOptions),
    name: "projectType",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.projectType,
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, watchProjectType === "Other" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Other Project"),
    control: control,
    placeholder: t("Enter  Name"),
    name: "otherProjectName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherProjectName,
    type: "textInput"
  })))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Ground Coverage"),
    placeholder: t("Enter Ground Coverage"),
    name: "groundCoverages",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.groundCoverages) || (formData === null || formData === void 0 ? void 0 : formData.groundCoverage),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("FAR"),
    placeholder: t("Enter FAR"),
    name: "fars",
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.fars) || (formData === null || formData === void 0 ? void 0 : formData.far),
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Building Height"),
    placeholder: t("Enter Building Height"),
    name: "buildingHeight",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Please specify if any other condition"),
    placeholder: t("Enter condition"),
    name: "anyotherCondition",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.anyotherCondition,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Front"),
    control: control,
    placeholder: t("Enter Front"),
    name: "previousSetbackFront",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackFront) || (formData === null || formData === void 0 ? void 0 : formData.setbackFronts),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Rear"),
    control: control,
    placeholder: t("Enter Rear"),
    name: "previousSetbackRear",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackRear) || (formData === null || formData === void 0 ? void 0 : formData.setbackRears),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (watchProjectType === "Building Design as per standard Drawing" || watchProjectType === "Standard condition as per Lease deed/freehold deed") && watchisSpecialProject === "yes" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-1"),
    control: control,
    placeholder: t("Enter Side Setback-1"),
    name: "previousSetbackSide1",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide1) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide1),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Side Setback-2"),
    control: control,
    placeholder: t("Enter Side Setback-2"),
    name: "previousSetbackSide2",
    mandatory: true,
    maxLength: 2,
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.previousSetbackSide2) || (formData === null || formData === void 0 ? void 0 : formData.setbackSide2),
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), fastPASData && (fastPASData === null || fastPASData === void 0 ? void 0 : (_fastPASData$descript10 = fastPASData.descriptionOfLand) === null || _fastPASData$descript10 === void 0 ? void 0 : _fastPASData$descript10.landArea) < 40000 && watchlandUseType !== "Residential" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: yesOrNo,
    label: `${t("Will You Pay Shelter Fee")}`,
    name: "shelterFee",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shelterFee,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, (watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || watchPlanOn === "Self Certification of residential Plot Area upto 100 SqM on approved layouts") && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is Your Plot sub-division"),
    control: control,
    name: "plotSubdivided",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotSubdivided,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Does existing building require any compounding ?"),
    control: control,
    name: "needCompounding",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.needCompounding,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, watchNeedComp === "no" && watchPlotSubdivided === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is your plot Lease hold ?"),
    control: control,
    name: "plotLeaseHold",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotLeaseHold,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), watchnatureOfConstruction === "Compounding" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Is building plan previously approved?"),
    control: control,
    name: "shortName",
    mandatory: true,
    data: yesOrNo,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.shortName,
    type: "radioButton",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchCompunding !== "no" && /*#__PURE__*/React__default.createElement(Col, null), watchCompunding === "no" && /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of compounding"),
    placeholder: t("Select Nature Of Compounding"),
    name: "isAncestralProperty",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty,
    data: SortingAlphabatically(natureOfCompounding),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Purchasable Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Basic FAR"),
    control: control,
    name: "basicFAR",
    mandatory: true,
    placeholder: t("Enter Basic FAR"),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.basicFAR,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Purchasable FAR"),
    control: control,
    name: "purchasableFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.purchasableFAR,
    type: "textInput",
    placeholder: t("Enter Purchasable FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Premium FAR"),
    control: control,
    name: "premiumFAR",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.premiumFAR,
    type: "textInput",
    placeholder: t("Enter Premium FAR"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer bg-white"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    style: {
      padding: "10px 15px"
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: "declaration",
      control: control,
      onChange: handleDeclarationChange,
      rules: {
        required: "You must agree to the terms and conditions"
      }
    }),
    label: /*#__PURE__*/React__default.createElement("span", null, "I hereby declare that all the layers and information provided in the drawing file are accurate to the best of my knowledge.", /*#__PURE__*/React__default.createElement("br", null), " The EDCR Scrutiny Engine will run based on this provided data only. Any other drawing-specific layers or information present in the file shall not be the responsibility of the EDCR Engine.")
  })))), !isSelfCert && /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Upload DXF File"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(DxfFileUploader, {
    control: control,
    name: "file",
    label: "Upload Building Plan Drawing",
    validationMsg: "(dxf only and Max file Size 300 MB)",
    isMandatory: true,
    required: true,
    tab: 3,
    setFile: setFile,
    maxFiles: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    },
    disabled: !declarationChecked || watchPlotSubdivided === "yes" || watchNeedComp === "yes"
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const getEDCRData$1 = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  if (id) {
    var _data$BPA, _edcrData$description, _edcrData$description2, _edcrData$description3, _edcrData$description4, _edcrData$landInfo, _edcrData$landInfo$ow, _edcrData$landInfo$ow2, _edcrData$landInfo2, _edcrData$landInfo2$o, _edcrData$landInfo2$o2, _edcrData$landInfo3, _edcrData$landInfo3$o, _edcrData$landInfo3$o2, _edcrData$documents, _edcrData$documents$f, _edcrData$additionalD;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData
    });
    const edcrData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    const applicationData = {
      applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      applicationId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationId,
      appliactionType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || "BUILDING_PLAN_SCRUTINY",
      applicationType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) || "BUILDING_PLAN_SCRUTINY",
      applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION",
      serviceType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || "NEW_CONSTRUCTION",
      transactionNumber: uuidv4(),
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      fastPASId: edcrData === null || edcrData === void 0 ? void 0 : edcrData.land_Id,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      city: edcrData === null || edcrData === void 0 ? void 0 : edcrData.city,
      locality: edcrData === null || edcrData === void 0 ? void 0 : edcrData.locality,
      village: edcrData === null || edcrData === void 0 ? void 0 : edcrData.village,
      doorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.doorNo,
      code: edcrData === null || edcrData === void 0 ? void 0 : edcrData.code,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      plotArea: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description = edcrData.descriptionOfLand) === null || _edcrData$description === void 0 ? void 0 : _edcrData$description.landArea,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      otherSchemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherSchemeName,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      areaType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.areaType,
      developmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.developmentArea,
      subDevelopmentArea: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subDevelopmentArea,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      fars: edcrData === null || edcrData === void 0 ? void 0 : edcrData.far,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      groundCoverages: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverage,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackFronts,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackRears,
      backSide: edcrData === null || edcrData === void 0 ? void 0 : edcrData.backSide,
      isPlotSetback: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isPlotSetback,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      otherProjectName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherProjectName,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      previousSetbackFront: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      previousSetbackRear: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      previousSetbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide1,
      previousSetbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.setbackSide2,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      landUseNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNo,
      purchasableFAR: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$description2 = edcrData.descriptionOfLand) === null || _edcrData$description2 === void 0 ? void 0 : (_edcrData$description3 = _edcrData$description2.properties) === null || _edcrData$description3 === void 0 ? void 0 : (_edcrData$description4 = _edcrData$description3[0]) === null || _edcrData$description4 === void 0 ? void 0 : _edcrData$description4.requiredAreaFAR) || 0,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      leaseholdNOC: edcrData === null || edcrData === void 0 ? void 0 : edcrData.leaseholdNOC,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      shelterFee: edcrData === null || edcrData === void 0 ? void 0 : edcrData.shelterFee,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      applicantName: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo = edcrData.landInfo) === null || _edcrData$landInfo === void 0 ? void 0 : (_edcrData$landInfo$ow = _edcrData$landInfo.owners) === null || _edcrData$landInfo$ow === void 0 ? void 0 : (_edcrData$landInfo$ow2 = _edcrData$landInfo$ow[0]) === null || _edcrData$landInfo$ow2 === void 0 ? void 0 : _edcrData$landInfo$ow2.name,
      aplicantMobileNumber: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo2 = edcrData.landInfo) === null || _edcrData$landInfo2 === void 0 ? void 0 : (_edcrData$landInfo2$o = _edcrData$landInfo2.owners) === null || _edcrData$landInfo2$o === void 0 ? void 0 : (_edcrData$landInfo2$o2 = _edcrData$landInfo2$o[0]) === null || _edcrData$landInfo2$o2 === void 0 ? void 0 : _edcrData$landInfo2$o2.mobileNumber,
      applicantEmailId: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$landInfo3 = edcrData.landInfo) === null || _edcrData$landInfo3 === void 0 ? void 0 : (_edcrData$landInfo3$o = _edcrData$landInfo3.owners) === null || _edcrData$landInfo3$o === void 0 ? void 0 : (_edcrData$landInfo3$o2 = _edcrData$landInfo3$o[0]) === null || _edcrData$landInfo3$o2 === void 0 ? void 0 : _edcrData$landInfo3$o2.emailId,
      licenseeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeName,
      licenseeLicenceNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeLicenceNumber) || "",
      licenseeMobileNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeMobileNumber) || "",
      licenseeEmailId: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeEmailId) || "",
      licenseeAddress: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.licenseeAddress) || "",
      file: edcrData === null || edcrData === void 0 ? void 0 : edcrData.file,
      signatureId: (edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : (_edcrData$documents$f = _edcrData$documents.filter(doc => doc.documentType === "signature")[0]) === null || _edcrData$documents$f === void 0 ? void 0 : _edcrData$documents$f.fileStoreId) || null,
      selectedOffice: edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$additionalD = edcrData.additionalDetails) === null || _edcrData$additionalD === void 0 ? void 0 : _edcrData$additionalD.selectedOffice,
      department: applicationFlow || null
    };
    return {
      applicationData,
      isAppDataLoading
    };
  } else {
    const applicationData = {
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      serviceType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: applicationFlow || null
    };
    return {
      applicationData,
      isAppDataLoading: false
    };
  }
};

const FarEDCRPortal = () => {
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [disable, setDisable] = useState(false);
  const [proposedSite, setProposedSite] = useState(null);
  const {
    applicationData: edcrData,
    isAppDataLoading: edcrAppDataLoading
  } = getEDCRData$1(id);
  const {
    applicationData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const isSelfCert = proposedSite === 'Self Certification of residential Plot Area upto 300 SqM on approved layoutsSelf Certification of residential Plot Area upto 300 SqM on approved layouts' || proposedSite === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const [edcrParams, setEdcrParams, clearEdcrParams] = Digit.Hooks.useSessionStorage("EDCR_CREATE", edcrData);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
    if (!id && (Array.isArray(edcrParams) || !(edcrParams !== null && edcrParams !== void 0 && edcrParams.appliactionType))) {
      clearEdcrParams();
    }
  }, [id]);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData !== null && formData !== void 0 && formData.scrutinyFlow && formData.scrutinyFlow !== "EDCR" && !(formData !== null && formData !== void 0 && formData.file)) {
      handleTabChange(nextSubTab, formData);
      return;
    }
    setDisable(true);
    const file = formData === null || formData === void 0 ? void 0 : formData.file;
    if (formData) {
      var _userInfo$roles, _data$natureOfConstru, _data$natureOfConstru2, _userRolesArray$, _edcrRequest, _edcrRequest$mapSubDe, _edcrRequest2, _edcrRequest2$additio, _edcrRequest3, _edcrRequest3$mapSubD, _edcrRequest4, _edcrRequest4$additio;
      const safeEdcrParams = Array.isArray(edcrParams) ? {} : {
        ...edcrParams
      };
      if (!(formData !== null && formData !== void 0 && formData.isRevised) && !(formData !== null && formData !== void 0 && formData.applicationScrutinyType)) {
        delete safeEdcrParams.edcrNumber;
        delete safeEdcrParams.transactionNumber;
      }
      const data = {
        ...safeEdcrParams,
        ...formData
      };
      const userRolesArray = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(user => user.code !== "CITIZEN")) || [];
      const edcrAppType = "BUILDING_PLAN_SCRUTINY";
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow || (safeEdcrParams === null || safeEdcrParams === void 0 ? void 0 : safeEdcrParams.department) || (formData === null || formData === void 0 ? void 0 : formData.department);
      const resolvedBusinessService = resolvedDept === "DA" || (data === null || data === void 0 ? void 0 : data.businessService) === "BPA_MAPSUB_DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      const subType = data !== null && data !== void 0 && data.serviceType && data.serviceType !== "yes" && data.serviceType !== "no" ? data.serviceType : (data === null || data === void 0 ? void 0 : data.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || (edcrData === null || edcrData === void 0 ? void 0 : edcrData.serviceType) || "NEW_CONSTRUCTION";
      const natureOfConstruction = typeof (data === null || data === void 0 ? void 0 : data.natureOfConstruction) === "object" ? (data === null || data === void 0 ? void 0 : (_data$natureOfConstru = data.natureOfConstruction) === null || _data$natureOfConstru === void 0 ? void 0 : _data$natureOfConstru.value) || (data === null || data === void 0 ? void 0 : (_data$natureOfConstru2 = data.natureOfConstruction) === null || _data$natureOfConstru2 === void 0 ? void 0 : _data$natureOfConstru2.name) : data === null || data === void 0 ? void 0 : data.natureOfConstruction;
      let edcrRequest = {
        transactionNumber: (formData === null || formData === void 0 ? void 0 : formData.transactionNumber) || (typeof uuidv4 === "function" ? uuidv4() : ""),
        edcrNumber: (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) || "",
        rolesCode: (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) || null,
        planFile: null,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        RequestInfo: {
          apiId: "",
          ver: "",
          ts: "",
          action: "",
          did: "",
          authToken: "",
          key: "",
          msgId: "",
          correlationId: "",
          userInfo: userInfo
        }
      };
      edcrRequest = {
        ...edcrRequest,
        ...data,
        tenantId: tenantId || (data === null || data === void 0 ? void 0 : data.tenantId) || "up",
        department: resolvedDept || (data === null || data === void 0 ? void 0 : data.department) || applicationFlow,
        businessService: resolvedBusinessService,
        appliactionType: edcrAppType,
        applicationType: edcrAppType,
        applicationSubType: subType,
        serviceType: subType,
        ...(natureOfConstruction ? {
          natureOfConstruction
        } : {})
      };
      if (!edcrRequest.transactionNumber) {
        edcrRequest.transactionNumber = typeof uuidv4 === "function" ? uuidv4() : "";
      }
      edcrRequest.tod = "";
      if ((_edcrRequest = edcrRequest) !== null && _edcrRequest !== void 0 && (_edcrRequest$mapSubDe = _edcrRequest.mapSubDetails) !== null && _edcrRequest$mapSubDe !== void 0 && _edcrRequest$mapSubDe.tod) {
        edcrRequest.mapSubDetails.tod = "";
      }
      if ((_edcrRequest2 = edcrRequest) !== null && _edcrRequest2 !== void 0 && (_edcrRequest2$additio = _edcrRequest2.additionalDetails) !== null && _edcrRequest2$additio !== void 0 && _edcrRequest2$additio.tod) {
        edcrRequest.additionalDetails.tod = "";
      }
      delete edcrRequest.landUseApprovalLetter;
      if ((_edcrRequest3 = edcrRequest) !== null && _edcrRequest3 !== void 0 && (_edcrRequest3$mapSubD = _edcrRequest3.mapSubDetails) !== null && _edcrRequest3$mapSubD !== void 0 && _edcrRequest3$mapSubD.landUseApprovalLetter) {
        delete edcrRequest.mapSubDetails.landUseApprovalLetter;
      }
      if ((_edcrRequest4 = edcrRequest) !== null && _edcrRequest4 !== void 0 && (_edcrRequest4$additio = _edcrRequest4.additionalDetails) !== null && _edcrRequest4$additio !== void 0 && _edcrRequest4$additio.landUseApprovalLetter) {
        delete edcrRequest.additionalDetails.landUseApprovalLetter;
      }
      let bodyFormData = new FormData();
      bodyFormData.append("planFile", file);
      bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
      if (activeTab === 0 && selectedSubTab === 0 && bodyFormData && file) {
        Digit.EDCRService.create({
          data: bodyFormData
        }, tenantId).then(result => {
          var _result$data;
          if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.edcrDetail) {
            var _result$data2, _result$data3;
            setDisable(false);
            setEdcrParams(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.edcrDetail);
            history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
              data: result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.edcrDetail
            });
          }
        }).catch(e => {
          var _e$response, _e$response2, _e$response2$data, _e$response2$data$, _e$response3, _e$response3$data, _e$response3$data$, _e$response4, _e$response4$data, _e$response5, _e$response5$data;
          setDisable(false);
          const errMsg = Array.isArray(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data) && ((e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$ = _e$response2$data[0]) === null || _e$response2$data$ === void 0 ? void 0 : _e$response2$data$.errorMessage) || (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$ = _e$response3$data[0]) === null || _e$response3$data$ === void 0 ? void 0 : _e$response3$data$.errorCode)) || (e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.message) || (e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.errorCode) || "Something went wrong!!";
          Modal("EDCR Error", errMsg, "error");
        });
      } else {
        setDisable(false);
      }
    } else {
      setDisable(false);
    }
  };
  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      var _data$mapSubDetails, _formData$mapSubDetai, _params$mapSubDetails;
      const data = {
        ...params,
        ...formData
      };
      const resolvedDept = (data === null || data === void 0 ? void 0 : data.department) || applicationFlow;
      data.department = resolvedDept;
      data.businessService = resolvedDept === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
      if (!data.applicationType || data.applicationType === "BUILDING_PLAN_SCRUTINY") {
        data.applicationType = formData !== null && formData !== void 0 && formData.isCompounding || data !== null && data !== void 0 && data.isCompounding ? "FORM_COMPOUNDING" : "FORM_MAP";
      }
      const resolvedLandUseLetter = (data === null || data === void 0 ? void 0 : data.landUseApprovalLetter) || (data === null || data === void 0 ? void 0 : (_data$mapSubDetails = data.mapSubDetails) === null || _data$mapSubDetails === void 0 ? void 0 : _data$mapSubDetails.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : formData.landUseApprovalLetter) || (formData === null || formData === void 0 ? void 0 : (_formData$mapSubDetai = formData.mapSubDetails) === null || _formData$mapSubDetai === void 0 ? void 0 : _formData$mapSubDetai.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : params.landUseApprovalLetter) || (params === null || params === void 0 ? void 0 : (_params$mapSubDetails = params.mapSubDetails) === null || _params$mapSubDetails === void 0 ? void 0 : _params$mapSubDetails.landUseApprovalLetter);
      if (resolvedLandUseLetter) {
        data.landUseApprovalLetter = resolvedLandUseLetter;
        data.approvalLetterUrl = resolvedLandUseLetter;
        data.mapSubDetails = {
          ...(data.mapSubDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
        data.additionalDetails = {
          ...(data.additionalDetails || {}),
          landUseApprovalLetter: resolvedLandUseLetter
        };
      }
      Digit.OBPSService.create({
        BPA: data
      }, tenantId).then(res => {
        var _res$BPA;
        if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
          var _res$BPA2;
          Modal("Application Created", `Application Created Successfully!`, "success");
          history.replace(`/digit-ui/citizen/obps/services/mapSubmissionPortal`, {
            data: res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0]
          });
        }
      }).catch(e => {
        var _e$response6, _e$response6$data, _e$response6$data$Err;
        Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response6 = e.response) === null || _e$response6 === void 0 ? void 0 : (_e$response6$data = _e$response6.data) === null || _e$response6$data === void 0 ? void 0 : (_e$response6$data$Err = _e$response6$data.Errors[0]) === null || _e$response6$data$Err === void 0 ? void 0 : _e$response6$data$Err.message}`, 'error');
      });
    }
  };
  useEffect(() => {
    if (id && applicationData) {
      var _applicationData$docu;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  useEffect(() => {
    if (id && edcrData) {
      var _edcrData$documents;
      setEdcrParams(edcrData);
      if ((edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$documents = edcrData.documents) === null || _edcrData$documents === void 0 ? void 0 : _edcrData$documents.length) > 0) {
        initFormMTDocs(edcrData.documents);
      }
    }
  }, [id, edcrAppDataLoading]);
  const renderContent = () => {
    var _Digit, _Digit$SessionStorage;
    const scrutinyFlow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.get("LTP.SCRUTINY.SELECTION");
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$f, {
            formData: isSelfCert || scrutinyFlow !== "EDCR" ? params : edcrParams,
            handleSubTabChange: handleSubTabChange,
            userInfo: userInfo,
            handleTabChange: handleTabChange,
            setProposedSite: setProposedSite,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id
          });
        default:
          return null;
      }
    }
  };
  if (isAppDataLoading || edcrAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (disable) {
    return /*#__PURE__*/React__default.createElement(ScrutinyUnderProcess, null);
  }
  if (id && !edcrData && edcrData !== null && edcrData !== void 0 && edcrData.proposalType) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: "Purchasable FAR  Application Form"
  }), activeTab === 0 && renderContent());
};

const PFARApplications = () => {
  var _Digit$UserService$ge;
  console.log("pfarapplicationsInsidethis");
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedAction, setSelectedAction] = useState("All");
  const [migratedData, setMigratedData] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [page, setPage] = React__default.useState(0);
  const [globalSearch, setGlobalSearch] = useState("");
  const applicationType = "FORM_PURCHASABLE_FAR";
  const formType = "PURCHASABLE_FAR";
  const mobileNumber = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber;
  const {
    data,
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType,
    pageNumber: page + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType
  });
  console.log("DATA GOR", data);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterUrl).filter(key => key.startsWith("objection_")).sort().at(-1);
    const rejectionLetterUrl = item === null || item === void 0 ? void 0 : item.farRejectLetterUrl;
    window.open(rejectionLetterUrl, "_blank");
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleActionChange = action => {
    setSelectedAction(action);
    setPage(0);
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  React__default.useEffect(() => {
    refetch();
  }, [page, rowsPerPage, refetch, selectedAction]);
  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearch({
        mobileNumber
      });
      setMigratedData(response === null || response === void 0 ? void 0 : response.ApplicationList);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchMigratedData();
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  function getApprovalLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.farApprovalLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  function getShortfallLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.farShortfallUrl;
    window.open(pdfUrl, "_blank");
  }
  const handleClickAction = item => {
    var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$landInfo2$owner3, _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : (_item$landInfo2$owner3 = _item$landInfo2$owner2.name) === null || _item$landInfo2$owner3 === void 0 ? void 0 : _item$landInfo2$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.BPA) || (data === null || data === void 0 ? void 0 : data.PurchasableFAR) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.name) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$landInfo7$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : (_item$landInfo7$owner3 = _item$landInfo7$owner2.mobileNumber) === null || _item$landInfo7$owner3 === void 0 ? void 0 : _item$landInfo7$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    render: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    render: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", null, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    render: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", null, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/edcrPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$taxHeadEstimate;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate = item.taxHeadEstimates) === null || _item$taxHeadEstimate === void 0 ? void 0 : _item$taxHeadEstimate[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
          history.push({
            pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")));
    }
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "proposalLetter",
    label: "Proposal Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.proposalUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.proposalUrl, "_blank")
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.status) === "APPROVED" && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "shortfallLetter",
    label: "Shortfall Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : item.status) === "REVERT_TO_APPLICANT" && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getShortfallLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "nocLetter",
    label: "NOC Request Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$nocLetterInfo, _item$nocLetterInfo$;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$nocLetterInfo = item.nocLetterInfo) === null || _item$nocLetterInfo === void 0 ? void 0 : (_item$nocLetterInfo$ = _item$nocLetterInfo[0]) === null || _item$nocLetterInfo$ === void 0 ? void 0 : _item$nocLetterInfo$.fileStoreUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          var _item$nocLetterInfo2, _item$nocLetterInfo2$;
          return window.open(item === null || item === void 0 ? void 0 : (_item$nocLetterInfo2 = item.nocLetterInfo) === null || _item$nocLetterInfo2 === void 0 ? void 0 : (_item$nocLetterInfo2$ = _item$nocLetterInfo2[0]) === null || _item$nocLetterInfo2$ === void 0 ? void 0 : _item$nocLetterInfo2$.fileStoreUrl, "_blank");
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "nocApprovalLetter",
    label: "NOC Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => {
      var _item$nocList, _item$nocList$;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$nocList = item.nocList) === null || _item$nocList === void 0 ? void 0 : (_item$nocList$ = _item$nocList[0]) === null || _item$nocList$ === void 0 ? void 0 : _item$nocList$.nocApprovedLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          var _item$nocList2, _item$nocList2$;
          return window.open(item === null || item === void 0 ? void 0 : (_item$nocList2 = item.nocList) === null || _item$nocList2 === void 0 ? void 0 : (_item$nocList2$ = _item$nocList2[0]) === null || _item$nocList2$ === void 0 ? void 0 : _item$nocList2$.nocApprovedLetterUrl, "_blank");
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        if (item.planOn === "SELF_MAP") {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/selfResidentialPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        } else {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/purchasablePortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => {
        var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: tabIndex,
    onChange: handleTabChange,
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "New Applications"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Archive Old Applications"
  }))), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 0,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Purchasable FAR Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    className: "bg-white",
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.render(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 1,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container archieve-old-table"
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "5%"
    }
  }, "Sr No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Owner Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Owner Mobile Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Application Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "View Summary"))), /*#__PURE__*/React__default.createElement("tbody", null, migratedData === null || migratedData === void 0 ? void 0 : migratedData.map((item, index) => {
    var _item$applicationdeta, _item$applicationdeta2, _item$applicationdeta3, _item$landInfo11, _item$landInfo11$owne, _item$landInfo11$owne2, _item$applicationdeta4, _item$applicationdeta5, _item$applicationdeta6, _item$landInfo12, _item$landInfo12$owne, _item$landInfo12$owne2;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: (item === null || item === void 0 ? void 0 : item.applicationNo) || (item === null || item === void 0 ? void 0 : item.applicationnumber) || index
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$applicationdeta = item.applicationdetails) === null || _item$applicationdeta === void 0 ? void 0 : (_item$applicationdeta2 = _item$applicationdeta.data) === null || _item$applicationdeta2 === void 0 ? void 0 : (_item$applicationdeta3 = _item$applicationdeta2.ownerDetail) === null || _item$applicationdeta3 === void 0 ? void 0 : _item$applicationdeta3.ownerName) || (item === null || item === void 0 ? void 0 : (_item$landInfo11 = item.landInfo) === null || _item$landInfo11 === void 0 ? void 0 : (_item$landInfo11$owne = _item$landInfo11.owners) === null || _item$landInfo11$owne === void 0 ? void 0 : (_item$landInfo11$owne2 = _item$landInfo11$owne[0]) === null || _item$landInfo11$owne2 === void 0 ? void 0 : _item$landInfo11$owne2.name)), /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$applicationdeta4 = item.applicationdetails) === null || _item$applicationdeta4 === void 0 ? void 0 : (_item$applicationdeta5 = _item$applicationdeta4.data) === null || _item$applicationdeta5 === void 0 ? void 0 : (_item$applicationdeta6 = _item$applicationdeta5.ownerDetail) === null || _item$applicationdeta6 === void 0 ? void 0 : _item$applicationdeta6.ownerContactNo) || (item === null || item === void 0 ? void 0 : (_item$landInfo12 = item.landInfo) === null || _item$landInfo12 === void 0 ? void 0 : (_item$landInfo12$owne = _item$landInfo12.owners) === null || _item$landInfo12$owne === void 0 ? void 0 : (_item$landInfo12$owne2 = _item$landInfo12$owne[0]) === null || _item$landInfo12$owne2 === void 0 ? void 0 : _item$landInfo12$owne2.mobileNumber)), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textDecoration: "underline blue 1px",
        cursor: "pointer",
        border: "1px solid #ddd",
        padding: "8px"
      },
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${(item === null || item === void 0 ? void 0 : item.applicationnumber) || (item === null || item === void 0 ? void 0 : item.applicationNo)}`
        });
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationnumber) || (item === null || item === void 0 ? void 0 : item.applicationNo)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => {
        const id = (item === null || item === void 0 ? void 0 : item.applicationnumber) || (item === null || item === void 0 ? void 0 : item.applicationNo);
        if (id) {
          setIdData(id);
          setshowMs(true);
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (migratedData === null || migratedData === void 0 ? void 0 : migratedData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), showMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showMs,
    onClose: () => {
      setshowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(MigratedSummary, {
    id: idData
  })), smShowMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  })));
};

const SubStep4$a = ({
  formData,
  handleSubTabChange,
  isEmployee,
  iframeSrc,
  setIframeSrc
}) => {
  var _formData$documents, _formData$description, _formData$description2, _formData$description3, _formData$description4;
  console.log("iframeSRC", iframeSrc);
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand)
    }
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    handleSubTabChange(4, data);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const kmlFile = formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.find(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === "kmlFile");
  console.log("kmlfile", kmlFile, formData);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "GEO Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form self-certified custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.latitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.latitude
  }), !isEmployee && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, kmlFile && /*#__PURE__*/React__default.createElement("div", {
    className: "download-kml",
    style: {
      display: "flex",
      alignItems: "center",
      gap: "280px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "KML File:"), /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "large",
    color: "info",
    onClick: () => getDocumentByFileStoreId(kmlFile === null || kmlFile === void 0 ? void 0 : kmlFile.fileStoreId, setLoading)
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "14px",
      height: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(TravelExploreOutlinedIcon, {
    color: "primary",
    sx: {
      fontSize: "14px"
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.longitude,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    maxLength: 10,
    disabled: formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.longitude
  })), /*#__PURE__*/React__default.createElement("br", null))), !isEmployee && /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const Step2$b = ({
  formData,
  handleTabChange,
  tenantId
}) => {
  var _formData$description, _migratedData$sanctio, _migratedData$sanctio2, _migratedData$sanctio3, _migratedData$sanctio4;
  const dispatch = useDispatch();
  const {
    initFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData
  };
  const isScheme = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const isSelfCert = (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" || (formData === null || formData === void 0 ? void 0 : formData.planOn) === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const {
    handleSubmit,
    control,
    setValue,
    trigger
  } = useForm({
    defaultValues
  });
  async function fetchLTPData() {
    var _userInfo$info;
    const createdBy = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
    try {
      var _response$Licenses, _ltpData$, _ltpData$$tradeLicens, _ltpData$$tradeLicens2;
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, {
        createdBy: createdBy
      });
      const ltpData = (response === null || response === void 0 ? void 0 : (_response$Licenses = response.Licenses) === null || _response$Licenses === void 0 ? void 0 : _response$Licenses.filter(e => (e === null || e === void 0 ? void 0 : e.status) === "APPROVED")) || [];
      const regCert = (ltpData === null || ltpData === void 0 ? void 0 : (_ltpData$ = ltpData[0]) === null || _ltpData$ === void 0 ? void 0 : (_ltpData$$tradeLicens = _ltpData$.tradeLicenseDetail) === null || _ltpData$$tradeLicens === void 0 ? void 0 : (_ltpData$$tradeLicens2 = _ltpData$$tradeLicens.applicationDocuments) === null || _ltpData$$tradeLicens2 === void 0 ? void 0 : _ltpData$$tradeLicens2.filter(e => (e === null || e === void 0 ? void 0 : e.documentType) === "Registration Certificate")) || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
  const migratedPlan = migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$sanctio = migratedData.sanctionFiles) === null || _migratedData$sanctio === void 0 ? void 0 : (_migratedData$sanctio2 = _migratedData$sanctio.find(item => item.fileType === "Plan")) === null || _migratedData$sanctio2 === void 0 ? void 0 : _migratedData$sanctio2.fileStoreURL;
  const migratedSanctionLetter = migratedData === null || migratedData === void 0 ? void 0 : (_migratedData$sanctio3 = migratedData.sanctionFiles) === null || _migratedData$sanctio3 === void 0 ? void 0 : (_migratedData$sanctio4 = _migratedData$sanctio3.find(item => item.fileType === "Certificate")) === null || _migratedData$sanctio4 === void 0 ? void 0 : _migratedData$sanctio4.fileStoreURL;
  useEffect(() => {
    fetchLTPData();
  }, []);
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    data = {
      ...data,
      nocDetails: formData === null || formData === void 0 ? void 0 : formData.nocDetails
    };
    handleTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrNumber) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      padding: "2rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      padding: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing Pdf", " "), ":"), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => window.open(formData === null || formData === void 0 ? void 0 : formData.updatedDxfFile, "_blank")
  })))))))), /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Mandatory Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Architect/Engineer Registration Certificate"),
    control: control,
    name: "Registration Certificate",
    validationMsg: "Upload File",
    required: true,
    isMandatory: true,
    trigger: trigger
  })), !isLowRiskCase && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Calculation sheet of Estimate with Affidavit"),
    control: control,
    name: "calculationSheet",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Khatauni"),
    control: control,
    name: "khatauni",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Owner Affidavit"),
    control: control,
    name: "ownerAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Drawing Pdf"),
    control: control,
    name: "drawingPdf",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    control: control,
    label: t("Allotment Letter/Possession Letter"),
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement"),
    control: control,
    name: "registrySaleDeedHPTA",
    isMandatory: true,
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), isSelfCert && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("LTP Affidavit"),
    control: control,
    name: "ltpAffidavit",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isScheme && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Developer/Consortium/Sales Agreement"),
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), !isDA && /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File",
    required: true,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    isMandatory: true,
    label: t("Site Photo"),
    control: control,
    name: "sitePhoto",
    validationMsg: "Upload File",
    required: true,
    maxFiles: 4,
    tab: 2,
    trigger: trigger
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*"))))))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Conditional Documents")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer common-app-form Upload-Input2 d-block only-white-bg"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Audit Report"),
    control: control,
    name: "structuralAuditReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Additional Document if any"),
    control: control,
    name: "additionalDoc",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Drawing and Design "),
    control: control,
    name: "structuraldrawing",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Stability Certificate"),
    control: control,
    name: "structuralcertificate",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Structural Design calculation Report"),
    control: control,
    name: "calculationReport",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    control: control,
    label: t("Vetted Structure and drawing along with certificate"),
    name: "vettedStructure",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer."),
    control: control,
    name: "annexture789",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, isDA && /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Upto date payment letter"),
    control: control,
    name: "uptodatePaymentLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "inner-mini-wrapper"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(FileUploader$2, {
    label: t("Approved Layout sanctioned Letter"),
    control: control,
    name: "sanctionLetter",
    validationMsg: "Upload File"
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (jpg, jpeg, png file only and Max file Size 10 MB)*"))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC"
    },
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))));
};

const PurchasableFARV3 = () => {
  var _Digit, _Digit2, _Digit3, _userInfo$info, _applicationData$audi;
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const [iframeSrc, setIframeSrc] = useState("");
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const [selectedSubTab, setSelectedSubTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("SA_CURRENT_SUBTAB")) || 0);
  const [activeTab, setActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("SA_CURRENT_TAB")) || 0);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [summaryShow, setSummaryshow] = useState(((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("SUMMARYSA_TAB")) || false);
  const history = useHistory();
  const {
    applicationData,
    isAppDataLoading
  } = getMapSubmissionData$1(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const userType = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.type;
  const lastApplicationNo = useRef(null);
  const isEmployee = userType === "EMPLOYEE";
  const Modal = useModal();
  const componentRef = useRef();
  const subTabLabels = [{
    label: "Application Information"
  }, {
    label: "Plot Details"
  }, {
    label: "Applicant Information"
  }, {
    label: "Geo Location"
  }, {
    label: "NOC Status"
  }];
  const closeToast = () => {
    setShowToast(null);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PURCHASABLE_FAR", applicationData || {});
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      console.log(data, "updatedDatahere");
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      data.applicationType = "FORM_PURCHASABLE_FAR";
      data.planOn = "PURCHASABLE_MAP";
      if (data !== null && data !== void 0 && data.additionalDetails) {
        delete data.additionalDetails;
      }
      if (formData !== null && formData !== void 0 && formData.Purchasable || data !== null && data !== void 0 && data.Purchasable || params !== null && params !== void 0 && params.Purchasable) {
        var _formData$Purchasable, _data$Purchasable, _params$Purchasable, _formData$Purchasable2, _data$Purchasable2, _params$Purchasable2;
        data.Purchasable = {
          PermittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable = formData.Purchasable) === null || _formData$Purchasable === void 0 ? void 0 : _formData$Purchasable.PermittedFactor) || (data === null || data === void 0 ? void 0 : (_data$Purchasable = data.Purchasable) === null || _data$Purchasable === void 0 ? void 0 : _data$Purchasable.PermittedFactor) || (params === null || params === void 0 ? void 0 : (_params$Purchasable = params.Purchasable) === null || _params$Purchasable === void 0 ? void 0 : _params$Purchasable.PermittedFactor) || "",
          Cost: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable2 = formData.Purchasable) === null || _formData$Purchasable2 === void 0 ? void 0 : _formData$Purchasable2.Cost) || (data === null || data === void 0 ? void 0 : (_data$Purchasable2 = data.Purchasable) === null || _data$Purchasable2 === void 0 ? void 0 : _data$Purchasable2.Cost) || (params === null || params === void 0 ? void 0 : (_params$Purchasable2 = params.Purchasable) === null || _params$Purchasable2 === void 0 ? void 0 : _params$Purchasable2.Cost) || ""
        };
      }
      if (activeTab === 0 && selectedSubTab === 0 && !id) {
        delete data.applicationNo;
        if (!data.workflow) {
          data.workflow = {};
        }
        data.workflow.action = "INITIATE";
        Digit.OBPSService.create({
          BPA: data
        }, tenantId).then(res => {
          var _res$BPA;
          if ((res === null || res === void 0 ? void 0 : (_res$BPA = res.BPA) === null || _res$BPA === void 0 ? void 0 : _res$BPA.length) > 0) {
            var _res$BPA$;
            const updatedData = {
              ...data,
              ...res.BPA[0]
            };
            if (data !== null && data !== void 0 && data.Purchasable && !((_res$BPA$ = res.BPA[0]) !== null && _res$BPA$ !== void 0 && _res$BPA$.Purchasable)) {
              updatedData.Purchasable = data.Purchasable;
            }
            onSelect("", updatedData, true);
            setShowToast({
              error: false,
              message: `Application Created Successfully!`
            });
            setSelectedSubTab(nextSubTab);
            Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        try {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            BPA: data
          }, {
            onSuccess: res => {
              var _res$BPA2, _res$BPA3, _res$BPA3$;
              const updatedBPA = {
                ...data,
                ...(res === null || res === void 0 ? void 0 : (_res$BPA2 = res.BPA) === null || _res$BPA2 === void 0 ? void 0 : _res$BPA2[0])
              };
              if (data !== null && data !== void 0 && data.Purchasable && !(res !== null && res !== void 0 && (_res$BPA3 = res.BPA) !== null && _res$BPA3 !== void 0 && (_res$BPA3$ = _res$BPA3[0]) !== null && _res$BPA3$ !== void 0 && _res$BPA3$.Purchasable)) {
                updatedBPA.Purchasable = data.Purchasable;
              }
              onSelect("", updatedBPA);
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            }
          });
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("SA_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const handleDeclarationChange = event => {
    setDeclarationChecked(event.target.checked);
  };
  const {
    data: {
      BPA: {
        StandardBuildingDesigns: standardDesigns
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["StandardBuildingDesigns"]);
  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (formData !== null && formData !== void 0 && formData.Purchasable || data !== null && data !== void 0 && data.Purchasable || params !== null && params !== void 0 && params.Purchasable) {
        var _formData$Purchasable3, _data$Purchasable3, _params$Purchasable3, _formData$Purchasable4, _data$Purchasable4, _params$Purchasable4;
        data.Purchasable = {
          PermittedFactor: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable3 = formData.Purchasable) === null || _formData$Purchasable3 === void 0 ? void 0 : _formData$Purchasable3.PermittedFactor) || (data === null || data === void 0 ? void 0 : (_data$Purchasable3 = data.Purchasable) === null || _data$Purchasable3 === void 0 ? void 0 : _data$Purchasable3.PermittedFactor) || (params === null || params === void 0 ? void 0 : (_params$Purchasable3 = params.Purchasable) === null || _params$Purchasable3 === void 0 ? void 0 : _params$Purchasable3.PermittedFactor) || "",
          Cost: (formData === null || formData === void 0 ? void 0 : (_formData$Purchasable4 = formData.Purchasable) === null || _formData$Purchasable4 === void 0 ? void 0 : _formData$Purchasable4.Cost) || (data === null || data === void 0 ? void 0 : (_data$Purchasable4 = data.Purchasable) === null || _data$Purchasable4 === void 0 ? void 0 : _data$Purchasable4.Cost) || (params === null || params === void 0 ? void 0 : (_params$Purchasable4 = params.Purchasable) === null || _params$Purchasable4 === void 0 ? void 0 : _params$Purchasable4.Cost) || ""
        };
      }
      try {
        if (nextTabNo === 4) {
          data.workflow = {
            action: "FORWARD_TO_DEPARTMENT",
            assignes: null
          };
        } else {
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
        }
        updateApiCall.mutate({
          BPA: data
        }, {
          onSuccess: res => {
            var _res$BPA4, _res$BPA5, _res$BPA5$;
            const updatedBPA = {
              ...data,
              ...(res === null || res === void 0 ? void 0 : (_res$BPA4 = res.BPA) === null || _res$BPA4 === void 0 ? void 0 : _res$BPA4[0])
            };
            if (data !== null && data !== void 0 && data.Purchasable && !(res !== null && res !== void 0 && (_res$BPA5 = res.BPA) !== null && _res$BPA5 !== void 0 && (_res$BPA5$ = _res$BPA5[0]) !== null && _res$BPA5$ !== void 0 && _res$BPA5$.Purchasable)) {
              updatedBPA.Purchasable = data.Purchasable;
            }
            onSelect("", updatedBPA);
            if (nextTabNo === 4) {
              var _Digit4, _Digit5, _Digit6;
              Modal("Application Submited", `Your Application ${params === null || params === void 0 ? void 0 : params.applicationNo} has been sent to department for further approval`, "success");
              clearParams();
              Digit.SessionStorage.del("FORM_SELF_APPROVAL");
              (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("EDCR_CREATE");
              (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("FASTPAS_ID");
              (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("SUMMARYSA_TAB");
              setTimeout(() => {
                resetFormMTDocs();
              }, 0);
              Digit.SessionStorage.del("SA_CURRENT_TAB");
              Digit.SessionStorage.del("SA_CURRENT_SUBTAB");
            } else {
              if (nextTabNo === 3) {
                Digit.SessionStorage.set("SUMMARYSA_TAB", true);
                setSummaryshow(true);
              }
              setShowToast({
                error: false,
                message: `Data has been saved successfully`
              });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
            }
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          }
        });
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 3) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
  };
  const applicationDataSignature = applicationData ? `${applicationData.applicationNo}-${(_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.lastModifiedTime}-${applicationData.status}` : null;
  useEffect(() => {
    if (!id || !applicationData) return;
    if (lastApplicationNo.current !== applicationData.applicationNo) {
      var _applicationData$docu;
      lastApplicationNo.current = applicationData.applicationNo;
      setParams(applicationData);
      if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu = applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData, applicationDataSignature]);
  const renderContent = () => {
    var _params$nocList, _params$nocList2;
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$6, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            userInfo: userInfo,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            id: id,
            onSelect: onSelect,
            initFormMTDocs: initFormMTDocs,
            standardDesigns: standardDesigns
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep2$3, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep3$5, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep4$a, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee,
            iframeSrc: iframeSrc,
            setIframeSrc: setIframeSrc
          });
        case 4:
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, id && (isAppDataLoading || !(params !== null && params !== void 0 && params.applicationNo)) ? /*#__PURE__*/React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "Loading NOC data...")) : (params === null || params === void 0 ? void 0 : (_params$nocList = params.nocList) === null || _params$nocList === void 0 ? void 0 : _params$nocList.length) > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NOCTakeAction, {
            formData: params,
            onNocUpdate: updatedNocList => {
              setParams(prev => ({
                ...prev,
                nocList: updatedNocList,
                nocDetails: {
                  ...((prev === null || prev === void 0 ? void 0 : prev.nocDetails) || {}),
                  nocListApplicantDoc: updatedNocList
                }
              }));
            }
          }), (params === null || params === void 0 ? void 0 : (_params$nocList2 = params.nocList) === null || _params$nocList2 === void 0 ? void 0 : _params$nocList2.some(noc => {
            var _noc$documents;
            return noc === null || noc === void 0 ? void 0 : (_noc$documents = noc.documents) === null || _noc$documents === void 0 ? void 0 : _noc$documents.some(d => d === null || d === void 0 ? void 0 : d.fileStoreId);
          })) && /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              padding: "12px 4px"
            }
          }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
            onClick: () => handleSubTabChange(5),
            variant: "contained",
            color: "success",
            size: "medium",
            label: "Save",
            type: "submit",
            sx: {
              backgroundColor: "#157CB3"
            }
          }))) : isEmployee ? /*#__PURE__*/React__default.createElement(IdentifyNoc, {
            formData: params,
            tenantId: tenantId,
            handleTabChange: handleTabChange,
            handleSubTabChange: handleSubTabChange,
            isEmployee: isEmployee
          }) :
          /*#__PURE__*/
          React__default.createElement("div", {
            style: {
              textAlign: "center",
              padding: "40px"
            }
          }, /*#__PURE__*/React__default.createElement("span", null, "No NOC available for this user.")));
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$b, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee
      });
    } else if (activeTab === 2) {
      return /*#__PURE__*/React__default.createElement(Step4$2, {
        formData: params,
        handleTabChange: handleTabChange,
        tenantId: tenantId,
        isEmployee: isEmployee,
        nextTab: 3
      });
    } else if (activeTab === 3 && summaryShow && params !== null && params !== void 0 && params.applicationNo) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$1, {
        style: {
          width: "90%",
          margin: "0 auto"
        },
        ref: componentRef
      }, /*#__PURE__*/React__default.createElement(SearchSummary, {
        id: params === null || params === void 0 ? void 0 : params.applicationNo,
        ref: componentRef,
        handleDeclarationChange: handleDeclarationChange,
        declarationChecked: declarationChecked,
        showDeclaration: true
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT"))), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#7600bc"
          }
        }, "Print Summary"),
        content: () => componentRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => handleTabChange(0)
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Forward to Department",
        type: "submit",
        sx: {
          backgroundColor: "#157CB3",
          width: "180px"
        },
        onClick: () => handleTabChange(4, params),
        disabled: !declarationChecked
      }))));
    } else if (activeTab === 4) {
      return /*#__PURE__*/React__default.createElement(Step6, {
        formData: params,
        handleSubTabChange: handleTabChange
      });
    }
  };
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(FormStrip, {
    formName: t("Purchasable FAR")
  }), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, {
    className: "technical-profession-section"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => handleTabChange(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application Form"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Document"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Drawing"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Summary"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Application History"
  }))), /*#__PURE__*/React__default.createElement(StyledDivider, null), activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: selectedSubTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTab$1, {
    key: index,
    label: tab.label
  })))), renderContent(), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const WorkCommencementModule = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee: _isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id
}) => {
  var _Digit, _data$MapSubmission, _data$MapSubmission$D, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo8$o2, _formData$landInfo8$o3, _formData$description;
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromWorkCommencementModule");
  const {
    t
  } = useTranslation();
  const [file, setFile] = useState(null);
  const tenantId = Digit.ULBService.getStateId();
  const {
    documents
  } = useSelector(state => state.formMT);
  const history = useHistory();
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const defaultValues = {
    ...formData,
    fastPASId: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    proposalType: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    isSpecialProject: formData === null || formData === void 0 ? void 0 : formData.isSpecialProject,
    groundCoverages: formData === null || formData === void 0 ? void 0 : formData.groundCoverages,
    fars: formData === null || formData === void 0 ? void 0 : formData.fars,
    buildingHeight: formData === null || formData === void 0 ? void 0 : formData.buildingHeight,
    previousSetbackFront: formData === null || formData === void 0 ? void 0 : formData.setbackFronts,
    previousSetbackRear: formData === null || formData === void 0 ? void 0 : formData.setbackRears,
    natureOfConstructionOptions: formData === null || formData === void 0 ? void 0 : formData.natureOfConstructionOptions
  };
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  const [fastPASData, setFastPasData] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("EMP_MAPSUB")) || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const {
    data,
    isLoading: isDropDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && (data === null || data === void 0 ? void 0 : (_data$MapSubmission = data.MapSubmission) === null || _data$MapSubmission === void 0 ? void 0 : (_data$MapSubmission$D = _data$MapSubmission.DropdownsConfig) === null || _data$MapSubmission$D === void 0 ? void 0 : _data$MapSubmission$D[0]);
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);
  const [watchPlanOn, watchnatureOfConstruction, watchlandUseType, watchSubZoneType, watchPrimaryUse, watchAtivityProposed, watchLandMark, watchState] = watch(["planOn", "natureOfConstruction", "zoneType", "subZoneType", "primaryUse", "activityProposed", "landMark", "landInfo.owners.[0].correspondenceAddress.state"]);
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const alldocs = fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !_isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (_isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleSearchClick = async fastPASId => {
    try {
      let response;
      let data;
      const id = fastPASId.replace(/[-/]/g, "");
      if (fastPASId) {
        var _response, _response$BPA, _response2, _response2$BPA, _data, _data$documents, _drawingPdfs$;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: id
        });
        console.log(response, "responsefromFASTPAS");
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          return;
        }
        data = (_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : _response2$BPA[0];
        setFastPasData(data);
        const drawingPdfs = (_data = data) === null || _data === void 0 ? void 0 : (_data$documents = _data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.filter(e => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs === null || drawingPdfs === void 0 ? void 0 : (_drawingPdfs$ = drawingPdfs[0]) === null || _drawingPdfs$ === void 0 ? void 0 : _drawingPdfs$.fileStoreId);
        if (data) {
          var _data2, _data2$descriptionOfL, _data3, _data3$descriptionOfL, _data4, _data4$descriptionOfL, _data5, _data5$descriptionOfL, _data6, _data6$descriptionOfL, _data6$descriptionOfL2, _data7, _data7$descriptionOfL, _data8, _data9, _data10, _data11, _data12, _data13, _data14, _data15, _data16, _data16$descriptionOf, _data17, _data17$descriptionOf, _data18, _data18$descriptionOf, _data19, _data19$descriptionOf, _data20, _data21, _data22, _data22$descriptionOf, _data23, _data23$descriptionOf, _data24, _data24$descriptionOf, _data25, _data25$descriptionOf, _data26, _data26$descriptionOf, _data27, _data28, _data28$descriptionOf, _data29, _data29$descriptionOf, _data30, _data30$professionald, _data31, _data31$professionald, _data32, _data32$professionald, _data33, _data33$professionald, _data34, _data34$professionald, _data35, _data35$professionald, _data36, _data36$professionald, _data37, _data37$landInfo, _data37$landInfo$owne, _data37$landInfo$owne2, _data38, _data38$landInfo, _data38$landInfo$owne, _data38$landInfo$owne2, _data39, _data39$landInfo, _data39$landInfo$owne, _data39$landInfo$owne2, _data40, _data40$landInfo, _data40$landInfo$owne, _data40$landInfo$owne2, _data40$landInfo$owne3, _data41, _data41$landInfo$owne, _data41$landInfo$owne2, _data41$landInfo$owne3, _data42, _data42$landInfo$owne, _data42$landInfo$owne2, _data42$landInfo$owne3, _data43, _data43$landInfo$owne, _data43$landInfo$owne2, _data43$landInfo$owne3, _data44, _data44$blocks, _data44$blocks$, _data44$blocks$$setBa, _data44$blocks$$setBa2, _data44$blocks$$setBa3, _data45, _data45$blocks, _data45$blocks$, _data45$blocks$$setBa, _data45$blocks$$setBa2, _data45$blocks$$setBa3, _data46, _data46$blocks, _data46$blocks$, _data46$blocks$$setBa, _data46$blocks$$setBa2, _data46$blocks$$setBa3, _data47, _data47$blocks, _data47$blocks$, _data47$blocks$$setBa, _data47$blocks$$setBa2, _data47$blocks$$setBa3, _data48, _data48$blocks, _data48$blocks$, _data48$blocks$$setBa, _data48$blocks$$setBa2, _data48$blocks$$setBa3, _data49, _data49$blocks, _data49$blocks$, _data49$blocks$$setBa, _data49$blocks$$setBa2, _data49$blocks$$setBa3, _data50, _data50$blocks, _data50$blocks$, _data50$blocks$$setBa, _data50$blocks$$setBa2, _data50$blocks$$setBa3, _data51, _data51$blocks, _data51$blocks$, _data51$blocks$$setBa, _data51$blocks$$setBa2, _data51$blocks$$setBa3, _data52, _data52$blocks, _data52$blocks$, _data52$blocks$$plint, _data53, _data53$descriptionOf;
          setValue("zoneType", (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$descriptionOfL = _data2.descriptionOfLand) === null || _data2$descriptionOfL === void 0 ? void 0 : _data2$descriptionOfL.landUsesType);
          setValue("primaryUse", (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$descriptionOfL = _data3.descriptionOfLand) === null || _data3$descriptionOfL === void 0 ? void 0 : _data3$descriptionOfL.activityAsPerMap);
          setValue("landMark", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$descriptionOfL = _data4.descriptionOfLand) === null || _data4$descriptionOfL === void 0 ? void 0 : _data4$descriptionOfL.landMark);
          setValue("sectorNo", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$descriptionOfL = _data5.descriptionOfLand) === null || _data5$descriptionOfL === void 0 ? void 0 : _data5$descriptionOfL.sectorNo);
          setValue("khasraNo", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$descriptionOfL = _data6.descriptionOfLand) === null || _data6$descriptionOfL === void 0 ? void 0 : (_data6$descriptionOfL2 = _data6$descriptionOfL.khasraWithArea[0]) === null || _data6$descriptionOfL2 === void 0 ? void 0 : _data6$descriptionOfL2.khasraNo);
          setValue("schemeName", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$descriptionOfL = _data7.descriptionOfLand) === null || _data7$descriptionOfL === void 0 ? void 0 : _data7$descriptionOfL.schemeName);
          setValue("natureOfConstruction", (_data8 = data) === null || _data8 === void 0 ? void 0 : _data8.natureOfConstruction);
          setValue("sanctionNumber", (_data9 = data) === null || _data9 === void 0 ? void 0 : _data9.sanctionNumber);
          setValue("sanctionDate", (_data10 = data) === null || _data10 === void 0 ? void 0 : _data10.sanctionDate);
          setValue("revenueVillage", (_data11 = data) === null || _data11 === void 0 ? void 0 : _data11.revenueVillage);
          setValue("landMark", (_data12 = data) === null || _data12 === void 0 ? void 0 : _data12.landMark);
          setValue("sectorNo", (_data13 = data) === null || _data13 === void 0 ? void 0 : _data13.sectorNo);
          setValue("khasraNo", (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.khasraNo);
          setValue("plotNo", (_data15 = data) === null || _data15 === void 0 ? void 0 : _data15.plotNo);
          setValue("descriptionOfLand.latitude", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$descriptionOf = _data16.descriptionOfLand) === null || _data16$descriptionOf === void 0 ? void 0 : _data16$descriptionOf.latitude);
          setValue("descriptionOfLand.longitude", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$descriptionOf = _data17.descriptionOfLand) === null || _data17$descriptionOf === void 0 ? void 0 : _data17$descriptionOf.longitude);
          setValue("descriptionOfLand.schemeType", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$descriptionOf = _data18.descriptionOfLand) === null || _data18$descriptionOf === void 0 ? void 0 : _data18$descriptionOf.schemeType);
          setValue("schemeName", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$descriptionOf = _data19.descriptionOfLand) === null || _data19$descriptionOf === void 0 ? void 0 : _data19$descriptionOf.schemeName);
          setValue("riskType", (_data20 = data) === null || _data20 === void 0 ? void 0 : _data20.riskType);
          setValue("planOn", "plinth_submission");
          setValue("selectedOffice", "Lucknow Development Authority");
          setValue("department", (_data21 = data) === null || _data21 === void 0 ? void 0 : _data21.department);
          setValue("businessService", "BPA_MAPPLINTH_DA");
          setValue("activityProposed", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$descriptionOf = _data22.descriptionOfLand) === null || _data22$descriptionOf === void 0 ? void 0 : _data22$descriptionOf.activityProposed);
          setValue("plotArea", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$descriptionOf = _data23.descriptionOfLand) === null || _data23$descriptionOf === void 0 ? void 0 : _data23$descriptionOf.landArea);
          setValue("plotAreaDoc", (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$descriptionOf = _data24.descriptionOfLand) === null || _data24$descriptionOf === void 0 ? void 0 : _data24$descriptionOf.plotAreaDoc);
          setValue("plotAreaPos", (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$descriptionOf = _data25.descriptionOfLand) === null || _data25$descriptionOf === void 0 ? void 0 : _data25$descriptionOf.plotAreaPossession);
          setValue("siteAddress", (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$descriptionOf = _data26.descriptionOfLand) === null || _data26$descriptionOf === void 0 ? void 0 : _data26$descriptionOf.landAddress);
          setValue("tehsil", (_data27 = data) === null || _data27 === void 0 ? void 0 : _data27.tehsil);
          setValue("typeOfArea", (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$descriptionOf = _data28.descriptionOfLand) === null || _data28$descriptionOf === void 0 ? void 0 : _data28$descriptionOf.developmentArea);
          setValue("subZoneType", (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$descriptionOf = _data29.descriptionOfLand) === null || _data29$descriptionOf === void 0 ? void 0 : _data29$descriptionOf.subLandUseAsPerLayout);
          setValue("professionaldetails.consultantCategory", (_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$professionald = _data30.professionaldetails) === null || _data30$professionald === void 0 ? void 0 : _data30$professionald.consultantCategory);
          setValue("professionaldetails.name", (_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$professionald = _data31.professionaldetails) === null || _data31$professionald === void 0 ? void 0 : _data31$professionald.name);
          setValue("professionaldetails.emailId", (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$professionald = _data32.professionaldetails) === null || _data32$professionald === void 0 ? void 0 : _data32$professionald.emailId);
          setValue("professionaldetails.mobileNumber", (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$professionald = _data33.professionaldetails) === null || _data33$professionald === void 0 ? void 0 : _data33$professionald.mobileNumber);
          setValue("professionaldetails.certificateNo", (_data34 = data) === null || _data34 === void 0 ? void 0 : (_data34$professionald = _data34.professionaldetails) === null || _data34$professionald === void 0 ? void 0 : _data34$professionald.certificateNo);
          setValue("professionaldetails.validupto", (_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$professionald = _data35.professionaldetails) === null || _data35$professionald === void 0 ? void 0 : _data35$professionald.validupto);
          setValue("landInfo.owners.[0].name", (_data36 = data) === null || _data36 === void 0 ? void 0 : (_data36$professionald = _data36.professionaldetails) === null || _data36$professionald === void 0 ? void 0 : _data36$professionald.consultantCategory);
          setValue("landInfo.owners.[0].name", (_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$landInfo = _data37.landInfo) === null || _data37$landInfo === void 0 ? void 0 : (_data37$landInfo$owne = _data37$landInfo.owners) === null || _data37$landInfo$owne === void 0 ? void 0 : (_data37$landInfo$owne2 = _data37$landInfo$owne[0]) === null || _data37$landInfo$owne2 === void 0 ? void 0 : _data37$landInfo$owne2.name);
          setValue("landInfo.owners.[0].emailId", (_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$landInfo = _data38.landInfo) === null || _data38$landInfo === void 0 ? void 0 : (_data38$landInfo$owne = _data38$landInfo.owners) === null || _data38$landInfo$owne === void 0 ? void 0 : (_data38$landInfo$owne2 = _data38$landInfo$owne[0]) === null || _data38$landInfo$owne2 === void 0 ? void 0 : _data38$landInfo$owne2.emailId);
          setValue("landInfo.owners.[0].mobileNumber", (_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$landInfo = _data39.landInfo) === null || _data39$landInfo === void 0 ? void 0 : (_data39$landInfo$owne = _data39$landInfo.owners) === null || _data39$landInfo$owne === void 0 ? void 0 : (_data39$landInfo$owne2 = _data39$landInfo$owne[0]) === null || _data39$landInfo$owne2 === void 0 ? void 0 : _data39$landInfo$owne2.mobileNumber);
          setValue("landInfo.owners.[0].correspondenceAddress.state", (_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$landInfo = _data40.landInfo) === null || _data40$landInfo === void 0 ? void 0 : (_data40$landInfo$owne = _data40$landInfo.owners) === null || _data40$landInfo$owne === void 0 ? void 0 : (_data40$landInfo$owne2 = _data40$landInfo$owne[0]) === null || _data40$landInfo$owne2 === void 0 ? void 0 : (_data40$landInfo$owne3 = _data40$landInfo$owne2.correspondenceAddress) === null || _data40$landInfo$owne3 === void 0 ? void 0 : _data40$landInfo$owne3.state);
          setValue("landInfo.owners.[0].correspondenceAddress.town", (_data41 = data) === null || _data41 === void 0 ? void 0 : (_data41$landInfo$owne = _data41.landInfo.owners) === null || _data41$landInfo$owne === void 0 ? void 0 : (_data41$landInfo$owne2 = _data41$landInfo$owne[0]) === null || _data41$landInfo$owne2 === void 0 ? void 0 : (_data41$landInfo$owne3 = _data41$landInfo$owne2.correspondenceAddress) === null || _data41$landInfo$owne3 === void 0 ? void 0 : _data41$landInfo$owne3.town);
          setValue("landInfo.owners.[0].correspondenceAddress.pinno", (_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$landInfo$owne = _data42.landInfo.owners) === null || _data42$landInfo$owne === void 0 ? void 0 : (_data42$landInfo$owne2 = _data42$landInfo$owne[0]) === null || _data42$landInfo$owne2 === void 0 ? void 0 : (_data42$landInfo$owne3 = _data42$landInfo$owne2.correspondenceAddress) === null || _data42$landInfo$owne3 === void 0 ? void 0 : _data42$landInfo$owne3.pinno);
          setValue("landInfo.owners.[0].correspondenceAddress.address", (_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$landInfo$owne = _data43.landInfo.owners) === null || _data43$landInfo$owne === void 0 ? void 0 : (_data43$landInfo$owne2 = _data43$landInfo$owne[0]) === null || _data43$landInfo$owne2 === void 0 ? void 0 : (_data43$landInfo$owne3 = _data43$landInfo$owne2.correspondenceAddress) === null || _data43$landInfo$owne3 === void 0 ? void 0 : _data43$landInfo$owne3.address);
          setValue("blocks.[0].setBacks.[0].frontYard.minimumDistance", (_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$blocks = _data44.blocks) === null || _data44$blocks === void 0 ? void 0 : (_data44$blocks$ = _data44$blocks[0]) === null || _data44$blocks$ === void 0 ? void 0 : (_data44$blocks$$setBa = _data44$blocks$.setBacks) === null || _data44$blocks$$setBa === void 0 ? void 0 : (_data44$blocks$$setBa2 = _data44$blocks$$setBa[0]) === null || _data44$blocks$$setBa2 === void 0 ? void 0 : (_data44$blocks$$setBa3 = _data44$blocks$$setBa2.frontYard) === null || _data44$blocks$$setBa3 === void 0 ? void 0 : _data44$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[0].rearYard.minimumDistance", (_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$blocks = _data45.blocks) === null || _data45$blocks === void 0 ? void 0 : (_data45$blocks$ = _data45$blocks[0]) === null || _data45$blocks$ === void 0 ? void 0 : (_data45$blocks$$setBa = _data45$blocks$.setBacks) === null || _data45$blocks$$setBa === void 0 ? void 0 : (_data45$blocks$$setBa2 = _data45$blocks$$setBa[0]) === null || _data45$blocks$$setBa2 === void 0 ? void 0 : (_data45$blocks$$setBa3 = _data45$blocks$$setBa2.rearYard) === null || _data45$blocks$$setBa3 === void 0 ? void 0 : _data45$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[0].sideYard1.minimumDistance", (_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$blocks = _data46.blocks) === null || _data46$blocks === void 0 ? void 0 : (_data46$blocks$ = _data46$blocks[0]) === null || _data46$blocks$ === void 0 ? void 0 : (_data46$blocks$$setBa = _data46$blocks$.setBacks) === null || _data46$blocks$$setBa === void 0 ? void 0 : (_data46$blocks$$setBa2 = _data46$blocks$$setBa[0]) === null || _data46$blocks$$setBa2 === void 0 ? void 0 : (_data46$blocks$$setBa3 = _data46$blocks$$setBa2.sideYard1) === null || _data46$blocks$$setBa3 === void 0 ? void 0 : _data46$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[0].sideYard2.minimumDistance", (_data47 = data) === null || _data47 === void 0 ? void 0 : (_data47$blocks = _data47.blocks) === null || _data47$blocks === void 0 ? void 0 : (_data47$blocks$ = _data47$blocks[0]) === null || _data47$blocks$ === void 0 ? void 0 : (_data47$blocks$$setBa = _data47$blocks$.setBacks) === null || _data47$blocks$$setBa === void 0 ? void 0 : (_data47$blocks$$setBa2 = _data47$blocks$$setBa[0]) === null || _data47$blocks$$setBa2 === void 0 ? void 0 : (_data47$blocks$$setBa3 = _data47$blocks$$setBa2.sideYard2) === null || _data47$blocks$$setBa3 === void 0 ? void 0 : _data47$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[1].frontYard.minimumDistance", (_data48 = data) === null || _data48 === void 0 ? void 0 : (_data48$blocks = _data48.blocks) === null || _data48$blocks === void 0 ? void 0 : (_data48$blocks$ = _data48$blocks[0]) === null || _data48$blocks$ === void 0 ? void 0 : (_data48$blocks$$setBa = _data48$blocks$.setBacks) === null || _data48$blocks$$setBa === void 0 ? void 0 : (_data48$blocks$$setBa2 = _data48$blocks$$setBa[1]) === null || _data48$blocks$$setBa2 === void 0 ? void 0 : (_data48$blocks$$setBa3 = _data48$blocks$$setBa2.frontYard) === null || _data48$blocks$$setBa3 === void 0 ? void 0 : _data48$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[1].rearYard.minimumDistance", (_data49 = data) === null || _data49 === void 0 ? void 0 : (_data49$blocks = _data49.blocks) === null || _data49$blocks === void 0 ? void 0 : (_data49$blocks$ = _data49$blocks[0]) === null || _data49$blocks$ === void 0 ? void 0 : (_data49$blocks$$setBa = _data49$blocks$.setBacks) === null || _data49$blocks$$setBa === void 0 ? void 0 : (_data49$blocks$$setBa2 = _data49$blocks$$setBa[1]) === null || _data49$blocks$$setBa2 === void 0 ? void 0 : (_data49$blocks$$setBa3 = _data49$blocks$$setBa2.rearYard) === null || _data49$blocks$$setBa3 === void 0 ? void 0 : _data49$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[1].sideYard1.minimumDistance", (_data50 = data) === null || _data50 === void 0 ? void 0 : (_data50$blocks = _data50.blocks) === null || _data50$blocks === void 0 ? void 0 : (_data50$blocks$ = _data50$blocks[0]) === null || _data50$blocks$ === void 0 ? void 0 : (_data50$blocks$$setBa = _data50$blocks$.setBacks) === null || _data50$blocks$$setBa === void 0 ? void 0 : (_data50$blocks$$setBa2 = _data50$blocks$$setBa[1]) === null || _data50$blocks$$setBa2 === void 0 ? void 0 : (_data50$blocks$$setBa3 = _data50$blocks$$setBa2.sideYard1) === null || _data50$blocks$$setBa3 === void 0 ? void 0 : _data50$blocks$$setBa3.minimumDistance);
          setValue("blocks.[0].setBacks.[1].sideYard2.minimumDistance", (_data51 = data) === null || _data51 === void 0 ? void 0 : (_data51$blocks = _data51.blocks) === null || _data51$blocks === void 0 ? void 0 : (_data51$blocks$ = _data51$blocks[0]) === null || _data51$blocks$ === void 0 ? void 0 : (_data51$blocks$$setBa = _data51$blocks$.setBacks) === null || _data51$blocks$$setBa === void 0 ? void 0 : (_data51$blocks$$setBa2 = _data51$blocks$$setBa[1]) === null || _data51$blocks$$setBa2 === void 0 ? void 0 : (_data51$blocks$$setBa3 = _data51$blocks$$setBa2.sideYard2) === null || _data51$blocks$$setBa3 === void 0 ? void 0 : _data51$blocks$$setBa3.minimumDistance);
          setValue("landInfo.checklistdata.plinthHeight", (_data52 = data) === null || _data52 === void 0 ? void 0 : (_data52$blocks = _data52.blocks) === null || _data52$blocks === void 0 ? void 0 : (_data52$blocks$ = _data52$blocks[0]) === null || _data52$blocks$ === void 0 ? void 0 : (_data52$blocks$$plint = _data52$blocks$.plinthHeight) === null || _data52$blocks$$plint === void 0 ? void 0 : _data52$blocks$$plint[0]);
          const isApproved = ((_data53 = data) === null || _data53 === void 0 ? void 0 : (_data53$descriptionOf = _data53.descriptionOfLand) === null || _data53$descriptionOf === void 0 ? void 0 : _data53$descriptionOf.schemeType) === "Scheme";
          setSchemeType(isApproved);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData.find(item => item.name === authority);
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Categery, _masterData$2, _masterData$2$Categer, _masterData$2$Categer2, _masterData$2$Categer3, _masterData$2$Categer4;
    console.log("FromNonschemeDataCalled", masterData, category);
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Categery = _masterData$.CategeryType) === null || _masterData$$Categery === void 0 ? void 0 : _masterData$$Categery.map(item => {
      return {
        name: item.Categery,
        label: item.Categery
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categer = _masterData$2.CategeryType) === null || _masterData$2$Categer === void 0 ? void 0 : (_masterData$2$Categer2 = _masterData$2$Categer.filter(item => item.Categery === category)) === null || _masterData$2$Categer2 === void 0 ? void 0 : (_masterData$2$Categer3 = _masterData$2$Categer2[0]) === null || _masterData$2$Categer3 === void 0 ? void 0 : (_masterData$2$Categer4 = _masterData$2$Categer3["Activity Proposed"]) === null || _masterData$2$Categer4 === void 0 ? void 0 : _masterData$2$Categer4.map(item => {
      return {
        name: item,
        label: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = !schemeType ? filterSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, schemeTypeData, watchlandUseType) : filterNonSchemeData(fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.selectedOffice, nonSchemeTypeData, watchlandUseType);
  const onSubmit = data => {
    const final = {
      ...fastPASData,
      ...data
    };
    if (_isEmployee) {
      handleTabChange(2, final);
    } else {
      data.khasraRemarks = remarks;
      handleTabChange(1, final);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Work Commencement Module)"))), /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS ID",
    placeholder: "Enter FASTPAS ID",
    name: "fastPASId",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.fastPASId,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee,
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("fastPASId"))
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Person (LTP)"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: `${t("Consultant Category")}`,
    placeholder: `${t("Cosultant Category")}`,
    name: "professionaldetails.consultantCategory",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_APPLICANT_NAME"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "professionaldetails.name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionaldetails) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "professionaldetails.emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionaldetails) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "professionaldetails.mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionaldetails) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Certificate No. (For Minimum Qualification)",
    control: control,
    placeholder: "Enter Certificate No",
    maxLength: 13,
    type: "textInput",
    name: "professionaldetails.certificateNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionaldetails) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.certificateNo
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_VALID_UPTO"),
    control: control,
    placeholder: "Select Date",
    type: "datePicker",
    name: "professionaldetails.validupto",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionaldetails) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.validupto,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner Information"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Name"),
    control: control,
    placeholder: t("LABEL_ENTER_NAME"),
    name: "landInfo.owners.[0].name",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : _formData$landInfo2$o2.name,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Enter Mobile No"),
    control: control,
    placeholder: t("Mobile No"),
    mobileNumber: true,
    mandatory: true,
    type: "textInput",
    name: "landInfo.owners.[0].mobileNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.mobileNumber,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10,
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("LABEL_EMAIL_ID"),
    control: control,
    placeholder: t("LABEL_ENTER_APPLICANT_EMAIL_ID"),
    name: "landInfo.owners.[0].emailId",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.emailId,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_STATE"),
    placeholder: t("LABEL_ENTER_STATE"),
    name: "landInfo.owners.[0].correspondenceAddress.state",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.correspondenceAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.state,
    type: "selectInput",
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: updistricts,
    label: t("LABEL_CITY"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY"),
    name: "landInfo.owners.[0].correspondenceAddress.town",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.correspondenceAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.town,
    type: watchState === "Uttar Pradesh" ? "selectInput" : "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_PINCODE"),
    placeholder: t("LABEL_ENTER_PINCODE"),
    name: "landInfo.owners.[0].correspondenceAddress.pinno",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.correspondenceAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.pinno,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6,
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("LABEL_ADDRESS"),
    placeholder: t("LABEL_ENTER_ADDRESS"),
    name: "landInfo.owners.[0].correspondenceAddress.address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : (_formData$landInfo8$o2 = _formData$landInfo8$o[0]) === null || _formData$landInfo8$o2 === void 0 ? void 0 : (_formData$landInfo8$o3 = _formData$landInfo8$o2.correspondenceAddress) === null || _formData$landInfo8$o3 === void 0 ? void 0 : _formData$landInfo8$o3.address,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    maxLength: 50,
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Plot Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Land Use"),
    placeholder: t("Select Type of Land"),
    name: "zoneType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.zoneType,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Land Sub Use"),
    placeholder: t("Select Type of Land Subuse"),
    name: "subZoneType",
    defaultValue: (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.subLandUseAsPerLayout) || (formData === null || formData === void 0 ? void 0 : formData.subZoneType),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landUseList),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "primaryUse",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.primaryUse,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(landSubUseList),
    label: t("Activity proposed"),
    placeholder: t("Select Type of Activity proposed"),
    name: "activityProposed",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.activityProposed,
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, " ", /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: SortingAlphabatically(planOnOptions),
    label: t("Proposed Site"),
    placeholder: t("Proposed Site"),
    name: "proposalType",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.proposalType,
    type: "selectInput",
    disabled: _isEmployee
  })), watchPlanOn === "Others" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Other Proposed Site",
    control: control,
    placeholder: t("Enter Proposed Site"),
    name: "otherSchemeName",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.otherSchemeName,
    type: "textInput",
    disabled: _isEmployee
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction No."),
    control: control,
    placeholder: t("Enter sanction number"),
    name: "layoutsanctionNumber",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionNumber,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sanction Date"),
    control: control,
    placeholder: t("Enter Sanction date"),
    name: "layoutsanctionDate",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate,
    type: "datePicker",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: t("Nature of Construction /Case Type"),
    placeholder: t("Select Nature Of Construction"),
    name: "natureOfConstruction",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction,
    data: SortingAlphabatically(natureOfConstruction),
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Validity"),
    control: control,
    placeholder: t("Select Validity"),
    name: "validity",
    mandatory: true,
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.validity,
    type: "datePicker",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Scheme Name",
    control: control,
    placeholder: "Select Scheme Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.schemeName,
    name: `schemeName`,
    type: "selectInput",
    mandatory: true,
    data: SortingAlphabatically(dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.schemeName),
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.tehsil,
    name: `tehsil`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Revenue Village/Colony Name",
    control: control,
    placeholder: "Enter Revenue Village",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.revenueVillage,
    name: `revenueVillage`,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Land Mark"),
    control: control,
    placeholder: t("Enter Land Mark"),
    name: "landMark",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.landMark,
    type: "textInput",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Sector/Pocket No."),
    control: control,
    placeholder: t("Enter Sector/Pocket No."),
    name: "sectorNo",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.sectorNo,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Khasra No."),
    control: control,
    placeholder: t("Enter Khasra No."),
    name: "khasraNo",
    maxLength: 15,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.khasraNo,
    type: "textInput",
    disabled: _isEmployee
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Plot No"),
    control: control,
    placeholder: t("Enter Plot no"),
    name: "plotNo",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.plotNo,
    type: "textInput",
    disabled: _isEmployee
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("strong", null, "Drawing PDF"), ":"), " ", /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 6
  }, dwgPdf ? /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading)
  }) : /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#d3d3d3",
    style: {
      width: "20px",
      height: "30px"
    }
  })))), /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Declaration"),
    control: control,
    name: "declaration",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Document"),
    control: control,
    name: "document",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Remark"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, !_isEmployee ? /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(RemarksEditor, {
    setRemarks: setRemarks,
    remarks: remarks,
    setError: setError,
    error: error
  })) : /*#__PURE__*/React__default.createElement(Row$1, null, "LTP Remark: ", formData === null || formData === void 0 ? void 0 : formData.khasraRemarks))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "20px",
      padding: "12px 16px",
      backgroundColor: "#fff3cd",
      border: "1px solid #ffeeba",
      borderRadius: "4px",
      color: "#856404",
      fontWeight: "500"
    }
  }, t("FASTPAS.GLOBAL.ONCE.TEXT")), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  }), !_isEmployee && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Forward",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3"
    }
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  })));
};

const filterCategory$1 = roles => {
  console.log("rolesFromFilter", roles);
  if (roles) {
    var _roles$filter$, _roles$filter$2;
    const result = (_roles$filter$ = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$ === void 0 ? void 0 : _roles$filter$.name;
    console.log("resultFromFIlter", result, roles);
    return (_roles$filter$2 = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$2 === void 0 ? void 0 : _roles$filter$2.name;
  }
};

const useLandUseData$1 = ({
  id,
  tenantId,
  userInfo,
  usersData,
  applicationFlow,
  validity,
  userUid
}) => {
  var _data$LandUse, _usersData$, _usersData$2;
  const isEditMode = !!id;
  console.log("logginFromNewHookCreate", id, isEditMode);
  const consultantCategory = filterCategory$1(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
      applicationNo: id
    });
  };
  const {
    data,
    isLoading: isAppDataLoading,
    isSuccess
  } = useQuery({
    queryKey: ["landUseData", id],
    queryFn: fetchApplicationData,
    enabled: isEditMode
  });
  const applicationData = isEditMode && isSuccess ? data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0] : {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      consultantCategory: consultantCategory,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      planDate: validity,
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      },
      certificateNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : _usersData$.registrationArchitectNumber,
      licenseNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.registrationNumber,
      planDate: validity
    },
    department: applicationFlow,
    landAreaDetails: {
      city: null,
      locality: null,
      village: null,
      areaType: null
    },
    descriptionOfLand: {
      revenueVillageMohal: null,
      propertyType: null,
      khataNo: null,
      multipleKhasra: [{
        khasraNo: "",
        area: ""
      }],
      khatauniNo: null,
      areaForCluSqM: 0,
      nameofConcerned: null,
      natureOfTower: null,
      towerToBeProposed: null,
      proposedGoundCoverageSqM: null,
      whetherUsedBySingleCompany: null,
      installationFeesDeposited: null,
      nameofConcerned: null,
      sectorNo: null,
      schemeName: null,
      approachRoadWidths: null,
      totalPlotArea: 0,
      appliedLandUse: {
        name: null
      },
      whetherUsedBySingleCompany: null,
      propertyType: {
        name: null
      },
      installationFeesDeposited: null,
      isChangeOfLandInvolved: null,
      typeOfCLUInvolved: {
        name: null
      }
    },
    activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
    applicationType: "FORM_LANDUSE",
    feeType: "ApplicationFee",
    workflow: {
      action: "INITIATE"
    },
    landInfo: {
      owners: [{
        name: null,
        fatherOrHusbandName: null,
        aadhaarNumber: "",
        mobileNumber: "",
        emailId: "",
        gender: null,
        correspondenceAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "PERMANENT"
        }
      }],
      tenantId
    },
    nocDetails: {
      applicantNOCData: null,
      additionalApplicantNOC: null,
      officerNOCData: null,
      additionalOfficerNOC: null,
      checkedByOfficer: null
    },
    businessService: null,
    documents: [],
    uiFlow: {
      flow: "Form_LANDUSE"
    }
  };
  return {
    applicationData,
    isAppDataLoading
  };
};

const useLandUseLogic$1 = () => {
  var _Digit, _Digit2, _cities$filter, _cities$filter$, _cities$filter$$bound, _cities$filter2, _cities$filter2$, _cities$filter2$$boun;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    formType
  } = useParams();
  console.log(useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getStateId() || "up";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  console.log("idFromLogic", id);
  const Modal = useModal();
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [usersData, setUsersData] = useState([]);
  const [validity, setvalidity] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const {
    documents
  } = useSelector(state => state.formMT);
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  console.log("applicationFlowFromLogic", applicationFlow, userInfo);
  const consultantCategory = filterCategory$1(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  useEffect(() => {
    const searchUser = async () => {
      try {
        var _response$user;
        const response = await Digit.UserService.userSearch(tenantId, {
          uuid: [userUid]
        }, {});
        console.log("searchUser:", response);
        setUsersData(response === null || response === void 0 ? void 0 : response.user);
        if ((response === null || response === void 0 ? void 0 : (_response$user = response.user) === null || _response$user === void 0 ? void 0 : _response$user.length) > 0) {
          var _response$user2, _response$user2$;
          const expiryDate = (response === null || response === void 0 ? void 0 : (_response$user2 = response.user) === null || _response$user2 === void 0 ? void 0 : (_response$user2$ = _response$user2[0]) === null || _response$user2$ === void 0 ? void 0 : _response$user2$.validUpto).split(" ")[0];
          console.log("expiryDateFromLogic", expiryDate);
          setvalidity(expiryDate);
        }
      } catch (error) {
        console.error("Error during user search:", error);
      }
    };
    searchUser();
  }, [tenantId, userUid, setvalidity]);
  const {
    applicationData,
    isAppDataLoading
  } = useLandUseData$1({
    id,
    tenantId,
    userInfo,
    usersData,
    applicationFlow,
    validity,
    userUid
  });
  const summaryRef = useRef();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORMLANDUSE", applicationData);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LANDUSE_CURRENT_TAB")) || 0);
  const [subActiveTab, setSubActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LANDUSE_CURRENT_SUBTAB")) || 0);
  const [showToast, setShowToast] = useState(null);
  const [archData, setArchData] = useState({});
  const isDA = applicationFlow === "DA";
  useEffect(() => {
    if (applicationData && applicationData !== null && applicationData !== void 0 && applicationData.selectedModule) {
      setSelectedModule(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selectedModule);
    }
  }, [applicationData]);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    console.log("ActiveTab", activeTab, nextTabNo, formData, params);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in params)) {
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse = result.LandUse) === null || _result$LandUse === void 0 ? void 0 : _result$LandUse.length) > 0) {
            onSelect("", {
              ...data,
              ...result.LandUse[0]
            }, true);
            setShowToast({
              key: "success",
              message: `Data has been saved successfully!`
            });
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          const error = (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro[0];
          if ((error === null || error === void 0 ? void 0 : error.message) === "The entered mobile number is already registered as an LTP. Please enter a valid owner mobile number." && (error === null || error === void 0 ? void 0 : error.code) === "ALready Registered Number") {
            Modal("User Already Registered", error === null || error === void 0 ? void 0 : error.message, "warning");
          } else {
            setShowToast({
              error: true,
              message: `Something went wrong!`
            });
          }
        });
      } else {
        try {
          if (activeTab === 2 || nextTabNo === 4) {
            var _formData$description, _formData$nocDetails, _formData$nocDetails$, _formData$nocDetails2, _formData$nocDetails3, _Digit3, _Digit4, _Digit5;
            console.log("insideActiveTab3", activeTab, nextTabNo);
            let redirectUrl = "";
            let message = "";
            const riskType = formData === null || formData === void 0 ? void 0 : formData.riskType;
            const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
            console.log("riskingTypeFrom", riskType, isLowRiskCase);
            const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
            const isNoc = (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : (_formData$nocDetails$ = _formData$nocDetails.additionalApplicantNOC) === null || _formData$nocDetails$ === void 0 ? void 0 : _formData$nocDetails$.length) > 0 || (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.applicantNOCData) && Object.keys(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : _formData$nocDetails3.applicantNOCData).some(key => {
              var _formData$nocDetails4;
              return (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails4 = formData.nocDetails) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.applicantNOCData[key]) === true;
            });
            if (isLowRiskCase) {
              data.nocDetails = {};
            }
            const validation = validateSummaryForm({
              formType: "FORMLANDUSE",
              formData: data,
              reduxDocuments: documents,
              t
            });
            if (!validation.isValid) {
              Modal("Missing Mandatory Fields", validation.errorHtml, "error");
              return;
            }
            data.workflow = {
              action: "APPROVED",
              assignes: null
            };
            redirectUrl = "/digit-ui/citizen/profile";
            message = "Application Approved";
            console.log("logBeforeLandUSeupdate", data, redirectUrl);
            if (!data.businessService) {
              data.businessService = isDA ? "BPA_LANDUSE_DA" : "BPA_LANDUSE_AVP";
            }
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                onSelect("", data);
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
            console.log("messageFromLU", message);
            Modal("Data has been saved successfully!", `Low risk application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> approved Successfully!`, "success", redirectUrl);
            clearParams();
            (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("FORMLANDUSE");
            (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("LANDUSE_CURRENT_TAB");
            (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
          } else {
            console.log("insideELseACTIVETAB", activeTab, nextTabNo);
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: null
            };
            if (!data.businessService) {
              data.businessService = isDA ? "BPA_LANDUSE_DA" : "BPA_LANDUSE_AVP";
            }
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                var _Digit6;
                onSelect("", data);
                setActiveTab(nextTabNo);
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
                setShowToast({
                  key: "success",
                  message: `Data has been saved successfully!`
                });
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
          }
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      }
    } else {
      var _Digit7;
      setActiveTab(nextTabNo);
      (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("subTabChange", params, formData);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse2;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse2 = result.LandUse) === null || _result$LandUse2 === void 0 ? void 0 : _result$LandUse2.length) > 0) {
            console.log("landuseResult", result === null || result === void 0 ? void 0 : result.LandUse);
            onSelect("", {
              ...formData,
              ...result.LandUse[0]
            }, "");
            setShowToast({
              key: "success",
              message: `Application Created Successfully!`
            });
            setSelectedModule(formData === null || formData === void 0 ? void 0 : formData.selectedModule);
            setSubActiveTab(nextSubTab);
            Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          var _e$response2, _e$response2$data, _e$response2$data$Err;
          const error = (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$Err = _e$response2$data.Errors) === null || _e$response2$data$Err === void 0 ? void 0 : _e$response2$data$Err[0];
          if ((error === null || error === void 0 ? void 0 : error.message) === "The entered mobile number is already registered as an LTP. Please enter a valid owner mobile number." && (error === null || error === void 0 ? void 0 : error.code) === "ALready Registered Number") {
            Modal("User Already Registered", error === null || error === void 0 ? void 0 : error.message, "warning");
          } else setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          if (!data.businessService) {
            data.businessService = isDA ? "BPA_LANDUSE_DA" : "BPA_LANDUSE_AVP";
          }
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: result => {
              var _result$LandUse3;
              if ((result === null || result === void 0 ? void 0 : (_result$LandUse3 = result.LandUse) === null || _result$LandUse3 === void 0 ? void 0 : _result$LandUse3.length) > 0) {
                onSelect("", result.LandUse[0]);
                setShowToast({
                  key: "success",
                  message: `Data has been saved successfully!`
                });
                setSubActiveTab(nextSubTab);
                Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
              }
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong!`
              });
            }
          });
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      BPA: {
        AVPSchemesUnitData: avpData
      } = {}
    } = {},
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", ["AVPSchemesUnitData"]);
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const avpUnits = avpData === null || avpData === void 0 ? void 0 : avpData.map(item => {
    return {
      name: item.Unit,
      label: item.Unit,
      value: item.Unit
    };
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  console.log("logoData", {
    logoStore,
    avpLogo,
    daLogo
  });
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const avpAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter = cities.filter(district => {
    var _district$code;
    return (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes("up.avp");
  })) === null || _cities$filter === void 0 ? void 0 : (_cities$filter$ = _cities$filter[0]) === null || _cities$filter$ === void 0 ? void 0 : (_cities$filter$$bound = _cities$filter$.boundary) === null || _cities$filter$$bound === void 0 ? void 0 : _cities$filter$$bound.filter(ele => ele.hasOwnProperty("location")) : [];
  const daAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter2 = cities.filter(district => {
    var _district$code2;
    return (_district$code2 = district.code) === null || _district$code2 === void 0 ? void 0 : _district$code2.includes("up.da");
  })) === null || _cities$filter2 === void 0 ? void 0 : (_cities$filter2$ = _cities$filter2[0]) === null || _cities$filter2$ === void 0 ? void 0 : (_cities$filter2$$boun = _cities$filter2$.boundary) === null || _cities$filter2$$boun === void 0 ? void 0 : _cities$filter2$$boun.filter(ele => ele.hasOwnProperty("location")) : [];
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  console.log("MDMS_Department_Data", schemeTypeData, nonSchemeTypeData);
  console.log("authoritiesNameMDMS", departmentList);
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "AVP");
  const officesList = applicationFlow == "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  console.log("fromLandUseLogic", officesList, applicationFlow);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  return {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setSubActiveTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo,
    selectedModule,
    setSelectedModule
  };
};

const ownerEntry$2 = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE"
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT"
  }
};
const SubStep1$g = ({
  formData,
  handleSubTabChange,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  id,
  setParams,
  initFormMTDocs,
  setShowToast,
  usersData
}) => {
  var _userInfo$info, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _watchOffice$split$;
  const {
    documents
  } = useSelector(state => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const {
    t
  } = useTranslation();
  const userInfo = Digit.UserService.getUser();
  const roles = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.roles) || [];
  const isLtp = roles.some(role => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role.code));
  console.log("FormData7676172617267", formData);
  const isOwner = roles.some(role => role.code === "OWNER") && !isLtp;
  const defaultValues = {
    ...formData,
    department: applicationFlow,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry$2]
    },
    documents: documents
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = isDistrictDataLoading ? [] : districtData.map(district => ({
    label: district.name,
    value: district.name,
    name: district.name
  }));
  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    trigger,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const watchState = watch(`landInfo.owners.[0].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice);
  const watchModule = watch("selectedModule") || (formData === null || formData === void 0 ? void 0 : formData.selectedModule);
  const watchSelectedOffice = isDA ? watchOffice === null || watchOffice === void 0 ? void 0 : watchOffice.split(" ")[0] : watchOffice === null || watchOffice === void 0 ? void 0 : (_watchOffice$split$ = watchOffice.split(",")[1]) === null || _watchOffice$split$ === void 0 ? void 0 : _watchOffice$split$.trim();
  const watchUnit = watch("selectedUnit") || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit);
  const watchCity = watch("selectedCity") || (formData === null || formData === void 0 ? void 0 : formData.selectedCity);
  const filterCities = (unit, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C;
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : _masterData$filter$$C.map(item => {
      return {
        name: item.City,
        label: item.City,
        value: item.City
      };
    });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        var _response, _response$Application, _response2, _data, _data$documents, _data2, _data2$ownerDetail, _data3, _data3$ownerDetail, _data4, _data4$ownerDetail, _data5, _data5$ownerDetail, _data6, _data6$ownerDetail, _data7, _data7$ownerDetail, _data8, _data8$projectDetail, _data9, _data9$architectDetai, _data10, _data10$architectDeta, _data11, _data11$architectDeta, _data12, _data12$architectDeta, _data13, _data13$architectDeta, _data14, _data14$architectDeta, _usersData$, _usersData$$roles, _usersData$$roles$fil, _usersData$$roles$fil2, _usersData$2, _usersData$3, _usersData$4, _usersData$5, _usersData$6, _usersData$7, _data15, _data15$plotDetail, _data16, _data16$plotDetail, _data17, _data17$plotDetail, _data18, _data18$plotDetail, _data19, _data19$plotDetail, _data20, _data20$plotDetail, _data21, _data21$plotDetail, _data22, _data22$plotDetail, _data23, _data23$ownerDetail, _data44, _data44$documents, _data44$documents$fil, _data45, _data45$documents, _data45$documents$fil, _data46, _data46$descriptionOf;
        response = await Digit.OBPSService.BPAmigratedSearchappNo({
          applicationNo
        });
        console.log(response, "responsefromId");
        if (!((_response = response) !== null && _response !== void 0 && (_response$Application = _response.Application) !== null && _response$Application !== void 0 && _response$Application.ownerDetail)) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        }
        data = (_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.Application;
        setFastPasData(data);
        const drawingPdfs = (_data = data) === null || _data === void 0 ? void 0 : (_data$documents = _data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.filter(e => e.documentType === "drawingPdf");
        if (data) {
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`
          });
        }
        console.log(data, response, "responseee");
        setValue("landInfo.owners.[0].name", (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$ownerDetail = _data2.ownerDetail) === null || _data2$ownerDetail === void 0 ? void 0 : _data2$ownerDetail.ownerName);
        setValue("landInfo.owners.[0].emailId", (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$ownerDetail = _data3.ownerDetail) === null || _data3$ownerDetail === void 0 ? void 0 : _data3$ownerDetail.ownerEmail);
        setValue("landInfo.owners.[0].mobileNumber", (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$ownerDetail = _data4.ownerDetail) === null || _data4$ownerDetail === void 0 ? void 0 : _data4$ownerDetail.ownerContactNo);
        setValue("landInfo.owners.[0].correspondenceAddress.state", (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$ownerDetail = _data5.ownerDetail) === null || _data5$ownerDetail === void 0 ? void 0 : _data5$ownerDetail.state);
        setValue("landInfo.owners.[0].correspondenceAddress.address", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$ownerDetail = _data6.ownerDetail) === null || _data6$ownerDetail === void 0 ? void 0 : _data6$ownerDetail.siteAdress);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$ownerDetail = _data7.ownerDetail) === null || _data7$ownerDetail === void 0 ? void 0 : _data7$ownerDetail.pincode);
        const office = ((_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$projectDetail = _data8.projectDetail) === null || _data8$projectDetail === void 0 ? void 0 : _data8$projectDetail.district) + " " + "Development Authority";
        setValue("selectedOffice", office);
        setValue("professionalInformation.consultantCategory", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$architectDetai = _data9.architectDetail) === null || _data9$architectDetai === void 0 ? void 0 : _data9$architectDetai.consultantCategory);
        setValue("professionalInformation.name", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$architectDeta = _data10.architectDetail) === null || _data10$architectDeta === void 0 ? void 0 : _data10$architectDeta.architectName);
        setValue("professionalInformation.planDate", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$architectDeta = _data11.architectDetail) === null || _data11$architectDeta === void 0 ? void 0 : _data11$architectDeta.validityUpto);
        setValue("professionalInformation.mobileNumber", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$architectDeta = _data12.architectDetail) === null || _data12$architectDeta === void 0 ? void 0 : _data12$architectDeta.mobileNumber);
        setValue("professionalInformation.certificateNumber", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$architectDeta = _data13.architectDetail) === null || _data13$architectDeta === void 0 ? void 0 : _data13$architectDeta.licenseNo);
        setValue("professionalInformation.emailId", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$architectDeta = _data14.architectDetail) === null || _data14$architectDeta === void 0 ? void 0 : _data14$architectDeta.emailId);
        setValue("professionalInformation.coa", usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : (_usersData$$roles = _usersData$.roles) === null || _usersData$$roles === void 0 ? void 0 : (_usersData$$roles$fil = _usersData$$roles.filter(e => e.code !== "CITIZEN" || e.code !== "LTP")) === null || _usersData$$roles$fil === void 0 ? void 0 : (_usersData$$roles$fil2 = _usersData$$roles$fil[0]) === null || _usersData$$roles$fil2 === void 0 ? void 0 : _usersData$$roles$fil2.name);
        setValue("professionalInformation.ername", usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.name);
        setValue("professionalInformation.validupto", usersData === null || usersData === void 0 ? void 0 : (_usersData$3 = usersData[0]) === null || _usersData$3 === void 0 ? void 0 : _usersData$3.validUpto);
        setValue("professionalInformation.ermobileNumber", usersData === null || usersData === void 0 ? void 0 : (_usersData$4 = usersData[0]) === null || _usersData$4 === void 0 ? void 0 : _usersData$4.mobileNumber);
        setValue("professionalInformation.certificateNo", usersData === null || usersData === void 0 ? void 0 : (_usersData$5 = usersData[0]) === null || _usersData$5 === void 0 ? void 0 : _usersData$5.registrationArchitectNumber);
        setValue("professionalInformation.erregistrationNumber", usersData === null || usersData === void 0 ? void 0 : (_usersData$6 = usersData[0]) === null || _usersData$6 === void 0 ? void 0 : _usersData$6.registrationNumber);
        setValue("professionalInformation.eremailId", usersData === null || usersData === void 0 ? void 0 : (_usersData$7 = usersData[0]) === null || _usersData$7 === void 0 ? void 0 : _usersData$7.emailId);
        setValue("descriptionOfLand.landArea", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$plotDetail = _data15.plotDetail) === null || _data15$plotDetail === void 0 ? void 0 : _data15$plotDetail.plotArea);
        setValue("descriptionOfLand.plotAreaDoc", (_data16 = data) === null || _data16 === void 0 ? void 0 : (_data16$plotDetail = _data16.plotDetail) === null || _data16$plotDetail === void 0 ? void 0 : _data16$plotDetail.plotAreaAsDocument);
        setValue("descriptionOfLand.developmentArea", (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$plotDetail = _data17.plotDetail) === null || _data17$plotDetail === void 0 ? void 0 : _data17$plotDetail.developmentArea);
        setValue("descriptionOfLand.landUsesType", (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$plotDetail = _data18.plotDetail) === null || _data18$plotDetail === void 0 ? void 0 : _data18$plotDetail.landUseZone);
        setValue("descriptionOfLand.subLandUseAsPerLayout", (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$plotDetail = _data19.plotDetail) === null || _data19$plotDetail === void 0 ? void 0 : _data19$plotDetail.landSubUseZone);
        setValue("descriptionOfLand.landMark", (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$plotDetail = _data20.plotDetail) === null || _data20$plotDetail === void 0 ? void 0 : _data20$plotDetail.landMark);
        setValue("descriptionOfLand.activityAsPerMap", (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$plotDetail = _data21.plotDetail) === null || _data21$plotDetail === void 0 ? void 0 : _data21$plotDetail.plotUse);
        setValue("descriptionOfLand.activityProposed", (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$plotDetail = _data22.plotDetail) === null || _data22$plotDetail === void 0 ? void 0 : _data22$plotDetail.plotSubUse);
        setValue("descriptionOfLand.landAddress", (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$ownerDetail = _data23.ownerDetail) === null || _data23$ownerDetail === void 0 ? void 0 : _data23$ownerDetail.siteAdress);
        setParams(prev => {
          var _prev$landInfo, _prev$landInfo$owners, _data24, _data24$ownerDetail, _data25, _data25$ownerDetail, _data26, _data26$ownerDetail, _prev$landInfo2, _prev$landInfo2$owner, _prev$landInfo2$owner2, _data27, _data27$ownerDetail, _data28, _data28$ownerDetail, _data29, _data29$ownerDetail, _userInfo$info2, _data30, _data30$architectDeta, _userInfo$info3, _data31, _data31$architectDeta, _data32, _data32$architectDeta, _data33, _data33$architectDeta, _usersData$8, _usersData$9, _usersData$10, _usersData$11, _usersData$12, _usersData$13, _usersData$14, _usersData$14$roles, _usersData$14$roles$f, _usersData$14$roles$f2, _data34, _data35, _data35$plotDetail, _data36, _data36$plotDetail, _data37, _data37$plotDetail, _data38, _data38$plotDetail, _data39, _data39$plotDetail, _data40, _data40$plotDetail, _data41, _data41$plotDetail, _data42, _data42$plotDetail, _data43, _data43$ownerDetail;
          return {
            ...prev,
            landInfo: {
              ...prev.landInfo,
              owners: [{
                ...((_prev$landInfo = prev.landInfo) === null || _prev$landInfo === void 0 ? void 0 : (_prev$landInfo$owners = _prev$landInfo.owners) === null || _prev$landInfo$owners === void 0 ? void 0 : _prev$landInfo$owners[0]),
                name: (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$ownerDetail = _data24.ownerDetail) === null || _data24$ownerDetail === void 0 ? void 0 : _data24$ownerDetail.ownerName,
                emailId: (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$ownerDetail = _data25.ownerDetail) === null || _data25$ownerDetail === void 0 ? void 0 : _data25$ownerDetail.ownerEmail,
                mobileNumber: (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$ownerDetail = _data26.ownerDetail) === null || _data26$ownerDetail === void 0 ? void 0 : _data26$ownerDetail.ownerContactNo,
                correspondenceAddress: {
                  ...((_prev$landInfo2 = prev.landInfo) === null || _prev$landInfo2 === void 0 ? void 0 : (_prev$landInfo2$owner = _prev$landInfo2.owners) === null || _prev$landInfo2$owner === void 0 ? void 0 : (_prev$landInfo2$owner2 = _prev$landInfo2$owner[0]) === null || _prev$landInfo2$owner2 === void 0 ? void 0 : _prev$landInfo2$owner2.correspondenceAddress),
                  state: (_data27 = data) === null || _data27 === void 0 ? void 0 : (_data27$ownerDetail = _data27.ownerDetail) === null || _data27$ownerDetail === void 0 ? void 0 : _data27$ownerDetail.state,
                  address: (_data28 = data) === null || _data28 === void 0 ? void 0 : (_data28$ownerDetail = _data28.ownerDetail) === null || _data28$ownerDetail === void 0 ? void 0 : _data28$ownerDetail.siteAdress,
                  pinno: (_data29 = data) === null || _data29 === void 0 ? void 0 : (_data29$ownerDetail = _data29.ownerDetail) === null || _data29$ownerDetail === void 0 ? void 0 : _data29$ownerDetail.pincode
                }
              }]
            },
            selectedOffice: watchOffice,
            professionalInformation: {
              ...prev.professionalInformation,
              name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.name,
              planDate: (_data30 = data) === null || _data30 === void 0 ? void 0 : (_data30$architectDeta = _data30.architectDetail) === null || _data30$architectDeta === void 0 ? void 0 : _data30$architectDeta.validityUpto,
              mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.mobileNumber,
              emailId: (_data31 = data) === null || _data31 === void 0 ? void 0 : (_data31$architectDeta = _data31.architectDetail) === null || _data31$architectDeta === void 0 ? void 0 : _data31$architectDeta.emailId,
              certificateNumber: (_data32 = data) === null || _data32 === void 0 ? void 0 : (_data32$architectDeta = _data32.architectDetail) === null || _data32$architectDeta === void 0 ? void 0 : _data32$architectDeta.licenseNo,
              consultantCategory: (_data33 = data) === null || _data33 === void 0 ? void 0 : (_data33$architectDeta = _data33.architectDetail) === null || _data33$architectDeta === void 0 ? void 0 : _data33$architectDeta.consultantCategory,
              ername: usersData === null || usersData === void 0 ? void 0 : (_usersData$8 = usersData[0]) === null || _usersData$8 === void 0 ? void 0 : _usersData$8.name,
              validupto: usersData === null || usersData === void 0 ? void 0 : (_usersData$9 = usersData[0]) === null || _usersData$9 === void 0 ? void 0 : _usersData$9.validUpto,
              ermobileNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$10 = usersData[0]) === null || _usersData$10 === void 0 ? void 0 : _usersData$10.mobileNumber,
              erregistrationNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$11 = usersData[0]) === null || _usersData$11 === void 0 ? void 0 : _usersData$11.registrationNumber,
              eremailId: usersData === null || usersData === void 0 ? void 0 : (_usersData$12 = usersData[0]) === null || _usersData$12 === void 0 ? void 0 : _usersData$12.emailId,
              certificateNo: usersData === null || usersData === void 0 ? void 0 : (_usersData$13 = usersData[0]) === null || _usersData$13 === void 0 ? void 0 : _usersData$13.registrationArchitectNumber,
              coa: usersData === null || usersData === void 0 ? void 0 : (_usersData$14 = usersData[0]) === null || _usersData$14 === void 0 ? void 0 : (_usersData$14$roles = _usersData$14.roles) === null || _usersData$14$roles === void 0 ? void 0 : (_usersData$14$roles$f = _usersData$14$roles.filter(e => e.code !== "CITIZEN" || e.code !== "LTP")) === null || _usersData$14$roles$f === void 0 ? void 0 : (_usersData$14$roles$f2 = _usersData$14$roles$f[0]) === null || _usersData$14$roles$f2 === void 0 ? void 0 : _usersData$14$roles$f2.name
            },
            previousProfessionalInformation: (_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.architectDetail,
            descriptionOfLand: {
              ...prev.descriptionOfLand,
              landArea: (_data35 = data) === null || _data35 === void 0 ? void 0 : (_data35$plotDetail = _data35.plotDetail) === null || _data35$plotDetail === void 0 ? void 0 : _data35$plotDetail.plotArea,
              plotAreaDoc: (_data36 = data) === null || _data36 === void 0 ? void 0 : (_data36$plotDetail = _data36.plotDetail) === null || _data36$plotDetail === void 0 ? void 0 : _data36$plotDetail.plotAreaAsDocument,
              developmentArea: (_data37 = data) === null || _data37 === void 0 ? void 0 : (_data37$plotDetail = _data37.plotDetail) === null || _data37$plotDetail === void 0 ? void 0 : _data37$plotDetail.developmentArea,
              landUsesType: (_data38 = data) === null || _data38 === void 0 ? void 0 : (_data38$plotDetail = _data38.plotDetail) === null || _data38$plotDetail === void 0 ? void 0 : _data38$plotDetail.landUseZone,
              subLandUseAsPerLayout: (_data39 = data) === null || _data39 === void 0 ? void 0 : (_data39$plotDetail = _data39.plotDetail) === null || _data39$plotDetail === void 0 ? void 0 : _data39$plotDetail.landSubUseZone,
              landMark: (_data40 = data) === null || _data40 === void 0 ? void 0 : (_data40$plotDetail = _data40.plotDetail) === null || _data40$plotDetail === void 0 ? void 0 : _data40$plotDetail.landMark,
              activityAsPerMap: (_data41 = data) === null || _data41 === void 0 ? void 0 : (_data41$plotDetail = _data41.plotDetail) === null || _data41$plotDetail === void 0 ? void 0 : _data41$plotDetail.plotUse,
              activityProposed: (_data42 = data) === null || _data42 === void 0 ? void 0 : (_data42$plotDetail = _data42.plotDetail) === null || _data42$plotDetail === void 0 ? void 0 : _data42$plotDetail.plotSubUse,
              landAddress: (_data43 = data) === null || _data43 === void 0 ? void 0 : (_data43$ownerDetail = _data43.ownerDetail) === null || _data43$ownerDetail === void 0 ? void 0 : _data43$ownerDetail.siteAdress
            }
          };
        });
        const mutationDocument = ((_data44 = data) === null || _data44 === void 0 ? void 0 : (_data44$documents = _data44.documents) === null || _data44$documents === void 0 ? void 0 : (_data44$documents$fil = _data44$documents.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.docName) === "Mutation Document")) === null || _data44$documents$fil === void 0 ? void 0 : _data44$documents$fil.map(doc => {
          return {
            fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
            documentType: "mutationLetter",
            isMandatory: true,
            additionalDetails: {
              fileName: "mutationLetter",
              title: "Mutation Letter"
            }
          };
        })) || [];
        const registryDocument = ((_data45 = data) === null || _data45 === void 0 ? void 0 : (_data45$documents = _data45.documents) === null || _data45$documents === void 0 ? void 0 : (_data45$documents$fil = _data45$documents.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.docName) === "Sale Deed/Gift deed/Will Deed any other deed/Mutation document/Lease Deed/POA/Development Agreement/Joint Venture/Consortium Agreement.")) === null || _data45$documents$fil === void 0 ? void 0 : _data45$documents$fil.map(doc => {
          return {
            fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
            documentType: "registrySaleDeedHPTA",
            isMandatory: true,
            additionalDetails: {
              fileName: "registrySaleDeedHPTA",
              title: "Sale Deed/Gift deed/Will Deed any other deed/Mutation document/Lease Deed/POA/Development Agreement/Joint Venture/Consortium Agreement."
            }
          };
        })) || [];
        console.log(mutationDocument, registryDocument, "muttationDocsss");
        initFormMTDocs([...mutationDocument, ...registryDocument]);
        const isApproved = ((_data46 = data) === null || _data46 === void 0 ? void 0 : (_data46$descriptionOf = _data46.descriptionOfLand) === null || _data46$descriptionOf === void 0 ? void 0 : _data46$descriptionOf.schemeType) === "Scheme";
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData === null || formData === void 0 ? void 0 : formData.location1);
  }, [formData === null || formData === void 0 ? void 0 : formData.location1]);
  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res || "BPA_LANDUSE_DA");
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSE", applicationFlow);
        setValue("businessService", res || "BPA_LANDUSE_AVP");
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);
  const validateFiles = () => {
    const uploadedDocs = documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType);
    const isValid = owners === null || owners === void 0 ? void 0 : owners.every((_, index) => uploadedDocs === null || uploadedDocs === void 0 ? void 0 : uploadedDocs.includes(`signature_${index}`));
    console.log("Validation Result:", isValid);
    return isValid;
  };
  const validateDistinctMobileNumbers = ownersList => {
    const allMobileNumbers = ownersList === null || ownersList === void 0 ? void 0 : ownersList.map(owner => owner.mobileNumber);
    const uniqueMobileNumbers = new Set(allMobileNumbers);
    return uniqueMobileNumbers.size === allMobileNumbers.length;
  };
  const validateDistinctAdhaarNumbers = ownersList => {
    const allAdhaarNumbers = ownersList === null || ownersList === void 0 ? void 0 : ownersList.map(owner => owner.aadhaarNumber);
    const uniqueAdhaarNumbers = new Set(allAdhaarNumbers);
    return uniqueAdhaarNumbers.size === allAdhaarNumbers.length;
  };
  const onSubmit = data => {
    var _data$landInfo3, _data$landInfo4;
    if (isLtp) {
      var _data$landInfo2, _data$landInfo2$owner;
      const isOwnerMobileSame = (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : (_data$landInfo2$owner = _data$landInfo2.owners) === null || _data$landInfo2$owner === void 0 ? void 0 : _data$landInfo2$owner.some(owner => {
        var _userInfo$info4;
        return owner.mobileNumber === (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info4 = userInfo.info) === null || _userInfo$info4 === void 0 ? void 0 : _userInfo$info4.mobileNumber);
      });
      if (isOwnerMobileSame) {
        setShowToast({
          error: true,
          message: `Owner's mobile number and LTP's mobile number can't be same`
        });
        return;
      }
    }
    if (!validateDistinctMobileNumbers((_data$landInfo3 = data.landInfo) === null || _data$landInfo3 === void 0 ? void 0 : _data$landInfo3.owners)) {
      setShowToast({
        error: true,
        message: `Mobile numbers must be distinct`
      });
      return;
    }
    if (!validateDistinctAdhaarNumbers((_data$landInfo4 = data.landInfo) === null || _data$landInfo4 === void 0 ? void 0 : _data$landInfo4.owners)) {
      setShowToast({
        error: true,
        message: `Aadhaar numbers must be distinct`
      });
      return;
    }
    const isValid = validateFiles();
    if (isValid) {
      var _userInfo$info5, _userInfo$info6, _data47;
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity
            }
          }
        },
        professionalInformation: {
          ...data.professionalInformation,
          name: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info5 = userInfo.info) === null || _userInfo$info5 === void 0 ? void 0 : _userInfo$info5.name,
          mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info6 = userInfo.info) === null || _userInfo$info6 === void 0 ? void 0 : _userInfo$info6.mobileNumber
        },
        previousProfessionalInformation: (fastPASData === null || fastPASData === void 0 ? void 0 : fastPASData.architectDetail) || ((_data47 = data) === null || _data47 === void 0 ? void 0 : _data47.previousProfessionalInformation)
      };
      console.log("data318", data);
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Old Case Application No")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "APPLICATION NO",
    placeholder: "Enter Application NO.",
    name: "oldCaseApplicationNo",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.oldCaseApplicationNo,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee,
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("oldCaseApplicationNo"))
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Select Module")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "98%",
    control: control,
    label: "Select Module",
    inputLabel: "Select module",
    placeholder: "Select module",
    name: "selectedModule",
    type: "selectInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedModule,
    data: SortingAlphabatically([{
      label: "Plinth",
      value: "Plinth"
    }, {
      label: "Completion",
      value: "Completion"
    }, {
      label: "Revalidation/Time Extension",
      value: "Revalidation/Time Extension"
    }]),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (formData === null || formData === void 0 ? void 0 : formData.selectedModule) || isEmployee || isApproved || watchModule
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority")), isDA ? /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Select Development Authority",
    inputLabel: "Select office",
    placeholder: "Select office",
    name: "selectedOffice",
    type: formData !== null && formData !== void 0 && formData.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedOffice,
    data: SortingAlphabatically(officesList),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })))) : /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "searchSelect",
    data: SortingAlphabatically(avpUnits),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || "",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })), watchUnit ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "searchSelect",
    data: SortingAlphabatically(avpCities),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null))), owners && (owners === null || owners === void 0 ? void 0 : owners.map((owner, index) => {
    var _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo4$o3;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: owner === null || owner === void 0 ? void 0 : owner.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer",
      style: {
        marginTop: "26px"
      }
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, t(`Owner/Applicant ${index + 1} Details`)), index > 0 && !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "right",
        marginBottom: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "remove-owner-btn",
      onClick: () => removeOwner(index)
    }, "\u2716 Remove Owner"))), /*#__PURE__*/React__default.createElement(Container, {
      className: "formInputContainer common-app-form",
      fluid: true
    }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Name",
      control: control,
      placeholder: "Enter Name",
      name: `landInfo.owners.[${index}].name`,
      type: "specialChar",
      allowedChars: "&/, ",
      maxLength: 200,
      onlyAlphabet: true,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Father Name / Husband Name",
      placeholder: "Enter Father Name / Husband Name",
      name: `landInfo.owners.[${index}].fatherOrHusbandName`,
      type: "specialChar",
      allowedChars: "&/, ",
      onlyAlphabet: true,
      maxLength: 200,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: t("Gender"),
      placeholder: t("Gender"),
      name: `landInfo.owners.[${index}].gender`,
      type: "searchSelect",
      data: SortingAlphabatically(genderData),
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[index]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.gender,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "Please select the gender"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      name: `landInfo.owners.[${index}].mobileNumber`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("MobileNo"),
          message: "Please enter valid mobile no"
        }
      },
      disabled: isEmployee || isApproved,
      maxLength: 10
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "E-mail ID",
      control: control,
      placeholder: "Enter E-mail ID",
      name: `landInfo.owners.[${index}].emailId`,
      type: "textInput",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Email"),
          message: "Please enter valid email id"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Aadhaar Number",
      control: control,
      placeholder: "Enter Aadhaar Number",
      name: `landInfo.owners.[${index}].aadhaarNumber`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("AadharNo"),
          message: "Please enter valid Aadhaar no"
        }
      },
      disabled: isEmployee || isApproved,
      maxLength: 12
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "State",
      placeholder: "Select State",
      name: `landInfo.owners.[${index}].correspondenceAddress.state`,
      type: "selectInput",
      disabled: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[index]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : (_formData$landInfo4$o3 = _formData$landInfo4$o2.correspondenceAddress) === null || _formData$landInfo4$o3 === void 0 ? void 0 : _formData$landInfo4$o3.state) || isEmployee || isApproved,
      data: statesName,
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      data: watchState === "Uttar Pradesh" ? updistricts : undefined,
      label: t("LABEL_DISTRICT"),
      placeholder: watchState === "Uttar Pradesh" ? "Select District" : "Enter District",
      name: `landInfo.owners.[${index}].correspondenceAddress.town`,
      type: watchState === "Uttar Pradesh" ? "searchSelect" : "textInput",
      mandatory: true,
      maxLength: 25,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Name"),
          message: "Please enter only letters and spaces"
        }
      },
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Communication Address",
      placeholder: "Enter Communication Address",
      name: `landInfo.owners.[${index}].correspondenceAddress.address`,
      type: "textInput",
      mandatory: true,
      maxLength: 150,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      },
      disabled: isEmployee || isApproved
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      name: `landInfo.owners.[${index}].correspondenceAddress.pinno`,
      type: "number",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        },
        pattern: {
          value: Digit.Utils.getPattern("Pincode"),
          message: "Please enter valid Pin Code"
        }
      },
      maxLength: 6,
      disabled: isEmployee || isApproved
    }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
      className: "custom-upload new-custom-uploader signature-attach-uploader"
    }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(FileUploader$3, {
      control: control,
      name: `signature_${index}`,
      label: "Attach Signature",
      validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
      isMandatory: true,
      required: true,
      tab: 2,
      maxFiles: 1,
      showError: showError
    }))), /*#__PURE__*/React__default.createElement(Col, null, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "add-owner-btn",
      onClick: () => {
        var _formData$professiona;
        return appendOwner({
          ...ownerEntry$2,
          mobileNumber: isOwner ? (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.mobileNumber) || "" : ""
        });
      },
      style: {
        marginTop: "40px"
      }
    }, "+ Add Owner"))), /*#__PURE__*/React__default.createElement("br", null)));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    disabled: loading,
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  })), /*#__PURE__*/React__default.createElement(ScrollButton, null)))));
};

const SubStep4$b = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  t,
  landSubUseTypes,
  landUseListActivities,
  landUsesSchemeTypeList,
  landSubUseTypes2,
  tenantId,
  departmentList,
  schemeTypeData,
  nonSchemeTypeData,
  avpList,
  applicationFlow,
  avpData,
  isEmployee,
  isApproved,
  id,
  isEdit
}) => {
  var _formData$description, _window$location, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description36, _formData$description37;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.plotAreaSite);
  const {
    documents
  } = useSelector(state => state.formMT);
  const isEditMode = Boolean(isEdit || id || (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.id) || typeof window !== "undefined" && ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) && window.location.pathname.includes("/services/oldCaseSearchLU/") && window.location.pathname.split("/services/oldCaseSearchLU/")[1]);
  console.log("FormData1212", formData, isApproved, isEmployee);
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation,
      schemeType: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "",
      roadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.roadWidths) || [{
        value: ""
      }],
      approachRoadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.approachRoadWidths) || [{
        value: ""
      }],
      otherSides: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.otherSides) || [{
        value: ""
      }],
      multipleKhata: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.multipleKhata) || [{
        value: ""
      }],
      khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.khasraDetails) || [{
        district: "",
        tehsil: "",
        village: "",
        plotNo: ""
      }],
      multipleKhasra: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.multipleKhasra) || [{
        khasraNo: "",
        area: ""
      }]
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const handleCoordinateChange = (field, value) => {
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const {
    fields: multipleKhasra,
    append: addKhasra,
    remove: removeKhasra
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra"
  });
  const {
    fields: roadWidthsArray,
    append: addRoadWidthField,
    remove: removeRoadWidthField
  } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths"
  });
  const {
    fields: otherSides,
    append: addOtherSide,
    remove: removeOtherSide
  } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides"
  });
  const {
    fields: approachRoadWidths,
    append: addApproachRoad,
    remove: removeApproachWidth
  } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths"
  });
  const {
    fields: multipleKhata,
    append: addKhata,
    remove: removeKhata
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata"
  });
  const {
    fields: khasraDetails,
    append: addKhasraDetail,
    remove: removeKhasraDetail
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  console.log("departmentListFrom444", schemeTypeData, nonSchemeTypeData);
  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const watchMaster = watch("descriptionOfLand.landUsesType");
  const watchActivityAsPerMap = watch("descriptionOfLand.activityAsPerMap");
  const watchSubLayout = watch("descriptionOfLand.subLandUseAsPerLayout");
  const watchPlanOn = watch("descriptionOfLand.planOn");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const watchGovernmentBuilding = watch("isGovernmentBuilding");
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMSV2(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${formData === null || formData === void 0 ? void 0 : formData.selectedOffice}")]`
  }]);
  const {
    data: {
      BPA: {
        LandUseAvpVillageMasterData: avpVillagesData
      } = {}
    } = {},
    isLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseAvpVillageMasterData",
    filter: `$..Districts[?(@.District=='${formData === null || formData === void 0 ? void 0 : formData.selectedCity}')]`
  }]);
  console.log("loggingVillagesData", villagesData, avpVillagesData);
  const filterTehsilData = (masterData, authority, district) => {
    var _masterData$find, _masterData$find$Dist, _masterData$find$Dist2, _masterData$find$Dist3;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$Dist = _masterData$find.Districts) === null || _masterData$find$Dist === void 0 ? void 0 : (_masterData$find$Dist2 = _masterData$find$Dist.find(item => item.District === district)) === null || _masterData$find$Dist2 === void 0 ? void 0 : (_masterData$find$Dist3 = _masterData$find$Dist2.tehsils) === null || _masterData$find$Dist3 === void 0 ? void 0 : _masterData$find$Dist3.map(item => {
      return {
        name: item.tehsilName,
        label: item.tehsilName,
        value: item.tehsilName
      };
    }) : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterAvpTehsilData = (masterData, district) => {
    var _masterData$find2, _masterData$find2$teh;
    const tehsilArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => item.District === district)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : _masterData$find2$teh.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    return tehsilArray || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    var _masterData$find3, _masterData$find3$Dis, _masterData$find3$Dis2, _masterData$find3$Dis3, _masterData$find3$Dis4, _masterData$find3$Dis5;
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = str => str === null || str === void 0 ? void 0 : str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    const result = tehsil && district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : (_masterData$find3$Dis2 = _masterData$find3$Dis.find(item => (item === null || item === void 0 ? void 0 : item.District) === district)) === null || _masterData$find3$Dis2 === void 0 ? void 0 : (_masterData$find3$Dis3 = _masterData$find3$Dis2.tehsils) === null || _masterData$find3$Dis3 === void 0 ? void 0 : (_masterData$find3$Dis4 = _masterData$find3$Dis3.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find3$Dis4 === void 0 ? void 0 : (_masterData$find3$Dis5 = _masterData$find3$Dis4.villages) === null || _masterData$find3$Dis5 === void 0 ? void 0 : _masterData$find3$Dis5.map(item => {
      const formatted = toTitleCase(item);
      return {
        name: formatted,
        value: formatted,
        label: formatted
      };
    }) : null;
    return result || [];
  };
  const filterAvpVillagesData = (masterData, district, tehsil) => {
    var _masterData$find4, _masterData$find4$teh, _masterData$find4$teh2, _masterData$find4$teh3, _masterData$find4$teh4;
    const villagesArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find4 = masterData.find(item => item.District === district)) === null || _masterData$find4 === void 0 ? void 0 : (_masterData$find4$teh = _masterData$find4.tehsils) === null || _masterData$find4$teh === void 0 ? void 0 : (_masterData$find4$teh2 = _masterData$find4$teh.find(item => item.tehsilName === tehsil)) === null || _masterData$find4$teh2 === void 0 ? void 0 : (_masterData$find4$teh3 = _masterData$find4$teh2.villages) === null || _masterData$find4$teh3 === void 0 ? void 0 : (_masterData$find4$teh4 = _masterData$find4$teh3.map) === null || _masterData$find4$teh4 === void 0 ? void 0 : _masterData$find4$teh4.call(_masterData$find4$teh3, item => ({
      name: item,
      label: item,
      value: item
    }));
  };
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find5, _masterData$find5$Dis;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find5 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find5 === void 0 ? void 0 : (_masterData$find5$Dis = _masterData$find5.Districts) === null || _masterData$find5$Dis === void 0 ? void 0 : _masterData$find5$Dis.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const isSchemeType = watchSchemeType === "Scheme";
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  console.log("upDIstricts", updistricts);
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : _masterData$2$Categor4.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", schemeTypeData, watchMaster, watchSubLayout);
  const plotNo = watch("descriptionOfLand.plotNo");
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(formData === null || formData === void 0 ? void 0 : formData.selectedOffice, nonSchemeTypeData, watchActivityAsPerMap);
  console.log("activityAsPerMap", activityAsPerMap);
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData === null || masterData === void 0 ? void 0 : masterData.filter(item => item.Name === department).map(item => item.ColonyGroups).flat().filter(item => item.ColonyType === planOn).map(item => item.Colonies).flat().map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("schemeFilteredData", schemeNameList);
    return schemeNameList;
  };
  const schemeNames = filterSchemeNames(departmentList, formData === null || formData === void 0 ? void 0 : formData.selectedOffice, watchPlanOn);
  const filterAvpSchemeNames = (unit, city, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C, _masterData$filter$$C2, _masterData$filter$$C3, _masterData$filter$$C4;
    console.log("avpMasterFrom4", masterData, unit, city);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : (_masterData$filter$$C2 = _masterData$filter$$C.filter(item => item.City === city)) === null || _masterData$filter$$C2 === void 0 ? void 0 : (_masterData$filter$$C3 = _masterData$filter$$C2[0]) === null || _masterData$filter$$C3 === void 0 ? void 0 : (_masterData$filter$$C4 = _masterData$filter$$C3.Schemes) === null || _masterData$filter$$C4 === void 0 ? void 0 : _masterData$filter$$C4.map(item => {
      return {
        name: item.SchemeName,
        label: item.SchemeName,
        value: item.SchemeName
      };
    });
    console.log("loggingAVPSchemeNames", result);
    return result;
  };
  const avpSchemeNames = filterAvpSchemeNames(formData === null || formData === void 0 ? void 0 : formData.selectedUnit, formData === null || formData === void 0 ? void 0 : formData.selectedCity, avpData);
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["kmlFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const onSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSubmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleSubTabChange(3, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    var _formData$description11;
    if (formData !== null && formData !== void 0 && (_formData$description11 = formData.descriptionOfLand) !== null && _formData$description11 !== void 0 && _formData$description11.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
      setValue("landInfo.owners[0].permanentAddress.district", formData === null || formData === void 0 ? void 0 : formData.location1);
    }
    setValue("documents", documents);
    if (formData !== null && formData !== void 0 && formData.location1 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.schemeType,
    data: SortingAlphabatically(schemeTypeList),
    disabled: isEmployee || isApproved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 0px",
      fontWeight: "600",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      textAlign: "right",
      color: "rgb(2, 11, 15)",
      padding: "9px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "clickHere",
    onClick: handleClick
  }, "Click here,"), "\xA0to know how to create a .kml file.")))), isSchemeType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 4px",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      backgroundColor: "#f2f2f2",
      color: "red",
      padding: "4px"
    }
  }, "Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission."))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Type of Scheme",
    placeholder: "Select type of scheme",
    name: `descriptionOfLand.planOn`,
    type: formData !== null && formData !== void 0 && (_formData$description13 = formData.descriptionOfLand) !== null && _formData$description13 !== void 0 && _formData$description13.planOn || isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: SortingAlphabatically(proposedSite),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.planOn,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: formData !== null && formData !== void 0 && formData.descriptionOfLand.schemeName || isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.schemeName,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, (formData === null || formData === void 0 ? void 0 : formData.selectedModule) !== "Revalidation/Time Extension" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan",
    inputLabel: "Select a plan.",
    placeholder: isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan",
    name: "descriptionOfLand.landUsesType",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.landUsesType,
    data: SortingAlphabatically(landUseList)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan",
    control: control,
    placeholder: isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan",
    name: "descriptionOfLand.subLandUseAsPerLayout",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(landSubUseList),
    disabled: isEmployee || isApproved,
    mandatory: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.subLandUseAsPerLayout
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, (formData === null || formData === void 0 ? void 0 : formData.selectedModule) !== "Revalidation/Time Extension" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "descriptionOfLand.activityAsPerMap",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.activityAsPerMap,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Activity Proposed"),
    control: control,
    placeholder: t("Select Activity Proposed"),
    name: "descriptionOfLand.activityProposed",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(activityProposed),
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 20,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.activityProposed
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.constructionType,
    type: "searchSelect"
  })), /*#__PURE__*/React__default.createElement(Col, null)), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraDetails.map((item, index) => {
    var _khasraTehsils$index, _khasraTehsils$index2, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35;
    const selectedTehsil = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index = khasraTehsils[index]) === null || _khasraTehsils$index === void 0 ? void 0 : _khasraTehsils$index.tehsil;
    const selectedDistrict = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index2 = khasraTehsils[index]) === null || _khasraTehsils$index2 === void 0 ? void 0 : _khasraTehsils$index2.district;
    const filteredVillages = isDA ? filterVillagesData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict, selectedTehsil) : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
    const tehsils = isDA ? filterTehsilData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict) : filterAvpTehsilData(avpVillagesData, selectedDistrict);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filterDistrictData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority")),
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: !isDA || formData !== null && formData !== void 0 && (_formData$description21 = formData.descriptionOfLand) !== null && _formData$description21 !== void 0 && (_formData$description22 = _formData$description21.khasraDetails) !== null && _formData$description22 !== void 0 && (_formData$description23 = _formData$description22[index]) !== null && _formData$description23 !== void 0 && _formData$description23.district || isEmployee || isApproved ? "textInput" : "searchSelect",
      defaultValue: formData === null || formData === void 0 ? void 0 : formData.location1,
      disabled: isEmployee || isApproved,
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(tehsils),
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : (_formData$description25 = _formData$description24.khasraDetails) === null || _formData$description25 === void 0 ? void 0 : (_formData$description26 = _formData$description25[index]) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.tehsil,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || formData !== null && formData !== void 0 && (_formData$description27 = formData.descriptionOfLand) !== null && _formData$description27 !== void 0 && (_formData$description28 = _formData$description27.khasraDetails) !== null && _formData$description28 !== void 0 && (_formData$description29 = _formData$description28[index]) !== null && _formData$description29 !== void 0 && _formData$description29.tehsil || isEmployee || isApproved ? "textInput" : "searchSelect",
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filteredVillages),
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : (_formData$description31 = _formData$description30.khasraDetails) === null || _formData$description31 === void 0 ? void 0 : (_formData$description32 = _formData$description31[index]) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.village,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || formData !== null && formData !== void 0 && (_formData$description33 = formData.descriptionOfLand) !== null && _formData$description33 !== void 0 && (_formData$description34 = _formData$description33.khasraDetails) !== null && _formData$description34 !== void 0 && (_formData$description35 = _formData$description34[index]) !== null && _formData$description35 !== void 0 && _formData$description35.village || isEmployee || isApproved ? "textInput" : "searchSelect",
      maxLength: 30,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "specialChar",
      allowedChars: "/,-",
      maxLength: 200,
      disabled: isEmployee || isApproved,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => removeKhasraDetail(index),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === khasraDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => addKhasraDetail({
        plotNo: "",
        district: "",
        tehsil: "",
        village: ""
      }),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  }))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(filterDistrictData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority")),
    label: t("LABEL_DISTRICT"),
    placeholder: "Select District",
    name: "landInfo.owners[0].permanentAddress.district",
    type: isDA ? "searchSelect" : "textInput",
    defaultValue: !isDA && (formData === null || formData === void 0 ? void 0 : formData.selectedCity),
    mandatory: true,
    disabled: isEmployee || isApproved,
    isRequired: true,
    validation: {
      required: {
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    name: "descriptionOfLand.plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    decimalScale: 2,
    maxLength: 30,
    disabled: isEmployee || isApproved
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    name: "descriptionOfLand.landArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    maxValue: maxPlotAreaSite,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    decimalScale: 2,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, roadWidthsArray.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: `descriptionOfLand.roadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: roadWidthsArray.length >= 4,
    onClick: () => addRoadWidthField({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), roadWidthsArray.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeRoadWidthField(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))), /*#__PURE__*/React__default.createElement(Col, null, approachRoadWidths.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)",
    placeholder: isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)",
    name: `descriptionOfLand.approachRoadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    sx: {
      Padding: "0px"
    },
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: approachRoadWidths.length >= 4,
    onClick: () => addApproachRoad({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), approachRoadWidths.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeApproachWidth(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("latitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("longitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description36 = formData.descriptionOfLand) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    disabled: isEmployee || isApproved,
    maxLength: 30000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : _formData$description37.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: isEmployee || isApproved,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    data: [{
      label: "Yes",
      value: "yes"
    }, {
      label: "No",
      value: "no"
    }],
    label: t("Is this a Government Building ?"),
    name: "isGovernmentBuilding",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding,
    disabled: isEmployee || isApproved,
    type: "radioButton",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), watchGovernmentBuilding === "yes" ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Government Building"),
    control: control,
    placeholder: t("Select Government Building"),
    data: SortingAlphabatically(governmentBuildingOptions),
    name: "governmentBuildingName",
    mandatory: true,
    disabled: isEmployee || isApproved,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.governmentBuildingName,
    type: "searchSelect"
  })) : /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const Step2$c = ({
  formData,
  isUpdating,
  handleTabChange,
  t,
  initFormMTDocs
}) => {
  var _formData$description2, _formData$description3, _formData$description4, _formData$description5;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  console.log("documentFromRedux", documents, formData);
  console.log("documentsectionRendered");
  const determineRiskType = formData => {
    const {
      activityAsPerMap,
      activityProposed,
      developmentArea,
      landArea,
      schemeType
    } = (formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand) || {};
    let riskType = "HIGH_NIVESH";
    if (activityAsPerMap === "Residential") {
      if (activityProposed === "Multi Unit" || activityProposed === "Group Housing" || activityProposed === "EWS Group Housing" || activityProposed === "LIG Group Housing" || activityProposed === "Affordable Group Housing") {
        riskType = "HIGH_NIVESH";
      } else if (activityProposed === "Row Houses" || activityProposed === "Semi Detached" || activityProposed === "Detached") {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else {
            if (schemeType === "Non Scheme") {
              riskType = "HIGH";
            }
          }
        } else {
          if (schemeType === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeType === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }
    return riskType;
  };
  const riskType = determineRiskType(formData);
  console.log("FinalriskType", riskType);
  const validateFiles = () => {
    var _formData$description;
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" ? ["completeDrawingFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA"] : ["completeDrawingFile", "registrySaleDeedHPTA"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation
    },
    documents: documents
  };
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) === "Scheme";
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    var _formData$documents;
    console.log("insideStep3effect");
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      var _formData$documents2;
      console.log("insideStep3effectIfCondition", formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.length);
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents, formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.schemeType]);
  const onSubmit = data => {
    const allowedDocs = isSchemeType ? ["completeDrawingFile", "kmlFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA", "sajraPlan", "giftDeed", "applicantPhoto", "signature", "approvalLetter", "drawingPdf"] : ["completeDrawingFile", "kmlFile", "developerConsortiumSalesAgreement", "khatauni", "registrySaleDeedHPTA", "mutationLetter", "sajraPlan", "applicantPhoto", "signature", "approvalLetter", "drawingPdf"];
    const conditionalDocs = documents === null || documents === void 0 ? void 0 : documents.filter(doc => {
      var _doc$documentType;
      return allowedDocs.includes(doc.documentType) || ((_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.startsWith("signature_"));
    });
    console.log("conditionalDocs", conditionalDocs);
    data = {
      ...data,
      riskType,
      descriptionOfLand: {
        ...data.descriptionOfLand,
        googleMapCoordinates: coordinate,
        googleMapLocation: googleLocation
      },
      documents: conditionalDocs
    };
    console.log("dataFromstep2", data);
    handleTabChange(2, data);
    console.log("insdieElseFromsubmit", showError);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-3",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including location/site plan, key plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "Upload File",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType && /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Allotment letter/Possession letter",
    control: control,
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMigrated: true
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Developer/Consortium/Sales Agreement",
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Khatauni",
    name: "khatauni",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMandatory: true,
    required: true,
    isMigrated: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Mutation Letter",
    name: "mutationLetter",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1,
    isMigrated: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Site Superimposed on Sajra Plan",
    control: control,
    name: "sajraPlan",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => {
      handleTabChange(0);
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const SubStep3$b = ({
  formData,
  handleSubTabChange,
  t,
  archData,
  validity,
  usersData,
  isEmployee,
  isApproved
}) => {
  var _formData$professiona, _formData$professiona2, _usersData$, _formData$professiona3, _usersData$2, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _usersData$5, _usersData$6, _usersData$7, _formData$professiona10, _formData$professiona11, _formData$previousPro, _formData$previousPro2, _formData$previousPro3, _formData$previousPro4, _formData$previousPro5, _formData$previousPro6, _formData$previousPro7, _formData$previousPro8, _formData$previousPro9, _formData$previousPro10, _formData$previousPro11, _formData$previousPro12, _formData$previousPro13, _formData$previousPro14, _formData$previousPro15;
  console.log("validityFromSUb3", formData, archData, validity, usersData);
  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionalInformation),
      planDate: (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.planDate) || validity,
      licenseNumber: (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.licenseNumber) || (usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : _usersData$.registrationNumber),
      certificateNumber: (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.certificateNumber) || (usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.registrationArchitectNumber)
    },
    previousProfessionalInformation: {
      ...(formData === null || formData === void 0 ? void 0 : formData.previousProfessionalInformation)
    }
  };
  const {
    handleSubmit,
    control
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    var _formData$professiona4, _usersData$3, _usersData$4;
    data = {
      ...data,
      professionalInformation: {
        ...data.professionalInformation,
        consultantCategory: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.consultantCategory,
        licenseNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$3 = usersData[0]) === null || _usersData$3 === void 0 ? void 0 : _usersData$3.registrationNumber,
        planDate: validity,
        certificateNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$4 = usersData[0]) === null || _usersData$4 === void 0 ? void 0 : _usersData$4.registrationArchitectNumber
      },
      previousProfessionalInformation: {
        ...(formData === null || formData === void 0 ? void 0 : formData.previousProfessionalInformation),
        ...data.previousProfessionalInformation
      }
    };
    console.log("dataFromSUb3", data);
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Consultant Category",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.coa) || isEmployee || isApproved,
    placeholder: "Enter Consultant Category",
    name: "professionalInformation.coa",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.coa,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    className: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.coa) ? "input-disabled" : ""
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionalInformation) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.ername) || isEmployee || isApproved,
    placeholder: "Enter Name",
    name: "professionalInformation.ername",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isRequired: true,
    type: "textInput",
    mandatory: true,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Validity",
    control: control,
    placeholder: "Validity",
    name: "professionalInformation.validupto",
    type: "textInput",
    defaultValue: validity,
    disabled: Boolean(validity) || isEmployee || isApproved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Mobile No.",
    control: control,
    placeholder: "Enter Mobile No.",
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionalInformation) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.ermobileNumber) || isEmployee || isApproved,
    name: "professionalInformation.ermobileNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: isEmployee || isApproved,
    label: "Certificate No. (For Minimum Qualification)",
    name: "professionalInformation.erregistrationNumber",
    defaultValue: usersData === null || usersData === void 0 ? void 0 : (_usersData$5 = usersData[0]) === null || _usersData$5 === void 0 ? void 0 : _usersData$5.registrationArchitectNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    height: "30px"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: Boolean(usersData === null || usersData === void 0 ? void 0 : (_usersData$6 = usersData[0]) === null || _usersData$6 === void 0 ? void 0 : _usersData$6.registrationArchitectNumber) || isEmployee || isApproved,
    label: "License No.",
    name: "professionalInformation.certificateNo",
    defaultValue: usersData === null || usersData === void 0 ? void 0 : (_usersData$7 = usersData[0]) === null || _usersData$7 === void 0 ? void 0 : _usersData$7.registrationArchitectNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail Id",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona10 = formData.professionalInformation) === null || _formData$professiona10 === void 0 ? void 0 : _formData$professiona10.eremailId) || isEmployee || isApproved,
    placeholder: "Enter E-mail Id",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona11 = formData.professionalInformation) === null || _formData$professiona11 === void 0 ? void 0 : _formData$professiona11.eremailId,
    name: "professionalInformation.eremailId",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Previous Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Consultant Category",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro = formData.previousProfessionalInformation) === null || _formData$previousPro === void 0 ? void 0 : _formData$previousPro.consultantCategory) || isEmployee || isApproved,
    placeholder: "Enter Consultant Category",
    name: "previousProfessionalInformation.consultantCategory",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro2 = formData.previousProfessionalInformation) === null || _formData$previousPro2 === void 0 ? void 0 : _formData$previousPro2.consultantCategory,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    className: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro3 = formData.previousProfessionalInformation) === null || _formData$previousPro3 === void 0 ? void 0 : _formData$previousPro3.consultantCategory) ? "input-disabled" : ""
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro4 = formData.previousProfessionalInformation) === null || _formData$previousPro4 === void 0 ? void 0 : _formData$previousPro4.architectName) || isEmployee || isApproved,
    placeholder: "Enter Name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro5 = formData.previousProfessionalInformation) === null || _formData$previousPro5 === void 0 ? void 0 : _formData$previousPro5.architectName,
    name: "previousProfessionalInformation.architectName",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isRequired: true,
    type: "textInput",
    mandatory: true,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Validity",
    control: control,
    placeholder: "Validity",
    name: "previousProfessionalInformation.validityUpto",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro6 = formData.previousProfessionalInformation) === null || _formData$previousPro6 === void 0 ? void 0 : _formData$previousPro6.validityUpto,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro7 = formData.previousProfessionalInformation) === null || _formData$previousPro7 === void 0 ? void 0 : _formData$previousPro7.validityUpto) || isEmployee || isApproved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Mobile No.",
    control: control,
    placeholder: "Enter Mobile No.",
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro8 = formData.previousProfessionalInformation) === null || _formData$previousPro8 === void 0 ? void 0 : _formData$previousPro8.mobileNumber) || isEmployee || isApproved,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro9 = formData.previousProfessionalInformation) === null || _formData$previousPro9 === void 0 ? void 0 : _formData$previousPro9.mobileNumber,
    name: "previousProfessionalInformation.mobileNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro10 = formData.previousProfessionalInformation) === null || _formData$previousPro10 === void 0 ? void 0 : _formData$previousPro10.licenseNo) || isEmployee || isApproved,
    label: "Certificate No. (For Minimum Qualification)",
    name: "previousProfessionalInformation.licenseNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro11 = formData.previousProfessionalInformation) === null || _formData$previousPro11 === void 0 ? void 0 : _formData$previousPro11.licenseNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    height: "30px"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro12 = formData.previousProfessionalInformation) === null || _formData$previousPro12 === void 0 ? void 0 : _formData$previousPro12.licenseNo) || isEmployee || isApproved,
    label: "License No.",
    name: "previousProfessionalInformation.licenseNo",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro13 = formData.previousProfessionalInformation) === null || _formData$previousPro13 === void 0 ? void 0 : _formData$previousPro13.licenseNo,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail Id",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$previousPro14 = formData.previousProfessionalInformation) === null || _formData$previousPro14 === void 0 ? void 0 : _formData$previousPro14.emailId) || isEmployee || isApproved,
    placeholder: "Enter E-mail Id",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$previousPro15 = formData.previousProfessionalInformation) === null || _formData$previousPro15 === void 0 ? void 0 : _formData$previousPro15.emailId,
    name: "previousProfessionalInformation.emailId",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const OldLandUsePlinth = ({
  t,
  formData,
  handleSubTabChange,
  handleTabChange,
  isEmployee,
  isApproved
}) => {
  const [showError, setShowError] = useState(false);
  const {
    handleSubmit,
    control
  } = useForm();
  const {
    documents
  } = useSelector(state => state.formMT);
  console.log("formData1111212", formData);
  const validateRequiredDocuments = (documents = []) => {
    const requiredTypes = ["drawingPdf", "approvalLetter"];
    return requiredTypes.every(type => documents.some(doc => doc.documentType === type));
  };
  const onSubmit = data => {
    const isValid = validateRequiredDocuments(documents);
    if (!isValid) {
      setShowError(true);
      return;
    } else {
      data = {
        ...formData,
        documents: documents
      };
      console.log("data", data, documents);
      handleTabChange(1, data);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Drawing PDF"),
    control: control,
    name: "drawingPdf",
    showError: showError,
    maxFiles: 1,
    validationMsg: "(pdf file only and Max file Size 150 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Approval Letter"),
    control: control,
    maxFiles: 1,
    showError: showError,
    name: "approvalLetter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const OldLandUseCompletion = ({
  t,
  formData,
  handleSubTabChange,
  handleTabChange,
  isEmployee,
  isApproved
}) => {
  const [showError, setShowError] = useState(false);
  const {
    handleSubmit,
    control,
    setValue
  } = useForm();
  const {
    documents
  } = useSelector(state => state.formMT);
  const userType = Digit.SessionStorage.get("userType");
  console.log("FormDatastats15155515", formData);
  const validateRequiredDocuments = (documents = []) => {
    const requiredTypes = ["drawingPdf", "approvalLetter"];
    return requiredTypes.every(type => documents.some(doc => doc.documentType === type));
  };
  useEffect(() => {
    if (formData) {
      if (formData !== null && formData !== void 0 && formData.layoutsanctionDate) {
        setValue("layoutsanctionDate", formData === null || formData === void 0 ? void 0 : formData.layoutsanctionDate);
      }
      if (formData !== null && formData !== void 0 && formData.validityDate) {
        setValue("validityDate", formData === null || formData === void 0 ? void 0 : formData.validityDate);
      }
      if (formData !== null && formData !== void 0 && formData.obpassSanctionDate) {
        setValue("obpassSanctionDate", formData === null || formData === void 0 ? void 0 : formData.obpassSanctionDate);
      }
    }
  }, [formData]);
  const onSubmit = data => {
    console.log("DataGOt1y2ty12", data);
    const isValid = validateRequiredDocuments(documents);
    if (!isValid) {
      setShowError(true);
      return;
    } else {
      const finalData = {
        ...formData,
        ...data,
        documents: documents
      };
      console.log("finalData33312", finalData, documents);
      handleTabChange(1, finalData);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Application Details"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction date"),
    control: control,
    placeholder: t("Enter Previous Sanction date"),
    name: "layoutsanctionDate",
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("Previous Sanction Validity date"),
    control: control,
    placeholder: t("Enter Previous Sanction Validity date"),
    name: "validityDate",
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: t("OBPASS Sanction date"),
    control: control,
    placeholder: t("Enter OBPASS Sanction date"),
    name: "obpassSanctionDate",
    type: "datePicker",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: userType !== "citizen"
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Document"))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Drawing PDF"),
    control: control,
    name: "drawingPdf",
    showError: showError,
    maxFiles: 1,
    validationMsg: "(pdf file only and Max file Size 150 MB)",
    required: true
  })), /*#__PURE__*/React__default.createElement(Col, {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: t("Approval Letter"),
    control: control,
    maxFiles: 1,
    showError: showError,
    name: "approvalLetter",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })))), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const SubStep5$1 = ({
  formData,
  module,
  handleSubTabChange,
  handleTabChange,
  t,
  isEmployee,
  isApproved
}) => {
  console.log("module", module);
  return /*#__PURE__*/React__default.createElement("div", null, module === "Plinth" ? /*#__PURE__*/React__default.createElement(OldLandUsePlinth, {
    formData: formData,
    t: t,
    handleSubTabChange: handleSubTabChange,
    handleTabChange: handleTabChange,
    isApproved: isApproved,
    isEmployee: isEmployee
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OldLandUseCompletion, {
    formData: formData,
    handleSubTabChange: handleSubTabChange,
    handleTabChange: handleTabChange,
    isApproved: isApproved,
    isEmployee: isEmployee,
    t: t
  })));
};

const OldLandUse = () => {
  const {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    setSubActiveTab,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo,
    selectedModule
  } = useLandUseLogic$1();
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList
  });
  console.log(applicationData, params, validity, "app_data");
  const applicationNumber = params === null || params === void 0 ? void 0 : params.applicationNo;
  const [subLabelsList, setSubLabelsList] = React__default.useState(subTabLabels);
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  useEffect(() => {
    if (selectedModule) {
      setSubLabelsList(prev => [...prev, {
        text: selectedModule
      }]);
    }
  }, [selectedModule]);
  useEffect(() => {
    var _applicationData$docu2;
    setParams(applicationData);
    if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu2 = applicationData.documents) === null || _applicationData$docu2 === void 0 ? void 0 : _applicationData$docu2.length) > 0) {
      initFormMTDocs(applicationData.documents);
    } else {
      resetFormMTDocs();
    }
  }, [id, isAppDataLoading]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$g, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            applicationFlow: applicationFlow,
            officesList: officesList,
            avpData: avpData,
            avpUnits: avpUnits,
            setParams: setParams,
            initFormMTDocs: initFormMTDocs,
            setShowToast: setShowToast,
            usersData: usersData
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$b, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            archData: archData,
            validity: validity,
            usersData: usersData
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$b, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            landSubUseTypes: landSubUses,
            landUseListActivities: landUseListActivities,
            landUsesSchemeTypeList: landUsesSchemeList,
            landSubUseTypes2: landSubUseTypes2,
            tenantId: tenantId,
            departmentList: departmentList,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            avpList: avpList,
            applicationFlow: applicationFlow,
            avpData: avpData,
            id: id,
            isEdit: Boolean(id || (params === null || params === void 0 ? void 0 : params.applicationNo))
          });
        case 3:
          return /*#__PURE__*/React__default.createElement(SubStep5$1, {
            formData: params,
            module: selectedModule,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$c, {
        formData: params,
        isUpdating: updateApiCall.isLoading,
        handleTabChange: handleTabChange,
        t: t,
        initFormMTDocs: initFormMTDocs
      });
    }
    if (activeTab === 2 && applicationNumber) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$2, {
        style: {
          marginTop: "20px"
        }
      }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
        formType: "formLandUse",
        id: applicationNumber,
        ref: summaryRef,
        logoData: applicationFlow == "DA" ? daLogo : avpLogo,
        oldCaseSearch: true
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#000"
          }
        }, "Print Summary"),
        content: () => summaryRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => {
          handleTabChange(0);
          handleSubTabChange(0);
        }
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: "#000"
        },
        onClick: () => handleTabChange(4, params)
      })))));
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id) {
    var _params$landInfo, _params$landInfo$owne, _params$landInfo$owne2, _params$landInfo$owne3;
    if (!(params !== null && params !== void 0 && (_params$landInfo = params.landInfo) !== null && _params$landInfo !== void 0 && (_params$landInfo$owne = _params$landInfo.owners) !== null && _params$landInfo$owne !== void 0 && (_params$landInfo$owne2 = _params$landInfo$owne[0]) !== null && _params$landInfo$owne2 !== void 0 && (_params$landInfo$owne3 = _params$landInfo$owne2.correspondenceAddress) !== null && _params$landInfo$owne3 !== void 0 && _params$landInfo$owne3.town)) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      padding: "20px"
    },
    className: "bg-white"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formStripLandUse mb-3 border-0"
  }, /*#__PURE__*/React__default.createElement("h2", null, "Land Use for Old Cases")), /*#__PURE__*/React__default.createElement("div", {
    className: "main-panel-corner land-use-corner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "left-corner"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => setActiveTab(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, primaryTab.map((item, index) => /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    key: `${item.text}.${index}`,
    label: item.text
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "right-corner"
  }, /*#__PURE__*/React__default.createElement("div", null, activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subLabelsList === null || subLabelsList === void 0 ? void 0 : subLabelsList.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent()))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const CompletionApplications = () => {
  var _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const citizenBaseUrl = "/digit-ui/citizen";
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [selectedAction, setSelectedAction] = useState("All");
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [migratedData, setMigratedData] = useState(null);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const mobileNumber = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber;
  const {
    data,
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_COMPLETION",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "MAP_SUB"
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.completionShortfallCertificateUrl;
    window.open(objectionLetterUrl, "_blank");
  };
  const handleRejectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const rejectionLetterUrl = item === null || item === void 0 ? void 0 : item.completionRejectionCertificateUrl;
    window.open(rejectionLetterUrl, "_blank");
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearch({
        mobileNumber
      });
      setMigratedData(response === null || response === void 0 ? void 0 : response.ApplicationList);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchMigratedData();
  }, []);
  const handleActionChange = action => {
    setSelectedAction(action);
    setCurentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  function getApprovalLetter(item) {
    const pdfUrl = (item === null || item === void 0 ? void 0 : item.approvalCertificateUrl) || (item === null || item === void 0 ? void 0 : item.completionApprovalCertificateUrl);
    window.open(pdfUrl, "_blank");
  }
  function getInitiationLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.farInimationLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo$owners3, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : (_item$landInfo$owners3 = _item$landInfo$owners2.name) === null || _item$landInfo$owners3 === void 0 ? void 0 : _item$landInfo$owners3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.BPA) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$auditDetails2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.mobileNumber) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails3;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-status"
      }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-resubmit"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/edcrPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-receipt"
      }, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate = item.taxHeadEstimates) === null || _item$taxHeadEstimate === void 0 ? void 0 : _item$taxHeadEstimate[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
          history.push({
            pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")));
    }
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.completionShortfallCertificateUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "rejectionLetter",
    label: "Rejection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.completionRejectionCertificateUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleRejectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "proposalLetter",
    label: "Proposal Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-proposal"
    }, (item === null || item === void 0 ? void 0 : item.proposalUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.proposalUrl, "_blank")
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-approval"
      }, (item === null || item === void 0 ? void 0 : item.status) === "APPROVED" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate2 = item.taxHeadEstimates) === null || _item$taxHeadEstimate2 === void 0 ? void 0 : _item$taxHeadEstimate2[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getApprovalLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "initiationLetter",
    label: "Initiation Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-initiation"
    }, (item === null || item === void 0 ? void 0 : item.farInimationLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getInitiationLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "nocStatus",
    label: "NOC Status",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-noc"
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        Digit.SessionStorage.set("nocAppData", item);
        history.push(`${citizenBaseUrl}/obps/nocApplications/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        if (item.planOn === "SELF_MAP") {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/selfResidentialPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        } else {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/completionPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => {
        var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleClickAction = item => {
    var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const viewModal = item => {
    if (item !== null && item !== void 0 && item.applicationnumber) {
      setIdData(item === null || item === void 0 ? void 0 : item.applicationnumber);
      setshowMs(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: tabIndex,
    onChange: handleTabChange,
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "New Applications"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Archive Old Applications"
  }))), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 0,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption .mapsub-my-applications"
  }, "Completion - My Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), " (", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 1,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container archieve-old-table"
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "5%"
    }
  }, "Sr No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Owner Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Owner Mobile Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Application Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "View Summary"))), /*#__PURE__*/React__default.createElement("tbody", null, migratedData === null || migratedData === void 0 ? void 0 : migratedData.map((item, index) => {
    var _item$applicationdeta, _item$applicationdeta2, _item$applicationdeta3, _item$applicationdeta4, _item$applicationdeta5, _item$applicationdeta6;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item === null || item === void 0 ? void 0 : item.applicationNo
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta = item.applicationdetails) === null || _item$applicationdeta === void 0 ? void 0 : (_item$applicationdeta2 = _item$applicationdeta.data) === null || _item$applicationdeta2 === void 0 ? void 0 : (_item$applicationdeta3 = _item$applicationdeta2.ownerDetail) === null || _item$applicationdeta3 === void 0 ? void 0 : _item$applicationdeta3.ownerName), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta4 = item.applicationdetails) === null || _item$applicationdeta4 === void 0 ? void 0 : (_item$applicationdeta5 = _item$applicationdeta4.data) === null || _item$applicationdeta5 === void 0 ? void 0 : (_item$applicationdeta6 = _item$applicationdeta5.ownerDetail) === null || _item$applicationdeta6 === void 0 ? void 0 : _item$applicationdeta6.ownerContactNo), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textDecoration: "underline blue 1px",
        cursor: "pointer",
        border: "1px solid #ddd",
        padding: "8px"
      },
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationnumber}`
        });
      }
    }, item === null || item === void 0 ? void 0 : item.applicationnumber), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => viewModal(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: 10,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), showMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showMs,
    onClose: () => {
      setshowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(MigratedSummary, {
    id: idData
  })), smShowMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  })));
};

const filterCategory$2 = roles => {
  console.log("rolesFromFilter", roles);
  if (roles) {
    var _roles$filter$, _roles$filter$2;
    const result = (_roles$filter$ = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$ === void 0 ? void 0 : _roles$filter$.name;
    console.log("resultFromFIlter", result, roles);
    return (_roles$filter$2 = roles.filter(item => item.name !== "Citizen")[0]) === null || _roles$filter$2 === void 0 ? void 0 : _roles$filter$2.name;
  }
};

const useLandUseData$2 = ({
  id,
  tenantId,
  userInfo,
  usersData,
  applicationFlow,
  validity,
  userUid
}) => {
  var _data$LandUse, _usersData$, _usersData$2;
  const isEditMode = !!id;
  console.log("logginFromNewHookCreate", id, isEditMode);
  const consultantCategory = filterCategory$2(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearchFormLandUse(tenantId, {
      applicationNo: id
    });
  };
  const {
    data,
    isLoading: isAppDataLoading,
    isSuccess
  } = useQuery({
    queryKey: ["landUseData", id],
    queryFn: fetchApplicationData,
    enabled: isEditMode
  });
  const applicationData = isEditMode && isSuccess ? data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0] : {
    tenantId,
    professionalInformation: {
      name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
      mobileNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber,
      consultantCategory: consultantCategory,
      emailId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.emailId,
      planDate: validity,
      address: {
        address: userInfo === null || userInfo === void 0 ? void 0 : userInfo.permanentAddress,
        district: null,
        state: null
      },
      certificateNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : _usersData$.registrationArchitectNumber,
      licenseNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.registrationNumber,
      planDate: validity
    },
    department: applicationFlow,
    landAreaDetails: {
      city: null,
      locality: null,
      village: null,
      areaType: null
    },
    descriptionOfLand: {
      revenueVillageMohal: null,
      propertyType: null,
      khataNo: null,
      multipleKhasra: [{
        khasraNo: "",
        area: ""
      }],
      khatauniNo: null,
      areaForCluSqM: 0,
      nameofConcerned: null,
      natureOfTower: null,
      towerToBeProposed: null,
      proposedGoundCoverageSqM: null,
      whetherUsedBySingleCompany: null,
      installationFeesDeposited: null,
      nameofConcerned: null,
      sectorNo: null,
      schemeName: null,
      approachRoadWidths: null,
      totalPlotArea: 0,
      appliedLandUse: {
        name: null
      },
      whetherUsedBySingleCompany: null,
      propertyType: {
        name: null
      },
      installationFeesDeposited: null,
      isChangeOfLandInvolved: null,
      typeOfCLUInvolved: {
        name: null
      }
    },
    activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
    applicationType: "FORM_LANDUSECONVERSION",
    feeType: "ApplicationFee",
    workflow: {
      action: "INITIATE"
    },
    landInfo: {
      owners: [{
        name: null,
        fatherOrHusbandName: null,
        aadhaarNumber: "",
        mobileNumber: "",
        emailId: "",
        gender: null,
        correspondenceAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "CORRESPONDENCE"
        },
        permanentAddress: {
          applicantName: null,
          applicantGuardianName: null,
          state: "",
          district: null,
          tehsil: null,
          town: null,
          address: "",
          pinno: "",
          type: "PERMANENT"
        }
      }],
      tenantId
    },
    nocDetails: {
      applicantNOCData: null,
      additionalApplicantNOC: null,
      officerNOCData: null,
      additionalOfficerNOC: null,
      checkedByOfficer: null
    },
    businessService: null,
    documents: [],
    uiFlow: {
      flow: "Form_LANDUSE"
    }
  };
  return {
    applicationData,
    isAppDataLoading
  };
};

const useLandUseLogic$2 = () => {
  var _Digit, _Digit2, _cities$filter, _cities$filter$, _cities$filter$$bound, _cities$filter2, _cities$filter2$, _cities$filter2$$boun;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    formType
  } = useParams();
  console.log(useParams(), "paramsHook");
  const tenantId = Digit.ULBService.getStateId() || "up";
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const id = authority ? `${authority}/${plan}/${form}/${year}/${serial}` : undefined;
  console.log("idFromLogic", id);
  const Modal = useModal();
  const dispatch = useDispatch();
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const [usersData, setUsersData] = useState([]);
  const [validity, setvalidity] = useState("");
  const {
    documents
  } = useSelector(state => state.formMT);
  const userUid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
  console.log("applicationFlowFromLogic", applicationFlow, userInfo);
  const consultantCategory = filterCategory$2(userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles);
  useEffect(() => {
    const searchUser = async () => {
      try {
        var _response$user;
        const response = await Digit.UserService.userSearch(tenantId, {
          uuid: [userUid]
        }, {});
        console.log("searchUser:", response);
        setUsersData(response === null || response === void 0 ? void 0 : response.user);
        if ((response === null || response === void 0 ? void 0 : (_response$user = response.user) === null || _response$user === void 0 ? void 0 : _response$user.length) > 0) {
          var _response$user2, _response$user2$;
          const expiryDate = (response === null || response === void 0 ? void 0 : (_response$user2 = response.user) === null || _response$user2 === void 0 ? void 0 : (_response$user2$ = _response$user2[0]) === null || _response$user2$ === void 0 ? void 0 : _response$user2$.validUpto).split(" ")[0];
          console.log("expiryDateFromLogic", expiryDate);
          setvalidity(expiryDate);
        }
      } catch (error) {
        console.error("Error during user search:", error);
      }
    };
    searchUser();
  }, [tenantId, userUid, setvalidity]);
  const {
    applicationData,
    isAppDataLoading
  } = useLandUseData$2({
    id,
    tenantId,
    userInfo,
    usersData,
    applicationFlow,
    validity,
    userUid
  });
  const summaryRef = useRef();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORMLANDUSE", applicationData);
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("LANDUSE_CURRENT_TAB")) || 0);
  const [subActiveTab, setSubActiveTab] = useState(((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("LANDUSE_CURRENT_SUBTAB")) || 0);
  const [showToast, setShowToast] = useState(null);
  const [archData, setArchData] = useState({});
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in params)) {
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse = result.LandUse) === null || _result$LandUse === void 0 ? void 0 : _result$LandUse.length) > 0) {
            onSelect("", {
              ...data,
              ...result.LandUse[0]
            }, true);
            setShowToast({
              key: "success",
              message: `Data has been saved successfully!`
            });
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            key: "true",
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        try {
          if (activeTab === 2 || nextTabNo === 4) {
            var _formData$description, _formData$nocDetails, _formData$nocDetails$, _formData$nocDetails2, _formData$nocDetails3, _Digit3, _Digit4, _Digit5;
            console.log("insideActiveTab3", activeTab, nextTabNo);
            let redirectUrl = "";
            let message = "";
            const riskType = formData === null || formData === void 0 ? void 0 : formData.riskType;
            const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
            console.log("riskingTypeFrom", riskType, isLowRiskCase);
            const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
            const isNoc = (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : (_formData$nocDetails$ = _formData$nocDetails.additionalApplicantNOC) === null || _formData$nocDetails$ === void 0 ? void 0 : _formData$nocDetails$.length) > 0 || (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.applicantNOCData) && Object.keys(formData === null || formData === void 0 ? void 0 : (_formData$nocDetails3 = formData.nocDetails) === null || _formData$nocDetails3 === void 0 ? void 0 : _formData$nocDetails3.applicantNOCData).some(key => {
              var _formData$nocDetails4;
              return (formData === null || formData === void 0 ? void 0 : (_formData$nocDetails4 = formData.nocDetails) === null || _formData$nocDetails4 === void 0 ? void 0 : _formData$nocDetails4.applicantNOCData[key]) === true;
            });
            if (isLowRiskCase) {
              data.nocDetails = {};
            }
            const validation = validateSummaryForm({
              formType: "FORMLANDUSECONVERSION",
              formData: data,
              reduxDocuments: documents,
              t
            });
            if (!validation.isValid) {
              Modal("Missing Mandatory Fields", validation.errorHtml, "error");
              return;
            }
            data.workflow = {
              action: "FORWARD_TO_DEPARTMENT",
              assignes: null
            };
            redirectUrl = "/digit-ui/citizen/profile";
            message = "Application forwarded to department";
            console.log("logBeforeLandUSeupdate", data, redirectUrl);
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                onSelect("", data);
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
            console.log("messageFromLU", message);
            Modal("Application Forwarded to department successfully!", `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> forwarded Successfully!`, "success", redirectUrl);
            clearParams();
            (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("FORMLANDUSE");
            (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("LANDUSE_CURRENT_TAB");
            (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("LANDUSE_CURRENT_SUBTAB");
          } else {
            console.log("insideELseACTIVETAB", activeTab, nextTabNo);
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: null
            };
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: () => {
                var _Digit6;
                onSelect("", data);
                setActiveTab(nextTabNo);
                (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
              },
              onError: () => {
                setShowToast({
                  error: true,
                  message: `Something went wrong, please try again!`
                });
              }
            });
          }
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      }
    } else {
      var _Digit7;
      setActiveTab(nextTabNo);
      (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.set("LANDUSE_CURRENT_TAB", nextTabNo);
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    console.log("subTabChange", params, formData);
    if (formData) {
      const data = {
        ...params,
        ...formData
      };
      if (activeTab === 0 && subActiveTab === 0 && !("applicationNo" in params)) {
        console.log("dataFromIf", data);
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(result => {
          var _result$LandUse2;
          if ((result === null || result === void 0 ? void 0 : (_result$LandUse2 = result.LandUse) === null || _result$LandUse2 === void 0 ? void 0 : _result$LandUse2.length) > 0) {
            console.log("landuseResult", result === null || result === void 0 ? void 0 : result.LandUse);
            onSelect("", {
              ...formData,
              ...result.LandUse[0]
            }, "");
            setShowToast({
              key: "success",
              message: `Application Created Successfully!`
            });
            setSubActiveTab(nextSubTab);
            Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
          }
        }).catch(e => {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        });
      } else {
        try {
          console.log("insideELse", data);
          data.workflow = {
            action: "UPLOAD_DOC",
            assignes: null
          };
          updateApiCall.mutate({
            LandUse: data
          }, {
            onSuccess: result => {
              var _result$LandUse3;
              if ((result === null || result === void 0 ? void 0 : (_result$LandUse3 = result.LandUse) === null || _result$LandUse3 === void 0 ? void 0 : _result$LandUse3.length) > 0) {
                onSelect("", result.LandUse[0]);
                setShowToast({
                  key: "success",
                  message: `Data has been saved successfully!`
                });
                setSubActiveTab(nextSubTab);
                Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
              }
            },
            onError: () => {
              setShowToast({
                error: true,
                message: `Something went wrong!`
              });
            }
          });
        } catch (error) {
          setShowToast({
            error: true,
            message: `Something went wrong!`
          });
        }
      }
    } else {
      console.log("inElseSubtab", nextSubTab);
      setSubActiveTab(nextSubTab);
      Digit.SessionStorage.set("LANDUSE_CURRENT_SUBTAB", nextSubTab);
    }
  };
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const {
    data: {
      BPA: {
        Organizations: departmentList
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      BPA: {
        AVPSchemesUnitData: avpData
      } = {}
    } = {},
    isLoading: isAvpDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["AVPSchemesUnitData"]);
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const avpUnits = avpData === null || avpData === void 0 ? void 0 : avpData.map(item => {
    return {
      name: item.Unit,
      label: item.Unit,
      value: item.Unit
    };
  });
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  console.log("logoData", {
    logoStore,
    avpLogo,
    daLogo
  });
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const avpAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter = cities.filter(district => {
    var _district$code;
    return (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes("up.avp");
  })) === null || _cities$filter === void 0 ? void 0 : (_cities$filter$ = _cities$filter[0]) === null || _cities$filter$ === void 0 ? void 0 : (_cities$filter$$bound = _cities$filter$.boundary) === null || _cities$filter$$bound === void 0 ? void 0 : _cities$filter$$bound.filter(ele => ele.hasOwnProperty("location")) : [];
  const daAuthorityList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : (_cities$filter2 = cities.filter(district => {
    var _district$code2;
    return (_district$code2 = district.code) === null || _district$code2 === void 0 ? void 0 : _district$code2.includes("up.da");
  })) === null || _cities$filter2 === void 0 ? void 0 : (_cities$filter2$ = _cities$filter2[0]) === null || _cities$filter2$ === void 0 ? void 0 : (_cities$filter2$$boun = _cities$filter2$.boundary) === null || _cities$filter2$$boun === void 0 ? void 0 : _cities$filter2$$boun.filter(ele => ele.hasOwnProperty("location")) : [];
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const officeNames = completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  console.log("MDMS_Department_Data", schemeTypeData, nonSchemeTypeData);
  console.log("authoritiesNameMDMS", departmentList);
  const daList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "DA");
  const avpList = departmentList === null || departmentList === void 0 ? void 0 : departmentList.filter(item => item.Type == "AVP");
  const officesList = applicationFlow == "DA" ? filterDepartmentsList(daList) : filterDepartmentsList(avpList);
  console.log("fromLandUseLogic", officesList, applicationFlow);
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs();
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null);
  };
  return {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setSubActiveTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo
  };
};

const ownerEntry$3 = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE"
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT"
  }
};
const SubStep1$h = ({
  formData,
  handleSubTabChange,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  id,
  setParams,
  initFormMTDocs,
  setShowToast
}) => {
  var _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _watchOffice$split$, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo4$o3;
  const {
    documents
  } = useSelector(state => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const {
    t
  } = useTranslation();
  const defaultValues = {
    ...formData,
    department: applicationFlow,
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry$3]
    },
    documents: documents
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = isDistrictDataLoading ? [] : districtData.map(district => ({
    label: district.name,
    value: district.name,
    name: district.name
  }));
  console.log("upDIstricts", updistricts);
  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    trigger,
    getValues
  } = useForm({
    defaultValues
  });
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  const watchState = watch(`landInfo.owners.[0].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || (formData === null || formData === void 0 ? void 0 : formData.selectedOffice);
  const watchSelectedOffice = isDA ? watchOffice === null || watchOffice === void 0 ? void 0 : watchOffice.split(" ")[0] : watchOffice === null || watchOffice === void 0 ? void 0 : (_watchOffice$split$ = watchOffice.split(",")[1]) === null || _watchOffice$split$ === void 0 ? void 0 : _watchOffice$split$.trim();
  const watchUnit = watch("selectedUnit") || (formData === null || formData === void 0 ? void 0 : formData.selectedUnit);
  const watchCity = watch("selectedCity") || (formData === null || formData === void 0 ? void 0 : formData.selectedCity);
  const filterCities = (unit, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C;
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : _masterData$filter$$C.map(item => {
      return {
        name: item.City,
        label: item.City,
        value: item.City
      };
    });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);
  const handleSearchClick = async applicationNo => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        var _response, _response$BPA, _response2, _response2$BPA, _response2$BPA$, _response3, _response3$BPA, _response3$BPA$filter, _data, _data$documents, _data2, _data2$additionalDeta, _data3, _data4, _data5, _data6, _data6$landInfo, _data6$landInfo$owner, _data6$landInfo$owner2, _data7, _data7$landInfo, _data7$landInfo$owner, _data7$landInfo$owner2, _data8, _data8$landInfo, _data8$landInfo$owner, _data8$landInfo$owner2, _data9, _data9$landInfo, _data9$landInfo$owner, _data9$landInfo$owner2, _data10, _data10$landInfo, _data10$landInfo$owne, _data10$landInfo$owne2, _data11, _data11$landInfo, _data11$landInfo$owne, _data11$landInfo$owne2, _data11$landInfo$owne3, _data12, _data12$landInfo, _data12$landInfo$owne, _data12$landInfo$owne2, _data12$landInfo$owne3, _data13, _data13$landInfo, _data13$landInfo$owne, _data13$landInfo$owne2, _data13$landInfo$owne3, _data14, _data14$landInfo, _data14$landInfo$owne, _data14$landInfo$owne2, _data15, _data15$landInfo, _data15$landInfo$owne, _data15$landInfo$owne2, _data15$landInfo$owne3;
        response = await Digit.OBPSService.BPAFastPASSearch({
          land_Id: applicationNo
        });
        console.log(response, "responsefromId");
        if (((_response = response) === null || _response === void 0 ? void 0 : (_response$BPA = _response.BPA) === null || _response$BPA === void 0 ? void 0 : _response$BPA.length) === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`
          });
          return;
        } else if (((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$BPA = _response2.BPA) === null || _response2$BPA === void 0 ? void 0 : (_response2$BPA$ = _response2$BPA[0]) === null || _response2$BPA$ === void 0 ? void 0 : _response2$BPA$.department) !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`
          });
          return;
        }
        data = (_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$BPA = _response3.BPA) === null || _response3$BPA === void 0 ? void 0 : (_response3$BPA$filter = _response3$BPA.filter(item => item.applicationType === "FORM_LANDUSE")) === null || _response3$BPA$filter === void 0 ? void 0 : _response3$BPA$filter[0];
        Digit.SessionStorage.set("FASTPAS_CONVERSION", data);
        setFastPasData(data);
        const drawingPdfs = (_data = data) === null || _data === void 0 ? void 0 : (_data$documents = _data.documents) === null || _data$documents === void 0 ? void 0 : _data$documents.filter(e => e.documentType === "drawingPdf");
        if (data) {
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`
          });
        }
        const architect = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$additionalDeta = _data2.additionalDetails) === null || _data2$additionalDeta === void 0 ? void 0 : _data2$additionalDeta.professionalInformation;
        const descriptionOfLand = (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.descriptionOfLand;
        const documents = (_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.documents;
        setValue("selectedOffice", (_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.selectedOffice);
        setValue("landInfo.owners.[0].emailId", (_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$landInfo = _data6.landInfo) === null || _data6$landInfo === void 0 ? void 0 : (_data6$landInfo$owner = _data6$landInfo.owners) === null || _data6$landInfo$owner === void 0 ? void 0 : (_data6$landInfo$owner2 = _data6$landInfo$owner[0]) === null || _data6$landInfo$owner2 === void 0 ? void 0 : _data6$landInfo$owner2.emailId);
        setValue("landInfo.owners.[0].mobileNumber", (_data7 = data) === null || _data7 === void 0 ? void 0 : (_data7$landInfo = _data7.landInfo) === null || _data7$landInfo === void 0 ? void 0 : (_data7$landInfo$owner = _data7$landInfo.owners) === null || _data7$landInfo$owner === void 0 ? void 0 : (_data7$landInfo$owner2 = _data7$landInfo$owner[0]) === null || _data7$landInfo$owner2 === void 0 ? void 0 : _data7$landInfo$owner2.mobileNumber);
        setValue("landInfo.owners.[0].fatherOrHusbandName", (_data8 = data) === null || _data8 === void 0 ? void 0 : (_data8$landInfo = _data8.landInfo) === null || _data8$landInfo === void 0 ? void 0 : (_data8$landInfo$owner = _data8$landInfo.owners) === null || _data8$landInfo$owner === void 0 ? void 0 : (_data8$landInfo$owner2 = _data8$landInfo$owner[0]) === null || _data8$landInfo$owner2 === void 0 ? void 0 : _data8$landInfo$owner2.fatherOrHusbandName);
        setValue("landInfo.owners.[0].gender", (_data9 = data) === null || _data9 === void 0 ? void 0 : (_data9$landInfo = _data9.landInfo) === null || _data9$landInfo === void 0 ? void 0 : (_data9$landInfo$owner = _data9$landInfo.owners) === null || _data9$landInfo$owner === void 0 ? void 0 : (_data9$landInfo$owner2 = _data9$landInfo$owner[0]) === null || _data9$landInfo$owner2 === void 0 ? void 0 : _data9$landInfo$owner2.gender);
        setValue("landInfo.owners.[0].name", (_data10 = data) === null || _data10 === void 0 ? void 0 : (_data10$landInfo = _data10.landInfo) === null || _data10$landInfo === void 0 ? void 0 : (_data10$landInfo$owne = _data10$landInfo.owners) === null || _data10$landInfo$owne === void 0 ? void 0 : (_data10$landInfo$owne2 = _data10$landInfo$owne[0]) === null || _data10$landInfo$owne2 === void 0 ? void 0 : _data10$landInfo$owne2.name);
        setValue("landInfo.owners.[0].correspondenceAddress.state", (_data11 = data) === null || _data11 === void 0 ? void 0 : (_data11$landInfo = _data11.landInfo) === null || _data11$landInfo === void 0 ? void 0 : (_data11$landInfo$owne = _data11$landInfo.owners) === null || _data11$landInfo$owne === void 0 ? void 0 : (_data11$landInfo$owne2 = _data11$landInfo$owne[0]) === null || _data11$landInfo$owne2 === void 0 ? void 0 : (_data11$landInfo$owne3 = _data11$landInfo$owne2.correspondenceAddress) === null || _data11$landInfo$owne3 === void 0 ? void 0 : _data11$landInfo$owne3.state);
        setValue("landInfo.owners.[0].correspondenceAddress.address", (_data12 = data) === null || _data12 === void 0 ? void 0 : (_data12$landInfo = _data12.landInfo) === null || _data12$landInfo === void 0 ? void 0 : (_data12$landInfo$owne = _data12$landInfo.owners) === null || _data12$landInfo$owne === void 0 ? void 0 : (_data12$landInfo$owne2 = _data12$landInfo$owne[0]) === null || _data12$landInfo$owne2 === void 0 ? void 0 : (_data12$landInfo$owne3 = _data12$landInfo$owne2.correspondenceAddress) === null || _data12$landInfo$owne3 === void 0 ? void 0 : _data12$landInfo$owne3.address);
        setValue("landInfo.owners.[0].correspondenceAddress.district", (_data13 = data) === null || _data13 === void 0 ? void 0 : (_data13$landInfo = _data13.landInfo) === null || _data13$landInfo === void 0 ? void 0 : (_data13$landInfo$owne = _data13$landInfo.owners) === null || _data13$landInfo$owne === void 0 ? void 0 : (_data13$landInfo$owne2 = _data13$landInfo$owne[0]) === null || _data13$landInfo$owne2 === void 0 ? void 0 : (_data13$landInfo$owne3 = _data13$landInfo$owne2.correspondenceAddress) === null || _data13$landInfo$owne3 === void 0 ? void 0 : _data13$landInfo$owne3.town);
        setValue("landInfo.owners.[0].aadhaarNumber", (_data14 = data) === null || _data14 === void 0 ? void 0 : (_data14$landInfo = _data14.landInfo) === null || _data14$landInfo === void 0 ? void 0 : (_data14$landInfo$owne = _data14$landInfo.owners) === null || _data14$landInfo$owne === void 0 ? void 0 : (_data14$landInfo$owne2 = _data14$landInfo$owne[0]) === null || _data14$landInfo$owne2 === void 0 ? void 0 : _data14$landInfo$owne2.aadhaarNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", (_data15 = data) === null || _data15 === void 0 ? void 0 : (_data15$landInfo = _data15.landInfo) === null || _data15$landInfo === void 0 ? void 0 : (_data15$landInfo$owne = _data15$landInfo.owners) === null || _data15$landInfo$owne === void 0 ? void 0 : (_data15$landInfo$owne2 = _data15$landInfo$owne[0]) === null || _data15$landInfo$owne2 === void 0 ? void 0 : (_data15$landInfo$owne3 = _data15$landInfo$owne2.correspondenceAddress) === null || _data15$landInfo$owne3 === void 0 ? void 0 : _data15$landInfo$owne3.pinno);
        setValue("professionalInformation.name", architect === null || architect === void 0 ? void 0 : architect.name);
        setValue("professionalInformation.planDate", architect === null || architect === void 0 ? void 0 : architect.planDate);
        setValue("professionalInformation.mobileNumber", architect === null || architect === void 0 ? void 0 : architect.mobileNumber);
        setValue("professionalInformation.emailId", architect === null || architect === void 0 ? void 0 : architect.emailId);
        setValue("professionalInformation.licenseNumber", architect === null || architect === void 0 ? void 0 : architect.licenseNumber);
        setValue("professionalInformation.consultantCategory", architect === null || architect === void 0 ? void 0 : architect.consultantCategory);
        setValue("descriptionOfLand.landArea", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea);
        setValue("descriptionOfLand.plotAreaDoc", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotAreaDoc);
        setValue("descriptionOfLand.developmentArea", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.developmentArea);
        setValue("descriptionOfLand.landUsesType", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUsesType);
        setValue("descriptionOfLand.subLandUseAsPerLayout", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout);
        setValue("descriptionOfLand.landMark", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark);
        setValue("descriptionOfLand.activityAsPerMap", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.activityAsPerMap);
        setValue("descriptionOfLand.activityProposed", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.activityProposed);
        setValue("descriptionOfLand.landAddress", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress);
        setValue("descriptionOfLand.schemeType", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeType);
        setValue("descriptionOfLand.planOn", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.planOn);
        setValue("descriptionOfLand.schemeName", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName);
        setValue("descriptionOfLand.longitude", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude);
        setValue("descriptionOfLand.latitude", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude);
        setValue("descriptionOfLand.khasraDetails", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraDetails);
        setValue("descriptionOfLand.roadWidths", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidths);
        setValue("descriptionOfLand.approachRoadWidths", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidths);
        setParams(prev => {
          var _data16, _prev$landInfo, _prev$landInfo$owners, _data17, _data17$landInfo, _data17$landInfo$owne, _data17$landInfo$owne2, _data18, _data18$landInfo, _data18$landInfo$owne, _data18$landInfo$owne2, _data19, _data19$landInfo, _data19$landInfo$owne, _data19$landInfo$owne2, _data20, _data20$landInfo, _data20$landInfo$owne, _data20$landInfo$owne2, _data21, _data21$landInfo, _data21$landInfo$owne, _data21$landInfo$owne2, _data22, _data22$landInfo, _data22$landInfo$owne, _data22$landInfo$owne2, _prev$landInfo2, _prev$landInfo2$owner, _prev$landInfo2$owner2, _data23, _data23$landInfo, _data23$landInfo$owne, _data23$landInfo$owne2, _data23$landInfo$owne3, _data24, _data24$landInfo, _data24$landInfo$owne, _data24$landInfo$owne2, _data24$landInfo$owne3, _data25, _data25$landInfo, _data25$landInfo$owne, _data25$landInfo$owne2, _data25$landInfo$owne3, _data26, _data26$landInfo, _data26$landInfo$owne, _data26$landInfo$owne2, _data26$landInfo$owne3;
          return {
            ...prev,
            selectedOffice: (_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.selectedOffice,
            landInfo: {
              ...prev.landInfo,
              owners: [{
                ...((_prev$landInfo = prev.landInfo) === null || _prev$landInfo === void 0 ? void 0 : (_prev$landInfo$owners = _prev$landInfo.owners) === null || _prev$landInfo$owners === void 0 ? void 0 : _prev$landInfo$owners[0]),
                name: (_data17 = data) === null || _data17 === void 0 ? void 0 : (_data17$landInfo = _data17.landInfo) === null || _data17$landInfo === void 0 ? void 0 : (_data17$landInfo$owne = _data17$landInfo.owners) === null || _data17$landInfo$owne === void 0 ? void 0 : (_data17$landInfo$owne2 = _data17$landInfo$owne[0]) === null || _data17$landInfo$owne2 === void 0 ? void 0 : _data17$landInfo$owne2.name,
                emailId: (_data18 = data) === null || _data18 === void 0 ? void 0 : (_data18$landInfo = _data18.landInfo) === null || _data18$landInfo === void 0 ? void 0 : (_data18$landInfo$owne = _data18$landInfo.owners) === null || _data18$landInfo$owne === void 0 ? void 0 : (_data18$landInfo$owne2 = _data18$landInfo$owne[0]) === null || _data18$landInfo$owne2 === void 0 ? void 0 : _data18$landInfo$owne2.emailId,
                mobileNumber: (_data19 = data) === null || _data19 === void 0 ? void 0 : (_data19$landInfo = _data19.landInfo) === null || _data19$landInfo === void 0 ? void 0 : (_data19$landInfo$owne = _data19$landInfo.owners) === null || _data19$landInfo$owne === void 0 ? void 0 : (_data19$landInfo$owne2 = _data19$landInfo$owne[0]) === null || _data19$landInfo$owne2 === void 0 ? void 0 : _data19$landInfo$owne2.mobileNumber,
                fatherOrHusbandName: (_data20 = data) === null || _data20 === void 0 ? void 0 : (_data20$landInfo = _data20.landInfo) === null || _data20$landInfo === void 0 ? void 0 : (_data20$landInfo$owne = _data20$landInfo.owners) === null || _data20$landInfo$owne === void 0 ? void 0 : (_data20$landInfo$owne2 = _data20$landInfo$owne[0]) === null || _data20$landInfo$owne2 === void 0 ? void 0 : _data20$landInfo$owne2.fatherOrHusbandName,
                gender: (_data21 = data) === null || _data21 === void 0 ? void 0 : (_data21$landInfo = _data21.landInfo) === null || _data21$landInfo === void 0 ? void 0 : (_data21$landInfo$owne = _data21$landInfo.owners) === null || _data21$landInfo$owne === void 0 ? void 0 : (_data21$landInfo$owne2 = _data21$landInfo$owne[0]) === null || _data21$landInfo$owne2 === void 0 ? void 0 : _data21$landInfo$owne2.gender,
                aadhaarNumber: (_data22 = data) === null || _data22 === void 0 ? void 0 : (_data22$landInfo = _data22.landInfo) === null || _data22$landInfo === void 0 ? void 0 : (_data22$landInfo$owne = _data22$landInfo.owners) === null || _data22$landInfo$owne === void 0 ? void 0 : (_data22$landInfo$owne2 = _data22$landInfo$owne[0]) === null || _data22$landInfo$owne2 === void 0 ? void 0 : _data22$landInfo$owne2.aadhaarNumber,
                correspondenceAddress: {
                  ...((_prev$landInfo2 = prev.landInfo) === null || _prev$landInfo2 === void 0 ? void 0 : (_prev$landInfo2$owner = _prev$landInfo2.owners) === null || _prev$landInfo2$owner === void 0 ? void 0 : (_prev$landInfo2$owner2 = _prev$landInfo2$owner[0]) === null || _prev$landInfo2$owner2 === void 0 ? void 0 : _prev$landInfo2$owner2.correspondenceAddress),
                  state: (_data23 = data) === null || _data23 === void 0 ? void 0 : (_data23$landInfo = _data23.landInfo) === null || _data23$landInfo === void 0 ? void 0 : (_data23$landInfo$owne = _data23$landInfo.owners) === null || _data23$landInfo$owne === void 0 ? void 0 : (_data23$landInfo$owne2 = _data23$landInfo$owne[0]) === null || _data23$landInfo$owne2 === void 0 ? void 0 : (_data23$landInfo$owne3 = _data23$landInfo$owne2.correspondenceAddress) === null || _data23$landInfo$owne3 === void 0 ? void 0 : _data23$landInfo$owne3.state,
                  address: (_data24 = data) === null || _data24 === void 0 ? void 0 : (_data24$landInfo = _data24.landInfo) === null || _data24$landInfo === void 0 ? void 0 : (_data24$landInfo$owne = _data24$landInfo.owners) === null || _data24$landInfo$owne === void 0 ? void 0 : (_data24$landInfo$owne2 = _data24$landInfo$owne[0]) === null || _data24$landInfo$owne2 === void 0 ? void 0 : (_data24$landInfo$owne3 = _data24$landInfo$owne2.correspondenceAddress) === null || _data24$landInfo$owne3 === void 0 ? void 0 : _data24$landInfo$owne3.address,
                  district: (_data25 = data) === null || _data25 === void 0 ? void 0 : (_data25$landInfo = _data25.landInfo) === null || _data25$landInfo === void 0 ? void 0 : (_data25$landInfo$owne = _data25$landInfo.owners) === null || _data25$landInfo$owne === void 0 ? void 0 : (_data25$landInfo$owne2 = _data25$landInfo$owne[0]) === null || _data25$landInfo$owne2 === void 0 ? void 0 : (_data25$landInfo$owne3 = _data25$landInfo$owne2.correspondenceAddress) === null || _data25$landInfo$owne3 === void 0 ? void 0 : _data25$landInfo$owne3.town,
                  pinno: (_data26 = data) === null || _data26 === void 0 ? void 0 : (_data26$landInfo = _data26.landInfo) === null || _data26$landInfo === void 0 ? void 0 : (_data26$landInfo$owne = _data26$landInfo.owners) === null || _data26$landInfo$owne === void 0 ? void 0 : (_data26$landInfo$owne2 = _data26$landInfo$owne[0]) === null || _data26$landInfo$owne2 === void 0 ? void 0 : (_data26$landInfo$owne3 = _data26$landInfo$owne2.correspondenceAddress) === null || _data26$landInfo$owne3 === void 0 ? void 0 : _data26$landInfo$owne3.pinno
                }
              }]
            },
            professionalInformation: {
              ...prev.professionalInformation,
              name: architect === null || architect === void 0 ? void 0 : architect.name,
              planDate: architect === null || architect === void 0 ? void 0 : architect.planDate,
              mobileNumber: architect === null || architect === void 0 ? void 0 : architect.mobileNumber,
              emailId: architect === null || architect === void 0 ? void 0 : architect.emailId,
              licenseNumber: architect === null || architect === void 0 ? void 0 : architect.licenseNumber,
              consultantCategory: architect === null || architect === void 0 ? void 0 : architect.consultantCategory
            },
            descriptionOfLand: {
              ...prev.descriptionOfLand,
              landArea: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landArea,
              plotAreaDoc: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotAreaDoc,
              developmentArea: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.developmentArea,
              landUsesType: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landUsesType,
              subLandUseAsPerLayout: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.subLandUseAsPerLayout,
              landMark: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark,
              activityAsPerMap: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.activityAsPerMap,
              activityProposed: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.activityProposed,
              landAddress: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress,
              schemeType: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeType,
              planOn: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.planOn,
              schemeName: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.schemeName,
              khasraDetails: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraDetails,
              latitude: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude,
              longitude: descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude
            }
          };
        });
        initFormMTDocs([...documents]);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData === null || formData === void 0 ? void 0 : formData.location1);
  }, [formData === null || formData === void 0 ? void 0 : formData.location1]);
  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSECONVERSION", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSECONVERSION", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);
  const validateFiles = () => {
    const uploadedDocs = documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType);
    const isValid = ["signature"].every(doc => uploadedDocs.includes(doc));
    return isValid;
  };
  const onSubmit = data => {
    const isValid = validateFiles();
    if (isValid) {
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity
            }
          }
        }
      };
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "FASTPAS ID")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "FASTPAS Id",
    placeholder: "Enter FASTPAS Id",
    name: "land_Id",
    type: "textInput",
    mandatory: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.land_Id,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee,
    showSearchIcon: true,
    onSearchClick: () => handleSearchClick(getValues("land_Id"))
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority")), isDA ? /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Select Development Authority",
    inputLabel: "Select office",
    placeholder: "Select office",
    name: "selectedOffice",
    type: formData !== null && formData !== void 0 && formData.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedOffice,
    data: SortingAlphabatically(officesList),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: (formData === null || formData === void 0 ? void 0 : formData.selectedOffice) || isEmployee || isApproved || watch("selectedOffice")
  })))) : /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    style: {
      position: "relative",
      marginBottom: "10px"
    },
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Unit",
    inputLabel: "Select unit",
    placeholder: "Select unit",
    name: "selectedUnit",
    type: "searchSelect",
    data: SortingAlphabatically(avpUnits),
    defaultValue: (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) || "",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved || watch("selectedUnit")
  })), watchUnit ? /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select City",
    inputLabel: "Select city",
    placeholder: "Select city",
    name: "selectedCity",
    type: "searchSelect",
    data: SortingAlphabatically(avpCities),
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.selectedCity,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: isEmployee || isApproved
  })) : /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    style: {
      marginTop: "26px"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Owner/Applicant Details"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    placeholder: "Enter Name",
    name: `landInfo.owners.[0].name`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].name")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Father Name",
    placeholder: "Enter Father Name",
    name: `landInfo.owners.[0].fatherOrHusbandName`,
    type: "textInput",
    maxLength: 30,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].fatherOrHusbandName")
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: t("Gender"),
    placeholder: t("Gender"),
    name: `landInfo.owners.[0].gender`,
    type: "searchSelect",
    data: SortingAlphabatically(genderData),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.gender,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].gender")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Mobile Number",
    placeholder: "Enter Mobile Number",
    name: `landInfo.owners.[0].mobileNumber`,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].mobileNumber"),
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail ID",
    control: control,
    placeholder: "Enter E-mail ID",
    name: `landInfo.owners.[0].emailId`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].emailId")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Aadhaar Number",
    control: control,
    placeholder: "Enter Aadhaar Number",
    name: `landInfo.owners.[0].aadhaarNumber`,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].aadhaarNumber"),
    maxLength: 12
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "State",
    placeholder: "Select State",
    name: `landInfo.owners.[0].correspondenceAddress.state`,
    type: "selectInput",
    disabled: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : (_formData$landInfo4$o3 = _formData$landInfo4$o2.correspondenceAddress) === null || _formData$landInfo4$o3 === void 0 ? void 0 : _formData$landInfo4$o3.state) || isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.state"),
    data: statesName,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: watchState === "Uttar Pradesh" ? updistricts : undefined,
    label: t("LABEL_DISTRICT"),
    placeholder: watchState === "Uttar Pradesh" ? "Select District" : "Enter District",
    name: `landInfo.owners.[0].correspondenceAddress.town`,
    type: watchState === "Uttar Pradesh" ? "searchSelect" : "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.town")
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Communication Address",
    placeholder: "Enter Communication Address",
    name: `landInfo.owners.[0].correspondenceAddress.address`,
    type: "textInput",
    mandatory: true,
    maxLength: 1500,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Address"),
        message: "Please enter valid Address"
      }
    },
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.address")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Pin Code",
    placeholder: "Enter Pin Code",
    name: `landInfo.owners.[0].correspondenceAddress.pinno`,
    type: "number",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Pincode"),
        message: "Please enter valid Pin Code"
      }
    },
    maxLength: 6,
    disabled: isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.pinno")
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader signature-attach-uploader"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    name: "signature",
    label: "Attach Signature",
    validationMsg: "(jpg, jpeg, png file only and Max file Size 10 MB)",
    isMandatory: true,
    required: true,
    tab: 2,
    maxFiles: 1,
    showError: showError
  }))), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    disabled: loading,
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  })), /*#__PURE__*/React__default.createElement(ScrollButton, null)))));
};

const SubStep4$c = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  t,
  landSubUseTypes,
  landUseListActivities,
  landUsesSchemeTypeList,
  landSubUseTypes2,
  tenantId,
  departmentList,
  schemeTypeData,
  nonSchemeTypeData,
  avpList,
  applicationFlow,
  avpData,
  isEmployee,
  isApproved,
  id,
  isEdit
}) => {
  var _formData$description, _window$location, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description51, _formData$description52;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.plotAreaSite);
  const {
    documents
  } = useSelector(state => state.formMT);
  const isEditMode = Boolean(isEdit || id || (formData === null || formData === void 0 ? void 0 : formData.applicationNo) || (formData === null || formData === void 0 ? void 0 : formData.id) || typeof window !== "undefined" && ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) && window.location.pathname.includes("/services/formLandUseConversion/") && window.location.pathname.split("/services/formLandUseConversion/")[1]);
  console.log(formData, "checkingformdata");
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...(formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand),
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation,
      schemeType: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "",
      roadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.roadWidths) || [{
        value: ""
      }],
      approachRoadWidths: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.approachRoadWidths) || [{
        value: ""
      }],
      otherSides: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.otherSides) || [{
        value: ""
      }],
      multipleKhata: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.multipleKhata) || [{
        value: ""
      }],
      khasraDetails: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.khasraDetails) || [{
        district: "",
        tehsil: "",
        village: "",
        plotNo: ""
      }],
      multipleKhasra: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.multipleKhasra) || [{
        khasraNo: "",
        area: ""
      }],
      landUsesType: formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.landUsesType,
      subLandUseAsPerLayout: formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.subLandUseAsPerLayout,
      activityAsPerMap: formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap,
      activityProposed: formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityProposed
    }
  };
  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue
  } = useForm({
    defaultValues
  });
  const handleCoordinateChange = (field, value) => {
    setCoordinate(prev => {
      const newCoordinates = [...prev];
      newCoordinates[0] = {
        ...newCoordinates[0],
        [field]: value
      };
      return newCoordinates;
    });
  };
  const {
    fields: multipleKhasra,
    append: addKhasra,
    remove: removeKhasra
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra"
  });
  const {
    fields: roadWidthsArray,
    append: addRoadWidthField,
    remove: removeRoadWidthField
  } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths"
  });
  const {
    fields: otherSides,
    append: addOtherSide,
    remove: removeOtherSide
  } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides"
  });
  const {
    fields: approachRoadWidths,
    append: addApproachRoad,
    remove: removeApproachWidth
  } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths"
  });
  const {
    fields: multipleKhata,
    append: addKhata,
    remove: removeKhata
  } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata"
  });
  const {
    fields: khasraDetails,
    append: addKhasraDetail,
    remove: removeKhasraDetail
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  console.log("departmentListFrom444", schemeTypeData, nonSchemeTypeData);
  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const watchMaster = watch("descriptionOfLand.requiredLandUsesType") || (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.requiredLandUsesType);
  const watchActivityAsPerMap = watch("descriptionOfLand.activityAsPerMap") || (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.activityAsPerMap);
  const watchSubLayout = watch("descriptionOfLand.subLandUseAsPerLayout") || (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.subLandUseAsPerLayout);
  const watchPlanOn = watch("descriptionOfLand.planOn") || (formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.planOn);
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails"
  });
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${formData === null || formData === void 0 ? void 0 : formData.selectedOffice}")]`
  }]);
  const {
    data: {
      BPA: {
        LandUseAvpVillageMasterData: avpVillagesData
      } = {}
    } = {},
    isLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseAvpVillageMasterData",
    filter: `$..Districts[?(@.District=='${formData === null || formData === void 0 ? void 0 : formData.selectedCity}')]`
  }]);
  console.log("loggingVillagesData", villagesData, avpVillagesData);
  const filterTehsilData = (masterData, authority, district) => {
    var _masterData$find, _masterData$find$Dist, _masterData$find$Dist2, _masterData$find$Dist3;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$Dist = _masterData$find.Districts) === null || _masterData$find$Dist === void 0 ? void 0 : (_masterData$find$Dist2 = _masterData$find$Dist.find(item => item.District === district)) === null || _masterData$find$Dist2 === void 0 ? void 0 : (_masterData$find$Dist3 = _masterData$find$Dist2.tehsils) === null || _masterData$find$Dist3 === void 0 ? void 0 : _masterData$find$Dist3.map(item => {
      return {
        name: item.tehsilName,
        label: item.tehsilName,
        value: item.tehsilName
      };
    }) : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterAvpTehsilData = (masterData, district) => {
    var _masterData$find2, _masterData$find2$teh;
    const tehsilArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => item.District === district)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$teh = _masterData$find2.tehsils) === null || _masterData$find2$teh === void 0 ? void 0 : _masterData$find2$teh.map(item => ({
      name: item.tehsilName,
      label: item.tehsilName,
      value: item.tehsilName
    }));
    return tehsilArray || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    var _masterData$find3, _masterData$find3$Dis, _masterData$find3$Dis2, _masterData$find3$Dis3, _masterData$find3$Dis4, _masterData$find3$Dis5;
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = str => str === null || str === void 0 ? void 0 : str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    const result = tehsil && district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : (_masterData$find3$Dis2 = _masterData$find3$Dis.find(item => (item === null || item === void 0 ? void 0 : item.District) === district)) === null || _masterData$find3$Dis2 === void 0 ? void 0 : (_masterData$find3$Dis3 = _masterData$find3$Dis2.tehsils) === null || _masterData$find3$Dis3 === void 0 ? void 0 : (_masterData$find3$Dis4 = _masterData$find3$Dis3.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find3$Dis4 === void 0 ? void 0 : (_masterData$find3$Dis5 = _masterData$find3$Dis4.villages) === null || _masterData$find3$Dis5 === void 0 ? void 0 : _masterData$find3$Dis5.map(item => {
      const formatted = toTitleCase(item);
      return {
        name: formatted,
        value: formatted,
        label: formatted
      };
    }) : null;
    return result || [];
  };
  const filterAvpVillagesData = (masterData, district, tehsil) => {
    var _masterData$find4, _masterData$find4$teh, _masterData$find4$teh2, _masterData$find4$teh3, _masterData$find4$teh4;
    const villagesArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find4 = masterData.find(item => item.District === district)) === null || _masterData$find4 === void 0 ? void 0 : (_masterData$find4$teh = _masterData$find4.tehsils) === null || _masterData$find4$teh === void 0 ? void 0 : (_masterData$find4$teh2 = _masterData$find4$teh.find(item => item.tehsilName === tehsil)) === null || _masterData$find4$teh2 === void 0 ? void 0 : (_masterData$find4$teh3 = _masterData$find4$teh2.villages) === null || _masterData$find4$teh3 === void 0 ? void 0 : (_masterData$find4$teh4 = _masterData$find4$teh3.map) === null || _masterData$find4$teh4 === void 0 ? void 0 : _masterData$find4$teh4.call(_masterData$find4$teh3, item => ({
      name: item,
      label: item,
      value: item
    }));
  };
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find5, _masterData$find5$Dis;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find5 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find5 === void 0 ? void 0 : (_masterData$find5$Dis = _masterData$find5.Districts) === null || _masterData$find5$Dis === void 0 ? void 0 : _masterData$find5$Dis.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const isSchemeType = watchSchemeType === "Scheme";
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    var _authorityData$LandUs;
    console.log("schemeDataCalled", authority, masterData, category, subCategory);
    const authorityData = masterData === null || masterData === void 0 ? void 0 : masterData[0];
    if (!authorityData) return {
      landUseList: [],
      landSubUseList: null
    };
    const landUseList = (authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs = authorityData.LandUse) === null || _authorityData$LandUs === void 0 ? void 0 : _authorityData$LandUs.map(item => ({
      name: item.Type,
      value: item.Type,
      label: item.Type
    }))) || [];
    let landSubUseList = null;
    if (category) {
      var _authorityData$LandUs2;
      const landUseCategory = authorityData === null || authorityData === void 0 ? void 0 : (_authorityData$LandUs2 = authorityData.LandUse) === null || _authorityData$LandUs2 === void 0 ? void 0 : _authorityData$LandUs2.find(item => item.Type === category);
      if (landUseCategory) {
        var _landUseCategory$Land;
        landSubUseList = ((_landUseCategory$Land = landUseCategory.LandSubUse) === null || _landUseCategory$Land === void 0 ? void 0 : _landUseCategory$Land.map(item => ({
          name: item,
          label: item,
          value: item
        }))) || [];
      }
    }
    console.log("loggingMasterData", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter(district => {
    var _district$code;
    return !((_district$code = district.code) !== null && _district$code !== void 0 && _district$code.includes("up"));
  });
  console.log("upDIstricts", updistricts);
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    var _masterData$, _masterData$$Category, _masterData$2, _masterData$2$Categor, _masterData$2$Categor2, _masterData$2$Categor3, _masterData$2$Categor4;
    const landUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$ = masterData[0]) === null || _masterData$ === void 0 ? void 0 : (_masterData$$Category = _masterData$.CategoryType) === null || _masterData$$Category === void 0 ? void 0 : _masterData$$Category.map(item => {
      return {
        name: item.Category,
        label: item.Category,
        value: item.Category
      };
    });
    const landSubUseList = masterData === null || masterData === void 0 ? void 0 : (_masterData$2 = masterData[0]) === null || _masterData$2 === void 0 ? void 0 : (_masterData$2$Categor = _masterData$2.CategoryType) === null || _masterData$2$Categor === void 0 ? void 0 : (_masterData$2$Categor2 = _masterData$2$Categor.filter(item => item.Category === category)) === null || _masterData$2$Categor2 === void 0 ? void 0 : (_masterData$2$Categor3 = _masterData$2$Categor2[0]) === null || _masterData$2$Categor3 === void 0 ? void 0 : (_masterData$2$Categor4 = _masterData$2$Categor3["Activity Proposed"]) === null || _masterData$2$Categor4 === void 0 ? void 0 : _masterData$2$Categor4.map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return {
      landUseList,
      landSubUseList
    };
  };
  const {
    landUseList,
    landSubUseList
  } = filterSchemeData(isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", schemeTypeData, watchMaster, watchSubLayout);
  console.log(landUseList, landSubUseList, schemeTypeData, watchMaster, watchSubLayout, "schemeList");
  useEffect(() => {
    var _formData$description19, _formData$description20, _formData$description21, _formData$description22;
    setValue("descriptionOfLand.landUsesType", formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.landUsesType);
    setValue("descriptionOfLand.subLandUseAsPerLayout", formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.subLandUseAsPerLayout);
    setValue("descriptionOfLand.activityAsPerMap", formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.activityAsPerMap);
    setValue("descriptionOfLand.activityProposed", formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.activityProposed);
    console.log(formData, "formData");
  }, []);
  const plotNo = watch("descriptionOfLand.plotNo");
  const {
    landUseList: activityAsPerMap,
    landSubUseList: activityProposed
  } = filterNonSchemeData(formData === null || formData === void 0 ? void 0 : formData.selectedOffice, nonSchemeTypeData, watchActivityAsPerMap);
  console.log("activityAsPerMap", activityAsPerMap);
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData === null || masterData === void 0 ? void 0 : masterData.filter(item => item.Name === department).map(item => item.ColonyGroups).flat().filter(item => item.ColonyType === planOn).map(item => item.Colonies).flat().map(item => {
      return {
        name: item,
        label: item,
        value: item
      };
    });
    console.log("schemeFilteredData", schemeNameList);
    return schemeNameList;
  };
  const schemeNames = filterSchemeNames(departmentList, formData === null || formData === void 0 ? void 0 : formData.selectedOffice, watchPlanOn);
  const filterAvpSchemeNames = (unit, city, masterData) => {
    var _masterData$filter, _masterData$filter$, _masterData$filter$$C, _masterData$filter$$C2, _masterData$filter$$C3, _masterData$filter$$C4;
    console.log("avpMasterFrom4", masterData, unit, city);
    const result = masterData === null || masterData === void 0 ? void 0 : (_masterData$filter = masterData.filter(item => item.Unit === unit)) === null || _masterData$filter === void 0 ? void 0 : (_masterData$filter$ = _masterData$filter[0]) === null || _masterData$filter$ === void 0 ? void 0 : (_masterData$filter$$C = _masterData$filter$.Cities) === null || _masterData$filter$$C === void 0 ? void 0 : (_masterData$filter$$C2 = _masterData$filter$$C.filter(item => item.City === city)) === null || _masterData$filter$$C2 === void 0 ? void 0 : (_masterData$filter$$C3 = _masterData$filter$$C2[0]) === null || _masterData$filter$$C3 === void 0 ? void 0 : (_masterData$filter$$C4 = _masterData$filter$$C3.Schemes) === null || _masterData$filter$$C4 === void 0 ? void 0 : _masterData$filter$$C4.map(item => {
      return {
        name: item.SchemeName,
        label: item.SchemeName,
        value: item.SchemeName
      };
    });
    console.log("loggingAVPSchemeNames", result);
    return result;
  };
  const avpSchemeNames = filterAvpSchemeNames(formData === null || formData === void 0 ? void 0 : formData.selectedUnit, formData === null || formData === void 0 ? void 0 : formData.selectedCity, avpData);
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["kmlFile"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const onSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSubmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    var _formData$description23;
    if (formData !== null && formData !== void 0 && (_formData$description23 = formData.descriptionOfLand) !== null && _formData$description23 !== void 0 && _formData$description23.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
      setValue("landInfo.owners[0].permanentAddress.district", formData === null || formData === void 0 ? void 0 : formData.location1);
    }
    setValue("documents", documents);
    if (formData !== null && formData !== void 0 && formData.location1 && (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Land Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Scheme Type",
    inputLabel: "Select Scheme Type",
    placeholder: "Select Scheme Type",
    name: "descriptionOfLand.schemeType",
    type: "searchSelect",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.schemeType,
    data: SortingAlphabatically(schemeTypeList),
    disabled: isEmployee || isApproved || isEditMode,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null)), isSchemeType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row$1, null, " ", /*#__PURE__*/React__default.createElement(Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 4px",
      fontWeight: "700"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      backgroundColor: "#f2f2f2",
      color: "red",
      padding: "4px"
    }
  }, "Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission."))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Type of Scheme",
    placeholder: "Select type of scheme",
    name: `descriptionOfLand.planOn`,
    type: formData !== null && formData !== void 0 && (_formData$description25 = formData.descriptionOfLand) !== null && _formData$description25 !== void 0 && _formData$description25.planOn || isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: SortingAlphabatically(proposedSite),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.planOn,
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.planOn"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Name of Scheme",
    placeholder: "Select Name of Scheme",
    name: `descriptionOfLand.schemeName`,
    type: formData !== null && formData !== void 0 && formData.descriptionOfLand.schemeName || isEmployee || isApproved ? "textInput" : "searchSelect",
    maxLength: 30,
    data: isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames),
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.schemeName,
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.schemeName"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan",
    inputLabel: "Select a plan.",
    placeholder: isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan",
    name: "descriptionOfLand.landUsesType",
    type: "textInput",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.landUsesType"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.landUsesType,
    data: SortingAlphabatically(landUseList)
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan",
    control: control,
    placeholder: isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan",
    name: "descriptionOfLand.subLandUseAsPerLayout",
    type: "textInput",
    data: SortingAlphabatically(landSubUseList),
    disabled: isEmployee || isApproved || watch("descriptionOfLand.subLandUseAsPerLayout"),
    mandatory: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.subLandUseAsPerLayout
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(activityAsPerMap),
    label: t("Primary Use of Proposed Activity"),
    placeholder: t("Select Primary Use of Proposed Activity"),
    name: "descriptionOfLand.activityAsPerMap",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.activityAsPerMap,
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.activityAsPerMap"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Activity Proposed"),
    control: control,
    placeholder: t("Select Activity Proposed"),
    name: "descriptionOfLand.activityProposed",
    type: "textInput",
    data: SortingAlphabatically(activityProposed),
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.activityProposed"),
    maxLength: 20,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.activityProposed
  })))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Development Area"),
    control: control,
    placeholder: t("Select Development Area"),
    data: SortingAlphabatically(ConstructionTypeOptions),
    name: "descriptionOfLand.developmentArea",
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.developmentArea"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.constructionType,
    type: "searchSelect"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Required Land Use as per Layout Plan" : "Required Land Use as per Master Plan",
    inputLabel: "Select a plan.",
    placeholder: isSchemeType ? "Select Required Land Use as per Layout Plan" : "Select Required Land Use as per Master Plan",
    name: "descriptionOfLand.requiredLandUsesType",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    mandatory: true,
    isRequired: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.requiredLandUsesType"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.requiredLandUsesType,
    data: SortingAlphabatically(landUseList)
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: isSchemeType ? "Required Land Sub Use as per Layout Plan" : "Required Land Sub Use as per Master Plan",
    control: control,
    placeholder: isSchemeType ? "Select Required Land Sub Use as per Layout Plan" : "Select Required Land Sub Use as per Master Plan",
    name: "descriptionOfLand.reqSubLandUseAsPerLayout",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(landSubUseList),
    disabled: isEmployee || isApproved || watch("descriptionOfLand.reqSubLandUseAsPerLayout"),
    mandatory: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.reqSubLandUseAsPerLayout
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: t("Require Activity Proposed"),
    control: control,
    placeholder: t("Select Require Activity Proposed"),
    name: "descriptionOfLand.reqActivityProposed",
    type: isEmployee || isApproved ? "textInput" : "searchSelect",
    data: SortingAlphabatically(activityProposed),
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.reqActivityProposed"),
    maxLength: 20,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description35 = formData.descriptionOfLand) === null || _formData$description35 === void 0 ? void 0 : _formData$description35.reqActivityProposed
  })))), !isSchemeType ? /*#__PURE__*/React__default.createElement("fieldset", {
    className: "fieldset-wrapper bg-white"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table landUserTable",
    border: "1",
    cellPadding: "8"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "table-no-background",
    style: {
      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, t("LABEL_DISTRICT"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, t("Tehsil"), /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Village", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Plot No./Khasra No./Arazi No.", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "10%"
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraDetails.map((item, index) => {
    var _khasraTehsils$index, _khasraTehsils$index2, _formData$description36, _formData$description37, _formData$description38, _formData$description39, _formData$description40, _formData$description41, _formData$description42, _formData$description43, _formData$description44, _formData$description45, _formData$description46, _formData$description47, _formData$description48, _formData$description49, _formData$description50;
    const selectedTehsil = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index = khasraTehsils[index]) === null || _khasraTehsils$index === void 0 ? void 0 : _khasraTehsils$index.tehsil;
    const selectedDistrict = khasraTehsils === null || khasraTehsils === void 0 ? void 0 : (_khasraTehsils$index2 = khasraTehsils[index]) === null || _khasraTehsils$index2 === void 0 ? void 0 : _khasraTehsils$index2.district;
    const filteredVillages = isDA ? filterVillagesData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict, selectedTehsil) : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
    const tehsils = isDA ? filterTehsilData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority", selectedDistrict) : filterAvpTehsilData(avpVillagesData, selectedDistrict);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item.id
    }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filterDistrictData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority")),
      placeholder: "Select District",
      name: `descriptionOfLand.khasraDetails[${index}].district`,
      type: !isDA || formData !== null && formData !== void 0 && (_formData$description36 = formData.descriptionOfLand) !== null && _formData$description36 !== void 0 && (_formData$description37 = _formData$description36.khasraDetails) !== null && _formData$description37 !== void 0 && (_formData$description38 = _formData$description37[index]) !== null && _formData$description38 !== void 0 && _formData$description38.district || isEmployee || isApproved ? "textInput" : "searchSelect",
      defaultValue: formData === null || formData === void 0 ? void 0 : formData.location1,
      disabled: isEmployee || isApproved || watch("descriptionOfLand.khasraDetails.[0].district"),
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(tehsils),
      placeholder: "Select Tehsil",
      name: `descriptionOfLand.khasraDetails[${index}].tehsil`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description39 = formData.descriptionOfLand) === null || _formData$description39 === void 0 ? void 0 : (_formData$description40 = _formData$description39.khasraDetails) === null || _formData$description40 === void 0 ? void 0 : (_formData$description41 = _formData$description40[index]) === null || _formData$description41 === void 0 ? void 0 : _formData$description41.tehsil,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || formData !== null && formData !== void 0 && (_formData$description42 = formData.descriptionOfLand) !== null && _formData$description42 !== void 0 && (_formData$description43 = _formData$description42.khasraDetails) !== null && _formData$description43 !== void 0 && (_formData$description44 = _formData$description43[index]) !== null && _formData$description44 !== void 0 && _formData$description44.tehsil || isEmployee || isApproved ? "textInput" : "searchSelect",
      disabled: isEmployee || isApproved || watch("descriptionOfLand.khasraDetails.[0].tehsil"),
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      data: SortingAlphabatically(filteredVillages),
      placeholder: "Select Village",
      name: `descriptionOfLand.khasraDetails[${index}].village`,
      defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description45 = formData.descriptionOfLand) === null || _formData$description45 === void 0 ? void 0 : (_formData$description46 = _formData$description45.khasraDetails) === null || _formData$description46 === void 0 ? void 0 : (_formData$description47 = _formData$description46[index]) === null || _formData$description47 === void 0 ? void 0 : _formData$description47.village,
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) < 1 || formData !== null && formData !== void 0 && (_formData$description48 = formData.descriptionOfLand) !== null && _formData$description48 !== void 0 && (_formData$description49 = _formData$description48.khasraDetails) !== null && _formData$description49 !== void 0 && (_formData$description50 = _formData$description49[index]) !== null && _formData$description50 !== void 0 && _formData$description50.village || isEmployee || isApproved ? "textInput" : "searchSelect",
      maxLength: 30,
      disabled: isEmployee || isApproved || watch("descriptionOfLand.khasraDetails.[0].village"),
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter Plot No./Khasra No./Arazi No.",
      mandatory: true,
      name: `descriptionOfLand.khasraDetails[${index}].plotNo`,
      type: "textInput",
      allowedChars: "/,-",
      maxLength: 200,
      disabled: isEmployee || isApproved || watch("descriptionOfLand.khasraDetails.[0].plotNo"),
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => removeKhasraDetail(index),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), index === khasraDetails.length - 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      onClick: () => addKhasraDetail({
        plotNo: "",
        district: "",
        tehsil: "",
        village: ""
      }),
      disabled: isEmployee || isApproved
    }, /*#__PURE__*/React__default.createElement(AddIcon, null))));
  }))))) : /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Plot No.",
    control: control,
    placeholder: "Enter Plot No.",
    mandatory: true,
    name: "descriptionOfLand.plotNo",
    type: "specialChar",
    allowedChars: "/,-",
    maxLength: 200,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.plotNo"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    data: SortingAlphabatically(filterDistrictData(villagesData, isDA ? formData === null || formData === void 0 ? void 0 : formData.selectedOffice : "Lucknow Development Authority")),
    label: t("LABEL_DISTRICT"),
    placeholder: "Select District",
    name: "landInfo.owners[0].permanentAddress.district",
    type: isDA ? "searchSelect" : "textInput",
    defaultValue: !isDA && (formData === null || formData === void 0 ? void 0 : formData.selectedCity),
    mandatory: true,
    disabled: !isDA || watch("landInfo.owners[0].permanentAddress.district"),
    isRequired: true,
    validation: {
      required: {
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per document) (sq. m)",
    placeholder: "Enter Plot area (as per document) (sq. m)",
    name: "descriptionOfLand.plotAreaDoc",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.plotAreaDoc")
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Plot area (as per site) (sq. m)",
    placeholder: "Enter Plot area (as per site) (sq. m)",
    name: "descriptionOfLand.landArea",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    message: "The value must not exceed plot area as per document",
    maxValue: maxPlotAreaSite,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.landArea"),
    validation: {
      required: {
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, roadWidthsArray.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: "Road width (existing) (m)",
    placeholder: "Enter Road width (existing) (m)",
    name: `descriptionOfLand.roadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.roadWidths.[0].value"),
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: roadWidthsArray.length >= 4,
    onClick: () => addRoadWidthField({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), roadWidthsArray.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeRoadWidthField(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))), /*#__PURE__*/React__default.createElement(Col, null, approachRoadWidths.map((field, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    label: isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)",
    placeholder: isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)",
    name: `descriptionOfLand.approachRoadWidths.${index}.value`,
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    containerStyles: {
      width: "100%"
    },
    isRequired: true,
    maxLength: 5,
    sx: {
      Padding: "0px"
    },
    disabled: isEmployee || isApproved || watch("descriptionOfLand.approachRoadWidths.[0].value"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "adornment",
    style: {
      position: "absolute",
      right: "0px"
    }
  }, index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    sx: {
      color: "#000"
    },
    "aria-label": "Add more",
    disabled: approachRoadWidths.length >= 4,
    onClick: () => addApproachRoad({
      value: ""
    })
  }, /*#__PURE__*/React__default.createElement(AddIcon, {
    sx: {
      color: "#000"
    }
  })), approachRoadWidths.length > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeApproachWidth(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("latitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Latitude",
    control: control,
    placeholder: "Enter Latitude",
    name: "descriptionOfLand.latitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.latitude"),
    isRequired: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    minLength: 8,
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement(Col, {
    onChange: e => handleCoordinateChange("longitude", e.target.value)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Longitude",
    control: control,
    placeholder: "Enter Longitude",
    name: "descriptionOfLand.longitude",
    type: "specialChar",
    allowedChars: ".",
    onlyNumeric: true,
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.longitude"),
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Coordinates"),
        message: "Value cannot be zero. Please provide valid coordinate."
      }
    },
    isRequired: true,
    maxLength: 10,
    minLength: 8
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Land Address",
    control: control,
    placeholder: "Enter Land Address",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description51 = formData.descriptionOfLand) === null || _formData$description51 === void 0 ? void 0 : _formData$description51.landAddress,
    name: "descriptionOfLand.landAddress",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.landAddress"),
    maxLength: 30000,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Nearby Landmark",
    control: control,
    placeholder: "Enter Nearby Landmark",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description52 = formData.descriptionOfLand) === null || _formData$description52 === void 0 ? void 0 : _formData$description52.landMark,
    name: "descriptionOfLand.landMark",
    type: "specialChar",
    allowedChars: "_&:,/. -",
    mandatory: true,
    required: true,
    disabled: isEmployee || isApproved || watch("descriptionOfLand.landMark"),
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement(KmlFileUploader, {
    name: "kmlFile",
    label: "KML File",
    isMandatory: true,
    validationMsg: "(.kml file only and Max file Size 10 MB)",
    required: true,
    tab: 1,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(2)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const Step2$d = ({
  formData,
  isUpdating,
  handleTabChange,
  t,
  initFormMTDocs
}) => {
  var _formData$description2, _formData$description3, _formData$description4, _formData$description5;
  const {
    documents
  } = useSelector(state => state.formMT);
  const [coordinate, setCoordinate] = useState([{
    latitude: "",
    longitude: ""
  }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  console.log("documentFromRedux", documents, formData);
  console.log("documentsectionRendered");
  const determineRiskType = formData => {
    const {
      activityAsPerMap,
      activityProposed,
      developmentArea,
      landArea,
      schemeType
    } = (formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand) || {};
    let riskType = "HIGH_NIVESH";
    if (activityAsPerMap === "Residential") {
      if (activityProposed === "Multi Unit" || activityProposed === "Group Housing" || activityProposed === "EWS Group Housing" || activityProposed === "LIG Group Housing" || activityProposed === "Affordable Group Housing") {
        riskType = "HIGH_NIVESH";
      } else if (activityProposed === "Row Houses" || activityProposed === "Semi Detached" || activityProposed === "Detached") {
        if (developmentArea === "Built Up") {
          if (landArea <= 100) {
            riskType = "LOW";
          } else {
            if (schemeType === "Non Scheme") {
              riskType = "HIGH";
            }
          }
        } else {
          if (schemeType === "Non Scheme") {
            riskType = "HIGH";
          } else if (schemeType === "Scheme") {
            riskType = "LOW";
          }
        }
      }
    }
    return riskType;
  };
  const riskType = determineRiskType(formData);
  console.log("FinalriskType", riskType);
  const validateFiles = () => {
    var _formData$description;
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme" ? ["completeDrawingFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA"] : ["completeDrawingFile", "registrySaleDeedHPTA"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.googleMapCoordinates) || coordinate,
      googleMapLocation: (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.googleMapLocation) || googleLocation
    },
    documents: documents
  };
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) === "Scheme";
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    defaultValues
  });
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    var _formData$documents;
    console.log("insideStep3effect");
    if ((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.length) > 0) {
      var _formData$documents2;
      console.log("insideStep3effectIfCondition", formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.length);
      initFormMTDocs(formData.documents);
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.documents, formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.schemeType]);
  const handleClick = () => {
    window.open("https://www.youtube.com/watch?v=TOYanGZdJxo", "_blank");
  };
  const onSubmit = data => {
    const allowedDocs = isSchemeType ? ["completeDrawingFile", "kmlFile", "allotmentLetterPossessionLetter", "registrySaleDeedHPTA", "sajraPlan", "giftDeed", "applicantPhoto", "signature"] : ["completeDrawingFile", "kmlFile", "developerConsortiumSalesAgreement", "khatauni", "registrySaleDeedHPTA", "mutationLetter", "sajraPlan", "applicantPhoto", "signature"];
    const conditionalDocs = documents === null || documents === void 0 ? void 0 : documents.filter(doc => allowedDocs.includes(doc.documentType));
    console.log("conditionalDocs", conditionalDocs);
    data = {
      ...data,
      riskType,
      descriptionOfLand: {
        ...data.descriptionOfLand,
        googleMapCoordinates: coordinate,
        googleMapLocation: googleLocation
      },
      documents: conditionalDocs
    };
    console.log("dataFromstep2", data);
    handleTabChange(2, data);
    console.log("insdieElseFromsubmit", showError);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Documents"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-3",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-12"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: "5px",
      color: "#333",
      margin: "9px 0px",
      fontWeight: "600",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      textAlign: "right",
      color: "rgb(2, 11, 15)",
      padding: "9px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "clickHere",
    onClick: handleClick
  }, "Click here,"), "\xA0to know how to create a .kml file.")))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    label: "Complete drawing including location/site plan, key plan",
    control: control,
    name: "completeDrawingFile",
    validationMsg: "Upload File",
    required: true,
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType && /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Allotment letter/Possession letter",
    control: control,
    name: "allotmentLetterPossessionLetter",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), isSchemeType ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    isMandatory: true,
    required: true,
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMigrated: true
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Developer/Consortium/Sales Agreement",
    control: control,
    name: "developerConsortiumSalesAgreement",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Khatauni",
    name: "khatauni",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Registry/Sale deed/HPTA/Land ownership/Gift deed",
    control: control,
    name: "registrySaleDeedHPTA",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 4,
    isMandatory: true,
    required: true,
    isMigrated: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    label: "Mutation Letter",
    name: "mutationLetter",
    validationMsg: "Upload File",
    showError: showError,
    tab: 4,
    maxFiles: 1,
    isMigrated: true
  }))), /*#__PURE__*/React__default.createElement(Col, {
    className: "col-sm-4"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "custom-upload new-custom-uploader"
  }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    label: "Site Superimposed on Sajra Plan",
    control: control,
    name: "sajraPlan",
    validationMsg: "Upload File",
    tab: 4,
    showError: showError,
    maxFiles: 1
  }))))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-red important-note"
  }, "Note: (pdf file only and Max file Size 30 MB)*")))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => {
      handleTabChange(0);
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const SubStep3$c = ({
  formData,
  handleSubTabChange,
  t,
  archData,
  validity,
  usersData,
  isEmployee,
  isApproved
}) => {
  var _formData$professiona, _formData$professiona2, _usersData$, _formData$professiona3, _usersData$2, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$professiona8, _formData$professiona9, _usersData$5, _usersData$6, _usersData$7, _formData$professiona10, _formData$professiona11;
  console.log("validityFromSUb3", formData, archData, validity, usersData);
  const defaultValues = {
    ...formData,
    professionalInformation: {
      ...(formData === null || formData === void 0 ? void 0 : formData.professionalInformation),
      planDate: (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.planDate) || validity,
      licenseNumber: (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.licenseNumber) || (usersData === null || usersData === void 0 ? void 0 : (_usersData$ = usersData[0]) === null || _usersData$ === void 0 ? void 0 : _usersData$.registrationNumber),
      certificateNumber: (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.certificateNumber) || (usersData === null || usersData === void 0 ? void 0 : (_usersData$2 = usersData[0]) === null || _usersData$2 === void 0 ? void 0 : _usersData$2.registrationArchitectNumber)
    }
  };
  const {
    handleSubmit,
    control
  } = useForm({
    defaultValues
  });
  const onSubmit = data => {
    var _formData$professiona4, _usersData$3, _usersData$4;
    data = {
      ...data,
      professionalInformation: {
        ...data.professionalInformation,
        consultantCategory: formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.consultantCategory,
        licenseNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$3 = usersData[0]) === null || _usersData$3 === void 0 ? void 0 : _usersData$3.registrationNumber,
        planDate: validity,
        certificateNumber: usersData === null || usersData === void 0 ? void 0 : (_usersData$4 = usersData[0]) === null || _usersData$4 === void 0 ? void 0 : _usersData$4.registrationArchitectNumber
      }
    };
    console.log("dataFromSUb3", data);
    handleSubTabChange(2, data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form px-4",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Consultant Category",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.consultantCategory) || isEmployee || isApproved,
    placeholder: "Enter Consultant Category",
    name: "professionalInformation.consultantCategory",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.consultantCategory,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 30,
    className: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.consultantCategory) ? "input-disabled" : ""
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Name",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona8 = formData.professionalInformation) === null || _formData$professiona8 === void 0 ? void 0 : _formData$professiona8.name) || isEmployee || isApproved,
    placeholder: "Enter Name",
    name: "professionalInformation.name",
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    },
    isRequired: true,
    type: "textInput",
    mandatory: true,
    maxLength: 30
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Validity",
    control: control,
    placeholder: "Validity",
    name: "professionalInformation.planDate",
    type: "textInput",
    defaultValue: validity,
    disabled: Boolean(validity) || isEmployee || isApproved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "Mobile No.",
    control: control,
    placeholder: "Enter Mobile No.",
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona9 = formData.professionalInformation) === null || _formData$professiona9 === void 0 ? void 0 : _formData$professiona9.mobileNumber) || isEmployee || isApproved,
    name: "professionalInformation.mobileNumber",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: isEmployee || isApproved,
    label: "Certificate No. (For Minimum Qualification)",
    name: "professionalInformation.certificateNumber",
    defaultValue: usersData === null || usersData === void 0 ? void 0 : (_usersData$5 = usersData[0]) === null || _usersData$5 === void 0 ? void 0 : _usersData$5.registrationArchitectNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true,
    height: "30px"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    control: control,
    disabled: Boolean(usersData === null || usersData === void 0 ? void 0 : (_usersData$6 = usersData[0]) === null || _usersData$6 === void 0 ? void 0 : _usersData$6.registrationNumber) || isEmployee || isApproved,
    label: "License No.",
    name: "professionalInformation.licenseNumber",
    defaultValue: usersData === null || usersData === void 0 ? void 0 : (_usersData$7 = usersData[0]) === null || _usersData$7 === void 0 ? void 0 : _usersData$7.registrationNumber,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "100%",
    label: "E-mail Id",
    control: control,
    disabled: Boolean(formData === null || formData === void 0 ? void 0 : (_formData$professiona10 = formData.professionalInformation) === null || _formData$professiona10 === void 0 ? void 0 : _formData$professiona10.emailId) || isEmployee || isApproved,
    placeholder: "Enter E-mail Id",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$professiona11 = formData.professionalInformation) === null || _formData$professiona11 === void 0 ? void 0 : _formData$professiona11.emailId,
    name: "professionalInformation.emailId",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    isRequired: true
  })), /*#__PURE__*/React__default.createElement(Col, null))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, !isEmployee && !isApproved && /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Prev",
    sx: {
      backgroundColor: "#CCC",
      marginRight: "4px"
    },
    onClick: () => handleSubTabChange(1)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "#000",
      marginRight: "4px"
    }
  }))))));
};

const LandUseConversionNew = () => {
  const {
    id,
    Modal,
    dispatch,
    initFormMTDocs,
    resetFormMTDocs,
    t,
    history,
    tenantId,
    userInfo,
    applicationData,
    isAppDataLoading,
    summaryRef,
    params,
    setParams,
    clearParams,
    updateApiCall,
    activeTab,
    setActiveTab,
    showToast,
    setShowToast,
    handleTabChange,
    Loader,
    handleSubTabChange,
    applicationFlow,
    officesList,
    setSubActiveTab,
    subActiveTab,
    archData,
    validity,
    DepartmentSelector,
    usersData,
    landSubUseTypes2,
    closeToast,
    departmentList,
    schemeTypeData,
    nonSchemeTypeData,
    avpList,
    avpData,
    avpUnits,
    avpLogo,
    daLogo
  } = useLandUseLogic$2();
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList
  });
  console.log(applicationData, params, validity, "app_data");
  const applicationNumber = params === null || params === void 0 ? void 0 : params.applicationNo;
  useEffect(() => {
    Digit.SessionStorage.set("FILE_NO");
    Digit.SessionStorage.set("OWNER_INFO");
  }, []);
  useEffect(() => {
    var _applicationData$docu2;
    setParams(applicationData);
    if ((applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$docu2 = applicationData.documents) === null || _applicationData$docu2 === void 0 ? void 0 : _applicationData$docu2.length) > 0) {
      initFormMTDocs(applicationData.documents);
    } else {
      resetFormMTDocs();
    }
  }, [id, isAppDataLoading]);
  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return /*#__PURE__*/React__default.createElement(SubStep1$h, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            applicationFlow: applicationFlow,
            officesList: officesList,
            avpData: avpData,
            avpUnits: avpUnits,
            setParams: setParams,
            initFormMTDocs: initFormMTDocs,
            setShowToast: setShowToast
          });
        case 1:
          return /*#__PURE__*/React__default.createElement(SubStep3$c, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            t: t,
            archData: archData,
            validity: validity,
            usersData: usersData
          });
        case 2:
          return /*#__PURE__*/React__default.createElement(SubStep4$c, {
            formData: params,
            handleSubTabChange: handleSubTabChange,
            handleTabChange: handleTabChange,
            t: t,
            landSubUseTypes: landSubUses,
            landUseListActivities: landUseListActivities,
            landUsesSchemeTypeList: landUsesSchemeList,
            landSubUseTypes2: landSubUseTypes2,
            tenantId: tenantId,
            departmentList: departmentList,
            schemeTypeData: schemeTypeData,
            nonSchemeTypeData: nonSchemeTypeData,
            avpList: avpList,
            applicationFlow: applicationFlow,
            avpData: avpData,
            id: id,
            isEdit: Boolean(id || (params === null || params === void 0 ? void 0 : params.applicationNo))
          });
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return /*#__PURE__*/React__default.createElement(Step2$d, {
        formData: params,
        isUpdating: updateApiCall.isLoading,
        handleTabChange: handleTabChange,
        t: t,
        initFormMTDocs: initFormMTDocs
      });
    }
    if (activeTab === 2 && applicationNumber) {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card$2, {
        style: {
          marginTop: "20px"
        }
      }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
        formType: "formLandUse",
        id: applicationNumber,
        ref: summaryRef,
        logoData: applicationFlow == "DA" ? daLogo : avpLogo,
        oldCaseSearch: true
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          margin: "20px",
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffeeba",
          borderRadius: "4px",
          color: "#856404",
          fontWeight: "500"
        }
      }, t("FASTPAS.GLOBAL.ONCE.TEXT")), /*#__PURE__*/React__default.createElement("div", {
        className: "footerContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "buttonWrapper"
      }, /*#__PURE__*/React__default.createElement(ReactToPrint, {
        trigger: () => /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
          variant: "contained",
          color: "success",
          size: "medium",
          label: "Print",
          sx: {
            backgroundColor: "#000"
          }
        }, "Print Summary"),
        content: () => summaryRef.current
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "error",
        size: "medium",
        label: "Preview",
        sx: {
          backgroundColor: "#CCC"
        },
        onClick: () => {
          handleTabChange(0);
          handleSubTabChange(0);
        }
      }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
        variant: "contained",
        color: "success",
        size: "medium",
        label: "Submit",
        type: "submit",
        sx: {
          backgroundColor: "#000"
        },
        onClick: () => handleTabChange(4, params)
      })))));
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isAppDataLoading || id && !applicationData) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (id) {
    var _params$landInfo, _params$landInfo$owne, _params$landInfo$owne2, _params$landInfo$owne3;
    if (!(params !== null && params !== void 0 && (_params$landInfo = params.landInfo) !== null && _params$landInfo !== void 0 && (_params$landInfo$owne = _params$landInfo.owners) !== null && _params$landInfo$owne !== void 0 && (_params$landInfo$owne2 = _params$landInfo$owne[0]) !== null && _params$landInfo$owne2 !== void 0 && (_params$landInfo$owne3 = _params$landInfo$owne2.correspondenceAddress) !== null && _params$landInfo$owne3 !== void 0 && _params$landInfo$owne3.town)) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
  }
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainWrapper, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      padding: "20px"
    },
    className: "bg-white"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formStripLandUse mb-3 border-0"
  }, /*#__PURE__*/React__default.createElement("h2", null, "Land Use Conversion")), /*#__PURE__*/React__default.createElement("div", {
    className: "main-panel-corner land-use-corner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "left-corner"
  }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: activeTab,
    onChange: (e, i) => setActiveTab(i),
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, primaryTab.map((item, index) => /*#__PURE__*/React__default.createElement(PrimaryTabNewTheme, {
    key: `${item.text}.${index}`,
    label: item.text
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "right-corner"
  }, /*#__PURE__*/React__default.createElement("div", null, activeTab === 0 && /*#__PURE__*/React__default.createElement(SubTabsWrapper$1, null, /*#__PURE__*/React__default.createElement(SubTabs$1, {
    value: subActiveTab,
    onChange: (e, i) => handleSubTabChange(i),
    "aria-label": "Sub Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, subTabLabels.map((tab, index) => /*#__PURE__*/React__default.createElement(SubTabNewTheme, {
    key: `${tab.text}.${index}`,
    label: tab.text
  })))), renderContent()))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const CompoundingApplications = () => {
  var _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const citizenBaseUrl = "/digit-ui/citizen";
  const history = useHistory();
  const [smShowMs, setSmShowMs] = useState(false);
  const [showMs, setshowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [selectedAction, setSelectedAction] = useState("All");
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [migratedData, setMigratedData] = useState(null);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const mobileNumber = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber;
  const {
    data,
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_COMPOUNDING",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "MAP_SUB"
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status", "action"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleObjectionLetter = item => {
    console.log("itemfromFunctionLetter", item);
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterUrl).filter(key => key.startsWith("objection_")).sort().at(-1);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  async function fetchMigratedData() {
    try {
      const response = await Digit.OBPSService.BPAmigratedSearch({
        mobileNumber
      });
      setMigratedData(response === null || response === void 0 ? void 0 : response.ApplicationList);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }
  useEffect(() => {
    fetchMigratedData();
  }, []);
  const handleActionChange = action => {
    setSelectedAction(action);
    setCurentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  function getApprovalLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.compoundingApprovalLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  function getRejectionLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.compoundingRejectLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  function getShortfallLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.compoundingShortfallUrl;
    window.open(pdfUrl, "_blank");
  }
  function getInitiationLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.farInimationLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo$owners3, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : (_item$landInfo$owners3 = _item$landInfo$owners2.name) === null || _item$landInfo$owners3 === void 0 ? void 0 : _item$landInfo$owners3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.BPA) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$auditDetails2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.mobileNumber) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails3;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-status"
      }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-resubmit"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/edcrPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-receipt"
      }, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate = item.taxHeadEstimates) === null || _item$taxHeadEstimate === void 0 ? void 0 : _item$taxHeadEstimate[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
          history.push({
            pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")));
    }
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "proposalLetter",
    label: "Proposal Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-proposal"
    }, (item === null || item === void 0 ? void 0 : item.proposalUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => window.open(item === null || item === void 0 ? void 0 : item.proposalUrl, "_blank")
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-approval"
    }, (item === null || item === void 0 ? void 0 : item.compoundingApprovalLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "Rejection Letter",
    label: "Rejection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-rejection"
      }, (item === null || item === void 0 ? void 0 : item.compoundingRejectLetterUrl) && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate2 = item.taxHeadEstimates) === null || _item$taxHeadEstimate2 === void 0 ? void 0 : _item$taxHeadEstimate2[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getRejectionLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "shortfallLetter",
    label: "Shortfall Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$taxHeadEstimate3;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-shortfall"
      }, (item === null || item === void 0 ? void 0 : item.compoundingShortfallUrl) && (item === null || item === void 0 ? void 0 : (_item$taxHeadEstimate3 = item.taxHeadEstimates) === null || _item$taxHeadEstimate3 === void 0 ? void 0 : _item$taxHeadEstimate3[0]) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getShortfallLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    }
  }, {
    id: "initiationLetter",
    label: "Initiation Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-initiation"
    }, (item === null || item === void 0 ? void 0 : item.farInimationLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getInitiationLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "nocStatus",
    label: "NOC Status",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-noc"
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        Digit.SessionStorage.set("nocAppData", item);
        history.push(`${citizenBaseUrl}/obps/nocApplications/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF", "WF_BPA_12_MAKE_PAYMENT_APPLICATION_FEE"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        if (item.planOn === "SELF_MAP") {
          history.push({
            pathname: `/digit-ui/citizen/obps/services/selfResidentialPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        } else {
          Digit.SessionStorage.set("nocAppData", item);
          history.push({
            pathname: `/digit-ui/citizen/obps/services/mapSubmissionPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
          });
        }
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => {
        var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleClickAction = item => {
    var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const viewModal = item => {
    if (item !== null && item !== void 0 && item.applicationnumber) {
      setIdData(item === null || item === void 0 ? void 0 : item.applicationnumber);
      setshowMs(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
    value: tabIndex,
    onChange: handleTabChange,
    "aria-label": "Tab Group",
    variant: "scrollable",
    scrollButtons: "auto"
  }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "New Applications"
  }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
    label: "Archive Old Applications"
  }))), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 0,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption .mapsub-my-applications"
  }, "Compounding - My Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement("div", {
    hidden: tabIndex !== 1,
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container archieve-old-table"
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "5%"
    }
  }, "Sr No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "20%"
    }
  }, "Owner Name"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Owner Mobile Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "Application Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      width: "25%"
    }
  }, "View Summary"))), /*#__PURE__*/React__default.createElement("tbody", null, migratedData === null || migratedData === void 0 ? void 0 : migratedData.map((item, index) => {
    var _item$applicationdeta, _item$applicationdeta2, _item$applicationdeta3, _item$applicationdeta4, _item$applicationdeta5, _item$applicationdeta6;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: item === null || item === void 0 ? void 0 : item.applicationNo
    }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta = item.applicationdetails) === null || _item$applicationdeta === void 0 ? void 0 : (_item$applicationdeta2 = _item$applicationdeta.data) === null || _item$applicationdeta2 === void 0 ? void 0 : (_item$applicationdeta3 = _item$applicationdeta2.ownerDetail) === null || _item$applicationdeta3 === void 0 ? void 0 : _item$applicationdeta3.ownerName), /*#__PURE__*/React__default.createElement("td", null, item === null || item === void 0 ? void 0 : (_item$applicationdeta4 = item.applicationdetails) === null || _item$applicationdeta4 === void 0 ? void 0 : (_item$applicationdeta5 = _item$applicationdeta4.data) === null || _item$applicationdeta5 === void 0 ? void 0 : (_item$applicationdeta6 = _item$applicationdeta5.ownerDetail) === null || _item$applicationdeta6 === void 0 ? void 0 : _item$applicationdeta6.ownerContactNo), /*#__PURE__*/React__default.createElement("td", {
      style: {
        textDecoration: "underline blue 1px",
        cursor: "pointer",
        border: "1px solid #ddd",
        padding: "8px"
      },
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/structuralform12/${item === null || item === void 0 ? void 0 : item.applicationnumber}`
        });
      }
    }, item === null || item === void 0 ? void 0 : item.applicationnumber), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "10px",
        alignContent: "center",
        display: "flex"
      },
      variant: "contained",
      color: "success",
      onClick: () => viewModal(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: 10,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))), showMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showMs,
    onClose: () => {
      setshowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(MigratedSummary, {
    id: idData
  })), smShowMs && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  })));
};

const ApplicationLandUseConversion = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [smShowMs, setSmShowMs] = useState(false);
  const [smShowLandUseNOC, setSmShowLandUseNOC] = useState(false);
  const [page, setPage] = React__default.useState(0);
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [itemData, setItemData] = useState({});
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAction, setSelectedAction] = useState("All");
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status", "action"]);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const {
    data = {},
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType: "FORM_LANDUSE",
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "formLandUse"
  });
  React__default.useEffect(() => {
    refetch();
  }, [currentpage, rowsPerPage, refetch, page, selectedAction]);
  const handleViewSummary = item => {
    var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name);
    setIdData(item === null || item === void 0 ? void 0 : item.applicationNo);
    if ((item === null || item === void 0 ? void 0 : item.applicationNo) != null) {
      setSmShowMs(true);
    } else {
      console.log("Application Number Null ");
    }
  };
  const handleActionChange = action => {
    setSelectedAction(action);
    setCurentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$landInfo2$owner3, _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : (_item$landInfo2$owner3 = _item$landInfo2$owner2.name) === null || _item$landInfo2$owner3 === void 0 ? void 0 : _item$landInfo2$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.LandUse) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.name) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$landInfo7$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : (_item$landInfo7$owner3 = _item$landInfo7$owner2.mobileNumber) === null || _item$landInfo7$owner3 === void 0 ? void 0 : _item$landInfo7$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    renderCell: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    renderCell: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-name"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-mobile"
      }, (item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-apptype"
    }, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    renderCell: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-date"
      }, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    renderCell: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-status"
      }, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "receipt",
    label: "Receipt",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-receipt"
    }, (item === null || item === void 0 ? void 0 : item.paymentStatus) === "SUCCESS" && /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "contained",
      className: "btn-table-action",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/professional/payment/${item === null || item === void 0 ? void 0 : item.applicationNo}/${item === null || item === void 0 ? void 0 : item.tenantId}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")))
  }, {
    id: "objectionLetter",
    label: "Objection Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-objection"
    }, (item === null || item === void 0 ? void 0 : item.objectionLetterUrl) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleObjectionLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }, {
    id: "approvalLetter",
    label: "Approval Letter",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => {
      var _item$descriptionOfLa;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-approval"
      }, (item === null || item === void 0 ? void 0 : item.status) === "APPROVED" && (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => handleOpenLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "Letter")));
    }
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    renderCell: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-action"
    }, ["INITIATE", "UPLOAD_DOC", "REVERT_WITH_OBSERVATION"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        const target = item !== null && item !== void 0 && item.oldCaseApplicationNo ? `/digit-ui/citizen/obps/services/oldCaseSearchLU/${item === null || item === void 0 ? void 0 : item.applicationNo}` : `/digit-ui/citizen/obps/services/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`;
        history.push(target);
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => handleViewSummary(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const handleObjectionLetter = item => {
    const objectionKey = Object.keys(item === null || item === void 0 ? void 0 : item.objectionLetterUrl).filter(key => key.startsWith("objection_")).sort().at(-1);
    const objectionLetterUrl = item === null || item === void 0 ? void 0 : item.objectionLetterUrl[objectionKey];
    window.open(objectionLetterUrl, "_blank");
  };
  const handleClickAction = item => {
    var _item$landInfo10, _item$landInfo10$owne, _item$landInfo10$owne2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo10 = item.landInfo) === null || _item$landInfo10 === void 0 ? void 0 : (_item$landInfo10$owne = _item$landInfo10.owners) === null || _item$landInfo10$owne === void 0 ? void 0 : (_item$landInfo10$owne2 = _item$landInfo10$owne[0]) === null || _item$landInfo10$owne2 === void 0 ? void 0 : _item$landInfo10$owne2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structural/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpenLetter = item => {
    if (item !== null && item !== void 0 && item.approvalLetterUrl) {
      const approvalLetterUrlLandUse = `${item === null || item === void 0 ? void 0 : item.approvalLetterUrl}`;
      window.open(approvalLetterUrlLandUse, "_blank");
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Land Use \u2013 My Applications"), /*#__PURE__*/React__default.createElement("div", {
    className: "combine-tab-panel"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "All" ? "active" : "",
    onClick: () => handleActionChange("All"),
    style: {
      cursor: "pointer"
    }
  }, "All"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Submitted" ? "active" : "",
    onClick: () => handleActionChange("Submitted"),
    style: {
      cursor: "pointer"
    }
  }, "Submitted"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Shortfall" ? "active" : "",
    onClick: () => handleActionChange("Shortfall"),
    style: {
      cursor: "pointer"
    }
  }, "Shortfall"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Reject" ? "active" : "",
    onClick: () => handleActionChange("Reject"),
    style: {
      cursor: "pointer"
    }
  }, "Reject"), /*#__PURE__*/React__default.createElement("span", {
    className: selectedAction === "Approved" ? "active" : "",
    onClick: () => handleActionChange("Approved"),
    style: {
      cursor: "pointer"
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, loader ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "Loading...")) : (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 5,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.renderCell(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [20, 50, 100, 200, 400, 1000],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => {
      setSmShowMs(false);
    }
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: "formLandUse"
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application NOC Details",
    dataOpen: smShowLandUseNOC,
    onClose: () => {
      setSmShowLandUseNOC(false);
    }
  }, /*#__PURE__*/React__default.createElement(ViewLandUseNoc, {
    itemData: itemData
  })));
};

const SubStep2$9 = ({
  formData,
  tenantId,
  handleTabChange
}) => {
  var _formData$additionalD;
  const history = useHistory$2();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, "PRESS RELEASE FEE:"), /*#__PURE__*/React__default.createElement("strong", null, `₹ ${(formData === null || formData === void 0 ? void 0 : formData.pressReleaseAmount) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || 0}`), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Make Payment",
    type: "submit",
    sx: {
      backgroundColor: "#157CB3",
      width: "150px",
      letterSpacing: "normal"
    },
    onClick: () => handleTabChange(1, formData)
  }));
};

const getFormSuggestionData = (t, id = null) => {
  var _Digit$SessionStorage, _edcrData$planDetail, _edcrData$planDetail$, _edcrData$planDetail$2, _mdmsData$BPA, _planDetail$plot, _planDetail$virtualBu7, _planDetail$virtualBu8, _planDetail$virtualBu9, _planDetail$virtualBu10, _planDetail$virtualBu11, _planDetail$planInfoP2, _planDetail$plot3, _planDetail$blocks3, _planDetail$parkingDe3, _planDetail$parkingDe4, _Digit2, _scrutinyDetails$city, _planInformation$corr, _scrutinyDetails$loca, _planInformation$corr2, _scrutinyDetails$vill, _planInformation$corr3;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const edcrData = (_Digit$SessionStorage = Digit.SessionStorage.get("EDCR_CREATE")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage[0];
  const planDetail = edcrData === null || edcrData === void 0 ? void 0 : edcrData.planDetail;
  const isRescrutiny = (planDetail === null || planDetail === void 0 ? void 0 : planDetail.applicationScrutinyType) || false;
  const regulatedObj = edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$planDetail = edcrData.planDetail) === null || _edcrData$planDetail === void 0 ? void 0 : (_edcrData$planDetail$ = _edcrData$planDetail.reportOutput) === null || _edcrData$planDetail$ === void 0 ? void 0 : (_edcrData$planDetail$2 = _edcrData$planDetail$.scrutinyDetails) === null || _edcrData$planDetail$2 === void 0 ? void 0 : _edcrData$planDetail$2.filter(e => e.key === "Block_1_Side Setback");
  const {
    isSuccess: isMdmsSuccess,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType = isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot = planDetail.plot) === null || _planDetail$plot === void 0 ? void 0 : _planDetail$plot.area, planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const planInformation = planDetail === null || planDetail === void 0 ? void 0 : planDetail.planInformation;
  if (id && !isRescrutiny) {
    var _data$BPA;
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    const _applicationData = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
    return {
      applicationData: _applicationData,
      isAppDataLoading
    };
  } else if (id && isRescrutiny) {
    var _data$BPA2, _planDetail$virtualBu, _planDetail$virtualBu2, _planDetail$virtualBu3, _planDetail$virtualBu4, _planDetail$virtualBu5, _planDetail$planInfoP, _planDetail$plot2, _planDetail$blocks2, _planDetail$virtualBu6, _planDetail$parkingDe, _planDetail$parkingDe2, _Digit;
    console.log(isRescrutiny, "isRescrutinyyyyyy");
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, {
        applicationId: id,
        isEmployee: false
      });
    };
    const {
      data,
      isLoading: isAppDataLoading,
      isSuccess
    } = useQuery({
      queryKey: [id],
      queryFn: fetchApplicationData,
      enabled: isMdmsSuccess
    });
    let _applicationData2 = isSuccess && (data === null || data === void 0 ? void 0 : (_data$BPA2 = data.BPA) === null || _data$BPA2 === void 0 ? void 0 : _data$BPA2[0]);
    _applicationData2 = {
      ..._applicationData2,
      applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
      occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
      edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
      totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu = planDetail.virtualBuilding) === null || _planDetail$virtualBu === void 0 ? void 0 : _planDetail$virtualBu.totalBuitUpArea,
      totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu2 = planDetail.virtualBuilding) === null || _planDetail$virtualBu2 === void 0 ? void 0 : _planDetail$virtualBu2.totalProposedArea,
      totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu3 = planDetail.virtualBuilding) === null || _planDetail$virtualBu3 === void 0 ? void 0 : _planDetail$virtualBu3.totalExistingBuiltUpArea,
      maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu4 = planDetail.virtualBuilding) === null || _planDetail$virtualBu4 === void 0 ? void 0 : (_planDetail$virtualBu5 = _planDetail$virtualBu4.totalCoverageArea) === null || _planDetail$virtualBu5 === void 0 ? void 0 : _planDetail$virtualBu5.toFixed(2)) || null,
      typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
      propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP = planDetail.planInfoProperties) === null || _planDetail$planInfoP === void 0 ? void 0 : _planDetail$planInfoP.PROPERTY_TYPE)),
      proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
      revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
      khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
      khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
      plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot2 = planDetail.plot) === null || _planDetail$plot2 === void 0 ? void 0 : _planDetail$plot2.area) || 0,
      totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
      blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
      noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks2 = planDetail.blocks) === null || _planDetail$blocks2 === void 0 ? void 0 : _planDetail$blocks2.length) || 0,
      premiumFAR: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu6 = planDetail.virtualBuilding) === null || _planDetail$virtualBu6 === void 0 ? void 0 : _planDetail$virtualBu6.premiumFarArea) || 0,
      demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
      parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe = planDetail.parkingDetails) === null || _planDetail$parkingDe === void 0 ? void 0 : _planDetail$parkingDe.overAllParkingArea) || 0,
      parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe2 = planDetail.parkingDetails) === null || _planDetail$parkingDe2 === void 0 ? void 0 : _planDetail$parkingDe2.parkingFloorNo) || 0,
      activeTab: ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("MS_CURRENT_TAB")) || 0,
      riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
      planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
      updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
      dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
      natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
      proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
      sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
      sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
      noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
      plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
      district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
      sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
      tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
      revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
      landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
      schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
      buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
      otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
      planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
      buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
      projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
      isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
      prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
      isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
      typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
      plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
      plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
      needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
      plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
      isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
      isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
      isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
      constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
      layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
      layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
      groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
      far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
      isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
      setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
      setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
      setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
      setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
      zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
      isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
      subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
      primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
      activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
      communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
      anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
      khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
      sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo
    };
    return {
      applicationData: _applicationData2,
      isAppDataLoading
    };
  }
  const applicationType = "FORM_PRESSRELEASE";
  const userInfo = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.form12);
  const [, applicationFlow] = useDepartmentSelector();
  const applicantName = toTitleCase((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantName));
  const applicationData = {
    tenantId,
    applicationNo: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber) || null,
    applicationDate: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationDate) || null,
    applicationSubType: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType) || null,
    occupancy: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.occupancy) || null,
    edcrNumber: (edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber) || null,
    totalBuildUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu7 = planDetail.virtualBuilding) === null || _planDetail$virtualBu7 === void 0 ? void 0 : _planDetail$virtualBu7.totalBuitUpArea,
    totalProposedArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu8 = planDetail.virtualBuilding) === null || _planDetail$virtualBu8 === void 0 ? void 0 : _planDetail$virtualBu8.totalProposedArea,
    totalExistingBuiltUpArea: planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu9 = planDetail.virtualBuilding) === null || _planDetail$virtualBu9 === void 0 ? void 0 : _planDetail$virtualBu9.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$virtualBu10 = planDetail.virtualBuilding) === null || _planDetail$virtualBu10 === void 0 ? void 0 : (_planDetail$virtualBu11 = _planDetail$virtualBu10.totalCoverageArea) === null || _planDetail$virtualBu11 === void 0 ? void 0 : _planDetail$virtualBu11.toFixed(2)) || null,
    typeofArea: toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : planInformation.landUseZone),
    propertyType: toTitleCase((planInformation === null || planInformation === void 0 ? void 0 : planInformation.applicantPropertyType) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$planInfoP2 = planDetail.planInfoProperties) === null || _planDetail$planInfoP2 === void 0 ? void 0 : _planDetail$planInfoP2.PROPERTY_TYPE)),
    proposal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.proposalSubmittedFor) || null,
    revenueVillageMohal: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.mauza) || null,
    khataNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khataNo) || null,
    khatauniNo: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.khatauniNo) || null,
    plotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$plot3 = planDetail.plot) === null || _planDetail$plot3 === void 0 ? void 0 : _planDetail$plot3.area) || 0,
    plotAreaDoc: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaDoc,
    plotAreaPos: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotAreaPossession,
    siteAddress: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landAddress,
    totalPlotArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.plotArea) || 0,
    blocks: (planDetail === null || planDetail === void 0 ? void 0 : planDetail.blocks) || null,
    basicFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.basicFAR,
    purchasableFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.purchasableFAR,
    premiumFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.premiumFAR,
    noOfBlocks: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$blocks3 = planDetail.blocks) === null || _planDetail$blocks3 === void 0 ? void 0 : _planDetail$blocks3.length) || 0,
    demolitionArea: (planInformation === null || planInformation === void 0 ? void 0 : planInformation.demolitionArea) || null,
    parkingArea: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe3 = planDetail.parkingDetails) === null || _planDetail$parkingDe3 === void 0 ? void 0 : _planDetail$parkingDe3.overAllParkingArea) || 0,
    parkingFloorNo: (planDetail === null || planDetail === void 0 ? void 0 : (_planDetail$parkingDe4 = planDetail.parkingDetails) === null || _planDetail$parkingDe4 === void 0 ? void 0 : _planDetail$parkingDe4.parkingFloorNo) || 0,
    activeTab: ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("MS_CURRENT_TAB")) || 0,
    riskType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.riskType,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null
    },
    planReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planReport,
    updatedDxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.updatedDxfFile,
    dxfFile: edcrData === null || edcrData === void 0 ? void 0 : edcrData.dxfFile,
    workflow: {
      action: "INITIATE",
      assignes: null
    },
    landInfo: {
      owners: null,
      address: {
        city: planInformation === null || planInformation === void 0 ? void 0 : planInformation.district,
        locality: {
          code: ""
        },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
      },
      tenantId
    },
    landAreaDetails: {
      city: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$city = scrutinyDetails.city) === null || _scrutinyDetails$city === void 0 ? void 0 : _scrutinyDetails$city.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr = planInformation.correspondenceAddress) === null || _planInformation$corr === void 0 ? void 0 : _planInformation$corr.district) || null,
      locality: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$loca = scrutinyDetails.locality) === null || _scrutinyDetails$loca === void 0 ? void 0 : _scrutinyDetails$loca.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr2 = planInformation.correspondenceAddress) === null || _planInformation$corr2 === void 0 ? void 0 : _planInformation$corr2.tehsil) || null
      },
      village: {
        name: (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$vill = scrutinyDetails.village) === null || _scrutinyDetails$vill === void 0 ? void 0 : _scrutinyDetails$vill.name) || toTitleCase(planInformation === null || planInformation === void 0 ? void 0 : (_planInformation$corr3 = planInformation.correspondenceAddress) === null || _planInformation$corr3 === void 0 ? void 0 : _planInformation$corr3.town) || null
      },
      areaType: scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.areaType
    },
    businessService: "BPA_PRESS_RELEASE",
    documents,
    viewPdf: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPdf,
    viewPlanReport: edcrData === null || edcrData === void 0 ? void 0 : edcrData.viewPlanReport,
    natureOfConstruction: edcrData === null || edcrData === void 0 ? void 0 : edcrData.natureOfConstruction,
    proposalType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.proposalType,
    sanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionDate,
    sanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sanctionNumber,
    noOfPlots: edcrData === null || edcrData === void 0 ? void 0 : edcrData.noOfPlots,
    plotNumbers: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNumbers,
    district: edcrData === null || edcrData === void 0 ? void 0 : edcrData.district,
    sectorNoPlotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNoPlotNo,
    tehsil: edcrData === null || edcrData === void 0 ? void 0 : edcrData.tehsil,
    revenueVillage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.revenueVillage,
    landMark: edcrData === null || edcrData === void 0 ? void 0 : edcrData.landMark,
    schemeName: edcrData === null || edcrData === void 0 ? void 0 : edcrData.schemeName,
    buildingClassification: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingClassification,
    otherbuildingClass: edcrData === null || edcrData === void 0 ? void 0 : edcrData.otherbuildingClass,
    planOn: edcrData === null || edcrData === void 0 ? void 0 : edcrData.planOn,
    buildingHeight: edcrData === null || edcrData === void 0 ? void 0 : edcrData.buildingHeight,
    projectType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.projectType,
    isRevised: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isRevised,
    prevFileNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.prevFileNo,
    isSpecialProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialProject,
    typeOfProject: edcrData === null || edcrData === void 0 ? void 0 : edcrData.typeOfProject,
    plotSubdivided: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotSubdivided,
    plotNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotNo,
    needCompounding: edcrData === null || edcrData === void 0 ? void 0 : edcrData.needCompounding,
    plotLeaseHold: edcrData === null || edcrData === void 0 ? void 0 : edcrData.plotLeaseHold,
    isApprovedLayout: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isApprovedLayout,
    isSpecialGroundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialGroundCoverage,
    isSpecialFAR: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSpecialFAR,
    constructionType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.constructionType,
    layoutsanctionNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionNumber,
    layoutsanctionDate: edcrData === null || edcrData === void 0 ? void 0 : edcrData.layoutsanctionDate,
    groundCoverage: edcrData === null || edcrData === void 0 ? void 0 : edcrData.groundCoverages,
    far: edcrData === null || edcrData === void 0 ? void 0 : edcrData.fars,
    isSetbackRequired: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isSetbackRequired,
    setbackFronts: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackFront,
    setbackRears: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackRear,
    setbackSide1: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide1,
    setbackSide2: edcrData === null || edcrData === void 0 ? void 0 : edcrData.previousSetbackSide2,
    zoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.zoneType,
    isMetroCity: edcrData === null || edcrData === void 0 ? void 0 : edcrData.isMetroCity,
    subZoneType: edcrData === null || edcrData === void 0 ? void 0 : edcrData.subZoneType,
    primaryUse: edcrData === null || edcrData === void 0 ? void 0 : edcrData.primaryUse,
    activityProposed: edcrData === null || edcrData === void 0 ? void 0 : edcrData.activityProposed,
    communityParking: edcrData === null || edcrData === void 0 ? void 0 : edcrData.communityParking,
    anyotherCondition: edcrData === null || edcrData === void 0 ? void 0 : edcrData.anyotherCondition,
    khasraNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.khasraNo,
    sectorNo: edcrData === null || edcrData === void 0 ? void 0 : edcrData.sectorNo,
    uiFlow: {
      flow: "Form12"
    }
  };
  return {
    applicationData,
    isAppDataLoading: false
  };
};

const FormSuggestionPortal = () => {
  var _Digit;
  const dispatch = useDispatch();
  console.log("insideformSuggestionnewform");
  const {
    initFormMTDocs,
    resetFormMTDocs
  } = bindActionCreators(formMTDocActions, dispatch);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const {
    id
  } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [activeTab, setActiveTab] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("FORM_SUGGESTION_TAB")) || 0);
  const [proposedSite, setProposedSite] = useState(null);
  const {
    applicationData,
    isAppDataLoading
  } = getFormSuggestionData(t, id);
  const {
    info: userInfo
  } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_PRESSRELEASE", applicationData);
  const {
    data: {
      LandUseMasterData: {
        Authorities: schemeTypeData
      } = {}
    } = {},
    isLoading: schemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {},
    isLoading: nonSchemeTypeDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "FORMLANDUSE");
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({
        ...data
      });
    } else {
      setParams({
        ...params,
        ...{
          [key]: {
            ...params[key],
            ...data
          }
        }
      });
    }
  };
  const handleTabChange = (nextTab, formData) => {
    console.log("nextTabFormData", formData, activeTab, nextTab);
    if (formData) {
      if (activeTab === 0 && formData && !(formData !== null && formData !== void 0 && formData.applicationNo)) {
        var _params$additionalDet, _formData$additionalD;
        const _pressFeeAmount = Number((params === null || params === void 0 ? void 0 : params.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : formData.pressReleaseFee) || (params === null || params === void 0 ? void 0 : (_params$additionalDet = params.additionalDetails) === null || _params$additionalDet === void 0 ? void 0 : _params$additionalDet.pressReleaseFee) || (formData === null || formData === void 0 ? void 0 : (_formData$additionalD = formData.additionalDetails) === null || _formData$additionalD === void 0 ? void 0 : _formData$additionalD.pressReleaseFee));
        const data = {
          ...params,
          ...formData,
          pressReleaseAmount: _pressFeeAmount,
          pressReleaseFee: _pressFeeAmount,
          businessService: "BPA_PRESS_RELEASE"
        };
        data.oldMapSubApplNumber = data.applicationNo;
        delete data.applicationNo;
        data.workflow = {
          action: "INITIATE",
          assignes: null
        };
        Digit.OBPSService.createLandUseUP({
          LandUse: data
        }, tenantId).then(res => {
          var _res$LandUse, _res$LandUse2, _res$LandUse2$;
          console.log("createLandUseUPResponse", res, res === null || res === void 0 ? void 0 : (_res$LandUse = res.LandUse) === null || _res$LandUse === void 0 ? void 0 : _res$LandUse.length);
          if (res !== null && res !== void 0 && (_res$LandUse2 = res.LandUse) !== null && _res$LandUse2 !== void 0 && (_res$LandUse2$ = _res$LandUse2[0]) !== null && _res$LandUse2$ !== void 0 && _res$LandUse2$.applicationNo) {
            onSelect("", {
              ...formData,
              ...res.LandUse[0]
            }, "");
            Modal("Application Created", `Application created Successfully!`, "success");
          }
          setActiveTab(nextTab);
          const updatedFormData = {
            ...formData,
            ...data
          };
          Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
          Digit.SessionStorage.set("FORM_PRESSRELEASE", updatedFormData);
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          Modal("Error", `${e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message}`, "error");
        });
      } else {
        const data = {
          ...params,
          ...formData,
          tenantId: (params === null || params === void 0 ? void 0 : params.tenantId) || tenantId
        };
        try {
          let redirectUrl = null;
          let message = "";
          if (activeTab === 1) {
            data.workflow = {
              action: "MAKE_PAYMENT",
              assignes: null
            };
            redirectUrl = `${citizenBaseUrl}/payment/collect/BPA.MAP_PRESSRELEASE_FEE/${params === null || params === void 0 ? void 0 : params.applicationNo}/${tenantId}/tenantId=${tenantId}`;
            message = `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> updated successfully, redirecting to payment page.`;
          } else {
            data.workflow = {
              action: "UPLOAD_DOC",
              assignes: null
            };
            redirectUrl = null;
            message = `Application <strong>${data === null || data === void 0 ? void 0 : data.applicationNo}</strong> updated successfully!`;
          }
          {
            updateApiCall.mutate({
              LandUse: data
            }, {
              onSuccess: res => {
                onSelect("", res.LandUse[0]);
                setActiveTab(nextTab);
                Modal("Data has been saved successfully!", message, "success", redirectUrl);
                Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              }
            });
          }
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("FORM_SUGGESTION_TAB", nextTab);
    }
  };
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return /*#__PURE__*/React__default.createElement(SubStep1$8, {
          formData: params,
          userInfo: userInfo,
          handleTabChange: handleTabChange,
          setProposedSite: setProposedSite,
          schemeTypeData: schemeTypeData,
          nonSchemeTypeData: nonSchemeTypeData,
          id: id
        });
      case 1:
        return /*#__PURE__*/React__default.createElement(SubStep2$9, {
          formData: params,
          userInfo: userInfo,
          id: id,
          tenantId: tenantId,
          handleTabChange: handleTabChange
        });
      default:
        return null;
    }
  };
  return (
    /*#__PURE__*/
    React__default.createElement(Box$2, {
      sx: {
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        overflowY: "auto",
        padding: "20px"
      },
      className: "bg-white"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formStripLandUse mb-3 border-0"
    }, /*#__PURE__*/React__default.createElement("h2", null, "Invitation/Suggestion Form")), /*#__PURE__*/React__default.createElement("div", {
      className: "main-panel-corner land-use-corner"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "left-corner"
    }, /*#__PURE__*/React__default.createElement(PrimaryTabsWrapper, null, /*#__PURE__*/React__default.createElement(PrimaryTabs, {
      value: activeTab,
      onChange: (e, i) => handleTabChange(i),
      "aria-label": "Tab Group",
      variant: "scrollable",
      scrollButtons: "auto"
    }, /*#__PURE__*/React__default.createElement(PrimaryTab, {
      label: "Application Form"
    }), /*#__PURE__*/React__default.createElement(PrimaryTab, {
      label: "Fees"
    })))), renderContent()))
  );
};

const FormSuggestionApplications = () => {
  var _Digit$UserService$ge;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [idData, setIdData] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [rowsPerPage, setRowsPerPage] = React__default.useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [currentpage, setCurentPage] = React__default.useState(0);
  const [selectedAction, setSelectedAction] = useState("All");
  const applicationType = "FORM_PRESSRELEASE";
  const {
    data,
    isLoading: loader,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationType,
    pageNumber: currentpage + 1,
    pageSize: rowsPerPage,
    ...(selectedAction !== "All" && {
      action: selectedAction
    })
  }, {
    formType: "FORM_PRESSRELEASE"
  });
  console.log("dataFromMapsubapplicationSearch", data);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  const [filters, setFilters] = useState({
    name: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: ""
  });
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [page, setPage] = React__default.useState(0);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
  }, []);
  const StyleTabelCell = styled$1(TableCell$2)(({
    theme
  }) => ({
    [`&.${tableCellClasses$1.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
      fontSize: 16
    },
    [`&.${tableCellClasses$1.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow$2)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.common.white
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2, _item$landInfo$owners3, _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2, _item$applicationNo, _t, _t2, _item$auditDetails;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : (_item$landInfo$owners3 = _item$landInfo$owners2.name) === null || _item$landInfo$owners3 === void 0 ? void 0 : _item$landInfo$owners3.toLowerCase()) || "";
          case "mobileNumber":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "";
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return ((_t = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "status":
            return ((_t2 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t2 === void 0 ? void 0 : _t2.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = column => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (data === null || data === void 0 ? void 0 : data.LandUse) || (data === null || data === void 0 ? void 0 : data.BPA) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2, _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : _item$landInfo4$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$landInfo5$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : (_item$landInfo5$owner3 = _item$landInfo5$owner2.name) === null || _item$landInfo5$owner3 === void 0 ? void 0 : _item$landInfo5$owner3.toLowerCase().includes(filters.name.toLowerCase());
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$landInfo6$owner3;
        return item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : (_item$landInfo6$owner3 = _item$landInfo6$owner2.mobileNumber) === null || _item$landInfo6$owner3 === void 0 ? void 0 : _item$landInfo6$owner3.includes(filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => {
        var _item$applicationNo2;
        return item === null || item === void 0 ? void 0 : (_item$applicationNo2 = item.applicationNo) === null || _item$applicationNo2 === void 0 ? void 0 : _item$applicationNo2.toLowerCase().includes(filters.applicationNo.toLowerCase());
      });
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => {
        var _t3;
        return (_t3 = t(item === null || item === void 0 ? void 0 : item.applicationType)) === null || _t3 === void 0 ? void 0 : _t3.toLowerCase().includes(filters.applicationType.toLowerCase());
      });
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _t4;
        return (_t4 = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t4 === void 0 ? void 0 : _t4.toLowerCase().includes(filters.status.toLowerCase());
      });
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  console.log("paginatedDatasuggestion", paginatedData, filteredData);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleClickAction = item => {
    var _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2;
    window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
    Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.name);
    Digit.SessionStorage.set("FASTPAS_ID", item);
    Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
    history.push({
      pathname: `/digit-ui/citizen/obps/structural/FORM_PRESSRELEASE/${item === null || item === void 0 ? void 0 : item.applicationNo}`
    });
  };
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    width: "5%",
    render: (item, index, page, rowsPerPage) => /*#__PURE__*/React__default.createElement("td", {
      className: "td-srno"
    }, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    width: "12%",
    render: item => {
      var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name) || "-");
    }
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
      return /*#__PURE__*/React__default.createElement("td", null, (item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber) || "-");
    }
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-appno"
    }, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleClickAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"))
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    width: "10%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, t(item === null || item === void 0 ? void 0 : item.applicationType) || "-")
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    width: "10%",
    render: item => {
      var _item$auditDetails2;
      return /*#__PURE__*/React__default.createElement("td", null, convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    width: "13%",
    render: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return /*#__PURE__*/React__default.createElement("td", {
          className: "td-status"
        }, `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})`);
      }
      return /*#__PURE__*/React__default.createElement("td", null, t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-");
    }
  }, {
    id: "resubmit",
    label: "Resubmit",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT"].includes(item === null || item === void 0 ? void 0 : item.status) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => history.push({
        pathname: `/digit-ui/citizen/obps/services/formSuggestionPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`,
        state: {
          applicationNumber: item === null || item === void 0 ? void 0 : item.applicationId
        }
      })
    }, /*#__PURE__*/React__default.createElement("span", null, "Resubmit")))
  }, {
    id: "action",
    label: "Action",
    filterable: false,
    sortable: false,
    width: "13%",
    render: item => /*#__PURE__*/React__default.createElement("td", null, ["INITIATE", "UPLOAD_DOC", "REVERT_TO_APPLICANT", "MAKE_PAYMENT_SELF"].includes(item === null || item === void 0 ? void 0 : item.status) ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        window.localStorage.setItem("ApplicationStatus", item === null || item === void 0 ? void 0 : item.status);
        history.push({
          pathname: `/digit-ui/citizen/obps/services/formSuggestionPortal/${item === null || item === void 0 ? void 0 : item.applicationId}`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, "Edit")) : /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "success",
      onClick: () => handleClickAction(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View")))
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  return /*#__PURE__*/React__default.createElement("div", null, loader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "Form Suggestion Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    className: "bg-white",
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), " (", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: "#fff"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    "aria-label": "sticky table",
    className: "citizen-application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    display: "flex",
    alignItems: "center",
    key: column.id
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `filter-${column.id}`
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id)
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, (paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.length) === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length + 6,
    align: "center"
  }, "No records found")) : paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => column.render(item, index, page, rowsPerPage))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }))));
};

const TLContext = createContext({});
const TLContextProvider = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement(TLContext.Provider, {
    value: {}
  }, /*#__PURE__*/React__default.createElement(ComplicesRemarksProvider, null, /*#__PURE__*/React__default.createElement(ScrutinyRemarksProvider, null, children)));
};

const App = ({
  path
}) => {
  var _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi, _Digit3, _Digit3$ComponentRegi, _Digit4, _Digit4$ComponentRegi, _Digit5, _Digit5$ComponentRegi, _Digit6, _Digit6$ComponentRegi, _Digit7, _Digit7$ComponentRegi, _Digit8, _Digit8$ComponentRegi, _Digit9, _Digit9$ComponentRegi;
  const {
    t
  } = useTranslation();
  const CreateEDCR = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent("ObpsCreateEDCR");
  const CreateOCEDCR = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent("ObpsCreateOCEDCR");
  const NewBuildingPermit = (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : (_Digit3$ComponentRegi = _Digit3.ComponentRegistryService) === null || _Digit3$ComponentRegi === void 0 ? void 0 : _Digit3$ComponentRegi.getComponent("ObpsNewBuildingPermit");
  const Form11BuildingPlanPermit = (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$ComponentRegi = _Digit4.ComponentRegistryService) === null || _Digit4$ComponentRegi === void 0 ? void 0 : _Digit4$ComponentRegi.getComponent("Form11BuildingPlanPermit");
  const Form26BuildingPlanPermit = (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : (_Digit5$ComponentRegi = _Digit5.ComponentRegistryService) === null || _Digit5$ComponentRegi === void 0 ? void 0 : _Digit5$ComponentRegi.getComponent("Form26BuildingPlanPermit");
  const OCBuildingPermit = (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : (_Digit6$ComponentRegi = _Digit6.ComponentRegistryService) === null || _Digit6$ComponentRegi === void 0 ? void 0 : _Digit6$ComponentRegi.getComponent("ObpsOCBuildingPermit");
  const StakeholderRegistration = (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : (_Digit7$ComponentRegi = _Digit7.ComponentRegistryService) === null || _Digit7$ComponentRegi === void 0 ? void 0 : _Digit7$ComponentRegi.getComponent("ObpsStakeholderRegistration");
  const EdcrInbox = (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : (_Digit8$ComponentRegi = _Digit8.ComponentRegistryService) === null || _Digit8$ComponentRegi === void 0 ? void 0 : _Digit8$ComponentRegi.getComponent("ObpsEdcrInbox");
  const BpaApplicationDetail = (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : (_Digit9$ComponentRegi = _Digit9.ComponentRegistryService) === null || _Digit9$ComponentRegi === void 0 ? void 0 : _Digit9$ComponentRegi.getComponent("ObpsCitizenBpaApplicationDetail");
  const isDocScreenAfterEdcr = sessionStorage.getItem("clickOnBPAApplyAfterEDCR") === "true" ? true : false;
  const formBasePath = "/digit-ui/citizen/obps/services/";
  return /*#__PURE__*/React__default.createElement(TLContextProvider, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !["response", "openlink/stakeholder", "/acknowledgement", `${formBasePath}ownerPortal`, `${formBasePath}ltpPortal`, `${formBasePath}mapSubmissionPortal`, `${formBasePath}formLandUse`, `${formBasePath}purchasableFAR`, `${formBasePath}edcrPortal`] && !isDocScreenAfterEdcr && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/home`,
    component: BPACitizenHomeScreen
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/search/application`,
    component: props => /*#__PURE__*/React__default.createElement(Search, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcrscrutiny/apply`,
    component: CreateEDCR
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcrscrutiny/oc-apply`,
    component: CreateOCEDCR
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/bpa/:applicationType/:serviceType`,
    component: NewBuildingPermit
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/form11`,
    component: Form11BuildingPlanPermit
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/form26`,
    component: Form26BuildingPlanPermit
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/ocbpa/:applicationType/:serviceType`,
    component: OCBuildingPermit
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/stakeholder/apply`,
    component: StakeholderRegistration
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/openlink/stakeholder/apply`,
    component: StakeholderRegistration
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/my-applications`,
    component: MyApplication
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/form12-applications`,
    component: Form12Applications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/bpa/inbox`,
    component: props => /*#__PURE__*/React__default.createElement(Inbox, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/bpa/inbox`,
    component: props => /*#__PURE__*/React__default.createElement(Inbox, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/tradelicence/payment/:id/:tenantId`,
    component: PaymentPrint
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/professional/payment/:authority/:plan/:form/:year/:serial/:tenantId`,
    component: PaymentPrint$1
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/subservice/payment/:id/:tenantId`,
    component: PaymentPrint$1
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/payment/failed/:id/`,
    component: PaymentFailed
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/form12inbox`,
    component: () => /*#__PURE__*/React__default.createElement(BPAForm12Inbox, {
      parentRoute: path,
      businessService: ["BPA"],
      filterComponent: "TL_INBOX_FILTER",
      initialStates: {},
      isInbox: true
    })
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcr/inbox`,
    component: props => /*#__PURE__*/React__default.createElement(EdcrInbox, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/stakeholder/:id`,
    component: ApplicationDetails
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/bpa/:id`,
    component: BpaApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/form12/:id`,
    component: Form12
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}`
  }, /*#__PURE__*/React__default.createElement(SideTopBarLayout, null, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `digit-ui/citizen/profile`,
    component: BPACommonSearchApp
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `digit-ui/citizen/user/profile`,
    component: UserProfile
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/ltpPortal/:id`,
    component: LTPRegistration
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/ltpPortal`,
    component: LTPRegistration
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/architect/:formType/:id`,
    component: ProfessionalApplicantDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/formProfessionalApplications`,
    component: ApplicationProfessional
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/registrationSummary`,
    component: RegistrationSummary
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/mapRevalidation/:id`,
    component: RevalidationPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/mapRevalidation`,
    component: RevalidationPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/owner-registration/:id`,
    component: OwnerRegistration
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/owner-registration`,
    component: OwnerRegistration
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/ownerPortal/:id`,
    component: OwnerPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/ownerPortal`,
    component: OwnerPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/selfResidentialPortal/:id`,
    component: ResidentialSelfPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/selfResidentialPortal`,
    component: ResidentialSelfPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/plinthPortal/:id`,
    component: PlinthPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/plinthPortal`,
    component: PlinthPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/LandUseConversion`,
    component: LandUseConversionNew
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/formSuggestion`,
    component: FormSuggestionPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/WorkCommencementModule`,
    component: WorkCommencementModule
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/completionPortal/:id`,
    component: CompletionPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/completionPortal`,
    component: CompletionPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/selfApprovalPortal/:id`,
    component: SelfApprovalPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/selfApprovalPortal`,
    component: SelfApprovalPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/purchasablePortal/:id`,
    component: PurchasableFARV3
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/purchasablePortal`,
    component: PurchasableFARV3
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/groupHousingPortal/:id`,
    component: GroupHousingPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/groupHousingPortal`,
    component: GroupHousingPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/propertyPortal`,
    component: RegisterProperty
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/selfCommercialPortal`,
    component: CommercialSelfPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/edcrPortal/:id`,
    component: EDCRPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/edcrPortal`,
    component: EDCRPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/farEdcrPortal/:id`,
    component: FarEDCRPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/farEdcrPortal`,
    component: FarEDCRPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcrscrutiny/apply/acknowledgement`,
    component: EDCRAcknowledgement
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/mapSubApplications`,
    component: MapSubApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/compoundingApplications`,
    component: CompoundingApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/nocApplications`,
    component: NOCTakeAction
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/plinthApplications`,
    component: PlintApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/formSuggestionApplications`,
    component: FormSuggestionApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/completionApplications`,
    component: CompletionApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/pFARApplications`,
    component: PFARApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/mapSubmissionPortal/:id`,
    component: MapSubmissionPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/compoundingModule`,
    component: CompoundingPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/formLandUse/:authority/:plan/:form/:year/:serial`,
    component: LandUse2
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/oldCaseSearchLU/:authority/:plan/:form/:year/:serial`,
    component: OldLandUse
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/oldCaseSearchLU`,
    component: OldLandUse
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/:formType/:state/:form/:year/:serial`,
    component: SUBApplicationForm11
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/mapSubmissionPortal`,
    component: MapSubmissionPortal
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/structuralform12/:authority/PL/:plan/:form/:year/:serial`,
    component: BpaApplicationForm12
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/structuralform12/:authority/:plan/:form/:year/:serial`,
    component: BpaApplicationForm12
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/structural/:formType/:authority/:plan/:form/:year/:serial`,
    component: SUBApplicationForm11
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/structuralform12/:id`,
    component: BpaApplicationForm12
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcrApplications`,
    component: EdcrApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/formLandUseApplications`,
    component: ApplicationFormLandUse
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/formLandUseConversionApplications`,
    component: ApplicationLandUseConversion
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/formLandUse`,
    component: LandUse2
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/purchasableFAR/:authority/:plan/:form/:year/:serial`,
    component: PurchasableFAR2
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/services/purchasableFAR`,
    component: PurchasableFAR2
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/purchasableFarApplications`,
    component: PurchasableFarApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/ownerApplications`,
    component: ownerApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/Payment/Applications`,
    component: PaymentDirect
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/Payment/Challan`,
    component: PaymentChallan
  })))))));
};

const FilterFormFieldsComponent$1 = ({
  statuses,
  isInboxLoading,
  registerRef,
  controlFilterForm,
  setFilterFormValue,
  filterFormState,
  getFilterFormValue,
  localitiesForEmployeesCurrentTenant,
  loadingLocalitiesForEmployeesCurrentTenant
}) => {
  const {
    t
  } = useTranslation();
  const availableOptions = [{
    code: "ASSIGNED_TO_ME",
    name: `${t("ES_INBOX_ASSIGNED_TO_ME")}`
  }, {
    code: "ASSIGNED_TO_ALL",
    name: `${t("ES_INBOX_ASSIGNED_TO_ALL")}`
  }];
  const stateId = Digit.ULBService.getStateId();
  const {
    data: stakeholderServiceTypes,
    isLoading: stakeholderServiceTypesLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "StakeholderRegistraition", "TradeTypetoRoleMapping", {
    select: data => {
      var _data$StakeholderRegi;
      return data === null || data === void 0 ? void 0 : (_data$StakeholderRegi = data.StakeholderRegistraition) === null || _data$StakeholderRegi === void 0 ? void 0 : _data$StakeholderRegi.TradeTypetoRoleMapping.reduce((accumulator, currentObject) => {
        const identifier = currentObject.tradeType.split(".")[0];
        if (accumulator.find(el => el.i18nKey.includes(identifier))) return accumulator;else return [...accumulator, {
          role: currentObject.role[0],
          i18nKey: `TRADELICENSE_TRADETYPE_${currentObject.tradeType.split(".")[0]}`,
          tradeType: currentObject.tradeType,
          identifier
        }];
      }, []);
    }
  });
  const selectedBusinessService = useWatch({
    control: controlFilterForm,
    name: "businessService",
    defaultValue: null
  });
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "assignee",
    control: controlFilterForm,
    render: props => {
      return /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          props.onChange(e.code);
        },
        selectedOption: availableOptions.filter(option => option.code === props.value)[0],
        optionsKey: "name",
        name: "assignee",
        options: availableOptions
      });
    }
  })), /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "businessService",
    control: controlFilterForm,
    render: props => {
      return stakeholderServiceTypesLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontSize: "18px",
          fontWeight: "600"
        }
      }, t("BPA_LICENSE_TYPE")), /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          setFilterFormValue("applicationStatus", []);
          props.onChange(e);
        },
        selectedOption: props.value,
        optionsKey: "i18nKey",
        options: stakeholderServiceTypes
      }));
    }
  })), selectedBusinessService ? /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement("div", {
    className: "filter-label",
    style: {
      fontSize: "18px",
      fontWeight: "600"
    }
  }, t("ACTION_TEST_APPLICATION_STATUS")), /*#__PURE__*/React__default.createElement(Controller, {
    name: "applicationStatus",
    control: controlFilterForm,
    render: props => {
      function changeItemCheckStatus(value) {
        props.onChange(value);
      }
      const renderStatusCheckBoxes = useMemo(() => {
        var _statuses$filter;
        return statuses === null || statuses === void 0 ? void 0 : (_statuses$filter = statuses.filter(e => e.businessservice === selectedBusinessService.identifier)) === null || _statuses$filter === void 0 ? void 0 : _statuses$filter.map((status, index) => {
          var _props$value2;
          return /*#__PURE__*/React__default.createElement(CheckBox$1, {
            key: index,
            onChange: e => {
              var _props$value;
              return e.target.checked ? changeItemCheckStatus([...props.value, status === null || status === void 0 ? void 0 : status.statusid]) : changeItemCheckStatus((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.filter(id => id !== (status === null || status === void 0 ? void 0 : status.statusid)));
            },
            checked: (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.includes(status === null || status === void 0 ? void 0 : status.statusid),
            label: `${t(`WF_${status.businessservice}_${status.applicationstatus}`)} (${status.count})`
          });
        });
      }, [props.value, statuses, selectedBusinessService]);
      return /*#__PURE__*/React__default.createElement(Fragment, null, isInboxLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment, null, renderStatusCheckBoxes));
    }
  })) : null);
};

const SearchFormFieldsComponents$1 = ({
  registerRef,
  searchFormState,
  searchFieldComponents
}) => {
  var _searchFormState$erro5, _searchFormState$erro6, _searchFormState$erro7, _searchFormState$erro8;
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  if (!isMobile) {
    var _searchFormState$erro, _searchFormState$erro2, _searchFormState$erro3, _searchFormState$erro4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "search-container",
      style: {
        width: "auto",
        marginLeft: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "search-complaint-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "complaint-input-container",
      style: {
        textAlign: "start"
      }
    }, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
      name: "applicationNo",
      inputRef: registerRef({})
    })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("CORE_COMMON_MOBILE_NUMBER")), /*#__PURE__*/React__default.createElement(MobileNumber, {
      name: "mobileNumber",
      type: "number",
      inputRef: registerRef({
        minLength: {
          value: 10,
          message: t("CORE_COMMON_MOBILE_ERROR")
        },
        maxLength: {
          value: 10,
          message: t("CORE_COMMON_MOBILE_ERROR")
        },
        pattern: {
          value: /[6789][0-9]{9}/,
          message: t("CORE_COMMON_MOBILE_ERROR")
        }
      })
    }), searchFormState !== null && searchFormState !== void 0 && (_searchFormState$erro = searchFormState.errors) !== null && _searchFormState$erro !== void 0 && (_searchFormState$erro2 = _searchFormState$erro["mobileNumber"]) !== null && _searchFormState$erro2 !== void 0 && _searchFormState$erro2.message ? /*#__PURE__*/React__default.createElement(CardLabelError, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro3 = searchFormState.errors) === null || _searchFormState$erro3 === void 0 ? void 0 : (_searchFormState$erro4 = _searchFormState$erro3["mobileNumber"]) === null || _searchFormState$erro4 === void 0 ? void 0 : _searchFormState$erro4.message) : null), /*#__PURE__*/React__default.createElement("div", {
      className: "search-action-wrapper",
      style: {
        width: "100%"
      }
    }, searchFieldComponents)))));
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
    name: "applicationNo",
    inputRef: registerRef({})
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("CORE_COMMON_MOBILE_NUMBER")), /*#__PURE__*/React__default.createElement(MobileNumber, {
    name: "mobileNumber",
    type: "number",
    inputRef: registerRef({
      minLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      maxLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      pattern: {
        value: /[6789][0-9]{9}/,
        message: t("CORE_COMMON_MOBILE_ERROR")
      }
    })
  }), searchFormState !== null && searchFormState !== void 0 && (_searchFormState$erro5 = searchFormState.errors) !== null && _searchFormState$erro5 !== void 0 && (_searchFormState$erro6 = _searchFormState$erro5["mobileNumber"]) !== null && _searchFormState$erro6 !== void 0 && _searchFormState$erro6.message ? /*#__PURE__*/React__default.createElement(CardLabelError, null, searchFormState === null || searchFormState === void 0 ? void 0 : (_searchFormState$erro7 = searchFormState.errors) === null || _searchFormState$erro7 === void 0 ? void 0 : (_searchFormState$erro8 = _searchFormState$erro7["mobileNumber"]) === null || _searchFormState$erro8 === void 0 ? void 0 : _searchFormState$erro8.message) : null));
};

const useInboxTableConfig$1 = ({
  parentRoute,
  onPageSizeChange,
  formState,
  totalCount,
  table,
  dispatch,
  onSortingByData
}) => {
  var _formState$tableForm, _formState$tableForm2, _formState$tableForm7, _formState$searchForm;
  const GetCell = value => /*#__PURE__*/React__default.createElement("span", {
    className: "cell-text styled-cell"
  }, value);
  const GetStatusCell = value => value === "Active" || value > 0 ? /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-success"
  }, value) : /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-error"
  }, value);
  const {
    t
  } = useTranslation();
  const tableColumnConfig = useMemo(() => {
    return [{
      Header: t("BPA_APPLICATION_NUMBER_LABEL"),
      accessor: "applicationNo",
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Link, {
          to: `${parentRoute}/stakeholder-inbox/stakeholder/${row.original["applicationId"]}`
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "link"
        }, row.original["applicationId"])));
      }
    }, {
      Header: t("CS_APPLICATION_DETAILS_APPLICATION_DATE"),
      accessor: "applicationDate",
      Cell: ({
        row
      }) => {
        var _row$original, _row$original2;
        return (_row$original = row.original) !== null && _row$original !== void 0 && _row$original["date"] ? GetCell(format(new Date((_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2["date"]), 'dd/MM/yyyy')) : "";
      }
    }, {
      Header: t("EVENTS_STATUS_LABEL"),
      accessor: row => t(`WF_${row === null || row === void 0 ? void 0 : row.businessService}_${row === null || row === void 0 ? void 0 : row.status}`)
    }, {
      Header: t("WF_INBOX_HEADER_CURRENT_OWNER"),
      accessor: row => row === null || row === void 0 ? void 0 : row.owner
    }, {
      Header: t("ES_INBOX_SLA_DAYS_REMAINING"),
      accessor: row => GetStatusCell(row === null || row === void 0 ? void 0 : row.sla)
    }];
  });
  return {
    getCellProps: cellInfo => {
      return {
        style: {
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    disableSort: false,
    autoSort: false,
    manualPagination: true,
    initSortI: "applicationDate",
    onPageSizeChange: onPageSizeChange,
    currentPage: ((_formState$tableForm = formState.tableForm) === null || _formState$tableForm === void 0 ? void 0 : _formState$tableForm.offset) / ((_formState$tableForm2 = formState.tableForm) === null || _formState$tableForm2 === void 0 ? void 0 : _formState$tableForm2.limit),
    onNextPage: () => {
      var _formState$tableForm3, _formState$tableForm4;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm3 = formState.tableForm) === null || _formState$tableForm3 === void 0 ? void 0 : _formState$tableForm3.offset) + parseInt((_formState$tableForm4 = formState.tableForm) === null || _formState$tableForm4 === void 0 ? void 0 : _formState$tableForm4.limit)
        }
      });
    },
    onPrevPage: () => {
      var _formState$tableForm5, _formState$tableForm6;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm5 = formState.tableForm) === null || _formState$tableForm5 === void 0 ? void 0 : _formState$tableForm5.offset) - parseInt((_formState$tableForm6 = formState.tableForm) === null || _formState$tableForm6 === void 0 ? void 0 : _formState$tableForm6.limit)
        }
      });
    },
    pageSizeLimit: (_formState$tableForm7 = formState.tableForm) === null || _formState$tableForm7 === void 0 ? void 0 : _formState$tableForm7.limit,
    onSort: onSortingByData,
    totalRecords: totalCount,
    onSearch: formState === null || formState === void 0 ? void 0 : (_formState$searchForm = formState.searchForm) === null || _formState$searchForm === void 0 ? void 0 : _formState$searchForm.message,
    onLastPage: () => {
      var _formState$tableForm8;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: Math.ceil(totalCount / 10) * 10 - parseInt((_formState$tableForm8 = formState.tableForm) === null || _formState$tableForm8 === void 0 ? void 0 : _formState$tableForm8.limit)
        }
      });
    },
    onFirstPage: () => dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        offset: 0
      }
    }),
    data: table,
    columns: tableColumnConfig
  };
};

const useInboxMobileCardsData$1 = ({
  parentRoute,
  table
}) => {
  const {
    t
  } = useTranslation();
  const dataForMobileInboxCards = table === null || table === void 0 ? void 0 : table.map(({
    applicationId,
    date,
    businessService,
    status,
    owner,
    sla
  }) => ({
    [t("BPA_APPLICATION_NUMBER_LABEL")]: applicationId,
    [t("CS_APPLICATION_DETAILS_APPLICATION_DATE")]: format(new Date(date), 'dd/MM/yyyy'),
    [t("EVENTS_STATUS_LABEL")]: t(`WF_${businessService}_${status}`),
    [t("WF_INBOX_HEADER_CURRENT_OWNER")]: owner,
    [t("ES_INBOX_SLA_DAYS_REMAINING")]: sla
  }));
  const MobileSortFormValues = () => {
    const sortOrderOptions = [{
      code: "DESC",
      i18nKey: "ES_COMMON_SORT_BY_DESC"
    }, {
      code: "ASC",
      i18nKey: "ES_COMMON_SORT_BY_ASC"
    }];
    const {
      control: controlSortForm
    } = useFormContext();
    return /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement(Controller, {
      name: "sortOrder",
      control: controlSortForm,
      render: ({
        onChange,
        value
      }) => /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          onChange(e.code);
        },
        selectedOption: sortOrderOptions.filter(option => option.code === value)[0],
        optionsKey: "i18nKey",
        name: "sortOrder",
        options: sortOrderOptions
      })
    }));
  };
  return {
    data: dataForMobileInboxCards,
    linkPrefix: `${parentRoute}/stakeholder-inbox/stakeholder/`,
    serviceRequestIdKey: t("BPA_APPLICATION_NUMBER_LABEL"),
    MobileSortFormValues
  };
};

const Inbox$1 = ({
  parentRoute
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const searchFormDefaultValues = {};
  const filterFormDefaultValues = {
    moduleName: "BPAREG",
    applicationStatus: [],
    locality: [],
    assignee: "ASSIGNED_TO_ALL"
  };
  const tableOrderFormDefaultValues = {
    sortBy: "",
    limit: window.Digit.Utils.browser.isMobile() ? 50 : 10,
    offset: 0,
    sortOrder: "DESC"
  };
  function formReducer(state, payload) {
    switch (payload.action) {
      case "mutateSearchForm":
        Digit.SessionStorage.set("STAKEHOLDER.INBOX", {
          ...state,
          searchForm: payload.data
        });
        return {
          ...state,
          searchForm: payload.data
        };
      case "mutateFilterForm":
        Digit.SessionStorage.set("STAKEHOLDER.INBOX", {
          ...state,
          filterForm: payload.data
        });
        return {
          ...state,
          filterForm: payload.data
        };
      case "mutateTableForm":
        Digit.SessionStorage.set("STAKEHOLDER.INBOX", {
          ...state,
          tableForm: payload.data
        });
        return {
          ...state,
          tableForm: payload.data
        };
    }
  }
  const InboxObjectInSessionStorage = Digit.SessionStorage.get("STAKEHOLDER.INBOX");
  const onSearchFormReset = setSearchFormValue => {
    setSearchFormValue("mobileNumber", null);
    setSearchFormValue("applicationNo", null);
    dispatch({
      action: "mutateSearchForm",
      data: searchFormDefaultValues
    });
  };
  const onFilterFormReset = setFilterFormValue => {
    setFilterFormValue("moduleName", "BPAREG");
    setFilterFormValue("applicationStatus", "");
    setFilterFormValue("locality", []);
    setFilterFormValue("assignee", "ASSIGNED_TO_ALL");
    dispatch({
      action: "mutateFilterForm",
      data: filterFormDefaultValues
    });
  };
  const onSortFormReset = setSortFormValue => {
    setSortFormValue("sortOrder", "DESC");
    dispatch({
      action: "mutateTableForm",
      data: tableOrderFormDefaultValues
    });
  };
  const formInitValue = useMemo(() => {
    return InboxObjectInSessionStorage || {
      filterForm: filterFormDefaultValues,
      searchForm: searchFormDefaultValues,
      tableForm: tableOrderFormDefaultValues
    };
  }, [Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.filterForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.searchForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.tableForm) || {})]);
  const [formState, dispatch] = useReducer(formReducer, formInitValue);
  const onPageSizeChange = e => {
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        limit: e.target.value
      }
    });
  };
  const onSortingByData = e => {
    if (e.length > 0) {
      const [{
        id,
        desc
      }] = e;
      const sortOrder = desc ? "DESC" : "ASC";
      const sortBy = id;
      if (!(formState.tableForm.sortBy === sortBy && formState.tableForm.sortOrder === sortOrder)) {
        dispatch({
          action: "mutateTableForm",
          data: {
            ...formState.tableForm,
            sortBy: id,
            sortOrder: desc ? "DESC" : "ASC"
          }
        });
      }
    }
  };
  const onMobileSortOrderData = data => {
    const {
      sortOrder
    } = data;
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        sortOrder
      }
    });
  };
  const {
    data: localitiesForEmployeesCurrentTenant,
    isLoading: loadingLocalitiesForEmployeesCurrentTenant
  } = Digit.Hooks.useBoundaryLocalities(tenantId, "revenue", {}, t);
  const PropsForInboxLinks = {
    logoIcon: /*#__PURE__*/React__default.createElement(CaseIcon, null),
    headerText: "CS_COMMON_OBPS",
    links: [{
      text: t("BPA_SEARCH_PAGE_TITLE"),
      link: "/digit-ui/employee/obps/search/application",
      businessService: "BPA",
      roles: ["BPAREG_EMPLOYEE", "BPAREG_APPROVER", "BPAREG_DOC_VERIFIER", "BPAREG_DOC_VERIFIER"]
    }]
  };
  const SearchFormFields = useCallback(({
    registerRef,
    searchFormState,
    searchFieldComponents
  }) => /*#__PURE__*/React__default.createElement(SearchFormFieldsComponents$1, {
    registerRef,
    searchFormState,
    searchFieldComponents
  }), []);
  const FilterFormFields = useCallback(({
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    getFilterFormValue
  }) => /*#__PURE__*/React__default.createElement(FilterFormFieldsComponent$1, {
    statuses,
    isInboxLoading,
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    filterFormState: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    getFilterFormValue,
    localitiesForEmployeesCurrentTenant,
    loadingLocalitiesForEmployeesCurrentTenant
  }), [statuses, isInboxLoading, localitiesForEmployeesCurrentTenant, loadingLocalitiesForEmployeesCurrentTenant]);
  const onSearchFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateSearchForm",
      data
    });
  };
  const onFilterFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateFilterForm",
      data
    });
  };
  const propsForSearchForm = {
    SearchFormFields,
    onSearchFormSubmit,
    searchFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.searchForm,
    resetSearchFormDefaultValues: searchFormDefaultValues,
    onSearchFormReset
  };
  const propsForFilterForm = {
    FilterFormFields,
    onFilterFormSubmit,
    filterFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    resetFilterFormDefaultValues: filterFormDefaultValues,
    onFilterFormReset
  };
  const propsForInboxTable = useInboxTableConfig$1({
    ...{
      parentRoute,
      onPageSizeChange,
      formState,
      totalCount,
      table,
      dispatch,
      onSortingByData
    }
  });
  const propsForInboxMobileCards = useInboxMobileCardsData$1({
    parentRoute,
    table
  });
  const propsForMobileSortForm = {
    onMobileSortOrderData,
    sortFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.tableForm,
    onSortFormReset
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Header, null, t("ES_COMMON_INBOX"), totalCount ? /*#__PURE__*/React__default.createElement("p", {
    className: "inbox-count"
  }, totalCount) : null), /*#__PURE__*/React__default.createElement(InboxComposer, _extends({
    isInboxLoading,
    PropsForInboxLinks
  }, propsForSearchForm, propsForFilterForm, propsForMobileSortForm, {
    propsForInboxTable,
    propsForInboxMobileCards,
    formState
  })));
};

function Address$1({
  applicationFlow,
  defaultValues,
  namePrefix,
  control,
  watch,
  setValue
}) {
  const permanentAddressKey = 'landInfo.owners[0].permanentAddress';
  const isPermanentAddress = namePrefix === permanentAddressKey;
  const [watchCorrespondenceAddress, watchCorrespondenceDistrict, watchCorrespondenceTehsil, watchPermanentDistrict, watchPermanentTehsil] = watch(['landInfo.owners[0].correspondenceAddress', 'landInfo.owners[0].correspondenceAddress.district', 'landInfo.owners[0].correspondenceAddress.tehsil', 'landInfo.owners[0].permanentAddress.district', 'landInfo.owners[0].permanentAddress.tehsil']);
  const handleSameAsCorrespondence = e => {
    if (e.target.checked) {
      setValue(permanentAddressKey, watchCorrespondenceAddress);
    } else {
      setValue(permanentAddressKey, {
        applicantName: '',
        applicantGuardianName: '',
        state: 'Uttar Pradesh',
        district: '',
        tehsil: '',
        town: '',
        address: '',
        pinno: '',
        type: isPermanentAddress ? "PERMANENT" : "CORRESPONDENCE"
      });
    }
  };
  const {
    data: districtData,
    isLoading: isDistrictDataLoading
  } = Digit.Hooks.useTenants();
  const districtList = !isDistrictDataLoading && applicationFlow ? districtData === null || districtData === void 0 ? void 0 : districtData.filter(district => {
    var _district$code;
    return (_district$code = district.code) === null || _district$code === void 0 ? void 0 : _district$code.includes(applicationFlow.toLowerCase());
  }) : [];
  const [correspondenceTehsilList, setCorrespondenceTehsilList] = useState([]);
  const [permanentTehsilList, setPermanentTehsilList] = useState([]);
  useEffect(() => {
    if (watchCorrespondenceDistrict) {
      var _districtList$find;
      const tehsilList = (_districtList$find = districtList.find(item => item.name === watchCorrespondenceDistrict)) === null || _districtList$find === void 0 ? void 0 : _districtList$find.boundary;
      setCorrespondenceTehsilList(tehsilList);
    }
  }, [watchCorrespondenceDistrict]);
  useEffect(() => {
    if (watchPermanentDistrict) {
      var _districtList$find2;
      const tehsilList = (_districtList$find2 = districtList.find(item => item.name === watchPermanentDistrict)) === null || _districtList$find2 === void 0 ? void 0 : _districtList$find2.boundary;
      setPermanentTehsilList(tehsilList);
    }
  }, [watchPermanentDistrict]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, isPermanentAddress ? /*#__PURE__*/React__default.createElement("div", {
    className: "checkboxWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Permanent Address"), /*#__PURE__*/React__default.createElement("label", {
    style: {
      alignItems: 'center',
      width: '18.25vw',
      marginBottom: 0,
      display: 'flex',
      gap: '0.5rem',
      translate: '-8px 0'
    }
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    onChange: handleSameAsCorrespondence
  }), "Same as Corr. Address")) : /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Correspondence Address"), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Name",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.applicantName,
    name: `${namePrefix}.applicantName`,
    type: "textInput",
    mandatory: true,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Guardian Name",
    maxLength: 30,
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.applicantGuardianName,
    name: `${namePrefix}.applicantGuardianName`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "State",
    defaultValue: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.state) || 'Uttar Pradesh',
    name: `${namePrefix}.state`,
    type: "textInput",
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: districtList,
    label: "District",
    placeholder: watchPermanentDistrict && 'District' || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.district) || 'District',
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.district,
    name: `${namePrefix}.district`,
    type: "selectInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: isPermanentAddress ? permanentTehsilList : correspondenceTehsilList,
    label: "Tehsil",
    placeholder: (isPermanentAddress ? watchPermanentTehsil : watchCorrespondenceTehsil) && 'Tehsil' || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.tehsil) || 'Tehsil',
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.tehsil,
    name: `${namePrefix}.tehsil`,
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Town/Village/Ward",
    placeholder: "Enter Town/Village/Ward",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.town,
    name: `${namePrefix}.town`,
    type: "textInput",
    mandatory: true,
    maxLength: 26,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Address",
    placeholder: "Enter Address",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.address,
    name: `${namePrefix}.address`,
    type: "textInput",
    mandatory: true,
    multiLine: true,
    maxLength: 150,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Address'),
        message: "Please enter valid Address"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Pincode",
    placeholder: "Enter Pincode",
    defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.pinno,
    name: `${namePrefix}.pinno`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Pincode'),
        message: "Please enter valid Pincode"
      }
    },
    maxLength: 6
  }));
}

function FileUploader$6({
  name,
  label,
  control,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  validation,
  tab
}) {
  const {
    documents
  } = useSelector(state => state.form11);
  const dispatch = useDispatch();
  const {
    addForm11Doc,
    removeForm11Doc
  } = bindActionCreators(form11DocActions, dispatch);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const handleFileUpload = async (file, inputName) => {
    setIsLoading(true);
    setShowToast(null);
    fileInputRef.current.value = null;
    if (!file) {
      setShowToast({
        error: true,
        label: "Please select a file."
      });
      setIsLoading(false);
      return;
    }
    if (tab === 1) {
      const allowedFormats = [".png", ".jpg", ".jpeg", ".pdf", ".JPG", ".PNG", ".JPEG", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file with a valid format (.png, .jpg, .jpeg, .pdf)."
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 10 MB."
        });
        setIsLoading(false);
        return;
      }
    } else {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split('.').pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({
          error: true,
          label: "Please select a file in a pdf format"
        });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 30 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setShowToast({
          error: true,
          label: "File size exceeds the maximum limit of 30 MB."
        });
        setIsLoading(false);
        return;
      }
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", tenantId);
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios$1.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addForm11Doc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        additionalDetails: {
          fileName: file.name,
          title: label
        }
      });
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer",
    style: {
      alignItems: 'flex-start'
    }
  }, hasLabel && /*#__PURE__*/React__default.createElement("h3", {
    className: `label`
  }, label, isMandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      p: '0.5rem 0.75rem 0.375rem',
      borderRadius: '0.25rem',
      flexDirection: 'column',
      position: 'relative',
      width: '18.25vw',
      display: 'flex'
    }
  }, isLoading ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      justifyContent: 'center',
      position: 'absolute',
      alignItems: 'center',
      display: 'flex',
      inset: 0
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : null, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return handleFileUpload(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    },
    style: {
      maxWidth: '100%'
    },
    required: required && !(documents !== null && documents !== void 0 && documents.some(doc => doc.documentType === name)),
    accept: ".png, .jpg, .jpeg, .pdf",
    ref: fileInputRef
  }), /*#__PURE__*/React__default.createElement("small", {
    className: "error"
  }, validationMsg), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement("span", {
    className: "errorText"
  }, showToast.label), !isLoading && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      maxWidth: '100%',
      display: 'flex',
      mb: 0.5,
      mt: 1
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map(doc => {
    var _doc$additionalDetail;
    if (!(name in documents) && doc.documentType !== name) {
      return null;
    }
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        justifyContent: 'space-between',
        p: '0.25rem 0 0.25rem 0.75rem',
        backgroundColor: '#eee',
        borderRadius: '0.25rem',
        wordBreak: 'break-all',
        fontSize: '0.875rem',
        alignItems: 'center',
        display: 'flex',
        lineHeight: 1,
        flex: 1
      },
      key: doc.fileStoreId
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || doc.documentType, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "info",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(VisibilityIcon, null)), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      color: "error",
      onClick: () => removeForm11Doc(doc.documentType)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, null))));
  })) || null)));
}

const Step1$4 = ({
  formData,
  cities,
  isLoading,
  handleTabChange
}) => {
  var _formData$description, _formData$description2, _formData$description3, _formData$landAreaDet, _formData$landAreaDet2, _formData$landAreaDet3, _formData$landAreaDet4, _formData$landAreaDet5, _formData$landAreaDet6, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _districts$filter, _districts$filter$, _areas$filter, _areas$filter$, _villages$filter, _areas$filter2, _areas$filter3, _areas$filter3$, _formData$landAreaDet7, _formData$landAreaDet8, _formData$landAreaDet9, _formData$landAreaDet10, _formData$landAreaDet11, _formData$landAreaDet12, _formData$landAreaDet13, _formData$landAreaDet14, _formData$landAreaDet15, _formData$landAreaDet16, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31;
  const {
    t
  } = useTranslation();
  const {
    documents
  } = useSelector(state => state.form11);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const dispatch = useDispatch();
  const {
    resetForm11Docs
  } = bindActionCreators(form11DocActions, dispatch);
  const [isChangeOfLandInvolved, setIsChangeOfLandInvolved] = useState((formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.typeOfLandVolved) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.name) === "yes" ? "yes" : null);
  const [totalPlotAreaVal, setTotalPlotAreaVal] = useState((formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.totalPlotArea) || 0);
  const [areaName, setAreaName] = useState(null);
  const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const applicationType = "FORM_11";
  const khasraTableEntry = {
    plotNo: null,
    plotArea: null,
    typeOfLand: null
  };
  const khasraWithAreaEntry = {
    khasraNo: null,
    area: null
  };
  const ownerEntry = {
    name: "",
    fatherOrHusbandName: "",
    mobileNumber: "",
    emailId: "",
    aadhaarNumber: "",
    gender: ""
  };
  const defaultValues = {
    ...formData,
    landAreaDetails: {
      city: (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet = formData.landAreaDetails) === null || _formData$landAreaDet === void 0 ? void 0 : _formData$landAreaDet.city) || null,
      areaType: (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet2 = formData.landAreaDetails) === null || _formData$landAreaDet2 === void 0 ? void 0 : _formData$landAreaDet2.areaType) || null,
      locality: {
        name: (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet3 = formData.landAreaDetails) === null || _formData$landAreaDet3 === void 0 ? void 0 : (_formData$landAreaDet4 = _formData$landAreaDet3.locality) === null || _formData$landAreaDet4 === void 0 ? void 0 : _formData$landAreaDet4.name) || null
      },
      village: {
        name: (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet5 = formData.landAreaDetails) === null || _formData$landAreaDet5 === void 0 ? void 0 : (_formData$landAreaDet6 = _formData$landAreaDet5.village) === null || _formData$landAreaDet6 === void 0 ? void 0 : _formData$landAreaDet6.name) || null
      }
    },
    landInfo: {
      ...(formData === null || formData === void 0 ? void 0 : formData.landInfo),
      owners: (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.length) > 0 ? formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.owners : [ownerEntry]
    },
    descriptionOfLand: {
      revenueVillageMohal: (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.revenueVillageMohal) || null,
      khataNo: (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.khataNo) || null,
      khatauniNo: (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.khatauniNo) || null,
      latLong: (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.latLong) || null,
      khasraWithArea: (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.khasraWithArea) || [khasraWithAreaEntry],
      totalPlotArea: (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.totalPlotArea) || 0,
      noOfPlot: (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.noOfPlot) || null,
      useType: {
        name: (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : (_formData$description12 = _formData$description11.useType) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.name) || null
      },
      propertyType: {
        name: (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : (_formData$description14 = _formData$description13.propertyType) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.name) || null
      },
      typeOfLandVolved: {
        name: formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : (_formData$description16 = _formData$description15.typeOfLandVolved) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.name
      },
      typeOfCLUInvolved: {
        name: (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : (_formData$description18 = _formData$description17.typeOfCLUInvolved) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.name) || null
      },
      khasraTable: (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.khasraTable) || [khasraTableEntry],
      plotArea: (formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.plotArea) || null
    },
    documents
  };
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    reset
  } = useForm({
    defaultValues
  });
  const [watchTypeOfCLUInvolved, watchCluInvolved] = watch(["descriptionOfLand.typeOfCLUInvolved.name", "descriptionOfLand.typeOfLandVolved.name"]);
  useEffect(() => {
    if (watchCluInvolved === "no") {
      setValue("descriptionOfLand.typeOfCLUInvolved", null);
      setValue("descriptionOfLand.khasraTable", [khasraTableEntry]);
    }
  }, [watchCluInvolved]);
  const {
    fields: khasraWithArea,
    append,
    remove
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraWithArea"
  });
  const {
    fields: khasraTable,
    append: appendTable,
    remove: removeTable
  } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraTable"
  });
  const watchPlotArea = watch("descriptionOfLand.khasraWithArea");
  const watchKhasraTable = watch("descriptionOfLand.khasraTable");
  const khasraWithAreaFields = khasraWithArea.map((field, index) => {
    return {
      ...field,
      ...watchPlotArea[index]
    };
  });
  const khasraTableFields = khasraTable.map((field, index) => {
    return {
      ...field,
      ...watchKhasraTable[index]
    };
  });
  useEffect(() => {
    const total = khasraWithAreaFields.reduce((total, field) => {
      return total + Number(field.area);
    }, 0);
    setValue("descriptionOfLand.totalPlotArea", total);
    setTotalPlotAreaVal(total);
  }, [khasraWithAreaFields]);
  const handlePropertyType = event => {
    setValue("propertyType", event.target.value);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const districts = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return (_city$code = city.code) === null || _city$code === void 0 ? void 0 : _city$code.includes(applicationFlow.toLowerCase());
  }) : [];
  const selectedDistrict = useWatch({
    control,
    name: "landAreaDetails.city"
  });
  const selectedArea = useWatch({
    control,
    name: "landAreaDetails.locality.name"
  });
  const selectedVillage = useWatch({
    control,
    name: "landAreaDetails.village.name"
  });
  const areas = districts === null || districts === void 0 ? void 0 : (_districts$filter = districts.filter(area => (area === null || area === void 0 ? void 0 : area.name) === selectedDistrict)) === null || _districts$filter === void 0 ? void 0 : (_districts$filter$ = _districts$filter[0]) === null || _districts$filter$ === void 0 ? void 0 : _districts$filter$.boundary;
  const villages = areas === null || areas === void 0 ? void 0 : (_areas$filter = areas.filter(village => (village === null || village === void 0 ? void 0 : village.name) === selectedArea)) === null || _areas$filter === void 0 ? void 0 : (_areas$filter$ = _areas$filter[0]) === null || _areas$filter$ === void 0 ? void 0 : _areas$filter$.children;
  const village = villages === null || villages === void 0 ? void 0 : (_villages$filter = villages.filter(village => (village === null || village === void 0 ? void 0 : village.name) === selectedVillage)) === null || _villages$filter === void 0 ? void 0 : _villages$filter[0];
  const selectedAreas = areas === null || areas === void 0 ? void 0 : (_areas$filter2 = areas.filter(village => (village === null || village === void 0 ? void 0 : village.name) === selectedArea)) === null || _areas$filter2 === void 0 ? void 0 : _areas$filter2[0];
  const areaType = areas !== null && areas !== void 0 && (_areas$filter3 = areas.filter(area => (area === null || area === void 0 ? void 0 : area.name) === selectedArea)) !== null && _areas$filter3 !== void 0 && (_areas$filter3$ = _areas$filter3[0]) !== null && _areas$filter3$ !== void 0 && _areas$filter3$.IsSpecialArea ? `Special Area` : `Planning Area`;
  const location = selectedAreas === null || selectedAreas === void 0 ? void 0 : selectedAreas.localname;
  useEffect(() => {
    setValue("landAreaDetails.areaType", areaType);
    setValue("landAreaDetails.locality.localname", location);
    setAreaName(areaType);
  }, [selectedArea]);
  const {
    fields: owners,
    append: appendOwner,
    remove: removeOwner
  } = useFieldArray({
    control,
    name: "landInfo.owners"
  });
  useEffect(async () => {
    const fetchBusinessService = await Digit.LocationService.getBusinessServices(selectedDistrict, location, applicationType, applicationFlow);
    setValue("businessService", fetchBusinessService);
    setValue("");
  }, [selectedArea]);
  const handleIsChangeOfLandInvolved = event => {
    const val = event.target.value;
    setValue("descriptionOfLand.typeOfLandVolved.name", val);
    setIsChangeOfLandInvolved(val === "yes");
  };
  const onSubmit = data => {
    var _data$landInfo, _data$landInfo$owners, _data$landInfo2;
    const landInfo = {
      ownershipCategory: (data === null || data === void 0 ? void 0 : (_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : (_data$landInfo$owners = _data$landInfo.owners) === null || _data$landInfo$owners === void 0 ? void 0 : _data$landInfo$owners.length) > 1 ? "INDIVIDUAL.MULTIOWNER" : "INDIVIDUAL.SINGLEOWNER",
      owners: (data === null || data === void 0 ? void 0 : (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : _data$landInfo2.owners) || null,
      ownerCorrespondanceAddress: null,
      ownerPermanentAddress: null,
      address: {
        city: selectedDistrict,
        locality: {
          code: (selectedAreas === null || selectedAreas === void 0 ? void 0 : selectedAreas.code) || null
        },
        region: (selectedAreas === null || selectedAreas === void 0 ? void 0 : selectedAreas.localname) || null,
        doorNo: (selectedAreas === null || selectedAreas === void 0 ? void 0 : selectedAreas.name) || null,
        areaType: areaType
      },
      tenantId
    };
    data.landInfo = landInfo;
    handleTabChange(1, data);
  };
  if (applicationFlow === null) {
    return /*#__PURE__*/React__default.createElement(DepartmentSelector, null);
  }
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Area Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "District",
    control: control,
    placeholder: "Select District",
    inputLabel: "Select District",
    name: "landAreaDetails.city",
    mandatory: true,
    type: "selectInput",
    data: districts,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet7 = formData.landAreaDetails) === null || _formData$landAreaDet7 === void 0 ? void 0 : _formData$landAreaDet7.city,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), isUdFlow ? /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Ward",
    control: control,
    placeholder: "Select Ward",
    inputLabel: "Select Ward",
    name: "landAreaDetails.village.name",
    mandatory: true,
    type: "selectInput",
    data: villages,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet8 = formData.landAreaDetails) === null || _formData$landAreaDet8 === void 0 ? void 0 : (_formData$landAreaDet9 = _formData$landAreaDet8.village) === null || _formData$landAreaDet9 === void 0 ? void 0 : _formData$landAreaDet9.name,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Name of Village",
    control: control,
    placeholder: "Select Name of Village",
    inputLabel: "Select Name of Village",
    name: "landAreaDetails.village.name",
    mandatory: true,
    type: "selectInput",
    data: villages,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet10 = formData.landAreaDetails) === null || _formData$landAreaDet10 === void 0 ? void 0 : (_formData$landAreaDet11 = _formData$landAreaDet10.village) === null || _formData$landAreaDet11 === void 0 ? void 0 : _formData$landAreaDet11.name,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, isUdFlow ? /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "ULB",
    control: control,
    placeholder: "Select ULB",
    inputLabel: "Select ULB",
    name: "landAreaDetails.locality.name",
    mandatory: true,
    type: "selectInput",
    data: areas,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet12 = formData.landAreaDetails) === null || _formData$landAreaDet12 === void 0 ? void 0 : (_formData$landAreaDet13 = _formData$landAreaDet12.locality) === null || _formData$landAreaDet13 === void 0 ? void 0 : _formData$landAreaDet13.name,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Notified Area",
    control: control,
    placeholder: "Select Notified Area",
    inputLabel: "Select Notified Area",
    name: "landAreaDetails.locality.name",
    mandatory: true,
    type: "selectInput",
    data: areas,
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet14 = formData.landAreaDetails) === null || _formData$landAreaDet14 === void 0 ? void 0 : (_formData$landAreaDet15 = _formData$landAreaDet14.locality) === null || _formData$landAreaDet15 === void 0 ? void 0 : _formData$landAreaDet15.name,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), selectedArea && !isUdFlow && /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Name of Area",
    control: control,
    disabled: true,
    name: "landAreaDetails.areaType",
    type: "textInput",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet16 = formData.landAreaDetails) === null || _formData$landAreaDet16 === void 0 ? void 0 : _formData$landAreaDet16.areaType,
    placeholder: areaName
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Applicant Name ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Guardian Name ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Applicant Mobile No. ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Applicant Email ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Aadhaar No."), /*#__PURE__*/React__default.createElement("th", null, "Gender ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "\xA0"))), /*#__PURE__*/React__default.createElement("tbody", null, owners === null || owners === void 0 ? void 0 : owners.map((owner, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: owner.id
  }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Name",
    defaultValue: owner.name,
    name: `landInfo.owners[${index}].name`,
    type: "textInput",
    hasLabel: false,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Guardian Name",
    defaultValue: owner.fatherOrHusbandName,
    name: `landInfo.owners[${index}].fatherOrHusbandName`,
    type: "textInput",
    hasLabel: false,
    maxLength: 30,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Name"),
        message: "Please enter only letters and spaces"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Mobile No.",
    defaultValue: owner.mobileNumber,
    name: `landInfo.owners[${index}].mobileNumber`,
    type: "textInput",
    hasLabel: false,
    mobileNumber: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Email",
    defaultValue: owner.emailId,
    name: `landInfo.owners[${index}].emailId`,
    type: "textInput",
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Email"),
        message: "Please enter valid email id"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Aadhaar No.",
    defaultValue: owner.aadhaarNumber,
    name: `landInfo.owners[${index}].aadhaarNumber`,
    type: "textInput",
    hasLabel: false,
    validation: {
      pattern: {
        value: Digit.Utils.getPattern("AadharNo"),
        message: "Please enter valid Aadhaar no"
      }
    },
    maxLength: 12
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Gender",
    defaultValue: owner.gender,
    name: `landInfo.owners[${index}].gender`,
    type: "radioButton",
    data: genderData,
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "Please select the gender"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      gap: ".5rem"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "Add more",
    onClick: () => appendOwner(ownerEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)), owners.length > 0 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeOwner(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Photo & Signature")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$6, {
    isMandatory: true,
    control: control,
    name: "applicantPhoto",
    label: "Applicant Photo",
    validationMsg: "(jpg,jpeg,png,pdf file only and Max file Size 10 MB)",
    required: true,
    tab: 1
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(FileUploader$6, {
    isMandatory: true,
    control: control,
    name: "signature",
    label: "Signature",
    validationMsg: "(jpg,jpeg,png,pdf file only and Max file Size 10 MB)",
    required: true,
    tab: 1
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Contact Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Address$1, {
    defaultValues: formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : _formData$landInfo3$o2.correspondenceAddress,
    namePrefix: "landInfo.owners[0].correspondenceAddress",
    applicationFlow,
    setValue,
    control,
    watch
  }), /*#__PURE__*/React__default.createElement(Address$1, {
    defaultValues: formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : _formData$landInfo4$o2.permanentAddress,
    namePrefix: "landInfo.owners[0].permanentAddress",
    applicationFlow,
    setValue,
    control,
    watch
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      paddingLeft: "100"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Description of land proposed for Development of Land/Construction of Building")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: "5px 5px 0 0",
      borderBottom: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: isUdFlow ? "Mohal/Muzza/Phati/Up Mohal" : "Revenue Village/Mohal",
    control: control,
    placeholder: "Enter Village Name.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.revenueVillageMohal,
    name: "descriptionOfLand.revenueVillageMohal",
    type: "textInput",
    mandatory: true,
    maxLength: 25,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Khatauni No.",
    control: control,
    placeholder: "Enter Khatauni No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.khatauniNo,
    name: "descriptionOfLand.khatauniNo",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Khata No.",
    control: control,
    placeholder: "Enter Khata No.",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.khataNo,
    name: "descriptionOfLand.khataNo",
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Latitude/Longitude",
    control: control,
    maxLength: 20,
    placeholder: "Enter Latitude/Longitude",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.latLong,
    name: "descriptionOfLand.latLong",
    type: "textInput"
  }))), khasraWithAreaFields.map((field, index) => /*#__PURE__*/React__default.createElement(Box, {
    key: field.id,
    className: "formInputContainer endAdornment"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Khasra No.",
    placeholder: "Enter Khasra No.",
    defaultValue: field.khasraNo,
    name: `descriptionOfLand.khasraWithArea.${index}.khasraNo`,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper append"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Area (Sq.M)",
    placeholder: "Enter Area (Sq.M)",
    defaultValue: field.area,
    maxLength: 10,
    name: `descriptionOfLand.khasraWithArea.${index}.area`,
    type: "textInput",
    mandatory: true,
    width: `calc(18.25vw - ${index === 0 ? "40px" : "80px"})`,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "adornment"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "info",
    "aria-label": "Add more",
    onClick: () => append(khasraWithAreaEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)), (khasraWithArea === null || khasraWithArea === void 0 ? void 0 : khasraWithArea.length) > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => remove(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: "0",
      borderBottom: 0,
      borderTopColor: "#eee"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Total Plot Area (Sq.m)",
    placeholder: `${totalPlotAreaVal}`,
    defaultValue: totalPlotAreaVal || (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.totalPlotArea),
    value: totalPlotAreaVal,
    name: "descriptionOfLand.totalPlotArea",
    type: "textInput",
    mandatory: true,
    maxLength: 10,
    disabled: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "No. of Plot",
    control: control,
    placeholder: "Enter No. of Plot",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.noOfPlot,
    name: "descriptionOfLand.noOfPlot",
    mandatory: true,
    maxLength: 10,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Amount"),
        message: "Please enter valid Numbers"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: "0 0 5px 5px",
      borderTopColor: "#eee"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: propertyTypeList,
    label: "Property Type",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : (_formData$description28 = _formData$description27.propertyType) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.name,
    name: "descriptionOfLand.propertyType.name",
    type: "radioButton",
    clickControl: handlePropertyType,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Plot Area for Sub-division/Development Activity(sq.m) ",
    control: control,
    placeholder: "Enter Details",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.plotArea,
    name: "descriptionOfLand.plotArea",
    mandatory: true,
    type: "textInput",
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    inputLabel: "Select Use Type",
    label: "Use Type",
    placeholder: "Select Use Type",
    name: "descriptionOfLand.useType.name",
    defaultValue: formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : (_formData$description31 = _formData$description30.useType) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.name,
    mandatory: true,
    type: "selectInput",
    data: useTypeList,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Plot after Subdivision")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: isChangeOfLandInvolved && watchTypeOfCLUInvolved ? "5px 5px 0 0" : "5px",
      borderBottomWidth: isChangeOfLandInvolved && watchTypeOfCLUInvolved ? 0 : 1
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper",
    style: {
      maxWidth: "50%"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: yesOrNo,
    label: "Whether Change of Land use involved",
    defaultValue: isChangeOfLandInvolved,
    name: "descriptionOfLand.typeOfLandVolved.name",
    type: "radioButton",
    clickControl: handleIsChangeOfLandInvolved,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), isChangeOfLandInvolved && /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: typeOfCluInvolved,
    label: "Type of CLU Involved",
    placeholder: "Select Type of CLU Involved",
    name: "descriptionOfLand.typeOfCLUInvolved.name",
    type: "selectInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), isChangeOfLandInvolved && watchTypeOfCLUInvolved && /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      borderRadius: "0 0 5px 5px",
      borderTopColor: "#eee"
    }
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "mb-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: "fit-content"
    }
  }, "SI#"), /*#__PURE__*/React__default.createElement("th", null, "Plot No. ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Plot Area ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Type of Land Development ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement("th", null, "Action(s)"))), /*#__PURE__*/React__default.createElement("tbody", null, khasraTableFields.map((field, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: field.id
  }, /*#__PURE__*/React__default.createElement("td", null, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Plot No.",
    defaultValue: field.plotNo,
    name: `descriptionOfLand.khasraTable.${index}.plotNo`,
    type: "textInput",
    hasLabel: false,
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Plot Area",
    defaultValue: field.plotArea,
    name: `descriptionOfLand.khasraTable.${index}.plotArea`,
    type: "textInput",
    hasLabel: false,
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: /^[0-9]+(\.[0-9]+)?$/,
        message: "Please enter valid area"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    data: typeOfLandForDevelopment,
    placeholder: "Select Type of Land",
    name: `descriptionOfLand.khasraTable.${index}.typeOfLand.name`,
    type: "selectInput",
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "info",
    "aria-label": "Add more",
    onClick: () => appendTable(khasraTableEntry)
  }, /*#__PURE__*/React__default.createElement(AddIcon, null)), (khasraTableFields === null || khasraTableFields === void 0 ? void 0 : khasraTableFields.length) > 1 && index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "Delete",
    onClick: () => removeTable(index)
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)))))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => {
      resetForm11Docs();
      reset();
    }
  })))));
};

const inputWidth$1 = 200;
const Step2$e = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.form11);
  const checklist = formData === null || formData === void 0 ? void 0 : formData.checklist;
  const defaultValues = {
    ...formData,
    checklist
  };
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    reset
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue('documents', documents);
  }, [documents]);
  const onSubmit = formData => {
    handleTabChange(2, formData);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Case Checklist")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Sr. No."), /*#__PURE__*/React__default.createElement("th", null, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("th", null, "As proposed"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Relaxation"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, " Minimum width of pedestrian links to smaller cluster of plots, not exceeding 5 in number."), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfPedestrian_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfPedestrian_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfPedestrian",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfPedestrian
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfPedestrianremarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfPedestrianremarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfPedestrian_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfPedestrian_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2."), /*#__PURE__*/React__default.createElement("td", null, " Minimum width of vehicular access, if number of plots is above 5."), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfVehicularAccess_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfVehicularAccess_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfVehicularAccess",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfVehicularAccess
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfVehicularAccessremarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfVehicularAccessremarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumWidthOfVehicularAccess_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumWidthOfVehicularAccess_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3."), /*#__PURE__*/React__default.createElement("td", null, " Minimum area for open/green space for the scheme having more than 5 plots."), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForOpenGreenSpace_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForOpenGreenSpace_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForOpenGreenSpace",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForOpenGreenSpace
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForOpenGreenSpaceremarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForOpenGreenSpaceremarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForOpenGreenSpace_relaxation",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForOpenGreenSpace_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4."), /*#__PURE__*/React__default.createElement("td", null, " Minimum area for soak pit etc. (irrespective of the number of plots)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForSoakPit_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForSoakPit_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForSoakPit",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForSoakPit
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForSoakPitRemarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForSoakPitRemarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.minimumAreaForSoakPit_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.minimumAreaForSoakPit_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5."), /*#__PURE__*/React__default.createElement("td", null, "Orientation of the plots shall be provided in such a manner to be in conformity with the integration of existing plots/infrastructure, wind direction, and natural flow of surface drainage unobstructed rain water discharge."), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.orientationOfPlots_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.orientationOfPlots_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "checklist.orientationOfPlots",
    data: yesOrNo,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.orientationOfPlots
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.orientationOfPlotsRemarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.orientationOfPlotsRemarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.orientationOfPlots_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.orientationOfPlots_relaxation
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6."), /*#__PURE__*/React__default.createElement("td", null, "Layout of plots shall be governed by easy access having acceptable grades minimum 1 in 15 and which may not obstruct view of vista"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.layoutOfPlots_regulated",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.layoutOfPlots_regulated
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "radioButton",
    control: control,
    name: "checklist.layoutOfPlots",
    data: yesOrNo,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.layoutOfPlots
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.layoutOfPlotsremarks",
    placeholder: "Enter Remarks",
    multiline: true,
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.layoutOfPlotsremarks
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: inputWidth$1,
    hasLabel: false,
    type: "textInput",
    control: control,
    name: "checklist.layoutOfPlots_relaxation",
    placeholder: "Enter Details",
    defaultValue: checklist === null || checklist === void 0 ? void 0 : checklist.layoutOfPlots_relaxation
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    sx: {
      backgroundColor: '#eee',
      '&:hover': {
        backgroundColor: '#e5e5e5'
      },
      color: '#000'
    },
    variant: "contained",
    size: "medium",
    label: "Prev",
    onClick: () => handleTabChange(0)
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => {
      reset();
    }
  })))));
};

const Step3$8 = ({
  formData,
  handleTabChange
}) => {
  const {
    documents
  } = useSelector(state => state.form11);
  const defaultValues = {
    ...formData,
    documents
  };
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues
  });
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = data => {
    handleTabChange(3, data);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React.createElement(FileUploader$6, {
    isMandatory: true,
    label: "Jamabandi",
    control: control,
    name: "jamabandhiDocument",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Conveyance Deed/Sale/Lease ",
    control: control,
    name: "conveyanceDeed",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Proposed Consolidated Map 1 (Note: Upload the map in portrait orientation) ",
    control: control,
    name: "proposedConsolidatedMap1",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Location Plan ",
    control: control,
    name: "locationPlan",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Tatima",
    control: control,
    name: "tatimaDocuments",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Demarcation Report/Affidavit",
    control: control,
    name: "demarcationReport",
    validationMsg: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    label: "Copy of Contouring Plan ",
    control: control,
    name: "copyOfContouringPlan",
    isMandatory: true,
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true
  }), /*#__PURE__*/React.createElement(FileUploader$6, {
    isMandatory: true,
    label: "Site Plan",
    control: control,
    name: "sitePlan",
    validationMsg: "(pdf file only and Max file Size 30 MB)",
    required: true,
    validation: "This file is required"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React.createElement(ButtonWrapper, {
    sx: {
      backgroundColor: "#eee",
      "&:hover": {
        backgroundColor: "#e5e5e5"
      },
      color: "#000"
    },
    variant: "contained",
    size: "medium",
    label: "Prev",
    onClick: () => handleTabChange(1)
  }), /*#__PURE__*/React.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save and Continue",
    type: "submit"
  })))));
};

const Step2$f = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Private Professional Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Registration no.",
    control: control,
    placeholder: "Enter Registration no.",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Name",
    control: control,
    placeholder: "Enter Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "mobileNumber",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Address ",
    control: control,
    placeholder: "Enter Address ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "State",
    control: control,
    placeholder: "Enter State",
    name: "district",
    mandatory: true,
    type: "textInput",
    data: statesData
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "District",
    control: control,
    placeholder: "Enter District",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Qualification Certificates ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Experience Certificates  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Town/Village/Ward",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "PIN No.",
    control: control,
    placeholder: "Enter PIN No. ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "E-mail ID ",
    control: control,
    placeholder: "Enter E-mail ID ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Class (As per Categories define)",
    control: control,
    placeholder: "Enter Class",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Degree University Name",
    control: control,
    placeholder: "Enter  Degree University Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Registration no.",
    control: control,
    placeholder: "Enter Registration no.",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Name",
    control: control,
    placeholder: "Enter Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "mobileNumber",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Address ",
    control: control,
    placeholder: "Enter Address ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "State",
    control: control,
    placeholder: "Enter State",
    name: "district",
    mandatory: true,
    type: "textInput",
    data: statesData
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "District",
    control: control,
    placeholder: "Enter District",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Structural Engineer Stability Certificate ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Town/Village/Ward",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "PIN No.",
    control: control,
    placeholder: "Enter PIN No. ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "E-mail ID ",
    control: control,
    placeholder: "Enter E-mail ID ",
    name: "district",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Prev"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save as Draft",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Form11 = () => {
  var _Digit$UserService, _Digit$UserService$ge;
  const [checkListData, setCheckListData] = useState({});
  const [documentData, setDocumentData] = useState([]);
  const [applicantData, setApplicantData] = useState([]);
  const [responseData, setResponseData] = useState({});
  const [applicationNumber, setApplicationNumber] = useState('');
  const step1Data = data => {
    setApplicantData(data);
  };
  const step2Data = data => {
    setCheckListData(data);
  };
  const step3Data = data => {
    setDocumentData(data);
  };
  const filteredCheckListData = Object.entries(checkListData).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const userToken = localStorage.getItem('token');
  const UserToken = (_Digit$UserService = Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token;
  console.log({
    userToken,
    UserToken
  }, "ggggggggggg");
  const handleSubmit = () => {
    var _Digit$UserService2, _Digit$UserService2$g;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Basic ZWdvdi11c2VyLWNsaWVudDo=");
    const userToken = localStorage.getItem('token');
    const UserToken = (_Digit$UserService2 = Digit.UserService) === null || _Digit$UserService2 === void 0 ? void 0 : (_Digit$UserService2$g = _Digit$UserService2.getUser()) === null || _Digit$UserService2$g === void 0 ? void 0 : _Digit$UserService2$g.access_token;
    console.log({
      userToken,
      UserToken
    }, "ggggggggggg");
    var raw = JSON.stringify({
      "RequestInfo": {
        "api_id": "1",
        "ver": "1",
        "ts": null,
        "action": "create",
        "did": "",
        "key": "",
        "msg_id": "",
        "requester_id": "",
        "authToken": userToken
      },
      "BPA": {
        "approvalNo": null,
        "accountId": null,
        "edcrNumber": null,
        "riskType": null,
        "applicationType": "FORM_11",
        "serviceType": "FORM_11",
        "landId": null,
        "tenantId": "hr",
        "applicationDate": "1676613488134",
        "status": "INITIATE",
        "department": "TCP",
        "category": "Residential",
        "totalPlotArea": 1.02,
        "applcationDetail": {
          "applicantInfo": {
            "applicantName": applicantData && applicantData.applicantName,
            "guardianName": applicantData && applicantData.guardianName,
            "applicantMobileNo": applicantData && applicantData.applicantMobileNo,
            "aadharNo": applicantData && applicantData.aadharNo,
            "uploadPhoto": "",
            "addMoreApplicant": "VV SS RR",
            "emailId": applicantData && applicantData.emailId,
            "pvtProfMobileNo": applicantData && applicantData.applicantMobileNo,
            "nocApplicantInfo": null
          },
          "landAreaDetails": {
            "district": "district",
            "notifiedArea": "TCP",
            "category": "Residential",
            "nameOfVillage": "nameOfVillage",
            "nameOfULB": "nameOfULB",
            "nameOfWard": null,
            "additionalLandAreaDetails": {
              "Name": "Digambar",
              "Gender": "Male",
              "Age": "88",
              "Try": {
                "address": "address",
                "pin": "444708"
              }
            },
            "applicantionInfo": {
              "Name": "Digambar",
              "Gender": "Male",
              "Age": "88"
            }
          },
          "descriptionOfLand": {
            "revenueVillageMohalla": applicantData && applicantData.revenueVillageMohalla,
            "khatoniNo": applicantData && applicantData.khatoniNo,
            "khasraNo": applicantData && applicantData.khasraNo,
            "khataNo": applicantData && applicantData.khataNo,
            "latitudeLongitude": applicantData && applicantData.latitudeLongitude,
            "totalPlotArea": applicantData && applicantData.totalPlotArea,
            "areaUnderConsideration": applicantData && applicantData.areaUnderConsideration,
            "noOfPlot": applicantData && applicantData.noOfPlot,
            "pvtProfessionalInfo": "pvtProfessionalInfo",
            "useType": "useType",
            "propertyType": "propertyType",
            "plotAreaForSubDivisionalDevelopmentActivitiesInSqM": applicantData && applicantData.plotAreaForSubDivisionalDevelopmentActivitiesInSqM,
            "whetherChangeOfLandUseInvolved": true,
            "additionalDescriptionOfLandDeteails": {
              "address": applicantData && applicantData.correspondenceAddress,
              "pin": applicantData && applicantData.correspondencePinCode
            }
          },
          "permanentAddressDetails": {
            "name": applicantData && applicantData.PermanentAdressName,
            "type": "type",
            "guardianName": applicantData && applicantData.PermanentGuardianName,
            "state": applicantData && applicantData.permanentState,
            "district": applicantData && applicantData.permanentDistrict,
            "tehsil": applicantData && applicantData.permanentTehsil,
            "townVillageWard": applicantData && applicantData.permanentVillage,
            "address": applicantData && applicantData.permanentAddress,
            "pin": applicantData && applicantData.permanentPincode
          },
          "correspondenceAddressDetails": {
            "name": applicantData && applicantData.correspondenceAdressName,
            "type": "type",
            "guardianName": applicantData.correspondenceGuardianName,
            "state": applicantData && applicantData.correspondenceState,
            "district": applicantData && applicantData.correspondenceDistrict,
            "tehsil": applicantData && applicantData.correspondenceTehsil,
            "townVillageWard": applicantData && applicantData.correspondenceVillage,
            "address": applicantData && applicantData.correspondenceAddress,
            "pin": applicantData && applicantData.correspondencePinCode
          },
          "permissionOfSubdivisionChecklist": filteredCheckListData,
          "documents": documentData
        },
        "workflow": {
          "action": "INITIATE",
          "assignes": null,
          "comments": "PPPPPPP",
          "varificationDocuments": null
        }
      }
    });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch(Urls$1.form11.create, requestOptions).then(response => response.text()).then(result => {
      setResponseData(result);
      console.log({
        result,
        responseData
      }, "rrrrr");
      console.log(result.BPA, "ssssssssssssss");
    }).catch(error => console.log('error', error));
  };
  useEffect(() => {
    console.log("ccccccc", checkListData, documentData, applicantData);
  }, [checkListData, documentData, applicantData]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step1$4, {
    step1Data: step1Data
  }), /*#__PURE__*/React__default.createElement(Step2$f, null), /*#__PURE__*/React__default.createElement(Step2$e, {
    step2Data: step2Data
  }), /*#__PURE__*/React__default.createElement(Step3$8, {
    step3Data: step3Data
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    style: {
      backgroundColor: '#1fa47c',
      color: 'white',
      marginLeft: '650px',
      marginBottom: '100px'
    },
    onClick: handleSubmit
  }, "Submit"));
};

const Form11Card = () => {
  var _Digit$SessionStorage, _Digit$SessionStorage2;
  const userRoles = (_Digit$SessionStorage = Digit.SessionStorage.get("User")) === null || _Digit$SessionStorage === void 0 ? void 0 : (_Digit$SessionStorage2 = _Digit$SessionStorage.info) === null || _Digit$SessionStorage2 === void 0 ? void 0 : _Digit$SessionStorage2.roles;
  const isEmployee = userRoles.find(role => role.code === "EMPLOYEE");
  useEffect(() => {
    Digit.SessionStorage.set("CITIZENSURVEY.INBOX", null);
  }, []);
  if (!isEmployee) return null;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data: documentsCount,
    isLoading: isLoadingDocs
  } = Digit.Hooks.engagement.useDocSearch({
    tenantIds: tenantId
  }, {
    select: data => {
      return data === null || data === void 0 ? void 0 : data.totalCount;
    }
  });
  const {
    data: MessagesCount,
    isLoading: isLoadingMessages
  } = Digit.Hooks.events.useInbox(tenantId, {}, {
    status: "ACTIVE,INACTIVE",
    eventTypes: "BROADCAST"
  }, {
    select: data => data === null || data === void 0 ? void 0 : data.totalCount
  });
  const {
    data: totalEvents,
    isLoading: isLoadingEvents
  } = Digit.Hooks.events.useInbox(tenantId, {}, {
    eventTypes: "EVENTSONGROUND"
  }, {
    select: data => data === null || data === void 0 ? void 0 : data.totalCount
  });
  const {
    data: surveysCount,
    isLoading: isLoadingSurveys
  } = Digit.Hooks.survey.useSearch({
    tenantIds: tenantId
  }, {
    select: data => data === null || data === void 0 ? void 0 : data.TotalCount
  });
  const totalDocsCount = useMemo(() => isLoadingDocs ? "-" : documentsCount, [isLoadingDocs, documentsCount]);
  const totalEventsCount = useMemo(() => isLoadingEvents ? "-" : totalEvents, [isLoadingEvents, totalEvents]);
  const totalMessagesCount = useMemo(() => isLoadingMessages ? "-" : MessagesCount, [isLoadingMessages, MessagesCount]);
  const totalSurveysCount = useMemo(() => isLoadingSurveys ? "-" : surveysCount, [isLoadingSurveys, surveysCount]);
  const {
    t
  } = useTranslation();
  let result = null;
  const propsForSurveyModuleCard = {
    Icon: /*#__PURE__*/React__default.createElement(SurveyIconSolid, null),
    moduleName: t("CS_COMMON_SURVEYS"),
    kpis: [{
      count: totalSurveysCount,
      label: t("TOTAL_SURVEYS"),
      link: `/digit-ui/employee/engagement/surveys/inbox`
    }],
    links: [{
      count: totalSurveysCount,
      label: t("ES_TITLE_INBOX"),
      link: `/digit-ui/employee/engagement/surveys/inbox`
    }, {
      label: t("CS_COMMON_NEW_SURVEY"),
      link: `/digit-ui/employee/engagement/surveys/create`
    }]
  };
  const propsForPMBModuleCard = {
    Icon: /*#__PURE__*/React__default.createElement(PMBIconSolid, null),
    moduleName: t("ACTION_TEST_PUBLIC_MESSAGE_BROADCAST"),
    kpis: [{
      count: totalMessagesCount,
      label: t("TOTAL_MESSAGES"),
      link: `/digit-ui/employee/engagement/messages/inbox`
    }],
    links: [{
      count: totalMessagesCount,
      label: t("ES_TITLE_INBOX"),
      link: `/digit-ui/employee/engagement/messages/inbox`
    }, {
      label: t("NEW_PUBLIC_MESSAGE_BUTTON_LABEL"),
      link: `/digit-ui/employee/engagement/messages/create`
    }]
  };
  const propsForEventsModuleCard = {
    Icon: /*#__PURE__*/React__default.createElement(EventsIconSolid, null),
    moduleName: t("TOTAL_EVENTS"),
    kpis: [{
      count: totalEventsCount,
      label: t("TOTAL_EVENTS"),
      link: `/digit-ui/employee/engagement/event/inbox`
    }],
    links: [{
      count: totalEventsCount,
      label: t("ES_TITLE_INBOX"),
      link: `/digit-ui/employee/engagement/event/inbox`
    }, {
      label: t("ES_TITLE_NEW_EVENTS"),
      link: `/digit-ui/employee/engagement/event/new-event`
    }]
  };
  const propsForDocumentModuleCard = {
    Icon: /*#__PURE__*/React__default.createElement(DocumentIconSolid, null),
    moduleName: t("ES_TITLE_DOCS"),
    kpis: [{
      count: totalDocsCount,
      label: t("TOTAL_DOCUMENTS"),
      link: `/digit-ui/employee/engagement/documents/inbox`
    }],
    links: [{
      count: totalDocsCount,
      label: t("ES_TITLE_INBOX"),
      link: `/digit-ui/employee/engagement/documents/inbox`
    }, {
      label: t("NEW_DOCUMENT_TEXT"),
      link: `/digit-ui/employee/engagement/documents/new-doc`
    }]
  };
  const propsForForm11ModuleCard = {
    Icon: /*#__PURE__*/React__default.createElement(DocumentIconSolid, null),
    moduleName: t("Development of Land - Form11"),
    kpis: [{
      count: totalDocsCount,
      label: t("TOTAL_FORMS_APPLIED"),
      link: `/digit-ui/employee/obps/inbox`
    }],
    links: [{
      count: totalDocsCount,
      label: t("ES_DOCS_COUNT"),
      link: `/digit-ui/employee/obps/inbox`
    }]
  };
  const engagementSubModulesProps = [propsForForm11ModuleCard];
  if (isEmployee) result = /*#__PURE__*/React__default.createElement(Fragment, null, engagementSubModulesProps.map((propsForModuleCard, index) => /*#__PURE__*/React__default.createElement(EmployeeModuleCard, Object.assign({
    key: index
  }, propsForModuleCard))));
  return result;
};

const EDCRForm = ({
  t,
  config,
  onSelect,
  formData,
  isShowToast,
  isSubmitBtnDisable,
  setIsShowToast
}) => {
  var _Digit, _Digit$SessionStorage, _Digit$SessionStorage2, _Digit2, _cityList$filter, _cityList$filter$, _Digit3, _localities$selectedL, _formData$Scrutiny, _formData$Scrutiny$, _formData$owners, _formData$owners$docu;
  const code = 'up';
  const applicationFlow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : (_Digit$SessionStorage2 = _Digit$SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) === null || _Digit$SessionStorage2 === void 0 ? void 0 : _Digit$SessionStorage2.toLowerCase();
  const udCode = applicationFlow === 'ud';
  const {
    data: cityList,
    isLoading: isCityListLoading
  } = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.Hooks.useTenants();
  const citymoduleList = !isCityListLoading && ((_cityList$filter = cityList.filter(e => {
    var _e$code;
    return e === null || e === void 0 ? void 0 : (_e$code = e.code) === null || _e$code === void 0 ? void 0 : _e$code.includes('avp');
  })) === null || _cityList$filter === void 0 ? void 0 : (_cityList$filter$ = _cityList$filter[0]) === null || _cityList$filter$ === void 0 ? void 0 : _cityList$filter$.boundary) || [];
  const scrutinyDetails = (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get(config.key);
  const [selectedCity, setSelectedCity] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.city) || null);
  const [localities, setLocalities] = useState((selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.boundary) || null);
  const [selectedLocality, setSelectedLocality] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.locality) || null);
  const [areaType, setAreaType] = useState('');
  const selectedLocalityIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name));
  const [villages, setVillages] = useState((selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.children) || (localities === null || localities === void 0 ? void 0 : (_localities$selectedL = localities[selectedLocalityIndex]) === null || _localities$selectedL === void 0 ? void 0 : _localities$selectedL.children) || []);
  const [village, setVillage] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.village) || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [name, setName] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny = formData.Scrutiny) === null || _formData$Scrutiny === void 0 ? void 0 : (_formData$Scrutiny$ = _formData$Scrutiny[0]) === null || _formData$Scrutiny$ === void 0 ? void 0 : _formData$Scrutiny$.applicantName));
  const [uploadedFile, setUploadedFile] = useState(() => {
    var _formData$Scrutiny2, _formData$Scrutiny2$, _formData$Scrutiny2$$;
    return (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny2 = formData.Scrutiny) === null || _formData$Scrutiny2 === void 0 ? void 0 : (_formData$Scrutiny2$ = _formData$Scrutiny2[0]) === null || _formData$Scrutiny2$ === void 0 ? void 0 : (_formData$Scrutiny2$$ = _formData$Scrutiny2$.proofIdentity) === null || _formData$Scrutiny2$$ === void 0 ? void 0 : _formData$Scrutiny2$$.fileStoreId) || null;
  });
  const [file, setFile] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : (_formData$owners$docu = _formData$owners.documents) === null || _formData$owners$docu === void 0 ? void 0 : _formData$owners$docu.proofIdentity);
  const [uploadMessage, setUploadMessage] = useState("");
  const history = useHistory();
  let validation = {};
  function setApplicantName(e) {
    setName(e.target.value);
  }
  function selectfile(e) {
    setUploadedFile(e.target.files[0]);
    setFile(e.target.files[0]);
  }
  const onSkip = () => {
    setUploadMessage("NEED TO DELETE");
  };
  function selectCity(city) {
    var _Digit4;
    setSelectedCity(city);
    setLocalities(city === null || city === void 0 ? void 0 : city.children);
    setOpenVillage(true);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType(city === null || city === void 0 ? void 0 : city.Unit);
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails = {
      city
    };
  }
  function selectLocality(locality) {
    var _formData$landAreaDet;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet = formData.landAreaDetails) !== null && _formData$landAreaDet !== void 0 && _formData$landAreaDet.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    setSelectedLocality(locality);
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }
  useEffect(() => {
    if (uploadMessage || isShowToast) {
      setName("");
      setUploadedFile(null);
      setFile("");
      setUploadMessage("");
    }
    if (isShowToast) {
      history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
        data: isShowToast !== null && isShowToast !== void 0 && isShowToast.label ? isShowToast === null || isShowToast === void 0 ? void 0 : isShowToast.label : "BPA_INTERNAL_SERVER_ERROR",
        type: "ERROR"
      });
    }
  }, [uploadMessage, isShowToast, isSubmitBtnDisable]);
  function onAdd() {
    setUploadMessage("NEED TO DELETE");
  }
  const handleSubmit = () => {
    var _Digit5;
    const data = {};
    data.tenantId = code;
    data.city = selectedCity;
    data.areaType = areaType || null;
    data.locality = selectedLocality || null;
    data.village = village || null;
    data.applicantName = name;
    data.file = file || uploadedFile || null;
    (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set(config.key, data);
    data.locality = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || "";
    data.village = (village === null || village === void 0 ? void 0 : village.name) || "";
    data.doorNo = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || null;
    onSelect(config.key, data);
  };
  if (isCityListLoading || isSubmitBtnDisable) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: !selectedCity || !name || !file || isSubmitBtnDisable,
    onAdd: onAdd,
    isMultipleAllow: true
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("City")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: citymoduleList,
    selectedOption: selectedCity,
    onSelect: selectCity,
    optionKey: "name",
    placeholder: `Select ${t("City")}`
  }), selectedCity && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Schemes")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true,
    isDropDown: true
  })), selectedCity && udCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Scheme")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && selectedLocality && villageOpen && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Unit")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    optionKey: "i18nKey",
    name: "areaType",
    value: areaType,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Owner Name")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "applicantName",
    onChange: setApplicantName,
    uploadMessage: uploadMessage,
    value: name
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_PLAN_DIAGRAM_LABEL")} *`), /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "edcr-doc",
    extraStyleName: "propertyCreate",
    accept: ".dxf",
    onUpload: selectfile,
    onDelete: () => {
      setUploadedFile(null);
      setFile("");
    },
    message: uploadedFile ? `1 ${t(`PT_ACTION_FILEUPLOADED`)}` : t(`ES_NO_FILE_SELECTED_LABEL`),
    uploadMessage: uploadMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      disabled: "true",
      height: "30px",
      width: "100%",
      fontSize: "14px"
    }
  }, t("EDCR_UPLOAD_FILE_LIMITS_LABEL")), isShowToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: isShowToast.key,
    label: t(isShowToast.label),
    onClose: () => setIsShowToast(null),
    isDleteBtn: true
  }));
};

let actions = [];
const getAction = flow => {
  switch (flow) {
    case "STAKEHOLDER":
      actions = ['BPA_LICENSE_DETAILS_LABEL', 'BPA_NEW_ADDRESS_HEADER_DETAILS', 'BPA_DOC_DETAILS_SUMMARY', 'BPA_STEPPER_SUMMARY_HEADER'];
      break;
    case "OCBPA":
      actions = ['BPA_SCRUTINY_DETAILS', 'BPA_DOCUMENT_AND_NOC_DETAILS_LABEL', 'BPA_STEPPER_SUMMARY_HEADER'];
    case "BPA":
      actions = ['BPA_SCRUTINY_DETAILS', 'Professional Information', 'Applicant Information', 'Documents', 'BPA_STEPPER_SUMMARY_HEADER'];
      break;
    case "Form11":
      actions = ['BPA_STEPPER_LAND_INFORMATION', 'BPA_STEPPER_PROFESSIONAL_INFORMATION', 'BPA_STEPPER_APPLICANT_INFORMATION', 'BPA_STEPPER_DOCUMENTS', 'BPA_STEPPER_SUMMARY_HEADER'];
      break;
    case "Form26":
      actions = ['BPA_STEPPER_LAND_INFORMATION', 'BPA_STEPPER_PROFESSIONAL_INFORMATION', 'BPA_STEPPER_APPLICANT_INFORMATION', 'BPA_STEPPER_DOCUMENTS', 'BPA_STEPPER_SUMMARY_HEADER'];
      break;
    default:
      actions = ['BPA_STEPPER_SCRUTINY_DETAILS_HEADER', 'BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL', 'BPA_NOC_DETAILS_SUMMARY', 'BPA_STEPPER_SUMMARY_HEADER'];
  }
};
const Timeline = ({
  currentStep: _currentStep = 1,
  flow: _flow = ""
}) => {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  getAction(_flow);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "timeline-container",
    style: isMobile ? {} : {
      maxWidth: "960px",
      minWidth: "640px",
      marginRight: "auto"
    }
  }, actions.map((action, index, arr) => /*#__PURE__*/React__default.createElement("div", {
    className: "timeline-checkpoint",
    key: index
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "timeline-content"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `circle ${index <= _currentStep - 1 && 'active'}`
  }, index < _currentStep - 1 ? /*#__PURE__*/React__default.createElement(TickMark, null) : index + 1), /*#__PURE__*/React__default.createElement("span", {
    className: "secondary-color"
  }, t(action))), index < arr.length - 1 && /*#__PURE__*/React__default.createElement("span", {
    className: `line ${index < _currentStep - 1 && 'active'}`
  }))));
};

const LocationDetails = ({
  config,
  onSelect,
  formData
}) => {
  var _formData, _formData$address, _formData2, _formData2$address, _formData3, _Digit;
  const {
    t
  } = useTranslation();
  let currCity = JSON.parse(sessionStorage.getItem("currentCity")) || {};
  let currPincode = sessionStorage.getItem("currentPincode");
  let currLocality = JSON.parse(sessionStorage.getItem("currentLocality")) || {};
  const allDistricts = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.DIST");
  const {
    pathname: url
  } = useLocation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState(allDistricts === null || allDistricts === void 0 ? void 0 : allDistricts.name);
  const [villageIndex, setVillageIndex] = useState(null);
  const [localities, setLocalities] = useState((allDistricts === null || allDistricts === void 0 ? void 0 : allDistricts.boundary) || []);
  const [selectedLocality, setSelectedLocality] = useState(((_formData = formData) === null || _formData === void 0 ? void 0 : (_formData$address = _formData.address) === null || _formData$address === void 0 ? void 0 : _formData$address.locality) || null);
  const [villages, setVillages] = useState([]);
  const [village, setVillage] = useState(((_formData2 = formData) === null || _formData2 === void 0 ? void 0 : (_formData2$address = _formData2.address) === null || _formData2$address === void 0 ? void 0 : _formData2$address.children) || null);
  const [villageOpen, setOpenVillage] = useState(false);
  const [areaType, setAreaType] = useState("");
  formData = {
    address: {
      ...((_formData3 = formData) === null || _formData3 === void 0 ? void 0 : _formData3.address)
    }
  };
  const code = (allDistricts === null || allDistricts === void 0 ? void 0 : allDistricts.code) || 'hp';
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const handleSubmit = () => {
    const address = {};
    address.city = selectedCity;
    address.tenantId = code;
    address.locality = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || "";
    address.areaType = areaType;
    address.village = (village === null || village === void 0 ? void 0 : village.name) || "";
    address.doorNo = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || null;
    onSelect(config.key, address);
  };
  function selectCity(city) {
    setSelectedLocality(null);
    setLocalities(null);
    setSelectedCity(city);
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    formData.address["city"] = city;
  }
  function selectLocality(locality) {
    var _formData4, _formData4$address, _localities$boundaryI, _localities$boundaryI2;
    if ((_formData4 = formData) !== null && _formData4 !== void 0 && (_formData4$address = _formData4.address) !== null && _formData4$address !== void 0 && _formData4$address.locality) {
      formData.address["locality"] = locality;
    }
    const boundaryIndex = localities.findIndex(e => e.name === locality.name);
    setVillageIndex(boundaryIndex);
    setSelectedLocality(locality);
    setVillages(localities === null || localities === void 0 ? void 0 : (_localities$boundaryI = localities[boundaryIndex]) === null || _localities$boundaryI === void 0 ? void 0 : _localities$boundaryI.children);
    setOpenVillage(true);
    setAreaType((localities === null || localities === void 0 ? void 0 : (_localities$boundaryI2 = localities[boundaryIndex]) === null || _localities$boundaryI2 === void 0 ? void 0 : _localities$boundaryI2.IsSpecialArea) === true ? `Special Area` : `Planning Area`);
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }
  function selectVillage(village) {
    var _formData5, _formData5$address;
    if ((_formData5 = formData) !== null && _formData5 !== void 0 && (_formData5$address = _formData5.address) !== null && _formData5$address !== void 0 && _formData5$address.village) {
      formData.address["village"] = village;
    }
    setVillage(village);
    sessionStorage.setItem("currVillage", JSON.stringify(village));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "13px"
    }
  }, !isOpen && /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    onSelect: handleSubmit,
    isDisabled: !selectedCity || !selectedLocality,
    isMultipleAllow: true,
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DISTRICT_LABEL")}*`), !isOpen && /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "district",
    value: selectedCity,
    onChange: selectCity,
    disabled: true
  }), !isOpen && selectedCity && tcpCode && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: config.isMandatory,
    options: localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    onSelect: selectLocality,
    t: t,
    isDependent: true,
    isDropDown: true
  })), !isOpen && selectedCity && udCode && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_ULB-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: config.isMandatory,
    options: localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    onSelect: selectLocality,
    t: t,
    isDependent: true,
    isDropDown: true
  })), !isOpen && selectedCity && villageOpen && tcpCode && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_AREA_TYPE_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    optionKey: "i18nKey",
    name: "district",
    value: areaType,
    disabled: true
  })), !isOpen && selectedCity && villageOpen && tcpCode && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_VILLAGE-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: config.isMandatory,
    options: villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    onSelect: selectVillage,
    t: t,
    isDependent: true,
    isDropDown: true
  })), !isOpen && selectedCity && villageOpen && udCode && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_WARD-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: config.isMandatory,
    options: villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    onSelect: selectVillage,
    t: t,
    isDependent: true,
    isDropDown: true
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      marginTop: '1rem'
    }
  })));
};

const LandDevelopment = ({
  landDevelopment,
  handlePlotChange,
  handlePlotAreaChange,
  handlePropertyTypeChange,
  addLandRow,
  deleteLandRow,
  propertyTypeOptions,
  t
}) => {
  let validation = {};
  return /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, t("CSS_COMMON_PLOTNO")), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("CSS_COMMON_PLOTAREA")), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("CSS_COMMON_PLOTTYPE")), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("CSS_COMMON_ADD")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, landDevelopment.map((elementInArray, index) => {
    var _elementInArray$landT;
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: index
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "plotNo",
      value: elementInArray.plotNo,
      onChange: e => handlePlotChange(e, index)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("PT_NAME_ERROR_MESSAGE")
    }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextInput$2, {
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "PlotArea",
      value: elementInArray.plotarea,
      onChange: e => handlePlotAreaChange(e, index)
    })), /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        width: '40%'
      }
    }, /*#__PURE__*/React__default.createElement(RadioOrSelect, {
      name: "propertyType",
      optionKey: "i18nKey",
      options: propertyTypeOptions,
      onSelect: code => handlePropertyTypeChange(code, index),
      selectedOption: elementInArray === null || elementInArray === void 0 ? void 0 : (_elementInArray$landT = elementInArray.landType) === null || _elementInArray$landT === void 0 ? void 0 : _elementInArray$landT.code,
      t: t
    })), /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        width: '20%'
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        gap: '.5rem',
        mt: "-1.2rem",
        ml: '.5rem'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      "aria-label": "add",
      onClick: addLandRow
    }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "delete",
      onClick: () => deleteLandRow(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
  })));
};

const KhasraArea = ({
  khasraArea,
  handleKhasraChange,
  handleAreaChange,
  addRow,
  deleteRow,
  t
}) => {
  let validation = {};
  return /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, t("BPA_PLOT_KHASARA_NO_LABEL")), /*#__PURE__*/React__default.createElement(TableCell$1, null, t("BPA_DOL_AREA_SQM_LABEL")), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Actions"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, khasraArea.map((elementInArray, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "khataNo",
    value: elementInArray.khasra,
    onChange: e => handleKhasraChange(e, index)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "area",
    value: elementInArray.area,
    onChange: e => handleAreaChange(e, index)
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      gap: '.5rem',
      mt: "-1.2rem",
      ml: '.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "add",
    onClick: addRow
  }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), index > 0 && /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    "aria-label": "delete",
    onClick: () => deleteRow(index)
  }, /*#__PURE__*/React__default.createElement(DeleteIcon, null))))))));
};

const PlotDetails = ({
  formData,
  onSelect,
  config
}) => {
  var _formData$data, _formData$data2, _data$planDetail, _data$planDetail$plan, _data$planDetail2, _data$planDetail2$pla, _data$planDetail3, _data$planDetail3$vir, _data$planDetail4, _data$planDetail4$pla, _data$planDetail5, _data$planDetail5$pla, _data$planDetail6, _data$planDetail7, _data$planDetail7$pla, _data$planDetail8, _data$planDetail8$far, _data$planDetail9, _data$planDetail9$far;
  const {
    t
  } = useTranslation();
  const [khatauniNo, setKhatauniNo] = useState("");
  const [subdivision, setSubdivision] = useState(null);
  const [isClu, setIsClu] = useState(null);
  const [cluType, setcluType] = useState("");
  const [caserefNo, setCaseRefNo] = useState("");
  const [excaserefNo, setExCaseRefNo] = useState("");
  const [noOfPlot, setnoOfPlot] = useState("");
  const [appliedLand, setAppliedLand] = useState(null);
  const [propertyType, setPropertyType] = useState([]);
  const [proposal, setProposal] = useState(null);
  const [constructionType, setConstructionType] = useState((formData === null || formData === void 0 ? void 0 : (_formData$data = formData.data) === null || _formData$data === void 0 ? void 0 : _formData$data.occupancyType) || "");
  const [areaforDevelopment, setPlotAreaforDevlopment] = useState("");
  const [totalKhasraArea, setTotalKhasraArea] = useState(0);
  let validation = {};
  const state = Digit.ULBService.getStateId();
  const {
    data,
    isLoading
  } = Digit.Hooks.obps.useScrutinyDetails(state, formData === null || formData === void 0 ? void 0 : (_formData$data2 = formData.data) === null || _formData$data2 === void 0 ? void 0 : _formData$data2.scrutinyNumber);
  const plotArea = (data === null || data === void 0 ? void 0 : (_data$planDetail = data.planDetail) === null || _data$planDetail === void 0 ? void 0 : (_data$planDetail$plan = _data$planDetail.planInformation) === null || _data$planDetail$plan === void 0 ? void 0 : _data$planDetail$plan.plotArea) || "";
  const typeofArea = (data === null || data === void 0 ? void 0 : (_data$planDetail2 = data.planDetail) === null || _data$planDetail2 === void 0 ? void 0 : (_data$planDetail2$pla = _data$planDetail2.planInformation) === null || _data$planDetail2$pla === void 0 ? void 0 : _data$planDetail2$pla.occupancy) || "";
  const buildupArea = (data === null || data === void 0 ? void 0 : (_data$planDetail3 = data.planDetail) === null || _data$planDetail3 === void 0 ? void 0 : (_data$planDetail3$vir = _data$planDetail3.virtualBuilding) === null || _data$planDetail3$vir === void 0 ? void 0 : _data$planDetail3$vir.totalBuitUpArea) || "";
  const [khasraArea, setKhasraArea] = useState([{
    khasra: "",
    area: ""
  }]);
  const [landDevelopment, setLandDevelopment] = useState([{
    plotNo: "",
    plotarea: "",
    landType: ""
  }]);
  function selectDivision(code) {
    setSubdivision(code);
  }
  function selectAppliedLand(code) {
    setAppliedLand(code);
  }
  const landOption = [{
    code: "Residential",
    i18nKey: "CS_COMMON_RESIDENTIAL"
  }, {
    code: "Industrial",
    i18nKey: "CS_COMMON_INDUSTRIAL"
  }, {
    code: "Commercial",
    i18nKey: "CS_COMMON_COMMERCIAL"
  }, {
    code: "Public & SemiPublic",
    i18nKey: "CS_COMMON_PUBLIC"
  }];
  const propertyTypeOptions = [{
    code: "Govt",
    i18nKey: "CS_COMMON_GOVT"
  }, {
    code: "Private",
    i18nKey: "CS_COMMON_PRIVATE"
  }, {
    code: "Public & SemiPublic",
    i18nKey: "CS_COMMON_PUBLIC"
  }];
  const cluTypeOptions = [{
    code: "CLUfromOriginal",
    i18nKey: "CS_BPA_CHANGE_OF_LAND_USE_FROM_ORIGINAL"
  }, {
    code: "IDPDevelopmentPlan",
    i18nKey: "IDP_DEVELOPMENT_PLAN_TO_OTHER_LAND_USE"
  }];
  const proposalTypeOptions = [{
    code: "Approval of Fresh Building Plan",
    i18nKey: "CS_COMMON_FRESH_BUILDING_PLAN"
  }, {
    code: "Change of Existing Building Use",
    i18nKey: "CS_COMMON_CHANGE_EXSISTING_BUILDING_USE"
  }, {
    code: "Reconstruction of Old Line",
    i18nKey: "CS_COMMON_RECONSTRUCTION"
  }, {
    code: "Alteration and Additional of Existing Building",
    i18nKey: "CS_COMMON_EXSISTING_BUILDING"
  }, {
    code: "New Building Use",
    i18nKey: "CS_COMMON_NEW_BUILDING_USE"
  }, {
    code: "Revised proposal of Approval Map",
    i18nKey: "CS_COMMON_PUBLIC_REVISED_MAP"
  }];
  const handleKhasraChange = (e, index) => {
    const updatedKhasraArea = [...khasraArea];
    updatedKhasraArea[index].khasra = e.target.value;
    setKhasraArea(updatedKhasraArea);
  };
  const handlePlotChange = (e, index) => {
    const updatedPLotNo = [...landDevelopment];
    updatedPLotNo[index].plotNo = e.target.value;
    setLandDevelopment(updatedPLotNo);
  };
  const handlePlotAreaChange = (e, index) => {
    const updatedPLotArea = [...landDevelopment];
    updatedPLotArea[index].plotarea = e.target.value;
    setLandDevelopment(updatedPLotArea);
  };
  const handlePropertyTypeChange = (code, index) => {
    console.log({
      code,
      index
    });
    const updatedLandDevelopment = [...landDevelopment];
    updatedLandDevelopment[index].landType = code === null || code === void 0 ? void 0 : code.code;
    setLandDevelopment(updatedLandDevelopment);
  };
  const handleAreaChange = (e, index) => {
    let totalArea = 0;
    const updatedKhasraArea = [...khasraArea];
    updatedKhasraArea[index].area = e.target.value;
    updatedKhasraArea.forEach(item => {
      totalArea += parseInt(item.area);
    });
    setKhasraArea(updatedKhasraArea);
    setTotalKhasraArea(totalArea);
  };
  const addRow = () => {
    var _khasraArea$index, _khasraArea$index$kha, _khasraArea$index2, _khasraArea$index2$ar;
    const index = khasraArea.length - 1;
    if ((khasraArea === null || khasraArea === void 0 ? void 0 : (_khasraArea$index = khasraArea[index]) === null || _khasraArea$index === void 0 ? void 0 : (_khasraArea$index$kha = _khasraArea$index.khasra) === null || _khasraArea$index$kha === void 0 ? void 0 : _khasraArea$index$kha.length) > 0 && (khasraArea === null || khasraArea === void 0 ? void 0 : (_khasraArea$index2 = khasraArea[index]) === null || _khasraArea$index2 === void 0 ? void 0 : (_khasraArea$index2$ar = _khasraArea$index2.area) === null || _khasraArea$index2$ar === void 0 ? void 0 : _khasraArea$index2$ar.length) > 0) {
      setKhasraArea([...khasraArea, {
        khasra: "",
        area: ""
      }]);
    } else {
      alert("Please add both the values");
    }
  };
  const addLandRow = () => {
    var _landDevelopment$inde, _landDevelopment$inde2, _landDevelopment$inde3, _landDevelopment$inde4, _landDevelopment$inde5, _landDevelopment$inde6;
    const index = landDevelopment.length - 1;
    if ((landDevelopment === null || landDevelopment === void 0 ? void 0 : (_landDevelopment$inde = landDevelopment[index]) === null || _landDevelopment$inde === void 0 ? void 0 : (_landDevelopment$inde2 = _landDevelopment$inde.plotNo) === null || _landDevelopment$inde2 === void 0 ? void 0 : _landDevelopment$inde2.length) > 0 && (landDevelopment === null || landDevelopment === void 0 ? void 0 : (_landDevelopment$inde3 = landDevelopment[index]) === null || _landDevelopment$inde3 === void 0 ? void 0 : (_landDevelopment$inde4 = _landDevelopment$inde3.plotarea) === null || _landDevelopment$inde4 === void 0 ? void 0 : _landDevelopment$inde4.length) > 0 && (landDevelopment === null || landDevelopment === void 0 ? void 0 : (_landDevelopment$inde5 = landDevelopment[index]) === null || _landDevelopment$inde5 === void 0 ? void 0 : (_landDevelopment$inde6 = _landDevelopment$inde5.landType) === null || _landDevelopment$inde6 === void 0 ? void 0 : _landDevelopment$inde6.length) > 0) {
      setLandDevelopment([...landDevelopment, {
        plotNo: "",
        plotarea: "",
        landType: ""
      }]);
    } else {
      alert("Please add all the values");
    }
  };
  const deleteRow = indexToDelete => {
    const updatedKhasraArea = khasraArea.filter((_, index) => index !== indexToDelete);
    let totalArea = 0;
    updatedKhasraArea.forEach(item => {
      totalArea += parseInt(item.area);
    });
    setKhasraArea(updatedKhasraArea);
    setTotalKhasraArea(totalArea);
  };
  const deleteLandRow = ind => {
    const updatedLandArea = landDevelopment.filter((_, index) => index !== ind);
    setLandDevelopment(updatedLandArea);
  };
  const handleSubmit = () => {
    const plotDetails = {};
    plotDetails.khatauniNo = khatauniNo || "", plotDetails.subdivision = (subdivision === null || subdivision === void 0 ? void 0 : subdivision.code) || " ", plotDetails.caserefNo = caserefNo || "", plotDetails.noOfPlot = noOfPlot || "", plotDetails.appliedLand = (appliedLand === null || appliedLand === void 0 ? void 0 : appliedLand.code) || "", plotDetails.propertyType = (propertyType === null || propertyType === void 0 ? void 0 : propertyType.code) || "", plotDetails.proposal = (proposal === null || proposal === void 0 ? void 0 : proposal.code) || "", plotDetails.constructionType = constructionType || "", plotDetails.areaforDevelopment = areaforDevelopment || "";
    plotDetails.plotArea = plotArea || "";
    plotDetails.typeofArea = typeofArea || "";
    plotDetails.totalBuildUpArea = buildupArea || "";
    plotDetails.khasraArea = khasraArea || [];
    plotDetails.totalKhasraArea = totalKhasraArea || 0;
    plotDetails.cluInvolved = isClu || null;
    plotDetails.cluType = cluType || null;
    plotDetails.landDevelopment = landDevelopment || [];
    plotDetails.exsistingCaseRefNo = excaserefNo || "";
    onSelect(config === null || config === void 0 ? void 0 : config.key, {
      ...plotDetails
    });
  };
  const onSkip = () => onSelect();
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  const labelStyle = {
    fontWeight: "bold",
    fontSize: "1rem"
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: handleSubmit,
    childrenAtTheBottom: false,
    t: t,
    _defaultValues: formData === null || formData === void 0 ? void 0 : formData.data,
    onSkip: onSkip,
    isDisabled: khatauniNo,
    cardStyle: {
      boxShadow: "none",
      padding: 0,
      border: 0
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BOUNDARY_PLOT_AREA_LABEL`),
    text: plotArea ? `${plotArea} ${t(`SQMT`)}` : "N/A"
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_PLOT_NUMBER_LABEL`),
    text: data === null || data === void 0 ? void 0 : (_data$planDetail4 = data.planDetail) === null || _data$planDetail4 === void 0 ? void 0 : (_data$planDetail4$pla = _data$planDetail4.planInformation) === null || _data$planDetail4$pla === void 0 ? void 0 : _data$planDetail4$pla.plotNo
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_KHATHA_NUMBER_LABEL`),
    text: data === null || data === void 0 ? void 0 : (_data$planDetail5 = data.planDetail) === null || _data$planDetail5 === void 0 ? void 0 : (_data$planDetail5$pla = _data$planDetail5.planInformation) === null || _data$planDetail5$pla === void 0 ? void 0 : _data$planDetail5$pla.khataNo
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_TYPE_OF_AREA_LABEL`),
    text: typeofArea || "N/A"
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_MAXIMUM_PERMISSIBLE_GROUND_COVERAGE`),
    text: (data === null || data === void 0 ? void 0 : (_data$planDetail6 = data.planDetail) === null || _data$planDetail6 === void 0 ? void 0 : _data$planDetail6.coverage) || "N/A"
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LAND_USE_LABEL`),
    text: t(`BPA_LAND_USE_${data === null || data === void 0 ? void 0 : (_data$planDetail7 = data.planDetail) === null || _data$planDetail7 === void 0 ? void 0 : (_data$planDetail7$pla = _data$planDetail7.planInformation) === null || _data$planDetail7$pla === void 0 ? void 0 : _data$planDetail7$pla.landUseZone}`) || "N/A"
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_FAR_LABEL`),
    text: (data === null || data === void 0 ? void 0 : (_data$planDetail8 = data.planDetail) === null || _data$planDetail8 === void 0 ? void 0 : (_data$planDetail8$far = _data$planDetail8.farDetails) === null || _data$planDetail8$far === void 0 ? void 0 : _data$planDetail8$far.providedFar) || (data === null || data === void 0 ? void 0 : (_data$planDetail9 = data.planDetail) === null || _data$planDetail9 === void 0 ? void 0 : (_data$planDetail9$far = _data$planDetail9.farDetails) === null || _data$planDetail9$far === void 0 ? void 0 : _data$planDetail9$far.permissableFar) || "N/A"
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BUILD_UP_AREA_LABEL`),
    text: buildupArea
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(KhasraArea, {
    khasraArea: khasraArea,
    handleKhasraChange: handleKhasraChange,
    handleAreaChange: handleAreaChange,
    addRow: addRow,
    deleteRow: deleteRow,
    t: t
  }), /*#__PURE__*/React__default.createElement(CardLabel, {
    style: labelStyle
  }, `${t("BPA_PLOT_TOTAL_KHASRA_AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "totalKhasraArea",
    value: totalKhasraArea,
    disabled: true
  }), /*#__PURE__*/React__default.createElement(CardLabel, {
    style: labelStyle
  }, `${t("BPA_PLOT_KHATAUNI_NO_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "khatauniNo",
    value: khatauniNo,
    onChange: e => setKhatauniNo(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_WHEATHER_SUBDIVISION_APPROVED_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionKey: "i18nKey",
    options: [{
      code: true,
      name: "yes",
      i18nKey: "CS_COMMON_YES"
    }, {
      code: false,
      name: "no",
      i18nKey: "CS_COMMON_NO"
    }],
    onSelect: selectDivision,
    selectedOption: subdivision,
    t: t
  }), (subdivision === null || subdivision === void 0 ? void 0 : subdivision.code) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_CASE_REFERENCE_NUMBER_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "caserefNo",
    value: caserefNo,
    onChange: e => setCaseRefNo(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_NO_OF_PLOT_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "number",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "noOfPlot",
    value: noOfPlot,
    onChange: e => setnoOfPlot(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    style: labelStyle
  }, `${t("BPA_APPLIED_ORIGINAL_LAND_USE")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    name: "appliedLand",
    optionKey: "i18nKey",
    options: landOption,
    onSelect: selectAppliedLand,
    selectedOption: appliedLand,
    t: t
  }), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PROPERTY_TYPE_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    name: "propertyType",
    optionKey: "i18nKey",
    options: propertyTypeOptions,
    onSelect: code => setPropertyType(code),
    selectedOption: propertyType,
    t: t
  }), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PROPOSAL_SUBMISSION_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    name: "proposal",
    optionKey: "i18nKey",
    options: proposalTypeOptions,
    onSelect: code => setProposal(code),
    selectedOption: proposal,
    t: t
  }), (proposal === null || proposal === void 0 ? void 0 : proposal.code) === "Revised proposal of Approval Map" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_EXSISTING_CASE_REFERENCE_NUMBER_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "exsistingCaseRefNo",
    value: excaserefNo,
    onChange: e => setExCaseRefNo(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_TYPE_OF_CONSTRUCTION_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "number",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "constructionType",
    value: constructionType,
    onChange: e => setConstructionType(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_AREA_FOR_DEVELOPMENT_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "number",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "plotAreafordevelopment",
    value: areaforDevelopment,
    onChange: e => setPlotAreaforDevlopment(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_WHEATHER_CHANGE_OF_LAND_USE_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionKey: "i18nKey",
    options: [{
      code: true,
      name: "yes",
      i18nKey: "CS_COMMON_YES"
    }, {
      code: false,
      name: "no",
      i18nKey: "CS_COMMON_NO"
    }],
    onSelect: code => setIsClu(code),
    selectedOption: isClu,
    t: t
  }), (isClu === null || isClu === void 0 ? void 0 : isClu.code) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_CLU_TYPE_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    name: "cluType",
    optionKey: "i18nKey",
    options: cluTypeOptions,
    onSelect: code => setcluType(code),
    selectedOption: cluType,
    t: t,
    isDropDown: true
  })), (isClu === null || isClu === void 0 ? void 0 : isClu.code) && (cluType === null || cluType === void 0 ? void 0 : cluType.code) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_PLOT_DETAILS_AFTER_SUBDIVISION")}`), /*#__PURE__*/React__default.createElement(LandDevelopment, {
    landDevelopment: landDevelopment,
    handlePlotChange: handlePlotChange,
    handlePlotAreaChange: handlePlotAreaChange,
    handlePropertyTypeChange: handlePropertyTypeChange,
    addLandRow: addLandRow,
    deleteLandRow: deleteLandRow,
    propertyTypeOptions: landOption,
    t: t
  }))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      margin: "1rem"
    }
  })));
};

const parseNumber = value => {
  const number = parseFloat(value);
  return isNaN(number) ? 0 : number;
};
const ScrutinyDetails = ({
  onSelect,
  userType,
  formData,
  config
}) => {
  var _formData$landInfo, _user$info, _formData$uiFlow, _formData$data, _formData$data$edcrDe, _formData$data$edcrDe2, _formData$data$edcrDe3, _formData$data$edcrDe4, _Digit, _formData$config$key, _formData$config$key$, _formData$config$key2, _formData$config$key3, _formData$config$key4, _formData$config$key5, _formData$config$key6, _formData$config$key7, _formData$config$key8, _formData$config$key9, _formData$config$key10, _formData$config$key11, _formData$config$key12, _formData$config$key13, _formData$config$key14, _formData$config$key15, _formData$config$key16, _formData$config$key17, _formData$config$key18, _formData$config$key19, _formData$config$key20, _formData$config$key21, _formData$config$key22, _formData$config$key23, _formData$config$key24, _formData$config$key25, _setBacksObj$, _setBacksObj$$frontYa, _setBacksObj$2, _setBacksObj$2$rearYa, _setBacksObj$3, _setBacksObj$3$sideYa, _setBacksObj$4, _setBacksObj$4$sideYa, _formData$data2, _data$planDetail, _data$planDetail$bloc, _data$planDetail$bloc2, _data$planDetail$bloc3, _data$planDetail2, _data$planDetail2$blo, _data$planDetail2$blo2, _data$planDetail2$blo3, _data$planDetail3, _data$planDetail3$blo, _data$planDetail3$blo2, _data$planDetail3$blo3, _data$planDetail4, _data$planDetail4$blo, _data$planDetail4$blo2, _data$planDetail4$blo3, _data$planDetail5, _data$planDetail5$blo, _data$planDetail5$blo2, _data$planDetail5$blo3, _data$planDetail6, _data$planDetail6$blo, _data$planDetail7, _data$planDetail7$pla, _data$planDetail8, _data$planDetail8$pla;
  const {
    t
  } = useTranslation();
  const [subOccupancy, setsubOccupancy] = useState([]);
  const [subOccupancyObject, setsubOccupancyObject] = useState((formData === null || formData === void 0 ? void 0 : formData.subOccupancy) || (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.unit) || {});
  let user = Digit.UserService.getUser();
  let validation = {};
  const tenantId = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.permanentCity) || Digit.ULBService.getCurrentTenantId();
  const checkingFlow = formData === null || formData === void 0 ? void 0 : (_formData$uiFlow = formData.uiFlow) === null || _formData$uiFlow === void 0 ? void 0 : _formData$uiFlow.flow;
  const setBacksObj = formData === null || formData === void 0 ? void 0 : (_formData$data = formData.data) === null || _formData$data === void 0 ? void 0 : (_formData$data$edcrDe = _formData$data.edcrDetails) === null || _formData$data$edcrDe === void 0 ? void 0 : (_formData$data$edcrDe2 = _formData$data$edcrDe.planDetail) === null || _formData$data$edcrDe2 === void 0 ? void 0 : (_formData$data$edcrDe3 = _formData$data$edcrDe2.blocks) === null || _formData$data$edcrDe3 === void 0 ? void 0 : (_formData$data$edcrDe4 = _formData$data$edcrDe3[0]) === null || _formData$data$edcrDe4 === void 0 ? void 0 : _formData$data$edcrDe4.setBacks;
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const isUdFlow = applicationFlow === 'UD';
  const [showToast, setShowToast] = useState(null);
  const [monument, setMonument] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key = formData[config.key]) === null || _formData$config$key === void 0 ? void 0 : (_formData$config$key$ = _formData$config$key.checklistData) === null || _formData$config$key$ === void 0 ? void 0 : _formData$config$key$.isAsiMonumnet) || {
    code: 'NO'
  });
  const [tree, setTree] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key2 = formData[config.key]) === null || _formData$config$key2 === void 0 ? void 0 : (_formData$config$key3 = _formData$config$key2.checklistData) === null || _formData$config$key3 === void 0 ? void 0 : _formData$config$key3.isTreeNear) || {
    code: 'NO'
  });
  const [highway, setHighway] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key4 = formData[config.key]) === null || _formData$config$key4 === void 0 ? void 0 : (_formData$config$key5 = _formData$config$key4.checklistData) === null || _formData$config$key5 === void 0 ? void 0 : _formData$config$key5.isHighwayNear) || {
    code: 'NO'
  });
  const [drainage, setDrainage] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key6 = formData[config.key]) === null || _formData$config$key6 === void 0 ? void 0 : (_formData$config$key7 = _formData$config$key6.checklistData) === null || _formData$config$key7 === void 0 ? void 0 : _formData$config$key7.isAbuttingDrainage) || {
    code: 'NO'
  });
  const [pipeline, setPipeline] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key8 = formData[config.key]) === null || _formData$config$key8 === void 0 ? void 0 : (_formData$config$key9 = _formData$config$key8.checklistData) === null || _formData$config$key9 === void 0 ? void 0 : _formData$config$key9.isCrossingPipeline) || {
    code: 'NO'
  });
  const [solar, setSolar] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key10 = formData[config.key]) === null || _formData$config$key10 === void 0 ? void 0 : (_formData$config$key11 = _formData$config$key10.checklistData) === null || _formData$config$key11 === void 0 ? void 0 : _formData$config$key11.isSolarInstalled) || {
    code: 'NO'
  });
  const [barrierfee, setBarrierFee] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key12 = formData[config.key]) === null || _formData$config$key12 === void 0 ? void 0 : (_formData$config$key13 = _formData$config$key12.checklistData) === null || _formData$config$key13 === void 0 ? void 0 : _formData$config$key13.isBarrierFeeforDisabled) || {
    code: 'NO'
  });
  const [valley, setValley] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key14 = formData[config.key]) === null || _formData$config$key14 === void 0 ? void 0 : (_formData$config$key15 = _formData$config$key14.checklistData) === null || _formData$config$key15 === void 0 ? void 0 : _formData$config$key15.isAbovetheValley) || {
    code: 'NO'
  });
  const [sliding, setSliding] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key16 = formData[config.key]) === null || _formData$config$key16 === void 0 ? void 0 : (_formData$config$key17 = _formData$config$key16.checklistData) === null || _formData$config$key17 === void 0 ? void 0 : _formData$config$key17.isNearSinkingOrSliding) || {
    code: 'NO'
  });
  const [rainwater, setRainwater] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key18 = formData[config.key]) === null || _formData$config$key18 === void 0 ? void 0 : (_formData$config$key19 = _formData$config$key18.checklistData) === null || _formData$config$key19 === void 0 ? void 0 : _formData$config$key19.isProvisionforrainwater) || {
    code: 'NO'
  });
  const [airport, setAirport] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key20 = formData[config.key]) === null || _formData$config$key20 === void 0 ? void 0 : (_formData$config$key21 = _formData$config$key20.checklistData) === null || _formData$config$key21 === void 0 ? void 0 : _formData$config$key21.isAAIPermissioned) || {
    code: 'NO'
  });
  const [dwelling, setDwelling] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key22 = formData[config.key]) === null || _formData$config$key22 === void 0 ? void 0 : (_formData$config$key23 = _formData$config$key22.checklistData) === null || _formData$config$key23 === void 0 ? void 0 : _formData$config$key23.noOfDwellingUnit) || 0);
  const [muckToBeDisposed, setMuckToBeDisposed] = useState((formData === null || formData === void 0 ? void 0 : (_formData$config$key24 = formData[config.key]) === null || _formData$config$key24 === void 0 ? void 0 : (_formData$config$key25 = _formData$config$key24.checklistData) === null || _formData$config$key25 === void 0 ? void 0 : _formData$config$key25.muckToBeDisposed) || 0);
  const [setBacks, setSetbacks] = useState({
    front: (setBacksObj === null || setBacksObj === void 0 ? void 0 : (_setBacksObj$ = setBacksObj[0]) === null || _setBacksObj$ === void 0 ? void 0 : (_setBacksObj$$frontYa = _setBacksObj$.frontYard) === null || _setBacksObj$$frontYa === void 0 ? void 0 : _setBacksObj$$frontYa.minimumDistance) || "",
    rear: (setBacksObj === null || setBacksObj === void 0 ? void 0 : (_setBacksObj$2 = setBacksObj[0]) === null || _setBacksObj$2 === void 0 ? void 0 : (_setBacksObj$2$rearYa = _setBacksObj$2.rearYard) === null || _setBacksObj$2$rearYa === void 0 ? void 0 : _setBacksObj$2$rearYa.minimumDistance) || "",
    left: (setBacksObj === null || setBacksObj === void 0 ? void 0 : (_setBacksObj$3 = setBacksObj[0]) === null || _setBacksObj$3 === void 0 ? void 0 : (_setBacksObj$3$sideYa = _setBacksObj$3.sideYard1) === null || _setBacksObj$3$sideYa === void 0 ? void 0 : _setBacksObj$3$sideYa.minimumDistance) || "",
    right: (setBacksObj === null || setBacksObj === void 0 ? void 0 : (_setBacksObj$4 = setBacksObj[0]) === null || _setBacksObj$4 === void 0 ? void 0 : (_setBacksObj$4$sideYa = _setBacksObj$4.sideYard2) === null || _setBacksObj$4$sideYa === void 0 ? void 0 : _setBacksObj$4$sideYa.minimumDistance) || ""
  });
  console.log(setBacksObj, "scrutinydetailspageformdata");
  const labelStyle = {
    fontWeight: '30px',
    fontSize: '1rem'
  };
  const stateCode = Digit.ULBService.getStateId();
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["SubOccupancyType"]);
  const {
    data,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(tenantId, formData === null || formData === void 0 ? void 0 : (_formData$data2 = formData.data) === null || _formData$data2 === void 0 ? void 0 : _formData$data2.scrutinyNumber, {
    enabled: true
  });
  function getFloorData(block) {
    var _block$building, _block$building$floor;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : (_block$building$floor = _block$building.floors) === null || _block$building$floor === void 0 ? void 0 : _block$building$floor.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  function getsuboptions() {
    var _mdmsData$BPA, _mdmsData$BPA$SubOccu;
    let suboccoption = [];
    mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : (_mdmsData$BPA$SubOccu = _mdmsData$BPA.SubOccupancyType) === null || _mdmsData$BPA$SubOccu === void 0 ? void 0 : _mdmsData$BPA$SubOccu.map(ob => {
      var _ob$code;
      suboccoption.push({
        code: ob.code,
        name: ob.name,
        i18nKey: `BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(ob === null || ob === void 0 ? void 0 : (_ob$code = ob.code) === null || _ob$code === void 0 ? void 0 : _ob$code.toUpperCase(), "-", "_")}`
      });
    });
    return Digit.Utils.locale.sortDropdownNames(suboccoption, 'i18nKey', t);
  }
  const ActionButton = ({
    label,
    jumpTo
  }) => {
    const {
      t
    } = useTranslation();
    const history = useHistory();
    function routeTo() {
      location.href = jumpTo;
    }
    return /*#__PURE__*/React__default.createElement(LinkButton, {
      label: t(label),
      onClick: routeTo
    });
  };
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const selectOccupancy = (e, data, num) => {
    let blocks = subOccupancyObject;
    let newSubOccupancy = [];
    e && (e === null || e === void 0 ? void 0 : e.map(ob => {
      newSubOccupancy.push(ob === null || ob === void 0 ? void 0 : ob[1]);
    }));
    blocks[`Block_${num}`] = newSubOccupancy;
    setsubOccupancy(newSubOccupancy);
    setsubOccupancyObject(blocks);
  };
  const onRemove = (index, key, num) => {
    let afterRemove = subOccupancyObject[`Block_${num}`].filter((value, i) => {
      return i !== index;
    });
    setsubOccupancy(afterRemove);
    let temp = subOccupancyObject;
    temp[`Block_${num}`] = afterRemove;
    setsubOccupancyObject(temp);
  };
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const tableColumns = useMemo(() => {
    return tableHeader === null || tableHeader === void 0 ? void 0 : tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  const onSkip = () => onSelect();
  const goNext = () => {
    if (checkingFlow === "OCBPA") {
      if (!(formData !== null && formData !== void 0 && formData.id)) {
        var _formData$edcrNumber, _formData$edcrNumber2, _formData$data3, _formData$data3$scrut, _formData$data4, _formData$data5, _formData$data6, _userInfo$info, _formData$data7, _formData$data7$bpaDa, _formData$data7$bpaDa2, _formData$data7$bpaDa3, _formData$data7$bpaDa4, _userInfo$info2, _formData$data8, _formData$data9, _formData$data10, _formData$data11, _formData$data12, _formData$data13, _formData$data14, _formData$data15, _formData$data16, _formData$data16$bpaD, _formData$data16$bpaD2;
        let payload = {};
        payload.edcrNumber = formData !== null && formData !== void 0 && (_formData$edcrNumber = formData.edcrNumber) !== null && _formData$edcrNumber !== void 0 && _formData$edcrNumber.edcrNumber ? formData === null || formData === void 0 ? void 0 : (_formData$edcrNumber2 = formData.edcrNumber) === null || _formData$edcrNumber2 === void 0 ? void 0 : _formData$edcrNumber2.edcrNumber : formData === null || formData === void 0 ? void 0 : (_formData$data3 = formData.data) === null || _formData$data3 === void 0 ? void 0 : (_formData$data3$scrut = _formData$data3.scrutinyNumber) === null || _formData$data3$scrut === void 0 ? void 0 : _formData$data3$scrut.edcrNumber;
        payload.riskType = formData === null || formData === void 0 ? void 0 : (_formData$data4 = formData.data) === null || _formData$data4 === void 0 ? void 0 : _formData$data4.riskType;
        payload.applicationType = formData === null || formData === void 0 ? void 0 : (_formData$data5 = formData.data) === null || _formData$data5 === void 0 ? void 0 : _formData$data5.applicationType;
        payload.serviceType = formData === null || formData === void 0 ? void 0 : (_formData$data6 = formData.data) === null || _formData$data6 === void 0 ? void 0 : _formData$data6.serviceType;
        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
        payload.tenantId = formData === null || formData === void 0 ? void 0 : (_formData$data7 = formData.data) === null || _formData$data7 === void 0 ? void 0 : (_formData$data7$bpaDa = _formData$data7.bpaData) === null || _formData$data7$bpaDa === void 0 ? void 0 : (_formData$data7$bpaDa2 = _formData$data7$bpaDa.bpaApprovalResponse) === null || _formData$data7$bpaDa2 === void 0 ? void 0 : (_formData$data7$bpaDa3 = _formData$data7$bpaDa2[0]) === null || _formData$data7$bpaDa3 === void 0 ? void 0 : (_formData$data7$bpaDa4 = _formData$data7$bpaDa3.landInfo) === null || _formData$data7$bpaDa4 === void 0 ? void 0 : _formData$data7$bpaDa4.tenantId;
        payload.workflow = {
          action: "INITIATE",
          assignes: [userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.uuid]
        };
        payload.accountId = accountId;
        payload.documents = null;
        payload.additionalDetails = {};
        if (formData !== null && formData !== void 0 && (_formData$data8 = formData.data) !== null && _formData$data8 !== void 0 && _formData$data8.holdingNumber) payload.additionalDetails.holdingNo = formData === null || formData === void 0 ? void 0 : (_formData$data9 = formData.data) === null || _formData$data9 === void 0 ? void 0 : _formData$data9.holdingNumber;
        if (formData !== null && formData !== void 0 && (_formData$data10 = formData.data) !== null && _formData$data10 !== void 0 && _formData$data10.registrationDetails) payload.additionalDetails.registrationDetails = formData === null || formData === void 0 ? void 0 : (_formData$data11 = formData.data) === null || _formData$data11 === void 0 ? void 0 : _formData$data11.registrationDetails;
        if (formData !== null && formData !== void 0 && (_formData$data12 = formData.data) !== null && _formData$data12 !== void 0 && _formData$data12.applicationType) payload.additionalDetails.applicationType = formData === null || formData === void 0 ? void 0 : (_formData$data13 = formData.data) === null || _formData$data13 === void 0 ? void 0 : _formData$data13.applicationType;
        if (formData !== null && formData !== void 0 && (_formData$data14 = formData.data) !== null && _formData$data14 !== void 0 && _formData$data14.serviceType) payload.additionalDetails.serviceType = formData === null || formData === void 0 ? void 0 : (_formData$data15 = formData.data) === null || _formData$data15 === void 0 ? void 0 : _formData$data15.serviceType;
        payload.landInfo = (formData === null || formData === void 0 ? void 0 : (_formData$data16 = formData.data) === null || _formData$data16 === void 0 ? void 0 : (_formData$data16$bpaD = _formData$data16.bpaData) === null || _formData$data16$bpaD === void 0 ? void 0 : (_formData$data16$bpaD2 = _formData$data16$bpaD.bpaApprovalResponse) === null || _formData$data16$bpaD2 === void 0 ? void 0 : _formData$data16$bpaD2[0].landInfo) || {};
        let nameOfAchitect = sessionStorage.getItem("BPA_ARCHITECT_NAME");
        let parsedArchitectName = nameOfAchitect ? JSON.parse(nameOfAchitect) : "ARCHITECT";
        payload.additionalDetails.typeOfArchitect = parsedArchitectName;
        Digit.OBPSService.create({
          BPA: payload
        }, tenantId).then((result, err) => {
          var _result$BPA;
          if ((result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA.length) > 0) {
            result.BPA[0].data = formData.data;
            result.BPA[0].uiFlow = formData === null || formData === void 0 ? void 0 : formData.uiFlow;
            onSelect("", result.BPA[0], "", true);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setShowToast({
            key: "true",
            message: (e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message) || null
          });
        });
      } else {
        onSelect("", formData, "", true);
      }
    } else {
      let ChecklistaData = {
        setbackfront: (setBacks === null || setBacks === void 0 ? void 0 : setBacks.front) || "",
        setbackrear: (setBacks === null || setBacks === void 0 ? void 0 : setBacks.rear) || "",
        setbackleft: (setBacks === null || setBacks === void 0 ? void 0 : setBacks.left) || "",
        setbackright: setBacks.right || "",
        isAsiMonumnet: monument,
        isTreeNear: tree,
        isHighwayNear: highway,
        isAbuttingDrainage: drainage,
        isCrossingPipeline: pipeline,
        isSolarInstalled: solar,
        isBarrierFeeforDisabled: barrierfee,
        isAbovetheValley: valley,
        isNearSinkingOrSliding: sliding,
        isProvisionforrainwater: rainwater,
        isAAIPermissioned: airport,
        noOfDwellingUnit: parseNumber(dwelling),
        ...(isUdFlow && {
          muckToBeDisposed: parseNumber(muckToBeDisposed)
        })
      };
      subOccupancyObject.checklistData = ChecklistaData;
      onSelect(config.key, subOccupancyObject);
    }
  };
  const clearall = num => {
    let res = [];
    let temp = subOccupancyObject;
    temp[`Block_${num}`] = res;
    setsubOccupancy(res);
    setsubOccupancyObject(temp);
  };
  function getSubOccupancyValues(index) {
    var _formData$data17, _formData$data17$bpaD, _formData$data17$bpaD2, _formData$data17$bpaD3, _formData$data17$bpaD4;
    let values = formData === null || formData === void 0 ? void 0 : (_formData$data17 = formData.data) === null || _formData$data17 === void 0 ? void 0 : (_formData$data17$bpaD = _formData$data17.bpaData) === null || _formData$data17$bpaD === void 0 ? void 0 : (_formData$data17$bpaD2 = _formData$data17$bpaD.bpaApprovalResponse) === null || _formData$data17$bpaD2 === void 0 ? void 0 : (_formData$data17$bpaD3 = _formData$data17$bpaD2[0]) === null || _formData$data17$bpaD3 === void 0 ? void 0 : (_formData$data17$bpaD4 = _formData$data17$bpaD3.landInfo) === null || _formData$data17$bpaD4 === void 0 ? void 0 : _formData$data17$bpaD4.unit;
    let returnValue = "";
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
      var _values$index, _values$index$usageCa;
      let splitArray = (_values$index = values[index]) === null || _values$index === void 0 ? void 0 : (_values$index$usageCa = _values$index.usageCategory) === null || _values$index$usageCa === void 0 ? void 0 : _values$index$usageCa.split(",");
      if (splitArray !== null && splitArray !== void 0 && splitArray.length) {
        const returnValueArray = splitArray === null || splitArray === void 0 ? void 0 : splitArray.map(data => data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.toUpperCase(), "-", "_")}`)}` : "NA");
        returnValue = returnValueArray.join(", ");
      }
    }
    return returnValue ? returnValue : "NA";
  }
  if (isMdmsLoading || isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  const cardLabelStyle = {
    fontWeight: 600
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    onSelect: goNext,
    onSkip: onSkip,
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none",
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    style: {
      border: "none"
    },
    label: checkingFlow === "OCBPA" ? t("BPA_OC_EDCR_NO_LABEL") : t("BPA_EDCR_NO_LABEL"),
    text: data === null || data === void 0 ? void 0 : data.edcrNumber
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_UPLOADED_PLAN_DIAGRAM"),
    text: /*#__PURE__*/React__default.createElement(ActionButton, {
      label: t("BPA_UPLOADED_PLAN_DXF"),
      jumpTo: data === null || data === void 0 ? void 0 : data.updatedDxfFile
    })
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_SCRUNTINY_REPORT_OUTPUT"),
    text: /*#__PURE__*/React__default.createElement(ActionButton, {
      label: t("BPA_SCRUTINY_REPORT_PDF"),
      jumpTo: data === null || data === void 0 ? void 0 : data.planReport
    })
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px"
    }
  }, checkingFlow === "OCBPA" ? t("BPA_ACTUAL_BUILDING_EXTRACT_HEADER") : t("BPA_BUILDING_EXTRACT_HEADER")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none",
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_TOTAL_BUILT_UP_AREA_HEADER"),
    text: data !== null && data !== void 0 && (_data$planDetail = data.planDetail) !== null && _data$planDetail !== void 0 && (_data$planDetail$bloc = _data$planDetail.blocks) !== null && _data$planDetail$bloc !== void 0 && (_data$planDetail$bloc2 = _data$planDetail$bloc[0]) !== null && _data$planDetail$bloc2 !== void 0 && (_data$planDetail$bloc3 = _data$planDetail$bloc2.building) !== null && _data$planDetail$bloc3 !== void 0 && _data$planDetail$bloc3.totalBuitUpArea ? `${data === null || data === void 0 ? void 0 : (_data$planDetail2 = data.planDetail) === null || _data$planDetail2 === void 0 ? void 0 : (_data$planDetail2$blo = _data$planDetail2.blocks) === null || _data$planDetail2$blo === void 0 ? void 0 : (_data$planDetail2$blo2 = _data$planDetail2$blo[0]) === null || _data$planDetail2$blo2 === void 0 ? void 0 : (_data$planDetail2$blo3 = _data$planDetail2$blo2.building) === null || _data$planDetail2$blo3 === void 0 ? void 0 : _data$planDetail2$blo3.totalBuitUpArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL"),
    text: data === null || data === void 0 ? void 0 : (_data$planDetail3 = data.planDetail) === null || _data$planDetail3 === void 0 ? void 0 : (_data$planDetail3$blo = _data$planDetail3.blocks) === null || _data$planDetail3$blo === void 0 ? void 0 : (_data$planDetail3$blo2 = _data$planDetail3$blo[0]) === null || _data$planDetail3$blo2 === void 0 ? void 0 : (_data$planDetail3$blo3 = _data$planDetail3$blo2.building) === null || _data$planDetail3$blo3 === void 0 ? void 0 : _data$planDetail3$blo3.totalFloors
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_HEIGHT_FROM_GROUND_LEVEL_FROM_MUMTY"),
    text: data !== null && data !== void 0 && (_data$planDetail4 = data.planDetail) !== null && _data$planDetail4 !== void 0 && (_data$planDetail4$blo = _data$planDetail4.blocks) !== null && _data$planDetail4$blo !== void 0 && (_data$planDetail4$blo2 = _data$planDetail4$blo[0]) !== null && _data$planDetail4$blo2 !== void 0 && (_data$planDetail4$blo3 = _data$planDetail4$blo2.building) !== null && _data$planDetail4$blo3 !== void 0 && _data$planDetail4$blo3.declaredBuildingHeight ? `${data === null || data === void 0 ? void 0 : (_data$planDetail5 = data.planDetail) === null || _data$planDetail5 === void 0 ? void 0 : (_data$planDetail5$blo = _data$planDetail5.blocks) === null || _data$planDetail5$blo === void 0 ? void 0 : (_data$planDetail5$blo2 = _data$planDetail5$blo[0]) === null || _data$planDetail5$blo2 === void 0 ? void 0 : (_data$planDetail5$blo3 = _data$planDetail5$blo2.building) === null || _data$planDetail5$blo3 === void 0 ? void 0 : _data$planDetail5$blo3.declaredBuildingHeight} ${t("BPA_MTRS_LABEL")}` : t("NA")
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px"
    }
  }, t("BPA_OCC_SUBOCC_HEADER")), data === null || data === void 0 ? void 0 : (_data$planDetail6 = data.planDetail) === null || _data$planDetail6 === void 0 ? void 0 : (_data$planDetail6$blo = _data$planDetail6.blocks) === null || _data$planDetail6$blo === void 0 ? void 0 : _data$planDetail6$blo.map((block, index) => {
    var _subOccupancyObject;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        fontSize: "20px"
      }
    }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React__default.createElement("div", {
      style: {
        margin: "0px 0px 0px 13px"
      }
    }, !(checkingFlow === "OCBPA") ? /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      style: {
        fontWeight: "bold"
      },
      className: "card-label-smaller"
    }, t("BPA_SUB_OCCUPANCY_LABEL")) : null, !(checkingFlow === "OCBPA") ? /*#__PURE__*/React__default.createElement(MultiSelectDropdown, {
      BlockNumber: block.number,
      className: "form-field",
      isMandatory: true,
      defaultUnit: "Selected",
      selected: subOccupancyObject[`Block_${block.number}`],
      options: getsuboptions(),
      onSelect: e => selectOccupancy(e, data, block.number),
      isOBPSMultiple: true,
      optionsKey: "i18nKey",
      ServerStyle: {
        width: "100%",
        overflowX: "hidden"
      },
      t: t
    }) : null, !(checkingFlow === "OCBPA") ? /*#__PURE__*/React__default.createElement("div", {
      className: "tag-container"
    }, subOccupancyObject[`Block_${block.number}`] && subOccupancyObject[`Block_${block.number}`].length > 0 && ((_subOccupancyObject = subOccupancyObject[`Block_${block.number}`]) === null || _subOccupancyObject === void 0 ? void 0 : _subOccupancyObject.map((value, index) => /*#__PURE__*/React__default.createElement(RemoveableTag, {
      key: index,
      text: `${t(value["i18nKey"])}`,
      onClick: () => onRemove(index, value, block.number)
    })))) : null, !(checkingFlow === "OCBPA") ? subOccupancyObject[`Block_${block.number}`] && subOccupancyObject[`Block_${block.number}`].length > 0 && /*#__PURE__*/React__default.createElement(LinkButton, {
      style: {
        textAlign: "left"
      },
      label: "Clear All",
      onClick: () => clearall(block.number)
    }) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "20px"
      }
    }, checkingFlow === "OCBPA" ? /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
      text: getSubOccupancyValues(index)
    })) : null), /*#__PURE__*/React__default.createElement("div", {
      style: {
        overflowX: "scroll"
      }
    }, /*#__PURE__*/React__default.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    }))));
  }), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px",
      textAlign: "left"
    }
  }, t("BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none",
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    label: t("BPA_APPLICATION_DEMOLITION_AREA_LABEL"),
    text: data !== null && data !== void 0 && (_data$planDetail7 = data.planDetail) !== null && _data$planDetail7 !== void 0 && (_data$planDetail7$pla = _data$planDetail7.planInformation) !== null && _data$planDetail7$pla !== void 0 && _data$planDetail7$pla.demolitionArea ? `${data === null || data === void 0 ? void 0 : (_data$planDetail8 = data.planDetail) === null || _data$planDetail8 === void 0 ? void 0 : (_data$planDetail8$pla = _data$planDetail8.planInformation) === null || _data$planDetail8$pla === void 0 ? void 0 : _data$planDetail8$pla.demolitionArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "0px 0px 0px 13px"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      fontWeight: "bold"
    }
  }, `${t("BPA_APPLICATION_SETBACKS_INFORMATION")}`), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_SETBACLS_TYPE_FRONT_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "front",
    placeholder: "FRONT",
    value: setBacks.front,
    onChange: e => setSetbacks({
      ...setBacks,
      front: e.target.value
    })
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_SETBACKS_TYPE_REAR_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "rear",
    placeholder: "REAR",
    value: setBacks.rear,
    onChange: e => setSetbacks({
      ...setBacks,
      rear: e.target.value
    })
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_SETBACKS_TYPE_LEFT_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    placeholder: "LEFT",
    name: "left",
    value: setBacks.left,
    onChange: e => setSetbacks({
      ...setBacks,
      left: e.target.value
    })
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    variant: "h6",
    style: labelStyle
  }, `${t("BPA_SETBACKS_TYPE_RIGHT_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "right",
    placeholder: "RIGHT",
    value: setBacks.right,
    onChange: e => setSetbacks({
      ...setBacks,
      right: e.target.value
    })
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PROPOSED_PLAN_IS_LOCATED_NEAR_ASI_MONUMENT"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: monument.code === 'YES',
      onChange: e => setMonument(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), monument.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "monument.name",
    value: monument.name,
    onChange: e => setMonument(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_TREES_STANDING_NEAR_PLOT"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: tree.code === 'YES',
      onChange: e => setTree(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), tree.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "tree.name",
    value: tree.name,
    onChange: e => setTree(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PLOT_ABUTTING_NATIONAL_HIGHWAY/STATE"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: highway.code === 'YES',
      onChange: e => setHighway(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), highway.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "highway.name",
    value: highway.name,
    onChange: e => setHighway(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PLOT_ABUTTING_NATURAL_DRAINAGE"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: drainage.code === 'YES',
      onChange: e => setDrainage(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), drainage.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "drainage.name",
    value: drainage.name,
    onChange: e => setDrainage(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PIPELINE_CROSSING_THE_PLOT"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: pipeline.code === 'YES',
      onChange: e => setPipeline(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), pipeline.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "pipeline.name",
    value: pipeline.name,
    onChange: e => setPipeline(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PROVISION_OF_SOLAR_PASSIVE_BUILDING"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: solar.code === 'YES',
      onChange: e => setSolar(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), solar.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "solar.name",
    value: solar.name,
    onChange: e => setSolar(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PROVISIONS_OF_BARRIER_FEE_FOR_PERSONS_WITH_DISABILITY"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: barrierfee.code === 'YES',
      onChange: e => setBarrierFee(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), barrierfee.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "barrierfee.name",
    value: barrierfee.name,
    onChange: e => setBarrierFee(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PLAN_IS_ABOVE_THE_ROAD_ON_VALLEY_SIDE"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: valley.code === 'YES',
      onChange: e => setValley(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), valley.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "valley.name",
    value: valley.name,
    onChange: e => setValley(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_PLAN_IS_LOCATED_IN_SINKING_AND_SLIDING_AREA"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: sliding.code === 'YES',
      onChange: e => setSliding(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), sliding.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "sliding.name",
    value: sliding.name,
    onChange: e => setSliding(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_RAINWATER_HARVESTING_TANK_PROVISION"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: rainwater.code === 'YES',
      onChange: e => setRainwater(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), rainwater.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "rainwater.name",
    value: rainwater.name,
    onChange: e => setRainwater(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, {
    style: cardLabelStyle
  }, `${t("BPA_APPLICATION_NO_OF_DWELLING_UNIT")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "number",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "dwelling",
    value: dwelling,
    onChange: e => setDwelling(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[0-9]*$",
    type: "number",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), isUdFlow && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: cardLabelStyle
  }, `${t("BPA_CHECKLIST_OPTION_MUCK_TO_BE_DISPOSED")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "number",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "muckToBeDisposed",
    value: muckToBeDisposed,
    onChange: e => setMuckToBeDisposed(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[0-9]*$",
    type: "number",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    label: t("BPA_APPLICATION_WHEATHER_THE_PERMISSION_FROM_AIRPORT_AUTHORITY_OF_INDIA_IS_REQUIRED"),
    sx: {
      display: 'block'
    },
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        '& .MuiSvgIcon-root': {
          fontSize: 28
        }
      },
      checked: airport.code === 'YES',
      onChange: e => setAirport(value => ({
        ...value,
        code: e.target.checked ? "YES" : "NO"
      }))
    })
  }), airport.code === 'YES' && /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "airport.name",
    value: airport.name,
    onChange: e => setAirport(value => ({
      ...value,
      name: e.target.value
    }))
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext,
    style: {
      margin: '1rem'
    }
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const StyledTab = styled(Tab)(({
  theme
}) => ({
  textTransform: 'none',
  padding: '0 1rem',
  fontSize: '18px'
}));
const BasicDetails = ({
  formData,
  onSelect,
  config,
  currTabRoute
}) => {
  var _formData$data, _formData$data2, _mdmsData$BPA, _basicData$planDetail, _basicData$planDetail2, _basicData$planDetail3, _basicData$planDetail11, _basicData$planDetail12, _basicData$planDetail13, _basicData$planDetail14, _scrutinyNumber$edcrN;
  const [showToast, setShowToast] = useState(null);
  const [basicData, setBasicData] = useState((formData === null || formData === void 0 ? void 0 : (_formData$data = formData.data) === null || _formData$data === void 0 ? void 0 : _formData$data.edcrDetails) || null);
  const [scrutinyNumber, setScrutinyNumber] = useState(formData === null || formData === void 0 ? void 0 : (_formData$data2 = formData.data) === null || _formData$data2 === void 0 ? void 0 : _formData$data2.scrutinyNumber);
  const [currentTab, setCurrentTab] = useState(currTabRoute);
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    path,
    params
  } = useRouteMatch();
  const baseUrl = path.substring(0, path.lastIndexOf('/'));
  const getPath = (path, params) => {
    params && Object.keys(params).map(key => {
      path = path.replace(`:${key}`, params[key]);
    });
    return path;
  };
  const updateTabUrl = tab => history.push(`${getPath(baseUrl, params)}/${tab}`);
  const handleTabChange = (e, newValue) => {
    setCurrentTab(newValue);
    updateTabUrl(newValue);
  };
  const stateCode = Digit.ULBService.getStateId();
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["RiskTypeComputation"]);
  const riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail = basicData.planDetail) === null || _basicData$planDetail === void 0 ? void 0 : (_basicData$planDetail2 = _basicData$planDetail.plot) === null || _basicData$planDetail2 === void 0 ? void 0 : _basicData$planDetail2.area, basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail3 = basicData.planDetail) === null || _basicData$planDetail3 === void 0 ? void 0 : _basicData$planDetail3.blocks);
  const closeToast = () => {
    setShowToast(null);
  };
  const handleSubmit = async event => {
    var _basicData$planDetail4, _basicData$planDetail5, _basicData$planDetail6, _basicData$planDetail7, _mdmsData$BPA2, _basicData$planDetail8, _basicData$planDetail9, _basicData$planDetail10;
    await onSelect(config === null || config === void 0 ? void 0 : config.key, {
      scrutinyNumber,
      applicantName: basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail4 = basicData.planDetail) === null || _basicData$planDetail4 === void 0 ? void 0 : (_basicData$planDetail5 = _basicData$planDetail4.planInformation) === null || _basicData$planDetail5 === void 0 ? void 0 : _basicData$planDetail5.applicantName,
      occupancyType: basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail6 = basicData.planDetail) === null || _basicData$planDetail6 === void 0 ? void 0 : (_basicData$planDetail7 = _basicData$planDetail6.planInformation) === null || _basicData$planDetail7 === void 0 ? void 0 : _basicData$planDetail7.occupancy,
      applicationType: basicData === null || basicData === void 0 ? void 0 : basicData.appliactionType,
      serviceType: basicData === null || basicData === void 0 ? void 0 : basicData.applicationSubType,
      applicationDate: basicData === null || basicData === void 0 ? void 0 : basicData.applicationDate,
      riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail8 = basicData.planDetail) === null || _basicData$planDetail8 === void 0 ? void 0 : (_basicData$planDetail9 = _basicData$planDetail8.plot) === null || _basicData$planDetail9 === void 0 ? void 0 : _basicData$planDetail9.area, basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail10 = basicData.planDetail) === null || _basicData$planDetail10 === void 0 ? void 0 : _basicData$planDetail10.blocks),
      edcrDetails: basicData
    });
  };
  let disableVlaue = sessionStorage.getItem("isEDCRDisable");
  disableVlaue = JSON.parse(disableVlaue);
  const getDetails = async () => {
    const details = await scrutinyDetailsData(scrutinyNumber === null || scrutinyNumber === void 0 ? void 0 : scrutinyNumber.edcrNumber, stateCode);
    if ((details === null || details === void 0 ? void 0 : details.type) == "ERROR") {
      setShowToast({
        message: details === null || details === void 0 ? void 0 : details.message
      });
      setBasicData(null);
    }
    if (details !== null && details !== void 0 && details.edcrNumber) {
      setBasicData(details);
      setShowToast(null);
    }
  };
  if (disableVlaue) {
    let edcrApi = sessionStorage.getItem("isEDCRAPIType");
    edcrApi = edcrApi ? JSON.parse(edcrApi) : false;
    if (!edcrApi || !basicData) {
      sessionStorage.setItem("isEDCRAPIType", JSON.stringify(true));
      getDetails();
    }
  }
  if (isMdmsLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(`${showToast === null || showToast === void 0 ? void 0 : showToast.message}`),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Timeline, {
    flow: "BPA",
    currentStep: 1
  }), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "card",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
      margin: '1.25rem auto 2rem'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleTabChange,
    sx: {
      margin: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(StyledTab, {
    label: t("Basic Details"),
    value: "basic-details"
  }), /*#__PURE__*/React__default.createElement(StyledTab, {
    label: t("Location Details"),
    value: "location"
  }), /*#__PURE__*/React__default.createElement(StyledTab, {
    label: t("Plot Details"),
    value: "plot-details"
  }), /*#__PURE__*/React__default.createElement(StyledTab, {
    label: t("BPA_EDCR_DETAILS"),
    value: "scrutiny-details"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "basic-details",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: 'white',
      marginLeft: "13px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      marginBottom: '2rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: basicData !== null && basicData !== void 0 && basicData.applicationDate ? format(new Date(basicData === null || basicData === void 0 ? void 0 : basicData.applicationDate), 'dd/MM/yyyy') : basicData === null || basicData === void 0 ? void 0 : basicData.applicationDate
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: basicData ? t(`WF_BPA_${basicData === null || basicData === void 0 ? void 0 : basicData.appliactionType}`) : ''
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`),
    text: t(basicData === null || basicData === void 0 ? void 0 : basicData.applicationSubType)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`),
    text: basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail11 = basicData.planDetail) === null || _basicData$planDetail11 === void 0 ? void 0 : (_basicData$planDetail12 = _basicData$planDetail11.planInformation) === null || _basicData$planDetail12 === void 0 ? void 0 : _basicData$planDetail12.occupancy
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`),
    text: basicData ? t(`WF_BPA_${riskType}`) : ''
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: basicData === null || basicData === void 0 ? void 0 : (_basicData$planDetail13 = basicData.planDetail) === null || _basicData$planDetail13 === void 0 ? void 0 : (_basicData$planDetail14 = _basicData$planDetail13.planInformation) === null || _basicData$planDetail14 === void 0 ? void 0 : _basicData$planDetail14.applicantName
  })), riskType ? /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    disabled: !(scrutinyNumber !== null && scrutinyNumber !== void 0 && (_scrutinyNumber$edcrN = scrutinyNumber.edcrNumber) !== null && _scrutinyNumber$edcrN !== void 0 && _scrutinyNumber$edcrN.length)
  }) : /*#__PURE__*/React__default.createElement(Loader, null))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "location",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(LocationDetails, {
    formData,
    onSelect,
    config
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "plot-details",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(PlotDetails, {
    formData,
    onSelect,
    config
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "scrutiny-details",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(ScrutinyDetails, {
    formData,
    onSelect,
    config
  }))));
};

const Step1$5 = ({
  t,
  onSelect,
  formData,
  currStep,
  step1Tabs
}) => {
  const [showToast, setShowToast] = useState(null);
  const [currentTab, setCurrentTab] = useState(currStep.route);
  const history = useHistory();
  const {
    path,
    params
  } = useRouteMatch();
  const baseUrl = path.substring(0, path.lastIndexOf('/'));
  const getPath = (path, params) => {
    params && Object.keys(params).map(key => {
      path = path.replace(`:${key}`, params[key]);
    });
    return path;
  };
  const updateTabUrl = tab => history.push(`${getPath(baseUrl, params)}/${tab}`);
  const handleTabChange = (e, newValue) => {
    setCurrentTab(newValue);
    updateTabUrl(newValue);
  };
  const closeToast = () => {
    setShowToast(null);
  };
  return /*#__PURE__*/React__default.createElement("div", null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(`${showToast === null || showToast === void 0 ? void 0 : showToast.message}`),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Timeline, {
    flow: "Form11",
    currentStep: currStep.step
  }), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "card",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
      margin: '1.25rem auto 2rem',
      overflow: 'initial'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleTabChange
  }, step1Tabs === null || step1Tabs === void 0 ? void 0 : step1Tabs.map(({
    tabLabel,
    route
  }) => /*#__PURE__*/React__default.createElement(Tab, {
    key: route,
    label: t(tabLabel),
    value: route,
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  }))), step1Tabs === null || step1Tabs === void 0 ? void 0 : step1Tabs.map(({
    tabComponent,
    route
  }) => {
    let Component = tabComponent;
    if (typeof tabComponent === "string") {
      Component = Digit.ComponentRegistryService.getComponent(tabComponent);
    }
    return /*#__PURE__*/React__default.createElement(TabPanel, {
      value: currentTab,
      index: route,
      sx: {
        p: 0
      }
    }, /*#__PURE__*/React__default.createElement(Component, {
      t,
      formData,
      onSelect,
      currStep
    }));
  })));
};

const Step1$6 = ({
  t,
  onSelect,
  formData,
  currStep,
  step1Tabs
}) => {
  const [showToast, setShowToast] = useState(null);
  const [currentTab, setCurrentTab] = useState(currStep.route);
  const history = useHistory();
  const {
    path,
    params
  } = useRouteMatch();
  const baseUrl = path.substring(0, path.lastIndexOf('/'));
  const getPath = (path, params) => {
    params && Object.keys(params).map(key => {
      path = path.replace(`:${key}`, params[key]);
    });
    return path;
  };
  const updateTabUrl = tab => history.push(`${getPath(baseUrl, params)}/${tab}`);
  const handleTabChange = (e, newValue) => {
    setCurrentTab(newValue);
    updateTabUrl(newValue);
  };
  const closeToast = () => {
    setShowToast(null);
  };
  return /*#__PURE__*/React__default.createElement("div", null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(`${showToast === null || showToast === void 0 ? void 0 : showToast.message}`),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Timeline, {
    flow: "Form26",
    currentStep: currStep.step
  }), /*#__PURE__*/React__default.createElement(Card$1, {
    className: "card",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
      margin: '1.25rem auto 2rem',
      overflow: 'initial'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleTabChange
  }, step1Tabs === null || step1Tabs === void 0 ? void 0 : step1Tabs.map(({
    tabLabel,
    route
  }) => /*#__PURE__*/React__default.createElement(Tab, {
    key: route,
    label: t(tabLabel),
    value: route,
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  }))), step1Tabs === null || step1Tabs === void 0 ? void 0 : step1Tabs.map(({
    tabComponent,
    route
  }, i) => {
    let Component = tabComponent;
    if (typeof tabComponent === "string") {
      Component = Digit.ComponentRegistryService.getComponent(tabComponent);
    }
    return /*#__PURE__*/React__default.createElement(TabPanel, {
      key: `${currentTab}-${i}`,
      value: currentTab,
      index: route,
      sx: {
        p: 0
      }
    }, /*#__PURE__*/React__default.createElement(Component, {
      t,
      formData,
      onSelect,
      currStep
    }));
  })));
};

const LandAreaDetails = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _localities$selectedL, _formData$currStep$ke5, _Digit;
  const currentCity = JSON.parse(sessionStorage.getItem("currentCity") || null);
  const currLocality = JSON.parse(sessionStorage.getItem("currLocality") || null);
  const currVillage = JSON.parse(sessionStorage.getItem("currVillage") || null);
  const [selectedCity, setSelectedCity] = useState(currentCity || ((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.city) || '');
  const [localities, setLocalities] = useState((selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.boundary) || (currentCity === null || currentCity === void 0 ? void 0 : currentCity.boundary) || ((_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : (_formData$currStep$ke3 = _formData$currStep$ke2.city) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.boundary) || []);
  const [selectedLocality, setSelectedLocality] = useState(currLocality || ((_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.locality) || null);
  const selectedLocalityIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name));
  const [villages, setVillages] = useState((selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.children) || (localities === null || localities === void 0 ? void 0 : (_localities$selectedL = localities[selectedLocalityIndex]) === null || _localities$selectedL === void 0 ? void 0 : _localities$selectedL.children) || []);
  const [village, setVillage] = useState(currVillage || ((_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.village) || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [areaType, setAreaType] = useState(selectedLocality !== null && selectedLocality !== void 0 && selectedLocality.IsSpecialArea ? `Special Area` : `Planning Area`  );
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const code = 'hp';
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const citymoduleList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return (_city$code = city.code) === null || _city$code === void 0 ? void 0 : _city$code.includes(applicationFlow.toLowerCase());
  }) : [];
  const handleSubmit = () => {
    const landAreaDetails = {};
    landAreaDetails.city = (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.name) || "";
    landAreaDetails.tenantId = code;
    landAreaDetails.locality = selectedLocality || "";
    landAreaDetails.areaType = areaType || "";
    landAreaDetails.village = village || "";
    onSelect(currStep.key, landAreaDetails);
  };
  function selectCity(city) {
    var _Digit2;
    setSelectedCity(city);
    setLocalities(city.boundary);
    setOpenVillage(false);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType('');
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails["city"] = city;
  }
  function selectLocality(locality) {
    var _formData$landAreaDet, _localities$boundaryI, _localities$boundaryI2;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet = formData.landAreaDetails) !== null && _formData$landAreaDet !== void 0 && _formData$landAreaDet.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    const boundaryIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === locality.name);
    setSelectedLocality(locality);
    setVillages(localities === null || localities === void 0 ? void 0 : (_localities$boundaryI = localities[boundaryIndex]) === null || _localities$boundaryI === void 0 ? void 0 : _localities$boundaryI.children);
    setOpenVillage(true);
    setAreaType(localities !== null && localities !== void 0 && (_localities$boundaryI2 = localities[boundaryIndex]) !== null && _localities$boundaryI2 !== void 0 && _localities$boundaryI2.IsSpecialArea ? `Special Area` : `Planning Area`);
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }
  function selectVillage(village) {
    var _formData$landAreaDet2;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet2 = formData.landAreaDetails) !== null && _formData$landAreaDet2 !== void 0 && _formData$landAreaDet2.village) {
      formData.landAreaDetails["village"] = village;
    }
    setVillage(village);
    sessionStorage.setItem("currVillage", JSON.stringify(village));
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    },
    isDisabled: !selectedCity || !selectedLocality,
    onSelect: handleSubmit,
    isMultipleAllow: true,
    t: t
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DISTRICT_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: citymoduleList,
    selectedOption: selectedCity,
    onSelect: selectCity,
    optionKey: "name",
    placeholder: `Select ${t("BPA_DISTRICT_LABEL")}`
  }), selectedCity && tcpCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && udCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_ULB-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && villageOpen && tcpCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_AREA_TYPE_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    optionKey: "i18nKey",
    name: "areaType",
    value: areaType,
    disabled: true
  })), selectedCity && villageOpen && tcpCode && (villages === null || villages === void 0 ? void 0 : villages.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_VILLAGE-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: villages === null || villages === void 0 ? void 0 : villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: village,
    onSelect: selectVillage,
    t: t,
    isDependent: true
  })), selectedCity && villageOpen && udCode && (villages === null || villages === void 0 ? void 0 : villages.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_WARD-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: villages === null || villages === void 0 ? void 0 : villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: village,
    onSelect: selectVillage,
    t: t,
    isDependent: true
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      marginTop: '1rem'
    }
  }));
};

const LandAreaDetails$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _localities$selectedL, _formData$currStep$ke5, _Digit;
  const currentCity = JSON.parse(sessionStorage.getItem("currentCity") || null);
  const currLocality = JSON.parse(sessionStorage.getItem("currLocality") || null);
  const currVillage = JSON.parse(sessionStorage.getItem("currVillage") || null);
  const [selectedCity, setSelectedCity] = useState(currentCity || ((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.city) || '');
  const [localities, setLocalities] = useState((selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.boundary) || (currentCity === null || currentCity === void 0 ? void 0 : currentCity.boundary) || ((_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : (_formData$currStep$ke3 = _formData$currStep$ke2.city) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.boundary) || []);
  const [selectedLocality, setSelectedLocality] = useState(currLocality || ((_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.locality) || null);
  const selectedLocalityIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name));
  const [villages, setVillages] = useState((selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.children) || (localities === null || localities === void 0 ? void 0 : (_localities$selectedL = localities[selectedLocalityIndex]) === null || _localities$selectedL === void 0 ? void 0 : _localities$selectedL.children) || []);
  const [village, setVillage] = useState(currVillage || ((_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.village) || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [areaType, setAreaType] = useState(selectedLocality !== null && selectedLocality !== void 0 && selectedLocality.IsSpecialArea ? `Special Area` : `Planning Area`  );
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const code = 'hp';
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const citymoduleList = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return (_city$code = city.code) === null || _city$code === void 0 ? void 0 : _city$code.includes(applicationFlow.toLowerCase());
  }) : [];
  const handleSubmit = () => {
    const landAreaDetails = {};
    landAreaDetails.city = (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.name) || "";
    landAreaDetails.tenantId = code;
    landAreaDetails.locality = selectedLocality || "";
    landAreaDetails.areaType = areaType || "";
    landAreaDetails.village = village || "";
    onSelect(currStep.key, landAreaDetails);
  };
  function selectCity(city) {
    var _Digit2;
    setSelectedCity(city);
    setLocalities(city.boundary);
    setOpenVillage(false);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType('');
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails["city"] = city;
  }
  function selectLocality(locality) {
    var _formData$landAreaDet, _localities$boundaryI, _localities$boundaryI2;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet = formData.landAreaDetails) !== null && _formData$landAreaDet !== void 0 && _formData$landAreaDet.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    const boundaryIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === locality.name);
    setSelectedLocality(locality);
    setVillages(localities === null || localities === void 0 ? void 0 : (_localities$boundaryI = localities[boundaryIndex]) === null || _localities$boundaryI === void 0 ? void 0 : _localities$boundaryI.children);
    setOpenVillage(true);
    setAreaType(localities !== null && localities !== void 0 && (_localities$boundaryI2 = localities[boundaryIndex]) !== null && _localities$boundaryI2 !== void 0 && _localities$boundaryI2.IsSpecialArea ? `Special Area` : `Planning Area`);
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }
  function selectVillage(village) {
    var _formData$landAreaDet2;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet2 = formData.landAreaDetails) !== null && _formData$landAreaDet2 !== void 0 && _formData$landAreaDet2.village) {
      formData.landAreaDetails["village"] = village;
    }
    setVillage(village);
    sessionStorage.setItem("currVillage", JSON.stringify(village));
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    },
    isDisabled: !selectedCity || !selectedLocality,
    onSelect: handleSubmit,
    isMultipleAllow: true,
    t: t
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DISTRICT_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: citymoduleList,
    selectedOption: selectedCity,
    onSelect: selectCity,
    optionKey: "name",
    placeholder: `Select ${t("BPA_DISTRICT_LABEL")}`
  }), selectedCity && tcpCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && udCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_ULB-AREA_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && villageOpen && tcpCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_AREA_TYPE_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    optionKey: "i18nKey",
    name: "areaType",
    value: areaType,
    disabled: true
  })), selectedCity && villageOpen && tcpCode && (villages === null || villages === void 0 ? void 0 : villages.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_VILLAGE-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: villages === null || villages === void 0 ? void 0 : villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: village,
    onSelect: selectVillage,
    t: t,
    isDependent: true
  })), selectedCity && villageOpen && udCode && (villages === null || villages === void 0 ? void 0 : villages.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_LOC_WARD-AREA_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: villages === null || villages === void 0 ? void 0 : villages.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: village,
    onSelect: selectVillage,
    t: t,
    isDependent: true
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      marginTop: '1rem'
    }
  }));
};

const InputText = React__default.forwardRef(({
  label,
  register,
  required,
  name,
  t,
  placeholder,
  grid: _grid = 6,
  disabled: _disabled = false
}, ref) => /*#__PURE__*/React__default.createElement(Grid$1, {
  item: true,
  xs: _grid
}, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t(label)}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
  t: t,
  type: "text",
  optionKey: "i18nKey",
  name: name,
  placeholder: placeholder
}, register(name), {
  disabled: _disabled,
  required: required,
  inputRef: ref
}))));
const Select = React__default.forwardRef(({
  onChange,
  name,
  label,
  t,
  options,
  selectedOption,
  isDropDown: _isDropDown = false,
  sortOptions: _sortOptions = true
}, ref) => /*#__PURE__*/React__default.createElement(Grid$1, {
  item: true,
  xs: 6
}, /*#__PURE__*/React__default.createElement("span", {
  className: "form-pt-dropdown-only"
}, /*#__PURE__*/React__default.createElement(CardLabel, null, t(label)), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
  optionCardStyles: {
    maxHeight: "20vmax",
    overflow: "scroll"
  },
  options: _sortOptions ? options.sort((a, b) => a.name.localeCompare(b.name)) : options,
  optionKey: "name",
  selected: selectedOption,
  _ref: ref,
  name: name,
  onSelect: onChange,
  t: t,
  isDropDown: _isDropDown,
  isDependent: true
}))));
const useTypeList$1 = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "Residential"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "Commercial"
}, {
  code: "hp.tcpsolan",
  id: 3,
  name: "Industrial"
}];
const typeOfLandVolvedYesList = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "For change of Land use from the original Use"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "IDP/Development Plan to Other Land Use"
}];
const propertyTypeList$1 = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "Govt"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "Private"
}, {
  code: "hp.tcpsolan",
  id: 3,
  name: "Public & Semi Public"
}];
const typeOfLandVolvedList = [{
  active: true,
  code: "YES",
  name: "Yes",
  i18nKey: "COMMON_MASTERS_YES"
}, {
  active: true,
  code: "NO",
  name: "No",
  i18nKey: "COMMON_MASTERS_NO"
}];
const DescriptionOfLand = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _formData$currStep$ke5, _formData$currStep$ke6, _formData$currStep$ke7, _formData$currStep$ke8, _formData$currStep$ke9, _formData$currStep$ke10, _formData$currStep$ke11, _formData$currStep$ke12, _formData$currStep$ke13, _formData$currStep$ke14, _formData$currStep$ke15, _formData$currStep$ke16, _formData$currStep$ke17, _formData$currStep$ke18;
  const khasraTableEntry = {
    plotNo: 0,
    plotArea: 0,
    typeOfLand: null
  };
  const khasraWithAreaEntry = {
    khasraNo: 0,
    area: 0
  };
  const defaultValues = {
    revenueVillageMohal: ((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.revenueVillageMohal) || null,
    khataNo: (_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : _formData$currStep$ke2.khataNo,
    khatauniNo: (_formData$currStep$ke3 = formData[currStep.key]) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.khatauniNo,
    latitude: (_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.latitude,
    longitude: (_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.longitude,
    khasraWithArea: ((_formData$currStep$ke6 = formData[currStep.key]) === null || _formData$currStep$ke6 === void 0 ? void 0 : _formData$currStep$ke6.khasraWithArea) || [khasraWithAreaEntry],
    totalPlotArea: ((_formData$currStep$ke7 = formData[currStep.key]) === null || _formData$currStep$ke7 === void 0 ? void 0 : _formData$currStep$ke7.totalPlotArea) || '',
    noOfPlot: (_formData$currStep$ke8 = formData[currStep.key]) === null || _formData$currStep$ke8 === void 0 ? void 0 : _formData$currStep$ke8.noOfPlot,
    propertyType: ((_formData$currStep$ke9 = formData[currStep.key]) === null || _formData$currStep$ke9 === void 0 ? void 0 : _formData$currStep$ke9.propertyType) || null,
    useType: ((_formData$currStep$ke10 = formData[currStep.key]) === null || _formData$currStep$ke10 === void 0 ? void 0 : _formData$currStep$ke10.useType) || null,
    plotArea: (_formData$currStep$ke11 = formData[currStep.key]) === null || _formData$currStep$ke11 === void 0 ? void 0 : _formData$currStep$ke11.plotArea,
    typeOfLandVolved: ((_formData$currStep$ke12 = formData[currStep.key]) === null || _formData$currStep$ke12 === void 0 ? void 0 : _formData$currStep$ke12.typeOfLandVolved) || null,
    typeOfCLUInvolved: ((_formData$currStep$ke13 = formData[currStep.key]) === null || _formData$currStep$ke13 === void 0 ? void 0 : _formData$currStep$ke13.typeOfCLUInvolved) || null,
    khasraTable: ((_formData$currStep$ke14 = formData[currStep.key]) === null || _formData$currStep$ke14 === void 0 ? void 0 : _formData$currStep$ke14.khasraTable) || [khasraTableEntry]
  };
  const {
    watch,
    control,
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    defaultValues
  });
  const {
    fields: khasraWithArea,
    append,
    remove
  } = useFieldArray({
    control,
    name: "khasraWithArea"
  });
  const {
    fields: khasraTable,
    append: appendTable,
    remove: removeTable
  } = useFieldArray({
    control,
    name: "khasraTable"
  });
  const watchPlotArea = watch("khasraWithArea");
  const watchKhasraTable = watch("khasraTable");
  const khasraWithAreaFields = khasraWithArea.map((field, index) => {
    return {
      ...field,
      ...watchPlotArea[index]
    };
  });
  const khasraTableFields = khasraTable.map((field, index) => {
    return {
      ...field,
      ...watchKhasraTable[index]
    };
  });
  useEffect(() => {
    const total = khasraWithAreaFields.reduce((total, field) => {
      return total + Number(field.area);
    }, 0);
    setValue('totalPlotArea', Number(total));
  }, [khasraWithAreaFields]);
  const [useType, setUseType] = useState(((_formData$currStep$ke15 = formData[currStep.key]) === null || _formData$currStep$ke15 === void 0 ? void 0 : _formData$currStep$ke15.useType) || null);
  const [propertyType, setPropertyType] = useState(((_formData$currStep$ke16 = formData[currStep.key]) === null || _formData$currStep$ke16 === void 0 ? void 0 : _formData$currStep$ke16.propertyType) || null);
  const [typeOfLandVolved, setTypeOfLandVolved] = useState(((_formData$currStep$ke17 = formData[currStep.key]) === null || _formData$currStep$ke17 === void 0 ? void 0 : _formData$currStep$ke17.typeOfLandVolved) || null);
  const [typeOfCLUInvolved, setTypeOfCLUInvolved] = useState(((_formData$currStep$ke18 = formData[currStep.key]) === null || _formData$currStep$ke18 === void 0 ? void 0 : _formData$currStep$ke18.typeOfCLUInvolved) || null);
  function selectedValue(value) {
    setTypeOfLandVolved(value);
    setValue('typeOfLandVolved', value);
  }
  function selectedValueUseType(value) {
    setUseType(value);
    setValue('useType', value);
  }
  function selectedValuePropertyType(value) {
    setPropertyType(value);
    setValue('propertyType', value);
  }
  function selectTypeOfCLUInvolved(value) {
    setTypeOfCLUInvolved(value);
    setValue('typeOfCLUInvolved', value);
  }
  const onSkip = () => onSelect();
  const handleOnSubmit = descriptionOfLand => {
    onSelect(currStep.key, descriptionOfLand);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0,
      overflowY: 'auto'
    },
    _defaultValues: formData === null || formData === void 0 ? void 0 : formData.data,
    childrenAtTheBottom: false,
    onSelect: handleSubmit(handleOnSubmit),
    onSkip: onSkip,
    t: t
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_REVENUE_VILLAGE_MOHALLA_LABEL",
    register,
    required: false,
    name: "revenueVillageMohal",
    t,
    placeholder: "Enter Revenue Village Mohalla"
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_KHATA_NO_LABEL",
    register,
    required: false,
    name: "khataNo",
    t,
    placeholder: "Enter khata No"
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_KHATAUNI_NO_LABEL",
    register,
    required: false,
    name: "khatauniNo",
    t,
    placeholder: "Enter khatauni No"
  }), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6,
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_LATITUDE_LABEL",
    register,
    required: false,
    name: "latitude",
    t,
    placeholder: "Enter latitude"
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_LONGITUDE_LABEL",
    register,
    required: false,
    name: "longitude",
    t,
    placeholder: "Enter longitude"
  })), khasraWithAreaFields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      container: true,
      key: field.id,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DOL_KHASARA_NO_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraWithArea.${index}.khasraNo`), {
      name: `khasraWithArea.${index}.khasraNo`,
      t: t,
      type: "text",
      optionKey: "i18nKey"
    }))), /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6,
      container: true,
      sx: {
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        flex: 1
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DOL_AREA_SQM_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraWithArea.${index}.area`), {
      name: `khasraWithArea.${index}.area`,
      t: t,
      type: "text",
      optionKey: "i18nKey"
    }))), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        gap: '.5rem',
        mt: ".9rem",
        ml: '.5rem'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      "aria-label": "add",
      onClick: () => append(khasraWithAreaEntry)
    }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), khasraWithArea.length > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "delete",
      onClick: () => remove(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
  }), /*#__PURE__*/React__default.createElement(InputText, Object.assign({}, {
    label: "BPA_DOL_TOTAL_PLOT_AREA_LABEL",
    register,
    required: false,
    name: "totalPlotArea",
    t,
    placeholder: "Enter Total Plot Area"
  }, {
    disabled: true
  })), /*#__PURE__*/React__default.createElement(InputText, {
    label: "BPA_DOL_NO_OF_PLOT_LABEL",
    register,
    required: false,
    name: "noOfPlot",
    t,
    placeholder: "Enter Number of Plot"
  }), /*#__PURE__*/React__default.createElement(Select, {
    label: "CORE_COMMON_PROPERTY_TYPE",
    register,
    required: false,
    name: "propertyType",
    t,
    selectedOption: propertyType,
    options: propertyTypeList$1,
    onChange: selectedValuePropertyType
  }), /*#__PURE__*/React__default.createElement(Select, {
    label: "CORE_COMMON_USE_TYPE",
    register,
    required: false,
    name: "useType",
    t,
    selectedOption: useType,
    options: useTypeList$1,
    onChange: selectedValueUseType
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "CORE_COMMON_PLOT_AREA",
    register,
    required: false,
    name: "plotArea",
    t,
    placeholder: "Enter plot Area"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("h2", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DETAILS_OF_PLOT_AFTER_SUBDIVISION")} *`))), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_TYPE_OF_LAND_VOLVED")} *`), /*#__PURE__*/React__default.createElement(RadioButtons, Object.assign({
    style: {
      display: 'flex',
      gap: '3rem',
      margin: 0
    },
    options: typeOfLandVolvedList,
    selectedOption: typeOfLandVolved,
    optionsKey: "i18nKey"
  }, register(`typeOfLandVolved`), {
    name: 'typeOfLandVolved',
    onSelect: selectedValue,
    labelKey: "PT_OWNERSHIP",
    isDependent: true
  })), (typeOfLandVolved === null || typeOfLandVolved === void 0 ? void 0 : typeOfLandVolved.code) == "YES" && /*#__PURE__*/React__default.createElement(Select, Object.assign({}, {
    label: "BPA_TYPE_OF_CLU_INVOLVED",
    register,
    required: false,
    name: "typeOfCLUInvolved",
    t,
    options: typeOfLandVolvedYesList,
    onChange: selectTypeOfCLUInvolved
  }, {
    isDropDown: true
  })), (typeOfLandVolved === null || typeOfLandVolved === void 0 ? void 0 : typeOfLandVolved.code) == "YES" && typeOfCLUInvolved && /*#__PURE__*/React__default.createElement("div", {
    className: "table table-bordered table-responsive",
    style: {
      display: "block",
      overflowX: 'visible'
    }
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 50
    }
  }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_NO")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_TYPE_OF_LAND_DEVELOPMENT")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_ADD_MORE")}`))), /*#__PURE__*/React__default.createElement("tbody", null, khasraTableFields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraTable.${index}.plotNo`), {
      name: `khasraTable.${index}.plotNo`,
      t: t,
      style: {
        margin: 0
      },
      type: "text",
      optionKey: "i18nKey",
      placeholder: "Enter Khasra No.",
      disabled: false,
      required: false
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraTable.${index}.plotArea`), {
      name: `khasraTable.${index}.plotArea`,
      t: t,
      style: {
        margin: 0
      },
      type: "text",
      optionKey: "i18nKey",
      placeholder: "Enter Area (sq.m)",
      disabled: false,
      required: false
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioOrSelect, Object.assign({}, register(`khasraTable.${index}.typeOfLand`), {
      name: `khasraTable.${index}.typeOfLand`,
      dropdownStyle: {
        margin: 0
      },
      optionCardStyles: {
        maxHeight: "20vmax",
        overflow: "scroll"
      },
      options: useTypeList$1.sort((a, b) => a.name.localeCompare(b.name)),
      optionKey: "name",
      onSelect: val => setValue(`khasraTable.${index}.typeOfLand`, val),
      t: t,
      isDependent: true,
      isDropDown: true
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        gap: '.5rem'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      "aria-label": "Add more",
      onClick: () => appendTable(khasraTableEntry)
    }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), khasraTableFields.length > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "Delete",
      onClick: () => removeTable(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
  }))))))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit(handleOnSubmit),
    style: {
      marginTop: '1rem'
    }
  })));
};

const InputText$1 = React__default.forwardRef(({
  label,
  register,
  required,
  name,
  t,
  placeholder,
  grid: _grid = 6,
  disabled: _disabled = false
}, ref) => /*#__PURE__*/React__default.createElement(Grid$1, {
  item: true,
  xs: _grid
}, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t(label)}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
  t: t,
  type: "text",
  optionKey: "i18nKey",
  name: name,
  placeholder: placeholder
}, register(name), {
  disabled: _disabled,
  readOnly: _disabled,
  required: required,
  inputRef: ref
}))));
const Select$1 = React__default.forwardRef(({
  onChange,
  name,
  label,
  t,
  options,
  selectedOption,
  isDropDown: _isDropDown = false,
  sortOptions: _sortOptions = true,
  grid: _grid2 = 6
}, ref) => /*#__PURE__*/React__default.createElement(Grid$1, {
  item: true,
  xs: _grid2
}, /*#__PURE__*/React__default.createElement("span", {
  className: "form-pt-dropdown-only"
}, /*#__PURE__*/React__default.createElement(CardLabel, null, t(label)), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
  optionCardStyles: {
    maxHeight: "20vmax",
    overflow: "scroll"
  },
  options: _sortOptions ? options.sort((a, b) => a.name.localeCompare(b.name)) : options,
  optionKey: "name",
  selectedOption: selectedOption,
  _ref: ref,
  name: name,
  onSelect: onChange,
  t: t,
  isDropDown: _isDropDown,
  isDependent: true
}))));
const useTypeList$2 = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "Residential"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "Commercial"
}, {
  code: "hp.tcpsolan",
  id: 3,
  name: "Industrial"
}, {
  code: "hp.tcpsolan",
  id: 4,
  name: "Public"
}];
const floorTypeList = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "Basement"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "Ground Floor"
}, {
  code: "hp.tcpsolan",
  id: 3,
  name: "1st Floor"
}, {
  code: "hp.tcpsolan",
  id: 4,
  name: "2nd Floor"
}, {
  code: "hp.tcpsolan",
  id: 5,
  name: "3rd Floor"
}, {
  code: "hp.tcpsolan",
  id: 6,
  name: "4th Floor"
}, {
  code: "hp.tcpsolan",
  id: 7,
  name: "5th Floor"
}, {
  code: "hp.tcpsolan",
  id: 8,
  name: "6th Floor"
}];
const typeOfLandVolvedYesList$1 = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "For change of Land use from the original Use"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "IDP/Development Plan to Other Land Use"
}];
const devialtionTypeOptions = [{
  code: "approvedpermissibleupto10percent",
  i18nKey: "APPROVED_AND_PERMISSIBLE_UPTO_10",
  name: 'Plan was approved and deviations beyond Permissible limits upto the extent of 10%'
}, {
  code: "notapprovedpermissibleupto10percent",
  i18nKey: "NOT_APPROVED_AND_PERMISSIBLE_UPTO_10",
  name: ' Plan was not approved and deviations beyond permissible limits upto the extent of 10%'
}, {
  code: "notapprovedpermissiblewithoutdeviation",
  i18nKey: "NOT_APPROVED_AND_PERMISSIBLE_WT_DEVIATION",
  name: 'Plan was not approved and construction carried out without deviations'
}, {
  code: "underSizeConstruction",
  i18nKey: "UNDERSIZE_CONSTRUCTION_LESSTHAN_10",
  name: 'Building constructed on under size plot to the extent of 10 % less than the permissible plot size'
}];
const propertyTypeList$2 = [{
  code: "hp.tcpsolan",
  id: 1,
  name: "Govt"
}, {
  code: "hp.tcpsolan",
  id: 2,
  name: "Private"
}, {
  code: "hp.tcpsolan",
  id: 3,
  name: "Public & Semi Public"
}];
const typeOfLandVolvedList$1 = [{
  active: true,
  code: "YES",
  name: "Yes",
  i18nKey: "COMMON_MASTERS_YES"
}, {
  active: true,
  code: "NO",
  name: "No",
  i18nKey: "COMMON_MASTERS_NO"
}];
const DescriptionOfLand$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _formData$currStep$ke5, _formData$currStep$ke6, _formData$currStep$ke7, _formData$currStep$ke8, _formData$currStep$ke9, _formData$currStep$ke10, _formData$currStep$ke11, _formData$currStep$ke12, _formData$currStep$ke13, _formData$currStep$ke14, _formData$currStep$ke15, _formData$currStep$ke16, _formData$currStep$ke17, _formData$currStep$ke18, _formData$currStep$ke19, _formData$currStep$ke20, _formData$currStep$ke21, _formData$currStep$ke22, _formData$currStep$ke23, _formData$currStep$ke24, _formData$currStep$ke25;
  const khasraTableEntry = {
    plotNo: 0,
    plotArea: 0,
    typeOfLand: null
  };
  const khasraWithAreaEntry = {
    khasraNo: 0,
    area: 0
  };
  const buildUpAreaEntry = {
    id: 0,
    floorType: null,
    floorArea: 0,
    landUseType: null,
    parkingArea: 0,
    actualConstruction: 0,
    permissibleDeviation: 0,
    setbackDeviation: 0,
    deviation: 0
  };
  const defaultValues = {
    revenueVillageMohal: ((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.revenueVillageMohal) || null,
    khataNo: (_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : _formData$currStep$ke2.khataNo,
    khatauniNo: (_formData$currStep$ke3 = formData[currStep.key]) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.khatauniNo,
    latitude: (_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.latitude,
    longitude: (_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.longitude,
    khasraWithArea: ((_formData$currStep$ke6 = formData[currStep.key]) === null || _formData$currStep$ke6 === void 0 ? void 0 : _formData$currStep$ke6.khasraWithArea) || [khasraWithAreaEntry],
    totalPlotArea: ((_formData$currStep$ke7 = formData[currStep.key]) === null || _formData$currStep$ke7 === void 0 ? void 0 : _formData$currStep$ke7.totalPlotArea) || '',
    noOfPlot: (_formData$currStep$ke8 = formData[currStep.key]) === null || _formData$currStep$ke8 === void 0 ? void 0 : _formData$currStep$ke8.noOfPlot,
    propertyType: ((_formData$currStep$ke9 = formData[currStep.key]) === null || _formData$currStep$ke9 === void 0 ? void 0 : _formData$currStep$ke9.propertyType) || null,
    useType: ((_formData$currStep$ke10 = formData[currStep.key]) === null || _formData$currStep$ke10 === void 0 ? void 0 : _formData$currStep$ke10.useType) || null,
    plotArea: (_formData$currStep$ke11 = formData[currStep.key]) === null || _formData$currStep$ke11 === void 0 ? void 0 : _formData$currStep$ke11.plotArea,
    maximumCoverage: (_formData$currStep$ke12 = formData[currStep.key]) === null || _formData$currStep$ke12 === void 0 ? void 0 : _formData$currStep$ke12.maximumCoverage,
    typeOfLandVolved: ((_formData$currStep$ke13 = formData[currStep.key]) === null || _formData$currStep$ke13 === void 0 ? void 0 : _formData$currStep$ke13.typeOfLandVolved) || null,
    typeOfCLUInvolved: ((_formData$currStep$ke14 = formData[currStep.key]) === null || _formData$currStep$ke14 === void 0 ? void 0 : _formData$currStep$ke14.typeOfCLUInvolved) || null,
    khasraTable: ((_formData$currStep$ke15 = formData[currStep.key]) === null || _formData$currStep$ke15 === void 0 ? void 0 : _formData$currStep$ke15.khasraTable) || [khasraTableEntry],
    typeOfDeviation: ((_formData$currStep$ke16 = formData[currStep.key]) === null || _formData$currStep$ke16 === void 0 ? void 0 : _formData$currStep$ke16.typeOfDeviation) || null,
    offenceRegistrationNumber: (_formData$currStep$ke17 = formData[currStep.key]) === null || _formData$currStep$ke17 === void 0 ? void 0 : _formData$currStep$ke17.offenceRegistrationNumber,
    offenceSubject: (_formData$currStep$ke18 = formData[currStep.key]) === null || _formData$currStep$ke18 === void 0 ? void 0 : _formData$currStep$ke18.offenceSubject,
    noOfBlocks: ((_formData$currStep$ke19 = formData[currStep.key]) === null || _formData$currStep$ke19 === void 0 ? void 0 : _formData$currStep$ke19.noOfBlocks) || 0,
    buildUpAreaTable: ((_formData$currStep$ke20 = formData[currStep.key]) === null || _formData$currStep$ke20 === void 0 ? void 0 : _formData$currStep$ke20.buildUpAreaTable) || []
  };
  const {
    watch,
    control,
    register,
    setValue,
    getValues,
    handleSubmit,
    setFocus,
    formState: {
      errors
    }
  } = useForm({
    defaultValues
  });
  const {
    fields: khasraWithArea,
    append,
    remove
  } = useFieldArray({
    control,
    name: "khasraWithArea"
  });
  const {
    fields: khasraTable,
    append: appendTable,
    remove: removeTable
  } = useFieldArray({
    control,
    name: "khasraTable"
  });
  const watchPlotArea = watch("khasraWithArea");
  const watchKhasraTable = watch("khasraTable");
  const watchNoOfBlocks = watch("noOfBlocks");
  const watchBuildUpAreaTable = watch("buildUpAreaTable");
  const watchMaximumCoverage = watch("maximumCoverage");
  const [useType, setUseType] = useState(((_formData$currStep$ke21 = formData[currStep.key]) === null || _formData$currStep$ke21 === void 0 ? void 0 : _formData$currStep$ke21.useType) || null);
  const [propertyType, setPropertyType] = useState(((_formData$currStep$ke22 = formData[currStep.key]) === null || _formData$currStep$ke22 === void 0 ? void 0 : _formData$currStep$ke22.propertyType) || null);
  const [typeOfLandVolved, setTypeOfLandVolved] = useState(((_formData$currStep$ke23 = formData[currStep.key]) === null || _formData$currStep$ke23 === void 0 ? void 0 : _formData$currStep$ke23.typeOfLandVolved) || null);
  const [typeOfCLUInvolved, setTypeOfCLUInvolved] = useState(((_formData$currStep$ke24 = formData[currStep.key]) === null || _formData$currStep$ke24 === void 0 ? void 0 : _formData$currStep$ke24.typeOfCLUInvolved) || null);
  const [typeOfDeviation, setTypeOfDeviation] = useState(((_formData$currStep$ke25 = formData[currStep.key]) === null || _formData$currStep$ke25 === void 0 ? void 0 : _formData$currStep$ke25.typeOfDeviation) || null);
  const [showToast, setShowToast] = useState(null);
  const khasraWithAreaFields = khasraWithArea.map((field, index) => {
    return {
      ...field,
      ...watchPlotArea[index]
    };
  });
  const khasraTableFields = khasraTable.map((field, index) => {
    return {
      ...field,
      ...watchKhasraTable[index]
    };
  });
  useEffect(debounce(() => {
    if (Number(watchNoOfBlocks) > 0) {
      var _tableData;
      const mappedData = count => Array.from(Array(Number(count)).keys()).map(i => ({
        table: [buildUpAreaEntry]
      }));
      const noOfBlocks = Number(watchNoOfBlocks);
      let tableData = watchBuildUpAreaTable;
      if (((_tableData = tableData) === null || _tableData === void 0 ? void 0 : _tableData.length) > 0) {
        if (tableData.length < noOfBlocks) {
          var _tableData2;
          const diffrence = noOfBlocks - ((_tableData2 = tableData) === null || _tableData2 === void 0 ? void 0 : _tableData2.length);
          const diffrenceData = mappedData(diffrence);
          tableData = [...tableData, ...diffrenceData];
        } else if (tableData.length > noOfBlocks) {
          tableData = tableData.filter((_, i) => noOfBlocks > i);
        }
      } else {
        tableData = mappedData(noOfBlocks);
      }
      setValue('buildUpAreaTable', tableData);
    }
  }, 50), [watchNoOfBlocks]);
  useEffect(() => {
    const total = khasraWithAreaFields.reduce((total, field) => {
      return total + Number(field.area);
    }, 0);
    setValue('totalPlotArea', Number(total));
  }, [khasraWithAreaFields]);
  useEffect(() => {
    if (Number(watchMaximumCoverage) > 0) {
      setShowToast(null);
    }
  }, [watchMaximumCoverage]);
  function selectedValue(value) {
    setTypeOfLandVolved(value);
    setValue('typeOfLandVolved', value);
  }
  function selectedValueUseType(value) {
    setUseType(value);
    setValue('useType', value);
  }
  function selectedValuePropertyType(value) {
    setPropertyType(value);
    setValue('propertyType', value);
  }
  function selectTypeOfCLUInvolved(value) {
    setTypeOfCLUInvolved(value);
    setValue('typeOfCLUInvolved', value);
  }
  function selectDeviationType(value) {
    setTypeOfDeviation(value);
    setValue('typeOfDeviation', value);
  }
  const addTableRow = debounce(tableIndex => {
    const buildUpAreaData = [...watchBuildUpAreaTable];
    const nextIndex = buildUpAreaData[tableIndex].table.length;
    buildUpAreaData[tableIndex].table.splice(nextIndex, 0, {
      ...buildUpAreaEntry,
      ...{
        id: nextIndex
      }
    });
    setValue('buildUpAreaTable', buildUpAreaData);
  }, 300);
  const removeTableRow = debounce((tableIndex, rowIndex) => {
    if (watchBuildUpAreaTable[tableIndex].table.length > 1) {
      const buildUpAreaData = [...watchBuildUpAreaTable];
      const filteredTable = buildUpAreaData[tableIndex].table;
      buildUpAreaData[tableIndex].table = filteredTable.filter(row => row.id !== rowIndex);
      setValue('buildUpAreaTable', buildUpAreaData);
    }
  }, 300);
  const updateBuildUpAreaData = debounce((tableIndex, rowIndex, key, value) => {
    const maximumCoverage = getValues('maximumCoverage');
    const calcPermissibleDeviation = (actualConstruction, floorArea) => {
      const calc = Number(actualConstruction) - Number(floorArea);
      if (isNaN(calc) || calc <= 0) {
        return 0;
      }
      return calc;
    };
    if (key === 'floorArea') {
      const actualConstruction = getValues(`buildUpAreaTable[${tableIndex}].table[${rowIndex}].actualConstruction`);
      if (maximumCoverage.length > 0) {
        setShowToast(null);
        if (Number(value) > Number(maximumCoverage)) {
          const errorMessage = 'Approved Floor Area Should be less than or equal to Maximum Permissible Ground Coverage(Sq.m)';
          setShowToast({
            error: true,
            key: `${key}_${tableIndex}_${rowIndex}`,
            label: errorMessage
          });
        } else {
          setShowToast(null);
        }
      } else {
        setShowToast({
          error: true,
          key: `${key}_${tableIndex}_${rowIndex}`,
          label: 'Maximum Permissible Ground Coverage(Sq.m) can not be left blank'
        });
        setFocus('maximumCoverage');
      }
      if (actualConstruction.length > 0) {
        const calcPermDev = calcPermissibleDeviation(actualConstruction, value);
        updateBuildUpAreaData(tableIndex, rowIndex, 'permissibleDeviation', calcPermDev);
      }
    }
    if (key === 'actualConstruction') {
      const floorArea = getValues(`buildUpAreaTable[${tableIndex}].table[${rowIndex}].floorArea`);
      const calcPermDev = calcPermissibleDeviation(value, floorArea);
      updateBuildUpAreaData(tableIndex, rowIndex, 'permissibleDeviation', calcPermDev);
    }
    const buildUpAreaData = [...watchBuildUpAreaTable];
    buildUpAreaData[tableIndex].table[rowIndex][key] = value;
    setValue('buildUpAreaTable', buildUpAreaData);
  }, 300);
  const onSkip = () => onSelect();
  const handleOnSubmit = descriptionOfLand => {
    console.info('buildUpAreaTable: form data on submit', descriptionOfLand, formData);
    onSelect(currStep.key, descriptionOfLand);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0,
      overflowY: 'auto'
    },
    _defaultValues: formData === null || formData === void 0 ? void 0 : formData.data,
    childrenAtTheBottom: false,
    onSelect: handleSubmit(handleOnSubmit),
    onSkip: onSkip,
    t: t
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Select$1, Object.assign({}, {
    label: "BPA_TYPE_OF_DEVIATION_CATEGORY_LABEL",
    register,
    required: false,
    name: "deviationType",
    t,
    options: devialtionTypeOptions,
    onChange: selectDeviationType,
    grid: 12
  }, {
    isDropDown: true
  })), typeOfDeviation && /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    item: true,
    spacing: 2
  }, typeOfDeviation && (typeOfDeviation === null || typeOfDeviation === void 0 ? void 0 : typeOfDeviation.code) === "approvedpermissibleupto10percent" && /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_OFFENCE_REGISTRATION_NUMBER",
    register,
    required: false,
    name: "offenceRegistrationNumber",
    t,
    placeholder: "Enter Registration Number"
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_OFFENCE_SUBJECT_LABEL",
    register,
    required: false,
    name: "offenceSubject",
    t,
    placeholder: "Enter Subject",
    grid: typeOfDeviation && (typeOfDeviation === null || typeOfDeviation === void 0 ? void 0 : typeOfDeviation.code) === "approvedpermissibleupto10percent" ? 6 : 12
  })), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_REVENUE_VILLAGE_MOHALLA_LABEL",
    register,
    required: false,
    name: "revenueVillageMohal",
    t,
    placeholder: "Enter Revenue Village Mohalla"
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_KHATA_NO_LABEL",
    register,
    required: false,
    name: "khataNo",
    t,
    placeholder: "Enter khata No"
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_KHATAUNI_NO_LABEL",
    register,
    required: false,
    name: "khatauniNo",
    t,
    placeholder: "Enter khatauni No"
  }), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6,
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_LATITUDE_LABEL",
    register,
    required: false,
    name: "latitude",
    t,
    placeholder: "Enter latitude"
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_LONGITUDE_LABEL",
    register,
    required: false,
    name: "longitude",
    t,
    placeholder: "Enter longitude"
  })), khasraWithAreaFields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      container: true,
      key: field.id,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DOL_KHASARA_NO_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraWithArea.${index}.khasraNo`), {
      name: `khasraWithArea.${index}.khasraNo`,
      t: t,
      type: "text",
      optionKey: "i18nKey"
    }))), /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6,
      container: true,
      sx: {
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        flex: 1
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DOL_AREA_SQM_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraWithArea.${index}.area`), {
      name: `khasraWithArea.${index}.area`,
      t: t,
      type: "text",
      optionKey: "i18nKey"
    }))), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        gap: '.5rem',
        mt: ".9rem",
        ml: '.5rem'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      "aria-label": "add",
      onClick: () => append(khasraWithAreaEntry)
    }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), khasraWithArea.length > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "delete",
      onClick: () => remove(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
  }), /*#__PURE__*/React__default.createElement(InputText$1, Object.assign({}, {
    label: "BPA_DOL_TOTAL_PLOT_AREA_LABEL",
    register,
    required: false,
    name: "totalPlotArea",
    t,
    placeholder: "Enter Total Plot Area"
  }, {
    disabled: true
  })), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "BPA_DOL_NO_OF_PLOT_LABEL",
    register,
    required: false,
    name: "noOfPlot",
    t,
    placeholder: "Enter Number of Plot"
  }), /*#__PURE__*/React__default.createElement(Select$1, {
    label: "CORE_COMMON_PROPERTY_TYPE",
    register,
    required: false,
    name: "propertyType",
    t,
    selectedOption: propertyType,
    options: propertyTypeList$2,
    onChange: selectedValuePropertyType
  }), /*#__PURE__*/React__default.createElement(Select$1, {
    label: "CORE_COMMON_USE_TYPE",
    register,
    required: false,
    name: "useType",
    t,
    selectedOption: useType,
    options: useTypeList$2,
    onChange: selectedValueUseType
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "CORE_COMMON_PLOT_AREA",
    register,
    required: false,
    name: "plotArea",
    t,
    placeholder: "Enter plot Area"
  }), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "CORE_COMMON_PERMISSBLE_COVERAGE",
    register,
    required: false,
    name: "maximumCoverage",
    t,
    placeholder: "Enter plot Area"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("h2", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_DETAILS_OF_PLOT_AFTER_SUBDIVISION")} *`))), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_TYPE_OF_LAND_VOLVED")} *`), /*#__PURE__*/React__default.createElement(RadioButtons, Object.assign({
    style: {
      display: 'flex',
      gap: '3rem',
      margin: 0
    },
    options: typeOfLandVolvedList$1,
    selectedOption: typeOfLandVolved,
    optionsKey: "i18nKey"
  }, register(`typeOfLandVolved`), {
    name: 'typeOfLandVolved',
    onSelect: selectedValue,
    labelKey: "PT_OWNERSHIP",
    isDependent: true
  })), (typeOfLandVolved === null || typeOfLandVolved === void 0 ? void 0 : typeOfLandVolved.code) == "YES" && /*#__PURE__*/React__default.createElement(Select$1, Object.assign({}, {
    label: "BPA_TYPE_OF_CLU_INVOLVED",
    register,
    required: false,
    name: "typeOfCLUInvolved",
    t,
    options: typeOfLandVolvedYesList$1,
    onChange: selectTypeOfCLUInvolved
  }, {
    isDropDown: true
  })), (typeOfLandVolved === null || typeOfLandVolved === void 0 ? void 0 : typeOfLandVolved.code) == "YES" && typeOfCLUInvolved && /*#__PURE__*/React__default.createElement("div", {
    className: "table table-bordered table-responsive",
    style: {
      display: "block",
      overflowX: 'visible'
    }
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 50
    }
  }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_NO")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_TYPE_OF_LAND_DEVELOPMENT")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_ADD_MORE")}`))), /*#__PURE__*/React__default.createElement("tbody", null, khasraTableFields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraTable.${index}.plotNo`), {
      name: `khasraTable.${index}.plotNo`,
      t: t,
      style: {
        margin: 0
      },
      type: "text",
      optionKey: "i18nKey",
      placeholder: "Enter Khasra No.",
      disabled: false,
      required: false
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`khasraTable.${index}.plotArea`), {
      name: `khasraTable.${index}.plotArea`,
      t: t,
      style: {
        margin: 0
      },
      type: "text",
      optionKey: "i18nKey",
      placeholder: "Enter Area (sq.m)",
      disabled: false,
      required: false
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioOrSelect, Object.assign({}, register(`khasraTable.${index}.typeOfLand`), {
      name: `khasraTable.${index}.typeOfLand`,
      dropdownStyle: {
        margin: 0
      },
      optionCardStyles: {
        maxHeight: "20vmax",
        overflow: "scroll"
      },
      options: useTypeList$2.sort((a, b) => a.name.localeCompare(b.name)),
      optionKey: "name",
      onSelect: val => setValue(`khasraTable.${index}.typeOfLand`, val),
      t: t,
      isDependent: true
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        gap: '.5rem'
      }
    }, /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "primary",
      "aria-label": "Add more",
      onClick: () => appendTable(khasraTableEntry)
    }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), khasraTableFields.length > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
      color: "error",
      "aria-label": "Delete",
      onClick: () => removeTable(index)
    }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
  })))), /*#__PURE__*/React__default.createElement(InputText$1, {
    label: "CORE_COMMON_NO_OF_BLOCK",
    register,
    required: false,
    name: "noOfBlocks",
    t,
    placeholder: "Enter Number of Blocks"
  }), Number(watchNoOfBlocks) > 0 && watchBuildUpAreaTable.map(({
    table
  }, idx) => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "table table-bordered table-responsive",
      style: {
        display: "block"
      },
      key: `table_${idx}`
    }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 150
      }
    }, `${t("BPA_FLOOR_TYPE")} *`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 100
      }
    }, `${t("BPA_APPROVED_FLOOR_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 150
      }
    }, `${t("BPA_LAND_USE_TYPE")} *`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, `${t("BPA_PARKING_AREA")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, `${t("BPA_ACTUAL_CONSTRUCTION")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, `${t("BPA_PERMISSIBLE_DEVIATION")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, `${t("BPA_SETBACK_DEVIATION")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, `${t("DEVIATION_CENT")}`), /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal"
    }, "\xA0"))), /*#__PURE__*/React__default.createElement("tbody", null, table === null || table === void 0 ? void 0 : table.map(({
      id,
      ...field
    }, index) => {
      var _watchBuildUpAreaTabl;
      return /*#__PURE__*/React__default.createElement("tr", {
        key: `row_${idx}_${id}`
      }, /*#__PURE__*/React__default.createElement("th", {
        className: "fw-normal",
        style: {
          minWidth: 50
        }
      }, index + 1), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("input", Object.assign({
        type: "hidden",
        value: (_watchBuildUpAreaTabl = watchBuildUpAreaTable[idx].table[id]) === null || _watchBuildUpAreaTabl === void 0 ? void 0 : _watchBuildUpAreaTabl.id,
        name: `buildUpAreaTable[${idx}].table[${id}].id`
      }, register(`buildUpAreaTable[${idx}].table[${id}].id`))), /*#__PURE__*/React__default.createElement(RadioOrSelect, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].floorType`), {
        name: `buildUpAreaTable[${idx}].table[${id}].floorType`,
        dropdownStyle: {
          margin: 0
        },
        optionCardStyles: {
          maxHeight: "20vmax",
          overflow: "scroll"
        },
        options: floorTypeList,
        optionKey: "name",
        selectedOption: `buildUpAreaTable[${idx}].table[${id}].floorType`,
        onSelect: val => updateBuildUpAreaData(idx, id, `floorType`, val),
        t: t,
        isDependent: true
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].floorArea`), {
        name: `buildUpAreaTable[${idx}].table[${id}].floorArea`,
        onChange: e => updateBuildUpAreaData(idx, id, `floorArea`, e.target.value),
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter Approved Floor Area",
        disabled: false,
        required: false,
        errorStyle: !!((showToast === null || showToast === void 0 ? void 0 : showToast.key) === `floorArea_${idx}_${id}`)
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(RadioOrSelect, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].landUseType`), {
        name: `buildUpAreaTable[${idx}].table[${id}].landUseType`,
        dropdownStyle: {
          margin: 0
        },
        optionCardStyles: {
          maxHeight: "20vmax",
          overflow: "scroll"
        },
        options: useTypeList$2.sort((a, b) => a.name.localeCompare(b.name)),
        optionKey: "name",
        selectedOption: `buildUpAreaTable[${idx}].table[${id}].landUseType`,
        onSelect: val => updateBuildUpAreaData(idx, id, `landUseType`, val),
        t: t,
        isDependent: true
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].parkingArea`), {
        name: `buildUpAreaTable[${idx}].table[${id}].parkingArea`,
        onChange: e => updateBuildUpAreaData(idx, id, `parkingArea`, e.target.value),
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter parking area",
        disabled: false,
        required: false
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].actualConstruction`), {
        name: `buildUpAreaTable[${idx}].table[${id}].actualConstruction`,
        onChange: e => updateBuildUpAreaData(idx, id, `actualConstruction`, e.target.value),
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter actual construction",
        disabled: false,
        required: false
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].permissibleDeviation`), {
        name: `buildUpAreaTable[${idx}].table[${id}].permissibleDeviation`,
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter permissible deviation",
        disabled: true,
        required: false
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].setbackDeviation`), {
        name: `buildUpAreaTable[${idx}].table[${id}].setbackDeviation`,
        onChange: e => updateBuildUpAreaData(idx, id, `setbackDeviation`, e.target.value),
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter permissible deviation",
        disabled: false,
        required: false
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({}, register(`buildUpAreaTable[${idx}].table[${id}].deviation`), {
        name: `buildUpAreaTable[${idx}].table[${id}].deviation`,
        onChange: e => updateBuildUpAreaData(idx, id, `deviation`, e.target.value),
        t: t,
        style: {
          margin: 0
        },
        type: "text",
        optionKey: "i18nKey",
        placeholder: "Enter deviation %",
        disabled: false,
        required: false
      }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: 'flex',
          gap: '.5rem'
        }
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        color: "primary",
        "aria-label": "Add more",
        onClick: () => addTableRow(idx)
      }, /*#__PURE__*/React__default.createElement(AddBoxIcon, null)), table.length > 1 && /*#__PURE__*/React__default.createElement(IconButton$1, {
        color: "error",
        "aria-label": "Delete",
        onClick: () => removeTableRow(idx, id)
      }, /*#__PURE__*/React__default.createElement(DeleteIcon, null)))));
    }))));
  })))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit(handleOnSubmit),
    style: {
      marginTop: '1rem'
    }
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    isDleteBtn: true,
    error: showToast.error,
    warning: showToast.warning,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const Checklist$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$checklist, _formData$checklist2, _formData$checklist3, _formData$checklist4, _formData$checklist5, _formData$checklist6;
  const [showToast, setShowToast] = useState(null);
  const [pedestrianMinWidth, setPedestrianMinWidth] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.pedestrianMinWidth) || "");
  const [vehicularAccessMinWidth, setVehicularAccessMinWidth] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.vehicularAccessMinWidth) || "");
  const [openGreenSpaceMinArea, setOpenGreenSpaceMinArea] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist3 = formData.checklist) === null || _formData$checklist3 === void 0 ? void 0 : _formData$checklist3.openGreenSpaceMinArea) || "");
  const [soakPitMinArea, setSoakPitMinArea] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist4 = formData.checklist) === null || _formData$checklist4 === void 0 ? void 0 : _formData$checklist4.soakPitMinArea) || "");
  const [plotOrientation, setPlotOrientation] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist5 = formData.checklist) === null || _formData$checklist5 === void 0 ? void 0 : _formData$checklist5.plotOrientation) || "");
  const [plotLayout, setPlotLayout] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist6 = formData.checklist) === null || _formData$checklist6 === void 0 ? void 0 : _formData$checklist6.plotLayout) || "");
  let validation = {};
  const closeToast = () => setShowToast(null);
  const onSkip = () => onSelect();
  const handleSubmit = () => {
    let checklist = {
      pedestrianMinWidth: pedestrianMinWidth || "",
      vehicularAccessMinWidth: vehicularAccessMinWidth || "",
      openGreenSpaceMinArea: openGreenSpaceMinArea || "",
      soakPitMinArea: soakPitMinArea || "",
      plotOrientation: plotOrientation || "",
      plotLayout: plotLayout || ""
    };
    onSelect(currStep.key, checklist);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    },
    onSelect: handleSubmit,
    onSkip: onSkip,
    t: t
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PADESTERIAN_MIN_WIDTH")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "pedestrianMinWidth",
    value: pedestrianMinWidth,
    onChange: e => setPedestrianMinWidth(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_VEHICULAR_ACCESS_MIN_WIDTH")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "vehicularAccessMinWidth",
    value: vehicularAccessMinWidth,
    onChange: e => setVehicularAccessMinWidth(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_OPEN_GREEN_SPACE_MIN_AREA")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "openGreenSpaceMinArea",
    value: openGreenSpaceMinArea,
    onChange: e => setOpenGreenSpaceMinArea(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_SOAK_PIT_MIN_AREA")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "soakPitMinArea",
    value: soakPitMinArea,
    onChange: e => setSoakPitMinArea(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PLOT_ORIENTATION")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "plotOrientation",
    value: plotOrientation,
    onChange: e => setPlotOrientation(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PLOT_LAYOUT")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "plotLayout",
    value: plotLayout,
    onChange: e => setPlotLayout(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      marginTop: '1rem'
    }
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const Checklist$2 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$checklist, _formData$checklist2, _formData$checklist3, _formData$checklist4, _formData$checklist5, _formData$checklist6;
  const [showToast, setShowToast] = useState(null);
  const [pedestrianMinWidth, setPedestrianMinWidth] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.pedestrianMinWidth) || "");
  const [vehicularAccessMinWidth, setVehicularAccessMinWidth] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.vehicularAccessMinWidth) || "");
  const [openGreenSpaceMinArea, setOpenGreenSpaceMinArea] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist3 = formData.checklist) === null || _formData$checklist3 === void 0 ? void 0 : _formData$checklist3.openGreenSpaceMinArea) || "");
  const [soakPitMinArea, setSoakPitMinArea] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist4 = formData.checklist) === null || _formData$checklist4 === void 0 ? void 0 : _formData$checklist4.soakPitMinArea) || "");
  const [plotOrientation, setPlotOrientation] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist5 = formData.checklist) === null || _formData$checklist5 === void 0 ? void 0 : _formData$checklist5.plotOrientation) || "");
  const [plotLayout, setPlotLayout] = useState((formData === null || formData === void 0 ? void 0 : (_formData$checklist6 = formData.checklist) === null || _formData$checklist6 === void 0 ? void 0 : _formData$checklist6.plotLayout) || "");
  let validation = {};
  const closeToast = () => setShowToast(null);
  const onSkip = () => onSelect();
  const handleSubmit = () => {
    let checklist = {
      pedestrianMinWidth: pedestrianMinWidth || "",
      vehicularAccessMinWidth: vehicularAccessMinWidth || "",
      openGreenSpaceMinArea: openGreenSpaceMinArea || "",
      soakPitMinArea: soakPitMinArea || "",
      plotOrientation: plotOrientation || "",
      plotLayout: plotLayout || ""
    };
    onSelect(currStep.key, checklist);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormStep, {
    cardStyle: {
      boxShadow: 'none',
      padding: 0,
      border: 0
    },
    onSelect: handleSubmit,
    onSkip: onSkip,
    t: t
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PADESTERIAN_MIN_WIDTH")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "pedestrianMinWidth",
    value: pedestrianMinWidth,
    onChange: e => setPedestrianMinWidth(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_VEHICULAR_ACCESS_MIN_WIDTH")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "vehicularAccessMinWidth",
    value: vehicularAccessMinWidth,
    onChange: e => setVehicularAccessMinWidth(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_OPEN_GREEN_SPACE_MIN_AREA")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "openGreenSpaceMinArea",
    value: openGreenSpaceMinArea,
    onChange: e => setOpenGreenSpaceMinArea(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_SOAK_PIT_MIN_AREA")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "soakPitMinArea",
    value: soakPitMinArea,
    onChange: e => setSoakPitMinArea(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PLOT_ORIENTATION")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "plotOrientation",
    value: plotOrientation,
    onChange: e => setPlotOrientation(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_CHECKLIST_OPTION_PLOT_LAYOUT")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "plotLayout",
    value: plotLayout,
    onChange: e => setPlotLayout(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit,
    style: {
      marginTop: '1rem'
    }
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const ProfessionalDetails = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$owners, _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _formData$currStep$ke5, _formData$currStep$ke6, _formData$currStep$ke7, _formData$currStep$ke8, _formData$currStep$ke9, _formData$currStep$ke10, _formData$currStep$ke11, _formData$currStep$ke12, _formData$currStep$ke13, _formData$currStep$ke14, _formData$currStep$ke15, _formData$currStep$ke16, _formData$currStep$ke17, _formData$currStep$ke18, _formData$currStep$ke19, _formData$currStep$ke20, _formData$currStep$ke21, _formData$currStep$ke22, _formData$owners2, _formData$owners2$own, _userInfo$info, _userInfo$info2, _userInfo$info3;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const userInfo = Digit.UserService.getUser();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategory, setOwnershipCategory] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : _formData$owners.ownershipCategory);
  const [name, setName] = useState(((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.name) || "");
  const [registrationNumber, setregistrationNo] = useState(((_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : _formData$currStep$ke2.registrationNumber) || "");
  const [emailId, setemailId] = useState(((_formData$currStep$ke3 = formData[currStep.key]) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.emailId) || "");
  const [address, setaddress] = useState(((_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.address) || "");
  const [district, setDistrict] = useState(((_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.district) || "");
  const [state, setState] = useState(((_formData$currStep$ke6 = formData[currStep.key]) === null || _formData$currStep$ke6 === void 0 ? void 0 : _formData$currStep$ke6.state) || "");
  const [mobileNumber, setMobileNumber] = useState(((_formData$currStep$ke7 = formData[currStep.key]) === null || _formData$currStep$ke7 === void 0 ? void 0 : _formData$currStep$ke7.mobileNumber) || "");
  const [tehsil, setTehsil] = useState(((_formData$currStep$ke8 = formData[currStep.key]) === null || _formData$currStep$ke8 === void 0 ? void 0 : _formData$currStep$ke8.tehsil) || "");
  const [town, setTown] = useState(((_formData$currStep$ke9 = formData[currStep.key]) === null || _formData$currStep$ke9 === void 0 ? void 0 : _formData$currStep$ke9.town) || "");
  const [pinNo, setPinNo] = useState(((_formData$currStep$ke10 = formData[currStep.key]) === null || _formData$currStep$ke10 === void 0 ? void 0 : _formData$currStep$ke10.pinNo) || "");
  const [classCat, setClassCat] = useState(((_formData$currStep$ke11 = formData[currStep.key]) === null || _formData$currStep$ke11 === void 0 ? void 0 : _formData$currStep$ke11.classA) || "");
  const [university, setUniversity] = useState(((_formData$currStep$ke12 = formData[currStep.key]) === null || _formData$currStep$ke12 === void 0 ? void 0 : _formData$currStep$ke12.university) || "");
  const [ername, setErName] = useState(((_formData$currStep$ke13 = formData[currStep.key]) === null || _formData$currStep$ke13 === void 0 ? void 0 : _formData$currStep$ke13.ername) || "");
  const [erregistrationNumber, setErregistrationNo] = useState(((_formData$currStep$ke14 = formData[currStep.key]) === null || _formData$currStep$ke14 === void 0 ? void 0 : _formData$currStep$ke14.erregistrationNumber) || "");
  const [eremailId, setEremailId] = useState(((_formData$currStep$ke15 = formData[currStep.key]) === null || _formData$currStep$ke15 === void 0 ? void 0 : _formData$currStep$ke15.eremailId) || "");
  const [eraddress, setEraddress] = useState(((_formData$currStep$ke16 = formData[currStep.key]) === null || _formData$currStep$ke16 === void 0 ? void 0 : _formData$currStep$ke16.eraddress) || "");
  const [erdistrict, setErDistrict] = useState(((_formData$currStep$ke17 = formData[currStep.key]) === null || _formData$currStep$ke17 === void 0 ? void 0 : _formData$currStep$ke17.erdistrict) || "");
  const [erstate, setErState] = useState(((_formData$currStep$ke18 = formData[currStep.key]) === null || _formData$currStep$ke18 === void 0 ? void 0 : _formData$currStep$ke18.erstate) || "");
  const [ermobileNumber, setErMobileNumber] = useState(((_formData$currStep$ke19 = formData[currStep.key]) === null || _formData$currStep$ke19 === void 0 ? void 0 : _formData$currStep$ke19.ermobileNumber) || "");
  const [ertehsil, setErTehsil] = useState(((_formData$currStep$ke20 = formData[currStep.key]) === null || _formData$currStep$ke20 === void 0 ? void 0 : _formData$currStep$ke20.ertehsil) || "");
  const [ertown, setErTown] = useState(((_formData$currStep$ke21 = formData[currStep.key]) === null || _formData$currStep$ke21 === void 0 ? void 0 : _formData$currStep$ke21.ertown) || "");
  const [erpinNo, setErPinNo] = useState(((_formData$currStep$ke22 = formData[currStep.key]) === null || _formData$currStep$ke22 === void 0 ? void 0 : _formData$currStep$ke22.erpinNo) || "");
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = useState(null);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  formData === null || formData === void 0 ? void 0 : (_formData$owners2 = formData.owners) === null || _formData$owners2 === void 0 ? void 0 : (_formData$owners2$own = _formData$owners2.owners) === null || _formData$owners2$own === void 0 ? void 0 : _formData$owners2$own.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const getFormEntries = filter => typeof formData[currStep.key] === 'object' && !Array.isArray(formData[currStep.key]) ? [Object.keys(formData[currStep.key]).filter(key => filter(key)).reduce((obj, key) => {
    obj[key] = formData[currStep.key][key];
    return obj;
  }, {})] : null;
  const [fields, setFeilds] = useState(getFormEntries(key => !key.startsWith('er')) || [{
    mobileNumber: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.mobileNumber) || "",
    name: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.name) || "",
    registrationNumber: "",
    emailId: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId) || "",
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinNo: "",
    classA: "",
    university: ""
  }]);
  const [erfields, setErFeilds] = useState(getFormEntries(key => key.startsWith('er')) || [{
    ermobileNumber: null,
    ername: "",
    erregistrationNumber: "",
    eremailId: "",
    eraddress: "",
    erstate: "",
    erdistrict: "",
    ertehsil: "",
    ertown: "",
    erpinNo: ""
  }]);
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErOwnerName(i, e) {
    let units = [...erfields];
    units[i].name = e.target.value;
    setErName(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setRegistrationNo(i, e) {
    let units = [...fields];
    units[i].registrationNumber = e.target.value;
    setregistrationNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErRegistrationNo(i, e) {
    let units = [...erfields];
    units[i].registrationNumber = e.target.value;
    setErregistrationNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setAddress(i, e) {
    let units = [...fields];
    units[i].address = e.target.value;
    setaddress(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErAddress(i, e) {
    let units = [...erfields];
    units[i].address = e.target.value;
    setEraddress(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErEmail(i, e) {
    let units = [...erfields];
    units[i].emailId = e.target.value;
    setEremailId(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectDistrict(i, e) {
    let units = [...fields];
    units[i].district = e.target.value;
    setDistrict(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErDistrict(i, e) {
    let units = [...erfields];
    units[i].district = e.target.value;
    setErDistrict(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTehsil(i, e) {
    let units = [...fields];
    units[i].tehsil = e.target.value;
    setTehsil(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTehsil(i, e) {
    let units = [...erfields];
    units[i].tehsil = e.target.value;
    setErTehsil(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTown(i, e) {
    let units = [...fields];
    units[i].town = e.target.value;
    setTown(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTown(i, e) {
    let units = [...erfields];
    units[i].town = e.target.value;
    setErTown(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectPinNO(i, e) {
    let units = [...fields];
    units[i].pinNo = e.target.value;
    setPinNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErPinNO(i, e) {
    let units = [...erfields];
    units[i].pinNo = e.target.value;
    setErPinNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectClassCat(i, e) {
    let units = [...fields];
    units[i].classA = e.target.value;
    setClassCat(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectUniversity(i, e) {
    let units = [...fields];
    units[i].university = e.target.value;
    setUniversity(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectState(i, e) {
    let units = [...fields];
    units[i].state = e.target.value;
    setState(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErState(i, e) {
    let units = [...erfields];
    units[i].state = e.target.value;
    setErState(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErMobileNo(i, e) {
    let units = [...erfields];
    units[i].mobileNumber = e.target.value;
    setErMobileNumber(e.target.value);
    setErFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    const professionaldetail = {};
    professionaldetail.registrationNumber = registrationNumber || "";
    professionaldetail.name = name || "";
    professionaldetail.mobileNumber = mobileNumber || "";
    professionaldetail.address = address || "";
    professionaldetail.state = state || "";
    professionaldetail.district = district || "";
    professionaldetail.tehsil = tehsil || "";
    professionaldetail.town = town || "";
    professionaldetail.pinNo = pinNo || "";
    professionaldetail.emailId = emailId || "";
    professionaldetail.classA = classCat || "";
    professionaldetail.university = university || "";
    professionaldetail.erregistrationNumber = erregistrationNumber || "";
    professionaldetail.ername = ername || "";
    professionaldetail.ermobileNumber = ermobileNumber || "";
    professionaldetail.eraddress = eraddress || "";
    professionaldetail.erstate = erstate || "";
    professionaldetail.erdistrict = erdistrict || "";
    professionaldetail.ertehsil = ertehsil || "";
    professionaldetail.ertown = ertown || "";
    professionaldetail.erpinNo = erpinNo || "";
    professionaldetail.eremailId = eremailId || "";
    if (currentTab == "1") {
      setCurrentTab("2");
      return;
    }
    onSelect(currStep.key, professionaldetail);
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: currStep.step,
    flow: "Form11"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, currStep.tabList.map((tab, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(tab)}`,
    value: `${index + 1}`,
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index, e)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.registrationNumber,
      onChange: e => setRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "emailId",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.address,
      onChange: e => setAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "state",
      value: field.state,
      onChange: e => selectState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinNo",
      value: field.pinNo,
      onChange: e => selectPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_CLASS_CATEGORIES")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "classA",
      value: field.classA,
      onChange: e => selectClassCat(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_UNIVERSITY_NAME")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "university",
      value: field.university,
      onChange: e => selectUniversity(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, erfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "ermobileNumber",
      value: field.ermobileNumber,
      onChange: e => setErMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index, e)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "ername",
      defaultValue: field.ername,
      onChange: e => setErOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "erregistrationNumber",
      defaultValue: field.erregistrationNumber,
      onChange: e => setErRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "eremail",
      defaultValue: field.eremailId,
      onChange: e => selectErEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "eraddress",
      defaultValue: field.eraddress,
      onChange: e => setErAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "erstate",
      defaultValue: field.erstate,
      onChange: e => selectErState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "erdistrict",
      defaultValue: field.erdistrict,
      onChange: e => selectErDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "ertehsil",
      defaultValue: field.ertehsil,
      onChange: e => selectErTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "ertown",
      defaultValue: field.ertown,
      onChange: e => selectErTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "erpinNo",
      defaultValue: field.erpinNo,
      onChange: e => selectErPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const ProfessionalDetails$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$owners, _formData$currStep$ke, _formData$currStep$ke2, _formData$currStep$ke3, _formData$currStep$ke4, _formData$currStep$ke5, _formData$currStep$ke6, _formData$currStep$ke7, _formData$currStep$ke8, _formData$currStep$ke9, _formData$currStep$ke10, _formData$currStep$ke11, _formData$currStep$ke12, _formData$currStep$ke13, _formData$owners2, _formData$owners2$own, _selcectedEng$permane, _selcectedEng$permane2, _selcectedEng$permane3, _selcectedEng$permane4, _selcectedEng$permane5, _selcectedEng$permane6, _formData$currStep$ke14, _formData$currStep$ke15, _formData$currStep$ke16, _formData$currStep$ke17, _formData$currStep$ke18, _formData$currStep$ke19, _formData$currStep$ke20, _formData$currStep$ke21, _formData$currStep$ke22, _formData$currStep$ke23, _userInfo$info, _userInfo$info2, _userInfo$info3;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const userInfo = Digit.UserService.getUser();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategory, setOwnershipCategory] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : _formData$owners.ownershipCategory);
  const [name, setName] = useState(((_formData$currStep$ke = formData[currStep.key]) === null || _formData$currStep$ke === void 0 ? void 0 : _formData$currStep$ke.name) || "");
  const [registrationNumber, setregistrationNo] = useState(((_formData$currStep$ke2 = formData[currStep.key]) === null || _formData$currStep$ke2 === void 0 ? void 0 : _formData$currStep$ke2.registrationNumber) || "");
  const [emailId, setemailId] = useState(((_formData$currStep$ke3 = formData[currStep.key]) === null || _formData$currStep$ke3 === void 0 ? void 0 : _formData$currStep$ke3.emailId) || "");
  const [address, setaddress] = useState(((_formData$currStep$ke4 = formData[currStep.key]) === null || _formData$currStep$ke4 === void 0 ? void 0 : _formData$currStep$ke4.address) || "");
  const [district, setDistrict] = useState(((_formData$currStep$ke5 = formData[currStep.key]) === null || _formData$currStep$ke5 === void 0 ? void 0 : _formData$currStep$ke5.district) || "");
  const [state, setState] = useState(((_formData$currStep$ke6 = formData[currStep.key]) === null || _formData$currStep$ke6 === void 0 ? void 0 : _formData$currStep$ke6.state) || "");
  const [mobileNumber, setMobileNumber] = useState(((_formData$currStep$ke7 = formData[currStep.key]) === null || _formData$currStep$ke7 === void 0 ? void 0 : _formData$currStep$ke7.mobileNumber) || "");
  const [tehsil, setTehsil] = useState(((_formData$currStep$ke8 = formData[currStep.key]) === null || _formData$currStep$ke8 === void 0 ? void 0 : _formData$currStep$ke8.tehsil) || "");
  const [town, setTown] = useState(((_formData$currStep$ke9 = formData[currStep.key]) === null || _formData$currStep$ke9 === void 0 ? void 0 : _formData$currStep$ke9.town) || "");
  const [pinNo, setPinNo] = useState(((_formData$currStep$ke10 = formData[currStep.key]) === null || _formData$currStep$ke10 === void 0 ? void 0 : _formData$currStep$ke10.pinNo) || "");
  const [classCat, setClassCat] = useState(((_formData$currStep$ke11 = formData[currStep.key]) === null || _formData$currStep$ke11 === void 0 ? void 0 : _formData$currStep$ke11.classA) || "");
  const [university, setUniversity] = useState(((_formData$currStep$ke12 = formData[currStep.key]) === null || _formData$currStep$ke12 === void 0 ? void 0 : _formData$currStep$ke12.university) || "");
  const [selcectedEng, setSelectedEng] = useState(((_formData$currStep$ke13 = formData[currStep.key]) === null || _formData$currStep$ke13 === void 0 ? void 0 : _formData$currStep$ke13.selcectedEng) || null);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  formData === null || formData === void 0 ? void 0 : (_formData$owners2 = formData.owners) === null || _formData$owners2 === void 0 ? void 0 : (_formData$owners2$own = _formData$owners2.owners) === null || _formData$owners2$own === void 0 ? void 0 : _formData$owners2$own.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const getFormEntries = filter => typeof formData[currStep.key] === 'object' && !Array.isArray(formData[currStep.key]) ? [Object.keys(formData[currStep.key]).filter(key => filter(key)).reduce((obj, key) => {
    obj[key] = formData[currStep.key][key];
    return obj;
  }, {})] : null;
  const [erfields, setErFeilds] = useState(getFormEntries(key => key.startsWith('er')) || [{
    ermobileNumber: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.mobileNumber) || "",
    ername: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.name) || "",
    erregistrationNumber: "",
    eremailId: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.emailId) || "",
    eraddress: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane = selcectedEng.permanentAddress) === null || _selcectedEng$permane === void 0 ? void 0 : _selcectedEng$permane.address) || "",
    erstate: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane2 = selcectedEng.permanentAddress) === null || _selcectedEng$permane2 === void 0 ? void 0 : _selcectedEng$permane2.state) || "",
    erdistrict: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane3 = selcectedEng.permanentAddress) === null || _selcectedEng$permane3 === void 0 ? void 0 : _selcectedEng$permane3.district) || "",
    ertehsil: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane4 = selcectedEng.permanentAddress) === null || _selcectedEng$permane4 === void 0 ? void 0 : _selcectedEng$permane4.tehsil) || "",
    ertown: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane5 = selcectedEng.permanentAddress) === null || _selcectedEng$permane5 === void 0 ? void 0 : _selcectedEng$permane5.town) || "",
    erpinNo: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane6 = selcectedEng.permanentAddress) === null || _selcectedEng$permane6 === void 0 ? void 0 : _selcectedEng$permane6.pinNo) || ""
  }]);
  const [ername, setErName] = useState(((_formData$currStep$ke14 = formData[currStep.key]) === null || _formData$currStep$ke14 === void 0 ? void 0 : _formData$currStep$ke14.ername) || erfields.ername || "");
  const [erregistrationNumber, setErregistrationNo] = useState(((_formData$currStep$ke15 = formData[currStep.key]) === null || _formData$currStep$ke15 === void 0 ? void 0 : _formData$currStep$ke15.erregistrationNumber) || erfields.erregistrationNumber || "");
  const [eremailId, setEremailId] = useState(((_formData$currStep$ke16 = formData[currStep.key]) === null || _formData$currStep$ke16 === void 0 ? void 0 : _formData$currStep$ke16.eremailId) || erfields.eremailId || "");
  const [eraddress, setEraddress] = useState(((_formData$currStep$ke17 = formData[currStep.key]) === null || _formData$currStep$ke17 === void 0 ? void 0 : _formData$currStep$ke17.eraddress) || erfields.eraddress || "");
  const [erdistrict, setErDistrict] = useState(((_formData$currStep$ke18 = formData[currStep.key]) === null || _formData$currStep$ke18 === void 0 ? void 0 : _formData$currStep$ke18.erdistrict) || erfields.erdistrict || "");
  const [erstate, setErState] = useState(((_formData$currStep$ke19 = formData[currStep.key]) === null || _formData$currStep$ke19 === void 0 ? void 0 : _formData$currStep$ke19.erstate) || erfields.erstate || "");
  const [ermobileNumber, setErMobileNumber] = useState(((_formData$currStep$ke20 = formData[currStep.key]) === null || _formData$currStep$ke20 === void 0 ? void 0 : _formData$currStep$ke20.ermobileNumber) || erfields.ermobileNumber || "");
  const [ertehsil, setErTehsil] = useState(((_formData$currStep$ke21 = formData[currStep.key]) === null || _formData$currStep$ke21 === void 0 ? void 0 : _formData$currStep$ke21.ertehsil) || erfields.ertehsil || "");
  const [ertown, setErTown] = useState(((_formData$currStep$ke22 = formData[currStep.key]) === null || _formData$currStep$ke22 === void 0 ? void 0 : _formData$currStep$ke22.ertown) || erfields.ertown || "");
  const [erpinNo, setErPinNo] = useState(((_formData$currStep$ke23 = formData[currStep.key]) === null || _formData$currStep$ke23 === void 0 ? void 0 : _formData$currStep$ke23.erpinNo) || erfields.erpinNo || "");
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = useState(null);
  const [engineersArr, setEngsArr] = useState([]);
  const [fields, setFeilds] = useState(getFormEntries(key => !key.startsWith('er')) || [{
    mobileNumber: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.mobileNumber) || "",
    name: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.name) || "",
    registrationNumber: "",
    emailId: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.emailId) || "",
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinNo: "",
    classA: "",
    university: ""
  }]);
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErOwnerName(i, e) {
    let units = [...erfields];
    units[i].name = e.target.value;
    setErName(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setRegistrationNo(i, e) {
    let units = [...fields];
    units[i].registrationNumber = e.target.value;
    setregistrationNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErRegistrationNo(i, e) {
    let units = [...erfields];
    units[i].registrationNumber = e.target.value;
    setErregistrationNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setAddress(i, e) {
    let units = [...fields];
    units[i].address = e.target.value;
    setaddress(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErAddress(i, e) {
    let units = [...erfields];
    units[i].address = e.target.value;
    setEraddress(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErEmail(i, e) {
    let units = [...erfields];
    units[i].emailId = e.target.value;
    setEremailId(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectDistrict(i, e) {
    let units = [...fields];
    units[i].district = e.target.value;
    setDistrict(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErDistrict(i, e) {
    let units = [...erfields];
    units[i].district = e.target.value;
    setErDistrict(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTehsil(i, e) {
    let units = [...fields];
    units[i].tehsil = e.target.value;
    setTehsil(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTehsil(i, e) {
    let units = [...erfields];
    units[i].tehsil = e.target.value;
    setErTehsil(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTown(i, e) {
    let units = [...fields];
    units[i].town = e.target.value;
    setTown(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTown(i, e) {
    let units = [...erfields];
    units[i].town = e.target.value;
    setErTown(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectPinNO(i, e) {
    let units = [...fields];
    units[i].pinNo = e.target.value;
    setPinNo(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErPinNO(i, e) {
    let units = [...erfields];
    units[i].pinNo = e.target.value;
    setErPinNo(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectClassCat(i, e) {
    let units = [...fields];
    units[i].classA = e.target.value;
    setClassCat(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectUniversity(i, e) {
    let units = [...fields];
    units[i].university = e.target.value;
    setUniversity(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectState(i, e) {
    let units = [...fields];
    units[i].state = e.target.value;
    setState(e.target.value);
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErState(i, e) {
    let units = [...erfields];
    units[i].state = e.target.value;
    setErState(e.target.value);
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErMobileNo(i, e) {
    let units = [...erfields];
    units[i].mobileNumber = e.target.value;
    setErMobileNumber(e.target.value);
    setErFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  useEffect(async () => {
    const tenantId = Digit.ULBService.getStateId();
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"]
    });
    setEngsArr(structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user);
  }, []);
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    var _erfields$, _erfields$2, _erfields$3, _erfields$4, _erfields$5, _erfields$6, _erfields$7, _erfields$8, _erfields$9, _erfields$10, _erfields$11;
    const professionaldetail = {};
    professionaldetail.registrationNumber = registrationNumber || "";
    professionaldetail.name = name || "";
    professionaldetail.mobileNumber = mobileNumber || "";
    professionaldetail.address = address || "";
    professionaldetail.state = state || "";
    professionaldetail.district = district || "";
    professionaldetail.tehsil = tehsil || "";
    professionaldetail.town = town || "";
    professionaldetail.pinNo = pinNo || "";
    professionaldetail.emailId = emailId || "";
    professionaldetail.classA = classCat || "";
    professionaldetail.university = university || "";
    professionaldetail.erregistrationNumber = (erfields === null || erfields === void 0 ? void 0 : (_erfields$ = erfields[0]) === null || _erfields$ === void 0 ? void 0 : _erfields$.erregistrationNumber) || "";
    professionaldetail.ername = ername || (erfields === null || erfields === void 0 ? void 0 : (_erfields$2 = erfields[0]) === null || _erfields$2 === void 0 ? void 0 : _erfields$2.ername) || "";
    professionaldetail.ermobileNumber = ermobileNumber || (erfields === null || erfields === void 0 ? void 0 : (_erfields$3 = erfields[0]) === null || _erfields$3 === void 0 ? void 0 : _erfields$3.ermobileNumber) || "";
    professionaldetail.eraddress = eraddress || (erfields === null || erfields === void 0 ? void 0 : (_erfields$4 = erfields[0]) === null || _erfields$4 === void 0 ? void 0 : _erfields$4.eraddress) || "";
    professionaldetail.erstate = erstate || (erfields === null || erfields === void 0 ? void 0 : (_erfields$5 = erfields[0]) === null || _erfields$5 === void 0 ? void 0 : _erfields$5.erstate) || "";
    professionaldetail.erdistrict = erdistrict || (erfields === null || erfields === void 0 ? void 0 : (_erfields$6 = erfields[0]) === null || _erfields$6 === void 0 ? void 0 : _erfields$6.erdistrict) || "";
    professionaldetail.ertehsil = ertehsil || (erfields === null || erfields === void 0 ? void 0 : (_erfields$7 = erfields[0]) === null || _erfields$7 === void 0 ? void 0 : _erfields$7.ertehsil) || "";
    professionaldetail.ertown = ertown || (erfields === null || erfields === void 0 ? void 0 : (_erfields$8 = erfields[0]) === null || _erfields$8 === void 0 ? void 0 : _erfields$8.ertown) || "";
    professionaldetail.erpinNo = erpinNo || (erfields === null || erfields === void 0 ? void 0 : (_erfields$9 = erfields[0]) === null || _erfields$9 === void 0 ? void 0 : _erfields$9.erpinNo) || "";
    professionaldetail.eremailId = eremailId || (erfields === null || erfields === void 0 ? void 0 : (_erfields$10 = erfields[0]) === null || _erfields$10 === void 0 ? void 0 : _erfields$10.eremailId) || "";
    professionaldetail.engineerUuid = (erfields === null || erfields === void 0 ? void 0 : (_erfields$11 = erfields[0]) === null || _erfields$11 === void 0 ? void 0 : _erfields$11.eruuid) || "";
    if (currentTab == "1") {
      setCurrentTab("2");
      return;
    }
    onSelect(currStep.key, professionaldetail);
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: currStep.step,
    flow: "Form26"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, currStep.tabList.map((tab, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(tab)}`,
    value: `${index + 1}`,
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index, e)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.registrationNumber,
      onChange: e => setRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "emailId",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.address,
      onChange: e => setAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "state",
      value: field.state,
      onChange: e => selectState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinNo",
      value: field.pinNo,
      onChange: e => selectPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_CLASS_CATEGORIES")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "classA",
      value: field.classA,
      onChange: e => selectClassCat(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_UNIVERSITY_NAME")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "university",
      value: field.university,
      onChange: e => selectUniversity(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, erfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      variant: "h6"
    }, `${t("BPA_SELECT_STRUCTURAL_ENGINEER_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
      name: "engineerType",
      optionKey: "name",
      options: engineersArr,
      onSelect: name => {
        var _name$permanentAddres, _name$permanentAddres2, _name$permanentAddres3, _name$permanentAddres4, _name$permanentAddres5, _name$permanentAddres6;
        setSelectedEng(name);
        setErFeilds([{
          ermobileNumber: (name === null || name === void 0 ? void 0 : name.mobileNumber) || "",
          ername: (name === null || name === void 0 ? void 0 : name.name) || "",
          erregistrationNumber: "",
          eremailId: (name === null || name === void 0 ? void 0 : name.emailId) || "",
          eraddress: (name === null || name === void 0 ? void 0 : (_name$permanentAddres = name.permanentAddress) === null || _name$permanentAddres === void 0 ? void 0 : _name$permanentAddres.address) || "",
          erstate: (name === null || name === void 0 ? void 0 : (_name$permanentAddres2 = name.permanentAddress) === null || _name$permanentAddres2 === void 0 ? void 0 : _name$permanentAddres2.state) || "",
          erdistrict: (name === null || name === void 0 ? void 0 : (_name$permanentAddres3 = name.permanentAddress) === null || _name$permanentAddres3 === void 0 ? void 0 : _name$permanentAddres3.district) || "",
          ertehsil: (name === null || name === void 0 ? void 0 : (_name$permanentAddres4 = name.permanentAddress) === null || _name$permanentAddres4 === void 0 ? void 0 : _name$permanentAddres4.tehsil) || "",
          ertown: (name === null || name === void 0 ? void 0 : (_name$permanentAddres5 = name.permanentAddress) === null || _name$permanentAddres5 === void 0 ? void 0 : _name$permanentAddres5.town) || "",
          erpinNo: (name === null || name === void 0 ? void 0 : (_name$permanentAddres6 = name.permanentAddress) === null || _name$permanentAddres6 === void 0 ? void 0 : _name$permanentAddres6.pinNo) || "",
          eruuid: (name === null || name === void 0 ? void 0 : name.uuid) || ""
        }]);
      },
      selectedOption: selcectedEng,
      t: t
    }), /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "ermobileNumber",
      value: field.ermobileNumber || ermobileNumber,
      onChange: e => setErMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index, e)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "ername",
      value: ername || field.ername,
      onChange: e => setErOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "erregistrationNumber",
      value: erregistrationNumber || field.erregistrationNumber,
      onChange: e => setErRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "eremailId",
      value: eremailId || field.eremailId,
      onChange: e => selectErEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "eraddress",
      value: eraddress || field.eraddress,
      onChange: e => setErAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "erstate",
      value: erstate || field.erstate,
      onChange: e => selectErState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "erdistrict",
      value: erdistrict || field.erdistrict,
      onChange: e => selectErDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "ertehsil",
      value: ertehsil || field.ertehsil,
      onChange: e => selectErTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "ertown",
      value: ertown || field.ertown,
      onChange: e => selectErTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "erpinNo",
      value: erpinNo || field.erpinNo,
      onChange: e => selectErPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const OwnerDetails = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _Digit, _formData$landAreaDet, _formData$landAreaDet2, _formData$landAreaDet3, _formData$landAreaDet4, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo15, _formData$landInfo15$, _formData$landInfo16, _formData$landInfo16$, _formData$landInfo17, _formData$landInfo17$, _formData$landInfo18, _formData$landInfo18$, _formData$landInfo19, _formData$landInfo19$, _formData$landInfo20, _formData$landInfo20$, _formData$landInfo21, _formData$landInfo21$, _formData$landInfo22, _formData$landInfo23, _formData$landInfo24;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  const flow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW");
  const isUD = flow === "UD";
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const tenantId = (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet = formData.landAreaDetails) === null || _formData$landAreaDet === void 0 ? void 0 : _formData$landAreaDet.tenantId) || Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const localName = formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet2 = formData.landAreaDetails) === null || _formData$landAreaDet2 === void 0 ? void 0 : (_formData$landAreaDet3 = _formData$landAreaDet2.locality) === null || _formData$landAreaDet3 === void 0 ? void 0 : (_formData$landAreaDet4 = _formData$landAreaDet3.localname) === null || _formData$landAreaDet4 === void 0 ? void 0 : _formData$landAreaDet4.trim();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategoryList, setOwnershipCategoryList] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [ownershipCategory, setOwnershipCategory] = useState((_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.ownershipCategory);
  const [name, setName] = useState(((_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.name) || "");
  const [guardiaNname, setguardianName] = useState(((_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : _formData$landInfo3$o.fatherOrHusbandName) || ((_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.guardianName) || "");
  const [emailId, setemailId] = useState(((_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : _formData$landInfo5$o.emailId) || "");
  const [aadharNo, setaadharNo] = useState(((_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : _formData$landInfo6$o.aadharNo) || "");
  const [isPrimaryOwner, setisPrimaryOwner] = useState(false);
  const [gender, setGender] = useState((_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : _formData$landInfo7$o.gender);
  const [mobileNumber, setMobileNumber] = useState(((_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : _formData$landInfo8$o.mobileNumber) || "");
  const [corAddress, setCorAddress] = useState(((_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : _formData$landInfo9$o.corrAddress) || "");
  const [permAddress, setPermAddress] = useState(((_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : _formData$landInfo10$.permAddress) || "");
  const [corState, setCorState] = useState(((_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : _formData$landInfo11$.corrState) || "");
  const [permState, setPermState] = useState(((_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : _formData$landInfo12$.permState) || "");
  const [corDistrict, setCorDistrict] = useState(((_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : _formData$landInfo13$.corrDistrict) || "");
  const [permDistrict, setPermDistrict] = useState(((_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : _formData$landInfo14$.permDistrict) || "");
  const [corTehsil, setCorTehsil] = useState(((_formData$landInfo15 = formData.landInfo) === null || _formData$landInfo15 === void 0 ? void 0 : (_formData$landInfo15$ = _formData$landInfo15.owners) === null || _formData$landInfo15$ === void 0 ? void 0 : _formData$landInfo15$.corrTehsil) || "");
  const [permTehsil, setPermTehsil] = useState(((_formData$landInfo16 = formData.landInfo) === null || _formData$landInfo16 === void 0 ? void 0 : (_formData$landInfo16$ = _formData$landInfo16.owners) === null || _formData$landInfo16$ === void 0 ? void 0 : _formData$landInfo16$.permTehsil) || "");
  const [corTown, setCorTown] = useState(((_formData$landInfo17 = formData.landInfo) === null || _formData$landInfo17 === void 0 ? void 0 : (_formData$landInfo17$ = _formData$landInfo17.owners) === null || _formData$landInfo17$ === void 0 ? void 0 : _formData$landInfo17$.corrTown) || "");
  const [permTown, setPermTown] = useState(((_formData$landInfo18 = formData.landInfo) === null || _formData$landInfo18 === void 0 ? void 0 : (_formData$landInfo18$ = _formData$landInfo18.owners) === null || _formData$landInfo18$ === void 0 ? void 0 : _formData$landInfo18$.permTown) || "");
  const [corPinNo, setCorPinNo] = useState(((_formData$landInfo19 = formData.landInfo) === null || _formData$landInfo19 === void 0 ? void 0 : (_formData$landInfo19$ = _formData$landInfo19.owners) === null || _formData$landInfo19$ === void 0 ? void 0 : _formData$landInfo19$.corrPinNo) || "");
  const [permPinNo, setPermPinNo] = useState(((_formData$landInfo20 = formData.landInfo) === null || _formData$landInfo20 === void 0 ? void 0 : (_formData$landInfo20$ = _formData$landInfo20.owners) === null || _formData$landInfo20$ === void 0 ? void 0 : _formData$landInfo20$.permPinNo) || "");
  const [disable, setDisable] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  (_formData$landInfo21 = formData.landInfo) === null || _formData$landInfo21 === void 0 ? void 0 : (_formData$landInfo21$ = _formData$landInfo21.owners) === null || _formData$landInfo21$ === void 0 ? void 0 : _formData$landInfo21$.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const [fields, setFeilds] = useState(((_formData$landInfo22 = formData.landInfo) === null || _formData$landInfo22 === void 0 ? void 0 : _formData$landInfo22.owners) || [{
    isPrimaryOwner: true,
    mobileNumber: null,
    name: "",
    guardianName: "",
    fatherOrHusbandName: "",
    emailId: "",
    aadhaarNumber: ""
  }]);
  const [addressfields, setAddressFeilds] = useState(((_formData$landInfo23 = formData.landInfo) === null || _formData$landInfo23 === void 0 ? void 0 : _formData$landInfo23.permanentaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [corraddressfields, setCorAddressFeilds] = useState(((_formData$landInfo24 = formData.landInfo) === null || _formData$landInfo24 === void 0 ? void 0 : _formData$landInfo24.correspondanceaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [isPermanentSameAsCorrespondence, setIsPermanentSameAsCorrespondence] = useState(false);
  useEffect(() => {
    var flag = 0;
    fields.map(ob => {
      if (ob.isPrimaryOwner) flag = 1;
      if (ob.name && ob.mobileNumber) {
        setCanmovenext(false);
      } else {
        setCanmovenext(true);
      }
    });
    if (!canmovenext && ownershipCategory && !(ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("SINGLEOWNER"))) {
      if (flag == 1) setCanmovenext(false);else setCanmovenext(true);
    }
  }, [fields]);
  useEffect(() => {
    const values = cloneDeep(fields);
    if (ownershipCategory && !ismultiple && (values === null || values === void 0 ? void 0 : values.length) > 1) setFeilds([{
      ...values[0],
      isPrimaryOwner: true
    }]);
  }, [ownershipCategory]);
  const {
    isLoading,
    data: ownerShipCategories
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["OwnerShipCategory"]);
  const {
    data: genderTypeData
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["GenderType"]);
  useEffect(() => {
    var _ownerShipCategories$;
    const ownershipCategoryLists = ownerShipCategories === null || ownerShipCategories === void 0 ? void 0 : (_ownerShipCategories$ = ownerShipCategories["common-masters"]) === null || _ownerShipCategories$ === void 0 ? void 0 : _ownerShipCategories$.OwnerShipCategory;
    if (ownershipCategoryLists && (ownershipCategoryLists === null || ownershipCategoryLists === void 0 ? void 0 : ownershipCategoryLists.length) > 0) {
      const finalOwnershipCategoryList = ownershipCategoryLists.filter(data => {
        var _data$code;
        return data === null || data === void 0 ? void 0 : (_data$code = data.code) === null || _data$code === void 0 ? void 0 : _data$code.includes("INDIVIDUAL");
      });
      finalOwnershipCategoryList.forEach(data => {
        data.i18nKey = `COMMON_MASTERS_OWNERSHIPCATEGORY_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.code, ".", "_")}`;
      });
      setOwnershipCategoryList(finalOwnershipCategoryList);
    }
  }, [ownerShipCategories]);
  useEffect(() => {
    var _genderTypeData$commo;
    const gendeTypeMenu = (genderTypeData === null || genderTypeData === void 0 ? void 0 : (_genderTypeData$commo = genderTypeData["common-masters"]) === null || _genderTypeData$commo === void 0 ? void 0 : _genderTypeData$commo.GenderType) || [];
    if (gendeTypeMenu && (gendeTypeMenu === null || gendeTypeMenu === void 0 ? void 0 : gendeTypeMenu.length) > 0) {
      const genderFilterTypeMenu = gendeTypeMenu.filter(data => data.active);
      genderFilterTypeMenu.forEach(data => {
        data.i18nKey = `COMMON_GENDER_${data.code}`;
      });
      setGenderList(genderFilterTypeMenu);
    }
  }, [genderTypeData]);
  function selectedValue(value) {
    setOwnershipCategory(value);
  }
  function handleAdd() {
    const values = [...fields];
    values.push({
      name: "",
      gender: "",
      mobileNumber: null,
      isPrimaryOwner: false
    });
    setFeilds(values);
    setCanmovenext(true);
  }
  function handleRemove(index) {
    const values = [...fields];
    if (values.length != 1) {
      values.splice(index, 1);
      if (values.length == 1) {
        values[0] = {
          ...values[0],
          isPrimaryOwner: true
        };
      }
      setFeilds(values);
    }
  }
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setGuardianName(i, e) {
    let units = [...fields];
    units[i].guardianName = e.target.value;
    units[i].fatherOrHusbandName = e.target.value;
    setguardianName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectAadhar(i, e) {
    let units = [...fields];
    units[i].aadhaarNumber = e.target.value;
    setaadharNo(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const togglePermanentSameAsCorrespondence = () => {
    setIsPermanentSameAsCorrespondence(!isPermanentSameAsCorrespondence);
    if (!isPermanentSameAsCorrespondence) {
      setAddressFeilds(corraddressfields);
    } else {
      setAddressFeilds([{
        address: "",
        state: "",
        district: "",
        tehsil: "",
        town: "",
        pinno: ""
      }]);
    }
  };
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setPrimaryOwner(i, e) {
    let units = [...fields];
    units.map(units => {
      units.isPrimaryOwner = false;
    });
    units[i].isPrimaryOwner = ismultiple ? e.target.checked : true;
    setisPrimaryOwner(e.target.checked);
    setFeilds(units);
  }
  const [error, setError] = useState(null);
  function setCorrAddress(i, e) {
    let units = [...corraddressfields];
    units[i].address = e.target.value;
    setCorAddress(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermAddress(i, e) {
    let units = [...addressfields];
    units[i].address = e.target.value;
    setPermAddress(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrState(i, e) {
    let units = [...corraddressfields];
    units[i].state = e.target.value;
    setCorState(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermState(i, e) {
    let units = [...addressfields];
    units[i].state = e.target.value;
    setPermState(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrDistrict(i, e) {
    let units = [...corraddressfields];
    units[i].district = e.target.value;
    setCorDistrict(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermDistrict(i, e) {
    let units = [...addressfields];
    units[i].district = e.target.value;
    setPermDistrict(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTehsil(i, e) {
    let units = [...corraddressfields];
    units[i].tehsil = e.target.value;
    setCorTehsil(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTehsil(i, e) {
    let units = [...addressfields];
    units[i].tehsil = e.target.value;
    setPermTehsil(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTown(i, e) {
    let units = [...corraddressfields];
    units[i].town = e.target.value;
    setCorTown(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTown(i, e) {
    let units = [...addressfields];
    units[i].town = e.target.value;
    setPermTown(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrPinNO(i, e) {
    let units = [...corraddressfields];
    units[i].pinno = e.target.value;
    setCorPinNo(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermPinNO(i, e) {
    let units = [...addressfields];
    units[i].pinno = e.target.value;
    setPermPinNo(e.target.value);
    setAddressFeilds(units);
  }
  const closeToast = () => {
    setShowToast(null);
  };
  const getOwnerDetails = async (indexValue, eData) => {
    var _ownersCopy$indexValu, _ownersCopy$indexValu2;
    const ownersCopy = cloneDeep(fields);
    const ownerNo = (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu = ownersCopy[indexValue]) === null || _ownersCopy$indexValu === void 0 ? void 0 : _ownersCopy$indexValu.mobileNumber) || "";
    setShowToast(null);
    if (!ownerNo.match(getPattern("MobileNo"))) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_MOBILE_NUMBER_INCORRECT"
      });
      return;
    }
    if (ownerNo === (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu2 = ownersCopy[indexValue]) === null || _ownersCopy$indexValu2 === void 0 ? void 0 : _ownersCopy$indexValu2.userName)) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED_TOGGLE_MSG"
      });
      return;
    }
    const matchingOwnerIndex = ownersCopy.findIndex(item => item.userName === ownerNo);
    if (matchingOwnerIndex > -1) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED"
      });
      return;
    } else {
      var _fields$indexValue, _usersResponse$user;
      const usersResponse = await Digit.UserService.userSearch(Digit.ULBService.getStateId(), {
        userName: fields === null || fields === void 0 ? void 0 : (_fields$indexValue = fields[indexValue]) === null || _fields$indexValue === void 0 ? void 0 : _fields$indexValue.mobileNumber
      }, {});
      if ((usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "ERR_MOBILE_NUMBER_NOT_REGISTERED"
        });
        setDisable(true);
        return;
      } else {
        var _usersResponse$user2, _values$indexValue, _values$indexValue2, _values$indexValue3, _values$indexValue3$g;
        const userData = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : _usersResponse$user2[0];
        userData.gender = userData.gender ? {
          code: userData.gender,
          active: true,
          i18nKey: `COMMON_GENDER_${userData.gender}`
        } : "";
        if (userData !== null && userData !== void 0 && userData.dob) userData.dob = convertDateToEpoch(userData === null || userData === void 0 ? void 0 : userData.dob);
        if (userData !== null && userData !== void 0 && userData.createdDate) {
          userData.createdDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.createdDate);
          userData.lastModifiedDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.lastModifiedDate);
          userData.pwdExpiryDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.pwdExpiryDate);
        }
        setDisable(false);
        let values = [...ownersCopy];
        if (values[indexValue]) {
          var _fields$indexValue2;
          values[indexValue] = userData;
          values[indexValue].isPrimaryOwner = ((_fields$indexValue2 = fields[indexValue]) === null || _fields$indexValue2 === void 0 ? void 0 : _fields$indexValue2.isPrimaryOwner) || false;
        }
        setFeilds(values);
        setCanmovenext(((_values$indexValue = values[indexValue]) === null || _values$indexValue === void 0 ? void 0 : _values$indexValue.mobileNumber) && ((_values$indexValue2 = values[indexValue]) === null || _values$indexValue2 === void 0 ? void 0 : _values$indexValue2.name) && ((_values$indexValue3 = values[indexValue]) === null || _values$indexValue3 === void 0 ? void 0 : (_values$indexValue3$g = _values$indexValue3.gender) === null || _values$indexValue3$g === void 0 ? void 0 : _values$indexValue3$g.code));
      }
    }
  };
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    setError(null);
    if (ismultiple == true && fields.length == 1) {
      window.scrollTo(0, 0);
      setError("BPA_ERROR_MULTIPLE_OWNER");
    } else {
      let owner = formData.owners;
      let ownerStep = {
        ...owner,
        owners: fields,
        ownershipCategory: ownershipCategory,
        correspondanceaddress: corraddressfields,
        permanentaddress: addressfields
      };
      if (!(formData !== null && formData !== void 0 && formData.id)) {
        var _ownerStep$owners, _formData$landAreaDet5, _formData$landAreaDet6, _userInfo$info, _userInfo$info2;
        setIsDisable(true);
        let conversionOwners = [];
        ownerStep === null || ownerStep === void 0 ? void 0 : (_ownerStep$owners = ownerStep.owners) === null || _ownerStep$owners === void 0 ? void 0 : _ownerStep$owners.map(owner => {
          conversionOwners.push({
            ...owner,
            active: owner.active,
            gender: owner.gender.code,
            tenantId: tenantId
          });
        });
        let payload = {
          ...formData
        };
        if (isUD) {
          payload.businessService = `BPA_UD${localName}_FORM11`.toLocaleUpperCase().trim();
        }
        if (!isUD && (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet5 = formData.landAreaDetails) === null || _formData$landAreaDet5 === void 0 ? void 0 : _formData$landAreaDet5.areaType) === "Special Area") {
          payload.businessService = "BPA_TCPBBNDA_FORM11";
        }
        if (!isUD && (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet6 = formData.landAreaDetails) === null || _formData$landAreaDet6 === void 0 ? void 0 : _formData$landAreaDet6.areaType) !== "Special Area") {
          payload.businessService = "BPA_FORM11";
        }
        payload.applicationType = "FORM_11";
        payload.feeType = "ApplicationFee";
        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
        payload.tenantId = tenantId;
        payload.workflow = {
          action: "INITIATE",
          assignes: [userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.uuid]
        };
        payload.accountId = accountId;
        payload.documents = null;
        payload.landInfo = {};
        payload.landInfo.owners = conversionOwners;
        payload.landInfo.ownershipCategory = ownershipCategory.code;
        payload.landInfo.owners[0].correspondenceAddress = ownerStep.correspondanceaddress[0];
        payload.landInfo.owners[0].permanentAddress = ownerStep.permanentaddress[0];
        payload.landInfo.ownerCorrespondanceAddress = null;
        payload.landInfo.ownerPermanentAddress = null;
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        Digit.OBPSService.createForm11({
          PermissionOfSubdivision: payload
        }, tenantId).then((result, err) => {
          var _result$PermissionOfS;
          if ((result === null || result === void 0 ? void 0 : (_result$PermissionOfS = result.PermissionOfSubdivision) === null || _result$PermissionOfS === void 0 ? void 0 : _result$PermissionOfS.length) > 0) {
            setIsDisable(false);
            onSelect("", result.PermissionOfSubdivision[0], "", true);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setIsDisable(false);
          setShowToast({
            key: "true",
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        onSelect(currStep.key, ownerStep);
      }
    }
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: currStep.step,
    flow: "Form11"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || !ownershipCategory || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, !isLoading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, currStep.tabList.map((tab, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(tab)}`,
    value: `${index + 1}`,
    sx: {
      textTransform: 'none',
      p: '0 1rem !important'
    }
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_TYPE_OF_OWNER_LABEL")} *`), /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: false,
    options: ownershipCategoryList,
    selectedOption: ownershipCategory,
    optionsKey: "i18nKey",
    onSelect: selectedValue,
    value: ownershipCategory,
    labelKey: "PT_OWNERSHIP",
    isDependent: true
  }), fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *` + `${t("(Please click on search icon to check wheather the owner registered or not)")}`), ismultiple && /*#__PURE__*/React__default.createElement(LinkButton, {
      label: /*#__PURE__*/React__default.createElement(DeleteIcon$1, {
        style: {
          float: "right",
          position: "relative",
          bottom: "5px"
        },
        fill: !(fields.length == 1) ? "#494848" : "#FAFAFA"
      }),
      style: {
        width: "100px",
        display: "inline",
        background: "black"
      },
      onClick: e => handleRemove(index)
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_GUARDIAN_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "guardianName",
      value: field.guardianName,
      onChange: e => setGuardianName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "emailId",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_AADHAR_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "number",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "aadhaarNumber",
      value: field.aadhaarNumber,
      onChange: e => selectAadhar(index, e)
    }, validation = {
      isRequired: true,
      pattern: getPattern("AadharNo"),
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), ismultiple && /*#__PURE__*/React__default.createElement(CheckBox$1, {
      label: t("BPA_IS_PRIMARY_OWNER_LABEL"),
      onChange: e => setPrimaryOwner(index, e),
      value: field.isPrimaryOwner,
      checked: field.isPrimaryOwner,
      style: {
        paddingTop: "10px"
      }
    })));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, corraddressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => setCorrAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectCorrState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectCorrDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectCorrTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectCorrTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectCorrPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "3",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$2, {
    control: /*#__PURE__*/React__default.createElement(Checkbox$1, {
      checked: isPermanentSameAsCorrespondence,
      onChange: togglePermanentSameAsCorrespondence,
      color: "primary"
    }),
    label: "Is Same as Correspondence Address?"
  }), addressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => selectPermAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectPermState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectPermDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectPermTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectPermTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectPermPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), ismultiple ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      paddingBottom: "15px",
      color: "#FF8C00"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    style: {
      paddingTop: "10px"
    },
    onClick: () => handleAdd()
  }, t("BPA_ADD_OWNER")))) : null) : /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext,
    disabled: disable
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const OwnerDetails$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _Digit, _Digit$SessionStorage, _formData$landAreaDet, _formData$landAreaDet2, _formData$landAreaDet3, _formData$landAreaDet4, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo8, _formData$landInfo8$o, _formData$landInfo9, _formData$landInfo9$o, _formData$landInfo10, _formData$landInfo10$, _formData$landInfo11, _formData$landInfo11$, _formData$landInfo12, _formData$landInfo12$, _formData$landInfo13, _formData$landInfo13$, _formData$landInfo14, _formData$landInfo14$, _formData$landInfo15, _formData$landInfo15$, _formData$landInfo16, _formData$landInfo16$, _formData$landInfo17, _formData$landInfo17$, _formData$landInfo18, _formData$landInfo18$, _formData$landInfo19, _formData$landInfo19$, _formData$landInfo20, _formData$landInfo20$, _formData$landInfo21, _formData$landInfo21$, _formData$landInfo22, _formData$landInfo23, _formData$landInfo24;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  const homeCity = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.DIST")) === null || _Digit$SessionStorage === void 0 ? void 0 : _Digit$SessionStorage.code;
  const isUD = (homeCity === null || homeCity === void 0 ? void 0 : homeCity.split('.')[1].substring(0, 2)) === 'ud';
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const localName = formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet = formData.landAreaDetails) === null || _formData$landAreaDet === void 0 ? void 0 : (_formData$landAreaDet2 = _formData$landAreaDet.locality) === null || _formData$landAreaDet2 === void 0 ? void 0 : (_formData$landAreaDet3 = _formData$landAreaDet2.localname) === null || _formData$landAreaDet3 === void 0 ? void 0 : _formData$landAreaDet3.trim();
  const [currentTab, setCurrentTab] = useState("1");
  const tenantId = (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet4 = formData.landAreaDetails) === null || _formData$landAreaDet4 === void 0 ? void 0 : _formData$landAreaDet4.tenantId) || Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategoryList, setOwnershipCategoryList] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [ownershipCategory, setOwnershipCategory] = useState((_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : _formData$landInfo$ow.ownershipCategory);
  const [name, setName] = useState(((_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : _formData$landInfo2$o.name) || "");
  const [guardiaNname, setguardianName] = useState(((_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : _formData$landInfo3$o.fatherOrHusbandName) || ((_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : _formData$landInfo4$o.guardiaNname) || "");
  const [emailId, setemailId] = useState(((_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : _formData$landInfo5$o.emailId) || "");
  const [aadharNo, setaadharNo] = useState(((_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : _formData$landInfo6$o.aadharNo) || "");
  const [isPrimaryOwner, setisPrimaryOwner] = useState(false);
  const [gender, setGender] = useState((_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : _formData$landInfo7$o.gender);
  const [mobileNumber, setMobileNumber] = useState(((_formData$landInfo8 = formData.landInfo) === null || _formData$landInfo8 === void 0 ? void 0 : (_formData$landInfo8$o = _formData$landInfo8.owners) === null || _formData$landInfo8$o === void 0 ? void 0 : _formData$landInfo8$o.mobileNumber) || "");
  const [corAddress, setCorAddress] = useState(((_formData$landInfo9 = formData.landInfo) === null || _formData$landInfo9 === void 0 ? void 0 : (_formData$landInfo9$o = _formData$landInfo9.owners) === null || _formData$landInfo9$o === void 0 ? void 0 : _formData$landInfo9$o.corrAddress) || "");
  const [permAddress, setPermAddress] = useState(((_formData$landInfo10 = formData.landInfo) === null || _formData$landInfo10 === void 0 ? void 0 : (_formData$landInfo10$ = _formData$landInfo10.owners) === null || _formData$landInfo10$ === void 0 ? void 0 : _formData$landInfo10$.permAddress) || "");
  const [corState, setCorState] = useState(((_formData$landInfo11 = formData.landInfo) === null || _formData$landInfo11 === void 0 ? void 0 : (_formData$landInfo11$ = _formData$landInfo11.owners) === null || _formData$landInfo11$ === void 0 ? void 0 : _formData$landInfo11$.corrState) || "");
  const [permState, setPermState] = useState(((_formData$landInfo12 = formData.landInfo) === null || _formData$landInfo12 === void 0 ? void 0 : (_formData$landInfo12$ = _formData$landInfo12.owners) === null || _formData$landInfo12$ === void 0 ? void 0 : _formData$landInfo12$.permState) || "");
  const [corDistrict, setCorDistrict] = useState(((_formData$landInfo13 = formData.landInfo) === null || _formData$landInfo13 === void 0 ? void 0 : (_formData$landInfo13$ = _formData$landInfo13.owners) === null || _formData$landInfo13$ === void 0 ? void 0 : _formData$landInfo13$.corrDistrict) || "");
  const [permDistrict, setPermDistrict] = useState(((_formData$landInfo14 = formData.landInfo) === null || _formData$landInfo14 === void 0 ? void 0 : (_formData$landInfo14$ = _formData$landInfo14.owners) === null || _formData$landInfo14$ === void 0 ? void 0 : _formData$landInfo14$.permDistrict) || "");
  const [corTehsil, setCorTehsil] = useState(((_formData$landInfo15 = formData.landInfo) === null || _formData$landInfo15 === void 0 ? void 0 : (_formData$landInfo15$ = _formData$landInfo15.owners) === null || _formData$landInfo15$ === void 0 ? void 0 : _formData$landInfo15$.corrTehsil) || "");
  const [permTehsil, setPermTehsil] = useState(((_formData$landInfo16 = formData.landInfo) === null || _formData$landInfo16 === void 0 ? void 0 : (_formData$landInfo16$ = _formData$landInfo16.owners) === null || _formData$landInfo16$ === void 0 ? void 0 : _formData$landInfo16$.permTehsil) || "");
  const [corTown, setCorTown] = useState(((_formData$landInfo17 = formData.landInfo) === null || _formData$landInfo17 === void 0 ? void 0 : (_formData$landInfo17$ = _formData$landInfo17.owners) === null || _formData$landInfo17$ === void 0 ? void 0 : _formData$landInfo17$.corrTown) || "");
  const [permTown, setPermTown] = useState(((_formData$landInfo18 = formData.landInfo) === null || _formData$landInfo18 === void 0 ? void 0 : (_formData$landInfo18$ = _formData$landInfo18.owners) === null || _formData$landInfo18$ === void 0 ? void 0 : _formData$landInfo18$.permTown) || "");
  const [corPinNo, setCorPinNo] = useState(((_formData$landInfo19 = formData.landInfo) === null || _formData$landInfo19 === void 0 ? void 0 : (_formData$landInfo19$ = _formData$landInfo19.owners) === null || _formData$landInfo19$ === void 0 ? void 0 : _formData$landInfo19$.corrPinNo) || "");
  const [permPinNo, setPermPinNo] = useState(((_formData$landInfo20 = formData.landInfo) === null || _formData$landInfo20 === void 0 ? void 0 : (_formData$landInfo20$ = _formData$landInfo20.owners) === null || _formData$landInfo20$ === void 0 ? void 0 : _formData$landInfo20$.permPinNo) || "");
  const [disable, setDisable] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  (_formData$landInfo21 = formData.landInfo) === null || _formData$landInfo21 === void 0 ? void 0 : (_formData$landInfo21$ = _formData$landInfo21.owners) === null || _formData$landInfo21$ === void 0 ? void 0 : _formData$landInfo21$.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const [fields, setFeilds] = useState(((_formData$landInfo22 = formData.landInfo) === null || _formData$landInfo22 === void 0 ? void 0 : _formData$landInfo22.owners) || [{
    isPrimaryOwner: true,
    mobileNumber: null,
    name: "",
    guardianName: "",
    fatherOrHusbandName: "",
    emailId: "",
    aadhaarNumber: ""
  }]);
  const [addressfields, setAddressFeilds] = useState(((_formData$landInfo23 = formData.landInfo) === null || _formData$landInfo23 === void 0 ? void 0 : _formData$landInfo23.permanentaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [corraddressfields, setCorAddressFeilds] = useState(((_formData$landInfo24 = formData.landInfo) === null || _formData$landInfo24 === void 0 ? void 0 : _formData$landInfo24.correspondanceaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [isPermanentSameAsCorrespondence, setIsPermanentSameAsCorrespondence] = useState(false);
  useEffect(() => {
    var flag = 0;
    fields.map(ob => {
      if (ob.isPrimaryOwner) flag = 1;
      if (ob.name && ob.mobileNumber) {
        setCanmovenext(false);
      } else {
        setCanmovenext(true);
      }
    });
    if (!canmovenext && ownershipCategory && !(ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("SINGLEOWNER"))) {
      if (flag == 1) setCanmovenext(false);else setCanmovenext(true);
    }
  }, [fields]);
  useEffect(() => {
    const values = cloneDeep(fields);
    if (ownershipCategory && !ismultiple && (values === null || values === void 0 ? void 0 : values.length) > 1) setFeilds([{
      ...values[0],
      isPrimaryOwner: true
    }]);
  }, [ownershipCategory]);
  const {
    isLoading,
    data: ownerShipCategories
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["OwnerShipCategory"]);
  const {
    data: genderTypeData
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["GenderType"]);
  useEffect(() => {
    var _ownerShipCategories$;
    const ownershipCategoryLists = ownerShipCategories === null || ownerShipCategories === void 0 ? void 0 : (_ownerShipCategories$ = ownerShipCategories["common-masters"]) === null || _ownerShipCategories$ === void 0 ? void 0 : _ownerShipCategories$.OwnerShipCategory;
    if (ownershipCategoryLists && (ownershipCategoryLists === null || ownershipCategoryLists === void 0 ? void 0 : ownershipCategoryLists.length) > 0) {
      const finalOwnershipCategoryList = ownershipCategoryLists.filter(data => {
        var _data$code;
        return data === null || data === void 0 ? void 0 : (_data$code = data.code) === null || _data$code === void 0 ? void 0 : _data$code.includes("INDIVIDUAL");
      });
      finalOwnershipCategoryList.forEach(data => {
        data.i18nKey = `COMMON_MASTERS_OWNERSHIPCATEGORY_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.code, ".", "_")}`;
      });
      setOwnershipCategoryList(finalOwnershipCategoryList);
    }
  }, [ownerShipCategories]);
  useEffect(() => {
    var _genderTypeData$commo;
    const gendeTypeMenu = (genderTypeData === null || genderTypeData === void 0 ? void 0 : (_genderTypeData$commo = genderTypeData["common-masters"]) === null || _genderTypeData$commo === void 0 ? void 0 : _genderTypeData$commo.GenderType) || [];
    if (gendeTypeMenu && (gendeTypeMenu === null || gendeTypeMenu === void 0 ? void 0 : gendeTypeMenu.length) > 0) {
      const genderFilterTypeMenu = gendeTypeMenu.filter(data => data.active);
      genderFilterTypeMenu.forEach(data => {
        data.i18nKey = `COMMON_GENDER_${data.code}`;
      });
      setGenderList(genderFilterTypeMenu);
    }
  }, [genderTypeData]);
  function selectedValue(value) {
    setOwnershipCategory(value);
  }
  function handleAdd() {
    const values = [...fields];
    values.push({
      name: "",
      gender: "",
      mobileNumber: null,
      isPrimaryOwner: false
    });
    setFeilds(values);
    setCanmovenext(true);
  }
  function handleRemove(index) {
    const values = [...fields];
    if (values.length != 1) {
      values.splice(index, 1);
      if (values.length == 1) {
        values[0] = {
          ...values[0],
          isPrimaryOwner: true
        };
      }
      setFeilds(values);
    }
  }
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setGuardianName(i, e) {
    let units = [...fields];
    units[i].guardianName = e.target.value;
    units[i].fatherOrHusbandName = e.target.value;
    setguardianName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectAadhar(i, e) {
    let units = [...fields];
    units[i].aadhaarNumber = e.target.value;
    setaadharNo(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const togglePermanentSameAsCorrespondence = () => {
    setIsPermanentSameAsCorrespondence(!isPermanentSameAsCorrespondence);
    if (!isPermanentSameAsCorrespondence) {
      setAddressFeilds(corraddressfields);
    } else {
      setAddressFeilds([{
        address: "",
        state: "",
        district: "",
        tehsil: "",
        town: "",
        pinno: ""
      }]);
    }
  };
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setPrimaryOwner(i, e) {
    let units = [...fields];
    units.map(units => {
      units.isPrimaryOwner = false;
    });
    units[i].isPrimaryOwner = ismultiple ? e.target.checked : true;
    setisPrimaryOwner(e.target.checked);
    setFeilds(units);
  }
  const [error, setError] = useState(null);
  function setCorrAddress(i, e) {
    let units = [...corraddressfields];
    units[i].address = e.target.value;
    setCorAddress(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermAddress(i, e) {
    let units = [...addressfields];
    units[i].address = e.target.value;
    setPermAddress(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrState(i, e) {
    let units = [...corraddressfields];
    units[i].state = e.target.value;
    setCorState(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermState(i, e) {
    let units = [...addressfields];
    units[i].state = e.target.value;
    setPermState(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrDistrict(i, e) {
    let units = [...corraddressfields];
    units[i].district = e.target.value;
    setCorDistrict(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermDistrict(i, e) {
    let units = [...addressfields];
    units[i].district = e.target.value;
    setPermDistrict(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTehsil(i, e) {
    let units = [...corraddressfields];
    units[i].tehsil = e.target.value;
    setCorTehsil(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTehsil(i, e) {
    let units = [...addressfields];
    units[i].tehsil = e.target.value;
    setPermTehsil(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTown(i, e) {
    let units = [...corraddressfields];
    units[i].town = e.target.value;
    setCorTown(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTown(i, e) {
    let units = [...addressfields];
    units[i].town = e.target.value;
    setPermTown(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrPinNO(i, e) {
    let units = [...corraddressfields];
    units[i].pinno = e.target.value;
    setCorPinNo(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermPinNO(i, e) {
    let units = [...addressfields];
    units[i].pinno = e.target.value;
    setPermPinNo(e.target.value);
    setAddressFeilds(units);
  }
  const closeToast = () => {
    setShowToast(null);
  };
  const getOwnerDetails = async (indexValue, eData) => {
    var _ownersCopy$indexValu, _ownersCopy$indexValu2;
    const ownersCopy = cloneDeep(fields);
    const ownerNo = (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu = ownersCopy[indexValue]) === null || _ownersCopy$indexValu === void 0 ? void 0 : _ownersCopy$indexValu.mobileNumber) || "";
    setShowToast(null);
    if (!ownerNo.match(getPattern("MobileNo"))) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_MOBILE_NUMBER_INCORRECT"
      });
      return;
    }
    if (ownerNo === (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu2 = ownersCopy[indexValue]) === null || _ownersCopy$indexValu2 === void 0 ? void 0 : _ownersCopy$indexValu2.userName)) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED_TOGGLE_MSG"
      });
      return;
    }
    const matchingOwnerIndex = ownersCopy.findIndex(item => item.userName === ownerNo);
    if (matchingOwnerIndex > -1) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED"
      });
      return;
    } else {
      var _fields$indexValue, _usersResponse$user;
      const usersResponse = await Digit.UserService.userSearch(Digit.ULBService.getStateId(), {
        userName: fields === null || fields === void 0 ? void 0 : (_fields$indexValue = fields[indexValue]) === null || _fields$indexValue === void 0 ? void 0 : _fields$indexValue.mobileNumber
      }, {});
      if ((usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "ERR_MOBILE_NUMBER_NOT_REGISTERED"
        });
        setDisable(true);
        return;
      } else {
        var _usersResponse$user2, _values$indexValue, _values$indexValue2, _values$indexValue3, _values$indexValue3$g;
        const userData = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : _usersResponse$user2[0];
        userData.gender = userData.gender ? {
          code: userData.gender,
          active: true,
          i18nKey: `COMMON_GENDER_${userData.gender}`
        } : "";
        if (userData !== null && userData !== void 0 && userData.dob) userData.dob = convertDateToEpoch(userData === null || userData === void 0 ? void 0 : userData.dob);
        if (userData !== null && userData !== void 0 && userData.createdDate) {
          userData.createdDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.createdDate);
          userData.lastModifiedDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.lastModifiedDate);
          userData.pwdExpiryDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.pwdExpiryDate);
        }
        setDisable(false);
        let values = [...ownersCopy];
        if (values[indexValue]) {
          var _fields$indexValue2;
          values[indexValue] = userData;
          values[indexValue].isPrimaryOwner = ((_fields$indexValue2 = fields[indexValue]) === null || _fields$indexValue2 === void 0 ? void 0 : _fields$indexValue2.isPrimaryOwner) || false;
        }
        setFeilds(values);
        setCanmovenext(((_values$indexValue = values[indexValue]) === null || _values$indexValue === void 0 ? void 0 : _values$indexValue.mobileNumber) && ((_values$indexValue2 = values[indexValue]) === null || _values$indexValue2 === void 0 ? void 0 : _values$indexValue2.name) && ((_values$indexValue3 = values[indexValue]) === null || _values$indexValue3 === void 0 ? void 0 : (_values$indexValue3$g = _values$indexValue3.gender) === null || _values$indexValue3$g === void 0 ? void 0 : _values$indexValue3$g.code));
      }
    }
  };
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    setError(null);
    if (ismultiple == true && fields.length == 1) {
      window.scrollTo(0, 0);
      setError("BPA_ERROR_MULTIPLE_OWNER");
    } else {
      let owner = formData.owners;
      let ownerStep = {
        ...owner,
        owners: fields,
        ownershipCategory: ownershipCategory,
        correspondanceaddress: corraddressfields,
        permanentaddress: addressfields
      };
      if (!(formData !== null && formData !== void 0 && formData.id)) {
        var _ownerStep$owners, _formData$landAreaDet5, _formData$landAreaDet6, _userInfo$info, _userInfo$info2;
        setIsDisable(true);
        let conversionOwners = [];
        ownerStep === null || ownerStep === void 0 ? void 0 : (_ownerStep$owners = ownerStep.owners) === null || _ownerStep$owners === void 0 ? void 0 : _ownerStep$owners.map(owner => {
          conversionOwners.push({
            ...owner,
            active: owner.active,
            gender: owner.gender.code,
            tenantId: tenantId
          });
        });
        let payload = {
          ...formData
        };
        if (isUD) {
          payload.businessService = `BPA_UD${localName}_FORM26`.toLocaleUpperCase().trim();
        }
        if (!isUD && (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet5 = formData.landAreaDetails) === null || _formData$landAreaDet5 === void 0 ? void 0 : _formData$landAreaDet5.areaType) === "Special Area") {
          payload.businessService = "BPA_TCPBBNDA_FORM26";
        }
        if (!isUD && (formData === null || formData === void 0 ? void 0 : (_formData$landAreaDet6 = formData.landAreaDetails) === null || _formData$landAreaDet6 === void 0 ? void 0 : _formData$landAreaDet6.areaType) !== "Special Area") {
          payload.businessService = "BPA_FORM26";
        }
        payload.applicationType = "FORM_26";
        payload.feeType = "ApplicationFee";
        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
        payload.tenantId = tenantId;
        payload.workflow = {
          action: "INITIATE",
          assignes: [userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.uuid]
        };
        payload.accountId = accountId;
        payload.documents = null;
        payload.landInfo = {};
        payload.landInfo.owners = conversionOwners;
        payload.landInfo.ownershipCategory = ownershipCategory.code;
        payload.landInfo.owners[0].correspondenceAddress = ownerStep.correspondanceaddress[0];
        payload.landInfo.owners[0].permanentAddress = ownerStep.permanentaddress[0];
        payload.landInfo.ownerCorrespondanceAddress = null;
        payload.landInfo.ownerPermanentAddress = null;
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        Digit.OBPSService.createForm11({
          PermissionOfSubdivision: payload
        }, tenantId).then((result, err) => {
          var _result$PermissionOfS;
          if ((result === null || result === void 0 ? void 0 : (_result$PermissionOfS = result.PermissionOfSubdivision) === null || _result$PermissionOfS === void 0 ? void 0 : _result$PermissionOfS.length) > 0) {
            setIsDisable(false);
            onSelect("", result.PermissionOfSubdivision[0], "", true);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setIsDisable(false);
          setShowToast({
            key: "true",
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        onSelect(currStep.key, ownerStep);
      }
    }
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: currStep.step,
    flow: "Form26"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || !ownershipCategory || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, !isLoading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, currStep.tabList.map((tab, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(tab)}`,
    value: `${index + 1}`,
    sx: {
      textTransform: 'none',
      p: '0 1rem !important'
    }
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_TYPE_OF_OWNER_LABEL")} *`), /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: false,
    options: ownershipCategoryList,
    selectedOption: ownershipCategory,
    optionsKey: "i18nKey",
    onSelect: selectedValue,
    value: ownershipCategory,
    labelKey: "PT_OWNERSHIP",
    isDependent: true
  }), fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *` + `${t("(Please click on search icon to check wheather the owner registered or not)")}`), ismultiple && /*#__PURE__*/React__default.createElement(LinkButton, {
      label: /*#__PURE__*/React__default.createElement(DeleteIcon$1, {
        style: {
          float: "right",
          position: "relative",
          bottom: "5px"
        },
        fill: !(fields.length == 1) ? "#494848" : "#FAFAFA"
      }),
      style: {
        width: "100px",
        display: "inline",
        background: "black"
      },
      onClick: e => handleRemove(index)
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_GUARDIAN_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "guardianName",
      value: field.guardianName,
      onChange: e => setGuardianName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "emailId",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_AADHAR_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "number",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "aadhaarNumber",
      value: field.aadhaarNumber,
      onChange: e => selectAadhar(index, e)
    }, validation = {
      isRequired: true,
      pattern: getPattern("AadharNo"),
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), ismultiple && /*#__PURE__*/React__default.createElement(CheckBox$1, {
      label: t("BPA_IS_PRIMARY_OWNER_LABEL"),
      onChange: e => setPrimaryOwner(index, e),
      value: field.isPrimaryOwner,
      checked: field.isPrimaryOwner,
      style: {
        paddingTop: "10px"
      }
    })));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, corraddressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => setCorrAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectCorrState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectCorrDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectCorrTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectCorrTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectCorrPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "3",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$2, {
    control: /*#__PURE__*/React__default.createElement(Checkbox$1, {
      checked: isPermanentSameAsCorrespondence,
      onChange: togglePermanentSameAsCorrespondence,
      color: "primary"
    }),
    label: "Is Same as Correspondence Address?"
  }), addressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => selectPermAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectPermState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectPermDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectPermTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectPermTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectPermPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), ismultiple ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      paddingBottom: "15px",
      color: "#FF8C00"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    style: {
      paddingTop: "10px"
    },
    onClick: () => handleAdd()
  }, t("BPA_ADD_OWNER")))) : null) : /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext,
    disabled: disable
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const DocumentDetails = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$uiFlow;
  const stateId = Digit.ULBService.getStateId();
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || [];
  const docsArray = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  const [documents, setDocuments] = useState(docsArray);
  const [error, setError] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const checkingFlow = formData === null || formData === void 0 ? void 0 : (_formData$uiFlow = formData.uiFlow) === null || _formData$uiFlow === void 0 ? void 0 : _formData$uiFlow.flow;
  const beforeUploadDocuments = cloneDeep((formData === null || formData === void 0 ? void 0 : formData.PrevStateDocuments) || []);
  const {
    data: bpaTaxDocuments,
    isLoading
  } = Digit.Hooks.obps.useBPATaxDocuments(stateId, formData, beforeUploadDocuments || []);
  const handleSubmit = () => {
    let document = formData.documents;
    let RealignedDocument = [];
    bpaTaxDocuments && bpaTaxDocuments.map(ob => {
      documents && (documents === null || documents === void 0 ? void 0 : documents.filter(x => ob.code === x.documentType).map(doc => {
        RealignedDocument.push(doc);
      }));
    });
    const documentStep = {
      ...document,
      documents: RealignedDocument
    };
    onSelect(currStep.key, [...documentStep.documents]);
  };
  const onSkip = () => onSelect();
  function onAdd() {}
  useEffect(() => {
    const allRequiredDocumentsCode = bpaTaxDocuments.filter(e => e.required).map(e => e.code);
    const reqDocumentEntered = allRequiredDocumentsCode.filter(reqCode => documents.reduce((acc, doc) => {
      var _doc$documentType, _doc$documentType$spl, _doc$documentType2, _doc$documentType2$sp;
      if (reqCode == `${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : (_doc$documentType$spl = _doc$documentType.split('.')) === null || _doc$documentType$spl === void 0 ? void 0 : _doc$documentType$spl[0]}.${doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : (_doc$documentType2$sp = _doc$documentType2.split('.')) === null || _doc$documentType2$sp === void 0 ? void 0 : _doc$documentType2$sp[1]}`) {
        return true;
      } else {
        return acc;
      }
    }, false));
    if (reqDocumentEntered.length == allRequiredDocumentsCode.length && documents.length > 0) {
      setEnableSubmit(false);
    } else {
      setEnableSubmit(false);
    }
  }, [documents, checkRequiredFields]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: checkingFlow === "OCBPA" ? 3 : currStep.step,
    flow: checkingFlow === "OCBPA" ? "OCBPA" : checkingFlow === "Form11" ? checkingFlow : "BPA"
  }), !isLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: currStep,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: ["editApplication", "sendbacktocitizen"].includes(window.location.href) ? false : enableSubmit,
    onAdd: onAdd,
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "600px",
        minWidth: "280px",
        marginBottom: "15px",
        paddingTop: "15px"
      }
    }, /*#__PURE__*/React__default.createElement(SelectDocument$1, {
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      formData: formData,
      beforeUploadDocuments: beforeUploadDocuments || []
    }));
  }), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    onClose: () => setError(null),
    error: true
  })) : /*#__PURE__*/React__default.createElement(Loader, null), ["/bpa/building_plan_scrutiny/new_construction", "/ocbpa/building_oc_plan_scrutiny/new_construction"].includes(window.location.href) && formData !== null && formData !== void 0 && formData.applicationNo ? /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
    style: {
      margin: "20px auto 0"
    },
    info: t("CS_FILE_APPLICATION_INFO_LABEL"),
    text: `${t("BPA_APPLICATION_NUMBER_LABEL")} ${formData === null || formData === void 0 ? void 0 : formData.applicationNo} ${t("BPA_DOCS_INFORMATION")}`,
    className: "info-banner-wrap-citizen-override"
  }) : "");
};
const SelectDocument$1 = React__default.memo(function MyComponent({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  formData,
  beforeUploadDocuments
}) {
  var _doc$dropdownData, _formData$documents, _doc$uploadedDocument;
  const filteredDocument = (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]) || (beforeUploadDocuments === null || beforeUploadDocuments === void 0 ? void 0 : beforeUploadDocuments.filter(item => {
    var _item$documentType2;
    return item === null || item === void 0 ? void 0 : (_item$documentType2 = item.documentType) === null || _item$documentType2 === void 0 ? void 0 : _item$documentType2.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) > 0 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType3;
    return item === null || item === void 0 ? void 0 : (_item$documentType3 = item.documentType) === null || _item$documentType3 === void 0 ? void 0 : _item$documentType3.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  }).map(e => ({
    fileStoreId: e === null || e === void 0 ? void 0 : e.fileStoreId,
    fileName: (e === null || e === void 0 ? void 0 : e.fileName) || ""
  }))) || null);
  const [newArray, setnewArray] = useState([]);
  const [uploadedfileArray, setuploadedfileArray] = useState([]);
  const [fileArray, setfileArray] = useState([] || (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(ob => ob.documentType === selectedDocument.code)));
  const handleSelectDocument = value => {
    if (filteredDocument !== null && filteredDocument !== void 0 && filteredDocument.documentType) {
      filteredDocument.documentType = value === null || value === void 0 ? void 0 : value.code;
      let currDocs = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType4;
        return item === null || item === void 0 ? void 0 : (_item$documentType4 = item.documentType) === null || _item$documentType4 === void 0 ? void 0 : _item$documentType4.includes(doc === null || doc === void 0 ? void 0 : doc.code);
      });
      currDocs.map(doc => doc.documentType = value === null || value === void 0 ? void 0 : value.code);
      let newDoc = [...(documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType5;
        return !(item !== null && item !== void 0 && (_item$documentType5 = item.documentType) !== null && _item$documentType5 !== void 0 && _item$documentType5.includes(doc === null || doc === void 0 ? void 0 : doc.code));
      })), ...currDocs];
      setDocuments(newDoc);
    }
    setSelectedDocument(value);
  };
  function selectfile(e, key) {
    e && setFile(e.file);
    e && setfileArray([...fileArray, e.file]);
  }
  function getData(e) {
    var _newArr;
    let key = selectedDocument.code;
    let data, newArr;
    if ((e === null || e === void 0 ? void 0 : e.length) > 0) {
      var _formData$documents2;
      data = Object.fromEntries(e);
      newArr = Object.values(data);
      newArr = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(ob => ob.documentType === selectedDocument.code);
      setnewArray(newArr);
      let newfiles = [];
      e === null || e === void 0 ? void 0 : e.map((doc, index) => {
        var _doc$, _doc$$fileStoreId, _doc$1$fileStoreId, _documents$find;
        newfiles.push({
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          additionalDetails: {
            category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
          },
          fileStoreId: doc === null || doc === void 0 ? void 0 : (_doc$ = doc[1]) === null || _doc$ === void 0 ? void 0 : (_doc$$fileStoreId = _doc$.fileStoreId) === null || _doc$$fileStoreId === void 0 ? void 0 : _doc$$fileStoreId.fileStoreId,
          documentUid: doc === null || doc === void 0 ? void 0 : (_doc$1$fileStoreId = doc[1].fileStoreId) === null || _doc$1$fileStoreId === void 0 ? void 0 : _doc$1$fileStoreId.fileStoreId,
          fileName: (doc === null || doc === void 0 ? void 0 : doc[0]) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        });
      });
      const __documents = [...(documents === null || documents === void 0 ? void 0 : documents.filter(e => e.documentType !== key)), ...newfiles];
      setDocuments(__documents);
    } else if ((e === null || e === void 0 ? void 0 : e.length) == 0) {
      const __documents = [...(documents === null || documents === void 0 ? void 0 : documents.filter(e => e.documentType !== key))];
      setDocuments(__documents);
    }
    (_newArr = newArr) === null || _newArr === void 0 ? void 0 : _newArr.map(ob => {
      if (!(ob !== null && ob !== void 0 && ob.file)) {
        ob.file = {};
      }
      ob.file.documentType = key;
      selectfile(ob);
    });
  }
  function setcodeafterupload() {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        let newfiles = [];
        uploadedfileArray && uploadedfileArray.map((doc, index) => {
          var _fileArray$index, _documents$find2;
          newfiles.push({
            documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
            fileStoreId: doc.fileStoreId,
            additionalDetails: {
              category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
            },
            documentUid: doc.fileStoreId,
            fileName: ((_fileArray$index = fileArray[index]) === null || _fileArray$index === void 0 ? void 0 : _fileArray$index.name) || "",
            id: documents ? (_documents$find2 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find2 === void 0 ? void 0 : _documents$find2.id : undefined
          });
        });
        return [...filteredDocumentsByFileStoreId, ...newfiles];
      });
      setuploadedfileArray([]);
    }
  }
  useEffect(() => {
    uploadedfileArray.length > 0 && setcodeafterupload();
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find3;
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          if ((prev === null || prev === void 0 ? void 0 : prev.length) > 0) {
            prev === null || prev === void 0 ? void 0 : prev.forEach(data => {
              var _data$documentType, _data$documentType2, _selectedDocument$cod, _selectedDocument$cod2;
              const normalDocumentType = `${data === null || data === void 0 ? void 0 : (_data$documentType = data.documentType) === null || _data$documentType === void 0 ? void 0 : _data$documentType.split('.')[0]}.${data === null || data === void 0 ? void 0 : (_data$documentType2 = data.documentType) === null || _data$documentType2 === void 0 ? void 0 : _data$documentType2.split('.')[1]}`;
              const selectedDocumentType = `${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod = selectedDocument.code) === null || _selectedDocument$cod === void 0 ? void 0 : _selectedDocument$cod.split('.')[0]}.${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod2 = selectedDocument.code) === null || _selectedDocument$cod2 === void 0 ? void 0 : _selectedDocument$cod2.split('.')[1]}`;
              if (normalDocumentType == selectedDocumentType) {
                var _data$file;
                if (data !== null && data !== void 0 && data.documentType) data.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
                if (data !== null && data !== void 0 && (_data$file = data.file) !== null && _data$file !== void 0 && _data$file.documentType) data.file.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
              }
            });
          }
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile.fileStoreId,
          documentUid: uploadedFile.fileStoreId,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || uploadedFile.fileName || "document",
          id: documents ? (_documents$find3 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find3 === void 0 ? void 0 : _documents$find3.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    if (!selectedDocument.code && uploadedFile !== null) setuploadedfileArray([...uploadedfileArray, uploadedFile]);
  }, [uploadedFile]);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  const uploadedFilesPreFill = useMemo(() => {
    var _formData$documents3, _formData$documents3$;
    let selectedUplDocs = [];
    formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.documents) === null || _formData$documents3$ === void 0 ? void 0 : _formData$documents3$.filter(ob => ob.documentType === selectedDocument.code).forEach(e => selectedUplDocs.push([e.fileName, {
      file: {
        name: e.fileName,
        type: e.documentType
      },
      fileStoreId: {
        fileStoreId: e.fileStoreId,
        tenantId
      }
    }]));
    return selectedUplDocs;
  }, [formData]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)} *` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    t: t,
    isMandatory: false,
    option: Digit.Utils.locale.sortDropdownNames(doc === null || doc === void 0 ? void 0 : doc.dropdownData, 'i18nKey', t),
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument
  }), /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: getData,
    setuploadedstate: uploadedFilesPreFill,
    t: t,
    extraStyleName: "OBPS",
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    isSendBackFlow: true,
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments
  }));
});

const DocumentDetails$1 = ({
  t,
  onSelect,
  formData,
  currStep
}) => {
  var _formData$uiFlow;
  const stateId = Digit.ULBService.getStateId();
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || [];
  const docsArray = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  const [documents, setDocuments] = useState(docsArray);
  const [error, setError] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const checkingFlow = formData === null || formData === void 0 ? void 0 : (_formData$uiFlow = formData.uiFlow) === null || _formData$uiFlow === void 0 ? void 0 : _formData$uiFlow.flow;
  const beforeUploadDocuments = cloneDeep((formData === null || formData === void 0 ? void 0 : formData.PrevStateDocuments) || []);
  const {
    data: bpaTaxDocuments,
    isLoading
  } = Digit.Hooks.obps.useBPATaxDocuments(stateId, formData, beforeUploadDocuments || []);
  const handleSubmit = () => {
    let document = formData.documents;
    let RealignedDocument = [];
    bpaTaxDocuments && bpaTaxDocuments.map(ob => {
      documents && (documents === null || documents === void 0 ? void 0 : documents.filter(x => ob.code === x.documentType).map(doc => {
        RealignedDocument.push(doc);
      }));
    });
    const documentStep = {
      ...document,
      documents: RealignedDocument
    };
    onSelect(currStep.key, [...documentStep.documents]);
  };
  const onSkip = () => onSelect();
  function onAdd() {}
  useEffect(() => {
    const allRequiredDocumentsCode = bpaTaxDocuments.filter(e => e.required).map(e => e.code);
    const reqDocumentEntered = allRequiredDocumentsCode.filter(reqCode => documents.reduce((acc, doc) => {
      var _doc$documentType, _doc$documentType$spl, _doc$documentType2, _doc$documentType2$sp;
      if (reqCode == `${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : (_doc$documentType$spl = _doc$documentType.split('.')) === null || _doc$documentType$spl === void 0 ? void 0 : _doc$documentType$spl[0]}.${doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : (_doc$documentType2$sp = _doc$documentType2.split('.')) === null || _doc$documentType2$sp === void 0 ? void 0 : _doc$documentType2$sp[1]}`) {
        return true;
      } else {
        return acc;
      }
    }, false));
    if (reqDocumentEntered.length == allRequiredDocumentsCode.length && documents.length > 0) {
      setEnableSubmit(false);
    } else {
      setEnableSubmit(false);
    }
  }, [documents, checkRequiredFields]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: checkingFlow === "OCBPA" ? 3 : currStep.step,
    flow: checkingFlow === "OCBPA" ? "OCBPA" : checkingFlow === "Form26" ? checkingFlow : "BPA"
  }), !isLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: currStep,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: ["editApplication", "sendbacktocitizen"].includes(window.location.href) ? false : enableSubmit,
    onAdd: onAdd,
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "600px",
        minWidth: "280px",
        marginBottom: "15px",
        paddingTop: "15px"
      }
    }, /*#__PURE__*/React__default.createElement(SelectDocument$2, {
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      formData: formData,
      beforeUploadDocuments: beforeUploadDocuments || []
    }));
  }), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    onClose: () => setError(null),
    error: true
  })) : /*#__PURE__*/React__default.createElement(Loader, null), ["/bpa/building_plan_scrutiny/new_construction", "/ocbpa/building_oc_plan_scrutiny/new_construction"].includes(window.location.href) && formData !== null && formData !== void 0 && formData.applicationNo ? /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
    style: {
      margin: "20px auto 0"
    },
    info: t("CS_FILE_APPLICATION_INFO_LABEL"),
    text: `${t("BPA_APPLICATION_NUMBER_LABEL")} ${formData === null || formData === void 0 ? void 0 : formData.applicationNo} ${t("BPA_DOCS_INFORMATION")}`,
    className: "info-banner-wrap-citizen-override"
  }) : "");
};
const SelectDocument$2 = React__default.memo(function MyComponent({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  formData,
  beforeUploadDocuments
}) {
  var _doc$dropdownData, _formData$documents, _doc$uploadedDocument;
  const filteredDocument = (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]) || (beforeUploadDocuments === null || beforeUploadDocuments === void 0 ? void 0 : beforeUploadDocuments.filter(item => {
    var _item$documentType2;
    return item === null || item === void 0 ? void 0 : (_item$documentType2 = item.documentType) === null || _item$documentType2 === void 0 ? void 0 : _item$documentType2.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) > 0 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType3;
    return item === null || item === void 0 ? void 0 : (_item$documentType3 = item.documentType) === null || _item$documentType3 === void 0 ? void 0 : _item$documentType3.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  }).map(e => ({
    fileStoreId: e === null || e === void 0 ? void 0 : e.fileStoreId,
    fileName: (e === null || e === void 0 ? void 0 : e.fileName) || ""
  }))) || null);
  const [newArray, setnewArray] = useState([]);
  const [uploadedfileArray, setuploadedfileArray] = useState([]);
  const [fileArray, setfileArray] = useState([] || (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.filter(ob => ob.documentType === selectedDocument.code)));
  const handleSelectDocument = value => {
    if (filteredDocument !== null && filteredDocument !== void 0 && filteredDocument.documentType) {
      filteredDocument.documentType = value === null || value === void 0 ? void 0 : value.code;
      let currDocs = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType4;
        return item === null || item === void 0 ? void 0 : (_item$documentType4 = item.documentType) === null || _item$documentType4 === void 0 ? void 0 : _item$documentType4.includes(doc === null || doc === void 0 ? void 0 : doc.code);
      });
      currDocs.map(doc => doc.documentType = value === null || value === void 0 ? void 0 : value.code);
      let newDoc = [...(documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType5;
        return !(item !== null && item !== void 0 && (_item$documentType5 = item.documentType) !== null && _item$documentType5 !== void 0 && _item$documentType5.includes(doc === null || doc === void 0 ? void 0 : doc.code));
      })), ...currDocs];
      setDocuments(newDoc);
    }
    setSelectedDocument(value);
  };
  function selectfile(e, key) {
    e && setFile(e.file);
    e && setfileArray([...fileArray, e.file]);
  }
  function getData(e) {
    var _newArr;
    let key = selectedDocument.code;
    let data, newArr;
    if ((e === null || e === void 0 ? void 0 : e.length) > 0) {
      var _formData$documents2;
      data = Object.fromEntries(e);
      newArr = Object.values(data);
      newArr = formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.filter(ob => ob.documentType === selectedDocument.code);
      setnewArray(newArr);
      let newfiles = [];
      e === null || e === void 0 ? void 0 : e.map((doc, index) => {
        var _doc$, _doc$$fileStoreId, _doc$1$fileStoreId, _documents$find;
        newfiles.push({
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          additionalDetails: {
            category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
          },
          fileStoreId: doc === null || doc === void 0 ? void 0 : (_doc$ = doc[1]) === null || _doc$ === void 0 ? void 0 : (_doc$$fileStoreId = _doc$.fileStoreId) === null || _doc$$fileStoreId === void 0 ? void 0 : _doc$$fileStoreId.fileStoreId,
          documentUid: doc === null || doc === void 0 ? void 0 : (_doc$1$fileStoreId = doc[1].fileStoreId) === null || _doc$1$fileStoreId === void 0 ? void 0 : _doc$1$fileStoreId.fileStoreId,
          fileName: (doc === null || doc === void 0 ? void 0 : doc[0]) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        });
      });
      const __documents = [...(documents === null || documents === void 0 ? void 0 : documents.filter(e => e.documentType !== key)), ...newfiles];
      setDocuments(__documents);
    } else if ((e === null || e === void 0 ? void 0 : e.length) == 0) {
      const __documents = [...(documents === null || documents === void 0 ? void 0 : documents.filter(e => e.documentType !== key))];
      setDocuments(__documents);
    }
    (_newArr = newArr) === null || _newArr === void 0 ? void 0 : _newArr.map(ob => {
      if (!(ob !== null && ob !== void 0 && ob.file)) {
        ob.file = {};
      }
      ob.file.documentType = key;
      selectfile(ob);
    });
  }
  function setcodeafterupload() {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        let newfiles = [];
        uploadedfileArray && uploadedfileArray.map((doc, index) => {
          var _fileArray$index, _documents$find2;
          newfiles.push({
            documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
            fileStoreId: doc.fileStoreId,
            additionalDetails: {
              category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
            },
            documentUid: doc.fileStoreId,
            fileName: ((_fileArray$index = fileArray[index]) === null || _fileArray$index === void 0 ? void 0 : _fileArray$index.name) || "",
            id: documents ? (_documents$find2 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find2 === void 0 ? void 0 : _documents$find2.id : undefined
          });
        });
        return [...filteredDocumentsByFileStoreId, ...newfiles];
      });
      setuploadedfileArray([]);
    }
  }
  useEffect(() => {
    uploadedfileArray.length > 0 && setcodeafterupload();
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find3;
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          if ((prev === null || prev === void 0 ? void 0 : prev.length) > 0) {
            prev === null || prev === void 0 ? void 0 : prev.forEach(data => {
              var _data$documentType, _data$documentType2, _selectedDocument$cod, _selectedDocument$cod2;
              const normalDocumentType = `${data === null || data === void 0 ? void 0 : (_data$documentType = data.documentType) === null || _data$documentType === void 0 ? void 0 : _data$documentType.split('.')[0]}.${data === null || data === void 0 ? void 0 : (_data$documentType2 = data.documentType) === null || _data$documentType2 === void 0 ? void 0 : _data$documentType2.split('.')[1]}`;
              const selectedDocumentType = `${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod = selectedDocument.code) === null || _selectedDocument$cod === void 0 ? void 0 : _selectedDocument$cod.split('.')[0]}.${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod2 = selectedDocument.code) === null || _selectedDocument$cod2 === void 0 ? void 0 : _selectedDocument$cod2.split('.')[1]}`;
              if (normalDocumentType == selectedDocumentType) {
                var _data$file;
                if (data !== null && data !== void 0 && data.documentType) data.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
                if (data !== null && data !== void 0 && (_data$file = data.file) !== null && _data$file !== void 0 && _data$file.documentType) data.file.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
              }
            });
          }
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile.fileStoreId,
          documentUid: uploadedFile.fileStoreId,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || uploadedFile.fileName || "document",
          id: documents ? (_documents$find3 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find3 === void 0 ? void 0 : _documents$find3.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    if (!selectedDocument.code && uploadedFile !== null) setuploadedfileArray([...uploadedfileArray, uploadedFile]);
  }, [uploadedFile]);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  const uploadedFilesPreFill = useMemo(() => {
    var _formData$documents3, _formData$documents3$;
    let selectedUplDocs = [];
    formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.documents) === null || _formData$documents3$ === void 0 ? void 0 : _formData$documents3$.filter(ob => ob.documentType === selectedDocument.code).forEach(e => selectedUplDocs.push([e.fileName, {
      file: {
        name: e.fileName,
        type: e.documentType
      },
      fileStoreId: {
        fileStoreId: e.fileStoreId,
        tenantId
      }
    }]));
    return selectedUplDocs;
  }, [formData]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)} *` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    t: t,
    isMandatory: false,
    option: Digit.Utils.locale.sortDropdownNames(doc === null || doc === void 0 ? void 0 : doc.dropdownData, 'i18nKey', t),
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument
  }), /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: getData,
    setuploadedstate: uploadedFilesPreFill,
    t: t,
    extraStyleName: "OBPS",
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    isSendBackFlow: true,
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments
  }));
});

const DocsRequired = ({
  onSelect,
  onSkip,
  config
}) => {
  var _userInfo$info, _docsList$;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateCode = Digit.ULBService.getStateId();
  const history = useHistory();
  const {
    applicationType: applicationType,
    serviceType: serviceType
  } = useParams();
  const [docsList, setDocsList] = useState([]);
  const [uiFlow, setUiFlow] = useState([]);
  const {
    data,
    isLoading
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", "DocumentTypes");
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateCode, "common-masters", ["DocumentType"]);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["RiskTypeComputation"]);
  const userInfo = Digit.UserService.getUser();
  const queryObject = {
    0: {
      tenantId: stateCode
    },
    1: {
      id: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.id
    }
  };
  const {
    data: LicenseData,
    isLoading: LicenseDataLoading
  } = Digit.Hooks.obps.useBPAREGSearch(tenantId, queryObject);
  const checkingUrl = window.location.href.includes("ocbpa");
  sessionStorage.removeItem("clickOnBPAApplyAfterEDCR");
  const {
    data: homePageUrlLinks,
    isLoading: homePageUrlLinksLoading
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["homePageUrlLinks"]);
  const goNext = () => {
    if (JSON.parse(sessionStorage.getItem("BPAintermediateValue")) !== null) {
      let formData = JSON.parse(sessionStorage.getItem("BPAintermediateValue"));
      sessionStorage.setItem("BPAintermediateValue", null);
      onSelect("", formData);
    } else onSelect("uiFlow", uiFlow);
  };
  useEffect(() => {
    let architectName = "",
      isDone = true;
    for (let i = 0; i < (LicenseData === null || LicenseData === void 0 ? void 0 : (_LicenseData$Licenses = LicenseData.Licenses) === null || _LicenseData$Licenses === void 0 ? void 0 : _LicenseData$Licenses.length); i++) {
      var _LicenseData$Licenses, _LicenseData$Licenses2, _LicenseData$Licenses3;
      if ((LicenseData === null || LicenseData === void 0 ? void 0 : (_LicenseData$Licenses2 = LicenseData.Licenses) === null || _LicenseData$Licenses2 === void 0 ? void 0 : (_LicenseData$Licenses3 = _LicenseData$Licenses2[i]) === null || _LicenseData$Licenses3 === void 0 ? void 0 : _LicenseData$Licenses3.status) === "APPROVED" && isDone) {
        var _LicenseData$Licenses4, _LicenseData$Licenses5, _LicenseData$Licenses6, _LicenseData$Licenses7, _LicenseData$Licenses8, _LicenseData$Licenses9;
        isDone = false;
        architectName = (LicenseData === null || LicenseData === void 0 ? void 0 : (_LicenseData$Licenses4 = LicenseData.Licenses) === null || _LicenseData$Licenses4 === void 0 ? void 0 : (_LicenseData$Licenses5 = _LicenseData$Licenses4[i]) === null || _LicenseData$Licenses5 === void 0 ? void 0 : (_LicenseData$Licenses6 = _LicenseData$Licenses5.tradeLicenseDetail) === null || _LicenseData$Licenses6 === void 0 ? void 0 : (_LicenseData$Licenses7 = _LicenseData$Licenses6.tradeUnits) === null || _LicenseData$Licenses7 === void 0 ? void 0 : (_LicenseData$Licenses8 = _LicenseData$Licenses7[0]) === null || _LicenseData$Licenses8 === void 0 ? void 0 : (_LicenseData$Licenses9 = _LicenseData$Licenses8.tradeType) === null || _LicenseData$Licenses9 === void 0 ? void 0 : _LicenseData$Licenses9.split('.')[0]) || "ARCHITECT";
        sessionStorage.setItem("BPA_ARCHITECT_NAME", JSON.stringify(architectName));
      }
    }
  }, [LicenseData]);
  useEffect(() => {
    if (!homePageUrlLinksLoading) {
      var _homePageUrlLinks$BPA, _homePageUrlLinks$BPA2;
      const windowUrl = window.location.href.split('/');
      const serviceType = windowUrl[windowUrl.length - 2];
      const applicationType = windowUrl[windowUrl.length - 3];
      homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA === void 0 ? void 0 : (_homePageUrlLinks$BPA2 = _homePageUrlLinks$BPA.homePageUrlLinks) === null || _homePageUrlLinks$BPA2 === void 0 ? void 0 : _homePageUrlLinks$BPA2.map(linkData => {
        if ((applicationType === null || applicationType === void 0 ? void 0 : applicationType.toUpperCase()) === (linkData === null || linkData === void 0 ? void 0 : linkData.applicationType) && (serviceType === null || serviceType === void 0 ? void 0 : serviceType.toUpperCase()) === (linkData === null || linkData === void 0 ? void 0 : linkData.serviceType)) {
          setUiFlow({
            flow: linkData === null || linkData === void 0 ? void 0 : linkData.flow,
            applicationType: linkData === null || linkData === void 0 ? void 0 : linkData.applicationType,
            serviceType: linkData === null || linkData === void 0 ? void 0 : linkData.serviceType
          });
        }
      });
    }
  }, [!homePageUrlLinksLoading]);
  useEffect(() => {
    if (!isLoading) {
      let unique = [],
        uniqueList = [];
      const windowUrl = window.location.href.split('/');
      const serviceType = windowUrl[windowUrl.length - 2];
      const applicationType = windowUrl[windowUrl.length - 3];
      for (let i = 0; i < data.length; i++) {
        if (!unique[data[i].applicationType] && !unique[data[i].ServiceType]) {
          unique[data[i].applicationType] = data[i];
        }
      }
      Object.values(unique).map(indData => {
        var _uniqueList$;
        if ((indData === null || indData === void 0 ? void 0 : indData.applicationType) == (applicationType === null || applicationType === void 0 ? void 0 : applicationType.toUpperCase()) && (indData === null || indData === void 0 ? void 0 : indData.ServiceType) == (serviceType === null || serviceType === void 0 ? void 0 : serviceType.toUpperCase())) {
          uniqueList.push(indData === null || indData === void 0 ? void 0 : indData.docTypes);
        }
        uniqueList === null || uniqueList === void 0 ? void 0 : (_uniqueList$ = uniqueList[0]) === null || _uniqueList$ === void 0 ? void 0 : _uniqueList$.forEach(doc => {
          var _commonDocs$commonMa, _commonDocs$commonMa$;
          let code = doc.code;
          doc.dropdownData = [];
          commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : (_commonDocs$commonMa$ = _commonDocs$commonMa.DocumentType) === null || _commonDocs$commonMa$ === void 0 ? void 0 : _commonDocs$commonMa$.forEach(value => {
            let values = value.code.slice(0, code.length);
            if (code === values) {
              doc.hasDropdown = true;
              value.i18nKey = value.code;
              doc.dropdownData.push(value);
            }
          });
        });
        setDocsList(uniqueList);
      });
    }
  }, [!isLoading]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, null, checkingUrl ? t(`BPA_OOCUPANCY_CERTIFICATE_APP_LABEL`) : t(`OBPS_NEW_BUILDING_PERMIT`)), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      color: "#0B0C0C",
      marginTop: "12px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px"
    }
  }, t(`OBPS_NEW_BUILDING_PERMIT_DESCRIPTION`)), isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, docsList === null || docsList === void 0 ? void 0 : (_docsList$ = docsList[0]) === null || _docsList$ === void 0 ? void 0 : _docsList$.map((doc, index) => {
    var _doc$dropdownData;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontWeight: 700,
        marginBottom: "8px"
      },
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, `${index + 1}.`, "\xA0"), /*#__PURE__*/React__default.createElement("div", null, ` ${t(doc === null || doc === void 0 ? void 0 : doc.code.replace('.', '_'))}`))), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginBottom: "16px"
      }
    }, doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.map((value, index) => {
      var _doc$dropdownData2;
      return (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData2 = doc.dropdownData) === null || _doc$dropdownData2 === void 0 ? void 0 : _doc$dropdownData2.length) !== index + 1 ? /*#__PURE__*/React__default.createElement("span", null, `${t(value === null || value === void 0 ? void 0 : value.i18nKey)}, `) : /*#__PURE__*/React__default.createElement("span", null, `${t(value === null || value === void 0 ? void 0 : value.i18nKey)}`);
    })));
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext
  })));
};

const OwnerDetails$2 = ({
  t,
  config,
  onSelect,
  userType,
  formData
}) => {
  var _formData$owners, _formData$owners2, _formData$owners3, _formData$owners4, _formData$owners5, _formData$owners6, _formData$owners7, _formData$owners8, _formData$owners9, _formData$owners10, _formData$owners11, _formData$owners12, _formData$owners13, _formData$owners14, _formData$owners15, _formData$owners16, _formData$owners17, _formData$owners18, _formData$owners19, _JSON$parse, _formData$owners20, _formData$owners20$ow, _formData$owners21, _formData$owners22, _formData$owners23;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategoryList, setOwnershipCategoryList] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [ownershipCategory, setOwnershipCategory] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : _formData$owners.ownershipCategory);
  const [name, setName] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners2 = formData.owners) === null || _formData$owners2 === void 0 ? void 0 : _formData$owners2.name) || "");
  const [guardiaNname, setguardianName] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners3 = formData.owners) === null || _formData$owners3 === void 0 ? void 0 : _formData$owners3.guardiaNname) || "");
  const [emailId, setemailId] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners4 = formData.owners) === null || _formData$owners4 === void 0 ? void 0 : _formData$owners4.emailId) || "");
  const [aadharNo, setaadharNo] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners5 = formData.owners) === null || _formData$owners5 === void 0 ? void 0 : _formData$owners5.aadharNo) || "");
  const [isPrimaryOwner, setisPrimaryOwner] = useState(false);
  const [gender, setGender] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners6 = formData.owners) === null || _formData$owners6 === void 0 ? void 0 : _formData$owners6.gender);
  const [mobileNumber, setMobileNumber] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners7 = formData.owners) === null || _formData$owners7 === void 0 ? void 0 : _formData$owners7.mobileNumber) || "");
  const [corAddress, setCorAddress] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners8 = formData.owners) === null || _formData$owners8 === void 0 ? void 0 : _formData$owners8.corrAddress) || "");
  const [permAddress, setPermAddress] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners9 = formData.owners) === null || _formData$owners9 === void 0 ? void 0 : _formData$owners9.permAddress) || "");
  const [corState, setCorState] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners10 = formData.owners) === null || _formData$owners10 === void 0 ? void 0 : _formData$owners10.corrState) || "");
  const [permState, setPermState] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners11 = formData.owners) === null || _formData$owners11 === void 0 ? void 0 : _formData$owners11.permState) || "");
  const [corDistrict, setCorDistrict] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners12 = formData.owners) === null || _formData$owners12 === void 0 ? void 0 : _formData$owners12.corrDistrict) || "");
  const [permDistrict, setPermDistrict] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners13 = formData.owners) === null || _formData$owners13 === void 0 ? void 0 : _formData$owners13.permDistrict) || "");
  const [corTehsil, setCorTehsil] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners14 = formData.owners) === null || _formData$owners14 === void 0 ? void 0 : _formData$owners14.corrTehsil) || "");
  const [permTehsil, setPermTehsil] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners15 = formData.owners) === null || _formData$owners15 === void 0 ? void 0 : _formData$owners15.permTehsil) || "");
  const [corTown, setCorTown] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners16 = formData.owners) === null || _formData$owners16 === void 0 ? void 0 : _formData$owners16.corrTown) || "");
  const [permTown, setPermTown] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners17 = formData.owners) === null || _formData$owners17 === void 0 ? void 0 : _formData$owners17.permTown) || "");
  const [corPinNo, setCorPinNo] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners18 = formData.owners) === null || _formData$owners18 === void 0 ? void 0 : _formData$owners18.corrPinNo) || "");
  const [permPinNo, setPermPinNo] = useState((formData === null || formData === void 0 ? void 0 : (_formData$owners19 = formData.owners) === null || _formData$owners19 === void 0 ? void 0 : _formData$owners19.permPinNo) || "");
  const [disable, setDisable] = useState(true);
  const localName = ((_JSON$parse = JSON.parse(sessionStorage.getItem("currLocality"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.localname) || "";
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  formData === null || formData === void 0 ? void 0 : (_formData$owners20 = formData.owners) === null || _formData$owners20 === void 0 ? void 0 : (_formData$owners20$ow = _formData$owners20.owners) === null || _formData$owners20$ow === void 0 ? void 0 : _formData$owners20$ow.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const [fields, setFeilds] = useState((formData === null || formData === void 0 ? void 0 : formData.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$owners21 = formData.owners) === null || _formData$owners21 === void 0 ? void 0 : _formData$owners21.owners) || [{
    name: "",
    mobileNumber: null,
    isPrimaryOwner: true,
    guardianName: "",
    emailId: "",
    aadharNumber: ""
  }]);
  const [addressfields, setAddressFeilds] = useState((formData === null || formData === void 0 ? void 0 : formData.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$owners22 = formData.owners) === null || _formData$owners22 === void 0 ? void 0 : _formData$owners22.permanentaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [corraddressfields, setCorAddressFeilds] = useState((formData === null || formData === void 0 ? void 0 : formData.owners) && (formData === null || formData === void 0 ? void 0 : (_formData$owners23 = formData.owners) === null || _formData$owners23 === void 0 ? void 0 : _formData$owners23.correspondanceaddress) || [{
    address: "",
    state: "",
    district: "",
    tehsil: "",
    town: "",
    pinno: ""
  }]);
  const [isPermanentSameAsCorrespondence, setIsPermanentSameAsCorrespondence] = useState(false);
  useEffect(() => {
    var flag = 0;
    fields.map(ob => {
      if (ob.isPrimaryOwner) flag = 1;
      if (ob.name && ob.mobileNumber) {
        setCanmovenext(false);
      } else {
        setCanmovenext(true);
      }
    });
    if (!canmovenext && ownershipCategory && !(ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("SINGLEOWNER"))) {
      if (flag == 1) setCanmovenext(false);else setCanmovenext(true);
    }
  }, [fields]);
  useEffect(() => {
    const values = cloneDeep(fields);
    if (ownershipCategory && !ismultiple && (values === null || values === void 0 ? void 0 : values.length) > 1) setFeilds([{
      ...values[0],
      isPrimaryOwner: true
    }]);
  }, [ownershipCategory]);
  const {
    isLoading,
    data: ownerShipCategories
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["OwnerShipCategory"]);
  const {
    data: genderTypeData
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["GenderType"]);
  useEffect(() => {
    var _ownerShipCategories$;
    const ownershipCategoryLists = ownerShipCategories === null || ownerShipCategories === void 0 ? void 0 : (_ownerShipCategories$ = ownerShipCategories["common-masters"]) === null || _ownerShipCategories$ === void 0 ? void 0 : _ownerShipCategories$.OwnerShipCategory;
    if (ownershipCategoryLists && (ownershipCategoryLists === null || ownershipCategoryLists === void 0 ? void 0 : ownershipCategoryLists.length) > 0) {
      const finalOwnershipCategoryList = ownershipCategoryLists.filter(data => {
        var _data$code;
        return data === null || data === void 0 ? void 0 : (_data$code = data.code) === null || _data$code === void 0 ? void 0 : _data$code.includes("INDIVIDUAL");
      });
      finalOwnershipCategoryList.forEach(data => {
        data.i18nKey = `COMMON_MASTERS_OWNERSHIPCATEGORY_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.code, ".", "_")}`;
      });
      setOwnershipCategoryList(finalOwnershipCategoryList);
    }
  }, [ownerShipCategories]);
  useEffect(() => {
    var _genderTypeData$commo;
    const gendeTypeMenu = (genderTypeData === null || genderTypeData === void 0 ? void 0 : (_genderTypeData$commo = genderTypeData["common-masters"]) === null || _genderTypeData$commo === void 0 ? void 0 : _genderTypeData$commo.GenderType) || [];
    if (gendeTypeMenu && (gendeTypeMenu === null || gendeTypeMenu === void 0 ? void 0 : gendeTypeMenu.length) > 0) {
      const genderFilterTypeMenu = gendeTypeMenu.filter(data => data.active);
      genderFilterTypeMenu.forEach(data => {
        data.i18nKey = `COMMON_GENDER_${data.code}`;
      });
      setGenderList(genderFilterTypeMenu);
    }
  }, [genderTypeData]);
  function selectedValue(value) {
    setOwnershipCategory(value);
  }
  function handleAdd() {
    const values = [...fields];
    values.push({
      name: "",
      gender: "",
      mobileNumber: null,
      isPrimaryOwner: false
    });
    setFeilds(values);
    setCanmovenext(true);
  }
  function handleRemove(index) {
    const values = [...fields];
    if (values.length != 1) {
      values.splice(index, 1);
      if (values.length == 1) {
        values[0] = {
          ...values[0],
          isPrimaryOwner: true
        };
      }
      setFeilds(values);
    }
  }
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setGuardianName(i, e) {
    let units = [...fields];
    units[i].guardianName = e.target.value;
    setguardianName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectAadhar(i, e) {
    let units = [...fields];
    units[i].aadharNumber = e.target.value;
    setaadharNo(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const togglePermanentSameAsCorrespondence = () => {
    setIsPermanentSameAsCorrespondence(!isPermanentSameAsCorrespondence);
    if (!isPermanentSameAsCorrespondence) {
      setAddressFeilds(corraddressfields);
    } else {
      setAddressFeilds([{
        address: "",
        state: "",
        district: "",
        tehsil: "",
        town: "",
        pinno: ""
      }]);
    }
  };
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setPrimaryOwner(i, e) {
    let units = [...fields];
    units.map(units => {
      units.isPrimaryOwner = false;
    });
    units[i].isPrimaryOwner = ismultiple ? e.target.checked : true;
    setisPrimaryOwner(e.target.checked);
    setFeilds(units);
  }
  const [error, setError] = useState(null);
  function setCorrAddress(i, e) {
    let units = [...corraddressfields];
    units[i].address = e.target.value;
    setCorAddress(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermAddress(i, e) {
    let units = [...addressfields];
    units[i].address = e.target.value;
    setPermAddress(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrState(i, e) {
    let units = [...corraddressfields];
    units[i].state = e.target.value;
    setCorState(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermState(i, e) {
    let units = [...addressfields];
    units[i].state = e.target.value;
    setPermState(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrDistrict(i, e) {
    let units = [...corraddressfields];
    units[i].district = e.target.value;
    setCorDistrict(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermDistrict(i, e) {
    let units = [...addressfields];
    units[i].district = e.target.value;
    setPermDistrict(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTehsil(i, e) {
    let units = [...corraddressfields];
    units[i].tehsil = e.target.value;
    setCorTehsil(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTehsil(i, e) {
    let units = [...addressfields];
    units[i].tehsil = e.target.value;
    setPermTehsil(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTown(i, e) {
    let units = [...corraddressfields];
    units[i].town = e.target.value;
    setCorTown(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTown(i, e) {
    let units = [...addressfields];
    units[i].town = e.target.value;
    setPermTown(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrPinNO(i, e) {
    let units = [...corraddressfields];
    units[i].pinno = e.target.value;
    setCorPinNo(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermPinNO(i, e) {
    let units = [...addressfields];
    units[i].pinno = e.target.value;
    setPermPinNo(e.target.value);
    setAddressFeilds(units);
  }
  function getusageCategoryAPI(arr) {
    let usageCat = "";
    arr.map((ob, i) => {
      usageCat = usageCat + (i !== 0 ? "," : "") + ob.code;
    });
    return usageCat;
  }
  function getUnitsForAPI(subOccupancyData) {
    var _subOccupancyData$dat, _subOccupancyData$dat2, _subOccupancyData$dat3;
    const ob = subOccupancyData === null || subOccupancyData === void 0 ? void 0 : subOccupancyData.subOccupancy;
    const blocksDetails = (subOccupancyData === null || subOccupancyData === void 0 ? void 0 : (_subOccupancyData$dat = subOccupancyData.data) === null || _subOccupancyData$dat === void 0 ? void 0 : (_subOccupancyData$dat2 = _subOccupancyData$dat.edcrDetails) === null || _subOccupancyData$dat2 === void 0 ? void 0 : (_subOccupancyData$dat3 = _subOccupancyData$dat2.planDetail) === null || _subOccupancyData$dat3 === void 0 ? void 0 : _subOccupancyData$dat3.blocks) || [];
    let units = [];
    if (ob) {
      let result = Object.entries(ob);
      result.map((unit, index) => {
        if (unit[0] !== "checklistData") {
          var _blocksDetails$index, _blocksDetails$index$, _blocksDetails$index$2, _blocksDetails$index$3, _blocksDetails$index$4, _blocksDetails$index$5;
          units.push({
            blockIndex: index,
            floorNo: unit[0].split("_")[1],
            unitType: "Block",
            occupancyType: (blocksDetails === null || blocksDetails === void 0 ? void 0 : (_blocksDetails$index = blocksDetails[index]) === null || _blocksDetails$index === void 0 ? void 0 : (_blocksDetails$index$ = _blocksDetails$index.building) === null || _blocksDetails$index$ === void 0 ? void 0 : (_blocksDetails$index$2 = _blocksDetails$index$.occupancies) === null || _blocksDetails$index$2 === void 0 ? void 0 : (_blocksDetails$index$3 = _blocksDetails$index$2[0]) === null || _blocksDetails$index$3 === void 0 ? void 0 : (_blocksDetails$index$4 = _blocksDetails$index$3.typeHelper) === null || _blocksDetails$index$4 === void 0 ? void 0 : (_blocksDetails$index$5 = _blocksDetails$index$4.type) === null || _blocksDetails$index$5 === void 0 ? void 0 : _blocksDetails$index$5.code) || "A",
            usageCategory: getusageCategoryAPI(unit[1])
          });
        }
      });
    }
    return units;
  }
  function getBlockIds(arr) {
    let blockId = {};
    arr.map((ob, ind) => {
      blockId[`Block_${ob.floorNo}`] = ob.id;
    });
    return blockId;
  }
  const closeToast = () => {
    setShowToast(null);
  };
  const getOwnerDetails = async (indexValue, eData) => {
    var _ownersCopy$indexValu, _ownersCopy$indexValu2;
    const ownersCopy = cloneDeep(fields);
    const ownerNo = (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu = ownersCopy[indexValue]) === null || _ownersCopy$indexValu === void 0 ? void 0 : _ownersCopy$indexValu.mobileNumber) || "";
    setShowToast(null);
    if (!ownerNo.match(getPattern("MobileNo"))) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_MOBILE_NUMBER_INCORRECT"
      });
      return;
    }
    if (ownerNo === (ownersCopy === null || ownersCopy === void 0 ? void 0 : (_ownersCopy$indexValu2 = ownersCopy[indexValue]) === null || _ownersCopy$indexValu2 === void 0 ? void 0 : _ownersCopy$indexValu2.userName)) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED_TOGGLE_MSG"
      });
      return;
    }
    const matchingOwnerIndex = ownersCopy.findIndex(item => item.userName === ownerNo);
    if (matchingOwnerIndex > -1) {
      setShowToast({
        key: "true",
        error: true,
        message: "ERR_OWNER_ALREADY_ADDED"
      });
      return;
    } else {
      var _fields$indexValue, _usersResponse$user;
      const usersResponse = await Digit.UserService.userSearch(Digit.ULBService.getStateId(), {
        userName: fields === null || fields === void 0 ? void 0 : (_fields$indexValue = fields[indexValue]) === null || _fields$indexValue === void 0 ? void 0 : _fields$indexValue.mobileNumber
      }, {});
      if ((usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "ERR_MOBILE_NUMBER_NOT_REGISTERED"
        });
        setDisable(true);
        return;
      } else {
        var _usersResponse$user2, _values$indexValue, _values$indexValue2, _values$indexValue3, _values$indexValue3$g;
        const userData = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : _usersResponse$user2[0];
        userData.gender = userData.gender ? userData === null || userData === void 0 ? void 0 : userData.gender : "";
        if (userData !== null && userData !== void 0 && userData.dob) userData.dob = convertDateToEpoch(userData === null || userData === void 0 ? void 0 : userData.dob);
        if (userData !== null && userData !== void 0 && userData.createdDate) {
          userData.createdDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.createdDate);
          userData.lastModifiedDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.lastModifiedDate);
          userData.pwdExpiryDate = convertDateTimeToEpoch(userData === null || userData === void 0 ? void 0 : userData.pwdExpiryDate);
        }
        setDisable(false);
        let values = [...ownersCopy];
        if (values[indexValue]) {
          var _fields$indexValue2;
          values[indexValue] = userData;
          values[indexValue].isPrimaryOwner = ((_fields$indexValue2 = fields[indexValue]) === null || _fields$indexValue2 === void 0 ? void 0 : _fields$indexValue2.isPrimaryOwner) || false;
        }
        setFeilds(values);
        if ((_values$indexValue = values[indexValue]) !== null && _values$indexValue !== void 0 && _values$indexValue.mobileNumber && (_values$indexValue2 = values[indexValue]) !== null && _values$indexValue2 !== void 0 && _values$indexValue2.name && (_values$indexValue3 = values[indexValue]) !== null && _values$indexValue3 !== void 0 && (_values$indexValue3$g = _values$indexValue3.gender) !== null && _values$indexValue3$g !== void 0 && _values$indexValue3$g.code) setCanmovenext(true);else setCanmovenext(false);
      }
    }
  };
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    setError(null);
    if (ismultiple == true && fields.length == 1) {
      window.scrollTo(0, 0);
      setError("BPA_ERROR_MULTIPLE_OWNER");
    } else {
      let owner = formData.owners;
      let ownerStep;
      ownerStep = {
        ...owner,
        owners: fields,
        ownershipCategory: ownershipCategory,
        correspondenceAddress: corraddressfields,
        permanentAddress: addressfields
      };
      if (!(formData !== null && formData !== void 0 && formData.id)) {
        var _ownerStep, _ownerStep$owners, _ownerStep2, _ownerStep3, _formData$edcrNumber, _formData$edcrNumber2, _formData$data, _formData$data$scruti, _formData$data2, _formData$address, _formData$address2, _formData$address3, _formData$address4, _formData$address5, _formData$data3, _formData$data4, _formData$data5, _formData$data6, _formData$data7, _formData$data8, _formData$data9, _formData$data10, _formData$data11, _formData$data12, _formData$data13, _formData$data14, _formData$data15, _formData$data16, _formData$data17, _formData$data18, _formData$data19, _formData$data20, _formData$data21, _userInfo$info, _formData$address6, _userInfo$info2, _formData$address7, _formData$data22, _formData$data23, _formData$data24, _formData$data25, _formData$data26, _formData$data27, _formData$data28, _formData$data29, _formData$address8, _formData$address9, _formData$address10, _formData$address11, _formData$address12, _formData$address13, _formData$address14, _formData$address15, _formData$address16, _formData$address17, _formData$address18, _formData$address19, _formData$address20, _formData$address21, _formData$address22, _formData$address23, _formData$address24, _formData$address25, _formData$address25$c, _formData$subOccupanc;
        setIsDisable(true);
        let conversionOwners = [];
        let corrAddress = [];
        let permAddress = [];
        (_ownerStep = ownerStep) === null || _ownerStep === void 0 ? void 0 : (_ownerStep$owners = _ownerStep.owners) === null || _ownerStep$owners === void 0 ? void 0 : _ownerStep$owners.map(owner => {
          conversionOwners.push({
            ...owner,
            active: true,
            name: owner.name,
            mobileNumber: owner.mobileNumber,
            isPrimaryOwner: owner.isPrimaryOwner,
            emailId: owner.emailId,
            aadharNumber: owner.aadharNumber,
            fatherOrHusbandName: guardiaNname || ""
          });
        });
        (_ownerStep2 = ownerStep) === null || _ownerStep2 === void 0 ? void 0 : _ownerStep2.correspondenceAddress.map(corradd => {
          corrAddress.push({
            ...corradd,
            type: "CORRESPONDENCE",
            active: true,
            address: corradd.address,
            state: corradd.state,
            district: corradd.district,
            tehsil: corradd.tehsil,
            town: corradd.town,
            pinno: corradd.pinno
          });
        });
        (_ownerStep3 = ownerStep) === null || _ownerStep3 === void 0 ? void 0 : _ownerStep3.permanentAddress.map(permadd => {
          permAddress.push({
            ...permadd,
            type: "PERMANENT",
            active: true,
            address: permadd.address,
            state: permadd.state,
            district: permadd.district,
            tehsil: permadd.tehsil,
            town: permadd.town,
            pinno: permadd.pinno
          });
        });
        let payload = {};
        payload.edcrNumber = formData !== null && formData !== void 0 && (_formData$edcrNumber = formData.edcrNumber) !== null && _formData$edcrNumber !== void 0 && _formData$edcrNumber.edcrNumber ? formData === null || formData === void 0 ? void 0 : (_formData$edcrNumber2 = formData.edcrNumber) === null || _formData$edcrNumber2 === void 0 ? void 0 : _formData$edcrNumber2.edcrNumber : formData === null || formData === void 0 ? void 0 : (_formData$data = formData.data) === null || _formData$data === void 0 ? void 0 : (_formData$data$scruti = _formData$data.scrutinyNumber) === null || _formData$data$scruti === void 0 ? void 0 : _formData$data$scruti.edcrNumber;
        payload.riskType = formData === null || formData === void 0 ? void 0 : (_formData$data2 = formData.data) === null || _formData$data2 === void 0 ? void 0 : _formData$data2.riskType;
        payload.applicationType = "FORM_12";
        payload.feeType = "ApplicationFee";
        if (formData !== null && formData !== void 0 && (_formData$address = formData.address) !== null && _formData$address !== void 0 && _formData$address.tenantId.includes("ud")) {
          payload.businessService = `BPA_UD${localName}`.toLocaleUpperCase().trim();
        }
        if (formData !== null && formData !== void 0 && (_formData$address2 = formData.address) !== null && _formData$address2 !== void 0 && _formData$address2.tenantId.includes("tcp") && (formData === null || formData === void 0 ? void 0 : (_formData$address3 = formData.address) === null || _formData$address3 === void 0 ? void 0 : _formData$address3.areaType) === "Special Area") {
          payload.businessService = "BPA_TCPBBNDA";
        }
        if (formData !== null && formData !== void 0 && (_formData$address4 = formData.address) !== null && _formData$address4 !== void 0 && _formData$address4.tenantId.includes("tcp") && (formData === null || formData === void 0 ? void 0 : (_formData$address5 = formData.address) === null || _formData$address5 === void 0 ? void 0 : _formData$address5.areaType) !== "Special Area") {
          payload.businessService = "BPA";
        }
        payload.typeofArea = (formData === null || formData === void 0 ? void 0 : (_formData$data3 = formData.data) === null || _formData$data3 === void 0 ? void 0 : _formData$data3.typeofArea) || "";
        payload.totalBuildUpArea = (formData === null || formData === void 0 ? void 0 : (_formData$data4 = formData.data) === null || _formData$data4 === void 0 ? void 0 : _formData$data4.totalBuildUpArea) || "";
        payload.plotArea = (formData === null || formData === void 0 ? void 0 : (_formData$data5 = formData.data) === null || _formData$data5 === void 0 ? void 0 : _formData$data5.plotArea) || "";
        payload.khataNo = (formData === null || formData === void 0 ? void 0 : (_formData$data6 = formData.data) === null || _formData$data6 === void 0 ? void 0 : _formData$data6.khataNo) || "", payload.khatauniNo = (formData === null || formData === void 0 ? void 0 : (_formData$data7 = formData.data) === null || _formData$data7 === void 0 ? void 0 : _formData$data7.khatauniNo) || "", payload.subdivision = (formData === null || formData === void 0 ? void 0 : (_formData$data8 = formData.data) === null || _formData$data8 === void 0 ? void 0 : _formData$data8.subdivision) || " ", payload.caserefNo = (formData === null || formData === void 0 ? void 0 : (_formData$data9 = formData.data) === null || _formData$data9 === void 0 ? void 0 : _formData$data9.caserefNo) || "", payload.noOfPlot = (formData === null || formData === void 0 ? void 0 : (_formData$data10 = formData.data) === null || _formData$data10 === void 0 ? void 0 : _formData$data10.noOfPlot) || "", payload.appliedLand = (formData === null || formData === void 0 ? void 0 : (_formData$data11 = formData.data) === null || _formData$data11 === void 0 ? void 0 : _formData$data11.appliedLand) || "", payload.propertyType = (formData === null || formData === void 0 ? void 0 : (_formData$data12 = formData.data) === null || _formData$data12 === void 0 ? void 0 : _formData$data12.propertyType) || "", payload.proposal = (formData === null || formData === void 0 ? void 0 : (_formData$data13 = formData.data) === null || _formData$data13 === void 0 ? void 0 : _formData$data13.proposal) || "", payload.constructionType = (formData === null || formData === void 0 ? void 0 : (_formData$data14 = formData.data) === null || _formData$data14 === void 0 ? void 0 : _formData$data14.constructionType) || "", payload.areaforDevelopment = (formData === null || formData === void 0 ? void 0 : (_formData$data15 = formData.data) === null || _formData$data15 === void 0 ? void 0 : _formData$data15.areaforDevelopment) || "";
        payload.khasraArea = (formData === null || formData === void 0 ? void 0 : (_formData$data16 = formData.data) === null || _formData$data16 === void 0 ? void 0 : _formData$data16.khasraArea) || [];
        payload.totalKhasraArea = formData === null || formData === void 0 ? void 0 : (_formData$data17 = formData.data) === null || _formData$data17 === void 0 ? void 0 : _formData$data17.totalKhasraArea;
        payload.cluInvolved = (formData === null || formData === void 0 ? void 0 : (_formData$data18 = formData.data) === null || _formData$data18 === void 0 ? void 0 : _formData$data18.cluInvolved) || null;
        payload.cluType = (formData === null || formData === void 0 ? void 0 : (_formData$data19 = formData.data) === null || _formData$data19 === void 0 ? void 0 : _formData$data19.cluType) || null;
        payload.landDevelopment = (formData === null || formData === void 0 ? void 0 : (_formData$data20 = formData.data) === null || _formData$data20 === void 0 ? void 0 : _formData$data20.landDevelopment) || [];
        payload.exsistingCaseRefNo = (formData === null || formData === void 0 ? void 0 : (_formData$data21 = formData.data) === null || _formData$data21 === void 0 ? void 0 : _formData$data21.exsistingCaseRefNo) || "";
        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.uuid;
        payload.tenantId = formData === null || formData === void 0 ? void 0 : (_formData$address6 = formData.address) === null || _formData$address6 === void 0 ? void 0 : _formData$address6.tenantId;
        payload.workflow = {
          action: "INITIATE",
          assignes: [userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.uuid]
        };
        payload.accountId = accountId;
        payload.documents = null;
        payload.additionalDetails = {
          GISPlaceName: formData === null || formData === void 0 ? void 0 : (_formData$address7 = formData.address) === null || _formData$address7 === void 0 ? void 0 : _formData$address7.placeName
        };
        if (formData !== null && formData !== void 0 && (_formData$data22 = formData.data) !== null && _formData$data22 !== void 0 && _formData$data22.holdingNumber) payload.additionalDetails.holdingNo = formData === null || formData === void 0 ? void 0 : (_formData$data23 = formData.data) === null || _formData$data23 === void 0 ? void 0 : _formData$data23.holdingNumber;
        if (formData !== null && formData !== void 0 && (_formData$data24 = formData.data) !== null && _formData$data24 !== void 0 && _formData$data24.registrationDetails) payload.additionalDetails.registrationDetails = formData === null || formData === void 0 ? void 0 : (_formData$data25 = formData.data) === null || _formData$data25 === void 0 ? void 0 : _formData$data25.registrationDetails;
        if (formData !== null && formData !== void 0 && (_formData$data26 = formData.data) !== null && _formData$data26 !== void 0 && _formData$data26.applicationType) payload.additionalDetails.applicationType = formData === null || formData === void 0 ? void 0 : (_formData$data27 = formData.data) === null || _formData$data27 === void 0 ? void 0 : _formData$data27.applicationType;
        if (formData !== null && formData !== void 0 && (_formData$data28 = formData.data) !== null && _formData$data28 !== void 0 && _formData$data28.serviceType) payload.additionalDetails.serviceType = formData === null || formData === void 0 ? void 0 : (_formData$data29 = formData.data) === null || _formData$data29 === void 0 ? void 0 : _formData$data29.serviceType;
        payload.landInfo = {};
        payload.landInfo.address = {};
        payload.professionaldetails = {};
        payload.professionaldetails = (formData === null || formData === void 0 ? void 0 : formData["professional-information"]) || {};
        if (formData !== null && formData !== void 0 && (_formData$address8 = formData.address) !== null && _formData$address8 !== void 0 && _formData$address8.city) payload.landInfo.address.city = formData === null || formData === void 0 ? void 0 : (_formData$address9 = formData.address) === null || _formData$address9 === void 0 ? void 0 : _formData$address9.city;
        if (formData !== null && formData !== void 0 && (_formData$address10 = formData.address) !== null && _formData$address10 !== void 0 && _formData$address10.locality) payload.landInfo.address.locality = {
          code: "hp.tcpsolan"
        };
        if (formData !== null && formData !== void 0 && (_formData$address11 = formData.address) !== null && _formData$address11 !== void 0 && _formData$address11.pincode) payload.landInfo.address.pincode = formData === null || formData === void 0 ? void 0 : (_formData$address12 = formData.address) === null || _formData$address12 === void 0 ? void 0 : _formData$address12.pincode;
        if (formData !== null && formData !== void 0 && (_formData$address13 = formData.address) !== null && _formData$address13 !== void 0 && _formData$address13.landmark) payload.landInfo.address.landmark = formData === null || formData === void 0 ? void 0 : (_formData$address14 = formData.address) === null || _formData$address14 === void 0 ? void 0 : _formData$address14.landmark;
        if (formData !== null && formData !== void 0 && (_formData$address15 = formData.address) !== null && _formData$address15 !== void 0 && _formData$address15.street) payload.landInfo.address.street = formData === null || formData === void 0 ? void 0 : (_formData$address16 = formData.address) === null || _formData$address16 === void 0 ? void 0 : _formData$address16.street;
        if (formData !== null && formData !== void 0 && (_formData$address17 = formData.address) !== null && _formData$address17 !== void 0 && _formData$address17.geoLocation) payload.landInfo.address.geoLocation = formData === null || formData === void 0 ? void 0 : (_formData$address18 = formData.address) === null || _formData$address18 === void 0 ? void 0 : _formData$address18.geoLocation;
        if (formData !== null && formData !== void 0 && (_formData$address19 = formData.address) !== null && _formData$address19 !== void 0 && _formData$address19.doorNo) payload.landInfo.address.doorNo = (formData === null || formData === void 0 ? void 0 : (_formData$address20 = formData.address) === null || _formData$address20 === void 0 ? void 0 : _formData$address20.doorNo) || null;
        if (formData !== null && formData !== void 0 && (_formData$address21 = formData.address) !== null && _formData$address21 !== void 0 && _formData$address21.village) payload.landInfo.address.village = formData === null || formData === void 0 ? void 0 : (_formData$address22 = formData.address) === null || _formData$address22 === void 0 ? void 0 : _formData$address22.village;
        if (formData !== null && formData !== void 0 && (_formData$address23 = formData.address) !== null && _formData$address23 !== void 0 && _formData$address23.areaType) payload.landInfo.address.areaType = formData === null || formData === void 0 ? void 0 : (_formData$address24 = formData.address) === null || _formData$address24 === void 0 ? void 0 : _formData$address24.areaType;
        payload.landInfo.address.region = localName.trim();
        payload.landInfo.owners = conversionOwners;
        payload.landInfo.ownershipCategory = ownershipCategory.code;
        payload.landInfo.owners[0].correspondenceAddress = corrAddress[0];
        payload.landInfo.owners[0].permanentAddress = permAddress[0];
        payload.landInfo.tenantId = (formData === null || formData === void 0 ? void 0 : (_formData$address25 = formData.address) === null || _formData$address25 === void 0 ? void 0 : (_formData$address25$c = _formData$address25.city) === null || _formData$address25$c === void 0 ? void 0 : _formData$address25$c.code) || "hp.tcpsolan";
        payload.landInfo.ownerCorrespondanceAddress = null;
        payload.landInfo.ownerPermanentAddress = null;
        const blockOccupancyDetails = formData;
        payload.landInfo.unit = getUnitsForAPI(blockOccupancyDetails);
        payload.landInfo.checklistdata = (formData === null || formData === void 0 ? void 0 : (_formData$subOccupanc = formData.subOccupancy) === null || _formData$subOccupanc === void 0 ? void 0 : _formData$subOccupanc.checklistData) || {};
        let nameOfAchitect = sessionStorage.getItem("BPA_ARCHITECT_NAME");
        let parsedArchitectName = nameOfAchitect ? JSON.parse(nameOfAchitect) : "ARCHITECT";
        payload.additionalDetails.typeOfArchitect = parsedArchitectName;
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        Digit.OBPSService.create({
          BPA: payload
        }, tenantId).then((result, err) => {
          var _result$BPA;
          if ((result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA.length) > 0) {
            var _result$BPA2, _result$BPA2$, _result$BPA2$$landInf, _result$BPA2$$landInf2, _result$BPA3, _result$BPA3$, _result$BPA3$$landInf, _result$BPA4, _result$BPA4$, _result$BPA4$$landInf, _formData$address26;
            result === null || result === void 0 ? void 0 : (_result$BPA2 = result.BPA) === null || _result$BPA2 === void 0 ? void 0 : (_result$BPA2$ = _result$BPA2[0]) === null || _result$BPA2$ === void 0 ? void 0 : (_result$BPA2$$landInf = _result$BPA2$.landInfo) === null || _result$BPA2$$landInf === void 0 ? void 0 : (_result$BPA2$$landInf2 = _result$BPA2$$landInf.owners) === null || _result$BPA2$$landInf2 === void 0 ? void 0 : _result$BPA2$$landInf2.forEach(owner => {
              owner.gender = {
                code: owner.gender,
                active: true,
                i18nKey: `COMMON_GENDER_${owner.gender}`
              };
            });
            result.BPA[0].owners = {
              ...owner,
              owners: result === null || result === void 0 ? void 0 : (_result$BPA3 = result.BPA) === null || _result$BPA3 === void 0 ? void 0 : (_result$BPA3$ = _result$BPA3[0]) === null || _result$BPA3$ === void 0 ? void 0 : (_result$BPA3$$landInf = _result$BPA3$.landInfo) === null || _result$BPA3$$landInf === void 0 ? void 0 : _result$BPA3$$landInf.owners,
              ownershipCategory: ownershipCategory
            };
            result.BPA[0].address = result === null || result === void 0 ? void 0 : (_result$BPA4 = result.BPA) === null || _result$BPA4 === void 0 ? void 0 : (_result$BPA4$ = _result$BPA4[0]) === null || _result$BPA4$ === void 0 ? void 0 : (_result$BPA4$$landInf = _result$BPA4$.landInfo) === null || _result$BPA4$$landInf === void 0 ? void 0 : _result$BPA4$$landInf.address;
            result.BPA[0].address.city = formData.address.city;
            result.BPA[0].address.locality = formData.address.locality;
            result.BPA[0].placeName = formData === null || formData === void 0 ? void 0 : (_formData$address26 = formData.address) === null || _formData$address26 === void 0 ? void 0 : _formData$address26.placeName;
            result.BPA[0].data = formData.data;
            result.BPA[0].BlockIds = getBlockIds(result.BPA[0].landInfo.unit);
            result.BPA[0].subOccupancy = formData === null || formData === void 0 ? void 0 : formData.subOccupancy;
            result.BPA[0].uiFlow = formData === null || formData === void 0 ? void 0 : formData.uiFlow;
            setIsDisable(false);
            onSelect("", result.BPA[0], "", true);
          }
        }).catch(e => {
          var _e$response, _e$response$data, _e$response$data$Erro;
          setIsDisable(false);
          setShowToast({
            key: "true",
            error: true,
            message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
          });
        });
      } else {
        if (currentTab == "1") {
          setCurrentTab("2");
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3");
          return;
        }
        onSelect(config.key, ownerStep);
      }
    }
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 3,
    flow: "BPA"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || !ownershipCategory || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, !isLoading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: t("Owner Details"),
    value: "1",
    sx: {
      textTransform: 'none',
      p: '0 1rem !important'
    }
  }), /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t("BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS")}`,
    value: "2",
    sx: {
      textTransform: 'none',
      p: '0 1rem !important'
    }
  }), /*#__PURE__*/React__default.createElement(Tab, {
    label: t("BPA_OWNER_PERMANENT_ADDRESS_DETAILS"),
    value: "3",
    sx: {
      textTransform: 'none',
      p: '0 1rem !important'
    }
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_TYPE_OF_OWNER_LABEL")} *`), /*#__PURE__*/React__default.createElement(RadioButtons, {
    isMandatory: config.isMandatory,
    options: ownershipCategoryList,
    selectedOption: ownershipCategory,
    optionsKey: "i18nKey",
    onSelect: selectedValue,
    value: ownershipCategory,
    labelKey: "PT_OWNERSHIP",
    isDependent: true
  }), fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *` + `${t("(Please click on search icon to check wheather the owner registered or not)")}`), ismultiple && /*#__PURE__*/React__default.createElement(LinkButton, {
      label: /*#__PURE__*/React__default.createElement(DeleteIcon$1, {
        style: {
          float: "right",
          position: "relative",
          bottom: "5px"
        },
        fill: !(fields.length == 1) ? "#494848" : "#FAFAFA"
      }),
      style: {
        width: "100px",
        display: "inline",
        background: "black"
      },
      onClick: e => handleRemove(index)
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        right: "35px",
        marginTop: "-24px",
        marginRight: Webview ? "-20px" : "-20px"
      },
      onClick: e => getOwnerDetails(index)
    }, " ", /*#__PURE__*/React__default.createElement(SearchIcon$1, null), " "))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_GUARDIAN_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.guardianName,
      onChange: e => setGuardianName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "email",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_AADHAR_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "number",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "aadhar",
      value: field.aadharNumber,
      onChange: e => selectAadhar(index, e)
    }, validation = {
      isRequired: true,
      pattern: getPattern("AadharNo"),
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), ismultiple && /*#__PURE__*/React__default.createElement(CheckBox$1, {
      label: t("BPA_IS_PRIMARY_OWNER_LABEL"),
      onChange: e => setPrimaryOwner(index, e),
      value: field.isPrimaryOwner,
      checked: field.isPrimaryOwner,
      style: {
        paddingTop: "10px"
      }
    })));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, corraddressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => setCorrAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectCorrState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectCorrDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectCorrTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectCorrTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectCorrPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "3",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$2, {
    control: /*#__PURE__*/React__default.createElement(Checkbox$1, {
      checked: isPermanentSameAsCorrespondence,
      onChange: togglePermanentSameAsCorrespondence,
      color: "primary"
    }),
    label: "Is Same as Correspondence Address?"
  }), addressfields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrAddress",
      value: field.address,
      onChange: e => selectPermAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "corrstate",
      value: field.state,
      onChange: e => selectPermState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectPermDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectPermTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectPermTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectPermPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), ismultiple ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      paddingBottom: "15px",
      color: "#FF8C00"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    style: {
      paddingTop: "10px"
    },
    onClick: () => handleAdd()
  }, t("BPA_ADD_OWNER")))) : null) : /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext,
    disabled: disable
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const DocumentDetails$2 = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  setError: setFormError,
  clearErrors: clearFormErrors,
  formState
}) => {
  var _formData$documents, _formData$uiFlow;
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.documents) || []);
  const [error, setError] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const checkingFlow = formData === null || formData === void 0 ? void 0 : (_formData$uiFlow = formData.uiFlow) === null || _formData$uiFlow === void 0 ? void 0 : _formData$uiFlow.flow;
  const beforeUploadDocuments = cloneDeep((formData === null || formData === void 0 ? void 0 : formData.PrevStateDocuments) || []);
  const {
    data: bpaTaxDocuments,
    isLoading
  } = Digit.Hooks.obps.useBPATaxDocuments(stateId, formData, beforeUploadDocuments || []);
  const handleSubmit = () => {
    let document = formData.documents;
    let documentStep;
    let RealignedDocument = [];
    bpaTaxDocuments && bpaTaxDocuments.map(ob => {
      documents && documents.filter(x => ob.code === x.documentType).map(doc => {
        RealignedDocument.push(doc);
      });
    });
    documentStep = {
      ...document,
      documents: RealignedDocument
    };
    onSelect(config.key, documentStep);
  };
  const onSkip = () => onSelect();
  function onAdd() {}
  useEffect(() => {
    const allRequiredDocumentsCode = bpaTaxDocuments.filter(e => e.required).map(e => e.code);
    const reqDocumentEntered = allRequiredDocumentsCode.filter(reqCode => documents.reduce((acc, doc) => {
      var _doc$documentType, _doc$documentType$spl, _doc$documentType2, _doc$documentType2$sp;
      if (reqCode == `${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : (_doc$documentType$spl = _doc$documentType.split('.')) === null || _doc$documentType$spl === void 0 ? void 0 : _doc$documentType$spl[0]}.${doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : (_doc$documentType2$sp = _doc$documentType2.split('.')) === null || _doc$documentType2$sp === void 0 ? void 0 : _doc$documentType2$sp[1]}`) {
        return true;
      } else {
        return acc;
      }
    }, false));
    if (reqDocumentEntered.length == allRequiredDocumentsCode.length && documents.length > 0) {
      setEnableSubmit(false);
    } else {
      setEnableSubmit(false);
    }
  }, [documents, checkRequiredFields]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: checkingFlow === "OCBPA" ? 3 : 4,
    flow: checkingFlow === "OCBPA" ? "OCBPA" : "BPA"
  }), !isLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: window.location.href.includes("editApplication") || window.location.href.includes("sendbacktocitizen") ? false : enableSubmit,
    onAdd: onAdd,
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "600px",
        minWidth: "280px",
        marginBottom: "15px",
        paddingTop: "15px"
      }
    }, /*#__PURE__*/React__default.createElement(SelectDocument$3, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      formData: formData,
      beforeUploadDocuments: beforeUploadDocuments || []
    }));
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    onClose: () => setError(null),
    error: true
  })) : /*#__PURE__*/React__default.createElement(Loader, null), (window.location.href.includes("/bpa/building_plan_scrutiny/new_construction") || window.location.href.includes("/ocbpa/building_oc_plan_scrutiny/new_construction")) && formData !== null && formData !== void 0 && formData.applicationNo ? /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
    style: {
      margin: "20px auto 0"
    },
    info: t("CS_FILE_APPLICATION_INFO_LABEL"),
    text: `${t("BPA_APPLICATION_NUMBER_LABEL")} ${formData === null || formData === void 0 ? void 0 : formData.applicationNo} ${t("BPA_DOCS_INFORMATION")}`,
    className: "info-banner-wrap-citizen-override"
  }) : "");
};
const SelectDocument$3 = React__default.memo(function MyComponent({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  formData,
  beforeUploadDocuments
}) {
  var _doc$dropdownData, _formData$documents2, _doc$uploadedDocument;
  const filteredDocument = (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]) || (beforeUploadDocuments === null || beforeUploadDocuments === void 0 ? void 0 : beforeUploadDocuments.filter(item => {
    var _item$documentType2;
    return item === null || item === void 0 ? void 0 : (_item$documentType2 = item.documentType) === null || _item$documentType2 === void 0 ? void 0 : _item$documentType2.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) > 0 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType3;
    return item === null || item === void 0 ? void 0 : (_item$documentType3 = item.documentType) === null || _item$documentType3 === void 0 ? void 0 : _item$documentType3.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  }).map(e => ({
    fileStoreId: e === null || e === void 0 ? void 0 : e.fileStoreId,
    fileName: (e === null || e === void 0 ? void 0 : e.fileName) || ""
  }))) || null);
  const [newArray, setnewArray] = useState([]);
  const [uploadedfileArray, setuploadedfileArray] = useState([]);
  const [fileArray, setfileArray] = useState([] || (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : _formData$documents2.documents.filter(ob => ob.documentType === selectedDocument.code)));
  const handleSelectDocument = value => {
    if (filteredDocument !== null && filteredDocument !== void 0 && filteredDocument.documentType) {
      filteredDocument.documentType = value === null || value === void 0 ? void 0 : value.code;
      let currDocs = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType4;
        return item === null || item === void 0 ? void 0 : (_item$documentType4 = item.documentType) === null || _item$documentType4 === void 0 ? void 0 : _item$documentType4.includes(doc === null || doc === void 0 ? void 0 : doc.code);
      });
      currDocs.map(doc => doc.documentType = value === null || value === void 0 ? void 0 : value.code);
      let newDoc = [...(documents === null || documents === void 0 ? void 0 : documents.filter(item => {
        var _item$documentType5;
        return !(item !== null && item !== void 0 && (_item$documentType5 = item.documentType) !== null && _item$documentType5 !== void 0 && _item$documentType5.includes(doc === null || doc === void 0 ? void 0 : doc.code));
      })), ...currDocs];
      setDocuments(newDoc);
    }
    setSelectedDocument(value);
  };
  function selectfile(e, key) {
    e && setFile(e.file);
    e && setfileArray([...fileArray, e.file]);
  }
  function getData(e) {
    var _newArr;
    let key = selectedDocument.code;
    let data, newArr;
    if ((e === null || e === void 0 ? void 0 : e.length) > 0) {
      var _formData$documents3, _formData$documents3$;
      data = Object.fromEntries(e);
      newArr = Object.values(data);
      newArr = formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.documents) === null || _formData$documents3$ === void 0 ? void 0 : _formData$documents3$.filter(ob => ob.documentType === selectedDocument.code);
      setnewArray(newArr);
      let newfiles = [];
      e === null || e === void 0 ? void 0 : e.map((doc, index) => {
        var _doc$, _doc$$fileStoreId, _doc$1$fileStoreId, _documents$find;
        newfiles.push({
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          additionalDetails: {
            category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
          },
          fileStoreId: doc === null || doc === void 0 ? void 0 : (_doc$ = doc[1]) === null || _doc$ === void 0 ? void 0 : (_doc$$fileStoreId = _doc$.fileStoreId) === null || _doc$$fileStoreId === void 0 ? void 0 : _doc$$fileStoreId.fileStoreId,
          documentUid: doc === null || doc === void 0 ? void 0 : (_doc$1$fileStoreId = doc[1].fileStoreId) === null || _doc$1$fileStoreId === void 0 ? void 0 : _doc$1$fileStoreId.fileStoreId,
          fileName: (doc === null || doc === void 0 ? void 0 : doc[0]) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        });
      });
      const __documents = [...documents.filter(e => e.documentType !== key), ...newfiles];
      setDocuments(__documents);
    } else if ((e === null || e === void 0 ? void 0 : e.length) == 0) {
      const __documents = [...documents.filter(e => e.documentType !== key)];
      setDocuments(__documents);
    }
    (_newArr = newArr) === null || _newArr === void 0 ? void 0 : _newArr.map(ob => {
      if (!(ob !== null && ob !== void 0 && ob.file)) {
        ob.file = {};
      }
      ob.file.documentType = key;
      selectfile(ob);
    });
  }
  function setcodeafterupload() {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        let newfiles = [];
        uploadedfileArray && uploadedfileArray.map((doc, index) => {
          var _fileArray$index, _documents$find2;
          newfiles.push({
            documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
            fileStoreId: doc.fileStoreId,
            additionalDetails: {
              category: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code.split(".").slice(0, 2).join('_')
            },
            documentUid: doc.fileStoreId,
            fileName: ((_fileArray$index = fileArray[index]) === null || _fileArray$index === void 0 ? void 0 : _fileArray$index.name) || "",
            id: documents ? (_documents$find2 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find2 === void 0 ? void 0 : _documents$find2.id : undefined
          });
        });
        return [...filteredDocumentsByFileStoreId, ...newfiles];
      });
      setuploadedfileArray([]);
    }
  }
  useEffect(() => {
    uploadedfileArray.length > 0 && setcodeafterupload();
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find3;
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          if ((prev === null || prev === void 0 ? void 0 : prev.length) > 0) {
            prev === null || prev === void 0 ? void 0 : prev.forEach(data => {
              var _data$documentType, _data$documentType2, _selectedDocument$cod, _selectedDocument$cod2;
              const normalDocumentType = `${data === null || data === void 0 ? void 0 : (_data$documentType = data.documentType) === null || _data$documentType === void 0 ? void 0 : _data$documentType.split('.')[0]}.${data === null || data === void 0 ? void 0 : (_data$documentType2 = data.documentType) === null || _data$documentType2 === void 0 ? void 0 : _data$documentType2.split('.')[1]}`;
              const selectedDocumentType = `${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod = selectedDocument.code) === null || _selectedDocument$cod === void 0 ? void 0 : _selectedDocument$cod.split('.')[0]}.${selectedDocument === null || selectedDocument === void 0 ? void 0 : (_selectedDocument$cod2 = selectedDocument.code) === null || _selectedDocument$cod2 === void 0 ? void 0 : _selectedDocument$cod2.split('.')[1]}`;
              if (normalDocumentType == selectedDocumentType) {
                var _data$file;
                if (data !== null && data !== void 0 && data.documentType) data.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
                if (data !== null && data !== void 0 && (_data$file = data.file) !== null && _data$file !== void 0 && _data$file.documentType) data.file.documentType = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code;
              }
            });
          }
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile.fileStoreId,
          documentUid: uploadedFile.fileStoreId,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || uploadedFile.fileName || "document",
          id: documents ? (_documents$find3 = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find3 === void 0 ? void 0 : _documents$find3.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    if (!selectedDocument.code && uploadedFile !== null) setuploadedfileArray([...uploadedfileArray, uploadedFile]);
  }, [uploadedFile]);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  const uploadedFilesPreFill = useMemo(() => {
    var _formData$documents4, _formData$documents4$;
    let selectedUplDocs = [];
    formData === null || formData === void 0 ? void 0 : (_formData$documents4 = formData.documents) === null || _formData$documents4 === void 0 ? void 0 : (_formData$documents4$ = _formData$documents4.documents) === null || _formData$documents4$ === void 0 ? void 0 : _formData$documents4$.filter(ob => ob.documentType === selectedDocument.code).forEach(e => selectedUplDocs.push([e.fileName, {
      file: {
        name: e.fileName,
        type: e.documentType
      },
      fileStoreId: {
        fileStoreId: e.fileStoreId,
        tenantId
      }
    }]));
    return selectedUplDocs;
  }, [formData]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)} *` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    t: t,
    isMandatory: false,
    option: Digit.Utils.locale.sortDropdownNames(doc === null || doc === void 0 ? void 0 : doc.dropdownData, 'i18nKey', t),
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument
  }), /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: getData,
    setuploadedstate: uploadedFilesPreFill,
    t: t,
    extraStyleName: "OBPS",
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    isSendBackFlow: true,
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments
  }));
});

function PropertyDocuments({
  documents,
  svgStyles = {},
  isSendBackFlow = false
}) {
  const {
    t
  } = useTranslation();
  const [filesArray, setFilesArray] = useState(() => []);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [pdfFiles, setPdfFiles] = useState({});
  useEffect(() => {
    var _acc;
    let acc = [];
    documents === null || documents === void 0 ? void 0 : documents.forEach((element, index, array) => {
      acc = [...acc, ...(element.values ? element.values : [])];
    });
    setFilesArray((_acc = acc) === null || _acc === void 0 ? void 0 : _acc.map(value => value === null || value === void 0 ? void 0 : value.fileStoreId));
  }, [documents]);
  useEffect(() => {
    if (filesArray !== null && filesArray !== void 0 && filesArray.length) {
      Digit.UploadServices.Filefetch(filesArray, Digit.ULBService.getStateId()).then(res => {
        setPdfFiles(res === null || res === void 0 ? void 0 : res.data);
      });
    }
  }, [filesArray]);
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("/obps");
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: checkLocation ? {
        marginTop: "32px",
        marginBottom: "18px",
        color: "#0B0C0C, 100%",
        fontSize: "24px",
        lineHeight: "30px"
      } : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _pdfFiles$value$fileS, _value$documentType;
      return /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS === void 0 ? void 0 : _pdfFiles$value$fileS.split(",")[0],
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto"
        },
        key: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React__default.createElement(PDFSvg, null)), /*#__PURE__*/React__default.createElement("p", {
        style: checkLocation ? {
          marginTop: "8px",
          fontWeight: "bold",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          textAlign: "center"
        } : {
          marginTop: "8px",
          fontWeight: "bold"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React__default.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React__default.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React__default.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => {
      var _pdfFiles$value$fileS2;
      return /*#__PURE__*/React__default.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS2 = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS2 === void 0 ? void 0 : _pdfFiles$value$fileS2.split(",")[0],
        style: {
          minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
          marginRight: "20px"
        },
        key: index
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          maxWidth: "940px",
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #D6D5D4",
          background: "#FAFAFA"
        }
      }, /*#__PURE__*/React__default.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          marginBottom: "10px"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          fontSize: "12px",
          color: "#505A5F",
          fontWeight: 400,
          lineHeight: "15px",
          marginBottom: "10px"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React__default.createElement(PDFSvg, null), /*#__PURE__*/React__default.createElement("p", {
        style: {
          marginTop: "8px",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          fontWeight: "400"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)));
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

const NOCDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  setError: setFormError,
  clearErrors: clearFormErrors,
  formState
}) => {
  var _formData$nocDocument, _formData$uiFlow;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [nocDocuments, setNocDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : _formData$nocDocument.nocDocuments) || []);
  const [error, setError] = useState(null);
  const [nocTaxDocuments, setNocTaxDocuments] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  let [beforeUploadNocDocuments, setBeforeUploadNocDocuments] = useState(formData !== null && formData !== void 0 && formData.PrevStateNocDocuments ? cloneDeep(formData === null || formData === void 0 ? void 0 : formData.PrevStateNocDocuments) : []);
  const checkingFlow = formData === null || formData === void 0 ? void 0 : (_formData$uiFlow = formData.uiFlow) === null || _formData$uiFlow === void 0 ? void 0 : _formData$uiFlow.flow;
  const [sourceRefId, setSourceRefId] = useState(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  const [nocDatils, setNocDetails] = useState([]);
  const [nocDocumentTypeMaping, setNocDocumentTypeMaping] = useState([]);
  const [commonDocMaping, setCommonDocMaping] = useState([]);
  const {
    data,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useNocDetails(formData === null || formData === void 0 ? void 0 : formData.tenantId, {
    sourceRefId: sourceRefId
  });
  const {
    isLoading: nocDocsLoading,
    data: nocDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "NOC", ["DocumentTypeMapping"]);
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(beforeUploadNocDocuments, {
    enabled: (beforeUploadNocDocuments === null || beforeUploadNocDocuments === void 0 ? void 0 : beforeUploadNocDocuments.length) > 0 ? true : false
  });
  useEffect(() => {
    var _pdfDetails$pdfFiles;
    if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
      var _pdfDetails$pdfFiles2;
      pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.forEach(resDoc => resDoc.title = resDoc === null || resDoc === void 0 ? void 0 : resDoc.documentType);
      setBeforeUploadNocDocuments(pdfDetails === null || pdfDetails === void 0 ? void 0 : pdfDetails.pdfFiles);
    }
  }, [pdfDetails === null || pdfDetails === void 0 ? void 0 : pdfDetails.pdfFiles]);
  useEffect(() => {
    setNocDetails(data);
  }, [data]);
  useEffect(() => {
    var _nocDocs$NOC;
    setNocDocumentTypeMaping(nocDocs === null || nocDocs === void 0 ? void 0 : (_nocDocs$NOC = nocDocs.NOC) === null || _nocDocs$NOC === void 0 ? void 0 : _nocDocs$NOC.DocumentTypeMapping);
  }, [nocDocs]);
  useEffect(() => {
    var _commonDocs$commonMa;
    setCommonDocMaping(commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : _commonDocs$commonMa.DocumentType);
  }, [commonDocs]);
  useEffect(() => {
    if (nocDatils !== null && nocDatils !== void 0 && nocDatils.length && nocDocumentTypeMaping !== null && nocDocumentTypeMaping !== void 0 && nocDocumentTypeMaping.length) {
      let documents = [];
      nocDatils.map(noc => {
        var _filteredData$, _filteredData$$docTyp;
        const filteredData = nocDocumentTypeMaping.filter(data => data.applicationType === noc.applicationType && data.nocType === noc.nocType);
        if (filteredData !== null && filteredData !== void 0 && (_filteredData$ = filteredData[0]) !== null && _filteredData$ !== void 0 && (_filteredData$$docTyp = _filteredData$.docTypes) !== null && _filteredData$$docTyp !== void 0 && _filteredData$$docTyp[0]) {
          filteredData[0].docTypes[0].nocType = filteredData[0].nocType;
          filteredData[0].docTypes[0].additionalDetails = {
            submissionDetails: noc.additionalDetails,
            applicationStatus: noc.applicationStatus,
            appNumberLink: noc.applicationNo,
            nocNo: noc.nocNo
          };
          documents.push(filteredData[0].docTypes[0]);
        }
      });
      let documentsList = [];
      if (documents && documents.length > 0) {
        documents.map(doc => {
          let code = doc.documentType;
          doc.dropdownData = [];
          doc.uploadedDocuments = [];
          commonDocMaping && commonDocMaping.forEach(value => {
            let values = value.code.slice(0, code.length);
            if (code === values) {
              doc.hasDropdown = true;
              doc.dropdownData.push(value);
            }
          });
          doc.uploadedDocuments[0] = {};
          doc.uploadedDocuments[0].values = [];
          beforeUploadNocDocuments.map(upDocs => {
            var _upDocs$documentType, _upDocs$documentType2;
            if (code === `${upDocs === null || upDocs === void 0 ? void 0 : (_upDocs$documentType = upDocs.documentType) === null || _upDocs$documentType === void 0 ? void 0 : _upDocs$documentType.split('.')[0]}.${upDocs === null || upDocs === void 0 ? void 0 : (_upDocs$documentType2 = upDocs.documentType) === null || _upDocs$documentType2 === void 0 ? void 0 : _upDocs$documentType2.split('.')[1]}`) {
              doc.uploadedDocuments[0].values.push(upDocs);
            }
          });
          documentsList.push(doc);
        });
      }
      documentsList.forEach(data => {
        data.code = data.documentType;
        data.dropdownData.forEach(dpData => {
          dpData.i18nKey = dpData.code;
        });
      });
      setNocTaxDocuments(documentsList);
    }
  }, [nocDatils, nocDocumentTypeMaping, commonDocMaping, beforeUploadNocDocuments]);
  const handleSubmit = () => {
    let nocDocument = formData.nocDocuments;
    let nocDocumentStep;
    nocDocumentStep = {
      ...nocDocument,
      nocDocuments: nocDocuments,
      NocDetails: nocDatils,
      nocTaxDocuments: nocTaxDocuments
    };
    onSelect(config.key, nocDocumentStep);
  };
  const onSkip = () => {
    let nocDocument = formData.nocDocuments;
    let nocDocumentStep;
    nocDocumentStep = {
      ...nocDocument,
      nocDocuments: nocDocuments,
      NocDetails: nocDatils,
      nocTaxDocuments: nocTaxDocuments
    };
    onSelect(config.key, nocDocumentStep);
  };
  function onAdd() {}
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 3,
    flow: checkingFlow === "OCBPA" ? "OCBPA" : ""
  }), !nocDocsLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    onAdd: onAdd
  }, nocTaxDocuments === null || nocTaxDocuments === void 0 ? void 0 : nocTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement(SelectDocument$4, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setNocDocuments: setNocDocuments,
      nocDocuments: nocDocuments,
      setCheckRequiredFields: setCheckRequiredFields,
      formData: formData,
      beforeUploadNocDocuments: beforeUploadNocDocuments,
      pdfLoading: pdfLoading
    });
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    onClose: () => setError(null),
    error: true
  })) : /*#__PURE__*/React__default.createElement(Loader, null));
};
function SelectDocument$4({
  t,
  document: doc,
  setNocDocuments,
  error,
  setError,
  nocDocuments,
  setCheckRequiredFields,
  formData,
  beforeUploadNocDocuments,
  pdfLoading
}) {
  var _doc$dropdownData, _doc$additionalDetail, _doc$uploadedDocument;
  const filteredDocument = (nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]) || (beforeUploadNocDocuments === null || beforeUploadNocDocuments === void 0 ? void 0 : beforeUploadNocDocuments.filter(item => {
    var _item$documentType2;
    return item === null || item === void 0 ? void 0 : (_item$documentType2 = item.documentType) === null || _item$documentType2 === void 0 ? void 0 : _item$documentType2.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0]);
  const tenantId = Digit.ULBService.getCurrentTenantId(doc);
  const [selectedDocument, setSelectedDocument] = useState(doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData[0]);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => {
    var _nocDocuments$filter$, _nocDocuments$filter$2;
    return {
      fileStoreId: nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$filter$ = nocDocuments.filter(item => {
        var _item$documentType3;
        return item === null || item === void 0 ? void 0 : (_item$documentType3 = item.documentType) === null || _item$documentType3 === void 0 ? void 0 : _item$documentType3.includes(doc === null || doc === void 0 ? void 0 : doc.code);
      })[0]) === null || _nocDocuments$filter$ === void 0 ? void 0 : _nocDocuments$filter$.fileStoreId,
      fileName: nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$filter$2 = nocDocuments.filter(item => {
        var _item$documentType4;
        return item === null || item === void 0 ? void 0 : (_item$documentType4 = item.documentType) === null || _item$documentType4 === void 0 ? void 0 : _item$documentType4.includes(doc === null || doc === void 0 ? void 0 : doc.code);
      })[0]) === null || _nocDocuments$filter$2 === void 0 ? void 0 : _nocDocuments$filter$2.fileName
    } || null;
  });
  const [newArray, setnewArray] = useState([]);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfile(e, key) {
    e && setSelectedDocument({
      documentType: key
    });
    e && setFile(e.file);
  }
  function getData(e, key) {
    var _newArr;
    let data, newArr;
    if ((e === null || e === void 0 ? void 0 : e.length) > 0) {
      var _formData$nocDocument2;
      data = Object.fromEntries(e);
      newArr = Object.values(data);
      newArr = formData === null || formData === void 0 ? void 0 : (_formData$nocDocument2 = formData.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.nocDocuments.filter(ob => ob.documentType === key);
      setnewArray(newArr);
      let newfiles = [];
      e === null || e === void 0 ? void 0 : e.map((doc, index) => {
        var _doc$, _doc$$fileStoreId, _doc$1$fileStoreId, _nocDocuments$find;
        newfiles.push({
          documentType: key,
          fileStoreId: doc === null || doc === void 0 ? void 0 : (_doc$ = doc[1]) === null || _doc$ === void 0 ? void 0 : (_doc$$fileStoreId = _doc$.fileStoreId) === null || _doc$$fileStoreId === void 0 ? void 0 : _doc$$fileStoreId.fileStoreId,
          documentUid: doc === null || doc === void 0 ? void 0 : (_doc$1$fileStoreId = doc[1].fileStoreId) === null || _doc$1$fileStoreId === void 0 ? void 0 : _doc$1$fileStoreId.fileStoreId,
          fileName: (doc === null || doc === void 0 ? void 0 : doc[0]) || "",
          id: nocDocuments ? (_nocDocuments$find = nocDocuments.find(x => x.documentType === key)) === null || _nocDocuments$find === void 0 ? void 0 : _nocDocuments$find.id : undefined
        });
      });
      const __documents = [...nocDocuments.filter(e => e.documentType !== key), ...newfiles];
      setNocDocuments(__documents);
    }
    (_newArr = newArr) === null || _newArr === void 0 ? void 0 : _newArr.map(ob => {
      if (!(ob !== null && ob !== void 0 && ob.file)) {
        ob.file = {};
      }
      ob.file.documentType = key;
      selectfile(ob, key);
    });
  }
  useEffect(() => {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.documentType && (nocDocuments.filter(ob => ob.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType)).length == 0 || newArray.filter(ob => {
      var _ob$file;
      return (ob === null || ob === void 0 ? void 0 : (_ob$file = ob.file) === null || _ob$file === void 0 ? void 0 : _ob$file.documentType) === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType);
    }).length !== nocDocuments.filter(ob => ob.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType)).length)) {
      setNocDocuments(prev => {
        var _doc$dropdownData2, _doc$dropdownData2$;
        if (uploadedFile === null || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === undefined || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileStoreId) === null) {
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile.fileStoreId);
        return [...filteredDocumentsByFileStoreId, {
          documentType: doc === null || doc === void 0 ? void 0 : (_doc$dropdownData2 = doc.dropdownData) === null || _doc$dropdownData2 === void 0 ? void 0 : (_doc$dropdownData2$ = _doc$dropdownData2[0]) === null || _doc$dropdownData2$ === void 0 ? void 0 : _doc$dropdownData2$.code,
          fileStoreId: uploadedFile.fileStoreId,
          documentUid: uploadedFile.fileStoreId,
          fileName: (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileName) || ""
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  const uploadedFilesPreFill = useMemo(() => {
    var _formData$nocDocument3, _formData$nocDocument4;
    let selectedUplDocs = [];
    const key = selectedDocument.code;
    formData === null || formData === void 0 ? void 0 : (_formData$nocDocument3 = formData.nocDocuments) === null || _formData$nocDocument3 === void 0 ? void 0 : (_formData$nocDocument4 = _formData$nocDocument3.nocDocuments) === null || _formData$nocDocument4 === void 0 ? void 0 : _formData$nocDocument4.filter(ob => ob.documentType === key).forEach(e => selectedUplDocs.push([e.fileName, {
      file: {
        name: e.fileName,
        type: e.documentType
      },
      fileStoreId: {
        fileStoreId: e.fileStoreId,
        tenantId
      }
    }]));
    return selectedUplDocs;
  }, [formData]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      border: "1px solid #D6D5D4",
      padding: "16px 8px 16px 8px",
      background: "#FAFAFA",
      borderRadius: "5px",
      marginBottom: "24px",
      marginTop: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h1", {
    style: {
      color: "#0B0C0C",
      lineHeight: "37px",
      fontWeight: "700",
      fontSize: "32px",
      fontFamily: "Roboto Condensed",
      paddingBottom: "24px"
    }
  }, t(`BPA_${doc === null || doc === void 0 ? void 0 : doc.nocType}_HEADER`)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      paddingBottom: "24px"
    }
  }, /*#__PURE__*/React__default.createElement("h1", {
    style: {
      color: "#0B0C0C",
      lineHeight: "19px",
      fontWeight: "700",
      fontSize: "16px",
      fontFamily: "Roboto",
      marginRight: "10px"
    }
  }, t(`BPA_${doc === null || doc === void 0 ? void 0 : doc.nocType}_LABEL`)), /*#__PURE__*/React__default.createElement("h1", null, doc === null || doc === void 0 ? void 0 : (_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.appNumberLink))), !window.location.href.includes("sendbacktocitizen") && /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: e => getData(e, doc.dropdownData[0].code),
    setuploadedstate: uploadedFilesPreFill,
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && !pdfLoading && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments,
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  }));
}

const ProfessionalDetails$2 = ({
  t,
  config,
  onSelect,
  userType,
  formData
}) => {
  var _formData$owners, _formData$owners2, _formData$owners2$own, _formData$professiona, _userInfo$info, _userInfo$info2, _userInfo$info3, _userInfo$info3$perma, _userInfo$info4, _userInfo$info4$perma, _userInfo$info5, _userInfo$info5$perma, _userInfo$info6, _userInfo$info6$perma, _userInfo$info7, _userInfo$info7$perma, _userInfo$info8, _userInfo$info8$perma, _userInfo$info9, _userInfo$info10, _userInfo$info10$perm, _formData$professiona2, _selcectedEng$permane, _selcectedEng$permane2, _selcectedEng$permane3, _selcectedEng$permane4, _selcectedEng$permane5, _selcectedEng$permane6;
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const userInfo = Digit.UserService.getUser();
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategory, setOwnershipCategory] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : _formData$owners.ownershipCategory);
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [error, setError] = useState(null);
  const [disable, setDisable] = useState(true);
  const [engineersArr, setEngsArr] = useState([]);
  const [selcectedEng, setSelectedEng] = useState(null);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && ownershipCategory.code.includes("MULTIPLEOWNERS") ? true : false;
  formData === null || formData === void 0 ? void 0 : (_formData$owners2 = formData.owners) === null || _formData$owners2 === void 0 ? void 0 : (_formData$owners2$own = _formData$owners2.owners) === null || _formData$owners2$own === void 0 ? void 0 : _formData$owners2$own.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false;
  });
  const [fields, setFeilds] = useState((formData === null || formData === void 0 ? void 0 : formData.professionals) && (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionals) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.professionals) || [{
    registrationNumber: "",
    name: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name) || "",
    mobileNumber: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber) || "",
    address: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : (_userInfo$info3$perma = _userInfo$info3.permanentAddress) === null || _userInfo$info3$perma === void 0 ? void 0 : _userInfo$info3$perma.address) || "",
    state: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info4 = userInfo.info) === null || _userInfo$info4 === void 0 ? void 0 : (_userInfo$info4$perma = _userInfo$info4.permanentAddress) === null || _userInfo$info4$perma === void 0 ? void 0 : _userInfo$info4$perma.state) || "",
    district: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info5 = userInfo.info) === null || _userInfo$info5 === void 0 ? void 0 : (_userInfo$info5$perma = _userInfo$info5.permanentAddress) === null || _userInfo$info5$perma === void 0 ? void 0 : _userInfo$info5$perma.district) || "",
    tehsil: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info6 = userInfo.info) === null || _userInfo$info6 === void 0 ? void 0 : (_userInfo$info6$perma = _userInfo$info6.permanentAddress) === null || _userInfo$info6$perma === void 0 ? void 0 : _userInfo$info6$perma.tehsil) || "",
    town: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info7 = userInfo.info) === null || _userInfo$info7 === void 0 ? void 0 : (_userInfo$info7$perma = _userInfo$info7.permanentAddress) === null || _userInfo$info7$perma === void 0 ? void 0 : _userInfo$info7$perma.town) || "",
    pinno: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info8 = userInfo.info) === null || _userInfo$info8 === void 0 ? void 0 : (_userInfo$info8$perma = _userInfo$info8.permanentAddress) === null || _userInfo$info8$perma === void 0 ? void 0 : _userInfo$info8$perma.pinNo) || "",
    emailId: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info9 = userInfo.info) === null || _userInfo$info9 === void 0 ? void 0 : _userInfo$info9.emailId) || "",
    class: "",
    university: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info10 = userInfo.info) === null || _userInfo$info10 === void 0 ? void 0 : (_userInfo$info10$perm = _userInfo$info10.permanentAddress) === null || _userInfo$info10$perm === void 0 ? void 0 : _userInfo$info10$perm.university) || ""
  }]);
  const [erfields, setErFeilds] = useState(selcectedEng && [selcectedEng] || (formData === null || formData === void 0 ? void 0 : formData.professionals) && (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionals) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.erprofessionals) || [{
    registrationNumber: "",
    name: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.name) || "",
    mobileNumber: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.mobileNumber) || "",
    address: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane = selcectedEng.permanentAddress) === null || _selcectedEng$permane === void 0 ? void 0 : _selcectedEng$permane.address) || "",
    state: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane2 = selcectedEng.permanentAddress) === null || _selcectedEng$permane2 === void 0 ? void 0 : _selcectedEng$permane2.state) || "",
    district: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane3 = selcectedEng.permanentAddress) === null || _selcectedEng$permane3 === void 0 ? void 0 : _selcectedEng$permane3.district) || "",
    tehsil: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane4 = selcectedEng.permanentAddress) === null || _selcectedEng$permane4 === void 0 ? void 0 : _selcectedEng$permane4.tehsil) || "",
    town: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane5 = selcectedEng.permanentAddress) === null || _selcectedEng$permane5 === void 0 ? void 0 : _selcectedEng$permane5.town) || "",
    pinno: (selcectedEng === null || selcectedEng === void 0 ? void 0 : (_selcectedEng$permane6 = selcectedEng.permanentAddress) === null || _selcectedEng$permane6 === void 0 ? void 0 : _selcectedEng$permane6.pinNo) || "",
    emailId: (selcectedEng === null || selcectedEng === void 0 ? void 0 : selcectedEng.emailId) || ""
  }]);
  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErOwnerName(i, e) {
    let units = [...erfields];
    units[i].name = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setRegistrationNo(i, e) {
    let units = [...fields];
    units[i].registrationNumber = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErRegistrationNo(i, e) {
    let units = [...erfields];
    units[i].registrationNumber = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setAddress(i, e) {
    let units = [...fields];
    units[i].address = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErAddress(i, e) {
    let units = [...erfields];
    units[i].address = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErEmail(i, e) {
    let units = [...erfields];
    units[i].emailId = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectDistrict(i, e) {
    let units = [...fields];
    units[i].district = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErDistrict(i, e) {
    let units = [...erfields];
    units[i].district = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTehsil(i, e) {
    let units = [...fields];
    units[i].tehsil = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTehsil(i, e) {
    let units = [...erfields];
    units[i].tehsil = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectTown(i, e) {
    let units = [...fields];
    units[i].town = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErTown(i, e) {
    let units = [...erfields];
    units[i].town = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectPinNO(i, e) {
    let units = [...fields];
    units[i].pinno = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErPinNO(i, e) {
    let units = [...erfields];
    units[i].pinno = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectClassCat(i, e) {
    let units = [...fields];
    units[i].class = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectUniversity(i, e) {
    let units = [...fields];
    units[i].university = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectState(i, e) {
    let units = [...fields];
    units[i].state = e.target.value;
    setFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectErState(i, e) {
    let units = [...erfields];
    units[i].state = e.target.value;
    setErFeilds(units);
    if (units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setErMobileNo(i, e) {
    let units = [...erfields];
    units[i].mobileNumber = e.target.value;
    setErFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(async () => {
    const tenantId = Digit.ULBService.getStateId();
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER"]
    });
    setEngsArr(structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user);
  }, []);
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const goNext = () => {
    var _fields$, _fields$2, _fields$3, _fields$4, _fields$5, _fields$6, _fields$7, _fields$8, _fields$9, _fields$10, _fields$11, _fields$12, _erfields$, _erfields$2, _erfields$3, _erfields$4, _erfields$5, _erfields$6, _erfields$7, _erfields$8, _erfields$9, _erfields$10, _erfields$11;
    const professionaldetail = {};
    professionaldetail.registrationNumber = (fields === null || fields === void 0 ? void 0 : (_fields$ = fields[0]) === null || _fields$ === void 0 ? void 0 : _fields$.registrationNumber) || "";
    professionaldetail.name = (fields === null || fields === void 0 ? void 0 : (_fields$2 = fields[0]) === null || _fields$2 === void 0 ? void 0 : _fields$2.name) || "";
    professionaldetail.mobileNumber = (fields === null || fields === void 0 ? void 0 : (_fields$3 = fields[0]) === null || _fields$3 === void 0 ? void 0 : _fields$3.mobileNumber) || "";
    professionaldetail.address = (fields === null || fields === void 0 ? void 0 : (_fields$4 = fields[0]) === null || _fields$4 === void 0 ? void 0 : _fields$4.address) || "";
    professionaldetail.state = (fields === null || fields === void 0 ? void 0 : (_fields$5 = fields[0]) === null || _fields$5 === void 0 ? void 0 : _fields$5.state) || "";
    professionaldetail.district = (fields === null || fields === void 0 ? void 0 : (_fields$6 = fields[0]) === null || _fields$6 === void 0 ? void 0 : _fields$6.district) || "";
    professionaldetail.tehsil = (fields === null || fields === void 0 ? void 0 : (_fields$7 = fields[0]) === null || _fields$7 === void 0 ? void 0 : _fields$7.tehsil) || "";
    professionaldetail.town = (fields === null || fields === void 0 ? void 0 : (_fields$8 = fields[0]) === null || _fields$8 === void 0 ? void 0 : _fields$8.town) || "";
    professionaldetail.pinNo = (fields === null || fields === void 0 ? void 0 : (_fields$9 = fields[0]) === null || _fields$9 === void 0 ? void 0 : _fields$9.pinno) || "";
    professionaldetail.emailId = (fields === null || fields === void 0 ? void 0 : (_fields$10 = fields[0]) === null || _fields$10 === void 0 ? void 0 : _fields$10.emailId) || "";
    professionaldetail.class = (fields === null || fields === void 0 ? void 0 : (_fields$11 = fields[0]) === null || _fields$11 === void 0 ? void 0 : _fields$11.class) || "";
    professionaldetail.university = (fields === null || fields === void 0 ? void 0 : (_fields$12 = fields[0]) === null || _fields$12 === void 0 ? void 0 : _fields$12.university) || "";
    professionaldetail.erregistrationNumber = (erfields === null || erfields === void 0 ? void 0 : (_erfields$ = erfields[0]) === null || _erfields$ === void 0 ? void 0 : _erfields$.registrationNumber) || "";
    professionaldetail.ername = (erfields === null || erfields === void 0 ? void 0 : (_erfields$2 = erfields[0]) === null || _erfields$2 === void 0 ? void 0 : _erfields$2.name) || "";
    professionaldetail.ermobileNumber = (erfields === null || erfields === void 0 ? void 0 : (_erfields$3 = erfields[0]) === null || _erfields$3 === void 0 ? void 0 : _erfields$3.mobileNumber) || "";
    professionaldetail.eraddress = (erfields === null || erfields === void 0 ? void 0 : (_erfields$4 = erfields[0]) === null || _erfields$4 === void 0 ? void 0 : _erfields$4.address) || "";
    professionaldetail.erstate = (erfields === null || erfields === void 0 ? void 0 : (_erfields$5 = erfields[0]) === null || _erfields$5 === void 0 ? void 0 : _erfields$5.state) || "";
    professionaldetail.erdistrict = (erfields === null || erfields === void 0 ? void 0 : (_erfields$6 = erfields[0]) === null || _erfields$6 === void 0 ? void 0 : _erfields$6.district) || "";
    professionaldetail.ertehsil = (erfields === null || erfields === void 0 ? void 0 : (_erfields$7 = erfields[0]) === null || _erfields$7 === void 0 ? void 0 : _erfields$7.tehsil) || "";
    professionaldetail.ertown = (erfields === null || erfields === void 0 ? void 0 : (_erfields$8 = erfields[0]) === null || _erfields$8 === void 0 ? void 0 : _erfields$8.town) || "";
    professionaldetail.erpinNo = (erfields === null || erfields === void 0 ? void 0 : (_erfields$9 = erfields[0]) === null || _erfields$9 === void 0 ? void 0 : _erfields$9.pinno) || "";
    professionaldetail.eremailId = (erfields === null || erfields === void 0 ? void 0 : (_erfields$10 = erfields[0]) === null || _erfields$10 === void 0 ? void 0 : _erfields$10.emailId) || "";
    professionaldetail.engineerUuid = (erfields === null || erfields === void 0 ? void 0 : (_erfields$11 = erfields[0]) === null || _erfields$11 === void 0 ? void 0 : _erfields$11.uuid) || "";
    if (currentTab == "1") {
      setCurrentTab("2");
      return;
    }
    onSelect(config.key, professionaldetail);
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 2,
    flow: "BPA"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: canmovenext || isDisable,
    forcedError: t(error),
    cardStyle: {
      margin: '1.25rem auto 2rem'
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")}`,
    value: "1",
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  }), /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")}`,
    value: "2",
    sx: {
      textTransform: 'none',
      p: '0 1rem'
    }
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, fields.map((field, index) => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative",
        zIndex: "100",
        left: "35px",
        marginTop: "-24.5px",
        marginLeft: Webview ? "-25px" : "-25px"
      }
    }, "+91"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA",
        padding: "0px 35px"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.registrationNumber,
      onChange: e => setRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "email",
      value: field.emailId,
      onChange: e => selectEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.address,
      onChange: e => setAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "state",
      value: field.state,
      onChange: e => selectState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: field.district,
      onChange: e => selectDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: field.tehsil,
      onChange: e => selectTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: field.town,
      onChange: e => selectTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: field.pinno,
      onChange: e => selectPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_CLASS_CATEGORIES")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "class",
      value: field.class,
      onChange: e => selectClassCat(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_UNIVERSITY_NAME")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "university",
      value: field.university,
      onChange: e => selectUniversity(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, erfields.map((field, index) => {
    var _field$permanentAddre, _field$permanentAddre2, _field$permanentAddre3, _field$permanentAddre4, _field$permanentAddre5, _field$permanentAddre6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: `${field}-${index}`
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: "solid",
        borderRadius: "5px",
        padding: "20px 20px 0",
        marginTop: "10px",
        borderColor: "#f3f3f3",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React__default.createElement(CardLabel, {
      variant: "h6"
    }, `${t("BPA_SELECT_STRUCTURAL_ENGINEER_LABEL")}`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
      name: "engineerType",
      optionKey: "name",
      options: engineersArr,
      onSelect: name => {
        setSelectedEng(name);
        setErFeilds([name]);
      },
      selectedOption: selcectedEng,
      t: t
    }), /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        marginBottom: "-15px"
      }
    }, `${t("CORE_COMMON_MOBILE_NUMBER")} *`), /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: "30px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "field-container"
    }, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      type: "text",
      t: t,
      isMandatory: false,
      optionKey: "i18nKey",
      name: "mobileNumber",
      value: field.mobileNumber,
      onChange: e => setErMobileNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "[6-9]{1}[0-9]{9}",
      type: "tel",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_NAME")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "name",
      value: field.name,
      onChange: e => setErOwnerName(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_REGISTRATION_NUMBER")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: field.registrationNumber,
      onChange: e => setErRegistrationNo(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "email",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "email",
      value: field.emailId,
      onChange: e => selectErEmail(index, e)
    }, {
      required: true,
      pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
      type: "email",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_ADDRESS")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre = field.permanentAddress) === null || _field$permanentAddre === void 0 ? void 0 : _field$permanentAddre.address) || (field === null || field === void 0 ? void 0 : field.address),
      onChange: e => setErAddress(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      style: {
        background: "#FAFAFA"
      },
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "registrationNumber",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre2 = field.permanentAddress) === null || _field$permanentAddre2 === void 0 ? void 0 : _field$permanentAddre2.state) || field.state,
      onChange: e => selectErState(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      type: "text",
      title: t("TL_NAME_ERROR_MESSAGE")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_DISTRICT")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "district",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre3 = field.permanentAddress) === null || _field$permanentAddre3 === void 0 ? void 0 : _field$permanentAddre3.district) || field.district,
      onChange: e => selectErDistrict(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TEHSIL")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "tehsil",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre4 = field.permanentAddress) === null || _field$permanentAddre4 === void 0 ? void 0 : _field$permanentAddre4.tehsil) || field.tehsil,
      onChange: e => selectErTehsil(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_TOWN")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "town",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre5 = field.permanentAddress) === null || _field$permanentAddre5 === void 0 ? void 0 : _field$permanentAddre5.town) || field.town,
      onChange: e => selectErTown(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("CORE_COMMON_PINNO")), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
      t: t,
      type: "text",
      isMandatory: true,
      optionKey: "i18nKey",
      name: "pinno",
      value: (field === null || field === void 0 ? void 0 : (_field$permanentAddre6 = field.permanentAddress) === null || _field$permanentAddre6 === void 0 ? void 0 : _field$permanentAddre6.pinNo) || field.pinno,
      onChange: e => selectErPinNO(index, e)
    }, validation = {
      isRequired: true,
      pattern: "^[a-zA-Z-.`' ]*$",
      title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
    }))));
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast
  }));
};

const StakeholderDocsRequired = ({
  onSelect,
  onSkip,
  config
}) => {
  var _data$StakeholderRegi, _data$StakeholderRegi2, _data$StakeholderRegi3, _data$StakeholderRegi4;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const {
    data,
    isLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    if (tenantId) Digit.LocalizationService.getLocale({
      modules: [`rainmaker-bpareg`],
      locale: Digit.StoreData.getCurrentLanguage(),
      tenantId: `${tenantId}`
    });
  }, [tenantId]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_NEW_BUILDING_HEADER`)), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      color: "#0B0C0C",
      marginTop: "12px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px"
    }
  }, t(`BPA_NEW_BUILDING_PERMIT_DESCRIPTION`)), isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, data === null || data === void 0 ? void 0 : (_data$StakeholderRegi = data.StakeholderRegistraition) === null || _data$StakeholderRegi === void 0 ? void 0 : (_data$StakeholderRegi2 = _data$StakeholderRegi.TradeTypetoRoleMapping) === null || _data$StakeholderRegi2 === void 0 ? void 0 : (_data$StakeholderRegi3 = _data$StakeholderRegi2[0]) === null || _data$StakeholderRegi3 === void 0 ? void 0 : (_data$StakeholderRegi4 = _data$StakeholderRegi3.docTypes) === null || _data$StakeholderRegi4 === void 0 ? void 0 : _data$StakeholderRegi4.map((doc, index) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontWeight: 700,
      marginBottom: "8px"
    },
    key: index
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      minWidth: "20px"
    }
  }, `${index + 1}.`, "\xA0"), /*#__PURE__*/React__default.createElement("div", null, ` ${t(`BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : doc.code.replace('.', '_')}`)}`))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      minWidth: "20px"
    }
  }), doc !== null && doc !== void 0 && doc.info ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#505A5F",
      fontSize: "16px"
    }
  }, `${t(doc === null || doc === void 0 ? void 0 : doc.info.replace('.', '_'))}`) : null))))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: onSelect
  }))));
};

const GIS = ({
  t,
  config,
  onSelect,
  formData: _formData = {},
  handleRemove,
  onSave
}) => {
  var _formData$address, _formData$address2;
  const [pincode, setPincode] = useState((_formData === null || _formData === void 0 ? void 0 : (_formData$address = _formData.address) === null || _formData$address === void 0 ? void 0 : _formData$address.pincode) || "");
  const [geoLocation, setGeoLocation] = useState((_formData === null || _formData === void 0 ? void 0 : (_formData$address2 = _formData.address) === null || _formData$address2 === void 0 ? void 0 : _formData$address2.geoLocation) || {});
  const tenants = Digit.Hooks.obps.useTenants();
  const [pincodeServicability, setPincodeServicability] = useState(null);
  const [placeName, setPlaceName] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  let Webview = !Digit.Utils.browser.isMobile();
  const onSkip = () => onSelect();
  const onChange = (code, location, place) => {
    setPincodeServicability(null);
    const foundValue = tenants === null || tenants === void 0 ? void 0 : tenants.find(obj => {
      var _obj$pincode;
      return (_obj$pincode = obj.pincode) === null || _obj$pincode === void 0 ? void 0 : _obj$pincode.find(item => item == code);
    });
    if (!foundValue) {
      setPincodeServicability("BPA_COMMON_PINCODE_NOT_SERVICABLE");
      setPincode("");
      setGeoLocation({});
      setPlaceName("");
    } else {
      setPincode(code);
      setGeoLocation(location);
      setPlaceName(place);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      background: "#00000050",
      width: "100%",
      height: "100vh",
      top: "0",
      left: "0"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      marginTop: "60px"
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    style: {
      float: "left",
      position: "relative",
      bottom: "32px",
      marginTop: Webview ? "62px" : "57px",
      marginLeft: Webview ? "26%" : "20px"
    },
    width: "24",
    height: "24",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M14.9999 9.66666C12.0533 9.66666 9.66658 12.0533 9.66658 15C9.66658 17.9467 12.0533 20.3333 14.9999 20.3333C17.9466 20.3333 20.3333 17.9467 20.3333 15C20.3333 12.0533 17.9466 9.66666 14.9999 9.66666ZM26.9199 13.6667C26.3066 8.10666 21.8933 3.69333 16.3333 3.07999V0.333328H13.6666V3.07999C8.10658 3.69333 3.69325 8.10666 3.07992 13.6667H0.333252V16.3333H3.07992C3.69325 21.8933 8.10658 26.3067 13.6666 26.92V29.6667H16.3333V26.92C21.8933 26.3067 26.3066 21.8933 26.9199 16.3333H29.6666V13.6667H26.9199ZM14.9999 24.3333C9.83992 24.3333 5.66658 20.16 5.66658 15C5.66658 9.83999 9.83992 5.66666 14.9999 5.66666C20.1599 5.66666 24.3333 9.83999 24.3333 15C24.3333 20.16 20.1599 24.3333 14.9999 24.3333Z",
    fill: "#505A5F"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: Webview ? {
      marginLeft: "25%",
      marginRight: "25%"
    } : {}
  }, /*#__PURE__*/React__default.createElement(LocationSearchCard, {
    style: {
      position: "relative",
      marginTop: "100px",
      marginBottom: "-100px"
    },
    header: t("BPA_GIS_LABEL"),
    cardText: t(""),
    nextText: t("BPA_PIN_LOCATION_LABEL"),
    skip: onSkip,
    t: t,
    position: geoLocation,
    onSave: () => onSave(geoLocation, pincode, placeName),
    onChange: (code, location, place) => onChange(code, location, place),
    disabled: pincode === "",
    forcedError: t(pincodeServicability),
    isPlaceRequired: true,
    handleRemove: handleRemove,
    Webview: Webview,
    isPopUp: true
  }))));
};

const OCEDCRDocsRequired = ({
  onSelect,
  onSkip,
  config
}) => {
  const {
    t
  } = useTranslation();
  const data = [{
    code: "BPA_PERMIT_NUMBER_OC_SCRUTINY_LABEL"
  }, {
    code: "BPA_PERMIT_DATE_LABEL"
  }, {
    code: "BPA_OC_PLAN_DXF_FILE"
  }];
  const goNext = () => {
    onSelect();
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_OC_NEW_BUILDING_CONSTRUCTION_LABEL`)), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      color: "#0B0C0C",
      marginTop: "12px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px"
    }
  }, t(`OBPS_OCEDCR_BUILDING_PERMIT_DESCRIPTION`)), /*#__PURE__*/React__default.createElement(Fragment$2, null, data === null || data === void 0 ? void 0 : data.map((doc, index) => /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      fontWeight: 700
    },
    key: index
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, `${index + 1}.`, "\xA0"), /*#__PURE__*/React__default.createElement("div", null, ` ${t(doc === null || doc === void 0 ? void 0 : doc.code.replace('.', '_'))}`))))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: goNext
  })), /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
    info: t("CS_FILE_APPLICATION_INFO_LABEL"),
    text: t(`OBPS_OC_DOCS_FILE_SIZE`),
    className: "info-banner-wrap-citizen-override"
  }));
};

const OCeDCRScrutiny = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  ownerIndex: _ownerIndex = 0,
  addNewOwner,
  isShowToast
}) => {
  var _formData$ScrutinyDet, _formData$ScrutinyDet2, _permitEdcrData$planD, _permitEdcrData$planD2, _permitEdcrData$planD3, _permitEdcrData$planD4, _permitEdcrData$planD5;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [permitNumber, setPermitNumber] = useState(formData === null || formData === void 0 ? void 0 : (_formData$ScrutinyDet = formData.ScrutinyDetails) === null || _formData$ScrutinyDet === void 0 ? void 0 : _formData$ScrutinyDet.ocPermitNumber);
  const [permitDate, setPermitDate] = useState(formData === null || formData === void 0 ? void 0 : (_formData$ScrutinyDet2 = formData.ScrutinyDetails) === null || _formData$ScrutinyDet2 === void 0 ? void 0 : _formData$ScrutinyDet2.ocPermitdate);
  const [permitEdcrData, setPermitEdcrData] = useState(formData === null || formData === void 0 ? void 0 : formData.ScrutinyDetails);
  const [showToast, setShowToast] = useState(null);
  let validation = {};
  function setPermitNo(e) {
    setPermitNumber(e.target.value);
  }
  function setOCPermitDate(e) {
    setPermitDate(e);
  }
  function onAdd() {}
  const onSkip = () => {};
  const handleSubmit = () => {
    const data = {};
    data.file = file;
    onSelect(config.key, data);
  };
  const getSearchResults = async () => {
    setPermitEdcrData({});
    setShowToast(null);
    let queryObj = {
      permitDate: convertDateToEpoch(permitDate),
      approvalNo: permitNumber
    };
    Digit.OBPSService.BPASearch(tenantId, queryObj).then((result, err) => {
      var _result$BPA, _result$BPA6;
      if ((result === null || result === void 0 ? void 0 : (_result$BPA = result.BPA) === null || _result$BPA === void 0 ? void 0 : _result$BPA.length) > 0) {
        var _result$BPA2, _result$BPA2$, _result$BPA3, _result$BPA3$, _result$BPA4, _result$BPA4$;
        const edcrNumber = result === null || result === void 0 ? void 0 : (_result$BPA2 = result.BPA) === null || _result$BPA2 === void 0 ? void 0 : (_result$BPA2$ = _result$BPA2[0]) === null || _result$BPA2$ === void 0 ? void 0 : _result$BPA2$.edcrNumber;
        const tenantIdForEdcr = result === null || result === void 0 ? void 0 : (_result$BPA3 = result.BPA) === null || _result$BPA3 === void 0 ? void 0 : (_result$BPA3$ = _result$BPA3[0]) === null || _result$BPA3$ === void 0 ? void 0 : _result$BPA3$.tenantId;
        if (permitDate === convertEpochToDate(result === null || result === void 0 ? void 0 : (_result$BPA4 = result.BPA) === null || _result$BPA4 === void 0 ? void 0 : (_result$BPA4$ = _result$BPA4[0]) === null || _result$BPA4$ === void 0 ? void 0 : _result$BPA4$.approvalDate)) {
          Digit.OBPSService.scrutinyDetails(tenantIdForEdcr, {
            edcrNumber: edcrNumber
          }).then(response => {
            var _userInfo$info;
            const userInfo = Digit.UserService.getUser();
            const queryObject = {
              0: {
                tenantId: stateId
              },
              1: {
                id: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.id
              }
            };
            Digit.OBPSService.BPAREGSearch(tenantId, queryObject).then((License, error) => {
              var _userInfo$info2, _response$edcrDetail;
              let architectName = "";
              for (let i = 0; i < License.Licenses.length; i++) {
                if (License.Licenses[i].status === "APPROVED") {
                  architectName = License.Licenses[i].tradeLicenseDetail.owners[0].name;
                }
              }
              if (!architectName) architectName = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.name;
              if (!architectName) architectName = License.Licenses[0].tradeLicenseDetail.owners[0].name;
              if ((response === null || response === void 0 ? void 0 : (_response$edcrDetail = response.edcrDetail) === null || _response$edcrDetail === void 0 ? void 0 : _response$edcrDetail.length) > 0) {
                var _result$BPA5, _result$BPA5$, _result$BPA5$$landInf, _result$BPA5$$landInf2, _isPrimaryOwner$, _response$edcrDetail2;
                const isPrimaryOwner = result === null || result === void 0 ? void 0 : (_result$BPA5 = result.BPA) === null || _result$BPA5 === void 0 ? void 0 : (_result$BPA5$ = _result$BPA5[0]) === null || _result$BPA5$ === void 0 ? void 0 : (_result$BPA5$$landInf = _result$BPA5$.landInfo) === null || _result$BPA5$$landInf === void 0 ? void 0 : (_result$BPA5$$landInf2 = _result$BPA5$$landInf.owners) === null || _result$BPA5$$landInf2 === void 0 ? void 0 : _result$BPA5$$landInf2.filter(data => data.isPrimaryOwner && data.isPrimaryOwner != "false");
                response.edcrDetail[0].applicantName = isPrimaryOwner === null || isPrimaryOwner === void 0 ? void 0 : (_isPrimaryOwner$ = isPrimaryOwner[0]) === null || _isPrimaryOwner$ === void 0 ? void 0 : _isPrimaryOwner$.name;
                response.edcrDetail[0].ocPermitNumber = permitNumber;
                response.edcrDetail[0].ocPermitdate = permitDate;
                response.edcrDetail[0].appliedBy = architectName;
                setPermitEdcrData(response === null || response === void 0 ? void 0 : (_response$edcrDetail2 = response.edcrDetail) === null || _response$edcrDetail2 === void 0 ? void 0 : _response$edcrDetail2[0]);
              }
            }).catch(e => {
              var _e$response, _e$response$data, _e$response$data$Erro;
              setShowToast({
                key: "error",
                error: true,
                message: (e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message) || null
              });
            });
          }).catch(e => {
            var _e$response2, _e$response2$data, _e$response2$data$Err;
            setShowToast({
              key: "error",
              error: true,
              message: (e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$Err = _e$response2$data.Errors[0]) === null || _e$response2$data$Err === void 0 ? void 0 : _e$response2$data$Err.message) || null
            });
          });
        } else {
          setShowToast({
            key: "error",
            warning: true,
            message: t("ERR_FILL_EDCR_PERMIT_INCORRECT_DATE")
          });
        }
      } else if ((result === null || result === void 0 ? void 0 : (_result$BPA6 = result.BPA) === null || _result$BPA6 === void 0 ? void 0 : _result$BPA6.length) == 0) {
        setShowToast({
          key: "error",
          error: true,
          message: t("BPA_NO_REC_FOUND_LABEL")
        });
      }
    }).catch(e => {
      var _e$response3, _e$response3$data, _e$response3$data$Err;
      setShowToast({
        key: "error",
        error: true,
        message: (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$Err = _e$response3$data.Errors[0]) === null || _e$response3$data$Err === void 0 ? void 0 : _e$response3$data$Err.message) || null
      });
    });
  };
  const routeToNextPage = () => {
    onSelect(config.key, permitEdcrData);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: !permitNumber,
    onAdd: onAdd,
    isMultipleAllow: true
  }, /*#__PURE__*/React__default.createElement(CardCaption, null, `${t("BPA_OC_NEW_BUILDING_CONSTRUCTION_LABEL")}`), /*#__PURE__*/React__default.createElement(CardHeader, null, `${t("BPA_OC_EDCR_SCRUTINY_LABEL")}`), /*#__PURE__*/React__default.createElement(CardText, null, `${t("BPA_PROVIDE_BPN_AND_BPD_APP_LABEL")}`), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("EDCR_BUILDING_PERMIT_NUM_LABEL")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "permitNumber",
    onChange: setPermitNo,
    value: permitNumber
  }, validation = {
    isRequired: true,
    pattern: getPattern("Name"),
    title: t("BPA_INVALID_NAME")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("EDCR_BUILDING_PERMIT_DATE_LABEL")} *`), /*#__PURE__*/React__default.createElement(DatePicker, {
    date: permitDate,
    name: "permitDate",
    onChange: setOCPermitDate
  }), /*#__PURE__*/React__default.createElement("div", {
    onClick: getSearchResults
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("ACTION_TEST_BPA_STAKE_HOLDER_SEARCH"),
    disabled: !permitNumber || !permitDate
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: () => {
      setShowToast(null);
    }
  })), permitEdcrData !== null && permitEdcrData !== void 0 && permitEdcrData.edcrNumber ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: !permitNumber,
    onAdd: onAdd,
    isMultipleAllow: true
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("REPORT_FSM_RESULT_APPLICANTNAME")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.applicantName),
    className: "border-none"
  }), /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.applicationSubType),
    className: "border-none"
  }), /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("EDCR_TOTAL_BUILD_UP_AREA_LABEL")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : (_permitEdcrData$planD = permitEdcrData.planDetail) === null || _permitEdcrData$planD === void 0 ? void 0 : (_permitEdcrData$planD2 = _permitEdcrData$planD.virtualBuilding) === null || _permitEdcrData$planD2 === void 0 ? void 0 : _permitEdcrData$planD2.totalBuitUpArea),
    className: "border-none"
  }), /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("EDCR_BUILDING_HEIGHT_LABEL")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : (_permitEdcrData$planD3 = permitEdcrData.planDetail) === null || _permitEdcrData$planD3 === void 0 ? void 0 : (_permitEdcrData$planD4 = _permitEdcrData$planD3.blocks[0]) === null || _permitEdcrData$planD4 === void 0 ? void 0 : (_permitEdcrData$planD5 = _permitEdcrData$planD4.building) === null || _permitEdcrData$planD5 === void 0 ? void 0 : _permitEdcrData$planD5.buildingHeight),
    className: "border-none"
  }), /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("BPA_ARCHITECT_NAME_LABEL")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.appliedBy),
    className: "border-none"
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement("h1", {
    style: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "700",
      padding: "0px 0px 16px 0px"
    }
  }, `${t("BPA_PERMIT_EDCR_DETAILS_LABEL")}`), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    label: `${t("BPA_EDCR_NO_LABEL")}`,
    text: t(permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.edcrNumber),
    className: "border-none"
  })), /*#__PURE__*/React__default.createElement("h1", {
    style: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "700",
      padding: "0px 0px 16px 0px"
    }
  }, `${t("BPA_UPLOADED_PLAN_DIAGRAM_LABEL")}`), /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.updatedDxfFile,
    style: {
      minWidth: "160px",
      marginRight: "20px"
    },
    key: permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.updatedDxfFile
  }, /*#__PURE__*/React__default.createElement(PDFSvg, null), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t("BPA_UPLOADED_PLAN_DXF"))), /*#__PURE__*/React__default.createElement("h1", {
    style: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "700",
      padding: "0px 0px 16px 0px"
    }
  }, `${t("BPA_SCRUTINY_REPORT_OUTPUT_LABEL")}`), /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.planReport,
    style: {
      minWidth: "160px",
      marginRight: "20px"
    },
    key: permitEdcrData === null || permitEdcrData === void 0 ? void 0 : permitEdcrData.planReport
  }, /*#__PURE__*/React__default.createElement(PDFSvg, null), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      fontWeight: "bold",
      fontSize: "14px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t("BPA_SCRUTINY_REPORT_PDF"))), /*#__PURE__*/React__default.createElement("div", {
    onClick: routeToNextPage
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_PROCEED_OC_SCRUTINY_LABEL")
  }))) : null);
};

const OCUploadPlanDiagram = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  ownerIndex: _ownerIndex = 0,
  addNewOwner,
  isShowToast,
  isSubmitBtnDisable,
  setIsShowToast
}) => {
  var _formData$uploadData2;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [uploadedFile, setUploadedFile] = useState(() => {
    var _formData$uploadData;
    return (formData === null || formData === void 0 ? void 0 : (_formData$uploadData = formData.uploadData) === null || _formData$uploadData === void 0 ? void 0 : _formData$uploadData.file) || null;
  });
  const [file, setFile] = useState(formData === null || formData === void 0 ? void 0 : (_formData$uploadData2 = formData.uploadData) === null || _formData$uploadData2 === void 0 ? void 0 : _formData$uploadData2.file);
  const [uploadMessage, setUploadMessage] = useState("");
  const history = useHistory();
  function selectfile(e) {
    setUploadedFile(e.target.files[0]);
    setFile(e.target.files[0]);
  }
  const onSkip = () => {};
  useEffect(() => {
    if (uploadMessage || isShowToast) {
      setUploadedFile(null);
      setFile("");
      setUploadMessage("");
    }
    if (isShowToast) {
      history.push(`/digit-ui/citizen/obps/edcrscrutiny/oc-apply/acknowledgement`, {
        data: isShowToast !== null && isShowToast !== void 0 && isShowToast.label ? isShowToast === null || isShowToast === void 0 ? void 0 : isShowToast.label : "BPA_INTERNAL_SERVER_ERROR",
        type: "ERROR"
      });
    }
  }, [uploadMessage, isShowToast, isSubmitBtnDisable]);
  function onAdd() {}
  const handleSubmit = () => {
    const data = {};
    data.file = file;
    onSelect(config.key, data, true, true);
  };
  if (isSubmitBtnDisable) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: !file || isSubmitBtnDisable,
    onAdd: onAdd,
    isMultipleAllow: true
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_OC_PLAN_DIAGRAM_DXF")} *`), /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "oc-doc",
    extraStyleName: "propertyCreate",
    accept: ".dxf",
    onUpload: selectfile,
    onDelete: () => {
      setUploadedFile(null);
      setFile("");
    },
    message: uploadedFile ? `1 ${t(`PT_ACTION_FILEUPLOADED`)}` : t(`ES_NO_FILE_SELECTED_LABEL`),
    uploadMessage: uploadMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      disabled: "true",
      height: "30px",
      width: "100%",
      fontSize: "14px"
    }
  }), isShowToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: isShowToast.key,
    label: t(isShowToast.label),
    onClose: () => setIsShowToast(null),
    isDleteBtn: true
  }));
};

const OCBasicDetails = ({
  formData,
  onSelect,
  config
}) => {
  var _formData$data, _formData$data2, _formData$data3, _formData$data4, _mdmsData$BPA, _data$planDetail, _data$planDetail$plot, _data$planDetail2, _data$planDetail9, _data$planDetail9$pla, _mdmsData$BPA5, _data$planDetail10, _data$planDetail10$pl, _data$planDetail11, _data$planDetail12, _data$planDetail12$pl;
  const [showToast, setShowToast] = useState(null);
  const [scrutinyNumber, setScrutinyNumber] = useState(formData === null || formData === void 0 ? void 0 : (_formData$data = formData.data) === null || _formData$data === void 0 ? void 0 : _formData$data.scrutinyNumber);
  const isMobile = window.Digit.Utils.browser.isMobile();
  const [isDisabled, setIsDisabled] = useState(formData !== null && formData !== void 0 && (_formData$data2 = formData.data) !== null && _formData$data2 !== void 0 && _formData$data2.scrutinyNumber ? true : false);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const [bpaData, setBpaData] = useState((formData === null || formData === void 0 ? void 0 : (_formData$data3 = formData.data) === null || _formData$data3 === void 0 ? void 0 : _formData$data3.bpaData) || {});
  const [data, setData] = useState((formData === null || formData === void 0 ? void 0 : (_formData$data4 = formData.data) === null || _formData$data4 === void 0 ? void 0 : _formData$data4.edcrDetails) || null);
  const [isLoadingApplication, setIsLoadingApplication] = useState(false);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["RiskTypeComputation"]);
  const riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, data === null || data === void 0 ? void 0 : (_data$planDetail = data.planDetail) === null || _data$planDetail === void 0 ? void 0 : (_data$planDetail$plot = _data$planDetail.plot) === null || _data$planDetail$plot === void 0 ? void 0 : _data$planDetail$plot.area, data === null || data === void 0 ? void 0 : (_data$planDetail2 = data.planDetail) === null || _data$planDetail2 === void 0 ? void 0 : _data$planDetail2.blocks);
  useEffect(() => {}, showToast);
  const getOCEDCRTotalDetails = async () => {
    var _otherData$edcrDetail, _otherData$edcrDetail2, _details$ocEdcrDetail;
    setData(null);
    setBpaData(null);
    setIsLoadingApplication(true);
    const details = await ocScrutinyDetailsData(scrutinyNumber === null || scrutinyNumber === void 0 ? void 0 : scrutinyNumber.edcrNumber, state);
    setIsLoadingApplication(false);
    if ((details === null || details === void 0 ? void 0 : details.type) == "ERROR") {
      setShowToast({
        key: "true",
        message: details === null || details === void 0 ? void 0 : details.message
      });
      setData(null);
      setBpaData(null);
    }
    let otherData = details === null || details === void 0 ? void 0 : details.otherDetails;
    let ocData = details === null || details === void 0 ? void 0 : details.ocEdcrDetails;
    if (otherData && ocData && ocData !== null && ocData !== void 0 && ocData.tenantId && otherData !== null && otherData !== void 0 && (_otherData$edcrDetail = otherData.edcrDetails) !== null && _otherData$edcrDetail !== void 0 && (_otherData$edcrDetail2 = _otherData$edcrDetail[0]) !== null && _otherData$edcrDetail2 !== void 0 && _otherData$edcrDetail2.tenantId) {
      var _otherData$edcrDetail3, _otherData$edcrDetail4, _otherData$bpaApprova, _otherData$bpaApprova2, _otherData$bpaRespons, _otherData$bpaRespons2, _otherData$bpaRespons3, _otherData$bpaRespons4, _otherData$bpaRespons5, _otherData$bpaRespons6;
      if ((otherData === null || otherData === void 0 ? void 0 : (_otherData$edcrDetail3 = otherData.edcrDetails) === null || _otherData$edcrDetail3 === void 0 ? void 0 : (_otherData$edcrDetail4 = _otherData$edcrDetail3[0]) === null || _otherData$edcrDetail4 === void 0 ? void 0 : _otherData$edcrDetail4.tenantId) != (ocData === null || ocData === void 0 ? void 0 : ocData.tenantId)) {
        setShowToast({
          key: "true",
          message: "BPA_INVALID_PERMIT_CITY"
        });
        return;
      } else if ((otherData === null || otherData === void 0 ? void 0 : (_otherData$bpaApprova = otherData.bpaApprovalResponse) === null || _otherData$bpaApprova === void 0 ? void 0 : (_otherData$bpaApprova2 = _otherData$bpaApprova[0]) === null || _otherData$bpaApprova2 === void 0 ? void 0 : _otherData$bpaApprova2.edcrNumber) === (ocData === null || ocData === void 0 ? void 0 : ocData.edcrNumber) && ((otherData === null || otherData === void 0 ? void 0 : (_otherData$bpaRespons = otherData.bpaResponse) === null || _otherData$bpaRespons === void 0 ? void 0 : (_otherData$bpaRespons2 = _otherData$bpaRespons[0]) === null || _otherData$bpaRespons2 === void 0 ? void 0 : _otherData$bpaRespons2.status) != "REJECTED" && (otherData === null || otherData === void 0 ? void 0 : (_otherData$bpaRespons3 = otherData.bpaResponse) === null || _otherData$bpaRespons3 === void 0 ? void 0 : (_otherData$bpaRespons4 = _otherData$bpaRespons3[0]) === null || _otherData$bpaRespons4 === void 0 ? void 0 : _otherData$bpaRespons4.status) != "PERMIT REVOCATION" || (otherData === null || otherData === void 0 ? void 0 : (_otherData$bpaRespons5 = otherData.bpaResponse) === null || _otherData$bpaRespons5 === void 0 ? void 0 : (_otherData$bpaRespons6 = _otherData$bpaRespons5[0]) === null || _otherData$bpaRespons6 === void 0 ? void 0 : _otherData$bpaRespons6.status) != "INITIATED")) {
        setShowToast({
          key: "true",
          message: "APPLICATION_NUMBER_ALREADY_EXISTS"
        });
        return;
      } else {
        sessionStorage.setItem("checkForProcced", JSON.stringify(false));
        setShowToast(null);
        setData(data);
      }
    }
    if (details !== null && details !== void 0 && (_details$ocEdcrDetail = details.ocEdcrDetails) !== null && _details$ocEdcrDetail !== void 0 && _details$ocEdcrDetail.edcrNumber) {
      setData(details === null || details === void 0 ? void 0 : details.ocEdcrDetails);
      setBpaData(details === null || details === void 0 ? void 0 : details.otherDetails);
      setShowToast(null);
    }
  };
  const handleKeyPress = async event => {
    var _scrutinyNumber$edcrN;
    if (!(scrutinyNumber !== null && scrutinyNumber !== void 0 && (_scrutinyNumber$edcrN = scrutinyNumber.edcrNumber) !== null && _scrutinyNumber$edcrN !== void 0 && _scrutinyNumber$edcrN.startsWith("OC"))) setShowToast({
      key: "true",
      message: t("BPA_INVALID_OCEDCR_NO"),
      labelName: "Please enter the valid OCeDCR Number."
    });else {
      if (event.key === "Enter") {
        const handleData = await getOCEDCRTotalDetails();
      }
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const noTocloseToast = () => {
    setShowToast(null);
  };
  const yesTocloseToast = () => {
    sessionStorage.setItem("checkForProcced", JSON.stringify(true));
    handleSubmit();
  };
  const handleSearch = async event => {
    var _scrutinyNumber$edcrN2;
    if (!(scrutinyNumber !== null && scrutinyNumber !== void 0 && (_scrutinyNumber$edcrN2 = scrutinyNumber.edcrNumber) !== null && _scrutinyNumber$edcrN2 !== void 0 && _scrutinyNumber$edcrN2.startsWith("OC"))) setShowToast({
      key: "true",
      message: t("BPA_INVALID_OCEDCR_NO"),
      labelName: "Please enter the valid OCeDCR Number."
    });else {
      const handleData = await getOCEDCRTotalDetails();
    }
  };
  const getDetails = async () => {
    const handleData = await getOCEDCRTotalDetails();
  };
  let disableVlaue = sessionStorage.getItem("isEDCRDisable");
  disableVlaue = JSON.parse(disableVlaue);
  useEffect(() => {
    if (disableVlaue) {
      let edcrApi = sessionStorage.getItem("isEDCRAPIType");
      edcrApi = edcrApi ? JSON.parse(edcrApi) : false;
      if (!edcrApi || !data) {
        sessionStorage.setItem("isEDCRAPIType", JSON.stringify(true));
        getDetails();
      }
    }
  }, []);
  const handleSubmit = event => {
    let isProccedToNextStep = false;
    if (bpaData && data) {
      var _bpaData$edcrDetails, _ocBpaEdcrDetails$pla, _ocBpaEdcrDetails$pla2, _bpaEdcrDetails$planD, _bpaEdcrDetails$planD2, _ocBpaEdcrDetails$pla3, _ocBpaEdcrDetails$pla4, _bpaEdcrDetails$planD3, _bpaEdcrDetails$planD4, _mdmsData$BPA2, _ocBpaEdcrDetails$pla5, _ocBpaEdcrDetails$pla6, _data$planDetail3, _mdmsData$BPA3, _bpaEdcrDetails$planD5, _bpaEdcrDetails$planD6, _data$planDetail4;
      const bpaEdcrDetails = (bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$edcrDetails = bpaData.edcrDetails) === null || _bpaData$edcrDetails === void 0 ? void 0 : _bpaData$edcrDetails[0]) || {};
      const ocBpaEdcrDetails = data || {};
      const ocEdcrKathaNo = ocBpaEdcrDetails === null || ocBpaEdcrDetails === void 0 ? void 0 : (_ocBpaEdcrDetails$pla = ocBpaEdcrDetails.planDetail) === null || _ocBpaEdcrDetails$pla === void 0 ? void 0 : (_ocBpaEdcrDetails$pla2 = _ocBpaEdcrDetails$pla.planInformation) === null || _ocBpaEdcrDetails$pla2 === void 0 ? void 0 : _ocBpaEdcrDetails$pla2.khataNo;
      const edcrKathaNo = bpaEdcrDetails === null || bpaEdcrDetails === void 0 ? void 0 : (_bpaEdcrDetails$planD = bpaEdcrDetails.planDetail) === null || _bpaEdcrDetails$planD === void 0 ? void 0 : (_bpaEdcrDetails$planD2 = _bpaEdcrDetails$planD.planInformation) === null || _bpaEdcrDetails$planD2 === void 0 ? void 0 : _bpaEdcrDetails$planD2.khataNo;
      const ocEdcrPlotNo = ocBpaEdcrDetails === null || ocBpaEdcrDetails === void 0 ? void 0 : (_ocBpaEdcrDetails$pla3 = ocBpaEdcrDetails.planDetail) === null || _ocBpaEdcrDetails$pla3 === void 0 ? void 0 : (_ocBpaEdcrDetails$pla4 = _ocBpaEdcrDetails$pla3.planInformation) === null || _ocBpaEdcrDetails$pla4 === void 0 ? void 0 : _ocBpaEdcrDetails$pla4.plotNo;
      const edcrPlotNo = bpaEdcrDetails === null || bpaEdcrDetails === void 0 ? void 0 : (_bpaEdcrDetails$planD3 = bpaEdcrDetails.planDetail) === null || _bpaEdcrDetails$planD3 === void 0 ? void 0 : (_bpaEdcrDetails$planD4 = _bpaEdcrDetails$planD3.planInformation) === null || _bpaEdcrDetails$planD4 === void 0 ? void 0 : _bpaEdcrDetails$planD4.plotNo;
      const riskTypes = {
        LOW: 0,
        MEDIUM: 1,
        HIGH: 2
      };
      const ocEdcrRiskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, ocBpaEdcrDetails === null || ocBpaEdcrDetails === void 0 ? void 0 : (_ocBpaEdcrDetails$pla5 = ocBpaEdcrDetails.planDetail) === null || _ocBpaEdcrDetails$pla5 === void 0 ? void 0 : (_ocBpaEdcrDetails$pla6 = _ocBpaEdcrDetails$pla5.plot) === null || _ocBpaEdcrDetails$pla6 === void 0 ? void 0 : _ocBpaEdcrDetails$pla6.area, data === null || data === void 0 ? void 0 : (_data$planDetail3 = data.planDetail) === null || _data$planDetail3 === void 0 ? void 0 : _data$planDetail3.blocks);
      const edcrRisktype = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA3 = mdmsData.BPA) === null || _mdmsData$BPA3 === void 0 ? void 0 : _mdmsData$BPA3.RiskTypeComputation, bpaEdcrDetails === null || bpaEdcrDetails === void 0 ? void 0 : (_bpaEdcrDetails$planD5 = bpaEdcrDetails.planDetail) === null || _bpaEdcrDetails$planD5 === void 0 ? void 0 : (_bpaEdcrDetails$planD6 = _bpaEdcrDetails$planD5.plot) === null || _bpaEdcrDetails$planD6 === void 0 ? void 0 : _bpaEdcrDetails$planD6.area, data === null || data === void 0 ? void 0 : (_data$planDetail4 = data.planDetail) === null || _data$planDetail4 === void 0 ? void 0 : _data$planDetail4.blocks);
      if (ocEdcrKathaNo && edcrKathaNo && ocEdcrPlotNo && edcrPlotNo) {
        if (ocEdcrPlotNo == edcrPlotNo && ocEdcrKathaNo == edcrKathaNo) {
          isProccedToNextStep = true;
        } else {
          if (ocEdcrKathaNo != edcrKathaNo && ocEdcrPlotNo == edcrPlotNo) {
            isProccedToNextStep = false;
            setShowToast({
              key: "true",
              message: "Khata number from permit order XXXX(permit order number) is not matching with the khata number from occupancy certificate. You cannot proceed with the application"
            });
          } else if (ocEdcrPlotNo != edcrPlotNo && ocEdcrKathaNo == edcrKathaNo) {
            isProccedToNextStep = false;
            setShowToast({
              key: "true",
              message: "Plot number from permit order XXXX(permit order number) is not matching with the Plot number from occupancy certificate. You cannot proceed with the application"
            });
          } else if (ocEdcrPlotNo != edcrPlotNo && ocEdcrKathaNo != edcrKathaNo) {
            isProccedToNextStep = false;
            setShowToast({
              key: "true",
              message: "Khata No and plot No from permit order XXXX(permit order number) is not matching with the Khata No and plot No from occupancy certificate. You cannot proceed with the application"
            });
          }
          return false;
        }
      }
      if (riskTypes[edcrRisktype] < riskTypes[ocEdcrRiskType]) {
        isProccedToNextStep = false;
        setShowToast({
          key: "true",
          message: t("BPA_RISK_TYPE_VALIDATION_ERROR"),
          labelName: "The Risk type from permit order XXXX(permit order number) to occupancy certificate application is changed from Low to high .You cannot proceed with the application."
        });
      } else if (riskTypes[edcrRisktype] > riskTypes[ocEdcrRiskType]) {
        isProccedToNextStep = JSON.parse(sessionStorage.getItem("checkForProcced"));
        setShowToast({
          warning: "true",
          message: t("BPA_RISK_TYPE_VALIDATION_WARNING"),
          labelName: "The Risk type in permit order XXXX is high where as the risk type in occupancy is Low , do you want to continue"
        });
      } else {
        isProccedToNextStep = true;
      }
    }
    if (isProccedToNextStep) {
      var _data$planDetail5, _data$planDetail5$pla, _data$planDetail6, _data$planDetail6$pla, _mdmsData$BPA4, _data$planDetail7, _data$planDetail7$plo, _data$planDetail8;
      onSelect(config === null || config === void 0 ? void 0 : config.key, {
        scrutinyNumber,
        applicantName: data === null || data === void 0 ? void 0 : (_data$planDetail5 = data.planDetail) === null || _data$planDetail5 === void 0 ? void 0 : (_data$planDetail5$pla = _data$planDetail5.planInformation) === null || _data$planDetail5$pla === void 0 ? void 0 : _data$planDetail5$pla.applicantName,
        occupancyType: data === null || data === void 0 ? void 0 : (_data$planDetail6 = data.planDetail) === null || _data$planDetail6 === void 0 ? void 0 : (_data$planDetail6$pla = _data$planDetail6.planInformation) === null || _data$planDetail6$pla === void 0 ? void 0 : _data$planDetail6$pla.occupancy,
        applicationType: data === null || data === void 0 ? void 0 : data.appliactionType,
        serviceType: data === null || data === void 0 ? void 0 : data.applicationSubType,
        applicationDate: data === null || data === void 0 ? void 0 : data.applicationDate,
        riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA4 = mdmsData.BPA) === null || _mdmsData$BPA4 === void 0 ? void 0 : _mdmsData$BPA4.RiskTypeComputation, data === null || data === void 0 ? void 0 : (_data$planDetail7 = data.planDetail) === null || _data$planDetail7 === void 0 ? void 0 : (_data$planDetail7$plo = _data$planDetail7.plot) === null || _data$planDetail7$plo === void 0 ? void 0 : _data$planDetail7$plo.area, data === null || data === void 0 ? void 0 : (_data$planDetail8 = data.planDetail) === null || _data$planDetail8 === void 0 ? void 0 : _data$planDetail8.blocks),
        bpaData: bpaData,
        edcrDetails: data
      });
    }
  };
  if (isMdmsLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 1,
    flow: "OCBPA"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: isMobile ? "obps-search" : "",
    style: !isMobile ? {
      maxWidth: "960px",
      minWidth: "640px",
      marginRight: "auto"
    } : {}
  }, /*#__PURE__*/React__default.createElement(Label, null, t(`OBPS_SEARCH_EDCR_NUMBER`)), /*#__PURE__*/React__default.createElement(TextInput$2, {
    className: "searchInput",
    onKeyPress: handleKeyPress,
    onChange: event => setScrutinyNumber({
      edcrNumber: event.target.value
    }),
    value: scrutinyNumber === null || scrutinyNumber === void 0 ? void 0 : scrutinyNumber.edcrNumber,
    signature: true,
    signatureImg: /*#__PURE__*/React__default.createElement(SearchIconSvg, {
      className: "signature-img",
      onClick: !disableVlaue && scrutinyNumber !== null && scrutinyNumber !== void 0 && scrutinyNumber.edcrNumber ? () => handleSearch() : null
    }),
    disable: isDisabled,
    style: {
      marginBottom: "10px"
    }
  })), isLoadingApplication ? /*#__PURE__*/React__default.createElement(Loader, null) : null, data && /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(CardCaption, null, t(`BPA_SCRUTINY_DETAILS`)), /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: data !== null && data !== void 0 && data.applicationDate ? format(new Date(data === null || data === void 0 ? void 0 : data.applicationDate), 'dd/MM/yyyy') : data === null || data === void 0 ? void 0 : data.applicationDate
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.appliactionType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`),
    text: t(data === null || data === void 0 ? void 0 : data.applicationSubType)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`),
    text: data === null || data === void 0 ? void 0 : (_data$planDetail9 = data.planDetail) === null || _data$planDetail9 === void 0 ? void 0 : (_data$planDetail9$pla = _data$planDetail9.planInformation) === null || _data$planDetail9$pla === void 0 ? void 0 : _data$planDetail9$pla.occupancy
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`),
    text: t(`WF_BPA_${Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA5 = mdmsData.BPA) === null || _mdmsData$BPA5 === void 0 ? void 0 : _mdmsData$BPA5.RiskTypeComputation, data === null || data === void 0 ? void 0 : (_data$planDetail10 = data.planDetail) === null || _data$planDetail10 === void 0 ? void 0 : (_data$planDetail10$pl = _data$planDetail10.plot) === null || _data$planDetail10$pl === void 0 ? void 0 : _data$planDetail10$pl.area, data === null || data === void 0 ? void 0 : (_data$planDetail11 = data.planDetail) === null || _data$planDetail11 === void 0 ? void 0 : _data$planDetail11.blocks)}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: data === null || data === void 0 ? void 0 : (_data$planDetail12 = data.planDetail) === null || _data$planDetail12 === void 0 ? void 0 : (_data$planDetail12$pl = _data$planDetail12.planInformation) === null || _data$planDetail12$pl === void 0 ? void 0 : _data$planDetail12$pl.applicantName
  })), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t(`CS_COMMON_NEXT`),
    onSubmit: handleSubmit
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast !== null && showToast !== void 0 && showToast.key ? true : false,
    warning: showToast !== null && showToast !== void 0 && showToast.warning ? true : false,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    isDleteBtn: true,
    onClose: closeToast,
    onNo: noTocloseToast,
    onYes: yesTocloseToast,
    isWarningButtons: true
  }));
};

const newConfig2 = [{
  head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
  body: [{
    route: "home",
    component: "EDCRForm2",
    nextStep: "",
    hideInEmployee: true,
    key: "ScrutinyDetails",
    texts: {
      headerCaption: "",
      header: "EDCR_COMMON_APPL_NEW",
      cardText: "BPA_PROVIDE_REQ_FOR_NEW_BPA",
      submitBarLabel: "EDCR_SCRUTINY_SUBMIT_BUTTON"
    }
  }]
}];

const CreateEDCR = ({
  parentRoute
}) => {
  var _location$state, _newConfig, _newConfig2, _Digit4, _Digit4$ComponentRegi;
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const applicationNumber = (location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.applicationNumber) || null;
  const history = useHistory();
  let config = [];
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("EDCR_CREATE", {});
  const [isShowToast, setIsShowToast] = useState(null);
  const [isSubmitBtnDisable, setIsSubmitBtnDisable] = useState(false);
  Digit.SessionStorage.set("EDCR_BACK", "IS_EDCR_BACK");
  useEffect(() => {
    if (!location.pathname.includes("/acknowledgement")) {
      var _Digit;
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("ScrutinyDetails");
      clearParams();
      setIsSubmitBtnDisable(false);
      setIsShowToast(null);
    }
  }, [location.pathname]);
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  function handleSelect(key, data, skipStep, index) {
    var _data$city, _data$city2, _userRolesArray$, _loggedInuserInfo$inf3, _Digit2, _Digit3, _edcrRequest, _edcrRequest$mapSubDe, _edcrRequest2, _edcrRequest2$additio, _edcrRequest3, _edcrRequest3$mapSubD, _edcrRequest4, _edcrRequest4$additio;
    setIsSubmitBtnDisable(true);
    const loggedInuserInfo = Digit.UserService.getUser();
    const userRolesArray = loggedInuserInfo === null || loggedInuserInfo === void 0 ? void 0 : loggedInuserInfo.info.roles.filter(user => user.code !== "CITIZEN");
    let edcrRequest = {
      transactionNumber: "",
      edcrNumber: "",
      rolesCode: "",
      planFile: null,
      tenantId: "",
      RequestInfo: {
        apiId: "",
        ver: "",
        ts: "",
        action: "",
        did: "",
        authToken: "",
        key: "",
        msgId: "",
        correlationId: "",
        userInfo: loggedInuserInfo
      }
    };
    const applicantName = data === null || data === void 0 ? void 0 : data.applicantName;
    const natureOfConstruction = data === null || data === void 0 ? void 0 : data.natureOfConstruction;
    const landMark = data === null || data === void 0 ? void 0 : data.landMark;
    const planOn = data === null || data === void 0 ? void 0 : data.planOn;
    const isRevised = data === null || data === void 0 ? void 0 : data.isRevised;
    const tehsil = data === null || data === void 0 ? void 0 : data.tehsil;
    const sectorNoPlotNo = data === null || data === void 0 ? void 0 : data.sectorNoPlotNo;
    const fars = data === null || data === void 0 ? void 0 : data.fars;
    const backSide = data === null || data === void 0 ? void 0 : data.backSide;
    const groundCoverages = data === null || data === void 0 ? void 0 : data.groundCoverages;
    const setbackRears = data === null || data === void 0 ? void 0 : data.setbackRears;
    const setbackFronts = data === null || data === void 0 ? void 0 : data.setbackFronts;
    const revenueVillage = data === null || data === void 0 ? void 0 : data.revenueVillage;
    const subDevelopmentArea = data === null || data === void 0 ? void 0 : data.subDevelopmentArea;
    const developmentArea = data === null || data === void 0 ? void 0 : data.developmentArea;
    const isPlotSetback = data === null || data === void 0 ? void 0 : data.isPlotSetback;
    const isApprovedLayout = data === null || data === void 0 ? void 0 : data.isApprovedLayout;
    const isSpecialProject = data === null || data === void 0 ? void 0 : data.isSpecialProject;
    const proposalType = data === null || data === void 0 ? void 0 : data.proposalType;
    const file = data === null || data === void 0 ? void 0 : data.file;
    const tenantId = data === null || data === void 0 ? void 0 : data.tenantId;
    const transactionNumber = uuidv4();
    const appliactionType = "BUILDING_PLAN_SCRUTINY";
    const applicationType = "BUILDING_PLAN_SCRUTINY";
    const applicationSubType = "NEW_CONSTRUCTION";
    const serviceType = "NEW_CONSTRUCTION";
    const city = (data === null || data === void 0 ? void 0 : (_data$city = data.city) === null || _data$city === void 0 ? void 0 : _data$city.name) || null;
    const code = (data === null || data === void 0 ? void 0 : (_data$city2 = data.city) === null || _data$city2 === void 0 ? void 0 : _data$city2.code) || null;
    const locality = (data === null || data === void 0 ? void 0 : data.locality) || null;
    const doorNo = (data === null || data === void 0 ? void 0 : data.doorNo) || null;
    const village = (data === null || data === void 0 ? void 0 : data.village) || null;
    const rolesCode = (userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code) || null;
    const areaType = (data === null || data === void 0 ? void 0 : data.areaType) || null;
    const licenseeName = loggedInuserInfo === null || loggedInuserInfo === void 0 ? void 0 : (_loggedInuserInfo$inf3 = loggedInuserInfo.info) === null || _loggedInuserInfo$inf3 === void 0 ? void 0 : _loggedInuserInfo$inf3.name;
    const department = ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
    edcrRequest = {
      ...edcrRequest,
      tenantId: tenantId || "up"
    };
    edcrRequest = {
      ...edcrRequest,
      rolesCode
    };
    edcrRequest = {
      ...edcrRequest,
      transactionNumber
    };
    edcrRequest = {
      ...edcrRequest,
      applicantName,
      applicationNumber,
      developmentArea,
      isPlotSetback,
      isSpecialProject,
      isApprovedLayout,
      setbackFronts,
      subDevelopmentArea,
      groundCoverages,
      setbackRears,
      fars,
      backSide,
      sectorNoPlotNo,
      landMark,
      planOn,
      tehsil,
      isRevised,
      natureOfConstruction,
      proposalType,
      revenueVillage
    };
    edcrRequest = {
      ...edcrRequest,
      appliactionType,
      applicationType
    };
    edcrRequest = {
      ...edcrRequest,
      applicationSubType,
      serviceType
    };
    const resolvedDept = department || ((_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
    const resolvedBusinessService = resolvedDept === "DA" || (data === null || data === void 0 ? void 0 : data.businessService) === "BPA_MAPSUB_DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP";
    edcrRequest = {
      ...edcrRequest,
      city,
      code,
      locality,
      doorNo,
      village,
      areaType,
      licenseeName,
      department: resolvedDept,
      businessService: resolvedBusinessService
    };
    edcrRequest.tod = "";
    if ((_edcrRequest = edcrRequest) !== null && _edcrRequest !== void 0 && (_edcrRequest$mapSubDe = _edcrRequest.mapSubDetails) !== null && _edcrRequest$mapSubDe !== void 0 && _edcrRequest$mapSubDe.tod) {
      edcrRequest.mapSubDetails.tod = "";
    }
    if ((_edcrRequest2 = edcrRequest) !== null && _edcrRequest2 !== void 0 && (_edcrRequest2$additio = _edcrRequest2.additionalDetails) !== null && _edcrRequest2$additio !== void 0 && _edcrRequest2$additio.tod) {
      edcrRequest.additionalDetails.tod = "";
    }
    delete edcrRequest.landUseApprovalLetter;
    if ((_edcrRequest3 = edcrRequest) !== null && _edcrRequest3 !== void 0 && (_edcrRequest3$mapSubD = _edcrRequest3.mapSubDetails) !== null && _edcrRequest3$mapSubD !== void 0 && _edcrRequest3$mapSubD.landUseApprovalLetter) {
      delete edcrRequest.mapSubDetails.landUseApprovalLetter;
    }
    if ((_edcrRequest4 = edcrRequest) !== null && _edcrRequest4 !== void 0 && (_edcrRequest4$additio = _edcrRequest4.additionalDetails) !== null && _edcrRequest4$additio !== void 0 && _edcrRequest4$additio.landUseApprovalLetter) {
      delete edcrRequest.additionalDetails.landUseApprovalLetter;
    }
    let bodyFormData = new FormData();
    bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
    bodyFormData.append("planFile", file);
    if (bodyFormData && file) {
      Digit.EDCRService.create({
        data: bodyFormData
      }, tenantId).then((result, err) => {
        var _result$data;
        setIsSubmitBtnDisable(false);
        if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.edcrDetail) {
          var _result$data2, _result$data3;
          setParams(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.edcrDetail);
          history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
            data: result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.edcrDetail
          });
        }
      }).catch(e => {
        var _e$response, _e$response2, _e$response2$data, _e$response2$data$, _e$response3, _e$response3$data, _e$response3$data$, _e$response4, _e$response4$data, _e$response5, _e$response5$data;
        const errCode = Array.isArray(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data) && ((e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$ = _e$response2$data[0]) === null || _e$response2$data$ === void 0 ? void 0 : _e$response2$data$.errorMessage) || (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$ = _e$response3$data[0]) === null || _e$response3$data$ === void 0 ? void 0 : _e$response3$data$.errorCode)) || (e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.errorCode) || (e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.message) || "BPA_INTERNAL_SERVER_ERROR";
        setParams({
          data: errCode,
          type: "ERROR"
        });
        setIsSubmitBtnDisable(false);
        setIsShowToast({
          key: true,
          label: errCode
        });
      });
    } else {
      setIsSubmitBtnDisable(false);
    }
  }
  const handleSkip = () => {};
  const handleMultiple = () => {};
  const onSuccess = () => {
    sessionStorage.removeItem("CurrentFinancialYear");
    queryClient.invalidateQueries("TL_CREATE_TRADE");
  };
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.EdcrConfig2 ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.EdcrConfig2 : newConfig2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "home";
  const EDCRAcknowledgement = (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : (_Digit4$ComponentRegi = _Digit4.ComponentRegistryService) === null || _Digit4$ComponentRegi === void 0 ? void 0 : _Digit4$ComponentRegi.getComponent('EDCRAcknowledgement');
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${match.path}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params,
      onAdd: handleMultiple,
      isShowToast: isShowToast,
      isSubmitBtnDisable: isSubmitBtnDisable,
      setIsShowToast: setIsShowToast
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${match.path}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(EDCRAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${match.path}/${config.indexRoute}`
  })));
};

const newConfig$1 = [{
  head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
  body: [{
    route: "docs-required",
    component: "OCEDCRDocsRequired",
    key: "data",
    nextStep: "home"
  }, {
    route: "home",
    component: "OCeDCRScrutiny",
    nextStep: "upload-diagram",
    hideInEmployee: true,
    key: "ScrutinyDetails"
  }, {
    route: "upload-diagram",
    component: "OCUploadPlanDiagram",
    nextStep: null,
    hideInEmployee: true,
    key: "uploadData",
    texts: {
      headerCaption: "BPA_OC_NEW_BUILDING_CONSTRUCTION_LABEL",
      header: "BPA_UPLOAD_OC_PLAN_DIAGRAM_LABEL",
      cardText: "",
      submitBarLabel: "BPA_COMMON_BUTTON_SUBMIT",
      skipText: ""
    }
  }]
}];

const CreateOCEDCR = ({
  parentRoute
}) => {
  var _newConfig, _newConfig2, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    t
  } = useTranslation();
  const {
    pathname
  } = useLocation();
  const {
    path,
    url
  } = useRouteMatch();
  const history = useHistory();
  let config = [];
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("OC_EDCR_CREATE", {});
  const [isShowToast, setIsShowToast] = useState(null);
  const [isSubmitBtnDisable, setIsSubmitBtnDisable] = useState(false);
  Digit.SessionStorage.set("EDCR_BACK", "IS_EDCR_BACK");
  useEffect(() => {
    if (!pathname.includes("/acknowledgement")) {
      var _Digit;
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("OC_EDCR_CREATE");
      clearParams();
      setIsSubmitBtnDisable(false);
      setIsShowToast(null);
    }
  }, [pathname]);
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  function createOCEdcr(key, uploadData, skipStep, isFromCreateApi) {
    var _loggedInuserInfo$inf, _loggedInuserInfo$inf2, _data$ScrutinyDetails, _data$ScrutinyDetails2, _data$ScrutinyDetails3, _data$ScrutinyDetails4, _data$ScrutinyDetails5, _data$ScrutinyDetails6, _edcrRequest, _edcrRequest$mapSubDe, _edcrRequest2, _edcrRequest2$additio;
    setIsSubmitBtnDisable(true);
    const data = params;
    const loggedInuserInfo = Digit.UserService.getUser();
    const userInfo = {
      id: loggedInuserInfo === null || loggedInuserInfo === void 0 ? void 0 : (_loggedInuserInfo$inf = loggedInuserInfo.info) === null || _loggedInuserInfo$inf === void 0 ? void 0 : _loggedInuserInfo$inf.uuid,
      tenantId: loggedInuserInfo === null || loggedInuserInfo === void 0 ? void 0 : (_loggedInuserInfo$inf2 = loggedInuserInfo.info) === null || _loggedInuserInfo$inf2 === void 0 ? void 0 : _loggedInuserInfo$inf2.tenantId
    };
    let edcrRequest = {
      transactionNumber: "",
      edcrNumber: "",
      planFile: null,
      tenantId: "",
      RequestInfo: {
        apiId: "",
        ver: "",
        ts: "",
        action: "",
        did: "",
        authToken: "",
        key: "",
        msgId: "",
        correlationId: "",
        userInfo: userInfo
      }
    };
    const transactionNumber = uuidv4();
    const edcrNumber = data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails = data.ScrutinyDetails) === null || _data$ScrutinyDetails === void 0 ? void 0 : _data$ScrutinyDetails.edcrNumber;
    const tenantId = data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails2 = data.ScrutinyDetails) === null || _data$ScrutinyDetails2 === void 0 ? void 0 : _data$ScrutinyDetails2.tenantId;
    const applicantName = data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails3 = data.ScrutinyDetails) === null || _data$ScrutinyDetails3 === void 0 ? void 0 : _data$ScrutinyDetails3.applicantName;
    const appliactionType = "BUILDING_OC_PLAN_SCRUTINY";
    const applicationType = "BUILDING_OC_PLAN_SCRUTINY";
    const applicationSubType = "NEW_CONSTRUCTION";
    const serviceType = "NEW_CONSTRUCTION";
    const permitDate = convertDateToEpoch(data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails4 = data.ScrutinyDetails) === null || _data$ScrutinyDetails4 === void 0 ? void 0 : _data$ScrutinyDetails4.ocPermitdate);
    const permitNumber = data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails5 = data.ScrutinyDetails) === null || _data$ScrutinyDetails5 === void 0 ? void 0 : _data$ScrutinyDetails5.ocPermitNumber;
    const comparisonEdcrNumber = data === null || data === void 0 ? void 0 : (_data$ScrutinyDetails6 = data.ScrutinyDetails) === null || _data$ScrutinyDetails6 === void 0 ? void 0 : _data$ScrutinyDetails6.edcrNumber;
    const file = uploadData === null || uploadData === void 0 ? void 0 : uploadData.file;
    edcrRequest = {
      ...edcrRequest,
      transactionNumber
    };
    edcrRequest = {
      ...edcrRequest,
      edcrNumber
    };
    edcrRequest = {
      ...edcrRequest,
      tenantId: tenantId || "up"
    };
    edcrRequest = {
      ...edcrRequest,
      applicantName
    };
    edcrRequest = {
      ...edcrRequest,
      appliactionType,
      applicationType
    };
    edcrRequest = {
      ...edcrRequest,
      applicationSubType,
      serviceType
    };
    edcrRequest = {
      ...edcrRequest,
      permitDate
    };
    edcrRequest = {
      ...edcrRequest,
      permitNumber
    };
    edcrRequest = {
      ...edcrRequest,
      comparisonEdcrNumber
    };
    delete edcrRequest.landUseApprovalLetter;
    if ((_edcrRequest = edcrRequest) !== null && _edcrRequest !== void 0 && (_edcrRequest$mapSubDe = _edcrRequest.mapSubDetails) !== null && _edcrRequest$mapSubDe !== void 0 && _edcrRequest$mapSubDe.landUseApprovalLetter) {
      delete edcrRequest.mapSubDetails.landUseApprovalLetter;
    }
    if ((_edcrRequest2 = edcrRequest) !== null && _edcrRequest2 !== void 0 && (_edcrRequest2$additio = _edcrRequest2.additionalDetails) !== null && _edcrRequest2$additio !== void 0 && _edcrRequest2$additio.landUseApprovalLetter) {
      delete edcrRequest.additionalDetails.landUseApprovalLetter;
    }
    let bodyFormData = new FormData();
    bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
    bodyFormData.append("planFile", file);
    if (bodyFormData && file) {
      Digit.EDCRService.create({
        data: bodyFormData
      }, tenantId).then((result, err) => {
        var _result$data;
        setIsSubmitBtnDisable(false);
        if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.edcrDetail) {
          var _result$data2, _result$data3;
          setParams(result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.edcrDetail);
          history.replace(`/digit-ui/citizen/obps/edcrscrutiny/oc-apply/acknowledgement`, {
            data: result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.edcrDetail
          });
        }
      }).catch(e => {
        var _e$response, _e$response2, _e$response2$data, _e$response2$data$, _e$response3, _e$response3$data, _e$response3$data$, _e$response4, _e$response4$data, _e$response5, _e$response5$data;
        const errCode = Array.isArray(e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data) && ((e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : (_e$response2$data$ = _e$response2$data[0]) === null || _e$response2$data$ === void 0 ? void 0 : _e$response2$data$.errorMessage) || (e === null || e === void 0 ? void 0 : (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : (_e$response3$data$ = _e$response3$data[0]) === null || _e$response3$data$ === void 0 ? void 0 : _e$response3$data$.errorCode)) || (e === null || e === void 0 ? void 0 : (_e$response4 = e.response) === null || _e$response4 === void 0 ? void 0 : (_e$response4$data = _e$response4.data) === null || _e$response4$data === void 0 ? void 0 : _e$response4$data.errorCode) || (e === null || e === void 0 ? void 0 : (_e$response5 = e.response) === null || _e$response5 === void 0 ? void 0 : (_e$response5$data = _e$response5.data) === null || _e$response5$data === void 0 ? void 0 : _e$response5$data.message) || "BPA_INTERNAL_SERVER_ERROR";
        setParams({
          data: errCode,
          type: "ERROR"
        });
        setIsSubmitBtnDisable(false);
        setIsShowToast({
          key: true,
          label: errCode
        });
      });
    } else {
      setIsSubmitBtnDisable(false);
    }
  }
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${path}/check`);
    }
    redirectWithHistory(`${path}/${nextStep}`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) createOCEdcr(key, data);else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    if (!skipStep) goNext();
  };
  const handleSkip = () => {};
  const handleMultiple = () => {};
  const onSuccess = () => {
    sessionStorage.removeItem("CurrentFinancialYear");
    queryClient.invalidateQueries("TL_CREATE_TRADE");
  };
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.OCEdcrConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.OCEdcrConfig : newConfig$1;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "docs-required";
  const EDCRAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('OCEDCRAcknowledgement');
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${match.path}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params,
      onAdd: handleMultiple,
      isShowToast: isShowToast,
      isSubmitBtnDisable: isSubmitBtnDisable,
      setIsShowToast: setIsShowToast
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${match.path}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(EDCRAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${match.path}/${config.indexRoute}`
  })));
};

const newConfig$2 = [{
  head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
  body: [{
    route: "basic-details",
    component: "BasicDetails",
    key: "data",
    nextStep: "location"
  }, {
    route: "location",
    component: "LocationDetails",
    nextStep: "plot-details",
    hideInEmployee: true,
    key: "address",
    texts: {
      headerCaption: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      header: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipAndContinueText: "CORE_COMMON_SKIP_CONTINUE"
    }
  }, {
    route: "plot-details",
    component: "PlotDetails",
    key: "data",
    nextStep: "scrutiny-details",
    texts: {
      headerCaption: "BPA_SCRUTINY_DETAILS",
      header: "BPA_PLOT_DETAILS_TITLE",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipText: "CORE_COMMON_SKIP_CONTINUE"
    }
  }, {
    route: "scrutiny-details",
    component: "ScrutinyDetails",
    nextStep: "private-professional-information",
    hideInEmployee: true,
    key: "subOccupancy",
    texts: {
      headerCaption: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      header: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipText: "CORE_COMMON_SKIP_CONTINUE"
    }
  }, {
    route: "private-professional-information",
    component: "ProfessionalDetails",
    nextStep: "owner-details",
    hideInEmployee: true,
    key: "professional-information",
    texts: {
      headerCaption: "BPA_PRIVATE_PROFESSIONAL_HEADER",
      header: "BPA_PROFESSIONAL_DETAILS",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipAndContinueText: "CORE_COMMON_SKIP_CONTINUE"
    }
  }, {
    route: "owner-details",
    component: "OwnerDetails",
    nextStep: "document-details",
    key: "owners",
    texts: {
      headerCaption: "BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL",
      header: "BPA_APPLICANT_DETAILS_HEADER",
      submitBarLabel: "CS_COMMON_NEXT"
    }
  }, {
    route: "document-details",
    component: "DocumentDetails",
    nextStep: null,
    key: "documents",
    texts: {
      headerCaption: "BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL",
      header: "BPA_DOCUMENT_DETAILS_LABEL",
      submitBarLabel: "CS_COMMON_NEXT"
    }
  }]
}];

const getPath$1 = (path, params) => {
  var _Object$keys;
  params && ((_Object$keys = Object.keys(params)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(key => {
    path = path.replace(`:${key}`, params[key]);
  }));
  return path;
};
const NewBuildingPermit = () => {
  var _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const {
    path,
    url
  } = useRouteMatch();
  const {
    pathname,
    state
  } = useLocation();
  const match = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state !== null && state !== void 0 && state.edcrNumber ? {
    data: {
      scrutinyNumber: {
        edcrNumber: state === null || state === void 0 ? void 0 : state.edcrNumber
      }
    }
  } : {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$1(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$1(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$1(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) {
      console.log(data, "data in createAPI");
      setParams(data);
    } else if (key === "") setParams({
      ...data
    });else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  console.log(params, "pppppppppp");
  let config = [];
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.BuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.BuildingPermitConfig : newConfig$2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "basic-details";
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('BPACheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('BPAAcknowledgement');
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    let Component = component;
    if (typeof component === "string") {
      if (['LocationDetails', 'PlotDetails', 'ScrutinyDetails'].includes(component)) {
        Component = Digit.ComponentRegistryService.getComponent('BasicDetails');
      } else {
        Component = Digit.ComponentRegistryService.getComponent(component);
      }
    }
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$1(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params,
      currTabRoute: routeObj.route
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$1(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$1(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$1(match.path, match.params)}/${config.indexRoute}`
  })));
};

const DataTable = ({
  data,
  headers
}) => {
  return /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, headers === null || headers === void 0 ? void 0 : headers.map((header, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: index
  }, header)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, data === null || data === void 0 ? void 0 : data.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, Object.keys(item).map((key, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: index
  }, item[key])))))));
};

const getPath$2 = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const NewBuildingPermit$1 = () => {
  var _newConfig, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const {
    pathname,
    state
  } = useLocation();
  const match = useRouteMatch();
  const history = useHistory();
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state !== null && state !== void 0 && state.edcrNumber ? {
    data: {
      scrutinyNumber: {
        edcrNumber: state === null || state === void 0 ? void 0 : state.edcrNumber
      }
    }
  } : {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const currentPath = pathname.split("/").pop();
  const goNext = skipStep => {
    let {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$2(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$2(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$2(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else if (key === "") setParams({
      ...data
    });else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  let config = [];
  newConfig = ((_newConfig = newConfig) === null || _newConfig === void 0 ? void 0 : _newConfig.PermissionOfSubdivision) || newConfig$2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "land-area-details";
  useEffect(() => {
    var _params$uiFlow;
    if (!params.uiFlow || ((_params$uiFlow = params.uiFlow) === null || _params$uiFlow === void 0 ? void 0 : _params$uiFlow.flow) !== 'Form11') {
      setParams({
        ...params,
        ...{
          uiFlow: {
            flow: "Form11"
          }
        }
      });
    }
  }, []);
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('BPAForm11CheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('BPAForm11Acknowledgement');
  const step1Tabs = config.filter(conf => conf.step === 1);
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map(routeObj => {
    const {
      component,
      route
    } = routeObj;
    if (!component) {
      return;
    }
    let Component = component;
    if (typeof component === "string") {
      Component = Digit.ComponentRegistryService.getComponent(component);
    }
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$2(match.path, match.params)}/${route}`,
      key: route
    }, /*#__PURE__*/React__default.createElement(Component, Object.assign({}, routeObj.step === 1 && step1Tabs && {
      step1Tabs
    }, {
      onSelect: handleSelect,
      onSkip: handleSkip,
      currStep: routeObj,
      formData: params,
      config: config,
      t: t
    })));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$2(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    formData: params,
    currStep: {
      step: 5
    }
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$2(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$2(match.path, match.params)}/${["form11", ""].includes(currentPath) ? config.indexRoute : currentPath}`
  })));
};

const getPath$3 = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const NewBuildingPermit$2 = () => {
  var _newConfig, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const {
    pathname,
    state
  } = useLocation();
  const match = useRouteMatch();
  const history = useHistory();
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state !== null && state !== void 0 && state.edcrNumber ? {
    data: {
      scrutinyNumber: {
        edcrNumber: state === null || state === void 0 ? void 0 : state.edcrNumber
      }
    }
  } : {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const currentPath = pathname.split("/").pop();
  const goNext = skipStep => {
    let {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$3(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$3(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    sessionStorage.removeItem("currLocality");
    sessionStorage.removeItem("currVillage");
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$3(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else if (key === "") setParams({
      ...data
    });else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  let config = [];
  newConfig = ((_newConfig = newConfig) === null || _newConfig === void 0 ? void 0 : _newConfig.CompositionOfOffences) || newConfig$2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "land-area-details";
  useEffect(() => {
    var _params$uiFlow;
    if (!params.uiFlow || ((_params$uiFlow = params.uiFlow) === null || _params$uiFlow === void 0 ? void 0 : _params$uiFlow.flow) !== 'Form26') {
      setParams({
        ...params,
        ...{
          uiFlow: {
            flow: "Form26"
          }
        }
      });
    }
  }, []);
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('BPAForm26CheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('BPAForm26Acknowledgement');
  const step1Tabs = config.filter(conf => conf.step === 1);
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map(routeObj => {
    const {
      component,
      route
    } = routeObj;
    if (!component) {
      return;
    }
    let Component = component;
    if (typeof component === "string") {
      Component = Digit.ComponentRegistryService.getComponent(component);
    }
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$3(match.path, match.params)}/${route}`,
      key: route
    }, /*#__PURE__*/React__default.createElement(Component, Object.assign({}, routeObj.step === 1 && step1Tabs && {
      step1Tabs
    }, {
      onSelect: handleSelect,
      onSkip: handleSkip,
      currStep: routeObj,
      formData: params,
      config: config,
      t: t
    })));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$3(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    formData: params,
    currStep: {
      step: 5
    }
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$3(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$3(match.path, match.params)}/${["form26", ""].includes(currentPath) ? config.indexRoute : currentPath}`
  })));
};

const newConfig$3 = [{
  head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
  body: [{
    route: "docs-required",
    component: "DocsRequired",
    key: "data",
    nextStep: "basic-details"
  }, {
    route: "basic-details",
    component: "OCBasicDetails",
    key: "data",
    nextStep: "plot-details"
  }, {
    route: "plot-details",
    component: "PlotDetails",
    key: "data",
    nextStep: "scrutiny-details",
    texts: {
      headerCaption: "BPA_SCRUTINY_DETAILS",
      header: "BPA_PLOT_DETAILS_TITLE",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipText: "CORE_COMMON_SKIP_CONTINUE"
    },
    inputs: [{
      label: "BPA_HOLDING_NUMBER_LABEL",
      type: "text",
      validation: {},
      name: "holdingNumber"
    }, {
      label: "BPA_BOUNDARY_LAND_REG_DETAIL_LABEL",
      type: "textarea",
      validation: {},
      name: "registrationDetails"
    }]
  }, {
    route: "scrutiny-details",
    component: "ScrutinyDetails",
    nextStep: "document-details",
    hideInEmployee: true,
    key: "subOccupancy",
    texts: {
      headerCaption: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      header: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      cardText: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipAndContinueText: ""
    }
  }, {
    route: "document-details",
    component: "DocumentDetails",
    nextStep: "noc-details",
    key: "documents",
    texts: {
      headerCaption: "BPA_OWNER_AND_DOCUMENT_DETAILS_LABEL",
      header: "BPA_DOCUMENT_DETAILS_LABEL",
      submitBarLabel: "CS_COMMON_NEXT"
    }
  }, {
    route: "noc-details",
    component: "NOCDetails",
    nextStep: null,
    key: "nocDocuments",
    texts: {
      headerCaption: "BPA_NOC_DETAILS_SUMMARY",
      header: "",
      submitBarLabel: "CS_COMMON_NEXT",
      skipText: "CORE_COMMON_SKIP_CONTINUE"
    }
  }]
}];

const getPath$4 = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const OCBuildingPermit = () => {
  var _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const {
    path,
    url
  } = useRouteMatch();
  const {
    pathname,
    state
  } = useLocation();
  const history = useHistory();
  const match = useRouteMatch();
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state !== null && state !== void 0 && state.edcrNumber ? {
    data: {
      scrutinyNumber: {
        edcrNumber: state === null || state === void 0 ? void 0 : state.edcrNumber
      }
    }
  } : {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$4(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$4(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$4(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else if (key === "") setParams({
      ...data
    });else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  let config = [];
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.OCBuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.OCBuildingPermitConfig : newConfig$3;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "docs-required";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('OCBPACheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('OCBPAAcknowledgement');
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$4(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$4(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$4(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$4(match.path, match.params)}/${config.indexRoute}`
  })));
};

const newConfig$4 = [{
  head: "ES_NEW_APPLICATION_PROPERTY_ASSESSMENT",
  body: [{
    route: "stakeholder-docs-required",
    component: "StakeholderDocsRequired",
    key: "data",
    nextStep: "provide-license-type"
  }, {
    type: "component",
    route: "provide-license-type",
    isMandatory: true,
    component: "LicenseType",
    texts: {
      headerCaption: "BPA_LICENSE_DET_CAPTION",
      header: "BPA_LICENSE_TYPE",
      cardText: "BPA_LICENSE_TYPE_TEXT",
      submitBarLabel: "CS_COMMON_NEXT"
    },
    nextStep: "license-details",
    key: "LicneseType",
    withoutLabel: true,
    hideInEmployee: true
  }, {
    type: "component",
    route: "license-details",
    isMandatory: true,
    component: "LicenseDetails",
    texts: {
      headerCaption: "BPA_LICENSE_DET_CAPTION",
      header: "BPA_LICENSE_DET_CAPTION",
      cardText: "BPA_LICENSE_DETAILS_TEXT",
      submitBarLabel: "CS_COMMON_NEXT"
    },
    nextStep: "Permanent-address",
    key: "LicneseDetails",
    withoutLabel: true,
    hideInEmployee: true
  }, {
    type: "component",
    route: "Permanent-address",
    isMandatory: true,
    component: "PermanentAddress",
    texts: {
      headerCaption: "BPA_NEW_ADDRESS_HEADER_DETAILS",
      header: "BPA_LICENSEE_PERM_ADDR_HEADER",
      cardText: "BPA_LICENSEE_PERMANENT_TEXT",
      submitBarLabel: "CS_COMMON_NEXT"
    },
    nextStep: "correspondence-address",
    key: "LicneseDetails",
    withoutLabel: true,
    hideInEmployee: true
  }, {
    type: "component",
    route: "correspondence-address",
    isMandatory: true,
    component: "CorrospondenceAddress",
    texts: {
      headerCaption: "BPA_NEW_ADDRESS_HEADER_DETAILS",
      header: "BPA_LICENSEE_CORRESPONDENCE_LABEL",
      cardText: "BPA_LICENSEE_CORRESPONDENCE_TEXT",
      submitBarLabel: "CS_COMMON_NEXT"
    },
    nextStep: "stakeholder-document-details",
    key: "LicneseDetails",
    withoutLabel: true,
    hideInEmployee: true
  }, {
    route: "stakeholder-document-details",
    component: "StakeholderDocuments",
    nextStep: null,
    key: "documents",
    texts: {
      headerCaption: "BPA_DOCUMENT_DETAILS_LABEL",
      header: "BPA_LICENSEE_DOCUMENT_DETAILS_HEADER",
      submitBarLabel: "CS_COMMON_NEXT"
    }
  }]
}];

const StakeholderRegistration = () => {
  var _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const queryClient = useQueryClient();
  const {
    t
  } = useTranslation();
  const {
    path,
    url
  } = useRouteMatch();
  const {
    pathname,
    state
  } = useLocation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT", state !== null && state !== void 0 && state.edcrNumber ? {
    data: {
      scrutinyNumber: {
        edcrNumber: state === null || state === void 0 ? void 0 : state.edcrNumber
      }
    }
  } : {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${path}/check`);
    }
    redirectWithHistory(`${path}/${nextStep}`);
  };
  const onSuccess = () => {
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${path}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else if (key === "") setParams({
      ...data
    });else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  let config = [];
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.StakeholderConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.StakeholderConfig : newConfig$4;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "stakeholder-docs-required";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('StakeholderCheckPage');
  const StakeholderAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('StakeholderAcknowledgement');
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${path}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(StakeholderAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${path}/${config.indexRoute}`
  })));
};

const configAcceptApplication = ({
  t,
  action,
  selectFile,
  uploadedFile,
  error,
  isCommentRequired: _isCommentRequired = true,
  setUploadedFile,
  file
}) => {
  return {
    label: {
      heading: `BPA_FORWARD_APPLICATION_HEADER`,
      submit: `BPA_${action}_BUTTON`,
      cancel: "CS_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: t("ES_OBPS_ACTION_COMMENTS"),
        isMandatory: _isCommentRequired,
        type: "textarea",
        populators: {
          name: "comments",
          validation: {
            required: _isCommentRequired
          }
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React__default.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configTermsAndConditions = ({
  t,
  applicationData
}) => {
  const data = getCheckBoxLabelData(t, applicationData);
  return {
    label: {
      heading: ``,
      submit: null,
      cancel: null,
      hideSubmit: true
    },
    data: [data]
  };
};

const Heading$1 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$2 = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
  fill: "#0B0C0C"
}));
const CloseBtn$2 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick,
    style: {
      backgroundColor: "#FFFFFF"
    }
  }, /*#__PURE__*/React__default.createElement(Close$2, null));
};
const ActionModal$1 = ({
  t,
  closeModal,
  submitAction,
  actionData,
  action,
  applicationData
}) => {
  var _config$label, _config$label2, _config$label3, _config$label4, _config$data;
  const [config, setConfig] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [defaultValues, setDefaultValues] = useState({});
  const [error, setError] = useState(null);
  const [termsData, setTermsData] = useState(false);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  const selectFile = e => {
    setFile(e.target.files[0]);
  };
  useEffect(() => {
    switch (action) {
      case "APPROVE":
        {
          setConfig(configAcceptApplication({
            t,
            action,
            selectFile,
            uploadedFile,
            error,
            isCommentRequired: false,
            setUploadedFile,
            file,
            error
          }));
          break;
        }
      case "SEND_TO_ARCHITECT":
        setConfig(configAcceptApplication({
          t,
          action,
          selectFile,
          uploadedFile,
          error,
          setUploadedFile,
          file,
          error
        }));
        break;
      case "TERMS_AND_CONDITIONS":
        setTermsData(true);
        setConfig(configTermsAndConditions({
          t,
          applicationData
        }));
        break;
      default:
        setConfig(configAcceptApplication({
          t,
          action,
          selectFile,
          uploadedFile,
          error,
          isCommentRequired: false,
          setUploadedFile,
          file,
          error
        }));
    }
  }, [action, uploadedFile, error]);
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            setUploadedFile(null);
            const response = await Digit.UploadServices.Filestorage("BPA", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const submit = data => {
    let workflow = {
      action
    };
    if (uploadedFile) {
      workflow.varificationDocuments = [{
        documentType: "Document - 1",
        fileName: (file === null || file === void 0 ? void 0 : file.name) || "",
        fileStoreId: uploadedFile
      }];
    }
    if (!(data !== null && data !== void 0 && data.comments)) delete data.comments;
    submitAction({
      ...data,
      ...workflow
    });
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$1, {
      label: t(config === null || config === void 0 ? void 0 : (_config$label = config.label) === null || _config$label === void 0 ? void 0 : _config$label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$2, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config === null || config === void 0 ? void 0 : (_config$label2 = config.label) === null || _config$label2 === void 0 ? void 0 : _config$label2.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config === null || config === void 0 ? void 0 : (_config$label3 = config.label) === null || _config$label3 === void 0 ? void 0 : _config$label3.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isDisabled: ((applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) === "UPLOAD_SITE_INSPECTION" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) === "APPROVE_BY_STRUCTURAL") && file === null ? true : false,
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "160px"
    },
    hideSubmit: config !== null && config !== void 0 && (_config$label4 = config.label) !== null && _config$label4 !== void 0 && _config$label4.hideSubmit ? true : false,
    popupModuleMianStyles: action == "TERMS_AND_CONDITIONS" ? {
      height: "92%",
      boxSizing: "border-box"
    } : mobileView ? {
      paddingLeft: "0px"
    } : {},
    headerBarMainStyle: action == "TERMS_AND_CONDITIONS" ? {
      margin: "0px",
      height: "35px"
    } : {}
  }, config !== null && config !== void 0 && config.form ? /*#__PURE__*/React__default.createElement(FormComposer, {
    cardStyle: {
      minWidth: "unset",
      paddingRight: "unset",
      marginRight: "18px",
      paddingBottom: "64px"
    },
    config: config === null || config === void 0 ? void 0 : config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  }) : null, termsData ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "95%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "18px",
      paddingBottom: "16px",
      color: "#000000",
      fontWeight: "700"
    }
  }, t("TERMS_AND_CONDITIONS")), (config === null || config === void 0 ? void 0 : config.data) && (config === null || config === void 0 ? void 0 : (_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.map((value, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "90%",
      overflow: "auto"
    }
  }, `${value}`)))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      minHeight: "5%"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonSelector, {
    label: t("BPA_GO_BACK_LABEL"),
    onSubmit: closeModal,
    style: {
      minWidth: "240px"
    }
  }))) : null);
};

const tablist = [{
  label: "WF_TAKE_ACTION",
  color: "red"
}, {
  label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS",
  color: "red"
}];
const BpaApplicationDetail = () => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _data$applicationData, _data$applicationData2, _workflowDetails, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _Digit$UserService$ge3, _userSearch$roles, _workflowDetails2, _workflowDetails2$dat, _workflowDetails2$dat2, _workflowDetails2$dat3, _workflowDetails4, _workflowDetails4$dat, _workflowDetails4$dat2, _data$applicationData30, _workflowDetails7, _workflowDetails7$dat, _workflowDetails7$dat2, _workflowDetails7$dat3, _data$collectionBillD, _data$applicationData43, _data$collectionBillD2, _data$applicationData48, _data$collectionBillD3, _workflowDetails13, _workflowDetails13$da, _workflowDetails13$da2, _data$applicationDeta, _data$applicationDeta4, _data$applicationData55, _data$applicationData56, _data$applicationDeta5, _data$applicationDeta6, _workflowDetails40, _workflowDetails40$da;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateCode = Digit.ULBService.getStateId();
  const queryClient = useQueryClient();
  const [showToast, setShowToast] = useState(null);
  const [isTocAccepted, setIsTocAccepted] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [checkBoxVisible, setCheckBoxVisible] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [showTakeAction, setShowTakeAction] = useState("");
  const [currentTab, setCurrentTab] = useState("0");
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };
  sessionStorage.removeItem("BPA_SUBMIT_APP");
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(true));
  sessionStorage.setItem("BPA_IS_ALREADY_WENT_OFF_DETAILS", JSON.stringify(false));
  const history = useHistory();
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const userInfo = ((_Digit$UserService$ge2 = Digit.UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.info) || {};
  sessionStorage.setItem("bpaApplicationDetails", false);
  let isFromSendBack = false;
  const {
    data: stakeHolderDetails,
    isLoading: stakeHolderDetailsLoading
  } = Digit.Hooks.obps.useMDMS(stateCode, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["DocTypeMapping"]);
  const {
    data,
    isLoading
  } = id && Digit.Hooks.obps.useBPADetailsPage(tenantId, {
    applicationNo: id
  });
  console.log("7777", id, data);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(tenantId.split(".")[0], "BPA", ["RiskTypeComputation"]);
  const mutation = Digit.Hooks.obps.useObpsAPI(data === null || data === void 0 ? void 0 : (_data$applicationData = data.applicationData) === null || _data$applicationData === void 0 ? void 0 : _data$applicationData.tenantId, false);
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData2 = data.applicationData) === null || _data$applicationData2 === void 0 ? void 0 : _data$applicationData2.tenantId,
    id: id,
    moduleCode: "OBPS",
    config: {
      enabled: !!data
    }
  });
  console.log("7777ww", mutation, (_workflowDetails = workflowDetails) === null || _workflowDetails === void 0 ? void 0 : (_workflowDetails$data = _workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2[0]) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.action);
  const userSearch = (_Digit$UserService$ge3 = Digit.UserService.getUser()) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.info;
  const isStakeholder = (userSearch === null || userSearch === void 0 ? void 0 : (_userSearch$roles = userSearch.roles) === null || _userSearch$roles === void 0 ? void 0 : _userSearch$roles.length) > 1;
  useEffect(() => {
    var _data$applicationData7, _data$applicationData8;
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData7 = data.applicationData) === null || _data$applicationData7 === void 0 ? void 0 : _data$applicationData7.status) == "CITIZEN_APPROVAL_INPROCESS" || (data === null || data === void 0 ? void 0 : (_data$applicationData8 = data.applicationData) === null || _data$applicationData8 === void 0 ? void 0 : _data$applicationData8.status) == "INPROGRESS") setCheckBoxVisible(true);else setCheckBoxVisible(false);
  }, [data]);
  const actionObject = (_workflowDetails2 = workflowDetails) === null || _workflowDetails2 === void 0 ? void 0 : (_workflowDetails2$dat = _workflowDetails2.data) === null || _workflowDetails2$dat === void 0 ? void 0 : (_workflowDetails2$dat2 = _workflowDetails2$dat.processInstances) === null || _workflowDetails2$dat2 === void 0 ? void 0 : (_workflowDetails2$dat3 = _workflowDetails2$dat2[0]) === null || _workflowDetails2$dat3 === void 0 ? void 0 : _workflowDetails2$dat3.auditDetails;
  const currentTime = new Date().getTime();
  const hoursDifference = (currentTime - (actionObject === null || actionObject === void 0 ? void 0 : actionObject.createdTime)) / (1000 * 60 * 60);
  const twentyFourHoursPassed = hoursDifference >= 24;
  async function getRecieptSearch({
    tenantId,
    payments,
    ...params
  }) {
    var _response;
    let response = {
      filestoreIds: [payments === null || payments === void 0 ? void 0 : payments.fileStoreId]
    };
    response = await Digit.PaymentService.generatePdf(tenantId, {
      Payments: [{
        ...payments
      }]
    }, "consolidatedreceipt");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[(_response = response) === null || _response === void 0 ? void 0 : _response.filestoreIds[0]], "_blank");
  }
  async function getPermitOccupancyOrderSearch({
    tenantId
  }, order, mode = "download") {
    var _data$applicationData9, _data$applicationData10, _data$applicationData11, _data$applicationData12, _data$applicationData13, _data$applicationData14, _data$applicationData15, _data$applicationData16;
    const customLetterDoc = data === null || data === void 0 ? void 0 : (_data$applicationData9 = data.applicationData) === null || _data$applicationData9 === void 0 ? void 0 : (_data$applicationData10 = _data$applicationData9.documents) === null || _data$applicationData10 === void 0 ? void 0 : _data$applicationData10.find(doc => doc.documentType === "customapprovalletter");
    const isAVP = (data === null || data === void 0 ? void 0 : (_data$applicationData11 = data.applicationData) === null || _data$applicationData11 === void 0 ? void 0 : _data$applicationData11.riskType) === "AVP" || (data === null || data === void 0 ? void 0 : (_data$applicationData12 = data.applicationData) === null || _data$applicationData12 === void 0 ? void 0 : (_data$applicationData13 = _data$applicationData12.additionalDetails) === null || _data$applicationData13 === void 0 ? void 0 : _data$applicationData13.riskType) === "AVP" || (data === null || data === void 0 ? void 0 : (_data$applicationData14 = data.applicationData) === null || _data$applicationData14 === void 0 ? void 0 : _data$applicationData14.department) === "AVP";
    if (customLetterDoc && isAVP) {
      try {
        var _response2$data, _response2$data$fileS, _response2$data$fileS2;
        const _response2 = await axios$1.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${customLetterDoc.fileStoreId}`);
        const fileUrl = _response2 === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : (_response2$data$fileS = _response2$data.fileStoreIds) === null || _response2$data$fileS === void 0 ? void 0 : (_response2$data$fileS2 = _response2$data$fileS[0]) === null || _response2$data$fileS2 === void 0 ? void 0 : _response2$data$fileS2.url;
        if (fileUrl) {
          window.open(fileUrl, "_blank");
        }
      } catch (err) {
        console.error("Failed to fetch custom approval letter URL", err);
      }
      return;
    }
    let currentDate = new Date();
    data.applicationData.additionalDetails.runDate = convertDateToEpoch(currentDate.getFullYear() + "-" + (currentDate.getMonth() + 1) + "-" + currentDate.getDate());
    let requestData = {
      ...(data === null || data === void 0 ? void 0 : data.applicationData),
      edcrDetail: [{
        ...(data === null || data === void 0 ? void 0 : data.edcrDetails)
      }]
    };
    let response = await Digit.PaymentService.generatePdf(tenantId, {
      Bpa: [requestData]
    }, order);
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[response === null || response === void 0 ? void 0 : response.filestoreIds[0]], "_blank");
    requestData["applicationType"] = data === null || data === void 0 ? void 0 : (_data$applicationData15 = data.applicationData) === null || _data$applicationData15 === void 0 ? void 0 : (_data$applicationData16 = _data$applicationData15.additionalDetails) === null || _data$applicationData16 === void 0 ? void 0 : _data$applicationData16.applicationType;
    let edcrResponse = await Digit.OBPSService.edcr_report_download({
      BPA: {
        ...requestData
      }
    });
    const responseStatus = parseInt(edcrResponse.status, 10);
    if (responseStatus === 201 || responseStatus === 200) {
      mode == "print" ? printPdf(new Blob([edcrResponse.data], {
        type: "application/pdf"
      })) : downloadPdf(new Blob([edcrResponse.data], {
        type: "application/pdf"
      }), `edcrReport.pdf`);
    }
  }
  async function getApprovalLetter() {
    var _data$applicationData17;
    const res = await OBPSService.designOfApprovalLetterPdf(tenantId, data === null || data === void 0 ? void 0 : (_data$applicationData17 = data.applicationData) === null || _data$applicationData17 === void 0 ? void 0 : _data$applicationData17.applicationNo);
    const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
      type: "application/pdf"
    });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  }
  async function getEmployeeStructuralLetter(url) {
    window.open(url, "_blank");
  }
  function getEmployeeApprovalLetter(url) {
    window.open(url, "_blank");
  }
  async function getRevocationPDFSearch({
    tenantId,
    ...params
  }) {
    let requestData = {
      ...(data === null || data === void 0 ? void 0 : data.applicationData)
    };
    let response = await Digit.PaymentService.generatePdf(tenantId, {
      Bpa: [requestData]
    }, "bpa-revocation");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[response === null || response === void 0 ? void 0 : response.filestoreIds[0]], "_blank");
  }
  useEffect(() => {
    switch (selectedAction) {
      case "APPROVE":
      case "SEND_TO_ARCHITECT":
      case "APPLY":
      case "SKIP_PAYMENT":
      case "SEND_TO_JE":
      case "UPLOAD_SITE_INSPECTION_REPORT":
      case "REJECT":
      case "SENDBACK_TO_ARCHITECT":
      case "FRWD_TO_JE":
      case "ASSIGN_TO_STRUCTURE_ENGINEER":
      case "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE":
        setShowModal(true);
    }
  }, [selectedAction]);
  const closeToast = () => {
    setShowToast(null);
  };
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const closeTermsModal = () => {
    setShowTermsModal(false);
  };
  async function onActionSelect(action) {
    var _data$applicationData18;
    let path = (data === null || data === void 0 ? void 0 : (_data$applicationData18 = data.applicationData) === null || _data$applicationData18 === void 0 ? void 0 : _data$applicationData18.businessService) == "BPA_OC" ? "ocbpa" : "bpa";
    const allPossibleActions = ["SEND_TO_JA", "SEND_TO_CLERK", "SEND_TO_JDM_JE_SPD"];
    const selectedAction = allPossibleActions.filter(e => e === action).toString();
    if (action === "FORWARD") {
      var _data$applicationData19, _data$applicationData20;
      history.replace(`/digit-ui/citizen/obps/sendbacktocitizen/ocbpa/${data === null || data === void 0 ? void 0 : (_data$applicationData19 = data.applicationData) === null || _data$applicationData19 === void 0 ? void 0 : _data$applicationData19.tenantId}/${data === null || data === void 0 ? void 0 : (_data$applicationData20 = data.applicationData) === null || _data$applicationData20 === void 0 ? void 0 : _data$applicationData20.applicationNo}/check`, {
        data: data === null || data === void 0 ? void 0 : data.applicationData,
        edcrDetails: data === null || data === void 0 ? void 0 : data.edcrDetails
      });
    }
    if (action === "MAKE_PAYMENT") {
      var _data$applicationData21;
      let applicationType = data === null || data === void 0 ? void 0 : (_data$applicationData21 = data.applicationData) === null || _data$applicationData21 === void 0 ? void 0 : _data$applicationData21.applicationType;
      let payload = {};
      if (applicationType === "FORM_12") {
        var _data$applicationData22;
        payload.BPA = data === null || data === void 0 ? void 0 : data.applicationData;
        payload.BPA.workflow = {
          action: "MAKE_PAYMENT",
          assignes: null,
          comments: null,
          varificationDocuments: null
        };
        payload.RequestInfo = data === null || data === void 0 ? void 0 : (_data$applicationData22 = data.applicationData) === null || _data$applicationData22 === void 0 ? void 0 : _data$applicationData22.RequestInfo;
        try {
          const response = await OBPSService.update(payload, tenantId);
          window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${id}/${data === null || data === void 0 ? void 0 : data.tenantId}?tenantId=${data === null || data === void 0 ? void 0 : data.tenantId}?flow=${applicationType}`}`);
        } catch (error) {
          console.error("Error in MAKE_PAYMENT action:", error);
        }
      } else if (applicationType === "FORM_11") {
        var _data$applicationData23;
        payload.PermissionOfSubdivision = data === null || data === void 0 ? void 0 : data.applicationData;
        payload.PermissionOfSubdivision.workflow = {
          action: "MAKE_PAYMENT",
          assignes: null,
          comments: null,
          varificationDocuments: null
        };
        payload.RequestInfo = data === null || data === void 0 ? void 0 : (_data$applicationData23 = data.applicationData) === null || _data$applicationData23 === void 0 ? void 0 : _data$applicationData23.RequestInfo;
        try {
          const response = await OBPSService.updateForm11(payload, tenantId);
          window.location.assign(`${window.location.origin}/digit-ui/citizen/payment/collect/${`bpa/${id}/${data === null || data === void 0 ? void 0 : data.tenantId}?tenantId=${data === null || data === void 0 ? void 0 : data.tenantId}?flow=${applicationType}`}`);
        } catch (error) {
          console.error("Error in MAKE_PAYMENT action:", error);
        }
      }
    }
    if (action === "APPROVAL_LETTER_GENERATE") {
      var _data$applicationData24;
      let payload = {};
      payload.BPA = data === null || data === void 0 ? void 0 : data.applicationData;
      payload.BPA.workflow = {
        action: "APPROVAL_LETTER_GENERATE",
        assignes: null,
        comments: null,
        varificationDocuments: null
      }, payload.RequestInfo = data === null || data === void 0 ? void 0 : (_data$applicationData24 = data.applicationData) === null || _data$applicationData24 === void 0 ? void 0 : _data$applicationData24.RequestInfo;
      try {
        var _data$applicationData25;
        const res = await OBPSService.designOfApprovalLetterPdf(tenantId, data === null || data === void 0 ? void 0 : (_data$applicationData25 = data.applicationData) === null || _data$applicationData25 === void 0 ? void 0 : _data$applicationData25.applicationNo);
        const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
          type: "application/pdf"
        });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
        if (res) {
          const response = await OBPSService.update(payload, tenantId);
          if (response) {
            history.replace(`/digit-ui/citizen/obps/response`, {
              data: payload
            });
          }
        } else {
          setShowToast({
            key: "error",
            error: {
              message: "Error in APPROVAL_LETTER_GENERATE"
            }
          });
        }
      } catch (error) {
        console.error("Error in approval letter generate action:", error);
      }
    }
    if (action === "GENERATE_STRUCTURAL_STABILITY_CERTIFICATE") {
      var _data$applicationData26;
      let payload = {};
      payload.BPA = data === null || data === void 0 ? void 0 : data.applicationData;
      payload.BPA.workflow = {
        action: "GENERATE_STRUCTURAL_STABILITY_CERTIFICATE",
        assignes: null,
        comments: null,
        varificationDocuments: null
      }, payload.RequestInfo = data === null || data === void 0 ? void 0 : (_data$applicationData26 = data.applicationData) === null || _data$applicationData26 === void 0 ? void 0 : _data$applicationData26.RequestInfo;
      try {
        var _data$applicationData27;
        const res = await OBPSService.designOfStructuralLetter(tenantId, data === null || data === void 0 ? void 0 : (_data$applicationData27 = data.applicationData) === null || _data$applicationData27 === void 0 ? void 0 : _data$applicationData27.applicationNo);
        const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
          type: "application/pdf"
        });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
        if (res) {
          const response = await OBPSService.update(payload, tenantId);
          if (response) {
            history.replace(`/digit-ui/citizen/obps/response`, {
              data: payload
            });
          }
        } else {
          setShowToast({
            key: "error",
            error: {
              message: "Error in STRUCTURAL_LETTER_GENERATE"
            }
          });
        }
      } catch (error) {
        console.error("Error in approval letter generate action:", error);
      }
    }
    if ((action === null || action === void 0 ? void 0 : action.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE") {
      var _applicationDetails;
      setShowModal(false);
      let payload = {};
      payload.BPA = applicationData;
      payload.BPA.workflow = {
        action: "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE",
        assignes: null,
        comments: onAddComments,
        varificationDocuments: null
      }, payload.RequestInfo = (_applicationDetails = applicationDetails) === null || _applicationDetails === void 0 ? void 0 : _applicationDetails.RequestInfo;
      try {
        var _applicationDetails2;
        const res = await OBPSService.designOfApprovalLetterPdf(state, (_applicationDetails2 = applicationDetails) === null || _applicationDetails2 === void 0 ? void 0 : _applicationDetails2.applicationNo);
        const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
          type: "application/pdf"
        });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl);
      } catch (error) {
        console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
      }
    }
    if (action === "SEND_TO_CITIZEN") {
      var _workflowDetails3, _workflowDetails3$dat, _workflowDetails3$dat2;
      if (((_workflowDetails3 = workflowDetails) === null || _workflowDetails3 === void 0 ? void 0 : (_workflowDetails3$dat = _workflowDetails3.data) === null || _workflowDetails3$dat === void 0 ? void 0 : (_workflowDetails3$dat2 = _workflowDetails3$dat.processInstances) === null || _workflowDetails3$dat2 === void 0 ? void 0 : _workflowDetails3$dat2.length) > 2) {
        var _data$applicationData28, _data$applicationData29;
        window.location.replace(`/digit-ui/citizen/obps/editApplication/${path}/${data === null || data === void 0 ? void 0 : (_data$applicationData28 = data.applicationData) === null || _data$applicationData28 === void 0 ? void 0 : _data$applicationData28.tenantId}/${data === null || data === void 0 ? void 0 : (_data$applicationData29 = data.applicationData) === null || _data$applicationData29 === void 0 ? void 0 : _data$applicationData29.applicationNo}`);
      } else {
        getBPAFormData(data === null || data === void 0 ? void 0 : data.applicationData, mdmsData, history, t);
      }
    }
    if (action === selectedAction) {
      const workflow = {
        action: selectedAction
      };
      mutation.mutate({
        BPA: {
          ...(data === null || data === void 0 ? void 0 : data.applicationData),
          workflow
        }
      }, {
        onError: (error, variables) => {
          var _error$response, _error$response$data, _error$response$data$, _error$response2, _error$response2$data, _error$response2$data2;
          setIsEnableLoader(false);
          setShowModal(false);
          setShowToast({
            key: "error",
            action: error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && (_error$response$data$ = _error$response$data.Errors[0]) !== null && _error$response$data$ !== void 0 && _error$response$data$.message ? error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : (_error$response2$data2 = _error$response2$data.Errors[0]) === null || _error$response2$data2 === void 0 ? void 0 : _error$response2$data2.message : error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          history.replace(`/digit-ui/citizen/obps/response`, {
            data: data
          });
          setShowModal(false);
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.invalidateQueries("BPA_DETAILS_PAGE");
          queryClient.invalidateQueries("workFlowDetails");
        }
      });
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  function checkForSubmitDisable() {
    if (checkBoxVisible) return isFromSendBack ? !isFromSendBack : !isTocAccepted;else return false;
  }
  const submitAction = workflow => {
    setIsEnableLoader(true);
    mutation.mutate({
      BPA: {
        ...(data === null || data === void 0 ? void 0 : data.applicationData),
        workflow
      }
    }, {
      onError: (error, variables) => {
        var _error$response3, _error$response3$data, _error$response3$data2, _error$response4, _error$response4$data, _error$response4$data2;
        setIsEnableLoader(false);
        setShowModal(false);
        setShowToast({
          key: "error",
          action: error !== null && error !== void 0 && (_error$response3 = error.response) !== null && _error$response3 !== void 0 && (_error$response3$data = _error$response3.data) !== null && _error$response3$data !== void 0 && (_error$response3$data2 = _error$response3$data.Errors[0]) !== null && _error$response3$data2 !== void 0 && _error$response3$data2.message ? error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : (_error$response4$data2 = _error$response4$data.Errors[0]) === null || _error$response4$data2 === void 0 ? void 0 : _error$response4$data2.message : error
        });
        setTimeout(closeToast, 5000);
      },
      onSuccess: (data, variables) => {
        setIsEnableLoader(false);
        history.replace(`/digit-ui/citizen/obps/response`, {
          data: data
        });
        setShowModal(false);
        setShowToast({
          key: "success",
          action: selectedAction
        });
        setTimeout(closeToast, 5000);
        queryClient.invalidateQueries("BPA_DETAILS_PAGE");
        queryClient.invalidateQueries("workFlowDetails");
      }
    });
  };
  if (((_workflowDetails4 = workflowDetails) === null || _workflowDetails4 === void 0 ? void 0 : (_workflowDetails4$dat = _workflowDetails4.data) === null || _workflowDetails4$dat === void 0 ? void 0 : (_workflowDetails4$dat2 = _workflowDetails4$dat.nextActions) === null || _workflowDetails4$dat2 === void 0 ? void 0 : _workflowDetails4$dat2.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$applicationData30 = data.applicationData) === null || _data$applicationData30 === void 0 ? void 0 : _data$applicationData30.status) == "CITIZEN_APPROVAL_INPROCESS") {
    var _userInfo$info, _data$applicationData31, _data$applicationData32;
    const _userInfo = Digit.UserService.getUser();
    const rolearray = _userInfo === null || _userInfo === void 0 ? void 0 : (_userInfo$info = _userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.roles;
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData31 = data.applicationData) === null || _data$applicationData31 === void 0 ? void 0 : _data$applicationData31.status) == "CITIZEN_APPROVAL_INPROCESS") {
      var _rolearray$;
      if ((rolearray === null || rolearray === void 0 ? void 0 : rolearray.length) == 1 && (rolearray === null || rolearray === void 0 ? void 0 : (_rolearray$ = rolearray[0]) === null || _rolearray$ === void 0 ? void 0 : _rolearray$.code) == "CITIZEN") {
        var _workflowDetails5, _workflowDetails5$dat;
        workflowDetails.data.nextActions = (_workflowDetails5 = workflowDetails) === null || _workflowDetails5 === void 0 ? void 0 : (_workflowDetails5$dat = _workflowDetails5.data) === null || _workflowDetails5$dat === void 0 ? void 0 : _workflowDetails5$dat.nextActions;
      } else {
        workflowDetails.data.nextActions = [];
      }
    } else if ((data === null || data === void 0 ? void 0 : (_data$applicationData32 = data.applicationData) === null || _data$applicationData32 === void 0 ? void 0 : _data$applicationData32.status) == "INPROGRESS") {
      var _stakeHolderDetails$S, _stakeHolderDetails$S2;
      let isArchitect = false;
      stakeHolderDetails === null || stakeHolderDetails === void 0 ? void 0 : (_stakeHolderDetails$S = stakeHolderDetails.StakeholderRegistraition) === null || _stakeHolderDetails$S === void 0 ? void 0 : (_stakeHolderDetails$S2 = _stakeHolderDetails$S.TradeTypetoRoleMapping) === null || _stakeHolderDetails$S2 === void 0 ? void 0 : _stakeHolderDetails$S2.map(type => {
        var _type$role;
        type === null || type === void 0 ? void 0 : (_type$role = type.role) === null || _type$role === void 0 ? void 0 : _type$role.map(role => {
          roles.push(role);
        });
      });
      const uniqueRoles = roles.filter((item, i, ar) => ar.indexOf(item) === i);
      if ((rolearray === null || rolearray === void 0 ? void 0 : rolearray.length) > 1) {
        rolearray.forEach(role => {
          if (uniqueRoles.includes(role.code)) {
            isArchitect = true;
          }
        });
      }
      if (isArchitect) {
        var _workflowDetails6, _workflowDetails6$dat;
        workflowDetails.data.nextActions = (_workflowDetails6 = workflowDetails) === null || _workflowDetails6 === void 0 ? void 0 : (_workflowDetails6$dat = _workflowDetails6.data) === null || _workflowDetails6$dat === void 0 ? void 0 : _workflowDetails6$dat.nextActions;
      } else {
        workflowDetails.data.nextActions = [];
      }
    }
  }
  if (((_workflowDetails7 = workflowDetails) === null || _workflowDetails7 === void 0 ? void 0 : (_workflowDetails7$dat = _workflowDetails7.data) === null || _workflowDetails7$dat === void 0 ? void 0 : (_workflowDetails7$dat2 = _workflowDetails7$dat.processInstances) === null || _workflowDetails7$dat2 === void 0 ? void 0 : (_workflowDetails7$dat3 = _workflowDetails7$dat2[0]) === null || _workflowDetails7$dat3 === void 0 ? void 0 : _workflowDetails7$dat3.action) === "SEND_BACK_TO_CITIZEN") {
    var _userInfo2$info;
    if (isTocAccepted) setIsTocAccepted(true);
    isFromSendBack = true;
    const _userInfo2 = Digit.UserService.getUser();
    const rolearray = _userInfo2 === null || _userInfo2 === void 0 ? void 0 : (_userInfo2$info = _userInfo2.info) === null || _userInfo2$info === void 0 ? void 0 : _userInfo2$info.roles;
    if ((rolearray === null || rolearray === void 0 ? void 0 : rolearray.length) !== 1) {
      var _workflowDetails8, _workflowDetails9;
      workflowDetails = {
        ...workflowDetails,
        data: {
          ...((_workflowDetails8 = workflowDetails) === null || _workflowDetails8 === void 0 ? void 0 : _workflowDetails8.data),
          actionState: {
            nextActions: []
          }
        },
        data: {
          ...((_workflowDetails9 = workflowDetails) === null || _workflowDetails9 === void 0 ? void 0 : _workflowDetails9.data),
          nextActions: []
        }
      };
    }
  }
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  let dowloadOptions = [];
  if ((data === null || data === void 0 ? void 0 : (_data$collectionBillD = data.collectionBillDetails) === null || _data$collectionBillD === void 0 ? void 0 : _data$collectionBillD.length) > 0) {
    const bpaPayments = cloneDeep(data === null || data === void 0 ? void 0 : data.collectionBillDetails);
    bpaPayments.forEach(pay => {
      var _pay$paymentDetails$, _pay$paymentDetails$2, _pay$paymentDetails$3, _pay$paymentDetails$4, _pay$paymentDetails$5;
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$ = pay.paymentDetails[0]) === null || _pay$paymentDetails$ === void 0 ? void 0 : _pay$paymentDetails$.businessService) === "BPA.NC_OC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData33, _data$applicationData34;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData33 = data.applicationData) === null || _data$applicationData33 === void 0 ? void 0 : _data$applicationData33.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData34 = data.applicationData) === null || _data$applicationData34 === void 0 ? void 0 : _data$applicationData34.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$2 = pay.paymentDetails[0]) === null || _pay$paymentDetails$2 === void 0 ? void 0 : _pay$paymentDetails$2.businessService) === "BPA.NC_OC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_OC_DEV_PEN_RECEIPT"),
          onClick: () => {
            var _data$applicationData35, _data$applicationData36;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData35 = data.applicationData) === null || _data$applicationData35 === void 0 ? void 0 : _data$applicationData35.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData36 = data.applicationData) === null || _data$applicationData36 === void 0 ? void 0 : _data$applicationData36.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$3 = pay.paymentDetails[0]) === null || _pay$paymentDetails$3 === void 0 ? void 0 : _pay$paymentDetails$3.businessService) === "BPA.LOW_RISK_PERMIT_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData37, _data$applicationData38;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData37 = data.applicationData) === null || _data$applicationData37 === void 0 ? void 0 : _data$applicationData37.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData38 = data.applicationData) === null || _data$applicationData38 === void 0 ? void 0 : _data$applicationData38.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$4 = pay.paymentDetails[0]) === null || _pay$paymentDetails$4 === void 0 ? void 0 : _pay$paymentDetails$4.businessService) === "BPA.NC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData39, _data$applicationData40;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData39 = data.applicationData) === null || _data$applicationData39 === void 0 ? void 0 : _data$applicationData39.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData40 = data.applicationData) === null || _data$applicationData40 === void 0 ? void 0 : _data$applicationData40.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$5 = pay.paymentDetails[0]) === null || _pay$paymentDetails$5 === void 0 ? void 0 : _pay$paymentDetails$5.businessService) === "BPA.NC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_SAN_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData41, _data$applicationData42;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData41 = data.applicationData) === null || _data$applicationData41 === void 0 ? void 0 : _data$applicationData41.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData42 = data.applicationData) === null || _data$applicationData42 === void 0 ? void 0 : _data$applicationData42.applicationNo
            });
          }
        });
      }
    });
  }
  if (data && (data === null || data === void 0 ? void 0 : (_data$applicationData43 = data.applicationData) === null || _data$applicationData43 === void 0 ? void 0 : _data$applicationData43.businessService) === "BPA_LOW" && (data === null || data === void 0 ? void 0 : (_data$collectionBillD2 = data.collectionBillDetails) === null || _data$collectionBillD2 === void 0 ? void 0 : _data$collectionBillD2.length) > 0) {
    var _data$applicationData44, _data$applicationData46;
    !(data !== null && data !== void 0 && (_data$applicationData44 = data.applicationData) !== null && _data$applicationData44 !== void 0 && _data$applicationData44.status.includes("REVOCATION")) && dowloadOptions.push({
      order: 3,
      label: t("BPA_PERMIT_ORDER"),
      onClick: () => {
        var _data$applicationData45;
        return getPermitOccupancyOrderSearch({
          tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData45 = data.applicationData) === null || _data$applicationData45 === void 0 ? void 0 : _data$applicationData45.tenantId
        }, "buildingpermit-low");
      }
    });
    (data === null || data === void 0 ? void 0 : (_data$applicationData46 = data.applicationData) === null || _data$applicationData46 === void 0 ? void 0 : _data$applicationData46.status.includes("REVOCATION")) && dowloadOptions.push({
      order: 3,
      label: t("BPA_REVOCATION_PDF_LABEL"),
      onClick: () => {
        var _data$applicationData47;
        return getRevocationPDFSearch({
          tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData47 = data.applicationData) === null || _data$applicationData47 === void 0 ? void 0 : _data$applicationData47.tenantId
        });
      }
    });
  } else if (data && (data === null || data === void 0 ? void 0 : (_data$applicationData48 = data.applicationData) === null || _data$applicationData48 === void 0 ? void 0 : _data$applicationData48.businessService) === "BPA" && (data === null || data === void 0 ? void 0 : (_data$collectionBillD3 = data.collectionBillDetails) === null || _data$collectionBillD3 === void 0 ? void 0 : _data$collectionBillD3.length) > 0) {
    var _data$applicationData49;
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData49 = data.applicationData) === null || _data$applicationData49 === void 0 ? void 0 : _data$applicationData49.status) === "APPROVED") {
      dowloadOptions.push({
        order: 3,
        label: t("BPA_PERMIT_ORDER"),
        onClick: () => {
          var _data$applicationData50;
          return getPermitOccupancyOrderSearch({
            tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData50 = data.applicationData) === null || _data$applicationData50 === void 0 ? void 0 : _data$applicationData50.tenantId
          }, "buildingpermit");
        }
      });
    }
  } else {
    var _data$applicationData51, _data$applicationData52, _data$applicationData53, _workflowDetails10, _workflowDetails10$da, _workflowDetails10$da2, _data$applicationData54, _filteredArray$, _filteredArray$$thumb, _filteredArray$$thumb2, _workflowDetails11, _workflowDetails11$da, _workflowDetails11$da2;
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData51 = data.applicationData) === null || _data$applicationData51 === void 0 ? void 0 : _data$applicationData51.plotArea) < 500 && ((data === null || data === void 0 ? void 0 : (_data$applicationData52 = data.applicationData) === null || _data$applicationData52 === void 0 ? void 0 : _data$applicationData52.status) === "APPROVED" || (data === null || data === void 0 ? void 0 : (_data$applicationData53 = data.applicationData) === null || _data$applicationData53 === void 0 ? void 0 : _data$applicationData53.status) === "UPLOAD_SITE_INSPECTION")) {
      dowloadOptions.push({
        order: 1,
        label: t("BPA_DOWNLOAD_APPROVAL_LETTER"),
        onClick: () => getApprovalLetter()
      });
    }
    const filteredArray = (_workflowDetails10 = workflowDetails) === null || _workflowDetails10 === void 0 ? void 0 : (_workflowDetails10$da = _workflowDetails10.data) === null || _workflowDetails10$da === void 0 ? void 0 : (_workflowDetails10$da2 = _workflowDetails10$da.timeline) === null || _workflowDetails10$da2 === void 0 ? void 0 : _workflowDetails10$da2.filter(item => item.performedAction === "UPLOAD_DIGI_SIGN_LETTER");
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData54 = data.applicationData) === null || _data$applicationData54 === void 0 ? void 0 : _data$applicationData54.status) === "APPROVED" && (filteredArray === null || filteredArray === void 0 ? void 0 : filteredArray.length) > 0 && (filteredArray === null || filteredArray === void 0 ? void 0 : (_filteredArray$ = filteredArray[0]) === null || _filteredArray$ === void 0 ? void 0 : (_filteredArray$$thumb = _filteredArray$.thumbnailsToShow) === null || _filteredArray$$thumb === void 0 ? void 0 : (_filteredArray$$thumb2 = _filteredArray$$thumb.fullImage) === null || _filteredArray$$thumb2 === void 0 ? void 0 : _filteredArray$$thumb2.length) > 0) {
      var _filteredArray$2, _filteredArray$2$thum, _filteredArray$2$thum2;
      const url = filteredArray === null || filteredArray === void 0 ? void 0 : (_filteredArray$2 = filteredArray[0]) === null || _filteredArray$2 === void 0 ? void 0 : (_filteredArray$2$thum = _filteredArray$2.thumbnailsToShow) === null || _filteredArray$2$thum === void 0 ? void 0 : (_filteredArray$2$thum2 = _filteredArray$2$thum.fullImage) === null || _filteredArray$2$thum2 === void 0 ? void 0 : _filteredArray$2$thum2[0];
      dowloadOptions.push({
        order: 2,
        label: t("BPA_DOWNLOAD_APPROVAL_LETTER"),
        onClick: () => getEmployeeApprovalLetter(url)
      });
    }
    if (((_workflowDetails11 = workflowDetails) === null || _workflowDetails11 === void 0 ? void 0 : (_workflowDetails11$da = _workflowDetails11.data) === null || _workflowDetails11$da === void 0 ? void 0 : (_workflowDetails11$da2 = _workflowDetails11$da.timeline) === null || _workflowDetails11$da2 === void 0 ? void 0 : _workflowDetails11$da2.length) > 3) {
      var _workflowDetails12, _workflowDetails12$da, _workflowDetails12$da2, _filteredArray$3, _filteredArray$3$thum, _filteredArray$3$thum2;
      const _filteredArray = (_workflowDetails12 = workflowDetails) === null || _workflowDetails12 === void 0 ? void 0 : (_workflowDetails12$da = _workflowDetails12.data) === null || _workflowDetails12$da === void 0 ? void 0 : (_workflowDetails12$da2 = _workflowDetails12$da.timeline) === null || _workflowDetails12$da2 === void 0 ? void 0 : _workflowDetails12$da2.filter(item => item.status === "SEND_TO_ARCHITECT");
      const url = _filteredArray === null || _filteredArray === void 0 ? void 0 : (_filteredArray$3 = _filteredArray[0]) === null || _filteredArray$3 === void 0 ? void 0 : (_filteredArray$3$thum = _filteredArray$3.thumbnailsToShow) === null || _filteredArray$3$thum === void 0 ? void 0 : (_filteredArray$3$thum2 = _filteredArray$3$thum.fullImage) === null || _filteredArray$3$thum2 === void 0 ? void 0 : _filteredArray$3$thum2[0];
      dowloadOptions.push({
        order: 3,
        label: t("BPA_DOWNLOAD_STRUCTURAL_LETTER"),
        onClick: () => getEmployeeStructuralLetter(url)
      });
    }
  }
  if (data !== null && data !== void 0 && data.comparisionReport) {
    dowloadOptions.push({
      order: 4,
      label: t("BPA_COMPARISON_REPORT_LABEL"),
      onClick: () => {
        var _data$comparisionRepo;
        return window.open(data === null || data === void 0 ? void 0 : (_data$comparisionRepo = data.comparisionReport) === null || _data$comparisionRepo === void 0 ? void 0 : _data$comparisionRepo.comparisonReport, "_blank");
      }
    });
  }
  dowloadOptions.sort(function (a, b) {
    return a.order - b.order;
  });
  if (((_workflowDetails13 = workflowDetails) === null || _workflowDetails13 === void 0 ? void 0 : (_workflowDetails13$da = _workflowDetails13.data) === null || _workflowDetails13$da === void 0 ? void 0 : (_workflowDetails13$da2 = _workflowDetails13$da.nextActions) === null || _workflowDetails13$da2 === void 0 ? void 0 : _workflowDetails13$da2.length) > 0) {
    var _workflowDetails14, _workflowDetails14$da, _workflowDetails14$da2, _workflowDetails15, _workflowDetails15$da, _workflowDetails15$da2, _workflowDetails16, _workflowDetails16$da, _workflowDetails16$da2;
    workflowDetails.data.nextActions = (_workflowDetails14 = workflowDetails) === null || _workflowDetails14 === void 0 ? void 0 : (_workflowDetails14$da = _workflowDetails14.data) === null || _workflowDetails14$da === void 0 ? void 0 : (_workflowDetails14$da2 = _workflowDetails14$da.nextActions) === null || _workflowDetails14$da2 === void 0 ? void 0 : _workflowDetails14$da2.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = (_workflowDetails15 = workflowDetails) === null || _workflowDetails15 === void 0 ? void 0 : (_workflowDetails15$da = _workflowDetails15.data) === null || _workflowDetails15$da === void 0 ? void 0 : (_workflowDetails15$da2 = _workflowDetails15$da.nextActions) === null || _workflowDetails15$da2 === void 0 ? void 0 : _workflowDetails15$da2.filter(actn => actn.action !== "ADHOC");
    workflowDetails.data.nextActions = (_workflowDetails16 = workflowDetails) === null || _workflowDetails16 === void 0 ? void 0 : (_workflowDetails16$da = _workflowDetails16.data) === null || _workflowDetails16$da === void 0 ? void 0 : (_workflowDetails16$da2 = _workflowDetails16$da.nextActions) === null || _workflowDetails16$da2 === void 0 ? void 0 : _workflowDetails16$da2.filter(actn => actn.action !== "SKIP_PAYMENT");
  }
  if ((data === null || data === void 0 ? void 0 : (_data$applicationDeta = data.applicationDetails) === null || _data$applicationDeta === void 0 ? void 0 : _data$applicationDeta.length) > 0) {
    var _data$applicationDeta2, _data$applicationDeta3;
    data.applicationDetails = (data === null || data === void 0 ? void 0 : (_data$applicationDeta2 = data.applicationDetails) === null || _data$applicationDeta2 === void 0 ? void 0 : _data$applicationDeta2.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$applicationDeta3 = data.applicationDetails) === null || _data$applicationDeta3 === void 0 ? void 0 : _data$applicationDeta3.filter(bpaData => Object.keys(bpaData).length !== 0));
  }
  const getCheckBoxLable = () => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, `${t("BPA_I_AGREE_THE_LABEL")} `), /*#__PURE__*/React__default.createElement("span", {
      style: {
        color: "#1F4A7C",
        cursor: "pointer"
      },
      onClick: () => setShowTermsModal(!showTermsModal)
    }, t(`BPA_TERMS_AND_CONDITIONS_LABEL`)));
  };
  const results = data === null || data === void 0 ? void 0 : (_data$applicationDeta4 = data.applicationDetails) === null || _data$applicationDeta4 === void 0 ? void 0 : _data$applicationDeta4.filter(element => {
    if (Object.keys(element).length !== 0) {
      return true;
    }
    return false;
  });
  if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
    data.applicationDetails = results;
  }
  const handleshow19 = async e => {
    console.log("enter111111111");
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: ".01",
        ts: null,
        action: "_update",
        did: "1",
        key: "",
        msgId: "20170310130900|en_IN",
        authToken: authToken,
        userInfo: userInfo
      }
    };
    try {
      console.log("5555676877try");
      const Resp = await axios$1.post(`${Urls$1.obps.designOfStuctural}?tenantId=hp&applicationNumber=${id}`, payload, {
        responseType: "arraybuffer"
      });
      const pdfBlob = new Blob([Resp.data], {
        type: "application/pdf"
      });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl);
      setShowTakeAction("Take_Action");
    } catch (error) {
      console.log("5555676877catch");
      return error;
    }
  };
  const handleChangedata = e => {
    undefined.setState({
      isRadioSelected: true
    });
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChangeTab
  }, tablist.map(({
    label,
    color
  }, index) => /*#__PURE__*/React__default.createElement(Tab, {
    label: `${t(label)}`,
    value: `${index}`,
    sx: {
      textTransform: "none",
      p: "0 1rem",
      color
    }
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "0",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", null, (data === null || data === void 0 ? void 0 : (_data$applicationData55 = data.applicationData) === null || _data$applicationData55 === void 0 ? void 0 : _data$applicationData55.applicationType) === "FORM_12" &&
  /*#__PURE__*/
  React__default.createElement(ApplicationView12, {
    id: id,
    formType: data === null || data === void 0 ? void 0 : (_data$applicationData56 = data.applicationData) === null || _data$applicationData56 === void 0 ? void 0 : _data$applicationData56.applicationType
  }), data === null || data === void 0 ? void 0 : (_data$applicationDeta5 = data.applicationDetails) === null || _data$applicationDeta5 === void 0 ? void 0 : _data$applicationDeta5.filter(ob => Object.keys(ob).length > 0).map((detail, index, arr) => {
    var _workflowDetails17, _workflowDetails18, _workflowDetails18$da, _workflowDetails18$da2, _workflowDetails19, _workflowDetails20, _workflowDetails20$da, _workflowDetails20$da2, _workflowDetails21, _workflowDetails21$da, _workflowDetails21$da2, _workflowDetails21$da3, _workflowDetails22, _workflowDetails22$da, _workflowDetails23, _workflowDetails23$da, _workflowDetails24, _workflowDetails25, _workflowDetails25$da, _workflowDetails25$da2, _workflowDetails26, _workflowDetails26$da, _workflowDetails26$da2, _workflowDetails26$da3, _workflowDetails27, _workflowDetails27$da, _workflowDetails28, _workflowDetails28$da, _workflowDetails29, _workflowDetails30, _workflowDetails30$da, _workflowDetails30$da2, _workflowDetails31, _workflowDetails31$da, _workflowDetails31$da2, _workflowDetails31$da3, _workflowDetails32, _workflowDetails32$da, _workflowDetails33, _workflowDetails33$da, _workflowDetails34, _workflowDetails35, _workflowDetails35$da, _workflowDetails35$da2, _workflowDetails36, _workflowDetails36$da, _workflowDetails36$da2, _workflowDetails36$da3, _workflowDetails37, _workflowDetails37$da, _workflowDetails37$da2, _workflowDetails37$da3, _workflowDetails38, _workflowDetails38$da, _workflowDetails38$da2, _workflowDetails38$da3, _workflowDetails39, _workflowDetails39$da, _workflowDetails39$da2, _workflowDetails39$da3;
    return /*#__PURE__*/React__default.createElement("div", null, index === arr.length - 1 && /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(Fragment$2, null, !((_workflowDetails17 = workflowDetails) !== null && _workflowDetails17 !== void 0 && _workflowDetails17.isLoading) && ((_workflowDetails18 = workflowDetails) === null || _workflowDetails18 === void 0 ? void 0 : (_workflowDetails18$da = _workflowDetails18.data) === null || _workflowDetails18$da === void 0 ? void 0 : (_workflowDetails18$da2 = _workflowDetails18$da.nextActions) === null || _workflowDetails18$da2 === void 0 ? void 0 : _workflowDetails18$da2.length) > 0 && !isFromSendBack && checkBoxVisible && /*#__PURE__*/React__default.createElement(CheckBox$1, {
      styles: {
        margin: "20px 0 40px",
        paddingTop: "10px"
      },
      checked: isTocAccepted,
      label: getCheckBoxLable(),
      onChange: () => {
        setIsTocAccepted(!isTocAccepted);
        isTocAccepted ? setDisplayMenu(!isTocAccepted) : "";
      }
    }), !((_workflowDetails19 = workflowDetails) !== null && _workflowDetails19 !== void 0 && _workflowDetails19.isLoading) && ((_workflowDetails20 = workflowDetails) === null || _workflowDetails20 === void 0 ? void 0 : (_workflowDetails20$da = _workflowDetails20.data) === null || _workflowDetails20$da === void 0 ? void 0 : (_workflowDetails20$da2 = _workflowDetails20$da.nextActions) === null || _workflowDetails20$da2 === void 0 ? void 0 : _workflowDetails20$da2.length) > 1 && ((_workflowDetails21 = workflowDetails) === null || _workflowDetails21 === void 0 ? void 0 : (_workflowDetails21$da = _workflowDetails21.data) === null || _workflowDetails21$da === void 0 ? void 0 : (_workflowDetails21$da2 = _workflowDetails21$da.nextActions) === null || _workflowDetails21$da2 === void 0 ? void 0 : (_workflowDetails21$da3 = _workflowDetails21$da2[0]) === null || _workflowDetails21$da3 === void 0 ? void 0 : _workflowDetails21$da3.action) != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(ActionBar, {
      style: {
        position: "relative",
        boxShadow: "none",
        minWidth: "240px",
        maxWidth: "310px",
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, displayMenu && (_workflowDetails22 = workflowDetails) !== null && _workflowDetails22 !== void 0 && (_workflowDetails22$da = _workflowDetails22.data) !== null && _workflowDetails22$da !== void 0 && _workflowDetails22$da.nextActions ? /*#__PURE__*/React__default.createElement(Menu, {
      style: {
        bottom: "37px",
        minWidth: "240px",
        maxWidth: "310px",
        width: "100%",
        right: "0px"
      },
      localeKeyPrefix: "WF_BPA",
      options: (_workflowDetails23 = workflowDetails) === null || _workflowDetails23 === void 0 ? void 0 : (_workflowDetails23$da = _workflowDetails23.data) === null || _workflowDetails23$da === void 0 ? void 0 : _workflowDetails23$da.nextActions.map(action => action.action),
      t: t,
      onSelect: onActionSelect
    }) : null, /*#__PURE__*/React__default.createElement(SubmitBar, {
      style: {
        width: "100%"
      },
      disabled: checkForSubmitDisable(),
      label: t("ES_COMMON_TAKE_ACTION"),
      onSubmit: () => setDisplayMenu(!displayMenu)
    }))), !((_workflowDetails24 = workflowDetails) !== null && _workflowDetails24 !== void 0 && _workflowDetails24.isLoading) && (((_workflowDetails25 = workflowDetails) === null || _workflowDetails25 === void 0 ? void 0 : (_workflowDetails25$da = _workflowDetails25.data) === null || _workflowDetails25$da === void 0 ? void 0 : (_workflowDetails25$da2 = _workflowDetails25$da.nextActions) === null || _workflowDetails25$da2 === void 0 ? void 0 : _workflowDetails25$da2.length) > 1 || ((_workflowDetails26 = workflowDetails) === null || _workflowDetails26 === void 0 ? void 0 : (_workflowDetails26$da = _workflowDetails26.data) === null || _workflowDetails26$da === void 0 ? void 0 : (_workflowDetails26$da2 = _workflowDetails26$da.nextActions) === null || _workflowDetails26$da2 === void 0 ? void 0 : (_workflowDetails26$da3 = _workflowDetails26$da2[0]) === null || _workflowDetails26$da3 === void 0 ? void 0 : _workflowDetails26$da3.action) === "UPLOAD_SITE_INSPECTION_REPORT") && isStakeholder && twentyFourHoursPassed && /*#__PURE__*/React__default.createElement(ActionBar, {
      style: {
        position: "relative",
        boxShadow: "none",
        minWidth: "240px",
        maxWidth: "310px",
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, displayMenu && (_workflowDetails27 = workflowDetails) !== null && _workflowDetails27 !== void 0 && (_workflowDetails27$da = _workflowDetails27.data) !== null && _workflowDetails27$da !== void 0 && _workflowDetails27$da.nextActions ? /*#__PURE__*/React__default.createElement(Menu, {
      style: {
        bottom: "37px",
        minWidth: "240px",
        maxWidth: "310px",
        width: "100%",
        right: "0px"
      },
      localeKeyPrefix: "WF_BPA",
      options: (_workflowDetails28 = workflowDetails) === null || _workflowDetails28 === void 0 ? void 0 : (_workflowDetails28$da = _workflowDetails28.data) === null || _workflowDetails28$da === void 0 ? void 0 : _workflowDetails28$da.nextActions.map(action => action.action),
      t: t,
      onSelect: onActionSelect
    }) : null, /*#__PURE__*/React__default.createElement(SubmitBar, {
      style: {
        width: "100%"
      },
      disabled: checkForSubmitDisable(),
      label: t("ES_COMMON_TAKE_ACTION"),
      onSubmit: () => setDisplayMenu(!displayMenu)
    }))), !((_workflowDetails29 = workflowDetails) !== null && _workflowDetails29 !== void 0 && _workflowDetails29.isLoading) && ((_workflowDetails30 = workflowDetails) === null || _workflowDetails30 === void 0 ? void 0 : (_workflowDetails30$da = _workflowDetails30.data) === null || _workflowDetails30$da === void 0 ? void 0 : (_workflowDetails30$da2 = _workflowDetails30$da.nextActions) === null || _workflowDetails30$da2 === void 0 ? void 0 : _workflowDetails30$da2.length) > 1 && ((_workflowDetails31 = workflowDetails) === null || _workflowDetails31 === void 0 ? void 0 : (_workflowDetails31$da = _workflowDetails31.data) === null || _workflowDetails31$da === void 0 ? void 0 : (_workflowDetails31$da2 = _workflowDetails31$da.nextActions) === null || _workflowDetails31$da2 === void 0 ? void 0 : (_workflowDetails31$da3 = _workflowDetails31$da2[0]) === null || _workflowDetails31$da3 === void 0 ? void 0 : _workflowDetails31$da3.action) === "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && /*#__PURE__*/React__default.createElement(Card, {
      style: {
        marginRight: "0%",
        marginLeft: "15%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "px-3"
    }, /*#__PURE__*/React__default.createElement(Button$3, {
      style: {
        textAlign: "right",
        padding: "4px"
      },
      value: "Submit",
      id: "Submit",
      onChange1: handleChangedata,
      name: "Submit",
      onClick: handleshow19
    }, "Issue Structural Certificate PDF ", /*#__PURE__*/React__default.createElement(FileDownloadIcon, null))), showTakeAction === "Take_Action" && /*#__PURE__*/React__default.createElement(ActionBar, {
      style: {
        position: "relative",
        boxShadow: "none",
        minWidth: "240px",
        maxWidth: "310px",
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, displayMenu && (_workflowDetails32 = workflowDetails) !== null && _workflowDetails32 !== void 0 && (_workflowDetails32$da = _workflowDetails32.data) !== null && _workflowDetails32$da !== void 0 && _workflowDetails32$da.nextActions ? /*#__PURE__*/React__default.createElement(Menu, {
      style: {
        bottom: "37px",
        minWidth: "240px",
        maxWidth: "310px",
        width: "100%",
        right: "0px"
      },
      localeKeyPrefix: "WF_BPA",
      options: (_workflowDetails33 = workflowDetails) === null || _workflowDetails33 === void 0 ? void 0 : (_workflowDetails33$da = _workflowDetails33.data) === null || _workflowDetails33$da === void 0 ? void 0 : _workflowDetails33$da.nextActions.map(action => action.action),
      t: t,
      onSelect: onActionSelect
    }) : null, /*#__PURE__*/React__default.createElement(SubmitBar, {
      style: {
        width: "100%"
      },
      disabled: checkForSubmitDisable(),
      label: t("ES_COMMON_TAKE_ACTION"),
      onSubmit: () => setDisplayMenu(!displayMenu)
    }))))), !((_workflowDetails34 = workflowDetails) !== null && _workflowDetails34 !== void 0 && _workflowDetails34.isLoading) && ((_workflowDetails35 = workflowDetails) === null || _workflowDetails35 === void 0 ? void 0 : (_workflowDetails35$da = _workflowDetails35.data) === null || _workflowDetails35$da === void 0 ? void 0 : (_workflowDetails35$da2 = _workflowDetails35$da.nextActions) === null || _workflowDetails35$da2 === void 0 ? void 0 : _workflowDetails35$da2.length) == 1 && ((_workflowDetails36 = workflowDetails) === null || _workflowDetails36 === void 0 ? void 0 : (_workflowDetails36$da = _workflowDetails36.data) === null || _workflowDetails36$da === void 0 ? void 0 : (_workflowDetails36$da2 = _workflowDetails36$da.nextActions) === null || _workflowDetails36$da2 === void 0 ? void 0 : (_workflowDetails36$da3 = _workflowDetails36$da2[0]) === null || _workflowDetails36$da3 === void 0 ? void 0 : _workflowDetails36$da3.action) !== "UPLOAD_SITE_INSPECTION_REPORT" && /*#__PURE__*/React__default.createElement(ActionBar, {
      style: {
        position: "relative",
        boxShadow: "none",
        minWidth: "240px",
        maxWidth: "310px",
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("button", {
      style: {
        width: "100%",
        color: "#FFFFFF",
        fontSize: "19px"
      },
      className: `${checkForSubmitDisable() ? "submit-bar-disabled" : "submit-bar"}`,
      disabled: checkForSubmitDisable(),
      name: (_workflowDetails37 = workflowDetails) === null || _workflowDetails37 === void 0 ? void 0 : (_workflowDetails37$da = _workflowDetails37.data) === null || _workflowDetails37$da === void 0 ? void 0 : (_workflowDetails37$da2 = _workflowDetails37$da.nextActions) === null || _workflowDetails37$da2 === void 0 ? void 0 : (_workflowDetails37$da3 = _workflowDetails37$da2[0]) === null || _workflowDetails37$da3 === void 0 ? void 0 : _workflowDetails37$da3.action,
      value: (_workflowDetails38 = workflowDetails) === null || _workflowDetails38 === void 0 ? void 0 : (_workflowDetails38$da = _workflowDetails38.data) === null || _workflowDetails38$da === void 0 ? void 0 : (_workflowDetails38$da2 = _workflowDetails38$da.nextActions) === null || _workflowDetails38$da2 === void 0 ? void 0 : (_workflowDetails38$da3 = _workflowDetails38$da2[0]) === null || _workflowDetails38$da3 === void 0 ? void 0 : _workflowDetails38$da3.action,
      onClick: e => {
        onActionSelect(e.target.value);
      }
    }, t(`WF_BPA_${(_workflowDetails39 = workflowDetails) === null || _workflowDetails39 === void 0 ? void 0 : (_workflowDetails39$da = _workflowDetails39.data) === null || _workflowDetails39$da === void 0 ? void 0 : (_workflowDetails39$da2 = _workflowDetails39$da.nextActions) === null || _workflowDetails39$da2 === void 0 ? void 0 : (_workflowDetails39$da3 = _workflowDetails39$da2[0]) === null || _workflowDetails39$da3 === void 0 ? void 0 : _workflowDetails39$da3.action}`)))))));
  }))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, data === null || data === void 0 ? void 0 : (_data$applicationDeta6 = data.applicationDetails) === null || _data$applicationDeta6 === void 0 ? void 0 : _data$applicationDeta6.filter(ob => Object.keys(ob).length > 0).map((detail, index, arr) => {
    return /*#__PURE__*/React__default.createElement("div", null, index === arr.length - 1 && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(BPAApplicationTimeline, {
      application: data === null || data === void 0 ? void 0 : data.applicationData,
      id: id
    })));
  }))), showTermsModal ? /*#__PURE__*/React__default.createElement(ActionModal$1, {
    t: t,
    action: "TERMS_AND_CONDITIONS",
    tenantId: tenantId,
    id: id,
    closeModal: closeTermsModal,
    submitAction: submitAction,
    applicationData: (data === null || data === void 0 ? void 0 : data.applicationData) || {}
  }) : null, showModal ? /*#__PURE__*/React__default.createElement(ActionModal$1, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    id: id,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: (_workflowDetails40 = workflowDetails) === null || _workflowDetails40 === void 0 ? void 0 : (_workflowDetails40$da = _workflowDetails40.data) === null || _workflowDetails40$da === void 0 ? void 0 : _workflowDetails40$da.timeline,
    applicationData: (data === null || data === void 0 ? void 0 : data.applicationData) || {}
  }) : null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast.key === "error" ? true : false,
    label: t(showToast.key === "success" ? `ES_OBPS_${showToast.action}_UPDATE_SUCCESS` : showToast.action),
    onClose: closeToast,
    style: {
      zIndex: "1000"
    }
  }));
};

const getPath$5 = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const getBPAEditDetails$1 = async (data, APIScrutinyDetails, mdmsData, nocdata, t) => {
  var _data$landInfo, _data$landInfo2, _data$landInfo3, _data$landInfo3$addre, _data$landInfo4, _data$landInfo4$addre, _data$landInfo4$addre2, _data$landInfo5, _data$landInfo5$addre, _data$landInfo6, _data$landInfo6$addre, _data$landInfo6$addre2, _APIScrutinyDetails$p, _APIScrutinyDetails$p2, _data$auditDetails, _data$additionalDetai, _APIScrutinyDetails$p3, _APIScrutinyDetails$p4, _data$additionalDetai2, _mdmsData$BPA, _APIScrutinyDetails$p5, _APIScrutinyDetails$p6, _APIScrutinyDetails$p7, _data$additionalDetai3, _data$landInfo7, _data$landInfo8, _data$landInfo9, _mdmsData$BPA2, _APIScrutinyDetails$p8, _APIScrutinyDetails$p9, _APIScrutinyDetails$p10, _data$landInfo10, _data$businessService, _data$businessService2, _data$additionalDetai4, _data$additionalDetai5;
  const getBlockIds = unit => {
    let blocks = {};
    unit && unit.map((ob, index) => {
      blocks[`Block_${index + 1}`] = ob.id;
    });
    return blocks;
  };
  const getBlocksforFlow = unit => {
    let arr = [];
    let subBlocks = [];
    let subOcc = {};
    unit && unit.map((un, index) => {
      var _un$usageCategory;
      arr = un === null || un === void 0 ? void 0 : (_un$usageCategory = un.usageCategory) === null || _un$usageCategory === void 0 ? void 0 : _un$usageCategory.split(",");
      subBlocks = [];
      arr && arr.map((ob, ind) => {
        subBlocks.push({
          code: ob,
          i18nKey: `BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`,
          name: t(`BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`)
        });
      });
      subOcc[`Block_${index + 1}`] = subBlocks;
    });
    return subOcc;
  };
  data.BlockIds = getBlockIds(data === null || data === void 0 ? void 0 : (_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : _data$landInfo.unit);
  data.address = data === null || data === void 0 ? void 0 : (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : _data$landInfo2.address;
  data.address.city = {
    code: data === null || data === void 0 ? void 0 : (_data$landInfo3 = data.landInfo) === null || _data$landInfo3 === void 0 ? void 0 : (_data$landInfo3$addre = _data$landInfo3.address) === null || _data$landInfo3$addre === void 0 ? void 0 : _data$landInfo3$addre.city,
    name: data === null || data === void 0 ? void 0 : (_data$landInfo4 = data.landInfo) === null || _data$landInfo4 === void 0 ? void 0 : (_data$landInfo4$addre = _data$landInfo4.address) === null || _data$landInfo4$addre === void 0 ? void 0 : (_data$landInfo4$addre2 = _data$landInfo4$addre.city) === null || _data$landInfo4$addre2 === void 0 ? void 0 : _data$landInfo4$addre2.split(".")[1]
  };
  data.address.locality = {
    ...(data === null || data === void 0 ? void 0 : (_data$landInfo5 = data.landInfo) === null || _data$landInfo5 === void 0 ? void 0 : (_data$landInfo5$addre = _data$landInfo5.address) === null || _data$landInfo5$addre === void 0 ? void 0 : _data$landInfo5$addre.locality),
    "i18nkey": data === null || data === void 0 ? void 0 : (_data$landInfo6 = data.landInfo) === null || _data$landInfo6 === void 0 ? void 0 : (_data$landInfo6$addre = _data$landInfo6.address) === null || _data$landInfo6$addre === void 0 ? void 0 : (_data$landInfo6$addre2 = _data$landInfo6$addre.locality) === null || _data$landInfo6$addre2 === void 0 ? void 0 : _data$landInfo6$addre2.name
  };
  data.data = {
    applicantName: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p === void 0 ? void 0 : (_APIScrutinyDetails$p2 = _APIScrutinyDetails$p.planInformation) === null || _APIScrutinyDetails$p2 === void 0 ? void 0 : _APIScrutinyDetails$p2.applicantName,
    applicationDate: data === null || data === void 0 ? void 0 : (_data$auditDetails = data.auditDetails) === null || _data$auditDetails === void 0 ? void 0 : _data$auditDetails.createdTime,
    applicationType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType,
    holdingNumber: data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.holdingNo,
    occupancyType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p3 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p3 === void 0 ? void 0 : (_APIScrutinyDetails$p4 = _APIScrutinyDetails$p3.planInformation) === null || _APIScrutinyDetails$p4 === void 0 ? void 0 : _APIScrutinyDetails$p4.occupancy,
    registrationDetails: data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.registrationDetails,
    riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p5 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p5 === void 0 ? void 0 : (_APIScrutinyDetails$p6 = _APIScrutinyDetails$p5.plot) === null || _APIScrutinyDetails$p6 === void 0 ? void 0 : _APIScrutinyDetails$p6.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p7 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p7 === void 0 ? void 0 : _APIScrutinyDetails$p7.blocks),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType),
    scrutinyNumber: {
      edcrNumber: data === null || data === void 0 ? void 0 : data.edcrNumber
    }
  };
  data["PrevStateDocuments"] = data === null || data === void 0 ? void 0 : data.documents;
  data.documents = {
    documents: []
  };
  let nocDocs = [];
  nocdata && nocdata.map((a, index) => {
    a.documents && a.documents.map((b, index) => {
      nocDocs.push(b);
    });
  });
  data["PrevStateNocDocuments"] = nocDocs;
  data.nocDocuments = {
    NocDetails: nocdata,
    nocDocuments: []
  };
  data === null || data === void 0 ? void 0 : data.landInfo.owners.map((owner, ind) => {
    owner.gender = {
      active: true,
      code: owner.gender,
      i18nKey: `COMMON_GENDER_${owner.gender}`
    };
  });
  data.owners = {
    owners: data === null || data === void 0 ? void 0 : (_data$landInfo7 = data.landInfo) === null || _data$landInfo7 === void 0 ? void 0 : _data$landInfo7.owners,
    ownershipCategory: {
      active: true,
      code: data === null || data === void 0 ? void 0 : (_data$landInfo8 = data.landInfo) === null || _data$landInfo8 === void 0 ? void 0 : _data$landInfo8.ownershipCategory,
      i18nKey: `COMMON_MASTERS_OWNERSHIPCATEGORY_${data === null || data === void 0 ? void 0 : (_data$landInfo9 = data.landInfo) === null || _data$landInfo9 === void 0 ? void 0 : _data$landInfo9.ownershipCategory.replaceAll(".", "_")}`
    }
  };
  data.riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p8 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p8 === void 0 ? void 0 : (_APIScrutinyDetails$p9 = _APIScrutinyDetails$p8.plot) === null || _APIScrutinyDetails$p9 === void 0 ? void 0 : _APIScrutinyDetails$p9.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p10 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p10 === void 0 ? void 0 : _APIScrutinyDetails$p10.blocks);
  data.subOccupancy = getBlocksforFlow(data === null || data === void 0 ? void 0 : (_data$landInfo10 = data.landInfo) === null || _data$landInfo10 === void 0 ? void 0 : _data$landInfo10.unit);
  data.uiFlow = {
    flow: data === null || data === void 0 ? void 0 : (_data$businessService = data.businessService) === null || _data$businessService === void 0 ? void 0 : (_data$businessService2 = _data$businessService.split(".")) === null || _data$businessService2 === void 0 ? void 0 : _data$businessService2[0],
    applicationType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.applicationType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai5 = data.additionalDetails) === null || _data$additionalDetai5 === void 0 ? void 0 : _data$additionalDetai5.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  sessionStorage.setItem("BPA_IS_ALREADY_WENT_OFF_DETAILS", JSON.stringify(true));
  return data;
};
const BPASendToArchitect = ({
  parentRoute
}) => {
  var _bpaData$, _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  sessionStorage.setItem("BPA_SUBMIT_APP", JSON.stringify("BPA_SUBMIT_APP"));
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    t
  } = useTranslation();
  const {
    applicationNo: applicationNo,
    tenantId
  } = useParams();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  let config = [];
  let application = {};
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT_EDITFLOW", {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(Digit.ULBService.getStateId(), "BPA", ["RiskTypeComputation"]);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading
  } = Digit.Hooks.obps.useBPASearch(tenantId, {
    applicationNo: applicationNo
  });
  let scrutinyNumber = {
    edcrNumber: bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$ = bpaData[0]) === null || _bpaData$ === void 0 ? void 0 : _bpaData$.edcrNumber
  };
  const {
    data: data1,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(Digit.ULBService.getStateId(), scrutinyNumber, {
    enabled: scrutinyNumber["edcrNumber"] ? true : false
  });
  let sourceRefId = applicationNo;
  const {
    data: nocdata,
    isLoading: isNocLoading,
    refetch: nocRefetch
  } = Digit.Hooks.obps.useNocDetails(tenantId, {
    sourceRefId: sourceRefId
  });
  const editApplication = window.location.href.includes("editApplication");
  useEffect(async () => {
    let isAlready = sessionStorage.getItem("BPA_IS_ALREADY_WENT_OFF_DETAILS");
    isAlready = isAlready ? JSON.parse(isAlready) : true;
    if (!isAlready && !isNocLoading && !isBpaSearchLoading && !isLoading) {
      application = bpaData ? bpaData[0] : {};
      if (data1 && nocdata) {
        application = bpaData[0];
        if (editApplication) {
          application.isEditApplication = true;
        }
        sessionStorage.setItem("bpaInitialObject", JSON.stringify({
          ...application
        }));
        let bpaEditDetails = await getBPAEditDetails$1(application, data1, mdmsData, nocdata, t);
        setParams({
          ...params,
          ...bpaEditDetails
        });
      }
    }
  }, [bpaData, data1, mdmsData, nocdata]);
  const goNext = skipStep => {
    var _pathname$split;
    const currentPath = pathname === null || pathname === void 0 ? void 0 : (_pathname$split = pathname.split("/")) === null || _pathname$split === void 0 ? void 0 : _pathname$split.pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$5(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$5(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$5(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.BuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.BuildingPermitConfig : newConfig$2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "check";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('BPACheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('BPAAcknowledgement');
  if (isNocLoading || isBpaSearchLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$5(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$5(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$5(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, data1 && /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$5(match.path, match.params)}/${config.indexRoute}`
  })));
};

const getPath$6 = (path, params) => {
  params && Object.keys(params).map(key => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};
const getBPAEditDetails$2 = async (data, APIScrutinyDetails, mdmsData, nocdata, t, OCData) => {
  var _data$landInfo, _data$additionalDetai, _data$landInfo2, _data$additionalDetai2, _APIScrutinyDetails$p, _APIScrutinyDetails$p2, _data$auditDetails, _data$additionalDetai3, _APIScrutinyDetails$p3, _APIScrutinyDetails$p4, _data$additionalDetai4, _mdmsData$BPA, _APIScrutinyDetails$p5, _APIScrutinyDetails$p6, _APIScrutinyDetails$p7, _data$additionalDetai5, _mdmsData$BPA2, _APIScrutinyDetails$p8, _APIScrutinyDetails$p9, _APIScrutinyDetails$p10, _data$landInfo3, _data$additionalDetai6, _data$additionalDetai7;
  const getBlocksforFlow = unit => {
    let arr = [];
    let subBlocks = [];
    let subOcc = {};
    unit && unit.map((un, index) => {
      var _un$usageCategory;
      arr = un === null || un === void 0 ? void 0 : (_un$usageCategory = un.usageCategory) === null || _un$usageCategory === void 0 ? void 0 : _un$usageCategory.split(",");
      subBlocks = [];
      arr && arr.map((ob, ind) => {
        subBlocks.push({
          code: ob,
          i18nKey: `BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`,
          name: t(`BPA_SUBOCCUPANCYTYPE_${ob.replaceAll(".", "_")}`)
        });
      });
      subOcc[`Block_${index + 1}`] = subBlocks;
    });
    return subOcc;
  };
  data.address = data === null || data === void 0 ? void 0 : (_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : _data$landInfo.address;
  data.additionalDetails = {
    ...(data === null || data === void 0 ? void 0 : data.additionalDetails),
    applicationType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType,
    holdingNo: data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : _data$additionalDetai.holdingNo,
    landId: data === null || data === void 0 ? void 0 : (_data$landInfo2 = data.landInfo) === null || _data$landInfo2 === void 0 ? void 0 : _data$landInfo2.id,
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  data.data = {
    applicantName: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p === void 0 ? void 0 : (_APIScrutinyDetails$p2 = _APIScrutinyDetails$p.planInformation) === null || _APIScrutinyDetails$p2 === void 0 ? void 0 : _APIScrutinyDetails$p2.applicantName,
    applicationDate: data === null || data === void 0 ? void 0 : (_data$auditDetails = data.auditDetails) === null || _data$auditDetails === void 0 ? void 0 : _data$auditDetails.createdTime,
    applicationType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType,
    holdingNumber: data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.holdingNo,
    bpaData: OCData,
    occupancyType: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p3 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p3 === void 0 ? void 0 : (_APIScrutinyDetails$p4 = _APIScrutinyDetails$p3.planInformation) === null || _APIScrutinyDetails$p4 === void 0 ? void 0 : _APIScrutinyDetails$p4.occupancy,
    registrationDetails: data === null || data === void 0 ? void 0 : (_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.registrationDetails,
    riskType: Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA = mdmsData.BPA) === null || _mdmsData$BPA === void 0 ? void 0 : _mdmsData$BPA.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p5 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p5 === void 0 ? void 0 : (_APIScrutinyDetails$p6 = _APIScrutinyDetails$p5.plot) === null || _APIScrutinyDetails$p6 === void 0 ? void 0 : _APIScrutinyDetails$p6.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p7 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p7 === void 0 ? void 0 : _APIScrutinyDetails$p7.blocks),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai5 = data.additionalDetails) === null || _data$additionalDetai5 === void 0 ? void 0 : _data$additionalDetai5.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType),
    edcrDetails: APIScrutinyDetails,
    scrutinyNumber: {
      edcrNumber: APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.edcrNumber
    }
  };
  data["PrevStateDocuments"] = data === null || data === void 0 ? void 0 : data.documents;
  data.documents = {
    documents: []
  };
  let nocDocs = [];
  nocdata && nocdata.map((a, index) => {
    a.documents && a.documents.map((b, index) => {
      nocDocs.push(b);
    });
  });
  data["PrevStateNocDocuments"] = nocDocs;
  data.nocDocuments = {
    NocDetails: nocdata,
    nocDocuments: []
  };
  data.riskType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p8 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p8 === void 0 ? void 0 : (_APIScrutinyDetails$p9 = _APIScrutinyDetails$p8.plot) === null || _APIScrutinyDetails$p9 === void 0 ? void 0 : _APIScrutinyDetails$p9.area, APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : (_APIScrutinyDetails$p10 = APIScrutinyDetails.planDetail) === null || _APIScrutinyDetails$p10 === void 0 ? void 0 : _APIScrutinyDetails$p10.blocks);
  data.subOccupancy = getBlocksforFlow(data === null || data === void 0 ? void 0 : (_data$landInfo3 = data.landInfo) === null || _data$landInfo3 === void 0 ? void 0 : _data$landInfo3.unit);
  data.uiFlow = {
    flow: "OCBPA",
    applicationType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai6 = data.additionalDetails) === null || _data$additionalDetai6 === void 0 ? void 0 : _data$additionalDetai6.applicationType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.appliactionType),
    serviceType: (data === null || data === void 0 ? void 0 : (_data$additionalDetai7 = data.additionalDetails) === null || _data$additionalDetai7 === void 0 ? void 0 : _data$additionalDetai7.serviceType) || (APIScrutinyDetails === null || APIScrutinyDetails === void 0 ? void 0 : APIScrutinyDetails.applicationSubType)
  };
  sessionStorage.setItem("BPA_IS_ALREADY_WENT_OFF_DETAILS", JSON.stringify(true));
  return data;
};
const OCSendToArchitect = ({
  parentRoute
}) => {
  var _bpaData$, _bpaData$2, _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  sessionStorage.setItem("BPA_SUBMIT_APP", JSON.stringify("BPA_SUBMIT_APP"));
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    t
  } = useTranslation();
  const {
    applicationNo: applicationNo,
    tenantId
  } = useParams();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  let config = [];
  let application = {};
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("OC_BUILDING_PERMIT_EDITFLOW", {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(Digit.ULBService.getStateId(), "BPA", ["RiskTypeComputation"]);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading
  } = Digit.Hooks.obps.useBPASearch(tenantId, {
    applicationNo: applicationNo
  });
  let scrutinyNumber = {
    edcrNumber: bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$ = bpaData[0]) === null || _bpaData$ === void 0 ? void 0 : _bpaData$.edcrNumber
  };
  const {
    data: data1,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(Digit.ULBService.getStateId(), scrutinyNumber, {
    enabled: bpaData !== null && bpaData !== void 0 && (_bpaData$2 = bpaData[0]) !== null && _bpaData$2 !== void 0 && _bpaData$2.edcrNumber ? true : false
  });
  let approvalNo = data1 === null || data1 === void 0 ? void 0 : data1.permitNumber;
  const {
    data: OCData,
    isLoading: isSearchLoading,
    refetch: refetchBPASearch
  } = Digit.Hooks.obps.useOCEdcrSearch(tenantId, {
    approvalNo: approvalNo
  }, {
    enabled: approvalNo && data1 !== null && data1 !== void 0 && data1.permitNumber ? true : false
  }, scrutinyNumber);
  let sourceRefId = applicationNo;
  const {
    data: nocdata,
    isLoading: isNocLoading,
    refetch: nocRefetch
  } = Digit.Hooks.obps.useNocDetails(tenantId, {
    sourceRefId: sourceRefId
  });
  const editApplication = window.location.href.includes("editApplication");
  const tlTrade = JSON.parse(sessionStorage.getItem("tl-trade")) || {};
  useEffect(async () => {
    let isAlready = sessionStorage.getItem("BPA_IS_ALREADY_WENT_OFF_DETAILS");
    isAlready = isAlready ? JSON.parse(isAlready) : true;
    if (!isAlready && !isNocLoading && !isBpaSearchLoading && !isLoading) {
      application = bpaData ? bpaData[0] : {};
      if (data1 && OCData) {
        application = bpaData[0];
        if (editApplication) {
          application.isEditApplication = true;
        }
        sessionStorage.setItem("bpaInitialObject", JSON.stringify({
          ...application
        }));
        let bpaEditDetails = await getBPAEditDetails$2(application, data1, mdmsData, nocdata, t, OCData);
        setParams({
          ...params,
          ...bpaEditDetails
        });
      }
    }
  }, [bpaData, data1, mdmsData, nocdata, OCData]);
  const goNext = skipStep => {
    var _pathname$split;
    const currentPath = pathname === null || pathname === void 0 ? void 0 : (_pathname$split = pathname.split("/")) === null || _pathname$split === void 0 ? void 0 : _pathname$split.pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath$6(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath$6(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath$6(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.OCBuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.OCBuildingPermitConfig : newConfig$3;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "check";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('OCBPACheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('OCBPAAcknowledgement');
  if (isNocLoading || isBpaSearchLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath$6(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$6(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath$6(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, data1 && OCData && /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath$6(match.path, match.params)}/${config.indexRoute}`
  })));
};

const BPASendBackToCitizen = ({
  parentRoute
}) => {
  var _bpaData$, _bpaData$2, _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const stateCode = Digit.ULBService.getStateId();
  const {
    applicationNo: applicationNo,
    tenantId
  } = useParams();
  sessionStorage.setItem("BPA_SUBMIT_APP", JSON.stringify("BPA_SUBMIT_APP"));
  let config = [],
    application = {};
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT_EDITFLOW", {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["RiskTypeComputation"]);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading
  } = Digit.Hooks.obps.useBPASearch(tenantId, {
    applicationNo: applicationNo
  });
  let scrutinyNumber = {
      edcrNumber: bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$ = bpaData[0]) === null || _bpaData$ === void 0 ? void 0 : _bpaData$.edcrNumber
    },
    sourceRefId = applicationNo;
  const {
    data: edcrDetails,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(stateCode, scrutinyNumber, {
    enabled: bpaData !== null && bpaData !== void 0 && (_bpaData$2 = bpaData[0]) !== null && _bpaData$2 !== void 0 && _bpaData$2.edcrNumber ? true : false
  });
  const {
    data: nocdata,
    isLoading: isNocLoading,
    refetch: nocRefetch
  } = Digit.Hooks.obps.useNocDetails(tenantId, {
    sourceRefId: sourceRefId
  });
  const editApplication = window.location.href.includes("editApplication");
  useEffect(async () => {
    let isAlready = sessionStorage.getItem("BPA_IS_ALREADY_WENT_OFF_DETAILS");
    isAlready = isAlready ? JSON.parse(isAlready) : true;
    if (!isAlready && !isNocLoading && !isBpaSearchLoading && !isLoading) {
      application = bpaData ? bpaData[0] : {};
      if (bpaData && application && edcrDetails && mdmsData && nocdata) {
        application = bpaData[0];
        if (editApplication) {
          application.isEditApplication = true;
        }
        sessionStorage.setItem("bpaInitialObject", JSON.stringify({
          ...application
        }));
        let bpaEditDetails = await getBPAEditDetails(application, edcrDetails, mdmsData, nocdata, t);
        setParams({
          ...params,
          ...bpaEditDetails
        });
      }
    }
  }, [bpaData, edcrDetails, mdmsData, nocdata]);
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {
    history.push(`${getPath(match.path, match.params)}/acknowledgement`);
  };
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.BuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.BuildingPermitConfig : newConfig$2;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "check";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('OCBPASendBackCheckPage');
  const OBPSAcknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('OCSendBackAcknowledgement');
  if (isNocLoading || isBpaSearchLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(OBPSAcknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath(match.path, match.params)}/${config.indexRoute}`
  })));
};

const OCSendBackToCitizen = ({
  parentRoute
}) => {
  var _bpaData$, _bpaData$2, _newConfig, _newConfig2, _Digit, _Digit$ComponentRegis, _Digit2, _Digit2$ComponentRegi;
  sessionStorage.setItem("BPA_SUBMIT_APP", JSON.stringify("BPA_SUBMIT_APP"));
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const stateCode = Digit.ULBService.getStateId();
  const {
    applicationNo: applicationNo,
    tenantId
  } = useParams();
  let config = [],
    application = {};
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("BUILDING_PERMIT_EDITFLOW", {});
  const stateId = Digit.ULBService.getStateId();
  let {
    data: newConfig
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["RiskTypeComputation", "homePageUrlLinks"]);
  const {
    data: bpaData,
    isLoading: isBpaSearchLoading
  } = Digit.Hooks.obps.useBPASearch(tenantId, {
    applicationNo: applicationNo
  });
  let scrutinyNumber = {
      edcrNumber: bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$ = bpaData[0]) === null || _bpaData$ === void 0 ? void 0 : _bpaData$.edcrNumber
    },
    sourceRefId = applicationNo;
  const {
    data: edcrDetails,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(stateCode, scrutinyNumber, {
    enabled: bpaData !== null && bpaData !== void 0 && (_bpaData$2 = bpaData[0]) !== null && _bpaData$2 !== void 0 && _bpaData$2.edcrNumber ? true : false
  });
  const {
    data: nocdata,
    isLoading: isNocLoading,
    refetch: nocRefetch
  } = Digit.Hooks.obps.useNocDetails(tenantId, {
    sourceRefId: sourceRefId
  });
  const editApplication = window.location.href.includes("editApplication");
  useEffect(async () => {
    let isAlready = sessionStorage.getItem("BPA_IS_ALREADY_WENT_OFF_DETAILS");
    isAlready = isAlready ? JSON.parse(isAlready) : true;
    if (!isAlready && !isNocLoading && !isBpaSearchLoading && !isLoading && !isMdmsLoading) {
      application = bpaData ? bpaData[0] : {};
      if (bpaData && application && edcrDetails && mdmsData && nocdata) {
        application = bpaData[0];
        if (editApplication) {
          application.isEditApplication = true;
        }
        sessionStorage.setItem("bpaInitialObject", JSON.stringify({
          ...application
        }));
        let bpaEditDetails = await getBPAEditDetails(application, edcrDetails, mdmsData, nocdata, t);
        setParams({
          ...params,
          ...bpaEditDetails
        });
      }
    }
  }, [bpaData, edcrDetails, mdmsData, nocdata]);
  const goNext = skipStep => {
    const currentPath = pathname.split("/").pop();
    const {
      nextStep
    } = config.find(routeObj => routeObj.route === currentPath);
    let redirectWithHistory = history.push;
    if (nextStep === null) {
      return redirectWithHistory(`${getPath(match.path, match.params)}/check`);
    }
    redirectWithHistory(`${getPath(match.path, match.params)}/${nextStep}`);
  };
  const onSuccess = () => {
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  const createApplication = async () => {};
  const handleSelect = (key, data, skipStep, isFromCreateApi) => {
    if (isFromCreateApi) setParams(data);else setParams({
      ...params,
      ...{
        [key]: {
          ...params[key],
          ...data
        }
      }
    });
    goNext();
  };
  const handleSkip = () => {};
  newConfig = (_newConfig = newConfig) !== null && _newConfig !== void 0 && _newConfig.OCBuildingPermitConfig ? (_newConfig2 = newConfig) === null || _newConfig2 === void 0 ? void 0 : _newConfig2.OCBuildingPermitConfig : newConfig$3;
  newConfig.forEach(obj => {
    config = config.concat(obj.body.filter(a => !a.hideInCitizen));
  });
  config.indexRoute = "check";
  useEffect(() => {
    if (sessionStorage.getItem("isPermitApplication") && sessionStorage.getItem("isPermitApplication") == "true") {
      clearParams();
      sessionStorage.setItem("isPermitApplication", false);
    }
  }, []);
  const CheckPage = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$ComponentRegis = _Digit.ComponentRegistryService) === null || _Digit$ComponentRegis === void 0 ? void 0 : _Digit$ComponentRegis.getComponent('OCBPASendBackCheckPage');
  const Acknowledgement = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$ComponentRegi = _Digit2.ComponentRegistryService) === null || _Digit2$ComponentRegi === void 0 ? void 0 : _Digit2$ComponentRegi.getComponent('OCSendBackAcknowledgement');
  if (isNocLoading || isBpaSearchLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Switch, null, config.map((routeObj, index) => {
    const {
      component,
      texts,
      inputs,
      key
    } = routeObj;
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    return /*#__PURE__*/React__default.createElement(Route, {
      path: `${getPath(match.path, match.params)}/${routeObj.route}`,
      key: index
    }, /*#__PURE__*/React__default.createElement(Component, {
      config: {
        texts,
        inputs,
        key
      },
      onSelect: handleSelect,
      onSkip: handleSkip,
      t: t,
      formData: params
    }));
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath(match.path, match.params)}/check`
  }, /*#__PURE__*/React__default.createElement(CheckPage, {
    onSubmit: createApplication,
    value: params
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${getPath(match.path, match.params)}/acknowledgement`
  }, /*#__PURE__*/React__default.createElement(Acknowledgement, {
    data: params,
    onSuccess: onSuccess
  })), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${getPath(match.path, match.params)}/${config.indexRoute}`
  })));
};

const FilterFormFieldsComponent$2 = ({
  controlFilterForm
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data: applicationTypesOfBPA,
    isLoading: loadingApplicationTypesOfBPA
  } = Digit.Hooks.obps.SearchMdmsTypes.useApplicationTypes(tenantId);
  const availableOptions = [{
    code: "Accepted",
    name: `${t("EDCR_ACCEPTED")}`
  }, {
    code: "Not Accepted",
    name: `${t("EDCR_NOT_ACCEPTED")}`
  }];
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "status",
    control: controlFilterForm,
    render: props => {
      return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontWeight: "400",
          fontSize: "16px"
        }
      }, t("BPA_COMMON_TABLE_COL_APP_STATUS_LABEL")), /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          props.onChange(e.code);
          Digit.SessionStorage.set("EDCR_BACK", "");
        },
        selectedOption: availableOptions.filter(option => option.code === props.value)[0],
        optionsKey: "name",
        name: "status",
        options: availableOptions
      }));
    }
  })), /*#__PURE__*/React__default.createElement(FilterFormField, null, /*#__PURE__*/React__default.createElement(Controller, {
    name: "appliactionType",
    control: controlFilterForm,
    render: props => {
      return loadingApplicationTypesOfBPA ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
        className: "filter-label sub-filter-label",
        style: {
          fontWeight: "400",
          fontSize: "16px"
        }
      }, t("BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL")), /*#__PURE__*/React__default.createElement(Dropdown, {
        t: t,
        option: applicationTypesOfBPA,
        selected: applicationTypesOfBPA.filter(option => option.code === props.value)[0],
        optionKey: "i18nKey",
        select: e => {
          props.onChange(e.code);
          Digit.SessionStorage.set("EDCR_BACK", "");
        }
      }));
    }
  })));
};

const SearchFormFieldsComponents$2 = ({
  registerRef,
  searchFormState,
  searchFieldComponents
}) => {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  if (!isMobile) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "search-container",
      style: {
        width: "auto",
        marginLeft: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "search-complaint-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "complaint-input-container",
      style: {
        textAlign: "start"
      }
    }, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
      name: "applicationNumber",
      inputRef: registerRef({})
    })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_EDCR_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
      name: "edcrNumber",
      inputRef: registerRef({})
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "search-action-wrapper",
      style: {
        width: "100%"
      }
    }, searchFieldComponents)))));
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APPLICATION_NUMBER_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
    name: "applicationNumber",
    inputRef: registerRef({})
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_EDCR_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
    name: "edcrNumber",
    inputRef: registerRef({})
  })));
};

const useInboxMobileCardsData$2 = ({
  table
}) => {
  const {
    t
  } = useTranslation();
  const dataForMobileInboxCards = table === null || table === void 0 ? void 0 : table.map(({
    applicationId,
    edcrNumber,
    date,
    planReportUrl,
    dxfFileurl,
    locality,
    status,
    owner
  }) => ({
    [t("EDCR_COMMON_TABLE_APPL_NO")]: applicationId,
    [t("CS_APPLICATION_DETAILS_APPLICATION_DATE")]: date ? format(new Date(date), "dd/MM/yyyy") : "NA",
    [t("EDCR_COMMON_TABLE_CITY_LABEL")]: t(locality),
    [t("EDCR_COMMON_TABLE_APPL_NAME")]: owner,
    [t("EDCR_COMMON_TABLE_SCRUTINY_NO")]: edcrNumber,
    [t("EDCR_COMMON_TABLE_COL_STATUS")]: status === "Accepted" ? /*#__PURE__*/React__default.createElement("span", {
      className: "sla-cell-success ",
      style: {
        background: "none",
        padding: "0px"
      }
    }, status) : /*#__PURE__*/React__default.createElement("span", {
      className: "sla-cell-error",
      style: {
        background: "none",
        padding: "0px"
      }
    }, status),
    [t("BPA_UPLOADED_PLAN_DXF")]: /*#__PURE__*/React__default.createElement("a", {
      href: `${dxfFileurl}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "link"
    }, t("BPA_DOWNLOAD"))),
    [t("EDCR_SCUTINY_REPORT")]: /*#__PURE__*/React__default.createElement("a", {
      href: `${planReportUrl}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "link"
    }, t("BPA_DOWNLOAD")))
  }));
  const MobileSortFormValues = () => {
    const sortOrderOptions = [{
      code: "DESC",
      i18nKey: "ES_INBOX_DATE_LATEST_FIRST"
    }, {
      code: "ASC",
      i18nKey: "ES_INBOX_DATE_LATEST_LAST"
    }];
    const {
      control: controlSortForm
    } = useFormContext();
    return /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement(Controller, {
      name: "sortOrder",
      control: controlSortForm,
      render: ({
        onChange,
        value
      }) => /*#__PURE__*/React__default.createElement(RadioButtons, {
        onSelect: e => {
          onChange(e.code);
        },
        selectedOption: sortOrderOptions.filter(option => option.code === value)[0],
        optionsKey: "i18nKey",
        name: "sortOrder",
        options: sortOrderOptions
      })
    }));
  };
  return {
    data: dataForMobileInboxCards,
    isTwoDynamicPrefix: true,
    getRedirectionLink: () => {},
    handleClickEnabled: false,
    serviceRequestIdKey: "applicationNo",
    MobileSortFormValues
  };
};

const Download = ({
  dowloadOptions
}) => {
  const [showOptions, setShowOptions] = useState(false);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(MultiLink, {
    className: "multilinkWrapper",
    onHeadClick: () => setShowOptions(!showOptions),
    displayOptions: showOptions,
    showOptions: setShowOptions,
    options: dowloadOptions,
    style: {
      right: "0",
      position: "unset",
      top: "0px",
      margin: "0px"
    },
    optionsStyle: {
      right: "10px",
      top: "unset",
      margin: "0px",
      position: "absolute"
    }
  }));
};
const useInboxTableConfig$2 = ({
  onPageSizeChange,
  formState,
  totalCount,
  table,
  dispatch,
  onSortingByData
}) => {
  var _formState$tableForm, _formState$tableForm2, _formState$tableForm7, _formState$searchForm;
  const GetCell = value => /*#__PURE__*/React__default.createElement("span", {
    className: "cell-text styled-cell"
  }, value);
  const GetStatusCell = value => value === "Accepted" ? /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-success ",
    style: {
      background: "none",
      padding: "unset"
    }
  }, value) : /*#__PURE__*/React__default.createElement("span", {
    className: "sla-cell-error",
    style: {
      background: "none",
      padding: "unset"
    }
  }, value);
  const {
    t
  } = useTranslation();
  const tableColumnConfig = useMemo(() => {
    return [{
      Header: t("EDCR_COMMON_TABLE_APPL_NO"),
      disableSortBy: true,
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
          className: ""
        }, row.original["applicationId"]));
      }
    }, {
      Header: t("CS_APPLICATION_DETAILS_APPLICATION_DATE"),
      accessor: "createdDate",
      Cell: ({
        row
      }) => {
        var _row$original, _row$original2;
        return (_row$original = row.original) !== null && _row$original !== void 0 && _row$original["date"] ? GetCell(format(new Date((_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2["date"]), "dd/MM/yyyy")) : "";
      }
    }, {
      Header: t("EDCR_COMMON_TABLE_CITY_LABEL"),
      accessor: row => t(row === null || row === void 0 ? void 0 : row.locality),
      disableSortBy: true
    }, {
      Header: t("EDCR_COMMON_TABLE_APPL_NAME"),
      accessor: row => row === null || row === void 0 ? void 0 : row.owner,
      disableSortBy: true
    }, {
      Header: t("EDCR_COMMON_TABLE_SCRUTINY_NO"),
      disableSortBy: true,
      Cell: ({
        row
      }) => {
        var _row$original3;
        return /*#__PURE__*/React__default.createElement("div", null, ((_row$original3 = row.original) === null || _row$original3 === void 0 ? void 0 : _row$original3.edcrNumber) !== "null" ? /*#__PURE__*/React__default.createElement("span", {
          className: ""
        }, row.original["edcrNumber"]) : "NA");
      }
    }, {
      Header: t("EDCR_COMMON_TABLE_COL_STATUS"),
      accessor: row => GetStatusCell(row === null || row === void 0 ? void 0 : row.status),
      disableSortBy: true
    }, {
      Header: t("PT_COMMON_TABLE_COL_ACTION_LABEL"),
      Cell: ({
        row
      }) => {
        return /*#__PURE__*/React__default.createElement(Download, {
          dowloadOptions: [{
            label: t("BPA_UPLOADED_PLAN_DXF"),
            onClick: () => window.open(`${row.original["dxfFileurl"]}`)
          }, {
            label: t("EDCR_SCUTINY_REPORT"),
            onClick: () => window.open(`${row.original["planReportUrl"]}`)
          }]
        });
      },
      disableSortBy: true
    }];
  });
  return {
    getCellProps: cellInfo => {
      return {
        style: {
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    className: "table edcr-citizen-inbox",
    disableSort: false,
    autoSort: false,
    manualPagination: true,
    initSortId: "createdDate",
    onPageSizeChange: onPageSizeChange,
    currentPage: ((_formState$tableForm = formState.tableForm) === null || _formState$tableForm === void 0 ? void 0 : _formState$tableForm.offset) / ((_formState$tableForm2 = formState.tableForm) === null || _formState$tableForm2 === void 0 ? void 0 : _formState$tableForm2.limit),
    onNextPage: () => {
      var _formState$tableForm3, _formState$tableForm4;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm3 = formState.tableForm) === null || _formState$tableForm3 === void 0 ? void 0 : _formState$tableForm3.offset) + parseInt((_formState$tableForm4 = formState.tableForm) === null || _formState$tableForm4 === void 0 ? void 0 : _formState$tableForm4.limit)
        }
      });
    },
    onPrevPage: () => {
      var _formState$tableForm5, _formState$tableForm6;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: parseInt((_formState$tableForm5 = formState.tableForm) === null || _formState$tableForm5 === void 0 ? void 0 : _formState$tableForm5.offset) - parseInt((_formState$tableForm6 = formState.tableForm) === null || _formState$tableForm6 === void 0 ? void 0 : _formState$tableForm6.limit)
        }
      });
    },
    pageSizeLimit: (_formState$tableForm7 = formState.tableForm) === null || _formState$tableForm7 === void 0 ? void 0 : _formState$tableForm7.limit,
    onSort: onSortingByData,
    totalRecords: totalCount,
    onSearch: formState === null || formState === void 0 ? void 0 : (_formState$searchForm = formState.searchForm) === null || _formState$searchForm === void 0 ? void 0 : _formState$searchForm.message,
    onLastPage: () => {
      var _formState$tableForm8;
      return dispatch({
        action: "mutateTableForm",
        data: {
          ...formState.tableForm,
          offset: Math.ceil(totalCount / 10) * 10 - parseInt((_formState$tableForm8 = formState.tableForm) === null || _formState$tableForm8 === void 0 ? void 0 : _formState$tableForm8.limit)
        }
      });
    },
    onFirstPage: () => dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        offset: 0
      }
    }),
    data: table,
    columns: tableColumnConfig
  };
};

const Inbox$2 = ({
  parentRoute
}) => {
  window.scroll(0, 0);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const searchFormDefaultValues = {};
  const filterFormDefaultValues = {
    appliactionType: "",
    status: ""
  };
  const tableOrderFormDefaultValues = {
    sortBy: "createdDate",
    limit: Digit.Utils.browser.isMobile() ? 50 : 10,
    offset: 0,
    sortOrder: "DESC"
  };
  function formReducer(state, payload) {
    switch (payload.action) {
      case "mutateSearchForm":
        Digit.SessionStorage.set("EDCR.INBOX", {
          ...state,
          searchForm: payload.data
        });
        return {
          ...state,
          searchForm: payload.data
        };
      case "mutateFilterForm":
        Digit.SessionStorage.set("EDCR.INBOX", {
          ...state,
          filterForm: payload.data
        });
        return {
          ...state,
          filterForm: payload.data
        };
      case "mutateTableForm":
        Digit.SessionStorage.set("EDCR.INBOX", {
          ...state,
          tableForm: payload.data
        });
        return {
          ...state,
          tableForm: payload.data
        };
    }
  }
  const InboxObjectInSessionStorage = Digit.SessionStorage.get("EDCR.INBOX");
  const onSearchFormReset = setSearchFormValue => {
    setSearchFormValue("edcrNumber", null);
    setSearchFormValue("applicationNumber", null);
    dispatch({
      action: "mutateSearchForm",
      data: searchFormDefaultValues
    });
  };
  const onFilterFormReset = setFilterFormValue => {
    setFilterFormValue("status", "");
    setFilterFormValue("appliactionType", "");
    dispatch({
      action: "mutateFilterForm",
      data: filterFormDefaultValues
    });
  };
  const onSortFormReset = setSortFormValue => {
    setSortFormValue("sortOrder", "DESC");
    dispatch({
      action: "mutateTableForm",
      data: tableOrderFormDefaultValues
    });
  };
  const formInitValue = useMemo(() => {
    const inboxFromhomePage = Digit.SessionStorage.get("EDCR_BACK");
    if (inboxFromhomePage === "IS_EDCR_BACK") {
      return {
        filterForm: filterFormDefaultValues,
        searchForm: searchFormDefaultValues,
        tableForm: tableOrderFormDefaultValues
      };
    }
    return InboxObjectInSessionStorage || {
      filterForm: filterFormDefaultValues,
      searchForm: searchFormDefaultValues,
      tableForm: tableOrderFormDefaultValues
    };
  }, [Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.filterForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.searchForm) || {}), Object.values((InboxObjectInSessionStorage === null || InboxObjectInSessionStorage === void 0 ? void 0 : InboxObjectInSessionStorage.tableForm) || {})]);
  const [formState, dispatch] = useReducer(formReducer, formInitValue);
  const onPageSizeChange = e => {
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        limit: e.target.value
      }
    });
  };
  const onSortingByData = e => {
    if (e.length > 0) {
      const [{
        id,
        desc
      }] = e;
      const sortOrder = desc ? "DESC" : "ASC";
      const sortBy = id;
      if (!(formState.tableForm.sortBy === sortBy && formState.tableForm.sortOrder === sortOrder)) {
        dispatch({
          action: "mutateTableForm",
          data: {
            ...formState.tableForm,
            sortBy: id,
            sortOrder: desc ? "DESC" : "ASC"
          }
        });
      }
    }
  };
  const onMobileSortOrderData = data => {
    const {
      sortOrder
    } = data;
    dispatch({
      action: "mutateTableForm",
      data: {
        ...formState.tableForm,
        sortOrder
      }
    });
  };
  const {
    isLoading: isInboxLoading,
    data: {
      table,
      totalCount
    } = {}
  } = Digit.Hooks.obps.useEDCRInbox({
    tenantId,
    filters: {
      ...formState
    }
  });
  const PropsForInboxLinks = {
    logoIcon: /*#__PURE__*/React__default.createElement(CaseIcon, null),
    headerText: "ACTION_TEST_EDCR_SCRUTINY",
    links: [{
      link: `/digit-ui/citizen/obps/edcrscrutiny/apply`,
      text: t("BPA_PLAN_SCRUTINY_FOR_NEW_CONSTRUCTION_LABEL")
    }, {
      link: `/digit-ui/citizen/obps/edcrscrutiny/oc-apply`,
      text: t("BPA_OC_PLAN_SCRUTINY_FOR_NEW_CONSTRUCTION_LABEL")
    }]
  };
  const SearchFormFields = useCallback(({
    registerRef,
    searchFormState,
    searchFieldComponents
  }) => /*#__PURE__*/React__default.createElement(SearchFormFieldsComponents$2, {
    registerRef,
    searchFormState,
    searchFieldComponents
  }), []);
  const FilterFormFields = useCallback(({
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    getFilterFormValue
  }) => /*#__PURE__*/React__default.createElement(FilterFormFieldsComponent$2, {
    isInboxLoading,
    registerRef,
    controlFilterForm,
    setFilterFormValue,
    filterFormState: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    getFilterFormValue
  }), [isInboxLoading]);
  const onSearchFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateSearchForm",
      data
    });
  };
  const onFilterFormSubmit = data => {
    data.hasOwnProperty("") && (data === null || data === void 0 ? true : delete data[""]);
    dispatch({
      action: "mutateTableForm",
      data: {
        ...tableOrderFormDefaultValues
      }
    });
    dispatch({
      action: "mutateFilterForm",
      data
    });
  };
  const propsForSearchForm = {
    SearchFormFields,
    onSearchFormSubmit,
    searchFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.searchForm,
    resetSearchFormDefaultValues: searchFormDefaultValues,
    onSearchFormReset
  };
  const propsForFilterForm = {
    FilterFormFields,
    onFilterFormSubmit,
    filterFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.filterForm,
    resetFilterFormDefaultValues: filterFormDefaultValues,
    onFilterFormReset
  };
  const propsForInboxTable = useInboxTableConfig$2({
    ...{
      parentRoute,
      onPageSizeChange,
      formState,
      totalCount,
      table,
      dispatch,
      onSortingByData
    }
  });
  const propsForInboxMobileCards = useInboxMobileCardsData$2({
    table
  });
  const propsForMobileSortForm = {
    onMobileSortOrderData,
    sortFormDefaultValues: formState === null || formState === void 0 ? void 0 : formState.tableForm,
    onSortFormReset
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Header, null, t("ES_COMMON_INBOX"), totalCount ? /*#__PURE__*/React__default.createElement("p", {
    className: "inbox-count"
  }, totalCount) : null), /*#__PURE__*/React__default.createElement(InboxComposer, _extends({
    isInboxLoading,
    PropsForInboxLinks
  }, propsForSearchForm, propsForFilterForm, propsForMobileSortForm, {
    propsForInboxTable,
    propsForInboxMobileCards,
    formState
  })));
};

const LicenseType = ({
  t,
  config,
  onSelect,
  userType,
  formData
}) => {
  var _formData, _formData$LicneseType, _formData2, _formData2$formData, _formData2$formData$L, _formData3, _formData3$LicneseTyp, _formData4, _formData4$formData, _formData4$formData$L;
  if (JSON.parse(sessionStorage.getItem("BPAREGintermediateValue")) !== null) {
    formData = JSON.parse(sessionStorage.getItem("BPAREGintermediateValue"));
    sessionStorage.setItem("BPAREGintermediateValue", null);
  } else formData = formData;
  let index = window.location.href.split("/").pop();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [LicenseType, setLicenseType] = useState(((_formData = formData) === null || _formData === void 0 ? void 0 : (_formData$LicneseType = _formData.LicneseType) === null || _formData$LicneseType === void 0 ? void 0 : _formData$LicneseType.LicenseType) || ((_formData2 = formData) === null || _formData2 === void 0 ? void 0 : (_formData2$formData = _formData2.formData) === null || _formData2$formData === void 0 ? void 0 : (_formData2$formData$L = _formData2$formData.LicneseType) === null || _formData2$formData$L === void 0 ? void 0 : _formData2$formData$L.LicenseType) || "");
  const [ArchitectNo, setArchitectNo] = useState(((_formData3 = formData) === null || _formData3 === void 0 ? void 0 : (_formData3$LicneseTyp = _formData3.LicneseType) === null || _formData3$LicneseTyp === void 0 ? void 0 : _formData3$LicneseTyp.ArchitectNo) || ((_formData4 = formData) === null || _formData4 === void 0 ? void 0 : (_formData4$formData = _formData4.formData) === null || _formData4$formData === void 0 ? void 0 : (_formData4$formData$L = _formData4$formData.LicneseType) === null || _formData4$formData$L === void 0 ? void 0 : _formData4$formData$L.ArchitectNo) || null);
  const {
    data,
    isLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  if (isopenlink) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  function getLicenseType() {
    var _data$StakeholderRegi;
    let list = [];
    let found = false;
    data === null || data === void 0 ? void 0 : (_data$StakeholderRegi = data.StakeholderRegistraition) === null || _data$StakeholderRegi === void 0 ? void 0 : _data$StakeholderRegi.TradeTypetoRoleMapping.map(ob => {
      found = list.some(el => el.i18nKey.includes(ob.tradeType.split(".")[0]));
      if (!found) list.push({
        role: ob.role,
        i18nKey: `TRADELICENSE_TRADETYPE_${ob.tradeType.split(".")[0]}`,
        tradeType: ob.tradeType
      });
    });
    return list;
  }
  const onSkip = () => onSelect();
  function selectLicenseType(value) {
    setLicenseType(value);
  }
  function selectArchitectNo(e) {
    setArchitectNo(e.target.value);
  }
  function goNext() {
    var _formData5, _formData6, _formData6$result, _formData6$result$Lic;
    if (!((_formData5 = formData) !== null && _formData5 !== void 0 && _formData5.result && (_formData6 = formData) !== null && _formData6 !== void 0 && (_formData6$result = _formData6.result) !== null && _formData6$result !== void 0 && (_formData6$result$Lic = _formData6$result.Licenses[0]) !== null && _formData6$result$Lic !== void 0 && _formData6$result$Lic.id)) onSelect(config.key, {
      LicenseType,
      ArchitectNo
    });else {
      var _formData7;
      let data = (_formData7 = formData) === null || _formData7 === void 0 ? void 0 : _formData7.formData;
      data.LicneseType.LicenseType = LicenseType;
      data.LicneseType.ArchitectNo = ArchitectNo;
      onSelect("", formData);
    }
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, isopenlink && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 1,
    flow: "STAKEHOLDER"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: goNext,
    onSkip: onSkip,
    isDisabled: LicenseType && LicenseType !== null && LicenseType !== void 0 && LicenseType.i18nKey.includes("ARCHITECT") ? !LicenseType || !ArchitectNo : !LicenseType
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_LICENSE_TYPE"), "*"), /*#__PURE__*/React__default.createElement("div", {
    className: "form-pt-dropdown-only"
  }, data && /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionKey: "i18nKey",
    isMandatory: config.isMandatory,
    options: getLicenseType() || {},
    selectedOption: LicenseType,
    onSelect: selectLicenseType
  })), LicenseType && (LicenseType === null || LicenseType === void 0 ? void 0 : LicenseType.i18nKey.includes("TRADELICENSE_TRADETYPE_ARCHITECT")) && (LicenseType === null || LicenseType === void 0 ? void 0 : LicenseType.tradeType.includes("ARCHITECT.CLASSA")) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_COUNCIL_NUMBER")}*`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "ArchitectNo",
    value: ArchitectNo,
    onChange: selectArchitectNo
  })))));
};

const LicenseDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  ownerIndex
}) => {
  var _userInfo$info, _formData$LicneseDeta, _formData$formData, _formData$formData$Li, _formData$LicneseDeta2, _formData$formData2, _formData$formData2$L, _formData$LicneseDeta3, _formData$formData3, _formData$formData3$L, _userInfo$info2, _formData$LicneseDeta4, _formData$formData4, _formData$formData4$L, _formData$LicneseDeta5, _formData$formData5, _formData$formData5$L;
  const {
    pathname: url
  } = useLocation();
  const userInfo = Digit.UserService.getUser();
  let validation = {};
  let isOpenLinkFlow = window.location.href.includes("openlink");
  const [name, setName] = useState((!isOpenLinkFlow ? userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.name : "") || (formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta = formData.LicneseDetails) === null || _formData$LicneseDeta === void 0 ? void 0 : _formData$LicneseDeta.name) || (formData === null || formData === void 0 ? void 0 : (_formData$formData = formData.formData) === null || _formData$formData === void 0 ? void 0 : (_formData$formData$Li = _formData$formData.LicneseDetails) === null || _formData$formData$Li === void 0 ? void 0 : _formData$formData$Li.name) || "");
  const [email, setEmail] = useState((formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta2 = formData.LicneseDetails) === null || _formData$LicneseDeta2 === void 0 ? void 0 : _formData$LicneseDeta2.email) || (formData === null || formData === void 0 ? void 0 : (_formData$formData2 = formData.formData) === null || _formData$formData2 === void 0 ? void 0 : (_formData$formData2$L = _formData$formData2.LicneseDetails) === null || _formData$formData2$L === void 0 ? void 0 : _formData$formData2$L.email) || "");
  const [gender, setGender] = useState((formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta3 = formData.LicneseDetails) === null || _formData$LicneseDeta3 === void 0 ? void 0 : _formData$LicneseDeta3.gender) || (formData === null || formData === void 0 ? void 0 : (_formData$formData3 = formData.formData) === null || _formData$formData3 === void 0 ? void 0 : (_formData$formData3$L = _formData$formData3.LicneseDetails) === null || _formData$formData3$L === void 0 ? void 0 : _formData$formData3$L.gender));
  const [mobileNumber, setMobileNumber] = useState((!isOpenLinkFlow ? userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber : "") || (formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta4 = formData.LicneseDetails) === null || _formData$LicneseDeta4 === void 0 ? void 0 : _formData$LicneseDeta4.mobileNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$formData4 = formData.formData) === null || _formData$formData4 === void 0 ? void 0 : (_formData$formData4$L = _formData$formData4.LicneseDetails) === null || _formData$formData4$L === void 0 ? void 0 : _formData$formData4$L.mobileNumber) || "");
  const [PanNumber, setPanNumber] = useState((formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta5 = formData.LicneseDetails) === null || _formData$LicneseDeta5 === void 0 ? void 0 : _formData$LicneseDeta5.PanNumber) || (formData === null || formData === void 0 ? void 0 : (_formData$formData5 = formData.formData) === null || _formData$formData5 === void 0 ? void 0 : (_formData$formData5$L = _formData$formData5.LicneseDetails) === null || _formData$formData5$L === void 0 ? void 0 : _formData$formData5$L.PanNumber) || "");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  if (isOpenLinkFlow) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  const {
    isLoading,
    data: genderTypeData
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["GenderType"]);
  let menu = [];
  genderTypeData && genderTypeData["common-masters"].GenderType.filter(data => data.active).map(genderDetails => {
    menu.push({
      i18nKey: `COMMON_GENDER_${genderDetails.code}`,
      code: `${genderDetails.code}`,
      value: `${genderDetails.code}`
    });
  });
  function SelectName(e) {
    setName(e.target.value);
  }
  function selectEmail(e) {
    setEmail(e.target.value);
  }
  function setGenderName(value) {
    setGender(value);
  }
  function setMobileNo(e) {
    setMobileNumber(e.target.value);
  }
  function selectPanNumber(e) {
    setPanNumber(e.target.value);
  }
  const goNext = () => {
    var _formData$result, _formData$result$Lice;
    if (!(formData !== null && formData !== void 0 && formData.result && formData !== null && formData !== void 0 && (_formData$result = formData.result) !== null && _formData$result !== void 0 && (_formData$result$Lice = _formData$result.Licenses[0]) !== null && _formData$result$Lice !== void 0 && _formData$result$Lice.id)) {
      let licenseDet = {
        name: name,
        mobileNumber: mobileNumber,
        gender: gender,
        email: email,
        PanNumber: PanNumber
      };
      onSelect(config.key, licenseDet);
    } else {
      let data = formData === null || formData === void 0 ? void 0 : formData.formData;
      data.LicneseDetails.name = name;
      data.LicneseDetails.mobileNumber = mobileNumber;
      data.LicneseDetails.gender = gender;
      data.LicneseDetails.email = email;
      data.LicneseDetails.PanNumber = PanNumber;
      onSelect("", formData);
    }
  };
  const onSkip = () => onSelect();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: isOpenLinkFlow ? "OpenlinkContainer" : ""
  }, isOpenLinkFlow && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 1,
    flow: "STAKEHOLDER"
  }), !isLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    config: config,
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: !name || !mobileNumber || !gender || !email
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_APPLICANT_NAME_LABEL")}*`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "name",
    value: name,
    onChange: SelectName,
    disable: name && !isOpenLinkFlow ? true : false
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("PT_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_APPLICANT_GENDER_LABEL")}*`), /*#__PURE__*/React__default.createElement(RadioButtons, {
    t: t,
    options: menu,
    optionsKey: "code",
    name: "gender",
    value: gender,
    selectedOption: gender,
    onSelect: setGenderName,
    isDependent: true,
    labelKey: "COMMON_GENDER"
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_OWNER_MOBILE_NO_LABEL")}*`), /*#__PURE__*/React__default.createElement(MobileNumber, Object.assign({
    value: mobileNumber,
    name: "mobileNumber",
    onChange: value => setMobileNo({
      target: {
        value
      }
    }),
    disable: mobileNumber && !isOpenLinkFlow ? true : false
  }, {
    required: true,
    pattern: "[6-9]{1}[0-9]{9}",
    type: "tel",
    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, t("BPA_APPLICANT_EMAIL_LABEL") + "*"), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "email",
    isMandatory: true,
    optionKey: "i18nKey",
    name: "email",
    value: email,
    onChange: selectEmail
  }, {
    required: true,
    pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$",
    type: "email",
    title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_APPLICANT_PAN_NO")}`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "PanNumber",
    value: PanNumber,
    onChange: selectPanNumber
  }, {
    required: true,
    pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
    title: t("BPA_INVALID_PAN_NO")
  })))) : /*#__PURE__*/React__default.createElement(Loader, null)));
};

const CorrospondenceAddress = ({
  t,
  config,
  onSelect,
  value,
  userType,
  formData
}) => {
  var _formData$formData, _formData$formData2;
  const onSkip = () => onSelect();
  const defaultAddress = {
    address: '',
    state: '',
    district: '',
    tehsil: '',
    town: '',
    pinNo: '',
    university: ''
  };
  const [Correspondenceaddress, setCorrespondenceaddress] = useState({
    ...defaultAddress,
    ...((formData === null || formData === void 0 ? void 0 : formData.Correspondenceaddress) || (formData === null || formData === void 0 ? void 0 : (_formData$formData = formData.formData) === null || _formData$formData === void 0 ? void 0 : _formData$formData.Correspondenceaddress) || {})
  });
  const [isAddressSame, setisAddressSame] = useState((formData === null || formData === void 0 ? void 0 : formData.isAddressSame) || (formData === null || formData === void 0 ? void 0 : (_formData$formData2 = formData.formData) === null || _formData$formData2 === void 0 ? void 0 : _formData$formData2.isAddressSame) || false);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [isDisableForNext, setIsDisableForNext] = useState(false);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  if (isopenlink) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  function selectChecked(e) {
    if (isAddressSame == false) {
      var _formData$LicneseDeta, _formData$LicneseDeta2, _formData$formData3, _formData$formData3$L;
      setisAddressSame(true);
      setCorrespondenceaddress(formData !== null && formData !== void 0 && (_formData$LicneseDeta = formData.LicneseDetails) !== null && _formData$LicneseDeta !== void 0 && _formData$LicneseDeta.PermanentAddress ? formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta2 = formData.LicneseDetails) === null || _formData$LicneseDeta2 === void 0 ? void 0 : _formData$LicneseDeta2.PermanentAddress : formData === null || formData === void 0 ? void 0 : (_formData$formData3 = formData.formData) === null || _formData$formData3 === void 0 ? void 0 : (_formData$formData3$L = _formData$formData3.LicneseDetails) === null || _formData$formData3$L === void 0 ? void 0 : _formData$formData3$L.PermanentAddress);
    } else {
      Array.from(document.querySelectorAll("input")).forEach(input => input.value = "");
      setisAddressSame(false);
      setCorrespondenceaddress("");
    }
  }
  const handleAddressChange = (fieldName, value) => {
    setCorrespondenceaddress({
      ...Correspondenceaddress,
      [fieldName]: value
    });
  };
  const goNext = () => {
    var _formData$result, _formData$result$Lice;
    if (!(formData !== null && formData !== void 0 && formData.result && formData !== null && formData !== void 0 && (_formData$result = formData.result) !== null && _formData$result !== void 0 && (_formData$result$Lice = _formData$result.Licenses[0]) !== null && _formData$result$Lice !== void 0 && _formData$result$Lice.id)) {
      var _formData$LicneseDeta3, _formData$LicneseDeta4, _formData$LicneseDeta5, _formData$LicneseDeta6, _formData$LicneseDeta7, _formData$LicneseDeta8, _formData$LicneseDeta9, _formData$LicneseType, _formData$LicneseType2, _formData$LicneseType3;
      setIsDisableForNext(true);
      let payload = {
        "Licenses": [{
          "tradeLicenseDetail": {
            "owners": [{
              "gender": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta3 = formData.LicneseDetails) === null || _formData$LicneseDeta3 === void 0 ? void 0 : (_formData$LicneseDeta4 = _formData$LicneseDeta3.gender) === null || _formData$LicneseDeta4 === void 0 ? void 0 : _formData$LicneseDeta4.code,
              "mobileNumber": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta5 = formData.LicneseDetails) === null || _formData$LicneseDeta5 === void 0 ? void 0 : _formData$LicneseDeta5.mobileNumber,
              "name": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta6 = formData.LicneseDetails) === null || _formData$LicneseDeta6 === void 0 ? void 0 : _formData$LicneseDeta6.name,
              "dob": null,
              "emailId": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta7 = formData.LicneseDetails) === null || _formData$LicneseDeta7 === void 0 ? void 0 : _formData$LicneseDeta7.email,
              "permanentAddress": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta8 = formData.LicneseDetails) === null || _formData$LicneseDeta8 === void 0 ? void 0 : _formData$LicneseDeta8.PermanentAddress,
              "correspondenceAddress": Correspondenceaddress,
              "pan": formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta9 = formData.LicneseDetails) === null || _formData$LicneseDeta9 === void 0 ? void 0 : _formData$LicneseDeta9.PanNumber
            }],
            "subOwnerShipCategory": "INDIVIDUAL",
            "tradeUnits": [{
              "tradeType": formData === null || formData === void 0 ? void 0 : (_formData$LicneseType = formData.LicneseType) === null || _formData$LicneseType === void 0 ? void 0 : (_formData$LicneseType2 = _formData$LicneseType.LicenseType) === null || _formData$LicneseType2 === void 0 ? void 0 : _formData$LicneseType2.tradeType
            }],
            "additionalDetail": {
              "counsilForArchNo": formData === null || formData === void 0 ? void 0 : (_formData$LicneseType3 = formData.LicneseType) === null || _formData$LicneseType3 === void 0 ? void 0 : _formData$LicneseType3.ArchitectNo
            },
            "address": {
              "city": "",
              "landmark": "",
              "pincode": ""
            },
            "institution": null,
            "applicationDocuments": null
          },
          "licenseType": "PERMANENT",
          "businessService": "BPAREG",
          "tenantId": stateId,
          "action": "NOWORKFLOW"
        }]
      };
      Digit.OBPSService.BPAREGCreate(payload, tenantId).then((result, err) => {
        setIsDisableForNext(false);
        let data = {
          result: result,
          formData: formData,
          Correspondenceaddress: Correspondenceaddress,
          isAddressSame: isAddressSame
        };
        onSelect("", data, "", true);
      }).catch(e => {
        var _e$response, _e$response$data, _e$response$data$Erro;
        setIsDisableForNext(false);
        setShowToast({
          key: "error"
        });
        setError((e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message) || null);
      });
    } else {
      formData.Correspondenceaddress = Correspondenceaddress;
      formData.isAddressSame = isAddressSame;
      onSelect("", formData, "", true);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, isopenlink && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 2,
    flow: "STAKEHOLDER"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    config: config,
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: isDisableForNext
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    label: t("BPA_SAME_AS_PERMANENT_ADDRESS"),
    onChange: e => selectChecked(),
    checked: isAddressSame,
    style: {
      paddingBottom: "10px",
      paddingTop: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "address",
    onChange: e => handleAddressChange('address', e.target.value),
    value: Correspondenceaddress.address,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "state",
    onChange: e => handleAddressChange('state', e.target.value),
    value: Correspondenceaddress.state,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_DISTRICT")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "district",
    onChange: e => handleAddressChange('district', e.target.value),
    value: Correspondenceaddress.district,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_TEHSIL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "tehsil",
    onChange: e => handleAddressChange('tehsil', e.target.value),
    value: Correspondenceaddress.tehsil,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_TOWN")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "town",
    onChange: e => handleAddressChange('town', e.target.value),
    value: Correspondenceaddress.town,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_PINNO")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "pinNo",
    onChange: e => handleAddressChange('pinNo', e.target.value),
    value: Correspondenceaddress.pinNo,
    disable: isAddressSame
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_UNIVERSITY_NAME")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "university",
    onChange: e => handleAddressChange('university', e.target.value),
    value: Correspondenceaddress.university,
    disable: isAddressSame
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      disabled: "true",
      height: "30px",
      width: "100%",
      fontSize: "14px"
    }
  }), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? true : false,
    label: error,
    isDleteBtn: true,
    onClose: () => {
      setShowToast(null);
      setError(null);
    }
  }));
};

const PermanentAddress = ({
  t,
  config,
  onSelect,
  value,
  userType,
  formData
}) => {
  var _formData$LicneseDeta, _formData$formData, _formData$formData$Li;
  const onSkip = () => onSelect();
  const defaultAddress = {
    address: '',
    state: '',
    district: '',
    tehsil: '',
    town: '',
    pinNo: '',
    university: ''
  };
  const [permanentAddress, setPermanentAddress] = useState({
    ...defaultAddress,
    ...((formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta = formData.LicneseDetails) === null || _formData$LicneseDeta === void 0 ? void 0 : _formData$LicneseDeta.PermanentAddress) || (formData === null || formData === void 0 ? void 0 : (_formData$formData = formData.formData) === null || _formData$formData === void 0 ? void 0 : (_formData$formData$Li = _formData$formData.LicneseDetails) === null || _formData$formData$Li === void 0 ? void 0 : _formData$formData$Li.PermanentAddress) || {})
  });
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  if (isopenlink) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  const handleAddressChange = (fieldName, value) => {
    setPermanentAddress({
      ...permanentAddress,
      [fieldName]: value
    });
  };
  const goNext = () => {
    var _formData$result, _formData$result$Lice;
    if (!(formData !== null && formData !== void 0 && formData.result && formData !== null && formData !== void 0 && (_formData$result = formData.result) !== null && _formData$result !== void 0 && (_formData$result$Lice = _formData$result.Licenses[0]) !== null && _formData$result$Lice !== void 0 && _formData$result$Lice.id)) {
      onSelect(config.key, {
        PermanentAddress: permanentAddress
      });
    } else {
      let data = formData === null || formData === void 0 ? void 0 : formData.formData;
      data.LicneseDetails.PermanentAddress = permanentAddress;
      onSelect("", formData);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, isopenlink && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 2,
    flow: "STAKEHOLDER"
  }), /*#__PURE__*/React__default.createElement(FormStep, {
    config: config,
    onSelect: goNext,
    onSkip: onSkip,
    t: t,
    isDisabled: !permanentAddress
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_PERMANANT_ADDRESS_LABEL")}*`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "permanentAddress",
    onChange: e => handleAddressChange('address', e.target.value),
    value: permanentAddress.address
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_STATE")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "state",
    onChange: e => handleAddressChange('state', e.target.value),
    value: permanentAddress.state
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_DISTRICT")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "district",
    onChange: e => handleAddressChange('district', e.target.value),
    value: permanentAddress.district
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_TEHSIL")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "tehsil",
    onChange: e => handleAddressChange('tehsil', e.target.value),
    value: permanentAddress.tehsil
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_TOWN")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "town",
    onChange: e => handleAddressChange('town', e.target.value),
    value: permanentAddress.town
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_PINNO")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "pinNo",
    onChange: e => handleAddressChange('pinNo', e.target.value),
    value: permanentAddress.pinNo
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("CORE_COMMON_UNIVERSITY_NAME")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    isMandatory: false,
    type: "text",
    optionKey: "i18nKey",
    name: "university",
    onChange: e => handleAddressChange('university', e.target.value),
    value: permanentAddress.university
  }))));
};

const StakeholderDocuments = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  setError: setFormError,
  clearErrors: clearFormErrors,
  formState
}) => {
  var _formData$documents, _formData$result, _formData$result$Lice, _formData$result$Lice2;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.documents) || []);
  const [error, setError] = useState(null);
  const [bpaTaxDocuments, setBpaTaxDocuments] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  let isopenlink = window.location.href.includes("/openlink/");
  if (isopenlink) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  const {
    data,
    isLoading
  } = Digit.Hooks.obps.useMDMS(stateId, "StakeholderRegistraition", "TradeTypetoRoleMapping");
  useEffect(() => {
    var _data$StakeholderRegi, _filtredBpaDocs, _filtredBpaDocs$, _filtredBpaDocs$$docT;
    let filtredBpaDocs = [];
    if (data !== null && data !== void 0 && (_data$StakeholderRegi = data.StakeholderRegistraition) !== null && _data$StakeholderRegi !== void 0 && _data$StakeholderRegi.TradeTypetoRoleMapping) {
      var _data$StakeholderRegi2, _data$StakeholderRegi3;
      filtredBpaDocs = data === null || data === void 0 ? void 0 : (_data$StakeholderRegi2 = data.StakeholderRegistraition) === null || _data$StakeholderRegi2 === void 0 ? void 0 : (_data$StakeholderRegi3 = _data$StakeholderRegi2.TradeTypetoRoleMapping) === null || _data$StakeholderRegi3 === void 0 ? void 0 : _data$StakeholderRegi3.filter(ob => {
        var _formData$formData, _formData$formData$Li, _formData$formData$Li2;
        return ob.tradeType === (formData === null || formData === void 0 ? void 0 : (_formData$formData = formData.formData) === null || _formData$formData === void 0 ? void 0 : (_formData$formData$Li = _formData$formData.LicneseType) === null || _formData$formData$Li === void 0 ? void 0 : (_formData$formData$Li2 = _formData$formData$Li.LicenseType) === null || _formData$formData$Li2 === void 0 ? void 0 : _formData$formData$Li2.tradeType);
      });
    }
    let documentsList = [];
    (_filtredBpaDocs = filtredBpaDocs) === null || _filtredBpaDocs === void 0 ? void 0 : (_filtredBpaDocs$ = _filtredBpaDocs[0]) === null || _filtredBpaDocs$ === void 0 ? void 0 : (_filtredBpaDocs$$docT = _filtredBpaDocs$.docTypes) === null || _filtredBpaDocs$$docT === void 0 ? void 0 : _filtredBpaDocs$$docT.forEach(doc => {
      documentsList.push(doc);
    });
    setBpaTaxDocuments(documentsList);
  }, [!isLoading]);
  const handleSubmit = () => {
    let document = formData.documents;
    let documentStep;
    let regularDocs = [];
    bpaTaxDocuments && documents && documents !== null && bpaTaxDocuments.map((initialob, index) => {
      let docobject = documents.find(ob => ob && ob !== null && ob.documentType === initialob.code);
      if (docobject) regularDocs.push(docobject);
    });
    documentStep = {
      ...document,
      documents: regularDocs
    };
    onSelect(config.key, documentStep);
  };
  const onSkip = () => onSelect();
  function onAdd() {}
  useEffect(() => {
    let count = 0;
    bpaTaxDocuments.map(doc => {
      let isRequired = false;
      documents.map(data => {
        if (doc.required && data !== null && data && doc.code == `${data.documentType.split(".")[0]}.${data.documentType.split(".")[1]}`) {
          isRequired = true;
        }
      });
      if (!isRequired && doc.required) {
        count = count + 1;
      }
    });
    if ((count == "0" || count == 0) && documents.length > 0) setEnableSubmit(false);else setEnableSubmit(false);
  }, [documents, checkRequiredFields]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, isopenlink && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 3,
    flow: "STAKEHOLDER"
  }), !isLoading ? /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmit,
    onSkip: onSkip,
    isDisabled: enableSubmit,
    onAdd: onAdd,
    cardStyle: {
      paddingRight: "16px"
    }
  }, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement(SelectDocument$5, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      isCitizenUrl: isCitizenUrl
    });
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    isDleteBtn: true,
    onClose: () => setError(null),
    error: true
  })) : /*#__PURE__*/React__default.createElement(Loader, null), !(formData !== null && formData !== void 0 && formData.initiationFlow) && /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
    info: t("CS_FILE_APPLICATION_INFO_LABEL"),
    text: `${t("BPA_APPLICATION_NUMBER_LABEL")} ${formData === null || formData === void 0 ? void 0 : (_formData$result = formData.result) === null || _formData$result === void 0 ? void 0 : (_formData$result$Lice = _formData$result.Licenses) === null || _formData$result$Lice === void 0 ? void 0 : (_formData$result$Lice2 = _formData$result$Lice[0]) === null || _formData$result$Lice2 === void 0 ? void 0 : _formData$result$Lice2.applicationNumber} ${t("BPA_DOCS_INFORMATION")}`,
    className: "info-banner-wrap-citizen-override"
  })));
};
function SelectDocument$5({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  isCitizenUrl
}) {
  var _doc$dropdownData, _doc$code, _doc$code2;
  const filteredDocument = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) === 1 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  function selectfile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    setDocuments(prev => {
      const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.documentType) !== (doc === null || doc === void 0 ? void 0 : doc.code));
      if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) {
        return filteredDocumentsByDocumentType;
      }
      const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
      return [...filteredDocumentsByFileStoreId, {
        documentType: doc === null || doc === void 0 ? void 0 : doc.code,
        fileStoreId: uploadedFile,
        documentUid: uploadedFile,
        fileName: (file === null || file === void 0 ? void 0 : file.name) || "",
        info: (doc === null || doc === void 0 ? void 0 : doc.info) || ""
      }];
    });
  }, [uploadedFile, file]);
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            setUploadedFile(null);
            const response = await Digit.UploadServices.Filestorage("PT", file, tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]);
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginBottom: "10px"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t(`BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$code = doc.code) === null || _doc$code === void 0 ? void 0 : _doc$code.replace(".", "_")}`)} *` : `${t(`BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$code2 = doc.code) === null || _doc$code2 === void 0 ? void 0 : _doc$code2.replace(".", "_")}`)}`), doc !== null && doc !== void 0 && doc.info ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontSize: "12px",
      color: "#505A5F",
      fontWeight: 400,
      lineHeight: "15px",
      marginBottom: "10px"
    }
  }, `${t(doc === null || doc === void 0 ? void 0 : doc.info)}`) : null, /*#__PURE__*/React__default.createElement(UploadFile, {
    extraStyleName: "OBPS",
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    onUpload: selectfile,
    onDelete: () => {
      setUploadedFile(null);
      setCheckRequiredFields(true);
    },
    message: uploadedFile ? `1 ${t(`CS_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
    iserror: error
  }));
}

const OBPSResponse = props => {
  var _state$data, _state$data$BPA;
  const {
    state
  } = props.location;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const bpaData = state === null || state === void 0 ? void 0 : (_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$BPA = _state$data.BPA) === null || _state$data$BPA === void 0 ? void 0 : _state$data$BPA[0];
  const [applicationData, setApplicationData] = useState({});
  const [isLoader, setIsLoader] = useState(true);
  const history = useHistory();
  const [isSanctionFee, setSanctionFee] = useState("");
  const [billData, setBillData] = useState(null);
  let bpaBusinessService = applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService;
  let bpaStatus = applicationData === null || applicationData === void 0 ? void 0 : applicationData.status;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: bpaData === null || bpaData === void 0 ? void 0 : bpaData.applicationNo,
    moduleCode: "BPA"
  });
  useEffect(async () => {
    var _bpaResponse$BPA, _bpaResponse$BPA$, _bpaResponse$BPA2, _bpaResponse$BPA2$, _bpaResponse$BPA3, _bpaResponse$BPA3$, _bpaResponse$BPA4, _bpaResponse$BPA4$, _fetchBill$Bill$, _bpaResponse$BPA5;
    setIsLoader(true);
    const bpaResponse = await Digit.OBPSService.BPASearch(tenantId, {
      applicationNo: bpaData === null || bpaData === void 0 ? void 0 : bpaData.applicationNo
    });
    let businessService = await getBusinessServices(bpaResponse === null || bpaResponse === void 0 ? void 0 : (_bpaResponse$BPA = bpaResponse.BPA) === null || _bpaResponse$BPA === void 0 ? void 0 : (_bpaResponse$BPA$ = _bpaResponse$BPA[0]) === null || _bpaResponse$BPA$ === void 0 ? void 0 : _bpaResponse$BPA$.businessService, bpaResponse === null || bpaResponse === void 0 ? void 0 : (_bpaResponse$BPA2 = bpaResponse.BPA) === null || _bpaResponse$BPA2 === void 0 ? void 0 : (_bpaResponse$BPA2$ = _bpaResponse$BPA2[0]) === null || _bpaResponse$BPA2$ === void 0 ? void 0 : _bpaResponse$BPA2$.status);
    const fetchBill = await Digit.PaymentService.fetchBill(tenantId, {
      consumerCode: bpaResponse === null || bpaResponse === void 0 ? void 0 : (_bpaResponse$BPA3 = bpaResponse.BPA) === null || _bpaResponse$BPA3 === void 0 ? void 0 : (_bpaResponse$BPA3$ = _bpaResponse$BPA3[0]) === null || _bpaResponse$BPA3$ === void 0 ? void 0 : _bpaResponse$BPA3$.applicationNo,
      businessService: businessService
    });
    if ((bpaResponse === null || bpaResponse === void 0 ? void 0 : (_bpaResponse$BPA4 = bpaResponse.BPA) === null || _bpaResponse$BPA4 === void 0 ? void 0 : (_bpaResponse$BPA4$ = _bpaResponse$BPA4[0]) === null || _bpaResponse$BPA4$ === void 0 ? void 0 : _bpaResponse$BPA4$.status) == "APPROVED" && fetchBill !== null && fetchBill !== void 0 && fetchBill.Bill[0] && (fetchBill === null || fetchBill === void 0 ? void 0 : (_fetchBill$Bill$ = fetchBill.Bill[0]) === null || _fetchBill$Bill$ === void 0 ? void 0 : _fetchBill$Bill$.totalAmount) != 0) setSanctionFee("_SAN_FEE");
    setIsLoader(false);
    setApplicationData(bpaResponse === null || bpaResponse === void 0 ? void 0 : (_bpaResponse$BPA5 = bpaResponse.BPA) === null || _bpaResponse$BPA5 === void 0 ? void 0 : _bpaResponse$BPA5[0]);
    setBillData(fetchBill === null || fetchBill === void 0 ? void 0 : fetchBill.Bill);
  }, []);
  const getHeaderMessage = () => {
    var _bpaData$workflow;
    return t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow = bpaData.workflow) === null || _bpaData$workflow === void 0 ? void 0 : _bpaData$workflow.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}${isSanctionFee ? isSanctionFee : ""}`);
  };
  const getSubHeaderMessage = () => {
    var _bpaData$workflow2, _bpaData$additionalDe, _bpaData$additionalDe2;
    return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow2 = bpaData.workflow) === null || _bpaData$workflow2 === void 0 ? void 0 : _bpaData$workflow2.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe = bpaData.additionalDetails) !== null && _bpaData$additionalDe !== void 0 && _bpaData$additionalDe.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe2 = bpaData.additionalDetails) === null || _bpaData$additionalDe2 === void 0 ? void 0 : _bpaData$additionalDe2.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}${isSanctionFee ? isSanctionFee : ""}`);
  };
  const printReciept = async () => {
    let response = await Digit.PaymentService.generatePdf(tenantId, {
      Bpa: [applicationData]
    }, "bpa-revocation");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[response === null || response === void 0 ? void 0 : response.filestoreIds[0]], "_blank");
  };
  const onSubmit = () => {
    history.push(`/digit-ui/employee`);
  };
  const getApplicationNoLabel = () => {
    return bpaBusinessService == "BPA" ? t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL");
  };
  const getPaymentURL = isCitizen => {
    if (isCitizen == true) return `/digit-ui/citizen/payment/collect/${getBusinessServices(applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService, applicationData === null || applicationData === void 0 ? void 0 : applicationData.status)}/${applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo}/${applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId}?tenantId=${applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId}`;
  };
  const getPaymentURLEmployee = () => {
    history.push(`/digit-ui/employee/payment/collect/${getBusinessServices(applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService, applicationData === null || applicationData === void 0 ? void 0 : applicationData.status)}/${applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo}/${applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId}?tenantId=${applicationData === null || applicationData === void 0 ? void 0 : applicationData.tenantId}`);
  };
  let isPayButtonEnable = false;
  if (workflowDetails && workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.data && !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading)) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.forEach(data => {
      if (data.action == "PAY" && !isPayButtonEnable) isPayButtonEnable = true;
    });
  }
  return /*#__PURE__*/React__default.createElement("div", null, isLoader || workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(Banner, {
    message: getHeaderMessage(),
    applicationNumber: applicationData === null || applicationData === void 0 ? void 0 : applicationData.applicationNo,
    info: getApplicationNoLabel(),
    successful: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PERMIT REVOCATION" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "REJECTED" ? false : true,
    style: {
      padding: "10px"
    },
    headerStyles: {
      fontSize: "32px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      paddingBottom: "10px",
      marginBottom: "10px"
    }
  }, getSubHeaderMessage()), (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PERMIT REVOCATION" ? /*#__PURE__*/React__default.createElement("div", {
    className: "primary-label-btn d-grid",
    style: {
      marginLeft: "unset",
      marginBottom: "10px",
      padding: "0px 8px"
    },
    onClick: printReciept
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "23",
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z",
    fill: "#1F4A7C"
  })), t("BPA_REVOCATION_PDF_LABEL")) : null, window.location.href.includes("/citizen") ? /*#__PURE__*/React__default.createElement("div", null, ((applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_APPL_FEE" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_FEE" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_SANC_FEE_PAYMENT") && (billData === null || billData === void 0 ? void 0 : billData.length) > 0 && isPayButtonEnable ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: getPaymentURL(true)
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("WF_BPA_PAY"),
    style: {
      margin: "10px 0px 0px 0px"
    }
  })), /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen/profile`
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))) : /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen/profile`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME"),
    style: {
      margin: "10px 10px 0px 0px"
    }
  }))) : /*#__PURE__*/React__default.createElement(ActionBar, {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "baseline"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, ((applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_APPL_FEE" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_FEE" || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) == "PENDING_SANC_FEE_PAYMENT") && (billData === null || billData === void 0 ? void 0 : billData.length) > 0 && isPayButtonEnable ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("WF_BPA_PAY"),
    onSubmit: getPaymentURLEmployee,
    style: {
      margin: "10px 0px 0px 0px"
    }
  }), /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/employee`
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#1F4A7C",
      margin: "0px 10px"
    }
  }, t("CORE_COMMON_GO_TO_HOME")))) : /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME"),
    onSubmit: onSubmit,
    style: {
      margin: "10px 10px 0px 0px"
    }
  })))));
};

const StakeholderResponse = props => {
  var _state$data, _state$data$Licenses, _bparegData$tradeLice, _bparegData$tradeLice2, _bparegData$tradeLice3, _bparegData$tradeLice4;
  const {
    state
  } = props.location;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const bparegData = state === null || state === void 0 ? void 0 : (_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$Licenses = _state$data.Licenses) === null || _state$data$Licenses === void 0 ? void 0 : _state$data$Licenses[0];
  const typeofStakeholder = bparegData === null || bparegData === void 0 ? void 0 : (_bparegData$tradeLice = bparegData.tradeLicenseDetail) === null || _bparegData$tradeLice === void 0 ? void 0 : (_bparegData$tradeLice2 = _bparegData$tradeLice.tradeUnits) === null || _bparegData$tradeLice2 === void 0 ? void 0 : (_bparegData$tradeLice3 = _bparegData$tradeLice2[0]) === null || _bparegData$tradeLice3 === void 0 ? void 0 : (_bparegData$tradeLice4 = _bparegData$tradeLice3.tradeType) === null || _bparegData$tradeLice4 === void 0 ? void 0 : _bparegData$tradeLice4.split('.')[0];
  const getHeaderMessage = () => {
    return t(`BPA_ARCHITECT_${bparegData === null || bparegData === void 0 ? void 0 : bparegData.status}_MAIN_HEAD`);
  };
  const getSubHeaderMessage = () => {
    return t(`BPA_ARCHITECT_${bparegData === null || bparegData === void 0 ? void 0 : bparegData.status}_SUB_MAIN_HEAD`);
  };
  const onSubmit = () => {
    history.push(`/digit-ui/employee`);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(Banner, {
    message: getHeaderMessage(),
    applicationNumber: bparegData === null || bparegData === void 0 ? void 0 : bparegData.applicationNumber,
    info: t("BPA_NEW_STAKEHOLDER_REGISTRATION_APP_LABEL"),
    successful: (bparegData === null || bparegData === void 0 ? void 0 : bparegData.status) == "REJECTED" ? false : true,
    style: {
      padding: "10px"
    },
    headerStyles: {
      fontSize: "32px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      paddingBottom: "10px",
      marginBottom: "10px"
    }
  }, getSubHeaderMessage()), /*#__PURE__*/React__default.createElement(ActionBar, {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "baseline"
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME"),
    onSubmit: onSubmit
  }))));
};

const ApplicationDetail = (props = {}) => {
  var _location$pathname, _location$pathname2, _location$pathname3, _data$LandUse, _data$ownerRegistrati, _data$PurchasableFAR, _data$BPA, _appData$nocList, _appData$nocList2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data17, _workflowDetails$data18, _workflowDetails$data19, _workflowDetails$data20;
  const {
    authority,
    state,
    plan,
    plinth,
    form,
    year,
    serial,
    formType,
    id: urlId
  } = useParams();
  console.log(useParams(), "paramsHook");
  const location = useLocation();
  console.log(location, "locationCheck");
  const isFromDashboard = (props === null || props === void 0 ? void 0 : props.isFromDashboard) || (location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("dashboard-details")) || (location === null || location === void 0 ? void 0 : (_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.includes("dashboard-v2")) || (location === null || location === void 0 ? void 0 : (_location$pathname3 = location.pathname) === null || _location$pathname3 === void 0 ? void 0 : _location$pathname3.includes("dashboard"));
  const idFromDashboard = (props === null || props === void 0 ? void 0 : props.applicationNo) || Digit.SessionStorage.get("DASHBOARD_ID");
  const id = plinth ? `${authority}/${plinth}/${plan}/${form}/${year}/${serial}` : urlId ? urlId : state ? `${state}/${form}/${year}/${serial}` : isFromDashboard ? idFromDashboard : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromCompAyush", id, urlId, isFromDashboard, idFromDashboard);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const [filters, setFilters] = useState(null);
  const history = useHistory();
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let {
    data: newConfig$1
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const isEmployee = history.location.pathname.includes("employee");
  useEffect(() => {
    if (formType !== "NOC") {
      setFilters({
        applicationNo: id,
        isEmployee,
        formType
      });
      return;
    }
    const fetchNocData = async () => {
      try {
        var _response$Noc, _response$Noc$;
        const response = await NOCService.NOCsearch({
          tenantId: "up",
          filters: {
            applicationNo: id
          }
        });
        console.log("responseFromNOCSearch", response);
        setFilters({
          applicationNo: response === null || response === void 0 ? void 0 : (_response$Noc = response.Noc) === null || _response$Noc === void 0 ? void 0 : (_response$Noc$ = _response$Noc[0]) === null || _response$Noc$ === void 0 ? void 0 : _response$Noc$.sourceRefId,
          isEmployee,
          formType: "FORM_MAP"
        });
      } catch (err) {
        console.error("Error in NOCsearch:", err);
      }
    };
    fetchNocData();
  }, [tenantId, id, isEmployee, formType]);
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, filters, {
    formType,
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true
    }
  });
  const {
    collectionBillRes,
    collectionBillDetails
  } = data;
  const appData = (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]) || (data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati[0]) || (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]) || (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || (data === null || data === void 0 ? void 0 : data.applicationData);
  console.log("appDetail", data, appData);
  if (!isLoading && appData) {
    var _collectionBillRes$, _collectionBillRes$$p;
    appData.paymentDetails = collectionBillRes === null || collectionBillRes === void 0 ? void 0 : (_collectionBillRes$ = collectionBillRes[0]) === null || _collectionBillRes$ === void 0 ? void 0 : (_collectionBillRes$$p = _collectionBillRes$.paymentDetails) === null || _collectionBillRes$$p === void 0 ? void 0 : _collectionBillRes$$p[0];
  }
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(stateId, formType);
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const matchedNoc = (appData === null || appData === void 0 ? void 0 : (_appData$nocList = appData.nocList) === null || _appData$nocList === void 0 ? void 0 : _appData$nocList.find(item => item.applicationNo === id)) || (appData === null || appData === void 0 ? void 0 : (_appData$nocList2 = appData.nocList) === null || _appData$nocList2 === void 0 ? void 0 : _appData$nocList2.find(item => item.businessService === (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode)));
  const nocApplicationId = (matchedNoc === null || matchedNoc === void 0 ? void 0 : matchedNoc.applicationNo) || id;
  console.log("userdetailsIndexFOrm", userDetails, nocApplicationId);
  const workFlowId = formType === "NOC" ? nocApplicationId : id;
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: workFlowId,
    moduleCode: formType === "NOC" ? (matchedNoc === null || matchedNoc === void 0 ? void 0 : matchedNoc.businessService) || (appData === null || appData === void 0 ? void 0 : appData.businessService) || "NOC" : appData === null || appData === void 0 ? void 0 : appData.businessService
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  const userInfo = Digit.UserService.getUser();
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.length) > 0) {
    var _workflowDetails$data15, _workflowDetails$data16;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, !isLoading && appData && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsForm11, {
    applicationDetails: appData,
    isLoading: updatingApplication,
    isDataLoading: updatingApplication,
    applicationData: appData,
    refetch: refetch,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data17 = workflowDetails.data) !== null && _workflowDetails$data17 !== void 0 && _workflowDetails$data17.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data18 = workflowDetails.data) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.applicationBusinessService : appData === null || appData === void 0 ? void 0 : appData.businessService,
    moduleCode: appData === null || appData === void 0 ? void 0 : appData.businessService,
    showToast: showToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data19 = workflowDetails.data) !== null && _workflowDetails$data19 !== void 0 && _workflowDetails$data19.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data20 = workflowDetails.data) === null || _workflowDetails$data20 === void 0 ? void 0 : _workflowDetails$data20.applicationBusinessService : appData === null || appData === void 0 ? void 0 : appData.businessService}_`,
    isFromDashboard: isFromDashboard
  }))));
};

const ApplicationDetailsForm34 = props => {
  var _workflowDetails$data;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setWarningPopUp(true);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if ((action === null || action === void 0 ? void 0 : action.action) === 'APPROVAL_LETTER_GENERATE') {
        setShowModal(false);
        let payload = {};
        payload.PermissionOfSubdivision = applicationData;
        payload.PermissionOfSubdivision.workflow = {
          "action": "APPROVAL_LETTER_GENERATE",
          "assignes": null,
          "comments": null,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const response = await OBPSService.update11(payload, tenantId);
          if (response) {
            history.replace(`/digit-ui/employee/obps/response`, {
              data: applicationData
            });
            window.open(`https://pdfhost.io/v/kXKIgTQUO_Form12_certificate`);
          }
        } catch (error) {
          console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
    setTimeout(() => {
      window.location.href = `/digit-ui/employee/obps/form11inbox`;
    }, 3000);
  };
  const closeWarningPopup = () => {
    setWarningPopUp(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
    }
    closeModal();
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("applicationDetails123", applicationDetails, applicationData);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsContentForm11, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    isLoading: isLoading,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine
  }), showModal ? /*#__PURE__*/React__default.createElement(ActionModal, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    state: state,
    id: applicationNumber,
    applicationDetails: applicationDetails,
    applicationData: applicationDetails,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    businessService: businessService,
    workflowDetails: workflowDetails,
    moduleCode: moduleCode
  }) : null, isWarningPop ? /*#__PURE__*/React__default.createElement(ApplicationDetailsWarningPopup, {
    action: selectedAction,
    workflowDetails: workflowDetails,
    businessService: businessService,
    isWarningPop: isWarningPop,
    closeWarningPopup: closeWarningPopup
  }) : null, /*#__PURE__*/React__default.createElement(ApplicationDetailsToast, {
    t: t,
    showToast: showToast,
    closeToast: closeToast,
    businessService: businessService
  }), /*#__PURE__*/React__default.createElement(ApplicationDetailsActionBar, {
    workflowDetails: workflowDetails,
    displayMenu: displayMenu,
    onActionSelect: onActionSelect,
    setDisplayMenu: setDisplayMenu,
    businessService: businessService,
    forcedActionPrefix: forcedActionPrefix,
    ActionBarStyle: ActionBarStyle,
    MenuStyle: MenuStyle,
    applicationDetails: applicationDetails
  })) : /*#__PURE__*/React__default.createElement(Loader, null));
};

const BpaApplicationDetailForm34 = () => {
  var _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data13, _workflowDetails$data14, _data$applicationData, _userInfo$info, _workflowDetails$data17, _workflowDetails$data18, _data$applicationData2, _workflowDetails$data19, _workflowDetails$data20, _data$applicationData3;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const defaultValues = {};
  const history = useHistory();
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let {
    data: newConfig$1
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id
  }, {
    formType: "Form11"
  });
  console.log("isDataForm11", data, bpaDocs, newConfig$1, mdmsData);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(tenantId, "Form11");
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  function checkHead(head) {
    if (head === "ES_NEW_APPLICATION_LOCATION_DETAILS") {
      return "TL_CHECK_ADDRESS";
    } else if (head === "ES_NEW_APPLICATION_OWNERSHIP_DETAILS") {
      return "TL_OWNERSHIP_DETAILS_HEADER";
    } else {
      return head;
    }
  }
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  const onFormValueChange = (setValue, formData, formState) => {
    setSubmitValve(!Object.keys(formState.errors).length);
  };
  let configs = newConfig$1 !== null && newConfig$1 !== void 0 && newConfig$1.InspectionReportConfig ? newConfig$1 === null || newConfig$1 === void 0 ? void 0 : newConfig$1.InspectionReportConfig : newConfig;
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPA_FORM11"
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  const userInfo = Digit.UserService.getUser();
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  let dowloadOptions = [];
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.length) > 0) {
    var _workflowDetails$data15, _workflowDetails$data16;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-application-details",
    style: {
      marginBottom: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Header, {
    styles: {
      marginLeft: "0px",
      paddingTop: "10px",
      fontSize: "32px"
    }
  }, t("CS_TITLE_APPLICATION_DETAILS")), dowloadOptions && dowloadOptions > 0 && /*#__PURE__*/React__default.createElement(MultiLink, {
    className: "multilinkWrapper employee-mulitlink-main-div",
    onHeadClick: () => setShowOptions(!showOptions),
    displayOptions: showOptions,
    options: dowloadOptions,
    downloadBtnClassName: "employee-download-btn-className",
    optionsClassName: "employee-options-btn-className"
  })), (data === null || data === void 0 ? void 0 : (_data$applicationData = data.applicationData) === null || _data$applicationData === void 0 ? void 0 : _data$applicationData.status) === "FIELDINSPECTION_INPROGRESS" && (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.roles.filter(role => role.code === "BPA_FIELD_INSPECTOR")).length > 0 && /*#__PURE__*/React__default.createElement(FormComposer, {
    heading: t(""),
    isDisabled: !canSubmit,
    config: configs.map(config => {
      return {
        ...config,
        body: config.body.filter(a => {
          return !a.hideInEmployee;
        }),
        head: checkHead(config.head)
      };
    }),
    fieldStyle: {
      marginRight: 0
    },
    submitInForm: false,
    defaultValues: defaultValues,
    onFormValueChange: onFormValueChange,
    breaklineStyle: {
      border: "0px"
    },
    className: "employeeCard-override"
  }), /*#__PURE__*/React__default.createElement(ApplicationDetailsForm34, {
    applicationDetails: data,
    isLoading: updatingApplication,
    isDataLoading: updatingApplication,
    applicationData: data,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data17 = workflowDetails.data) !== null && _workflowDetails$data17 !== void 0 && _workflowDetails$data17.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data18 = workflowDetails.data) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.applicationBusinessService : data === null || data === void 0 ? void 0 : (_data$applicationData2 = data.applicationData) === null || _data$applicationData2 === void 0 ? void 0 : _data$applicationData2.businessService,
    moduleCode: "BPA_FORM11",
    showToast: showToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data19 = workflowDetails.data) !== null && _workflowDetails$data19 !== void 0 && _workflowDetails$data19.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data20 = workflowDetails.data) === null || _workflowDetails$data20 === void 0 ? void 0 : _workflowDetails$data20.applicationBusinessService : data === null || data === void 0 ? void 0 : (_data$applicationData3 = data.applicationData) === null || _data$applicationData3 === void 0 ? void 0 : _data$applicationData3.businessService}_`
  })));
};

const Form12Detail = () => {
  var _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data13, _workflowDetails$data14, _workflowDetails$data17, _workflowDetails$data18;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEmployee = history.location.pathname.includes("employee");
  const [showToast, setShowToast] = useState(null);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [error, setError] = useState(null);
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  });
  const {
    applicationData,
    applicationDetails,
    businessService,
    edcrDetails,
    collectionBillDetails
  } = data;
  console.log("form12Details,", applicationData, applicationDetails, businessService, edcrDetails, collectionBillDetails, "ccccccc");
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(stateId);
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: applicationData === null || applicationData === void 0 ? void 0 : applicationData.businessService
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.length) > 0) {
    var _workflowDetails$data15, _workflowDetails$data16;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && applicationData ?
  /*#__PURE__*/
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      margin: "15px 0px 15px",
      padding: "8px",
      position: "relative"
    },
    className: "employeeCard-override"
  }, /*#__PURE__*/React__default.createElement(HouseIcon, {
    style: {
      color: 'red'
    }
  }), " Take Action"), /*#__PURE__*/React__default.createElement(ApplicationDetailsForm12, {
    applicationDetails: applicationData,
    isLoading: isLoading,
    isDataLoading: updatingApplication,
    applicationData: applicationData,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: businessService,
    moduleCode: businessService,
    showToast: showToast,
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data17 = workflowDetails.data) !== null && _workflowDetails$data17 !== void 0 && _workflowDetails$data17.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data18 = workflowDetails.data) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.applicationBusinessService : businessService}_`
  })) : /*#__PURE__*/React__default.createElement(Loader, null));
};

const useStyles$4 = makeStyles$1(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: '20px',
      width: '25ch'
    }
  },
  formControl: {
    margin: '20px',
    width: '260px'
  }
}));

const useStyles$5 = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableHeader: {
    backgroundColor: "#225785",
    borderBottom: "2px solid #ddd"
  },
  tableCell: {
    textAlign: "center",
    padding: "10px 15px",
    fontWeight: "bold",
    borderRight: "1px solid #ddd"
  },
  lastTableCell: {
    borderRight: "none"
  },
  whiteText: {
    color: "#ffffff"
  }
});
const StyledTableCell$4 = styled$1(TableCell$3)(({
  theme
}) => ({
  fontWeight: "bold",
  backgroundColor: "#1f4a7c",
  color: theme.palette.common.white,
  "& .MuiTableSortLabel-root": {
    color: "white",
    "&:hover": {
      color: "white"
    },
    "&.Mui-active": {
      color: "white"
    }
  },
  "& .MuiInput-root": {
    "&:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.42)"
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "white"
    },
    "&:after": {
      borderBottomColor: "white"
    },
    "& input": {
      color: "white",
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.7)"
      }
    }
  },
  "& .MuiSvgIcon-root": {
    color: "white"
  }
}));
const StyledTableRow$4 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable = ({
  ApplicationData,
  isLoading
}) => {
  var _ApplicationData$, _ApplicationData$$add, _ApplicationData$$add2, _ApplicationData$$add3, _ApplicationData$$add4;
  console.log("applicationdata", ApplicationData, ApplicationData === null || ApplicationData === void 0 ? void 0 : (_ApplicationData$ = ApplicationData[0]) === null || _ApplicationData$ === void 0 ? void 0 : (_ApplicationData$$add = _ApplicationData$.additionalDetails) === null || _ApplicationData$$add === void 0 ? void 0 : (_ApplicationData$$add2 = _ApplicationData$$add.landInfo) === null || _ApplicationData$$add2 === void 0 ? void 0 : (_ApplicationData$$add3 = _ApplicationData$$add2.owners) === null || _ApplicationData$$add3 === void 0 ? void 0 : (_ApplicationData$$add4 = _ApplicationData$$add3[0]) === null || _ApplicationData$$add4 === void 0 ? void 0 : _ApplicationData$$add4.name);
  const classes = useStyles$5();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [smShow, setSmShow] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [SmShowFAR, setSmShowFAR] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [letterLoader, setLetterLoader] = useState(false);
  const handleTakeAction = item => {
    var _Digit, _Digit2;
    console.log("itemFromTakeAction", item, item === null || item === void 0 ? void 0 : item.businessService);
    const appNo = item === null || item === void 0 ? void 0 : item.applicationNo;
    if (!appNo) {
      console.warn("No application number found", item);
      return;
    }
    const businessService = (item === null || item === void 0 ? void 0 : item.businessService) || "";
    const applicationType = (item === null || item === void 0 ? void 0 : item.applicationType) || "";
    const isStakeholder = businessService === "BPAREG" || (applicationType === null || applicationType === void 0 ? void 0 : applicationType.includes("STAKEHOLDER"));
    const isLandUse = businessService.startsWith("BPA_LANDUSE_DA") || businessService.startsWith("BPA_LANDUSE_AVP") || businessService.startsWith("BPA_KYP") || applicationType === "FORM_LANDUSE";
    const isLandUseConversion = businessService.includes("LANDUSECONVERSION") || businessService.includes("LANDUSE_CONVERSION") || applicationType === "FORM_LANDUSECONVERSION";
    const isPressRelease = businessService === "BPA_PRESS_RELEASE" || applicationType === "FORM_PRESSRELEASE";
    const isFar = businessService === "BPA_FAR_DA" || businessService === "BPA_FAR_AVP" || businessService === "BPA_PURCHASEFAR_DA" || businessService === "BPA_PURCHASEFAR_AVP" || applicationType === "FORM_PURCHASABLE_FAR" || applicationType === "FORM_FAR";
    const isNoc = businessService.startsWith("BPA_NOC") || applicationType === "FORM_NOC";
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("isDocValidated");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("isNotingValidated");
    if (isStakeholder) {
      Digit.SessionStorage.del("EMP_LTP");
      history.push(`/digit-ui/employee/obps/professional/${appNo}`);
    } else if (isLandUse) {
      Digit.SessionStorage.del("EMP_LANDUSE");
      history.push(`/digit-ui/employee/obps/application/formLandUse/${appNo}`);
    } else if (isLandUseConversion) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/FORM_LANDUSECONVERSION/${appNo}`);
    } else if (isPressRelease) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/FORM_PRESSRELEASE/${appNo}`);
    } else if (isFar) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${appNo}`);
    } else if (isNoc) {
      history.push(`/digit-ui/employee/obps/application/NOC/${appNo}`);
    } else {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/MAP_SUB/${appNo}`);
    }
  };
  const getProposedActivity = item => {
    var _item$businessObject, _item$businessObject2, _item$businessObject3, _item$businessObject4, _item$businessObject5, _item$businessObject6, _item$businessObject7, _item$businessObject8, _item$additionalDetai, _item$additionalDetai2, _item$additionalDetai3, _item$descriptionOfLa;
    return (item === null || item === void 0 ? void 0 : (_item$businessObject = item.businessObject) === null || _item$businessObject === void 0 ? void 0 : _item$businessObject.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$businessObject2 = item.businessObject) === null || _item$businessObject2 === void 0 ? void 0 : (_item$businessObject3 = _item$businessObject2.additionalDetails) === null || _item$businessObject3 === void 0 ? void 0 : _item$businessObject3.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$businessObject4 = item.businessObject) === null || _item$businessObject4 === void 0 ? void 0 : (_item$businessObject5 = _item$businessObject4.additionalDetails) === null || _item$businessObject5 === void 0 ? void 0 : (_item$businessObject6 = _item$businessObject5.descriptionOfLand) === null || _item$businessObject6 === void 0 ? void 0 : _item$businessObject6.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$businessObject7 = item.businessObject) === null || _item$businessObject7 === void 0 ? void 0 : (_item$businessObject8 = _item$businessObject7.descriptionOfLand) === null || _item$businessObject8 === void 0 ? void 0 : _item$businessObject8.activityProposed) || (item === null || item === void 0 ? void 0 : item.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : (_item$additionalDetai3 = _item$additionalDetai2.descriptionOfLand) === null || _item$additionalDetai3 === void 0 ? void 0 : _item$additionalDetai3.activityProposed) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.activityProposed) || "-";
  };
  const getPlotArea = item => {
    var _item$businessObject9, _item$businessObject10, _item$businessObject11, _item$businessObject12, _item$businessObject13, _item$businessObject14, _item$businessObject15, _item$businessObject16, _item$businessObject17, _item$businessObject18, _item$businessObject19, _item$businessObject20, _item$businessObject21, _item$businessObject22, _item$plotInfo, _item$additionalDetai4, _item$additionalDetai5, _item$additionalDetai6, _item$additionalDetai7, _item$additionalDetai8, _item$additionalDetai9, _item$additionalDetai10;
    return (item === null || item === void 0 ? void 0 : (_item$businessObject9 = item.businessObject) === null || _item$businessObject9 === void 0 ? void 0 : _item$businessObject9.plotArea) || (item === null || item === void 0 ? void 0 : (_item$businessObject10 = item.businessObject) === null || _item$businessObject10 === void 0 ? void 0 : (_item$businessObject11 = _item$businessObject10.plotInfo) === null || _item$businessObject11 === void 0 ? void 0 : _item$businessObject11.plotArea) || (item === null || item === void 0 ? void 0 : (_item$businessObject12 = item.businessObject) === null || _item$businessObject12 === void 0 ? void 0 : (_item$businessObject13 = _item$businessObject12.additionalDetails) === null || _item$businessObject13 === void 0 ? void 0 : _item$businessObject13.plotArea) || (item === null || item === void 0 ? void 0 : (_item$businessObject14 = item.businessObject) === null || _item$businessObject14 === void 0 ? void 0 : (_item$businessObject15 = _item$businessObject14.additionalDetails) === null || _item$businessObject15 === void 0 ? void 0 : (_item$businessObject16 = _item$businessObject15.descriptionOfLand) === null || _item$businessObject16 === void 0 ? void 0 : _item$businessObject16.landArea) || (item === null || item === void 0 ? void 0 : (_item$businessObject17 = item.businessObject) === null || _item$businessObject17 === void 0 ? void 0 : (_item$businessObject18 = _item$businessObject17.additionalDetails) === null || _item$businessObject18 === void 0 ? void 0 : (_item$businessObject19 = _item$businessObject18.descriptionOfLand) === null || _item$businessObject19 === void 0 ? void 0 : _item$businessObject19.plotAreaDoc) || (item === null || item === void 0 ? void 0 : (_item$businessObject20 = item.businessObject) === null || _item$businessObject20 === void 0 ? void 0 : (_item$businessObject21 = _item$businessObject20.additionalDetails) === null || _item$businessObject21 === void 0 ? void 0 : (_item$businessObject22 = _item$businessObject21.descriptionOfLand) === null || _item$businessObject22 === void 0 ? void 0 : _item$businessObject22.plotArea) || (item === null || item === void 0 ? void 0 : item.plotArea) || (item === null || item === void 0 ? void 0 : (_item$plotInfo = item.plotInfo) === null || _item$plotInfo === void 0 ? void 0 : _item$plotInfo.plotArea) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai4 = item.additionalDetails) === null || _item$additionalDetai4 === void 0 ? void 0 : _item$additionalDetai4.plotArea) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai5 = item.additionalDetails) === null || _item$additionalDetai5 === void 0 ? void 0 : (_item$additionalDetai6 = _item$additionalDetai5.descriptionOfLand) === null || _item$additionalDetai6 === void 0 ? void 0 : _item$additionalDetai6.landArea) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai7 = item.additionalDetails) === null || _item$additionalDetai7 === void 0 ? void 0 : (_item$additionalDetai8 = _item$additionalDetai7.descriptionOfLand) === null || _item$additionalDetai8 === void 0 ? void 0 : _item$additionalDetai8.plotAreaDoc) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai9 = item.additionalDetails) === null || _item$additionalDetai9 === void 0 ? void 0 : (_item$additionalDetai10 = _item$additionalDetai9.descriptionOfLand) === null || _item$additionalDetai10 === void 0 ? void 0 : _item$additionalDetai10.plotArea) || "-";
  };
  const getSchemeName = item => {
    var _item$businessObject23, _item$businessObject24, _item$businessObject25, _item$businessObject26, _item$businessObject27, _item$businessObject28, _item$businessObject29, _item$businessObject30, _item$additionalDetai11, _item$additionalDetai12, _item$additionalDetai13, _item$descriptionOfLa2;
    return (item === null || item === void 0 ? void 0 : (_item$businessObject23 = item.businessObject) === null || _item$businessObject23 === void 0 ? void 0 : _item$businessObject23.schemeName) || (item === null || item === void 0 ? void 0 : (_item$businessObject24 = item.businessObject) === null || _item$businessObject24 === void 0 ? void 0 : (_item$businessObject25 = _item$businessObject24.additionalDetails) === null || _item$businessObject25 === void 0 ? void 0 : _item$businessObject25.schemeName) || (item === null || item === void 0 ? void 0 : (_item$businessObject26 = item.businessObject) === null || _item$businessObject26 === void 0 ? void 0 : (_item$businessObject27 = _item$businessObject26.additionalDetails) === null || _item$businessObject27 === void 0 ? void 0 : (_item$businessObject28 = _item$businessObject27.descriptionOfLand) === null || _item$businessObject28 === void 0 ? void 0 : _item$businessObject28.schemeName) || (item === null || item === void 0 ? void 0 : (_item$businessObject29 = item.businessObject) === null || _item$businessObject29 === void 0 ? void 0 : (_item$businessObject30 = _item$businessObject29.descriptionOfLand) === null || _item$businessObject30 === void 0 ? void 0 : _item$businessObject30.schemeName) || (item === null || item === void 0 ? void 0 : item.schemeName) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai11 = item.additionalDetails) === null || _item$additionalDetai11 === void 0 ? void 0 : _item$additionalDetai11.schemeName) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai12 = item.additionalDetails) === null || _item$additionalDetai12 === void 0 ? void 0 : (_item$additionalDetai13 = _item$additionalDetai12.descriptionOfLand) === null || _item$additionalDetai13 === void 0 ? void 0 : _item$additionalDetai13.schemeName) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa2 = item.descriptionOfLand) === null || _item$descriptionOfLa2 === void 0 ? void 0 : _item$descriptionOfLa2.schemeName) || "-";
  };
  const getPlotNo = item => {
    var _item$businessObject31, _item$businessObject32, _item$businessObject33, _item$businessObject34, _item$businessObject35, _item$businessObject36, _item$businessObject37, _item$businessObject38, _item$additionalDetai14, _item$additionalDetai15, _item$additionalDetai16, _item$descriptionOfLa3;
    return (item === null || item === void 0 ? void 0 : (_item$businessObject31 = item.businessObject) === null || _item$businessObject31 === void 0 ? void 0 : _item$businessObject31.plotNo) || (item === null || item === void 0 ? void 0 : (_item$businessObject32 = item.businessObject) === null || _item$businessObject32 === void 0 ? void 0 : (_item$businessObject33 = _item$businessObject32.additionalDetails) === null || _item$businessObject33 === void 0 ? void 0 : _item$businessObject33.plotNo) || (item === null || item === void 0 ? void 0 : (_item$businessObject34 = item.businessObject) === null || _item$businessObject34 === void 0 ? void 0 : (_item$businessObject35 = _item$businessObject34.additionalDetails) === null || _item$businessObject35 === void 0 ? void 0 : (_item$businessObject36 = _item$businessObject35.descriptionOfLand) === null || _item$businessObject36 === void 0 ? void 0 : _item$businessObject36.plotNo) || (item === null || item === void 0 ? void 0 : (_item$businessObject37 = item.businessObject) === null || _item$businessObject37 === void 0 ? void 0 : (_item$businessObject38 = _item$businessObject37.descriptionOfLand) === null || _item$businessObject38 === void 0 ? void 0 : _item$businessObject38.plotNo) || (item === null || item === void 0 ? void 0 : item.plotNo) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai14 = item.additionalDetails) === null || _item$additionalDetai14 === void 0 ? void 0 : _item$additionalDetai14.plotNo) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai15 = item.additionalDetails) === null || _item$additionalDetai15 === void 0 ? void 0 : (_item$additionalDetai16 = _item$additionalDetai15.descriptionOfLand) === null || _item$additionalDetai16 === void 0 ? void 0 : _item$additionalDetai16.plotNo) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa3 = item.descriptionOfLand) === null || _item$descriptionOfLa3 === void 0 ? void 0 : _item$descriptionOfLa3.plotNo) || "-";
  };
  const getApprovalLetterId = item => {
    var _item$additionalDetai17, _item$businessObject39, _item$businessObject40, _item$businessObject41, _item$additionalDetai18, _item$businessObject42, _item$businessObject43, _item$businessObject44, _item$additionalDetai19, _item$additionalDetai20;
    const raw = (item === null || item === void 0 ? void 0 : item.approvalLetterId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai17 = item.additionalDetails) === null || _item$additionalDetai17 === void 0 ? void 0 : _item$additionalDetai17.approvalLetterId) || (item === null || item === void 0 ? void 0 : (_item$businessObject39 = item.businessObject) === null || _item$businessObject39 === void 0 ? void 0 : _item$businessObject39.approvalLetterId) || (item === null || item === void 0 ? void 0 : (_item$businessObject40 = item.businessObject) === null || _item$businessObject40 === void 0 ? void 0 : (_item$businessObject41 = _item$businessObject40.additionalDetails) === null || _item$businessObject41 === void 0 ? void 0 : _item$businessObject41.approvalLetterId) || (item === null || item === void 0 ? void 0 : item.approvalCertificateId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai18 = item.additionalDetails) === null || _item$additionalDetai18 === void 0 ? void 0 : _item$additionalDetai18.approvalCertificateId) || (item === null || item === void 0 ? void 0 : (_item$businessObject42 = item.businessObject) === null || _item$businessObject42 === void 0 ? void 0 : _item$businessObject42.approvalCertificateId) || (item === null || item === void 0 ? void 0 : (_item$businessObject43 = item.businessObject) === null || _item$businessObject43 === void 0 ? void 0 : (_item$businessObject44 = _item$businessObject43.additionalDetails) === null || _item$businessObject44 === void 0 ? void 0 : _item$businessObject44.approvalCertificateId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai19 = item.additionalDetails) === null || _item$additionalDetai19 === void 0 ? void 0 : _item$additionalDetai19.approvalCertificateUrl) || (item === null || item === void 0 ? void 0 : item.approvalCertificateUrl) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai20 = item.additionalDetails) === null || _item$additionalDetai20 === void 0 ? void 0 : _item$additionalDetai20.approvalLetterUrl) || (item === null || item === void 0 ? void 0 : item.approvalLetterUrl);
    if (!raw) return null;
    if (typeof raw === "string" && raw.trim() !== "") {
      return raw.trim();
    }
    if (typeof raw === "object") {
      const keys = Object.keys(raw);
      if (keys.length > 0) {
        const latestKey = keys.sort().at(-1);
        return raw[latestKey];
      }
    }
    return null;
  };
  function getApprovalLetter(item) {
    const fileStoreId = getApprovalLetterId(item);
    if (!fileStoreId) return;
    if (typeof fileStoreId === "string" && (fileStoreId.startsWith("http://") || fileStoreId.startsWith("https://"))) {
      window.open(fileStoreId, "_blank");
      return;
    }
    getDocumentByFileStoreId(fileStoreId, setLetterLoader);
  }
  const getProvisionalApprovalLetterId = item => {
    var _item$additionalDetai21, _item$businessObject45, _item$businessObject46, _item$businessObject47, _item$additionalDetai22, _item$businessObject48, _item$businessObject49, _item$businessObject50;
    const raw = (item === null || item === void 0 ? void 0 : item.provisionalApprovalLetterId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai21 = item.additionalDetails) === null || _item$additionalDetai21 === void 0 ? void 0 : _item$additionalDetai21.provisionalApprovalLetterId) || (item === null || item === void 0 ? void 0 : (_item$businessObject45 = item.businessObject) === null || _item$businessObject45 === void 0 ? void 0 : _item$businessObject45.provisionalApprovalLetterId) || (item === null || item === void 0 ? void 0 : (_item$businessObject46 = item.businessObject) === null || _item$businessObject46 === void 0 ? void 0 : (_item$businessObject47 = _item$businessObject46.additionalDetails) === null || _item$businessObject47 === void 0 ? void 0 : _item$businessObject47.provisionalApprovalLetterId) || (item === null || item === void 0 ? void 0 : item.provisionalApprovalLetterUrl) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai22 = item.additionalDetails) === null || _item$additionalDetai22 === void 0 ? void 0 : _item$additionalDetai22.provisionalApprovalLetterUrl) || (item === null || item === void 0 ? void 0 : (_item$businessObject48 = item.businessObject) === null || _item$businessObject48 === void 0 ? void 0 : _item$businessObject48.provisionalApprovalLetterUrl) || (item === null || item === void 0 ? void 0 : (_item$businessObject49 = item.businessObject) === null || _item$businessObject49 === void 0 ? void 0 : (_item$businessObject50 = _item$businessObject49.additionalDetails) === null || _item$businessObject50 === void 0 ? void 0 : _item$businessObject50.provisionalApprovalLetterUrl);
    if (!raw) return null;
    if (typeof raw === "string" && raw.trim() !== "") {
      return raw.trim();
    }
    if (typeof raw === "object") {
      const keys = Object.keys(raw);
      if (keys.length > 0) {
        const latestKey = keys.sort().at(-1);
        return raw[latestKey];
      }
    }
    return null;
  };
  const handleProvisionalApprovalLetter = item => {
    const fileStoreId = getProvisionalApprovalLetterId(item);
    if (!fileStoreId) return;
    if (typeof fileStoreId === "string" && (fileStoreId.startsWith("http://") || fileStoreId.startsWith("https://"))) {
      window.open(fileStoreId, "_blank");
      return;
    }
    getDocumentByFileStoreId(fileStoreId, setLetterLoader);
  };
  const [filters, setFilters] = useState({
    name: "",
    applicationNo: "",
    status: "",
    serviceType: "",
    proposedActivity: "",
    plotArea: "",
    schemeName: "",
    plotNo: "",
    date: ""
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "applicationNo", "name", "serviceType", "proposedActivity", "plotArea", "schemeName", "plotNo", "status", "applicationDate", "provisionalApprovalLetter", "approvalLetter"]);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    exportValue: item => {
      var _item$additionalDetai23;
      return (item === null || item === void 0 ? void 0 : (_item$additionalDetai23 = item.additionalDetails) === null || _item$additionalDetai23 === void 0 ? void 0 : _item$additionalDetai23.applicationNo) || "-";
    },
    render: item => {
      var _item$additionalDetai24;
      return /*#__PURE__*/React__default.createElement("strong", {
        onClick: e => {
          handleTakeAction(item === null || item === void 0 ? void 0 : item.additionalDetails);
        },
        style: {
          color: "blue",
          textDecoration: "none",
          cursor: "pointer"
        }
      }, (item === null || item === void 0 ? void 0 : (_item$additionalDetai24 = item.additionalDetails) === null || _item$additionalDetai24 === void 0 ? void 0 : _item$additionalDetai24.applicationNo) || "-");
    }
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    render: item => {
      var _item$additionalDetai25, _item$additionalDetai26, _item$additionalDetai27, _item$additionalDetai28;
      console.log("123456", item);
      return (item === null || item === void 0 ? void 0 : (_item$additionalDetai25 = item.additionalDetails) === null || _item$additionalDetai25 === void 0 ? void 0 : (_item$additionalDetai26 = _item$additionalDetai25.landInfo) === null || _item$additionalDetai26 === void 0 ? void 0 : (_item$additionalDetai27 = _item$additionalDetai26.owners) === null || _item$additionalDetai27 === void 0 ? void 0 : (_item$additionalDetai28 = _item$additionalDetai27[0]) === null || _item$additionalDetai28 === void 0 ? void 0 : _item$additionalDetai28.name) || "-";
    }
  }, {
    id: "serviceType",
    label: "Service Type",
    filterable: true,
    render: item => {
      var _item$additionalDetai29;
      return t(`${item === null || item === void 0 ? void 0 : (_item$additionalDetai29 = item.additionalDetails) === null || _item$additionalDetai29 === void 0 ? void 0 : _item$additionalDetai29.applicationType}`) || "-";
    }
  }, {
    id: "proposedActivity",
    label: "Proposed Activity",
    filterable: true,
    render: item => getProposedActivity(item)
  }, {
    id: "plotArea",
    label: "Plot Area",
    filterable: true,
    render: item => getPlotArea(item)
  }, {
    id: "schemeName",
    label: "Scheme Name",
    filterable: true,
    render: item => getSchemeName(item)
  }, {
    id: "plotNo",
    label: "Plot No",
    filterable: true,
    render: item => getPlotNo(item)
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    render: item => t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-"
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    render: item => {
      var _item$additionalDetai30, _item$additionalDetai31;
      return convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$additionalDetai30 = item.additionalDetails) === null || _item$additionalDetai30 === void 0 ? void 0 : (_item$additionalDetai31 = _item$additionalDetai30.auditDetails) === null || _item$additionalDetai31 === void 0 ? void 0 : _item$additionalDetai31.createdTime) || "-";
    }
  }, {
    id: "provisionalApprovalLetter",
    label: "Provisional Approval Letter",
    filterable: false,
    sortable: false,
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-provisional"
    }, Boolean(getProvisionalApprovalLetterId(item)) && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => handleProvisionalApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))),
    width: "10%"
  }, {
    id: "approvalLetter",
    label: "Approval Certificate",
    filterable: false,
    sortable: false,
    render: item => {
      var _item$additionalDetai32;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-approval"
      }, ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC" || (item === null || item === void 0 ? void 0 : item.status) === "APPROVED_JE" || Boolean((item === null || item === void 0 ? void 0 : item.approvalLetterId) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai32 = item.additionalDetails) === null || _item$additionalDetai32 === void 0 ? void 0 : _item$additionalDetai32.approvalLetterId))) && Boolean(getApprovalLetterId(item)) && /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => getApprovalLetter(item)
      }, /*#__PURE__*/React__default.createElement("span", null, "View")));
    },
    width: "10%"
  }];
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const getFilteredAndSortedData = () => {
    let filteredData = ApplicationData || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(({
        additionalDetails,
        status
      }) => {
        var _additionalDetails$la, _additionalDetails$la2, _additionalDetails$la3, _additionalDetails$au;
        const item = {
          additionalDetails,
          status
        };
        return matchesSearch(additionalDetails === null || additionalDetails === void 0 ? void 0 : (_additionalDetails$la = additionalDetails.landInfo) === null || _additionalDetails$la === void 0 ? void 0 : (_additionalDetails$la2 = _additionalDetails$la.owners) === null || _additionalDetails$la2 === void 0 ? void 0 : (_additionalDetails$la3 = _additionalDetails$la2[0]) === null || _additionalDetails$la3 === void 0 ? void 0 : _additionalDetails$la3.name, globalSearch) || matchesSearch(additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.applicationNo, globalSearch) || matchesSearch(t(`${additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.applicationType}`), globalSearch) || matchesSearch(t(`WF_BPA_MAP_${status}`), globalSearch) || matchesSearch(convertEpochToDateDMY(additionalDetails === null || additionalDetails === void 0 ? void 0 : (_additionalDetails$au = additionalDetails.auditDetails) === null || _additionalDetails$au === void 0 ? void 0 : _additionalDetails$au.createdTime), globalSearch) || matchesSearch(getProposedActivity(item), globalSearch) || matchesSearch(getPlotArea(item), globalSearch) || matchesSearch(getSchemeName(item), globalSearch) || matchesSearch(getPlotNo(item), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(({
        additionalDetails
      }) => {
        var _additionalDetails$la4, _additionalDetails$la5, _additionalDetails$la6;
        return matchesSearch(additionalDetails === null || additionalDetails === void 0 ? void 0 : (_additionalDetails$la4 = additionalDetails.landInfo) === null || _additionalDetails$la4 === void 0 ? void 0 : (_additionalDetails$la5 = _additionalDetails$la4.owners) === null || _additionalDetails$la5 === void 0 ? void 0 : (_additionalDetails$la6 = _additionalDetails$la5[0]) === null || _additionalDetails$la6 === void 0 ? void 0 : _additionalDetails$la6.name, filters.name);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(({
        additionalDetails
      }) => matchesSearch(additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.applicationNo, filters.applicationNo));
    }
    if (filters.proposedActivity) {
      filteredData = filteredData.filter(item => matchesSearch(getProposedActivity(item), filters.proposedActivity));
    }
    if (filters.plotArea) {
      filteredData = filteredData.filter(item => matchesSearch(getPlotArea(item), filters.plotArea));
    }
    if (filters.schemeName) {
      filteredData = filteredData.filter(item => matchesSearch(getSchemeName(item), filters.schemeName));
    }
    if (filters.plotNo) {
      filteredData = filteredData.filter(item => matchesSearch(getPlotNo(item), filters.plotNo));
    }
    if (filters.serviceType) {
      filteredData = filteredData.filter(({
        additionalDetails
      }) => matchesSearch(t(`${additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.applicationType}`), filters.serviceType));
    }
    if (filters.status) {
      filteredData = filteredData.filter(({
        status
      }) => matchesSearch(t(`WF_BPA_MAP_${status}`), filters.status));
    }
    filteredData.sort((a, b) => {
      var _a$auditDetails, _b$auditDetails;
      let comparison = 0;
      const aValue = orderBy === "applicationDate" ? a === null || a === void 0 ? void 0 : (_a$auditDetails = a.auditDetails) === null || _a$auditDetails === void 0 ? void 0 : _a$auditDetails.createdTime : orderBy === "applicationNo" ? a === null || a === void 0 ? void 0 : a.applicationNo : orderBy === "status" ? a === null || a === void 0 ? void 0 : a.status : "";
      const bValue = orderBy === "applicationDate" ? b === null || b === void 0 ? void 0 : (_b$auditDetails = b.auditDetails) === null || _b$auditDetails === void 0 ? void 0 : _b$auditDetails.createdTime : orderBy === "applicationNo" ? b === null || b === void 0 ? void 0 : b.applicationNo : orderBy === "status" ? b === null || b === void 0 ? void 0 : b.status : "";
      if (aValue > bValue) {
        comparison = 1;
      } else if (aValue < bValue) {
        comparison = -1;
      }
      return order === "desc" ? -comparison : comparison;
    });
    return filteredData;
  };
  const filteredAndSortedData = getFilteredAndSortedData();
  const paginatedData = filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleExcelDownload = () => {
    const exportData = filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.map((app, idx) => {
      const row = {};
      allColumns.forEach(col => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "Exported Data");
  };
  if (isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, letterLoader && /*#__PURE__*/React__default.createElement(Loader, null), /*#__PURE__*/React__default.createElement(TableContainer$3, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-global-search"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField$1, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleExcelDownload,
    title: "Export to Excel",
    style: {
      height: "35px",
      padding: "5px 0px",
      marginRight: "8px"
    },
    disabled: (filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.length) === 0
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    style: {
      fontSize: "20px",
      color: "rgb(85 108 214)"
    }
  })))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$5, {
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("th", {
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField$1, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement(TableBody$3, null, isLoading ? /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell$3, {
    colSpan: columns.length,
    align: "center"
  }, "Loading...")) : paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell$3, {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$4, {
    hover: true,
    key: index
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$3, {
    key: `${index}-${column.id}`
  }, column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item)))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: (ApplicationData === null || ApplicationData === void 0 ? void 0 : ApplicationData.length) || 0,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50]
  }), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => setSmShow(false)
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: SmShowFAR,
    onClose: () => setSmShowFAR(false)
  }, /*#__PURE__*/React__default.createElement(Summary, {
    id: idData
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => setSmShowMs(false)
  }, /*#__PURE__*/React__default.createElement(SearchSummary, {
    id: idData
  }), " "));
};

const useStyles$6 = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableHeader: {
    backgroundColor: "#225785",
    borderBottom: "2px solid #ddd"
  },
  tableCell: {
    textAlign: "center",
    padding: "10px 15px",
    fontWeight: "bold",
    borderRight: "1px solid #ddd"
  },
  lastTableCell: {
    borderRight: "none"
  },
  whiteText: {
    color: "#ffffff"
  }
});
const PREDEFINED_ROLES = [{
  label: "Architect",
  value: "Architect"
}, {
  label: "Structural Engineer",
  value: "Structural Engineer"
}, {
  label: "Graduate Civil Engineer",
  value: "Graduate Civil Engineer"
}, {
  label: "Supervisor",
  value: "Supervisor"
}, {
  label: "Town Planner",
  value: "Town Planner"
}, {
  label: "Landscape Architect",
  value: "Landscape Architect"
}, {
  label: "Urban Designer",
  value: "Urban Designer"
}, {
  label: "Engineers for Utility Services",
  value: "Engineers for Utility Services"
}];
const getItemRole = item => {
  var _item$additionalDetai, _item$additionalDetai2, _item$additionalDetai3, _item$additionalDetai4, _item$additionalDetai5, _item$additionalDetai6, _item$additionalDetai7, _item$tradeLicenseDet, _item$tradeLicenseDet2, _item$tradeLicenseDet3, _item$tradeLicenseDet4, _item$tradeLicenseDet5;
  return (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.registrationType) || (item === null || item === void 0 ? void 0 : item.registrationType) || (item === null || item === void 0 ? void 0 : item.role) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : (_item$additionalDetai3 = _item$additionalDetai2.tradeLicenseDetail) === null || _item$additionalDetai3 === void 0 ? void 0 : (_item$additionalDetai4 = _item$additionalDetai3.tradeUnits) === null || _item$additionalDetai4 === void 0 ? void 0 : (_item$additionalDetai5 = _item$additionalDetai4[0]) === null || _item$additionalDetai5 === void 0 ? void 0 : (_item$additionalDetai6 = _item$additionalDetai5.tradeType) === null || _item$additionalDetai6 === void 0 ? void 0 : (_item$additionalDetai7 = _item$additionalDetai6.split(".")) === null || _item$additionalDetai7 === void 0 ? void 0 : _item$additionalDetai7[0]) || (item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet = item.tradeLicenseDetail) === null || _item$tradeLicenseDet === void 0 ? void 0 : (_item$tradeLicenseDet2 = _item$tradeLicenseDet.tradeUnits) === null || _item$tradeLicenseDet2 === void 0 ? void 0 : (_item$tradeLicenseDet3 = _item$tradeLicenseDet2[0]) === null || _item$tradeLicenseDet3 === void 0 ? void 0 : (_item$tradeLicenseDet4 = _item$tradeLicenseDet3.tradeType) === null || _item$tradeLicenseDet4 === void 0 ? void 0 : (_item$tradeLicenseDet5 = _item$tradeLicenseDet4.split(".")) === null || _item$tradeLicenseDet5 === void 0 ? void 0 : _item$tradeLicenseDet5[0]) || "";
};
const matchesRole = (itemRole, targetRole) => {
  if (!itemRole || !targetRole) return false;
  const cleanItem = String(itemRole).trim().toLowerCase();
  const cleanTarget = String(targetRole).trim().toLowerCase();
  if (cleanItem === cleanTarget) return true;
  if (cleanItem.split(".")[0].trim() === cleanTarget) return true;
  return false;
};
const matchesSearch = (value, search) => {
  if (!value) return false;
  return value.toString().toLowerCase().includes(search.toLowerCase());
};
const InboxTableLTR = ({
  scrutinyDetails
}) => {
  const classes = useStyles$6();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const {
    officerRole
  } = useSelector(state => state.empInbox || {});
  const user = Digit.UserService.getUser();
  const isNodalOfficerAwas = useMemo(() => {
    var _user$info;
    const rolesFromRedux = officerRole || [];
    const rolesFromUser = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.roles) || [];
    const allRoles = [...rolesFromRedux, ...rolesFromUser];
    return allRoles.some(role => (role === null || role === void 0 ? void 0 : role.code) === "NODAL_OFFICER_AWAS" || (role === null || role === void 0 ? void 0 : role.code) === "Nodal Officer" || (role === null || role === void 0 ? void 0 : role.name) === "Nodal Officer AWAS Bandhu" || typeof (role === null || role === void 0 ? void 0 : role.name) === "string" && role.name.toLowerCase().includes("nodal officer awas"));
  }, [officerRole, user]);
  const [smShow, setSmShow] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [selectedRole, setSelectedRole] = useState("");
  const [filters, setFilters] = useState({
    name: "",
    emailId: "",
    applicationNumber: "",
    status: "",
    applicationDate: "",
    role: ""
  });
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "emailId", "applicationNumber", "role", "applicationDate", "status", "paymentReceipt", "approvalLetter"]);
  const roleTabsData = useMemo(() => {
    const tabs = [...PREDEFINED_ROLES];
    const knownValues = new Set(PREDEFINED_ROLES.map(r => r.value.toLowerCase()));
    const rawList = (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.ApplicationData) || [];
    rawList.forEach(item => {
      const role = getItemRole(item);
      if (role && role !== "-" && role !== "N/A") {
        const normalized = role.split(".")[0].trim();
        if (normalized && !knownValues.has(normalized.toLowerCase())) {
          knownValues.add(normalized.toLowerCase());
          tabs.push({
            label: normalized,
            value: normalized
          });
        }
      }
    });
    return tabs;
  }, [scrutinyDetails]);
  const handleTakeAction = item => {
    console.log("itemFromTakeAction", item, item === null || item === void 0 ? void 0 : item.businessService);
    switch (item === null || item === void 0 ? void 0 : item.businessService) {
      case "BPAREG":
        history.push(`/digit-ui/employee/obps/professional/${item === null || item === void 0 ? void 0 : item.applicationNumber}`);
        break;
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
        break;
      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationNo}`);
        break;
      default:
        history.push(`/digit-ui/employee/obps/professional/${item === null || item === void 0 ? void 0 : item.applicationNumber}`);
        break;
    }
  };
  function getApprovalLetter(item) {
    var _item$additionalDetai8;
    const pdfUrl = item === null || item === void 0 ? void 0 : (_item$additionalDetai8 = item.additionalDetails) === null || _item$additionalDetai8 === void 0 ? void 0 : _item$additionalDetai8.approvalLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  const allColumns = [{
    id: "srNo",
    label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
    filterable: false,
    sortable: false,
    render: (item, index) => /*#__PURE__*/React__default.createElement(TableCell$3, null, page * rowsPerPage + index + 1)
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$additionalDetai9, _item$additionalDetai10, _item$additionalDetai11, _item$additionalDetai12;
      return /*#__PURE__*/React__default.createElement(TableCell$3, null, (item === null || item === void 0 ? void 0 : (_item$additionalDetai9 = item.additionalDetails) === null || _item$additionalDetai9 === void 0 ? void 0 : (_item$additionalDetai10 = _item$additionalDetai9.tradeLicenseDetail) === null || _item$additionalDetai10 === void 0 ? void 0 : (_item$additionalDetai11 = _item$additionalDetai10.owners) === null || _item$additionalDetai11 === void 0 ? void 0 : (_item$additionalDetai12 = _item$additionalDetai11[0]) === null || _item$additionalDetai12 === void 0 ? void 0 : _item$additionalDetai12.name) || (item === null || item === void 0 ? void 0 : item.name) || "-");
    }
  }, {
    id: "emailId",
    label: "Email",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$additionalDetai13, _item$additionalDetai14, _item$additionalDetai15, _item$additionalDetai16;
      return /*#__PURE__*/React__default.createElement(TableCell$3, null, (item === null || item === void 0 ? void 0 : (_item$additionalDetai13 = item.additionalDetails) === null || _item$additionalDetai13 === void 0 ? void 0 : (_item$additionalDetai14 = _item$additionalDetai13.tradeLicenseDetail) === null || _item$additionalDetai14 === void 0 ? void 0 : (_item$additionalDetai15 = _item$additionalDetai14.owners) === null || _item$additionalDetai15 === void 0 ? void 0 : (_item$additionalDetai16 = _item$additionalDetai15[0]) === null || _item$additionalDetai16 === void 0 ? void 0 : _item$additionalDetai16.emailId) || (item === null || item === void 0 ? void 0 : item.emailId) || "-");
    }
  }, {
    id: "applicationNumber",
    label: "Application/Ref.No",
    filterable: true,
    sortable: true,
    render: item => /*#__PURE__*/React__default.createElement(TableCell$3, null, /*#__PURE__*/React__default.createElement("strong", {
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      },
      onClick: () => handleTakeAction(item)
    }, (item === null || item === void 0 ? void 0 : item.applicationNumber) || "-"))
  }, {
    id: "role",
    label: t("FASTPAS.GLOBAL.USER.ROLE") || "Role",
    filterable: true,
    sortable: true,
    render: item => /*#__PURE__*/React__default.createElement(TableCell$3, null, getItemRole(item) || "-"),
    width: "10%"
  }, {
    id: "applicationDate",
    label: "Applied On",
    filterable: false,
    sortable: true,
    render: item => {
      var _item$additionalDetai17, _item$additionalDetai18;
      return /*#__PURE__*/React__default.createElement(TableCell$3, null, convertEpochToDate(item === null || item === void 0 ? void 0 : (_item$additionalDetai17 = item.additionalDetails) === null || _item$additionalDetai17 === void 0 ? void 0 : (_item$additionalDetai18 = _item$additionalDetai17.auditDetails) === null || _item$additionalDetai18 === void 0 ? void 0 : _item$additionalDetai18.createdTime) || "-");
    }
  }, {
    id: "status",
    label: "Pending Status",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$additionalDetai19;
      return /*#__PURE__*/React__default.createElement(TableCell$3, null, t(`WF_BPA_MAP_${(item === null || item === void 0 ? void 0 : (_item$additionalDetai19 = item.additionalDetails) === null || _item$additionalDetai19 === void 0 ? void 0 : _item$additionalDetai19.status) || (item === null || item === void 0 ? void 0 : item.status)}`) || "-");
    }
  }, {
    id: "paymentReceipt",
    label: t("FASTPAS.GLOBAL.PAYMENT.RECIEPT.TEXT"),
    filterable: false,
    sortable: false,
    render: item => {
      var _item$additionalDetai20;
      return /*#__PURE__*/React__default.createElement("td", {
        className: "td-receipt"
      }, (item === null || item === void 0 ? void 0 : (_item$additionalDetai20 = item.additionalDetails) === null || _item$additionalDetai20 === void 0 ? void 0 : _item$additionalDetai20.registrationType) !== "Architect" && ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_ND_OFF_AWAS" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_NODAL") ? /*#__PURE__*/React__default.createElement(Button$2, {
        size: "small",
        className: "btn-table-action",
        variant: "contained",
        color: "primary",
        onClick: () => {
          history.push({
            pathname: `/digit-ui/citizen/obps/tradelicence/payment/${item === null || item === void 0 ? void 0 : item.applicationNumber}/up`
          });
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Receipt")) : "N/A");
    },
    width: "10%"
  }, {
    id: "approvalLetter",
    label: t("FASTPAS.GLOBAL.APPROVAL.LETTER"),
    filterable: false,
    sortable: false,
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-approval"
    }, ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC") && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, "View"))),
    width: "10%"
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const getFilteredData = () => {
    let filteredData = (scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.ApplicationData) || [];
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        var _item$additionalDetai21, _item$additionalDetai22, _item$additionalDetai23, _item$additionalDetai24, _item$additionalDetai25, _item$additionalDetai26, _item$additionalDetai27, _item$additionalDetai28, _item$additionalDetai29, _item$additionalDetai30, _item$additionalDetai31;
        return matchesSearch(item === null || item === void 0 ? void 0 : item.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$additionalDetai21 = item.additionalDetails) === null || _item$additionalDetai21 === void 0 ? void 0 : (_item$additionalDetai22 = _item$additionalDetai21.tradeLicenseDetail) === null || _item$additionalDetai22 === void 0 ? void 0 : (_item$additionalDetai23 = _item$additionalDetai22.owners) === null || _item$additionalDetai23 === void 0 ? void 0 : (_item$additionalDetai24 = _item$additionalDetai23[0]) === null || _item$additionalDetai24 === void 0 ? void 0 : _item$additionalDetai24.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$additionalDetai25 = item.additionalDetails) === null || _item$additionalDetai25 === void 0 ? void 0 : (_item$additionalDetai26 = _item$additionalDetai25.landInfo) === null || _item$additionalDetai26 === void 0 ? void 0 : (_item$additionalDetai27 = _item$additionalDetai26.owners) === null || _item$additionalDetai27 === void 0 ? void 0 : (_item$additionalDetai28 = _item$additionalDetai27[0]) === null || _item$additionalDetai28 === void 0 ? void 0 : _item$additionalDetai28.emailId, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNumber, globalSearch) || matchesSearch(getItemRole(item), globalSearch) || matchesSearch(t(`WF_BPA_MAP_${(item === null || item === void 0 ? void 0 : (_item$additionalDetai29 = item.additionalDetails) === null || _item$additionalDetai29 === void 0 ? void 0 : _item$additionalDetai29.status) || (item === null || item === void 0 ? void 0 : item.status)}`), globalSearch) || matchesSearch(convertEpochToDate(item === null || item === void 0 ? void 0 : (_item$additionalDetai30 = item.additionalDetails) === null || _item$additionalDetai30 === void 0 ? void 0 : (_item$additionalDetai31 = _item$additionalDetai30.auditDetails) === null || _item$additionalDetai31 === void 0 ? void 0 : _item$additionalDetai31.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$additionalDetai32, _item$additionalDetai33, _item$additionalDetai34, _item$additionalDetai35;
        return matchesSearch((item === null || item === void 0 ? void 0 : (_item$additionalDetai32 = item.additionalDetails) === null || _item$additionalDetai32 === void 0 ? void 0 : (_item$additionalDetai33 = _item$additionalDetai32.tradeLicenseDetail) === null || _item$additionalDetai33 === void 0 ? void 0 : (_item$additionalDetai34 = _item$additionalDetai33.owners) === null || _item$additionalDetai34 === void 0 ? void 0 : (_item$additionalDetai35 = _item$additionalDetai34[0]) === null || _item$additionalDetai35 === void 0 ? void 0 : _item$additionalDetai35.name) || (item === null || item === void 0 ? void 0 : item.name), filters.name);
      });
    }
    if (filters.emailId) {
      filteredData = filteredData.filter(item => {
        var _item$additionalDetai36, _item$additionalDetai37, _item$additionalDetai38, _item$additionalDetai39;
        return matchesSearch((item === null || item === void 0 ? void 0 : (_item$additionalDetai36 = item.additionalDetails) === null || _item$additionalDetai36 === void 0 ? void 0 : (_item$additionalDetai37 = _item$additionalDetai36.tradeLicenseDetail) === null || _item$additionalDetai37 === void 0 ? void 0 : (_item$additionalDetai38 = _item$additionalDetai37.owners) === null || _item$additionalDetai38 === void 0 ? void 0 : (_item$additionalDetai39 = _item$additionalDetai38[0]) === null || _item$additionalDetai39 === void 0 ? void 0 : _item$additionalDetai39.emailId) || (item === null || item === void 0 ? void 0 : item.emailId), filters.emailId);
      });
    }
    if (filters.applicationNumber) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNumber, filters.applicationNumber));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => {
        var _item$additionalDetai40;
        return matchesSearch(t(`WF_BPA_MAP_${(item === null || item === void 0 ? void 0 : (_item$additionalDetai40 = item.additionalDetails) === null || _item$additionalDetai40 === void 0 ? void 0 : _item$additionalDetai40.status) || (item === null || item === void 0 ? void 0 : item.status)}`), filters.status);
      });
    }
    if (filters.role) {
      filteredData = filteredData.filter(item => matchesSearch(getItemRole(item), filters.role));
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const filterRoleData = useMemo(() => {
    const roleMap = {};
    roleTabsData.forEach(tab => {
      roleMap[tab.value] = (filteredData || []).filter(item => matchesRole(getItemRole(item), tab.value));
    });
    return roleMap;
  }, [filteredData, roleTabsData]);
  const roleFilteredData = useMemo(() => {
    if (!selectedRole) {
      return filteredData;
    }
    return filterRoleData[selectedRole] || [];
  }, [selectedRole, filterRoleData, filteredData]);
  const filteredAndSortedData = useMemo(() => {
    const sorted = [...roleFilteredData];
    sorted.sort((a, b) => {
      var _a$additionalDetails, _a$additionalDetails$, _a$additionalDetails$2, _a$additionalDetails$3, _b$additionalDetails, _b$additionalDetails$, _b$additionalDetails$2, _b$additionalDetails$3, _a$additionalDetails2, _a$additionalDetails3, _a$additionalDetails4, _a$additionalDetails5, _b$additionalDetails2, _b$additionalDetails3, _b$additionalDetails4, _b$additionalDetails5, _a$additionalDetails6, _b$additionalDetails6, _a$additionalDetails7, _a$additionalDetails8, _b$additionalDetails7, _b$additionalDetails8;
      let aValue, bValue;
      switch (orderBy) {
        case "name":
          aValue = ((a === null || a === void 0 ? void 0 : (_a$additionalDetails = a.additionalDetails) === null || _a$additionalDetails === void 0 ? void 0 : (_a$additionalDetails$ = _a$additionalDetails.tradeLicenseDetail) === null || _a$additionalDetails$ === void 0 ? void 0 : (_a$additionalDetails$2 = _a$additionalDetails$.owners) === null || _a$additionalDetails$2 === void 0 ? void 0 : (_a$additionalDetails$3 = _a$additionalDetails$2[0]) === null || _a$additionalDetails$3 === void 0 ? void 0 : _a$additionalDetails$3.name) || (a === null || a === void 0 ? void 0 : a.name) || "").toLowerCase();
          bValue = ((b === null || b === void 0 ? void 0 : (_b$additionalDetails = b.additionalDetails) === null || _b$additionalDetails === void 0 ? void 0 : (_b$additionalDetails$ = _b$additionalDetails.tradeLicenseDetail) === null || _b$additionalDetails$ === void 0 ? void 0 : (_b$additionalDetails$2 = _b$additionalDetails$.owners) === null || _b$additionalDetails$2 === void 0 ? void 0 : (_b$additionalDetails$3 = _b$additionalDetails$2[0]) === null || _b$additionalDetails$3 === void 0 ? void 0 : _b$additionalDetails$3.name) || (b === null || b === void 0 ? void 0 : b.name) || "").toLowerCase();
          break;
        case "emailId":
          aValue = ((a === null || a === void 0 ? void 0 : (_a$additionalDetails2 = a.additionalDetails) === null || _a$additionalDetails2 === void 0 ? void 0 : (_a$additionalDetails3 = _a$additionalDetails2.tradeLicenseDetail) === null || _a$additionalDetails3 === void 0 ? void 0 : (_a$additionalDetails4 = _a$additionalDetails3.owners) === null || _a$additionalDetails4 === void 0 ? void 0 : (_a$additionalDetails5 = _a$additionalDetails4[0]) === null || _a$additionalDetails5 === void 0 ? void 0 : _a$additionalDetails5.emailId) || (a === null || a === void 0 ? void 0 : a.emailId) || "").toLowerCase();
          bValue = ((b === null || b === void 0 ? void 0 : (_b$additionalDetails2 = b.additionalDetails) === null || _b$additionalDetails2 === void 0 ? void 0 : (_b$additionalDetails3 = _b$additionalDetails2.tradeLicenseDetail) === null || _b$additionalDetails3 === void 0 ? void 0 : (_b$additionalDetails4 = _b$additionalDetails3.owners) === null || _b$additionalDetails4 === void 0 ? void 0 : (_b$additionalDetails5 = _b$additionalDetails4[0]) === null || _b$additionalDetails5 === void 0 ? void 0 : _b$additionalDetails5.emailId) || (b === null || b === void 0 ? void 0 : b.emailId) || "").toLowerCase();
          break;
        case "applicationNumber":
          aValue = ((a === null || a === void 0 ? void 0 : a.applicationNumber) || "").toLowerCase();
          bValue = ((b === null || b === void 0 ? void 0 : b.applicationNumber) || "").toLowerCase();
          break;
        case "role":
          aValue = (getItemRole(a) || "").toLowerCase();
          bValue = (getItemRole(b) || "").toLowerCase();
          break;
        case "status":
          aValue = (t(`WF_BPA_MAP_${(a === null || a === void 0 ? void 0 : (_a$additionalDetails6 = a.additionalDetails) === null || _a$additionalDetails6 === void 0 ? void 0 : _a$additionalDetails6.status) || (a === null || a === void 0 ? void 0 : a.status)}`) || "").toLowerCase();
          bValue = (t(`WF_BPA_MAP_${(b === null || b === void 0 ? void 0 : (_b$additionalDetails6 = b.additionalDetails) === null || _b$additionalDetails6 === void 0 ? void 0 : _b$additionalDetails6.status) || (b === null || b === void 0 ? void 0 : b.status)}`) || "").toLowerCase();
          break;
        case "applicationDate":
          aValue = (a === null || a === void 0 ? void 0 : (_a$additionalDetails7 = a.additionalDetails) === null || _a$additionalDetails7 === void 0 ? void 0 : (_a$additionalDetails8 = _a$additionalDetails7.auditDetails) === null || _a$additionalDetails8 === void 0 ? void 0 : _a$additionalDetails8.createdTime) || 0;
          bValue = (b === null || b === void 0 ? void 0 : (_b$additionalDetails7 = b.additionalDetails) === null || _b$additionalDetails7 === void 0 ? void 0 : (_b$additionalDetails8 = _b$additionalDetails7.auditDetails) === null || _b$additionalDetails8 === void 0 ? void 0 : _b$additionalDetails8.createdTime) || 0;
          break;
        default:
          aValue = "";
          bValue = "";
      }
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    });
    return sorted;
  }, [roleFilteredData, orderBy, order, t]);
  const paginatedData = useMemo(() => {
    return filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredAndSortedData, page, rowsPerPage]);
  const handleOpenColumnFilter = event => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleExcelDownload = () => {
    const exportColumns = columns;
    const exportData = filteredAndSortedData.map((app, idx) => {
      const row = {};
      exportColumns.forEach(col => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (col.id === "name") {
          var _app$additionalDetail, _app$additionalDetail2, _app$additionalDetail3, _app$additionalDetail4;
          row[col.label] = (app === null || app === void 0 ? void 0 : (_app$additionalDetail = app.additionalDetails) === null || _app$additionalDetail === void 0 ? void 0 : (_app$additionalDetail2 = _app$additionalDetail.tradeLicenseDetail) === null || _app$additionalDetail2 === void 0 ? void 0 : (_app$additionalDetail3 = _app$additionalDetail2.owners) === null || _app$additionalDetail3 === void 0 ? void 0 : (_app$additionalDetail4 = _app$additionalDetail3[0]) === null || _app$additionalDetail4 === void 0 ? void 0 : _app$additionalDetail4.name) || (app === null || app === void 0 ? void 0 : app.name) || "-";
        } else if (col.id === "emailId") {
          var _app$additionalDetail5, _app$additionalDetail6, _app$additionalDetail7, _app$additionalDetail8;
          row[col.label] = (app === null || app === void 0 ? void 0 : (_app$additionalDetail5 = app.additionalDetails) === null || _app$additionalDetail5 === void 0 ? void 0 : (_app$additionalDetail6 = _app$additionalDetail5.tradeLicenseDetail) === null || _app$additionalDetail6 === void 0 ? void 0 : (_app$additionalDetail7 = _app$additionalDetail6.owners) === null || _app$additionalDetail7 === void 0 ? void 0 : (_app$additionalDetail8 = _app$additionalDetail7[0]) === null || _app$additionalDetail8 === void 0 ? void 0 : _app$additionalDetail8.emailId) || (app === null || app === void 0 ? void 0 : app.emailId) || "-";
        } else if (col.id === "applicationNumber") {
          row[col.label] = (app === null || app === void 0 ? void 0 : app.applicationNumber) || "-";
        } else if (col.id === "role") {
          row[col.label] = getItemRole(app) || "-";
        } else if (col.id === "applicationDate") {
          var _app$additionalDetail9, _app$additionalDetail10;
          row[col.label] = convertEpochToDate(app === null || app === void 0 ? void 0 : (_app$additionalDetail9 = app.additionalDetails) === null || _app$additionalDetail9 === void 0 ? void 0 : (_app$additionalDetail10 = _app$additionalDetail9.auditDetails) === null || _app$additionalDetail10 === void 0 ? void 0 : _app$additionalDetail10.createdTime) || "-";
        } else if (col.id === "status") {
          var _app$additionalDetail11;
          row[col.label] = t(`WF_BPA_MAP_${(app === null || app === void 0 ? void 0 : (_app$additionalDetail11 = app.additionalDetails) === null || _app$additionalDetail11 === void 0 ? void 0 : _app$additionalDetail11.status) || (app === null || app === void 0 ? void 0 : app.status)}`) || "-";
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "Licence Technical Person");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$3, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-global-search"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length === allColumns.length ? "All" : selectedColumns.length, ")", " "), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => {
      setGlobalSearch(e.target.value);
      setPage(0);
    },
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => {
          setGlobalSearch("");
          setPage(0);
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleExcelDownload,
    title: "Export to Excel",
    style: {
      height: "35px",
      padding: "5px 0px",
      marginRight: "8px",
      background: "transparent",
      border: "none",
      cursor: "pointer"
    },
    disabled: filteredAndSortedData.length === 0
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    style: {
      fontSize: "20px",
      color: "rgb(85 108 214)"
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), isNodalOfficerAwas && /*#__PURE__*/React__default.createElement("div", {
    className: "risk-type-bar",
    style: {
      display: "flex",
      gap: "8px",
      marginBottom: "8px",
      justifyContent: "left",
      overflowX: "auto",
      paddingBottom: "4px"
    }
  }, roleTabsData.map(tab => {
    var _filterRoleData$tab$v, _filterRoleData$tab$v2, _filterRoleData$tab$v3;
    return /*#__PURE__*/React__default.createElement("button", {
      key: tab.value,
      disabled: ((_filterRoleData$tab$v = filterRoleData[tab.value]) === null || _filterRoleData$tab$v === void 0 ? void 0 : _filterRoleData$tab$v.length) === 0,
      style: {
        cursor: ((_filterRoleData$tab$v2 = filterRoleData[tab.value]) === null || _filterRoleData$tab$v2 === void 0 ? void 0 : _filterRoleData$tab$v2.length) === 0 ? "not-allowed" : "pointer"
      },
      className: `risk-type-button ${selectedRole === tab.value ? "active" : ""}`,
      onClick: () => {
        setSelectedRole(prev => prev === tab.value ? "" : tab.value);
        setPage(0);
      }
    }, tab.label, " ", /*#__PURE__*/React__default.createElement("span", {
      className: "count"
    }, "(", ((_filterRoleData$tab$v3 = filterRoleData[tab.value]) === null || _filterRoleData$tab$v3 === void 0 ? void 0 : _filterRoleData$tab$v3.length) || 0, ")"));
  })), /*#__PURE__*/React__default.createElement(Table$5, {
    className: "application-table",
    "aria-label": "applied data tabular format"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("th", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    }
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement(TableBody$3, null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell$3, {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$3, {
    key: index
  }, columns.map(column => column.render(item, index)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: filteredAndSortedData.length,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50]
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShow,
    onClose: () => setSmShow(false)
  }, /*#__PURE__*/React__default.createElement(TakeActionItem, {
    id: idData,
    formType: formType
  })), /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: smShowMs,
    onClose: () => setSmShowMs(false)
  }, /*#__PURE__*/React__default.createElement(ApplicationView12, {
    id: idData,
    formType: formType
  })));
};

const RiskTypeBar = ({
  selected,
  onSelect,
  riskCount,
  setRiskFilter
}) => {
  console.log("fromBar", riskCount);
  const handleClick = riskType => {
    setRiskFilter(riskType);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "risk-type-bar"
  }, riskCount.map(({
    action,
    count,
    riskType
  }) => /*#__PURE__*/React__default.createElement("button", {
    key: action,
    className: `risk-type-button ${selected === action ? "active" : ""}`,
    onClick: () => handleClick(riskType)
  }, action, " ", /*#__PURE__*/React__default.createElement("span", {
    className: "count"
  }, "(", count, ")"))));
};

function DashboardApplicantReport() {
  var _Digit$UserService$ge;
  const {
    formType,
    cardType,
    label
  } = useParams();
  console.log("fromParams", formType, cardType, label);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || {};
  const [scrutinyDetails, setScrutinyDetails] = useState(null);
  const [riskCount, setRiskCount] = useState([]);
  const [riskFilter, setRiskFilter] = useState("");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [loading, setLoading] = useState(false);
  const fetchData = async riskType => {
    setLoading(true);
    const filters = riskType ? {
      stateStatus: label,
      riskType,
      applicationType: formType
    } : {
      stateStatus: label,
      applicationType: formType
    };
    const result = formType === "FORM_NOC" ? await OBPSService.NOCCountApplicationData(tenantId, filters) : await OBPSService.applicationDetailDataView(tenantId, filters);
    console.log("resultFromFetchData", result);
    setScrutinyDetails(result);
    setRiskCount(result === null || result === void 0 ? void 0 : result.riskCount);
    setLoading(false);
  };
  const fetchSelfData = async () => {
    try {
      setLoading(true);
      const postData = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken: authToken,
          userInfo: userDetails,
          msgId: "1757415138608|en_IN"
        }
      };
      const res = await axios$1.post(`${Urls$1.obps.getSelfApprovalData}?tenantId=${tenantId}`, postData);
      console.log("NEW RESDATA WIRTH FORMTYPE", res.data, formType);
      if (formType === "SELF_APPROVAL") {
        var _res$data, _res$data$selfApprova;
        setScrutinyDetails((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$selfApprova = _res$data.selfApproval) === null || _res$data$selfApprova === void 0 ? void 0 : _res$data$selfApprova.details);
      } else {
        var _res$data2, _res$data2$selfCertif;
        setScrutinyDetails((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$selfCertif = _res$data2.selfCertificate) === null || _res$data2$selfCertif === void 0 ? void 0 : _res$data2$selfCertif.details);
      }
      console.log("selfData", res, res.data);
    } catch (error) {
      console.log("error in fetching self data", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchDataAppendex = async () => {
    const result = await OBPSService.fetchAppendex(tenantId, {
      stateStatus: label
    });
    setScrutinyDetails(result);
  };
  const fetchDataProfessional = async () => {
    const result = await OBPSService.fetchProfessional(tenantId, {
      stateStatus: label
    });
    setScrutinyDetails(result);
    console.log("logg22222222...?", result);
  };
  useEffect(() => {
    console.log("fromEffectTablesEmp", label, cardType, loading);
    if (cardType === "planningPermission" && formType !== "SELF_APPROVAL" && formType !== "SELF_CERTIFICATION") {
      console.log("I shouldnt be here");
      fetchData(riskFilter);
    }
    if (cardType === "appendex") {
      console.log("I shouldnt be here");
      fetchDataAppendex();
    }
    if (cardType === "professional") {
      console.log("I shouldnt be here");
      fetchDataProfessional();
    }
    if (formType === "SELF_APPROVAL" || formType === "SELF_CERTIFICATION") {
      console.log("I should be here ");
      fetchSelfData();
    }
  }, [label, riskFilter, formType, cardType]);
  if (loading) {
    console.log("cardType4444444", loading);
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      marginLeft: "1%"
    }
  }, cardType === "planningPermission" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formType !== "FORM_NOC" && /*#__PURE__*/React__default.createElement(RiskTypeBar, {
    riskCount: riskCount,
    setRiskFilter: setRiskFilter
  }), /*#__PURE__*/React__default.createElement(InboxTable, {
    ApplicationData: formType === "SELF_APPROVAL" || formType === "SELF_CERTIFICATION" ? scrutinyDetails : scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.ApplicationData,
    isLoading: loading
  })), cardType === "professional" && /*#__PURE__*/React__default.createElement(InboxTableLTR, {
    scrutinyDetails: scrutinyDetails
  }));
}

const ScheduleInspection = () => {
  var _sortParams$, _sortParams$2, _sortParams$3, _sortParams$4, _data$table2, _data$table3, _data$table4;
  const {
    control,
    handleSubmit
  } = useForm();
  const [selectedRows, setSelectedRows] = useState([]);
  const tenantId = 'hp';
  const initialStates = {};
  const {
    t
  } = useTranslation();
  const [pageOffset, setPageOffset] = useState((initialStates === null || initialStates === void 0 ? void 0 : initialStates.pageOffset) || 0);
  const [pageSize, setPageSize] = useState((initialStates === null || initialStates === void 0 ? void 0 : initialStates.pageSize) || 10);
  const [sortParams, setSortParams] = useState((initialStates === null || initialStates === void 0 ? void 0 : initialStates.sortParams) || [{
    id: "applicationDate",
    desc: false
  }]);
  const [setSearchFieldsBackToOriginalState, setSetSearchFieldsBackToOriginalState] = useState(false);
  const [searchParams, setSearchParams] = useState(() => {
    return (initialStates === null || initialStates === void 0 ? void 0 : initialStates.searchParams) || {};
  });
  let isMobile = window.Digit.Utils.browser.isMobile();
  let paginationParams = isMobile ? {
    limit: 100,
    offset: 0,
    sortBy: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$ = sortParams[0]) === null || _sortParams$ === void 0 ? void 0 : _sortParams$.id,
    sortOrder: sortParams !== null && sortParams !== void 0 && (_sortParams$2 = sortParams[0]) !== null && _sortParams$2 !== void 0 && _sortParams$2.desc ? "DESC" : "ASC"
  } : {
    limit: pageSize,
    offset: pageOffset,
    sortBy: sortParams === null || sortParams === void 0 ? void 0 : (_sortParams$3 = sortParams[0]) === null || _sortParams$3 === void 0 ? void 0 : _sortParams$3.id,
    sortOrder: sortParams !== null && sortParams !== void 0 && (_sortParams$4 = sortParams[0]) !== null && _sortParams$4 !== void 0 && _sortParams$4.desc ? "DESC" : "ASC"
  };
  const {
    isFetching,
    isLoading: hookLoading,
    searchResponseKey,
    data,
    searchFields,
    ...rest
  } = Digit.Hooks.obps.useAllformInbox({
    tenantId,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {}
  });
  useEffect(() => {
    setPageOffset(0);
  }, [searchParams]);
  const handleRowClick = row => {
    const isSelected = selectedRows.some(selectedRow => selectedRow.applicationNo === row.applicationNo);
    if (isSelected) {
      setSelectedRows(prev => prev.filter(selectedRow => selectedRow.applicationNo !== row.applicationNo));
    } else {
      setSelectedRows(prev => [...prev, row]);
    }
  };
  const handleSelectAllClick = () => {
    var _data$table;
    if (selectedRows.length === (data === null || data === void 0 ? void 0 : (_data$table = data.table) === null || _data$table === void 0 ? void 0 : _data$table.length)) {
      setSelectedRows([]);
    } else {
      setSelectedRows([...(data === null || data === void 0 ? void 0 : data.table)]);
    }
  };
  const onSubmit = async data => {
    let InspectionDetail;
    selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(detail => {
      var _data$inspectionTime, _data$inspectionTime2, _data$inspectionTime3;
      detail.inspectionTime = `${data === null || data === void 0 ? void 0 : (_data$inspectionTime = data.inspectionTime) === null || _data$inspectionTime === void 0 ? void 0 : _data$inspectionTime.$H}:${data === null || data === void 0 ? void 0 : (_data$inspectionTime2 = data.inspectionTime) === null || _data$inspectionTime2 === void 0 ? void 0 : _data$inspectionTime2.$m}:${data === null || data === void 0 ? void 0 : (_data$inspectionTime3 = data.inspectionTime) === null || _data$inspectionTime3 === void 0 ? void 0 : _data$inspectionTime3.$s}`;
      detail.inspectionDate = convertDateToEpoch$1(data === null || data === void 0 ? void 0 : data.inspectionDate);
      detail.inspectionRemark = data === null || data === void 0 ? void 0 : data.remarks;
      detail.applicationNo = detail === null || detail === void 0 ? void 0 : detail.applicationNo;
      detail.tenantId = tenantId;
    });
    InspectionDetail = selectedRows;
    const response = await OBPSService.scheduleInspection({
      InspectionDetail
    });
    if (response) {
      alert('Inspection details has been sent to applicant');
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Schedule Inspection")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      width: '90%',
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper",
    style: {
      width: '50%'
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Checkbox, {
    indeterminate: selectedRows.length > 0 && selectedRows.length <= (data === null || data === void 0 ? void 0 : (_data$table2 = data.table) === null || _data$table2 === void 0 ? void 0 : _data$table2.length),
    checked: selectedRows.length === (data === null || data === void 0 ? void 0 : (_data$table3 = data.table) === null || _data$table3 === void 0 ? void 0 : _data$table3.length),
    onChange: handleSelectAllClick
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Name & Form-No"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Application No"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Mobile No"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, data === null || data === void 0 ? void 0 : (_data$table4 = data.table) === null || _data$table4 === void 0 ? void 0 : _data$table4.map(row => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: row.applicationNo,
    onClick: () => handleRowClick(row)
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: selectedRows.some(selectedRow => (selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.applicationNo) === row.applicationNo)
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("p", null, row === null || row === void 0 ? void 0 : row.owner), /*#__PURE__*/React__default.createElement("p", null, row === null || row === void 0 ? void 0 : row.formNo)), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.applicationNo), /*#__PURE__*/React__default.createElement(TableCell$1, null, row === null || row === void 0 ? void 0 : row.mobileNumber))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Inspection Date",
    control: control,
    placeholder: "Select Date",
    name: "inspectionDate",
    type: "datePicker"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Inspection Time",
    control: control,
    placeholder: "Select Time",
    name: "inspectionTime",
    type: "timePicker"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Remarks",
    control: control,
    placeholder: "Remarks....",
    name: "remarks",
    type: "textInput",
    mandatory: true,
    multiLine: true,
    labelWidth: "70%"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer",
    style: {
      marginTop: '50px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Submit",
    type: "submit",
    onClick: handleSubmit
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  }))))));
};

const useStyles$7 = makeStyles$1({
  table: {
    minWidth: 650,
    borderCollapse: "collapse"
  },
  headerRow: {
    backgroundColor: "rgb(21 124 179)"
  },
  headerCell: {
    color: "white !important",
    fontWeight: "bold",
    fontSize: "14px"
  },
  tableRowOdd: {
    backgroundColor: "#f7f7f7"
  },
  tableRowEven: {
    backgroundColor: "#ffffff"
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#e6f4ff",
      cursor: "pointer",
      transition: "0.2s ease-in-out"
    }
  },
  tableCell: {
    borderBottom: "1px solid #ddd",
    padding: "12px 16px",
    fontSize: "12px"
  }
});

const useStyles$8 = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    padding: '6px 12px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    }
  }
}));

const useStyles$9 = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const data$1 = [{
  Sl: 1,
  Name: 'Sanket',
  FormNo: 'Appendix10',
  "Application/RefNo": 'HPBPA20241200011',
  'Application Fee': '22000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'E-Cash Payment',
  'DD/Challan Date': '2024-01-29',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 2,
  Name: 'Rahul',
  FormNo: 'Form11',
  "Application/RefNo": 'HPBPA20241200012',
  'Application Fee': '21000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'Manpura',
  'Payment Mode': 'E-Cash Payment',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 3,
  Name: 'Sakshi',
  FormNo: 'Form11',
  "Application/RefNo": 'HPBPA20241200013',
  'Application Fee': '23000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'Manpura',
  'Payment Mode': 'E-Cash Payment',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 4,
  Name: 'Rahul',
  FormNo: 'Form34',
  "Application/RefNo": 'HPBPA20241200014',
  'Application Fee': '21000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'Manpura',
  'Payment Mode': 'E-Cash Payment',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 5,
  Name: 'Sunil',
  FormNo: 'Form26',
  "Application/RefNo": 'HPBPA20241200015',
  'Application Fee': '32000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'E-Cash Payment',
  'DD/Challan Date': '2024-01-29',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 6,
  Name: 'Sunita',
  FormNo: 'Form11',
  "Application/RefNo": 'HPBPA20241200016',
  'Application Fee': '32000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'Manpura',
  'DD/Challan Date': '2024-01-29',
  'Payment Mode': 'E-Cash Payment',
  'Action': 'Approved'
}, {
  Sl: 7,
  Name: 'Aanchal',
  FormNo: 'Form11',
  "Application/RefNo": 'HPBPA20241200017',
  'Application Fee': '42000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'Manpura',
  'DD/Challan Date': '2024-01-29',
  'Payment Mode': 'E-Cash Payment',
  'Action': 'Approved'
}, {
  Sl: 8,
  Name: 'Rose',
  FormNo: 'Appendix10',
  "Application/RefNo": 'HPBPA20241200018',
  'Application Fee': '3000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'E-Cash Payment',
  'DD/Challan Date': '2024-01-29',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 9,
  Name: 'Sunita',
  FormNo: 'Form11',
  "Application/RefNo": 'HPBPA20241200019',
  'Application Fee': '4400',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'E-Cash Payment',
  'DD/Challan Date': '2024-01-29',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}, {
  Sl: 10,
  Name: 'Sunil',
  FormNo: 'Appendix10',
  "Application/RefNo": 'HPBPA20241200020',
  'Application Fee': '2000',
  'Downloads': 'View',
  'Status': 'Paid',
  'Payment Mode': 'E-Cash Payment',
  'DD/Challan Date': '2024-01-29',
  'Payment Update Date': 'Doc1, Doc2',
  'Action': 'Approved'
}];
const InboxTable$1 = ({
  apiData
}) => {
  var _apiData$Payments;
  const classes = useStyles$9();
  console.log(apiData, "aaaaaaaaa");
  return /*#__PURE__*/React__default.createElement(TableContainer$3, {
    component: Paper$3
  }, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, null, Object.keys(data$1[0]).map(heading => /*#__PURE__*/React__default.createElement(TableCell$3, {
    key: heading,
    className: classes.tableCell
  }, heading)))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData === null || apiData === void 0 ? void 0 : (_apiData$Payments = apiData.Payments) === null || _apiData$Payments === void 0 ? void 0 : _apiData$Payments.map((row, index) => {
    var _row$paymentDetails, _row$paymentDetails$, _row$paymentDetails2, _row$paymentDetails2$, _row$paymentDetails2$2, _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow$3, {
      key: row.id
    }, /*#__PURE__*/React__default.createElement(TableCell$3, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : row.payerName), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : (_row$paymentDetails = row.paymentDetails) === null || _row$paymentDetails === void 0 ? void 0 : (_row$paymentDetails$ = _row$paymentDetails[0]) === null || _row$paymentDetails$ === void 0 ? void 0 : _row$paymentDetails$.businessService), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : (_row$paymentDetails2 = row.paymentDetails) === null || _row$paymentDetails2 === void 0 ? void 0 : (_row$paymentDetails2$ = _row$paymentDetails2[0]) === null || _row$paymentDetails2$ === void 0 ? void 0 : (_row$paymentDetails2$2 = _row$paymentDetails2$.bill) === null || _row$paymentDetails2$2 === void 0 ? void 0 : _row$paymentDetails2$2.consumerCode), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : row.totalAmountPaid), /*#__PURE__*/React__default.createElement(TableCell$3, null, "View"), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : row.paymentStatus), /*#__PURE__*/React__default.createElement(TableCell$3, null, row === null || row === void 0 ? void 0 : row.paymentMode), /*#__PURE__*/React__default.createElement(TableCell$3, null, " ", convertEpochToDate(row === null || row === void 0 ? void 0 : row.transactionDate)), /*#__PURE__*/React__default.createElement(TableCell$3, null, " ", convertEpochToDate(row === null || row === void 0 ? void 0 : (_row$auditDetails = row.auditDetails) === null || _row$auditDetails === void 0 ? void 0 : _row$auditDetails.lastModifiedTime)), /*#__PURE__*/React__default.createElement(TableCell$3, null));
  }))));
};

function PaymentDetails({
  type
}) {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [apiData, setApiData] = useState(null);
  const fetchData = async params => {
    const result = await OBPSService.paymentDetailData(params);
    setApiData(result);
  };
  useEffect(async () => {
    await fetchData(tenantId);
  }, []);
  return /*#__PURE__*/React__default.createElement(InboxTable$1, {
    apiData: apiData
  });
}

const useStyles$a = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function PaymentDashboard() {
  const classes = useStyles$a();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Update Payment",
    value: "1",
    className: classes.customTab
  }))), /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(PaymentDetails, {
    type: "payment"
  }))));
}

const useStyles$b = makeStyles$1(theme => ({
  card: {
    width: '100%',
    height: 'auto',
    backgroundColor: '#f0f0f0',
    borderRadius: "10px"
  },
  strip: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '5px',
    flexWrap: 'wrap'
  },
  outerBox: {
    padding: '23px 37px 30px 14px',
    position: 'relative',
    backgroundColor: '#fff',
    overflow: 'hidden',
    width: 'calc(25% - 10px)',
    margin: '5px',
    borderRadius: '5px',
    borderLeft: '4px solid #146694',
    display: 'flex',
    alignItems: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      right: '-46px',
      width: '100px',
      height: '100px',
      background: 'linear-gradient(135deg, rgb(14 55 79 / 18%) 0%, rgb(21 108 156 / 30%) 100%)',
      borderRadius: '100%',
      bottom: '-48px'
    }
  },
  cardItemHeading: {
    fontSize: '16px'
  },
  link: {
    fontSize: '14px',
    marginTop: '6px',
    display: 'block',
    textDecoration: 'none',
    color: '#12587f',
    fontWeight: '500',
    '&:hover': {
      fontSize: '14px',
      color: '#1976d2'
    }
  },
  svgIcon: {
    fontSize: '26px',
    marginRight: '11px',
    color: '#125b83'
  }
}));
const Report = ({
  report,
  index
}) => {
  const classes = useStyles$b();
  return /*#__PURE__*/React__default.createElement(Card$1, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.strip
  }, report === null || report === void 0 ? void 0 : report.map((item, index) => /*#__PURE__*/React__default.createElement("div", {
    className: classes.outerBox
  }, /*#__PURE__*/React__default.createElement(AiFillDashboard, {
    className: classes.svgIcon
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    className: classes.cardItemHeading
  }, item.label), /*#__PURE__*/React__default.createElement(Link$1, {
    key: index,
    href: `${item.link}`,
    className: classes.link
  }, "View Report")))))));
};

function MISReport({
  tenantIdCodeOuter,
  type
}) {
  const [filteredReportArr, setFilteredReportArr] = useState([]);
  const reportArr = [[{
    label: "Summary Report",
    link: "summary-reports"
  }, {
    label: "Registration Report",
    link: "viewApplications"
  }, {
    label: "Payment Report",
    link: "payment-details-report"
  }, {
    label: "Application Report",
    link: "application-details"
  }, {
    label: "Revenue Report",
    link: "revenue-details"
  }, {
    label: "Employee Performance Report",
    link: "employee-performance-report"
  }], []];
  useEffect(() => {
    const updatedReportArr = reportArr.map(reportGroup => reportGroup.map(report => {
      if (tenantIdCodeOuter === "UD") {
        if (report.label === "Summary Report") {
          return {
            ...report,
            link: "ulb-details"
          };
        }
        if (report.label === "Proposal Wise Report") {
          return {
            ...report,
            link: "no-records"
          };
        }
        if (report.label === "Application Report") {
          return {
            ...report,
            label: "Details Application Report"
          };
        }
      }
      return report;
    }));
    setFilteredReportArr(updatedReportArr);
  }, [tenantIdCodeOuter]);
  console.log(filteredReportArr, tenantIdCodeOuter, "filteredReportArr111111111");
  return /*#__PURE__*/React__default.createElement("div", null, filteredReportArr && (filteredReportArr === null || filteredReportArr === void 0 ? void 0 : filteredReportArr.map((element, index) => (element === null || element === void 0 ? void 0 : element.length) > 0 ? /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: {
      flexBasis: "30%",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Report, {
    report: element,
    index: index
  })) : null)));
}

const useStyles$c = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function MISDashboard() {
  const classes = useStyles$c();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "MIS Reports",
    value: "1",
    className: classes.customTab
  }))), /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(MISReport, {
    type: "reports"
  }))));
}

const useStyles$d = makeStyles$1(theme => ({
  card: {
    width: 400,
    height: 'auto',
    backgroundColor: '#225785',
    borderRadius: "10px",
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    color: '#cccccc',
    margin: 'auto',
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  },
  strip: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '5px'
  }
}));
const NoRecordsCard = () => {
  const classes = useStyles$d();
  return /*#__PURE__*/React__default.createElement(Card$4, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent$1, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    component: "div",
    align: "center"
  }, "No Records Found"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    color: "textSecondary",
    align: "center",
    style: {
      color: '#fcfcfc'
    }
  }, "Development is in Progress."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    color: "textSecondary",
    align: "center",
    style: {
      color: '#fcfcfc',
      display: 'flex'
    }
  }, "Thank You for your Patience.", /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: '2px'
    }
  }, /*#__PURE__*/React__default.createElement(BiSolidLike, null)))));
};

const useStyles$e = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const headerData$1 = [{
  slno: "Sl. No"
}, {
  Name: "Name"
}, {
  formNo: "Form No."
}, {
  "Application No": "Application No."
}, {
  "Payment Ref No": "Payment Reference No."
}, {
  "Payment Date": "Payment Date"
}, {
  "Transaction Id": "Transaction Id"
}, {
  "Status": "Status"
}, {
  "Application Fee": "Application Fee"
}, {
  "Details": "Details"
}];
const StyledTableCell$5 = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$5 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$2 = ({
  apiData
}) => {
  var _apiData$MISPaymentDe;
  const classes = useStyles$e();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$1.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.MISPaymentDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$5, {
    key: row.id
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row === null || row === void 0 ? void 0 : row.payername), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row === null || row === void 0 ? void 0 : row.serviceType), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row === null || row === void 0 ? void 0 : row.applicationnumber), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row === null || row === void 0 ? void 0 : row.applicationnumber), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, " ", ConvertEpochToDate(row === null || row === void 0 ? void 0 : row.transcation_date)), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row === null || row === void 0 ? void 0 : row.transcationnumber), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, " ", row === null || row === void 0 ? void 0 : row.txn_status), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, " ", row === null || row === void 0 ? void 0 : row.total_amount), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, 'Details'))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$MISPaymentDe = apiData.MISPaymentDetails) === null || _apiData$MISPaymentDe === void 0 ? void 0 : _apiData$MISPaymentDe.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

function PaymentDetails$1({
  type
}) {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [apiData, setApiData] = useState(null);
  const fetchData = async () => {
    const result = await OBPSService.paymentReportData();
    setApiData(result);
  };
  useEffect(async () => {
    await fetchData();
  }, []);
  return /*#__PURE__*/React__default.createElement(InboxTable$2, {
    apiData: apiData
  });
}

const useStyles$f = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function PaymentDetailsReport() {
  const classes = useStyles$f();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Online Payment",
    value: "1",
    className: classes.customTab
  }))), /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(PaymentDetails$1, {
    type: "payment"
  }))));
}

const useStyles$g = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const headerData$2 = [{
  slno: "Sl. No"
}, {
  formName: "Form Name"
}, {
  NoOfApplied: "No. of Applied"
}, {
  TotaleCharges: "Total E-Charges"
}];
const StyledTableCell$6 = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$6 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$3 = ({
  apiData
}) => {
  var _apiData$MISDetails;
  const classes = useStyles$g();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$2.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.MISDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$6, {
    key: row.id
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, row === null || row === void 0 ? void 0 : row.serviceType), /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, row === null || row === void 0 ? void 0 : row.count), /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, row === null || row === void 0 ? void 0 : row.totalEcharges))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$MISDetails = apiData.MISDetails) === null || _apiData$MISDetails === void 0 ? void 0 : _apiData$MISDetails.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

function EChargesDetail() {
  const tenantId = Digit.ULBService.getStateId();
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async params => {
    try {
      const result = await OBPSService.eChargesReportData(params);
      setApiData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(async () => {
    await fetchData(tenantId);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && apiData && /*#__PURE__*/React__default.createElement(InboxTable$3, {
    apiData: apiData
  }));
}

const useStyles$h = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function EChargesReport() {
  const classes = useStyles$h();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "E-Charges",
    value: "1",
    className: classes.customTab
  }))), /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(EChargesDetail, null))));
}

const useStyles$i = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const headerData$3 = [{
  slno: "Sl. No"
}, {
  authority: "Authority Name"
}, {
  moduleName: "Module Name"
}, {
  RefNo: "Application No."
}, {
  ownerName: "Owner Name"
}, {
  mobileNo: "Mobile No."
}, {
  ltpName: "Ltp Name"
}, {
  ltpMobileNo: "Ltp Mobile No"
}, {
  status: "Status"
}, {
  schemeType: "Scheme Type"
}, {
  activityProposed: "Activity Proposed"
}, {
  plotUse: "Plot Use"
}, {
  plotNumber: "Plot Number"
}, {
  plotArea: "Plot Area (sq.m)"
}, {
  totalBuildUpArea: "Total Built-Up Area (sq.m)"
}, {
  siteAddress: "Site Address"
}, {
  createdDate: "Created Date"
}, {
  approvedDate: "Approved Date"
}, {
  feeAmount: "Fee Amount"
}];
const StyledTableCell$7 = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$7 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$4 = ({
  apiData
}) => {
  var _apiData$MisData;
  const {
    t
  } = useTranslation();
  const classes = useStyles$i();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$3.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.MisData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$7, {
    key: row.serialNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.authorityName) || (row === null || row === void 0 ? void 0 : row.developmentAuthorityName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, t(`${row === null || row === void 0 ? void 0 : row.modulename}`) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.applicationnumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.ownerName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.mobileNumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.ltpName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.ltpMobilenumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, t(`${row === null || row === void 0 ? void 0 : row.latestStatus}`)), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.schemeType) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.activityProposed) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.plotUse) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.plotNumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.plotArea) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.totalBuildUpArea) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.siteAddress) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, row !== null && row !== void 0 && row.createdDate ? new Date(row.createdDate).toLocaleDateString("en-IN") : "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, row !== null && row !== void 0 && row.approvedDate ? new Date(row.approvedDate).toLocaleDateString("en-IN") : "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, (row === null || row === void 0 ? void 0 : row.feeAmount) || "N/A"))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$MisData = apiData.MisData) === null || _apiData$MisData === void 0 ? void 0 : _apiData$MisData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const FilterForm = ({
  onSubmit,
  userDetails,
  userType,
  location1
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2, _Digit$UserService$ge3;
  const isSuperUser = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : (_Digit$UserService$ge3 = _Digit$UserService$ge2.roles) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.some(r => ["SUPERUSER", "EMPLOYEE_ADMIN"].includes(r.code));
  const getOneWeekAgo = () => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d;
  };
  const getToday = () => new Date();
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues: {
      developmentAuthorityName: location1,
      createdFrom: isSuperUser ? getOneWeekAgo() : null,
      createdTo: isSuperUser ? getToday() : null
    }
  });
  const tenantId = Digit.ULBService.getStateId();
  const {
    data: {
      BPA: {
        Organizations: departmentListOptions
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  console.log(departmentListOptions, location1, "departmentListOptions");
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const filterCompList = completeList === null || completeList === void 0 ? void 0 : completeList.filter(e => {
      var _e$Name, _e$Name2;
      return !(e !== null && e !== void 0 && (_e$Name = e.Name) !== null && _e$Name !== void 0 && _e$Name.includes("UP Housing and Development Board")) && !(e !== null && e !== void 0 && (_e$Name2 = e.Name) !== null && _e$Name2 !== void 0 && _e$Name2.includes("Uttar Pradesh Online Building Plan Approval System"));
    });
    const officeNames = filterCompList === null || filterCompList === void 0 ? void 0 : filterCompList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  useEffect(() => {
    if (departmentListOptions !== null && departmentListOptions !== void 0 && departmentListOptions.length && location1) {
      setValue("developmentAuthorityName", location1);
    }
  }, [departmentListOptions, location1, setValue]);
  const daList = departmentListOptions === null || departmentListOptions === void 0 ? void 0 : departmentListOptions.filter(item => item.Type == "DA");
  const avpList = departmentListOptions === null || departmentListOptions === void 0 ? void 0 : departmentListOptions.filter(item => item.Type == "AVP");
  const officesList = filterDepartmentsList(departmentListOptions);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Organization Name",
    control: control,
    placeholder: "Select Organization",
    name: "developmentAuthorityName",
    data: SortingAlphabatically(officesList),
    type: userType !== "Admin" ? "textInput" : "selectInput",
    disabled: userType !== "Admin"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Module Name",
    control: control,
    placeholder: "Select Module Name",
    data: [{
      value: 'Land Use',
      label: 'Land Use'
    }, {
      value: 'Map-Submission high risk',
      label: 'Map Submission (High Risk)'
    }, {
      value: 'Map-Submission(200-500)',
      label: 'Map Submission 200-50'
    }, {
      value: 'Map-Submission(100-30)',
      label: 'Map Submission 100-30'
    }, {
      value: 'Plinth',
      label: 'Plinth Submission'
    }, {
      value: 'Compounding',
      label: 'Compounding Submission'
    }, {
      value: 'Completion',
      label: 'Completion'
    }, {
      value: 'Purchasable FAR',
      label: 'Purchasable Map Submission'
    }, {
      value: 'Layout Approved by Authority',
      label: 'Layout Approved by Authority'
    }],
    name: "modulename",
    type: "selectInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "From Date",
    control: control,
    placeholder: "Select Date",
    name: "createdFrom",
    type: "datePicker"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "To Date",
    control: control,
    placeholder: "Select Date",
    name: "createdTo",
    type: "datePicker",
    disableFuture: true
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper",
    style: {
      display: 'flex',
      gap: '8px'
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Search",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: reset
  })))));
};

function ApplicationDetail$1({
  setApiData,
  apiData
}) {
  var _userInfo$info, _userInfo$info$roles, _userDetails$location, _userDetails$location2;
  const userInfo = Digit.UserService.getUser();
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo !== null && userInfo !== void 0 && (_userInfo$info = userInfo.info) !== null && _userInfo$info !== void 0 && (_userInfo$info$roles = _userInfo$info.roles) !== null && _userInfo$info$roles !== void 0 && _userInfo$info$roles.some(role => role.code === "HRMS_ADMIN" || role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN") ? "Admin" : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location = userDetails.location1) === null || _userDetails$location === void 0 ? void 0 : _userDetails$location.length) > 1 ? userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location2 = userDetails.location1) === null || _userDetails$location2 === void 0 ? void 0 : _userDetails$location2.concat(" Development Authority") : null;
  console.log(userDetails, userDetails === null || userDetails === void 0 ? void 0 : userDetails.location1, "userDetialsss");
  const {
    t
  } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const fetchData = async (tenantId, params) => {
    setIsLoading(true);
    setShowToast(null);
    try {
      var _result$MISReportDeta;
      const result = await OBPSService.applicationReportMISData(tenantId, params);
      console.log(result, "resultherere");
      if (!result) {
        throw new Error("No data received from server");
      } else if ((result === null || result === void 0 ? void 0 : (_result$MISReportDeta = result.MISReportDetails) === null || _result$MISReportDeta === void 0 ? void 0 : _result$MISReportDeta.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found"
        });
      }
      setApiData(result);
    } catch (err) {
      var _err$response, _err$response$data;
      console.error("Error fetching data:", err);
      const message = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = async formData => {
    let {
      developmentAuthorityName,
      modulename,
      createdFrom,
      createdTo
    } = formData;
    if (modulename === "Plinth Submission") {
      modulename = "plinth_submission";
    } else if (modulename === "Map Compounding") {
      modulename = "FORM_MAP_COMPOUNDING";
    } else if (modulename === "Purchasable Map Submission") {
      modulename = "PURCHASABLE_MAP";
    }
    try {
      await fetchData(tenantId, {
        developmentAuthorityName,
        modulename,
        createdFrom,
        createdTo
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    const fetchDataOnMount = async () => {
      var _userInfo$info2, _userInfo$info2$roles;
      const isSuperUser = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : (_userInfo$info2$roles = _userInfo$info2.roles) === null || _userInfo$info2$roles === void 0 ? void 0 : _userInfo$info2$roles.some(r => ["SUPERUSER", "EMPLOYEE_ADMIN"].includes(r.code));
      let params = {
        developmentAuthorityName: location1
      };
      if (isSuperUser) {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);
        params.createdFrom = oneWeekAgo;
        params.createdTo = today;
      }
      await fetchData(tenantId, params);
    };
    fetchDataOnMount();
  }, [tenantId]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterForm, {
    onSubmit: handleFormSubmit,
    userDetails: userDetails,
    userType: userType,
    location1: location1
  }), isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), !isLoading && !showToast && apiData && /*#__PURE__*/React__default.createElement(InboxTable$4, {
    apiData: apiData
  }));
}

const useStyles$j = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function ApplicationsReport() {
  const classes = useStyles$j();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    var _apiData$MisData;
    const charData = apiData === null || apiData === void 0 ? void 0 : (_apiData$MisData = apiData.MisData) === null || _apiData$MisData === void 0 ? void 0 : _apiData$MisData.map((st, index) => ({
      sl_no: index + 1,
      authorityName: (st === null || st === void 0 ? void 0 : st.authorityName) || (st === null || st === void 0 ? void 0 : st.developmentAuthorityName) || "N/A",
      moduleName: t(`${st === null || st === void 0 ? void 0 : st.modulename}`) || "N/A",
      applicationnumber: (st === null || st === void 0 ? void 0 : st.applicationnumber) || "N/A",
      owner_name: (st === null || st === void 0 ? void 0 : st.ownerName) || "N/A",
      mobile_number: (st === null || st === void 0 ? void 0 : st.mobileNumber) || "N/A",
      ltp_name: (st === null || st === void 0 ? void 0 : st.ltpName) || "N/A",
      ltpMobilenumber: (st === null || st === void 0 ? void 0 : st.ltpMobilenumber) || "N/A",
      status: t(`${st === null || st === void 0 ? void 0 : st.latestStatus}`),
      schemeType: (st === null || st === void 0 ? void 0 : st.schemeType) || "N/A",
      activityProposed: (st === null || st === void 0 ? void 0 : st.activityProposed) || "N/A",
      plotUse: (st === null || st === void 0 ? void 0 : st.plotUse) || "N/A",
      plotNumber: (st === null || st === void 0 ? void 0 : st.plotNumber) || "N/A",
      plotArea: (st === null || st === void 0 ? void 0 : st.plotArea) || "N/A",
      totalBuildUpArea: (st === null || st === void 0 ? void 0 : st.totalBuildUpArea) || "N/A",
      siteAddress: (st === null || st === void 0 ? void 0 : st.siteAddress) || "N/A",
      created_date: st !== null && st !== void 0 && st.createdDate ? new Date(st.createdDate).toLocaleDateString("en-IN") : "N/A",
      approved_date: st !== null && st !== void 0 && st.approvedDate ? new Date(st.approvedDate).toLocaleDateString("en-IN") : "N/A",
      fee: (st === null || st === void 0 ? void 0 : st.feeAmount) || "N/A"
    }));
    return Digit.Download.Excel(charData, "application-report");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Application Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: '45rem'
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: '3rem'
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: '22px'
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(ApplicationDetail$1, {
    setApiData: setApiData,
    apiData: apiData
  })))));
}

const useStyles$k = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  },
  anchorLink: {
    textDecoration: 'underline',
    color: '#1F4A7C'
  }
});
const headerData$4 = [{
  slno: "Sl. No"
}, {
  applicantName: "Applicant Name"
}, {
  applicantionNO: "Application No"
}, {
  applicantionType: "Application Type"
}, {
  status: "Status"
}, {
  architect: "Architect Name"
}, {
  createdDate: "Created Date"
}, {
  serviceType: "Service Type"
}, {
  dxfFileUrl: "DxfFile Url"
}, {
  scrutinizedFile: "File Url"
}];
const StyledTableCell$8 = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$8 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$5 = ({
  apiData
}) => {
  const classes = useStyles$k();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$4.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && apiData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$8, {
    key: row.id
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.applicantName), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.applicationNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.applicationType), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.status), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.architectInformation), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, " ", ConvertEpochToDate(Number(row === null || row === void 0 ? void 0 : row.createdDate))), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, row === null || row === void 0 ? void 0 : row.serviceType), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, /*#__PURE__*/React__default.createElement("a", {
    href: row === null || row === void 0 ? void 0 : row.dxfFileUrl,
    style: {
      textDecoration: 'underline',
      color: '#1F4A7C'
    }
  }, "dxf file")), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, /*#__PURE__*/React__default.createElement("a", {
    href: row === null || row === void 0 ? void 0 : row.reportOutputUrl,
    style: {
      textDecoration: 'underline',
      color: '#1F4A7C'
    }
  }, "pdf file"))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : apiData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

function ApplicationDetail$2() {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async params => {
    try {
      const result = await OBPSService.scrutinyReportFailedData(params);
      setApiData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(async () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    await fetchData(formattedDate);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && apiData && /*#__PURE__*/React__default.createElement(InboxTable$5, {
    apiData: apiData
  }));
}

const useStyles$l = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function ScrutinyFailedReport() {
  const classes = useStyles$l();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const componentPDF = useRef();
  const handleChange = newValue => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Scrutiny Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: '50rem'
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(ApplicationDetail$2, null)))));
}

const useStyles$m = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const headerData$5 = [{
  slno: "Sl. No"
}, {
  name: "Name"
}, {
  mobileNo: "Mobile No"
}, {
  servicetype: "Service Type"
}, {
  applicationNo: "Application No"
}, {
  District: "District"
}, {
  Status: "Status"
}, {
  ApplicationFee: "Application Fee"
}, {
  dos: "Date Of Submission"
}];
const StyledTableCell$9 = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$9 = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$6 = ({
  apiData
}) => {
  var _apiData$MISReportDet;
  const {
    t
  } = useTranslation();
  const classes = useStyles$m();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$5.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.MISReportDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
    var _row$ownerInfo, _row$ownerInfo$, _row$ownerInfo2, _row$ownerInfo2$;
    return /*#__PURE__*/React__default.createElement(StyledTableRow$9, {
      key: row.id
    }, /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : (_row$ownerInfo = row.ownerInfo) === null || _row$ownerInfo === void 0 ? void 0 : (_row$ownerInfo$ = _row$ownerInfo[0]) === null || _row$ownerInfo$ === void 0 ? void 0 : _row$ownerInfo$.name), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : (_row$ownerInfo2 = row.ownerInfo) === null || _row$ownerInfo2 === void 0 ? void 0 : (_row$ownerInfo2$ = _row$ownerInfo2[0]) === null || _row$ownerInfo2$ === void 0 ? void 0 : _row$ownerInfo2$.mobileNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : row.servicetype), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : row.applicationnumber), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : row.district), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, " ", t(`${row === null || row === void 0 ? void 0 : row.status}`)), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row === null || row === void 0 ? void 0 : row.applicationFee), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, " ", ConvertEpochToDate(Number(row === null || row === void 0 ? void 0 : row.dateofSubmisson))));
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$MISReportDet = apiData.MISReportDetails) === null || _apiData$MISReportDet === void 0 ? void 0 : _apiData$MISReportDet.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

function ApplicationDetail$3() {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async params => {
    try {
      const result = await OBPSService.inwardReportData(params);
      setApiData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(async () => {
    await fetchData(tenantId);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && apiData && /*#__PURE__*/React__default.createElement(InboxTable$6, {
    apiData: apiData
  }));
}

const useStyles$n = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function InwardReport() {
  const classes = useStyles$n();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const componentPDF = useRef();
  const handleChange = newValue => {
    setValue(newValue);
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Inward Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: '50rem'
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(ApplicationDetail$3, null)))));
}

const ProfessionalApplicationDetail = () => {
  var _applicationDetails$p, _workflowDetails$data, _workflowDetails$data2, _applicationDetails$a3, _workflowDetails$data3, _workflowDetails$data4;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0];
  const [showToast, setShowToast] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading,
    data: applicationDetails
  } = Digit.Hooks.obps.useLicenseDetails(tenantId, {
    applicationNumber: id
  }, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true
  });
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useBPAREGApplicationActions();
  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPAREG"
  });
  const closeToast = () => {
    setShowToast(null);
  };
  let dowloadOptions = [];
  if ((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p = applicationDetails.payments) === null || _applicationDetails$p === void 0 ? void 0 : _applicationDetails$p.length) > 0) {
    dowloadOptions.push({
      label: t("TL_RECEIPT"),
      onClick: () => {
        var _applicationDetails$p2, _applicationDetails$p3, _applicationDetails$p4, _applicationDetails$p5, _applicationDetails$a, _applicationDetails$a2;
        return downloadAndPrintReciept((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p2 = applicationDetails.payments) === null || _applicationDetails$p2 === void 0 ? void 0 : (_applicationDetails$p3 = _applicationDetails$p2[0]) === null || _applicationDetails$p3 === void 0 ? void 0 : (_applicationDetails$p4 = _applicationDetails$p3.paymentDetails) === null || _applicationDetails$p4 === void 0 ? void 0 : (_applicationDetails$p5 = _applicationDetails$p4[0]) === null || _applicationDetails$p5 === void 0 ? void 0 : _applicationDetails$p5.businessService) || "BPAREG", applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.applicationNumber, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : _applicationDetails$a2.tenantId);
      }
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, !isLoading && applicationDetails && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsProffessional, {
    applicationDetails: applicationDetails,
    isLoading: isLoading,
    isDataLoading: isLoading,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.applicationBusinessService : applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a3 = applicationDetails.applicationData) === null || _applicationDetails$a3 === void 0 ? void 0 : _applicationDetails$a3.businessService,
    moduleCode: "BPAREG",
    showToast: showToast,
    setShowToast: setShowToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    closeToast: closeToast,
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data3 = workflowDetails.data) !== null && _workflowDetails$data3 !== void 0 && _workflowDetails$data3.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data4 = workflowDetails.data) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.applicationBusinessService : applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.businessService}_`
  })));
};

const useStyles$o = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: '#1F4A7C',
    color: '#fff'
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd'
  },
  blueText: {
    color: '#1F4A7C'
  }
});
const headerData$6 = [{
  slno: "Sl. No"
}, {
  Name: "Name"
}, {
  mobileNo: "Mobile No"
}, {
  formType: "Application Type"
}, {
  plotArea: "Plot Area"
}, {
  RefNo: "Application No."
}, {
  Date: "Date"
}, {
  status: "Status"
}, {
  district: 'District'
}, {
  area: 'Area'
}, {
  nameOfArea: 'Name Of Area'
}, {
  subArea: 'Sub Area'
}, {
  paymentStatus: 'Payment Status'
}];
const StyledTableCell$a = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$a = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$7 = ({
  apiData
}) => {
  var _apiData$SelfCertific;
  const {
    t
  } = useTranslation();
  const classes = useStyles$o();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedApplicationNo, setSelectedApplicationNo] = useState('');
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$6.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.SelfCertificationDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
    var _row$name, _row$name$, _row$name2, _row$name2$, _row$additionaldetail, _row$additionaldetail2, _row$applicationnumbe, _row$additionaldetail3, _row$additionaldetail4, _row$additionaldetail5, _row$additionaldetail6, _row$additionaldetail7, _row$applicationnumbe2, _row$additionaldetail8, _row$additionaldetail9, _row$additionaldetail10, _row$additionaldetail11, _row$additionaldetail12, _row$additionaldetail13, _row$additionaldetail14, _row$additionaldetail15;
    return /*#__PURE__*/React__default.createElement(StyledTableRow$a, {
      key: row.id
    }, /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : (_row$name = row.name) === null || _row$name === void 0 ? void 0 : (_row$name$ = _row$name[0]) === null || _row$name$ === void 0 ? void 0 : _row$name$.name), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : (_row$name2 = row.name) === null || _row$name2 === void 0 ? void 0 : (_row$name2$ = _row$name2[0]) === null || _row$name2$ === void 0 ? void 0 : _row$name2$.mobileNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : row.servicetype), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : row.totalplotarea), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : row.applicationnumber), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, ConvertEpochToDate(Number(row === null || row === void 0 ? void 0 : row.createdtime))), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, t(row === null || row === void 0 ? void 0 : row.status)), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : (_row$additionaldetail = row.additionaldetails) === null || _row$additionaldetail === void 0 ? void 0 : (_row$additionaldetail2 = _row$additionaldetail.landAreaDetails) === null || _row$additionaldetail2 === void 0 ? void 0 : _row$additionaldetail2.city), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row !== null && row !== void 0 && (_row$applicationnumbe = row.applicationnumber) !== null && _row$applicationnumbe !== void 0 && _row$applicationnumbe.includes('UD') ? row === null || row === void 0 ? void 0 : (_row$additionaldetail3 = row.additionaldetails) === null || _row$additionaldetail3 === void 0 ? void 0 : (_row$additionaldetail4 = _row$additionaldetail3.landAreaDetails) === null || _row$additionaldetail4 === void 0 ? void 0 : _row$additionaldetail4.city : row === null || row === void 0 ? void 0 : (_row$additionaldetail5 = row.additionaldetails) === null || _row$additionaldetail5 === void 0 ? void 0 : (_row$additionaldetail6 = _row$additionaldetail5.landAreaDetails) === null || _row$additionaldetail6 === void 0 ? void 0 : (_row$additionaldetail7 = _row$additionaldetail6.locality) === null || _row$additionaldetail7 === void 0 ? void 0 : _row$additionaldetail7.name), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row !== null && row !== void 0 && (_row$applicationnumbe2 = row.applicationnumber) !== null && _row$applicationnumbe2 !== void 0 && _row$applicationnumbe2.includes('UD') ? row === null || row === void 0 ? void 0 : (_row$additionaldetail8 = row.additionaldetails) === null || _row$additionaldetail8 === void 0 ? void 0 : (_row$additionaldetail9 = _row$additionaldetail8.landAreaDetails) === null || _row$additionaldetail9 === void 0 ? void 0 : (_row$additionaldetail10 = _row$additionaldetail9.locality) === null || _row$additionaldetail10 === void 0 ? void 0 : _row$additionaldetail10.name : row === null || row === void 0 ? void 0 : (_row$additionaldetail11 = row.additionaldetails) === null || _row$additionaldetail11 === void 0 ? void 0 : (_row$additionaldetail12 = _row$additionaldetail11.landAreaDetails) === null || _row$additionaldetail12 === void 0 ? void 0 : _row$additionaldetail12.areaType), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row === null || row === void 0 ? void 0 : (_row$additionaldetail13 = row.additionaldetails) === null || _row$additionaldetail13 === void 0 ? void 0 : (_row$additionaldetail14 = _row$additionaldetail13.landAreaDetails) === null || _row$additionaldetail14 === void 0 ? void 0 : (_row$additionaldetail15 = _row$additionaldetail14.village) === null || _row$additionaldetail15 === void 0 ? void 0 : _row$additionaldetail15.name), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, (row === null || row === void 0 ? void 0 : row.paymentStatus) === "SUCCESS" && (row === null || row === void 0 ? void 0 : row.servicetype) === "FORM_12" ? /*#__PURE__*/React__default.createElement("button", {
      className: "btn btn-primary",
      style: {
        padding: "5px",
        backgroundColor: "#1F4A7C"
      },
      onClick: () => {
        setShowPaymentDetails(true);
        setSelectedApplicationNo(row === null || row === void 0 ? void 0 : row.applicationnumber);
      }
    }, "Receipt") : /*#__PURE__*/React__default.createElement("h4", null, "Not Done"), showPaymentDetails && selectedApplicationNo === (row === null || row === void 0 ? void 0 : row.applicationnumber) && /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
      colSpan: 5
    }, /*#__PURE__*/React__default.createElement(DialogContentModal, {
      title: "Application Payment Details",
      dataOpen: showPaymentDetails,
      onClose: () => setShowPaymentDetails(false)
    }, /*#__PURE__*/React__default.createElement(PaymentPrint$3, {
      id: selectedApplicationNo
    })))));
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$SelfCertific = apiData.SelfCertificationDetails) === null || _apiData$SelfCertific === void 0 ? void 0 : _apiData$SelfCertific.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

function CertificateDetail({
  setApiData,
  apiData
}) {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async (tenantId, params) => {
    try {
      const result = await OBPSService.selfApprovalReportData(tenantId, params);
      setApiData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchDataOnMount = async () => {
      await fetchData(tenantId, {
        applicationType: 'FORM_12',
        plotArea: 500,
        typeofArea: 'Residential'
      });
    };
    fetchDataOnMount();
  }, [tenantId]);
  return /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && apiData && /*#__PURE__*/React__default.createElement(InboxTable$7, {
    apiData: apiData
  }));
}

const useStyles$p = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function SelfCertificationReport() {
  const classes = useStyles$p();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    var _apiData$SelfCertific;
    const charData = apiData === null || apiData === void 0 ? void 0 : (_apiData$SelfCertific = apiData.SelfCertificationDetails) === null || _apiData$SelfCertific === void 0 ? void 0 : _apiData$SelfCertific.map(st => {
      var _st$additionaldetails, _st$additionaldetails2, _st$applicationnumber, _st$applicationnumber2, _st$additionaldetails3, _st$additionaldetails4, _st$additionaldetails5, _st$additionaldetails6, _st$additionaldetails7, _st$applicationnumber3, _st$additionaldetails8, _st$additionaldetails9, _st$additionaldetails10, _st$additionaldetails11, _st$additionaldetails12, _st$additionaldetails13, _st$additionaldetails14, _st$additionaldetails15, _st$name, _st$name$, _st$name2, _st$name2$;
      return {
        ...st,
        status: t(st.status),
        District: st === null || st === void 0 ? void 0 : (_st$additionaldetails = st.additionaldetails) === null || _st$additionaldetails === void 0 ? void 0 : (_st$additionaldetails2 = _st$additionaldetails.landAreaDetails) === null || _st$additionaldetails2 === void 0 ? void 0 : _st$additionaldetails2.city,
        Department: st !== null && st !== void 0 && (_st$applicationnumber = st.applicationnumber) !== null && _st$applicationnumber !== void 0 && _st$applicationnumber.includes('UD') ? 'UD' : 'TCP',
        Area: st !== null && st !== void 0 && (_st$applicationnumber2 = st.applicationnumber) !== null && _st$applicationnumber2 !== void 0 && _st$applicationnumber2.includes('UD') ? st === null || st === void 0 ? void 0 : (_st$additionaldetails3 = st.additionaldetails) === null || _st$additionaldetails3 === void 0 ? void 0 : (_st$additionaldetails4 = _st$additionaldetails3.landAreaDetails) === null || _st$additionaldetails4 === void 0 ? void 0 : _st$additionaldetails4.city : st === null || st === void 0 ? void 0 : (_st$additionaldetails5 = st.additionaldetails) === null || _st$additionaldetails5 === void 0 ? void 0 : (_st$additionaldetails6 = _st$additionaldetails5.landAreaDetails) === null || _st$additionaldetails6 === void 0 ? void 0 : (_st$additionaldetails7 = _st$additionaldetails6.locality) === null || _st$additionaldetails7 === void 0 ? void 0 : _st$additionaldetails7.name,
        NameOFArea: st !== null && st !== void 0 && (_st$applicationnumber3 = st.applicationnumber) !== null && _st$applicationnumber3 !== void 0 && _st$applicationnumber3.includes('UD') ? st === null || st === void 0 ? void 0 : (_st$additionaldetails8 = st.additionaldetails) === null || _st$additionaldetails8 === void 0 ? void 0 : (_st$additionaldetails9 = _st$additionaldetails8.landAreaDetails) === null || _st$additionaldetails9 === void 0 ? void 0 : (_st$additionaldetails10 = _st$additionaldetails9.locality) === null || _st$additionaldetails10 === void 0 ? void 0 : _st$additionaldetails10.name : st === null || st === void 0 ? void 0 : (_st$additionaldetails11 = st.additionaldetails) === null || _st$additionaldetails11 === void 0 ? void 0 : (_st$additionaldetails12 = _st$additionaldetails11.landAreaDetails) === null || _st$additionaldetails12 === void 0 ? void 0 : _st$additionaldetails12.areaType,
        SubArea: st === null || st === void 0 ? void 0 : (_st$additionaldetails13 = st.additionaldetails) === null || _st$additionaldetails13 === void 0 ? void 0 : (_st$additionaldetails14 = _st$additionaldetails13.landAreaDetails) === null || _st$additionaldetails14 === void 0 ? void 0 : (_st$additionaldetails15 = _st$additionaldetails14.village) === null || _st$additionaldetails15 === void 0 ? void 0 : _st$additionaldetails15.name,
        name: st === null || st === void 0 ? void 0 : (_st$name = st.name) === null || _st$name === void 0 ? void 0 : (_st$name$ = _st$name[0]) === null || _st$name$ === void 0 ? void 0 : _st$name$.name,
        mobilenumber: st === null || st === void 0 ? void 0 : (_st$name2 = st.name) === null || _st$name2 === void 0 ? void 0 : (_st$name2$ = _st$name2[0]) === null || _st$name2$ === void 0 ? void 0 : _st$name2$.mobileNumber
      };
    });
    return Digit.Download.Excel(charData, "application-report");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Self Approval Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: '45rem'
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: '3rem'
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: '22px'
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(CertificateDetail, {
    setApiData: setApiData,
    apiData: apiData
  })))));
}

const FormInfo$2 = styled(Box)(() => ({
  backgroundColor: "#fff7cb",
  margin: "2rem auto 0",
  padding: "1.5rem"
}));
const PrimaryTabsWrapper$1 = styled(Box)(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem"
}));
const MainTabs$2 = styled(Tabs)(() => ({
  marginInline: "auto"
}));
const MainTab$2 = styled(Tab)(() => ({
  "&.MuiTab-root": {
    textTransform: "none",
    paddingInline: "1rem",
    color: "#1F4A7C",
    outline: "none"
  },
  "&.Mui-selected": {
    backgroundColor: "#1F4A7C",
    color: "white"
  }
}));
const PrimaryTabs$1 = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "#5CB85C",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const PrimaryTab$1 = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(8, 89, 114)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    backgroundColor: "rgb(21, 124, 79)",
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid #1e8bc5",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const MandatoryInfo$2 = styled(Box)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: "red",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const InfoBox$2 = styled(Box)(() => ({
  lineHeight: 1.5,
  fontSize: "16px",
  color: "#1F4A7C",
  padding: "8px 16px",
  backgroundColor: "#f0f4fa",
  borderRadius: "1px",
  fontWeight: "600",
  marginLeft: "30px",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const StyledMenuItem$2 = styled(MenuItem$2)(() => ({
  "&.MuiMenuItem-root": {
    padding: "0.25rem 0.75rem",
    display: "block"
  }
}));
const SubTabsWrapper$2 = styled(Box)(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem"
}));
const SubTabs$2 = styled(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "rgb(73, 151, 192)",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const SubTab$2 = styled(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(21, 124, 179)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    backgroundColor: "rgb(7, 97, 142)",
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid #1e8bc5",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const StyledDivider$2 = styled(Divider)(({
  theme
}) => ({
  height: "1px" + "!important",
  backgroundColor: "#085A85",
  color: "#1F4A7C",
  alignSelf: "center"
}));
const PortalWrapper$2 = styled("div")(() => ({
  display: "flex",
  height: "100vh",
  width: "120%",
  boxSizing: "border-box"
}));
const SideWrapper$1 = styled("div")(() => ({
  flex: "0 0 15%",
  backgroundColor: "#262D33"
}));
const SideBarWrapper$1 = styled(Box)(() => ({
  height: "100vh",
  color: "#fff",
  padding: "1rem",
  boxSizing: "border-box"
}));
const ModuleTextWrapper$1 = styled("h2")(() => ({
  backgroundColor: "#157CB3",
  margin: ".625rem",
  padding: ".5rem"
}));
const MainWrapper$1 = styled("div")(() => ({
  flex: "0 0 85%",
  padding: "1rem",
  overflowX: "hidden"
}));
const FormInputContainer$1 = styled("div")(() => ({
  display: "flex",
  borderRadius: "1px",
  padding: "1.25rem 1.5rem",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  overflow: "auto"
}));
const RowWrapper$1 = styled("div")(() => ({
  flex: 1,
  gap: "1rem",
  display: "flex",
  flexDirection: "column"
}));
const StyledOutlinedInput$1 = styled(OutlinedInput)(() => ({
  borderRadius: "5px",
  border: "2px solid #1F4A7C"
}));
const SummaryCard$1 = styled(Card$1)(() => ({
  backgroundColor: "rgb(21, 124, 179)"
}));

const useStyles$q = makeStyles$1(theme => ({
  p: {
    fontSize: "14px",
    overflow: "hidden",
    whitespce: "nowrap"
  }
}));
const ChatBoardReply = ({
  formData,
  messageId
}) => {
  var _userRolesArray$, _userRolesArray$2, _chatBoardHistoryData3, _formData$auditDetail, _formData$landInfo, _formData$landInfo$ow, _formData$landInfo$ow2, _formData$professiona, _chatBoardHistoryData4;
  const classes = useStyles$q();
  const {
    t
  } = useTranslation();
  const Modal = useModal();
  const {
    chatBoardDataRemarks,
    handleGetRemarkssValues,
    chatBoardHistoryData,
    handleGetHistoryRemarkssValues
  } = useContext(ScrutinyRemarksContext);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [chatData, setChatData] = useState([]);
  const userData = Digit.UserService.getUser() || {};
  const userInfo = (userData === null || userData === void 0 ? void 0 : userData.info) || {};
  const authToken = (userData === null || userData === void 0 ? void 0 : userData.access_token) || null;
  const userRolesArray = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roles.filter(user => user.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code;
  const designation = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$2 = userRolesArray[0]) === null || _userRolesArray$2 === void 0 ? void 0 : _userRolesArray$2.name;
  const [developerRemarks, setDeveloperRemarks] = React__default.useState("");
  const [messageTo, setMessageTo] = React__default.useState(undefined);
  const [assignTo, setAssignTo] = React__default.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [error, setError] = useState(null);
  const replyToMessageObj = chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : (_chatBoardHistoryData3 = chatBoardHistoryData.egScrutiny) === null || _chatBoardHistoryData3 === void 0 ? void 0 : _chatBoardHistoryData3.find(val => val.id == messageId);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  const selectRole = (role, name) => {
    setAssignTo(role, name);
  };
  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };
  const onMessageToChange = e => {
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };
  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken
      },
      egScrutiny: {
        applicationId: formData === null || formData === void 0 ? void 0 : formData.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: true,
        userid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) || null,
        serviceId: messageId,
        documentId: uploadedFile,
        bussinessServiceName: formData === null || formData === void 0 ? void 0 : formData.businessService,
        designation: designation,
        name: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) || null,
        employeeName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || null,
        role: filterDataRole,
        applicationStatus: formData === null || formData === void 0 ? void 0 : formData.status,
        assignTo: assignTo || null,
        chatBoardStatus: "PENDING",
        chatBoardReply: {},
        previousStatus: replyToMessageObj === null || replyToMessageObj === void 0 ? void 0 : replyToMessageObj.chatBoardStatus,
        previousUserId: replyToMessageObj === null || replyToMessageObj === void 0 ? void 0 : replyToMessageObj.userid,
        previousEmployeeRole: replyToMessageObj === null || replyToMessageObj === void 0 ? void 0 : replyToMessageObj.role
      }
    };
    try {
      const Resp = await axios$1.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then(response => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    let redirectPath = "/digit-ui/employee";
    Modal("Application Chat Board", `Application <strong>(${formData === null || formData === void 0 ? void 0 : formData.applicationNo}) Chat Board</strong> Successfully!`, "success", redirectPath);
    await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo), handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
  };
  const handlemodalAttachment = e => {
    setUploadedFileAttachment("AttachmentOPen");
  };
  const [post, setPost] = useState({
    content: "",
    hearingDate: ""
  });
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _tenantId, _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || ((_tenantId = tenantId) === null || _tenantId === void 0 ? void 0 : _tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  useEffect(() => {
    const fetchRemarks = async () => {
      if (!(formData !== null && formData !== void 0 && formData.applicationNo)) return;
      try {
        await handleGetRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
        await handleGetHistoryRemarkssValues(formData === null || formData === void 0 ? void 0 : formData.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };
    fetchRemarks();
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationNo]);
  const assignerChatbaord = [{
    code: replyToMessageObj === null || replyToMessageObj === void 0 ? void 0 : replyToMessageObj.role,
    name: replyToMessageObj === null || replyToMessageObj === void 0 ? void 0 : replyToMessageObj.employeeName
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      padding: "10px",
      color: "#fff",
      fontWeight: "bold",
      textAlign: "left"
    }
  }, "Application Details"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "File Number:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationNo), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Submitted On:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, ConvertEpochToDate(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime)), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Owner/Applicant:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ow = _formData$landInfo.owners) === null || _formData$landInfo$ow === void 0 ? void 0 : (_formData$landInfo$ow2 = _formData$landInfo$ow[0]) === null || _formData$landInfo$ow2 === void 0 ? void 0 : _formData$landInfo$ow2.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Name of Architect:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionaldetails) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.name), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingLeft: "20px",
      paddingBottom: "3px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Case Type:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px",
      paddingBottom: "3px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.natureOfConstruction), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      fontSize: "13px",
      paddingBottom: "3px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Project Type:")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#FFFFFF",
      fontSize: "13px",
      paddingBottom: "3px"
    },
    item: true,
    xs: 6,
    md: 3
  }, formData === null || formData === void 0 ? void 0 : formData.applicationType))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      paddingLeft: "20px",
      paddingTop: "1rem"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Message To")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    className: "form-field",
    label: `Applicant`,
    onChange: onMessageToChange,
    checked: applicantChecked,
    style: {
      marginLeft: "25px",
      paddingTop: "3px",
      fontSize: "14px"
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(CheckBox$1, {
    className: "form-field",
    label: `Department`,
    onChange: onMessageToChange,
    checked: developerChecked,
    style: {
      marginLeft: "25px",
      paddingTop: "5px",
      fontSize: "14px"
    }
  })))), developerChecked === true && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) !== "CITIZEN" && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      overflow: "visible"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      backgroundColor: "#E6EFF8",
      paddingLeft: "20px",
      paddingTop: "1rem"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement("strong", null, "Assign To")), /*#__PURE__*/React__default.createElement(Grid, {
    style: {
      fontSize: "14px",
      marginTop: "8px",
      marginBottom: "-8px"
    },
    item: true,
    xs: 6,
    md: 3
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    option: assignerChatbaord,
    optionKey: "name",
    optionValue: "code",
    select: selectRole,
    placeholder: "Select Role",
    style: {
      marginLeft: "25px",
      paddingTop: "5px",
      fontSize: "14px",
      overflow: "visible"
    }
  })))), /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement(DemoParinted, {
    setContent: setDeveloperRemarks,
    content: developerRemarks
  }), uploadedFileAttachment === "AttachmentOPen" && /*#__PURE__*/React__default.createElement(Box$2, {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 3"
  }, " Document /Certificate"), /*#__PURE__*/React__default.createElement(Box$2, {
    gridColumn: "span 9"
  }, /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "workflow-doc",
    onUpload: selectFile,
    onDelete: () => {
      setUploadedFile(null);
    },
    message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
    accept: "image/*, .pdf, .png, .jpeg, .jpg",
    iserror: error
  }))), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: 20,
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalsubmit
  }, "Send"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "10px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: closeEditor
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "submit-bar submit-bar-take-action",
    style: {
      marginLeft: "70px",
      color: "#fff",
      textAlign: "center",
      marginBottom: "5px"
    },
    onClick: handlemodalAttachment
  }, "Attachment")), formData && (chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : chatBoardHistoryData.egScrutiny) && /*#__PURE__*/React__default.createElement(Card$1, {
    style: {
      marginTop: "1rem",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
      padding: "10px",
      color: "#fff",
      fontWeight: "bold",
      textAlign: "left"
    }
  }, "History Of Web Message"), /*#__PURE__*/React__default.createElement("section", {
    className: "remarks-table"
  }, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Sr. No"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "AssignTo"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Message To"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Message"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "File Number"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Created By"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Date"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      fontSize: "12px"
    }
  }, "Attachments"))), /*#__PURE__*/React__default.createElement("tbody", null, chatBoardHistoryData === null || chatBoardHistoryData === void 0 ? void 0 : (_chatBoardHistoryData4 = chatBoardHistoryData.egScrutiny) === null || _chatBoardHistoryData4 === void 0 ? void 0 : _chatBoardHistoryData4.map((item, index) => {
    var _item$assignTo, _item$assignTo2;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, (item === null || item === void 0 ? void 0 : (_item$assignTo = item.assignTo) === null || _item$assignTo === void 0 ? void 0 : _item$assignTo.name) || (item === null || item === void 0 ? void 0 : item.fieldIdL), ",", item === null || item === void 0 ? void 0 : (_item$assignTo2 = item.assignTo) === null || _item$assignTo2 === void 0 ? void 0 : _item$assignTo2.code), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, " ", item !== null && item !== void 0 && item.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item === null || item === void 0 ? void 0 : item.fieldIdL}`), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, item === null || item === void 0 ? void 0 : item.fieldIdL), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, /*#__PURE__*/React__default.createElement(SafeHtml, {
      html: item === null || item === void 0 ? void 0 : item.comment
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, item === null || item === void 0 ? void 0 : item.applicationId), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, item === null || item === void 0 ? void 0 : item.employeeName, ",(", item === null || item === void 0 ? void 0 : item.designation, ")"), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, " ", /*#__PURE__*/React__default.createElement(FormattedDate, {
      timestamp: item === null || item === void 0 ? void 0 : item.createdOn
    })), /*#__PURE__*/React__default.createElement("td", {
      style: {
        fontSize: "12px"
      }
    }, /*#__PURE__*/React__default.createElement("a", {
      target: "_",
      href: item === null || item === void 0 ? void 0 : item.documentUrl,
      style: {
        minWidth: "80px",
        height: "auto",
        minWidth: "30px"
      }
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: "20px",
        height: "30px"
      }
    }))));
  }))))));
};

const InboxReplyChatBoard = ({}) => {
  var _data$LandUse, _data$ownerRegistrati, _data$PurchasableFAR, _data$BPA;
  const {
    authority,
    plan,
    form,
    year,
    serial,
    formType,
    id: urlId
  } = useParams$1();
  console.log(useParams$1(), "paramsHook");
  const id = urlId ? urlId : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromComp", id, urlId);
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const history = useHistory$2();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  const appData = (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]) || (data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati[0]) || (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]) || (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]);
  console.log("appDetail", data, appData);
  let search = window.location.search;
  const messageId = search.split("=")[1];
  console.log("messageId  ", messageId);
  console.log("appadat ", appData);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ChatBoardReply, {
    formData: appData,
    messageId: messageId
  }));
};

const CreateNOC = () => {
  const [showError, setShowError] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [isPreviewLoadingLoading, setIsPreviewLoading] = useState(false);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    documents
  } = useSelector(state => state.formMT);
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({});
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["nocExcel"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const tooltipMessage = "Excel template available for download!";
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = data => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = async data => {
    var _data$documents, _data$documents$;
    console.log("dataFromCreateNOC", data);
    const fileStoreId = data === null || data === void 0 ? void 0 : (_data$documents = data.documents) === null || _data$documents === void 0 ? void 0 : (_data$documents$ = _data$documents[0]) === null || _data$documents$ === void 0 ? void 0 : _data$documents$.fileStoreId;
    const nocRequest = {
      fileStoreId,
      tenantId
    };
    try {
      const result = await Digit.OBPSService.NOCExcelCreate(tenantId, {
        nocRequest
      });
      console.log("loggingResultNOC", result);
      setShowToast({
        key: "success",
        message: result === null || result === void 0 ? void 0 : result.message
      });
    } catch (e) {
      var _e$response, _e$response$data, _e$response$data$Erro;
      setShowToast({
        key: "true",
        error: true,
        message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "NOC Master")), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(FileUploader$3, {
    control: control,
    name: "nocExcel",
    label: "Attach Excel Sheet",
    validationMsg: "(.xlsx) are allowed. Max file size: 10 MB.",
    isMandatory: true,
    required: true,
    tab: 6,
    maxFiles: 1,
    showError: showError
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "22px"
    }
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: tooltipMessage,
    onClick: () => getDocumentByFileStoreId("900fbc5f-39c6-4d0f-8c56-58c840fc2c67", setIsPreviewLoading),
    arrow: true
  }, "Excel Template", /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    fontSize: "small"
  }))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save",
    type: "submit",
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  }))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDeleteBtn: true
  })));
};

const EditNoc = ({
  departmentsList,
  nocSearchData,
  isLoading,
  tenantId,
  setEditMode,
  refetch
}) => {
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const baseColumns = [{
    id: "srNo",
    label: "Sr. No",
    filterable: false
  }, {
    id: "district",
    label: "District",
    filterable: true
  }, {
    id: "tehsil",
    label: "Tehsil",
    filterable: true
  }, {
    id: "village",
    label: "Village",
    filterable: true
  }];
  const deptColumns = departmentsList.map(dept => ({
    id: dept.code,
    label: dept.name,
    filterable: true
  }));
  const allColumns = [...baseColumns, ...deptColumns];
  const [selectedColumns, setSelectedColumns] = useState(allColumns.map(col => col.id));
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showToast, setShowToast] = useState(null);
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const getFilteredData = () => {
    let filteredData = nocSearchData || [];
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        const {
          RegionInfo,
          Departments
        } = item;
        return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district, globalSearch) || matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil, globalSearch) || matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village, globalSearch) || departmentsList.some(dept => matchesSearch(Departments === null || Departments === void 0 ? void 0 : Departments[dept.code], globalSearch));
      });
    }
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter(item => {
          const {
            RegionInfo,
            Departments
          } = item;
          if (key === "district") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district, value);
          if (key === "tehsil") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil, value);
          if (key === "village") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village, value);
          return matchesSearch(Departments === null || Departments === void 0 ? void 0 : Departments[key], value);
        });
      }
    });
    return filteredData;
  };
  const filteredData = getFilteredData();
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    watch
  } = useForm();
  const watchAllFields = watch();
  useEffect(() => {
    if (!nocSearchData) return;
    nocSearchData.forEach((item, idx) => {
      departmentsList.forEach(dept => {
        var _item$Departments, _item$Departments$dep;
        setValue(`noc[${idx}].${dept.code}`, ((_item$Departments = item.Departments) === null || _item$Departments === void 0 ? void 0 : (_item$Departments$dep = _item$Departments[dept.code]) === null || _item$Departments$dep === void 0 ? void 0 : _item$Departments$dep.toLowerCase()) === "yes");
      });
    });
  }, [nocSearchData, departmentsList, setValue]);
  const closeToast = () => {
    setShowToast(null);
    setEditMode(false);
    history.push("/digit-ui/employee/obps/noc/view");
    refetch();
  };
  const onFormSubmit = async formData => {
    const nocDetails = (nocSearchData || []).map((item, idx) => {
      const {
        RegionInfo,
        Departments,
        ...rest
      } = item;
      const row = {
        district: (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district) || "",
        tehsil: (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil) || "",
        village: (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village) || "",
        authority: (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.authority) || "",
        ...rest
      };
      departmentsList.forEach(dept => {
        var _formData$noc, _formData$noc$idx;
        row[dept.code] = (_formData$noc = formData.noc) !== null && _formData$noc !== void 0 && (_formData$noc$idx = _formData$noc[idx]) !== null && _formData$noc$idx !== void 0 && _formData$noc$idx[dept.code] ? "Yes" : "No";
      });
      if (item.createdBy) row.createdBy = item.createdBy;
      if (item.createdTime) row.createdTime = item.createdTime;
      if (item.lastModifyBy) row.lastModifyBy = item.lastModifyBy;
      if (item.lastModifiedTime) row.lastModifiedTime = item.lastModifiedTime;
      return row;
    });
    try {
      const result = await Digit.OBPSService.NOCExcelUpdate(tenantId, {
        nocDetails
      });
      if (result) {
        setShowToast({
          key: "success",
          message: `NOC list updated successfully.`
        });
      }
    } catch (e) {
      var _e$response, _e$response$data, _e$response$data$Erro;
      setShowToast({
        key: "true",
        error: true,
        message: e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$Erro = _e$response$data.Errors[0]) === null || _e$response$data$Erro === void 0 ? void 0 : _e$response$data$Erro.message
      });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  if (isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-table-noc-header",
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    className: "emp-table-caption"
  }, "Edit NOC"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflowX: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    className: "table-popover"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    className: "application-table noc-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => {
    let stickyClass = "";
    if (column.id === "district") stickyClass = "sticky-col";
    if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
    if (column.id === "village") stickyClass = "sticky-col-village";
    return /*#__PURE__*/React__default.createElement("th", {
      key: column.id,
      className: stickyClass
    }, column.label);
  })), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => {
    let stickyClass = "";
    if (column.id === "district") stickyClass = "sticky-col";
    if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
    if (column.id === "village") stickyClass = "sticky-col-village";
    return /*#__PURE__*/React__default.createElement("td", {
      key: column.id,
      className: stickyClass
    }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
      variant: "standard",
      size: "small",
      value: filters[column.id] || "",
      onChange: e => handleFilterChange(column.id, e.target.value),
      InputProps: {
        endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default.createElement(IconButton$1, {
          size: "small",
          onClick: () => handleClearFilter(column.id)
        }, /*#__PURE__*/React__default.createElement(ClearIcon, {
          fontSize: "small"
        })))
      },
      sx: {
        "& .MuiInput-input": {
          color: "black !important",
          fontSize: "0.75rem"
        },
        width: "100%"
      }
    }));
  }))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => {
    const {
      RegionInfo
    } = item;
    const rowIdx = nocSearchData.indexOf(item);
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, columns.map(column => {
      var _watchAllFields$noc, _watchAllFields$noc$r;
      let stickyClass = "";
      if (column.id === "district") stickyClass = "sticky-col";
      if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
      if (column.id === "village") stickyClass = "sticky-col-village";
      if (column.id === "srNo") return /*#__PURE__*/React__default.createElement("td", {
        key: column.id
      }, page * rowsPerPage + index + 1);
      if (column.id === "district") return /*#__PURE__*/React__default.createElement("td", {
        key: column.id,
        className: stickyClass
      }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district) || "NA");
      if (column.id === "tehsil") return /*#__PURE__*/React__default.createElement("td", {
        key: column.id,
        className: stickyClass
      }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil) || "NA");
      if (column.id === "village") return /*#__PURE__*/React__default.createElement("td", {
        key: column.id,
        className: stickyClass
      }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village) || "NA");
      return /*#__PURE__*/React__default.createElement("td", {
        key: column.id
      }, /*#__PURE__*/React__default.createElement(Checkbox, Object.assign({}, register(`noc[${rowIdx}].${column.id}`), {
        checked: (watchAllFields === null || watchAllFields === void 0 ? void 0 : (_watchAllFields$noc = watchAllFields.noc) === null || _watchAllFields$noc === void 0 ? void 0 : (_watchAllFields$noc$r = _watchAllFields$noc[rowIdx]) === null || _watchAllFields$noc$r === void 0 ? void 0 : _watchAllFields$noc$r[column.id]) || false,
        color: "primary",
        sx: {
          padding: "0px"
        }
      })));
    }));
  })))), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    component: "div",
    count: filteredData.length,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50]
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "1rem",
      margin: "1rem 0"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, "Save")), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDeleteBtn: true
  })));
};

const NOCSearch = {
  all: async (tenantId, filters = {}) => {
    const response = await NOCService.NOCsearch({
      tenantId,
      filters
    });
    return response;
  },
  application: async (tenantId, filters = {}) => {
    const response = await NOCService.NOCsearch({
      tenantId,
      filters
    });
    return response.Noc[0];
  },
  departmentNoc: async (tenantId, filters = {}) => {
    const response = await NOCService.NOCExcelSearch({
      tenantId,
      filters
    });
    return response.NocDetailsList;
  },
  updateNocDetail: async (tenantId, nocDetails, filters = {}) => {
    const response = await NOCService.NOCExcelUpdate({
      tenantId,
      nocDetails,
      filters
    });
    return response;
  },
  numberOfApplications: async (tenantId, filters = {}) => {
    const response = await NOCService.NOCsearch({
      tenantId,
      filters
    });
    return response.Noc;
  },
  scrutinyDetails: async (tenantId, params, data) => {
    var _response$edcrDetail;
    const response = await OBPSService.scrutinyDetails(tenantId, params, data);
    return response === null || response === void 0 ? void 0 : (_response$edcrDetail = response.edcrDetail) === null || _response$edcrDetail === void 0 ? void 0 : _response$edcrDetail[0];
  },
  BPADetails: async (tenantId, params) => {
    const response = await OBPSService.BPASearch(tenantId, params);
    return response === null || response === void 0 ? void 0 : response.BPA;
  },
  applicationDetails: async (t, tenantId, applicationNumber, userType) => {
    var _bpaResponse, _bpaResponse$, _bpaResponse3, _bpaResponse3$, _bpaResponse4, _bpaResponse4$, _edcrResponse, _edcrResponse2, _edcrResponse3;
    const filter = applicationNumber;
    const response = await NOCSearch.application(tenantId, filter);
    let bpaResponse = [];
    if (response !== null && response !== void 0 && response.sourceRefId) {
      const bpaFilter = {
        applicationNo: response === null || response === void 0 ? void 0 : response.sourceRefId
      };
      bpaResponse = await NOCSearch.BPADetails(tenantId, bpaFilter);
    }
    let edcrResponse = {};
    if ((_bpaResponse = bpaResponse) !== null && _bpaResponse !== void 0 && (_bpaResponse$ = _bpaResponse[0]) !== null && _bpaResponse$ !== void 0 && _bpaResponse$.edcrNumber) {
      var _bpaResponse2, _bpaResponse2$;
      const bpaFilter = {
        edcrNumber: (_bpaResponse2 = bpaResponse) === null || _bpaResponse2 === void 0 ? void 0 : (_bpaResponse2$ = _bpaResponse2[0]) === null || _bpaResponse2$ === void 0 ? void 0 : _bpaResponse2$.edcrNumber
      };
      edcrResponse = await NOCSearch.scrutinyDetails(tenantId, bpaFilter);
    }
    let employeeResponse = [];
    const buildingDetails = {
      title: "NOC_BULDING_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "NOC_APP_NO_LABEL",
        value: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Link, {
          to: `/digit-ui/employee/obps/bpa/${(_bpaResponse3 = bpaResponse) === null || _bpaResponse3 === void 0 ? void 0 : (_bpaResponse3$ = _bpaResponse3[0]) === null || _bpaResponse3$ === void 0 ? void 0 : _bpaResponse3$.applicationNo}`
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "link",
          style: {
            color: "#1F4A7C"
          }
        }, (_bpaResponse4 = bpaResponse) === null || _bpaResponse4 === void 0 ? void 0 : (_bpaResponse4$ = _bpaResponse4[0]) === null || _bpaResponse4$ === void 0 ? void 0 : _bpaResponse4$.applicationNo)))
      }, {
        title: "NOC_MODULE_SOURCE_LABEL",
        value: t(response === null || response === void 0 ? void 0 : response.source) || "NA"
      }, {
        title: "NOC_APPLICATION_TYPE_LABEL",
        value: (_edcrResponse = edcrResponse) !== null && _edcrResponse !== void 0 && _edcrResponse.appliactionType ? t(`WF_BPA_${(_edcrResponse2 = edcrResponse) === null || _edcrResponse2 === void 0 ? void 0 : _edcrResponse2.appliactionType}`) : "NA"
      }, {
        title: "NOC_SERVICE_TYPE_LABEL",
        value: t((_edcrResponse3 = edcrResponse) === null || _edcrResponse3 === void 0 ? void 0 : _edcrResponse3.applicationSubType) || "NA"
      }]
    };
    response && employeeResponse.push(buildingDetails);
    return {
      tenantId: response.tenantId,
      applicationDetails: employeeResponse,
      additionalDetails: response === null || response === void 0 ? void 0 : response.additionalDetails,
      applicationData: response
    };
  }
};

const ViewNOC = () => {
  var _mdmsDepartments$;
  const tenantId = Digit.ULBService.getStateId() || "up";
  const {
    t
  } = useTranslation();
  const ADMIN = Digit.Utils.hrmsAccess();
  const [showError, setShowError] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const SUPERUSER = Digit.Utils.superUserAccess();
  const closeToast = () => {
    setShowToast(null);
  };
  const filterDistrictData = (masterData, authority) => {
    var _masterData$find, _masterData$find$Dist;
    const districtsArray = masterData === null || masterData === void 0 ? void 0 : (_masterData$find = masterData.find(item => item.authorityName === authority)) === null || _masterData$find === void 0 ? void 0 : (_masterData$find$Dist = _masterData$find.Districts) === null || _masterData$find$Dist === void 0 ? void 0 : _masterData$find$Dist.map(item => {
      return {
        name: item === null || item === void 0 ? void 0 : item.District,
        label: item === null || item === void 0 ? void 0 : item.District,
        value: item === null || item === void 0 ? void 0 : item.District
      };
    });
    console.log("districtArray", districtsArray);
    return districtsArray || [];
  };
  const filterTehsilData = (masterData, authority, district) => {
    var _masterData$find2, _masterData$find2$Dis, _masterData$find2$Dis2, _masterData$find2$Dis3;
    console.log("filterTehsilDataCalled", masterData, authority);
    const result = district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find2 = masterData.find(item => item.authorityName === authority)) === null || _masterData$find2 === void 0 ? void 0 : (_masterData$find2$Dis = _masterData$find2.Districts) === null || _masterData$find2$Dis === void 0 ? void 0 : (_masterData$find2$Dis2 = _masterData$find2$Dis.find(item => item.District === district)) === null || _masterData$find2$Dis2 === void 0 ? void 0 : (_masterData$find2$Dis3 = _masterData$find2$Dis2.tehsils) === null || _masterData$find2$Dis3 === void 0 ? void 0 : _masterData$find2$Dis3.map(item => {
      return {
        name: item.tehsilName,
        label: item.tehsilName,
        value: item.tehsilName
      };
    }) : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    var _masterData$find3, _masterData$find3$Dis, _masterData$find3$Dis2, _masterData$find3$Dis3, _masterData$find3$Dis4, _masterData$find3$Dis5;
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = str => str === null || str === void 0 ? void 0 : str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    const result = tehsil && district && authority ? masterData === null || masterData === void 0 ? void 0 : (_masterData$find3 = masterData.find(item => (item === null || item === void 0 ? void 0 : item.authorityName) === authority)) === null || _masterData$find3 === void 0 ? void 0 : (_masterData$find3$Dis = _masterData$find3.Districts) === null || _masterData$find3$Dis === void 0 ? void 0 : (_masterData$find3$Dis2 = _masterData$find3$Dis.find(item => (item === null || item === void 0 ? void 0 : item.District) === district)) === null || _masterData$find3$Dis2 === void 0 ? void 0 : (_masterData$find3$Dis3 = _masterData$find3$Dis2.tehsils) === null || _masterData$find3$Dis3 === void 0 ? void 0 : (_masterData$find3$Dis4 = _masterData$find3$Dis3.find(item => (item === null || item === void 0 ? void 0 : item.tehsilName) === tehsil)) === null || _masterData$find3$Dis4 === void 0 ? void 0 : (_masterData$find3$Dis5 = _masterData$find3$Dis4.villages) === null || _masterData$find3$Dis5 === void 0 ? void 0 : _masterData$find3$Dis5.map(item => {
      const formatted = toTitleCase(item);
      return {
        name: formatted,
        value: formatted,
        label: formatted
      };
    }) : null;
    return result || [];
  };
  const {
    data: {
      NOC: {
        NocDepartment: mdmsDepartments
      } = {}
    } = {},
    isLoading: isMdmsLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", ["NocDepartment"]);
  const user = Digit.SessionStorage.get("USER_DETAIL") || {};
  const authority = `${user === null || user === void 0 ? void 0 : user.location1} Development Authority`;
  console.log("authorityFromNoc", authority, user);
  const {
    data,
    isLoading: isDataLoading,
    error,
    refetch
  } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, authority, "", "", [], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true
  });
  console.log("logNocSearchDataView", data);
  const departmentsList = (mdmsDepartments === null || mdmsDepartments === void 0 ? void 0 : (_mdmsDepartments$ = mdmsDepartments[0]) === null || _mdmsDepartments$ === void 0 ? void 0 : _mdmsDepartments$.department) || [];
  const headers = departmentsList === null || departmentsList === void 0 ? void 0 : departmentsList.map(dept => dept.name);
  const baseColumns = [{
    id: "srNo",
    label: "Sr. No",
    filterable: false
  }, {
    id: "district",
    label: "District",
    filterable: true
  }, {
    id: "tehsil",
    label: "Tehsil",
    filterable: true
  }, {
    id: "village",
    label: "Village",
    filterable: true
  }];
  const deptColumns = departmentsList.map(dept => ({
    id: dept.code,
    label: dept.name,
    filterable: true
  }));
  const allColumns = [...baseColumns, ...deptColumns];
  console.log("viewNoc", departmentsList, mdmsDepartments, data, headers);
  const handleExcelDownload = () => {
    if (!data || data.length === 0) {
      return;
    }
    const charData = data === null || data === void 0 ? void 0 : data.map((item, index) => {
      var _item$RegionInfo, _item$RegionInfo2, _item$RegionInfo3;
      const row = {
        District: (_item$RegionInfo = item.RegionInfo) === null || _item$RegionInfo === void 0 ? void 0 : _item$RegionInfo.district,
        Tehsil: (_item$RegionInfo2 = item.RegionInfo) === null || _item$RegionInfo2 === void 0 ? void 0 : _item$RegionInfo2.tehsil,
        Village: (_item$RegionInfo3 = item.RegionInfo) === null || _item$RegionInfo3 === void 0 ? void 0 : _item$RegionInfo3.village
      };
      departmentsList.forEach(({
        code,
        name
      }) => {
        var _item$Departments;
        row[name] = ((_item$Departments = item.Departments) === null || _item$Departments === void 0 ? void 0 : _item$Departments[code]) || "-";
      });
      return row;
    });
    return Digit.Download.Excel(charData, "NOC-Data");
  };
  const [selectedColumns, setSelectedColumns] = useState(allColumns.map(col => col.id));
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const {
    data: {
      BPA: {
        LandUseVillageMasterData: villagesData
      } = {}
    } = {},
    isLoading: isVillagesLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", [{
    name: "LandUseVillageMasterData",
    filter: `$[?(@.authorityName=="${authority}")]`
  }]);
  console.log("villagesDataFromNoc", villagesData);
  const {
    handleSubmit,
    control,
    setValue
  } = useForm({
    defaultValues: {
      authority: authority ? authority : "",
      authorityDistrict: "",
      authorityTehsil: "",
      authorityVillage: ""
    }
  });
  const watchDistrict = useWatch({
    control,
    name: "authorityDistrict"
  });
  const watchTehsil = useWatch({
    control,
    name: "authorityTehsil"
  });
  const districts = filterDistrictData(villagesData, authority);
  const tehsils = filterTehsilData(villagesData, authority, watchDistrict);
  const villages = filterVillagesData(villagesData, authority, watchDistrict, watchTehsil);
  useEffect(() => {
    setValue("authorityTehsil", "");
    setValue("authorityVillage", "");
  }, [watchDistrict]);
  useEffect(() => {
    setValue("authorityVillage", "");
  }, [watchTehsil]);
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const getFilteredData = () => {
    let filteredData = data || [];
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        const {
          RegionInfo,
          Departments
        } = item;
        return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district, globalSearch) || matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil, globalSearch) || matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village, globalSearch) || departmentsList.some(dept => matchesSearch(Departments === null || Departments === void 0 ? void 0 : Departments[dept.code], globalSearch));
      });
    }
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter(item => {
          const {
            RegionInfo,
            Departments
          } = item;
          if (key === "district") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district, value);
          if (key === "tehsil") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil, value);
          if (key === "village") return matchesSearch(RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village, value);
          return matchesSearch(Departments === null || Departments === void 0 ? void 0 : Departments[key], value);
        });
      }
    });
    return filteredData;
  };
  const filteredData = getFilteredData();
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleOpenColumnFilter = event => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleAddData = async payload => {
    console.log("addDataData", payload);
    const NocDetails = [{
      authority: payload === null || payload === void 0 ? void 0 : payload.authority,
      district: payload === null || payload === void 0 ? void 0 : payload.authorityDistrict,
      tehsil: payload === null || payload === void 0 ? void 0 : payload.authorityTehsil,
      village: payload === null || payload === void 0 ? void 0 : payload.authorityVillage
    }];
    try {
      const res = await NOCSearch.updateNocDetail(tenantId, NocDetails);
      console.log("responseFromAddData", res);
      setShowToast({
        key: "success",
        message: res === null || res === void 0 ? void 0 : res.Message
      });
    } catch (e) {
      var _result;
      console.log("response", data);
      setShowToast({
        key: "success",
        message: (_result = result) === null || _result === void 0 ? void 0 : _result.message
      });
    }
  };
  const handleEditClick = rowData => {
    setEditMode(true);
  };
  const handleAddClick = rowData => {
    setAddMode(true);
  };
  useEffect(() => {
    if (refetch) refetch();
  }, []);
  if (isDataLoading || isMdmsLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  if (editMode) {
    return /*#__PURE__*/React__default.createElement(EditNoc, {
      departmentsList: departmentsList,
      nocSearchData: data,
      isLoading: isMdmsLoading && isDataLoading,
      tenantId: tenantId,
      setEditMode: setEditMode,
      refetch: refetch
    });
  }
  const renderColumns = allColumns.filter(col => selectedColumns.includes(col.id));
  if (!editMode) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
      className: "emp-table-noc-header",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "1rem"
      }
    }, /*#__PURE__*/React__default.createElement("caption", {
      className: "emp-table-caption"
    }, "NOC MASTER")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px"
      }
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "outlined",
      startIcon: /*#__PURE__*/React__default.createElement(EditIcon, null),
      size: "small",
      onClick: () => handleEditClick(),
      sx: {
        height: "27px",
        fontSize: "12px",
        borderColor: "rgb(31, 74, 124)",
        color: "rgb(31, 74, 124)"
      }
    }, "Edit"), /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "outlined",
      startIcon: /*#__PURE__*/React__default.createElement(EditIcon, null),
      size: "small",
      onClick: () => handleAddClick(),
      sx: {
        height: "27px",
        fontSize: "12px",
        borderColor: "rgb(31, 74, 124)",
        color: "rgb(31, 74, 124)"
      }
    }, "Add Data"), /*#__PURE__*/React__default.createElement(Button$2, {
      variant: "outlined",
      startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
      onClick: handleOpenColumnFilter,
      size: "small",
      sx: {
        height: "27px",
        fontSize: "12px",
        borderColor: "rgb(31, 74, 124)",
        color: "rgb(31, 74, 124)"
      }
    }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
      variant: "outlined",
      size: "small",
      placeholder: "Search here...",
      value: globalSearch,
      onChange: e => handleGlobalSearch(e.target.value),
      InputProps: {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, /*#__PURE__*/React__default.createElement(SearchIcon, {
          sx: {
            background: "#2A3F54",
            color: "#fff",
            height: "24px",
            borderRadius: "7px 0px 0px 7px",
            width: "29px"
          }
        })),
        endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React__default.createElement(IconButton$1, {
          size: "small",
          onClick: () => handleGlobalSearch("")
        }, /*#__PURE__*/React__default.createElement(ClearIcon, {
          fontSize: "small"
        })))
      },
      sx: {
        padding: "0px",
        height: "25px",
        "& .MuiInputBase-root": {
          height: "27px",
          padding: "0px"
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgb(31, 74, 124)"
        },
        "& .MuiOutlinedInput-input": {
          padding: "0",
          fontSize: "12px"
        }
      }
    }))), /*#__PURE__*/React__default.createElement("div", {
      style: {
        overflowX: "auto"
      }
    }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
      className: "table-container"
    }, /*#__PURE__*/React__default.createElement(Popover, {
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: handleCloseColumnFilter,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      className: "table-popover"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "select-column-popover"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle2",
      gutterBottom: true
    }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
      control: /*#__PURE__*/React__default.createElement(Checkbox, {
        sx: {
          padding: "0px"
        },
        checked: selectedColumns.length === allColumns.length,
        indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
        onChange: e => {
          if (e.target.checked) {
            setSelectedColumns(allColumns.map(col => col.id));
          } else {
            setSelectedColumns([allColumns[0].id]);
          }
        }
      }),
      sx: {
        margin: "0px",
        fontWeight: "bold"
      },
      label: "Select All"
    }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
      key: column.id
    }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
      control: /*#__PURE__*/React__default.createElement(Checkbox, {
        sx: {
          padding: "0px"
        },
        checked: selectedColumns.includes(column.id),
        onChange: () => handleColumnToggle(column.id),
        disabled: column.id === "srNo" && selectedColumns.length === 1
      }),
      sx: {
        margin: "0px"
      },
      label: column.label
    }))))), /*#__PURE__*/React__default.createElement(Table$2, {
      stickyHeader: true,
      className: "application-table noc-table"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, renderColumns.map(column => {
      let stickyClass = "";
      if (column.id === "srNo") stickyClass = "sticky-col-srno";
      if (column.id === "district") stickyClass = "sticky-col";
      if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
      if (column.id === "village") stickyClass = "sticky-col-village";
      return /*#__PURE__*/React__default.createElement("th", {
        key: column.id,
        className: stickyClass
      }, column.label);
    })), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => {
      let stickyClass = "";
      if (column.id === "srNo") stickyClass = "sticky-col-srno";
      if (column.id === "district") stickyClass = "sticky-col";
      if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
      if (column.id === "village") stickyClass = "sticky-col-village";
      return /*#__PURE__*/React__default.createElement("td", {
        key: column.id,
        className: stickyClass
      }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
        variant: "standard",
        size: "small",
        value: filters[column.id] || "",
        onChange: e => handleFilterChange(column.id, e.target.value),
        InputProps: {
          endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React__default.createElement(IconButton$1, {
            size: "small",
            onClick: () => handleClearFilter(column.id)
          }, "X"))
        },
        sx: {
          "& .MuiInput-input": {
            color: "black !important",
            fontSize: "0.75rem"
          },
          width: "100%"
        }
      }));
    }))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colSpan: columns.length,
      align: "center"
    }, "No records found")) : paginatedData.map((item, index) => {
      const {
        RegionInfo,
        Departments
      } = item;
      return /*#__PURE__*/React__default.createElement("tr", {
        key: index
      }, columns.map(column => {
        let stickyClass = "";
        if (column.id === "srNo") stickyClass = "sticky-col-srno";
        if (column.id === "district") stickyClass = "sticky-col";
        if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
        if (column.id === "village") stickyClass = "sticky-col-village";
        if (column.id === "srNo") return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          className: stickyClass
        }, index + 1);
        if (column.id === "district") return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          className: stickyClass
        }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.district) || "NA");
        if (column.id === "tehsil") return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          className: stickyClass
        }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.tehsil) || "NA");
        if (column.id === "village") return /*#__PURE__*/React__default.createElement("td", {
          key: column.id,
          className: stickyClass
        }, (RegionInfo === null || RegionInfo === void 0 ? void 0 : RegionInfo.village) || "NA");
        return /*#__PURE__*/React__default.createElement("td", {
          key: column.id
        }, (Departments === null || Departments === void 0 ? void 0 : Departments[column.id]) || "No");
      }));
    })))), addMode && /*#__PURE__*/React__default.createElement("section", {
      className: "groupContainer3"
    }, /*#__PURE__*/React__default.createElement("form", {
      onSubmit: handleSubmit(handleAddData)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formContainer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, "Add Data")), /*#__PURE__*/React__default.createElement(Container, {
      className: "formInputContainer",
      fluid: true
    }, /*#__PURE__*/React__default.createElement(Row$1, {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Development Authority",
      inputLabel: "Select authority",
      placeholder: "Select authority",
      name: "authority",
      type: "textInput",
      mandatory: true,
      disabled: SUPERUSER ? false : true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Select District",
      control: control,
      data: districts || [],
      placeholder: "Select District",
      name: `authorityDistrict`,
      type: "searchSelect",
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    }))), /*#__PURE__*/React__default.createElement(Row$1, {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      control: control,
      label: "Select Tehsil",
      data: tehsils || [],
      inputLabel: "Select tehsil",
      placeholder: "Select tehsil",
      name: "authorityTehsil",
      type: (tehsils === null || tehsils === void 0 ? void 0 : tehsils.length) > 0 ? "searchSelect" : "textInput",
      mandatory: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      label: "Select Village",
      control: control,
      data: villages || [],
      placeholder: "Select Village",
      name: "authorityVillage",
      type: (villages === null || villages === void 0 ? void 0 : villages.length) > 0 ? "searchSelect" : "textInput",
      maxLength: 30,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    }))))), /*#__PURE__*/React__default.createElement("div", {
      className: "footerContainer2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "buttonWrapper"
    }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
      variant: "contained",
      color: "success",
      size: "medium",
      label: "Save",
      type: "submit",
      sx: {
        backgroundColor: "black",
        marginRight: "4px",
        marginTop: "20px"
      }
    })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
      error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
      warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
      label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
      onClose: closeToast,
      isDeleteBtn: true
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "1rem 0"
      }
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "mrlg cursorPointer",
      onClick: handleExcelDownload,
      style: {
        display: "flex",
        justifyContent: "space-around",
        marginLeft: "3rem"
      }
    }, /*#__PURE__*/React__default.createElement(FaDownload, {
      style: {
        fontSize: "18px"
      }
    }), /*#__PURE__*/React__default.createElement("i", {
      style: {
        fontSize: "13px"
      }
    }, " Download Excel")), /*#__PURE__*/React__default.createElement(TablePagination$1, {
      component: "div",
      count: filteredData.length,
      page: page,
      onPageChange: handleChangePage,
      rowsPerPage: rowsPerPage,
      onRowsPerPageChange: handleChangeRowsPerPage,
      rowsPerPageOptions: [5, 10, 25, 50]
    }))));
  }
};

dayjs.extend(customParseFormat);
const isSchemeItem = item => {
  var _item$descriptionOfLa, _item$additionalDetai, _item$additionalDetai2, _item$additionalDetai3, _item$mapSubDetails;
  if (!item) return false;
  const st = String((item === null || item === void 0 ? void 0 : item.schemeType) || (item === null || item === void 0 ? void 0 : item.scheme_type) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : (_item$additionalDetai3 = _item$additionalDetai2.descriptionOfLand) === null || _item$additionalDetai3 === void 0 ? void 0 : _item$additionalDetai3.schemeType) || (item === null || item === void 0 ? void 0 : (_item$mapSubDetails = item.mapSubDetails) === null || _item$mapSubDetails === void 0 ? void 0 : _item$mapSubDetails.schemeType) || "").trim().toLowerCase();
  return st === "scheme" || st === "scheme type" || st === "schemetype";
};
const isMapItem = item => {
  if (!item) return false;
  const bs = ((item === null || item === void 0 ? void 0 : item.businessService) || "").toLowerCase();
  const mn = ((item === null || item === void 0 ? void 0 : item.moduleName) || "").toLowerCase();
  const at = ((item === null || item === void 0 ? void 0 : item.applicationType) || "").toLowerCase();
  const typeStr = `${bs} ${mn} ${at}`;
  const isCompounding = typeStr.includes("compounding") || bs.includes("compounding");
  const isCompletion = typeStr.includes("completion") || bs.includes("completion");
  const isPlinth = typeStr.includes("plinth") || bs.includes("plinth");
  const isFar = typeStr.includes("far") || bs.includes("far");
  const isLandUseConversion = typeStr.includes("conversion") || typeStr.includes("form_landuseconversion") || typeStr.includes("landuseconversion") || bs.includes("conversion");
  const isLandUse = !isLandUseConversion && (typeStr.includes("landuse") || typeStr.includes("land use") || typeStr.includes("land_use") || typeStr.includes("pressrelease") || typeStr.includes("press release") || typeStr.includes("press_release") || typeStr.includes("form_pressrelease") || typeStr.includes("form_landuse") || bs.includes("landuse") || bs.includes("land_use") || bs.includes("pressrelease"));
  if (isCompounding || isCompletion || isPlinth || isFar || isLandUse || isLandUseConversion) {
    return false;
  }
  const itemRisk = ((item === null || item === void 0 ? void 0 : item.riskType) || "").toUpperCase();
  if (["LOW", "MEDIUM", "MED", "HIGH", "HIGH_NIVESH"].includes(itemRisk)) {
    return true;
  }
  return true;
};
const isDscPendingStatus = item => {
  if (!item) return false;
  const sub = ((item === null || item === void 0 ? void 0 : item.status) || "").toLowerCase().trim();
  const newSub = ((item === null || item === void 0 ? void 0 : item.subDashBoardStatus) || "").toLowerCase().trim();
  const main = ((item === null || item === void 0 ? void 0 : item.mainDashBoardStatus) || "").toLowerCase().trim();
  const dash = ((item === null || item === void 0 ? void 0 : item.dashboardStatus) || "").toLowerCase().trim();
  const state = ((item === null || item === void 0 ? void 0 : item.state) || "").toLowerCase().trim();
  const allStatus = `${sub} ${newSub} ${main} ${dash} ${state}`;
  return allStatus.includes("apply for dsc") || allStatus.includes("apply_for_dsc") || allStatus.includes("pending for dsc") || allStatus.includes("pending_for_dsc") || allStatus.includes("dsc pending") || allStatus.includes("dsc_pending") || allStatus.includes("dsc_approval") || allStatus.includes("pending_dsc") || sub === "pending for dsc" || newSub === "pending for dsc" || sub.startsWith("apply_for_dsc") || main.startsWith("apply_for_dsc") || dash.startsWith("apply_for_dsc") || main.includes("dsc pending") || dash.includes("dsc pending");
};
const ApplicationTable$1 = ({
  dashboardData,
  filters,
  showMs,
  setshowMs,
  onApplicationSelect,
  fastPasIdSearch,
  setFastPasIdSearch,
  loading,
  isFromProgress: _isFromProgress = false
}) => {
  const history = useHistory();
  const [orderBy, setOrderBy] = useState("createdTime");
  const [order, setOrder] = useState("desc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "applicationNo", "moduleName", "ownerName", "schemeType", "plotNumber", "siteAddress", "activityProposed", ...(_isFromProgress ? ["daysPending"] : []), "status"]);
  const [columnFilters, setColumnFilters] = useState({});
  console.log("IsLoadingComing", loading);
  const handleTakeAction = item => {
    var _Digit, _Digit2, _Digit3;
    console.log("itemFromTakeAction", item, item === null || item === void 0 ? void 0 : item.businessService);
    const sourceQuery = "?source=dashboard";
    const appNo = (item === null || item === void 0 ? void 0 : item.applicationNo) || (item === null || item === void 0 ? void 0 : item.applicationId);
    if (!appNo) {
      console.warn("No application number found", item);
      return;
    }
    const businessService = (item === null || item === void 0 ? void 0 : item.businessService) || "";
    const applicationType = (item === null || item === void 0 ? void 0 : item.applicationType) || "";
    const isCompletion = businessService.includes("COMPLETION") || businessService === "BPA_OC" || businessService === "BPA_OC_LOW" || businessService === "BPA_CC" || applicationType === "FORM_COMPLETION" || applicationType === "COMPLETION" || appNo.includes("/CC/") || appNo.includes("/cc/");
    const isLandUse = businessService.startsWith("BPA_LANDUSE_DA") || businessService.startsWith("BPA_LANDUSE_AVP") || businessService.startsWith("BPA_KYP") || applicationType === "FORM_LANDUSE";
    const isLandUseConversion = businessService.includes("LANDUSECONVERSION") || businessService.includes("LANDUSE_CONVERSION") || applicationType === "FORM_LANDUSECONVERSION";
    const isPressRelease = businessService === "BPA_PRESS_RELEASE" || applicationType === "FORM_PRESSRELEASE";
    const isStakeholder = businessService === "BPAREG" || (applicationType === null || applicationType === void 0 ? void 0 : applicationType.includes("STAKEHOLDER"));
    const isFar = businessService === "BPA_FAR_DA" || businessService === "BPA_FAR_AVP" || applicationType === "FORM_FAR";
    const isNoc = (businessService === null || businessService === void 0 ? void 0 : businessService.startsWith("BPA_NOC")) || applicationType === "FORM_NOC";
    if (isStakeholder) {
      Digit.SessionStorage.del("EMP_LTP");
    } else if (isLandUse) {
      Digit.SessionStorage.del("EMP_LANDUSE");
    } else {
      Digit.SessionStorage.del("EMP_MAPSUB");
    }
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("isDocValidated");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("isNotingValidated");
    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("isSitePhotoUploaded");
    Digit.SessionStorage.set("DASHBOARD_ID", appNo);
    if (onApplicationSelect) {
      onApplicationSelect(item);
      return;
    }
    if (isStakeholder) {
      history.push(`/digit-ui/employee/obps/professional/${appNo}${sourceQuery}`);
    } else if (isLandUse) {
      history.push(`/digit-ui/employee/obps/application/formLandUse/${appNo}${sourceQuery}`);
    } else if (isLandUseConversion) {
      history.push(`/digit-ui/employee/obps/application/FORM_LANDUSECONVERSION/${appNo}${sourceQuery}`);
    } else if (isPressRelease) {
      history.push(`/digit-ui/employee/obps/application/FORM_PRESSRELEASE/${appNo}${sourceQuery}`);
    } else if (isFar) {
      history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${appNo}${sourceQuery}`);
    } else if (isNoc) {
      history.push(`/digit-ui/employee/obps/application/NOC/${appNo}${sourceQuery}`);
    } else {
      history.push(`/digit-ui/employee/obps/application/MAP_SUB/${appNo}${sourceQuery}`);
    }
  };
  const ALL_COLUMNS = [{
    id: "srNo",
    label: "Sr. No.",
    filterable: false,
    sortable: false
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.applicationNo) || "-",
    render: (item, onTakeAction) => /*#__PURE__*/React__default.createElement("a", {
      onClick: () => handleTakeAction(item),
      style: {
        cursor: "pointer"
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-")
  }, {
    id: "moduleName",
    label: "Module Name",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.moduleName) || (item === null || item === void 0 ? void 0 : item.applicationType) || "-",
    render: item => (item === null || item === void 0 ? void 0 : item.moduleName) || (item === null || item === void 0 ? void 0 : item.applicationType) || "-"
  }, {
    id: "ownerName",
    label: "Owner Name",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.ownerName) || "-",
    render: item => (item === null || item === void 0 ? void 0 : item.ownerName) || "-"
  }, {
    id: "schemeType",
    label: "Scheme Type",
    filterable: true,
    sortable: true,
    exportValue: item => {
      var _item$descriptionOfLa2, _item$additionalDetai4;
      return (item === null || item === void 0 ? void 0 : item.schemeType) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa2 = item.descriptionOfLand) === null || _item$descriptionOfLa2 === void 0 ? void 0 : _item$descriptionOfLa2.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai4 = item.additionalDetails) === null || _item$additionalDetai4 === void 0 ? void 0 : _item$additionalDetai4.schemeType) || "-";
    },
    render: item => {
      var _item$descriptionOfLa3, _item$additionalDetai5;
      return (item === null || item === void 0 ? void 0 : item.schemeType) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa3 = item.descriptionOfLand) === null || _item$descriptionOfLa3 === void 0 ? void 0 : _item$descriptionOfLa3.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai5 = item.additionalDetails) === null || _item$additionalDetai5 === void 0 ? void 0 : _item$additionalDetai5.schemeType) || "-";
    }
  }, {
    id: "plotNumber",
    label: "Plot No.",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.plotNumber) || "-",
    render: item => (item === null || item === void 0 ? void 0 : item.plotNumber) || "-"
  }, {
    id: "siteAddress",
    label: "Site Address",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.siteAddress) || "-",
    render: item => (item === null || item === void 0 ? void 0 : item.siteAddress) || "-"
  }, {
    id: "activityProposed",
    label: "Activity Proposed",
    filterable: true,
    sortable: true,
    exportValue: item => (item === null || item === void 0 ? void 0 : item.activityProposed) || "-",
    render: item => (item === null || item === void 0 ? void 0 : item.activityProposed) || "-"
  }, ...(_isFromProgress ? [{
    id: "daysPending",
    label: "Days Pending",
    filterable: false,
    sortable: true,
    render: item => {
      if (!(item !== null && item !== void 0 && item.lastCreatedTime)) return "-";
      const diff = dayjs().startOf("day").diff(dayjs(item.lastCreatedTime, "DD-MM-YYYY"), "day");
      return diff;
    }
  }] : []), {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.subDashBoardStatus) === "Pending for DSC" ? item === null || item === void 0 ? void 0 : item.subDashBoardStatus : (item === null || item === void 0 ? void 0 : item.status) || "-"
  }, {
    id: "organization",
    label: "Organization",
    filterable: true,
    sortable: true,
    render: item => `${item === null || item === void 0 ? void 0 : item.shortName} - ${item === null || item === void 0 ? void 0 : item.location1}` || (item === null || item === void 0 ? void 0 : item.department) || "-"
  }, {
    id: "createdUserName",
    label: "Created By",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.createdUserName) || "-"
  }, {
    id: "createdTime",
    label: "Created On",
    filterable: false,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.createdTime) || "-"
  }, {
    id: "updatedOn",
    label: "Updated On",
    filterable: false,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.lastCreatedTime) || "-"
  }];
  const getPendingDays = dateStr => {
    if (!dateStr) return -1;
    const [day, month, year] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    if (isNaN(date.getTime())) return -1;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return Math.floor((today - date) / (1000 * 60 * 60 * 24));
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      let aValue;
      let bValue;
      if (orderBy === "daysPending") {
        aValue = getPendingDays(a.lastCreatedTime);
        bValue = getPendingDays(b.lastCreatedTime);
      } else {
        aValue = a[orderBy] ? a[orderBy].toString().toLowerCase() : "";
        bValue = b[orderBy] ? b[orderBy].toString().toLowerCase() : "";
      }
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      }
      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleColumnFilterChange = (property, value) => {
    setColumnFilters({
      ...columnFilters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearColumnFilter = property => {
    setColumnFilters({
      ...columnFilters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const handleFasPassIdSearch = value => {
    setFastPasIdSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = dashboardData || [];
    filteredData = filteredData.filter(app => {
      var _app$status, _app$mainDashBoardSta, _app$dashboardStatus, _app$subDashBoardStat, _filters$status;
      const status = ((_app$status = app.status) === null || _app$status === void 0 ? void 0 : _app$status.toString().toLowerCase()) || "";
      const mainStatus = ((_app$mainDashBoardSta = app.mainDashBoardStatus) === null || _app$mainDashBoardSta === void 0 ? void 0 : _app$mainDashBoardSta.toString().toLowerCase()) || "";
      const dashStatus = ((_app$dashboardStatus = app.dashboardStatus) === null || _app$dashboardStatus === void 0 ? void 0 : _app$dashboardStatus.toString().toLowerCase()) || "";
      const newSubStatus = app === null || app === void 0 ? void 0 : (_app$subDashBoardStat = app.subDashBoardStatus) === null || _app$subDashBoardStat === void 0 ? void 0 : _app$subDashBoardStat.toLowerCase();
      const filterStatus = (filters === null || filters === void 0 ? void 0 : (_filters$status = filters.status) === null || _filters$status === void 0 ? void 0 : _filters$status.toString()) || "";
      const isScheme = isSchemeItem(app);
      let matchesStatus = !filterStatus ? true : false;
      if (filterStatus) {
        if (filterStatus === "Rejected") {
          matchesStatus = status.includes("reject") || mainStatus.includes("reject") || dashStatus.includes("reject");
        } else if (filterStatus === "Send back to Applicant") {
          matchesStatus = status.includes("revert to applicant") || status.includes("send back to applicant") || status.includes("shortfall") || mainStatus.includes("send back") || mainStatus.includes("shortfall") || dashStatus.includes("send back") || dashStatus.includes("shortfall") || mainStatus === "citizen_action_pending_at_ltp";
        } else if (filterStatus === "Document Uploaded") {
          matchesStatus = status.includes("document uploaded") || status.includes("pay application fees") || mainStatus.includes("pay application fees") || dashStatus.includes("pay application fees");
        } else if (filterStatus === "Approved") {
          const _isMap = isMapItem(app);
          const isDsc = isDscPendingStatus(app);
          const isApproved = (mainStatus.includes("approved") || mainStatus.includes("approve") || dashStatus.includes("approved") || dashStatus.includes("approve") || status.includes("approved") || status.includes("approve")) && !isDsc && !mainStatus.includes("provisionally") && !dashStatus.includes("provisionally");
          const isSelfCert = mainStatus.includes("self certification") || dashStatus.includes("self certification") || status.includes("self certification") || mainStatus.includes("self_certification") || dashStatus.includes("self_certification") || status.includes("self_certification") || mainStatus.includes("self approved") || dashStatus.includes("self approved") || status.includes("self approved") || mainStatus.includes("self_approved") || dashStatus.includes("self_approved") || status.includes("self_approved") || mainStatus.includes("self approval") || dashStatus.includes("self approval") || status.includes("self approval") || mainStatus.includes("self_approval") || dashStatus.includes("self_approval") || status.includes("self_approval") || ["self certification approved", "self_certification_approved"].includes(mainStatus) || ["self certification approved", "self_certification_approved"].includes(dashStatus) || ["self certification approved", "self_certification_approved"].includes(status);
          if (_isMap) {
            matchesStatus = isApproved || isSelfCert;
          } else {
            matchesStatus = isApproved && !mainStatus.includes("self") && !dashStatus.includes("self") && ((filters === null || filters === void 0 ? void 0 : filters.schemeType) === "SCHEME" ? isScheme : !isScheme);
          }
        } else if (filterStatus === "Self Certification Approved" || filterStatus === "Self Approved Scheme" || filterStatus === "Self Approval") {
          const _isMap2 = isMapItem(app);
          if (_isMap2) {
            matchesStatus = false;
          } else {
            const isDsc = isDscPendingStatus(app);
            const isApproved = (mainStatus.includes("approved") || mainStatus.includes("approve") || dashStatus.includes("approved") || dashStatus.includes("approve")) && !isDsc && !mainStatus.includes("provisionally") && !dashStatus.includes("provisionally");
            const isSelfCert = ["self certification approved", "self_certification_approved"].includes(mainStatus) || ["self certification approved", "self_certification_approved"].includes(dashStatus) || ["self certification approved", "self_certification_approved"].includes(status);
            matchesStatus = isApproved && isScheme || isSelfCert;
          }
        } else if (filterStatus === "Provisionally Approved" || filterStatus === "Make Payment") {
          matchesStatus = (status.includes("payment pending") || status.includes("architect payment pending") || mainStatus.includes("payment pending") || dashStatus.includes("payment pending") || status.includes("make payment") || status.includes("make payment self") || mainStatus.includes("provisionally approved") || dashStatus.includes("provisionally approved")) && !status.includes("pay application fees") && !mainStatus.includes("pay application fees") && !dashStatus.includes("pay application fees");
        } else if (filterStatus === "Received") {
          matchesStatus = ["received", "application received"].includes(mainStatus) || ["received", "application received"].includes(dashStatus);
        } else if (filterStatus === "Auto Rejected") {
          matchesStatus = status.includes("auto reject") || mainStatus.includes("auto reject") || dashStatus.includes("auto reject");
        } else if (filterStatus === "Apply For DSC" || filterStatus === "DSC Pending") {
          matchesStatus = isDscPendingStatus(app);
        } else {
          matchesStatus = app.mainDashBoardStatus === filterStatus;
        }
      }
      let matchesSchemeType = true;
      const isMap = isMapItem(app);
      if ((filters === null || filters === void 0 ? void 0 : filters.schemeType) === "SCHEME") {
        matchesSchemeType = isScheme;
      } else if ((filters === null || filters === void 0 ? void 0 : filters.schemeType) === "NON_SCHEME") {
        matchesSchemeType = isMap ? true : !isScheme;
      }
      const isCompoundingOrCompletion = (app.applicationType || app.moduleName || app.businessService || "").toLowerCase().includes("compounding") || (app.applicationType || app.moduleName || app.businessService || "").toLowerCase().includes("completion") || (app.applicationType || app.moduleName || app.businessService || "").toLowerCase().includes("oc") || (app.applicationType || app.moduleName || app.businessService || "").toLowerCase().includes("cc");
      const matchesRiskType = !(filters !== null && filters !== void 0 && filters.riskType) || (app.riskType === filters.riskType || filters.riskType === "HIGH" && app.riskType === "HIGH_NIVESH") && !(filters.riskType.includes("HIGH") && isCompoundingOrCompletion);
      return matchesStatus && matchesSchemeType && matchesRiskType;
    });
    if (globalSearch) {
      filteredData = filteredData.filter(item => {
        return ALL_COLUMNS.some(col => {
          const val = col.id === "moduleName" ? (item === null || item === void 0 ? void 0 : item.moduleName) || (item === null || item === void 0 ? void 0 : item.applicationType) : item[col.id];
          return matchesSearch(val, globalSearch);
        });
      });
    }
    Object.entries(columnFilters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter(item => {
          const val = key === "moduleName" ? (item === null || item === void 0 ? void 0 : item.moduleName) || (item === null || item === void 0 ? void 0 : item.applicationType) : item[key];
          return matchesSearch(val, value);
        });
      }
    });
    return filteredData;
  };
  const visibleColumns = ALL_COLUMNS.filter(col => selectedColumns.includes(col.id));
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleSelectAllColumns = e => {
    if (e.target.checked) {
      setSelectedColumns(ALL_COLUMNS.map(col => col.id));
    } else {
      setSelectedColumns(["srNo"]);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleExcelDownload = () => {
    const exportData = filteredData.map((app, idx) => {
      const row = {};
      ALL_COLUMNS.forEach(col => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "application-details");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, "Application Details Summary"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, "Columns (", selectedColumns.length, "/", ALL_COLUMNS.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search By FastPas Id",
    value: fastPasIdSearch,
    onChange: e => handleFasPassIdSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "32px"
        }
      })),
      endAdornment: fastPasIdSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleFasPassIdSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    onClick: handleExcelDownload,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px"
    },
    disabled: filteredData.length === 0
  }, "Download Excel"))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === ALL_COLUMNS.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < ALL_COLUMNS.length,
      onChange: handleSelectAllColumns
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), ALL_COLUMNS.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo"
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, visibleColumns.map(column => /*#__PURE__*/React__default.createElement("th", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, column.label), column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1,
        fontSize: "16px"
      }
    }))
  }))))), /*#__PURE__*/React__default.createElement("tr", null, visibleColumns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: columnFilters[column.id] || "",
    onChange: e => handleColumnFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: columnFilters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearColumnFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: visibleColumns.length,
    align: "center",
    style: {
      padding: "20px"
    }
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, visibleColumns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `${index}-${column.id}`
  }, column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item)))))))), !loading && /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: filteredData.length,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [10, 20, 30, 50, 100]
  }));
};

const isMapItem$1 = item => {
  if (!item) return false;
  const bs = ((item === null || item === void 0 ? void 0 : item.businessService) || "").toLowerCase();
  const mn = ((item === null || item === void 0 ? void 0 : item.moduleName) || "").toLowerCase();
  const at = ((item === null || item === void 0 ? void 0 : item.applicationType) || "").toLowerCase();
  const typeStr = `${bs} ${mn} ${at}`;
  const isCompounding = typeStr.includes("compounding") || bs.includes("compounding");
  const isCompletion = typeStr.includes("completion") || bs.includes("completion");
  const isPlinth = typeStr.includes("plinth") || bs.includes("plinth");
  const isFar = typeStr.includes("far") || bs.includes("far");
  const isLandUseConversion = typeStr.includes("conversion") || typeStr.includes("form_landuseconversion") || typeStr.includes("landuseconversion") || bs.includes("conversion");
  const isLandUse = !isLandUseConversion && (typeStr.includes("landuse") || typeStr.includes("land use") || typeStr.includes("land_use") || typeStr.includes("pressrelease") || typeStr.includes("press release") || typeStr.includes("press_release") || typeStr.includes("form_pressrelease") || typeStr.includes("form_landuse") || bs.includes("landuse") || bs.includes("land_use") || bs.includes("pressrelease"));
  if (isCompounding || isCompletion || isPlinth || isFar || isLandUse || isLandUseConversion) {
    return false;
  }
  const itemRisk = ((item === null || item === void 0 ? void 0 : item.riskType) || "").toUpperCase();
  if (["LOW", "MEDIUM", "MED", "HIGH", "HIGH_NIVESH"].includes(itemRisk)) {
    return true;
  }
  return true;
};
const isDscPendingStatus$1 = item => {
  if (!item) return false;
  const sub = ((item === null || item === void 0 ? void 0 : item.status) || "").toLowerCase().trim();
  const newSub = ((item === null || item === void 0 ? void 0 : item.subDashBoardStatus) || "").toLowerCase().trim();
  const main = ((item === null || item === void 0 ? void 0 : item.mainDashBoardStatus) || "").toLowerCase().trim();
  const dash = ((item === null || item === void 0 ? void 0 : item.dashboardStatus) || "").toLowerCase().trim();
  const state = ((item === null || item === void 0 ? void 0 : item.state) || "").toLowerCase().trim();
  const allStatus = `${sub} ${newSub} ${main} ${dash} ${state}`;
  return allStatus.includes("apply for dsc") || allStatus.includes("apply_for_dsc") || allStatus.includes("pending for dsc") || allStatus.includes("pending_for_dsc") || allStatus.includes("dsc pending") || allStatus.includes("dsc_pending") || allStatus.includes("dsc_approval") || allStatus.includes("pending_dsc") || sub === "pending for dsc" || newSub === "pending for dsc" || sub.startsWith("apply_for_dsc") || main.startsWith("apply_for_dsc") || dash.startsWith("apply_for_dsc") || main.includes("dsc pending") || dash.includes("dsc pending");
};
const computeStatusBreakdown = (items = []) => {
  const counts = {
    total: items.length,
    approved: 0,
    pending: 0,
    shortfall: 0,
    draft: 0,
    rejected: 0,
    paymentPending: 0
  };
  items.forEach(item => {
    const main = (item.mainDashBoardStatus || "").toLowerCase();
    const dash = (item.dashboardStatus || "").toLowerCase();
    const sub = (item.status || "").toLowerCase();
    const newSub = (item.subDashBoardStatus || "").toLowerCase();
    const isMap = isMapItem$1(item);
    const isDsc = isDscPendingStatus$1(item);
    const isApprove = (main.includes("approved") || main.includes("approve") || dash.includes("approved") || dash.includes("approve") || sub.includes("approved") || sub.includes("approve")) && !isDsc && !main.includes("provisionally") && !dash.includes("provisionally");
    const isSelfCert = main.includes("self certification") || dash.includes("self certification") || sub.includes("self certification") || main.includes("self_certification") || dash.includes("self_certification") || sub.includes("self_certification") || main.includes("self approved") || dash.includes("self approved") || sub.includes("self approved") || main.includes("self_approved") || dash.includes("self_approved") || sub.includes("self_approved") || main.includes("self approval") || dash.includes("self approval") || sub.includes("self approval") || main.includes("self_approval") || dash.includes("self_approval") || sub.includes("self_approval") || ["self certification approved", "self_certification_approved"].includes(main) || ["self certification approved", "self_certification_approved"].includes(dash) || ["self certification approved", "self_certification_approved"].includes(sub);
    if (isMap ? isApprove || isSelfCert : isApprove && !main.includes("self") && !dash.includes("self")) {
      counts.approved++;
    }
    if (sub.includes("document uploaded") || sub.includes("pay application fees") || main.includes("pay application fees") || dash.includes("pay application fees")) {
      counts.draft++;
    }
    if (main.includes("in progress with officer") || main.includes("in progress with officers") || dash.includes("in progress with officer") || dash.includes("in progress with officers")) {
      counts.pending++;
    }
    if (sub.includes("revert to applicant") || sub.includes("send back to applicant") || sub.includes("shortfall") || main.includes("send back") || main.includes("shortfall") || dash.includes("send back") || dash.includes("shortfall") || main === "citizen_action_pending_at_ltp") {
      counts.shortfall++;
    }
    if (sub.includes("reject") || main.includes("reject") || dash.includes("reject")) {
      counts.rejected++;
    }
    if ((sub.includes("payment pending") || sub.includes("architect payment pending") || main.includes("payment pending") || dash.includes("payment pending") || sub.includes("make payment") || sub.includes("make payment self") || main.includes("provisionally approved") || dash.includes("provisionally approved")) && !sub.includes("pay application fees") && !main.includes("pay application fees") && !dash.includes("pay application fees")) {
      counts.paymentPending++;
    }
  });
  return counts;
};
const ROW_CONFIG = [{
  id: "MAP",
  label: "Map Submission",
  icon: "📋",
  color: "#1565c0",
  bg: "#dbeafe",
  hasSubmenu: true,
  subOptions: [{
    id: "MAP_LOW",
    label: "Low Risk",
    color: "#2e7d32",
    bg: "#dcfce7",
    icon: "🟢"
  }, {
    id: "MAP_MED",
    label: "Medium Risk",
    color: "#ed6c02",
    bg: "#ffedd5",
    icon: "🟠"
  }, {
    id: "MAP_HIGH",
    label: "High Risk Map",
    color: "#c2410c",
    bg: "#ffedd5",
    icon: "🔴"
  }]
}, {
  id: "LAND_USE",
  label: "Land Use",
  icon: "🗺️",
  color: "#0d9488",
  bg: "#ccfbf1"
}, {
  id: "COMPOUNDING",
  label: "Compounding",
  icon: "🔨",
  color: "#b91c1c",
  bg: "#fff1f2"
}, {
  id: "COMPLETION",
  label: "Completion",
  icon: "📊",
  color: "#0e7490",
  bg: "#ecfeff"
}, {
  id: "PLINTH",
  label: "Plinth",
  icon: "🏛️",
  color: "#7e22ce",
  bg: "#f5f3ff"
}, {
  id: "PURCHASABLE_FAR",
  label: "Purchasable FAR",
  icon: "🏢",
  color: "#0284c7",
  bg: "#e0f2fe"
}, {
  id: "LANDUSE_CONVERSION",
  label: "Land Use Conversion",
  icon: "🔄",
  color: "#059669",
  bg: "#d1fae5"
}];
const AllFilesSummaryTable = ({
  dashboardData: _dashboardData = [],
  matchesPillFilter,
  onCellClick,
  onViewAllForPill
}) => {
  const [mapExpanded, setMapExpanded] = useState(true);
  const tableData = useMemo(() => {
    return ROW_CONFIG.map(row => {
      const items = (_dashboardData || []).filter(item => matchesPillFilter(item, row.id === "MAP" ? "MAP_ALL" : row.id));
      const counts = computeStatusBreakdown(items);
      let subRows = [];
      if (row.hasSubmenu && row.subOptions) {
        subRows = row.subOptions.map(sub => {
          const subItems = (_dashboardData || []).filter(item => matchesPillFilter(item, sub.id));
          return {
            ...sub,
            counts: computeStatusBreakdown(subItems)
          };
        });
      }
      return {
        ...row,
        counts,
        subRows
      };
    });
  }, [_dashboardData, matchesPillFilter]);
  const grandTotal = useMemo(() => {
    return computeStatusBreakdown(_dashboardData);
  }, [_dashboardData]);
  const handleExportCSV = () => {
    const headers = ["File Type", "Total Files", "Pending with Officer", "Approved", "Shortfall", "Draft", "Rejected", "Payment Pending"];
    const rows = tableData.flatMap(r => {
      const mainRow = [`"${r.label}"`, r.counts.total, r.counts.pending, r.counts.approved, r.counts.shortfall, r.counts.draft, r.counts.rejected, r.counts.paymentPending];
      if (r.subRows && r.subRows.length > 0) {
        const subs = r.subRows.map(s => [`"  -- ${s.label}"`, s.counts.total, s.counts.pending, s.counts.approved, s.counts.shortfall, s.counts.draft, s.counts.rejected, s.counts.paymentPending]);
        return [mainRow, ...subs];
      }
      return [mainRow];
    });
    rows.push([`"GRAND TOTAL"`, grandTotal.total, grandTotal.pending, grandTotal.approved, grandTotal.shortfall, grandTotal.draft, grandTotal.rejected, grandTotal.paymentPending]);
    const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows.map(e => e.join(","))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `All_Files_Summary_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const renderCellCount = (count, statusType, pillId, color = "#1976d2", bg = "#f0f7ff") => {
    const isZero = count === 0;
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: isZero ? "No applications" : `Click to view ${count} ${statusType} files in table below`,
      arrow: true,
      placement: "top"
    }, /*#__PURE__*/React__default.createElement(Box, {
      onClick: () => {
        if (!isZero && onCellClick) {
          onCellClick(pillId, statusType);
        }
      },
      sx: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "48px",
        px: 1.4,
        py: 0.65,
        borderRadius: "10px",
        background: isZero ? "#f9fafb" : bg,
        color: isZero ? "#9ca3af" : color,
        fontWeight: isZero ? 500 : 800,
        fontSize: "13.5px",
        border: isZero ? "1px solid #f3f4f6" : `1px solid ${color}35`,
        cursor: isZero ? "default" : "pointer",
        transition: "all 0.22s cubic-bezier(.4,0,.2,1)",
        boxShadow: isZero ? "none" : `0 2px 6px ${color}14`,
        "&:hover": isZero ? {} : {
          transform: "translateY(-2px) scale(1.06)",
          boxShadow: `0 6px 16px ${color}30`,
          background: color,
          color: "#ffffff",
          borderColor: color
        }
      }
    }, count.toLocaleString()));
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mb: 4,
      animation: "v2TableFadeIn 0.5s ease both",
      "@keyframes v2TableFadeIn": {
        from: {
          opacity: 0,
          transform: "translateY(18px)"
        },
        to: {
          opacity: 1,
          transform: "translateY(0)"
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 0,
    sx: {
      borderRadius: "20px",
      overflow: "hidden",
      border: "1.5px solid rgba(21, 101, 192, 0.14)",
      background: "#ffffff",
      boxShadow: "0 12px 40px -10px rgba(13, 43, 107, 0.09), 0 4px 12px rgba(0,0,0,0.03)"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      px: 3.5,
      py: 2.2,
      background: "linear-gradient(135deg, #0d2b6b 0%, #1565c0 45%, #1976d2 80%, #0288d1 100%)",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 2,
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: -40,
      right: -40,
      width: 180,
      height: 180,
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.8
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 44,
      height: 44,
      borderRadius: "12px",
      background: "rgba(255,255,255,0.18)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(255,255,255,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "22px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    }
  }, "\uD83D\uDCD1"), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 900,
      fontSize: "19px",
      color: "#ffffff",
      letterSpacing: "-0.3px",
      display: "flex",
      alignItems: "center",
      gap: 1.2
    }
  }, "All Files Status Summary Matrix", /*#__PURE__*/React__default.createElement(Chip, {
    label: `${grandTotal.total.toLocaleString()} Total Files`,
    size: "small",
    sx: {
      background: "rgba(255,255,255,0.22)",
      color: "#ffffff",
      fontWeight: 800,
      fontSize: "11px",
      border: "1px solid rgba(255,255,255,0.35)",
      backdropFilter: "blur(4px)"
    }
  })), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "12px",
      color: "rgba(255,255,255,0.8)",
      fontWeight: 500,
      mt: 0.3
    }
  }, "Consolidated overview of all file types with status breakdowns. Click any number to view files below."))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.2
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    size: "small",
    onClick: handleExportCSV,
    startIcon: /*#__PURE__*/React__default.createElement(DownloadIcon, {
      sx: {
        fontSize: 18
      }
    }),
    sx: {
      background: "rgba(255,255,255,0.95)",
      color: "#0d2b6b",
      fontWeight: 700,
      fontSize: "12px",
      textTransform: "none",
      borderRadius: "10px",
      px: 2,
      py: 0.8,
      boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
      "&:hover": {
        background: "#ffffff",
        transform: "translateY(-1px)",
        boxShadow: "0 6px 18px rgba(0,0,0,0.22)"
      },
      transition: "all 0.2s ease"
    }
  }, "Export CSV"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    sx: {
      maxHeight: 720
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    stickyHeader: true,
    sx: {
      minWidth: 860
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      "& th": {
        background: "#f1f5f9",
        color: "#1e293b",
        fontWeight: 800,
        fontSize: "12px",
        textTransform: "uppercase",
        letterSpacing: "0.6px",
        py: 1.6,
        px: 2,
        borderBottom: "2px solid #cbd5e1",
        whiteSpace: "nowrap"
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      minWidth: 240
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\uD83D\uDCC1"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#334155"
    }
  }, "File / Application Type"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\uD83D\uDCCA"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#1976d2"
    }
  }, "Total Files"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\u23F3"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#2e7d32"
    }
  }, "Pending (Officer)"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\u2705"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#16a34a"
    }
  }, "Approved"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\u26A0\uFE0F"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#9333ea"
    }
  }, "Shortfall"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\u270D\uFE0F"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#ea580c"
    }
  }, "Draft"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\u274C"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#dc2626"
    }
  }, "Rejected"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.6
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span"
  }, "\uD83D\uDCB3"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#0284c7"
    }
  }, "Payment Pending"))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center",
    sx: {
      minWidth: 140
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      fontSize: "12px",
      color: "#64748b"
    }
  }, "Status Ratio")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, tableData.map((row, idx) => {
    const isEven = idx % 2 === 0;
    const hasSub = row.hasSubmenu && row.subRows && row.subRows.length > 0;
    const total = row.counts.total;
    const approvedPct = total > 0 ? Math.round(row.counts.approved / total * 100) : 0;
    const pendingPct = total > 0 ? Math.round(row.counts.pending / total * 100) : 0;
    const shortfallPct = total > 0 ? Math.round(row.counts.shortfall / total * 100) : 0;
    const draftPct = total > 0 ? Math.round(row.counts.draft / total * 100) : 0;
    const rejectedPct = total > 0 ? Math.round(row.counts.rejected / total * 100) : 0;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: row.id
    }, /*#__PURE__*/React__default.createElement(TableRow$1, {
      sx: {
        background: isEven ? "#ffffff" : "#fbfcfe",
        transition: "background 0.2s ease",
        "&:hover": {
          background: "#f0f7ff !important"
        },
        "& td": {
          py: 1.4,
          px: 2,
          borderBottom: hasSub && mapExpanded ? "none" : "1px solid #e2e8f0"
        }
      }
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1.2
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      onClick: () => {
        if (onViewAllForPill) onViewAllForPill(row.id);
      },
      sx: {
        display: "inline-flex",
        alignItems: "center",
        gap: 1.2,
        px: 1.8,
        py: 0.75,
        borderRadius: "14px",
        background: row.bg,
        border: `1.5px solid ${row.color}45`,
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
        "&:hover": {
          transform: "translateY(-1px) scale(1.02)",
          boxShadow: `0 6px 16px ${row.color}25`,
          borderColor: row.color
        }
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: 28,
        height: 28,
        borderRadius: "8px",
        background: `${row.color}22`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        flexShrink: 0
      }
    }, row.icon), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontWeight: 800,
        fontSize: "13px",
        color: row.color,
        whiteSpace: "nowrap"
      }
    }, row.label)), hasSub && /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: e => {
        e.stopPropagation();
        setMapExpanded(!mapExpanded);
      },
      sx: {
        color: row.color,
        background: `${row.color}15`,
        width: 28,
        height: 28,
        "&:hover": {
          background: `${row.color}30`
        }
      }
    }, mapExpanded ? /*#__PURE__*/React__default.createElement(KeyboardArrowUpIcon, {
      sx: {
        fontSize: 18
      }
    }) : /*#__PURE__*/React__default.createElement(KeyboardArrowDownIcon, {
      sx: {
        fontSize: 18
      }
    })))), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.total, "Total", row.id, "#1565c0", "#eff6ff")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.pending, "In Progress With Officer", row.id, "#2e7d32", "#f0fdf4")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.approved, "Approved", row.id, "#16a34a", "#f0fdf4")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.shortfall, "Send back to Applicant", row.id, "#9333ea", "#faf5ff")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.draft, "Document Uploaded", row.id, "#ea580c", "#fff7ed")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.rejected, "Rejected", row.id, "#dc2626", "#fef2f2")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, renderCellCount(row.counts.paymentPending, "Make Payment", row.id, "#0284c7", "#f0f9ff")), /*#__PURE__*/React__default.createElement(TableCell$1, {
      align: "center"
    }, /*#__PURE__*/React__default.createElement(Tooltip, {
      title: `Approved: ${approvedPct}% | Pending: ${pendingPct}% | Shortfall: ${shortfallPct}% | Draft: ${draftPct}% | Rejected: ${rejectedPct}%`,
      arrow: true,
      placement: "left"
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: "100%",
        maxWidth: 120,
        mx: "auto"
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        height: 8,
        borderRadius: 4,
        overflow: "hidden",
        background: "#e2e8f0"
      }
    }, approvedPct > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: `${approvedPct}%`,
        background: "#16a34a"
      }
    }), pendingPct > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: `${pendingPct}%`,
        background: "#2e7d32"
      }
    }), shortfallPct > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: `${shortfallPct}%`,
        background: "#9333ea"
      }
    }), draftPct > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: `${draftPct}%`,
        background: "#ea580c"
      }
    }), rejectedPct > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: `${rejectedPct}%`,
        background: "#dc2626"
      }
    })), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "10.5px",
        fontWeight: 700,
        color: "#64748b",
        mt: 0.4
      }
    }, approvedPct, "% Approved"))))), hasSub && /*#__PURE__*/React__default.createElement(TableRow$1, {
      sx: {
        background: "#f8faff"
      }
    }, /*#__PURE__*/React__default.createElement(TableCell$1, {
      colSpan: 9,
      sx: {
        p: 0,
        borderBottom: "1px solid #e2e8f0"
      }
    }, /*#__PURE__*/React__default.createElement(Collapse, {
      in: mapExpanded,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        py: 1,
        px: 3
      }
    }, row.subRows.map(sub => {
      const subTotal = sub.counts.total;
      const subAppPct = subTotal > 0 ? Math.round(sub.counts.approved / subTotal * 100) : 0;
      return /*#__PURE__*/React__default.createElement(Box, {
        key: sub.id,
        sx: {
          display: "flex",
          alignItems: "center",
          py: 0.9,
          px: 1.5,
          my: 0.4,
          borderRadius: "10px",
          background: "#ffffff",
          border: `1px dashed ${sub.color}40`,
          transition: "all 0.2s ease",
          "&:hover": {
            background: `${sub.color}08`
          }
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          minWidth: 220,
          display: "flex",
          alignItems: "center",
          gap: 1
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          fontSize: "13px"
        }
      }, sub.icon), /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "12px",
          fontWeight: 700,
          color: sub.color
        }
      }, sub.label)), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          flex: 1,
          display: "flex",
          justifyContent: "space-around"
        }
      }, renderCellCount(sub.counts.total, "Total", sub.id, "#1565c0", "#eff6ff"), renderCellCount(sub.counts.pending, "In Progress With Officer", sub.id, "#2e7d32", "#f0fdf4"), renderCellCount(sub.counts.approved, "Approved", sub.id, "#16a34a", "#f0fdf4"), renderCellCount(sub.counts.shortfall, "Send back to Applicant", sub.id, "#9333ea", "#faf5ff"), renderCellCount(sub.counts.draft, "Document Uploaded", sub.id, "#ea580c", "#fff7ed"), renderCellCount(sub.counts.rejected, "Rejected", sub.id, "#dc2626", "#fef2f2"), renderCellCount(sub.counts.paymentPending, "Make Payment", sub.id, "#0284c7", "#f0f9ff"), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          width: 100,
          textAlign: "center"
        }
      }, /*#__PURE__*/React__default.createElement(Typography, {
        sx: {
          fontSize: "11px",
          fontWeight: 700,
          color: "#64748b"
        }
      }, subAppPct, "% app."))));
    }))))));
  }), /*#__PURE__*/React__default.createElement(TableRow$1, {
    sx: {
      background: "linear-gradient(90deg, #f8fafc 0%, #edf2f7 50%, #f1f5f9 100%)",
      borderTop: "2.5px solid #94a3b8",
      "& td": {
        py: 2,
        px: 2,
        fontWeight: 900
      }
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.2
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 32,
      height: 32,
      borderRadius: "8px",
      background: "#0d2b6b",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px"
    }
  }, "\uD83D\uDCC8"), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 900,
      fontSize: "14px",
      color: "#0d2b6b"
    }
  }, "GRAND TOTAL"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "All Categories Combined")))), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.total, "Total", "ALL", "#0d2b6b", "#e0e7ff")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.pending, "In Progress With Officer", "ALL", "#166534", "#dcfce7")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.approved, "Approved", "ALL", "#15803d", "#dcfce7")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.shortfall, "Send back to Applicant", "ALL", "#7e22ce", "#f3e8ff")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.draft, "Document Uploaded", "ALL", "#c2410c", "#ffedd5")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.rejected, "Rejected", "ALL", "#b91c1c", "#fee2e2")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, renderCellCount(grandTotal.paymentPending, "Make Payment", "ALL", "#0369a1", "#e0f2fe")), /*#__PURE__*/React__default.createElement(TableCell$1, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: "100%",
      maxWidth: 120,
      mx: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Chip, {
    label: `${grandTotal.total > 0 ? Math.round(grandTotal.approved / grandTotal.total * 100) : 0}% Approved`,
    size: "small",
    sx: {
      background: "#16a34a",
      color: "#ffffff",
      fontWeight: 800,
      fontSize: "11px"
    }
  }))))))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      px: 3,
      py: 1.5,
      background: "#f8fafc",
      borderTop: "1px solid #e2e8f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#16a34a"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Approved")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#2e7d32"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Pending Officer")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#9333ea"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Shortfall")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#ea580c"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Draft")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#dc2626"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Rejected")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "#0284c7"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10.5px",
      color: "#64748b",
      fontWeight: 600
    }
  }, "Payment Due"))))));
};

const toNumber = v => {
  const n = Number(String(v !== null && v !== undefined ? v : 0).replace(/[^0-9.-]+/g, ""));
  return isNaN(n) ? 0 : n;
};
const getChargeLabel = key => key.replace(/Amount$/, "").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, c => c.toUpperCase());
const getRecords = apiData => Array.isArray(apiData) ? apiData : (apiData === null || apiData === void 0 ? void 0 : apiData.MisAllExtractData) || [];
const buildBudgetHeadSummary = (records = []) => {
  const totals = {};
  records.forEach(rec => {
    Object.keys(rec).forEach(key => {
      if (!key.endsWith("Amount")) return;
      const n = toNumber(rec[key]);
      if (!n) return;
      totals[key] = (totals[key] || 0) + n;
    });
  });
  return Object.entries(totals).map(([feeType, total]) => ({
    feeType,
    label: getChargeLabel(feeType),
    totalAmount: Math.round(total * 100) / 100
  })).sort((a, b) => a.label.localeCompare(b.label));
};
const getRecordsForHead = (records = [], feeType) => records.filter(rec => toNumber(rec[feeType]) > 0).map(rec => ({
  applicationnumber: rec.applicationnumber,
  amount: Math.round(toNumber(rec[feeType]) * 100) / 100,
  payDate: rec.settlementdate,
  raw: rec
}));

dayjs.extend(customParseFormat);
const getPendingDays = date => {
  if (!date) return "-";
  const parsedDate = dayjs(date, "DD-MM-YYYY");
  return dayjs().diff(parsedDate, "day");
};
const getModuleFromAppNo = (appNo = "") => {
  if (!appNo || typeof appNo !== "string") return "";
  const upper = appNo.toUpperCase();
  if (upper.includes("COMP")) return "Compounding";
  if (upper.includes("LU")) return "Land Use";
  if (upper.includes("MS")) return "Map Submission";
  if (upper.includes("CC")) return "Completion";
  if (upper.includes("PF")) return "Purchasable FAR";
  return "";
};
const useStyles$r = makeStyles$1({
  table: {
    minWidth: 800
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd"
  },
  blueText: {
    color: "#1F4A7C"
  }
});
const headerData$7 = [{
  id: "slno",
  label: "Sr. No",
  sortable: true
}, {
  id: "applicationNo",
  label: "Application Number",
  sortable: true
}, {
  id: "riskType",
  label: "Risk Type",
  sortable: true
}, {
  id: "applicationType",
  label: "Module Name",
  sortable: true
}, {
  id: "lastCreatedTime",
  label: "Last Updated",
  sortable: true
}, {
  id: "pendingTime",
  label: "Pending Days",
  sortable: true,
  exportValue: row => getPendingDays(row === null || row === void 0 ? void 0 : row.lastCreatedTime)
}];
const StyledTableCell$b = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$b = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  ":hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const EmployeePendingFiles = ({
  applications,
  tenantId,
  onApplicationSelect
}) => {
  const classes = useStyles$r();
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState("lastCreatedTime");
  const [order, setOrder] = useState("desc");
  useEffect(() => {
    if (applications && tenantId) {
      getRowData(applications, tenantId);
    }
  }, [tenantId, applications]);
  const getRowData = async (applications, tenantId) => {
    try {
      setIsLoading(true);
      const queryObj = {
        applicationNo: applications.join(",")
      };
      const res = await Digit.OBPSService.dashboardReportData(tenantId, queryObj);
      const reportData = (res === null || res === void 0 ? void 0 : res.CommonSearchRequest) || [];
      setRowData(reportData);
    } catch (err) {
      console.log("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const handleTakeAction = item => {
    var _Digit, _Digit2, _Digit3;
    const appNo = (item === null || item === void 0 ? void 0 : item.applicationNo) || (item === null || item === void 0 ? void 0 : item.applicationId);
    if (!appNo) {
      console.warn("No application number found", item);
      return;
    }
    const businessService = (item === null || item === void 0 ? void 0 : item.businessService) || "";
    const applicationType = (item === null || item === void 0 ? void 0 : item.applicationType) || "";
    const isCompletion = businessService.includes("COMPLETION") || businessService === "BPA_OC" || businessService === "BPA_OC_LOW" || businessService === "BPA_CC" || applicationType === "FORM_COMPLETION" || applicationType === "COMPLETION" || appNo.includes("/CC/") || appNo.includes("/cc/");
    const isLandUse = businessService.startsWith("BPA_LANDUSE_DA") || businessService.startsWith("BPA_LANDUSE_AVP") || businessService.startsWith("BPA_KYP") || applicationType === "FORM_LANDUSE";
    const isStakeholder = businessService === "BPAREG" || (applicationType === null || applicationType === void 0 ? void 0 : applicationType.includes("STAKEHOLDER"));
    if (isStakeholder) {
      Digit.SessionStorage.del("EMP_LTP");
    } else if (isLandUse) {
      Digit.SessionStorage.del("EMP_LANDUSE");
    } else {
      Digit.SessionStorage.del("EMP_MAPSUB");
    }
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("isDocValidated");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("isNotingValidated");
    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("isSitePhotoUploaded");
    Digit.SessionStorage.set("DASHBOARD_ID", appNo);
    if (onApplicationSelect) {
      onApplicationSelect(item);
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      let aValue;
      let bValue;
      if (orderBy === "slno") {
        aValue = rowData.indexOf(a);
        bValue = rowData.indexOf(b);
      } else {
        aValue = a !== null && a !== void 0 && a[orderBy] ? a[orderBy].toString().toLowerCase() : "";
        bValue = b !== null && b !== void 0 && b[orderBy] ? b[orderBy].toString().toLowerCase() : "";
      }
      if (orderBy === "lastCreatedTime") {
        aValue = dayjs(a === null || a === void 0 ? void 0 : a.lastCreatedTime, "DD-MM-YYYY").valueOf();
        bValue = dayjs(b === null || b === void 0 ? void 0 : b.lastCreatedTime, "DD-MM-YYYY").valueOf();
      }
      if (orderBy === "pendingTime") {
        aValue = getPendingDays(a === null || a === void 0 ? void 0 : a.lastCreatedTime);
        bValue = getPendingDays(b === null || b === void 0 ? void 0 : b.lastCreatedTime);
      }
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const sortedData = rowData.slice().sort(getComparator(order, orderBy));
  const handleExcelDownload = () => {
    const exportData = sortedData.map((app, idx) => {
      const row = {};
      headerData$7 === null || headerData$7 === void 0 ? void 0 : headerData$7.forEach(col => {
        if (col.id === "slno") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "application-details");
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "right",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    color: "primary",
    onClick: handleExcelDownload,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px"
    },
    disabled: sortedData.length === 0
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    style: {
      fontSize: "20px",
      color: "rgb(85 108 214)"
    }
  }))), /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$7.map(column => /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    key: column.id
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, column.label), column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1,
        fontSize: "16px"
      }
    }))
  })))))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, sortedData && (sortedData === null || sortedData === void 0 ? void 0 : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$b, {
    key: row.serialNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "#1976d2",
      cursor: "pointer",
      fontWeight: "bold"
    },
    onClick: () => handleTakeAction(row)
  }, (row === null || row === void 0 ? void 0 : row.applicationNo) || "-"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, (row === null || row === void 0 ? void 0 : row.riskType) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, getModuleFromAppNo(row === null || row === void 0 ? void 0 : row.applicationNo) || (row === null || row === void 0 ? void 0 : row.applicationType) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, (row === null || row === void 0 ? void 0 : row.lastCreatedTime) || "-"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, getPendingDays(row === null || row === void 0 ? void 0 : row.lastCreatedTime)))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    slotProps: {
      select: {
        MenuProps: {
          sx: {
            zIndex: 100001
          }
        }
      }
    },
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (rowData === null || rowData === void 0 ? void 0 : rowData.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })));
};

const getModuleFromAppNo$1 = (appNo = "") => {
  if (!appNo || typeof appNo !== "string") return "Other";
  const upper = appNo.toUpperCase();
  if (upper.includes("COMP")) return "Compounding";
  if (upper.includes("LU")) return "Land Use";
  if (upper.includes("MS")) return "Map Submission";
  if (upper.includes("CC")) return "Completion";
  if (upper.includes("PF")) return "Purchasable FAR";
  return "Other";
};
const getModuleFromItem = item => {
  const appNo = (item === null || item === void 0 ? void 0 : item.applicationNo) || (item === null || item === void 0 ? void 0 : item.applicationId) || "";
  const fromAppNo = getModuleFromAppNo$1(appNo);
  if (fromAppNo !== "Other") return fromAppNo;
  const appType = ((item === null || item === void 0 ? void 0 : item.applicationType) || (item === null || item === void 0 ? void 0 : item.moduleName) || "").toUpperCase();
  if (appType.includes("COMPLETION") || appType.includes("FORM_COMPLETION")) return "Completion";
  if (appType.includes("COMPOUNDING") || appType.includes("FORM_COMPOUNDING")) return "Compounding";
  if (appType.includes("LANDUSE") || appType.includes("LAND_USE") || appType.includes("FORM_LANDUSE")) return "Land Use";
  if (appType.includes("MAP") || appType.includes("FORM_MAP")) return "Map Submission";
  if (appType.includes("PURCHASABLE") || appType.includes("FAR") || appType.includes("FORM_FAR")) return "Purchasable FAR";
  return "Other";
};
const formatRoleName = role => {
  if (!role || role === "-") return "Other / Unassigned";
  const r = role.trim();
  const upper = r.toUpperCase().replace(/[_\s-]+/g, "_");
  const roleMap = {
    JE: "Junior Engineer (JE)",
    AE: "Assistant Engineer (AE)",
    EE: "Executive Engineer (EE)",
    SE: "Superintending Engineer (SE)",
    CE: "Chief Engineer (CE)",
    APA: "Assistant Town Planner (APA)",
    ATP: "Associate Town Planner (ATP)",
    CTP: "Chief Town Planner (CTP)",
    STP: "Senior Town Planner (STP)",
    DRAFTSMAN: "Draftsman",
    VICE_CHAIRMAN: "Vice Chairman",
    VC: "Vice Chairman",
    NODAL_OFFICER: "Nodal Officer"
  };
  if (roleMap[upper]) return roleMap[upper];
  return r.replace(/_/g, " ");
};
const getModuleColor = module => {
  switch (module) {
    case "Land Use":
      return {
        bg: "#ecfdf5",
        color: "#047857",
        border: "#a7f3d0"
      };
    case "Map Submission":
      return {
        bg: "#eff6ff",
        color: "#1d4ed8",
        border: "#bfdbfe"
      };
    case "Completion":
      return {
        bg: "#faf5ff",
        color: "#7e22ce",
        border: "#e9d5ff"
      };
    case "Compounding":
      return {
        bg: "#fffbeb",
        color: "#b45309",
        border: "#fde68a"
      };
    case "Purchasable FAR":
      return {
        bg: "#eef2ff",
        color: "#4338ca",
        border: "#c7d2fe"
      };
    default:
      return {
        bg: "#f1f5f9",
        color: "#475569",
        border: "#cbd5e1"
      };
  }
};
const MODULE_OPTIONS = [{
  value: "ALL",
  label: "All Modules"
}, {
  value: "Land Use",
  label: "Land Use (LU)"
}, {
  value: "Map Submission",
  label: "Map Submission (MS)"
}, {
  value: "Completion",
  label: "Completion (CC)"
}, {
  value: "Compounding",
  label: "Compounding (COMP)"
}, {
  value: "Purchasable FAR",
  label: "Purchasable FAR (PF)"
}];
const ProgreesWithOfficer = ({
  tenantId,
  userDetails,
  location,
  department,
  onApplicationSelect,
  dashboardData: _dashboardData = [],
  fromDate,
  toDate,
  selectedApplicationType,
  moduleFilter: externalModuleFilter,
  onModuleChange
}) => {
  var _Digit$UserService$ge;
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const [internalModule, setInternalModule] = useState("ALL");
  const [searchQuery, setSearchQuery] = useState("");
  const [collapsedRoles, setCollapsedRoles] = useState({});
  const requestKeyRef = useRef("");
  const isFetchingRef = useRef(false);
  const selectedModule = externalModuleFilter !== undefined ? externalModuleFilter : internalModule;
  const handleModuleChange = newModule => {
    if (onModuleChange) {
      onModuleChange(newModule);
    }
    setInternalModule(newModule);
  };
  const toggleRoleCollapse = roleKey => {
    setCollapsedRoles(prev => ({
      ...prev,
      [roleKey]: !prev[roleKey]
    }));
  };
  const columns = [{
    id: "srNo",
    label: "Sr. No.",
    width: "70px",
    align: "center"
  }, {
    id: "name",
    label: "Name",
    align: "left"
  }, {
    id: "designation",
    label: "Designation",
    width: "160px",
    align: "left"
  }, {
    id: "module",
    label: "Module",
    width: "240px",
    align: "left"
  }, {
    id: "numberOfFiles",
    label: "Number Of files",
    width: "140px",
    align: "right"
  }];
  const inProgressApps = useMemo(() => {
    return (_dashboardData || []).filter(item => {
      const main = (item.mainDashBoardStatus || "").toLowerCase();
      const dash = (item.dashboardStatus || "").toLowerCase();
      const sub = (item.status || "").toLowerCase();
      const subDash = (item.subDashBoardStatus || "").toLowerCase();
      return main.includes("in progress with officer") || main.includes("in progress with officers") || dash.includes("in progress with officer") || dash.includes("in progress with officers") || sub.includes("in progress with officer") || sub.includes("in progress with officers") || subDash.includes("in progress with officer") || subDash.includes("in progress with officers") || sub.includes("forward");
    });
  }, [_dashboardData]);
  const filteredApps = useMemo(() => {
    if (!selectedModule || selectedModule === "ALL") return inProgressApps;
    return inProgressApps.filter(item => getModuleFromItem(item) === selectedModule);
  }, [inProgressApps, selectedModule]);
  const roleGroups = useMemo(() => {
    if (!_dashboardData || _dashboardData.length === 0) return null;
    const roleMap = {};
    filteredApps.forEach(item => {
      let assigneeName = item.lastUserName || item.employeName || item.assigneeName || item.currentAssigneeName;
      let roleId = item.lastUserDesignation || item.employeRole || item.roleId;
      if (!assigneeName && item.status && item.status.includes("Pending with")) {
        const match = item.status.match(/Pending with \((.*?)\)(?:\s*\((.*?)\))?/i);
        if (match) {
          assigneeName = match[1];
          if (!roleId && match[2]) roleId = match[2];
        }
      }
      if (!assigneeName && item.status && item.status.toLowerCase().includes("forward")) {
        const forwardMatch = item.status.match(/Forward\s+(?:To\s+)?([A-Za-z_]+)/i);
        if (forwardMatch) {
          assigneeName = forwardMatch[1];
          if (!roleId) roleId = forwardMatch[1];
        }
      }
      assigneeName = (assigneeName || "Unassigned").trim();
      roleId = (roleId || "-").trim();
      const roleKey = roleId.toUpperCase();
      const roleDisplayName = formatRoleName(roleId);
      const moduleName = getModuleFromItem(item);
      if (!roleMap[roleKey]) {
        roleMap[roleKey] = {
          roleKey,
          roleId,
          roleDisplayName,
          totalFiles: 0,
          allApplicationNumbers: [],
          officersMap: {}
        };
      }
      roleMap[roleKey].totalFiles += 1;
      if (item.applicationNo) {
        roleMap[roleKey].allApplicationNumbers.push(item.applicationNo);
      }
      if (!roleMap[roleKey].officersMap[assigneeName]) {
        roleMap[roleKey].officersMap[assigneeName] = {
          assigneeName,
          roleId,
          numberOfApplication: 0,
          applicationNumber: [],
          moduleCounts: {},
          moduleApplications: {}
        };
      }
      const officer = roleMap[roleKey].officersMap[assigneeName];
      officer.numberOfApplication += 1;
      if (item.applicationNo) {
        officer.applicationNumber.push(item.applicationNo);
      }
      officer.moduleCounts[moduleName] = (officer.moduleCounts[moduleName] || 0) + 1;
      if (!officer.moduleApplications[moduleName]) {
        officer.moduleApplications[moduleName] = [];
      }
      if (item.applicationNo) {
        officer.moduleApplications[moduleName].push(item.applicationNo);
      }
    });
    return Object.values(roleMap).map(roleGroup => {
      let officers = Object.values(roleGroup.officersMap).sort((a, b) => b.numberOfApplication - a.numberOfApplication);
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase().trim();
        officers = officers.filter(off => off.assigneeName.toLowerCase().includes(q) || off.roleId.toLowerCase().includes(q));
      }
      return {
        ...roleGroup,
        officers
      };
    }).filter(roleGroup => roleGroup.officers.length > 0).sort((a, b) => b.totalFiles - a.totalFiles);
  }, [_dashboardData, filteredApps, searchQuery]);
  const fallbackRoleGroups = useMemo(() => {
    if (roleGroups !== null) return roleGroups;
    if (!tableData || tableData.length === 0) return null;
    const roleMap = {};
    tableData.forEach(item => {
      const assigneeName = (item.assigneeName || item.employeName || "Unassigned").trim();
      const roleId = (item.roleId || item.employeRole || "-").trim();
      const apps = Array.isArray(item.applicationNumber) ? item.applicationNumber : [];
      const matchedApps = apps.filter(appNo => {
        if (!selectedModule || selectedModule === "ALL") return true;
        return getModuleFromAppNo$1(appNo) === selectedModule;
      });
      if (matchedApps.length === 0 && selectedModule !== "ALL") return;
      const roleKey = roleId.toUpperCase();
      const roleDisplayName = formatRoleName(roleId);
      if (!roleMap[roleKey]) {
        roleMap[roleKey] = {
          roleKey,
          roleId,
          roleDisplayName,
          totalFiles: 0,
          allApplicationNumbers: [],
          officersMap: {}
        };
      }
      roleMap[roleKey].totalFiles += matchedApps.length;
      roleMap[roleKey].allApplicationNumbers.push(...matchedApps);
      if (!roleMap[roleKey].officersMap[assigneeName]) {
        roleMap[roleKey].officersMap[assigneeName] = {
          assigneeName,
          roleId,
          numberOfApplication: 0,
          applicationNumber: [],
          moduleCounts: {},
          moduleApplications: {}
        };
      }
      const officer = roleMap[roleKey].officersMap[assigneeName];
      officer.numberOfApplication += matchedApps.length;
      officer.applicationNumber.push(...matchedApps);
      matchedApps.forEach(appNo => {
        const mod = getModuleFromAppNo$1(appNo);
        officer.moduleCounts[mod] = (officer.moduleCounts[mod] || 0) + 1;
        if (!officer.moduleApplications[mod]) officer.moduleApplications[mod] = [];
        officer.moduleApplications[mod].push(appNo);
      });
    });
    return Object.values(roleMap).map(roleGroup => {
      let officers = Object.values(roleGroup.officersMap).sort((a, b) => b.numberOfApplication - a.numberOfApplication);
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase().trim();
        officers = officers.filter(off => off.assigneeName.toLowerCase().includes(q) || off.roleId.toLowerCase().includes(q));
      }
      return {
        ...roleGroup,
        officers
      };
    }).filter(roleGroup => roleGroup.officers.length > 0).sort((a, b) => b.totalFiles - a.totalFiles);
  }, [roleGroups, tableData, selectedModule, searchQuery]);
  const displayRoleGroups = roleGroups !== null ? roleGroups : fallbackRoleGroups;
  const totalDisplayedFiles = useMemo(() => {
    if (!displayRoleGroups) return 0;
    return displayRoleGroups.reduce((acc, curr) => acc + curr.totalFiles, 0);
  }, [displayRoleGroups]);
  useEffect(() => {
    if (!tenantId || !department || !userDetails) return;
    const requestKey = `${tenantId}-${location}-${department}-${userDetails === null || userDetails === void 0 ? void 0 : userDetails.uuid}-${fromDate}-${toDate}-${selectedApplicationType}`;
    if (requestKeyRef.current === requestKey) {
      return;
    }
    requestKeyRef.current = requestKey;
    getPendingFilesData(tenantId, location, department, userDetails);
  }, [tenantId, location, department, userDetails === null || userDetails === void 0 ? void 0 : userDetails.uuid, fromDate, toDate, selectedApplicationType]);
  const getPendingFilesData = async (tenantId, location = "All", department, userDetails) => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    try {
      setLoading(true);
      const postData = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          msgId: "1781850252247|en_IN",
          userInfo: {
            ...userDetails,
            active: true,
            tenantId,
            permanentCity: null
          }
        }
      };
      const queryParams = new URLSearchParams({
        department
      });
      if (location !== "All") {
        queryParams.append("location", location);
      }
      const res = await axios$1.post(`${Urls$1.obps.employeeWorkflowCount}?${queryParams.toString()}`, postData);
      setTableData((res === null || res === void 0 ? void 0 : res.data) || []);
    } catch (err) {
      console.error(err);
      setTableData([]);
    } finally {
      isFetchingRef.current = false;
      setLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && (!_dashboardData || _dashboardData.length === 0) ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Loader, null)) : /*#__PURE__*/React__default.createElement(Paper$2, {
    elevation: 0,
    sx: {
      border: "1px solid #e0e0e0",
      borderRadius: "12px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1.5,
      px: 2.5,
      py: 1.2,
      background: "#f8fafc",
      borderBottom: "1px solid #e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    sx: {
      fontWeight: 600,
      fontSize: "13px",
      color: "#64748b"
    }
  }, "Officers categorized by designation \u2022 Total ", totalDisplayedFiles, " pending file", totalDisplayedFiles === 1 ? "" : "s"), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(TextField$1, {
    size: "small",
    placeholder: "Search officer name or role...",
    value: searchQuery,
    onChange: e => setSearchQuery(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          fontSize: 18,
          color: "#64748b"
        }
      }))
    },
    sx: {
      width: 250,
      "& .MuiOutlinedInput-root": {
        height: 34,
        fontSize: "12.5px",
        backgroundColor: "#fff",
        borderRadius: "8px"
      }
    }
  }), externalModuleFilter === undefined && /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 0.8
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    sx: {
      fontWeight: 700,
      fontSize: "12.5px",
      color: "#475569"
    }
  }, "Module:"), /*#__PURE__*/React__default.createElement(Select$2, {
    value: selectedModule,
    onChange: e => handleModuleChange(e.target.value),
    size: "small",
    sx: {
      height: 34,
      minWidth: 180,
      fontSize: "12.5px",
      fontWeight: 600,
      borderRadius: "8px",
      backgroundColor: "#fff"
    }
  }, MODULE_OPTIONS.map(opt => /*#__PURE__*/React__default.createElement(MenuItem$3, {
    key: opt.value,
    value: opt.value,
    sx: {
      fontSize: "13px"
    }
  }, opt.label)))))), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    sx: {
      maxHeight: 600
    }
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    sx: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, null, columns.map(col => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: col.id,
    sx: {
      backgroundColor: "#1f4a7c",
      color: "#fff",
      fontWeight: 700,
      fontSize: "13px",
      py: 1.2,
      px: 2,
      width: col.width || "auto",
      textAlign: col.align || "left",
      borderBottom: "2px solid #153a63"
    }
  }, col.label)))), /*#__PURE__*/React__default.createElement(TableBody$2, null, displayRoleGroups && displayRoleGroups.length > 0 ? displayRoleGroups.map(group => {
    const isCollapsed = Boolean(collapsedRoles[group.roleKey]);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: group.roleKey
    }, /*#__PURE__*/React__default.createElement(TableRow$2, {
      onClick: () => toggleRoleCollapse(group.roleKey),
      sx: {
        backgroundColor: "#fffde7 !important",
        borderTop: "2px solid #fbc02d",
        borderBottom: "1.5px solid #fbc02d",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        "&:hover": {
          backgroundColor: "#fff9c4 !important"
        }
      }
    }, /*#__PURE__*/React__default.createElement(TableCell$2, {
      colSpan: 3,
      sx: {
        py: 1.2,
        px: 2,
        fontWeight: 800,
        fontSize: "14px",
        color: "#422006",
        letterSpacing: "0.4px"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        color: "#b45309",
        fontSize: "12px",
        fontWeight: "bold"
      }
    }, isCollapsed ? "▶" : "▼"), /*#__PURE__*/React__default.createElement(Box$1, {
      component: "span",
      sx: {
        textTransform: "uppercase"
      }
    }, group.roleDisplayName), /*#__PURE__*/React__default.createElement(Box$1, {
      component: "span",
      sx: {
        ml: 1,
        px: 1,
        py: 0.2,
        fontSize: "11px",
        fontWeight: 600,
        borderRadius: "12px",
        backgroundColor: "#fef08a",
        color: "#854d0e",
        border: "1px solid #fde047"
      }
    }, group.officers.length, " ", group.officers.length === 1 ? "Officer" : "Officers"))), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        py: 1.2,
        px: 2,
        fontWeight: 700,
        fontSize: "13px",
        color: "#854d0e"
      }
    }, selectedModule === "ALL" ? "All Modules" : selectedModule), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        py: 1.2,
        px: 2,
        textAlign: "right",
        fontWeight: 900,
        fontSize: "15px",
        color: "#0284c7"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      component: "span",
      title: "Click to view all applications for this role",
      onClick: e => {
        e.stopPropagation();
        setApplications(group.allApplicationNumbers);
        setShowModal(true);
      },
      sx: {
        cursor: "pointer",
        px: 1.2,
        py: 0.3,
        borderRadius: "6px",
        backgroundColor: "#e0f2fe",
        border: "1px solid #bae6fd",
        fontWeight: 800,
        color: "#0369a1",
        "&:hover": {
          backgroundColor: "#bae6fd",
          textDecoration: "underline"
        }
      }
    }, group.totalFiles))), !isCollapsed && group.officers.map((officer, officerIdx) => /*#__PURE__*/React__default.createElement(TableRow$2, {
      key: `${group.roleKey}_${officer.assigneeName}_${officerIdx}`,
      sx: {
        backgroundColor: officerIdx % 2 === 0 ? "#ffffff" : "#f8fafc",
        "&:hover": {
          backgroundColor: "#f1f5f9"
        }
      }
    }, /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        textAlign: "center",
        fontSize: "13px",
        color: "#64748b",
        py: 1.1,
        px: 2
      }
    }, officerIdx + 1), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        fontWeight: 600,
        fontSize: "13.5px",
        color: "#1e293b",
        py: 1.1,
        px: 2
      }
    }, officer.assigneeName), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        fontSize: "13px",
        color: "#475569",
        py: 1.1,
        px: 2
      }
    }, officer.roleId), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        py: 1.1,
        px: 2
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        display: "flex",
        flexWrap: "wrap",
        gap: 0.6
      }
    }, Object.entries(officer.moduleCounts).map(([modName, count]) => {
      const colors = getModuleColor(modName);
      return /*#__PURE__*/React__default.createElement(Box$1, {
        key: modName,
        onClick: e => {
          e.stopPropagation();
          setApplications(officer.moduleApplications[modName] || []);
          setShowModal(true);
        },
        title: `Click to view ${count} ${modName} application(s)`,
        sx: {
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          px: 1,
          py: 0.25,
          borderRadius: "6px",
          fontSize: "12px",
          fontWeight: 600,
          backgroundColor: colors.bg,
          color: colors.color,
          border: `1px solid ${colors.border}`,
          cursor: "pointer",
          transition: "all 0.15s ease",
          "&:hover": {
            boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
            transform: "translateY(-1px)"
          }
        }
      }, /*#__PURE__*/React__default.createElement("span", null, modName), selectedModule === "ALL" && Object.keys(officer.moduleCounts).length > 1 && /*#__PURE__*/React__default.createElement("span", {
        style: {
          background: colors.color,
          color: "#fff",
          borderRadius: "10px",
          padding: "0 5px",
          fontSize: "10px",
          fontWeight: 700
        }
      }, count));
    }))), /*#__PURE__*/React__default.createElement(TableCell$2, {
      sx: {
        textAlign: "right",
        py: 1.1,
        px: 2
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      component: "span",
      onClick: () => {
        setApplications(officer.applicationNumber);
        setShowModal(true);
      },
      sx: {
        cursor: "pointer",
        fontWeight: 700,
        fontSize: "14px",
        color: "#0066cc",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    }, officer.numberOfApplication)))));
  }) : /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    colSpan: 5,
    sx: {
      textAlign: "center",
      fontWeight: 600,
      padding: "30px",
      color: "#64748b",
      fontSize: "14px"
    }
  }, "No In-Progress applications found ", selectedModule !== "ALL" ? `for ${selectedModule}` : "")))))), showModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React__default.createElement(EmployeePendingFiles, {
    applications: applications,
    tenantId: tenantId,
    onApplicationSelect: onApplicationSelect
  })));
};
var ProgreesWithOfficer$1 = React__default.memo(ProgreesWithOfficer);

const StyledTableCell$c = styled(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$c = styled(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  ":hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const AVPInProgressModal = ({
  isLoading,
  tableData,
  tenantId,
  onApplicationSelect
}) => {
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const columns = [{
    id: "srNo",
    label: "Sr. No."
  }, {
    id: "asignee",
    label: "Asignee Name"
  }, {
    id: "numberOfFiles",
    label: "Number Of files"
  }];
  console.log("Applications", applications);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Paper$1, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, null, /*#__PURE__*/React__default.createElement(Table$2, {
    className: "application-table",
    style: {
      width: "100%",
      tableLayout: "fixed"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, columns.map((col, index) => /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    key: col.id,
    style: {
      padding: "8px",
      textAlign: index === 0 ? "center" : "left",
      width: `${100 / columns.length}%`
    }
  }, col.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, tableData.map((item, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$c, {
    key: item.unit
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    align: "center"
  }, index + 1), /*#__PURE__*/React__default.createElement(StyledTableCell$c, null, item.assigneeName), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => {
      if (item.numberOfApplication === 0) {
        return;
      }
      setApplications(item.applicationNumber);
      setShowModal(true);
    },
    sx: {
      display: "inline-block",
      backgroundColor: item.numberOfApplication > 0 ? "#1976d220" : "#eeeeee",
      color: item.numberOfApplication > 0 ? "#1976d2" : "#999",
      fontWeight: 700,
      borderRadius: "12px",
      px: 1.5,
      py: 0.25,
      minWidth: 36,
      textAlign: "center",
      cursor: item.numberOfApplication > 0 ? "pointer" : "default",
      transition: "background 0.2s",
      "&:hover": {
        backgroundColor: item.numberOfApplication > 0 ? "#1976d240" : "#eeeeee",
        textDecoration: item.numberOfApplication > 0 ? "underline" : "none"
      }
    }
  }, item.numberOfApplication)))))))), showModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React__default.createElement(EmployeePendingFiles, {
    applications: applications === null || applications === void 0 ? void 0 : applications.split(",").map(item => item.trim()).filter(Boolean),
    tenantId: tenantId,
    onApplicationSelect: onApplicationSelect
  })));
};

const StyledTableCell$d = styled$2(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 15,
    fontWeight: 600
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$d = styled$2(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const AVPPendingWithOfficers = ({
  tenantId,
  userDetails,
  location,
  department,
  onApplicationSelect,
  dashboardData: _dashboardData = [],
  fromDate,
  toDate,
  selectedApplicationType
}) => {
  var _Digit$UserService$ge;
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const norm = s => (s || "").trim().toLowerCase();
  const buildOfficerSummary = (data = [], unit) => {
    const officers = new Map();
    data.filter(item => norm(item.location) === norm(unit)).forEach(item => {
      if (!officers.has(item.assignee)) officers.set(item.assignee, item);
    });
    return [...officers.values()].sort((a, b) => b.numberOfApplication - a.numberOfApplication);
  };
  const columns = [{
    id: "srNo",
    label: "Sr. No."
  }, {
    id: "unit",
    label: "Unit"
  }, {
    id: "numberOfFiles",
    label: "Number Of files"
  }];
  console.log("MainDashboard data", _dashboardData, tableData, applications);
  console.log("PROPS", location, department, tenantId, userDetails, onApplicationSelect);
  const inProgressApps = useMemo(() => {
    return _dashboardData.filter(item => (item === null || item === void 0 ? void 0 : item.mainDashBoardStatus) === "In Progress With Officers");
  }, [_dashboardData]);
  const unitSummary = useMemo(() => {
    const units = Array.from({
      length: 7
    }, (_, index) => `Unit ${index + 1}`);
    return units.map(unit => {
      const unitApplications = inProgressApps.filter(item => (item === null || item === void 0 ? void 0 : item.location1) === unit);
      return {
        unit,
        numberOfFiles: unitApplications.length,
        applicationNumber: unitApplications.map(item => item === null || item === void 0 ? void 0 : item.applicationNo).filter(Boolean)
      };
    });
  }, [inProgressApps]);
  const getUnitWorkflowCount = async unit => {
    console.log("UNIT !!", unit);
    try {
      setLoading(true);
      const postData = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          msgId: "1781850252247|en_IN",
          userInfo: {
            ...userDetails,
            active: true,
            tenantId,
            permanentCity: null
          }
        }
      };
      const queryParams = new URLSearchParams({
        department: "AVP",
        location1: unit
      });
      const res = await axios$1.post(`${Urls$1.obps.employeeWorkflowCount}?${queryParams.toString()}`, postData);
      const summary = buildOfficerSummary(res === null || res === void 0 ? void 0 : res.data, unit);
      setTableData(summary);
      if (summary.length > 0) setShowModal(true);
      console.log(`employeeWorkflowCount result for ${unit}:`, res === null || res === void 0 ? void 0 : res.data);
    } catch (err) {
      console.error(`Failed to fetch employeeWorkflowCount for ${unit}`, err);
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$1, null, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption",
    style: {
      display: "block",
      textAlign: "left"
    }
  }, "In Progress With Officer"), /*#__PURE__*/React__default.createElement(Table$4, {
    className: "application-table",
    style: {
      width: "100%",
      tableLayout: "fixed"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, columns.map((col, index) => /*#__PURE__*/React__default.createElement(StyledTableCell$d, {
    key: col.id,
    style: {
      padding: "8px",
      textAlign: index === 0 ? "center" : "left",
      width: `${100 / columns.length}%`
    }
  }, col.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, unitSummary.map((item, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$d, {
    key: item.assignee
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$d, {
    align: "center"
  }, index + 1), /*#__PURE__*/React__default.createElement(StyledTableCell$d, null, item.unit), /*#__PURE__*/React__default.createElement(StyledTableCell$d, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => {
      if (item.numberOfFiles === 0) {
        return;
      }
      getUnitWorkflowCount(item.unit);
    },
    sx: {
      display: "inline-block",
      backgroundColor: item.numberOfFiles > 0 ? "#1976d220" : "#eeeeee",
      color: item.numberOfFiles > 0 ? "#1976d2" : "#999",
      fontWeight: 700,
      borderRadius: "12px",
      px: 1.5,
      py: 0.25,
      minWidth: 36,
      textAlign: "center",
      cursor: item.numberOfFiles > 0 ? "pointer" : "default",
      transition: "background 0.2s",
      "&:hover": {
        backgroundColor: item.numberOfFiles > 0 ? "#1976d240" : "#eeeeee",
        textDecoration: item.numberOfFiles > 0 ? "underline" : "none"
      }
    }
  }, item.numberOfFiles))))))), showModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Application Details",
    dataOpen: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React__default.createElement(AVPInProgressModal, {
    isLoading: loading,
    onApplicationSelect: onApplicationSelect,
    tableData: tableData,
    tenantId: tenantId
  })));
};
var AVPPendingWithOfficers$1 = React__default.memo(AVPPendingWithOfficers);

dayjs.extend(customParseFormat);
const StyledTableCell$e = styled$1(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 15,
    fontWeight: 600
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$e = styled$1(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InProgressWithOfficerModal = ({
  dashboardData: _dashboardData = [],
  onApplicationSelect
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const inProgressRecords = useMemo(() => (_dashboardData || []).filter(item => {
    const main = (item.mainDashBoardStatus || "").toLowerCase();
    const dash = (item.dashboardStatus || "").toLowerCase();
    const sub = (item.status || "").toLowerCase();
    const subDash = (item.subDashBoardStatus || "").toLowerCase();
    return main.includes("in progress with officer") || main.includes("in progress with officers") || main.includes("in_progress_with_officer") || dash.includes("in progress with officer") || dash.includes("in progress with officers") || sub.includes("in progress with officer") || subDash.includes("in progress with officer");
  }), [_dashboardData]);
  const getPendingDays = item => {
    var _item$auditDetails, _item$auditDetails2;
    const dateVal = (item === null || item === void 0 ? void 0 : item.lastCreatedTime) || (item === null || item === void 0 ? void 0 : item.createdTime) || (item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.lastModifiedTime);
    if (!dateVal) return -1;
    if (typeof dateVal === "number" && dateVal > 0) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = new Date(dateVal);
      d.setHours(0, 0, 0, 0);
      return Math.max(0, Math.floor((today.getTime() - d.getTime()) / 86400000));
    }
    if (typeof dateVal === "string" && /^\d{10,14}$/.test(dateVal.trim())) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = new Date(Number(dateVal.trim()));
      d.setHours(0, 0, 0, 0);
      return Math.max(0, Math.floor((today.getTime() - d.getTime()) / 86400000));
    }
    const s = String(dateVal).trim();
    const parts = s.split(/[-/]/);
    if (parts.length === 3) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = parts[0].length === 4 ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])) : new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      d.setHours(0, 0, 0, 0);
      if (!isNaN(d.getTime())) {
        return Math.max(0, Math.floor((today.getTime() - d.getTime()) / 86400000));
      }
    }
    const parsedDate = dayjs(dateVal);
    if (parsedDate.isValid()) {
      return Math.max(0, dayjs().startOf("day").diff(parsedDate.startOf("day"), "day"));
    }
    return -1;
  };
  const statusSummary = useMemo(() => {
    const map = {};
    inProgressRecords.forEach(item => {
      const statusKey = item.status || "Unknown";
      if (!map[statusKey]) {
        map[statusKey] = {
          count: 0,
          pending15Count: 0
        };
      }
      map[statusKey].count += 1;
      if (getPendingDays(item) >= 15) {
        map[statusKey].pending15Count += 1;
      }
    });
    return Object.entries(map).map(([status, {
      count,
      pending15Count
    }]) => ({
      status,
      count,
      pending15Count
    })).sort((a, b) => b.count - a.count);
  }, [inProgressRecords]);
  const totalFiles = inProgressRecords.length;
  const detailRecords = useMemo(() => {
    if (!selectedStatus) return [];
    return inProgressRecords.filter(item => (item.status || "Unknown") === selectedStatus);
  }, [selectedStatus, inProgressRecords]);
  console.log("Detail Records", detailRecords);
  const [fastPasIdSearch, setFastPasIdSearch] = useState("");
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: 2,
      minWidth: 400
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    sx: {
      mb: 2,
      color: "#444",
      fontWeight: 600
    }
  }, "Total In Progress Files: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#1976d2",
      fontWeight: 700
    }
  }, totalFiles)), statusSummary.length === 0 ? /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      textAlign: "center",
      color: "#999",
      py: 4
    }
  }, "No records found") : /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      borderRadius: "8px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    "aria-label": "in-progress-with-officer-table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyledTableCell$e, null, "Sr. No."), /*#__PURE__*/React__default.createElement(StyledTableCell$e, null, "Status"), /*#__PURE__*/React__default.createElement(StyledTableCell$e, {
    align: "center"
  }, "Files Count"), /*#__PURE__*/React__default.createElement(StyledTableCell$e, {
    align: "center"
  }, "No of files Pending > 15 Days"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, statusSummary.map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$e, {
    key: row.status
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$e, null, index + 1), /*#__PURE__*/React__default.createElement(StyledTableCell$e, null, row.status), /*#__PURE__*/React__default.createElement(StyledTableCell$e, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => setSelectedStatus(row.status),
    sx: {
      display: "inline-block",
      backgroundColor: "#1976d220",
      color: "#1976d2",
      fontWeight: 700,
      borderRadius: "12px",
      px: 1.5,
      py: 0.25,
      minWidth: 36,
      textAlign: "center",
      cursor: "pointer",
      transition: "background 0.2s",
      "&:hover": {
        backgroundColor: "#1976d240",
        textDecoration: "underline"
      }
    }
  }, row.count)), /*#__PURE__*/React__default.createElement(StyledTableCell$e, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "inline-block",
      backgroundColor: "#FFF4CC",
      color: "#9A6700",
      fontWeight: 700,
      borderRadius: "12px",
      px: 1.5,
      py: 0.25,
      minWidth: 36,
      textAlign: "center"
    }
  }, row.pending15Count))))))), selectedStatus && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    dataOpen: !!selectedStatus,
    onClose: () => setSelectedStatus(null),
    title: `In Progress — ${selectedStatus} (${detailRecords.length} records)`
  }, /*#__PURE__*/React__default.createElement(ApplicationTable$1, {
    dashboardData: detailRecords,
    filters: {},
    showMs: false,
    setshowMs: () => {},
    fastPasIdSearch: fastPasIdSearch,
    setFastPasIdSearch: setFastPasIdSearch,
    loading: false,
    onApplicationSelect: onApplicationSelect,
    isFromProgress: true
  })));
};

const StyledTableCell$f = styled$1(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 15,
    fontWeight: 600
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$f = styled$1(TableRow$1)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const dashboardData = [{
  id: null,
  applicationNo: "/BP/PF/2026-27/0010",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    createdTime: 1780469783610,
    lastModifiedTime: 1780469798451
  },
  department: "DA",
  createdUserName: "NAMAN R SRIVASTAVA",
  createdTime: "03-06-2026",
  lastUserName: null,
  lastCreatedTime: "03-06-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: null,
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "/BP/PF/2026-27/0011",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    createdTime: 1780473805269,
    lastModifiedTime: 1780473811493
  },
  department: "DA",
  createdUserName: "NAMAN R SRIVASTAVA",
  createdTime: "03-06-2026",
  lastUserName: null,
  lastCreatedTime: "03-06-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: null,
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "/BP/PF/2026-27/0012",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    createdTime: 1780474487216,
    lastModifiedTime: 1780474487216
  },
  department: "DA",
  createdUserName: "NAMAN R SRIVASTAVA",
  createdTime: "03-06-2026",
  lastUserName: null,
  lastCreatedTime: "03-06-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: null,
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0007",
  applicationType: "Purchasable FAR",
  status: "Pending with (Suresh Kumar Pandey) (JE)",
  auditDetails: {
    createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
    createdTime: 1776679501165,
    lastModifiedTime: 1776679547238
  },
  department: "DA",
  createdUserName: "NAMAN R SRIVASTAVA",
  createdTime: "20-04-2026",
  lastUserName: "Suresh Kumar Pandey",
  lastCreatedTime: "20-04-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "JE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0008",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "21085789-e841-4d29-9dc3-f44d8a761b0a",
    lastModifiedBy: "21085789-e841-4d29-9dc3-f44d8a761b0a",
    createdTime: 1777964841702,
    lastModifiedTime: 1777964841702
  },
  department: "DA",
  createdUserName: "Ajay",
  createdTime: "05-05-2026",
  lastUserName: null,
  lastCreatedTime: "05-05-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0013",
  applicationType: "Purchasable FAR",
  status: "Pending with (Lakshman Singh) (JE)",
  auditDetails: {
    createdBy: "d905b5f9-a42b-4c38-a302-0f4a17881d6a",
    lastModifiedBy: "d905b5f9-a42b-4c38-a302-0f4a17881d6a",
    createdTime: 1783664869988,
    lastModifiedTime: 1783665005772
  },
  department: "DA",
  createdUserName: "Yash",
  createdTime: "10-07-2026",
  lastUserName: "Lakshman Singh",
  lastCreatedTime: "10-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "JE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0014",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
    lastModifiedBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
    createdTime: 1784895608605,
    lastModifiedTime: 1784895608605
  },
  department: "DA",
  createdUserName: "Raj Singh",
  createdTime: "24-07-2026",
  lastUserName: null,
  lastCreatedTime: "24-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0015",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
    lastModifiedBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
    createdTime: 1784966021228,
    lastModifiedTime: 1784966021228
  },
  department: "DA",
  createdUserName: "Raj Singh",
  createdTime: "25-07-2026",
  lastUserName: null,
  lastCreatedTime: "25-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0016",
  applicationType: "Purchasable FAR",
  status: "Pending with (Ravi Sharma) (AE)",
  auditDetails: {
    createdBy: "3f2d8e19-9c12-4a76-b123-2d5f6e8a9012",
    lastModifiedBy: "3f2d8e19-9c12-4a76-b123-2d5f6e8a9012",
    createdTime: 1785052100000,
    lastModifiedTime: 1785052150000
  },
  department: "DA",
  createdUserName: "Amit Kumar",
  createdTime: "26-07-2026",
  lastUserName: "Ravi Sharma",
  lastCreatedTime: "26-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "AE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0017",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "4a2e7c11-8d34-4f52-a912-6c8e1b7d2304",
    lastModifiedBy: "4a2e7c11-8d34-4f52-a912-6c8e1b7d2304",
    createdTime: 1785138500000,
    lastModifiedTime: 1785138500000
  },
  department: "DA",
  createdUserName: "Vikas Singh",
  createdTime: "27-07-2026",
  lastUserName: null,
  lastCreatedTime: "27-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: null,
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0018",
  applicationType: "Purchasable FAR",
  status: "Pending with (Anil Verma) (JE)",
  auditDetails: {
    createdBy: "5b3f9a22-7e45-4c61-b823-8d9f2e6a3415",
    lastModifiedBy: "5b3f9a22-7e45-4c61-b823-8d9f2e6a3415",
    createdTime: 1785224900000,
    lastModifiedTime: 1785224950000
  },
  department: "DA",
  createdUserName: "Deepak Gupta",
  createdTime: "28-07-2026",
  lastUserName: "Anil Verma",
  lastCreatedTime: "28-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "JE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0019",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "6c4a1b33-9f56-4d72-c934-9e0f3b7a4526",
    lastModifiedBy: "6c4a1b33-9f56-4d72-c934-9e0f3b7a4526",
    createdTime: 1785311300000,
    lastModifiedTime: 1785311300000
  },
  department: "DA",
  createdUserName: "Pankaj Yadav",
  createdTime: "29-07-2026",
  lastUserName: null,
  lastCreatedTime: "29-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0020",
  applicationType: "Purchasable FAR",
  status: "Pending with (Neeraj Singh) (JE)",
  auditDetails: {
    createdBy: "7d5b2c44-8a67-4e83-d145-0f1a4c8b5637",
    lastModifiedBy: "7d5b2c44-8a67-4e83-d145-0f1a4c8b5637",
    createdTime: 1785397700000,
    lastModifiedTime: 1785397750000
  },
  department: "DA",
  createdUserName: "Rohit Mishra",
  createdTime: "30-07-2026",
  lastUserName: "Neeraj Singh",
  lastCreatedTime: "30-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "JE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Non Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0021",
  applicationType: "Purchasable FAR",
  status: "Document Uploaded",
  auditDetails: {
    createdBy: "8e6c3d55-9b78-4f94-e256-1a2b5d9c6748",
    lastModifiedBy: "8e6c3d55-9b78-4f94-e256-1a2b5d9c6748",
    createdTime: 1785484100000,
    lastModifiedTime: 1785484100000
  },
  department: "DA",
  createdUserName: "Sanjay Kumar",
  createdTime: "31-07-2026",
  lastUserName: null,
  lastCreatedTime: "31-07-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: null,
  mainDashBoardStatus: "Pending With Applicant",
  subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
  isRecievedFile: "false",
  riskType: null,
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "no",
  schemeType: "Scheme"
}, {
  id: null,
  applicationNo: "LDA/BP/PF/2026-27/0022",
  applicationType: "Purchasable FAR",
  status: "Pending with (Manoj Tiwari) (AE)",
  auditDetails: {
    createdBy: "9f7d4e66-ac89-4fa5-f367-2b3c6e0d7859",
    lastModifiedBy: "9f7d4e66-ac89-4fa5-f367-2b3c6e0d7859",
    createdTime: 1785570500000,
    lastModifiedTime: 1785570550000
  },
  department: "DA",
  createdUserName: "Arun Singh",
  createdTime: "01-08-2026",
  lastUserName: "Manoj Tiwari",
  lastCreatedTime: "01-08-2026",
  createdUserDesignation: "Architect",
  lastUserDesignation: "AE",
  mainDashBoardStatus: "In Progress With Officers",
  subDashBoardStatus: null,
  isRecievedFile: "true",
  riskType: "HIGH_NIVESH",
  location1: "Lucknow Development Authority",
  shortName: "LDA",
  businessService: "BPA_PURCHASEFAR_DA",
  employeName: null,
  employeRole: null,
  isGovernmentBuilding: "yes",
  schemeType: "Scheme"
}];
const LandUseApprovedSummary = () => {
  const fileTypeSummary = useMemo(() => {
    const counts = {
      "Government Buildings": 0,
      Scheme: 0,
      "Non-Scheme": 0
    };
    dashboardData.forEach(item => {
      if (String(item === null || item === void 0 ? void 0 : item.isGovernmentBuilding).toLowerCase() === "yes") {
        counts["Government Buildings"] += 1;
        return;
      }
      const schemeType = String((item === null || item === void 0 ? void 0 : item.schemeType) || "").trim().toLowerCase();
      if (schemeType === "scheme") {
        counts.Scheme += 1;
      } else if (schemeType === "non scheme" || schemeType === "non-scheme") {
        counts["Non-Scheme"] += 1;
      }
    });
    return Object.entries(counts).map(([type, count]) => ({
      type,
      count
    }));
  }, [dashboardData]);
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: 2,
      minWidth: 400
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    sx: {
      mb: 2,
      color: "#444",
      fontWeight: 600
    }
  }, "Total Approved Files: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#1976d2",
      fontWeight: 700
    }
  }, dashboardData.length)), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      borderRadius: "8px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    "aria-label": "land-use-approved-summary-table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyledTableCell$f, null, "Type of Files"), /*#__PURE__*/React__default.createElement(StyledTableCell$f, {
    align: "center"
  }, "Files Count"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, fileTypeSummary.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$f, {
    key: row.type
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$f, null, row.type), /*#__PURE__*/React__default.createElement(StyledTableCell$f, {
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "inline-block",
      backgroundColor: "#1976d220",
      color: "#1976d2",
      fontWeight: 700,
      borderRadius: "12px",
      px: 1.5,
      py: 0.25,
      minWidth: 36,
      textAlign: "center"
    }
  }, row.count))))))));
};

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

const parseAgeToDays = ageStr => {
  if (!ageStr) return 0;
  let days = 0;
  const yearMatch = ageStr.match(/(\d+)\s*year/);
  const monMatch = ageStr.match(/(\d+)\s*mon/);
  const dayMatch = ageStr.match(/(\d+)\s*day/);
  if (yearMatch) days += parseInt(yearMatch[1]) * 365;
  if (monMatch) days += parseInt(monMatch[1]) * 30;
  if (dayMatch) days += parseInt(dayMatch[1]);
  return days;
};
const computeDisposalBucketsFromMis = misData => {
  const counts = [0, 0, 0, 0];
  const bucketItems = [[], [], [], []];
  (misData || []).forEach(item => {
    const ageDays = parseAgeToDays(item.age);
    if (ageDays <= 7) {
      counts[0]++;
      bucketItems[0].push(item);
    } else if (ageDays <= 15) {
      counts[1]++;
      bucketItems[1].push(item);
    } else if (ageDays <= 30) {
      counts[2]++;
      bucketItems[2].push(item);
    } else {
      counts[3]++;
      bucketItems[3].push(item);
    }
  });
  return {
    buckets: [{
      label: "0 – 7 days",
      xLabel: ["0–7", "days"],
      count: counts[0],
      color: "#4CAF50",
      bg: "#e8f5e9",
      items: bucketItems[0]
    }, {
      label: "8 – 15 days",
      xLabel: ["8–15", "days"],
      count: counts[1],
      color: "#2196F3",
      bg: "#e3f2fd",
      items: bucketItems[1]
    }, {
      label: "16 – 30 days",
      xLabel: ["16–30", "days"],
      count: counts[2],
      color: "#FF9800",
      bg: "#fff3e0",
      items: bucketItems[2]
    }, {
      label: "More than 30 days",
      xLabel: [">30", "days"],
      count: counts[3],
      color: "#F44336",
      bg: "#ffebee",
      items: bucketItems[3]
    }],
    totalInProgress: (misData === null || misData === void 0 ? void 0 : misData.length) || 0
  };
};
function getDonutSlice(cx, cy, rOuter, rInner, startAngle, endAngle) {
  let angle = endAngle - startAngle;
  if (angle >= 360) angle = 359.99;
  if (angle <= 0) return "";
  const startRad = (startAngle - 90) * Math.PI / 180;
  const endRad = (startAngle + angle - 90) * Math.PI / 180;
  const x1 = cx + rOuter * Math.cos(startRad);
  const y1 = cy + rOuter * Math.sin(startRad);
  const x2 = cx + rOuter * Math.cos(endRad);
  const y2 = cy + rOuter * Math.sin(endRad);
  const x3 = cx + rInner * Math.cos(endRad);
  const y3 = cy + rInner * Math.sin(endRad);
  const x4 = cx + rInner * Math.cos(startRad);
  const y4 = cy + rInner * Math.sin(startRad);
  const largeArc = angle > 180 ? 1 : 0;
  return `M ${x1} ${y1} A ${rOuter} ${rOuter} 0 ${largeArc} 1 ${x2} ${y2} L ${x3} ${y3} A ${rInner} ${rInner} 0 ${largeArc} 0 ${x4} ${y4} Z`;
}
function getPieSlice(cx, cy, r, startAngle, endAngle) {
  let angle = endAngle - startAngle;
  if (angle >= 360) angle = 359.99;
  if (angle <= 0) return "";
  const startRad = (startAngle - 90) * Math.PI / 180;
  const endRad = (startAngle + angle - 90) * Math.PI / 180;
  const x1 = cx + r * Math.cos(startRad);
  const y1 = cy + r * Math.sin(startRad);
  const x2 = cx + r * Math.cos(endRad);
  const y2 = cy + r * Math.sin(endRad);
  const largeArc = angle > 180 ? 1 : 0;
  return `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
}
const DisposalBarChart = ({
  buckets,
  totalInProgress,
  onBucketClick
}) => {
  const CHART_H = 145;
  const maxCount = Math.max(...buckets.map(b => b.count), 1);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      px: 1,
      pt: 0.5
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      color: "#6b7280",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    }
  }, "File Disposal Timeline (Days)"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      color: "#9ca3af",
      fontWeight: 600
    }
  }, "Total: ", totalInProgress, " files")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "relative",
      height: `${CHART_H + 54}px`,
      display: "flex",
      alignItems: "flex-end",
      gap: "12px",
      pt: 2
    }
  }, [0, 25, 50, 75, 100].map(pct => /*#__PURE__*/React__default.createElement(Box, {
    key: pct,
    sx: {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: `${36 + pct / 100 * CHART_H}px`,
      height: "1px",
      background: "rgba(0, 0, 0, 0.05)",
      borderBottom: "1px dashed rgba(0,0,0,0.06)",
      zIndex: 0
    }
  })), buckets.map((b, i) => {
    const barHeightPx = b.count > 0 ? Math.max(Math.round(b.count / maxCount * CHART_H), 14) : 4;
    const showHeight = mounted ? `${barHeightPx}px` : "4px";
    return /*#__PURE__*/React__default.createElement(Box, {
      key: i,
      sx: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        zIndex: 1
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "14px",
        fontWeight: 800,
        color: b.count > 0 ? b.color : "#9ca3af",
        mb: 0.8,
        lineHeight: 1,
        opacity: mounted ? 1 : 0,
        transform: mounted ? "none" : "translateY(8px)",
        transition: `all 0.4s ease ${0.2 + i * 0.1}s`
      }
    }, b.count), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: "58%",
        minWidth: "22px",
        maxWidth: "46px",
        borderRadius: "8px 8px 0 0",
        height: showHeight,
        background: b.count > 0 ? `linear-gradient(180deg, ${b.color} 0%, ${b.color}cc 100%)` : "#e5e7eb",
        boxShadow: b.count > 0 ? `0 -3px 12px ${b.color}40` : "none",
        transition: `height 0.75s cubic-bezier(0.34, 1.56, 0.64, 1) ${i * 0.09}s`,
        position: "relative",
        overflow: "hidden",
        cursor: b.count > 0 ? "pointer" : "default",
        "&:hover": {
          filter: b.count > 0 ? "brightness(1.1)" : "none",
          transform: b.count > 0 ? "scaleY(1.025)" : "none"
        }
      },
      onClick: () => {
        if (b.count > 0 && onBucketClick) {
          onBucketClick(b);
        }
      }
    }, b.count > 0 && /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "40%",
        background: "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, transparent 100%)"
      }
    })), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        mt: 1,
        textAlign: "center",
        height: "30px"
      }
    }, b.xLabel.map((txt, ti) => /*#__PURE__*/React__default.createElement(Typography, {
      key: ti,
      sx: {
        fontSize: "10px",
        color: "#4b5563",
        fontWeight: 700,
        lineHeight: 1.3
      }
    }, txt))));
  })), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      textAlign: "center",
      color: "#9ca3af",
      fontSize: "10px",
      fontWeight: 700,
      mt: 0.5,
      letterSpacing: "0.5px",
      textTransform: "uppercase"
    }
  }, "Creation Date \u2192 Today (In Progress With Officers)"));
};
const DisposalDonutChart = ({
  buckets,
  totalInProgress,
  onBucketClick
}) => {
  var _buckets$;
  const [viewMode, setViewMode] = useState("donut");
  const [mounted, setMounted] = useState(false);
  const [hoveredIdx, setHoveredIdx] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);
  const total = totalInProgress;
  const cx = 90;
  const cy = 90;
  const rOuter = 78;
  const rInner = viewMode === "donut" ? 48 : 0;
  let currentAngle = 0;
  const slices = buckets.map((b, i) => {
    const pct = total > 0 ? b.count / total : 0;
    const sweep = pct * 360;
    const startAngle = currentAngle;
    const endAngle = currentAngle + sweep;
    currentAngle += sweep;
    const pathD = viewMode === "donut" ? getDonutSlice(cx, cy, rOuter, rInner, startAngle, endAngle) : getPieSlice(cx, cy, rOuter, startAngle, endAngle);
    return {
      ...b,
      pct,
      startAngle,
      endAngle,
      sweep,
      pathD
    };
  });
  const withinCount = buckets.slice(0, 3).reduce((s, b) => s + b.count, 0);
  const withinPct = total > 0 ? (withinCount / total * 100).toFixed(1) : "0.0";
  const overdueCount = ((_buckets$ = buckets[3]) === null || _buckets$ === void 0 ? void 0 : _buckets$.count) || 0;
  return /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      color: "#6b7280",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    }
  }, "File Disposal Distribution"), /*#__PURE__*/React__default.createElement(ButtonGroup, {
    size: "small",
    variant: "outlined",
    sx: {
      height: 26
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: () => setViewMode("donut"),
    sx: {
      px: 1,
      py: 0,
      fontSize: "10px",
      fontWeight: 700,
      textTransform: "none",
      background: viewMode === "donut" ? "#1976d2" : "transparent",
      color: viewMode === "donut" ? "#fff" : "#1976d2",
      borderColor: "#1976d2 !important",
      "&:hover": {
        background: viewMode === "donut" ? "#1565c0" : "rgba(25,118,210,0.08)"
      }
    },
    startIcon: /*#__PURE__*/React__default.createElement(DonutLargeIcon, {
      sx: {
        fontSize: 13
      }
    })
  }, "Donut"), /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: () => setViewMode("pie"),
    sx: {
      px: 1,
      py: 0,
      fontSize: "10px",
      fontWeight: 700,
      textTransform: "none",
      background: viewMode === "pie" ? "#1976d2" : "transparent",
      color: viewMode === "pie" ? "#fff" : "#1976d2",
      borderColor: "#1976d2 !important",
      "&:hover": {
        background: viewMode === "pie" ? "#1565c0" : "rgba(25,118,210,0.08)"
      }
    },
    startIcon: /*#__PURE__*/React__default.createElement(PieChartIcon, {
      sx: {
        fontSize: 13
      }
    })
  }, "Pie"))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      gap: 2,
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "relative",
      width: 180,
      height: 180,
      flexShrink: 0
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "180",
    height: "180",
    viewBox: "0 0 180 180",
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("filter", {
    id: "fdtShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React__default.createElement("feDropShadow", {
    dx: "0",
    dy: "2",
    stdDeviation: "3",
    floodOpacity: "0.18"
  }))), total === 0 && /*#__PURE__*/React__default.createElement("circle", {
    cx: cx,
    cy: cy,
    r: viewMode === "donut" ? 63 : 78,
    fill: viewMode === "donut" ? "none" : "#f3f4f6",
    stroke: "#e5e7eb",
    strokeWidth: viewMode === "donut" ? 28 : 2,
    strokeDasharray: "5 5"
  }), total > 0 && slices.map((seg, i) => {
    if (seg.count === 0 || !seg.pathD) return null;
    const isHovered = hoveredIdx === i;
    return /*#__PURE__*/React__default.createElement("path", {
      key: i,
      d: seg.pathD,
      fill: seg.color,
      stroke: "#ffffff",
      strokeWidth: viewMode === "donut" ? "2" : "1.5",
      filter: isHovered ? "url(#fdtShadow)" : "none",
      style: {
        cursor: "pointer",
        transition: "transform 0.25s ease, opacity 0.25s ease",
        transformOrigin: `${cx}px ${cy}px`,
        transform: isHovered ? "scale(1.04)" : "scale(1)",
        opacity: mounted ? 1 : 0
      },
      onMouseEnter: () => setHoveredIdx(i),
      onMouseLeave: () => setHoveredIdx(null),
      onClick: () => {
        if (seg.count > 0 && onBucketClick) {
          onBucketClick(seg);
        }
      }
    });
  })), viewMode === "donut" && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      pointerEvents: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 900,
      fontSize: "22px",
      color: "#d97706",
      lineHeight: 1
    }
  }, totalInProgress), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "9px",
      color: "#6b7280",
      fontWeight: 700,
      letterSpacing: "0.3px",
      mt: 0.3
    }
  }, "In Progress"))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: 1
    }
  }, buckets.map((b, i) => {
    const pct = total > 0 ? (b.count / total * 100).toFixed(1) : "0.0";
    const isHovered = hoveredIdx === i;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: i,
      onMouseEnter: () => setHoveredIdx(i),
      onMouseLeave: () => setHoveredIdx(null),
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 0.8,
        px: 1,
        borderRadius: "8px",
        borderBottom: i < 3 ? "1px solid rgba(0,0,0,0.05)" : "none",
        background: isHovered ? "rgba(0,0,0,0.03)" : "transparent",
        cursor: b.count > 0 ? "pointer" : "default",
        transition: "background 0.2s ease"
      },
      onClick: () => {
        if (b.count > 0 && onBucketClick) {
          onBucketClick(b);
        }
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: b.color,
        flexShrink: 0,
        boxShadow: `0 0 5px ${b.color}70`
      }
    }), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "11px",
        color: "#374151",
        fontWeight: 600
      }
    }, b.label)), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1.5
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "13px",
        fontWeight: 800,
        color: "#111827"
      }
    }, b.count), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "11px",
        fontWeight: 700,
        color: b.color,
        minWidth: "42px",
        textAlign: "right"
      }
    }, pct, "%")));
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1.2,
      pt: 1,
      borderTop: "1.5px solid rgba(0,0,0,0.06)",
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(CheckCircleIcon, {
    sx: {
      color: "#2e7d32",
      fontSize: 18
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      color: "#4b5563",
      fontWeight: 600
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span",
    sx: {
      fontWeight: 800,
      color: "#2e7d32",
      fontSize: "13px"
    }
  }, withinCount), " ", "files within 30 days")), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "14px",
      fontWeight: 900,
      color: "#2e7d32"
    }
  }, withinPct, "%")), overdueCount > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 0.8,
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(WarningAmberIcon, {
    sx: {
      color: "#f44336",
      fontSize: 17
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      color: "#f44336",
      fontWeight: 700
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "span",
    sx: {
      fontWeight: 900,
      fontSize: "13px"
    }
  }, overdueCount), " ", "files overdue (>30 days)")))));
};
const FileDisposalTimeline = ({
  data,
  location
}) => {
  var _selectedBucket$items;
  const [misData, setMisData] = useState([]);
  const [selectedBucket, setSelectedBucket] = useState(null);
  const [moduleFilter, setModuleFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    control,
    handleSubmit,
    watch
  } = useForm();
  const {
    buckets,
    totalInProgress
  } = useMemo(() => computeDisposalBucketsFromMis(misData), [misData]);
  const fetchMisData = async (modName = "") => {
    try {
      var _location$split;
      setIsLoading(true);
      const userInfo = window.Digit.UserService.getUser();
      const requestBody = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken: userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token,
          userInfo: userInfo === null || userInfo === void 0 ? void 0 : userInfo.info,
          msgId: "1790863310923|en_IN"
        }
      };
      const userDetails = window.Digit.SessionStorage.get("USER_DETAIL");
      const isUnitSelected = location === null || location === void 0 ? void 0 : location.startsWith("Unit-");
      const district = location === "All" || location === "Uttar Pradesh Awas and Evam Vikas Parishad" ? "" : isUnitSelected ? location.replace("-", " ") : (userDetails === null || userDetails === void 0 ? void 0 : userDetails.location1) || (location === null || location === void 0 ? void 0 : (_location$split = location.split(" ")) === null || _location$split === void 0 ? void 0 : _location$split[0]);
      const locationParam = encodeURIComponent(district || "");
      const moduleParam = encodeURIComponent(modName || "");
      const response = await fetch(`/bpa-services/v1/bpa/_extarctMisDataForPendingFile?location=${locationParam}&moduleName=${moduleParam}&age=&action=&status=&businessId=`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      });
      const responseData = await response.json();
      console.log("MIS Data API Response:", responseData);
      if (responseData !== null && responseData !== void 0 && responseData.MisDataForPendingFile) {
        const filteredData = responseData.MisDataForPendingFile.filter(item => {
          var _item$status, _item$status$toUpperC;
          return item === null || item === void 0 ? void 0 : (_item$status = item.status) === null || _item$status === void 0 ? void 0 : (_item$status$toUpperC = _item$status.toUpperCase()) === null || _item$status$toUpperC === void 0 ? void 0 : _item$status$toUpperC.includes("FORWARD");
        });
        setMisData(filteredData);
      } else {
        setMisData([]);
      }
    } catch (error) {
      console.error("Error fetching MIS data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchMisData(moduleFilter);
  }, [location]);
  const onSearch = formData => {
    var _formData$modulename;
    console.log("FileDisposalTimeline onSearch formData:", formData);
    const selectedModule = (formData === null || formData === void 0 ? void 0 : (_formData$modulename = formData.modulename) === null || _formData$modulename === void 0 ? void 0 : _formData$modulename.value) || (formData === null || formData === void 0 ? void 0 : formData.modulename) || "";
    setModuleFilter(selectedModule);
    fetchMisData(selectedModule);
  };
  const panelSx = {
    borderRadius: "16px",
    border: "1px solid rgba(25,118,210,0.12)",
    background: "linear-gradient(140deg,#ffffff 0%,#f8fbff 100%)",
    p: 2.5,
    boxShadow: "0 4px 22px rgba(0,0,0,0.07)",
    height: "100%",
    animation: "fdtPanelIn 0.55s cubic-bezier(.4,0,.2,1) both",
    "@keyframes fdtPanelIn": {
      from: {
        opacity: 0,
        transform: "translateY(20px)"
      },
      to: {
        opacity: 1,
        transform: "translateY(0)"
      }
    }
  };
  const PanelHeader = ({
    subtitle
  }) => /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      mb: 0.8
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 32,
      height: 32,
      borderRadius: "9px",
      background: "linear-gradient(135deg,#d97706,#fbbf24)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 3px 8px rgba(217,119,6,0.45)"
    }
  }, /*#__PURE__*/React__default.createElement(AccessTimeIcon, {
    sx: {
      fontSize: 18,
      color: "#fff"
    }
  })), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 700,
      fontSize: "14px",
      color: "#1565c0",
      lineHeight: 1.2
    }
  }, "File Disposal Time Line"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10px",
      color: "#9ca3af",
      fontWeight: 500
    }
  }, subtitle || "In Progress With Officer — by creation date")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      ml: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Chip, {
    size: "small",
    label: `${totalInProgress} In Progress`,
    sx: {
      background: "linear-gradient(135deg,#d97706,#fbbf24)",
      color: "#fff",
      fontWeight: 700,
      fontSize: "10px",
      boxShadow: "0 2px 8px rgba(217,119,6,0.4)",
      height: 22
    }
  }))));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Box, {
    component: "form",
    onSubmit: handleSubmit(onSearch),
    sx: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: 2,
      mb: 3
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 300,
      '& > div': {
        mb: 0
      }
    }
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Module Name",
    control: control,
    placeholder: "Select Module Name",
    data: [{
      value: 'Land Use',
      label: 'Land Use'
    }, {
      value: 'Map Submisssion High risk',
      label: 'Map Submisssion High risk'
    }, {
      value: 'Plinth Submission',
      label: 'Plinth Submission'
    }, {
      value: 'FORM_MAP_COMPOUNDING',
      label: 'FORM_MAP_COMPOUNDINGn'
    }, {
      value: 'Purchasable Map Submission',
      label: 'Purchasable Map Submission'
    }],
    name: "modulename",
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    variant: "contained",
    sx: {
      height: 40,
      px: 3,
      background: "#f47738",
      "&:hover": {
        background: "#d6612b"
      },
      fontWeight: "bold"
    }
  }, "Search")), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    sx: {
      mb: 4
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: panelSx
  }, /*#__PURE__*/React__default.createElement(PanelHeader, {
    subtitle: "Age Distribution (Days Elapsed Since Creation)"
  }), /*#__PURE__*/React__default.createElement(DisposalBarChart, {
    buckets: buckets,
    totalInProgress: totalInProgress,
    onBucketClick: setSelectedBucket
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: panelSx
  }, /*#__PURE__*/React__default.createElement(PanelHeader, {
    subtitle: "Overall Proportion & Timeliness Breakdown"
  }), /*#__PURE__*/React__default.createElement(DisposalDonutChart, {
    buckets: buckets,
    totalInProgress: totalInProgress,
    onBucketClick: setSelectedBucket
  })))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: Boolean(selectedBucket),
    onClose: () => setSelectedBucket(null),
    maxWidth: "sm",
    fullWidth: true,
    PaperProps: {
      sx: {
        borderRadius: "12px",
        p: 1
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pb: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 12,
      height: 12,
      borderRadius: "50%",
      background: (selectedBucket === null || selectedBucket === void 0 ? void 0 : selectedBucket.color) || "#1976d2"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 700,
      color: "#111827",
      fontSize: "16px"
    }
  }, "Files: ", selectedBucket === null || selectedBucket === void 0 ? void 0 : selectedBucket.label)), /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: () => setSelectedBucket(null),
    size: "small"
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    sx: {
      p: 2,
      pt: 2,
      maxHeight: "60vh"
    }
  }, (selectedBucket === null || selectedBucket === void 0 ? void 0 : (_selectedBucket$items = selectedBucket.items) === null || _selectedBucket$items === void 0 ? void 0 : _selectedBucket$items.length) > 0 ? /*#__PURE__*/React__default.createElement(List, {
    sx: {
      pt: 0
    }
  }, selectedBucket.items.map((item, idx) => /*#__PURE__*/React__default.createElement(ListItem, {
    key: idx,
    sx: {
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      mb: 1,
      background: "#f9fafb"
    }
  }, /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontWeight: 700,
        color: "#1976d2",
        fontSize: "14px"
      }
    }, item.businessId),
    secondary: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      sx: {
        fontSize: "12px",
        color: "#6b7280",
        display: "block"
      }
    }, "Module: ", item.moduleName, " | Location: ", item.location), /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      sx: {
        fontSize: "12px",
        color: "#6b7280",
        display: "block"
      }
    }, "Status: ", item.status), /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      sx: {
        fontSize: "12px",
        color: "#d97706",
        display: "block",
        mt: 0.5,
        fontWeight: 500
      }
    }, "Age: ", item.age))
  })))) : /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      color: "#6b7280",
      textAlign: "center",
      py: 4
    }
  }, "No files in this category."))));
};

const useCountUp = (target, duration = 1200) => {
  const [count, setCount] = useState(0);
  const rafRef = useRef(null);
  useEffect(() => {
    const end = parseInt(String(target || 0), 10) || 0;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    setCount(0);
    if (end === 0) return;
    let startTime = null;
    const tick = ts => {
      if (!startTime) startTime = ts;
      const pct = Math.min((ts - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - pct, 3);
      setCount(Math.round(end * eased));
      if (pct < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [target]);
  return count;
};
const PILL_TABS = [{
  id: "MAP",
  label: "Map Submission",
  sub: "All risks",
  types: ["map submission", "form_map", "map"],
  icon: "📋",
  color: "#1565c0",
  bg: "#dbeafe",
  hasSubmenu: true,
  subOptions: [{
    id: "MAP_ALL",
    label: "All Map Submissions",
    sub: "All risk levels",
    color: "#1565c0",
    icon: "📋"
  }, {
    id: "MAP_LOW",
    label: "Low Risk (Self Approval-(100-30))",
    sub: "Low risk map",
    color: "#2e7d32",
    icon: "🟢"
  }, {
    id: "MAP_MED",
    label: "Medium Risk (Self Certification - 200-500)",
    sub: "Medium risk map",
    color: "#ed6c02",
    icon: "🟠"
  }, {
    id: "MAP_HIGH",
    label: "High Risk",
    sub: "High & Nivesh risk",
    color: "#c2410c",
    icon: "🔴"
  }]
}, {
  id: "PLINTH",
  label: "Plinth",
  sub: "",
  types: ["plinth", "form_plinth"],
  riskType: null,
  icon: "🏛️",
  color: "#7e22ce",
  bg: "#f5f3ff"
}, {
  id: "COMPOUNDING",
  label: "Compounding",
  sub: "",
  types: ["compounding", "form_compounding"],
  riskType: null,
  icon: "🔨",
  color: "#b91c1c",
  bg: "#fff1f2"
}, {
  id: "COMPLETION",
  label: "Completion",
  sub: "",
  types: ["completion", "form_completion"],
  riskType: null,
  icon: "📊",
  color: "#0e7490",
  bg: "#ecfeff"
}, {
  id: "PURCHASABLE_FAR",
  label: "Purchasable FAR",
  sub: "",
  types: ["purchasable far", "purchasable_far", "form_purchasable_far", "purchasable", "form_far", "far"],
  riskType: null,
  icon: "🏢",
  color: "#0284c7",
  bg: "#e0f2fe"
}, {
  id: "LAND_USE",
  label: "Land Use",
  sub: "",
  types: ["land use", "landuse", "form_landuse", "form_pressrelease", "press release"],
  riskType: null,
  icon: "🗺️",
  color: "#0d9488",
  bg: "#ccfbf1"
}, {
  id: "LANDUSE_CONVERSION",
  label: "Land Use Conversion",
  sub: "",
  types: ["land use conversion", "landuseconversion", "form_landuseconversion", "conversion"],
  riskType: null,
  icon: "🔄",
  color: "#059669",
  bg: "#d1fae5"
}, {
  id: "ALL",
  label: "ALL",
  sub: "Summary Table",
  types: [],
  riskType: null,
  icon: "📑",
  color: "#0d2b6b",
  bg: "#e0e7ff"
}];
const isDscPendingStatus$2 = item => {
  if (!item) return false;
  const sub = ((item === null || item === void 0 ? void 0 : item.status) || "").toLowerCase().trim();
  const newSub = ((item === null || item === void 0 ? void 0 : item.subDashBoardStatus) || "").toLowerCase().trim();
  const main = ((item === null || item === void 0 ? void 0 : item.mainDashBoardStatus) || "").toLowerCase().trim();
  const dash = ((item === null || item === void 0 ? void 0 : item.dashboardStatus) || "").toLowerCase().trim();
  const state = ((item === null || item === void 0 ? void 0 : item.state) || "").toLowerCase().trim();
  const allStatus = `${sub} ${newSub} ${main} ${dash} ${state}`;
  return allStatus.includes("apply for dsc") || allStatus.includes("apply_for_dsc") || allStatus.includes("pending for dsc") || allStatus.includes("pending_for_dsc") || allStatus.includes("dsc pending") || allStatus.includes("dsc_pending") || allStatus.includes("dsc_approval") || allStatus.includes("pending_dsc") || sub === "pending for dsc" || newSub === "pending for dsc" || sub.startsWith("apply_for_dsc") || main.startsWith("apply_for_dsc") || dash.startsWith("apply_for_dsc") || main.includes("dsc pending") || dash.includes("dsc pending");
};
const matchesPillFilter = (item, pillId) => {
  if (!item || !pillId || pillId === "ALL") return true;
  const modName = (item.moduleName || "").toLowerCase().trim();
  const appType = (item.applicationType || item.appliactionType || item.formType || item.serviceType || "").toLowerCase().trim();
  const bs = (item.businessService || "").toLowerCase().trim();
  const itemRisk = (item.riskType || "").toUpperCase().trim();
  const typeStr = `${modName} ${appType}`.trim();
  const isCompletion = typeStr.includes("completion") || typeStr.includes("form_completion") || typeStr.includes("occupancy") || typeStr === "oc" || typeStr === "cc" || typeStr.includes("_oc") || typeStr.includes("_cc") || typeStr.includes("oc_") || typeStr.includes("cc_") || bs.includes("completion") || bs === "bpa_oc" || bs === "bpa_oc_low" || bs === "bpa_cc" || bs.includes("_oc") || bs.includes("_cc");
  const isPlinth = typeStr.includes("plinth") || typeStr.includes("plinth_submission") || typeStr.includes("form_plinth") || bs.includes("plinth") || bs === "bpa_plinth";
  const isCompounding = typeStr.includes("compounding") || typeStr.includes("form_map_compounding") || typeStr.includes("form_compounding") || bs.includes("compounding") || bs === "bpa_compounding";
  const isFar = typeStr.includes("purchasable") || typeStr.includes("purchasable_map") || typeStr.includes("far") || typeStr.includes("form_purchasable_far") || typeStr.includes("form_far") || bs.includes("far") || bs.includes("purchasable");
  const isLandUseConversion = typeStr.includes("conversion") || typeStr.includes("form_landuseconversion") || typeStr.includes("landuseconversion") || bs.includes("conversion");
  const isLandUse = !isLandUseConversion && (typeStr.includes("landuse") || typeStr.includes("land use") || typeStr.includes("land_use") || typeStr.includes("pressrelease") || typeStr.includes("press release") || typeStr.includes("press_release") || typeStr.includes("form_pressrelease") || typeStr.includes("form_landuse") || bs.includes("landuse") || bs.includes("land_use") || bs.includes("pressrelease"));
  const isMap = !isCompounding && !isCompletion && !isPlinth && !isFar && !isLandUse && !isLandUseConversion;
  if (pillId === "COMPLETION") return isCompletion;
  if (pillId === "PLINTH") return isPlinth;
  if (pillId === "COMPOUNDING") return isCompounding;
  if (pillId === "PURCHASABLE_FAR") return isFar;
  if (pillId === "LAND_USE") return isLandUse;
  if (pillId === "LANDUSE_CONVERSION") return isLandUseConversion;
  if (pillId === "MAP" || pillId === "MAP_ALL") {
    if (isCompounding || isCompletion) return false;
    return isMap;
  }
  if (pillId === "MAP_LOW") {
    if (isCompounding || isCompletion) return false;
    return isMap && typeStr.includes("100-30");
  }
  if (pillId === "MAP_MED") {
    if (isCompounding || isCompletion) return false;
    return isMap && typeStr.includes("200-500");
  }
  if (pillId === "MAP_HIGH") {
    if (isCompounding || isCompletion) return false;
    const isLowByName = typeStr.includes("100-30");
    const isMedByName = typeStr.includes("200-500");
    return isMap && !isLowByName && !isMedByName;
  }
  return true;
};
const isSchemeItem$1 = item => {
  var _item$descriptionOfLa, _item$additionalDetai, _item$additionalDetai2, _item$additionalDetai3, _item$mapSubDetails;
  if (!item) return false;
  const st = String((item === null || item === void 0 ? void 0 : item.schemeType) || (item === null || item === void 0 ? void 0 : item.scheme_type) || (item === null || item === void 0 ? void 0 : (_item$descriptionOfLa = item.descriptionOfLand) === null || _item$descriptionOfLa === void 0 ? void 0 : _item$descriptionOfLa.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.schemeType) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : (_item$additionalDetai3 = _item$additionalDetai2.descriptionOfLand) === null || _item$additionalDetai3 === void 0 ? void 0 : _item$additionalDetai3.schemeType) || (item === null || item === void 0 ? void 0 : (_item$mapSubDetails = item.mapSubDetails) === null || _item$mapSubDetails === void 0 ? void 0 : _item$mapSubDetails.schemeType) || "").trim().toLowerCase();
  return st === "scheme" || st === "scheme type" || st === "schemetype";
};
const getActivePillLabel = id => {
  if (!id) return "";
  if (id === "ALL") return "All Applications (Summary View)";
  if (id === "MAP" || id === "MAP_ALL") return "Map Submission (All Risks)";
  if (id === "MAP_LOW") return "Map Submission (Low Risk (Self Approval-(100-30)))";
  if (id === "MAP_MED") return "Map Submission (Medium Risk (Self Certification - 200-500))";
  if (id === "MAP_HIGH") return "Map Submission (High Risk)";
  if (id === "PLINTH") return "Plinth";
  if (id === "COMPOUNDING") return "Compounding";
  if (id === "COMPLETION") return "Completion Certificate";
  if (id === "PURCHASABLE_FAR") return "Purchasable FAR";
  if (id === "LAND_USE") return "Land Use";
  if (id === "LANDUSE_CONVERSION") return "Land Use Conversion";
  return id;
};
const AnimatedKpiCard = ({
  card,
  index,
  isActive,
  cardsVisible,
  onCardClick
}) => {
  const animatedValue = useCountUp(card.value);
  return /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => onCardClick(card.type),
    sx: {
      borderRadius: "16px",
      border: isActive ? `2px solid ${card.color}` : "1px solid rgba(0,0,0,0.06)",
      boxShadow: isActive ? `0 8px 32px ${card.color}45` : "0 2px 12px rgba(0,0,0,0.07)",
      transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
      "&:hover": {
        boxShadow: `0 12px 32px ${card.color}35`,
        transform: "translateY(-4px) scale(1.01)",
        cursor: "pointer"
      },
      height: "100%",
      minHeight: "110px",
      background: isActive ? `linear-gradient(140deg, ${card.color}18 0%, ${card.color}06 100%)` : "linear-gradient(140deg, #ffffff 0%, #f7f9fc 100%)",
      position: "relative",
      overflow: "hidden",
      ...(cardsVisible ? {
        animation: `v2CardIn 0.55s cubic-bezier(.4,0,.2,1) ${index * 0.065}s both`,
        "@keyframes v2CardIn": {
          from: {
            opacity: 0,
            transform: "translateY(26px) scale(0.95)"
          },
          to: {
            opacity: 1,
            transform: "translateY(0) scale(1)"
          }
        }
      } : {
        opacity: 0
      })
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "3px",
      background: isActive ? `linear-gradient(90deg, ${card.color}, ${card.color}66)` : `linear-gradient(90deg, ${card.color}55, ${card.color}11)`,
      transition: "all 0.3s ease"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      bottom: -18,
      right: -18,
      width: 72,
      height: 72,
      borderRadius: "50%",
      background: `radial-gradient(circle, ${card.color}18, transparent 70%)`,
      transition: "all 0.3s ease"
    }
  }), card.sparkline && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "44px",
      opacity: isActive ? 0.28 : 0.14,
      pointerEvents: "none",
      zIndex: 0,
      transition: "opacity 0.3s ease"
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "100%",
    height: "44",
    viewBox: "0 0 100 35",
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: `sg-${card.type}`,
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0%",
    stopColor: card.color,
    stopOpacity: "0.85"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "100%",
    stopColor: card.color,
    stopOpacity: "0.08"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: card.sparkline,
    fill: `url(#sg-${card.type})`
  }), card.sparklineLine && /*#__PURE__*/React__default.createElement("path", {
    d: card.sparklineLine,
    fill: "none",
    stroke: card.color,
    strokeWidth: "1.5",
    strokeOpacity: isActive ? 0.7 : 0.4
  }))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: "14px 16px",
      position: "relative",
      zIndex: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: `linear-gradient(135deg, ${card.color}28, ${card.color}10)`,
      borderRadius: "10px",
      width: 36,
      height: 36,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      boxShadow: `0 2px 6px ${card.color}25`
    }
  }, card.icon), isActive && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: card.color,
      boxShadow: `0 0 0 3px ${card.color}30`,
      animation: "v2Pulse 1.5s infinite",
      "@keyframes v2Pulse": {
        "0%": {
          boxShadow: `0 0 0 0 ${card.color}50`
        },
        "70%": {
          boxShadow: `0 0 0 6px ${card.color}00`
        },
        "100%": {
          boxShadow: `0 0 0 0 ${card.color}00`
        }
      }
    }
  })), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 800,
      color: card.color,
      fontSize: "26px",
      lineHeight: 1,
      mb: 0.4,
      letterSpacing: "-0.5px"
    }
  }, animatedValue.toLocaleString()), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      color: "#555",
      fontSize: "11px",
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      lineHeight: 1.3
    }
  }, card.title), card.subtitle && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      color: "#aaa",
      fontSize: "9.5px",
      fontWeight: 500,
      mt: 0.3
    }
  }, card.subtitle)));
};
const PillTab = ({
  tab,
  activePill,
  pillCounts,
  count,
  isActive: propIsActive,
  index,
  onPillClick
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isPopoverOpen = Boolean(anchorEl);
  const isMapTab = Boolean(tab.hasSubmenu);
  const isMapActive = isMapTab && ["MAP", "MAP_ALL", "MAP_LOW", "MAP_MED", "MAP_HIGH"].includes(activePill);
  const isActive = propIsActive !== undefined ? propIsActive : isMapTab ? isMapActive : activePill === tab.id;
  const getCount = key => {
    if (pillCounts && typeof pillCounts[key] === "number") return pillCounts[key];
    if (count !== undefined && count !== null) return count;
    return 0;
  };
  const activeSub = isMapTab && activePill && Array.isArray(tab.subOptions) ? tab.subOptions.find(s => s.id === activePill) : null;
  const currentColor = activeSub ? activeSub.color : tab.color;
  const currentBg = activeSub ? `${activeSub.color}22` : tab.bg;
  const currentLabel = tab.label;
  const currentSub = activeSub ? activeSub.label : isMapTab ? "All risks" : tab.sub;
  const currentCount = isMapTab ? activeSub ? getCount(activeSub.id) : getCount("MAP") || getCount("MAP_ALL") || 0 : getCount(tab.id);
  const handleClick = e => {
    if (isMapTab) {
      setAnchorEl(e.currentTarget);
    } else {
      onPillClick(tab.id);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSubSelect = subId => {
    setAnchorEl(null);
    onPillClick(subId);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box, {
    onClick: handleClick,
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      px: 2.2,
      py: 1.1,
      borderRadius: "14px",
      cursor: "pointer",
      flexShrink: 0,
      background: isActive ? `linear-gradient(135deg, ${currentColor} 0%, ${currentColor}dd 100%)` : "#ffffff",
      border: isActive ? `2px solid ${currentColor}` : `1.5px solid ${tab.color}4a`,
      boxShadow: isActive ? `0 6px 22px ${currentColor}55` : "0 2px 10px rgba(0,0,0,0.07)",
      transition: "all 0.28s cubic-bezier(.4,0,.2,1)",
      animation: `v2PillIn 0.42s ease ${index * 0.07}s both`,
      "@keyframes v2PillIn": {
        from: {
          opacity: 0,
          transform: "translateX(-22px) scale(0.95)"
        },
        to: {
          opacity: 1,
          transform: "translateX(0) scale(1)"
        }
      },
      "&:hover": {
        transform: "translateY(-3px) scale(1.025)",
        boxShadow: `0 9px 26px ${currentColor}50`
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 34,
      height: 34,
      borderRadius: "10px",
      background: isActive ? "rgba(255,255,255,0.22)" : currentBg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "15px",
      flexShrink: 0,
      boxShadow: isActive ? "0 2px 6px rgba(0,0,0,0.12)" : "none"
    }
  }, activeSub ? activeSub.icon : tab.icon), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "12px",
      fontWeight: 700,
      color: isActive ? "#fff" : tab.color,
      lineHeight: 1.25
    }
  }, currentLabel), currentSub && /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10px",
      color: isActive ? "rgba(255,255,255,0.85)" : "#6b7280",
      fontWeight: 500,
      lineHeight: 1.25
    }
  }, currentSub)), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: isActive ? "rgba(255,255,255,0.24)" : `${currentColor}18`,
      borderRadius: "8px",
      px: 0.9,
      py: 0.35,
      ml: 0.5,
      minWidth: "30px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      fontWeight: 800,
      color: isActive ? "#fff" : currentColor
    }
  }, currentCount)), isMapTab && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: isActive ? "#fff" : currentColor,
      transform: isPopoverOpen ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.25s ease",
      ml: -0.5
    }
  }, /*#__PURE__*/React__default.createElement(ExpandMoreIcon, {
    sx: {
      fontSize: 18
    }
  }))), isMapTab && /*#__PURE__*/React__default.createElement(Popover, {
    open: isPopoverOpen,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    PaperProps: {
      sx: {
        mt: 1.2,
        borderRadius: "16px",
        p: 1.5,
        minWidth: "270px",
        boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
        border: "1px solid rgba(25,118,210,0.18)",
        background: "linear-gradient(180deg, #ffffff 0%, #f8faff 100%)",
        backdropFilter: "blur(12px)",
        animation: "v2PopIn 0.25s cubic-bezier(.4,0,.2,1) both",
        "@keyframes v2PopIn": {
          from: {
            opacity: 0,
            transform: "scale(0.92) translateY(-8px)"
          },
          to: {
            opacity: 1,
            transform: "scale(1) translateY(0)"
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      px: 1.2,
      pt: 0.5,
      pb: 1.2,
      borderBottom: "1px solid rgba(0,0,0,0.06)",
      mb: 1
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "12px",
      fontWeight: 800,
      color: "#1565c0",
      display: "flex",
      alignItems: "center",
      gap: 0.7
    }
  }, "\uD83D\uDCCB Map Submission Categories"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "10px",
      color: "#6b7280",
      mt: 0.3
    }
  }, "Select a risk level or view all submissions")), Array.isArray(tab.subOptions) && tab.subOptions.map(opt => {
    const isSelected = activePill === opt.id || opt.id === "MAP_ALL" && activePill === "MAP";
    const optCount = getCount(opt.id);
    return /*#__PURE__*/React__default.createElement(Box, {
      key: opt.id,
      onClick: e => {
        e.stopPropagation();
        handleSubSelect(opt.id);
      },
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 1.5,
        py: 1.1,
        mb: 0.6,
        borderRadius: "11px",
        cursor: "pointer",
        background: isSelected ? `${opt.color}18` : "transparent",
        border: isSelected ? `1.5px solid ${opt.color}60` : "1.5px solid transparent",
        transition: "all 0.2s ease",
        "&:hover": {
          background: isSelected ? `${opt.color}24` : "rgba(0,0,0,0.04)",
          transform: "translateX(3px)"
        }
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1.2
      }
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        width: 28,
        height: 28,
        borderRadius: "8px",
        background: isSelected ? opt.color : `${opt.color}15`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "13px",
        color: isSelected ? "#fff" : opt.color,
        flexShrink: 0
      }
    }, opt.icon), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "12px",
        fontWeight: isSelected ? 800 : 700,
        color: isSelected ? opt.color : "#1f2937",
        lineHeight: 1.2
      }
    }, opt.label), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        fontSize: "10px",
        color: "#6b7280",
        fontWeight: 500
      }
    }, opt.sub))), /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        background: isSelected ? opt.color : `${opt.color}15`,
        color: isSelected ? "#fff" : opt.color,
        borderRadius: "8px",
        px: 1,
        py: 0.3,
        fontSize: "11px",
        fontWeight: 800,
        minWidth: "30px",
        textAlign: "center",
        boxShadow: isSelected ? `0 2px 8px ${opt.color}40` : "none"
      }
    }, optCount));
  })));
};
const SectionLabel = ({
  label,
  gradientColors
}) => /*#__PURE__*/React__default.createElement(Box, {
  sx: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    gap: 1
  }
}, /*#__PURE__*/React__default.createElement(Box, {
  sx: {
    width: 4,
    height: 20,
    borderRadius: "2px",
    background: `linear-gradient(180deg, ${gradientColors[0]}, ${gradientColors[1]})`
  }
}), /*#__PURE__*/React__default.createElement(Typography, {
  sx: {
    fontWeight: 700,
    fontSize: "13px",
    color: "#374151",
    textTransform: "uppercase",
    letterSpacing: "0.9px"
  }
}, label));
const DashboardPageV2 = () => {
  var _userDetails$location, _userDetails$location2, _userDetails$roles2, _userDetails$roles3;
  const history = useHistory();
  const getFinancialYearStart = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    return new Date(year, 3, 1);
  };
  const addOneYear = date => {
    const d = new Date(date);
    d.setFullYear(d.getFullYear() + 1);
    return d;
  };
  const getDefaultFromDate = () => {
    var _userDetails$roles;
    const userDetails = Digit.SessionStorage.get("USER_DETAIL");
    const isSuperUser = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$roles = userDetails.roles) === null || _userDetails$roles === void 0 ? void 0 : _userDetails$roles.some(r => ["SUPERUSER", "EMPLOYEE_ADMIN"].includes(r.code));
    if (isSuperUser) {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() - 7);
      return d;
    }
    return getFinancialYearStart();
  };
  const [activePill, setActivePill] = useState(null);
  const [activeCard, setActiveCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const [cardsVisible, setCardsVisible] = useState(false);
  const [fromDate, setFromDate] = useState(getDefaultFromDate);
  const [toDate, setToDate] = useState(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  });
  const [selectedApplicationType, setSelectedApplicationType] = useState(null);
  const [selectedAuthority, setSelectedAuthority] = useState(null);
  const [fastPasIdSearch, setFastPasIdSearch] = useState("");
  const [showInProgressModal, setShowInProgressModal] = useState(false);
  const [showLandUseApprovedModal, setShowLandUseApprovedModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showMs, setshowMs] = useState(false);
  const [expandedOfficerAccordion, setExpandedOfficerAccordion] = useState(false);
  const [officerModuleFilter, setOfficerModuleFilter] = useState("ALL");
  const [filters, setFilters] = useState({
    department: "",
    applicationType: "",
    status: "",
    riskType: "",
    subStatus: "",
    duplicateStatus: "",
    createdBy: "",
    userDesignation: "",
    assigned: "",
    schemeType: ""
  });
  const debounceFastPasIdSearch = useDebounce(fastPasIdSearch, 700);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location = userDetails.location1) === null || _userDetails$location === void 0 ? void 0 : _userDetails$location.length) > 1 ? userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location2 = userDetails.location1) === null || _userDetails$location2 === void 0 ? void 0 : _userDetails$location2.concat(" Development Authority") : null;
  const userType = userDetails !== null && userDetails !== void 0 && (_userDetails$roles2 = userDetails.roles) !== null && _userDetails$roles2 !== void 0 && _userDetails$roles2.some(r => ["HRMS_ADMIN", "SUPERUSER", "EMPLOYEE_ADMIN"].includes(r.code) || r.name === "Nodal Officer AWAS Bandhu") ? "Admin" : null;
  const isSuperAdmin = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$roles3 = userDetails.roles) === null || _userDetails$roles3 === void 0 ? void 0 : _userDetails$roles3.some(r => ["SUPERUSER", "EMPLOYEE_ADMIN"].includes(r.code) || r.name === "Nodal Officer AWAS Bandhu");
  const isAvpUser = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.tenantId) === "up.avp";
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data: {
      BPA: {
        DashboardAuthorityList
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["DashboardAuthorityList"]);
  useEffect(() => {
    if (isAvpUser && userType !== "Admin") {
      setSelectedAuthority("Uttar Pradesh Awas and Evam Vikas Parishad");
      setFilters(prev => ({
        ...prev,
        authority: "Uttar Pradesh Awas and Evam Vikas Parishad"
      }));
    } else if (location1 && userType !== "Admin") {
      setSelectedAuthority(location1);
      setFilters(prev => ({
        ...prev,
        authority: location1
      }));
    }
  }, [location1, userType]);
  const fetchDashboardData = async (fastPasId = "") => {
    var _userDetails$location3, _selectedAuthority$sp;
    const fmt = d => `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    const todayDate = toDate ? new Date(toDate) : (() => {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    })();
    const startDate = fromDate ? new Date(fromDate) : (() => {
      const d = new Date(todayDate);
      d.setFullYear(d.getFullYear() - 1);
      return d;
    })();
    const isUnitSelected = selectedAuthority === null || selectedAuthority === void 0 ? void 0 : selectedAuthority.startsWith("Unit-");
    const q = {
      fromDateBi: fmt(startDate),
      toDateBi: fmt(todayDate),
      applicationType: selectedApplicationType === "ALL" ? "" : selectedApplicationType,
      district: selectedAuthority === "All" || selectedAuthority === "Uttar Pradesh Awas and Evam Vikas Parishad" ? "" : isUnitSelected ? selectedAuthority.replace("-", " ") : (userDetails !== null && userDetails !== void 0 && (_userDetails$location3 = userDetails.location1) !== null && _userDetails$location3 !== void 0 && _userDetails$location3.startsWith("Unnao Shuklaganj") ? "Unnao Shuklaganj" : userDetails === null || userDetails === void 0 ? void 0 : userDetails.location1) || (selectedAuthority !== null && selectedAuthority !== void 0 && selectedAuthority.startsWith("Unnao Shuklaganj") ? "Unnao Shuklaganj" : selectedAuthority === null || selectedAuthority === void 0 ? void 0 : (_selectedAuthority$sp = selectedAuthority.split(" ")) === null || _selectedAuthority$sp === void 0 ? void 0 : _selectedAuthority$sp[0]),
      department: tenantId === "up.avp" || selectedAuthority === "Uttar Pradesh Awas and Evam Vikas Parishad" || isUnitSelected ? "AVP" : "DA",
      land_Id: fastPasId || ""
    };
    Object.keys(q).forEach(k => {
      if (!q[k]) delete q[k];
    });
    try {
      setLoading(true);
      setCardsVisible(false);
      const res = await Digit.OBPSService.dashboardReportData(tenantId, q);
      setDashboardData((res === null || res === void 0 ? void 0 : res.CommonSearchRequest) || []);
      setTimeout(() => setCardsVisible(true), 90);
    } catch (err) {
      console.error("DashboardV2 fetch error", err);
      setDashboardData([]);
    } finally {
      setLoading(false);
      setTimeout(() => setCardsVisible(true), 90);
    }
  };
  useEffect(() => {
    if (debounceFastPasIdSearch) fetchDashboardData(debounceFastPasIdSearch);else fetchDashboardData();
  }, [debounceFastPasIdSearch]);
  const pillFilteredData = useMemo(() => {
    if (!activePill) return dashboardData;
    return (dashboardData || []).filter(item => matchesPillFilter(item, activePill));
  }, [dashboardData, activePill]);
  const statusCounts = useMemo(() => {
    const m = {
      total: pillFilteredData.length,
      approved: 0,
      inProgress: 0,
      draft: 0,
      shortfall: 0,
      rejected: 0,
      received: 0,
      provisionallyApproved: 0,
      dscPending: 0,
      selfApproval: 0,
      paymentPending: 0,
      autoRejected: 0,
      avpProgress: 0,
      netReceived: 0
    };
    pillFilteredData.forEach(item => {
      var _item$mainDashBoardSt, _item$dashboardStatus, _item$status, _item$subDashBoardSta;
      const main = ((_item$mainDashBoardSt = item.mainDashBoardStatus) === null || _item$mainDashBoardSt === void 0 ? void 0 : _item$mainDashBoardSt.toLowerCase()) || "";
      const dash = ((_item$dashboardStatus = item.dashboardStatus) === null || _item$dashboardStatus === void 0 ? void 0 : _item$dashboardStatus.toLowerCase()) || "";
      const sub = (item === null || item === void 0 ? void 0 : (_item$status = item.status) === null || _item$status === void 0 ? void 0 : _item$status.toLowerCase()) || "";
      const newSub = (item === null || item === void 0 ? void 0 : (_item$subDashBoardSta = item.subDashBoardStatus) === null || _item$subDashBoardSta === void 0 ? void 0 : _item$subDashBoardSta.toLowerCase()) || "";
      const isScheme = isSchemeItem$1(item);
      const isMap = matchesPillFilter(item, "MAP_ALL");
      const isDsc = isDscPendingStatus$2(item);
      const isForwardingState = sub.includes("forward") || sub.includes("pending for") || sub.includes("pending approval");
      const isApprove = (main.includes("approved") || dash.includes("approved") || sub.includes("approved")) && !isDsc && !isForwardingState && !main.includes("provisionally") && !dash.includes("provisionally");
      const isSelfCert = main.includes("self certification") || dash.includes("self certification") || sub.includes("self certification") || main.includes("self_certification") || dash.includes("self_certification") || sub.includes("self_certification") || main.includes("self approved") || dash.includes("self approved") || sub.includes("self approved") || main.includes("self_approved") || dash.includes("self_approved") || sub.includes("self_approved") || main.includes("self approval") || dash.includes("self approval") || sub.includes("self approval") || main.includes("self_approval") || dash.includes("self_approval") || sub.includes("self_approval") || ["self certification approved", "self_certification_approved"].includes(main) || ["self certification approved", "self_certification_approved"].includes(dash) || ["self certification approved", "self_certification_approved"].includes(sub);
      if (isMap) {
        if (isApprove || isSelfCert) {
          m.approved++;
        }
      } else {
        const isLandUseType = matchesPillFilter(item, "LAND_USE") || matchesPillFilter(item, "LANDUSE_CONVERSION");
        if (isLandUseType) {
          if (isApprove && isScheme || isSelfCert) {
            m.selfApproval++;
          } else if (isApprove && !isScheme) {
            m.approved++;
          }
        } else {
          if (isApprove || isSelfCert) {
            m.approved++;
          }
        }
      }
      if (sub.includes("document uploaded") || sub.includes("pay application fees") || main.includes("pay application fees") || dash.includes("pay application fees") || sub.includes("draft")) {
        m.draft++;
      }
      if (main.includes("in progress with officer") || main.includes("in progress with officers") || dash.includes("in progress with officer") || dash.includes("in progress with officers") || sub.includes("forward")) {
        var _item$location;
        m.inProgress++;
        if (item !== null && item !== void 0 && (_item$location = item.location1) !== null && _item$location !== void 0 && _item$location.includes("Unit")) m.avpProgress++;
      }
      const isPaymentOrProvisional = (sub.includes("payment pending") || sub.includes("architect payment pending") || main.includes("payment pending") || dash.includes("payment pending") || sub.includes("make payment") || sub.includes("make payment self") || main.includes("provisionally approved") || dash.includes("provisionally approved")) && !sub.includes("pay application fees") && !main.includes("pay application fees") && !dash.includes("pay application fees");
      if (isPaymentOrProvisional) {
        m.paymentPending++;
        m.provisionallyApproved++;
      }
      if (sub.includes("reject") || main.includes("reject") || dash.includes("reject")) {
        m.rejected++;
      }
      if (sub.includes("revert to applicant") || sub.includes("send back to applicant") || sub.includes("shortfall") || main.includes("send back") || main.includes("shortfall") || dash.includes("send back") || dash.includes("shortfall") || main === "citizen_action_pending_at_ltp") {
        m.shortfall++;
      }
      if (["received", "application received"].includes(main) || ["received", "application received"].includes(dash)) {
        m.received++;
      }
      if (isDsc) {
        m.dscPending++;
      }
      if (sub.includes("auto reject") || main.includes("auto reject") || dash.includes("auto reject")) {
        m.autoRejected++;
      }
    });
    m.netReceived = m.total - m.draft;
    return m;
  }, [pillFilteredData]);
  const officerBadgeCount = useMemo(() => {
    let list = (dashboardData || []).filter(item => {
      const main = (item.mainDashBoardStatus || "").toLowerCase();
      const dash = (item.dashboardStatus || "").toLowerCase();
      const sub = (item.status || "").toLowerCase();
      const subDash = (item.subDashBoardStatus || "").toLowerCase();
      return main.includes("in progress with officer") || main.includes("in progress with officers") || dash.includes("in progress with officer") || dash.includes("in progress with officers") || sub.includes("in progress with officer") || sub.includes("in progress with officers") || subDash.includes("in progress with officer") || subDash.includes("in progress with officers") || sub.includes("forward");
    });
    if (isAvpUser) {
      list = list.filter(item => {
        var _item$location2;
        return item === null || item === void 0 ? void 0 : (_item$location2 = item.location1) === null || _item$location2 === void 0 ? void 0 : _item$location2.includes("Unit");
      });
    }
    if (officerModuleFilter && officerModuleFilter !== "ALL") {
      list = list.filter(item => getModuleFromItem(item) === officerModuleFilter);
    }
    return list.length;
  }, [dashboardData, isAvpUser, officerModuleFilter]);
  const pillCounts = useMemo(() => {
    const data = dashboardData || [];
    return {
      ALL: data.length,
      MAP: data.filter(item => matchesPillFilter(item, "MAP_ALL")).length,
      MAP_ALL: data.filter(item => matchesPillFilter(item, "MAP_ALL")).length,
      MAP_LOW: data.filter(item => matchesPillFilter(item, "MAP_LOW")).length,
      MAP_MED: data.filter(item => matchesPillFilter(item, "MAP_MED")).length,
      MAP_HIGH: data.filter(item => matchesPillFilter(item, "MAP_HIGH")).length,
      PLINTH: data.filter(item => matchesPillFilter(item, "PLINTH")).length,
      COMPOUNDING: data.filter(item => matchesPillFilter(item, "COMPOUNDING")).length,
      COMPLETION: data.filter(item => matchesPillFilter(item, "COMPLETION")).length,
      PURCHASABLE_FAR: data.filter(item => matchesPillFilter(item, "PURCHASABLE_FAR")).length,
      LAND_USE: data.filter(item => matchesPillFilter(item, "LAND_USE")).length,
      LANDUSE_CONVERSION: data.filter(item => matchesPillFilter(item, "LANDUSE_CONVERSION")).length
    };
  }, [dashboardData]);
  const cardData = useMemo(() => {
    const isLandUse = activePill === "LAND_USE" || activePill === "LANDUSE_CONVERSION" || typeof activePill === "string" && activePill.toLowerCase().includes("land") || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_LANDUSE" || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_LANDUSECONVERSION" || selectedApplicationType === "FORM_LANDUSE" || selectedApplicationType === "FORM_LANDUSECONVERSION";
    const isLowRisk = activePill === "MAP_LOW" || (filters === null || filters === void 0 ? void 0 : filters.riskType) === "LOW";
    const isMediumRisk = activePill === "MAP_MED" || (filters === null || filters === void 0 ? void 0 : filters.riskType) === "MEDIUM";
    const isHighRisk = activePill === "MAP_HIGH" || (filters === null || filters === void 0 ? void 0 : filters.riskType) === "HIGH" || (filters === null || filters === void 0 ? void 0 : filters.riskType) === "HIGH_NIVESH";
    const isMap = activePill === "MAP" || activePill === "MAP_ALL" || isLowRisk || isMediumRisk || isHighRisk || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_MAP" || selectedApplicationType === "FORM_MAP";
    const isCompounding = activePill === "COMPOUNDING" || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_COMPOUNDING" || selectedApplicationType === "FORM_COMPOUNDING";
    const allCards = [{
      title: "Total Files",
      value: statusCounts.total,
      subtitle: "All applications",
      color: "#1976d2",
      icon: "📊",
      type: "Total Applications",
      sparkline: "M 0 26 Q 20 18, 40 22 T 70 12 T 100 6 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 26 Q 20 18, 40 22 T 70 12 T 100 6"
    }, {
      title: "Draft Files",
      value: statusCounts.draft,
      subtitle: "With Applicant",
      color: "#FF9800",
      icon: "✍️",
      type: "pendingWithApplicant",
      sparkline: "M 0 18 Q 30 26, 60 12 T 100 20 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 18 Q 30 26, 60 12 T 100 20"
    }, {
      title: "Net Received",
      value: statusCounts.netReceived,
      subtitle: "Total Files minus Draft Files",
      color: "#009688",
      icon: "📥",
      type: "Received",
      sparkline: "M 0 28 Q 20 20, 50 12 T 80 16 T 100 8 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 28 Q 20 20, 50 12 T 80 16 T 100 8"
    }, {
      title: "Approved",
      value: statusCounts.approved,
      subtitle: isLandUse ? "Non-scheme files" : isMap ? "Scheme & non-scheme files" : "Approved by authority",
      color: "#4CAF50",
      icon: "✅",
      type: "Approved",
      sparkline: "M 0 28 Q 25 24, 50 14 T 80 8 T 100 4 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 28 Q 25 24, 50 14 T 80 8 T 100 4"
    }, {
      title: "In Progress with Officer",
      value: statusCounts.inProgress,
      subtitle: "",
      color: "#4CAF50",
      icon: "⏳",
      type: "pendingWithOfficer",
      sparkline: "M 0 22 Q 25 10, 50 25 T 75 14 T 100 18 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 22 Q 25 10, 50 25 T 75 14 T 100 18"
    }, {
      title: "Shortfall",
      value: statusCounts.shortfall,
      subtitle: "Documents required",
      color: "#9C27B0",
      icon: "⏳",
      type: "Shortfall",
      sparkline: "M 0 25 Q 25 15, 50 28 T 80 18 T 100 22 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 25 Q 25 15, 50 28 T 80 18 T 100 22"
    }, {
      title: "Rejected",
      value: statusCounts.rejected,
      subtitle: "",
      color: "#F44336",
      icon: "❌",
      type: "Rejected",
      sparkline: "M 0 16 Q 30 28, 65 14 T 100 24 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 16 Q 30 28, 65 14 T 100 24"
    }, {
      title: "DSC Pending",
      value: statusCounts.dscPending,
      subtitle: "",
      color: "#455a64",
      icon: "🔐",
      type: "DSCPending",
      sparkline: "M 0 20 Q 25 26, 55 16 T 100 12 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 20 Q 25 26, 55 16 T 100 12"
    }, {
      title: "Self Approved Scheme",
      value: statusCounts.selfApproval,
      subtitle: "Scheme files (Self approved)",
      color: "#FF7043",
      icon: "✅",
      type: "SelfApproval",
      sparkline: "M 0 26 Q 35 12, 70 20 T 100 6 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 26 Q 35 12, 70 20 T 100 6"
    }, {
      title: "Payment Pending",
      value: statusCounts.paymentPending,
      subtitle: "Fees due",
      color: "#f57c00",
      icon: "💳",
      type: "PaymentPending",
      sparkline: "M 0 18 Q 25 12, 50 26 T 85 14 T 100 20 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 18 Q 25 12, 50 26 T 85 14 T 100 20"
    }, {
      title: "Auto Rejected",
      value: statusCounts.autoRejected,
      subtitle: "System rejected",
      color: "#8e24aa",
      icon: "❌",
      type: "AutoRejected",
      sparkline: "M 0 22 Q 30 28, 60 18 T 100 26 L 100 35 L 0 35 Z",
      sparklineLine: "M 0 22 Q 30 28, 60 18 T 100 26"
    }];
    let filteredCards = allCards;
    if (isLowRisk || isMediumRisk) {
      filteredCards = filteredCards.filter(c => c.type !== "SelfApproval" && c.type !== "AutoRejected" && c.type !== "Shortfall");
    } else if (isHighRisk || isMap) {
      filteredCards = filteredCards.filter(c => c.type !== "SelfApproval");
    }
    if (isCompounding) {
      filteredCards = filteredCards.filter(c => c.type !== "SelfApproval");
    }
    if (isLandUse) {
      filteredCards = filteredCards.filter(c => c.type !== "ProvisionallyApproved" && c.type !== "PaymentPending" && c.type !== "AutoRejected");
    }
    return filteredCards;
  }, [statusCounts, activePill, filters === null || filters === void 0 ? void 0 : filters.riskType, filters === null || filters === void 0 ? void 0 : filters.applicationType, selectedApplicationType]);
  const computedLocation = useMemo(() => (location1 !== null && location1 !== void 0 && location1.startsWith("Unnao Shuklaganj") ? "Unnao Shuklaganj" : location1 === null || location1 === void 0 ? void 0 : location1.split(" ")[0]) || (selectedAuthority !== null && selectedAuthority !== void 0 && selectedAuthority.startsWith("Unnao Shuklaganj") ? "Unnao Shuklaganj" : selectedAuthority === null || selectedAuthority === void 0 ? void 0 : selectedAuthority.split(" ")[0]), [location1, selectedAuthority]);
  const computedDepartment = useMemo(() => selectedAuthority === "Uttar Pradesh Awas and Evam Vikas Parishad" ? "AVP" : "DA", [selectedAuthority]);
  const handleCardClick = cardType => {
    if (cardType === "pendingWithOfficer") {
      setShowInProgressModal(true);
      return;
    }
    if (activeCard === cardType) {
      setActiveCard(null);
      setFilters(p => ({
        ...p,
        status: "",
        riskType: "",
        schemeType: ""
      }));
    } else {
      setActiveCard(cardType);
      const statusMap = {
        "Total Applications": "",
        Approved: "Approved",
        pendingWithApplicant: "Document Uploaded",
        Shortfall: "Send back to Applicant",
        Rejected: "Rejected",
        Received: "Received",
        ProvisionallyApproved: "Provisionally Approved",
        DSCPending: "Apply For DSC",
        SelfApproval: "Self Approved Scheme",
        PaymentPending: "Make Payment",
        AutoRejected: "Auto Rejected"
      };
      const isLandUse = activePill === "LAND_USE" || activePill === "LANDUSE_CONVERSION" || typeof activePill === "string" && activePill.toLowerCase().includes("land") || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_LANDUSE" || (filters === null || filters === void 0 ? void 0 : filters.applicationType) === "FORM_LANDUSECONVERSION" || selectedApplicationType === "FORM_LANDUSE" || selectedApplicationType === "FORM_LANDUSECONVERSION";
      setFilters(p => ({
        ...p,
        status: statusMap[cardType] || "",
        riskType: "",
        schemeType: cardType === "Approved" ? isLandUse ? "NON_SCHEME" : "" : cardType === "SelfApproval" ? "SCHEME" : ""
      }));
    }
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth"
    });
  };
  const handlePillClick = pillId => {
    setActivePill(prev => prev === pillId ? null : pillId);
    setActiveCard(null);
    setFilters(p => ({
      ...p,
      status: "",
      riskType: "",
      schemeType: ""
    }));
  };
  const handleChange = key => event => {
    const value = event.target.value;
    const filterValue = key === "applicationType" && value === "ALL" ? "" : value;
    setFilters(p => ({
      ...p,
      [key]: filterValue
    }));
    if (key === "authority") setSelectedAuthority(value);
    if (key === "applicationType") setSelectedApplicationType(value);
  };
  const handleReset = () => {
    setSelectedApplicationType(null);
    if (isSuperAdmin) setSelectedAuthority(null);
    setFromDate(getFinancialYearStart());
    setToDate(() => {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    });
    setActivePill(null);
    setActiveCard(null);
    setOfficerModuleFilter("ALL");
    setFilters({
      department: "",
      applicationType: "",
      status: "",
      riskType: "",
      subStatus: "",
      duplicateStatus: "",
      createdBy: "",
      userDesignation: "",
      assigned: "",
      schemeType: ""
    });
    setTimeout(() => fetchDashboardData(""), 120);
  };
  const filteredApplications = useMemo(() => {
    return dashboardData.filter(app => {
      var _app$status, _app$mainDashBoardSta, _app$dashboardStatus, _app$subDashBoardStat, _app$applicationType, _filters$applicationT;
      const status = ((_app$status = app.status) === null || _app$status === void 0 ? void 0 : _app$status.toLowerCase()) || "";
      const main = ((_app$mainDashBoardSta = app.mainDashBoardStatus) === null || _app$mainDashBoardSta === void 0 ? void 0 : _app$mainDashBoardSta.toLowerCase()) || "";
      const dash = ((_app$dashboardStatus = app.dashboardStatus) === null || _app$dashboardStatus === void 0 ? void 0 : _app$dashboardStatus.toLowerCase()) || "";
      const newSub = (app === null || app === void 0 ? void 0 : (_app$subDashBoardStat = app.subDashBoardStatus) === null || _app$subDashBoardStat === void 0 ? void 0 : _app$subDashBoardStat.toLowerCase()) || "";
      const fs = filters.status || "";
      const isScheme = isSchemeItem$1(app);
      const isMap = matchesPillFilter(app, "MAP_ALL");
      let matchesStatus = !fs;
      if (fs === "Rejected") matchesStatus = status.includes("reject") || main.includes("reject") || dash.includes("reject");else if (fs === "Send back to Applicant") matchesStatus = status.includes("revert to applicant") || status.includes("send back to applicant") || status.includes("shortfall") || main.includes("send back") || main.includes("shortfall") || dash.includes("send back") || dash.includes("shortfall") || main === "citizen_action_pending_at_ltp";else if (fs === "Document Uploaded") matchesStatus = status.includes("document uploaded") || status.includes("pay application fees") || main.includes("pay application fees") || dash.includes("pay application fees");else if (fs === "Approved") {
        const isDsc = isDscPendingStatus$2(app);
        const isForwardingState = status.includes("forward") || status.includes("pending for") || status.includes("pending approval");
        const isApprove = (main.includes("approved") || dash.includes("approved") || status.includes("approved")) && !isDsc && !isForwardingState && !main.includes("provisionally") && !dash.includes("provisionally");
        const isSelfCert = main.includes("self certification") || dash.includes("self certification") || status.includes("self certification") || main.includes("self_certification") || dash.includes("self_certification") || status.includes("self_certification") || main.includes("self approved") || dash.includes("self approved") || status.includes("self approved") || main.includes("self_approved") || dash.includes("self_approved") || status.includes("self_approved") || main.includes("self approval") || dash.includes("self approval") || status.includes("self approval") || main.includes("self_approval") || dash.includes("self_approval") || status.includes("self_approval") || ["self certification approved", "self_certification_approved"].includes(main) || ["self certification approved", "self_certification_approved"].includes(dash) || ["self certification approved", "self_certification_approved"].includes(status);
        if (isMap) {
          matchesStatus = isApprove || isSelfCert;
        } else {
          const isLandUseType = matchesPillFilter(app, "LAND_USE") || matchesPillFilter(app, "LANDUSE_CONVERSION");
          if (isLandUseType) {
            matchesStatus = isApprove && !isScheme && !main.includes("self") && !dash.includes("self");
          } else {
            matchesStatus = isApprove || isSelfCert;
          }
        }
      } else if (fs === "Make Payment" || fs === "Provisionally Approved") {
        matchesStatus = (status.includes("payment pending") || status.includes("architect payment pending") || main.includes("payment pending") || dash.includes("payment pending") || status.includes("make payment") || status.includes("make payment self") || main.includes("provisionally approved") || dash.includes("provisionally approved")) && !status.includes("pay application fees") && !main.includes("pay application fees") && !dash.includes("pay application fees");
      } else if (fs === "In Progress With Officer") {
        matchesStatus = main.includes("in progress with officer") || main.includes("in progress with officers") || dash.includes("in progress with officer") || dash.includes("in progress with officers") || status.includes("forward");
      } else if (fs === "Apply For DSC" || fs === "DSC Pending") matchesStatus = isDscPendingStatus$2(app);else if (fs === "Self Certification Approved" || fs === "Self Approved Scheme" || fs === "Self Approval") {
        if (isMap) {
          matchesStatus = false;
        } else {
          const isDsc = isDscPendingStatus$2(app);
          const isApprove = (main.includes("approved") || main.includes("approve") || dash.includes("approved") || dash.includes("approve")) && !isDsc && !main.includes("provisionally") && !dash.includes("provisionally");
          const isSelfCert = ["self certification approved", "self_certification_approved"].includes(main) || ["self certification approved", "self_certification_approved"].includes(dash);
          matchesStatus = isApprove && isScheme || isSelfCert;
        }
      } else if (fs === "Received") matchesStatus = ["received", "application received"].includes(main) || ["received", "application received"].includes(dash);else if (fs === "Auto Rejected") matchesStatus = status.includes("auto reject") || main.includes("auto reject") || dash.includes("auto reject");else if (fs) matchesStatus = app.mainDashBoardStatus === fs || app.dashboardStatus === fs;
      let matchesSchemeType = true;
      if (filters.schemeType === "SCHEME") matchesSchemeType = isScheme;else if (filters.schemeType === "NON_SCHEME") matchesSchemeType = isMap ? true : !isScheme;
      const appTypeStr = `${app.moduleName || ""} ${app.applicationType || ""}`.toLowerCase();
      if (activePill === "MAP_HIGH") {
        if (appTypeStr.includes("200-500") || appTypeStr.includes("100-30")) return false;
      }
      return matchesStatus && matchesSchemeType && (!activePill || matchesPillFilter(app, activePill)) && (!filters.riskType || (app.riskType === filters.riskType || filters.riskType === "HIGH" && app.riskType === "HIGH_NIVESH" || filters.riskType === "HIGH" && app.riskType === "HIGH_NIVESH") && !(filters.riskType === "HIGH" && (app.riskType === "MEDIUM" || app.riskType === "MED")) && !(filters.riskType.includes("HIGH") && (matchesPillFilter(app, "COMPOUNDING") || matchesPillFilter(app, "COMPLETION")))) && (!filters.applicationType || app.applicationType === filters.applicationType || app.moduleName === filters.applicationType || ((_app$applicationType = app.applicationType) === null || _app$applicationType === void 0 ? void 0 : _app$applicationType.toLowerCase()) === ((_filters$applicationT = filters.applicationType) === null || _filters$applicationT === void 0 ? void 0 : _filters$applicationT.toLowerCase()) || filters.applicationType === "FORM_COMPLETION" && appTypeStr.includes("completion") || filters.applicationType === "FORM_MAP" && appTypeStr.includes("map") || filters.applicationType === "FORM_PLINTH" && appTypeStr.includes("plinth") || filters.applicationType === "FORM_COMPOUNDING" && appTypeStr.includes("compounding") || filters.applicationType === "FORM_LANDUSE" && (appTypeStr.includes("land") || appTypeStr.includes("pressrelease")) && !appTypeStr.includes("conversion") || filters.applicationType === "FORM_LANDUSECONVERSION" && appTypeStr.includes("conversion") || filters.applicationType === "FORM_FAR" && (appTypeStr.includes("far") || appTypeStr.includes("purchasable"))) && (!filters.createdBy || app.createdUserName === filters.createdBy) && (!filters.department || app.department === filters.department);
    });
  }, [dashboardData, filters, activePill]);
  const filterFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      background: "rgba(255,255,255,0.95)",
      "& fieldset": {
        borderColor: "rgba(255,255,255,0.5)"
      },
      "&:hover fieldset": {
        borderColor: "rgba(255,255,255,0.8)"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff"
      }
    }
  };
  const filterLabelSx = {
    color: "#1565c0",
    fontWeight: 700,
    fontSize: "12px",
    backgroundColor: "rgba(255,255,255,0.95)",
    px: 0.5,
    borderRadius: "4px",
    transform: "translate(14px, -9px) scale(0.85)",
    "&.Mui-focused": {
      color: "#1565c0"
    }
  };
  const filterSelectSx = {
    borderRadius: "10px",
    background: "rgba(255,255,255,0.95)",
    color: "#222",
    fontSize: "13px",
    fontWeight: 500
  };
  const datePickerSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      background: "rgba(255,255,255,0.95)",
      fontSize: "13px",
      "& fieldset": {
        borderColor: "rgba(255,255,255,0.5)"
      },
      "&:hover fieldset": {
        borderColor: "rgba(255,255,255,0.8)"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff"
      }
    },
    "& .MuiInputLabel-root": {
      color: "#1565c0",
      fontWeight: 700,
      fontSize: "12px",
      backgroundColor: "rgba(255,255,255,0.95)",
      px: 0.5,
      borderRadius: "4px",
      transform: "translate(14px, -9px) scale(0.85)"
    }
  };
  return /*#__PURE__*/React__default.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: "linear-gradient(160deg,#f0f4ff 0%,#fafbff 50%,#f5f0ff 100%)",
      minHeight: "100vh"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: "linear-gradient(135deg,#0d2b6b 0%,#1565c0 28%,#1976d2 52%,#0288d1 76%,#006064 100%)",
      px: 4,
      pt: 3,
      pb: 0,
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: -80,
      right: -80,
      width: 300,
      height: 300,
      borderRadius: "50%",
      background: "radial-gradient(circle,rgba(255,255,255,0.09) 0%,transparent 70%)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      bottom: -100,
      left: "-5%",
      width: 340,
      height: 340,
      borderRadius: "50%",
      background: "radial-gradient(circle,rgba(255,255,255,0.07) 0%,transparent 70%)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "100%",
      backgroundImage: "radial-gradient(rgba(255,255,255,0.04) 1px,transparent 1px)",
      backgroundSize: "28px 28px",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: -30,
      right: "12%",
      width: 120,
      height: 120,
      border: "1.5px solid rgba(255,255,255,0.12)",
      borderRadius: "50%",
      animation: "v2Spin 18s linear infinite",
      "@keyframes v2Spin": {
        from: {
          transform: "rotate(0deg)"
        },
        to: {
          transform: "rotate(360deg)"
        }
      },
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      position: "absolute",
      top: 10,
      right: "calc(12% + 20px)",
      width: 80,
      height: 80,
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "50%",
      animation: "v2Spin 12s linear infinite reverse",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 2.5,
      position: "relative",
      zIndex: 2
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      textAlign: "center",
      flex: 1,
      px: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 900,
      fontSize: "32px",
      color: "#fff",
      letterSpacing: "-0.5px",
      lineHeight: 1,
      textShadow: "0 2px 20px rgba(0,0,0,0.3)",
      animation: "v2ScaleIn 0.7s cubic-bezier(.4,0,.2,1) 0.1s both",
      "@keyframes v2ScaleIn": {
        from: {
          opacity: 0,
          transform: "scale(0.9)"
        },
        to: {
          opacity: 1,
          transform: "scale(1)"
        }
      }
    }
  }, "FASTPAS"), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mx: "auto",
      mt: 0.8,
      mb: 0.6,
      width: "50%",
      height: "2px",
      borderRadius: "2px",
      background: "linear-gradient(90deg,transparent,rgba(255,255,255,0.7),rgba(100,220,255,0.9),rgba(255,255,255,0.7),transparent)",
      animation: "v2Shimmer 2.5s ease-in-out infinite",
      "@keyframes v2Shimmer": {
        "0%,100%": {
          opacity: 0.65
        },
        "50%": {
          opacity: 1
        }
      }
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "12px",
      color: "rgba(255,255,255,0.6)",
      fontWeight: 500,
      letterSpacing: "0.3px"
    }
  }, "Fast & Simplified Trust based Plan Approval System")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: 1,
      flexShrink: 0
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: "linear-gradient(135deg,rgba(255,255,255,0.15),rgba(255,255,255,0.06))",
      backdropFilter: "blur(12px)",
      borderRadius: "12px",
      px: 2,
      py: 0.8,
      border: "1px solid rgba(255,255,255,0.2)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      color: "#fff",
      fontSize: "12px",
      fontWeight: 600
    }
  }, "\uD83D\uDCC5 ", new Date().toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric"
  }))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: loading ? "linear-gradient(135deg,rgba(255,200,0,0.2),rgba(255,150,0,0.1))" : "linear-gradient(135deg,rgba(76,255,145,0.2),rgba(0,200,100,0.1))",
      backdropFilter: "blur(8px)",
      borderRadius: "10px",
      px: 1.5,
      py: 0.6,
      border: `1px solid ${loading ? "rgba(255,200,0,0.3)" : "rgba(76,255,145,0.3)"}`,
      display: "flex",
      alignItems: "center",
      gap: 0.7
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 7,
      height: 7,
      borderRadius: "50%",
      background: loading ? "#ffc107" : "#4cff91",
      boxShadow: loading ? "0 0 6px #ffc107" : "0 0 6px #4cff91",
      animation: "v2LiveBlink 1.8s infinite"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "11px",
      fontWeight: 700,
      color: loading ? "#ffc107" : "#4cff91"
    }
  }, loading ? "Refreshing…" : "Live Data")))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      background: "rgba(255,255,255,0.10)",
      backdropFilter: "blur(16px)",
      border: "1px solid rgba(255,255,255,0.18)",
      borderRadius: "18px 18px 0 0",
      px: 3,
      pt: 2.5,
      pb: 2,
      position: "relative",
      zIndex: 2,
      animation: "v2SlideUp 0.5s ease 0.25s both",
      "@keyframes v2SlideUp": {
        from: {
          opacity: 0,
          transform: "translateY(14px)"
        },
        to: {
          opacity: 1,
          transform: "translateY(0)"
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true,
    size: "small",
    sx: filterFieldSx
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    shrink: true,
    sx: filterLabelSx
  }, "Authority"), /*#__PURE__*/React__default.createElement(Select$3, {
    value: selectedAuthority || location1 || "",
    onChange: handleChange("authority"),
    label: "Authority",
    disabled: !isSuperAdmin,
    notched: true,
    sx: filterSelectSx
  }, DashboardAuthorityList === null || DashboardAuthorityList === void 0 ? void 0 : DashboardAuthorityList.map(item => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: item.code,
    value: item.label
  }, item.label)), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-1"
  }, "Unit-1"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-2"
  }, "Unit-2"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-3"
  }, "Unit-3"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-4"
  }, "Unit-4"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-5"
  }, "Unit-5"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-6"
  }, "Unit-6"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Unit-7"
  }, "Unit-7")))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React__default.createElement(Stack, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(DatePicker$2, {
    label: "From Date",
    value: fromDate,
    maxDate: toDate,
    onChange: d => {
      if (!d) return;
      setFromDate(d);
      if (toDate > addOneYear(d)) setToDate(addOneYear(d));
    },
    slotProps: {
      textField: {
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          shrink: true
        },
        sx: datePickerSx
      }
    }
  }), /*#__PURE__*/React__default.createElement(DatePicker$2, {
    label: "To Date",
    value: toDate,
    minDate: fromDate,
    maxDate: addOneYear(fromDate),
    onChange: d => {
      if (d) setToDate(d);
    },
    slotProps: {
      textField: {
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          shrink: true
        },
        sx: datePickerSx
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React__default.createElement(Stack, {
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => !loading && fetchDashboardData(""),
    sx: {
      flex: 1,
      height: "40px",
      borderRadius: "10px",
      fontWeight: 800,
      background: "linear-gradient(135deg,#ffffff 0%,#e3f2fd 100%)",
      color: "#0d2b6b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: loading ? "not-allowed" : "pointer",
      gap: 0.5,
      fontSize: "13px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
      "&:hover": {
        background: "linear-gradient(135deg,#ffffff 0%,#bbdefb 100%)",
        transform: loading ? "none" : "translateY(-1px)"
      },
      transition: "all 0.2s ease"
    }
  }, loading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 18,
    sx: {
      color: "#0d2b6b"
    }
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SearchIcon, {
    sx: {
      fontSize: 16
    }
  }), "Search")), /*#__PURE__*/React__default.createElement(Box, {
    onClick: handleReset,
    sx: {
      width: "40px",
      height: "40px",
      borderRadius: "10px",
      background: "rgba(255,255,255,0.2)",
      border: "1px solid rgba(255,255,255,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#fff",
      flexShrink: 0,
      "&:hover": {
        background: "rgba(255,255,255,0.32)"
      }
    }
  }, /*#__PURE__*/React__default.createElement(RefreshIcon, {
    sx: {
      fontSize: 18
    }
  }))))))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      px: 3,
      pt: 3,
      pb: 5
    }
  }, activeCard && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
      background: "linear-gradient(135deg,#e8f4fd,#f0e6ff)",
      borderRadius: "20px",
      px: 2,
      py: 0.6,
      mb: 2,
      border: "1px solid rgba(25,118,210,0.2)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "#1976d2"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontSize: "12px",
      fontWeight: 600,
      color: "#1565c0"
    }
  }, "Filtered: ", activeCard), /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => {
      setActiveCard(null);
      setFilters(f => ({
        ...f,
        status: "",
        riskType: ""
      }));
    },
    sx: {
      ml: 0.5,
      cursor: "pointer",
      color: "#888",
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: 1,
      "&:hover": {
        color: "#d32f2f"
      }
    }
  }, "\xD7")), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      gap: 1.5,
      mb: 3,
      flexWrap: "wrap",
      animation: "v2FadeInUp 0.5s ease 0.2s both",
      "@keyframes v2FadeInUp": {
        from: {
          opacity: 0,
          transform: "translateY(18px)"
        },
        to: {
          opacity: 1,
          transform: "translateY(0)"
        }
      }
    }
  }, PILL_TABS.map((tab, i) => /*#__PURE__*/React__default.createElement(PillTab, {
    key: tab.id,
    tab: tab,
    index: i,
    activePill: activePill,
    pillCounts: pillCounts,
    count: pillCounts ? pillCounts[tab.id] : 0,
    onPillClick: handlePillClick
  })), activePill && /*#__PURE__*/React__default.createElement(Box, {
    onClick: () => handlePillClick(activePill),
    sx: {
      display: "flex",
      alignItems: "center",
      px: 2.5,
      py: 1.1,
      borderRadius: "14px",
      cursor: "pointer",
      border: "1.5px dashed #d1d5db",
      color: "#6b7280",
      fontSize: "12px",
      fontWeight: 600,
      gap: 0.5,
      flexShrink: 0,
      "&:hover": {
        color: "#dc2626",
        borderColor: "#dc2626"
      },
      transition: "all 0.2s ease"
    }
  }, "\u2715 Clear")), activePill === "ALL" ? /*#__PURE__*/React__default.createElement(AllFilesSummaryTable, {
    dashboardData: dashboardData,
    matchesPillFilter: matchesPillFilter,
    onCellClick: (pillId, statusType) => {
      if (pillId && pillId !== "ALL") {
        setActivePill(pillId);
      }
      const statusMap = {
        "Total": "",
        "Approved": "Approved",
        "In Progress With Officer": "In Progress With Officer",
        "Send back to Applicant": "Send back to Applicant",
        "Document Uploaded": "Document Uploaded",
        "Rejected": "Rejected",
        "Make Payment": "Make Payment"
      };
      const isMapPill = pillId === "MAP" || pillId === "MAP_ALL" || pillId === "MAP_LOW" || pillId === "MAP_MED" || pillId === "MAP_HIGH";
      setFilters(prev => ({
        ...prev,
        status: statusMap[statusType] !== undefined ? statusMap[statusType] : statusType,
        schemeType: statusType === "Approved" ? isMapPill ? "" : "NON_SCHEME" : "",
        riskType: pillId === "MAP_LOW" ? "LOW" : pillId === "MAP_MED" ? "MEDIUM" : pillId === "MAP_HIGH" ? "HIGH" : ""
      }));
      const appsSection = document.getElementById("dashboard-v2-applications-section");
      if (appsSection) {
        appsSection.scrollIntoView({
          behavior: "smooth"
        });
      } else {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth"
        });
      }
    },
    onViewAllForPill: pillId => {
      setActivePill(pillId);
      setActiveCard(null);
      setFilters(p => ({
        ...p,
        status: "",
        riskType: "",
        schemeType: ""
      }));
    }
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    sx: {
      mb: 4
    }
  }, cardData.map((card, i) => /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 2,
    key: card.type
  }, /*#__PURE__*/React__default.createElement(AnimatedKpiCard, {
    card: card,
    index: i,
    isActive: activeCard === card.type,
    cardsVisible: cardsVisible,
    onCardClick: handleCardClick
  }))))), /*#__PURE__*/React__default.createElement(SectionLabel, {
    label: "File Disposal Timeline",
    gradientColors: ["#0288d1", "#006064"]
  }), /*#__PURE__*/React__default.createElement(FileDisposalTimeline, {
    data: pillFilteredData,
    location: selectedAuthority || ""
  }), /*#__PURE__*/React__default.createElement(Box, {
    id: "dashboard-v2-applications-section"
  }, /*#__PURE__*/React__default.createElement(SectionLabel, {
    label: "Applications",
    gradientColors: ["#7b1fa2", "#c2185b"]
  })), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    expanded: expandedOfficerAccordion,
    onChange: (e, expanded) => setExpandedOfficerAccordion(expanded),
    sx: {
      borderRadius: "16px !important",
      border: "1px solid rgba(25,118,210,0.15)",
      boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
      background: "#fff",
      "&:before": {
        display: "none"
      },
      overflow: "hidden"
    }
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, {
      sx: {
        color: "#1976d2"
      }
    }),
    sx: {
      background: "linear-gradient(135deg,#e8f4fd 0%,#f0f7ff 100%)",
      borderBottom: expandedOfficerAccordion ? "1px solid rgba(25,118,210,0.1)" : "none",
      minHeight: 56,
      "&.Mui-expanded": {
        minHeight: 56
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      pr: 2,
      flexWrap: "wrap",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      fontSize: "20px"
    }
  }, "\u23F3"), /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 700,
      fontSize: "15px",
      color: "#1565c0"
    }
  }, "In Progress With Officer"), officerBadgeCount > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      ml: 1,
      background: "#1976d2",
      color: "#fff",
      borderRadius: "10px",
      px: 1,
      py: 0.1,
      fontSize: "11px",
      fontWeight: 700
    }
  }, officerBadgeCount)), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    },
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React__default.createElement(Typography, {
    sx: {
      fontWeight: 700,
      fontSize: "13px",
      color: "#1565c0"
    }
  }, "Module:"), /*#__PURE__*/React__default.createElement(Select$3, {
    value: officerModuleFilter,
    onChange: e => {
      setOfficerModuleFilter(e.target.value);
      if (!expandedOfficerAccordion) {
        setExpandedOfficerAccordion(true);
      }
    },
    size: "small",
    sx: {
      height: 32,
      minWidth: 175,
      fontSize: "12px",
      fontWeight: 600,
      borderRadius: "8px",
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(25,118,210,0.3)"
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "ALL",
    sx: {
      fontSize: "12.5px"
    }
  }, "All Modules"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Land Use",
    sx: {
      fontSize: "12.5px"
    }
  }, "Land Use (LU)"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Map Submission",
    sx: {
      fontSize: "12.5px"
    }
  }, "Map Submission (MS)"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Completion",
    sx: {
      fontSize: "12.5px"
    }
  }, "Completion (CC)"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Compounding",
    sx: {
      fontSize: "12.5px"
    }
  }, "Compounding (COMP)"), /*#__PURE__*/React__default.createElement(MenuItem$2, {
    value: "Purchasable FAR",
    sx: {
      fontSize: "12.5px"
    }
  }, "Purchasable FAR (PF)"))))), /*#__PURE__*/React__default.createElement(AccordionDetails, {
    sx: {
      p: 0
    }
  }, isAvpUser ? /*#__PURE__*/React__default.createElement(AVPPendingWithOfficers$1, {
    tenantId: tenantId,
    userDetails: userDetails,
    location: computedLocation,
    department: computedDepartment,
    onApplicationSelect: setSelectedApplication,
    dashboardData: dashboardData,
    fromDate: fromDate,
    toDate: toDate,
    selectedApplicationType: selectedApplicationType,
    moduleFilter: officerModuleFilter,
    onModuleChange: setOfficerModuleFilter
  }) : /*#__PURE__*/React__default.createElement(ProgreesWithOfficer$1, {
    tenantId: tenantId,
    userDetails: userDetails,
    location: computedLocation,
    department: computedDepartment,
    onApplicationSelect: setSelectedApplication,
    dashboardData: dashboardData,
    fromDate: fromDate,
    toDate: toDate,
    selectedApplicationType: selectedApplicationType,
    moduleFilter: officerModuleFilter,
    onModuleChange: setOfficerModuleFilter
  })))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
      border: "1px solid rgba(0,0,0,0.06)"
    }
  }, /*#__PURE__*/React__default.createElement(ApplicationTable$1, {
    dashboardData: pillFilteredData,
    filters: filters,
    fastPasIdSearch: fastPasIdSearch,
    setFastPasIdSearch: setFastPasIdSearch,
    loading: loading,
    showMs: showMs,
    setshowMs: setshowMs,
    onApplicationSelect: setSelectedApplication
  }))))), selectedApplication && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    dataOpen: !!selectedApplication,
    onClose: () => setSelectedApplication(null),
    title: `Application Details - ${selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationNo}`
  }, /*#__PURE__*/React__default.createElement(ApplicationDetail, {
    isFromDashboard: true,
    applicationNo: selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationNo
  })), showInProgressModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    dataOpen: showInProgressModal,
    onClose: () => setShowInProgressModal(false),
    title: `In Progress With Officer — Status Summary${activePill ? ` (${getActivePillLabel(activePill)})` : ""}`
  }, /*#__PURE__*/React__default.createElement(InProgressWithOfficerModal, {
    dashboardData: pillFilteredData,
    onApplicationSelect: setSelectedApplication
  })), showLandUseApprovedModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    dataOpen: showLandUseApprovedModal,
    onClose: () => setShowLandUseApprovedModal(false),
    title: "Land Use Approved \u2014 Status Summary"
  }, /*#__PURE__*/React__default.createElement(LandUseApprovedSummary, {
    dashboardData: dashboardData,
    onApplicationSelect: setSelectedApplication
  }))));
};

const CAD_MAX_SIZE = 300 * 1024 * 1024;
const DRAWING_PDF_MAX_SIZE = 150 * 1024 * 1024;
const DEFAULT_MAX_SIZE = 30 * 1024 * 1024;
const UniversalFileUploader = ({
  name: _name = "fileInput",
  label: _label = "Upload File",
  maxFiles: _maxFiles = 5,
  uploadedDocs: _uploadedDocs = [],
  setUploadedDocs: _setUploadedDocs = () => {},
  control,
  required: _required = false,
  showError: _showError = false,
  tenantId: _tenantId = "up",
  module: _module = "common-upload"
}) => {
  const fileInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const allowedExtensions = [".pdf", ".png", ".jpg", ".jpeg", ".dxf", ".dwg", ".mp3", ".mp4", ".mov", ".avi", ".mkv"];
  const handleFileUpload = async e => {
    const files = Array.from(e.target.files);
    setIsLoading(true);
    setShowToast(null);
    try {
      const alreadyUploaded = docsForThisType.length;
      const filesToUpload = files.slice(0, Math.max(0, _maxFiles - alreadyUploaded));
      for (const file of filesToUpload) {
        const ext = "." + file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(ext)) {
          setShowToast({
            error: true,
            label: `Invalid format: ${file.name}`
          });
          continue;
        }
        const isCadFile = [".dxf", ".dwg"].includes(ext);
        const isDrawingPdf = ext === ".pdf" && ((_name === null || _name === void 0 ? void 0 : _name.toLowerCase().includes("drawing")) || (_label === null || _label === void 0 ? void 0 : _label.toLowerCase().includes("drawing")));
        const limit = isCadFile ? CAD_MAX_SIZE : isDrawingPdf ? DRAWING_PDF_MAX_SIZE : DEFAULT_MAX_SIZE;
        if (file.size > limit) {
          setShowToast({
            error: true,
            label: `${file.name} exceeds ${limit / (1024 * 1024)} MB limit.`
          });
          continue;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("tenantId", _tenantId);
        formData.append("module", _module);
        formData.append("tag", "universal-upload");
        try {
          const resp = await axios$1.post("/filestore/v1/files", formData, {});
          const filesId = resp.data.files[0];
          _setUploadedDocs(prev => [...prev, {
            documentType: _name,
            fileStoreId: filesId.fileStoreId,
            additionalDetails: {
              fileName: file.name,
              title: _label
            }
          }]);
        } catch (err) {
          console.error(err.message);
          setShowToast({
            error: true,
            label: `Upload failed for ${file.name}`
          });
        }
      }
    } finally {
      setIsLoading(false);
      e.target.value = null;
    }
  };
  const handleDelete = fileStoreId => {
    _setUploadedDocs(prev => prev.filter(doc => doc.fileStoreId !== fileStoreId));
  };
  const docsForThisType = _uploadedDocs === null || _uploadedDocs === void 0 ? void 0 : _uploadedDocs.filter(doc => doc.documentType === _name);
  const getAcceptType = () => allowedExtensions.join(",");
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      mb: 0.5
    }
  }, _label, " ", _required && /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "red"
    }
  }, "*")), /*#__PURE__*/React__default.createElement(FormControl$1, {
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    onClick: () => fileInputRef.current.click(),
    sx: {
      height: "32px",
      mb: 1,
      fontSize: "0.75rem",
      backgroundColor: "rgb(21,124,179)",
      "&:hover": {
        backgroundColor: "#004e6c"
      }
    },
    disabled: docsForThisType.length >= _maxFiles
  }, isLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    sx: {
      color: "#fff"
    },
    size: 20
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CloudUploadOutlinedIcon, {
    fontSize: "small",
    sx: {
      mr: 1
    }
  }), "Upload File")), control ? /*#__PURE__*/React__default.createElement(Controller, {
    name: _name,
    control: control,
    rules: {
      required: _required && docsForThisType.length === 0
    },
    render: () => /*#__PURE__*/React__default.createElement("input", {
      ref: fileInputRef,
      type: "file",
      multiple: true,
      accept: getAcceptType(),
      style: {
        display: "none"
      },
      onChange: handleFileUpload
    })
  }) : /*#__PURE__*/React__default.createElement("input", {
    ref: fileInputRef,
    type: "file",
    multiple: true,
    accept: getAcceptType(),
    style: {
      display: "none"
    },
    onChange: handleFileUpload
  })), docsForThisType.length > 0 && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mt: 1
    }
  }, docsForThisType.map(doc => {
    var _doc$additionalDetail;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: doc.fileStoreId,
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "0.8rem",
        p: "4px 8px",
        mb: "6px",
        borderRadius: "4px",
        backgroundColor: "#f1f1f1"
      }
    }, ((_doc$additionalDetail = doc.additionalDetails) === null || _doc$additionalDetail === void 0 ? void 0 : _doc$additionalDetail.fileName) || "Uploaded File", /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: () => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
    }, isPreviewLoading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 14
    }) : /*#__PURE__*/React__default.createElement(VisibilityIcon, {
      fontSize: "small"
    })), /*#__PURE__*/React__default.createElement(IconButton$1, {
      size: "small",
      onClick: () => handleDelete(doc.fileStoreId)
    }, /*#__PURE__*/React__default.createElement(DeleteForeverIcon, {
      color: "error",
      fontSize: "small"
    }))));
  })), _required && _showError && docsForThisType.length === 0 && /*#__PURE__*/React__default.createElement(Typography, {
    color: "error",
    variant: "caption"
  }, `${_label} is required.`), !!(showToast !== null && showToast !== void 0 && showToast.error) && /*#__PURE__*/React__default.createElement(Typography, {
    color: "error",
    variant: "caption"
  }, showToast.label));
};

const documentTypes = ["User Manual", "Video Tutorial", "Training Video", "FAQ", "SOP", "Sample Drawing", "Building Byelaws and GO"];
const approvalUserManual = ["LTP Registration", "Land use Verification", "SelfCertification Via Registration"];
const approvalFAQ = ["FASTPAS FAQ"];
const approvalLAW = ["Building Bye Laws-2025"];
const visibilityType = ["Department Only", "Public"];
const categoryTypes = ["Application", "Bye Laws", "EDCR", "GO"];
const StandardForm = ({
  onClose
}) => {
  const [rows, setRows] = useState([{
    sno: 1,
    category: "",
    description: "",
    docType: "",
    isApproval: "",
    typeOfUser: "",
    fileUrl: ""
  }]);
  const [fileUrlDoc, setFileUrlDoc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token) || null;
  const handleChange = (index, e) => {
    const {
      name,
      value
    } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    if (name === "docType" && value !== "User Manual") {
      newRows[index].isApproval = "";
    }
    if (name === "typeOfUser" && value !== "Department Only") {
      newRows[index].typeOdUser = "";
    }
    setRows(newRows);
  };
  const handleAddRow = () => {
    setRows([...rows, {
      sno: rows.length + 1,
      category: "",
      description: "",
      docType: "",
      isApproval: "",
      fileUrl: ""
    }]);
  };
  const handleDeleteRow = index => {
    const newRows = rows.filter((_, i) => i !== index).map((row, i) => ({
      ...row,
      sno: i + 1
    }));
    setRows(newRows);
    setFileUrlDoc(prev => prev.filter(f => f.rowIndex !== index));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setShowErrors(true);
    try {
      const payload = {
        UserManual: rows.map((row, index) => {
          const uploaded = fileUrlDoc[index];
          return {
            tenantId: "up",
            sno: row.sno.toString(),
            category: row.category,
            description: row.description,
            isApproved: "manual",
            isSubApproved: row.docType || "N/A",
            subCategory: row.isApproval || "N/A",
            downloadLink: (uploaded === null || uploaded === void 0 ? void 0 : uploaded.fileStoreId) || "",
            typeOfUser: row.typeOfUser || ""
          };
        }),
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          userInfo,
          msgId: `${Date.now()}|en_IN`
        }
      };
      console.log("📦 Payload:", payload);
      await axios$1.post(`${Urls$1.UserManualCreate}`, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      setOpenDialog(true);
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Error submitting form. Check console for details.");
    } finally {
      setLoading(false);
    }
  };
  const handleSuccessClose = () => {
    setOpenDialog(false);
    if (onClose) {
      onClose();
    }
  };
  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mx: "auto",
      mt: 4,
      p: 2,
      maxWidth: "95%"
    }
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 3,
    sx: {
      p: 3,
      mb: 4,
      borderRadius: 3,
      background: "linear-gradient(135deg, #f9f9fb, #f0f4ff)",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    onClick: handleCancel,
    sx: {
      position: "absolute",
      top: 8,
      right: 8,
      color: "#1A237E"
    }
  }, /*#__PURE__*/React__default.createElement(Close$8, null)), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    align: "center",
    gutterBottom: true,
    sx: {
      color: "#1A237E",
      fontWeight: 600
    }
  }, "Manual & Documents Form"), /*#__PURE__*/React__default.createElement(Divider, {
    sx: {
      mb: 3
    }
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit
  }, rows.map((row, index) => /*#__PURE__*/React__default.createElement(Paper$1, {
    key: index,
    elevation: 1,
    sx: {
      p: 2,
      mb: 2,
      borderRadius: 2,
      backgroundColor: "#fff",
      border: "1px solid #e0e0e0"
    }
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 1
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "S.No.",
    value: row.sno,
    disabled: true,
    size: "small",
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: "Document Type",
    name: "docType",
    value: row.docType,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, documentTypes.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), (row.docType === "User Manual" || row.docType === "Training Video" || row.docType === "Video Tutorial" || row.docType === "Sample Drawing" || row.docType === "SOP") && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: row.docType,
    name: "isApproval",
    value: row.isApproval,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, approvalUserManual.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), row.docType === "FAQ" && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: "FAQ",
    name: "isApproval",
    value: row.isApproval,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, approvalFAQ.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), row.docType === "Building Byelaws and GO" && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: "Building Byelaws and GO",
    name: "isApproval",
    value: row.isApproval,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, approvalLAW.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: "Category",
    name: "category",
    value: row.category,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, categoryTypes.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Description",
    name: "description",
    value: row.description,
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 1
  }, /*#__PURE__*/React__default.createElement(TextField, {
    select: true,
    label: "Visibility",
    name: "typeOfUser",
    value: row.typeOfUser || "",
    onChange: e => handleChange(index, e),
    fullWidth: true,
    size: "small",
    required: true
  }, visibilityType.map(type => /*#__PURE__*/React__default.createElement(MenuItem$2, {
    key: type,
    value: type
  }, type)))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 2
  }, /*#__PURE__*/React__default.createElement(UniversalFileUploader, {
    label: "Upload your files",
    name: `fileUploader-${index}`,
    uploadedDocs: fileUrlDoc,
    setUploadedDocs: setFileUrlDoc,
    maxFiles: 5,
    required: true,
    showError: showErrors && fileUrlDoc.filter(f => f.documentType === `fileUploader-${index}`).length === 0
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "error",
    onClick: () => handleDeleteRow(index)
  }, /*#__PURE__*/React__default.createElement(Delete, null)))))), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    gap: 2,
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(Add, null),
    onClick: handleAddRow,
    disabled: loading,
    sx: {
      textTransform: "none",
      borderColor: "#1A237E",
      color: "#1A237E",
      "&:hover": {
        backgroundColor: "#e8eaf6"
      }
    }
  }, "Add Row"), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: loading,
    sx: {
      textTransform: "none",
      backgroundColor: "#1A237E",
      "&:hover": {
        backgroundColor: "#303f9f"
      }
    }
  }, loading ? "Submitting..." : "Submit All"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    color: "error",
    onClick: handleCancel,
    disabled: loading,
    sx: {
      textTransform: "none"
    }
  }, "Cancel")))), rows.length > 0 && /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 2,
    sx: {
      p: 2,
      borderRadius: 2,
      border: "1px solid #e0e0e0",
      backgroundColor: "#fafbff"
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    sx: {
      color: "#1A237E",
      fontWeight: 600
    }
  }, "Live Preview"), /*#__PURE__*/React__default.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "#e8eaf6"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, "S.No."), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Category"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Description"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Document Type"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "Sub Type"), /*#__PURE__*/React__default.createElement(TableCell$1, null, "File"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, rows.map((row, i) => {
    var _fileUrlDoc$i;
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: row.sno
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, row.sno), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.category), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.docType), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.isApproval || "N/A"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (_fileUrlDoc$i = fileUrlDoc[i]) !== null && _fileUrlDoc$i !== void 0 && _fileUrlDoc$i.fileStoreId ? /*#__PURE__*/React__default.createElement("a", {
      href: fileUrlDoc[i].fileStoreId,
      target: "_blank",
      rel: "noreferrer",
      style: {
        color: "#1A237E"
      }
    }, "View") : "-"));
  })))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: openDialog,
    onClose: handleSuccessClose
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Success"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(Typography, null, "Form submitted successfully!")), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleSuccessClose,
    color: "primary"
  }, "Close"))));
};

const WhatsNew = () => {
  const [rows, setRows] = useState([]);
  const [category, setCategory] = useState("");
  const [date, setDate] = useState(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token) || null;
  const handleAdd = () => {
    if (!category || !description) {
      alert("Please enter both Category and Description.");
      return;
    }
    const newRow = {
      sno: rows.length + 1,
      category,
      updatedDate: date,
      description,
      updatedOn: new Date().toLocaleString()
    };
    setRows([...rows, newRow]);
    setCategory("");
    setDate(null);
    setDescription("");
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setShowErrors(true);
    try {
      const payload = {
        UserManual: rows.map(row => ({
          tenantId: "up",
          sno: row.sno.toString(),
          category: row.category,
          updatedDate: row.updatedDate ? row.updatedDate.format("YYYY-MM-DD") : "",
          description: row.description,
          isApproved: "Whats New",
          isSubApproved: "",
          subCategory: "",
          downloadLink: ""
        })),
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          userInfo,
          msgId: `${Date.now()}|en_IN`
        }
      };
      console.log("📦 Payload:", payload);
      await axios$1.post(`${Urls$1.UserManualCreate}`, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      setOpenDialog(true);
      alert("✅ Data submitted successfully!");
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Error submitting form. Check console for details.");
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(LocalizationProvider, {
    dateAdapter: AdapterDayjs
  }, /*#__PURE__*/React__default.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "\uD83E\uDDFE What's New"), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 3
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Category",
    value: category,
    defaultValue: "New",
    onChange: e => setCategory(e.target.value),
    sx: {
      flex: 1
    }
  }), /*#__PURE__*/React__default.createElement(DatePicker$2, {
    label: "Date",
    value: date,
    onChange: newValue => setDate(newValue),
    renderInput: params => /*#__PURE__*/React__default.createElement(TextField, Object.assign({}, params, {
      sx: {
        flex: 1
      }
    }))
  })), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1"
  }, "Description :"), /*#__PURE__*/React__default.createElement(DemoParinted, {
    content: description,
    setContent: setDescription
  }), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    gap: 2,
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleAdd,
    disabled: loading
  }, "Add Record"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    onClick: handleSubmit,
    disabled: rows.length === 0 || loading
  }, loading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 24
  }) : "Submit"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "S.No.")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Category")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Date")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Description")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Updated On")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, rows.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.category), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.updatedDate ? row.updatedDate.format("DD/MM/YYYY") : ""), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: row.description
    },
    style: {
      border: "1px solid #ccc",
      padding: "8px",
      borderRadius: "4px",
      backgroundColor: "#fafafa"
    }
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.updatedOn))))))));
};

const EmpFileTransfer = ({
  t,
  control,
  handleSubmit,
  onSubmit,
  watch,
  departmentList,
  getOfficesListForIndex,
  getApplicationFlowForIndex,
  handleEmpSearch,
  handleFileTransfer,
  employeeIdList
}) => {
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer3"
  }, /*#__PURE__*/React__default.createElement("form", {
    className: "formContainer",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Employee File Transfer")))), /*#__PURE__*/React__default.createElement(AccordionDetails, {
    className: "formInputContainer common-app-form emp-transfer-accordiondetails"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-transfer-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-transfer-formcontainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Transfer Files From"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form emp-transfer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Department",
    name: `selectedDepartmentFrom`,
    type: "selectInput",
    data: departmentList,
    mandatory: true,
    width: "16.25vw",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Authority",
    name: `selectedAuthorityFrom`,
    type: "selectInput",
    data: getOfficesListForIndex(watch("selectedDepartmentFrom")),
    mandatory: true,
    width: "16.25vw",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    disabled: !getApplicationFlowForIndex()
  }))), (employeeIdList === null || employeeIdList === void 0 ? void 0 : employeeIdList.length) > 0 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "96.5%",
    control: control,
    label: "Select Employee Id",
    inputLabel: "Select Employee Id",
    placeholder: "Select Employee Id",
    name: "employeeIdFrom",
    type: "searchSelect",
    returnObject: true,
    data: employeeIdList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer emp-transfer-formcontainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Transfer Files To"))), /*#__PURE__*/React__default.createElement(Container, {
    className: "formInputContainer common-app-form emp-transfer",
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Department",
    name: `selectedDepartmentTo`,
    type: "selectInput",
    data: departmentList,
    defaultValue: watchDepartment || "",
    disabled: true,
    mandatory: true,
    width: "16.25vw",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Authority",
    name: `selectedAuthorityTo`,
    type: "selectInput",
    data: getOfficesListForIndex(watch("selectedDepartmentTo")),
    defaultValue: watchAuthority || "",
    disabled: true,
    mandatory: true,
    width: "16.25vw",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (employeeIdList === null || employeeIdList === void 0 ? void 0 : employeeIdList.length) > 0 && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    width: "96.5%",
    control: control,
    label: "Select Employee Id",
    inputLabel: "Select Employee Id",
    placeholder: "Select Employee Id",
    name: "employeeIdTo",
    type: "searchSelect",
    returnObject: true,
    data: employeeIdList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper emp-transfer-buttonwrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "info",
    size: "medium",
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Search", " ", /*#__PURE__*/React__default.createElement(SearchIcon, {
      sx: {
        color: "#fff",
        height: "18px",
        width: "18px"
      }
    })),
    type: "button",
    disabled: !watch("selectedAuthorityFrom"),
    onClick: () => handleEmpSearch(watch("selectedAuthorityFrom")),
    sx: {
      backgroundColor: "#1565C0",
      marginRight: "4px",
      marginTop: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Transfer",
    type: "button",
    disabled: !(watch("employeeIdTo") && watch("employeeIdFrom")),
    onClick: handleFileTransfer,
    sx: {
      backgroundColor: "black",
      marginRight: "4px",
      marginTop: "20px"
    }
  }))))));
};

function DeactivateEmployee({
  t,
  control,
  handleSubmit,
  onSubmit,
  watch,
  departmentList,
  getOfficesListForIndex,
  getOtherRoleName,
  trigger
}) {
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const user = Digit.UserService.getUser();
  const {
    documents
  } = useSelector(state => state.formMT);
  const userInfo = user.info || {};
  const authToken = (user === null || user === void 0 ? void 0 : user.access_token) || null;
  const stateId = Digit.ULBService.getStateId();
  const columns = [{
    id: "empId",
    label: "Employee Id",
    width: "17%"
  }, {
    id: "name",
    label: "Name",
    width: "16%"
  }, {
    id: "role",
    label: "Role",
    width: "13%"
  }, {
    id: "remark",
    label: "Remark",
    width: "13%"
  }, {
    id: "upload",
    label: "Upload",
    width: "13%"
  }];
  const watchFromEmp = watch("employeeIdDeactivate");
  async function handleEmpSearch(authority) {
    var _authority$split$;
    if (!authority) {
      return;
    }
    const watchDepartment = watch("selectedDepartment");
    setLoading(true);
    const location = watchDepartment === "DA" ? authority === null || authority === void 0 ? void 0 : authority.split(" ")[0] : authority === null || authority === void 0 ? void 0 : (_authority$split$ = authority.split(",")[1]) === null || _authority$split$ === void 0 ? void 0 : _authority$split$.trim();
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user === null || user === void 0 ? void 0 : user.info
      }
    };
    try {
      var _response$data, _response$data2;
      const response = await axios$1.post(`${Urls$1.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.user);
      setEmployeeIdList(((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.user) || []).map(employee => ({
        label: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        value: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        name: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        payload: employee
      })));
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }
  const validateFiles = () => {
    const uploadedDocs = new Set(documents === null || documents === void 0 ? void 0 : documents.map(doc => doc.documentType));
    const requiredDocs = ["deactivateOrder"];
    return requiredDocs.every(doc => uploadedDocs.has(doc));
  };
  const handleDeactivateEmp = async uuid => {
    trigger();
    const isValid = validateFiles();
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
    if (!uuid) return;
    console.log("uuidfromfunc", uuid);
    let result = 0;
    try {
      result = await Digit.WorkflowService.getCount("up", {
        assignee: uuid
      });
      console.log("loggingcountresponse", result);
    } catch (error) {
      console.error("Error while fetching count:", error);
    }
    if (result.data !== 0) {
      alert("Employee cannot be deactivated as there are pending files assigned.");
      return;
    }
    const selectedUser = await Digit.UserService.userSearch(stateId, {
      uuid: [uuid]
    }, {});
    console.log("selectedUser", selectedUser);
    try {
      var _selectedUser$user, _selectedUser$user$;
      const payload = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken: authToken,
          userInfo: userInfo,
          msgId: "1743578637716|en_IN"
        },
        userName: selectedUser === null || selectedUser === void 0 ? void 0 : (_selectedUser$user = selectedUser.user) === null || _selectedUser$user === void 0 ? void 0 : (_selectedUser$user$ = _selectedUser$user[0]) === null || _selectedUser$user$ === void 0 ? void 0 : _selectedUser$user$.userName
      };
      const response = await axios$1.post(`${Urls$1.hrms.deactivateUser}`, payload);
      alert("Employee Deactivated Successfully");
      console.log("logafterdeactivation", response);
    } catch (error) {
      console.error("Error while deactivating employee:", error);
      alert("Failed to deactivate employee. Please try again.");
      return;
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    className: "formContainer",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Deactivate Employee")))), /*#__PURE__*/React__default.createElement(AccordionDetails, {
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "mb-3"
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Department",
    name: `selectedDepartment`,
    type: "selectInput",
    data: departmentList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Authority",
    name: `selectedAuthorityDeactivate`,
    type: "selectInput",
    data: getOfficesListForIndex(watch("selectedDepartment")),
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), (employeeIdList === null || employeeIdList === void 0 ? void 0 : employeeIdList.length) > 0 && /*#__PURE__*/React__default.createElement(Row$1, {
    className: "mb-3"
  }, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Select Employee Id",
    inputLabel: "Select Employee Id",
    placeholder: "Select Employee Id",
    name: "employeeIdDeactivate",
    type: "searchSelect",
    returnObject: true,
    data: employeeIdList,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, null))), watchFromEmp && (_watchFromEmp$payload => {
    const selectedEmpRole = getOtherRoleName((watchFromEmp === null || watchFromEmp === void 0 ? void 0 : (_watchFromEmp$payload = watchFromEmp.payload) === null || _watchFromEmp$payload === void 0 ? void 0 : _watchFromEmp$payload.roles) || []);
    console.log("selectedEmpROle", selectedEmpRole);
    return /*#__PURE__*/React__default.createElement(TableContainer$1, {
      component: Paper$1,
      className: "table-container emp-transfer-tablecontainer"
    }, " ", /*#__PURE__*/React__default.createElement(Table$2, {
      stickyHeader: true,
      "aria-label": "noc info table",
      className: "application-table"
    }, " ", /*#__PURE__*/React__default.createElement(TableHead$1, null, " ", /*#__PURE__*/React__default.createElement(TableRow$1, {
      className: "citizen-header-row"
    }, " ", columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: column.id,
      style: {
        width: column.width,
        fontWeight: "bold",
        background: "#1f4a7c",
        color: "#fff",
        fontSize: "13px"
      }
    }, " ", column.label, " ")), " "), " "), " ", /*#__PURE__*/React__default.createElement(TableBody$1, null, " ", /*#__PURE__*/React__default.createElement(TableRow$1, null, " ", /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        fontSize: "13px"
      }
    }, watchFromEmp.payload.userName || "-"), " ", /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        fontSize: "13px"
      }
    }, watchFromEmp.payload.name || "-"), " ", /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        fontSize: "13px",
        textAlign: "center"
      }
    }, selectedEmpRole || "-"), " ", /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        fontSize: "13px",
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(InputWrapper, {
      width: "100%",
      hasLabel: false,
      control: control,
      placeholder: "Enter remarks",
      name: `deactivateRemarks`,
      type: "textInput",
      mandatory: true,
      isRequired: true,
      validation: {
        required: {
          value: true,
          message: "This field is required"
        }
      }
    })), " ", /*#__PURE__*/React__default.createElement(TableCell$1, {
      style: {
        fontSize: "13px",
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement(FileUploader$3, {
      isMandatory: true,
      hasLabel: false,
      control: control,
      name: "deactivateOrder",
      validationMsg: "Upload File",
      required: true,
      tab: 4,
      showError: showError,
      maxFiles: 1
    })), " "), " "), " "), " ");
  })(), /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper emp-transfer-buttonwrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "info",
    size: "medium",
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Search", " ", /*#__PURE__*/React__default.createElement(SearchIcon, {
      sx: {
        color: "#fff",
        height: "18px",
        width: "18px"
      }
    })),
    type: "button",
    disabled: !watch("selectedAuthorityDeactivate"),
    onClick: () => handleEmpSearch(watch("selectedAuthorityDeactivate")),
    sx: {
      backgroundColor: "#1565C0",
      marginRight: "4px",
      marginTop: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Deactivate",
    type: "button",
    disabled: !watch("employeeIdDeactivate"),
    onClick: () => {
      var _watchFromEmp$payload2;
      return handleDeactivateEmp(watchFromEmp === null || watchFromEmp === void 0 ? void 0 : (_watchFromEmp$payload2 = watchFromEmp.payload) === null || _watchFromEmp$payload2 === void 0 ? void 0 : _watchFromEmp$payload2.uuid);
    },
    sx: {
      backgroundColor: "#ED6C02",
      marginRight: "4px",
      marginTop: "20px"
    }
  }))))));
}

const InitiateTransfer = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const user = Digit.UserService.getUser();
  const authToken = (user === null || user === void 0 ? void 0 : user.access_token) || null;
  const [filteredRolesInfor, setFilteredRolesInfor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [fromSearchCompleted, setFromSearchCompleted] = useState({});
  const [toSearchCompleted, setToSearchCompleted] = useState({});
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: {
      errors
    }
  } = useForm({
    defaultValues
  });
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");
  const watchFromEmp = watch("employeeIdFrom");
  const watchToEmp = watch("employeeIdTo");
  function getOtherRoleName(roles) {
    const otherRole = roles.find(role => role.name.toLowerCase() !== "employee");
    console.log("fromGetOtherRoleName", otherRole);
    return otherRole ? otherRole.name : null;
  }
  const getApplicationFlowForIndex = () => watchDepartment || "";
  const departmentList = [{
    value: "DA",
    label: "Development Authority"
  }, {
    value: "AVP",
    label: "Awas Evam Vikas Parishad"
  }];
  const {
    data: EmployeeTypes = {},
    isLoadings
  } = Digit.Hooks.hrms.useHrmsMDMS(tenantId, "egov-hrms", "HRMSRolesandDesignation") || {};
  const {
    data: {
      BPA: {
        Organizations
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const daList = Organizations === null || Organizations === void 0 ? void 0 : Organizations.filter(item => item.Type === "DA");
  const avpList = Organizations === null || Organizations === void 0 ? void 0 : Organizations.filter(item => item.Type === "AVP");
  const filterDepartmentsList = completeList => {
    return completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
  };
  const getOfficesListForIndex = currentApplicationFlow => {
    return currentApplicationFlow === "DA" ? filterDepartmentsList(daList) : currentApplicationFlow === "AVP" ? filterDepartmentsList(avpList) : [];
  };
  const onSubmit = async data => {
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user === null || user === void 0 ? void 0 : user.info
      },
      JobDelegation: data.transferDetails.map(transfer => ({
        departmentId: transfer.departmentId,
        currentLocation: transfer.location1,
        tenantId: transfer.districtCode,
        empId: transfer.empId,
        oldDesignationRole: transfer.oldDesignationRole,
        roles: transfer.roles.map(role => ({
          code: role.code,
          name: role.name,
          description: role.description
        })),
        location1: transfer.district,
        location2: transfer.area,
        ward: transfer.location3,
        startDate: transfer.startDate,
        endDate: transfer.endDate
      }))
    };
    try {
      const response = await axios$1.post(`${Urls$1.hrms.UserJobdelegationSearch}`, payload);
      setOpenApplicantPopup(true);
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form.");
    }
  };
  async function handleEmpSearch(authority) {
    var _authority$split$;
    if (!authority) {
      return;
    }
    setLoading(true);
    const location = watchDepartment === "DA" ? authority === null || authority === void 0 ? void 0 : authority.split(" ")[0] : authority === null || authority === void 0 ? void 0 : (_authority$split$ = authority.split(",")[1]) === null || _authority$split$ === void 0 ? void 0 : _authority$split$.trim();
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user === null || user === void 0 ? void 0 : user.info
      }
    };
    try {
      var _response$data2, _response$data3;
      const response = await axios$1.post(`${Urls$1.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.user);
      setEmployeeIdList(((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.user) || []).map(employee => ({
        label: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        value: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        name: String(`${employee === null || employee === void 0 ? void 0 : employee.userName} - ${employee === null || employee === void 0 ? void 0 : employee.name}`),
        payload: employee
      })));
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }
  async function handleFileTransfer() {
    var _watchFromEmp$value, _watchToEmp$value;
    console.log("bothEmployees", watchFromEmp, watchToEmp);
    const filters = {
      oldEmpId: (watchFromEmp === null || watchFromEmp === void 0 ? void 0 : (_watchFromEmp$value = watchFromEmp.value) === null || _watchFromEmp$value === void 0 ? void 0 : _watchFromEmp$value.split("-")[0].trim()) || "",
      newEmpId: (watchToEmp === null || watchToEmp === void 0 ? void 0 : (_watchToEmp$value = watchToEmp.value) === null || _watchToEmp$value === void 0 ? void 0 : _watchToEmp$value.split("-")[0].trim()) || ""
    };
    console.log("filtersFromtransfer", filters);
    if (filters.oldEmpId === "" || filters.newEmpId === "") {
      alert("Please select both Old Employee Id and New Employee Id");
      return;
    }
    if (filters.oldEmpId === filters.newEmpId) {
      alert("Old Employee Id and New Employee Id cannot be the same");
      return;
    }
    Digit.UserService.employeeFileTransfer(filters).then(res => {
      if (!res || res.status === 200 || res.status === 204 || res.success) {
        alert("Employee File Transfer Successful");
      } else {
        console.log("Unexpected Response:", res);
        alert("Employee File Transfer Failed");
      }
    }).catch(err => {
      console.error("errorFromFileTransfer", err);
      alert("Employee File Transfer Failed");
    });
  }
  if (loading && isLoadings) {
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, null));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmpFileTransfer, {
    t: t,
    control: control,
    handleSubmit: handleSubmit,
    onSubmit: onSubmit,
    watch: watch,
    departmentList: departmentList,
    getOfficesListForIndex: getOfficesListForIndex,
    getApplicationFlowForIndex: getApplicationFlowForIndex,
    handleEmpSearch: handleEmpSearch,
    handleFileTransfer: handleFileTransfer,
    employeeIdList: employeeIdList
  }), /*#__PURE__*/React__default.createElement(DeactivateEmployee, {
    t: t,
    control: control,
    handleSubmit: handleSubmit,
    onSubmit: onSubmit,
    watch: watch,
    departmentList: departmentList,
    getOfficesListForIndex: getOfficesListForIndex,
    getApplicationFlowForIndex: getApplicationFlowForIndex,
    handleFileTransfer: handleFileTransfer,
    getOtherRoleName: getOtherRoleName,
    trigger: trigger
  }));
};

const UserManualTable = ({
  formType,
  isSubApproved
}) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editRow, setEditRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [deletingId, setDeletingId] = useState(null);
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios$1.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=${isSubApproved}`, dataToSend);
      console.log("📘 Response From User Manual API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching user manual data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  const handleDelete = async id => {
    if (!window.confirm("Are you sure you want to delete this manual?")) return;
    try {
      setDeletingId(id);
      const payload = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      await axios$1.post(`${Urls$1.UserManualDelete}?id=${id}`, payload);
      console.log("PayloadDelete", payload);
      alert("Deleted successfully!");
      fetchManualData();
    } catch (error) {
      console.error("❌ Delete failed:", error);
      alert("Delete failed. Please try again.");
    } finally {
      setDeletingId(null);
    }
  };
  const handleEdit = row => {
    setEditRow(row.id);
    setEditData({
      ...row
    });
  };
  const handleSave = async () => {
    try {
      const payload = {
        RequestInfo: {
          apiId: "Rainmaker"
        },
        UserManual: [editData]
      };
      await axios$1.post(`${Urls$1.UserManualUpdate}`, payload);
      alert("Updated successfully!");
      setEditRow(null);
      fetchManualData();
    } catch (error) {
      console.error("❌ Update failed:", error);
      alert("Update failed. Please try again.");
    }
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper$1, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      maxHeight: 400,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "User Manual"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    sx: {
      fontWeight: 600
    }
  }, "Actions"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, tableData.length > 0 ? tableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell$1, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link$1, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"), /*#__PURE__*/React__default.createElement(TableCell$1, {
      sx: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "outlined",
      color: "primary",
      onClick: () => handleEdit(row),
      sx: {
        mr: 1
      }
    }, "Edit"), /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      variant: "outlined",
      color: "error",
      disabled: deletingId === row.id,
      onClick: () => handleDelete(row.id)
    }, deletingId === row.id ? "Deleting..." : "Delete")));
  }) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 7,
    align: "center"
  }, "No data available"))))), /*#__PURE__*/React__default.createElement(Dialog$1, {
    open: Boolean(editRow),
    onClose: () => setEditRow(null),
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(DialogTitle$1, null, "Edit User Manual"), /*#__PURE__*/React__default.createElement(DialogContent$1, null, /*#__PURE__*/React__default.createElement(TextField, {
    margin: "dense",
    label: "Category",
    fullWidth: true,
    value: editData.category || "",
    onChange: e => setEditData({
      ...editData,
      category: e.target.value
    })
  }), /*#__PURE__*/React__default.createElement(TextField, {
    margin: "dense",
    label: "Description",
    fullWidth: true,
    value: editData.description || "",
    onChange: e => setEditData({
      ...editData,
      description: e.target.value
    })
  }), /*#__PURE__*/React__default.createElement(TextField, {
    margin: "dense",
    label: "Download Link",
    fullWidth: true,
    value: editData.downloadLink || "",
    onChange: e => setEditData({
      ...editData,
      downloadLink: e.target.value
    })
  })), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: () => setEditRow(null)
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleSave,
    variant: "contained"
  }, "Save"))));
};

const UserManualPopup = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabLabels = ["User Manual", "Video Tutorial", "Training Video", "FAQ", "SOP", "Sample Drawing", "Building Byelaws and GO"];
  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const TabPanel = ({
    children,
    value,
    index
  }) => /*#__PURE__*/React__default.createElement(Box, {
    role: "tabpanel",
    hidden: value !== index,
    sx: {
      p: 3,
      backgroundColor: "#fff",
      borderRadius: 1,
      boxShadow: 1,
      minHeight: 240
    }
  }, value === index && children);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DialogTitle$1, {
    sx: {
      textAlign: "center",
      fontWeight: 600,
      fontSize: "1.3rem",
      background: "linear-gradient(to right, #0c5a88, #1976d2)",
      color: "#fff",
      padding: "12px 20px",
      lineHeight: 1.0,
      position: "relative",
      minHeight: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, "Manual & Documents"), /*#__PURE__*/React__default.createElement(DialogContent$1, {
    sx: {
      p: 3
    }
  }, /*#__PURE__*/React__default.createElement(Paper$1, {
    elevation: 0,
    sx: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      mb: 2,
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: activeTab,
    onChange: handleTabChange,
    variant: "scrollable",
    scrollButtons: "auto",
    TabIndicatorProps: {
      style: {
        backgroundColor: "#0c5a88"
      }
    },
    sx: {
      "& .MuiTab-root": {
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 1,
        mx: 0.5,
        backgroundColor: "#c5e3f6",
        color: "#0c3d64",
        minWidth: 140,
        "&.Mui-selected": {
          backgroundColor: "#0c5a88",
          color: "#fff"
        }
      }
    }
  }, tabLabels.map((label, index) => /*#__PURE__*/React__default.createElement(Tab, {
    key: index,
    label: label
  })))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 0
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "User Manual"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 1
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "Video Tutorial"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 2
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "Training Video"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 3
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "FAQ"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 4
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "SOP"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 5
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "Sample Drawing"
  })), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 6
  }, /*#__PURE__*/React__default.createElement(UserManualTable, {
    tenantId: "hp",
    formType: "manual",
    isSubApproved: "Building Byelaws and GO"
  }))));
};

const HeroBanner = () => {
  const [rows, setRows] = useState([]);
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token) || null;
  const handleAdd = () => {
    if (!category || !description) {
      alert("Please enter both Category and Description.");
      return;
    }
    const newRow = {
      sno: rows.length + 1,
      category,
      description,
      updatedOn: new Date().toLocaleString()
    };
    setRows([...rows, newRow]);
    setCategory("");
    setDescription("");
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setShowErrors(true);
    try {
      const payload = {
        UserManual: rows.map(row => ({
          tenantId: "up",
          sno: row.sno.toString(),
          category: row.category,
          description: row.description,
          isApproved: "Latest Release",
          isSubApproved: "",
          subCategory: "",
          downloadLink: ""
        })),
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          userInfo,
          msgId: `${Date.now()}|en_IN`
        }
      };
      console.log("📦 Payload:", payload);
      await axios$1.post(`${Urls$1.UserManualCreate}`, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      setOpenDialog(true);
      alert("✅ Data submitted successfully!");
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Error submitting form. Check console for details.");
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "\uD83E\uDDFE Latest Release"), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 3
  }, /*#__PURE__*/React__default.createElement(TextField, {
    label: "Category",
    value: category,
    defaultValue: "Latest Release",
    onChange: e => setCategory(e.target.value),
    fullWidth: true
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1"
  }, "Description :"), /*#__PURE__*/React__default.createElement(DemoParinted, {
    content: description,
    setContent: setDescription
  }), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    gap: 2,
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleAdd,
    disabled: loading
  }, "Add Record"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "success",
    onClick: handleSubmit,
    disabled: rows.length === 0 || loading
  }, loading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 24
  }) : "Submit"))), /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, {
    sx: {
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "S.No.")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Category")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Description")), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("strong", null, "Updated On")))), /*#__PURE__*/React__default.createElement(TableBody$1, null, rows.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.category), /*#__PURE__*/React__default.createElement(TableCell$1, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: row.description
    },
    style: {
      border: "1px solid #ccc",
      padding: "8px",
      borderRadius: "4px",
      backgroundColor: "#fafafa"
    }
  })), /*#__PURE__*/React__default.createElement(TableCell$1, null, row.updatedOn)))))));
};

const RibbonMessage = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = userInfo === null || userInfo === void 0 ? void 0 : userInfo.access_token;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const saveRibbon = async description => {
    setLoading(true);
    const payload = {
      UserManual: [{
        tenantId,
        sno: "1",
        category: "RIBBON",
        description,
        isApproved: "RIBBON_MESSAGE",
        isSubApproved: "",
        subCategory: "",
        downloadLink: ""
      }],
      RequestInfo: {
        apiId: "Rainmaker",
        authToken,
        userInfo,
        msgId: `${Date.now()}|en_IN`
      }
    };
    try {
      await axios$1.post(Urls$1.UserManualCreate, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.info(description ? "Ribbon message published" : "Ribbon message removed");
      setMessage("");
    } catch (e) {
      console.error("Ribbon action failed", e);
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    p: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "\uD83D\uDEA8 Ribbon Message"), /*#__PURE__*/React__default.createElement(DemoParinted, {
    content: message,
    setContent: setMessage
  }), /*#__PURE__*/React__default.createElement(Box, {
    mt: 3,
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "error",
    disabled: loading,
    onClick: () => {
      if (!message.trim()) return;
      saveRibbon(message);
    }
  }, loading ? /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 22
  }) : "Publish"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    color: "secondary",
    disabled: loading,
    onClick: () => saveRibbon("")
  }, "Remove from Homepage")));
};

const useStyles$s = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd"
  },
  blueText: {
    color: "#1F4A7C"
  }
});
const headerData$8 = [{
  slno: "Sl. No"
}, {
  Name: "LTP Name"
}, {
  mobileNo: "LTP Type"
}, {
  formType: "Application Number"
}, {
  planningFee: "License Number"
}, {
  RefNo: "Mobile No"
}, {
  status: "Email"
}, {
  authority: "Authority"
}, {
  dos: "District"
}, {
  dos: "Validity"
}];
const StyledTableCell$g = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$g = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$8 = ({
  apiData
}) => {
  var _apiData$Licenses;
  const {
    t
  } = useTranslation();
  const classes = useStyles$s();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$8.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.Licenses.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
    var _item$tradeLicenseDet, _item$tradeLicenseDet2, _item$tradeLicenseDet3, _item$tradeLicenseDet4, _item$tradeLicenseDet5, _item$tradeLicenseDet6, _item$tradeLicenseDet7, _item$tradeLicenseDet8, _item$tradeLicenseDet9, _item$tradeLicenseDet10, _item$tradeLicenseDet11, _item$tradeLicenseDet12, _item$tradeLicenseDet13, _item$tradeLicenseDet14, _item$tradeLicenseDet15, _item$tradeLicenseDet16, _item$tradeLicenseDet17, _item$tradeLicenseDet18, _item$tradeLicenseDet19, _item$tradeLicenseDet20, _item$tradeLicenseDet21, _item$tradeLicenseDet22, _item$tradeLicenseDet23;
    return /*#__PURE__*/React__default.createElement(StyledTableRow$g, {
      key: item === null || item === void 0 ? void 0 : item.id
    }, /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet = item.tradeLicenseDetail) === null || _item$tradeLicenseDet === void 0 ? void 0 : (_item$tradeLicenseDet2 = _item$tradeLicenseDet.owners) === null || _item$tradeLicenseDet2 === void 0 ? void 0 : (_item$tradeLicenseDet3 = _item$tradeLicenseDet2[0]) === null || _item$tradeLicenseDet3 === void 0 ? void 0 : _item$tradeLicenseDet3.name), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet4 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet4 === void 0 ? void 0 : (_item$tradeLicenseDet5 = _item$tradeLicenseDet4.tradeUnits) === null || _item$tradeLicenseDet5 === void 0 ? void 0 : (_item$tradeLicenseDet6 = _item$tradeLicenseDet5[0]) === null || _item$tradeLicenseDet6 === void 0 ? void 0 : (_item$tradeLicenseDet7 = _item$tradeLicenseDet6.tradeType) === null || _item$tradeLicenseDet7 === void 0 ? void 0 : (_item$tradeLicenseDet8 = _item$tradeLicenseDet7.split(".")) === null || _item$tradeLicenseDet8 === void 0 ? void 0 : _item$tradeLicenseDet8[0]), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : item.applicationNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet9 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet9 === void 0 ? void 0 : (_item$tradeLicenseDet10 = _item$tradeLicenseDet9.owners) === null || _item$tradeLicenseDet10 === void 0 ? void 0 : (_item$tradeLicenseDet11 = _item$tradeLicenseDet10[0]) === null || _item$tradeLicenseDet11 === void 0 ? void 0 : _item$tradeLicenseDet11.architectureNo), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet12 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet12 === void 0 ? void 0 : (_item$tradeLicenseDet13 = _item$tradeLicenseDet12.owners) === null || _item$tradeLicenseDet13 === void 0 ? void 0 : (_item$tradeLicenseDet14 = _item$tradeLicenseDet13[0]) === null || _item$tradeLicenseDet14 === void 0 ? void 0 : _item$tradeLicenseDet14.mobileNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet15 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet15 === void 0 ? void 0 : (_item$tradeLicenseDet16 = _item$tradeLicenseDet15.owners) === null || _item$tradeLicenseDet16 === void 0 ? void 0 : (_item$tradeLicenseDet17 = _item$tradeLicenseDet16[0]) === null || _item$tradeLicenseDet17 === void 0 ? void 0 : _item$tradeLicenseDet17.emailId), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, (item === null || item === void 0 ? void 0 : item.authorityName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet18 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet18 === void 0 ? void 0 : (_item$tradeLicenseDet19 = _item$tradeLicenseDet18.owners) === null || _item$tradeLicenseDet19 === void 0 ? void 0 : (_item$tradeLicenseDet20 = _item$tradeLicenseDet19[0]) === null || _item$tradeLicenseDet20 === void 0 ? void 0 : (_item$tradeLicenseDet21 = _item$tradeLicenseDet20.correspondenceAddress) === null || _item$tradeLicenseDet21 === void 0 ? void 0 : _item$tradeLicenseDet21.district), /*#__PURE__*/React__default.createElement(StyledTableCell$g, null, item === null || item === void 0 ? void 0 : (_item$tradeLicenseDet22 = item.tradeLicenseDetail) === null || _item$tradeLicenseDet22 === void 0 ? void 0 : (_item$tradeLicenseDet23 = _item$tradeLicenseDet22.additionalDetail) === null || _item$tradeLicenseDet23 === void 0 ? void 0 : _item$tradeLicenseDet23.validupto));
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$Licenses = apiData.Licenses) === null || _apiData$Licenses === void 0 ? void 0 : _apiData$Licenses.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const FilterForm$1 = ({
  onSubmit
}) => {
  const {
    handleSubmit,
    control,
    reset
  } = useForm();
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Application Number",
    placeholder: "Enter Application No",
    name: "applicationNumber",
    type: "textInput",
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Mobile No",
    control: control,
    placeholder: "Enter Mobile No",
    name: "mobileNumber",
    type: "textInput",
    mandatory: true,
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Form Type",
    control: control,
    placeholder: "Select Form Type",
    data: [{
      value: 'Form LTP',
      label: 'Form LTP'
    }],
    name: "formType",
    type: "selectInput",
    mandatory: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "License Number",
    control: control,
    placeholder: "Enter License No",
    name: "licenseNumbers",
    type: "textInput",
    mandatory: true
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper",
    style: {
      display: 'flex',
      gap: '8px'
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Search",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: reset
  })))));
};

function ApplicationDetail$4({
  setApiData,
  apiData
}) {
  var _userInfo$info, _userInfo$info$roles;
  const userInfo = Digit.UserService.getUser();
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo !== null && userInfo !== void 0 && (_userInfo$info = userInfo.info) !== null && _userInfo$info !== void 0 && (_userInfo$info$roles = _userInfo$info.roles) !== null && _userInfo$info$roles !== void 0 && _userInfo$info$roles.some(role => role.code === "HRMS_ADMIN") ? "Admin" : null;
  const {
    t
  } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const fetchData = async (tenantId, params) => {
    setIsLoading(true);
    setShowToast(null);
    try {
      var _result$Licenses;
      const result = await TLService.misReportRegistration(tenantId, params);
      console.log(result, "resultherere");
      if (!result) {
        throw new Error("No data received from server");
      } else if ((result === null || result === void 0 ? void 0 : (_result$Licenses = result.Licenses) === null || _result$Licenses === void 0 ? void 0 : _result$Licenses.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found"
        });
      }
      setApiData(result);
    } catch (err) {
      var _err$response, _err$response$data;
      console.error("Error fetching data:", err);
      const message = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = async formData => {
    let {
      formType,
      mobileNumber,
      applicationNumber,
      licenseNumbers
    } = formData;
    try {
      await fetchData(tenantId, {
        formType,
        mobileNumber,
        applicationNumber,
        licenseNumbers
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    const fetchDataOnMount = async () => {
      await fetchData(tenantId, {
        userType
      });
    };
    fetchDataOnMount();
  }, [tenantId]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterForm$1, {
    onSubmit: handleFormSubmit
  }), isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), !isLoading && !showToast && apiData && /*#__PURE__*/React__default.createElement(InboxTable$8, {
    apiData: apiData
  }));
}

const useStyles$t = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px'
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px'
    }
  }
}));
function RegistrationReport() {
  const classes = useStyles$t();
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = useState('1');
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    var _apiData$Licenses;
    const charData = apiData === null || apiData === void 0 ? void 0 : (_apiData$Licenses = apiData.Licenses) === null || _apiData$Licenses === void 0 ? void 0 : _apiData$Licenses.map(st => {
      var _st$tradeLicenseDetai, _st$tradeLicenseDetai2, _st$tradeLicenseDetai3, _st$tradeLicenseDetai4, _st$tradeLicenseDetai5, _st$tradeLicenseDetai6, _st$tradeLicenseDetai7, _st$tradeLicenseDetai8, _st$tradeLicenseDetai9, _st$tradeLicenseDetai10, _st$tradeLicenseDetai11, _st$tradeLicenseDetai12, _st$tradeLicenseDetai13, _st$tradeLicenseDetai14, _st$tradeLicenseDetai15, _st$tradeLicenseDetai16, _st$tradeLicenseDetai17, _st$tradeLicenseDetai18, _st$tradeLicenseDetai19, _st$tradeLicenseDetai20, _st$tradeLicenseDetai21, _st$tradeLicenseDetai22, _st$tradeLicenseDetai23, _st$tradeLicenseDetai24, _st$tradeLicenseDetai25, _st$tradeLicenseDetai26, _st$tradeLicenseDetai27, _st$tradeLicenseDetai28;
      return {
        registrationType: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai === void 0 ? void 0 : (_st$tradeLicenseDetai2 = _st$tradeLicenseDetai.tradeUnits) === null || _st$tradeLicenseDetai2 === void 0 ? void 0 : (_st$tradeLicenseDetai3 = _st$tradeLicenseDetai2[0]) === null || _st$tradeLicenseDetai3 === void 0 ? void 0 : (_st$tradeLicenseDetai4 = _st$tradeLicenseDetai3.tradeType) === null || _st$tradeLicenseDetai4 === void 0 ? void 0 : (_st$tradeLicenseDetai5 = _st$tradeLicenseDetai4.split(".")) === null || _st$tradeLicenseDetai5 === void 0 ? void 0 : _st$tradeLicenseDetai5[0],
        applicationnumber: st === null || st === void 0 ? void 0 : st.applicationNumber,
        licenseNumber: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai6 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai6 === void 0 ? void 0 : (_st$tradeLicenseDetai7 = _st$tradeLicenseDetai6.owners) === null || _st$tradeLicenseDetai7 === void 0 ? void 0 : (_st$tradeLicenseDetai8 = _st$tradeLicenseDetai7[0]) === null || _st$tradeLicenseDetai8 === void 0 ? void 0 : _st$tradeLicenseDetai8.architectureNo,
        applicantName: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai9 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai9 === void 0 ? void 0 : (_st$tradeLicenseDetai10 = _st$tradeLicenseDetai9.owners) === null || _st$tradeLicenseDetai10 === void 0 ? void 0 : (_st$tradeLicenseDetai11 = _st$tradeLicenseDetai10[0]) === null || _st$tradeLicenseDetai11 === void 0 ? void 0 : _st$tradeLicenseDetai11.name,
        mobileNumber: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai12 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai12 === void 0 ? void 0 : (_st$tradeLicenseDetai13 = _st$tradeLicenseDetai12.owners) === null || _st$tradeLicenseDetai13 === void 0 ? void 0 : (_st$tradeLicenseDetai14 = _st$tradeLicenseDetai13[0]) === null || _st$tradeLicenseDetai14 === void 0 ? void 0 : _st$tradeLicenseDetai14.mobileNumber,
        emailId: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai15 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai15 === void 0 ? void 0 : (_st$tradeLicenseDetai16 = _st$tradeLicenseDetai15.owners) === null || _st$tradeLicenseDetai16 === void 0 ? void 0 : (_st$tradeLicenseDetai17 = _st$tradeLicenseDetai16[0]) === null || _st$tradeLicenseDetai17 === void 0 ? void 0 : _st$tradeLicenseDetai17.emailId,
        authorityName: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai18 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai18 === void 0 ? void 0 : (_st$tradeLicenseDetai19 = _st$tradeLicenseDetai18.additionalDetail) === null || _st$tradeLicenseDetai19 === void 0 ? void 0 : _st$tradeLicenseDetai19.authorityName,
        appliedOn: convertEpochToDate$1(st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai20 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai20 === void 0 ? void 0 : (_st$tradeLicenseDetai21 = _st$tradeLicenseDetai20.additionalDetail) === null || _st$tradeLicenseDetai21 === void 0 ? void 0 : _st$tradeLicenseDetai21.applicationDate),
        validupto: st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai22 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai22 === void 0 ? void 0 : (_st$tradeLicenseDetai23 = _st$tradeLicenseDetai22.additionalDetail) === null || _st$tradeLicenseDetai23 === void 0 ? void 0 : _st$tradeLicenseDetai23.validupto,
        paymentDate: convertEpochToDate$1(st === null || st === void 0 ? void 0 : st.txnCreatedTime) || "N/A",
        estimateAmount: (st === null || st === void 0 ? void 0 : (_st$tradeLicenseDetai24 = st.tradeLicenseDetail) === null || _st$tradeLicenseDetai24 === void 0 ? void 0 : (_st$tradeLicenseDetai25 = _st$tradeLicenseDetai24.additionalDetail) === null || _st$tradeLicenseDetai25 === void 0 ? void 0 : (_st$tradeLicenseDetai26 = _st$tradeLicenseDetai25.calculation) === null || _st$tradeLicenseDetai26 === void 0 ? void 0 : (_st$tradeLicenseDetai27 = _st$tradeLicenseDetai26.taxHeadEstimates) === null || _st$tradeLicenseDetai27 === void 0 ? void 0 : (_st$tradeLicenseDetai28 = _st$tradeLicenseDetai27[0]) === null || _st$tradeLicenseDetai28 === void 0 ? void 0 : _st$tradeLicenseDetai28.estimateAmount) || 0,
        status: t(st === null || st === void 0 ? void 0 : st.status)
      };
    });
    return Digit.Download.Excel(charData, "registration-report");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: '100%',
      typography: 'body1'
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider',
      marginLeft: '20px'
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Registrations Report",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: '45rem'
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: '3rem'
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: '22px'
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(ApplicationDetail$4, {
    setApiData: setApiData,
    apiData: apiData
  })))));
}

const MasterDataManagement = () => {
  const token = Digit.UserService.getUser().access_token;
  const currentHeader = process.env.REACT_APP_MASTER_DATA_DOMAIN || "";
  console.log("currentHeader", currentHeader);
  const url = `${currentHeader}?token=${token}`;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "master-data-container"
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: url,
    title: "Document Viewer"
  }));
};

const RAW_STATUS_LABELS = {
  DOCUMENT_UPLOADED: "Document Uploaded",
  FORWARD_TO_JE: "Forwared To Junior Engineer",
  FORWARD_TO_AE: "Forwarded To AE",
  FORWARD_TO_ATP: "Forwarded To ATP",
  FORWARD_TO_DEPARTMENT: "Forwarded To Department",
  FORWARD_TO_EE_TP: "Forwarded To EE/TP",
  PENDING_AT_CTP: "Forwarded To CTP",
  PAYMENT_PENDING: "Pay Application Fees",
  FINAL_PAYMENT_PENDING: "Final Payment Pending",
  SEND_BACK_TO_APPLICANT: "Send back to Applicant",
  APPROVED: "Approved",
  FORWARD_TO_ADDITIONAL_SECRETORY_SECRETORY: "Forwarded To Additional Secretory",
  APPLY_FOR_DSC: "Apply For DSC",
  UPLOAD_DOC: "Draft",
  MAKE_PAYMENT: "Make Payment",
  FORWARD_TO_PO: "Forwarded To PO",
  MAKE_PAYMENT_SELF: "Make Payment Self",
  MAKE_PAYMENT_APPLICATION_FEE_FIRST: "Make Payment Application Fee First",
  FORWARD_TO_NODAL: "Forwarded To Nodal",
  GENERATE_APPROVAL_LETTER: "Generate Approval Letter",
  APPROVED_JE: "Apprved By JE",
  FORWARD_TO_APA: "Forwarded To APA",
  MAKE_PAYMENT_SELF_REGENERATE: "Make Pyment Self Regenerate",
  FORWARD_TO_CTP: "Forwarded To CTP",
  SENDBACK_TO_CITIZEN: "Send Back To Citizen",
  FORWARD_TO_Architectural_Assistant: "Forwarded to AA",
  MAKE_PAYMENT_APPLICATION_FEE: "Make Payment Aplication Fees",
  FORWARD_TO_CTP_FINAL_LEVEL: "Forwarded To CTP",
  FORWARD_TO_ND_OFF_AWAS: "Forwarded To Nodal AWAS BANDHU",
  REVERT_TO_APPLICANT: "Shortfall",
  MAKE_PAYMENT_BY_ARCHITECT: "Make Payment By Architect",
  EE_TP_AFTER_PAYMENT: "Sent to EE/TP After Payment",
  CTP_AFTER_PAYMENT: "Sent to CTP After Payment",
  REJECTED: "Rejected"
};
const CATEGORY_LABELS = {
  DRAFT: "Draft",
  REJECTED: "Rejected",
  APPROVAL: "Approval",
  PROVISIONALLY_APPROVED: "Provisionally Approved",
  PENDING_FOR_DSC: "Pending for DSC",
  SHORTFALL: "Shortfall",
  IN_PROGRESS_WITH_OFFICER: "In Progress With Officer"
};
const CATEGORY_ORDER = ["DRAFT", "IN_PROGRESS_WITH_OFFICER", "PENDING_FOR_DSC", "PROVISIONALLY_APPROVED", "APPROVAL", "SHORTFALL", "REJECTED"];
const CATEGORY_STATUS_MAP = {
  DRAFT: ["DOCUMENT_UPLOADED", "MAKE_PAYMENT_SELF", "UPLOAD_DOC", "MAKE_PAYMENT_APPLICATION_FEE", "MAKE_PAYMENT_APPLICATION_FEE_FIRST"],
  REJECTED: ["REJECTED"],
  APPROVAL: ["APPROVED", "APPROVED_JE"],
  PROVISIONALLY_APPROVED: ["PAYMENT_PENDING", "FINAL_PAYMENT_PENDING", "MAKE_PAYMENT", "MAKE_PAYMENT_BY_ARCHITECT"],
  PENDING_FOR_DSC: ["APPLY_FOR_DSC"],
  SHORTFALL: ["SEND_BACK_TO_APPLICANT", "REVERT_TO_APPLICANT"],
  IN_PROGRESS_WITH_OFFICER: ["FORWARD_TO_ADDITIONAL_SECRETORY_SECRETORY", "FORWARD_TO_AE", "FORWARD_TO_ATP", "FORWARD_TO_DEPARTMENT", "FORWARD_TO_EE_TP", "FORWARD_TO_JE", "FORWARD_TO_PO", "FORWARD_TO_NODAL", "FORWARD_TO_APA", "FORWARD_TO_CTP", "FORWARD_TO_CTP_FINAL_LEVEL", "FORWARD_TO_ND_OFF_AWAS", "FORWARD_TO_Architectural_Assistant", "PENDING_AT_CTP", "SENDBACK_TO_CITIZEN", "FORWARED_TO_AA", "FORWARD_TO_VICE_CHAIRMAN", "PENDING_AT_VC", "FORWARD_TO_AAP", "FORWARED_TO_CAP", "FORWARD_TO_AP"]
};
const STATUS_TO_CATEGORY = {};
Object.entries(CATEGORY_STATUS_MAP).forEach(([category, statuses]) => {
  statuses.forEach(status => {
    STATUS_TO_CATEGORY[status.toUpperCase()] = category;
  });
});
const getCategory = rawStatus => {
  if (!rawStatus) return "IN_PROGRESS_WITH_OFFICER";
  const status = rawStatus.toUpperCase();
  if (STATUS_TO_CATEGORY[status]) return STATUS_TO_CATEGORY[status];
  if (/_AFTER_PAYMENT$/.test(status)) return "PENDING_FOR_DSC";
  if (process.env.NODE_ENV !== "production") {
    console.warn(`[useModuleSummary] Unmapped status "${rawStatus}" — defaulting to IN_PROGRESS_WITH_OFFICER`);
  }
  return "IN_PROGRESS_WITH_OFFICER";
};
const STATUS_LABELS = {
  ...RAW_STATUS_LABELS,
  ...CATEGORY_LABELS
};
const useModuleSummary = apiData => {
  const moduleSummary = useMemo(() => {
    const misData = (apiData === null || apiData === void 0 ? void 0 : apiData.MisData) || [];
    const grouped = misData.reduce((acc, item) => {
      const module = item === null || item === void 0 ? void 0 : item.modulename;
      if (!acc[module]) {
        acc[module] = {
          moduleName: module,
          total: 0,
          approved: 0,
          draft: 0
        };
      }
      acc[module].total += 1;
      if ((item === null || item === void 0 ? void 0 : item.latestStatus) === "APPROVED") {
        acc[module].approved += 1;
      } else {
        acc[module].draft += 1;
      }
      return acc;
    }, {});
    return Object.values(grouped);
  }, [apiData === null || apiData === void 0 ? void 0 : apiData.MisData]);
  return moduleSummary;
};
const prepareDashboardData = (data = [], selectedModule = "") => {
  const filteredData = selectedModule ? data.filter(item => item.modulename === selectedModule) : data;
  const moduleNames = [...new Set(data.map(item => item.modulename).filter(Boolean))];
  const statuses = CATEGORY_ORDER;
  const grouped = {};
  filteredData.forEach(item => {
    const authority = item.developmentAuthorityName || "Unknown";
    if (!grouped[authority]) {
      grouped[authority] = {
        developmentAuthorityName: authority,
        grandTotal: 0
      };
      statuses.forEach(category => {
        grouped[authority][category] = 0;
      });
    }
    const category = getCategory(item.latestStatus);
    grouped[authority][category]++;
    grouped[authority].grandTotal++;
  });
  return {
    moduleNames,
    statuses,
    tableData: Object.values(grouped)
  };
};

const useStyles$u = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd"
  },
  blueText: {
    color: "#1F4A7C"
  }
});
const getStickyStyle = (key, isHeader = false, isOddRow = false) => {
  const bodyBackground = isOddRow ? "#f1f0f5" : "#ffffff";
  switch (key) {
    case "developmentAuthorityName":
      return {
        position: "sticky",
        left: 0,
        zIndex: isHeader ? 4 : 2,
        background: isHeader ? "#1f4a7c" : bodyBackground
      };
    case "grandTotal":
      return {
        position: "sticky",
        right: 0,
        zIndex: isHeader ? 4 : 2,
        background: isHeader ? "#1f4a7c" : bodyBackground,
        fontWeight: "bold"
      };
    default:
      return {};
  }
};
const StyledTableCell$h = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 13,
    fontWeight: "bold",
    width: "110px",
    minWidth: "110px",
    maxWidth: "110px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    textAlign: "center",
    padding: "9px !important",
    lineHeight: "18px"
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 13,
    width: "110px",
    minWidth: "110px",
    maxWidth: "110px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: "center",
    padding: "9px !important"
  }
}));
const StyledTableRow$h = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$9 = ({
  apiData,
  location1,
  newApiData,
  showTotalRow: _showTotalRow = false
}) => {
  const moduleSummary = useModuleSummary(apiData);
  const {
    t
  } = useTranslation();
  const classes = useStyles$u();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const tableData = (newApiData === null || newApiData === void 0 ? void 0 : newApiData.tableData) || [];
  const statuses = ((newApiData === null || newApiData === void 0 ? void 0 : newApiData.statuses) || []).filter(status => status && status !== "null");
  const headerData = useMemo(() => {
    return [{
      key: "serialNo",
      label: "Sl. No"
    }, {
      key: "developmentAuthorityName",
      label: "Development Authority"
    }, {
      key: "grandTotal",
      label: "Recieved"
    }, ...statuses.map(status => ({
      key: status,
      label: STATUS_LABELS[status] || status
    }))];
  }, [statuses]);
  const columnTotals = useMemo(() => {
    const totals = {};
    headerData.forEach(col => {
      if (col.key === "serialNo" || col.key === "developmentAuthorityName") return;
      totals[col.key] = tableData.reduce((sum, row) => sum + (Number(row[col.key]) || 0), 0);
    });
    return totals;
  }, [headerData, tableData]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table",
    style: {
      overflowX: "auto",
      maxWidth: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    colSpan: headerData.length,
    align: "center",
    style: {
      backgroundColor: "#1F4A7C",
      color: "#fff",
      fontWeight: "bold",
      fontSize: 18
    }
  }, location1 || "All Department Authorities"))), /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData.map(item => /*#__PURE__*/React__default.createElement(StyledTableCell$h, {
    key: item.key,
    style: getStickyStyle(item.key, true)
  }, item.label)))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, tableData === null || tableData === void 0 ? void 0 : tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$h, {
    key: row.developmentAuthorityName
  }, headerData.map(column => /*#__PURE__*/React__default.createElement(StyledTableCell$h, {
    key: column.key,
    style: {
      ...getStickyStyle(column.key, false, index % 2 === 0),
      fontWeight: column.key === "grandTotal" || column.key === "developmentAuthorityName" ? "bold" : "normal"
    }
  }, column.key === "serialNo" ? page * rowsPerPage + index + 1 : row[column.key] || 0)))), _showTotalRow && tableData.length > 0 && /*#__PURE__*/React__default.createElement(TableRow$3, null, headerData.map(column => {
    const totalCellStyle = {
      ...getStickyStyle(column.key, false),
      background: "#dfe7f1",
      fontWeight: "bold",
      borderTop: "2px solid #1f4a7c"
    };
    let content = columnTotals[column.key] !== undefined && columnTotals[column.key] !== null ? columnTotals[column.key] : 0;
    if (column.key === "serialNo") content = "";
    if (column.key === "developmentAuthorityName") content = "Grand Total";
    return /*#__PURE__*/React__default.createElement(StyledTableCell$h, {
      key: column.key,
      style: totalCellStyle
    }, content);
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: tableData.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const datePickerSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "rgba(255,255,255,0.95)",
    fontSize: "13px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(21, 101, 192, 0.5)",
      borderWidth: "1px"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(21, 101, 192, 0.8)"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1565c0",
      borderWidth: "1.5px"
    }
  },
  "& .MuiInputLabel-root": {
    color: "#1565c0",
    fontWeight: 700,
    fontSize: "12px",
    backgroundColor: "rgba(255,255,255,0.95)",
    px: 0.5,
    borderRadius: "4px",
    transform: "translate(14px, -9px) scale(0.85)",
    "&.MuiInputLabel-shrink": {
      transform: "translate(14px, -9px) scale(0.85)"
    }
  }
};
const formatDate$2 = date => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${date.getFullYear()}-${mm}-${dd}`;
};
function SummaryDetail({
  setApiData,
  apiData,
  newApiData,
  selectedModule,
  setSelectedModule
}) {
  var _userInfo$info, _userInfo$info$roles, _userInfo$info2, _userInfo$info2$roles, _userDetails$location, _userDetails$location2;
  const userInfo = Digit.UserService.getUser();
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo !== null && userInfo !== void 0 && (_userInfo$info = userInfo.info) !== null && _userInfo$info !== void 0 && (_userInfo$info$roles = _userInfo$info.roles) !== null && _userInfo$info$roles !== void 0 && _userInfo$info$roles.some(role => role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN") ? "SuperAdmin" : userInfo !== null && userInfo !== void 0 && (_userInfo$info2 = userInfo.info) !== null && _userInfo$info2 !== void 0 && (_userInfo$info2$roles = _userInfo$info2.roles) !== null && _userInfo$info2$roles !== void 0 && _userInfo$info2$roles.some(role => role.code === "HRMS_ADMIN") ? "Admin" : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location = userDetails.location1) === null || _userDetails$location === void 0 ? void 0 : _userDetails$location.length) > 1 ? userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location2 = userDetails.location1) === null || _userDetails$location2 === void 0 ? void 0 : _userDetails$location2.concat(" Development Authority") : null;
  const {
    control,
    reset,
    watch,
    setValue,
    handleSubmit
  } = useForm();
  const {
    t
  } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const getFinancialYearStart = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    return new Date(year, 3, 1);
  };
  const getDefaultFinancialYearDates = () => {
    const start = getFinancialYearStart();
    const end = new Date();
    end.setHours(0, 0, 0, 0);
    return {
      fromDate: start,
      toDate: end
    };
  };
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [modules, setModules] = useState([]);
  const [fromDate, setFromDate] = useState(() => getDefaultFinancialYearDates().fromDate);
  const [toDate, setToDate] = useState(() => getDefaultFinancialYearDates().toDate);
  const addOneYear = date => {
    const d = new Date(date);
    d.setFullYear(d.getFullYear() + 1);
    return d;
  };
  const fetchData = async (tenantId, params, customFromDate = fromDate, customToDate = toDate) => {
    setIsLoading(true);
    setShowToast(null);
    const todayDate = customToDate ? new Date(customToDate) : (() => {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    })();
    const oneYearAgoDate = customFromDate ? new Date(customFromDate) : (() => {
      const d = new Date(todayDate);
      d.setFullYear(d.getFullYear() - 1);
      return d;
    })();
    try {
      var _result$MisData;
      const result = await OBPSService.applicationReportMISData(tenantId, {
        ...params,
        fromDate: formatDate$2(oneYearAgoDate),
        toDate: formatDate$2(todayDate)
      });
      if (!result) {
        throw new Error("No data received from server");
      } else if ((result === null || result === void 0 ? void 0 : (_result$MisData = result.MisData) === null || _result$MisData === void 0 ? void 0 : _result$MisData.length) === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found"
        });
      }
      setApiData(result);
    } catch (err) {
      var _err$response, _err$response$data;
      console.error("Error fetching data:", err);
      const message = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const resetFilterState = () => {
    const defaultDates = getDefaultFinancialYearDates();
    setFromDate(defaultDates.fromDate);
    setToDate(defaultDates.toDate);
    reset();
    setSelectedModule("");
    setApiData(null);
    setShowToast(null);
  };
  const handleFormSubmit = async formData => {
    const {
      modulename
    } = formData;
    if (!modulename) {
      setShowToast({
        key: "true",
        warning: true,
        message: "Please select a module"
      });
      return;
    }
    setSelectedModule(modulename);
    try {
      await fetchData(tenantId, {
        modulename
      }, fromDate, toDate);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    let cancelled = false;
    const loadModules = async () => {
      try {
        var _prepareDashboardData;
        const {
          fromDate: start,
          toDate: end
        } = getDefaultFinancialYearDates();
        const result = await OBPSService.applicationReportMISData(tenantId, {
          developmentAuthorityName: location1,
          createdFrom: formatDate$2(start),
          createdTo: formatDate$2(end)
        });
        const names = (_prepareDashboardData = prepareDashboardData((result === null || result === void 0 ? void 0 : result.MisData) || [], "")) === null || _prepareDashboardData === void 0 ? void 0 : _prepareDashboardData.moduleNames;
        if (!cancelled) {
          setModules((names || []).map(item => ({
            label: item,
            value: item
          })));
        }
      } catch (err) {
        console.error("Error loading modules:", err);
      }
    };
    loadModules();
    return () => {
      cancelled = true;
    };
  }, [tenantId]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(handleFormSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Module Name",
    control: control,
    placeholder: "Select Module Name",
    data: modules,
    name: "modulename",
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null)), /*#__PURE__*/React__default.createElement(LocalizationProvider$1, {
    dateAdapter: AdapterDateFns
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    style: {
      marginTop: "10px",
      marginLeft: "-8px"
    }
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(DatePicker$1, {
    label: "From Date",
    value: fromDate,
    maxDate: toDate,
    sx: datePickerSx,
    onChange: newDate => {
      if (!newDate) return;
      setFromDate(newDate);
      if (toDate > addOneYear(newDate)) {
        setToDate(addOneYear(newDate));
      }
    },
    slotProps: {
      textField: {
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          shrink: true
        }
      }
    }
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React__default.createElement(DatePicker$1, {
    label: "To Date",
    value: toDate,
    minDate: fromDate,
    maxDate: addOneYear(fromDate),
    sx: datePickerSx,
    onChange: newDate => {
      if (!newDate) return;
      setToDate(newDate);
    },
    slotProps: {
      textField: {
        size: "small",
        fullWidth: true,
        InputLabelProps: {
          shrink: true
        }
      }
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper",
    style: {
      display: "flex",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Search",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => resetFilterState()
  }))))), isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), !isLoading && !showToast && apiData && /*#__PURE__*/React__default.createElement(InboxTable$9, {
    apiData: apiData,
    location1: location1,
    newApiData: newApiData,
    showTotalRow: true
  }));
}

const useStyles$v = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: "#1F4A7C",
    color: "white",
    marginRight: "3px",
    borderRadius: "3px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      color: "black",
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: "#1F4A7C",
      color: "white",
      marginLeft: "200px",
      borderRadius: "2px"
    },
    printerIcon: {
      verticalAlign: "middle",
      marginLeft: "5px"
    }
  }
}));
function SummaryReport() {
  const classes = useStyles$v();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [value, setValue] = useState("1");
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const moduleSummary = useModuleSummary(apiData);
  const [newAPiData, setNewAPiData] = useState(null);
  const [selectedModule, setSelectedModule] = useState("");
  useEffect(() => {
    if (apiData !== null && apiData !== void 0 && apiData.MisData) {
      setNewAPiData(prepareDashboardData(apiData.MisData, selectedModule));
    } else {
      setNewAPiData(null);
    }
  }, [apiData === null || apiData === void 0 ? void 0 : apiData.MisData, selectedModule]);
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    var _newAPiData$tableData;
    if (!(newAPiData !== null && newAPiData !== void 0 && (_newAPiData$tableData = newAPiData.tableData) !== null && _newAPiData$tableData !== void 0 && _newAPiData$tableData.length)) return;
    const {
      tableData,
      statuses
    } = newAPiData;
    const excelData = tableData.map((row, index) => {
      const excelRow = {
        "Sl. No": index + 1,
        "Development Authority": row.developmentAuthorityName
      };
      statuses.forEach(status => {
        excelRow[STATUS_LABELS[status] || status] = row[status] || 0;
      });
      excelRow["Grand Total"] = row.grandTotal;
      return excelRow;
    });
    Digit.Download.Excel(excelData, "Map-Submission-High-Risk-Status");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: "100%",
      typography: "body1"
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: "divider",
      marginLeft: "20px"
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Summary Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: "45rem"
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: "3rem"
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: "22px"
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(SummaryDetail, {
    setApiData: setApiData,
    apiData: apiData,
    newApiData: newAPiData,
    selectedModule: selectedModule,
    setSelectedModule: setSelectedModule
  })))));
}

const useStyles$w = makeStyles$1({
  table: {
    minWidth: 650
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd"
  },
  blueText: {
    color: "#1F4A7C"
  }
});
const headerData$9 = [{
  serialNo: "Sl. No"
}, {
  applicationnumber: "File Number"
}, {
  developmentAuthorityName: "Org Name"
}, {
  modulename: "Module Name"
}, {
  ownerName: "Owner Name"
}, {
  ownermobileno: "Owner Mobile No."
}, {
  commAdd: "Communication Address"
}, {
  siteAddress: "Site Address"
}, {
  schemeName: "Scheme Name"
}, {
  status: "Status"
}, {
  plosUse: "Plot Use"
}, {
  activityProposed: "Activity Proposed"
}, {
  ltpName: "LTP Name"
}, {
  ltpMobilenumber: "LTP Mobile No."
}, {
  plotArea: "Plot Area"
}, {
  totalBuiltupArea: "Total Built-up Area"
}, {
  buildingHeigh: "Building Height"
}, {
  totalFees: "Total Fees"
}, {
  totalFeeRec: "Total Fee Received"
}, {
  totalFeesDue: "Total Fees Due"
}, {
  submissiondate: "Submission Date"
}, {
  approvalDate: "Approval Date"
}, {
  settlementdate: "Settlement Date"
}, {
  siteInspectionFeesAmount: "Site Inspection Fees"
}, {
  stackingChargesAmount: "Stacking Charges"
}, {
  strengtheningChargesAmount: "Strengthening Charges"
}, {
  waterChargesAmount: "Water Charges"
}, {
  buildingPermissionFeesAmount: "Building Permission Fees"
}, {
  buildingPermitFeesAmount: "Building Permit Fees"
}, {
  specialAmenitiesChargesAmount: "Special Amenities Charges"
}, {
  labourCessAmount: "Labour Cess"
}, {
  securityDepositChargesforTreePlantationAmount: "Security Deposit (Tree Plantation)"
}, {
  securityDepositchargesforRainWaterHarvestingAmount: "Security Deposit (Rain Water Harvesting)"
}, {
  securityDepositchargesforSolarEnergyAmount: "Security Deposit (Solar Energy)"
}, {
  amalgamationChargesAmount: "Amalgamation Charges"
}, {
  bandhaChargesAmount: "Bandha Charges"
}, {
  bettermentChargesAmount: "Betterment Charges"
}, {
  cityDevelopmentChargesAmount: "City Development Charges"
}, {
  compoundingChargesAmount: "Compounding Charges"
}, {
  developmentFeeAmount: "Development Fee"
}, {
  developmentPermitFeeAmount: "Development Permit Fee"
}, {
  gstAmount: "GST Amount"
}, {
  impactFeeAmount: "Impact Fee"
}, {
  licenseFeeforIntegratedTownshipAmount: "Integrated Township License Fee"
}, {
  maintenanceChargesAmount: "Maintenance Charges"
}, {
  melaShulkAmount: "Mela Shulk"
}, {
  purchasableFARChargesAmount: "Purchasable FAR Charges"
}, {
  sewerChargesAmount: "Sewer Charges"
}, {
  shelterfeesAmount: "Shelter Fees"
}, {
  subdivisionChargesAmount: "Subdivision Charges"
}, {
  villageDevelopmentChargesAmount: "Village Development Charges"
}, {
  surplusAmountAmount: "Surplus Amount"
}, {
  securityDepositChargesforMechanicalParkingAmount: "Security Deposit (Mechanical Parking)"
}, {
  otherChargesAmount: "Other Charges"
}, {
  mapRateFeesAmount: "Map Rate Fees"
}, {
  bpaLandUseFormFeesAmount: "BPA Land Use Form Fee Amount"
}, {
  planon: "Plan On"
}, {
  challanNo: "Challan No"
}, {
  risk: "Risk"
}, {
  permitNumber: "Permit Number"
}, {
  externalDevelopmentCharges: "External Development Charges"
}, {
  withoutPermUnderPermissibleGroundCoverageAmount: "Without Perm Under Permissible Ground Coverage"
}, {
  inFrontSetbackAmount: "In Front Setback"
}, {
  inRearSetbackAmount: "In Rear Setback"
}, {
  inSideSetbackAmount: "In Side Setback"
}, {
  onAllSidesBuildingAbove15mAmount: "On All Sides Building Above 15m"
}, {
  contraventionConstructionsAmount: "Contravention Constructions"
}, {
  metroCessAmount: "Metro Cess Amount"
}, {
  sewerAndWaterConnectionChargesAmount: "Sewer And Water Connection Charges"
}, {
  internalDevelopmentChargesAmount: "Internal Development Charges"
}, {
  parkingChargesAmount: "Parking Charges"
}, {
  withinPermGroundBeyondFARAmount: "Within Perm Ground Beyond FAR"
}, {
  basementBeyondLimitAmount: "Basement Beyond Limit"
}, {
  roomHeightLessAmount: "Room Height Less"
}, {
  roomWidthLessAmount: "Room Width Less"
}, {
  roomAreaLessAmount: "Room Area Less"
}, {
  lightVentilationLessAmount: "Light Ventilation Less"
}, {
  boundaryWallHeightAmount: "Boundary Wall Height"
}, {
  buildingHeightBeyondAmount: "Building Height Beyond"
}, {
  otherChargesPermittedAmount: "Other Charges Permitted"
}, {
  compoundableResidentialUnitsAmount: "Compoundable Residential Units"
}];
const StyledTableCell$i = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$i = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$a = ({
  apiData
}) => {
  var _apiData$MisAllExtrac;
  const {
    t
  } = useTranslation();
  const classes = useStyles$w();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$9.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, apiData && (apiData === null || apiData === void 0 ? void 0 : apiData.MisAllExtractData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$i, {
    key: row.serialNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.applicationnumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.developmentAuthorityName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, t(`${row === null || row === void 0 ? void 0 : row.modulename}`) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.ownerName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.ownermobileno) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.commAdd) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.siteAddress) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.schemeName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.status) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.plosUse) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.activityProposed) || "-"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.ltpName) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.ltpMobilenumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.plotArea) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.totalBuiltupArea) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.buildingHeigh) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.totalFees) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.totalFeeRec) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.totalFeesDue) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.submissiondate) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.approvalDate) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.settlementDate) || (row === null || row === void 0 ? void 0 : row.settlementdate) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.siteInspectionFeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.stackingChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.strengtheningChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.waterChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.buildingPermissionFeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.buildingPermitFeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.specialAmenitiesChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.labourCessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.securityDepositChargesforTreePlantationAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.securityDepositchargesforRainWaterHarvestingAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.securityDepositchargesforSolarEnergyAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.amalgamationChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.bandhaChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.bettermentChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.cityDevelopmentChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.compoundingChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.developmentFeeAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.developmentPermitFeeAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.gstAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.impactFeeAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.licenseFeeforIntegratedTownshipAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.maintenanceChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.melaShulkAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.purchasableFARChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.sewerChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.shelterfeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.subdivisionChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.villageDevelopmentChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.surplusAmountAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.securityDepositChargesforMechanicalParkingAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.otherChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.mapRateFeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.bpaLandUseFormFeesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.planon) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.challanNo) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.risk) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.permitNumber) || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.externalDevelopmentCharges) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.withoutPermUnderPermissibleGroundCoverageAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.inFrontSetbackAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.inRearSetbackAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.inSideSetbackAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.onAllSidesBuildingAbove15mAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.contraventionConstructionsAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.metroCessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.sewerAndWaterConnectionChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.internalDevelopmentChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.parkingChargesAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.withinPermGroundBeyondFARAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.basementBeyondLimitAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.roomHeightLessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.roomWidthLessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.roomAreaLessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.lightVentilationLessAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.boundaryWallHeightAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.buildingHeightBeyondAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.otherChargesPermittedAmount) || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$i, null, (row === null || row === void 0 ? void 0 : row.compoundableResidentialUnitsAmount) || "0"))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (apiData === null || apiData === void 0 ? void 0 : (_apiData$MisAllExtrac = apiData.MisAllExtractData) === null || _apiData$MisAllExtrac === void 0 ? void 0 : _apiData$MisAllExtrac.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const FilterForm$2 = ({
  onSubmit,
  userDetails,
  userType,
  location1,
  onReset
}) => {
  const defaultFromDate = useMemo(() => dayjs().subtract(1, "month").format("YYYY-MM-DD"), []);
  const defaultToDate = useMemo(() => dayjs().format("YYYY-MM-DD"), []);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues: {
      developmentAuthorityName: location1,
      applicationnumber: "",
      activityProposed: "",
      amount: "",
      minAmount: "",
      maxAmount: "",
      createdFrom: defaultFromDate,
      createdTo: defaultToDate
    }
  });
  const tenantId = Digit.ULBService.getStateId();
  const {
    data: {
      BPA: {
        Organizations: departmentListOptions
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const {
    data: {
      PrimaryUseMasterData: {
        ProposedActivity: nonSchemeTypeData
      } = {}
    } = {}
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);
  const activityProposedOptions = useMemo(() => {
    if (!nonSchemeTypeData) return [];
    const activities = new Set();
    const list = Array.isArray(nonSchemeTypeData) ? nonSchemeTypeData : [nonSchemeTypeData];
    list.forEach(item => {
      const catList = (item === null || item === void 0 ? void 0 : item.CategoryType) || (Array.isArray(item) ? item : []);
      if (Array.isArray(catList)) {
        catList.forEach(cat => {
          const acts = (cat === null || cat === void 0 ? void 0 : cat["Activity Proposed"]) || (cat === null || cat === void 0 ? void 0 : cat.activityProposed) || [];
          if (Array.isArray(acts)) {
            acts.forEach(act => {
              if (act && typeof act === "string" && act.trim()) {
                activities.add(act.trim());
              }
            });
          }
        });
      }
    });
    return Array.from(activities).sort((a, b) => a.localeCompare(b)).map(act => ({
      value: act,
      label: act,
      name: act
    }));
  }, [nonSchemeTypeData]);
  const amountRangeOptions = [{
    value: "0 - 10,000",
    label: "0 - 10,000",
    name: "0 - 10,000"
  }, {
    value: "10,000 - 50,000",
    label: "10,000 - 50,000",
    name: "10,000 - 50,000"
  }, {
    value: "50,000 - 1,00,000",
    label: "50,000 - 1,00,000",
    name: "50,000 - 1,00,000"
  }, {
    value: "1,00,000 - 2,00,000",
    label: "1,00,000 - 2,00,000",
    name: "1,00,000 - 2,00,000"
  }, {
    value: "2,00,000 - 5,00,000",
    label: "2,00,000 - 5,00,000",
    name: "2,00,000 - 5,00,000"
  }, {
    value: "5,00,000 - 10,00,000",
    label: "5,00,000 - 10,00,000",
    name: "5,00,000 - 10,00,000"
  }, {
    value: "Above 10,00,000",
    label: "Above 10,00,000",
    name: "Above 10,00,000"
  }, {
    value: "Custom Range",
    label: "Custom Range",
    name: "Custom Range"
  }];
  const watchAmount = watch("amount");
  console.log(departmentListOptions, location1, "departmentListOptions");
  function filterDepartmentsList(completeList) {
    console.log("completeListFromFunc", completeList);
    const filterCompList = completeList === null || completeList === void 0 ? void 0 : completeList.filter(e => {
      var _e$Name, _e$Name2;
      return !(e !== null && e !== void 0 && (_e$Name = e.Name) !== null && _e$Name !== void 0 && _e$Name.includes("UP Housing and Development Board")) && !(e !== null && e !== void 0 && (_e$Name2 = e.Name) !== null && _e$Name2 !== void 0 && _e$Name2.includes("Uttar Pradesh Online Building Plan Approval System"));
    });
    const officeNames = filterCompList === null || filterCompList === void 0 ? void 0 : filterCompList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    console.log(officeNames, "fromInsideFunc_Filter");
    return officeNames;
  }
  useEffect(() => {
    if (departmentListOptions !== null && departmentListOptions !== void 0 && departmentListOptions.length && location1) {
      setValue("developmentAuthorityName", location1);
    }
  }, [departmentListOptions, location1, setValue]);
  useEffect(() => {
    setValue("createdFrom", defaultFromDate);
    setValue("createdTo", defaultToDate);
  }, [defaultFromDate, defaultToDate, setValue]);
  const handleReset = () => {
    reset({
      developmentAuthorityName: location1 || "",
      applicationnumber: "",
      activityProposed: "",
      amount: "",
      minAmount: "",
      maxAmount: "",
      createdFrom: defaultFromDate,
      createdTo: defaultToDate
    });
    setValue("createdFrom", defaultFromDate);
    setValue("createdTo", defaultToDate);
    if (onReset) {
      onReset();
    }
  };
  const officesList = filterDepartmentsList(departmentListOptions);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(data => onSubmit(data, "NEW_API"))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer",
    style: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      padding: "8px 16px 4px 16px"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleSubmit(data => onSubmit(data, "OLD_API")),
    style: {
      fontSize: "11px",
      padding: "3px 8px",
      borderRadius: "4px",
      border: "1px solid #1F4A7C",
      backgroundColor: "#fff",
      color: "#1F4A7C",
      cursor: "pointer",
      fontWeight: 600,
      lineHeight: "1.4",
      transition: "all 0.2s ease"
    },
    onMouseEnter: e => {
      e.currentTarget.style.backgroundColor = "#1F4A7C";
      e.currentTarget.style.color = "#fff";
    },
    onMouseLeave: e => {
      e.currentTarget.style.backgroundColor = "#fff";
      e.currentTarget.style.color = "#1F4A7C";
    },
    title: "Fetch data using the old API with previous integrated filters"
  }, "Fetch (Old API)")), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Organization Name",
    control: control,
    placeholder: "Select Organization",
    name: "developmentAuthorityName",
    data: SortingAlphabatically(officesList),
    type: userType !== "Admin" ? "textInput" : "selectInput",
    disabled: userType !== "Admin"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "File Number",
    control: control,
    placeholder: "Enter File Number",
    name: "applicationnumber",
    type: "textInput"
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Activity Proposed",
    control: control,
    placeholder: "Select Activity Proposed",
    data: SortingAlphabatically(activityProposedOptions),
    name: "activityProposed",
    type: "selectInput"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Amount",
    control: control,
    placeholder: "Select Amount Range",
    data: amountRangeOptions,
    name: "amount",
    type: "selectInput"
  }))), watchAmount === "Custom Range" && /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Min Amount",
    control: control,
    placeholder: "Enter Min Amount",
    name: "minAmount",
    type: "textInput",
    onlyNumeric: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Max Amount",
    control: control,
    placeholder: "Enter Max Amount",
    name: "maxAmount",
    type: "textInput",
    onlyNumeric: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "From Date",
    control: control,
    placeholder: "Select Date",
    name: "createdFrom",
    type: "datePicker",
    defaultValue: defaultFromDate,
    disableFuture: true
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "To Date",
    control: control,
    placeholder: "Select Date",
    name: "createdTo",
    type: "datePicker",
    defaultValue: defaultToDate,
    disableFuture: true
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper",
    style: {
      display: "flex",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Search",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: handleReset
  })))));
};

const trimDevelopmentAuthority = value => {
  if (!value || typeof value !== "string") return "";
  return value.replace(/develop[,]?e?mnt\s*authorit[a-z]*/gi, "").replace(/development\s*authority/gi, "").replace(/development\s*authoriy/gi, "").replace(/\s+/g, " ").trim();
};
const getAmountRangeBounds = (amount, minAmount, maxAmount) => {
  let from = undefined;
  let to = undefined;
  if (amount === "Custom Range") {
    if (minAmount !== undefined && minAmount !== null && minAmount !== "" && !isNaN(parseFloat(minAmount))) {
      from = parseFloat(minAmount);
    }
    if (maxAmount !== undefined && maxAmount !== null && maxAmount !== "" && !isNaN(parseFloat(maxAmount))) {
      to = parseFloat(maxAmount);
    }
  } else if (amount && typeof amount === "string") {
    if (amount.includes("Above")) {
      const num = parseFloat(amount.replace(/[^0-9]/g, ""));
      if (!isNaN(num)) from = num;
    } else if (amount.includes("-")) {
      var _parts$, _parts$2;
      const parts = amount.split("-");
      const minPart = parseFloat((_parts$ = parts[0]) === null || _parts$ === void 0 ? void 0 : _parts$.replace(/[^0-9]/g, ""));
      const maxPart = parseFloat((_parts$2 = parts[1]) === null || _parts$2 === void 0 ? void 0 : _parts$2.replace(/[^0-9]/g, ""));
      if (!isNaN(minPart)) from = minPart;
      if (!isNaN(maxPart)) to = maxPart;
    }
  }
  return {
    totalAmountFrom: from,
    totalAmountTo: to
  };
};
function ApplicationDetail$5({
  setApiData,
  apiData
}) {
  var _userInfo$info, _userInfo$info$roles, _userDetails$location, _userDetails$location2;
  const userInfo = Digit.UserService.getUser();
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo !== null && userInfo !== void 0 && (_userInfo$info = userInfo.info) !== null && _userInfo$info !== void 0 && (_userInfo$info$roles = _userInfo$info.roles) !== null && _userInfo$info$roles !== void 0 && _userInfo$info$roles.some(role => role.code === "HRMS_ADMIN" || role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN") ? "Admin" : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location = userDetails.location1) === null || _userDetails$location === void 0 ? void 0 : _userDetails$location.length) > 1 ? userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location2 = userDetails.location1) === null || _userDetails$location2 === void 0 ? void 0 : _userDetails$location2.concat(" Development Authority") : null;
  console.log(userDetails, userDetails === null || userDetails === void 0 ? void 0 : userDetails.location1, "userDetialsss");
  const {
    t
  } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [activeApiSource, setActiveApiSource] = useState("NEW_API");
  const fetchData = async (tenantId, params, filterCriteria = {}, apiType = "NEW_API") => {
    setIsLoading(true);
    setShowToast(null);
    setActiveApiSource(apiType);
    try {
      var _result;
      let result;
      if (apiType === "OLD_API") {
        result = await OBPSService.paymentReportMISData(tenantId, params);
      } else {
        result = await OBPSService.paymentReportMISDataNew(tenantId, params);
      }
      console.log(result, "resultherere", "apiType:", apiType);
      if (!result) {
        throw new Error("No data received from server");
      }
      const rawRecords = ((_result = result) === null || _result === void 0 ? void 0 : _result.MisAllExtractData) || [];
      let filteredRecords = [...rawRecords];
      const {
        applicationnumber,
        activityProposed,
        amount,
        minAmount,
        maxAmount
      } = filterCriteria;
      if (applicationnumber && applicationnumber.trim()) {
        const queryAppNo = applicationnumber.trim().toLowerCase();
        filteredRecords = filteredRecords.filter(row => {
          const appNo = String((row === null || row === void 0 ? void 0 : row.applicationnumber) || (row === null || row === void 0 ? void 0 : row.applicationNo) || (row === null || row === void 0 ? void 0 : row.fileNumber) || (row === null || row === void 0 ? void 0 : row.ApplicationNumber) || "").toLowerCase();
          return appNo.includes(queryAppNo);
        });
      }
      if (activityProposed && activityProposed.trim()) {
        const queryActivity = activityProposed.trim().toLowerCase();
        filteredRecords = filteredRecords.filter(row => {
          var _row$businessObject, _row$businessObject2, _row$businessObject2$, _row$businessObject3, _row$businessObject3$, _row$businessObject3$2, _row$businessObject4, _row$businessObject4$, _row$additionalDetail, _row$additionalDetail2, _row$additionalDetail3, _row$descriptionOfLan;
          const rowActivity = String((row === null || row === void 0 ? void 0 : row.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$businessObject = row.businessObject) === null || _row$businessObject === void 0 ? void 0 : _row$businessObject.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$businessObject2 = row.businessObject) === null || _row$businessObject2 === void 0 ? void 0 : (_row$businessObject2$ = _row$businessObject2.additionalDetails) === null || _row$businessObject2$ === void 0 ? void 0 : _row$businessObject2$.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$businessObject3 = row.businessObject) === null || _row$businessObject3 === void 0 ? void 0 : (_row$businessObject3$ = _row$businessObject3.additionalDetails) === null || _row$businessObject3$ === void 0 ? void 0 : (_row$businessObject3$2 = _row$businessObject3$.descriptionOfLand) === null || _row$businessObject3$2 === void 0 ? void 0 : _row$businessObject3$2.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$businessObject4 = row.businessObject) === null || _row$businessObject4 === void 0 ? void 0 : (_row$businessObject4$ = _row$businessObject4.descriptionOfLand) === null || _row$businessObject4$ === void 0 ? void 0 : _row$businessObject4$.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$additionalDetail = row.additionalDetails) === null || _row$additionalDetail === void 0 ? void 0 : _row$additionalDetail.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$additionalDetail2 = row.additionalDetails) === null || _row$additionalDetail2 === void 0 ? void 0 : (_row$additionalDetail3 = _row$additionalDetail2.descriptionOfLand) === null || _row$additionalDetail3 === void 0 ? void 0 : _row$additionalDetail3.activityProposed) || (row === null || row === void 0 ? void 0 : (_row$descriptionOfLan = row.descriptionOfLand) === null || _row$descriptionOfLan === void 0 ? void 0 : _row$descriptionOfLan.activityProposed) || (row === null || row === void 0 ? void 0 : row.plosUse) || "").toLowerCase().trim();
          return rowActivity === queryActivity || rowActivity.includes(queryActivity);
        });
      }
      if (amount && amount.trim()) {
        const {
          totalAmountFrom,
          totalAmountTo
        } = getAmountRangeBounds(amount, minAmount, maxAmount);
        const min = totalAmountFrom !== undefined ? totalAmountFrom : 0;
        const max = totalAmountTo !== undefined ? totalAmountTo : Infinity;
        filteredRecords = filteredRecords.filter(row => {
          const rawFees = row === null || row === void 0 ? void 0 : row.totalFees;
          if (rawFees === undefined || rawFees === null || rawFees === "") {
            return min === 0;
          }
          const numFees = Number(String(rawFees).replace(/[^0-9.-]+/g, ""));
          if (isNaN(numFees)) return false;
          return numFees >= min && numFees <= max;
        });
      }
      if (filteredRecords.length === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found"
        });
      }
      setApiData({
        ...result,
        MisAllExtractData: filteredRecords
      });
    } catch (err) {
      var _err$response, _err$response$data;
      console.error("Error fetching data:", err);
      const message = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = async (formData, apiType = "NEW_API") => {
    let {
      developmentAuthorityName,
      createdFrom,
      createdTo,
      applicationnumber,
      activityProposed,
      amount,
      minAmount,
      maxAmount
    } = formData;
    if (!developmentAuthorityName && location1) {
      developmentAuthorityName = location1;
    }
    const defaultFromDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
    const defaultToDate = dayjs().format("YYYY-MM-DD");
    createdFrom = createdFrom || defaultFromDate;
    createdTo = createdTo || defaultToDate;
    const apiParams = {};
    if (apiType === "OLD_API") {
      if (developmentAuthorityName && typeof developmentAuthorityName === "string" && developmentAuthorityName.trim()) {
        apiParams.developmentAuthorityName = developmentAuthorityName.trim();
      }
      if (createdFrom && typeof createdFrom === "string" && createdFrom.trim()) {
        apiParams.createdFrom = createdFrom.trim();
      }
      if (createdTo && typeof createdTo === "string" && createdTo.trim()) {
        apiParams.createdTo = createdTo.trim();
      }
      if (applicationnumber && typeof applicationnumber === "string" && applicationnumber.trim()) {
        apiParams.applicationnumber = applicationnumber.trim();
        apiParams.applicationNo = applicationnumber.trim();
      }
      if (activityProposed && typeof activityProposed === "string" && activityProposed.trim()) {
        apiParams.activityProposed = activityProposed.trim();
      }
      if (amount && typeof amount === "string" && amount.trim() && amount.trim() !== "Custom Range") {
        apiParams.amount = amount.trim();
      }
      if (minAmount !== undefined && minAmount !== null && minAmount !== "" && !isNaN(parseFloat(minAmount))) {
        apiParams.minAmount = parseFloat(minAmount);
      }
      if (maxAmount !== undefined && maxAmount !== null && maxAmount !== "" && !isNaN(parseFloat(maxAmount))) {
        apiParams.maxAmount = parseFloat(maxAmount);
      }
    } else {
      if (developmentAuthorityName && typeof developmentAuthorityName === "string" && developmentAuthorityName.trim()) {
        const trimmedLoc = trimDevelopmentAuthority(developmentAuthorityName);
        if (trimmedLoc) {
          apiParams.location = trimmedLoc;
        }
      }
      if (createdFrom && typeof createdFrom === "string" && createdFrom.trim()) {
        apiParams.createdFrom = createdFrom.trim();
      }
      if (createdTo && typeof createdTo === "string" && createdTo.trim()) {
        apiParams.createdTo = createdTo.trim();
      }
      if (applicationnumber && typeof applicationnumber === "string" && applicationnumber.trim()) {
        apiParams.ApplicationNumber = applicationnumber.trim();
        apiParams.applicationnumber = applicationnumber.trim();
        apiParams.applicationNo = applicationnumber.trim();
      }
      if (activityProposed && typeof activityProposed === "string" && activityProposed.trim()) {
        apiParams.activityProposed = activityProposed.trim();
      }
      if (amount && amount.trim()) {
        const {
          totalAmountFrom,
          totalAmountTo
        } = getAmountRangeBounds(amount, minAmount, maxAmount);
        if (totalAmountFrom !== undefined && !isNaN(totalAmountFrom)) {
          apiParams.totalAmountFrom = totalAmountFrom;
        }
        if (totalAmountTo !== undefined && !isNaN(totalAmountTo)) {
          apiParams.totalAmountTo = totalAmountTo;
        }
      }
      apiParams._ = Date.now();
    }
    const filterCriteria = {
      applicationnumber,
      activityProposed,
      amount,
      minAmount,
      maxAmount
    };
    try {
      await fetchData(tenantId, apiParams, filterCriteria, apiType);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleReset = () => {
    setApiData(null);
    setShowToast(null);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterForm$2, {
    onSubmit: handleFormSubmit,
    userDetails: userDetails,
    userType: userType,
    location1: location1,
    onReset: handleReset
  }), isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), !isLoading && !showToast && apiData && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "6px",
      fontSize: "12px",
      color: "#666"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "Data Source: ", /*#__PURE__*/React__default.createElement("b", {
    style: {
      color: activeApiSource === "OLD_API" ? "#d32f2f" : "#1f4a7c"
    }
  }, activeApiSource === "OLD_API" ? "Old API (/bpa-services/v1/bpa/_extractAllMisData)" : "New API"))), /*#__PURE__*/React__default.createElement(InboxTable$a, {
    apiData: apiData
  })));
}

const useStyles$x = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: "#1F4A7C",
    color: "white",
    marginRight: "3px",
    borderRadius: "3px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      color: "black",
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: "#1F4A7C",
      color: "white",
      marginLeft: "200px",
      borderRadius: "2px"
    },
    printerIcon: {
      verticalAlign: "middle",
      marginLeft: "5px"
    }
  }
}));
function PaymentDetails$2() {
  const classes = useStyles$x();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [value, setValue] = useState("1");
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    var _apiData$MisAllExtrac;
    if (!(apiData !== null && apiData !== void 0 && apiData.MisAllExtractData) || apiData.MisAllExtractData.length === 0) return;
    const charData = apiData === null || apiData === void 0 ? void 0 : (_apiData$MisAllExtrac = apiData.MisAllExtractData) === null || _apiData$MisAllExtrac === void 0 ? void 0 : _apiData$MisAllExtrac.map((st, index) => ({
      serialNo: index + 1,
      applicationnumber: (st === null || st === void 0 ? void 0 : st.applicationnumber) || "N/A",
      developmentAuthorityName: (st === null || st === void 0 ? void 0 : st.developmentAuthorityName) || "N/A",
      modulename: (st === null || st === void 0 ? void 0 : st.modulename) || "N/A",
      ownerName: (st === null || st === void 0 ? void 0 : st.ownerName) || "N/A",
      ownermobileno: (st === null || st === void 0 ? void 0 : st.ownermobileno) || "N/A",
      commAdd: (st === null || st === void 0 ? void 0 : st.commAdd) || "N/A",
      siteAddress: (st === null || st === void 0 ? void 0 : st.siteAddress) || "N/A",
      schemeName: (st === null || st === void 0 ? void 0 : st.schemeName) || "N/A",
      status: (st === null || st === void 0 ? void 0 : st.status) || "N/A",
      plosUse: (st === null || st === void 0 ? void 0 : st.plosUse) || "N/A",
      activityProposed: (st === null || st === void 0 ? void 0 : st.activityProposed) || (st === null || st === void 0 ? void 0 : st.plosUse) || "N/A",
      ltpName: (st === null || st === void 0 ? void 0 : st.ltpName) || "N/A",
      ltpMobilenumber: (st === null || st === void 0 ? void 0 : st.ltpMobilenumber) || "N/A",
      plotArea: (st === null || st === void 0 ? void 0 : st.plotArea) || 0,
      totalBuiltupArea: (st === null || st === void 0 ? void 0 : st.totalBuiltupArea) || 0,
      buildingHeigh: (st === null || st === void 0 ? void 0 : st.buildingHeigh) || 0,
      totalFees: (st === null || st === void 0 ? void 0 : st.totalFees) || 0,
      totalFeeRec: (st === null || st === void 0 ? void 0 : st.totalFeeRec) || 0,
      totalFeesDue: (st === null || st === void 0 ? void 0 : st.totalFeesDue) || 0,
      submissiondate: (st === null || st === void 0 ? void 0 : st.submissiondate) || "N/A",
      approvalDate: (st === null || st === void 0 ? void 0 : st.approvalDate) || "N/A",
      settlementdate: (st === null || st === void 0 ? void 0 : st.settlementDate) || (st === null || st === void 0 ? void 0 : st.settlementdate) || "N/A",
      "Site Inspection": (st === null || st === void 0 ? void 0 : st.siteInspectionFeesAmount) || 0,
      "Stacking Charges": (st === null || st === void 0 ? void 0 : st.stackingChargesAmount) || 0,
      "Strengthening Charges": (st === null || st === void 0 ? void 0 : st.strengtheningChargesAmount) || 0,
      "Water Charges": (st === null || st === void 0 ? void 0 : st.waterChargesAmount) || 0,
      "Building Permission Fees": (st === null || st === void 0 ? void 0 : st.buildingPermissionFeesAmount) || 0,
      "Building Permit Fees": (st === null || st === void 0 ? void 0 : st.buildingPermitFeesAmount) || 0,
      "Special Amenities Charges": (st === null || st === void 0 ? void 0 : st.specialAmenitiesChargesAmount) || 0,
      "Labour Cess": (st === null || st === void 0 ? void 0 : st.labourCessAmount) || 0,
      "Security Deposit Charges for Tree Planatation": (st === null || st === void 0 ? void 0 : st.securityDepositChargesforTreePlantationAmount) || 0,
      "Security Deposit Charges for Rain Water Harvesting": (st === null || st === void 0 ? void 0 : st.securityDepositchargesforRainWaterHarvestingAmount) || 0,
      "Security Deposit Charges for Solar Energy": (st === null || st === void 0 ? void 0 : st.securityDepositchargesforSolarEnergyAmount) || 0,
      "Amalgamation Charges": (st === null || st === void 0 ? void 0 : st.amalgamationChargesAmount) || 0,
      "Bandha Charges": (st === null || st === void 0 ? void 0 : st.bandhaChargesAmount) || 0,
      "Betterment Charges": (st === null || st === void 0 ? void 0 : st.bettermentChargesAmount) || 0,
      "City Development Charges": (st === null || st === void 0 ? void 0 : st.cityDevelopmentChargesAmount) || 0,
      "Compounding Charges": (st === null || st === void 0 ? void 0 : st.compoundingChargesAmount) || 0,
      "Development Fee": (st === null || st === void 0 ? void 0 : st.developmentFeeAmount) || 0,
      "Development Permit Fee": (st === null || st === void 0 ? void 0 : st.developmentPermitFeeAmount) || 0,
      "GST": (st === null || st === void 0 ? void 0 : st.gstAmount) || 0,
      "Impact Fee": (st === null || st === void 0 ? void 0 : st.impactFeeAmount) || 0,
      "License Fee for Integrated Township": (st === null || st === void 0 ? void 0 : st.licenseFeeforIntegratedTownshipAmount) || 0,
      "Maintenance Charges": (st === null || st === void 0 ? void 0 : st.maintenanceChargesAmount) || 0,
      "Mela Shulk": (st === null || st === void 0 ? void 0 : st.melaShulkAmount) || 0,
      "Purchasable FAR Charges": (st === null || st === void 0 ? void 0 : st.purchasableFARChargesAmount) || 0,
      "Sewer Charges": (st === null || st === void 0 ? void 0 : st.sewerChargesAmount) || 0,
      "Shelter Fee": (st === null || st === void 0 ? void 0 : st.shelterfeesAmount) || 0,
      "Sub-division Charges": (st === null || st === void 0 ? void 0 : st.subdivisionChargesAmount) || 0,
      "Village Development Charges": (st === null || st === void 0 ? void 0 : st.villageDevelopmentChargesAmount) || 0,
      "Surplus Amount": (st === null || st === void 0 ? void 0 : st.surplusAmountAmount) || 0,
      "Security Deposit Charges for Mechanical Parking": (st === null || st === void 0 ? void 0 : st.securityDepositChargesforMechanicalParkingAmount) || 0,
      "Other Charges": (st === null || st === void 0 ? void 0 : st.otherChargesAmount) || 0,
      "Map Rate fees": (st === null || st === void 0 ? void 0 : st.mapRateFeesAmount) || 0,
      "BPA Land Use Form Charges": (st === null || st === void 0 ? void 0 : st.bpaLandUseFormFeesAmount) || 0,
      planon: (st === null || st === void 0 ? void 0 : st.planon) || "N/A",
      challanNo: (st === null || st === void 0 ? void 0 : st.challanNo) || "N/A",
      risk: (st === null || st === void 0 ? void 0 : st.risk) || "N/A",
      permitNumber: (st === null || st === void 0 ? void 0 : st.permitNumber) || "N/A",
      "External Development Fee": (st === null || st === void 0 ? void 0 : st.externalDevelopmentCharges) || 0,
      "Without Permission under Permissible Ground Coverage": (st === null || st === void 0 ? void 0 : st.withoutPermUnderPermissibleGroundCoverageAmount) || 0,
      "In Front Setbacks": (st === null || st === void 0 ? void 0 : st.inFrontSetbackAmount) || 0,
      "In Rear Setbacks": (st === null || st === void 0 ? void 0 : st.inRearSetbackAmount) || 0,
      "In Sides Setbacks": (st === null || st === void 0 ? void 0 : st.inSideSetbackAmount) || 0,
      "All sides beyond 15m": (st === null || st === void 0 ? void 0 : st.onAllSidesBuildingAbove15mAmount) || 0,
      "Contravention Constructions": (st === null || st === void 0 ? void 0 : st.contraventionConstructionsAmount) || 0,
      "Metro Cess": (st === null || st === void 0 ? void 0 : st.metroCessAmount) || 0,
      "Sewer Water connection Charges": (st === null || st === void 0 ? void 0 : st.sewerAndWaterConnectionChargesAmount) || 0,
      "Internal Development Charges": (st === null || st === void 0 ? void 0 : st.internalDevelopmentChargesAmount) || 0,
      "Parking Charges": (st === null || st === void 0 ? void 0 : st.parkingChargesAmount) || 0,
      "Within Permissible Ground Beyond FAR": (st === null || st === void 0 ? void 0 : st.withinPermGroundBeyondFARAmount) || 0,
      "Basement beyond limit": (st === null || st === void 0 ? void 0 : st.basementBeyondLimitAmount) || 0,
      "Room height Less": (st === null || st === void 0 ? void 0 : st.roomHeightLessAmount) || 0,
      "Room width Less": (st === null || st === void 0 ? void 0 : st.roomWidthLessAmount) || 0,
      "Room Area Less": (st === null || st === void 0 ? void 0 : st.roomAreaLessAmount) || 0,
      "Light Ventilation Less": (st === null || st === void 0 ? void 0 : st.lightVentilationLessAmount) || 0,
      "Boundary Wall Height": (st === null || st === void 0 ? void 0 : st.boundaryWallHeightAmount) || 0,
      "Building Height Beyond": (st === null || st === void 0 ? void 0 : st.buildingHeightBeyondAmount) || 0,
      "Compounding Permitted Use": (st === null || st === void 0 ? void 0 : st.otherChargesPermittedAmount) || 0,
      "Residential Units": (st === null || st === void 0 ? void 0 : st.compoundableResidentialUnitsAmount) || 0
    }));
    return Digit.Download.Excel(charData, "payment-report");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: "100%",
      typography: "body1"
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: "divider",
      marginLeft: "20px"
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Payment Report",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: "45rem"
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: "3rem"
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: "22px"
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(ApplicationDetail$5, {
    setApiData: setApiData,
    apiData: apiData
  })))));
}

function EmployeeList({
  t,
  superUser,
  control,
  updatedAuthority,
  setValue,
  handleSubmit,
  onSubmit,
  watch,
  departmentList,
  getOfficesListForIndex,
  getOtherRoleName,
  trigger
}) {
  const [loading, setLoading] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const user = Digit.UserService.getUser();
  const authToken = (user === null || user === void 0 ? void 0 : user.access_token) || null;
  const columns = [{
    id: "empId",
    label: "S.NO.",
    width: "17%"
  }, {
    id: "name",
    label: "Name",
    width: "16%"
  }, {
    id: "role",
    label: "Designation",
    width: "13%"
  }, {
    id: "remark",
    label: "Mobile No",
    width: "13%"
  }, {
    id: "upload",
    label: "Employee Id",
    width: "13%"
  }];
  useEffect(() => {
    if (updatedAuthority) {
      setValue("selectedAuthorityDeactivate", updatedAuthority);
    }
  }, [updatedAuthority, setValue]);
  const getFilteredOffices = () => {
    const offices = getOfficesListForIndex();
    console.log("officesList", offices, updatedAuthority);
    return offices.map(item => {
      console.log("itemValue", item.value !== updatedAuthority, item.value);
      return {
        ...item,
        disabled: item.value == updatedAuthority
      };
    });
  };
  async function handleEmpSearch(authority) {
    if (!authority) {
      return;
    }
    setLoading(true);
    const location = authority !== null && authority !== void 0 && authority.includes("Development Authority") ? authority.split("Development Authority")[0].trim() : authority;
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user === null || user === void 0 ? void 0 : user.info
      }
    };
    try {
      var _response$data;
      const response = await axios$1.post(`${Urls$1.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.user);
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }
  const getDesignation = emp => {
    if (emp !== null && emp !== void 0 && emp.designationName) {
      return emp.designationName;
    }
    const roles = emp === null || emp === void 0 ? void 0 : emp.roles;
    if (roles && (roles === null || roles === void 0 ? void 0 : roles.length) > 0) {
      const filteredRoles = roles.filter(item => (item === null || item === void 0 ? void 0 : item.code) !== "EMPLOYEE" && (item === null || item === void 0 ? void 0 : item.code) !== "CITIZEN");
      if (filteredRoles.length > 0) {
        return filteredRoles.map(role => (role === null || role === void 0 ? void 0 : role.name) || (role === null || role === void 0 ? void 0 : role.code)).join(", ");
      }
    }
    return "N/A";
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    className: "formContainer",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(CustomAccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("Search Employee")))), /*#__PURE__*/React__default.createElement(AccordionDetails, {
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React__default.createElement(Row$1, {
    className: "mb-3"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Authority",
    name: `selectedAuthorityDeactivate`,
    type: "selectInput",
    data: getFilteredOffices(),
    disabled: !superUser
  })), /*#__PURE__*/React__default.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper emp-transfer-buttonwrapper",
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "info",
    size: "medium",
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Search", " ", /*#__PURE__*/React__default.createElement(SearchIcon, {
      sx: {
        color: "#fff",
        height: "18px",
        width: "18px",
        marginTop: "0px"
      }
    })),
    type: "button",
    disabled: !watch("selectedAuthorityDeactivate"),
    onClick: () => handleEmpSearch(watch("selectedAuthorityDeactivate")),
    sx: {
      backgroundColor: "#1565C0",
      marginRight: "4px",
      marginTop: "px",
      display: "flex",
      justifyConent: "center",
      alignItems: "center"
    }
  }))))), /*#__PURE__*/React__default.createElement(Table$2, null, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: column.id,
    style: {
      width: column.width,
      fontWeight: "bold",
      background: "#1f4a7c",
      color: "#fff",
      fontSize: "13px"
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, employeeList.length > 0 ? employeeList.map((emp, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
    key: index
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, index + 1), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, emp.name || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, getDesignation(emp)), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, emp.mobileNumber || "-"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      fontSize: "13px"
    }
  }, emp.userName || "-"))) : /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(TableCell$1, {
    colSpan: 5,
    align: "center"
  }, "No Data Found"))))))));
}

const SearchDetails = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const user = Digit.UserService.getUser();
  const authToken = (user === null || user === void 0 ? void 0 : user.access_token) || null;
  const [filteredRolesInfor, setFilteredRolesInfor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [fromSearchCompleted, setFromSearchCompleted] = useState({});
  const [toSearchCompleted, setToSearchCompleted] = useState({});
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      selectedAuthorityDeactivate: ""
    }
  });
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");
  const watchFromEmp = watch("employeeIdFrom");
  const watchToEmp = watch("employeeIdTo");
  function getOtherRoleName(roles) {
    const otherRole = roles.find(role => role.name.toLowerCase() !== "employee");
    console.log("fromGetOtherRoleName", otherRole);
    return otherRole ? otherRole.name : null;
  }
  const getApplicationFlowForIndex = () => watchDepartment || "";
  const departmentList = [{
    value: "DA",
    label: "Development Authority"
  }, {
    value: "AVP",
    label: "Awas Evam Vikas Parishad"
  }];
  const {
    data: EmployeeTypes = {},
    isLoadings
  } = Digit.Hooks.hrms.useHrmsMDMS(tenantId, "egov-hrms", "HRMSRolesandDesignation") || {};
  const {
    data: {
      BPA: {
        Organizations
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  const daList = Organizations === null || Organizations === void 0 ? void 0 : Organizations.filter(item => item.Type === "DA");
  const avpList = Organizations === null || Organizations === void 0 ? void 0 : Organizations.filter(item => item.Type === "AVP");
  const filterDepartmentsList = completeList => {
    return completeList === null || completeList === void 0 ? void 0 : completeList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
  };
  const getOfficesListForIndex = () => {
    const daOffices = filterDepartmentsList(daList || []);
    const avpOffices = filterDepartmentsList(avpList || []);
    return [...daOffices, ...avpOffices];
  };
  const userDetail = Digit.SessionStorage.get("USER_DETAIL") || {};
  const SUPERUSER = Digit.Utils.superUserAccess();
  const authority = userDetail === null || userDetail === void 0 ? void 0 : userDetail.location1;
  const updatedAuthority = authority ? `${authority} Development Authority` : "";
  console.log("userDetail", updatedAuthority);
  const onSubmit = async data => {
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user === null || user === void 0 ? void 0 : user.info
      },
      JobDelegation: data.transferDetails.map(transfer => ({
        departmentId: transfer.departmentId,
        currentLocation: transfer.location1,
        tenantId: transfer.districtCode,
        empId: transfer.empId,
        oldDesignationRole: transfer.oldDesignationRole,
        roles: transfer.roles.map(role => ({
          code: role.code,
          name: role.name,
          description: role.description
        })),
        location1: transfer.district,
        location2: transfer.area,
        ward: transfer.location3,
        startDate: transfer.startDate,
        endDate: transfer.endDate
      }))
    };
    try {
      const response = await axios$1.post(`${Urls$1.hrms.UserJobdelegationSearch}`, payload);
      setOpenApplicantPopup(true);
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form.");
    }
  };
  async function handleFileTransfer() {
    var _watchFromEmp$value, _watchToEmp$value;
    console.log("bothEmployees", watchFromEmp, watchToEmp);
    const filters = {
      oldEmpId: (watchFromEmp === null || watchFromEmp === void 0 ? void 0 : (_watchFromEmp$value = watchFromEmp.value) === null || _watchFromEmp$value === void 0 ? void 0 : _watchFromEmp$value.split("-")[0].trim()) || "",
      newEmpId: (watchToEmp === null || watchToEmp === void 0 ? void 0 : (_watchToEmp$value = watchToEmp.value) === null || _watchToEmp$value === void 0 ? void 0 : _watchToEmp$value.split("-")[0].trim()) || ""
    };
    console.log("filtersFromtransfer", filters);
    if (filters.oldEmpId === "" || filters.newEmpId === "") {
      alert("Please select both Old Employee Id and New Employee Id");
      return;
    }
    if (filters.oldEmpId === filters.newEmpId) {
      alert("Old Employee Id and New Employee Id cannot be the same");
      return;
    }
    Digit.UserService.employeeFileTransfer(filters).then(res => {
      if (!res || res.status === 200 || res.status === 204 || res.success) {
        alert("Employee File Transfer Successful");
      } else {
        console.log("Unexpected Response:", res);
        alert("Employee File Transfer Failed");
      }
    }).catch(err => {
      console.error("errorFromFileTransfer", err);
      alert("Employee File Transfer Failed");
    });
  }
  if (loading && isLoadings) {
    return /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, null));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(EmployeeList, {
    t: t,
    control: control,
    handleSubmit: handleSubmit,
    onSubmit: onSubmit,
    watch: watch,
    departmentList: departmentList,
    getOfficesListForIndex: getOfficesListForIndex,
    getApplicationFlowForIndex: getApplicationFlowForIndex,
    handleFileTransfer: handleFileTransfer,
    getOtherRoleName: getOtherRoleName,
    trigger: trigger,
    setValue: setValue,
    superUser: SUPERUSER,
    updatedAuthority: updatedAuthority
  }));
};

const SearchEmployeeData = () => {
  const [apiData, setApiData] = useState(null);
  console.log(apiData, "ApiData");
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SearchDetails, {
    apiData: apiData,
    setApiData: setApiData
  }));
};

const useStyles$y = makeStyles$1({
  table: {
    minWidth: 800
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  }
});
const headerData$a = [{
  slno: "Sr. No"
}, {
  applicationNumber: "Application Number"
}, {
  amount: "Amount"
}, {
  payDate: "Pay Date"
}];
const StyledTableCell$j = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$j = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  ":hover": {
    backgroundColor: "#1f4a7c1c"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const PerRevenueDetail = ({
  rows: _rows = []
}) => {
  const classes = useStyles$y();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$a.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.keys(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, _rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$j, {
    key: row.applicationnumber
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$j, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$j, null, row.applicationnumber || "N/A"), /*#__PURE__*/React__default.createElement(StyledTableCell$j, null, row.amount || "0"), /*#__PURE__*/React__default.createElement(StyledTableCell$j, null, row.payDate || "N/A")))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: _rows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const useStyles$z = makeStyles$1({
  table: {
    minWidth: 850
  },
  tableRow: {
    backgroundColor: "#1F4A7C",
    color: "#fff"
  },
  tableCell: {
    backgroundColor: "#f2f2f2",
    padding: "10px",
    fontWeight: "bold",
    border: "1px solid #ddd"
  },
  blueText: {
    color: "#1F4A7C"
  }
});
const headerData$b = [{
  slno: "Sr. No"
}, {
  feeType: "Budget Head"
}, {
  totalAmount: "Total Amount"
}];
const StyledTableCell$k = styled$1(TableCell$2)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$k = styled$1(TableRow$3)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  ":hover": {
    backgroundColor: "#1f4a7c4d"
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const InboxTable$b = ({
  apiData,
  tenantId,
  location
}) => {
  const {
    t
  } = useTranslation();
  const classes = useStyles$z();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = React__default.useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedFeeType, setSelectedFeeType] = useState("");
  const records = useMemo(() => getRecords(apiData), [apiData]);
  const rows = useMemo(() => buildBudgetHeadSummary(records), [records]);
  const detailRows = useMemo(() => selectedFeeType ? getRecordsForHead(records, selectedFeeType) : [], [records, selectedFeeType]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement(Paper$3, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer$3, null, /*#__PURE__*/React__default.createElement(Table$5, {
    className: classes.table,
    "aria-label": "simple table"
  }, /*#__PURE__*/React__default.createElement(TableHead$3, null, /*#__PURE__*/React__default.createElement(TableRow$3, {
    className: classes.tableRow
  }, headerData$b.map(item => /*#__PURE__*/React__default.createElement(TableCell$2, {
    key: Object.values(item)[0]
  }, Object.values(item)[0])))), /*#__PURE__*/React__default.createElement(TableBody$3, {
    style: {
      backgroundColor: "#fbfaff"
    }
  }, rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$k, {
    key: row.feeType,
    style: {
      cursor: "pointer"
    },
    onClick: () => {
      setSelectedFeeType(row.feeType);
      setShowModal(true);
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$k, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$k, null, row.label), /*#__PURE__*/React__default.createElement(StyledTableCell$k, null, row.totalAmount)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: (rows === null || rows === void 0 ? void 0 : rows.length) || 0,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }), showModal && /*#__PURE__*/React__default.createElement(DialogContentModal, {
    title: "Revenue Details",
    dataOpen: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React__default.createElement(PerRevenueDetail, {
    rows: detailRows,
    feeType: selectedFeeType,
    tenantId: tenantId,
    location: location
  })));
};

const FilterForm$3 = ({
  onSubmit,
  userDetails,
  userType,
  location1,
  onReset
}) => {
  const [disableSearch, setDisableSearch] = useState(true);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    defaultValues: {
      developmentAuthorityName: location1
    }
  });
  const allValues = watch();
  const {
    createdFrom,
    createdTo,
    developmentAuthorityName
  } = allValues;
  const hasFromDate = !!createdFrom;
  const hasToDate = !!createdTo;
  const hasOrganization = !!developmentAuthorityName;
  useEffect(() => {
    const disableButton = !hasOrganization || hasFromDate && !hasToDate || !hasFromDate && hasToDate;
    setDisableSearch(disableButton);
  }, [allValues]);
  const tenantId = Digit.ULBService.getStateId();
  const {
    data: {
      BPA: {
        Organizations: departmentListOptions
      } = {}
    } = {},
    isLoading: isDataLoading
  } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);
  function filterDepartmentsList(completeList) {
    const filterCompList = completeList === null || completeList === void 0 ? void 0 : completeList.filter(e => {
      var _e$Name, _e$Name2;
      return !(e !== null && e !== void 0 && (_e$Name = e.Name) !== null && _e$Name !== void 0 && _e$Name.includes("UP Housing and Development Board")) && !(e !== null && e !== void 0 && (_e$Name2 = e.Name) !== null && _e$Name2 !== void 0 && _e$Name2.includes("Uttar Pradesh Online Building Plan Approval System"));
    });
    const officeNames = filterCompList === null || filterCompList === void 0 ? void 0 : filterCompList.map(office => ({
      value: office.Name,
      label: office.Name
    }));
    return officeNames;
  }
  useEffect(() => {
    if (departmentListOptions !== null && departmentListOptions !== void 0 && departmentListOptions.length && location1) {
      setValue("developmentAuthorityName", location1);
    }
  }, [departmentListOptions, location1, setValue]);
  const daList = departmentListOptions === null || departmentListOptions === void 0 ? void 0 : departmentListOptions.filter(item => item.Type == "DA");
  const avpList = departmentListOptions === null || departmentListOptions === void 0 ? void 0 : departmentListOptions.filter(item => item.Type == "AVP");
  const officesList = filterDepartmentsList(departmentListOptions);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement(Container, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "From Date",
    control: control,
    placeholder: "Select Date",
    name: "createdFrom",
    type: "datePicker"
  })), /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "To Date",
    control: control,
    placeholder: "Select Date",
    name: "createdTo",
    type: "datePicker",
    disableFuture: true
  }))), /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Organization Name",
    control: control,
    placeholder: "Select Organization",
    name: "developmentAuthorityName",
    data: SortingAlphabatically(officesList),
    type: userType !== "Admin" && userType !== "SuperAdmin" ? "textInput" : "selectInput",
    disabled: userType !== "SuperAdmin"
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer2",
    style: {
      marginTop: "0px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper",
    style: {
      display: "flex",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    disabled: disableSearch,
    color: disableSearch ? "secondary" : "success",
    size: "medium",
    label: "Search",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset",
    onClick: () => {
      reset();
      onReset();
    }
  })))));
};

function RevenueDetail({
  setApiData,
  apiData
}) {
  var _Digit$UserService$ge, _userInfo$info, _userInfo$info$roles, _userInfo$info2, _userInfo$info2$roles, _userDetails$location, _userDetails$location2;
  const userInfo = Digit.UserService.getUser();
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || null;
  let tenantId = Digit.ULBService.getCurrentTenantId();
  let userType = userInfo !== null && userInfo !== void 0 && (_userInfo$info = userInfo.info) !== null && _userInfo$info !== void 0 && (_userInfo$info$roles = _userInfo$info.roles) !== null && _userInfo$info$roles !== void 0 && _userInfo$info$roles.some(role => role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN") ? "SuperAdmin" : userInfo !== null && userInfo !== void 0 && (_userInfo$info2 = userInfo.info) !== null && _userInfo$info2 !== void 0 && (_userInfo$info2$roles = _userInfo$info2.roles) !== null && _userInfo$info2$roles !== void 0 && _userInfo$info2$roles.some(role => role.code === "HRMS_ADMIN") ? "Admin" : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location = userDetails.location1) === null || _userDetails$location === void 0 ? void 0 : _userDetails$location.length) > 1 ? userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$location2 = userDetails.location1) === null || _userDetails$location2 === void 0 ? void 0 : _userDetails$location2.concat(" Development Authority") : null;
  const {
    t
  } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const fetchData = async (tenantId, params, apiType = "NEW_API") => {
    setIsLoading(true);
    setShowToast(null);
    try {
      var _result;
      let result;
      if (apiType === "OLD_API") {
        result = await OBPSService.paymentReportMISData(tenantId, params);
      } else {
        result = await OBPSService.paymentReportMISDataNew(tenantId, params);
      }
      console.log(result, "resultherere", "apiType:", apiType);
      if (!result) {
        throw new Error("No data received from server");
      }
      const rawRecords = ((_result = result) === null || _result === void 0 ? void 0 : _result.MisAllExtractData) || [];
      let filteredRecords = [...rawRecords];
      if (filteredRecords.length === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found"
        });
      }
      setApiData({
        ...result,
        MisAllExtractData: filteredRecords
      });
    } catch (err) {
      var _err$response, _err$response$data;
      console.error("Error fetching data:", err);
      const message = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message
      });
      setApiData(null);
    } finally {
      setIsLoading(false);
    }
  };
  console.log(apiData, "apiDataapiDataapiDataapiDataapiData");
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = async formData => {
    const {
      developmentAuthorityName,
      createdFrom,
      createdTo
    } = formData || {};
    console.log("FORMDARASDA", formData);
    const location = (developmentAuthorityName === null || developmentAuthorityName === void 0 ? void 0 : developmentAuthorityName.split(" ")[0]) || developmentAuthorityName;
    if (!location || !createdFrom || !createdTo) {
      setApiData(null);
      setShowToast({
        key: "true",
        warning: true,
        message: "Please select Location, From Date and To Date"
      });
      return;
    }
    if (new Date(createdFrom) > new Date(createdTo)) {
      setApiData(null);
      setShowToast({
        key: "true",
        error: true,
        message: "From Date cannot be after To Date"
      });
      return;
    }
    setSelectedLocation(location);
    const params = {
      location,
      createdFrom: createdFrom,
      createdTo: createdTo
    };
    await fetchData(tenantId, params, "NEW_API");
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterForm$3, {
    onSubmit: handleFormSubmit,
    userDetails: userDetails,
    userType: userType,
    location1: location1,
    onReset: () => {
      setApiData(null);
      setShowToast(null);
      setSelectedLocation("");
    }
  }), isLoading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Loader, null)), !isLoading && showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), !isLoading && !showToast && apiData && /*#__PURE__*/React__default.createElement(InboxTable$b, {
    apiData: apiData === null || apiData === void 0 ? void 0 : apiData.MisAllExtractData,
    tenantId: tenantId,
    location: location1 || selectedLocation
  }));
}

const useStyles$A = makeStyles$1(theme => ({
  customTab: {
    backgroundColor: "#1F4A7C",
    color: "white",
    marginRight: "3px",
    borderRadius: "3px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      color: "black",
      border: `1px solid ${theme.palette.primary.main}`
    },
    printerTab: {
      backgroundColor: "#1F4A7C",
      color: "white",
      marginLeft: "200px",
      borderRadius: "2px"
    },
    printerIcon: {
      verticalAlign: "middle",
      marginLeft: "5px"
    }
  }
}));
function RevenueReport() {
  const classes = useStyles$A();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [value, setValue] = useState("1");
  const componentPDF = useRef();
  const [apiData, setApiData] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = newValue => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    const records = (apiData === null || apiData === void 0 ? void 0 : apiData.MisAllExtractData) || [];
    const summary = buildBudgetHeadSummary(records);
    const charData = summary.map(item => ({
      budgetHead: item.label,
      amount: item.totalAmount
    }));
    if (charData.length === 0) {
      return;
    }
    return Digit.Download.Excel(charData, "revenue-report");
  };
  return /*#__PURE__*/createElement(Box$1, {
    sx: {
      width: "100%",
      typography: "body1"
    }
  }, /*#__PURE__*/createElement(TabContext, {
    value: value
  }, /*#__PURE__*/createElement(Box$1, {
    sx: {
      borderBottom: 1,
      borderColor: "divider",
      marginLeft: "20px"
    }
  }, /*#__PURE__*/createElement(TabList, {
    onChange: handleChange,
    "aria-label": "lab API tabs example",
    defaultIndex: selectedTabIndex
  }, /*#__PURE__*/createElement(Tab$1, {
    label: "Revenue Reports",
    value: "1",
    className: classes.customTab
  }), /*#__PURE__*/createElement(ReactToPrint, {
    trigger: () => /*#__PURE__*/createElement("button", {
      style: {
        marginLeft: "45rem"
      },
      id: "invoice-print"
    }, /*#__PURE__*/createElement(PrintIcon$1, null)),
    content: () => componentPDF.current
  }), /*#__PURE__*/createElement("button", {
    className: "mrlg cursorPointer",
    onClick: handleExcelDownload,
    style: {
      marginLeft: "3rem"
    }
  }, /*#__PURE__*/createElement(FaFileExcel, {
    style: {
      fontSize: "22px"
    }
  })))), /*#__PURE__*/createElement("div", {
    ref: componentPDF
  }, /*#__PURE__*/createElement(TabPanel$1, {
    value: "1"
  }, /*#__PURE__*/createElement(RevenueDetail, {
    setApiData: setApiData,
    apiData: apiData
  })))));
}

const EditChallan = () => {
  const {
    t
  } = useTranslation();
  const [applicationNoInput, setApplicationNoInput] = useState("");
  const [currentAppNo, setCurrentAppNo] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const getUserToken = () => {
    try {
      var _Digit, _Digit$UserService, _Digit$UserService$ge, _window, _window$localStorage;
      const user = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.call(_Digit$UserService);
      return (user === null || user === void 0 ? void 0 : user.access_token) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem("token")) || "";
    } catch (e) {
      var _window2, _window2$localStorage;
      return ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$localStorage = _window2.localStorage) === null || _window2$localStorage === void 0 ? void 0 : _window2$localStorage.getItem("token")) || "";
    }
  };
  const buildChallanUpdaterUrl = appNo => {
    const token = getUserToken();
    const baseUrl = process.env.REACT_APP_CHALLAN_UPDATER_URL || "/bpa-ui/challan-updater-direct";
    const encodedToken = encodeURIComponent(token || "");
    const encodedAppNo = encodeURIComponent(appNo || "");
    return `${baseUrl}?token=${encodedToken}&applicationNo=${encodedAppNo}`;
  };
  const handleGo = e => {
    if (e) e.preventDefault();
    const trimmed = applicationNoInput.trim();
    if (!trimmed) return;
    setCurrentAppNo(trimmed);
    const url = buildChallanUpdaterUrl(trimmed);
    setIframeSrc(url);
  };
  const handleRefresh = () => {
    if (currentAppNo) {
      const url = `${buildChallanUpdaterUrl(currentAppNo)}&_t=${Date.now()}`;
      setIframeSrc(url);
    }
  };
  const handleOpenInNewTab = () => {
    if (iframeSrc) {
      window.open(iframeSrc, "_blank", "noopener,noreferrer");
    }
  };
  const handleCopyAppNo = () => {
    if (currentAppNo) {
      var _navigator$clipboard;
      (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(currentAppNo);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      p: {
        xs: 1.5,
        md: 3
      },
      maxWidth: 1320,
      margin: "0 auto"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none",
      margin: 0,
      padding: 0
    }
  }, t("CS_COMMON_BACK", "Back"))), /*#__PURE__*/React__default.createElement(Card$1, {
    sx: {
      mb: 3,
      background: "linear-gradient(135deg, #1F4A7C 0%, #0d2a4a 100%)",
      color: "#fff",
      borderRadius: "12px",
      boxShadow: "0 8px 24px rgba(31, 74, 124, 0.25)"
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    sx: {
      p: {
        xs: 2.5,
        md: 3.5
      }
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      mb: 1
    }
  }, /*#__PURE__*/React__default.createElement(ReceiptIcon, {
    sx: {
      fontSize: 32,
      color: "#64b5f6"
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "h1",
    sx: {
      fontWeight: 700,
      fontSize: {
        xs: "22px",
        md: "28px"
      },
      color: "#fff"
    }
  }, t("ES_OBPS_EDIT_CHALLAN_TITLE", "Edit Challan"))), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "rgba(255, 255, 255, 0.8)",
      maxWidth: 700
    }
  }, t("ES_OBPS_EDIT_CHALLAN_SUBTITLE", "Enter the Application Number to load the Challan Updater interface directly and update fee heads or challan details.")))), /*#__PURE__*/React__default.createElement(Card$1, {
    elevation: 2,
    sx: {
      mb: 3,
      borderRadius: "12px",
      border: "1px solid #e0e6ed",
      background: "#ffffff"
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    sx: {
      p: {
        xs: 2.5,
        md: 3
      }
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    sx: {
      fontWeight: 600,
      mb: 2,
      color: "#1F4A7C",
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    fontSize: "small"
  }), t("ES_OBPS_FIND_APPLICATION", "Search Application")), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleGo
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 8,
    md: 9
  }, /*#__PURE__*/React__default.createElement(TextField, {
    fullWidth: true,
    required: true,
    id: "application-number-input",
    label: t("BPA_BASIC_DETAILS_APPLICATION_NAME", "Application Number"),
    placeholder: t("ES_OBPS_APP_NO_PLACEHOLDER", "Enter Application Number (e.g. LDA/BP/MS/2026-27/6585)"),
    value: applicationNoInput,
    onChange: e => setApplicationNoInput(e.target.value),
    variant: "outlined",
    size: "medium",
    autoFocus: true,
    InputProps: {
      endAdornment: applicationNoInput ? /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => setApplicationNoInput("")
      }, /*#__PURE__*/React__default.createElement(CloseIcon, {
        fontSize: "small"
      })) : null
    },
    sx: {
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        backgroundColor: "#fcfdfe"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 3
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    id: "btn-edit-challan-go",
    type: "submit",
    fullWidth: true,
    variant: "contained",
    endIcon: /*#__PURE__*/React__default.createElement(ArrowForwardIcon, null),
    sx: {
      height: "56px",
      borderRadius: "8px",
      fontWeight: 700,
      fontSize: "16px",
      textTransform: "none",
      backgroundColor: "#1F4A7C",
      boxShadow: "0 4px 12px rgba(31, 74, 124, 0.3)",
      "&:hover": {
        backgroundColor: "#163860"
      }
    }
  }, t("ES_COMMON_GO", "Go"))))))), iframeSrc && /*#__PURE__*/React__default.createElement(Card$1, {
    elevation: 3,
    sx: {
      borderRadius: "12px",
      border: "1px solid #dbe2ea",
      overflow: "hidden",
      backgroundColor: "#ffffff",
      mb: 4
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1.5,
      px: 2.5,
      py: 1.5,
      backgroundColor: "#f8fafc",
      borderBottom: "1px solid #e2e8f0"
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1.5
    }
  }, /*#__PURE__*/React__default.createElement(ReceiptIcon, {
    sx: {
      color: "#1F4A7C",
      fontSize: 22
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    sx: {
      fontWeight: 600,
      color: "#64748b"
    }
  }, t("APPLICATION_NO_LABEL", "Application No:")), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    sx: {
      fontWeight: 700,
      color: "#1F4A7C"
    }
  }, currentAppNo), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: copySuccess ? t("COPIED", "Copied!") : t("COPY", "Copy Application Number")
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    onClick: handleCopyAppNo,
    sx: {
      color: copySuccess ? "#2e7d32" : "#64748b"
    }
  }, /*#__PURE__*/React__default.createElement(ContentCopyIcon, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    title: t("REFRESH_IFRAME", "Reload")
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    onClick: handleRefresh,
    sx: {
      color: "#1F4A7C"
    }
  }, /*#__PURE__*/React__default.createElement(RefreshIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React__default.createElement(Tooltip, {
    title: t("OPEN_NEW_TAB", "Open in New Tab")
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    size: "small",
    onClick: handleOpenInNewTab,
    sx: {
      color: "#1F4A7C"
    }
  }, /*#__PURE__*/React__default.createElement(OpenInNewIcon, {
    fontSize: "small"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "master-data-container",
    style: {
      width: "100%",
      height: "850px",
      minHeight: "650px",
      backgroundColor: "#ffffff"
    }
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: iframeSrc,
    title: "Challan Updater Direct",
    style: {
      width: "100%",
      height: "100%",
      border: "none",
      display: "block"
    }
  }))), !iframeSrc && /*#__PURE__*/React__default.createElement(Card$1, {
    sx: {
      p: 5,
      textAlign: "center",
      borderRadius: "12px",
      border: "1px dashed #cbd5e1",
      backgroundColor: "#fcfdfe"
    }
  }, /*#__PURE__*/React__default.createElement(ReceiptIcon, {
    sx: {
      fontSize: 56,
      color: "#94a3b8",
      mb: 1.5
    }
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    sx: {
      fontWeight: 700,
      color: "#1e293b",
      mb: 1
    }
  }, t("ES_OBPS_READY_TO_UPDATE_CHALLAN", "Application Challan Updater")), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    sx: {
      color: "#64748b",
      maxWidth: 520,
      margin: "0 auto"
    }
  }, t("ES_OBPS_CHALLAN_UPDATER_PROMPT", "Enter an Application Number in the box above and click 'Go' to load the Challan Updater interface directly."))));
};

function EmployeeReportCard() {
  let token = "";
  try {
    var _Digit, _Digit$UserService, _Digit$UserService$ge, _Digit2, _Digit2$UserService, _Digit2$UserService$g, _Digit2$UserService$g2, _window, _window$localStorage;
    token = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || ((_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : (_Digit2$UserService = _Digit2.UserService) === null || _Digit2$UserService === void 0 ? void 0 : (_Digit2$UserService$g = _Digit2$UserService.getUser()) === null || _Digit2$UserService$g === void 0 ? void 0 : (_Digit2$UserService$g2 = _Digit2$UserService$g.info) === null || _Digit2$UserService$g2 === void 0 ? void 0 : _Digit2$UserService$g2.access_token) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem("token")) || "";
  } catch (e) {
    var _window2, _window2$localStorage;
    token = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$localStorage = _window2.localStorage) === null || _window2$localStorage === void 0 ? void 0 : _window2$localStorage.getItem("token")) || "";
  }
  if (typeof token === "string") {
    token = token.replace(/^"(.*)"$/, "$1").trim();
  }
  const encodedToken = encodeURIComponent(token || "");
  const reportUrl = `https://map.up.gov.in/bpa-ui/login?token=${encodedToken}`;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      padding: "16px 24px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "12px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "master-data-container",
    style: {
      width: "100%",
      height: "calc(100vh - 160px)",
      minHeight: "750px",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
    }
  }, /*#__PURE__*/React__default.createElement("iframe", {
    className: "fastPas-iframe",
    src: reportUrl,
    title: "Employee Performance Report",
    style: {
      width: "100%",
      height: "100%",
      border: "none"
    }
  })));
}

const EmployeeApp = ({
  path
}) => {
  var _Digit, _Digit$Utils;
  console.log("path", path);
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const Inbox = Digit.ComponentRegistryService.getComponent("BPAInbox");
  const StakeholderInbox = Digit.ComponentRegistryService.getComponent("StakeholderInbox");
  const ApplicationDetail$1 = Digit.ComponentRegistryService.getComponent("ObpsEmpApplicationDetail");
  const BpaApplicationDetail = Digit.ComponentRegistryService.getComponent("ObpsEmployeeBpaApplicationDetail");
  const isLocation = window.location.href.includes("bpa") || window.location.href.includes("stakeholder-inbox/stakeholder") || window.location.href.includes("application");
  const isFromNoc = window.location.href.includes("digit-ui/employee/obps/bpa/") || window.location.href.includes("digit-ui/employee/obps/purchasableFAR/");
  const isRes = window.location.href.includes("obps/response") || window.location.href.includes("obps/stakeholder-response");
  const isDevOrUat = (_Digit = Digit) !== null && _Digit !== void 0 && (_Digit$Utils = _Digit.Utils) !== null && _Digit$Utils !== void 0 && _Digit$Utils.isDevOrUatEnv ? Digit.Utils.isDevOrUatEnv() : false;
  return /*#__PURE__*/React__default.createElement(TLContextProvider, null, /*#__PURE__*/React__default.createElement(Fragment$2, null, isFromNoc ? /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none",
      margin: "0",
      padding: "0"
    }
  }, t("CS_COMMON_BACK")) : null, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/stakeholder-inbox/stakeholder/:id`,
    component: ApplicationDetail$1
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/search/application/stakeholder/:id`,
    component: ApplicationDetail$1
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/search/application/bpa/:id`,
    component: BpaApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/search/application`,
    component: props => /*#__PURE__*/React__default.createElement(Search, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/inbox/bpa/:id`,
    component: BpaApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/stakeholder-inbox`,
    component: props => /*#__PURE__*/React__default.createElement(StakeholderInbox, Object.assign({}, props, {
      parentRoute: path
    }))
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/bpa/:id`,
    component: BpaApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/response`,
    component: OBPSResponse
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/stakeholder-response`,
    component: StakeholderResponse
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application/:formType/:authority/:plinth/:plan/:form/:year/:serial`,
    component: ApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application/:formType/:authority/:plan/:form/:year/:serial`,
    component: ApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application/:formType/:state/:form/:year/:serial`,
    component: ApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application/:formType/:id`,
    component: ApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application-detail/form12/:id`,
    component: Form12Detail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/applicationview/:formType/:id`,
    component: TakeActionItem
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/form34/:id`,
    component: BpaApplicationDetailForm34
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/dashboardui/table/:formType/:label/:cardType`,
    component: DashboardApplicantReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/dashboardui/table/:label/:cardType`,
    component: DashboardApplicantReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/scheduleInspection`,
    component: ScheduleInspection
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/viewApplications`,
    component: RegistrationReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/licenseforms`,
    component: ApplicationProfessional
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/ownerApplications`,
    component: ownerApplications
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/payment-dashboard`,
    component: PaymentDashboard
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/mis-reports`,
    component: MISDashboard
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/no-records`,
    component: NoRecordsCard
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/payment-details`,
    component: PaymentDetailsReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/eCharges-details`,
    component: EChargesReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/application-details`,
    component: ApplicationsReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/summary-reports`,
    component: SummaryReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/payment-details-report`,
    component: PaymentDetails$2
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/self-certification-details`,
    component: SelfCertificationReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/revenue-details`,
    component: RevenueReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/Inbox/chatboard/:formType/:authority/:plan/:form/:year/:serial`,
    component: InboxReplyChatBoard
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcr-reports`,
    component: ScrutinyFailedReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/inward-reports`,
    component: InwardReport
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/professional/:id`,
    component: ProfessionalApplicationDetail
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/noc/create`,
    component: CreateNOC
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/noc/view`,
    component: ViewNOC
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/dashboard-details`,
    component: DashboardPageV2
  }), " ", /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/Document/Management/create`,
    component: StandardForm
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/Document/Management/Search`,
    component: UserManualPopup
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/New/Management/create`,
    component: WhatsNew
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/New/Management/Release`,
    component: HeroBanner
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/employeeTransfer/initiate`,
    component: InitiateTransfer
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/master-data`,
    component: MasterDataManagement
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/New/Management/Ribbon`,
    component: RibbonMessage
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/search-employee`,
    component: SearchEmployeeData
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edit-challan`,
    component: EditChallan
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/employee-performance-report`,
    component: EmployeeReportCard
  }), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/edcrApplications`,
    component: EdcrApplications
  }))));
};

const SearchFormFieldsComponent = ({
  formState,
  Controller,
  register,
  control,
  t,
  reset,
  previousPage
}) => {
  var _userInfo$value, _JSON$parse, _userInformation$role, _userInformation$role2, _businessServiceData$, _formState$errors, _formState$errors$mob;
  const stateTenantId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
  const userInfo = userInfos ? JSON.parse(userInfos) : {};
  const userInformation = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.info;
  const applicationType = useWatch({
    control,
    name: "applicationType"
  });
  const oldApplicationType = sessionStorage.getItem("search_application") || "";
  if (oldApplicationType && oldApplicationType != "undefined" && ((_JSON$parse = JSON.parse(oldApplicationType)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.code) !== (applicationType === null || applicationType === void 0 ? void 0 : applicationType.code)) control.setValue("status", "");
  sessionStorage.setItem("search_application", JSON.stringify(applicationType));
  const {
    applicationTypes,
    ServiceTypes
  } = Digit.Hooks.obps.useServiceTypeFromApplicationType({
    Applicationtype: (applicationType === null || applicationType === void 0 ? void 0 : applicationType.code) || ((userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role = userInformation.roles) === null || _userInformation$role === void 0 ? void 0 : _userInformation$role.filter(ob => ob.code.includes("BPAREG_")).length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role2 = userInformation.roles) === null || _userInformation$role2 === void 0 ? void 0 : _userInformation$role2.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? "BPA_STAKEHOLDER_REGISTRATION" : "BUILDING_PLAN_SCRUTINY"),
    tenantId: stateTenantId
  });
  const businessServices = "BPA,BPA_LOW,BPA_OC,ARCHITECT,BUILDER,ENGINEER,STRUCTURALENGINEER";
  const {
    isLoading,
    data: businessServiceData
  } = Digit.Hooks.obps.useBusinessServiceData(tenantId, businessServices, {});
  let bpaStatus = [],
    bpaOCStatus = [],
    bparegStatus = [],
    applicationStatuses = [];
  businessServiceData === null || businessServiceData === void 0 ? void 0 : (_businessServiceData$ = businessServiceData.BusinessServices) === null || _businessServiceData$ === void 0 ? void 0 : _businessServiceData$.map(data => {
    data.states.map(state => {
      if (state.state && state.applicationStatus) {
        if (data.business == "BPAREG") {
          bparegStatus.push({
            code: state.applicationStatus,
            i18nKey: `WF_ARCHITECT_${state.state}`,
            module: data.business
          });
        } else {
          if ((data === null || data === void 0 ? void 0 : data.businessService) == "BPA_OC") {
            bpaOCStatus.push({
              code: state.applicationStatus,
              i18nKey: `WF_BPA_${state.state}`,
              module: data.business
            });
          } else {
            bpaStatus.push({
              code: state.applicationStatus,
              i18nKey: `WF_BPA_${state.state}`,
              module: data.business
            });
          }
        }
      }
    });
  });
  let bpaFlags = [],
    bpaStatusUnique = [],
    i;
  for (i = 0; i < bpaStatus.length; i++) {
    if (bpaFlags[bpaStatus[i].code]) continue;
    bpaFlags[bpaStatus[i].code] = true;
    bpaStatusUnique.push(bpaStatus[i].code);
  }
  let bpaOCFlags = [],
    bpaOCStatusStatusUnique = [],
    j;
  for (j = 0; j < bpaOCStatus.length; j++) {
    if (bpaOCFlags[bpaOCStatus[j].code]) continue;
    bpaOCFlags[bpaOCStatus[j].code] = true;
    bpaOCStatusStatusUnique.push(bpaOCStatus[j].code);
  }
  let bpaRegFlags = [],
    bparegStatusUnique = [],
    k;
  for (k = 0; k < bparegStatus.length; k++) {
    if (bpaRegFlags[bparegStatus[k].code]) continue;
    bpaRegFlags[bparegStatus[k].code] = true;
    bparegStatusUnique.push(bparegStatus[k].code);
  }
  const bpaApplicationStatus = [],
    bpaOCApplicationStatus = [],
    bpaRegApplicationStatus = [];
  bpaStatusUnique.forEach(code => bpaApplicationStatus.push({
    i18nKey: `WF_BPA_${code}`,
    code: code
  }));
  bpaOCStatusStatusUnique.forEach(code => bpaOCApplicationStatus.push({
    i18nKey: `WF_BPA_${code}`,
    code: code
  }));
  bparegStatusUnique.forEach(code => bpaRegApplicationStatus.push({
    i18nKey: `WF_BPA_${code}`,
    code: code
  }));
  bpaApplicationStatus.forEach(bpaCode => {
    bpaStatus.map(bpaCde => {
      if ((bpaCode === null || bpaCode === void 0 ? void 0 : bpaCode.code) == (bpaCde === null || bpaCde === void 0 ? void 0 : bpaCde.code)) bpaCode.i18nKey = bpaCde.i18nKey;
    });
  });
  bpaOCApplicationStatus.forEach(bpaOCCode => {
    bpaOCStatus.map(bpaOCCde => {
      if ((bpaOCCode === null || bpaOCCode === void 0 ? void 0 : bpaOCCode.code) == (bpaOCCde === null || bpaOCCde === void 0 ? void 0 : bpaOCCde.code)) bpaOCCode.i18nKey = bpaOCCde.i18nKey;
    });
  });
  bpaRegApplicationStatus.forEach(bparegCode => {
    bparegStatus.map(bparegCde => {
      if ((bparegCode === null || bparegCode === void 0 ? void 0 : bparegCode.code) == (bparegCde === null || bparegCde === void 0 ? void 0 : bparegCde.code)) bparegCode.i18nKey = bparegCde.i18nKey;
    });
  });
  if ((applicationType === null || applicationType === void 0 ? void 0 : applicationType.code) === "BPA_STAKEHOLDER_REGISTRATION") applicationStatuses = bpaRegApplicationStatus;else if ((applicationType === null || applicationType === void 0 ? void 0 : applicationType.code) === "BUILDING_PLAN_SCRUTINY") applicationStatuses = bpaApplicationStatus;else if ((applicationType === null || applicationType === void 0 ? void 0 : applicationType.code) === "BUILDING_OC_PLAN_SCRUTINY") applicationStatuses = bpaOCApplicationStatus;else applicationStatuses = [];
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_SEARCH_APPLICATION_NO_LABEL")), /*#__PURE__*/React__default.createElement(TextInput$2, {
    name: "applicationNo",
    inputRef: register({})
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APP_MOBILE_NO_SEARCH_PARAM")), /*#__PURE__*/React__default.createElement(MobileNumber, {
    name: "mobileNumber",
    disable: window.location.href.includes("/digit-ui/citizen") ? true : false,
    inputRef: register({
      minLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      maxLength: {
        value: 10,
        message: t("CORE_COMMON_MOBILE_ERROR")
      },
      pattern: {
        value: /[6789][0-9]{9}/,
        message: t("CORE_COMMON_MOBILE_ERROR")
      }
    }),
    type: "number",
    componentInFront: /*#__PURE__*/React__default.createElement("div", {
      className: "employee-card-input employee-card-input--front"
    }, "+91")
  }), /*#__PURE__*/React__default.createElement(CardLabelError, null, formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$mob = _formState$errors["mobileNumber"]) === null || _formState$errors$mob === void 0 ? void 0 : _formState$errors$mob.message)), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_SEARCH_APPLICATION_TYPE_LABEL")), /*#__PURE__*/React__default.createElement(Controller, {
    control: control,
    name: "applicationType",
    render: props => /*#__PURE__*/React__default.createElement(Dropdown, {
      selected: props.value,
      select: props.onChange,
      onBlur: props.onBlur,
      option: applicationTypes,
      optionKey: "i18nKey",
      t: t
    })
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL")), /*#__PURE__*/React__default.createElement(Controller, {
    control: control,
    name: "serviceType",
    render: props => /*#__PURE__*/React__default.createElement(Dropdown, {
      selected: ServiceTypes && (ServiceTypes === null || ServiceTypes === void 0 ? void 0 : ServiceTypes.length) > 0 ? props.value : ServiceTypes[0],
      select: props.onChange,
      onBlur: props.onBlur,
      option: ServiceTypes,
      optionKey: "i18nKey",
      t: t,
      isBPAREG: ServiceTypes && (ServiceTypes === null || ServiceTypes === void 0 ? void 0 : ServiceTypes.length) > 0 ? true : false
    })
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APP_FROM_DATE_SEARCH_PARAM")), /*#__PURE__*/React__default.createElement(Controller, {
    render: props => /*#__PURE__*/React__default.createElement(DatePicker, {
      date: props.value,
      onChange: props.onChange
    }),
    name: "fromDate",
    control: control
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_APP_TO_DATE_SEARCH_PARAM")), /*#__PURE__*/React__default.createElement(Controller, {
    render: props => /*#__PURE__*/React__default.createElement(DatePicker, {
      date: props.value,
      onChange: props.onChange
    }),
    name: "toDate",
    control: control
  })), /*#__PURE__*/React__default.createElement(SearchField, null, /*#__PURE__*/React__default.createElement("label", null, t("BPA_SEARCH_APPLICATION_STATUS_LABEL")), /*#__PURE__*/React__default.createElement(Controller, {
    control: control,
    name: "status",
    render: props => /*#__PURE__*/React__default.createElement(Dropdown, {
      selected: props.value,
      select: props.onChange,
      onBlur: props.onBlur,
      option: applicationStatuses,
      optionKey: "i18nKey",
      t: t
    })
  })), /*#__PURE__*/React__default.createElement(SearchField, {
    className: "submit"
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("ES_COMMON_SEARCH"),
    submit: true
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "24px"
    },
    onClick: () => {
      var _userInformation$role3, _userInformation$role4, _userInformation$role5, _userInformation$role6, _userInformation$role7, _userInformation$role8, _userInformation$role9, _userInformation$role10, _userInformation$role11, _userInformation$role12, _userInformation$role13, _userInformation$role14;
      reset({
        applicationNo: "",
        mobileNumber: "",
        fromDate: "",
        toDate: "",
        status: "",
        offset: 0,
        limit: 10,
        sortBy: "commencementDate",
        sortOrder: "DESC",
        applicationType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role3 = userInformation.roles) === null || _userInformation$role3 === void 0 ? void 0 : (_userInformation$role4 = _userInformation$role3.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role4 === void 0 ? void 0 : _userInformation$role4.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role5 = userInformation.roles) === null || _userInformation$role5 === void 0 ? void 0 : _userInformation$role5.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
          code: "BUILDING_PLAN_SCRUTINY",
          i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
        } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role6 = userInformation.roles) === null || _userInformation$role6 === void 0 ? void 0 : (_userInformation$role7 = _userInformation$role6.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role7 === void 0 ? void 0 : _userInformation$role7.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role8 = userInformation.roles) === null || _userInformation$role8 === void 0 ? void 0 : _userInformation$role8.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? {
          code: "BPA_STAKEHOLDER_REGISTRATION",
          i18nKey: "WF_BPA_BPA_STAKEHOLDER_REGISTRATION"
        } : {
          code: "BUILDING_PLAN_SCRUTINY",
          i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
        },
        serviceType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role9 = userInformation.roles) === null || _userInformation$role9 === void 0 ? void 0 : (_userInformation$role10 = _userInformation$role9.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role10 === void 0 ? void 0 : _userInformation$role10.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role11 = userInformation.roles) === null || _userInformation$role11 === void 0 ? void 0 : _userInformation$role11.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
          applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
          code: "NEW_CONSTRUCTION",
          i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
        } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role12 = userInformation.roles) === null || _userInformation$role12 === void 0 ? void 0 : (_userInformation$role13 = _userInformation$role12.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role13 === void 0 ? void 0 : _userInformation$role13.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role14 = userInformation.roles) === null || _userInformation$role14 === void 0 ? void 0 : _userInformation$role14.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? "" : {
          applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
          code: "NEW_CONSTRUCTION",
          i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
        },
        "isSubmitSuccessful": false
      });
      previousPage();
    }
  }, t(`ES_COMMON_CLEAR_ALL`))));
};

const useSearchApplicationTableConfig = ({
  t
}) => {
  const getRedirectionLink = bService => {
    let redirectBS = bService === "BPAREG" ? "search/application/stakeholder" : "search/application/bpa";
    if (window.location.href.includes("/citizen")) {
      redirectBS = bService === "BPAREG" ? "stakeholder" : "bpa";
    }
    return redirectBS;
  };
  const GetCell = value => /*#__PURE__*/React__default.createElement("span", {
    className: "cell-text"
  }, value);
  return useMemo(() => [{
    Header: t("BPA_APPLICATION_NUMBER_LABEL"),
    accessor: "applicationNo",
    disableSortBy: true,
    Cell: ({
      row
    }) => {
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
        className: "link"
      }, /*#__PURE__*/React__default.createElement(Link, {
        to: window.location.href.includes("/citizen") ? `/digit-ui/citizen/obps/${getRedirectionLink(row.original["businessService"]) || "--"}/${row.original["applicationNo"] || row.original["applicationNumber"]}` : `/digit-ui/employee/obps/${getRedirectionLink(row.original["businessService"]) || "--"}/${row.original["applicationNo"] || row.original["applicationNumber"]}`
      }, row.original["applicationNo"] || row.original["applicationNumber"])));
    }
  }, {
    Header: t("BPA_COMMON_TABLE_COL_APP_DATE_LABEL"),
    disableSortBy: true,
    accessor: row => {
      var _row$auditDetails, _row$auditDetails2;
      return GetCell(row !== null && row !== void 0 && (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? convertEpochToDateDMY(row === null || row === void 0 ? void 0 : (_row$auditDetails2 = row.auditDetails) === null || _row$auditDetails2 === void 0 ? void 0 : _row$auditDetails2.createdTime) : "");
    }
  }, {
    Header: t("BPA_SEARCH_APPLICATION_TYPE_LABEL"),
    disableSortBy: true,
    accessor: "applicationType",
    Cell: ({
      row
    }) => {
      var _row$original, _row$original$additio, _row$original2, _row$original2$additi, _row$original3, _row$original4;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
        className: "cell-text"
      }, (_row$original = row.original) !== null && _row$original !== void 0 && (_row$original$additio = _row$original.additionalDetails) !== null && _row$original$additio !== void 0 && _row$original$additio.applicationType ? t(`WF_BPA_${(_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : (_row$original2$additi = _row$original2.additionalDetails) === null || _row$original2$additi === void 0 ? void 0 : _row$original2$additi.applicationType}`) : (_row$original3 = row.original) !== null && _row$original3 !== void 0 && _row$original3.businessService ? t(`BPA_APPLICATIONTYPE_${row === null || row === void 0 ? void 0 : (_row$original4 = row.original) === null || _row$original4 === void 0 ? void 0 : _row$original4.businessService}`) : "-"));
    }
  }, {
    Header: t("BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL"),
    disableSortBy: true,
    accessor: row => {
      var _row$additionalDetail, _row$tradeLicenseDeta, _row$tradeLicenseDeta2, _row$tradeLicenseDeta3, _row$tradeLicenseDeta4;
      return GetCell(t(((_row$additionalDetail = row.additionalDetails) === null || _row$additionalDetail === void 0 ? void 0 : _row$additionalDetail.serviceType) || t(`TRADELICENSE_TRADETYPE_${row === null || row === void 0 ? void 0 : (_row$tradeLicenseDeta = row.tradeLicenseDetail) === null || _row$tradeLicenseDeta === void 0 ? void 0 : (_row$tradeLicenseDeta2 = _row$tradeLicenseDeta.tradeUnits) === null || _row$tradeLicenseDeta2 === void 0 ? void 0 : (_row$tradeLicenseDeta3 = _row$tradeLicenseDeta2[0]) === null || _row$tradeLicenseDeta3 === void 0 ? void 0 : (_row$tradeLicenseDeta4 = _row$tradeLicenseDeta3.tradeType) === null || _row$tradeLicenseDeta4 === void 0 ? void 0 : _row$tradeLicenseDeta4.split(".")[0]}`) || "-"));
    }
  }, {
    Header: t("BPA_CURRENT_OWNER_HEAD"),
    accessor: row => GetCell((row === null || row === void 0 ? void 0 : row.assignee) || "-"),
    disableSortBy: true
  }, {
    Header: t("BPA_STATUS_LABEL"),
    accessor: row => GetCell(t((row === null || row === void 0 ? void 0 : row.state) && `WF_BPA_${row.state}` || (row === null || row === void 0 ? void 0 : row.state) && `WF_BPA_${row.status}` || "NA")),
    disableSortBy: true
  }], []);
};

const OBPSSearchApplication = ({
  tenantId,
  t,
  onSubmit,
  data,
  error,
  searchData,
  isLoading,
  Count,
  setparamerror
}) => {
  var _userInfo$value, _userInfo$value2, _userInfo$value2$info, _userInformation$role, _userInformation$role2, _userInformation$role3, _userInformation$role4, _userInformation$role5, _userInformation$role6, _userInformation$role7, _userInformation$role8, _userInformation$role9, _userInformation$role10, _userInformation$role11, _userInformation$role12, _data$3, _data$4;
  const [showToast, setShowToast] = useState(null);
  const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
  const userInfo = userInfos ? JSON.parse(userInfos) : {};
  const userInformation = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.info;
  const currentUserPhoneNumber = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$value2 = userInfo.value) === null || _userInfo$value2 === void 0 ? void 0 : (_userInfo$value2$info = _userInfo$value2.info) === null || _userInfo$value2$info === void 0 ? void 0 : _userInfo$value2$info.mobileNumber;
  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState
  } = useForm({
    defaultValues: {
      applicationNo: "",
      mobileNumber: window.location.href.includes("/digit-ui/citizen") ? currentUserPhoneNumber : "",
      fromDate: "",
      toDate: "",
      status: "",
      offset: 0,
      limit: 10,
      sortBy: "commencementDate",
      sortOrder: "DESC",
      applicationType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role = userInformation.roles) === null || _userInformation$role === void 0 ? void 0 : (_userInformation$role2 = _userInformation$role.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role2 === void 0 ? void 0 : _userInformation$role2.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role3 = userInformation.roles) === null || _userInformation$role3 === void 0 ? void 0 : _userInformation$role3.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
        code: "BUILDING_PLAN_SCRUTINY",
        i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
      } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role4 = userInformation.roles) === null || _userInformation$role4 === void 0 ? void 0 : (_userInformation$role5 = _userInformation$role4.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role5 === void 0 ? void 0 : _userInformation$role5.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role6 = userInformation.roles) === null || _userInformation$role6 === void 0 ? void 0 : _userInformation$role6.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? {
        code: "BPA_STAKEHOLDER_REGISTRATION",
        i18nKey: "WF_BPA_BPA_STAKEHOLDER_REGISTRATION"
      } : {
        code: "BUILDING_PLAN_SCRUTINY",
        i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
      },
      serviceType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role7 = userInformation.roles) === null || _userInformation$role7 === void 0 ? void 0 : (_userInformation$role8 = _userInformation$role7.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role8 === void 0 ? void 0 : _userInformation$role8.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role9 = userInformation.roles) === null || _userInformation$role9 === void 0 ? void 0 : _userInformation$role9.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
        applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
        code: "NEW_CONSTRUCTION",
        i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
      } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role10 = userInformation.roles) === null || _userInformation$role10 === void 0 ? void 0 : (_userInformation$role11 = _userInformation$role10.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role11 === void 0 ? void 0 : _userInformation$role11.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role12 = userInformation.roles) === null || _userInformation$role12 === void 0 ? void 0 : _userInformation$role12.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? "" : {
        applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
        code: "NEW_CONSTRUCTION",
        i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
      },
      ...searchData
    }
  });
  useEffect(() => {
    register("offset", 0);
    register("limit", 10);
    register("sortBy", "commencementDate");
    register("sortOrder", "DESC");
  }, [register]);
  React__default.useEffect(() => {
    if (formState.isSubmitSuccessful) {
      var _Digit$UserService$ge, _Digit$UserService$ge2, _userInformation$role13, _userInformation$role14, _userInformation$role15, _userInformation$role16, _userInformation$role17, _userInformation$role18, _userInformation$role19, _userInformation$role20, _userInformation$role21, _userInformation$role22, _userInformation$role23, _userInformation$role24;
      reset({
        applicationNo: "",
        mobileNumber: window.location.href.includes("/digit-ui/citizen") ? (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.mobileNumber : "",
        fromDate: "",
        toDate: "",
        status: "",
        offset: 0,
        limit: 10,
        sortBy: "commencementDate",
        sortOrder: "DESC",
        applicationType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role13 = userInformation.roles) === null || _userInformation$role13 === void 0 ? void 0 : (_userInformation$role14 = _userInformation$role13.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role14 === void 0 ? void 0 : _userInformation$role14.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role15 = userInformation.roles) === null || _userInformation$role15 === void 0 ? void 0 : _userInformation$role15.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
          code: "BUILDING_PLAN_SCRUTINY",
          i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
        } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role16 = userInformation.roles) === null || _userInformation$role16 === void 0 ? void 0 : (_userInformation$role17 = _userInformation$role16.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role17 === void 0 ? void 0 : _userInformation$role17.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role18 = userInformation.roles) === null || _userInformation$role18 === void 0 ? void 0 : _userInformation$role18.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? {
          code: "BPA_STAKEHOLDER_REGISTRATION",
          i18nKey: "WF_BPA_BPA_STAKEHOLDER_REGISTRATION"
        } : {
          code: "BUILDING_PLAN_SCRUTINY",
          i18nKey: "WF_BPA_BUILDING_PLAN_SCRUTINY"
        },
        serviceType: (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role19 = userInformation.roles) === null || _userInformation$role19 === void 0 ? void 0 : (_userInformation$role20 = _userInformation$role19.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role20 === void 0 ? void 0 : _userInformation$role20.length) <= 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role21 = userInformation.roles) === null || _userInformation$role21 === void 0 ? void 0 : _userInformation$role21.filter(ob => ob.code.includes("BPA_")).length) > 0 ? {
          applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
          code: "NEW_CONSTRUCTION",
          i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
        } : (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role22 = userInformation.roles) === null || _userInformation$role22 === void 0 ? void 0 : (_userInformation$role23 = _userInformation$role22.filter(ob => ob.code.includes("BPAREG_"))) === null || _userInformation$role23 === void 0 ? void 0 : _userInformation$role23.length) > 0 && (userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$role24 = userInformation.roles) === null || _userInformation$role24 === void 0 ? void 0 : _userInformation$role24.filter(ob => ob.code.includes("BPA_")).length) <= 0 ? "" : {
          applicationType: ["BUILDING_PLAN_SCRUTINY", "BUILDING_OC_PLAN_SCRUTINY"],
          code: "NEW_CONSTRUCTION",
          i18nKey: "BPA_SERVICETYPE_NEW_CONSTRUCTION"
        },
        ...searchData,
        isSubmitSuccessful: false
      });
    }
  }, [formState]);
  const columns = useSearchApplicationTableConfig({
    t
  });
  const [currPage, setCurrPage] = useState(getValues("offset") / getValues("limit"));
  useEffect(() => {
    if (error !== "") {
      setparamerror("");
      setShowToast({
        key: true,
        label: error
      });
    }
  }, [error]);
  const fetchLastPage = () => {
    setValue("offset", Count && Math.ceil(Count / 10) * 10 - getValues("limit"));
    handleSubmit(onSubmit)();
  };
  const fetchFirstPage = () => {
    setValue("offset", 0);
    handleSubmit(onSubmit)();
  };
  const onSort = useCallback(args => {
    if (args.length === 0) return;
    setValue("sortBy", args.id);
    setValue("sortOrder", args.desc ? "DESC" : "ASC");
  }, []);
  function onPageSizeChange(e) {
    setValue("limit", Number(e.target.value));
    handleSubmit(onSubmit)();
  }
  function nextPage() {
    setValue("offset", getValues("offset") + getValues("limit"));
    handleSubmit(onSubmit)();
  }
  function previousPage() {
    setValue("offset", getValues("offset") - getValues("limit"));
    handleSubmit(onSubmit)();
  }
  useEffect(() => {
    if (!(getValues("offset") == undefined || getValues("limit") == undefined)) setCurrPage(getValues("offset") / getValues("limit"));
  }, [getValues("offset"), getValues("limit")]);
  const isMobile = window.Digit.Utils.browser.isMobile();
  const searchFormFieldsComponentProps = {
    formState,
    Controller,
    register,
    control,
    t,
    reset,
    previousPage
  };
  const getRedirectionLink = bService => {
    let redirectBS = bService === "BPAREG" ? "search/application/stakeholder" : "search/application/bpa";
    if (window.location.href.includes("/citizen")) {
      redirectBS = bService === "BPAREG" ? "stakeholder" : "bpa";
    }
    return redirectBS;
  };
  const propsMobileInboxCards = useMemo(() => data === null || data === void 0 ? void 0 : data.map(data => {
    var _data$auditDetails, _data$additionalDetai, _data$additionalDetai2, _data$additionalDetai3, _data$additionalDetai4, _data$landInfo;
    return {
      [t("BPA_APPLICATION_NUMBER_LABEL")]: data.applicationNo,
      [t("BPA_COMMON_TABLE_COL_APP_DATE_LABEL")]: convertEpochToDateDMY((_data$auditDetails = data.auditDetails) === null || _data$auditDetails === void 0 ? void 0 : _data$auditDetails.createdTime) || "",
      [t("BPA_SEARCH_APPLICATION_TYPE_LABEL")]: (_data$additionalDetai = data.additionalDetails) !== null && _data$additionalDetai !== void 0 && _data$additionalDetai.applicationType ? t(`WF_BPA_${(_data$additionalDetai2 = data.additionalDetails) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.applicationType}`) : "-",
      [t("BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL")]: (_data$additionalDetai3 = data.additionalDetails) !== null && _data$additionalDetai3 !== void 0 && _data$additionalDetai3.serviceType ? t((_data$additionalDetai4 = data.additionalDetails) === null || _data$additionalDetai4 === void 0 ? void 0 : _data$additionalDetai4.serviceType) : "-",
      [t("BPA_CURRENT_OWNER_HEAD")]: ((_data$landInfo = data.landInfo) === null || _data$landInfo === void 0 ? void 0 : _data$landInfo.owners.map(o => o.name).join(",")) || "-",
      [t("BPA_STATUS_LABEL")]: data.state ? t(`WF_BPA_${data.state}`) : "NA"
    };
  }), [data]);
  if (isMobile) {
    var _data$, _data$2;
    function activateModal(state, action) {
      switch (action.type) {
        case "set":
          return action.payload;
        case "remove":
          return false;
      }
    }
    const [currentlyActiveMobileModal, setActiveMobileModal] = useReducer(activateModal, false);
    const closeMobilePopupModal = () => {
      setActiveMobileModal({
        type: "remove"
      });
    };
    const MobilePopUpCloseButton = () => /*#__PURE__*/React__default.createElement("div", {
      className: "InboxMobilePopupCloseButtonWrapper",
      onClick: closeMobilePopupModal
    }, /*#__PURE__*/React__default.createElement(CloseSvg, null));
    const MobileComponentDirectory = ({
      currentlyActiveMobileModal,
      searchFormFieldsComponentProps,
      ...props
    }) => {
      const {
        closeMobilePopupModal
      } = props;
      switch (currentlyActiveMobileModal) {
        case "SearchFormComponent":
          return /*#__PURE__*/React__default.createElement(SearchForm, props, /*#__PURE__*/React__default.createElement(MobilePopUpCloseButton, null), /*#__PURE__*/React__default.createElement("div", {
            className: "MobilePopupHeadingWrapper"
          }, /*#__PURE__*/React__default.createElement("h2", null, t("ES_COMMON_SEARCH_APPLICATION"), ":")), /*#__PURE__*/React__default.createElement(SearchFormFieldsComponent, Object.assign({}, searchFormFieldsComponentProps, {
            closeMobilePopupModal
          })));
        default:
          return /*#__PURE__*/React__default.createElement("span", null);
      }
    };
    const CurrentMobileModalComponent = useCallback(({
      currentlyActiveMobileModal,
      searchFormFieldsComponentProps,
      ...props
    }) => MobileComponentDirectory({
      currentlyActiveMobileModal,
      searchFormFieldsComponentProps,
      ...props
    }), [currentlyActiveMobileModal]);
    if (isLoading) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "searchBox"
    }, /*#__PURE__*/React__default.createElement(SearchAction, {
      text: t("ES_COMMON_SEARCH_APPLICATION"),
      handleActionClick: () => setActiveMobileModal({
        type: "set",
        payload: "SearchFormComponent"
      })
    })), currentlyActiveMobileModal ? /*#__PURE__*/React__default.createElement(PopUp, null, /*#__PURE__*/React__default.createElement(CurrentMobileModalComponent, Object.assign({
      onSubmit: data => {
        setActiveMobileModal({
          type: "remove"
        });
        onSubmit(data);
      },
      handleSubmit: handleSubmit,
      id: "search-form",
      className: "rm-mb form-field-flex-one inboxPopupMobileWrapper"
    }, {
      searchFormFieldsComponentProps,
      currentlyActiveMobileModal,
      closeMobilePopupModal
    }))) : null, data !== null && data !== void 0 && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.display ? /*#__PURE__*/React__default.createElement(Card, {
      style: {
        marginTop: 20
      }
    }, t(data === null || data === void 0 ? void 0 : (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.display).split("\\n").map((text, index) => /*#__PURE__*/React__default.createElement("p", {
      key: index,
      style: {
        textAlign: "center"
      }
    }, text))) : /*#__PURE__*/React__default.createElement(DetailsCard, {
      data: propsMobileInboxCards,
      isTwoDynamicPrefix: true,
      linkPrefix: window.location.href.includes("/citizen") ? `/digit-ui/citizen/obps/` : `/digit-ui/employee/obps/`,
      getRedirectionLink: getRedirectionLink,
      serviceRequestIdKey: "applicationNo"
    }));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Header, null, t("ES_COMMON_SEARCH_APPLICATION")), /*#__PURE__*/React__default.createElement(SearchForm, {
    onSubmit: onSubmit,
    handleSubmit: handleSubmit
  }, /*#__PURE__*/React__default.createElement(SearchFormFieldsComponent, searchFormFieldsComponentProps)), !isLoading && data !== null && data !== void 0 && (_data$3 = data[0]) !== null && _data$3 !== void 0 && _data$3.display ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      marginTop: 20
    }
  }, t(data === null || data === void 0 ? void 0 : (_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.display).split("\\n").map((text, index) => /*#__PURE__*/React__default.createElement("p", {
    key: index,
    style: {
      textAlign: "center"
    }
  }, text))) : !showToast ? !isLoading ? /*#__PURE__*/React__default.createElement(Table, {
    t: t,
    data: data,
    columns: columns,
    getCellProps: cellInfo => {
      return {
        style: {
          minWidth: cellInfo.column.Header === t("ES_INBOX_APPLICATION_NO") ? "240px" : "",
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    onPageSizeChange: onPageSizeChange,
    currentPage: currPage,
    onNextPage: nextPage,
    onPrevPage: previousPage,
    pageSizeLimit: getValues("limit"),
    onSort: onSort,
    totalRecords: Count,
    disableSort: false,
    onLastPage: fetchLastPage,
    onFirstPage: fetchFirstPage,
    sortParams: [{
      id: getValues("sortBy"),
      desc: getValues("sortOrder") === "DESC" ? true : false
    }]
  }) : /*#__PURE__*/React__default.createElement(Loader, null) : "", showToast && /*#__PURE__*/React__default.createElement(Toast, {
    warning: showToast.label == "BPA_ADD_MORE_PARAM_STAKEHOLDER" ? true : false,
    error: showToast.label == "BPA_ADD_MORE_PARAM_STAKEHOLDER" ? false : showToast.key,
    label: t(showToast.label),
    isDleteBtn: true,
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const OBPSDocumentsEmp = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  setError: setFormError,
  clearErrors: clearFormErrors,
  formState,
  index: indexx,
  setFieldReports,
  documentList
}) => {
  var _formData$FeildReport, _formData$FeildReport2;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$FeildReport = formData.FeildReports) === null || _formData$FeildReport === void 0 ? void 0 : (_formData$FeildReport2 = _formData$FeildReport[indexx]) === null || _formData$FeildReport2 === void 0 ? void 0 : _formData$FeildReport2.Documents) || []);
  const [error, setError] = useState(null);
  const [previousLicenseDetails, setPreviousLicenseDetails] = useState((formData === null || formData === void 0 ? void 0 : formData.tradedetils1) || []);
  let action = "create";
  const {
    pathname
  } = useLocation();
  const isEditScreen = pathname.includes("/modify-application/");
  if (isEditScreen) action = "update";
  const {
    isLoading,
    data: documentsData
  } = Digit.Hooks.pt.usePropertyMDMS(stateId, "TradeLicense", ["documentObj"]);
  const ckeckingLocation = window.location.href.includes("renew-application-details");
  let finalTlDocumentsList = [];
  documentList && documentList.map(doc => {
    finalTlDocumentsList.push({
      documentType: doc.code,
      code: doc.code
    });
  });
  const goNext = () => {
    let data = formData;
    data && data !== null && data !== void 0 && data.FieldReports && (data === null || data === void 0 ? void 0 : data.FieldReports.length) > 0 && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 ? data.FieldReports[indexx] = {
      ...data.FieldReports[indexx],
      Documents: documents
    } : "";
    data && data !== null && data !== void 0 && data.FieldReports && (data === null || data === void 0 ? void 0 : data.FieldReports.length) > 0 && documents.length > 0 ? setFieldReports(data.FieldReports) : "";
  };
  useEffect(() => {
    goNext();
  }, [documents]);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", null, finalTlDocumentsList === null || finalTlDocumentsList === void 0 ? void 0 : finalTlDocumentsList.map((document, index) => {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SelectDocument$6, {
      key: index,
      document: document,
      action: action,
      t: t,
      id: `obps-doc-${index}`,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      formData: formData,
      setFormError: setFormError,
      clearFormErrors: clearFormErrors,
      config: config,
      formState: formState,
      stateId: stateId
    }));
  }), error && /*#__PURE__*/React__default.createElement(Toast, {
    label: error,
    onClose: () => setError(null),
    error: true
  }));
};
function SelectDocument$6({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  action,
  formData,
  setFormError,
  clearFormErrors,
  config,
  formState,
  fromRawData,
  key,
  id,
  stateId = {
    stateId
  }
}) {
  const filteredDocument = documents === null || documents === void 0 ? void 0 : documents.filter(item => item === null || item === void 0 ? void 0 : item.documentType);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [selectedDocument, setSelectedDocument] = useState("");
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const [isHidden, setHidden] = useState(false);
  const [newArray, setnewArray] = useState([]);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfile(e, key) {
    var _e$fileStoreId;
    e && setSelectedDocument({
      documentType: key
    });
    e && setFile(e.file);
    e && setUploadedFile(e === null || e === void 0 ? void 0 : (_e$fileStoreId = e.fileStoreId) === null || _e$fileStoreId === void 0 ? void 0 : _e$fileStoreId.fileStoreId);
  }
  function getData(e, key) {
    let data = Object.fromEntries(e);
    let newArr = Object.values(data);
    setnewArray(newArr);
    if (documents && newArr && documents.filter(ob => ob.documentType === key).length > newArr.length) {
      setDocuments(documents.filter(ob => ob.documentType !== key));
    }
    newArr && newArr.map(ob => {
      ob.file.documentType = key;
      selectfile(ob, key);
    });
  }
  const addError = () => {
    var _formState$errors, _formState$errors$con;
    let type = (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$con = _formState$errors[config.key]) === null || _formState$errors$con === void 0 ? void 0 : _formState$errors$con.type;
    if (!Array.isArray(type)) type = [];
    if (!type.includes(doc.documentType)) {
      type.push(doc.documentType);
      setFormError(config.key, {
        type
      });
    }
  };
  const removeError = () => {
    var _formState$errors2, _formState$errors2$co;
    let type = (_formState$errors2 = formState.errors) === null || _formState$errors2 === void 0 ? void 0 : (_formState$errors2$co = _formState$errors2[config.key]) === null || _formState$errors2$co === void 0 ? void 0 : _formState$errors2$co.type;
    if (!Array.isArray(type)) type = [];
    if (type.includes(doc === null || doc === void 0 ? void 0 : doc.documentType)) {
      type = type.filter(e => e != (doc === null || doc === void 0 ? void 0 : doc.documentType));
      if (!type.length) {
        clearFormErrors(config.key);
      } else {
        setFormError(config.key, {
          type
        });
      }
    }
  };
  useEffect(() => {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.documentType && (documents.filter(ob => ob.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType)).length == 0 || newArray.filter(ob => {
      var _ob$file;
      return (ob === null || ob === void 0 ? void 0 : (_ob$file = ob.file) === null || _ob$file === void 0 ? void 0 : _ob$file.documentType) === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType);
    }).length !== documents.filter(ob => ob.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType)).length)) {
      setDocuments(prev => {
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) {
          return prev;
        }
        const filteredDocumentsByFileStoreId = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        const filteredDocumentByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.documentType) !== (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType));
        if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.id) {
          return [...filteredDocumentsByFileStoreId, {
            documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType,
            fileStoreId: uploadedFile,
            tenantId: tenantId,
            id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.id
          }];
        } else {
          let UniqueDocTypeTempArray = [];
          newArray.map(ob => {
            var _ob$fileStoreId, _ob$fileStoreId2;
            UniqueDocTypeTempArray.push({
              documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.documentType,
              fileStoreId: ob === null || ob === void 0 ? void 0 : (_ob$fileStoreId = ob.fileStoreId) === null || _ob$fileStoreId === void 0 ? void 0 : _ob$fileStoreId.fileStoreId,
              tenantId: ob === null || ob === void 0 ? void 0 : (_ob$fileStoreId2 = ob.fileStoreId) === null || _ob$fileStoreId2 === void 0 ? void 0 : _ob$fileStoreId2.tenantId
            });
          });
          return [...filteredDocumentByDocumentType, ...UniqueDocTypeTempArray];
        }
      });
    }
    if (!isHidden) {
      const isRenewal = window.location.href.includes("renew-application-details");
      if (!isRenewal) {
        if (!uploadedFile || !(selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.documentType)) {
          addError();
        } else if (uploadedFile && selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.documentType) {
          removeError();
        }
      }
    } else if (isHidden) {
      removeError();
    }
  }, [uploadedFile, selectedDocument, isHidden]);
  useEffect(() => {
    var _formData$documents, _formData$documents$d;
    if (doc && (formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : (_formData$documents$d = _formData$documents.documents) === null || _formData$documents$d === void 0 ? void 0 : _formData$documents$d.length) > 0) {
      for (let i = 0; i < (formData === null || formData === void 0 ? void 0 : (_formData$documents2 = formData.documents) === null || _formData$documents2 === void 0 ? void 0 : (_formData$documents2$ = _formData$documents2.documents) === null || _formData$documents2$ === void 0 ? void 0 : _formData$documents2$.length); i++) {
        var _formData$documents2, _formData$documents2$, _formData$documents3, _formData$documents3$, _formData$documents3$2;
        if ((doc === null || doc === void 0 ? void 0 : doc.documentType) === (formData === null || formData === void 0 ? void 0 : (_formData$documents3 = formData.documents) === null || _formData$documents3 === void 0 ? void 0 : (_formData$documents3$ = _formData$documents3.documents) === null || _formData$documents3$ === void 0 ? void 0 : (_formData$documents3$2 = _formData$documents3$[i]) === null || _formData$documents3$2 === void 0 ? void 0 : _formData$documents3$2.documentType)) {
          var _formData$documents4, _formData$documents4$, _formData$documents4$2, _formData$documents5, _formData$documents5$, _formData$documents5$2, _formData$documents6, _formData$documents6$, _formData$documents6$2;
          setSelectedDocument({
            documentType: formData === null || formData === void 0 ? void 0 : (_formData$documents4 = formData.documents) === null || _formData$documents4 === void 0 ? void 0 : (_formData$documents4$ = _formData$documents4.documents) === null || _formData$documents4$ === void 0 ? void 0 : (_formData$documents4$2 = _formData$documents4$[i]) === null || _formData$documents4$2 === void 0 ? void 0 : _formData$documents4$2.documentType,
            id: formData === null || formData === void 0 ? void 0 : (_formData$documents5 = formData.documents) === null || _formData$documents5 === void 0 ? void 0 : (_formData$documents5$ = _formData$documents5.documents) === null || _formData$documents5$ === void 0 ? void 0 : (_formData$documents5$2 = _formData$documents5$[i]) === null || _formData$documents5$2 === void 0 ? void 0 : _formData$documents5$2.id
          });
          setUploadedFile(formData === null || formData === void 0 ? void 0 : (_formData$documents6 = formData.documents) === null || _formData$documents6 === void 0 ? void 0 : (_formData$documents6$ = _formData$documents6.documents) === null || _formData$documents6$ === void 0 ? void 0 : (_formData$documents6$2 = _formData$documents6$[i]) === null || _formData$documents6$2 === void 0 ? void 0 : _formData$documents6$2.fileStoreId);
        }
      }
    }
  }, [doc]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "card-label-smaller",
    style: {
      width: "100%"
    }
  }, (doc === null || doc === void 0 ? void 0 : doc.documentType) != "OLDLICENCENO" ? `${t(`${doc === null || doc === void 0 ? void 0 : doc.documentType.replaceAll(".", "_")}`)}*` : `${t(`${doc === null || doc === void 0 ? void 0 : doc.documentType.replaceAll(".", "_")}`)}`), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: stateId,
    getFormState: e => getData(e, doc === null || doc === void 0 ? void 0 : doc.documentType.replaceAll(".", "_")),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }))));
}

const createUnitDetails = () => ({
  InspectionDate: "",
  InspectionTime: "",
  Checklist: [],
  Documents: [],
  key: Date.now()
});
const InspectionReport = ({
  config,
  onSelect,
  userType,
  formData,
  setError,
  formState,
  clearErrors
}) => {
  const {
    t
  } = useTranslation();
  const {
    pathname
  } = useLocation();
  const isEditScreen = pathname.includes("/modify-application/");
  const [FieldReports, setFieldReports] = useState((formData === null || formData === void 0 ? void 0 : formData.FieldReports) || [createUnitDetails()]);
  const [focusIndex, setFocusIndex] = useState({
    index: -1,
    type: ""
  });
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [tradeTypeMdmsData, setTradeTypeMdmsData] = useState([]);
  const [tradeCategoryValues, setTradeCategoryValues] = useState([]);
  const [tradeTypeOptionsList, setTradeTypeOptionsList] = useState([]);
  const [questionList, setquestionList] = useState([]);
  const [documentList, setdocumentList] = useState([]);
  const [tradeSubTypeOptionsList, setTradeSubTypeOptionsList] = useState([]);
  const [isErrors, setIsErrors] = useState(false);
  const [previousLicenseDetails, setPreviousLicenseDetails] = useState((formData === null || formData === void 0 ? void 0 : formData.tradedetils1) || []);
  let isRenewal = window.location.href.includes("tl/renew-application-details");
  if (window.location.href.includes("tl/renew-application-details")) isRenewal = true;
  const {
    data: tradeMdmsData,
    isLoading
  } = Digit.Hooks.tl.useTradeLicenseMDMS(stateId, "TradeLicense", "TradeUnits", "[?(@.type=='TL')]");
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["CheckList"]);
  let type = "LOW";
  const addNewFieldReport = () => {
    const newUnit = createUnitDetails();
    setFieldReports(prev => [...prev, newUnit]);
  };
  const removeUnit = unit => {
    setFieldReports(prev => prev.filter(o => o.key != unit.key));
  };
  useEffect(() => {
    const data = FieldReports.map(e => {
      return e;
    });
    onSelect(config === null || config === void 0 ? void 0 : config.key, data);
    sessionStorage.setItem("INSPECTION_DATA", JSON.stringify(data));
  }, [FieldReports]);
  useEffect(() => {
    onSelect("tradedetils1", previousLicenseDetails);
  }, [previousLicenseDetails]);
  useEffect(() => {
    let ques = [];
    let documentlist = [];
    bpaDocs && bpaDocs.BPA.CheckList.map(ob => {
      if ((ob === null || ob === void 0 ? void 0 : ob.RiskType) === type && (ob === null || ob === void 0 ? void 0 : ob.WFState) === "FIELDINSPECTION_PENDING") {
        ques = [...ob.questions];
        documentlist = [...ob.docTypes];
      }
    });
    setdocumentList(documentlist);
    setquestionList(ques);
  }, [bpaDocs]);
  const commonProps = {
    focusIndex,
    allFieldReport: FieldReports,
    setFocusIndex,
    removeUnit,
    formData,
    formState,
    setFieldReports,
    t,
    setError,
    clearErrors,
    config,
    onSelect,
    userType,
    tradeCategoryValues,
    tradeTypeOptionsList,
    setTradeTypeOptionsList,
    tradeTypeMdmsData,
    tradeSubTypeOptionsList,
    setTradeSubTypeOptionsList,
    setTradeTypeMdmsData,
    setTradeCategoryValues,
    tradeMdmsData,
    isErrors,
    setIsErrors,
    previousLicenseDetails,
    setPreviousLicenseDetails,
    isLoading,
    bpaDocs,
    type,
    questionList,
    setquestionList,
    documentList
  };
  if (isEditScreen) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, FieldReports && FieldReports.map((unit, index) => /*#__PURE__*/React__default.createElement(InspectionReportForm, Object.assign({
    key: unit.key,
    index: index,
    unit: unit
  }, commonProps)))), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: t("BPA_ADD_FIELD_INSPECTION"),
    onClick: addNewFieldReport,
    style: {
      color: "#1F4A7C",
      width: "fit-content"
    }
  }));
};
const InspectionReportForm = _props => {
  var _formData$ownershipCa2;
  const {
    unit,
    index,
    focusIndex,
    allFieldReport,
    setFocusIndex,
    removeUnit,
    setFieldReports,
    t,
    formData,
    config,
    onSelect,
    userType,
    setError,
    clearErrors,
    formState,
    tradeCategoryValues,
    tradeTypeOptionsList,
    setTradeTypeOptionsList,
    tradeTypeMdmsData,
    tradeSubTypeOptionsList,
    setTradeSubTypeOptionsList,
    setTradeTypeMdmsData,
    setTradeCategoryValues,
    tradeMdmsData,
    isErrors,
    setIsErrors,
    previousLicenseDetails,
    setPreviousLicenseDetails,
    isLoading,
    bpaDocs,
    type,
    questionList,
    setquestionList,
    documentList
  } = _props;
  const {
    control,
    formState: localFormState,
    watch,
    setError: setLocalError,
    clearErrors: clearLocalErrors,
    setValue,
    trigger,
    getValues
  } = useForm();
  const formValue = watch();
  const {
    errors
  } = localFormState;
  const isIndividualTypeOwner = useMemo(() => {
    var _formData$ownershipCa;
    return formData === null || formData === void 0 ? void 0 : (_formData$ownershipCa = formData.ownershipCategory) === null || _formData$ownershipCa === void 0 ? void 0 : _formData$ownershipCa.code.includes("INDIVIDUAL");
  }, [formData === null || formData === void 0 ? void 0 : (_formData$ownershipCa2 = formData.ownershipCategory) === null || _formData$ownershipCa2 === void 0 ? void 0 : _formData$ownershipCa2.code]);
  useEffect(() => {
    trigger();
  }, []);
  useEffect(() => {
    const keys = Object.keys(formValue);
    const part = {};
    keys.forEach(key => part[key] = unit[key]);
    let _ownerType = isIndividualTypeOwner ? {} : {
      ownerType: {
        code: "NONE"
      }
    };
    let questionLength = questionList ? {
      questionLength: questionList.length
    } : {
      questionLength: 0
    };
    let Ques = questionList ? {
      questionList: questionList
    } : {
      questionList: []
    };
    if (!_$1.isEqual(formValue, part)) {
      Object.keys(formValue).map(data => {
        if (data != "key" && formValue[data] != undefined && formValue[data] != "" && formValue[data] != null && !isErrors) {
          setIsErrors(true);
        }
      });
      setFieldReports(prev => prev.map(o => o.key && o.key === unit.key ? {
        ...o,
        ...formValue,
        ..._ownerType,
        ...questionLength,
        ...Ques
      } : {
        ...o
      }));
      trigger();
    }
  }, [formValue]);
  useEffect(() => {
    var _formState$errors$con;
    if (Object.keys(errors).length && !_$1.isEqual(((_formState$errors$con = formState.errors[config.key]) === null || _formState$errors$con === void 0 ? void 0 : _formState$errors$con.type) || {}, errors)) {
      setError(config.key, {
        type: errors
      });
    } else if (!Object.keys(errors).length && formState.errors[config.key] && isErrors) {
      clearErrors(config.key);
    }
  }, [errors]);
  let ckeckingLocation = window.location.href.includes("renew-application-details");
  if (window.location.href.includes("edit-application-details")) ckeckingLocation = true;
  const getOptions = option => {
    let fieldoptions = [];
    option.split("/").map(op => {
      fieldoptions.push({
        i18nKey: `SCORE_${op}`,
        code: op
      });
    });
    return fieldoptions;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: "16px",
      maxWidth: "950px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "fieldInspectionWrapper"
  }, (allFieldReport === null || allFieldReport === void 0 ? void 0 : allFieldReport.length) > 1 ? /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(DeleteIcon$1, {
      style: {
        float: "right",
        position: "relative",
        bottom: "-6px"
      },
      fill: !(allFieldReport.length == 1) ? "#494848" : "#FAFAFA"
    }),
    style: {
      width: "100px",
      display: "inline",
      background: "black"
    },
    onClick: e => removeUnit(unit)
  }) : null, /*#__PURE__*/React__default.createElement(CardSectionHeader, null, (allFieldReport === null || allFieldReport === void 0 ? void 0 : allFieldReport.length) > 1 ? `${t("BPA_FI_REPORT")}-${index + 1}` : `${t("BPA_FI_REPORT")}`), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginTop: "0px",
      width: "100%"
    },
    className: "card-label-smaller"
  }, `${t("BPA_FI_DATE_LABEL")} * `), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "InspectionDate",
    rules: {
      required: t("REQUIRED_FIELD")
    },
    control: control,
    render: props => /*#__PURE__*/React__default.createElement(DatePicker, {
      date: props.value,
      name: "InspectionDate",
      onChange: props.onChange
    })
  }))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginTop: "0px",
      width: "100%"
    },
    className: "card-label-smaller"
  }, `${t("ES_COMMON_TIME")} * `), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    name: "InspectionTime",
    rules: {
      required: t("REQUIRED_FIELD")
    },
    control: control,
    render: props => /*#__PURE__*/React__default.createElement(TextInput$2, {
      name: "InspectionTime",
      type: "time",
      value: props.value,
      onChange: props.onChange
    })
  }))), /*#__PURE__*/React__default.createElement(CardSectionHeader, null, t("BPA_CHECK_LIST_DETAILS")), questionList && questionList.map((ob, ind) => /*#__PURE__*/React__default.createElement("div", {
    key: ind,
    className: "fieldInsepctionInsideWrapper",
    style: {
      maxWidth: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginRight: "30px",
      width: "100%"
    },
    className: "card-label-smaller"
  }, `${t(ob.question)}*`), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    control: control,
    name: `question_${ind}`,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    render: props => /*#__PURE__*/React__default.createElement(Dropdown, {
      className: "form-field",
      style: {
        width: "100%",
        maxWidth: "100%"
      },
      selected: getValues(`question${ind}`),
      disable: false,
      option: getOptions(ob.fieldType),
      select: e => {
        var _props$value;
        if ((props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.code) == (e === null || e === void 0 ? void 0 : e.code)) return true;
        props.onChange(e);
      },
      optionKey: "i18nKey",
      onBlur: props.onBlur,
      t: t
    })
  }))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      marginRight: "30px",
      width: "100%"
    },
    className: "card-label-smaller"
  }, t("BPA_ENTER_REMARKS")), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Controller, {
    control: control,
    name: `Remarks_${ind}`,
    defaultValue: unit === null || unit === void 0 ? void 0 : unit.uomValue,
    render: props => /*#__PURE__*/React__default.createElement(TextInput$2, {
      value: getValues(`Remarks${ind}`),
      onChange: e => {
        props.onChange(e);
      },
      onBlur: props.onBlur
    })
  }))))), /*#__PURE__*/React__default.createElement(CardSectionHeader, {
    style: {
      marginTop: "20px"
    }
  }, t("BPA_FIELD_INSPECTION_DOCUMENTS")), /*#__PURE__*/React__default.createElement(OBPSDocumentsEmp, {
    t: t,
    config: config,
    onSelect: onSelect,
    userType: userType,
    formData: formData,
    setError: setError,
    clearErrors: clearErrors,
    formState: formState,
    index: index,
    setFieldReports: setFieldReports,
    documentList: documentList
  }))));
};

const useInbox = ({
  tenantId,
  filters,
  config
}) => {
  var _Object$keys;
  return useQuery(["INBOX_DATA", tenantId, ...((_Object$keys = Object.keys(filters)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(e => filters === null || filters === void 0 ? void 0 : filters[e]))], () => InboxGeneral.Search({
    inbox: {
      ...filters
    }
  }), {
    ...config
  });
};

const useCommonInbox = ({
  tenantId,
  filters,
  config,
  userBusinessServices
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: userBusinessServices,
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...(sortOrder ? {
        sortOrder
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.name.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$business31, _application$business32, _application$ProcessI, _application$ProcessI2, _application$ProcessI3, _application$business33, _application$business34, _application$business35, _application$business36, _application$business37, _application$business38, _application$business39, _application$business40, _application$business41, _application$business42, _application$ProcessI4, _application$ProcessI5, _application$ProcessI6;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNo,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.businessService,
              status: application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : _application$business5.status,
              proposedActivity: application === null || application === void 0 ? void 0 : (_application$business6 = application.businessObject) === null || _application$business6 === void 0 ? void 0 : _application$business6.activityProposed,
              plotArea: (application === null || application === void 0 ? void 0 : (_application$business7 = application.businessObject) === null || _application$business7 === void 0 ? void 0 : _application$business7.plotArea) || (application === null || application === void 0 ? void 0 : (_application$business8 = application.businessObject) === null || _application$business8 === void 0 ? void 0 : (_application$business9 = _application$business8.descriptionOfLand) === null || _application$business9 === void 0 ? void 0 : _application$business9.landArea) || (application === null || application === void 0 ? void 0 : (_application$business10 = application.businessObject) === null || _application$business10 === void 0 ? void 0 : (_application$business11 = _application$business10.descriptionOfLand) === null || _application$business11 === void 0 ? void 0 : _application$business11.totalPlotArea),
              schemeName: application === null || application === void 0 ? void 0 : (_application$business12 = application.businessObject) === null || _application$business12 === void 0 ? void 0 : _application$business12.schemeName,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business13 = application.businessObject) === null || _application$business13 === void 0 ? void 0 : _application$business13.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : (_application$business15 = _application$business14.descriptionOfLand) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.khasraDetails) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16[0]) === null || _application$business17 === void 0 ? void 0 : _application$business17.plotNo),
              owner: application === null || application === void 0 ? void 0 : (_application$business18 = application.businessObject) === null || _application$business18 === void 0 ? void 0 : (_application$business19 = _application$business18.landInfo) === null || _application$business19 === void 0 ? void 0 : (_application$business20 = _application$business19.owners) === null || _application$business20 === void 0 ? void 0 : (_application$business21 = _application$business20[0]) === null || _application$business21 === void 0 ? void 0 : _application$business21.name,
              emailId: application === null || application === void 0 ? void 0 : (_application$business22 = application.businessObject) === null || _application$business22 === void 0 ? void 0 : (_application$business23 = _application$business22.landInfo) === null || _application$business23 === void 0 ? void 0 : (_application$business24 = _application$business23.owners) === null || _application$business24 === void 0 ? void 0 : (_application$business25 = _application$business24[0]) === null || _application$business25 === void 0 ? void 0 : _application$business25.emailId,
              applicationType: application === null || application === void 0 ? void 0 : (_application$business26 = application.businessObject) === null || _application$business26 === void 0 ? void 0 : _application$business26.applicationType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business27 = application.businessObject) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27.landInfo) === null || _application$business28 === void 0 ? void 0 : (_application$business29 = _application$business28.owners) === null || _application$business29 === void 0 ? void 0 : (_application$business30 = _application$business29[0]) === null || _application$business30 === void 0 ? void 0 : _application$business30.photo,
              location: application === null || application === void 0 ? void 0 : (_application$business31 = application.businessObject) === null || _application$business31 === void 0 ? void 0 : _application$business31.location1,
              registrationNo: application === null || application === void 0 ? void 0 : (_application$business32 = application.businessObject) === null || _application$business32 === void 0 ? void 0 : _application$business32.registrationNo,
              nextAction: application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : (_application$ProcessI2 = _application$ProcessI.nextActions) === null || _application$ProcessI2 === void 0 ? void 0 : (_application$ProcessI3 = _application$ProcessI2[0]) === null || _application$ProcessI3 === void 0 ? void 0 : _application$ProcessI3.action,
              department: application === null || application === void 0 ? void 0 : (_application$business33 = application.businessObject) === null || _application$business33 === void 0 ? void 0 : _application$business33.department,
              land_Id: application === null || application === void 0 ? void 0 : (_application$business34 = application.businessObject) === null || _application$business34 === void 0 ? void 0 : _application$business34.land_Id,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business35 = application.businessObject) === null || _application$business35 === void 0 ? void 0 : (_application$business36 = _application$business35.professionaldetails) === null || _application$business36 === void 0 ? void 0 : _application$business36.name) || (application === null || application === void 0 ? void 0 : (_application$business37 = application.businessObject) === null || _application$business37 === void 0 ? void 0 : (_application$business38 = _application$business37.professionalInformation) === null || _application$business38 === void 0 ? void 0 : _application$business38.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business39 = application.businessObject) === null || _application$business39 === void 0 ? void 0 : (_application$business40 = _application$business39.auditDetails) === null || _application$business40 === void 0 ? void 0 : _application$business40.lastModifiedTime,
              selectedUnit: application === null || application === void 0 ? void 0 : (_application$business41 = application.businessObject) === null || _application$business41 === void 0 ? void 0 : _application$business41.selectedUnit,
              isGovernmentBuilding: (application === null || application === void 0 ? void 0 : (_application$business42 = application.businessObject) === null || _application$business42 === void 0 ? void 0 : _application$business42.isGovernmentBuilding) === "yes",
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI4 = application.ProcessInstance) === null || _application$ProcessI4 === void 0 ? void 0 : (_application$ProcessI5 = _application$ProcessI4.assigner) === null || _application$ProcessI5 === void 0 ? void 0 : (_application$ProcessI6 = _application$ProcessI5.roles) === null || _application$ProcessI6 === void 0 ? void 0 : _application$ProcessI6.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const useNOCInbox = ({
  tenantId,
  filters,
  config,
  userBusinessServices
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  console.log("userInfoFromNOCInbox", Digit.UserService.getUser(), userBusinessServices);
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "noc-services",
      businessService: [userBusinessServices],
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...(sortOrder ? {
        sortOrder
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.name.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$ProcessI, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$ProcessI2, _application$ProcessI3, _application$ProcessI4, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$ProcessI5, _application$ProcessI6, _application$ProcessI7;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNo,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : _application$ProcessI.businessService,
              status: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.applicationStatus,
              owner: application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : (_application$business6 = _application$business5.landInfo) === null || _application$business6 === void 0 ? void 0 : (_application$business7 = _application$business6.owners) === null || _application$business7 === void 0 ? void 0 : (_application$business8 = _application$business7[0]) === null || _application$business8 === void 0 ? void 0 : _application$business8.name,
              applicationType: application === null || application === void 0 ? void 0 : (_application$business9 = application.businessObject) === null || _application$business9 === void 0 ? void 0 : _application$business9.applicationType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business10 = application.businessObject) === null || _application$business10 === void 0 ? void 0 : (_application$business11 = _application$business10.landInfo) === null || _application$business11 === void 0 ? void 0 : (_application$business12 = _application$business11.owners) === null || _application$business12 === void 0 ? void 0 : (_application$business13 = _application$business12[0]) === null || _application$business13 === void 0 ? void 0 : _application$business13.photo,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : _application$business14.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business15 = application.businessObject) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.descriptionOfLand) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16.khasraDetails) === null || _application$business17 === void 0 ? void 0 : (_application$business18 = _application$business17[0]) === null || _application$business18 === void 0 ? void 0 : _application$business18.plotNo),
              location: application === null || application === void 0 ? void 0 : (_application$business19 = application.businessObject) === null || _application$business19 === void 0 ? void 0 : _application$business19.location1,
              registrationNo: application === null || application === void 0 ? void 0 : (_application$business20 = application.businessObject) === null || _application$business20 === void 0 ? void 0 : _application$business20.registrationNo,
              nextAction: application === null || application === void 0 ? void 0 : (_application$ProcessI2 = application.ProcessInstance) === null || _application$ProcessI2 === void 0 ? void 0 : (_application$ProcessI3 = _application$ProcessI2.nextActions) === null || _application$ProcessI3 === void 0 ? void 0 : (_application$ProcessI4 = _application$ProcessI3[0]) === null || _application$ProcessI4 === void 0 ? void 0 : _application$ProcessI4.action,
              department: application === null || application === void 0 ? void 0 : (_application$business21 = application.businessObject) === null || _application$business21 === void 0 ? void 0 : _application$business21.department,
              land_Id: application === null || application === void 0 ? void 0 : (_application$business22 = application.businessObject) === null || _application$business22 === void 0 ? void 0 : _application$business22.land_Id,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business23 = application.businessObject) === null || _application$business23 === void 0 ? void 0 : (_application$business24 = _application$business23.professionaldetails) === null || _application$business24 === void 0 ? void 0 : _application$business24.name) || (application === null || application === void 0 ? void 0 : (_application$business25 = application.businessObject) === null || _application$business25 === void 0 ? void 0 : (_application$business26 = _application$business25.professionalInformation) === null || _application$business26 === void 0 ? void 0 : _application$business26.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business27 = application.businessObject) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27.auditDetails) === null || _application$business28 === void 0 ? void 0 : _application$business28.lastModifiedTime,
              sourceRefId: application === null || application === void 0 ? void 0 : (_application$business29 = application.businessObject) === null || _application$business29 === void 0 ? void 0 : _application$business29.sourceRefId,
              selectedUnit: application === null || application === void 0 ? void 0 : (_application$business30 = application.businessObject) === null || _application$business30 === void 0 ? void 0 : _application$business30.selectedUnit,
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI5 = application.ProcessInstance) === null || _application$ProcessI5 === void 0 ? void 0 : (_application$ProcessI6 = _application$ProcessI5.assigner) === null || _application$ProcessI6 === void 0 ? void 0 : (_application$ProcessI7 = _application$ProcessI6.roles) === null || _application$ProcessI7 === void 0 ? void 0 : _application$ProcessI7.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const useTPInbox = ({
  tenantId,
  filters,
  config
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "BPAREG",
      businessService: ["BPAREG"],
      assignee: "",
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      sortOrder: "DESC",
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.code.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$business31, _application$business32, _application$business33, _application$business34, _application$ProcessI, _application$ProcessI2, _application$ProcessI3, _application$ProcessI4, _application$ProcessI5;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNumber,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.businessService,
              locality: `${application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : (_application$business6 = _application$business5.tenantId) === null || _application$business6 === void 0 ? void 0 : (_application$business7 = _application$business6.toUpperCase()) === null || _application$business7 === void 0 ? void 0 : (_application$business8 = _application$business7.split(".")) === null || _application$business8 === void 0 ? void 0 : _application$business8.join("_")}_REVENUE_${application === null || application === void 0 ? void 0 : (_application$business9 = application.businessObject) === null || _application$business9 === void 0 ? void 0 : (_application$business10 = _application$business9.tenantId) === null || _application$business10 === void 0 ? void 0 : _application$business10.toUpperCase()}`,
              status: application === null || application === void 0 ? void 0 : (_application$business11 = application.businessObject) === null || _application$business11 === void 0 ? void 0 : _application$business11.status,
              approvalLetter: application === null || application === void 0 ? void 0 : (_application$business12 = application.businessObject) === null || _application$business12 === void 0 ? void 0 : _application$business12.approvalLetterUrl,
              registrationType: application === null || application === void 0 ? void 0 : (_application$business13 = application.businessObject) === null || _application$business13 === void 0 ? void 0 : _application$business13.registrationType,
              owner: application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : (_application$business15 = _application$business14.tradeLicenseDetail) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.owners) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16[0]) === null || _application$business17 === void 0 ? void 0 : _application$business17.name,
              dairyNo: application === null || application === void 0 ? void 0 : (_application$business18 = application.businessObject) === null || _application$business18 === void 0 ? void 0 : _application$business18.tcpDairyNumber,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business19 = application.businessObject) === null || _application$business19 === void 0 ? void 0 : _application$business19.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business20 = application.businessObject) === null || _application$business20 === void 0 ? void 0 : (_application$business21 = _application$business20.descriptionOfLand) === null || _application$business21 === void 0 ? void 0 : (_application$business22 = _application$business21.khasraDetails) === null || _application$business22 === void 0 ? void 0 : (_application$business23 = _application$business22[0]) === null || _application$business23 === void 0 ? void 0 : _application$business23.plotNo),
              applicationType: application === null || application === void 0 ? void 0 : (_application$business24 = application.businessObject) === null || _application$business24 === void 0 ? void 0 : _application$business24.licenseType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business25 = application.businessObject) === null || _application$business25 === void 0 ? void 0 : (_application$business26 = _application$business25.tradeLicenseDetail) === null || _application$business26 === void 0 ? void 0 : (_application$business27 = _application$business26.owners) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27[0]) === null || _application$business28 === void 0 ? void 0 : _application$business28.photo,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business29 = application.businessObject) === null || _application$business29 === void 0 ? void 0 : (_application$business30 = _application$business29.professionaldetails) === null || _application$business30 === void 0 ? void 0 : _application$business30.name) || (application === null || application === void 0 ? void 0 : (_application$business31 = application.businessObject) === null || _application$business31 === void 0 ? void 0 : (_application$business32 = _application$business31.professionalInformation) === null || _application$business32 === void 0 ? void 0 : _application$business32.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business33 = application.businessObject) === null || _application$business33 === void 0 ? void 0 : (_application$business34 = _application$business33.auditDetails) === null || _application$business34 === void 0 ? void 0 : _application$business34.lastModifiedTime,
              sla: Math.round((application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : _application$ProcessI.businesssServiceSla) / (24 * 60 * 60 * 1000)),
              stateSla: Math.round((application === null || application === void 0 ? void 0 : (_application$ProcessI2 = application.ProcessInstance) === null || _application$ProcessI2 === void 0 ? void 0 : _application$ProcessI2.stateSla) / (24 * 60 * 60 * 1000)),
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI3 = application.ProcessInstance) === null || _application$ProcessI3 === void 0 ? void 0 : (_application$ProcessI4 = _application$ProcessI3.assigner) === null || _application$ProcessI4 === void 0 ? void 0 : (_application$ProcessI5 = _application$ProcessI4.roles) === null || _application$ProcessI5 === void 0 ? void 0 : _application$ProcessI5.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const isMobile = window.innerWidth <= 768;
const nocDepartmentRoles = ["Acquisition_Section_Incharge", "Nazul_Section_Incharge", "Improvement_Trust_Incharge", "Property_Section_Incharge", "Urban_Ceiling_Incharge", "Tehsildar", "AAI_General_Manager", "Army_Airforce_Station_Officer", "Fire_Chief_Officer", "Irrigation_Executive_Officer", "UPMRC_MD", "Forest_District_Officer", "Railways_Section_Engineer", "Power_Executive_Engineer", "NHAI_Project_Director", "PWD_Executive_Engineer", "ASI_Superintendent", "Jail_Superintendent", "ULB_Nagar_Aayukt", "Environment_UPPCB_Secretary", "Security_ADG", "UPAVP_Chief_Architect"];
const fetchApplications = (tenantId, userBusinessServices, officerRole) => {
  var _sortParams$, _sortParams$2, _sortParams$3, _sortParams$4;
  const [sortParams, setSortParams] = useState([{
    id: "applicationDate",
    desc: false
  }]);
  const [pageSize, setPageSize] = useState(3000);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const paginationParams = isMobile ? {
    limit: 100,
    offset: 0,
    sortBy: (_sortParams$ = sortParams[0]) === null || _sortParams$ === void 0 ? void 0 : _sortParams$.id,
    sortOrder: (_sortParams$2 = sortParams[0]) !== null && _sortParams$2 !== void 0 && _sortParams$2.desc ? "DESC" : "ASC"
  } : {
    limit: pageSize,
    offset: pageOffset,
    sortBy: (_sortParams$3 = sortParams[0]) === null || _sortParams$3 === void 0 ? void 0 : _sortParams$3.id,
    sortOrder: (_sortParams$4 = sortParams[0]) !== null && _sortParams$4 !== void 0 && _sortParams$4.desc ? "DESC" : "ASC"
  };
  const isNocDepartment = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => nocDepartmentRoles.includes(role.code));
  console.log("isNOCDepartment", isNocDepartment, userBusinessServices);
  const {
    isFetching,
    isLoading: hookLoading,
    searchResponseKey,
    data,
    searchFields,
    ...rest
  } = hasAuthorizedRoles ? useTPInbox({
    tenantId,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }) : isNocDepartment ? useNOCInbox({
    tenantId,
    userBusinessServices,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {
      enabled: !!userBusinessServices,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }) : useCommonInbox({
    tenantId,
    userBusinessServices,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams,
      uuid: {
        code: "ASSIGNED_TO_ME"
      }
    },
    config: {
      enabled: !!userBusinessServices,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  });
  return {
    applications: data || [],
    isOfficerLTP: hasAuthorizedRoles,
    isFetching
  };
};

const isAutoForwardedRecord = item => {
  var _item$raw;
  if (item !== null && item !== void 0 && item.isAutoForwarded) return true;
  const processInstance = (item === null || item === void 0 ? void 0 : item.ProcessInstance) || (item === null || item === void 0 ? void 0 : item.processInstance) || (item === null || item === void 0 ? void 0 : (_item$raw = item.raw) === null || _item$raw === void 0 ? void 0 : _item$raw.ProcessInstance);
  const assigner = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.assigner) || (item === null || item === void 0 ? void 0 : item.assigner);
  if ((assigner === null || assigner === void 0 ? void 0 : assigner.userName) === "WF_ADMIN_ESCLATE" || (assigner === null || assigner === void 0 ? void 0 : assigner.name) === "Admin Escalation") return true;
  const roles = assigner === null || assigner === void 0 ? void 0 : assigner.roles;
  if (Array.isArray(roles)) {
    return roles.some(role => {
      const code = typeof role === "string" ? role : role === null || role === void 0 ? void 0 : role.code;
      const name = typeof role === "object" ? role === null || role === void 0 ? void 0 : role.name : "";
      return code === "WF_ADMIN_ESCLATE" || name === "Admin Escalation";
    });
  }
  return false;
};
const EmpReceivedFiles = () => {
  let user = Digit.UserService.getUser();
  const {
    businessServices: userBusinessServices,
    tenantId,
    count,
    officerRole
  } = useSelector(state => state.empInbox);
  const history = useHistory();
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "Authorized_Officer");
  const {
    applications,
    isOfficerLTP,
    isFetching
  } = fetchApplications(tenantId, userBusinessServices, officerRole);
  console.log("applicationsFromEmpReceivedFiles", applications, officerRole);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "applicationNo", "ownerName", "serviceType", "proposedActivity", "plotArea", "plotNo", "status", "recievedDate"]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {
    t
  } = useTranslation();
  const [filters, setFilters] = useState({
    applicationNo: "",
    landId: "",
    ownerName: "",
    applicationType: "",
    status: "",
    date: "",
    unit: ""
  });
  const tabsData = [{
    label: "Landuse",
    value: "Landuse"
  }, {
    label: "Map Submission",
    value: "Map Submission"
  }, {
    label: "Comp.",
    value: "Comp."
  }, {
    label: "Plinth",
    value: "Plinth"
  }, {
    label: "PFAR",
    value: "PFAR"
  }, {
    label: "Completion",
    value: "Completion"
  }, {
    label: "Gov. Bldg.",
    value: "Gov. Bldg."
  }, {
    label: "DSC Pending",
    value: "DSC Pending"
  }, {
    label: "Obj. Suggestion",
    value: "Obj. Suggestion"
  }, {
    label: "Auto Forwarded",
    value: "Auto Forwarded"
  }];
  const allColumns = [{
    id: "srNo",
    label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
    filterable: false,
    width: "5%",
    minWidth: "5%"
  }, {
    id: "applicationNo",
    label: t("FASTPAS.GLOBAL.APPLICATION.NUMBER"),
    filterable: true,
    sortable: true,
    render: item => {
      const isAutoForwarded = isAutoForwardedRecord(item);
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "6px",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        onClick: () => handleTakeAction(item)
      }, (item === null || item === void 0 ? void 0 : item.applicationId) || "-"), isAutoForwarded && /*#__PURE__*/React__default.createElement("span", {
        style: {
          backgroundColor: "#d97706",
          color: "#ffffff",
          fontSize: "9px",
          fontWeight: 700,
          padding: "1px 5px",
          borderRadius: "3px",
          letterSpacing: "0.3px",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
          display: "inline-block",
          lineHeight: "1.3",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
        },
        title: "Auto Forwarded (Admin Escalation)"
      }, "Auto Forwarded"));
    },
    exportValue: item => (item === null || item === void 0 ? void 0 : item.applicationId) || "-",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "ltpName",
    label: "LTP Name",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.ltpName) || "-",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "ownerName",
    label: "Name",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.owner) || "-",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "serviceType",
    label: "Service Type",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.applicationType) || "Map Submission",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "natureOfConstruction",
    label: "Case Type",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$additionalDetai;
      return (item === null || item === void 0 ? void 0 : item.natureOfConstruction) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.natureOfConstruction) || "-";
    },
    exportValue: item => {
      var _item$additionalDetai2;
      return (item === null || item === void 0 ? void 0 : item.natureOfConstruction) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai2 = item.additionalDetails) === null || _item$additionalDetai2 === void 0 ? void 0 : _item$additionalDetai2.natureOfConstruction) || "-";
    },
    width: "12%",
    minWidth: "12%"
  }, {
    id: "proposedActivity",
    label: "Proposed Activity",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.proposedActivity) || "Residential",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "plotArea",
    label: "Plot Area",
    filterable: true,
    sortable: true,
    render: item => item === null || item === void 0 ? void 0 : item.plotArea,
    width: "8%",
    minWidth: "8%"
  }, {
    id: "schemeName",
    label: "Scheme Name",
    filterable: true,
    sortable: true,
    render: item => item === null || item === void 0 ? void 0 : item.schemeName,
    width: "12%",
    minWidth: "12%"
  }, {
    id: "plotNo",
    label: "Plot No",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.plotNo) || "N/A",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "unit",
    label: "Unit",
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.selectedUnit) || "-",
    exportValue: item => (item === null || item === void 0 ? void 0 : item.selectedUnit) || "-",
    width: "10%",
    minWidth: "5%"
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    render: item => t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-",
    width: "12%",
    minWidth: "12%"
  }, {
    id: "applicationDate",
    label: "Submission Date",
    filterable: false,
    sortable: true,
    render: item => convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.date) || "-",
    width: "8%",
    minWidth: "8%"
  }, {
    id: "recievedDate",
    label: "Received Date",
    filterable: false,
    sortable: true,
    render: item => convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.recievedTime) || "-",
    width: "8%",
    minWidth: "8%"
  }];
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$applicationId, _item$ltpName, _item$owner, _item$applicationType, _item$proposedActivit, _item$schemeName, _item$plotNo, _item$selectedUnit, _t;
        switch (orderBy) {
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationId = item.applicationId) === null || _item$applicationId === void 0 ? void 0 : _item$applicationId.toLowerCase()) || "";
          case "ltpName":
            return (item === null || item === void 0 ? void 0 : (_item$ltpName = item.ltpName) === null || _item$ltpName === void 0 ? void 0 : _item$ltpName.toLowerCase()) || "";
          case "ownerName":
            return (item === null || item === void 0 ? void 0 : (_item$owner = item.owner) === null || _item$owner === void 0 ? void 0 : _item$owner.toLowerCase()) || "";
          case "serviceType":
            return (item === null || item === void 0 ? void 0 : (_item$applicationType = item.applicationType) === null || _item$applicationType === void 0 ? void 0 : _item$applicationType.toLowerCase()) || "";
          case "proposedActivity":
            return (item === null || item === void 0 ? void 0 : (_item$proposedActivit = item.proposedActivity) === null || _item$proposedActivit === void 0 ? void 0 : _item$proposedActivit.toLowerCase()) || "";
          case "plotArea":
            return Number(item === null || item === void 0 ? void 0 : item.plotArea) || 0;
          case "schemeName":
            return (item === null || item === void 0 ? void 0 : (_item$schemeName = item.schemeName) === null || _item$schemeName === void 0 ? void 0 : _item$schemeName.toLowerCase()) || "";
          case "plotNo":
            return (item === null || item === void 0 ? void 0 : (_item$plotNo = item.plotNo) === null || _item$plotNo === void 0 ? void 0 : _item$plotNo.toLowerCase()) || "";
          case "unit":
            return (item === null || item === void 0 ? void 0 : (_item$selectedUnit = item.selectedUnit) === null || _item$selectedUnit === void 0 ? void 0 : _item$selectedUnit.toLowerCase()) || "";
          case "status":
            return ((_t = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : item.date) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (typeof aValue === "number" && typeof bValue === "number") {
        return order === "desc" ? bValue - aValue : aValue - bValue;
      }
      if (order === "desc") {
        return String(bValue).localeCompare(String(aValue));
      } else {
        return String(aValue).localeCompare(String(bValue));
      }
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (applications === null || applications === void 0 ? void 0 : applications.table) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        return matchesSearch(item === null || item === void 0 ? void 0 : item.owner, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationId, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.land_Id, globalSearch) || matchesSearch(t(item === null || item === void 0 ? void 0 : item.applicationType), globalSearch) || matchesSearch(t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`), globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.date), globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.selectedUnit, globalSearch) || isAutoForwardedRecord(item) && matchesSearch("Auto Forwarded Escalated", globalSearch);
      });
    }
    if (filters.ownerName) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.owner, filters.ownerName));
    }
    if (filters.landId) {
      filteredData = filteredData.filter(item => {
        var _item$land_Id;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$land_Id = item.land_Id) === null || _item$land_Id === void 0 ? void 0 : _item$land_Id.toString(), filters.landId);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationId, filters.applicationNo));
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => matchesSearch(t(item === null || item === void 0 ? void 0 : item.applicationType), filters.applicationType));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => matchesSearch(t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`), filters.status));
    }
    if (filters.unit) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.selectedUnit, filters.unit));
    }
    return filteredData;
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const filteredData = getFilteredData();
  const sortedData = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return [];
    return filteredData.slice().sort(getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);
  console.log("sortedData291", sortedData, filteredData, order, orderBy);
  const isApplyForDSCPresent = status => {
    if (status.includes("_AFTER_PAYMENT")) {
      return true;
    } else return false;
  };
  const filterData = useMemo(() => {
    return {
      Landuse: sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_LANDUSE"),
      "Map Submission": sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_MAP"),
      "Comp.": sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_COMPOUNDING"),
      Plinth: sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_PLINTH"),
      PFAR: sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_PURCHASABLE_FAR"),
      Completion: sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_COMPLETION"),
      "Gov. Bldg.": sortedData.filter(item => item === null || item === void 0 ? void 0 : item.isGovernmentBuilding),
      "DSC Pending": sortedData.filter(item => {
        var _item$status;
        return (item === null || item === void 0 ? void 0 : (_item$status = item.status) === null || _item$status === void 0 ? void 0 : _item$status.startsWith("APPLY_FOR_DSC")) || isApplyForDSCPresent(item === null || item === void 0 ? void 0 : item.status);
      }),
      "Obj. Suggestion": sortedData.filter(item => (item === null || item === void 0 ? void 0 : item.applicationType) === "FORM_PRESSRELEASE"),
      "Auto Forwarded": sortedData.filter(item => isAutoForwardedRecord(item))
    };
  }, [sortedData]);
  const filteredAndSortedData = useMemo(() => {
    if (!selectedAction) {
      return sortedData;
    }
    return filterData[selectedAction] || sortedData;
  }, [selectedAction, filterData, sortedData]);
  const paginatedData = useMemo(() => {
    return filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredAndSortedData, page, rowsPerPage]);
  const handleTakeAction = item => {
    var _Digit, _Digit2, _Digit3;
    console.log("itemFromTakeAction", item, item === null || item === void 0 ? void 0 : item.businessService);
    const appNo = item === null || item === void 0 ? void 0 : item.applicationId;
    if (!appNo) {
      console.warn("No application number found", item);
      return;
    }
    const businessService = (item === null || item === void 0 ? void 0 : item.businessService) || "";
    const applicationType = (item === null || item === void 0 ? void 0 : item.applicationType) || "";
    const isStakeholder = businessService === "BPAREG" || (applicationType === null || applicationType === void 0 ? void 0 : applicationType.includes("STAKEHOLDER"));
    const isLandUse = businessService.startsWith("BPA_LANDUSE_DA") || businessService.startsWith("BPA_LANDUSE_AVP") || businessService.startsWith("BPA_KYP") || applicationType === "FORM_LANDUSE";
    const isLandUseConversion = businessService.includes("LANDUSECONVERSION") || businessService.includes("LANDUSE_CONVERSION") || applicationType === "FORM_LANDUSECONVERSION";
    const isPressRelease = businessService === "BPA_PRESS_RELEASE" || applicationType === "FORM_PRESSRELEASE";
    const isFar = businessService === "BPA_FAR_DA" || businessService === "BPA_FAR_AVP" || businessService === "BPA_PURCHASEFAR_DA" || businessService === "BPA_PURCHASEFAR_AVP" || applicationType === "FORM_PURCHASABLE_FAR" || applicationType === "FORM_FAR";
    const isNoc = businessService.startsWith("BPA_NOC") || applicationType === "FORM_NOC";
    (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("isDocValidated");
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("isNotingValidated");
    (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("isSitePhotoUploaded");
    if (isStakeholder) {
      Digit.SessionStorage.del("EMP_LTP");
      history.push(`/digit-ui/employee/obps/professional/${appNo}`);
    } else if (isLandUse) {
      Digit.SessionStorage.del("EMP_LANDUSE");
      history.push(`/digit-ui/employee/obps/application/formLandUse/${appNo}`);
    } else if (isLandUseConversion) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/FORM_LANDUSECONVERSION/${appNo}`);
    } else if (isPressRelease) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/FORM_PRESSRELEASE/${appNo}`);
    } else if (isFar) {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${appNo}`);
    } else if (isNoc) {
      history.push(`/digit-ui/employee/obps/application/NOC/${appNo}`);
    } else {
      Digit.SessionStorage.del("EMP_MAPSUB");
      history.push(`/digit-ui/employee/obps/application/MAP_SUB/${appNo}`);
    }
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const isNocDepartment = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => nocDepartmentRoles.includes(role.code));
  console.log("filteredAndSortedData", filterData, filteredAndSortedData, paginatedData, selectedAction);
  const handleExcelDownload = () => {
    const exportColumns = isNocDepartment ? columns : allColumns;
    const exportData = filteredData.map((app, idx) => {
      const row = {};
      exportColumns.forEach(col => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "Received Files");
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  if (isFetching) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "16px",
      padding: "12px",
      background: "#fff",
      border: "1px solid #ddd",
      borderRadius: "6px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "8px",
      flexWrap: "wrap",
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "emp-table-caption",
    style: {
      margin: 0,
      padding: 0,
      width: "auto",
      flex: "0 0 auto",
      textAlign: "left"
    }
  }, t("FASTPAS.FILES.RECEIVED.TEXT")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length === allColumns.length ? "All" : selectedColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleExcelDownload,
    title: "Export to Excel",
    style: {
      height: "35px",
      padding: "5px 0px",
      marginRight: "8px"
    },
    disabled: filteredData.length === 0
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    style: {
      fontSize: "20px",
      color: "rgb(85 108 214)"
    }
  })))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "risk-type-bar",
    style: {
      display: "flex",
      flexWrap: "nowrap",
      overflowX: "auto",
      gap: "8px",
      marginBottom: "12px",
      justifyContent: "flex-start"
    }
  }, tabsData.map(tab => {
    var _filterData$tab$value, _filterData$tab$value2, _filterData$tab$value3;
    return /*#__PURE__*/React__default.createElement("button", {
      key: tab.value,
      disabled: ((_filterData$tab$value = filterData[tab.value]) === null || _filterData$tab$value === void 0 ? void 0 : _filterData$tab$value.length) === 0,
      style: {
        flexShrink: 0,
        whiteSpace: "nowrap",
        cursor: ((_filterData$tab$value2 = filterData[tab.value]) === null || _filterData$tab$value2 === void 0 ? void 0 : _filterData$tab$value2.length) === 0 ? "not-allowed" : "pointer"
      },
      className: `risk-type-button ${selectedAction === tab.value ? "active" : ""}`,
      onClick: () => setSelectedAction(prev => prev === tab.value ? "" : tab.value)
    }, tab.label, " ", /*#__PURE__*/React__default.createElement("span", {
      className: "count"
    }, "(", ((_filterData$tab$value3 = filterData[tab.value]) === null || _filterData$tab$value3 === void 0 ? void 0 : _filterData$tab$value3.length) || 0, ")"));
  })), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "table-container",
    sx: {
      width: "100%",
      overflowX: "auto",
      overflowY: "visible",
      border: "1px solid #c9d3dd",
      borderRadius: "4px"
    }
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    className: "application-table",
    sx: {
      width: "100%",
      minWidth: "1400px",
      tableLayout: "auto",
      borderCollapse: "collapse",
      "& th, & td": {
        boxSizing: "border-box",
        padding: "12px 16px",
        border: "1px solid #ddd",
        whiteSpace: "normal"
      },
      "& td": {
        overflowWrap: "anywhere",
        wordBreak: "break-word"
      },
      "& th": {
        backgroundColor: "#176082",
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center",
        verticalAlign: "middle",
        overflowWrap: "normal",
        wordBreak: "normal"
      },
      "& tbody tr:nth-of-type(even)": {
        backgroundColor: "#eaeaea"
      },
      "& tbody tr:nth-of-type(odd)": {
        backgroundColor: "#f9f9f9"
      },
      "& tbody tr:hover": {
        backgroundColor: "#e0f7fa"
      }
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("th", {
    key: column.id,
    style: {
      minWidth: column.minWidth || "120px",
      width: column.width || "auto"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "4px",
      flexWrap: "wrap"
    }
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  }))))), /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    style: {
      minWidth: column.minWidth || "120px",
      width: column.width || "auto",
      backgroundColor: "#eaeaea",
      padding: "8px 16px"
    }
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    fullWidth: true,
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "black"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      width: "100%",
      minWidth: "80px",
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem",
        minWidth: 0
      }
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    style: {
      textAlign: "center"
    }
  }, "No records found")) : paginatedData.map((item, index) => {
    const isAutoForwarded = isAutoForwardedRecord(item);
    return /*#__PURE__*/React__default.createElement("tr", {
      hover: true,
      key: index,
      title: isAutoForwarded ? "Auto Forwarded (Admin Escalation)" : undefined
    }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
      key: `${index}-${column.id}`
    }, column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: (filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.length) || 0,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50]
  }));
};

const PREDEFINED_ROLES$1 = [{
  label: "Architect",
  value: "Architect"
}, {
  label: "Structural Engineer",
  value: "Structural Engineer"
}, {
  label: "Graduate Civil Engineer",
  value: "Graduate Civil Engineer"
}, {
  label: "Supervisor",
  value: "Supervisor"
}, {
  label: "Town Planner",
  value: "Town Planner"
}, {
  label: "Landscape Architect",
  value: "Landscape Architect"
}, {
  label: "Urban Designer",
  value: "Urban Designer"
}, {
  label: "Engineers for Utility Services",
  value: "Engineers for Utility Services"
}];
const getItemRole$1 = item => {
  var _item$additionalDetai, _item$businessObject;
  return (item === null || item === void 0 ? void 0 : item.registrationType) || (item === null || item === void 0 ? void 0 : item.role) || (item === null || item === void 0 ? void 0 : (_item$additionalDetai = item.additionalDetails) === null || _item$additionalDetai === void 0 ? void 0 : _item$additionalDetai.registrationType) || (item === null || item === void 0 ? void 0 : (_item$businessObject = item.businessObject) === null || _item$businessObject === void 0 ? void 0 : _item$businessObject.registrationType) || "";
};
const matchesRole$1 = (itemRole, targetRole) => {
  if (!itemRole || !targetRole) return false;
  const cleanItem = String(itemRole).trim().toLowerCase();
  const cleanTarget = String(targetRole).trim().toLowerCase();
  if (cleanItem === cleanTarget) return true;
  if (cleanItem.split(".")[0].trim() === cleanTarget) return true;
  return false;
};
const isAutoForwardedRecord$1 = item => {
  var _item$ProcessInstance, _item$ProcessInstance2;
  if (item !== null && item !== void 0 && item.isAutoForwarded) return true;
  const roles = item === null || item === void 0 ? void 0 : (_item$ProcessInstance = item.ProcessInstance) === null || _item$ProcessInstance === void 0 ? void 0 : (_item$ProcessInstance2 = _item$ProcessInstance.assigner) === null || _item$ProcessInstance2 === void 0 ? void 0 : _item$ProcessInstance2.roles;
  if (Array.isArray(roles)) {
    return roles.some(role => {
      const code = typeof role === "string" ? role : role === null || role === void 0 ? void 0 : role.code;
      const name = typeof role === "object" ? role === null || role === void 0 ? void 0 : role.name : "";
      return code === "WF_ADMIN_ESCLATE" || name === "Admin Escalation";
    });
  }
  return false;
};
const NodalReceievedFiles = () => {
  let user = Digit.UserService.getUser();
  const {
    businessServices: userBusinessServices,
    tenantId,
    count,
    officerRole
  } = useSelector(state => state.empInbox);
  const history = useHistory();
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "Authorized_Officer");
  const {
    applications,
    isOfficerLTP,
    isFetching
  } = fetchApplications(tenantId, userBusinessServices, officerRole);
  console.log("applicationsFromEmpReceivedFiles", applications, officerRole);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "applicationNo", "ownerName", "applicationType", "status", "applicationDate", "paymentReceipt", "approvalLetter", "role"]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {
    t
  } = useTranslation();
  const isNodalOfficerAwas = useMemo(() => {
    var _Digit$UserService$ge, _Digit$UserService$ge2;
    const rolesFromRedux = officerRole || [];
    const rolesFromUser = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.roles) || [];
    const allRoles = [...rolesFromRedux, ...rolesFromUser];
    return allRoles.some(role => (role === null || role === void 0 ? void 0 : role.code) === "NODAL_OFFICER_AWAS" || (role === null || role === void 0 ? void 0 : role.code) === "Nodal Officer" || (role === null || role === void 0 ? void 0 : role.name) === "Nodal Officer AWAS Bandhu" || typeof (role === null || role === void 0 ? void 0 : role.name) === "string" && role.name.toLowerCase().includes("nodal officer awas"));
  }, [officerRole]);
  const roleTabsData = useMemo(() => {
    const tabs = [...PREDEFINED_ROLES$1];
    const knownValues = new Set(PREDEFINED_ROLES$1.map(r => r.value.toLowerCase()));
    const rawList = (applications === null || applications === void 0 ? void 0 : applications.table) || [];
    rawList.forEach(item => {
      const role = getItemRole$1(item);
      if (role && role !== "-" && role !== "N/A") {
        const normalized = role.split(".")[0].trim();
        if (normalized && !knownValues.has(normalized.toLowerCase())) {
          knownValues.add(normalized.toLowerCase());
          tabs.push({
            label: normalized,
            value: normalized
          });
        }
      }
    });
    return tabs;
  }, [applications]);
  function getApprovalLetter(item) {
    const pdfUrl = item === null || item === void 0 ? void 0 : item.approvalLetter;
    window.open(pdfUrl, "_blank");
  }
  const [filters, setFilters] = useState({
    applicationNo: "",
    landId: "",
    ownerName: "",
    applicationType: "",
    status: "",
    date: "",
    role: ""
  });
  const allColumns = [{
    id: "srNo",
    label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
    filterable: false,
    width: "5%"
  }, {
    id: "applicationNo",
    label: t("FASTPAS.GLOBAL.APPLICATION.NUMBER"),
    filterable: true,
    sortable: true,
    render: item => {
      console.log("itemFromApplicationNo", item);
      const isAutoForwarded = isAutoForwardedRecord$1(item);
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: "6px",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React__default.createElement("a", {
        onClick: () => handleTakeAction(item)
      }, (item === null || item === void 0 ? void 0 : item.applicationId) || "-"), isAutoForwarded && /*#__PURE__*/React__default.createElement("span", {
        style: {
          backgroundColor: "#d97706",
          color: "#ffffff",
          fontSize: "9px",
          fontWeight: 700,
          padding: "1px 5px",
          borderRadius: "3px",
          letterSpacing: "0.3px",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
          display: "inline-block",
          lineHeight: "1.3",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
        },
        title: "Auto Forwarded (Admin Escalation)"
      }, "Auto Forwarded"));
    },
    exportValue: item => (item === null || item === void 0 ? void 0 : item.applicationId) || "-",
    width: "10%"
  }, {
    id: "ownerName",
    label: t("FASTPAS.GLOBAL.APPLICANT.NAME.TEXT"),
    filterable: true,
    sortable: true,
    render: item => (item === null || item === void 0 ? void 0 : item.owner) || "-",
    width: "10%"
  }, {
    id: "applicationType",
    label: t("FASTPAS.GLOBAL.SERVICE.TYPE"),
    filterable: true,
    sortable: true,
    render: item => t(item === null || item === void 0 ? void 0 : item.applicationType) || "-",
    width: "10%"
  }, {
    id: "status",
    label: t("FASTPAS.GLOBAL.APPLICATION.STATUS"),
    filterable: true,
    sortable: true,
    render: item => t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || "-",
    width: "13%"
  }, {
    id: "applicationDate",
    label: t("FASTPAS.GLOBAL.APPLICATION.DATE"),
    filterable: false,
    sortable: true,
    render: item => convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.date) || "-",
    width: "10%"
  }, {
    id: "paymentReceipt",
    label: t("FASTPAS.GLOBAL.PAYMENT.RECIEPT.TEXT"),
    filterable: false,
    sortable: false,
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-receipt"
    }, (item === null || item === void 0 ? void 0 : item.registrationType) !== "Architect" && ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_ND_OFF_AWAS" || (item === null || item === void 0 ? void 0 : item.status) === "FORWARD_TO_NODAL") ? /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => {
        history.push({
          pathname: `/digit-ui/citizen/obps/tradelicence/payment/${item === null || item === void 0 ? void 0 : item.applicationId}/up`
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, t("FASTPAS.GLOBAL.RECEIPT.TEXT"))) : "N/A"),
    width: "10%"
  }, {
    id: "approvalLetter",
    label: t("FASTPAS.GLOBAL.APPROVAL.LETTER"),
    filterable: false,
    sortable: false,
    render: item => /*#__PURE__*/React__default.createElement("td", {
      className: "td-approval"
    }, ((item === null || item === void 0 ? void 0 : item.status) === "APPROVED" || (item === null || item === void 0 ? void 0 : item.status) === "APPLY_FOR_DSC") && /*#__PURE__*/React__default.createElement(Button$2, {
      size: "small",
      className: "btn-table-action",
      variant: "contained",
      color: "primary",
      onClick: () => getApprovalLetter(item)
    }, /*#__PURE__*/React__default.createElement("span", null, t("FASTPAS.GLOBAL.VIEW.TEXT")))),
    width: "10%"
  }, {
    id: "role",
    label: t("FASTPAS.GLOBAL.USER.ROLE"),
    filterable: true,
    sortable: true,
    render: item => getItemRole$1(item) || "-",
    width: "10%"
  }];
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$applicationId, _item$land_Id, _item$owner, _item$applicationType, _t, _getItemRole;
        switch (orderBy) {
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationId = item.applicationId) === null || _item$applicationId === void 0 ? void 0 : _item$applicationId.toLowerCase()) || "";
          case "landId":
            return (item === null || item === void 0 ? void 0 : (_item$land_Id = item.land_Id) === null || _item$land_Id === void 0 ? void 0 : _item$land_Id.toLowerCase()) || "";
          case "ownerName":
            return (item === null || item === void 0 ? void 0 : (_item$owner = item.owner) === null || _item$owner === void 0 ? void 0 : _item$owner.toLowerCase()) || "";
          case "applicationType":
            return (item === null || item === void 0 ? void 0 : (_item$applicationType = item.applicationType) === null || _item$applicationType === void 0 ? void 0 : _item$applicationType.toLowerCase()) || "";
          case "status":
            return ((_t = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          case "role":
            return ((_getItemRole = getItemRole$1(item)) === null || _getItemRole === void 0 ? void 0 : _getItemRole.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : item.date) || 0;
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = (applications === null || applications === void 0 ? void 0 : applications.table) || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        return matchesSearch(item === null || item === void 0 ? void 0 : item.owner, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationId, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.land_Id, globalSearch) || matchesSearch(t(item === null || item === void 0 ? void 0 : item.applicationType), globalSearch) || matchesSearch(t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`), globalSearch) || matchesSearch(getItemRole$1(item), globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : item.date), globalSearch);
      });
    }
    if (filters.ownerName) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.owner, filters.ownerName));
    }
    if (filters.landId) {
      filteredData = filteredData.filter(item => {
        var _item$land_Id2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$land_Id2 = item.land_Id) === null || _item$land_Id2 === void 0 ? void 0 : _item$land_Id2.toString(), filters.landId);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationId, filters.applicationNo));
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => matchesSearch(t(item === null || item === void 0 ? void 0 : item.applicationType), filters.applicationType));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => matchesSearch(t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`), filters.status));
    }
    if (filters.role) {
      filteredData = filteredData.filter(item => matchesSearch(getItemRole$1(item), filters.role));
    }
    return filteredData;
  };
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const filteredData = getFilteredData();
  const sortedData = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return [];
    return filteredData.slice().sort(getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);
  const filterRoleData = useMemo(() => {
    const roleMap = {};
    roleTabsData.forEach(tab => {
      roleMap[tab.value] = (sortedData || []).filter(item => matchesRole$1(getItemRole$1(item), tab.value));
    });
    return roleMap;
  }, [sortedData, roleTabsData]);
  const filteredAndSortedData = useMemo(() => {
    if (!selectedRole) {
      return sortedData;
    }
    return filterRoleData[selectedRole] || sortedData;
  }, [selectedRole, filterRoleData, sortedData]);
  const paginatedData = useMemo(() => {
    return filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredAndSortedData, page, rowsPerPage]);
  const handleTakeAction = item => {
    var _Digit, _Digit2, _Digit3, _Digit4, _Digit5, _Digit6, _Digit7, _Digit8, _Digit9, _Digit10, _Digit11, _Digit12, _Digit13, _Digit14, _Digit15, _item$businessService;
    console.log("itemFromTakeAction", item, item === null || item === void 0 ? void 0 : item.businessService);
    switch (item === null || item === void 0 ? void 0 : item.businessService) {
      case "BPAREG":
        Digit.SessionStorage.del("EMP_LTP");
        (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("isDocValidated");
        (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.del("isNotingValidated");
        (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.del("isSitePhotoUploaded");
        history.push(`/digit-ui/employee/obps/professional/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        break;
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        Digit.SessionStorage.del("EMP_MAPSUB");
        (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.del("isDocValidated");
        (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.del("isNotingValidated");
        (_Digit6 = Digit) === null || _Digit6 === void 0 ? void 0 : _Digit6.SessionStorage.del("isSitePhotoUploaded");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        break;
      case "BPA_MAPPLINTH_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        (_Digit7 = Digit) === null || _Digit7 === void 0 ? void 0 : _Digit7.SessionStorage.del("isDocValidated");
        (_Digit8 = Digit) === null || _Digit8 === void 0 ? void 0 : _Digit8.SessionStorage.del("isNotingValidated");
        (_Digit9 = Digit) === null || _Digit9 === void 0 ? void 0 : _Digit9.SessionStorage.del("isSitePhotoUploaded");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        break;
      case "BPA_PURCHASEFAR_DA":
      case "BPA_PURCHASEFAR_AVP":
        Digit.SessionStorage.del("EMP_MAPSUB");
        (_Digit10 = Digit) === null || _Digit10 === void 0 ? void 0 : _Digit10.SessionStorage.del("isDocValidated");
        (_Digit11 = Digit) === null || _Digit11 === void 0 ? void 0 : _Digit11.SessionStorage.del("isNotingValidated");
        (_Digit12 = Digit) === null || _Digit12 === void 0 ? void 0 : _Digit12.SessionStorage.del("isSitePhotoUploaded");
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
      case "BPA_KYP_DA":
        Digit.SessionStorage.del("EMP_LANDUSE");
        (_Digit13 = Digit) === null || _Digit13 === void 0 ? void 0 : _Digit13.SessionStorage.del("isDocValidated");
        (_Digit14 = Digit) === null || _Digit14 === void 0 ? void 0 : _Digit14.SessionStorage.del("isNotingValidated");
        (_Digit15 = Digit) === null || _Digit15 === void 0 ? void 0 : _Digit15.SessionStorage.del("isSitePhotoUploaded");
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        break;
      default:
        if (item !== null && item !== void 0 && (_item$businessService = item.businessService) !== null && _item$businessService !== void 0 && _item$businessService.startsWith("BPA_NOC")) {
          history.push(`/digit-ui/employee/obps/application/NOC/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        } else {
          console.log("Unhandled Business Service", item === null || item === void 0 ? void 0 : item.businessService);
        }
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleExcelDownload = () => {
    const exportColumns = columns;
    const exportData = filteredAndSortedData.map((app, idx) => {
      const row = {};
      exportColumns.forEach(col => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (col.id === "role") {
          row[col.label] = getItemRole$1(app) || "-";
        } else if (col.id === "applicationDate") {
          row[col.label] = convertEpochToDateDMY(app === null || app === void 0 ? void 0 : app.date) || "-";
        } else if (col.id === "status") {
          row[col.label] = t(`WF_BPA_MAP_${app === null || app === void 0 ? void 0 : app.status}`) || "-";
        } else if (col.id === "applicationType") {
          row[col.label] = t(app === null || app === void 0 ? void 0 : app.applicationType) || "-";
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = app[col.id] || "-";
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });
    Digit.Download.Excel(exportData, "Received Files");
  };
  if (isFetching) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    className: "table-container"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, t("FASTPAS.FILES.RECEIVED.TEXT"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length === allColumns.length ? "All" : selectedColumns.length, ")", " "), /*#__PURE__*/React__default.createElement(TextField, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#2A3F54",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleExcelDownload,
    title: "Export to Excel",
    style: {
      height: "35px",
      padding: "5px 0px",
      marginRight: "8px",
      background: "transparent",
      border: "none",
      cursor: "pointer"
    },
    disabled: filteredAndSortedData.length === 0
  }, /*#__PURE__*/React__default.createElement(FaFileExcel, {
    style: {
      fontSize: "20px",
      color: "rgb(85 108 214)"
    }
  })))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), isNodalOfficerAwas && /*#__PURE__*/React__default.createElement("div", {
    className: "risk-type-bar",
    style: {
      display: "flex",
      gap: "8px",
      marginBottom: "8px",
      justifyContent: "left",
      overflowX: "auto",
      paddingBottom: "4px"
    }
  }, roleTabsData.map(tab => {
    var _filterRoleData$tab$v, _filterRoleData$tab$v2, _filterRoleData$tab$v3;
    return /*#__PURE__*/React__default.createElement("button", {
      key: tab.value,
      disabled: ((_filterRoleData$tab$v = filterRoleData[tab.value]) === null || _filterRoleData$tab$v === void 0 ? void 0 : _filterRoleData$tab$v.length) === 0,
      style: {
        cursor: ((_filterRoleData$tab$v2 = filterRoleData[tab.value]) === null || _filterRoleData$tab$v2 === void 0 ? void 0 : _filterRoleData$tab$v2.length) === 0 ? "not-allowed" : "pointer"
      },
      className: `risk-type-button ${selectedRole === tab.value ? "active" : ""}`,
      onClick: () => {
        setSelectedRole(prev => prev === tab.value ? "" : tab.value);
        setPage(0);
      }
    }, tab.label, " ", /*#__PURE__*/React__default.createElement("span", {
      className: "count"
    }, "(", ((_filterRoleData$tab$v3 = filterRoleData[tab.value]) === null || _filterRoleData$tab$v3 === void 0 ? void 0 : _filterRoleData$tab$v3.length) || 0, ")"));
  })), /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    className: "application-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(column => /*#__PURE__*/React__default.createElement("th", {
    key: column.id,
    display: "flex",
    alignItems: "center"
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  })))), /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => {
    const isAutoForwarded = isAutoForwardedRecord$1(item);
    return /*#__PURE__*/React__default.createElement("tr", {
      hover: true,
      key: index,
      title: isAutoForwarded ? "Auto Forwarded (Admin Escalation)" : undefined
    }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
      key: `${index}-${column.id}`
    }, column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item))));
  })))), /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: (filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.length) || 0,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50]
  }));
};

const AllReceivedFiles = () => {
  const {
    businessServices: userBusinessServices,
    tenantId,
    count,
    officerRole
  } = useSelector(state => state.empInbox);
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "Authorized_Officer");
  const isSpecialOfficer = hasAuthorizedRoles || authorizedOfficer;
  if (isSpecialOfficer) {
    return /*#__PURE__*/React__default.createElement(NodalReceievedFiles, null);
  }
  return /*#__PURE__*/React__default.createElement(EmpReceivedFiles, null);
};

const OBPSEmployeeHomeCard = () => {
  var _userInfo$info, _userInfo$info$roles;
  const [totalCount, setTotalCount] = useState(0);
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const stakeholderEmployeeRoles = [{
    code: "BPAREG_DOC_VERIFIER",
    tenantId: tenantId
  }, {
    code: "BPAREG_APPROVER",
    tenantId: tenantId
  }, {
    code: "JE_HQ",
    tenantId: tenantId
  }, {
    code: "ASSOCIATE_JE",
    tenantId: tenantId
  }, {
    code: "PO_HQ",
    tenantId: tenantId
  }, {
    code: "ATP_HQ",
    tenantId: tenantId
  }, {
    code: "Authorized_Officer",
    tenantId: tenantId
  }, {
    code: "APA",
    tenantId: tenantId
  }, {
    code: "ATP",
    tenantId: tenantId
  }, {
    code: "DRAFTSMAN",
    tenantId: tenantId
  }, {
    code: "TCP_HQ",
    tenantId: tenantId
  }, {
    code: "STP_HQ",
    tenantId: tenantId
  }, {
    code: "Draughtsman",
    tenantId: tenantId
  }, {
    code: "JE",
    tenantId: tenantId
  }, {
    code: "Junior_Draughtsman",
    tenantId: tenantId
  }, {
    code: "Executive",
    tenantId: tenantId
  }, {
    code: "Clerk",
    tenantId: tenantId
  }, {
    code: "PO",
    tenantId: tenantId
  }, {
    code: "Planning_Officer",
    tenantId: tenantId
  }, {
    code: "Planning Officer",
    tenantId: tenantId
  }, {
    code: "PLANNING_OFFICER",
    tenantId: tenantId
  }, {
    code: "Assistant_Engineer",
    tenantId: tenantId
  }, {
    code: "Commissioner",
    tenantId: tenantId
  }, {
    code: "Secretary",
    tenantId: tenantId
  }, {
    code: "BPA_SURVEYOR",
    tenantId: tenantId
  }, {
    code: "Junior_Assistant",
    tenantId: tenantId
  }, {
    code: "JDM",
    tenantId: tenantId
  }, {
    code: "SPD_BBNDA",
    tenantId: tenantId
  }, {
    code: "RO_BBNDA",
    tenantId: tenantId
  }, {
    code: "ATP_BBNDA",
    tenantId: tenantId
  }, {
    code: "TCP_BBNDA",
    tenantId: tenantId
  }, {
    code: "CEO_BBNDA",
    tenantId: tenantId
  }, {
    code: "RO_BBNDA",
    tenantId: tenantId
  }, {
    code: "Additional_CEO_BBNDA",
    tenantId: tenantId
  }, {
    code: "Architect_Planner",
    tenantId: tenantId
  }, {
    code: "HPAC",
    tenantId: tenantId
  }, {
    code: "Draftman_Tax_Department_Applicant",
    tenantId: tenantId
  }, {
    code: "Nodal Officer",
    tenantId: tenantId
  }, {
    code: "AO",
    tenantId: tenantId
  }, {
    code: "EMO",
    tenantId: tenantId
  }, {
    code: "LAO",
    tenantId: tenantId
  }, {
    code: "NODAL_OFFICER_AWAS",
    tenantId: tenantId
  }, {
    code: "Acquisition_Section_Incharge",
    tenantId: tenantId
  }, {
    code: "Nazul_Section_Incharge",
    tenantId: tenantId
  }, {
    code: "Improvement_Trust_Incharge",
    tenantId: tenantId
  }, {
    code: "Property_Section_Incharge",
    tenantId: tenantId
  }, {
    code: "Urban_Ceiling_Incharge",
    tenantId: tenantId
  }, {
    code: "Tehsildar",
    tenantId: tenantId
  }, {
    code: "AAI_General_Manager",
    tenantId: tenantId
  }, {
    code: "Army_Airforce_Station_Officer",
    tenantId: tenantId
  }, {
    code: "Fire_Chief_Officer",
    tenantId: tenantId
  }, {
    code: "Irrigation_Executive_Officer",
    tenantId: tenantId
  }, {
    code: "UPMRC_MD",
    tenantId: tenantId
  }, {
    code: "Forest_District_Officer",
    tenantId: tenantId
  }, {
    code: "Railways_Section_Engineer",
    tenantId: tenantId
  }, {
    code: "Power_Executive_Engineer",
    tenantId: tenantId
  }, {
    code: "NHAI_Project_Director",
    tenantId: tenantId
  }, {
    code: "PWD_Executive_Engineer",
    tenantId: tenantId
  }, {
    code: "ASI_Superintendent",
    tenantId: tenantId
  }, {
    code: "Jail_Superintendent",
    tenantId: tenantId
  }, {
    code: "ULB_Nagar_Aayukt",
    tenantId: tenantId
  }, {
    code: "Environment_UPPCB_Secretary",
    tenantId: tenantId
  }, {
    code: "Security_ADG",
    tenantId: tenantId
  }, {
    code: "UPAVP_Chief_Architect",
    tenantId: tenantId
  }, {
    code: "FINANCE_CONTROLLER",
    tenantId: tenantId
  }, {
    code: "PRO",
    tenantId: tenantId
  }];
  const bpaEmployeeRoles = ["BPA_FIELD_INSPECTOR", "BPA_NOC_VERIFIER", "BPA_APPROVER", "BPA_VERIFIER", "CEMP", "JE_HQ", "PO_HQ", "ATP_HQ", "TCP_HQ", "STP_HQ", "Additional Director", "Chairman", "Draughtsman", "JE", "EE", "Additional_Secretory", "Additional_Secretary", "Secretory", "Vice_Chairman", "Junior_Draughtsman", "Executive", "Clerk", "PO", "Planning_Officer", "Planning Officer", "PLANNING_OFFICER", "Assistant_Engineer", "Member_Secretary", "Commissioner", "Secretary", "ASSOCIATE_JE", "BPA_SURVEYOR", "Junior_Assistant", "JDM", "SPD_BBNDA", "RO_BBNDA", "ATP_BBNDA", "TCP_BBNDA", "AE", "JE", "CEO_BBNDA", "Additional_CEO_BBNDA", "Architect_Planner", "HPAC", "Draftman_Tax_Department_Applicant", "TCP", "ATP", "Nodal Officer", "AO", "CTP", "Authorized_Officer", "EMO", "LAO", "AA", "AAP", "AP", "SAP", "CAP", "DM", "TP", "HC", "NODAL_OFFICER_AWAS", "DRAFTSMAN", "APA", "ATP", "Acquisition_Section_Incharge", "Nazul_Section_Incharge", "Improvement_Trust_Incharge", "Property_Section_Incharge", "Urban_Ceiling_Incharge", "Tehsildar", "AAI_General_Manager", "Army_Airforce_Station_Officer", "Fire_Chief_Officer", "Irrigation_Executive_Officer", "UPMRC_MD", "Forest_District_Officer", "Railways_Section_Engineer", "Power_Executive_Engineer", "NHAI_Project_Director", "PWD_Executive_Engineer", "ASI_Superintendent", "Jail_Superintendent", "ULB_Nagar_Aayukt", "Environment_UPPCB_Secretary", "Security_ADG", "UPAVP_Chief_Architect", "FINANCE_CONTROLLER", "PRO", "Joint_Secretary"];
  const userInfo = Digit.UserService.getUser();
  const isFinanceController = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.some(role => role.code === "FINANCE_CONTROLLER");
  const checkingForStakeholderRoles = showHidingLinksForStakeholder(stakeholderEmployeeRoles);
  const checkingForBPARoles = showHidingLinksForBPA(bpaEmployeeRoles);
  let result = null;
  if (isFinanceController) {
    return /*#__PURE__*/React__default.createElement(Redirect, {
      to: "/digit-ui/employee/obps/mis-reports"
    });
  }
  if (checkingForBPARoles || checkingForStakeholderRoles) result = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AllReceivedFiles, null));
  return result;
};

const Heading$2 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close$3 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$3 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$3, null));
};
const ActionModal$2 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'PT')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [disableActionSubmit, setDisableActionSubmit] = useState(false);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    if (!(action !== null && action !== void 0 && action.showFinancialYearsModal)) {
      let workflow = {
        action: action === null || action === void 0 ? void 0 : action.action,
        comments: data === null || data === void 0 ? void 0 : data.comments,
        businessService,
        moduleName: moduleCode
      };
      workflow["assignes"] = action !== null && action !== void 0 && action.isTerminateState || !selectedApprover ? [] : [selectedApprover];
      if (uploadedFile) workflow["documents"] = [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }];
      submitAction({
        Property: {
          ...applicationData,
          workflow
        }
      });
    } else {
      submitAction({
        customFunctionToExecute: action === null || action === void 0 ? void 0 : action.customFunctionToExecute,
        Assessment: {
          financialYear: selectedFinancialYear === null || selectedFinancialYear === void 0 ? void 0 : selectedFinancialYear.name,
          propertyId: applicationData === null || applicationData === void 0 ? void 0 : applicationData.propertyId,
          tenantId,
          source: applicationData === null || applicationData === void 0 ? void 0 : applicationData.source,
          channel: applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel,
          assessmentDate: Date.now()
        }
      });
    }
  }
  useEffect(() => {
    if (action) {
      if (action !== null && action !== void 0 && action.showFinancialYearsModal) {
        setConfig(configPTAssessProperty({
          t,
          action,
          financialYears,
          selectedFinancialYear,
          setSelectedFinancialYear
        }));
      } else {
        setConfig(configPTApproverApplication({
          t,
          action,
          approvers,
          selectedApprover,
          setSelectedApprover,
          selectFile,
          uploadedFile,
          setUploadedFile,
          businessService
        }));
      }
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$2, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$3, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    isDisabled: !action.showFinancialYearsModal ? PTALoading || (action === null || action === void 0 ? void 0 : action.docUploadRequired) && !uploadedFile : !selectedFinancialYear,
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const Heading$3 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close$4 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$4 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$4, null));
};
const ActionModal$3 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'TL')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configTLApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService
      }));
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$3, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$4, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const Heading$4 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$5 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$5 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$5, null));
};
const ActionModal$4 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    }, false, {
      isStakeholder: true,
      bpa: false
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAREGApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$4, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$5, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const Heading$5 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$6 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$6 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$6, null));
};
const ActionModal$5 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _applicationData4;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    let nocData = [];
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") {
          nocData.push(noc);
        }
      });
    }
    submitAction({
      BPA: applicationData
    }, (nocData === null || nocData === void 0 ? void 0 : nocData.length) > 0 ? nocData : false, {
      isStakeholder: false,
      bpa: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$5, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$6, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {},
    isDisabled: ((_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.status) === "UPLOAD_DIGI_SIGN_LETTER" && file === null ? true : false
  }, PTALoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const Heading$6 = props => {
  return /*#__PURE__*/React__default.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$7 = () => /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$7 = props => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React__default.createElement(Close$7, null));
};
const ActionModal$6 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  const history = useHistory();
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("NOC", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    var _applicationData, _applicationData$docu, _applicationData2;
    let enteredDocs = JSON.parse(sessionStorage.getItem("NewNOCDocs"));
    let newDocs = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$docu = _applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0 ? [...((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.documents)] : [];
    enteredDocs.map((d, index) => {
      newDocs.push(d);
    });
    applicationData = {
      ...applicationData,
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: data !== null && data !== void 0 && data.comments ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        documents: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      documents: newDocs
    };
    submitAction({
      Noc: applicationData
    }, false, {
      isNoc: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configNOCApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React__default.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React__default.createElement(Heading$6, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React__default.createElement(CloseBtn$7, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React__default.createElement(Loader, null);
};

const ActionModal$7 = props => {
  if (props !== null && props !== void 0 && props.businessService.includes("PT")) {
    return /*#__PURE__*/React__default.createElement(ActionModal$2, props);
  }
  if (props !== null && props !== void 0 && props.businessService.includes("NewTL") || props !== null && props !== void 0 && props.businessService.includes("TL") || props !== null && props !== void 0 && props.businessService.includes("EDITRENEWAL") || props !== null && props !== void 0 && props.businessService.includes("DIRECTRENEWAL")) {
    return /*#__PURE__*/React__default.createElement(ActionModal$3, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPAREG")) {
    return /*#__PURE__*/React__default.createElement(ActionModal$4, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA")) {
    return /*#__PURE__*/React__default.createElement(ActionModal$5, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("NOC")) {
    return /*#__PURE__*/React__default.createElement(ActionModal$6, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA_FORM11")) {
    return /*#__PURE__*/React__default.createElement(ActionModal, props);
  }
};

const getDocuments = fiDocuments => {
  const returnDocuments = [{
    title: "BPA_DOCUMENT_DETAILS_LABEL",
    values: fiDocuments === null || fiDocuments === void 0 ? void 0 : fiDocuments.map(doc => {
      var _doc$documentType;
      return {
        title: doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll('.', '_'),
        documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
        documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
        fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
        id: doc === null || doc === void 0 ? void 0 : doc.id,
        url: doc === null || doc === void 0 ? void 0 : doc.url
      };
    })
  }];
  return returnDocuments;
};
function InspectionReport$1({
  fiReport,
  isCitizen = false
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, isCitizen ? /*#__PURE__*/React__default.createElement(CardHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`) : /*#__PURE__*/React__default.createElement(CardSectionHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`), fiReport.map((fiData, index) => {
    var _fiData$date, _fiData$date2, _fiData$date3, _fiData$questions, _fiData$questions2;
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px",
        marginBottom: "24px"
      }
    }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      style: {
        fontSize: "20px"
      }
    }, (fiReport === null || fiReport === void 0 ? void 0 : fiReport.length) == 1 ? `${t(`BPA_FI_REPORT`)}` : `${t(`BPA_FI_REPORT`)} - ${index + 1}`), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_DATE_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.date ? fiData.date.includes("-") ? `${(_fiData$date = fiData.date) === null || _fiData$date === void 0 ? void 0 : _fiData$date.split("-")[2]}/${(_fiData$date2 = fiData.date) === null || _fiData$date2 === void 0 ? void 0 : _fiData$date2.split("-")[1]}/${(_fiData$date3 = fiData.date) === null || _fiData$date3 === void 0 ? void 0 : _fiData$date3.split("-")[0]}` : fiData === null || fiData === void 0 ? void 0 : fiData.date : "NA"
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_TIME_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.time ? fiData === null || fiData === void 0 ? void 0 : fiData.time : "NA"
    }), (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions = fiData.questions) === null || _fiData$questions === void 0 ? void 0 : _fiData$questions.length) && (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions2 = fiData.questions) === null || _fiData$questions2 === void 0 ? void 0 : _fiData$questions2.map(qstn => /*#__PURE__*/React__default.createElement("div", {
      style: {
        background: "white",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        marginTop: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t(`${qstn.question}`)}`,
      text: qstn !== null && qstn !== void 0 && qstn.value ? qstn === null || qstn === void 0 ? void 0 : qstn.value : "NA"
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_ENTER_REMARKS`)}`,
      text: qstn.remarks ? qstn.remarks : "NA"
    })))), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
      documents: getDocuments(fiData === null || fiData === void 0 ? void 0 : fiData.docs),
      svgStyles: {
        width: "100px",
        height: "100px",
        viewBox: "0 0 25 25",
        minWidth: "100px"
      }
    })));
  })));
}

function SelectDocument$7({
  t,
  document: doc,
  setNocDocuments,
  setError,
  nocDocuments
}) {
  const filteredDocument = nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState();
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfile(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    var _doc$dropdownData, _doc$dropdownData$;
    if (doc !== null && doc !== void 0 && (_doc$dropdownData = doc.dropdownData) !== null && _doc$dropdownData !== void 0 && (_doc$dropdownData$ = _doc$dropdownData[0]) !== null && _doc$dropdownData$ !== void 0 && _doc$dropdownData$.code) {
      setNocDocuments(prev => {
        var _doc$dropdownData3;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => {
          var _doc$dropdownData2, _doc$dropdownData2$;
          return (item === null || item === void 0 ? void 0 : item.documentType) !== (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData2 = doc.dropdownData) === null || _doc$dropdownData2 === void 0 ? void 0 : (_doc$dropdownData2$ = _doc$dropdownData2[0]) === null || _doc$dropdownData2$ === void 0 ? void 0 : _doc$dropdownData2$.code);
        });
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) {
          return filteredDocumentsByDocumentType;
        }
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: doc === null || doc === void 0 ? void 0 : (_doc$dropdownData3 = doc.dropdownData) === null || _doc$dropdownData3 === void 0 ? void 0 : _doc$dropdownData3[0].code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || ""
        }];
      });
    }
  }, [uploadedFile]);
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            setUploadedFile(null);
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getData = state => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    selectfile(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {}
  }, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      width: "98%",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    style: {
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t("TL_BUTTON_UPLOAD FILE")}*` : `${t("TL_BUTTON_UPLOAD FILE")}`), /*#__PURE__*/React__default.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(MultiUploadWrapper, {
    module: "NOC",
    tenantId: tenantId,
    getFormState: e => getData(e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }))));
}
const NOCDocuments = ({
  t,
  noc,
  docs,
  isNoc,
  applicationData,
  NOCdata,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da;
  const tenantId = Digit.ULBService.getStateId();
  const stateId = Digit.ULBService.getStateId();
  const bpaApplicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const {
    isLoading: nocDocsLoading,
    data: nocDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "NOC", ["DocumentTypeMapping"], {
    enabled: isNoc
  });
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"], {
    enabled: !isNoc
  });
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  const [commonDocMaping, setCommonDocMaping] = useState([]);
  const [nocTaxDocuments, setNocTaxDocuments] = useState([]);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const [nocDocuments, setNocDocuments] = Digit.Hooks.useSessionStorage(noc === null || noc === void 0 ? void 0 : noc.nocType, []);
  const [error, setError] = useState(null);
  const isEmployee = window.location.href.includes("/employee/");
  useEffect(() => {
    var _commonDocs$commonMa;
    setCommonDocMaping(commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : _commonDocs$commonMa.DocumentType);
  }, [commonDocs]);
  useEffect(() => {
    var _filteredData, _filteredData$, _filteredData$$docTyp;
    let documents = [];
    let filteredData;
    if (isNoc) {
      var _nocDocs$NOC, _nocDocs$NOC$Document;
      filteredData = nocDocs === null || nocDocs === void 0 ? void 0 : (_nocDocs$NOC = nocDocs.NOC) === null || _nocDocs$NOC === void 0 ? void 0 : (_nocDocs$NOC$Document = _nocDocs$NOC.DocumentTypeMapping) === null || _nocDocs$NOC$Document === void 0 ? void 0 : _nocDocs$NOC$Document.filter(data => {
        return (data === null || data === void 0 ? void 0 : data.applicationType) === (noc === null || noc === void 0 ? void 0 : noc.applicationType) && (data === null || data === void 0 ? void 0 : data.nocType) === (noc === null || noc === void 0 ? void 0 : noc.nocType);
      });
    } else {
      var _bpaDocs$BPA, _bpaDocs$BPA$DocTypeM;
      filteredData = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA = bpaDocs.BPA) === null || _bpaDocs$BPA === void 0 ? void 0 : (_bpaDocs$BPA$DocTypeM = _bpaDocs$BPA.DocTypeMapping) === null || _bpaDocs$BPA$DocTypeM === void 0 ? void 0 : _bpaDocs$BPA$DocTypeM.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) && data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    if ((_filteredData = filteredData) !== null && _filteredData !== void 0 && (_filteredData$ = _filteredData[0]) !== null && _filteredData$ !== void 0 && (_filteredData$$docTyp = _filteredData$.docTypes) !== null && _filteredData$$docTyp !== void 0 && _filteredData$$docTyp[0]) {
      filteredData[0].docTypes[0].nocType = filteredData[0].nocType;
      filteredData[0].docTypes[0].additionalDetails = {
        submissionDetails: noc === null || noc === void 0 ? void 0 : noc.additionalDetails,
        applicationStatus: noc === null || noc === void 0 ? void 0 : noc.applicationStatus,
        appNumberLink: noc === null || noc === void 0 ? void 0 : noc.applicationNo,
        nocNo: noc === null || noc === void 0 ? void 0 : noc.nocNo
      };
      documents.push(filteredData[0].docTypes[0]);
    }
    let documentsList = [];
    if (documents && documents.length > 0) {
      documents.map(doc => {
        let code = doc.documentType;
        doc.dropdownData = [];
        commonDocMaping === null || commonDocMaping === void 0 ? void 0 : commonDocMaping.forEach(value => {
          let values = value.code.slice(0, code === null || code === void 0 ? void 0 : code.length);
          if (code === values) {
            doc.hasDropdown = true;
            doc.dropdownData.push(value);
          }
        });
        documentsList.push(doc);
      });
      setNocTaxDocuments(documentsList);
    }
  }, [nocDocs, commonDocMaping]);
  useEffect(() => {
    if (bpaApplicationStatus === 'NOC_VERIFICATION_INPROGRESS' && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      border: "1px solid #D6D5D4",
      padding: "16px 0px 16px 8px",
      background: "#FAFAFA",
      borderRadius: "5px",
      marginBottom: "24px",
      maxWidth: "950px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    label: isEmployee ? `${t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`)}` : t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`),
    labelStyle: {
      fontSize: "20px",
      width: "150%"
    }
  }), NOCdata && NOCdata.map((noc, index) => {
    if (noc !== null && noc !== void 0 && noc.value) {
      if ((noc === null || noc === void 0 ? void 0 : noc.field) == "STATUS") {
        return /*#__PURE__*/React__default.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA"),
          textStyle: (noc === null || noc === void 0 ? void 0 : noc.value) == "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.value) == "AUTO_APPROVED" ? {
            color: "#00703C"
          } : {
            color: "#D4351C"
          }
        });
      } else {
        return /*#__PURE__*/React__default.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA")
        });
      }
    }
  })), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: docs,
    svgStyles: {
      width: "80px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "80px"
    }
  }), checkEnablingDocs && (nocTaxDocuments === null || nocTaxDocuments === void 0 ? void 0 : nocTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React__default.createElement(SelectDocument$7, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setNocDocuments: setNocDocuments,
      nocDocuments: nocDocuments,
      checkEnablingDocs: checkEnablingDocs
    });
  })));
};

const PermissionCheck = ({
  permissions,
  t
}) => {
  const [approvalChecks, setApprovalChecks, clearApprovals] = Digit.Hooks.useSessionStorage("OBPS_APPROVAL_CHECKS", permissions === null || permissions === void 0 ? void 0 : permissions.map(permission => ({
    label: permission,
    checked: false
  })));
  const [newApprovals, setNewApprovals, clearNewApprovals] = Digit.Hooks.useSessionStorage('OBPS_NEW_APPROVALS', []);
  useEffect(() => {
    return () => {
      Digit.SessionStorage.del("OBPS_NEW_APPROVALS");
      Digit.SessionStorage.del("OBPS_APPROVAL_CHECKS");
    };
  }, []);
  const handleAdd = () => {
    setNewApprovals([...newApprovals, {
      label: ''
    }]);
  };
  const handleRemove = index => {
    const values = [...newApprovals];
    values.splice(index, 1);
    setNewApprovals([...values]);
  };
  const handleChange = (event, index) => {
    setNewApprovals(() => {
      return newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, id) => {
        if (index === id) {
          var _event$target;
          return {
            label: event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value
          };
        }
        return approval;
      });
    });
  };
  const handleCheck = (event, label, index) => {
    const isChecked = event.target.checked;
    setApprovalChecks(() => {
      return approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((approval, id) => {
        if (index === id) {
          return {
            ...approval,
            checked: isChecked
          };
        }
        return approval;
      });
    });
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      marginBottom: "16px",
      fontSize: "24px"
    }
  }, t("BPA_PERMIT_CONDITIONS")), approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((permission, index) => /*#__PURE__*/React__default.createElement(CheckBox$1, {
    key: index,
    styles: {
      margin: "20px 0 40px",
      maxWidth: "70%"
    },
    label: permission === null || permission === void 0 ? void 0 : permission.label,
    checked: permission === null || permission === void 0 ? void 0 : permission.checked,
    onChange: event => handleCheck(event, permission === null || permission === void 0 ? void 0 : permission.label, index),
    isLabelFirst: true,
    index: index
  })), newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, index) => /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement(TextInput$2, {
    key: index,
    value: approval === null || approval === void 0 ? void 0 : approval.label,
    onChange: event => handleChange(event, index),
    textInputStyle: {
      maxWidth: "830px",
      width: "830px"
    },
    placeholder: "Enter permit conditions.........."
  }), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Close$9, {
      style: {
        float: "right",
        position: "relative",
        bottom: "32px",
        marginTop: "-21px",
        marginRight: "35%"
      }
    }))),
    style: {},
    onClick: e => handleRemove(index)
  }))), /*#__PURE__*/React__default.createElement(LinkButton, {
    style: {
      color: "#1F4A7C",
      maxWidth: "10%",
      marginRight: "3%"
    },
    label: t(`BPA_ADD_MORE`),
    onClick: handleAdd
  }));
};

function PropertyEstimates({
  taxHeadEstimatesCalculation
}) {
  const {
    taxHeadEstimates
  } = taxHeadEstimatesCalculation;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "40px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    label: t("ES_PT_TITLE_TAX_HEADS"),
    text: t("ES_PT_TITLE_AMOUNT"),
    className: "border-none",
    textStyle: {
      fontWeight: "bold"
    }
  }), /*#__PURE__*/React__default.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.map((estimate, index) => {
    return /*#__PURE__*/React__default.createElement(Row, {
      key: t(estimate.taxHeadCode),
      label: t(estimate.taxHeadCode),
      text: `₹ ${estimate.estimateAmount}` || "N/A",
      last: index === (taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.length) - 1,
      className: "border-none",
      textStyle: {
        color: "#505A5F"
      },
      labelStyle: {
        color: "#505A5F"
      }
    });
  }), /*#__PURE__*/React__default.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), /*#__PURE__*/React__default.createElement(Row, {
    label: t("ES_PT_TITLE_TOTAL_DUE_AMOUNT"),
    text: `₹ ${taxHeadEstimatesCalculation === null || taxHeadEstimatesCalculation === void 0 ? void 0 : taxHeadEstimatesCalculation.totalAmount}` || "N/A",
    className: "border-none",
    textStyle: {
      fontSize: "24px",
      fontWeight: "bold"
    }
  })));
}

function PropertyFloors({
  floors
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, floors.map(floor => {
    var _floor$values;
    return /*#__PURE__*/React__default.createElement("div", {
      key: t(floor === null || floor === void 0 ? void 0 : floor.title),
      style: {
        marginTop: "19px"
      }
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(floor === null || floor === void 0 ? void 0 : floor.title)), floor === null || floor === void 0 ? void 0 : (_floor$values = floor.values) === null || _floor$values === void 0 ? void 0 : _floor$values.map((value, index) => {
      var _value$values;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: index
      }, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
        style: {
          marginBottom: "16px",
          color: "#505A5F",
          fontSize: "16px",
          marginTop: index !== 0 ? "16px" : "revert"
        }
      }, t(value.title)), /*#__PURE__*/React__default.createElement(StatusTable, {
        style: {
          position: "relative",
          padding: "8px"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          border: "1px solid #D6D5D4",
          padding: "16px",
          marginTop: "8px",
          borderRadius: "4px",
          background: "#FAFAFA",
          maxWidth: "100%"
        }
      }, value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((value, index) => {
        var _value$values2;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React__default.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React__default.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values2 = value.values) === null || _value$values2 === void 0 ? void 0 : _value$values2.length) - 1,
          caption: value.caption,
          className: "border-none"
        });
      }))));
    }));
  }));
}

function PropertyOwners({
  owners
}) {
  const {
    t
  } = useTranslation();
  const checkOwnerLength = (owners === null || owners === void 0 ? void 0 : owners.length) || 1;
  let cardStyles = {
    marginTop: "19px"
  };
  let statusTableStyles = {
    position: "relative",
    padding: "8px"
  };
  let rowContainerStyle = {
    justifyContent: "space-between",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#0B0C0C"
  };
  if ( Number(checkOwnerLength) > 1) {
    cardStyles = {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
  } else if ( !(Number(checkOwnerLength) > 1)) {
    cardStyles = {
      marginTop: "19px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
    statusTableStyles = {
      position: "relative",
      marginTop: "19px"
    };
  }
  if (window.location.href.includes("obps")) {
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    rowContainerStyle = {};
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, owners.map((owner, index) => {
    var _owner$values;
    return /*#__PURE__*/React__default.createElement("div", {
      key: t(owner === null || owner === void 0 ? void 0 : owner.title),
      style: cardStyles
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style:  Number(checkOwnerLength) > 1 ? {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "16px",
        lineHeight: "19px"
      } : {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    },  Number(checkOwnerLength) > 1 ? `${t(owner === null || owner === void 0 ? void 0 : owner.title)} ${index + 1}` : t(owner === null || owner === void 0 ? void 0 : owner.title)), /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(StatusTable, {
      style: statusTableStyles
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        maxWidth: "640px",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: "auto"
      }
    }), owner === null || owner === void 0 ? void 0 : (_owner$values = owner.values) === null || _owner$values === void 0 ? void 0 : _owner$values.map((value, index) => {
      var _value$values;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React__default.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Row, {
        key: t(value.title),
        label:  `${t(value.title)}`,
        text: t(value.value) || "N/A",
        last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
        caption: value.caption,
        className: "border-none",
        textStyle: value.textStyle,
        rowContainerStyle: rowContainerStyle
      }));
    }))));
  }));
}

const ScruntinyDetails = ({
  scrutinyDetails,
  paymentsList: _paymentsList = []
}) => {
  var _scrutinyDetails$valu, _scrutinyDetails$perm, _scrutinyDetails$scru;
  const {
    t
  } = useTranslation();
  const getTextValues = data => {
    if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return /*#__PURE__*/React__default.createElement("span", {
      style: {
        color: "#00703C"
      }
    }, t(data === null || data === void 0 ? void 0 : data.value));else if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return t(data === null || data === void 0 ? void 0 : data.value);else if (data !== null && data !== void 0 && data.value) return data === null || data === void 0 ? void 0 : data.value;else t("NA");
  };
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, !(scrutinyDetails !== null && scrutinyDetails !== void 0 && scrutinyDetails.isChecklist) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$valu = scrutinyDetails.values) === null || _scrutinyDetails$valu === void 0 ? void 0 : _scrutinyDetails$valu.map((value, index) => {
    if (value !== null && value !== void 0 && value.isUnit) return /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? `${getTextValues(value)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("NA"),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });else if (value !== null && value !== void 0 && value.isHeader && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else if (value !== null && value !== void 0 && value.isSubTitle && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px",
        margin: "0px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: getTextValues(value),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });
  }), scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$perm = scrutinyDetails.permit) === null || _scrutinyDetails$perm === void 0 ? void 0 : _scrutinyDetails$perm.map((value, ind) => {
    return /*#__PURE__*/React__default.createElement(CardLabel, {
      style: {
        fontWeight: "400"
      }
    }, value === null || value === void 0 ? void 0 : value.title);
  })), /*#__PURE__*/React__default.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$scru = scrutinyDetails.scruntinyDetails) === null || _scrutinyDetails$scru === void 0 ? void 0 : _scrutinyDetails$scru.map((report, index) => {
    return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t(report === null || report === void 0 ? void 0 : report.title)}`,
      labelStyle: {
        width: "150%"
      }
    }), report !== null && report !== void 0 && report.value ? /*#__PURE__*/React__default.createElement("a", {
      href: report === null || report === void 0 ? void 0 : report.value,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React__default.createElement(PDFSvg, null)) : /*#__PURE__*/React__default.createElement("span", null, t("NA")), /*#__PURE__*/React__default.createElement("p", {
      style: {
        margin: "8px 0px",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F"
      }
    }, t(report === null || report === void 0 ? void 0 : report.text)));
  })))));
};

const SubOccupancyTable = ({
  edcrDetails,
  applicationData
}) => {
  var _edcrDetails$values, _edcrDetails$subOccup, _edcrDetails$subOccup2, _edcrDetails$subOccup3, _edcrDetails$subOccup4;
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
    if (searcher == "") return str;
    while (str.includes(searcher)) {
      str = str.replace(searcher, replaceWith);
    }
    return str;
  };
  function getSubOccupancyValues(index) {
    var _applicationData$land;
    let values = applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land = applicationData.landInfo) === null || _applicationData$land === void 0 ? void 0 : _applicationData$land.unit;
    let returnValue = "";
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
      var _values$index, _values$index$usageCa;
      let splitArray = (_values$index = values[index]) === null || _values$index === void 0 ? void 0 : (_values$index$usageCa = _values$index.usageCategory) === null || _values$index$usageCa === void 0 ? void 0 : _values$index$usageCa.split(',');
      if (splitArray !== null && splitArray !== void 0 && splitArray.length) {
        const returnValueArray = splitArray.map(data => data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.toUpperCase(), "-", "_")}`)}` : "NA");
        returnValue = returnValueArray.join(', ');
      }
    }
    return returnValue ? returnValue : "NA";
  }
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$values = edcrDetails.values) === null || _edcrDetails$values === void 0 ? void 0 : _edcrDetails$values.map((value, index) => {
    if (value !== null && value !== void 0 && value.isHeader) return /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      labelStyle: {
        width: "100%",
        fontSize: "20px"
      },
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? value === null || value === void 0 ? void 0 : value.value : ""
    });
  })), edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup === void 0 ? void 0 : (_edcrDetails$subOccup2 = _edcrDetails$subOccup[0]) === null || _edcrDetails$subOccup2 === void 0 ? void 0 : (_edcrDetails$subOccup3 = _edcrDetails$subOccup2.value) === null || _edcrDetails$subOccup3 === void 0 ? void 0 : (_edcrDetails$subOccup4 = _edcrDetails$subOccup3.planDetail) === null || _edcrDetails$subOccup4 === void 0 ? void 0 : _edcrDetails$subOccup4.blocks.map((block, index) => {
    var _edcrDetails$subOccup5, _edcrDetails$subOccup6, _edcrDetails$subOccup7, _edcrDetails$subOccup8, _edcrDetails$subOccup9;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup5 = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup5 === void 0 ? void 0 : (_edcrDetails$subOccup6 = _edcrDetails$subOccup5[0]) === null || _edcrDetails$subOccup6 === void 0 ? void 0 : (_edcrDetails$subOccup7 = _edcrDetails$subOccup6.value) === null || _edcrDetails$subOccup7 === void 0 ? void 0 : (_edcrDetails$subOccup8 = _edcrDetails$subOccup7.planDetail) === null || _edcrDetails$subOccup8 === void 0 ? void 0 : (_edcrDetails$subOccup9 = _edcrDetails$subOccup8.blocks) === null || _edcrDetails$subOccup9 === void 0 ? void 0 : _edcrDetails$subOccup9.length) > 0 ? {
        marginBottom: "30px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px"
      } : {
        marginBottom: "30px"
      }
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "18px",
        lineHeight: "19px"
      }
    }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: {
        wordBreak: "break-word"
      },
      label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
      text: getSubOccupancyValues(index)
    })), /*#__PURE__*/React__default.createElement("div", {
      style: window.location.href.includes("citizen") || isMobile ? {
        overflow: "scroll"
      } : {
        maxWidth: "950px",
        maxHeight: "280px"
      }
    }, /*#__PURE__*/React__default.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    })));
  })));
};

function TLTradeAccessories({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React__default.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
        style: {
          marginBottom: "8px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: index
      }, /*#__PURE__*/React__default.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React__default.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React__default.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

function TLTradeUnits({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React__default.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
        style: {
          marginBottom: "9px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: index
      }, /*#__PURE__*/React__default.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React__default.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React__default.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "NA",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

const ProfessionalsAddressMapper = ({
  data,
  t
}) => {
  const erKeys = Object.keys(data).filter(key => key.startsWith("er") && !key.includes("engineerUuid") && !key.includes("erplotArea"));
  const stringKeys = Object.keys(data).filter(key => !key.startsWith("er") && !key.includes("engineerUuid") && typeof data[key] === "string" && data[key] !== null);
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")), /*#__PURE__*/React__default.createElement(StatusTable, null, stringKeys.map((key, index) => /*#__PURE__*/React__default.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.toUpperCase()}`),
    text: data[key] || ""
  })))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")), /*#__PURE__*/React__default.createElement(StatusTable, null, erKeys.map((key, index) => /*#__PURE__*/React__default.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.slice(2).toUpperCase()}`),
    text: data[key] || ""
  })))));
};

function ApplicationDetailsContent({
  applicationDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  businessService,
  timelineStatusPrefix,
  showTimeLine = true,
  statusAttribute = "status",
  paymentsList
}) {
  var _applicationDetails$a, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
  const {
    t
  } = useTranslation();
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData$audi;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel) || ""
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData$audi2, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi2 = applicationData.auditDetails) === null || _applicationData$audi2 === void 0 ? void 0 : _applicationData$audi2.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React__default.createElement(TLCaption, {
        data: caption
      });
    }
  };
  const getTranslatedValues = (dataValue, isNotTranslated) => {
    if (dataValue) {
      return !isNotTranslated ? t(dataValue) : dataValue;
    } else {
      return t("NA");
    }
  };
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc");
  const isNocLocation = window.location.href.includes("employee/noc");
  const isBPALocation = window.location.href.includes("employee/obps");
  const getRowStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else if (checkLocation) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else {
      return {};
    }
  };
  const getTableStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else if (checkLocation) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else {
      return {};
    }
  };
  const getMainDivStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        lineHeight: "19px",
        maxWidth: "950px",
        minWidth: "280px"
      };
    } else if (checkLocation) {
      return {
        lineHeight: "19px",
        maxWidth: "600px",
        minWidth: "280px"
      };
    } else {
      return {};
    }
  };
  const getTextValue = value => {
    if (value !== null && value !== void 0 && value.skip) return value.value;else if (value !== null && value !== void 0 && value.isUnit) return value !== null && value !== void 0 && value.value ? `${getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("N/A");else return value !== null && value !== void 0 && value.value ? getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated) : t("N/A");
  };
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      position: "relative"
    },
    className: "employeeCard-override"
  }, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationDetails) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.map((detail, index) => {
    var _detail$values, _detail$additionalDet, _applicationDetails$a2, _applicationDetails$a3, _applicationDetails$a4, _detail$additionalDet2, _applicationDetails$a5, _applicationDetails$a6, _detail$values4, _detail$additionalDet3, _detail$additionalDet4, _detail$additionalDet5, _detail$additionalDet6, _detail$additionalDet7, _detail$additionalDet8, _detail$additionalDet9, _detail$additionalDet10, _detail$additionalDet11, _workflowDetails$data, _workflowDetails$data2, _detail$additionalDet12, _detail$additionalDet13, _detail$additionalDet14, _detail$additionalDet15, _detail$additionalDet16, _detail$additionalDet17, _detail$additionalDet18, _detail$additionalDet19, _detail$additionalDet20, _detail$additionalDet21, _detail$additionalDet22, _detail$additionalDet23, _detail$additionalDet24;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      style: getMainDivStyles()
    }, (index === 0 || index === 9) && detail.asSectionHeader ? /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginBottom: "16px",
        fontSize: "24px"
      }
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      style: index == 0 && checkLocation ? {
        marginBottom: "16px",
        fontSize: "24px"
      } : {
        marginBottom: "16px",
        marginTop: "32px",
        fontSize: "24px"
      }
    }, isNocLocation ? `${t(detail.title)}` : t(detail.title))), /*#__PURE__*/React__default.createElement(StatusTable, {
      style: getTableStyles()
    }, (detail === null || detail === void 0 ? void 0 : detail.title) && !(detail !== null && detail !== void 0 && detail.title.includes("NOC")) && (detail === null || detail === void 0 ? void 0 : (_detail$values = detail.values) === null || _detail$values === void 0 ? void 0 : _detail$values.map((value, index) => {
      var _detail$values3;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React__default.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      if ((value === null || value === void 0 ? void 0 : value.isLink) == true) {
        var _detail$values2;
        return /*#__PURE__*/React__default.createElement(Row, {
          key: t(value.title),
          label: window.location.href.includes("tl") ? /*#__PURE__*/React__default.createElement("div", {
            style: {
              width: "200%"
            }
          }, /*#__PURE__*/React__default.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, t(value === null || value === void 0 ? void 0 : value.title)))) : isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
          text: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, value === null || value === void 0 ? void 0 : value.value))),
          last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values2 = detail.values) === null || _detail$values2 === void 0 ? void 0 : _detail$values2.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: getRowStyles()
        });
      }
      return /*#__PURE__*/React__default.createElement(Row, {
        key: t(value.title),
        label: isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
        text: getTextValue(value),
        last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values3 = detail.values) === null || _detail$values3 === void 0 ? void 0 : _detail$values3.length) - 1,
        caption: value.caption,
        className: "border-none",
        rowContainerStyle: getRowStyles()
      });
    })))), (detail === null || detail === void 0 ? void 0 : detail.belowComponent) && /*#__PURE__*/React__default.createElement(detail.belowComponent, null), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet = detail.additionalDetails) === null || _detail$additionalDet === void 0 ? void 0 : _detail$additionalDet.inspectionReport) && /*#__PURE__*/React__default.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      paymentsList: paymentsList
    }), (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : (_applicationDetails$a3 = _applicationDetails$a2.additionalDetails) === null || _applicationDetails$a3 === void 0 ? void 0 : (_applicationDetails$a4 = _applicationDetails$a3.fieldinspection_pending) === null || _applicationDetails$a4 === void 0 ? void 0 : _applicationDetails$a4.length) > 0 && (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet2 = detail.additionalDetails) === null || _detail$additionalDet2 === void 0 ? void 0 : _detail$additionalDet2.fiReport) && /*#__PURE__*/React__default.createElement(InspectionReport$1, {
      fiReport: applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a5 = applicationDetails.applicationData) === null || _applicationDetails$a5 === void 0 ? void 0 : (_applicationDetails$a6 = _applicationDetails$a5.additionalDetails) === null || _applicationDetails$a6 === void 0 ? void 0 : _applicationDetails$a6.fieldinspection_pending
    }), (detail === null || detail === void 0 ? void 0 : detail.isprofessionalDetail) && /*#__PURE__*/React__default.createElement(ProfessionalsAddressMapper, {
      data: detail === null || detail === void 0 ? void 0 : (_detail$values4 = detail.values) === null || _detail$values4 === void 0 ? void 0 : _detail$values4[0],
      t: t
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet3 = detail.additionalDetails) === null || _detail$additionalDet3 === void 0 ? void 0 : _detail$additionalDet3.floors) && /*#__PURE__*/React__default.createElement(PropertyFloors, {
      floors: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet4 = detail.additionalDetails) === null || _detail$additionalDet4 === void 0 ? void 0 : _detail$additionalDet4.floors
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet5 = detail.additionalDetails) === null || _detail$additionalDet5 === void 0 ? void 0 : _detail$additionalDet5.owners) && /*#__PURE__*/React__default.createElement(PropertyOwners, {
      owners: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet6 = detail.additionalDetails) === null || _detail$additionalDet6 === void 0 ? void 0 : _detail$additionalDet6.owners
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet7 = detail.additionalDetails) === null || _detail$additionalDet7 === void 0 ? void 0 : _detail$additionalDet7.units) && /*#__PURE__*/React__default.createElement(TLTradeUnits, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet8 = detail.additionalDetails) === null || _detail$additionalDet8 === void 0 ? void 0 : _detail$additionalDet8.units
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet9 = detail.additionalDetails) === null || _detail$additionalDet9 === void 0 ? void 0 : _detail$additionalDet9.accessories) && /*#__PURE__*/React__default.createElement(TLTradeAccessories, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet10 = detail.additionalDetails) === null || _detail$additionalDet10 === void 0 ? void 0 : _detail$additionalDet10.accessories
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet11 = detail.additionalDetails) === null || _detail$additionalDet11 === void 0 ? void 0 : _detail$additionalDet11.permissions) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React__default.createElement(PermissionCheck, {
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      t: t,
      permissions: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet12 = detail.additionalDetails) === null || _detail$additionalDet12 === void 0 ? void 0 : _detail$additionalDet12.permissions
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet13 = detail.additionalDetails) === null || _detail$additionalDet13 === void 0 ? void 0 : _detail$additionalDet13.obpsDocuments) && /*#__PURE__*/React__default.createElement(BPADocuments, {
      t: t,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.obpsDocuments,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet14 = detail.additionalDetails) === null || _detail$additionalDet14 === void 0 ? void 0 : _detail$additionalDet14.noc) && /*#__PURE__*/React__default.createElement(NOCDocuments, {
      t: t,
      isNoc: true,
      NOCdata: detail.values,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.noc,
      noc: (_detail$additionalDet15 = detail.additionalDetails) === null || _detail$additionalDet15 === void 0 ? void 0 : _detail$additionalDet15.data,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet16 = detail.additionalDetails) === null || _detail$additionalDet16 === void 0 ? void 0 : _detail$additionalDet16.scruntinyDetails) && /*#__PURE__*/React__default.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet17 = detail.additionalDetails) === null || _detail$additionalDet17 === void 0 ? void 0 : _detail$additionalDet17.buildingExtractionDetails) && /*#__PURE__*/React__default.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet18 = detail.additionalDetails) === null || _detail$additionalDet18 === void 0 ? void 0 : _detail$additionalDet18.subOccupancyTableDetails) && /*#__PURE__*/React__default.createElement(SubOccupancyTable, {
      edcrDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet19 = detail.additionalDetails) === null || _detail$additionalDet19 === void 0 ? void 0 : _detail$additionalDet19.documentsWithUrl) && /*#__PURE__*/React__default.createElement(DocumentsPreview, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet20 = detail.additionalDetails) === null || _detail$additionalDet20 === void 0 ? void 0 : _detail$additionalDet20.documentsWithUrl
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet21 = detail.additionalDetails) === null || _detail$additionalDet21 === void 0 ? void 0 : _detail$additionalDet21.documents) && /*#__PURE__*/React__default.createElement(PropertyDocuments, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet22 = detail.additionalDetails) === null || _detail$additionalDet22 === void 0 ? void 0 : _detail$additionalDet22.documents
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet23 = detail.additionalDetails) === null || _detail$additionalDet23 === void 0 ? void 0 : _detail$additionalDet23.taxHeadEstimatesCalculation) && /*#__PURE__*/React__default.createElement(PropertyEstimates, {
      taxHeadEstimatesCalculation: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet24 = detail.additionalDetails) === null || _detail$additionalDet24 === void 0 ? void 0 : _detail$additionalDet24.taxHeadEstimatesCalculation
    }));
  }), showTimeLine && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BreakLine, null), ((workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) || isDataLoading) && /*#__PURE__*/React__default.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isDataLoading && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
    style: {
      marginBottom: "16px",
      marginTop: "32px"
    }
  }, t("ES_APPLICATION_DETAILS_APPLICATION_TIMELINE")), workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data5 = workflowDetails.data) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.length) === 1 ? /*#__PURE__*/React__default.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${timelineStatusPrefix}${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8.timeline[0]) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline[0])
  }) : /*#__PURE__*/React__default.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : _workflowDetails$data11.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data12 = workflowDetails.data) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${timelineStatusPrefix}${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint[statusAttribute]}`),
      customChild: getTimelineCaptions(checkpoint)
    }));
  }))))));
}

const ApplicationDetails$1 = props => {
  var _workflowDetails$data;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setWarningPopUp(true);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if ((action === null || action === void 0 ? void 0 : action.action) === 'APPROVAL_LETTER_GENERATE') {
        setShowModal(false);
        let payload = {};
        payload.BPA = applicationData;
        payload.BPA.workflow = {
          "action": "APPROVAL_LETTER_GENERATE",
          "assignes": null,
          "comments": null,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
          if (res) {
            await OBPSService.update(payload, tenantId);
            history.push({
              pathname: "/digit-ui/employee/obps/form12inbox"
            });
          } else {
            setShowToast({
              key: "error",
              error: {
                message: "Error in APPROVAL_LETTER_GENERATE"
              }
            });
          }
        } catch (error) {
          console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const closeWarningPopup = () => {
    setWarningPopUp(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
    }
    closeModal();
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplicationDetailsContent, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine
  }), showModal ? /*#__PURE__*/React__default.createElement(ActionModal$7, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    state: state,
    id: applicationNumber,
    applicationDetails: applicationDetails,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    businessService: businessService,
    workflowDetails: workflowDetails,
    moduleCode: moduleCode
  }) : null, isWarningPop ? /*#__PURE__*/React__default.createElement(ApplicationDetailsWarningPopup, {
    action: selectedAction,
    workflowDetails: workflowDetails,
    businessService: businessService,
    isWarningPop: isWarningPop,
    closeWarningPopup: closeWarningPopup
  }) : null, /*#__PURE__*/React__default.createElement(ApplicationDetailsToast, {
    t: t,
    showToast: showToast,
    closeToast: closeToast,
    businessService: businessService
  }), /*#__PURE__*/React__default.createElement(ApplicationDetailsActionBar, {
    workflowDetails: workflowDetails,
    displayMenu: displayMenu,
    onActionSelect: onActionSelect,
    setDisplayMenu: setDisplayMenu,
    businessService: businessService,
    forcedActionPrefix: forcedActionPrefix,
    ActionBarStyle: ActionBarStyle,
    MenuStyle: MenuStyle,
    applicationDetails: applicationDetails
  })) : /*#__PURE__*/React__default.createElement(Loader, null));
};

const ApplicationDetail$6 = () => {
  var _applicationDetails$p, _applicationDetails$p6, _workflowDetails$data, _workflowDetails$data2, _applicationDetails$a3;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = tenantId === null || tenantId === void 0 ? void 0 : tenantId.split('.')[0];
  const [showToast, setShowToast] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading,
    data: applicationDetails
  } = Digit.Hooks.obps.useLicenseDetails(tenantId, {
    applicationNumber: id
  }, {});
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useBPAREGApplicationActions();
  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPAREG"
  });
  const closeToast = () => {
    setShowToast(null);
  };
  let dowloadOptions = [];
  if ((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p = applicationDetails.payments) === null || _applicationDetails$p === void 0 ? void 0 : _applicationDetails$p.length) > 0) {
    dowloadOptions.push({
      label: t("TL_RECEIPT"),
      onClick: () => {
        var _applicationDetails$p2, _applicationDetails$p3, _applicationDetails$p4, _applicationDetails$p5, _applicationDetails$a, _applicationDetails$a2;
        return downloadAndPrintReciept((applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p2 = applicationDetails.payments) === null || _applicationDetails$p2 === void 0 ? void 0 : (_applicationDetails$p3 = _applicationDetails$p2[0]) === null || _applicationDetails$p3 === void 0 ? void 0 : (_applicationDetails$p4 = _applicationDetails$p3.paymentDetails) === null || _applicationDetails$p4 === void 0 ? void 0 : (_applicationDetails$p5 = _applicationDetails$p4[0]) === null || _applicationDetails$p5 === void 0 ? void 0 : _applicationDetails$p5.businessService) || "BPAREG", applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.applicationNumber, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : _applicationDetails$a2.tenantId);
      }
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-application-details"
  }, /*#__PURE__*/React__default.createElement(Header, null, t("CS_TITLE_APPLICATION_DETAILS")), (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$p6 = applicationDetails.payments) === null || _applicationDetails$p6 === void 0 ? void 0 : _applicationDetails$p6.length) > 0 && /*#__PURE__*/React__default.createElement(MultiLink, {
    className: "multilinkWrapper employee-mulitlink-main-div",
    onHeadClick: () => setShowOptions(!showOptions),
    displayOptions: showOptions,
    options: dowloadOptions,
    downloadBtnClassName: "employee-download-btn-className",
    optionsClassName: "employee-options-btn-className"
  })), /*#__PURE__*/React__default.createElement(ApplicationDetails$1, {
    applicationDetails: applicationDetails,
    isLoading: isLoading,
    isDataLoading: isLoading,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data = workflowDetails.data) !== null && _workflowDetails$data !== void 0 && _workflowDetails$data.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.applicationBusinessService : applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a3 = applicationDetails.applicationData) === null || _applicationDetails$a3 === void 0 ? void 0 : _applicationDetails$a3.businessService,
    moduleCode: "BPAREG",
    showToast: showToast,
    setShowToast: setShowToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    closeToast: closeToast,
    timelineStatusPrefix: "WF_NEWTL_"
  }));
};

const BpaApplicationDetail$1 = () => {
  var _mdmsData$BPA, _userInfo$info, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data7, _workflowDetails$data8, _data$collectionBillD, _data$applicationData30, _data$collectionBillD2, _data$applicationData35, _data$collectionBillD3, _data$applicationData38, _workflowDetails$data15, _workflowDetails$data16, _data$applicationDeta7, _data$applicationData39, _userInfo$info2, _workflowDetails$data19, _workflowDetails$data20, _data$applicationData40, _workflowDetails$data21, _workflowDetails$data22, _data$applicationData41;
  const {
    id
  } = useParams();
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const [canSubmit, setSubmitValve] = useState(false);
  const defaultValues = {};
  const history = useHistory();
  const [_formData, setFormData, _clear] = Digit.Hooks.useSessionStorage("store-data", null);
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const [error, setError] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  let {
    data: newConfig$1
  } = Digit.Hooks.obps.SearchMdmsTypes.getFormConfig(stateId, []);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["RiskTypeComputation"]);
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id
  });
  useEffect(() => {
    if (!bpaDocsLoading && !isLoading) {
      var _bpaDocs$BPA;
      let filtredBpaDocs = [];
      if (bpaDocs !== null && bpaDocs !== void 0 && (_bpaDocs$BPA = bpaDocs.BPA) !== null && _bpaDocs$BPA !== void 0 && _bpaDocs$BPA.DocTypeMapping) {
        var _bpaDocs$BPA2, _bpaDocs$BPA2$DocType, _data$applicationDeta, _data$applicationDeta2, _data$applicationDeta3, _data$applicationDeta4, _data$applicationDeta5, _filtredBpaDocs, _filtredBpaDocs$, _filtredBpaDocs2, _filtredBpaDocs2$;
        filtredBpaDocs = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA2 = bpaDocs.BPA) === null || _bpaDocs$BPA2 === void 0 ? void 0 : (_bpaDocs$BPA2$DocType = _bpaDocs$BPA2.DocTypeMapping) === null || _bpaDocs$BPA2$DocType === void 0 ? void 0 : _bpaDocs$BPA2$DocType.filter(ob => {
          var _data$applicationData4, _data$applicationData5, _data$applicationData6, _data$applicationData7, _data$applicationData8;
          return ob.WFState == "INPROGRESS" && ob.RiskType == (data === null || data === void 0 ? void 0 : (_data$applicationData4 = data.applicationData) === null || _data$applicationData4 === void 0 ? void 0 : _data$applicationData4.riskType) && ob.ServiceType == (data === null || data === void 0 ? void 0 : (_data$applicationData5 = data.applicationData) === null || _data$applicationData5 === void 0 ? void 0 : (_data$applicationData6 = _data$applicationData5.additionalDetails) === null || _data$applicationData6 === void 0 ? void 0 : _data$applicationData6.serviceType) && ob.applicationType == (data === null || data === void 0 ? void 0 : (_data$applicationData7 = data.applicationData) === null || _data$applicationData7 === void 0 ? void 0 : (_data$applicationData8 = _data$applicationData7.additionalDetails) === null || _data$applicationData8 === void 0 ? void 0 : _data$applicationData8.applicationType);
        });
        let documents = data === null || data === void 0 ? void 0 : (_data$applicationDeta = data.applicationDetails) === null || _data$applicationDeta === void 0 ? void 0 : (_data$applicationDeta2 = _data$applicationDeta.filter(ob => ob.title === "BPA_DOCUMENT_DETAILS_LABEL")[0]) === null || _data$applicationDeta2 === void 0 ? void 0 : (_data$applicationDeta3 = _data$applicationDeta2.additionalDetails) === null || _data$applicationDeta3 === void 0 ? void 0 : (_data$applicationDeta4 = _data$applicationDeta3.obpsDocuments) === null || _data$applicationDeta4 === void 0 ? void 0 : (_data$applicationDeta5 = _data$applicationDeta4[0]) === null || _data$applicationDeta5 === void 0 ? void 0 : _data$applicationDeta5.values;
        let RealignedDocument = [];
        filtredBpaDocs && ((_filtredBpaDocs = filtredBpaDocs) === null || _filtredBpaDocs === void 0 ? void 0 : (_filtredBpaDocs$ = _filtredBpaDocs[0]) === null || _filtredBpaDocs$ === void 0 ? void 0 : _filtredBpaDocs$.docTypes) && ((_filtredBpaDocs2 = filtredBpaDocs) === null || _filtredBpaDocs2 === void 0 ? void 0 : (_filtredBpaDocs2$ = _filtredBpaDocs2[0]) === null || _filtredBpaDocs2$ === void 0 ? void 0 : _filtredBpaDocs2$.docTypes.map(ob => {
          documents && documents.filter(x => ob.code === x.documentType.slice(0, x.documentType.lastIndexOf("."))).map(doc => {
            RealignedDocument.push(doc);
          });
        }));
        const newApplicationDetails = data.applicationDetails && data.applicationDetails.map(obj => {
          if (obj.title === "BPA_DOCUMENT_DETAILS_LABEL") {
            return {
              ...obj,
              additionalDetails: {
                obpsDocuments: [{
                  title: "",
                  values: RealignedDocument
                }]
              }
            };
          }
          return obj;
        });
        data.applicationDetails = newApplicationDetails && newApplicationDetails.length > 0 ? [...newApplicationDetails] : data === null || data === void 0 ? void 0 : data.applicationDetails;
      }
    }
  }, [bpaDocs, data]);
  async function getRecieptSearch({
    tenantId,
    payments,
    ...params
  }) {
    var _response;
    let response = {
      filestoreIds: [payments === null || payments === void 0 ? void 0 : payments.fileStoreId]
    };
    response = await Digit.PaymentService.generatePdf(tenantId, {
      Payments: [{
        ...payments
      }]
    }, "consolidatedreceipt");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[(_response = response) === null || _response === void 0 ? void 0 : _response.filestoreIds[0]], "_blank");
  }
  async function getPermitOccupancyOrderSearch({
    tenantId
  }, order, mode = "download") {
    var _data$applicationData9, _data$applicationData10, _data$applicationData11, _data$applicationData12, _data$applicationData13, _data$applicationData14, _data$applicationData15, _data$applicationData16;
    const customLetterDoc = data === null || data === void 0 ? void 0 : (_data$applicationData9 = data.applicationData) === null || _data$applicationData9 === void 0 ? void 0 : (_data$applicationData10 = _data$applicationData9.documents) === null || _data$applicationData10 === void 0 ? void 0 : _data$applicationData10.find(doc => doc.documentType === "customapprovalletter");
    const isAVP = (data === null || data === void 0 ? void 0 : (_data$applicationData11 = data.applicationData) === null || _data$applicationData11 === void 0 ? void 0 : _data$applicationData11.riskType) === "AVP" || (data === null || data === void 0 ? void 0 : (_data$applicationData12 = data.applicationData) === null || _data$applicationData12 === void 0 ? void 0 : (_data$applicationData13 = _data$applicationData12.additionalDetails) === null || _data$applicationData13 === void 0 ? void 0 : _data$applicationData13.riskType) === "AVP" || (data === null || data === void 0 ? void 0 : (_data$applicationData14 = data.applicationData) === null || _data$applicationData14 === void 0 ? void 0 : _data$applicationData14.department) === "AVP";
    if (customLetterDoc && isAVP) {
      try {
        var _response2$data, _response2$data$fileS, _response2$data$fileS2;
        const _response2 = await axios.get(`/filestore/v1/files/url?tenantId=${tenantId}&fileStoreIds=${customLetterDoc.fileStoreId}`);
        const fileUrl = _response2 === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : (_response2$data$fileS = _response2$data.fileStoreIds) === null || _response2$data$fileS === void 0 ? void 0 : (_response2$data$fileS2 = _response2$data$fileS[0]) === null || _response2$data$fileS2 === void 0 ? void 0 : _response2$data$fileS2.url;
        if (fileUrl) {
          window.open(fileUrl, "_blank");
        }
      } catch (err) {
        console.error("Failed to fetch custom approval letter URL", err);
      }
      return;
    }
    let currentDate = new Date();
    data.applicationData.additionalDetails.runDate = convertDateToEpoch(currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate());
    let requestData = {
      ...(data === null || data === void 0 ? void 0 : data.applicationData),
      edcrDetail: [{
        ...(data === null || data === void 0 ? void 0 : data.edcrDetails)
      }]
    };
    let response = await Digit.PaymentService.generatePdf(tenantId, {
      Bpa: [requestData]
    }, order);
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[response === null || response === void 0 ? void 0 : response.filestoreIds[0]], "_blank");
    requestData["applicationType"] = data === null || data === void 0 ? void 0 : (_data$applicationData15 = data.applicationData) === null || _data$applicationData15 === void 0 ? void 0 : (_data$applicationData16 = _data$applicationData15.additionalDetails) === null || _data$applicationData16 === void 0 ? void 0 : _data$applicationData16.applicationType;
    let edcrResponse = await Digit.OBPSService.edcr_report_download({
      BPA: {
        ...requestData
      }
    });
    const responseStatus = parseInt(edcrResponse.status, 10);
    if (responseStatus === 201 || responseStatus === 200) {
      mode == "print" ? printPdf(new Blob([edcrResponse.data], {
        type: "application/pdf"
      })) : downloadPdf(new Blob([edcrResponse.data], {
        type: "application/pdf"
      }), `edcrReport.pdf`);
    }
  }
  async function getRevocationPDFSearch({
    tenantId,
    ...params
  }) {
    let requestData = {
      ...(data === null || data === void 0 ? void 0 : data.applicationData)
    };
    let response = await Digit.PaymentService.generatePdf(tenantId, {
      Bpa: [requestData]
    }, "bpa-revocation");
    const fileStore = await Digit.PaymentService.printReciept(tenantId, {
      fileStoreIds: response.filestoreIds[0]
    });
    window.open(fileStore[response === null || response === void 0 ? void 0 : response.filestoreIds[0]], "_blank");
  }
  const [showOptions, setShowOptions] = useState(false);
  const {
    isLoading: updatingApplication,
    isError: updateApplicationError,
    data: updateResponse,
    error: updateError,
    mutate
  } = Digit.Hooks.obps.useApplicationActions(tenantId);
  const nocMutation = Digit.Hooks.obps.useObpsAPI(tenantId, true);
  let risType = "";
  sessionStorage.setItem("bpaApplicationDetails", true);
  function checkHead(head) {
    if (head === "ES_NEW_APPLICATION_LOCATION_DETAILS") {
      return "TL_CHECK_ADDRESS";
    } else if (head === "ES_NEW_APPLICATION_OWNERSHIP_DETAILS") {
      return "TL_OWNERSHIP_DETAILS_HEADER";
    } else {
      return head;
    }
  }
  const closeToast = () => {
    setShowToast(null);
    setError(null);
  };
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  const onFormValueChange = (setValue, formData, formState) => {
    setSubmitValve(!Object.keys(formState.errors).length);
  };
  let configs = newConfig$1 !== null && newConfig$1 !== void 0 && newConfig$1.InspectionReportConfig ? newConfig$1 === null || newConfig$1 === void 0 ? void 0 : newConfig$1.InspectionReportConfig : newConfig;
  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: "BPA"
  });
  if (workflowDetails && workflowDetails.data && !workflowDetails.isLoading) {
    var _workflowDetails$data, _workflowDetails$data2;
    workflowDetails.data.initialActionState = (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.initialActionState) || {
      ...(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data2 = workflowDetails.data) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.actionState)
    } || {};
    workflowDetails.data.actionState = {
      ...workflowDetails.data
    };
  }
  if (mdmsData !== null && mdmsData !== void 0 && (_mdmsData$BPA = mdmsData.BPA) !== null && _mdmsData$BPA !== void 0 && _mdmsData$BPA.RiskTypeComputation && data !== null && data !== void 0 && data.edcrDetails) {
    var _mdmsData$BPA2, _data$edcrDetails, _data$edcrDetails$pla, _data$edcrDetails$pla2, _data$edcrDetails2, _data$edcrDetails2$pl, _data$applicationDeta6;
    risType = Digit.Utils.obps.calculateRiskType(mdmsData === null || mdmsData === void 0 ? void 0 : (_mdmsData$BPA2 = mdmsData.BPA) === null || _mdmsData$BPA2 === void 0 ? void 0 : _mdmsData$BPA2.RiskTypeComputation, data === null || data === void 0 ? void 0 : (_data$edcrDetails = data.edcrDetails) === null || _data$edcrDetails === void 0 ? void 0 : (_data$edcrDetails$pla = _data$edcrDetails.planDetail) === null || _data$edcrDetails$pla === void 0 ? void 0 : (_data$edcrDetails$pla2 = _data$edcrDetails$pla.plot) === null || _data$edcrDetails$pla2 === void 0 ? void 0 : _data$edcrDetails$pla2.area, data === null || data === void 0 ? void 0 : (_data$edcrDetails2 = data.edcrDetails) === null || _data$edcrDetails2 === void 0 ? void 0 : (_data$edcrDetails2$pl = _data$edcrDetails2.planDetail) === null || _data$edcrDetails2$pl === void 0 ? void 0 : _data$edcrDetails2$pl.blocks);
    data === null || data === void 0 ? void 0 : (_data$applicationDeta6 = data.applicationDetails) === null || _data$applicationDeta6 === void 0 ? void 0 : _data$applicationDeta6.map(detail => {
      if (detail !== null && detail !== void 0 && detail.isInsert) {
        var _detail$values;
        (_detail$values = detail.values) === null || _detail$values === void 0 ? void 0 : _detail$values.forEach(value => {
          if (value !== null && value !== void 0 && value.isInsert) value.value = `WF_BPA_${risType}`;
        });
      }
    });
  }
  const userInfo = Digit.UserService.getUser();
  const rolearray = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : _userInfo$info.roles.filter(item => {
    if (item.code == "CEMP" && item.tenantId === tenantId || item.code == "CITIZEN") return true;
  });
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.processInstances) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0) {
    var _get, _workflowDetails$data5, _workflowDetails$data6;
    let filteredActions = [];
    filteredActions = (_get = get(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data5 = workflowDetails.data) === null || _workflowDetails$data5 === void 0 ? void 0 : _workflowDetails$data5.processInstances[0], "nextActions", [])) === null || _get === void 0 ? void 0 : _get.filter(item => item.action != "ADHOC");
    let actions = orderBy(filteredActions, ["action"], ["desc"]);
    if ((!actions || (actions === null || actions === void 0 ? void 0 : actions.length) == 0) && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data6 = workflowDetails.data) !== null && _workflowDetails$data6 !== void 0 && _workflowDetails$data6.actionState) workflowDetails.data.actionState.nextActions = [];
  }
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data7 = workflowDetails.data) === null || _workflowDetails$data7 === void 0 ? void 0 : (_workflowDetails$data8 = _workflowDetails$data7.nextActions) === null || _workflowDetails$data8 === void 0 ? void 0 : _workflowDetails$data8.length) > 0) {
    var _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data9 = workflowDetails.data) === null || _workflowDetails$data9 === void 0 ? void 0 : (_workflowDetails$data10 = _workflowDetails$data9.nextActions) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.filter(actn => actn.action !== "INITIATE");
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : (_workflowDetails$data12 = _workflowDetails$data11.nextActions) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.filter(actn => actn.action !== "ADHOC");
  }
  if (rolearray) {
    var _workflowDetails$data13, _workflowDetails$data14;
    workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data13 = workflowDetails.data) === null || _workflowDetails$data13 === void 0 ? void 0 : (_workflowDetails$data14 = _workflowDetails$data13.nextActions) === null || _workflowDetails$data14 === void 0 ? void 0 : _workflowDetails$data14.forEach(action => {
      if ((action === null || action === void 0 ? void 0 : action.action) === "PAY") {
        var _data$applicationData17, _data$applicationData18, _data$applicationData19;
        action.redirectionUrll = {
          pathname: `${getBusinessServices(data === null || data === void 0 ? void 0 : (_data$applicationData17 = data.applicationData) === null || _data$applicationData17 === void 0 ? void 0 : _data$applicationData17.businessService, data === null || data === void 0 ? void 0 : (_data$applicationData18 = data.applicationData) === null || _data$applicationData18 === void 0 ? void 0 : _data$applicationData18.status)}/${data === null || data === void 0 ? void 0 : (_data$applicationData19 = data.applicationData) === null || _data$applicationData19 === void 0 ? void 0 : _data$applicationData19.applicationNo}/${tenantId}?tenantId=${tenantId}`,
          state: tenantId
        };
      }
    });
  }
  let dowloadOptions = [];
  if ((data === null || data === void 0 ? void 0 : (_data$collectionBillD = data.collectionBillDetails) === null || _data$collectionBillD === void 0 ? void 0 : _data$collectionBillD.length) > 0) {
    const bpaPayments = cloneDeep(data === null || data === void 0 ? void 0 : data.collectionBillDetails);
    bpaPayments.forEach(pay => {
      var _pay$paymentDetails$, _pay$paymentDetails$2, _pay$paymentDetails$3, _pay$paymentDetails$4, _pay$paymentDetails$5;
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$ = pay.paymentDetails[0]) === null || _pay$paymentDetails$ === void 0 ? void 0 : _pay$paymentDetails$.businessService) === "BPA.NC_OC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData20, _data$applicationData21;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData20 = data.applicationData) === null || _data$applicationData20 === void 0 ? void 0 : _data$applicationData20.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData21 = data.applicationData) === null || _data$applicationData21 === void 0 ? void 0 : _data$applicationData21.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$2 = pay.paymentDetails[0]) === null || _pay$paymentDetails$2 === void 0 ? void 0 : _pay$paymentDetails$2.businessService) === "BPA.NC_OC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_OC_DEV_PEN_RECEIPT"),
          onClick: () => {
            var _data$applicationData22, _data$applicationData23;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData22 = data.applicationData) === null || _data$applicationData22 === void 0 ? void 0 : _data$applicationData22.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData23 = data.applicationData) === null || _data$applicationData23 === void 0 ? void 0 : _data$applicationData23.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$3 = pay.paymentDetails[0]) === null || _pay$paymentDetails$3 === void 0 ? void 0 : _pay$paymentDetails$3.businessService) === "BPA.LOW_RISK_PERMIT_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData24, _data$applicationData25;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData24 = data.applicationData) === null || _data$applicationData24 === void 0 ? void 0 : _data$applicationData24.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData25 = data.applicationData) === null || _data$applicationData25 === void 0 ? void 0 : _data$applicationData25.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$4 = pay.paymentDetails[0]) === null || _pay$paymentDetails$4 === void 0 ? void 0 : _pay$paymentDetails$4.businessService) === "BPA.NC_APP_FEE") {
        dowloadOptions.push({
          order: 1,
          label: t("BPA_APP_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData26, _data$applicationData27;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData26 = data.applicationData) === null || _data$applicationData26 === void 0 ? void 0 : _data$applicationData26.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData27 = data.applicationData) === null || _data$applicationData27 === void 0 ? void 0 : _data$applicationData27.applicationNo
            });
          }
        });
      }
      if ((pay === null || pay === void 0 ? void 0 : (_pay$paymentDetails$5 = pay.paymentDetails[0]) === null || _pay$paymentDetails$5 === void 0 ? void 0 : _pay$paymentDetails$5.businessService) === "BPA.NC_SAN_FEE") {
        dowloadOptions.push({
          order: 2,
          label: t("BPA_SAN_FEE_RECEIPT"),
          onClick: () => {
            var _data$applicationData28, _data$applicationData29;
            return getRecieptSearch({
              tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData28 = data.applicationData) === null || _data$applicationData28 === void 0 ? void 0 : _data$applicationData28.tenantId,
              payments: pay,
              consumerCodes: data === null || data === void 0 ? void 0 : (_data$applicationData29 = data.applicationData) === null || _data$applicationData29 === void 0 ? void 0 : _data$applicationData29.applicationNo
            });
          }
        });
      }
    });
  }
  if (data && (data === null || data === void 0 ? void 0 : (_data$applicationData30 = data.applicationData) === null || _data$applicationData30 === void 0 ? void 0 : _data$applicationData30.businessService) === "BPA_LOW" && (data === null || data === void 0 ? void 0 : (_data$collectionBillD2 = data.collectionBillDetails) === null || _data$collectionBillD2 === void 0 ? void 0 : _data$collectionBillD2.length) > 0) {
    var _data$applicationData31, _data$applicationData33;
    !(data !== null && data !== void 0 && (_data$applicationData31 = data.applicationData) !== null && _data$applicationData31 !== void 0 && _data$applicationData31.status.includes("REVOCATION")) && dowloadOptions.push({
      order: 3,
      label: t("BPA_PERMIT_ORDER"),
      onClick: () => {
        var _data$applicationData32;
        return getPermitOccupancyOrderSearch({
          tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData32 = data.applicationData) === null || _data$applicationData32 === void 0 ? void 0 : _data$applicationData32.tenantId
        }, "buildingpermit-low");
      }
    });
    (data === null || data === void 0 ? void 0 : (_data$applicationData33 = data.applicationData) === null || _data$applicationData33 === void 0 ? void 0 : _data$applicationData33.status.includes("REVOCATION")) && dowloadOptions.push({
      order: 3,
      label: t("BPA_REVOCATION_PDF_LABEL"),
      onClick: () => {
        var _data$applicationData34;
        return getRevocationPDFSearch({
          tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData34 = data.applicationData) === null || _data$applicationData34 === void 0 ? void 0 : _data$applicationData34.tenantId
        });
      }
    });
  } else if (data && (data === null || data === void 0 ? void 0 : (_data$applicationData35 = data.applicationData) === null || _data$applicationData35 === void 0 ? void 0 : _data$applicationData35.businessService) === "BPA" && (data === null || data === void 0 ? void 0 : (_data$collectionBillD3 = data.collectionBillDetails) === null || _data$collectionBillD3 === void 0 ? void 0 : _data$collectionBillD3.length) > 0) {
    var _data$applicationData36;
    if ((data === null || data === void 0 ? void 0 : (_data$applicationData36 = data.applicationData) === null || _data$applicationData36 === void 0 ? void 0 : _data$applicationData36.status) === "APPROVED") {
      dowloadOptions.push({
        order: 3,
        label: t("BPA_PERMIT_ORDER"),
        onClick: () => {
          var _data$applicationData37;
          return getPermitOccupancyOrderSearch({
            tenantId: data === null || data === void 0 ? void 0 : (_data$applicationData37 = data.applicationData) === null || _data$applicationData37 === void 0 ? void 0 : _data$applicationData37.tenantId
          }, "buildingpermit");
        }
      });
    }
  }
  if (data !== null && data !== void 0 && data.comparisionReport && data && (data === null || data === void 0 ? void 0 : (_data$applicationData38 = data.applicationData) === null || _data$applicationData38 === void 0 ? void 0 : _data$applicationData38.businessService) === "BPA_OC") {
    dowloadOptions.push({
      order: 4,
      label: t("BPA_COMPARISON_REPORT_LABEL"),
      onClick: () => {
        var _data$comparisionRepo;
        return window.open(data === null || data === void 0 ? void 0 : (_data$comparisionRepo = data.comparisionReport) === null || _data$comparisionRepo === void 0 ? void 0 : _data$comparisionRepo.comparisonReport, "_blank");
      }
    });
  }
  dowloadOptions.sort(function (a, b) {
    return a.order - b.order;
  });
  if ((workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data15 = workflowDetails.data) === null || _workflowDetails$data15 === void 0 ? void 0 : (_workflowDetails$data16 = _workflowDetails$data15.nextActions) === null || _workflowDetails$data16 === void 0 ? void 0 : _workflowDetails$data16.length) > 0) {
    var _workflowDetails$data17, _workflowDetails$data18;
    workflowDetails.data.nextActions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data17 = workflowDetails.data) === null || _workflowDetails$data17 === void 0 ? void 0 : (_workflowDetails$data18 = _workflowDetails$data17.nextActions) === null || _workflowDetails$data18 === void 0 ? void 0 : _workflowDetails$data18.filter(actn => actn.action !== "SKIP_PAYMENT" && actn.action !== "EDIT");
  }
  const results = data === null || data === void 0 ? void 0 : (_data$applicationDeta7 = data.applicationDetails) === null || _data$applicationDeta7 === void 0 ? void 0 : _data$applicationDeta7.filter(element => {
    if (Object.keys(element).length !== 0) {
      return true;
    }
    return false;
  });
  data.applicationDetails = results;
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-main-application-details"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-application-details",
    style: {
      marginBottom: "15px"
    }
  }, /*#__PURE__*/React__default.createElement(Header, {
    styles: {
      marginLeft: "0px",
      paddingTop: "10px",
      fontSize: "32px"
    }
  }, t("CS_TITLE_APPLICATION_DETAILS")), dowloadOptions && dowloadOptions.length > 0 && /*#__PURE__*/React__default.createElement(MultiLink, {
    className: "multilinkWrapper employee-mulitlink-main-div",
    onHeadClick: () => setShowOptions(!showOptions),
    displayOptions: showOptions,
    options: dowloadOptions,
    downloadBtnClassName: "employee-download-btn-className",
    optionsClassName: "employee-options-btn-className"
  })), (data === null || data === void 0 ? void 0 : (_data$applicationData39 = data.applicationData) === null || _data$applicationData39 === void 0 ? void 0 : _data$applicationData39.status) === "FIELDINSPECTION_INPROGRESS" && (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.roles.filter(role => role.code === "BPA_FIELD_INSPECTOR")).length > 0 && /*#__PURE__*/React__default.createElement(FormComposer, {
    heading: t(""),
    isDisabled: !canSubmit,
    config: configs.map(config => {
      return {
        ...config,
        body: config.body.filter(a => {
          return !a.hideInEmployee;
        }),
        head: checkHead(config.head)
      };
    }),
    fieldStyle: {
      marginRight: 0
    },
    submitInForm: false,
    defaultValues: defaultValues,
    onFormValueChange: onFormValueChange,
    breaklineStyle: {
      border: "0px"
    },
    className: "employeeCard-override"
  }), /*#__PURE__*/React__default.createElement(ApplicationDetails$1, {
    applicationDetails: data,
    isLoading: isLoading,
    isDataLoading: isLoading,
    applicationData: data === null || data === void 0 ? void 0 : data.applicationData,
    nocMutation: nocMutation,
    mutate: mutate,
    workflowDetails: workflowDetails,
    businessService: workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data19 = workflowDetails.data) !== null && _workflowDetails$data19 !== void 0 && _workflowDetails$data19.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data20 = workflowDetails.data) === null || _workflowDetails$data20 === void 0 ? void 0 : _workflowDetails$data20.applicationBusinessService : data === null || data === void 0 ? void 0 : (_data$applicationData40 = data.applicationData) === null || _data$applicationData40 === void 0 ? void 0 : _data$applicationData40.businessService,
    moduleCode: "BPA",
    showToast: showToast,
    ActionBarStyle: isMobile ? {} : {
      paddingRight: "50px"
    },
    MenuStyle: isMobile ? {} : {
      right: "50px"
    },
    setShowToast: setShowToast,
    closeToast: closeToast,
    statusAttribute: "state",
    timelineStatusPrefix: `WF_${workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data21 = workflowDetails.data) !== null && _workflowDetails$data21 !== void 0 && _workflowDetails$data21.applicationBusinessService ? workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data22 = workflowDetails.data) === null || _workflowDetails$data22 === void 0 ? void 0 : _workflowDetails$data22.applicationBusinessService : data === null || data === void 0 ? void 0 : (_data$applicationData41 = data.applicationData) === null || _data$applicationData41 === void 0 ? void 0 : _data$applicationData41.businessService}_`
  })));
};

const AddressMapper = ({
  data,
  header,
  t
}) => {
  delete data["active"];
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, header), /*#__PURE__*/React__default.createElement(StatusTable, null, Object.keys(data).map((key, index) => /*#__PURE__*/React__default.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.toUpperCase()}`),
    text: data[key] || ""
  }))));
};

const SplittedFeeData = ({
  splittedFeeData,
  t
}) => {
  return /*#__PURE__*/React__default.createElement(StatusTable, null, splittedFeeData.map((item, index) => Object.entries(item).map(([key, value]) => key !== "estimateAmount" && /*#__PURE__*/React__default.createElement(Row, {
    key: `${index}_${key}`,
    className: "border-none",
    label: t(`BPA_COMMON_${key.toUpperCase()}_FEE`),
    text: `₹ ${value || "0"}`
  }))));
};

const CheckPage = ({
  onSubmit,
  value
}) => {
  var _user$info, _value$businessServic, _documents$documents, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _value$data, _value$data2, _additionalDetails$ap, _additionalDetails$se, _data$edcrDetails, _datafromAPI$planDeta3, _datafromAPI$planDeta4, _datafromAPI$planDeta5, _datafromAPI$planDeta6, _datafromAPI$planDeta7, _datafromAPI$planDeta8, _datafromAPI$planDeta9, _datafromAPI$planDeta10, _datafromAPI$planDeta11, _datafromAPI$planDeta12, _value$additionalDeta, _value$additionalDeta2, _value$data3, _value$additionalDeta3, _value$additionalDeta4, _data$scrutinyNumber, _value$additionalDeta5, _value$additionalDeta6, _value$additionalDeta7, _value$additionalDeta8, _value$additionalDeta9, _value$additionalDeta10, _value$additionalDeta11, _value$additionalDeta12, _value$additionalDeta13, _value$additionalDeta14, _value$additionalDeta15, _value$additionalDeta16, _datafromAPI$planDeta13, _datafromAPI$planDeta14, _datafromAPI$planDeta15, _datafromAPI$planDeta16, _datafromAPI$planDeta17, _datafromAPI$planDeta18, _datafromAPI$planDeta19, _datafromAPI$planDeta20, _datafromAPI$planDeta21, _datafromAPI$planDeta22, _datafromAPI$planDeta23, _datafromAPI$planDeta24, _datafromAPI$planDeta25, _splittedFeeData$;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  let user = Digit.UserService.getUser();
  const tenantId = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.permanentCity) || (value === null || value === void 0 ? void 0 : value.tenantId) || Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const isUD = value === null || value === void 0 ? void 0 : (_value$businessServic = value.businessService) === null || _value$businessServic === void 0 ? void 0 : _value$businessServic.includes("UD");
  const {
    data,
    address,
    owners,
    nocDocuments,
    documents,
    additionalDetails,
    subOccupancy,
    PrevStateDocuments,
    PrevStateNocDocuments,
    applicationNo,
    taxHeadEstimates,
    professionaldetails
  } = value;
  const isEditApplication = window.location.href.includes("editApplication");
  console.log({
    data,
    address,
    owners,
    nocDocuments,
    documents,
    additionalDetails,
    subOccupancy,
    PrevStateDocuments,
    PrevStateNocDocuments,
    applicationNo,
    professionaldetails
  }, "vALLUEEEE");
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : (_documents$documents = documents.documents) === null || _documents$documents === void 0 ? void 0 : _documents$documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading,
    error
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const {
    data: datafromAPI,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(tenantId, value === null || value === void 0 ? void 0 : (_value$data = value.data) === null || _value$data === void 0 ? void 0 : _value$data.scrutinyNumber, {
    enabled: value !== null && value !== void 0 && (_value$data2 = value.data) !== null && _value$data2 !== void 0 && _value$data2.scrutinyNumber ? true : false
  });
  const splittedFeeData = taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.map(item => {
    return Object.fromEntries(Object.entries(item).filter(([key, value]) => typeof value === 'number'));
  });
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/bpa/${additionalDetails === null || additionalDetails === void 0 ? void 0 : (_additionalDetails$ap = additionalDetails.applicationType) === null || _additionalDetails$ap === void 0 ? void 0 : _additionalDetails$ap.toLowerCase()}/${additionalDetails === null || additionalDetails === void 0 ? void 0 : (_additionalDetails$se = additionalDetails.serviceType) === null || _additionalDetails$se === void 0 ? void 0 : _additionalDetails$se.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/bpa/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/bpa/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}`;
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const khasraAreaHeaders = ['Khasra', 'Area'];
  const landDevelopmentHeaders = ['Plot No', 'Plot Area', 'Land Type'];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }
  function getBlockSubOccupancy(index) {
    let returnValueArray = [];
    subOccupancy && subOccupancy[`Block_${index + 1}`] && subOccupancy[`Block_${index + 1}`].map(ob => {
      var _ob$i18nKey;
      returnValueArray.push(`${t(stringReplaceAll(ob === null || ob === void 0 ? void 0 : (_ob$i18nKey = ob.i18nKey) === null || _ob$i18nKey === void 0 ? void 0 : _ob$i18nKey.toUpperCase(), "-", "_"))}`);
    });
    return returnValueArray !== null && returnValueArray !== void 0 && returnValueArray.length ? returnValueArray.join(', ') : "NA";
  }
  if (pdfLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 5,
    flow: "BPA"
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER"))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: applicationNo ? applicationNo : ""
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: convertEpochToDateDMY(Number(data === null || data === void 0 ? void 0 : data.applicationDate))
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: data ? t(`WF_BPA_${data === null || data === void 0 ? void 0 : (_data$edcrDetails = data.edcrDetails) === null || _data$edcrDetails === void 0 ? void 0 : _data$edcrDetails.appliactionType}`) : ''
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`),
    text: t(data === null || data === void 0 ? void 0 : data.serviceType)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`),
    text: data === null || data === void 0 ? void 0 : data.occupancyType
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`),
    text: data ? t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.riskType}`) : ''
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: data === null || data === void 0 ? void 0 : data.applicantName
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_NEW_TRADE_DETAILS_HEADER_DETAILS")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/location`)
  })), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_CITY_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.city) || t("CS_NA")
  }), !isUD ? /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_NOTIFIED-AREA_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.locality) || t("CS_NA")
  }) : /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_ULB-AREA_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.locality) || t("CS_NA")
  }), !isUD && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_AREA_TYPE_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.areaType) || t("CS_NA")
  }), !isUD ? /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_VILLAGE-AREA_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.village) || t("CS_NA")
  }) : /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_WARD-AREA_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.village) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_PLOT_DETAILS_TITLE")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/plot-details`)
  })), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    textStyle: {
      paddingLeft: "12px"
    },
    label: t(`BPA_BOUNDARY_PLOT_AREA_LABEL`),
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta3 = datafromAPI.planDetail) !== null && _datafromAPI$planDeta3 !== void 0 && (_datafromAPI$planDeta4 = _datafromAPI$planDeta3.planInformation) !== null && _datafromAPI$planDeta4 !== void 0 && _datafromAPI$planDeta4.plotArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta5 = datafromAPI.planDetail) === null || _datafromAPI$planDeta5 === void 0 ? void 0 : (_datafromAPI$planDeta6 = _datafromAPI$planDeta5.planInformation) === null || _datafromAPI$planDeta6 === void 0 ? void 0 : _datafromAPI$planDeta6.plotArea} ${t(`BPA_SQ_MT_LABEL`)}` : t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_PLOT_NUMBER_LABEL`),
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta7 = datafromAPI.planDetail) === null || _datafromAPI$planDeta7 === void 0 ? void 0 : (_datafromAPI$planDeta8 = _datafromAPI$planDeta7.planInformation) === null || _datafromAPI$planDeta8 === void 0 ? void 0 : _datafromAPI$planDeta8.plotNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_KHATHA_NUMBER_LABEL`),
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta9 = datafromAPI.planDetail) === null || _datafromAPI$planDeta9 === void 0 ? void 0 : (_datafromAPI$planDeta10 = _datafromAPI$planDeta9.planInformation) === null || _datafromAPI$planDeta10 === void 0 ? void 0 : _datafromAPI$planDeta10.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_KHATHA_NUMBER_LABEL`),
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta11 = datafromAPI.planDetail) === null || _datafromAPI$planDeta11 === void 0 ? void 0 : (_datafromAPI$planDeta12 = _datafromAPI$planDeta11.planInformation) === null || _datafromAPI$planDeta12 === void 0 ? void 0 : _datafromAPI$planDeta12.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_PLOT_WHEATHER_CHANGE_OF_LAND_USE_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$additionalDeta = value.additionalDetails) === null || _value$additionalDeta === void 0 ? void 0 : (_value$additionalDeta2 = _value$additionalDeta.cluInvolved) === null || _value$additionalDeta2 === void 0 ? void 0 : _value$additionalDeta2.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_PLOT_KHATAUNI_NO_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$data3 = value.data) === null || _value$data3 === void 0 ? void 0 : _value$data3.khatauniNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_STEPPER_KHASRA_AREA_HEADER")), /*#__PURE__*/React__default.createElement(DataTable, {
    data: value === null || value === void 0 ? void 0 : (_value$additionalDeta3 = value.additionalDetails) === null || _value$additionalDeta3 === void 0 ? void 0 : _value$additionalDeta3.khasraArea,
    headers: khasraAreaHeaders
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_PLOT_DETAILS_AFTER_SUBDIVISION")), /*#__PURE__*/React__default.createElement(DataTable, {
    data: value === null || value === void 0 ? void 0 : (_value$additionalDeta4 = value.additionalDetails) === null || _value$additionalDeta4 === void 0 ? void 0 : _value$additionalDeta4.landDevelopment,
    headers: landDevelopmentHeaders
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_STEPPER_SCRUTINY_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/scrutiny-details`)
  })), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px"
    }
  }, t("BPA_EDCR_DETAILS")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_EDCR_NO_LABEL"),
    text: data === null || data === void 0 ? void 0 : (_data$scrutinyNumber = data.scrutinyNumber) === null || _data$scrutinyNumber === void 0 ? void 0 : _data$scrutinyNumber.edcrNumber
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_UPLOADED_PLAN_DIAGRAM")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.updatedDxfFile)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_UPLOADED_PLAN_DXF`)), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_SCRUNTINY_REPORT_OUTPUT")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.planReport)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_SCRUTINY_REPORT_PDF`)), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_APPLICATION_SETBACKS_INFORMATION")), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_SETBACLS_TYPE_FRONT_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$additionalDeta5 = value.additionalDetails) === null || _value$additionalDeta5 === void 0 ? void 0 : (_value$additionalDeta6 = _value$additionalDeta5.landInfo) === null || _value$additionalDeta6 === void 0 ? void 0 : (_value$additionalDeta7 = _value$additionalDeta6.checklistdata) === null || _value$additionalDeta7 === void 0 ? void 0 : _value$additionalDeta7.setbackfront) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_SETBACKS_TYPE_REAR_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$additionalDeta8 = value.additionalDetails) === null || _value$additionalDeta8 === void 0 ? void 0 : (_value$additionalDeta9 = _value$additionalDeta8.landInfo) === null || _value$additionalDeta9 === void 0 ? void 0 : (_value$additionalDeta10 = _value$additionalDeta9.checklistdata) === null || _value$additionalDeta10 === void 0 ? void 0 : _value$additionalDeta10.setbackrear) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_SETBACKS_TYPE_LEFT_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$additionalDeta11 = value.additionalDetails) === null || _value$additionalDeta11 === void 0 ? void 0 : (_value$additionalDeta12 = _value$additionalDeta11.landInfo) === null || _value$additionalDeta12 === void 0 ? void 0 : (_value$additionalDeta13 = _value$additionalDeta12.checklistdata) === null || _value$additionalDeta13 === void 0 ? void 0 : _value$additionalDeta13.setbackleft) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_SETBACKS_TYPE_RIGHT_LABEL`),
    text: (value === null || value === void 0 ? void 0 : (_value$additionalDeta14 = value.additionalDetails) === null || _value$additionalDeta14 === void 0 ? void 0 : (_value$additionalDeta15 = _value$additionalDeta14.landInfo) === null || _value$additionalDeta15 === void 0 ? void 0 : (_value$additionalDeta16 = _value$additionalDeta15.checklistdata) === null || _value$additionalDeta16 === void 0 ? void 0 : _value$additionalDeta16.setbackright) || t("CS_NA")
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px"
    }
  }, t("BPA_BUILDING_EXTRACT_HEADER")), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_TOTAL_BUILT_UP_AREA_HEADER"),
    text: `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta13 = datafromAPI.planDetail) === null || _datafromAPI$planDeta13 === void 0 ? void 0 : (_datafromAPI$planDeta14 = _datafromAPI$planDeta13.blocks) === null || _datafromAPI$planDeta14 === void 0 ? void 0 : (_datafromAPI$planDeta15 = _datafromAPI$planDeta14[0]) === null || _datafromAPI$planDeta15 === void 0 ? void 0 : (_datafromAPI$planDeta16 = _datafromAPI$planDeta15.building) === null || _datafromAPI$planDeta16 === void 0 ? void 0 : _datafromAPI$planDeta16.totalBuitUpArea} ${t("BPA_SQ_MTRS_LABEL")}`
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL"),
    text: datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta17 = datafromAPI.planDetail) === null || _datafromAPI$planDeta17 === void 0 ? void 0 : (_datafromAPI$planDeta18 = _datafromAPI$planDeta17.blocks) === null || _datafromAPI$planDeta18 === void 0 ? void 0 : (_datafromAPI$planDeta19 = _datafromAPI$planDeta18[0]) === null || _datafromAPI$planDeta19 === void 0 ? void 0 : (_datafromAPI$planDeta20 = _datafromAPI$planDeta19.building) === null || _datafromAPI$planDeta20 === void 0 ? void 0 : _datafromAPI$planDeta20.totalFloors
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_HEIGHT_FROM_GROUND_LEVEL_FROM_MUMTY"),
    text: `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta21 = datafromAPI.planDetail) === null || _datafromAPI$planDeta21 === void 0 ? void 0 : (_datafromAPI$planDeta22 = _datafromAPI$planDeta21.blocks) === null || _datafromAPI$planDeta22 === void 0 ? void 0 : (_datafromAPI$planDeta23 = _datafromAPI$planDeta22[0]) === null || _datafromAPI$planDeta23 === void 0 ? void 0 : (_datafromAPI$planDeta24 = _datafromAPI$planDeta23.building) === null || _datafromAPI$planDeta24 === void 0 ? void 0 : _datafromAPI$planDeta24.declaredBuildingHeight} ${t("BPA_MTRS_LABEL")}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: "20px"
    }
  }, t("BPA_OCC_SUBOCC_HEADER")), datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta25 = datafromAPI.planDetail) === null || _datafromAPI$planDeta25 === void 0 ? void 0 : _datafromAPI$planDeta25.blocks.map((block, index) => {
    var _datafromAPI$planDeta26, _datafromAPI$planDeta27;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta26 = datafromAPI.planDetail) === null || _datafromAPI$planDeta26 === void 0 ? void 0 : (_datafromAPI$planDeta27 = _datafromAPI$planDeta26.blocks) === null || _datafromAPI$planDeta27 === void 0 ? void 0 : _datafromAPI$planDeta27.length) > 1 ? {
        marginTop: "19px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        borderRadius: "4px",
        padding: "8px",
        lineHeight: "19px",
        maxWidth: "960px",
        minWidth: "280px"
      } : {}
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginTop: "15px",
        fontSize: "18px"
      }
    }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: {
        wordBreak: "break-word"
      },
      label: t("BPA_SUB_OCCUPANCY_LABEL"),
      text: getBlockSubOccupancy(index) === "" ? t("CS_NA") : getBlockSubOccupancy(index)
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        overflow: "scroll"
      }
    }, /*#__PURE__*/React__default.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    })));
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: '16px'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_PROFESSIONAL_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/private-professional-information`)
  })), /*#__PURE__*/React__default.createElement(ProfessionalsAddressMapper, {
    data: professionaldetails,
    t: t
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_APPLICANT_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/owner-details`)
  })), (owners === null || owners === void 0 ? void 0 : owners.owners) && (owners === null || owners === void 0 ? void 0 : owners.owners.map((ob, index) => {
    var _owners$owners, _ob$gender;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (owners === null || owners === void 0 ? void 0 : (_owners$owners = owners.owners) === null || _owners$owners === void 0 ? void 0 : _owners$owners.length) > 1 ? {
        marginTop: "19px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        borderRadius: "4px",
        padding: "8px",
        lineHeight: "19px",
        maxWidth: "960px",
        minWidth: "280px"
      } : {}
    }, owners.owners.length > 1 && /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("COMMON_OWNER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: index == 0 && owners.owners.length == 1 ? {
        paddingLeft: "12px"
      } : {},
      label: t(`CORE_COMMON_NAME`),
      text: ob === null || ob === void 0 ? void 0 : ob.name
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_APPLICANT_GENDER_LABEL`),
      text: t(ob === null || ob === void 0 ? void 0 : (_ob$gender = ob.gender) === null || _ob$gender === void 0 ? void 0 : _ob$gender.i18nKey)
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`CORE_COMMON_MOBILE_NUMBER`),
      text: ob === null || ob === void 0 ? void 0 : ob.mobileNumber
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_IS_PRIMARY_OWNER_LABEL`),
      text: `${ob === null || ob === void 0 ? void 0 : ob.isPrimaryOwner}`
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`CORE_COMMON_GUARDIAN_NAME`),
      text: `${ob === null || ob === void 0 ? void 0 : ob.fatherOrHusbandName}`
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_APPLICANT_EMAIL_LABEL`),
      text: `${ob === null || ob === void 0 ? void 0 : ob.emailId}`
    }), /*#__PURE__*/React__default.createElement(AddressMapper, {
      data: ob === null || ob === void 0 ? void 0 : ob.permanentAddress,
      header: t("BPA_OWNER_PERMANENT_ADDRESS_DETAILS"),
      t: t
    }), /*#__PURE__*/React__default.createElement(AddressMapper, {
      data: ob === null || ob === void 0 ? void 0 : ob.correspondenceAddress,
      header: t("BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS"),
      t: t
    })));
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_DOCUMENT_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        margin: "-84px"
      }
    }),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/document-details`)
  })), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: getOrderDocuments(applicationDocs),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_SUMMARY_FEE_EST")), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(SplittedFeeData, {
    splittedFeeData: splittedFeeData,
    t: t
  }), /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement(CardHeader, null, "\u20B9 ", (splittedFeeData === null || splittedFeeData === void 0 ? void 0 : (_splittedFeeData$ = splittedFeeData[0]) === null || _splittedFeeData$ === void 0 ? void 0 : _splittedFeeData$.estimateAmount) || "0"), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_SEND_TO_STRUCTURAL_ENGINEER"),
    onSubmit: onSubmit
  })));
};

const CheckPage$1 = ({
  onSubmit,
  formData,
  currStep
}) => {
  var _Digit, _owners$, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _formData$application, _formData$serviceType, _formData$auditDetail, _owners$2, _landAreaDetails$loca, _landAreaDetails$vill, _descriptionOfLand$kh, _descriptionOfLand$pr, _descriptionOfLand$us, _descriptionOfLand$ty, _descriptionOfLand$ty2, _descriptionOfLand$ty3, _descriptionOfLand$kh2;
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const BusinessService = udCode ? "BPA.FORM_11_FEE_UD" : "BPA.FORM_11_FEE";
  const {
    applicationNo,
    landAreaDetails,
    descriptionOfLand,
    checklist,
    landInfo,
    nocDocuments,
    PrevStateDocuments,
    PrevStateNocDocuments
  } = formData;
  const owners = landInfo === null || landInfo === void 0 ? void 0 : landInfo.owners;
  const ownerPermanentAddress = owners === null || owners === void 0 ? void 0 : (_owners$ = owners[0]) === null || _owners$ === void 0 ? void 0 : _owners$.permanentAddress;
  const docs = formData === null || formData === void 0 ? void 0 : formData.documents;
  const documents = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount;
  let processingFee;
  let applicationFee;
  if (!udCode && totalAmount !== undefined) {
    processingFee = totalAmount;
  } else {
    var _formData$description, _formData$description2;
    applicationFee = ((_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : (_formData$description2 = _formData$description.useType) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.name) === "Residential" ? 500 : 1000;
    processingFee = totalAmount - applicationFee;
  }
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationType) === null || _formData$application === void 0 ? void 0 : _formData$application.toLowerCase()}/${formData === null || formData === void 0 ? void 0 : (_formData$serviceType = formData.serviceType) === null || _formData$serviceType === void 0 ? void 0 : _formData$serviceType.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (!applicationNo) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
      flow: "Form11",
      currentStep: currStep.step
    }), /*#__PURE__*/React__default.createElement(Card, {
      style: {
        paddingRight: "1rem",
        marginTop: '1rem'
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      display: "flex",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER"))), /*#__PURE__*/React__default.createElement("hr", {
      style: {
        backgroundColor: "#cccccc",
        height: "2px",
        marginBottom: "20px"
      }
    }), /*#__PURE__*/React__default.createElement(CardHeader, {
      styles: {
        textAlign: 'center'
      }
    }, "No Application Data Available.")));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
    flow: "Form11",
    currentStep: currStep.step
  }), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem",
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER"))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: applicationNo || ""
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: convertEpochToDateDMY(Number(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime))
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: t(`WF_BPA_${formData === null || formData === void 0 ? void 0 : formData.applicationType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: owners === null || owners === void 0 ? void 0 : (_owners$2 = owners[0]) === null || _owners$2 === void 0 ? void 0 : _owners$2.name
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_STEPPER_LAND_INFORMATION")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/land-area-details`)
  }))), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_LAND_AREA_DETAILS")), (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DISTRICT_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city) || t("CS_NA")
  }), tcpCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_NOTIFIED-AREA_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$loca = landAreaDetails.locality) === null || _landAreaDetails$loca === void 0 ? void 0 : _landAreaDetails$loca.name) || t("CS_NA")
  }), udCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(udCode ? `BPA_ULB-AREA_LABEL` : `BPA_AREA_TYPE_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.areaType) || t("CS_NA")
  }), udCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(udCode ? `BPA_LOC_WARD-AREA_LABEL` : `BPA_LOC_VILLAGE-AREA_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$vill = landAreaDetails.village) === null || _landAreaDetails$vill === void 0 ? void 0 : _landAreaDetails$vill.name) || t("CS_NA")
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_DESCRIPTION_OF_LAND")), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_REVENUE_VILLAGE_MOHALLA_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.revenueVillageMohal) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_KHATA_NO_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_KHATAUNI_NO_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LAT_LONG_LABEL`),
    text: descriptionOfLand !== null && descriptionOfLand !== void 0 && descriptionOfLand.latitude ? `${descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude} - ${descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude}` : t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      border: '1px solid #d6d5d4',
      padding: '1rem 1rem 0',
      marginBottom: '1rem'
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$kh = descriptionOfLand.khasraWithArea) === null || _descriptionOfLand$kh === void 0 ? void 0 : _descriptionOfLand$kh.map(({
    khasraNo,
    area
  }, index) => /*#__PURE__*/React__default.createElement(Box$1, {
    key: `${khasraNo}_${area}_${index}`,
    sx: {
      paddingBottom: '.5rem',
      display: 'flex',
      ...((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraWithArea.length) !== index + 1 && {
        borderBottom: '1px solid #d6d5d4',
        marginBottom: '1rem'
      })
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      whiteSpace: 'nowrap',
      flex: 1
    },
    textStyle: {
      maxWidth: '35%'
    },
    className: "border-none",
    label: t(`BPA_DOL_KHASARA_NO_LABEL`),
    text: khasraNo || t("CS_NA"),
    rowContainerStyle: {
      flex: 1,
      marginBottom: 0
    }
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      whiteSpace: 'nowrap',
      flex: 1
    },
    textStyle: {
      maxWidth: '35%'
    },
    className: "border-none",
    label: t(`BPA_DOL_AREA_SQM_LABEL`),
    text: area || t("CS_NA"),
    rowContainerStyle: {
      flex: 1,
      marginBottom: 0
    }
  })))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_TOTAL_PLOT_AREA_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.totalPlotArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_NO_OF_PLOT_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.noOfPlot) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PROPERTY_TYPE`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$pr = descriptionOfLand.propertyType) === null || _descriptionOfLand$pr === void 0 ? void 0 : _descriptionOfLand$pr.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_USE_TYPE`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$us = descriptionOfLand.useType) === null || _descriptionOfLand$us === void 0 ? void 0 : _descriptionOfLand$us.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PLOT_AREA`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_DETAILS_OF_PLOT_AFTER_SUBDIVISION")), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_TYPE_OF_LAND_VOLVED`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty = descriptionOfLand.typeOfLandVolved) === null || _descriptionOfLand$ty === void 0 ? void 0 : _descriptionOfLand$ty.name) || t("CS_NA")
  }), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty2 = descriptionOfLand.typeOfLandVolved) === null || _descriptionOfLand$ty2 === void 0 ? void 0 : _descriptionOfLand$ty2.name) === "Yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_TYPE_OF_CLU_INVOLVED`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty3 = descriptionOfLand.typeOfCLUInvolved) === null || _descriptionOfLand$ty3 === void 0 ? void 0 : _descriptionOfLand$ty3.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "table table-bordered table-responsive"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 50
    }
  }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_NO")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_TYPE_OF_LAND_DEVELOPMENT")} *`))), /*#__PURE__*/React__default.createElement("tbody", null, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$kh2 = descriptionOfLand.khasraTable) === null || _descriptionOfLand$kh2 === void 0 ? void 0 : _descriptionOfLand$kh2.map((field, index) => {
    var _field$typeOfLand;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", null, field.plotNo), /*#__PURE__*/React__default.createElement("td", null, field.plotArea), /*#__PURE__*/React__default.createElement("td", null, (_field$typeOfLand = field.typeOfLand) === null || _field$typeOfLand === void 0 ? void 0 : _field$typeOfLand.name));
  }))))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_CHECKLIST")), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PADESTERIAN_MIN_WIDTH`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.pedestrianMinWidth) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_VEHICULAR_ACCESS_MIN_WIDTH`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.vehicularAccessMinWidth) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_OPEN_GREEN_SPACE_MIN_AREA`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.openGreenSpaceMinArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_SOAK_PIT_MIN_AREA`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.soakPitMinArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PLOT_ORIENTATION`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.plotOrientation) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PLOT_LAYOUT`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.plotLayout) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_NEW_TRADE_DETAILS_HEADER_DETAILS")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/land-area-details`)
  }))), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_CITY_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.town) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_MOHALLA_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.tehsil) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DISTRICT_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.district) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_STATE`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.state) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DETAILS_PIN_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.pinno) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_APPLICANT_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/owner-details`)
  }))), owners === null || owners === void 0 ? void 0 : owners.map((ob, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: (owners === null || owners === void 0 ? void 0 : owners.length) > 1 ? {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    } : {}
  }, owners.length > 1 && /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("COMMON_OWNER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    textStyle: index == 0 && owners.length == 1 ? {
      paddingLeft: "12px"
    } : {},
    label: t(`CORE_COMMON_NAME`),
    text: ob === null || ob === void 0 ? void 0 : ob.name
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_GENDER_LABEL`),
    text: t(ob === null || ob === void 0 ? void 0 : ob.gender)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_MOBILE_NUMBER`),
    text: ob === null || ob === void 0 ? void 0 : ob.mobileNumber
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_EMAIL_LABEL`),
    text: ob === null || ob === void 0 ? void 0 : ob.emailId
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_IS_PRIMARY_OWNER_LABEL`),
    text: `${ob !== null && ob !== void 0 && ob.isPrimaryOwner ? 'Yes' : 'No'}`
  }))))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_DOCUMENT_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/document-details`)
  }))), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: getOrderDocuments(applicationDocs),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem",
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_SUMMARY_FEE_EST")), !udCode && /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_PROCESSING_FEE_INCLUDING_ECHARGES`),
    text: `₹ ${processingFee || "0"}`
  })), udCode && /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_APPLICATION_FEE`),
    text: `₹ ${applicationFee || "0"}`
  }), processingFee > 0 && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_PROCESSING_FEE_INCLUDING_ECHARGES`),
    text: `₹ ${processingFee || "0"}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", null, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement("div", null, "\u20B9 ", totalAmount || "0")), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: udCode ? t("CS_COMMON_SUBMIT") : t("BPA_SEND_TO_JE/JD/SPD"),
    onSubmit: onSubmit
  })));
};

const CheckPage$2 = ({
  onSubmit,
  formData,
  currStep
}) => {
  var _Digit, _owners$, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _formData$auditDetail, _owners$2, _landAreaDetails$loca, _landAreaDetails$vill, _descriptionOfLand$kh, _descriptionOfLand$pr, _descriptionOfLand$us, _descriptionOfLand$ty, _descriptionOfLand$ty2, _descriptionOfLand$ty3, _descriptionOfLand$kh2, _descriptionOfLand$bu;
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const tcpCode = applicationFlow === 'TCP';
  const udCode = applicationFlow === 'UD';
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === "BPA_FORM26" ? "BPA.FORM_26_FEE" : "BPA.FORM_26_FEE_UD";
  const {
    applicationNo,
    landAreaDetails,
    descriptionOfLand,
    checklist,
    landInfo,
    nocDocuments,
    PrevStateDocuments,
    PrevStateNocDocuments
  } = formData;
  const owners = landInfo === null || landInfo === void 0 ? void 0 : landInfo.owners;
  const ownerPermanentAddress = owners === null || owners === void 0 ? void 0 : (_owners$ = owners[0]) === null || _owners$ === void 0 ? void 0 : _owners$.permanentAddress;
  const docs = formData === null || formData === void 0 ? void 0 : formData.documents;
  const documents = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount;
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  const {
    pathname
  } = useLocation();
  const basePath = pathname.split('/').slice(0, -1).join('/');
  let routeLink = basePath;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form26/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form26/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (!applicationNo) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
      flow: "Form11",
      currentStep: currStep.step
    }), /*#__PURE__*/React__default.createElement(Card, {
      style: {
        paddingRight: "1rem",
        marginTop: '1rem'
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      display: "flex",
      justifyContent: "center"
    }, /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER"))), /*#__PURE__*/React__default.createElement("hr", {
      style: {
        backgroundColor: "#cccccc",
        height: "2px",
        marginBottom: "20px"
      }
    }), /*#__PURE__*/React__default.createElement(CardHeader, {
      styles: {
        textAlign: 'center'
      }
    }, "No Application Data Available.")));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
    flow: "Form26",
    currentStep: currStep.step
  }), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem",
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER"))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: applicationNo || ""
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: convertEpochToDateDMY(Number(formData === null || formData === void 0 ? void 0 : (_formData$auditDetail = formData.auditDetails) === null || _formData$auditDetail === void 0 ? void 0 : _formData$auditDetail.createdTime))
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: t(`WF_BPA_${formData === null || formData === void 0 ? void 0 : formData.applicationType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: owners === null || owners === void 0 ? void 0 : (_owners$2 = owners[0]) === null || _owners$2 === void 0 ? void 0 : _owners$2.name
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_STEPPER_LAND_INFORMATION")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/land-area-details`)
  }))), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_LAND_AREA_DETAILS")), (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DISTRICT_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city) || t("CS_NA")
  }), tcpCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_NOTIFIED-AREA_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$loca = landAreaDetails.locality) === null || _landAreaDetails$loca === void 0 ? void 0 : _landAreaDetails$loca.name) || t("CS_NA")
  }), udCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(udCode ? `BPA_ULB-AREA_LABEL` : `BPA_AREA_TYPE_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.areaType) || t("CS_NA")
  }), udCode && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(udCode ? `BPA_LOC_WARD-AREA_LABEL` : `BPA_LOC_VILLAGE-AREA_LABEL`),
    text: (landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$vill = landAreaDetails.village) === null || _landAreaDetails$vill === void 0 ? void 0 : _landAreaDetails$vill.name) || t("CS_NA")
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_DESCRIPTION_OF_LAND")), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_REVENUE_VILLAGE_MOHALLA_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.revenueVillageMohal) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_KHATA_NO_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_KHATAUNI_NO_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LAT_LONG_LABEL`),
    text: descriptionOfLand !== null && descriptionOfLand !== void 0 && descriptionOfLand.latitude ? `${descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude} - ${descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude}` : t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      border: '1px solid #d6d5d4',
      padding: '1rem 1rem 0',
      marginBottom: '1rem'
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$kh = descriptionOfLand.khasraWithArea) === null || _descriptionOfLand$kh === void 0 ? void 0 : _descriptionOfLand$kh.map(({
    khasraNo,
    area
  }, index) => /*#__PURE__*/React__default.createElement(Box$1, {
    key: `${khasraNo}_${area}_${index}`,
    sx: {
      paddingBottom: '.5rem',
      display: 'flex',
      ...((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraWithArea.length) !== index + 1 && {
        borderBottom: '1px solid #d6d5d4',
        marginBottom: '1rem'
      })
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      whiteSpace: 'nowrap',
      flex: 1
    },
    textStyle: {
      maxWidth: '35%'
    },
    className: "border-none",
    label: t(`BPA_DOL_KHASARA_NO_LABEL`),
    text: khasraNo || t("CS_NA"),
    rowContainerStyle: {
      flex: 1,
      marginBottom: 0
    }
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      whiteSpace: 'nowrap',
      flex: 1
    },
    textStyle: {
      maxWidth: '35%'
    },
    className: "border-none",
    label: t(`BPA_DOL_AREA_SQM_LABEL`),
    text: area || t("CS_NA"),
    rowContainerStyle: {
      flex: 1,
      marginBottom: 0
    }
  })))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_TOTAL_PLOT_AREA_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.totalPlotArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DOL_NO_OF_PLOT_LABEL`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.noOfPlot) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PROPERTY_TYPE`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$pr = descriptionOfLand.propertyType) === null || _descriptionOfLand$pr === void 0 ? void 0 : _descriptionOfLand$pr.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_USE_TYPE`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$us = descriptionOfLand.useType) === null || _descriptionOfLand$us === void 0 ? void 0 : _descriptionOfLand$us.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PLOT_AREA`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PERMISSBLE_COVERAGE`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.maximumCoverage) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_DETAILS_OF_PLOT_AFTER_SUBDIVISION")), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_TYPE_OF_LAND_VOLVED`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty = descriptionOfLand.typeOfLandVolved) === null || _descriptionOfLand$ty === void 0 ? void 0 : _descriptionOfLand$ty.name) || t("CS_NA")
  }), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty2 = descriptionOfLand.typeOfLandVolved) === null || _descriptionOfLand$ty2 === void 0 ? void 0 : _descriptionOfLand$ty2.name) === "Yes" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_TYPE_OF_CLU_INVOLVED`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$ty3 = descriptionOfLand.typeOfCLUInvolved) === null || _descriptionOfLand$ty3 === void 0 ? void 0 : _descriptionOfLand$ty3.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "table table-bordered table-responsive"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 50
    }
  }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_NO")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PLOT_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_TYPE_OF_LAND_DEVELOPMENT")} *`))), /*#__PURE__*/React__default.createElement("tbody", null, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$kh2 = descriptionOfLand.khasraTable) === null || _descriptionOfLand$kh2 === void 0 ? void 0 : _descriptionOfLand$kh2.map((field, index) => {
    var _field$typeOfLand;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: field.id
    }, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", null, field.plotNo), /*#__PURE__*/React__default.createElement("td", null, field.plotArea), /*#__PURE__*/React__default.createElement("td", null, (_field$typeOfLand = field.typeOfLand) === null || _field$typeOfLand === void 0 ? void 0 : _field$typeOfLand.name));
  }))))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_NO_OF_BLOCK`),
    text: (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.noOfBlocks) || t("CS_NA")
  }), descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$bu = descriptionOfLand.buildUpAreaTable) === null || _descriptionOfLand$bu === void 0 ? void 0 : _descriptionOfLand$bu.map(({
    table
  }, idx) => /*#__PURE__*/React__default.createElement("div", {
    className: "table table-bordered table-responsive",
    style: {
      display: "block"
    },
    key: `table_${idx}`
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 50
    }
  }, `${t("BPA_SHORT_SERIAL_NO")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal",
    style: {
      minWidth: 100
    }
  }, `${t("BPA_FLOOR_TYPE")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_APPROVED_FLOOR_AREA")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_LAND_USE_TYPE")} *`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PARKING_AREA")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_ACTUAL_CONSTRUCTION")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_PERMISSIBLE_DEVIATION")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("BPA_SETBACK_DEVIATION")}`), /*#__PURE__*/React__default.createElement("th", {
    className: "fw-normal"
  }, `${t("DEVIATION_CENT")}`))), /*#__PURE__*/React__default.createElement("tbody", null, table === null || table === void 0 ? void 0 : table.map((field, index) => {
    var _field$floorType, _field$landUseType;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: `row_${idx}_${index}`
    }, /*#__PURE__*/React__default.createElement("th", {
      className: "fw-normal",
      style: {
        minWidth: 50
      }
    }, index + 1), /*#__PURE__*/React__default.createElement("td", {
      style: {
        minWidth: 100
      }
    }, (_field$floorType = field.floorType) === null || _field$floorType === void 0 ? void 0 : _field$floorType.name), /*#__PURE__*/React__default.createElement("td", null, field.floorArea), /*#__PURE__*/React__default.createElement("td", null, (_field$landUseType = field.landUseType) === null || _field$landUseType === void 0 ? void 0 : _field$landUseType.name), /*#__PURE__*/React__default.createElement("td", null, field.parkingArea), /*#__PURE__*/React__default.createElement("td", null, field.actualConstruction), /*#__PURE__*/React__default.createElement("td", null, field.permissibleDeviation), /*#__PURE__*/React__default.createElement("td", null, field.setbackDeviation), /*#__PURE__*/React__default.createElement("td", null, field.deviation));
  }))))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      fontSize: 20,
      marginLeft: 0
    }
  }, t("BPA_TAB_CHECKLIST")), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PADESTERIAN_MIN_WIDTH`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.pedestrianMinWidth) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_VEHICULAR_ACCESS_MIN_WIDTH`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.vehicularAccessMinWidth) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_OPEN_GREEN_SPACE_MIN_AREA`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.openGreenSpaceMinArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_SOAK_PIT_MIN_AREA`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.soakPitMinArea) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PLOT_ORIENTATION`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.plotOrientation) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    labelStyle: {
      flex: 1
    },
    textStyle: {
      width: '10%'
    },
    className: "border-none",
    label: t(`BPA_CHECKLIST_OPTION_PLOT_LAYOUT`),
    text: (checklist === null || checklist === void 0 ? void 0 : checklist.plotLayout) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_NEW_TRADE_DETAILS_HEADER_DETAILS")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/land-area-details`)
  }))), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_CITY_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.town) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_MOHALLA_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.tehsil) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DISTRICT_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.district) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_STATE`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.state) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DETAILS_PIN_LABEL`),
    text: (ownerPermanentAddress === null || ownerPermanentAddress === void 0 ? void 0 : ownerPermanentAddress.pinno) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_APPLICANT_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/owner-details`)
  }))), owners === null || owners === void 0 ? void 0 : owners.map((ob, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index,
    style: (owners === null || owners === void 0 ? void 0 : owners.length) > 1 ? {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    } : {}
  }, owners.length > 1 && /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("COMMON_OWNER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    textStyle: index == 0 && owners.length == 1 ? {
      paddingLeft: "12px"
    } : {},
    label: t(`CORE_COMMON_NAME`),
    text: ob === null || ob === void 0 ? void 0 : ob.name
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_GENDER_LABEL`),
    text: t(ob === null || ob === void 0 ? void 0 : ob.gender)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_MOBILE_NUMBER`),
    text: ob === null || ob === void 0 ? void 0 : ob.mobileNumber
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_EMAIL_LABEL`),
    text: ob === null || ob === void 0 ? void 0 : ob.emailId
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_IS_PRIMARY_OWNER_LABEL`),
    text: `${ob !== null && ob !== void 0 && ob.isPrimaryOwner ? 'Yes' : 'No'}`
  }))))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, null, t("BPA_DOCUMENT_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, null),
    style: {
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/document-details`)
  }))), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: getOrderDocuments(applicationDocs),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "1rem",
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_SUMMARY_FEE_EST")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      margin: '0 1rem'
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_APPLICATION_FEE`),
    text: `₹ ${totalAmount || "0"}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", null, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement("div", null, "\u20B9 ", totalAmount || "0")), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_SEND_TO_STRUCTURAL_ENGINEER"),
    onSubmit: onSubmit
  })));
};

const CheckPage$3 = ({
  onSubmit,
  value
}) => {
  var _user$info, _documents$documents, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _value$data, _value$data2, _datafromAPI$planDeta, _datafromAPI$planDeta2, _datafromAPI$planDeta3, _datafromAPI$planDeta4, _datafromAPI$planDeta5, _datafromAPI$planDeta6, _datafromAPI$planDeta7, _datafromAPI$planDeta8, _data$scrutinyNumber, _datafromAPI$planDeta9, _datafromAPI$planDeta10, _datafromAPI$planDeta11, _datafromAPI$planDeta12, _datafromAPI$planDeta13, _datafromAPI$planDeta14, _datafromAPI$planDeta15, _datafromAPI$planDeta16, _datafromAPI$planDeta17, _datafromAPI$planDeta18, _datafromAPI$planDeta19, _datafromAPI$planDeta20, _datafromAPI$planDeta21, _datafromAPI$planDeta22, _datafromAPI$planDeta23, _datafromAPI$planDeta24, _datafromAPI$planDeta25, _datafromAPI$planDeta28, _datafromAPI$planDeta29, _datafromAPI$planDeta30, _datafromAPI$planDeta31, _paymentDetails$Bill$, _paymentDetails$Bill$2, _paymentDetails$Bill, _paymentDetails$Bill$3, _paymentDetails$Bill$4, _paymentDetails$Bill2, _paymentDetails$Bill3, _paymentDetails$Bill4;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  let user = Digit.UserService.getUser();
  let BusinessService;
  if (value.businessService === "BPA_LOW") BusinessService = "BPA.LOW_RISK_PERMIT_FEE";else if (value.businessService === "BPA") BusinessService = "BPA.NC_APP_FEE";else if (value.businessService === "BPA_OC") BusinessService = "BPA.NC_OC_APP_FEE";
  const {
    data,
    address,
    owners,
    nocDocuments,
    documents,
    additionalDetails,
    PrevStateDocuments,
    PrevStateNocDocuments,
    applicationNo,
    uiFlow
  } = value;
  const tenantId = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.permanentCity) || (value === null || value === void 0 ? void 0 : value.tenantId) || Digit.ULBService.getCurrentTenantId();
  let isEditApplication = window.location.href.includes("editApplication");
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : (_documents$documents = documents.documents) === null || _documents$documents === void 0 ? void 0 : _documents$documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading,
    error
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [],
    nocAppDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }
  const {
    data: datafromAPI,
    isLoading,
    refetch
  } = Digit.Hooks.obps.useScrutinyDetails(tenantId, value === null || value === void 0 ? void 0 : (_value$data = value.data) === null || _value$data === void 0 ? void 0 : _value$data.scrutinyNumber, {
    enabled: value !== null && value !== void 0 && (_value$data2 = value.data) !== null && _value$data2 !== void 0 && _value$data2.scrutinyNumber ? true : false
  });
  let consumerCode = value === null || value === void 0 ? void 0 : value.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: tenantId || (value === null || value === void 0 ? void 0 : value.tenantId)
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  let routeLink = !isEditApplication ? `/digit-ui/citizen/obps/ocbpa/${additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.applicationType.toLowerCase()}/${additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.serviceType.toLowerCase()}` : `/digit-ui/citizen/obps/editApplication/ocbpa/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}`;
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  function getSubOccupancyValues(index) {
    var _data$bpaData, _data$bpaData$bpaAppr, _data$bpaData$bpaAppr2, _data$bpaData$bpaAppr3;
    let values = data === null || data === void 0 ? void 0 : (_data$bpaData = data.bpaData) === null || _data$bpaData === void 0 ? void 0 : (_data$bpaData$bpaAppr = _data$bpaData.bpaApprovalResponse) === null || _data$bpaData$bpaAppr === void 0 ? void 0 : (_data$bpaData$bpaAppr2 = _data$bpaData$bpaAppr[0]) === null || _data$bpaData$bpaAppr2 === void 0 ? void 0 : (_data$bpaData$bpaAppr3 = _data$bpaData$bpaAppr2.landInfo) === null || _data$bpaData$bpaAppr3 === void 0 ? void 0 : _data$bpaData$bpaAppr3.unit;
    let returnValue = "";
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
      var _values$index, _values$index$usageCa;
      let splitArray = (_values$index = values[index]) === null || _values$index === void 0 ? void 0 : (_values$index$usageCa = _values$index.usageCategory) === null || _values$index$usageCa === void 0 ? void 0 : _values$index$usageCa.split(',');
      if (splitArray !== null && splitArray !== void 0 && splitArray.length) {
        const returnValueArray = splitArray.map(data => data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.toUpperCase(), "-", "_")}`)}` : "NA");
        returnValue = returnValueArray.join(', ');
      }
    }
    return returnValue ? returnValue : "NA";
  }
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }
  if (pdfLoading || isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 4,
    flow: (uiFlow === null || uiFlow === void 0 ? void 0 : uiFlow.flow) === "OCBPA" ? "OCBPA" : ""
  }), /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER")), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: applicationNo ? applicationNo : ""
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`)}`,
    text: convertEpochToDateDMY(Number(data === null || data === void 0 ? void 0 : data.applicationDate))
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`)}`,
    text: t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.applicationType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`)}`,
    text: t(data === null || data === void 0 ? void 0 : data.serviceType)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`)}`,
    text: data === null || data === void 0 ? void 0 : data.occupancyType
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`)}`,
    text: t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.riskType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`)}`,
    text: data === null || data === void 0 ? void 0 : data.applicantName
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_PLOT_DETAILS_TITLE")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-10px",
        float: "right",
        position: "relative",
        bottom: "32px"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/plot-details`)
  }), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BOUNDARY_PLOT_AREA_LABEL`)}`,
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta = datafromAPI.planDetail) !== null && _datafromAPI$planDeta !== void 0 && (_datafromAPI$planDeta2 = _datafromAPI$planDeta.planInformation) !== null && _datafromAPI$planDeta2 !== void 0 && _datafromAPI$planDeta2.plotArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta3 = datafromAPI.planDetail) === null || _datafromAPI$planDeta3 === void 0 ? void 0 : (_datafromAPI$planDeta4 = _datafromAPI$planDeta3.planInformation) === null || _datafromAPI$planDeta4 === void 0 ? void 0 : _datafromAPI$planDeta4.plotArea} ${t(`BPA_SQ_FT_LABEL`)}` : t("CS_NA"),
    textStyle: {
      paddingLeft: "12px"
    }
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_PLOT_NUMBER_LABEL`)}`,
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta5 = datafromAPI.planDetail) === null || _datafromAPI$planDeta5 === void 0 ? void 0 : (_datafromAPI$planDeta6 = _datafromAPI$planDeta5.planInformation) === null || _datafromAPI$planDeta6 === void 0 ? void 0 : _datafromAPI$planDeta6.plotNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_KHATHA_NUMBER_LABEL`)}`,
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta7 = datafromAPI.planDetail) === null || _datafromAPI$planDeta7 === void 0 ? void 0 : (_datafromAPI$planDeta8 = _datafromAPI$planDeta7.planInformation) === null || _datafromAPI$planDeta8 === void 0 ? void 0 : _datafromAPI$planDeta8.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_HOLDING_NUMBER_LABEL`)}`,
    text: (data === null || data === void 0 ? void 0 : data.holdingNumber) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`BPA_BOUNDARY_LAND_REG_DETAIL_LABEL`)}`,
    text: (data === null || data === void 0 ? void 0 : data.registrationDetails) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, `${t("BPA_STEPPER_SCRUTINY_DETAILS_HEADER")}`), /*#__PURE__*/React__default.createElement(CardSubHeader, null, `${t("BPA_EDCR_DETAILS")}`), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t("BPA_OC_EDCR_NO_LABEL")}`,
    text: data === null || data === void 0 ? void 0 : (_data$scrutinyNumber = data.scrutinyNumber) === null || _data$scrutinyNumber === void 0 ? void 0 : _data$scrutinyNumber.edcrNumber
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_UPLOADED_PLAN_DIAGRAM")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.updatedDxfFile)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_UPLOADED_PLAN_DXF`)), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_SCRUNTINY_REPORT_OUTPUT")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.planReport)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_SCRUTINY_REPORT_PDF`))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, `${t("BPA_ACTUAL_BUILDING_EXTRACT_HEADER")}`), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t("BPA_TOTAL_BUILT_UP_AREA_HEADER")}`,
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta9 = datafromAPI.planDetail) !== null && _datafromAPI$planDeta9 !== void 0 && (_datafromAPI$planDeta10 = _datafromAPI$planDeta9.blocks) !== null && _datafromAPI$planDeta10 !== void 0 && (_datafromAPI$planDeta11 = _datafromAPI$planDeta10[0]) !== null && _datafromAPI$planDeta11 !== void 0 && (_datafromAPI$planDeta12 = _datafromAPI$planDeta11.building) !== null && _datafromAPI$planDeta12 !== void 0 && _datafromAPI$planDeta12.totalBuitUpArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta13 = datafromAPI.planDetail) === null || _datafromAPI$planDeta13 === void 0 ? void 0 : (_datafromAPI$planDeta14 = _datafromAPI$planDeta13.blocks) === null || _datafromAPI$planDeta14 === void 0 ? void 0 : (_datafromAPI$planDeta15 = _datafromAPI$planDeta14[0]) === null || _datafromAPI$planDeta15 === void 0 ? void 0 : (_datafromAPI$planDeta16 = _datafromAPI$planDeta15.building) === null || _datafromAPI$planDeta16 === void 0 ? void 0 : _datafromAPI$planDeta16.totalBuitUpArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t("BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL")}`,
    text: datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta17 = datafromAPI.planDetail) === null || _datafromAPI$planDeta17 === void 0 ? void 0 : (_datafromAPI$planDeta18 = _datafromAPI$planDeta17.blocks) === null || _datafromAPI$planDeta18 === void 0 ? void 0 : (_datafromAPI$planDeta19 = _datafromAPI$planDeta18[0]) === null || _datafromAPI$planDeta19 === void 0 ? void 0 : (_datafromAPI$planDeta20 = _datafromAPI$planDeta19.building) === null || _datafromAPI$planDeta20 === void 0 ? void 0 : _datafromAPI$planDeta20.totalFloors
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t("BPA_HEIGHT_FROM_GROUND_LEVEL_FROM_MUMTY")}`,
    text: `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta21 = datafromAPI.planDetail) === null || _datafromAPI$planDeta21 === void 0 ? void 0 : (_datafromAPI$planDeta22 = _datafromAPI$planDeta21.blocks) === null || _datafromAPI$planDeta22 === void 0 ? void 0 : (_datafromAPI$planDeta23 = _datafromAPI$planDeta22[0]) === null || _datafromAPI$planDeta23 === void 0 ? void 0 : (_datafromAPI$planDeta24 = _datafromAPI$planDeta23.building) === null || _datafromAPI$planDeta24 === void 0 ? void 0 : _datafromAPI$planDeta24.declaredBuildingHeight} ${t("BPA_MTRS_LABEL")}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, `${t("BPA_OCC_SUBOCC_HEADER")}`), datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta25 = datafromAPI.planDetail) === null || _datafromAPI$planDeta25 === void 0 ? void 0 : _datafromAPI$planDeta25.blocks.map((block, index) => {
    var _datafromAPI$planDeta26, _datafromAPI$planDeta27;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta26 = datafromAPI.planDetail) === null || _datafromAPI$planDeta26 === void 0 ? void 0 : (_datafromAPI$planDeta27 = _datafromAPI$planDeta26.blocks) === null || _datafromAPI$planDeta27 === void 0 ? void 0 : _datafromAPI$planDeta27.length) > 1 ? {
        marginTop: "19px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        borderRadius: "4px",
        padding: "8px",
        lineHeight: "19px",
        maxWidth: "960px",
        minWidth: "280px"
      } : {}
    }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
      style: {
        marginTop: "15px"
      }
    }, `${t("BPA_BLOCK_SUBHEADER")}`, " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      textStyle: {
        wordBreak: "break-word"
      },
      label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
      text: getSubOccupancyValues(index)
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {
        overflowX: "scroll"
      }
    }, /*#__PURE__*/React__default.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    })));
  }), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, `${t("BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL")}`), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t("BPA_APPLICATION_DEMOLITION_AREA_LABEL")}`,
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta28 = datafromAPI.planDetail) !== null && _datafromAPI$planDeta28 !== void 0 && (_datafromAPI$planDeta29 = _datafromAPI$planDeta28.planInformation) !== null && _datafromAPI$planDeta29 !== void 0 && _datafromAPI$planDeta29.demolitionArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta30 = datafromAPI.planDetail) === null || _datafromAPI$planDeta30 === void 0 ? void 0 : (_datafromAPI$planDeta31 = _datafromAPI$planDeta30.planInformation) === null || _datafromAPI$planDeta31 === void 0 ? void 0 : _datafromAPI$planDeta31.demolitionArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_DOCUMENT_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-10px",
        float: "right",
        position: "relative",
        bottom: "32px"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/document-details`)
  }), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: getOrderDocuments(applicationDocs),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_NOC_DETAILS_SUMMARY")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-10px",
        float: "right",
        position: "relative",
        bottom: "32px"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/noc-details`)
  }), nocDocuments && (nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.NocDetails.map((noc, index) => {
    var _nocDocuments$NocDeta, _noc$additionalDetail, _noc$additionalDetail2, _noc$additionalDetail3, _noc$auditDetails;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$NocDeta = nocDocuments.NocDetails) === null || _nocDocuments$NocDeta === void 0 ? void 0 : _nocDocuments$NocDeta.length) > 1 ? {
        marginTop: "19px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        borderRadius: "4px",
        padding: "8px",
        lineHeight: "19px",
        maxWidth: "960px",
        minWidth: "280px"
      } : {}
    }, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      style: {
        marginBottom: "24px"
      }
    }, `${t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`)}`), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_LABEL`),
      text: noc === null || noc === void 0 ? void 0 : noc.applicationNo
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_NOC_STATUS`),
      text: t(`${noc === null || noc === void 0 ? void 0 : noc.applicationStatus}`),
      textStyle: (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) == "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) == "AUTO_APPROVED" ? {
        color: "#00703C"
      } : {
        color: "#D4351C"
      }
    }), noc !== null && noc !== void 0 && (_noc$additionalDetail = noc.additionalDetails) !== null && _noc$additionalDetail !== void 0 && _noc$additionalDetail.SubmittedOn ? /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t("BPA_NOC_SUBMISSION_DATE")}`,
      text: noc !== null && noc !== void 0 && (_noc$additionalDetail2 = noc.additionalDetails) !== null && _noc$additionalDetail2 !== void 0 && _noc$additionalDetail2.SubmittedOn ? convertEpochToDateDMY(Number(noc === null || noc === void 0 ? void 0 : (_noc$additionalDetail3 = noc.additionalDetails) === null || _noc$additionalDetail3 === void 0 ? void 0 : _noc$additionalDetail3.SubmittedOn)) : "NA"
    }) : null, noc !== null && noc !== void 0 && noc.nocNo ? /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t("BPA_APPROVAL_NUMBER_LABEL")}`,
      text: (noc === null || noc === void 0 ? void 0 : noc.nocNo) || "NA"
    }) : null, (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) === "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) === "REJECTED" || (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) === "AUTO_APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) === "AUTO_REJECTED" ? /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: `${t("BPA_APPROVED_REJECTED_ON_LABEL")}`,
      text: convertEpochToDateDMY(Number(noc === null || noc === void 0 ? void 0 : (_noc$auditDetails = noc.auditDetails) === null || _noc$auditDetails === void 0 ? void 0 : _noc$auditDetails.lastModifiedTime))
    }) : null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_DOCUMENT_DETAILS_LABEL`),
      text: ""
    }), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
      documents: getOrderDocuments(nocAppDocs === null || nocAppDocs === void 0 ? void 0 : nocAppDocs.filter(data => {
        var _data$documentType, _noc$nocType, _noc$nocType$split;
        return data === null || data === void 0 ? void 0 : (_data$documentType = data.documentType) === null || _data$documentType === void 0 ? void 0 : _data$documentType.includes(noc === null || noc === void 0 ? void 0 : (_noc$nocType = noc.nocType) === null || _noc$nocType === void 0 ? void 0 : (_noc$nocType$split = _noc$nocType.split("_")) === null || _noc$nocType$split === void 0 ? void 0 : _noc$nocType$split[0]);
      }), true),
      svgStyles: {},
      isSendBackFlow: false,
      isHrLine: true,
      titleStyles: {
        fontSize: "18px",
        lineHeight: "24px",
        "fontWeight": 700,
        marginBottom: "10px"
      }
    })));
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, `${t("BPA_SUMMARY_FEE_EST")}`), /*#__PURE__*/React__default.createElement(StatusTable, null, paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill$ = paymentDetails.Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.billAccountDetails.map((bill, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: `${t(`${bill.taxHeadCode}`)}`,
    text: `₹ ${bill === null || bill === void 0 ? void 0 : bill.amount}`
  }))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_TOTAL_AMT`),
    text: `₹ ${(paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$3 = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$3 === void 0 ? void 0 : (_paymentDetails$Bill$4 = _paymentDetails$Bill$3.billDetails[0]) === null || _paymentDetails$Bill$4 === void 0 ? void 0 : _paymentDetails$Bill$4.amount) || "0"}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement(CardHeader, null, "\u20B9 ", (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill2 = paymentDetails.Bill) === null || _paymentDetails$Bill2 === void 0 ? void 0 : (_paymentDetails$Bill3 = _paymentDetails$Bill2[0]) === null || _paymentDetails$Bill3 === void 0 ? void 0 : (_paymentDetails$Bill4 = _paymentDetails$Bill3.billDetails[0]) === null || _paymentDetails$Bill4 === void 0 ? void 0 : _paymentDetails$Bill4.amount) || "0"), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_SEND_TO_CITIZEN_LABEL"),
    onSubmit: onSubmit
  })));
};

const CheckPage$4 = ({
  onSubmit,
  value
}) => {
  var _user$info, _value$data, _value$uiFlow, _documents$documents, _nocDocuments$nocDocu, _pdfDetails$pdfFiles, _value$uiFlow3, _datafromAPI$planDeta, _datafromAPI$planDeta2, _datafromAPI$planDeta3, _datafromAPI$planDeta4, _datafromAPI$planDeta5, _datafromAPI$planDeta6, _datafromAPI$planDeta7, _datafromAPI$planDeta8, _value$uiFlow4, _data$scrutinyNumber, _value$uiFlow5, _datafromAPI$planDeta9, _datafromAPI$planDeta10, _datafromAPI$planDeta11, _datafromAPI$planDeta12, _datafromAPI$planDeta13, _datafromAPI$planDeta14, _datafromAPI$planDeta15, _datafromAPI$planDeta16, _datafromAPI$planDeta17, _datafromAPI$planDeta18, _datafromAPI$planDeta19, _datafromAPI$planDeta20, _datafromAPI$planDeta21, _datafromAPI$planDeta22, _datafromAPI$planDeta23, _datafromAPI$planDeta24, _datafromAPI$planDeta25, _datafromAPI$planDeta26, _datafromAPI$planDeta27, _datafromAPI$planDeta28, _datafromAPI$planDeta29, _value$uiFlow6, _address$city, _address$locality, _reciept_data$Payment, _reciept_data$Payment2, _reciept_data$Payment3, _reciept_data$Payment4, _reciept_data$Payment5, _reciept_data$Payment6, _reciept_data$Payment7, _reciept_data$Payment8, _reciept_data$Payment9, _reciept_data$Payment10, _reciept_data$Payment11, _reciept_data$Payment12, _reciept_data$Payment13, _reciept_data$Payment14, _reciept_data$Payment15, _reciept_data$Payment16, _reciept_data$Payment17, _reciept_data$Payment18, _reciept_data$Payment19, _reciept_data$Payment20, _reciept_data$Payment21, _workflowDetails$data;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  let user = Digit.UserService.getUser(),
    BusinessService;
  const tenantId = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.permanentCity;
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const datafromAPI = value === null || value === void 0 ? void 0 : (_value$data = value.data) === null || _value$data === void 0 ? void 0 : _value$data.edcrDetails;
  const queryClient = useQueryClient();
  const {
    data,
    address,
    owners,
    nocDocuments,
    documents,
    additionalDetails,
    subOccupancy,
    PrevStateDocuments,
    PrevStateNocDocuments,
    applicationNo
  } = value;
  let routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/${value.businessService == "BPA_OC" ? "ocbpa" : "bpa"}/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}`;
  if ((value === null || value === void 0 ? void 0 : (_value$uiFlow = value.uiFlow) === null || _value$uiFlow === void 0 ? void 0 : _value$uiFlow.flow) === "OCBPA") routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/ocbpa/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}`;
  if (value.businessService === "BPA_LOW") BusinessService = "BPA.LOW_RISK_PERMIT_FEE";else if (value.businessService === "BPA") BusinessService = "BPA.NC_APP_FEE";else BusinessService = "BPA.NC_OC_APP_FEE";
  let improvedDoc = [];
  PrevStateDocuments === null || PrevStateDocuments === void 0 ? void 0 : PrevStateDocuments.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : (_documents$documents = documents.documents) === null || _documents$documents === void 0 ? void 0 : _documents$documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  PrevStateNocDocuments === null || PrevStateNocDocuments === void 0 ? void 0 : PrevStateNocDocuments.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$nocDocu = nocDocuments.nocDocuments) === null || _nocDocuments$nocDocu === void 0 ? void 0 : _nocDocuments$nocDocu.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading,
    error
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [],
    nocAppDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }
  const {
    data: reciept_data,
    isLoading: recieptDataLoading
  } = Digit.Hooks.useRecieptSearch({
    tenantId: value === null || value === void 0 ? void 0 : value.tenantId,
    businessService: BusinessService,
    consumerCodes: value === null || value === void 0 ? void 0 : value.applicationNo
  }, {
    enabled: value !== null && value !== void 0 && value.applicationNo && BusinessService && value !== null && value !== void 0 && value.tenantId ? true : false
  });
  const mutation = Digit.Hooks.obps.useObpsAPI(value === null || value === void 0 ? void 0 : value.tenantId, false);
  const workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: value === null || value === void 0 ? void 0 : value.tenantId,
    id: value === null || value === void 0 ? void 0 : value.applicationNo,
    moduleCode: "OBPS",
    config: {
      enabled: value !== null && value !== void 0 && value.applicationNo && value !== null && value !== void 0 && value.tenantId ? true : false
    }
  });
  const closeToast = () => {
    setShowToast(null);
  };
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const submitAction = workflow => {
    var _value$uiFlow2;
    let bpaData = cloneDeep(value);
    bpaData.assignee = [];
    const isOCBPS = (value === null || value === void 0 ? void 0 : (_value$uiFlow2 = value.uiFlow) === null || _value$uiFlow2 === void 0 ? void 0 : _value$uiFlow2.flow) === "OCBPA" ? true : false;
    const formdata = convertToBPAObject(bpaData, isOCBPS, true);
    mutation.mutate({
      BPA: {
        ...(formdata === null || formdata === void 0 ? void 0 : formdata.BPA),
        workflow
      }
    }, {
      onError: (error, variables) => {
        var _error$response, _error$response$data, _error$response$data$;
        setShowModal(false);
        setShowToast({
          key: "error",
          action: (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.Errors[0]) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.message) || error
        });
        setTimeout(closeToast, 5000);
      },
      onSuccess: (data, variables) => {
        setShowModal(false);
        setShowToast({
          key: "success",
          action: selectedAction
        });
        setTimeout(closeToast, 5000);
        queryClient.invalidateQueries("BPA_DETAILS_PAGE");
        queryClient.invalidateQueries("workFlowDetails");
        history.replace(`/digit-ui/citizen/obps/sendbacktocitizen/ocbpa/${value === null || value === void 0 ? void 0 : value.tenantId}/${value === null || value === void 0 ? void 0 : value.applicationNo}/acknowledgement`, {
          data: value === null || value === void 0 ? void 0 : value.applicationNo
        });
      }
    });
  };
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function onActionSelect(action = "FORWARD") {
    setSelectedAction("FORWARD");
    setShowModal(true);
  }
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  function routeTo(jumpTo) {
    location.href = jumpTo;
  }
  function getBlockSubOccupancy(index) {
    let subOccupancyString = "";
    subOccupancy[`Block_${index + 1}`] && subOccupancy[`Block_${index + 1}`].map(ob => {
      var _ob$i18nKey;
      subOccupancyString += `${t(stringReplaceAll(ob === null || ob === void 0 ? void 0 : (_ob$i18nKey = ob.i18nKey) === null || _ob$i18nKey === void 0 ? void 0 : _ob$i18nKey.toUpperCase(), "-", "_"))}, `;
    });
    return subOccupancyString;
  }
  useEffect(() => {
    switch (selectedAction) {
      case "FORWARD":
        setShowModal(true);
    }
  }, [selectedAction]);
  if (pdfLoading || recieptDataLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 4,
    flow: (value === null || value === void 0 ? void 0 : (_value$uiFlow3 = value.uiFlow) === null || _value$uiFlow3 === void 0 ? void 0 : _value$uiFlow3.flow) === "OCBPA" ? "OCBPA" : ""
  }), /*#__PURE__*/React__default.createElement(Header, null, t("BPA_STEPPER_SUMMARY_HEADER")), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: applicationNo ? applicationNo : ""
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t(`BPA_BASIC_DETAILS_TITLE`)), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`),
    text: convertEpochToDateDMY(Number(data === null || data === void 0 ? void 0 : data.applicationDate))
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`),
    text: t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.applicationType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`),
    text: t(data === null || data === void 0 ? void 0 : data.serviceType)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`),
    text: data === null || data === void 0 ? void 0 : data.occupancyType
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`),
    text: t(`WF_BPA_${data === null || data === void 0 ? void 0 : data.riskType}`)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`),
    text: data === null || data === void 0 ? void 0 : data.applicantName
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_PLOT_DETAILS_TITLE")), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BOUNDARY_PLOT_AREA_LABEL`),
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta = datafromAPI.planDetail) !== null && _datafromAPI$planDeta !== void 0 && (_datafromAPI$planDeta2 = _datafromAPI$planDeta.planInformation) !== null && _datafromAPI$planDeta2 !== void 0 && _datafromAPI$planDeta2.plotArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta3 = datafromAPI.planDetail) === null || _datafromAPI$planDeta3 === void 0 ? void 0 : (_datafromAPI$planDeta4 = _datafromAPI$planDeta3.planInformation) === null || _datafromAPI$planDeta4 === void 0 ? void 0 : _datafromAPI$planDeta4.plotArea} ${t(`BPA_SQ_FT_LABEL`)}` : t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_PLOT_NUMBER_LABEL`),
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta5 = datafromAPI.planDetail) === null || _datafromAPI$planDeta5 === void 0 ? void 0 : (_datafromAPI$planDeta6 = _datafromAPI$planDeta5.planInformation) === null || _datafromAPI$planDeta6 === void 0 ? void 0 : _datafromAPI$planDeta6.plotNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_KHATHA_NUMBER_LABEL`),
    text: (datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta7 = datafromAPI.planDetail) === null || _datafromAPI$planDeta7 === void 0 ? void 0 : (_datafromAPI$planDeta8 = _datafromAPI$planDeta7.planInformation) === null || _datafromAPI$planDeta8 === void 0 ? void 0 : _datafromAPI$planDeta8.khataNo) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_HOLDING_NUMBER_LABEL`),
    text: (data === null || data === void 0 ? void 0 : data.holdingNumber) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_BOUNDARY_LAND_REG_DETAIL_LABEL`),
    text: (data === null || data === void 0 ? void 0 : data.registrationDetails) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_STEPPER_SCRUTINY_DETAILS_HEADER")), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t((value === null || value === void 0 ? void 0 : (_value$uiFlow4 = value.uiFlow) === null || _value$uiFlow4 === void 0 ? void 0 : _value$uiFlow4.flow) === "OCBPA" ? "BPA_OC_EDCR_NO_LABEL" : "BPA_EDCR_DETAILS")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_EDCR_NO_LABEL"),
    text: (data === null || data === void 0 ? void 0 : (_data$scrutinyNumber = data.scrutinyNumber) === null || _data$scrutinyNumber === void 0 ? void 0 : _data$scrutinyNumber.edcrNumber) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_UPLOADED_PLAN_DIAGRAM")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.updatedDxfFile)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_UPLOADED_PLAN_DXF`)), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_SCRUNTINY_REPORT_OUTPUT")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(PDFSvg, null),
    onClick: () => routeTo(datafromAPI === null || datafromAPI === void 0 ? void 0 : datafromAPI.planReport)
  }), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginTop: "8px",
      marginBottom: "20px",
      textAlign: "Left",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#505A5F",
      fontWeight: "400"
    }
  }, t(`BPA_SCRUTINY_REPORT_PDF`))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, (value === null || value === void 0 ? void 0 : (_value$uiFlow5 = value.uiFlow) === null || _value$uiFlow5 === void 0 ? void 0 : _value$uiFlow5.flow) === "OCBPA" ? t("BPA_ACTUAL_BUILDING_EXTRACT_HEADER") : t("BPA_BUILDING_EXTRACT_HEADER")), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_TOTAL_BUILT_UP_AREA_HEADER"),
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta9 = datafromAPI.planDetail) !== null && _datafromAPI$planDeta9 !== void 0 && (_datafromAPI$planDeta10 = _datafromAPI$planDeta9.blocks) !== null && _datafromAPI$planDeta10 !== void 0 && (_datafromAPI$planDeta11 = _datafromAPI$planDeta10[0]) !== null && _datafromAPI$planDeta11 !== void 0 && (_datafromAPI$planDeta12 = _datafromAPI$planDeta11.building) !== null && _datafromAPI$planDeta12 !== void 0 && _datafromAPI$planDeta12.totalBuitUpArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta13 = datafromAPI.planDetail) === null || _datafromAPI$planDeta13 === void 0 ? void 0 : (_datafromAPI$planDeta14 = _datafromAPI$planDeta13.blocks) === null || _datafromAPI$planDeta14 === void 0 ? void 0 : (_datafromAPI$planDeta15 = _datafromAPI$planDeta14[0]) === null || _datafromAPI$planDeta15 === void 0 ? void 0 : (_datafromAPI$planDeta16 = _datafromAPI$planDeta15.building) === null || _datafromAPI$planDeta16 === void 0 ? void 0 : _datafromAPI$planDeta16.totalBuitUpArea} ${t("BPA_SQ_MTRS_LABEL")}` : t("NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL"),
    text: datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta17 = datafromAPI.planDetail) === null || _datafromAPI$planDeta17 === void 0 ? void 0 : (_datafromAPI$planDeta18 = _datafromAPI$planDeta17.blocks) === null || _datafromAPI$planDeta18 === void 0 ? void 0 : (_datafromAPI$planDeta19 = _datafromAPI$planDeta18[0]) === null || _datafromAPI$planDeta19 === void 0 ? void 0 : (_datafromAPI$planDeta20 = _datafromAPI$planDeta19.building) === null || _datafromAPI$planDeta20 === void 0 ? void 0 : _datafromAPI$planDeta20.totalFloors
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_HEIGHT_FROM_GROUND_LEVEL_FROM_MUMTY"),
    text: `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta21 = datafromAPI.planDetail) === null || _datafromAPI$planDeta21 === void 0 ? void 0 : (_datafromAPI$planDeta22 = _datafromAPI$planDeta21.blocks) === null || _datafromAPI$planDeta22 === void 0 ? void 0 : (_datafromAPI$planDeta23 = _datafromAPI$planDeta22[0]) === null || _datafromAPI$planDeta23 === void 0 ? void 0 : (_datafromAPI$planDeta24 = _datafromAPI$planDeta23.building) === null || _datafromAPI$planDeta24 === void 0 ? void 0 : _datafromAPI$planDeta24.declaredBuildingHeight} ${t("BPA_MTRS_LABEL")}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_OCC_SUBOCC_HEADER")), datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta25 = datafromAPI.planDetail) === null || _datafromAPI$planDeta25 === void 0 ? void 0 : _datafromAPI$planDeta25.blocks.map((block, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      marginTop: "15px"
    }
  }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    textStyle: {
      wordBreak: "break-word"
    },
    label: t("BPA_SUB_OCCUPANCY_LABEL"),
    text: getBlockSubOccupancy(index) === "" ? t("CS_NA") : getBlockSubOccupancy(index)
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: "scroll"
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    className: "customTable table-fixed-first-column table-border-style",
    t: t,
    disableSort: false,
    autoSort: true,
    manualPagination: false,
    isPaginationRequired: false,
    initSortId: "S N ",
    data: getFloorData(block),
    columns: tableColumns,
    getCellProps: cellInfo => {
      return {
        style: {}
      };
    }
  })))), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(StatusTable, {
    style: {
      border: "none"
    }
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("BPA_APPLICATION_DEMOLITION_AREA_LABEL"),
    text: datafromAPI !== null && datafromAPI !== void 0 && (_datafromAPI$planDeta26 = datafromAPI.planDetail) !== null && _datafromAPI$planDeta26 !== void 0 && (_datafromAPI$planDeta27 = _datafromAPI$planDeta26.planInformation) !== null && _datafromAPI$planDeta27 !== void 0 && _datafromAPI$planDeta27.demolitionArea ? `${datafromAPI === null || datafromAPI === void 0 ? void 0 : (_datafromAPI$planDeta28 = datafromAPI.planDetail) === null || _datafromAPI$planDeta28 === void 0 ? void 0 : (_datafromAPI$planDeta29 = _datafromAPI$planDeta28.planInformation) === null || _datafromAPI$planDeta29 === void 0 ? void 0 : _datafromAPI$planDeta29.demolitionArea} ${t("BPA_SQ_MTRS_LABEL")} ` : t("CS_NA")
  }))), (value === null || value === void 0 ? void 0 : (_value$uiFlow6 = value.uiFlow) === null || _value$uiFlow6 === void 0 ? void 0 : _value$uiFlow6.flow) !== "OCBPA" ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_NEW_TRADE_DETAILS_HEADER_DETAILS")), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DETAILS_PIN_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.pincode) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_CITY_LABEL`),
    text: (address === null || address === void 0 ? void 0 : (_address$city = address.city) === null || _address$city === void 0 ? void 0 : _address$city.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LOC_MOHALLA_LABEL`),
    text: (address === null || address === void 0 ? void 0 : (_address$locality = address.locality) === null || _address$locality === void 0 ? void 0 : _address$locality.name) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_DETAILS_SRT_NAME_LABEL`),
    text: (address === null || address === void 0 ? void 0 : address.street) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`ES_NEW_APPLICATION_LOCATION_LANDMARK`),
    text: (address === null || address === void 0 ? void 0 : address.landmark) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_APPLICANT_DETAILS_HEADER")), (owners === null || owners === void 0 ? void 0 : owners.owners) && (owners === null || owners === void 0 ? void 0 : owners.owners.map((ob, index) => {
    var _ob$gender;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, owners.owners.length > 1 && /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("COMMON_OWNER"), " ", index + 1), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`CORE_COMMON_NAME`),
      text: ob === null || ob === void 0 ? void 0 : ob.name
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_APPLICANT_GENDER_LABEL`),
      text: t(ob === null || ob === void 0 ? void 0 : (_ob$gender = ob.gender) === null || _ob$gender === void 0 ? void 0 : _ob$gender.i18nKey)
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`CORE_COMMON_MOBILE_NUMBER`),
      text: ob === null || ob === void 0 ? void 0 : ob.mobileNumber
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_IS_PRIMARY_OWNER_LABEL`),
      text: `${ob === null || ob === void 0 ? void 0 : ob.isPrimaryOwner}`
    })));
  })))) : null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_DOCUMENT_DETAILS_LABEL")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-10px",
        float: "right",
        position: "relative",
        bottom: "32px"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/document-details`)
  }), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
    documents: getOrderDocuments(applicationDocs),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_NOC_DETAILS_SUMMARY")), nocDocuments && (nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.NocDetails.map((noc, index) => {
    var _nocDocuments$NocDeta;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: (nocDocuments === null || nocDocuments === void 0 ? void 0 : (_nocDocuments$NocDeta = nocDocuments.NocDetails) === null || _nocDocuments$NocDeta === void 0 ? void 0 : _nocDocuments$NocDeta.length) > 1 ? {
        marginTop: "19px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        borderRadius: "4px",
        padding: "8px",
        lineHeight: "19px",
        maxWidth: "960px",
        minWidth: "280px"
      } : {}
    }, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      style: {
        marginBottom: "24px"
      }
    }, `${t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`)}`), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_LABEL`),
      text: noc === null || noc === void 0 ? void 0 : noc.applicationNo
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_NOC_STATUS`),
      text: t(`${noc === null || noc === void 0 ? void 0 : noc.applicationStatus}`),
      textStyle: (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) == "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.applicationStatus) == "AUTO_APPROVED" ? {
        color: "#00703C"
      } : {
        color: "#D4351C"
      }
    }), /*#__PURE__*/React__default.createElement(Row, {
      className: "border-none",
      label: t(`BPA_DOCUMENT_DETAILS_LABEL`),
      text: ""
    }), /*#__PURE__*/React__default.createElement(DocumentsPreview, {
      documents: getOrderDocuments(nocAppDocs === null || nocAppDocs === void 0 ? void 0 : nocAppDocs.filter(data => {
        var _data$documentType, _noc$nocType, _noc$nocType$split;
        return data === null || data === void 0 ? void 0 : (_data$documentType = data.documentType) === null || _data$documentType === void 0 ? void 0 : _data$documentType.includes(noc === null || noc === void 0 ? void 0 : (_noc$nocType = noc.nocType) === null || _noc$nocType === void 0 ? void 0 : (_noc$nocType$split = _noc$nocType.split("_")) === null || _noc$nocType$split === void 0 ? void 0 : _noc$nocType$split[0]);
      }), true),
      svgStyles: {},
      isSendBackFlow: false,
      isHrLine: true,
      titleStyles: {
        fontSize: "18px",
        lineHeight: "24px",
        "fontWeight": 700,
        marginBottom: "10px"
      }
    })));
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardSubHeader, null, t("BPA_SUMMARY_FEE_EST")), /*#__PURE__*/React__default.createElement(StatusTable, null, reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment = reciept_data.Payments) === null || _reciept_data$Payment === void 0 ? void 0 : (_reciept_data$Payment2 = _reciept_data$Payment[0]) === null || _reciept_data$Payment2 === void 0 ? void 0 : (_reciept_data$Payment3 = _reciept_data$Payment2.paymentDetails) === null || _reciept_data$Payment3 === void 0 ? void 0 : (_reciept_data$Payment4 = _reciept_data$Payment3[0]) === null || _reciept_data$Payment4 === void 0 ? void 0 : (_reciept_data$Payment5 = _reciept_data$Payment4.bill) === null || _reciept_data$Payment5 === void 0 ? void 0 : (_reciept_data$Payment6 = _reciept_data$Payment5.billDetails) === null || _reciept_data$Payment6 === void 0 ? void 0 : (_reciept_data$Payment7 = _reciept_data$Payment6[0]) === null || _reciept_data$Payment7 === void 0 ? void 0 : _reciept_data$Payment7.billAccountDetails.map((bill, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`${bill.taxHeadCode}`),
    text: `₹ ${bill === null || bill === void 0 ? void 0 : bill.amount}`
  }))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_TOTAL_AMT`),
    text: `₹ ${(reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment8 = reciept_data.Payments) === null || _reciept_data$Payment8 === void 0 ? void 0 : (_reciept_data$Payment9 = _reciept_data$Payment8[0]) === null || _reciept_data$Payment9 === void 0 ? void 0 : (_reciept_data$Payment10 = _reciept_data$Payment9.paymentDetails) === null || _reciept_data$Payment10 === void 0 ? void 0 : (_reciept_data$Payment11 = _reciept_data$Payment10[0]) === null || _reciept_data$Payment11 === void 0 ? void 0 : (_reciept_data$Payment12 = _reciept_data$Payment11.bill) === null || _reciept_data$Payment12 === void 0 ? void 0 : (_reciept_data$Payment13 = _reciept_data$Payment12.billDetails) === null || _reciept_data$Payment13 === void 0 ? void 0 : (_reciept_data$Payment14 = _reciept_data$Payment13[0]) === null || _reciept_data$Payment14 === void 0 ? void 0 : _reciept_data$Payment14.amount) || "0"}`
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, null, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement(CardHeader, null, "\u20B9 ", (reciept_data === null || reciept_data === void 0 ? void 0 : (_reciept_data$Payment15 = reciept_data.Payments) === null || _reciept_data$Payment15 === void 0 ? void 0 : (_reciept_data$Payment16 = _reciept_data$Payment15[0]) === null || _reciept_data$Payment16 === void 0 ? void 0 : (_reciept_data$Payment17 = _reciept_data$Payment16.paymentDetails) === null || _reciept_data$Payment17 === void 0 ? void 0 : (_reciept_data$Payment18 = _reciept_data$Payment17[0]) === null || _reciept_data$Payment18 === void 0 ? void 0 : (_reciept_data$Payment19 = _reciept_data$Payment18.bill) === null || _reciept_data$Payment19 === void 0 ? void 0 : (_reciept_data$Payment20 = _reciept_data$Payment19.billDetails) === null || _reciept_data$Payment20 === void 0 ? void 0 : (_reciept_data$Payment21 = _reciept_data$Payment20[0]) === null || _reciept_data$Payment21 === void 0 ? void 0 : _reciept_data$Payment21.amount) || "0"), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_COMMON_BUTTON_SUBMIT"),
    onSubmit: onActionSelect
  })), showModal ? /*#__PURE__*/React__default.createElement(ActionModal$1, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    id: value === null || value === void 0 ? void 0 : value.applicationNo,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline
  }) : null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast.key === "error" ? true : false,
    label: t(showToast.key === "success" ? `ES_OBPS_${showToast.action}_UPDATE_SUCCESS` : showToast.action),
    onClose: closeToast
  }));
};

function OBPSDocument({
  value = {},
  Code,
  index,
  isNOC = false,
  svgStyles = {
    width: "100px",
    height: "100px",
    viewBox: "0 0 25 25",
    minWidth: "100px"
  },
  isStakeHolder = false
}) {
  const {
    t
  } = useTranslation();
  const {
    isLoading,
    isError,
    error,
    data
  } = Digit.Hooks.obps.useOBPSDocumentSearch({
    value
  }, {
    value
  }, Code, index, isNOC);
  let documents = [];
  if (isNOC) {
    var _value$nocDocuments, _value$nocDocuments2;
    value !== null && value !== void 0 && value.nocDocuments ? (value === null || value === void 0 ? void 0 : (_value$nocDocuments = value.nocDocuments) === null || _value$nocDocuments === void 0 ? void 0 : _value$nocDocuments.nocDocuments.length) > 0 && (value === null || value === void 0 ? void 0 : (_value$nocDocuments2 = value.nocDocuments) === null || _value$nocDocuments2 === void 0 ? void 0 : _value$nocDocuments2.nocDocuments.filter(ob => {
      var _ob$documentType;
      return ob === null || ob === void 0 ? void 0 : (_ob$documentType = ob.documentType) === null || _ob$documentType === void 0 ? void 0 : _ob$documentType.includes(Code);
    }).map(ob => {
      documents.push(ob);
    })) : (value === null || value === void 0 ? void 0 : value.length) > 0 && (value === null || value === void 0 ? void 0 : value.filter(ob => {
      var _ob$documentType2;
      return ob === null || ob === void 0 ? void 0 : (_ob$documentType2 = ob.documentType) === null || _ob$documentType2 === void 0 ? void 0 : _ob$documentType2.includes(Code);
    }).map(ob => {
      documents.push(ob);
    }));
  } else {
    var _value$documents;
    value !== null && value !== void 0 && value.documents ? value === null || value === void 0 ? void 0 : (_value$documents = value.documents) === null || _value$documents === void 0 ? void 0 : _value$documents.documents.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === Code).map(ob => {
      documents.push(ob);
    }) : value.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === Code).map(ob => {
      documents.push(ob);
    });
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap"
    }
  }, documents.length > 0 ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }, documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    let documentLink = pdfDownloadLink(data.pdfFiles, document === null || document === void 0 ? void 0 : document.fileStoreId);
    return /*#__PURE__*/React__default.createElement("a", {
      target: "_blank",
      href: documentLink,
      style: {
        minWidth: "80px",
        marginRight: "10px",
        maxWidth: "100px",
        height: "auto"
      },
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement(PDFSvg, null)), isStakeHolder ? /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "8px",
        textAlign: "center",
        color: "#505A5F"
      }
    }, t(`BPAREG_HEADER_${stringReplaceAll(Code === null || Code === void 0 ? void 0 : Code.toUpperCase(), ".", "_")}`)) : null, " ", !isStakeHolder ? /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "8px",
        textAlign: "center",
        color: "#505A5F"
      }
    }, `${t(Code)}`) : null);
  })) : /*#__PURE__*/React__default.createElement(CardText, null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
}

const CheckPage$5 = ({
  onSubmit,
  value
}) => {
  var _user$info, _user$info2, _value$result, _result$Licenses, _result$Licenses$, _result$Licenses2, _result$Licenses2$, _formData$LicneseType, _formData$LicneseType2, _formData$LicneseType3, _formData$LicneseType4, _formData$LicneseType5, _formData$LicneseDeta, _formData$LicneseDeta2, _formData$LicneseDeta3, _formData$LicneseDeta4, _formData$LicneseDeta5, _formData$LicneseDeta6, _formData$LicneseDeta7, _formData$LicneseDeta8, _formData$LicneseDeta9, _formData$LicneseDeta10, _formData$LicneseDeta11, _formData$LicneseDeta12, _formData$LicneseDeta13, _formData$LicneseDeta14, _formData$LicneseDeta15, _formData$LicneseDeta16, _formData$LicneseDeta17, _formData$LicneseDeta18, _formData$LicneseDeta19, _value$Correspondence, _value$Correspondence2, _value$Correspondence3, _value$Correspondence4, _value$Correspondence5, _value$Correspondence6, _value$Correspondence7, _paymentDetails$billR, _paymentDetails$billR2, _paymentDetails$billR3, _paymentDetails$billR4, _paymentDetails$billR5, _paymentDetails$billR6, _paymentDetails$billR7, _paymentDetails$billR8, _paymentDetails$billR9, _paymentDetails$billR10, _paymentDetails$billR11, _paymentDetails$billR12, _paymentDetails$billR13, _paymentDetails$billR14, _paymentDetails$billR15;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  let user = Digit.UserService.getUser();
  const tenantId = user && user !== null && user !== void 0 && user.info && user !== null && user !== void 0 && (_user$info = user.info) !== null && _user$info !== void 0 && _user$info.permanentCity ? user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : _user$info2.permanentCity : Digit.ULBService.getCurrentTenantId();
  const tenant = Digit.ULBService.getStateId();
  let isopenlink = window.location.href.includes("/openlink/");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  if (isopenlink) window.onunload = function () {
    sessionStorage.removeItem("Digit.BUILDING_PERMIT");
  };
  const {
    result,
    formData,
    documents
  } = value;
  let consumerCode = value === null || value === void 0 ? void 0 : (_value$result = value.result) === null || _value$result === void 0 ? void 0 : _value$result.Licenses[0].applicationNumber;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.obps.useBPAREGgetbill({
    businessService: "BPAREG",
    ...fetchBillParams,
    tenantId: tenant ? tenant : tenantId.split(".")[0]
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  let routeLink = isopenlink ? `/digit-ui/citizen/obps/openlink/stakeholder/apply` : `/digit-ui/citizen/obps/stakeholder/apply`;
  function routeTo(jumpTo) {
    history.push(jumpTo);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: isopenlink ? "OpenlinkContainer" : ""
  }, /*#__PURE__*/React__default.createElement("div", null, isopenlink && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Timeline, {
    currentStep: 4,
    flow: "STAKEHOLDER"
  }), /*#__PURE__*/React__default.createElement(Header, {
    styles: {
      fontSize: "32px"
    }
  }, t("BPA_STEPPER_SUMMARY_HEADER")), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICATION_NUMBER_LABEL`),
    text: result !== null && result !== void 0 && (_result$Licenses = result.Licenses) !== null && _result$Licenses !== void 0 && (_result$Licenses$ = _result$Licenses[0]) !== null && _result$Licenses$ !== void 0 && _result$Licenses$.applicationNumber ? result === null || result === void 0 ? void 0 : (_result$Licenses2 = result.Licenses) === null || _result$Licenses2 === void 0 ? void 0 : (_result$Licenses2$ = _result$Licenses2[0]) === null || _result$Licenses2$ === void 0 ? void 0 : _result$Licenses2$.applicationNumber : ""
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSE_DETAILS_LABEL`)), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-3rem",
        float: "right",
        position: "relative",
        bottom: "32px",
        marginRight: "-8rem"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/provide-license-type`)
  }), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LICENSE_TYPE`),
    textStyle: {
      paddingLeft: "12px"
    },
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseType = formData.LicneseType) === null || _formData$LicneseType === void 0 ? void 0 : (_formData$LicneseType2 = _formData$LicneseType.LicenseType) === null || _formData$LicneseType2 === void 0 ? void 0 : _formData$LicneseType2.i18nKey)
  }), (formData === null || formData === void 0 ? void 0 : (_formData$LicneseType3 = formData.LicneseType) === null || _formData$LicneseType3 === void 0 ? void 0 : (_formData$LicneseType4 = _formData$LicneseType3.LicenseType) === null || _formData$LicneseType4 === void 0 ? void 0 : _formData$LicneseType4.i18nKey.includes("ARCHITECT")) && /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COUNCIL_NUMBER`),
    text: formData === null || formData === void 0 ? void 0 : (_formData$LicneseType5 = formData.LicneseType) === null || _formData$LicneseType5 === void 0 ? void 0 : _formData$LicneseType5.ArchitectNo
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSE_DET_CAPTION`)), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-3rem",
        float: "right",
        position: "relative",
        bottom: "32px",
        marginRight: "-8rem"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/license-details`)
  }), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_NAME_LABEL`),
    textStyle: {
      paddingLeft: "12px"
    },
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta = formData.LicneseDetails) === null || _formData$LicneseDeta === void 0 ? void 0 : _formData$LicneseDeta.name)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_GENDER_LABEL`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta2 = formData.LicneseDetails) === null || _formData$LicneseDeta2 === void 0 ? void 0 : _formData$LicneseDeta2.gender.i18nKey)
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_OWNER_MOBILE_NO_LABEL`),
    text: formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta3 = formData.LicneseDetails) === null || _formData$LicneseDeta3 === void 0 ? void 0 : _formData$LicneseDeta3.mobileNumber
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_EMAIL_LABEL`),
    text: (formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta4 = formData.LicneseDetails) === null || _formData$LicneseDeta4 === void 0 ? void 0 : _formData$LicneseDeta4.email) || t("CS_NA")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_PAN_NO`),
    text: (formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta5 = formData.LicneseDetails) === null || _formData$LicneseDeta5 === void 0 ? void 0 : _formData$LicneseDeta5.PanNumber) || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_LICENSEE_PERMANENT_LABEL`))), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-3rem",
        float: "right",
        position: "relative",
        bottom: "32px",
        marginRight: "-9rem"
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/Permanent-address`)
  }), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_LICENSEE_PERMANENT_LABEL`),
    textStyle: {
      paddingLeft: "12px"
    },
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta6 = formData.LicneseDetails) === null || _formData$LicneseDeta6 === void 0 ? void 0 : (_formData$LicneseDeta7 = _formData$LicneseDeta6.PermanentAddress) === null || _formData$LicneseDeta7 === void 0 ? void 0 : _formData$LicneseDeta7.address) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_STATE`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta8 = formData.LicneseDetails) === null || _formData$LicneseDeta8 === void 0 ? void 0 : (_formData$LicneseDeta9 = _formData$LicneseDeta8.PermanentAddress) === null || _formData$LicneseDeta9 === void 0 ? void 0 : _formData$LicneseDeta9.state) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_DISTRICT`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta10 = formData.LicneseDetails) === null || _formData$LicneseDeta10 === void 0 ? void 0 : (_formData$LicneseDeta11 = _formData$LicneseDeta10.PermanentAddress) === null || _formData$LicneseDeta11 === void 0 ? void 0 : _formData$LicneseDeta11.district) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_TEHSIL`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta12 = formData.LicneseDetails) === null || _formData$LicneseDeta12 === void 0 ? void 0 : (_formData$LicneseDeta13 = _formData$LicneseDeta12.PermanentAddress) === null || _formData$LicneseDeta13 === void 0 ? void 0 : _formData$LicneseDeta13.tehsil) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_TOWN`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta14 = formData.LicneseDetails) === null || _formData$LicneseDeta14 === void 0 ? void 0 : (_formData$LicneseDeta15 = _formData$LicneseDeta14.PermanentAddress) === null || _formData$LicneseDeta15 === void 0 ? void 0 : _formData$LicneseDeta15.town) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PINNO`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta16 = formData.LicneseDetails) === null || _formData$LicneseDeta16 === void 0 ? void 0 : (_formData$LicneseDeta17 = _formData$LicneseDeta16.PermanentAddress) === null || _formData$LicneseDeta17 === void 0 ? void 0 : _formData$LicneseDeta17.pinNo) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_UNIVERSITY_NAME`),
    text: t(formData === null || formData === void 0 ? void 0 : (_formData$LicneseDeta18 = formData.LicneseDetails) === null || _formData$LicneseDeta18 === void 0 ? void 0 : (_formData$LicneseDeta19 = _formData$LicneseDeta18.PermanentAddress) === null || _formData$LicneseDeta19 === void 0 ? void 0 : _formData$LicneseDeta19.university) || t("N/A")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t(`BPA_COMMUNICATION_ADDRESS_HEADER_DETAILS`))), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-3rem",
        float: "right",
        position: "relative",
        bottom: "32px",
        marginRight: '-12rem'
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/correspondence-address`)
  }), /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL`),
    textStyle: {
      paddingLeft: "12px"
    },
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence = value.Correspondenceaddress) === null || _value$Correspondence === void 0 ? void 0 : _value$Correspondence.address) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_STATE`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence2 = value.Correspondenceaddress) === null || _value$Correspondence2 === void 0 ? void 0 : _value$Correspondence2.state) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_DISTRICT`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence3 = value.Correspondenceaddress) === null || _value$Correspondence3 === void 0 ? void 0 : _value$Correspondence3.district) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_TEHSIL`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence4 = value.Correspondenceaddress) === null || _value$Correspondence4 === void 0 ? void 0 : _value$Correspondence4.tehsil) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_TOWN`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence5 = value.Correspondenceaddress) === null || _value$Correspondence5 === void 0 ? void 0 : _value$Correspondence5.town) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_PINNO`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence6 = value.Correspondenceaddress) === null || _value$Correspondence6 === void 0 ? void 0 : _value$Correspondence6.pinNo) || t("N/A")
  }), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`CORE_COMMON_UNIVERSITY_NAME`),
    text: t(value === null || value === void 0 ? void 0 : (_value$Correspondence7 = value.Correspondenceaddress) === null || _value$Correspondence7 === void 0 ? void 0 : _value$Correspondence7.university) || t("N/A")
  }))), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t("BPA_DOC_DETAILS_SUMMARY")), /*#__PURE__*/React__default.createElement(LinkButton, {
    label: /*#__PURE__*/React__default.createElement(EditIcon$1, {
      style: {
        marginTop: "-3rem",
        float: "right",
        position: "relative",
        bottom: "32px",
        marginRight: '-9rem'
      }
    }),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: () => routeTo(`${routeLink}/stakeholder-document-details`)
  }), documents === null || documents === void 0 ? void 0 : documents.documents.map((doc, index) => {
    var _doc$documentType, _documents$documents;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement(CardSectionHeader, {
      styles: {
        fontSize: "18px"
      }
    }, t(`BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replace('.', '_')}`)), doc !== null && doc !== void 0 && doc.info ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "12px",
        color: "#505A5F",
        fontWeight: 400,
        lineHeight: "15px"
      }
    }, `${t(doc === null || doc === void 0 ? void 0 : doc.info)}`) : null, /*#__PURE__*/React__default.createElement(StatusTable, null, /*#__PURE__*/React__default.createElement(OBPSDocument, {
      value: value,
      Code: doc === null || doc === void 0 ? void 0 : doc.documentType,
      index: index,
      isNOC: false,
      svgStyles: {},
      isStakeHolder: true
    }), (documents === null || documents === void 0 ? void 0 : (_documents$documents = documents.documents) === null || _documents$documents === void 0 ? void 0 : _documents$documents.length) != index + 1 ? /*#__PURE__*/React__default.createElement("hr", {
      style: {
        color: "#cccccc",
        backgroundColor: "#cccccc",
        height: "2px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }) : null));
  })), /*#__PURE__*/React__default.createElement(Card, {
    style: {
      paddingRight: "16px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t("BPA_SUMMARY_FEE_EST")), /*#__PURE__*/React__default.createElement(StatusTable, null, paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$billR = paymentDetails.billResponse) === null || _paymentDetails$billR === void 0 ? void 0 : (_paymentDetails$billR2 = _paymentDetails$billR.Bill[0]) === null || _paymentDetails$billR2 === void 0 ? void 0 : (_paymentDetails$billR3 = _paymentDetails$billR2.billDetails[0]) === null || _paymentDetails$billR3 === void 0 ? void 0 : _paymentDetails$billR3.billAccountDetails.map((bill, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t("REGISTRATION_FEE_INCLUDING_ECHARGES"),
    text: `₹ ${bill === null || bill === void 0 ? void 0 : bill.amount}` || t("CS_NA")
  }))), /*#__PURE__*/React__default.createElement(Row, {
    className: "border-none",
    label: t(`BPA_COMMON_TOTAL_AMT`),
    text: `₹ ${paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$billR4 = paymentDetails.billResponse) === null || _paymentDetails$billR4 === void 0 ? void 0 : (_paymentDetails$billR5 = _paymentDetails$billR4.Bill) === null || _paymentDetails$billR5 === void 0 ? void 0 : (_paymentDetails$billR6 = _paymentDetails$billR5[0]) === null || _paymentDetails$billR6 === void 0 ? void 0 : (_paymentDetails$billR7 = _paymentDetails$billR6.billDetails[0]) === null || _paymentDetails$billR7 === void 0 ? void 0 : _paymentDetails$billR7.amount}` || t("CS_NA")
  })), /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: "#cccccc",
      backgroundColor: "#cccccc",
      height: "2px",
      marginTop: "20px",
      marginBottom: "20px"
    }
  }), /*#__PURE__*/React__default.createElement(CardHeader, {
    styles: {
      fontSize: "24px"
    }
  }, t("BPA_COMMON_TOTAL_AMT")), /*#__PURE__*/React__default.createElement(CardHeader, null, "\u20B9 ", paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$billR8 = paymentDetails.billResponse) === null || _paymentDetails$billR8 === void 0 ? void 0 : (_paymentDetails$billR9 = _paymentDetails$billR8.Bill) === null || _paymentDetails$billR9 === void 0 ? void 0 : (_paymentDetails$billR10 = _paymentDetails$billR9[0]) === null || _paymentDetails$billR10 === void 0 ? void 0 : (_paymentDetails$billR11 = _paymentDetails$billR10.billDetails[0]) === null || _paymentDetails$billR11 === void 0 ? void 0 : _paymentDetails$billR11.amount), /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CS_COMMON_SUBMIT"),
    onSubmit: onSubmit,
    disabled: paymentDetails !== null && paymentDetails !== void 0 && (_paymentDetails$billR12 = paymentDetails.billResponse) !== null && _paymentDetails$billR12 !== void 0 && (_paymentDetails$billR13 = _paymentDetails$billR12.Bill) !== null && _paymentDetails$billR13 !== void 0 && (_paymentDetails$billR14 = _paymentDetails$billR13[0]) !== null && _paymentDetails$billR14 !== void 0 && (_paymentDetails$billR15 = _paymentDetails$billR14.billDetails[0]) !== null && _paymentDetails$billR15 !== void 0 && _paymentDetails$billR15.amount ? false : true
  })))));
};

const EDCRAcknowledgement$1 = props => {
  var _props$data2, _props$data3, _props$data5, _bpaLinks$linkData, _bpaLinks$linkData$fl, _edcrData$appliaction, _edcrData$application;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    var _props$data;
    if ((props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.type) == "ERROR" && !showToast) setShowToast(true);
  }, [props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.data]);
  if ((props === null || props === void 0 ? void 0 : (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.type) == "ERROR") {
    var _props$data4;
    return /*#__PURE__*/React__default.createElement(Card, {
      style: {
        padding: "0px"
      }
    }, /*#__PURE__*/React__default.createElement(Banner, {
      message: t("CS_BPA_APPLICATION_FAILED"),
      applicationNumber: "",
      info: "",
      successful: false,
      infoStyles: {
        fontSize: "18px",
        lineHeight: "21px",
        fontWeight: "bold",
        textAlign: "center",
        padding: "0px 15px"
      },
      applicationNumberStyles: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: "bold",
        marginTop: "10px"
      },
      style: {
        width: "100%",
        padding: "10px"
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(Link, {
      to: `/digit-ui/citizen`
    }, /*#__PURE__*/React__default.createElement(SubmitBar, {
      label: t("CORE_COMMON_GO_TO_HOME")
    }))), showToast ? /*#__PURE__*/React__default.createElement(Toast, {
      error: "error",
      label: t(props === null || props === void 0 ? void 0 : (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.data),
      onClose: () => setShowToast(null),
      isDleteBtn: true
    }) : null);
  }
  sessionStorage.setItem("isEDCRDisable", JSON.stringify(true));
  sessionStorage.setItem("isPermitApplication", true);
  const edcrData = props === null || props === void 0 ? void 0 : (_props$data5 = props.data) === null || _props$data5 === void 0 ? void 0 : _props$data5[0];
  const [bpaLinks, setBpaLinks] = useState({});
  const state = Digit.ULBService.getStateId();
  const {
    data: homePageUrlLinks,
    isLoading: homePageUrlLinksLoading
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["homePageUrlLinks"]);
  const {
    isMdmsLoading,
    data: mdmsData
  } = Digit.Hooks.obps.useMDMS(state, "BPA", ["RiskTypeComputation"]);
  useEffect(() => {
    var _homePageUrlLinks$BPA, _homePageUrlLinks$BPA2;
    if (!homePageUrlLinksLoading && (homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA === void 0 ? void 0 : (_homePageUrlLinks$BPA2 = _homePageUrlLinks$BPA.homePageUrlLinks) === null || _homePageUrlLinks$BPA2 === void 0 ? void 0 : _homePageUrlLinks$BPA2.length) > 0) {
      var _homePageUrlLinks$BPA3, _homePageUrlLinks$BPA4;
      homePageUrlLinks === null || homePageUrlLinks === void 0 ? void 0 : (_homePageUrlLinks$BPA3 = homePageUrlLinks.BPA) === null || _homePageUrlLinks$BPA3 === void 0 ? void 0 : (_homePageUrlLinks$BPA4 = _homePageUrlLinks$BPA3.homePageUrlLinks) === null || _homePageUrlLinks$BPA4 === void 0 ? void 0 : _homePageUrlLinks$BPA4.map(linkData => {
        if ((linkData === null || linkData === void 0 ? void 0 : linkData.applicationType) === (edcrData === null || edcrData === void 0 ? void 0 : edcrData.appliactionType) && (linkData === null || linkData === void 0 ? void 0 : linkData.serviceType) === (edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationSubType)) {
          setBpaLinks({
            linkData: linkData,
            edcrNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber
          });
        }
      });
    }
  }, [!homePageUrlLinksLoading]);
  const printReciept = async () => {
    var win = window.open(edcrData.planReport, '_blank');
    if (win) {
      win.focus();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, (edcrData === null || edcrData === void 0 ? void 0 : edcrData.status) == "Accepted" ? /*#__PURE__*/React__default.createElement(Card, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(Banner, {
    message: t("BPA_OC_EDCR_ACKNOWLEDGEMENT_SUCCESS_MESSAGE_LABEL"),
    applicationNumber: edcrData === null || edcrData === void 0 ? void 0 : edcrData.edcrNumber,
    info: t("EDCR_SCRUTINY_NUMBER_LABEL"),
    successful: true,
    infoStyles: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "bold",
      textAlign: "center",
      padding: "0px 15px"
    },
    applicationNumberStyles: {
      fontSize: "24px",
      lineHeight: "28px",
      fontWeight: "bold",
      marginTop: "10px"
    },
    style: {
      width: "100%",
      padding: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "10px"
    }
  }, `${t("PDF_STATIC_LABEL_CONSOLIDATED_BILL_CONSUMER_ID_TL")} - ${edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber}`), /*#__PURE__*/React__default.createElement("div", {
    className: "primary-label-btn d-grid",
    style: {
      marginLeft: "unset",
      marginBottom: "10px",
      padding: "0px 8px"
    },
    onClick: printReciept
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "23",
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z",
    fill: "#1F4A7C"
  })), t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen/obps/${bpaLinks === null || bpaLinks === void 0 ? void 0 : (_bpaLinks$linkData = bpaLinks.linkData) === null || _bpaLinks$linkData === void 0 ? void 0 : (_bpaLinks$linkData$fl = _bpaLinks$linkData.flow) === null || _bpaLinks$linkData$fl === void 0 ? void 0 : _bpaLinks$linkData$fl.toLowerCase()}/${edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$appliaction = edcrData.appliactionType) === null || _edcrData$appliaction === void 0 ? void 0 : _edcrData$appliaction.toLowerCase()}/${edcrData === null || edcrData === void 0 ? void 0 : (_edcrData$application = edcrData.applicationSubType) === null || _edcrData$application === void 0 ? void 0 : _edcrData$application.toLowerCase()}/docs-required`,
      state: bpaLinks
    },
    replace: true
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_APPLY_OC_FOR_BPA_LABEL"),
    className: "oc-aknowledgement-screen",
    onSubmit: () => sessionStorage.setItem("clickOnBPAApplyAfterEDCR", true)
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "12px",
      paddingBottom: "10px",
      paddingLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen`
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })))) : /*#__PURE__*/React__default.createElement(Card, {
    style: {
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(Banner, {
    message: t("BPA_OC_EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_LABEL"),
    applicationNumber: "",
    info: "",
    successful: false,
    infoStyles: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "bold",
      textAlign: "center",
      padding: "0px 15px"
    },
    applicationNumberStyles: {
      fontSize: "24px",
      lineHeight: "28px",
      fontWeight: "bold",
      marginTop: "10px"
    },
    style: {
      width: "100%",
      padding: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "10px"
    }
  }, t("EDCR_ACKNOWLEDGEMENT_REJECTED_MESSAGE_TEXT_LABEL")), /*#__PURE__*/React__default.createElement(CardText, {
    style: {
      padding: "0px 8px",
      marginBottom: "10px"
    }
  }, `${t("PDF_STATIC_LABEL_CONSOLIDATED_BILL_CONSUMER_ID_TL")} - ${edcrData === null || edcrData === void 0 ? void 0 : edcrData.applicationNumber}`), /*#__PURE__*/React__default.createElement("div", {
    className: "primary-label-btn d-grid",
    style: {
      marginLeft: "unset",
      marginBottom: "10px",
      padding: "0px 8px"
    },
    onClick: printReciept
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "23",
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.3334 8H14V0H6.00002V8H0.666687L10 17.3333L19.3334 8ZM0.666687 20V22.6667H19.3334V20H0.666687Z",
    fill: "#1F4A7C"
  })), t("EDCR_DOWNLOAD_SCRUTINY_REPORT_LABEL")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px",
      paddingBottom: "10px",
      paddingLeft: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen`
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "10px",
      paddingBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen/obps/form12/selfcertification`,
      state: bpaLinks
    },
    replace: true
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("APPLY_FOR_FORM12"),
    onSubmit: () => sessionStorage.setItem("clickOnBPAApplyAfterEDCR", true)
  }), /*#__PURE__*/React__default.createElement(CardText, {
    className: "button-sub-text",
    style: {
      fontSize: "14px",
      lineHeight: "16px",
      textAlign: "center",
      margin: "0px",
      marginTop: "4px",
      fontWeight: "400",
      color: "#0B0C0C"
    }
  }, t("BPA_FOR_NEW_CONSTRUCTION_LABEL"))))));
};

const GetActionMessage = props => {
  var _props$data, _props$data$BPA, _props$data2, _props$data2$BPA, _props$data2$BPA$, _props$data3, _props$data3$BPA, _props$data3$BPA$;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$BPA = _props$data.BPA) === null || _props$data$BPA === void 0 ? void 0 : _props$data$BPA[0];
  let bpaBusinessService = props !== null && props !== void 0 && (_props$data2 = props.data) !== null && _props$data2 !== void 0 && (_props$data2$BPA = _props$data2.BPA) !== null && _props$data2$BPA !== void 0 && (_props$data2$BPA$ = _props$data2$BPA[0]) !== null && _props$data2$BPA$ !== void 0 && _props$data2$BPA$.businessService ? props === null || props === void 0 ? void 0 : (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : (_props$data3$BPA = _props$data3.BPA) === null || _props$data3$BPA === void 0 ? void 0 : (_props$data3$BPA$ = _props$data3$BPA[0]) === null || _props$data3$BPA$ === void 0 ? void 0 : _props$data3$BPA$.businessService : "BPA";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (props.isSuccess) {
    var _bpaData$workflow, _bpaData$workflow2, _bpaData$workflow3, _bpaData$workflow4;
    if (getAppAction == "BPA_SUBMIT_APP") return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow = bpaData.workflow) === null || _bpaData$workflow === void 0 ? void 0 : _bpaData$workflow.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow2 = bpaData.workflow) === null || _bpaData$workflow2 === void 0 ? void 0 : _bpaData$workflow2.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow3 = bpaData.workflow) === null || _bpaData$workflow3 === void 0 ? void 0 : _bpaData$workflow3.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow4 = bpaData.workflow) === null || _bpaData$workflow4 === void 0 ? void 0 : _bpaData$workflow4.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  } else if (props.isLoading) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED");
  }
};
const getCardText = (t, props) => {
  var _props$BPA, _props$BPA2, _props$BPA2$, _props$BPA3, _props$BPA3$, _bpaData$workflow5, _bpaData$additionalDe, _bpaData$additionalDe2, _bpaData$workflow6, _bpaData$additionalDe3, _bpaData$additionalDe4;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$BPA = props.BPA) === null || _props$BPA === void 0 ? void 0 : _props$BPA[0];
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA2 = props.BPA) !== null && _props$BPA2 !== void 0 && (_props$BPA2$ = _props$BPA2[0]) !== null && _props$BPA2$ !== void 0 && _props$BPA2$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA3 = props.BPA) === null || _props$BPA3 === void 0 ? void 0 : (_props$BPA3$ = _props$BPA3[0]) === null || _props$BPA3$ === void 0 ? void 0 : _props$BPA3$.businessService : "BPA";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (getAppAction == "BPA_SUBMIT_APP") return t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow5 = bpaData.workflow) === null || _bpaData$workflow5 === void 0 ? void 0 : _bpaData$workflow5.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe = bpaData.additionalDetails) !== null && _bpaData$additionalDe !== void 0 && _bpaData$additionalDe.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe2 = bpaData.additionalDetails) === null || _bpaData$additionalDe2 === void 0 ? void 0 : _bpaData$additionalDe2.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow6 = bpaData.workflow) === null || _bpaData$workflow6 === void 0 ? void 0 : _bpaData$workflow6.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe3 = bpaData.additionalDetails) !== null && _bpaData$additionalDe3 !== void 0 && _bpaData$additionalDe3.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe4 = bpaData.additionalDetails) === null || _bpaData$additionalDe4 === void 0 ? void 0 : _bpaData$additionalDe4.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
};
const getApplicationNoLabel = props => {
  var _props$BPA4, _props$BPA4$, _props$BPA5, _props$BPA5$;
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA4 = props.BPA) !== null && _props$BPA4 !== void 0 && (_props$BPA4$ = _props$BPA4[0]) !== null && _props$BPA4$ !== void 0 && _props$BPA4$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA5 = props.BPA) === null || _props$BPA5 === void 0 ? void 0 : (_props$BPA5$ = _props$BPA5[0]) === null || _props$BPA5$ === void 0 ? void 0 : _props$BPA5$.businessService : "BPA";
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  return bpaBusinessService == "BPA" ? props === null || props === void 0 ? void 0 : props.t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : props === null || props === void 0 ? void 0 : props.t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL");
};
const BannerPicker = props => {
  var _props$data4;
  return /*#__PURE__*/React__default.createElement(Banner, {
    message: GetActionMessage(props),
    applicationNumber: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.BPA[0].applicationNo,
    info: props.isSuccess ? getApplicationNoLabel(props) : "",
    successful: props.isSuccess,
    headerStyles: {
      fontSize: "32px"
    }
  });
};
const OBPSAcknowledgement = ({
  data,
  onSuccess
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation1 = Digit.Hooks.obps.useObpsAPI(tenantId, false);
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  useEffect(() => {
    try {
      var _data$address, _data$address2, _data$address2$city;
      let tenantid = data !== null && data !== void 0 && (_data$address = data.address) !== null && _data$address !== void 0 && _data$address.city ? (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$city = _data$address2.city) === null || _data$address2$city === void 0 ? void 0 : _data$address2$city.code : tenantId;
      data.tenantId = tenantid;
      let formdata = {};
      formdata = convertToBPAObject(data);
      mutation1.mutate(formdata, {
        onSuccess
      });
    } catch (err) {
      console.log(err);
    }
  }, []);
  return mutation1.isLoading || mutation1.isIdle ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(BannerPicker, {
    t: t,
    data: mutation1.data,
    isSuccess: mutation1.isSuccess,
    isLoading: mutation1.isIdle || mutation1.isLoading
  }), mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, getCardText(t, mutation1.data)), !mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, t("CS_FILE_PROPERTY_FAILED_RESPONSE")), /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })));
};

const GetActionMessage$1 = props => {
  var _props$data, _props$data$Permissio, _props$data2, _props$data2$Permissi, _props$data2$Permissi2;
  const bpaData = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$Permissio = _props$data.PermissionOfSubdivision) === null || _props$data$Permissio === void 0 ? void 0 : _props$data$Permissio[0];
  const bpaBusinessService = ((_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : (_props$data2$Permissi = _props$data2.PermissionOfSubdivision) === null || _props$data2$Permissi === void 0 ? void 0 : (_props$data2$Permissi2 = _props$data2$Permissi[0]) === null || _props$data2$Permissi2 === void 0 ? void 0 : _props$data2$Permissi2.businessService) || "BPA_FORM11";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (props.isSuccess) {
    var _bpaData$workflow, _bpaData$workflow2, _bpaData$workflow3, _bpaData$workflow4;
    if (getAppAction == "BPA_SUBMIT_APP") return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow = bpaData.workflow) === null || _bpaData$workflow === void 0 ? void 0 : _bpaData$workflow.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow2 = bpaData.workflow) === null || _bpaData$workflow2 === void 0 ? void 0 : _bpaData$workflow2.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow3 = bpaData.workflow) === null || _bpaData$workflow3 === void 0 ? void 0 : _bpaData$workflow3.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow4 = bpaData.workflow) === null || _bpaData$workflow4 === void 0 ? void 0 : _bpaData$workflow4.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  } else if (props.isLoading) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED");
  }
};
const getCardText$1 = (t, props) => {
  var _props$PermissionOfSu, _props$data3, _props$data3$Permissi, _props$data3$Permissi2, _bpaData$workflow5, _bpaData$additionalDe, _bpaData$additionalDe2, _bpaData$workflow6, _bpaData$additionalDe3, _bpaData$additionalDe4;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$PermissionOfSu = props.PermissionOfSubdivision) === null || _props$PermissionOfSu === void 0 ? void 0 : _props$PermissionOfSu[0];
  const bpaBusinessService = ((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : (_props$data3$Permissi = _props$data3.PermissionOfSubdivision) === null || _props$data3$Permissi === void 0 ? void 0 : (_props$data3$Permissi2 = _props$data3$Permissi[0]) === null || _props$data3$Permissi2 === void 0 ? void 0 : _props$data3$Permissi2.businessService) || "BPA_FORM11";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (getAppAction == "BPA_SUBMIT_APP") return t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow5 = bpaData.workflow) === null || _bpaData$workflow5 === void 0 ? void 0 : _bpaData$workflow5.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe = bpaData.additionalDetails) !== null && _bpaData$additionalDe !== void 0 && _bpaData$additionalDe.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe2 = bpaData.additionalDetails) === null || _bpaData$additionalDe2 === void 0 ? void 0 : _bpaData$additionalDe2.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow6 = bpaData.workflow) === null || _bpaData$workflow6 === void 0 ? void 0 : _bpaData$workflow6.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe3 = bpaData.additionalDetails) !== null && _bpaData$additionalDe3 !== void 0 && _bpaData$additionalDe3.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe4 = bpaData.additionalDetails) === null || _bpaData$additionalDe4 === void 0 ? void 0 : _bpaData$additionalDe4.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
};
const getApplicationNoLabel$1 = props => {
  var _props$BPA, _props$BPA$, _props$BPA2, _props$BPA2$;
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA = props.BPA) !== null && _props$BPA !== void 0 && (_props$BPA$ = _props$BPA[0]) !== null && _props$BPA$ !== void 0 && _props$BPA$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA2 = props.BPA) === null || _props$BPA2 === void 0 ? void 0 : (_props$BPA2$ = _props$BPA2[0]) === null || _props$BPA2$ === void 0 ? void 0 : _props$BPA2$.businessService : "BPA";
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  return bpaBusinessService == "BPA" ? props === null || props === void 0 ? void 0 : props.t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : props === null || props === void 0 ? void 0 : props.t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL");
};
const BannerPicker$1 = props => {
  var _props$data4;
  return /*#__PURE__*/React__default.createElement(Banner, {
    message: GetActionMessage$1(props),
    applicationNumber: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.PermissionOfSubdivision[0].applicationNo,
    info: props.isSuccess ? getApplicationNoLabel$1(props) : "",
    successful: props.isSuccess,
    headerStyles: {
      fontSize: "32px"
    }
  });
};
const OBPSAcknowledgement$1 = ({
  data,
  onSuccess
}) => {
  var _data$landAreaDetails, _mutation1$data, _mutation1$data$Permi;
  const {
    t
  } = useTranslation();
  const tenantId = (data === null || data === void 0 ? void 0 : (_data$landAreaDetails = data.landAreaDetails) === null || _data$landAreaDetails === void 0 ? void 0 : _data$landAreaDetails.tenantId) || Digit.ULBService.getCurrentTenantId();
  const mutation1 = Digit.Hooks.obps.useObpsAPI(tenantId, 'Form11');
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  useEffect(() => {
    try {
      var _data$address, _data$address2, _data$address2$city;
      let tenantid = data !== null && data !== void 0 && (_data$address = data.address) !== null && _data$address !== void 0 && _data$address.city ? (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$city = _data$address2.city) === null || _data$address2$city === void 0 ? void 0 : _data$address2$city.code : tenantId;
      data.tenantId = tenantid;
      let formdata = {};
      formdata = convertForm11ToBPAObject(data);
      mutation1.mutate(formdata, {
        onSuccess
      });
    } catch (err) {
      console.error(err);
    }
  }, []);
  return mutation1.isLoading || mutation1.isIdle ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(BannerPicker$1, {
    t: t,
    data: mutation1.data,
    isSuccess: mutation1.isSuccess,
    isLoading: mutation1.isIdle || mutation1.isLoading
  }), mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, getCardText$1(t, mutation1.data)), !mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, t("CS_FILE_PROPERTY_FAILED_RESPONSE")), /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })), mutation1.isSuccess && (mutation1 === null || mutation1 === void 0 ? void 0 : (_mutation1$data = mutation1.data) === null || _mutation1$data === void 0 ? void 0 : (_mutation1$data$Permi = _mutation1$data.PermissionOfSubdivision[0].businessService) === null || _mutation1$data$Permi === void 0 ? void 0 : _mutation1$data$Permi.includes("UD")) && /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen/payment/collect/bpa/${mutation1.data.PermissionOfSubdivision[0].applicationNo}/${mutation1.data.PermissionOfSubdivision[0].tenantId}?tenantId=${mutation1.data.PermissionOfSubdivision[0].tenantId}?flow=${mutation1.data.PermissionOfSubdivision[0].applicationType}`,
      state: {
        tenantId: mutation1.data.PermissionOfSubdivision[0].tenantId
      }
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("COMMON_MAKE_PAYMENT"),
    style: {
      transform: 'translate(15rem, -2.5rem)'
    }
  })));
};

const GetActionMessage$2 = props => {
  var _props$data, _props$data$Permissio, _props$data2, _props$data2$Permissi, _props$data2$Permissi2;
  const bpaData = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$Permissio = _props$data.PermissionOfSubdivision) === null || _props$data$Permissio === void 0 ? void 0 : _props$data$Permissio[0];
  const bpaBusinessService = ((_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : (_props$data2$Permissi = _props$data2.PermissionOfSubdivision) === null || _props$data2$Permissi === void 0 ? void 0 : (_props$data2$Permissi2 = _props$data2$Permissi[0]) === null || _props$data2$Permissi2 === void 0 ? void 0 : _props$data2$Permissi2.businessService) || "BPA_FORM26";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (props.isSuccess) {
    var _bpaData$workflow, _bpaData$workflow2, _bpaData$workflow3, _bpaData$workflow4;
    if (getAppAction == "BPA_SUBMIT_APP") return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow = bpaData.workflow) === null || _bpaData$workflow === void 0 ? void 0 : _bpaData$workflow.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow2 = bpaData.workflow) === null || _bpaData$workflow2 === void 0 ? void 0 : _bpaData$workflow2.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow3 = bpaData.workflow) === null || _bpaData$workflow3 === void 0 ? void 0 : _bpaData$workflow3.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow4 = bpaData.workflow) === null || _bpaData$workflow4 === void 0 ? void 0 : _bpaData$workflow4.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  } else if (props.isLoading) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED");
  }
};
const getCardText$2 = (t, props) => {
  var _props$PermissionOfSu, _props$data3, _props$data3$Permissi, _props$data3$Permissi2, _bpaData$workflow5, _bpaData$additionalDe, _bpaData$additionalDe2, _bpaData$workflow6, _bpaData$additionalDe3, _bpaData$additionalDe4;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$PermissionOfSu = props.PermissionOfSubdivision) === null || _props$PermissionOfSu === void 0 ? void 0 : _props$PermissionOfSu[0];
  const bpaBusinessService = ((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : (_props$data3$Permissi = _props$data3.PermissionOfSubdivision) === null || _props$data3$Permissi === void 0 ? void 0 : (_props$data3$Permissi2 = _props$data3$Permissi[0]) === null || _props$data3$Permissi2 === void 0 ? void 0 : _props$data3$Permissi2.businessService) || "BPA_FORM26";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (getAppAction == "BPA_SUBMIT_APP") return t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow5 = bpaData.workflow) === null || _bpaData$workflow5 === void 0 ? void 0 : _bpaData$workflow5.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe = bpaData.additionalDetails) !== null && _bpaData$additionalDe !== void 0 && _bpaData$additionalDe.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe2 = bpaData.additionalDetails) === null || _bpaData$additionalDe2 === void 0 ? void 0 : _bpaData$additionalDe2.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow6 = bpaData.workflow) === null || _bpaData$workflow6 === void 0 ? void 0 : _bpaData$workflow6.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe3 = bpaData.additionalDetails) !== null && _bpaData$additionalDe3 !== void 0 && _bpaData$additionalDe3.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe4 = bpaData.additionalDetails) === null || _bpaData$additionalDe4 === void 0 ? void 0 : _bpaData$additionalDe4.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
};
const getApplicationNoLabel$2 = props => {
  var _props$BPA, _props$BPA$, _props$BPA2, _props$BPA2$;
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA = props.BPA) !== null && _props$BPA !== void 0 && (_props$BPA$ = _props$BPA[0]) !== null && _props$BPA$ !== void 0 && _props$BPA$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA2 = props.BPA) === null || _props$BPA2 === void 0 ? void 0 : (_props$BPA2$ = _props$BPA2[0]) === null || _props$BPA2$ === void 0 ? void 0 : _props$BPA2$.businessService : "BPA";
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  return bpaBusinessService == "BPA" ? props === null || props === void 0 ? void 0 : props.t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : props === null || props === void 0 ? void 0 : props.t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL");
};
const BannerPicker$2 = props => {
  var _props$data4;
  return /*#__PURE__*/React__default.createElement(Banner, {
    message: GetActionMessage$2(props),
    applicationNumber: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.PermissionOfSubdivision[0].applicationNo,
    info: props.isSuccess ? getApplicationNoLabel$2(props) : "",
    successful: props.isSuccess,
    headerStyles: {
      fontSize: "32px"
    }
  });
};
const OBPSAcknowledgement$2 = ({
  data,
  onSuccess
}) => {
  var _data$landAreaDetails;
  const {
    t
  } = useTranslation();
  const tenantId = (data === null || data === void 0 ? void 0 : (_data$landAreaDetails = data.landAreaDetails) === null || _data$landAreaDetails === void 0 ? void 0 : _data$landAreaDetails.tenantId) || Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.obps.useObpsAPI(tenantId, 'Form26');
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  useEffect(() => {
    try {
      var _data$address, _data$address2, _data$address2$city;
      let tenantid = data !== null && data !== void 0 && (_data$address = data.address) !== null && _data$address !== void 0 && _data$address.city ? (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$city = _data$address2.city) === null || _data$address2$city === void 0 ? void 0 : _data$address2$city.code : tenantId;
      data.tenantId = tenantid;
      let formdata = {};
      formdata = convertForm11ToBPAObject(data);
      mutation.mutate(formdata, {
        onSuccess
      });
    } catch (err) {
      console.log(err);
    }
  }, []);
  return mutation.isLoading || mutation.isIdle ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(BannerPicker$2, {
    t: t,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  }), mutation.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, getCardText$2(t, mutation.data)), !mutation.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, t("CS_FILE_PROPERTY_FAILED_RESPONSE")), /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })));
};

const GetActionMessage$3 = props => {
  var _props$data, _props$data$BPA, _props$data2, _props$data2$BPA, _props$data2$BPA$, _props$data3, _props$data3$BPA, _props$data3$BPA$;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$BPA = _props$data.BPA) === null || _props$data$BPA === void 0 ? void 0 : _props$data$BPA[0];
  let bpaBusinessService = props !== null && props !== void 0 && (_props$data2 = props.data) !== null && _props$data2 !== void 0 && (_props$data2$BPA = _props$data2.BPA) !== null && _props$data2$BPA !== void 0 && (_props$data2$BPA$ = _props$data2$BPA[0]) !== null && _props$data2$BPA$ !== void 0 && _props$data2$BPA$.businessService ? props === null || props === void 0 ? void 0 : (_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : (_props$data3$BPA = _props$data3.BPA) === null || _props$data3$BPA === void 0 ? void 0 : (_props$data3$BPA$ = _props$data3$BPA[0]) === null || _props$data3$BPA$ === void 0 ? void 0 : _props$data3$BPA$.businessService : "BPA";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (props.isSuccess) {
    var _bpaData$workflow, _bpaData$workflow2, _bpaData$workflow3, _bpaData$workflow4;
    if (getAppAction == "BPA_SUBMIT_APP") return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow = bpaData.workflow) === null || _bpaData$workflow === void 0 ? void 0 : _bpaData$workflow.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow2 = bpaData.workflow) === null || _bpaData$workflow2 === void 0 ? void 0 : _bpaData$workflow2.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow3 = bpaData.workflow) === null || _bpaData$workflow3 === void 0 ? void 0 : _bpaData$workflow3.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : props === null || props === void 0 ? void 0 : props.t(`BPA_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow4 = bpaData.workflow) === null || _bpaData$workflow4 === void 0 ? void 0 : _bpaData$workflow4.action}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  } else if (props.isLoading) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("editApplication") ? props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED") : props === null || props === void 0 ? void 0 : props.t("CS_BPA_APPLICATION_FAILED");
  }
};
const getCardText$3 = (t, props) => {
  var _props$BPA, _props$BPA2, _props$BPA2$, _props$BPA3, _props$BPA3$, _bpaData$workflow5, _bpaData$additionalDe, _bpaData$additionalDe2, _bpaData$workflow6, _bpaData$additionalDe3, _bpaData$additionalDe4;
  const bpaData = props === null || props === void 0 ? void 0 : (_props$BPA = props.BPA) === null || _props$BPA === void 0 ? void 0 : _props$BPA[0];
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA2 = props.BPA) !== null && _props$BPA2 !== void 0 && (_props$BPA2$ = _props$BPA2[0]) !== null && _props$BPA2$ !== void 0 && _props$BPA2$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA3 = props.BPA) === null || _props$BPA3 === void 0 ? void 0 : (_props$BPA3$ = _props$BPA3[0]) === null || _props$BPA3$ === void 0 ? void 0 : _props$BPA3$.businessService : "BPA";
  let bpaStatus = bpaData === null || bpaData === void 0 ? void 0 : bpaData.status;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  if (getAppAction == "BPA_SUBMIT_APP") t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow5 = bpaData.workflow) === null || _bpaData$workflow5 === void 0 ? void 0 : _bpaData$workflow5.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe = bpaData.additionalDetails) !== null && _bpaData$additionalDe !== void 0 && _bpaData$additionalDe.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe2 = bpaData.additionalDetails) === null || _bpaData$additionalDe2 === void 0 ? void 0 : _bpaData$additionalDe2.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
  return t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$workflow6 = bpaData.workflow) === null || _bpaData$workflow6 === void 0 ? void 0 : _bpaData$workflow6.action}_${bpaData !== null && bpaData !== void 0 && (_bpaData$additionalDe3 = bpaData.additionalDetails) !== null && _bpaData$additionalDe3 !== void 0 && _bpaData$additionalDe3.typeOfArchitect ? bpaData === null || bpaData === void 0 ? void 0 : (_bpaData$additionalDe4 = bpaData.additionalDetails) === null || _bpaData$additionalDe4 === void 0 ? void 0 : _bpaData$additionalDe4.typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`);
};
const getApplicationNoLabel$3 = props => {
  var _props$BPA4, _props$BPA4$, _props$BPA5, _props$BPA5$;
  let bpaBusinessService = props !== null && props !== void 0 && (_props$BPA4 = props.BPA) !== null && _props$BPA4 !== void 0 && (_props$BPA4$ = _props$BPA4[0]) !== null && _props$BPA4$ !== void 0 && _props$BPA4$.businessService ? props === null || props === void 0 ? void 0 : (_props$BPA5 = props.BPA) === null || _props$BPA5 === void 0 ? void 0 : (_props$BPA5$ = _props$BPA5[0]) === null || _props$BPA5$ === void 0 ? void 0 : _props$BPA5$.businessService : "BPA";
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  if (bpaBusinessService == "BPA") {
    return props === null || props === void 0 ? void 0 : props.t("BPA_PERMIT_APPLICATION_NUMBER_LABEL");
  } else {
    return props === null || props === void 0 ? void 0 : props.t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL");
  }
};
const BannerPicker$3 = props => {
  var _props$data4;
  return /*#__PURE__*/React__default.createElement(Banner, {
    message: GetActionMessage$3(props),
    applicationNumber: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.BPA[0].applicationNo,
    info: props.isSuccess ? getApplicationNoLabel$3(props) : "",
    successful: props.isSuccess,
    headerStyles: {
      fontSize: "32px"
    }
  });
};
const OBPSAcknowledgement$3 = ({
  data,
  onSuccess
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.obps.useObpsAPI(data !== null && data !== void 0 && data.tenantId ? data === null || data === void 0 ? void 0 : data.tenantId : tenantId, true);
  const mutation1 = Digit.Hooks.obps.useObpsAPI(data !== null && data !== void 0 && data.tenantId ? data === null || data === void 0 ? void 0 : data.tenantId : tenantId, false);
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  useEffect(() => {
    try {
      var _data$nocDocuments;
      let tenantId = data !== null && data !== void 0 && data.tenantId ? data === null || data === void 0 ? void 0 : data.tenantId : tenantId;
      data.tenantId = data === null || data === void 0 ? void 0 : data.tenantId;
      let formdata = {};
      data === null || data === void 0 ? void 0 : (_data$nocDocuments = data.nocDocuments) === null || _data$nocDocuments === void 0 ? void 0 : _data$nocDocuments.NocDetails.map(noc => {
        formdata = convertToNocObject(noc, data);
        mutation.mutate(formdata, {
          onSuccess
        });
      });
      formdata = convertToBPAObject(data, true);
      mutation1.mutate(formdata, {
        onSuccess
      });
    } catch (err) {}
  }, []);
  return mutation1.isLoading || mutation1.isIdle ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(BannerPicker$3, {
    t: t,
    data: mutation1.data,
    isSuccess: mutation1.isSuccess,
    isLoading: mutation1.isIdle || mutation1.isLoading
  }), mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, getCardText$3(t, mutation1.data)), !mutation1.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, t(Digit.Utils.locale.getTransformedLocale(mutation1.error.message))), /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })));
};

const Acknowledgement = props => {
  var _BPAData$workflow, _BPAData$workflow2, _BPAData$additionalDe;
  const BPAData = props === null || props === void 0 ? void 0 : props.data;
  const {
    t
  } = useTranslation();
  let getAppAction = sessionStorage.getItem("BPA_SUBMIT_APP") ? JSON.parse(sessionStorage.getItem("BPA_SUBMIT_APP")) : null;
  let bpaBusinessService = BPAData !== null && BPAData !== void 0 && BPAData.businessService ? BPAData === null || BPAData === void 0 ? void 0 : BPAData.businessService : "BPA";
  let bpaStatus = BPAData === null || BPAData === void 0 ? void 0 : BPAData.status;
  let bpaAction = BPAData !== null && BPAData !== void 0 && (_BPAData$workflow = BPAData.workflow) !== null && _BPAData$workflow !== void 0 && _BPAData$workflow.action ? BPAData === null || BPAData === void 0 ? void 0 : (_BPAData$workflow2 = BPAData.workflow) === null || _BPAData$workflow2 === void 0 ? void 0 : _BPAData$workflow2.action : "VERIFY_FORWARD";
  let typeOfArchitect = BPAData === null || BPAData === void 0 ? void 0 : (_BPAData$additionalDe = BPAData.additionalDetails) === null || _BPAData$additionalDe === void 0 ? void 0 : _BPAData$additionalDe.typeOfArchitect;
  if (bpaBusinessService == "BPA_LOW") bpaBusinessService = "BPA";
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(Banner, {
    message: getAppAction == "BPA_SUBMIT_APP" ? t(`BPA_SUBMIT_HEADER_${bpaBusinessService}_${bpaAction}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : t(`BPA_HEADER_${bpaBusinessService}_${bpaAction}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`),
    applicationNumber: BPAData === null || BPAData === void 0 ? void 0 : BPAData.applicationNo,
    info: bpaBusinessService == "BPA" ? t("BPA_PERMIT_APPLICATION_NUMBER_LABEL") : t("BPA_OCCUPANCY_CERTIFICATE_APPLICATION_NUMBER_LABEL"),
    successful: true,
    style: {
      padding: "10px"
    },
    headerStyles: {
      fontSize: "32px"
    }
  }), /*#__PURE__*/React__default.createElement(CardText, null, getAppAction == "BPA_SUBMIT_APP" ? t(`BPA_SUBMIT_SUB_HEADER_${bpaBusinessService}_${bpaAction}_${typeOfArchitect ? typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`) : t(`BPA_SUB_HEADER_${bpaBusinessService}_${bpaAction}_${typeOfArchitect ? typeOfArchitect : "ARCHITECT"}_${stringReplaceAll(bpaStatus, " ", "_").toUpperCase()}`)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "12px",
      padding: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen`
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })))));
};

const GetActionMessage$4 = props => {
  const {
    t
  } = useTranslation();
  if (props.isSuccess) {
    return !window.location.href.includes("edit-application") ? t("CS_STAKEHOLDER_APPLICATION_SUCCESS") : t("CS_PROPERTY_UPDATE_APPLICATION_SUCCESS");
  } else if (props.isLoading) {
    return !window.location.href.includes("edit-application") ? t("CS_STAKEHOLDER_APPLICATION_PENDING") : t("CS_PROPERTY_UPDATE_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("edit-application") ? t("CS_STAKEHOLDER_APPLICATION_FAILED") : t("CS_PROPERTY_UPDATE_APPLICATION_FAILED");
  }
};
const BannerPicker$4 = props => {
  var _props$data;
  return /*#__PURE__*/React__default.createElement(Banner, {
    message: GetActionMessage$4(props),
    applicationNumber: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.Licenses[0].applicationNumber,
    info: props.isSuccess ? props.t("BPA_NEW_STAKEHOLDER_REGISTRATION_APP_LABEL") : "",
    successful: props.isSuccess,
    style: {
      padding: "10px"
    },
    headerStyles: {
      fontSize: "32px"
    }
  });
};
const StakeholderAcknowledgement = ({
  data,
  onSuccess
}) => {
  var _data$address, _data$address2, _data$address2$city, _mutation$data, _mutation$data$Licens, _mutation$data$Licens2, _mutation$data$Licens3, _mutation$data$Licens4, _mutation$data$Licens5, _mutation$data$Licens6;
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const mutation = Digit.Hooks.obps.useStakeholderAPI(data !== null && data !== void 0 && (_data$address = data.address) !== null && _data$address !== void 0 && _data$address.city ? (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$city = _data$address2.city) === null || _data$address2$city === void 0 ? void 0 : _data$address2$city.code : tenantId, true);
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  let isOpenLinkFlow = window.location.href.includes("openlink");
  const isCitizenUrl = Digit.Utils.browser.isMobile() ? true : false;
  const licenseType = (mutation === null || mutation === void 0 ? void 0 : (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Licens = _mutation$data.Licenses) === null || _mutation$data$Licens === void 0 ? void 0 : (_mutation$data$Licens2 = _mutation$data$Licens[0]) === null || _mutation$data$Licens2 === void 0 ? void 0 : (_mutation$data$Licens3 = _mutation$data$Licens2.tradeLicenseDetail) === null || _mutation$data$Licens3 === void 0 ? void 0 : (_mutation$data$Licens4 = _mutation$data$Licens3.tradeUnits) === null || _mutation$data$Licens4 === void 0 ? void 0 : (_mutation$data$Licens5 = _mutation$data$Licens4[0]) === null || _mutation$data$Licens5 === void 0 ? void 0 : (_mutation$data$Licens6 = _mutation$data$Licens5.tradeType) === null || _mutation$data$Licens6 === void 0 ? void 0 : _mutation$data$Licens6.split(".")[0]) || "ARCHITECT";
  useEffect(() => {
    try {
      var _data$result, _data$result$Licenses, _data$result2, _data$result2$License;
      let tenantId = data !== null && data !== void 0 && (_data$result = data.result) !== null && _data$result !== void 0 && (_data$result$Licenses = _data$result.Licenses[0]) !== null && _data$result$Licenses !== void 0 && _data$result$Licenses.tenantId ? data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : (_data$result2$License = _data$result2.Licenses[0]) === null || _data$result2$License === void 0 ? void 0 : _data$result2$License.tenantId : tenantId;
      data.tenantId = tenantId;
      let formdata = {};
      formdata = convertToStakeholderObject(data);
      mutation.mutate(formdata, {
        onSuccess
      });
    } catch (err) {}
  }, []);
  return mutation.isLoading || mutation.isIdle ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: isOpenLinkFlow ? "OpenlinkContainer" : ""
  }, isOpenLinkFlow && /*#__PURE__*/React__default.createElement(BackButton, {
    style: {
      border: "none"
    }
  }, t("CS_COMMON_BACK")), /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(BannerPicker$4, {
    t: t,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  }), mutation.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, `${t(`TRADELICENSE_TRADETYPE_${licenseType}`)}${t(`CS_FILE_STAKEHOLDER_RESPONSE`)}`), !mutation.isSuccess && /*#__PURE__*/React__default.createElement(CardText, null, t("CS_FILE_PROPERTY_FAILED_RESPONSE")), mutation.isSuccess && !isOpenLinkFlow && /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen/payment/collect/${mutation.data.Licenses[0].businessService}/${mutation.data.Licenses[0].applicationNumber}/${mutation.data.Licenses[0].tenantId}?tenantId=${mutation.data.Licenses[0].tenantId}`,
      state: {
        tenantId: mutation.data.Licenses[0].tenantId
      }
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("COMMON_MAKE_PAYMENT")
  })), !isOpenLinkFlow && /*#__PURE__*/React__default.createElement(Link, {
    to: `/digit-ui/citizen`
  }, /*#__PURE__*/React__default.createElement(LinkButton, {
    label: t("CORE_COMMON_GO_TO_HOME")
  })), mutation.isSuccess && isOpenLinkFlow && /*#__PURE__*/React__default.createElement(Link, {
    to: {
      pathname: `/digit-ui/citizen`
    }
  }, /*#__PURE__*/React__default.createElement(SubmitBar, {
    label: t("BPA_COMMON_PROCEED_NEXT")
  })))));
};

const ProjectTypList = [{
  code: "Plot-subdivision",
  name: "Plot-subdivision"
}, {
  code: "Building_Permsssion_Normal",
  name: "Building Permsssion-Normal"
}, {
  code: "Building_Permsssion-Sub_division",
  name: "Building Permsssion-Sub division"
}, {
  code: "Integrated_Township",
  name: "Integrated Township"
}, {
  code: "Layout_Development",
  name: "Layout Development"
}, {
  code: "Building_Permsssion-Group_Development",
  name: "Building Permsssion-Group Development"
}];
const natureOfConstructionOptions$1 = [{
  code: "NEW_CONSTRUCTION",
  name: "New"
}, {
  code: "Addition Extension",
  name: "Addition Extension"
}, {
  code: "Redevelopment/Reconstruction ",
  name: "Redevelopment/Reconstruction "
}];
const planOnOptions$1 = [{
  code: "DA/AVP_Approval_Schemes",
  name: "DA/AVP Approval Schemes"
}, {
  code: "Private_Approved_Schemes",
  name: "Private Approved Schemes"
}, {
  code: "Others",
  name: "Others"
}];
const subDevelopmentAreaOptions = [{
  code: "NA",
  name: "NA"
}, {
  code: "Metro_City_Area",
  name: "Metro City Area"
}, {
  code: "Vilage_Area",
  name: "Vilage Area"
}, {
  code: "Other_Town_Area",
  name: "Other Town Area"
}];
const developmentAreaOptions = [{
  code: "Existing_Builtup_Area/Constructed_Area",
  name: "Existing Builtup Area/Constructed Area"
}, {
  code: "Developed_Area",
  name: "Developed Area"
}, {
  code: "New_Area",
  name: "New Area"
}, {
  code: "Undevelopment_Area",
  name: "Undevelopment Area"
}, {
  code: "Undefined_Area",
  name: "Undefined Area"
}];
const proposalTypeOptions = [{
  code: "Yes",
  name: "Yes"
}, {
  code: "No",
  name: "No"
}];
const EDCRForm2 = ({
  t,
  config,
  onSelect,
  formData,
  isShowToast,
  isSubmitBtnDisable,
  setIsShowToast
}) => {
  var _Digit, _Digit$SessionStorage, _Digit$SessionStorage2, _Digit2, _cityList$filter, _cityList$filter$, _Digit3, _localities$selectedL, _formData$Scrutiny, _formData$Scrutiny$, _formData$Scrutiny2, _formData$Scrutiny2$, _formData$Scrutiny3, _formData$Scrutiny3$, _formData$owners, _formData$owners$docu, _formData$Scrutiny5, _formData$Scrutiny5$, _formData$Scrutiny6, _formData$Scrutiny6$, _formData$Scrutiny7, _formData$Scrutiny7$, _formData$Scrutiny8, _formData$Scrutiny8$, _formData$Scrutiny9, _formData$Scrutiny9$, _formData$Scrutiny10, _formData$Scrutiny10$, _formData$Scrutiny11, _formData$Scrutiny11$, _formData$Scrutiny12, _formData$Scrutiny12$, _formData$Scrutiny13, _formData$Scrutiny13$, _formData$Scrutiny14, _formData$Scrutiny14$, _formData$Scrutiny15, _formData$Scrutiny15$, _formData$Scrutiny16, _formData$Scrutiny16$, _formData$Scrutiny17, _formData$Scrutiny17$, _formData$Scrutiny18, _formData$Scrutiny18$, _formData$Scrutiny19, _formData$Scrutiny19$, _formData$Scrutiny20, _formData$Scrutiny20$, _formData$Scrutiny21, _formData$Scrutiny21$;
  const code = "up";
  const applicationFlow = (_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$SessionStorage = _Digit.SessionStorage) === null || _Digit$SessionStorage === void 0 ? void 0 : (_Digit$SessionStorage2 = _Digit$SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) === null || _Digit$SessionStorage2 === void 0 ? void 0 : _Digit$SessionStorage2.toLowerCase();
  const udCode = applicationFlow === "ud";
  const {
    data: cityList,
    isLoading: isCityListLoading
  } = (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.Hooks.useTenants();
  const citymoduleList = !isCityListLoading && ((_cityList$filter = cityList.filter(e => {
    var _e$code;
    return e === null || e === void 0 ? void 0 : (_e$code = e.code) === null || _e$code === void 0 ? void 0 : _e$code.includes("avp");
  })) === null || _cityList$filter === void 0 ? void 0 : (_cityList$filter$ = _cityList$filter[0]) === null || _cityList$filter$ === void 0 ? void 0 : _cityList$filter$.boundary) || [];
  const scrutinyDetails = (_Digit3 = Digit) === null || _Digit3 === void 0 ? void 0 : _Digit3.SessionStorage.get(config.key);
  const [selectedCity, setSelectedCity] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.city) || null);
  const [localities, setLocalities] = useState((selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.boundary) || null);
  const [selectedLocality, setSelectedLocality] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.locality) || null);
  const [areaType, setAreaType] = useState("");
  const selectedLocalityIndex = localities === null || localities === void 0 ? void 0 : localities.findIndex(e => e.name === (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name));
  const [villages, setVillages] = useState((selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.children) || (localities === null || localities === void 0 ? void 0 : (_localities$selectedL = localities[selectedLocalityIndex]) === null || _localities$selectedL === void 0 ? void 0 : _localities$selectedL.children) || []);
  const [village, setVillage] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.village) || null);
  const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [name, setName] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.applicantName) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny = formData.Scrutiny) === null || _formData$Scrutiny === void 0 ? void 0 : (_formData$Scrutiny$ = _formData$Scrutiny[0]) === null || _formData$Scrutiny$ === void 0 ? void 0 : _formData$Scrutiny$.applicantName));
  const [groundCoverages, setgroundCoverages] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.groundCoverages) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny2 = formData.Scrutiny) === null || _formData$Scrutiny2 === void 0 ? void 0 : (_formData$Scrutiny2$ = _formData$Scrutiny2[0]) === null || _formData$Scrutiny2$ === void 0 ? void 0 : _formData$Scrutiny2$.groundCoverages));
  const [fars, setFars] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.fars) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny3 = formData.Scrutiny) === null || _formData$Scrutiny3 === void 0 ? void 0 : (_formData$Scrutiny3$ = _formData$Scrutiny3[0]) === null || _formData$Scrutiny3$ === void 0 ? void 0 : _formData$Scrutiny3$.fars));
  const [uploadedFile, setUploadedFile] = useState(() => {
    var _formData$Scrutiny4, _formData$Scrutiny4$, _formData$Scrutiny4$$;
    return (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny4 = formData.Scrutiny) === null || _formData$Scrutiny4 === void 0 ? void 0 : (_formData$Scrutiny4$ = _formData$Scrutiny4[0]) === null || _formData$Scrutiny4$ === void 0 ? void 0 : (_formData$Scrutiny4$$ = _formData$Scrutiny4$.proofIdentity) === null || _formData$Scrutiny4$$ === void 0 ? void 0 : _formData$Scrutiny4$$.fileStoreId) || null;
  });
  const [file, setFile] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : (_formData$owners$docu = _formData$owners.documents) === null || _formData$owners$docu === void 0 ? void 0 : _formData$owners$docu.proofIdentity);
  const [uploadMessage, setUploadMessage] = useState("");
  const findOption = (options, val) => {
    if (!val) return null;
    if (typeof val === "object") return val;
    return (options === null || options === void 0 ? void 0 : options.find(opt => opt.name === val || opt.code === val)) || (typeof val === "string" ? {
      code: val,
      name: val
    } : null);
  };
  const [landMarks, setLandMarks] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.landMarks) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny5 = formData.Scrutiny) === null || _formData$Scrutiny5 === void 0 ? void 0 : (_formData$Scrutiny5$ = _formData$Scrutiny5[0]) === null || _formData$Scrutiny5$ === void 0 ? void 0 : _formData$Scrutiny5$.landMarks));
  const [natureOfConstruction, setNatureOfConstruction] = useState(findOption(natureOfConstructionOptions$1, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.natureOfConstruction) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny6 = formData.Scrutiny) === null || _formData$Scrutiny6 === void 0 ? void 0 : (_formData$Scrutiny6$ = _formData$Scrutiny6[0]) === null || _formData$Scrutiny6$ === void 0 ? void 0 : _formData$Scrutiny6$.natureOfConstruction) || null);
  const [proposalType, setProposalType] = useState(findOption(proposalTypeOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.proposalType) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny7 = formData.Scrutiny) === null || _formData$Scrutiny7 === void 0 ? void 0 : (_formData$Scrutiny7$ = _formData$Scrutiny7[0]) === null || _formData$Scrutiny7$ === void 0 ? void 0 : _formData$Scrutiny7$.proposalType) || null);
  const [isSpecialProject, setIsSpecialProject] = useState(findOption(proposalTypeOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.isSpecialProject) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny8 = formData.Scrutiny) === null || _formData$Scrutiny8 === void 0 ? void 0 : (_formData$Scrutiny8$ = _formData$Scrutiny8[0]) === null || _formData$Scrutiny8$ === void 0 ? void 0 : _formData$Scrutiny8$.isSpecialProject) || null);
  const [isPlotSetback, setIsPlotSetback] = useState(findOption(proposalTypeOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.isPlotSetback) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny9 = formData.Scrutiny) === null || _formData$Scrutiny9 === void 0 ? void 0 : (_formData$Scrutiny9$ = _formData$Scrutiny9[0]) === null || _formData$Scrutiny9$ === void 0 ? void 0 : _formData$Scrutiny9$.isPlotSetback) || null);
  const [setbackFront, setSetbackFront] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.setbackFront) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny10 = formData.Scrutiny) === null || _formData$Scrutiny10 === void 0 ? void 0 : (_formData$Scrutiny10$ = _formData$Scrutiny10[0]) === null || _formData$Scrutiny10$ === void 0 ? void 0 : _formData$Scrutiny10$.setbackFront));
  const [setbackRear, setSetbackRear] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.setbackRear) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny11 = formData.Scrutiny) === null || _formData$Scrutiny11 === void 0 ? void 0 : (_formData$Scrutiny11$ = _formData$Scrutiny11[0]) === null || _formData$Scrutiny11$ === void 0 ? void 0 : _formData$Scrutiny11$.setbackRear));
  const [backSide, setBackSide] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.backSide) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny12 = formData.Scrutiny) === null || _formData$Scrutiny12 === void 0 ? void 0 : (_formData$Scrutiny12$ = _formData$Scrutiny12[0]) === null || _formData$Scrutiny12$ === void 0 ? void 0 : _formData$Scrutiny12$.backSide));
  const [isApprovedLayout, setIsApprovedLayout] = useState(findOption(proposalTypeOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.isApprovedLayout) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny13 = formData.Scrutiny) === null || _formData$Scrutiny13 === void 0 ? void 0 : (_formData$Scrutiny13$ = _formData$Scrutiny13[0]) === null || _formData$Scrutiny13$ === void 0 ? void 0 : _formData$Scrutiny13$.isApprovedLayout) || null);
  const [projectType, setProjectType] = useState(findOption(ProjectTypList, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.projectType) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny14 = formData.Scrutiny) === null || _formData$Scrutiny14 === void 0 ? void 0 : (_formData$Scrutiny14$ = _formData$Scrutiny14[0]) === null || _formData$Scrutiny14$ === void 0 ? void 0 : _formData$Scrutiny14$.projectType) || null);
  const [isRevised, setIsRevised] = useState(findOption(proposalTypeOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.isRevised) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny15 = formData.Scrutiny) === null || _formData$Scrutiny15 === void 0 ? void 0 : (_formData$Scrutiny15$ = _formData$Scrutiny15[0]) === null || _formData$Scrutiny15$ === void 0 ? void 0 : _formData$Scrutiny15$.isRevised) || null);
  const [tehsil, setTehsil] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.tehsil) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny16 = formData.Scrutiny) === null || _formData$Scrutiny16 === void 0 ? void 0 : (_formData$Scrutiny16$ = _formData$Scrutiny16[0]) === null || _formData$Scrutiny16$ === void 0 ? void 0 : _formData$Scrutiny16$.tehsil));
  const [revenueVillage, setRevenueVillage] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.revenueVillage) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny17 = formData.Scrutiny) === null || _formData$Scrutiny17 === void 0 ? void 0 : (_formData$Scrutiny17$ = _formData$Scrutiny17[0]) === null || _formData$Scrutiny17$ === void 0 ? void 0 : _formData$Scrutiny17$.revenueVillage));
  const [planOn, setPlanOn] = useState(findOption(planOnOptions$1, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.planOn) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny18 = formData.Scrutiny) === null || _formData$Scrutiny18 === void 0 ? void 0 : (_formData$Scrutiny18$ = _formData$Scrutiny18[0]) === null || _formData$Scrutiny18$ === void 0 ? void 0 : _formData$Scrutiny18$.planOn) || null);
  const [sectorNoPlotNo, setSectorNoPlotNo] = useState((scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.sectorNoPlotNo) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny19 = formData.Scrutiny) === null || _formData$Scrutiny19 === void 0 ? void 0 : (_formData$Scrutiny19$ = _formData$Scrutiny19[0]) === null || _formData$Scrutiny19$ === void 0 ? void 0 : _formData$Scrutiny19$.sectorNoPlotNo));
  const [developmentArea, setDevelopmentArea] = useState(findOption(developmentAreaOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.developmentArea) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny20 = formData.Scrutiny) === null || _formData$Scrutiny20 === void 0 ? void 0 : (_formData$Scrutiny20$ = _formData$Scrutiny20[0]) === null || _formData$Scrutiny20$ === void 0 ? void 0 : _formData$Scrutiny20$.developmentArea) || null);
  const [subDevelopmentArea, setsubDevelopmentArea] = useState(findOption(subDevelopmentAreaOptions, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : scrutinyDetails.subDevelopmentArea) || (formData === null || formData === void 0 ? void 0 : (_formData$Scrutiny21 = formData.Scrutiny) === null || _formData$Scrutiny21 === void 0 ? void 0 : (_formData$Scrutiny21$ = _formData$Scrutiny21[0]) === null || _formData$Scrutiny21$ === void 0 ? void 0 : _formData$Scrutiny21$.subDevelopmentArea) || null);
  const [isSpecialYes, setIsSpecialYes] = useState("Upto 300 SqM residential single dwelling unit of santion plan");
  const selectNatureOfConstruction = option => {
    setNatureOfConstruction(option);
    formData.natureOfConstruction = option;
  };
  const selectsubDevelopmentArea = option => {
    setsubDevelopmentArea(option);
    formData.subDevelopmentArea = option;
  };
  const selectdevelopmentArea = option => {
    setDevelopmentArea(option);
    formData.developmentArea = option;
  };
  const selectPlanOn = option => {
    setPlanOn(option);
    formData.planOn = option;
  };
  const selectProposalType = option => {
    setProposalType(option);
    formData.proposalType = option;
  };
  const selectIsPlotSetback = option => {
    setIsPlotSetback(option);
    formData.isPlotSetback = option;
  };
  const selectIsSpecialProject = option => {
    setIsSpecialProject(option);
    formData.isSpecialProject = option;
  };
  const selectIsApprovedLayout = option => {
    setIsApprovedLayout(option);
    formData.isApprovedLayout = option;
  };
  const selectIsRevised = option => {
    setIsRevised(option);
    formData.isRevised = option;
  };
  const selectProjectType = option => {
    setProjectType(option);
    formData.projectType = option;
  };
  const history = useHistory();
  let validation = {};
  function setApplicantName(e) {
    setName(e.target.value);
  }
  const isSetbackRear = e => {
    setSetbackRear(e.target.value);
  };
  const setIssetbackFront = e => {
    setSetbackFront(e.target.value);
  };
  const isSetbackSide = e => {
    setBackSide(e.target.value);
  };
  function setgroundCoverage(e) {
    setgroundCoverages(e.target.value);
  }
  function setFar(e) {
    setFars(e.target.value);
  }
  function isSpecialProjectYes(e) {
    setIsSpecialYes(e.target.value);
  }
  function setsectorNoPlotNoName(e) {
    setSectorNoPlotNo(e.target.value);
  }
  function setTehsilName(e) {
    setTehsil(e.target.value);
  }
  function setRevenueVillageName(e) {
    setRevenueVillage(e.target.value);
  }
  function setLandMarksName(e) {
    setLandMarks(e.target.value);
  }
  function selectfile(e) {
    setUploadedFile(e.target.files[0]);
    setFile(e.target.files[0]);
  }
  const onSkip = () => {
    setUploadMessage("NEED TO DELETE");
  };
  function selectCity(city) {
    var _Digit4;
    setSelectedCity(city);
    setLocalities(city === null || city === void 0 ? void 0 : city.children);
    setOpenVillage(true);
    setSelectedLocality(null);
    setVillage(null);
    setAreaType(city === null || city === void 0 ? void 0 : city.Unit);
    sessionStorage.setItem("currentCity", JSON.stringify(city));
    (_Digit4 = Digit) === null || _Digit4 === void 0 ? void 0 : _Digit4.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
    formData.landAreaDetails = {
      city
    };
  }
  function selectLocality(locality) {
    var _formData$landAreaDet;
    if (formData !== null && formData !== void 0 && (_formData$landAreaDet = formData.landAreaDetails) !== null && _formData$landAreaDet !== void 0 && _formData$landAreaDet.locality) {
      formData.landAreaDetails["locality"] = locality;
    }
    setSelectedLocality(locality);
    sessionStorage.setItem("currLocality", JSON.stringify(locality));
  }
  useEffect(() => {
    if (uploadMessage || isShowToast) {
      setName("");
      setUploadedFile(null);
      setFile("");
      setUploadMessage("");
    }
    if (isShowToast) {
      history.replace(`/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, {
        data: isShowToast !== null && isShowToast !== void 0 && isShowToast.label ? isShowToast === null || isShowToast === void 0 ? void 0 : isShowToast.label : "BPA_INTERNAL_SERVER_ERROR",
        type: "ERROR"
      });
    }
  }, [uploadMessage, isShowToast, isSubmitBtnDisable]);
  function onAdd() {
    setUploadMessage("NEED TO DELETE");
  }
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset
  } = useForm({});
  const watchTODType = watch("orientDevelopment");
  const getValue = val => {
    if (!val) return null;
    if (typeof val === "object") return (val === null || val === void 0 ? void 0 : val.name) || (val === null || val === void 0 ? void 0 : val.code) || null;
    return val;
  };
  const handleSubmits = () => {
    var _Digit5;
    const data = {};
    data.tenantId = code;
    data.city = selectedCity;
    data.areaType = areaType || null;
    data.natureOfConstruction = getValue(natureOfConstruction);
    data.subDevelopmentArea = getValue(subDevelopmentArea);
    data.developmentArea = getValue(developmentArea);
    data.isSpecialProject = getValue(isSpecialProject);
    data.isApprovedLayout = getValue(isApprovedLayout);
    data.isPlotSetback = getValue(isPlotSetback);
    data.planOn = getValue(planOn);
    data.proposalType = getValue(proposalType);
    data.isRevised = getValue(isRevised);
    data.projectType = getValue(projectType);
    data.appliactionType = "BUILDING_PLAN_SCRUTINY";
    data.applicationType = "BUILDING_PLAN_SCRUTINY";
    data.applicationSubType = "NEW_CONSTRUCTION";
    data.serviceType = "NEW_CONSTRUCTION";
    data.locality = selectedLocality || null;
    data.village = village || null;
    data.applicantName = name;
    data.tehsil = tehsil;
    data.fars = fars;
    data.sectorNoPlotNo = sectorNoPlotNo;
    data.backSides = backSide;
    data.groundCoverages = groundCoverages;
    data.setbackRears = setbackRear;
    data.setbackFronts = setbackFront;
    data.revenueVillage = revenueVillage;
    data.landMark = landMarks;
    data.file = file || uploadedFile || null;
    const {
      file: _file,
      ...dataToSave
    } = data;
    (_Digit5 = Digit) === null || _Digit5 === void 0 ? void 0 : _Digit5.SessionStorage.set(config.key, dataToSave);
    data.locality = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || "";
    data.village = (village === null || village === void 0 ? void 0 : village.name) || "";
    data.doorNo = (selectedLocality === null || selectedLocality === void 0 ? void 0 : selectedLocality.name) || null;
    onSelect(config.key, data);
  };
  console.log("datakeys", isSpecialProject, subDevelopmentArea === null || subDevelopmentArea === void 0 ? void 0 : subDevelopmentArea.name, landMarks, natureOfConstruction);
  if (isCityListLoading || isSubmitBtnDisable) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: handleSubmits,
    onSkip: onSkip,
    isDisabled: !selectedCity || !name || !file || isSubmitBtnDisable,
    onAdd: onAdd,
    isMultipleAllow: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("EDCR_COMMON_APPL_NEW"))), /*#__PURE__*/React__default.createElement("p", null, t("BPA_PROVIDE_REQ_FOR_NEW_BPA")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Nature of Construction / Case Type")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: natureOfConstructionOptions$1,
    selectedOption: natureOfConstruction,
    onSelect: selectNatureOfConstruction,
    optionKey: "name",
    placeholder: t("Select Nature of Construction / Case Type")
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Proposal Type Design")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    options: proposalTypeOptions,
    selectedOption: proposalType,
    onSelect: selectProposalType,
    optionKey: "name",
    isDependent: false
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Is Revised")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    options: proposalTypeOptions,
    selectedOption: isRevised,
    onSelect: selectIsRevised,
    optionKey: "name",
    isDependent: false
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Project Type")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: ProjectTypList,
    selectedOption: projectType,
    onSelect: selectProjectType,
    optionKey: "name",
    placeholder: `Select ${t("City")}`
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("District")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: citymoduleList,
    selectedOption: selectedCity,
    onSelect: selectCity,
    optionKey: "name",
    placeholder: `Select ${t("City")}`
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Tehsil")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "tehsil",
    onChange: setTehsilName,
    uploadMessage: uploadMessage,
    value: tehsil
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Revenue Village")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "revenueVillage",
    onChange: setRevenueVillageName,
    uploadMessage: uploadMessage,
    value: revenueVillage
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Land Mark")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "landMark",
    onChange: setLandMarksName,
    uploadMessage: uploadMessage,
    value: landMarks
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Plan On")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: planOnOptions$1,
    selectedOption: planOn,
    onSelect: selectPlanOn,
    optionKey: "name",
    placeholder: `Select ${t("City")}`
  }), selectedCity && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Schemes")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true,
    isDropDown: true
  })), selectedCity && udCode && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Scheme")}*`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    isMandatory: false,
    options: localities === null || localities === void 0 ? void 0 : localities.sort((a, b) => a.name.localeCompare(b.name)),
    optionKey: "name",
    selectedOption: selectedLocality,
    onSelect: selectLocality,
    t: t,
    isDependent: true
  })), selectedCity && selectedLocality && villageOpen && (localities === null || localities === void 0 ? void 0 : localities.length) > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Unit")}`), /*#__PURE__*/React__default.createElement(TextInput$2, {
    t: t,
    type: "text",
    optionKey: "i18nKey",
    name: "areaType",
    value: areaType,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Sector No./Plot No.")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "sectorNoPlotNo",
    onChange: setsectorNoPlotNoName,
    uploadMessage: uploadMessage,
    value: sectorNoPlotNo
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Development Area")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: developmentAreaOptions,
    selectedOption: developmentArea,
    onSelect: selectdevelopmentArea,
    optionKey: "name",
    placeholder: t("Select Development Area")
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("SubDevelopment Area")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    optionCardStyles: {
      maxHeight: "20vmax",
      overflow: "scroll"
    },
    options: subDevelopmentAreaOptions,
    selectedOption: subDevelopmentArea,
    onSelect: selectsubDevelopmentArea,
    optionKey: "name",
    placeholder: t("Select SubDevelopment Area")
  }), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Is This Special Project")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    options: proposalTypeOptions,
    selectedOption: isSpecialProject,
    onSelect: selectIsSpecialProject,
    optionKey: "name",
    isDependent: false
  }), isSpecialProject && (isSpecialProject === null || isSpecialProject === void 0 ? void 0 : isSpecialProject.name) === "Yes" && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "isSpecialYes",
    onChange: isSpecialProjectYes,
    uploadMessage: uploadMessage,
    value: isSpecialYes
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z0-9]+(( )+[a-zA-Z0-9]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  }))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Is this Approved Layout")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    options: proposalTypeOptions,
    selectedOption: isApprovedLayout,
    onSelect: selectIsApprovedLayout,
    optionKey: "name",
    isDependent: false
  }), isApprovedLayout && (isApprovedLayout === null || isApprovedLayout === void 0 ? void 0 : isApprovedLayout.name) === "Yes" && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Ground Coverage %")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "groundCoverages",
    onChange: setgroundCoverage,
    uploadMessage: uploadMessage,
    value: groundCoverages
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("FAR")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "fars",
    onChange: setFar,
    uploadMessage: uploadMessage,
    value: fars
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Is plot has special required value of Setback?")} *`), /*#__PURE__*/React__default.createElement(RadioOrSelect, {
    t: t,
    options: proposalTypeOptions,
    selectedOption: isPlotSetback,
    onSelect: selectIsPlotSetback,
    optionKey: "name",
    isDependent: false
  }), isPlotSetback && (isPlotSetback === null || isPlotSetback === void 0 ? void 0 : isPlotSetback.name) === "Yes" && /*#__PURE__*/React__default.createElement("span", {
    className: "form-pt-dropdown-only"
  }, /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Setback Front")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "setbackFronts",
    onChange: setIssetbackFront,
    uploadMessage: uploadMessage,
    value: setbackFront
  }, validation = {
    isRequired: true,
    pattern: "^[0-9]+$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Setback Rear")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "setbackRears",
    onChange: isSetbackRear,
    uploadMessage: uploadMessage,
    value: setbackRear
  }, validation = {
    isRequired: true,
    pattern: "^[0-9]+$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Setback Side")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "backSides",
    onChange: isSetbackSide,
    uploadMessage: uploadMessage,
    value: backSide
  }, validation = {
    isRequired: true,
    pattern: "^[0-9]+$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })))), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("Owner Name")} *`), /*#__PURE__*/React__default.createElement(TextInput$2, Object.assign({
    isMandatory: false,
    optionKey: "i18nKey",
    t: t,
    name: "applicantName",
    onChange: setApplicantName,
    uploadMessage: uploadMessage,
    value: name
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
    type: "text",
    title: t("TL_NAME_ERROR_MESSAGE")
  })), /*#__PURE__*/React__default.createElement(CardLabel, null, `${t("BPA_PLAN_DIAGRAM_LABEL")} *`), /*#__PURE__*/React__default.createElement(UploadFile, {
    id: "edcr-doc",
    extraStyleName: "propertyCreate",
    accept: ".dxf",
    onUpload: selectfile,
    onDelete: () => {
      setUploadedFile(null);
      setFile("");
    },
    message: uploadedFile ? `1 ${t(`PT_ACTION_FILEUPLOADED`)}` : t(`ES_NO_FILE_SELECTED_LABEL`),
    uploadMessage: uploadMessage
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      disabled: "true",
      height: "30px",
      width: "100%",
      fontSize: "14px"
    }
  }, t("EDCR_UPLOAD_FILE_LIMITS_LABEL")), isShowToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: isShowToast.key,
    label: t(isShowToast.label),
    onClose: () => setIsShowToast(null),
    isDleteBtn: true
  })))));
};

const OBPSModule = ({
  stateCode,
  userType,
  tenants
}) => {
  const moduleCode = ["bpa", "bpareg", "common"];
  const {
    path,
    url
  } = useRouteMatch();
  const language = Digit.StoreData.getCurrentLanguage();
  const {
    isLoading,
    data: store
  } = Digit.Services.useStore({
    stateCode,
    moduleCode,
    language
  });
  Digit.SessionStorage.set("OBPS_TENANTS", tenants);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (userType === "citizen") {
    return /*#__PURE__*/React__default.createElement(App, {
      path: path,
      stateCode: stateCode
    });
  }
  return /*#__PURE__*/React__default.createElement(EmployeeApp, {
    path: path,
    stateCode: stateCode
  });
};
const OBPSLinks = ({
  matchPath,
  userType
}) => {
  const {
    t
  } = useTranslation();
  const links = [{
    link: `${matchPath}/my-applications`,
    i18nKey: t("BPA_CITIZEN_HOME_VIEW_APP_BY_CITIZEN_LABEL")
  }, {
    link: `${matchPath}/stakeholder/apply/stakeholder-docs-required`,
    i18nKey: t("BPA_CITIZEN_HOME_STAKEHOLDER_LOGIN_LABEL")
  }, {
    link: `${matchPath}/home`,
    i18nKey: t("BPA_CITIZEN_HOME_ARCHITECT_LOGIN_LABEL")
  }];
  return /*#__PURE__*/React__default.createElement(CitizenOBPSCard, {
    header: t("ACTION_TEST_BUILDING_PLAN_APPROVAL"),
    links: links,
    Icon: () => /*#__PURE__*/React__default.createElement(OBPSIcon, null),
    Info: () => /*#__PURE__*/React__default.createElement(CitizenInfoLabel, {
      style: {
        margin: "0px",
        padding: "10px"
      },
      info: t("CS_FILE_APPLICATION_INFO_LABEL"),
      text: t(`BPA_CITIZEN_HOME_STAKEHOLDER_INCLUDES_INFO_LABEL`)
    }),
    isInfo: true
  });
};
const componentsToRegister = {
  OBPSModule,
  OBPSLinks,
  OBPSCard: OBPSEmployeeHomeCard,
  BPACitizenHomeScreen,
  EDCRForm,
  EDCRForm2,
  Form11,
  Form11Card,
  BasicDetails,
  Form11Step1: Step1$5,
  LandAreaDetails,
  DescriptionOfLand,
  Checklist: Checklist$1,
  Form11Step2: ProfessionalDetails,
  Form11Step3: OwnerDetails,
  Form11Step4: DocumentDetails,
  Form26Step1: Step1$6,
  OffencesLandAreaDetails: LandAreaDetails$1,
  OffencesDescriptionOfLand: DescriptionOfLand$1,
  OffencesChecklist: Checklist$2,
  Form26Step2: ProfessionalDetails$1,
  Form26Step3: OwnerDetails$1,
  Form26Step4: DocumentDetails$1,
  DocsRequired,
  PlotDetails,
  ScrutinyDetails,
  OwnerDetails: OwnerDetails$2,
  DocumentDetails: DocumentDetails$2,
  NOCDetails,
  LocationDetails,
  ProfessionalDetails: ProfessionalDetails$2,
  GIS,
  OCEDCRDocsRequired,
  OCeDCRScrutiny,
  OCUploadPlanDiagram,
  StakeholderDocsRequired,
  LicenseType,
  LicenseDetails,
  CorrospondenceAddress,
  PermanentAddress,
  StakeholderDocuments,
  OCBasicDetails,
  OBPSSearchApplication,
  InspectionReport,
  BPAInbox: Inbox,
  StakeholderInbox: Inbox$1,
  StakeholderCheckPage: CheckPage$5,
  BPACheckPage: CheckPage,
  Form11CheckPage: CheckPage$1,
  OCBPACheckPage: CheckPage$3,
  OCBPASendBackCheckPage: CheckPage$4,
  EDCRAcknowledgement,
  OCEDCRAcknowledgement: EDCRAcknowledgement$1,
  BPAAcknowledgement: OBPSAcknowledgement,
  BPAForm11CheckPage: CheckPage$1,
  BPAForm26CheckPage: CheckPage$2,
  Form11Acknowledgement: OBPSAcknowledgement$1,
  BPAForm26Acknowledgement: OBPSAcknowledgement$2,
  OCBPAAcknowledgement: OBPSAcknowledgement$3,
  BPAForm11Acknowledgement: OBPSAcknowledgement$1,
  OCSendBackAcknowledgement: Acknowledgement,
  StakeholderAcknowledgement,
  ObpsCreateEDCR: CreateEDCR,
  ObpsCreateOCEDCR: CreateOCEDCR,
  ObpsNewBuildingPermit: NewBuildingPermit,
  DataTable,
  Form11BuildingPlanPermit: NewBuildingPermit$1,
  Form26BuildingPlanPermit: NewBuildingPermit$2,
  ObpsOCBuildingPermit: OCBuildingPermit,
  ObpsStakeholderRegistration: StakeholderRegistration,
  ObpsCitizenBpaApplicationDetail: BpaApplicationDetail,
  ObpsBPASendToArchitect: BPASendToArchitect,
  ObpsOCSendToArchitect: OCSendToArchitect,
  ObpsBPASendBackToCitizen: BPASendBackToCitizen,
  ObpsOCSendBackToCitizen: OCSendBackToCitizen,
  ObpsEdcrInbox: Inbox$2,
  ObpsEmpApplicationDetail: ApplicationDetail$6,
  ObpsEmployeeBpaApplicationDetail: BpaApplicationDetail$1
};
const initOBPSComponents = () => {
  Object.entries(componentsToRegister).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};

export { initOBPSComponents };
//# sourceMappingURL=index.modern.js.map
